
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9CBKV", function(module, exports) {

$parcel$export(module.exports, "register", () => $7014f332a162ea1f$export$6503ec6e8aabbaf, (v) => $7014f332a162ea1f$export$6503ec6e8aabbaf = v);
var $7014f332a162ea1f$export$6503ec6e8aabbaf;
var $7014f332a162ea1f$export$f7ad0328861e2f03;
"use strict";
var $7014f332a162ea1f$var$mapping = new Map();
function $7014f332a162ea1f$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$7014f332a162ea1f$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $7014f332a162ea1f$var$resolve(id) {
    var resolved = $7014f332a162ea1f$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$7014f332a162ea1f$export$6503ec6e8aabbaf = $7014f332a162ea1f$var$register;
$7014f332a162ea1f$export$f7ad0328861e2f03 = $7014f332a162ea1f$var$resolve;

});

parcelRegister("7qipm", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", () => $56793d9663fecec4$export$bdfd709ae4826697, (v) => $56793d9663fecec4$export$bdfd709ae4826697 = v);
$parcel$export(module.exports, "getOrigin", () => $56793d9663fecec4$export$5a759dc7a1cfb72a, (v) => $56793d9663fecec4$export$5a759dc7a1cfb72a = v);
var $56793d9663fecec4$export$bdfd709ae4826697;
var $56793d9663fecec4$export$c9e73fbda7da57b6;
var $56793d9663fecec4$export$5a759dc7a1cfb72a;
"use strict";
var $56793d9663fecec4$var$bundleURL = {};
function $56793d9663fecec4$var$getBundleURLCached(id) {
    var value = $56793d9663fecec4$var$bundleURL[id];
    if (!value) {
        value = $56793d9663fecec4$var$getBundleURL();
        $56793d9663fecec4$var$bundleURL[id] = value;
    }
    return value;
}
function $56793d9663fecec4$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $56793d9663fecec4$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $56793d9663fecec4$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $56793d9663fecec4$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$56793d9663fecec4$export$bdfd709ae4826697 = $56793d9663fecec4$var$getBundleURLCached;
$56793d9663fecec4$export$c9e73fbda7da57b6 = $56793d9663fecec4$var$getBaseURL;
$56793d9663fecec4$export$5a759dc7a1cfb72a = $56793d9663fecec4$var$getOrigin;

});

parcelRegister("lc1R0", function(module, exports) {

$parcel$export(module.exports, "Doc", () => $a852d2d5bb3d1ec6$export$bceacc74c2212615);
$parcel$export(module.exports, "applyUpdate", () => $a852d2d5bb3d1ec6$export$c271737a9c02e925);
$parcel$export(module.exports, "encodeStateAsUpdate", () => $a852d2d5bb3d1ec6$export$e5848df80e65bd53);
$parcel$export(module.exports, "encodeStateVector", () => $a852d2d5bb3d1ec6$export$3e2f5393f32e71f);
$parcel$export(module.exports, "UndoManager", () => $a852d2d5bb3d1ec6$export$932a3f9a7e88971c);

var $7uKvC = parcelRequire("7uKvC");

var $dWqHQ = parcelRequire("dWqHQ");

var $bJmyZ = parcelRequire("bJmyZ");

var $d1VR8 = parcelRequire("d1VR8");

var $kRma6 = parcelRequire("kRma6");

var $9QtgA = parcelRequire("9QtgA");

var $2ocYS = parcelRequire("2ocYS");

var $kSy7V = parcelRequire("kSy7V");

var $7WDUw = parcelRequire("7WDUw");

var $gFLjS = parcelRequire("gFLjS");

var $6ciaJ = parcelRequire("6ciaJ");

var $45hHO = parcelRequire("45hHO");

var $9IXCW = parcelRequire("9IXCW");
parcelRequire("giaim");
var $7qZUp = parcelRequire("7qZUp");
var $giaim = parcelRequire("giaim");

var $drUmF = parcelRequire("drUmF");

var $1dTGB = parcelRequire("1dTGB");

var $fphiM = parcelRequire("fphiM");

var $4m6H0 = parcelRequire("4m6H0");

var $kRoyo = parcelRequire("kRoyo");
/**
 * This is an abstract interface that all Connectors should implement to keep them interchangeable.
 *
 * @note This interface is experimental and it is not advised to actually inherit this class.
 *       It just serves as typing information.
 *
 * @extends {ObservableV2<any>}
 */ class $a852d2d5bb3d1ec6$export$c3faceeb92aa39dd extends (0, $7uKvC.ObservableV2) {
    /**
   * @param {Doc} ydoc
   * @param {any} awareness
   */ constructor(ydoc, awareness){
        super();
        this.doc = ydoc;
        this.awareness = awareness;
    }
}
class $a852d2d5bb3d1ec6$var$DeleteItem {
    /**
   * @param {number} clock
   * @param {number} len
   */ constructor(clock, len){
        /**
     * @type {number}
     */ this.clock = clock;
        /**
     * @type {number}
     */ this.len = len;
    }
}
/**
 * We no longer maintain a DeleteStore. DeleteSet is a temporary object that is created when needed.
 * - When created in a transaction, it must only be accessed after sorting, and merging
 *   - This DeleteSet is send to other clients
 * - We do not create a DeleteSet when we send a sync message. The DeleteSet message is created directly from StructStore
 * - We read a DeleteSet as part of a sync/update message. In this case the DeleteSet is already sorted and merged.
 */ class $a852d2d5bb3d1ec6$var$DeleteSet {
    constructor(){
        /**
     * @type {Map<number,Array<DeleteItem>>}
     */ this.clients = new Map();
    }
}
/**
 * Iterate over all structs that the DeleteSet gc's.
 *
 * @param {Transaction} transaction
 * @param {DeleteSet} ds
 * @param {function(GC|Item):void} f
 *
 * @function
 */ const $a852d2d5bb3d1ec6$export$8afefebbaf4e4c78 = (transaction, ds, f)=>ds.clients.forEach((deletes, clientid)=>{
        const structs = /** @type {Array<GC|Item>} */ transaction.doc.store.clients.get(clientid);
        for(let i = 0; i < deletes.length; i++){
            const del = deletes[i];
            $a852d2d5bb3d1ec6$var$iterateStructs(transaction, structs, del.clock, del.len, f);
        }
    });
/**
 * @param {Array<DeleteItem>} dis
 * @param {number} clock
 * @return {number|null}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$findIndexDS = (dis, clock)=>{
    let left = 0;
    let right = dis.length - 1;
    while(left <= right){
        const midindex = $bJmyZ.floor((left + right) / 2);
        const mid = dis[midindex];
        const midclock = mid.clock;
        if (midclock <= clock) {
            if (clock < midclock + mid.len) return midindex;
            left = midindex + 1;
        } else right = midindex - 1;
    }
    return null;
};
/**
 * @param {DeleteSet} ds
 * @param {ID} id
 * @return {boolean}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$export$dcb04af092e44fde = (ds, id)=>{
    const dis = ds.clients.get(id.client);
    return dis !== undefined && $a852d2d5bb3d1ec6$var$findIndexDS(dis, id.clock) !== null;
};
/**
 * @param {DeleteSet} ds
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$sortAndMergeDeleteSet = (ds)=>{
    ds.clients.forEach((dels)=>{
        dels.sort((a, b)=>a.clock - b.clock);
        // merge items without filtering or splicing the array
        // i is the current pointer
        // j refers to the current insert position for the pointed item
        // try to merge dels[i] into dels[j-1] or set dels[j]=dels[i]
        let i, j;
        for(i = 1, j = 1; i < dels.length; i++){
            const left = dels[j - 1];
            const right = dels[i];
            if (left.clock + left.len >= right.clock) left.len = $bJmyZ.max(left.len, right.clock + right.len - left.clock);
            else {
                if (j < i) dels[j] = right;
                j++;
            }
        }
        dels.length = j;
    });
};
/**
 * @param {Array<DeleteSet>} dss
 * @return {DeleteSet} A fresh DeleteSet
 */ const $a852d2d5bb3d1ec6$export$b7826cadad53901e = (dss)=>{
    const merged = new $a852d2d5bb3d1ec6$var$DeleteSet();
    for(let dssI = 0; dssI < dss.length; dssI++)dss[dssI].clients.forEach((delsLeft, client)=>{
        if (!merged.clients.has(client)) {
            // Write all missing keys from current ds and all following.
            // If merged already contains `client` current ds has already been added.
            /**
         * @type {Array<DeleteItem>}
         */ const dels = delsLeft.slice();
            for(let i = dssI + 1; i < dss.length; i++)$dWqHQ.appendTo(dels, dss[i].clients.get(client) || []);
            merged.clients.set(client, dels);
        }
    });
    $a852d2d5bb3d1ec6$var$sortAndMergeDeleteSet(merged);
    return merged;
};
/**
 * @param {DeleteSet} ds
 * @param {number} client
 * @param {number} clock
 * @param {number} length
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$addToDeleteSet = (ds, client, clock, length)=>{
    $d1VR8.setIfUndefined(ds.clients, client, ()=>/** @type {Array<DeleteItem>} */ []).push(new $a852d2d5bb3d1ec6$var$DeleteItem(clock, length));
};
const $a852d2d5bb3d1ec6$export$8cbac0d946238699 = ()=>new $a852d2d5bb3d1ec6$var$DeleteSet();
/**
 * @param {StructStore} ss
 * @return {DeleteSet} Merged and sorted DeleteSet
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$export$8450d668bec558e2 = (ss)=>{
    const ds = $a852d2d5bb3d1ec6$export$8cbac0d946238699();
    ss.clients.forEach((structs, client)=>{
        /**
     * @type {Array<DeleteItem>}
     */ const dsitems = [];
        for(let i = 0; i < structs.length; i++){
            const struct = structs[i];
            if (struct.deleted) {
                const clock = struct.id.clock;
                let len = struct.length;
                if (i + 1 < structs.length) for(let next = structs[i + 1]; i + 1 < structs.length && next.deleted; next = structs[++i + 1])len += next.length;
                dsitems.push(new $a852d2d5bb3d1ec6$var$DeleteItem(clock, len));
            }
        }
        if (dsitems.length > 0) ds.clients.set(client, dsitems);
    });
    return ds;
};
/**
 * @param {DSEncoderV1 | DSEncoderV2} encoder
 * @param {DeleteSet} ds
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$writeDeleteSet = (encoder, ds)=>{
    $kRma6.writeVarUint(encoder.restEncoder, ds.clients.size);
    // Ensure that the delete set is written in a deterministic order
    $dWqHQ.from(ds.clients.entries()).sort((a, b)=>b[0] - a[0]).forEach(([client, dsitems])=>{
        encoder.resetDsCurVal();
        $kRma6.writeVarUint(encoder.restEncoder, client);
        const len = dsitems.length;
        $kRma6.writeVarUint(encoder.restEncoder, len);
        for(let i = 0; i < len; i++){
            const item = dsitems[i];
            encoder.writeDsClock(item.clock);
            encoder.writeDsLen(item.len);
        }
    });
};
/**
 * @param {DSDecoderV1 | DSDecoderV2} decoder
 * @return {DeleteSet}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$readDeleteSet = (decoder)=>{
    const ds = new $a852d2d5bb3d1ec6$var$DeleteSet();
    const numClients = $9QtgA.readVarUint(decoder.restDecoder);
    for(let i = 0; i < numClients; i++){
        decoder.resetDsCurVal();
        const client = $9QtgA.readVarUint(decoder.restDecoder);
        const numberOfDeletes = $9QtgA.readVarUint(decoder.restDecoder);
        if (numberOfDeletes > 0) {
            const dsField = $d1VR8.setIfUndefined(ds.clients, client, ()=>/** @type {Array<DeleteItem>} */ []);
            for(let i = 0; i < numberOfDeletes; i++)dsField.push(new $a852d2d5bb3d1ec6$var$DeleteItem(decoder.readDsClock(), decoder.readDsLen()));
        }
    }
    return ds;
};
/**
 * @todo YDecoder also contains references to String and other Decoders. Would make sense to exchange YDecoder.toUint8Array for YDecoder.DsToUint8Array()..
 */ /**
 * @param {DSDecoderV1 | DSDecoderV2} decoder
 * @param {Transaction} transaction
 * @param {StructStore} store
 * @return {Uint8Array|null} Returns a v2 update containing all deletes that couldn't be applied yet; or null if all deletes were applied successfully.
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$readAndApplyDeleteSet = (decoder, transaction, store)=>{
    const unappliedDS = new $a852d2d5bb3d1ec6$var$DeleteSet();
    const numClients = $9QtgA.readVarUint(decoder.restDecoder);
    for(let i = 0; i < numClients; i++){
        decoder.resetDsCurVal();
        const client = $9QtgA.readVarUint(decoder.restDecoder);
        const numberOfDeletes = $9QtgA.readVarUint(decoder.restDecoder);
        const structs = store.clients.get(client) || [];
        const state = $a852d2d5bb3d1ec6$export$50fdfeece43146fd(store, client);
        for(let i = 0; i < numberOfDeletes; i++){
            const clock = decoder.readDsClock();
            const clockEnd = clock + decoder.readDsLen();
            if (clock < state) {
                if (state < clockEnd) $a852d2d5bb3d1ec6$var$addToDeleteSet(unappliedDS, client, state, clockEnd - state);
                let index = $a852d2d5bb3d1ec6$export$5f8f02523cf47b58(structs, clock);
                /**
         * We can ignore the case of GC and Delete structs, because we are going to skip them
         * @type {Item}
         */ // @ts-ignore
                let struct = structs[index];
                // split the first item if necessary
                if (!struct.deleted && struct.id.clock < clock) {
                    structs.splice(index + 1, 0, $a852d2d5bb3d1ec6$var$splitItem(transaction, struct, clock - struct.id.clock));
                    index++; // increase we now want to use the next struct
                }
                while(index < structs.length){
                    // @ts-ignore
                    struct = structs[index++];
                    if (struct.id.clock < clockEnd) {
                        if (!struct.deleted) {
                            if (clockEnd < struct.id.clock + struct.length) structs.splice(index, 0, $a852d2d5bb3d1ec6$var$splitItem(transaction, struct, clockEnd - struct.id.clock));
                            struct.delete(transaction);
                        }
                    } else break;
                }
            } else $a852d2d5bb3d1ec6$var$addToDeleteSet(unappliedDS, client, clock, clockEnd - clock);
        }
    }
    if (unappliedDS.clients.size > 0) {
        const ds = new $a852d2d5bb3d1ec6$export$30c99e08943e1c2();
        $kRma6.writeVarUint(ds.restEncoder, 0); // encode 0 structs
        $a852d2d5bb3d1ec6$var$writeDeleteSet(ds, unappliedDS);
        return ds.toUint8Array();
    }
    return null;
};
/**
 * @param {DeleteSet} ds1
 * @param {DeleteSet} ds2
 */ const $a852d2d5bb3d1ec6$export$9697b72c46fd3a5d = (ds1, ds2)=>{
    if (ds1.clients.size !== ds2.clients.size) return false;
    for (const [client, deleteItems1] of ds1.clients.entries()){
        const deleteItems2 = /** @type {Array<import('../internals.js').DeleteItem>} */ ds2.clients.get(client);
        if (deleteItems2 === undefined || deleteItems1.length !== deleteItems2.length) return false;
        for(let i = 0; i < deleteItems1.length; i++){
            const di1 = deleteItems1[i];
            const di2 = deleteItems2[i];
            if (di1.clock !== di2.clock || di1.len !== di2.len) return false;
        }
    }
    return true;
};
/**
 * @module Y
 */ const $a852d2d5bb3d1ec6$var$generateNewClientId = $2ocYS.uint32;
/**
 * @typedef {Object} DocOpts
 * @property {boolean} [DocOpts.gc=true] Disable garbage collection (default: gc=true)
 * @property {function(Item):boolean} [DocOpts.gcFilter] Will be called before an Item is garbage collected. Return false to keep the Item.
 * @property {string} [DocOpts.guid] Define a globally unique identifier for this document
 * @property {string | null} [DocOpts.collectionid] Associate this document with a collection. This only plays a role if your provider has a concept of collection.
 * @property {any} [DocOpts.meta] Any kind of meta information you want to associate with this document. If this is a subdocument, remote peers will store the meta information as well.
 * @property {boolean} [DocOpts.autoLoad] If a subdocument, automatically load document. If this is a subdocument, remote peers will load the document as well automatically.
 * @property {boolean} [DocOpts.shouldLoad] Whether the document should be synced by the provider now. This is toggled to true when you call ydoc.load()
 */ /**
 * @typedef {Object} DocEvents
 * @property {function(Doc):void} DocEvents.destroy
 * @property {function(Doc):void} DocEvents.load
 * @property {function(boolean, Doc):void} DocEvents.sync
 * @property {function(Uint8Array, any, Doc, Transaction):void} DocEvents.update
 * @property {function(Uint8Array, any, Doc, Transaction):void} DocEvents.updateV2
 * @property {function(Doc):void} DocEvents.beforeAllTransactions
 * @property {function(Transaction, Doc):void} DocEvents.beforeTransaction
 * @property {function(Transaction, Doc):void} DocEvents.beforeObserverCalls
 * @property {function(Transaction, Doc):void} DocEvents.afterTransaction
 * @property {function(Transaction, Doc):void} DocEvents.afterTransactionCleanup
 * @property {function(Doc, Array<Transaction>):void} DocEvents.afterAllTransactions
 * @property {function({ loaded: Set<Doc>, added: Set<Doc>, removed: Set<Doc> }, Doc, Transaction):void} DocEvents.subdocs
 */ /**
 * A Yjs instance handles the state of shared data.
 * @extends ObservableV2<DocEvents>
 */ class $a852d2d5bb3d1ec6$export$bceacc74c2212615 extends (0, $7uKvC.ObservableV2) {
    /**
   * @param {DocOpts} opts configuration
   */ constructor({ guid: guid = $2ocYS.uuidv4(), collectionid: collectionid = null, gc: gc = true, gcFilter: gcFilter = ()=>true, meta: meta = null, autoLoad: autoLoad = false, shouldLoad: shouldLoad = true } = {}){
        super();
        this.gc = gc;
        this.gcFilter = gcFilter;
        this.clientID = $a852d2d5bb3d1ec6$var$generateNewClientId();
        this.guid = guid;
        this.collectionid = collectionid;
        /**
     * @type {Map<string, AbstractType<YEvent<any>>>}
     */ this.share = new Map();
        this.store = new $a852d2d5bb3d1ec6$var$StructStore();
        /**
     * @type {Transaction | null}
     */ this._transaction = null;
        /**
     * @type {Array<Transaction>}
     */ this._transactionCleanups = [];
        /**
     * @type {Set<Doc>}
     */ this.subdocs = new Set();
        /**
     * If this document is a subdocument - a document integrated into another document - then _item is defined.
     * @type {Item?}
     */ this._item = null;
        this.shouldLoad = shouldLoad;
        this.autoLoad = autoLoad;
        this.meta = meta;
        /**
     * This is set to true when the persistence provider loaded the document from the database or when the `sync` event fires.
     * Note that not all providers implement this feature. Provider authors are encouraged to fire the `load` event when the doc content is loaded from the database.
     *
     * @type {boolean}
     */ this.isLoaded = false;
        /**
     * This is set to true when the connection provider has successfully synced with a backend.
     * Note that when using peer-to-peer providers this event may not provide very useful.
     * Also note that not all providers implement this feature. Provider authors are encouraged to fire
     * the `sync` event when the doc has been synced (with `true` as a parameter) or if connection is
     * lost (with false as a parameter).
     */ this.isSynced = false;
        this.isDestroyed = false;
        /**
     * Promise that resolves once the document has been loaded from a presistence provider.
     */ this.whenLoaded = $kSy7V.create((resolve)=>{
            this.on('load', ()=>{
                this.isLoaded = true;
                resolve(this);
            });
        });
        const provideSyncedPromise = ()=>$kSy7V.create((resolve)=>{
                /**
       * @param {boolean} isSynced
       */ const eventHandler = (isSynced)=>{
                    if (isSynced === undefined || isSynced === true) {
                        this.off('sync', eventHandler);
                        resolve();
                    }
                };
                this.on('sync', eventHandler);
            });
        this.on('sync', (isSynced)=>{
            if (isSynced === false && this.isSynced) this.whenSynced = provideSyncedPromise();
            this.isSynced = isSynced === undefined || isSynced === true;
            if (this.isSynced && !this.isLoaded) this.emit('load', [
                this
            ]);
        });
        /**
     * Promise that resolves once the document has been synced with a backend.
     * This promise is recreated when the connection is lost.
     * Note the documentation about the `isSynced` property.
     */ this.whenSynced = provideSyncedPromise();
    }
    /**
   * Notify the parent document that you request to load data into this subdocument (if it is a subdocument).
   *
   * `load()` might be used in the future to request any provider to load the most current data.
   *
   * It is safe to call `load()` multiple times.
   */ load() {
        const item = this._item;
        if (item !== null && !this.shouldLoad) $a852d2d5bb3d1ec6$export$dac1bad6146b2469(/** @type {any} */ item.parent.doc, (transaction)=>{
            transaction.subdocsLoaded.add(this);
        }, null, true);
        this.shouldLoad = true;
    }
    getSubdocs() {
        return this.subdocs;
    }
    getSubdocGuids() {
        return new Set($dWqHQ.from(this.subdocs).map((doc)=>doc.guid));
    }
    /**
   * Changes that happen inside of a transaction are bundled. This means that
   * the observer fires _after_ the transaction is finished and that all changes
   * that happened inside of the transaction are sent as one message to the
   * other peers.
   *
   * @template T
   * @param {function(Transaction):T} f The function that should be executed as a transaction
   * @param {any} [origin] Origin of who started the transaction. Will be stored on transaction.origin
   * @return T
   *
   * @public
   */ transact(f, origin = null) {
        return $a852d2d5bb3d1ec6$export$dac1bad6146b2469(this, f, origin);
    }
    /**
   * Define a shared data type.
   *
   * Multiple calls of `ydoc.get(name, TypeConstructor)` yield the same result
   * and do not overwrite each other. I.e.
   * `ydoc.get(name, Y.Array) === ydoc.get(name, Y.Array)`
   *
   * After this method is called, the type is also available on `ydoc.share.get(name)`.
   *
   * *Best Practices:*
   * Define all types right after the Y.Doc instance is created and store them in a separate object.
   * Also use the typed methods `getText(name)`, `getArray(name)`, ..
   *
   * @template {typeof AbstractType<any>} Type
   * @example
   *   const ydoc = new Y.Doc(..)
   *   const appState = {
   *     document: ydoc.getText('document')
   *     comments: ydoc.getArray('comments')
   *   }
   *
   * @param {string} name
   * @param {Type} TypeConstructor The constructor of the type definition. E.g. Y.Text, Y.Array, Y.Map, ...
   * @return {InstanceType<Type>} The created type. Constructed with TypeConstructor
   *
   * @public
   */ get(name, TypeConstructor = /** @type {any} */ $a852d2d5bb3d1ec6$export$c265dc8338484497) {
        const type = $d1VR8.setIfUndefined(this.share, name, ()=>{
            // @ts-ignore
            const t = new TypeConstructor();
            t._integrate(this, null);
            return t;
        });
        const Constr = type.constructor;
        if (TypeConstructor !== $a852d2d5bb3d1ec6$export$c265dc8338484497 && Constr !== TypeConstructor) {
            if (Constr === $a852d2d5bb3d1ec6$export$c265dc8338484497) {
                // @ts-ignore
                const t = new TypeConstructor();
                t._map = type._map;
                type._map.forEach(/** @param {Item?} n */ (n)=>{
                    for(; n !== null; n = n.left)// @ts-ignore
                    n.parent = t;
                });
                t._start = type._start;
                for(let n = t._start; n !== null; n = n.right)n.parent = t;
                t._length = type._length;
                this.share.set(name, t);
                t._integrate(this, null);
                return /** @type {InstanceType<Type>} */ t;
            } else throw new Error(`Type with the name ${name} has already been defined with a different constructor`);
        }
        return /** @type {InstanceType<Type>} */ type;
    }
    /**
   * @template T
   * @param {string} [name]
   * @return {YArray<T>}
   *
   * @public
   */ getArray(name = '') {
        return /** @type {YArray<T>} */ this.get(name, $a852d2d5bb3d1ec6$export$c4be6576ca6fe4aa);
    }
    /**
   * @param {string} [name]
   * @return {YText}
   *
   * @public
   */ getText(name = '') {
        return this.get(name, $a852d2d5bb3d1ec6$export$5f1af8db9871e1d6);
    }
    /**
   * @template T
   * @param {string} [name]
   * @return {YMap<T>}
   *
   * @public
   */ getMap(name = '') {
        return /** @type {YMap<T>} */ this.get(name, $a852d2d5bb3d1ec6$export$a5c7b93649eaf8f8);
    }
    /**
   * @param {string} [name]
   * @return {YXmlElement}
   *
   * @public
   */ getXmlElement(name = '') {
        return /** @type {YXmlElement<{[key:string]:string}>} */ this.get(name, $a852d2d5bb3d1ec6$export$4db87581d3ca170d);
    }
    /**
   * @param {string} [name]
   * @return {YXmlFragment}
   *
   * @public
   */ getXmlFragment(name = '') {
        return this.get(name, $a852d2d5bb3d1ec6$export$d5ce8c3e1731f1a7);
    }
    /**
   * Converts the entire document into a js object, recursively traversing each yjs type
   * Doesn't log types that have not been defined (using ydoc.getType(..)).
   *
   * @deprecated Do not use this method and rather call toJSON directly on the shared types.
   *
   * @return {Object<string, any>}
   */ toJSON() {
        /**
     * @type {Object<string, any>}
     */ const doc = {};
        this.share.forEach((value, key)=>{
            doc[key] = value.toJSON();
        });
        return doc;
    }
    /**
   * Emit `destroy` event and unregister all event handlers.
   */ destroy() {
        this.isDestroyed = true;
        $dWqHQ.from(this.subdocs).forEach((subdoc)=>subdoc.destroy());
        const item = this._item;
        if (item !== null) {
            this._item = null;
            const content = /** @type {ContentDoc} */ item.content;
            content.doc = new $a852d2d5bb3d1ec6$export$bceacc74c2212615({
                guid: this.guid,
                ...content.opts,
                shouldLoad: false
            });
            content.doc._item = item;
            $a852d2d5bb3d1ec6$export$dac1bad6146b2469(/** @type {any} */ item.parent.doc, (transaction)=>{
                const doc = content.doc;
                if (!item.deleted) transaction.subdocsAdded.add(doc);
                transaction.subdocsRemoved.add(this);
            }, null, true);
        }
        // @ts-ignore
        this.emit('destroyed', [
            true
        ]); // DEPRECATED!
        this.emit('destroy', [
            this
        ]);
        super.destroy();
    }
}
class $a852d2d5bb3d1ec6$var$DSDecoderV1 {
    /**
   * @param {decoding.Decoder} decoder
   */ constructor(decoder){
        this.restDecoder = decoder;
    }
    resetDsCurVal() {
    // nop
    }
    /**
   * @return {number}
   */ readDsClock() {
        return $9QtgA.readVarUint(this.restDecoder);
    }
    /**
   * @return {number}
   */ readDsLen() {
        return $9QtgA.readVarUint(this.restDecoder);
    }
}
class $a852d2d5bb3d1ec6$export$1aa46d9818b5d1ec extends $a852d2d5bb3d1ec6$var$DSDecoderV1 {
    /**
   * @return {ID}
   */ readLeftID() {
        return $a852d2d5bb3d1ec6$export$6c7d4e6171d008d0($9QtgA.readVarUint(this.restDecoder), $9QtgA.readVarUint(this.restDecoder));
    }
    /**
   * @return {ID}
   */ readRightID() {
        return $a852d2d5bb3d1ec6$export$6c7d4e6171d008d0($9QtgA.readVarUint(this.restDecoder), $9QtgA.readVarUint(this.restDecoder));
    }
    /**
   * Read the next client id.
   * Use this in favor of readID whenever possible to reduce the number of objects created.
   */ readClient() {
        return $9QtgA.readVarUint(this.restDecoder);
    }
    /**
   * @return {number} info An unsigned 8-bit integer
   */ readInfo() {
        return $9QtgA.readUint8(this.restDecoder);
    }
    /**
   * @return {string}
   */ readString() {
        return $9QtgA.readVarString(this.restDecoder);
    }
    /**
   * @return {boolean} isKey
   */ readParentInfo() {
        return $9QtgA.readVarUint(this.restDecoder) === 1;
    }
    /**
   * @return {number} info An unsigned 8-bit integer
   */ readTypeRef() {
        return $9QtgA.readVarUint(this.restDecoder);
    }
    /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @return {number} len
   */ readLen() {
        return $9QtgA.readVarUint(this.restDecoder);
    }
    /**
   * @return {any}
   */ readAny() {
        return $9QtgA.readAny(this.restDecoder);
    }
    /**
   * @return {Uint8Array}
   */ readBuf() {
        return $7WDUw.copyUint8Array($9QtgA.readVarUint8Array(this.restDecoder));
    }
    /**
   * Legacy implementation uses JSON parse. We use any-decoding in v2.
   *
   * @return {any}
   */ readJSON() {
        return JSON.parse($9QtgA.readVarString(this.restDecoder));
    }
    /**
   * @return {string}
   */ readKey() {
        return $9QtgA.readVarString(this.restDecoder);
    }
}
class $a852d2d5bb3d1ec6$var$DSDecoderV2 {
    /**
   * @param {decoding.Decoder} decoder
   */ constructor(decoder){
        /**
     * @private
     */ this.dsCurrVal = 0;
        this.restDecoder = decoder;
    }
    resetDsCurVal() {
        this.dsCurrVal = 0;
    }
    /**
   * @return {number}
   */ readDsClock() {
        this.dsCurrVal += $9QtgA.readVarUint(this.restDecoder);
        return this.dsCurrVal;
    }
    /**
   * @return {number}
   */ readDsLen() {
        const diff = $9QtgA.readVarUint(this.restDecoder) + 1;
        this.dsCurrVal += diff;
        return diff;
    }
}
class $a852d2d5bb3d1ec6$export$1c932452355c5571 extends $a852d2d5bb3d1ec6$var$DSDecoderV2 {
    /**
   * @param {decoding.Decoder} decoder
   */ constructor(decoder){
        super(decoder);
        /**
     * List of cached keys. If the keys[id] does not exist, we read a new key
     * from stringEncoder and push it to keys.
     *
     * @type {Array<string>}
     */ this.keys = [];
        $9QtgA.readVarUint(decoder); // read feature flag - currently unused
        this.keyClockDecoder = new $9QtgA.IntDiffOptRleDecoder($9QtgA.readVarUint8Array(decoder));
        this.clientDecoder = new $9QtgA.UintOptRleDecoder($9QtgA.readVarUint8Array(decoder));
        this.leftClockDecoder = new $9QtgA.IntDiffOptRleDecoder($9QtgA.readVarUint8Array(decoder));
        this.rightClockDecoder = new $9QtgA.IntDiffOptRleDecoder($9QtgA.readVarUint8Array(decoder));
        this.infoDecoder = new $9QtgA.RleDecoder($9QtgA.readVarUint8Array(decoder), $9QtgA.readUint8);
        this.stringDecoder = new $9QtgA.StringDecoder($9QtgA.readVarUint8Array(decoder));
        this.parentInfoDecoder = new $9QtgA.RleDecoder($9QtgA.readVarUint8Array(decoder), $9QtgA.readUint8);
        this.typeRefDecoder = new $9QtgA.UintOptRleDecoder($9QtgA.readVarUint8Array(decoder));
        this.lenDecoder = new $9QtgA.UintOptRleDecoder($9QtgA.readVarUint8Array(decoder));
    }
    /**
   * @return {ID}
   */ readLeftID() {
        return new $a852d2d5bb3d1ec6$export$8be180ec26319f9f(this.clientDecoder.read(), this.leftClockDecoder.read());
    }
    /**
   * @return {ID}
   */ readRightID() {
        return new $a852d2d5bb3d1ec6$export$8be180ec26319f9f(this.clientDecoder.read(), this.rightClockDecoder.read());
    }
    /**
   * Read the next client id.
   * Use this in favor of readID whenever possible to reduce the number of objects created.
   */ readClient() {
        return this.clientDecoder.read();
    }
    /**
   * @return {number} info An unsigned 8-bit integer
   */ readInfo() {
        return /** @type {number} */ this.infoDecoder.read();
    }
    /**
   * @return {string}
   */ readString() {
        return this.stringDecoder.read();
    }
    /**
   * @return {boolean}
   */ readParentInfo() {
        return this.parentInfoDecoder.read() === 1;
    }
    /**
   * @return {number} An unsigned 8-bit integer
   */ readTypeRef() {
        return this.typeRefDecoder.read();
    }
    /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @return {number}
   */ readLen() {
        return this.lenDecoder.read();
    }
    /**
   * @return {any}
   */ readAny() {
        return $9QtgA.readAny(this.restDecoder);
    }
    /**
   * @return {Uint8Array}
   */ readBuf() {
        return $9QtgA.readVarUint8Array(this.restDecoder);
    }
    /**
   * This is mainly here for legacy purposes.
   *
   * Initial we incoded objects using JSON. Now we use the much faster lib0/any-encoder. This method mainly exists for legacy purposes for the v1 encoder.
   *
   * @return {any}
   */ readJSON() {
        return $9QtgA.readAny(this.restDecoder);
    }
    /**
   * @return {string}
   */ readKey() {
        const keyClock = this.keyClockDecoder.read();
        if (keyClock < this.keys.length) return this.keys[keyClock];
        else {
            const key = this.stringDecoder.read();
            this.keys.push(key);
            return key;
        }
    }
}
class $a852d2d5bb3d1ec6$var$DSEncoderV1 {
    constructor(){
        this.restEncoder = $kRma6.createEncoder();
    }
    toUint8Array() {
        return $kRma6.toUint8Array(this.restEncoder);
    }
    resetDsCurVal() {
    // nop
    }
    /**
   * @param {number} clock
   */ writeDsClock(clock) {
        $kRma6.writeVarUint(this.restEncoder, clock);
    }
    /**
   * @param {number} len
   */ writeDsLen(len) {
        $kRma6.writeVarUint(this.restEncoder, len);
    }
}
class $a852d2d5bb3d1ec6$export$99171b804d9c5b54 extends $a852d2d5bb3d1ec6$var$DSEncoderV1 {
    /**
   * @param {ID} id
   */ writeLeftID(id) {
        $kRma6.writeVarUint(this.restEncoder, id.client);
        $kRma6.writeVarUint(this.restEncoder, id.clock);
    }
    /**
   * @param {ID} id
   */ writeRightID(id) {
        $kRma6.writeVarUint(this.restEncoder, id.client);
        $kRma6.writeVarUint(this.restEncoder, id.clock);
    }
    /**
   * Use writeClient and writeClock instead of writeID if possible.
   * @param {number} client
   */ writeClient(client) {
        $kRma6.writeVarUint(this.restEncoder, client);
    }
    /**
   * @param {number} info An unsigned 8-bit integer
   */ writeInfo(info) {
        $kRma6.writeUint8(this.restEncoder, info);
    }
    /**
   * @param {string} s
   */ writeString(s) {
        $kRma6.writeVarString(this.restEncoder, s);
    }
    /**
   * @param {boolean} isYKey
   */ writeParentInfo(isYKey) {
        $kRma6.writeVarUint(this.restEncoder, isYKey ? 1 : 0);
    }
    /**
   * @param {number} info An unsigned 8-bit integer
   */ writeTypeRef(info) {
        $kRma6.writeVarUint(this.restEncoder, info);
    }
    /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @param {number} len
   */ writeLen(len) {
        $kRma6.writeVarUint(this.restEncoder, len);
    }
    /**
   * @param {any} any
   */ writeAny(any) {
        $kRma6.writeAny(this.restEncoder, any);
    }
    /**
   * @param {Uint8Array} buf
   */ writeBuf(buf) {
        $kRma6.writeVarUint8Array(this.restEncoder, buf);
    }
    /**
   * @param {any} embed
   */ writeJSON(embed) {
        $kRma6.writeVarString(this.restEncoder, JSON.stringify(embed));
    }
    /**
   * @param {string} key
   */ writeKey(key) {
        $kRma6.writeVarString(this.restEncoder, key);
    }
}
class $a852d2d5bb3d1ec6$var$DSEncoderV2 {
    constructor(){
        this.restEncoder = $kRma6.createEncoder(); // encodes all the rest / non-optimized
        this.dsCurrVal = 0;
    }
    toUint8Array() {
        return $kRma6.toUint8Array(this.restEncoder);
    }
    resetDsCurVal() {
        this.dsCurrVal = 0;
    }
    /**
   * @param {number} clock
   */ writeDsClock(clock) {
        const diff = clock - this.dsCurrVal;
        this.dsCurrVal = clock;
        $kRma6.writeVarUint(this.restEncoder, diff);
    }
    /**
   * @param {number} len
   */ writeDsLen(len) {
        if (len === 0) $gFLjS.unexpectedCase();
        $kRma6.writeVarUint(this.restEncoder, len - 1);
        this.dsCurrVal += len;
    }
}
class $a852d2d5bb3d1ec6$export$30c99e08943e1c2 extends $a852d2d5bb3d1ec6$var$DSEncoderV2 {
    constructor(){
        super();
        /**
     * @type {Map<string,number>}
     */ this.keyMap = new Map();
        /**
     * Refers to the next uniqe key-identifier to me used.
     * See writeKey method for more information.
     *
     * @type {number}
     */ this.keyClock = 0;
        this.keyClockEncoder = new $kRma6.IntDiffOptRleEncoder();
        this.clientEncoder = new $kRma6.UintOptRleEncoder();
        this.leftClockEncoder = new $kRma6.IntDiffOptRleEncoder();
        this.rightClockEncoder = new $kRma6.IntDiffOptRleEncoder();
        this.infoEncoder = new $kRma6.RleEncoder($kRma6.writeUint8);
        this.stringEncoder = new $kRma6.StringEncoder();
        this.parentInfoEncoder = new $kRma6.RleEncoder($kRma6.writeUint8);
        this.typeRefEncoder = new $kRma6.UintOptRleEncoder();
        this.lenEncoder = new $kRma6.UintOptRleEncoder();
    }
    toUint8Array() {
        const encoder = $kRma6.createEncoder();
        $kRma6.writeVarUint(encoder, 0); // this is a feature flag that we might use in the future
        $kRma6.writeVarUint8Array(encoder, this.keyClockEncoder.toUint8Array());
        $kRma6.writeVarUint8Array(encoder, this.clientEncoder.toUint8Array());
        $kRma6.writeVarUint8Array(encoder, this.leftClockEncoder.toUint8Array());
        $kRma6.writeVarUint8Array(encoder, this.rightClockEncoder.toUint8Array());
        $kRma6.writeVarUint8Array(encoder, $kRma6.toUint8Array(this.infoEncoder));
        $kRma6.writeVarUint8Array(encoder, this.stringEncoder.toUint8Array());
        $kRma6.writeVarUint8Array(encoder, $kRma6.toUint8Array(this.parentInfoEncoder));
        $kRma6.writeVarUint8Array(encoder, this.typeRefEncoder.toUint8Array());
        $kRma6.writeVarUint8Array(encoder, this.lenEncoder.toUint8Array());
        // @note The rest encoder is appended! (note the missing var)
        $kRma6.writeUint8Array(encoder, $kRma6.toUint8Array(this.restEncoder));
        return $kRma6.toUint8Array(encoder);
    }
    /**
   * @param {ID} id
   */ writeLeftID(id) {
        this.clientEncoder.write(id.client);
        this.leftClockEncoder.write(id.clock);
    }
    /**
   * @param {ID} id
   */ writeRightID(id) {
        this.clientEncoder.write(id.client);
        this.rightClockEncoder.write(id.clock);
    }
    /**
   * @param {number} client
   */ writeClient(client) {
        this.clientEncoder.write(client);
    }
    /**
   * @param {number} info An unsigned 8-bit integer
   */ writeInfo(info) {
        this.infoEncoder.write(info);
    }
    /**
   * @param {string} s
   */ writeString(s) {
        this.stringEncoder.write(s);
    }
    /**
   * @param {boolean} isYKey
   */ writeParentInfo(isYKey) {
        this.parentInfoEncoder.write(isYKey ? 1 : 0);
    }
    /**
   * @param {number} info An unsigned 8-bit integer
   */ writeTypeRef(info) {
        this.typeRefEncoder.write(info);
    }
    /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @param {number} len
   */ writeLen(len) {
        this.lenEncoder.write(len);
    }
    /**
   * @param {any} any
   */ writeAny(any) {
        $kRma6.writeAny(this.restEncoder, any);
    }
    /**
   * @param {Uint8Array} buf
   */ writeBuf(buf) {
        $kRma6.writeVarUint8Array(this.restEncoder, buf);
    }
    /**
   * This is mainly here for legacy purposes.
   *
   * Initial we incoded objects using JSON. Now we use the much faster lib0/any-encoder. This method mainly exists for legacy purposes for the v1 encoder.
   *
   * @param {any} embed
   */ writeJSON(embed) {
        $kRma6.writeAny(this.restEncoder, embed);
    }
    /**
   * Property keys are often reused. For example, in y-prosemirror the key `bold` might
   * occur very often. For a 3d application, the key `position` might occur very often.
   *
   * We cache these keys in a Map and refer to them via a unique number.
   *
   * @param {string} key
   */ writeKey(key) {
        const clock = this.keyMap.get(key);
        if (clock === undefined) {
            /**
       * @todo uncomment to introduce this feature finally
       *
       * Background. The ContentFormat object was always encoded using writeKey, but the decoder used to use readString.
       * Furthermore, I forgot to set the keyclock. So everything was working fine.
       *
       * However, this feature here is basically useless as it is not being used (it actually only consumes extra memory).
       *
       * I don't know yet how to reintroduce this feature..
       *
       * Older clients won't be able to read updates when we reintroduce this feature. So this should probably be done using a flag.
       *
       */ // this.keyMap.set(key, this.keyClock)
            this.keyClockEncoder.write(this.keyClock++);
            this.stringEncoder.write(key);
        } else this.keyClockEncoder.write(clock);
    }
}
/**
 * @module encoding
 */ /*
 * We use the first five bits in the info flag for determining the type of the struct.
 *
 * 0: GC
 * 1: Item with Deleted content
 * 2: Item with JSON content
 * 3: Item with Binary content
 * 4: Item with String content
 * 5: Item with Embed content (for richtext content)
 * 6: Item with Format content (a formatting marker for richtext content)
 * 7: Item with Type
 */ /**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Array<GC|Item>} structs All structs by `client`
 * @param {number} client
 * @param {number} clock write structs starting with `ID(client,clock)`
 *
 * @function
 */ const $a852d2d5bb3d1ec6$var$writeStructs = (encoder, structs, client, clock)=>{
    // write first id
    clock = $bJmyZ.max(clock, structs[0].id.clock); // make sure the first id exists
    const startNewStructs = $a852d2d5bb3d1ec6$export$5f8f02523cf47b58(structs, clock);
    // write # encoded structs
    $kRma6.writeVarUint(encoder.restEncoder, structs.length - startNewStructs);
    encoder.writeClient(client);
    $kRma6.writeVarUint(encoder.restEncoder, clock);
    const firstStruct = structs[startNewStructs];
    // write first struct with an offset
    firstStruct.write(encoder, clock - firstStruct.id.clock);
    for(let i = startNewStructs + 1; i < structs.length; i++)structs[i].write(encoder, 0);
};
/**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {StructStore} store
 * @param {Map<number,number>} _sm
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$writeClientsStructs = (encoder, store, _sm)=>{
    // we filter all valid _sm entries into sm
    const sm = new Map();
    _sm.forEach((clock, client)=>{
        // only write if new structs are available
        if ($a852d2d5bb3d1ec6$export$50fdfeece43146fd(store, client) > clock) sm.set(client, clock);
    });
    $a852d2d5bb3d1ec6$var$getStateVector(store).forEach((_clock, client)=>{
        if (!_sm.has(client)) sm.set(client, 0);
    });
    // write # states that were updated
    $kRma6.writeVarUint(encoder.restEncoder, sm.size);
    // Write items with higher client ids first
    // This heavily improves the conflict algorithm.
    $dWqHQ.from(sm.entries()).sort((a, b)=>b[0] - a[0]).forEach(([client, clock])=>{
        $a852d2d5bb3d1ec6$var$writeStructs(encoder, /** @type {Array<GC|Item>} */ store.clients.get(client), client, clock);
    });
};
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder The decoder object to read data from.
 * @param {Doc} doc
 * @return {Map<number, { i: number, refs: Array<Item | GC> }>}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$readClientsStructRefs = (decoder, doc)=>{
    /**
   * @type {Map<number, { i: number, refs: Array<Item | GC> }>}
   */ const clientRefs = $d1VR8.create();
    const numOfStateUpdates = $9QtgA.readVarUint(decoder.restDecoder);
    for(let i = 0; i < numOfStateUpdates; i++){
        const numberOfStructs = $9QtgA.readVarUint(decoder.restDecoder);
        /**
     * @type {Array<GC|Item>}
     */ const refs = new Array(numberOfStructs);
        const client = decoder.readClient();
        let clock = $9QtgA.readVarUint(decoder.restDecoder);
        // const start = performance.now()
        clientRefs.set(client, {
            i: 0,
            refs: refs
        });
        for(let i = 0; i < numberOfStructs; i++){
            const info = decoder.readInfo();
            switch($6ciaJ.BITS5 & info){
                case 0:
                    {
                        const len = decoder.readLen();
                        refs[i] = new $a852d2d5bb3d1ec6$export$12d259ff017e6b58($a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(client, clock), len);
                        clock += len;
                        break;
                    }
                case 10:
                    {
                        // @todo we could reduce the amount of checks by adding Skip struct to clientRefs so we know that something is missing.
                        const len = $9QtgA.readVarUint(decoder.restDecoder);
                        refs[i] = new $a852d2d5bb3d1ec6$export$38d24f5c1eb0e4c0($a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(client, clock), len);
                        clock += len;
                        break;
                    }
                default:
                    {
                        /**
           * The optimized implementation doesn't use any variables because inlining variables is faster.
           * Below a non-optimized version is shown that implements the basic algorithm with
           * a few comments
           */ const cantCopyParentInfo = (info & ($6ciaJ.BIT7 | $6ciaJ.BIT8)) === 0;
                        // If parent = null and neither left nor right are defined, then we know that `parent` is child of `y`
                        // and we read the next string as parentYKey.
                        // It indicates how we store/retrieve parent from `y.share`
                        // @type {string|null}
                        const struct = new $a852d2d5bb3d1ec6$export$6d08773d2e66f8f2($a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(client, clock), null, (info & $6ciaJ.BIT8) === $6ciaJ.BIT8 ? decoder.readLeftID() : null, null, (info & $6ciaJ.BIT7) === $6ciaJ.BIT7 ? decoder.readRightID() : null, cantCopyParentInfo ? decoder.readParentInfo() ? doc.get(decoder.readString()) : decoder.readLeftID() : null, cantCopyParentInfo && (info & $6ciaJ.BIT6) === $6ciaJ.BIT6 ? decoder.readString() : null, $a852d2d5bb3d1ec6$var$readItemContent(decoder, info) // item content
                        );
                        /* A non-optimized implementation of the above algorithm:

          // The item that was originally to the left of this item.
          const origin = (info & binary.BIT8) === binary.BIT8 ? decoder.readLeftID() : null
          // The item that was originally to the right of this item.
          const rightOrigin = (info & binary.BIT7) === binary.BIT7 ? decoder.readRightID() : null
          const cantCopyParentInfo = (info & (binary.BIT7 | binary.BIT8)) === 0
          const hasParentYKey = cantCopyParentInfo ? decoder.readParentInfo() : false
          // If parent = null and neither left nor right are defined, then we know that `parent` is child of `y`
          // and we read the next string as parentYKey.
          // It indicates how we store/retrieve parent from `y.share`
          // @type {string|null}
          const parentYKey = cantCopyParentInfo && hasParentYKey ? decoder.readString() : null

          const struct = new Item(
            createID(client, clock),
            null, // left
            origin, // origin
            null, // right
            rightOrigin, // right origin
            cantCopyParentInfo && !hasParentYKey ? decoder.readLeftID() : (parentYKey !== null ? doc.get(parentYKey) : null), // parent
            cantCopyParentInfo && (info & binary.BIT6) === binary.BIT6 ? decoder.readString() : null, // parentSub
            readItemContent(decoder, info) // item content
          )
          */ refs[i] = struct;
                        clock += struct.length;
                    }
            }
        }
    // console.log('time to read: ', performance.now() - start) // @todo remove
    }
    return clientRefs;
};
/**
 * Resume computing structs generated by struct readers.
 *
 * While there is something to do, we integrate structs in this order
 * 1. top element on stack, if stack is not empty
 * 2. next element from current struct reader (if empty, use next struct reader)
 *
 * If struct causally depends on another struct (ref.missing), we put next reader of
 * `ref.id.client` on top of stack.
 *
 * At some point we find a struct that has no causal dependencies,
 * then we start emptying the stack.
 *
 * It is not possible to have circles: i.e. struct1 (from client1) depends on struct2 (from client2)
 * depends on struct3 (from client1). Therefore the max stack size is eqaul to `structReaders.length`.
 *
 * This method is implemented in a way so that we can resume computation if this update
 * causally depends on another update.
 *
 * @param {Transaction} transaction
 * @param {StructStore} store
 * @param {Map<number, { i: number, refs: (GC | Item)[] }>} clientsStructRefs
 * @return { null | { update: Uint8Array, missing: Map<number,number> } }
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$integrateStructs = (transaction, store, clientsStructRefs)=>{
    /**
   * @type {Array<Item | GC>}
   */ const stack = [];
    // sort them so that we take the higher id first, in case of conflicts the lower id will probably not conflict with the id from the higher user.
    let clientsStructRefsIds = $dWqHQ.from(clientsStructRefs.keys()).sort((a, b)=>a - b);
    if (clientsStructRefsIds.length === 0) return null;
    const getNextStructTarget = ()=>{
        if (clientsStructRefsIds.length === 0) return null;
        let nextStructsTarget = /** @type {{i:number,refs:Array<GC|Item>}} */ clientsStructRefs.get(clientsStructRefsIds[clientsStructRefsIds.length - 1]);
        while(nextStructsTarget.refs.length === nextStructsTarget.i){
            clientsStructRefsIds.pop();
            if (clientsStructRefsIds.length > 0) nextStructsTarget = /** @type {{i:number,refs:Array<GC|Item>}} */ clientsStructRefs.get(clientsStructRefsIds[clientsStructRefsIds.length - 1]);
            else return null;
        }
        return nextStructsTarget;
    };
    let curStructsTarget = getNextStructTarget();
    if (curStructsTarget === null) return null;
    /**
   * @type {StructStore}
   */ const restStructs = new $a852d2d5bb3d1ec6$var$StructStore();
    const missingSV = new Map();
    /**
   * @param {number} client
   * @param {number} clock
   */ const updateMissingSv = (client, clock)=>{
        const mclock = missingSV.get(client);
        if (mclock == null || mclock > clock) missingSV.set(client, clock);
    };
    /**
   * @type {GC|Item}
   */ let stackHead = /** @type {any} */ curStructsTarget.refs[/** @type {any} */ curStructsTarget.i++];
    // caching the state because it is used very often
    const state = new Map();
    const addStackToRestSS = ()=>{
        for (const item of stack){
            const client = item.id.client;
            const unapplicableItems = clientsStructRefs.get(client);
            if (unapplicableItems) {
                // decrement because we weren't able to apply previous operation
                unapplicableItems.i--;
                restStructs.clients.set(client, unapplicableItems.refs.slice(unapplicableItems.i));
                clientsStructRefs.delete(client);
                unapplicableItems.i = 0;
                unapplicableItems.refs = [];
            } else // item was the last item on clientsStructRefs and the field was already cleared. Add item to restStructs and continue
            restStructs.clients.set(client, [
                item
            ]);
            // remove client from clientsStructRefsIds to prevent users from applying the same update again
            clientsStructRefsIds = clientsStructRefsIds.filter((c)=>c !== client);
        }
        stack.length = 0;
    };
    // iterate over all struct readers until we are done
    while(true){
        if (stackHead.constructor !== $a852d2d5bb3d1ec6$export$38d24f5c1eb0e4c0) {
            const localClock = $d1VR8.setIfUndefined(state, stackHead.id.client, ()=>$a852d2d5bb3d1ec6$export$50fdfeece43146fd(store, stackHead.id.client));
            const offset = localClock - stackHead.id.clock;
            if (offset < 0) {
                // update from the same client is missing
                stack.push(stackHead);
                updateMissingSv(stackHead.id.client, stackHead.id.clock - 1);
                // hid a dead wall, add all items from stack to restSS
                addStackToRestSS();
            } else {
                const missing = stackHead.getMissing(transaction, store);
                if (missing !== null) {
                    stack.push(stackHead);
                    // get the struct reader that has the missing struct
                    /**
           * @type {{ refs: Array<GC|Item>, i: number }}
           */ const structRefs = clientsStructRefs.get(/** @type {number} */ missing) || {
                        refs: [],
                        i: 0
                    };
                    if (structRefs.refs.length === structRefs.i) {
                        // This update message causally depends on another update message that doesn't exist yet
                        updateMissingSv(/** @type {number} */ missing, $a852d2d5bb3d1ec6$export$50fdfeece43146fd(store, missing));
                        addStackToRestSS();
                    } else {
                        stackHead = structRefs.refs[structRefs.i++];
                        continue;
                    }
                } else if (offset === 0 || offset < stackHead.length) {
                    // all fine, apply the stackhead
                    stackHead.integrate(transaction, offset);
                    state.set(stackHead.id.client, stackHead.id.clock + stackHead.length);
                }
            }
        }
        // iterate to next stackHead
        if (stack.length > 0) stackHead = /** @type {GC|Item} */ stack.pop();
        else if (curStructsTarget !== null && curStructsTarget.i < curStructsTarget.refs.length) stackHead = /** @type {GC|Item} */ curStructsTarget.refs[curStructsTarget.i++];
        else {
            curStructsTarget = getNextStructTarget();
            if (curStructsTarget === null) break;
            else stackHead = /** @type {GC|Item} */ curStructsTarget.refs[curStructsTarget.i++];
        }
    }
    if (restStructs.clients.size > 0) {
        const encoder = new $a852d2d5bb3d1ec6$export$30c99e08943e1c2();
        $a852d2d5bb3d1ec6$var$writeClientsStructs(encoder, restStructs, new Map());
        // write empty deleteset
        // writeDeleteSet(encoder, new DeleteSet())
        $kRma6.writeVarUint(encoder.restEncoder, 0); // => no need for an extra function call, just write 0 deletes
        return {
            missing: missingSV,
            update: encoder.toUint8Array()
        };
    }
    return null;
};
/**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Transaction} transaction
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$writeStructsFromTransaction = (encoder, transaction)=>$a852d2d5bb3d1ec6$var$writeClientsStructs(encoder, transaction.doc.store, transaction.beforeState);
/**
 * Read and apply a document update.
 *
 * This function has the same effect as `applyUpdate` but accepts a decoder.
 *
 * @param {decoding.Decoder} decoder
 * @param {Doc} ydoc
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 * @param {UpdateDecoderV1 | UpdateDecoderV2} [structDecoder]
 *
 * @function
 */ const $a852d2d5bb3d1ec6$export$7abe492a0b891b4d = (decoder, ydoc, transactionOrigin, structDecoder = new $a852d2d5bb3d1ec6$export$1c932452355c5571(decoder))=>$a852d2d5bb3d1ec6$export$dac1bad6146b2469(ydoc, (transaction)=>{
        // force that transaction.local is set to non-local
        transaction.local = false;
        let retry = false;
        const doc = transaction.doc;
        const store = doc.store;
        // let start = performance.now()
        const ss = $a852d2d5bb3d1ec6$var$readClientsStructRefs(structDecoder, doc);
        // console.log('time to read structs: ', performance.now() - start) // @todo remove
        // start = performance.now()
        // console.log('time to merge: ', performance.now() - start) // @todo remove
        // start = performance.now()
        const restStructs = $a852d2d5bb3d1ec6$var$integrateStructs(transaction, store, ss);
        const pending = store.pendingStructs;
        if (pending) {
            // check if we can apply something
            for (const [client, clock] of pending.missing)if (clock < $a852d2d5bb3d1ec6$export$50fdfeece43146fd(store, client)) {
                retry = true;
                break;
            }
            if (restStructs) {
                // merge restStructs into store.pending
                for (const [client, clock] of restStructs.missing){
                    const mclock = pending.missing.get(client);
                    if (mclock == null || mclock > clock) pending.missing.set(client, clock);
                }
                pending.update = $a852d2d5bb3d1ec6$export$ce273d78de0331d1([
                    pending.update,
                    restStructs.update
                ]);
            }
        } else store.pendingStructs = restStructs;
        // console.log('time to integrate: ', performance.now() - start) // @todo remove
        // start = performance.now()
        const dsRest = $a852d2d5bb3d1ec6$var$readAndApplyDeleteSet(structDecoder, transaction, store);
        if (store.pendingDs) {
            // @todo we could make a lower-bound state-vector check as we do above
            const pendingDSUpdate = new $a852d2d5bb3d1ec6$export$1c932452355c5571($9QtgA.createDecoder(store.pendingDs));
            $9QtgA.readVarUint(pendingDSUpdate.restDecoder); // read 0 structs, because we only encode deletes in pendingdsupdate
            const dsRest2 = $a852d2d5bb3d1ec6$var$readAndApplyDeleteSet(pendingDSUpdate, transaction, store);
            if (dsRest && dsRest2) // case 1: ds1 != null && ds2 != null
            store.pendingDs = $a852d2d5bb3d1ec6$export$ce273d78de0331d1([
                dsRest,
                dsRest2
            ]);
            else // case 2: ds1 != null
            // case 3: ds2 != null
            // case 4: ds1 == null && ds2 == null
            store.pendingDs = dsRest || dsRest2;
        } else // Either dsRest == null && pendingDs == null OR dsRest != null
        store.pendingDs = dsRest;
        // console.log('time to cleanup: ', performance.now() - start) // @todo remove
        // start = performance.now()
        // console.log('time to resume delete readers: ', performance.now() - start) // @todo remove
        // start = performance.now()
        if (retry) {
            const update = /** @type {{update: Uint8Array}} */ store.pendingStructs.update;
            store.pendingStructs = null;
            $a852d2d5bb3d1ec6$export$acc3b0324aabf1b6(transaction.doc, update);
        }
    }, transactionOrigin, false);
/**
 * Read and apply a document update.
 *
 * This function has the same effect as `applyUpdate` but accepts a decoder.
 *
 * @param {decoding.Decoder} decoder
 * @param {Doc} ydoc
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 *
 * @function
 */ const $a852d2d5bb3d1ec6$export$d67ac8d73b7d336c = (decoder, ydoc, transactionOrigin)=>$a852d2d5bb3d1ec6$export$7abe492a0b891b4d(decoder, ydoc, transactionOrigin, new $a852d2d5bb3d1ec6$export$1aa46d9818b5d1ec(decoder));
/**
 * Apply a document update created by, for example, `y.on('update', update => ..)` or `update = encodeStateAsUpdate()`.
 *
 * This function has the same effect as `readUpdate` but accepts an Uint8Array instead of a Decoder.
 *
 * @param {Doc} ydoc
 * @param {Uint8Array} update
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} [YDecoder]
 *
 * @function
 */ const $a852d2d5bb3d1ec6$export$acc3b0324aabf1b6 = (ydoc, update, transactionOrigin, YDecoder = $a852d2d5bb3d1ec6$export$1c932452355c5571)=>{
    const decoder = $9QtgA.createDecoder(update);
    $a852d2d5bb3d1ec6$export$7abe492a0b891b4d(decoder, ydoc, transactionOrigin, new YDecoder(decoder));
};
/**
 * Apply a document update created by, for example, `y.on('update', update => ..)` or `update = encodeStateAsUpdate()`.
 *
 * This function has the same effect as `readUpdate` but accepts an Uint8Array instead of a Decoder.
 *
 * @param {Doc} ydoc
 * @param {Uint8Array} update
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 *
 * @function
 */ const $a852d2d5bb3d1ec6$export$c271737a9c02e925 = (ydoc, update, transactionOrigin)=>$a852d2d5bb3d1ec6$export$acc3b0324aabf1b6(ydoc, update, transactionOrigin, $a852d2d5bb3d1ec6$export$1aa46d9818b5d1ec);
/**
 * Write all the document as a single update message. If you specify the state of the remote client (`targetStateVector`) it will
 * only write the operations that are missing.
 *
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Doc} doc
 * @param {Map<number,number>} [targetStateVector] The state of the target that receives the update. Leave empty to write all known structs
 *
 * @function
 */ const $a852d2d5bb3d1ec6$var$writeStateAsUpdate = (encoder, doc, targetStateVector = new Map())=>{
    $a852d2d5bb3d1ec6$var$writeClientsStructs(encoder, doc.store, targetStateVector);
    $a852d2d5bb3d1ec6$var$writeDeleteSet(encoder, $a852d2d5bb3d1ec6$export$8450d668bec558e2(doc.store));
};
/**
 * Write all the document as a single update message that can be applied on the remote document. If you specify the state of the remote client (`targetState`) it will
 * only write the operations that are missing.
 *
 * Use `writeStateAsUpdate` instead if you are working with lib0/encoding.js#Encoder
 *
 * @param {Doc} doc
 * @param {Uint8Array} [encodedTargetStateVector] The state of the target that receives the update. Leave empty to write all known structs
 * @param {UpdateEncoderV1 | UpdateEncoderV2} [encoder]
 * @return {Uint8Array}
 *
 * @function
 */ const $a852d2d5bb3d1ec6$export$90338e0798f6f64f = (doc, encodedTargetStateVector = new Uint8Array([
    0
]), encoder = new $a852d2d5bb3d1ec6$export$30c99e08943e1c2())=>{
    const targetStateVector = $a852d2d5bb3d1ec6$export$324ac6fb20a844e3(encodedTargetStateVector);
    $a852d2d5bb3d1ec6$var$writeStateAsUpdate(encoder, doc, targetStateVector);
    const updates = [
        encoder.toUint8Array()
    ];
    // also add the pending updates (if there are any)
    if (doc.store.pendingDs) updates.push(doc.store.pendingDs);
    if (doc.store.pendingStructs) updates.push($a852d2d5bb3d1ec6$export$a8143edf39d2ad8e(doc.store.pendingStructs.update, encodedTargetStateVector));
    if (updates.length > 1) {
        if (encoder.constructor === $a852d2d5bb3d1ec6$export$99171b804d9c5b54) return $a852d2d5bb3d1ec6$export$6319871659fd2460(updates.map((update, i)=>i === 0 ? update : $a852d2d5bb3d1ec6$export$afffbdeed14adbd(update)));
        else if (encoder.constructor === $a852d2d5bb3d1ec6$export$30c99e08943e1c2) return $a852d2d5bb3d1ec6$export$ce273d78de0331d1(updates);
    }
    return updates[0];
};
/**
 * Write all the document as a single update message that can be applied on the remote document. If you specify the state of the remote client (`targetState`) it will
 * only write the operations that are missing.
 *
 * Use `writeStateAsUpdate` instead if you are working with lib0/encoding.js#Encoder
 *
 * @param {Doc} doc
 * @param {Uint8Array} [encodedTargetStateVector] The state of the target that receives the update. Leave empty to write all known structs
 * @return {Uint8Array}
 *
 * @function
 */ const $a852d2d5bb3d1ec6$export$e5848df80e65bd53 = (doc, encodedTargetStateVector)=>$a852d2d5bb3d1ec6$export$90338e0798f6f64f(doc, encodedTargetStateVector, new $a852d2d5bb3d1ec6$export$99171b804d9c5b54());
/**
 * Read state vector from Decoder and return as Map
 *
 * @param {DSDecoderV1 | DSDecoderV2} decoder
 * @return {Map<number,number>} Maps `client` to the number next expected `clock` from that client.
 *
 * @function
 */ const $a852d2d5bb3d1ec6$var$readStateVector = (decoder)=>{
    const ss = new Map();
    const ssLength = $9QtgA.readVarUint(decoder.restDecoder);
    for(let i = 0; i < ssLength; i++){
        const client = $9QtgA.readVarUint(decoder.restDecoder);
        const clock = $9QtgA.readVarUint(decoder.restDecoder);
        ss.set(client, clock);
    }
    return ss;
};
/**
 * Read decodedState and return State as Map.
 *
 * @param {Uint8Array} decodedState
 * @return {Map<number,number>} Maps `client` to the number next expected `clock` from that client.
 *
 * @function
 */ // export const decodeStateVectorV2 = decodedState => readStateVector(new DSDecoderV2(decoding.createDecoder(decodedState)))
/**
 * Read decodedState and return State as Map.
 *
 * @param {Uint8Array} decodedState
 * @return {Map<number,number>} Maps `client` to the number next expected `clock` from that client.
 *
 * @function
 */ const $a852d2d5bb3d1ec6$export$324ac6fb20a844e3 = (decodedState)=>$a852d2d5bb3d1ec6$var$readStateVector(new $a852d2d5bb3d1ec6$var$DSDecoderV1($9QtgA.createDecoder(decodedState)));
/**
 * @param {DSEncoderV1 | DSEncoderV2} encoder
 * @param {Map<number,number>} sv
 * @function
 */ const $a852d2d5bb3d1ec6$var$writeStateVector = (encoder, sv)=>{
    $kRma6.writeVarUint(encoder.restEncoder, sv.size);
    $dWqHQ.from(sv.entries()).sort((a, b)=>b[0] - a[0]).forEach(([client, clock])=>{
        $kRma6.writeVarUint(encoder.restEncoder, client); // @todo use a special client decoder that is based on mapping
        $kRma6.writeVarUint(encoder.restEncoder, clock);
    });
    return encoder;
};
/**
 * @param {DSEncoderV1 | DSEncoderV2} encoder
 * @param {Doc} doc
 *
 * @function
 */ const $a852d2d5bb3d1ec6$var$writeDocumentStateVector = (encoder, doc)=>$a852d2d5bb3d1ec6$var$writeStateVector(encoder, $a852d2d5bb3d1ec6$var$getStateVector(doc.store));
/**
 * Encode State as Uint8Array.
 *
 * @param {Doc|Map<number,number>} doc
 * @param {DSEncoderV1 | DSEncoderV2} [encoder]
 * @return {Uint8Array}
 *
 * @function
 */ const $a852d2d5bb3d1ec6$var$encodeStateVectorV2 = (doc, encoder = new $a852d2d5bb3d1ec6$var$DSEncoderV2())=>{
    if (doc instanceof Map) $a852d2d5bb3d1ec6$var$writeStateVector(encoder, doc);
    else $a852d2d5bb3d1ec6$var$writeDocumentStateVector(encoder, doc);
    return encoder.toUint8Array();
};
/**
 * Encode State as Uint8Array.
 *
 * @param {Doc|Map<number,number>} doc
 * @return {Uint8Array}
 *
 * @function
 */ const $a852d2d5bb3d1ec6$export$3e2f5393f32e71f = (doc)=>$a852d2d5bb3d1ec6$var$encodeStateVectorV2(doc, new $a852d2d5bb3d1ec6$var$DSEncoderV1());
/**
 * General event handler implementation.
 *
 * @template ARG0, ARG1
 *
 * @private
 */ class $a852d2d5bb3d1ec6$var$EventHandler {
    constructor(){
        /**
     * @type {Array<function(ARG0, ARG1):void>}
     */ this.l = [];
    }
}
/**
 * @template ARG0,ARG1
 * @returns {EventHandler<ARG0,ARG1>}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$createEventHandler = ()=>new $a852d2d5bb3d1ec6$var$EventHandler();
/**
 * Adds an event listener that is called when
 * {@link EventHandler#callEventListeners} is called.
 *
 * @template ARG0,ARG1
 * @param {EventHandler<ARG0,ARG1>} eventHandler
 * @param {function(ARG0,ARG1):void} f The event handler.
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$addEventHandlerListener = (eventHandler, f)=>eventHandler.l.push(f);
/**
 * Removes an event listener.
 *
 * @template ARG0,ARG1
 * @param {EventHandler<ARG0,ARG1>} eventHandler
 * @param {function(ARG0,ARG1):void} f The event handler that was added with
 *                     {@link EventHandler#addEventListener}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$removeEventHandlerListener = (eventHandler, f)=>{
    const l = eventHandler.l;
    const len = l.length;
    eventHandler.l = l.filter((g)=>f !== g);
    if (len === eventHandler.l.length) console.error('[yjs] Tried to remove event handler that doesn\'t exist.');
};
/**
 * Call all event listeners that were added via
 * {@link EventHandler#addEventListener}.
 *
 * @template ARG0,ARG1
 * @param {EventHandler<ARG0,ARG1>} eventHandler
 * @param {ARG0} arg0
 * @param {ARG1} arg1
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$callEventHandlerListeners = (eventHandler, arg0, arg1)=>$45hHO.callAll(eventHandler.l, [
        arg0,
        arg1
    ]);
class $a852d2d5bb3d1ec6$export$8be180ec26319f9f {
    /**
   * @param {number} client client id
   * @param {number} clock unique per client id, continuous number
   */ constructor(client, clock){
        /**
     * Client id
     * @type {number}
     */ this.client = client;
        /**
     * unique per client id, continuous number
     * @type {number}
     */ this.clock = clock;
    }
}
/**
 * @param {ID | null} a
 * @param {ID | null} b
 * @return {boolean}
 *
 * @function
 */ const $a852d2d5bb3d1ec6$export$c0af976e7e459c02 = (a, b)=>a === b || a !== null && b !== null && a.client === b.client && a.clock === b.clock;
/**
 * @param {number} client
 * @param {number} clock
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$export$6c7d4e6171d008d0 = (client, clock)=>new $a852d2d5bb3d1ec6$export$8be180ec26319f9f(client, clock);
/**
 * @param {encoding.Encoder} encoder
 * @param {ID} id
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$writeID = (encoder, id)=>{
    $kRma6.writeVarUint(encoder, id.client);
    $kRma6.writeVarUint(encoder, id.clock);
};
/**
 * Read ID.
 * * If first varUint read is 0xFFFFFF a RootID is returned.
 * * Otherwise an ID is returned
 *
 * @param {decoding.Decoder} decoder
 * @return {ID}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$readID = (decoder)=>$a852d2d5bb3d1ec6$export$6c7d4e6171d008d0($9QtgA.readVarUint(decoder), $9QtgA.readVarUint(decoder));
/**
 * The top types are mapped from y.share.get(keyname) => type.
 * `type` does not store any information about the `keyname`.
 * This function finds the correct `keyname` for `type` and throws otherwise.
 *
 * @param {AbstractType<any>} type
 * @return {string}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$export$e726a40920d54663 = (type)=>{
    // @ts-ignore _y must be defined, otherwise unexpected case
    for (const [key, value] of type.doc.share.entries()){
        if (value === type) return key;
    }
    throw $gFLjS.unexpectedCase();
};
/**
 * Check if `parent` is a parent of `child`.
 *
 * @param {AbstractType<any>} parent
 * @param {Item|null} child
 * @return {Boolean} Whether `parent` is a parent of `child`.
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$export$3c81af374b054d6a = (parent, child)=>{
    while(child !== null){
        if (child.parent === parent) return true;
        child = /** @type {AbstractType<any>} */ child.parent._item;
    }
    return false;
};
/**
 * Convenient helper to log type information.
 *
 * Do not use in productive systems as the output can be immense!
 *
 * @param {AbstractType<any>} type
 */ const $a852d2d5bb3d1ec6$export$e9068ad704ba2f79 = (type)=>{
    const res = [];
    let n = type._start;
    while(n){
        res.push(n);
        n = n.right;
    }
    console.log('Children: ', res);
    console.log('Children content: ', res.filter((m)=>!m.deleted).map((m)=>m.content));
};
class $a852d2d5bb3d1ec6$export$b9e8b5fa1162ca4e {
    /**
   * @param {Doc} doc
   * @param {YMap<any>} [storeType]
   */ constructor(doc, storeType = doc.getMap('users')){
        /**
     * @type {Map<string,DeleteSet>}
     */ const dss = new Map();
        this.yusers = storeType;
        this.doc = doc;
        /**
     * Maps from clientid to userDescription
     *
     * @type {Map<number,string>}
     */ this.clients = new Map();
        this.dss = dss;
        /**
     * @param {YMap<any>} user
     * @param {string} userDescription
     */ const initUser = (user, userDescription)=>{
            /**
       * @type {YArray<Uint8Array>}
       */ const ds = user.get('ds');
            const ids = user.get('ids');
            const addClientId = /** @param {number} clientid */ (clientid)=>this.clients.set(clientid, userDescription);
            ds.observe(/** @param {YArrayEvent<any>} event */ (event)=>{
                event.changes.added.forEach((item)=>{
                    item.content.getContent().forEach((encodedDs)=>{
                        if (encodedDs instanceof Uint8Array) this.dss.set(userDescription, $a852d2d5bb3d1ec6$export$b7826cadad53901e([
                            this.dss.get(userDescription) || $a852d2d5bb3d1ec6$export$8cbac0d946238699(),
                            $a852d2d5bb3d1ec6$var$readDeleteSet(new $a852d2d5bb3d1ec6$var$DSDecoderV1($9QtgA.createDecoder(encodedDs)))
                        ]));
                    });
                });
            });
            this.dss.set(userDescription, $a852d2d5bb3d1ec6$export$b7826cadad53901e(ds.map((encodedDs)=>$a852d2d5bb3d1ec6$var$readDeleteSet(new $a852d2d5bb3d1ec6$var$DSDecoderV1($9QtgA.createDecoder(encodedDs))))));
            ids.observe(/** @param {YArrayEvent<any>} event */ (event)=>event.changes.added.forEach((item)=>item.content.getContent().forEach(addClientId)));
            ids.forEach(addClientId);
        };
        // observe users
        storeType.observe((event)=>{
            event.keysChanged.forEach((userDescription)=>initUser(storeType.get(userDescription), userDescription));
        });
        // add intial data
        storeType.forEach(initUser);
    }
    /**
   * @param {Doc} doc
   * @param {number} clientid
   * @param {string} userDescription
   * @param {Object} conf
   * @param {function(Transaction, DeleteSet):boolean} [conf.filter]
   */ setUserMapping(doc, clientid, userDescription, { filter: filter = ()=>true } = {}) {
        const users = this.yusers;
        let user = users.get(userDescription);
        if (!user) {
            user = new $a852d2d5bb3d1ec6$export$a5c7b93649eaf8f8();
            user.set('ids', new $a852d2d5bb3d1ec6$export$c4be6576ca6fe4aa());
            user.set('ds', new $a852d2d5bb3d1ec6$export$c4be6576ca6fe4aa());
            users.set(userDescription, user);
        }
        user.get('ids').push([
            clientid
        ]);
        users.observe((_event)=>{
            setTimeout(()=>{
                const userOverwrite = users.get(userDescription);
                if (userOverwrite !== user) {
                    // user was overwritten, port all data over to the next user object
                    // @todo Experiment with Y.Sets here
                    user = userOverwrite;
                    // @todo iterate over old type
                    this.clients.forEach((_userDescription, clientid)=>{
                        if (userDescription === _userDescription) user.get('ids').push([
                            clientid
                        ]);
                    });
                    const encoder = new $a852d2d5bb3d1ec6$var$DSEncoderV1();
                    const ds = this.dss.get(userDescription);
                    if (ds) {
                        $a852d2d5bb3d1ec6$var$writeDeleteSet(encoder, ds);
                        user.get('ds').push([
                            encoder.toUint8Array()
                        ]);
                    }
                }
            }, 0);
        });
        doc.on('afterTransaction', /** @param {Transaction} transaction */ (transaction)=>{
            setTimeout(()=>{
                const yds = user.get('ds');
                const ds = transaction.deleteSet;
                if (transaction.local && ds.clients.size > 0 && filter(transaction, ds)) {
                    const encoder = new $a852d2d5bb3d1ec6$var$DSEncoderV1();
                    $a852d2d5bb3d1ec6$var$writeDeleteSet(encoder, ds);
                    yds.push([
                        encoder.toUint8Array()
                    ]);
                }
            });
        });
    }
    /**
   * @param {number} clientid
   * @return {any}
   */ getUserByClientId(clientid) {
        return this.clients.get(clientid) || null;
    }
    /**
   * @param {ID} id
   * @return {string | null}
   */ getUserByDeletedId(id) {
        for (const [userDescription, ds] of this.dss.entries()){
            if ($a852d2d5bb3d1ec6$export$dcb04af092e44fde(ds, id)) return userDescription;
        }
        return null;
    }
}
/**
 * A relative position is based on the Yjs model and is not affected by document changes.
 * E.g. If you place a relative position before a certain character, it will always point to this character.
 * If you place a relative position at the end of a type, it will always point to the end of the type.
 *
 * A numeric position is often unsuited for user selections, because it does not change when content is inserted
 * before or after.
 *
 * ```Insert(0, 'x')('a|bc') = 'xa|bc'``` Where | is the relative position.
 *
 * One of the properties must be defined.
 *
 * @example
 *   // Current cursor position is at position 10
 *   const relativePosition = createRelativePositionFromIndex(yText, 10)
 *   // modify yText
 *   yText.insert(0, 'abc')
 *   yText.delete(3, 10)
 *   // Compute the cursor position
 *   const absolutePosition = createAbsolutePositionFromRelativePosition(y, relativePosition)
 *   absolutePosition.type === yText // => true
 *   console.log('cursor location is ' + absolutePosition.index) // => cursor location is 3
 *
 */ class $a852d2d5bb3d1ec6$export$da21a415c5907662 {
    /**
   * @param {ID|null} type
   * @param {string|null} tname
   * @param {ID|null} item
   * @param {number} assoc
   */ constructor(type, tname, item, assoc = 0){
        /**
     * @type {ID|null}
     */ this.type = type;
        /**
     * @type {string|null}
     */ this.tname = tname;
        /**
     * @type {ID | null}
     */ this.item = item;
        /**
     * A relative position is associated to a specific character. By default
     * assoc >= 0, the relative position is associated to the character
     * after the meant position.
     * I.e. position 1 in 'ab' is associated to character 'b'.
     *
     * If assoc < 0, then the relative position is associated to the caharacter
     * before the meant position.
     *
     * @type {number}
     */ this.assoc = assoc;
    }
}
/**
 * @param {RelativePosition} rpos
 * @return {any}
 */ const $a852d2d5bb3d1ec6$export$a783b081767a452e = (rpos)=>{
    const json = {};
    if (rpos.type) json.type = rpos.type;
    if (rpos.tname) json.tname = rpos.tname;
    if (rpos.item) json.item = rpos.item;
    if (rpos.assoc != null) json.assoc = rpos.assoc;
    return json;
};
/**
 * @param {any} json
 * @return {RelativePosition}
 *
 * @function
 */ const $a852d2d5bb3d1ec6$export$ddad8a1b8f7475d8 = (json)=>new $a852d2d5bb3d1ec6$export$da21a415c5907662(json.type == null ? null : $a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(json.type.client, json.type.clock), json.tname ?? null, json.item == null ? null : $a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(json.item.client, json.item.clock), json.assoc == null ? 0 : json.assoc);
class $a852d2d5bb3d1ec6$export$64c95a3fb7344864 {
    /**
   * @param {AbstractType<any>} type
   * @param {number} index
   * @param {number} [assoc]
   */ constructor(type, index, assoc = 0){
        /**
     * @type {AbstractType<any>}
     */ this.type = type;
        /**
     * @type {number}
     */ this.index = index;
        this.assoc = assoc;
    }
}
/**
 * @param {AbstractType<any>} type
 * @param {number} index
 * @param {number} [assoc]
 *
 * @function
 */ const $a852d2d5bb3d1ec6$var$createAbsolutePosition = (type, index, assoc = 0)=>new $a852d2d5bb3d1ec6$export$64c95a3fb7344864(type, index, assoc);
/**
 * @param {AbstractType<any>} type
 * @param {ID|null} item
 * @param {number} [assoc]
 *
 * @function
 */ const $a852d2d5bb3d1ec6$var$createRelativePosition = (type, item, assoc)=>{
    let typeid = null;
    let tname = null;
    if (type._item === null) tname = $a852d2d5bb3d1ec6$export$e726a40920d54663(type);
    else typeid = $a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(type._item.id.client, type._item.id.clock);
    return new $a852d2d5bb3d1ec6$export$da21a415c5907662(typeid, tname, item, assoc);
};
/**
 * Create a relativePosition based on a absolute position.
 *
 * @param {AbstractType<any>} type The base type (e.g. YText or YArray).
 * @param {number} index The absolute position.
 * @param {number} [assoc]
 * @return {RelativePosition}
 *
 * @function
 */ const $a852d2d5bb3d1ec6$export$197e7d99e3857e88 = (type, index, assoc = 0)=>{
    let t = type._start;
    if (assoc < 0) {
        // associated to the left character or the beginning of a type, increment index if possible.
        if (index === 0) return $a852d2d5bb3d1ec6$var$createRelativePosition(type, null, assoc);
        index--;
    }
    while(t !== null){
        if (!t.deleted && t.countable) {
            if (t.length > index) // case 1: found position somewhere in the linked list
            return $a852d2d5bb3d1ec6$var$createRelativePosition(type, $a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(t.id.client, t.id.clock + index), assoc);
            index -= t.length;
        }
        if (t.right === null && assoc < 0) // left-associated position, return last available id
        return $a852d2d5bb3d1ec6$var$createRelativePosition(type, t.lastId, assoc);
        t = t.right;
    }
    return $a852d2d5bb3d1ec6$var$createRelativePosition(type, null, assoc);
};
/**
 * @param {encoding.Encoder} encoder
 * @param {RelativePosition} rpos
 *
 * @function
 */ const $a852d2d5bb3d1ec6$var$writeRelativePosition = (encoder, rpos)=>{
    const { type: type, tname: tname, item: item, assoc: assoc } = rpos;
    if (item !== null) {
        $kRma6.writeVarUint(encoder, 0);
        $a852d2d5bb3d1ec6$var$writeID(encoder, item);
    } else if (tname !== null) {
        // case 2: found position at the end of the list and type is stored in y.share
        $kRma6.writeUint8(encoder, 1);
        $kRma6.writeVarString(encoder, tname);
    } else if (type !== null) {
        // case 3: found position at the end of the list and type is attached to an item
        $kRma6.writeUint8(encoder, 2);
        $a852d2d5bb3d1ec6$var$writeID(encoder, type);
    } else throw $gFLjS.unexpectedCase();
    $kRma6.writeVarInt(encoder, assoc);
    return encoder;
};
/**
 * @param {RelativePosition} rpos
 * @return {Uint8Array}
 */ const $a852d2d5bb3d1ec6$export$c5c95ef724203575 = (rpos)=>{
    const encoder = $kRma6.createEncoder();
    $a852d2d5bb3d1ec6$var$writeRelativePosition(encoder, rpos);
    return $kRma6.toUint8Array(encoder);
};
/**
 * @param {decoding.Decoder} decoder
 * @return {RelativePosition}
 *
 * @function
 */ const $a852d2d5bb3d1ec6$var$readRelativePosition = (decoder)=>{
    let type = null;
    let tname = null;
    let itemID = null;
    switch($9QtgA.readVarUint(decoder)){
        case 0:
            // case 1: found position somewhere in the linked list
            itemID = $a852d2d5bb3d1ec6$var$readID(decoder);
            break;
        case 1:
            // case 2: found position at the end of the list and type is stored in y.share
            tname = $9QtgA.readVarString(decoder);
            break;
        case 2:
            // case 3: found position at the end of the list and type is attached to an item
            type = $a852d2d5bb3d1ec6$var$readID(decoder);
    }
    const assoc = $9QtgA.hasContent(decoder) ? $9QtgA.readVarInt(decoder) : 0;
    return new $a852d2d5bb3d1ec6$export$da21a415c5907662(type, tname, itemID, assoc);
};
/**
 * @param {Uint8Array} uint8Array
 * @return {RelativePosition}
 */ const $a852d2d5bb3d1ec6$export$58a46cebc90e7851 = (uint8Array)=>$a852d2d5bb3d1ec6$var$readRelativePosition($9QtgA.createDecoder(uint8Array));
/**
 * @param {StructStore} store
 * @param {ID} id
 */ const $a852d2d5bb3d1ec6$var$getItemWithOffset = (store, id)=>{
    const item = $a852d2d5bb3d1ec6$export$f92dfeb71e9bb569(store, id);
    const diff = id.clock - item.id.clock;
    return {
        item: item,
        diff: diff
    };
};
/**
 * Transform a relative position to an absolute position.
 *
 * If you want to share the relative position with other users, you should set
 * `followUndoneDeletions` to false to get consistent results across all clients.
 *
 * When calculating the absolute position, we try to follow the "undone deletions". This yields
 * better results for the user who performed undo. However, only the user who performed the undo
 * will get the better results, the other users don't know which operations recreated a deleted
 * range of content. There is more information in this ticket: https://github.com/yjs/yjs/issues/638
 *
 * @param {RelativePosition} rpos
 * @param {Doc} doc
 * @param {boolean} followUndoneDeletions - whether to follow undone deletions - see https://github.com/yjs/yjs/issues/638
 * @return {AbsolutePosition|null}
 *
 * @function
 */ const $a852d2d5bb3d1ec6$export$8fc3152f62fb7ed1 = (rpos, doc, followUndoneDeletions = true)=>{
    const store = doc.store;
    const rightID = rpos.item;
    const typeID = rpos.type;
    const tname = rpos.tname;
    const assoc = rpos.assoc;
    let type = null;
    let index = 0;
    if (rightID !== null) {
        if ($a852d2d5bb3d1ec6$export$50fdfeece43146fd(store, rightID.client) <= rightID.clock) return null;
        const res = followUndoneDeletions ? $a852d2d5bb3d1ec6$var$followRedone(store, rightID) : $a852d2d5bb3d1ec6$var$getItemWithOffset(store, rightID);
        const right = res.item;
        if (!(right instanceof $a852d2d5bb3d1ec6$export$6d08773d2e66f8f2)) return null;
        type = /** @type {AbstractType<any>} */ right.parent;
        if (type._item === null || !type._item.deleted) {
            index = right.deleted || !right.countable ? 0 : res.diff + (assoc >= 0 ? 0 : 1); // adjust position based on left association if necessary
            let n = right.left;
            while(n !== null){
                if (!n.deleted && n.countable) index += n.length;
                n = n.left;
            }
        }
    } else {
        if (tname !== null) type = doc.get(tname);
        else if (typeID !== null) {
            if ($a852d2d5bb3d1ec6$export$50fdfeece43146fd(store, typeID.client) <= typeID.clock) // type does not exist yet
            return null;
            const { item: item } = followUndoneDeletions ? $a852d2d5bb3d1ec6$var$followRedone(store, typeID) : {
                item: $a852d2d5bb3d1ec6$export$f92dfeb71e9bb569(store, typeID)
            };
            if (item instanceof $a852d2d5bb3d1ec6$export$6d08773d2e66f8f2 && item.content instanceof $a852d2d5bb3d1ec6$export$e2e108cbe2e4f865) type = item.content.type;
            else // struct is garbage collected
            return null;
        } else throw $gFLjS.unexpectedCase();
        if (assoc >= 0) index = type._length;
        else index = 0;
    }
    return $a852d2d5bb3d1ec6$var$createAbsolutePosition(type, index, rpos.assoc);
};
/**
 * @param {RelativePosition|null} a
 * @param {RelativePosition|null} b
 * @return {boolean}
 *
 * @function
 */ const $a852d2d5bb3d1ec6$export$fc8bd253c948b475 = (a, b)=>a === b || a !== null && b !== null && a.tname === b.tname && $a852d2d5bb3d1ec6$export$c0af976e7e459c02(a.item, b.item) && $a852d2d5bb3d1ec6$export$c0af976e7e459c02(a.type, b.type) && a.assoc === b.assoc;
class $a852d2d5bb3d1ec6$export$c963130a5525248f {
    /**
   * @param {DeleteSet} ds
   * @param {Map<number,number>} sv state map
   */ constructor(ds, sv){
        /**
     * @type {DeleteSet}
     */ this.ds = ds;
        /**
     * State Map
     * @type {Map<number,number>}
     */ this.sv = sv;
    }
}
/**
 * @param {Snapshot} snap1
 * @param {Snapshot} snap2
 * @return {boolean}
 */ const $a852d2d5bb3d1ec6$export$742742a0f55b273d = (snap1, snap2)=>{
    const ds1 = snap1.ds.clients;
    const ds2 = snap2.ds.clients;
    const sv1 = snap1.sv;
    const sv2 = snap2.sv;
    if (sv1.size !== sv2.size || ds1.size !== ds2.size) return false;
    for (const [key, value] of sv1.entries()){
        if (sv2.get(key) !== value) return false;
    }
    for (const [client, dsitems1] of ds1.entries()){
        const dsitems2 = ds2.get(client) || [];
        if (dsitems1.length !== dsitems2.length) return false;
        for(let i = 0; i < dsitems1.length; i++){
            const dsitem1 = dsitems1[i];
            const dsitem2 = dsitems2[i];
            if (dsitem1.clock !== dsitem2.clock || dsitem1.len !== dsitem2.len) return false;
        }
    }
    return true;
};
/**
 * @param {Snapshot} snapshot
 * @param {DSEncoderV1 | DSEncoderV2} [encoder]
 * @return {Uint8Array}
 */ const $a852d2d5bb3d1ec6$export$b946cadc55f8e512 = (snapshot, encoder = new $a852d2d5bb3d1ec6$var$DSEncoderV2())=>{
    $a852d2d5bb3d1ec6$var$writeDeleteSet(encoder, snapshot.ds);
    $a852d2d5bb3d1ec6$var$writeStateVector(encoder, snapshot.sv);
    return encoder.toUint8Array();
};
/**
 * @param {Snapshot} snapshot
 * @return {Uint8Array}
 */ const $a852d2d5bb3d1ec6$export$a6d29989648e995 = (snapshot)=>$a852d2d5bb3d1ec6$export$b946cadc55f8e512(snapshot, new $a852d2d5bb3d1ec6$var$DSEncoderV1());
/**
 * @param {Uint8Array} buf
 * @param {DSDecoderV1 | DSDecoderV2} [decoder]
 * @return {Snapshot}
 */ const $a852d2d5bb3d1ec6$export$b0049fa299f4f58e = (buf, decoder = new $a852d2d5bb3d1ec6$var$DSDecoderV2($9QtgA.createDecoder(buf)))=>{
    return new $a852d2d5bb3d1ec6$export$c963130a5525248f($a852d2d5bb3d1ec6$var$readDeleteSet(decoder), $a852d2d5bb3d1ec6$var$readStateVector(decoder));
};
/**
 * @param {Uint8Array} buf
 * @return {Snapshot}
 */ const $a852d2d5bb3d1ec6$export$5c696daccf32bd2e = (buf)=>$a852d2d5bb3d1ec6$export$b0049fa299f4f58e(buf, new $a852d2d5bb3d1ec6$var$DSDecoderV1($9QtgA.createDecoder(buf)));
/**
 * @param {DeleteSet} ds
 * @param {Map<number,number>} sm
 * @return {Snapshot}
 */ const $a852d2d5bb3d1ec6$export$548fae0445f878fd = (ds, sm)=>new $a852d2d5bb3d1ec6$export$c963130a5525248f(ds, sm);
const $a852d2d5bb3d1ec6$export$d4568a81dd107a34 = $a852d2d5bb3d1ec6$export$548fae0445f878fd($a852d2d5bb3d1ec6$export$8cbac0d946238699(), new Map());
/**
 * @param {Doc} doc
 * @return {Snapshot}
 */ const $a852d2d5bb3d1ec6$export$b8801ea43165ed7d = (doc)=>$a852d2d5bb3d1ec6$export$548fae0445f878fd($a852d2d5bb3d1ec6$export$8450d668bec558e2(doc.store), $a852d2d5bb3d1ec6$var$getStateVector(doc.store));
/**
 * @param {Item} item
 * @param {Snapshot|undefined} snapshot
 *
 * @protected
 * @function
 */ const $a852d2d5bb3d1ec6$var$isVisible = (item, snapshot)=>snapshot === undefined ? !item.deleted : snapshot.sv.has(item.id.client) && (snapshot.sv.get(item.id.client) || 0) > item.id.clock && !$a852d2d5bb3d1ec6$export$dcb04af092e44fde(snapshot.ds, item.id);
/**
 * @param {Transaction} transaction
 * @param {Snapshot} snapshot
 */ const $a852d2d5bb3d1ec6$var$splitSnapshotAffectedStructs = (transaction, snapshot)=>{
    const meta = $d1VR8.setIfUndefined(transaction.meta, $a852d2d5bb3d1ec6$var$splitSnapshotAffectedStructs, $9IXCW.create);
    const store = transaction.doc.store;
    // check if we already split for this snapshot
    if (!meta.has(snapshot)) {
        snapshot.sv.forEach((clock, client)=>{
            if (clock < $a852d2d5bb3d1ec6$export$50fdfeece43146fd(store, client)) $a852d2d5bb3d1ec6$var$getItemCleanStart(transaction, $a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(client, clock));
        });
        $a852d2d5bb3d1ec6$export$8afefebbaf4e4c78(transaction, snapshot.ds, (_item)=>{});
        meta.add(snapshot);
    }
};
/**
 * @example
 *  const ydoc = new Y.Doc({ gc: false })
 *  ydoc.getText().insert(0, 'world!')
 *  const snapshot = Y.snapshot(ydoc)
 *  ydoc.getText().insert(0, 'hello ')
 *  const restored = Y.createDocFromSnapshot(ydoc, snapshot)
 *  assert(restored.getText().toString() === 'world!')
 *
 * @param {Doc} originDoc
 * @param {Snapshot} snapshot
 * @param {Doc} [newDoc] Optionally, you may define the Yjs document that receives the data from originDoc
 * @return {Doc}
 */ const $a852d2d5bb3d1ec6$export$5be4ae1e1e56a014 = (originDoc, snapshot, newDoc = new $a852d2d5bb3d1ec6$export$bceacc74c2212615())=>{
    if (originDoc.gc) // we should not try to restore a GC-ed document, because some of the restored items might have their content deleted
    throw new Error('Garbage-collection must be disabled in `originDoc`!');
    const { sv: sv, ds: ds } = snapshot;
    const encoder = new $a852d2d5bb3d1ec6$export$30c99e08943e1c2();
    originDoc.transact((transaction)=>{
        let size = 0;
        sv.forEach((clock)=>{
            if (clock > 0) size++;
        });
        $kRma6.writeVarUint(encoder.restEncoder, size);
        // splitting the structs before writing them to the encoder
        for (const [client, clock] of sv){
            if (clock === 0) continue;
            if (clock < $a852d2d5bb3d1ec6$export$50fdfeece43146fd(originDoc.store, client)) $a852d2d5bb3d1ec6$var$getItemCleanStart(transaction, $a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(client, clock));
            const structs = originDoc.store.clients.get(client) || [];
            const lastStructIndex = $a852d2d5bb3d1ec6$export$5f8f02523cf47b58(structs, clock - 1);
            // write # encoded structs
            $kRma6.writeVarUint(encoder.restEncoder, lastStructIndex + 1);
            encoder.writeClient(client);
            // first clock written is 0
            $kRma6.writeVarUint(encoder.restEncoder, 0);
            for(let i = 0; i <= lastStructIndex; i++)structs[i].write(encoder, 0);
        }
        $a852d2d5bb3d1ec6$var$writeDeleteSet(encoder, ds);
    });
    $a852d2d5bb3d1ec6$export$acc3b0324aabf1b6(newDoc, encoder.toUint8Array(), 'snapshot');
    return newDoc;
};
/**
 * @param {Snapshot} snapshot
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} [YDecoder]
 */ const $a852d2d5bb3d1ec6$var$snapshotContainsUpdateV2 = (snapshot, update, YDecoder = $a852d2d5bb3d1ec6$export$1c932452355c5571)=>{
    const updateDecoder = new YDecoder($9QtgA.createDecoder(update));
    const lazyDecoder = new $a852d2d5bb3d1ec6$var$LazyStructReader(updateDecoder, false);
    for(let curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next()){
        if ((snapshot.sv.get(curr.id.client) || 0) < curr.id.clock + curr.length) return false;
    }
    const mergedDS = $a852d2d5bb3d1ec6$export$b7826cadad53901e([
        snapshot.ds,
        $a852d2d5bb3d1ec6$var$readDeleteSet(updateDecoder)
    ]);
    return $a852d2d5bb3d1ec6$export$9697b72c46fd3a5d(snapshot.ds, mergedDS);
};
/**
 * @param {Snapshot} snapshot
 * @param {Uint8Array} update
 */ const $a852d2d5bb3d1ec6$export$f938135bed5d8db7 = (snapshot, update)=>$a852d2d5bb3d1ec6$var$snapshotContainsUpdateV2(snapshot, update, $a852d2d5bb3d1ec6$export$1aa46d9818b5d1ec);
class $a852d2d5bb3d1ec6$var$StructStore {
    constructor(){
        /**
     * @type {Map<number,Array<GC|Item>>}
     */ this.clients = new Map();
        /**
     * @type {null | { missing: Map<number, number>, update: Uint8Array }}
     */ this.pendingStructs = null;
        /**
     * @type {null | Uint8Array}
     */ this.pendingDs = null;
    }
}
/**
 * Return the states as a Map<client,clock>.
 * Note that clock refers to the next expected clock id.
 *
 * @param {StructStore} store
 * @return {Map<number,number>}
 *
 * @public
 * @function
 */ const $a852d2d5bb3d1ec6$var$getStateVector = (store)=>{
    const sm = new Map();
    store.clients.forEach((structs, client)=>{
        const struct = structs[structs.length - 1];
        sm.set(client, struct.id.clock + struct.length);
    });
    return sm;
};
/**
 * @param {StructStore} store
 * @param {number} client
 * @return {number}
 *
 * @public
 * @function
 */ const $a852d2d5bb3d1ec6$export$50fdfeece43146fd = (store, client)=>{
    const structs = store.clients.get(client);
    if (structs === undefined) return 0;
    const lastStruct = structs[structs.length - 1];
    return lastStruct.id.clock + lastStruct.length;
};
/**
 * @param {StructStore} store
 * @param {GC|Item} struct
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$addStruct = (store, struct)=>{
    let structs = store.clients.get(struct.id.client);
    if (structs === undefined) {
        structs = [];
        store.clients.set(struct.id.client, structs);
    } else {
        const lastStruct = structs[structs.length - 1];
        if (lastStruct.id.clock + lastStruct.length !== struct.id.clock) throw $gFLjS.unexpectedCase();
    }
    structs.push(struct);
};
/**
 * Perform a binary search on a sorted array
 * @param {Array<Item|GC>} structs
 * @param {number} clock
 * @return {number}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$export$5f8f02523cf47b58 = (structs, clock)=>{
    let left = 0;
    let right = structs.length - 1;
    let mid = structs[right];
    let midclock = mid.id.clock;
    if (midclock === clock) return right;
    // @todo does it even make sense to pivot the search?
    // If a good split misses, it might actually increase the time to find the correct item.
    // Currently, the only advantage is that search with pivoting might find the item on the first try.
    let midindex = $bJmyZ.floor(clock / (midclock + mid.length - 1) * right); // pivoting the search
    while(left <= right){
        mid = structs[midindex];
        midclock = mid.id.clock;
        if (midclock <= clock) {
            if (clock < midclock + mid.length) return midindex;
            left = midindex + 1;
        } else right = midindex - 1;
        midindex = $bJmyZ.floor((left + right) / 2);
    }
    // Always check state before looking for a struct in StructStore
    // Therefore the case of not finding a struct is unexpected
    throw $gFLjS.unexpectedCase();
};
/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 *
 * @param {StructStore} store
 * @param {ID} id
 * @return {GC|Item}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$find = (store, id)=>{
    /**
   * @type {Array<GC|Item>}
   */ // @ts-ignore
    const structs = store.clients.get(id.client);
    return structs[$a852d2d5bb3d1ec6$export$5f8f02523cf47b58(structs, id.clock)];
};
/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$export$f92dfeb71e9bb569 = /** @type {function(StructStore,ID):Item} */ $a852d2d5bb3d1ec6$var$find;
/**
 * @param {Transaction} transaction
 * @param {Array<Item|GC>} structs
 * @param {number} clock
 */ const $a852d2d5bb3d1ec6$var$findIndexCleanStart = (transaction, structs, clock)=>{
    const index = $a852d2d5bb3d1ec6$export$5f8f02523cf47b58(structs, clock);
    const struct = structs[index];
    if (struct.id.clock < clock && struct instanceof $a852d2d5bb3d1ec6$export$6d08773d2e66f8f2) {
        structs.splice(index + 1, 0, $a852d2d5bb3d1ec6$var$splitItem(transaction, struct, clock - struct.id.clock));
        return index + 1;
    }
    return index;
};
/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 *
 * @param {Transaction} transaction
 * @param {ID} id
 * @return {Item}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$getItemCleanStart = (transaction, id)=>{
    const structs = /** @type {Array<Item>} */ transaction.doc.store.clients.get(id.client);
    return structs[$a852d2d5bb3d1ec6$var$findIndexCleanStart(transaction, structs, id.clock)];
};
/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 *
 * @param {Transaction} transaction
 * @param {StructStore} store
 * @param {ID} id
 * @return {Item}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$getItemCleanEnd = (transaction, store, id)=>{
    /**
   * @type {Array<Item>}
   */ // @ts-ignore
    const structs = store.clients.get(id.client);
    const index = $a852d2d5bb3d1ec6$export$5f8f02523cf47b58(structs, id.clock);
    const struct = structs[index];
    if (id.clock !== struct.id.clock + struct.length - 1 && struct.constructor !== $a852d2d5bb3d1ec6$export$12d259ff017e6b58) structs.splice(index + 1, 0, $a852d2d5bb3d1ec6$var$splitItem(transaction, struct, id.clock - struct.id.clock + 1));
    return struct;
};
/**
 * Replace `item` with `newitem` in store
 * @param {StructStore} store
 * @param {GC|Item} struct
 * @param {GC|Item} newStruct
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$replaceStruct = (store, struct, newStruct)=>{
    const structs = /** @type {Array<GC|Item>} */ store.clients.get(struct.id.client);
    structs[$a852d2d5bb3d1ec6$export$5f8f02523cf47b58(structs, struct.id.clock)] = newStruct;
};
/**
 * Iterate over a range of structs
 *
 * @param {Transaction} transaction
 * @param {Array<Item|GC>} structs
 * @param {number} clockStart Inclusive start
 * @param {number} len
 * @param {function(GC|Item):void} f
 *
 * @function
 */ const $a852d2d5bb3d1ec6$var$iterateStructs = (transaction, structs, clockStart, len, f)=>{
    if (len === 0) return;
    const clockEnd = clockStart + len;
    let index = $a852d2d5bb3d1ec6$var$findIndexCleanStart(transaction, structs, clockStart);
    let struct;
    do {
        struct = structs[index++];
        if (clockEnd < struct.id.clock + struct.length) $a852d2d5bb3d1ec6$var$findIndexCleanStart(transaction, structs, clockEnd);
        f(struct);
    }while (index < structs.length && structs[index].id.clock < clockEnd);
};
/**
 * A transaction is created for every change on the Yjs model. It is possible
 * to bundle changes on the Yjs model in a single transaction to
 * minimize the number on messages sent and the number of observer calls.
 * If possible the user of this library should bundle as many changes as
 * possible. Here is an example to illustrate the advantages of bundling:
 *
 * @example
 * const ydoc = new Y.Doc()
 * const map = ydoc.getMap('map')
 * // Log content when change is triggered
 * map.observe(() => {
 *   console.log('change triggered')
 * })
 * // Each change on the map type triggers a log message:
 * map.set('a', 0) // => "change triggered"
 * map.set('b', 0) // => "change triggered"
 * // When put in a transaction, it will trigger the log after the transaction:
 * ydoc.transact(() => {
 *   map.set('a', 1)
 *   map.set('b', 1)
 * }) // => "change triggered"
 *
 * @public
 */ class $a852d2d5bb3d1ec6$export$febc5573c75cefb0 {
    /**
   * @param {Doc} doc
   * @param {any} origin
   * @param {boolean} local
   */ constructor(doc, origin, local){
        /**
     * The Yjs instance.
     * @type {Doc}
     */ this.doc = doc;
        /**
     * Describes the set of deleted items by ids
     * @type {DeleteSet}
     */ this.deleteSet = new $a852d2d5bb3d1ec6$var$DeleteSet();
        /**
     * Holds the state before the transaction started.
     * @type {Map<Number,Number>}
     */ this.beforeState = $a852d2d5bb3d1ec6$var$getStateVector(doc.store);
        /**
     * Holds the state after the transaction.
     * @type {Map<Number,Number>}
     */ this.afterState = new Map();
        /**
     * All types that were directly modified (property added or child
     * inserted/deleted). New types are not included in this Set.
     * Maps from type to parentSubs (`item.parentSub = null` for YArray)
     * @type {Map<AbstractType<YEvent<any>>,Set<String|null>>}
     */ this.changed = new Map();
        /**
     * Stores the events for the types that observe also child elements.
     * It is mainly used by `observeDeep`.
     * @type {Map<AbstractType<YEvent<any>>,Array<YEvent<any>>>}
     */ this.changedParentTypes = new Map();
        /**
     * @type {Array<AbstractStruct>}
     */ this._mergeStructs = [];
        /**
     * @type {any}
     */ this.origin = origin;
        /**
     * Stores meta information on the transaction
     * @type {Map<any,any>}
     */ this.meta = new Map();
        /**
     * Whether this change originates from this doc.
     * @type {boolean}
     */ this.local = local;
        /**
     * @type {Set<Doc>}
     */ this.subdocsAdded = new Set();
        /**
     * @type {Set<Doc>}
     */ this.subdocsRemoved = new Set();
        /**
     * @type {Set<Doc>}
     */ this.subdocsLoaded = new Set();
        /**
     * @type {boolean}
     */ this._needFormattingCleanup = false;
    }
}
/**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Transaction} transaction
 * @return {boolean} Whether data was written.
 */ const $a852d2d5bb3d1ec6$var$writeUpdateMessageFromTransaction = (encoder, transaction)=>{
    if (transaction.deleteSet.clients.size === 0 && !$d1VR8.any(transaction.afterState, (clock, client)=>transaction.beforeState.get(client) !== clock)) return false;
    $a852d2d5bb3d1ec6$var$sortAndMergeDeleteSet(transaction.deleteSet);
    $a852d2d5bb3d1ec6$var$writeStructsFromTransaction(encoder, transaction);
    $a852d2d5bb3d1ec6$var$writeDeleteSet(encoder, transaction.deleteSet);
    return true;
};
/**
 * If `type.parent` was added in current transaction, `type` technically
 * did not change, it was just added and we should not fire events for `type`.
 *
 * @param {Transaction} transaction
 * @param {AbstractType<YEvent<any>>} type
 * @param {string|null} parentSub
 */ const $a852d2d5bb3d1ec6$var$addChangedTypeToTransaction = (transaction, type, parentSub)=>{
    const item = type._item;
    if (item === null || item.id.clock < (transaction.beforeState.get(item.id.client) || 0) && !item.deleted) $d1VR8.setIfUndefined(transaction.changed, type, $9IXCW.create).add(parentSub);
};
/**
 * @param {Array<AbstractStruct>} structs
 * @param {number} pos
 * @return {number} # of merged structs
 */ const $a852d2d5bb3d1ec6$var$tryToMergeWithLefts = (structs, pos)=>{
    let right = structs[pos];
    let left = structs[pos - 1];
    let i = pos;
    for(; i > 0; right = left, left = structs[--i - 1]){
        if (left.deleted === right.deleted && left.constructor === right.constructor) {
            if (left.mergeWith(right)) {
                if (right instanceof $a852d2d5bb3d1ec6$export$6d08773d2e66f8f2 && right.parentSub !== null && /** @type {AbstractType<any>} */ right.parent._map.get(right.parentSub) === right) /** @type {AbstractType<any>} */ right.parent._map.set(right.parentSub, /** @type {Item} */ left);
                continue;
            }
        }
        break;
    }
    const merged = pos - i;
    if (merged) // remove all merged structs from the array
    structs.splice(pos + 1 - merged, merged);
    return merged;
};
/**
 * @param {DeleteSet} ds
 * @param {StructStore} store
 * @param {function(Item):boolean} gcFilter
 */ const $a852d2d5bb3d1ec6$var$tryGcDeleteSet = (ds, store, gcFilter)=>{
    for (const [client, deleteItems] of ds.clients.entries()){
        const structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
        for(let di = deleteItems.length - 1; di >= 0; di--){
            const deleteItem = deleteItems[di];
            const endDeleteItemClock = deleteItem.clock + deleteItem.len;
            for(let si = $a852d2d5bb3d1ec6$export$5f8f02523cf47b58(structs, deleteItem.clock), struct = structs[si]; si < structs.length && struct.id.clock < endDeleteItemClock; struct = structs[++si]){
                const struct = structs[si];
                if (deleteItem.clock + deleteItem.len <= struct.id.clock) break;
                if (struct instanceof $a852d2d5bb3d1ec6$export$6d08773d2e66f8f2 && struct.deleted && !struct.keep && gcFilter(struct)) struct.gc(store, false);
            }
        }
    }
};
/**
 * @param {DeleteSet} ds
 * @param {StructStore} store
 */ const $a852d2d5bb3d1ec6$var$tryMergeDeleteSet = (ds, store)=>{
    // try to merge deleted / gc'd items
    // merge from right to left for better efficiency and so we don't miss any merge targets
    ds.clients.forEach((deleteItems, client)=>{
        const structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
        for(let di = deleteItems.length - 1; di >= 0; di--){
            const deleteItem = deleteItems[di];
            // start with merging the item next to the last deleted item
            const mostRightIndexToCheck = $bJmyZ.min(structs.length - 1, 1 + $a852d2d5bb3d1ec6$export$5f8f02523cf47b58(structs, deleteItem.clock + deleteItem.len - 1));
            for(let si = mostRightIndexToCheck, struct = structs[si]; si > 0 && struct.id.clock >= deleteItem.clock; struct = structs[si])si -= 1 + $a852d2d5bb3d1ec6$var$tryToMergeWithLefts(structs, si);
        }
    });
};
/**
 * @param {DeleteSet} ds
 * @param {StructStore} store
 * @param {function(Item):boolean} gcFilter
 */ const $a852d2d5bb3d1ec6$export$c2e5de00fc43f658 = (ds, store, gcFilter)=>{
    $a852d2d5bb3d1ec6$var$tryGcDeleteSet(ds, store, gcFilter);
    $a852d2d5bb3d1ec6$var$tryMergeDeleteSet(ds, store);
};
/**
 * @param {Array<Transaction>} transactionCleanups
 * @param {number} i
 */ const $a852d2d5bb3d1ec6$var$cleanupTransactions = (transactionCleanups, i)=>{
    if (i < transactionCleanups.length) {
        const transaction = transactionCleanups[i];
        const doc = transaction.doc;
        const store = doc.store;
        const ds = transaction.deleteSet;
        const mergeStructs = transaction._mergeStructs;
        try {
            $a852d2d5bb3d1ec6$var$sortAndMergeDeleteSet(ds);
            transaction.afterState = $a852d2d5bb3d1ec6$var$getStateVector(transaction.doc.store);
            doc.emit('beforeObserverCalls', [
                transaction,
                doc
            ]);
            /**
       * An array of event callbacks.
       *
       * Each callback is called even if the other ones throw errors.
       *
       * @type {Array<function():void>}
       */ const fs = [];
            // observe events on changed types
            transaction.changed.forEach((subs, itemtype)=>fs.push(()=>{
                    if (itemtype._item === null || !itemtype._item.deleted) itemtype._callObserver(transaction, subs);
                }));
            fs.push(()=>{
                // deep observe events
                transaction.changedParentTypes.forEach((events, type)=>{
                    // We need to think about the possibility that the user transforms the
                    // Y.Doc in the event.
                    if (type._dEH.l.length > 0 && (type._item === null || !type._item.deleted)) {
                        events = events.filter((event)=>event.target._item === null || !event.target._item.deleted);
                        events.forEach((event)=>{
                            event.currentTarget = type;
                            // path is relative to the current target
                            event._path = null;
                        });
                        // sort events by path length so that top-level events are fired first.
                        events.sort((event1, event2)=>event1.path.length - event2.path.length);
                        // We don't need to check for events.length
                        // because we know it has at least one element
                        $a852d2d5bb3d1ec6$var$callEventHandlerListeners(type._dEH, events, transaction);
                    }
                });
            });
            fs.push(()=>doc.emit('afterTransaction', [
                    transaction,
                    doc
                ]));
            (0, $45hHO.callAll)(fs, []);
            if (transaction._needFormattingCleanup) $a852d2d5bb3d1ec6$var$cleanupYTextAfterTransaction(transaction);
        } finally{
            // Replace deleted items with ItemDeleted / GC.
            // This is where content is actually remove from the Yjs Doc.
            if (doc.gc) $a852d2d5bb3d1ec6$var$tryGcDeleteSet(ds, store, doc.gcFilter);
            $a852d2d5bb3d1ec6$var$tryMergeDeleteSet(ds, store);
            // on all affected store.clients props, try to merge
            transaction.afterState.forEach((clock, client)=>{
                const beforeClock = transaction.beforeState.get(client) || 0;
                if (beforeClock !== clock) {
                    const structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
                    // we iterate from right to left so we can safely remove entries
                    const firstChangePos = $bJmyZ.max($a852d2d5bb3d1ec6$export$5f8f02523cf47b58(structs, beforeClock), 1);
                    for(let i = structs.length - 1; i >= firstChangePos;)i -= 1 + $a852d2d5bb3d1ec6$var$tryToMergeWithLefts(structs, i);
                }
            });
            // try to merge mergeStructs
            // @todo: it makes more sense to transform mergeStructs to a DS, sort it, and merge from right to left
            //        but at the moment DS does not handle duplicates
            for(let i = mergeStructs.length - 1; i >= 0; i--){
                const { client: client, clock: clock } = mergeStructs[i].id;
                const structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
                const replacedStructPos = $a852d2d5bb3d1ec6$export$5f8f02523cf47b58(structs, clock);
                if (replacedStructPos + 1 < structs.length) {
                    if ($a852d2d5bb3d1ec6$var$tryToMergeWithLefts(structs, replacedStructPos + 1) > 1) continue; // no need to perform next check, both are already merged
                }
                if (replacedStructPos > 0) $a852d2d5bb3d1ec6$var$tryToMergeWithLefts(structs, replacedStructPos);
            }
            if (!transaction.local && transaction.afterState.get(doc.clientID) !== transaction.beforeState.get(doc.clientID)) {
                $giaim.print($7qZUp.ORANGE, $7qZUp.BOLD, '[yjs] ', $7qZUp.UNBOLD, $7qZUp.RED, 'Changed the client-id because another client seems to be using it.');
                doc.clientID = $a852d2d5bb3d1ec6$var$generateNewClientId();
            }
            // @todo Merge all the transactions into one and provide send the data as a single update message
            doc.emit('afterTransactionCleanup', [
                transaction,
                doc
            ]);
            if (doc._observers.has('update')) {
                const encoder = new $a852d2d5bb3d1ec6$export$99171b804d9c5b54();
                const hasContent = $a852d2d5bb3d1ec6$var$writeUpdateMessageFromTransaction(encoder, transaction);
                if (hasContent) doc.emit('update', [
                    encoder.toUint8Array(),
                    transaction.origin,
                    doc,
                    transaction
                ]);
            }
            if (doc._observers.has('updateV2')) {
                const encoder = new $a852d2d5bb3d1ec6$export$30c99e08943e1c2();
                const hasContent = $a852d2d5bb3d1ec6$var$writeUpdateMessageFromTransaction(encoder, transaction);
                if (hasContent) doc.emit('updateV2', [
                    encoder.toUint8Array(),
                    transaction.origin,
                    doc,
                    transaction
                ]);
            }
            const { subdocsAdded: subdocsAdded, subdocsLoaded: subdocsLoaded, subdocsRemoved: subdocsRemoved } = transaction;
            if (subdocsAdded.size > 0 || subdocsRemoved.size > 0 || subdocsLoaded.size > 0) {
                subdocsAdded.forEach((subdoc)=>{
                    subdoc.clientID = doc.clientID;
                    if (subdoc.collectionid == null) subdoc.collectionid = doc.collectionid;
                    doc.subdocs.add(subdoc);
                });
                subdocsRemoved.forEach((subdoc)=>doc.subdocs.delete(subdoc));
                doc.emit('subdocs', [
                    {
                        loaded: subdocsLoaded,
                        added: subdocsAdded,
                        removed: subdocsRemoved
                    },
                    doc,
                    transaction
                ]);
                subdocsRemoved.forEach((subdoc)=>subdoc.destroy());
            }
            if (transactionCleanups.length <= i + 1) {
                doc._transactionCleanups = [];
                doc.emit('afterAllTransactions', [
                    doc,
                    transactionCleanups
                ]);
            } else $a852d2d5bb3d1ec6$var$cleanupTransactions(transactionCleanups, i + 1);
        }
    }
};
/**
 * Implements the functionality of `y.transact(()=>{..})`
 *
 * @template T
 * @param {Doc} doc
 * @param {function(Transaction):T} f
 * @param {any} [origin=true]
 * @return {T}
 *
 * @function
 */ const $a852d2d5bb3d1ec6$export$dac1bad6146b2469 = (doc, f, origin = null, local = true)=>{
    const transactionCleanups = doc._transactionCleanups;
    let initialCall = false;
    /**
   * @type {any}
   */ let result = null;
    if (doc._transaction === null) {
        initialCall = true;
        doc._transaction = new $a852d2d5bb3d1ec6$export$febc5573c75cefb0(doc, origin, local);
        transactionCleanups.push(doc._transaction);
        if (transactionCleanups.length === 1) doc.emit('beforeAllTransactions', [
            doc
        ]);
        doc.emit('beforeTransaction', [
            doc._transaction,
            doc
        ]);
    }
    try {
        result = f(doc._transaction);
    } finally{
        if (initialCall) {
            const finishCleanup = doc._transaction === transactionCleanups[0];
            doc._transaction = null;
            if (finishCleanup) // The first transaction ended, now process observer calls.
            // Observer call may create new transactions for which we need to call the observers and do cleanup.
            // We don't want to nest these calls, so we execute these calls one after
            // another.
            // Also we need to ensure that all cleanups are called, even if the
            // observes throw errors.
            // This file is full of hacky try {} finally {} blocks to ensure that an
            // event can throw errors and also that the cleanup is called.
            $a852d2d5bb3d1ec6$var$cleanupTransactions(transactionCleanups, 0);
        }
    }
    return result;
};
class $a852d2d5bb3d1ec6$var$StackItem {
    /**
   * @param {DeleteSet} deletions
   * @param {DeleteSet} insertions
   */ constructor(deletions, insertions){
        this.insertions = insertions;
        this.deletions = deletions;
        /**
     * Use this to save and restore metadata like selection range
     */ this.meta = new Map();
    }
}
/**
 * @param {Transaction} tr
 * @param {UndoManager} um
 * @param {StackItem} stackItem
 */ const $a852d2d5bb3d1ec6$var$clearUndoManagerStackItem = (tr, um, stackItem)=>{
    $a852d2d5bb3d1ec6$export$8afefebbaf4e4c78(tr, stackItem.deletions, (item)=>{
        if (item instanceof $a852d2d5bb3d1ec6$export$6d08773d2e66f8f2 && um.scope.some((type)=>$a852d2d5bb3d1ec6$export$3c81af374b054d6a(type, item))) $a852d2d5bb3d1ec6$var$keepItem(item, false);
    });
};
/**
 * @param {UndoManager} undoManager
 * @param {Array<StackItem>} stack
 * @param {'undo'|'redo'} eventType
 * @return {StackItem?}
 */ const $a852d2d5bb3d1ec6$var$popStackItem = (undoManager, stack, eventType)=>{
    /**
   * Keep a reference to the transaction so we can fire the event with the changedParentTypes
   * @type {any}
   */ let _tr = null;
    const doc = undoManager.doc;
    const scope = undoManager.scope;
    $a852d2d5bb3d1ec6$export$dac1bad6146b2469(doc, (transaction)=>{
        while(stack.length > 0 && undoManager.currStackItem === null){
            const store = doc.store;
            const stackItem = /** @type {StackItem} */ stack.pop();
            /**
       * @type {Set<Item>}
       */ const itemsToRedo = new Set();
            /**
       * @type {Array<Item>}
       */ const itemsToDelete = [];
            let performedChange = false;
            $a852d2d5bb3d1ec6$export$8afefebbaf4e4c78(transaction, stackItem.insertions, (struct)=>{
                if (struct instanceof $a852d2d5bb3d1ec6$export$6d08773d2e66f8f2) {
                    if (struct.redone !== null) {
                        let { item: item, diff: diff } = $a852d2d5bb3d1ec6$var$followRedone(store, struct.id);
                        if (diff > 0) item = $a852d2d5bb3d1ec6$var$getItemCleanStart(transaction, $a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(item.id.client, item.id.clock + diff));
                        struct = item;
                    }
                    if (!struct.deleted && scope.some((type)=>$a852d2d5bb3d1ec6$export$3c81af374b054d6a(type, /** @type {Item} */ struct))) itemsToDelete.push(struct);
                }
            });
            $a852d2d5bb3d1ec6$export$8afefebbaf4e4c78(transaction, stackItem.deletions, (struct)=>{
                if (struct instanceof $a852d2d5bb3d1ec6$export$6d08773d2e66f8f2 && scope.some((type)=>$a852d2d5bb3d1ec6$export$3c81af374b054d6a(type, struct)) && // Never redo structs in stackItem.insertions because they were created and deleted in the same capture interval.
                !$a852d2d5bb3d1ec6$export$dcb04af092e44fde(stackItem.insertions, struct.id)) itemsToRedo.add(struct);
            });
            itemsToRedo.forEach((struct)=>{
                performedChange = $a852d2d5bb3d1ec6$var$redoItem(transaction, struct, itemsToRedo, stackItem.insertions, undoManager.ignoreRemoteMapChanges, undoManager) !== null || performedChange;
            });
            // We want to delete in reverse order so that children are deleted before
            // parents, so we have more information available when items are filtered.
            for(let i = itemsToDelete.length - 1; i >= 0; i--){
                const item = itemsToDelete[i];
                if (undoManager.deleteFilter(item)) {
                    item.delete(transaction);
                    performedChange = true;
                }
            }
            undoManager.currStackItem = performedChange ? stackItem : null;
        }
        transaction.changed.forEach((subProps, type)=>{
            // destroy search marker if necessary
            if (subProps.has(null) && type._searchMarker) type._searchMarker.length = 0;
        });
        _tr = transaction;
    }, undoManager);
    const res = undoManager.currStackItem;
    if (res != null) {
        const changedParentTypes = _tr.changedParentTypes;
        undoManager.emit('stack-item-popped', [
            {
                stackItem: res,
                type: eventType,
                changedParentTypes: changedParentTypes,
                origin: undoManager
            },
            undoManager
        ]);
        undoManager.currStackItem = null;
    }
    return res;
};
/**
 * @typedef {Object} UndoManagerOptions
 * @property {number} [UndoManagerOptions.captureTimeout=500]
 * @property {function(Transaction):boolean} [UndoManagerOptions.captureTransaction] Do not capture changes of a Transaction if result false.
 * @property {function(Item):boolean} [UndoManagerOptions.deleteFilter=()=>true] Sometimes
 * it is necessary to filter what an Undo/Redo operation can delete. If this
 * filter returns false, the type/item won't be deleted even it is in the
 * undo/redo scope.
 * @property {Set<any>} [UndoManagerOptions.trackedOrigins=new Set([null])]
 * @property {boolean} [ignoreRemoteMapChanges] Experimental. By default, the UndoManager will never overwrite remote changes. Enable this property to enable overwriting remote changes on key-value changes (Y.Map, properties on Y.Xml, etc..).
 * @property {Doc} [doc] The document that this UndoManager operates on. Only needed if typeScope is empty.
 */ /**
 * @typedef {Object} StackItemEvent
 * @property {StackItem} StackItemEvent.stackItem
 * @property {any} StackItemEvent.origin
 * @property {'undo'|'redo'} StackItemEvent.type
 * @property {Map<AbstractType<YEvent<any>>,Array<YEvent<any>>>} StackItemEvent.changedParentTypes
 */ /**
 * Fires 'stack-item-added' event when a stack item was added to either the undo- or
 * the redo-stack. You may store additional stack information via the
 * metadata property on `event.stackItem.meta` (it is a `Map` of metadata properties).
 * Fires 'stack-item-popped' event when a stack item was popped from either the
 * undo- or the redo-stack. You may restore the saved stack information from `event.stackItem.meta`.
 *
 * @extends {ObservableV2<{'stack-item-added':function(StackItemEvent, UndoManager):void, 'stack-item-popped': function(StackItemEvent, UndoManager):void, 'stack-cleared': function({ undoStackCleared: boolean, redoStackCleared: boolean }):void, 'stack-item-updated': function(StackItemEvent, UndoManager):void }>}
 */ class $a852d2d5bb3d1ec6$export$932a3f9a7e88971c extends (0, $7uKvC.ObservableV2) {
    /**
   * @param {AbstractType<any>|Array<AbstractType<any>>} typeScope Accepts either a single type, or an array of types
   * @param {UndoManagerOptions} options
   */ constructor(typeScope, { captureTimeout: captureTimeout = 500, captureTransaction: captureTransaction = (_tr)=>true, deleteFilter: deleteFilter = ()=>true, trackedOrigins: trackedOrigins = new Set([
        null
    ]), ignoreRemoteMapChanges: ignoreRemoteMapChanges = false, doc: doc = /** @type {Doc} */ $dWqHQ.isArray(typeScope) ? typeScope[0].doc : typeScope.doc } = {}){
        super();
        /**
     * @type {Array<AbstractType<any>>}
     */ this.scope = [];
        this.doc = doc;
        this.addToScope(typeScope);
        this.deleteFilter = deleteFilter;
        trackedOrigins.add(this);
        this.trackedOrigins = trackedOrigins;
        this.captureTransaction = captureTransaction;
        /**
     * @type {Array<StackItem>}
     */ this.undoStack = [];
        /**
     * @type {Array<StackItem>}
     */ this.redoStack = [];
        /**
     * Whether the client is currently undoing (calling UndoManager.undo)
     *
     * @type {boolean}
     */ this.undoing = false;
        this.redoing = false;
        /**
     * The currently popped stack item if UndoManager.undoing or UndoManager.redoing
     *
     * @type {StackItem|null}
     */ this.currStackItem = null;
        this.lastChange = 0;
        this.ignoreRemoteMapChanges = ignoreRemoteMapChanges;
        this.captureTimeout = captureTimeout;
        /**
     * @param {Transaction} transaction
     */ this.afterTransactionHandler = (transaction)=>{
            // Only track certain transactions
            if (!this.captureTransaction(transaction) || !this.scope.some((type)=>transaction.changedParentTypes.has(type)) || !this.trackedOrigins.has(transaction.origin) && (!transaction.origin || !this.trackedOrigins.has(transaction.origin.constructor))) return;
            const undoing = this.undoing;
            const redoing = this.redoing;
            const stack = undoing ? this.redoStack : this.undoStack;
            if (undoing) this.stopCapturing(); // next undo should not be appended to last stack item
            else if (!redoing) // neither undoing nor redoing: delete redoStack
            this.clear(false, true);
            const insertions = new $a852d2d5bb3d1ec6$var$DeleteSet();
            transaction.afterState.forEach((endClock, client)=>{
                const startClock = transaction.beforeState.get(client) || 0;
                const len = endClock - startClock;
                if (len > 0) $a852d2d5bb3d1ec6$var$addToDeleteSet(insertions, client, startClock, len);
            });
            const now = $drUmF.getUnixTime();
            let didAdd = false;
            if (this.lastChange > 0 && now - this.lastChange < this.captureTimeout && stack.length > 0 && !undoing && !redoing) {
                // append change to last stack op
                const lastOp = stack[stack.length - 1];
                lastOp.deletions = $a852d2d5bb3d1ec6$export$b7826cadad53901e([
                    lastOp.deletions,
                    transaction.deleteSet
                ]);
                lastOp.insertions = $a852d2d5bb3d1ec6$export$b7826cadad53901e([
                    lastOp.insertions,
                    insertions
                ]);
            } else {
                // create a new stack op
                stack.push(new $a852d2d5bb3d1ec6$var$StackItem(transaction.deleteSet, insertions));
                didAdd = true;
            }
            if (!undoing && !redoing) this.lastChange = now;
            // make sure that deleted structs are not gc'd
            $a852d2d5bb3d1ec6$export$8afefebbaf4e4c78(transaction, transaction.deleteSet, /** @param {Item|GC} item */ (item)=>{
                if (item instanceof $a852d2d5bb3d1ec6$export$6d08773d2e66f8f2 && this.scope.some((type)=>$a852d2d5bb3d1ec6$export$3c81af374b054d6a(type, item))) $a852d2d5bb3d1ec6$var$keepItem(item, true);
            });
            /**
       * @type {[StackItemEvent, UndoManager]}
       */ const changeEvent = [
                {
                    stackItem: stack[stack.length - 1],
                    origin: transaction.origin,
                    type: undoing ? 'redo' : 'undo',
                    changedParentTypes: transaction.changedParentTypes
                },
                this
            ];
            if (didAdd) this.emit('stack-item-added', changeEvent);
            else this.emit('stack-item-updated', changeEvent);
        };
        this.doc.on('afterTransaction', this.afterTransactionHandler);
        this.doc.on('destroy', ()=>{
            this.destroy();
        });
    }
    /**
   * @param {Array<AbstractType<any>> | AbstractType<any>} ytypes
   */ addToScope(ytypes) {
        ytypes = $dWqHQ.isArray(ytypes) ? ytypes : [
            ytypes
        ];
        ytypes.forEach((ytype)=>{
            if (this.scope.every((yt)=>yt !== ytype)) {
                if (ytype.doc !== this.doc) $giaim.warn('[yjs#509] Not same Y.Doc'); // use MultiDocUndoManager instead. also see https://github.com/yjs/yjs/issues/509
                this.scope.push(ytype);
            }
        });
    }
    /**
   * @param {any} origin
   */ addTrackedOrigin(origin) {
        this.trackedOrigins.add(origin);
    }
    /**
   * @param {any} origin
   */ removeTrackedOrigin(origin) {
        this.trackedOrigins.delete(origin);
    }
    clear(clearUndoStack = true, clearRedoStack = true) {
        if (clearUndoStack && this.canUndo() || clearRedoStack && this.canRedo()) this.doc.transact((tr)=>{
            if (clearUndoStack) {
                this.undoStack.forEach((item)=>$a852d2d5bb3d1ec6$var$clearUndoManagerStackItem(tr, this, item));
                this.undoStack = [];
            }
            if (clearRedoStack) {
                this.redoStack.forEach((item)=>$a852d2d5bb3d1ec6$var$clearUndoManagerStackItem(tr, this, item));
                this.redoStack = [];
            }
            this.emit('stack-cleared', [
                {
                    undoStackCleared: clearUndoStack,
                    redoStackCleared: clearRedoStack
                }
            ]);
        });
    }
    /**
   * UndoManager merges Undo-StackItem if they are created within time-gap
   * smaller than `options.captureTimeout`. Call `um.stopCapturing()` so that the next
   * StackItem won't be merged.
   *
   *
   * @example
   *     // without stopCapturing
   *     ytext.insert(0, 'a')
   *     ytext.insert(1, 'b')
   *     um.undo()
   *     ytext.toString() // => '' (note that 'ab' was removed)
   *     // with stopCapturing
   *     ytext.insert(0, 'a')
   *     um.stopCapturing()
   *     ytext.insert(0, 'b')
   *     um.undo()
   *     ytext.toString() // => 'a' (note that only 'b' was removed)
   *
   */ stopCapturing() {
        this.lastChange = 0;
    }
    /**
   * Undo last changes on type.
   *
   * @return {StackItem?} Returns StackItem if a change was applied
   */ undo() {
        this.undoing = true;
        let res;
        try {
            res = $a852d2d5bb3d1ec6$var$popStackItem(this, this.undoStack, 'undo');
        } finally{
            this.undoing = false;
        }
        return res;
    }
    /**
   * Redo last undo operation.
   *
   * @return {StackItem?} Returns StackItem if a change was applied
   */ redo() {
        this.redoing = true;
        let res;
        try {
            res = $a852d2d5bb3d1ec6$var$popStackItem(this, this.redoStack, 'redo');
        } finally{
            this.redoing = false;
        }
        return res;
    }
    /**
   * Are undo steps available?
   *
   * @return {boolean} `true` if undo is possible
   */ canUndo() {
        return this.undoStack.length > 0;
    }
    /**
   * Are redo steps available?
   *
   * @return {boolean} `true` if redo is possible
   */ canRedo() {
        return this.redoStack.length > 0;
    }
    destroy() {
        this.trackedOrigins.delete(this);
        this.doc.off('afterTransaction', this.afterTransactionHandler);
        super.destroy();
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 */ function* $a852d2d5bb3d1ec6$var$lazyStructReaderGenerator(decoder) {
    const numOfStateUpdates = $9QtgA.readVarUint(decoder.restDecoder);
    for(let i = 0; i < numOfStateUpdates; i++){
        const numberOfStructs = $9QtgA.readVarUint(decoder.restDecoder);
        const client = decoder.readClient();
        let clock = $9QtgA.readVarUint(decoder.restDecoder);
        for(let i = 0; i < numberOfStructs; i++){
            const info = decoder.readInfo();
            // @todo use switch instead of ifs
            if (info === 10) {
                const len = $9QtgA.readVarUint(decoder.restDecoder);
                yield new $a852d2d5bb3d1ec6$export$38d24f5c1eb0e4c0($a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(client, clock), len);
                clock += len;
            } else if (($6ciaJ.BITS5 & info) !== 0) {
                const cantCopyParentInfo = (info & ($6ciaJ.BIT7 | $6ciaJ.BIT8)) === 0;
                // If parent = null and neither left nor right are defined, then we know that `parent` is child of `y`
                // and we read the next string as parentYKey.
                // It indicates how we store/retrieve parent from `y.share`
                // @type {string|null}
                const struct = new $a852d2d5bb3d1ec6$export$6d08773d2e66f8f2($a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(client, clock), null, (info & $6ciaJ.BIT8) === $6ciaJ.BIT8 ? decoder.readLeftID() : null, null, (info & $6ciaJ.BIT7) === $6ciaJ.BIT7 ? decoder.readRightID() : null, // @ts-ignore Force writing a string here.
                cantCopyParentInfo ? decoder.readParentInfo() ? decoder.readString() : decoder.readLeftID() : null, cantCopyParentInfo && (info & $6ciaJ.BIT6) === $6ciaJ.BIT6 ? decoder.readString() : null, $a852d2d5bb3d1ec6$var$readItemContent(decoder, info) // item content
                );
                yield struct;
                clock += struct.length;
            } else {
                const len = decoder.readLen();
                yield new $a852d2d5bb3d1ec6$export$12d259ff017e6b58($a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(client, clock), len);
                clock += len;
            }
        }
    }
}
class $a852d2d5bb3d1ec6$var$LazyStructReader {
    /**
   * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
   * @param {boolean} filterSkips
   */ constructor(decoder, filterSkips){
        this.gen = $a852d2d5bb3d1ec6$var$lazyStructReaderGenerator(decoder);
        /**
     * @type {null | Item | Skip | GC}
     */ this.curr = null;
        this.done = false;
        this.filterSkips = filterSkips;
        this.next();
    }
    /**
   * @return {Item | GC | Skip |null}
   */ next() {
        // ignore "Skip" structs
        do this.curr = this.gen.next().value || null;
        while (this.filterSkips && this.curr !== null && this.curr.constructor === $a852d2d5bb3d1ec6$export$38d24f5c1eb0e4c0);
        return this.curr;
    }
}
/**
 * @param {Uint8Array} update
 *
 */ const $a852d2d5bb3d1ec6$export$d6235ced6e55ace9 = (update)=>$a852d2d5bb3d1ec6$export$624b3f0248c2dc40(update, $a852d2d5bb3d1ec6$export$1aa46d9818b5d1ec);
/**
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} [YDecoder]
 *
 */ const $a852d2d5bb3d1ec6$export$624b3f0248c2dc40 = (update, YDecoder = $a852d2d5bb3d1ec6$export$1c932452355c5571)=>{
    const structs = [];
    const updateDecoder = new YDecoder($9QtgA.createDecoder(update));
    const lazyDecoder = new $a852d2d5bb3d1ec6$var$LazyStructReader(updateDecoder, false);
    for(let curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next())structs.push(curr);
    $giaim.print('Structs: ', structs);
    const ds = $a852d2d5bb3d1ec6$var$readDeleteSet(updateDecoder);
    $giaim.print('DeleteSet: ', ds);
};
/**
 * @param {Uint8Array} update
 *
 */ const $a852d2d5bb3d1ec6$export$aa45cba8121663dc = (update)=>$a852d2d5bb3d1ec6$export$2fed33908eb23d71(update, $a852d2d5bb3d1ec6$export$1aa46d9818b5d1ec);
/**
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} [YDecoder]
 *
 */ const $a852d2d5bb3d1ec6$export$2fed33908eb23d71 = (update, YDecoder = $a852d2d5bb3d1ec6$export$1c932452355c5571)=>{
    const structs = [];
    const updateDecoder = new YDecoder($9QtgA.createDecoder(update));
    const lazyDecoder = new $a852d2d5bb3d1ec6$var$LazyStructReader(updateDecoder, false);
    for(let curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next())structs.push(curr);
    return {
        structs: structs,
        ds: $a852d2d5bb3d1ec6$var$readDeleteSet(updateDecoder)
    };
};
class $a852d2d5bb3d1ec6$var$LazyStructWriter {
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ constructor(encoder){
        this.currClient = 0;
        this.startClock = 0;
        this.written = 0;
        this.encoder = encoder;
        /**
     * We want to write operations lazily, but also we need to know beforehand how many operations we want to write for each client.
     *
     * This kind of meta-information (#clients, #structs-per-client-written) is written to the restEncoder.
     *
     * We fragment the restEncoder and store a slice of it per-client until we know how many clients there are.
     * When we flush (toUint8Array) we write the restEncoder using the fragments and the meta-information.
     *
     * @type {Array<{ written: number, restEncoder: Uint8Array }>}
     */ this.clientStructs = [];
    }
}
/**
 * @param {Array<Uint8Array>} updates
 * @return {Uint8Array}
 */ const $a852d2d5bb3d1ec6$export$6319871659fd2460 = (updates)=>$a852d2d5bb3d1ec6$export$ce273d78de0331d1(updates, $a852d2d5bb3d1ec6$export$1aa46d9818b5d1ec, $a852d2d5bb3d1ec6$export$99171b804d9c5b54);
/**
 * @param {Uint8Array} update
 * @param {typeof DSEncoderV1 | typeof DSEncoderV2} YEncoder
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} YDecoder
 * @return {Uint8Array}
 */ const $a852d2d5bb3d1ec6$export$ed51750cf3ab2381 = (update, YEncoder = $a852d2d5bb3d1ec6$var$DSEncoderV2, YDecoder = $a852d2d5bb3d1ec6$export$1c932452355c5571)=>{
    const encoder = new YEncoder();
    const updateDecoder = new $a852d2d5bb3d1ec6$var$LazyStructReader(new YDecoder($9QtgA.createDecoder(update)), false);
    let curr = updateDecoder.curr;
    if (curr !== null) {
        let size = 0;
        let currClient = curr.id.client;
        let stopCounting = curr.id.clock !== 0; // must start at 0
        let currClock = stopCounting ? 0 : curr.id.clock + curr.length;
        for(; curr !== null; curr = updateDecoder.next()){
            if (currClient !== curr.id.client) {
                if (currClock !== 0) {
                    size++;
                    // We found a new client
                    // write what we have to the encoder
                    $kRma6.writeVarUint(encoder.restEncoder, currClient);
                    $kRma6.writeVarUint(encoder.restEncoder, currClock);
                }
                currClient = curr.id.client;
                currClock = 0;
                stopCounting = curr.id.clock !== 0;
            }
            // we ignore skips
            if (curr.constructor === $a852d2d5bb3d1ec6$export$38d24f5c1eb0e4c0) stopCounting = true;
            if (!stopCounting) currClock = curr.id.clock + curr.length;
        }
        // write what we have
        if (currClock !== 0) {
            size++;
            $kRma6.writeVarUint(encoder.restEncoder, currClient);
            $kRma6.writeVarUint(encoder.restEncoder, currClock);
        }
        // prepend the size of the state vector
        const enc = $kRma6.createEncoder();
        $kRma6.writeVarUint(enc, size);
        $kRma6.writeBinaryEncoder(enc, encoder.restEncoder);
        encoder.restEncoder = enc;
        return encoder.toUint8Array();
    } else {
        $kRma6.writeVarUint(encoder.restEncoder, 0);
        return encoder.toUint8Array();
    }
};
/**
 * @param {Uint8Array} update
 * @return {Uint8Array}
 */ const $a852d2d5bb3d1ec6$export$5c451fd8502b011f = (update)=>$a852d2d5bb3d1ec6$export$ed51750cf3ab2381(update, $a852d2d5bb3d1ec6$var$DSEncoderV1, $a852d2d5bb3d1ec6$export$1aa46d9818b5d1ec);
/**
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} YDecoder
 * @return {{ from: Map<number,number>, to: Map<number,number> }}
 */ const $a852d2d5bb3d1ec6$export$8212a58b2178fdcf = (update, YDecoder = $a852d2d5bb3d1ec6$export$1c932452355c5571)=>{
    /**
   * @type {Map<number, number>}
   */ const from = new Map();
    /**
   * @type {Map<number, number>}
   */ const to = new Map();
    const updateDecoder = new $a852d2d5bb3d1ec6$var$LazyStructReader(new YDecoder($9QtgA.createDecoder(update)), false);
    let curr = updateDecoder.curr;
    if (curr !== null) {
        let currClient = curr.id.client;
        let currClock = curr.id.clock;
        // write the beginning to `from`
        from.set(currClient, currClock);
        for(; curr !== null; curr = updateDecoder.next()){
            if (currClient !== curr.id.client) {
                // We found a new client
                // write the end to `to`
                to.set(currClient, currClock);
                // write the beginning to `from`
                from.set(curr.id.client, curr.id.clock);
                // update currClient
                currClient = curr.id.client;
            }
            currClock = curr.id.clock + curr.length;
        }
        // write the end to `to`
        to.set(currClient, currClock);
    }
    return {
        from: from,
        to: to
    };
};
/**
 * @param {Uint8Array} update
 * @return {{ from: Map<number,number>, to: Map<number,number> }}
 */ const $a852d2d5bb3d1ec6$export$e212b06fd4bf78fd = (update)=>$a852d2d5bb3d1ec6$export$8212a58b2178fdcf(update, $a852d2d5bb3d1ec6$export$1aa46d9818b5d1ec);
/**
 * This method is intended to slice any kind of struct and retrieve the right part.
 * It does not handle side-effects, so it should only be used by the lazy-encoder.
 *
 * @param {Item | GC | Skip} left
 * @param {number} diff
 * @return {Item | GC}
 */ const $a852d2d5bb3d1ec6$var$sliceStruct = (left, diff)=>{
    if (left.constructor === $a852d2d5bb3d1ec6$export$12d259ff017e6b58) {
        const { client: client, clock: clock } = left.id;
        return new $a852d2d5bb3d1ec6$export$12d259ff017e6b58($a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(client, clock + diff), left.length - diff);
    } else if (left.constructor === $a852d2d5bb3d1ec6$export$38d24f5c1eb0e4c0) {
        const { client: client, clock: clock } = left.id;
        return new $a852d2d5bb3d1ec6$export$38d24f5c1eb0e4c0($a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(client, clock + diff), left.length - diff);
    } else {
        const leftItem = /** @type {Item} */ left;
        const { client: client, clock: clock } = leftItem.id;
        return new $a852d2d5bb3d1ec6$export$6d08773d2e66f8f2($a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(client, clock + diff), null, $a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(client, clock + diff - 1), null, leftItem.rightOrigin, leftItem.parent, leftItem.parentSub, leftItem.content.splice(diff));
    }
};
/**
 *
 * This function works similarly to `readUpdateV2`.
 *
 * @param {Array<Uint8Array>} updates
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} [YDecoder]
 * @param {typeof UpdateEncoderV1 | typeof UpdateEncoderV2} [YEncoder]
 * @return {Uint8Array}
 */ const $a852d2d5bb3d1ec6$export$ce273d78de0331d1 = (updates, YDecoder = $a852d2d5bb3d1ec6$export$1c932452355c5571, YEncoder = $a852d2d5bb3d1ec6$export$30c99e08943e1c2)=>{
    if (updates.length === 1) return updates[0];
    const updateDecoders = updates.map((update)=>new YDecoder($9QtgA.createDecoder(update)));
    let lazyStructDecoders = updateDecoders.map((decoder)=>new $a852d2d5bb3d1ec6$var$LazyStructReader(decoder, true));
    /**
   * @todo we don't need offset because we always slice before
   * @type {null | { struct: Item | GC | Skip, offset: number }}
   */ let currWrite = null;
    const updateEncoder = new YEncoder();
    // write structs lazily
    const lazyStructEncoder = new $a852d2d5bb3d1ec6$var$LazyStructWriter(updateEncoder);
    // Note: We need to ensure that all lazyStructDecoders are fully consumed
    // Note: Should merge document updates whenever possible - even from different updates
    // Note: Should handle that some operations cannot be applied yet ()
    while(true){
        // Write higher clients first ⇒ sort by clientID & clock and remove decoders without content
        lazyStructDecoders = lazyStructDecoders.filter((dec)=>dec.curr !== null);
        lazyStructDecoders.sort(/** @type {function(any,any):number} */ (dec1, dec2)=>{
            if (dec1.curr.id.client === dec2.curr.id.client) {
                const clockDiff = dec1.curr.id.clock - dec2.curr.id.clock;
                if (clockDiff === 0) // @todo remove references to skip since the structDecoders must filter Skips.
                return dec1.curr.constructor === dec2.curr.constructor ? 0 : dec1.curr.constructor === $a852d2d5bb3d1ec6$export$38d24f5c1eb0e4c0 ? 1 : -1 // we are filtering skips anyway.
                ;
                else return clockDiff;
            } else return dec2.curr.id.client - dec1.curr.id.client;
        });
        if (lazyStructDecoders.length === 0) break;
        const currDecoder = lazyStructDecoders[0];
        // write from currDecoder until the next operation is from another client or if filler-struct
        // then we need to reorder the decoders and find the next operation to write
        const firstClient = /** @type {Item | GC} */ currDecoder.curr.id.client;
        if (currWrite !== null) {
            let curr = /** @type {Item | GC | null} */ currDecoder.curr;
            let iterated = false;
            // iterate until we find something that we haven't written already
            // remember: first the high client-ids are written
            while(curr !== null && curr.id.clock + curr.length <= currWrite.struct.id.clock + currWrite.struct.length && curr.id.client >= currWrite.struct.id.client){
                curr = currDecoder.next();
                iterated = true;
            }
            if (curr === null || // current decoder is empty
            curr.id.client !== firstClient || // check whether there is another decoder that has has updates from `firstClient`
            iterated && curr.id.clock > currWrite.struct.id.clock + currWrite.struct.length // the above while loop was used and we are potentially missing updates
            ) continue;
            if (firstClient !== currWrite.struct.id.client) {
                $a852d2d5bb3d1ec6$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
                currWrite = {
                    struct: curr,
                    offset: 0
                };
                currDecoder.next();
            } else if (currWrite.struct.id.clock + currWrite.struct.length < curr.id.clock) {
                // @todo write currStruct & set currStruct = Skip(clock = currStruct.id.clock + currStruct.length, length = curr.id.clock - self.clock)
                if (currWrite.struct.constructor === $a852d2d5bb3d1ec6$export$38d24f5c1eb0e4c0) // extend existing skip
                currWrite.struct.length = curr.id.clock + curr.length - currWrite.struct.id.clock;
                else {
                    $a852d2d5bb3d1ec6$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
                    const diff = curr.id.clock - currWrite.struct.id.clock - currWrite.struct.length;
                    /**
             * @type {Skip}
             */ const struct = new $a852d2d5bb3d1ec6$export$38d24f5c1eb0e4c0($a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(firstClient, currWrite.struct.id.clock + currWrite.struct.length), diff);
                    currWrite = {
                        struct: struct,
                        offset: 0
                    };
                }
            } else {
                const diff = currWrite.struct.id.clock + currWrite.struct.length - curr.id.clock;
                if (diff > 0) {
                    if (currWrite.struct.constructor === $a852d2d5bb3d1ec6$export$38d24f5c1eb0e4c0) // prefer to slice Skip because the other struct might contain more information
                    currWrite.struct.length -= diff;
                    else curr = $a852d2d5bb3d1ec6$var$sliceStruct(curr, diff);
                }
                if (!currWrite.struct.mergeWith(/** @type {any} */ curr)) {
                    $a852d2d5bb3d1ec6$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
                    currWrite = {
                        struct: curr,
                        offset: 0
                    };
                    currDecoder.next();
                }
            }
        } else {
            currWrite = {
                struct: /** @type {Item | GC} */ currDecoder.curr,
                offset: 0
            };
            currDecoder.next();
        }
        for(let next = currDecoder.curr; next !== null && next.id.client === firstClient && next.id.clock === currWrite.struct.id.clock + currWrite.struct.length && next.constructor !== $a852d2d5bb3d1ec6$export$38d24f5c1eb0e4c0; next = currDecoder.next()){
            $a852d2d5bb3d1ec6$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
            currWrite = {
                struct: next,
                offset: 0
            };
        }
    }
    if (currWrite !== null) {
        $a852d2d5bb3d1ec6$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
        currWrite = null;
    }
    $a852d2d5bb3d1ec6$var$finishLazyStructWriting(lazyStructEncoder);
    const dss = updateDecoders.map((decoder)=>$a852d2d5bb3d1ec6$var$readDeleteSet(decoder));
    const ds = $a852d2d5bb3d1ec6$export$b7826cadad53901e(dss);
    $a852d2d5bb3d1ec6$var$writeDeleteSet(updateEncoder, ds);
    return updateEncoder.toUint8Array();
};
/**
 * @param {Uint8Array} update
 * @param {Uint8Array} sv
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} [YDecoder]
 * @param {typeof UpdateEncoderV1 | typeof UpdateEncoderV2} [YEncoder]
 */ const $a852d2d5bb3d1ec6$export$a8143edf39d2ad8e = (update, sv, YDecoder = $a852d2d5bb3d1ec6$export$1c932452355c5571, YEncoder = $a852d2d5bb3d1ec6$export$30c99e08943e1c2)=>{
    const state = $a852d2d5bb3d1ec6$export$324ac6fb20a844e3(sv);
    const encoder = new YEncoder();
    const lazyStructWriter = new $a852d2d5bb3d1ec6$var$LazyStructWriter(encoder);
    const decoder = new YDecoder($9QtgA.createDecoder(update));
    const reader = new $a852d2d5bb3d1ec6$var$LazyStructReader(decoder, false);
    while(reader.curr){
        const curr = reader.curr;
        const currClient = curr.id.client;
        const svClock = state.get(currClient) || 0;
        if (reader.curr.constructor === $a852d2d5bb3d1ec6$export$38d24f5c1eb0e4c0) {
            // the first written struct shouldn't be a skip
            reader.next();
            continue;
        }
        if (curr.id.clock + curr.length > svClock) {
            $a852d2d5bb3d1ec6$var$writeStructToLazyStructWriter(lazyStructWriter, curr, $bJmyZ.max(svClock - curr.id.clock, 0));
            reader.next();
            while(reader.curr && reader.curr.id.client === currClient){
                $a852d2d5bb3d1ec6$var$writeStructToLazyStructWriter(lazyStructWriter, reader.curr, 0);
                reader.next();
            }
        } else // read until something new comes up
        while(reader.curr && reader.curr.id.client === currClient && reader.curr.id.clock + reader.curr.length <= svClock)reader.next();
    }
    $a852d2d5bb3d1ec6$var$finishLazyStructWriting(lazyStructWriter);
    // write ds
    const ds = $a852d2d5bb3d1ec6$var$readDeleteSet(decoder);
    $a852d2d5bb3d1ec6$var$writeDeleteSet(encoder, ds);
    return encoder.toUint8Array();
};
/**
 * @param {Uint8Array} update
 * @param {Uint8Array} sv
 */ const $a852d2d5bb3d1ec6$export$bf60b51d6c283426 = (update, sv)=>$a852d2d5bb3d1ec6$export$a8143edf39d2ad8e(update, sv, $a852d2d5bb3d1ec6$export$1aa46d9818b5d1ec, $a852d2d5bb3d1ec6$export$99171b804d9c5b54);
/**
 * @param {LazyStructWriter} lazyWriter
 */ const $a852d2d5bb3d1ec6$var$flushLazyStructWriter = (lazyWriter)=>{
    if (lazyWriter.written > 0) {
        lazyWriter.clientStructs.push({
            written: lazyWriter.written,
            restEncoder: $kRma6.toUint8Array(lazyWriter.encoder.restEncoder)
        });
        lazyWriter.encoder.restEncoder = $kRma6.createEncoder();
        lazyWriter.written = 0;
    }
};
/**
 * @param {LazyStructWriter} lazyWriter
 * @param {Item | GC} struct
 * @param {number} offset
 */ const $a852d2d5bb3d1ec6$var$writeStructToLazyStructWriter = (lazyWriter, struct, offset)=>{
    // flush curr if we start another client
    if (lazyWriter.written > 0 && lazyWriter.currClient !== struct.id.client) $a852d2d5bb3d1ec6$var$flushLazyStructWriter(lazyWriter);
    if (lazyWriter.written === 0) {
        lazyWriter.currClient = struct.id.client;
        // write next client
        lazyWriter.encoder.writeClient(struct.id.client);
        // write startClock
        $kRma6.writeVarUint(lazyWriter.encoder.restEncoder, struct.id.clock + offset);
    }
    struct.write(lazyWriter.encoder, offset);
    lazyWriter.written++;
};
/**
 * Call this function when we collected all parts and want to
 * put all the parts together. After calling this method,
 * you can continue using the UpdateEncoder.
 *
 * @param {LazyStructWriter} lazyWriter
 */ const $a852d2d5bb3d1ec6$var$finishLazyStructWriting = (lazyWriter)=>{
    $a852d2d5bb3d1ec6$var$flushLazyStructWriter(lazyWriter);
    // this is a fresh encoder because we called flushCurr
    const restEncoder = lazyWriter.encoder.restEncoder;
    /**
   * Now we put all the fragments together.
   * This works similarly to `writeClientsStructs`
   */ // write # states that were updated - i.e. the clients
    $kRma6.writeVarUint(restEncoder, lazyWriter.clientStructs.length);
    for(let i = 0; i < lazyWriter.clientStructs.length; i++){
        const partStructs = lazyWriter.clientStructs[i];
        /**
     * Works similarly to `writeStructs`
     */ // write # encoded structs
        $kRma6.writeVarUint(restEncoder, partStructs.written);
        // write the rest of the fragment
        $kRma6.writeUint8Array(restEncoder, partStructs.restEncoder);
    }
};
/**
 * @param {Uint8Array} update
 * @param {function(Item|GC|Skip):Item|GC|Skip} blockTransformer
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} YDecoder
 * @param {typeof UpdateEncoderV2 | typeof UpdateEncoderV1 } YEncoder
 */ const $a852d2d5bb3d1ec6$var$convertUpdateFormat = (update, blockTransformer, YDecoder, YEncoder)=>{
    const updateDecoder = new YDecoder($9QtgA.createDecoder(update));
    const lazyDecoder = new $a852d2d5bb3d1ec6$var$LazyStructReader(updateDecoder, false);
    const updateEncoder = new YEncoder();
    const lazyWriter = new $a852d2d5bb3d1ec6$var$LazyStructWriter(updateEncoder);
    for(let curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next())$a852d2d5bb3d1ec6$var$writeStructToLazyStructWriter(lazyWriter, blockTransformer(curr), 0);
    $a852d2d5bb3d1ec6$var$finishLazyStructWriting(lazyWriter);
    const ds = $a852d2d5bb3d1ec6$var$readDeleteSet(updateDecoder);
    $a852d2d5bb3d1ec6$var$writeDeleteSet(updateEncoder, ds);
    return updateEncoder.toUint8Array();
};
/**
 * @typedef {Object} ObfuscatorOptions
 * @property {boolean} [ObfuscatorOptions.formatting=true]
 * @property {boolean} [ObfuscatorOptions.subdocs=true]
 * @property {boolean} [ObfuscatorOptions.yxml=true] Whether to obfuscate nodeName / hookName
 */ /**
 * @param {ObfuscatorOptions} obfuscator
 */ const $a852d2d5bb3d1ec6$var$createObfuscator = ({ formatting: formatting = true, subdocs: subdocs = true, yxml: yxml = true } = {})=>{
    let i = 0;
    const mapKeyCache = $d1VR8.create();
    const nodeNameCache = $d1VR8.create();
    const formattingKeyCache = $d1VR8.create();
    const formattingValueCache = $d1VR8.create();
    formattingValueCache.set(null, null); // end of a formatting range should always be the end of a formatting range
    /**
   * @param {Item|GC|Skip} block
   * @return {Item|GC|Skip}
   */ return (block)=>{
        switch(block.constructor){
            case $a852d2d5bb3d1ec6$export$12d259ff017e6b58:
            case $a852d2d5bb3d1ec6$export$38d24f5c1eb0e4c0:
                return block;
            case $a852d2d5bb3d1ec6$export$6d08773d2e66f8f2:
                {
                    const item = /** @type {Item} */ block;
                    const content = item.content;
                    switch(content.constructor){
                        case $a852d2d5bb3d1ec6$export$3b06e0b3a2ece602:
                            break;
                        case $a852d2d5bb3d1ec6$export$e2e108cbe2e4f865:
                            if (yxml) {
                                const type = /** @type {ContentType} */ content.type;
                                if (type instanceof $a852d2d5bb3d1ec6$export$4db87581d3ca170d) type.nodeName = $d1VR8.setIfUndefined(nodeNameCache, type.nodeName, ()=>'node-' + i);
                                if (type instanceof $a852d2d5bb3d1ec6$export$ec64c1dd5e7a264) type.hookName = $d1VR8.setIfUndefined(nodeNameCache, type.hookName, ()=>'hook-' + i);
                            }
                            break;
                        case $a852d2d5bb3d1ec6$export$1d788b93bbb631a0:
                            {
                                const c = /** @type {ContentAny} */ content;
                                c.arr = c.arr.map(()=>i);
                                break;
                            }
                        case $a852d2d5bb3d1ec6$export$e8d530cdf62d1cbd:
                            {
                                const c = /** @type {ContentBinary} */ content;
                                c.content = new Uint8Array([
                                    i
                                ]);
                                break;
                            }
                        case $a852d2d5bb3d1ec6$export$b564c0e69572c0e:
                            {
                                const c = /** @type {ContentDoc} */ content;
                                if (subdocs) {
                                    c.opts = {};
                                    c.doc.guid = i + '';
                                }
                                break;
                            }
                        case $a852d2d5bb3d1ec6$export$c3787ba7f6086664:
                            {
                                const c = /** @type {ContentEmbed} */ content;
                                c.embed = {};
                                break;
                            }
                        case $a852d2d5bb3d1ec6$export$3194899188fb5a88:
                            {
                                const c = /** @type {ContentFormat} */ content;
                                if (formatting) {
                                    c.key = $d1VR8.setIfUndefined(formattingKeyCache, c.key, ()=>i + '');
                                    c.value = $d1VR8.setIfUndefined(formattingValueCache, c.value, ()=>({
                                            i: i
                                        }));
                                }
                                break;
                            }
                        case $a852d2d5bb3d1ec6$export$6a907ea8f733ecf3:
                            {
                                const c = /** @type {ContentJSON} */ content;
                                c.arr = c.arr.map(()=>i);
                                break;
                            }
                        case $a852d2d5bb3d1ec6$export$ee670b2cf091bbb6:
                            {
                                const c = /** @type {ContentString} */ content;
                                c.str = $1dTGB.repeat(i % 10 + '', c.str.length);
                                break;
                            }
                        default:
                            // unknown content type
                            $gFLjS.unexpectedCase();
                    }
                    if (item.parentSub) item.parentSub = $d1VR8.setIfUndefined(mapKeyCache, item.parentSub, ()=>i + '');
                    i++;
                    return block;
                }
            default:
                // unknown block-type
                $gFLjS.unexpectedCase();
        }
    };
};
/**
 * This function obfuscates the content of a Yjs update. This is useful to share
 * buggy Yjs documents while significantly limiting the possibility that a
 * developer can on the user. Note that it might still be possible to deduce
 * some information by analyzing the "structure" of the document or by analyzing
 * the typing behavior using the CRDT-related metadata that is still kept fully
 * intact.
 *
 * @param {Uint8Array} update
 * @param {ObfuscatorOptions} [opts]
 */ const $a852d2d5bb3d1ec6$export$2dc24d59ec48a24e = (update, opts)=>$a852d2d5bb3d1ec6$var$convertUpdateFormat(update, $a852d2d5bb3d1ec6$var$createObfuscator(opts), $a852d2d5bb3d1ec6$export$1aa46d9818b5d1ec, $a852d2d5bb3d1ec6$export$99171b804d9c5b54);
/**
 * @param {Uint8Array} update
 * @param {ObfuscatorOptions} [opts]
 */ const $a852d2d5bb3d1ec6$export$90648fb14f8c31aa = (update, opts)=>$a852d2d5bb3d1ec6$var$convertUpdateFormat(update, $a852d2d5bb3d1ec6$var$createObfuscator(opts), $a852d2d5bb3d1ec6$export$1c932452355c5571, $a852d2d5bb3d1ec6$export$30c99e08943e1c2);
/**
 * @param {Uint8Array} update
 */ const $a852d2d5bb3d1ec6$export$162408325d5832c = (update)=>$a852d2d5bb3d1ec6$var$convertUpdateFormat(update, $45hHO.id, $a852d2d5bb3d1ec6$export$1aa46d9818b5d1ec, $a852d2d5bb3d1ec6$export$30c99e08943e1c2);
/**
 * @param {Uint8Array} update
 */ const $a852d2d5bb3d1ec6$export$afffbdeed14adbd = (update)=>$a852d2d5bb3d1ec6$var$convertUpdateFormat(update, $45hHO.id, $a852d2d5bb3d1ec6$export$1c932452355c5571, $a852d2d5bb3d1ec6$export$99171b804d9c5b54);
const $a852d2d5bb3d1ec6$var$errorComputeChanges = 'You must not compute changes after the event-handler fired.';
/**
 * @template {AbstractType<any>} T
 * YEvent describes the changes on a YType.
 */ class $a852d2d5bb3d1ec6$export$80fac438977fb51c {
    /**
   * @param {T} target The changed type.
   * @param {Transaction} transaction
   */ constructor(target, transaction){
        /**
     * The type on which this event was created on.
     * @type {T}
     */ this.target = target;
        /**
     * The current target on which the observe callback is called.
     * @type {AbstractType<any>}
     */ this.currentTarget = target;
        /**
     * The transaction that triggered this event.
     * @type {Transaction}
     */ this.transaction = transaction;
        /**
     * @type {Object|null}
     */ this._changes = null;
        /**
     * @type {null | Map<string, { action: 'add' | 'update' | 'delete', oldValue: any, newValue: any }>}
     */ this._keys = null;
        /**
     * @type {null | Array<{ insert?: string | Array<any> | object | AbstractType<any>, retain?: number, delete?: number, attributes?: Object<string, any> }>}
     */ this._delta = null;
        /**
     * @type {Array<string|number>|null}
     */ this._path = null;
    }
    /**
   * Computes the path from `y` to the changed type.
   *
   * @todo v14 should standardize on path: Array<{parent, index}> because that is easier to work with.
   *
   * The following property holds:
   * @example
   *   let type = y
   *   event.path.forEach(dir => {
   *     type = type.get(dir)
   *   })
   *   type === event.target // => true
   */ get path() {
        return this._path || (this._path = $a852d2d5bb3d1ec6$var$getPathTo(this.currentTarget, this.target));
    }
    /**
   * Check if a struct is deleted by this event.
   *
   * In contrast to change.deleted, this method also returns true if the struct was added and then deleted.
   *
   * @param {AbstractStruct} struct
   * @return {boolean}
   */ deletes(struct) {
        return $a852d2d5bb3d1ec6$export$dcb04af092e44fde(this.transaction.deleteSet, struct.id);
    }
    /**
   * @type {Map<string, { action: 'add' | 'update' | 'delete', oldValue: any, newValue: any }>}
   */ get keys() {
        if (this._keys === null) {
            if (this.transaction.doc._transactionCleanups.length === 0) throw $gFLjS.create($a852d2d5bb3d1ec6$var$errorComputeChanges);
            const keys = new Map();
            const target = this.target;
            const changed = /** @type Set<string|null> */ this.transaction.changed.get(target);
            changed.forEach((key)=>{
                if (key !== null) {
                    const item = /** @type {Item} */ target._map.get(key);
                    /**
           * @type {'delete' | 'add' | 'update'}
           */ let action;
                    let oldValue;
                    if (this.adds(item)) {
                        let prev = item.left;
                        while(prev !== null && this.adds(prev))prev = prev.left;
                        if (this.deletes(item)) {
                            if (prev !== null && this.deletes(prev)) {
                                action = 'delete';
                                oldValue = $dWqHQ.last(prev.content.getContent());
                            } else return;
                        } else if (prev !== null && this.deletes(prev)) {
                            action = 'update';
                            oldValue = $dWqHQ.last(prev.content.getContent());
                        } else {
                            action = 'add';
                            oldValue = undefined;
                        }
                    } else {
                        if (this.deletes(item)) {
                            action = 'delete';
                            oldValue = $dWqHQ.last(/** @type {Item} */ item.content.getContent());
                        } else return; // nop
                    }
                    keys.set(key, {
                        action: action,
                        oldValue: oldValue
                    });
                }
            });
            this._keys = keys;
        }
        return this._keys;
    }
    /**
   * This is a computed property. Note that this can only be safely computed during the
   * event call. Computing this property after other changes happened might result in
   * unexpected behavior (incorrect computation of deltas). A safe way to collect changes
   * is to store the `changes` or the `delta` object. Avoid storing the `transaction` object.
   *
   * @type {Array<{insert?: string | Array<any> | object | AbstractType<any>, retain?: number, delete?: number, attributes?: Object<string, any>}>}
   */ get delta() {
        return this.changes.delta;
    }
    /**
   * Check if a struct is added by this event.
   *
   * In contrast to change.deleted, this method also returns true if the struct was added and then deleted.
   *
   * @param {AbstractStruct} struct
   * @return {boolean}
   */ adds(struct) {
        return struct.id.clock >= (this.transaction.beforeState.get(struct.id.client) || 0);
    }
    /**
   * This is a computed property. Note that this can only be safely computed during the
   * event call. Computing this property after other changes happened might result in
   * unexpected behavior (incorrect computation of deltas). A safe way to collect changes
   * is to store the `changes` or the `delta` object. Avoid storing the `transaction` object.
   *
   * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string, delete?:number, retain?:number}>}}
   */ get changes() {
        let changes = this._changes;
        if (changes === null) {
            if (this.transaction.doc._transactionCleanups.length === 0) throw $gFLjS.create($a852d2d5bb3d1ec6$var$errorComputeChanges);
            const target = this.target;
            const added = $9IXCW.create();
            const deleted = $9IXCW.create();
            /**
       * @type {Array<{insert:Array<any>}|{delete:number}|{retain:number}>}
       */ const delta = [];
            changes = {
                added: added,
                deleted: deleted,
                delta: delta,
                keys: this.keys
            };
            const changed = /** @type Set<string|null> */ this.transaction.changed.get(target);
            if (changed.has(null)) {
                /**
         * @type {any}
         */ let lastOp = null;
                const packOp = ()=>{
                    if (lastOp) delta.push(lastOp);
                };
                for(let item = target._start; item !== null; item = item.right){
                    if (item.deleted) {
                        if (this.deletes(item) && !this.adds(item)) {
                            if (lastOp === null || lastOp.delete === undefined) {
                                packOp();
                                lastOp = {
                                    delete: 0
                                };
                            }
                            lastOp.delete += item.length;
                            deleted.add(item);
                        } // else nop
                    } else if (this.adds(item)) {
                        if (lastOp === null || lastOp.insert === undefined) {
                            packOp();
                            lastOp = {
                                insert: []
                            };
                        }
                        lastOp.insert = lastOp.insert.concat(item.content.getContent());
                        added.add(item);
                    } else {
                        if (lastOp === null || lastOp.retain === undefined) {
                            packOp();
                            lastOp = {
                                retain: 0
                            };
                        }
                        lastOp.retain += item.length;
                    }
                }
                if (lastOp !== null && lastOp.retain === undefined) packOp();
            }
            this._changes = changes;
        }
        return /** @type {any} */ changes;
    }
}
/**
 * Compute the path from this type to the specified target.
 *
 * @example
 *   // `child` should be accessible via `type.get(path[0]).get(path[1])..`
 *   const path = type.getPathTo(child)
 *   // assuming `type instanceof YArray`
 *   console.log(path) // might look like => [2, 'key1']
 *   child === type.get(path[0]).get(path[1])
 *
 * @param {AbstractType<any>} parent
 * @param {AbstractType<any>} child target
 * @return {Array<string|number>} Path to the target
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$getPathTo = (parent, child)=>{
    const path = [];
    while(child._item !== null && child !== parent){
        if (child._item.parentSub !== null) // parent is map-ish
        path.unshift(child._item.parentSub);
        else {
            // parent is array-ish
            let i = 0;
            let c = /** @type {AbstractType<any>} */ child._item.parent._start;
            while(c !== child._item && c !== null){
                if (!c.deleted && c.countable) i += c.length;
                c = c.right;
            }
            path.unshift(i);
        }
        child = /** @type {AbstractType<any>} */ child._item.parent;
    }
    return path;
};
/**
 * https://docs.yjs.dev/getting-started/working-with-shared-types#caveats
 */ const $a852d2d5bb3d1ec6$var$warnPrematureAccess = ()=>{
    $giaim.warn('Invalid access: Add Yjs type to a document before reading data.');
};
const $a852d2d5bb3d1ec6$var$maxSearchMarker = 80;
/**
 * A unique timestamp that identifies each marker.
 *
 * Time is relative,.. this is more like an ever-increasing clock.
 *
 * @type {number}
 */ let $a852d2d5bb3d1ec6$var$globalSearchMarkerTimestamp = 0;
class $a852d2d5bb3d1ec6$var$ArraySearchMarker {
    /**
   * @param {Item} p
   * @param {number} index
   */ constructor(p, index){
        p.marker = true;
        this.p = p;
        this.index = index;
        this.timestamp = $a852d2d5bb3d1ec6$var$globalSearchMarkerTimestamp++;
    }
}
/**
 * @param {ArraySearchMarker} marker
 */ const $a852d2d5bb3d1ec6$var$refreshMarkerTimestamp = (marker)=>{
    marker.timestamp = $a852d2d5bb3d1ec6$var$globalSearchMarkerTimestamp++;
};
/**
 * This is rather complex so this function is the only thing that should overwrite a marker
 *
 * @param {ArraySearchMarker} marker
 * @param {Item} p
 * @param {number} index
 */ const $a852d2d5bb3d1ec6$var$overwriteMarker = (marker, p, index)=>{
    marker.p.marker = false;
    marker.p = p;
    p.marker = true;
    marker.index = index;
    marker.timestamp = $a852d2d5bb3d1ec6$var$globalSearchMarkerTimestamp++;
};
/**
 * @param {Array<ArraySearchMarker>} searchMarker
 * @param {Item} p
 * @param {number} index
 */ const $a852d2d5bb3d1ec6$var$markPosition = (searchMarker, p, index)=>{
    if (searchMarker.length >= $a852d2d5bb3d1ec6$var$maxSearchMarker) {
        // override oldest marker (we don't want to create more objects)
        const marker = searchMarker.reduce((a, b)=>a.timestamp < b.timestamp ? a : b);
        $a852d2d5bb3d1ec6$var$overwriteMarker(marker, p, index);
        return marker;
    } else {
        // create new marker
        const pm = new $a852d2d5bb3d1ec6$var$ArraySearchMarker(p, index);
        searchMarker.push(pm);
        return pm;
    }
};
/**
 * Search marker help us to find positions in the associative array faster.
 *
 * They speed up the process of finding a position without much bookkeeping.
 *
 * A maximum of `maxSearchMarker` objects are created.
 *
 * This function always returns a refreshed marker (updated timestamp)
 *
 * @param {AbstractType<any>} yarray
 * @param {number} index
 */ const $a852d2d5bb3d1ec6$var$findMarker = (yarray, index)=>{
    if (yarray._start === null || index === 0 || yarray._searchMarker === null) return null;
    const marker = yarray._searchMarker.length === 0 ? null : yarray._searchMarker.reduce((a, b)=>$bJmyZ.abs(index - a.index) < $bJmyZ.abs(index - b.index) ? a : b);
    let p = yarray._start;
    let pindex = 0;
    if (marker !== null) {
        p = marker.p;
        pindex = marker.index;
        $a852d2d5bb3d1ec6$var$refreshMarkerTimestamp(marker); // we used it, we might need to use it again
    }
    // iterate to right if possible
    while(p.right !== null && pindex < index){
        if (!p.deleted && p.countable) {
            if (index < pindex + p.length) break;
            pindex += p.length;
        }
        p = p.right;
    }
    // iterate to left if necessary (might be that pindex > index)
    while(p.left !== null && pindex > index){
        p = p.left;
        if (!p.deleted && p.countable) pindex -= p.length;
    }
    // we want to make sure that p can't be merged with left, because that would screw up everything
    // in that cas just return what we have (it is most likely the best marker anyway)
    // iterate to left until p can't be merged with left
    while(p.left !== null && p.left.id.client === p.id.client && p.left.id.clock + p.left.length === p.id.clock){
        p = p.left;
        if (!p.deleted && p.countable) pindex -= p.length;
    }
    // @todo remove!
    // assure position
    // {
    //   let start = yarray._start
    //   let pos = 0
    //   while (start !== p) {
    //     if (!start.deleted && start.countable) {
    //       pos += start.length
    //     }
    //     start = /** @type {Item} */ (start.right)
    //   }
    //   if (pos !== pindex) {
    //     debugger
    //     throw new Error('Gotcha position fail!')
    //   }
    // }
    // if (marker) {
    //   if (window.lengthes == null) {
    //     window.lengthes = []
    //     window.getLengthes = () => window.lengthes.sort((a, b) => a - b)
    //   }
    //   window.lengthes.push(marker.index - pindex)
    //   console.log('distance', marker.index - pindex, 'len', p && p.parent.length)
    // }
    if (marker !== null && $bJmyZ.abs(marker.index - pindex) < /** @type {YText|YArray<any>} */ p.parent.length / $a852d2d5bb3d1ec6$var$maxSearchMarker) {
        // adjust existing marker
        $a852d2d5bb3d1ec6$var$overwriteMarker(marker, p, pindex);
        return marker;
    } else // create new marker
    return $a852d2d5bb3d1ec6$var$markPosition(yarray._searchMarker, p, pindex);
};
/**
 * Update markers when a change happened.
 *
 * This should be called before doing a deletion!
 *
 * @param {Array<ArraySearchMarker>} searchMarker
 * @param {number} index
 * @param {number} len If insertion, len is positive. If deletion, len is negative.
 */ const $a852d2d5bb3d1ec6$var$updateMarkerChanges = (searchMarker, index, len)=>{
    for(let i = searchMarker.length - 1; i >= 0; i--){
        const m = searchMarker[i];
        if (len > 0) {
            /**
       * @type {Item|null}
       */ let p = m.p;
            p.marker = false;
            // Ideally we just want to do a simple position comparison, but this will only work if
            // search markers don't point to deleted items for formats.
            // Iterate marker to prev undeleted countable position so we know what to do when updating a position
            while(p && (p.deleted || !p.countable)){
                p = p.left;
                if (p && !p.deleted && p.countable) // adjust position. the loop should break now
                m.index -= p.length;
            }
            if (p === null || p.marker === true) {
                // remove search marker if updated position is null or if position is already marked
                searchMarker.splice(i, 1);
                continue;
            }
            m.p = p;
            p.marker = true;
        }
        if (index < m.index || len > 0 && index === m.index) m.index = $bJmyZ.max(index, m.index + len);
    }
};
/**
 * Accumulate all (list) children of a type and return them as an Array.
 *
 * @param {AbstractType<any>} t
 * @return {Array<Item>}
 */ const $a852d2d5bb3d1ec6$export$5418d693f13991b3 = (t)=>{
    t.doc ?? $a852d2d5bb3d1ec6$var$warnPrematureAccess();
    let s = t._start;
    const arr = [];
    while(s){
        arr.push(s);
        s = s.right;
    }
    return arr;
};
/**
 * Call event listeners with an event. This will also add an event to all
 * parents (for `.observeDeep` handlers).
 *
 * @template EventType
 * @param {AbstractType<EventType>} type
 * @param {Transaction} transaction
 * @param {EventType} event
 */ const $a852d2d5bb3d1ec6$var$callTypeObservers = (type, transaction, event)=>{
    const changedType = type;
    const changedParentTypes = transaction.changedParentTypes;
    while(true){
        // @ts-ignore
        $d1VR8.setIfUndefined(changedParentTypes, type, ()=>[]).push(event);
        if (type._item === null) break;
        type = /** @type {AbstractType<any>} */ type._item.parent;
    }
    $a852d2d5bb3d1ec6$var$callEventHandlerListeners(changedType._eH, event, transaction);
};
/**
 * @template EventType
 * Abstract Yjs Type class
 */ class $a852d2d5bb3d1ec6$export$c265dc8338484497 {
    constructor(){
        /**
     * @type {Item|null}
     */ this._item = null;
        /**
     * @type {Map<string,Item>}
     */ this._map = new Map();
        /**
     * @type {Item|null}
     */ this._start = null;
        /**
     * @type {Doc|null}
     */ this.doc = null;
        this._length = 0;
        /**
     * Event handlers
     * @type {EventHandler<EventType,Transaction>}
     */ this._eH = $a852d2d5bb3d1ec6$var$createEventHandler();
        /**
     * Deep event handlers
     * @type {EventHandler<Array<YEvent<any>>,Transaction>}
     */ this._dEH = $a852d2d5bb3d1ec6$var$createEventHandler();
        /**
     * @type {null | Array<ArraySearchMarker>}
     */ this._searchMarker = null;
    }
    /**
   * @return {AbstractType<any>|null}
   */ get parent() {
        return this._item ? /** @type {AbstractType<any>} */ this._item.parent : null;
    }
    /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item|null} item
   */ _integrate(y, item) {
        this.doc = y;
        this._item = item;
    }
    /**
   * @return {AbstractType<EventType>}
   */ _copy() {
        throw $gFLjS.methodUnimplemented();
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {AbstractType<EventType>}
   */ clone() {
        throw $gFLjS.methodUnimplemented();
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} _encoder
   */ _write(_encoder) {}
    /**
   * The first non-deleted item
   */ get _first() {
        let n = this._start;
        while(n !== null && n.deleted)n = n.right;
        return n;
    }
    /**
   * Creates YEvent and calls all type observers.
   * Must be implemented by each type.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} _parentSubs Keys changed on this type. `null` if list was modified.
   */ _callObserver(transaction, _parentSubs) {
        if (!transaction.local && this._searchMarker) this._searchMarker.length = 0;
    }
    /**
   * Observe all events that are created on this type.
   *
   * @param {function(EventType, Transaction):void} f Observer function
   */ observe(f) {
        $a852d2d5bb3d1ec6$var$addEventHandlerListener(this._eH, f);
    }
    /**
   * Observe all events that are created by this type and its children.
   *
   * @param {function(Array<YEvent<any>>,Transaction):void} f Observer function
   */ observeDeep(f) {
        $a852d2d5bb3d1ec6$var$addEventHandlerListener(this._dEH, f);
    }
    /**
   * Unregister an observer function.
   *
   * @param {function(EventType,Transaction):void} f Observer function
   */ unobserve(f) {
        $a852d2d5bb3d1ec6$var$removeEventHandlerListener(this._eH, f);
    }
    /**
   * Unregister an observer function.
   *
   * @param {function(Array<YEvent<any>>,Transaction):void} f Observer function
   */ unobserveDeep(f) {
        $a852d2d5bb3d1ec6$var$removeEventHandlerListener(this._dEH, f);
    }
    /**
   * @abstract
   * @return {any}
   */ toJSON() {}
}
/**
 * @param {AbstractType<any>} type
 * @param {number} start
 * @param {number} end
 * @return {Array<any>}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$typeListSlice = (type, start, end)=>{
    type.doc ?? $a852d2d5bb3d1ec6$var$warnPrematureAccess();
    if (start < 0) start = type._length + start;
    if (end < 0) end = type._length + end;
    let len = end - start;
    const cs = [];
    let n = type._start;
    while(n !== null && len > 0){
        if (n.countable && !n.deleted) {
            const c = n.content.getContent();
            if (c.length <= start) start -= c.length;
            else {
                for(let i = start; i < c.length && len > 0; i++){
                    cs.push(c[i]);
                    len--;
                }
                start = 0;
            }
        }
        n = n.right;
    }
    return cs;
};
/**
 * @param {AbstractType<any>} type
 * @return {Array<any>}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$typeListToArray = (type)=>{
    type.doc ?? $a852d2d5bb3d1ec6$var$warnPrematureAccess();
    const cs = [];
    let n = type._start;
    while(n !== null){
        if (n.countable && !n.deleted) {
            const c = n.content.getContent();
            for(let i = 0; i < c.length; i++)cs.push(c[i]);
        }
        n = n.right;
    }
    return cs;
};
/**
 * @param {AbstractType<any>} type
 * @param {Snapshot} snapshot
 * @return {Array<any>}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$export$9de42b6dda4c7e48 = (type, snapshot)=>{
    const cs = [];
    let n = type._start;
    while(n !== null){
        if (n.countable && $a852d2d5bb3d1ec6$var$isVisible(n, snapshot)) {
            const c = n.content.getContent();
            for(let i = 0; i < c.length; i++)cs.push(c[i]);
        }
        n = n.right;
    }
    return cs;
};
/**
 * Executes a provided function on once on every element of this YArray.
 *
 * @param {AbstractType<any>} type
 * @param {function(any,number,any):void} f A function to execute on every element of this YArray.
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$typeListForEach = (type, f)=>{
    let index = 0;
    let n = type._start;
    type.doc ?? $a852d2d5bb3d1ec6$var$warnPrematureAccess();
    while(n !== null){
        if (n.countable && !n.deleted) {
            const c = n.content.getContent();
            for(let i = 0; i < c.length; i++)f(c[i], index++, type);
        }
        n = n.right;
    }
};
/**
 * @template C,R
 * @param {AbstractType<any>} type
 * @param {function(C,number,AbstractType<any>):R} f
 * @return {Array<R>}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$typeListMap = (type, f)=>{
    /**
   * @type {Array<any>}
   */ const result = [];
    $a852d2d5bb3d1ec6$var$typeListForEach(type, (c, i)=>{
        result.push(f(c, i, type));
    });
    return result;
};
/**
 * @param {AbstractType<any>} type
 * @return {IterableIterator<any>}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$typeListCreateIterator = (type)=>{
    let n = type._start;
    /**
   * @type {Array<any>|null}
   */ let currentContent = null;
    let currentContentIndex = 0;
    return {
        [Symbol.iterator] () {
            return this;
        },
        next: ()=>{
            // find some content
            if (currentContent === null) {
                while(n !== null && n.deleted)n = n.right;
                // check if we reached the end, no need to check currentContent, because it does not exist
                if (n === null) return {
                    done: true,
                    value: undefined
                };
                // we found n, so we can set currentContent
                currentContent = n.content.getContent();
                currentContentIndex = 0;
                n = n.right; // we used the content of n, now iterate to next
            }
            const value = currentContent[currentContentIndex++];
            // check if we need to empty currentContent
            if (currentContent.length <= currentContentIndex) currentContent = null;
            return {
                done: false,
                value: value
            };
        }
    };
};
/**
 * @param {AbstractType<any>} type
 * @param {number} index
 * @return {any}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$typeListGet = (type, index)=>{
    type.doc ?? $a852d2d5bb3d1ec6$var$warnPrematureAccess();
    const marker = $a852d2d5bb3d1ec6$var$findMarker(type, index);
    let n = type._start;
    if (marker !== null) {
        n = marker.p;
        index -= marker.index;
    }
    for(; n !== null; n = n.right)if (!n.deleted && n.countable) {
        if (index < n.length) return n.content.getContent()[index];
        index -= n.length;
    }
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {Item?} referenceItem
 * @param {Array<Object<string,any>|Array<any>|boolean|number|null|string|Uint8Array>} content
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$typeListInsertGenericsAfter = (transaction, parent, referenceItem, content)=>{
    let left = referenceItem;
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    const store = doc.store;
    const right = referenceItem === null ? parent._start : referenceItem.right;
    /**
   * @type {Array<Object|Array<any>|number|null>}
   */ let jsonContent = [];
    const packJsonContent = ()=>{
        if (jsonContent.length > 0) {
            left = new $a852d2d5bb3d1ec6$export$6d08773d2e66f8f2($a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(ownClientId, $a852d2d5bb3d1ec6$export$50fdfeece43146fd(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $a852d2d5bb3d1ec6$export$1d788b93bbb631a0(jsonContent));
            left.integrate(transaction, 0);
            jsonContent = [];
        }
    };
    content.forEach((c)=>{
        if (c === null) jsonContent.push(c);
        else switch(c.constructor){
            case Number:
            case Object:
            case Boolean:
            case Array:
            case String:
                jsonContent.push(c);
                break;
            default:
                packJsonContent();
                switch(c.constructor){
                    case Uint8Array:
                    case ArrayBuffer:
                        left = new $a852d2d5bb3d1ec6$export$6d08773d2e66f8f2($a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(ownClientId, $a852d2d5bb3d1ec6$export$50fdfeece43146fd(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $a852d2d5bb3d1ec6$export$e8d530cdf62d1cbd(new Uint8Array(/** @type {Uint8Array} */ c)));
                        left.integrate(transaction, 0);
                        break;
                    case $a852d2d5bb3d1ec6$export$bceacc74c2212615:
                        left = new $a852d2d5bb3d1ec6$export$6d08773d2e66f8f2($a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(ownClientId, $a852d2d5bb3d1ec6$export$50fdfeece43146fd(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $a852d2d5bb3d1ec6$export$b564c0e69572c0e(/** @type {Doc} */ c));
                        left.integrate(transaction, 0);
                        break;
                    default:
                        if (c instanceof $a852d2d5bb3d1ec6$export$c265dc8338484497) {
                            left = new $a852d2d5bb3d1ec6$export$6d08773d2e66f8f2($a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(ownClientId, $a852d2d5bb3d1ec6$export$50fdfeece43146fd(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $a852d2d5bb3d1ec6$export$e2e108cbe2e4f865(c));
                            left.integrate(transaction, 0);
                        } else throw new Error('Unexpected content type in insert operation');
                }
        }
    });
    packJsonContent();
};
const $a852d2d5bb3d1ec6$var$lengthExceeded = ()=>$gFLjS.create('Length exceeded!');
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {number} index
 * @param {Array<Object<string,any>|Array<any>|number|null|string|Uint8Array>} content
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$typeListInsertGenerics = (transaction, parent, index, content)=>{
    if (index > parent._length) throw $a852d2d5bb3d1ec6$var$lengthExceeded();
    if (index === 0) {
        if (parent._searchMarker) $a852d2d5bb3d1ec6$var$updateMarkerChanges(parent._searchMarker, index, content.length);
        return $a852d2d5bb3d1ec6$var$typeListInsertGenericsAfter(transaction, parent, null, content);
    }
    const startIndex = index;
    const marker = $a852d2d5bb3d1ec6$var$findMarker(parent, index);
    let n = parent._start;
    if (marker !== null) {
        n = marker.p;
        index -= marker.index;
        // we need to iterate one to the left so that the algorithm works
        if (index === 0) {
            // @todo refactor this as it actually doesn't consider formats
            n = n.prev; // important! get the left undeleted item so that we can actually decrease index
            index += n && n.countable && !n.deleted ? n.length : 0;
        }
    }
    for(; n !== null; n = n.right)if (!n.deleted && n.countable) {
        if (index <= n.length) {
            if (index < n.length) // insert in-between
            $a852d2d5bb3d1ec6$var$getItemCleanStart(transaction, $a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(n.id.client, n.id.clock + index));
            break;
        }
        index -= n.length;
    }
    if (parent._searchMarker) $a852d2d5bb3d1ec6$var$updateMarkerChanges(parent._searchMarker, startIndex, content.length);
    return $a852d2d5bb3d1ec6$var$typeListInsertGenericsAfter(transaction, parent, n, content);
};
/**
 * Pushing content is special as we generally want to push after the last item. So we don't have to update
 * the serach marker.
 *
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {Array<Object<string,any>|Array<any>|number|null|string|Uint8Array>} content
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$typeListPushGenerics = (transaction, parent, content)=>{
    // Use the marker with the highest index and iterate to the right.
    const marker = (parent._searchMarker || []).reduce((maxMarker, currMarker)=>currMarker.index > maxMarker.index ? currMarker : maxMarker, {
        index: 0,
        p: parent._start
    });
    let n = marker.p;
    if (n) while(n.right)n = n.right;
    return $a852d2d5bb3d1ec6$var$typeListInsertGenericsAfter(transaction, parent, n, content);
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {number} index
 * @param {number} length
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$typeListDelete = (transaction, parent, index, length)=>{
    if (length === 0) return;
    const startIndex = index;
    const startLength = length;
    const marker = $a852d2d5bb3d1ec6$var$findMarker(parent, index);
    let n = parent._start;
    if (marker !== null) {
        n = marker.p;
        index -= marker.index;
    }
    // compute the first item to be deleted
    for(; n !== null && index > 0; n = n.right)if (!n.deleted && n.countable) {
        if (index < n.length) $a852d2d5bb3d1ec6$var$getItemCleanStart(transaction, $a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(n.id.client, n.id.clock + index));
        index -= n.length;
    }
    // delete all items until done
    while(length > 0 && n !== null){
        if (!n.deleted) {
            if (length < n.length) $a852d2d5bb3d1ec6$var$getItemCleanStart(transaction, $a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(n.id.client, n.id.clock + length));
            n.delete(transaction);
            length -= n.length;
        }
        n = n.right;
    }
    if (length > 0) throw $a852d2d5bb3d1ec6$var$lengthExceeded();
    if (parent._searchMarker) $a852d2d5bb3d1ec6$var$updateMarkerChanges(parent._searchMarker, startIndex, -startLength + length /* in case we remove the above exception */ );
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {string} key
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$typeMapDelete = (transaction, parent, key)=>{
    const c = parent._map.get(key);
    if (c !== undefined) c.delete(transaction);
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @param {Object|number|null|Array<any>|string|Uint8Array|AbstractType<any>} value
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$typeMapSet = (transaction, parent, key, value)=>{
    const left = parent._map.get(key) || null;
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    let content;
    if (value == null) content = new $a852d2d5bb3d1ec6$export$1d788b93bbb631a0([
        value
    ]);
    else switch(value.constructor){
        case Number:
        case Object:
        case Boolean:
        case Array:
        case String:
            content = new $a852d2d5bb3d1ec6$export$1d788b93bbb631a0([
                value
            ]);
            break;
        case Uint8Array:
            content = new $a852d2d5bb3d1ec6$export$e8d530cdf62d1cbd(/** @type {Uint8Array} */ value);
            break;
        case $a852d2d5bb3d1ec6$export$bceacc74c2212615:
            content = new $a852d2d5bb3d1ec6$export$b564c0e69572c0e(/** @type {Doc} */ value);
            break;
        default:
            if (value instanceof $a852d2d5bb3d1ec6$export$c265dc8338484497) content = new $a852d2d5bb3d1ec6$export$e2e108cbe2e4f865(value);
            else throw new Error('Unexpected content type');
    }
    new $a852d2d5bb3d1ec6$export$6d08773d2e66f8f2($a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(ownClientId, $a852d2d5bb3d1ec6$export$50fdfeece43146fd(doc.store, ownClientId)), left, left && left.lastId, null, null, parent, key, content).integrate(transaction, 0);
};
/**
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @return {Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$typeMapGet = (parent, key)=>{
    parent.doc ?? $a852d2d5bb3d1ec6$var$warnPrematureAccess();
    const val = parent._map.get(key);
    return val !== undefined && !val.deleted ? val.content.getContent()[val.length - 1] : undefined;
};
/**
 * @param {AbstractType<any>} parent
 * @return {Object<string,Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined>}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$typeMapGetAll = (parent)=>{
    /**
   * @type {Object<string,any>}
   */ const res = {};
    parent.doc ?? $a852d2d5bb3d1ec6$var$warnPrematureAccess();
    parent._map.forEach((value, key)=>{
        if (!value.deleted) res[key] = value.content.getContent()[value.length - 1];
    });
    return res;
};
/**
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @return {boolean}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$typeMapHas = (parent, key)=>{
    parent.doc ?? $a852d2d5bb3d1ec6$var$warnPrematureAccess();
    const val = parent._map.get(key);
    return val !== undefined && !val.deleted;
};
/**
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @param {Snapshot} snapshot
 * @return {Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$export$a7c089bf6c22a1db = (parent, key, snapshot)=>{
    let v = parent._map.get(key) || null;
    while(v !== null && (!snapshot.sv.has(v.id.client) || v.id.clock >= (snapshot.sv.get(v.id.client) || 0)))v = v.left;
    return v !== null && $a852d2d5bb3d1ec6$var$isVisible(v, snapshot) ? v.content.getContent()[v.length - 1] : undefined;
};
/**
 * @param {AbstractType<any>} parent
 * @param {Snapshot} snapshot
 * @return {Object<string,Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined>}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$export$7769bdedaef2c91b = (parent, snapshot)=>{
    /**
   * @type {Object<string,any>}
   */ const res = {};
    parent._map.forEach((value, key)=>{
        /**
     * @type {Item|null}
     */ let v = value;
        while(v !== null && (!snapshot.sv.has(v.id.client) || v.id.clock >= (snapshot.sv.get(v.id.client) || 0)))v = v.left;
        if (v !== null && $a852d2d5bb3d1ec6$var$isVisible(v, snapshot)) res[key] = v.content.getContent()[v.length - 1];
    });
    return res;
};
/**
 * @param {AbstractType<any> & { _map: Map<string, Item> }} type
 * @return {IterableIterator<Array<any>>}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$createMapIterator = (type)=>{
    type.doc ?? $a852d2d5bb3d1ec6$var$warnPrematureAccess();
    return $fphiM.iteratorFilter(type._map.entries(), /** @param {any} entry */ (entry)=>!entry[1].deleted);
};
/**
 * @module YArray
 */ /**
 * Event that describes the changes on a YArray
 * @template T
 * @extends YEvent<YArray<T>>
 */ class $a852d2d5bb3d1ec6$export$a095f7fee639264a extends $a852d2d5bb3d1ec6$export$80fac438977fb51c {
}
/**
 * A shared Array implementation.
 * @template T
 * @extends AbstractType<YArrayEvent<T>>
 * @implements {Iterable<T>}
 */ class $a852d2d5bb3d1ec6$export$c4be6576ca6fe4aa extends $a852d2d5bb3d1ec6$export$c265dc8338484497 {
    constructor(){
        super();
        /**
     * @type {Array<any>?}
     * @private
     */ this._prelimContent = [];
        /**
     * @type {Array<ArraySearchMarker>}
     */ this._searchMarker = [];
    }
    /**
   * Construct a new YArray containing the specified items.
   * @template {Object<string,any>|Array<any>|number|null|string|Uint8Array} T
   * @param {Array<T>} items
   * @return {YArray<T>}
   */ static from(items) {
        /**
     * @type {YArray<T>}
     */ const a = new $a852d2d5bb3d1ec6$export$c4be6576ca6fe4aa();
        a.push(items);
        return a;
    }
    /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */ _integrate(y, item) {
        super._integrate(y, item);
        this.insert(0, /** @type {Array<any>} */ this._prelimContent);
        this._prelimContent = null;
    }
    /**
   * @return {YArray<T>}
   */ _copy() {
        return new $a852d2d5bb3d1ec6$export$c4be6576ca6fe4aa();
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YArray<T>}
   */ clone() {
        /**
     * @type {YArray<T>}
     */ const arr = new $a852d2d5bb3d1ec6$export$c4be6576ca6fe4aa();
        arr.insert(0, this.toArray().map((el)=>el instanceof $a852d2d5bb3d1ec6$export$c265dc8338484497 ? /** @type {typeof el} */ el.clone() : el));
        return arr;
    }
    get length() {
        this.doc ?? $a852d2d5bb3d1ec6$var$warnPrematureAccess();
        return this._length;
    }
    /**
   * Creates YArrayEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */ _callObserver(transaction, parentSubs) {
        super._callObserver(transaction, parentSubs);
        $a852d2d5bb3d1ec6$var$callTypeObservers(this, transaction, new $a852d2d5bb3d1ec6$export$a095f7fee639264a(this, transaction));
    }
    /**
   * Inserts new content at an index.
   *
   * Important: This function expects an array of content. Not just a content
   * object. The reason for this "weirdness" is that inserting several elements
   * is very efficient when it is done as a single operation.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  yarray.insert(0, ['a'])
   *  // Insert numbers 1, 2 at position 1
   *  yarray.insert(1, [1, 2])
   *
   * @param {number} index The index to insert content at.
   * @param {Array<T>} content The array of content
   */ insert(index, content) {
        if (this.doc !== null) $a852d2d5bb3d1ec6$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $a852d2d5bb3d1ec6$var$typeListInsertGenerics(transaction, this, index, /** @type {any} */ content);
        });
        else /** @type {Array<any>} */ this._prelimContent.splice(index, 0, ...content);
    }
    /**
   * Appends content to this YArray.
   *
   * @param {Array<T>} content Array of content to append.
   *
   * @todo Use the following implementation in all types.
   */ push(content) {
        if (this.doc !== null) $a852d2d5bb3d1ec6$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $a852d2d5bb3d1ec6$var$typeListPushGenerics(transaction, this, /** @type {any} */ content);
        });
        else /** @type {Array<any>} */ this._prelimContent.push(...content);
    }
    /**
   * Prepends content to this YArray.
   *
   * @param {Array<T>} content Array of content to prepend.
   */ unshift(content) {
        this.insert(0, content);
    }
    /**
   * Deletes elements starting from an index.
   *
   * @param {number} index Index at which to start deleting elements
   * @param {number} length The number of elements to remove. Defaults to 1.
   */ delete(index, length = 1) {
        if (this.doc !== null) $a852d2d5bb3d1ec6$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $a852d2d5bb3d1ec6$var$typeListDelete(transaction, this, index, length);
        });
        else /** @type {Array<any>} */ this._prelimContent.splice(index, length);
    }
    /**
   * Returns the i-th element from a YArray.
   *
   * @param {number} index The index of the element to return from the YArray
   * @return {T}
   */ get(index) {
        return $a852d2d5bb3d1ec6$var$typeListGet(this, index);
    }
    /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @return {Array<T>}
   */ toArray() {
        return $a852d2d5bb3d1ec6$var$typeListToArray(this);
    }
    /**
   * Returns a portion of this YArray into a JavaScript Array selected
   * from start to end (end not included).
   *
   * @param {number} [start]
   * @param {number} [end]
   * @return {Array<T>}
   */ slice(start = 0, end = this.length) {
        return $a852d2d5bb3d1ec6$var$typeListSlice(this, start, end);
    }
    /**
   * Transforms this Shared Type to a JSON object.
   *
   * @return {Array<any>}
   */ toJSON() {
        return this.map((c)=>c instanceof $a852d2d5bb3d1ec6$export$c265dc8338484497 ? c.toJSON() : c);
    }
    /**
   * Returns an Array with the result of calling a provided function on every
   * element of this YArray.
   *
   * @template M
   * @param {function(T,number,YArray<T>):M} f Function that produces an element of the new Array
   * @return {Array<M>} A new array with each element being the result of the
   *                 callback function
   */ map(f) {
        return $a852d2d5bb3d1ec6$var$typeListMap(this, /** @type {any} */ f);
    }
    /**
   * Executes a provided function once on every element of this YArray.
   *
   * @param {function(T,number,YArray<T>):void} f A function to execute on every element of this YArray.
   */ forEach(f) {
        $a852d2d5bb3d1ec6$var$typeListForEach(this, f);
    }
    /**
   * @return {IterableIterator<T>}
   */ [Symbol.iterator]() {
        return $a852d2d5bb3d1ec6$var$typeListCreateIterator(this);
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ _write(encoder) {
        encoder.writeTypeRef($a852d2d5bb3d1ec6$var$YArrayRefID);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} _decoder
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$readYArray = (_decoder)=>new $a852d2d5bb3d1ec6$export$c4be6576ca6fe4aa();
/**
 * @module YMap
 */ /**
 * @template T
 * @extends YEvent<YMap<T>>
 * Event that describes the changes on a YMap.
 */ class $a852d2d5bb3d1ec6$export$33aab1b1a47c1cc3 extends $a852d2d5bb3d1ec6$export$80fac438977fb51c {
    /**
   * @param {YMap<T>} ymap The YArray that changed.
   * @param {Transaction} transaction
   * @param {Set<any>} subs The keys that changed.
   */ constructor(ymap, transaction, subs){
        super(ymap, transaction);
        this.keysChanged = subs;
    }
}
/**
 * @template MapType
 * A shared Map implementation.
 *
 * @extends AbstractType<YMapEvent<MapType>>
 * @implements {Iterable<[string, MapType]>}
 */ class $a852d2d5bb3d1ec6$export$a5c7b93649eaf8f8 extends $a852d2d5bb3d1ec6$export$c265dc8338484497 {
    /**
   *
   * @param {Iterable<readonly [string, any]>=} entries - an optional iterable to initialize the YMap
   */ constructor(entries){
        super();
        /**
     * @type {Map<string,any>?}
     * @private
     */ this._prelimContent = null;
        if (entries === undefined) this._prelimContent = new Map();
        else this._prelimContent = new Map(entries);
    }
    /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */ _integrate(y, item) {
        super._integrate(y, item); /** @type {Map<string, any>} */ 
        this._prelimContent.forEach((value, key)=>{
            this.set(key, value);
        });
        this._prelimContent = null;
    }
    /**
   * @return {YMap<MapType>}
   */ _copy() {
        return new $a852d2d5bb3d1ec6$export$a5c7b93649eaf8f8();
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YMap<MapType>}
   */ clone() {
        /**
     * @type {YMap<MapType>}
     */ const map = new $a852d2d5bb3d1ec6$export$a5c7b93649eaf8f8();
        this.forEach((value, key)=>{
            map.set(key, value instanceof $a852d2d5bb3d1ec6$export$c265dc8338484497 ? /** @type {typeof value} */ value.clone() : value);
        });
        return map;
    }
    /**
   * Creates YMapEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */ _callObserver(transaction, parentSubs) {
        $a852d2d5bb3d1ec6$var$callTypeObservers(this, transaction, new $a852d2d5bb3d1ec6$export$33aab1b1a47c1cc3(this, transaction, parentSubs));
    }
    /**
   * Transforms this Shared Type to a JSON object.
   *
   * @return {Object<string,any>}
   */ toJSON() {
        this.doc ?? $a852d2d5bb3d1ec6$var$warnPrematureAccess();
        /**
     * @type {Object<string,MapType>}
     */ const map = {};
        this._map.forEach((item, key)=>{
            if (!item.deleted) {
                const v = item.content.getContent()[item.length - 1];
                map[key] = v instanceof $a852d2d5bb3d1ec6$export$c265dc8338484497 ? v.toJSON() : v;
            }
        });
        return map;
    }
    /**
   * Returns the size of the YMap (count of key/value pairs)
   *
   * @return {number}
   */ get size() {
        return [
            ...$a852d2d5bb3d1ec6$var$createMapIterator(this)
        ].length;
    }
    /**
   * Returns the keys for each element in the YMap Type.
   *
   * @return {IterableIterator<string>}
   */ keys() {
        return $fphiM.iteratorMap($a852d2d5bb3d1ec6$var$createMapIterator(this), /** @param {any} v */ (v)=>v[0]);
    }
    /**
   * Returns the values for each element in the YMap Type.
   *
   * @return {IterableIterator<MapType>}
   */ values() {
        return $fphiM.iteratorMap($a852d2d5bb3d1ec6$var$createMapIterator(this), /** @param {any} v */ (v)=>v[1].content.getContent()[v[1].length - 1]);
    }
    /**
   * Returns an Iterator of [key, value] pairs
   *
   * @return {IterableIterator<[string, MapType]>}
   */ entries() {
        return $fphiM.iteratorMap($a852d2d5bb3d1ec6$var$createMapIterator(this), /** @param {any} v */ (v)=>/** @type {any} */ [
                v[0],
                v[1].content.getContent()[v[1].length - 1]
            ]);
    }
    /**
   * Executes a provided function on once on every key-value pair.
   *
   * @param {function(MapType,string,YMap<MapType>):void} f A function to execute on every element of this YArray.
   */ forEach(f) {
        this.doc ?? $a852d2d5bb3d1ec6$var$warnPrematureAccess();
        this._map.forEach((item, key)=>{
            if (!item.deleted) f(item.content.getContent()[item.length - 1], key, this);
        });
    }
    /**
   * Returns an Iterator of [key, value] pairs
   *
   * @return {IterableIterator<[string, MapType]>}
   */ [Symbol.iterator]() {
        return this.entries();
    }
    /**
   * Remove a specified element from this YMap.
   *
   * @param {string} key The key of the element to remove.
   */ delete(key) {
        if (this.doc !== null) $a852d2d5bb3d1ec6$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $a852d2d5bb3d1ec6$var$typeMapDelete(transaction, this, key);
        });
        else /** @type {Map<string, any>} */ this._prelimContent.delete(key);
    }
    /**
   * Adds or updates an element with a specified key and value.
   * @template {MapType} VAL
   *
   * @param {string} key The key of the element to add to this YMap
   * @param {VAL} value The value of the element to add
   * @return {VAL}
   */ set(key, value) {
        if (this.doc !== null) $a852d2d5bb3d1ec6$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $a852d2d5bb3d1ec6$var$typeMapSet(transaction, this, key, /** @type {any} */ value);
        });
        else /** @type {Map<string, any>} */ this._prelimContent.set(key, value);
        return value;
    }
    /**
   * Returns a specified element from this YMap.
   *
   * @param {string} key
   * @return {MapType|undefined}
   */ get(key) {
        return /** @type {any} */ $a852d2d5bb3d1ec6$var$typeMapGet(this, key);
    }
    /**
   * Returns a boolean indicating whether the specified key exists or not.
   *
   * @param {string} key The key to test.
   * @return {boolean}
   */ has(key) {
        return $a852d2d5bb3d1ec6$var$typeMapHas(this, key);
    }
    /**
   * Removes all elements from this YMap.
   */ clear() {
        if (this.doc !== null) $a852d2d5bb3d1ec6$export$dac1bad6146b2469(this.doc, (transaction)=>{
            this.forEach(function(_value, key, map) {
                $a852d2d5bb3d1ec6$var$typeMapDelete(transaction, map, key);
            });
        });
        else /** @type {Map<string, any>} */ this._prelimContent.clear();
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ _write(encoder) {
        encoder.writeTypeRef($a852d2d5bb3d1ec6$var$YMapRefID);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} _decoder
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$readYMap = (_decoder)=>new $a852d2d5bb3d1ec6$export$a5c7b93649eaf8f8();
/**
 * @module YText
 */ /**
 * @param {any} a
 * @param {any} b
 * @return {boolean}
 */ const $a852d2d5bb3d1ec6$var$equalAttrs = (a, b)=>a === b || typeof a === 'object' && typeof b === 'object' && a && b && $4m6H0.equalFlat(a, b);
class $a852d2d5bb3d1ec6$var$ItemTextListPosition {
    /**
   * @param {Item|null} left
   * @param {Item|null} right
   * @param {number} index
   * @param {Map<string,any>} currentAttributes
   */ constructor(left, right, index, currentAttributes){
        this.left = left;
        this.right = right;
        this.index = index;
        this.currentAttributes = currentAttributes;
    }
    /**
   * Only call this if you know that this.right is defined
   */ forward() {
        if (this.right === null) $gFLjS.unexpectedCase();
        switch(this.right.content.constructor){
            case $a852d2d5bb3d1ec6$export$3194899188fb5a88:
                if (!this.right.deleted) $a852d2d5bb3d1ec6$var$updateCurrentAttributes(this.currentAttributes, /** @type {ContentFormat} */ this.right.content);
                break;
            default:
                if (!this.right.deleted) this.index += this.right.length;
                break;
        }
        this.left = this.right;
        this.right = this.right.right;
    }
}
/**
 * @param {Transaction} transaction
 * @param {ItemTextListPosition} pos
 * @param {number} count steps to move forward
 * @return {ItemTextListPosition}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$findNextPosition = (transaction, pos, count)=>{
    while(pos.right !== null && count > 0){
        switch(pos.right.content.constructor){
            case $a852d2d5bb3d1ec6$export$3194899188fb5a88:
                if (!pos.right.deleted) $a852d2d5bb3d1ec6$var$updateCurrentAttributes(pos.currentAttributes, /** @type {ContentFormat} */ pos.right.content);
                break;
            default:
                if (!pos.right.deleted) {
                    if (count < pos.right.length) // split right
                    $a852d2d5bb3d1ec6$var$getItemCleanStart(transaction, $a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(pos.right.id.client, pos.right.id.clock + count));
                    pos.index += pos.right.length;
                    count -= pos.right.length;
                }
                break;
        }
        pos.left = pos.right;
        pos.right = pos.right.right;
    // pos.forward() - we don't forward because that would halve the performance because we already do the checks above
    }
    return pos;
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {number} index
 * @param {boolean} useSearchMarker
 * @return {ItemTextListPosition}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$findPosition = (transaction, parent, index, useSearchMarker)=>{
    const currentAttributes = new Map();
    const marker = useSearchMarker ? $a852d2d5bb3d1ec6$var$findMarker(parent, index) : null;
    if (marker) {
        const pos = new $a852d2d5bb3d1ec6$var$ItemTextListPosition(marker.p.left, marker.p, marker.index, currentAttributes);
        return $a852d2d5bb3d1ec6$var$findNextPosition(transaction, pos, index - marker.index);
    } else {
        const pos = new $a852d2d5bb3d1ec6$var$ItemTextListPosition(null, parent._start, 0, currentAttributes);
        return $a852d2d5bb3d1ec6$var$findNextPosition(transaction, pos, index);
    }
};
/**
 * Negate applied formats
 *
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {Map<string,any>} negatedAttributes
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$insertNegatedAttributes = (transaction, parent, currPos, negatedAttributes)=>{
    // check if we really need to remove attributes
    while(currPos.right !== null && (currPos.right.deleted === true || currPos.right.content.constructor === $a852d2d5bb3d1ec6$export$3194899188fb5a88 && $a852d2d5bb3d1ec6$var$equalAttrs(negatedAttributes.get(/** @type {ContentFormat} */ currPos.right.content.key), /** @type {ContentFormat} */ currPos.right.content.value))){
        if (!currPos.right.deleted) negatedAttributes.delete(/** @type {ContentFormat} */ currPos.right.content.key);
        currPos.forward();
    }
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    negatedAttributes.forEach((val, key)=>{
        const left = currPos.left;
        const right = currPos.right;
        const nextFormat = new $a852d2d5bb3d1ec6$export$6d08773d2e66f8f2($a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(ownClientId, $a852d2d5bb3d1ec6$export$50fdfeece43146fd(doc.store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $a852d2d5bb3d1ec6$export$3194899188fb5a88(key, val));
        nextFormat.integrate(transaction, 0);
        currPos.right = nextFormat;
        currPos.forward();
    });
};
/**
 * @param {Map<string,any>} currentAttributes
 * @param {ContentFormat} format
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$updateCurrentAttributes = (currentAttributes, format)=>{
    const { key: key, value: value } = format;
    if (value === null) currentAttributes.delete(key);
    else currentAttributes.set(key, value);
};
/**
 * @param {ItemTextListPosition} currPos
 * @param {Object<string,any>} attributes
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$minimizeAttributeChanges = (currPos, attributes)=>{
    // go right while attributes[right.key] === right.value (or right is deleted)
    while(true){
        if (currPos.right === null) break;
        else if (currPos.right.deleted || currPos.right.content.constructor === $a852d2d5bb3d1ec6$export$3194899188fb5a88 && $a852d2d5bb3d1ec6$var$equalAttrs(attributes[/** @type {ContentFormat} */ currPos.right.content.key] ?? null, /** @type {ContentFormat} */ currPos.right.content.value)) ;
        else break;
        currPos.forward();
    }
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {Object<string,any>} attributes
 * @return {Map<string,any>}
 *
 * @private
 * @function
 **/ const $a852d2d5bb3d1ec6$var$insertAttributes = (transaction, parent, currPos, attributes)=>{
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    const negatedAttributes = new Map();
    // insert format-start items
    for(const key in attributes){
        const val = attributes[key];
        const currentVal = currPos.currentAttributes.get(key) ?? null;
        if (!$a852d2d5bb3d1ec6$var$equalAttrs(currentVal, val)) {
            // save negated attribute (set null if currentVal undefined)
            negatedAttributes.set(key, currentVal);
            const { left: left, right: right } = currPos;
            currPos.right = new $a852d2d5bb3d1ec6$export$6d08773d2e66f8f2($a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(ownClientId, $a852d2d5bb3d1ec6$export$50fdfeece43146fd(doc.store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $a852d2d5bb3d1ec6$export$3194899188fb5a88(key, val));
            currPos.right.integrate(transaction, 0);
            currPos.forward();
        }
    }
    return negatedAttributes;
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {string|object|AbstractType<any>} text
 * @param {Object<string,any>} attributes
 *
 * @private
 * @function
 **/ const $a852d2d5bb3d1ec6$var$insertText = (transaction, parent, currPos, text, attributes)=>{
    currPos.currentAttributes.forEach((_val, key)=>{
        if (attributes[key] === undefined) attributes[key] = null;
    });
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    $a852d2d5bb3d1ec6$var$minimizeAttributeChanges(currPos, attributes);
    const negatedAttributes = $a852d2d5bb3d1ec6$var$insertAttributes(transaction, parent, currPos, attributes);
    // insert content
    const content = text.constructor === String ? new $a852d2d5bb3d1ec6$export$ee670b2cf091bbb6(/** @type {string} */ text) : text instanceof $a852d2d5bb3d1ec6$export$c265dc8338484497 ? new $a852d2d5bb3d1ec6$export$e2e108cbe2e4f865(text) : new $a852d2d5bb3d1ec6$export$c3787ba7f6086664(text);
    let { left: left, right: right, index: index } = currPos;
    if (parent._searchMarker) $a852d2d5bb3d1ec6$var$updateMarkerChanges(parent._searchMarker, currPos.index, content.getLength());
    right = new $a852d2d5bb3d1ec6$export$6d08773d2e66f8f2($a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(ownClientId, $a852d2d5bb3d1ec6$export$50fdfeece43146fd(doc.store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, content);
    right.integrate(transaction, 0);
    currPos.right = right;
    currPos.index = index;
    currPos.forward();
    $a852d2d5bb3d1ec6$var$insertNegatedAttributes(transaction, parent, currPos, negatedAttributes);
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {number} length
 * @param {Object<string,any>} attributes
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$formatText = (transaction, parent, currPos, length, attributes)=>{
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    $a852d2d5bb3d1ec6$var$minimizeAttributeChanges(currPos, attributes);
    const negatedAttributes = $a852d2d5bb3d1ec6$var$insertAttributes(transaction, parent, currPos, attributes);
    // iterate until first non-format or null is found
    // delete all formats with attributes[format.key] != null
    // also check the attributes after the first non-format as we do not want to insert redundant negated attributes there
    // eslint-disable-next-line no-labels
    iterationLoop: while(currPos.right !== null && (length > 0 || negatedAttributes.size > 0 && (currPos.right.deleted || currPos.right.content.constructor === $a852d2d5bb3d1ec6$export$3194899188fb5a88))){
        if (!currPos.right.deleted) switch(currPos.right.content.constructor){
            case $a852d2d5bb3d1ec6$export$3194899188fb5a88:
                {
                    const { key: key, value: value } = /** @type {ContentFormat} */ currPos.right.content;
                    const attr = attributes[key];
                    if (attr !== undefined) {
                        if ($a852d2d5bb3d1ec6$var$equalAttrs(attr, value)) negatedAttributes.delete(key);
                        else {
                            if (length === 0) break iterationLoop;
                            negatedAttributes.set(key, value);
                        }
                        currPos.right.delete(transaction);
                    } else currPos.currentAttributes.set(key, value);
                    break;
                }
            default:
                if (length < currPos.right.length) $a852d2d5bb3d1ec6$var$getItemCleanStart(transaction, $a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(currPos.right.id.client, currPos.right.id.clock + length));
                length -= currPos.right.length;
                break;
        }
        currPos.forward();
    }
    // Quill just assumes that the editor starts with a newline and that it always
    // ends with a newline. We only insert that newline when a new newline is
    // inserted - i.e when length is bigger than type.length
    if (length > 0) {
        let newlines = '';
        for(; length > 0; length--)newlines += '\n';
        currPos.right = new $a852d2d5bb3d1ec6$export$6d08773d2e66f8f2($a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(ownClientId, $a852d2d5bb3d1ec6$export$50fdfeece43146fd(doc.store, ownClientId)), currPos.left, currPos.left && currPos.left.lastId, currPos.right, currPos.right && currPos.right.id, parent, null, new $a852d2d5bb3d1ec6$export$ee670b2cf091bbb6(newlines));
        currPos.right.integrate(transaction, 0);
        currPos.forward();
    }
    $a852d2d5bb3d1ec6$var$insertNegatedAttributes(transaction, parent, currPos, negatedAttributes);
};
/**
 * Call this function after string content has been deleted in order to
 * clean up formatting Items.
 *
 * @param {Transaction} transaction
 * @param {Item} start
 * @param {Item|null} curr exclusive end, automatically iterates to the next Content Item
 * @param {Map<string,any>} startAttributes
 * @param {Map<string,any>} currAttributes
 * @return {number} The amount of formatting Items deleted.
 *
 * @function
 */ const $a852d2d5bb3d1ec6$var$cleanupFormattingGap = (transaction, start, curr, startAttributes, currAttributes)=>{
    /**
   * @type {Item|null}
   */ let end = start;
    /**
   * @type {Map<string,ContentFormat>}
   */ const endFormats = $d1VR8.create();
    while(end && (!end.countable || end.deleted)){
        if (!end.deleted && end.content.constructor === $a852d2d5bb3d1ec6$export$3194899188fb5a88) {
            const cf = /** @type {ContentFormat} */ end.content;
            endFormats.set(cf.key, cf);
        }
        end = end.right;
    }
    let cleanups = 0;
    let reachedCurr = false;
    while(start !== end){
        if (curr === start) reachedCurr = true;
        if (!start.deleted) {
            const content = start.content;
            switch(content.constructor){
                case $a852d2d5bb3d1ec6$export$3194899188fb5a88:
                    {
                        const { key: key, value: value } = /** @type {ContentFormat} */ content;
                        const startAttrValue = startAttributes.get(key) ?? null;
                        if (endFormats.get(key) !== content || startAttrValue === value) {
                            // Either this format is overwritten or it is not necessary because the attribute already existed.
                            start.delete(transaction);
                            cleanups++;
                            if (!reachedCurr && (currAttributes.get(key) ?? null) === value && startAttrValue !== value) {
                                if (startAttrValue === null) currAttributes.delete(key);
                                else currAttributes.set(key, startAttrValue);
                            }
                        }
                        if (!reachedCurr && !start.deleted) $a852d2d5bb3d1ec6$var$updateCurrentAttributes(currAttributes, /** @type {ContentFormat} */ content);
                        break;
                    }
            }
        }
        start = /** @type {Item} */ start.right;
    }
    return cleanups;
};
/**
 * @param {Transaction} transaction
 * @param {Item | null} item
 */ const $a852d2d5bb3d1ec6$var$cleanupContextlessFormattingGap = (transaction, item)=>{
    // iterate until item.right is null or content
    while(item && item.right && (item.right.deleted || !item.right.countable))item = item.right;
    const attrs = new Set();
    // iterate back until a content item is found
    while(item && (item.deleted || !item.countable)){
        if (!item.deleted && item.content.constructor === $a852d2d5bb3d1ec6$export$3194899188fb5a88) {
            const key = /** @type {ContentFormat} */ item.content.key;
            if (attrs.has(key)) item.delete(transaction);
            else attrs.add(key);
        }
        item = item.left;
    }
};
/**
 * This function is experimental and subject to change / be removed.
 *
 * Ideally, we don't need this function at all. Formatting attributes should be cleaned up
 * automatically after each change. This function iterates twice over the complete YText type
 * and removes unnecessary formatting attributes. This is also helpful for testing.
 *
 * This function won't be exported anymore as soon as there is confidence that the YText type works as intended.
 *
 * @param {YText} type
 * @return {number} How many formatting attributes have been cleaned up.
 */ const $a852d2d5bb3d1ec6$export$5d9f53c13ebffb65 = (type)=>{
    let res = 0;
    $a852d2d5bb3d1ec6$export$dac1bad6146b2469(/** @type {Doc} */ type.doc, (transaction)=>{
        let start = /** @type {Item} */ type._start;
        let end = type._start;
        let startAttributes = $d1VR8.create();
        const currentAttributes = $d1VR8.copy(startAttributes);
        while(end){
            if (end.deleted === false) switch(end.content.constructor){
                case $a852d2d5bb3d1ec6$export$3194899188fb5a88:
                    $a852d2d5bb3d1ec6$var$updateCurrentAttributes(currentAttributes, /** @type {ContentFormat} */ end.content);
                    break;
                default:
                    res += $a852d2d5bb3d1ec6$var$cleanupFormattingGap(transaction, start, end, startAttributes, currentAttributes);
                    startAttributes = $d1VR8.copy(currentAttributes);
                    start = end;
                    break;
            }
            end = end.right;
        }
    });
    return res;
};
/**
 * This will be called by the transction once the event handlers are called to potentially cleanup
 * formatting attributes.
 *
 * @param {Transaction} transaction
 */ const $a852d2d5bb3d1ec6$var$cleanupYTextAfterTransaction = (transaction)=>{
    /**
   * @type {Set<YText>}
   */ const needFullCleanup = new Set();
    // check if another formatting item was inserted
    const doc = transaction.doc;
    for (const [client, afterClock] of transaction.afterState.entries()){
        const clock = transaction.beforeState.get(client) || 0;
        if (afterClock === clock) continue;
        $a852d2d5bb3d1ec6$var$iterateStructs(transaction, /** @type {Array<Item|GC>} */ doc.store.clients.get(client), clock, afterClock, (item)=>{
            if (!item.deleted && /** @type {Item} */ item.content.constructor === $a852d2d5bb3d1ec6$export$3194899188fb5a88 && item.constructor !== $a852d2d5bb3d1ec6$export$12d259ff017e6b58) needFullCleanup.add(/** @type {any} */ item.parent);
        });
    }
    // cleanup in a new transaction
    $a852d2d5bb3d1ec6$export$dac1bad6146b2469(doc, (t)=>{
        $a852d2d5bb3d1ec6$export$8afefebbaf4e4c78(transaction, transaction.deleteSet, (item)=>{
            if (item instanceof $a852d2d5bb3d1ec6$export$12d259ff017e6b58 || !/** @type {YText} */ item.parent._hasFormatting || needFullCleanup.has(/** @type {YText} */ item.parent)) return;
            const parent = /** @type {YText} */ item.parent;
            if (item.content.constructor === $a852d2d5bb3d1ec6$export$3194899188fb5a88) needFullCleanup.add(parent);
            else // If no formatting attribute was inserted or deleted, we can make due with contextless
            // formatting cleanups.
            // Contextless: it is not necessary to compute currentAttributes for the affected position.
            $a852d2d5bb3d1ec6$var$cleanupContextlessFormattingGap(t, item);
        });
        // If a formatting item was inserted, we simply clean the whole type.
        // We need to compute currentAttributes for the current position anyway.
        for (const yText of needFullCleanup)$a852d2d5bb3d1ec6$export$5d9f53c13ebffb65(yText);
    });
};
/**
 * @param {Transaction} transaction
 * @param {ItemTextListPosition} currPos
 * @param {number} length
 * @return {ItemTextListPosition}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$deleteText = (transaction, currPos, length)=>{
    const startLength = length;
    const startAttrs = $d1VR8.copy(currPos.currentAttributes);
    const start = currPos.right;
    while(length > 0 && currPos.right !== null){
        if (currPos.right.deleted === false) switch(currPos.right.content.constructor){
            case $a852d2d5bb3d1ec6$export$e2e108cbe2e4f865:
            case $a852d2d5bb3d1ec6$export$c3787ba7f6086664:
            case $a852d2d5bb3d1ec6$export$ee670b2cf091bbb6:
                if (length < currPos.right.length) $a852d2d5bb3d1ec6$var$getItemCleanStart(transaction, $a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(currPos.right.id.client, currPos.right.id.clock + length));
                length -= currPos.right.length;
                currPos.right.delete(transaction);
                break;
        }
        currPos.forward();
    }
    if (start) $a852d2d5bb3d1ec6$var$cleanupFormattingGap(transaction, start, currPos.right, startAttrs, currPos.currentAttributes);
    const parent = /** @type {AbstractType<any>} */ /** @type {Item} */ (currPos.left || currPos.right).parent;
    if (parent._searchMarker) $a852d2d5bb3d1ec6$var$updateMarkerChanges(parent._searchMarker, currPos.index, -startLength + length);
    return currPos;
};
/**
 * The Quill Delta format represents changes on a text document with
 * formatting information. For mor information visit {@link https://quilljs.com/docs/delta/|Quill Delta}
 *
 * @example
 *   {
 *     ops: [
 *       { insert: 'Gandalf', attributes: { bold: true } },
 *       { insert: ' the ' },
 *       { insert: 'Grey', attributes: { color: '#cccccc' } }
 *     ]
 *   }
 *
 */ /**
  * Attributes that can be assigned to a selection of text.
  *
  * @example
  *   {
  *     bold: true,
  *     font-size: '40px'
  *   }
  *
  * @typedef {Object} TextAttributes
  */ /**
 * @extends YEvent<YText>
 * Event that describes the changes on a YText type.
 */ class $a852d2d5bb3d1ec6$export$51155b8ebb74188a extends $a852d2d5bb3d1ec6$export$80fac438977fb51c {
    /**
   * @param {YText} ytext
   * @param {Transaction} transaction
   * @param {Set<any>} subs The keys that changed
   */ constructor(ytext, transaction, subs){
        super(ytext, transaction);
        /**
     * Whether the children changed.
     * @type {Boolean}
     * @private
     */ this.childListChanged = false;
        /**
     * Set of all changed attributes.
     * @type {Set<string>}
     */ this.keysChanged = new Set();
        subs.forEach((sub)=>{
            if (sub === null) this.childListChanged = true;
            else this.keysChanged.add(sub);
        });
    }
    /**
   * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string, delete?:number, retain?:number}>}}
   */ get changes() {
        if (this._changes === null) {
            /**
       * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string|AbstractType<any>|object, delete?:number, retain?:number}>}}
       */ const changes = {
                keys: this.keys,
                delta: this.delta,
                added: new Set(),
                deleted: new Set()
            };
            this._changes = changes;
        }
        return /** @type {any} */ this._changes;
    }
    /**
   * Compute the changes in the delta format.
   * A {@link https://quilljs.com/docs/delta/|Quill Delta}) that represents the changes on the document.
   *
   * @type {Array<{insert?:string|object|AbstractType<any>, delete?:number, retain?:number, attributes?: Object<string,any>}>}
   *
   * @public
   */ get delta() {
        if (this._delta === null) {
            const y = /** @type {Doc} */ this.target.doc;
            /**
       * @type {Array<{insert?:string|object|AbstractType<any>, delete?:number, retain?:number, attributes?: Object<string,any>}>}
       */ const delta = [];
            $a852d2d5bb3d1ec6$export$dac1bad6146b2469(y, (transaction)=>{
                const currentAttributes = new Map(); // saves all current attributes for insert
                const oldAttributes = new Map();
                let item = this.target._start;
                /**
         * @type {string?}
         */ let action = null;
                /**
         * @type {Object<string,any>}
         */ const attributes = {}; // counts added or removed new attributes for retain
                /**
         * @type {string|object}
         */ let insert = '';
                let retain = 0;
                let deleteLen = 0;
                const addOp = ()=>{
                    if (action !== null) {
                        /**
             * @type {any}
             */ let op = null;
                        switch(action){
                            case 'delete':
                                if (deleteLen > 0) op = {
                                    delete: deleteLen
                                };
                                deleteLen = 0;
                                break;
                            case 'insert':
                                if (typeof insert === 'object' || insert.length > 0) {
                                    op = {
                                        insert: insert
                                    };
                                    if (currentAttributes.size > 0) {
                                        op.attributes = {};
                                        currentAttributes.forEach((value, key)=>{
                                            if (value !== null) op.attributes[key] = value;
                                        });
                                    }
                                }
                                insert = '';
                                break;
                            case 'retain':
                                if (retain > 0) {
                                    op = {
                                        retain: retain
                                    };
                                    if (!$4m6H0.isEmpty(attributes)) op.attributes = $4m6H0.assign({}, attributes);
                                }
                                retain = 0;
                                break;
                        }
                        if (op) delta.push(op);
                        action = null;
                    }
                };
                while(item !== null){
                    switch(item.content.constructor){
                        case $a852d2d5bb3d1ec6$export$e2e108cbe2e4f865:
                        case $a852d2d5bb3d1ec6$export$c3787ba7f6086664:
                            if (this.adds(item)) {
                                if (!this.deletes(item)) {
                                    addOp();
                                    action = 'insert';
                                    insert = item.content.getContent()[0];
                                    addOp();
                                }
                            } else if (this.deletes(item)) {
                                if (action !== 'delete') {
                                    addOp();
                                    action = 'delete';
                                }
                                deleteLen += 1;
                            } else if (!item.deleted) {
                                if (action !== 'retain') {
                                    addOp();
                                    action = 'retain';
                                }
                                retain += 1;
                            }
                            break;
                        case $a852d2d5bb3d1ec6$export$ee670b2cf091bbb6:
                            if (this.adds(item)) {
                                if (!this.deletes(item)) {
                                    if (action !== 'insert') {
                                        addOp();
                                        action = 'insert';
                                    }
                                    insert += /** @type {ContentString} */ item.content.str;
                                }
                            } else if (this.deletes(item)) {
                                if (action !== 'delete') {
                                    addOp();
                                    action = 'delete';
                                }
                                deleteLen += item.length;
                            } else if (!item.deleted) {
                                if (action !== 'retain') {
                                    addOp();
                                    action = 'retain';
                                }
                                retain += item.length;
                            }
                            break;
                        case $a852d2d5bb3d1ec6$export$3194899188fb5a88:
                            {
                                const { key: key, value: value } = /** @type {ContentFormat} */ item.content;
                                if (this.adds(item)) {
                                    if (!this.deletes(item)) {
                                        const curVal = currentAttributes.get(key) ?? null;
                                        if (!$a852d2d5bb3d1ec6$var$equalAttrs(curVal, value)) {
                                            if (action === 'retain') addOp();
                                            if ($a852d2d5bb3d1ec6$var$equalAttrs(value, oldAttributes.get(key) ?? null)) delete attributes[key];
                                            else attributes[key] = value;
                                        } else if (value !== null) item.delete(transaction);
                                    }
                                } else if (this.deletes(item)) {
                                    oldAttributes.set(key, value);
                                    const curVal = currentAttributes.get(key) ?? null;
                                    if (!$a852d2d5bb3d1ec6$var$equalAttrs(curVal, value)) {
                                        if (action === 'retain') addOp();
                                        attributes[key] = curVal;
                                    }
                                } else if (!item.deleted) {
                                    oldAttributes.set(key, value);
                                    const attr = attributes[key];
                                    if (attr !== undefined) {
                                        if (!$a852d2d5bb3d1ec6$var$equalAttrs(attr, value)) {
                                            if (action === 'retain') addOp();
                                            if (value === null) delete attributes[key];
                                            else attributes[key] = value;
                                        } else if (attr !== null) item.delete(transaction);
                                    }
                                }
                                if (!item.deleted) {
                                    if (action === 'insert') addOp();
                                    $a852d2d5bb3d1ec6$var$updateCurrentAttributes(currentAttributes, /** @type {ContentFormat} */ item.content);
                                }
                                break;
                            }
                    }
                    item = item.right;
                }
                addOp();
                while(delta.length > 0){
                    const lastOp = delta[delta.length - 1];
                    if (lastOp.retain !== undefined && lastOp.attributes === undefined) // retain delta's if they don't assign attributes
                    delta.pop();
                    else break;
                }
            });
            this._delta = delta;
        }
        return /** @type {any} */ this._delta;
    }
}
/**
 * Type that represents text with formatting information.
 *
 * This type replaces y-richtext as this implementation is able to handle
 * block formats (format information on a paragraph), embeds (complex elements
 * like pictures and videos), and text formats (**bold**, *italic*).
 *
 * @extends AbstractType<YTextEvent>
 */ class $a852d2d5bb3d1ec6$export$5f1af8db9871e1d6 extends $a852d2d5bb3d1ec6$export$c265dc8338484497 {
    /**
   * @param {String} [string] The initial value of the YText.
   */ constructor(string){
        super();
        /**
     * Array of pending operations on this type
     * @type {Array<function():void>?}
     */ this._pending = string !== undefined ? [
            ()=>this.insert(0, string)
        ] : [];
        /**
     * @type {Array<ArraySearchMarker>|null}
     */ this._searchMarker = [];
        /**
     * Whether this YText contains formatting attributes.
     * This flag is updated when a formatting item is integrated (see ContentFormat.integrate)
     */ this._hasFormatting = false;
    }
    /**
   * Number of characters of this text type.
   *
   * @type {number}
   */ get length() {
        this.doc ?? $a852d2d5bb3d1ec6$var$warnPrematureAccess();
        return this._length;
    }
    /**
   * @param {Doc} y
   * @param {Item} item
   */ _integrate(y, item) {
        super._integrate(y, item);
        try {
            /** @type {Array<function>} */ this._pending.forEach((f)=>f());
        } catch (e) {
            console.error(e);
        }
        this._pending = null;
    }
    _copy() {
        return new $a852d2d5bb3d1ec6$export$5f1af8db9871e1d6();
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YText}
   */ clone() {
        const text = new $a852d2d5bb3d1ec6$export$5f1af8db9871e1d6();
        text.applyDelta(this.toDelta());
        return text;
    }
    /**
   * Creates YTextEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */ _callObserver(transaction, parentSubs) {
        super._callObserver(transaction, parentSubs);
        const event = new $a852d2d5bb3d1ec6$export$51155b8ebb74188a(this, transaction, parentSubs);
        $a852d2d5bb3d1ec6$var$callTypeObservers(this, transaction, event);
        // If a remote change happened, we try to cleanup potential formatting duplicates.
        if (!transaction.local && this._hasFormatting) transaction._needFormattingCleanup = true;
    }
    /**
   * Returns the unformatted string representation of this YText type.
   *
   * @public
   */ toString() {
        this.doc ?? $a852d2d5bb3d1ec6$var$warnPrematureAccess();
        let str = '';
        /**
     * @type {Item|null}
     */ let n = this._start;
        while(n !== null){
            if (!n.deleted && n.countable && n.content.constructor === $a852d2d5bb3d1ec6$export$ee670b2cf091bbb6) str += /** @type {ContentString} */ n.content.str;
            n = n.right;
        }
        return str;
    }
    /**
   * Returns the unformatted string representation of this YText type.
   *
   * @return {string}
   * @public
   */ toJSON() {
        return this.toString();
    }
    /**
   * Apply a {@link Delta} on this shared YText type.
   *
   * @param {any} delta The changes to apply on this element.
   * @param {object}  opts
   * @param {boolean} [opts.sanitize] Sanitize input delta. Removes ending newlines if set to true.
   *
   *
   * @public
   */ applyDelta(delta, { sanitize: sanitize = true } = {}) {
        if (this.doc !== null) $a852d2d5bb3d1ec6$export$dac1bad6146b2469(this.doc, (transaction)=>{
            const currPos = new $a852d2d5bb3d1ec6$var$ItemTextListPosition(null, this._start, 0, new Map());
            for(let i = 0; i < delta.length; i++){
                const op = delta[i];
                if (op.insert !== undefined) {
                    // Quill assumes that the content starts with an empty paragraph.
                    // Yjs/Y.Text assumes that it starts empty. We always hide that
                    // there is a newline at the end of the content.
                    // If we omit this step, clients will see a different number of
                    // paragraphs, but nothing bad will happen.
                    const ins = !sanitize && typeof op.insert === 'string' && i === delta.length - 1 && currPos.right === null && op.insert.slice(-1) === '\n' ? op.insert.slice(0, -1) : op.insert;
                    if (typeof ins !== 'string' || ins.length > 0) $a852d2d5bb3d1ec6$var$insertText(transaction, this, currPos, ins, op.attributes || {});
                } else if (op.retain !== undefined) $a852d2d5bb3d1ec6$var$formatText(transaction, this, currPos, op.retain, op.attributes || {});
                else if (op.delete !== undefined) $a852d2d5bb3d1ec6$var$deleteText(transaction, currPos, op.delete);
            }
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.applyDelta(delta));
    }
    /**
   * Returns the Delta representation of this YText type.
   *
   * @param {Snapshot} [snapshot]
   * @param {Snapshot} [prevSnapshot]
   * @param {function('removed' | 'added', ID):any} [computeYChange]
   * @return {any} The Delta representation of this type.
   *
   * @public
   */ toDelta(snapshot, prevSnapshot, computeYChange) {
        this.doc ?? $a852d2d5bb3d1ec6$var$warnPrematureAccess();
        /**
     * @type{Array<any>}
     */ const ops = [];
        const currentAttributes = new Map();
        const doc = /** @type {Doc} */ this.doc;
        let str = '';
        let n = this._start;
        function packStr() {
            if (str.length > 0) {
                // pack str with attributes to ops
                /**
         * @type {Object<string,any>}
         */ const attributes = {};
                let addAttributes = false;
                currentAttributes.forEach((value, key)=>{
                    addAttributes = true;
                    attributes[key] = value;
                });
                /**
         * @type {Object<string,any>}
         */ const op = {
                    insert: str
                };
                if (addAttributes) op.attributes = attributes;
                ops.push(op);
                str = '';
            }
        }
        const computeDelta = ()=>{
            while(n !== null){
                if ($a852d2d5bb3d1ec6$var$isVisible(n, snapshot) || prevSnapshot !== undefined && $a852d2d5bb3d1ec6$var$isVisible(n, prevSnapshot)) switch(n.content.constructor){
                    case $a852d2d5bb3d1ec6$export$ee670b2cf091bbb6:
                        {
                            const cur = currentAttributes.get('ychange');
                            if (snapshot !== undefined && !$a852d2d5bb3d1ec6$var$isVisible(n, snapshot)) {
                                if (cur === undefined || cur.user !== n.id.client || cur.type !== 'removed') {
                                    packStr();
                                    currentAttributes.set('ychange', computeYChange ? computeYChange('removed', n.id) : {
                                        type: 'removed'
                                    });
                                }
                            } else if (prevSnapshot !== undefined && !$a852d2d5bb3d1ec6$var$isVisible(n, prevSnapshot)) {
                                if (cur === undefined || cur.user !== n.id.client || cur.type !== 'added') {
                                    packStr();
                                    currentAttributes.set('ychange', computeYChange ? computeYChange('added', n.id) : {
                                        type: 'added'
                                    });
                                }
                            } else if (cur !== undefined) {
                                packStr();
                                currentAttributes.delete('ychange');
                            }
                            str += /** @type {ContentString} */ n.content.str;
                            break;
                        }
                    case $a852d2d5bb3d1ec6$export$e2e108cbe2e4f865:
                    case $a852d2d5bb3d1ec6$export$c3787ba7f6086664:
                        {
                            packStr();
                            /**
               * @type {Object<string,any>}
               */ const op = {
                                insert: n.content.getContent()[0]
                            };
                            if (currentAttributes.size > 0) {
                                const attrs = /** @type {Object<string,any>} */ {};
                                op.attributes = attrs;
                                currentAttributes.forEach((value, key)=>{
                                    attrs[key] = value;
                                });
                            }
                            ops.push(op);
                            break;
                        }
                    case $a852d2d5bb3d1ec6$export$3194899188fb5a88:
                        if ($a852d2d5bb3d1ec6$var$isVisible(n, snapshot)) {
                            packStr();
                            $a852d2d5bb3d1ec6$var$updateCurrentAttributes(currentAttributes, /** @type {ContentFormat} */ n.content);
                        }
                        break;
                }
                n = n.right;
            }
            packStr();
        };
        if (snapshot || prevSnapshot) // snapshots are merged again after the transaction, so we need to keep the
        // transaction alive until we are done
        $a852d2d5bb3d1ec6$export$dac1bad6146b2469(doc, (transaction)=>{
            if (snapshot) $a852d2d5bb3d1ec6$var$splitSnapshotAffectedStructs(transaction, snapshot);
            if (prevSnapshot) $a852d2d5bb3d1ec6$var$splitSnapshotAffectedStructs(transaction, prevSnapshot);
            computeDelta();
        }, 'cleanup');
        else computeDelta();
        return ops;
    }
    /**
   * Insert text at a given index.
   *
   * @param {number} index The index at which to start inserting.
   * @param {String} text The text to insert at the specified position.
   * @param {TextAttributes} [attributes] Optionally define some formatting
   *                                    information to apply on the inserted
   *                                    Text.
   * @public
   */ insert(index, text, attributes) {
        if (text.length <= 0) return;
        const y = this.doc;
        if (y !== null) $a852d2d5bb3d1ec6$export$dac1bad6146b2469(y, (transaction)=>{
            const pos = $a852d2d5bb3d1ec6$var$findPosition(transaction, this, index, !attributes);
            if (!attributes) {
                attributes = {};
                // @ts-ignore
                pos.currentAttributes.forEach((v, k)=>{
                    attributes[k] = v;
                });
            }
            $a852d2d5bb3d1ec6$var$insertText(transaction, this, pos, text, attributes);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.insert(index, text, attributes));
    }
    /**
   * Inserts an embed at a index.
   *
   * @param {number} index The index to insert the embed at.
   * @param {Object | AbstractType<any>} embed The Object that represents the embed.
   * @param {TextAttributes} [attributes] Attribute information to apply on the
   *                                    embed
   *
   * @public
   */ insertEmbed(index, embed, attributes) {
        const y = this.doc;
        if (y !== null) $a852d2d5bb3d1ec6$export$dac1bad6146b2469(y, (transaction)=>{
            const pos = $a852d2d5bb3d1ec6$var$findPosition(transaction, this, index, !attributes);
            $a852d2d5bb3d1ec6$var$insertText(transaction, this, pos, embed, attributes || {});
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.insertEmbed(index, embed, attributes || {}));
    }
    /**
   * Deletes text starting from an index.
   *
   * @param {number} index Index at which to start deleting.
   * @param {number} length The number of characters to remove. Defaults to 1.
   *
   * @public
   */ delete(index, length) {
        if (length === 0) return;
        const y = this.doc;
        if (y !== null) $a852d2d5bb3d1ec6$export$dac1bad6146b2469(y, (transaction)=>{
            $a852d2d5bb3d1ec6$var$deleteText(transaction, $a852d2d5bb3d1ec6$var$findPosition(transaction, this, index, true), length);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.delete(index, length));
    }
    /**
   * Assigns properties to a range of text.
   *
   * @param {number} index The position where to start formatting.
   * @param {number} length The amount of characters to assign properties to.
   * @param {TextAttributes} attributes Attribute information to apply on the
   *                                    text.
   *
   * @public
   */ format(index, length, attributes) {
        if (length === 0) return;
        const y = this.doc;
        if (y !== null) $a852d2d5bb3d1ec6$export$dac1bad6146b2469(y, (transaction)=>{
            const pos = $a852d2d5bb3d1ec6$var$findPosition(transaction, this, index, false);
            if (pos.right === null) return;
            $a852d2d5bb3d1ec6$var$formatText(transaction, this, pos, length, attributes);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.format(index, length, attributes));
    }
    /**
   * Removes an attribute.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that is to be removed.
   *
   * @public
   */ removeAttribute(attributeName) {
        if (this.doc !== null) $a852d2d5bb3d1ec6$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $a852d2d5bb3d1ec6$var$typeMapDelete(transaction, this, attributeName);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.removeAttribute(attributeName));
    }
    /**
   * Sets or updates an attribute.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that is to be set.
   * @param {any} attributeValue The attribute value that is to be set.
   *
   * @public
   */ setAttribute(attributeName, attributeValue) {
        if (this.doc !== null) $a852d2d5bb3d1ec6$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $a852d2d5bb3d1ec6$var$typeMapSet(transaction, this, attributeName, attributeValue);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.setAttribute(attributeName, attributeValue));
    }
    /**
   * Returns an attribute value that belongs to the attribute name.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that identifies the
   *                               queried value.
   * @return {any} The queried attribute value.
   *
   * @public
   */ getAttribute(attributeName) {
        return /** @type {any} */ $a852d2d5bb3d1ec6$var$typeMapGet(this, attributeName);
    }
    /**
   * Returns all attribute name/value pairs in a JSON Object.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @return {Object<string, any>} A JSON Object that describes the attributes.
   *
   * @public
   */ getAttributes() {
        return $a852d2d5bb3d1ec6$var$typeMapGetAll(this);
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ _write(encoder) {
        encoder.writeTypeRef($a852d2d5bb3d1ec6$var$YTextRefID);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} _decoder
 * @return {YText}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$readYText = (_decoder)=>new $a852d2d5bb3d1ec6$export$5f1af8db9871e1d6();
/**
 * @module YXml
 */ /**
 * Define the elements to which a set of CSS queries apply.
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Selectors|CSS_Selectors}
 *
 * @example
 *   query = '.classSelector'
 *   query = 'nodeSelector'
 *   query = '#idSelector'
 *
 * @typedef {string} CSS_Selector
 */ /**
 * Dom filter function.
 *
 * @callback domFilter
 * @param {string} nodeName The nodeName of the element
 * @param {Map} attributes The map of attributes.
 * @return {boolean} Whether to include the Dom node in the YXmlElement.
 */ /**
 * Represents a subset of the nodes of a YXmlElement / YXmlFragment and a
 * position within them.
 *
 * Can be created with {@link YXmlFragment#createTreeWalker}
 *
 * @public
 * @implements {Iterable<YXmlElement|YXmlText|YXmlElement|YXmlHook>}
 */ class $a852d2d5bb3d1ec6$var$YXmlTreeWalker {
    /**
   * @param {YXmlFragment | YXmlElement} root
   * @param {function(AbstractType<any>):boolean} [f]
   */ constructor(root, f = ()=>true){
        this._filter = f;
        this._root = root;
        /**
     * @type {Item}
     */ this._currentNode = /** @type {Item} */ root._start;
        this._firstCall = true;
        root.doc ?? $a852d2d5bb3d1ec6$var$warnPrematureAccess();
    }
    [Symbol.iterator]() {
        return this;
    }
    /**
   * Get the next node.
   *
   * @return {IteratorResult<YXmlElement|YXmlText|YXmlHook>} The next node.
   *
   * @public
   */ next() {
        /**
     * @type {Item|null}
     */ let n = this._currentNode;
        let type = n && n.content && /** @type {any} */ n.content.type;
        if (n !== null && (!this._firstCall || n.deleted || !this._filter(type))) do {
            type = /** @type {any} */ n.content.type;
            if (!n.deleted && (type.constructor === $a852d2d5bb3d1ec6$export$4db87581d3ca170d || type.constructor === $a852d2d5bb3d1ec6$export$d5ce8c3e1731f1a7) && type._start !== null) // walk down in the tree
            n = type._start;
            else // walk right or up in the tree
            while(n !== null){
                if (n.right !== null) {
                    n = n.right;
                    break;
                } else if (n.parent === this._root) n = null;
                else n = /** @type {AbstractType<any>} */ n.parent._item;
            }
        }while (n !== null && (n.deleted || !this._filter(/** @type {ContentType} */ n.content.type)));
        this._firstCall = false;
        if (n === null) // @ts-ignore
        return {
            value: undefined,
            done: true
        };
        this._currentNode = n;
        return {
            value: /** @type {any} */ n.content.type,
            done: false
        };
    }
}
/**
 * Represents a list of {@link YXmlElement}.and {@link YXmlText} types.
 * A YxmlFragment is similar to a {@link YXmlElement}, but it does not have a
 * nodeName and it does not have attributes. Though it can be bound to a DOM
 * element - in this case the attributes and the nodeName are not shared.
 *
 * @public
 * @extends AbstractType<YXmlEvent>
 */ class $a852d2d5bb3d1ec6$export$d5ce8c3e1731f1a7 extends $a852d2d5bb3d1ec6$export$c265dc8338484497 {
    constructor(){
        super();
        /**
     * @type {Array<any>|null}
     */ this._prelimContent = [];
    }
    /**
   * @type {YXmlElement|YXmlText|null}
   */ get firstChild() {
        const first = this._first;
        return first ? first.content.getContent()[0] : null;
    }
    /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */ _integrate(y, item) {
        super._integrate(y, item);
        this.insert(0, /** @type {Array<any>} */ this._prelimContent);
        this._prelimContent = null;
    }
    _copy() {
        return new $a852d2d5bb3d1ec6$export$d5ce8c3e1731f1a7();
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlFragment}
   */ clone() {
        const el = new $a852d2d5bb3d1ec6$export$d5ce8c3e1731f1a7();
        // @ts-ignore
        el.insert(0, this.toArray().map((item)=>item instanceof $a852d2d5bb3d1ec6$export$c265dc8338484497 ? item.clone() : item));
        return el;
    }
    get length() {
        this.doc ?? $a852d2d5bb3d1ec6$var$warnPrematureAccess();
        return this._prelimContent === null ? this._length : this._prelimContent.length;
    }
    /**
   * Create a subtree of childNodes.
   *
   * @example
   * const walker = elem.createTreeWalker(dom => dom.nodeName === 'div')
   * for (let node in walker) {
   *   // `node` is a div node
   *   nop(node)
   * }
   *
   * @param {function(AbstractType<any>):boolean} filter Function that is called on each child element and
   *                          returns a Boolean indicating whether the child
   *                          is to be included in the subtree.
   * @return {YXmlTreeWalker} A subtree and a position within it.
   *
   * @public
   */ createTreeWalker(filter) {
        return new $a852d2d5bb3d1ec6$var$YXmlTreeWalker(this, filter);
    }
    /**
   * Returns the first YXmlElement that matches the query.
   * Similar to DOM's {@link querySelector}.
   *
   * Query support:
   *   - tagname
   * TODO:
   *   - id
   *   - attribute
   *
   * @param {CSS_Selector} query The query on the children.
   * @return {YXmlElement|YXmlText|YXmlHook|null} The first element that matches the query or null.
   *
   * @public
   */ querySelector(query) {
        query = query.toUpperCase();
        // @ts-ignore
        const iterator = new $a852d2d5bb3d1ec6$var$YXmlTreeWalker(this, (element)=>element.nodeName && element.nodeName.toUpperCase() === query);
        const next = iterator.next();
        if (next.done) return null;
        else return next.value;
    }
    /**
   * Returns all YXmlElements that match the query.
   * Similar to Dom's {@link querySelectorAll}.
   *
   * @todo Does not yet support all queries. Currently only query by tagName.
   *
   * @param {CSS_Selector} query The query on the children
   * @return {Array<YXmlElement|YXmlText|YXmlHook|null>} The elements that match this query.
   *
   * @public
   */ querySelectorAll(query) {
        query = query.toUpperCase();
        // @ts-ignore
        return $dWqHQ.from(new $a852d2d5bb3d1ec6$var$YXmlTreeWalker(this, (element)=>element.nodeName && element.nodeName.toUpperCase() === query));
    }
    /**
   * Creates YXmlEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */ _callObserver(transaction, parentSubs) {
        $a852d2d5bb3d1ec6$var$callTypeObservers(this, transaction, new $a852d2d5bb3d1ec6$export$88c9145a0c3b556c(this, parentSubs, transaction));
    }
    /**
   * Get the string representation of all the children of this YXmlFragment.
   *
   * @return {string} The string representation of all children.
   */ toString() {
        return $a852d2d5bb3d1ec6$var$typeListMap(this, (xml)=>xml.toString()).join('');
    }
    /**
   * @return {string}
   */ toJSON() {
        return this.toString();
    }
    /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks={}] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Node} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */ toDOM(_document = document, hooks = {}, binding) {
        const fragment = _document.createDocumentFragment();
        if (binding !== undefined) binding._createAssociation(fragment, this);
        $a852d2d5bb3d1ec6$var$typeListForEach(this, (xmlType)=>{
            fragment.insertBefore(xmlType.toDOM(_document, hooks, binding), null);
        });
        return fragment;
    }
    /**
   * Inserts new content at an index.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  xml.insert(0, [new Y.XmlText('text')])
   *
   * @param {number} index The index to insert content at
   * @param {Array<YXmlElement|YXmlText>} content The array of content
   */ insert(index, content) {
        if (this.doc !== null) $a852d2d5bb3d1ec6$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $a852d2d5bb3d1ec6$var$typeListInsertGenerics(transaction, this, index, content);
        });
        else // @ts-ignore _prelimContent is defined because this is not yet integrated
        this._prelimContent.splice(index, 0, ...content);
    }
    /**
   * Inserts new content at an index.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  xml.insert(0, [new Y.XmlText('text')])
   *
   * @param {null|Item|YXmlElement|YXmlText} ref The index to insert content at
   * @param {Array<YXmlElement|YXmlText>} content The array of content
   */ insertAfter(ref, content) {
        if (this.doc !== null) $a852d2d5bb3d1ec6$export$dac1bad6146b2469(this.doc, (transaction)=>{
            const refItem = ref && ref instanceof $a852d2d5bb3d1ec6$export$c265dc8338484497 ? ref._item : ref;
            $a852d2d5bb3d1ec6$var$typeListInsertGenericsAfter(transaction, this, refItem, content);
        });
        else {
            const pc = /** @type {Array<any>} */ this._prelimContent;
            const index = ref === null ? 0 : pc.findIndex((el)=>el === ref) + 1;
            if (index === 0 && ref !== null) throw $gFLjS.create('Reference item not found');
            pc.splice(index, 0, ...content);
        }
    }
    /**
   * Deletes elements starting from an index.
   *
   * @param {number} index Index at which to start deleting elements
   * @param {number} [length=1] The number of elements to remove. Defaults to 1.
   */ delete(index, length = 1) {
        if (this.doc !== null) $a852d2d5bb3d1ec6$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $a852d2d5bb3d1ec6$var$typeListDelete(transaction, this, index, length);
        });
        else // @ts-ignore _prelimContent is defined because this is not yet integrated
        this._prelimContent.splice(index, length);
    }
    /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @return {Array<YXmlElement|YXmlText|YXmlHook>}
   */ toArray() {
        return $a852d2d5bb3d1ec6$var$typeListToArray(this);
    }
    /**
   * Appends content to this YArray.
   *
   * @param {Array<YXmlElement|YXmlText>} content Array of content to append.
   */ push(content) {
        this.insert(this.length, content);
    }
    /**
   * Prepends content to this YArray.
   *
   * @param {Array<YXmlElement|YXmlText>} content Array of content to prepend.
   */ unshift(content) {
        this.insert(0, content);
    }
    /**
   * Returns the i-th element from a YArray.
   *
   * @param {number} index The index of the element to return from the YArray
   * @return {YXmlElement|YXmlText}
   */ get(index) {
        return $a852d2d5bb3d1ec6$var$typeListGet(this, index);
    }
    /**
   * Returns a portion of this YXmlFragment into a JavaScript Array selected
   * from start to end (end not included).
   *
   * @param {number} [start]
   * @param {number} [end]
   * @return {Array<YXmlElement|YXmlText>}
   */ slice(start = 0, end = this.length) {
        return $a852d2d5bb3d1ec6$var$typeListSlice(this, start, end);
    }
    /**
   * Executes a provided function on once on every child element.
   *
   * @param {function(YXmlElement|YXmlText,number, typeof self):void} f A function to execute on every element of this YArray.
   */ forEach(f) {
        $a852d2d5bb3d1ec6$var$typeListForEach(this, f);
    }
    /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */ _write(encoder) {
        encoder.writeTypeRef($a852d2d5bb3d1ec6$var$YXmlFragmentRefID);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} _decoder
 * @return {YXmlFragment}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$readYXmlFragment = (_decoder)=>new $a852d2d5bb3d1ec6$export$d5ce8c3e1731f1a7();
/**
 * @typedef {Object|number|null|Array<any>|string|Uint8Array|AbstractType<any>} ValueTypes
 */ /**
 * An YXmlElement imitates the behavior of a
 * https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element
 *
 * * An YXmlElement has attributes (key value pairs)
 * * An YXmlElement has childElements that must inherit from YXmlElement
 *
 * @template {{ [key: string]: ValueTypes }} [KV={ [key: string]: string }]
 */ class $a852d2d5bb3d1ec6$export$4db87581d3ca170d extends $a852d2d5bb3d1ec6$export$d5ce8c3e1731f1a7 {
    constructor(nodeName = 'UNDEFINED'){
        super();
        this.nodeName = nodeName;
        /**
     * @type {Map<string, any>|null}
     */ this._prelimAttrs = new Map();
    }
    /**
   * @type {YXmlElement|YXmlText|null}
   */ get nextSibling() {
        const n = this._item ? this._item.next : null;
        return n ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n.content.type : null;
    }
    /**
   * @type {YXmlElement|YXmlText|null}
   */ get prevSibling() {
        const n = this._item ? this._item.prev : null;
        return n ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n.content.type : null;
    }
    /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */ _integrate(y, item) {
        super._integrate(y, item);
        /** @type {Map<string, any>} */ this._prelimAttrs.forEach((value, key)=>{
            this.setAttribute(key, value);
        });
        this._prelimAttrs = null;
    }
    /**
   * Creates an Item with the same effect as this Item (without position effect)
   *
   * @return {YXmlElement}
   */ _copy() {
        return new $a852d2d5bb3d1ec6$export$4db87581d3ca170d(this.nodeName);
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlElement<KV>}
   */ clone() {
        /**
     * @type {YXmlElement<KV>}
     */ const el = new $a852d2d5bb3d1ec6$export$4db87581d3ca170d(this.nodeName);
        const attrs = this.getAttributes();
        $4m6H0.forEach(attrs, (value, key)=>{
            if (typeof value === 'string') el.setAttribute(key, value);
        });
        // @ts-ignore
        el.insert(0, this.toArray().map((item)=>item instanceof $a852d2d5bb3d1ec6$export$c265dc8338484497 ? item.clone() : item));
        return el;
    }
    /**
   * Returns the XML serialization of this YXmlElement.
   * The attributes are ordered by attribute-name, so you can easily use this
   * method to compare YXmlElements
   *
   * @return {string} The string representation of this type.
   *
   * @public
   */ toString() {
        const attrs = this.getAttributes();
        const stringBuilder = [];
        const keys = [];
        for(const key in attrs)keys.push(key);
        keys.sort();
        const keysLen = keys.length;
        for(let i = 0; i < keysLen; i++){
            const key = keys[i];
            stringBuilder.push(key + '="' + attrs[key] + '"');
        }
        const nodeName = this.nodeName.toLocaleLowerCase();
        const attrsString = stringBuilder.length > 0 ? ' ' + stringBuilder.join(' ') : '';
        return `<${nodeName}${attrsString}>${super.toString()}</${nodeName}>`;
    }
    /**
   * Removes an attribute from this YXmlElement.
   *
   * @param {string} attributeName The attribute name that is to be removed.
   *
   * @public
   */ removeAttribute(attributeName) {
        if (this.doc !== null) $a852d2d5bb3d1ec6$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $a852d2d5bb3d1ec6$var$typeMapDelete(transaction, this, attributeName);
        });
        else /** @type {Map<string,any>} */ this._prelimAttrs.delete(attributeName);
    }
    /**
   * Sets or updates an attribute.
   *
   * @template {keyof KV & string} KEY
   *
   * @param {KEY} attributeName The attribute name that is to be set.
   * @param {KV[KEY]} attributeValue The attribute value that is to be set.
   *
   * @public
   */ setAttribute(attributeName, attributeValue) {
        if (this.doc !== null) $a852d2d5bb3d1ec6$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $a852d2d5bb3d1ec6$var$typeMapSet(transaction, this, attributeName, attributeValue);
        });
        else /** @type {Map<string, any>} */ this._prelimAttrs.set(attributeName, attributeValue);
    }
    /**
   * Returns an attribute value that belongs to the attribute name.
   *
   * @template {keyof KV & string} KEY
   *
   * @param {KEY} attributeName The attribute name that identifies the
   *                               queried value.
   * @return {KV[KEY]|undefined} The queried attribute value.
   *
   * @public
   */ getAttribute(attributeName) {
        return /** @type {any} */ $a852d2d5bb3d1ec6$var$typeMapGet(this, attributeName);
    }
    /**
   * Returns whether an attribute exists
   *
   * @param {string} attributeName The attribute name to check for existence.
   * @return {boolean} whether the attribute exists.
   *
   * @public
   */ hasAttribute(attributeName) {
        return /** @type {any} */ $a852d2d5bb3d1ec6$var$typeMapHas(this, attributeName);
    }
    /**
   * Returns all attribute name/value pairs in a JSON Object.
   *
   * @param {Snapshot} [snapshot]
   * @return {{ [Key in Extract<keyof KV,string>]?: KV[Key]}} A JSON Object that describes the attributes.
   *
   * @public
   */ getAttributes(snapshot) {
        return /** @type {any} */ snapshot ? $a852d2d5bb3d1ec6$export$7769bdedaef2c91b(this, snapshot) : $a852d2d5bb3d1ec6$var$typeMapGetAll(this);
    }
    /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks={}] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Node} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */ toDOM(_document = document, hooks = {}, binding) {
        const dom = _document.createElement(this.nodeName);
        const attrs = this.getAttributes();
        for(const key in attrs){
            const value = attrs[key];
            if (typeof value === 'string') dom.setAttribute(key, value);
        }
        $a852d2d5bb3d1ec6$var$typeListForEach(this, (yxml)=>{
            dom.appendChild(yxml.toDOM(_document, hooks, binding));
        });
        if (binding !== undefined) binding._createAssociation(dom, this);
        return dom;
    }
    /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */ _write(encoder) {
        encoder.writeTypeRef($a852d2d5bb3d1ec6$var$YXmlElementRefID);
        encoder.writeKey(this.nodeName);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YXmlElement}
 *
 * @function
 */ const $a852d2d5bb3d1ec6$var$readYXmlElement = (decoder)=>new $a852d2d5bb3d1ec6$export$4db87581d3ca170d(decoder.readKey());
/**
 * @extends YEvent<YXmlElement|YXmlText|YXmlFragment>
 * An Event that describes changes on a YXml Element or Yxml Fragment
 */ class $a852d2d5bb3d1ec6$export$88c9145a0c3b556c extends $a852d2d5bb3d1ec6$export$80fac438977fb51c {
    /**
   * @param {YXmlElement|YXmlText|YXmlFragment} target The target on which the event is created.
   * @param {Set<string|null>} subs The set of changed attributes. `null` is included if the
   *                   child list changed.
   * @param {Transaction} transaction The transaction instance with wich the
   *                                  change was created.
   */ constructor(target, subs, transaction){
        super(target, transaction);
        /**
     * Whether the children changed.
     * @type {Boolean}
     * @private
     */ this.childListChanged = false;
        /**
     * Set of all changed attributes.
     * @type {Set<string>}
     */ this.attributesChanged = new Set();
        subs.forEach((sub)=>{
            if (sub === null) this.childListChanged = true;
            else this.attributesChanged.add(sub);
        });
    }
}
/**
 * You can manage binding to a custom type with YXmlHook.
 *
 * @extends {YMap<any>}
 */ class $a852d2d5bb3d1ec6$export$ec64c1dd5e7a264 extends $a852d2d5bb3d1ec6$export$a5c7b93649eaf8f8 {
    /**
   * @param {string} hookName nodeName of the Dom Node.
   */ constructor(hookName){
        super();
        /**
     * @type {string}
     */ this.hookName = hookName;
    }
    /**
   * Creates an Item with the same effect as this Item (without position effect)
   */ _copy() {
        return new $a852d2d5bb3d1ec6$export$ec64c1dd5e7a264(this.hookName);
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlHook}
   */ clone() {
        const el = new $a852d2d5bb3d1ec6$export$ec64c1dd5e7a264(this.hookName);
        this.forEach((value, key)=>{
            el.set(key, value);
        });
        return el;
    }
    /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object.<string, any>} [hooks] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type
   * @return {Element} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */ toDOM(_document = document, hooks = {}, binding) {
        const hook = hooks[this.hookName];
        let dom;
        if (hook !== undefined) dom = hook.createDom(this);
        else dom = document.createElement(this.hookName);
        dom.setAttribute('data-yjs-hook', this.hookName);
        if (binding !== undefined) binding._createAssociation(dom, this);
        return dom;
    }
    /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */ _write(encoder) {
        encoder.writeTypeRef($a852d2d5bb3d1ec6$var$YXmlHookRefID);
        encoder.writeKey(this.hookName);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YXmlHook}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$readYXmlHook = (decoder)=>new $a852d2d5bb3d1ec6$export$ec64c1dd5e7a264(decoder.readKey());
/**
 * Represents text in a Dom Element. In the future this type will also handle
 * simple formatting information like bold and italic.
 */ class $a852d2d5bb3d1ec6$export$b35b8f45887823df extends $a852d2d5bb3d1ec6$export$5f1af8db9871e1d6 {
    /**
   * @type {YXmlElement|YXmlText|null}
   */ get nextSibling() {
        const n = this._item ? this._item.next : null;
        return n ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n.content.type : null;
    }
    /**
   * @type {YXmlElement|YXmlText|null}
   */ get prevSibling() {
        const n = this._item ? this._item.prev : null;
        return n ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n.content.type : null;
    }
    _copy() {
        return new $a852d2d5bb3d1ec6$export$b35b8f45887823df();
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlText}
   */ clone() {
        const text = new $a852d2d5bb3d1ec6$export$b35b8f45887823df();
        text.applyDelta(this.toDelta());
        return text;
    }
    /**
   * Creates a Dom Element that mirrors this YXmlText.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Text} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */ toDOM(_document = document, hooks, binding) {
        const dom = _document.createTextNode(this.toString());
        if (binding !== undefined) binding._createAssociation(dom, this);
        return dom;
    }
    toString() {
        // @ts-ignore
        return this.toDelta().map((delta)=>{
            const nestedNodes = [];
            for(const nodeName in delta.attributes){
                const attrs = [];
                for(const key in delta.attributes[nodeName])attrs.push({
                    key: key,
                    value: delta.attributes[nodeName][key]
                });
                // sort attributes to get a unique order
                attrs.sort((a, b)=>a.key < b.key ? -1 : 1);
                nestedNodes.push({
                    nodeName: nodeName,
                    attrs: attrs
                });
            }
            // sort node order to get a unique order
            nestedNodes.sort((a, b)=>a.nodeName < b.nodeName ? -1 : 1);
            // now convert to dom string
            let str = '';
            for(let i = 0; i < nestedNodes.length; i++){
                const node = nestedNodes[i];
                str += `<${node.nodeName}`;
                for(let j = 0; j < node.attrs.length; j++){
                    const attr = node.attrs[j];
                    str += ` ${attr.key}="${attr.value}"`;
                }
                str += '>';
            }
            str += delta.insert;
            for(let i = nestedNodes.length - 1; i >= 0; i--)str += `</${nestedNodes[i].nodeName}>`;
            return str;
        }).join('');
    }
    /**
   * @return {string}
   */ toJSON() {
        return this.toString();
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ _write(encoder) {
        encoder.writeTypeRef($a852d2d5bb3d1ec6$var$YXmlTextRefID);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YXmlText}
 *
 * @private
 * @function
 */ const $a852d2d5bb3d1ec6$var$readYXmlText = (decoder)=>new $a852d2d5bb3d1ec6$export$b35b8f45887823df();
class $a852d2d5bb3d1ec6$export$3cf6f9765c5c3196 {
    /**
   * @param {ID} id
   * @param {number} length
   */ constructor(id, length){
        this.id = id;
        this.length = length;
    }
    /**
   * @type {boolean}
   */ get deleted() {
        throw $gFLjS.methodUnimplemented();
    }
    /**
   * Merge this struct with the item to the right.
   * This method is already assuming that `this.id.clock + this.length === this.id.clock`.
   * Also this method does *not* remove right from StructStore!
   * @param {AbstractStruct} right
   * @return {boolean} wether this merged with right
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   * @param {number} offset
   * @param {number} encodingRef
   */ write(encoder, offset, encodingRef) {
        throw $gFLjS.methodUnimplemented();
    }
    /**
   * @param {Transaction} transaction
   * @param {number} offset
   */ integrate(transaction, offset) {
        throw $gFLjS.methodUnimplemented();
    }
}
const $a852d2d5bb3d1ec6$var$structGCRefNumber = 0;
/**
 * @private
 */ class $a852d2d5bb3d1ec6$export$12d259ff017e6b58 extends $a852d2d5bb3d1ec6$export$3cf6f9765c5c3196 {
    get deleted() {
        return true;
    }
    delete() {}
    /**
   * @param {GC} right
   * @return {boolean}
   */ mergeWith(right) {
        if (this.constructor !== right.constructor) return false;
        this.length += right.length;
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {number} offset
   */ integrate(transaction, offset) {
        if (offset > 0) {
            this.id.clock += offset;
            this.length -= offset;
        }
        $a852d2d5bb3d1ec6$var$addStruct(transaction.doc.store, this);
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeInfo($a852d2d5bb3d1ec6$var$structGCRefNumber);
        encoder.writeLen(this.length - offset);
    }
    /**
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */ getMissing(transaction, store) {
        return null;
    }
}
class $a852d2d5bb3d1ec6$export$e8d530cdf62d1cbd {
    /**
   * @param {Uint8Array} content
   */ constructor(content){
        this.content = content;
    }
    /**
   * @return {number}
   */ getLength() {
        return 1;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [
            this.content
        ];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentBinary}
   */ copy() {
        return new $a852d2d5bb3d1ec6$export$e8d530cdf62d1cbd(this.content);
    }
    /**
   * @param {number} offset
   * @return {ContentBinary}
   */ splice(offset) {
        throw $gFLjS.methodUnimplemented();
    }
    /**
   * @param {ContentBinary} right
   * @return {boolean}
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {}
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeBuf(this.content);
    }
    /**
   * @return {number}
   */ getRef() {
        return 3;
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2 } decoder
 * @return {ContentBinary}
 */ const $a852d2d5bb3d1ec6$var$readContentBinary = (decoder)=>new $a852d2d5bb3d1ec6$export$e8d530cdf62d1cbd(decoder.readBuf());
class $a852d2d5bb3d1ec6$export$3b06e0b3a2ece602 {
    /**
   * @param {number} len
   */ constructor(len){
        this.len = len;
    }
    /**
   * @return {number}
   */ getLength() {
        return this.len;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return false;
    }
    /**
   * @return {ContentDeleted}
   */ copy() {
        return new $a852d2d5bb3d1ec6$export$3b06e0b3a2ece602(this.len);
    }
    /**
   * @param {number} offset
   * @return {ContentDeleted}
   */ splice(offset) {
        const right = new $a852d2d5bb3d1ec6$export$3b06e0b3a2ece602(this.len - offset);
        this.len = offset;
        return right;
    }
    /**
   * @param {ContentDeleted} right
   * @return {boolean}
   */ mergeWith(right) {
        this.len += right.len;
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {
        $a852d2d5bb3d1ec6$var$addToDeleteSet(transaction.deleteSet, item.id.client, item.id.clock, this.len);
        item.markDeleted();
    }
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeLen(this.len - offset);
    }
    /**
   * @return {number}
   */ getRef() {
        return 1;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2 } decoder
 * @return {ContentDeleted}
 */ const $a852d2d5bb3d1ec6$var$readContentDeleted = (decoder)=>new $a852d2d5bb3d1ec6$export$3b06e0b3a2ece602(decoder.readLen());
/**
 * @param {string} guid
 * @param {Object<string, any>} opts
 */ const $a852d2d5bb3d1ec6$var$createDocFromOpts = (guid, opts)=>new $a852d2d5bb3d1ec6$export$bceacc74c2212615({
        guid: guid,
        ...opts,
        shouldLoad: opts.shouldLoad || opts.autoLoad || false
    });
/**
 * @private
 */ class $a852d2d5bb3d1ec6$export$b564c0e69572c0e {
    /**
   * @param {Doc} doc
   */ constructor(doc){
        if (doc._item) console.error('This document was already integrated as a sub-document. You should create a second instance instead with the same guid.');
        /**
     * @type {Doc}
     */ this.doc = doc;
        /**
     * @type {any}
     */ const opts = {};
        this.opts = opts;
        if (!doc.gc) opts.gc = false;
        if (doc.autoLoad) opts.autoLoad = true;
        if (doc.meta !== null) opts.meta = doc.meta;
    }
    /**
   * @return {number}
   */ getLength() {
        return 1;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [
            this.doc
        ];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentDoc}
   */ copy() {
        return new $a852d2d5bb3d1ec6$export$b564c0e69572c0e($a852d2d5bb3d1ec6$var$createDocFromOpts(this.doc.guid, this.opts));
    }
    /**
   * @param {number} offset
   * @return {ContentDoc}
   */ splice(offset) {
        throw $gFLjS.methodUnimplemented();
    }
    /**
   * @param {ContentDoc} right
   * @return {boolean}
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {
        // this needs to be reflected in doc.destroy as well
        this.doc._item = item;
        transaction.subdocsAdded.add(this.doc);
        if (this.doc.shouldLoad) transaction.subdocsLoaded.add(this.doc);
    }
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {
        if (transaction.subdocsAdded.has(this.doc)) transaction.subdocsAdded.delete(this.doc);
        else transaction.subdocsRemoved.add(this.doc);
    }
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeString(this.doc.guid);
        encoder.writeAny(this.opts);
    }
    /**
   * @return {number}
   */ getRef() {
        return 9;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentDoc}
 */ const $a852d2d5bb3d1ec6$var$readContentDoc = (decoder)=>new $a852d2d5bb3d1ec6$export$b564c0e69572c0e($a852d2d5bb3d1ec6$var$createDocFromOpts(decoder.readString(), decoder.readAny()));
/**
 * @private
 */ class $a852d2d5bb3d1ec6$export$c3787ba7f6086664 {
    /**
   * @param {Object} embed
   */ constructor(embed){
        this.embed = embed;
    }
    /**
   * @return {number}
   */ getLength() {
        return 1;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [
            this.embed
        ];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentEmbed}
   */ copy() {
        return new $a852d2d5bb3d1ec6$export$c3787ba7f6086664(this.embed);
    }
    /**
   * @param {number} offset
   * @return {ContentEmbed}
   */ splice(offset) {
        throw $gFLjS.methodUnimplemented();
    }
    /**
   * @param {ContentEmbed} right
   * @return {boolean}
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {}
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeJSON(this.embed);
    }
    /**
   * @return {number}
   */ getRef() {
        return 5;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentEmbed}
 */ const $a852d2d5bb3d1ec6$var$readContentEmbed = (decoder)=>new $a852d2d5bb3d1ec6$export$c3787ba7f6086664(decoder.readJSON());
/**
 * @private
 */ class $a852d2d5bb3d1ec6$export$3194899188fb5a88 {
    /**
   * @param {string} key
   * @param {Object} value
   */ constructor(key, value){
        this.key = key;
        this.value = value;
    }
    /**
   * @return {number}
   */ getLength() {
        return 1;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return false;
    }
    /**
   * @return {ContentFormat}
   */ copy() {
        return new $a852d2d5bb3d1ec6$export$3194899188fb5a88(this.key, this.value);
    }
    /**
   * @param {number} _offset
   * @return {ContentFormat}
   */ splice(_offset) {
        throw $gFLjS.methodUnimplemented();
    }
    /**
   * @param {ContentFormat} _right
   * @return {boolean}
   */ mergeWith(_right) {
        return false;
    }
    /**
   * @param {Transaction} _transaction
   * @param {Item} item
   */ integrate(_transaction, item) {
        // @todo searchmarker are currently unsupported for rich text documents
        const p = /** @type {YText} */ item.parent;
        p._searchMarker = null;
        p._hasFormatting = true;
    }
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeKey(this.key);
        encoder.writeJSON(this.value);
    }
    /**
   * @return {number}
   */ getRef() {
        return 6;
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentFormat}
 */ const $a852d2d5bb3d1ec6$var$readContentFormat = (decoder)=>new $a852d2d5bb3d1ec6$export$3194899188fb5a88(decoder.readKey(), decoder.readJSON());
/**
 * @private
 */ class $a852d2d5bb3d1ec6$export$6a907ea8f733ecf3 {
    /**
   * @param {Array<any>} arr
   */ constructor(arr){
        /**
     * @type {Array<any>}
     */ this.arr = arr;
    }
    /**
   * @return {number}
   */ getLength() {
        return this.arr.length;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return this.arr;
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentJSON}
   */ copy() {
        return new $a852d2d5bb3d1ec6$export$6a907ea8f733ecf3(this.arr);
    }
    /**
   * @param {number} offset
   * @return {ContentJSON}
   */ splice(offset) {
        const right = new $a852d2d5bb3d1ec6$export$6a907ea8f733ecf3(this.arr.slice(offset));
        this.arr = this.arr.slice(0, offset);
        return right;
    }
    /**
   * @param {ContentJSON} right
   * @return {boolean}
   */ mergeWith(right) {
        this.arr = this.arr.concat(right.arr);
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {}
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        const len = this.arr.length;
        encoder.writeLen(len - offset);
        for(let i = offset; i < len; i++){
            const c = this.arr[i];
            encoder.writeString(c === undefined ? 'undefined' : JSON.stringify(c));
        }
    }
    /**
   * @return {number}
   */ getRef() {
        return 2;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentJSON}
 */ const $a852d2d5bb3d1ec6$var$readContentJSON = (decoder)=>{
    const len = decoder.readLen();
    const cs = [];
    for(let i = 0; i < len; i++){
        const c = decoder.readString();
        if (c === 'undefined') cs.push(undefined);
        else cs.push(JSON.parse(c));
    }
    return new $a852d2d5bb3d1ec6$export$6a907ea8f733ecf3(cs);
};
const $a852d2d5bb3d1ec6$var$isDevMode = $kRoyo.getVariable('node_env') === 'development';
class $a852d2d5bb3d1ec6$export$1d788b93bbb631a0 {
    /**
   * @param {Array<any>} arr
   */ constructor(arr){
        /**
     * @type {Array<any>}
     */ this.arr = arr;
        $a852d2d5bb3d1ec6$var$isDevMode && $4m6H0.deepFreeze(arr);
    }
    /**
   * @return {number}
   */ getLength() {
        return this.arr.length;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return this.arr;
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentAny}
   */ copy() {
        return new $a852d2d5bb3d1ec6$export$1d788b93bbb631a0(this.arr);
    }
    /**
   * @param {number} offset
   * @return {ContentAny}
   */ splice(offset) {
        const right = new $a852d2d5bb3d1ec6$export$1d788b93bbb631a0(this.arr.slice(offset));
        this.arr = this.arr.slice(0, offset);
        return right;
    }
    /**
   * @param {ContentAny} right
   * @return {boolean}
   */ mergeWith(right) {
        this.arr = this.arr.concat(right.arr);
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {}
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        const len = this.arr.length;
        encoder.writeLen(len - offset);
        for(let i = offset; i < len; i++){
            const c = this.arr[i];
            encoder.writeAny(c);
        }
    }
    /**
   * @return {number}
   */ getRef() {
        return 8;
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentAny}
 */ const $a852d2d5bb3d1ec6$var$readContentAny = (decoder)=>{
    const len = decoder.readLen();
    const cs = [];
    for(let i = 0; i < len; i++)cs.push(decoder.readAny());
    return new $a852d2d5bb3d1ec6$export$1d788b93bbb631a0(cs);
};
/**
 * @private
 */ class $a852d2d5bb3d1ec6$export$ee670b2cf091bbb6 {
    /**
   * @param {string} str
   */ constructor(str){
        /**
     * @type {string}
     */ this.str = str;
    }
    /**
   * @return {number}
   */ getLength() {
        return this.str.length;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return this.str.split('');
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentString}
   */ copy() {
        return new $a852d2d5bb3d1ec6$export$ee670b2cf091bbb6(this.str);
    }
    /**
   * @param {number} offset
   * @return {ContentString}
   */ splice(offset) {
        const right = new $a852d2d5bb3d1ec6$export$ee670b2cf091bbb6(this.str.slice(offset));
        this.str = this.str.slice(0, offset);
        // Prevent encoding invalid documents because of splitting of surrogate pairs: https://github.com/yjs/yjs/issues/248
        const firstCharCode = this.str.charCodeAt(offset - 1);
        if (firstCharCode >= 0xD800 && firstCharCode <= 0xDBFF) {
            // Last character of the left split is the start of a surrogate utf16/ucs2 pair.
            // We don't support splitting of surrogate pairs because this may lead to invalid documents.
            // Replace the invalid character with a unicode replacement character (� / U+FFFD)
            this.str = this.str.slice(0, offset - 1) + "\uFFFD";
            // replace right as well
            right.str = "\uFFFD" + right.str.slice(1);
        }
        return right;
    }
    /**
   * @param {ContentString} right
   * @return {boolean}
   */ mergeWith(right) {
        this.str += right.str;
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {}
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeString(offset === 0 ? this.str : this.str.slice(offset));
    }
    /**
   * @return {number}
   */ getRef() {
        return 4;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentString}
 */ const $a852d2d5bb3d1ec6$var$readContentString = (decoder)=>new $a852d2d5bb3d1ec6$export$ee670b2cf091bbb6(decoder.readString());
/**
 * @type {Array<function(UpdateDecoderV1 | UpdateDecoderV2):AbstractType<any>>}
 * @private
 */ const $a852d2d5bb3d1ec6$var$typeRefs = [
    $a852d2d5bb3d1ec6$var$readYArray,
    $a852d2d5bb3d1ec6$var$readYMap,
    $a852d2d5bb3d1ec6$var$readYText,
    $a852d2d5bb3d1ec6$var$readYXmlElement,
    $a852d2d5bb3d1ec6$var$readYXmlFragment,
    $a852d2d5bb3d1ec6$var$readYXmlHook,
    $a852d2d5bb3d1ec6$var$readYXmlText
];
const $a852d2d5bb3d1ec6$var$YArrayRefID = 0;
const $a852d2d5bb3d1ec6$var$YMapRefID = 1;
const $a852d2d5bb3d1ec6$var$YTextRefID = 2;
const $a852d2d5bb3d1ec6$var$YXmlElementRefID = 3;
const $a852d2d5bb3d1ec6$var$YXmlFragmentRefID = 4;
const $a852d2d5bb3d1ec6$var$YXmlHookRefID = 5;
const $a852d2d5bb3d1ec6$var$YXmlTextRefID = 6;
/**
 * @private
 */ class $a852d2d5bb3d1ec6$export$e2e108cbe2e4f865 {
    /**
   * @param {AbstractType<any>} type
   */ constructor(type){
        /**
     * @type {AbstractType<any>}
     */ this.type = type;
    }
    /**
   * @return {number}
   */ getLength() {
        return 1;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [
            this.type
        ];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentType}
   */ copy() {
        return new $a852d2d5bb3d1ec6$export$e2e108cbe2e4f865(this.type._copy());
    }
    /**
   * @param {number} offset
   * @return {ContentType}
   */ splice(offset) {
        throw $gFLjS.methodUnimplemented();
    }
    /**
   * @param {ContentType} right
   * @return {boolean}
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {
        this.type._integrate(transaction.doc, item);
    }
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {
        let item = this.type._start;
        while(item !== null){
            if (!item.deleted) item.delete(transaction);
            else if (item.id.clock < (transaction.beforeState.get(item.id.client) || 0)) // This will be gc'd later and we want to merge it if possible
            // We try to merge all deleted items after each transaction,
            // but we have no knowledge about that this needs to be merged
            // since it is not in transaction.ds. Hence we add it to transaction._mergeStructs
            transaction._mergeStructs.push(item);
            item = item.right;
        }
        this.type._map.forEach((item)=>{
            if (!item.deleted) item.delete(transaction);
            else if (item.id.clock < (transaction.beforeState.get(item.id.client) || 0)) // same as above
            transaction._mergeStructs.push(item);
        });
        transaction.changed.delete(this.type);
    }
    /**
   * @param {StructStore} store
   */ gc(store) {
        let item = this.type._start;
        while(item !== null){
            item.gc(store, true);
            item = item.right;
        }
        this.type._start = null;
        this.type._map.forEach(/** @param {Item | null} item */ (item)=>{
            while(item !== null){
                item.gc(store, true);
                item = item.left;
            }
        });
        this.type._map = new Map();
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        this.type._write(encoder);
    }
    /**
   * @return {number}
   */ getRef() {
        return 7;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentType}
 */ const $a852d2d5bb3d1ec6$var$readContentType = (decoder)=>new $a852d2d5bb3d1ec6$export$e2e108cbe2e4f865($a852d2d5bb3d1ec6$var$typeRefs[decoder.readTypeRef()](decoder));
/**
 * @todo This should return several items
 *
 * @param {StructStore} store
 * @param {ID} id
 * @return {{item:Item, diff:number}}
 */ const $a852d2d5bb3d1ec6$var$followRedone = (store, id)=>{
    /**
   * @type {ID|null}
   */ let nextID = id;
    let diff = 0;
    let item;
    do {
        if (diff > 0) nextID = $a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(nextID.client, nextID.clock + diff);
        item = $a852d2d5bb3d1ec6$export$f92dfeb71e9bb569(store, nextID);
        diff = nextID.clock - item.id.clock;
        nextID = item.redone;
    }while (nextID !== null && item instanceof $a852d2d5bb3d1ec6$export$6d08773d2e66f8f2);
    return {
        item: item,
        diff: diff
    };
};
/**
 * Make sure that neither item nor any of its parents is ever deleted.
 *
 * This property does not persist when storing it into a database or when
 * sending it to other peers
 *
 * @param {Item|null} item
 * @param {boolean} keep
 */ const $a852d2d5bb3d1ec6$var$keepItem = (item, keep)=>{
    while(item !== null && item.keep !== keep){
        item.keep = keep;
        item = /** @type {AbstractType<any>} */ item.parent._item;
    }
};
/**
 * Split leftItem into two items
 * @param {Transaction} transaction
 * @param {Item} leftItem
 * @param {number} diff
 * @return {Item}
 *
 * @function
 * @private
 */ const $a852d2d5bb3d1ec6$var$splitItem = (transaction, leftItem, diff)=>{
    // create rightItem
    const { client: client, clock: clock } = leftItem.id;
    const rightItem = new $a852d2d5bb3d1ec6$export$6d08773d2e66f8f2($a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(client, clock + diff), leftItem, $a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(client, clock + diff - 1), leftItem.right, leftItem.rightOrigin, leftItem.parent, leftItem.parentSub, leftItem.content.splice(diff));
    if (leftItem.deleted) rightItem.markDeleted();
    if (leftItem.keep) rightItem.keep = true;
    if (leftItem.redone !== null) rightItem.redone = $a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(leftItem.redone.client, leftItem.redone.clock + diff);
    // update left (do not set leftItem.rightOrigin as it will lead to problems when syncing)
    leftItem.right = rightItem;
    // update right
    if (rightItem.right !== null) rightItem.right.left = rightItem;
    // right is more specific.
    transaction._mergeStructs.push(rightItem);
    // update parent._map
    if (rightItem.parentSub !== null && rightItem.right === null) /** @type {AbstractType<any>} */ rightItem.parent._map.set(rightItem.parentSub, rightItem);
    leftItem.length = diff;
    return rightItem;
};
/**
 * @param {Array<StackItem>} stack
 * @param {ID} id
 */ const $a852d2d5bb3d1ec6$var$isDeletedByUndoStack = (stack, id)=>$dWqHQ.some(stack, /** @param {StackItem} s */ (s)=>$a852d2d5bb3d1ec6$export$dcb04af092e44fde(s.deletions, id));
/**
 * Redoes the effect of this operation.
 *
 * @param {Transaction} transaction The Yjs instance.
 * @param {Item} item
 * @param {Set<Item>} redoitems
 * @param {DeleteSet} itemsToDelete
 * @param {boolean} ignoreRemoteMapChanges
 * @param {import('../utils/UndoManager.js').UndoManager} um
 *
 * @return {Item|null}
 *
 * @private
 */ const $a852d2d5bb3d1ec6$var$redoItem = (transaction, item, redoitems, itemsToDelete, ignoreRemoteMapChanges, um)=>{
    const doc = transaction.doc;
    const store = doc.store;
    const ownClientID = doc.clientID;
    const redone = item.redone;
    if (redone !== null) return $a852d2d5bb3d1ec6$var$getItemCleanStart(transaction, redone);
    let parentItem = /** @type {AbstractType<any>} */ item.parent._item;
    /**
   * @type {Item|null}
   */ let left = null;
    /**
   * @type {Item|null}
   */ let right;
    // make sure that parent is redone
    if (parentItem !== null && parentItem.deleted === true) {
        // try to undo parent if it will be undone anyway
        if (parentItem.redone === null && (!redoitems.has(parentItem) || $a852d2d5bb3d1ec6$var$redoItem(transaction, parentItem, redoitems, itemsToDelete, ignoreRemoteMapChanges, um) === null)) return null;
        while(parentItem.redone !== null)parentItem = $a852d2d5bb3d1ec6$var$getItemCleanStart(transaction, parentItem.redone);
    }
    const parentType = parentItem === null ? /** @type {AbstractType<any>} */ item.parent : /** @type {ContentType} */ parentItem.content.type;
    if (item.parentSub === null) {
        // Is an array item. Insert at the old position
        left = item.left;
        right = item;
        // find next cloned_redo items
        while(left !== null){
            /**
       * @type {Item|null}
       */ let leftTrace = left;
            // trace redone until parent matches
            while(leftTrace !== null && /** @type {AbstractType<any>} */ leftTrace.parent._item !== parentItem)leftTrace = leftTrace.redone === null ? null : $a852d2d5bb3d1ec6$var$getItemCleanStart(transaction, leftTrace.redone);
            if (leftTrace !== null && /** @type {AbstractType<any>} */ leftTrace.parent._item === parentItem) {
                left = leftTrace;
                break;
            }
            left = left.left;
        }
        while(right !== null){
            /**
       * @type {Item|null}
       */ let rightTrace = right;
            // trace redone until parent matches
            while(rightTrace !== null && /** @type {AbstractType<any>} */ rightTrace.parent._item !== parentItem)rightTrace = rightTrace.redone === null ? null : $a852d2d5bb3d1ec6$var$getItemCleanStart(transaction, rightTrace.redone);
            if (rightTrace !== null && /** @type {AbstractType<any>} */ rightTrace.parent._item === parentItem) {
                right = rightTrace;
                break;
            }
            right = right.right;
        }
    } else {
        right = null;
        if (item.right && !ignoreRemoteMapChanges) {
            left = item;
            // Iterate right while right is in itemsToDelete
            // If it is intended to delete right while item is redone, we can expect that item should replace right.
            while(left !== null && left.right !== null && (left.right.redone || $a852d2d5bb3d1ec6$export$dcb04af092e44fde(itemsToDelete, left.right.id) || $a852d2d5bb3d1ec6$var$isDeletedByUndoStack(um.undoStack, left.right.id) || $a852d2d5bb3d1ec6$var$isDeletedByUndoStack(um.redoStack, left.right.id))){
                left = left.right;
                // follow redone
                while(left.redone)left = $a852d2d5bb3d1ec6$var$getItemCleanStart(transaction, left.redone);
            }
            if (left && left.right !== null) // It is not possible to redo this item because it conflicts with a
            // change from another client
            return null;
        } else left = parentType._map.get(item.parentSub) || null;
    }
    const nextClock = $a852d2d5bb3d1ec6$export$50fdfeece43146fd(store, ownClientID);
    const nextId = $a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(ownClientID, nextClock);
    const redoneItem = new $a852d2d5bb3d1ec6$export$6d08773d2e66f8f2(nextId, left, left && left.lastId, right, right && right.id, parentType, item.parentSub, item.content.copy());
    item.redone = nextId;
    $a852d2d5bb3d1ec6$var$keepItem(redoneItem, true);
    redoneItem.integrate(transaction, 0);
    return redoneItem;
};
/**
 * Abstract class that represents any content.
 */ class $a852d2d5bb3d1ec6$export$6d08773d2e66f8f2 extends $a852d2d5bb3d1ec6$export$3cf6f9765c5c3196 {
    /**
   * @param {ID} id
   * @param {Item | null} left
   * @param {ID | null} origin
   * @param {Item | null} right
   * @param {ID | null} rightOrigin
   * @param {AbstractType<any>|ID|null} parent Is a type if integrated, is null if it is possible to copy parent from left or right, is ID before integration to search for it.
   * @param {string | null} parentSub
   * @param {AbstractContent} content
   */ constructor(id, left, origin, right, rightOrigin, parent, parentSub, content){
        super(id, content.getLength());
        /**
     * The item that was originally to the left of this item.
     * @type {ID | null}
     */ this.origin = origin;
        /**
     * The item that is currently to the left of this item.
     * @type {Item | null}
     */ this.left = left;
        /**
     * The item that is currently to the right of this item.
     * @type {Item | null}
     */ this.right = right;
        /**
     * The item that was originally to the right of this item.
     * @type {ID | null}
     */ this.rightOrigin = rightOrigin;
        /**
     * @type {AbstractType<any>|ID|null}
     */ this.parent = parent;
        /**
     * If the parent refers to this item with some kind of key (e.g. YMap, the
     * key is specified here. The key is then used to refer to the list in which
     * to insert this item. If `parentSub = null` type._start is the list in
     * which to insert to. Otherwise it is `parent._map`.
     * @type {String | null}
     */ this.parentSub = parentSub;
        /**
     * If this type's effect is redone this type refers to the type that undid
     * this operation.
     * @type {ID | null}
     */ this.redone = null;
        /**
     * @type {AbstractContent}
     */ this.content = content;
        /**
     * bit1: keep
     * bit2: countable
     * bit3: deleted
     * bit4: mark - mark node as fast-search-marker
     * @type {number} byte
     */ this.info = this.content.isCountable() ? $6ciaJ.BIT2 : 0;
    }
    /**
   * This is used to mark the item as an indexed fast-search marker
   *
   * @type {boolean}
   */ set marker(isMarked) {
        if ((this.info & $6ciaJ.BIT4) > 0 !== isMarked) this.info ^= $6ciaJ.BIT4;
    }
    get marker() {
        return (this.info & $6ciaJ.BIT4) > 0;
    }
    /**
   * If true, do not garbage collect this Item.
   */ get keep() {
        return (this.info & $6ciaJ.BIT1) > 0;
    }
    set keep(doKeep) {
        if (this.keep !== doKeep) this.info ^= $6ciaJ.BIT1;
    }
    get countable() {
        return (this.info & $6ciaJ.BIT2) > 0;
    }
    /**
   * Whether this item was deleted or not.
   * @type {Boolean}
   */ get deleted() {
        return (this.info & $6ciaJ.BIT3) > 0;
    }
    set deleted(doDelete) {
        if (this.deleted !== doDelete) this.info ^= $6ciaJ.BIT3;
    }
    markDeleted() {
        this.info |= $6ciaJ.BIT3;
    }
    /**
   * Return the creator clientID of the missing op or define missing items and return null.
   *
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */ getMissing(transaction, store) {
        if (this.origin && this.origin.client !== this.id.client && this.origin.clock >= $a852d2d5bb3d1ec6$export$50fdfeece43146fd(store, this.origin.client)) return this.origin.client;
        if (this.rightOrigin && this.rightOrigin.client !== this.id.client && this.rightOrigin.clock >= $a852d2d5bb3d1ec6$export$50fdfeece43146fd(store, this.rightOrigin.client)) return this.rightOrigin.client;
        if (this.parent && this.parent.constructor === $a852d2d5bb3d1ec6$export$8be180ec26319f9f && this.id.client !== this.parent.client && this.parent.clock >= $a852d2d5bb3d1ec6$export$50fdfeece43146fd(store, this.parent.client)) return this.parent.client;
        // We have all missing ids, now find the items
        if (this.origin) {
            this.left = $a852d2d5bb3d1ec6$var$getItemCleanEnd(transaction, store, this.origin);
            this.origin = this.left.lastId;
        }
        if (this.rightOrigin) {
            this.right = $a852d2d5bb3d1ec6$var$getItemCleanStart(transaction, this.rightOrigin);
            this.rightOrigin = this.right.id;
        }
        if (this.left && this.left.constructor === $a852d2d5bb3d1ec6$export$12d259ff017e6b58 || this.right && this.right.constructor === $a852d2d5bb3d1ec6$export$12d259ff017e6b58) this.parent = null;
        else if (!this.parent) {
            // only set parent if this shouldn't be garbage collected
            if (this.left && this.left.constructor === $a852d2d5bb3d1ec6$export$6d08773d2e66f8f2) {
                this.parent = this.left.parent;
                this.parentSub = this.left.parentSub;
            }
            if (this.right && this.right.constructor === $a852d2d5bb3d1ec6$export$6d08773d2e66f8f2) {
                this.parent = this.right.parent;
                this.parentSub = this.right.parentSub;
            }
        } else if (this.parent.constructor === $a852d2d5bb3d1ec6$export$8be180ec26319f9f) {
            const parentItem = $a852d2d5bb3d1ec6$export$f92dfeb71e9bb569(store, this.parent);
            if (parentItem.constructor === $a852d2d5bb3d1ec6$export$12d259ff017e6b58) this.parent = null;
            else this.parent = /** @type {ContentType} */ parentItem.content.type;
        }
        return null;
    }
    /**
   * @param {Transaction} transaction
   * @param {number} offset
   */ integrate(transaction, offset) {
        if (offset > 0) {
            this.id.clock += offset;
            this.left = $a852d2d5bb3d1ec6$var$getItemCleanEnd(transaction, transaction.doc.store, $a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(this.id.client, this.id.clock - 1));
            this.origin = this.left.lastId;
            this.content = this.content.splice(offset);
            this.length -= offset;
        }
        if (this.parent) {
            if (!this.left && (!this.right || this.right.left !== null) || this.left && this.left.right !== this.right) {
                /**
         * @type {Item|null}
         */ let left = this.left;
                /**
         * @type {Item|null}
         */ let o;
                // set o to the first conflicting item
                if (left !== null) o = left.right;
                else if (this.parentSub !== null) {
                    o = /** @type {AbstractType<any>} */ this.parent._map.get(this.parentSub) || null;
                    while(o !== null && o.left !== null)o = o.left;
                } else o = /** @type {AbstractType<any>} */ this.parent._start;
                // TODO: use something like DeleteSet here (a tree implementation would be best)
                // @todo use global set definitions
                /**
         * @type {Set<Item>}
         */ const conflictingItems = new Set();
                /**
         * @type {Set<Item>}
         */ const itemsBeforeOrigin = new Set();
                // Let c in conflictingItems, b in itemsBeforeOrigin
                // ***{origin}bbbb{this}{c,b}{c,b}{o}***
                // Note that conflictingItems is a subset of itemsBeforeOrigin
                while(o !== null && o !== this.right){
                    itemsBeforeOrigin.add(o);
                    conflictingItems.add(o);
                    if ($a852d2d5bb3d1ec6$export$c0af976e7e459c02(this.origin, o.origin)) {
                        // case 1
                        if (o.id.client < this.id.client) {
                            left = o;
                            conflictingItems.clear();
                        } else if ($a852d2d5bb3d1ec6$export$c0af976e7e459c02(this.rightOrigin, o.rightOrigin)) break;
                         // else, o might be integrated before an item that this conflicts with. If so, we will find it in the next iterations
                    } else if (o.origin !== null && itemsBeforeOrigin.has($a852d2d5bb3d1ec6$export$f92dfeb71e9bb569(transaction.doc.store, o.origin))) // case 2
                    {
                        if (!conflictingItems.has($a852d2d5bb3d1ec6$export$f92dfeb71e9bb569(transaction.doc.store, o.origin))) {
                            left = o;
                            conflictingItems.clear();
                        }
                    } else break;
                    o = o.right;
                }
                this.left = left;
            }
            // reconnect left/right + update parent map/start if necessary
            if (this.left !== null) {
                const right = this.left.right;
                this.right = right;
                this.left.right = this;
            } else {
                let r;
                if (this.parentSub !== null) {
                    r = /** @type {AbstractType<any>} */ this.parent._map.get(this.parentSub) || null;
                    while(r !== null && r.left !== null)r = r.left;
                } else {
                    r = /** @type {AbstractType<any>} */ this.parent._start; /** @type {AbstractType<any>} */ 
                    this.parent._start = this;
                }
                this.right = r;
            }
            if (this.right !== null) this.right.left = this;
            else if (this.parentSub !== null) {
                // set as current parent value if right === null and this is parentSub
                /** @type {AbstractType<any>} */ this.parent._map.set(this.parentSub, this);
                if (this.left !== null) // this is the current attribute value of parent. delete right
                this.left.delete(transaction);
            }
            // adjust length of parent
            if (this.parentSub === null && this.countable && !this.deleted) /** @type {AbstractType<any>} */ this.parent._length += this.length;
            $a852d2d5bb3d1ec6$var$addStruct(transaction.doc.store, this);
            this.content.integrate(transaction, this);
            // add parent to transaction.changed
            $a852d2d5bb3d1ec6$var$addChangedTypeToTransaction(transaction, /** @type {AbstractType<any>} */ this.parent, this.parentSub);
            if (/** @type {AbstractType<any>} */ this.parent._item !== null && /** @type {AbstractType<any>} */ this.parent._item.deleted || this.parentSub !== null && this.right !== null) // delete if parent is deleted or if this is not the current attribute value of parent
            this.delete(transaction);
        } else // parent is not defined. Integrate GC struct instead
        new $a852d2d5bb3d1ec6$export$12d259ff017e6b58(this.id, this.length).integrate(transaction, 0);
    }
    /**
   * Returns the next non-deleted item
   */ get next() {
        let n = this.right;
        while(n !== null && n.deleted)n = n.right;
        return n;
    }
    /**
   * Returns the previous non-deleted item
   */ get prev() {
        let n = this.left;
        while(n !== null && n.deleted)n = n.left;
        return n;
    }
    /**
   * Computes the last content address of this Item.
   */ get lastId() {
        // allocating ids is pretty costly because of the amount of ids created, so we try to reuse whenever possible
        return this.length === 1 ? this.id : $a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(this.id.client, this.id.clock + this.length - 1);
    }
    /**
   * Try to merge two items
   *
   * @param {Item} right
   * @return {boolean}
   */ mergeWith(right) {
        if (this.constructor === right.constructor && $a852d2d5bb3d1ec6$export$c0af976e7e459c02(right.origin, this.lastId) && this.right === right && $a852d2d5bb3d1ec6$export$c0af976e7e459c02(this.rightOrigin, right.rightOrigin) && this.id.client === right.id.client && this.id.clock + this.length === right.id.clock && this.deleted === right.deleted && this.redone === null && right.redone === null && this.content.constructor === right.content.constructor && this.content.mergeWith(right.content)) {
            const searchMarker = /** @type {AbstractType<any>} */ this.parent._searchMarker;
            if (searchMarker) searchMarker.forEach((marker)=>{
                if (marker.p === right) {
                    // right is going to be "forgotten" so we need to update the marker
                    marker.p = this;
                    // adjust marker index
                    if (!this.deleted && this.countable) marker.index -= this.length;
                }
            });
            if (right.keep) this.keep = true;
            this.right = right.right;
            if (this.right !== null) this.right.left = this;
            this.length += right.length;
            return true;
        }
        return false;
    }
    /**
   * Mark this Item as deleted.
   *
   * @param {Transaction} transaction
   */ delete(transaction) {
        if (!this.deleted) {
            const parent = /** @type {AbstractType<any>} */ this.parent;
            // adjust the length of parent
            if (this.countable && this.parentSub === null) parent._length -= this.length;
            this.markDeleted();
            $a852d2d5bb3d1ec6$var$addToDeleteSet(transaction.deleteSet, this.id.client, this.id.clock, this.length);
            $a852d2d5bb3d1ec6$var$addChangedTypeToTransaction(transaction, parent, this.parentSub);
            this.content.delete(transaction);
        }
    }
    /**
   * @param {StructStore} store
   * @param {boolean} parentGCd
   */ gc(store, parentGCd) {
        if (!this.deleted) throw $gFLjS.unexpectedCase();
        this.content.gc(store);
        if (parentGCd) $a852d2d5bb3d1ec6$var$replaceStruct(store, this, new $a852d2d5bb3d1ec6$export$12d259ff017e6b58(this.id, this.length));
        else this.content = new $a852d2d5bb3d1ec6$export$3b06e0b3a2ece602(this.length);
    }
    /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   * @param {number} offset
   */ write(encoder, offset) {
        const origin = offset > 0 ? $a852d2d5bb3d1ec6$export$6c7d4e6171d008d0(this.id.client, this.id.clock + offset - 1) : this.origin;
        const rightOrigin = this.rightOrigin;
        const parentSub = this.parentSub;
        const info = this.content.getRef() & $6ciaJ.BITS5 | (origin === null ? 0 : $6ciaJ.BIT8) | // origin is defined
        (rightOrigin === null ? 0 : $6ciaJ.BIT7) | // right origin is defined
        (parentSub === null ? 0 : $6ciaJ.BIT6); // parentSub is non-null
        encoder.writeInfo(info);
        if (origin !== null) encoder.writeLeftID(origin);
        if (rightOrigin !== null) encoder.writeRightID(rightOrigin);
        if (origin === null && rightOrigin === null) {
            const parent = /** @type {AbstractType<any>} */ this.parent;
            if (parent._item !== undefined) {
                const parentItem = parent._item;
                if (parentItem === null) {
                    // parent type on y._map
                    // find the correct key
                    const ykey = $a852d2d5bb3d1ec6$export$e726a40920d54663(parent);
                    encoder.writeParentInfo(true); // write parentYKey
                    encoder.writeString(ykey);
                } else {
                    encoder.writeParentInfo(false); // write parent id
                    encoder.writeLeftID(parentItem.id);
                }
            } else if (parent.constructor === String) {
                encoder.writeParentInfo(true); // write parentYKey
                encoder.writeString(parent);
            } else if (parent.constructor === $a852d2d5bb3d1ec6$export$8be180ec26319f9f) {
                encoder.writeParentInfo(false); // write parent id
                encoder.writeLeftID(parent);
            } else $gFLjS.unexpectedCase();
            if (parentSub !== null) encoder.writeString(parentSub);
        }
        this.content.write(encoder, offset);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @param {number} info
 */ const $a852d2d5bb3d1ec6$var$readItemContent = (decoder, info)=>$a852d2d5bb3d1ec6$var$contentRefs[info & $6ciaJ.BITS5](decoder);
/**
 * A lookup map for reading Item content.
 *
 * @type {Array<function(UpdateDecoderV1 | UpdateDecoderV2):AbstractContent>}
 */ const $a852d2d5bb3d1ec6$var$contentRefs = [
    ()=>{
        $gFLjS.unexpectedCase();
    },
    $a852d2d5bb3d1ec6$var$readContentDeleted,
    $a852d2d5bb3d1ec6$var$readContentJSON,
    $a852d2d5bb3d1ec6$var$readContentBinary,
    $a852d2d5bb3d1ec6$var$readContentString,
    $a852d2d5bb3d1ec6$var$readContentEmbed,
    $a852d2d5bb3d1ec6$var$readContentFormat,
    $a852d2d5bb3d1ec6$var$readContentType,
    $a852d2d5bb3d1ec6$var$readContentAny,
    $a852d2d5bb3d1ec6$var$readContentDoc,
    ()=>{
        $gFLjS.unexpectedCase();
    } // 10 - Skip is not ItemContent
];
const $a852d2d5bb3d1ec6$var$structSkipRefNumber = 10;
/**
 * @private
 */ class $a852d2d5bb3d1ec6$export$38d24f5c1eb0e4c0 extends $a852d2d5bb3d1ec6$export$3cf6f9765c5c3196 {
    get deleted() {
        return true;
    }
    delete() {}
    /**
   * @param {Skip} right
   * @return {boolean}
   */ mergeWith(right) {
        if (this.constructor !== right.constructor) return false;
        this.length += right.length;
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {number} offset
   */ integrate(transaction, offset) {
        // skip structs cannot be integrated
        $gFLjS.unexpectedCase();
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeInfo($a852d2d5bb3d1ec6$var$structSkipRefNumber);
        // write as VarUint because Skips can't make use of predictable length-encoding
        $kRma6.writeVarUint(encoder.restEncoder, this.length - offset);
    }
    /**
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */ getMissing(transaction, store) {
        return null;
    }
}
/** eslint-env browser */ const $a852d2d5bb3d1ec6$var$glo = /** @type {any} */ typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $a852d2d5bb3d1ec6$var$importIdentifier = '__ $YJS$ __';
if ($a852d2d5bb3d1ec6$var$glo[$a852d2d5bb3d1ec6$var$importIdentifier] === true) /**
   * Dear reader of this message. Please take this seriously.
   *
   * If you see this message, make sure that you only import one version of Yjs. In many cases,
   * your package manager installs two versions of Yjs that are used by different packages within your project.
   * Another reason for this message is that some parts of your project use the commonjs version of Yjs
   * and others use the EcmaScript version of Yjs.
   *
   * This often leads to issues that are hard to debug. We often need to perform constructor checks,
   * e.g. `struct instanceof GC`. If you imported different versions of Yjs, it is impossible for us to
   * do the constructor checks anymore - which might break the CRDT algorithm.
   *
   * https://github.com/yjs/yjs/issues/438
   */ console.error('Yjs was already imported. This breaks constructor checks and will lead to issues! - https://github.com/yjs/yjs/issues/438');
$a852d2d5bb3d1ec6$var$glo[$a852d2d5bb3d1ec6$var$importIdentifier] = true;

});
parcelRegister("7uKvC", function(module, exports) {

$parcel$export(module.exports, "ObservableV2", () => $574f6972eb19fdfe$export$e23d3436ce401adc);
$parcel$export(module.exports, "Observable", () => $574f6972eb19fdfe$export$77cea355fa80b5f4);
/**
 * Observable class prototype.
 *
 * @module observable
 */ 
var $d1VR8 = parcelRequire("d1VR8");

var $9IXCW = parcelRequire("9IXCW");

var $dWqHQ = parcelRequire("dWqHQ");
class $574f6972eb19fdfe$export$e23d3436ce401adc {
    constructor(){
        /**
     * Some desc.
     * @type {Map<string, Set<any>>}
     */ this._observers = $d1VR8.create();
    }
    /**
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name
   * @param {EVENTS[NAME]} f
   */ on(name, f) {
        $d1VR8.setIfUndefined(this._observers, /** @type {string} */ name, $9IXCW.create).add(f);
        return f;
    }
    /**
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name
   * @param {EVENTS[NAME]} f
   */ once(name, f) {
        /**
     * @param  {...any} args
     */ const _f = (...args)=>{
            this.off(name, /** @type {any} */ _f);
            f(...args);
        };
        this.on(name, /** @type {any} */ _f);
    }
    /**
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name
   * @param {EVENTS[NAME]} f
   */ off(name, f) {
        const observers = this._observers.get(name);
        if (observers !== undefined) {
            observers.delete(f);
            if (observers.size === 0) this._observers.delete(name);
        }
    }
    /**
   * Emit a named event. All registered event listeners that listen to the
   * specified name will receive the event.
   *
   * @todo This should catch exceptions
   *
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name The event name.
   * @param {Parameters<EVENTS[NAME]>} args The arguments that are applied to the event listener.
   */ emit(name, args) {
        // copy all listeners to an array first to make sure that no event is emitted to listeners that are subscribed while the event handler is called.
        return $dWqHQ.from((this._observers.get(name) || $d1VR8.create()).values()).forEach((f)=>f(...args));
    }
    destroy() {
        this._observers = $d1VR8.create();
    }
}
class $574f6972eb19fdfe$export$77cea355fa80b5f4 {
    constructor(){
        /**
     * Some desc.
     * @type {Map<N, any>}
     */ this._observers = $d1VR8.create();
    }
    /**
   * @param {N} name
   * @param {function} f
   */ on(name, f) {
        $d1VR8.setIfUndefined(this._observers, name, $9IXCW.create).add(f);
    }
    /**
   * @param {N} name
   * @param {function} f
   */ once(name, f) {
        /**
     * @param  {...any} args
     */ const _f = (...args)=>{
            this.off(name, _f);
            f(...args);
        };
        this.on(name, _f);
    }
    /**
   * @param {N} name
   * @param {function} f
   */ off(name, f) {
        const observers = this._observers.get(name);
        if (observers !== undefined) {
            observers.delete(f);
            if (observers.size === 0) this._observers.delete(name);
        }
    }
    /**
   * Emit a named event. All registered event listeners that listen to the
   * specified name will receive the event.
   *
   * @todo This should catch exceptions
   *
   * @param {N} name The event name.
   * @param {Array<any>} args The arguments that are applied to the event listener.
   */ emit(name, args) {
        // copy all listeners to an array first to make sure that no event is emitted to listeners that are subscribed while the event handler is called.
        return $dWqHQ.from((this._observers.get(name) || $d1VR8.create()).values()).forEach((f)=>f(...args));
    }
    destroy() {
        this._observers = $d1VR8.create();
    }
} /* c8 ignore end */ 

});
parcelRegister("d1VR8", function(module, exports) {

$parcel$export(module.exports, "create", () => $97c83f5e903e4439$export$185802fd694ee1f5);
$parcel$export(module.exports, "copy", () => $97c83f5e903e4439$export$784d13d8ee351f07);
$parcel$export(module.exports, "setIfUndefined", () => $97c83f5e903e4439$export$dccd489362a8619);
$parcel$export(module.exports, "map", () => $97c83f5e903e4439$export$871de8747c9eaa88);
$parcel$export(module.exports, "any", () => $97c83f5e903e4439$export$4154a199d7d90455);
/**
 * Utility module to work with key-value stores.
 *
 * @module map
 */ /**
 * Creates a new Map instance.
 *
 * @function
 * @return {Map<any, any>}
 *
 * @function
 */ const $97c83f5e903e4439$export$185802fd694ee1f5 = ()=>new Map();
const $97c83f5e903e4439$export$784d13d8ee351f07 = (m)=>{
    const r = $97c83f5e903e4439$export$185802fd694ee1f5();
    m.forEach((v, k)=>{
        r.set(k, v);
    });
    return r;
};
const $97c83f5e903e4439$export$dccd489362a8619 = (map, key, createT)=>{
    let set = map.get(key);
    if (set === undefined) map.set(key, set = createT());
    return set;
};
const $97c83f5e903e4439$export$871de8747c9eaa88 = (m, f)=>{
    const res = [];
    for (const [key, value] of m)res.push(f(value, key));
    return res;
};
const $97c83f5e903e4439$export$4154a199d7d90455 = (m, f)=>{
    for (const [key, value] of m){
        if (f(value, key)) return true;
    }
    return false;
};
const $97c83f5e903e4439$export$84bf76cd7afc7469 = (m, f)=>{
    for (const [key, value] of m){
        if (!f(value, key)) return false;
    }
    return true;
};

});

parcelRegister("9IXCW", function(module, exports) {

$parcel$export(module.exports, "create", () => $714679cc9341111d$export$185802fd694ee1f5);
$parcel$export(module.exports, "from", () => $714679cc9341111d$export$6788812c4e6611e6);
/**
 * Utility module to work with sets.
 *
 * @module set
 */ const $714679cc9341111d$export$185802fd694ee1f5 = ()=>new Set();
const $714679cc9341111d$export$45b10814cc054894 = (set)=>Array.from(set);
const $714679cc9341111d$export$43128fadae87b74a = (set)=>set.values().next().value ?? undefined;
const $714679cc9341111d$export$6788812c4e6611e6 = (entries)=>new Set(entries);

});

parcelRegister("dWqHQ", function(module, exports) {

$parcel$export(module.exports, "last", () => $a26568727d2e8ef5$export$4c7897fafd92b108);
$parcel$export(module.exports, "appendTo", () => $a26568727d2e8ef5$export$9ceefe31f12a3778);
$parcel$export(module.exports, "from", () => $a26568727d2e8ef5$export$6788812c4e6611e6);
$parcel$export(module.exports, "some", () => $a26568727d2e8ef5$export$ad14ef4001db2bcd);
$parcel$export(module.exports, "equalFlat", () => $a26568727d2e8ef5$export$4f1c34abb2bb4c8);
$parcel$export(module.exports, "unfold", () => $a26568727d2e8ef5$export$c48e357c1a89b78d);
$parcel$export(module.exports, "isArray", () => $a26568727d2e8ef5$export$43bee75e5e14138e);
$parcel$export(module.exports, "map", () => $a26568727d2e8ef5$export$871de8747c9eaa88);
/**
 * Utility module to work with Arrays.
 *
 * @module array
 */ 
var $9IXCW = parcelRequire("9IXCW");
const $a26568727d2e8ef5$export$4c7897fafd92b108 = (arr)=>arr[arr.length - 1];
const $a26568727d2e8ef5$export$185802fd694ee1f5 = ()=>/** @type {Array<C>} */ [];
const $a26568727d2e8ef5$export$784d13d8ee351f07 = (a)=>/** @type {Array<D>} */ a.slice();
const $a26568727d2e8ef5$export$9ceefe31f12a3778 = (dest, src)=>{
    for(let i = 0; i < src.length; i++)dest.push(src[i]);
};
const $a26568727d2e8ef5$export$6788812c4e6611e6 = Array.from;
const $a26568727d2e8ef5$export$7ecc1a3b11b57dab = (arr, f)=>{
    for(let i = 0; i < arr.length; i++){
        if (!f(arr[i], i, arr)) return false;
    }
    return true;
};
const $a26568727d2e8ef5$export$ad14ef4001db2bcd = (arr, f)=>{
    for(let i = 0; i < arr.length; i++){
        if (f(arr[i], i, arr)) return true;
    }
    return false;
};
const $a26568727d2e8ef5$export$4f1c34abb2bb4c8 = (a, b)=>a.length === b.length && $a26568727d2e8ef5$export$7ecc1a3b11b57dab(a, (item, index)=>item === b[index]);
const $a26568727d2e8ef5$export$bffa455ba8c619a6 = (arr)=>$a26568727d2e8ef5$export$93e2b83da34ff82a(arr, /** @type {Array<ELEM>} */ [], (acc, val)=>acc.concat(val));
const $a26568727d2e8ef5$export$c48e357c1a89b78d = (len, f)=>{
    const array = new Array(len);
    for(let i = 0; i < len; i++)array[i] = f(i, array);
    return array;
};
const $a26568727d2e8ef5$export$93e2b83da34ff82a = (arr, seed, folder)=>arr.reduce(folder, seed);
const $a26568727d2e8ef5$export$43bee75e5e14138e = Array.isArray;
const $a26568727d2e8ef5$export$7a5d5c156e7dc406 = (arr)=>$a26568727d2e8ef5$export$6788812c4e6611e6($9IXCW.from(arr));
const $a26568727d2e8ef5$export$abf0e2545164275f = (arr, mapper)=>{
    /**
   * @type {Set<M>}
   */ const happened = $9IXCW.create();
    /**
   * @type {Array<T>}
   */ const result = [];
    for(let i = 0; i < arr.length; i++){
        const el = arr[i];
        const mapped = mapper(el);
        if (!happened.has(mapped)) {
            happened.add(mapped);
            result.push(el);
        }
    }
    return result;
};
const $a26568727d2e8ef5$export$871de8747c9eaa88 = (arr, mapper)=>{
    /**
   * @type {Array<any>}
   */ const res = Array(arr.length);
    for(let i = 0; i < arr.length; i++)res[i] = mapper(/** @type {any} */ arr[i], i, /** @type {any} */ arr);
    return /** @type {any} */ res;
};

});


parcelRegister("bJmyZ", function(module, exports) {

$parcel$export(module.exports, "floor", () => $88a5664bbb10abac$export$a3fe094919f356fd);
$parcel$export(module.exports, "ceil", () => $88a5664bbb10abac$export$803ce6b71a0a94b2);
$parcel$export(module.exports, "abs", () => $88a5664bbb10abac$export$2335f513bbd82c6d);
$parcel$export(module.exports, "round", () => $88a5664bbb10abac$export$2077e0241d6afd3c);
$parcel$export(module.exports, "log10", () => $88a5664bbb10abac$export$75e08744a3ff8516);
$parcel$export(module.exports, "min", () => $88a5664bbb10abac$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $88a5664bbb10abac$export$8960430cfd85939f);
$parcel$export(module.exports, "pow", () => $88a5664bbb10abac$export$9c297f60e22e3389);
$parcel$export(module.exports, "exp10", () => $88a5664bbb10abac$export$1bb2a14208c790f7);
$parcel$export(module.exports, "isNegativeZero", () => $88a5664bbb10abac$export$dc0a61f4a9121f92);
/**
 * Common Math expressions.
 *
 * @module math
 */ const $88a5664bbb10abac$export$a3fe094919f356fd = Math.floor;
const $88a5664bbb10abac$export$803ce6b71a0a94b2 = Math.ceil;
const $88a5664bbb10abac$export$2335f513bbd82c6d = Math.abs;
const $88a5664bbb10abac$export$46de3d998ca9a030 = Math.imul;
const $88a5664bbb10abac$export$2077e0241d6afd3c = Math.round;
const $88a5664bbb10abac$export$75e08744a3ff8516 = Math.log10;
const $88a5664bbb10abac$export$b9fae0bba9d9094d = Math.log2;
const $88a5664bbb10abac$export$bef1f36f5486a6a3 = Math.log;
const $88a5664bbb10abac$export$eba8049fb5020b81 = Math.sqrt;
const $88a5664bbb10abac$export$e16d8520af44a096 = (a, b)=>a + b;
const $88a5664bbb10abac$export$96ec731ed4dcb222 = (a, b)=>a < b ? a : b;
const $88a5664bbb10abac$export$8960430cfd85939f = (a, b)=>a > b ? a : b;
const $88a5664bbb10abac$export$c9f5652083b8129d = Number.isNaN;
const $88a5664bbb10abac$export$9c297f60e22e3389 = Math.pow;
const $88a5664bbb10abac$export$1bb2a14208c790f7 = (exp)=>Math.pow(10, exp);
const $88a5664bbb10abac$export$c5552dfdbc7cec71 = Math.sign;
const $88a5664bbb10abac$export$dc0a61f4a9121f92 = (n)=>n !== 0 ? n < 0 : 1 / n < 0;

});

parcelRegister("kRma6", function(module, exports) {

$parcel$export(module.exports, "createEncoder", () => $f2f9f2c90ca1c855$export$4e76eeb6df88c889);
$parcel$export(module.exports, "encode", () => $f2f9f2c90ca1c855$export$c564cdbbe6da493);
$parcel$export(module.exports, "toUint8Array", () => $f2f9f2c90ca1c855$export$73470fd2221e6aef);
$parcel$export(module.exports, "length", () => $f2f9f2c90ca1c855$export$f24224f1c91d8156);
$parcel$export(module.exports, "write", () => $f2f9f2c90ca1c855$export$68d8715fc104d294);
$parcel$export(module.exports, "writeUint8", () => $f2f9f2c90ca1c855$export$826a1a6619653272);
$parcel$export(module.exports, "writeVarUint", () => $f2f9f2c90ca1c855$export$872f48c75febcd2b);
$parcel$export(module.exports, "writeVarInt", () => $f2f9f2c90ca1c855$export$ff90f819e16cc9bb);
$parcel$export(module.exports, "writeVarUint8Array", () => $f2f9f2c90ca1c855$export$f7d11515275e88a2);
$parcel$export(module.exports, "writeVarString", () => $f2f9f2c90ca1c855$export$dde49cb52d5f1650);
$parcel$export(module.exports, "writeBinaryEncoder", () => $f2f9f2c90ca1c855$export$c029b62321ea3da);
$parcel$export(module.exports, "writeUint8Array", () => $f2f9f2c90ca1c855$export$73b5e63e27d2b4c7);
$parcel$export(module.exports, "writeAny", () => $f2f9f2c90ca1c855$export$264b1e8551468ea);
$parcel$export(module.exports, "RleEncoder", () => $f2f9f2c90ca1c855$export$8fa72bb4fa9409ff);
$parcel$export(module.exports, "UintOptRleEncoder", () => $f2f9f2c90ca1c855$export$785ebd3312c38061);
$parcel$export(module.exports, "IntDiffOptRleEncoder", () => $f2f9f2c90ca1c855$export$7542c66a59375c6f);
$parcel$export(module.exports, "StringEncoder", () => $f2f9f2c90ca1c855$export$7dcdc5c32f31c550);
/**
 * Efficient schema-less binary encoding with support for variable length encoding.
 *
 * Use [lib0/encoding] with [lib0/decoding]. Every encoding function has a corresponding decoding function.
 *
 * Encodes numbers in little-endian order (least to most significant byte order)
 * and is compatible with Golang's binary encoding (https://golang.org/pkg/encoding/binary/)
 * which is also used in Protocol Buffers.
 *
 * ```js
 * // encoding step
 * const encoder = encoding.createEncoder()
 * encoding.writeVarUint(encoder, 256)
 * encoding.writeVarString(encoder, 'Hello world!')
 * const buf = encoding.toUint8Array(encoder)
 * ```
 *
 * ```js
 * // decoding step
 * const decoder = decoding.createDecoder(buf)
 * decoding.readVarUint(decoder) // => 256
 * decoding.readVarString(decoder) // => 'Hello world!'
 * decoding.hasContent(decoder) // => false - all data is read
 * ```
 *
 * @module encoding
 */ 
var $bJmyZ = parcelRequire("bJmyZ");

var $6BhQL = parcelRequire("6BhQL");

var $6ciaJ = parcelRequire("6ciaJ");

var $1dTGB = parcelRequire("1dTGB");

var $dWqHQ = parcelRequire("dWqHQ");
class $f2f9f2c90ca1c855$export$a50aceb0e02a00aa {
    constructor(){
        this.cpos = 0;
        this.cbuf = new Uint8Array(100);
        /**
     * @type {Array<Uint8Array>}
     */ this.bufs = [];
    }
}
const $f2f9f2c90ca1c855$export$4e76eeb6df88c889 = ()=>new $f2f9f2c90ca1c855$export$a50aceb0e02a00aa();
const $f2f9f2c90ca1c855$export$c564cdbbe6da493 = (f)=>{
    const encoder = $f2f9f2c90ca1c855$export$4e76eeb6df88c889();
    f(encoder);
    return $f2f9f2c90ca1c855$export$73470fd2221e6aef(encoder);
};
const $f2f9f2c90ca1c855$export$f24224f1c91d8156 = (encoder)=>{
    let len = encoder.cpos;
    for(let i = 0; i < encoder.bufs.length; i++)len += encoder.bufs[i].length;
    return len;
};
const $f2f9f2c90ca1c855$export$7ad75c69830b76d7 = (encoder)=>encoder.cpos > 0 || encoder.bufs.length > 0;
const $f2f9f2c90ca1c855$export$73470fd2221e6aef = (encoder)=>{
    const uint8arr = new Uint8Array($f2f9f2c90ca1c855$export$f24224f1c91d8156(encoder));
    let curPos = 0;
    for(let i = 0; i < encoder.bufs.length; i++){
        const d = encoder.bufs[i];
        uint8arr.set(d, curPos);
        curPos += d.length;
    }
    uint8arr.set(new Uint8Array(encoder.cbuf.buffer, 0, encoder.cpos), curPos);
    return uint8arr;
};
const $f2f9f2c90ca1c855$export$39fb588b9aff60c5 = (encoder, len)=>{
    const bufferLen = encoder.cbuf.length;
    if (bufferLen - encoder.cpos < len) {
        encoder.bufs.push(new Uint8Array(encoder.cbuf.buffer, 0, encoder.cpos));
        encoder.cbuf = new Uint8Array($bJmyZ.max(bufferLen, len) * 2);
        encoder.cpos = 0;
    }
};
const $f2f9f2c90ca1c855$export$68d8715fc104d294 = (encoder, num)=>{
    const bufferLen = encoder.cbuf.length;
    if (encoder.cpos === bufferLen) {
        encoder.bufs.push(encoder.cbuf);
        encoder.cbuf = new Uint8Array(bufferLen * 2);
        encoder.cpos = 0;
    }
    encoder.cbuf[encoder.cpos++] = num;
};
const $f2f9f2c90ca1c855$export$adaa4cf7ef1b65be = (encoder, pos, num)=>{
    let buffer = null;
    // iterate all buffers and adjust position
    for(let i = 0; i < encoder.bufs.length && buffer === null; i++){
        const b = encoder.bufs[i];
        if (pos < b.length) buffer = b // found buffer
        ;
        else pos -= b.length;
    }
    if (buffer === null) // use current buffer
    buffer = encoder.cbuf;
    buffer[pos] = num;
};
const $f2f9f2c90ca1c855$export$826a1a6619653272 = $f2f9f2c90ca1c855$export$68d8715fc104d294;
const $f2f9f2c90ca1c855$export$83964ea8501fbf8 = $f2f9f2c90ca1c855$export$adaa4cf7ef1b65be;
const $f2f9f2c90ca1c855$export$ba6b74b6f3145a00 = (encoder, num)=>{
    $f2f9f2c90ca1c855$export$68d8715fc104d294(encoder, num & $6ciaJ.BITS8);
    $f2f9f2c90ca1c855$export$68d8715fc104d294(encoder, num >>> 8 & $6ciaJ.BITS8);
};
const $f2f9f2c90ca1c855$export$f86e1edc3d839287 = (encoder, pos, num)=>{
    $f2f9f2c90ca1c855$export$adaa4cf7ef1b65be(encoder, pos, num & $6ciaJ.BITS8);
    $f2f9f2c90ca1c855$export$adaa4cf7ef1b65be(encoder, pos + 1, num >>> 8 & $6ciaJ.BITS8);
};
const $f2f9f2c90ca1c855$export$835343b0f7799f5b = (encoder, num)=>{
    for(let i = 0; i < 4; i++){
        $f2f9f2c90ca1c855$export$68d8715fc104d294(encoder, num & $6ciaJ.BITS8);
        num >>>= 8;
    }
};
const $f2f9f2c90ca1c855$export$efed0d8c16230d13 = (encoder, num)=>{
    for(let i = 3; i >= 0; i--)$f2f9f2c90ca1c855$export$68d8715fc104d294(encoder, num >>> 8 * i & $6ciaJ.BITS8);
};
const $f2f9f2c90ca1c855$export$5517b6394fc440fb = (encoder, pos, num)=>{
    for(let i = 0; i < 4; i++){
        $f2f9f2c90ca1c855$export$adaa4cf7ef1b65be(encoder, pos + i, num & $6ciaJ.BITS8);
        num >>>= 8;
    }
};
const $f2f9f2c90ca1c855$export$872f48c75febcd2b = (encoder, num)=>{
    while(num > $6ciaJ.BITS7){
        $f2f9f2c90ca1c855$export$68d8715fc104d294(encoder, $6ciaJ.BIT8 | $6ciaJ.BITS7 & num);
        num = $bJmyZ.floor(num / 128) // shift >>> 7
        ;
    }
    $f2f9f2c90ca1c855$export$68d8715fc104d294(encoder, $6ciaJ.BITS7 & num);
};
const $f2f9f2c90ca1c855$export$ff90f819e16cc9bb = (encoder, num)=>{
    const isNegative = $bJmyZ.isNegativeZero(num);
    if (isNegative) num = -num;
    //             |- whether to continue reading         |- whether is negative     |- number
    $f2f9f2c90ca1c855$export$68d8715fc104d294(encoder, (num > $6ciaJ.BITS6 ? $6ciaJ.BIT8 : 0) | (isNegative ? $6ciaJ.BIT7 : 0) | $6ciaJ.BITS6 & num);
    num = $bJmyZ.floor(num / 64) // shift >>> 6
    ;
    // We don't need to consider the case of num === 0 so we can use a different
    // pattern here than above.
    while(num > 0){
        $f2f9f2c90ca1c855$export$68d8715fc104d294(encoder, (num > $6ciaJ.BITS7 ? $6ciaJ.BIT8 : 0) | $6ciaJ.BITS7 & num);
        num = $bJmyZ.floor(num / 128) // shift >>> 7
        ;
    }
};
/**
 * A cache to store strings temporarily
 */ const $f2f9f2c90ca1c855$var$_strBuffer = new Uint8Array(30000);
const $f2f9f2c90ca1c855$var$_maxStrBSize = $f2f9f2c90ca1c855$var$_strBuffer.length / 3;
const $f2f9f2c90ca1c855$export$dff327976627e12b = (encoder, str)=>{
    if (str.length < $f2f9f2c90ca1c855$var$_maxStrBSize) {
        // We can encode the string into the existing buffer
        /* c8 ignore next */ const written = $1dTGB.utf8TextEncoder.encodeInto(str, $f2f9f2c90ca1c855$var$_strBuffer).written || 0;
        $f2f9f2c90ca1c855$export$872f48c75febcd2b(encoder, written);
        for(let i = 0; i < written; i++)$f2f9f2c90ca1c855$export$68d8715fc104d294(encoder, $f2f9f2c90ca1c855$var$_strBuffer[i]);
    } else $f2f9f2c90ca1c855$export$f7d11515275e88a2(encoder, $1dTGB.encodeUtf8(str));
};
const $f2f9f2c90ca1c855$export$94cf4193edfe959a = (encoder, str)=>{
    const encodedString = unescape(encodeURIComponent(str));
    const len = encodedString.length;
    $f2f9f2c90ca1c855$export$872f48c75febcd2b(encoder, len);
    for(let i = 0; i < len; i++)$f2f9f2c90ca1c855$export$68d8715fc104d294(encoder, /** @type {number} */ encodedString.codePointAt(i));
};
const $f2f9f2c90ca1c855$export$dde49cb52d5f1650 = $1dTGB.utf8TextEncoder && /** @type {any} */ $1dTGB.utf8TextEncoder.encodeInto ? $f2f9f2c90ca1c855$export$dff327976627e12b : $f2f9f2c90ca1c855$export$94cf4193edfe959a;
const $f2f9f2c90ca1c855$export$be5604ffb9fbbd0c = (encoder, str)=>$f2f9f2c90ca1c855$export$6c17d6eec4abdaa6(encoder, $1dTGB.encodeUtf8(str));
const $f2f9f2c90ca1c855$export$6c17d6eec4abdaa6 = (encoder, buf)=>{
    for(let i = 0; i < buf.length; i++){
        const b = buf[i];
        if (b === 0 || b === 1) $f2f9f2c90ca1c855$export$68d8715fc104d294(encoder, 1);
        $f2f9f2c90ca1c855$export$68d8715fc104d294(encoder, buf[i]);
    }
    $f2f9f2c90ca1c855$export$68d8715fc104d294(encoder, 0);
};
const $f2f9f2c90ca1c855$export$c029b62321ea3da = (encoder, append)=>$f2f9f2c90ca1c855$export$73b5e63e27d2b4c7(encoder, $f2f9f2c90ca1c855$export$73470fd2221e6aef(append));
const $f2f9f2c90ca1c855$export$73b5e63e27d2b4c7 = (encoder, uint8Array)=>{
    const bufferLen = encoder.cbuf.length;
    const cpos = encoder.cpos;
    const leftCopyLen = $bJmyZ.min(bufferLen - cpos, uint8Array.length);
    const rightCopyLen = uint8Array.length - leftCopyLen;
    encoder.cbuf.set(uint8Array.subarray(0, leftCopyLen), cpos);
    encoder.cpos += leftCopyLen;
    if (rightCopyLen > 0) {
        // Still something to write, write right half..
        // Append new buffer
        encoder.bufs.push(encoder.cbuf);
        // must have at least size of remaining buffer
        encoder.cbuf = new Uint8Array($bJmyZ.max(bufferLen * 2, rightCopyLen));
        // copy array
        encoder.cbuf.set(uint8Array.subarray(leftCopyLen));
        encoder.cpos = rightCopyLen;
    }
};
const $f2f9f2c90ca1c855$export$f7d11515275e88a2 = (encoder, uint8Array)=>{
    $f2f9f2c90ca1c855$export$872f48c75febcd2b(encoder, uint8Array.byteLength);
    $f2f9f2c90ca1c855$export$73b5e63e27d2b4c7(encoder, uint8Array);
};
const $f2f9f2c90ca1c855$export$1f031ae9c71bd530 = (encoder, len)=>{
    $f2f9f2c90ca1c855$export$39fb588b9aff60c5(encoder, len);
    const dview = new DataView(encoder.cbuf.buffer, encoder.cpos, len);
    encoder.cpos += len;
    return dview;
};
const $f2f9f2c90ca1c855$export$a33455db0a9638a6 = (encoder, num)=>$f2f9f2c90ca1c855$export$1f031ae9c71bd530(encoder, 4).setFloat32(0, num, false);
const $f2f9f2c90ca1c855$export$231a04cea676c54c = (encoder, num)=>$f2f9f2c90ca1c855$export$1f031ae9c71bd530(encoder, 8).setFloat64(0, num, false);
const $f2f9f2c90ca1c855$export$4fbfa93dd6e14543 = (encoder, num)=>/** @type {any} */ $f2f9f2c90ca1c855$export$1f031ae9c71bd530(encoder, 8).setBigInt64(0, num, false);
const $f2f9f2c90ca1c855$export$663ca46034903888 = (encoder, num)=>/** @type {any} */ $f2f9f2c90ca1c855$export$1f031ae9c71bd530(encoder, 8).setBigUint64(0, num, false);
const $f2f9f2c90ca1c855$var$floatTestBed = new DataView(new ArrayBuffer(4));
/**
 * Check if a number can be encoded as a 32 bit float.
 *
 * @param {number} num
 * @return {boolean}
 */ const $f2f9f2c90ca1c855$var$isFloat32 = (num)=>{
    $f2f9f2c90ca1c855$var$floatTestBed.setFloat32(0, num);
    return $f2f9f2c90ca1c855$var$floatTestBed.getFloat32(0) === num;
};
const $f2f9f2c90ca1c855$export$264b1e8551468ea = (encoder, data)=>{
    switch(typeof data){
        case 'string':
            // TYPE 119: STRING
            $f2f9f2c90ca1c855$export$68d8715fc104d294(encoder, 119);
            $f2f9f2c90ca1c855$export$dde49cb52d5f1650(encoder, data);
            break;
        case 'number':
            if ($6BhQL.isInteger(data) && $bJmyZ.abs(data) <= $6ciaJ.BITS31) {
                // TYPE 125: INTEGER
                $f2f9f2c90ca1c855$export$68d8715fc104d294(encoder, 125);
                $f2f9f2c90ca1c855$export$ff90f819e16cc9bb(encoder, data);
            } else if ($f2f9f2c90ca1c855$var$isFloat32(data)) {
                // TYPE 124: FLOAT32
                $f2f9f2c90ca1c855$export$68d8715fc104d294(encoder, 124);
                $f2f9f2c90ca1c855$export$a33455db0a9638a6(encoder, data);
            } else {
                // TYPE 123: FLOAT64
                $f2f9f2c90ca1c855$export$68d8715fc104d294(encoder, 123);
                $f2f9f2c90ca1c855$export$231a04cea676c54c(encoder, data);
            }
            break;
        case 'bigint':
            // TYPE 122: BigInt
            $f2f9f2c90ca1c855$export$68d8715fc104d294(encoder, 122);
            $f2f9f2c90ca1c855$export$4fbfa93dd6e14543(encoder, data);
            break;
        case 'object':
            if (data === null) // TYPE 126: null
            $f2f9f2c90ca1c855$export$68d8715fc104d294(encoder, 126);
            else if ($dWqHQ.isArray(data)) {
                // TYPE 117: Array
                $f2f9f2c90ca1c855$export$68d8715fc104d294(encoder, 117);
                $f2f9f2c90ca1c855$export$872f48c75febcd2b(encoder, data.length);
                for(let i = 0; i < data.length; i++)$f2f9f2c90ca1c855$export$264b1e8551468ea(encoder, data[i]);
            } else if (data instanceof Uint8Array) {
                // TYPE 116: ArrayBuffer
                $f2f9f2c90ca1c855$export$68d8715fc104d294(encoder, 116);
                $f2f9f2c90ca1c855$export$f7d11515275e88a2(encoder, data);
            } else {
                // TYPE 118: Object
                $f2f9f2c90ca1c855$export$68d8715fc104d294(encoder, 118);
                const keys = Object.keys(data);
                $f2f9f2c90ca1c855$export$872f48c75febcd2b(encoder, keys.length);
                for(let i = 0; i < keys.length; i++){
                    const key = keys[i];
                    $f2f9f2c90ca1c855$export$dde49cb52d5f1650(encoder, key);
                    $f2f9f2c90ca1c855$export$264b1e8551468ea(encoder, data[key]);
                }
            }
            break;
        case 'boolean':
            // TYPE 120/121: boolean (true/false)
            $f2f9f2c90ca1c855$export$68d8715fc104d294(encoder, data ? 120 : 121);
            break;
        default:
            // TYPE 127: undefined
            $f2f9f2c90ca1c855$export$68d8715fc104d294(encoder, 127);
    }
};
class $f2f9f2c90ca1c855$export$8fa72bb4fa9409ff extends $f2f9f2c90ca1c855$export$a50aceb0e02a00aa {
    /**
   * @param {function(Encoder, T):void} writer
   */ constructor(writer){
        super();
        /**
     * The writer
     */ this.w = writer;
        /**
     * Current state
     * @type {T|null}
     */ this.s = null;
        this.count = 0;
    }
    /**
   * @param {T} v
   */ write(v) {
        if (this.s === v) this.count++;
        else {
            if (this.count > 0) // flush counter, unless this is the first value (count = 0)
            $f2f9f2c90ca1c855$export$872f48c75febcd2b(this, this.count - 1) // since count is always > 0, we can decrement by one. non-standard encoding ftw
            ;
            this.count = 1;
            // write first value
            this.w(this, v);
            this.s = v;
        }
    }
}
class $f2f9f2c90ca1c855$export$c636f3fa46f2752c extends $f2f9f2c90ca1c855$export$a50aceb0e02a00aa {
    /**
   * @param {number} start
   */ constructor(start){
        super();
        /**
     * Current state
     * @type {number}
     */ this.s = start;
    }
    /**
   * @param {number} v
   */ write(v) {
        $f2f9f2c90ca1c855$export$ff90f819e16cc9bb(this, v - this.s);
        this.s = v;
    }
}
class $f2f9f2c90ca1c855$export$29917ece4cb403fb extends $f2f9f2c90ca1c855$export$a50aceb0e02a00aa {
    /**
   * @param {number} start
   */ constructor(start){
        super();
        /**
     * Current state
     * @type {number}
     */ this.s = start;
        this.count = 0;
    }
    /**
   * @param {number} v
   */ write(v) {
        if (this.s === v && this.count > 0) this.count++;
        else {
            if (this.count > 0) // flush counter, unless this is the first value (count = 0)
            $f2f9f2c90ca1c855$export$872f48c75febcd2b(this, this.count - 1) // since count is always > 0, we can decrement by one. non-standard encoding ftw
            ;
            this.count = 1;
            // write first value
            $f2f9f2c90ca1c855$export$ff90f819e16cc9bb(this, v - this.s);
            this.s = v;
        }
    }
}
/**
 * @param {UintOptRleEncoder} encoder
 */ const $f2f9f2c90ca1c855$var$flushUintOptRleEncoder = (encoder)=>{
    if (encoder.count > 0) {
        // flush counter, unless this is the first value (count = 0)
        // case 1: just a single value. set sign to positive
        // case 2: write several values. set sign to negative to indicate that there is a length coming
        $f2f9f2c90ca1c855$export$ff90f819e16cc9bb(encoder.encoder, encoder.count === 1 ? encoder.s : -encoder.s);
        if (encoder.count > 1) $f2f9f2c90ca1c855$export$872f48c75febcd2b(encoder.encoder, encoder.count - 2) // since count is always > 1, we can decrement by one. non-standard encoding ftw
        ;
    }
};
class $f2f9f2c90ca1c855$export$785ebd3312c38061 {
    constructor(){
        this.encoder = new $f2f9f2c90ca1c855$export$a50aceb0e02a00aa();
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
    }
    /**
   * @param {number} v
   */ write(v) {
        if (this.s === v) this.count++;
        else {
            $f2f9f2c90ca1c855$var$flushUintOptRleEncoder(this);
            this.count = 1;
            this.s = v;
        }
    }
    /**
   * Flush the encoded state and transform this to a Uint8Array.
   *
   * Note that this should only be called once.
   */ toUint8Array() {
        $f2f9f2c90ca1c855$var$flushUintOptRleEncoder(this);
        return $f2f9f2c90ca1c855$export$73470fd2221e6aef(this.encoder);
    }
}
class $f2f9f2c90ca1c855$export$f460a01fb0702193 {
    constructor(){
        this.encoder = new $f2f9f2c90ca1c855$export$a50aceb0e02a00aa();
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
    }
    /**
   * @param {number} v
   */ write(v) {
        if (this.s + this.count === v) this.count++;
        else {
            $f2f9f2c90ca1c855$var$flushUintOptRleEncoder(this);
            this.count = 1;
            this.s = v;
        }
    }
    /**
   * Flush the encoded state and transform this to a Uint8Array.
   *
   * Note that this should only be called once.
   */ toUint8Array() {
        $f2f9f2c90ca1c855$var$flushUintOptRleEncoder(this);
        return $f2f9f2c90ca1c855$export$73470fd2221e6aef(this.encoder);
    }
}
/**
 * @param {IntDiffOptRleEncoder} encoder
 */ const $f2f9f2c90ca1c855$var$flushIntDiffOptRleEncoder = (encoder)=>{
    if (encoder.count > 0) {
        //          31 bit making up the diff | wether to write the counter
        // const encodedDiff = encoder.diff << 1 | (encoder.count === 1 ? 0 : 1)
        const encodedDiff = encoder.diff * 2 + (encoder.count === 1 ? 0 : 1);
        // flush counter, unless this is the first value (count = 0)
        // case 1: just a single value. set first bit to positive
        // case 2: write several values. set first bit to negative to indicate that there is a length coming
        $f2f9f2c90ca1c855$export$ff90f819e16cc9bb(encoder.encoder, encodedDiff);
        if (encoder.count > 1) $f2f9f2c90ca1c855$export$872f48c75febcd2b(encoder.encoder, encoder.count - 2) // since count is always > 1, we can decrement by one. non-standard encoding ftw
        ;
    }
};
class $f2f9f2c90ca1c855$export$7542c66a59375c6f {
    constructor(){
        this.encoder = new $f2f9f2c90ca1c855$export$a50aceb0e02a00aa();
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
        this.diff = 0;
    }
    /**
   * @param {number} v
   */ write(v) {
        if (this.diff === v - this.s) {
            this.s = v;
            this.count++;
        } else {
            $f2f9f2c90ca1c855$var$flushIntDiffOptRleEncoder(this);
            this.count = 1;
            this.diff = v - this.s;
            this.s = v;
        }
    }
    /**
   * Flush the encoded state and transform this to a Uint8Array.
   *
   * Note that this should only be called once.
   */ toUint8Array() {
        $f2f9f2c90ca1c855$var$flushIntDiffOptRleEncoder(this);
        return $f2f9f2c90ca1c855$export$73470fd2221e6aef(this.encoder);
    }
}
class $f2f9f2c90ca1c855$export$7dcdc5c32f31c550 {
    constructor(){
        /**
     * @type {Array<string>}
     */ this.sarr = [];
        this.s = '';
        this.lensE = new $f2f9f2c90ca1c855$export$785ebd3312c38061();
    }
    /**
   * @param {string} string
   */ write(string) {
        this.s += string;
        if (this.s.length > 19) {
            this.sarr.push(this.s);
            this.s = '';
        }
        this.lensE.write(string.length);
    }
    toUint8Array() {
        const encoder = new $f2f9f2c90ca1c855$export$a50aceb0e02a00aa();
        this.sarr.push(this.s);
        this.s = '';
        $f2f9f2c90ca1c855$export$dde49cb52d5f1650(encoder, this.sarr.join(''));
        $f2f9f2c90ca1c855$export$73b5e63e27d2b4c7(encoder, this.lensE.toUint8Array());
        return $f2f9f2c90ca1c855$export$73470fd2221e6aef(encoder);
    }
}

});
parcelRegister("6BhQL", function(module, exports) {

$parcel$export(module.exports, "MAX_SAFE_INTEGER", () => $4ce40b6d239d0b82$export$18510406f204a1b9);
$parcel$export(module.exports, "isInteger", () => $4ce40b6d239d0b82$export$a287f47fed4544b8);
/**
 * Utility helpers for working with numbers.
 *
 * @module number
 */ 
var $bJmyZ = parcelRequire("bJmyZ");

var $6ciaJ = parcelRequire("6ciaJ");
const $4ce40b6d239d0b82$export$18510406f204a1b9 = Number.MAX_SAFE_INTEGER;
const $4ce40b6d239d0b82$export$91ddad910c1af487 = Number.MIN_SAFE_INTEGER;
const $4ce40b6d239d0b82$export$7accc3db8e859605 = -2147483648;
const $4ce40b6d239d0b82$export$a5f353c3c14c00d0 = $6ciaJ.BITS31;
const $4ce40b6d239d0b82$export$f055c566d4c0f541 = $6ciaJ.BITS32;
const $4ce40b6d239d0b82$export$a287f47fed4544b8 = Number.isInteger || ((num)=>typeof num === 'number' && isFinite(num) && $bJmyZ.floor(num) === num);
const $4ce40b6d239d0b82$export$c9f5652083b8129d = Number.isNaN;
const $4ce40b6d239d0b82$export$5f87784a266e50a4 = Number.parseInt;
const $4ce40b6d239d0b82$export$33de6ea056a4cdbb = (n)=>{
    n &= $6ciaJ.BITS32;
    let count = 0;
    while(n){
        n &= n - 1;
        count++;
    }
    return count;
};

});
parcelRegister("6ciaJ", function(module, exports) {

$parcel$export(module.exports, "BIT1", () => $4831f5a8babcface$export$ee2c6657cb286da4);
$parcel$export(module.exports, "BIT2", () => $4831f5a8babcface$export$1f117f3b0edc2676);
$parcel$export(module.exports, "BIT3", () => $4831f5a8babcface$export$e5294f8c78cf7711);
$parcel$export(module.exports, "BIT4", () => $4831f5a8babcface$export$873ae8db4cef5125);
$parcel$export(module.exports, "BIT6", () => $4831f5a8babcface$export$daf23f774967089);
$parcel$export(module.exports, "BIT7", () => $4831f5a8babcface$export$eb5a8e0006ab4bb5);
$parcel$export(module.exports, "BIT8", () => $4831f5a8babcface$export$e25597372303a045);
$parcel$export(module.exports, "BITS5", () => $4831f5a8babcface$export$bc2aba63e4099c09);
$parcel$export(module.exports, "BITS6", () => $4831f5a8babcface$export$f39f4e074e983a34);
$parcel$export(module.exports, "BITS7", () => $4831f5a8babcface$export$f84d6bebff154ceb);
$parcel$export(module.exports, "BITS8", () => $4831f5a8babcface$export$c880072ee0e87648);
$parcel$export(module.exports, "BITS21", () => $4831f5a8babcface$export$b5ffbef7f0f6f536);
$parcel$export(module.exports, "BITS31", () => $4831f5a8babcface$export$87ec42487f19c66c);
$parcel$export(module.exports, "BITS32", () => $4831f5a8babcface$export$3ea07c5174cba08a);
/* eslint-env browser */ /**
 * Binary data constants.
 *
 * @module binary
 */ /**
 * n-th bit activated.
 *
 * @type {number}
 */ const $4831f5a8babcface$export$ee2c6657cb286da4 = 1;
const $4831f5a8babcface$export$1f117f3b0edc2676 = 2;
const $4831f5a8babcface$export$e5294f8c78cf7711 = 4;
const $4831f5a8babcface$export$873ae8db4cef5125 = 8;
const $4831f5a8babcface$export$b6e6496517dfbd31 = 16;
const $4831f5a8babcface$export$daf23f774967089 = 32;
const $4831f5a8babcface$export$eb5a8e0006ab4bb5 = 64;
const $4831f5a8babcface$export$e25597372303a045 = 128;
const $4831f5a8babcface$export$f15587807021fe79 = 256;
const $4831f5a8babcface$export$70939d57ba836c5 = 512;
const $4831f5a8babcface$export$9ec47920d80e8c85 = 1024;
const $4831f5a8babcface$export$bc5dd16b35d4584b = 2048;
const $4831f5a8babcface$export$76a85e893e6d6ecc = 4096;
const $4831f5a8babcface$export$fb6ca64a3ffa3aa9 = 8192;
const $4831f5a8babcface$export$e7adc86ee9ea4b00 = 16384;
const $4831f5a8babcface$export$6aa68b9346d558bb = 32768;
const $4831f5a8babcface$export$5d7aab37466c79ea = 65536;
const $4831f5a8babcface$export$3aa401309ff3940 = 131072;
const $4831f5a8babcface$export$1fd8467d3320465f = 262144;
const $4831f5a8babcface$export$d1dceb84a396f684 = 524288;
const $4831f5a8babcface$export$ef62e7729d79baec = 1048576;
const $4831f5a8babcface$export$40651ae3846a7710 = 2097152;
const $4831f5a8babcface$export$e03976987cb0b818 = 4194304;
const $4831f5a8babcface$export$dd5dceb22223d8ef = 8388608;
const $4831f5a8babcface$export$aecaefba6ae044e4 = 16777216;
const $4831f5a8babcface$export$6e47d6f6c411c0e1 = 33554432;
const $4831f5a8babcface$export$321a8fda0150a18 = 67108864;
const $4831f5a8babcface$export$d7843230fff08622 = 134217728;
const $4831f5a8babcface$export$9fe7219cb72d1ed8 = 268435456;
const $4831f5a8babcface$export$c85121a54e1cc97f = 536870912;
const $4831f5a8babcface$export$76075a64dc7c21ef = 1073741824;
const $4831f5a8babcface$export$49d5cdcf29800e09 = -2147483648;
const $4831f5a8babcface$export$853d99058378c102 = 0;
const $4831f5a8babcface$export$b859c32a415b3ec1 = 1;
const $4831f5a8babcface$export$decefe6957191373 = 3;
const $4831f5a8babcface$export$d1defff3cbd2c6f4 = 7;
const $4831f5a8babcface$export$8d2b432c8c02ae65 = 15;
const $4831f5a8babcface$export$bc2aba63e4099c09 = 31;
const $4831f5a8babcface$export$f39f4e074e983a34 = 63;
const $4831f5a8babcface$export$f84d6bebff154ceb = 127;
const $4831f5a8babcface$export$c880072ee0e87648 = 255;
const $4831f5a8babcface$export$cbbfa5d3c076ad8c = 511;
const $4831f5a8babcface$export$e365aa75b5fa7293 = 1023;
const $4831f5a8babcface$export$51bfc23c1b7b60c3 = 2047;
const $4831f5a8babcface$export$3b0a099b88523ac = 4095;
const $4831f5a8babcface$export$8345c1c06d3e5fc1 = 8191;
const $4831f5a8babcface$export$e20cffba663a7688 = 16383;
const $4831f5a8babcface$export$cd0970fd37b207c6 = 32767;
const $4831f5a8babcface$export$250487b182389b6a = 65535;
const $4831f5a8babcface$export$9d6e01d73abdaadb = $4831f5a8babcface$export$3aa401309ff3940 - 1;
const $4831f5a8babcface$export$eedeab0ac4009664 = $4831f5a8babcface$export$1fd8467d3320465f - 1;
const $4831f5a8babcface$export$e1840c3c33a76ffc = $4831f5a8babcface$export$d1dceb84a396f684 - 1;
const $4831f5a8babcface$export$f0ae3ba8312e92e3 = $4831f5a8babcface$export$ef62e7729d79baec - 1;
const $4831f5a8babcface$export$b5ffbef7f0f6f536 = $4831f5a8babcface$export$40651ae3846a7710 - 1;
const $4831f5a8babcface$export$33ae34bc8e747862 = $4831f5a8babcface$export$e03976987cb0b818 - 1;
const $4831f5a8babcface$export$3629272792e6a9a0 = $4831f5a8babcface$export$dd5dceb22223d8ef - 1;
const $4831f5a8babcface$export$a07300a4cc2ba23c = $4831f5a8babcface$export$aecaefba6ae044e4 - 1;
const $4831f5a8babcface$export$9137f2824b26e02b = $4831f5a8babcface$export$6e47d6f6c411c0e1 - 1;
const $4831f5a8babcface$export$94d4c3aa7cfbb8dd = $4831f5a8babcface$export$321a8fda0150a18 - 1;
const $4831f5a8babcface$export$8af89455097efce0 = $4831f5a8babcface$export$d7843230fff08622 - 1;
const $4831f5a8babcface$export$dee9196bb8567fe9 = $4831f5a8babcface$export$9fe7219cb72d1ed8 - 1;
const $4831f5a8babcface$export$bd0b5ef1d89e90f = $4831f5a8babcface$export$c85121a54e1cc97f - 1;
const $4831f5a8babcface$export$e5560e011efa8766 = $4831f5a8babcface$export$76075a64dc7c21ef - 1;
const $4831f5a8babcface$export$87ec42487f19c66c = 0x7FFFFFFF;
const $4831f5a8babcface$export$3ea07c5174cba08a = 0xFFFFFFFF;

});


parcelRegister("1dTGB", function(module, exports) {

$parcel$export(module.exports, "fromCharCode", () => $0e42337049a5d7ba$export$30216c0101da0ee0);
$parcel$export(module.exports, "fromCamelCase", () => $0e42337049a5d7ba$export$87429743646c3257);
$parcel$export(module.exports, "utf8TextEncoder", () => $0e42337049a5d7ba$export$f3ce4806f2484eb);
$parcel$export(module.exports, "encodeUtf8", () => $0e42337049a5d7ba$export$8f647c2204da8484);
$parcel$export(module.exports, "utf8TextDecoder", () => $0e42337049a5d7ba$export$f477633695bbbcd);
$parcel$export(module.exports, "decodeUtf8", () => $0e42337049a5d7ba$export$72118b85b055afd);
$parcel$export(module.exports, "repeat", () => $0e42337049a5d7ba$export$76d90c956114f2c2);

var $dWqHQ = parcelRequire("dWqHQ");
const $0e42337049a5d7ba$export$30216c0101da0ee0 = String.fromCharCode;
const $0e42337049a5d7ba$export$73bfc63873071f74 = String.fromCodePoint;
const $0e42337049a5d7ba$export$e3a9a653b2a11ac1 = $0e42337049a5d7ba$export$30216c0101da0ee0(65535);
/**
 * @param {string} s
 * @return {string}
 */ const $0e42337049a5d7ba$var$toLowerCase = (s)=>s.toLowerCase();
const $0e42337049a5d7ba$var$trimLeftRegex = /^\s*/g;
const $0e42337049a5d7ba$export$c5557f40488c48ec = (s)=>s.replace($0e42337049a5d7ba$var$trimLeftRegex, '');
const $0e42337049a5d7ba$var$fromCamelCaseRegex = /([A-Z])/g;
const $0e42337049a5d7ba$export$87429743646c3257 = (s, separator)=>$0e42337049a5d7ba$export$c5557f40488c48ec(s.replace($0e42337049a5d7ba$var$fromCamelCaseRegex, (match)=>`${separator}${$0e42337049a5d7ba$var$toLowerCase(match)}`));
const $0e42337049a5d7ba$export$ba35f6b806a3dbd4 = (str)=>unescape(encodeURIComponent(str)).length;
const $0e42337049a5d7ba$export$83d8cea287b4dfcd = (str)=>{
    const encodedString = unescape(encodeURIComponent(str));
    const len = encodedString.length;
    const buf = new Uint8Array(len);
    for(let i = 0; i < len; i++)buf[i] = /** @type {number} */ encodedString.codePointAt(i);
    return buf;
};
const $0e42337049a5d7ba$export$f3ce4806f2484eb = /** @type {TextEncoder} */ typeof TextEncoder !== 'undefined' ? new TextEncoder() : null;
const $0e42337049a5d7ba$export$9a0a70804ee285dd = (str)=>$0e42337049a5d7ba$export$f3ce4806f2484eb.encode(str);
const $0e42337049a5d7ba$export$8f647c2204da8484 = $0e42337049a5d7ba$export$f3ce4806f2484eb ? $0e42337049a5d7ba$export$9a0a70804ee285dd : $0e42337049a5d7ba$export$83d8cea287b4dfcd;
const $0e42337049a5d7ba$export$154b750182ae32cf = (buf)=>{
    let remainingLen = buf.length;
    let encodedString = '';
    let bufPos = 0;
    while(remainingLen > 0){
        const nextLen = remainingLen < 10000 ? remainingLen : 10000;
        const bytes = buf.subarray(bufPos, bufPos + nextLen);
        bufPos += nextLen;
        // Starting with ES5.1 we can supply a generic array-like object as arguments
        encodedString += String.fromCodePoint.apply(null, /** @type {any} */ bytes);
        remainingLen -= nextLen;
    }
    return decodeURIComponent(escape(encodedString));
};
let $0e42337049a5d7ba$export$f477633695bbbcd = typeof TextDecoder === 'undefined' ? null : new TextDecoder('utf-8', {
    fatal: true,
    ignoreBOM: true
});
/* c8 ignore start */ if ($0e42337049a5d7ba$export$f477633695bbbcd && $0e42337049a5d7ba$export$f477633695bbbcd.decode(new Uint8Array()).length === 1) // Safari doesn't handle BOM correctly.
// This fixes a bug in Safari 13.0.5 where it produces a BOM the first time it is called.
// utf8TextDecoder.decode(new Uint8Array()).length === 1 on the first call and
// utf8TextDecoder.decode(new Uint8Array()).length === 1 on the second call
// Another issue is that from then on no BOM chars are recognized anymore
/* c8 ignore next */ $0e42337049a5d7ba$export$f477633695bbbcd = null;
const $0e42337049a5d7ba$export$23d5f1ce72f56168 = (buf)=>/** @type {TextDecoder} */ $0e42337049a5d7ba$export$f477633695bbbcd.decode(buf);
const $0e42337049a5d7ba$export$72118b85b055afd = $0e42337049a5d7ba$export$f477633695bbbcd ? $0e42337049a5d7ba$export$23d5f1ce72f56168 : $0e42337049a5d7ba$export$154b750182ae32cf;
const $0e42337049a5d7ba$export$869882364835d202 = (str, index, remove, insert = '')=>str.slice(0, index) + insert + str.slice(index + remove);
const $0e42337049a5d7ba$export$76d90c956114f2c2 = (source, n)=>$dWqHQ.unfold(n, ()=>source).join('');

});


parcelRegister("9QtgA", function(module, exports) {

$parcel$export(module.exports, "createDecoder", () => $72afac1be7f6db54$export$f8c898e83b60faaa);
$parcel$export(module.exports, "hasContent", () => $72afac1be7f6db54$export$7ad75c69830b76d7);
$parcel$export(module.exports, "readVarUint8Array", () => $72afac1be7f6db54$export$7418bbc18dee40f3);
$parcel$export(module.exports, "readVarUint", () => $72afac1be7f6db54$export$5a476e4dbe7923d5);
$parcel$export(module.exports, "readUint8", () => $72afac1be7f6db54$export$d5778a2beba4ceef);
$parcel$export(module.exports, "readVarInt", () => $72afac1be7f6db54$export$1dd5b9ddf6575ae8);
$parcel$export(module.exports, "readVarString", () => $72afac1be7f6db54$export$3b64b4d753b81ec2);
$parcel$export(module.exports, "readAny", () => $72afac1be7f6db54$export$82863139061f472f);
$parcel$export(module.exports, "RleDecoder", () => $72afac1be7f6db54$export$f1f1200492b832af);
$parcel$export(module.exports, "UintOptRleDecoder", () => $72afac1be7f6db54$export$2dc62fb2f864b82e);
$parcel$export(module.exports, "IntDiffOptRleDecoder", () => $72afac1be7f6db54$export$d502ab0bf048a596);
$parcel$export(module.exports, "StringDecoder", () => $72afac1be7f6db54$export$63a7aa211a91ed69);
/**
 * Efficient schema-less binary decoding with support for variable length encoding.
 *
 * Use [lib0/decoding] with [lib0/encoding]. Every encoding function has a corresponding decoding function.
 *
 * Encodes numbers in little-endian order (least to most significant byte order)
 * and is compatible with Golang's binary encoding (https://golang.org/pkg/encoding/binary/)
 * which is also used in Protocol Buffers.
 *
 * ```js
 * // encoding step
 * const encoder = encoding.createEncoder()
 * encoding.writeVarUint(encoder, 256)
 * encoding.writeVarString(encoder, 'Hello world!')
 * const buf = encoding.toUint8Array(encoder)
 * ```
 *
 * ```js
 * // decoding step
 * const decoder = decoding.createDecoder(buf)
 * decoding.readVarUint(decoder) // => 256
 * decoding.readVarString(decoder) // => 'Hello world!'
 * decoding.hasContent(decoder) // => false - all data is read
 * ```
 *
 * @module decoding
 */ 
var $6ciaJ = parcelRequire("6ciaJ");

var $bJmyZ = parcelRequire("bJmyZ");

var $6BhQL = parcelRequire("6BhQL");

var $1dTGB = parcelRequire("1dTGB");

var $gFLjS = parcelRequire("gFLjS");

var $kRma6 = parcelRequire("kRma6");
const $72afac1be7f6db54$var$errorUnexpectedEndOfArray = $gFLjS.create('Unexpected end of array');
const $72afac1be7f6db54$var$errorIntegerOutOfRange = $gFLjS.create('Integer out of Range');
class $72afac1be7f6db54$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array Binary data to decode
   */ constructor(uint8Array){
        /**
     * Decoding target.
     *
     * @type {Uint8Array}
     */ this.arr = uint8Array;
        /**
     * Current decoding position.
     *
     * @type {number}
     */ this.pos = 0;
    }
}
const $72afac1be7f6db54$export$f8c898e83b60faaa = (uint8Array)=>new $72afac1be7f6db54$export$f9de6ca0bc043724(uint8Array);
const $72afac1be7f6db54$export$7ad75c69830b76d7 = (decoder)=>decoder.pos !== decoder.arr.length;
const $72afac1be7f6db54$export$9cd59f9826255e47 = (decoder, newPos = decoder.pos)=>{
    const _decoder = $72afac1be7f6db54$export$f8c898e83b60faaa(decoder.arr);
    _decoder.pos = newPos;
    return _decoder;
};
const $72afac1be7f6db54$export$e21b2fe168d56a89 = (decoder, len)=>{
    const view = new Uint8Array(decoder.arr.buffer, decoder.pos + decoder.arr.byteOffset, len);
    decoder.pos += len;
    return view;
};
const $72afac1be7f6db54$export$7418bbc18dee40f3 = (decoder)=>$72afac1be7f6db54$export$e21b2fe168d56a89(decoder, $72afac1be7f6db54$export$5a476e4dbe7923d5(decoder));
const $72afac1be7f6db54$export$8c9f57cb3e3e2d3b = (decoder)=>$72afac1be7f6db54$export$e21b2fe168d56a89(decoder, decoder.arr.length - decoder.pos);
const $72afac1be7f6db54$export$228a9507fbdfcdb6 = (decoder)=>decoder.pos++;
const $72afac1be7f6db54$export$d5778a2beba4ceef = (decoder)=>decoder.arr[decoder.pos++];
const $72afac1be7f6db54$export$ef14636f4cf20706 = (decoder)=>{
    const uint = decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8);
    decoder.pos += 2;
    return uint;
};
const $72afac1be7f6db54$export$967c96218130b9ba = (decoder)=>{
    const uint = decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8) + (decoder.arr[decoder.pos + 2] << 16) + (decoder.arr[decoder.pos + 3] << 24) >>> 0;
    decoder.pos += 4;
    return uint;
};
const $72afac1be7f6db54$export$adb88b5d4ab91f4e = (decoder)=>{
    const uint = decoder.arr[decoder.pos + 3] + (decoder.arr[decoder.pos + 2] << 8) + (decoder.arr[decoder.pos + 1] << 16) + (decoder.arr[decoder.pos] << 24) >>> 0;
    decoder.pos += 4;
    return uint;
};
const $72afac1be7f6db54$export$c6eca102d0b41ca0 = (decoder)=>decoder.arr[decoder.pos];
const $72afac1be7f6db54$export$e5eb1e52afa13f8d = (decoder)=>decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8);
const $72afac1be7f6db54$export$67e54e775d28f9ae = (decoder)=>decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8) + (decoder.arr[decoder.pos + 2] << 16) + (decoder.arr[decoder.pos + 3] << 24) >>> 0;
const $72afac1be7f6db54$export$5a476e4dbe7923d5 = (decoder)=>{
    let num = 0;
    let mult = 1;
    const len = decoder.arr.length;
    while(decoder.pos < len){
        const r = decoder.arr[decoder.pos++];
        // num = num | ((r & binary.BITS7) << len)
        num = num + (r & $6ciaJ.BITS7) * mult // shift $r << (7*#iterations) and add it to num
        ;
        mult *= 128 // next iteration, shift 7 "more" to the left
        ;
        if (r < $6ciaJ.BIT8) return num;
        /* c8 ignore start */ if (num > $6BhQL.MAX_SAFE_INTEGER) throw $72afac1be7f6db54$var$errorIntegerOutOfRange;
    /* c8 ignore stop */ }
    throw $72afac1be7f6db54$var$errorUnexpectedEndOfArray;
};
const $72afac1be7f6db54$export$1dd5b9ddf6575ae8 = (decoder)=>{
    let r = decoder.arr[decoder.pos++];
    let num = r & $6ciaJ.BITS6;
    let mult = 64;
    const sign = (r & $6ciaJ.BIT7) > 0 ? -1 : 1;
    if ((r & $6ciaJ.BIT8) === 0) // don't continue reading
    return sign * num;
    const len = decoder.arr.length;
    while(decoder.pos < len){
        r = decoder.arr[decoder.pos++];
        // num = num | ((r & binary.BITS7) << len)
        num = num + (r & $6ciaJ.BITS7) * mult;
        mult *= 128;
        if (r < $6ciaJ.BIT8) return sign * num;
        /* c8 ignore start */ if (num > $6BhQL.MAX_SAFE_INTEGER) throw $72afac1be7f6db54$var$errorIntegerOutOfRange;
    /* c8 ignore stop */ }
    throw $72afac1be7f6db54$var$errorUnexpectedEndOfArray;
};
const $72afac1be7f6db54$export$dc86e1eb544aa5ab = (decoder)=>{
    const pos = decoder.pos;
    const s = $72afac1be7f6db54$export$5a476e4dbe7923d5(decoder);
    decoder.pos = pos;
    return s;
};
const $72afac1be7f6db54$export$47c43df02cd47fca = (decoder)=>{
    const pos = decoder.pos;
    const s = $72afac1be7f6db54$export$1dd5b9ddf6575ae8(decoder);
    decoder.pos = pos;
    return s;
};
const $72afac1be7f6db54$export$e73299e6158668bb = (decoder)=>{
    let remainingLen = $72afac1be7f6db54$export$5a476e4dbe7923d5(decoder);
    if (remainingLen === 0) return '';
    else {
        let encodedString = String.fromCodePoint($72afac1be7f6db54$export$d5778a2beba4ceef(decoder)) // remember to decrease remainingLen
        ;
        if (--remainingLen < 100) while(remainingLen--)encodedString += String.fromCodePoint($72afac1be7f6db54$export$d5778a2beba4ceef(decoder));
        else while(remainingLen > 0){
            const nextLen = remainingLen < 10000 ? remainingLen : 10000;
            // this is dangerous, we create a fresh array view from the existing buffer
            const bytes = decoder.arr.subarray(decoder.pos, decoder.pos + nextLen);
            decoder.pos += nextLen;
            // Starting with ES5.1 we can supply a generic array-like object as arguments
            encodedString += String.fromCodePoint.apply(null, /** @type {any} */ bytes);
            remainingLen -= nextLen;
        }
        return decodeURIComponent(escape(encodedString));
    }
};
const $72afac1be7f6db54$export$7247eefae50fb91a = (decoder)=>/** @type any */ $1dTGB.utf8TextDecoder.decode($72afac1be7f6db54$export$7418bbc18dee40f3(decoder));
const $72afac1be7f6db54$export$3b64b4d753b81ec2 = $1dTGB.utf8TextDecoder ? $72afac1be7f6db54$export$7247eefae50fb91a : $72afac1be7f6db54$export$e73299e6158668bb;
const $72afac1be7f6db54$export$23764cfecad9ae2f = (decoder)=>{
    const encoder = $kRma6.createEncoder();
    let b;
    while(true){
        b = $72afac1be7f6db54$export$d5778a2beba4ceef(decoder);
        if (b === 0) return $kRma6.toUint8Array(encoder);
        if (b === 1) b = $72afac1be7f6db54$export$d5778a2beba4ceef(decoder);
        $kRma6.write(encoder, b);
    }
};
const $72afac1be7f6db54$export$d38ec182b293d566 = (decoder)=>$1dTGB.decodeUtf8($72afac1be7f6db54$export$23764cfecad9ae2f(decoder));
const $72afac1be7f6db54$export$91c1f3f0dd9bd2f5 = (decoder)=>{
    const pos = decoder.pos;
    const s = $72afac1be7f6db54$export$3b64b4d753b81ec2(decoder);
    decoder.pos = pos;
    return s;
};
const $72afac1be7f6db54$export$d7dd05f632129fe5 = (decoder, len)=>{
    const dv = new DataView(decoder.arr.buffer, decoder.arr.byteOffset + decoder.pos, len);
    decoder.pos += len;
    return dv;
};
const $72afac1be7f6db54$export$dbc4aa781d9afe3b = (decoder)=>$72afac1be7f6db54$export$d7dd05f632129fe5(decoder, 4).getFloat32(0, false);
const $72afac1be7f6db54$export$d89a471990a89a7f = (decoder)=>$72afac1be7f6db54$export$d7dd05f632129fe5(decoder, 8).getFloat64(0, false);
const $72afac1be7f6db54$export$99e633bd4f295d85 = (decoder)=>/** @type {any} */ $72afac1be7f6db54$export$d7dd05f632129fe5(decoder, 8).getBigInt64(0, false);
const $72afac1be7f6db54$export$21575c47d1f9b652 = (decoder)=>/** @type {any} */ $72afac1be7f6db54$export$d7dd05f632129fe5(decoder, 8).getBigUint64(0, false);
/**
 * @type {Array<function(Decoder):any>}
 */ const $72afac1be7f6db54$var$readAnyLookupTable = [
    (decoder)=>undefined,
    (decoder)=>null,
    $72afac1be7f6db54$export$1dd5b9ddf6575ae8,
    $72afac1be7f6db54$export$dbc4aa781d9afe3b,
    $72afac1be7f6db54$export$d89a471990a89a7f,
    $72afac1be7f6db54$export$99e633bd4f295d85,
    (decoder)=>false,
    (decoder)=>true,
    $72afac1be7f6db54$export$3b64b4d753b81ec2,
    (decoder)=>{
        const len = $72afac1be7f6db54$export$5a476e4dbe7923d5(decoder);
        /**
     * @type {Object<string,any>}
     */ const obj = {};
        for(let i = 0; i < len; i++){
            const key = $72afac1be7f6db54$export$3b64b4d753b81ec2(decoder);
            obj[key] = $72afac1be7f6db54$export$82863139061f472f(decoder);
        }
        return obj;
    },
    (decoder)=>{
        const len = $72afac1be7f6db54$export$5a476e4dbe7923d5(decoder);
        const arr = [];
        for(let i = 0; i < len; i++)arr.push($72afac1be7f6db54$export$82863139061f472f(decoder));
        return arr;
    },
    $72afac1be7f6db54$export$7418bbc18dee40f3 // CASE 116: Uint8Array
];
const $72afac1be7f6db54$export$82863139061f472f = (decoder)=>$72afac1be7f6db54$var$readAnyLookupTable[127 - $72afac1be7f6db54$export$d5778a2beba4ceef(decoder)](decoder);
class $72afac1be7f6db54$export$f1f1200492b832af extends $72afac1be7f6db54$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array
   * @param {function(Decoder):T} reader
   */ constructor(uint8Array, reader){
        super(uint8Array);
        /**
     * The reader
     */ this.reader = reader;
        /**
     * Current state
     * @type {T|null}
     */ this.s = null;
        this.count = 0;
    }
    read() {
        if (this.count === 0) {
            this.s = this.reader(this);
            if ($72afac1be7f6db54$export$7ad75c69830b76d7(this)) this.count = $72afac1be7f6db54$export$5a476e4dbe7923d5(this) + 1 // see encoder implementation for the reason why this is incremented
            ;
            else this.count = -1 // read the current value forever
            ;
        }
        this.count--;
        return /** @type {T} */ this.s;
    }
}
class $72afac1be7f6db54$export$938378143fffe1b4 extends $72afac1be7f6db54$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array
   * @param {number} start
   */ constructor(uint8Array, start){
        super(uint8Array);
        /**
     * Current state
     * @type {number}
     */ this.s = start;
    }
    /**
   * @return {number}
   */ read() {
        this.s += $72afac1be7f6db54$export$1dd5b9ddf6575ae8(this);
        return this.s;
    }
}
class $72afac1be7f6db54$export$595b36f1b42934c6 extends $72afac1be7f6db54$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array
   * @param {number} start
   */ constructor(uint8Array, start){
        super(uint8Array);
        /**
     * Current state
     * @type {number}
     */ this.s = start;
        this.count = 0;
    }
    /**
   * @return {number}
   */ read() {
        if (this.count === 0) {
            this.s += $72afac1be7f6db54$export$1dd5b9ddf6575ae8(this);
            if ($72afac1be7f6db54$export$7ad75c69830b76d7(this)) this.count = $72afac1be7f6db54$export$5a476e4dbe7923d5(this) + 1 // see encoder implementation for the reason why this is incremented
            ;
            else this.count = -1 // read the current value forever
            ;
        }
        this.count--;
        return /** @type {number} */ this.s;
    }
}
class $72afac1be7f6db54$export$2dc62fb2f864b82e extends $72afac1be7f6db54$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array
   */ constructor(uint8Array){
        super(uint8Array);
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
    }
    read() {
        if (this.count === 0) {
            this.s = $72afac1be7f6db54$export$1dd5b9ddf6575ae8(this);
            // if the sign is negative, we read the count too, otherwise count is 1
            const isNegative = $bJmyZ.isNegativeZero(this.s);
            this.count = 1;
            if (isNegative) {
                this.s = -this.s;
                this.count = $72afac1be7f6db54$export$5a476e4dbe7923d5(this) + 2;
            }
        }
        this.count--;
        return /** @type {number} */ this.s;
    }
}
class $72afac1be7f6db54$export$727389af14dfe417 extends $72afac1be7f6db54$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array
   */ constructor(uint8Array){
        super(uint8Array);
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
    }
    read() {
        if (this.count === 0) {
            this.s = $72afac1be7f6db54$export$1dd5b9ddf6575ae8(this);
            // if the sign is negative, we read the count too, otherwise count is 1
            const isNegative = $bJmyZ.isNegativeZero(this.s);
            this.count = 1;
            if (isNegative) {
                this.s = -this.s;
                this.count = $72afac1be7f6db54$export$5a476e4dbe7923d5(this) + 2;
            }
        }
        this.count--;
        return /** @type {number} */ this.s++;
    }
}
class $72afac1be7f6db54$export$d502ab0bf048a596 extends $72afac1be7f6db54$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array
   */ constructor(uint8Array){
        super(uint8Array);
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
        this.diff = 0;
    }
    /**
   * @return {number}
   */ read() {
        if (this.count === 0) {
            const diff = $72afac1be7f6db54$export$1dd5b9ddf6575ae8(this);
            // if the first bit is set, we read more data
            const hasCount = diff & 1;
            this.diff = $bJmyZ.floor(diff / 2) // shift >> 1
            ;
            this.count = 1;
            if (hasCount) this.count = $72afac1be7f6db54$export$5a476e4dbe7923d5(this) + 2;
        }
        this.s += this.diff;
        this.count--;
        return this.s;
    }
}
class $72afac1be7f6db54$export$63a7aa211a91ed69 {
    /**
   * @param {Uint8Array} uint8Array
   */ constructor(uint8Array){
        this.decoder = new $72afac1be7f6db54$export$2dc62fb2f864b82e(uint8Array);
        this.str = $72afac1be7f6db54$export$3b64b4d753b81ec2(this.decoder);
        /**
     * @type {number}
     */ this.spos = 0;
    }
    /**
   * @return {string}
   */ read() {
        const end = this.spos + this.decoder.read();
        const res = this.str.slice(this.spos, end);
        this.spos = end;
        return res;
    }
}

});
parcelRegister("gFLjS", function(module, exports) {

$parcel$export(module.exports, "create", () => $c2352e58238453c8$export$185802fd694ee1f5);
$parcel$export(module.exports, "methodUnimplemented", () => $c2352e58238453c8$export$73ced5c7e10d6d0f);
$parcel$export(module.exports, "unexpectedCase", () => $c2352e58238453c8$export$965b6bccecbd9673);
/**
 * Error helpers.
 *
 * @module error
 */ /**
 * @param {string} s
 * @return {Error}
 */ /* c8 ignore next */ const $c2352e58238453c8$export$185802fd694ee1f5 = (s)=>new Error(s);
const $c2352e58238453c8$export$73ced5c7e10d6d0f = ()=>{
    throw $c2352e58238453c8$export$185802fd694ee1f5('Method unimplemented');
};
const $c2352e58238453c8$export$965b6bccecbd9673 = ()=>{
    throw $c2352e58238453c8$export$185802fd694ee1f5('Unexpected case');
};

});


parcelRegister("2ocYS", function(module, exports) {

$parcel$export(module.exports, "uint32", () => $1bd7e460a097150f$export$de9ffb9418dd7d0d);
$parcel$export(module.exports, "uuidv4", () => $1bd7e460a097150f$export$abe4376e1bf796d6);
/**
 * Isomorphic module for true random numbers / buffers / uuids.
 *
 * Attention: falls back to Math.random if the browser does not support crypto.
 *
 * @module random
 */ 
var $bJmyZ = parcelRequire("bJmyZ");

var $6ciaJ = parcelRequire("6ciaJ");

var $gTs2D = parcelRequire("gTs2D");
const $1bd7e460a097150f$export$bb0a9c36cf454ea0 = Math.random;
const $1bd7e460a097150f$export$de9ffb9418dd7d0d = ()=>(0, $gTs2D.getRandomValues)(new Uint32Array(1))[0];
const $1bd7e460a097150f$export$6bf94e3d82617e4e = ()=>{
    const arr = (0, $gTs2D.getRandomValues)(new Uint32Array(8));
    return (arr[0] & $6ciaJ.BITS21) * ($6ciaJ.BITS32 + 1) + (arr[1] >>> 0);
};
const $1bd7e460a097150f$export$a9a18ae5ba42aeab = (arr)=>arr[$bJmyZ.floor($1bd7e460a097150f$export$bb0a9c36cf454ea0() * arr.length)];
// @ts-ignore
const $1bd7e460a097150f$var$uuidv4Template = "10000000-1000-4000-8000-100000000000";
const $1bd7e460a097150f$export$abe4376e1bf796d6 = ()=>$1bd7e460a097150f$var$uuidv4Template.replace(/[018]/g, /** @param {number} c */ (c)=>(c ^ $1bd7e460a097150f$export$de9ffb9418dd7d0d() & 15 >> c / 4).toString(16));

});
parcelRegister("gTs2D", function(module, exports) {

$parcel$export(module.exports, "getRandomValues", () => $c4c788da6f1faac8$export$960b9ff25e7d4257);
/* eslint-env browser */ const $c4c788da6f1faac8$export$f45422fd2e8042d4 = crypto.subtle;
const $c4c788da6f1faac8$export$960b9ff25e7d4257 = crypto.getRandomValues.bind(crypto);

});


parcelRegister("kSy7V", function(module, exports) {

$parcel$export(module.exports, "create", () => $f33352a75d80a57b$export$185802fd694ee1f5);
/**
 * Utility helpers to work with promises.
 *
 * @module promise
 */ 
var $drUmF = parcelRequire("drUmF");
const $f33352a75d80a57b$export$185802fd694ee1f5 = (f)=>/** @type {Promise<T>} */ new Promise(f);
const $f33352a75d80a57b$export$fe201bb3bbe031e9 = (f)=>new Promise(f);
const $f33352a75d80a57b$export$84bf76cd7afc7469 = Promise.all.bind(Promise);
const $f33352a75d80a57b$export$2800f3ceda99eb84 = (reason)=>Promise.reject(reason);
const $f33352a75d80a57b$export$f7ad0328861e2f03 = (res)=>Promise.resolve(res);
const $f33352a75d80a57b$export$65eff93aa071dbbd = (res)=>Promise.resolve(res);
const $f33352a75d80a57b$export$a40009bd2c363351 = (timeout, check, intervalResolution = 10)=>$f33352a75d80a57b$export$185802fd694ee1f5((resolve, reject)=>{
        const startTime = $drUmF.getUnixTime();
        const hasTimeout = timeout > 0;
        const untilInterval = ()=>{
            if (check()) {
                clearInterval(intervalHandle);
                resolve();
            } else if (hasTimeout) /* c8 ignore else */ {
                if ($drUmF.getUnixTime() - startTime > timeout) {
                    clearInterval(intervalHandle);
                    reject(new Error('Timeout'));
                }
            }
        };
        const intervalHandle = setInterval(untilInterval, intervalResolution);
    });
const $f33352a75d80a57b$export$6ab8c822a2b03a03 = async (check, timeout = 0, intervalResolution = 10)=>{
    const startTime = $drUmF.getUnixTime();
    const noTimeout = timeout <= 0;
    // eslint-disable-next-line no-unmodified-loop-condition
    while(noTimeout || $drUmF.getUnixTime() - startTime <= timeout){
        if (await check()) return;
        await $f33352a75d80a57b$export$5c069c93d2b7493f(intervalResolution);
    }
    throw new Error('Timeout');
};
const $f33352a75d80a57b$export$5c069c93d2b7493f = (timeout)=>$f33352a75d80a57b$export$185802fd694ee1f5((resolve, _reject)=>setTimeout(resolve, timeout));
const $f33352a75d80a57b$export$4369c812aac99591 = (p)=>p instanceof Promise || p && p.then && p.catch && p.finally;

});
parcelRegister("drUmF", function(module, exports) {

$parcel$export(module.exports, "getUnixTime", () => $9ca984d61e4a8f44$export$1f77c0008d16313);
/**
 * Utility module to work with time.
 *
 * @module time
 */ 
var $5aVib = parcelRequire("5aVib");

var $bJmyZ = parcelRequire("bJmyZ");
const $9ca984d61e4a8f44$export$aa350b96d91cd94 = ()=>new Date();
const $9ca984d61e4a8f44$export$1f77c0008d16313 = Date.now;
const $9ca984d61e4a8f44$export$70cb903099cabea3 = (d)=>{
    if (d < 60000) {
        const p = $5aVib.prefix(d, -1);
        return $bJmyZ.round(p.n * 100) / 100 + p.prefix + 's';
    }
    d = $bJmyZ.floor(d / 1000);
    const seconds = d % 60;
    const minutes = $bJmyZ.floor(d / 60) % 60;
    const hours = $bJmyZ.floor(d / 3600) % 24;
    const days = $bJmyZ.floor(d / 86400);
    if (days > 0) return days + 'd' + (hours > 0 || minutes > 30 ? ' ' + (minutes > 30 ? hours + 1 : hours) + 'h' : '');
    if (hours > 0) /* c8 ignore next */ return hours + 'h' + (minutes > 0 || seconds > 30 ? ' ' + (seconds > 30 ? minutes + 1 : minutes) + 'min' : '');
    return minutes + 'min' + (seconds > 0 ? ' ' + seconds + 's' : '');
};

});
parcelRegister("5aVib", function(module, exports) {

$parcel$export(module.exports, "prefix", () => $3c4a53fa3ccd0b84$export$82e9f45cca5ba907);
/**
 * Utility module to convert metric values.
 *
 * @module metric
 */ 
var $bJmyZ = parcelRequire("bJmyZ");
const $3c4a53fa3ccd0b84$export$3c3f39195836e927 = 1e24;
const $3c4a53fa3ccd0b84$export$bc1fc8bc8e1895cf = 1e21;
const $3c4a53fa3ccd0b84$export$91377b751fc464a0 = 1e18;
const $3c4a53fa3ccd0b84$export$fc10d2598c9417a5 = 1e15;
const $3c4a53fa3ccd0b84$export$ce366dc9d5abf7ac = 1e12;
const $3c4a53fa3ccd0b84$export$197e40aa3a484017 = 1e9;
const $3c4a53fa3ccd0b84$export$580f1e8cf64f2815 = 1e6;
const $3c4a53fa3ccd0b84$export$a3ed9693cfbf67fa = 1e3;
const $3c4a53fa3ccd0b84$export$6ec17edd70114a88 = 1e2;
const $3c4a53fa3ccd0b84$export$6ffbaf3528ca9f3f = 10;
const $3c4a53fa3ccd0b84$export$ec5800edbd9f0b69 = 0.1;
const $3c4a53fa3ccd0b84$export$9faf718fe58aaa35 = 0.01;
const $3c4a53fa3ccd0b84$export$fab274f99578ceb6 = 1e-3;
const $3c4a53fa3ccd0b84$export$77bd0ce503b87b26 = 1e-6;
const $3c4a53fa3ccd0b84$export$ddef5c050164e23e = 1e-9;
const $3c4a53fa3ccd0b84$export$e10c52a2ab594201 = 1e-12;
const $3c4a53fa3ccd0b84$export$c49f04803481822 = 1e-15;
const $3c4a53fa3ccd0b84$export$5510a0bcf77f39 = 1e-18;
const $3c4a53fa3ccd0b84$export$2b85cc24af20b7fe = 1e-21;
const $3c4a53fa3ccd0b84$export$a2878e23774b59ce = 1e-24;
const $3c4a53fa3ccd0b84$var$prefixUp = [
    '',
    'k',
    'M',
    'G',
    'T',
    'P',
    'E',
    'Z',
    'Y'
];
const $3c4a53fa3ccd0b84$var$prefixDown = [
    '',
    'm',
    "\u03BC",
    'n',
    'p',
    'f',
    'a',
    'z',
    'y'
];
const $3c4a53fa3ccd0b84$export$82e9f45cca5ba907 = (n, baseMultiplier = 0)=>{
    const nPow = n === 0 ? 0 : $bJmyZ.log10(n);
    let mult = 0;
    while(nPow < mult * 3 && baseMultiplier > -8){
        baseMultiplier--;
        mult--;
    }
    while(nPow >= 3 + mult * 3 && baseMultiplier < 8){
        baseMultiplier++;
        mult++;
    }
    const prefix = baseMultiplier < 0 ? $3c4a53fa3ccd0b84$var$prefixDown[-baseMultiplier] : $3c4a53fa3ccd0b84$var$prefixUp[baseMultiplier];
    return {
        n: $bJmyZ.round((mult > 0 ? n / $bJmyZ.exp10(mult * 3) : n * $bJmyZ.exp10(mult * -3)) * 1e12) / 1e12,
        prefix: prefix
    };
};

});



parcelRegister("7WDUw", function(module, exports) {

$parcel$export(module.exports, "createUint8ArrayFromArrayBuffer", () => $5c8ce8962693cc22$export$1b999ddd54e5bed1);
$parcel$export(module.exports, "toBase64", () => $5c8ce8962693cc22$export$37cc283d8fbd3462);
$parcel$export(module.exports, "fromBase64", () => $5c8ce8962693cc22$export$c537b38001c583b7);
$parcel$export(module.exports, "copyUint8Array", () => $5c8ce8962693cc22$export$fe6f60023cd5ffaf);
/**
 * Utility functions to work with buffers (Uint8Array).
 *
 * @module buffer
 */ 
var $1dTGB = parcelRequire("1dTGB");

var $kRoyo = parcelRequire("kRoyo");

var $dWqHQ = parcelRequire("dWqHQ");

var $bJmyZ = parcelRequire("bJmyZ");

var $kRma6 = parcelRequire("kRma6");

var $9QtgA = parcelRequire("9QtgA");

var $djTVs = parcelRequire("djTVs");
var $5c8ce8962693cc22$require$Buffer = $djTVs.Buffer;
const $5c8ce8962693cc22$export$79a0c4c40eecffbb = (len)=>new Uint8Array(len);
const $5c8ce8962693cc22$export$f3c8b5f6d250ec43 = (buffer, byteOffset, length)=>new Uint8Array(buffer, byteOffset, length);
const $5c8ce8962693cc22$export$1b999ddd54e5bed1 = (buffer)=>new Uint8Array(buffer);
/* c8 ignore start */ /**
 * @param {Uint8Array} bytes
 * @return {string}
 */ const $5c8ce8962693cc22$var$toBase64Browser = (bytes)=>{
    let s = '';
    for(let i = 0; i < bytes.byteLength; i++)s += $1dTGB.fromCharCode(bytes[i]);
    // eslint-disable-next-line no-undef
    return btoa(s);
};
/* c8 ignore stop */ /**
 * @param {Uint8Array} bytes
 * @return {string}
 */ const $5c8ce8962693cc22$var$toBase64Node = (bytes)=>$5c8ce8962693cc22$require$Buffer.from(bytes.buffer, bytes.byteOffset, bytes.byteLength).toString('base64');
/* c8 ignore start */ /**
 * @param {string} s
 * @return {Uint8Array}
 */ const $5c8ce8962693cc22$var$fromBase64Browser = (s)=>{
    // eslint-disable-next-line no-undef
    const a = atob(s);
    const bytes = $5c8ce8962693cc22$export$79a0c4c40eecffbb(a.length);
    for(let i = 0; i < a.length; i++)bytes[i] = a.charCodeAt(i);
    return bytes;
};
/* c8 ignore stop */ /**
 * @param {string} s
 */ const $5c8ce8962693cc22$var$fromBase64Node = (s)=>{
    const buf = $5c8ce8962693cc22$require$Buffer.from(s, 'base64');
    return $5c8ce8962693cc22$export$f3c8b5f6d250ec43(buf.buffer, buf.byteOffset, buf.byteLength);
};
const $5c8ce8962693cc22$export$37cc283d8fbd3462 = $kRoyo.isBrowser ? $5c8ce8962693cc22$var$toBase64Browser : $5c8ce8962693cc22$var$toBase64Node;
const $5c8ce8962693cc22$export$c537b38001c583b7 = $kRoyo.isBrowser ? $5c8ce8962693cc22$var$fromBase64Browser : $5c8ce8962693cc22$var$fromBase64Node;
const $5c8ce8962693cc22$export$31f478961f22a29 = (buf)=>$5c8ce8962693cc22$export$37cc283d8fbd3462(buf).replaceAll('+', '-').replaceAll('/', '_').replaceAll('=', '');
const $5c8ce8962693cc22$export$2fcb175ca881fa06 = (base64)=>$5c8ce8962693cc22$export$c537b38001c583b7(base64.replaceAll('-', '+').replaceAll('_', '/'));
const $5c8ce8962693cc22$export$f4915efbb94d4d01 = (buf)=>$dWqHQ.map(buf, (b)=>b.toString(16).padStart(2, '0')).join('');
const $5c8ce8962693cc22$export$99a70112ceb8327b = (hex)=>{
    const hlen = hex.length;
    const buf = new Uint8Array($bJmyZ.ceil(hlen / 2));
    for(let i = 0; i < hlen; i += 2)buf[buf.length - i / 2 - 1] = Number.parseInt(hex.slice(hlen - i - 2, hlen - i), 16);
    return buf;
};
const $5c8ce8962693cc22$export$fe6f60023cd5ffaf = (uint8Array)=>{
    const newBuf = $5c8ce8962693cc22$export$79a0c4c40eecffbb(uint8Array.byteLength);
    newBuf.set(uint8Array);
    return newBuf;
};
const $5c8ce8962693cc22$export$355ad3726be07997 = (data)=>$kRma6.encode((encoder)=>$kRma6.writeAny(encoder, data));
const $5c8ce8962693cc22$export$929c279cfec29a23 = (buf)=>$9QtgA.readAny($9QtgA.createDecoder(buf));
const $5c8ce8962693cc22$export$e87773390ebfdab4 = (bs, N)=>{
    if (N === 0) return bs;
    bs = new Uint8Array(bs);
    bs[0] <<= N;
    for(let i = 1; i < bs.length; i++){
        bs[i - 1] |= bs[i] >>> 8 - N;
        bs[i] <<= N;
    }
    return bs;
};

});
parcelRegister("kRoyo", function(module, exports) {

$parcel$export(module.exports, "isNode", () => $f2fbcdc01e41b0be$export$8ee0fc9ee280b4ee);
$parcel$export(module.exports, "isBrowser", () => $f2fbcdc01e41b0be$export$4e09c449d6c407f7);
$parcel$export(module.exports, "getVariable", () => $f2fbcdc01e41b0be$export$39fb32ac18db3f88);
$parcel$export(module.exports, "supportsColor", () => $f2fbcdc01e41b0be$export$fcbe44f5d6fcebd);
/**
 * Isomorphic module to work access the environment (query params, env variables).
 *
 * @module environment
 */ 
var $d1VR8 = parcelRequire("d1VR8");

var $1dTGB = parcelRequire("1dTGB");

var $4kmLV = parcelRequire("4kmLV");

var $btW3J = parcelRequire("btW3J");

var $45hHO = parcelRequire("45hHO");

var $iZPu2 = parcelRequire("iZPu2");
const $f2fbcdc01e41b0be$export$8ee0fc9ee280b4ee = typeof $iZPu2 !== 'undefined' && $iZPu2.release && /node|io\.js/.test($iZPu2.release.name) && Object.prototype.toString.call(typeof $iZPu2 !== 'undefined' ? $iZPu2 : 0) === '[object process]';
const $f2fbcdc01e41b0be$export$4e09c449d6c407f7 = typeof window !== 'undefined' && typeof document !== 'undefined' && !$f2fbcdc01e41b0be$export$8ee0fc9ee280b4ee;
const $f2fbcdc01e41b0be$export$9ac100e40613ea10 = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
/**
 * @type {Map<string,string>}
 */ let $f2fbcdc01e41b0be$var$params;
const $f2fbcdc01e41b0be$var$args = [];
/* c8 ignore start */ const $f2fbcdc01e41b0be$var$computeParams = ()=>{
    if ($f2fbcdc01e41b0be$var$params === undefined) {
        if ($f2fbcdc01e41b0be$export$8ee0fc9ee280b4ee) {
            $f2fbcdc01e41b0be$var$params = $d1VR8.create();
            const pargs = $iZPu2.argv;
            let currParamName = null;
            for(let i = 0; i < pargs.length; i++){
                const parg = pargs[i];
                if (parg[0] === '-') {
                    if (currParamName !== null) $f2fbcdc01e41b0be$var$params.set(currParamName, '');
                    currParamName = parg;
                } else if (currParamName !== null) {
                    $f2fbcdc01e41b0be$var$params.set(currParamName, parg);
                    currParamName = null;
                } else $f2fbcdc01e41b0be$var$args.push(parg);
            }
            if (currParamName !== null) $f2fbcdc01e41b0be$var$params.set(currParamName, '');
        // in ReactNative for example this would not be true (unless connected to the Remote Debugger)
        } else if (typeof location === 'object') {
            $f2fbcdc01e41b0be$var$params = $d1VR8.create(); // eslint-disable-next-line no-undef
            (location.search || '?').slice(1).split('&').forEach((kv)=>{
                if (kv.length !== 0) {
                    const [key, value] = kv.split('=');
                    $f2fbcdc01e41b0be$var$params.set(`--${$1dTGB.fromCamelCase(key, '-')}`, value);
                    $f2fbcdc01e41b0be$var$params.set(`-${$1dTGB.fromCamelCase(key, '-')}`, value);
                }
            });
        } else $f2fbcdc01e41b0be$var$params = $d1VR8.create();
    }
    return $f2fbcdc01e41b0be$var$params;
};
const $f2fbcdc01e41b0be$export$3ad523d4e4ddff75 = (name)=>$f2fbcdc01e41b0be$var$computeParams().has(name);
const $f2fbcdc01e41b0be$export$ecf541e09a511845 = (name, defaultVal)=>$f2fbcdc01e41b0be$var$computeParams().get(name) || defaultVal;
const $f2fbcdc01e41b0be$export$39fb32ac18db3f88 = (name)=>$f2fbcdc01e41b0be$export$8ee0fc9ee280b4ee ? $4kmLV.undefinedToNull($iZPu2.env[name.toUpperCase().replaceAll('-', '_')]) : $4kmLV.undefinedToNull($btW3J.varStorage.getItem(name));
const $f2fbcdc01e41b0be$export$137940a4fd07b923 = (name)=>$f2fbcdc01e41b0be$var$computeParams().get('--' + name) || $f2fbcdc01e41b0be$export$39fb32ac18db3f88(name);
const $f2fbcdc01e41b0be$export$e336c1d2b3b2390d = (name)=>{
    const c = $f2fbcdc01e41b0be$export$137940a4fd07b923(name);
    if (c == null) throw new Error(`Expected configuration "${name.toUpperCase().replaceAll('-', '_')}"`);
    return c;
};
const $f2fbcdc01e41b0be$export$41f29dc169f5b0eb = (name)=>$f2fbcdc01e41b0be$export$3ad523d4e4ddff75('--' + name) || $f2fbcdc01e41b0be$export$39fb32ac18db3f88(name) !== null;
const $f2fbcdc01e41b0be$export$d71d1489bc353e92 = $f2fbcdc01e41b0be$export$41f29dc169f5b0eb('production');
/* c8 ignore next 2 */ const $f2fbcdc01e41b0be$var$forceColor = $f2fbcdc01e41b0be$export$8ee0fc9ee280b4ee && $45hHO.isOneOf(undefined, [
    'true',
    '1',
    '2'
]);
const $f2fbcdc01e41b0be$export$fcbe44f5d6fcebd = $f2fbcdc01e41b0be$var$forceColor || !$f2fbcdc01e41b0be$export$3ad523d4e4ddff75('--no-colors') && // @todo deprecate --no-colors
!$f2fbcdc01e41b0be$export$41f29dc169f5b0eb('no-color') && (!$f2fbcdc01e41b0be$export$8ee0fc9ee280b4ee || $iZPu2.stdout.isTTY) && (!$f2fbcdc01e41b0be$export$8ee0fc9ee280b4ee || $f2fbcdc01e41b0be$export$3ad523d4e4ddff75('--color') || $f2fbcdc01e41b0be$export$39fb32ac18db3f88('COLORTERM') !== null || ($f2fbcdc01e41b0be$export$39fb32ac18db3f88('TERM') || '').includes('color')) /* c8 ignore stop */ ;

});
parcelRegister("4kmLV", function(module, exports) {

$parcel$export(module.exports, "undefinedToNull", () => $326ab1b401c2934c$export$43874719a1af321f);
/**
 * Often used conditions.
 *
 * @module conditions
 */ /**
 * @template T
 * @param {T|null|undefined} v
 * @return {T|null}
 */ /* c8 ignore next */ const $326ab1b401c2934c$export$43874719a1af321f = (v)=>v === undefined ? null : v;

});

parcelRegister("btW3J", function(module, exports) {

$parcel$export(module.exports, "varStorage", () => $85bf7078f0210c80$export$86b84a8d42aa2c65);
$parcel$export(module.exports, "onChange", () => $85bf7078f0210c80$export$bd913411069e59d3);
$parcel$export(module.exports, "offChange", () => $85bf7078f0210c80$export$ff6a13ad336aa064);
/* eslint-env browser */ /**
 * Isomorphic variable storage.
 *
 * Uses LocalStorage in the browser and falls back to in-memory storage.
 *
 * @module storage
 */ /* c8 ignore start */ class $85bf7078f0210c80$var$VarStoragePolyfill {
    constructor(){
        this.map = new Map();
    }
    /**
   * @param {string} key
   * @param {any} newValue
   */ setItem(key, newValue) {
        this.map.set(key, newValue);
    }
    /**
   * @param {string} key
   */ getItem(key) {
        return this.map.get(key);
    }
}
/* c8 ignore stop */ /**
 * @type {any}
 */ let $85bf7078f0210c80$var$_localStorage = new $85bf7078f0210c80$var$VarStoragePolyfill();
let $85bf7078f0210c80$var$usePolyfill = true;
/* c8 ignore start */ try {
    // if the same-origin rule is violated, accessing localStorage might thrown an error
    if (typeof localStorage !== 'undefined' && localStorage) {
        $85bf7078f0210c80$var$_localStorage = localStorage;
        $85bf7078f0210c80$var$usePolyfill = false;
    }
} catch (e) {}
const $85bf7078f0210c80$export$86b84a8d42aa2c65 = $85bf7078f0210c80$var$_localStorage;
const $85bf7078f0210c80$export$bd913411069e59d3 = (eventHandler)=>$85bf7078f0210c80$var$usePolyfill || addEventListener('storage', /** @type {any} */ eventHandler);
const $85bf7078f0210c80$export$ff6a13ad336aa064 = (eventHandler)=>$85bf7078f0210c80$var$usePolyfill || removeEventListener('storage', /** @type {any} */ eventHandler);

});

parcelRegister("45hHO", function(module, exports) {

$parcel$export(module.exports, "callAll", () => $2f955d01468fe9eb$export$9dd9a52f2dd5b9ce);
$parcel$export(module.exports, "nop", () => $2f955d01468fe9eb$export$b5f1cfe7b08e6ed5);
$parcel$export(module.exports, "id", () => $2f955d01468fe9eb$export$d560c7e4a29451c2);
$parcel$export(module.exports, "equalityDeep", () => $2f955d01468fe9eb$export$2ca9a723affd5d11);
$parcel$export(module.exports, "isOneOf", () => $2f955d01468fe9eb$export$532a90c0e5e8e48c);
/**
 * Common functions and function call helpers.
 *
 * @module function
 */ 
var $dWqHQ = parcelRequire("dWqHQ");

var $4m6H0 = parcelRequire("4m6H0");
const $2f955d01468fe9eb$export$9dd9a52f2dd5b9ce = (fs, args, i = 0)=>{
    try {
        for(; i < fs.length; i++)fs[i](...args);
    } finally{
        if (i < fs.length) $2f955d01468fe9eb$export$9dd9a52f2dd5b9ce(fs, args, i + 1);
    }
};
const $2f955d01468fe9eb$export$b5f1cfe7b08e6ed5 = ()=>{};
const $2f955d01468fe9eb$export$5635d7ef4b8fee1c = (f)=>f();
const $2f955d01468fe9eb$export$d560c7e4a29451c2 = (a)=>a;
const $2f955d01468fe9eb$export$bbb1dcf8c6c6bac1 = (a, b)=>a === b;
const $2f955d01468fe9eb$export$6ca82605a98f2278 = (a, b)=>a === b || a != null && b != null && a.constructor === b.constructor && ($dWqHQ.isArray(a) && $dWqHQ.equalFlat(a, /** @type {Array<T>} */ b) || typeof a === 'object' && $4m6H0.equalFlat(a, b));
const $2f955d01468fe9eb$export$2ca9a723affd5d11 = (a, b)=>{
    if (a == null || b == null) return $2f955d01468fe9eb$export$bbb1dcf8c6c6bac1(a, b);
    if (a.constructor !== b.constructor) return false;
    if (a === b) return true;
    switch(a.constructor){
        case ArrayBuffer:
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // eslint-disable-next-line no-fallthrough
        case Uint8Array:
            if (a.byteLength !== b.byteLength) return false;
            for(let i = 0; i < a.length; i++){
                if (a[i] !== b[i]) return false;
            }
            break;
        case Set:
            if (a.size !== b.size) return false;
            for (const value of a){
                if (!b.has(value)) return false;
            }
            break;
        case Map:
            if (a.size !== b.size) return false;
            for (const key of a.keys()){
                if (!b.has(key) || !$2f955d01468fe9eb$export$2ca9a723affd5d11(a.get(key), b.get(key))) return false;
            }
            break;
        case Object:
            if ($4m6H0.length(a) !== $4m6H0.length(b)) return false;
            for(const key in a){
                if (!$4m6H0.hasProperty(a, key) || !$2f955d01468fe9eb$export$2ca9a723affd5d11(a[key], b[key])) return false;
            }
            break;
        case Array:
            if (a.length !== b.length) return false;
            for(let i = 0; i < a.length; i++){
                if (!$2f955d01468fe9eb$export$2ca9a723affd5d11(a[i], b[i])) return false;
            }
            break;
        default:
            return false;
    }
    return true;
};
const $2f955d01468fe9eb$export$532a90c0e5e8e48c = (value, options)=>options.includes(value);
const $2f955d01468fe9eb$export$43bee75e5e14138e = $dWqHQ.isArray;
const $2f955d01468fe9eb$export$844ec244b1367d54 = (s)=>s && s.constructor === String;
const $2f955d01468fe9eb$export$7e4aa119212bc614 = (n)=>n != null && n.constructor === Number;
const $2f955d01468fe9eb$export$226b3eccf92c9ed9 = (n, T)=>n && n.constructor === T;
const $2f955d01468fe9eb$export$6306e0d85c68df69 = (T)=>/**
   * @param {any} n
   * @return {n is InstanceType<TYPE>}
   **/ (n)=>n && n.constructor === T;

});
parcelRegister("4m6H0", function(module, exports) {

$parcel$export(module.exports, "assign", () => $32be6884f1380a63$export$e6e34fd1f2686227);
$parcel$export(module.exports, "forEach", () => $32be6884f1380a63$export$4b80e395e36b5a56);
$parcel$export(module.exports, "map", () => $32be6884f1380a63$export$871de8747c9eaa88);
$parcel$export(module.exports, "length", () => $32be6884f1380a63$export$f24224f1c91d8156);
$parcel$export(module.exports, "isEmpty", () => $32be6884f1380a63$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "hasProperty", () => $32be6884f1380a63$export$bf9617eaf5d2451);
$parcel$export(module.exports, "equalFlat", () => $32be6884f1380a63$export$4f1c34abb2bb4c8);
$parcel$export(module.exports, "deepFreeze", () => $32be6884f1380a63$export$7e32b29e1cb162e1);
/**
 * Utility functions for working with EcmaScript objects.
 *
 * @module object
 */ /**
 * @return {Object<string,any>} obj
 */ const $32be6884f1380a63$export$185802fd694ee1f5 = ()=>Object.create(null);
const $32be6884f1380a63$export$e6e34fd1f2686227 = Object.assign;
const $32be6884f1380a63$export$ed97f33186d4b816 = Object.keys;
const $32be6884f1380a63$export$4b80e395e36b5a56 = (obj, f)=>{
    for(const key in obj)f(obj[key], key);
};
const $32be6884f1380a63$export$871de8747c9eaa88 = (obj, f)=>{
    const results = [];
    for(const key in obj)results.push(f(obj[key], key));
    return results;
};
const $32be6884f1380a63$export$f24224f1c91d8156 = (obj)=>$32be6884f1380a63$export$ed97f33186d4b816(obj).length;
const $32be6884f1380a63$export$346677f925de839c = (obj)=>$32be6884f1380a63$export$ed97f33186d4b816(obj).length;
const $32be6884f1380a63$export$ad14ef4001db2bcd = (obj, f)=>{
    for(const key in obj){
        if (f(obj[key], key)) return true;
    }
    return false;
};
const $32be6884f1380a63$export$dd1bc94b04021eeb = (obj)=>{
    // eslint-disable-next-line
    for(const _k in obj)return false;
    return true;
};
const $32be6884f1380a63$export$7ecc1a3b11b57dab = (obj, f)=>{
    for(const key in obj){
        if (!f(obj[key], key)) return false;
    }
    return true;
};
const $32be6884f1380a63$export$bf9617eaf5d2451 = (obj, key)=>Object.prototype.hasOwnProperty.call(obj, key);
const $32be6884f1380a63$export$4f1c34abb2bb4c8 = (a, b)=>a === b || $32be6884f1380a63$export$346677f925de839c(a) === $32be6884f1380a63$export$346677f925de839c(b) && $32be6884f1380a63$export$7ecc1a3b11b57dab(a, (val, key)=>(val !== undefined || $32be6884f1380a63$export$bf9617eaf5d2451(b, key)) && b[key] === val);
const $32be6884f1380a63$export$792f3d81ea979f55 = Object.freeze;
const $32be6884f1380a63$export$7e32b29e1cb162e1 = (o)=>{
    for(const key in o){
        const c = o[key];
        if (typeof c === 'object' || typeof c === 'function') $32be6884f1380a63$export$7e32b29e1cb162e1(o[key]);
    }
    return $32be6884f1380a63$export$792f3d81ea979f55(o);
};

});


parcelRegister("iZPu2", function(module, exports) {
// shim for using process in browser
var $dd45dc0d1af9c139$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $dd45dc0d1af9c139$var$cachedSetTimeout;
var $dd45dc0d1af9c139$var$cachedClearTimeout;
function $dd45dc0d1af9c139$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $dd45dc0d1af9c139$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $dd45dc0d1af9c139$var$cachedSetTimeout = setTimeout;
        else $dd45dc0d1af9c139$var$cachedSetTimeout = $dd45dc0d1af9c139$var$defaultSetTimout;
    } catch (e) {
        $dd45dc0d1af9c139$var$cachedSetTimeout = $dd45dc0d1af9c139$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $dd45dc0d1af9c139$var$cachedClearTimeout = clearTimeout;
        else $dd45dc0d1af9c139$var$cachedClearTimeout = $dd45dc0d1af9c139$var$defaultClearTimeout;
    } catch (e) {
        $dd45dc0d1af9c139$var$cachedClearTimeout = $dd45dc0d1af9c139$var$defaultClearTimeout;
    }
})();
function $dd45dc0d1af9c139$var$runTimeout(fun) {
    if ($dd45dc0d1af9c139$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($dd45dc0d1af9c139$var$cachedSetTimeout === $dd45dc0d1af9c139$var$defaultSetTimout || !$dd45dc0d1af9c139$var$cachedSetTimeout) && setTimeout) {
        $dd45dc0d1af9c139$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $dd45dc0d1af9c139$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $dd45dc0d1af9c139$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $dd45dc0d1af9c139$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $dd45dc0d1af9c139$var$runClearTimeout(marker) {
    if ($dd45dc0d1af9c139$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($dd45dc0d1af9c139$var$cachedClearTimeout === $dd45dc0d1af9c139$var$defaultClearTimeout || !$dd45dc0d1af9c139$var$cachedClearTimeout) && clearTimeout) {
        $dd45dc0d1af9c139$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $dd45dc0d1af9c139$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $dd45dc0d1af9c139$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $dd45dc0d1af9c139$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $dd45dc0d1af9c139$var$queue = [];
var $dd45dc0d1af9c139$var$draining = false;
var $dd45dc0d1af9c139$var$currentQueue;
var $dd45dc0d1af9c139$var$queueIndex = -1;
function $dd45dc0d1af9c139$var$cleanUpNextTick() {
    if (!$dd45dc0d1af9c139$var$draining || !$dd45dc0d1af9c139$var$currentQueue) return;
    $dd45dc0d1af9c139$var$draining = false;
    if ($dd45dc0d1af9c139$var$currentQueue.length) $dd45dc0d1af9c139$var$queue = $dd45dc0d1af9c139$var$currentQueue.concat($dd45dc0d1af9c139$var$queue);
    else $dd45dc0d1af9c139$var$queueIndex = -1;
    if ($dd45dc0d1af9c139$var$queue.length) $dd45dc0d1af9c139$var$drainQueue();
}
function $dd45dc0d1af9c139$var$drainQueue() {
    if ($dd45dc0d1af9c139$var$draining) return;
    var timeout = $dd45dc0d1af9c139$var$runTimeout($dd45dc0d1af9c139$var$cleanUpNextTick);
    $dd45dc0d1af9c139$var$draining = true;
    var len = $dd45dc0d1af9c139$var$queue.length;
    while(len){
        $dd45dc0d1af9c139$var$currentQueue = $dd45dc0d1af9c139$var$queue;
        $dd45dc0d1af9c139$var$queue = [];
        while(++$dd45dc0d1af9c139$var$queueIndex < len)if ($dd45dc0d1af9c139$var$currentQueue) $dd45dc0d1af9c139$var$currentQueue[$dd45dc0d1af9c139$var$queueIndex].run();
        $dd45dc0d1af9c139$var$queueIndex = -1;
        len = $dd45dc0d1af9c139$var$queue.length;
    }
    $dd45dc0d1af9c139$var$currentQueue = null;
    $dd45dc0d1af9c139$var$draining = false;
    $dd45dc0d1af9c139$var$runClearTimeout(timeout);
}
$dd45dc0d1af9c139$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $dd45dc0d1af9c139$var$queue.push(new $dd45dc0d1af9c139$var$Item(fun, args));
    if ($dd45dc0d1af9c139$var$queue.length === 1 && !$dd45dc0d1af9c139$var$draining) $dd45dc0d1af9c139$var$runTimeout($dd45dc0d1af9c139$var$drainQueue);
};
// v8 likes predictible objects
function $dd45dc0d1af9c139$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$dd45dc0d1af9c139$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$dd45dc0d1af9c139$var$process.title = 'browser';
$dd45dc0d1af9c139$var$process.browser = true;
$dd45dc0d1af9c139$var$process.env = {};
$dd45dc0d1af9c139$var$process.argv = [];
$dd45dc0d1af9c139$var$process.version = ''; // empty string to avoid regexp issues
$dd45dc0d1af9c139$var$process.versions = {};
function $dd45dc0d1af9c139$var$noop() {}
$dd45dc0d1af9c139$var$process.on = $dd45dc0d1af9c139$var$noop;
$dd45dc0d1af9c139$var$process.addListener = $dd45dc0d1af9c139$var$noop;
$dd45dc0d1af9c139$var$process.once = $dd45dc0d1af9c139$var$noop;
$dd45dc0d1af9c139$var$process.off = $dd45dc0d1af9c139$var$noop;
$dd45dc0d1af9c139$var$process.removeListener = $dd45dc0d1af9c139$var$noop;
$dd45dc0d1af9c139$var$process.removeAllListeners = $dd45dc0d1af9c139$var$noop;
$dd45dc0d1af9c139$var$process.emit = $dd45dc0d1af9c139$var$noop;
$dd45dc0d1af9c139$var$process.prependListener = $dd45dc0d1af9c139$var$noop;
$dd45dc0d1af9c139$var$process.prependOnceListener = $dd45dc0d1af9c139$var$noop;
$dd45dc0d1af9c139$var$process.listeners = function(name) {
    return [];
};
$dd45dc0d1af9c139$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$dd45dc0d1af9c139$var$process.cwd = function() {
    return '/';
};
$dd45dc0d1af9c139$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$dd45dc0d1af9c139$var$process.umask = function() {
    return 0;
};

});


parcelRegister("djTVs", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $9b286e5f237c4a32$export$a143d493d941bafc, (v) => $9b286e5f237c4a32$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $9b286e5f237c4a32$export$f99ded8fe4b79145, (v) => $9b286e5f237c4a32$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $9b286e5f237c4a32$export$a143d493d941bafc;
var $9b286e5f237c4a32$export$e4cf37d7f6fb9e0a;
var $9b286e5f237c4a32$export$f99ded8fe4b79145;
var $9b286e5f237c4a32$export$599f31c3813fae4d;
'use strict';

var $a7ttr = parcelRequire("a7ttr");

var $dAiKa = parcelRequire("dAiKa");
const $9b286e5f237c4a32$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$9b286e5f237c4a32$export$a143d493d941bafc = $9b286e5f237c4a32$var$Buffer;
$9b286e5f237c4a32$export$e4cf37d7f6fb9e0a = $9b286e5f237c4a32$var$SlowBuffer;
$9b286e5f237c4a32$export$f99ded8fe4b79145 = 50;
const $9b286e5f237c4a32$var$K_MAX_LENGTH = 0x7fffffff;
$9b286e5f237c4a32$export$599f31c3813fae4d = $9b286e5f237c4a32$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $9b286e5f237c4a32$var$Buffer.TYPED_ARRAY_SUPPORT = $9b286e5f237c4a32$var$typedArraySupport();
if (!$9b286e5f237c4a32$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $9b286e5f237c4a32$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($9b286e5f237c4a32$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$9b286e5f237c4a32$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($9b286e5f237c4a32$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$9b286e5f237c4a32$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $9b286e5f237c4a32$var$createBuffer(length) {
    if (length > $9b286e5f237c4a32$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $9b286e5f237c4a32$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $9b286e5f237c4a32$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $9b286e5f237c4a32$var$allocUnsafe(arg);
    }
    return $9b286e5f237c4a32$var$from(arg, encodingOrOffset, length);
}
$9b286e5f237c4a32$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $9b286e5f237c4a32$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $9b286e5f237c4a32$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $9b286e5f237c4a32$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($9b286e5f237c4a32$var$isInstance(value, ArrayBuffer) || value && $9b286e5f237c4a32$var$isInstance(value.buffer, ArrayBuffer)) return $9b286e5f237c4a32$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($9b286e5f237c4a32$var$isInstance(value, SharedArrayBuffer) || value && $9b286e5f237c4a32$var$isInstance(value.buffer, SharedArrayBuffer))) return $9b286e5f237c4a32$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $9b286e5f237c4a32$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $9b286e5f237c4a32$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $9b286e5f237c4a32$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $9b286e5f237c4a32$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $9b286e5f237c4a32$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($9b286e5f237c4a32$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($9b286e5f237c4a32$var$Buffer, Uint8Array);
function $9b286e5f237c4a32$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $9b286e5f237c4a32$var$alloc(size, fill, encoding) {
    $9b286e5f237c4a32$var$assertSize(size);
    if (size <= 0) return $9b286e5f237c4a32$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $9b286e5f237c4a32$var$createBuffer(size).fill(fill, encoding) : $9b286e5f237c4a32$var$createBuffer(size).fill(fill);
    return $9b286e5f237c4a32$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $9b286e5f237c4a32$var$Buffer.alloc = function(size, fill, encoding) {
    return $9b286e5f237c4a32$var$alloc(size, fill, encoding);
};
function $9b286e5f237c4a32$var$allocUnsafe(size) {
    $9b286e5f237c4a32$var$assertSize(size);
    return $9b286e5f237c4a32$var$createBuffer(size < 0 ? 0 : $9b286e5f237c4a32$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $9b286e5f237c4a32$var$Buffer.allocUnsafe = function(size) {
    return $9b286e5f237c4a32$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $9b286e5f237c4a32$var$Buffer.allocUnsafeSlow = function(size) {
    return $9b286e5f237c4a32$var$allocUnsafe(size);
};
function $9b286e5f237c4a32$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$9b286e5f237c4a32$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $9b286e5f237c4a32$var$byteLength(string, encoding) | 0;
    let buf = $9b286e5f237c4a32$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $9b286e5f237c4a32$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $9b286e5f237c4a32$var$checked(array.length) | 0;
    const buf = $9b286e5f237c4a32$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $9b286e5f237c4a32$var$fromArrayView(arrayView) {
    if ($9b286e5f237c4a32$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $9b286e5f237c4a32$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $9b286e5f237c4a32$var$fromArrayLike(arrayView);
}
function $9b286e5f237c4a32$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $9b286e5f237c4a32$var$Buffer.prototype);
    return buf;
}
function $9b286e5f237c4a32$var$fromObject(obj) {
    if ($9b286e5f237c4a32$var$Buffer.isBuffer(obj)) {
        const len = $9b286e5f237c4a32$var$checked(obj.length) | 0;
        const buf = $9b286e5f237c4a32$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $9b286e5f237c4a32$var$numberIsNaN(obj.length)) return $9b286e5f237c4a32$var$createBuffer(0);
        return $9b286e5f237c4a32$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $9b286e5f237c4a32$var$fromArrayLike(obj.data);
}
function $9b286e5f237c4a32$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $9b286e5f237c4a32$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $9b286e5f237c4a32$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $9b286e5f237c4a32$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $9b286e5f237c4a32$var$Buffer.alloc(+length);
}
$9b286e5f237c4a32$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $9b286e5f237c4a32$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$9b286e5f237c4a32$var$Buffer.compare = function compare(a, b) {
    if ($9b286e5f237c4a32$var$isInstance(a, Uint8Array)) a = $9b286e5f237c4a32$var$Buffer.from(a, a.offset, a.byteLength);
    if ($9b286e5f237c4a32$var$isInstance(b, Uint8Array)) b = $9b286e5f237c4a32$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$9b286e5f237c4a32$var$Buffer.isBuffer(a) || !$9b286e5f237c4a32$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$9b286e5f237c4a32$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$9b286e5f237c4a32$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $9b286e5f237c4a32$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $9b286e5f237c4a32$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($9b286e5f237c4a32$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$9b286e5f237c4a32$var$Buffer.isBuffer(buf)) buf = $9b286e5f237c4a32$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$9b286e5f237c4a32$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $9b286e5f237c4a32$var$byteLength(string, encoding) {
    if ($9b286e5f237c4a32$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $9b286e5f237c4a32$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $9b286e5f237c4a32$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $9b286e5f237c4a32$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $9b286e5f237c4a32$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$9b286e5f237c4a32$var$Buffer.byteLength = $9b286e5f237c4a32$var$byteLength;
function $9b286e5f237c4a32$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $9b286e5f237c4a32$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $9b286e5f237c4a32$var$utf8Slice(this, start, end);
        case 'ascii':
            return $9b286e5f237c4a32$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $9b286e5f237c4a32$var$latin1Slice(this, start, end);
        case 'base64':
            return $9b286e5f237c4a32$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $9b286e5f237c4a32$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$9b286e5f237c4a32$var$Buffer.prototype._isBuffer = true;
function $9b286e5f237c4a32$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$9b286e5f237c4a32$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$9b286e5f237c4a32$var$swap(this, i, i + 1);
    return this;
};
$9b286e5f237c4a32$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $9b286e5f237c4a32$var$swap(this, i, i + 3);
        $9b286e5f237c4a32$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$9b286e5f237c4a32$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $9b286e5f237c4a32$var$swap(this, i, i + 7);
        $9b286e5f237c4a32$var$swap(this, i + 1, i + 6);
        $9b286e5f237c4a32$var$swap(this, i + 2, i + 5);
        $9b286e5f237c4a32$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$9b286e5f237c4a32$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $9b286e5f237c4a32$var$utf8Slice(this, 0, length);
    return $9b286e5f237c4a32$var$slowToString.apply(this, arguments);
};
$9b286e5f237c4a32$var$Buffer.prototype.toLocaleString = $9b286e5f237c4a32$var$Buffer.prototype.toString;
$9b286e5f237c4a32$var$Buffer.prototype.equals = function equals(b) {
    if (!$9b286e5f237c4a32$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $9b286e5f237c4a32$var$Buffer.compare(this, b) === 0;
};
$9b286e5f237c4a32$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $9b286e5f237c4a32$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($9b286e5f237c4a32$var$customInspectSymbol) $9b286e5f237c4a32$var$Buffer.prototype[$9b286e5f237c4a32$var$customInspectSymbol] = $9b286e5f237c4a32$var$Buffer.prototype.inspect;
$9b286e5f237c4a32$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($9b286e5f237c4a32$var$isInstance(target, Uint8Array)) target = $9b286e5f237c4a32$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$9b286e5f237c4a32$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $9b286e5f237c4a32$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($9b286e5f237c4a32$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $9b286e5f237c4a32$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($9b286e5f237c4a32$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $9b286e5f237c4a32$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $9b286e5f237c4a32$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $9b286e5f237c4a32$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$9b286e5f237c4a32$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$9b286e5f237c4a32$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $9b286e5f237c4a32$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$9b286e5f237c4a32$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $9b286e5f237c4a32$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $9b286e5f237c4a32$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($9b286e5f237c4a32$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $9b286e5f237c4a32$var$utf8Write(buf, string, offset, length) {
    return $9b286e5f237c4a32$var$blitBuffer($9b286e5f237c4a32$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $9b286e5f237c4a32$var$asciiWrite(buf, string, offset, length) {
    return $9b286e5f237c4a32$var$blitBuffer($9b286e5f237c4a32$var$asciiToBytes(string), buf, offset, length);
}
function $9b286e5f237c4a32$var$base64Write(buf, string, offset, length) {
    return $9b286e5f237c4a32$var$blitBuffer($9b286e5f237c4a32$var$base64ToBytes(string), buf, offset, length);
}
function $9b286e5f237c4a32$var$ucs2Write(buf, string, offset, length) {
    return $9b286e5f237c4a32$var$blitBuffer($9b286e5f237c4a32$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$9b286e5f237c4a32$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $9b286e5f237c4a32$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $9b286e5f237c4a32$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $9b286e5f237c4a32$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $9b286e5f237c4a32$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $9b286e5f237c4a32$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$9b286e5f237c4a32$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $9b286e5f237c4a32$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $a7ttr.fromByteArray(buf);
    else return $a7ttr.fromByteArray(buf.slice(start, end));
}
function $9b286e5f237c4a32$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $9b286e5f237c4a32$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $9b286e5f237c4a32$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $9b286e5f237c4a32$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $9b286e5f237c4a32$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $9b286e5f237c4a32$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $9b286e5f237c4a32$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $9b286e5f237c4a32$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $9b286e5f237c4a32$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $9b286e5f237c4a32$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $9b286e5f237c4a32$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$9b286e5f237c4a32$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $9b286e5f237c4a32$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $9b286e5f237c4a32$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$9b286e5f237c4a32$var$Buffer.prototype.readUintLE = $9b286e5f237c4a32$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $9b286e5f237c4a32$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$9b286e5f237c4a32$var$Buffer.prototype.readUintBE = $9b286e5f237c4a32$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $9b286e5f237c4a32$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$9b286e5f237c4a32$var$Buffer.prototype.readUint8 = $9b286e5f237c4a32$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9b286e5f237c4a32$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$9b286e5f237c4a32$var$Buffer.prototype.readUint16LE = $9b286e5f237c4a32$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9b286e5f237c4a32$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$9b286e5f237c4a32$var$Buffer.prototype.readUint16BE = $9b286e5f237c4a32$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9b286e5f237c4a32$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$9b286e5f237c4a32$var$Buffer.prototype.readUint32LE = $9b286e5f237c4a32$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9b286e5f237c4a32$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$9b286e5f237c4a32$var$Buffer.prototype.readUint32BE = $9b286e5f237c4a32$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9b286e5f237c4a32$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$9b286e5f237c4a32$var$Buffer.prototype.readBigUInt64LE = $9b286e5f237c4a32$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $9b286e5f237c4a32$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $9b286e5f237c4a32$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$9b286e5f237c4a32$var$Buffer.prototype.readBigUInt64BE = $9b286e5f237c4a32$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $9b286e5f237c4a32$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $9b286e5f237c4a32$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$9b286e5f237c4a32$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $9b286e5f237c4a32$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$9b286e5f237c4a32$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $9b286e5f237c4a32$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$9b286e5f237c4a32$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9b286e5f237c4a32$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$9b286e5f237c4a32$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9b286e5f237c4a32$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$9b286e5f237c4a32$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9b286e5f237c4a32$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$9b286e5f237c4a32$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9b286e5f237c4a32$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$9b286e5f237c4a32$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9b286e5f237c4a32$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$9b286e5f237c4a32$var$Buffer.prototype.readBigInt64LE = $9b286e5f237c4a32$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $9b286e5f237c4a32$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $9b286e5f237c4a32$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$9b286e5f237c4a32$var$Buffer.prototype.readBigInt64BE = $9b286e5f237c4a32$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $9b286e5f237c4a32$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $9b286e5f237c4a32$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$9b286e5f237c4a32$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9b286e5f237c4a32$var$checkOffset(offset, 4, this.length);
    return $dAiKa.read(this, offset, true, 23, 4);
};
$9b286e5f237c4a32$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9b286e5f237c4a32$var$checkOffset(offset, 4, this.length);
    return $dAiKa.read(this, offset, false, 23, 4);
};
$9b286e5f237c4a32$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9b286e5f237c4a32$var$checkOffset(offset, 8, this.length);
    return $dAiKa.read(this, offset, true, 52, 8);
};
$9b286e5f237c4a32$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9b286e5f237c4a32$var$checkOffset(offset, 8, this.length);
    return $dAiKa.read(this, offset, false, 52, 8);
};
function $9b286e5f237c4a32$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$9b286e5f237c4a32$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$9b286e5f237c4a32$var$Buffer.prototype.writeUintLE = $9b286e5f237c4a32$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $9b286e5f237c4a32$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$9b286e5f237c4a32$var$Buffer.prototype.writeUintBE = $9b286e5f237c4a32$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $9b286e5f237c4a32$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$9b286e5f237c4a32$var$Buffer.prototype.writeUint8 = $9b286e5f237c4a32$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9b286e5f237c4a32$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$9b286e5f237c4a32$var$Buffer.prototype.writeUint16LE = $9b286e5f237c4a32$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9b286e5f237c4a32$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$9b286e5f237c4a32$var$Buffer.prototype.writeUint16BE = $9b286e5f237c4a32$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9b286e5f237c4a32$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$9b286e5f237c4a32$var$Buffer.prototype.writeUint32LE = $9b286e5f237c4a32$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9b286e5f237c4a32$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$9b286e5f237c4a32$var$Buffer.prototype.writeUint32BE = $9b286e5f237c4a32$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9b286e5f237c4a32$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $9b286e5f237c4a32$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $9b286e5f237c4a32$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $9b286e5f237c4a32$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $9b286e5f237c4a32$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$9b286e5f237c4a32$var$Buffer.prototype.writeBigUInt64LE = $9b286e5f237c4a32$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $9b286e5f237c4a32$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$9b286e5f237c4a32$var$Buffer.prototype.writeBigUInt64BE = $9b286e5f237c4a32$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $9b286e5f237c4a32$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$9b286e5f237c4a32$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $9b286e5f237c4a32$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$9b286e5f237c4a32$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $9b286e5f237c4a32$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$9b286e5f237c4a32$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9b286e5f237c4a32$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$9b286e5f237c4a32$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9b286e5f237c4a32$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$9b286e5f237c4a32$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9b286e5f237c4a32$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$9b286e5f237c4a32$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9b286e5f237c4a32$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$9b286e5f237c4a32$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9b286e5f237c4a32$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$9b286e5f237c4a32$var$Buffer.prototype.writeBigInt64LE = $9b286e5f237c4a32$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $9b286e5f237c4a32$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$9b286e5f237c4a32$var$Buffer.prototype.writeBigInt64BE = $9b286e5f237c4a32$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $9b286e5f237c4a32$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $9b286e5f237c4a32$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $9b286e5f237c4a32$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9b286e5f237c4a32$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $dAiKa.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$9b286e5f237c4a32$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $9b286e5f237c4a32$var$writeFloat(this, value, offset, true, noAssert);
};
$9b286e5f237c4a32$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $9b286e5f237c4a32$var$writeFloat(this, value, offset, false, noAssert);
};
function $9b286e5f237c4a32$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9b286e5f237c4a32$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $dAiKa.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$9b286e5f237c4a32$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $9b286e5f237c4a32$var$writeDouble(this, value, offset, true, noAssert);
};
$9b286e5f237c4a32$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $9b286e5f237c4a32$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$9b286e5f237c4a32$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$9b286e5f237c4a32$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$9b286e5f237c4a32$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$9b286e5f237c4a32$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $9b286e5f237c4a32$var$Buffer.isBuffer(val) ? val : $9b286e5f237c4a32$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $9b286e5f237c4a32$var$errors = {};
function $9b286e5f237c4a32$var$E(sym, getMessage, Base) {
    $9b286e5f237c4a32$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$9b286e5f237c4a32$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$9b286e5f237c4a32$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$9b286e5f237c4a32$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $9b286e5f237c4a32$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $9b286e5f237c4a32$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $9b286e5f237c4a32$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $9b286e5f237c4a32$var$checkBounds(buf, offset, byteLength) {
    $9b286e5f237c4a32$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $9b286e5f237c4a32$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $9b286e5f237c4a32$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $9b286e5f237c4a32$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $9b286e5f237c4a32$var$checkBounds(buf, offset, byteLength);
}
function $9b286e5f237c4a32$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $9b286e5f237c4a32$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $9b286e5f237c4a32$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $9b286e5f237c4a32$var$validateNumber(value, type);
        throw new $9b286e5f237c4a32$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $9b286e5f237c4a32$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $9b286e5f237c4a32$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $9b286e5f237c4a32$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $9b286e5f237c4a32$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($9b286e5f237c4a32$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $9b286e5f237c4a32$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $9b286e5f237c4a32$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $9b286e5f237c4a32$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $9b286e5f237c4a32$var$base64ToBytes(str) {
    return $a7ttr.toByteArray($9b286e5f237c4a32$var$base64clean(str));
}
function $9b286e5f237c4a32$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $9b286e5f237c4a32$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $9b286e5f237c4a32$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $9b286e5f237c4a32$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $9b286e5f237c4a32$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $9b286e5f237c4a32$var$BufferBigIntNotDefined : fn;
}
function $9b286e5f237c4a32$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("a7ttr", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $75e16bb6a5e6e4e1$export$d622b2ad8d90c771, (v) => $75e16bb6a5e6e4e1$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $75e16bb6a5e6e4e1$export$6100ba28696e12de, (v) => $75e16bb6a5e6e4e1$export$6100ba28696e12de = v);
var $75e16bb6a5e6e4e1$export$a48f0734ac7c2329;
var $75e16bb6a5e6e4e1$export$d622b2ad8d90c771;
var $75e16bb6a5e6e4e1$export$6100ba28696e12de;
'use strict';
$75e16bb6a5e6e4e1$export$a48f0734ac7c2329 = $75e16bb6a5e6e4e1$var$byteLength;
$75e16bb6a5e6e4e1$export$d622b2ad8d90c771 = $75e16bb6a5e6e4e1$var$toByteArray;
$75e16bb6a5e6e4e1$export$6100ba28696e12de = $75e16bb6a5e6e4e1$var$fromByteArray;
var $75e16bb6a5e6e4e1$var$lookup = [];
var $75e16bb6a5e6e4e1$var$revLookup = [];
var $75e16bb6a5e6e4e1$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $75e16bb6a5e6e4e1$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $75e16bb6a5e6e4e1$var$i = 0, $75e16bb6a5e6e4e1$var$len = $75e16bb6a5e6e4e1$var$code.length; $75e16bb6a5e6e4e1$var$i < $75e16bb6a5e6e4e1$var$len; ++$75e16bb6a5e6e4e1$var$i){
    $75e16bb6a5e6e4e1$var$lookup[$75e16bb6a5e6e4e1$var$i] = $75e16bb6a5e6e4e1$var$code[$75e16bb6a5e6e4e1$var$i];
    $75e16bb6a5e6e4e1$var$revLookup[$75e16bb6a5e6e4e1$var$code.charCodeAt($75e16bb6a5e6e4e1$var$i)] = $75e16bb6a5e6e4e1$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$75e16bb6a5e6e4e1$var$revLookup['-'.charCodeAt(0)] = 62;
$75e16bb6a5e6e4e1$var$revLookup['_'.charCodeAt(0)] = 63;
function $75e16bb6a5e6e4e1$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $75e16bb6a5e6e4e1$var$byteLength(b64) {
    var lens = $75e16bb6a5e6e4e1$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $75e16bb6a5e6e4e1$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $75e16bb6a5e6e4e1$var$toByteArray(b64) {
    var tmp;
    var lens = $75e16bb6a5e6e4e1$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $75e16bb6a5e6e4e1$var$Arr($75e16bb6a5e6e4e1$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $75e16bb6a5e6e4e1$var$revLookup[b64.charCodeAt(i)] << 18 | $75e16bb6a5e6e4e1$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $75e16bb6a5e6e4e1$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $75e16bb6a5e6e4e1$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $75e16bb6a5e6e4e1$var$revLookup[b64.charCodeAt(i)] << 2 | $75e16bb6a5e6e4e1$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $75e16bb6a5e6e4e1$var$revLookup[b64.charCodeAt(i)] << 10 | $75e16bb6a5e6e4e1$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $75e16bb6a5e6e4e1$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $75e16bb6a5e6e4e1$var$tripletToBase64(num) {
    return $75e16bb6a5e6e4e1$var$lookup[num >> 18 & 0x3F] + $75e16bb6a5e6e4e1$var$lookup[num >> 12 & 0x3F] + $75e16bb6a5e6e4e1$var$lookup[num >> 6 & 0x3F] + $75e16bb6a5e6e4e1$var$lookup[num & 0x3F];
}
function $75e16bb6a5e6e4e1$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($75e16bb6a5e6e4e1$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $75e16bb6a5e6e4e1$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($75e16bb6a5e6e4e1$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($75e16bb6a5e6e4e1$var$lookup[tmp >> 2] + $75e16bb6a5e6e4e1$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($75e16bb6a5e6e4e1$var$lookup[tmp >> 10] + $75e16bb6a5e6e4e1$var$lookup[tmp >> 4 & 0x3F] + $75e16bb6a5e6e4e1$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("dAiKa", function(module, exports) {

$parcel$export(module.exports, "read", () => $9e3d2d3f7b51c855$export$aafa59e2e03f2942, (v) => $9e3d2d3f7b51c855$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $9e3d2d3f7b51c855$export$68d8715fc104d294, (v) => $9e3d2d3f7b51c855$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $9e3d2d3f7b51c855$export$aafa59e2e03f2942;
var $9e3d2d3f7b51c855$export$68d8715fc104d294;
$9e3d2d3f7b51c855$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$9e3d2d3f7b51c855$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("giaim", function(module, exports) {

$parcel$export(module.exports, "print", () => $bdc650300bfd0838$export$c2d084dc44961371);
$parcel$export(module.exports, "warn", () => $bdc650300bfd0838$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "BOLD", () => (parcelRequire("7qZUp")).BOLD);
$parcel$export(module.exports, "UNBOLD", () => (parcelRequire("7qZUp")).UNBOLD);
$parcel$export(module.exports, "RED", () => (parcelRequire("7qZUp")).RED);
$parcel$export(module.exports, "ORANGE", () => (parcelRequire("7qZUp")).ORANGE);
/**
 * Isomorphic logging module with support for colors!
 *
 * @module logging
 */ 
var $kRoyo = parcelRequire("kRoyo");

var $9IXCW = parcelRequire("9IXCW");

var $dergl = parcelRequire("dergl");

var $6PR82 = parcelRequire("6PR82");

var $305Xo = parcelRequire("305Xo");

var $d1VR8 = parcelRequire("d1VR8");

var $it7Pj = parcelRequire("it7Pj");

var $bJmyZ = parcelRequire("bJmyZ");

var $7qZUp = parcelRequire("7qZUp");
/**
 * @type {Object<Symbol,pair.Pair<string,string>>}
 */ const $bdc650300bfd0838$var$_browserStyleMap = {
    [$7qZUp.BOLD]: $dergl.create('font-weight', 'bold'),
    [$7qZUp.UNBOLD]: $dergl.create('font-weight', 'normal'),
    [$7qZUp.BLUE]: $dergl.create('color', 'blue'),
    [$7qZUp.GREEN]: $dergl.create('color', 'green'),
    [$7qZUp.GREY]: $dergl.create('color', 'grey'),
    [$7qZUp.RED]: $dergl.create('color', 'red'),
    [$7qZUp.PURPLE]: $dergl.create('color', 'purple'),
    [$7qZUp.ORANGE]: $dergl.create('color', 'orange'),
    [$7qZUp.UNCOLOR]: $dergl.create('color', 'black')
};
/**
 * @param {Array<string|Symbol|Object|number|function():any>} args
 * @return {Array<string|object|number>}
 */ /* c8 ignore start */ const $bdc650300bfd0838$var$computeBrowserLoggingArgs = (args)=>{
    if (args.length === 1 && args[0]?.constructor === Function) args = /** @type {Array<string|Symbol|Object|number>} */ /** @type {[function]} */ args[0]();
    const strBuilder = [];
    const styles = [];
    const currentStyle = $d1VR8.create();
    /**
   * @type {Array<string|Object|number>}
   */ let logArgs = [];
    // try with formatting until we find something unsupported
    let i = 0;
    for(; i < args.length; i++){
        const arg = args[i];
        // @ts-ignore
        const style = $bdc650300bfd0838$var$_browserStyleMap[arg];
        if (style !== undefined) currentStyle.set(style.left, style.right);
        else {
            if (arg === undefined) break;
            if (arg.constructor === String || arg.constructor === Number) {
                const style = $6PR82.mapToStyleString(currentStyle);
                if (i > 0 || style.length > 0) {
                    strBuilder.push('%c' + arg);
                    styles.push(style);
                } else strBuilder.push(arg);
            } else break;
        }
    }
    if (i > 0) {
        // create logArgs with what we have so far
        logArgs = styles;
        logArgs.unshift(strBuilder.join(''));
    }
    // append the rest
    for(; i < args.length; i++){
        const arg = args[i];
        if (!(arg instanceof Symbol)) logArgs.push(arg);
    }
    return logArgs;
};
/* c8 ignore stop */ /* c8 ignore start */ const $bdc650300bfd0838$var$computeLoggingArgs = $kRoyo.supportsColor ? $bdc650300bfd0838$var$computeBrowserLoggingArgs : $7qZUp.computeNoColorLoggingArgs;
const $bdc650300bfd0838$export$c2d084dc44961371 = (...args)=>{
    console.log(...$bdc650300bfd0838$var$computeLoggingArgs(args));
    /* c8 ignore next */ $bdc650300bfd0838$export$6f0283bff34730a1.forEach((vc)=>vc.print(args));
};
const $bdc650300bfd0838$export$c106dd0671a0fc2d = (...args)=>{
    console.warn(...$bdc650300bfd0838$var$computeLoggingArgs(args));
    args.unshift($7qZUp.ORANGE);
    $bdc650300bfd0838$export$6f0283bff34730a1.forEach((vc)=>vc.print(args));
};
const $bdc650300bfd0838$export$55ee1551a3f962e6 = (err)=>{
    console.error(err);
    $bdc650300bfd0838$export$6f0283bff34730a1.forEach((vc)=>vc.printError(err));
};
const $bdc650300bfd0838$export$85acd411250ab137 = (url, height)=>{
    if ($kRoyo.isBrowser) console.log('%c                      ', `font-size: ${height}px; background-size: contain; background-repeat: no-repeat; background-image: url(${url})`);
    $bdc650300bfd0838$export$6f0283bff34730a1.forEach((vc)=>vc.printImg(url, height));
};
const $bdc650300bfd0838$export$fcd48d8a033dbfbf = (base64, height)=>$bdc650300bfd0838$export$85acd411250ab137(`data:image/gif;base64,${base64}`, height);
const $bdc650300bfd0838$export$e5e25fbcc1f7affe = (...args)=>{
    console.group(...$bdc650300bfd0838$var$computeLoggingArgs(args));
    /* c8 ignore next */ $bdc650300bfd0838$export$6f0283bff34730a1.forEach((vc)=>vc.group(args));
};
const $bdc650300bfd0838$export$488ef8fb3416a29f = (...args)=>{
    console.groupCollapsed(...$bdc650300bfd0838$var$computeLoggingArgs(args));
    /* c8 ignore next */ $bdc650300bfd0838$export$6f0283bff34730a1.forEach((vc)=>vc.groupCollapsed(args));
};
const $bdc650300bfd0838$export$a57f3dfe595273e6 = ()=>{
    console.groupEnd();
    /* c8 ignore next */ $bdc650300bfd0838$export$6f0283bff34730a1.forEach((vc)=>vc.groupEnd());
};
const $bdc650300bfd0838$export$76dff282388623b3 = (createNode)=>$bdc650300bfd0838$export$6f0283bff34730a1.forEach((vc)=>vc.printDom(createNode()));
const $bdc650300bfd0838$export$98f2e847362d891 = (canvas, height)=>$bdc650300bfd0838$export$85acd411250ab137(canvas.toDataURL(), height);
const $bdc650300bfd0838$export$6f0283bff34730a1 = $9IXCW.create();
/**
 * @param {Array<string|Symbol|Object|number>} args
 * @return {Array<Element>}
 */ /* c8 ignore start */ const $bdc650300bfd0838$var$_computeLineSpans = (args)=>{
    const spans = [];
    const currentStyle = new Map();
    // try with formatting until we find something unsupported
    let i = 0;
    for(; i < args.length; i++){
        let arg = args[i];
        // @ts-ignore
        const style = $bdc650300bfd0838$var$_browserStyleMap[arg];
        if (style !== undefined) currentStyle.set(style.left, style.right);
        else {
            if (arg === undefined) arg = 'undefined ';
            if (arg.constructor === String || arg.constructor === Number) {
                // @ts-ignore
                const span = $6PR82.element('span', [
                    $dergl.create('style', $6PR82.mapToStyleString(currentStyle))
                ], [
                    $6PR82.text(arg.toString())
                ]);
                if (span.innerHTML === '') span.innerHTML = '&nbsp;';
                spans.push(span);
            } else break;
        }
    }
    // append the rest
    for(; i < args.length; i++){
        let content = args[i];
        if (!(content instanceof Symbol)) {
            if (content.constructor !== String && content.constructor !== Number) content = ' ' + $305Xo.stringify(content) + ' ';
            spans.push($6PR82.element('span', [], [
                $6PR82.text(/** @type {string} */ content)
            ]));
        }
    }
    return spans;
};
/* c8 ignore stop */ const $bdc650300bfd0838$var$lineStyle = 'font-family:monospace;border-bottom:1px solid #e2e2e2;padding:2px;';
class $bdc650300bfd0838$export$79dd518d42f6d7a1 {
    /**
   * @param {Element} dom
   */ constructor(dom){
        this.dom = dom;
        /**
     * @type {Element}
     */ this.ccontainer = this.dom;
        this.depth = 0;
        $bdc650300bfd0838$export$6f0283bff34730a1.add(this);
    }
    /**
   * @param {Array<string|Symbol|Object|number>} args
   * @param {boolean} collapsed
   */ group(args, collapsed = false) {
        $it7Pj.enqueue(()=>{
            const triangleDown = $6PR82.element('span', [
                $dergl.create('hidden', collapsed),
                $dergl.create('style', 'color:grey;font-size:120%;')
            ], [
                $6PR82.text("\u25BC")
            ]);
            const triangleRight = $6PR82.element('span', [
                $dergl.create('hidden', !collapsed),
                $dergl.create('style', 'color:grey;font-size:125%;')
            ], [
                $6PR82.text("\u25B6")
            ]);
            const content = $6PR82.element('div', [
                $dergl.create('style', `${$bdc650300bfd0838$var$lineStyle};padding-left:${this.depth * 10}px`)
            ], [
                triangleDown,
                triangleRight,
                $6PR82.text(' ')
            ].concat($bdc650300bfd0838$var$_computeLineSpans(args)));
            const nextContainer = $6PR82.element('div', [
                $dergl.create('hidden', collapsed)
            ]);
            const nextLine = $6PR82.element('div', [], [
                content,
                nextContainer
            ]);
            $6PR82.append(this.ccontainer, [
                nextLine
            ]);
            this.ccontainer = nextContainer;
            this.depth++;
            // when header is clicked, collapse/uncollapse container
            $6PR82.addEventListener(content, 'click', (_event)=>{
                nextContainer.toggleAttribute('hidden');
                triangleDown.toggleAttribute('hidden');
                triangleRight.toggleAttribute('hidden');
            });
        });
    }
    /**
   * @param {Array<string|Symbol|Object|number>} args
   */ groupCollapsed(args) {
        this.group(args, true);
    }
    groupEnd() {
        $it7Pj.enqueue(()=>{
            if (this.depth > 0) {
                this.depth--;
                // @ts-ignore
                this.ccontainer = this.ccontainer.parentElement.parentElement;
            }
        });
    }
    /**
   * @param {Array<string|Symbol|Object|number>} args
   */ print(args) {
        $it7Pj.enqueue(()=>{
            $6PR82.append(this.ccontainer, [
                $6PR82.element('div', [
                    $dergl.create('style', `${$bdc650300bfd0838$var$lineStyle};padding-left:${this.depth * 10}px`)
                ], $bdc650300bfd0838$var$_computeLineSpans(args))
            ]);
        });
    }
    /**
   * @param {Error} err
   */ printError(err) {
        this.print([
            $7qZUp.RED,
            $7qZUp.BOLD,
            err.toString()
        ]);
    }
    /**
   * @param {string} url
   * @param {number} height
   */ printImg(url, height) {
        $it7Pj.enqueue(()=>{
            $6PR82.append(this.ccontainer, [
                $6PR82.element('img', [
                    $dergl.create('src', url),
                    $dergl.create('height', `${$bJmyZ.round(height * 1.5)}px`)
                ])
            ]);
        });
    }
    /**
   * @param {Node} node
   */ printDom(node) {
        $it7Pj.enqueue(()=>{
            $6PR82.append(this.ccontainer, [
                node
            ]);
        });
    }
    destroy() {
        $it7Pj.enqueue(()=>{
            $bdc650300bfd0838$export$6f0283bff34730a1.delete(this);
        });
    }
}
const $bdc650300bfd0838$export$3b589da4ab12cf23 = (dom)=>new $bdc650300bfd0838$export$79dd518d42f6d7a1(dom);
const $bdc650300bfd0838$export$c2977e725d59a2fd = (moduleName)=>$7qZUp.createModuleLogger($bdc650300bfd0838$export$c2d084dc44961371, moduleName);

});
parcelRegister("dergl", function(module, exports) {

$parcel$export(module.exports, "create", () => $9a21baf95bcfca99$export$185802fd694ee1f5);
$parcel$export(module.exports, "forEach", () => $9a21baf95bcfca99$export$4b80e395e36b5a56);
/**
 * Working with value pairs.
 *
 * @module pair
 */ /**
 * @template L,R
 */ class $9a21baf95bcfca99$export$d63d7cff08fe4dc9 {
    /**
   * @param {L} left
   * @param {R} right
   */ constructor(left, right){
        this.left = left;
        this.right = right;
    }
}
const $9a21baf95bcfca99$export$185802fd694ee1f5 = (left, right)=>new $9a21baf95bcfca99$export$d63d7cff08fe4dc9(left, right);
const $9a21baf95bcfca99$export$ca0ea131672c5a9b = (right, left)=>new $9a21baf95bcfca99$export$d63d7cff08fe4dc9(left, right);
const $9a21baf95bcfca99$export$4b80e395e36b5a56 = (arr, f)=>arr.forEach((p)=>f(p.left, p.right));
const $9a21baf95bcfca99$export$871de8747c9eaa88 = (arr, f)=>arr.map((p)=>f(p.left, p.right));

});

parcelRegister("6PR82", function(module, exports) {

$parcel$export(module.exports, "append", () => $4fa0b7b754a77917$export$10d8903dec122b9d);
$parcel$export(module.exports, "addEventListener", () => $4fa0b7b754a77917$export$3f65cefe8380dbea);
$parcel$export(module.exports, "element", () => $4fa0b7b754a77917$export$8454457683f90105);
$parcel$export(module.exports, "text", () => $4fa0b7b754a77917$export$6f093cfa640b7166);
$parcel$export(module.exports, "mapToStyleString", () => $4fa0b7b754a77917$export$7d9cafe158c3b49);
/* eslint-env browser */ /**
 * Utility module to work with the DOM.
 *
 * @module dom
 */ 
var $dergl = parcelRequire("dergl");

var $d1VR8 = parcelRequire("d1VR8");
const $4fa0b7b754a77917$export$2a111da947c407d2 = /** @type {Document} */ typeof document !== 'undefined' ? document : {};
const $4fa0b7b754a77917$export$c8a8987d4410bf2d = (name)=>$4fa0b7b754a77917$export$2a111da947c407d2.createElement(name);
const $4fa0b7b754a77917$export$fb51152cd5328759 = ()=>$4fa0b7b754a77917$export$2a111da947c407d2.createDocumentFragment();
const $4fa0b7b754a77917$export$b2ce9ad90858ed7a = (text)=>$4fa0b7b754a77917$export$2a111da947c407d2.createTextNode(text);
const $4fa0b7b754a77917$export$fb621bb527230cda = /** @type {DOMParser} */ typeof DOMParser !== 'undefined' ? new DOMParser() : null;
const $4fa0b7b754a77917$export$77c9ee5a14f9d7cf = (el, name, opts)=>el.dispatchEvent(new CustomEvent(name, opts));
const $4fa0b7b754a77917$export$74da2cba014bdc09 = (el, attrs)=>{
    $dergl.forEach(attrs, (key, value)=>{
        if (value === false) el.removeAttribute(key);
        else if (value === true) el.setAttribute(key, '');
        else // @ts-ignore
        el.setAttribute(key, value);
    });
    return el;
};
const $4fa0b7b754a77917$export$ba744f7d152abea1 = (el, attrs)=>{
    attrs.forEach((value, key)=>{
        el.setAttribute(key, value);
    });
    return el;
};
const $4fa0b7b754a77917$export$f00aeb236b6f05af = (children)=>{
    const fragment = $4fa0b7b754a77917$export$fb51152cd5328759();
    for(let i = 0; i < children.length; i++)$4fa0b7b754a77917$export$1b8e57c9ea42f1d2(fragment, children[i]);
    return fragment;
};
const $4fa0b7b754a77917$export$10d8903dec122b9d = (parent, nodes)=>{
    $4fa0b7b754a77917$export$1b8e57c9ea42f1d2(parent, $4fa0b7b754a77917$export$f00aeb236b6f05af(nodes));
    return parent;
};
const $4fa0b7b754a77917$export$cd7f480d6b8286c3 = (el)=>el.remove();
const $4fa0b7b754a77917$export$3f65cefe8380dbea = (el, name, f)=>el.addEventListener(name, f);
const $4fa0b7b754a77917$export$8ff9f68337b520c0 = (el, name, f)=>el.removeEventListener(name, f);
const $4fa0b7b754a77917$export$40a4ed63e5cb7043 = (node, listeners)=>{
    $dergl.forEach(listeners, (name, f)=>$4fa0b7b754a77917$export$3f65cefe8380dbea(node, name, f));
    return node;
};
const $4fa0b7b754a77917$export$8c7b13b21690651d = (node, listeners)=>{
    $dergl.forEach(listeners, (name, f)=>$4fa0b7b754a77917$export$8ff9f68337b520c0(node, name, f));
    return node;
};
const $4fa0b7b754a77917$export$8454457683f90105 = (name, attrs = [], children = [])=>$4fa0b7b754a77917$export$10d8903dec122b9d($4fa0b7b754a77917$export$74da2cba014bdc09($4fa0b7b754a77917$export$c8a8987d4410bf2d(name), attrs), children);
const $4fa0b7b754a77917$export$67ea982130081db = (width, height)=>{
    const c = /** @type {HTMLCanvasElement} */ $4fa0b7b754a77917$export$c8a8987d4410bf2d('canvas');
    c.height = height;
    c.width = width;
    return c;
};
const $4fa0b7b754a77917$export$6f093cfa640b7166 = $4fa0b7b754a77917$export$b2ce9ad90858ed7a;
const $4fa0b7b754a77917$export$7f60f118cd3e6292 = (pair)=>`${pair.left}:${pair.right};`;
const $4fa0b7b754a77917$export$3d24a00500154f45 = (pairs)=>pairs.map($4fa0b7b754a77917$export$7f60f118cd3e6292).join('');
const $4fa0b7b754a77917$export$7d9cafe158c3b49 = (m)=>$d1VR8.map(m, (value, key)=>`${key}:${value};`).join('');
const $4fa0b7b754a77917$export$78fb49a702cc1f2 = (el, query)=>el.querySelector(query);
const $4fa0b7b754a77917$export$2e83b5c43fb7af7b = (el, query)=>el.querySelectorAll(query);
const $4fa0b7b754a77917$export$83595b84fc78b9b4 = (id)=>/** @type {HTMLElement} */ $4fa0b7b754a77917$export$2a111da947c407d2.getElementById(id);
/**
 * @param {string} html
 * @return {HTMLElement}
 */ const $4fa0b7b754a77917$var$_parse = (html)=>$4fa0b7b754a77917$export$fb621bb527230cda.parseFromString(`<html><body>${html}</body></html>`, 'text/html').body;
const $4fa0b7b754a77917$export$e1152f5efcc82ad = (html)=>$4fa0b7b754a77917$export$f00aeb236b6f05af(/** @type {any} */ $4fa0b7b754a77917$var$_parse(html).childNodes);
const $4fa0b7b754a77917$export$b23064c2dcaf2b63 = (html)=>/** @type HTMLElement */ $4fa0b7b754a77917$var$_parse(html).firstElementChild;
const $4fa0b7b754a77917$export$e6a6680780233a77 = (oldEl, newEl)=>oldEl.replaceWith(newEl);
const $4fa0b7b754a77917$export$86b68c7dbeb53c22 = (parent, el, ref)=>parent.insertBefore(el, ref);
const $4fa0b7b754a77917$export$1b8e57c9ea42f1d2 = (parent, child)=>parent.appendChild(child);
const $4fa0b7b754a77917$export$51c8a276ee4b8f51 = $4fa0b7b754a77917$export$2a111da947c407d2.ELEMENT_NODE;
const $4fa0b7b754a77917$export$5bcc40203615fc2e = $4fa0b7b754a77917$export$2a111da947c407d2.TEXT_NODE;
const $4fa0b7b754a77917$export$e5fc6332c1c8eb8e = $4fa0b7b754a77917$export$2a111da947c407d2.CDATA_SECTION_NODE;
const $4fa0b7b754a77917$export$3d597a6ef0f08b0a = $4fa0b7b754a77917$export$2a111da947c407d2.COMMENT_NODE;
const $4fa0b7b754a77917$export$4139dcda4f7f83db = $4fa0b7b754a77917$export$2a111da947c407d2.DOCUMENT_NODE;
const $4fa0b7b754a77917$export$e9e7ddfdb004b848 = $4fa0b7b754a77917$export$2a111da947c407d2.DOCUMENT_TYPE_NODE;
const $4fa0b7b754a77917$export$b86725031ae151ee = $4fa0b7b754a77917$export$2a111da947c407d2.DOCUMENT_FRAGMENT_NODE;
const $4fa0b7b754a77917$export$1aa65d86db59b879 = (node, type)=>node.nodeType === type;
const $4fa0b7b754a77917$export$3c81af374b054d6a = (parent, child)=>{
    let p = child.parentNode;
    while(p && p !== parent)p = p.parentNode;
    return p === parent;
} /* c8 ignore stop */ ;

});

parcelRegister("305Xo", function(module, exports) {

$parcel$export(module.exports, "stringify", () => $22f5fe1c6d62fe1e$export$fac44ee5b035f737);
/**
 * JSON utility functions.
 *
 * @module json
 */ /**
 * Transform JavaScript object to JSON.
 *
 * @param {any} object
 * @return {string}
 */ const $22f5fe1c6d62fe1e$export$fac44ee5b035f737 = JSON.stringify;
const $22f5fe1c6d62fe1e$export$98e6a39c04603d36 = JSON.parse;

});

parcelRegister("it7Pj", function(module, exports) {

$parcel$export(module.exports, "enqueue", () => $d72101a723b03524$export$513072ba72100d9c);
/* global requestIdleCallback, requestAnimationFrame, cancelIdleCallback, cancelAnimationFrame */ /**
 * Utility module to work with EcmaScript's event loop.
 *
 * @module eventloop
 */ /**
 * @type {Array<function>}
 */ let $d72101a723b03524$var$queue = [];
const $d72101a723b03524$var$_runQueue = ()=>{
    for(let i = 0; i < $d72101a723b03524$var$queue.length; i++)$d72101a723b03524$var$queue[i]();
    $d72101a723b03524$var$queue = [];
};
const $d72101a723b03524$export$513072ba72100d9c = (f)=>{
    $d72101a723b03524$var$queue.push(f);
    if ($d72101a723b03524$var$queue.length === 1) setTimeout($d72101a723b03524$var$_runQueue, 0);
};
/**
 * @typedef {Object} TimeoutObject
 * @property {function} TimeoutObject.destroy
 */ /**
 * @param {function(number):void} clearFunction
 */ const $d72101a723b03524$var$createTimeoutClass = (clearFunction)=>class TT {
        /**
   * @param {number} timeoutId
   */ constructor(timeoutId){
            this._ = timeoutId;
        }
        destroy() {
            clearFunction(this._);
        }
    };
const $d72101a723b03524$var$Timeout = $d72101a723b03524$var$createTimeoutClass(clearTimeout);
const $d72101a723b03524$export$83e74882c5df8fe1 = (timeout, callback)=>new $d72101a723b03524$var$Timeout(setTimeout(callback, timeout));
const $d72101a723b03524$var$Interval = $d72101a723b03524$var$createTimeoutClass(clearInterval);
const $d72101a723b03524$export$3174cdbf0a0cbc84 = (timeout, callback)=>new $d72101a723b03524$var$Interval(setInterval(callback, timeout));
const $d72101a723b03524$export$c35d437ae5945fcd = $d72101a723b03524$var$createTimeoutClass((arg)=>typeof requestAnimationFrame !== 'undefined' && cancelAnimationFrame(arg));
const $d72101a723b03524$export$1402cba6a733f33a = (cb)=>typeof requestAnimationFrame === 'undefined' ? $d72101a723b03524$export$83e74882c5df8fe1(0, cb) : new $d72101a723b03524$export$c35d437ae5945fcd(requestAnimationFrame(cb));
/* c8 ignore next */ // @ts-ignore
const $d72101a723b03524$var$Idle = $d72101a723b03524$var$createTimeoutClass((arg)=>typeof cancelIdleCallback !== 'undefined' && cancelIdleCallback(arg));
const $d72101a723b03524$export$9f62c65f1b707875 = (cb)=>typeof requestIdleCallback !== 'undefined' ? new $d72101a723b03524$var$Idle(requestIdleCallback(cb)) : $d72101a723b03524$export$83e74882c5df8fe1(1000, cb);
const $d72101a723b03524$export$21cd608c50c2ba31 = (timeout)=>{
    let timer = -1;
    return (f)=>{
        clearTimeout(timer);
        if (f) timer = /** @type {any} */ setTimeout(f, timeout);
    };
};

});

parcelRegister("7qZUp", function(module, exports) {

$parcel$export(module.exports, "BOLD", () => $569afbf003be6ad9$export$c1286c4c2a7c066);
$parcel$export(module.exports, "UNBOLD", () => $569afbf003be6ad9$export$f0ce1666bb40789b);
$parcel$export(module.exports, "BLUE", () => $569afbf003be6ad9$export$738c3b9a44c87ecc);
$parcel$export(module.exports, "GREY", () => $569afbf003be6ad9$export$7d278ca694634874);
$parcel$export(module.exports, "GREEN", () => $569afbf003be6ad9$export$48d4b2cd5bc0e88b);
$parcel$export(module.exports, "RED", () => $569afbf003be6ad9$export$aa201224bb439d47);
$parcel$export(module.exports, "PURPLE", () => $569afbf003be6ad9$export$7ffdeca4b2f927a2);
$parcel$export(module.exports, "ORANGE", () => $569afbf003be6ad9$export$3de5e29ed1757f9b);
$parcel$export(module.exports, "UNCOLOR", () => $569afbf003be6ad9$export$b586f81201748dd0);
$parcel$export(module.exports, "computeNoColorLoggingArgs", () => $569afbf003be6ad9$export$3454091cc3c6c473);
$parcel$export(module.exports, "createModuleLogger", () => $569afbf003be6ad9$export$c2977e725d59a2fd);

var $ieD4A = parcelRequire("ieD4A");

var $drUmF = parcelRequire("drUmF");

var $kRoyo = parcelRequire("kRoyo");

var $45hHO = parcelRequire("45hHO");

var $305Xo = parcelRequire("305Xo");
const $569afbf003be6ad9$export$c1286c4c2a7c066 = $ieD4A.create();
const $569afbf003be6ad9$export$f0ce1666bb40789b = $ieD4A.create();
const $569afbf003be6ad9$export$738c3b9a44c87ecc = $ieD4A.create();
const $569afbf003be6ad9$export$7d278ca694634874 = $ieD4A.create();
const $569afbf003be6ad9$export$48d4b2cd5bc0e88b = $ieD4A.create();
const $569afbf003be6ad9$export$aa201224bb439d47 = $ieD4A.create();
const $569afbf003be6ad9$export$7ffdeca4b2f927a2 = $ieD4A.create();
const $569afbf003be6ad9$export$3de5e29ed1757f9b = $ieD4A.create();
const $569afbf003be6ad9$export$b586f81201748dd0 = $ieD4A.create();
const $569afbf003be6ad9$export$3454091cc3c6c473 = (args)=>{
    if (args.length === 1 && args[0]?.constructor === Function) args = /** @type {Array<string|Symbol|Object|number>} */ /** @type {[function]} */ args[0]();
    const strBuilder = [];
    const logArgs = [];
    // try with formatting until we find something unsupported
    let i = 0;
    for(; i < args.length; i++){
        const arg = args[i];
        if (arg === undefined) break;
        else if (arg.constructor === String || arg.constructor === Number) strBuilder.push(arg);
        else if (arg.constructor === Object) break;
    }
    if (i > 0) // create logArgs with what we have so far
    logArgs.push(strBuilder.join(''));
    // append the rest
    for(; i < args.length; i++){
        const arg = args[i];
        if (!(arg instanceof Symbol)) logArgs.push(arg);
    }
    return logArgs;
};
/* c8 ignore stop */ const $569afbf003be6ad9$var$loggingColors = [
    $569afbf003be6ad9$export$48d4b2cd5bc0e88b,
    $569afbf003be6ad9$export$7ffdeca4b2f927a2,
    $569afbf003be6ad9$export$3de5e29ed1757f9b,
    $569afbf003be6ad9$export$738c3b9a44c87ecc
];
let $569afbf003be6ad9$var$nextColor = 0;
let $569afbf003be6ad9$var$lastLoggingTime = $drUmF.getUnixTime();
const $569afbf003be6ad9$export$c2977e725d59a2fd = (_print, moduleName)=>{
    const color = $569afbf003be6ad9$var$loggingColors[$569afbf003be6ad9$var$nextColor];
    const debugRegexVar = $kRoyo.getVariable('log');
    const doLogging = debugRegexVar !== null && (debugRegexVar === '*' || debugRegexVar === 'true' || new RegExp(debugRegexVar, 'gi').test(moduleName));
    $569afbf003be6ad9$var$nextColor = ($569afbf003be6ad9$var$nextColor + 1) % $569afbf003be6ad9$var$loggingColors.length;
    moduleName += ': ';
    return !doLogging ? $45hHO.nop : (...args)=>{
        if (args.length === 1 && args[0]?.constructor === Function) args = args[0]();
        const timeNow = $drUmF.getUnixTime();
        const timeDiff = timeNow - $569afbf003be6ad9$var$lastLoggingTime;
        $569afbf003be6ad9$var$lastLoggingTime = timeNow;
        _print(color, moduleName, $569afbf003be6ad9$export$b586f81201748dd0, ...args.map((arg)=>{
            if (arg != null && arg.constructor === Uint8Array) arg = Array.from(arg);
            const t = typeof arg;
            switch(t){
                case 'string':
                case 'symbol':
                    return arg;
                default:
                    return $305Xo.stringify(arg);
            }
        }), color, ' +' + timeDiff + 'ms');
    };
} /* c8 ignore stop */ ;

});
parcelRegister("ieD4A", function(module, exports) {

$parcel$export(module.exports, "create", () => $d467d7dda3983250$export$185802fd694ee1f5);
/**
 * Utility module to work with EcmaScript Symbols.
 *
 * @module symbol
 */ /**
 * Return fresh symbol.
 *
 * @return {Symbol}
 */ const $d467d7dda3983250$export$185802fd694ee1f5 = Symbol;
const $d467d7dda3983250$export$a244864fd9645c7f = (s)=>typeof s === 'symbol';

});



parcelRegister("fphiM", function(module, exports) {

$parcel$export(module.exports, "iteratorFilter", () => $b3769c978b891f36$export$88f0b2eef157f31a);
$parcel$export(module.exports, "iteratorMap", () => $b3769c978b891f36$export$1570d514f543056a);
/**
 * Utility module to create and manipulate Iterators.
 *
 * @module iterator
 */ /**
 * @template T,R
 * @param {Iterator<T>} iterator
 * @param {function(T):R} f
 * @return {IterableIterator<R>}
 */ const $b3769c978b891f36$export$68b1bda190f54159 = (iterator, f)=>({
        [Symbol.iterator] () {
            return this;
        },
        // @ts-ignore
        next () {
            const r = iterator.next();
            return {
                value: r.done ? undefined : f(r.value),
                done: r.done
            };
        }
    });
const $b3769c978b891f36$export$7342c78d7e13e778 = (next)=>({
        /**
   * @return {IterableIterator<T>}
   */ [Symbol.iterator] () {
            return this;
        },
        next: // @ts-ignore
        next
    });
const $b3769c978b891f36$export$88f0b2eef157f31a = (iterator, filter)=>$b3769c978b891f36$export$7342c78d7e13e778(()=>{
        let res;
        do res = iterator.next();
        while (!res.done && !filter(res.value));
        return res;
    });
const $b3769c978b891f36$export$1570d514f543056a = (iterator, fmap)=>$b3769c978b891f36$export$7342c78d7e13e778(()=>{
        const { done: done, value: value } = iterator.next();
        return {
            done: done,
            value: done ? undefined : fmap(value)
        };
    });

});


parcelRegister("6iwTo", function(module, exports) {

$parcel$export(module.exports, "WebsocketProvider", () => $495df03e80ee0346$export$c0e03644998998fb);
/**
 * @module provider/websocket
 */ /* eslint-env browser */ 

var $4vird = parcelRequire("4vird");

var $drUmF = parcelRequire("drUmF");

var $kRma6 = parcelRequire("kRma6");

var $9QtgA = parcelRequire("9QtgA");

var $ToBJT = parcelRequire("ToBJT");

var $aHEC8 = parcelRequire("aHEC8");

var $dqc6X = parcelRequire("dqc6X");

var $7uKvC = parcelRequire("7uKvC");

var $bJmyZ = parcelRequire("bJmyZ");

var $5o50s = parcelRequire("5o50s");

var $kRoyo = parcelRequire("kRoyo");

var $iZPu2 = parcelRequire("iZPu2");
const $495df03e80ee0346$export$70790f6f28b13205 = 0;
const $495df03e80ee0346$export$83b62f7afdd0e333 = 3;
const $495df03e80ee0346$export$790bca08a5d3ef2c = 1;
const $495df03e80ee0346$export$89c03a973d1d6923 = 2;
/**
 *                       encoder,          decoder,          provider,          emitSynced, messageType
 * @type {Array<function(encoding.Encoder, decoding.Decoder, WebsocketProvider, boolean,    number):void>}
 */ const $495df03e80ee0346$var$messageHandlers = [];
$495df03e80ee0346$var$messageHandlers[$495df03e80ee0346$export$70790f6f28b13205] = (encoder, decoder, provider, emitSynced, _messageType)=>{
    $kRma6.writeVarUint(encoder, $495df03e80ee0346$export$70790f6f28b13205);
    const syncMessageType = $ToBJT.readSyncMessage(decoder, encoder, provider.doc, provider);
    if (emitSynced && syncMessageType === $ToBJT.messageYjsSyncStep2 && !provider.synced) provider.synced = true;
};
$495df03e80ee0346$var$messageHandlers[$495df03e80ee0346$export$83b62f7afdd0e333] = (encoder, _decoder, provider, _emitSynced, _messageType)=>{
    $kRma6.writeVarUint(encoder, $495df03e80ee0346$export$790bca08a5d3ef2c);
    $kRma6.writeVarUint8Array(encoder, $dqc6X.encodeAwarenessUpdate(provider.awareness, Array.from(provider.awareness.getStates().keys())));
};
$495df03e80ee0346$var$messageHandlers[$495df03e80ee0346$export$790bca08a5d3ef2c] = (_encoder, decoder, provider, _emitSynced, _messageType)=>{
    $dqc6X.applyAwarenessUpdate(provider.awareness, $9QtgA.readVarUint8Array(decoder), provider);
};
$495df03e80ee0346$var$messageHandlers[$495df03e80ee0346$export$89c03a973d1d6923] = (_encoder, decoder, provider, _emitSynced, _messageType)=>{
    $aHEC8.readAuthMessage(decoder, provider.doc, (_ydoc, reason)=>$495df03e80ee0346$var$permissionDeniedHandler(provider, reason));
};
// @todo - this should depend on awareness.outdatedTime
const $495df03e80ee0346$var$messageReconnectTimeout = 30000;
/**
 * @param {WebsocketProvider} provider
 * @param {string} reason
 */ const $495df03e80ee0346$var$permissionDeniedHandler = (provider, reason)=>console.warn(`Permission denied to access ${provider.url}.\n${reason}`);
/**
 * @param {WebsocketProvider} provider
 * @param {Uint8Array} buf
 * @param {boolean} emitSynced
 * @return {encoding.Encoder}
 */ const $495df03e80ee0346$var$readMessage = (provider, buf, emitSynced)=>{
    const decoder = $9QtgA.createDecoder(buf);
    const encoder = $kRma6.createEncoder();
    const messageType = $9QtgA.readVarUint(decoder);
    const messageHandler = provider.messageHandlers[messageType];
    if (/** @type {any} */ messageHandler) messageHandler(encoder, decoder, provider, emitSynced, messageType);
    else console.error('Unable to compute message');
    return encoder;
};
/**
 * Outsource this function so that a new websocket connection is created immediately.
 * I suspect that the `ws.onclose` event is not always fired if there are network issues.
 *
 * @param {WebsocketProvider} provider
 * @param {WebSocket} ws
 * @param {CloseEvent | null} event
 */ const $495df03e80ee0346$var$closeWebsocketConnection = (provider, ws, event)=>{
    if (ws === provider.ws) {
        provider.emit('connection-close', [
            event,
            provider
        ]);
        provider.ws = null;
        ws.close();
        provider.wsconnecting = false;
        if (provider.wsconnected) {
            provider.wsconnected = false;
            provider.synced = false;
            // update awareness (all users except local left)
            $dqc6X.removeAwarenessStates(provider.awareness, Array.from(provider.awareness.getStates().keys()).filter((client)=>client !== provider.doc.clientID), provider);
            provider.emit('status', [
                {
                    status: 'disconnected'
                }
            ]);
        } else provider.wsUnsuccessfulReconnects++;
        // Start with no reconnect timeout and increase timeout by
        // using exponential backoff starting with 100ms
        setTimeout($495df03e80ee0346$var$setupWS, $bJmyZ.min($bJmyZ.pow(2, provider.wsUnsuccessfulReconnects) * 100, provider.maxBackoffTime), provider);
    }
};
/**
 * @param {WebsocketProvider} provider
 */ const $495df03e80ee0346$var$setupWS = (provider)=>{
    if (provider.shouldConnect && provider.ws === null) {
        const websocket = new provider._WS(provider.url, provider.protocols);
        websocket.binaryType = 'arraybuffer';
        provider.ws = websocket;
        provider.wsconnecting = true;
        provider.wsconnected = false;
        provider.synced = false;
        websocket.onmessage = (event)=>{
            provider.wsLastMessageReceived = $drUmF.getUnixTime();
            const encoder = $495df03e80ee0346$var$readMessage(provider, new Uint8Array(event.data), true);
            if ($kRma6.length(encoder) > 1) websocket.send($kRma6.toUint8Array(encoder));
        };
        websocket.onerror = (event)=>{
            provider.emit('connection-error', [
                event,
                provider
            ]);
        };
        websocket.onclose = (event)=>{
            $495df03e80ee0346$var$closeWebsocketConnection(provider, websocket, event);
        };
        websocket.onopen = ()=>{
            provider.wsLastMessageReceived = $drUmF.getUnixTime();
            provider.wsconnecting = false;
            provider.wsconnected = true;
            provider.wsUnsuccessfulReconnects = 0;
            provider.emit('status', [
                {
                    status: 'connected'
                }
            ]);
            // always send sync step 1 when connected
            const encoder = $kRma6.createEncoder();
            $kRma6.writeVarUint(encoder, $495df03e80ee0346$export$70790f6f28b13205);
            $ToBJT.writeSyncStep1(encoder, provider.doc);
            websocket.send($kRma6.toUint8Array(encoder));
            // broadcast local awareness state
            if (provider.awareness.getLocalState() !== null) {
                const encoderAwarenessState = $kRma6.createEncoder();
                $kRma6.writeVarUint(encoderAwarenessState, $495df03e80ee0346$export$790bca08a5d3ef2c);
                $kRma6.writeVarUint8Array(encoderAwarenessState, $dqc6X.encodeAwarenessUpdate(provider.awareness, [
                    provider.doc.clientID
                ]));
                websocket.send($kRma6.toUint8Array(encoderAwarenessState));
            }
        };
        provider.emit('status', [
            {
                status: 'connecting'
            }
        ]);
    }
};
/**
 * @param {WebsocketProvider} provider
 * @param {ArrayBuffer} buf
 */ const $495df03e80ee0346$var$broadcastMessage = (provider, buf)=>{
    const ws = provider.ws;
    if (provider.wsconnected && ws && ws.readyState === ws.OPEN) ws.send(buf);
    if (provider.bcconnected) $4vird.publish(provider.bcChannel, buf, provider);
};
class $495df03e80ee0346$export$c0e03644998998fb extends (0, $7uKvC.ObservableV2) {
    /**
   * @param {string} serverUrl
   * @param {string} roomname
   * @param {Y.Doc} doc
   * @param {object} opts
   * @param {boolean} [opts.connect]
   * @param {awarenessProtocol.Awareness} [opts.awareness]
   * @param {Object<string,string>} [opts.params] specify url parameters
   * @param {Array<string>} [opts.protocols] specify websocket protocols
   * @param {typeof WebSocket} [opts.WebSocketPolyfill] Optionall provide a WebSocket polyfill
   * @param {number} [opts.resyncInterval] Request server state every `resyncInterval` milliseconds
   * @param {number} [opts.maxBackoffTime] Maximum amount of time to wait before trying to reconnect (we try to reconnect using exponential backoff)
   * @param {boolean} [opts.disableBc] Disable cross-tab BroadcastChannel communication
   */ constructor(serverUrl, roomname, doc, { connect: connect = true, awareness: awareness = new $dqc6X.Awareness(doc), params: params = {}, protocols: protocols = [], WebSocketPolyfill: WebSocketPolyfill = WebSocket, resyncInterval: resyncInterval = -1, maxBackoffTime: maxBackoffTime = 2500, disableBc: disableBc = false } = {}){
        super();
        // ensure that url is always ends with /
        while(serverUrl[serverUrl.length - 1] === '/')serverUrl = serverUrl.slice(0, serverUrl.length - 1);
        this.serverUrl = serverUrl;
        this.bcChannel = serverUrl + '/' + roomname;
        this.maxBackoffTime = maxBackoffTime;
        /**
     * The specified url parameters. This can be safely updated. The changed parameters will be used
     * when a new connection is established.
     * @type {Object<string,string>}
     */ this.params = params;
        this.protocols = protocols;
        this.roomname = roomname;
        this.doc = doc;
        this._WS = WebSocketPolyfill;
        this.awareness = awareness;
        this.wsconnected = false;
        this.wsconnecting = false;
        this.bcconnected = false;
        this.disableBc = disableBc;
        this.wsUnsuccessfulReconnects = 0;
        this.messageHandlers = $495df03e80ee0346$var$messageHandlers.slice();
        /**
     * @type {boolean}
     */ this._synced = false;
        /**
     * @type {WebSocket?}
     */ this.ws = null;
        this.wsLastMessageReceived = 0;
        /**
     * Whether to connect to other peers or not
     * @type {boolean}
     */ this.shouldConnect = connect;
        /**
     * @type {number}
     */ this._resyncInterval = 0;
        if (resyncInterval > 0) this._resyncInterval = /** @type {any} */ setInterval(()=>{
            if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                // resend sync step 1
                const encoder = $kRma6.createEncoder();
                $kRma6.writeVarUint(encoder, $495df03e80ee0346$export$70790f6f28b13205);
                $ToBJT.writeSyncStep1(encoder, doc);
                this.ws.send($kRma6.toUint8Array(encoder));
            }
        }, resyncInterval);
        /**
     * @param {ArrayBuffer} data
     * @param {any} origin
     */ this._bcSubscriber = (data, origin)=>{
            if (origin !== this) {
                const encoder = $495df03e80ee0346$var$readMessage(this, new Uint8Array(data), false);
                if ($kRma6.length(encoder) > 1) $4vird.publish(this.bcChannel, $kRma6.toUint8Array(encoder), this);
            }
        };
        /**
     * Listens to Yjs updates and sends them to remote peers (ws and broadcastchannel)
     * @param {Uint8Array} update
     * @param {any} origin
     */ this._updateHandler = (update, origin)=>{
            if (origin !== this) {
                const encoder = $kRma6.createEncoder();
                $kRma6.writeVarUint(encoder, $495df03e80ee0346$export$70790f6f28b13205);
                $ToBJT.writeUpdate(encoder, update);
                $495df03e80ee0346$var$broadcastMessage(this, $kRma6.toUint8Array(encoder));
            }
        };
        this.doc.on('update', this._updateHandler);
        /**
     * @param {any} changed
     * @param {any} _origin
     */ this._awarenessUpdateHandler = ({ added: added, updated: updated, removed: removed }, _origin)=>{
            const changedClients = added.concat(updated).concat(removed);
            const encoder = $kRma6.createEncoder();
            $kRma6.writeVarUint(encoder, $495df03e80ee0346$export$790bca08a5d3ef2c);
            $kRma6.writeVarUint8Array(encoder, $dqc6X.encodeAwarenessUpdate(awareness, changedClients));
            $495df03e80ee0346$var$broadcastMessage(this, $kRma6.toUint8Array(encoder));
        };
        this._exitHandler = ()=>{
            $dqc6X.removeAwarenessStates(this.awareness, [
                doc.clientID
            ], 'app closed');
        };
        if ($kRoyo.isNode && typeof $iZPu2 !== 'undefined') $iZPu2.on('exit', this._exitHandler);
        awareness.on('update', this._awarenessUpdateHandler);
        this._checkInterval = /** @type {any} */ setInterval(()=>{
            if (this.wsconnected && $495df03e80ee0346$var$messageReconnectTimeout < $drUmF.getUnixTime() - this.wsLastMessageReceived) // no message received in a long time - not even your own awareness
            // updates (which are updated every 15 seconds)
            $495df03e80ee0346$var$closeWebsocketConnection(this, /** @type {WebSocket} */ this.ws, null);
        }, $495df03e80ee0346$var$messageReconnectTimeout / 10);
        if (connect) this.connect();
    }
    get url() {
        const encodedParams = $5o50s.encodeQueryParams(this.params);
        return this.serverUrl + '/' + this.roomname + (encodedParams.length === 0 ? '' : '?' + encodedParams);
    }
    /**
   * @type {boolean}
   */ get synced() {
        return this._synced;
    }
    set synced(state) {
        if (this._synced !== state) {
            this._synced = state;
            // @ts-ignore
            this.emit('synced', [
                state
            ]);
            this.emit('sync', [
                state
            ]);
        }
    }
    destroy() {
        if (this._resyncInterval !== 0) clearInterval(this._resyncInterval);
        clearInterval(this._checkInterval);
        this.disconnect();
        if ($kRoyo.isNode && typeof $iZPu2 !== 'undefined') $iZPu2.off('exit', this._exitHandler);
        this.awareness.off('update', this._awarenessUpdateHandler);
        this.doc.off('update', this._updateHandler);
        super.destroy();
    }
    connectBc() {
        if (this.disableBc) return;
        if (!this.bcconnected) {
            $4vird.subscribe(this.bcChannel, this._bcSubscriber);
            this.bcconnected = true;
        }
        // send sync step1 to bc
        // write sync step 1
        const encoderSync = $kRma6.createEncoder();
        $kRma6.writeVarUint(encoderSync, $495df03e80ee0346$export$70790f6f28b13205);
        $ToBJT.writeSyncStep1(encoderSync, this.doc);
        $4vird.publish(this.bcChannel, $kRma6.toUint8Array(encoderSync), this);
        // broadcast local state
        const encoderState = $kRma6.createEncoder();
        $kRma6.writeVarUint(encoderState, $495df03e80ee0346$export$70790f6f28b13205);
        $ToBJT.writeSyncStep2(encoderState, this.doc);
        $4vird.publish(this.bcChannel, $kRma6.toUint8Array(encoderState), this);
        // write queryAwareness
        const encoderAwarenessQuery = $kRma6.createEncoder();
        $kRma6.writeVarUint(encoderAwarenessQuery, $495df03e80ee0346$export$83b62f7afdd0e333);
        $4vird.publish(this.bcChannel, $kRma6.toUint8Array(encoderAwarenessQuery), this);
        // broadcast local awareness state
        const encoderAwarenessState = $kRma6.createEncoder();
        $kRma6.writeVarUint(encoderAwarenessState, $495df03e80ee0346$export$790bca08a5d3ef2c);
        $kRma6.writeVarUint8Array(encoderAwarenessState, $dqc6X.encodeAwarenessUpdate(this.awareness, [
            this.doc.clientID
        ]));
        $4vird.publish(this.bcChannel, $kRma6.toUint8Array(encoderAwarenessState), this);
    }
    disconnectBc() {
        // broadcast message with local awareness state set to null (indicating disconnect)
        const encoder = $kRma6.createEncoder();
        $kRma6.writeVarUint(encoder, $495df03e80ee0346$export$790bca08a5d3ef2c);
        $kRma6.writeVarUint8Array(encoder, $dqc6X.encodeAwarenessUpdate(this.awareness, [
            this.doc.clientID
        ], new Map()));
        $495df03e80ee0346$var$broadcastMessage(this, $kRma6.toUint8Array(encoder));
        if (this.bcconnected) {
            $4vird.unsubscribe(this.bcChannel, this._bcSubscriber);
            this.bcconnected = false;
        }
    }
    disconnect() {
        this.shouldConnect = false;
        this.disconnectBc();
        if (this.ws !== null) $495df03e80ee0346$var$closeWebsocketConnection(this, this.ws, null);
    }
    connect() {
        this.shouldConnect = true;
        if (!this.wsconnected && this.ws === null) {
            $495df03e80ee0346$var$setupWS(this);
            this.connectBc();
        }
    }
}

});
parcelRegister("4vird", function(module, exports) {

$parcel$export(module.exports, "subscribe", () => $34785c129858c7d7$export$ec068583843480e7);
$parcel$export(module.exports, "unsubscribe", () => $34785c129858c7d7$export$f500693cef883ffd);
$parcel$export(module.exports, "publish", () => $34785c129858c7d7$export$89b472e03be495df);
/* eslint-env browser */ /**
 * Helpers for cross-tab communication using broadcastchannel with LocalStorage fallback.
 *
 * ```js
 * // In browser window A:
 * broadcastchannel.subscribe('my events', data => console.log(data))
 * broadcastchannel.publish('my events', 'Hello world!') // => A: 'Hello world!' fires synchronously in same tab
 *
 * // In browser window B:
 * broadcastchannel.publish('my events', 'hello from tab B') // => A: 'hello from tab B'
 * ```
 *
 * @module broadcastchannel
 */ // @todo before next major: use Uint8Array instead as buffer object

var $d1VR8 = parcelRequire("d1VR8");

var $9IXCW = parcelRequire("9IXCW");

var $7WDUw = parcelRequire("7WDUw");

var $btW3J = parcelRequire("btW3J");
/**
 * @typedef {Object} Channel
 * @property {Set<function(any, any):any>} Channel.subs
 * @property {any} Channel.bc
 */ /**
 * @type {Map<string, Channel>}
 */ const $34785c129858c7d7$var$channels = new Map();
/* c8 ignore start */ class $34785c129858c7d7$var$LocalStoragePolyfill {
    /**
   * @param {string} room
   */ constructor(room){
        this.room = room;
        /**
     * @type {null|function({data:ArrayBuffer}):void}
     */ this.onmessage = null;
        /**
     * @param {any} e
     */ this._onChange = (e)=>e.key === room && this.onmessage !== null && this.onmessage({
                data: $7WDUw.fromBase64(e.newValue || '')
            });
        $btW3J.onChange(this._onChange);
    }
    /**
   * @param {ArrayBuffer} buf
   */ postMessage(buf) {
        $btW3J.varStorage.setItem(this.room, $7WDUw.toBase64($7WDUw.createUint8ArrayFromArrayBuffer(buf)));
    }
    close() {
        $btW3J.offChange(this._onChange);
    }
}
/* c8 ignore stop */ // Use BroadcastChannel or Polyfill
/* c8 ignore next */ const $34785c129858c7d7$var$BC = typeof BroadcastChannel === 'undefined' ? $34785c129858c7d7$var$LocalStoragePolyfill : BroadcastChannel;
/**
 * @param {string} room
 * @return {Channel}
 */ const $34785c129858c7d7$var$getChannel = (room)=>$d1VR8.setIfUndefined($34785c129858c7d7$var$channels, room, ()=>{
        const subs = $9IXCW.create();
        const bc = new $34785c129858c7d7$var$BC(room);
        /**
     * @param {{data:ArrayBuffer}} e
     */ /* c8 ignore next */ bc.onmessage = (e)=>subs.forEach((sub)=>sub(e.data, 'broadcastchannel'));
        return {
            bc: bc,
            subs: subs
        };
    });
const $34785c129858c7d7$export$ec068583843480e7 = (room, f)=>{
    $34785c129858c7d7$var$getChannel(room).subs.add(f);
    return f;
};
const $34785c129858c7d7$export$f500693cef883ffd = (room, f)=>{
    const channel = $34785c129858c7d7$var$getChannel(room);
    const unsubscribed = channel.subs.delete(f);
    if (unsubscribed && channel.subs.size === 0) {
        channel.bc.close();
        $34785c129858c7d7$var$channels.delete(room);
    }
    return unsubscribed;
};
const $34785c129858c7d7$export$89b472e03be495df = (room, data, origin = null)=>{
    const c = $34785c129858c7d7$var$getChannel(room);
    c.bc.postMessage(data);
    c.subs.forEach((sub)=>sub(data, origin));
};

});

parcelRegister("ToBJT", function(module, exports) {

$parcel$export(module.exports, "messageYjsSyncStep2", () => $0a6839bea59247af$export$ff102031071a8f85);
$parcel$export(module.exports, "writeSyncStep1", () => $0a6839bea59247af$export$2a4abf6cf2c7e66f);
$parcel$export(module.exports, "writeSyncStep2", () => $0a6839bea59247af$export$b2b01faa10f64871);
$parcel$export(module.exports, "writeUpdate", () => $0a6839bea59247af$export$72c173541034b28e);
$parcel$export(module.exports, "readSyncMessage", () => $0a6839bea59247af$export$26b589e63b591e96);
/**
 * @module sync-protocol
 */ 
var $kRma6 = parcelRequire("kRma6");

var $9QtgA = parcelRequire("9QtgA");

var $lc1R0 = parcelRequire("lc1R0");
const $0a6839bea59247af$export$edbc8479a3fd0d51 = 0;
const $0a6839bea59247af$export$ff102031071a8f85 = 1;
const $0a6839bea59247af$export$f589a35bfce33e17 = 2;
const $0a6839bea59247af$export$2a4abf6cf2c7e66f = (encoder, doc)=>{
    $kRma6.writeVarUint(encoder, $0a6839bea59247af$export$edbc8479a3fd0d51);
    const sv = $lc1R0.encodeStateVector(doc);
    $kRma6.writeVarUint8Array(encoder, sv);
};
const $0a6839bea59247af$export$b2b01faa10f64871 = (encoder, doc, encodedStateVector)=>{
    $kRma6.writeVarUint(encoder, $0a6839bea59247af$export$ff102031071a8f85);
    $kRma6.writeVarUint8Array(encoder, $lc1R0.encodeStateAsUpdate(doc, encodedStateVector));
};
const $0a6839bea59247af$export$24e7fa74cb33e063 = (decoder, encoder, doc)=>$0a6839bea59247af$export$b2b01faa10f64871(encoder, doc, $9QtgA.readVarUint8Array(decoder));
const $0a6839bea59247af$export$60818ebea09048c1 = (decoder, doc, transactionOrigin)=>{
    try {
        $lc1R0.applyUpdate(doc, $9QtgA.readVarUint8Array(decoder), transactionOrigin);
    } catch (error) {
        // This catches errors that are thrown by event handlers
        console.error('Caught error while handling a Yjs update', error);
    }
};
const $0a6839bea59247af$export$72c173541034b28e = (encoder, update)=>{
    $kRma6.writeVarUint(encoder, $0a6839bea59247af$export$f589a35bfce33e17);
    $kRma6.writeVarUint8Array(encoder, update);
};
const $0a6839bea59247af$export$d67ac8d73b7d336c = $0a6839bea59247af$export$60818ebea09048c1;
const $0a6839bea59247af$export$26b589e63b591e96 = (decoder, encoder, doc, transactionOrigin)=>{
    const messageType = $9QtgA.readVarUint(decoder);
    switch(messageType){
        case $0a6839bea59247af$export$edbc8479a3fd0d51:
            $0a6839bea59247af$export$24e7fa74cb33e063(decoder, encoder, doc);
            break;
        case $0a6839bea59247af$export$ff102031071a8f85:
            $0a6839bea59247af$export$60818ebea09048c1(decoder, doc, transactionOrigin);
            break;
        case $0a6839bea59247af$export$f589a35bfce33e17:
            $0a6839bea59247af$export$d67ac8d73b7d336c(decoder, doc, transactionOrigin);
            break;
        default:
            throw new Error('Unknown message type');
    }
    return messageType;
};

});

parcelRegister("aHEC8", function(module, exports) {

$parcel$export(module.exports, "readAuthMessage", () => $7cad6ca1cb96b28e$export$7e13d1a8c99eb68e);


var $kRma6 = parcelRequire("kRma6");

var $9QtgA = parcelRequire("9QtgA");
const $7cad6ca1cb96b28e$export$cfc218bc4e82266b = 0;
const $7cad6ca1cb96b28e$export$492291cd287a058f = (encoder, reason)=>{
    $kRma6.writeVarUint(encoder, $7cad6ca1cb96b28e$export$cfc218bc4e82266b);
    $kRma6.writeVarString(encoder, reason);
};
const $7cad6ca1cb96b28e$export$7e13d1a8c99eb68e = (decoder, y, permissionDeniedHandler)=>{
    switch($9QtgA.readVarUint(decoder)){
        case $7cad6ca1cb96b28e$export$cfc218bc4e82266b:
            permissionDeniedHandler(y, $9QtgA.readVarString(decoder));
    }
};

});

parcelRegister("dqc6X", function(module, exports) {

$parcel$export(module.exports, "Awareness", () => $9c5719200d804a73$export$5bb40478b91fee65);
$parcel$export(module.exports, "removeAwarenessStates", () => $9c5719200d804a73$export$3edbfe2f45ae9ff8);
$parcel$export(module.exports, "encodeAwarenessUpdate", () => $9c5719200d804a73$export$e194fa93ebd743e9);
$parcel$export(module.exports, "applyAwarenessUpdate", () => $9c5719200d804a73$export$2f92845406d72d1a);
/**
 * @module awareness-protocol
 */ 
var $kRma6 = parcelRequire("kRma6");

var $9QtgA = parcelRequire("9QtgA");

var $drUmF = parcelRequire("drUmF");

var $bJmyZ = parcelRequire("bJmyZ");

var $7uKvC = parcelRequire("7uKvC");

var $45hHO = parcelRequire("45hHO");

const $9c5719200d804a73$export$47b58b45939fff5e = 30000;
class $9c5719200d804a73$export$5bb40478b91fee65 extends (0, $7uKvC.Observable) {
    /**
   * @param {Y.Doc} doc
   */ constructor(doc){
        super();
        this.doc = doc;
        /**
     * @type {number}
     */ this.clientID = doc.clientID;
        /**
     * Maps from client id to client state
     * @type {Map<number, Object<string, any>>}
     */ this.states = new Map();
        /**
     * @type {Map<number, MetaClientState>}
     */ this.meta = new Map();
        this._checkInterval = /** @type {any} */ setInterval(()=>{
            const now = $drUmF.getUnixTime();
            if (this.getLocalState() !== null && $9c5719200d804a73$export$47b58b45939fff5e / 2 <= now - /** @type {{lastUpdated:number}} */ this.meta.get(this.clientID).lastUpdated) // renew local clock
            this.setLocalState(this.getLocalState());
            /**
       * @type {Array<number>}
       */ const remove = [];
            this.meta.forEach((meta, clientid)=>{
                if (clientid !== this.clientID && $9c5719200d804a73$export$47b58b45939fff5e <= now - meta.lastUpdated && this.states.has(clientid)) remove.push(clientid);
            });
            if (remove.length > 0) $9c5719200d804a73$export$3edbfe2f45ae9ff8(this, remove, 'timeout');
        }, $bJmyZ.floor($9c5719200d804a73$export$47b58b45939fff5e / 10));
        doc.on('destroy', ()=>{
            this.destroy();
        });
        this.setLocalState({});
    }
    destroy() {
        this.emit('destroy', [
            this
        ]);
        this.setLocalState(null);
        super.destroy();
        clearInterval(this._checkInterval);
    }
    /**
   * @return {Object<string,any>|null}
   */ getLocalState() {
        return this.states.get(this.clientID) || null;
    }
    /**
   * @param {Object<string,any>|null} state
   */ setLocalState(state) {
        const clientID = this.clientID;
        const currLocalMeta = this.meta.get(clientID);
        const clock = currLocalMeta === undefined ? 0 : currLocalMeta.clock + 1;
        const prevState = this.states.get(clientID);
        if (state === null) this.states.delete(clientID);
        else this.states.set(clientID, state);
        this.meta.set(clientID, {
            clock: clock,
            lastUpdated: $drUmF.getUnixTime()
        });
        const added = [];
        const updated = [];
        const filteredUpdated = [];
        const removed = [];
        if (state === null) removed.push(clientID);
        else if (prevState == null) {
            if (state != null) added.push(clientID);
        } else {
            updated.push(clientID);
            if (!$45hHO.equalityDeep(prevState, state)) filteredUpdated.push(clientID);
        }
        if (added.length > 0 || filteredUpdated.length > 0 || removed.length > 0) this.emit('change', [
            {
                added: added,
                updated: filteredUpdated,
                removed: removed
            },
            'local'
        ]);
        this.emit('update', [
            {
                added: added,
                updated: updated,
                removed: removed
            },
            'local'
        ]);
    }
    /**
   * @param {string} field
   * @param {any} value
   */ setLocalStateField(field, value) {
        const state = this.getLocalState();
        if (state !== null) this.setLocalState({
            ...state,
            [field]: value
        });
    }
    /**
   * @return {Map<number,Object<string,any>>}
   */ getStates() {
        return this.states;
    }
}
const $9c5719200d804a73$export$3edbfe2f45ae9ff8 = (awareness, clients, origin)=>{
    const removed = [];
    for(let i = 0; i < clients.length; i++){
        const clientID = clients[i];
        if (awareness.states.has(clientID)) {
            awareness.states.delete(clientID);
            if (clientID === awareness.clientID) {
                const curMeta = /** @type {MetaClientState} */ awareness.meta.get(clientID);
                awareness.meta.set(clientID, {
                    clock: curMeta.clock + 1,
                    lastUpdated: $drUmF.getUnixTime()
                });
            }
            removed.push(clientID);
        }
    }
    if (removed.length > 0) {
        awareness.emit('change', [
            {
                added: [],
                updated: [],
                removed: removed
            },
            origin
        ]);
        awareness.emit('update', [
            {
                added: [],
                updated: [],
                removed: removed
            },
            origin
        ]);
    }
};
const $9c5719200d804a73$export$e194fa93ebd743e9 = (awareness, clients, states = awareness.states)=>{
    const len = clients.length;
    const encoder = $kRma6.createEncoder();
    $kRma6.writeVarUint(encoder, len);
    for(let i = 0; i < len; i++){
        const clientID = clients[i];
        const state = states.get(clientID) || null;
        const clock = /** @type {MetaClientState} */ awareness.meta.get(clientID).clock;
        $kRma6.writeVarUint(encoder, clientID);
        $kRma6.writeVarUint(encoder, clock);
        $kRma6.writeVarString(encoder, JSON.stringify(state));
    }
    return $kRma6.toUint8Array(encoder);
};
const $9c5719200d804a73$export$17dfc8fb4d274726 = (update, modify)=>{
    const decoder = $9QtgA.createDecoder(update);
    const encoder = $kRma6.createEncoder();
    const len = $9QtgA.readVarUint(decoder);
    $kRma6.writeVarUint(encoder, len);
    for(let i = 0; i < len; i++){
        const clientID = $9QtgA.readVarUint(decoder);
        const clock = $9QtgA.readVarUint(decoder);
        const state = JSON.parse($9QtgA.readVarString(decoder));
        const modifiedState = modify(state);
        $kRma6.writeVarUint(encoder, clientID);
        $kRma6.writeVarUint(encoder, clock);
        $kRma6.writeVarString(encoder, JSON.stringify(modifiedState));
    }
    return $kRma6.toUint8Array(encoder);
};
const $9c5719200d804a73$export$2f92845406d72d1a = (awareness, update, origin)=>{
    const decoder = $9QtgA.createDecoder(update);
    const timestamp = $drUmF.getUnixTime();
    const added = [];
    const updated = [];
    const filteredUpdated = [];
    const removed = [];
    const len = $9QtgA.readVarUint(decoder);
    for(let i = 0; i < len; i++){
        const clientID = $9QtgA.readVarUint(decoder);
        let clock = $9QtgA.readVarUint(decoder);
        const state = JSON.parse($9QtgA.readVarString(decoder));
        const clientMeta = awareness.meta.get(clientID);
        const prevState = awareness.states.get(clientID);
        const currClock = clientMeta === undefined ? 0 : clientMeta.clock;
        if (currClock < clock || currClock === clock && state === null && awareness.states.has(clientID)) {
            if (state === null) {
                // never let a remote client remove this local state
                if (clientID === awareness.clientID && awareness.getLocalState() != null) // remote client removed the local state. Do not remote state. Broadcast a message indicating
                // that this client still exists by increasing the clock
                clock++;
                else awareness.states.delete(clientID);
            } else awareness.states.set(clientID, state);
            awareness.meta.set(clientID, {
                clock: clock,
                lastUpdated: timestamp
            });
            if (clientMeta === undefined && state !== null) added.push(clientID);
            else if (clientMeta !== undefined && state === null) removed.push(clientID);
            else if (state !== null) {
                if (!$45hHO.equalityDeep(state, prevState)) filteredUpdated.push(clientID);
                updated.push(clientID);
            }
        }
    }
    if (added.length > 0 || filteredUpdated.length > 0 || removed.length > 0) awareness.emit('change', [
        {
            added: added,
            updated: filteredUpdated,
            removed: removed
        },
        origin
    ]);
    if (added.length > 0 || updated.length > 0 || removed.length > 0) awareness.emit('update', [
        {
            added: added,
            updated: updated,
            removed: removed
        },
        origin
    ]);
};

});

parcelRegister("5o50s", function(module, exports) {

$parcel$export(module.exports, "encodeQueryParams", () => $3ec313c8cfdd79f9$export$8c0ce924e434923b);
/**
 * Utility module to work with urls.
 *
 * @module url
 */ 
var $4m6H0 = parcelRequire("4m6H0");
const $3ec313c8cfdd79f9$export$6025d61c37f75253 = (url)=>{
    /**
   * @type {Object<string,string>}
   */ const query = {};
    const urlQuerySplit = url.split('?');
    const pairs = urlQuerySplit[urlQuerySplit.length - 1].split('&');
    for(let i = 0; i < pairs.length; i++){
        const item = pairs[i];
        if (item.length > 0) {
            const pair = item.split('=');
            query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
        }
    }
    return query;
};
const $3ec313c8cfdd79f9$export$8c0ce924e434923b = (params)=>$4m6H0.map(params, (val, key)=>`${encodeURIComponent(key)}=${encodeURIComponent(val)}`).join('&');

});


parcelRegister("gFW3W", function(module, exports) {

$parcel$export(module.exports, "listen", () => $c23d83b256c12a3b$export$63174c828edd6ff8);
$parcel$export(module.exports, "elem", () => $c23d83b256c12a3b$export$5bf96401662340b7);
$parcel$export(module.exports, "getScaleFreeNetwork", () => $c23d83b256c12a3b$export$6bf6edce410823e2);
$parcel$export(module.exports, "uuidv4", () => $c23d83b256c12a3b$export$abe4376e1bf796d6);
$parcel$export(module.exports, "isEmpty", () => $c23d83b256c12a3b$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "deepMerge", () => $c23d83b256c12a3b$export$6969335ea1e4e77c);
$parcel$export(module.exports, "deepCopy", () => $c23d83b256c12a3b$export$6c40052bed430212);
$parcel$export(module.exports, "object_equals", () => $c23d83b256c12a3b$export$4ac8d508c4ab434e);
$parcel$export(module.exports, "strip", () => $c23d83b256c12a3b$export$6a0f863afc2134d8);
$parcel$export(module.exports, "splitText", () => $c23d83b256c12a3b$export$2878cc467c8be8fe);
$parcel$export(module.exports, "factorSizeToPercent", () => $c23d83b256c12a3b$export$ac4113339a72565f);
$parcel$export(module.exports, "setFactorSizeFromPercent", () => $c23d83b256c12a3b$export$a0bb1be471bb15e6);
$parcel$export(module.exports, "getDashes", () => $c23d83b256c12a3b$export$530c09b40c9ab953);
$parcel$export(module.exports, "convertDashes", () => $c23d83b256c12a3b$export$adbf3e12eca5d8b);
$parcel$export(module.exports, "dragElement", () => $c23d83b256c12a3b$export$69374dc2b307e4);
$parcel$export(module.exports, "addContextMenu", () => $c23d83b256c12a3b$export$598e091c8246c6cb);
$parcel$export(module.exports, "generateName", () => $c23d83b256c12a3b$export$5d832d6580b26c5);
$parcel$export(module.exports, "statusMsg", () => $c23d83b256c12a3b$export$3cb6beff6f79e98b);
$parcel$export(module.exports, "alertMsg", () => $c23d83b256c12a3b$export$9968692a49529c1);
$parcel$export(module.exports, "cancelAlertMsg", () => $c23d83b256c12a3b$export$3f0900b8af1937e2);
$parcel$export(module.exports, "clearStatusBar", () => $c23d83b256c12a3b$export$62fd92124955fcd2);
$parcel$export(module.exports, "shorten", () => $c23d83b256c12a3b$export$dd78866213f805a5);
$parcel$export(module.exports, "initials", () => $c23d83b256c12a3b$export$82a129a7016c8ea8);
$parcel$export(module.exports, "setNodeHidden", () => $c23d83b256c12a3b$export$607b01733b83ff83);
$parcel$export(module.exports, "setEdgeHidden", () => $c23d83b256c12a3b$export$d2556b5c60092110);
$parcel$export(module.exports, "standardize_color", () => $c23d83b256c12a3b$export$8ca79063e5b53d36);
$parcel$export(module.exports, "makeColor", () => $c23d83b256c12a3b$export$b09d2a0246869f74);
$parcel$export(module.exports, "lightOrDark", () => $c23d83b256c12a3b$export$c44b387df32fe705);
$parcel$export(module.exports, "CP", () => $c23d83b256c12a3b$export$6d0b2a5dd774590a);
$parcel$export(module.exports, "timeAndDate", () => $c23d83b256c12a3b$export$b3902f047e75d149);
$parcel$export(module.exports, "setEndOfContenteditable", () => $c23d83b256c12a3b$export$8bc063faa2ba2bd3);
$parcel$export(module.exports, "exactTime", () => $c23d83b256c12a3b$export$cdee113d0db2579a);
$parcel$export(module.exports, "capitalizeFirstLetter", () => $c23d83b256c12a3b$export$d07f57595c356899);
$parcel$export(module.exports, "lowerFirstLetter", () => $c23d83b256c12a3b$export$81b06ab76a3757ce);
$parcel$export(module.exports, "humanSize", () => $c23d83b256c12a3b$export$89dc6f1d08c41ada);
$parcel$export(module.exports, "isQuillEmpty", () => $c23d83b256c12a3b$export$99f0341e4542bf23);
$parcel$export(module.exports, "stripNL", () => $c23d83b256c12a3b$export$e6b553c28e5248fd);
$parcel$export(module.exports, "displayHelp", () => $c23d83b256c12a3b$export$9f711266042c4a52);
/*********************************************************************************************************************  

PRSM Participatory System Mapper 

	Copyright (C) 2022  Nigel Gilbert prsm@prsm.uk

	This program is free software: you can redistribute it and/or modify
	it under the terms of the GNU General Public License as published by
	the Free Software Foundation, either version 3 of the License, or
	(at your option) any later version.

	This program is distributed in the hope that it will be useful,
	but WITHOUT ANY WARRANTY; without even the implied warranty of
	MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	GNU General Public License for more details.

	You should have received a copy of the GNU General Public License
	along with this program.  If not, see <https://www.gnu.org/licenses/>.


This module provides a set of utility functions used widely within the PRSM code.  
 ******************************************************************************************************************** */ 
var $hV9VG = parcelRequire("hV9VG");

var $bEhJ5 = parcelRequire("bEhJ5");
const $c23d83b256c12a3b$var$MANUALURL = './doc/help/doc_build/manual/Introduction.html';
function $c23d83b256c12a3b$export$63174c828edd6ff8(id, event, callback, options) {
    $c23d83b256c12a3b$export$5bf96401662340b7(id).addEventListener(event, callback, options);
}
function $c23d83b256c12a3b$export$5bf96401662340b7(id) {
    return document.getElementById(id);
}
function $c23d83b256c12a3b$export$c81866d3953e7921(array, item) {
    if (array) {
        if (!array.includes(item)) array.push(item);
    } else array = [
        item
    ];
    return array;
}
function $c23d83b256c12a3b$export$6bf6edce410823e2(nodeCount) {
    var nodes = [];
    var edges = [];
    var connectionCount = [];
    // randomly create some nodes and edges
    for(var i = 0; i < nodeCount; i++){
        nodes.push({
            id: String(i),
            label: String(i),
            grp: 'group0',
            value: 1
        });
        connectionCount[i] = 0;
        // create edges in a scale-free-network way
        if (i == 1) {
            var from = i;
            var to = 0;
            edges.push({
                from: from.toString(),
                to: to.toString(),
                grp: 'edge0'
            });
            connectionCount[from]++;
            connectionCount[to]++;
        } else if (i > 1) {
            var conn = edges.length * 2;
            var rand = Math.floor($c23d83b256c12a3b$var$seededRandom() * conn);
            var cum = 0;
            var j = 0;
            while(j < connectionCount.length && cum < rand){
                cum += connectionCount[j];
                j++;
            }
            from = i;
            to = j;
            edges.push({
                from: from.toString(),
                to: to.toString(),
                grp: 'edge0'
            });
            connectionCount[from]++;
            connectionCount[to]++;
        }
    }
    return {
        nodes: nodes,
        edges: edges
    };
}
var $c23d83b256c12a3b$var$randomSeed = 764 // Math.round(Math.random()*1000);
;
function $c23d83b256c12a3b$var$seededRandom() {
    var x = Math.sin($c23d83b256c12a3b$var$randomSeed++) * 10000;
    return x - Math.floor(x);
}
function $c23d83b256c12a3b$export$abe4376e1bf796d6() {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c)=>(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
}
function $c23d83b256c12a3b$export$dd1bc94b04021eeb(obj) {
    for(let p in obj)return false;
    return true;
}
function $c23d83b256c12a3b$export$6969335ea1e4e77c() {
    // Setup merged object
    let newObj = {};
    // Merge the object into the newObj object
    function merge(obj) {
        for(let prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
            // If property is an object, merge properties
            if (Object.prototype.toString.call(obj[prop]) === '[object Object]') newObj[prop] = $c23d83b256c12a3b$export$6969335ea1e4e77c(newObj[prop], obj[prop]);
            else newObj[prop] = obj[prop];
        }
    }
    // Loop through each object and conduct a merge
    for(let i = 0; i < arguments.length; i++)merge(arguments[i]);
    return newObj;
}
function $c23d83b256c12a3b$export$6c40052bed430212(obj) {
    /* 	if (typeof obj !== 'object' || obj === null) {
		return obj
	}
	if (obj instanceof Array) {
		return obj.reduce((arr, item, i) => {
			arr[i] = deepCopy(item)
			return arr
		}, [])
	}
	if (obj instanceof Object) {
		return Object.keys(obj).reduce((newObj, key) => {
			newObj[key] = deepCopy(obj[key])
			return newObj
		}, {})
	} */ return structuredClone(obj);
}
window.deepCopy = $c23d83b256c12a3b$export$6c40052bed430212;
function $c23d83b256c12a3b$export$4ac8d508c4ab434e(x, y) {
    if (x === y) return true;
    // if both x and y are null or undefined and exactly the same
    if (!(x instanceof Object) || !(y instanceof Object)) return false;
    // if they are not strictly equal, they both need to be Objects
    if (x.constructor !== y.constructor) return false;
    // they must have the exact same prototype chain, the closest we can do is
    // test their constructor.
    for(let p in x){
        if (!Object.prototype.hasOwnProperty.call(x, p)) continue;
        // other properties were tested using x.constructor === y.constructor
        if (!Object.prototype.hasOwnProperty.call(y, p)) return false;
        // allows to compare x[ p ] and y[ p ] when set to undefined
        if (x[p] === y[p]) continue;
        // if they have the same strict value or identity then they are equal
        if (typeof x[p] !== 'object') return false;
        // Numbers, Strings, Functions, Booleans must be strictly equal
        if (!$c23d83b256c12a3b$export$4ac8d508c4ab434e(x[p], y[p])) return false;
    // Objects and Arrays must be tested recursively
    }
    for(let p in y)if (Object.prototype.hasOwnProperty.call(y, p) && !Object.prototype.hasOwnProperty.call(x, p)) return false;
    // allows x[ p ] to be set to undefined
    return true;
}
window.object_equals = $c23d83b256c12a3b$export$4ac8d508c4ab434e;
function $c23d83b256c12a3b$export$cf0b2a6c63f9e656(source, propsToRemove) {
    let out = {};
    for(let key in source)if (!(key in propsToRemove)) out[key] = source[key];
    return out;
}
function $c23d83b256c12a3b$export$c39b210f955bc1b8(arr, propsToRemove) {
    return arr.map((item)=>{
        return $c23d83b256c12a3b$export$cf0b2a6c63f9e656(item, propsToRemove);
    });
}
function $c23d83b256c12a3b$export$6a0f863afc2134d8(obj, allowed) {
    return allowed.reduce((a, e)=>(a[e] = obj[e], a), {});
}
function $c23d83b256c12a3b$export$2878cc467c8be8fe(txt, width = 10) {
    let lines = '';
    let chunks = txt.trim().split('\n');
    chunks.forEach((chunk)=>{
        let words = chunk.trim().split(/\s/);
        let nChars = chunk.trim().length;
        if (nChars > 2 * width) width = Math.floor(Math.sqrt(nChars));
        for(let i = 0, linelength = 0; i < words.length; i++){
            lines += words[i];
            if (i == words.length - 1) break;
            linelength += words[i].length;
            if (linelength > width) {
                lines += '\n';
                linelength = 0;
            } else lines += ' ';
        }
        lines += '\n';
    });
    return lines.trim();
}
/**
 * Performs intersection operation between called set and otherSet
 */ Set.prototype.intersection = function(otherSet) {
    let intersectionSet = new Set();
    for (var el of otherSet)if (this.has(el)) intersectionSet.add(el);
    return intersectionSet;
};
function $c23d83b256c12a3b$export$ac4113339a72565f(size) {
    let fSize = (size - 20) / 2.5;
    return isNaN(fSize) || fSize < 30 ? 0 : fSize;
}
function $c23d83b256c12a3b$export$a0bb1be471bb15e6(node, percent) {
    if (percent < 5) {
        node.size = 25;
        node.heightConstraint = node.widthConstraint = false;
    } else node.heightConstraint = node.widthConstraint = node.size = percent * 2.5 + 20;
}
function $c23d83b256c12a3b$export$530c09b40c9ab953(bDashes, bWidth) {
    if (bWidth === 0) return 'none';
    if (bDashes === false) return 'solid';
    if (bDashes === true) return 'dashed';
    if (Array.isArray(bDashes)) {
        if (bDashes[0] === 10) return 'dashedLinks';
        return 'dots';
    }
    return null;
}
function $c23d83b256c12a3b$export$adbf3e12eca5d8b(val) {
    switch(val){
        case 'dashed':
            return true;
        case 'dashedLinks':
            return [
                10,
                10
            ];
        case 'solid':
            return false;
        case 'none':
            return false;
        case 'dots':
            return [
                2,
                8
            ];
        default:
            return false;
    }
}
function $c23d83b256c12a3b$export$69374dc2b307e4(el, header) {
    header.addEventListener('mouseenter', ()=>header.style.cursor = 'move');
    header.addEventListener('mouseout', ()=>header.style.cursor = 'auto');
    let mc = new $hV9VG.Manager(header, {
        recognizers: [
            [
                $hV9VG.Pan,
                {
                    direction: $hV9VG.DIRECTION_ALL,
                    threshold: 0
                }
            ]
        ]
    });
    // tie in the handler that will be called
    mc.on('pan', handleDrag);
    let lastPosX = 0;
    let lastPosY = 0;
    let isDragging = false;
    let width = 0;
    let height = 0;
    function handleDrag(ev) {
        // DRAG STARTED
        // here, let's snag the current position
        // and keep track of the fact that we're dragging
        if (!isDragging) {
            isDragging = true;
            lastPosX = el.offsetLeft;
            lastPosY = el.offsetTop;
            width = el.offsetWidth;
            height = el.offsetHeight;
        }
        // we simply need to determine where the x,y of this
        // object is relative to where it's "last" known position is
        // NOTE:
        //    deltaX and deltaY are cumulative
        // Thus we need to always calculate 'real x and y' relative
        // to the "lastPosX/Y"
        el.style.cursor = 'move';
        let posX = ev.deltaX + lastPosX;
        if (posX < 0) posX = 0;
        if (posX > window.innerWidth - width) posX = window.innerWidth - width;
        let posY = ev.deltaY + lastPosY;
        if (posY < 0) posY = 0;
        if (posY > window.innerHeight - height) posY = window.innerHeight - height;
        // move our element to that position
        el.style.left = posX + 'px';
        el.style.top = posY + 'px';
        // DRAG ENDED
        // this is where we simply forget we are dragging
        if (ev.isFinal) {
            isDragging = false;
            el.style.cursor = 'auto';
        }
    }
}
function $c23d83b256c12a3b$export$598e091c8246c6cb(elem, menu) {
    const menuEl = document.createElement('div');
    menuEl.classList.add('context-menu');
    document.body.appendChild(menuEl);
    elem.addEventListener('contextmenu', (event)=>{
        event.preventDefault();
        const { clientX: mouseX, clientY: mouseY } = event;
        let posX = window.innerWidth - mouseX < menuEl.offsetWidth + 4 ? window.innerWidth - menuEl.offsetWidth - 4 : mouseX;
        let posY = window.innerHeight - mouseY < menuEl.offsetHeight + 4 ? window.innerHeight - menuEl.offsetHeight - 4 : mouseY;
        menuEl.style.top = `${posY}px`;
        menuEl.style.left = `${posX}px`;
        menuEl.classList.remove('visible');
        setTimeout(()=>{
            menuEl.classList.add('visible');
        });
    });
    document.body.addEventListener('click', ()=>{
        menuEl.classList.remove('visible');
    });
    menu.forEach((item)=>{
        const { label: label, action: action } = item;
        let option = document.createElement('div');
        option.classList.add('item');
        option.innerHTML = label;
        option.addEventListener('click', ()=>{
            document.body.removeChild(menuEl);
            action();
        });
        option.addEventListener('contextmenu', (event)=>event.preventDefault());
        menuEl.appendChild(option);
    });
}
const $c23d83b256c12a3b$var$SEA_CREATURES = Object.freeze([
    'walrus',
    'seal',
    'fish',
    'shark',
    'clam',
    'coral',
    'whale',
    'crab',
    'lobster',
    'starfish',
    'eel',
    'dolphin',
    'squid',
    'jellyfish',
    'ray',
    'shrimp',
    'herring',
    'angler',
    'mackerel',
    'salmon',
    'urchin',
    'anemone',
    'morel',
    'axolotl',
    'blobfish',
    'tubeworm',
    'seabream',
    'seaweed',
    'anchovy',
    'cod',
    'barramundi',
    'carp',
    'crayfish',
    'haddock',
    'hake',
    'octopus',
    'plaice',
    'sardine',
    'skate',
    'sturgeon',
    'swordfish',
    'whelk'
]);
const $c23d83b256c12a3b$var$ADJECTIVES = Object.freeze([
    'cute',
    'adorable',
    'lovable',
    'happy',
    'sandy',
    'bubbly',
    'friendly',
    'drifting',
    'huge',
    'big',
    'small',
    'giant',
    'massive',
    'tiny',
    'nippy',
    'odd',
    'perfect',
    'rude',
    'wonderful',
    'agile',
    'beautiful',
    'bossy',
    'candid',
    'carnivorous',
    'clever',
    'cold',
    'cold-blooded',
    'colorful',
    'cuddly',
    'curious',
    'cute',
    'dangerous',
    'deadly',
    'domestic',
    'dominant',
    'energetic',
    'fast',
    'feisty',
    'ferocious',
    'fierce',
    'fluffy',
    'friendly',
    'furry',
    'fuzzy',
    'grumpy',
    'hairy',
    'heavy',
    'herbivorous',
    'jealous',
    'large',
    'lazy',
    'loud',
    'lovable',
    'loving',
    'malicious',
    'maternal',
    'mean',
    'messy',
    'nocturnal',
    'noisy',
    'nosy',
    'picky',
    'playful',
    'poisonous',
    'quick',
    'rough',
    'sassy',
    'scaly',
    'short',
    'shy',
    'slimy',
    'slow',
    'small',
    'smart',
    'smelly',
    'soft',
    'spikey',
    'stinky',
    'strong',
    'stubborn',
    'submissive',
    'tall',
    'tame',
    'tenacious',
    'territorial',
    'tiny',
    'vicious',
    'warm',
    'wild'
]);
let $c23d83b256c12a3b$var$colors = [
    '#00ffff',
    '#f0ffff',
    '#f5f5dc',
    '#0000ff',
    '#a52a2a',
    '#00008b',
    '#008b8b',
    '#a9a9a9',
    '#006400',
    '#bdb76b',
    '#8b008b',
    '#556b2f',
    '#ff8c00',
    '#9932cc',
    '#8b0000',
    '#e9967a',
    '#9400d3',
    '#ff00ff',
    '#ffd700',
    '#008000',
    '#4b0082',
    '#f0e68c',
    '#add8e6',
    '#e0ffff',
    '#90ee90',
    '#d3d3d3',
    '#ffb6c1',
    '#ffffe0',
    '#00ff00',
    '#ff00ff',
    '#800000',
    '#000080',
    '#808000',
    '#ffa500',
    '#ffc0cb',
    '#800080',
    '#ff0000',
    '#c0c0c0',
    '#ffff00'
];
const $c23d83b256c12a3b$var$random = (items)=>items[Math.random() * items.length | 0];
/**
 * Determine whether the RGB color is light or not
 * http://www.w3.org/TR/AERT#color-contrast
 * @param  {number}  r               Red
 * @param  {number}  g               Green
 * @param  {number}  b               Blue
 * @param  {number}  differencePoint
 * @return {boolean}
 */ const $c23d83b256c12a3b$var$rgbIsLight = (r, g, b, differencePoint)=>(r * 299 + g * 587 + b * 114) / 1000 >= differencePoint;
/**
 * return a random colour, with a flag to show whether the color is light or dark,
 *  to suggest whether text applied should be white or black
 * @returns {Object} {color: string, isLight: boolean}
 */ function $c23d83b256c12a3b$var$randomColour() {
    const color = $c23d83b256c12a3b$var$random($c23d83b256c12a3b$var$colors);
    const rgb = color.replace('#', '');
    return {
        color: color,
        isLight: $c23d83b256c12a3b$var$rgbIsLight(parseInt(rgb.substring(0, 2), 16), parseInt(rgb.substring(2, 4), 16), parseInt(rgb.substring(4, 6), 16), 128)
    };
}
const $c23d83b256c12a3b$var$capitalize = (string)=>string[0].toUpperCase() + string.slice(1);
function $c23d83b256c12a3b$export$5d832d6580b26c5() {
    let name = $c23d83b256c12a3b$var$capitalize($c23d83b256c12a3b$var$random($c23d83b256c12a3b$var$ADJECTIVES)) + ' ' + $c23d83b256c12a3b$var$capitalize($c23d83b256c12a3b$var$random($c23d83b256c12a3b$var$SEA_CREATURES));
    return {
        ...$c23d83b256c12a3b$var$randomColour(),
        name: name,
        anon: true,
        asleep: false
    };
}
function $c23d83b256c12a3b$export$3cb6beff6f79e98b(msg) {
    $c23d83b256c12a3b$export$5bf96401662340b7('statusBar').innerHTML = $c23d83b256c12a3b$var$htmlEntities(msg);
}
function $c23d83b256c12a3b$export$9968692a49529c1(msg, status, dontFade) {
    let errMsgElement = $c23d83b256c12a3b$export$5bf96401662340b7('errMsg');
    switch(status){
        case 'info':
            errMsgElement.style.backgroundColor = 'black';
            errMsgElement.style.color = 'white';
            break;
        case 'warn':
            errMsgElement.style.backgroundColor = '#FFEB3B';
            errMsgElement.style.color = 'black';
            break;
        case 'error':
            errMsgElement.style.backgroundColor = 'red';
            errMsgElement.style.color = 'white';
            break;
        default:
            console.log('Unknown status in alertMsg: ' + status);
            return;
    }
    errMsgElement.innerHTML = msg;
    if (dontFade) errMsgElement.style.opacity = 1;
    else {
        $c23d83b256c12a3b$export$63174c828edd6ff8('errMsg', 'animationend', ()=>{
            $c23d83b256c12a3b$export$5bf96401662340b7('errMsg').classList.remove('fadeInAndOut');
        });
        errMsgElement.classList.add('fadeInAndOut');
    }
}
function $c23d83b256c12a3b$export$3f0900b8af1937e2() {
    $c23d83b256c12a3b$export$5bf96401662340b7('errMsg').style.opacity = 0;
}
/**
 * replace special characters with their HTML entity codes
 * @param {string} str
 */ function $c23d83b256c12a3b$var$htmlEntities(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&quot;');
}
function $c23d83b256c12a3b$export$62fd92124955fcd2() {
    $c23d83b256c12a3b$export$3cb6beff6f79e98b(' ');
}
/**
 * shorten the label if necessary and add an ellipsis
 * @param {string} label text to shorten
 * @param {number} maxLength if longer than this, cut the excess
 */ const $c23d83b256c12a3b$var$SHORTLABELLEN = 25 // when listing node labels, use ellipsis after this number of chars
;
function $c23d83b256c12a3b$export$dd78866213f805a5(label, maxLength = $c23d83b256c12a3b$var$SHORTLABELLEN) {
    return label.length > maxLength ? label.substring(0, maxLength) + '...' : label;
}
function $c23d83b256c12a3b$export$82a129a7016c8ea8(name) {
    return name.replace(/[^A-Za-z0-9À-ÿ ]/gi, '').replace(/ +/gi, ' ').match(/(^\S\S?|\b\S)?/g).join('').match(/(^\S|\S$)?/g).join('').toUpperCase();
}
/**********************************************************colours ************************************************** */ const $c23d83b256c12a3b$var$hiddenOpacity = 0.1;
function $c23d83b256c12a3b$export$607b01733b83ff83(node, hide) {
    node.nodeHidden = hide;
    node.opacity = hide ? $c23d83b256c12a3b$var$hiddenOpacity : 1.0;
    node.font.color = $c23d83b256c12a3b$var$rgba(node.font.color, hide ? $c23d83b256c12a3b$var$hiddenOpacity : 1.0);
    return node;
}
function $c23d83b256c12a3b$export$d2556b5c60092110(edge, hide) {
    edge.edgeHidden = hide;
    edge.color.opacity = hide ? $c23d83b256c12a3b$var$hiddenOpacity : 1.0;
    if (!edge.font.color) edge.font.color = 'rgba(0,0,0,1)';
    edge.font.color = $c23d83b256c12a3b$var$rgba(edge.font.color, hide ? $c23d83b256c12a3b$var$hiddenOpacity : 1.0);
    return edge;
}
/**
 * convert an rgb(a) string to rgba with given alpha value
 */ function $c23d83b256c12a3b$var$rgba(rgb, alpha) {
    if (rgb.indexOf('a') == -1) rgb = rgb.replace('rgb', 'rgba').replace(')', ',0.0)');
    return rgb.replace(/[^,]*$/, ` ${alpha})`);
}
function $c23d83b256c12a3b$export$8ca79063e5b53d36(str) {
    if (!str) return '#000000';
    if (str.charAt(0) === '#') return str;
    let ctx = document.createElement('canvas').getContext('2d');
    ctx.fillStyle = str;
    return ctx.fillStyle;
}
function $c23d83b256c12a3b$export$34921afaa5f8c308(color) {
    return '#' + ('000000' + (0xffffff ^ parseInt(color.substring(1), 16)).toString(16)).slice(-6);
}
const $c23d83b256c12a3b$export$b09d2a0246869f74 = function() {
    let counter = 0;
    let freq = 0.3, phase1 = 0, phase2 = 2, phase3 = 4, center = 128, width = 127;
    return function() {
        counter += 1;
        let red = Math.sin(freq * counter + phase1) * width + center;
        let grn = Math.sin(freq * counter + phase2) * width + center;
        let blu = Math.sin(freq * counter + phase3) * width + center;
        return 'rgb(' + Math.round(red) + ',' + Math.round(grn) + ',' + Math.round(blu) + ')';
    };
}();
window.makeColor = $c23d83b256c12a3b$export$b09d2a0246869f74;
function $c23d83b256c12a3b$export$c44b387df32fe705(color) {
    // Variables for red, green, blue values
    let r, g, b, hsp;
    // Check the format of the color, HEX or RGB?
    if (color.match(/^rgb/)) {
        // If RGB --> store the red, green, blue values in separate variables
        color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
        r = color[1];
        g = color[2];
        b = color[3];
    } else {
        // If hex --> Convert it to RGB: http://gist.github.com/983661
        color = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));
        r = color >> 16;
        g = color >> 8 & 255;
        b = color & 255;
    }
    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
    // Using the HSP value, determine whether the color is light or dark
    if (hsp > 127.5) return 'light';
    else return 'dark';
}
class $c23d83b256c12a3b$export$6d0b2a5dd774590a {
    constructor(){
        this.container = document.createElement('div');
        this.container.className = 'color-picker-container';
        this.container.id = 'colorPicker';
        let controls = document.createElement('div');
        controls.id = 'colorPickerControls';
        this.container.appendChild(controls);
        document.querySelector('body').insertAdjacentElement('beforeend', this.container);
        // see https://iro.js.org/guide.html#getting-started
        this.colorPicker = new (0, $bEhJ5.default).ColorPicker('#colorPickerControls', {
            width: 160,
            color: 'rgba(255, 255, 255, 1)',
            borderWidth: 1,
            borderColor: 'rgba(255, 255, 255,1)',
            margin: 6,
            layout: [
                {
                    component: (0, $bEhJ5.default).ui.Wheel,
                    options: {
                        borderColor: '#ffffff'
                    }
                },
                {
                    component: (0, $bEhJ5.default).ui.Slider,
                    options: {
                        borderColor: '#000000',
                        sliderType: 'value',
                        padding: 2,
                        handleRadius: 4
                    }
                },
                {
                    component: (0, $bEhJ5.default).ui.Slider,
                    options: {
                        borderColor: '#000000',
                        sliderType: 'alpha',
                        padding: 2,
                        handleRadius: 4
                    }
                }
            ]
        });
        // set up a grid of squares to hold last 8 selected colors
        this.colorCache = document.createElement('div');
        this.colorCache.id = 'colorCache';
        this.colorCache.className = 'color-cache';
        for(let i = 0; i < 8; i++){
            let c = document.createElement('div');
            c.id = 'color' + i;
            c.className = 'cached-color';
            // prefill with standard colours
            c.style.backgroundColor = [
                'rgba(255, 0, 0,1)',
                'rgba(0, 255, 0,1)',
                'rgb(0, 0, 255)',
                'rgba(255, 255, 0,1)',
                'rgb(255, 255, 255)',
                'rgba(0, 0, 0,1)',
                'rgba(154, 219, 180,1)',
                'rgba(219, 110, 103,1)'
            ][i];
            c.addEventListener('click', (e)=>{
                let color = e.target.style.backgroundColor;
                if (color) this.colorPicker.color.rgbaString = e.target.style.backgroundColor;
            });
            this.colorCache.appendChild(c);
        }
        document.getElementById('colorPickerControls').insertAdjacentElement('afterend', this.colorCache);
    }
    /**
	 * attach a color picker to an element to recolor the background to that element
	 * @param {string} wellId the id of the DOM element to attach the color picker to
	 * @param {string} callback - function to call when the color has been chosen, with that color as argument
	 */ createColorPicker(wellId, callback, onChange) {
        let well = $c23d83b256c12a3b$export$5bf96401662340b7(wellId);
        well.style.backgroundColor = '#ffffff';
        // add listener to display picker when well clicked
        well.addEventListener('click', (event)=>{
            this.container.style.display = 'block';
            let netPane = $c23d83b256c12a3b$export$5bf96401662340b7('net-pane').getBoundingClientRect();
            // locate picker so it does not go outside netPane
            let top = event.clientY + well.offsetHeight + 10;
            if (top > netPane.bottom - this.container.offsetHeight) top = netPane.bottom - this.container.offsetHeight - 10;
            if (top < netPane.top) top = netPane.top + 10;
            let left = event.clientX - this.container.offsetWidth / 2;
            if (left < netPane.left) left = netPane.left + 10;
            if (left > netPane.right - this.container.offsetWidth) left = netPane.right - this.container.offsetWidth - 10;
            this.container.style.top = `${top}px`;
            this.container.style.left = `${left}px`;
            this.container.well = well;
            this.container.callback = callback;
            this.container.onChange = onChange;
            this.colorPicker.color.rgbaString = well.style.backgroundColor;
            this.onclose = this.closeColorPicker.bind(this);
            document.addEventListener('click', this.onclose, true);
            // update well as color is changed
            this.colorPicker.on('color:change', (color)=>{
                well.style.backgroundColor = color.rgbaString;
                if (onChange) onChange();
            });
        });
    }
    /**
	 * Report chosen colour when user clicks outside of picker (and well)
	 * Hide the picker and save the colour choice in the previously selected colour grid
	 * @param {event} event
	 */ closeColorPicker(event) {
        if (!(this.container.contains(event.target) || this.container.well.contains(event.target))) {
            this.container.style.display = 'none';
            document.removeEventListener('click', this.onclose, true);
            let color = this.container.well.style.backgroundColor;
            // save the chosen color for future selection if it is not already there
            this.saveColor(color);
            let callback = this.container.callback;
            if (callback) callback(color);
            this.colorPicker.off('color:change');
        }
    }
    /**
	 * Save the color in the previously selected colour grid, if not already saved
	 * into a free slot, or if there isn't one shift the current colours to the left
	 * and save the new at the right end
	 * @param {string} color
	 */ saveColor(color) {
        let saveds = this.colorCache.children;
        for(let i = 0; i < 8; i++){
            if (saveds[i].style.backgroundColor == color) return;
        }
        for(let i = 0; i < 8; i++)if (saveds[i].style.backgroundColor == '') {
            saveds[i].style.backgroundColor = color;
            return;
        }
        for(let i = 0, j = 1; j < 8; i++, j++)saveds[i].style.backgroundColor = saveds[j].style.backgroundColor;
        saveds[7].style.backgroundColor = color;
    }
}
function $c23d83b256c12a3b$export$b3902f047e75d149(utc, full = false) {
    let time = new Date();
    time.setTime(utc);
    if (!full && time.toDateString() == new Date().toDateString()) // return Today, 12:34
    return 'Today, ' + time.toLocaleString('en-GB', {
        hour: '2-digit',
        minute: '2-digit'
    });
    if (!full && time.getFullYear() == new Date().getFullYear()) // return 12 Sept, 12:34
    return time.toLocaleString('en-GB', {
        day: '2-digit',
        month: 'short',
        hour: '2-digit',
        minute: '2-digit'
    });
    // return 12 Sep 2023, 12:34
    return time.toLocaleString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    }).replace('Sept', 'Sep');
}
function $c23d83b256c12a3b$export$8bc063faa2ba2bd3(contentEditableElement) {
    let range = document.createRange() //Create a range (a range is a like the selection but invisible)
    ;
    range.selectNodeContents(contentEditableElement) //Select the entire contents of the element with the range
    ;
    range.collapse(false) //collapse the range to the end point. false means collapse to end rather than the start
    ;
    let selection = window.getSelection() //get the selection object (allows you to change selection)
    ;
    selection.removeAllRanges() //remove any selections already made
    ;
    selection.addRange(range) //make the range you have just created the visible selection
    ;
}
function $c23d83b256c12a3b$export$cdee113d0db2579a(time) {
    let d = time ? new Date(time) : new Date();
    return `${d.toLocaleTimeString()}:${d.getMilliseconds()} `;
}
function $c23d83b256c12a3b$export$d07f57595c356899(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function $c23d83b256c12a3b$export$81b06ab76a3757ce(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
}
function $c23d83b256c12a3b$export$89dc6f1d08c41ada(bytes, si = true) {
    let u, b = bytes, t = si ? 1000 : 1024;
    [
        '',
        si ? 'k' : 'K',
        ...'MGTPEZY'
    ].find((x)=>(u = x, b /= t, b ** 2 < 1));
    return `${u ? (t * b).toFixed(1) : bytes}${u}${!si && u ? 'i' : ''}B`;
}
function $c23d83b256c12a3b$export$99f0341e4542bf23(quill) {
    if ((quill.getContents()['ops'] || []).length !== 1) return false;
    return quill.getText().trim().length === 0;
}
function $c23d83b256c12a3b$export$e6b553c28e5248fd(str) {
    return str.replace(/\r?\n|\r/g, ' ');
}
function $c23d83b256c12a3b$export$9f711266042c4a52() {
    window.open($c23d83b256c12a3b$var$MANUALURL, 'helpWindow');
}

});
parcelRegister("hV9VG", function(module, exports) {

$parcel$export(module.exports, "DIRECTION_ALL", () => $d0bf7654e2e5fac0$export$b992f700de4c54f);
$parcel$export(module.exports, "Pan", () => $d0bf7654e2e5fac0$export$f86166cd6057c2d1);
$parcel$export(module.exports, "Manager", () => $d0bf7654e2e5fac0$export$d0d38e7dec7a1a61);
$parcel$export(module.exports, "default", () => $d0bf7654e2e5fac0$export$2e2bcd8739ae039);
/*! Hammer.JS - v2.0.17-rc - 2019-12-16
 * http://naver.github.io/egjs
 *
 * Forked By Naver egjs
 * Copyright (c) hammerjs
 * Licensed under the MIT license */ function $d0bf7654e2e5fac0$var$_extends() {
    $d0bf7654e2e5fac0$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d0bf7654e2e5fac0$var$_extends.apply(this, arguments);
}
function $d0bf7654e2e5fac0$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $d0bf7654e2e5fac0$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
/**
 * @private
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */ var $d0bf7654e2e5fac0$var$assign;
if (typeof Object.assign !== 'function') $d0bf7654e2e5fac0$var$assign = function assign(target) {
    if (target === undefined || target === null) throw new TypeError('Cannot convert undefined or null to object');
    var output = Object(target);
    for(var index = 1; index < arguments.length; index++){
        var source = arguments[index];
        if (source !== undefined && source !== null) {
            for(var nextKey in source)if (source.hasOwnProperty(nextKey)) output[nextKey] = source[nextKey];
        }
    }
    return output;
};
else $d0bf7654e2e5fac0$var$assign = Object.assign;
var $d0bf7654e2e5fac0$export$e6e34fd1f2686227 = $d0bf7654e2e5fac0$var$assign;
var $d0bf7654e2e5fac0$var$VENDOR_PREFIXES = [
    '',
    'webkit',
    'Moz',
    'MS',
    'ms',
    'o'
];
var $d0bf7654e2e5fac0$var$TEST_ELEMENT = typeof document === "undefined" ? {
    style: {}
} : document.createElement('div');
var $d0bf7654e2e5fac0$var$TYPE_FUNCTION = 'function';
var $d0bf7654e2e5fac0$var$round = Math.round, $d0bf7654e2e5fac0$var$abs = Math.abs;
var $d0bf7654e2e5fac0$var$now = Date.now;
/**
 * @private
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */ function $d0bf7654e2e5fac0$export$302158222cd49bab(obj, property) {
    var prefix;
    var prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);
    var i = 0;
    while(i < $d0bf7654e2e5fac0$var$VENDOR_PREFIXES.length){
        prefix = $d0bf7654e2e5fac0$var$VENDOR_PREFIXES[i];
        prop = prefix ? prefix + camelProp : property;
        if (prop in obj) return prop;
        i++;
    }
    return undefined;
}
/* eslint-disable no-new-func, no-nested-ternary */ var $d0bf7654e2e5fac0$var$win;
if (typeof window === "undefined") // window is undefined in node.js
$d0bf7654e2e5fac0$var$win = {};
else $d0bf7654e2e5fac0$var$win = window;
var $d0bf7654e2e5fac0$var$PREFIXED_TOUCH_ACTION = $d0bf7654e2e5fac0$export$302158222cd49bab($d0bf7654e2e5fac0$var$TEST_ELEMENT.style, 'touchAction');
var $d0bf7654e2e5fac0$var$NATIVE_TOUCH_ACTION = $d0bf7654e2e5fac0$var$PREFIXED_TOUCH_ACTION !== undefined;
function $d0bf7654e2e5fac0$var$getTouchActionProps() {
    if (!$d0bf7654e2e5fac0$var$NATIVE_TOUCH_ACTION) return false;
    var touchMap = {};
    var cssSupports = $d0bf7654e2e5fac0$var$win.CSS && $d0bf7654e2e5fac0$var$win.CSS.supports;
    [
        'auto',
        'manipulation',
        'pan-y',
        'pan-x',
        'pan-x pan-y',
        'none'
    ].forEach(function(val) {
        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        return touchMap[val] = cssSupports ? $d0bf7654e2e5fac0$var$win.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}
var $d0bf7654e2e5fac0$var$TOUCH_ACTION_COMPUTE = 'compute';
var $d0bf7654e2e5fac0$var$TOUCH_ACTION_AUTO = 'auto';
var $d0bf7654e2e5fac0$var$TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var $d0bf7654e2e5fac0$var$TOUCH_ACTION_NONE = 'none';
var $d0bf7654e2e5fac0$var$TOUCH_ACTION_PAN_X = 'pan-x';
var $d0bf7654e2e5fac0$var$TOUCH_ACTION_PAN_Y = 'pan-y';
var $d0bf7654e2e5fac0$var$TOUCH_ACTION_MAP = $d0bf7654e2e5fac0$var$getTouchActionProps();
var $d0bf7654e2e5fac0$var$MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
var $d0bf7654e2e5fac0$var$SUPPORT_TOUCH = 'ontouchstart' in $d0bf7654e2e5fac0$var$win;
var $d0bf7654e2e5fac0$var$SUPPORT_POINTER_EVENTS = $d0bf7654e2e5fac0$export$302158222cd49bab($d0bf7654e2e5fac0$var$win, 'PointerEvent') !== undefined;
var $d0bf7654e2e5fac0$var$SUPPORT_ONLY_TOUCH = $d0bf7654e2e5fac0$var$SUPPORT_TOUCH && $d0bf7654e2e5fac0$var$MOBILE_REGEX.test(navigator.userAgent);
var $d0bf7654e2e5fac0$var$INPUT_TYPE_TOUCH = 'touch';
var $d0bf7654e2e5fac0$var$INPUT_TYPE_PEN = 'pen';
var $d0bf7654e2e5fac0$var$INPUT_TYPE_MOUSE = 'mouse';
var $d0bf7654e2e5fac0$var$INPUT_TYPE_KINECT = 'kinect';
var $d0bf7654e2e5fac0$var$COMPUTE_INTERVAL = 25;
var $d0bf7654e2e5fac0$export$a343f8e8a934fd59 = 1;
var $d0bf7654e2e5fac0$export$6235f66f7766ee8c = 2;
var $d0bf7654e2e5fac0$export$26a469bc3fde64f7 = 4;
var $d0bf7654e2e5fac0$export$a6cb74acba980f94 = 8;
var $d0bf7654e2e5fac0$export$d423ecd2ef2f65e7 = 1;
var $d0bf7654e2e5fac0$export$4f1506fa80c37e6f = 2;
var $d0bf7654e2e5fac0$export$a34043b88230a335 = 4;
var $d0bf7654e2e5fac0$export$b5ad9376033e98b2 = 8;
var $d0bf7654e2e5fac0$export$28a694fb106a7f62 = 16;
var $d0bf7654e2e5fac0$export$50a4ff95cf34d3b8 = $d0bf7654e2e5fac0$export$4f1506fa80c37e6f | $d0bf7654e2e5fac0$export$a34043b88230a335;
var $d0bf7654e2e5fac0$export$9727db57753c1f4 = $d0bf7654e2e5fac0$export$b5ad9376033e98b2 | $d0bf7654e2e5fac0$export$28a694fb106a7f62;
var $d0bf7654e2e5fac0$export$b992f700de4c54f = $d0bf7654e2e5fac0$export$50a4ff95cf34d3b8 | $d0bf7654e2e5fac0$export$9727db57753c1f4;
var $d0bf7654e2e5fac0$var$PROPS_XY = [
    'x',
    'y'
];
var $d0bf7654e2e5fac0$var$PROPS_CLIENT_XY = [
    'clientX',
    'clientY'
];
/**
 * @private
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */ function $d0bf7654e2e5fac0$export$79b2f7037acddd43(obj, iterator, context) {
    var i;
    if (!obj) return;
    if (obj.forEach) obj.forEach(iterator, context);
    else if (obj.length !== undefined) {
        i = 0;
        while(i < obj.length){
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else for(i in obj)obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
}
/**
 * @private
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */ function $d0bf7654e2e5fac0$export$4d5490c74eb6bfd5(val, args) {
    if (typeof val === $d0bf7654e2e5fac0$var$TYPE_FUNCTION) return val.apply(args ? args[0] || undefined : undefined, args);
    return val;
}
/**
 * @private
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */ function $d0bf7654e2e5fac0$var$inStr(str, find) {
    return str.indexOf(find) > -1;
}
/**
 * @private
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */ function $d0bf7654e2e5fac0$var$cleanTouchActions(actions) {
    // none
    if ($d0bf7654e2e5fac0$var$inStr(actions, $d0bf7654e2e5fac0$var$TOUCH_ACTION_NONE)) return $d0bf7654e2e5fac0$var$TOUCH_ACTION_NONE;
    var hasPanX = $d0bf7654e2e5fac0$var$inStr(actions, $d0bf7654e2e5fac0$var$TOUCH_ACTION_PAN_X);
    var hasPanY = $d0bf7654e2e5fac0$var$inStr(actions, $d0bf7654e2e5fac0$var$TOUCH_ACTION_PAN_Y); // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) return $d0bf7654e2e5fac0$var$TOUCH_ACTION_NONE;
     // pan-x OR pan-y
    if (hasPanX || hasPanY) return hasPanX ? $d0bf7654e2e5fac0$var$TOUCH_ACTION_PAN_X : $d0bf7654e2e5fac0$var$TOUCH_ACTION_PAN_Y;
     // manipulation
    if ($d0bf7654e2e5fac0$var$inStr(actions, $d0bf7654e2e5fac0$var$TOUCH_ACTION_MANIPULATION)) return $d0bf7654e2e5fac0$var$TOUCH_ACTION_MANIPULATION;
    return $d0bf7654e2e5fac0$var$TOUCH_ACTION_AUTO;
}
/**
 * @private
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */ var $d0bf7654e2e5fac0$export$e9e4ceed4aa397af = /*#__PURE__*/ function() {
    function TouchAction(manager, value) {
        this.manager = manager;
        this.set(value);
    }
    /**
   * @private
   * set the touchAction value on the element or enable the polyfill
   * @param {String} value
   */ var _proto = TouchAction.prototype;
    _proto.set = function set(value) {
        // find out the touch-action by the event handlers
        if (value === $d0bf7654e2e5fac0$var$TOUCH_ACTION_COMPUTE) value = this.compute();
        if ($d0bf7654e2e5fac0$var$NATIVE_TOUCH_ACTION && this.manager.element.style && $d0bf7654e2e5fac0$var$TOUCH_ACTION_MAP[value]) this.manager.element.style[$d0bf7654e2e5fac0$var$PREFIXED_TOUCH_ACTION] = value;
        this.actions = value.toLowerCase().trim();
    };
    /**
   * @private
   * just re-set the touchAction value
   */ _proto.update = function update() {
        this.set(this.manager.options.touchAction);
    };
    /**
   * @private
   * compute the value for the touchAction property based on the recognizer's settings
   * @returns {String} value
   */ _proto.compute = function compute() {
        var actions = [];
        $d0bf7654e2e5fac0$export$79b2f7037acddd43(this.manager.recognizers, function(recognizer) {
            if ($d0bf7654e2e5fac0$export$4d5490c74eb6bfd5(recognizer.options.enable, [
                recognizer
            ])) actions = actions.concat(recognizer.getTouchAction());
        });
        return $d0bf7654e2e5fac0$var$cleanTouchActions(actions.join(' '));
    };
    /**
   * @private
   * this method is called on each input cycle and provides the preventing of the browser behavior
   * @param {Object} input
   */ _proto.preventDefaults = function preventDefaults(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection; // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }
        var actions = this.actions;
        var hasNone = $d0bf7654e2e5fac0$var$inStr(actions, $d0bf7654e2e5fac0$var$TOUCH_ACTION_NONE) && !$d0bf7654e2e5fac0$var$TOUCH_ACTION_MAP[$d0bf7654e2e5fac0$var$TOUCH_ACTION_NONE];
        var hasPanY = $d0bf7654e2e5fac0$var$inStr(actions, $d0bf7654e2e5fac0$var$TOUCH_ACTION_PAN_Y) && !$d0bf7654e2e5fac0$var$TOUCH_ACTION_MAP[$d0bf7654e2e5fac0$var$TOUCH_ACTION_PAN_Y];
        var hasPanX = $d0bf7654e2e5fac0$var$inStr(actions, $d0bf7654e2e5fac0$var$TOUCH_ACTION_PAN_X) && !$d0bf7654e2e5fac0$var$TOUCH_ACTION_MAP[$d0bf7654e2e5fac0$var$TOUCH_ACTION_PAN_X];
        if (hasNone) {
            // do not prevent defaults if this is a tap gesture
            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;
            if (isTapPointer && isTapMovement && isTapTouchTime) return;
        }
        if (hasPanX && hasPanY) // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
        return;
        if (hasNone || hasPanY && direction & $d0bf7654e2e5fac0$export$50a4ff95cf34d3b8 || hasPanX && direction & $d0bf7654e2e5fac0$export$9727db57753c1f4) return this.preventSrc(srcEvent);
    };
    /**
   * @private
   * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
   * @param {Object} srcEvent
   */ _proto.preventSrc = function preventSrc(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    };
    return TouchAction;
}();
/**
 * @private
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */ function $d0bf7654e2e5fac0$export$8dd5c737a2b3c45d(node, parent) {
    while(node){
        if (node === parent) return true;
        node = node.parentNode;
    }
    return false;
}
/**
 * @private
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */ function $d0bf7654e2e5fac0$var$getCenter(pointers) {
    var pointersLength = pointers.length; // no need to loop when only one touch
    if (pointersLength === 1) return {
        x: $d0bf7654e2e5fac0$var$round(pointers[0].clientX),
        y: $d0bf7654e2e5fac0$var$round(pointers[0].clientY)
    };
    var x = 0;
    var y = 0;
    var i = 0;
    while(i < pointersLength){
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }
    return {
        x: $d0bf7654e2e5fac0$var$round(x / pointersLength),
        y: $d0bf7654e2e5fac0$var$round(y / pointersLength)
    };
}
/**
 * @private
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */ function $d0bf7654e2e5fac0$var$simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while(i < input.pointers.length){
        pointers[i] = {
            clientX: $d0bf7654e2e5fac0$var$round(input.pointers[i].clientX),
            clientY: $d0bf7654e2e5fac0$var$round(input.pointers[i].clientY)
        };
        i++;
    }
    return {
        timeStamp: $d0bf7654e2e5fac0$var$now(),
        pointers: pointers,
        center: $d0bf7654e2e5fac0$var$getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}
/**
 * @private
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */ function $d0bf7654e2e5fac0$var$getDistance(p1, p2, props) {
    if (!props) props = $d0bf7654e2e5fac0$var$PROPS_XY;
    var x = p2[props[0]] - p1[props[0]];
    var y = p2[props[1]] - p1[props[1]];
    return Math.sqrt(x * x + y * y);
}
/**
 * @private
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */ function $d0bf7654e2e5fac0$var$getAngle(p1, p2, props) {
    if (!props) props = $d0bf7654e2e5fac0$var$PROPS_XY;
    var x = p2[props[0]] - p1[props[0]];
    var y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}
/**
 * @private
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */ function $d0bf7654e2e5fac0$var$getDirection(x, y) {
    if (x === y) return $d0bf7654e2e5fac0$export$d423ecd2ef2f65e7;
    if ($d0bf7654e2e5fac0$var$abs(x) >= $d0bf7654e2e5fac0$var$abs(y)) return x < 0 ? $d0bf7654e2e5fac0$export$4f1506fa80c37e6f : $d0bf7654e2e5fac0$export$a34043b88230a335;
    return y < 0 ? $d0bf7654e2e5fac0$export$b5ad9376033e98b2 : $d0bf7654e2e5fac0$export$28a694fb106a7f62;
}
function $d0bf7654e2e5fac0$var$computeDeltaXY(session, input) {
    var center = input.center; // let { offsetDelta:offset = {}, prevDelta = {}, prevInput = {} } = session;
    // jscs throwing error on defalut destructured values and without defaults tests fail
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};
    if (input.eventType === $d0bf7654e2e5fac0$export$a343f8e8a934fd59 || prevInput.eventType === $d0bf7654e2e5fac0$export$26a469bc3fde64f7) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };
        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }
    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}
/**
 * @private
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */ function $d0bf7654e2e5fac0$var$getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}
/**
 * @private
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */ function $d0bf7654e2e5fac0$var$getScale(start, end) {
    return $d0bf7654e2e5fac0$var$getDistance(end[0], end[1], $d0bf7654e2e5fac0$var$PROPS_CLIENT_XY) / $d0bf7654e2e5fac0$var$getDistance(start[0], start[1], $d0bf7654e2e5fac0$var$PROPS_CLIENT_XY);
}
/**
 * @private
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */ function $d0bf7654e2e5fac0$var$getRotation(start, end) {
    return $d0bf7654e2e5fac0$var$getAngle(end[1], end[0], $d0bf7654e2e5fac0$var$PROPS_CLIENT_XY) + $d0bf7654e2e5fac0$var$getAngle(start[1], start[0], $d0bf7654e2e5fac0$var$PROPS_CLIENT_XY);
}
/**
 * @private
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */ function $d0bf7654e2e5fac0$var$computeIntervalInputData(session, input) {
    var last = session.lastInterval || input;
    var deltaTime = input.timeStamp - last.timeStamp;
    var velocity;
    var velocityX;
    var velocityY;
    var direction;
    if (input.eventType !== $d0bf7654e2e5fac0$export$a6cb74acba980f94 && (deltaTime > $d0bf7654e2e5fac0$var$COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;
        var v = $d0bf7654e2e5fac0$var$getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = $d0bf7654e2e5fac0$var$abs(v.x) > $d0bf7654e2e5fac0$var$abs(v.y) ? v.x : v.y;
        direction = $d0bf7654e2e5fac0$var$getDirection(deltaX, deltaY);
        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }
    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}
/**
* @private
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */ function $d0bf7654e2e5fac0$var$computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length; // store the first input to calculate the distance and direction
    if (!session.firstInput) session.firstInput = $d0bf7654e2e5fac0$var$simpleCloneInputData(input);
     // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) session.firstMultiple = $d0bf7654e2e5fac0$var$simpleCloneInputData(input);
    else if (pointersLength === 1) session.firstMultiple = false;
    var firstInput = session.firstInput, firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
    var center = input.center = $d0bf7654e2e5fac0$var$getCenter(pointers);
    input.timeStamp = $d0bf7654e2e5fac0$var$now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;
    input.angle = $d0bf7654e2e5fac0$var$getAngle(offsetCenter, center);
    input.distance = $d0bf7654e2e5fac0$var$getDistance(offsetCenter, center);
    $d0bf7654e2e5fac0$var$computeDeltaXY(session, input);
    input.offsetDirection = $d0bf7654e2e5fac0$var$getDirection(input.deltaX, input.deltaY);
    var overallVelocity = $d0bf7654e2e5fac0$var$getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = $d0bf7654e2e5fac0$var$abs(overallVelocity.x) > $d0bf7654e2e5fac0$var$abs(overallVelocity.y) ? overallVelocity.x : overallVelocity.y;
    input.scale = firstMultiple ? $d0bf7654e2e5fac0$var$getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? $d0bf7654e2e5fac0$var$getRotation(firstMultiple.pointers, pointers) : 0;
    input.maxPointers = !session.prevInput ? input.pointers.length : input.pointers.length > session.prevInput.maxPointers ? input.pointers.length : session.prevInput.maxPointers;
    $d0bf7654e2e5fac0$var$computeIntervalInputData(session, input); // find the correct target
    var target = manager.element;
    var srcEvent = input.srcEvent;
    var srcEventTarget;
    if (srcEvent.composedPath) srcEventTarget = srcEvent.composedPath()[0];
    else if (srcEvent.path) srcEventTarget = srcEvent.path[0];
    else srcEventTarget = srcEvent.target;
    if ($d0bf7654e2e5fac0$export$8dd5c737a2b3c45d(srcEventTarget, target)) target = srcEventTarget;
    input.target = target;
}
/**
 * @private
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */ function $d0bf7654e2e5fac0$var$inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = eventType & $d0bf7654e2e5fac0$export$a343f8e8a934fd59 && pointersLen - changedPointersLen === 0;
    var isFinal = eventType & ($d0bf7654e2e5fac0$export$26a469bc3fde64f7 | $d0bf7654e2e5fac0$export$a6cb74acba980f94) && pointersLen - changedPointersLen === 0;
    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;
    if (isFirst) manager.session = {};
     // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType; // compute scale, rotation etc
    $d0bf7654e2e5fac0$var$computeInputData(manager, input); // emit secret event
    manager.emit('hammer.input', input);
    manager.recognize(input);
    manager.session.prevInput = input;
}
/**
 * @private
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */ function $d0bf7654e2e5fac0$export$a4a1898ed2c527c4(str) {
    return str.trim().split(/\s+/g);
}
/**
 * @private
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */ function $d0bf7654e2e5fac0$export$af631764ddc44097(target, types, handler) {
    $d0bf7654e2e5fac0$export$79b2f7037acddd43($d0bf7654e2e5fac0$export$a4a1898ed2c527c4(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}
/**
 * @private
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */ function $d0bf7654e2e5fac0$export$8c8705df4a2dcec9(target, types, handler) {
    $d0bf7654e2e5fac0$export$79b2f7037acddd43($d0bf7654e2e5fac0$export$a4a1898ed2c527c4(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}
/**
 * @private
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */ function $d0bf7654e2e5fac0$var$getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return doc.defaultView || doc.parentWindow || window;
}
/**
 * @private
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */ var $d0bf7654e2e5fac0$export$f5b8910cec6cf069 = /*#__PURE__*/ function() {
    function Input(manager, callback) {
        var self = this;
        this.manager = manager;
        this.callback = callback;
        this.element = manager.element;
        this.target = manager.options.inputTarget; // smaller wrapper around the handler, for the scope and the enabled state of the manager,
        // so when disabled the input events are completely bypassed.
        this.domHandler = function(ev) {
            if ($d0bf7654e2e5fac0$export$4d5490c74eb6bfd5(manager.options.enable, [
                manager
            ])) self.handler(ev);
        };
        this.init();
    }
    /**
   * @private
   * should handle the inputEvent data and trigger the callback
   * @virtual
   */ var _proto = Input.prototype;
    _proto.handler = function handler() {};
    /**
   * @private
   * bind the events
   */ _proto.init = function init() {
        this.evEl && $d0bf7654e2e5fac0$export$af631764ddc44097(this.element, this.evEl, this.domHandler);
        this.evTarget && $d0bf7654e2e5fac0$export$af631764ddc44097(this.target, this.evTarget, this.domHandler);
        this.evWin && $d0bf7654e2e5fac0$export$af631764ddc44097($d0bf7654e2e5fac0$var$getWindowForElement(this.element), this.evWin, this.domHandler);
    };
    /**
   * @private
   * unbind the events
   */ _proto.destroy = function destroy() {
        this.evEl && $d0bf7654e2e5fac0$export$8c8705df4a2dcec9(this.element, this.evEl, this.domHandler);
        this.evTarget && $d0bf7654e2e5fac0$export$8c8705df4a2dcec9(this.target, this.evTarget, this.domHandler);
        this.evWin && $d0bf7654e2e5fac0$export$8c8705df4a2dcec9($d0bf7654e2e5fac0$var$getWindowForElement(this.element), this.evWin, this.domHandler);
    };
    return Input;
}();
/**
 * @private
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */ function $d0bf7654e2e5fac0$export$6632823c2c02cb2c(src, find, findByKey) {
    if (src.indexOf && !findByKey) return src.indexOf(find);
    else {
        var i = 0;
        while(i < src.length){
            if (findByKey && src[i][findByKey] == find || !findByKey && src[i] === find) // do not use === here, test fails
            return i;
            i++;
        }
        return -1;
    }
}
var $d0bf7654e2e5fac0$var$POINTER_INPUT_MAP = {
    pointerdown: $d0bf7654e2e5fac0$export$a343f8e8a934fd59,
    pointermove: $d0bf7654e2e5fac0$export$6235f66f7766ee8c,
    pointerup: $d0bf7654e2e5fac0$export$26a469bc3fde64f7,
    pointercancel: $d0bf7654e2e5fac0$export$a6cb74acba980f94,
    pointerout: $d0bf7654e2e5fac0$export$a6cb74acba980f94
}; // in IE10 the pointer types is defined as an enum
var $d0bf7654e2e5fac0$var$IE10_POINTER_TYPE_ENUM = {
    2: $d0bf7654e2e5fac0$var$INPUT_TYPE_TOUCH,
    3: $d0bf7654e2e5fac0$var$INPUT_TYPE_PEN,
    4: $d0bf7654e2e5fac0$var$INPUT_TYPE_MOUSE,
    5: $d0bf7654e2e5fac0$var$INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};
var $d0bf7654e2e5fac0$var$POINTER_ELEMENT_EVENTS = 'pointerdown';
var $d0bf7654e2e5fac0$var$POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel'; // IE10 has prefixed support, and case-sensitive
if ($d0bf7654e2e5fac0$var$win.MSPointerEvent && !$d0bf7654e2e5fac0$var$win.PointerEvent) {
    $d0bf7654e2e5fac0$var$POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    $d0bf7654e2e5fac0$var$POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}
/**
 * @private
 * Pointer events input
 * @constructor
 * @extends Input
 */ var $d0bf7654e2e5fac0$export$d5ae9b841773907 = /*#__PURE__*/ function(_Input) {
    $d0bf7654e2e5fac0$var$_inheritsLoose(PointerEventInput, _Input);
    function PointerEventInput() {
        var _this;
        var proto = PointerEventInput.prototype;
        proto.evEl = $d0bf7654e2e5fac0$var$POINTER_ELEMENT_EVENTS;
        proto.evWin = $d0bf7654e2e5fac0$var$POINTER_WINDOW_EVENTS;
        _this = _Input.apply(this, arguments) || this;
        _this.store = _this.manager.session.pointerEvents = [];
        return _this;
    }
    /**
   * @private
   * handle mouse events
   * @param {Object} ev
   */ var _proto = PointerEventInput.prototype;
    _proto.handler = function handler(ev) {
        var store = this.store;
        var removePointer = false;
        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = $d0bf7654e2e5fac0$var$POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = $d0bf7654e2e5fac0$var$IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
        var isTouch = pointerType === $d0bf7654e2e5fac0$var$INPUT_TYPE_TOUCH; // get index of the event in the store
        var storeIndex = $d0bf7654e2e5fac0$export$6632823c2c02cb2c(store, ev.pointerId, 'pointerId'); // start and mouse must be down
        if (eventType & $d0bf7654e2e5fac0$export$a343f8e8a934fd59 && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & ($d0bf7654e2e5fac0$export$26a469bc3fde64f7 | $d0bf7654e2e5fac0$export$a6cb74acba980f94)) removePointer = true;
         // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) return;
         // update the event in the store
        store[storeIndex] = ev;
        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [
                ev
            ],
            pointerType: pointerType,
            srcEvent: ev
        });
        if (removePointer) // remove from the store
        store.splice(storeIndex, 1);
    };
    return PointerEventInput;
}($d0bf7654e2e5fac0$export$f5b8910cec6cf069);
/**
 * @private
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */ function $d0bf7654e2e5fac0$export$45b10814cc054894(obj) {
    return Array.prototype.slice.call(obj, 0);
}
/**
 * @private
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */ function $d0bf7654e2e5fac0$export$bbd17ecb0679edd7(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;
    while(i < src.length){
        var val = key ? src[i][key] : src[i];
        if ($d0bf7654e2e5fac0$export$6632823c2c02cb2c(values, val) < 0) results.push(src[i]);
        values[i] = val;
        i++;
    }
    if (sort) {
        if (!key) results = results.sort();
        else results = results.sort(function(a, b) {
            return a[key] > b[key];
        });
    }
    return results;
}
var $d0bf7654e2e5fac0$var$TOUCH_INPUT_MAP = {
    touchstart: $d0bf7654e2e5fac0$export$a343f8e8a934fd59,
    touchmove: $d0bf7654e2e5fac0$export$6235f66f7766ee8c,
    touchend: $d0bf7654e2e5fac0$export$26a469bc3fde64f7,
    touchcancel: $d0bf7654e2e5fac0$export$a6cb74acba980f94
};
var $d0bf7654e2e5fac0$var$TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';
/**
 * @private
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */ var $d0bf7654e2e5fac0$export$8210fab11c86ffb5 = /*#__PURE__*/ function(_Input) {
    $d0bf7654e2e5fac0$var$_inheritsLoose(TouchInput, _Input);
    function TouchInput() {
        var _this;
        TouchInput.prototype.evTarget = $d0bf7654e2e5fac0$var$TOUCH_TARGET_EVENTS;
        _this = _Input.apply(this, arguments) || this;
        _this.targetIds = {}; // this.evTarget = TOUCH_TARGET_EVENTS;
        return _this;
    }
    var _proto = TouchInput.prototype;
    _proto.handler = function handler(ev) {
        var type = $d0bf7654e2e5fac0$var$TOUCH_INPUT_MAP[ev.type];
        var touches = $d0bf7654e2e5fac0$var$getTouches.call(this, ev, type);
        if (!touches) return;
        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: $d0bf7654e2e5fac0$var$INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    };
    return TouchInput;
}($d0bf7654e2e5fac0$export$f5b8910cec6cf069);
function $d0bf7654e2e5fac0$var$getTouches(ev, type) {
    var allTouches = $d0bf7654e2e5fac0$export$45b10814cc054894(ev.touches);
    var targetIds = this.targetIds; // when there is only one touch, the process can be simplified
    if (type & ($d0bf7654e2e5fac0$export$a343f8e8a934fd59 | $d0bf7654e2e5fac0$export$6235f66f7766ee8c) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [
            allTouches,
            allTouches
        ];
    }
    var i;
    var targetTouches;
    var changedTouches = $d0bf7654e2e5fac0$export$45b10814cc054894(ev.changedTouches);
    var changedTargetTouches = [];
    var target = this.target; // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return $d0bf7654e2e5fac0$export$8dd5c737a2b3c45d(touch.target, target);
    }); // collect touches
    if (type === $d0bf7654e2e5fac0$export$a343f8e8a934fd59) {
        i = 0;
        while(i < targetTouches.length){
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    } // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while(i < changedTouches.length){
        if (targetIds[changedTouches[i].identifier]) changedTargetTouches.push(changedTouches[i]);
         // cleanup removed touches
        if (type & ($d0bf7654e2e5fac0$export$26a469bc3fde64f7 | $d0bf7654e2e5fac0$export$a6cb74acba980f94)) delete targetIds[changedTouches[i].identifier];
        i++;
    }
    if (!changedTargetTouches.length) return;
    return [
        $d0bf7654e2e5fac0$export$bbd17ecb0679edd7(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}
var $d0bf7654e2e5fac0$var$MOUSE_INPUT_MAP = {
    mousedown: $d0bf7654e2e5fac0$export$a343f8e8a934fd59,
    mousemove: $d0bf7654e2e5fac0$export$6235f66f7766ee8c,
    mouseup: $d0bf7654e2e5fac0$export$26a469bc3fde64f7
};
var $d0bf7654e2e5fac0$var$MOUSE_ELEMENT_EVENTS = 'mousedown';
var $d0bf7654e2e5fac0$var$MOUSE_WINDOW_EVENTS = 'mousemove mouseup';
/**
 * @private
 * Mouse events input
 * @constructor
 * @extends Input
 */ var $d0bf7654e2e5fac0$export$a491aeaf0289a5d3 = /*#__PURE__*/ function(_Input) {
    $d0bf7654e2e5fac0$var$_inheritsLoose(MouseInput, _Input);
    function MouseInput() {
        var _this;
        var proto = MouseInput.prototype;
        proto.evEl = $d0bf7654e2e5fac0$var$MOUSE_ELEMENT_EVENTS;
        proto.evWin = $d0bf7654e2e5fac0$var$MOUSE_WINDOW_EVENTS;
        _this = _Input.apply(this, arguments) || this;
        _this.pressed = false; // mousedown state
        return _this;
    }
    /**
   * @private
   * handle mouse events
   * @param {Object} ev
   */ var _proto = MouseInput.prototype;
    _proto.handler = function handler(ev) {
        var eventType = $d0bf7654e2e5fac0$var$MOUSE_INPUT_MAP[ev.type]; // on start we want to have the left mouse button down
        if (eventType & $d0bf7654e2e5fac0$export$a343f8e8a934fd59 && ev.button === 0) this.pressed = true;
        if (eventType & $d0bf7654e2e5fac0$export$6235f66f7766ee8c && ev.which !== 1) eventType = $d0bf7654e2e5fac0$export$26a469bc3fde64f7;
         // mouse must be down
        if (!this.pressed) return;
        if (eventType & $d0bf7654e2e5fac0$export$26a469bc3fde64f7) this.pressed = false;
        this.callback(this.manager, eventType, {
            pointers: [
                ev
            ],
            changedPointers: [
                ev
            ],
            pointerType: $d0bf7654e2e5fac0$var$INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    };
    return MouseInput;
}($d0bf7654e2e5fac0$export$f5b8910cec6cf069);
/**
 * @private
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */ var $d0bf7654e2e5fac0$var$DEDUP_TIMEOUT = 2500;
var $d0bf7654e2e5fac0$var$DEDUP_DISTANCE = 25;
function $d0bf7654e2e5fac0$var$setLastTouch(eventData) {
    var _eventData$changedPoi = eventData.changedPointers, touch = _eventData$changedPoi[0];
    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {
            x: touch.clientX,
            y: touch.clientY
        };
        var lts = this.lastTouches;
        this.lastTouches.push(lastTouch);
        var removeLastTouch = function removeLastTouch() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) lts.splice(i, 1);
        };
        setTimeout(removeLastTouch, $d0bf7654e2e5fac0$var$DEDUP_TIMEOUT);
    }
}
function $d0bf7654e2e5fac0$var$recordTouches(eventType, eventData) {
    if (eventType & $d0bf7654e2e5fac0$export$a343f8e8a934fd59) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        $d0bf7654e2e5fac0$var$setLastTouch.call(this, eventData);
    } else if (eventType & ($d0bf7654e2e5fac0$export$26a469bc3fde64f7 | $d0bf7654e2e5fac0$export$a6cb74acba980f94)) $d0bf7654e2e5fac0$var$setLastTouch.call(this, eventData);
}
function $d0bf7654e2e5fac0$var$isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX;
    var y = eventData.srcEvent.clientY;
    for(var i = 0; i < this.lastTouches.length; i++){
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x);
        var dy = Math.abs(y - t.y);
        if (dx <= $d0bf7654e2e5fac0$var$DEDUP_DISTANCE && dy <= $d0bf7654e2e5fac0$var$DEDUP_DISTANCE) return true;
    }
    return false;
}
var $d0bf7654e2e5fac0$export$560ade0f6763a0bb = /*#__PURE__*/ function() {
    var TouchMouseInput = /*#__PURE__*/ function(_Input) {
        $d0bf7654e2e5fac0$var$_inheritsLoose(TouchMouseInput, _Input);
        function TouchMouseInput(_manager, callback) {
            var _this;
            _this = _Input.call(this, _manager, callback) || this;
            _this.handler = function(manager, inputEvent, inputData) {
                var isTouch = inputData.pointerType === $d0bf7654e2e5fac0$var$INPUT_TYPE_TOUCH;
                var isMouse = inputData.pointerType === $d0bf7654e2e5fac0$var$INPUT_TYPE_MOUSE;
                if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) return;
                 // when we're in a touch event, record touches to  de-dupe synthetic mouse event
                if (isTouch) $d0bf7654e2e5fac0$var$recordTouches.call($d0bf7654e2e5fac0$var$_assertThisInitialized($d0bf7654e2e5fac0$var$_assertThisInitialized(_this)), inputEvent, inputData);
                else if (isMouse && $d0bf7654e2e5fac0$var$isSyntheticEvent.call($d0bf7654e2e5fac0$var$_assertThisInitialized($d0bf7654e2e5fac0$var$_assertThisInitialized(_this)), inputData)) return;
                _this.callback(manager, inputEvent, inputData);
            };
            _this.touch = new $d0bf7654e2e5fac0$export$8210fab11c86ffb5(_this.manager, _this.handler);
            _this.mouse = new $d0bf7654e2e5fac0$export$a491aeaf0289a5d3(_this.manager, _this.handler);
            _this.primaryTouch = null;
            _this.lastTouches = [];
            return _this;
        }
        /**
     * @private
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */ var _proto = TouchMouseInput.prototype;
        /**
     * @private
     * remove the event listeners
     */ _proto.destroy = function destroy() {
            this.touch.destroy();
            this.mouse.destroy();
        };
        return TouchMouseInput;
    }($d0bf7654e2e5fac0$export$f5b8910cec6cf069);
    return TouchMouseInput;
}();
/**
 * @private
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */ function $d0bf7654e2e5fac0$var$createInputInstance(manager) {
    var Type; // let inputClass = manager.options.inputClass;
    var inputClass = manager.options.inputClass;
    if (inputClass) Type = inputClass;
    else if ($d0bf7654e2e5fac0$var$SUPPORT_POINTER_EVENTS) Type = $d0bf7654e2e5fac0$export$d5ae9b841773907;
    else if ($d0bf7654e2e5fac0$var$SUPPORT_ONLY_TOUCH) Type = $d0bf7654e2e5fac0$export$8210fab11c86ffb5;
    else if (!$d0bf7654e2e5fac0$var$SUPPORT_TOUCH) Type = $d0bf7654e2e5fac0$export$a491aeaf0289a5d3;
    else Type = $d0bf7654e2e5fac0$export$560ade0f6763a0bb;
    return new Type(manager, $d0bf7654e2e5fac0$var$inputHandler);
}
/**
 * @private
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */ function $d0bf7654e2e5fac0$var$invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        $d0bf7654e2e5fac0$export$79b2f7037acddd43(arg, context[fn], context);
        return true;
    }
    return false;
}
var $d0bf7654e2e5fac0$export$bfbca205559bb816 = 1;
var $d0bf7654e2e5fac0$export$426ce8a3b1bb06d7 = 2;
var $d0bf7654e2e5fac0$export$dc7e8c09bf56e28f = 4;
var $d0bf7654e2e5fac0$export$d02fa1ba40b3705d = 8;
var $d0bf7654e2e5fac0$export$28fbdfb5d0b4294d = $d0bf7654e2e5fac0$export$d02fa1ba40b3705d;
var $d0bf7654e2e5fac0$export$f08468f3419e849f = 16;
var $d0bf7654e2e5fac0$export$f9914f41337664c = 32;
/**
 * @private
 * get a unique id
 * @returns {number} uniqueId
 */ var $d0bf7654e2e5fac0$var$_uniqueId = 1;
function $d0bf7654e2e5fac0$var$uniqueId() {
    return $d0bf7654e2e5fac0$var$_uniqueId++;
}
/**
 * @private
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */ function $d0bf7654e2e5fac0$var$getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) return manager.get(otherRecognizer);
    return otherRecognizer;
}
/**
 * @private
 * get a usable string, used as event postfix
 * @param {constant} state
 * @returns {String} state
 */ function $d0bf7654e2e5fac0$var$stateStr(state) {
    if (state & $d0bf7654e2e5fac0$export$f08468f3419e849f) return 'cancel';
    else if (state & $d0bf7654e2e5fac0$export$d02fa1ba40b3705d) return 'end';
    else if (state & $d0bf7654e2e5fac0$export$dc7e8c09bf56e28f) return 'move';
    else if (state & $d0bf7654e2e5fac0$export$426ce8a3b1bb06d7) return 'start';
    return '';
}
/**
 * @private
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */ /**
 * @private
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */ var $d0bf7654e2e5fac0$export$d051b53981c4a264 = /*#__PURE__*/ function() {
    function Recognizer(options) {
        if (options === void 0) options = {};
        this.options = $d0bf7654e2e5fac0$var$_extends({
            enable: true
        }, options);
        this.id = $d0bf7654e2e5fac0$var$uniqueId();
        this.manager = null; // default is enable true
        this.state = $d0bf7654e2e5fac0$export$bfbca205559bb816;
        this.simultaneous = {};
        this.requireFail = [];
    }
    /**
   * @private
   * set options
   * @param {Object} options
   * @return {Recognizer}
   */ var _proto = Recognizer.prototype;
    _proto.set = function set(options) {
        $d0bf7654e2e5fac0$export$e6e34fd1f2686227(this.options, options); // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    };
    /**
   * @private
   * recognize simultaneous with an other recognizer.
   * @param {Recognizer} otherRecognizer
   * @returns {Recognizer} this
   */ _proto.recognizeWith = function recognizeWith(otherRecognizer) {
        if ($d0bf7654e2e5fac0$var$invokeArrayArg(otherRecognizer, 'recognizeWith', this)) return this;
        var simultaneous = this.simultaneous;
        otherRecognizer = $d0bf7654e2e5fac0$var$getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    };
    /**
   * @private
   * drop the simultaneous link. it doesnt remove the link on the other recognizer.
   * @param {Recognizer} otherRecognizer
   * @returns {Recognizer} this
   */ _proto.dropRecognizeWith = function dropRecognizeWith(otherRecognizer) {
        if ($d0bf7654e2e5fac0$var$invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) return this;
        otherRecognizer = $d0bf7654e2e5fac0$var$getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    };
    /**
   * @private
   * recognizer can only run when an other is failing
   * @param {Recognizer} otherRecognizer
   * @returns {Recognizer} this
   */ _proto.requireFailure = function requireFailure(otherRecognizer) {
        if ($d0bf7654e2e5fac0$var$invokeArrayArg(otherRecognizer, 'requireFailure', this)) return this;
        var requireFail = this.requireFail;
        otherRecognizer = $d0bf7654e2e5fac0$var$getRecognizerByNameIfManager(otherRecognizer, this);
        if ($d0bf7654e2e5fac0$export$6632823c2c02cb2c(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    };
    /**
   * @private
   * drop the requireFailure link. it does not remove the link on the other recognizer.
   * @param {Recognizer} otherRecognizer
   * @returns {Recognizer} this
   */ _proto.dropRequireFailure = function dropRequireFailure(otherRecognizer) {
        if ($d0bf7654e2e5fac0$var$invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) return this;
        otherRecognizer = $d0bf7654e2e5fac0$var$getRecognizerByNameIfManager(otherRecognizer, this);
        var index = $d0bf7654e2e5fac0$export$6632823c2c02cb2c(this.requireFail, otherRecognizer);
        if (index > -1) this.requireFail.splice(index, 1);
        return this;
    };
    /**
   * @private
   * has require failures boolean
   * @returns {boolean}
   */ _proto.hasRequireFailures = function hasRequireFailures() {
        return this.requireFail.length > 0;
    };
    /**
   * @private
   * if the recognizer can recognize simultaneous with an other recognizer
   * @param {Recognizer} otherRecognizer
   * @returns {Boolean}
   */ _proto.canRecognizeWith = function canRecognizeWith(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    };
    /**
   * @private
   * You should use `tryEmit` instead of `emit` directly to check
   * that all the needed recognizers has failed before emitting.
   * @param {Object} input
   */ _proto.emit = function emit(input) {
        var self = this;
        var state = this.state;
        function emit(event) {
            self.manager.emit(event, input);
        } // 'panstart' and 'panmove'
        if (state < $d0bf7654e2e5fac0$export$d02fa1ba40b3705d) emit(self.options.event + $d0bf7654e2e5fac0$var$stateStr(state));
        emit(self.options.event); // simple 'eventName' events
        if (input.additionalEvent) // additional event(panleft, panright, pinchin, pinchout...)
        emit(input.additionalEvent);
         // panend and pancancel
        if (state >= $d0bf7654e2e5fac0$export$d02fa1ba40b3705d) emit(self.options.event + $d0bf7654e2e5fac0$var$stateStr(state));
    };
    /**
   * @private
   * Check that all the require failure recognizers has failed,
   * if true, it emits a gesture event,
   * otherwise, setup the state to FAILED.
   * @param {Object} input
   */ _proto.tryEmit = function tryEmit(input) {
        if (this.canEmit()) return this.emit(input);
         // it's failing anyway
        this.state = $d0bf7654e2e5fac0$export$f9914f41337664c;
    };
    /**
   * @private
   * can we emit?
   * @returns {boolean}
   */ _proto.canEmit = function canEmit() {
        var i = 0;
        while(i < this.requireFail.length){
            if (!(this.requireFail[i].state & ($d0bf7654e2e5fac0$export$f9914f41337664c | $d0bf7654e2e5fac0$export$bfbca205559bb816))) return false;
            i++;
        }
        return true;
    };
    /**
   * @private
   * update the recognizer
   * @param {Object} inputData
   */ _proto.recognize = function recognize(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = $d0bf7654e2e5fac0$export$e6e34fd1f2686227({}, inputData); // is is enabled and allow recognizing?
        if (!$d0bf7654e2e5fac0$export$4d5490c74eb6bfd5(this.options.enable, [
            this,
            inputDataClone
        ])) {
            this.reset();
            this.state = $d0bf7654e2e5fac0$export$f9914f41337664c;
            return;
        } // reset when we've reached the end
        if (this.state & ($d0bf7654e2e5fac0$export$28fbdfb5d0b4294d | $d0bf7654e2e5fac0$export$f08468f3419e849f | $d0bf7654e2e5fac0$export$f9914f41337664c)) this.state = $d0bf7654e2e5fac0$export$bfbca205559bb816;
        this.state = this.process(inputDataClone); // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & ($d0bf7654e2e5fac0$export$426ce8a3b1bb06d7 | $d0bf7654e2e5fac0$export$dc7e8c09bf56e28f | $d0bf7654e2e5fac0$export$d02fa1ba40b3705d | $d0bf7654e2e5fac0$export$f08468f3419e849f)) this.tryEmit(inputDataClone);
    };
    /**
   * @private
   * return the state of the recognizer
   * the actual recognizing happens in this method
   * @virtual
   * @param {Object} inputData
   * @returns {constant} STATE
   */ /* jshint ignore:start */ _proto.process = function process(inputData) {};
    /* jshint ignore:end */ /**
   * @private
   * return the preferred touch-action
   * @virtual
   * @returns {Array}
   */ _proto.getTouchAction = function getTouchAction() {};
    /**
   * @private
   * called when the gesture isn't allowed to recognize
   * like when another is being recognized or it is disabled
   * @virtual
   */ _proto.reset = function reset() {};
    return Recognizer;
}();
/**
 * @private
 * A tap is recognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */ var $d0bf7654e2e5fac0$export$4451a18ddc7083b7 = /*#__PURE__*/ function(_Recognizer) {
    $d0bf7654e2e5fac0$var$_inheritsLoose(TapRecognizer, _Recognizer);
    function TapRecognizer(options) {
        var _this;
        if (options === void 0) options = {};
        _this = _Recognizer.call(this, $d0bf7654e2e5fac0$var$_extends({
            event: 'tap',
            pointers: 1,
            taps: 1,
            interval: 300,
            // max time between the multi-tap taps
            time: 250,
            // max time of the pointer to be down (like finger on the screen)
            threshold: 9,
            // a minimal movement is ok, but keep it low
            posThreshold: 10
        }, options)) || this; // previous time and center,
        // used for tap counting
        _this.pTime = false;
        _this.pCenter = false;
        _this._timer = null;
        _this._input = null;
        _this.count = 0;
        return _this;
    }
    var _proto = TapRecognizer.prototype;
    _proto.getTouchAction = function getTouchAction() {
        return [
            $d0bf7654e2e5fac0$var$TOUCH_ACTION_MANIPULATION
        ];
    };
    _proto.process = function process(input) {
        var _this2 = this;
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;
        this.reset();
        if (input.eventType & $d0bf7654e2e5fac0$export$a343f8e8a934fd59 && this.count === 0) return this.failTimeout();
         // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType !== $d0bf7654e2e5fac0$export$26a469bc3fde64f7) return this.failTimeout();
            var validInterval = this.pTime ? input.timeStamp - this.pTime < options.interval : true;
            var validMultiTap = !this.pCenter || $d0bf7654e2e5fac0$var$getDistance(this.pCenter, input.center) < options.posThreshold;
            this.pTime = input.timeStamp;
            this.pCenter = input.center;
            if (!validMultiTap || !validInterval) this.count = 1;
            else this.count += 1;
            this._input = input; // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) return $d0bf7654e2e5fac0$export$28fbdfb5d0b4294d;
                else {
                    this._timer = setTimeout(function() {
                        _this2.state = $d0bf7654e2e5fac0$export$28fbdfb5d0b4294d;
                        _this2.tryEmit();
                    }, options.interval);
                    return $d0bf7654e2e5fac0$export$426ce8a3b1bb06d7;
                }
            }
        }
        return $d0bf7654e2e5fac0$export$f9914f41337664c;
    };
    _proto.failTimeout = function failTimeout() {
        var _this3 = this;
        this._timer = setTimeout(function() {
            _this3.state = $d0bf7654e2e5fac0$export$f9914f41337664c;
        }, this.options.interval);
        return $d0bf7654e2e5fac0$export$f9914f41337664c;
    };
    _proto.reset = function reset() {
        clearTimeout(this._timer);
    };
    _proto.emit = function emit() {
        if (this.state === $d0bf7654e2e5fac0$export$28fbdfb5d0b4294d) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    };
    return TapRecognizer;
}($d0bf7654e2e5fac0$export$d051b53981c4a264);
/**
 * @private
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */ var $d0bf7654e2e5fac0$export$8a2d586d6373c6d2 = /*#__PURE__*/ function(_Recognizer) {
    $d0bf7654e2e5fac0$var$_inheritsLoose(AttrRecognizer, _Recognizer);
    function AttrRecognizer(options) {
        if (options === void 0) options = {};
        return _Recognizer.call(this, $d0bf7654e2e5fac0$var$_extends({
            pointers: 1
        }, options)) || this;
    }
    /**
   * @private
   * Used to check if it the recognizer receives valid input, like input.distance > 10.
   * @memberof AttrRecognizer
   * @param {Object} input
   * @returns {Boolean} recognized
   */ var _proto = AttrRecognizer.prototype;
    _proto.attrTest = function attrTest(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    };
    /**
   * @private
   * Process the input and return the state for the recognizer
   * @memberof AttrRecognizer
   * @param {Object} input
   * @returns {*} State
   */ _proto.process = function process(input) {
        var state = this.state;
        var eventType = input.eventType;
        var isRecognized = state & ($d0bf7654e2e5fac0$export$426ce8a3b1bb06d7 | $d0bf7654e2e5fac0$export$dc7e8c09bf56e28f);
        var isValid = this.attrTest(input); // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & $d0bf7654e2e5fac0$export$a6cb74acba980f94 || !isValid)) return state | $d0bf7654e2e5fac0$export$f08468f3419e849f;
        else if (isRecognized || isValid) {
            if (eventType & $d0bf7654e2e5fac0$export$26a469bc3fde64f7) return state | $d0bf7654e2e5fac0$export$d02fa1ba40b3705d;
            else if (!(state & $d0bf7654e2e5fac0$export$426ce8a3b1bb06d7)) return $d0bf7654e2e5fac0$export$426ce8a3b1bb06d7;
            return state | $d0bf7654e2e5fac0$export$dc7e8c09bf56e28f;
        }
        return $d0bf7654e2e5fac0$export$f9914f41337664c;
    };
    return AttrRecognizer;
}($d0bf7654e2e5fac0$export$d051b53981c4a264);
/**
 * @private
 * direction cons to string
 * @param {constant} direction
 * @returns {String}
 */ function $d0bf7654e2e5fac0$var$directionStr(direction) {
    if (direction === $d0bf7654e2e5fac0$export$28a694fb106a7f62) return 'down';
    else if (direction === $d0bf7654e2e5fac0$export$b5ad9376033e98b2) return 'up';
    else if (direction === $d0bf7654e2e5fac0$export$4f1506fa80c37e6f) return 'left';
    else if (direction === $d0bf7654e2e5fac0$export$a34043b88230a335) return 'right';
    return '';
}
/**
 * @private
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */ var $d0bf7654e2e5fac0$export$f86166cd6057c2d1 = /*#__PURE__*/ function(_AttrRecognizer) {
    $d0bf7654e2e5fac0$var$_inheritsLoose(PanRecognizer, _AttrRecognizer);
    function PanRecognizer(options) {
        var _this;
        if (options === void 0) options = {};
        _this = _AttrRecognizer.call(this, $d0bf7654e2e5fac0$var$_extends({
            event: 'pan',
            threshold: 10,
            pointers: 1,
            direction: $d0bf7654e2e5fac0$export$b992f700de4c54f
        }, options)) || this;
        _this.pX = null;
        _this.pY = null;
        return _this;
    }
    var _proto = PanRecognizer.prototype;
    _proto.getTouchAction = function getTouchAction() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & $d0bf7654e2e5fac0$export$50a4ff95cf34d3b8) actions.push($d0bf7654e2e5fac0$var$TOUCH_ACTION_PAN_Y);
        if (direction & $d0bf7654e2e5fac0$export$9727db57753c1f4) actions.push($d0bf7654e2e5fac0$var$TOUCH_ACTION_PAN_X);
        return actions;
    };
    _proto.directionTest = function directionTest(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY; // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & $d0bf7654e2e5fac0$export$50a4ff95cf34d3b8) {
                direction = x === 0 ? $d0bf7654e2e5fac0$export$d423ecd2ef2f65e7 : x < 0 ? $d0bf7654e2e5fac0$export$4f1506fa80c37e6f : $d0bf7654e2e5fac0$export$a34043b88230a335;
                hasMoved = x !== this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = y === 0 ? $d0bf7654e2e5fac0$export$d423ecd2ef2f65e7 : y < 0 ? $d0bf7654e2e5fac0$export$b5ad9376033e98b2 : $d0bf7654e2e5fac0$export$28a694fb106a7f62;
                hasMoved = y !== this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    };
    _proto.attrTest = function attrTest(input) {
        return $d0bf7654e2e5fac0$export$8a2d586d6373c6d2.prototype.attrTest.call(this, input) && (this.state & $d0bf7654e2e5fac0$export$426ce8a3b1bb06d7 || !(this.state & $d0bf7654e2e5fac0$export$426ce8a3b1bb06d7) && this.directionTest(input));
    };
    _proto.emit = function emit(input) {
        this.pX = input.deltaX;
        this.pY = input.deltaY;
        var direction = $d0bf7654e2e5fac0$var$directionStr(input.direction);
        if (direction) input.additionalEvent = this.options.event + direction;
        _AttrRecognizer.prototype.emit.call(this, input);
    };
    return PanRecognizer;
}($d0bf7654e2e5fac0$export$8a2d586d6373c6d2);
/**
 * @private
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */ var $d0bf7654e2e5fac0$export$3838c944534dffa = /*#__PURE__*/ function(_AttrRecognizer) {
    $d0bf7654e2e5fac0$var$_inheritsLoose(SwipeRecognizer, _AttrRecognizer);
    function SwipeRecognizer(options) {
        if (options === void 0) options = {};
        return _AttrRecognizer.call(this, $d0bf7654e2e5fac0$var$_extends({
            event: 'swipe',
            threshold: 10,
            velocity: 0.3,
            direction: $d0bf7654e2e5fac0$export$50a4ff95cf34d3b8 | $d0bf7654e2e5fac0$export$9727db57753c1f4,
            pointers: 1
        }, options)) || this;
    }
    var _proto = SwipeRecognizer.prototype;
    _proto.getTouchAction = function getTouchAction() {
        return $d0bf7654e2e5fac0$export$f86166cd6057c2d1.prototype.getTouchAction.call(this);
    };
    _proto.attrTest = function attrTest(input) {
        var direction = this.options.direction;
        var velocity;
        if (direction & ($d0bf7654e2e5fac0$export$50a4ff95cf34d3b8 | $d0bf7654e2e5fac0$export$9727db57753c1f4)) velocity = input.overallVelocity;
        else if (direction & $d0bf7654e2e5fac0$export$50a4ff95cf34d3b8) velocity = input.overallVelocityX;
        else if (direction & $d0bf7654e2e5fac0$export$9727db57753c1f4) velocity = input.overallVelocityY;
        return _AttrRecognizer.prototype.attrTest.call(this, input) && direction & input.offsetDirection && input.distance > this.options.threshold && input.maxPointers === this.options.pointers && $d0bf7654e2e5fac0$var$abs(velocity) > this.options.velocity && input.eventType & $d0bf7654e2e5fac0$export$26a469bc3fde64f7;
    };
    _proto.emit = function emit(input) {
        var direction = $d0bf7654e2e5fac0$var$directionStr(input.offsetDirection);
        if (direction) this.manager.emit(this.options.event + direction, input);
        this.manager.emit(this.options.event, input);
    };
    return SwipeRecognizer;
}($d0bf7654e2e5fac0$export$8a2d586d6373c6d2);
/**
 * @private
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */ var $d0bf7654e2e5fac0$export$826ae541ddf1527b = /*#__PURE__*/ function(_AttrRecognizer) {
    $d0bf7654e2e5fac0$var$_inheritsLoose(PinchRecognizer, _AttrRecognizer);
    function PinchRecognizer(options) {
        if (options === void 0) options = {};
        return _AttrRecognizer.call(this, $d0bf7654e2e5fac0$var$_extends({
            event: 'pinch',
            threshold: 0,
            pointers: 2
        }, options)) || this;
    }
    var _proto = PinchRecognizer.prototype;
    _proto.getTouchAction = function getTouchAction() {
        return [
            $d0bf7654e2e5fac0$var$TOUCH_ACTION_NONE
        ];
    };
    _proto.attrTest = function attrTest(input) {
        return _AttrRecognizer.prototype.attrTest.call(this, input) && (Math.abs(input.scale - 1) > this.options.threshold || this.state & $d0bf7654e2e5fac0$export$426ce8a3b1bb06d7);
    };
    _proto.emit = function emit(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        _AttrRecognizer.prototype.emit.call(this, input);
    };
    return PinchRecognizer;
}($d0bf7654e2e5fac0$export$8a2d586d6373c6d2);
/**
 * @private
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */ var $d0bf7654e2e5fac0$export$152db69a76b6b79e = /*#__PURE__*/ function(_AttrRecognizer) {
    $d0bf7654e2e5fac0$var$_inheritsLoose(RotateRecognizer, _AttrRecognizer);
    function RotateRecognizer(options) {
        if (options === void 0) options = {};
        return _AttrRecognizer.call(this, $d0bf7654e2e5fac0$var$_extends({
            event: 'rotate',
            threshold: 0,
            pointers: 2
        }, options)) || this;
    }
    var _proto = RotateRecognizer.prototype;
    _proto.getTouchAction = function getTouchAction() {
        return [
            $d0bf7654e2e5fac0$var$TOUCH_ACTION_NONE
        ];
    };
    _proto.attrTest = function attrTest(input) {
        return _AttrRecognizer.prototype.attrTest.call(this, input) && (Math.abs(input.rotation) > this.options.threshold || this.state & $d0bf7654e2e5fac0$export$426ce8a3b1bb06d7);
    };
    return RotateRecognizer;
}($d0bf7654e2e5fac0$export$8a2d586d6373c6d2);
/**
 * @private
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */ var $d0bf7654e2e5fac0$export$90610caf6d8d0242 = /*#__PURE__*/ function(_Recognizer) {
    $d0bf7654e2e5fac0$var$_inheritsLoose(PressRecognizer, _Recognizer);
    function PressRecognizer(options) {
        var _this;
        if (options === void 0) options = {};
        _this = _Recognizer.call(this, $d0bf7654e2e5fac0$var$_extends({
            event: 'press',
            pointers: 1,
            time: 251,
            // minimal time of the pointer to be pressed
            threshold: 9
        }, options)) || this;
        _this._timer = null;
        _this._input = null;
        return _this;
    }
    var _proto = PressRecognizer.prototype;
    _proto.getTouchAction = function getTouchAction() {
        return [
            $d0bf7654e2e5fac0$var$TOUCH_ACTION_AUTO
        ];
    };
    _proto.process = function process(input) {
        var _this2 = this;
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;
        this._input = input; // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || input.eventType & ($d0bf7654e2e5fac0$export$26a469bc3fde64f7 | $d0bf7654e2e5fac0$export$a6cb74acba980f94) && !validTime) this.reset();
        else if (input.eventType & $d0bf7654e2e5fac0$export$a343f8e8a934fd59) {
            this.reset();
            this._timer = setTimeout(function() {
                _this2.state = $d0bf7654e2e5fac0$export$28fbdfb5d0b4294d;
                _this2.tryEmit();
            }, options.time);
        } else if (input.eventType & $d0bf7654e2e5fac0$export$26a469bc3fde64f7) return $d0bf7654e2e5fac0$export$28fbdfb5d0b4294d;
        return $d0bf7654e2e5fac0$export$f9914f41337664c;
    };
    _proto.reset = function reset() {
        clearTimeout(this._timer);
    };
    _proto.emit = function emit(input) {
        if (this.state !== $d0bf7654e2e5fac0$export$28fbdfb5d0b4294d) return;
        if (input && input.eventType & $d0bf7654e2e5fac0$export$26a469bc3fde64f7) this.manager.emit(this.options.event + "up", input);
        else {
            this._input.timeStamp = $d0bf7654e2e5fac0$var$now();
            this.manager.emit(this.options.event, this._input);
        }
    };
    return PressRecognizer;
}($d0bf7654e2e5fac0$export$d051b53981c4a264);
var $d0bf7654e2e5fac0$var$defaults = {
    /**
   * @private
   * set if DOM events are being triggered.
   * But this is slower and unused by simple implementations, so disabled by default.
   * @type {Boolean}
   * @default false
   */ domEvents: false,
    /**
   * @private
   * The value for the touchAction property/fallback.
   * When set to `compute` it will magically set the correct value based on the added recognizers.
   * @type {String}
   * @default compute
   */ touchAction: $d0bf7654e2e5fac0$var$TOUCH_ACTION_COMPUTE,
    /**
   * @private
   * @type {Boolean}
   * @default true
   */ enable: true,
    /**
   * @private
   * EXPERIMENTAL FEATURE -- can be removed/changed
   * Change the parent input target element.
   * If Null, then it is being set the to main element.
   * @type {Null|EventTarget}
   * @default null
   */ inputTarget: null,
    /**
   * @private
   * force an input class
   * @type {Null|Function}
   * @default null
   */ inputClass: null,
    /**
   * @private
   * Some CSS properties can be used to improve the working of Hammer.
   * Add them to this method and they will be set when creating a new Manager.
   * @namespace
   */ cssProps: {
        /**
     * @private
     * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
     * @type {String}
     * @default 'none'
     */ userSelect: "none",
        /**
     * @private
     * Disable the Windows Phone grippers when pressing an element.
     * @type {String}
     * @default 'none'
     */ touchSelect: "none",
        /**
     * @private
     * Disables the default callout shown when you touch and hold a touch target.
     * On iOS, when you touch and hold a touch target such as a link, Safari displays
     * a callout containing information about the link. This property allows you to disable that callout.
     * @type {String}
     * @default 'none'
     */ touchCallout: "none",
        /**
     * @private
     * Specifies whether zooming is enabled. Used by IE10>
     * @type {String}
     * @default 'none'
     */ contentZooming: "none",
        /**
     * @private
     * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
     * @type {String}
     * @default 'none'
     */ userDrag: "none",
        /**
     * @private
     * Overrides the highlight color shown when the user taps a link or a JavaScript
     * clickable element in iOS. This property obeys the alpha value, if specified.
     * @type {String}
     * @default 'rgba(0,0,0,0)'
     */ tapHighlightColor: "rgba(0,0,0,0)"
    }
};
/**
 * @private
 * Default recognizer setup when calling `Hammer()`
 * When creating a new Manager these will be skipped.
 * This is separated with other defaults because of tree-shaking.
 * @type {Array}
 */ var $d0bf7654e2e5fac0$var$preset = [
    [
        $d0bf7654e2e5fac0$export$152db69a76b6b79e,
        {
            enable: false
        }
    ],
    [
        $d0bf7654e2e5fac0$export$826ae541ddf1527b,
        {
            enable: false
        },
        [
            'rotate'
        ]
    ],
    [
        $d0bf7654e2e5fac0$export$3838c944534dffa,
        {
            direction: $d0bf7654e2e5fac0$export$50a4ff95cf34d3b8
        }
    ],
    [
        $d0bf7654e2e5fac0$export$f86166cd6057c2d1,
        {
            direction: $d0bf7654e2e5fac0$export$50a4ff95cf34d3b8
        },
        [
            'swipe'
        ]
    ],
    [
        $d0bf7654e2e5fac0$export$4451a18ddc7083b7
    ],
    [
        $d0bf7654e2e5fac0$export$4451a18ddc7083b7,
        {
            event: 'doubletap',
            taps: 2
        },
        [
            'tap'
        ]
    ],
    [
        $d0bf7654e2e5fac0$export$90610caf6d8d0242
    ]
];
var $d0bf7654e2e5fac0$var$STOP = 1;
var $d0bf7654e2e5fac0$var$FORCED_STOP = 2;
/**
 * @private
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */ function $d0bf7654e2e5fac0$var$toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) return;
    var prop;
    $d0bf7654e2e5fac0$export$79b2f7037acddd43(manager.options.cssProps, function(value, name) {
        prop = $d0bf7654e2e5fac0$export$302158222cd49bab(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else element.style[prop] = manager.oldCssProps[prop] || "";
    });
    if (!add) manager.oldCssProps = {};
}
/**
 * @private
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */ function $d0bf7654e2e5fac0$var$triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent("Event");
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}
/**
* @private
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */ var $d0bf7654e2e5fac0$export$d0d38e7dec7a1a61 = /*#__PURE__*/ function() {
    function Manager(element, options) {
        var _this = this;
        this.options = $d0bf7654e2e5fac0$export$e6e34fd1f2686227({}, $d0bf7654e2e5fac0$var$defaults, options || {});
        this.options.inputTarget = this.options.inputTarget || element;
        this.handlers = {};
        this.session = {};
        this.recognizers = [];
        this.oldCssProps = {};
        this.element = element;
        this.input = $d0bf7654e2e5fac0$var$createInputInstance(this);
        this.touchAction = new $d0bf7654e2e5fac0$export$e9e4ceed4aa397af(this, this.options.touchAction);
        $d0bf7654e2e5fac0$var$toggleCssProps(this, true);
        $d0bf7654e2e5fac0$export$79b2f7037acddd43(this.options.recognizers, function(item) {
            var recognizer = _this.add(new item[0](item[1]));
            item[2] && recognizer.recognizeWith(item[2]);
            item[3] && recognizer.requireFailure(item[3]);
        }, this);
    }
    /**
   * @private
   * set options
   * @param {Object} options
   * @returns {Manager}
   */ var _proto = Manager.prototype;
    _proto.set = function set(options) {
        $d0bf7654e2e5fac0$export$e6e34fd1f2686227(this.options, options); // Options that need a little more setup
        if (options.touchAction) this.touchAction.update();
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    };
    /**
   * @private
   * stop recognizing for this session.
   * This session will be discarded, when a new [input]start event is fired.
   * When forced, the recognizer cycle is stopped immediately.
   * @param {Boolean} [force]
   */ _proto.stop = function stop(force) {
        this.session.stopped = force ? $d0bf7654e2e5fac0$var$FORCED_STOP : $d0bf7654e2e5fac0$var$STOP;
    };
    /**
   * @private
   * run the recognizers!
   * called by the inputHandler function on every movement of the pointers (touches)
   * it walks through all the recognizers and tries to detect the gesture that is being made
   * @param {Object} inputData
   */ _proto.recognize = function recognize(inputData) {
        var session = this.session;
        if (session.stopped) return;
         // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);
        var recognizer;
        var recognizers = this.recognizers; // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer; // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || curRecognizer && curRecognizer.state & $d0bf7654e2e5fac0$export$28fbdfb5d0b4294d) {
            session.curRecognizer = null;
            curRecognizer = null;
        }
        var i = 0;
        while(i < recognizers.length){
            recognizer = recognizers[i]; // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== $d0bf7654e2e5fac0$var$FORCED_STOP && (!curRecognizer || recognizer === curRecognizer || // 2
            recognizer.canRecognizeWith(curRecognizer))) // 3
            recognizer.recognize(inputData);
            else recognizer.reset();
             // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & ($d0bf7654e2e5fac0$export$426ce8a3b1bb06d7 | $d0bf7654e2e5fac0$export$dc7e8c09bf56e28f | $d0bf7654e2e5fac0$export$d02fa1ba40b3705d)) {
                session.curRecognizer = recognizer;
                curRecognizer = recognizer;
            }
            i++;
        }
    };
    /**
   * @private
   * get a recognizer by its event name.
   * @param {Recognizer|String} recognizer
   * @returns {Recognizer|Null}
   */ _proto.get = function get(recognizer) {
        if (recognizer instanceof $d0bf7654e2e5fac0$export$d051b53981c4a264) return recognizer;
        var recognizers = this.recognizers;
        for(var i = 0; i < recognizers.length; i++){
            if (recognizers[i].options.event === recognizer) return recognizers[i];
        }
        return null;
    };
    /**
   * @private add a recognizer to the manager
   * existing recognizers with the same event name will be removed
   * @param {Recognizer} recognizer
   * @returns {Recognizer|Manager}
   */ _proto.add = function add(recognizer) {
        if ($d0bf7654e2e5fac0$var$invokeArrayArg(recognizer, "add", this)) return this;
         // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) this.remove(existing);
        this.recognizers.push(recognizer);
        recognizer.manager = this;
        this.touchAction.update();
        return recognizer;
    };
    /**
   * @private
   * remove a recognizer by name or instance
   * @param {Recognizer|String} recognizer
   * @returns {Manager}
   */ _proto.remove = function remove(recognizer) {
        if ($d0bf7654e2e5fac0$var$invokeArrayArg(recognizer, "remove", this)) return this;
        var targetRecognizer = this.get(recognizer); // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = $d0bf7654e2e5fac0$export$6632823c2c02cb2c(recognizers, targetRecognizer);
            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }
        return this;
    };
    /**
   * @private
   * bind event
   * @param {String} events
   * @param {Function} handler
   * @returns {EventEmitter} this
   */ _proto.on = function on(events, handler) {
        if (events === undefined || handler === undefined) return this;
        var handlers = this.handlers;
        $d0bf7654e2e5fac0$export$79b2f7037acddd43($d0bf7654e2e5fac0$export$a4a1898ed2c527c4(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    };
    /**
   * @private unbind event, leave emit blank to remove all handlers
   * @param {String} events
   * @param {Function} [handler]
   * @returns {EventEmitter} this
   */ _proto.off = function off(events, handler) {
        if (events === undefined) return this;
        var handlers = this.handlers;
        $d0bf7654e2e5fac0$export$79b2f7037acddd43($d0bf7654e2e5fac0$export$a4a1898ed2c527c4(events), function(event) {
            if (!handler) delete handlers[event];
            else handlers[event] && handlers[event].splice($d0bf7654e2e5fac0$export$6632823c2c02cb2c(handlers[event], handler), 1);
        });
        return this;
    };
    /**
   * @private emit event to the listeners
   * @param {String} event
   * @param {Object} data
   */ _proto.emit = function emit(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) $d0bf7654e2e5fac0$var$triggerDomEvent(event, data);
         // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) return;
        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };
        var i = 0;
        while(i < handlers.length){
            handlers[i](data);
            i++;
        }
    };
    /**
   * @private
   * destroy the manager and unbinds all events
   * it doesn't unbind dom events, that is the user own responsibility
   */ _proto.destroy = function destroy() {
        this.element && $d0bf7654e2e5fac0$var$toggleCssProps(this, false);
        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    };
    return Manager;
}();
var $d0bf7654e2e5fac0$var$SINGLE_TOUCH_INPUT_MAP = {
    touchstart: $d0bf7654e2e5fac0$export$a343f8e8a934fd59,
    touchmove: $d0bf7654e2e5fac0$export$6235f66f7766ee8c,
    touchend: $d0bf7654e2e5fac0$export$26a469bc3fde64f7,
    touchcancel: $d0bf7654e2e5fac0$export$a6cb74acba980f94
};
var $d0bf7654e2e5fac0$var$SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var $d0bf7654e2e5fac0$var$SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';
/**
 * @private
 * Touch events input
 * @constructor
 * @extends Input
 */ var $d0bf7654e2e5fac0$export$486d8d91364fa2ac = /*#__PURE__*/ function(_Input) {
    $d0bf7654e2e5fac0$var$_inheritsLoose(SingleTouchInput, _Input);
    function SingleTouchInput() {
        var _this;
        var proto = SingleTouchInput.prototype;
        proto.evTarget = $d0bf7654e2e5fac0$var$SINGLE_TOUCH_TARGET_EVENTS;
        proto.evWin = $d0bf7654e2e5fac0$var$SINGLE_TOUCH_WINDOW_EVENTS;
        _this = _Input.apply(this, arguments) || this;
        _this.started = false;
        return _this;
    }
    var _proto = SingleTouchInput.prototype;
    _proto.handler = function handler(ev) {
        var type = $d0bf7654e2e5fac0$var$SINGLE_TOUCH_INPUT_MAP[ev.type]; // should we handle the touch events?
        if (type === $d0bf7654e2e5fac0$export$a343f8e8a934fd59) this.started = true;
        if (!this.started) return;
        var touches = $d0bf7654e2e5fac0$var$normalizeSingleTouches.call(this, ev, type); // when done, reset the started state
        if (type & ($d0bf7654e2e5fac0$export$26a469bc3fde64f7 | $d0bf7654e2e5fac0$export$a6cb74acba980f94) && touches[0].length - touches[1].length === 0) this.started = false;
        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: $d0bf7654e2e5fac0$var$INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    };
    return SingleTouchInput;
}($d0bf7654e2e5fac0$export$f5b8910cec6cf069);
function $d0bf7654e2e5fac0$var$normalizeSingleTouches(ev, type) {
    var all = $d0bf7654e2e5fac0$export$45b10814cc054894(ev.touches);
    var changed = $d0bf7654e2e5fac0$export$45b10814cc054894(ev.changedTouches);
    if (type & ($d0bf7654e2e5fac0$export$26a469bc3fde64f7 | $d0bf7654e2e5fac0$export$a6cb74acba980f94)) all = $d0bf7654e2e5fac0$export$bbd17ecb0679edd7(all.concat(changed), 'identifier', true);
    return [
        all,
        changed
    ];
}
/**
 * @private
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */ function $d0bf7654e2e5fac0$var$deprecate(method, name, message) {
    var deprecationMessage = "DEPRECATED METHOD: " + name + "\n" + message + " AT \n";
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '').replace(/^\s+at\s+/gm, '').replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';
        var log = window.console && (window.console.warn || window.console.log);
        if (log) log.call(window.console, deprecationMessage, stack);
        return method.apply(this, arguments);
    };
}
/**
 * @private
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */ var $d0bf7654e2e5fac0$export$8b58be045bf06082 = $d0bf7654e2e5fac0$var$deprecate(function(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while(i < keys.length){
        if (!merge || merge && dest[keys[i]] === undefined) dest[keys[i]] = src[keys[i]];
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');
/**
 * @private
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */ var $d0bf7654e2e5fac0$export$4950aa0f605343fb = $d0bf7654e2e5fac0$var$deprecate(function(dest, src) {
    return $d0bf7654e2e5fac0$export$8b58be045bf06082(dest, src, true);
}, 'merge', 'Use `assign`.');
/**
 * @private
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */ function $d0bf7654e2e5fac0$export$4dc9a6b0ae3dfd2a(child, base, properties) {
    var baseP = base.prototype;
    var childP;
    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;
    if (properties) $d0bf7654e2e5fac0$export$e6e34fd1f2686227(childP, properties);
}
/**
 * @private
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */ function $d0bf7654e2e5fac0$export$2c348afe2becdb4f(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}
/**
 * @private
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */ var $d0bf7654e2e5fac0$var$Hammer = /*#__PURE__*/ function() {
    var Hammer = /**
    * @private
    * @const {string}
    */ function Hammer(element, options) {
        if (options === void 0) options = {};
        return new $d0bf7654e2e5fac0$export$d0d38e7dec7a1a61(element, $d0bf7654e2e5fac0$var$_extends({
            recognizers: $d0bf7654e2e5fac0$var$preset.concat()
        }, options));
    };
    Hammer.VERSION = "2.0.17-rc";
    Hammer.DIRECTION_ALL = $d0bf7654e2e5fac0$export$b992f700de4c54f;
    Hammer.DIRECTION_DOWN = $d0bf7654e2e5fac0$export$28a694fb106a7f62;
    Hammer.DIRECTION_LEFT = $d0bf7654e2e5fac0$export$4f1506fa80c37e6f;
    Hammer.DIRECTION_RIGHT = $d0bf7654e2e5fac0$export$a34043b88230a335;
    Hammer.DIRECTION_UP = $d0bf7654e2e5fac0$export$b5ad9376033e98b2;
    Hammer.DIRECTION_HORIZONTAL = $d0bf7654e2e5fac0$export$50a4ff95cf34d3b8;
    Hammer.DIRECTION_VERTICAL = $d0bf7654e2e5fac0$export$9727db57753c1f4;
    Hammer.DIRECTION_NONE = $d0bf7654e2e5fac0$export$d423ecd2ef2f65e7;
    Hammer.DIRECTION_DOWN = $d0bf7654e2e5fac0$export$28a694fb106a7f62;
    Hammer.INPUT_START = $d0bf7654e2e5fac0$export$a343f8e8a934fd59;
    Hammer.INPUT_MOVE = $d0bf7654e2e5fac0$export$6235f66f7766ee8c;
    Hammer.INPUT_END = $d0bf7654e2e5fac0$export$26a469bc3fde64f7;
    Hammer.INPUT_CANCEL = $d0bf7654e2e5fac0$export$a6cb74acba980f94;
    Hammer.STATE_POSSIBLE = $d0bf7654e2e5fac0$export$bfbca205559bb816;
    Hammer.STATE_BEGAN = $d0bf7654e2e5fac0$export$426ce8a3b1bb06d7;
    Hammer.STATE_CHANGED = $d0bf7654e2e5fac0$export$dc7e8c09bf56e28f;
    Hammer.STATE_ENDED = $d0bf7654e2e5fac0$export$d02fa1ba40b3705d;
    Hammer.STATE_RECOGNIZED = $d0bf7654e2e5fac0$export$28fbdfb5d0b4294d;
    Hammer.STATE_CANCELLED = $d0bf7654e2e5fac0$export$f08468f3419e849f;
    Hammer.STATE_FAILED = $d0bf7654e2e5fac0$export$f9914f41337664c;
    Hammer.Manager = $d0bf7654e2e5fac0$export$d0d38e7dec7a1a61;
    Hammer.Input = $d0bf7654e2e5fac0$export$f5b8910cec6cf069;
    Hammer.TouchAction = $d0bf7654e2e5fac0$export$e9e4ceed4aa397af;
    Hammer.TouchInput = $d0bf7654e2e5fac0$export$8210fab11c86ffb5;
    Hammer.MouseInput = $d0bf7654e2e5fac0$export$a491aeaf0289a5d3;
    Hammer.PointerEventInput = $d0bf7654e2e5fac0$export$d5ae9b841773907;
    Hammer.TouchMouseInput = $d0bf7654e2e5fac0$export$560ade0f6763a0bb;
    Hammer.SingleTouchInput = $d0bf7654e2e5fac0$export$486d8d91364fa2ac;
    Hammer.Recognizer = $d0bf7654e2e5fac0$export$d051b53981c4a264;
    Hammer.AttrRecognizer = $d0bf7654e2e5fac0$export$8a2d586d6373c6d2;
    Hammer.Tap = $d0bf7654e2e5fac0$export$4451a18ddc7083b7;
    Hammer.Pan = $d0bf7654e2e5fac0$export$f86166cd6057c2d1;
    Hammer.Swipe = $d0bf7654e2e5fac0$export$3838c944534dffa;
    Hammer.Pinch = $d0bf7654e2e5fac0$export$826ae541ddf1527b;
    Hammer.Rotate = $d0bf7654e2e5fac0$export$152db69a76b6b79e;
    Hammer.Press = $d0bf7654e2e5fac0$export$90610caf6d8d0242;
    Hammer.on = $d0bf7654e2e5fac0$export$af631764ddc44097;
    Hammer.off = $d0bf7654e2e5fac0$export$8c8705df4a2dcec9;
    Hammer.each = $d0bf7654e2e5fac0$export$79b2f7037acddd43;
    Hammer.merge = $d0bf7654e2e5fac0$export$4950aa0f605343fb;
    Hammer.extend = $d0bf7654e2e5fac0$export$8b58be045bf06082;
    Hammer.bindFn = $d0bf7654e2e5fac0$export$2c348afe2becdb4f;
    Hammer.assign = $d0bf7654e2e5fac0$export$e6e34fd1f2686227;
    Hammer.inherit = $d0bf7654e2e5fac0$export$4dc9a6b0ae3dfd2a;
    Hammer.bindFn = $d0bf7654e2e5fac0$export$2c348afe2becdb4f;
    Hammer.prefixed = $d0bf7654e2e5fac0$export$302158222cd49bab;
    Hammer.toArray = $d0bf7654e2e5fac0$export$45b10814cc054894;
    Hammer.inArray = $d0bf7654e2e5fac0$export$6632823c2c02cb2c;
    Hammer.uniqueArray = $d0bf7654e2e5fac0$export$bbd17ecb0679edd7;
    Hammer.splitStr = $d0bf7654e2e5fac0$export$a4a1898ed2c527c4;
    Hammer.boolOrFn = $d0bf7654e2e5fac0$export$4d5490c74eb6bfd5;
    Hammer.hasParent = $d0bf7654e2e5fac0$export$8dd5c737a2b3c45d;
    Hammer.addEventListeners = $d0bf7654e2e5fac0$export$af631764ddc44097;
    Hammer.removeEventListeners = $d0bf7654e2e5fac0$export$8c8705df4a2dcec9;
    Hammer.defaults = $d0bf7654e2e5fac0$export$e6e34fd1f2686227({}, $d0bf7654e2e5fac0$var$defaults, {
        preset: $d0bf7654e2e5fac0$var$preset
    });
    return Hammer;
}();
//  style loader but by script tag, not by the loader.
var $d0bf7654e2e5fac0$export$ebe90cb607ad99e = $d0bf7654e2e5fac0$var$Hammer.defaults;
var $d0bf7654e2e5fac0$export$2e2bcd8739ae039 = $d0bf7654e2e5fac0$var$Hammer;

});

parcelRegister("bEhJ5", function(module, exports) {

$parcel$export(module.exports, "default", () => $87b12e2e7973c4f3$export$2e2bcd8739ae039);
/*!
 * iro.js v5.5.2
 * 2016-2021 James Daniel
 * Licensed under MPL 2.0
 * github.com/jaames/iro.js
 */ var $87b12e2e7973c4f3$var$n, $87b12e2e7973c4f3$var$u, $87b12e2e7973c4f3$var$t, $87b12e2e7973c4f3$var$i, $87b12e2e7973c4f3$var$r, $87b12e2e7973c4f3$var$o, $87b12e2e7973c4f3$var$f = {}, $87b12e2e7973c4f3$var$e = [], $87b12e2e7973c4f3$var$c = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|^--/i;
function $87b12e2e7973c4f3$var$s(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $87b12e2e7973c4f3$var$a(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $87b12e2e7973c4f3$var$h(n, l, u) {
    var t, i, r, o, f = arguments;
    if (l = $87b12e2e7973c4f3$var$s({}, l), arguments.length > 3) for(u = [
        u
    ], t = 3; t < arguments.length; t++)u.push(f[t]);
    if (null != u && (l.children = u), null != n && null != n.defaultProps) for(i in n.defaultProps)void 0 === l[i] && (l[i] = n.defaultProps[i]);
    return o = l.key, null != (r = l.ref) && delete l.ref, null != o && delete l.key, $87b12e2e7973c4f3$var$v(n, l, o, r);
}
function $87b12e2e7973c4f3$var$v(l, u, t, i) {
    var r = {
        type: l,
        props: u,
        key: t,
        ref: i,
        __k: null,
        __p: null,
        __b: 0,
        __e: null,
        l: null,
        __c: null,
        constructor: void 0
    };
    return $87b12e2e7973c4f3$var$n.vnode && $87b12e2e7973c4f3$var$n.vnode(r), r;
}
function $87b12e2e7973c4f3$var$d(n) {
    return n.children;
}
function $87b12e2e7973c4f3$var$y(n) {
    if (null == n || "boolean" == typeof n) return null;
    if ("string" == typeof n || "number" == typeof n) return $87b12e2e7973c4f3$var$v(null, n, null, null);
    if (null != n.__e || null != n.__c) {
        var l = $87b12e2e7973c4f3$var$v(n.type, n.props, n.key, null);
        return l.__e = n.__e, l;
    }
    return n;
}
function $87b12e2e7973c4f3$var$m(n, l) {
    this.props = n, this.context = l;
}
function $87b12e2e7973c4f3$var$w(n, l) {
    if (null == l) return n.__p ? $87b12e2e7973c4f3$var$w(n.__p, n.__p.__k.indexOf(n) + 1) : null;
    for(var u; l < n.__k.length; l++){
        if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    }
    return "function" == typeof n.type ? $87b12e2e7973c4f3$var$w(n) : null;
}
function $87b12e2e7973c4f3$var$g(n) {
    var l, u;
    if (null != (n = n.__p) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $87b12e2e7973c4f3$var$g(n);
    }
}
function $87b12e2e7973c4f3$var$k(l) {
    (!l.__d && (l.__d = !0) && 1 === $87b12e2e7973c4f3$var$u.push(l) || $87b12e2e7973c4f3$var$i !== $87b12e2e7973c4f3$var$n.debounceRendering) && ($87b12e2e7973c4f3$var$i = $87b12e2e7973c4f3$var$n.debounceRendering, ($87b12e2e7973c4f3$var$n.debounceRendering || $87b12e2e7973c4f3$var$t)($87b12e2e7973c4f3$var$_));
}
function $87b12e2e7973c4f3$var$_() {
    var n, l, t, i, r, o, f, e;
    for($87b12e2e7973c4f3$var$u.sort(function(n, l) {
        return l.__v.__b - n.__v.__b;
    }); n = $87b12e2e7973c4f3$var$u.pop();)n.__d && (t = void 0, i = void 0, o = (r = (l = n).__v).__e, f = l.__P, e = l.u, l.u = !1, f && (t = [], i = $87b12e2e7973c4f3$var$$(f, r, $87b12e2e7973c4f3$var$s({}, r), l.__n, void 0 !== f.ownerSVGElement, null, t, e, null == o ? $87b12e2e7973c4f3$var$w(r) : o), $87b12e2e7973c4f3$var$j(t, r), i != o && $87b12e2e7973c4f3$var$g(r)));
}
function $87b12e2e7973c4f3$var$b(n, l, u, t, i, r, o, c, s) {
    var h, v, p, d, y, m, g, k = u && u.__k || $87b12e2e7973c4f3$var$e, _ = k.length;
    if (c == $87b12e2e7973c4f3$var$f && (c = null != r ? r[0] : _ ? $87b12e2e7973c4f3$var$w(u, 0) : null), h = 0, l.__k = $87b12e2e7973c4f3$var$x(l.__k, function(u) {
        if (null != u) {
            if (u.__p = l, u.__b = l.__b + 1, null === (p = k[h]) || p && u.key == p.key && u.type === p.type) k[h] = void 0;
            else for(v = 0; v < _; v++){
                if ((p = k[v]) && u.key == p.key && u.type === p.type) {
                    k[v] = void 0;
                    break;
                }
                p = null;
            }
            if (d = $87b12e2e7973c4f3$var$$(n, u, p = p || $87b12e2e7973c4f3$var$f, t, i, r, o, null, c, s), (v = u.ref) && p.ref != v && (g || (g = [])).push(v, u.__c || d, u), null != d) {
                if (null == m && (m = d), null != u.l) d = u.l, u.l = null;
                else if (r == p || d != c || null == d.parentNode) {
                    n: if (null == c || c.parentNode !== n) n.appendChild(d);
                    else {
                        for(y = c, v = 0; (y = y.nextSibling) && v < _; v += 2){
                            if (y == d) break n;
                        }
                        n.insertBefore(d, c);
                    }
                    "option" == l.type && (n.value = "");
                }
                c = d.nextSibling, "function" == typeof l.type && (l.l = d);
            }
        }
        return h++, u;
    }), l.__e = m, null != r && "function" != typeof l.type) for(h = r.length; h--;)null != r[h] && $87b12e2e7973c4f3$var$a(r[h]);
    for(h = _; h--;)null != k[h] && $87b12e2e7973c4f3$var$D(k[h], k[h]);
    if (g) for(h = 0; h < g.length; h++)$87b12e2e7973c4f3$var$A(g[h], g[++h], g[++h]);
}
function $87b12e2e7973c4f3$var$x(n, l, u) {
    if (null == u && (u = []), null == n || "boolean" == typeof n) l && u.push(l(null));
    else if (Array.isArray(n)) for(var t = 0; t < n.length; t++)$87b12e2e7973c4f3$var$x(n[t], l, u);
    else u.push(l ? l($87b12e2e7973c4f3$var$y(n)) : n);
    return u;
}
function $87b12e2e7973c4f3$var$C(n, l, u, t, i) {
    var r;
    for(r in u)r in l || $87b12e2e7973c4f3$var$N(n, r, null, u[r], t);
    for(r in l)i && "function" != typeof l[r] || "value" === r || "checked" === r || u[r] === l[r] || $87b12e2e7973c4f3$var$N(n, r, l[r], u[r], t);
}
function $87b12e2e7973c4f3$var$P(n, l, u) {
    "-" === l[0] ? n.setProperty(l, u) : n[l] = "number" == typeof u && !1 === $87b12e2e7973c4f3$var$c.test(l) ? u + "px" : null == u ? "" : u;
}
function $87b12e2e7973c4f3$var$N(n, l, u, t, i) {
    var r, o, f, e, c;
    if ("key" === (l = i ? "className" === l ? "class" : l : "class" === l ? "className" : l) || "children" === l) ;
    else if ("style" === l) {
        if (r = n.style, "string" == typeof u) r.cssText = u;
        else {
            if ("string" == typeof t && (r.cssText = "", t = null), t) for(o in t)u && o in u || $87b12e2e7973c4f3$var$P(r, o, "");
            if (u) for(f in u)t && u[f] === t[f] || $87b12e2e7973c4f3$var$P(r, f, u[f]);
        }
    } else "o" === l[0] && "n" === l[1] ? (e = l !== (l = l.replace(/Capture$/, "")), c = l.toLowerCase(), l = (c in n ? c : l).slice(2), u ? (t || n.addEventListener(l, $87b12e2e7973c4f3$var$T, e), (n.t || (n.t = {}))[l] = u) : n.removeEventListener(l, $87b12e2e7973c4f3$var$T, e)) : "list" !== l && "tagName" !== l && "form" !== l && !i && l in n ? n[l] = null == u ? "" : u : "function" != typeof u && "dangerouslySetInnerHTML" !== l && (l !== (l = l.replace(/^xlink:?/, "")) ? null == u || !1 === u ? n.removeAttributeNS("http://www.w3.org/1999/xlink", l.toLowerCase()) : n.setAttributeNS("http://www.w3.org/1999/xlink", l.toLowerCase(), u) : null == u || !1 === u ? n.removeAttribute(l) : n.setAttribute(l, u));
}
function $87b12e2e7973c4f3$var$T(l) {
    return this.t[l.type]($87b12e2e7973c4f3$var$n.event ? $87b12e2e7973c4f3$var$n.event(l) : l);
}
function $87b12e2e7973c4f3$var$$(l, u, t, i, r, o, f, e, c, a) {
    var h, v, p, y, w, g, k, _, C, P, N = u.type;
    if (void 0 !== u.constructor) return null;
    (h = $87b12e2e7973c4f3$var$n.__b) && h(u);
    try {
        n: if ("function" == typeof N) {
            if (_ = u.props, C = (h = N.contextType) && i[h.__c], P = h ? C ? C.props.value : h.__p : i, t.__c ? k = (v = u.__c = t.__c).__p = v.__E : ("prototype" in N && N.prototype.render ? u.__c = v = new N(_, P) : (u.__c = v = new $87b12e2e7973c4f3$var$m(_, P), v.constructor = N, v.render = $87b12e2e7973c4f3$var$H), C && C.sub(v), v.props = _, v.state || (v.state = {}), v.context = P, v.__n = i, p = v.__d = !0, v.__h = []), null == v.__s && (v.__s = v.state), null != N.getDerivedStateFromProps && $87b12e2e7973c4f3$var$s(v.__s == v.state ? v.__s = $87b12e2e7973c4f3$var$s({}, v.__s) : v.__s, N.getDerivedStateFromProps(_, v.__s)), p) null == N.getDerivedStateFromProps && null != v.componentWillMount && v.componentWillMount(), null != v.componentDidMount && f.push(v);
            else {
                if (null == N.getDerivedStateFromProps && null == e && null != v.componentWillReceiveProps && v.componentWillReceiveProps(_, P), !e && null != v.shouldComponentUpdate && !1 === v.shouldComponentUpdate(_, v.__s, P)) {
                    for(v.props = _, v.state = v.__s, v.__d = !1, v.__v = u, u.__e = null != c ? c !== t.__e ? c : t.__e : null, u.__k = t.__k, h = 0; h < u.__k.length; h++)u.__k[h] && (u.__k[h].__p = u);
                    break n;
                }
                null != v.componentWillUpdate && v.componentWillUpdate(_, v.__s, P);
            }
            for(y = v.props, w = v.state, v.context = P, v.props = _, v.state = v.__s, (h = $87b12e2e7973c4f3$var$n.__r) && h(u), v.__d = !1, v.__v = u, v.__P = l, h = v.render(v.props, v.state, v.context), u.__k = $87b12e2e7973c4f3$var$x(null != h && h.type == $87b12e2e7973c4f3$var$d && null == h.key ? h.props.children : h), null != v.getChildContext && (i = $87b12e2e7973c4f3$var$s($87b12e2e7973c4f3$var$s({}, i), v.getChildContext())), p || null == v.getSnapshotBeforeUpdate || (g = v.getSnapshotBeforeUpdate(y, w)), $87b12e2e7973c4f3$var$b(l, u, t, i, r, o, f, c, a), v.base = u.__e; h = v.__h.pop();)v.__s && (v.state = v.__s), h.call(v);
            p || null == y || null == v.componentDidUpdate || v.componentDidUpdate(y, w, g), k && (v.__E = v.__p = null);
        } else u.__e = $87b12e2e7973c4f3$var$z(t.__e, u, t, i, r, o, f, a);
        (h = $87b12e2e7973c4f3$var$n.diffed) && h(u);
    } catch (l) {
        $87b12e2e7973c4f3$var$n.__e(l, u, t);
    }
    return u.__e;
}
function $87b12e2e7973c4f3$var$j(l, u) {
    for(var t; t = l.pop();)try {
        t.componentDidMount();
    } catch (l) {
        $87b12e2e7973c4f3$var$n.__e(l, t.__v);
    }
    $87b12e2e7973c4f3$var$n.__c && $87b12e2e7973c4f3$var$n.__c(u);
}
function $87b12e2e7973c4f3$var$z(n, l, u, t, i, r, o, c) {
    var s, a, h, v, p = u.props, d = l.props;
    if (i = "svg" === l.type || i, null == n && null != r) {
        for(s = 0; s < r.length; s++)if (null != (a = r[s]) && (null === l.type ? 3 === a.nodeType : a.localName === l.type)) {
            n = a, r[s] = null;
            break;
        }
    }
    if (null == n) {
        if (null === l.type) return document.createTextNode(d);
        n = i ? document.createElementNS("http://www.w3.org/2000/svg", l.type) : document.createElement(l.type), r = null;
    }
    return null === l.type ? p !== d && (null != r && (r[r.indexOf(n)] = null), n.data = d) : l !== u && (null != r && (r = $87b12e2e7973c4f3$var$e.slice.call(n.childNodes)), h = (p = u.props || $87b12e2e7973c4f3$var$f).dangerouslySetInnerHTML, v = d.dangerouslySetInnerHTML, c || (v || h) && (v && h && v.__html == h.__html || (n.innerHTML = v && v.__html || "")), $87b12e2e7973c4f3$var$C(n, d, p, i, c), l.__k = l.props.children, v || $87b12e2e7973c4f3$var$b(n, l, u, t, "foreignObject" !== l.type && i, r, o, $87b12e2e7973c4f3$var$f, c), c || ("value" in d && void 0 !== d.value && d.value !== n.value && (n.value = null == d.value ? "" : d.value), "checked" in d && void 0 !== d.checked && d.checked !== n.checked && (n.checked = d.checked))), n;
}
function $87b12e2e7973c4f3$var$A(l, u, t) {
    try {
        "function" == typeof l ? l(u) : l.current = u;
    } catch (l) {
        $87b12e2e7973c4f3$var$n.__e(l, t);
    }
}
function $87b12e2e7973c4f3$var$D(l, u, t) {
    var i, r, o;
    if ($87b12e2e7973c4f3$var$n.unmount && $87b12e2e7973c4f3$var$n.unmount(l), (i = l.ref) && $87b12e2e7973c4f3$var$A(i, null, u), t || "function" == typeof l.type || (t = null != (r = l.__e)), l.__e = l.l = null, null != (i = l.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (l) {
            $87b12e2e7973c4f3$var$n.__e(l, u);
        }
        i.base = i.__P = null;
    }
    if (i = l.__k) for(o = 0; o < i.length; o++)i[o] && $87b12e2e7973c4f3$var$D(i[o], u, t);
    null != r && $87b12e2e7973c4f3$var$a(r);
}
function $87b12e2e7973c4f3$var$H(n, l, u) {
    return this.constructor(n, u);
}
function $87b12e2e7973c4f3$var$I(l, u, t) {
    var i, o, c;
    $87b12e2e7973c4f3$var$n.__p && $87b12e2e7973c4f3$var$n.__p(l, u), o = (i = t === $87b12e2e7973c4f3$var$r) ? null : t && t.__k || u.__k, l = $87b12e2e7973c4f3$var$h($87b12e2e7973c4f3$var$d, null, [
        l
    ]), c = [], $87b12e2e7973c4f3$var$$(u, i ? u.__k = l : (t || u).__k = l, o || $87b12e2e7973c4f3$var$f, $87b12e2e7973c4f3$var$f, void 0 !== u.ownerSVGElement, t && !i ? [
        t
    ] : o ? null : $87b12e2e7973c4f3$var$e.slice.call(u.childNodes), c, !1, t || $87b12e2e7973c4f3$var$f, i), $87b12e2e7973c4f3$var$j(c, l);
}
$87b12e2e7973c4f3$var$n = {}, $87b12e2e7973c4f3$var$m.prototype.setState = function(n, l) {
    var u = this.__s !== this.state && this.__s || (this.__s = $87b12e2e7973c4f3$var$s({}, this.state));
    ("function" != typeof n || (n = n(u, this.props))) && $87b12e2e7973c4f3$var$s(u, n), null != n && this.__v && (this.u = !1, l && this.__h.push(l), $87b12e2e7973c4f3$var$k(this));
}, $87b12e2e7973c4f3$var$m.prototype.forceUpdate = function(n) {
    this.__v && (n && this.__h.push(n), this.u = !0, $87b12e2e7973c4f3$var$k(this));
}, $87b12e2e7973c4f3$var$m.prototype.render = $87b12e2e7973c4f3$var$d, $87b12e2e7973c4f3$var$u = [], $87b12e2e7973c4f3$var$t = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $87b12e2e7973c4f3$var$i = $87b12e2e7973c4f3$var$n.debounceRendering, $87b12e2e7973c4f3$var$n.__e = function(n, l, u) {
    for(var t; l = l.__p;){
        if ((t = l.__c) && !t.__p) try {
            if (t.constructor && null != t.constructor.getDerivedStateFromError) t.setState(t.constructor.getDerivedStateFromError(n));
            else {
                if (null == t.componentDidCatch) continue;
                t.componentDidCatch(n);
            }
            return $87b12e2e7973c4f3$var$k(t.__E = t);
        } catch (l) {
            n = l;
        }
    }
    throw n;
}, $87b12e2e7973c4f3$var$r = $87b12e2e7973c4f3$var$f, $87b12e2e7973c4f3$var$o = 0;
function $87b12e2e7973c4f3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $87b12e2e7973c4f3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $87b12e2e7973c4f3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $87b12e2e7973c4f3$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $87b12e2e7973c4f3$var$_extends() {
    $87b12e2e7973c4f3$var$_extends = Object.assign || function(target) {
        var arguments$1 = arguments;
        for(var i = 1; i < arguments.length; i++){
            var source = arguments$1[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $87b12e2e7973c4f3$var$_extends.apply(this, arguments);
}
// Some regular expressions for rgb() and hsl() Colors are borrowed from tinyColor
// https://github.com/bgrins/TinyColor
// Kelvin temperature math borrowed from Neil Barlett's implementation
// from https://github.com/neilbartlett/color-temperature
// https://www.w3.org/TR/css3-values/#integers
var $87b12e2e7973c4f3$var$CSS_INTEGER = '[-\\+]?\\d+%?'; // http://www.w3.org/TR/css3-values/#number-value
var $87b12e2e7973c4f3$var$CSS_NUMBER = '[-\\+]?\\d*\\.\\d+%?'; // Allow positive/negative integer/number. Don't capture the either/or, just the entire outcome
var $87b12e2e7973c4f3$var$CSS_UNIT = '(?:' + $87b12e2e7973c4f3$var$CSS_NUMBER + ')|(?:' + $87b12e2e7973c4f3$var$CSS_INTEGER + ')'; // Parse function params
// Parens and commas are optional, and this also allows for whitespace between numbers
var $87b12e2e7973c4f3$var$PERMISSIVE_MATCH_3 = '[\\s|\\(]+(' + $87b12e2e7973c4f3$var$CSS_UNIT + ')[,|\\s]+(' + $87b12e2e7973c4f3$var$CSS_UNIT + ')[,|\\s]+(' + $87b12e2e7973c4f3$var$CSS_UNIT + ')\\s*\\)?';
var $87b12e2e7973c4f3$var$PERMISSIVE_MATCH_4 = '[\\s|\\(]+(' + $87b12e2e7973c4f3$var$CSS_UNIT + ')[,|\\s]+(' + $87b12e2e7973c4f3$var$CSS_UNIT + ')[,|\\s]+(' + $87b12e2e7973c4f3$var$CSS_UNIT + ')[,|\\s]+(' + $87b12e2e7973c4f3$var$CSS_UNIT + ')\\s*\\)?'; // Regex patterns for functional color strings
var $87b12e2e7973c4f3$var$REGEX_FUNCTIONAL_RGB = new RegExp('rgb' + $87b12e2e7973c4f3$var$PERMISSIVE_MATCH_3);
var $87b12e2e7973c4f3$var$REGEX_FUNCTIONAL_RGBA = new RegExp('rgba' + $87b12e2e7973c4f3$var$PERMISSIVE_MATCH_4);
var $87b12e2e7973c4f3$var$REGEX_FUNCTIONAL_HSL = new RegExp('hsl' + $87b12e2e7973c4f3$var$PERMISSIVE_MATCH_3);
var $87b12e2e7973c4f3$var$REGEX_FUNCTIONAL_HSLA = new RegExp('hsla' + $87b12e2e7973c4f3$var$PERMISSIVE_MATCH_4); // Color string parsing regex
var $87b12e2e7973c4f3$var$HEX_START = '^(?:#?|0x?)';
var $87b12e2e7973c4f3$var$HEX_INT_SINGLE = '([0-9a-fA-F]{1})';
var $87b12e2e7973c4f3$var$HEX_INT_DOUBLE = '([0-9a-fA-F]{2})';
var $87b12e2e7973c4f3$var$REGEX_HEX_3 = new RegExp($87b12e2e7973c4f3$var$HEX_START + $87b12e2e7973c4f3$var$HEX_INT_SINGLE + $87b12e2e7973c4f3$var$HEX_INT_SINGLE + $87b12e2e7973c4f3$var$HEX_INT_SINGLE + '$');
var $87b12e2e7973c4f3$var$REGEX_HEX_4 = new RegExp($87b12e2e7973c4f3$var$HEX_START + $87b12e2e7973c4f3$var$HEX_INT_SINGLE + $87b12e2e7973c4f3$var$HEX_INT_SINGLE + $87b12e2e7973c4f3$var$HEX_INT_SINGLE + $87b12e2e7973c4f3$var$HEX_INT_SINGLE + '$');
var $87b12e2e7973c4f3$var$REGEX_HEX_6 = new RegExp($87b12e2e7973c4f3$var$HEX_START + $87b12e2e7973c4f3$var$HEX_INT_DOUBLE + $87b12e2e7973c4f3$var$HEX_INT_DOUBLE + $87b12e2e7973c4f3$var$HEX_INT_DOUBLE + '$');
var $87b12e2e7973c4f3$var$REGEX_HEX_8 = new RegExp($87b12e2e7973c4f3$var$HEX_START + $87b12e2e7973c4f3$var$HEX_INT_DOUBLE + $87b12e2e7973c4f3$var$HEX_INT_DOUBLE + $87b12e2e7973c4f3$var$HEX_INT_DOUBLE + $87b12e2e7973c4f3$var$HEX_INT_DOUBLE + '$'); // Kelvin temperature bounds
var $87b12e2e7973c4f3$var$KELVIN_MIN = 2000;
var $87b12e2e7973c4f3$var$KELVIN_MAX = 40000; // Math shorthands
var $87b12e2e7973c4f3$var$log = Math.log, $87b12e2e7973c4f3$var$round = Math.round, $87b12e2e7973c4f3$var$floor = Math.floor;
/**
 * @desc Clamp a number between a min and max value
 * @param num - input value
 * @param min - min allowed value
 * @param max - max allowed value
 */ function $87b12e2e7973c4f3$var$clamp(num, min, max) {
    return Math.min(Math.max(num, min), max);
}
/**
 * @desc Parse a css unit string - either regular int or a percentage number
 * @param str - css unit string
 * @param max - max unit value, used for calculating percentages
 */ function $87b12e2e7973c4f3$var$parseUnit(str, max) {
    var isPercentage = str.indexOf('%') > -1;
    var num = parseFloat(str);
    return isPercentage ? max / 100 * num : num;
}
/**
 * @desc Parse hex str to an int
 * @param str - hex string to parse
 */ function $87b12e2e7973c4f3$var$parseHexInt(str) {
    return parseInt(str, 16);
}
/**
 * @desc Convert nunber into to 2-digit hex
 * @param int - number to convert
 */ function $87b12e2e7973c4f3$var$intToHex(_int) {
    return _int.toString(16).padStart(2, '0');
}
var $87b12e2e7973c4f3$var$IroColor = /*#__PURE__*/ function() {
    /**
    * @constructor Color object
    * @param value - initial color value
  */ function IroColor(value, onChange) {
        // The default Color value
        this.$ = {
            h: 0,
            s: 0,
            v: 0,
            a: 1
        };
        if (value) this.set(value);
         // The watch callback function for this Color will be stored here
        this.onChange = onChange;
        this.initialValue = $87b12e2e7973c4f3$var$_extends({}, this.$); // copy initial value
    }
    /**
    * @desc Set the Color from any valid value
    * @param value - new color value
  */ var _proto = IroColor.prototype;
    _proto.set = function set(value) {
        if (typeof value === 'string') {
            if (/^(?:#?|0x?)[0-9a-fA-F]{3,8}$/.test(value)) this.hexString = value;
            else if (/^rgba?/.test(value)) this.rgbString = value;
            else if (/^hsla?/.test(value)) this.hslString = value;
        } else if (typeof value === 'object') {
            if (value instanceof IroColor) this.hsva = value.hsva;
            else if ('r' in value && 'g' in value && 'b' in value) this.rgb = value;
            else if ('h' in value && 's' in value && 'v' in value) this.hsv = value;
            else if ('h' in value && 's' in value && 'l' in value) this.hsl = value;
            else if ('kelvin' in value) this.kelvin = value.kelvin;
        } else throw new Error('Invalid color value');
    } /**
    * @desc Shortcut to set a specific channel value
    * @param format - hsv | hsl | rgb
    * @param channel - individual channel to set, for example if model = hsl, chanel = h | s | l
    * @param value - new value for the channel
  */ ;
    _proto.setChannel = function setChannel(format, channel, value) {
        var _extends2;
        this[format] = $87b12e2e7973c4f3$var$_extends({}, this[format], (_extends2 = {}, _extends2[channel] = value, _extends2));
    } /**
   * @desc Reset color back to its initial value
   */ ;
    _proto.reset = function reset() {
        this.hsva = this.initialValue;
    } /**
    * @desc make new Color instance with the same value as this one
  */ ;
    _proto.clone = function clone() {
        return new IroColor(this);
    } /**
   * @desc remove color onChange
   */ ;
    _proto.unbind = function unbind() {
        this.onChange = undefined;
    } /**
    * @desc Convert hsv object to rgb
    * @param hsv - hsv color object
  */ ;
    IroColor.hsvToRgb = function hsvToRgb(hsv) {
        var h = hsv.h / 60;
        var s = hsv.s / 100;
        var v = hsv.v / 100;
        var i = $87b12e2e7973c4f3$var$floor(h);
        var f = h - i;
        var p = v * (1 - s);
        var q = v * (1 - f * s);
        var t = v * (1 - (1 - f) * s);
        var mod = i % 6;
        var r = [
            v,
            q,
            p,
            p,
            t,
            v
        ][mod];
        var g = [
            t,
            v,
            v,
            q,
            p,
            p
        ][mod];
        var b = [
            p,
            p,
            t,
            v,
            v,
            q
        ][mod];
        return {
            r: $87b12e2e7973c4f3$var$clamp(r * 255, 0, 255),
            g: $87b12e2e7973c4f3$var$clamp(g * 255, 0, 255),
            b: $87b12e2e7973c4f3$var$clamp(b * 255, 0, 255)
        };
    } /**
    * @desc Convert rgb object to hsv
    * @param rgb - rgb object
  */ ;
    IroColor.rgbToHsv = function rgbToHsv(rgb) {
        var r = rgb.r / 255;
        var g = rgb.g / 255;
        var b = rgb.b / 255;
        var max = Math.max(r, g, b);
        var min = Math.min(r, g, b);
        var delta = max - min;
        var hue = 0;
        var value = max;
        var saturation = max === 0 ? 0 : delta / max;
        switch(max){
            case min:
                hue = 0; // achromatic
                break;
            case r:
                hue = (g - b) / delta + (g < b ? 6 : 0);
                break;
            case g:
                hue = (b - r) / delta + 2;
                break;
            case b:
                hue = (r - g) / delta + 4;
                break;
        }
        return {
            h: hue * 60 % 360,
            s: $87b12e2e7973c4f3$var$clamp(saturation * 100, 0, 100),
            v: $87b12e2e7973c4f3$var$clamp(value * 100, 0, 100)
        };
    } /**
    * @desc Convert hsv object to hsl
    * @param hsv - hsv object
  */ ;
    IroColor.hsvToHsl = function hsvToHsl(hsv) {
        var s = hsv.s / 100;
        var v = hsv.v / 100;
        var l = (2 - s) * v;
        var divisor = l <= 1 ? l : 2 - l; // Avoid division by zero when lightness is close to zero
        var saturation = divisor < 1e-9 ? 0 : s * v / divisor;
        return {
            h: hsv.h,
            s: $87b12e2e7973c4f3$var$clamp(saturation * 100, 0, 100),
            l: $87b12e2e7973c4f3$var$clamp(l * 50, 0, 100)
        };
    } /**
    * @desc Convert hsl object to hsv
    * @param hsl - hsl object
  */ ;
    IroColor.hslToHsv = function hslToHsv(hsl) {
        var l = hsl.l * 2;
        var s = hsl.s * (l <= 100 ? l : 200 - l) / 100; // Avoid division by zero when l + s is near 0
        var saturation = l + s < 1e-9 ? 0 : 2 * s / (l + s);
        return {
            h: hsl.h,
            s: $87b12e2e7973c4f3$var$clamp(saturation * 100, 0, 100),
            v: $87b12e2e7973c4f3$var$clamp((l + s) / 2, 0, 100)
        };
    } /**
    * @desc Convert a kelvin temperature to an approx, RGB value
    * @param kelvin - kelvin temperature
  */ ;
    IroColor.kelvinToRgb = function kelvinToRgb(kelvin) {
        var temp = kelvin / 100;
        var r, g, b;
        if (temp < 66) {
            r = 255;
            g = -155.25485562709179 - 0.44596950469579133 * (g = temp - 2) + 104.49216199393888 * $87b12e2e7973c4f3$var$log(g);
            b = temp < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (b = temp - 10) + 115.67994401066147 * $87b12e2e7973c4f3$var$log(b);
        } else {
            r = 351.97690566805693 + 0.114206453784165 * (r = temp - 55) - 40.25366309332127 * $87b12e2e7973c4f3$var$log(r);
            g = 325.4494125711974 + 0.07943456536662342 * (g = temp - 50) - 28.0852963507957 * $87b12e2e7973c4f3$var$log(g);
            b = 255;
        }
        return {
            r: $87b12e2e7973c4f3$var$clamp($87b12e2e7973c4f3$var$floor(r), 0, 255),
            g: $87b12e2e7973c4f3$var$clamp($87b12e2e7973c4f3$var$floor(g), 0, 255),
            b: $87b12e2e7973c4f3$var$clamp($87b12e2e7973c4f3$var$floor(b), 0, 255)
        };
    } /**
   * @desc Convert an RGB color to an approximate kelvin temperature
   * @param kelvin - kelvin temperature
  */ ;
    IroColor.rgbToKelvin = function rgbToKelvin(rgb) {
        var r = rgb.r, b = rgb.b;
        var eps = 0.4;
        var minTemp = $87b12e2e7973c4f3$var$KELVIN_MIN;
        var maxTemp = $87b12e2e7973c4f3$var$KELVIN_MAX;
        var temp;
        while(maxTemp - minTemp > eps){
            temp = (maxTemp + minTemp) * 0.5;
            var _rgb = IroColor.kelvinToRgb(temp);
            if (_rgb.b / _rgb.r >= b / r) maxTemp = temp;
            else minTemp = temp;
        }
        return temp;
    };
    $87b12e2e7973c4f3$var$_createClass(IroColor, [
        {
            key: "hsv",
            get: function get() {
                // value is cloned to allow changes to be made to the values before passing them back
                var value = this.$;
                return {
                    h: value.h,
                    s: value.s,
                    v: value.v
                };
            },
            set: function set(newValue) {
                var oldValue = this.$;
                newValue = $87b12e2e7973c4f3$var$_extends({}, oldValue, newValue); // If this Color is being watched for changes we need to compare the new and old values to check the difference
                // Otherwise we can just be lazy
                if (this.onChange) {
                    // Compute changed values
                    var changes = {
                        h: false,
                        v: false,
                        s: false,
                        a: false
                    };
                    for(var key in oldValue)changes[key] = newValue[key] != oldValue[key];
                    this.$ = newValue; // If the value has changed, call hook callback
                    if (changes.h || changes.s || changes.v || changes.a) this.onChange(this, changes);
                } else this.$ = newValue;
            }
        },
        {
            key: "hsva",
            get: function get() {
                return $87b12e2e7973c4f3$var$_extends({}, this.$);
            },
            set: function set(value) {
                this.hsv = value;
            }
        },
        {
            key: "hue",
            get: function get() {
                return this.$.h;
            },
            set: function set(value) {
                this.hsv = {
                    h: value
                };
            }
        },
        {
            key: "saturation",
            get: function get() {
                return this.$.s;
            },
            set: function set(value) {
                this.hsv = {
                    s: value
                };
            }
        },
        {
            key: "value",
            get: function get() {
                return this.$.v;
            },
            set: function set(value) {
                this.hsv = {
                    v: value
                };
            }
        },
        {
            key: "alpha",
            get: function get() {
                return this.$.a;
            },
            set: function set(value) {
                this.hsv = $87b12e2e7973c4f3$var$_extends({}, this.hsv, {
                    a: value
                });
            }
        },
        {
            key: "kelvin",
            get: function get() {
                return IroColor.rgbToKelvin(this.rgb);
            },
            set: function set(value) {
                this.rgb = IroColor.kelvinToRgb(value);
            }
        },
        {
            key: "red",
            get: function get() {
                var rgb = this.rgb;
                return rgb.r;
            },
            set: function set(value) {
                this.rgb = $87b12e2e7973c4f3$var$_extends({}, this.rgb, {
                    r: value
                });
            }
        },
        {
            key: "green",
            get: function get() {
                var rgb = this.rgb;
                return rgb.g;
            },
            set: function set(value) {
                this.rgb = $87b12e2e7973c4f3$var$_extends({}, this.rgb, {
                    g: value
                });
            }
        },
        {
            key: "blue",
            get: function get() {
                var rgb = this.rgb;
                return rgb.b;
            },
            set: function set(value) {
                this.rgb = $87b12e2e7973c4f3$var$_extends({}, this.rgb, {
                    b: value
                });
            }
        },
        {
            key: "rgb",
            get: function get() {
                var _IroColor$hsvToRgb = IroColor.hsvToRgb(this.$), r = _IroColor$hsvToRgb.r, g = _IroColor$hsvToRgb.g, b = _IroColor$hsvToRgb.b;
                return {
                    r: $87b12e2e7973c4f3$var$round(r),
                    g: $87b12e2e7973c4f3$var$round(g),
                    b: $87b12e2e7973c4f3$var$round(b)
                };
            },
            set: function set(value) {
                this.hsv = $87b12e2e7973c4f3$var$_extends({}, IroColor.rgbToHsv(value), {
                    a: value.a === undefined ? 1 : value.a
                });
            }
        },
        {
            key: "rgba",
            get: function get() {
                return $87b12e2e7973c4f3$var$_extends({}, this.rgb, {
                    a: this.alpha
                });
            },
            set: function set(value) {
                this.rgb = value;
            }
        },
        {
            key: "hsl",
            get: function get() {
                var _IroColor$hsvToHsl = IroColor.hsvToHsl(this.$), h = _IroColor$hsvToHsl.h, s = _IroColor$hsvToHsl.s, l = _IroColor$hsvToHsl.l;
                return {
                    h: $87b12e2e7973c4f3$var$round(h),
                    s: $87b12e2e7973c4f3$var$round(s),
                    l: $87b12e2e7973c4f3$var$round(l)
                };
            },
            set: function set(value) {
                this.hsv = $87b12e2e7973c4f3$var$_extends({}, IroColor.hslToHsv(value), {
                    a: value.a === undefined ? 1 : value.a
                });
            }
        },
        {
            key: "hsla",
            get: function get() {
                return $87b12e2e7973c4f3$var$_extends({}, this.hsl, {
                    a: this.alpha
                });
            },
            set: function set(value) {
                this.hsl = value;
            }
        },
        {
            key: "rgbString",
            get: function get() {
                var rgb = this.rgb;
                return "rgb(" + rgb.r + ", " + rgb.g + ", " + rgb.b + ")";
            },
            set: function set(value) {
                var match;
                var r, g, b, a = 1;
                if (match = $87b12e2e7973c4f3$var$REGEX_FUNCTIONAL_RGB.exec(value)) {
                    r = $87b12e2e7973c4f3$var$parseUnit(match[1], 255);
                    g = $87b12e2e7973c4f3$var$parseUnit(match[2], 255);
                    b = $87b12e2e7973c4f3$var$parseUnit(match[3], 255);
                } else if (match = $87b12e2e7973c4f3$var$REGEX_FUNCTIONAL_RGBA.exec(value)) {
                    r = $87b12e2e7973c4f3$var$parseUnit(match[1], 255);
                    g = $87b12e2e7973c4f3$var$parseUnit(match[2], 255);
                    b = $87b12e2e7973c4f3$var$parseUnit(match[3], 255);
                    a = $87b12e2e7973c4f3$var$parseUnit(match[4], 1);
                }
                if (match) this.rgb = {
                    r: r,
                    g: g,
                    b: b,
                    a: a
                };
                else throw new Error('Invalid rgb string');
            }
        },
        {
            key: "rgbaString",
            get: function get() {
                var rgba = this.rgba;
                return "rgba(" + rgba.r + ", " + rgba.g + ", " + rgba.b + ", " + rgba.a + ")";
            },
            set: function set(value) {
                this.rgbString = value;
            }
        },
        {
            key: "hexString",
            get: function get() {
                var rgb = this.rgb;
                return "#" + $87b12e2e7973c4f3$var$intToHex(rgb.r) + $87b12e2e7973c4f3$var$intToHex(rgb.g) + $87b12e2e7973c4f3$var$intToHex(rgb.b);
            },
            set: function set(value) {
                var match;
                var r, g, b, a = 255;
                if (match = $87b12e2e7973c4f3$var$REGEX_HEX_3.exec(value)) {
                    r = $87b12e2e7973c4f3$var$parseHexInt(match[1]) * 17;
                    g = $87b12e2e7973c4f3$var$parseHexInt(match[2]) * 17;
                    b = $87b12e2e7973c4f3$var$parseHexInt(match[3]) * 17;
                } else if (match = $87b12e2e7973c4f3$var$REGEX_HEX_4.exec(value)) {
                    r = $87b12e2e7973c4f3$var$parseHexInt(match[1]) * 17;
                    g = $87b12e2e7973c4f3$var$parseHexInt(match[2]) * 17;
                    b = $87b12e2e7973c4f3$var$parseHexInt(match[3]) * 17;
                    a = $87b12e2e7973c4f3$var$parseHexInt(match[4]) * 17;
                } else if (match = $87b12e2e7973c4f3$var$REGEX_HEX_6.exec(value)) {
                    r = $87b12e2e7973c4f3$var$parseHexInt(match[1]);
                    g = $87b12e2e7973c4f3$var$parseHexInt(match[2]);
                    b = $87b12e2e7973c4f3$var$parseHexInt(match[3]);
                } else if (match = $87b12e2e7973c4f3$var$REGEX_HEX_8.exec(value)) {
                    r = $87b12e2e7973c4f3$var$parseHexInt(match[1]);
                    g = $87b12e2e7973c4f3$var$parseHexInt(match[2]);
                    b = $87b12e2e7973c4f3$var$parseHexInt(match[3]);
                    a = $87b12e2e7973c4f3$var$parseHexInt(match[4]);
                }
                if (match) this.rgb = {
                    r: r,
                    g: g,
                    b: b,
                    a: a / 255
                };
                else throw new Error('Invalid hex string');
            }
        },
        {
            key: "hex8String",
            get: function get() {
                var rgba = this.rgba;
                return "#" + $87b12e2e7973c4f3$var$intToHex(rgba.r) + $87b12e2e7973c4f3$var$intToHex(rgba.g) + $87b12e2e7973c4f3$var$intToHex(rgba.b) + $87b12e2e7973c4f3$var$intToHex($87b12e2e7973c4f3$var$floor(rgba.a * 255));
            },
            set: function set(value) {
                this.hexString = value;
            }
        },
        {
            key: "hslString",
            get: function get() {
                var hsl = this.hsl;
                return "hsl(" + hsl.h + ", " + hsl.s + "%, " + hsl.l + "%)";
            },
            set: function set(value) {
                var match;
                var h, s, l, a = 1;
                if (match = $87b12e2e7973c4f3$var$REGEX_FUNCTIONAL_HSL.exec(value)) {
                    h = $87b12e2e7973c4f3$var$parseUnit(match[1], 360);
                    s = $87b12e2e7973c4f3$var$parseUnit(match[2], 100);
                    l = $87b12e2e7973c4f3$var$parseUnit(match[3], 100);
                } else if (match = $87b12e2e7973c4f3$var$REGEX_FUNCTIONAL_HSLA.exec(value)) {
                    h = $87b12e2e7973c4f3$var$parseUnit(match[1], 360);
                    s = $87b12e2e7973c4f3$var$parseUnit(match[2], 100);
                    l = $87b12e2e7973c4f3$var$parseUnit(match[3], 100);
                    a = $87b12e2e7973c4f3$var$parseUnit(match[4], 1);
                }
                if (match) this.hsl = {
                    h: h,
                    s: s,
                    l: l,
                    a: a
                };
                else throw new Error('Invalid hsl string');
            }
        },
        {
            key: "hslaString",
            get: function get() {
                var hsla = this.hsla;
                return "hsla(" + hsla.h + ", " + hsla.s + "%, " + hsla.l + "%, " + hsla.a + ")";
            },
            set: function set(value) {
                this.hslString = value;
            }
        }
    ]);
    return IroColor;
}();
var $87b12e2e7973c4f3$var$sliderDefaultOptions = {
    sliderShape: 'bar',
    sliderType: 'value',
    minTemperature: 2200,
    maxTemperature: 11000
};
/**
 * @desc Get the bounding dimensions of the slider
 * @param props - slider props
 */ function $87b12e2e7973c4f3$var$getSliderDimensions(props) {
    var _sliderSize;
    var width = props.width, sliderSize = props.sliderSize, borderWidth = props.borderWidth, handleRadius = props.handleRadius, padding = props.padding, sliderShape = props.sliderShape;
    var ishorizontal = props.layoutDirection === 'horizontal'; // automatically calculate sliderSize if its not defined
    sliderSize = (_sliderSize = sliderSize) != null ? _sliderSize : padding * 2 + handleRadius * 2;
    if (sliderShape === 'circle') return {
        handleStart: props.padding + props.handleRadius,
        handleRange: width - padding * 2 - handleRadius * 2,
        width: width,
        height: width,
        cx: width / 2,
        cy: width / 2,
        radius: width / 2 - borderWidth / 2
    };
    else return {
        handleStart: sliderSize / 2,
        handleRange: width - sliderSize,
        radius: sliderSize / 2,
        x: 0,
        y: 0,
        width: ishorizontal ? sliderSize : width,
        height: ishorizontal ? width : sliderSize
    };
}
/**
 * @desc Get the current slider value for a given color, as a percentage
 * @param props - slider props
 * @param color
 */ function $87b12e2e7973c4f3$var$getCurrentSliderValue(props, color) {
    var hsva = color.hsva;
    var rgb = color.rgb;
    switch(props.sliderType){
        case 'red':
            return rgb.r / 2.55;
        case 'green':
            return rgb.g / 2.55;
        case 'blue':
            return rgb.b / 2.55;
        case 'alpha':
            return hsva.a * 100;
        case 'kelvin':
            var minTemperature = props.minTemperature, maxTemperature = props.maxTemperature;
            var temperatureRange = maxTemperature - minTemperature;
            var percent = (color.kelvin - minTemperature) / temperatureRange * 100; // clmap percentage
            return Math.max(0, Math.min(percent, 100));
        case 'hue':
            return hsva.h /= 3.6;
        case 'saturation':
            return hsva.s;
        case 'value':
        default:
            return hsva.v;
    }
}
/**
 * @desc Get the current slider value from user input
 * @param props - slider props
 * @param x - global input x position
 * @param y - global input y position
 */ function $87b12e2e7973c4f3$var$getSliderValueFromInput(props, x, y) {
    var _getSliderDimensions = $87b12e2e7973c4f3$var$getSliderDimensions(props), handleRange = _getSliderDimensions.handleRange, handleStart = _getSliderDimensions.handleStart;
    var handlePos;
    if (props.layoutDirection === 'horizontal') handlePos = -1 * y + handleRange + handleStart;
    else handlePos = x - handleStart;
     // clamp handle position
    handlePos = Math.max(Math.min(handlePos, handleRange), 0);
    var percent = Math.round(100 / handleRange * handlePos);
    switch(props.sliderType){
        case 'kelvin':
            var minTemperature = props.minTemperature, maxTemperature = props.maxTemperature;
            var temperatureRange = maxTemperature - minTemperature;
            return minTemperature + temperatureRange * (percent / 100);
        case 'alpha':
            return percent / 100;
        case 'hue':
            return percent * 3.6;
        case 'red':
        case 'blue':
        case 'green':
            return percent * 2.55;
        default:
            return percent;
    }
}
/**
 * @desc Get the current handle position for a given color
 * @param props - slider props
 * @param color
 */ function $87b12e2e7973c4f3$var$getSliderHandlePosition(props, color) {
    var _getSliderDimensions2 = $87b12e2e7973c4f3$var$getSliderDimensions(props), width = _getSliderDimensions2.width, height = _getSliderDimensions2.height, handleRange = _getSliderDimensions2.handleRange, handleStart = _getSliderDimensions2.handleStart;
    var ishorizontal = props.layoutDirection === 'horizontal';
    var sliderValue = $87b12e2e7973c4f3$var$getCurrentSliderValue(props, color);
    var midPoint = ishorizontal ? width / 2 : height / 2;
    var handlePos = handleStart + sliderValue / 100 * handleRange;
    if (ishorizontal) handlePos = -1 * handlePos + handleRange + handleStart * 2;
    return {
        x: ishorizontal ? midPoint : handlePos,
        y: ishorizontal ? handlePos : midPoint
    };
}
/**
 * @desc Get the gradient stops for a slider
 * @param props - slider props
 * @param color
 */ function $87b12e2e7973c4f3$var$getSliderGradient(props, color) {
    var hsv = color.hsv;
    var rgb = color.rgb;
    switch(props.sliderType){
        case 'red':
            return [
                [
                    0,
                    "rgb(0," + rgb.g + "," + rgb.b + ")"
                ],
                [
                    100,
                    "rgb(255," + rgb.g + "," + rgb.b + ")"
                ]
            ];
        case 'green':
            return [
                [
                    0,
                    "rgb(" + rgb.r + "," + 0 + "," + rgb.b + ")"
                ],
                [
                    100,
                    "rgb(" + rgb.r + "," + 255 + "," + rgb.b + ")"
                ]
            ];
        case 'blue':
            return [
                [
                    0,
                    "rgb(" + rgb.r + "," + rgb.g + "," + 0 + ")"
                ],
                [
                    100,
                    "rgb(" + rgb.r + "," + rgb.g + "," + 255 + ")"
                ]
            ];
        case 'alpha':
            return [
                [
                    0,
                    "rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ",0)"
                ],
                [
                    100,
                    "rgb(" + rgb.r + "," + rgb.g + "," + rgb.b + ")"
                ]
            ];
        case 'kelvin':
            var stops = [];
            var min = props.minTemperature;
            var max = props.maxTemperature;
            var numStops = 8;
            var range = max - min;
            for(var kelvin = min, stop = 0; kelvin < max; kelvin += range / numStops, stop += 1){
                var _IroColor$kelvinToRgb = $87b12e2e7973c4f3$var$IroColor.kelvinToRgb(kelvin), r = _IroColor$kelvinToRgb.r, g = _IroColor$kelvinToRgb.g, b = _IroColor$kelvinToRgb.b;
                stops.push([
                    100 / numStops * stop,
                    "rgb(" + r + "," + g + "," + b + ")"
                ]);
            }
            return stops;
        case 'hue':
            return [
                [
                    0,
                    '#f00'
                ],
                [
                    16.666,
                    '#ff0'
                ],
                [
                    33.333,
                    '#0f0'
                ],
                [
                    50,
                    '#0ff'
                ],
                [
                    66.666,
                    '#00f'
                ],
                [
                    83.333,
                    '#f0f'
                ],
                [
                    100,
                    '#f00'
                ]
            ];
        case 'saturation':
            var noSat = $87b12e2e7973c4f3$var$IroColor.hsvToHsl({
                h: hsv.h,
                s: 0,
                v: hsv.v
            });
            var fullSat = $87b12e2e7973c4f3$var$IroColor.hsvToHsl({
                h: hsv.h,
                s: 100,
                v: hsv.v
            });
            return [
                [
                    0,
                    "hsl(" + noSat.h + "," + noSat.s + "%," + noSat.l + "%)"
                ],
                [
                    100,
                    "hsl(" + fullSat.h + "," + fullSat.s + "%," + fullSat.l + "%)"
                ]
            ];
        case 'value':
        default:
            var hsl = $87b12e2e7973c4f3$var$IroColor.hsvToHsl({
                h: hsv.h,
                s: hsv.s,
                v: 100
            });
            return [
                [
                    0,
                    '#000'
                ],
                [
                    100,
                    "hsl(" + hsl.h + "," + hsl.s + "%," + hsl.l + "%)"
                ]
            ];
    }
}
var $87b12e2e7973c4f3$var$TAU = Math.PI * 2; // javascript's modulo operator doesn't produce positive numbers with negative input
// https://dev.to/maurobringolf/a-neat-trick-to-compute-modulo-of-negative-numbers-111e
var $87b12e2e7973c4f3$var$mod = function mod(a, n) {
    return (a % n + n) % n;
}; // distance between points (x, y) and (0, 0)
var $87b12e2e7973c4f3$var$dist = function dist(x, y) {
    return Math.sqrt(x * x + y * y);
};
/**
 * @param props - wheel props
 * @internal
 */ function $87b12e2e7973c4f3$var$getHandleRange(props) {
    return props.width / 2 - props.padding - props.handleRadius - props.borderWidth;
}
/**
 * Returns true if point (x, y) lands inside the wheel
 * @param props - wheel props
 * @param x
 * @param y
 */ function $87b12e2e7973c4f3$var$isInputInsideWheel(props, x, y) {
    var _getWheelDimensions = $87b12e2e7973c4f3$var$getWheelDimensions(props), cx = _getWheelDimensions.cx, cy = _getWheelDimensions.cy;
    var r = props.width / 2;
    return $87b12e2e7973c4f3$var$dist(cx - x, cy - y) < r;
}
/**
 * @desc Get the point as the center of the wheel
 * @param props - wheel props
 */ function $87b12e2e7973c4f3$var$getWheelDimensions(props) {
    var r = props.width / 2;
    return {
        width: props.width,
        radius: r - props.borderWidth,
        cx: r,
        cy: r
    };
}
/**
 * @desc Translate an angle according to wheelAngle and wheelDirection
 * @param props - wheel props
 * @param angle - input angle
 */ function $87b12e2e7973c4f3$var$translateWheelAngle(props, angle, invert) {
    var wheelAngle = props.wheelAngle;
    var wheelDirection = props.wheelDirection; // inverted and clockwisee
    if (invert && wheelDirection === 'clockwise') angle = wheelAngle + angle;
    else if (wheelDirection === 'clockwise') angle = 360 - wheelAngle + angle;
    else if (invert && wheelDirection === 'anticlockwise') angle = wheelAngle + 180 - angle;
    else if (wheelDirection === 'anticlockwise') angle = wheelAngle - angle;
    return $87b12e2e7973c4f3$var$mod(angle, 360);
}
/**
 * @desc Get the current handle position for a given color
 * @param props - wheel props
 * @param color
 */ function $87b12e2e7973c4f3$var$getWheelHandlePosition(props, color) {
    var hsv = color.hsv;
    var _getWheelDimensions2 = $87b12e2e7973c4f3$var$getWheelDimensions(props), cx = _getWheelDimensions2.cx, cy = _getWheelDimensions2.cy;
    var handleRange = $87b12e2e7973c4f3$var$getHandleRange(props);
    var handleAngle = (180 + $87b12e2e7973c4f3$var$translateWheelAngle(props, hsv.h, true)) * ($87b12e2e7973c4f3$var$TAU / 360);
    var handleDist = hsv.s / 100 * handleRange;
    var direction = props.wheelDirection === 'clockwise' ? -1 : 1;
    return {
        x: cx + handleDist * Math.cos(handleAngle) * direction,
        y: cy + handleDist * Math.sin(handleAngle) * direction
    };
}
/**
 * @desc Get the current wheel value from user input
 * @param props - wheel props
 * @param x - global input x position
 * @param y - global input y position
 */ function $87b12e2e7973c4f3$var$getWheelValueFromInput(props, x, y) {
    var _getWheelDimensions3 = $87b12e2e7973c4f3$var$getWheelDimensions(props), cx = _getWheelDimensions3.cx, cy = _getWheelDimensions3.cy;
    var handleRange = $87b12e2e7973c4f3$var$getHandleRange(props);
    x = cx - x;
    y = cy - y; // Calculate the hue by converting the angle to radians
    var hue = $87b12e2e7973c4f3$var$translateWheelAngle(props, Math.atan2(-y, -x) * (360 / $87b12e2e7973c4f3$var$TAU)); // Find the point's distance from the center of the wheel
    // This is used to show the saturation level
    var handleDist = Math.min($87b12e2e7973c4f3$var$dist(x, y), handleRange);
    return {
        h: Math.round(hue),
        s: Math.round(100 / handleRange * handleDist)
    };
}
/**
 * @desc Get the bounding dimensions of the box
 * @param props - box props
 */ function $87b12e2e7973c4f3$var$getBoxDimensions(props) {
    var width = props.width, boxHeight = props.boxHeight, padding = props.padding, handleRadius = props.handleRadius;
    return {
        width: width,
        height: boxHeight != null ? boxHeight : width,
        radius: padding + handleRadius
    };
}
/**
 * @desc Get the current box value from user input
 * @param props - box props
 * @param x - global input x position
 * @param y - global input y position
 */ function $87b12e2e7973c4f3$var$getBoxValueFromInput(props, x, y) {
    var _getBoxDimensions = $87b12e2e7973c4f3$var$getBoxDimensions(props), width = _getBoxDimensions.width, height = _getBoxDimensions.height, radius = _getBoxDimensions.radius;
    var handleStart = radius;
    var handleRangeX = width - radius * 2;
    var handleRangeY = height - radius * 2;
    var percentX = (x - handleStart) / handleRangeX * 100;
    var percentY = (y - handleStart) / handleRangeY * 100;
    return {
        s: Math.max(0, Math.min(percentX, 100)),
        v: Math.max(0, Math.min(100 - percentY, 100))
    };
}
/**
 * @desc Get the current box handle position for a given color
 * @param props - box props
 * @param color
 */ function $87b12e2e7973c4f3$var$getBoxHandlePosition(props, color) {
    var _getBoxDimensions2 = $87b12e2e7973c4f3$var$getBoxDimensions(props), width = _getBoxDimensions2.width, height = _getBoxDimensions2.height, radius = _getBoxDimensions2.radius;
    var hsv = color.hsv;
    var handleStart = radius;
    var handleRangeX = width - radius * 2;
    var handleRangeY = height - radius * 2;
    return {
        x: handleStart + hsv.s / 100 * handleRangeX,
        y: handleStart + (handleRangeY - hsv.v / 100 * handleRangeY)
    };
}
/**
 * @desc Get the gradient stops for a box
 * @param props - box props
 * @param color
 */ function $87b12e2e7973c4f3$var$getBoxGradients(props, color) {
    var hue = color.hue;
    return [
        [
            [
                0,
                '#fff'
            ],
            [
                100,
                "hsl(" + hue + ",100%,50%)"
            ]
        ],
        [
            [
                0,
                'rgba(0,0,0,0)'
            ],
            [
                100,
                '#000'
            ]
        ]
    ];
}
// Keep track of html <base> elements for resolveSvgUrl
// getElementsByTagName returns a live HTMLCollection, which stays in sync with the DOM tree
// So it only needs to be called once
var $87b12e2e7973c4f3$var$BASE_ELEMENTS;
/**
 * @desc Resolve an SVG reference URL
 * This is required to work around how Safari and iOS webviews handle gradient URLS under certain conditions
 * If a page is using a client-side routing library which makes use of the HTML <base> tag,
 * Safari won't be able to render SVG gradients properly (as they are referenced by URLs)
 * More info on the problem:
 * https://stackoverflow.com/questions/19742805/angular-and-svg-filters/19753427#19753427
 * https://github.com/jaames/iro.js/issues/18
 * https://github.com/jaames/iro.js/issues/45
 * https://github.com/jaames/iro.js/pull/89
 * @props url - SVG reference URL
 */ function $87b12e2e7973c4f3$var$resolveSvgUrl(url) {
    if (!$87b12e2e7973c4f3$var$BASE_ELEMENTS) $87b12e2e7973c4f3$var$BASE_ELEMENTS = document.getElementsByTagName('base');
     // Sniff useragent string to check if the user is running Safari
    var ua = window.navigator.userAgent;
    var isSafari = /^((?!chrome|android).)*safari/i.test(ua);
    var isIos = /iPhone|iPod|iPad/i.test(ua);
    var location = window.location;
    return (isSafari || isIos) && $87b12e2e7973c4f3$var$BASE_ELEMENTS.length > 0 ? location.protocol + "//" + location.host + location.pathname + location.search + url : url;
}
/**
 * @desc Given a specifc (x, y) position, test if there's a handle there and return its index, else return null.
 *       This is used for components like the box and wheel which support multiple handles when multicolor is active
 * @props x - point x position
 * @props y - point y position
 * @props handlePositions - array of {x, y} coords for each handle
 */ function $87b12e2e7973c4f3$var$getHandleAtPoint(props, x, y, handlePositions) {
    for(var i = 0; i < handlePositions.length; i++){
        var dX = handlePositions[i].x - x;
        var dY = handlePositions[i].y - y;
        var dist = Math.sqrt(dX * dX + dY * dY);
        if (dist < props.handleRadius) return i;
    }
    return null;
}
function $87b12e2e7973c4f3$var$cssBorderStyles(props) {
    return {
        boxSizing: 'border-box',
        border: props.borderWidth + "px solid " + props.borderColor
    };
}
function $87b12e2e7973c4f3$var$cssGradient(type, direction, stops) {
    return type + "-gradient(" + direction + ", " + stops.map(function(_ref) {
        var o = _ref[0], col = _ref[1];
        return col + " " + o + "%";
    }).join(',') + ")";
}
function $87b12e2e7973c4f3$var$cssValue(value) {
    if (typeof value === 'string') return value;
    return value + "px";
}
var $87b12e2e7973c4f3$var$iroColorPickerOptionDefaults = {
    width: 300,
    height: 300,
    color: '#fff',
    colors: [],
    padding: 6,
    layoutDirection: 'vertical',
    borderColor: '#fff',
    borderWidth: 0,
    handleRadius: 8,
    activeHandleRadius: null,
    handleSvg: null,
    handleProps: {
        x: 0,
        y: 0
    },
    wheelLightness: true,
    wheelAngle: 0,
    wheelDirection: 'anticlockwise',
    sliderSize: null,
    sliderMargin: 12,
    boxHeight: null
};
var $87b12e2e7973c4f3$var$SECONDARY_EVENTS = [
    "mousemove" /* MouseMove */ ,
    "touchmove" /* TouchMove */ ,
    "mouseup" /* MouseUp */ ,
    "touchend" /* TouchEnd */ 
];
// Base component class for iro UI components
// This extends the Preact component class to allow them to react to mouse/touch input events by themselves
var $87b12e2e7973c4f3$var$IroComponentWrapper = /*@__PURE__*/ function(Component) {
    function IroComponentWrapper(props) {
        Component.call(this, props);
        // Generate unique ID for the component
        // This can be used to generate unique IDs for gradients, etc
        this.uid = (Math.random() + 1).toString(36).substring(5);
    }
    if (Component) IroComponentWrapper.__proto__ = Component;
    IroComponentWrapper.prototype = Object.create(Component && Component.prototype);
    IroComponentWrapper.prototype.constructor = IroComponentWrapper;
    IroComponentWrapper.prototype.render = function render(props) {
        var eventHandler = this.handleEvent.bind(this);
        var rootProps = {
            onMouseDown: eventHandler,
            // https://github.com/jaames/iro.js/issues/126
            // https://github.com/preactjs/preact/issues/2113#issuecomment-553408767
            ontouchstart: eventHandler
        };
        var isHorizontal = props.layoutDirection === 'horizontal';
        var margin = props.margin === null ? props.sliderMargin : props.margin;
        var rootStyles = {
            overflow: 'visible',
            display: isHorizontal ? 'inline-block' : 'block'
        };
        // first component shouldn't have any margin
        if (props.index > 0) rootStyles[isHorizontal ? 'marginLeft' : 'marginTop'] = margin;
        return $87b12e2e7973c4f3$var$h($87b12e2e7973c4f3$var$d, null, props.children(this.uid, rootProps, rootStyles));
    };
    // More info on handleEvent:
    // https://medium.com/@WebReflection/dom-handleevent-a-cross-platform-standard-since-year-2000-5bf17287fd38
    // TL;DR this lets us have a single point of entry for multiple events, and we can avoid callback/binding hell
    IroComponentWrapper.prototype.handleEvent = function handleEvent(e) {
        var this$1 = this;
        var inputHandler = this.props.onInput;
        // Get the screen position of the component
        var bounds = this.base.getBoundingClientRect();
        // Prefect default browser action
        e.preventDefault();
        // Detect if the event is a touch event by checking if it has the `touches` property
        // If it is a touch event, use the first touch input
        var point = e.touches ? e.changedTouches[0] : e;
        var x = point.clientX - bounds.left;
        var y = point.clientY - bounds.top;
        switch(e.type){
            case "mousedown" /* MouseDown */ :
            case "touchstart" /* TouchStart */ :
                var result = inputHandler(x, y, 0 /* Start */ );
                if (result !== false) $87b12e2e7973c4f3$var$SECONDARY_EVENTS.forEach(function(event) {
                    document.addEventListener(event, this$1, {
                        passive: false
                    });
                });
                break;
            case "mousemove" /* MouseMove */ :
            case "touchmove" /* TouchMove */ :
                inputHandler(x, y, 1 /* Move */ );
                break;
            case "mouseup" /* MouseUp */ :
            case "touchend" /* TouchEnd */ :
                inputHandler(x, y, 2 /* End */ );
                $87b12e2e7973c4f3$var$SECONDARY_EVENTS.forEach(function(event) {
                    document.removeEventListener(event, this$1, {
                        passive: false
                    });
                });
                break;
        }
    };
    return IroComponentWrapper;
}($87b12e2e7973c4f3$var$m);
function $87b12e2e7973c4f3$var$IroHandle(props) {
    var radius = props.r;
    var url = props.url;
    var cx = radius;
    var cy = radius;
    return $87b12e2e7973c4f3$var$h("svg", {
        className: "IroHandle IroHandle--" + props.index + " " + (props.isActive ? 'IroHandle--isActive' : ''),
        style: {
            '-webkit-tap-highlight-color': 'rgba(0, 0, 0, 0);',
            transform: "translate(" + $87b12e2e7973c4f3$var$cssValue(props.x) + ", " + $87b12e2e7973c4f3$var$cssValue(props.y) + ")",
            willChange: 'transform',
            top: $87b12e2e7973c4f3$var$cssValue(-radius),
            left: $87b12e2e7973c4f3$var$cssValue(-radius),
            width: $87b12e2e7973c4f3$var$cssValue(radius * 2),
            height: $87b12e2e7973c4f3$var$cssValue(radius * 2),
            position: 'absolute',
            overflow: 'visible'
        }
    }, url && $87b12e2e7973c4f3$var$h("use", Object.assign({
        xlinkHref: $87b12e2e7973c4f3$var$resolveSvgUrl(url)
    }, props.props)), !url && $87b12e2e7973c4f3$var$h("circle", {
        cx: cx,
        cy: cy,
        r: radius,
        fill: "none",
        "stroke-width": 2,
        stroke: "#000"
    }), !url && $87b12e2e7973c4f3$var$h("circle", {
        cx: cx,
        cy: cy,
        r: radius - 2,
        fill: props.fill,
        "stroke-width": 2,
        stroke: "#fff"
    }));
}
$87b12e2e7973c4f3$var$IroHandle.defaultProps = {
    fill: 'none',
    x: 0,
    y: 0,
    r: 8,
    url: null,
    props: {
        x: 0,
        y: 0
    }
};
function $87b12e2e7973c4f3$var$IroSlider(props) {
    var activeIndex = props.activeIndex;
    var activeColor = activeIndex !== undefined && activeIndex < props.colors.length ? props.colors[activeIndex] : props.color;
    var ref = $87b12e2e7973c4f3$var$getSliderDimensions(props);
    var width = ref.width;
    var height = ref.height;
    var radius = ref.radius;
    var handlePos = $87b12e2e7973c4f3$var$getSliderHandlePosition(props, activeColor);
    var gradient = $87b12e2e7973c4f3$var$getSliderGradient(props, activeColor);
    function handleInput(x, y, type) {
        var value = $87b12e2e7973c4f3$var$getSliderValueFromInput(props, x, y);
        props.parent.inputActive = true;
        activeColor[props.sliderType] = value;
        props.onInput(type, props.id);
    }
    return $87b12e2e7973c4f3$var$h($87b12e2e7973c4f3$var$IroComponentWrapper, Object.assign({}, props, {
        onInput: handleInput
    }), function(uid, rootProps, rootStyles) {
        return $87b12e2e7973c4f3$var$h("div", Object.assign({}, rootProps, {
            className: "IroSlider",
            style: Object.assign({}, {
                position: 'relative',
                width: $87b12e2e7973c4f3$var$cssValue(width),
                height: $87b12e2e7973c4f3$var$cssValue(height),
                borderRadius: $87b12e2e7973c4f3$var$cssValue(radius),
                // checkered bg to represent alpha
                background: "conic-gradient(#ccc 25%, #fff 0 50%, #ccc 0 75%, #fff 0)",
                backgroundSize: '8px 8px'
            }, rootStyles)
        }), $87b12e2e7973c4f3$var$h("div", {
            className: "IroSliderGradient",
            style: Object.assign({}, {
                position: 'absolute',
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                borderRadius: $87b12e2e7973c4f3$var$cssValue(radius),
                background: $87b12e2e7973c4f3$var$cssGradient('linear', props.layoutDirection === 'horizontal' ? 'to top' : 'to right', gradient)
            }, $87b12e2e7973c4f3$var$cssBorderStyles(props))
        }), $87b12e2e7973c4f3$var$h($87b12e2e7973c4f3$var$IroHandle, {
            isActive: true,
            index: activeColor.index,
            r: props.handleRadius,
            url: props.handleSvg,
            props: props.handleProps,
            x: handlePos.x,
            y: handlePos.y
        }));
    });
}
$87b12e2e7973c4f3$var$IroSlider.defaultProps = Object.assign({}, $87b12e2e7973c4f3$var$sliderDefaultOptions);
function $87b12e2e7973c4f3$var$IroBox(props) {
    var ref = $87b12e2e7973c4f3$var$getBoxDimensions(props);
    var width = ref.width;
    var height = ref.height;
    var radius = ref.radius;
    var colors = props.colors;
    var colorPicker = props.parent;
    var activeIndex = props.activeIndex;
    var activeColor = activeIndex !== undefined && activeIndex < props.colors.length ? props.colors[activeIndex] : props.color;
    var gradients = $87b12e2e7973c4f3$var$getBoxGradients(props, activeColor);
    var handlePositions = colors.map(function(color) {
        return $87b12e2e7973c4f3$var$getBoxHandlePosition(props, color);
    });
    function handleInput(x, y, inputType) {
        if (inputType === 0 /* Start */ ) {
            // getHandleAtPoint() returns the index for the handle if the point 'hits' it, or null otherwise
            var activeHandle = $87b12e2e7973c4f3$var$getHandleAtPoint(props, x, y, handlePositions);
            // If the input hit a handle, set it as the active handle, but don't update the color
            if (activeHandle !== null) colorPicker.setActiveColor(activeHandle);
            else {
                colorPicker.inputActive = true;
                activeColor.hsv = $87b12e2e7973c4f3$var$getBoxValueFromInput(props, x, y);
                props.onInput(inputType, props.id);
            }
        } else if (inputType === 1 /* Move */ ) {
            colorPicker.inputActive = true;
            activeColor.hsv = $87b12e2e7973c4f3$var$getBoxValueFromInput(props, x, y);
        }
        // let the color picker fire input:start, input:move or input:end events
        props.onInput(inputType, props.id);
    }
    return $87b12e2e7973c4f3$var$h($87b12e2e7973c4f3$var$IroComponentWrapper, Object.assign({}, props, {
        onInput: handleInput
    }), function(uid, rootProps, rootStyles) {
        return $87b12e2e7973c4f3$var$h("div", Object.assign({}, rootProps, {
            className: "IroBox",
            style: Object.assign({}, {
                width: $87b12e2e7973c4f3$var$cssValue(width),
                height: $87b12e2e7973c4f3$var$cssValue(height),
                position: 'relative'
            }, rootStyles)
        }), $87b12e2e7973c4f3$var$h("div", {
            className: "IroBox",
            style: Object.assign({}, {
                width: '100%',
                height: '100%',
                borderRadius: $87b12e2e7973c4f3$var$cssValue(radius)
            }, $87b12e2e7973c4f3$var$cssBorderStyles(props), {
                background: $87b12e2e7973c4f3$var$cssGradient('linear', 'to bottom', gradients[1]) + ',' + $87b12e2e7973c4f3$var$cssGradient('linear', 'to right', gradients[0])
            })
        }), colors.filter(function(color) {
            return color !== activeColor;
        }).map(function(color) {
            return $87b12e2e7973c4f3$var$h($87b12e2e7973c4f3$var$IroHandle, {
                isActive: false,
                index: color.index,
                fill: color.hslString,
                r: props.handleRadius,
                url: props.handleSvg,
                props: props.handleProps,
                x: handlePositions[color.index].x,
                y: handlePositions[color.index].y
            });
        }), $87b12e2e7973c4f3$var$h($87b12e2e7973c4f3$var$IroHandle, {
            isActive: true,
            index: activeColor.index,
            fill: activeColor.hslString,
            r: props.activeHandleRadius || props.handleRadius,
            url: props.handleSvg,
            props: props.handleProps,
            x: handlePositions[activeColor.index].x,
            y: handlePositions[activeColor.index].y
        }));
    });
}
var $87b12e2e7973c4f3$var$HUE_GRADIENT_CLOCKWISE = 'conic-gradient(red, yellow, lime, aqua, blue, magenta, red)';
var $87b12e2e7973c4f3$var$HUE_GRADIENT_ANTICLOCKWISE = 'conic-gradient(red, magenta, blue, aqua, lime, yellow, red)';
function $87b12e2e7973c4f3$var$IroWheel(props) {
    var ref = $87b12e2e7973c4f3$var$getWheelDimensions(props);
    var width = ref.width;
    var colors = props.colors;
    var borderWidth = props.borderWidth;
    var colorPicker = props.parent;
    var activeColor = props.color;
    var hsv = activeColor.hsv;
    var handlePositions = colors.map(function(color) {
        return $87b12e2e7973c4f3$var$getWheelHandlePosition(props, color);
    });
    var circleStyles = {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        boxSizing: 'border-box'
    };
    function handleInput(x, y, inputType) {
        if (inputType === 0 /* Start */ ) {
            // input hitbox is a square, 
            // so we want to ignore any initial clicks outside the circular shape of the wheel
            if (!$87b12e2e7973c4f3$var$isInputInsideWheel(props, x, y)) // returning false will cease all event handling for this interaction
            return false;
            // getHandleAtPoint() returns the index for the handle if the point 'hits' it, or null otherwise
            var activeHandle = $87b12e2e7973c4f3$var$getHandleAtPoint(props, x, y, handlePositions);
            // If the input hit a handle, set it as the active handle, but don't update the color
            if (activeHandle !== null) colorPicker.setActiveColor(activeHandle);
            else {
                colorPicker.inputActive = true;
                activeColor.hsv = $87b12e2e7973c4f3$var$getWheelValueFromInput(props, x, y);
                props.onInput(inputType, props.id);
            }
        } else if (inputType === 1 /* Move */ ) {
            colorPicker.inputActive = true;
            activeColor.hsv = $87b12e2e7973c4f3$var$getWheelValueFromInput(props, x, y);
        }
        // let the color picker fire input:start, input:move or input:end events
        props.onInput(inputType, props.id);
    }
    return $87b12e2e7973c4f3$var$h($87b12e2e7973c4f3$var$IroComponentWrapper, Object.assign({}, props, {
        onInput: handleInput
    }), function(uid, rootProps, rootStyles) {
        return $87b12e2e7973c4f3$var$h("div", Object.assign({}, rootProps, {
            className: "IroWheel",
            style: Object.assign({}, {
                width: $87b12e2e7973c4f3$var$cssValue(width),
                height: $87b12e2e7973c4f3$var$cssValue(width),
                position: 'relative'
            }, rootStyles)
        }), $87b12e2e7973c4f3$var$h("div", {
            className: "IroWheelHue",
            style: Object.assign({}, circleStyles, {
                transform: "rotateZ(" + (props.wheelAngle + 90) + "deg)",
                background: props.wheelDirection === 'clockwise' ? $87b12e2e7973c4f3$var$HUE_GRADIENT_CLOCKWISE : $87b12e2e7973c4f3$var$HUE_GRADIENT_ANTICLOCKWISE
            })
        }), $87b12e2e7973c4f3$var$h("div", {
            className: "IroWheelSaturation",
            style: Object.assign({}, circleStyles, {
                background: 'radial-gradient(circle closest-side, #fff, transparent)'
            })
        }), props.wheelLightness && $87b12e2e7973c4f3$var$h("div", {
            className: "IroWheelLightness",
            style: Object.assign({}, circleStyles, {
                background: '#000',
                opacity: 1 - hsv.v / 100
            })
        }), $87b12e2e7973c4f3$var$h("div", {
            className: "IroWheelBorder",
            style: Object.assign({}, circleStyles, $87b12e2e7973c4f3$var$cssBorderStyles(props))
        }), colors.filter(function(color) {
            return color !== activeColor;
        }).map(function(color) {
            return $87b12e2e7973c4f3$var$h($87b12e2e7973c4f3$var$IroHandle, {
                isActive: false,
                index: color.index,
                fill: color.hslString,
                r: props.handleRadius,
                url: props.handleSvg,
                props: props.handleProps,
                x: handlePositions[color.index].x,
                y: handlePositions[color.index].y
            });
        }), $87b12e2e7973c4f3$var$h($87b12e2e7973c4f3$var$IroHandle, {
            isActive: true,
            index: activeColor.index,
            fill: activeColor.hslString,
            r: props.activeHandleRadius || props.handleRadius,
            url: props.handleSvg,
            props: props.handleProps,
            x: handlePositions[activeColor.index].x,
            y: handlePositions[activeColor.index].y
        }));
    });
}
function $87b12e2e7973c4f3$var$createWidget(WidgetComponent) {
    var widgetFactory = function(parent, props) {
        var widget; // will become an instance of the widget component class
        var widgetRoot = document.createElement('div');
        // Render widget into a temp DOM node
        $87b12e2e7973c4f3$var$I($87b12e2e7973c4f3$var$h(WidgetComponent, Object.assign({}, {
            ref: function(ref) {
                return widget = ref;
            }
        }, props)), widgetRoot);
        function mountWidget() {
            var container = parent instanceof Element ? parent : document.querySelector(parent);
            container.appendChild(widget.base);
            widget.onMount(container);
        }
        // Mount it into the DOM when the page document is ready
        if (document.readyState !== 'loading') mountWidget();
        else document.addEventListener('DOMContentLoaded', mountWidget);
        return widget;
    };
    // Allow the widget factory to inherit component prototype + static class methods
    // This makes it easier for plugin authors to extend the base widget component
    widgetFactory.prototype = WidgetComponent.prototype;
    Object.assign(widgetFactory, WidgetComponent);
    // Add reference to base component too
    widgetFactory.__component = WidgetComponent;
    return widgetFactory;
}
var $87b12e2e7973c4f3$var$IroColorPicker = /*@__PURE__*/ function(Component) {
    function IroColorPicker(props) {
        var this$1 = this;
        Component.call(this, props);
        this.colors = [];
        this.inputActive = false;
        this.events = {};
        this.activeEvents = {};
        this.deferredEvents = {};
        this.id = props.id;
        var colors = props.colors.length > 0 ? props.colors : [
            props.color
        ];
        colors.forEach(function(colorValue) {
            return this$1.addColor(colorValue);
        });
        this.setActiveColor(0);
        // Pass all the props into the component's state,
        // Except we want to add the color object and make sure that refs aren't passed down to children
        this.state = Object.assign({}, props, {
            color: this.color,
            colors: this.colors,
            layout: props.layout
        });
    }
    if (Component) IroColorPicker.__proto__ = Component;
    IroColorPicker.prototype = Object.create(Component && Component.prototype);
    IroColorPicker.prototype.constructor = IroColorPicker;
    // Plubic multicolor API
    /**
    * @desc Add a color to the color picker
    * @param color new color to add
    * @param index optional color index
    */ IroColorPicker.prototype.addColor = function addColor(color, index) {
        if (index === void 0) index = this.colors.length;
        // Create a new iro.Color
        // Also bind it to onColorChange, so whenever the color changes it updates the color picker
        var newColor = new $87b12e2e7973c4f3$var$IroColor(color, this.onColorChange.bind(this));
        // Insert color @ the given index
        this.colors.splice(index, 0, newColor);
        // Reindex colors
        this.colors.forEach(function(color, index) {
            return color.index = index;
        });
        // Update picker state if necessary
        if (this.state) this.setState({
            colors: this.colors
        });
        // Fire color init event
        this.deferredEmit('color:init', newColor);
    };
    /**
     * @desc Remove a color from the color picker
     * @param index color index
     */ IroColorPicker.prototype.removeColor = function removeColor(index) {
        var color = this.colors.splice(index, 1)[0];
        // Destroy the color object -- this unbinds it from the color picker
        color.unbind();
        // Reindex colors
        this.colors.forEach(function(color, index) {
            return color.index = index;
        });
        // Update picker state if necessary
        if (this.state) this.setState({
            colors: this.colors
        });
        // If the active color was removed, default active color to 0
        if (color.index === this.color.index) this.setActiveColor(0);
        // Fire color remove event
        this.emit('color:remove', color);
    };
    /**
     * @desc Set the currently active color
     * @param index color index
     */ IroColorPicker.prototype.setActiveColor = function setActiveColor(index) {
        this.color = this.colors[index];
        if (this.state) this.setState({
            color: this.color
        });
        // Fire color switch event
        this.emit('color:setActive', this.color);
    };
    /**
     * @desc Replace all of the current colorPicker colors
     * @param newColorValues list of new colors to add
     */ IroColorPicker.prototype.setColors = function setColors(newColorValues, activeColorIndex) {
        var this$1 = this;
        if (activeColorIndex === void 0) activeColorIndex = 0;
        // Unbind color events
        this.colors.forEach(function(color) {
            return color.unbind();
        });
        // Destroy old colors
        this.colors = [];
        // Add new colors
        newColorValues.forEach(function(colorValue) {
            return this$1.addColor(colorValue);
        });
        // Reset active color
        this.setActiveColor(activeColorIndex);
        this.emit('color:setAll', this.colors);
    };
    // Public ColorPicker events API
    /**
     * @desc Set a callback function for an event
     * @param eventList event(s) to listen to
     * @param callback - Function called when the event is fired
     */ IroColorPicker.prototype.on = function on(eventList, callback) {
        var this$1 = this;
        var events = this.events;
        // eventList can be an eventType string or an array of eventType strings
        (!Array.isArray(eventList) ? [
            eventList
        ] : eventList).forEach(function(eventType) {
            // Add event callback
            (events[eventType] || (events[eventType] = [])).push(callback);
            // Call deferred events
            // These are events that can be stored until a listener for them is added
            if (this$1.deferredEvents[eventType]) {
                // Deffered events store an array of arguments from when the event was called
                this$1.deferredEvents[eventType].forEach(function(args) {
                    callback.apply(null, args);
                });
                // Clear deferred events
                this$1.deferredEvents[eventType] = [];
            }
        });
    };
    /**
     * @desc Remove a callback function for an event added with on()
     * @param eventList - event(s) to listen to
     * @param callback - original callback function to remove
     */ IroColorPicker.prototype.off = function off(eventList, callback) {
        var this$1 = this;
        (!Array.isArray(eventList) ? [
            eventList
        ] : eventList).forEach(function(eventType) {
            var callbackList = this$1.events[eventType];
            // this.emitHook('event:off', eventType, callback);
            if (callbackList) callbackList.splice(callbackList.indexOf(callback), 1);
        });
    };
    /**
     * @desc Emit an event
     * @param eventType event to emit
     */ IroColorPicker.prototype.emit = function emit(eventType) {
        var this$1 = this;
        var args = [], len = arguments.length - 1;
        while(len-- > 0)args[len] = arguments[len + 1];
        var activeEvents = this.activeEvents;
        var isEventActive = activeEvents.hasOwnProperty(eventType) ? activeEvents[eventType] : false;
        // Prevent event callbacks from firing if the event is already active
        // This stops infinite loops if something in an event callback causes the same event to be fired again
        // (e.g. setting the color inside a color:change callback)
        if (!isEventActive) {
            activeEvents[eventType] = true;
            var callbackList = this.events[eventType] || [];
            callbackList.forEach(function(fn) {
                return fn.apply(this$1, args);
            });
            activeEvents[eventType] = false;
        }
    };
    /**
     * @desc Emit an event now, or save it for when the relevent event listener is added
     * @param eventType - The name of the event to emit
     */ IroColorPicker.prototype.deferredEmit = function deferredEmit(eventType) {
        var ref;
        var args = [], len = arguments.length - 1;
        while(len-- > 0)args[len] = arguments[len + 1];
        var deferredEvents = this.deferredEvents;
        (ref = this).emit.apply(ref, [
            eventType
        ].concat(args));
        (deferredEvents[eventType] || (deferredEvents[eventType] = [])).push(args);
    };
    // Public utility methods
    IroColorPicker.prototype.setOptions = function setOptions(newOptions) {
        this.setState(newOptions);
    };
    /**
     * @desc Resize the color picker
     * @param width - new width
     */ IroColorPicker.prototype.resize = function resize(width) {
        this.setOptions({
            width: width
        });
    };
    /**
     * @desc Reset the color picker to the initial color provided in the color picker options
     */ IroColorPicker.prototype.reset = function reset() {
        this.colors.forEach(function(color) {
            return color.reset();
        });
        this.setState({
            colors: this.colors
        });
    };
    /**
     * @desc Called by the createWidget wrapper when the element is mounted into the page
     * @param container - the container element for this ColorPicker instance
     */ IroColorPicker.prototype.onMount = function onMount(container) {
        this.el = container;
        this.deferredEmit('mount', this);
    };
    // Internal methods
    /**
     * @desc React to a color update
     * @param color - current color
     * @param changes - shows which h,s,v,a color channels changed
     */ IroColorPicker.prototype.onColorChange = function onColorChange(color, changes) {
        this.setState({
            color: this.color
        });
        if (this.inputActive) {
            this.inputActive = false;
            this.emit('input:change', color, changes);
        }
        this.emit('color:change', color, changes);
    };
    /**
     * @desc Handle input from a UI control element
     * @param type - event type
     */ IroColorPicker.prototype.emitInputEvent = function emitInputEvent(type, originId) {
        if (type === 0 /* Start */ ) this.emit('input:start', this.color, originId);
        else if (type === 1 /* Move */ ) this.emit('input:move', this.color, originId);
        else if (type === 2 /* End */ ) this.emit('input:end', this.color, originId);
    };
    IroColorPicker.prototype.render = function render(props, state) {
        var this$1 = this;
        var layout = state.layout;
        // use layout shorthands
        if (!Array.isArray(layout)) {
            layout;
            layout = [
                {
                    component: $87b12e2e7973c4f3$var$IroWheel
                },
                {
                    component: $87b12e2e7973c4f3$var$IroSlider
                }
            ];
            // add transparency slider to the layout
            if (state.transparency) layout.push({
                component: $87b12e2e7973c4f3$var$IroSlider,
                options: {
                    sliderType: 'alpha'
                }
            });
        }
        return $87b12e2e7973c4f3$var$h("div", {
            class: "IroColorPicker",
            id: state.id,
            style: {
                display: state.display
            }
        }, layout.map(function(ref, componentIndex) {
            var UiComponent = ref.component;
            var options = ref.options;
            return $87b12e2e7973c4f3$var$h(UiComponent, Object.assign({}, state, options, {
                ref: undefined,
                onInput: this$1.emitInputEvent.bind(this$1),
                parent: this$1,
                index: componentIndex
            }));
        }));
    };
    return IroColorPicker;
}($87b12e2e7973c4f3$var$m);
$87b12e2e7973c4f3$var$IroColorPicker.defaultProps = Object.assign({}, $87b12e2e7973c4f3$var$iroColorPickerOptionDefaults, {
    colors: [],
    display: 'block',
    id: null,
    layout: 'default',
    margin: null
});
var $87b12e2e7973c4f3$var$IroColorPickerWidget = $87b12e2e7973c4f3$var$createWidget($87b12e2e7973c4f3$var$IroColorPicker);
var $87b12e2e7973c4f3$var$iro;
(function(iro) {
    iro.version = "5.5.2"; // replaced by @rollup/plugin-replace; see rollup.config.js
    iro.Color = $87b12e2e7973c4f3$var$IroColor;
    iro.ColorPicker = $87b12e2e7973c4f3$var$IroColorPickerWidget;
    var ui;
    (function(ui) {
        ui.h = $87b12e2e7973c4f3$var$h;
        ui.ComponentBase = $87b12e2e7973c4f3$var$IroComponentWrapper;
        ui.Handle = $87b12e2e7973c4f3$var$IroHandle;
        ui.Slider = $87b12e2e7973c4f3$var$IroSlider;
        ui.Wheel = $87b12e2e7973c4f3$var$IroWheel;
        ui.Box = $87b12e2e7973c4f3$var$IroBox;
    })(ui = iro.ui || (iro.ui = {}));
})($87b12e2e7973c4f3$var$iro || ($87b12e2e7973c4f3$var$iro = {}));
var $87b12e2e7973c4f3$var$iro$1 = $87b12e2e7973c4f3$var$iro;
var $87b12e2e7973c4f3$export$2e2bcd8739ae039 = $87b12e2e7973c4f3$var$iro$1;

});


parcelRegister("l52Gj", function(module, exports) {
"use strict";

});

parcelRegister("aBK2w", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b91129824bcdcdc$export$2e2bcd8739ae039);

var $c2vEo = parcelRequire("c2vEo");

var $lj0Uy = parcelRequire("lj0Uy");

var $k0HGJ = parcelRequire("k0HGJ");

var $71Fw5 = parcelRequire("71Fw5");

var $e9JMe = parcelRequire("e9JMe");

var $gWGql = parcelRequire("gWGql");

var $1bZ3M = parcelRequire("1bZ3M");

var $hS85A = parcelRequire("hS85A");

var $dopqb = parcelRequire("dopqb");

var $i3udl = parcelRequire("i3udl");

var $1WwLQ = parcelRequire("1WwLQ");

var $6Okcm = parcelRequire("6Okcm");

var $UtFnU = parcelRequire("UtFnU");

var $1M5DR = parcelRequire("1M5DR");

var $ltGnr = parcelRequire("ltGnr");

var $6wBAW = parcelRequire("6wBAW");

var $72gZ3 = parcelRequire("72gZ3");

var $5PJkd = parcelRequire("5PJkd");

var $7VTjX = parcelRequire("7VTjX");

var $lKALb = parcelRequire("lKALb");

var $W91pZ = parcelRequire("W91pZ");

var $ipVZD = parcelRequire("ipVZD");

var $3GLge = parcelRequire("3GLge");

var $04AhF = parcelRequire("04AhF");

var $lgElq = parcelRequire("lgElq");

var $4bKc2 = parcelRequire("4bKc2");

var $ilcQW = parcelRequire("ilcQW");

var $hnVID = parcelRequire("hnVID");

var $kHULU = parcelRequire("kHULU");

var $7rjsX = parcelRequire("7rjsX");

var $9qeMZ = parcelRequire("9qeMZ");
(0, $c2vEo.default).register({
    'attributors/attribute/direction': (0, $k0HGJ.DirectionAttribute),
    'attributors/class/align': (0, $lj0Uy.AlignClass),
    'attributors/class/background': (0, $hS85A.BackgroundClass),
    'attributors/class/color': (0, $dopqb.ColorClass),
    'attributors/class/direction': (0, $k0HGJ.DirectionClass),
    'attributors/class/font': (0, $i3udl.FontClass),
    'attributors/class/size': (0, $1WwLQ.SizeClass),
    'attributors/style/align': (0, $lj0Uy.AlignStyle),
    'attributors/style/background': (0, $hS85A.BackgroundStyle),
    'attributors/style/color': (0, $dopqb.ColorStyle),
    'attributors/style/direction': (0, $k0HGJ.DirectionStyle),
    'attributors/style/font': (0, $i3udl.FontStyle),
    'attributors/style/size': (0, $1WwLQ.SizeStyle)
}, true);
(0, $c2vEo.default).register({
    'formats/align': (0, $lj0Uy.AlignClass),
    'formats/direction': (0, $k0HGJ.DirectionClass),
    'formats/indent': (0, $71Fw5.default),
    'formats/background': (0, $hS85A.BackgroundStyle),
    'formats/color': (0, $dopqb.ColorStyle),
    'formats/font': (0, $i3udl.FontClass),
    'formats/size': (0, $1WwLQ.SizeClass),
    'formats/blockquote': (0, $e9JMe.default),
    'formats/code-block': (0, $W91pZ.default),
    'formats/header': (0, $gWGql.default),
    'formats/list': (0, $1bZ3M.default),
    'formats/bold': (0, $6Okcm.default),
    'formats/code': (0, $W91pZ.Code),
    'formats/italic': (0, $UtFnU.default),
    'formats/link': (0, $1M5DR.default),
    'formats/script': (0, $ltGnr.default),
    'formats/strike': (0, $6wBAW.default),
    'formats/underline': (0, $72gZ3.default),
    'formats/formula': (0, $5PJkd.default),
    'formats/image': (0, $7VTjX.default),
    'formats/video': (0, $lKALb.default),
    'modules/syntax': (0, $ipVZD.default),
    'modules/table': (0, $3GLge.default),
    'modules/toolbar': (0, $04AhF.default),
    'themes/bubble': (0, $7rjsX.default),
    'themes/snow': (0, $9qeMZ.default),
    'ui/icons': (0, $lgElq.default),
    'ui/picker': (0, $4bKc2.default),
    'ui/icon-picker': (0, $hnVID.default),
    'ui/color-picker': (0, $ilcQW.default),
    'ui/tooltip': (0, $kHULU.default)
}, true);
var $7b91129824bcdcdc$export$2e2bcd8739ae039 = (0, $c2vEo.default);

});
parcelRegister("c2vEo", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c3e3915228c993b$export$2e2bcd8739ae039);

var $ePuKS = parcelRequire("ePuKS");

var $jUBfi = parcelRequire("jUBfi");

var $gkqQr = parcelRequire("gkqQr");

var $BNn3z = parcelRequire("BNn3z");

var $9VFAE = parcelRequire("9VFAE");

var $jqZQb = parcelRequire("jqZQb");

var $95m1U = parcelRequire("95m1U");

var $4BsTF = parcelRequire("4BsTF");

var $l6ueR = parcelRequire("l6ueR");

var $jQ3Vn = parcelRequire("jQ3Vn");

var $ecT31 = parcelRequire("ecT31");

var $c7x7B = parcelRequire("c7x7B");

var $9LWxB = parcelRequire("9LWxB");

var $ehD63 = parcelRequire("ehD63");

var $h2b1E = parcelRequire("h2b1E");

var $2qoCa = parcelRequire("2qoCa");

var $43smM = parcelRequire("43smM");
(0, $ePuKS.default).register({
    'blots/block': (0, $jUBfi.default),
    'blots/block/embed': (0, $jUBfi.BlockEmbed),
    'blots/break': (0, $gkqQr.default),
    'blots/container': (0, $BNn3z.default),
    'blots/cursor': (0, $9VFAE.default),
    'blots/embed': (0, $jqZQb.default),
    'blots/inline': (0, $95m1U.default),
    'blots/scroll': (0, $4BsTF.default),
    'blots/text': (0, $l6ueR.default),
    'modules/clipboard': (0, $jQ3Vn.default),
    'modules/history': (0, $ecT31.default),
    'modules/keyboard': (0, $c7x7B.default),
    'modules/uploader': (0, $9LWxB.default),
    'modules/input': (0, $h2b1E.default),
    'modules/uiNode': (0, $2qoCa.default)
});
var $8c3e3915228c993b$export$2e2bcd8739ae039 = (0, $ePuKS.default);

});
parcelRegister("ePuKS", function(module, exports) {

$parcel$export(module.exports, "default", () => $acbdaf6ec67cab2c$export$2e2bcd8739ae039);

var $jjgrT = parcelRequire("jjgrT");

var $45gdf = parcelRequire("45gdf");

var $ehD63 = parcelRequire("ehD63");

var $aRNA0 = parcelRequire("aRNA0");

var $hJr1g = parcelRequire("hJr1g");

var $315Gv = parcelRequire("315Gv");

var $dwJXH = parcelRequire("dwJXH");

var $43smM = parcelRequire("43smM");

var $6EzZS = parcelRequire("6EzZS");

var $C3M1D = parcelRequire("C3M1D");

var $8ioPK = parcelRequire("8ioPK");

var $2tdRQ = parcelRequire("2tdRQ");

var $5bW5Y = parcelRequire("5bW5Y");
const $acbdaf6ec67cab2c$var$debug = (0, $dwJXH.default)('quill');
const $acbdaf6ec67cab2c$export$bc58ce2776ecdb6f = new $45gdf.Registry();
$45gdf.ParentBlot.uiClass = 'ql-ui';
/**
 * Options for initializing a Quill instance
 */ /**
 * Similar to QuillOptions, but with all properties expanded to their default values,
 * and all selectors resolved to HTMLElements.
 */ class $acbdaf6ec67cab2c$export$2e2bcd8739ae039 {
    static DEFAULTS = {
        bounds: null,
        modules: {
            clipboard: true,
            keyboard: true,
            history: true,
            uploader: true
        },
        placeholder: '',
        readOnly: false,
        registry: $acbdaf6ec67cab2c$export$bc58ce2776ecdb6f,
        theme: 'default'
    };
    static events = (0, $hJr1g.default).events;
    static sources = (0, $hJr1g.default).sources;
    static version = "2.0.3";
    static imports = {
        delta: (0, (/*@__PURE__*/$parcel$interopDefault($ehD63))),
        parchment: $45gdf,
        'core/module': (0, $43smM.default),
        'core/theme': (0, $8ioPK.default)
    };
    static debug(limit) {
        if (limit === true) limit = 'log';
        (0, $dwJXH.default).level(limit);
    }
    static find(node) {
        let bubble = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return (0, $315Gv.default).get(node) || $acbdaf6ec67cab2c$export$bc58ce2776ecdb6f.find(node, bubble);
    }
    static import(name) {
        if (this.imports[name] == null) $acbdaf6ec67cab2c$var$debug.error(`Cannot import ${name}. Are you sure it was registered?`);
        return this.imports[name];
    }
    static register() {
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) !== 'string') {
            const target = arguments.length <= 0 ? undefined : arguments[0];
            const overwrite = !!(arguments.length <= 1 ? undefined : arguments[1]);
            const name = 'attrName' in target ? target.attrName : target.blotName;
            if (typeof name === 'string') // Shortcut for formats:
            // register(Blot | Attributor, overwrite)
            this.register(`formats/${name}`, target, overwrite);
            else Object.keys(target).forEach((key)=>{
                this.register(key, target[key], overwrite);
            });
        } else {
            const path = arguments.length <= 0 ? undefined : arguments[0];
            const target = arguments.length <= 1 ? undefined : arguments[1];
            const overwrite = !!(arguments.length <= 2 ? undefined : arguments[2]);
            if (this.imports[path] != null && !overwrite) $acbdaf6ec67cab2c$var$debug.warn(`Overwriting ${path} with`, target);
            this.imports[path] = target;
            if ((path.startsWith('blots/') || path.startsWith('formats/')) && target && typeof target !== 'boolean' && target.blotName !== 'abstract') $acbdaf6ec67cab2c$export$bc58ce2776ecdb6f.register(target);
            if (typeof target.register === 'function') target.register($acbdaf6ec67cab2c$export$bc58ce2776ecdb6f);
        }
    }
    constructor(container){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.options = $acbdaf6ec67cab2c$export$72ab7189806b6df5(container, options);
        this.container = this.options.container;
        if (this.container == null) {
            $acbdaf6ec67cab2c$var$debug.error('Invalid Quill container', container);
            return;
        }
        if (this.options.debug) $acbdaf6ec67cab2c$export$2e2bcd8739ae039.debug(this.options.debug);
        const html = this.container.innerHTML.trim();
        this.container.classList.add('ql-container');
        this.container.innerHTML = '';
        (0, $315Gv.default).set(this.container, this);
        this.root = this.addContainer('ql-editor');
        this.root.classList.add('ql-blank');
        this.emitter = new (0, $hJr1g.default)();
        const scrollBlotName = $45gdf.ScrollBlot.blotName;
        const ScrollBlot = this.options.registry.query(scrollBlotName);
        if (!ScrollBlot || !('blotName' in ScrollBlot)) throw new Error(`Cannot initialize Quill without "${scrollBlotName}" blot`);
        this.scroll = new ScrollBlot(this.options.registry, this.root, {
            emitter: this.emitter
        });
        this.editor = new (0, $aRNA0.default)(this.scroll);
        this.selection = new (0, $6EzZS.default)(this.scroll, this.emitter);
        this.composition = new (0, $C3M1D.default)(this.scroll, this.emitter);
        this.theme = new this.options.theme(this, this.options); // eslint-disable-line new-cap
        this.keyboard = this.theme.addModule('keyboard');
        this.clipboard = this.theme.addModule('clipboard');
        this.history = this.theme.addModule('history');
        this.uploader = this.theme.addModule('uploader');
        this.theme.addModule('input');
        this.theme.addModule('uiNode');
        this.theme.init();
        this.emitter.on((0, $hJr1g.default).events.EDITOR_CHANGE, (type)=>{
            if (type === (0, $hJr1g.default).events.TEXT_CHANGE) this.root.classList.toggle('ql-blank', this.editor.isBlank());
        });
        this.emitter.on((0, $hJr1g.default).events.SCROLL_UPDATE, (source, mutations)=>{
            const oldRange = this.selection.lastRange;
            const [newRange] = this.selection.getRange();
            const selectionInfo = oldRange && newRange ? {
                oldRange: oldRange,
                newRange: newRange
            } : undefined;
            $acbdaf6ec67cab2c$var$modify.call(this, ()=>this.editor.update(null, mutations, selectionInfo), source);
        });
        this.emitter.on((0, $hJr1g.default).events.SCROLL_EMBED_UPDATE, (blot, delta)=>{
            const oldRange = this.selection.lastRange;
            const [newRange] = this.selection.getRange();
            const selectionInfo = oldRange && newRange ? {
                oldRange: oldRange,
                newRange: newRange
            } : undefined;
            $acbdaf6ec67cab2c$var$modify.call(this, ()=>{
                const change = new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().retain(blot.offset(this)).retain({
                    [blot.statics.blotName]: delta
                });
                return this.editor.update(change, [], selectionInfo);
            }, $acbdaf6ec67cab2c$export$2e2bcd8739ae039.sources.USER);
        });
        if (html) {
            const contents = this.clipboard.convert({
                html: `${html}<p><br></p>`,
                text: '\n'
            });
            this.setContents(contents);
        }
        this.history.clear();
        if (this.options.placeholder) this.root.setAttribute('data-placeholder', this.options.placeholder);
        if (this.options.readOnly) this.disable();
        this.allowReadOnlyEdits = false;
    }
    addContainer(container) {
        let refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        if (typeof container === 'string') {
            const className = container;
            container = document.createElement('div');
            container.classList.add(className);
        }
        this.container.insertBefore(container, refNode);
        return container;
    }
    blur() {
        this.selection.setRange(null);
    }
    deleteText(index, length, source) {
        // @ts-expect-error
        [index, length, , source] = $acbdaf6ec67cab2c$export$e336952123c0bccd(index, length, source);
        return $acbdaf6ec67cab2c$var$modify.call(this, ()=>{
            return this.editor.deleteText(index, length);
        }, source, index, -1 * length);
    }
    disable() {
        this.enable(false);
    }
    editReadOnly(modifier) {
        this.allowReadOnlyEdits = true;
        const value = modifier();
        this.allowReadOnlyEdits = false;
        return value;
    }
    enable() {
        let enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.scroll.enable(enabled);
        this.container.classList.toggle('ql-disabled', !enabled);
    }
    focus() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.selection.focus();
        if (!options.preventScroll) this.scrollSelectionIntoView();
    }
    format(name, value) {
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $hJr1g.default).sources.API;
        return $acbdaf6ec67cab2c$var$modify.call(this, ()=>{
            const range = this.getSelection(true);
            let change = new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))();
            if (range == null) return change;
            if (this.scroll.query(name, $45gdf.Scope.BLOCK)) change = this.editor.formatLine(range.index, range.length, {
                [name]: value
            });
            else if (range.length === 0) {
                this.selection.format(name, value);
                return change;
            } else change = this.editor.formatText(range.index, range.length, {
                [name]: value
            });
            this.setSelection(range, (0, $hJr1g.default).sources.SILENT);
            return change;
        }, source);
    }
    formatLine(index, length, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        [index, length, formats, source] = $acbdaf6ec67cab2c$export$e336952123c0bccd(index, length, // @ts-expect-error
        name, value, source);
        return $acbdaf6ec67cab2c$var$modify.call(this, ()=>{
            return this.editor.formatLine(index, length, formats);
        }, source, index, 0);
    }
    formatText(index, length, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        [index, length, formats, source] = $acbdaf6ec67cab2c$export$e336952123c0bccd(// @ts-expect-error
        index, length, name, value, source);
        return $acbdaf6ec67cab2c$var$modify.call(this, ()=>{
            return this.editor.formatText(index, length, formats);
        }, source, index, 0);
    }
    getBounds(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let bounds = null;
        if (typeof index === 'number') bounds = this.selection.getBounds(index, length);
        else bounds = this.selection.getBounds(index.index, index.length);
        if (!bounds) return null;
        const containerBounds = this.container.getBoundingClientRect();
        return {
            bottom: bounds.bottom - containerBounds.top,
            height: bounds.height,
            left: bounds.left - containerBounds.left,
            right: bounds.right - containerBounds.left,
            top: bounds.top - containerBounds.top,
            width: bounds.width
        };
    }
    getContents() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
        [index, length] = $acbdaf6ec67cab2c$export$e336952123c0bccd(index, length);
        return this.editor.getContents(index, length);
    }
    getFormat() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        if (typeof index === 'number') return this.editor.getFormat(index, length);
        return this.editor.getFormat(index.index, index.length);
    }
    getIndex(blot) {
        return blot.offset(this.scroll);
    }
    getLength() {
        return this.scroll.length();
    }
    getLeaf(index) {
        return this.scroll.leaf(index);
    }
    getLine(index) {
        return this.scroll.line(index);
    }
    getLines() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
        if (typeof index !== 'number') return this.scroll.lines(index.index, index.length);
        return this.scroll.lines(index, length);
    }
    getModule(name) {
        return this.theme.modules[name];
    }
    getSelection() {
        let focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (focus) this.focus();
        this.update(); // Make sure we access getRange with editor in consistent state
        return this.selection.getRange()[0];
    }
    getSemanticHTML() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof index === 'number') length = length ?? this.getLength() - index;
        // @ts-expect-error
        [index, length] = $acbdaf6ec67cab2c$export$e336952123c0bccd(index, length);
        return this.editor.getHTML(index, length);
    }
    getText() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof index === 'number') length = length ?? this.getLength() - index;
        // @ts-expect-error
        [index, length] = $acbdaf6ec67cab2c$export$e336952123c0bccd(index, length);
        return this.editor.getText(index, length);
    }
    hasFocus() {
        return this.selection.hasFocus();
    }
    insertEmbed(index, embed, value) {
        let source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $acbdaf6ec67cab2c$export$2e2bcd8739ae039.sources.API;
        return $acbdaf6ec67cab2c$var$modify.call(this, ()=>{
            return this.editor.insertEmbed(index, embed, value);
        }, source, index);
    }
    insertText(index, text, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        // @ts-expect-error
        [index, , formats, source] = $acbdaf6ec67cab2c$export$e336952123c0bccd(index, 0, name, value, source);
        return $acbdaf6ec67cab2c$var$modify.call(this, ()=>{
            return this.editor.insertText(index, text, formats);
        }, source, index, text.length);
    }
    isEnabled() {
        return this.scroll.isEnabled();
    }
    off() {
        return this.emitter.off(...arguments);
    }
    on() {
        return this.emitter.on(...arguments);
    }
    once() {
        return this.emitter.once(...arguments);
    }
    removeFormat(index, length, source) {
        [index, length, , source] = $acbdaf6ec67cab2c$export$e336952123c0bccd(index, length, source);
        return $acbdaf6ec67cab2c$var$modify.call(this, ()=>{
            return this.editor.removeFormat(index, length);
        }, source, index);
    }
    scrollRectIntoView(rect) {
        (0, $2tdRQ.default)(this.root, rect);
    }
    /**
   * @deprecated Use Quill#scrollSelectionIntoView() instead.
   */ scrollIntoView() {
        console.warn('Quill#scrollIntoView() has been deprecated and will be removed in the near future. Please use Quill#scrollSelectionIntoView() instead.');
        this.scrollSelectionIntoView();
    }
    /**
   * Scroll the current selection into the visible area.
   * If the selection is already visible, no scrolling will occur.
   */ scrollSelectionIntoView() {
        const range = this.selection.lastRange;
        const bounds = range && this.selection.getBounds(range.index, range.length);
        if (bounds) this.scrollRectIntoView(bounds);
    }
    setContents(delta) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $hJr1g.default).sources.API;
        return $acbdaf6ec67cab2c$var$modify.call(this, ()=>{
            delta = new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))(delta);
            const length = this.getLength();
            // Quill will set empty editor to \n
            const delete1 = this.editor.deleteText(0, length);
            const applied = this.editor.insertContents(0, delta);
            // Remove extra \n from empty editor initialization
            const delete2 = this.editor.deleteText(this.getLength() - 1, 1);
            return delete1.compose(applied).compose(delete2);
        }, source);
    }
    setSelection(index, length, source) {
        if (index == null) // @ts-expect-error https://github.com/microsoft/TypeScript/issues/22609
        this.selection.setRange(null, length || $acbdaf6ec67cab2c$export$2e2bcd8739ae039.sources.API);
        else {
            // @ts-expect-error
            [index, length, , source] = $acbdaf6ec67cab2c$export$e336952123c0bccd(index, length, source);
            this.selection.setRange(new (0, $6EzZS.Range)(Math.max(0, index), length), source);
            if (source !== (0, $hJr1g.default).sources.SILENT) this.scrollSelectionIntoView();
        }
    }
    setText(text) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $hJr1g.default).sources.API;
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().insert(text);
        return this.setContents(delta, source);
    }
    update() {
        let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $hJr1g.default).sources.USER;
        const change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
        this.selection.update(source);
        // TODO this is usually undefined
        return change;
    }
    updateContents(delta) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $hJr1g.default).sources.API;
        return $acbdaf6ec67cab2c$var$modify.call(this, ()=>{
            delta = new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))(delta);
            return this.editor.applyDelta(delta);
        }, source, true);
    }
}
function $acbdaf6ec67cab2c$var$resolveSelector(selector) {
    return typeof selector === 'string' ? document.querySelector(selector) : selector;
}
function $acbdaf6ec67cab2c$var$expandModuleConfig(config) {
    return Object.entries(config ?? {}).reduce((expanded, _ref)=>{
        let [key, value] = _ref;
        return {
            ...expanded,
            [key]: value === true ? {} : value
        };
    }, {});
}
function $acbdaf6ec67cab2c$var$omitUndefinedValuesFromOptions(obj) {
    return Object.fromEntries(Object.entries(obj).filter((entry)=>entry[1] !== undefined));
}
function $acbdaf6ec67cab2c$export$72ab7189806b6df5(containerOrSelector, options) {
    const container = $acbdaf6ec67cab2c$var$resolveSelector(containerOrSelector);
    if (!container) throw new Error('Invalid Quill container');
    const shouldUseDefaultTheme = !options.theme || options.theme === $acbdaf6ec67cab2c$export$2e2bcd8739ae039.DEFAULTS.theme;
    const theme = shouldUseDefaultTheme ? (0, $8ioPK.default) : $acbdaf6ec67cab2c$export$2e2bcd8739ae039.import(`themes/${options.theme}`);
    if (!theme) throw new Error(`Invalid theme ${options.theme}. Did you register it?`);
    const { modules: quillModuleDefaults, ...quillDefaults } = $acbdaf6ec67cab2c$export$2e2bcd8739ae039.DEFAULTS;
    const { modules: themeModuleDefaults, ...themeDefaults } = theme.DEFAULTS;
    let userModuleOptions = $acbdaf6ec67cab2c$var$expandModuleConfig(options.modules);
    // Special case toolbar shorthand
    if (userModuleOptions != null && userModuleOptions.toolbar && userModuleOptions.toolbar.constructor !== Object) userModuleOptions = {
        ...userModuleOptions,
        toolbar: {
            container: userModuleOptions.toolbar
        }
    };
    const modules = (0, $jjgrT.default)({}, $acbdaf6ec67cab2c$var$expandModuleConfig(quillModuleDefaults), $acbdaf6ec67cab2c$var$expandModuleConfig(themeModuleDefaults), userModuleOptions);
    const config = {
        ...quillDefaults,
        ...$acbdaf6ec67cab2c$var$omitUndefinedValuesFromOptions(themeDefaults),
        ...$acbdaf6ec67cab2c$var$omitUndefinedValuesFromOptions(options)
    };
    let registry = options.registry;
    if (registry) {
        if (options.formats) $acbdaf6ec67cab2c$var$debug.warn('Ignoring "formats" option because "registry" is specified');
    } else registry = options.formats ? (0, $5bW5Y.default)(options.formats, config.registry, $acbdaf6ec67cab2c$var$debug) : config.registry;
    return {
        ...config,
        registry: registry,
        container: container,
        theme: theme,
        modules: Object.entries(modules).reduce((modulesWithDefaults, _ref2)=>{
            let [name, value] = _ref2;
            if (!value) return modulesWithDefaults;
            const moduleClass = $acbdaf6ec67cab2c$export$2e2bcd8739ae039.import(`modules/${name}`);
            if (moduleClass == null) {
                $acbdaf6ec67cab2c$var$debug.error(`Cannot load ${name} module. Are you sure you registered it?`);
                return modulesWithDefaults;
            }
            return {
                ...modulesWithDefaults,
                // @ts-expect-error
                [name]: (0, $jjgrT.default)({}, moduleClass.DEFAULTS || {}, value)
            };
        }, {}),
        bounds: $acbdaf6ec67cab2c$var$resolveSelector(config.bounds)
    };
}
// Handle selection preservation and TEXT_CHANGE emission
// common to modification APIs
function $acbdaf6ec67cab2c$var$modify(modifier, source, index, shift) {
    if (!this.isEnabled() && source === (0, $hJr1g.default).sources.USER && !this.allowReadOnlyEdits) return new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))();
    let range = index == null ? null : this.getSelection();
    const oldDelta = this.editor.delta;
    const change = modifier();
    if (range != null) {
        if (index === true) index = range.index; // eslint-disable-line prefer-destructuring
        if (shift == null) range = $acbdaf6ec67cab2c$var$shiftRange(range, change, source);
        else if (shift !== 0) // @ts-expect-error index should always be number
        range = $acbdaf6ec67cab2c$var$shiftRange(range, index, shift, source);
        this.setSelection(range, (0, $hJr1g.default).sources.SILENT);
    }
    if (change.length() > 0) {
        const args = [
            (0, $hJr1g.default).events.TEXT_CHANGE,
            change,
            oldDelta,
            source
        ];
        this.emitter.emit((0, $hJr1g.default).events.EDITOR_CHANGE, ...args);
        if (source !== (0, $hJr1g.default).sources.SILENT) this.emitter.emit(...args);
    }
    return change;
}
function $acbdaf6ec67cab2c$export$e336952123c0bccd(index, length, name, value, source) {
    let formats = {};
    // @ts-expect-error
    if (typeof index.index === 'number' && typeof index.length === 'number') {
        // Allow for throwaway end (used by insertText/insertEmbed)
        if (typeof length !== 'number') {
            // @ts-expect-error
            source = value;
            value = name;
            name = length;
            // @ts-expect-error
            length = index.length; // eslint-disable-line prefer-destructuring
            // @ts-expect-error
            index = index.index; // eslint-disable-line prefer-destructuring
        } else {
            // @ts-expect-error
            length = index.length; // eslint-disable-line prefer-destructuring
            // @ts-expect-error
            index = index.index; // eslint-disable-line prefer-destructuring
        }
    } else if (typeof length !== 'number') {
        // @ts-expect-error
        source = value;
        value = name;
        name = length;
        length = 0;
    }
    // Handle format being object, two format name/value strings or excluded
    if (typeof name === 'object') {
        // @ts-expect-error Fix me later
        formats = name;
        // @ts-expect-error
        source = value;
    } else if (typeof name === 'string') {
        if (value != null) formats[name] = value;
        else // @ts-expect-error
        source = name;
    }
    // Handle optional source
    source = source || (0, $hJr1g.default).sources.API;
    // @ts-expect-error
    return [
        index,
        length,
        formats,
        source
    ];
}
function $acbdaf6ec67cab2c$var$shiftRange(range, index, lengthOrSource, source) {
    const length = typeof lengthOrSource === 'number' ? lengthOrSource : 0;
    if (range == null) return null;
    let start;
    let end;
    // @ts-expect-error -- TODO: add a better type guard around `index`
    if (index && typeof index.transformPosition === 'function') [start, end] = [
        range.index,
        range.index + range.length
    ].map((pos)=>// @ts-expect-error -- TODO: add a better type guard around `index`
        index.transformPosition(pos, source !== (0, $hJr1g.default).sources.USER));
    else [start, end] = [
        range.index,
        range.index + range.length
    ].map((pos)=>{
        // @ts-expect-error -- TODO: add a better type guard around `index`
        if (pos < index || pos === index && source === (0, $hJr1g.default).sources.USER) return pos;
        if (length >= 0) return pos + length;
        // @ts-expect-error -- TODO: add a better type guard around `index`
        return Math.max(index, pos + length);
    });
    return new (0, $6EzZS.Range)(start, end - start);
}

});
parcelRegister("jjgrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0ec8d117c01a1c0$export$2e2bcd8739ae039);

var $2PJEg = parcelRequire("2PJEg");

var $dLZ6u = parcelRequire("dLZ6u");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $e0ec8d117c01a1c0$var$merge = (0, $dLZ6u.default)(function(object, source, srcIndex) {
    (0, $2PJEg.default)(object, source, srcIndex);
});
var $e0ec8d117c01a1c0$export$2e2bcd8739ae039 = $e0ec8d117c01a1c0$var$merge;

});
parcelRegister("2PJEg", function(module, exports) {

$parcel$export(module.exports, "default", () => $2103c104f7196c40$export$2e2bcd8739ae039);

var $dGI8c = parcelRequire("dGI8c");

var $8pF4l = parcelRequire("8pF4l");

var $hepmG = parcelRequire("hepmG");

var $VDxGB = parcelRequire("VDxGB");

var $laXqR = parcelRequire("laXqR");

var $58AyX = parcelRequire("58AyX");

var $dVBd1 = parcelRequire("dVBd1");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $2103c104f7196c40$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    (0, $hepmG.default)(source, function(srcValue, key) {
        stack || (stack = new (0, $dGI8c.default));
        if ((0, $laXqR.default)(srcValue)) (0, $VDxGB.default)(object, source, key, srcIndex, $2103c104f7196c40$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer((0, $dVBd1.default)(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            (0, $8pF4l.default)(object, key, newValue);
        }
    }, (0, $58AyX.default));
}
var $2103c104f7196c40$export$2e2bcd8739ae039 = $2103c104f7196c40$var$baseMerge;

});
parcelRegister("dGI8c", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f716e2953a5972c$export$2e2bcd8739ae039);

var $if9OP = parcelRequire("if9OP");

var $gvqOr = parcelRequire("gvqOr");

var $g3QZd = parcelRequire("g3QZd");

var $jm5WQ = parcelRequire("jm5WQ");

var $i8RAn = parcelRequire("i8RAn");

var $bRg0v = parcelRequire("bRg0v");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $9f716e2953a5972c$var$Stack(entries) {
    var data = this.__data__ = new (0, $if9OP.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$9f716e2953a5972c$var$Stack.prototype.clear = (0, $gvqOr.default);
$9f716e2953a5972c$var$Stack.prototype['delete'] = (0, $g3QZd.default);
$9f716e2953a5972c$var$Stack.prototype.get = (0, $jm5WQ.default);
$9f716e2953a5972c$var$Stack.prototype.has = (0, $i8RAn.default);
$9f716e2953a5972c$var$Stack.prototype.set = (0, $bRg0v.default);
var $9f716e2953a5972c$export$2e2bcd8739ae039 = $9f716e2953a5972c$var$Stack;

});
parcelRegister("if9OP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4813e866e4c45dd$export$2e2bcd8739ae039);

var $1en7H = parcelRequire("1en7H");

var $fjH4Z = parcelRequire("fjH4Z");

var $5SCuM = parcelRequire("5SCuM");

var $jxYyc = parcelRequire("jxYyc");

var $33ZZM = parcelRequire("33ZZM");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d4813e866e4c45dd$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$d4813e866e4c45dd$var$ListCache.prototype.clear = (0, $1en7H.default);
$d4813e866e4c45dd$var$ListCache.prototype['delete'] = (0, $fjH4Z.default);
$d4813e866e4c45dd$var$ListCache.prototype.get = (0, $5SCuM.default);
$d4813e866e4c45dd$var$ListCache.prototype.has = (0, $jxYyc.default);
$d4813e866e4c45dd$var$ListCache.prototype.set = (0, $33ZZM.default);
var $d4813e866e4c45dd$export$2e2bcd8739ae039 = $d4813e866e4c45dd$var$ListCache;

});
parcelRegister("1en7H", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e590903031d19f4$export$2e2bcd8739ae039);
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $0e590903031d19f4$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $0e590903031d19f4$export$2e2bcd8739ae039 = $0e590903031d19f4$var$listCacheClear;

});

parcelRegister("fjH4Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $b26a0c0d1557fdfe$export$2e2bcd8739ae039);

var $haWz0 = parcelRequire("haWz0");
/** Used for built-in method references. */ var $b26a0c0d1557fdfe$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $b26a0c0d1557fdfe$var$splice = $b26a0c0d1557fdfe$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b26a0c0d1557fdfe$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $haWz0.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $b26a0c0d1557fdfe$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $b26a0c0d1557fdfe$export$2e2bcd8739ae039 = $b26a0c0d1557fdfe$var$listCacheDelete;

});
parcelRegister("haWz0", function(module, exports) {

$parcel$export(module.exports, "default", () => $c810cc545488bd22$export$2e2bcd8739ae039);

var $44Qh5 = parcelRequire("44Qh5");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $c810cc545488bd22$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $44Qh5.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $c810cc545488bd22$export$2e2bcd8739ae039 = $c810cc545488bd22$var$assocIndexOf;

});
parcelRegister("44Qh5", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f8015c6162dbffe$export$2e2bcd8739ae039);
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $2f8015c6162dbffe$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $2f8015c6162dbffe$export$2e2bcd8739ae039 = $2f8015c6162dbffe$var$eq;

});



parcelRegister("5SCuM", function(module, exports) {

$parcel$export(module.exports, "default", () => $447fdb5065e685f2$export$2e2bcd8739ae039);

var $haWz0 = parcelRequire("haWz0");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $447fdb5065e685f2$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $haWz0.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $447fdb5065e685f2$export$2e2bcd8739ae039 = $447fdb5065e685f2$var$listCacheGet;

});

parcelRegister("jxYyc", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3b0117f93345d36$export$2e2bcd8739ae039);

var $haWz0 = parcelRequire("haWz0");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e3b0117f93345d36$var$listCacheHas(key) {
    return (0, $haWz0.default)(this.__data__, key) > -1;
}
var $e3b0117f93345d36$export$2e2bcd8739ae039 = $e3b0117f93345d36$var$listCacheHas;

});

parcelRegister("33ZZM", function(module, exports) {

$parcel$export(module.exports, "default", () => $23b1bdec3fc58b6a$export$2e2bcd8739ae039);

var $haWz0 = parcelRequire("haWz0");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $23b1bdec3fc58b6a$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $haWz0.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $23b1bdec3fc58b6a$export$2e2bcd8739ae039 = $23b1bdec3fc58b6a$var$listCacheSet;

});


parcelRegister("gvqOr", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0445703b64a5f20$export$2e2bcd8739ae039);

var $if9OP = parcelRequire("if9OP");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $c0445703b64a5f20$var$stackClear() {
    this.__data__ = new (0, $if9OP.default);
    this.size = 0;
}
var $c0445703b64a5f20$export$2e2bcd8739ae039 = $c0445703b64a5f20$var$stackClear;

});

parcelRegister("g3QZd", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb1607285356b772$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $bb1607285356b772$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $bb1607285356b772$export$2e2bcd8739ae039 = $bb1607285356b772$var$stackDelete;

});

parcelRegister("jm5WQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e174af907af1ccf1$export$2e2bcd8739ae039);
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e174af907af1ccf1$var$stackGet(key) {
    return this.__data__.get(key);
}
var $e174af907af1ccf1$export$2e2bcd8739ae039 = $e174af907af1ccf1$var$stackGet;

});

parcelRegister("i8RAn", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3528a5e389f65f5$export$2e2bcd8739ae039);
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d3528a5e389f65f5$var$stackHas(key) {
    return this.__data__.has(key);
}
var $d3528a5e389f65f5$export$2e2bcd8739ae039 = $d3528a5e389f65f5$var$stackHas;

});

parcelRegister("bRg0v", function(module, exports) {

$parcel$export(module.exports, "default", () => $023a56f62190b326$export$2e2bcd8739ae039);

var $if9OP = parcelRequire("if9OP");

var $lhx5c = parcelRequire("lhx5c");

var $hO2ZN = parcelRequire("hO2ZN");
/** Used as the size to enable large array optimizations. */ var $023a56f62190b326$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $023a56f62190b326$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $if9OP.default)) {
        var pairs = data.__data__;
        if (!(0, $lhx5c.default) || pairs.length < $023a56f62190b326$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $hO2ZN.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $023a56f62190b326$export$2e2bcd8739ae039 = $023a56f62190b326$var$stackSet;

});
parcelRegister("lhx5c", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7e4d918dd9e8b79$export$2e2bcd8739ae039);

var $31iYT = parcelRequire("31iYT");

var $4LQN3 = parcelRequire("4LQN3");
/* Built-in method references that are verified to be native. */ var $f7e4d918dd9e8b79$var$Map = (0, $31iYT.default)((0, $4LQN3.default), 'Map');
var $f7e4d918dd9e8b79$export$2e2bcd8739ae039 = $f7e4d918dd9e8b79$var$Map;

});
parcelRegister("31iYT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2330305c44d6e2ae$export$2e2bcd8739ae039);

var $kc8vV = parcelRequire("kc8vV");

var $e4pCu = parcelRequire("e4pCu");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $2330305c44d6e2ae$var$getNative(object, key) {
    var value = (0, $e4pCu.default)(object, key);
    return (0, $kc8vV.default)(value) ? value : undefined;
}
var $2330305c44d6e2ae$export$2e2bcd8739ae039 = $2330305c44d6e2ae$var$getNative;

});
parcelRegister("kc8vV", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb3b885699f4f1a0$export$2e2bcd8739ae039);

var $18BVV = parcelRequire("18BVV");

var $fOk5D = parcelRequire("fOk5D");

var $laXqR = parcelRequire("laXqR");

var $gtAhe = parcelRequire("gtAhe");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $eb3b885699f4f1a0$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $eb3b885699f4f1a0$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $eb3b885699f4f1a0$var$funcProto = Function.prototype, $eb3b885699f4f1a0$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $eb3b885699f4f1a0$var$funcToString = $eb3b885699f4f1a0$var$funcProto.toString;
/** Used to check objects for own properties. */ var $eb3b885699f4f1a0$var$hasOwnProperty = $eb3b885699f4f1a0$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $eb3b885699f4f1a0$var$reIsNative = RegExp('^' + $eb3b885699f4f1a0$var$funcToString.call($eb3b885699f4f1a0$var$hasOwnProperty).replace($eb3b885699f4f1a0$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $eb3b885699f4f1a0$var$baseIsNative(value) {
    if (!(0, $laXqR.default)(value) || (0, $fOk5D.default)(value)) return false;
    var pattern = (0, $18BVV.default)(value) ? $eb3b885699f4f1a0$var$reIsNative : $eb3b885699f4f1a0$var$reIsHostCtor;
    return pattern.test((0, $gtAhe.default)(value));
}
var $eb3b885699f4f1a0$export$2e2bcd8739ae039 = $eb3b885699f4f1a0$var$baseIsNative;

});
parcelRegister("18BVV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d43f68b297fb7db$export$2e2bcd8739ae039);

var $fXyl2 = parcelRequire("fXyl2");

var $laXqR = parcelRequire("laXqR");
/** `Object#toString` result references. */ var $0d43f68b297fb7db$var$asyncTag = '[object AsyncFunction]', $0d43f68b297fb7db$var$funcTag = '[object Function]', $0d43f68b297fb7db$var$genTag = '[object GeneratorFunction]', $0d43f68b297fb7db$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $0d43f68b297fb7db$var$isFunction(value) {
    if (!(0, $laXqR.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $fXyl2.default)(value);
    return tag == $0d43f68b297fb7db$var$funcTag || tag == $0d43f68b297fb7db$var$genTag || tag == $0d43f68b297fb7db$var$asyncTag || tag == $0d43f68b297fb7db$var$proxyTag;
}
var $0d43f68b297fb7db$export$2e2bcd8739ae039 = $0d43f68b297fb7db$var$isFunction;

});
parcelRegister("fXyl2", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9e70099c2aa1aa5$export$2e2bcd8739ae039);

var $a2xkg = parcelRequire("a2xkg");

var $i411m = parcelRequire("i411m");

var $PDdNi = parcelRequire("PDdNi");
/** `Object#toString` result references. */ var $b9e70099c2aa1aa5$var$nullTag = '[object Null]', $b9e70099c2aa1aa5$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $b9e70099c2aa1aa5$var$symToStringTag = (0, $a2xkg.default) ? (0, $a2xkg.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $b9e70099c2aa1aa5$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $b9e70099c2aa1aa5$var$undefinedTag : $b9e70099c2aa1aa5$var$nullTag;
    return $b9e70099c2aa1aa5$var$symToStringTag && $b9e70099c2aa1aa5$var$symToStringTag in Object(value) ? (0, $i411m.default)(value) : (0, $PDdNi.default)(value);
}
var $b9e70099c2aa1aa5$export$2e2bcd8739ae039 = $b9e70099c2aa1aa5$var$baseGetTag;

});
parcelRegister("a2xkg", function(module, exports) {

$parcel$export(module.exports, "default", () => $74f3f11439d83855$export$2e2bcd8739ae039);

var $4LQN3 = parcelRequire("4LQN3");
/** Built-in value references. */ var $74f3f11439d83855$var$Symbol = (0, $4LQN3.default).Symbol;
var $74f3f11439d83855$export$2e2bcd8739ae039 = $74f3f11439d83855$var$Symbol;

});
parcelRegister("4LQN3", function(module, exports) {

$parcel$export(module.exports, "default", () => $37948041e7f76055$export$2e2bcd8739ae039);

var $4vlAK = parcelRequire("4vlAK");
/** Detect free variable `self`. */ var $37948041e7f76055$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $37948041e7f76055$var$root = (0, $4vlAK.default) || $37948041e7f76055$var$freeSelf || Function('return this')();
var $37948041e7f76055$export$2e2bcd8739ae039 = $37948041e7f76055$var$root;

});
parcelRegister("4vlAK", function(module, exports) {

$parcel$export(module.exports, "default", () => $347ace580bb376a9$export$2e2bcd8739ae039);
/** Detect free variable `global` from Node.js. */ var $347ace580bb376a9$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $347ace580bb376a9$export$2e2bcd8739ae039 = $347ace580bb376a9$var$freeGlobal;

});



parcelRegister("i411m", function(module, exports) {

$parcel$export(module.exports, "default", () => $d269646eb88f59eb$export$2e2bcd8739ae039);

var $a2xkg = parcelRequire("a2xkg");
/** Used for built-in method references. */ var $d269646eb88f59eb$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d269646eb88f59eb$var$hasOwnProperty = $d269646eb88f59eb$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $d269646eb88f59eb$var$nativeObjectToString = $d269646eb88f59eb$var$objectProto.toString;
/** Built-in value references. */ var $d269646eb88f59eb$var$symToStringTag = (0, $a2xkg.default) ? (0, $a2xkg.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $d269646eb88f59eb$var$getRawTag(value) {
    var isOwn = $d269646eb88f59eb$var$hasOwnProperty.call(value, $d269646eb88f59eb$var$symToStringTag), tag = value[$d269646eb88f59eb$var$symToStringTag];
    try {
        value[$d269646eb88f59eb$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $d269646eb88f59eb$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$d269646eb88f59eb$var$symToStringTag] = tag;
        else delete value[$d269646eb88f59eb$var$symToStringTag];
    }
    return result;
}
var $d269646eb88f59eb$export$2e2bcd8739ae039 = $d269646eb88f59eb$var$getRawTag;

});

parcelRegister("PDdNi", function(module, exports) {

$parcel$export(module.exports, "default", () => $09b3301ac40a2b7f$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $09b3301ac40a2b7f$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $09b3301ac40a2b7f$var$nativeObjectToString = $09b3301ac40a2b7f$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $09b3301ac40a2b7f$var$objectToString(value) {
    return $09b3301ac40a2b7f$var$nativeObjectToString.call(value);
}
var $09b3301ac40a2b7f$export$2e2bcd8739ae039 = $09b3301ac40a2b7f$var$objectToString;

});


parcelRegister("laXqR", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6a8a2299f977977$export$2e2bcd8739ae039);
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f6a8a2299f977977$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $f6a8a2299f977977$export$2e2bcd8739ae039 = $f6a8a2299f977977$var$isObject;

});


parcelRegister("fOk5D", function(module, exports) {

$parcel$export(module.exports, "default", () => $b82b1bfa7c2a5412$export$2e2bcd8739ae039);

var $98cF7 = parcelRequire("98cF7");
/** Used to detect methods masquerading as native. */ var $b82b1bfa7c2a5412$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $98cF7.default) && (0, $98cF7.default).keys && (0, $98cF7.default).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $b82b1bfa7c2a5412$var$isMasked(func) {
    return !!$b82b1bfa7c2a5412$var$maskSrcKey && $b82b1bfa7c2a5412$var$maskSrcKey in func;
}
var $b82b1bfa7c2a5412$export$2e2bcd8739ae039 = $b82b1bfa7c2a5412$var$isMasked;

});
parcelRegister("98cF7", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a5eaee0a2e9810f$export$2e2bcd8739ae039);

var $4LQN3 = parcelRequire("4LQN3");
/** Used to detect overreaching core-js shims. */ var $6a5eaee0a2e9810f$var$coreJsData = (0, $4LQN3.default)['__core-js_shared__'];
var $6a5eaee0a2e9810f$export$2e2bcd8739ae039 = $6a5eaee0a2e9810f$var$coreJsData;

});


parcelRegister("gtAhe", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfeb7ea352f94648$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $bfeb7ea352f94648$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $bfeb7ea352f94648$var$funcToString = $bfeb7ea352f94648$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $bfeb7ea352f94648$var$toSource(func) {
    if (func != null) {
        try {
            return $bfeb7ea352f94648$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $bfeb7ea352f94648$export$2e2bcd8739ae039 = $bfeb7ea352f94648$var$toSource;

});


parcelRegister("e4pCu", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e54ff59770d3e9$export$2e2bcd8739ae039);
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $a3e54ff59770d3e9$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $a3e54ff59770d3e9$export$2e2bcd8739ae039 = $a3e54ff59770d3e9$var$getValue;

});



parcelRegister("hO2ZN", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf696e0b56a20d12$export$2e2bcd8739ae039);

var $fR3cr = parcelRequire("fR3cr");

var $i75eS = parcelRequire("i75eS");

var $h6dO4 = parcelRequire("h6dO4");

var $bvtk1 = parcelRequire("bvtk1");

var $1TiHU = parcelRequire("1TiHU");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $cf696e0b56a20d12$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$cf696e0b56a20d12$var$MapCache.prototype.clear = (0, $fR3cr.default);
$cf696e0b56a20d12$var$MapCache.prototype['delete'] = (0, $i75eS.default);
$cf696e0b56a20d12$var$MapCache.prototype.get = (0, $h6dO4.default);
$cf696e0b56a20d12$var$MapCache.prototype.has = (0, $bvtk1.default);
$cf696e0b56a20d12$var$MapCache.prototype.set = (0, $1TiHU.default);
var $cf696e0b56a20d12$export$2e2bcd8739ae039 = $cf696e0b56a20d12$var$MapCache;

});
parcelRegister("fR3cr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8ae49a391ac0814$export$2e2bcd8739ae039);

var $brNuw = parcelRequire("brNuw");

var $if9OP = parcelRequire("if9OP");

var $lhx5c = parcelRequire("lhx5c");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $b8ae49a391ac0814$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $brNuw.default),
        'map': new ((0, $lhx5c.default) || (0, $if9OP.default)),
        'string': new (0, $brNuw.default)
    };
}
var $b8ae49a391ac0814$export$2e2bcd8739ae039 = $b8ae49a391ac0814$var$mapCacheClear;

});
parcelRegister("brNuw", function(module, exports) {

$parcel$export(module.exports, "default", () => $85589b45b7b129b7$export$2e2bcd8739ae039);

var $dpimn = parcelRequire("dpimn");

var $joJew = parcelRequire("joJew");

var $14xmj = parcelRequire("14xmj");

var $hf1ZC = parcelRequire("hf1ZC");

var $5BaP9 = parcelRequire("5BaP9");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $85589b45b7b129b7$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$85589b45b7b129b7$var$Hash.prototype.clear = (0, $dpimn.default);
$85589b45b7b129b7$var$Hash.prototype['delete'] = (0, $joJew.default);
$85589b45b7b129b7$var$Hash.prototype.get = (0, $14xmj.default);
$85589b45b7b129b7$var$Hash.prototype.has = (0, $hf1ZC.default);
$85589b45b7b129b7$var$Hash.prototype.set = (0, $5BaP9.default);
var $85589b45b7b129b7$export$2e2bcd8739ae039 = $85589b45b7b129b7$var$Hash;

});
parcelRegister("dpimn", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c2bda0fde6e3a03$export$2e2bcd8739ae039);

var $aXC6J = parcelRequire("aXC6J");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $9c2bda0fde6e3a03$var$hashClear() {
    this.__data__ = (0, $aXC6J.default) ? (0, $aXC6J.default)(null) : {};
    this.size = 0;
}
var $9c2bda0fde6e3a03$export$2e2bcd8739ae039 = $9c2bda0fde6e3a03$var$hashClear;

});
parcelRegister("aXC6J", function(module, exports) {

$parcel$export(module.exports, "default", () => $7facf96abf0f0dfb$export$2e2bcd8739ae039);

var $31iYT = parcelRequire("31iYT");
/* Built-in method references that are verified to be native. */ var $7facf96abf0f0dfb$var$nativeCreate = (0, $31iYT.default)(Object, 'create');
var $7facf96abf0f0dfb$export$2e2bcd8739ae039 = $7facf96abf0f0dfb$var$nativeCreate;

});


parcelRegister("joJew", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1f358914e82e65d$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e1f358914e82e65d$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $e1f358914e82e65d$export$2e2bcd8739ae039 = $e1f358914e82e65d$var$hashDelete;

});

parcelRegister("14xmj", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c800a8f892bc37e$export$2e2bcd8739ae039);

var $aXC6J = parcelRequire("aXC6J");
/** Used to stand-in for `undefined` hash values. */ var $0c800a8f892bc37e$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $0c800a8f892bc37e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0c800a8f892bc37e$var$hasOwnProperty = $0c800a8f892bc37e$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0c800a8f892bc37e$var$hashGet(key) {
    var data = this.__data__;
    if (0, $aXC6J.default) {
        var result = data[key];
        return result === $0c800a8f892bc37e$var$HASH_UNDEFINED ? undefined : result;
    }
    return $0c800a8f892bc37e$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $0c800a8f892bc37e$export$2e2bcd8739ae039 = $0c800a8f892bc37e$var$hashGet;

});

parcelRegister("hf1ZC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8d5621b6fb51aa1$export$2e2bcd8739ae039);

var $aXC6J = parcelRequire("aXC6J");
/** Used for built-in method references. */ var $c8d5621b6fb51aa1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c8d5621b6fb51aa1$var$hasOwnProperty = $c8d5621b6fb51aa1$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c8d5621b6fb51aa1$var$hashHas(key) {
    var data = this.__data__;
    return (0, $aXC6J.default) ? data[key] !== undefined : $c8d5621b6fb51aa1$var$hasOwnProperty.call(data, key);
}
var $c8d5621b6fb51aa1$export$2e2bcd8739ae039 = $c8d5621b6fb51aa1$var$hashHas;

});

parcelRegister("5BaP9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4138cde5fa48e120$export$2e2bcd8739ae039);

var $aXC6J = parcelRequire("aXC6J");
/** Used to stand-in for `undefined` hash values. */ var $4138cde5fa48e120$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $4138cde5fa48e120$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $aXC6J.default) && value === undefined ? $4138cde5fa48e120$var$HASH_UNDEFINED : value;
    return this;
}
var $4138cde5fa48e120$export$2e2bcd8739ae039 = $4138cde5fa48e120$var$hashSet;

});



parcelRegister("i75eS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2fcf1cf31c20abc$export$2e2bcd8739ae039);

var $gCZaO = parcelRequire("gCZaO");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d2fcf1cf31c20abc$var$mapCacheDelete(key) {
    var result = (0, $gCZaO.default)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $d2fcf1cf31c20abc$export$2e2bcd8739ae039 = $d2fcf1cf31c20abc$var$mapCacheDelete;

});
parcelRegister("gCZaO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1afa5bbb4fa3202$export$2e2bcd8739ae039);

var $ioC4d = parcelRequire("ioC4d");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c1afa5bbb4fa3202$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $ioC4d.default)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $c1afa5bbb4fa3202$export$2e2bcd8739ae039 = $c1afa5bbb4fa3202$var$getMapData;

});
parcelRegister("ioC4d", function(module, exports) {

$parcel$export(module.exports, "default", () => $d647ff2f67c35356$export$2e2bcd8739ae039);
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $d647ff2f67c35356$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $d647ff2f67c35356$export$2e2bcd8739ae039 = $d647ff2f67c35356$var$isKeyable;

});



parcelRegister("h6dO4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c72db4ec3646c0a0$export$2e2bcd8739ae039);

var $gCZaO = parcelRequire("gCZaO");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $c72db4ec3646c0a0$var$mapCacheGet(key) {
    return (0, $gCZaO.default)(this, key).get(key);
}
var $c72db4ec3646c0a0$export$2e2bcd8739ae039 = $c72db4ec3646c0a0$var$mapCacheGet;

});

parcelRegister("bvtk1", function(module, exports) {

$parcel$export(module.exports, "default", () => $860955aaef231267$export$2e2bcd8739ae039);

var $gCZaO = parcelRequire("gCZaO");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $860955aaef231267$var$mapCacheHas(key) {
    return (0, $gCZaO.default)(this, key).has(key);
}
var $860955aaef231267$export$2e2bcd8739ae039 = $860955aaef231267$var$mapCacheHas;

});

parcelRegister("1TiHU", function(module, exports) {

$parcel$export(module.exports, "default", () => $1609705a3118bbf0$export$2e2bcd8739ae039);

var $gCZaO = parcelRequire("gCZaO");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $1609705a3118bbf0$var$mapCacheSet(key, value) {
    var data = (0, $gCZaO.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $1609705a3118bbf0$export$2e2bcd8739ae039 = $1609705a3118bbf0$var$mapCacheSet;

});




parcelRegister("8pF4l", function(module, exports) {

$parcel$export(module.exports, "default", () => $620083fb442cd6dc$export$2e2bcd8739ae039);

var $bi6mr = parcelRequire("bi6mr");

var $44Qh5 = parcelRequire("44Qh5");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $620083fb442cd6dc$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !(0, $44Qh5.default)(object[key], value) || value === undefined && !(key in object)) (0, $bi6mr.default)(object, key, value);
}
var $620083fb442cd6dc$export$2e2bcd8739ae039 = $620083fb442cd6dc$var$assignMergeValue;

});
parcelRegister("bi6mr", function(module, exports) {

$parcel$export(module.exports, "default", () => $83864f4939dc3aab$export$2e2bcd8739ae039);

var $c1SQo = parcelRequire("c1SQo");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $83864f4939dc3aab$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $c1SQo.default)) (0, $c1SQo.default)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $83864f4939dc3aab$export$2e2bcd8739ae039 = $83864f4939dc3aab$var$baseAssignValue;

});
parcelRegister("c1SQo", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c201eef2d085fe4$export$2e2bcd8739ae039);

var $31iYT = parcelRequire("31iYT");
var $8c201eef2d085fe4$var$defineProperty = function() {
    try {
        var func = (0, $31iYT.default)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $8c201eef2d085fe4$export$2e2bcd8739ae039 = $8c201eef2d085fe4$var$defineProperty;

});



parcelRegister("hepmG", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8b76b6e6e290698$export$2e2bcd8739ae039);

var $fVUU6 = parcelRequire("fVUU6");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $c8b76b6e6e290698$var$baseFor = (0, $fVUU6.default)();
var $c8b76b6e6e290698$export$2e2bcd8739ae039 = $c8b76b6e6e290698$var$baseFor;

});
parcelRegister("fVUU6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b99851cca6661715$export$2e2bcd8739ae039);
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $b99851cca6661715$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
var $b99851cca6661715$export$2e2bcd8739ae039 = $b99851cca6661715$var$createBaseFor;

});


parcelRegister("VDxGB", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ad3ff447c7bc343$export$2e2bcd8739ae039);

var $8pF4l = parcelRequire("8pF4l");

var $4qVZZ = parcelRequire("4qVZZ");

var $9ABB2 = parcelRequire("9ABB2");

var $b0UBG = parcelRequire("b0UBG");

var $8gaby = parcelRequire("8gaby");

var $lpbPE = parcelRequire("lpbPE");

var $5FGuY = parcelRequire("5FGuY");

var $gU2lN = parcelRequire("gU2lN");

var $g4npv = parcelRequire("g4npv");

var $18BVV = parcelRequire("18BVV");

var $laXqR = parcelRequire("laXqR");

var $ggb61 = parcelRequire("ggb61");

var $5tzKv = parcelRequire("5tzKv");

var $dVBd1 = parcelRequire("dVBd1");

var $ho2gQ = parcelRequire("ho2gQ");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $0ad3ff447c7bc343$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = (0, $dVBd1.default)(object, key), srcValue = (0, $dVBd1.default)(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        (0, $8pF4l.default)(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = (0, $5FGuY.default)(srcValue), isBuff = !isArr && (0, $g4npv.default)(srcValue), isTyped = !isArr && !isBuff && (0, $5tzKv.default)(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ((0, $5FGuY.default)(objValue)) newValue = objValue;
            else if ((0, $gU2lN.default)(objValue)) newValue = (0, $b0UBG.default)(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = (0, $4qVZZ.default)(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = (0, $9ABB2.default)(srcValue, true);
            } else newValue = [];
        } else if ((0, $ggb61.default)(srcValue) || (0, $lpbPE.default)(srcValue)) {
            newValue = objValue;
            if ((0, $lpbPE.default)(objValue)) newValue = (0, $ho2gQ.default)(objValue);
            else if (!(0, $laXqR.default)(objValue) || (0, $18BVV.default)(objValue)) newValue = (0, $8gaby.default)(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    (0, $8pF4l.default)(object, key, newValue);
}
var $0ad3ff447c7bc343$export$2e2bcd8739ae039 = $0ad3ff447c7bc343$var$baseMergeDeep;

});
parcelRegister("4qVZZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $33a6948060d53f07$export$2e2bcd8739ae039);

var $4LQN3 = parcelRequire("4LQN3");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $4LQN3.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $33a6948060d53f07$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("9ABB2", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fb4a3b4943c43bf$export$2e2bcd8739ae039);

var $4bMpJ = parcelRequire("4bMpJ");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $6fb4a3b4943c43bf$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $4bMpJ.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $6fb4a3b4943c43bf$export$2e2bcd8739ae039 = $6fb4a3b4943c43bf$var$cloneTypedArray;

});
parcelRegister("4bMpJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $30cdbe87a72a98a6$export$2e2bcd8739ae039);

var $8W9sY = parcelRequire("8W9sY");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $30cdbe87a72a98a6$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $8W9sY.default)(result).set(new (0, $8W9sY.default)(arrayBuffer));
    return result;
}
var $30cdbe87a72a98a6$export$2e2bcd8739ae039 = $30cdbe87a72a98a6$var$cloneArrayBuffer;

});
parcelRegister("8W9sY", function(module, exports) {

$parcel$export(module.exports, "default", () => $681b154fff23bba9$export$2e2bcd8739ae039);

var $4LQN3 = parcelRequire("4LQN3");
/** Built-in value references. */ var $681b154fff23bba9$var$Uint8Array = (0, $4LQN3.default).Uint8Array;
var $681b154fff23bba9$export$2e2bcd8739ae039 = $681b154fff23bba9$var$Uint8Array;

});



parcelRegister("b0UBG", function(module, exports) {

$parcel$export(module.exports, "default", () => $804b9ab8d5768cfb$export$2e2bcd8739ae039);
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $804b9ab8d5768cfb$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $804b9ab8d5768cfb$export$2e2bcd8739ae039 = $804b9ab8d5768cfb$var$copyArray;

});

parcelRegister("8gaby", function(module, exports) {

$parcel$export(module.exports, "default", () => $6037b7eef5f30bec$export$2e2bcd8739ae039);

var $6tj5h = parcelRequire("6tj5h");

var $6fKLs = parcelRequire("6fKLs");

var $aDfK8 = parcelRequire("aDfK8");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $6037b7eef5f30bec$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, $aDfK8.default)(object) ? (0, $6tj5h.default)((0, $6fKLs.default)(object)) : {};
}
var $6037b7eef5f30bec$export$2e2bcd8739ae039 = $6037b7eef5f30bec$var$initCloneObject;

});
parcelRegister("6tj5h", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b64413df322a60e$export$2e2bcd8739ae039);

var $laXqR = parcelRequire("laXqR");
/** Built-in value references. */ var $4b64413df322a60e$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $4b64413df322a60e$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $laXqR.default)(proto)) return {};
        if ($4b64413df322a60e$var$objectCreate) return $4b64413df322a60e$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $4b64413df322a60e$export$2e2bcd8739ae039 = $4b64413df322a60e$var$baseCreate;

});

parcelRegister("6fKLs", function(module, exports) {

$parcel$export(module.exports, "default", () => $48d86b3a3ad1b346$export$2e2bcd8739ae039);

var $lIN3V = parcelRequire("lIN3V");
/** Built-in value references. */ var $48d86b3a3ad1b346$var$getPrototype = (0, $lIN3V.default)(Object.getPrototypeOf, Object);
var $48d86b3a3ad1b346$export$2e2bcd8739ae039 = $48d86b3a3ad1b346$var$getPrototype;

});
parcelRegister("lIN3V", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd03c3ca42816179$export$2e2bcd8739ae039);
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $fd03c3ca42816179$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $fd03c3ca42816179$export$2e2bcd8739ae039 = $fd03c3ca42816179$var$overArg;

});


parcelRegister("aDfK8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bd9c2293404309b$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $7bd9c2293404309b$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $7bd9c2293404309b$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $7bd9c2293404309b$var$objectProto;
    return value === proto;
}
var $7bd9c2293404309b$export$2e2bcd8739ae039 = $7bd9c2293404309b$var$isPrototype;

});


parcelRegister("lpbPE", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9551c5c26311cc3$export$2e2bcd8739ae039);

var $jYt8o = parcelRequire("jYt8o");

var $kmlEc = parcelRequire("kmlEc");
/** Used for built-in method references. */ var $f9551c5c26311cc3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f9551c5c26311cc3$var$hasOwnProperty = $f9551c5c26311cc3$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $f9551c5c26311cc3$var$propertyIsEnumerable = $f9551c5c26311cc3$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $f9551c5c26311cc3$var$isArguments = (0, $jYt8o.default)(function() {
    return arguments;
}()) ? (0, $jYt8o.default) : function(value) {
    return (0, $kmlEc.default)(value) && $f9551c5c26311cc3$var$hasOwnProperty.call(value, 'callee') && !$f9551c5c26311cc3$var$propertyIsEnumerable.call(value, 'callee');
};
var $f9551c5c26311cc3$export$2e2bcd8739ae039 = $f9551c5c26311cc3$var$isArguments;

});
parcelRegister("jYt8o", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8aa385f0279597d$export$2e2bcd8739ae039);

var $fXyl2 = parcelRequire("fXyl2");

var $kmlEc = parcelRequire("kmlEc");
/** `Object#toString` result references. */ var $e8aa385f0279597d$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $e8aa385f0279597d$var$baseIsArguments(value) {
    return (0, $kmlEc.default)(value) && (0, $fXyl2.default)(value) == $e8aa385f0279597d$var$argsTag;
}
var $e8aa385f0279597d$export$2e2bcd8739ae039 = $e8aa385f0279597d$var$baseIsArguments;

});
parcelRegister("kmlEc", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed26a7730a9d7d83$export$2e2bcd8739ae039);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $ed26a7730a9d7d83$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $ed26a7730a9d7d83$export$2e2bcd8739ae039 = $ed26a7730a9d7d83$var$isObjectLike;

});



parcelRegister("5FGuY", function(module, exports) {

$parcel$export(module.exports, "default", () => $4211bf6c05058fa7$export$2e2bcd8739ae039);
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $4211bf6c05058fa7$var$isArray = Array.isArray;
var $4211bf6c05058fa7$export$2e2bcd8739ae039 = $4211bf6c05058fa7$var$isArray;

});

parcelRegister("gU2lN", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4e3b3189bbb282f$export$2e2bcd8739ae039);

var $aKfKc = parcelRequire("aKfKc");

var $kmlEc = parcelRequire("kmlEc");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $c4e3b3189bbb282f$var$isArrayLikeObject(value) {
    return (0, $kmlEc.default)(value) && (0, $aKfKc.default)(value);
}
var $c4e3b3189bbb282f$export$2e2bcd8739ae039 = $c4e3b3189bbb282f$var$isArrayLikeObject;

});
parcelRegister("aKfKc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d2a69bc8e847ea1$export$2e2bcd8739ae039);

var $18BVV = parcelRequire("18BVV");

var $1gcT1 = parcelRequire("1gcT1");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $7d2a69bc8e847ea1$var$isArrayLike(value) {
    return value != null && (0, $1gcT1.default)(value.length) && !(0, $18BVV.default)(value);
}
var $7d2a69bc8e847ea1$export$2e2bcd8739ae039 = $7d2a69bc8e847ea1$var$isArrayLike;

});
parcelRegister("1gcT1", function(module, exports) {

$parcel$export(module.exports, "default", () => $0eb148113ad98fcd$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $0eb148113ad98fcd$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $0eb148113ad98fcd$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $0eb148113ad98fcd$var$MAX_SAFE_INTEGER;
}
var $0eb148113ad98fcd$export$2e2bcd8739ae039 = $0eb148113ad98fcd$var$isLength;

});



parcelRegister("g4npv", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb2f2de17ed116e3$export$2e2bcd8739ae039);

var $4LQN3 = parcelRequire("4LQN3");

var $5MfHI = parcelRequire("5MfHI");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $4LQN3.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $5MfHI.default);
var $bb2f2de17ed116e3$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("5MfHI", function(module, exports) {

$parcel$export(module.exports, "default", () => $434d9df66f95948e$export$2e2bcd8739ae039);
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $434d9df66f95948e$var$stubFalse() {
    return false;
}
var $434d9df66f95948e$export$2e2bcd8739ae039 = $434d9df66f95948e$var$stubFalse;

});


parcelRegister("ggb61", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd66bf6fb52326d5$export$2e2bcd8739ae039);

var $fXyl2 = parcelRequire("fXyl2");

var $6fKLs = parcelRequire("6fKLs");

var $kmlEc = parcelRequire("kmlEc");
/** `Object#toString` result references. */ var $bd66bf6fb52326d5$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $bd66bf6fb52326d5$var$funcProto = Function.prototype, $bd66bf6fb52326d5$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $bd66bf6fb52326d5$var$funcToString = $bd66bf6fb52326d5$var$funcProto.toString;
/** Used to check objects for own properties. */ var $bd66bf6fb52326d5$var$hasOwnProperty = $bd66bf6fb52326d5$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $bd66bf6fb52326d5$var$objectCtorString = $bd66bf6fb52326d5$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $bd66bf6fb52326d5$var$isPlainObject(value) {
    if (!(0, $kmlEc.default)(value) || (0, $fXyl2.default)(value) != $bd66bf6fb52326d5$var$objectTag) return false;
    var proto = (0, $6fKLs.default)(value);
    if (proto === null) return true;
    var Ctor = $bd66bf6fb52326d5$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $bd66bf6fb52326d5$var$funcToString.call(Ctor) == $bd66bf6fb52326d5$var$objectCtorString;
}
var $bd66bf6fb52326d5$export$2e2bcd8739ae039 = $bd66bf6fb52326d5$var$isPlainObject;

});

parcelRegister("5tzKv", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fcb643ac4521c37$export$2e2bcd8739ae039);

var $4k5a5 = parcelRequire("4k5a5");

var $eX79t = parcelRequire("eX79t");

var $5Xc4H = parcelRequire("5Xc4H");
/* Node.js helper references. */ var $3fcb643ac4521c37$var$nodeIsTypedArray = (0, $5Xc4H.default) && (0, $5Xc4H.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $3fcb643ac4521c37$var$isTypedArray = $3fcb643ac4521c37$var$nodeIsTypedArray ? (0, $eX79t.default)($3fcb643ac4521c37$var$nodeIsTypedArray) : (0, $4k5a5.default);
var $3fcb643ac4521c37$export$2e2bcd8739ae039 = $3fcb643ac4521c37$var$isTypedArray;

});
parcelRegister("4k5a5", function(module, exports) {

$parcel$export(module.exports, "default", () => $325d08afc9826f72$export$2e2bcd8739ae039);

var $fXyl2 = parcelRequire("fXyl2");

var $1gcT1 = parcelRequire("1gcT1");

var $kmlEc = parcelRequire("kmlEc");
/** `Object#toString` result references. */ var $325d08afc9826f72$var$argsTag = '[object Arguments]', $325d08afc9826f72$var$arrayTag = '[object Array]', $325d08afc9826f72$var$boolTag = '[object Boolean]', $325d08afc9826f72$var$dateTag = '[object Date]', $325d08afc9826f72$var$errorTag = '[object Error]', $325d08afc9826f72$var$funcTag = '[object Function]', $325d08afc9826f72$var$mapTag = '[object Map]', $325d08afc9826f72$var$numberTag = '[object Number]', $325d08afc9826f72$var$objectTag = '[object Object]', $325d08afc9826f72$var$regexpTag = '[object RegExp]', $325d08afc9826f72$var$setTag = '[object Set]', $325d08afc9826f72$var$stringTag = '[object String]', $325d08afc9826f72$var$weakMapTag = '[object WeakMap]';
var $325d08afc9826f72$var$arrayBufferTag = '[object ArrayBuffer]', $325d08afc9826f72$var$dataViewTag = '[object DataView]', $325d08afc9826f72$var$float32Tag = '[object Float32Array]', $325d08afc9826f72$var$float64Tag = '[object Float64Array]', $325d08afc9826f72$var$int8Tag = '[object Int8Array]', $325d08afc9826f72$var$int16Tag = '[object Int16Array]', $325d08afc9826f72$var$int32Tag = '[object Int32Array]', $325d08afc9826f72$var$uint8Tag = '[object Uint8Array]', $325d08afc9826f72$var$uint8ClampedTag = '[object Uint8ClampedArray]', $325d08afc9826f72$var$uint16Tag = '[object Uint16Array]', $325d08afc9826f72$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $325d08afc9826f72$var$typedArrayTags = {};
$325d08afc9826f72$var$typedArrayTags[$325d08afc9826f72$var$float32Tag] = $325d08afc9826f72$var$typedArrayTags[$325d08afc9826f72$var$float64Tag] = $325d08afc9826f72$var$typedArrayTags[$325d08afc9826f72$var$int8Tag] = $325d08afc9826f72$var$typedArrayTags[$325d08afc9826f72$var$int16Tag] = $325d08afc9826f72$var$typedArrayTags[$325d08afc9826f72$var$int32Tag] = $325d08afc9826f72$var$typedArrayTags[$325d08afc9826f72$var$uint8Tag] = $325d08afc9826f72$var$typedArrayTags[$325d08afc9826f72$var$uint8ClampedTag] = $325d08afc9826f72$var$typedArrayTags[$325d08afc9826f72$var$uint16Tag] = $325d08afc9826f72$var$typedArrayTags[$325d08afc9826f72$var$uint32Tag] = true;
$325d08afc9826f72$var$typedArrayTags[$325d08afc9826f72$var$argsTag] = $325d08afc9826f72$var$typedArrayTags[$325d08afc9826f72$var$arrayTag] = $325d08afc9826f72$var$typedArrayTags[$325d08afc9826f72$var$arrayBufferTag] = $325d08afc9826f72$var$typedArrayTags[$325d08afc9826f72$var$boolTag] = $325d08afc9826f72$var$typedArrayTags[$325d08afc9826f72$var$dataViewTag] = $325d08afc9826f72$var$typedArrayTags[$325d08afc9826f72$var$dateTag] = $325d08afc9826f72$var$typedArrayTags[$325d08afc9826f72$var$errorTag] = $325d08afc9826f72$var$typedArrayTags[$325d08afc9826f72$var$funcTag] = $325d08afc9826f72$var$typedArrayTags[$325d08afc9826f72$var$mapTag] = $325d08afc9826f72$var$typedArrayTags[$325d08afc9826f72$var$numberTag] = $325d08afc9826f72$var$typedArrayTags[$325d08afc9826f72$var$objectTag] = $325d08afc9826f72$var$typedArrayTags[$325d08afc9826f72$var$regexpTag] = $325d08afc9826f72$var$typedArrayTags[$325d08afc9826f72$var$setTag] = $325d08afc9826f72$var$typedArrayTags[$325d08afc9826f72$var$stringTag] = $325d08afc9826f72$var$typedArrayTags[$325d08afc9826f72$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $325d08afc9826f72$var$baseIsTypedArray(value) {
    return (0, $kmlEc.default)(value) && (0, $1gcT1.default)(value.length) && !!$325d08afc9826f72$var$typedArrayTags[(0, $fXyl2.default)(value)];
}
var $325d08afc9826f72$export$2e2bcd8739ae039 = $325d08afc9826f72$var$baseIsTypedArray;

});

parcelRegister("eX79t", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae2c1f988f25fa0d$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $ae2c1f988f25fa0d$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $ae2c1f988f25fa0d$export$2e2bcd8739ae039 = $ae2c1f988f25fa0d$var$baseUnary;

});

parcelRegister("5Xc4H", function(module, exports) {

$parcel$export(module.exports, "default", () => $455bd43f56f78b96$export$2e2bcd8739ae039);

var $4vlAK = parcelRequire("4vlAK");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $4vlAK.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $455bd43f56f78b96$export$2e2bcd8739ae039 = nodeUtil;

});


parcelRegister("dVBd1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a23d76263624ce29$export$2e2bcd8739ae039);
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $a23d76263624ce29$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
var $a23d76263624ce29$export$2e2bcd8739ae039 = $a23d76263624ce29$var$safeGet;

});

parcelRegister("ho2gQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca867074d86637ab$export$2e2bcd8739ae039);

var $2e2mM = parcelRequire("2e2mM");

var $58AyX = parcelRequire("58AyX");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $ca867074d86637ab$var$toPlainObject(value) {
    return (0, $2e2mM.default)(value, (0, $58AyX.default)(value));
}
var $ca867074d86637ab$export$2e2bcd8739ae039 = $ca867074d86637ab$var$toPlainObject;

});
parcelRegister("2e2mM", function(module, exports) {

$parcel$export(module.exports, "default", () => $19eeb982b315b630$export$2e2bcd8739ae039);

var $jtEid = parcelRequire("jtEid");

var $bi6mr = parcelRequire("bi6mr");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $19eeb982b315b630$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $bi6mr.default)(object, key, newValue);
        else (0, $jtEid.default)(object, key, newValue);
    }
    return object;
}
var $19eeb982b315b630$export$2e2bcd8739ae039 = $19eeb982b315b630$var$copyObject;

});
parcelRegister("jtEid", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2dffb16241f7fc8$export$2e2bcd8739ae039);

var $bi6mr = parcelRequire("bi6mr");

var $44Qh5 = parcelRequire("44Qh5");
/** Used for built-in method references. */ var $e2dffb16241f7fc8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e2dffb16241f7fc8$var$hasOwnProperty = $e2dffb16241f7fc8$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $e2dffb16241f7fc8$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($e2dffb16241f7fc8$var$hasOwnProperty.call(object, key) && (0, $44Qh5.default)(objValue, value)) || value === undefined && !(key in object)) (0, $bi6mr.default)(object, key, value);
}
var $e2dffb16241f7fc8$export$2e2bcd8739ae039 = $e2dffb16241f7fc8$var$assignValue;

});


parcelRegister("58AyX", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bda0fbc61ed6c95$export$2e2bcd8739ae039);

var $9yJBQ = parcelRequire("9yJBQ");

var $biKtP = parcelRequire("biKtP");

var $aKfKc = parcelRequire("aKfKc");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $3bda0fbc61ed6c95$var$keysIn(object) {
    return (0, $aKfKc.default)(object) ? (0, $9yJBQ.default)(object, true) : (0, $biKtP.default)(object);
}
var $3bda0fbc61ed6c95$export$2e2bcd8739ae039 = $3bda0fbc61ed6c95$var$keysIn;

});
parcelRegister("9yJBQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f5aab20f3abeaf1$export$2e2bcd8739ae039);

var $fLkB7 = parcelRequire("fLkB7");

var $lpbPE = parcelRequire("lpbPE");

var $5FGuY = parcelRequire("5FGuY");

var $g4npv = parcelRequire("g4npv");

var $9SP6P = parcelRequire("9SP6P");

var $5tzKv = parcelRequire("5tzKv");
/** Used for built-in method references. */ var $6f5aab20f3abeaf1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6f5aab20f3abeaf1$var$hasOwnProperty = $6f5aab20f3abeaf1$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $6f5aab20f3abeaf1$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $5FGuY.default)(value), isArg = !isArr && (0, $lpbPE.default)(value), isBuff = !isArr && !isArg && (0, $g4npv.default)(value), isType = !isArr && !isArg && !isBuff && (0, $5tzKv.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $fLkB7.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $6f5aab20f3abeaf1$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $9SP6P.default)(key, length)))) result.push(key);
    return result;
}
var $6f5aab20f3abeaf1$export$2e2bcd8739ae039 = $6f5aab20f3abeaf1$var$arrayLikeKeys;

});
parcelRegister("fLkB7", function(module, exports) {

$parcel$export(module.exports, "default", () => $b79b391033645424$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $b79b391033645424$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $b79b391033645424$export$2e2bcd8739ae039 = $b79b391033645424$var$baseTimes;

});

parcelRegister("9SP6P", function(module, exports) {

$parcel$export(module.exports, "default", () => $7320cd6bbcc3df4f$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $7320cd6bbcc3df4f$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $7320cd6bbcc3df4f$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $7320cd6bbcc3df4f$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $7320cd6bbcc3df4f$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $7320cd6bbcc3df4f$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $7320cd6bbcc3df4f$export$2e2bcd8739ae039 = $7320cd6bbcc3df4f$var$isIndex;

});


parcelRegister("biKtP", function(module, exports) {

$parcel$export(module.exports, "default", () => $83a56e1f600b168f$export$2e2bcd8739ae039);

var $laXqR = parcelRequire("laXqR");

var $aDfK8 = parcelRequire("aDfK8");

var $3g54T = parcelRequire("3g54T");
/** Used for built-in method references. */ var $83a56e1f600b168f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $83a56e1f600b168f$var$hasOwnProperty = $83a56e1f600b168f$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $83a56e1f600b168f$var$baseKeysIn(object) {
    if (!(0, $laXqR.default)(object)) return (0, $3g54T.default)(object);
    var isProto = (0, $aDfK8.default)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$83a56e1f600b168f$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $83a56e1f600b168f$export$2e2bcd8739ae039 = $83a56e1f600b168f$var$baseKeysIn;

});
parcelRegister("3g54T", function(module, exports) {

$parcel$export(module.exports, "default", () => $25f6ce11aba2af34$export$2e2bcd8739ae039);
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $25f6ce11aba2af34$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $25f6ce11aba2af34$export$2e2bcd8739ae039 = $25f6ce11aba2af34$var$nativeKeysIn;

});






parcelRegister("dLZ6u", function(module, exports) {

$parcel$export(module.exports, "default", () => $a06f1012f60139de$export$2e2bcd8739ae039);

var $7qFSr = parcelRequire("7qFSr");

var $96HvO = parcelRequire("96HvO");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $a06f1012f60139de$var$createAssigner(assigner) {
    return (0, $7qFSr.default)(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && (0, $96HvO.default)(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
var $a06f1012f60139de$export$2e2bcd8739ae039 = $a06f1012f60139de$var$createAssigner;

});
parcelRegister("7qFSr", function(module, exports) {

$parcel$export(module.exports, "default", () => $568b7205d8faa049$export$2e2bcd8739ae039);

var $3erME = parcelRequire("3erME");

var $8FXeb = parcelRequire("8FXeb");

var $aHES1 = parcelRequire("aHES1");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $568b7205d8faa049$var$baseRest(func, start) {
    return (0, $aHES1.default)((0, $8FXeb.default)(func, start, (0, $3erME.default)), func + '');
}
var $568b7205d8faa049$export$2e2bcd8739ae039 = $568b7205d8faa049$var$baseRest;

});
parcelRegister("3erME", function(module, exports) {

$parcel$export(module.exports, "default", () => $25a83b2b69d14b10$export$2e2bcd8739ae039);
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $25a83b2b69d14b10$var$identity(value) {
    return value;
}
var $25a83b2b69d14b10$export$2e2bcd8739ae039 = $25a83b2b69d14b10$var$identity;

});

parcelRegister("8FXeb", function(module, exports) {

$parcel$export(module.exports, "default", () => $65101874bf347397$export$2e2bcd8739ae039);

var $hPnqA = parcelRequire("hPnqA");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $65101874bf347397$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $65101874bf347397$var$overRest(func, start, transform) {
    start = $65101874bf347397$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $65101874bf347397$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, $hPnqA.default)(func, this, otherArgs);
    };
}
var $65101874bf347397$export$2e2bcd8739ae039 = $65101874bf347397$var$overRest;

});
parcelRegister("hPnqA", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfa95f61b57dbca0$export$2e2bcd8739ae039);
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $cfa95f61b57dbca0$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var $cfa95f61b57dbca0$export$2e2bcd8739ae039 = $cfa95f61b57dbca0$var$apply;

});


parcelRegister("aHES1", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cad9f85cc0e0ada$export$2e2bcd8739ae039);

var $fA6u2 = parcelRequire("fA6u2");

var $1f1Yj = parcelRequire("1f1Yj");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $7cad9f85cc0e0ada$var$setToString = (0, $1f1Yj.default)((0, $fA6u2.default));
var $7cad9f85cc0e0ada$export$2e2bcd8739ae039 = $7cad9f85cc0e0ada$var$setToString;

});
parcelRegister("fA6u2", function(module, exports) {

$parcel$export(module.exports, "default", () => $b57f3f45138adeaa$export$2e2bcd8739ae039);

var $3dhGD = parcelRequire("3dhGD");

var $c1SQo = parcelRequire("c1SQo");

var $3erME = parcelRequire("3erME");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $b57f3f45138adeaa$var$baseSetToString = !(0, $c1SQo.default) ? (0, $3erME.default) : function(func, string) {
    return (0, $c1SQo.default)(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': (0, $3dhGD.default)(string),
        'writable': true
    });
};
var $b57f3f45138adeaa$export$2e2bcd8739ae039 = $b57f3f45138adeaa$var$baseSetToString;

});
parcelRegister("3dhGD", function(module, exports) {

$parcel$export(module.exports, "default", () => $25704e36875fa0d0$export$2e2bcd8739ae039);
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $25704e36875fa0d0$var$constant(value) {
    return function() {
        return value;
    };
}
var $25704e36875fa0d0$export$2e2bcd8739ae039 = $25704e36875fa0d0$var$constant;

});


parcelRegister("1f1Yj", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e78b8ba93fe6497$export$2e2bcd8739ae039);
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $0e78b8ba93fe6497$var$HOT_COUNT = 800, $0e78b8ba93fe6497$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0e78b8ba93fe6497$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $0e78b8ba93fe6497$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $0e78b8ba93fe6497$var$nativeNow(), remaining = $0e78b8ba93fe6497$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $0e78b8ba93fe6497$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var $0e78b8ba93fe6497$export$2e2bcd8739ae039 = $0e78b8ba93fe6497$var$shortOut;

});



parcelRegister("96HvO", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a166d2fe07ec70c$export$2e2bcd8739ae039);

var $44Qh5 = parcelRequire("44Qh5");

var $aKfKc = parcelRequire("aKfKc");

var $9SP6P = parcelRequire("9SP6P");

var $laXqR = parcelRequire("laXqR");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $6a166d2fe07ec70c$var$isIterateeCall(value, index, object) {
    if (!(0, $laXqR.default)(object)) return false;
    var type = typeof index;
    if (type == 'number' ? (0, $aKfKc.default)(object) && (0, $9SP6P.default)(index, object.length) : type == 'string' && index in object) return (0, $44Qh5.default)(object[index], value);
    return false;
}
var $6a166d2fe07ec70c$export$2e2bcd8739ae039 = $6a166d2fe07ec70c$var$isIterateeCall;

});



parcelRegister("45gdf", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $2f943492f49ce12a$export$775b6bb06e53a214);
$parcel$export(module.exports, "Attributor", () => $2f943492f49ce12a$export$217610c4183502d0);
$parcel$export(module.exports, "Registry", () => $2f943492f49ce12a$export$4d9facee29974f3);
$parcel$export(module.exports, "ClassAttributor", () => $2f943492f49ce12a$export$651d45509677cf07);
$parcel$export(module.exports, "StyleAttributor", () => $2f943492f49ce12a$export$7c8099bbfe87b94d);
$parcel$export(module.exports, "AttributorStore", () => $2f943492f49ce12a$export$68ad86ab95e8de42);
$parcel$export(module.exports, "LeafBlot", () => $2f943492f49ce12a$export$7420b9c542181544);
$parcel$export(module.exports, "ParentBlot", () => $2f943492f49ce12a$export$e43113f0aad76fe);
$parcel$export(module.exports, "InlineBlot", () => $2f943492f49ce12a$export$f67a34bc25a7a861);
$parcel$export(module.exports, "BlockBlot", () => $2f943492f49ce12a$export$4f7f03641f7bfc8c);
$parcel$export(module.exports, "ContainerBlot", () => $2f943492f49ce12a$export$c898d510319704c0);
$parcel$export(module.exports, "EmbedBlot", () => $2f943492f49ce12a$export$297a1fa96f55f00f);
$parcel$export(module.exports, "ScrollBlot", () => $2f943492f49ce12a$export$7175329dad7a46f1);
$parcel$export(module.exports, "TextBlot", () => $2f943492f49ce12a$export$10ac0c5716409de6);
var $2f943492f49ce12a$export$775b6bb06e53a214 = /* @__PURE__ */ ((Scope2)=>(Scope2[Scope2.TYPE = 3] = "TYPE", Scope2[Scope2.LEVEL = 12] = "LEVEL", Scope2[Scope2.ATTRIBUTE = 13] = "ATTRIBUTE", Scope2[Scope2.BLOT = 14] = "BLOT", Scope2[Scope2.INLINE = 7] = "INLINE", Scope2[Scope2.BLOCK = 11] = "BLOCK", Scope2[Scope2.BLOCK_BLOT = 10] = "BLOCK_BLOT", Scope2[Scope2.INLINE_BLOT = 6] = "INLINE_BLOT", Scope2[Scope2.BLOCK_ATTRIBUTE = 9] = "BLOCK_ATTRIBUTE", Scope2[Scope2.INLINE_ATTRIBUTE = 5] = "INLINE_ATTRIBUTE", Scope2[Scope2.ANY = 15] = "ANY", Scope2))($2f943492f49ce12a$export$775b6bb06e53a214 || {});
class $2f943492f49ce12a$export$217610c4183502d0 {
    constructor(attrName, keyName, options = {}){
        this.attrName = attrName, this.keyName = keyName;
        const attributeBit = $2f943492f49ce12a$export$775b6bb06e53a214.TYPE & $2f943492f49ce12a$export$775b6bb06e53a214.ATTRIBUTE;
        this.scope = options.scope != null ? // Ignore type bits, force attribute bit
        options.scope & $2f943492f49ce12a$export$775b6bb06e53a214.LEVEL | attributeBit : $2f943492f49ce12a$export$775b6bb06e53a214.ATTRIBUTE, options.whitelist != null && (this.whitelist = options.whitelist);
    }
    static keys(node) {
        return Array.from(node.attributes).map((item)=>item.name);
    }
    add(node, value) {
        return this.canAdd(node, value) ? (node.setAttribute(this.keyName, value), !0) : !1;
    }
    canAdd(_node, value) {
        return this.whitelist == null ? !0 : typeof value == "string" ? this.whitelist.indexOf(value.replace(/["']/g, "")) > -1 : this.whitelist.indexOf(value) > -1;
    }
    remove(node) {
        node.removeAttribute(this.keyName);
    }
    value(node) {
        const value = node.getAttribute(this.keyName);
        return this.canAdd(node, value) && value ? value : "";
    }
}
class $2f943492f49ce12a$var$ParchmentError extends Error {
    constructor(message){
        message = "[Parchment] " + message, super(message), this.message = message, this.name = this.constructor.name;
    }
}
const $2f943492f49ce12a$var$_Registry = class _Registry {
    constructor(){
        this.attributes = {}, this.classes = {}, this.tags = {}, this.types = {};
    }
    static find(node, bubble = !1) {
        if (node == null) return null;
        if (this.blots.has(node)) return this.blots.get(node) || null;
        if (bubble) {
            let parentNode = null;
            try {
                parentNode = node.parentNode;
            } catch  {
                return null;
            }
            return this.find(parentNode, bubble);
        }
        return null;
    }
    create(scroll, input, value) {
        const match2 = this.query(input);
        if (match2 == null) throw new $2f943492f49ce12a$var$ParchmentError(`Unable to create ${input} blot`);
        const blotClass = match2, node = // @ts-expect-error Fix me later
        input instanceof Node || input.nodeType === Node.TEXT_NODE ? input : blotClass.create(value), blot = new blotClass(scroll, node, value);
        return _Registry.blots.set(blot.domNode, blot), blot;
    }
    find(node, bubble = !1) {
        return _Registry.find(node, bubble);
    }
    query(query, scope = $2f943492f49ce12a$export$775b6bb06e53a214.ANY) {
        let match2;
        return typeof query == "string" ? match2 = this.types[query] || this.attributes[query] : query instanceof Text || query.nodeType === Node.TEXT_NODE ? match2 = this.types.text : typeof query == "number" ? query & $2f943492f49ce12a$export$775b6bb06e53a214.LEVEL & $2f943492f49ce12a$export$775b6bb06e53a214.BLOCK ? match2 = this.types.block : query & $2f943492f49ce12a$export$775b6bb06e53a214.LEVEL & $2f943492f49ce12a$export$775b6bb06e53a214.INLINE && (match2 = this.types.inline) : query instanceof Element && ((query.getAttribute("class") || "").split(/\s+/).some((name)=>(match2 = this.classes[name], !!match2)), match2 = match2 || this.tags[query.tagName]), match2 == null ? null : "scope" in match2 && scope & $2f943492f49ce12a$export$775b6bb06e53a214.LEVEL & match2.scope && scope & $2f943492f49ce12a$export$775b6bb06e53a214.TYPE & match2.scope ? match2 : null;
    }
    register(...definitions) {
        return definitions.map((definition)=>{
            const isBlot = "blotName" in definition, isAttr = "attrName" in definition;
            if (!isBlot && !isAttr) throw new $2f943492f49ce12a$var$ParchmentError("Invalid definition");
            if (isBlot && definition.blotName === "abstract") throw new $2f943492f49ce12a$var$ParchmentError("Cannot register abstract class");
            const key = isBlot ? definition.blotName : isAttr ? definition.attrName : void 0;
            return this.types[key] = definition, isAttr ? typeof definition.keyName == "string" && (this.attributes[definition.keyName] = definition) : isBlot && (definition.className && (this.classes[definition.className] = definition), definition.tagName && (Array.isArray(definition.tagName) ? definition.tagName = definition.tagName.map((tagName)=>tagName.toUpperCase()) : definition.tagName = definition.tagName.toUpperCase(), (Array.isArray(definition.tagName) ? definition.tagName : [
                definition.tagName
            ]).forEach((tag)=>{
                (this.tags[tag] == null || definition.className == null) && (this.tags[tag] = definition);
            }))), definition;
        });
    }
};
$2f943492f49ce12a$var$_Registry.blots = /* @__PURE__ */ new WeakMap();
let $2f943492f49ce12a$export$4d9facee29974f3 = $2f943492f49ce12a$var$_Registry;
function $2f943492f49ce12a$var$match(node, prefix) {
    return (node.getAttribute("class") || "").split(/\s+/).filter((name)=>name.indexOf(`${prefix}-`) === 0);
}
class $2f943492f49ce12a$var$ClassAttributor extends $2f943492f49ce12a$export$217610c4183502d0 {
    static keys(node) {
        return (node.getAttribute("class") || "").split(/\s+/).map((name)=>name.split("-").slice(0, -1).join("-"));
    }
    add(node, value) {
        return this.canAdd(node, value) ? (this.remove(node), node.classList.add(`${this.keyName}-${value}`), !0) : !1;
    }
    remove(node) {
        $2f943492f49ce12a$var$match(node, this.keyName).forEach((name)=>{
            node.classList.remove(name);
        }), node.classList.length === 0 && node.removeAttribute("class");
    }
    value(node) {
        const value = ($2f943492f49ce12a$var$match(node, this.keyName)[0] || "").slice(this.keyName.length + 1);
        return this.canAdd(node, value) ? value : "";
    }
}
const $2f943492f49ce12a$export$651d45509677cf07 = $2f943492f49ce12a$var$ClassAttributor;
function $2f943492f49ce12a$var$camelize(name) {
    const parts = name.split("-"), rest = parts.slice(1).map((part)=>part[0].toUpperCase() + part.slice(1)).join("");
    return parts[0] + rest;
}
class $2f943492f49ce12a$var$StyleAttributor extends $2f943492f49ce12a$export$217610c4183502d0 {
    static keys(node) {
        return (node.getAttribute("style") || "").split(";").map((value)=>value.split(":")[0].trim());
    }
    add(node, value) {
        return this.canAdd(node, value) ? (node.style[$2f943492f49ce12a$var$camelize(this.keyName)] = value, !0) : !1;
    }
    remove(node) {
        node.style[$2f943492f49ce12a$var$camelize(this.keyName)] = "", node.getAttribute("style") || node.removeAttribute("style");
    }
    value(node) {
        const value = node.style[$2f943492f49ce12a$var$camelize(this.keyName)];
        return this.canAdd(node, value) ? value : "";
    }
}
const $2f943492f49ce12a$export$7c8099bbfe87b94d = $2f943492f49ce12a$var$StyleAttributor;
class $2f943492f49ce12a$var$AttributorStore {
    constructor(domNode){
        this.attributes = {}, this.domNode = domNode, this.build();
    }
    attribute(attribute, value) {
        value ? attribute.add(this.domNode, value) && (attribute.value(this.domNode) != null ? this.attributes[attribute.attrName] = attribute : delete this.attributes[attribute.attrName]) : (attribute.remove(this.domNode), delete this.attributes[attribute.attrName]);
    }
    build() {
        this.attributes = {};
        const blot = $2f943492f49ce12a$export$4d9facee29974f3.find(this.domNode);
        if (blot == null) return;
        const attributes = $2f943492f49ce12a$export$217610c4183502d0.keys(this.domNode), classes = $2f943492f49ce12a$export$651d45509677cf07.keys(this.domNode), styles = $2f943492f49ce12a$export$7c8099bbfe87b94d.keys(this.domNode);
        attributes.concat(classes).concat(styles).forEach((name)=>{
            const attr = blot.scroll.query(name, $2f943492f49ce12a$export$775b6bb06e53a214.ATTRIBUTE);
            attr instanceof $2f943492f49ce12a$export$217610c4183502d0 && (this.attributes[attr.attrName] = attr);
        });
    }
    copy(target) {
        Object.keys(this.attributes).forEach((key)=>{
            const value = this.attributes[key].value(this.domNode);
            target.format(key, value);
        });
    }
    move(target) {
        this.copy(target), Object.keys(this.attributes).forEach((key)=>{
            this.attributes[key].remove(this.domNode);
        }), this.attributes = {};
    }
    values() {
        return Object.keys(this.attributes).reduce((attributes, name)=>(attributes[name] = this.attributes[name].value(this.domNode), attributes), {});
    }
}
const $2f943492f49ce12a$export$68ad86ab95e8de42 = $2f943492f49ce12a$var$AttributorStore, $2f943492f49ce12a$var$_ShadowBlot = class _ShadowBlot {
    constructor(scroll, domNode){
        this.scroll = scroll, this.domNode = domNode, $2f943492f49ce12a$export$4d9facee29974f3.blots.set(domNode, this), this.prev = null, this.next = null;
    }
    static create(rawValue) {
        if (this.tagName == null) throw new $2f943492f49ce12a$var$ParchmentError("Blot definition missing tagName");
        let node, value;
        return Array.isArray(this.tagName) ? (typeof rawValue == "string" ? (value = rawValue.toUpperCase(), parseInt(value, 10).toString() === value && (value = parseInt(value, 10))) : typeof rawValue == "number" && (value = rawValue), typeof value == "number" ? node = document.createElement(this.tagName[value - 1]) : value && this.tagName.indexOf(value) > -1 ? node = document.createElement(value) : node = document.createElement(this.tagName[0])) : node = document.createElement(this.tagName), this.className && node.classList.add(this.className), node;
    }
    // Hack for accessing inherited static methods
    get statics() {
        return this.constructor;
    }
    attach() {}
    clone() {
        const domNode = this.domNode.cloneNode(!1);
        return this.scroll.create(domNode);
    }
    detach() {
        this.parent != null && this.parent.removeChild(this), $2f943492f49ce12a$export$4d9facee29974f3.blots.delete(this.domNode);
    }
    deleteAt(index, length) {
        this.isolate(index, length).remove();
    }
    formatAt(index, length, name, value) {
        const blot = this.isolate(index, length);
        if (this.scroll.query(name, $2f943492f49ce12a$export$775b6bb06e53a214.BLOT) != null && value) blot.wrap(name, value);
        else if (this.scroll.query(name, $2f943492f49ce12a$export$775b6bb06e53a214.ATTRIBUTE) != null) {
            const parent = this.scroll.create(this.statics.scope);
            blot.wrap(parent), parent.format(name, value);
        }
    }
    insertAt(index, value, def) {
        const blot = def == null ? this.scroll.create("text", value) : this.scroll.create(value, def), ref = this.split(index);
        this.parent.insertBefore(blot, ref || void 0);
    }
    isolate(index, length) {
        const target = this.split(index);
        if (target == null) throw new Error("Attempt to isolate at end");
        return target.split(length), target;
    }
    length() {
        return 1;
    }
    offset(root = this.parent) {
        return this.parent == null || this === root ? 0 : this.parent.children.offset(this) + this.parent.offset(root);
    }
    optimize(_context) {
        this.statics.requiredContainer && !(this.parent instanceof this.statics.requiredContainer) && this.wrap(this.statics.requiredContainer.blotName);
    }
    remove() {
        this.domNode.parentNode != null && this.domNode.parentNode.removeChild(this.domNode), this.detach();
    }
    replaceWith(name, value) {
        const replacement = typeof name == "string" ? this.scroll.create(name, value) : name;
        return this.parent != null && (this.parent.insertBefore(replacement, this.next || void 0), this.remove()), replacement;
    }
    split(index, _force) {
        return index === 0 ? this : this.next;
    }
    update(_mutations, _context) {}
    wrap(name, value) {
        const wrapper = typeof name == "string" ? this.scroll.create(name, value) : name;
        if (this.parent != null && this.parent.insertBefore(wrapper, this.next || void 0), typeof wrapper.appendChild != "function") throw new $2f943492f49ce12a$var$ParchmentError(`Cannot wrap ${name}`);
        return wrapper.appendChild(this), wrapper;
    }
};
$2f943492f49ce12a$var$_ShadowBlot.blotName = "abstract";
let $2f943492f49ce12a$var$ShadowBlot = $2f943492f49ce12a$var$_ShadowBlot;
const $2f943492f49ce12a$var$_LeafBlot = class _LeafBlot extends $2f943492f49ce12a$var$ShadowBlot {
    /**
   * Returns the value represented by domNode if it is this Blot's type
   * No checking that domNode can represent this Blot type is required so
   * applications needing it should check externally before calling.
   */ static value(_domNode) {
        return !0;
    }
    /**
   * Given location represented by node and offset from DOM Selection Range,
   * return index to that location.
   */ index(node, offset) {
        return this.domNode === node || this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY ? Math.min(offset, 1) : -1;
    }
    /**
   * Given index to location within blot, return node and offset representing
   * that location, consumable by DOM Selection Range
   */ position(index, _inclusive) {
        let offset = Array.from(this.parent.domNode.childNodes).indexOf(this.domNode);
        return index > 0 && (offset += 1), [
            this.parent.domNode,
            offset
        ];
    }
    /**
   * Return value represented by this blot
   * Should not change without interaction from API or
   * user change detectable by update()
   */ value() {
        return {
            [this.statics.blotName]: this.statics.value(this.domNode) || !0
        };
    }
};
$2f943492f49ce12a$var$_LeafBlot.scope = $2f943492f49ce12a$export$775b6bb06e53a214.INLINE_BLOT;
let $2f943492f49ce12a$var$LeafBlot = $2f943492f49ce12a$var$_LeafBlot;
const $2f943492f49ce12a$export$7420b9c542181544 = $2f943492f49ce12a$var$LeafBlot;
class $2f943492f49ce12a$var$LinkedList {
    constructor(){
        this.head = null, this.tail = null, this.length = 0;
    }
    append(...nodes) {
        if (this.insertBefore(nodes[0], null), nodes.length > 1) {
            const rest = nodes.slice(1);
            this.append(...rest);
        }
    }
    at(index) {
        const next = this.iterator();
        let cur = next();
        for(; cur && index > 0;)index -= 1, cur = next();
        return cur;
    }
    contains(node) {
        const next = this.iterator();
        let cur = next();
        for(; cur;){
            if (cur === node) return !0;
            cur = next();
        }
        return !1;
    }
    indexOf(node) {
        const next = this.iterator();
        let cur = next(), index = 0;
        for(; cur;){
            if (cur === node) return index;
            index += 1, cur = next();
        }
        return -1;
    }
    insertBefore(node, refNode) {
        node != null && (this.remove(node), node.next = refNode, refNode != null ? (node.prev = refNode.prev, refNode.prev != null && (refNode.prev.next = node), refNode.prev = node, refNode === this.head && (this.head = node)) : this.tail != null ? (this.tail.next = node, node.prev = this.tail, this.tail = node) : (node.prev = null, this.head = this.tail = node), this.length += 1);
    }
    offset(target) {
        let index = 0, cur = this.head;
        for(; cur != null;){
            if (cur === target) return index;
            index += cur.length(), cur = cur.next;
        }
        return -1;
    }
    remove(node) {
        this.contains(node) && (node.prev != null && (node.prev.next = node.next), node.next != null && (node.next.prev = node.prev), node === this.head && (this.head = node.next), node === this.tail && (this.tail = node.prev), this.length -= 1);
    }
    iterator(curNode = this.head) {
        return ()=>{
            const ret = curNode;
            return curNode != null && (curNode = curNode.next), ret;
        };
    }
    find(index, inclusive = !1) {
        const next = this.iterator();
        let cur = next();
        for(; cur;){
            const length = cur.length();
            if (index < length || inclusive && index === length && (cur.next == null || cur.next.length() !== 0)) return [
                cur,
                index
            ];
            index -= length, cur = next();
        }
        return [
            null,
            0
        ];
    }
    forEach(callback) {
        const next = this.iterator();
        let cur = next();
        for(; cur;)callback(cur), cur = next();
    }
    forEachAt(index, length, callback) {
        if (length <= 0) return;
        const [startNode, offset] = this.find(index);
        let curIndex = index - offset;
        const next = this.iterator(startNode);
        let cur = next();
        for(; cur && curIndex < index + length;){
            const curLength = cur.length();
            index > curIndex ? callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index)) : callback(cur, 0, Math.min(curLength, index + length - curIndex)), curIndex += curLength, cur = next();
        }
    }
    map(callback) {
        return this.reduce((memo, cur)=>(memo.push(callback(cur)), memo), []);
    }
    reduce(callback, memo) {
        const next = this.iterator();
        let cur = next();
        for(; cur;)memo = callback(memo, cur), cur = next();
        return memo;
    }
}
function $2f943492f49ce12a$var$makeAttachedBlot(node, scroll) {
    const found = scroll.find(node);
    if (found) return found;
    try {
        return scroll.create(node);
    } catch  {
        const blot = scroll.create($2f943492f49ce12a$export$775b6bb06e53a214.INLINE);
        return Array.from(node.childNodes).forEach((child)=>{
            blot.domNode.appendChild(child);
        }), node.parentNode && node.parentNode.replaceChild(blot.domNode, node), blot.attach(), blot;
    }
}
const $2f943492f49ce12a$var$_ParentBlot = class _ParentBlot extends $2f943492f49ce12a$var$ShadowBlot {
    constructor(scroll, domNode){
        super(scroll, domNode), this.uiNode = null, this.build();
    }
    appendChild(other) {
        this.insertBefore(other);
    }
    attach() {
        super.attach(), this.children.forEach((child)=>{
            child.attach();
        });
    }
    attachUI(node) {
        this.uiNode != null && this.uiNode.remove(), this.uiNode = node, _ParentBlot.uiClass && this.uiNode.classList.add(_ParentBlot.uiClass), this.uiNode.setAttribute("contenteditable", "false"), this.domNode.insertBefore(this.uiNode, this.domNode.firstChild);
    }
    /**
   * Called during construction, should fill its own children LinkedList.
   */ build() {
        this.children = new $2f943492f49ce12a$var$LinkedList(), Array.from(this.domNode.childNodes).filter((node)=>node !== this.uiNode).reverse().forEach((node)=>{
            try {
                const child = $2f943492f49ce12a$var$makeAttachedBlot(node, this.scroll);
                this.insertBefore(child, this.children.head || void 0);
            } catch (err) {
                if (err instanceof $2f943492f49ce12a$var$ParchmentError) return;
                throw err;
            }
        });
    }
    deleteAt(index, length) {
        if (index === 0 && length === this.length()) return this.remove();
        this.children.forEachAt(index, length, (child, offset, childLength)=>{
            child.deleteAt(offset, childLength);
        });
    }
    descendant(criteria, index = 0) {
        const [child, offset] = this.children.find(index);
        return criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria ? [
            child,
            offset
        ] : child instanceof _ParentBlot ? child.descendant(criteria, offset) : [
            null,
            -1
        ];
    }
    descendants(criteria, index = 0, length = Number.MAX_VALUE) {
        let descendants = [], lengthLeft = length;
        return this.children.forEachAt(index, length, (child, childIndex, childLength)=>{
            (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) && descendants.push(child), child instanceof _ParentBlot && (descendants = descendants.concat(child.descendants(criteria, childIndex, lengthLeft))), lengthLeft -= childLength;
        }), descendants;
    }
    detach() {
        this.children.forEach((child)=>{
            child.detach();
        }), super.detach();
    }
    enforceAllowedChildren() {
        let done = !1;
        this.children.forEach((child)=>{
            done || this.statics.allowedChildren.some((def)=>child instanceof def) || (child.statics.scope === $2f943492f49ce12a$export$775b6bb06e53a214.BLOCK_BLOT ? (child.next != null && this.splitAfter(child), child.prev != null && this.splitAfter(child.prev), child.parent.unwrap(), done = !0) : child instanceof _ParentBlot ? child.unwrap() : child.remove());
        });
    }
    formatAt(index, length, name, value) {
        this.children.forEachAt(index, length, (child, offset, childLength)=>{
            child.formatAt(offset, childLength, name, value);
        });
    }
    insertAt(index, value, def) {
        const [child, offset] = this.children.find(index);
        if (child) child.insertAt(offset, value, def);
        else {
            const blot = def == null ? this.scroll.create("text", value) : this.scroll.create(value, def);
            this.appendChild(blot);
        }
    }
    insertBefore(childBlot, refBlot) {
        childBlot.parent != null && childBlot.parent.children.remove(childBlot);
        let refDomNode = null;
        this.children.insertBefore(childBlot, refBlot || null), childBlot.parent = this, refBlot != null && (refDomNode = refBlot.domNode), (this.domNode.parentNode !== childBlot.domNode || this.domNode.nextSibling !== refDomNode) && this.domNode.insertBefore(childBlot.domNode, refDomNode), childBlot.attach();
    }
    length() {
        return this.children.reduce((memo, child)=>memo + child.length(), 0);
    }
    moveChildren(targetParent, refNode) {
        this.children.forEach((child)=>{
            targetParent.insertBefore(child, refNode);
        });
    }
    optimize(context) {
        if (super.optimize(context), this.enforceAllowedChildren(), this.uiNode != null && this.uiNode !== this.domNode.firstChild && this.domNode.insertBefore(this.uiNode, this.domNode.firstChild), this.children.length === 0) {
            if (this.statics.defaultChild != null) {
                const child = this.scroll.create(this.statics.defaultChild.blotName);
                this.appendChild(child);
            } else this.remove();
        }
    }
    path(index, inclusive = !1) {
        const [child, offset] = this.children.find(index, inclusive), position = [
            [
                this,
                index
            ]
        ];
        return child instanceof _ParentBlot ? position.concat(child.path(offset, inclusive)) : (child != null && position.push([
            child,
            offset
        ]), position);
    }
    removeChild(child) {
        this.children.remove(child);
    }
    replaceWith(name, value) {
        const replacement = typeof name == "string" ? this.scroll.create(name, value) : name;
        return replacement instanceof _ParentBlot && this.moveChildren(replacement), super.replaceWith(replacement);
    }
    split(index, force = !1) {
        if (!force) {
            if (index === 0) return this;
            if (index === this.length()) return this.next;
        }
        const after = this.clone();
        return this.parent && this.parent.insertBefore(after, this.next || void 0), this.children.forEachAt(index, this.length(), (child, offset, _length)=>{
            const split = child.split(offset, force);
            split != null && after.appendChild(split);
        }), after;
    }
    splitAfter(child) {
        const after = this.clone();
        for(; child.next != null;)after.appendChild(child.next);
        return this.parent && this.parent.insertBefore(after, this.next || void 0), after;
    }
    unwrap() {
        this.parent && this.moveChildren(this.parent, this.next || void 0), this.remove();
    }
    update(mutations, _context) {
        const addedNodes = [], removedNodes = [];
        mutations.forEach((mutation)=>{
            mutation.target === this.domNode && mutation.type === "childList" && (addedNodes.push(...mutation.addedNodes), removedNodes.push(...mutation.removedNodes));
        }), removedNodes.forEach((node)=>{
            if (node.parentNode != null && // @ts-expect-error Fix me later
            node.tagName !== "IFRAME" && document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) return;
            const blot = this.scroll.find(node);
            blot != null && (blot.domNode.parentNode == null || blot.domNode.parentNode === this.domNode) && blot.detach();
        }), addedNodes.filter((node)=>node.parentNode === this.domNode && node !== this.uiNode).sort((a, b)=>a === b ? 0 : a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? 1 : -1).forEach((node)=>{
            let refBlot = null;
            node.nextSibling != null && (refBlot = this.scroll.find(node.nextSibling));
            const blot = $2f943492f49ce12a$var$makeAttachedBlot(node, this.scroll);
            (blot.next !== refBlot || blot.next == null) && (blot.parent != null && blot.parent.removeChild(this), this.insertBefore(blot, refBlot || void 0));
        }), this.enforceAllowedChildren();
    }
};
$2f943492f49ce12a$var$_ParentBlot.uiClass = "";
let $2f943492f49ce12a$var$ParentBlot = $2f943492f49ce12a$var$_ParentBlot;
const $2f943492f49ce12a$export$e43113f0aad76fe = $2f943492f49ce12a$var$ParentBlot;
function $2f943492f49ce12a$var$isEqual(obj1, obj2) {
    if (Object.keys(obj1).length !== Object.keys(obj2).length) return !1;
    for(const prop in obj1)if (obj1[prop] !== obj2[prop]) return !1;
    return !0;
}
const $2f943492f49ce12a$var$_InlineBlot = class _InlineBlot extends $2f943492f49ce12a$export$e43113f0aad76fe {
    static create(value) {
        return super.create(value);
    }
    static formats(domNode, scroll) {
        const match2 = scroll.query(_InlineBlot.blotName);
        if (!(match2 != null && domNode.tagName === match2.tagName)) {
            if (typeof this.tagName == "string") return !0;
            if (Array.isArray(this.tagName)) return domNode.tagName.toLowerCase();
        }
    }
    constructor(scroll, domNode){
        super(scroll, domNode), this.attributes = new $2f943492f49ce12a$export$68ad86ab95e8de42(this.domNode);
    }
    format(name, value) {
        if (name === this.statics.blotName && !value) this.children.forEach((child)=>{
            child instanceof _InlineBlot || (child = child.wrap(_InlineBlot.blotName, !0)), this.attributes.copy(child);
        }), this.unwrap();
        else {
            const format = this.scroll.query(name, $2f943492f49ce12a$export$775b6bb06e53a214.INLINE);
            if (format == null) return;
            format instanceof $2f943492f49ce12a$export$217610c4183502d0 ? this.attributes.attribute(format, value) : value && (name !== this.statics.blotName || this.formats()[name] !== value) && this.replaceWith(name, value);
        }
    }
    formats() {
        const formats = this.attributes.values(), format = this.statics.formats(this.domNode, this.scroll);
        return format != null && (formats[this.statics.blotName] = format), formats;
    }
    formatAt(index, length, name, value) {
        this.formats()[name] != null || this.scroll.query(name, $2f943492f49ce12a$export$775b6bb06e53a214.ATTRIBUTE) ? this.isolate(index, length).format(name, value) : super.formatAt(index, length, name, value);
    }
    optimize(context) {
        super.optimize(context);
        const formats = this.formats();
        if (Object.keys(formats).length === 0) return this.unwrap();
        const next = this.next;
        next instanceof _InlineBlot && next.prev === this && $2f943492f49ce12a$var$isEqual(formats, next.formats()) && (next.moveChildren(this), next.remove());
    }
    replaceWith(name, value) {
        const replacement = super.replaceWith(name, value);
        return this.attributes.copy(replacement), replacement;
    }
    update(mutations, context) {
        super.update(mutations, context), mutations.some((mutation)=>mutation.target === this.domNode && mutation.type === "attributes") && this.attributes.build();
    }
    wrap(name, value) {
        const wrapper = super.wrap(name, value);
        return wrapper instanceof _InlineBlot && this.attributes.move(wrapper), wrapper;
    }
};
$2f943492f49ce12a$var$_InlineBlot.allowedChildren = [
    $2f943492f49ce12a$var$_InlineBlot,
    $2f943492f49ce12a$export$7420b9c542181544
], $2f943492f49ce12a$var$_InlineBlot.blotName = "inline", $2f943492f49ce12a$var$_InlineBlot.scope = $2f943492f49ce12a$export$775b6bb06e53a214.INLINE_BLOT, $2f943492f49ce12a$var$_InlineBlot.tagName = "SPAN";
let $2f943492f49ce12a$var$InlineBlot = $2f943492f49ce12a$var$_InlineBlot;
const $2f943492f49ce12a$export$f67a34bc25a7a861 = $2f943492f49ce12a$var$InlineBlot, $2f943492f49ce12a$var$_BlockBlot = class _BlockBlot extends $2f943492f49ce12a$export$e43113f0aad76fe {
    static create(value) {
        return super.create(value);
    }
    static formats(domNode, scroll) {
        const match2 = scroll.query(_BlockBlot.blotName);
        if (!(match2 != null && domNode.tagName === match2.tagName)) {
            if (typeof this.tagName == "string") return !0;
            if (Array.isArray(this.tagName)) return domNode.tagName.toLowerCase();
        }
    }
    constructor(scroll, domNode){
        super(scroll, domNode), this.attributes = new $2f943492f49ce12a$export$68ad86ab95e8de42(this.domNode);
    }
    format(name, value) {
        const format = this.scroll.query(name, $2f943492f49ce12a$export$775b6bb06e53a214.BLOCK);
        format != null && (format instanceof $2f943492f49ce12a$export$217610c4183502d0 ? this.attributes.attribute(format, value) : name === this.statics.blotName && !value ? this.replaceWith(_BlockBlot.blotName) : value && (name !== this.statics.blotName || this.formats()[name] !== value) && this.replaceWith(name, value));
    }
    formats() {
        const formats = this.attributes.values(), format = this.statics.formats(this.domNode, this.scroll);
        return format != null && (formats[this.statics.blotName] = format), formats;
    }
    formatAt(index, length, name, value) {
        this.scroll.query(name, $2f943492f49ce12a$export$775b6bb06e53a214.BLOCK) != null ? this.format(name, value) : super.formatAt(index, length, name, value);
    }
    insertAt(index, value, def) {
        if (def == null || this.scroll.query(value, $2f943492f49ce12a$export$775b6bb06e53a214.INLINE) != null) super.insertAt(index, value, def);
        else {
            const after = this.split(index);
            if (after != null) {
                const blot = this.scroll.create(value, def);
                after.parent.insertBefore(blot, after);
            } else throw new Error("Attempt to insertAt after block boundaries");
        }
    }
    replaceWith(name, value) {
        const replacement = super.replaceWith(name, value);
        return this.attributes.copy(replacement), replacement;
    }
    update(mutations, context) {
        super.update(mutations, context), mutations.some((mutation)=>mutation.target === this.domNode && mutation.type === "attributes") && this.attributes.build();
    }
};
$2f943492f49ce12a$var$_BlockBlot.blotName = "block", $2f943492f49ce12a$var$_BlockBlot.scope = $2f943492f49ce12a$export$775b6bb06e53a214.BLOCK_BLOT, $2f943492f49ce12a$var$_BlockBlot.tagName = "P", $2f943492f49ce12a$var$_BlockBlot.allowedChildren = [
    $2f943492f49ce12a$export$f67a34bc25a7a861,
    $2f943492f49ce12a$var$_BlockBlot,
    $2f943492f49ce12a$export$7420b9c542181544
];
let $2f943492f49ce12a$var$BlockBlot = $2f943492f49ce12a$var$_BlockBlot;
const $2f943492f49ce12a$export$4f7f03641f7bfc8c = $2f943492f49ce12a$var$BlockBlot, $2f943492f49ce12a$var$_ContainerBlot = class _ContainerBlot extends $2f943492f49ce12a$export$e43113f0aad76fe {
    checkMerge() {
        return this.next !== null && this.next.statics.blotName === this.statics.blotName;
    }
    deleteAt(index, length) {
        super.deleteAt(index, length), this.enforceAllowedChildren();
    }
    formatAt(index, length, name, value) {
        super.formatAt(index, length, name, value), this.enforceAllowedChildren();
    }
    insertAt(index, value, def) {
        super.insertAt(index, value, def), this.enforceAllowedChildren();
    }
    optimize(context) {
        super.optimize(context), this.children.length > 0 && this.next != null && this.checkMerge() && (this.next.moveChildren(this), this.next.remove());
    }
};
$2f943492f49ce12a$var$_ContainerBlot.blotName = "container", $2f943492f49ce12a$var$_ContainerBlot.scope = $2f943492f49ce12a$export$775b6bb06e53a214.BLOCK_BLOT;
let $2f943492f49ce12a$var$ContainerBlot = $2f943492f49ce12a$var$_ContainerBlot;
const $2f943492f49ce12a$export$c898d510319704c0 = $2f943492f49ce12a$var$ContainerBlot;
class $2f943492f49ce12a$var$EmbedBlot extends $2f943492f49ce12a$export$7420b9c542181544 {
    static formats(_domNode, _scroll) {}
    format(name, value) {
        super.formatAt(0, this.length(), name, value);
    }
    formatAt(index, length, name, value) {
        index === 0 && length === this.length() ? this.format(name, value) : super.formatAt(index, length, name, value);
    }
    formats() {
        return this.statics.formats(this.domNode, this.scroll);
    }
}
const $2f943492f49ce12a$export$297a1fa96f55f00f = $2f943492f49ce12a$var$EmbedBlot, $2f943492f49ce12a$var$OBSERVER_CONFIG = {
    attributes: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
}, $2f943492f49ce12a$var$MAX_OPTIMIZE_ITERATIONS = 100, $2f943492f49ce12a$var$_ScrollBlot = class _ScrollBlot extends $2f943492f49ce12a$export$e43113f0aad76fe {
    constructor(registry, node){
        super(null, node), this.registry = registry, this.scroll = this, this.build(), this.observer = new MutationObserver((mutations)=>{
            this.update(mutations);
        }), this.observer.observe(this.domNode, $2f943492f49ce12a$var$OBSERVER_CONFIG), this.attach();
    }
    create(input, value) {
        return this.registry.create(this, input, value);
    }
    find(node, bubble = !1) {
        const blot = this.registry.find(node, bubble);
        return blot ? blot.scroll === this ? blot : bubble ? this.find(blot.scroll.domNode.parentNode, !0) : null : null;
    }
    query(query, scope = $2f943492f49ce12a$export$775b6bb06e53a214.ANY) {
        return this.registry.query(query, scope);
    }
    register(...definitions) {
        return this.registry.register(...definitions);
    }
    build() {
        this.scroll != null && super.build();
    }
    detach() {
        super.detach(), this.observer.disconnect();
    }
    deleteAt(index, length) {
        this.update(), index === 0 && length === this.length() ? this.children.forEach((child)=>{
            child.remove();
        }) : super.deleteAt(index, length);
    }
    formatAt(index, length, name, value) {
        this.update(), super.formatAt(index, length, name, value);
    }
    insertAt(index, value, def) {
        this.update(), super.insertAt(index, value, def);
    }
    optimize(mutations = [], context = {}) {
        super.optimize(context);
        const mutationsMap = context.mutationsMap || /* @__PURE__ */ new WeakMap();
        let records = Array.from(this.observer.takeRecords());
        for(; records.length > 0;)mutations.push(records.pop());
        const mark = (blot, markParent = !0)=>{
            blot == null || blot === this || blot.domNode.parentNode != null && (mutationsMap.has(blot.domNode) || mutationsMap.set(blot.domNode, []), markParent && mark(blot.parent));
        }, optimize = (blot)=>{
            mutationsMap.has(blot.domNode) && (blot instanceof $2f943492f49ce12a$export$e43113f0aad76fe && blot.children.forEach(optimize), mutationsMap.delete(blot.domNode), blot.optimize(context));
        };
        let remaining = mutations;
        for(let i = 0; remaining.length > 0; i += 1){
            if (i >= $2f943492f49ce12a$var$MAX_OPTIMIZE_ITERATIONS) throw new Error("[Parchment] Maximum optimize iterations reached");
            for(remaining.forEach((mutation)=>{
                const blot = this.find(mutation.target, !0);
                blot != null && (blot.domNode === mutation.target && (mutation.type === "childList" ? (mark(this.find(mutation.previousSibling, !1)), Array.from(mutation.addedNodes).forEach((node)=>{
                    const child = this.find(node, !1);
                    mark(child, !1), child instanceof $2f943492f49ce12a$export$e43113f0aad76fe && child.children.forEach((grandChild)=>{
                        mark(grandChild, !1);
                    });
                })) : mutation.type === "attributes" && mark(blot.prev)), mark(blot));
            }), this.children.forEach(optimize), remaining = Array.from(this.observer.takeRecords()), records = remaining.slice(); records.length > 0;)mutations.push(records.pop());
        }
    }
    update(mutations, context = {}) {
        mutations = mutations || this.observer.takeRecords();
        const mutationsMap = /* @__PURE__ */ new WeakMap();
        mutations.map((mutation)=>{
            const blot = this.find(mutation.target, !0);
            return blot == null ? null : mutationsMap.has(blot.domNode) ? (mutationsMap.get(blot.domNode).push(mutation), null) : (mutationsMap.set(blot.domNode, [
                mutation
            ]), blot);
        }).forEach((blot)=>{
            blot != null && blot !== this && mutationsMap.has(blot.domNode) && blot.update(mutationsMap.get(blot.domNode) || [], context);
        }), context.mutationsMap = mutationsMap, mutationsMap.has(this.domNode) && super.update(mutationsMap.get(this.domNode), context), this.optimize(mutations, context);
    }
};
$2f943492f49ce12a$var$_ScrollBlot.blotName = "scroll", $2f943492f49ce12a$var$_ScrollBlot.defaultChild = $2f943492f49ce12a$export$4f7f03641f7bfc8c, $2f943492f49ce12a$var$_ScrollBlot.allowedChildren = [
    $2f943492f49ce12a$export$4f7f03641f7bfc8c,
    $2f943492f49ce12a$export$c898d510319704c0
], $2f943492f49ce12a$var$_ScrollBlot.scope = $2f943492f49ce12a$export$775b6bb06e53a214.BLOCK_BLOT, $2f943492f49ce12a$var$_ScrollBlot.tagName = "DIV";
let $2f943492f49ce12a$var$ScrollBlot = $2f943492f49ce12a$var$_ScrollBlot;
const $2f943492f49ce12a$export$7175329dad7a46f1 = $2f943492f49ce12a$var$ScrollBlot, $2f943492f49ce12a$var$_TextBlot = class _TextBlot extends $2f943492f49ce12a$export$7420b9c542181544 {
    static create(value) {
        return document.createTextNode(value);
    }
    static value(domNode) {
        return domNode.data;
    }
    constructor(scroll, node){
        super(scroll, node), this.text = this.statics.value(this.domNode);
    }
    deleteAt(index, length) {
        this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
    }
    index(node, offset) {
        return this.domNode === node ? offset : -1;
    }
    insertAt(index, value, def) {
        def == null ? (this.text = this.text.slice(0, index) + value + this.text.slice(index), this.domNode.data = this.text) : super.insertAt(index, value, def);
    }
    length() {
        return this.text.length;
    }
    optimize(context) {
        super.optimize(context), this.text = this.statics.value(this.domNode), this.text.length === 0 ? this.remove() : this.next instanceof _TextBlot && this.next.prev === this && (this.insertAt(this.length(), this.next.value()), this.next.remove());
    }
    position(index, _inclusive = !1) {
        return [
            this.domNode,
            index
        ];
    }
    split(index, force = !1) {
        if (!force) {
            if (index === 0) return this;
            if (index === this.length()) return this.next;
        }
        const after = this.scroll.create(this.domNode.splitText(index));
        return this.parent.insertBefore(after, this.next || void 0), this.text = this.statics.value(this.domNode), after;
    }
    update(mutations, _context) {
        mutations.some((mutation)=>mutation.type === "characterData" && mutation.target === this.domNode) && (this.text = this.statics.value(this.domNode));
    }
    value() {
        return this.text;
    }
};
$2f943492f49ce12a$var$_TextBlot.blotName = "text", $2f943492f49ce12a$var$_TextBlot.scope = $2f943492f49ce12a$export$775b6bb06e53a214.INLINE_BLOT;
let $2f943492f49ce12a$var$TextBlot = $2f943492f49ce12a$var$_TextBlot;
const $2f943492f49ce12a$export$10ac0c5716409de6 = $2f943492f49ce12a$var$TextBlot;

});

parcelRegister("ehD63", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AttributeMap = module.exports.OpIterator = module.exports.Op = void 0;

var $9pwAz = parcelRequire("9pwAz");

var $5TqHm = parcelRequire("5TqHm");

var $kJrLa = parcelRequire("kJrLa");

var $crM0e = parcelRequire("crM0e");
module.exports.AttributeMap = $crM0e.default;

var $btvN9 = parcelRequire("btvN9");
module.exports.Op = $btvN9.default;

var $lAZzT = parcelRequire("lAZzT");
module.exports.OpIterator = $lAZzT.default;
const $a660fafc35ff360c$var$NULL_CHARACTER = String.fromCharCode(0); // Placeholder char for embed in diff()
const $a660fafc35ff360c$var$getEmbedTypeAndData = (a, b)=>{
    if (typeof a !== 'object' || a === null) throw new Error(`cannot retain a ${typeof a}`);
    if (typeof b !== 'object' || b === null) throw new Error(`cannot retain a ${typeof b}`);
    const embedType = Object.keys(a)[0];
    if (!embedType || embedType !== Object.keys(b)[0]) throw new Error(`embed types not matched: ${embedType} != ${Object.keys(b)[0]}`);
    return [
        embedType,
        a[embedType],
        b[embedType]
    ];
};
class $a660fafc35ff360c$var$Delta {
    constructor(ops){
        // Assume we are given a well formed ops
        if (Array.isArray(ops)) this.ops = ops;
        else if (ops != null && Array.isArray(ops.ops)) this.ops = ops.ops;
        else this.ops = [];
    }
    static registerEmbed(embedType, handler) {
        this.handlers[embedType] = handler;
    }
    static unregisterEmbed(embedType) {
        delete this.handlers[embedType];
    }
    static getHandler(embedType) {
        const handler = this.handlers[embedType];
        if (!handler) throw new Error(`no handlers for embed type "${embedType}"`);
        return handler;
    }
    insert(arg, attributes) {
        const newOp = {};
        if (typeof arg === 'string' && arg.length === 0) return this;
        newOp.insert = arg;
        if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) newOp.attributes = attributes;
        return this.push(newOp);
    }
    delete(length) {
        if (length <= 0) return this;
        return this.push({
            delete: length
        });
    }
    retain(length, attributes) {
        if (typeof length === 'number' && length <= 0) return this;
        const newOp = {
            retain: length
        };
        if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) newOp.attributes = attributes;
        return this.push(newOp);
    }
    push(newOp) {
        let index = this.ops.length;
        let lastOp = this.ops[index - 1];
        newOp = $5TqHm(newOp);
        if (typeof lastOp === 'object') {
            if (typeof newOp.delete === 'number' && typeof lastOp.delete === 'number') {
                this.ops[index - 1] = {
                    delete: lastOp.delete + newOp.delete
                };
                return this;
            }
            // Since it does not matter if we insert before or after deleting at the same index,
            // always prefer to insert first
            if (typeof lastOp.delete === 'number' && newOp.insert != null) {
                index -= 1;
                lastOp = this.ops[index - 1];
                if (typeof lastOp !== 'object') {
                    this.ops.unshift(newOp);
                    return this;
                }
            }
            if ($kJrLa(newOp.attributes, lastOp.attributes)) {
                if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
                    this.ops[index - 1] = {
                        insert: lastOp.insert + newOp.insert
                    };
                    if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes;
                    return this;
                } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
                    this.ops[index - 1] = {
                        retain: lastOp.retain + newOp.retain
                    };
                    if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes;
                    return this;
                }
            }
        }
        if (index === this.ops.length) this.ops.push(newOp);
        else this.ops.splice(index, 0, newOp);
        return this;
    }
    chop() {
        const lastOp = this.ops[this.ops.length - 1];
        if (lastOp && typeof lastOp.retain === 'number' && !lastOp.attributes) this.ops.pop();
        return this;
    }
    filter(predicate) {
        return this.ops.filter(predicate);
    }
    forEach(predicate) {
        this.ops.forEach(predicate);
    }
    map(predicate) {
        return this.ops.map(predicate);
    }
    partition(predicate) {
        const passed = [];
        const failed = [];
        this.forEach((op)=>{
            const target = predicate(op) ? passed : failed;
            target.push(op);
        });
        return [
            passed,
            failed
        ];
    }
    reduce(predicate, initialValue) {
        return this.ops.reduce(predicate, initialValue);
    }
    changeLength() {
        return this.reduce((length, elem)=>{
            if (elem.insert) return length + $btvN9.default.length(elem);
            else if (elem.delete) return length - elem.delete;
            return length;
        }, 0);
    }
    length() {
        return this.reduce((length, elem)=>{
            return length + $btvN9.default.length(elem);
        }, 0);
    }
    slice(start = 0, end = Infinity) {
        const ops = [];
        const iter = new $lAZzT.default(this.ops);
        let index = 0;
        while(index < end && iter.hasNext()){
            let nextOp;
            if (index < start) nextOp = iter.next(start - index);
            else {
                nextOp = iter.next(end - index);
                ops.push(nextOp);
            }
            index += $btvN9.default.length(nextOp);
        }
        return new $a660fafc35ff360c$var$Delta(ops);
    }
    compose(other) {
        const thisIter = new $lAZzT.default(this.ops);
        const otherIter = new $lAZzT.default(other.ops);
        const ops = [];
        const firstOther = otherIter.peek();
        if (firstOther != null && typeof firstOther.retain === 'number' && firstOther.attributes == null) {
            let firstLeft = firstOther.retain;
            while(thisIter.peekType() === 'insert' && thisIter.peekLength() <= firstLeft){
                firstLeft -= thisIter.peekLength();
                ops.push(thisIter.next());
            }
            if (firstOther.retain - firstLeft > 0) otherIter.next(firstOther.retain - firstLeft);
        }
        const delta = new $a660fafc35ff360c$var$Delta(ops);
        while(thisIter.hasNext() || otherIter.hasNext()){
            if (otherIter.peekType() === 'insert') delta.push(otherIter.next());
            else if (thisIter.peekType() === 'delete') delta.push(thisIter.next());
            else {
                const length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                const thisOp = thisIter.next(length);
                const otherOp = otherIter.next(length);
                if (otherOp.retain) {
                    const newOp = {};
                    if (typeof thisOp.retain === 'number') newOp.retain = typeof otherOp.retain === 'number' ? length : otherOp.retain;
                    else if (typeof otherOp.retain === 'number') {
                        if (thisOp.retain == null) newOp.insert = thisOp.insert;
                        else newOp.retain = thisOp.retain;
                    } else {
                        const action = thisOp.retain == null ? 'insert' : 'retain';
                        const [embedType, thisData, otherData] = $a660fafc35ff360c$var$getEmbedTypeAndData(thisOp[action], otherOp.retain);
                        const handler = $a660fafc35ff360c$var$Delta.getHandler(embedType);
                        newOp[action] = {
                            [embedType]: handler.compose(thisData, otherData, action === 'retain')
                        };
                    }
                    // Preserve null when composing with a retain, otherwise remove it for inserts
                    const attributes = $crM0e.default.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
                    if (attributes) newOp.attributes = attributes;
                    delta.push(newOp);
                    // Optimization if rest of other is just retain
                    if (!otherIter.hasNext() && $kJrLa(delta.ops[delta.ops.length - 1], newOp)) {
                        const rest = new $a660fafc35ff360c$var$Delta(thisIter.rest());
                        return delta.concat(rest).chop();
                    }
                // Other op should be delete, we could be an insert or retain
                // Insert + delete cancels out
                } else if (typeof otherOp.delete === 'number' && (typeof thisOp.retain === 'number' || typeof thisOp.retain === 'object' && thisOp.retain !== null)) delta.push(otherOp);
            }
        }
        return delta.chop();
    }
    concat(other) {
        const delta = new $a660fafc35ff360c$var$Delta(this.ops.slice());
        if (other.ops.length > 0) {
            delta.push(other.ops[0]);
            delta.ops = delta.ops.concat(other.ops.slice(1));
        }
        return delta;
    }
    diff(other, cursor) {
        if (this.ops === other.ops) return new $a660fafc35ff360c$var$Delta();
        const strings = [
            this,
            other
        ].map((delta)=>{
            return delta.map((op)=>{
                if (op.insert != null) return typeof op.insert === 'string' ? op.insert : $a660fafc35ff360c$var$NULL_CHARACTER;
                const prep = delta === other ? 'on' : 'with';
                throw new Error('diff() called ' + prep + ' non-document');
            }).join('');
        });
        const retDelta = new $a660fafc35ff360c$var$Delta();
        const diffResult = $9pwAz(strings[0], strings[1], cursor, true);
        const thisIter = new $lAZzT.default(this.ops);
        const otherIter = new $lAZzT.default(other.ops);
        diffResult.forEach((component)=>{
            let length = component[1].length;
            while(length > 0){
                let opLength = 0;
                switch(component[0]){
                    case $9pwAz.INSERT:
                        opLength = Math.min(otherIter.peekLength(), length);
                        retDelta.push(otherIter.next(opLength));
                        break;
                    case $9pwAz.DELETE:
                        opLength = Math.min(length, thisIter.peekLength());
                        thisIter.next(opLength);
                        retDelta.delete(opLength);
                        break;
                    case $9pwAz.EQUAL:
                        opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
                        const thisOp = thisIter.next(opLength);
                        const otherOp = otherIter.next(opLength);
                        if ($kJrLa(thisOp.insert, otherOp.insert)) retDelta.retain(opLength, $crM0e.default.diff(thisOp.attributes, otherOp.attributes));
                        else retDelta.push(otherOp).delete(opLength);
                        break;
                }
                length -= opLength;
            }
        });
        return retDelta.chop();
    }
    eachLine(predicate, newline = '\n') {
        const iter = new $lAZzT.default(this.ops);
        let line = new $a660fafc35ff360c$var$Delta();
        let i = 0;
        while(iter.hasNext()){
            if (iter.peekType() !== 'insert') return;
            const thisOp = iter.peek();
            const start = $btvN9.default.length(thisOp) - iter.peekLength();
            const index = typeof thisOp.insert === 'string' ? thisOp.insert.indexOf(newline, start) - start : -1;
            if (index < 0) line.push(iter.next());
            else if (index > 0) line.push(iter.next(index));
            else {
                if (predicate(line, iter.next(1).attributes || {}, i) === false) return;
                i += 1;
                line = new $a660fafc35ff360c$var$Delta();
            }
        }
        if (line.length() > 0) predicate(line, {}, i);
    }
    invert(base) {
        const inverted = new $a660fafc35ff360c$var$Delta();
        this.reduce((baseIndex, op)=>{
            if (op.insert) inverted.delete($btvN9.default.length(op));
            else if (typeof op.retain === 'number' && op.attributes == null) {
                inverted.retain(op.retain);
                return baseIndex + op.retain;
            } else if (op.delete || typeof op.retain === 'number') {
                const length = op.delete || op.retain;
                const slice = base.slice(baseIndex, baseIndex + length);
                slice.forEach((baseOp)=>{
                    if (op.delete) inverted.push(baseOp);
                    else if (op.retain && op.attributes) inverted.retain($btvN9.default.length(baseOp), $crM0e.default.invert(op.attributes, baseOp.attributes));
                });
                return baseIndex + length;
            } else if (typeof op.retain === 'object' && op.retain !== null) {
                const slice = base.slice(baseIndex, baseIndex + 1);
                const baseOp = new $lAZzT.default(slice.ops).next();
                const [embedType, opData, baseOpData] = $a660fafc35ff360c$var$getEmbedTypeAndData(op.retain, baseOp.insert);
                const handler = $a660fafc35ff360c$var$Delta.getHandler(embedType);
                inverted.retain({
                    [embedType]: handler.invert(opData, baseOpData)
                }, $crM0e.default.invert(op.attributes, baseOp.attributes));
                return baseIndex + 1;
            }
            return baseIndex;
        }, 0);
        return inverted.chop();
    }
    transform(arg, priority = false) {
        priority = !!priority;
        if (typeof arg === 'number') return this.transformPosition(arg, priority);
        const other = arg;
        const thisIter = new $lAZzT.default(this.ops);
        const otherIter = new $lAZzT.default(other.ops);
        const delta = new $a660fafc35ff360c$var$Delta();
        while(thisIter.hasNext() || otherIter.hasNext()){
            if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) delta.retain($btvN9.default.length(thisIter.next()));
            else if (otherIter.peekType() === 'insert') delta.push(otherIter.next());
            else {
                const length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                const thisOp = thisIter.next(length);
                const otherOp = otherIter.next(length);
                if (thisOp.delete) continue;
                else if (otherOp.delete) delta.push(otherOp);
                else {
                    const thisData = thisOp.retain;
                    const otherData = otherOp.retain;
                    let transformedData = typeof otherData === 'object' && otherData !== null ? otherData : length;
                    if (typeof thisData === 'object' && thisData !== null && typeof otherData === 'object' && otherData !== null) {
                        const embedType = Object.keys(thisData)[0];
                        if (embedType === Object.keys(otherData)[0]) {
                            const handler = $a660fafc35ff360c$var$Delta.getHandler(embedType);
                            if (handler) transformedData = {
                                [embedType]: handler.transform(thisData[embedType], otherData[embedType], priority)
                            };
                        }
                    }
                    // We retain either their retain or insert
                    delta.retain(transformedData, $crM0e.default.transform(thisOp.attributes, otherOp.attributes, priority));
                }
            }
        }
        return delta.chop();
    }
    transformPosition(index, priority = false) {
        priority = !!priority;
        const thisIter = new $lAZzT.default(this.ops);
        let offset = 0;
        while(thisIter.hasNext() && offset <= index){
            const length = thisIter.peekLength();
            const nextType = thisIter.peekType();
            thisIter.next();
            if (nextType === 'delete') {
                index -= Math.min(length, index - offset);
                continue;
            } else if (nextType === 'insert' && (offset < index || !priority)) index += length;
            offset += length;
        }
        return index;
    }
}
$a660fafc35ff360c$var$Delta.Op = $btvN9.default;
$a660fafc35ff360c$var$Delta.OpIterator = $lAZzT.default;
$a660fafc35ff360c$var$Delta.AttributeMap = $crM0e.default;
$a660fafc35ff360c$var$Delta.handlers = {};
module.exports.default = $a660fafc35ff360c$var$Delta;
module.exports = $a660fafc35ff360c$var$Delta;
module.exports.default = $a660fafc35ff360c$var$Delta;

});
parcelRegister("9pwAz", function(module, exports) {
/**
 * This library modifies the diff-patch-match library by Neil Fraser
 * by removing the patch and match functionality and certain advanced
 * options in the diff function. The original license is as follows:
 *
 * ===
 *
 * Diff Match and Patch
 *
 * Copyright 2006 Google Inc.
 * http://code.google.com/p/google-diff-match-patch/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */ var $6d9fba4f60e9ac24$var$DIFF_DELETE = -1;
var $6d9fba4f60e9ac24$var$DIFF_INSERT = 1;
var $6d9fba4f60e9ac24$var$DIFF_EQUAL = 0;
/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {Int|Object} [cursor_pos] Edit position in text1 or object with more info
 * @param {boolean} [cleanup] Apply semantic cleanup before returning.
 * @return {Array} Array of diff tuples.
 */ function $6d9fba4f60e9ac24$var$diff_main(text1, text2, cursor_pos, cleanup, _fix_unicode) {
    // Check for equality
    if (text1 === text2) {
        if (text1) return [
            [
                $6d9fba4f60e9ac24$var$DIFF_EQUAL,
                text1
            ]
        ];
        return [];
    }
    if (cursor_pos != null) {
        var editdiff = $6d9fba4f60e9ac24$var$find_cursor_edit_diff(text1, text2, cursor_pos);
        if (editdiff) return editdiff;
    }
    // Trim off common prefix (speedup).
    var commonlength = $6d9fba4f60e9ac24$var$diff_commonPrefix(text1, text2);
    var commonprefix = text1.substring(0, commonlength);
    text1 = text1.substring(commonlength);
    text2 = text2.substring(commonlength);
    // Trim off common suffix (speedup).
    commonlength = $6d9fba4f60e9ac24$var$diff_commonSuffix(text1, text2);
    var commonsuffix = text1.substring(text1.length - commonlength);
    text1 = text1.substring(0, text1.length - commonlength);
    text2 = text2.substring(0, text2.length - commonlength);
    // Compute the diff on the middle block.
    var diffs = $6d9fba4f60e9ac24$var$diff_compute_(text1, text2);
    // Restore the prefix and suffix.
    if (commonprefix) diffs.unshift([
        $6d9fba4f60e9ac24$var$DIFF_EQUAL,
        commonprefix
    ]);
    if (commonsuffix) diffs.push([
        $6d9fba4f60e9ac24$var$DIFF_EQUAL,
        commonsuffix
    ]);
    $6d9fba4f60e9ac24$var$diff_cleanupMerge(diffs, _fix_unicode);
    if (cleanup) $6d9fba4f60e9ac24$var$diff_cleanupSemantic(diffs);
    return diffs;
}
/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 */ function $6d9fba4f60e9ac24$var$diff_compute_(text1, text2) {
    var diffs;
    if (!text1) // Just add some text (speedup).
    return [
        [
            $6d9fba4f60e9ac24$var$DIFF_INSERT,
            text2
        ]
    ];
    if (!text2) // Just delete some text (speedup).
    return [
        [
            $6d9fba4f60e9ac24$var$DIFF_DELETE,
            text1
        ]
    ];
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    var i = longtext.indexOf(shorttext);
    if (i !== -1) {
        // Shorter text is inside the longer text (speedup).
        diffs = [
            [
                $6d9fba4f60e9ac24$var$DIFF_INSERT,
                longtext.substring(0, i)
            ],
            [
                $6d9fba4f60e9ac24$var$DIFF_EQUAL,
                shorttext
            ],
            [
                $6d9fba4f60e9ac24$var$DIFF_INSERT,
                longtext.substring(i + shorttext.length)
            ]
        ];
        // Swap insertions for deletions if diff is reversed.
        if (text1.length > text2.length) diffs[0][0] = diffs[2][0] = $6d9fba4f60e9ac24$var$DIFF_DELETE;
        return diffs;
    }
    if (shorttext.length === 1) // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [
        [
            $6d9fba4f60e9ac24$var$DIFF_DELETE,
            text1
        ],
        [
            $6d9fba4f60e9ac24$var$DIFF_INSERT,
            text2
        ]
    ];
    // Check to see if the problem can be split in two.
    var hm = $6d9fba4f60e9ac24$var$diff_halfMatch_(text1, text2);
    if (hm) {
        // A half-match was found, sort out the return data.
        var text1_a = hm[0];
        var text1_b = hm[1];
        var text2_a = hm[2];
        var text2_b = hm[3];
        var mid_common = hm[4];
        // Send both pairs off for separate processing.
        var diffs_a = $6d9fba4f60e9ac24$var$diff_main(text1_a, text2_a);
        var diffs_b = $6d9fba4f60e9ac24$var$diff_main(text1_b, text2_b);
        // Merge the results.
        return diffs_a.concat([
            [
                $6d9fba4f60e9ac24$var$DIFF_EQUAL,
                mid_common
            ]
        ], diffs_b);
    }
    return $6d9fba4f60e9ac24$var$diff_bisect_(text1, text2);
}
/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 * @private
 */ function $6d9fba4f60e9ac24$var$diff_bisect_(text1, text2) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    var max_d = Math.ceil((text1_length + text2_length) / 2);
    var v_offset = max_d;
    var v_length = 2 * max_d;
    var v1 = new Array(v_length);
    var v2 = new Array(v_length);
    // Setting all elements to -1 is faster in Chrome & Firefox than mixing
    // integers and undefined.
    for(var x = 0; x < v_length; x++){
        v1[x] = -1;
        v2[x] = -1;
    }
    v1[v_offset + 1] = 0;
    v2[v_offset + 1] = 0;
    var delta = text1_length - text2_length;
    // If the total number of characters is odd, then the front path will collide
    // with the reverse path.
    var front = delta % 2 !== 0;
    // Offsets for start and end of k loop.
    // Prevents mapping of space beyond the grid.
    var k1start = 0;
    var k1end = 0;
    var k2start = 0;
    var k2end = 0;
    for(var d = 0; d < max_d; d++){
        // Walk the front path one step.
        for(var k1 = -d + k1start; k1 <= d - k1end; k1 += 2){
            var k1_offset = v_offset + k1;
            var x1;
            if (k1 === -d || k1 !== d && v1[k1_offset - 1] < v1[k1_offset + 1]) x1 = v1[k1_offset + 1];
            else x1 = v1[k1_offset - 1] + 1;
            var y1 = x1 - k1;
            while(x1 < text1_length && y1 < text2_length && text1.charAt(x1) === text2.charAt(y1)){
                x1++;
                y1++;
            }
            v1[k1_offset] = x1;
            if (x1 > text1_length) // Ran off the right of the graph.
            k1end += 2;
            else if (y1 > text2_length) // Ran off the bottom of the graph.
            k1start += 2;
            else if (front) {
                var k2_offset = v_offset + delta - k1;
                if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] !== -1) {
                    // Mirror x2 onto top-left coordinate system.
                    var x2 = text1_length - v2[k2_offset];
                    if (x1 >= x2) // Overlap detected.
                    return $6d9fba4f60e9ac24$var$diff_bisectSplit_(text1, text2, x1, y1);
                }
            }
        }
        // Walk the reverse path one step.
        for(var k2 = -d + k2start; k2 <= d - k2end; k2 += 2){
            var k2_offset = v_offset + k2;
            var x2;
            if (k2 === -d || k2 !== d && v2[k2_offset - 1] < v2[k2_offset + 1]) x2 = v2[k2_offset + 1];
            else x2 = v2[k2_offset - 1] + 1;
            var y2 = x2 - k2;
            while(x2 < text1_length && y2 < text2_length && text1.charAt(text1_length - x2 - 1) === text2.charAt(text2_length - y2 - 1)){
                x2++;
                y2++;
            }
            v2[k2_offset] = x2;
            if (x2 > text1_length) // Ran off the left of the graph.
            k2end += 2;
            else if (y2 > text2_length) // Ran off the top of the graph.
            k2start += 2;
            else if (!front) {
                var k1_offset = v_offset + delta - k2;
                if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] !== -1) {
                    var x1 = v1[k1_offset];
                    var y1 = v_offset + x1 - k1_offset;
                    // Mirror x2 onto top-left coordinate system.
                    x2 = text1_length - x2;
                    if (x1 >= x2) // Overlap detected.
                    return $6d9fba4f60e9ac24$var$diff_bisectSplit_(text1, text2, x1, y1);
                }
            }
        }
    }
    // Diff took too long and hit the deadline or
    // number of diffs equals number of characters, no commonality at all.
    return [
        [
            $6d9fba4f60e9ac24$var$DIFF_DELETE,
            text1
        ],
        [
            $6d9fba4f60e9ac24$var$DIFF_INSERT,
            text2
        ]
    ];
}
/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @return {Array} Array of diff tuples.
 */ function $6d9fba4f60e9ac24$var$diff_bisectSplit_(text1, text2, x, y) {
    var text1a = text1.substring(0, x);
    var text2a = text2.substring(0, y);
    var text1b = text1.substring(x);
    var text2b = text2.substring(y);
    // Compute both diffs serially.
    var diffs = $6d9fba4f60e9ac24$var$diff_main(text1a, text2a);
    var diffsb = $6d9fba4f60e9ac24$var$diff_main(text1b, text2b);
    return diffs.concat(diffsb);
}
/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */ function $6d9fba4f60e9ac24$var$diff_commonPrefix(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.charAt(0) !== text2.charAt(0)) return 0;
    // Binary search.
    // Performance analysis: http://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerstart = 0;
    while(pointermin < pointermid){
        if (text1.substring(pointerstart, pointermid) == text2.substring(pointerstart, pointermid)) {
            pointermin = pointermid;
            pointerstart = pointermin;
        } else pointermax = pointermid;
        pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    if ($6d9fba4f60e9ac24$var$is_surrogate_pair_start(text1.charCodeAt(pointermid - 1))) pointermid--;
    return pointermid;
}
/**
 * Determine if the suffix of one string is the prefix of another.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of the first
 *     string and the start of the second string.
 * @private
 */ function $6d9fba4f60e9ac24$var$diff_commonOverlap_(text1, text2) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    // Eliminate the null case.
    if (text1_length == 0 || text2_length == 0) return 0;
    // Truncate the longer string.
    if (text1_length > text2_length) text1 = text1.substring(text1_length - text2_length);
    else if (text1_length < text2_length) text2 = text2.substring(0, text1_length);
    var text_length = Math.min(text1_length, text2_length);
    // Quick check for the worst case.
    if (text1 == text2) return text_length;
    // Start by looking for a single character match
    // and increase length until no match is found.
    // Performance analysis: http://neil.fraser.name/news/2010/11/04/
    var best = 0;
    var length = 1;
    while(true){
        var pattern = text1.substring(text_length - length);
        var found = text2.indexOf(pattern);
        if (found == -1) return best;
        length += found;
        if (found == 0 || text1.substring(text_length - length) == text2.substring(0, length)) {
            best = length;
            length++;
        }
    }
}
/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */ function $6d9fba4f60e9ac24$var$diff_commonSuffix(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.slice(-1) !== text2.slice(-1)) return 0;
    // Binary search.
    // Performance analysis: http://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerend = 0;
    while(pointermin < pointermid){
        if (text1.substring(text1.length - pointermid, text1.length - pointerend) == text2.substring(text2.length - pointermid, text2.length - pointerend)) {
            pointermin = pointermid;
            pointerend = pointermin;
        } else pointermax = pointermid;
        pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    if ($6d9fba4f60e9ac24$var$is_surrogate_pair_end(text1.charCodeAt(text1.length - pointermid))) pointermid--;
    return pointermid;
}
/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 */ function $6d9fba4f60e9ac24$var$diff_halfMatch_(text1, text2) {
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    if (longtext.length < 4 || shorttext.length * 2 < longtext.length) return null; // Pointless.
    /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */ function diff_halfMatchI_(longtext, shorttext, i) {
        // Start with a 1/4 length substring at position i as a seed.
        var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
        var j = -1;
        var best_common = "";
        var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
        while((j = shorttext.indexOf(seed, j + 1)) !== -1){
            var prefixLength = $6d9fba4f60e9ac24$var$diff_commonPrefix(longtext.substring(i), shorttext.substring(j));
            var suffixLength = $6d9fba4f60e9ac24$var$diff_commonSuffix(longtext.substring(0, i), shorttext.substring(0, j));
            if (best_common.length < suffixLength + prefixLength) {
                best_common = shorttext.substring(j - suffixLength, j) + shorttext.substring(j, j + prefixLength);
                best_longtext_a = longtext.substring(0, i - suffixLength);
                best_longtext_b = longtext.substring(i + prefixLength);
                best_shorttext_a = shorttext.substring(0, j - suffixLength);
                best_shorttext_b = shorttext.substring(j + prefixLength);
            }
        }
        if (best_common.length * 2 >= longtext.length) return [
            best_longtext_a,
            best_longtext_b,
            best_shorttext_a,
            best_shorttext_b,
            best_common
        ];
        else return null;
    }
    // First check if the second quarter is the seed for a half-match.
    var hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));
    // Check again based on the third quarter.
    var hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));
    var hm;
    if (!hm1 && !hm2) return null;
    else if (!hm2) hm = hm1;
    else if (!hm1) hm = hm2;
    else // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
    // A half-match was found, sort out the return data.
    var text1_a, text1_b, text2_a, text2_b;
    if (text1.length > text2.length) {
        text1_a = hm[0];
        text1_b = hm[1];
        text2_a = hm[2];
        text2_b = hm[3];
    } else {
        text2_a = hm[0];
        text2_b = hm[1];
        text1_a = hm[2];
        text1_b = hm[3];
    }
    var mid_common = hm[4];
    return [
        text1_a,
        text1_b,
        text2_a,
        text2_b,
        mid_common
    ];
}
/**
 * Reduce the number of edits by eliminating semantically trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ function $6d9fba4f60e9ac24$var$diff_cleanupSemantic(diffs) {
    var changes = false;
    var equalities = []; // Stack of indices where equalities are found.
    var equalitiesLength = 0; // Keeping our own length var is faster in JS.
    /** @type {?string} */ var lastequality = null;
    // Always equal to diffs[equalities[equalitiesLength - 1]][1]
    var pointer = 0; // Index of current position.
    // Number of characters that changed prior to the equality.
    var length_insertions1 = 0;
    var length_deletions1 = 0;
    // Number of characters that changed after the equality.
    var length_insertions2 = 0;
    var length_deletions2 = 0;
    while(pointer < diffs.length){
        if (diffs[pointer][0] == $6d9fba4f60e9ac24$var$DIFF_EQUAL) {
            // Equality found.
            equalities[equalitiesLength++] = pointer;
            length_insertions1 = length_insertions2;
            length_deletions1 = length_deletions2;
            length_insertions2 = 0;
            length_deletions2 = 0;
            lastequality = diffs[pointer][1];
        } else {
            // An insertion or deletion.
            if (diffs[pointer][0] == $6d9fba4f60e9ac24$var$DIFF_INSERT) length_insertions2 += diffs[pointer][1].length;
            else length_deletions2 += diffs[pointer][1].length;
            // Eliminate an equality that is smaller or equal to the edits on both
            // sides of it.
            if (lastequality && lastequality.length <= Math.max(length_insertions1, length_deletions1) && lastequality.length <= Math.max(length_insertions2, length_deletions2)) {
                // Duplicate record.
                diffs.splice(equalities[equalitiesLength - 1], 0, [
                    $6d9fba4f60e9ac24$var$DIFF_DELETE,
                    lastequality
                ]);
                // Change second copy to insert.
                diffs[equalities[equalitiesLength - 1] + 1][0] = $6d9fba4f60e9ac24$var$DIFF_INSERT;
                // Throw away the equality we just deleted.
                equalitiesLength--;
                // Throw away the previous equality (it needs to be reevaluated).
                equalitiesLength--;
                pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
                length_insertions1 = 0; // Reset the counters.
                length_deletions1 = 0;
                length_insertions2 = 0;
                length_deletions2 = 0;
                lastequality = null;
                changes = true;
            }
        }
        pointer++;
    }
    // Normalize the diff.
    if (changes) $6d9fba4f60e9ac24$var$diff_cleanupMerge(diffs);
    $6d9fba4f60e9ac24$var$diff_cleanupSemanticLossless(diffs);
    // Find any overlaps between deletions and insertions.
    // e.g: <del>abcxxx</del><ins>xxxdef</ins>
    //   -> <del>abc</del>xxx<ins>def</ins>
    // e.g: <del>xxxabc</del><ins>defxxx</ins>
    //   -> <ins>def</ins>xxx<del>abc</del>
    // Only extract an overlap if it is as big as the edit ahead or behind it.
    pointer = 1;
    while(pointer < diffs.length){
        if (diffs[pointer - 1][0] == $6d9fba4f60e9ac24$var$DIFF_DELETE && diffs[pointer][0] == $6d9fba4f60e9ac24$var$DIFF_INSERT) {
            var deletion = diffs[pointer - 1][1];
            var insertion = diffs[pointer][1];
            var overlap_length1 = $6d9fba4f60e9ac24$var$diff_commonOverlap_(deletion, insertion);
            var overlap_length2 = $6d9fba4f60e9ac24$var$diff_commonOverlap_(insertion, deletion);
            if (overlap_length1 >= overlap_length2) {
                if (overlap_length1 >= deletion.length / 2 || overlap_length1 >= insertion.length / 2) {
                    // Overlap found.  Insert an equality and trim the surrounding edits.
                    diffs.splice(pointer, 0, [
                        $6d9fba4f60e9ac24$var$DIFF_EQUAL,
                        insertion.substring(0, overlap_length1)
                    ]);
                    diffs[pointer - 1][1] = deletion.substring(0, deletion.length - overlap_length1);
                    diffs[pointer + 1][1] = insertion.substring(overlap_length1);
                    pointer++;
                }
            } else if (overlap_length2 >= deletion.length / 2 || overlap_length2 >= insertion.length / 2) {
                // Reverse overlap found.
                // Insert an equality and swap and trim the surrounding edits.
                diffs.splice(pointer, 0, [
                    $6d9fba4f60e9ac24$var$DIFF_EQUAL,
                    deletion.substring(0, overlap_length2)
                ]);
                diffs[pointer - 1][0] = $6d9fba4f60e9ac24$var$DIFF_INSERT;
                diffs[pointer - 1][1] = insertion.substring(0, insertion.length - overlap_length2);
                diffs[pointer + 1][0] = $6d9fba4f60e9ac24$var$DIFF_DELETE;
                diffs[pointer + 1][1] = deletion.substring(overlap_length2);
                pointer++;
            }
            pointer++;
        }
        pointer++;
    }
}
var $6d9fba4f60e9ac24$var$nonAlphaNumericRegex_ = /[^a-zA-Z0-9]/;
var $6d9fba4f60e9ac24$var$whitespaceRegex_ = /\s/;
var $6d9fba4f60e9ac24$var$linebreakRegex_ = /[\r\n]/;
var $6d9fba4f60e9ac24$var$blanklineEndRegex_ = /\n\r?\n$/;
var $6d9fba4f60e9ac24$var$blanklineStartRegex_ = /^\r?\n\r?\n/;
/**
 * Look for single edits surrounded on both sides by equalities
 * which can be shifted sideways to align the edit to a word boundary.
 * e.g: The c<ins>at c</ins>ame. -> The <ins>cat </ins>came.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ function $6d9fba4f60e9ac24$var$diff_cleanupSemanticLossless(diffs) {
    /**
   * Given two strings, compute a score representing whether the internal
   * boundary falls on logical boundaries.
   * Scores range from 6 (best) to 0 (worst).
   * Closure, but does not reference any external variables.
   * @param {string} one First string.
   * @param {string} two Second string.
   * @return {number} The score.
   * @private
   */ function diff_cleanupSemanticScore_(one, two) {
        if (!one || !two) // Edges are the best.
        return 6;
        // Each port of this function behaves slightly differently due to
        // subtle differences in each language's definition of things like
        // 'whitespace'.  Since this function's purpose is largely cosmetic,
        // the choice has been made to use each language's native features
        // rather than force total conformity.
        var char1 = one.charAt(one.length - 1);
        var char2 = two.charAt(0);
        var nonAlphaNumeric1 = char1.match($6d9fba4f60e9ac24$var$nonAlphaNumericRegex_);
        var nonAlphaNumeric2 = char2.match($6d9fba4f60e9ac24$var$nonAlphaNumericRegex_);
        var whitespace1 = nonAlphaNumeric1 && char1.match($6d9fba4f60e9ac24$var$whitespaceRegex_);
        var whitespace2 = nonAlphaNumeric2 && char2.match($6d9fba4f60e9ac24$var$whitespaceRegex_);
        var lineBreak1 = whitespace1 && char1.match($6d9fba4f60e9ac24$var$linebreakRegex_);
        var lineBreak2 = whitespace2 && char2.match($6d9fba4f60e9ac24$var$linebreakRegex_);
        var blankLine1 = lineBreak1 && one.match($6d9fba4f60e9ac24$var$blanklineEndRegex_);
        var blankLine2 = lineBreak2 && two.match($6d9fba4f60e9ac24$var$blanklineStartRegex_);
        if (blankLine1 || blankLine2) // Five points for blank lines.
        return 5;
        else if (lineBreak1 || lineBreak2) // Four points for line breaks.
        return 4;
        else if (nonAlphaNumeric1 && !whitespace1 && whitespace2) // Three points for end of sentences.
        return 3;
        else if (whitespace1 || whitespace2) // Two points for whitespace.
        return 2;
        else if (nonAlphaNumeric1 || nonAlphaNumeric2) // One point for non-alphanumeric.
        return 1;
        return 0;
    }
    var pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while(pointer < diffs.length - 1){
        if (diffs[pointer - 1][0] == $6d9fba4f60e9ac24$var$DIFF_EQUAL && diffs[pointer + 1][0] == $6d9fba4f60e9ac24$var$DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            var equality1 = diffs[pointer - 1][1];
            var edit = diffs[pointer][1];
            var equality2 = diffs[pointer + 1][1];
            // First, shift the edit as far left as possible.
            var commonOffset = $6d9fba4f60e9ac24$var$diff_commonSuffix(equality1, edit);
            if (commonOffset) {
                var commonString = edit.substring(edit.length - commonOffset);
                equality1 = equality1.substring(0, equality1.length - commonOffset);
                edit = commonString + edit.substring(0, edit.length - commonOffset);
                equality2 = commonString + equality2;
            }
            // Second, step character by character right, looking for the best fit.
            var bestEquality1 = equality1;
            var bestEdit = edit;
            var bestEquality2 = equality2;
            var bestScore = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
            while(edit.charAt(0) === equality2.charAt(0)){
                equality1 += edit.charAt(0);
                edit = edit.substring(1) + equality2.charAt(0);
                equality2 = equality2.substring(1);
                var score = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
                // The >= encourages trailing rather than leading whitespace on edits.
                if (score >= bestScore) {
                    bestScore = score;
                    bestEquality1 = equality1;
                    bestEdit = edit;
                    bestEquality2 = equality2;
                }
            }
            if (diffs[pointer - 1][1] != bestEquality1) {
                // We have an improvement, save it back to the diff.
                if (bestEquality1) diffs[pointer - 1][1] = bestEquality1;
                else {
                    diffs.splice(pointer - 1, 1);
                    pointer--;
                }
                diffs[pointer][1] = bestEdit;
                if (bestEquality2) diffs[pointer + 1][1] = bestEquality2;
                else {
                    diffs.splice(pointer + 1, 1);
                    pointer--;
                }
            }
        }
        pointer++;
    }
}
/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {Array} diffs Array of diff tuples.
 * @param {boolean} fix_unicode Whether to normalize to a unicode-correct diff
 */ function $6d9fba4f60e9ac24$var$diff_cleanupMerge(diffs, fix_unicode) {
    diffs.push([
        $6d9fba4f60e9ac24$var$DIFF_EQUAL,
        ""
    ]); // Add a dummy entry at the end.
    var pointer = 0;
    var count_delete = 0;
    var count_insert = 0;
    var text_delete = "";
    var text_insert = "";
    var commonlength;
    while(pointer < diffs.length){
        if (pointer < diffs.length - 1 && !diffs[pointer][1]) {
            diffs.splice(pointer, 1);
            continue;
        }
        switch(diffs[pointer][0]){
            case $6d9fba4f60e9ac24$var$DIFF_INSERT:
                count_insert++;
                text_insert += diffs[pointer][1];
                pointer++;
                break;
            case $6d9fba4f60e9ac24$var$DIFF_DELETE:
                count_delete++;
                text_delete += diffs[pointer][1];
                pointer++;
                break;
            case $6d9fba4f60e9ac24$var$DIFF_EQUAL:
                var previous_equality = pointer - count_insert - count_delete - 1;
                if (fix_unicode) {
                    // prevent splitting of unicode surrogate pairs.  when fix_unicode is true,
                    // we assume that the old and new text in the diff are complete and correct
                    // unicode-encoded JS strings, but the tuple boundaries may fall between
                    // surrogate pairs.  we fix this by shaving off stray surrogates from the end
                    // of the previous equality and the beginning of this equality.  this may create
                    // empty equalities or a common prefix or suffix.  for example, if AB and AC are
                    // emojis, `[[0, 'A'], [-1, 'BA'], [0, 'C']]` would turn into deleting 'ABAC' and
                    // inserting 'AC', and then the common suffix 'AC' will be eliminated.  in this
                    // particular case, both equalities go away, we absorb any previous inequalities,
                    // and we keep scanning for the next equality before rewriting the tuples.
                    if (previous_equality >= 0 && $6d9fba4f60e9ac24$var$ends_with_pair_start(diffs[previous_equality][1])) {
                        var stray = diffs[previous_equality][1].slice(-1);
                        diffs[previous_equality][1] = diffs[previous_equality][1].slice(0, -1);
                        text_delete = stray + text_delete;
                        text_insert = stray + text_insert;
                        if (!diffs[previous_equality][1]) {
                            // emptied out previous equality, so delete it and include previous delete/insert
                            diffs.splice(previous_equality, 1);
                            pointer--;
                            var k = previous_equality - 1;
                            if (diffs[k] && diffs[k][0] === $6d9fba4f60e9ac24$var$DIFF_INSERT) {
                                count_insert++;
                                text_insert = diffs[k][1] + text_insert;
                                k--;
                            }
                            if (diffs[k] && diffs[k][0] === $6d9fba4f60e9ac24$var$DIFF_DELETE) {
                                count_delete++;
                                text_delete = diffs[k][1] + text_delete;
                                k--;
                            }
                            previous_equality = k;
                        }
                    }
                    if ($6d9fba4f60e9ac24$var$starts_with_pair_end(diffs[pointer][1])) {
                        var stray = diffs[pointer][1].charAt(0);
                        diffs[pointer][1] = diffs[pointer][1].slice(1);
                        text_delete += stray;
                        text_insert += stray;
                    }
                }
                if (pointer < diffs.length - 1 && !diffs[pointer][1]) {
                    // for empty equality not at end, wait for next equality
                    diffs.splice(pointer, 1);
                    break;
                }
                if (text_delete.length > 0 || text_insert.length > 0) {
                    // note that diff_commonPrefix and diff_commonSuffix are unicode-aware
                    if (text_delete.length > 0 && text_insert.length > 0) {
                        // Factor out any common prefixes.
                        commonlength = $6d9fba4f60e9ac24$var$diff_commonPrefix(text_insert, text_delete);
                        if (commonlength !== 0) {
                            if (previous_equality >= 0) diffs[previous_equality][1] += text_insert.substring(0, commonlength);
                            else {
                                diffs.splice(0, 0, [
                                    $6d9fba4f60e9ac24$var$DIFF_EQUAL,
                                    text_insert.substring(0, commonlength)
                                ]);
                                pointer++;
                            }
                            text_insert = text_insert.substring(commonlength);
                            text_delete = text_delete.substring(commonlength);
                        }
                        // Factor out any common suffixes.
                        commonlength = $6d9fba4f60e9ac24$var$diff_commonSuffix(text_insert, text_delete);
                        if (commonlength !== 0) {
                            diffs[pointer][1] = text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];
                            text_insert = text_insert.substring(0, text_insert.length - commonlength);
                            text_delete = text_delete.substring(0, text_delete.length - commonlength);
                        }
                    }
                    // Delete the offending records and add the merged ones.
                    var n = count_insert + count_delete;
                    if (text_delete.length === 0 && text_insert.length === 0) {
                        diffs.splice(pointer - n, n);
                        pointer = pointer - n;
                    } else if (text_delete.length === 0) {
                        diffs.splice(pointer - n, n, [
                            $6d9fba4f60e9ac24$var$DIFF_INSERT,
                            text_insert
                        ]);
                        pointer = pointer - n + 1;
                    } else if (text_insert.length === 0) {
                        diffs.splice(pointer - n, n, [
                            $6d9fba4f60e9ac24$var$DIFF_DELETE,
                            text_delete
                        ]);
                        pointer = pointer - n + 1;
                    } else {
                        diffs.splice(pointer - n, n, [
                            $6d9fba4f60e9ac24$var$DIFF_DELETE,
                            text_delete
                        ], [
                            $6d9fba4f60e9ac24$var$DIFF_INSERT,
                            text_insert
                        ]);
                        pointer = pointer - n + 2;
                    }
                }
                if (pointer !== 0 && diffs[pointer - 1][0] === $6d9fba4f60e9ac24$var$DIFF_EQUAL) {
                    // Merge this equality with the previous one.
                    diffs[pointer - 1][1] += diffs[pointer][1];
                    diffs.splice(pointer, 1);
                } else pointer++;
                count_insert = 0;
                count_delete = 0;
                text_delete = "";
                text_insert = "";
                break;
        }
    }
    if (diffs[diffs.length - 1][1] === "") diffs.pop(); // Remove the dummy entry at the end.
    // Second pass: look for single edits surrounded on both sides by equalities
    // which can be shifted sideways to eliminate an equality.
    // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
    var changes = false;
    pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while(pointer < diffs.length - 1){
        if (diffs[pointer - 1][0] === $6d9fba4f60e9ac24$var$DIFF_EQUAL && diffs[pointer + 1][0] === $6d9fba4f60e9ac24$var$DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            if (diffs[pointer][1].substring(diffs[pointer][1].length - diffs[pointer - 1][1].length) === diffs[pointer - 1][1]) {
                // Shift the edit over the previous equality.
                diffs[pointer][1] = diffs[pointer - 1][1] + diffs[pointer][1].substring(0, diffs[pointer][1].length - diffs[pointer - 1][1].length);
                diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
                diffs.splice(pointer - 1, 1);
                changes = true;
            } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) == diffs[pointer + 1][1]) {
                // Shift the edit over the next equality.
                diffs[pointer - 1][1] += diffs[pointer + 1][1];
                diffs[pointer][1] = diffs[pointer][1].substring(diffs[pointer + 1][1].length) + diffs[pointer + 1][1];
                diffs.splice(pointer + 1, 1);
                changes = true;
            }
        }
        pointer++;
    }
    // If shifts were made, the diff needs reordering and another shift sweep.
    if (changes) $6d9fba4f60e9ac24$var$diff_cleanupMerge(diffs, fix_unicode);
}
function $6d9fba4f60e9ac24$var$is_surrogate_pair_start(charCode) {
    return charCode >= 0xd800 && charCode <= 0xdbff;
}
function $6d9fba4f60e9ac24$var$is_surrogate_pair_end(charCode) {
    return charCode >= 0xdc00 && charCode <= 0xdfff;
}
function $6d9fba4f60e9ac24$var$starts_with_pair_end(str) {
    return $6d9fba4f60e9ac24$var$is_surrogate_pair_end(str.charCodeAt(0));
}
function $6d9fba4f60e9ac24$var$ends_with_pair_start(str) {
    return $6d9fba4f60e9ac24$var$is_surrogate_pair_start(str.charCodeAt(str.length - 1));
}
function $6d9fba4f60e9ac24$var$remove_empty_tuples(tuples) {
    var ret = [];
    for(var i = 0; i < tuples.length; i++)if (tuples[i][1].length > 0) ret.push(tuples[i]);
    return ret;
}
function $6d9fba4f60e9ac24$var$make_edit_splice(before, oldMiddle, newMiddle, after) {
    if ($6d9fba4f60e9ac24$var$ends_with_pair_start(before) || $6d9fba4f60e9ac24$var$starts_with_pair_end(after)) return null;
    return $6d9fba4f60e9ac24$var$remove_empty_tuples([
        [
            $6d9fba4f60e9ac24$var$DIFF_EQUAL,
            before
        ],
        [
            $6d9fba4f60e9ac24$var$DIFF_DELETE,
            oldMiddle
        ],
        [
            $6d9fba4f60e9ac24$var$DIFF_INSERT,
            newMiddle
        ],
        [
            $6d9fba4f60e9ac24$var$DIFF_EQUAL,
            after
        ]
    ]);
}
function $6d9fba4f60e9ac24$var$find_cursor_edit_diff(oldText, newText, cursor_pos) {
    // note: this runs after equality check has ruled out exact equality
    var oldRange = typeof cursor_pos === "number" ? {
        index: cursor_pos,
        length: 0
    } : cursor_pos.oldRange;
    var newRange = typeof cursor_pos === "number" ? null : cursor_pos.newRange;
    // take into account the old and new selection to generate the best diff
    // possible for a text edit.  for example, a text change from "xxx" to "xx"
    // could be a delete or forwards-delete of any one of the x's, or the
    // result of selecting two of the x's and typing "x".
    var oldLength = oldText.length;
    var newLength = newText.length;
    if (oldRange.length === 0 && (newRange === null || newRange.length === 0)) {
        // see if we have an insert or delete before or after cursor
        var oldCursor = oldRange.index;
        var oldBefore = oldText.slice(0, oldCursor);
        var oldAfter = oldText.slice(oldCursor);
        var maybeNewCursor = newRange ? newRange.index : null;
        editBefore: {
            // is this an insert or delete right before oldCursor?
            var newCursor = oldCursor + newLength - oldLength;
            if (maybeNewCursor !== null && maybeNewCursor !== newCursor) break editBefore;
            if (newCursor < 0 || newCursor > newLength) break editBefore;
            var newBefore = newText.slice(0, newCursor);
            var newAfter = newText.slice(newCursor);
            if (newAfter !== oldAfter) break editBefore;
            var prefixLength = Math.min(oldCursor, newCursor);
            var oldPrefix = oldBefore.slice(0, prefixLength);
            var newPrefix = newBefore.slice(0, prefixLength);
            if (oldPrefix !== newPrefix) break editBefore;
            var oldMiddle = oldBefore.slice(prefixLength);
            var newMiddle = newBefore.slice(prefixLength);
            return $6d9fba4f60e9ac24$var$make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldAfter);
        }
        editAfter: {
            // is this an insert or delete right after oldCursor?
            if (maybeNewCursor !== null && maybeNewCursor !== oldCursor) break editAfter;
            var cursor = oldCursor;
            var newBefore = newText.slice(0, cursor);
            var newAfter = newText.slice(cursor);
            if (newBefore !== oldBefore) break editAfter;
            var suffixLength = Math.min(oldLength - cursor, newLength - cursor);
            var oldSuffix = oldAfter.slice(oldAfter.length - suffixLength);
            var newSuffix = newAfter.slice(newAfter.length - suffixLength);
            if (oldSuffix !== newSuffix) break editAfter;
            var oldMiddle = oldAfter.slice(0, oldAfter.length - suffixLength);
            var newMiddle = newAfter.slice(0, newAfter.length - suffixLength);
            return $6d9fba4f60e9ac24$var$make_edit_splice(oldBefore, oldMiddle, newMiddle, oldSuffix);
        }
    }
    if (oldRange.length > 0 && newRange && newRange.length === 0) replaceRange: {
        // see if diff could be a splice of the old selection range
        var oldPrefix = oldText.slice(0, oldRange.index);
        var oldSuffix = oldText.slice(oldRange.index + oldRange.length);
        var prefixLength = oldPrefix.length;
        var suffixLength = oldSuffix.length;
        if (newLength < prefixLength + suffixLength) break replaceRange;
        var newPrefix = newText.slice(0, prefixLength);
        var newSuffix = newText.slice(newLength - suffixLength);
        if (oldPrefix !== newPrefix || oldSuffix !== newSuffix) break replaceRange;
        var oldMiddle = oldText.slice(prefixLength, oldLength - suffixLength);
        var newMiddle = newText.slice(prefixLength, newLength - suffixLength);
        return $6d9fba4f60e9ac24$var$make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldSuffix);
    }
    return null;
}
function $6d9fba4f60e9ac24$var$diff(text1, text2, cursor_pos, cleanup) {
    // only pass fix_unicode=true at the top level, not when diff_main is
    // recursively invoked
    return $6d9fba4f60e9ac24$var$diff_main(text1, text2, cursor_pos, cleanup, true);
}
$6d9fba4f60e9ac24$var$diff.INSERT = $6d9fba4f60e9ac24$var$DIFF_INSERT;
$6d9fba4f60e9ac24$var$diff.DELETE = $6d9fba4f60e9ac24$var$DIFF_DELETE;
$6d9fba4f60e9ac24$var$diff.EQUAL = $6d9fba4f60e9ac24$var$DIFF_EQUAL;
module.exports = $6d9fba4f60e9ac24$var$diff;

});

parcelRegister("5TqHm", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', promiseTag = '[object Promise]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */ function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
}
/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */ function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
}
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array ? array.length : 0;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__['delete'](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) object[key] = value;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
    var result;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            if (isHostObject(value)) return object ? value : {};
            result = initCloneObject(isFunc ? {} : value);
            if (!isDeep) return copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, baseClone, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (!isArr) var props = isFull ? getAllKeys(value) : keys(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
    });
    return result;
}
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */ function baseCreate(proto) {
    return isObject(proto) ? objectCreate(proto) : {};
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var result = new buffer.constructor(buffer.length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */ function cloneMap(map, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
    return arrayReduce(array, addMapEntry, new map.constructor);
}
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */ function cloneSet(set, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
    return arrayReduce(array, addSetEntry, new set.constructor);
}
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        assignValue(object, key, newValue === undefined ? source[key] : newValue);
    }
    return object;
}
/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, cloneFunc, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return cloneMap(object, isDeep, cloneFunc);
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return cloneSet(object, isDeep, cloneFunc);
        case symbolTag:
            return cloneSymbol(object);
    }
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return baseClone(value, true, true);
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = cloneDeep;

});

parcelRegister("kJrLa", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});

parcelRegister("crM0e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5TqHm = parcelRequire("5TqHm");

var $kJrLa = parcelRequire("kJrLa");
var $90fd3e03c0b52abf$var$AttributeMap;
(function(AttributeMap) {
    function compose(a = {}, b = {}, keepNull = false) {
        if (typeof a !== 'object') a = {};
        if (typeof b !== 'object') b = {};
        let attributes = $5TqHm(b);
        if (!keepNull) attributes = Object.keys(attributes).reduce((copy, key)=>{
            if (attributes[key] != null) copy[key] = attributes[key];
            return copy;
        }, {});
        for(const key in a)if (a[key] !== undefined && b[key] === undefined) attributes[key] = a[key];
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.compose = compose;
    function diff(a = {}, b = {}) {
        if (typeof a !== 'object') a = {};
        if (typeof b !== 'object') b = {};
        const attributes = Object.keys(a).concat(Object.keys(b)).reduce((attrs, key)=>{
            if (!$kJrLa(a[key], b[key])) attrs[key] = b[key] === undefined ? null : b[key];
            return attrs;
        }, {});
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.diff = diff;
    function invert(attr = {}, base = {}) {
        attr = attr || {};
        const baseInverted = Object.keys(base).reduce((memo, key)=>{
            if (base[key] !== attr[key] && attr[key] !== undefined) memo[key] = base[key];
            return memo;
        }, {});
        return Object.keys(attr).reduce((memo, key)=>{
            if (attr[key] !== base[key] && base[key] === undefined) memo[key] = null;
            return memo;
        }, baseInverted);
    }
    AttributeMap.invert = invert;
    function transform(a, b, priority = false) {
        if (typeof a !== 'object') return b;
        if (typeof b !== 'object') return undefined;
        if (!priority) return b; // b simply overwrites us without priority
        const attributes = Object.keys(b).reduce((attrs, key)=>{
            if (a[key] === undefined) attrs[key] = b[key]; // null is a valid value
            return attrs;
        }, {});
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.transform = transform;
})($90fd3e03c0b52abf$var$AttributeMap || ($90fd3e03c0b52abf$var$AttributeMap = {}));
module.exports.default = $90fd3e03c0b52abf$var$AttributeMap;

});

parcelRegister("btvN9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $85ab1052702b29b0$var$Op;
(function(Op) {
    function length(op) {
        if (typeof op.delete === 'number') return op.delete;
        else if (typeof op.retain === 'number') return op.retain;
        else if (typeof op.retain === 'object' && op.retain !== null) return 1;
        else return typeof op.insert === 'string' ? op.insert.length : 1;
    }
    Op.length = length;
})($85ab1052702b29b0$var$Op || ($85ab1052702b29b0$var$Op = {}));
module.exports.default = $85ab1052702b29b0$var$Op;

});

parcelRegister("lAZzT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $btvN9 = parcelRequire("btvN9");
class $fb8cb9d825b9930b$var$Iterator {
    constructor(ops){
        this.ops = ops;
        this.index = 0;
        this.offset = 0;
    }
    hasNext() {
        return this.peekLength() < Infinity;
    }
    next(length) {
        if (!length) length = Infinity;
        const nextOp = this.ops[this.index];
        if (nextOp) {
            const offset = this.offset;
            const opLength = $btvN9.default.length(nextOp);
            if (length >= opLength - offset) {
                length = opLength - offset;
                this.index += 1;
                this.offset = 0;
            } else this.offset += length;
            if (typeof nextOp.delete === 'number') return {
                delete: length
            };
            else {
                const retOp = {};
                if (nextOp.attributes) retOp.attributes = nextOp.attributes;
                if (typeof nextOp.retain === 'number') retOp.retain = length;
                else if (typeof nextOp.retain === 'object' && nextOp.retain !== null) // offset should === 0, length should === 1
                retOp.retain = nextOp.retain;
                else if (typeof nextOp.insert === 'string') retOp.insert = nextOp.insert.substr(offset, length);
                else // offset should === 0, length should === 1
                retOp.insert = nextOp.insert;
                return retOp;
            }
        } else return {
            retain: Infinity
        };
    }
    peek() {
        return this.ops[this.index];
    }
    peekLength() {
        if (this.ops[this.index]) // Should never return 0 if our index is being managed correctly
        return $btvN9.default.length(this.ops[this.index]) - this.offset;
        else return Infinity;
    }
    peekType() {
        const op = this.ops[this.index];
        if (op) {
            if (typeof op.delete === 'number') return 'delete';
            else if (typeof op.retain === 'number' || typeof op.retain === 'object' && op.retain !== null) return 'retain';
            else return 'insert';
        }
        return 'retain';
    }
    rest() {
        if (!this.hasNext()) return [];
        else if (this.offset === 0) return this.ops.slice(this.index);
        else {
            const offset = this.offset;
            const index = this.index;
            const next = this.next();
            const rest = this.ops.slice(this.index);
            this.offset = offset;
            this.index = index;
            return [
                next
            ].concat(rest);
        }
    }
}
module.exports.default = $fb8cb9d825b9930b$var$Iterator;

});


parcelRegister("aRNA0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e95501c9b574ce1$export$2e2bcd8739ae039);

var $buDZz = parcelRequire("buDZz");
var $4vxV0 = parcelRequire("4vxV0");
var $jjgrT = parcelRequire("jjgrT");

var $45gdf = parcelRequire("45gdf");

var $ehD63 = parcelRequire("ehD63");

var $jUBfi = parcelRequire("jUBfi");

var $gkqQr = parcelRequire("gkqQr");

var $9VFAE = parcelRequire("9VFAE");

var $l6ueR = parcelRequire("l6ueR");

var $6EzZS = parcelRequire("6EzZS");
const $7e95501c9b574ce1$var$ASCII = /^[ -~]*$/;
class $7e95501c9b574ce1$var$Editor {
    constructor(scroll){
        this.scroll = scroll;
        this.delta = this.getDelta();
    }
    applyDelta(delta) {
        this.scroll.update();
        let scrollLength = this.scroll.length();
        this.scroll.batchStart();
        const normalizedDelta = $7e95501c9b574ce1$var$normalizeDelta(delta);
        const deleteDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))();
        const normalizedOps = $7e95501c9b574ce1$var$splitOpLines(normalizedDelta.ops.slice());
        normalizedOps.reduce((index, op)=>{
            const length = (0, $ehD63.Op).length(op);
            let attributes = op.attributes || {};
            let isImplicitNewlinePrepended = false;
            let isImplicitNewlineAppended = false;
            if (op.insert != null) {
                deleteDelta.retain(length);
                if (typeof op.insert === 'string') {
                    const text = op.insert;
                    isImplicitNewlineAppended = !text.endsWith('\n') && (scrollLength <= index || !!this.scroll.descendant((0, $jUBfi.BlockEmbed), index)[0]);
                    this.scroll.insertAt(index, text);
                    const [line, offset] = this.scroll.line(index);
                    let formats = (0, $jjgrT.default)({}, (0, $jUBfi.bubbleFormats)(line));
                    if (line instanceof (0, $jUBfi.default)) {
                        const [leaf] = line.descendant((0, $45gdf.LeafBlot), offset);
                        if (leaf) formats = (0, $jjgrT.default)(formats, (0, $jUBfi.bubbleFormats)(leaf));
                    }
                    attributes = (0, $ehD63.AttributeMap).diff(formats, attributes) || {};
                } else if (typeof op.insert === 'object') {
                    const key = Object.keys(op.insert)[0]; // There should only be one key
                    if (key == null) return index;
                    const isInlineEmbed = this.scroll.query(key, (0, $45gdf.Scope).INLINE) != null;
                    if (isInlineEmbed) {
                        if (scrollLength <= index || !!this.scroll.descendant((0, $jUBfi.BlockEmbed), index)[0]) isImplicitNewlineAppended = true;
                    } else if (index > 0) {
                        const [leaf, offset] = this.scroll.descendant((0, $45gdf.LeafBlot), index - 1);
                        if (leaf instanceof (0, $l6ueR.default)) {
                            const text = leaf.value();
                            if (text[offset] !== '\n') isImplicitNewlinePrepended = true;
                        } else if (leaf instanceof (0, $45gdf.EmbedBlot) && leaf.statics.scope === (0, $45gdf.Scope).INLINE_BLOT) isImplicitNewlinePrepended = true;
                    }
                    this.scroll.insertAt(index, key, op.insert[key]);
                    if (isInlineEmbed) {
                        const [leaf] = this.scroll.descendant((0, $45gdf.LeafBlot), index);
                        if (leaf) {
                            const formats = (0, $jjgrT.default)({}, (0, $jUBfi.bubbleFormats)(leaf));
                            attributes = (0, $ehD63.AttributeMap).diff(formats, attributes) || {};
                        }
                    }
                }
                scrollLength += length;
            } else {
                deleteDelta.push(op);
                if (op.retain !== null && typeof op.retain === 'object') {
                    const key = Object.keys(op.retain)[0];
                    if (key == null) return index;
                    this.scroll.updateEmbedAt(index, key, op.retain[key]);
                }
            }
            Object.keys(attributes).forEach((name)=>{
                this.scroll.formatAt(index, length, name, attributes[name]);
            });
            const prependedLength = isImplicitNewlinePrepended ? 1 : 0;
            const addedLength = isImplicitNewlineAppended ? 1 : 0;
            scrollLength += prependedLength + addedLength;
            deleteDelta.retain(prependedLength);
            deleteDelta.delete(addedLength);
            return index + length + prependedLength + addedLength;
        }, 0);
        deleteDelta.reduce((index, op)=>{
            if (typeof op.delete === 'number') {
                this.scroll.deleteAt(index, op.delete);
                return index;
            }
            return index + (0, $ehD63.Op).length(op);
        }, 0);
        this.scroll.batchEnd();
        this.scroll.optimize();
        return this.update(normalizedDelta);
    }
    deleteText(index, length) {
        this.scroll.deleteAt(index, length);
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().retain(index).delete(length));
    }
    formatLine(index, length) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.scroll.update();
        Object.keys(formats).forEach((format)=>{
            this.scroll.lines(index, Math.max(length, 1)).forEach((line)=>{
                line.format(format, formats[format]);
            });
        });
        this.scroll.optimize();
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().retain(index).retain(length, (0, $buDZz.default)(formats));
        return this.update(delta);
    }
    formatText(index, length) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        Object.keys(formats).forEach((format)=>{
            this.scroll.formatAt(index, length, format, formats[format]);
        });
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().retain(index).retain(length, (0, $buDZz.default)(formats));
        return this.update(delta);
    }
    getContents(index, length) {
        return this.delta.slice(index, index + length);
    }
    getDelta() {
        return this.scroll.lines().reduce((delta, line)=>{
            return delta.concat(line.delta());
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))());
    }
    getFormat(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let lines = [];
        let leaves = [];
        if (length === 0) this.scroll.path(index).forEach((path)=>{
            const [blot] = path;
            if (blot instanceof (0, $jUBfi.default)) lines.push(blot);
            else if (blot instanceof (0, $45gdf.LeafBlot)) leaves.push(blot);
        });
        else {
            lines = this.scroll.lines(index, length);
            leaves = this.scroll.descendants((0, $45gdf.LeafBlot), index, length);
        }
        const [lineFormats, leafFormats] = [
            lines,
            leaves
        ].map((blots)=>{
            const blot = blots.shift();
            if (blot == null) return {};
            let formats = (0, $jUBfi.bubbleFormats)(blot);
            while(Object.keys(formats).length > 0){
                const blot = blots.shift();
                if (blot == null) return formats;
                formats = $7e95501c9b574ce1$var$combineFormats((0, $jUBfi.bubbleFormats)(blot), formats);
            }
            return formats;
        });
        return {
            ...lineFormats,
            ...leafFormats
        };
    }
    getHTML(index, length) {
        const [line, lineOffset] = this.scroll.line(index);
        if (line) {
            const lineLength = line.length();
            const isWithinLine = line.length() >= lineOffset + length;
            if (isWithinLine && !(lineOffset === 0 && length === lineLength)) return $7e95501c9b574ce1$var$convertHTML(line, lineOffset, length, true);
            return $7e95501c9b574ce1$var$convertHTML(this.scroll, index, length, true);
        }
        return '';
    }
    getText(index, length) {
        return this.getContents(index, length).filter((op)=>typeof op.insert === 'string').map((op)=>op.insert).join('');
    }
    insertContents(index, contents) {
        const normalizedDelta = $7e95501c9b574ce1$var$normalizeDelta(contents);
        const change = new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().retain(index).concat(normalizedDelta);
        this.scroll.insertContents(index, normalizedDelta);
        return this.update(change);
    }
    insertEmbed(index, embed, value) {
        this.scroll.insertAt(index, embed, value);
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().retain(index).insert({
            [embed]: value
        }));
    }
    insertText(index, text) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
        this.scroll.insertAt(index, text);
        Object.keys(formats).forEach((format)=>{
            this.scroll.formatAt(index, text.length, format, formats[format]);
        });
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().retain(index).insert(text, (0, $buDZz.default)(formats)));
    }
    isBlank() {
        if (this.scroll.children.length === 0) return true;
        if (this.scroll.children.length > 1) return false;
        const blot = this.scroll.children.head;
        if (blot?.statics.blotName !== (0, $jUBfi.default).blotName) return false;
        const block = blot;
        if (block.children.length > 1) return false;
        return block.children.head instanceof (0, $gkqQr.default);
    }
    removeFormat(index, length) {
        const text = this.getText(index, length);
        const [line, offset] = this.scroll.line(index + length);
        let suffixLength = 0;
        let suffix = new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))();
        if (line != null) {
            suffixLength = line.length() - offset;
            suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
        }
        const contents = this.getContents(index, length + suffixLength);
        const diff = contents.diff(new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().insert(text).concat(suffix));
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().retain(index).concat(diff);
        return this.applyDelta(delta);
    }
    update(change) {
        let mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        let selectionInfo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
        const oldDelta = this.delta;
        if (mutations.length === 1 && mutations[0].type === 'characterData' && // @ts-expect-error Fix me later
        mutations[0].target.data.match($7e95501c9b574ce1$var$ASCII) && this.scroll.find(mutations[0].target)) {
            // Optimization for character changes
            const textBlot = this.scroll.find(mutations[0].target);
            const formats = (0, $jUBfi.bubbleFormats)(textBlot);
            const index = textBlot.offset(this.scroll);
            // @ts-expect-error Fix me later
            const oldValue = mutations[0].oldValue.replace((0, $9VFAE.default).CONTENTS, '');
            const oldText = new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().insert(oldValue);
            // @ts-expect-error
            const newText = new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().insert(textBlot.value());
            const relativeSelectionInfo = selectionInfo && {
                oldRange: $7e95501c9b574ce1$var$shiftRange(selectionInfo.oldRange, -index),
                newRange: $7e95501c9b574ce1$var$shiftRange(selectionInfo.newRange, -index)
            };
            const diffDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().retain(index).concat(oldText.diff(newText, relativeSelectionInfo));
            change = diffDelta.reduce((delta, op)=>{
                if (op.insert) return delta.insert(op.insert, formats);
                return delta.push(op);
            }, new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))());
            this.delta = oldDelta.compose(change);
        } else {
            this.delta = this.getDelta();
            if (!change || !(0, $4vxV0.default)(oldDelta.compose(change), this.delta)) change = oldDelta.diff(this.delta, selectionInfo);
        }
        return change;
    }
}
function $7e95501c9b574ce1$var$convertListHTML(items, lastIndent, types) {
    if (items.length === 0) {
        const [endTag] = $7e95501c9b574ce1$var$getListType(types.pop());
        if (lastIndent <= 0) return `</li></${endTag}>`;
        return `</li></${endTag}>${$7e95501c9b574ce1$var$convertListHTML([], lastIndent - 1, types)}`;
    }
    const [{ child: child, offset: offset, length: length, indent: indent, type: type }, ...rest] = items;
    const [tag, attribute] = $7e95501c9b574ce1$var$getListType(type);
    if (indent > lastIndent) {
        types.push(type);
        if (indent === lastIndent + 1) return `<${tag}><li${attribute}>${$7e95501c9b574ce1$var$convertHTML(child, offset, length)}${$7e95501c9b574ce1$var$convertListHTML(rest, indent, types)}`;
        return `<${tag}><li>${$7e95501c9b574ce1$var$convertListHTML(items, lastIndent + 1, types)}`;
    }
    const previousType = types[types.length - 1];
    if (indent === lastIndent && type === previousType) return `</li><li${attribute}>${$7e95501c9b574ce1$var$convertHTML(child, offset, length)}${$7e95501c9b574ce1$var$convertListHTML(rest, indent, types)}`;
    const [endTag] = $7e95501c9b574ce1$var$getListType(types.pop());
    return `</li></${endTag}>${$7e95501c9b574ce1$var$convertListHTML(items, lastIndent - 1, types)}`;
}
function $7e95501c9b574ce1$var$convertHTML(blot, index, length) {
    let isRoot = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if ('html' in blot && typeof blot.html === 'function') return blot.html(index, length);
    if (blot instanceof (0, $l6ueR.default)) {
        const escapedText = (0, $l6ueR.escapeText)(blot.value().slice(index, index + length));
        return escapedText.replaceAll(' ', '&nbsp;');
    }
    if (blot instanceof (0, $45gdf.ParentBlot)) {
        // TODO fix API
        if (blot.statics.blotName === 'list-container') {
            const items = [];
            blot.children.forEachAt(index, length, (child, offset, childLength)=>{
                const formats = 'formats' in child && typeof child.formats === 'function' ? child.formats() : {};
                items.push({
                    child: child,
                    offset: offset,
                    length: childLength,
                    indent: formats.indent || 0,
                    type: formats.list
                });
            });
            return $7e95501c9b574ce1$var$convertListHTML(items, -1, []);
        }
        const parts = [];
        blot.children.forEachAt(index, length, (child, offset, childLength)=>{
            parts.push($7e95501c9b574ce1$var$convertHTML(child, offset, childLength));
        });
        if (isRoot || blot.statics.blotName === 'list') return parts.join('');
        const { outerHTML: outerHTML, innerHTML: innerHTML } = blot.domNode;
        const [start, end] = outerHTML.split(`>${innerHTML}<`);
        // TODO cleanup
        if (start === '<table') return `<table style="border: 1px solid #000;">${parts.join('')}<${end}`;
        return `${start}>${parts.join('')}<${end}`;
    }
    return blot.domNode instanceof Element ? blot.domNode.outerHTML : '';
}
function $7e95501c9b574ce1$var$combineFormats(formats, combined) {
    return Object.keys(combined).reduce((merged, name)=>{
        if (formats[name] == null) return merged;
        const combinedValue = combined[name];
        if (combinedValue === formats[name]) merged[name] = combinedValue;
        else if (Array.isArray(combinedValue)) {
            if (combinedValue.indexOf(formats[name]) < 0) merged[name] = combinedValue.concat([
                formats[name]
            ]);
            else // If style already exists, don't add to an array, but don't lose other styles
            merged[name] = combinedValue;
        } else merged[name] = [
            combinedValue,
            formats[name]
        ];
        return merged;
    }, {});
}
function $7e95501c9b574ce1$var$getListType(type) {
    const tag = type === 'ordered' ? 'ol' : 'ul';
    switch(type){
        case 'checked':
            return [
                tag,
                ' data-list="checked"'
            ];
        case 'unchecked':
            return [
                tag,
                ' data-list="unchecked"'
            ];
        default:
            return [
                tag,
                ''
            ];
    }
}
function $7e95501c9b574ce1$var$normalizeDelta(delta) {
    return delta.reduce((normalizedDelta, op)=>{
        if (typeof op.insert === 'string') {
            const text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
            return normalizedDelta.insert(text, op.attributes);
        }
        return normalizedDelta.push(op);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))());
}
function $7e95501c9b574ce1$var$shiftRange(_ref, amount) {
    let { index: index, length: length } = _ref;
    return new (0, $6EzZS.Range)(index + amount, length);
}
function $7e95501c9b574ce1$var$splitOpLines(ops) {
    const split = [];
    ops.forEach((op)=>{
        if (typeof op.insert === 'string') {
            const lines = op.insert.split('\n');
            lines.forEach((line, index)=>{
                if (index) split.push({
                    insert: '\n',
                    attributes: op.attributes
                });
                if (line) split.push({
                    insert: line,
                    attributes: op.attributes
                });
            });
        } else split.push(op);
    });
    return split;
}
var $7e95501c9b574ce1$export$2e2bcd8739ae039 = $7e95501c9b574ce1$var$Editor;

});
parcelRegister("buDZz", function(module, exports) {

$parcel$export(module.exports, "default", () => $85e1849fa3f60a5f$export$2e2bcd8739ae039);

var $7qQv6 = parcelRequire("7qQv6");
/** Used to compose bitmasks for cloning. */ var $85e1849fa3f60a5f$var$CLONE_DEEP_FLAG = 1, $85e1849fa3f60a5f$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $85e1849fa3f60a5f$var$cloneDeep(value) {
    return (0, $7qQv6.default)(value, $85e1849fa3f60a5f$var$CLONE_DEEP_FLAG | $85e1849fa3f60a5f$var$CLONE_SYMBOLS_FLAG);
}
var $85e1849fa3f60a5f$export$2e2bcd8739ae039 = $85e1849fa3f60a5f$var$cloneDeep;

});
parcelRegister("7qQv6", function(module, exports) {

$parcel$export(module.exports, "default", () => $5693afa94064766c$export$2e2bcd8739ae039);

var $dGI8c = parcelRequire("dGI8c");

var $92Aj0 = parcelRequire("92Aj0");

var $jtEid = parcelRequire("jtEid");

var $dFxHN = parcelRequire("dFxHN");

var $7SCVq = parcelRequire("7SCVq");

var $4qVZZ = parcelRequire("4qVZZ");

var $b0UBG = parcelRequire("b0UBG");

var $iC0tT = parcelRequire("iC0tT");

var $luDJH = parcelRequire("luDJH");

var $eB7MH = parcelRequire("eB7MH");

var $8itqA = parcelRequire("8itqA");

var $8mBks = parcelRequire("8mBks");

var $7GkeV = parcelRequire("7GkeV");

var $9RifV = parcelRequire("9RifV");

var $8gaby = parcelRequire("8gaby");

var $5FGuY = parcelRequire("5FGuY");

var $g4npv = parcelRequire("g4npv");

var $4UjjW = parcelRequire("4UjjW");

var $laXqR = parcelRequire("laXqR");

var $fu0rw = parcelRequire("fu0rw");

var $ev8yW = parcelRequire("ev8yW");

var $58AyX = parcelRequire("58AyX");
/** Used to compose bitmasks for cloning. */ var $5693afa94064766c$var$CLONE_DEEP_FLAG = 1, $5693afa94064766c$var$CLONE_FLAT_FLAG = 2, $5693afa94064766c$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $5693afa94064766c$var$argsTag = '[object Arguments]', $5693afa94064766c$var$arrayTag = '[object Array]', $5693afa94064766c$var$boolTag = '[object Boolean]', $5693afa94064766c$var$dateTag = '[object Date]', $5693afa94064766c$var$errorTag = '[object Error]', $5693afa94064766c$var$funcTag = '[object Function]', $5693afa94064766c$var$genTag = '[object GeneratorFunction]', $5693afa94064766c$var$mapTag = '[object Map]', $5693afa94064766c$var$numberTag = '[object Number]', $5693afa94064766c$var$objectTag = '[object Object]', $5693afa94064766c$var$regexpTag = '[object RegExp]', $5693afa94064766c$var$setTag = '[object Set]', $5693afa94064766c$var$stringTag = '[object String]', $5693afa94064766c$var$symbolTag = '[object Symbol]', $5693afa94064766c$var$weakMapTag = '[object WeakMap]';
var $5693afa94064766c$var$arrayBufferTag = '[object ArrayBuffer]', $5693afa94064766c$var$dataViewTag = '[object DataView]', $5693afa94064766c$var$float32Tag = '[object Float32Array]', $5693afa94064766c$var$float64Tag = '[object Float64Array]', $5693afa94064766c$var$int8Tag = '[object Int8Array]', $5693afa94064766c$var$int16Tag = '[object Int16Array]', $5693afa94064766c$var$int32Tag = '[object Int32Array]', $5693afa94064766c$var$uint8Tag = '[object Uint8Array]', $5693afa94064766c$var$uint8ClampedTag = '[object Uint8ClampedArray]', $5693afa94064766c$var$uint16Tag = '[object Uint16Array]', $5693afa94064766c$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $5693afa94064766c$var$cloneableTags = {};
$5693afa94064766c$var$cloneableTags[$5693afa94064766c$var$argsTag] = $5693afa94064766c$var$cloneableTags[$5693afa94064766c$var$arrayTag] = $5693afa94064766c$var$cloneableTags[$5693afa94064766c$var$arrayBufferTag] = $5693afa94064766c$var$cloneableTags[$5693afa94064766c$var$dataViewTag] = $5693afa94064766c$var$cloneableTags[$5693afa94064766c$var$boolTag] = $5693afa94064766c$var$cloneableTags[$5693afa94064766c$var$dateTag] = $5693afa94064766c$var$cloneableTags[$5693afa94064766c$var$float32Tag] = $5693afa94064766c$var$cloneableTags[$5693afa94064766c$var$float64Tag] = $5693afa94064766c$var$cloneableTags[$5693afa94064766c$var$int8Tag] = $5693afa94064766c$var$cloneableTags[$5693afa94064766c$var$int16Tag] = $5693afa94064766c$var$cloneableTags[$5693afa94064766c$var$int32Tag] = $5693afa94064766c$var$cloneableTags[$5693afa94064766c$var$mapTag] = $5693afa94064766c$var$cloneableTags[$5693afa94064766c$var$numberTag] = $5693afa94064766c$var$cloneableTags[$5693afa94064766c$var$objectTag] = $5693afa94064766c$var$cloneableTags[$5693afa94064766c$var$regexpTag] = $5693afa94064766c$var$cloneableTags[$5693afa94064766c$var$setTag] = $5693afa94064766c$var$cloneableTags[$5693afa94064766c$var$stringTag] = $5693afa94064766c$var$cloneableTags[$5693afa94064766c$var$symbolTag] = $5693afa94064766c$var$cloneableTags[$5693afa94064766c$var$uint8Tag] = $5693afa94064766c$var$cloneableTags[$5693afa94064766c$var$uint8ClampedTag] = $5693afa94064766c$var$cloneableTags[$5693afa94064766c$var$uint16Tag] = $5693afa94064766c$var$cloneableTags[$5693afa94064766c$var$uint32Tag] = true;
$5693afa94064766c$var$cloneableTags[$5693afa94064766c$var$errorTag] = $5693afa94064766c$var$cloneableTags[$5693afa94064766c$var$funcTag] = $5693afa94064766c$var$cloneableTags[$5693afa94064766c$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $5693afa94064766c$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $5693afa94064766c$var$CLONE_DEEP_FLAG, isFlat = bitmask & $5693afa94064766c$var$CLONE_FLAT_FLAG, isFull = bitmask & $5693afa94064766c$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $laXqR.default)(value)) return value;
    var isArr = (0, $5FGuY.default)(value);
    if (isArr) {
        result = (0, $7GkeV.default)(value);
        if (!isDeep) return (0, $b0UBG.default)(value, result);
    } else {
        var tag = (0, $8mBks.default)(value), isFunc = tag == $5693afa94064766c$var$funcTag || tag == $5693afa94064766c$var$genTag;
        if ((0, $g4npv.default)(value)) return (0, $4qVZZ.default)(value, isDeep);
        if (tag == $5693afa94064766c$var$objectTag || tag == $5693afa94064766c$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $8gaby.default)(value);
            if (!isDeep) return isFlat ? (0, $luDJH.default)(value, (0, $7SCVq.default)(result, value)) : (0, $iC0tT.default)(value, (0, $dFxHN.default)(result, value));
        } else {
            if (!$5693afa94064766c$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $9RifV.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $dGI8c.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $fu0rw.default)(value)) value.forEach(function(subValue) {
        result.add($5693afa94064766c$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $4UjjW.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $5693afa94064766c$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $8itqA.default) : (0, $eB7MH.default) : isFlat ? (0, $58AyX.default) : (0, $ev8yW.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $92Aj0.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $jtEid.default)(result, key, $5693afa94064766c$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $5693afa94064766c$export$2e2bcd8739ae039 = $5693afa94064766c$var$baseClone;

});
parcelRegister("92Aj0", function(module, exports) {

$parcel$export(module.exports, "default", () => $6950767daf020b2a$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $6950767daf020b2a$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $6950767daf020b2a$export$2e2bcd8739ae039 = $6950767daf020b2a$var$arrayEach;

});

parcelRegister("dFxHN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f393fe65929a99d$export$2e2bcd8739ae039);

var $2e2mM = parcelRequire("2e2mM");

var $ev8yW = parcelRequire("ev8yW");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $9f393fe65929a99d$var$baseAssign(object, source) {
    return object && (0, $2e2mM.default)(source, (0, $ev8yW.default)(source), object);
}
var $9f393fe65929a99d$export$2e2bcd8739ae039 = $9f393fe65929a99d$var$baseAssign;

});
parcelRegister("ev8yW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8ea9a434f86bcaa$export$2e2bcd8739ae039);

var $9yJBQ = parcelRequire("9yJBQ");

var $2VQHR = parcelRequire("2VQHR");

var $aKfKc = parcelRequire("aKfKc");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $a8ea9a434f86bcaa$var$keys(object) {
    return (0, $aKfKc.default)(object) ? (0, $9yJBQ.default)(object) : (0, $2VQHR.default)(object);
}
var $a8ea9a434f86bcaa$export$2e2bcd8739ae039 = $a8ea9a434f86bcaa$var$keys;

});
parcelRegister("2VQHR", function(module, exports) {

$parcel$export(module.exports, "default", () => $2229ca0fb71f4092$export$2e2bcd8739ae039);

var $aDfK8 = parcelRequire("aDfK8");

var $g4H8X = parcelRequire("g4H8X");
/** Used for built-in method references. */ var $2229ca0fb71f4092$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2229ca0fb71f4092$var$hasOwnProperty = $2229ca0fb71f4092$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $2229ca0fb71f4092$var$baseKeys(object) {
    if (!(0, $aDfK8.default)(object)) return (0, $g4H8X.default)(object);
    var result = [];
    for(var key in Object(object))if ($2229ca0fb71f4092$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $2229ca0fb71f4092$export$2e2bcd8739ae039 = $2229ca0fb71f4092$var$baseKeys;

});
parcelRegister("g4H8X", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb3e7c6fdb570b9d$export$2e2bcd8739ae039);

var $lIN3V = parcelRequire("lIN3V");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $bb3e7c6fdb570b9d$var$nativeKeys = (0, $lIN3V.default)(Object.keys, Object);
var $bb3e7c6fdb570b9d$export$2e2bcd8739ae039 = $bb3e7c6fdb570b9d$var$nativeKeys;

});




parcelRegister("7SCVq", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bcbc544dd710d57$export$2e2bcd8739ae039);

var $2e2mM = parcelRequire("2e2mM");

var $58AyX = parcelRequire("58AyX");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $5bcbc544dd710d57$var$baseAssignIn(object, source) {
    return object && (0, $2e2mM.default)(source, (0, $58AyX.default)(source), object);
}
var $5bcbc544dd710d57$export$2e2bcd8739ae039 = $5bcbc544dd710d57$var$baseAssignIn;

});

parcelRegister("iC0tT", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8cc262b8380699f$export$2e2bcd8739ae039);

var $2e2mM = parcelRequire("2e2mM");

var $fhlU7 = parcelRequire("fhlU7");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $d8cc262b8380699f$var$copySymbols(source, object) {
    return (0, $2e2mM.default)(source, (0, $fhlU7.default)(source), object);
}
var $d8cc262b8380699f$export$2e2bcd8739ae039 = $d8cc262b8380699f$var$copySymbols;

});
parcelRegister("fhlU7", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1f96f4623ce7a3c$export$2e2bcd8739ae039);

var $9RJkx = parcelRequire("9RJkx");

var $82IHl = parcelRequire("82IHl");
/** Used for built-in method references. */ var $b1f96f4623ce7a3c$var$objectProto = Object.prototype;
/** Built-in value references. */ var $b1f96f4623ce7a3c$var$propertyIsEnumerable = $b1f96f4623ce7a3c$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b1f96f4623ce7a3c$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $b1f96f4623ce7a3c$var$getSymbols = !$b1f96f4623ce7a3c$var$nativeGetSymbols ? (0, $82IHl.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $9RJkx.default)($b1f96f4623ce7a3c$var$nativeGetSymbols(object), function(symbol) {
        return $b1f96f4623ce7a3c$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $b1f96f4623ce7a3c$export$2e2bcd8739ae039 = $b1f96f4623ce7a3c$var$getSymbols;

});
parcelRegister("9RJkx", function(module, exports) {

$parcel$export(module.exports, "default", () => $72ec39f0a855c80e$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $72ec39f0a855c80e$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $72ec39f0a855c80e$export$2e2bcd8739ae039 = $72ec39f0a855c80e$var$arrayFilter;

});

parcelRegister("82IHl", function(module, exports) {

$parcel$export(module.exports, "default", () => $5db12ebd229cb079$export$2e2bcd8739ae039);
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $5db12ebd229cb079$var$stubArray() {
    return [];
}
var $5db12ebd229cb079$export$2e2bcd8739ae039 = $5db12ebd229cb079$var$stubArray;

});



parcelRegister("luDJH", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa5b391427e50dab$export$2e2bcd8739ae039);

var $2e2mM = parcelRequire("2e2mM");

var $lXcBR = parcelRequire("lXcBR");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $fa5b391427e50dab$var$copySymbolsIn(source, object) {
    return (0, $2e2mM.default)(source, (0, $lXcBR.default)(source), object);
}
var $fa5b391427e50dab$export$2e2bcd8739ae039 = $fa5b391427e50dab$var$copySymbolsIn;

});
parcelRegister("lXcBR", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffb8e3b11f667eae$export$2e2bcd8739ae039);

var $kVWBv = parcelRequire("kVWBv");

var $6fKLs = parcelRequire("6fKLs");

var $fhlU7 = parcelRequire("fhlU7");

var $82IHl = parcelRequire("82IHl");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ffb8e3b11f667eae$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $ffb8e3b11f667eae$var$getSymbolsIn = !$ffb8e3b11f667eae$var$nativeGetSymbols ? (0, $82IHl.default) : function(object) {
    var result = [];
    while(object){
        (0, $kVWBv.default)(result, (0, $fhlU7.default)(object));
        object = (0, $6fKLs.default)(object);
    }
    return result;
};
var $ffb8e3b11f667eae$export$2e2bcd8739ae039 = $ffb8e3b11f667eae$var$getSymbolsIn;

});
parcelRegister("kVWBv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3d6970440d99a1c$export$2e2bcd8739ae039);
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $f3d6970440d99a1c$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $f3d6970440d99a1c$export$2e2bcd8739ae039 = $f3d6970440d99a1c$var$arrayPush;

});



parcelRegister("eB7MH", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa0a8f3bc6ba4230$export$2e2bcd8739ae039);

var $3HOOX = parcelRequire("3HOOX");

var $fhlU7 = parcelRequire("fhlU7");

var $ev8yW = parcelRequire("ev8yW");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $aa0a8f3bc6ba4230$var$getAllKeys(object) {
    return (0, $3HOOX.default)(object, (0, $ev8yW.default), (0, $fhlU7.default));
}
var $aa0a8f3bc6ba4230$export$2e2bcd8739ae039 = $aa0a8f3bc6ba4230$var$getAllKeys;

});
parcelRegister("3HOOX", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b2ccf3461d3827d$export$2e2bcd8739ae039);

var $kVWBv = parcelRequire("kVWBv");

var $5FGuY = parcelRequire("5FGuY");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $2b2ccf3461d3827d$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $5FGuY.default)(object) ? result : (0, $kVWBv.default)(result, symbolsFunc(object));
}
var $2b2ccf3461d3827d$export$2e2bcd8739ae039 = $2b2ccf3461d3827d$var$baseGetAllKeys;

});


parcelRegister("8itqA", function(module, exports) {

$parcel$export(module.exports, "default", () => $60a6d4f089e46d82$export$2e2bcd8739ae039);

var $3HOOX = parcelRequire("3HOOX");

var $lXcBR = parcelRequire("lXcBR");

var $58AyX = parcelRequire("58AyX");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $60a6d4f089e46d82$var$getAllKeysIn(object) {
    return (0, $3HOOX.default)(object, (0, $58AyX.default), (0, $lXcBR.default));
}
var $60a6d4f089e46d82$export$2e2bcd8739ae039 = $60a6d4f089e46d82$var$getAllKeysIn;

});

parcelRegister("8mBks", function(module, exports) {

$parcel$export(module.exports, "default", () => $616d55892fa0078d$export$2e2bcd8739ae039);

var $a5zwh = parcelRequire("a5zwh");

var $lhx5c = parcelRequire("lhx5c");

var $lcf0p = parcelRequire("lcf0p");

var $3bLxT = parcelRequire("3bLxT");

var $6axqd = parcelRequire("6axqd");

var $fXyl2 = parcelRequire("fXyl2");

var $gtAhe = parcelRequire("gtAhe");
/** `Object#toString` result references. */ var $616d55892fa0078d$var$mapTag = '[object Map]', $616d55892fa0078d$var$objectTag = '[object Object]', $616d55892fa0078d$var$promiseTag = '[object Promise]', $616d55892fa0078d$var$setTag = '[object Set]', $616d55892fa0078d$var$weakMapTag = '[object WeakMap]';
var $616d55892fa0078d$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $616d55892fa0078d$var$dataViewCtorString = (0, $gtAhe.default)((0, $a5zwh.default)), $616d55892fa0078d$var$mapCtorString = (0, $gtAhe.default)((0, $lhx5c.default)), $616d55892fa0078d$var$promiseCtorString = (0, $gtAhe.default)((0, $lcf0p.default)), $616d55892fa0078d$var$setCtorString = (0, $gtAhe.default)((0, $3bLxT.default)), $616d55892fa0078d$var$weakMapCtorString = (0, $gtAhe.default)((0, $6axqd.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $616d55892fa0078d$var$getTag = (0, $fXyl2.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $a5zwh.default) && $616d55892fa0078d$var$getTag(new (0, $a5zwh.default)(new ArrayBuffer(1))) != $616d55892fa0078d$var$dataViewTag || (0, $lhx5c.default) && $616d55892fa0078d$var$getTag(new (0, $lhx5c.default)) != $616d55892fa0078d$var$mapTag || (0, $lcf0p.default) && $616d55892fa0078d$var$getTag((0, $lcf0p.default).resolve()) != $616d55892fa0078d$var$promiseTag || (0, $3bLxT.default) && $616d55892fa0078d$var$getTag(new (0, $3bLxT.default)) != $616d55892fa0078d$var$setTag || (0, $6axqd.default) && $616d55892fa0078d$var$getTag(new (0, $6axqd.default)) != $616d55892fa0078d$var$weakMapTag) $616d55892fa0078d$var$getTag = function(value) {
    var result = (0, $fXyl2.default)(value), Ctor = result == $616d55892fa0078d$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $gtAhe.default)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $616d55892fa0078d$var$dataViewCtorString:
            return $616d55892fa0078d$var$dataViewTag;
        case $616d55892fa0078d$var$mapCtorString:
            return $616d55892fa0078d$var$mapTag;
        case $616d55892fa0078d$var$promiseCtorString:
            return $616d55892fa0078d$var$promiseTag;
        case $616d55892fa0078d$var$setCtorString:
            return $616d55892fa0078d$var$setTag;
        case $616d55892fa0078d$var$weakMapCtorString:
            return $616d55892fa0078d$var$weakMapTag;
    }
    return result;
};
var $616d55892fa0078d$export$2e2bcd8739ae039 = $616d55892fa0078d$var$getTag;

});
parcelRegister("a5zwh", function(module, exports) {

$parcel$export(module.exports, "default", () => $7585ec7c52f4c93f$export$2e2bcd8739ae039);

var $31iYT = parcelRequire("31iYT");

var $4LQN3 = parcelRequire("4LQN3");
/* Built-in method references that are verified to be native. */ var $7585ec7c52f4c93f$var$DataView = (0, $31iYT.default)((0, $4LQN3.default), 'DataView');
var $7585ec7c52f4c93f$export$2e2bcd8739ae039 = $7585ec7c52f4c93f$var$DataView;

});

parcelRegister("lcf0p", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6e65bc490783b6d$export$2e2bcd8739ae039);

var $31iYT = parcelRequire("31iYT");

var $4LQN3 = parcelRequire("4LQN3");
/* Built-in method references that are verified to be native. */ var $f6e65bc490783b6d$var$Promise = (0, $31iYT.default)((0, $4LQN3.default), 'Promise');
var $f6e65bc490783b6d$export$2e2bcd8739ae039 = $f6e65bc490783b6d$var$Promise;

});

parcelRegister("3bLxT", function(module, exports) {

$parcel$export(module.exports, "default", () => $252747bfbf61a58c$export$2e2bcd8739ae039);

var $31iYT = parcelRequire("31iYT");

var $4LQN3 = parcelRequire("4LQN3");
/* Built-in method references that are verified to be native. */ var $252747bfbf61a58c$var$Set = (0, $31iYT.default)((0, $4LQN3.default), 'Set');
var $252747bfbf61a58c$export$2e2bcd8739ae039 = $252747bfbf61a58c$var$Set;

});

parcelRegister("6axqd", function(module, exports) {

$parcel$export(module.exports, "default", () => $47dd9a24c096d36e$export$2e2bcd8739ae039);

var $31iYT = parcelRequire("31iYT");

var $4LQN3 = parcelRequire("4LQN3");
/* Built-in method references that are verified to be native. */ var $47dd9a24c096d36e$var$WeakMap = (0, $31iYT.default)((0, $4LQN3.default), 'WeakMap');
var $47dd9a24c096d36e$export$2e2bcd8739ae039 = $47dd9a24c096d36e$var$WeakMap;

});


parcelRegister("7GkeV", function(module, exports) {

$parcel$export(module.exports, "default", () => $597c27d6383c4228$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $597c27d6383c4228$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $597c27d6383c4228$var$hasOwnProperty = $597c27d6383c4228$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $597c27d6383c4228$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $597c27d6383c4228$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $597c27d6383c4228$export$2e2bcd8739ae039 = $597c27d6383c4228$var$initCloneArray;

});

parcelRegister("9RifV", function(module, exports) {

$parcel$export(module.exports, "default", () => $72d7398b647ca218$export$2e2bcd8739ae039);

var $4bMpJ = parcelRequire("4bMpJ");

var $huSUg = parcelRequire("huSUg");

var $ev3UO = parcelRequire("ev3UO");

var $lTF2h = parcelRequire("lTF2h");

var $9ABB2 = parcelRequire("9ABB2");
/** `Object#toString` result references. */ var $72d7398b647ca218$var$boolTag = '[object Boolean]', $72d7398b647ca218$var$dateTag = '[object Date]', $72d7398b647ca218$var$mapTag = '[object Map]', $72d7398b647ca218$var$numberTag = '[object Number]', $72d7398b647ca218$var$regexpTag = '[object RegExp]', $72d7398b647ca218$var$setTag = '[object Set]', $72d7398b647ca218$var$stringTag = '[object String]', $72d7398b647ca218$var$symbolTag = '[object Symbol]';
var $72d7398b647ca218$var$arrayBufferTag = '[object ArrayBuffer]', $72d7398b647ca218$var$dataViewTag = '[object DataView]', $72d7398b647ca218$var$float32Tag = '[object Float32Array]', $72d7398b647ca218$var$float64Tag = '[object Float64Array]', $72d7398b647ca218$var$int8Tag = '[object Int8Array]', $72d7398b647ca218$var$int16Tag = '[object Int16Array]', $72d7398b647ca218$var$int32Tag = '[object Int32Array]', $72d7398b647ca218$var$uint8Tag = '[object Uint8Array]', $72d7398b647ca218$var$uint8ClampedTag = '[object Uint8ClampedArray]', $72d7398b647ca218$var$uint16Tag = '[object Uint16Array]', $72d7398b647ca218$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $72d7398b647ca218$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $72d7398b647ca218$var$arrayBufferTag:
            return (0, $4bMpJ.default)(object);
        case $72d7398b647ca218$var$boolTag:
        case $72d7398b647ca218$var$dateTag:
            return new Ctor(+object);
        case $72d7398b647ca218$var$dataViewTag:
            return (0, $huSUg.default)(object, isDeep);
        case $72d7398b647ca218$var$float32Tag:
        case $72d7398b647ca218$var$float64Tag:
        case $72d7398b647ca218$var$int8Tag:
        case $72d7398b647ca218$var$int16Tag:
        case $72d7398b647ca218$var$int32Tag:
        case $72d7398b647ca218$var$uint8Tag:
        case $72d7398b647ca218$var$uint8ClampedTag:
        case $72d7398b647ca218$var$uint16Tag:
        case $72d7398b647ca218$var$uint32Tag:
            return (0, $9ABB2.default)(object, isDeep);
        case $72d7398b647ca218$var$mapTag:
            return new Ctor;
        case $72d7398b647ca218$var$numberTag:
        case $72d7398b647ca218$var$stringTag:
            return new Ctor(object);
        case $72d7398b647ca218$var$regexpTag:
            return (0, $ev3UO.default)(object);
        case $72d7398b647ca218$var$setTag:
            return new Ctor;
        case $72d7398b647ca218$var$symbolTag:
            return (0, $lTF2h.default)(object);
    }
}
var $72d7398b647ca218$export$2e2bcd8739ae039 = $72d7398b647ca218$var$initCloneByTag;

});
parcelRegister("huSUg", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbcfd44d094c690a$export$2e2bcd8739ae039);

var $4bMpJ = parcelRequire("4bMpJ");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $cbcfd44d094c690a$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $4bMpJ.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $cbcfd44d094c690a$export$2e2bcd8739ae039 = $cbcfd44d094c690a$var$cloneDataView;

});

parcelRegister("ev3UO", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8e6ff70dc112d7e$export$2e2bcd8739ae039);
/** Used to match `RegExp` flags from their coerced string values. */ var $a8e6ff70dc112d7e$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $a8e6ff70dc112d7e$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $a8e6ff70dc112d7e$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $a8e6ff70dc112d7e$export$2e2bcd8739ae039 = $a8e6ff70dc112d7e$var$cloneRegExp;

});

parcelRegister("lTF2h", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff0e90e5e9421306$export$2e2bcd8739ae039);

var $a2xkg = parcelRequire("a2xkg");
/** Used to convert symbols to primitives and strings. */ var $ff0e90e5e9421306$var$symbolProto = (0, $a2xkg.default) ? (0, $a2xkg.default).prototype : undefined, $ff0e90e5e9421306$var$symbolValueOf = $ff0e90e5e9421306$var$symbolProto ? $ff0e90e5e9421306$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $ff0e90e5e9421306$var$cloneSymbol(symbol) {
    return $ff0e90e5e9421306$var$symbolValueOf ? Object($ff0e90e5e9421306$var$symbolValueOf.call(symbol)) : {};
}
var $ff0e90e5e9421306$export$2e2bcd8739ae039 = $ff0e90e5e9421306$var$cloneSymbol;

});


parcelRegister("4UjjW", function(module, exports) {

$parcel$export(module.exports, "default", () => $392b61158a335c67$export$2e2bcd8739ae039);

var $9zucg = parcelRequire("9zucg");

var $eX79t = parcelRequire("eX79t");

var $5Xc4H = parcelRequire("5Xc4H");
/* Node.js helper references. */ var $392b61158a335c67$var$nodeIsMap = (0, $5Xc4H.default) && (0, $5Xc4H.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $392b61158a335c67$var$isMap = $392b61158a335c67$var$nodeIsMap ? (0, $eX79t.default)($392b61158a335c67$var$nodeIsMap) : (0, $9zucg.default);
var $392b61158a335c67$export$2e2bcd8739ae039 = $392b61158a335c67$var$isMap;

});
parcelRegister("9zucg", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f7ece612d87e7dd$export$2e2bcd8739ae039);

var $8mBks = parcelRequire("8mBks");

var $kmlEc = parcelRequire("kmlEc");
/** `Object#toString` result references. */ var $6f7ece612d87e7dd$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $6f7ece612d87e7dd$var$baseIsMap(value) {
    return (0, $kmlEc.default)(value) && (0, $8mBks.default)(value) == $6f7ece612d87e7dd$var$mapTag;
}
var $6f7ece612d87e7dd$export$2e2bcd8739ae039 = $6f7ece612d87e7dd$var$baseIsMap;

});


parcelRegister("fu0rw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b45a005061a34b88$export$2e2bcd8739ae039);

var $aj5mw = parcelRequire("aj5mw");

var $eX79t = parcelRequire("eX79t");

var $5Xc4H = parcelRequire("5Xc4H");
/* Node.js helper references. */ var $b45a005061a34b88$var$nodeIsSet = (0, $5Xc4H.default) && (0, $5Xc4H.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $b45a005061a34b88$var$isSet = $b45a005061a34b88$var$nodeIsSet ? (0, $eX79t.default)($b45a005061a34b88$var$nodeIsSet) : (0, $aj5mw.default);
var $b45a005061a34b88$export$2e2bcd8739ae039 = $b45a005061a34b88$var$isSet;

});
parcelRegister("aj5mw", function(module, exports) {

$parcel$export(module.exports, "default", () => $780fd68c79001184$export$2e2bcd8739ae039);

var $8mBks = parcelRequire("8mBks");

var $kmlEc = parcelRequire("kmlEc");
/** `Object#toString` result references. */ var $780fd68c79001184$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $780fd68c79001184$var$baseIsSet(value) {
    return (0, $kmlEc.default)(value) && (0, $8mBks.default)(value) == $780fd68c79001184$var$setTag;
}
var $780fd68c79001184$export$2e2bcd8739ae039 = $780fd68c79001184$var$baseIsSet;

});




parcelRegister("4vxV0", function(module, exports) {

$parcel$export(module.exports, "default", () => $34845e2908d68994$export$2e2bcd8739ae039);

var $e4Wte = parcelRequire("e4Wte");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $34845e2908d68994$var$isEqual(value, other) {
    return (0, $e4Wte.default)(value, other);
}
var $34845e2908d68994$export$2e2bcd8739ae039 = $34845e2908d68994$var$isEqual;

});
parcelRegister("e4Wte", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3fecb68ad2fdf43$export$2e2bcd8739ae039);

var $eYYvG = parcelRequire("eYYvG");

var $kmlEc = parcelRequire("kmlEc");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $a3fecb68ad2fdf43$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, $kmlEc.default)(value) && !(0, $kmlEc.default)(other)) return value !== value && other !== other;
    return (0, $eYYvG.default)(value, other, bitmask, customizer, $a3fecb68ad2fdf43$var$baseIsEqual, stack);
}
var $a3fecb68ad2fdf43$export$2e2bcd8739ae039 = $a3fecb68ad2fdf43$var$baseIsEqual;

});
parcelRegister("eYYvG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae859b4d50f53d66$export$2e2bcd8739ae039);

var $dGI8c = parcelRequire("dGI8c");

var $jCd1U = parcelRequire("jCd1U");

var $4iYV1 = parcelRequire("4iYV1");

var $9B025 = parcelRequire("9B025");

var $8mBks = parcelRequire("8mBks");

var $5FGuY = parcelRequire("5FGuY");

var $g4npv = parcelRequire("g4npv");

var $5tzKv = parcelRequire("5tzKv");
/** Used to compose bitmasks for value comparisons. */ var $ae859b4d50f53d66$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $ae859b4d50f53d66$var$argsTag = '[object Arguments]', $ae859b4d50f53d66$var$arrayTag = '[object Array]', $ae859b4d50f53d66$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $ae859b4d50f53d66$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ae859b4d50f53d66$var$hasOwnProperty = $ae859b4d50f53d66$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ae859b4d50f53d66$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, $5FGuY.default)(object), othIsArr = (0, $5FGuY.default)(other), objTag = objIsArr ? $ae859b4d50f53d66$var$arrayTag : (0, $8mBks.default)(object), othTag = othIsArr ? $ae859b4d50f53d66$var$arrayTag : (0, $8mBks.default)(other);
    objTag = objTag == $ae859b4d50f53d66$var$argsTag ? $ae859b4d50f53d66$var$objectTag : objTag;
    othTag = othTag == $ae859b4d50f53d66$var$argsTag ? $ae859b4d50f53d66$var$objectTag : othTag;
    var objIsObj = objTag == $ae859b4d50f53d66$var$objectTag, othIsObj = othTag == $ae859b4d50f53d66$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, $g4npv.default)(object)) {
        if (!(0, $g4npv.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, $dGI8c.default));
        return objIsArr || (0, $5tzKv.default)(object) ? (0, $jCd1U.default)(object, other, bitmask, customizer, equalFunc, stack) : (0, $4iYV1.default)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $ae859b4d50f53d66$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $ae859b4d50f53d66$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $ae859b4d50f53d66$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, $dGI8c.default));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, $dGI8c.default));
    return (0, $9B025.default)(object, other, bitmask, customizer, equalFunc, stack);
}
var $ae859b4d50f53d66$export$2e2bcd8739ae039 = $ae859b4d50f53d66$var$baseIsEqualDeep;

});
parcelRegister("jCd1U", function(module, exports) {

$parcel$export(module.exports, "default", () => $e47bac657b44156c$export$2e2bcd8739ae039);

var $hRebh = parcelRequire("hRebh");

var $fkUNl = parcelRequire("fkUNl");

var $itq0U = parcelRequire("itq0U");
/** Used to compose bitmasks for value comparisons. */ var $e47bac657b44156c$var$COMPARE_PARTIAL_FLAG = 1, $e47bac657b44156c$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $e47bac657b44156c$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $e47bac657b44156c$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $e47bac657b44156c$var$COMPARE_UNORDERED_FLAG ? new (0, $hRebh.default) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, $fkUNl.default)(other, function(othValue, othIndex) {
                if (!(0, $itq0U.default)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
var $e47bac657b44156c$export$2e2bcd8739ae039 = $e47bac657b44156c$var$equalArrays;

});
parcelRegister("hRebh", function(module, exports) {

$parcel$export(module.exports, "default", () => $d00262f75b418989$export$2e2bcd8739ae039);

var $hO2ZN = parcelRequire("hO2ZN");

var $SPy5Y = parcelRequire("SPy5Y");

var $aRKbk = parcelRequire("aRKbk");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $d00262f75b418989$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, $hO2ZN.default);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$d00262f75b418989$var$SetCache.prototype.add = $d00262f75b418989$var$SetCache.prototype.push = (0, $SPy5Y.default);
$d00262f75b418989$var$SetCache.prototype.has = (0, $aRKbk.default);
var $d00262f75b418989$export$2e2bcd8739ae039 = $d00262f75b418989$var$SetCache;

});
parcelRegister("SPy5Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a4d07cd9a59b13e$export$2e2bcd8739ae039);
/** Used to stand-in for `undefined` hash values. */ var $0a4d07cd9a59b13e$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $0a4d07cd9a59b13e$var$setCacheAdd(value) {
    this.__data__.set(value, $0a4d07cd9a59b13e$var$HASH_UNDEFINED);
    return this;
}
var $0a4d07cd9a59b13e$export$2e2bcd8739ae039 = $0a4d07cd9a59b13e$var$setCacheAdd;

});

parcelRegister("aRKbk", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e92ad5414f1ffa9$export$2e2bcd8739ae039);
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $7e92ad5414f1ffa9$var$setCacheHas(value) {
    return this.__data__.has(value);
}
var $7e92ad5414f1ffa9$export$2e2bcd8739ae039 = $7e92ad5414f1ffa9$var$setCacheHas;

});


parcelRegister("fkUNl", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2a4c787d8e6f1bd$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $b2a4c787d8e6f1bd$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
var $b2a4c787d8e6f1bd$export$2e2bcd8739ae039 = $b2a4c787d8e6f1bd$var$arraySome;

});

parcelRegister("itq0U", function(module, exports) {

$parcel$export(module.exports, "default", () => $d72f1d3602657dd5$export$2e2bcd8739ae039);
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d72f1d3602657dd5$var$cacheHas(cache, key) {
    return cache.has(key);
}
var $d72f1d3602657dd5$export$2e2bcd8739ae039 = $d72f1d3602657dd5$var$cacheHas;

});


parcelRegister("4iYV1", function(module, exports) {

$parcel$export(module.exports, "default", () => $3228190dcd60d96b$export$2e2bcd8739ae039);

var $a2xkg = parcelRequire("a2xkg");

var $8W9sY = parcelRequire("8W9sY");

var $44Qh5 = parcelRequire("44Qh5");

var $jCd1U = parcelRequire("jCd1U");

var $glrk7 = parcelRequire("glrk7");

var $rbx89 = parcelRequire("rbx89");
/** Used to compose bitmasks for value comparisons. */ var $3228190dcd60d96b$var$COMPARE_PARTIAL_FLAG = 1, $3228190dcd60d96b$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $3228190dcd60d96b$var$boolTag = '[object Boolean]', $3228190dcd60d96b$var$dateTag = '[object Date]', $3228190dcd60d96b$var$errorTag = '[object Error]', $3228190dcd60d96b$var$mapTag = '[object Map]', $3228190dcd60d96b$var$numberTag = '[object Number]', $3228190dcd60d96b$var$regexpTag = '[object RegExp]', $3228190dcd60d96b$var$setTag = '[object Set]', $3228190dcd60d96b$var$stringTag = '[object String]', $3228190dcd60d96b$var$symbolTag = '[object Symbol]';
var $3228190dcd60d96b$var$arrayBufferTag = '[object ArrayBuffer]', $3228190dcd60d96b$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $3228190dcd60d96b$var$symbolProto = (0, $a2xkg.default) ? (0, $a2xkg.default).prototype : undefined, $3228190dcd60d96b$var$symbolValueOf = $3228190dcd60d96b$var$symbolProto ? $3228190dcd60d96b$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $3228190dcd60d96b$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $3228190dcd60d96b$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $3228190dcd60d96b$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, $8W9sY.default)(object), new (0, $8W9sY.default)(other))) return false;
            return true;
        case $3228190dcd60d96b$var$boolTag:
        case $3228190dcd60d96b$var$dateTag:
        case $3228190dcd60d96b$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, $44Qh5.default)(+object, +other);
        case $3228190dcd60d96b$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $3228190dcd60d96b$var$regexpTag:
        case $3228190dcd60d96b$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $3228190dcd60d96b$var$mapTag:
            var convert = (0, $glrk7.default);
        case $3228190dcd60d96b$var$setTag:
            var isPartial = bitmask & $3228190dcd60d96b$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, $rbx89.default));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $3228190dcd60d96b$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, $jCd1U.default)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $3228190dcd60d96b$var$symbolTag:
            if ($3228190dcd60d96b$var$symbolValueOf) return $3228190dcd60d96b$var$symbolValueOf.call(object) == $3228190dcd60d96b$var$symbolValueOf.call(other);
    }
    return false;
}
var $3228190dcd60d96b$export$2e2bcd8739ae039 = $3228190dcd60d96b$var$equalByTag;

});
parcelRegister("glrk7", function(module, exports) {

$parcel$export(module.exports, "default", () => $be63cd65be917da9$export$2e2bcd8739ae039);
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $be63cd65be917da9$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
var $be63cd65be917da9$export$2e2bcd8739ae039 = $be63cd65be917da9$var$mapToArray;

});

parcelRegister("rbx89", function(module, exports) {

$parcel$export(module.exports, "default", () => $051b78045490ba05$export$2e2bcd8739ae039);
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $051b78045490ba05$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
var $051b78045490ba05$export$2e2bcd8739ae039 = $051b78045490ba05$var$setToArray;

});


parcelRegister("9B025", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fc79838dc9a2d82$export$2e2bcd8739ae039);

var $eB7MH = parcelRequire("eB7MH");
/** Used to compose bitmasks for value comparisons. */ var $6fc79838dc9a2d82$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $6fc79838dc9a2d82$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6fc79838dc9a2d82$var$hasOwnProperty = $6fc79838dc9a2d82$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $6fc79838dc9a2d82$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $6fc79838dc9a2d82$var$COMPARE_PARTIAL_FLAG, objProps = (0, $eB7MH.default)(object), objLength = objProps.length, othProps = (0, $eB7MH.default)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $6fc79838dc9a2d82$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
var $6fc79838dc9a2d82$export$2e2bcd8739ae039 = $6fc79838dc9a2d82$var$equalObjects;

});




parcelRegister("jUBfi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7f02381fd0887d3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "blockDelta", () => $e7f02381fd0887d3$export$992ff47219af5a2b);
$parcel$export(module.exports, "BlockEmbed", () => $e7f02381fd0887d3$export$48b9f0688962d028);
$parcel$export(module.exports, "bubbleFormats", () => $e7f02381fd0887d3$export$e4bb5a6163449612);

var $45gdf = parcelRequire("45gdf");

var $ehD63 = parcelRequire("ehD63");

var $gkqQr = parcelRequire("gkqQr");

var $95m1U = parcelRequire("95m1U");

var $l6ueR = parcelRequire("l6ueR");
const $e7f02381fd0887d3$var$NEWLINE_LENGTH = 1;
class $e7f02381fd0887d3$export$2e2bcd8739ae039 extends (0, $45gdf.BlockBlot) {
    cache = {};
    delta() {
        if (this.cache.delta == null) this.cache.delta = $e7f02381fd0887d3$export$992ff47219af5a2b(this);
        return this.cache.delta;
    }
    deleteAt(index, length) {
        super.deleteAt(index, length);
        this.cache = {};
    }
    formatAt(index, length, name, value) {
        if (length <= 0) return;
        if (this.scroll.query(name, (0, $45gdf.Scope).BLOCK)) {
            if (index + length === this.length()) this.format(name, value);
        } else super.formatAt(index, Math.min(length, this.length() - index - 1), name, value);
        this.cache = {};
    }
    insertAt(index, value, def) {
        if (def != null) {
            super.insertAt(index, value, def);
            this.cache = {};
            return;
        }
        if (value.length === 0) return;
        const lines = value.split('\n');
        const text = lines.shift();
        if (text.length > 0) {
            if (index < this.length() - 1 || this.children.tail == null) super.insertAt(Math.min(index, this.length() - 1), text);
            else this.children.tail.insertAt(this.children.tail.length(), text);
            this.cache = {};
        }
        // TODO: Fix this next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let block = this;
        lines.reduce((lineIndex, line)=>{
            // @ts-expect-error Fix me later
            block = block.split(lineIndex, true);
            block.insertAt(0, line);
            return line.length;
        }, index + text.length);
    }
    insertBefore(blot, ref) {
        const { head: head } = this.children;
        super.insertBefore(blot, ref);
        if (head instanceof (0, $gkqQr.default)) head.remove();
        this.cache = {};
    }
    length() {
        if (this.cache.length == null) this.cache.length = super.length() + $e7f02381fd0887d3$var$NEWLINE_LENGTH;
        return this.cache.length;
    }
    moveChildren(target, ref) {
        super.moveChildren(target, ref);
        this.cache = {};
    }
    optimize(context) {
        super.optimize(context);
        this.cache = {};
    }
    path(index) {
        return super.path(index, true);
    }
    removeChild(child) {
        super.removeChild(child);
        this.cache = {};
    }
    split(index) {
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (force && (index === 0 || index >= this.length() - $e7f02381fd0887d3$var$NEWLINE_LENGTH)) {
            const clone = this.clone();
            if (index === 0) {
                this.parent.insertBefore(clone, this);
                return this;
            }
            this.parent.insertBefore(clone, this.next);
            return clone;
        }
        const next = super.split(index, force);
        this.cache = {};
        return next;
    }
}
$e7f02381fd0887d3$export$2e2bcd8739ae039.blotName = 'block';
$e7f02381fd0887d3$export$2e2bcd8739ae039.tagName = 'P';
$e7f02381fd0887d3$export$2e2bcd8739ae039.defaultChild = (0, $gkqQr.default);
$e7f02381fd0887d3$export$2e2bcd8739ae039.allowedChildren = [
    (0, $gkqQr.default),
    (0, $95m1U.default),
    (0, $45gdf.EmbedBlot),
    (0, $l6ueR.default)
];
class $e7f02381fd0887d3$export$48b9f0688962d028 extends (0, $45gdf.EmbedBlot) {
    attach() {
        super.attach();
        this.attributes = new (0, $45gdf.AttributorStore)(this.domNode);
    }
    delta() {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().insert(this.value(), {
            ...this.formats(),
            ...this.attributes.values()
        });
    }
    format(name, value) {
        const attribute = this.scroll.query(name, (0, $45gdf.Scope).BLOCK_ATTRIBUTE);
        if (attribute != null) // @ts-expect-error TODO: Scroll#query() should return Attributor when scope is attribute
        this.attributes.attribute(attribute, value);
    }
    formatAt(index, length, name, value) {
        this.format(name, value);
    }
    insertAt(index, value, def) {
        if (def != null) {
            super.insertAt(index, value, def);
            return;
        }
        const lines = value.split('\n');
        const text = lines.pop();
        const blocks = lines.map((line)=>{
            const block = this.scroll.create($e7f02381fd0887d3$export$2e2bcd8739ae039.blotName);
            block.insertAt(0, line);
            return block;
        });
        const ref = this.split(index);
        blocks.forEach((block)=>{
            this.parent.insertBefore(block, ref);
        });
        if (text) this.parent.insertBefore(this.scroll.create('text', text), ref);
    }
}
$e7f02381fd0887d3$export$48b9f0688962d028.scope = (0, $45gdf.Scope).BLOCK_BLOT;
// It is important for cursor behavior BlockEmbeds use tags that are block level elements
function $e7f02381fd0887d3$export$992ff47219af5a2b(blot) {
    let filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return blot.descendants((0, $45gdf.LeafBlot)).reduce((delta, leaf)=>{
        if (leaf.length() === 0) return delta;
        return delta.insert(leaf.value(), $e7f02381fd0887d3$export$e4bb5a6163449612(leaf, {}, filter));
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))()).insert('\n', $e7f02381fd0887d3$export$e4bb5a6163449612(blot));
}
function $e7f02381fd0887d3$export$e4bb5a6163449612(blot) {
    let formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (blot == null) return formats;
    if ('formats' in blot && typeof blot.formats === 'function') {
        formats = {
            ...formats,
            ...blot.formats()
        };
        if (filter) // exclude syntax highlighting from deltas and getFormat()
        delete formats['code-token'];
    }
    if (blot.parent == null || blot.parent.statics.blotName === 'scroll' || blot.parent.statics.scope !== blot.statics.scope) return formats;
    return $e7f02381fd0887d3$export$e4bb5a6163449612(blot.parent, formats, filter);
}

});
parcelRegister("gkqQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $be33566837cfcf5a$export$2e2bcd8739ae039);

var $45gdf = parcelRequire("45gdf");
class $be33566837cfcf5a$var$Break extends (0, $45gdf.EmbedBlot) {
    static value() {
        return undefined;
    }
    optimize() {
        if (this.prev || this.next) this.remove();
    }
    length() {
        return 0;
    }
    value() {
        return '';
    }
}
$be33566837cfcf5a$var$Break.blotName = 'break';
$be33566837cfcf5a$var$Break.tagName = 'BR';
var $be33566837cfcf5a$export$2e2bcd8739ae039 = $be33566837cfcf5a$var$Break;

});

parcelRegister("95m1U", function(module, exports) {

$parcel$export(module.exports, "default", () => $69d5ab5da0d40991$export$2e2bcd8739ae039);

var $45gdf = parcelRequire("45gdf");

var $gkqQr = parcelRequire("gkqQr");

var $l6ueR = parcelRequire("l6ueR");
class $69d5ab5da0d40991$var$Inline extends (0, $45gdf.InlineBlot) {
    static allowedChildren = [
        $69d5ab5da0d40991$var$Inline,
        (0, $gkqQr.default),
        (0, $45gdf.EmbedBlot),
        (0, $l6ueR.default)
    ];
    // Lower index means deeper in the DOM tree, since not found (-1) is for embeds
    static order = [
        'cursor',
        'inline',
        // Must be lower
        'link',
        // Chrome wants <a> to be lower
        'underline',
        'strike',
        'italic',
        'bold',
        'script',
        'code' // Must be higher
    ];
    static compare(self, other) {
        const selfIndex = $69d5ab5da0d40991$var$Inline.order.indexOf(self);
        const otherIndex = $69d5ab5da0d40991$var$Inline.order.indexOf(other);
        if (selfIndex >= 0 || otherIndex >= 0) return selfIndex - otherIndex;
        if (self === other) return 0;
        if (self < other) return -1;
        return 1;
    }
    formatAt(index, length, name, value) {
        if ($69d5ab5da0d40991$var$Inline.compare(this.statics.blotName, name) < 0 && this.scroll.query(name, (0, $45gdf.Scope).BLOT)) {
            const blot = this.isolate(index, length);
            if (value) blot.wrap(name, value);
        } else super.formatAt(index, length, name, value);
    }
    optimize(context) {
        super.optimize(context);
        if (this.parent instanceof $69d5ab5da0d40991$var$Inline && $69d5ab5da0d40991$var$Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
            const parent = this.parent.isolate(this.offset(), this.length());
            // @ts-expect-error TODO: make isolate generic
            this.moveChildren(parent);
            parent.wrap(this);
        }
    }
}
var $69d5ab5da0d40991$export$2e2bcd8739ae039 = $69d5ab5da0d40991$var$Inline;

});
parcelRegister("l6ueR", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5d19d4d969d4a59$export$2e2bcd8739ae039);
$parcel$export(module.exports, "escapeText", () => $f5d19d4d969d4a59$export$96e6fc3a139b2555);

var $45gdf = parcelRequire("45gdf");
class $f5d19d4d969d4a59$export$2e2bcd8739ae039 extends (0, $45gdf.TextBlot) {
}
// https://lodash.com/docs#escape
const $f5d19d4d969d4a59$var$entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
};
function $f5d19d4d969d4a59$export$96e6fc3a139b2555(text) {
    return text.replace(/[&<>"']/g, (s)=>$f5d19d4d969d4a59$var$entityMap[s]);
}

});



parcelRegister("9VFAE", function(module, exports) {

$parcel$export(module.exports, "default", () => $73a9b2db786e2434$export$2e2bcd8739ae039);

var $45gdf = parcelRequire("45gdf");

var $l6ueR = parcelRequire("l6ueR");
class $73a9b2db786e2434$var$Cursor extends (0, $45gdf.EmbedBlot) {
    static blotName = 'cursor';
    static className = 'ql-cursor';
    static tagName = 'span';
    static CONTENTS = '\uFEFF';
    static value() {
        return undefined;
    }
    constructor(scroll, domNode, selection){
        super(scroll, domNode);
        this.selection = selection;
        this.textNode = document.createTextNode($73a9b2db786e2434$var$Cursor.CONTENTS);
        this.domNode.appendChild(this.textNode);
        this.savedLength = 0;
    }
    detach() {
        // super.detach() will also clear domNode.__blot
        if (this.parent != null) this.parent.removeChild(this);
    }
    format(name, value) {
        if (this.savedLength !== 0) {
            super.format(name, value);
            return;
        }
        // TODO: Fix this next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let target = this;
        let index = 0;
        while(target != null && target.statics.scope !== (0, $45gdf.Scope).BLOCK_BLOT){
            index += target.offset(target.parent);
            target = target.parent;
        }
        if (target != null) {
            this.savedLength = $73a9b2db786e2434$var$Cursor.CONTENTS.length;
            // @ts-expect-error TODO: allow empty context in Parchment
            target.optimize();
            target.formatAt(index, $73a9b2db786e2434$var$Cursor.CONTENTS.length, name, value);
            this.savedLength = 0;
        }
    }
    index(node, offset) {
        if (node === this.textNode) return 0;
        return super.index(node, offset);
    }
    length() {
        return this.savedLength;
    }
    position() {
        return [
            this.textNode,
            this.textNode.data.length
        ];
    }
    remove() {
        super.remove();
        // @ts-expect-error Fix me later
        this.parent = null;
    }
    restore() {
        if (this.selection.composing || this.parent == null) return null;
        const range = this.selection.getNativeRange();
        // Browser may push down styles/nodes inside the cursor blot.
        // https://dvcs.w3.org/hg/editing/raw-file/tip/editing.html#push-down-values
        while(this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode)// @ts-expect-error Fix me later
        this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
        const prevTextBlot = this.prev instanceof (0, $l6ueR.default) ? this.prev : null;
        const prevTextLength = prevTextBlot ? prevTextBlot.length() : 0;
        const nextTextBlot = this.next instanceof (0, $l6ueR.default) ? this.next : null;
        // @ts-expect-error TODO: make TextBlot.text public
        const nextText = nextTextBlot ? nextTextBlot.text : '';
        const { textNode: textNode } = this;
        // take text from inside this blot and reset it
        const newText = textNode.data.split($73a9b2db786e2434$var$Cursor.CONTENTS).join('');
        textNode.data = $73a9b2db786e2434$var$Cursor.CONTENTS;
        // proactively merge TextBlots around cursor so that optimization
        // doesn't lose the cursor.  the reason we are here in cursor.restore
        // could be that the user clicked in prevTextBlot or nextTextBlot, or
        // the user typed something.
        let mergedTextBlot;
        if (prevTextBlot) {
            mergedTextBlot = prevTextBlot;
            if (newText || nextTextBlot) {
                prevTextBlot.insertAt(prevTextBlot.length(), newText + nextText);
                if (nextTextBlot) nextTextBlot.remove();
            }
        } else if (nextTextBlot) {
            mergedTextBlot = nextTextBlot;
            nextTextBlot.insertAt(0, newText);
        } else {
            const newTextNode = document.createTextNode(newText);
            mergedTextBlot = this.scroll.create(newTextNode);
            this.parent.insertBefore(mergedTextBlot, this);
        }
        this.remove();
        if (range) {
            // calculate selection to restore
            const remapOffset = (node, offset)=>{
                if (prevTextBlot && node === prevTextBlot.domNode) return offset;
                if (node === textNode) return prevTextLength + offset - 1;
                if (nextTextBlot && node === nextTextBlot.domNode) return prevTextLength + newText.length + offset;
                return null;
            };
            const start = remapOffset(range.start.node, range.start.offset);
            const end = remapOffset(range.end.node, range.end.offset);
            if (start !== null && end !== null) return {
                startNode: mergedTextBlot.domNode,
                startOffset: start,
                endNode: mergedTextBlot.domNode,
                endOffset: end
            };
        }
        return null;
    }
    update(mutations, context) {
        if (mutations.some((mutation)=>{
            return mutation.type === 'characterData' && mutation.target === this.textNode;
        })) {
            const range = this.restore();
            if (range) context.range = range;
        }
    }
    // Avoid .ql-cursor being a descendant of `<a/>`.
    // The reason is Safari pushes down `<a/>` on text insertion.
    // That will cause DOM nodes not sync with the model.
    //
    // For example ({I} is the caret), given the markup:
    //    <a><span class="ql-cursor">\uFEFF{I}</span></a>
    // When typing a char "x", `<a/>` will be pushed down inside the `<span>` first:
    //    <span class="ql-cursor"><a>\uFEFF{I}</a></span>
    // And then "x" will be inserted after `<a/>`:
    //    <span class="ql-cursor"><a>\uFEFF</a>d{I}</span>
    optimize(context) {
        // @ts-expect-error Fix me later
        super.optimize(context);
        let { parent: parent } = this;
        while(parent){
            if (parent.domNode.tagName === 'A') {
                this.savedLength = $73a9b2db786e2434$var$Cursor.CONTENTS.length;
                // @ts-expect-error TODO: make isolate generic
                parent.isolate(this.offset(parent), this.length()).unwrap();
                this.savedLength = 0;
                break;
            }
            parent = parent.parent;
        }
    }
    value() {
        return '';
    }
}
var $73a9b2db786e2434$export$2e2bcd8739ae039 = $73a9b2db786e2434$var$Cursor;

});

parcelRegister("6EzZS", function(module, exports) {

$parcel$export(module.exports, "Range", () => $4d8266c942c5bd0e$export$9a58ef0d7ad3278c);
$parcel$export(module.exports, "default", () => $4d8266c942c5bd0e$export$2e2bcd8739ae039);

var $45gdf = parcelRequire("45gdf");

var $buDZz = parcelRequire("buDZz");
var $4vxV0 = parcelRequire("4vxV0");

var $hJr1g = parcelRequire("hJr1g");

var $dwJXH = parcelRequire("dwJXH");
const $4d8266c942c5bd0e$var$debug = (0, $dwJXH.default)('quill:selection');
class $4d8266c942c5bd0e$export$9a58ef0d7ad3278c {
    constructor(index){
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        this.index = index;
        this.length = length;
    }
}
class $4d8266c942c5bd0e$var$Selection {
    constructor(scroll, emitter){
        this.emitter = emitter;
        this.scroll = scroll;
        this.composing = false;
        this.mouseDown = false;
        this.root = this.scroll.domNode;
        // @ts-expect-error
        this.cursor = this.scroll.create('cursor', this);
        // savedRange is last non-null range
        this.savedRange = new $4d8266c942c5bd0e$export$9a58ef0d7ad3278c(0, 0);
        this.lastRange = this.savedRange;
        this.lastNative = null;
        this.handleComposition();
        this.handleDragging();
        this.emitter.listenDOM('selectionchange', document, ()=>{
            if (!this.mouseDown && !this.composing) setTimeout(this.update.bind(this, (0, $hJr1g.default).sources.USER), 1);
        });
        this.emitter.on((0, $hJr1g.default).events.SCROLL_BEFORE_UPDATE, ()=>{
            if (!this.hasFocus()) return;
            const native = this.getNativeRange();
            if (native == null) return;
            if (native.start.node === this.cursor.textNode) return; // cursor.restore() will handle
            this.emitter.once((0, $hJr1g.default).events.SCROLL_UPDATE, (source, mutations)=>{
                try {
                    if (this.root.contains(native.start.node) && this.root.contains(native.end.node)) this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
                    const triggeredByTyping = mutations.some((mutation)=>mutation.type === 'characterData' || mutation.type === 'childList' || mutation.type === 'attributes' && mutation.target === this.root);
                    this.update(triggeredByTyping ? (0, $hJr1g.default).sources.SILENT : source);
                } catch (ignored) {
                // ignore
                }
            });
        });
        this.emitter.on((0, $hJr1g.default).events.SCROLL_OPTIMIZE, (mutations, context)=>{
            if (context.range) {
                const { startNode: startNode, startOffset: startOffset, endNode: endNode, endOffset: endOffset } = context.range;
                this.setNativeRange(startNode, startOffset, endNode, endOffset);
                this.update((0, $hJr1g.default).sources.SILENT);
            }
        });
        this.update((0, $hJr1g.default).sources.SILENT);
    }
    handleComposition() {
        this.emitter.on((0, $hJr1g.default).events.COMPOSITION_BEFORE_START, ()=>{
            this.composing = true;
        });
        this.emitter.on((0, $hJr1g.default).events.COMPOSITION_END, ()=>{
            this.composing = false;
            if (this.cursor.parent) {
                const range = this.cursor.restore();
                if (!range) return;
                setTimeout(()=>{
                    this.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
                }, 1);
            }
        });
    }
    handleDragging() {
        this.emitter.listenDOM('mousedown', document.body, ()=>{
            this.mouseDown = true;
        });
        this.emitter.listenDOM('mouseup', document.body, ()=>{
            this.mouseDown = false;
            this.update((0, $hJr1g.default).sources.USER);
        });
    }
    focus() {
        if (this.hasFocus()) return;
        this.root.focus({
            preventScroll: true
        });
        this.setRange(this.savedRange);
    }
    format(format, value) {
        this.scroll.update();
        const nativeRange = this.getNativeRange();
        if (nativeRange == null || !nativeRange.native.collapsed || this.scroll.query(format, (0, $45gdf.Scope).BLOCK)) return;
        if (nativeRange.start.node !== this.cursor.textNode) {
            const blot = this.scroll.find(nativeRange.start.node, false);
            if (blot == null) return;
            // TODO Give blot ability to not split
            if (blot instanceof (0, $45gdf.LeafBlot)) {
                const after = blot.split(nativeRange.start.offset);
                blot.parent.insertBefore(this.cursor, after);
            } else // @ts-expect-error TODO: nativeRange.start.node doesn't seem to match function signature
            blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
            this.cursor.attach();
        }
        this.cursor.format(format, value);
        this.scroll.optimize();
        this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
        this.update();
    }
    getBounds(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        const scrollLength = this.scroll.length();
        index = Math.min(index, scrollLength - 1);
        length = Math.min(index + length, scrollLength - 1) - index;
        let node;
        let [leaf, offset] = this.scroll.leaf(index);
        if (leaf == null) return null;
        if (length > 0 && offset === leaf.length()) {
            const [next] = this.scroll.leaf(index + 1);
            if (next) {
                const [line] = this.scroll.line(index);
                const [nextLine] = this.scroll.line(index + 1);
                if (line === nextLine) {
                    leaf = next;
                    offset = 0;
                }
            }
        }
        [node, offset] = leaf.position(offset, true);
        const range = document.createRange();
        if (length > 0) {
            range.setStart(node, offset);
            [leaf, offset] = this.scroll.leaf(index + length);
            if (leaf == null) return null;
            [node, offset] = leaf.position(offset, true);
            range.setEnd(node, offset);
            return range.getBoundingClientRect();
        }
        let side = 'left';
        let rect;
        if (node instanceof Text) {
            // Return null if the text node is empty because it is
            // not able to get a useful client rect:
            // https://github.com/w3c/csswg-drafts/issues/2514.
            // Empty text nodes are most likely caused by TextBlot#optimize()
            // not getting called when editor content changes.
            if (!node.data.length) return null;
            if (offset < node.data.length) {
                range.setStart(node, offset);
                range.setEnd(node, offset + 1);
            } else {
                range.setStart(node, offset - 1);
                range.setEnd(node, offset);
                side = 'right';
            }
            rect = range.getBoundingClientRect();
        } else {
            if (!(leaf.domNode instanceof Element)) return null;
            rect = leaf.domNode.getBoundingClientRect();
            if (offset > 0) side = 'right';
        }
        return {
            bottom: rect.top + rect.height,
            height: rect.height,
            left: rect[side],
            right: rect[side],
            top: rect.top,
            width: 0
        };
    }
    getNativeRange() {
        const selection = document.getSelection();
        if (selection == null || selection.rangeCount <= 0) return null;
        const nativeRange = selection.getRangeAt(0);
        if (nativeRange == null) return null;
        const range = this.normalizeNative(nativeRange);
        $4d8266c942c5bd0e$var$debug.info('getNativeRange', range);
        return range;
    }
    getRange() {
        const root = this.scroll.domNode;
        if ('isConnected' in root && !root.isConnected) // document.getSelection() forces layout on Blink, so we trend to
        // not calling it.
        return [
            null,
            null
        ];
        const normalized = this.getNativeRange();
        if (normalized == null) return [
            null,
            null
        ];
        const range = this.normalizedToRange(normalized);
        return [
            range,
            normalized
        ];
    }
    hasFocus() {
        return document.activeElement === this.root || document.activeElement != null && $4d8266c942c5bd0e$var$contains(this.root, document.activeElement);
    }
    normalizedToRange(range) {
        const positions = [
            [
                range.start.node,
                range.start.offset
            ]
        ];
        if (!range.native.collapsed) positions.push([
            range.end.node,
            range.end.offset
        ]);
        const indexes = positions.map((position)=>{
            const [node, offset] = position;
            const blot = this.scroll.find(node, true);
            // @ts-expect-error Fix me later
            const index = blot.offset(this.scroll);
            if (offset === 0) return index;
            if (blot instanceof (0, $45gdf.LeafBlot)) return index + blot.index(node, offset);
            // @ts-expect-error Fix me later
            return index + blot.length();
        });
        const end = Math.min(Math.max(...indexes), this.scroll.length() - 1);
        const start = Math.min(end, ...indexes);
        return new $4d8266c942c5bd0e$export$9a58ef0d7ad3278c(start, end - start);
    }
    normalizeNative(nativeRange) {
        if (!$4d8266c942c5bd0e$var$contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !$4d8266c942c5bd0e$var$contains(this.root, nativeRange.endContainer)) return null;
        const range = {
            start: {
                node: nativeRange.startContainer,
                offset: nativeRange.startOffset
            },
            end: {
                node: nativeRange.endContainer,
                offset: nativeRange.endOffset
            },
            native: nativeRange
        };
        [
            range.start,
            range.end
        ].forEach((position)=>{
            let { node: node, offset: offset } = position;
            while(!(node instanceof Text) && node.childNodes.length > 0){
                if (node.childNodes.length > offset) {
                    node = node.childNodes[offset];
                    offset = 0;
                } else if (node.childNodes.length === offset) {
                    // @ts-expect-error Fix me later
                    node = node.lastChild;
                    if (node instanceof Text) offset = node.data.length;
                    else if (node.childNodes.length > 0) // Container case
                    offset = node.childNodes.length;
                    else // Embed case
                    offset = node.childNodes.length + 1;
                } else break;
            }
            position.node = node;
            position.offset = offset;
        });
        return range;
    }
    rangeToNative(range) {
        const scrollLength = this.scroll.length();
        const getPosition = (index, inclusive)=>{
            index = Math.min(scrollLength - 1, index);
            const [leaf, leafOffset] = this.scroll.leaf(index);
            return leaf ? leaf.position(leafOffset, inclusive) : [
                null,
                -1
            ];
        };
        return [
            ...getPosition(range.index, false),
            ...getPosition(range.index + range.length, true)
        ];
    }
    setNativeRange(startNode, startOffset) {
        let endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
        let endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
        let force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
        $4d8266c942c5bd0e$var$debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
        if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || // @ts-expect-error Fix me later
        endNode.parentNode == null)) return;
        const selection = document.getSelection();
        if (selection == null) return;
        if (startNode != null) {
            if (!this.hasFocus()) this.root.focus({
                preventScroll: true
            });
            const { native: native } = this.getNativeRange() || {};
            if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {
                if (startNode instanceof Element && startNode.tagName === 'BR') {
                    // @ts-expect-error Fix me later
                    startOffset = Array.from(startNode.parentNode.childNodes).indexOf(startNode);
                    startNode = startNode.parentNode;
                }
                if (endNode instanceof Element && endNode.tagName === 'BR') {
                    // @ts-expect-error Fix me later
                    endOffset = Array.from(endNode.parentNode.childNodes).indexOf(endNode);
                    endNode = endNode.parentNode;
                }
                const range = document.createRange();
                // @ts-expect-error Fix me later
                range.setStart(startNode, startOffset);
                // @ts-expect-error Fix me later
                range.setEnd(endNode, endOffset);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        } else {
            selection.removeAllRanges();
            this.root.blur();
        }
    }
    setRange(range) {
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $hJr1g.default).sources.API;
        if (typeof force === 'string') {
            source = force;
            force = false;
        }
        $4d8266c942c5bd0e$var$debug.info('setRange', range);
        if (range != null) {
            const args = this.rangeToNative(range);
            this.setNativeRange(...args, force);
        } else this.setNativeRange(null);
        this.update(source);
    }
    update() {
        let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $hJr1g.default).sources.USER;
        const oldRange = this.lastRange;
        const [lastRange, nativeRange] = this.getRange();
        this.lastRange = lastRange;
        this.lastNative = nativeRange;
        if (this.lastRange != null) this.savedRange = this.lastRange;
        if (!(0, $4vxV0.default)(oldRange, this.lastRange)) {
            if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
                const range = this.cursor.restore();
                if (range) this.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
            }
            const args = [
                (0, $hJr1g.default).events.SELECTION_CHANGE,
                (0, $buDZz.default)(this.lastRange),
                (0, $buDZz.default)(oldRange),
                source
            ];
            this.emitter.emit((0, $hJr1g.default).events.EDITOR_CHANGE, ...args);
            if (source !== (0, $hJr1g.default).sources.SILENT) this.emitter.emit(...args);
        }
    }
}
function $4d8266c942c5bd0e$var$contains(parent, descendant) {
    try {
        // Firefox inserts inaccessible nodes around video elements
        descendant.parentNode; // eslint-disable-line @typescript-eslint/no-unused-expressions
    } catch (e) {
        return false;
    }
    return parent.contains(descendant);
}
var $4d8266c942c5bd0e$export$2e2bcd8739ae039 = $4d8266c942c5bd0e$var$Selection;

});
parcelRegister("hJr1g", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce8b991fc042788b$export$2e2bcd8739ae039);
parcelRequire("fEII2");
var $jdUOE = parcelRequire("jdUOE");

var $315Gv = parcelRequire("315Gv");

var $dwJXH = parcelRequire("dwJXH");
const $ce8b991fc042788b$var$debug = (0, $dwJXH.default)('quill:events');
const $ce8b991fc042788b$var$EVENTS = [
    'selectionchange',
    'mousedown',
    'mouseup',
    'click'
];
$ce8b991fc042788b$var$EVENTS.forEach((eventName)=>{
    document.addEventListener(eventName, function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        Array.from(document.querySelectorAll('.ql-container')).forEach((node)=>{
            const quill = (0, $315Gv.default).get(node);
            if (quill && quill.emitter) quill.emitter.handleDOM(...args);
        });
    });
});
class $ce8b991fc042788b$var$Emitter extends (0, (/*@__PURE__*/$parcel$interopDefault($jdUOE))) {
    static events = {
        EDITOR_CHANGE: 'editor-change',
        SCROLL_BEFORE_UPDATE: 'scroll-before-update',
        SCROLL_BLOT_MOUNT: 'scroll-blot-mount',
        SCROLL_BLOT_UNMOUNT: 'scroll-blot-unmount',
        SCROLL_OPTIMIZE: 'scroll-optimize',
        SCROLL_UPDATE: 'scroll-update',
        SCROLL_EMBED_UPDATE: 'scroll-embed-update',
        SELECTION_CHANGE: 'selection-change',
        TEXT_CHANGE: 'text-change',
        COMPOSITION_BEFORE_START: 'composition-before-start',
        COMPOSITION_START: 'composition-start',
        COMPOSITION_BEFORE_END: 'composition-before-end',
        COMPOSITION_END: 'composition-end'
    };
    static sources = {
        API: 'api',
        SILENT: 'silent',
        USER: 'user'
    };
    constructor(){
        super();
        this.domListeners = {};
        this.on('error', $ce8b991fc042788b$var$debug.error);
    }
    emit() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        $ce8b991fc042788b$var$debug.log.call($ce8b991fc042788b$var$debug, ...args);
        // @ts-expect-error
        return super.emit(...args);
    }
    handleDOM(event) {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        (this.domListeners[event.type] || []).forEach((_ref)=>{
            let { node: node, handler: handler } = _ref;
            if (event.target === node || node.contains(event.target)) handler(event, ...args);
        });
    }
    listenDOM(eventName, node, handler) {
        if (!this.domListeners[eventName]) this.domListeners[eventName] = [];
        this.domListeners[eventName].push({
            node: node,
            handler: handler
        });
    }
}
var $ce8b991fc042788b$export$2e2bcd8739ae039 = $ce8b991fc042788b$var$Emitter;

});
parcelRegister("fEII2", function(module, exports) {

$parcel$export(module.exports, "EventEmitter", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("jdUOE")))));

var $jdUOE = parcelRequire("jdUOE");
var $109334eaa8f15a67$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($jdUOE)));

});
parcelRegister("jdUOE", function(module, exports) {
'use strict';
var $dfeb4db2d5e79956$var$has = Object.prototype.hasOwnProperty, $dfeb4db2d5e79956$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $dfeb4db2d5e79956$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $dfeb4db2d5e79956$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $dfeb4db2d5e79956$var$Events().__proto__) $dfeb4db2d5e79956$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $dfeb4db2d5e79956$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $dfeb4db2d5e79956$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $dfeb4db2d5e79956$var$EE(fn, context || emitter, once), evt = $dfeb4db2d5e79956$var$prefix ? $dfeb4db2d5e79956$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $dfeb4db2d5e79956$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $dfeb4db2d5e79956$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $dfeb4db2d5e79956$var$EventEmitter() {
    this._events = new $dfeb4db2d5e79956$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $dfeb4db2d5e79956$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($dfeb4db2d5e79956$var$has.call(events, name)) names.push($dfeb4db2d5e79956$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $dfeb4db2d5e79956$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $dfeb4db2d5e79956$var$prefix ? $dfeb4db2d5e79956$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $dfeb4db2d5e79956$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $dfeb4db2d5e79956$var$prefix ? $dfeb4db2d5e79956$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $dfeb4db2d5e79956$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $dfeb4db2d5e79956$var$prefix ? $dfeb4db2d5e79956$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $dfeb4db2d5e79956$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $dfeb4db2d5e79956$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $dfeb4db2d5e79956$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $dfeb4db2d5e79956$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $dfeb4db2d5e79956$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $dfeb4db2d5e79956$var$prefix ? $dfeb4db2d5e79956$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $dfeb4db2d5e79956$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $dfeb4db2d5e79956$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $dfeb4db2d5e79956$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $dfeb4db2d5e79956$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $dfeb4db2d5e79956$var$prefix ? $dfeb4db2d5e79956$var$prefix + event : event;
        if (this._events[evt]) $dfeb4db2d5e79956$var$clearEvent(this, evt);
    } else {
        this._events = new $dfeb4db2d5e79956$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$dfeb4db2d5e79956$var$EventEmitter.prototype.off = $dfeb4db2d5e79956$var$EventEmitter.prototype.removeListener;
$dfeb4db2d5e79956$var$EventEmitter.prototype.addListener = $dfeb4db2d5e79956$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$dfeb4db2d5e79956$var$EventEmitter.prefixed = $dfeb4db2d5e79956$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$dfeb4db2d5e79956$var$EventEmitter.EventEmitter = $dfeb4db2d5e79956$var$EventEmitter;
module.exports = $dfeb4db2d5e79956$var$EventEmitter;

});


parcelRegister("315Gv", function(module, exports) {

$parcel$export(module.exports, "default", () => $2325dfea80138dfc$export$2e2bcd8739ae039);
var $2325dfea80138dfc$export$2e2bcd8739ae039 = new WeakMap();

});

parcelRegister("dwJXH", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d91ea9b066a8835$export$2e2bcd8739ae039);
const $9d91ea9b066a8835$var$levels = [
    'error',
    'warn',
    'log',
    'info'
];
let $9d91ea9b066a8835$var$level = 'warn';
function $9d91ea9b066a8835$var$debug(method) {
    if ($9d91ea9b066a8835$var$level) {
        if ($9d91ea9b066a8835$var$levels.indexOf(method) <= $9d91ea9b066a8835$var$levels.indexOf($9d91ea9b066a8835$var$level)) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            console[method](...args); // eslint-disable-line no-console
        }
    }
}
function $9d91ea9b066a8835$var$namespace(ns) {
    return $9d91ea9b066a8835$var$levels.reduce((logger, method)=>{
        logger[method] = $9d91ea9b066a8835$var$debug.bind(console, method, ns);
        return logger;
    }, {});
}
$9d91ea9b066a8835$var$namespace.level = (newLevel)=>{
    $9d91ea9b066a8835$var$level = newLevel;
};
$9d91ea9b066a8835$var$debug.level = $9d91ea9b066a8835$var$namespace.level;
var $9d91ea9b066a8835$export$2e2bcd8739ae039 = $9d91ea9b066a8835$var$namespace;

});




parcelRegister("43smM", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f3d7237fe69d5d5$export$2e2bcd8739ae039);
class $2f3d7237fe69d5d5$var$Module {
    static DEFAULTS = {};
    constructor(quill){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.quill = quill;
        this.options = options;
    }
}
var $2f3d7237fe69d5d5$export$2e2bcd8739ae039 = $2f3d7237fe69d5d5$var$Module;

});

parcelRegister("C3M1D", function(module, exports) {

$parcel$export(module.exports, "default", () => $07267a155661a1e1$export$2e2bcd8739ae039);

var $jqZQb = parcelRequire("jqZQb");

var $hJr1g = parcelRequire("hJr1g");
class $07267a155661a1e1$var$Composition {
    isComposing = false;
    constructor(scroll, emitter){
        this.scroll = scroll;
        this.emitter = emitter;
        this.setupListeners();
    }
    setupListeners() {
        this.scroll.domNode.addEventListener('compositionstart', (event)=>{
            if (!this.isComposing) this.handleCompositionStart(event);
        });
        this.scroll.domNode.addEventListener('compositionend', (event)=>{
            if (this.isComposing) // Webkit makes DOM changes after compositionend, so we use microtask to
            // ensure the order.
            // https://bugs.webkit.org/show_bug.cgi?id=31902
            queueMicrotask(()=>{
                this.handleCompositionEnd(event);
            });
        });
    }
    handleCompositionStart(event) {
        const blot = event.target instanceof Node ? this.scroll.find(event.target, true) : null;
        if (blot && !(blot instanceof (0, $jqZQb.default))) {
            this.emitter.emit((0, $hJr1g.default).events.COMPOSITION_BEFORE_START, event);
            this.scroll.batchStart();
            this.emitter.emit((0, $hJr1g.default).events.COMPOSITION_START, event);
            this.isComposing = true;
        }
    }
    handleCompositionEnd(event) {
        this.emitter.emit((0, $hJr1g.default).events.COMPOSITION_BEFORE_END, event);
        this.scroll.batchEnd();
        this.emitter.emit((0, $hJr1g.default).events.COMPOSITION_END, event);
        this.isComposing = false;
    }
}
var $07267a155661a1e1$export$2e2bcd8739ae039 = $07267a155661a1e1$var$Composition;

});
parcelRegister("jqZQb", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2606a4dbdbce08b$export$2e2bcd8739ae039);

var $45gdf = parcelRequire("45gdf");

var $l6ueR = parcelRequire("l6ueR");
const $e2606a4dbdbce08b$var$GUARD_TEXT = '\uFEFF';
class $e2606a4dbdbce08b$var$Embed extends (0, $45gdf.EmbedBlot) {
    constructor(scroll, node){
        super(scroll, node);
        this.contentNode = document.createElement('span');
        this.contentNode.setAttribute('contenteditable', 'false');
        Array.from(this.domNode.childNodes).forEach((childNode)=>{
            this.contentNode.appendChild(childNode);
        });
        this.leftGuard = document.createTextNode($e2606a4dbdbce08b$var$GUARD_TEXT);
        this.rightGuard = document.createTextNode($e2606a4dbdbce08b$var$GUARD_TEXT);
        this.domNode.appendChild(this.leftGuard);
        this.domNode.appendChild(this.contentNode);
        this.domNode.appendChild(this.rightGuard);
    }
    index(node, offset) {
        if (node === this.leftGuard) return 0;
        if (node === this.rightGuard) return 1;
        return super.index(node, offset);
    }
    restore(node) {
        let range = null;
        let textNode;
        const text = node.data.split($e2606a4dbdbce08b$var$GUARD_TEXT).join('');
        if (node === this.leftGuard) {
            if (this.prev instanceof (0, $l6ueR.default)) {
                const prevLength = this.prev.length();
                this.prev.insertAt(prevLength, text);
                range = {
                    startNode: this.prev.domNode,
                    startOffset: prevLength + text.length
                };
            } else {
                textNode = document.createTextNode(text);
                this.parent.insertBefore(this.scroll.create(textNode), this);
                range = {
                    startNode: textNode,
                    startOffset: text.length
                };
            }
        } else if (node === this.rightGuard) {
            if (this.next instanceof (0, $l6ueR.default)) {
                this.next.insertAt(0, text);
                range = {
                    startNode: this.next.domNode,
                    startOffset: text.length
                };
            } else {
                textNode = document.createTextNode(text);
                this.parent.insertBefore(this.scroll.create(textNode), this.next);
                range = {
                    startNode: textNode,
                    startOffset: text.length
                };
            }
        }
        node.data = $e2606a4dbdbce08b$var$GUARD_TEXT;
        return range;
    }
    update(mutations, context) {
        mutations.forEach((mutation)=>{
            if (mutation.type === 'characterData' && (mutation.target === this.leftGuard || mutation.target === this.rightGuard)) {
                const range = this.restore(mutation.target);
                if (range) context.range = range;
            }
        });
    }
}
var $e2606a4dbdbce08b$export$2e2bcd8739ae039 = $e2606a4dbdbce08b$var$Embed;

});


parcelRegister("8ioPK", function(module, exports) {

$parcel$export(module.exports, "default", () => $60a3449d0b8ea62b$export$2e2bcd8739ae039);
class $60a3449d0b8ea62b$var$Theme {
    static DEFAULTS = {
        modules: {}
    };
    static themes = {
        default: $60a3449d0b8ea62b$var$Theme
    };
    modules = {};
    constructor(quill, options){
        this.quill = quill;
        this.options = options;
    }
    init() {
        Object.keys(this.options.modules).forEach((name)=>{
            if (this.modules[name] == null) this.addModule(name);
        });
    }
    addModule(name) {
        // @ts-expect-error
        const ModuleClass = this.quill.constructor.import(`modules/${name}`);
        this.modules[name] = new ModuleClass(this.quill, this.options.modules[name] || {});
        return this.modules[name];
    }
}
var $60a3449d0b8ea62b$export$2e2bcd8739ae039 = $60a3449d0b8ea62b$var$Theme;

});

parcelRegister("2tdRQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cc90bfc6dbbf5aa$export$2e2bcd8739ae039);
const $1cc90bfc6dbbf5aa$var$getParentElement = (element)=>element.parentElement || element.getRootNode().host || null;
const $1cc90bfc6dbbf5aa$var$getElementRect = (element)=>{
    const rect = element.getBoundingClientRect();
    const scaleX = 'offsetWidth' in element && Math.abs(rect.width) / element.offsetWidth || 1;
    const scaleY = 'offsetHeight' in element && Math.abs(rect.height) / element.offsetHeight || 1;
    return {
        top: rect.top,
        right: rect.left + element.clientWidth * scaleX,
        bottom: rect.top + element.clientHeight * scaleY,
        left: rect.left
    };
};
const $1cc90bfc6dbbf5aa$var$paddingValueToInt = (value)=>{
    const number = parseInt(value, 10);
    return Number.isNaN(number) ? 0 : number;
};
// Follow the steps described in https://www.w3.org/TR/cssom-view-1/#element-scrolling-members,
// assuming that the scroll option is set to 'nearest'.
const $1cc90bfc6dbbf5aa$var$getScrollDistance = (targetStart, targetEnd, scrollStart, scrollEnd, scrollPaddingStart, scrollPaddingEnd)=>{
    if (targetStart < scrollStart && targetEnd > scrollEnd) return 0;
    if (targetStart < scrollStart) return -(scrollStart - targetStart + scrollPaddingStart);
    if (targetEnd > scrollEnd) return targetEnd - targetStart > scrollEnd - scrollStart ? targetStart + scrollPaddingStart - scrollStart : targetEnd - scrollEnd + scrollPaddingEnd;
    return 0;
};
const $1cc90bfc6dbbf5aa$var$scrollRectIntoView = (root, targetRect)=>{
    const document = root.ownerDocument;
    let rect = targetRect;
    let current = root;
    while(current){
        const isDocumentBody = current === document.body;
        const bounding = isDocumentBody ? {
            top: 0,
            right: window.visualViewport?.width ?? document.documentElement.clientWidth,
            bottom: window.visualViewport?.height ?? document.documentElement.clientHeight,
            left: 0
        } : $1cc90bfc6dbbf5aa$var$getElementRect(current);
        const style = getComputedStyle(current);
        const scrollDistanceX = $1cc90bfc6dbbf5aa$var$getScrollDistance(rect.left, rect.right, bounding.left, bounding.right, $1cc90bfc6dbbf5aa$var$paddingValueToInt(style.scrollPaddingLeft), $1cc90bfc6dbbf5aa$var$paddingValueToInt(style.scrollPaddingRight));
        const scrollDistanceY = $1cc90bfc6dbbf5aa$var$getScrollDistance(rect.top, rect.bottom, bounding.top, bounding.bottom, $1cc90bfc6dbbf5aa$var$paddingValueToInt(style.scrollPaddingTop), $1cc90bfc6dbbf5aa$var$paddingValueToInt(style.scrollPaddingBottom));
        if (scrollDistanceX || scrollDistanceY) {
            if (isDocumentBody) document.defaultView?.scrollBy(scrollDistanceX, scrollDistanceY);
            else {
                const { scrollLeft: scrollLeft, scrollTop: scrollTop } = current;
                if (scrollDistanceY) current.scrollTop += scrollDistanceY;
                if (scrollDistanceX) current.scrollLeft += scrollDistanceX;
                const scrolledLeft = current.scrollLeft - scrollLeft;
                const scrolledTop = current.scrollTop - scrollTop;
                rect = {
                    left: rect.left - scrolledLeft,
                    top: rect.top - scrolledTop,
                    right: rect.right - scrolledLeft,
                    bottom: rect.bottom - scrolledTop
                };
            }
        }
        current = isDocumentBody || style.position === 'fixed' ? null : $1cc90bfc6dbbf5aa$var$getParentElement(current);
    }
};
var $1cc90bfc6dbbf5aa$export$2e2bcd8739ae039 = $1cc90bfc6dbbf5aa$var$scrollRectIntoView;

});

parcelRegister("5bW5Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c7b0b582d1382dc$export$2e2bcd8739ae039);

var $45gdf = parcelRequire("45gdf");
const $3c7b0b582d1382dc$var$MAX_REGISTER_ITERATIONS = 100;
const $3c7b0b582d1382dc$var$CORE_FORMATS = [
    'block',
    'break',
    'cursor',
    'inline',
    'scroll',
    'text'
];
const $3c7b0b582d1382dc$var$createRegistryWithFormats = (formats, sourceRegistry, debug)=>{
    const registry = new (0, $45gdf.Registry)();
    $3c7b0b582d1382dc$var$CORE_FORMATS.forEach((name)=>{
        const coreBlot = sourceRegistry.query(name);
        if (coreBlot) registry.register(coreBlot);
    });
    formats.forEach((name)=>{
        let format = sourceRegistry.query(name);
        if (!format) debug.error(`Cannot register "${name}" specified in "formats" config. Are you sure it was registered?`);
        let iterations = 0;
        while(format){
            registry.register(format);
            format = 'blotName' in format ? format.requiredContainer ?? null : null;
            iterations += 1;
            if (iterations > $3c7b0b582d1382dc$var$MAX_REGISTER_ITERATIONS) {
                debug.error(`Cycle detected in registering blot requiredContainer: "${name}"`);
                break;
            }
        }
    });
    return registry;
};
var $3c7b0b582d1382dc$export$2e2bcd8739ae039 = $3c7b0b582d1382dc$var$createRegistryWithFormats;

});


parcelRegister("BNn3z", function(module, exports) {

$parcel$export(module.exports, "default", () => $0719c0d8199db986$export$2e2bcd8739ae039);

var $45gdf = parcelRequire("45gdf");
class $0719c0d8199db986$var$Container extends (0, $45gdf.ContainerBlot) {
}
var $0719c0d8199db986$export$2e2bcd8739ae039 = $0719c0d8199db986$var$Container;

});

parcelRegister("4BsTF", function(module, exports) {

$parcel$export(module.exports, "default", () => $35a10876ab1dd85b$export$2e2bcd8739ae039);

var $45gdf = parcelRequire("45gdf");

var $ehD63 = parcelRequire("ehD63");

var $hJr1g = parcelRequire("hJr1g");

var $jUBfi = parcelRequire("jUBfi");

var $gkqQr = parcelRequire("gkqQr");

var $BNn3z = parcelRequire("BNn3z");
function $35a10876ab1dd85b$var$isLine(blot) {
    return blot instanceof (0, $jUBfi.default) || blot instanceof (0, $jUBfi.BlockEmbed);
}
function $35a10876ab1dd85b$var$isUpdatable(blot) {
    return typeof blot.updateContent === 'function';
}
class $35a10876ab1dd85b$var$Scroll extends (0, $45gdf.ScrollBlot) {
    static blotName = 'scroll';
    static className = 'ql-editor';
    static tagName = 'DIV';
    static defaultChild = (0, $jUBfi.default);
    static allowedChildren = [
        (0, $jUBfi.default),
        (0, $jUBfi.BlockEmbed),
        (0, $BNn3z.default)
    ];
    constructor(registry, domNode, _ref){
        let { emitter: emitter } = _ref;
        super(registry, domNode);
        this.emitter = emitter;
        this.batch = false;
        this.optimize();
        this.enable();
        this.domNode.addEventListener('dragstart', (e)=>this.handleDragStart(e));
    }
    batchStart() {
        if (!Array.isArray(this.batch)) this.batch = [];
    }
    batchEnd() {
        if (!this.batch) return;
        const mutations = this.batch;
        this.batch = false;
        this.update(mutations);
    }
    emitMount(blot) {
        this.emitter.emit((0, $hJr1g.default).events.SCROLL_BLOT_MOUNT, blot);
    }
    emitUnmount(blot) {
        this.emitter.emit((0, $hJr1g.default).events.SCROLL_BLOT_UNMOUNT, blot);
    }
    emitEmbedUpdate(blot, change) {
        this.emitter.emit((0, $hJr1g.default).events.SCROLL_EMBED_UPDATE, blot, change);
    }
    deleteAt(index, length) {
        const [first, offset] = this.line(index);
        const [last] = this.line(index + length);
        super.deleteAt(index, length);
        if (last != null && first !== last && offset > 0) {
            if (first instanceof (0, $jUBfi.BlockEmbed) || last instanceof (0, $jUBfi.BlockEmbed)) {
                this.optimize();
                return;
            }
            const ref = last.children.head instanceof (0, $gkqQr.default) ? null : last.children.head;
            // @ts-expect-error
            first.moveChildren(last, ref);
            // @ts-expect-error
            first.remove();
        }
        this.optimize();
    }
    enable() {
        let enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.domNode.setAttribute('contenteditable', enabled ? 'true' : 'false');
    }
    formatAt(index, length, format, value) {
        super.formatAt(index, length, format, value);
        this.optimize();
    }
    insertAt(index, value, def) {
        if (index >= this.length()) {
            if (def == null || this.scroll.query(value, (0, $45gdf.Scope).BLOCK) == null) {
                const blot = this.scroll.create(this.statics.defaultChild.blotName);
                this.appendChild(blot);
                if (def == null && value.endsWith('\n')) blot.insertAt(0, value.slice(0, -1), def);
                else blot.insertAt(0, value, def);
            } else {
                const embed = this.scroll.create(value, def);
                this.appendChild(embed);
            }
        } else super.insertAt(index, value, def);
        this.optimize();
    }
    insertBefore(blot, ref) {
        if (blot.statics.scope === (0, $45gdf.Scope).INLINE_BLOT) {
            const wrapper = this.scroll.create(this.statics.defaultChild.blotName);
            wrapper.appendChild(blot);
            super.insertBefore(wrapper, ref);
        } else super.insertBefore(blot, ref);
    }
    insertContents(index, delta) {
        const renderBlocks = this.deltaToRenderBlocks(delta.concat(new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().insert('\n')));
        const last = renderBlocks.pop();
        if (last == null) return;
        this.batchStart();
        const first = renderBlocks.shift();
        if (first) {
            const shouldInsertNewlineChar = first.type === 'block' && (first.delta.length() === 0 || !this.descendant((0, $jUBfi.BlockEmbed), index)[0] && index < this.length());
            const delta = first.type === 'block' ? first.delta : new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().insert({
                [first.key]: first.value
            });
            $35a10876ab1dd85b$var$insertInlineContents(this, index, delta);
            const newlineCharLength = first.type === 'block' ? 1 : 0;
            const lineEndIndex = index + delta.length() + newlineCharLength;
            if (shouldInsertNewlineChar) this.insertAt(lineEndIndex - 1, '\n');
            const formats = (0, $jUBfi.bubbleFormats)(this.line(index)[0]);
            const attributes = (0, $ehD63.AttributeMap).diff(formats, first.attributes) || {};
            Object.keys(attributes).forEach((name)=>{
                this.formatAt(lineEndIndex - 1, 1, name, attributes[name]);
            });
            index = lineEndIndex;
        }
        let [refBlot, refBlotOffset] = this.children.find(index);
        if (renderBlocks.length) {
            if (refBlot) {
                refBlot = refBlot.split(refBlotOffset);
                refBlotOffset = 0;
            }
            renderBlocks.forEach((renderBlock)=>{
                if (renderBlock.type === 'block') {
                    const block = this.createBlock(renderBlock.attributes, refBlot || undefined);
                    $35a10876ab1dd85b$var$insertInlineContents(block, 0, renderBlock.delta);
                } else {
                    const blockEmbed = this.create(renderBlock.key, renderBlock.value);
                    this.insertBefore(blockEmbed, refBlot || undefined);
                    Object.keys(renderBlock.attributes).forEach((name)=>{
                        blockEmbed.format(name, renderBlock.attributes[name]);
                    });
                }
            });
        }
        if (last.type === 'block' && last.delta.length()) {
            const offset = refBlot ? refBlot.offset(refBlot.scroll) + refBlotOffset : this.length();
            $35a10876ab1dd85b$var$insertInlineContents(this, offset, last.delta);
        }
        this.batchEnd();
        this.optimize();
    }
    isEnabled() {
        return this.domNode.getAttribute('contenteditable') === 'true';
    }
    leaf(index) {
        const last = this.path(index).pop();
        if (!last) return [
            null,
            -1
        ];
        const [blot, offset] = last;
        return blot instanceof (0, $45gdf.LeafBlot) ? [
            blot,
            offset
        ] : [
            null,
            -1
        ];
    }
    line(index) {
        if (index === this.length()) return this.line(index - 1);
        // @ts-expect-error TODO: make descendant() generic
        return this.descendant($35a10876ab1dd85b$var$isLine, index);
    }
    lines() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
        const getLines = (blot, blotIndex, blotLength)=>{
            let lines = [];
            let lengthLeft = blotLength;
            blot.children.forEachAt(blotIndex, blotLength, (child, childIndex, childLength)=>{
                if ($35a10876ab1dd85b$var$isLine(child)) lines.push(child);
                else if (child instanceof (0, $45gdf.ContainerBlot)) lines = lines.concat(getLines(child, childIndex, lengthLeft));
                lengthLeft -= childLength;
            });
            return lines;
        };
        return getLines(this, index, length);
    }
    optimize() {
        let mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.batch) return;
        super.optimize(mutations, context);
        if (mutations.length > 0) this.emitter.emit((0, $hJr1g.default).events.SCROLL_OPTIMIZE, mutations, context);
    }
    path(index) {
        return super.path(index).slice(1); // Exclude self
    }
    remove() {
    // Never remove self
    }
    update(mutations) {
        if (this.batch) {
            if (Array.isArray(mutations)) this.batch = this.batch.concat(mutations);
            return;
        }
        let source = (0, $hJr1g.default).sources.USER;
        if (typeof mutations === 'string') source = mutations;
        if (!Array.isArray(mutations)) mutations = this.observer.takeRecords();
        mutations = mutations.filter((_ref2)=>{
            let { target: target } = _ref2;
            const blot = this.find(target, true);
            return blot && !$35a10876ab1dd85b$var$isUpdatable(blot);
        });
        if (mutations.length > 0) this.emitter.emit((0, $hJr1g.default).events.SCROLL_BEFORE_UPDATE, source, mutations);
        super.update(mutations.concat([])); // pass copy
        if (mutations.length > 0) this.emitter.emit((0, $hJr1g.default).events.SCROLL_UPDATE, source, mutations);
    }
    updateEmbedAt(index, key, change) {
        // Currently it only supports top-level embeds (BlockEmbed).
        // We can update `ParentBlot` in parchment to support inline embeds.
        const [blot] = this.descendant((b)=>b instanceof (0, $jUBfi.BlockEmbed), index);
        if (blot && blot.statics.blotName === key && $35a10876ab1dd85b$var$isUpdatable(blot)) blot.updateContent(change);
    }
    handleDragStart(event) {
        event.preventDefault();
    }
    deltaToRenderBlocks(delta) {
        const renderBlocks = [];
        let currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))();
        delta.forEach((op)=>{
            const insert = op?.insert;
            if (!insert) return;
            if (typeof insert === 'string') {
                const splitted = insert.split('\n');
                splitted.slice(0, -1).forEach((text)=>{
                    currentBlockDelta.insert(text, op.attributes);
                    renderBlocks.push({
                        type: 'block',
                        delta: currentBlockDelta,
                        attributes: op.attributes ?? {}
                    });
                    currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))();
                });
                const last = splitted[splitted.length - 1];
                if (last) currentBlockDelta.insert(last, op.attributes);
            } else {
                const key = Object.keys(insert)[0];
                if (!key) return;
                if (this.query(key, (0, $45gdf.Scope).INLINE)) currentBlockDelta.push(op);
                else {
                    if (currentBlockDelta.length()) renderBlocks.push({
                        type: 'block',
                        delta: currentBlockDelta,
                        attributes: {}
                    });
                    currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))();
                    renderBlocks.push({
                        type: 'blockEmbed',
                        key: key,
                        value: insert[key],
                        attributes: op.attributes ?? {}
                    });
                }
            }
        });
        if (currentBlockDelta.length()) renderBlocks.push({
            type: 'block',
            delta: currentBlockDelta,
            attributes: {}
        });
        return renderBlocks;
    }
    createBlock(attributes, refBlot) {
        let blotName;
        const formats = {};
        Object.entries(attributes).forEach((_ref3)=>{
            let [key, value] = _ref3;
            const isBlockBlot = this.query(key, (0, $45gdf.Scope).BLOCK & (0, $45gdf.Scope).BLOT) != null;
            if (isBlockBlot) blotName = key;
            else formats[key] = value;
        });
        const block = this.create(blotName || this.statics.defaultChild.blotName, blotName ? attributes[blotName] : undefined);
        this.insertBefore(block, refBlot || undefined);
        const length = block.length();
        Object.entries(formats).forEach((_ref4)=>{
            let [key, value] = _ref4;
            block.formatAt(0, length, key, value);
        });
        return block;
    }
}
function $35a10876ab1dd85b$var$insertInlineContents(parent, index, inlineContents) {
    inlineContents.reduce((index, op)=>{
        const length = (0, $ehD63.Op).length(op);
        let attributes = op.attributes || {};
        if (op.insert != null) {
            if (typeof op.insert === 'string') {
                const text = op.insert;
                parent.insertAt(index, text);
                const [leaf] = parent.descendant((0, $45gdf.LeafBlot), index);
                const formats = (0, $jUBfi.bubbleFormats)(leaf);
                attributes = (0, $ehD63.AttributeMap).diff(formats, attributes) || {};
            } else if (typeof op.insert === 'object') {
                const key = Object.keys(op.insert)[0]; // There should only be one key
                if (key == null) return index;
                parent.insertAt(index, key, op.insert[key]);
                const isInlineEmbed = parent.scroll.query(key, (0, $45gdf.Scope).INLINE) != null;
                if (isInlineEmbed) {
                    const [leaf] = parent.descendant((0, $45gdf.LeafBlot), index);
                    const formats = (0, $jUBfi.bubbleFormats)(leaf);
                    attributes = (0, $ehD63.AttributeMap).diff(formats, attributes) || {};
                }
            }
        }
        Object.keys(attributes).forEach((key)=>{
            parent.formatAt(index, length, key, attributes[key]);
        });
        return index + length;
    }, index);
}
var $35a10876ab1dd85b$export$2e2bcd8739ae039 = $35a10876ab1dd85b$var$Scroll;

});

parcelRegister("jQ3Vn", function(module, exports) {

$parcel$export(module.exports, "default", () => $e715eaf5a8c4789c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "traverse", () => $e715eaf5a8c4789c$export$df3f009e3d155b20);

var $45gdf = parcelRequire("45gdf");

var $ehD63 = parcelRequire("ehD63");

var $jUBfi = parcelRequire("jUBfi");

var $dwJXH = parcelRequire("dwJXH");

var $43smM = parcelRequire("43smM");

var $ePuKS = parcelRequire("ePuKS");

var $lj0Uy = parcelRequire("lj0Uy");

var $hS85A = parcelRequire("hS85A");

var $W91pZ = parcelRequire("W91pZ");

var $dopqb = parcelRequire("dopqb");

var $k0HGJ = parcelRequire("k0HGJ");

var $i3udl = parcelRequire("i3udl");

var $1WwLQ = parcelRequire("1WwLQ");

var $c7x7B = parcelRequire("c7x7B");

var $cagvo = parcelRequire("cagvo");
const $e715eaf5a8c4789c$var$debug = (0, $dwJXH.default)('quill:clipboard');
const $e715eaf5a8c4789c$var$CLIPBOARD_CONFIG = [
    [
        Node.TEXT_NODE,
        $e715eaf5a8c4789c$export$9b884371b5570711
    ],
    [
        Node.TEXT_NODE,
        $e715eaf5a8c4789c$export$c695b9637111f586
    ],
    [
        'br',
        $e715eaf5a8c4789c$var$matchBreak
    ],
    [
        Node.ELEMENT_NODE,
        $e715eaf5a8c4789c$export$c695b9637111f586
    ],
    [
        Node.ELEMENT_NODE,
        $e715eaf5a8c4789c$export$e9719de873a22c03
    ],
    [
        Node.ELEMENT_NODE,
        $e715eaf5a8c4789c$export$7da59a717dc94488
    ],
    [
        Node.ELEMENT_NODE,
        $e715eaf5a8c4789c$var$matchStyles
    ],
    [
        'li',
        $e715eaf5a8c4789c$var$matchIndent
    ],
    [
        'ol, ul',
        $e715eaf5a8c4789c$var$matchList
    ],
    [
        'pre',
        $e715eaf5a8c4789c$var$matchCodeBlock
    ],
    [
        'tr',
        $e715eaf5a8c4789c$var$matchTable
    ],
    [
        'b',
        $e715eaf5a8c4789c$var$createMatchAlias('bold')
    ],
    [
        'i',
        $e715eaf5a8c4789c$var$createMatchAlias('italic')
    ],
    [
        'strike',
        $e715eaf5a8c4789c$var$createMatchAlias('strike')
    ],
    [
        'style',
        $e715eaf5a8c4789c$var$matchIgnore
    ]
];
const $e715eaf5a8c4789c$var$ATTRIBUTE_ATTRIBUTORS = [
    (0, $lj0Uy.AlignAttribute),
    (0, $k0HGJ.DirectionAttribute)
].reduce((memo, attr)=>{
    memo[attr.keyName] = attr;
    return memo;
}, {});
const $e715eaf5a8c4789c$var$STYLE_ATTRIBUTORS = [
    (0, $lj0Uy.AlignStyle),
    (0, $hS85A.BackgroundStyle),
    (0, $dopqb.ColorStyle),
    (0, $k0HGJ.DirectionStyle),
    (0, $i3udl.FontStyle),
    (0, $1WwLQ.SizeStyle)
].reduce((memo, attr)=>{
    memo[attr.keyName] = attr;
    return memo;
}, {});
class $e715eaf5a8c4789c$export$2e2bcd8739ae039 extends (0, $43smM.default) {
    static DEFAULTS = {
        matchers: []
    };
    constructor(quill, options){
        super(quill, options);
        this.quill.root.addEventListener('copy', (e)=>this.onCaptureCopy(e, false));
        this.quill.root.addEventListener('cut', (e)=>this.onCaptureCopy(e, true));
        this.quill.root.addEventListener('paste', this.onCapturePaste.bind(this));
        this.matchers = [];
        $e715eaf5a8c4789c$var$CLIPBOARD_CONFIG.concat(this.options.matchers ?? []).forEach((_ref)=>{
            let [selector, matcher] = _ref;
            this.addMatcher(selector, matcher);
        });
    }
    addMatcher(selector, matcher) {
        this.matchers.push([
            selector,
            matcher
        ]);
    }
    convert(_ref2) {
        let { html: html, text: text } = _ref2;
        let formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (formats[(0, $W91pZ.default).blotName]) return new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().insert(text || '', {
            [(0, $W91pZ.default).blotName]: formats[(0, $W91pZ.default).blotName]
        });
        if (!html) return new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().insert(text || '', formats);
        const delta = this.convertHTML(html);
        // Remove trailing newline
        if ($e715eaf5a8c4789c$var$deltaEndsWith(delta, '\n') && (delta.ops[delta.ops.length - 1].attributes == null || formats.table)) return delta.compose(new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().retain(delta.length() - 1).delete(1));
        return delta;
    }
    normalizeHTML(doc) {
        (0, $cagvo.default)(doc);
    }
    convertHTML(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        this.normalizeHTML(doc);
        const container = doc.body;
        const nodeMatches = new WeakMap();
        const [elementMatchers, textMatchers] = this.prepareMatching(container, nodeMatches);
        return $e715eaf5a8c4789c$export$df3f009e3d155b20(this.quill.scroll, container, elementMatchers, textMatchers, nodeMatches);
    }
    dangerouslyPasteHTML(index, html) {
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $ePuKS.default).sources.API;
        if (typeof index === 'string') {
            const delta = this.convert({
                html: index,
                text: ''
            });
            // @ts-expect-error
            this.quill.setContents(delta, html);
            this.quill.setSelection(0, (0, $ePuKS.default).sources.SILENT);
        } else {
            const paste = this.convert({
                html: html,
                text: ''
            });
            this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().retain(index).concat(paste), source);
            this.quill.setSelection(index + paste.length(), (0, $ePuKS.default).sources.SILENT);
        }
    }
    onCaptureCopy(e) {
        let isCut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (e.defaultPrevented) return;
        e.preventDefault();
        const [range] = this.quill.selection.getRange();
        if (range == null) return;
        const { html: html, text: text } = this.onCopy(range, isCut);
        e.clipboardData?.setData('text/plain', text);
        e.clipboardData?.setData('text/html', html);
        if (isCut) (0, $c7x7B.deleteRange)({
            range: range,
            quill: this.quill
        });
    }
    /*
   * https://www.iana.org/assignments/media-types/text/uri-list
   */ normalizeURIList(urlList) {
        return urlList.split(/\r?\n/)// Ignore all comments
        .filter((url)=>url[0] !== '#').join('\n');
    }
    onCapturePaste(e) {
        if (e.defaultPrevented || !this.quill.isEnabled()) return;
        e.preventDefault();
        const range = this.quill.getSelection(true);
        if (range == null) return;
        const html = e.clipboardData?.getData('text/html');
        let text = e.clipboardData?.getData('text/plain');
        if (!html && !text) {
            const urlList = e.clipboardData?.getData('text/uri-list');
            if (urlList) text = this.normalizeURIList(urlList);
        }
        const files = Array.from(e.clipboardData?.files || []);
        if (!html && files.length > 0) {
            this.quill.uploader.upload(range, files);
            return;
        }
        if (html && files.length > 0) {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            if (doc.body.childElementCount === 1 && doc.body.firstElementChild?.tagName === 'IMG') {
                this.quill.uploader.upload(range, files);
                return;
            }
        }
        this.onPaste(range, {
            html: html,
            text: text
        });
    }
    onCopy(range) {
        const text = this.quill.getText(range);
        const html = this.quill.getSemanticHTML(range);
        return {
            html: html,
            text: text
        };
    }
    onPaste(range, _ref3) {
        let { text: text, html: html } = _ref3;
        const formats = this.quill.getFormat(range.index);
        const pastedDelta = this.convert({
            text: text,
            html: html
        }, formats);
        $e715eaf5a8c4789c$var$debug.log('onPaste', pastedDelta, {
            text: text,
            html: html
        });
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().retain(range.index).delete(range.length).concat(pastedDelta);
        this.quill.updateContents(delta, (0, $ePuKS.default).sources.USER);
        // range.length contributes to delta.length()
        this.quill.setSelection(delta.length() - range.length, (0, $ePuKS.default).sources.SILENT);
        this.quill.scrollSelectionIntoView();
    }
    prepareMatching(container, nodeMatches) {
        const elementMatchers = [];
        const textMatchers = [];
        this.matchers.forEach((pair)=>{
            const [selector, matcher] = pair;
            switch(selector){
                case Node.TEXT_NODE:
                    textMatchers.push(matcher);
                    break;
                case Node.ELEMENT_NODE:
                    elementMatchers.push(matcher);
                    break;
                default:
                    Array.from(container.querySelectorAll(selector)).forEach((node)=>{
                        if (nodeMatches.has(node)) {
                            const matches = nodeMatches.get(node);
                            matches?.push(matcher);
                        } else nodeMatches.set(node, [
                            matcher
                        ]);
                    });
                    break;
            }
        });
        return [
            elementMatchers,
            textMatchers
        ];
    }
}
function $e715eaf5a8c4789c$var$applyFormat(delta, format, value, scroll) {
    if (!scroll.query(format)) return delta;
    return delta.reduce((newDelta, op)=>{
        if (!op.insert) return newDelta;
        if (op.attributes && op.attributes[format]) return newDelta.push(op);
        const formats = value ? {
            [format]: value
        } : {};
        return newDelta.insert(op.insert, {
            ...formats,
            ...op.attributes
        });
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))());
}
function $e715eaf5a8c4789c$var$deltaEndsWith(delta, text) {
    let endText = '';
    for(let i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i // eslint-disable-line no-plusplus
    ){
        const op = delta.ops[i];
        if (typeof op.insert !== 'string') break;
        endText = op.insert + endText;
    }
    return endText.slice(-1 * text.length) === text;
}
function $e715eaf5a8c4789c$var$isLine(node, scroll) {
    if (!(node instanceof Element)) return false;
    const match = scroll.query(node);
    // @ts-expect-error
    if (match && match.prototype instanceof (0, $45gdf.EmbedBlot)) return false;
    return [
        'address',
        'article',
        'blockquote',
        'canvas',
        'dd',
        'div',
        'dl',
        'dt',
        'fieldset',
        'figcaption',
        'figure',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'header',
        'iframe',
        'li',
        'main',
        'nav',
        'ol',
        'output',
        'p',
        'pre',
        'section',
        'table',
        'td',
        'tr',
        'ul',
        'video'
    ].includes(node.tagName.toLowerCase());
}
function $e715eaf5a8c4789c$var$isBetweenInlineElements(node, scroll) {
    return node.previousElementSibling && node.nextElementSibling && !$e715eaf5a8c4789c$var$isLine(node.previousElementSibling, scroll) && !$e715eaf5a8c4789c$var$isLine(node.nextElementSibling, scroll);
}
const $e715eaf5a8c4789c$var$preNodes = new WeakMap();
function $e715eaf5a8c4789c$var$isPre(node) {
    if (node == null) return false;
    if (!$e715eaf5a8c4789c$var$preNodes.has(node)) {
        // @ts-expect-error
        if (node.tagName === 'PRE') $e715eaf5a8c4789c$var$preNodes.set(node, true);
        else $e715eaf5a8c4789c$var$preNodes.set(node, $e715eaf5a8c4789c$var$isPre(node.parentNode));
    }
    return $e715eaf5a8c4789c$var$preNodes.get(node);
}
function $e715eaf5a8c4789c$export$df3f009e3d155b20(scroll, node, elementMatchers, textMatchers, nodeMatches) {
    // Post-order
    if (node.nodeType === node.TEXT_NODE) return textMatchers.reduce((delta, matcher)=>{
        return matcher(node, delta, scroll);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))());
    if (node.nodeType === node.ELEMENT_NODE) return Array.from(node.childNodes || []).reduce((delta, childNode)=>{
        let childrenDelta = $e715eaf5a8c4789c$export$df3f009e3d155b20(scroll, childNode, elementMatchers, textMatchers, nodeMatches);
        if (childNode.nodeType === node.ELEMENT_NODE) {
            childrenDelta = elementMatchers.reduce((reducedDelta, matcher)=>{
                return matcher(childNode, reducedDelta, scroll);
            }, childrenDelta);
            childrenDelta = (nodeMatches.get(childNode) || []).reduce((reducedDelta, matcher)=>{
                return matcher(childNode, reducedDelta, scroll);
            }, childrenDelta);
        }
        return delta.concat(childrenDelta);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))());
    return new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))();
}
function $e715eaf5a8c4789c$var$createMatchAlias(format) {
    return (_node, delta, scroll)=>{
        return $e715eaf5a8c4789c$var$applyFormat(delta, format, true, scroll);
    };
}
function $e715eaf5a8c4789c$export$7da59a717dc94488(node, delta, scroll) {
    const attributes = (0, $45gdf.Attributor).keys(node);
    const classes = (0, $45gdf.ClassAttributor).keys(node);
    const styles = (0, $45gdf.StyleAttributor).keys(node);
    const formats = {};
    attributes.concat(classes).concat(styles).forEach((name)=>{
        let attr = scroll.query(name, (0, $45gdf.Scope).ATTRIBUTE);
        if (attr != null) {
            formats[attr.attrName] = attr.value(node);
            if (formats[attr.attrName]) return;
        }
        attr = $e715eaf5a8c4789c$var$ATTRIBUTE_ATTRIBUTORS[name];
        if (attr != null && (attr.attrName === name || attr.keyName === name)) formats[attr.attrName] = attr.value(node) || undefined;
        attr = $e715eaf5a8c4789c$var$STYLE_ATTRIBUTORS[name];
        if (attr != null && (attr.attrName === name || attr.keyName === name)) {
            attr = $e715eaf5a8c4789c$var$STYLE_ATTRIBUTORS[name];
            formats[attr.attrName] = attr.value(node) || undefined;
        }
    });
    return Object.entries(formats).reduce((newDelta, _ref4)=>{
        let [name, value] = _ref4;
        return $e715eaf5a8c4789c$var$applyFormat(newDelta, name, value, scroll);
    }, delta);
}
function $e715eaf5a8c4789c$export$e9719de873a22c03(node, delta, scroll) {
    const match = scroll.query(node);
    if (match == null) return delta;
    // @ts-expect-error
    if (match.prototype instanceof (0, $45gdf.EmbedBlot)) {
        const embed = {};
        // @ts-expect-error
        const value = match.value(node);
        if (value != null) {
            // @ts-expect-error
            embed[match.blotName] = value;
            // @ts-expect-error
            return new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().insert(embed, match.formats(node, scroll));
        }
    } else {
        // @ts-expect-error
        if (match.prototype instanceof (0, $45gdf.BlockBlot) && !$e715eaf5a8c4789c$var$deltaEndsWith(delta, '\n')) delta.insert('\n');
        if ('blotName' in match && 'formats' in match && typeof match.formats === 'function') return $e715eaf5a8c4789c$var$applyFormat(delta, match.blotName, match.formats(node, scroll), scroll);
    }
    return delta;
}
function $e715eaf5a8c4789c$var$matchBreak(node, delta) {
    if (!$e715eaf5a8c4789c$var$deltaEndsWith(delta, '\n')) delta.insert('\n');
    return delta;
}
function $e715eaf5a8c4789c$var$matchCodeBlock(node, delta, scroll) {
    const match = scroll.query('code-block');
    const language = match && 'formats' in match && typeof match.formats === 'function' ? match.formats(node, scroll) : true;
    return $e715eaf5a8c4789c$var$applyFormat(delta, 'code-block', language, scroll);
}
function $e715eaf5a8c4789c$var$matchIgnore() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))();
}
function $e715eaf5a8c4789c$var$matchIndent(node, delta, scroll) {
    const match = scroll.query(node);
    if (match == null || // @ts-expect-error
    match.blotName !== 'list' || !$e715eaf5a8c4789c$var$deltaEndsWith(delta, '\n')) return delta;
    let indent = -1;
    let parent = node.parentNode;
    while(parent != null){
        // @ts-expect-error
        if ([
            'OL',
            'UL'
        ].includes(parent.tagName)) indent += 1;
        parent = parent.parentNode;
    }
    if (indent <= 0) return delta;
    return delta.reduce((composed, op)=>{
        if (!op.insert) return composed;
        if (op.attributes && typeof op.attributes.indent === 'number') return composed.push(op);
        return composed.insert(op.insert, {
            indent: indent,
            ...op.attributes || {}
        });
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))());
}
function $e715eaf5a8c4789c$var$matchList(node, delta, scroll) {
    const element = node;
    let list = element.tagName === 'OL' ? 'ordered' : 'bullet';
    const checkedAttr = element.getAttribute('data-checked');
    if (checkedAttr) list = checkedAttr === 'true' ? 'checked' : 'unchecked';
    return $e715eaf5a8c4789c$var$applyFormat(delta, 'list', list, scroll);
}
function $e715eaf5a8c4789c$export$c695b9637111f586(node, delta, scroll) {
    if (!$e715eaf5a8c4789c$var$deltaEndsWith(delta, '\n')) {
        if ($e715eaf5a8c4789c$var$isLine(node, scroll) && (node.childNodes.length > 0 || node instanceof HTMLParagraphElement)) return delta.insert('\n');
        if (delta.length() > 0 && node.nextSibling) {
            let nextSibling = node.nextSibling;
            while(nextSibling != null){
                if ($e715eaf5a8c4789c$var$isLine(nextSibling, scroll)) return delta.insert('\n');
                const match = scroll.query(nextSibling);
                // @ts-expect-error
                if (match && match.prototype instanceof (0, $jUBfi.BlockEmbed)) return delta.insert('\n');
                nextSibling = nextSibling.firstChild;
            }
        }
    }
    return delta;
}
function $e715eaf5a8c4789c$var$matchStyles(node, delta, scroll) {
    const formats = {};
    const style = node.style || {};
    if (style.fontStyle === 'italic') formats.italic = true;
    if (style.textDecoration === 'underline') formats.underline = true;
    if (style.textDecoration === 'line-through') formats.strike = true;
    if (style.fontWeight?.startsWith('bold') || // @ts-expect-error Fix me later
    parseInt(style.fontWeight, 10) >= 700) formats.bold = true;
    delta = Object.entries(formats).reduce((newDelta, _ref5)=>{
        let [name, value] = _ref5;
        return $e715eaf5a8c4789c$var$applyFormat(newDelta, name, value, scroll);
    }, delta);
    // @ts-expect-error
    if (parseFloat(style.textIndent || 0) > 0) // Could be 0.5in
    return new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().insert('\t').concat(delta);
    return delta;
}
function $e715eaf5a8c4789c$var$matchTable(node, delta, scroll) {
    const table = node.parentElement?.tagName === 'TABLE' ? node.parentElement : node.parentElement?.parentElement;
    if (table != null) {
        const rows = Array.from(table.querySelectorAll('tr'));
        const row = rows.indexOf(node) + 1;
        return $e715eaf5a8c4789c$var$applyFormat(delta, 'table', row, scroll);
    }
    return delta;
}
function $e715eaf5a8c4789c$export$9b884371b5570711(node, delta, scroll) {
    // @ts-expect-error
    let text = node.data;
    // Word represents empty line with <o:p>&nbsp;</o:p>
    if (node.parentElement?.tagName === 'O:P') return delta.insert(text.trim());
    if (!$e715eaf5a8c4789c$var$isPre(node)) {
        if (text.trim().length === 0 && text.includes('\n') && !$e715eaf5a8c4789c$var$isBetweenInlineElements(node, scroll)) return delta;
        // convert all non-nbsp whitespace into regular space
        text = text.replace(/[^\S\u00a0]/g, ' ');
        // collapse consecutive spaces into one
        text = text.replace(/ {2,}/g, ' ');
        if (node.previousSibling == null && node.parentElement != null && $e715eaf5a8c4789c$var$isLine(node.parentElement, scroll) || node.previousSibling instanceof Element && $e715eaf5a8c4789c$var$isLine(node.previousSibling, scroll)) // block structure means we don't need leading space
        text = text.replace(/^ /, '');
        if (node.nextSibling == null && node.parentElement != null && $e715eaf5a8c4789c$var$isLine(node.parentElement, scroll) || node.nextSibling instanceof Element && $e715eaf5a8c4789c$var$isLine(node.nextSibling, scroll)) // block structure means we don't need trailing space
        text = text.replace(/ $/, '');
        // done removing whitespace and can normalize all to regular space
        text = text.replaceAll('\u00a0', ' ');
    }
    return delta.insert(text);
}

});
parcelRegister("lj0Uy", function(module, exports) {

$parcel$export(module.exports, "AlignAttribute", () => $f82c143f66594a73$export$2ef0f9fb04a51388);
$parcel$export(module.exports, "AlignClass", () => $f82c143f66594a73$export$7f3685f5846c07da);
$parcel$export(module.exports, "AlignStyle", () => $f82c143f66594a73$export$d2060f5d114c9fe8);

var $45gdf = parcelRequire("45gdf");
const $f82c143f66594a73$var$config = {
    scope: (0, $45gdf.Scope).BLOCK,
    whitelist: [
        'right',
        'center',
        'justify'
    ]
};
const $f82c143f66594a73$export$2ef0f9fb04a51388 = new (0, $45gdf.Attributor)('align', 'align', $f82c143f66594a73$var$config);
const $f82c143f66594a73$export$7f3685f5846c07da = new (0, $45gdf.ClassAttributor)('align', 'ql-align', $f82c143f66594a73$var$config);
const $f82c143f66594a73$export$d2060f5d114c9fe8 = new (0, $45gdf.StyleAttributor)('align', 'text-align', $f82c143f66594a73$var$config);

});

parcelRegister("hS85A", function(module, exports) {

$parcel$export(module.exports, "BackgroundClass", () => $d02dc11e36bf2bff$export$8aa96c8963152b12);
$parcel$export(module.exports, "BackgroundStyle", () => $d02dc11e36bf2bff$export$dc1cbcab4c682ef);

var $45gdf = parcelRequire("45gdf");

var $dopqb = parcelRequire("dopqb");
const $d02dc11e36bf2bff$export$8aa96c8963152b12 = new (0, $45gdf.ClassAttributor)('background', 'ql-bg', {
    scope: (0, $45gdf.Scope).INLINE
});
const $d02dc11e36bf2bff$export$dc1cbcab4c682ef = new (0, $dopqb.ColorAttributor)('background', 'background-color', {
    scope: (0, $45gdf.Scope).INLINE
});

});
parcelRegister("dopqb", function(module, exports) {

$parcel$export(module.exports, "ColorAttributor", () => $9c013c69d71592cf$export$c992e3369f248f6e);
$parcel$export(module.exports, "ColorClass", () => $9c013c69d71592cf$export$42795dcf0ec6f3c8);
$parcel$export(module.exports, "ColorStyle", () => $9c013c69d71592cf$export$1415f56796d9a5a9);

var $45gdf = parcelRequire("45gdf");
class $9c013c69d71592cf$export$c992e3369f248f6e extends (0, $45gdf.StyleAttributor) {
    value(domNode) {
        let value = super.value(domNode);
        if (!value.startsWith('rgb(')) return value;
        value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
        const hex = value.split(',').map((component)=>`00${parseInt(component, 10).toString(16)}`.slice(-2)).join('');
        return `#${hex}`;
    }
}
const $9c013c69d71592cf$export$42795dcf0ec6f3c8 = new (0, $45gdf.ClassAttributor)('color', 'ql-color', {
    scope: (0, $45gdf.Scope).INLINE
});
const $9c013c69d71592cf$export$1415f56796d9a5a9 = new $9c013c69d71592cf$export$c992e3369f248f6e('color', 'color', {
    scope: (0, $45gdf.Scope).INLINE
});

});


parcelRegister("W91pZ", function(module, exports) {

$parcel$export(module.exports, "CodeBlockContainer", () => $0aec6a737725d873$export$3b131632d3d15165);
$parcel$export(module.exports, "default", () => $0aec6a737725d873$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Code", () => $0aec6a737725d873$export$52f0f02147b12c03);

var $jUBfi = parcelRequire("jUBfi");

var $gkqQr = parcelRequire("gkqQr");

var $9VFAE = parcelRequire("9VFAE");

var $95m1U = parcelRequire("95m1U");

var $l6ueR = parcelRequire("l6ueR");

var $BNn3z = parcelRequire("BNn3z");

var $ePuKS = parcelRequire("ePuKS");
class $0aec6a737725d873$export$3b131632d3d15165 extends (0, $BNn3z.default) {
    static create(value) {
        const domNode = super.create(value);
        domNode.setAttribute('spellcheck', 'false');
        return domNode;
    }
    code(index, length) {
        return this.children// @ts-expect-error
        .map((child)=>child.length() <= 1 ? '' : child.domNode.innerText).join('\n').slice(index, index + length);
    }
    html(index, length) {
        // `\n`s are needed in order to support empty lines at the beginning and the end.
        // https://html.spec.whatwg.org/multipage/syntax.html#element-restrictions
        return `<pre>\n${(0, $l6ueR.escapeText)(this.code(index, length))}\n</pre>`;
    }
}
class $0aec6a737725d873$export$2e2bcd8739ae039 extends (0, $jUBfi.default) {
    static TAB = '  ';
    static register() {
        (0, $ePuKS.default).register($0aec6a737725d873$export$3b131632d3d15165);
    }
}
class $0aec6a737725d873$export$52f0f02147b12c03 extends (0, $95m1U.default) {
}
$0aec6a737725d873$export$52f0f02147b12c03.blotName = 'code';
$0aec6a737725d873$export$52f0f02147b12c03.tagName = 'CODE';
$0aec6a737725d873$export$2e2bcd8739ae039.blotName = 'code-block';
$0aec6a737725d873$export$2e2bcd8739ae039.className = 'ql-code-block';
$0aec6a737725d873$export$2e2bcd8739ae039.tagName = 'DIV';
$0aec6a737725d873$export$3b131632d3d15165.blotName = 'code-block-container';
$0aec6a737725d873$export$3b131632d3d15165.className = 'ql-code-block-container';
$0aec6a737725d873$export$3b131632d3d15165.tagName = 'DIV';
$0aec6a737725d873$export$3b131632d3d15165.allowedChildren = [
    $0aec6a737725d873$export$2e2bcd8739ae039
];
$0aec6a737725d873$export$2e2bcd8739ae039.allowedChildren = [
    (0, $l6ueR.default),
    (0, $gkqQr.default),
    (0, $9VFAE.default)
];
$0aec6a737725d873$export$2e2bcd8739ae039.requiredContainer = $0aec6a737725d873$export$3b131632d3d15165;

});

parcelRegister("k0HGJ", function(module, exports) {

$parcel$export(module.exports, "DirectionAttribute", () => $e915b24b141a419b$export$4158215dafad9efa);
$parcel$export(module.exports, "DirectionClass", () => $e915b24b141a419b$export$630028b3af294dec);
$parcel$export(module.exports, "DirectionStyle", () => $e915b24b141a419b$export$175979e518d1dfd1);

var $45gdf = parcelRequire("45gdf");
const $e915b24b141a419b$var$config = {
    scope: (0, $45gdf.Scope).BLOCK,
    whitelist: [
        'rtl'
    ]
};
const $e915b24b141a419b$export$4158215dafad9efa = new (0, $45gdf.Attributor)('direction', 'dir', $e915b24b141a419b$var$config);
const $e915b24b141a419b$export$630028b3af294dec = new (0, $45gdf.ClassAttributor)('direction', 'ql-direction', $e915b24b141a419b$var$config);
const $e915b24b141a419b$export$175979e518d1dfd1 = new (0, $45gdf.StyleAttributor)('direction', 'direction', $e915b24b141a419b$var$config);

});

parcelRegister("i3udl", function(module, exports) {

$parcel$export(module.exports, "FontClass", () => $d24ff1bcb2f832e7$export$78a99ee601572ab);
$parcel$export(module.exports, "FontStyle", () => $d24ff1bcb2f832e7$export$23b468d4ca3f8c96);

var $45gdf = parcelRequire("45gdf");
const $d24ff1bcb2f832e7$var$config = {
    scope: (0, $45gdf.Scope).INLINE,
    whitelist: [
        'serif',
        'monospace'
    ]
};
const $d24ff1bcb2f832e7$export$78a99ee601572ab = new (0, $45gdf.ClassAttributor)('font', 'ql-font', $d24ff1bcb2f832e7$var$config);
class $d24ff1bcb2f832e7$var$FontStyleAttributor extends (0, $45gdf.StyleAttributor) {
    value(node) {
        return super.value(node).replace(/["']/g, '');
    }
}
const $d24ff1bcb2f832e7$export$23b468d4ca3f8c96 = new $d24ff1bcb2f832e7$var$FontStyleAttributor('font', 'font-family', $d24ff1bcb2f832e7$var$config);

});

parcelRegister("1WwLQ", function(module, exports) {

$parcel$export(module.exports, "SizeClass", () => $16a4a0c745016b58$export$c84684d52bca9684);
$parcel$export(module.exports, "SizeStyle", () => $16a4a0c745016b58$export$5443b95a30e89ac5);

var $45gdf = parcelRequire("45gdf");
const $16a4a0c745016b58$export$c84684d52bca9684 = new (0, $45gdf.ClassAttributor)('size', 'ql-size', {
    scope: (0, $45gdf.Scope).INLINE,
    whitelist: [
        'small',
        'large',
        'huge'
    ]
});
const $16a4a0c745016b58$export$5443b95a30e89ac5 = new (0, $45gdf.StyleAttributor)('size', 'font-size', {
    scope: (0, $45gdf.Scope).INLINE,
    whitelist: [
        '10px',
        '18px',
        '32px'
    ]
});

});

parcelRegister("c7x7B", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d2fd4c49c574ba5$export$2e2bcd8739ae039);
$parcel$export(module.exports, "deleteRange", () => $8d2fd4c49c574ba5$export$a6c813797f379898);

var $buDZz = parcelRequire("buDZz");
var $4vxV0 = parcelRequire("4vxV0");

var $ehD63 = parcelRequire("ehD63");

var $45gdf = parcelRequire("45gdf");

var $ePuKS = parcelRequire("ePuKS");

var $dwJXH = parcelRequire("dwJXH");

var $43smM = parcelRequire("43smM");
const $8d2fd4c49c574ba5$var$debug = (0, $dwJXH.default)('quill:keyboard');
const $8d2fd4c49c574ba5$export$34a157fc58f3dd07 = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';
class $8d2fd4c49c574ba5$export$2e2bcd8739ae039 extends (0, $43smM.default) {
    static match(evt, binding) {
        if ([
            'altKey',
            'ctrlKey',
            'metaKey',
            'shiftKey'
        ].some((key)=>{
            return !!binding[key] !== evt[key] && binding[key] !== null;
        })) return false;
        return binding.key === evt.key || binding.key === evt.which;
    }
    constructor(quill, options){
        super(quill, options);
        this.bindings = {};
        // @ts-expect-error Fix me later
        Object.keys(this.options.bindings).forEach((name)=>{
            // @ts-expect-error Fix me later
            if (this.options.bindings[name]) // @ts-expect-error Fix me later
            this.addBinding(this.options.bindings[name]);
        });
        this.addBinding({
            key: 'Enter',
            shiftKey: null
        }, this.handleEnter);
        this.addBinding({
            key: 'Enter',
            metaKey: null,
            ctrlKey: null,
            altKey: null
        }, ()=>{});
        if (/Firefox/i.test(navigator.userAgent)) {
            // Need to handle delete and backspace for Firefox in the general case #1171
            this.addBinding({
                key: 'Backspace'
            }, {
                collapsed: true
            }, this.handleBackspace);
            this.addBinding({
                key: 'Delete'
            }, {
                collapsed: true
            }, this.handleDelete);
        } else {
            this.addBinding({
                key: 'Backspace'
            }, {
                collapsed: true,
                prefix: /^.?$/
            }, this.handleBackspace);
            this.addBinding({
                key: 'Delete'
            }, {
                collapsed: true,
                suffix: /^.?$/
            }, this.handleDelete);
        }
        this.addBinding({
            key: 'Backspace'
        }, {
            collapsed: false
        }, this.handleDeleteRange);
        this.addBinding({
            key: 'Delete'
        }, {
            collapsed: false
        }, this.handleDeleteRange);
        this.addBinding({
            key: 'Backspace',
            altKey: null,
            ctrlKey: null,
            metaKey: null,
            shiftKey: null
        }, {
            collapsed: true,
            offset: 0
        }, this.handleBackspace);
        this.listen();
    }
    addBinding(keyBinding) {
        let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const binding = $8d2fd4c49c574ba5$export$a3295358bff77e(keyBinding);
        if (binding == null) {
            $8d2fd4c49c574ba5$var$debug.warn('Attempted to add invalid keyboard binding', binding);
            return;
        }
        if (typeof context === 'function') context = {
            handler: context
        };
        if (typeof handler === 'function') handler = {
            handler: handler
        };
        const keys = Array.isArray(binding.key) ? binding.key : [
            binding.key
        ];
        keys.forEach((key)=>{
            const singleBinding = {
                ...binding,
                key: key,
                ...context,
                ...handler
            };
            this.bindings[singleBinding.key] = this.bindings[singleBinding.key] || [];
            this.bindings[singleBinding.key].push(singleBinding);
        });
    }
    listen() {
        this.quill.root.addEventListener('keydown', (evt)=>{
            if (evt.defaultPrevented || evt.isComposing) return;
            // evt.isComposing is false when pressing Enter/Backspace when composing in Safari
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            const isComposing = evt.keyCode === 229 && (evt.key === 'Enter' || evt.key === 'Backspace');
            if (isComposing) return;
            const bindings = (this.bindings[evt.key] || []).concat(this.bindings[evt.which] || []);
            const matches = bindings.filter((binding)=>$8d2fd4c49c574ba5$export$2e2bcd8739ae039.match(evt, binding));
            if (matches.length === 0) return;
            // @ts-expect-error
            const blot = (0, $ePuKS.default).find(evt.target, true);
            if (blot && blot.scroll !== this.quill.scroll) return;
            const range = this.quill.getSelection();
            if (range == null || !this.quill.hasFocus()) return;
            const [line, offset] = this.quill.getLine(range.index);
            const [leafStart, offsetStart] = this.quill.getLeaf(range.index);
            const [leafEnd, offsetEnd] = range.length === 0 ? [
                leafStart,
                offsetStart
            ] : this.quill.getLeaf(range.index + range.length);
            const prefixText = leafStart instanceof (0, $45gdf.TextBlot) ? leafStart.value().slice(0, offsetStart) : '';
            const suffixText = leafEnd instanceof (0, $45gdf.TextBlot) ? leafEnd.value().slice(offsetEnd) : '';
            const curContext = {
                collapsed: range.length === 0,
                // @ts-expect-error Fix me later
                empty: range.length === 0 && line.length() <= 1,
                format: this.quill.getFormat(range),
                line: line,
                offset: offset,
                prefix: prefixText,
                suffix: suffixText,
                event: evt
            };
            const prevented = matches.some((binding)=>{
                if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
                if (binding.empty != null && binding.empty !== curContext.empty) return false;
                if (binding.offset != null && binding.offset !== curContext.offset) return false;
                if (Array.isArray(binding.format)) {
                    // any format is present
                    if (binding.format.every((name)=>curContext.format[name] == null)) return false;
                } else if (typeof binding.format === 'object') {
                    // all formats must match
                    if (!Object.keys(binding.format).every((name)=>{
                        // @ts-expect-error Fix me later
                        if (binding.format[name] === true) return curContext.format[name] != null;
                        // @ts-expect-error Fix me later
                        if (binding.format[name] === false) return curContext.format[name] == null;
                        // @ts-expect-error Fix me later
                        return (0, $4vxV0.default)(binding.format[name], curContext.format[name]);
                    })) return false;
                }
                if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
                if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
                // @ts-expect-error Fix me later
                return binding.handler.call(this, range, curContext, binding) !== true;
            });
            if (prevented) evt.preventDefault();
        });
    }
    handleBackspace(range, context) {
        // Check for astral symbols
        const length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
        if (range.index === 0 || this.quill.getLength() <= 1) return;
        let formats = {};
        const [line] = this.quill.getLine(range.index);
        let delta = new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().retain(range.index - length).delete(length);
        if (context.offset === 0) {
            // Always deleting newline here, length always 1
            const [prev] = this.quill.getLine(range.index - 1);
            if (prev) {
                const isPrevLineEmpty = prev.statics.blotName === 'block' && prev.length() <= 1;
                if (!isPrevLineEmpty) {
                    // @ts-expect-error Fix me later
                    const curFormats = line.formats();
                    const prevFormats = this.quill.getFormat(range.index - 1, 1);
                    formats = (0, $ehD63.AttributeMap).diff(curFormats, prevFormats) || {};
                    if (Object.keys(formats).length > 0) {
                        // line.length() - 1 targets \n in line, another -1 for newline being deleted
                        const formatDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))()// @ts-expect-error Fix me later
                        .retain(range.index + line.length() - 2).retain(1, formats);
                        delta = delta.compose(formatDelta);
                    }
                }
            }
        }
        this.quill.updateContents(delta, (0, $ePuKS.default).sources.USER);
        this.quill.focus();
    }
    handleDelete(range, context) {
        // Check for astral symbols
        const length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
        if (range.index >= this.quill.getLength() - length) return;
        let formats = {};
        const [line] = this.quill.getLine(range.index);
        let delta = new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().retain(range.index).delete(length);
        // @ts-expect-error Fix me later
        if (context.offset >= line.length() - 1) {
            const [next] = this.quill.getLine(range.index + 1);
            if (next) {
                // @ts-expect-error Fix me later
                const curFormats = line.formats();
                const nextFormats = this.quill.getFormat(range.index, 1);
                formats = (0, $ehD63.AttributeMap).diff(curFormats, nextFormats) || {};
                if (Object.keys(formats).length > 0) delta = delta.retain(next.length() - 1).retain(1, formats);
            }
        }
        this.quill.updateContents(delta, (0, $ePuKS.default).sources.USER);
        this.quill.focus();
    }
    handleDeleteRange(range) {
        $8d2fd4c49c574ba5$export$a6c813797f379898({
            range: range,
            quill: this.quill
        });
        this.quill.focus();
    }
    handleEnter(range, context) {
        const lineFormats = Object.keys(context.format).reduce((formats, format)=>{
            if (this.quill.scroll.query(format, (0, $45gdf.Scope).BLOCK) && !Array.isArray(context.format[format])) formats[format] = context.format[format];
            return formats;
        }, {});
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().retain(range.index).delete(range.length).insert('\n', lineFormats);
        this.quill.updateContents(delta, (0, $ePuKS.default).sources.USER);
        this.quill.setSelection(range.index + 1, (0, $ePuKS.default).sources.SILENT);
        this.quill.focus();
    }
}
const $8d2fd4c49c574ba5$var$defaultOptions = {
    bindings: {
        bold: $8d2fd4c49c574ba5$var$makeFormatHandler('bold'),
        italic: $8d2fd4c49c574ba5$var$makeFormatHandler('italic'),
        underline: $8d2fd4c49c574ba5$var$makeFormatHandler('underline'),
        indent: {
            // highlight tab or tab at beginning of list, indent or blockquote
            key: 'Tab',
            format: [
                'blockquote',
                'indent',
                'list'
            ],
            handler (range, context) {
                if (context.collapsed && context.offset !== 0) return true;
                this.quill.format('indent', '+1', (0, $ePuKS.default).sources.USER);
                return false;
            }
        },
        outdent: {
            key: 'Tab',
            shiftKey: true,
            format: [
                'blockquote',
                'indent',
                'list'
            ],
            // highlight tab or tab at beginning of list, indent or blockquote
            handler (range, context) {
                if (context.collapsed && context.offset !== 0) return true;
                this.quill.format('indent', '-1', (0, $ePuKS.default).sources.USER);
                return false;
            }
        },
        'outdent backspace': {
            key: 'Backspace',
            collapsed: true,
            shiftKey: null,
            metaKey: null,
            ctrlKey: null,
            altKey: null,
            format: [
                'indent',
                'list'
            ],
            offset: 0,
            handler (range, context) {
                if (context.format.indent != null) this.quill.format('indent', '-1', (0, $ePuKS.default).sources.USER);
                else if (context.format.list != null) this.quill.format('list', false, (0, $ePuKS.default).sources.USER);
            }
        },
        'indent code-block': $8d2fd4c49c574ba5$var$makeCodeBlockHandler(true),
        'outdent code-block': $8d2fd4c49c574ba5$var$makeCodeBlockHandler(false),
        'remove tab': {
            key: 'Tab',
            shiftKey: true,
            collapsed: true,
            prefix: /\t$/,
            handler (range) {
                this.quill.deleteText(range.index - 1, 1, (0, $ePuKS.default).sources.USER);
            }
        },
        tab: {
            key: 'Tab',
            handler (range, context) {
                if (context.format.table) return true;
                this.quill.history.cutoff();
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().retain(range.index).delete(range.length).insert('\t');
                this.quill.updateContents(delta, (0, $ePuKS.default).sources.USER);
                this.quill.history.cutoff();
                this.quill.setSelection(range.index + 1, (0, $ePuKS.default).sources.SILENT);
                return false;
            }
        },
        'blockquote empty enter': {
            key: 'Enter',
            collapsed: true,
            format: [
                'blockquote'
            ],
            empty: true,
            handler () {
                this.quill.format('blockquote', false, (0, $ePuKS.default).sources.USER);
            }
        },
        'list empty enter': {
            key: 'Enter',
            collapsed: true,
            format: [
                'list'
            ],
            empty: true,
            handler (range, context) {
                const formats = {
                    list: false
                };
                if (context.format.indent) formats.indent = false;
                this.quill.formatLine(range.index, range.length, formats, (0, $ePuKS.default).sources.USER);
            }
        },
        'checklist enter': {
            key: 'Enter',
            collapsed: true,
            format: {
                list: 'checked'
            },
            handler (range) {
                const [line, offset] = this.quill.getLine(range.index);
                const formats = {
                    // @ts-expect-error Fix me later
                    ...line.formats(),
                    list: 'checked'
                };
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().retain(range.index).insert('\n', formats)// @ts-expect-error Fix me later
                .retain(line.length() - offset - 1).retain(1, {
                    list: 'unchecked'
                });
                this.quill.updateContents(delta, (0, $ePuKS.default).sources.USER);
                this.quill.setSelection(range.index + 1, (0, $ePuKS.default).sources.SILENT);
                this.quill.scrollSelectionIntoView();
            }
        },
        'header enter': {
            key: 'Enter',
            collapsed: true,
            format: [
                'header'
            ],
            suffix: /^$/,
            handler (range, context) {
                const [line, offset] = this.quill.getLine(range.index);
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().retain(range.index).insert('\n', context.format)// @ts-expect-error Fix me later
                .retain(line.length() - offset - 1).retain(1, {
                    header: null
                });
                this.quill.updateContents(delta, (0, $ePuKS.default).sources.USER);
                this.quill.setSelection(range.index + 1, (0, $ePuKS.default).sources.SILENT);
                this.quill.scrollSelectionIntoView();
            }
        },
        'table backspace': {
            key: 'Backspace',
            format: [
                'table'
            ],
            collapsed: true,
            offset: 0,
            handler () {}
        },
        'table delete': {
            key: 'Delete',
            format: [
                'table'
            ],
            collapsed: true,
            suffix: /^$/,
            handler () {}
        },
        'table enter': {
            key: 'Enter',
            shiftKey: null,
            format: [
                'table'
            ],
            handler (range) {
                const module = this.quill.getModule('table');
                if (module) {
                    // @ts-expect-error
                    const [table, row, cell, offset] = module.getTable(range);
                    const shift = $8d2fd4c49c574ba5$var$tableSide(table, row, cell, offset);
                    if (shift == null) return;
                    let index = table.offset();
                    if (shift < 0) {
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().retain(index).insert('\n');
                        this.quill.updateContents(delta, (0, $ePuKS.default).sources.USER);
                        this.quill.setSelection(range.index + 1, range.length, (0, $ePuKS.default).sources.SILENT);
                    } else if (shift > 0) {
                        index += table.length();
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().retain(index).insert('\n');
                        this.quill.updateContents(delta, (0, $ePuKS.default).sources.USER);
                        this.quill.setSelection(index, (0, $ePuKS.default).sources.USER);
                    }
                }
            }
        },
        'table tab': {
            key: 'Tab',
            shiftKey: null,
            format: [
                'table'
            ],
            handler (range, context) {
                const { event: event, line: cell } = context;
                const offset = cell.offset(this.quill.scroll);
                if (event.shiftKey) this.quill.setSelection(offset - 1, (0, $ePuKS.default).sources.USER);
                else this.quill.setSelection(offset + cell.length(), (0, $ePuKS.default).sources.USER);
            }
        },
        'list autofill': {
            key: ' ',
            shiftKey: null,
            collapsed: true,
            format: {
                'code-block': false,
                blockquote: false,
                table: false
            },
            prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
            handler (range, context) {
                if (this.quill.scroll.query('list') == null) return true;
                const { length: length } = context.prefix;
                const [line, offset] = this.quill.getLine(range.index);
                if (offset > length) return true;
                let value;
                switch(context.prefix.trim()){
                    case '[]':
                    case '[ ]':
                        value = 'unchecked';
                        break;
                    case '[x]':
                        value = 'checked';
                        break;
                    case '-':
                    case '*':
                        value = 'bullet';
                        break;
                    default:
                        value = 'ordered';
                }
                this.quill.insertText(range.index, ' ', (0, $ePuKS.default).sources.USER);
                this.quill.history.cutoff();
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().retain(range.index - offset).delete(length + 1)// @ts-expect-error Fix me later
                .retain(line.length() - 2 - offset).retain(1, {
                    list: value
                });
                this.quill.updateContents(delta, (0, $ePuKS.default).sources.USER);
                this.quill.history.cutoff();
                this.quill.setSelection(range.index - length, (0, $ePuKS.default).sources.SILENT);
                return false;
            }
        },
        'code exit': {
            key: 'Enter',
            collapsed: true,
            format: [
                'code-block'
            ],
            prefix: /^$/,
            suffix: /^\s*$/,
            handler (range) {
                const [line, offset] = this.quill.getLine(range.index);
                let numLines = 2;
                let cur = line;
                while(cur != null && cur.length() <= 1 && cur.formats()['code-block']){
                    // @ts-expect-error
                    cur = cur.prev;
                    numLines -= 1;
                    // Requisite prev lines are empty
                    if (numLines <= 0) {
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))()// @ts-expect-error Fix me later
                        .retain(range.index + line.length() - offset - 2).retain(1, {
                            'code-block': null
                        }).delete(1);
                        this.quill.updateContents(delta, (0, $ePuKS.default).sources.USER);
                        this.quill.setSelection(range.index - 1, (0, $ePuKS.default).sources.SILENT);
                        return false;
                    }
                }
                return true;
            }
        },
        'embed left': $8d2fd4c49c574ba5$var$makeEmbedArrowHandler('ArrowLeft', false),
        'embed left shift': $8d2fd4c49c574ba5$var$makeEmbedArrowHandler('ArrowLeft', true),
        'embed right': $8d2fd4c49c574ba5$var$makeEmbedArrowHandler('ArrowRight', false),
        'embed right shift': $8d2fd4c49c574ba5$var$makeEmbedArrowHandler('ArrowRight', true),
        'table down': $8d2fd4c49c574ba5$var$makeTableArrowHandler(false),
        'table up': $8d2fd4c49c574ba5$var$makeTableArrowHandler(true)
    }
};
$8d2fd4c49c574ba5$export$2e2bcd8739ae039.DEFAULTS = $8d2fd4c49c574ba5$var$defaultOptions;
function $8d2fd4c49c574ba5$var$makeCodeBlockHandler(indent) {
    return {
        key: 'Tab',
        shiftKey: !indent,
        format: {
            'code-block': true
        },
        handler (range, _ref) {
            let { event: event } = _ref;
            const CodeBlock = this.quill.scroll.query('code-block');
            // @ts-expect-error
            const { TAB: TAB } = CodeBlock;
            if (range.length === 0 && !event.shiftKey) {
                this.quill.insertText(range.index, TAB, (0, $ePuKS.default).sources.USER);
                this.quill.setSelection(range.index + TAB.length, (0, $ePuKS.default).sources.SILENT);
                return;
            }
            const lines = range.length === 0 ? this.quill.getLines(range.index, 1) : this.quill.getLines(range);
            let { index: index, length: length } = range;
            lines.forEach((line, i)=>{
                if (indent) {
                    line.insertAt(0, TAB);
                    if (i === 0) index += TAB.length;
                    else length += TAB.length;
                // @ts-expect-error Fix me later
                } else if (line.domNode.textContent.startsWith(TAB)) {
                    line.deleteAt(0, TAB.length);
                    if (i === 0) index -= TAB.length;
                    else length -= TAB.length;
                }
            });
            this.quill.update((0, $ePuKS.default).sources.USER);
            this.quill.setSelection(index, length, (0, $ePuKS.default).sources.SILENT);
        }
    };
}
function $8d2fd4c49c574ba5$var$makeEmbedArrowHandler(key, shiftKey) {
    const where = key === 'ArrowLeft' ? 'prefix' : 'suffix';
    return {
        key: key,
        shiftKey: shiftKey,
        altKey: null,
        [where]: /^$/,
        handler (range) {
            let { index: index } = range;
            if (key === 'ArrowRight') index += range.length + 1;
            const [leaf] = this.quill.getLeaf(index);
            if (!(leaf instanceof (0, $45gdf.EmbedBlot))) return true;
            if (key === 'ArrowLeft') {
                if (shiftKey) this.quill.setSelection(range.index - 1, range.length + 1, (0, $ePuKS.default).sources.USER);
                else this.quill.setSelection(range.index - 1, (0, $ePuKS.default).sources.USER);
            } else if (shiftKey) this.quill.setSelection(range.index, range.length + 1, (0, $ePuKS.default).sources.USER);
            else this.quill.setSelection(range.index + range.length + 1, (0, $ePuKS.default).sources.USER);
            return false;
        }
    };
}
function $8d2fd4c49c574ba5$var$makeFormatHandler(format) {
    return {
        key: format[0],
        shortKey: true,
        handler (range, context) {
            this.quill.format(format, !context.format[format], (0, $ePuKS.default).sources.USER);
        }
    };
}
function $8d2fd4c49c574ba5$var$makeTableArrowHandler(up) {
    return {
        key: up ? 'ArrowUp' : 'ArrowDown',
        collapsed: true,
        format: [
            'table'
        ],
        handler (range, context) {
            // TODO move to table module
            const key = up ? 'prev' : 'next';
            const cell = context.line;
            const targetRow = cell.parent[key];
            if (targetRow != null) {
                if (targetRow.statics.blotName === 'table-row') {
                    // @ts-expect-error
                    let targetCell = targetRow.children.head;
                    let cur = cell;
                    while(cur.prev != null){
                        // @ts-expect-error
                        cur = cur.prev;
                        targetCell = targetCell.next;
                    }
                    const index = targetCell.offset(this.quill.scroll) + Math.min(context.offset, targetCell.length() - 1);
                    this.quill.setSelection(index, 0, (0, $ePuKS.default).sources.USER);
                }
            } else {
                // @ts-expect-error
                const targetLine = cell.table()[key];
                if (targetLine != null) {
                    if (up) this.quill.setSelection(targetLine.offset(this.quill.scroll) + targetLine.length() - 1, 0, (0, $ePuKS.default).sources.USER);
                    else this.quill.setSelection(targetLine.offset(this.quill.scroll), 0, (0, $ePuKS.default).sources.USER);
                }
            }
            return false;
        }
    };
}
function $8d2fd4c49c574ba5$export$a3295358bff77e(binding) {
    if (typeof binding === 'string' || typeof binding === 'number') binding = {
        key: binding
    };
    else if (typeof binding === 'object') binding = (0, $buDZz.default)(binding);
    else return null;
    if (binding.shortKey) {
        binding[$8d2fd4c49c574ba5$export$34a157fc58f3dd07] = binding.shortKey;
        delete binding.shortKey;
    }
    return binding;
}
// TODO: Move into quill.ts or editor.ts
function $8d2fd4c49c574ba5$export$a6c813797f379898(_ref2) {
    let { quill: quill, range: range } = _ref2;
    const lines = quill.getLines(range);
    let formats = {};
    if (lines.length > 1) {
        const firstFormats = lines[0].formats();
        const lastFormats = lines[lines.length - 1].formats();
        formats = (0, $ehD63.AttributeMap).diff(lastFormats, firstFormats) || {};
    }
    quill.deleteText(range, (0, $ePuKS.default).sources.USER);
    if (Object.keys(formats).length > 0) quill.formatLine(range.index, 1, formats, (0, $ePuKS.default).sources.USER);
    quill.setSelection(range.index, (0, $ePuKS.default).sources.SILENT);
}
function $8d2fd4c49c574ba5$var$tableSide(_table, row, cell, offset) {
    if (row.prev == null && row.next == null) {
        if (cell.prev == null && cell.next == null) return offset === 0 ? -1 : 1;
        return cell.prev == null ? -1 : 1;
    }
    if (row.prev == null) return -1;
    if (row.next == null) return 1;
    return null;
}

});

parcelRegister("cagvo", function(module, exports) {

$parcel$export(module.exports, "default", () => $8db338d6313cb7e4$export$2e2bcd8739ae039);

var $5q9J8 = parcelRequire("5q9J8");

var $5x9Ip = parcelRequire("5x9Ip");
const $8db338d6313cb7e4$var$NORMALIZERS = [
    (0, $5x9Ip.default),
    (0, $5q9J8.default)
];
const $8db338d6313cb7e4$var$normalizeExternalHTML = (doc)=>{
    if (doc.documentElement) $8db338d6313cb7e4$var$NORMALIZERS.forEach((normalize)=>{
        normalize(doc);
    });
};
var $8db338d6313cb7e4$export$2e2bcd8739ae039 = $8db338d6313cb7e4$var$normalizeExternalHTML;

});
parcelRegister("5q9J8", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f26ed02c7b8072f$export$2e2bcd8739ae039);
const $3f26ed02c7b8072f$var$normalWeightRegexp = /font-weight:\s*normal/;
const $3f26ed02c7b8072f$var$blockTagNames = [
    'P',
    'OL',
    'UL'
];
const $3f26ed02c7b8072f$var$isBlockElement = (element)=>{
    return element && $3f26ed02c7b8072f$var$blockTagNames.includes(element.tagName);
};
const $3f26ed02c7b8072f$var$normalizeEmptyLines = (doc)=>{
    Array.from(doc.querySelectorAll('br')).filter((br)=>$3f26ed02c7b8072f$var$isBlockElement(br.previousElementSibling) && $3f26ed02c7b8072f$var$isBlockElement(br.nextElementSibling)).forEach((br)=>{
        br.parentNode?.removeChild(br);
    });
};
const $3f26ed02c7b8072f$var$normalizeFontWeight = (doc)=>{
    Array.from(doc.querySelectorAll('b[style*="font-weight"]')).filter((node)=>node.getAttribute('style')?.match($3f26ed02c7b8072f$var$normalWeightRegexp)).forEach((node)=>{
        const fragment = doc.createDocumentFragment();
        fragment.append(...node.childNodes);
        node.parentNode?.replaceChild(fragment, node);
    });
};
function $3f26ed02c7b8072f$export$2e2bcd8739ae039(doc) {
    if (doc.querySelector('[id^="docs-internal-guid-"]')) {
        $3f26ed02c7b8072f$var$normalizeFontWeight(doc);
        $3f26ed02c7b8072f$var$normalizeEmptyLines(doc);
    }
}

});

parcelRegister("5x9Ip", function(module, exports) {

$parcel$export(module.exports, "default", () => $407792182f0be5a0$export$2e2bcd8739ae039);
const $407792182f0be5a0$var$ignoreRegexp = /\bmso-list:[^;]*ignore/i;
const $407792182f0be5a0$var$idRegexp = /\bmso-list:[^;]*\bl(\d+)/i;
const $407792182f0be5a0$var$indentRegexp = /\bmso-list:[^;]*\blevel(\d+)/i;
const $407792182f0be5a0$var$parseListItem = (element, html)=>{
    const style = element.getAttribute('style');
    const idMatch = style?.match($407792182f0be5a0$var$idRegexp);
    if (!idMatch) return null;
    const id = Number(idMatch[1]);
    const indentMatch = style?.match($407792182f0be5a0$var$indentRegexp);
    const indent = indentMatch ? Number(indentMatch[1]) : 1;
    const typeRegexp = new RegExp(`@list l${id}:level${indent}\\s*\\{[^\\}]*mso-level-number-format:\\s*([\\w-]+)`, 'i');
    const typeMatch = html.match(typeRegexp);
    const type = typeMatch && typeMatch[1] === 'bullet' ? 'bullet' : 'ordered';
    return {
        id: id,
        indent: indent,
        type: type,
        element: element
    };
};
// list items are represented as `p` tags with styles like `mso-list: l0 level1` where:
// 1. "0" in "l0" means the list item id;
// 2. "1" in "level1" means the indent level, starting from 1.
const $407792182f0be5a0$var$normalizeListItem = (doc)=>{
    const msoList = Array.from(doc.querySelectorAll('[style*=mso-list]'));
    const ignored = [];
    const others = [];
    msoList.forEach((node)=>{
        const shouldIgnore = (node.getAttribute('style') || '').match($407792182f0be5a0$var$ignoreRegexp);
        if (shouldIgnore) ignored.push(node);
        else others.push(node);
    });
    // Each list item contains a marker wrapped with "mso-list: Ignore".
    ignored.forEach((node)=>node.parentNode?.removeChild(node));
    // The list stype is not defined inline with the tag, instead, it's in the
    // style tag so we need to pass the html as a string.
    const html = doc.documentElement.innerHTML;
    const listItems = others.map((element)=>$407792182f0be5a0$var$parseListItem(element, html)).filter((parsed)=>parsed);
    while(listItems.length){
        const childListItems = [];
        let current = listItems.shift();
        // Group continuous items into the same group (aka "ul")
        while(current){
            childListItems.push(current);
            current = listItems.length && listItems[0]?.element === current.element.nextElementSibling && // Different id means the next item doesn't belong to this group.
            listItems[0].id === current.id ? listItems.shift() : null;
        }
        const ul = document.createElement('ul');
        childListItems.forEach((listItem)=>{
            const li = document.createElement('li');
            li.setAttribute('data-list', listItem.type);
            if (listItem.indent > 1) li.setAttribute('class', `ql-indent-${listItem.indent - 1}`);
            li.innerHTML = listItem.element.innerHTML;
            ul.appendChild(li);
        });
        const element = childListItems[0]?.element;
        const { parentNode: parentNode } = element ?? {};
        if (element) parentNode?.replaceChild(ul, element);
        childListItems.slice(1).forEach((_ref)=>{
            let { element: e } = _ref;
            parentNode?.removeChild(e);
        });
    }
};
function $407792182f0be5a0$export$2e2bcd8739ae039(doc) {
    if (doc.documentElement.getAttribute('xmlns:w') === 'urn:schemas-microsoft-com:office:word') $407792182f0be5a0$var$normalizeListItem(doc);
}

});



parcelRegister("ecT31", function(module, exports) {

$parcel$export(module.exports, "default", () => $a57ce3016d3d142f$export$2e2bcd8739ae039);

var $45gdf = parcelRequire("45gdf");

var $43smM = parcelRequire("43smM");

var $ePuKS = parcelRequire("ePuKS");
class $a57ce3016d3d142f$export$2e2bcd8739ae039 extends (0, $43smM.default) {
    static DEFAULTS = {
        delay: 1000,
        maxStack: 100,
        userOnly: false
    };
    lastRecorded = 0;
    ignoreChange = false;
    stack = {
        undo: [],
        redo: []
    };
    currentRange = null;
    constructor(quill, options){
        super(quill, options);
        this.quill.on((0, $ePuKS.default).events.EDITOR_CHANGE, (eventName, value, oldValue, source)=>{
            if (eventName === (0, $ePuKS.default).events.SELECTION_CHANGE) {
                if (value && source !== (0, $ePuKS.default).sources.SILENT) this.currentRange = value;
            } else if (eventName === (0, $ePuKS.default).events.TEXT_CHANGE) {
                if (!this.ignoreChange) {
                    if (!this.options.userOnly || source === (0, $ePuKS.default).sources.USER) this.record(value, oldValue);
                    else this.transform(value);
                }
                this.currentRange = $a57ce3016d3d142f$var$transformRange(this.currentRange, value);
            }
        });
        this.quill.keyboard.addBinding({
            key: 'z',
            shortKey: true
        }, this.undo.bind(this));
        this.quill.keyboard.addBinding({
            key: [
                'z',
                'Z'
            ],
            shortKey: true,
            shiftKey: true
        }, this.redo.bind(this));
        if (/Win/i.test(navigator.platform)) this.quill.keyboard.addBinding({
            key: 'y',
            shortKey: true
        }, this.redo.bind(this));
        this.quill.root.addEventListener('beforeinput', (event)=>{
            if (event.inputType === 'historyUndo') {
                this.undo();
                event.preventDefault();
            } else if (event.inputType === 'historyRedo') {
                this.redo();
                event.preventDefault();
            }
        });
    }
    change(source, dest) {
        if (this.stack[source].length === 0) return;
        const item = this.stack[source].pop();
        if (!item) return;
        const base = this.quill.getContents();
        const inverseDelta = item.delta.invert(base);
        this.stack[dest].push({
            delta: inverseDelta,
            range: $a57ce3016d3d142f$var$transformRange(item.range, inverseDelta)
        });
        this.lastRecorded = 0;
        this.ignoreChange = true;
        this.quill.updateContents(item.delta, (0, $ePuKS.default).sources.USER);
        this.ignoreChange = false;
        this.restoreSelection(item);
    }
    clear() {
        this.stack = {
            undo: [],
            redo: []
        };
    }
    cutoff() {
        this.lastRecorded = 0;
    }
    record(changeDelta, oldDelta) {
        if (changeDelta.ops.length === 0) return;
        this.stack.redo = [];
        let undoDelta = changeDelta.invert(oldDelta);
        let undoRange = this.currentRange;
        const timestamp = Date.now();
        if (// @ts-expect-error Fix me later
        this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
            const item = this.stack.undo.pop();
            if (item) {
                undoDelta = undoDelta.compose(item.delta);
                undoRange = item.range;
            }
        } else this.lastRecorded = timestamp;
        if (undoDelta.length() === 0) return;
        this.stack.undo.push({
            delta: undoDelta,
            range: undoRange
        });
        // @ts-expect-error Fix me later
        if (this.stack.undo.length > this.options.maxStack) this.stack.undo.shift();
    }
    redo() {
        this.change('redo', 'undo');
    }
    transform(delta) {
        $a57ce3016d3d142f$var$transformStack(this.stack.undo, delta);
        $a57ce3016d3d142f$var$transformStack(this.stack.redo, delta);
    }
    undo() {
        this.change('undo', 'redo');
    }
    restoreSelection(stackItem) {
        if (stackItem.range) this.quill.setSelection(stackItem.range, (0, $ePuKS.default).sources.USER);
        else {
            const index = $a57ce3016d3d142f$export$64042f78dc41d29e(this.quill.scroll, stackItem.delta);
            this.quill.setSelection(index, (0, $ePuKS.default).sources.USER);
        }
    }
}
function $a57ce3016d3d142f$var$transformStack(stack, delta) {
    let remoteDelta = delta;
    for(let i = stack.length - 1; i >= 0; i -= 1){
        const oldItem = stack[i];
        stack[i] = {
            delta: remoteDelta.transform(oldItem.delta, true),
            range: oldItem.range && $a57ce3016d3d142f$var$transformRange(oldItem.range, remoteDelta)
        };
        remoteDelta = oldItem.delta.transform(remoteDelta);
        if (stack[i].delta.length() === 0) stack.splice(i, 1);
    }
}
function $a57ce3016d3d142f$var$endsWithNewlineChange(scroll, delta) {
    const lastOp = delta.ops[delta.ops.length - 1];
    if (lastOp == null) return false;
    if (lastOp.insert != null) return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
    if (lastOp.attributes != null) return Object.keys(lastOp.attributes).some((attr)=>{
        return scroll.query(attr, (0, $45gdf.Scope).BLOCK) != null;
    });
    return false;
}
function $a57ce3016d3d142f$export$64042f78dc41d29e(scroll, delta) {
    const deleteLength = delta.reduce((length, op)=>{
        return length + (op.delete || 0);
    }, 0);
    let changeIndex = delta.length() - deleteLength;
    if ($a57ce3016d3d142f$var$endsWithNewlineChange(scroll, delta)) changeIndex -= 1;
    return changeIndex;
}
function $a57ce3016d3d142f$var$transformRange(range, delta) {
    if (!range) return range;
    const start = delta.transformPosition(range.index);
    const end = delta.transformPosition(range.index + range.length);
    return {
        index: start,
        length: end - start
    };
}

});

parcelRegister("9LWxB", function(module, exports) {

$parcel$export(module.exports, "default", () => $71d5e9d9dd8654fe$export$2e2bcd8739ae039);

var $ehD63 = parcelRequire("ehD63");

var $hJr1g = parcelRequire("hJr1g");

var $43smM = parcelRequire("43smM");
class $71d5e9d9dd8654fe$var$Uploader extends (0, $43smM.default) {
    constructor(quill, options){
        super(quill, options);
        quill.root.addEventListener('drop', (e)=>{
            e.preventDefault();
            let native = null;
            if (document.caretRangeFromPoint) native = document.caretRangeFromPoint(e.clientX, e.clientY);
            else if (document.caretPositionFromPoint) {
                // @ts-expect-error
                const position = document.caretPositionFromPoint(e.clientX, e.clientY);
                native = document.createRange();
                native.setStart(position.offsetNode, position.offset);
                native.setEnd(position.offsetNode, position.offset);
            }
            const normalized = native && quill.selection.normalizeNative(native);
            if (normalized) {
                const range = quill.selection.normalizedToRange(normalized);
                if (e.dataTransfer?.files) this.upload(range, e.dataTransfer.files);
            }
        });
    }
    upload(range, files) {
        const uploads = [];
        Array.from(files).forEach((file)=>{
            if (file && this.options.mimetypes?.includes(file.type)) uploads.push(file);
        });
        if (uploads.length > 0) // @ts-expect-error Fix me later
        this.options.handler.call(this, range, uploads);
    }
}
$71d5e9d9dd8654fe$var$Uploader.DEFAULTS = {
    mimetypes: [
        'image/png',
        'image/jpeg'
    ],
    handler (range, files) {
        if (!this.quill.scroll.query('image')) return;
        const promises = files.map((file)=>{
            return new Promise((resolve)=>{
                const reader = new FileReader();
                reader.onload = ()=>{
                    resolve(reader.result);
                };
                reader.readAsDataURL(file);
            });
        });
        Promise.all(promises).then((images)=>{
            const update = images.reduce((delta, image)=>{
                return delta.insert({
                    image: image
                });
            }, new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().retain(range.index).delete(range.length));
            this.quill.updateContents(update, (0, $hJr1g.default).sources.USER);
            this.quill.setSelection(range.index + images.length, (0, $hJr1g.default).sources.SILENT);
        });
    }
};
var $71d5e9d9dd8654fe$export$2e2bcd8739ae039 = $71d5e9d9dd8654fe$var$Uploader;

});

parcelRegister("h2b1E", function(module, exports) {

$parcel$export(module.exports, "default", () => $c66b2d07900cb8ca$export$2e2bcd8739ae039);

var $ehD63 = parcelRequire("ehD63");

var $43smM = parcelRequire("43smM");

var $ePuKS = parcelRequire("ePuKS");

var $c7x7B = parcelRequire("c7x7B");
const $c66b2d07900cb8ca$var$INSERT_TYPES = [
    'insertText',
    'insertReplacementText'
];
class $c66b2d07900cb8ca$var$Input extends (0, $43smM.default) {
    constructor(quill, options){
        super(quill, options);
        quill.root.addEventListener('beforeinput', (event)=>{
            this.handleBeforeInput(event);
        });
        // Gboard with English input on Android triggers `compositionstart` sometimes even
        // users are not going to type anything.
        if (!/Android/i.test(navigator.userAgent)) quill.on((0, $ePuKS.default).events.COMPOSITION_BEFORE_START, ()=>{
            this.handleCompositionStart();
        });
    }
    deleteRange(range) {
        (0, $c7x7B.deleteRange)({
            range: range,
            quill: this.quill
        });
    }
    replaceText(range) {
        let text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        if (range.length === 0) return false;
        if (text) {
            // Follow the native behavior that inherits the formats of the first character
            const formats = this.quill.getFormat(range.index, 1);
            this.deleteRange(range);
            this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().retain(range.index).insert(text, formats), (0, $ePuKS.default).sources.USER);
        } else this.deleteRange(range);
        this.quill.setSelection(range.index + text.length, 0, (0, $ePuKS.default).sources.SILENT);
        return true;
    }
    handleBeforeInput(event) {
        if (this.quill.composition.isComposing || event.defaultPrevented || !$c66b2d07900cb8ca$var$INSERT_TYPES.includes(event.inputType)) return;
        const staticRange = event.getTargetRanges ? event.getTargetRanges()[0] : null;
        if (!staticRange || staticRange.collapsed === true) return;
        const text = $c66b2d07900cb8ca$var$getPlainTextFromInputEvent(event);
        if (text == null) return;
        const normalized = this.quill.selection.normalizeNative(staticRange);
        const range = normalized ? this.quill.selection.normalizedToRange(normalized) : null;
        if (range && this.replaceText(range, text)) event.preventDefault();
    }
    handleCompositionStart() {
        const range = this.quill.getSelection();
        if (range) this.replaceText(range);
    }
}
function $c66b2d07900cb8ca$var$getPlainTextFromInputEvent(event) {
    // When `inputType` is "insertText":
    // - `event.data` should be string (Safari uses `event.dataTransfer`).
    // - `event.dataTransfer` should be null.
    // When `inputType` is "insertReplacementText":
    // - `event.data` should be null.
    // - `event.dataTransfer` should contain "text/plain" data.
    if (typeof event.data === 'string') return event.data;
    if (event.dataTransfer?.types.includes('text/plain')) return event.dataTransfer.getData('text/plain');
    return null;
}
var $c66b2d07900cb8ca$export$2e2bcd8739ae039 = $c66b2d07900cb8ca$var$Input;

});

parcelRegister("2qoCa", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c411a6da233a5f9$export$2e2bcd8739ae039);

var $45gdf = parcelRequire("45gdf");

var $43smM = parcelRequire("43smM");

var $ePuKS = parcelRequire("ePuKS");
const $1c411a6da233a5f9$var$isMac = /Mac/i.test(navigator.platform);
const $1c411a6da233a5f9$export$b6cc50769bf06658 = 100;
// A loose check to determine if the shortcut can move the caret before a UI node:
// <ANY_PARENT>[CARET]<div class="ql-ui"></div>[CONTENT]</ANY_PARENT>
const $1c411a6da233a5f9$var$canMoveCaretBeforeUINode = (event)=>{
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight' || // RTL scripts or moving from the end of the previous line
    event.key === 'ArrowUp' || event.key === 'ArrowDown' || event.key === 'Home') return true;
    if ($1c411a6da233a5f9$var$isMac && event.key === 'a' && event.ctrlKey === true) return true;
    return false;
};
class $1c411a6da233a5f9$var$UINode extends (0, $43smM.default) {
    isListening = false;
    selectionChangeDeadline = 0;
    constructor(quill, options){
        super(quill, options);
        this.handleArrowKeys();
        this.handleNavigationShortcuts();
    }
    handleArrowKeys() {
        this.quill.keyboard.addBinding({
            key: [
                'ArrowLeft',
                'ArrowRight'
            ],
            offset: 0,
            shiftKey: null,
            handler (range, _ref) {
                let { line: line, event: event } = _ref;
                if (!(line instanceof (0, $45gdf.ParentBlot)) || !line.uiNode) return true;
                const isRTL = getComputedStyle(line.domNode)['direction'] === 'rtl';
                if (isRTL && event.key !== 'ArrowRight' || !isRTL && event.key !== 'ArrowLeft') return true;
                this.quill.setSelection(range.index - 1, range.length + (event.shiftKey ? 1 : 0), (0, $ePuKS.default).sources.USER);
                return false;
            }
        });
    }
    handleNavigationShortcuts() {
        this.quill.root.addEventListener('keydown', (event)=>{
            if (!event.defaultPrevented && $1c411a6da233a5f9$var$canMoveCaretBeforeUINode(event)) this.ensureListeningToSelectionChange();
        });
    }
    /**
   * We only listen to the `selectionchange` event when
   * there is an intention of moving the caret to the beginning using shortcuts.
   * This is primarily implemented to prevent infinite loops, as we are changing
   * the selection within the handler of a `selectionchange` event.
   */ ensureListeningToSelectionChange() {
        this.selectionChangeDeadline = Date.now() + $1c411a6da233a5f9$export$b6cc50769bf06658;
        if (this.isListening) return;
        this.isListening = true;
        const listener = ()=>{
            this.isListening = false;
            if (Date.now() <= this.selectionChangeDeadline) this.handleSelectionChange();
        };
        document.addEventListener('selectionchange', listener, {
            once: true
        });
    }
    handleSelectionChange() {
        const selection = document.getSelection();
        if (!selection) return;
        const range = selection.getRangeAt(0);
        if (range.collapsed !== true || range.startOffset !== 0) return;
        const line = this.quill.scroll.find(range.startContainer);
        if (!(line instanceof (0, $45gdf.ParentBlot)) || !line.uiNode) return;
        const newRange = document.createRange();
        newRange.setStartAfter(line.uiNode);
        newRange.setEndAfter(line.uiNode);
        selection.removeAllRanges();
        selection.addRange(newRange);
    }
}
var $1c411a6da233a5f9$export$2e2bcd8739ae039 = $1c411a6da233a5f9$var$UINode;

});


parcelRegister("71Fw5", function(module, exports) {

$parcel$export(module.exports, "default", () => $51d8d4b24cd55b40$export$2e2bcd8739ae039);

var $45gdf = parcelRequire("45gdf");
class $51d8d4b24cd55b40$var$IndentAttributor extends (0, $45gdf.ClassAttributor) {
    add(node, value) {
        let normalizedValue = 0;
        if (value === '+1' || value === '-1') {
            const indent = this.value(node) || 0;
            normalizedValue = value === '+1' ? indent + 1 : indent - 1;
        } else if (typeof value === 'number') normalizedValue = value;
        if (normalizedValue === 0) {
            this.remove(node);
            return true;
        }
        return super.add(node, normalizedValue.toString());
    }
    canAdd(node, value) {
        return super.canAdd(node, value) || super.canAdd(node, parseInt(value, 10));
    }
    value(node) {
        return parseInt(super.value(node), 10) || undefined; // Don't return NaN
    }
}
const $51d8d4b24cd55b40$var$IndentClass = new $51d8d4b24cd55b40$var$IndentAttributor('indent', 'ql-indent', {
    scope: (0, $45gdf.Scope).BLOCK,
    // @ts-expect-error
    whitelist: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8
    ]
});
var $51d8d4b24cd55b40$export$2e2bcd8739ae039 = $51d8d4b24cd55b40$var$IndentClass;

});

parcelRegister("e9JMe", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4e56a5082e778fd$export$2e2bcd8739ae039);

var $jUBfi = parcelRequire("jUBfi");
class $a4e56a5082e778fd$var$Blockquote extends (0, $jUBfi.default) {
    static blotName = 'blockquote';
    static tagName = 'blockquote';
}
var $a4e56a5082e778fd$export$2e2bcd8739ae039 = $a4e56a5082e778fd$var$Blockquote;

});

parcelRegister("gWGql", function(module, exports) {

$parcel$export(module.exports, "default", () => $c562f89a276ee833$export$2e2bcd8739ae039);

var $jUBfi = parcelRequire("jUBfi");
class $c562f89a276ee833$var$Header extends (0, $jUBfi.default) {
    static blotName = 'header';
    static tagName = [
        'H1',
        'H2',
        'H3',
        'H4',
        'H5',
        'H6'
    ];
    static formats(domNode) {
        return this.tagName.indexOf(domNode.tagName) + 1;
    }
}
var $c562f89a276ee833$export$2e2bcd8739ae039 = $c562f89a276ee833$var$Header;

});

parcelRegister("1bZ3M", function(module, exports) {

$parcel$export(module.exports, "default", () => $0de62ec3ac883f6f$export$2e2bcd8739ae039);

var $jUBfi = parcelRequire("jUBfi");

var $BNn3z = parcelRequire("BNn3z");

var $ePuKS = parcelRequire("ePuKS");
class $0de62ec3ac883f6f$export$122a2a667e12876b extends (0, $BNn3z.default) {
}
$0de62ec3ac883f6f$export$122a2a667e12876b.blotName = 'list-container';
$0de62ec3ac883f6f$export$122a2a667e12876b.tagName = 'OL';
class $0de62ec3ac883f6f$export$2e2bcd8739ae039 extends (0, $jUBfi.default) {
    static create(value) {
        const node = super.create();
        node.setAttribute('data-list', value);
        return node;
    }
    static formats(domNode) {
        return domNode.getAttribute('data-list') || undefined;
    }
    static register() {
        (0, $ePuKS.default).register($0de62ec3ac883f6f$export$122a2a667e12876b);
    }
    constructor(scroll, domNode){
        super(scroll, domNode);
        const ui = domNode.ownerDocument.createElement('span');
        const listEventHandler = (e)=>{
            if (!scroll.isEnabled()) return;
            const format = this.statics.formats(domNode, scroll);
            if (format === 'checked') {
                this.format('list', 'unchecked');
                e.preventDefault();
            } else if (format === 'unchecked') {
                this.format('list', 'checked');
                e.preventDefault();
            }
        };
        ui.addEventListener('mousedown', listEventHandler);
        ui.addEventListener('touchstart', listEventHandler);
        this.attachUI(ui);
    }
    format(name, value) {
        if (name === this.statics.blotName && value) this.domNode.setAttribute('data-list', value);
        else super.format(name, value);
    }
}
$0de62ec3ac883f6f$export$2e2bcd8739ae039.blotName = 'list';
$0de62ec3ac883f6f$export$2e2bcd8739ae039.tagName = 'LI';
$0de62ec3ac883f6f$export$122a2a667e12876b.allowedChildren = [
    $0de62ec3ac883f6f$export$2e2bcd8739ae039
];
$0de62ec3ac883f6f$export$2e2bcd8739ae039.requiredContainer = $0de62ec3ac883f6f$export$122a2a667e12876b;

});

parcelRegister("6Okcm", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f57148efe8e369c$export$2e2bcd8739ae039);

var $95m1U = parcelRequire("95m1U");
class $4f57148efe8e369c$var$Bold extends (0, $95m1U.default) {
    static blotName = 'bold';
    static tagName = [
        'STRONG',
        'B'
    ];
    static create() {
        return super.create();
    }
    static formats() {
        return true;
    }
    optimize(context) {
        super.optimize(context);
        if (this.domNode.tagName !== this.statics.tagName[0]) this.replaceWith(this.statics.blotName);
    }
}
var $4f57148efe8e369c$export$2e2bcd8739ae039 = $4f57148efe8e369c$var$Bold;

});

parcelRegister("UtFnU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a9c3e3997cde197$export$2e2bcd8739ae039);

var $6Okcm = parcelRequire("6Okcm");
class $0a9c3e3997cde197$var$Italic extends (0, $6Okcm.default) {
    static blotName = 'italic';
    static tagName = [
        'EM',
        'I'
    ];
}
var $0a9c3e3997cde197$export$2e2bcd8739ae039 = $0a9c3e3997cde197$var$Italic;

});

parcelRegister("1M5DR", function(module, exports) {

$parcel$export(module.exports, "default", () => $14aea684c7db5407$export$2e2bcd8739ae039);
$parcel$export(module.exports, "sanitize", () => $14aea684c7db5407$export$83d2e9e3e4ee39ed);

var $95m1U = parcelRequire("95m1U");
class $14aea684c7db5407$export$2e2bcd8739ae039 extends (0, $95m1U.default) {
    static blotName = 'link';
    static tagName = 'A';
    static SANITIZED_URL = 'about:blank';
    static PROTOCOL_WHITELIST = [
        'http',
        'https',
        'mailto',
        'tel',
        'sms'
    ];
    static create(value) {
        const node = super.create(value);
        node.setAttribute('href', this.sanitize(value));
        node.setAttribute('rel', 'noopener noreferrer');
        node.setAttribute('target', '_blank');
        return node;
    }
    static formats(domNode) {
        return domNode.getAttribute('href');
    }
    static sanitize(url) {
        return $14aea684c7db5407$export$83d2e9e3e4ee39ed(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
    }
    format(name, value) {
        if (name !== this.statics.blotName || !value) super.format(name, value);
        else // @ts-expect-error
        this.domNode.setAttribute('href', this.constructor.sanitize(value));
    }
}
function $14aea684c7db5407$export$83d2e9e3e4ee39ed(url, protocols) {
    const anchor = document.createElement('a');
    anchor.href = url;
    const protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
    return protocols.indexOf(protocol) > -1;
}

});

parcelRegister("ltGnr", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa2d2d9f6493d942$export$2e2bcd8739ae039);

var $95m1U = parcelRequire("95m1U");
class $fa2d2d9f6493d942$var$Script extends (0, $95m1U.default) {
    static blotName = 'script';
    static tagName = [
        'SUB',
        'SUP'
    ];
    static create(value) {
        if (value === 'super') return document.createElement('sup');
        if (value === 'sub') return document.createElement('sub');
        return super.create(value);
    }
    static formats(domNode) {
        if (domNode.tagName === 'SUB') return 'sub';
        if (domNode.tagName === 'SUP') return 'super';
        return undefined;
    }
}
var $fa2d2d9f6493d942$export$2e2bcd8739ae039 = $fa2d2d9f6493d942$var$Script;

});

parcelRegister("6wBAW", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c02e4cf206e5074$export$2e2bcd8739ae039);

var $6Okcm = parcelRequire("6Okcm");
class $4c02e4cf206e5074$var$Strike extends (0, $6Okcm.default) {
    static blotName = 'strike';
    static tagName = [
        'S',
        'STRIKE'
    ];
}
var $4c02e4cf206e5074$export$2e2bcd8739ae039 = $4c02e4cf206e5074$var$Strike;

});

parcelRegister("72gZ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $51f5e4eaaf7a94e7$export$2e2bcd8739ae039);

var $95m1U = parcelRequire("95m1U");
class $51f5e4eaaf7a94e7$var$Underline extends (0, $95m1U.default) {
    static blotName = 'underline';
    static tagName = 'U';
}
var $51f5e4eaaf7a94e7$export$2e2bcd8739ae039 = $51f5e4eaaf7a94e7$var$Underline;

});

parcelRegister("5PJkd", function(module, exports) {

$parcel$export(module.exports, "default", () => $43f4dfcc550b114e$export$2e2bcd8739ae039);

var $jqZQb = parcelRequire("jqZQb");
class $43f4dfcc550b114e$var$Formula extends (0, $jqZQb.default) {
    static blotName = 'formula';
    static className = 'ql-formula';
    static tagName = 'SPAN';
    static create(value) {
        // @ts-expect-error
        if (window.katex == null) throw new Error('Formula module requires KaTeX.');
        const node = super.create(value);
        if (typeof value === 'string') {
            // @ts-expect-error
            window.katex.render(value, node, {
                throwOnError: false,
                errorColor: '#f00'
            });
            node.setAttribute('data-value', value);
        }
        return node;
    }
    static value(domNode) {
        return domNode.getAttribute('data-value');
    }
    html() {
        const { formula: formula } = this.value();
        return `<span>${formula}</span>`;
    }
}
var $43f4dfcc550b114e$export$2e2bcd8739ae039 = $43f4dfcc550b114e$var$Formula;

});

parcelRegister("7VTjX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c68c4d9b946ad4f$export$2e2bcd8739ae039);

var $45gdf = parcelRequire("45gdf");

var $1M5DR = parcelRequire("1M5DR");
const $5c68c4d9b946ad4f$var$ATTRIBUTES = [
    'alt',
    'height',
    'width'
];
class $5c68c4d9b946ad4f$var$Image extends (0, $45gdf.EmbedBlot) {
    static blotName = 'image';
    static tagName = 'IMG';
    static create(value) {
        const node = super.create(value);
        if (typeof value === 'string') node.setAttribute('src', this.sanitize(value));
        return node;
    }
    static formats(domNode) {
        return $5c68c4d9b946ad4f$var$ATTRIBUTES.reduce((formats, attribute)=>{
            if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
            return formats;
        }, {});
    }
    static match(url) {
        return /\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url);
    }
    static sanitize(url) {
        return (0, $1M5DR.sanitize)(url, [
            'http',
            'https',
            'data'
        ]) ? url : '//:0';
    }
    static value(domNode) {
        return domNode.getAttribute('src');
    }
    format(name, value) {
        if ($5c68c4d9b946ad4f$var$ATTRIBUTES.indexOf(name) > -1) {
            if (value) this.domNode.setAttribute(name, value);
            else this.domNode.removeAttribute(name);
        } else super.format(name, value);
    }
}
var $5c68c4d9b946ad4f$export$2e2bcd8739ae039 = $5c68c4d9b946ad4f$var$Image;

});

parcelRegister("lKALb", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd5a689d5624e74c$export$2e2bcd8739ae039);

var $jUBfi = parcelRequire("jUBfi");

var $1M5DR = parcelRequire("1M5DR");
const $fd5a689d5624e74c$var$ATTRIBUTES = [
    'height',
    'width'
];
class $fd5a689d5624e74c$var$Video extends (0, $jUBfi.BlockEmbed) {
    static blotName = 'video';
    static className = 'ql-video';
    static tagName = 'IFRAME';
    static create(value) {
        const node = super.create(value);
        node.setAttribute('frameborder', '0');
        node.setAttribute('allowfullscreen', 'true');
        node.setAttribute('src', this.sanitize(value));
        return node;
    }
    static formats(domNode) {
        return $fd5a689d5624e74c$var$ATTRIBUTES.reduce((formats, attribute)=>{
            if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
            return formats;
        }, {});
    }
    static sanitize(url) {
        return (0, $1M5DR.default).sanitize(url);
    }
    static value(domNode) {
        return domNode.getAttribute('src');
    }
    format(name, value) {
        if ($fd5a689d5624e74c$var$ATTRIBUTES.indexOf(name) > -1) {
            if (value) this.domNode.setAttribute(name, value);
            else this.domNode.removeAttribute(name);
        } else super.format(name, value);
    }
    html() {
        const { video: video } = this.value();
        return `<a href="${video}">${video}</a>`;
    }
}
var $fd5a689d5624e74c$export$2e2bcd8739ae039 = $fd5a689d5624e74c$var$Video;

});

parcelRegister("ipVZD", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6878c049d90f631$export$2e2bcd8739ae039);

var $ehD63 = parcelRequire("ehD63");

var $45gdf = parcelRequire("45gdf");

var $95m1U = parcelRequire("95m1U");

var $ePuKS = parcelRequire("ePuKS");

var $43smM = parcelRequire("43smM");

var $jUBfi = parcelRequire("jUBfi");

var $gkqQr = parcelRequire("gkqQr");

var $9VFAE = parcelRequire("9VFAE");

var $l6ueR = parcelRequire("l6ueR");

var $W91pZ = parcelRequire("W91pZ");

var $jQ3Vn = parcelRequire("jQ3Vn");
const $d6878c049d90f631$var$TokenAttributor = new (0, $45gdf.ClassAttributor)('code-token', 'hljs', {
    scope: (0, $45gdf.Scope).INLINE
});
class $d6878c049d90f631$export$9460eee64f276be7 extends (0, $95m1U.default) {
    static formats(node, scroll) {
        while(node != null && node !== scroll.domNode){
            if (node.classList && node.classList.contains((0, $W91pZ.default).className)) // @ts-expect-error
            return super.formats(node, scroll);
            // @ts-expect-error
            node = node.parentNode;
        }
        return undefined;
    }
    constructor(scroll, domNode, value){
        // @ts-expect-error
        super(scroll, domNode, value);
        $d6878c049d90f631$var$TokenAttributor.add(this.domNode, value);
    }
    format(format, value) {
        if (format !== $d6878c049d90f631$export$9460eee64f276be7.blotName) super.format(format, value);
        else if (value) $d6878c049d90f631$var$TokenAttributor.add(this.domNode, value);
        else {
            $d6878c049d90f631$var$TokenAttributor.remove(this.domNode);
            this.domNode.classList.remove(this.statics.className);
        }
    }
    optimize() {
        // @ts-expect-error
        super.optimize(...arguments);
        if (!$d6878c049d90f631$var$TokenAttributor.value(this.domNode)) this.unwrap();
    }
}
$d6878c049d90f631$export$9460eee64f276be7.blotName = 'code-token';
$d6878c049d90f631$export$9460eee64f276be7.className = 'ql-token';
class $d6878c049d90f631$export$6c415d1fdae3dfdb extends (0, $W91pZ.default) {
    static create(value) {
        const domNode = super.create(value);
        if (typeof value === 'string') domNode.setAttribute('data-language', value);
        return domNode;
    }
    static formats(domNode) {
        // @ts-expect-error
        return domNode.getAttribute('data-language') || 'plain';
    }
    static register() {}
    format(name, value) {
        if (name === this.statics.blotName && value) // @ts-expect-error
        this.domNode.setAttribute('data-language', value);
        else super.format(name, value);
    }
    replaceWith(name, value) {
        this.formatAt(0, this.length(), $d6878c049d90f631$export$9460eee64f276be7.blotName, false);
        return super.replaceWith(name, value);
    }
}
class $d6878c049d90f631$var$SyntaxCodeBlockContainer extends (0, $W91pZ.CodeBlockContainer) {
    attach() {
        super.attach();
        this.forceNext = false;
        // @ts-expect-error
        this.scroll.emitMount(this);
    }
    format(name, value) {
        if (name === $d6878c049d90f631$export$6c415d1fdae3dfdb.blotName) {
            this.forceNext = true;
            this.children.forEach((child)=>{
                // @ts-expect-error
                child.format(name, value);
            });
        }
    }
    formatAt(index, length, name, value) {
        if (name === $d6878c049d90f631$export$6c415d1fdae3dfdb.blotName) this.forceNext = true;
        super.formatAt(index, length, name, value);
    }
    highlight(highlight) {
        let forced = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (this.children.head == null) return;
        const nodes = Array.from(this.domNode.childNodes).filter((node)=>node !== this.uiNode);
        const text = `${nodes.map((node)=>node.textContent).join('\n')}\n`;
        const language = $d6878c049d90f631$export$6c415d1fdae3dfdb.formats(this.children.head.domNode);
        if (forced || this.forceNext || this.cachedText !== text) {
            if (text.trim().length > 0 || this.cachedText == null) {
                const oldDelta = this.children.reduce((delta, child)=>{
                    // @ts-expect-error
                    return delta.concat((0, $jUBfi.blockDelta)(child, false));
                }, new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))());
                const delta = highlight(text, language);
                oldDelta.diff(delta).reduce((index, _ref)=>{
                    let { retain: retain, attributes: attributes } = _ref;
                    // Should be all retains
                    if (!retain) return index;
                    if (attributes) Object.keys(attributes).forEach((format)=>{
                        if ([
                            $d6878c049d90f631$export$6c415d1fdae3dfdb.blotName,
                            $d6878c049d90f631$export$9460eee64f276be7.blotName
                        ].includes(format)) // @ts-expect-error
                        this.formatAt(index, retain, format, attributes[format]);
                    });
                    // @ts-expect-error
                    return index + retain;
                }, 0);
            }
            this.cachedText = text;
            this.forceNext = false;
        }
    }
    html(index, length) {
        const [codeBlock] = this.children.find(index);
        const language = codeBlock ? $d6878c049d90f631$export$6c415d1fdae3dfdb.formats(codeBlock.domNode) : 'plain';
        return `<pre data-language="${language}">\n${(0, $l6ueR.escapeText)(this.code(index, length))}\n</pre>`;
    }
    optimize(context) {
        super.optimize(context);
        if (this.parent != null && this.children.head != null && this.uiNode != null) {
            const language = $d6878c049d90f631$export$6c415d1fdae3dfdb.formats(this.children.head.domNode);
            // @ts-expect-error
            if (language !== this.uiNode.value) // @ts-expect-error
            this.uiNode.value = language;
        }
    }
}
$d6878c049d90f631$var$SyntaxCodeBlockContainer.allowedChildren = [
    $d6878c049d90f631$export$6c415d1fdae3dfdb
];
$d6878c049d90f631$export$6c415d1fdae3dfdb.requiredContainer = $d6878c049d90f631$var$SyntaxCodeBlockContainer;
$d6878c049d90f631$export$6c415d1fdae3dfdb.allowedChildren = [
    $d6878c049d90f631$export$9460eee64f276be7,
    (0, $9VFAE.default),
    (0, $l6ueR.default),
    (0, $gkqQr.default)
];
const $d6878c049d90f631$var$highlight = (lib, language, text)=>{
    if (typeof lib.versionString === 'string') {
        const majorVersion = lib.versionString.split('.')[0];
        if (parseInt(majorVersion, 10) >= 11) return lib.highlight(text, {
            language: language
        }).value;
    }
    return lib.highlight(language, text).value;
};
class $d6878c049d90f631$export$2e2bcd8739ae039 extends (0, $43smM.default) {
    static register() {
        (0, $ePuKS.default).register($d6878c049d90f631$export$9460eee64f276be7, true);
        (0, $ePuKS.default).register($d6878c049d90f631$export$6c415d1fdae3dfdb, true);
        (0, $ePuKS.default).register($d6878c049d90f631$var$SyntaxCodeBlockContainer, true);
    }
    constructor(quill, options){
        super(quill, options);
        if (this.options.hljs == null) throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
        // @ts-expect-error Fix me later
        this.languages = this.options.languages.reduce((memo, _ref2)=>{
            let { key: key } = _ref2;
            memo[key] = true;
            return memo;
        }, {});
        this.highlightBlot = this.highlightBlot.bind(this);
        this.initListener();
        this.initTimer();
    }
    initListener() {
        this.quill.on((0, $ePuKS.default).events.SCROLL_BLOT_MOUNT, (blot)=>{
            if (!(blot instanceof $d6878c049d90f631$var$SyntaxCodeBlockContainer)) return;
            const select = this.quill.root.ownerDocument.createElement('select');
            // @ts-expect-error Fix me later
            this.options.languages.forEach((_ref3)=>{
                let { key: key, label: label } = _ref3;
                const option = select.ownerDocument.createElement('option');
                option.textContent = label;
                option.setAttribute('value', key);
                select.appendChild(option);
            });
            select.addEventListener('change', ()=>{
                blot.format($d6878c049d90f631$export$6c415d1fdae3dfdb.blotName, select.value);
                this.quill.root.focus(); // Prevent scrolling
                this.highlight(blot, true);
            });
            if (blot.uiNode == null) {
                blot.attachUI(select);
                if (blot.children.head) select.value = $d6878c049d90f631$export$6c415d1fdae3dfdb.formats(blot.children.head.domNode);
            }
        });
    }
    initTimer() {
        let timer = null;
        this.quill.on((0, $ePuKS.default).events.SCROLL_OPTIMIZE, ()=>{
            if (timer) clearTimeout(timer);
            timer = setTimeout(()=>{
                this.highlight();
                timer = null;
            }, this.options.interval);
        });
    }
    highlight() {
        let blot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (this.quill.selection.composing) return;
        this.quill.update((0, $ePuKS.default).sources.USER);
        const range = this.quill.getSelection();
        const blots = blot == null ? this.quill.scroll.descendants($d6878c049d90f631$var$SyntaxCodeBlockContainer) : [
            blot
        ];
        blots.forEach((container)=>{
            container.highlight(this.highlightBlot, force);
        });
        this.quill.update((0, $ePuKS.default).sources.SILENT);
        if (range != null) this.quill.setSelection(range, (0, $ePuKS.default).sources.SILENT);
    }
    highlightBlot(text) {
        let language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'plain';
        language = this.languages[language] ? language : 'plain';
        if (language === 'plain') return (0, $l6ueR.escapeText)(text).split('\n').reduce((delta, line, i)=>{
            if (i !== 0) delta.insert('\n', {
                [(0, $W91pZ.default).blotName]: language
            });
            return delta.insert(line);
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))());
        const container = this.quill.root.ownerDocument.createElement('div');
        container.classList.add((0, $W91pZ.default).className);
        container.innerHTML = $d6878c049d90f631$var$highlight(this.options.hljs, language, text);
        return (0, $jQ3Vn.traverse)(this.quill.scroll, container, [
            (node, delta)=>{
                // @ts-expect-error
                const value = $d6878c049d90f631$var$TokenAttributor.value(node);
                if (value) return delta.compose(new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().retain(delta.length(), {
                    [$d6878c049d90f631$export$9460eee64f276be7.blotName]: value
                }));
                return delta;
            }
        ], [
            (node, delta)=>{
                // @ts-expect-error
                return node.data.split('\n').reduce((memo, nodeText, i)=>{
                    if (i !== 0) memo.insert('\n', {
                        [(0, $W91pZ.default).blotName]: language
                    });
                    return memo.insert(nodeText);
                }, delta);
            }
        ], new WeakMap());
    }
}
$d6878c049d90f631$export$2e2bcd8739ae039.DEFAULTS = {
    hljs: (()=>{
        return window.hljs;
    })(),
    interval: 1000,
    languages: [
        {
            key: 'plain',
            label: 'Plain'
        },
        {
            key: 'bash',
            label: 'Bash'
        },
        {
            key: 'cpp',
            label: 'C++'
        },
        {
            key: 'cs',
            label: 'C#'
        },
        {
            key: 'css',
            label: 'CSS'
        },
        {
            key: 'diff',
            label: 'Diff'
        },
        {
            key: 'xml',
            label: 'HTML/XML'
        },
        {
            key: 'java',
            label: 'Java'
        },
        {
            key: 'javascript',
            label: 'JavaScript'
        },
        {
            key: 'markdown',
            label: 'Markdown'
        },
        {
            key: 'php',
            label: 'PHP'
        },
        {
            key: 'python',
            label: 'Python'
        },
        {
            key: 'ruby',
            label: 'Ruby'
        },
        {
            key: 'sql',
            label: 'SQL'
        }
    ]
};

});

parcelRegister("3GLge", function(module, exports) {

$parcel$export(module.exports, "default", () => $2af9f45f302265a6$export$2e2bcd8739ae039);

var $ehD63 = parcelRequire("ehD63");

var $ePuKS = parcelRequire("ePuKS");

var $43smM = parcelRequire("43smM");

var $iw1MQ = parcelRequire("iw1MQ");
class $2af9f45f302265a6$var$Table extends (0, $43smM.default) {
    static register() {
        (0, $ePuKS.default).register((0, $iw1MQ.TableCell));
        (0, $ePuKS.default).register((0, $iw1MQ.TableRow));
        (0, $ePuKS.default).register((0, $iw1MQ.TableBody));
        (0, $ePuKS.default).register((0, $iw1MQ.TableContainer));
    }
    constructor(){
        super(...arguments);
        this.listenBalanceCells();
    }
    balanceTables() {
        this.quill.scroll.descendants((0, $iw1MQ.TableContainer)).forEach((table)=>{
            table.balanceCells();
        });
    }
    deleteColumn() {
        const [table, , cell] = this.getTable();
        if (cell == null) return;
        // @ts-expect-error
        table.deleteColumn(cell.cellOffset());
        this.quill.update((0, $ePuKS.default).sources.USER);
    }
    deleteRow() {
        const [, row] = this.getTable();
        if (row == null) return;
        row.remove();
        this.quill.update((0, $ePuKS.default).sources.USER);
    }
    deleteTable() {
        const [table] = this.getTable();
        if (table == null) return;
        // @ts-expect-error
        const offset = table.offset();
        // @ts-expect-error
        table.remove();
        this.quill.update((0, $ePuKS.default).sources.USER);
        this.quill.setSelection(offset, (0, $ePuKS.default).sources.SILENT);
    }
    getTable() {
        let range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.quill.getSelection();
        if (range == null) return [
            null,
            null,
            null,
            -1
        ];
        const [cell, offset] = this.quill.getLine(range.index);
        if (cell == null || cell.statics.blotName !== (0, $iw1MQ.TableCell).blotName) return [
            null,
            null,
            null,
            -1
        ];
        const row = cell.parent;
        const table = row.parent.parent;
        // @ts-expect-error
        return [
            table,
            row,
            cell,
            offset
        ];
    }
    insertColumn(offset) {
        const range = this.quill.getSelection();
        if (!range) return;
        const [table, row, cell] = this.getTable(range);
        if (cell == null) return;
        const column = cell.cellOffset();
        table.insertColumn(column + offset);
        this.quill.update((0, $ePuKS.default).sources.USER);
        let shift = row.rowOffset();
        if (offset === 0) shift += 1;
        this.quill.setSelection(range.index + shift, range.length, (0, $ePuKS.default).sources.SILENT);
    }
    insertColumnLeft() {
        this.insertColumn(0);
    }
    insertColumnRight() {
        this.insertColumn(1);
    }
    insertRow(offset) {
        const range = this.quill.getSelection();
        if (!range) return;
        const [table, row, cell] = this.getTable(range);
        if (cell == null) return;
        const index = row.rowOffset();
        table.insertRow(index + offset);
        this.quill.update((0, $ePuKS.default).sources.USER);
        if (offset > 0) this.quill.setSelection(range, (0, $ePuKS.default).sources.SILENT);
        else this.quill.setSelection(range.index + row.children.length, range.length, (0, $ePuKS.default).sources.SILENT);
    }
    insertRowAbove() {
        this.insertRow(0);
    }
    insertRowBelow() {
        this.insertRow(1);
    }
    insertTable(rows, columns) {
        const range = this.quill.getSelection();
        if (range == null) return;
        const delta = new Array(rows).fill(0).reduce((memo)=>{
            const text = new Array(columns).fill('\n').join('');
            return memo.insert(text, {
                table: (0, $iw1MQ.tableId)()
            });
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))().retain(range.index));
        this.quill.updateContents(delta, (0, $ePuKS.default).sources.USER);
        this.quill.setSelection(range.index, (0, $ePuKS.default).sources.SILENT);
        this.balanceTables();
    }
    listenBalanceCells() {
        this.quill.on((0, $ePuKS.default).events.SCROLL_OPTIMIZE, (mutations)=>{
            mutations.some((mutation)=>{
                if ([
                    'TD',
                    'TR',
                    'TBODY',
                    'TABLE'
                ].includes(mutation.target.tagName)) {
                    this.quill.once((0, $ePuKS.default).events.TEXT_CHANGE, (delta, old, source)=>{
                        if (source !== (0, $ePuKS.default).sources.USER) return;
                        this.balanceTables();
                    });
                    return true;
                }
                return false;
            });
        });
    }
}
var $2af9f45f302265a6$export$2e2bcd8739ae039 = $2af9f45f302265a6$var$Table;

});
parcelRegister("iw1MQ", function(module, exports) {

$parcel$export(module.exports, "TableCell", () => $d7ac99fc59d00b5d$export$1e4baea7053fc0e3);
$parcel$export(module.exports, "tableId", () => $d7ac99fc59d00b5d$export$9bd6f73cbe857f1b);
$parcel$export(module.exports, "TableRow", () => $d7ac99fc59d00b5d$export$b05581f4e764e162);
$parcel$export(module.exports, "TableBody", () => $d7ac99fc59d00b5d$export$76ccd210b9029917);
$parcel$export(module.exports, "TableContainer", () => $d7ac99fc59d00b5d$export$f2c3aea42b2a048f);

var $jUBfi = parcelRequire("jUBfi");

var $BNn3z = parcelRequire("BNn3z");
class $d7ac99fc59d00b5d$export$1e4baea7053fc0e3 extends (0, $jUBfi.default) {
    static blotName = 'table';
    static tagName = 'TD';
    static create(value) {
        const node = super.create();
        if (value) node.setAttribute('data-row', value);
        else node.setAttribute('data-row', $d7ac99fc59d00b5d$export$9bd6f73cbe857f1b());
        return node;
    }
    static formats(domNode) {
        if (domNode.hasAttribute('data-row')) return domNode.getAttribute('data-row');
        return undefined;
    }
    cellOffset() {
        if (this.parent) return this.parent.children.indexOf(this);
        return -1;
    }
    format(name, value) {
        if (name === $d7ac99fc59d00b5d$export$1e4baea7053fc0e3.blotName && value) this.domNode.setAttribute('data-row', value);
        else super.format(name, value);
    }
    row() {
        return this.parent;
    }
    rowOffset() {
        if (this.row()) return this.row().rowOffset();
        return -1;
    }
    table() {
        return this.row() && this.row().table();
    }
}
class $d7ac99fc59d00b5d$export$b05581f4e764e162 extends (0, $BNn3z.default) {
    static blotName = 'table-row';
    static tagName = 'TR';
    checkMerge() {
        // @ts-expect-error
        if (super.checkMerge() && this.next.children.head != null) {
            // @ts-expect-error
            const thisHead = this.children.head.formats();
            // @ts-expect-error
            const thisTail = this.children.tail.formats();
            // @ts-expect-error
            const nextHead = this.next.children.head.formats();
            // @ts-expect-error
            const nextTail = this.next.children.tail.formats();
            return thisHead.table === thisTail.table && thisHead.table === nextHead.table && thisHead.table === nextTail.table;
        }
        return false;
    }
    optimize(context) {
        super.optimize(context);
        this.children.forEach((child)=>{
            if (child.next == null) return;
            const childFormats = child.formats();
            const nextFormats = child.next.formats();
            if (childFormats.table !== nextFormats.table) {
                const next = this.splitAfter(child);
                if (next) // @ts-expect-error TODO: parameters of optimize() should be a optional
                next.optimize();
                // We might be able to merge with prev now
                if (this.prev) // @ts-expect-error TODO: parameters of optimize() should be a optional
                this.prev.optimize();
            }
        });
    }
    rowOffset() {
        if (this.parent) return this.parent.children.indexOf(this);
        return -1;
    }
    table() {
        return this.parent && this.parent.parent;
    }
}
class $d7ac99fc59d00b5d$export$76ccd210b9029917 extends (0, $BNn3z.default) {
    static blotName = 'table-body';
    static tagName = 'TBODY';
}
class $d7ac99fc59d00b5d$export$f2c3aea42b2a048f extends (0, $BNn3z.default) {
    static blotName = 'table-container';
    static tagName = 'TABLE';
    balanceCells() {
        const rows = this.descendants($d7ac99fc59d00b5d$export$b05581f4e764e162);
        const maxColumns = rows.reduce((max, row)=>{
            return Math.max(row.children.length, max);
        }, 0);
        rows.forEach((row)=>{
            new Array(maxColumns - row.children.length).fill(0).forEach(()=>{
                let value;
                if (row.children.head != null) value = $d7ac99fc59d00b5d$export$1e4baea7053fc0e3.formats(row.children.head.domNode);
                const blot = this.scroll.create($d7ac99fc59d00b5d$export$1e4baea7053fc0e3.blotName, value);
                row.appendChild(blot);
                // @ts-expect-error TODO: parameters of optimize() should be a optional
                blot.optimize(); // Add break blot
            });
        });
    }
    cells(column) {
        return this.rows().map((row)=>row.children.at(column));
    }
    deleteColumn(index) {
        // @ts-expect-error
        const [body] = this.descendant($d7ac99fc59d00b5d$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        body.children.forEach((row)=>{
            const cell = row.children.at(index);
            if (cell != null) cell.remove();
        });
    }
    insertColumn(index) {
        // @ts-expect-error
        const [body] = this.descendant($d7ac99fc59d00b5d$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        body.children.forEach((row)=>{
            const ref = row.children.at(index);
            // @ts-expect-error
            const value = $d7ac99fc59d00b5d$export$1e4baea7053fc0e3.formats(row.children.head.domNode);
            const cell = this.scroll.create($d7ac99fc59d00b5d$export$1e4baea7053fc0e3.blotName, value);
            row.insertBefore(cell, ref);
        });
    }
    insertRow(index) {
        // @ts-expect-error
        const [body] = this.descendant($d7ac99fc59d00b5d$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        const id = $d7ac99fc59d00b5d$export$9bd6f73cbe857f1b();
        const row = this.scroll.create($d7ac99fc59d00b5d$export$b05581f4e764e162.blotName);
        body.children.head.children.forEach(()=>{
            const cell = this.scroll.create($d7ac99fc59d00b5d$export$1e4baea7053fc0e3.blotName, id);
            row.appendChild(cell);
        });
        const ref = body.children.at(index);
        body.insertBefore(row, ref);
    }
    rows() {
        const body = this.children.head;
        if (body == null) return [];
        return body.children.map((row)=>row);
    }
}
$d7ac99fc59d00b5d$export$f2c3aea42b2a048f.allowedChildren = [
    $d7ac99fc59d00b5d$export$76ccd210b9029917
];
$d7ac99fc59d00b5d$export$76ccd210b9029917.requiredContainer = $d7ac99fc59d00b5d$export$f2c3aea42b2a048f;
$d7ac99fc59d00b5d$export$76ccd210b9029917.allowedChildren = [
    $d7ac99fc59d00b5d$export$b05581f4e764e162
];
$d7ac99fc59d00b5d$export$b05581f4e764e162.requiredContainer = $d7ac99fc59d00b5d$export$76ccd210b9029917;
$d7ac99fc59d00b5d$export$b05581f4e764e162.allowedChildren = [
    $d7ac99fc59d00b5d$export$1e4baea7053fc0e3
];
$d7ac99fc59d00b5d$export$1e4baea7053fc0e3.requiredContainer = $d7ac99fc59d00b5d$export$b05581f4e764e162;
function $d7ac99fc59d00b5d$export$9bd6f73cbe857f1b() {
    const id = Math.random().toString(36).slice(2, 6);
    return `row-${id}`;
}

});


parcelRegister("04AhF", function(module, exports) {

$parcel$export(module.exports, "default", () => $00dc8513aace9765$export$2e2bcd8739ae039);

var $ehD63 = parcelRequire("ehD63");

var $45gdf = parcelRequire("45gdf");

var $ePuKS = parcelRequire("ePuKS");

var $dwJXH = parcelRequire("dwJXH");

var $43smM = parcelRequire("43smM");
const $00dc8513aace9765$var$debug = (0, $dwJXH.default)('quill:toolbar');
class $00dc8513aace9765$export$2e2bcd8739ae039 extends (0, $43smM.default) {
    constructor(quill, options){
        super(quill, options);
        if (Array.isArray(this.options.container)) {
            const container = document.createElement('div');
            container.setAttribute('role', 'toolbar');
            $00dc8513aace9765$export$faadaf0198b97fbe(container, this.options.container);
            quill.container?.parentNode?.insertBefore(container, quill.container);
            this.container = container;
        } else if (typeof this.options.container === 'string') this.container = document.querySelector(this.options.container);
        else this.container = this.options.container;
        if (!(this.container instanceof HTMLElement)) {
            $00dc8513aace9765$var$debug.error('Container required for toolbar', this.options);
            return;
        }
        this.container.classList.add('ql-toolbar');
        this.controls = [];
        this.handlers = {};
        if (this.options.handlers) Object.keys(this.options.handlers).forEach((format)=>{
            const handler = this.options.handlers?.[format];
            if (handler) this.addHandler(format, handler);
        });
        Array.from(this.container.querySelectorAll('button, select')).forEach((input)=>{
            // @ts-expect-error
            this.attach(input);
        });
        this.quill.on((0, $ePuKS.default).events.EDITOR_CHANGE, ()=>{
            const [range] = this.quill.selection.getRange(); // quill.getSelection triggers update
            this.update(range);
        });
    }
    addHandler(format, handler) {
        this.handlers[format] = handler;
    }
    attach(input) {
        let format = Array.from(input.classList).find((className)=>{
            return className.indexOf('ql-') === 0;
        });
        if (!format) return;
        format = format.slice(3);
        if (input.tagName === 'BUTTON') input.setAttribute('type', 'button');
        if (this.handlers[format] == null && this.quill.scroll.query(format) == null) {
            $00dc8513aace9765$var$debug.warn('ignoring attaching to nonexistent format', format, input);
            return;
        }
        const eventName = input.tagName === 'SELECT' ? 'change' : 'click';
        input.addEventListener(eventName, (e)=>{
            let value;
            if (input.tagName === 'SELECT') {
                // @ts-expect-error
                if (input.selectedIndex < 0) return;
                // @ts-expect-error
                const selected = input.options[input.selectedIndex];
                if (selected.hasAttribute('selected')) value = false;
                else value = selected.value || false;
            } else {
                if (input.classList.contains('ql-active')) value = false;
                else // @ts-expect-error
                value = input.value || !input.hasAttribute('value');
                e.preventDefault();
            }
            this.quill.focus();
            const [range] = this.quill.selection.getRange();
            if (this.handlers[format] != null) this.handlers[format].call(this, value);
            else if (// @ts-expect-error
            this.quill.scroll.query(format).prototype instanceof (0, $45gdf.EmbedBlot)) {
                value = prompt(`Enter ${format}`); // eslint-disable-line no-alert
                if (!value) return;
                this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($ehD63)))()// @ts-expect-error Fix me later
                .retain(range.index)// @ts-expect-error Fix me later
                .delete(range.length).insert({
                    [format]: value
                }), (0, $ePuKS.default).sources.USER);
            } else this.quill.format(format, value, (0, $ePuKS.default).sources.USER);
            this.update(range);
        });
        this.controls.push([
            format,
            input
        ]);
    }
    update(range) {
        const formats = range == null ? {} : this.quill.getFormat(range);
        this.controls.forEach((pair)=>{
            const [format, input] = pair;
            if (input.tagName === 'SELECT') {
                let option = null;
                if (range == null) option = null;
                else if (formats[format] == null) option = input.querySelector('option[selected]');
                else if (!Array.isArray(formats[format])) {
                    let value = formats[format];
                    if (typeof value === 'string') value = value.replace(/"/g, '\\"');
                    option = input.querySelector(`option[value="${value}"]`);
                }
                if (option == null) {
                    // @ts-expect-error TODO fix me later
                    input.value = ''; // TODO make configurable?
                    // @ts-expect-error TODO fix me later
                    input.selectedIndex = -1;
                } else option.selected = true;
            } else if (range == null) {
                input.classList.remove('ql-active');
                input.setAttribute('aria-pressed', 'false');
            } else if (input.hasAttribute('value')) {
                // both being null should match (default values)
                // '1' should match with 1 (headers)
                const value = formats[format];
                const isActive = value === input.getAttribute('value') || value != null && value.toString() === input.getAttribute('value') || value == null && !input.getAttribute('value');
                input.classList.toggle('ql-active', isActive);
                input.setAttribute('aria-pressed', isActive.toString());
            } else {
                const isActive = formats[format] != null;
                input.classList.toggle('ql-active', isActive);
                input.setAttribute('aria-pressed', isActive.toString());
            }
        });
    }
}
$00dc8513aace9765$export$2e2bcd8739ae039.DEFAULTS = {};
function $00dc8513aace9765$var$addButton(container, format, value) {
    const input = document.createElement('button');
    input.setAttribute('type', 'button');
    input.classList.add(`ql-${format}`);
    input.setAttribute('aria-pressed', 'false');
    if (value != null) {
        input.value = value;
        input.setAttribute('aria-label', `${format}: ${value}`);
    } else input.setAttribute('aria-label', format);
    container.appendChild(input);
}
function $00dc8513aace9765$export$faadaf0198b97fbe(container, groups) {
    if (!Array.isArray(groups[0])) // @ts-expect-error
    groups = [
        groups
    ];
    groups.forEach((controls)=>{
        const group = document.createElement('span');
        group.classList.add('ql-formats');
        controls.forEach((control)=>{
            if (typeof control === 'string') $00dc8513aace9765$var$addButton(group, control);
            else {
                const format = Object.keys(control)[0];
                const value = control[format];
                if (Array.isArray(value)) $00dc8513aace9765$var$addSelect(group, format, value);
                else $00dc8513aace9765$var$addButton(group, format, value);
            }
        });
        container.appendChild(group);
    });
}
function $00dc8513aace9765$var$addSelect(container, format, values) {
    const input = document.createElement('select');
    input.classList.add(`ql-${format}`);
    values.forEach((value)=>{
        const option = document.createElement('option');
        if (value !== false) option.setAttribute('value', String(value));
        else option.setAttribute('selected', 'selected');
        input.appendChild(option);
    });
    container.appendChild(input);
}
$00dc8513aace9765$export$2e2bcd8739ae039.DEFAULTS = {
    container: null,
    handlers: {
        clean () {
            const range = this.quill.getSelection();
            if (range == null) return;
            if (range.length === 0) {
                const formats = this.quill.getFormat();
                Object.keys(formats).forEach((name)=>{
                    // Clean functionality in existing apps only clean inline formats
                    if (this.quill.scroll.query(name, (0, $45gdf.Scope).INLINE) != null) this.quill.format(name, false, (0, $ePuKS.default).sources.USER);
                });
            } else this.quill.removeFormat(range.index, range.length, (0, $ePuKS.default).sources.USER);
        },
        direction (value) {
            const { align: align } = this.quill.getFormat();
            if (value === 'rtl' && align == null) this.quill.format('align', 'right', (0, $ePuKS.default).sources.USER);
            else if (!value && align === 'right') this.quill.format('align', false, (0, $ePuKS.default).sources.USER);
            this.quill.format('direction', value, (0, $ePuKS.default).sources.USER);
        },
        indent (value) {
            const range = this.quill.getSelection();
            // @ts-expect-error
            const formats = this.quill.getFormat(range);
            // @ts-expect-error
            const indent = parseInt(formats.indent || 0, 10);
            if (value === '+1' || value === '-1') {
                let modifier = value === '+1' ? 1 : -1;
                if (formats.direction === 'rtl') modifier *= -1;
                this.quill.format('indent', indent + modifier, (0, $ePuKS.default).sources.USER);
            }
        },
        link (value) {
            if (value === true) value = prompt('Enter link URL:'); // eslint-disable-line no-alert
            this.quill.format('link', value, (0, $ePuKS.default).sources.USER);
        },
        list (value) {
            const range = this.quill.getSelection();
            // @ts-expect-error
            const formats = this.quill.getFormat(range);
            if (value === 'check') {
                if (formats.list === 'checked' || formats.list === 'unchecked') this.quill.format('list', false, (0, $ePuKS.default).sources.USER);
                else this.quill.format('list', 'unchecked', (0, $ePuKS.default).sources.USER);
            } else this.quill.format('list', value, (0, $ePuKS.default).sources.USER);
        }
    }
};

});

parcelRegister("lgElq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7ba6333c5570018$export$2e2bcd8739ae039);
const $f7ba6333c5570018$var$alignLeftIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"13\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"9\" y1=\"4\" y2=\"4\"/></svg>";
const $f7ba6333c5570018$var$alignCenterIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"14\" x2=\"4\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"12\" x2=\"6\" y1=\"4\" y2=\"4\"/></svg>";
const $f7ba6333c5570018$var$alignRightIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"5\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"9\" y1=\"4\" y2=\"4\"/></svg>";
const $f7ba6333c5570018$var$alignJustifyIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"4\" y2=\"4\"/></svg>";
const $f7ba6333c5570018$var$backgroundIcon = "<svg viewbox=\"0 0 18 18\"><g class=\"ql-fill ql-color-label\"><polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"/><rect height=\"1\" width=\"1\" x=\"4\" y=\"4\"/><polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"6\"/><rect height=\"1\" width=\"1\" x=\"3\" y=\"5\"/><rect height=\"1\" width=\"1\" x=\"4\" y=\"7\"/><polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"12\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"9\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"15\"/><polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"/><rect height=\"1\" width=\"1\" x=\"3\" y=\"8\"/><path d=\"M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z\"/><path d=\"M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z\"/><path d=\"M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z\"/><rect height=\"1\" width=\"1\" x=\"12\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"11\" y=\"3\"/><path d=\"M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"3\"/><rect height=\"1\" width=\"1\" x=\"6\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"3\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"5\" y=\"3\"/><rect height=\"1\" width=\"1\" x=\"9\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"14\"/><polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"/><rect height=\"1\" width=\"1\" x=\"13\" y=\"7\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"5\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"6\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"8\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"9\"/><path d=\"M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"3\"/><polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"12\" y=\"5\"/><rect height=\"1\" width=\"1\" x=\"13\" y=\"4\"/><polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"/><rect height=\"1\" width=\"1\" x=\"9\" y=\"14\"/><rect height=\"1\" width=\"1\" x=\"8\" y=\"15\"/><path d=\"M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z\"/><rect height=\"1\" width=\"1\" x=\"5\" y=\"15\"/><path d=\"M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z\"/><rect height=\"1\" width=\"1\" x=\"11\" y=\"15\"/><path d=\"M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"15\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"11\"/></g><polyline class=\"ql-stroke\" points=\"5.5 13 9 5 12.5 13\"/><line class=\"ql-stroke\" x1=\"11.63\" x2=\"6.38\" y1=\"11\" y2=\"11\"/></svg>";
const $f7ba6333c5570018$var$blockquoteIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-fill ql-stroke\" height=\"3\" width=\"3\" x=\"4\" y=\"5\"/><rect class=\"ql-fill ql-stroke\" height=\"3\" width=\"3\" x=\"11\" y=\"5\"/><path class=\"ql-even ql-fill ql-stroke\" d=\"M7,8c0,4.031-3,5-3,5\"/><path class=\"ql-even ql-fill ql-stroke\" d=\"M14,8c0,4.031-3,5-3,5\"/></svg>";
const $f7ba6333c5570018$var$boldIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-stroke\" d=\"M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z\"/><path class=\"ql-stroke\" d=\"M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z\"/></svg>";
const $f7ba6333c5570018$var$cleanIcon = "<svg class=\"\" viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"5\" x2=\"13\" y1=\"3\" y2=\"3\"/><line class=\"ql-stroke\" x1=\"6\" x2=\"9.35\" y1=\"12\" y2=\"3\"/><line class=\"ql-stroke\" x1=\"11\" x2=\"15\" y1=\"11\" y2=\"15\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"11\" y1=\"11\" y2=\"15\"/><rect class=\"ql-fill\" height=\"1\" rx=\"0.5\" ry=\"0.5\" width=\"7\" x=\"2\" y=\"14\"/></svg>";
const $f7ba6333c5570018$var$codeIcon = "<svg viewbox=\"0 0 18 18\"><polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"/><polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"/><line class=\"ql-stroke\" x1=\"10\" x2=\"8\" y1=\"5\" y2=\"13\"/></svg>";
const $f7ba6333c5570018$var$colorIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-color-label ql-stroke ql-transparent\" x1=\"3\" x2=\"15\" y1=\"15\" y2=\"15\"/><polyline class=\"ql-stroke\" points=\"5.5 11 9 3 12.5 11\"/><line class=\"ql-stroke\" x1=\"11.63\" x2=\"6.38\" y1=\"9\" y2=\"9\"/></svg>";
const $f7ba6333c5570018$var$directionLeftToRightIcon = "<svg viewbox=\"0 0 18 18\"><polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"/><line class=\"ql-stroke ql-fill\" x1=\"15\" x2=\"11\" y1=\"4\" y2=\"4\"/><path class=\"ql-fill\" d=\"M11,3a3,3,0,0,0,0,6h1V3H11Z\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"11\" y=\"4\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"13\" y=\"4\"/></svg>";
const $f7ba6333c5570018$var$directionRightToLeftIcon = "<svg viewbox=\"0 0 18 18\"><polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"/><line class=\"ql-stroke ql-fill\" x1=\"9\" x2=\"5\" y1=\"4\" y2=\"4\"/><path class=\"ql-fill\" d=\"M5,3A3,3,0,0,0,5,9H6V3H5Z\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"5\" y=\"4\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"7\" y=\"4\"/></svg>";
const $f7ba6333c5570018$var$formulaIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z\"/><rect class=\"ql-fill\" height=\"1.6\" rx=\"0.8\" ry=\"0.8\" width=\"5\" x=\"5.15\" y=\"6.2\"/><path class=\"ql-fill\" d=\"M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z\"/></svg>";
const $f7ba6333c5570018$var$headerIcon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z\"/></svg>";
const $f7ba6333c5570018$var$header2Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z\"/></svg>";
const $f7ba6333c5570018$var$header3Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M16.65186,12.30664a2.6742,2.6742,0,0,1-2.915,2.68457,3.96592,3.96592,0,0,1-2.25537-.6709.56007.56007,0,0,1-.13232-.83594L11.64648,13c.209-.34082.48389-.36328.82471-.1543a2.32654,2.32654,0,0,0,1.12256.33008c.71484,0,1.12207-.35156,1.12207-.78125,0-.61523-.61621-.86816-1.46338-.86816H13.2085a.65159.65159,0,0,1-.68213-.41895l-.05518-.10937a.67114.67114,0,0,1,.14307-.78125l.71533-.86914a8.55289,8.55289,0,0,1,.68213-.7373V8.58887a3.93913,3.93913,0,0,1-.748.05469H11.9873a.54085.54085,0,0,1-.605-.60547V7.59863a.54085.54085,0,0,1,.605-.60547h3.75146a.53773.53773,0,0,1,.60547.59375v.17676a1.03723,1.03723,0,0,1-.27539.748L14.74854,10.0293A2.31132,2.31132,0,0,1,16.65186,12.30664ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z\"/></svg>";
const $f7ba6333c5570018$var$header4Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm7.05371,7.96582v.38477c0,.39648-.165.60547-.46191.60547h-.47314v1.29785a.54085.54085,0,0,1-.605.60547h-.69336a.54085.54085,0,0,1-.605-.60547V12.95605H11.333a.5412.5412,0,0,1-.60547-.60547v-.15332a1.199,1.199,0,0,1,.22021-.748l2.56348-4.05957a.7819.7819,0,0,1,.72607-.39648h1.27637a.54085.54085,0,0,1,.605.60547v3.7627h.33008A.54055.54055,0,0,1,17.05371,11.96582ZM14.28125,8.7207h-.022a4.18969,4.18969,0,0,1-.38525.81348l-1.188,1.80469v.02246h1.5293V9.60059A7.04058,7.04058,0,0,1,14.28125,8.7207Z\"/></svg>";
const $f7ba6333c5570018$var$header5Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M16.74023,12.18555a2.75131,2.75131,0,0,1-2.91553,2.80566,3.908,3.908,0,0,1-2.25537-.68164.54809.54809,0,0,1-.13184-.8252L11.73438,13c.209-.34082.48389-.36328.8252-.1543a2.23757,2.23757,0,0,0,1.1001.33008,1.01827,1.01827,0,0,0,1.1001-.96777c0-.61621-.53906-.97949-1.25439-.97949a2.15554,2.15554,0,0,0-.64893.09961,1.15209,1.15209,0,0,1-.814.01074l-.12109-.04395a.64116.64116,0,0,1-.45117-.71484l.231-3.00391a.56666.56666,0,0,1,.62744-.583H15.541a.54085.54085,0,0,1,.605.60547v.43945a.54085.54085,0,0,1-.605.60547H13.41748l-.04395.72559a1.29306,1.29306,0,0,1-.04395.30859h.022a2.39776,2.39776,0,0,1,.57227-.07715A2.53266,2.53266,0,0,1,16.74023,12.18555ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z\"/></svg>";
const $f7ba6333c5570018$var$header6Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M14.51758,9.64453a1.85627,1.85627,0,0,0-1.24316.38477H13.252a1.73532,1.73532,0,0,1,1.72754-1.4082,2.66491,2.66491,0,0,1,.5498.06641c.35254.05469.57227.01074.70508-.40723l.16406-.5166a.53393.53393,0,0,0-.373-.75977,4.83723,4.83723,0,0,0-1.17773-.14258c-2.43164,0-3.7627,2.17773-3.7627,4.43359,0,2.47559,1.60645,3.69629,3.19043,3.69629A2.70585,2.70585,0,0,0,16.96,12.19727,2.43861,2.43861,0,0,0,14.51758,9.64453Zm-.23047,3.58691c-.67187,0-1.22168-.81445-1.22168-1.45215,0-.47363.30762-.583.72559-.583.96875,0,1.27734.59375,1.27734,1.12207A.82182.82182,0,0,1,14.28711,13.23145ZM10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Z\"/></svg>";
const $f7ba6333c5570018$var$italicIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"7\" x2=\"13\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"5\" x2=\"11\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"8\" x2=\"10\" y1=\"14\" y2=\"4\"/></svg>";
const $f7ba6333c5570018$var$imageIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-stroke\" height=\"10\" width=\"12\" x=\"3\" y=\"4\"/><circle class=\"ql-fill\" cx=\"6\" cy=\"7\" r=\"1\"/><polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"/></svg>";
const $f7ba6333c5570018$var$indentIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"9\" y2=\"9\"/><polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"/></svg>";
const $f7ba6333c5570018$var$outdentIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"9\" y2=\"9\"/><polyline class=\"ql-stroke\" points=\"5 7 5 11 3 9 5 7\"/></svg>";
const $f7ba6333c5570018$var$linkIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"7\" x2=\"11\" y1=\"7\" y2=\"11\"/><path class=\"ql-even ql-stroke\" d=\"M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z\"/><path class=\"ql-even ql-stroke\" d=\"M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z\"/></svg>";
const $f7ba6333c5570018$var$listBulletIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"6\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"6\" x2=\"15\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"6\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"3\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"3\" y1=\"14\" y2=\"14\"/></svg>";
const $f7ba6333c5570018$var$listCheckIcon = "<svg class=\"\" viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"4\" y2=\"4\"/><polyline class=\"ql-stroke\" points=\"3 4 4 5 6 3\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"14\" y2=\"14\"/><polyline class=\"ql-stroke\" points=\"3 14 4 15 6 13\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"9\" y2=\"9\"/><polyline class=\"ql-stroke\" points=\"3 9 4 10 6 8\"/></svg>";
const $f7ba6333c5570018$var$listOrderedIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"7\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"7\" x2=\"15\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"7\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke ql-thin\" x1=\"2.5\" x2=\"4.5\" y1=\"5.5\" y2=\"5.5\"/><path class=\"ql-fill\" d=\"M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z\"/><path class=\"ql-stroke ql-thin\" d=\"M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156\"/><path class=\"ql-stroke ql-thin\" d=\"M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109\"/></svg>";
const $f7ba6333c5570018$var$subscriptIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z\"/><path class=\"ql-fill\" d=\"M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z\"/></svg>";
const $f7ba6333c5570018$var$superscriptIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z\"/><path class=\"ql-fill\" d=\"M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z\"/></svg>";
const $f7ba6333c5570018$var$strikeIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke ql-thin\" x1=\"15.5\" x2=\"2.5\" y1=\"8.5\" y2=\"9.5\"/><path class=\"ql-fill\" d=\"M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z\"/><path class=\"ql-fill\" d=\"M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z\"/></svg>";
const $f7ba6333c5570018$var$tableIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-stroke\" height=\"12\" width=\"12\" x=\"3\" y=\"3\"/><rect class=\"ql-fill\" height=\"2\" width=\"3\" x=\"5\" y=\"5\"/><rect class=\"ql-fill\" height=\"2\" width=\"4\" x=\"9\" y=\"5\"/><g class=\"ql-fill ql-transparent\"><rect height=\"2\" width=\"3\" x=\"5\" y=\"8\"/><rect height=\"2\" width=\"4\" x=\"9\" y=\"8\"/><rect height=\"2\" width=\"3\" x=\"5\" y=\"11\"/><rect height=\"2\" width=\"4\" x=\"9\" y=\"11\"/></g></svg>";
const $f7ba6333c5570018$var$underlineIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-stroke\" d=\"M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3\"/><rect class=\"ql-fill\" height=\"1\" rx=\"0.5\" ry=\"0.5\" width=\"12\" x=\"3\" y=\"15\"/></svg>";
const $f7ba6333c5570018$var$videoIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-stroke\" height=\"12\" width=\"12\" x=\"3\" y=\"3\"/><rect class=\"ql-fill\" height=\"12\" width=\"1\" x=\"5\" y=\"3\"/><rect class=\"ql-fill\" height=\"12\" width=\"1\" x=\"12\" y=\"3\"/><rect class=\"ql-fill\" height=\"2\" width=\"8\" x=\"5\" y=\"8\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"5\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"7\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"10\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"12\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"5\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"7\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"10\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"12\"/></svg>";
var $f7ba6333c5570018$export$2e2bcd8739ae039 = {
    align: {
        '': $f7ba6333c5570018$var$alignLeftIcon,
        center: $f7ba6333c5570018$var$alignCenterIcon,
        right: $f7ba6333c5570018$var$alignRightIcon,
        justify: $f7ba6333c5570018$var$alignJustifyIcon
    },
    background: $f7ba6333c5570018$var$backgroundIcon,
    blockquote: $f7ba6333c5570018$var$blockquoteIcon,
    bold: $f7ba6333c5570018$var$boldIcon,
    clean: $f7ba6333c5570018$var$cleanIcon,
    code: $f7ba6333c5570018$var$codeIcon,
    'code-block': $f7ba6333c5570018$var$codeIcon,
    color: $f7ba6333c5570018$var$colorIcon,
    direction: {
        '': $f7ba6333c5570018$var$directionLeftToRightIcon,
        rtl: $f7ba6333c5570018$var$directionRightToLeftIcon
    },
    formula: $f7ba6333c5570018$var$formulaIcon,
    header: {
        '1': $f7ba6333c5570018$var$headerIcon,
        '2': $f7ba6333c5570018$var$header2Icon,
        '3': $f7ba6333c5570018$var$header3Icon,
        '4': $f7ba6333c5570018$var$header4Icon,
        '5': $f7ba6333c5570018$var$header5Icon,
        '6': $f7ba6333c5570018$var$header6Icon
    },
    italic: $f7ba6333c5570018$var$italicIcon,
    image: $f7ba6333c5570018$var$imageIcon,
    indent: {
        '+1': $f7ba6333c5570018$var$indentIcon,
        '-1': $f7ba6333c5570018$var$outdentIcon
    },
    link: $f7ba6333c5570018$var$linkIcon,
    list: {
        bullet: $f7ba6333c5570018$var$listBulletIcon,
        check: $f7ba6333c5570018$var$listCheckIcon,
        ordered: $f7ba6333c5570018$var$listOrderedIcon
    },
    script: {
        sub: $f7ba6333c5570018$var$subscriptIcon,
        super: $f7ba6333c5570018$var$superscriptIcon
    },
    strike: $f7ba6333c5570018$var$strikeIcon,
    table: $f7ba6333c5570018$var$tableIcon,
    underline: $f7ba6333c5570018$var$underlineIcon,
    video: $f7ba6333c5570018$var$videoIcon
};

});

parcelRegister("4bKc2", function(module, exports) {

$parcel$export(module.exports, "default", () => $30cc058624146cba$export$2e2bcd8739ae039);
const $30cc058624146cba$var$DropdownIcon = "<svg viewbox=\"0 0 18 18\"><polygon class=\"ql-stroke\" points=\"7 11 9 13 11 11 7 11\"/><polygon class=\"ql-stroke\" points=\"7 7 9 5 11 7 7 7\"/></svg>";
let $30cc058624146cba$var$optionsCounter = 0;
function $30cc058624146cba$var$toggleAriaAttribute(element, attribute) {
    element.setAttribute(attribute, `${!(element.getAttribute(attribute) === 'true')}`);
}
class $30cc058624146cba$var$Picker {
    constructor(select){
        this.select = select;
        this.container = document.createElement('span');
        this.buildPicker();
        this.select.style.display = 'none';
        // @ts-expect-error Fix me later
        this.select.parentNode.insertBefore(this.container, this.select);
        this.label.addEventListener('mousedown', ()=>{
            this.togglePicker();
        });
        this.label.addEventListener('keydown', (event)=>{
            switch(event.key){
                case 'Enter':
                    this.togglePicker();
                    break;
                case 'Escape':
                    this.escape();
                    event.preventDefault();
                    break;
                default:
            }
        });
        this.select.addEventListener('change', this.update.bind(this));
    }
    togglePicker() {
        this.container.classList.toggle('ql-expanded');
        // Toggle aria-expanded and aria-hidden to make the picker accessible
        $30cc058624146cba$var$toggleAriaAttribute(this.label, 'aria-expanded');
        // @ts-expect-error
        $30cc058624146cba$var$toggleAriaAttribute(this.options, 'aria-hidden');
    }
    buildItem(option) {
        const item = document.createElement('span');
        // @ts-expect-error
        item.tabIndex = '0';
        item.setAttribute('role', 'button');
        item.classList.add('ql-picker-item');
        const value = option.getAttribute('value');
        if (value) item.setAttribute('data-value', value);
        if (option.textContent) item.setAttribute('data-label', option.textContent);
        item.addEventListener('click', ()=>{
            this.selectItem(item, true);
        });
        item.addEventListener('keydown', (event)=>{
            switch(event.key){
                case 'Enter':
                    this.selectItem(item, true);
                    event.preventDefault();
                    break;
                case 'Escape':
                    this.escape();
                    event.preventDefault();
                    break;
                default:
            }
        });
        return item;
    }
    buildLabel() {
        const label = document.createElement('span');
        label.classList.add('ql-picker-label');
        label.innerHTML = $30cc058624146cba$var$DropdownIcon;
        // @ts-expect-error
        label.tabIndex = '0';
        label.setAttribute('role', 'button');
        label.setAttribute('aria-expanded', 'false');
        this.container.appendChild(label);
        return label;
    }
    buildOptions() {
        const options = document.createElement('span');
        options.classList.add('ql-picker-options');
        // Don't want screen readers to read this until options are visible
        options.setAttribute('aria-hidden', 'true');
        // @ts-expect-error
        options.tabIndex = '-1';
        // Need a unique id for aria-controls
        options.id = `ql-picker-options-${$30cc058624146cba$var$optionsCounter}`;
        $30cc058624146cba$var$optionsCounter += 1;
        this.label.setAttribute('aria-controls', options.id);
        // @ts-expect-error
        this.options = options;
        Array.from(this.select.options).forEach((option)=>{
            const item = this.buildItem(option);
            options.appendChild(item);
            if (option.selected === true) this.selectItem(item);
        });
        this.container.appendChild(options);
    }
    buildPicker() {
        Array.from(this.select.attributes).forEach((item)=>{
            this.container.setAttribute(item.name, item.value);
        });
        this.container.classList.add('ql-picker');
        this.label = this.buildLabel();
        this.buildOptions();
    }
    escape() {
        // Close menu and return focus to trigger label
        this.close();
        // Need setTimeout for accessibility to ensure that the browser executes
        // focus on the next process thread and after any DOM content changes
        setTimeout(()=>this.label.focus(), 1);
    }
    close() {
        this.container.classList.remove('ql-expanded');
        this.label.setAttribute('aria-expanded', 'false');
        // @ts-expect-error
        this.options.setAttribute('aria-hidden', 'true');
    }
    selectItem(item) {
        let trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        const selected = this.container.querySelector('.ql-selected');
        if (item === selected) return;
        if (selected != null) selected.classList.remove('ql-selected');
        if (item == null) return;
        item.classList.add('ql-selected');
        // @ts-expect-error Fix me later
        this.select.selectedIndex = Array.from(item.parentNode.children).indexOf(item);
        if (item.hasAttribute('data-value')) // @ts-expect-error Fix me later
        this.label.setAttribute('data-value', item.getAttribute('data-value'));
        else this.label.removeAttribute('data-value');
        if (item.hasAttribute('data-label')) // @ts-expect-error Fix me later
        this.label.setAttribute('data-label', item.getAttribute('data-label'));
        else this.label.removeAttribute('data-label');
        if (trigger) {
            this.select.dispatchEvent(new Event('change'));
            this.close();
        }
    }
    update() {
        let option;
        if (this.select.selectedIndex > -1) {
            const item = // @ts-expect-error Fix me later
            this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
            option = this.select.options[this.select.selectedIndex];
            // @ts-expect-error
            this.selectItem(item);
        } else this.selectItem(null);
        const isActive = option != null && option !== this.select.querySelector('option[selected]');
        this.label.classList.toggle('ql-active', isActive);
    }
}
var $30cc058624146cba$export$2e2bcd8739ae039 = $30cc058624146cba$var$Picker;

});

parcelRegister("ilcQW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5a4287ea6c8b6a0$export$2e2bcd8739ae039);

var $4bKc2 = parcelRequire("4bKc2");
class $d5a4287ea6c8b6a0$var$ColorPicker extends (0, $4bKc2.default) {
    constructor(select, label){
        super(select);
        this.label.innerHTML = label;
        this.container.classList.add('ql-color-picker');
        Array.from(this.container.querySelectorAll('.ql-picker-item')).slice(0, 7).forEach((item)=>{
            item.classList.add('ql-primary');
        });
    }
    buildItem(option) {
        const item = super.buildItem(option);
        item.style.backgroundColor = option.getAttribute('value') || '';
        return item;
    }
    selectItem(item, trigger) {
        super.selectItem(item, trigger);
        const colorLabel = this.label.querySelector('.ql-color-label');
        const value = item ? item.getAttribute('data-value') || '' : '';
        if (colorLabel) {
            if (colorLabel.tagName === 'line') colorLabel.style.stroke = value;
            else colorLabel.style.fill = value;
        }
    }
}
var $d5a4287ea6c8b6a0$export$2e2bcd8739ae039 = $d5a4287ea6c8b6a0$var$ColorPicker;

});

parcelRegister("hnVID", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca815b6de8b6f6a6$export$2e2bcd8739ae039);

var $4bKc2 = parcelRequire("4bKc2");
class $ca815b6de8b6f6a6$var$IconPicker extends (0, $4bKc2.default) {
    constructor(select, icons){
        super(select);
        this.container.classList.add('ql-icon-picker');
        Array.from(this.container.querySelectorAll('.ql-picker-item')).forEach((item)=>{
            item.innerHTML = icons[item.getAttribute('data-value') || ''];
        });
        this.defaultItem = this.container.querySelector('.ql-selected');
        this.selectItem(this.defaultItem);
    }
    selectItem(target, trigger) {
        super.selectItem(target, trigger);
        const item = target || this.defaultItem;
        if (item != null) {
            if (this.label.innerHTML === item.innerHTML) return;
            this.label.innerHTML = item.innerHTML;
        }
    }
}
var $ca815b6de8b6f6a6$export$2e2bcd8739ae039 = $ca815b6de8b6f6a6$var$IconPicker;

});

parcelRegister("kHULU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f133dc7998db6b25$export$2e2bcd8739ae039);
const $f133dc7998db6b25$var$isScrollable = (el)=>{
    const { overflowY: overflowY } = getComputedStyle(el, null);
    return overflowY !== 'visible' && overflowY !== 'clip';
};
class $f133dc7998db6b25$var$Tooltip {
    constructor(quill, boundsContainer){
        this.quill = quill;
        this.boundsContainer = boundsContainer || document.body;
        this.root = quill.addContainer('ql-tooltip');
        // @ts-expect-error
        this.root.innerHTML = this.constructor.TEMPLATE;
        if ($f133dc7998db6b25$var$isScrollable(this.quill.root)) this.quill.root.addEventListener('scroll', ()=>{
            this.root.style.marginTop = `${-1 * this.quill.root.scrollTop}px`;
        });
        this.hide();
    }
    hide() {
        this.root.classList.add('ql-hidden');
    }
    position(reference) {
        const left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
        // root.scrollTop should be 0 if scrollContainer !== root
        const top = reference.bottom + this.quill.root.scrollTop;
        this.root.style.left = `${left}px`;
        this.root.style.top = `${top}px`;
        this.root.classList.remove('ql-flip');
        const containerBounds = this.boundsContainer.getBoundingClientRect();
        const rootBounds = this.root.getBoundingClientRect();
        let shift = 0;
        if (rootBounds.right > containerBounds.right) {
            shift = containerBounds.right - rootBounds.right;
            this.root.style.left = `${left + shift}px`;
        }
        if (rootBounds.left < containerBounds.left) {
            shift = containerBounds.left - rootBounds.left;
            this.root.style.left = `${left + shift}px`;
        }
        if (rootBounds.bottom > containerBounds.bottom) {
            const height = rootBounds.bottom - rootBounds.top;
            const verticalShift = reference.bottom - reference.top + height;
            this.root.style.top = `${top - verticalShift}px`;
            this.root.classList.add('ql-flip');
        }
        return shift;
    }
    show() {
        this.root.classList.remove('ql-editing');
        this.root.classList.remove('ql-hidden');
    }
}
var $f133dc7998db6b25$export$2e2bcd8739ae039 = $f133dc7998db6b25$var$Tooltip;

});

parcelRegister("7rjsX", function(module, exports) {

$parcel$export(module.exports, "default", () => $56aa27985f423f9f$export$2e2bcd8739ae039);

var $jjgrT = parcelRequire("jjgrT");

var $hJr1g = parcelRequire("hJr1g");

var $1fqfh = parcelRequire("1fqfh");

var $6EzZS = parcelRequire("6EzZS");

var $lgElq = parcelRequire("lgElq");

var $ePuKS = parcelRequire("ePuKS");
const $56aa27985f423f9f$var$TOOLBAR_CONFIG = [
    [
        'bold',
        'italic',
        'link'
    ],
    [
        {
            header: 1
        },
        {
            header: 2
        },
        'blockquote'
    ]
];
class $56aa27985f423f9f$export$572b56f7a5e9813a extends (0, $1fqfh.BaseTooltip) {
    static TEMPLATE = [
        '<span class="ql-tooltip-arrow"></span>',
        '<div class="ql-tooltip-editor">',
        '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
        '<a class="ql-close"></a>',
        '</div>'
    ].join('');
    constructor(quill, bounds){
        super(quill, bounds);
        this.quill.on((0, $hJr1g.default).events.EDITOR_CHANGE, (type, range, oldRange, source)=>{
            if (type !== (0, $hJr1g.default).events.SELECTION_CHANGE) return;
            if (range != null && range.length > 0 && source === (0, $hJr1g.default).sources.USER) {
                this.show();
                // Lock our width so we will expand beyond our offsetParent boundaries
                this.root.style.left = '0px';
                this.root.style.width = '';
                this.root.style.width = `${this.root.offsetWidth}px`;
                const lines = this.quill.getLines(range.index, range.length);
                if (lines.length === 1) {
                    const bounds = this.quill.getBounds(range);
                    if (bounds != null) this.position(bounds);
                } else {
                    const lastLine = lines[lines.length - 1];
                    const index = this.quill.getIndex(lastLine);
                    const length = Math.min(lastLine.length() - 1, range.index + range.length - index);
                    const indexBounds = this.quill.getBounds(new (0, $6EzZS.Range)(index, length));
                    if (indexBounds != null) this.position(indexBounds);
                }
            } else if (document.activeElement !== this.textbox && this.quill.hasFocus()) this.hide();
        });
    }
    listen() {
        super.listen();
        // @ts-expect-error Fix me later
        this.root.querySelector('.ql-close').addEventListener('click', ()=>{
            this.root.classList.remove('ql-editing');
        });
        this.quill.on((0, $hJr1g.default).events.SCROLL_OPTIMIZE, ()=>{
            // Let selection be restored by toolbar handlers before repositioning
            setTimeout(()=>{
                if (this.root.classList.contains('ql-hidden')) return;
                const range = this.quill.getSelection();
                if (range != null) {
                    const bounds = this.quill.getBounds(range);
                    if (bounds != null) this.position(bounds);
                }
            }, 1);
        });
    }
    cancel() {
        this.show();
    }
    position(reference) {
        const shift = super.position(reference);
        const arrow = this.root.querySelector('.ql-tooltip-arrow');
        // @ts-expect-error
        arrow.style.marginLeft = '';
        if (shift !== 0) // @ts-expect-error
        arrow.style.marginLeft = `${-1 * shift - arrow.offsetWidth / 2}px`;
        return shift;
    }
}
class $56aa27985f423f9f$export$2e2bcd8739ae039 extends (0, $1fqfh.default) {
    constructor(quill, options){
        if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = $56aa27985f423f9f$var$TOOLBAR_CONFIG;
        super(quill, options);
        this.quill.container.classList.add('ql-bubble');
    }
    extendToolbar(toolbar) {
        // @ts-expect-error
        this.tooltip = new $56aa27985f423f9f$export$572b56f7a5e9813a(this.quill, this.options.bounds);
        if (toolbar.container != null) {
            this.tooltip.root.appendChild(toolbar.container);
            this.buildButtons(toolbar.container.querySelectorAll('button'), (0, $lgElq.default));
            this.buildPickers(toolbar.container.querySelectorAll('select'), (0, $lgElq.default));
        }
    }
}
$56aa27985f423f9f$export$2e2bcd8739ae039.DEFAULTS = (0, $jjgrT.default)({}, (0, $1fqfh.default).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                link (value) {
                    if (!value) this.quill.format('link', false, (0, $ePuKS.default).sources.USER);
                    else // @ts-expect-error
                    this.quill.theme.tooltip.edit();
                }
            }
        }
    }
});

});
parcelRegister("1fqfh", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e8b8cf60d51ea03$export$2e2bcd8739ae039);
$parcel$export(module.exports, "BaseTooltip", () => $0e8b8cf60d51ea03$export$ba0102162f9e195c);

var $jjgrT = parcelRequire("jjgrT");

var $hJr1g = parcelRequire("hJr1g");

var $8ioPK = parcelRequire("8ioPK");

var $ilcQW = parcelRequire("ilcQW");

var $hnVID = parcelRequire("hnVID");

var $4bKc2 = parcelRequire("4bKc2");

var $kHULU = parcelRequire("kHULU");
const $0e8b8cf60d51ea03$var$ALIGNS = [
    false,
    'center',
    'right',
    'justify'
];
const $0e8b8cf60d51ea03$var$COLORS = [
    '#000000',
    '#e60000',
    '#ff9900',
    '#ffff00',
    '#008a00',
    '#0066cc',
    '#9933ff',
    '#ffffff',
    '#facccc',
    '#ffebcc',
    '#ffffcc',
    '#cce8cc',
    '#cce0f5',
    '#ebd6ff',
    '#bbbbbb',
    '#f06666',
    '#ffc266',
    '#ffff66',
    '#66b966',
    '#66a3e0',
    '#c285ff',
    '#888888',
    '#a10000',
    '#b26b00',
    '#b2b200',
    '#006100',
    '#0047b2',
    '#6b24b2',
    '#444444',
    '#5c0000',
    '#663d00',
    '#666600',
    '#003700',
    '#002966',
    '#3d1466'
];
const $0e8b8cf60d51ea03$var$FONTS = [
    false,
    'serif',
    'monospace'
];
const $0e8b8cf60d51ea03$var$HEADERS = [
    '1',
    '2',
    '3',
    false
];
const $0e8b8cf60d51ea03$var$SIZES = [
    'small',
    false,
    'large',
    'huge'
];
class $0e8b8cf60d51ea03$export$2e2bcd8739ae039 extends (0, $8ioPK.default) {
    constructor(quill, options){
        super(quill, options);
        const listener = (e)=>{
            if (!document.body.contains(quill.root)) {
                document.body.removeEventListener('click', listener);
                return;
            }
            if (this.tooltip != null && // @ts-expect-error
            !this.tooltip.root.contains(e.target) && // @ts-expect-error
            document.activeElement !== this.tooltip.textbox && !this.quill.hasFocus()) this.tooltip.hide();
            if (this.pickers != null) this.pickers.forEach((picker)=>{
                // @ts-expect-error
                if (!picker.container.contains(e.target)) picker.close();
            });
        };
        quill.emitter.listenDOM('click', document.body, listener);
    }
    addModule(name) {
        const module = super.addModule(name);
        if (name === 'toolbar') // @ts-expect-error
        this.extendToolbar(module);
        return module;
    }
    buildButtons(buttons, icons) {
        Array.from(buttons).forEach((button)=>{
            const className = button.getAttribute('class') || '';
            className.split(/\s+/).forEach((name)=>{
                if (!name.startsWith('ql-')) return;
                name = name.slice(3);
                if (icons[name] == null) return;
                if (name === 'direction') // @ts-expect-error
                button.innerHTML = icons[name][''] + icons[name].rtl;
                else if (typeof icons[name] === 'string') // @ts-expect-error
                button.innerHTML = icons[name];
                else {
                    // @ts-expect-error
                    const value = button.value || '';
                    // @ts-expect-error
                    if (value != null && icons[name][value]) // @ts-expect-error
                    button.innerHTML = icons[name][value];
                }
            });
        });
    }
    buildPickers(selects, icons) {
        this.pickers = Array.from(selects).map((select)=>{
            if (select.classList.contains('ql-align')) {
                if (select.querySelector('option') == null) $0e8b8cf60d51ea03$var$fillSelect(select, $0e8b8cf60d51ea03$var$ALIGNS);
                if (typeof icons.align === 'object') return new (0, $hnVID.default)(select, icons.align);
            }
            if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
                const format = select.classList.contains('ql-background') ? 'background' : 'color';
                if (select.querySelector('option') == null) $0e8b8cf60d51ea03$var$fillSelect(select, $0e8b8cf60d51ea03$var$COLORS, format === 'background' ? '#ffffff' : '#000000');
                return new (0, $ilcQW.default)(select, icons[format]);
            }
            if (select.querySelector('option') == null) {
                if (select.classList.contains('ql-font')) $0e8b8cf60d51ea03$var$fillSelect(select, $0e8b8cf60d51ea03$var$FONTS);
                else if (select.classList.contains('ql-header')) $0e8b8cf60d51ea03$var$fillSelect(select, $0e8b8cf60d51ea03$var$HEADERS);
                else if (select.classList.contains('ql-size')) $0e8b8cf60d51ea03$var$fillSelect(select, $0e8b8cf60d51ea03$var$SIZES);
            }
            return new (0, $4bKc2.default)(select);
        });
        const update = ()=>{
            this.pickers.forEach((picker)=>{
                picker.update();
            });
        };
        this.quill.on((0, $hJr1g.default).events.EDITOR_CHANGE, update);
    }
}
$0e8b8cf60d51ea03$export$2e2bcd8739ae039.DEFAULTS = (0, $jjgrT.default)({}, (0, $8ioPK.default).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                formula () {
                    this.quill.theme.tooltip.edit('formula');
                },
                image () {
                    let fileInput = this.container.querySelector('input.ql-image[type=file]');
                    if (fileInput == null) {
                        fileInput = document.createElement('input');
                        fileInput.setAttribute('type', 'file');
                        fileInput.setAttribute('accept', this.quill.uploader.options.mimetypes.join(', '));
                        fileInput.classList.add('ql-image');
                        fileInput.addEventListener('change', ()=>{
                            const range = this.quill.getSelection(true);
                            this.quill.uploader.upload(range, fileInput.files);
                            fileInput.value = '';
                        });
                        this.container.appendChild(fileInput);
                    }
                    fileInput.click();
                },
                video () {
                    this.quill.theme.tooltip.edit('video');
                }
            }
        }
    }
});
class $0e8b8cf60d51ea03$export$ba0102162f9e195c extends (0, $kHULU.default) {
    constructor(quill, boundsContainer){
        super(quill, boundsContainer);
        this.textbox = this.root.querySelector('input[type="text"]');
        this.listen();
    }
    listen() {
        // @ts-expect-error Fix me later
        this.textbox.addEventListener('keydown', (event)=>{
            if (event.key === 'Enter') {
                this.save();
                event.preventDefault();
            } else if (event.key === 'Escape') {
                this.cancel();
                event.preventDefault();
            }
        });
    }
    cancel() {
        this.hide();
        this.restoreFocus();
    }
    edit() {
        let mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
        let preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        this.root.classList.remove('ql-hidden');
        this.root.classList.add('ql-editing');
        if (this.textbox == null) return;
        if (preview != null) this.textbox.value = preview;
        else if (mode !== this.root.getAttribute('data-mode')) this.textbox.value = '';
        const bounds = this.quill.getBounds(this.quill.selection.savedRange);
        if (bounds != null) this.position(bounds);
        this.textbox.select();
        this.textbox.setAttribute('placeholder', this.textbox.getAttribute(`data-${mode}`) || '');
        this.root.setAttribute('data-mode', mode);
    }
    restoreFocus() {
        this.quill.focus({
            preventScroll: true
        });
    }
    save() {
        // @ts-expect-error Fix me later
        let { value: value } = this.textbox;
        switch(this.root.getAttribute('data-mode')){
            case 'link':
                {
                    const { scrollTop: scrollTop } = this.quill.root;
                    if (this.linkRange) {
                        this.quill.formatText(this.linkRange, 'link', value, (0, $hJr1g.default).sources.USER);
                        delete this.linkRange;
                    } else {
                        this.restoreFocus();
                        this.quill.format('link', value, (0, $hJr1g.default).sources.USER);
                    }
                    this.quill.root.scrollTop = scrollTop;
                    break;
                }
            case 'video':
                value = $0e8b8cf60d51ea03$var$extractVideoUrl(value);
            // eslint-disable-next-line no-fallthrough
            case 'formula':
                {
                    if (!value) break;
                    const range = this.quill.getSelection(true);
                    if (range != null) {
                        const index = range.index + range.length;
                        this.quill.insertEmbed(index, // @ts-expect-error Fix me later
                        this.root.getAttribute('data-mode'), value, (0, $hJr1g.default).sources.USER);
                        if (this.root.getAttribute('data-mode') === 'formula') this.quill.insertText(index + 1, ' ', (0, $hJr1g.default).sources.USER);
                        this.quill.setSelection(index + 2, (0, $hJr1g.default).sources.USER);
                    }
                    break;
                }
            default:
        }
        // @ts-expect-error Fix me later
        this.textbox.value = '';
        this.hide();
    }
}
function $0e8b8cf60d51ea03$var$extractVideoUrl(url) {
    let match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
    if (match) return `${match[1] || 'https'}://www.youtube.com/embed/${match[2]}?showinfo=0`;
    // eslint-disable-next-line no-cond-assign
    if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) return `${match[1] || 'https'}://player.vimeo.com/video/${match[2]}/`;
    return url;
}
function $0e8b8cf60d51ea03$var$fillSelect(select, values) {
    let defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    values.forEach((value)=>{
        const option = document.createElement('option');
        if (value === defaultValue) option.setAttribute('selected', 'selected');
        else option.setAttribute('value', String(value));
        select.appendChild(option);
    });
}

});


parcelRegister("9qeMZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dc203916cd06560$export$2e2bcd8739ae039);

var $jjgrT = parcelRequire("jjgrT");

var $hJr1g = parcelRequire("hJr1g");

var $1fqfh = parcelRequire("1fqfh");

var $1M5DR = parcelRequire("1M5DR");

var $6EzZS = parcelRequire("6EzZS");

var $lgElq = parcelRequire("lgElq");

var $ePuKS = parcelRequire("ePuKS");
const $6dc203916cd06560$var$TOOLBAR_CONFIG = [
    [
        {
            header: [
                '1',
                '2',
                '3',
                false
            ]
        }
    ],
    [
        'bold',
        'italic',
        'underline',
        'link'
    ],
    [
        {
            list: 'ordered'
        },
        {
            list: 'bullet'
        }
    ],
    [
        'clean'
    ]
];
class $6dc203916cd06560$var$SnowTooltip extends (0, $1fqfh.BaseTooltip) {
    static TEMPLATE = [
        '<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>',
        '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
        '<a class="ql-action"></a>',
        '<a class="ql-remove"></a>'
    ].join('');
    preview = this.root.querySelector('a.ql-preview');
    listen() {
        super.listen();
        // @ts-expect-error Fix me later
        this.root.querySelector('a.ql-action').addEventListener('click', (event)=>{
            if (this.root.classList.contains('ql-editing')) this.save();
            else // @ts-expect-error Fix me later
            this.edit('link', this.preview.textContent);
            event.preventDefault();
        });
        // @ts-expect-error Fix me later
        this.root.querySelector('a.ql-remove').addEventListener('click', (event)=>{
            if (this.linkRange != null) {
                const range = this.linkRange;
                this.restoreFocus();
                this.quill.formatText(range, 'link', false, (0, $hJr1g.default).sources.USER);
                delete this.linkRange;
            }
            event.preventDefault();
            this.hide();
        });
        this.quill.on((0, $hJr1g.default).events.SELECTION_CHANGE, (range, oldRange, source)=>{
            if (range == null) return;
            if (range.length === 0 && source === (0, $hJr1g.default).sources.USER) {
                const [link, offset] = this.quill.scroll.descendant((0, $1M5DR.default), range.index);
                if (link != null) {
                    this.linkRange = new (0, $6EzZS.Range)(range.index - offset, link.length());
                    const preview = (0, $1M5DR.default).formats(link.domNode);
                    // @ts-expect-error Fix me later
                    this.preview.textContent = preview;
                    // @ts-expect-error Fix me later
                    this.preview.setAttribute('href', preview);
                    this.show();
                    const bounds = this.quill.getBounds(this.linkRange);
                    if (bounds != null) this.position(bounds);
                    return;
                }
            } else delete this.linkRange;
            this.hide();
        });
    }
    show() {
        super.show();
        this.root.removeAttribute('data-mode');
    }
}
class $6dc203916cd06560$var$SnowTheme extends (0, $1fqfh.default) {
    constructor(quill, options){
        if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = $6dc203916cd06560$var$TOOLBAR_CONFIG;
        super(quill, options);
        this.quill.container.classList.add('ql-snow');
    }
    extendToolbar(toolbar) {
        if (toolbar.container != null) {
            toolbar.container.classList.add('ql-snow');
            this.buildButtons(toolbar.container.querySelectorAll('button'), (0, $lgElq.default));
            this.buildPickers(toolbar.container.querySelectorAll('select'), (0, $lgElq.default));
            // @ts-expect-error
            this.tooltip = new $6dc203916cd06560$var$SnowTooltip(this.quill, this.options.bounds);
            if (toolbar.container.querySelector('.ql-link')) this.quill.keyboard.addBinding({
                key: 'k',
                shortKey: true
            }, (_range, context)=>{
                toolbar.handlers.link.call(toolbar, !context.format.link);
            });
        }
    }
}
$6dc203916cd06560$var$SnowTheme.DEFAULTS = (0, $jjgrT.default)({}, (0, $1fqfh.default).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                link (value) {
                    if (value) {
                        const range = this.quill.getSelection();
                        if (range == null || range.length === 0) return;
                        let preview = this.quill.getText(range);
                        if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) preview = `mailto:${preview}`;
                        // @ts-expect-error
                        const { tooltip: tooltip } = this.quill.theme;
                        tooltip.edit('link', preview);
                    } else this.quill.format('link', false, (0, $ePuKS.default).sources.USER);
                }
            }
        }
    }
});
var $6dc203916cd06560$export$2e2bcd8739ae039 = $6dc203916cd06560$var$SnowTheme;

});


parcelRegister("3gspO", function(module, exports) {
// Copyright (c) 2013 Pieroxy <pieroxy@pieroxy.net>
// This work is free. You can redistribute it and/or modify it
// under the terms of the WTFPL, Version 2
// For more information see LICENSE.txt or http://www.wtfpl.net/
//
// For more information, the home page:
// http://pieroxy.net/blog/pages/lz-string/testing.html
//
// LZ-based compression algorithm, version 1.4.5
var LZString = function() {
    // private property
    var f = String.fromCharCode;
    var keyStrBase64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var keyStrUriSafe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$";
    var baseReverseDic = {};
    function getBaseValue(alphabet, character) {
        if (!baseReverseDic[alphabet]) {
            baseReverseDic[alphabet] = {};
            for(var i = 0; i < alphabet.length; i++)baseReverseDic[alphabet][alphabet.charAt(i)] = i;
        }
        return baseReverseDic[alphabet][character];
    }
    var LZString = {
        compressToBase64: function(input) {
            if (input == null) return "";
            var res = LZString._compress(input, 6, function(a) {
                return keyStrBase64.charAt(a);
            });
            switch(res.length % 4){
                default:
                case 0:
                    return res;
                case 1:
                    return res + "===";
                case 2:
                    return res + "==";
                case 3:
                    return res + "=";
            }
        },
        decompressFromBase64: function(input) {
            if (input == null) return "";
            if (input == "") return null;
            return LZString._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrBase64, input.charAt(index));
            });
        },
        compressToUTF16: function(input) {
            if (input == null) return "";
            return LZString._compress(input, 15, function(a) {
                return f(a + 32);
            }) + " ";
        },
        decompressFromUTF16: function(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString._decompress(compressed.length, 16384, function(index) {
                return compressed.charCodeAt(index) - 32;
            });
        },
        //compress into uint8array (UCS-2 big endian format)
        compressToUint8Array: function(uncompressed) {
            var compressed = LZString.compress(uncompressed);
            var buf = new Uint8Array(compressed.length * 2); // 2 bytes per character
            for(var i = 0, TotalLen = compressed.length; i < TotalLen; i++){
                var current_value = compressed.charCodeAt(i);
                buf[i * 2] = current_value >>> 8;
                buf[i * 2 + 1] = current_value % 256;
            }
            return buf;
        },
        //decompress from uint8array (UCS-2 big endian format)
        decompressFromUint8Array: function(compressed) {
            if (compressed === null || compressed === undefined) return LZString.decompress(compressed);
            else {
                var buf = new Array(compressed.length / 2); // 2 bytes per character
                for(var i = 0, TotalLen = buf.length; i < TotalLen; i++)buf[i] = compressed[i * 2] * 256 + compressed[i * 2 + 1];
                var result = [];
                buf.forEach(function(c) {
                    result.push(f(c));
                });
                return LZString.decompress(result.join(''));
            }
        },
        //compress into a string that is already URI encoded
        compressToEncodedURIComponent: function(input) {
            if (input == null) return "";
            return LZString._compress(input, 6, function(a) {
                return keyStrUriSafe.charAt(a);
            });
        },
        //decompress from an output of compressToEncodedURIComponent
        decompressFromEncodedURIComponent: function(input) {
            if (input == null) return "";
            if (input == "") return null;
            input = input.replace(/ /g, "+");
            return LZString._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrUriSafe, input.charAt(index));
            });
        },
        compress: function(uncompressed) {
            return LZString._compress(uncompressed, 16, function(a) {
                return f(a);
            });
        },
        _compress: function(uncompressed, bitsPerChar, getCharFromInt) {
            if (uncompressed == null) return "";
            var i, value, context_dictionary = {}, context_dictionaryToCreate = {}, context_c = "", context_wc = "", context_w = "", context_enlargeIn = 2, context_dictSize = 3, context_numBits = 2, context_data = [], context_data_val = 0, context_data_position = 0, ii;
            for(ii = 0; ii < uncompressed.length; ii += 1){
                context_c = uncompressed.charAt(ii);
                if (!Object.prototype.hasOwnProperty.call(context_dictionary, context_c)) {
                    context_dictionary[context_c] = context_dictSize++;
                    context_dictionaryToCreate[context_c] = true;
                }
                context_wc = context_w + context_c;
                if (Object.prototype.hasOwnProperty.call(context_dictionary, context_wc)) context_w = context_wc;
                else {
                    if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                        if (context_w.charCodeAt(0) < 256) {
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 8; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        } else {
                            value = 1;
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1 | value;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = 0;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 16; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        }
                        context_enlargeIn--;
                        if (context_enlargeIn == 0) {
                            context_enlargeIn = Math.pow(2, context_numBits);
                            context_numBits++;
                        }
                        delete context_dictionaryToCreate[context_w];
                    } else {
                        value = context_dictionary[context_w];
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    // Add wc to the dictionary.
                    context_dictionary[context_wc] = context_dictSize++;
                    context_w = String(context_c);
                }
            }
            // Output the code for w.
            if (context_w !== "") {
                if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                    if (context_w.charCodeAt(0) < 256) {
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 8; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    } else {
                        value = 1;
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = 0;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 16; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    delete context_dictionaryToCreate[context_w];
                } else {
                    value = context_dictionary[context_w];
                    for(i = 0; i < context_numBits; i++){
                        context_data_val = context_data_val << 1 | value & 1;
                        if (context_data_position == bitsPerChar - 1) {
                            context_data_position = 0;
                            context_data.push(getCharFromInt(context_data_val));
                            context_data_val = 0;
                        } else context_data_position++;
                        value = value >> 1;
                    }
                }
                context_enlargeIn--;
                if (context_enlargeIn == 0) {
                    context_enlargeIn = Math.pow(2, context_numBits);
                    context_numBits++;
                }
            }
            // Mark the end of the stream
            value = 2;
            for(i = 0; i < context_numBits; i++){
                context_data_val = context_data_val << 1 | value & 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                } else context_data_position++;
                value = value >> 1;
            }
            // Flush the last char
            while(true){
                context_data_val = context_data_val << 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data.push(getCharFromInt(context_data_val));
                    break;
                } else context_data_position++;
            }
            return context_data.join('');
        },
        decompress: function(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString._decompress(compressed.length, 32768, function(index) {
                return compressed.charCodeAt(index);
            });
        },
        _decompress: function(length, resetValue, getNextValue) {
            var dictionary = [], next, enlargeIn = 4, dictSize = 4, numBits = 3, entry = "", result = [], i, w, bits, resb, maxpower, power, c, data = {
                val: getNextValue(0),
                position: resetValue,
                index: 1
            };
            for(i = 0; i < 3; i += 1)dictionary[i] = i;
            bits = 0;
            maxpower = Math.pow(2, 2);
            power = 1;
            while(power != maxpower){
                resb = data.val & data.position;
                data.position >>= 1;
                if (data.position == 0) {
                    data.position = resetValue;
                    data.val = getNextValue(data.index++);
                }
                bits |= (resb > 0 ? 1 : 0) * power;
                power <<= 1;
            }
            switch(next = bits){
                case 0:
                    bits = 0;
                    maxpower = Math.pow(2, 8);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 1:
                    bits = 0;
                    maxpower = Math.pow(2, 16);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 2:
                    return "";
            }
            dictionary[3] = c;
            w = c;
            result.push(c);
            while(true){
                if (data.index > length) return "";
                bits = 0;
                maxpower = Math.pow(2, numBits);
                power = 1;
                while(power != maxpower){
                    resb = data.val & data.position;
                    data.position >>= 1;
                    if (data.position == 0) {
                        data.position = resetValue;
                        data.val = getNextValue(data.index++);
                    }
                    bits |= (resb > 0 ? 1 : 0) * power;
                    power <<= 1;
                }
                switch(c = bits){
                    case 0:
                        bits = 0;
                        maxpower = Math.pow(2, 8);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 1:
                        bits = 0;
                        maxpower = Math.pow(2, 16);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 2:
                        return result.join('');
                }
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
                if (dictionary[c]) entry = dictionary[c];
                else {
                    if (c === dictSize) entry = w + w.charAt(0);
                    else return null;
                }
                result.push(entry);
                // Add w+entry[0] to the dictionary.
                dictionary[dictSize++] = w + entry.charAt(0);
                enlargeIn--;
                w = entry;
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
            }
        }
    };
    return LZString;
}();
if (typeof define === 'function' && define.amd) define(function() {
    return LZString;
});
else if (module != null) module.exports = LZString;
else if (typeof angular !== 'undefined' && angular != null) angular.module('LZString', []).factory('LZString', function() {
    return LZString;
});

});

parcelRegister("gMLdp", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"participatory-system-mapper\",\"version\":\"2.5.0\",\"description\":\"Participatory System Mapper, browser app for collaboratively creating system maps\",\"keywords\":[\"social network\",\"participatory\",\"stakeholder\",\"policy analysis\"],\"bugs\":{\"email\":\"n.gilbert@surrey.ac.uk\"},\"author\":\"Nigel Gilbert\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/micrology/prsm\"},\"targets\":{\"default\":{\"engines\":{\"browserslist\":\"fully supports es6\"},\"distDir\":\"dist\",\"publicUrl\":\".\"}},\"parcelIgnore\":[\"/doc/help/\"],\"scripts\":{\"lint\":\"./node_modules/.bin/eslint ./js/*.js --fix --quiet\",\"pretty\":\"prettier --write ./html/*.html ./*.html ./js/*.js ./css/*.css doc/**/*.{html,css} package.json\",\"build-help\":\"cd doc/help && npm run build\",\"check\":\"npm run --silent lint && npm run --silent build-help && npm run --silent pretty\",\"serve\":\"npx parcel serve './html/*.html' --port 4444 --open\",\"websocket\":\"npx y-websocket\",\"dev\":\"npm run clean && npx parcel build './html/*.html' --no-optimize --no-scope-hoist\",\"build\":\"rm -rf dist/* && npx parcel build './html/*.html'\",\"jsdoc\":\"npx jsdoc -r -c .jsdoc.json\",\"clean\":\"rm -rf dist/*\",\"rebuild-docker\":\"docker buildx build -f docker/docker-y-websocket/Dockerfile --platform linux/amd64,linux/arm64 -t micrology/prsm-y-websocket --push . && docker buildx build --platform linux/amd64,linux/arm64 -t micrology/prsm-httpd --push -f docker/docker-httpd/Dockerfile .\",\"manual\":\"cd doc/help && npm run dev &\",\"deploy\":\"npm run build && doc/help/deploy.rspress.bash && npm run build-help\"},\"license\":\"GPL-3.0-or-later\",\"dependencies\":{\"@aws-sdk/client-bedrock-runtime\":\"^3.726.1\",\"@aws-sdk/client-cognito-identity\":\"^3.726.1\",\"@aws-sdk/client-sts\":\"^3.726.1\",\"@egjs/hammerjs\":\"^2.0.17\",\"@jaames/iro\":\"^5.5.2\",\"3d-force-graph\":\"1.74.5\",\"bootstrap\":\"^5.3.3\",\"fabric\":\"^5.3.0\",\"fast-xml-parser\":\"^4.2.4\",\"file-saver\":\"^2.0.5\",\"luxon\":\"^3.2.1\",\"lz-string\":\"^1.4.4\",\"markdown-to-quill-delta\":\"^1.0.0\",\"quill\":\"^2.0.0\",\"quill-delta-to-html\":\"^0.12.1\",\"quill-to-word\":\"^0.0.7\",\"tabulator-tables\":\"^6.3.0\",\"three\":\"0.172.0\",\"three-spritetext\":\"^1.9.3\",\"uuid\":\"^8.3.2\",\"vis-data\":\"^7.1.4\",\"vis-network\":\"^9.1.4\",\"vis-util\":\"^5.0.3\",\"xlsx\":\"https://cdn.sheetjs.com/xlsx-0.20.2/xlsx-0.20.2.tgz\",\"y-websocket\":\"^2.0.4\",\"yjs\":\"^13.5.47\"},\"devDependencies\":{\"@eslint/eslintrc\":\"^3.2.0\",\"@eslint/js\":\"^9.17.0\",\"@parcel/optimizer-terser\":\"^2.9.3\",\"buffer\":\"^6.0.3\",\"docdash\":\"^2.0.2\",\"eslint\":\"^9.17.0\",\"eslint-config-prettier\":\"^9.1.0\",\"globals\":\"^15.14.0\",\"jsdoc\":\"^4.0.2\",\"microdiff\":\"^1.3.1\",\"parcel\":\"^2.13.3\",\"parcel-resolver-ignore\":\"^2.1.5\",\"prettier\":\"^3.4.2\",\"process\":\"^0.11.10\",\"sharp\":\"^0.33.5\"},\"@parcel/resolver-default\":{\"packageExports\":true},\"private\":true,\"optionalDependencies\":{\"@parcel/watcher-linux-x64-glibc\":\"^2.4.1\"}}");

});

var $9f2ba4875146f214$exports = {};


(parcelRequire("9CBKV")).register((parcelRequire("7qipm")).getBundleURL('6blyj'), JSON.parse("[\"6blyj\",\"prsm.36f44fa1.js\",\"kESxW\",\"PRSMlogo200.3b156bda.webp\",\"02k9f\",\"betweenness.19722fdc.js\"]"));

/********************************************************************************************* 

PRSM Participatory System Mapper 

MIT License

Copyright (c) [2022] Nigel Gilbert email: prsm@prsm.uk

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.


This is the main entry point for PRSM.  
********************************************************************************************/ 
var $lc1R0 = parcelRequire("lc1R0");

var $6iwTo = parcelRequire("6iwTo");
/**
 * vis-network
 * https://visjs.github.io/vis-network/
 *
 * A dynamic, browser-based visualization library.
 *
 * @version 9.1.9
 * @date    2023-11-03T01:42:27.418Z
 *
 * @copyright (c) 2011-2017 Almende B.V, http://almende.com
 * @copyright (c) 2017-2019 visjs contributors, https://github.com/visjs
 *
 * @license
 * vis.js is dual licensed under both
 *
 *   1. The Apache 2.0 License
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 *   and
 *
 *   2. The MIT License
 *      http://opensource.org/licenses/MIT
 *
 * vis.js may be distributed under either license.
 */ /**
 * vis-data
 * http://visjs.org/
 *
 * Manage unstructured data using DataSet. Add, update, and remove data, and listen for changes in the data.
 *
 * @version 7.1.9
 * @date    2023-11-24T17:53:34.179Z
 *
 * @copyright (c) 2011-2017 Almende B.V, http://almende.com
 * @copyright (c) 2017-2019 visjs contributors, https://github.com/visjs
 *
 * @license
 * vis.js is dual licensed under both
 *
 *   1. The Apache 2.0 License
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 *   and
 *
 *   2. The MIT License
 *      http://opensource.org/licenses/MIT
 *
 * vis.js may be distributed under either license.
 */ function $558228835489ffff$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $558228835489ffff$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
function $558228835489ffff$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var $558228835489ffff$var$defineProperty$f = {
    exports: {}
};
var $558228835489ffff$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $558228835489ffff$var$global$p = // eslint-disable-next-line es/no-global-this -- safe
$558228835489ffff$var$check(typeof globalThis == 'object' && globalThis) || $558228835489ffff$var$check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
$558228835489ffff$var$check(typeof self == 'object' && self) || $558228835489ffff$var$check(typeof $558228835489ffff$var$commonjsGlobal == 'object' && $558228835489ffff$var$commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || $558228835489ffff$var$commonjsGlobal || Function('return this')();
var $558228835489ffff$var$fails$u = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};
var $558228835489ffff$var$fails$t = $558228835489ffff$var$fails$u;
var $558228835489ffff$var$functionBindNative = !$558228835489ffff$var$fails$t(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != 'function' || test.hasOwnProperty('prototype');
});
var $558228835489ffff$var$NATIVE_BIND$4 = $558228835489ffff$var$functionBindNative;
var $558228835489ffff$var$FunctionPrototype$4 = Function.prototype;
var $558228835489ffff$var$apply$6 = $558228835489ffff$var$FunctionPrototype$4.apply;
var $558228835489ffff$var$call$k = $558228835489ffff$var$FunctionPrototype$4.call;
// eslint-disable-next-line es/no-reflect -- safe
var $558228835489ffff$var$functionApply = typeof Reflect == 'object' && Reflect.apply || ($558228835489ffff$var$NATIVE_BIND$4 ? $558228835489ffff$var$call$k.bind($558228835489ffff$var$apply$6) : function() {
    return $558228835489ffff$var$call$k.apply($558228835489ffff$var$apply$6, arguments);
});
var $558228835489ffff$var$NATIVE_BIND$3 = $558228835489ffff$var$functionBindNative;
var $558228835489ffff$var$FunctionPrototype$3 = Function.prototype;
var $558228835489ffff$var$call$j = $558228835489ffff$var$FunctionPrototype$3.call;
var $558228835489ffff$var$uncurryThisWithBind = $558228835489ffff$var$NATIVE_BIND$3 && $558228835489ffff$var$FunctionPrototype$3.bind.bind($558228835489ffff$var$call$j, $558228835489ffff$var$call$j);
var $558228835489ffff$var$functionUncurryThis = $558228835489ffff$var$NATIVE_BIND$3 ? $558228835489ffff$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $558228835489ffff$var$call$j.apply(fn, arguments);
    };
};
var $558228835489ffff$var$uncurryThis$q = $558228835489ffff$var$functionUncurryThis;
var $558228835489ffff$var$toString$9 = $558228835489ffff$var$uncurryThis$q({}.toString);
var $558228835489ffff$var$stringSlice$1 = $558228835489ffff$var$uncurryThis$q(''.slice);
var $558228835489ffff$var$classofRaw$2 = function(it) {
    return $558228835489ffff$var$stringSlice$1($558228835489ffff$var$toString$9(it), 8, -1);
};
var $558228835489ffff$var$classofRaw$1 = $558228835489ffff$var$classofRaw$2;
var $558228835489ffff$var$uncurryThis$p = $558228835489ffff$var$functionUncurryThis;
var $558228835489ffff$var$functionUncurryThisClause = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($558228835489ffff$var$classofRaw$1(fn) === 'Function') return $558228835489ffff$var$uncurryThis$p(fn);
};
var $558228835489ffff$var$documentAll$2 = typeof document == 'object' && document.all;
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var $558228835489ffff$var$IS_HTMLDDA = typeof $558228835489ffff$var$documentAll$2 == 'undefined' && $558228835489ffff$var$documentAll$2 !== undefined;
var $558228835489ffff$var$documentAll_1 = {
    all: $558228835489ffff$var$documentAll$2,
    IS_HTMLDDA: $558228835489ffff$var$IS_HTMLDDA
};
var $558228835489ffff$var$$documentAll$1 = $558228835489ffff$var$documentAll_1;
var $558228835489ffff$var$documentAll$1 = $558228835489ffff$var$$documentAll$1.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var $558228835489ffff$var$isCallable$m = $558228835489ffff$var$$documentAll$1.IS_HTMLDDA ? function(argument) {
    return typeof argument == 'function' || argument === $558228835489ffff$var$documentAll$1;
} : function(argument) {
    return typeof argument == 'function';
};
var $558228835489ffff$var$objectGetOwnPropertyDescriptor = {};
var $558228835489ffff$var$fails$s = $558228835489ffff$var$fails$u;
// Detect IE8's incomplete defineProperty implementation
var $558228835489ffff$var$descriptors = !$558228835489ffff$var$fails$s(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});
var $558228835489ffff$var$NATIVE_BIND$2 = $558228835489ffff$var$functionBindNative;
var $558228835489ffff$var$call$i = Function.prototype.call;
var $558228835489ffff$var$functionCall = $558228835489ffff$var$NATIVE_BIND$2 ? $558228835489ffff$var$call$i.bind($558228835489ffff$var$call$i) : function() {
    return $558228835489ffff$var$call$i.apply($558228835489ffff$var$call$i, arguments);
};
var $558228835489ffff$var$objectPropertyIsEnumerable = {};
var $558228835489ffff$var$$propertyIsEnumerable$1 = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $558228835489ffff$var$getOwnPropertyDescriptor$7 = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $558228835489ffff$var$NASHORN_BUG = $558228835489ffff$var$getOwnPropertyDescriptor$7 && !$558228835489ffff$var$$propertyIsEnumerable$1.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
$558228835489ffff$var$objectPropertyIsEnumerable.f = $558228835489ffff$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $558228835489ffff$var$getOwnPropertyDescriptor$7(this, V);
    return !!descriptor && descriptor.enumerable;
} : $558228835489ffff$var$$propertyIsEnumerable$1;
var $558228835489ffff$var$createPropertyDescriptor$7 = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};
var $558228835489ffff$var$uncurryThis$o = $558228835489ffff$var$functionUncurryThis;
var $558228835489ffff$var$fails$r = $558228835489ffff$var$fails$u;
var $558228835489ffff$var$classof$f = $558228835489ffff$var$classofRaw$2;
var $558228835489ffff$var$$Object$4 = Object;
var $558228835489ffff$var$split = $558228835489ffff$var$uncurryThis$o(''.split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var $558228835489ffff$var$indexedObject = $558228835489ffff$var$fails$r(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$558228835489ffff$var$$Object$4('z').propertyIsEnumerable(0);
}) ? function(it) {
    return $558228835489ffff$var$classof$f(it) === 'String' ? $558228835489ffff$var$split(it, '') : $558228835489ffff$var$$Object$4(it);
} : $558228835489ffff$var$$Object$4;
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var $558228835489ffff$var$isNullOrUndefined$6 = function(it) {
    return it === null || it === undefined;
};
var $558228835489ffff$var$isNullOrUndefined$5 = $558228835489ffff$var$isNullOrUndefined$6;
var $558228835489ffff$var$$TypeError$g = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var $558228835489ffff$var$requireObjectCoercible$3 = function(it) {
    if ($558228835489ffff$var$isNullOrUndefined$5(it)) throw new $558228835489ffff$var$$TypeError$g("Can't call method on " + it);
    return it;
};
// toObject with fallback for non-array-like ES3 strings
var $558228835489ffff$var$IndexedObject$3 = $558228835489ffff$var$indexedObject;
var $558228835489ffff$var$requireObjectCoercible$2 = $558228835489ffff$var$requireObjectCoercible$3;
var $558228835489ffff$var$toIndexedObject$a = function(it) {
    return $558228835489ffff$var$IndexedObject$3($558228835489ffff$var$requireObjectCoercible$2(it));
};
var $558228835489ffff$var$isCallable$l = $558228835489ffff$var$isCallable$m;
var $558228835489ffff$var$$documentAll = $558228835489ffff$var$documentAll_1;
var $558228835489ffff$var$documentAll = $558228835489ffff$var$$documentAll.all;
var $558228835489ffff$var$isObject$h = $558228835489ffff$var$$documentAll.IS_HTMLDDA ? function(it) {
    return typeof it == 'object' ? it !== null : $558228835489ffff$var$isCallable$l(it) || it === $558228835489ffff$var$documentAll;
} : function(it) {
    return typeof it == 'object' ? it !== null : $558228835489ffff$var$isCallable$l(it);
};
var $558228835489ffff$var$path$o = {};
var $558228835489ffff$var$path$n = $558228835489ffff$var$path$o;
var $558228835489ffff$var$global$o = $558228835489ffff$var$global$p;
var $558228835489ffff$var$isCallable$k = $558228835489ffff$var$isCallable$m;
var $558228835489ffff$var$aFunction = function(variable) {
    return $558228835489ffff$var$isCallable$k(variable) ? variable : undefined;
};
var $558228835489ffff$var$getBuiltIn$f = function(namespace, method) {
    return arguments.length < 2 ? $558228835489ffff$var$aFunction($558228835489ffff$var$path$n[namespace]) || $558228835489ffff$var$aFunction($558228835489ffff$var$global$o[namespace]) : $558228835489ffff$var$path$n[namespace] && $558228835489ffff$var$path$n[namespace][method] || $558228835489ffff$var$global$o[namespace] && $558228835489ffff$var$global$o[namespace][method];
};
var $558228835489ffff$var$uncurryThis$n = $558228835489ffff$var$functionUncurryThis;
var $558228835489ffff$var$objectIsPrototypeOf = $558228835489ffff$var$uncurryThis$n({}.isPrototypeOf);
var $558228835489ffff$var$engineUserAgent = typeof navigator != 'undefined' && String(navigator.userAgent) || '';
var $558228835489ffff$var$global$n = $558228835489ffff$var$global$p;
var $558228835489ffff$var$userAgent$5 = $558228835489ffff$var$engineUserAgent;
var $558228835489ffff$var$process$3 = $558228835489ffff$var$global$n.process;
var $558228835489ffff$var$Deno$1 = $558228835489ffff$var$global$n.Deno;
var $558228835489ffff$var$versions = $558228835489ffff$var$process$3 && $558228835489ffff$var$process$3.versions || $558228835489ffff$var$Deno$1 && $558228835489ffff$var$Deno$1.version;
var $558228835489ffff$var$v8 = $558228835489ffff$var$versions && $558228835489ffff$var$versions.v8;
var $558228835489ffff$var$match, $558228835489ffff$var$version;
if ($558228835489ffff$var$v8) {
    $558228835489ffff$var$match = $558228835489ffff$var$v8.split('.');
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $558228835489ffff$var$version = $558228835489ffff$var$match[0] > 0 && $558228835489ffff$var$match[0] < 4 ? 1 : +($558228835489ffff$var$match[0] + $558228835489ffff$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$558228835489ffff$var$version && $558228835489ffff$var$userAgent$5) {
    $558228835489ffff$var$match = $558228835489ffff$var$userAgent$5.match(/Edge\/(\d+)/);
    if (!$558228835489ffff$var$match || $558228835489ffff$var$match[1] >= 74) {
        $558228835489ffff$var$match = $558228835489ffff$var$userAgent$5.match(/Chrome\/(\d+)/);
        if ($558228835489ffff$var$match) $558228835489ffff$var$version = +$558228835489ffff$var$match[1];
    }
}
var $558228835489ffff$var$engineV8Version = $558228835489ffff$var$version;
/* eslint-disable es/no-symbol -- required for testing */ var $558228835489ffff$var$V8_VERSION$3 = $558228835489ffff$var$engineV8Version;
var $558228835489ffff$var$fails$q = $558228835489ffff$var$fails$u;
var $558228835489ffff$var$global$m = $558228835489ffff$var$global$p;
var $558228835489ffff$var$$String$5 = $558228835489ffff$var$global$m.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var $558228835489ffff$var$symbolConstructorDetection = !!Object.getOwnPropertySymbols && !$558228835489ffff$var$fails$q(function() {
    var symbol = Symbol('symbol detection');
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$558228835489ffff$var$$String$5(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $558228835489ffff$var$V8_VERSION$3 && $558228835489ffff$var$V8_VERSION$3 < 41;
});
/* eslint-disable es/no-symbol -- required for testing */ var $558228835489ffff$var$NATIVE_SYMBOL$5 = $558228835489ffff$var$symbolConstructorDetection;
var $558228835489ffff$var$useSymbolAsUid = $558228835489ffff$var$NATIVE_SYMBOL$5 && !Symbol.sham && typeof Symbol.iterator == 'symbol';
var $558228835489ffff$var$getBuiltIn$e = $558228835489ffff$var$getBuiltIn$f;
var $558228835489ffff$var$isCallable$j = $558228835489ffff$var$isCallable$m;
var $558228835489ffff$var$isPrototypeOf$k = $558228835489ffff$var$objectIsPrototypeOf;
var $558228835489ffff$var$USE_SYMBOL_AS_UID$1 = $558228835489ffff$var$useSymbolAsUid;
var $558228835489ffff$var$$Object$3 = Object;
var $558228835489ffff$var$isSymbol$5 = $558228835489ffff$var$USE_SYMBOL_AS_UID$1 ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    var $Symbol = $558228835489ffff$var$getBuiltIn$e('Symbol');
    return $558228835489ffff$var$isCallable$j($Symbol) && $558228835489ffff$var$isPrototypeOf$k($Symbol.prototype, $558228835489ffff$var$$Object$3(it));
};
var $558228835489ffff$var$$String$4 = String;
var $558228835489ffff$var$tryToString$6 = function(argument) {
    try {
        return $558228835489ffff$var$$String$4(argument);
    } catch (error) {
        return 'Object';
    }
};
var $558228835489ffff$var$isCallable$i = $558228835489ffff$var$isCallable$m;
var $558228835489ffff$var$tryToString$5 = $558228835489ffff$var$tryToString$6;
var $558228835489ffff$var$$TypeError$f = TypeError;
// `Assert: IsCallable(argument) is true`
var $558228835489ffff$var$aCallable$e = function(argument) {
    if ($558228835489ffff$var$isCallable$i(argument)) return argument;
    throw new $558228835489ffff$var$$TypeError$f($558228835489ffff$var$tryToString$5(argument) + ' is not a function');
};
var $558228835489ffff$var$aCallable$d = $558228835489ffff$var$aCallable$e;
var $558228835489ffff$var$isNullOrUndefined$4 = $558228835489ffff$var$isNullOrUndefined$6;
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var $558228835489ffff$var$getMethod$3 = function(V, P) {
    var func = V[P];
    return $558228835489ffff$var$isNullOrUndefined$4(func) ? undefined : $558228835489ffff$var$aCallable$d(func);
};
var $558228835489ffff$var$call$h = $558228835489ffff$var$functionCall;
var $558228835489ffff$var$isCallable$h = $558228835489ffff$var$isCallable$m;
var $558228835489ffff$var$isObject$g = $558228835489ffff$var$isObject$h;
var $558228835489ffff$var$$TypeError$e = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var $558228835489ffff$var$ordinaryToPrimitive$1 = function(input, pref) {
    var fn, val;
    if (pref === 'string' && $558228835489ffff$var$isCallable$h(fn = input.toString) && !$558228835489ffff$var$isObject$g(val = $558228835489ffff$var$call$h(fn, input))) return val;
    if ($558228835489ffff$var$isCallable$h(fn = input.valueOf) && !$558228835489ffff$var$isObject$g(val = $558228835489ffff$var$call$h(fn, input))) return val;
    if (pref !== 'string' && $558228835489ffff$var$isCallable$h(fn = input.toString) && !$558228835489ffff$var$isObject$g(val = $558228835489ffff$var$call$h(fn, input))) return val;
    throw new $558228835489ffff$var$$TypeError$e("Can't convert object to primitive value");
};
var $558228835489ffff$var$shared$7 = {
    exports: {}
};
var $558228835489ffff$var$isPure = true;
var $558228835489ffff$var$global$l = $558228835489ffff$var$global$p;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $558228835489ffff$var$defineProperty$e = Object.defineProperty;
var $558228835489ffff$var$defineGlobalProperty$1 = function(key, value) {
    try {
        $558228835489ffff$var$defineProperty$e($558228835489ffff$var$global$l, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $558228835489ffff$var$global$l[key] = value;
    }
    return value;
};
var $558228835489ffff$var$global$k = $558228835489ffff$var$global$p;
var $558228835489ffff$var$defineGlobalProperty = $558228835489ffff$var$defineGlobalProperty$1;
var $558228835489ffff$var$SHARED = '__core-js_shared__';
var $558228835489ffff$var$store$3 = $558228835489ffff$var$global$k[$558228835489ffff$var$SHARED] || $558228835489ffff$var$defineGlobalProperty($558228835489ffff$var$SHARED, {});
var $558228835489ffff$var$sharedStore = $558228835489ffff$var$store$3;
var $558228835489ffff$var$store$2 = $558228835489ffff$var$sharedStore;
($558228835489ffff$var$shared$7.exports = function(key, value) {
    return $558228835489ffff$var$store$2[key] || ($558228835489ffff$var$store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: '3.33.2',
    mode: 'pure',
    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
    license: 'https://github.com/zloirock/core-js/blob/v3.33.2/LICENSE',
    source: 'https://github.com/zloirock/core-js'
});
var $558228835489ffff$var$sharedExports = $558228835489ffff$var$shared$7.exports;
var $558228835489ffff$var$requireObjectCoercible$1 = $558228835489ffff$var$requireObjectCoercible$3;
var $558228835489ffff$var$$Object$2 = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var $558228835489ffff$var$toObject$e = function(argument) {
    return $558228835489ffff$var$$Object$2($558228835489ffff$var$requireObjectCoercible$1(argument));
};
var $558228835489ffff$var$uncurryThis$m = $558228835489ffff$var$functionUncurryThis;
var $558228835489ffff$var$toObject$d = $558228835489ffff$var$toObject$e;
var $558228835489ffff$var$hasOwnProperty = $558228835489ffff$var$uncurryThis$m({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var $558228835489ffff$var$hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
    return $558228835489ffff$var$hasOwnProperty($558228835489ffff$var$toObject$d(it), key);
};
var $558228835489ffff$var$uncurryThis$l = $558228835489ffff$var$functionUncurryThis;
var $558228835489ffff$var$id$1 = 0;
var $558228835489ffff$var$postfix = Math.random();
var $558228835489ffff$var$toString$8 = $558228835489ffff$var$uncurryThis$l(1.0.toString);
var $558228835489ffff$var$uid$4 = function(key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + $558228835489ffff$var$toString$8(++$558228835489ffff$var$id$1 + $558228835489ffff$var$postfix, 36);
};
var $558228835489ffff$var$global$j = $558228835489ffff$var$global$p;
var $558228835489ffff$var$shared$6 = $558228835489ffff$var$sharedExports;
var $558228835489ffff$var$hasOwn$j = $558228835489ffff$var$hasOwnProperty_1;
var $558228835489ffff$var$uid$3 = $558228835489ffff$var$uid$4;
var $558228835489ffff$var$NATIVE_SYMBOL$4 = $558228835489ffff$var$symbolConstructorDetection;
var $558228835489ffff$var$USE_SYMBOL_AS_UID = $558228835489ffff$var$useSymbolAsUid;
var $558228835489ffff$var$Symbol$3 = $558228835489ffff$var$global$j.Symbol;
var $558228835489ffff$var$WellKnownSymbolsStore$2 = $558228835489ffff$var$shared$6('wks');
var $558228835489ffff$var$createWellKnownSymbol = $558228835489ffff$var$USE_SYMBOL_AS_UID ? $558228835489ffff$var$Symbol$3['for'] || $558228835489ffff$var$Symbol$3 : $558228835489ffff$var$Symbol$3 && $558228835489ffff$var$Symbol$3.withoutSetter || $558228835489ffff$var$uid$3;
var $558228835489ffff$var$wellKnownSymbol$n = function(name) {
    if (!$558228835489ffff$var$hasOwn$j($558228835489ffff$var$WellKnownSymbolsStore$2, name)) $558228835489ffff$var$WellKnownSymbolsStore$2[name] = $558228835489ffff$var$NATIVE_SYMBOL$4 && $558228835489ffff$var$hasOwn$j($558228835489ffff$var$Symbol$3, name) ? $558228835489ffff$var$Symbol$3[name] : $558228835489ffff$var$createWellKnownSymbol('Symbol.' + name);
    return $558228835489ffff$var$WellKnownSymbolsStore$2[name];
};
var $558228835489ffff$var$call$g = $558228835489ffff$var$functionCall;
var $558228835489ffff$var$isObject$f = $558228835489ffff$var$isObject$h;
var $558228835489ffff$var$isSymbol$4 = $558228835489ffff$var$isSymbol$5;
var $558228835489ffff$var$getMethod$2 = $558228835489ffff$var$getMethod$3;
var $558228835489ffff$var$ordinaryToPrimitive = $558228835489ffff$var$ordinaryToPrimitive$1;
var $558228835489ffff$var$wellKnownSymbol$m = $558228835489ffff$var$wellKnownSymbol$n;
var $558228835489ffff$var$$TypeError$d = TypeError;
var $558228835489ffff$var$TO_PRIMITIVE = $558228835489ffff$var$wellKnownSymbol$m('toPrimitive');
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var $558228835489ffff$var$toPrimitive$6 = function(input, pref) {
    if (!$558228835489ffff$var$isObject$f(input) || $558228835489ffff$var$isSymbol$4(input)) return input;
    var exoticToPrim = $558228835489ffff$var$getMethod$2(input, $558228835489ffff$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = $558228835489ffff$var$call$g(exoticToPrim, input, pref);
        if (!$558228835489ffff$var$isObject$f(result) || $558228835489ffff$var$isSymbol$4(result)) return result;
        throw new $558228835489ffff$var$$TypeError$d("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = 'number';
    return $558228835489ffff$var$ordinaryToPrimitive(input, pref);
};
var $558228835489ffff$var$toPrimitive$5 = $558228835489ffff$var$toPrimitive$6;
var $558228835489ffff$var$isSymbol$3 = $558228835489ffff$var$isSymbol$5;
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var $558228835489ffff$var$toPropertyKey$4 = function(argument) {
    var key = $558228835489ffff$var$toPrimitive$5(argument, 'string');
    return $558228835489ffff$var$isSymbol$3(key) ? key : key + '';
};
var $558228835489ffff$var$global$i = $558228835489ffff$var$global$p;
var $558228835489ffff$var$isObject$e = $558228835489ffff$var$isObject$h;
var $558228835489ffff$var$document$3 = $558228835489ffff$var$global$i.document;
// typeof document.createElement is 'object' in old IE
var $558228835489ffff$var$EXISTS$1 = $558228835489ffff$var$isObject$e($558228835489ffff$var$document$3) && $558228835489ffff$var$isObject$e($558228835489ffff$var$document$3.createElement);
var $558228835489ffff$var$documentCreateElement$1 = function(it) {
    return $558228835489ffff$var$EXISTS$1 ? $558228835489ffff$var$document$3.createElement(it) : {};
};
var $558228835489ffff$var$DESCRIPTORS$h = $558228835489ffff$var$descriptors;
var $558228835489ffff$var$fails$p = $558228835489ffff$var$fails$u;
var $558228835489ffff$var$createElement$1 = $558228835489ffff$var$documentCreateElement$1;
// Thanks to IE8 for its funny defineProperty
var $558228835489ffff$var$ie8DomDefine = !$558228835489ffff$var$DESCRIPTORS$h && !$558228835489ffff$var$fails$p(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($558228835489ffff$var$createElement$1('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a !== 7;
});
var $558228835489ffff$var$DESCRIPTORS$g = $558228835489ffff$var$descriptors;
var $558228835489ffff$var$call$f = $558228835489ffff$var$functionCall;
var $558228835489ffff$var$propertyIsEnumerableModule$2 = $558228835489ffff$var$objectPropertyIsEnumerable;
var $558228835489ffff$var$createPropertyDescriptor$6 = $558228835489ffff$var$createPropertyDescriptor$7;
var $558228835489ffff$var$toIndexedObject$9 = $558228835489ffff$var$toIndexedObject$a;
var $558228835489ffff$var$toPropertyKey$3 = $558228835489ffff$var$toPropertyKey$4;
var $558228835489ffff$var$hasOwn$i = $558228835489ffff$var$hasOwnProperty_1;
var $558228835489ffff$var$IE8_DOM_DEFINE$1 = $558228835489ffff$var$ie8DomDefine;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $558228835489ffff$var$$getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$558228835489ffff$var$objectGetOwnPropertyDescriptor.f = $558228835489ffff$var$DESCRIPTORS$g ? $558228835489ffff$var$$getOwnPropertyDescriptor$2 : function getOwnPropertyDescriptor(O, P) {
    O = $558228835489ffff$var$toIndexedObject$9(O);
    P = $558228835489ffff$var$toPropertyKey$3(P);
    if ($558228835489ffff$var$IE8_DOM_DEFINE$1) try {
        return $558228835489ffff$var$$getOwnPropertyDescriptor$2(O, P);
    } catch (error) {}
    if ($558228835489ffff$var$hasOwn$i(O, P)) return $558228835489ffff$var$createPropertyDescriptor$6(!$558228835489ffff$var$call$f($558228835489ffff$var$propertyIsEnumerableModule$2.f, O, P), O[P]);
};
var $558228835489ffff$var$fails$o = $558228835489ffff$var$fails$u;
var $558228835489ffff$var$isCallable$g = $558228835489ffff$var$isCallable$m;
var $558228835489ffff$var$replacement = /#|\.prototype\./;
var $558228835489ffff$var$isForced$2 = function(feature, detection) {
    var value = $558228835489ffff$var$data[$558228835489ffff$var$normalize(feature)];
    return value === $558228835489ffff$var$POLYFILL ? true : value === $558228835489ffff$var$NATIVE ? false : $558228835489ffff$var$isCallable$g(detection) ? $558228835489ffff$var$fails$o(detection) : !!detection;
};
var $558228835489ffff$var$normalize = $558228835489ffff$var$isForced$2.normalize = function(string) {
    return String(string).replace($558228835489ffff$var$replacement, '.').toLowerCase();
};
var $558228835489ffff$var$data = $558228835489ffff$var$isForced$2.data = {};
var $558228835489ffff$var$NATIVE = $558228835489ffff$var$isForced$2.NATIVE = 'N';
var $558228835489ffff$var$POLYFILL = $558228835489ffff$var$isForced$2.POLYFILL = 'P';
var $558228835489ffff$var$isForced_1 = $558228835489ffff$var$isForced$2;
var $558228835489ffff$var$uncurryThis$k = $558228835489ffff$var$functionUncurryThisClause;
var $558228835489ffff$var$aCallable$c = $558228835489ffff$var$aCallable$e;
var $558228835489ffff$var$NATIVE_BIND$1 = $558228835489ffff$var$functionBindNative;
var $558228835489ffff$var$bind$i = $558228835489ffff$var$uncurryThis$k($558228835489ffff$var$uncurryThis$k.bind);
// optional / simple context binding
var $558228835489ffff$var$functionBindContext = function(fn, that) {
    $558228835489ffff$var$aCallable$c(fn);
    return that === undefined ? fn : $558228835489ffff$var$NATIVE_BIND$1 ? $558228835489ffff$var$bind$i(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};
var $558228835489ffff$var$objectDefineProperty = {};
var $558228835489ffff$var$DESCRIPTORS$f = $558228835489ffff$var$descriptors;
var $558228835489ffff$var$fails$n = $558228835489ffff$var$fails$u;
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var $558228835489ffff$var$v8PrototypeDefineBug = $558228835489ffff$var$DESCRIPTORS$f && $558228835489ffff$var$fails$n(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, 'prototype', {
        value: 42,
        writable: false
    }).prototype !== 42;
});
var $558228835489ffff$var$isObject$d = $558228835489ffff$var$isObject$h;
var $558228835489ffff$var$$String$3 = String;
var $558228835489ffff$var$$TypeError$c = TypeError;
// `Assert: Type(argument) is Object`
var $558228835489ffff$var$anObject$d = function(argument) {
    if ($558228835489ffff$var$isObject$d(argument)) return argument;
    throw new $558228835489ffff$var$$TypeError$c($558228835489ffff$var$$String$3(argument) + ' is not an object');
};
var $558228835489ffff$var$DESCRIPTORS$e = $558228835489ffff$var$descriptors;
var $558228835489ffff$var$IE8_DOM_DEFINE = $558228835489ffff$var$ie8DomDefine;
var $558228835489ffff$var$V8_PROTOTYPE_DEFINE_BUG$1 = $558228835489ffff$var$v8PrototypeDefineBug;
var $558228835489ffff$var$anObject$c = $558228835489ffff$var$anObject$d;
var $558228835489ffff$var$toPropertyKey$2 = $558228835489ffff$var$toPropertyKey$4;
var $558228835489ffff$var$$TypeError$b = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $558228835489ffff$var$$defineProperty$1 = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $558228835489ffff$var$$getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var $558228835489ffff$var$ENUMERABLE = 'enumerable';
var $558228835489ffff$var$CONFIGURABLE$1 = 'configurable';
var $558228835489ffff$var$WRITABLE = 'writable';
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
$558228835489ffff$var$objectDefineProperty.f = $558228835489ffff$var$DESCRIPTORS$e ? $558228835489ffff$var$V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
    $558228835489ffff$var$anObject$c(O);
    P = $558228835489ffff$var$toPropertyKey$2(P);
    $558228835489ffff$var$anObject$c(Attributes);
    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && $558228835489ffff$var$WRITABLE in Attributes && !Attributes[$558228835489ffff$var$WRITABLE]) {
        var current = $558228835489ffff$var$$getOwnPropertyDescriptor$1(O, P);
        if (current && current[$558228835489ffff$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $558228835489ffff$var$CONFIGURABLE$1 in Attributes ? Attributes[$558228835489ffff$var$CONFIGURABLE$1] : current[$558228835489ffff$var$CONFIGURABLE$1],
                enumerable: $558228835489ffff$var$ENUMERABLE in Attributes ? Attributes[$558228835489ffff$var$ENUMERABLE] : current[$558228835489ffff$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $558228835489ffff$var$$defineProperty$1(O, P, Attributes);
} : $558228835489ffff$var$$defineProperty$1 : function defineProperty(O, P, Attributes) {
    $558228835489ffff$var$anObject$c(O);
    P = $558228835489ffff$var$toPropertyKey$2(P);
    $558228835489ffff$var$anObject$c(Attributes);
    if ($558228835489ffff$var$IE8_DOM_DEFINE) try {
        return $558228835489ffff$var$$defineProperty$1(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw new $558228835489ffff$var$$TypeError$b('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};
var $558228835489ffff$var$DESCRIPTORS$d = $558228835489ffff$var$descriptors;
var $558228835489ffff$var$definePropertyModule$4 = $558228835489ffff$var$objectDefineProperty;
var $558228835489ffff$var$createPropertyDescriptor$5 = $558228835489ffff$var$createPropertyDescriptor$7;
var $558228835489ffff$var$createNonEnumerableProperty$9 = $558228835489ffff$var$DESCRIPTORS$d ? function(object, key, value) {
    return $558228835489ffff$var$definePropertyModule$4.f(object, key, $558228835489ffff$var$createPropertyDescriptor$5(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};
var $558228835489ffff$var$global$h = $558228835489ffff$var$global$p;
var $558228835489ffff$var$apply$5 = $558228835489ffff$var$functionApply;
var $558228835489ffff$var$uncurryThis$j = $558228835489ffff$var$functionUncurryThisClause;
var $558228835489ffff$var$isCallable$f = $558228835489ffff$var$isCallable$m;
var $558228835489ffff$var$getOwnPropertyDescriptor$6 = $558228835489ffff$var$objectGetOwnPropertyDescriptor.f;
var $558228835489ffff$var$isForced$1 = $558228835489ffff$var$isForced_1;
var $558228835489ffff$var$path$m = $558228835489ffff$var$path$o;
var $558228835489ffff$var$bind$h = $558228835489ffff$var$functionBindContext;
var $558228835489ffff$var$createNonEnumerableProperty$8 = $558228835489ffff$var$createNonEnumerableProperty$9;
var $558228835489ffff$var$hasOwn$h = $558228835489ffff$var$hasOwnProperty_1;
var $558228835489ffff$var$wrapConstructor = function(NativeConstructor) {
    var Wrapper = function(a, b, c) {
        if (this instanceof Wrapper) {
            switch(arguments.length){
                case 0:
                    return new NativeConstructor();
                case 1:
                    return new NativeConstructor(a);
                case 2:
                    return new NativeConstructor(a, b);
            }
            return new NativeConstructor(a, b, c);
        }
        return $558228835489ffff$var$apply$5(NativeConstructor, this, arguments);
    };
    Wrapper.prototype = NativeConstructor.prototype;
    return Wrapper;
};
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ var $558228835489ffff$var$_export = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var PROTO = options.proto;
    var nativeSource = GLOBAL ? $558228835489ffff$var$global$h : STATIC ? $558228835489ffff$var$global$h[TARGET] : ($558228835489ffff$var$global$h[TARGET] || {}).prototype;
    var target = GLOBAL ? $558228835489ffff$var$path$m : $558228835489ffff$var$path$m[TARGET] || $558228835489ffff$var$createNonEnumerableProperty$8($558228835489ffff$var$path$m, TARGET, {})[TARGET];
    var targetPrototype = target.prototype;
    var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
    var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;
    for(key in source){
        FORCED = $558228835489ffff$var$isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contains in native
        USE_NATIVE = !FORCED && nativeSource && $558228835489ffff$var$hasOwn$h(nativeSource, key);
        targetProperty = target[key];
        if (USE_NATIVE) {
            if (options.dontCallGetSet) {
                descriptor = $558228835489ffff$var$getOwnPropertyDescriptor$6(nativeSource, key);
                nativeProperty = descriptor && descriptor.value;
            } else nativeProperty = nativeSource[key];
        }
        // export native or implementation
        sourceProperty = USE_NATIVE && nativeProperty ? nativeProperty : source[key];
        if (USE_NATIVE && typeof targetProperty == typeof sourceProperty) continue;
        // bind methods to global for calling from export context
        if (options.bind && USE_NATIVE) resultProperty = $558228835489ffff$var$bind$h(sourceProperty, $558228835489ffff$var$global$h);
        else if (options.wrap && USE_NATIVE) resultProperty = $558228835489ffff$var$wrapConstructor(sourceProperty);
        else if (PROTO && $558228835489ffff$var$isCallable$f(sourceProperty)) resultProperty = $558228835489ffff$var$uncurryThis$j(sourceProperty);
        else resultProperty = sourceProperty;
        // add a flag to not completely full polyfills
        if (options.sham || sourceProperty && sourceProperty.sham || targetProperty && targetProperty.sham) $558228835489ffff$var$createNonEnumerableProperty$8(resultProperty, 'sham', true);
        $558228835489ffff$var$createNonEnumerableProperty$8(target, key, resultProperty);
        if (PROTO) {
            VIRTUAL_PROTOTYPE = TARGET + 'Prototype';
            if (!$558228835489ffff$var$hasOwn$h($558228835489ffff$var$path$m, VIRTUAL_PROTOTYPE)) $558228835489ffff$var$createNonEnumerableProperty$8($558228835489ffff$var$path$m, VIRTUAL_PROTOTYPE, {});
            // export virtual prototype methods
            $558228835489ffff$var$createNonEnumerableProperty$8($558228835489ffff$var$path$m[VIRTUAL_PROTOTYPE], key, sourceProperty);
            // export real prototype methods
            if (options.real && targetPrototype && (FORCED || !targetPrototype[key])) $558228835489ffff$var$createNonEnumerableProperty$8(targetPrototype, key, sourceProperty);
        }
    }
};
var $558228835489ffff$var$$$P = $558228835489ffff$var$_export;
var $558228835489ffff$var$DESCRIPTORS$c = $558228835489ffff$var$descriptors;
var $558228835489ffff$var$defineProperty$d = $558228835489ffff$var$objectDefineProperty.f;
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
// eslint-disable-next-line es/no-object-defineproperty -- safe
$558228835489ffff$var$$$P({
    target: 'Object',
    stat: true,
    forced: Object.defineProperty !== $558228835489ffff$var$defineProperty$d,
    sham: !$558228835489ffff$var$DESCRIPTORS$c
}, {
    defineProperty: $558228835489ffff$var$defineProperty$d
});
var $558228835489ffff$var$path$l = $558228835489ffff$var$path$o;
var $558228835489ffff$var$Object$4 = $558228835489ffff$var$path$l.Object;
var $558228835489ffff$var$defineProperty$c = $558228835489ffff$var$defineProperty$f.exports = function defineProperty(it, key, desc) {
    return $558228835489ffff$var$Object$4.defineProperty(it, key, desc);
};
if ($558228835489ffff$var$Object$4.defineProperty.sham) $558228835489ffff$var$defineProperty$c.sham = true;
var $558228835489ffff$var$definePropertyExports = $558228835489ffff$var$defineProperty$f.exports;
var $558228835489ffff$var$parent$18 = $558228835489ffff$var$definePropertyExports;
var $558228835489ffff$var$defineProperty$b = $558228835489ffff$var$parent$18;
var $558228835489ffff$var$parent$17 = $558228835489ffff$var$defineProperty$b;
var $558228835489ffff$var$defineProperty$a = $558228835489ffff$var$parent$17;
var $558228835489ffff$var$parent$16 = $558228835489ffff$var$defineProperty$a;
var $558228835489ffff$var$defineProperty$9 = $558228835489ffff$var$parent$16;
var $558228835489ffff$var$defineProperty$8 = $558228835489ffff$var$defineProperty$9;
var $558228835489ffff$var$_Object$defineProperty$1 = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$defineProperty$8);
var $558228835489ffff$var$classof$e = $558228835489ffff$var$classofRaw$2;
// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var $558228835489ffff$var$isArray$e = Array.isArray || function isArray(argument) {
    return $558228835489ffff$var$classof$e(argument) === 'Array';
};
var $558228835489ffff$var$ceil = Math.ceil;
var $558228835489ffff$var$floor$1 = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var $558228835489ffff$var$mathTrunc = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $558228835489ffff$var$floor$1 : $558228835489ffff$var$ceil)(n);
};
var $558228835489ffff$var$trunc = $558228835489ffff$var$mathTrunc;
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var $558228835489ffff$var$toIntegerOrInfinity$4 = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $558228835489ffff$var$trunc(number);
};
var $558228835489ffff$var$toIntegerOrInfinity$3 = $558228835489ffff$var$toIntegerOrInfinity$4;
var $558228835489ffff$var$min$2 = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var $558228835489ffff$var$toLength$1 = function(argument) {
    return argument > 0 ? $558228835489ffff$var$min$2($558228835489ffff$var$toIntegerOrInfinity$3(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
var $558228835489ffff$var$toLength = $558228835489ffff$var$toLength$1;
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var $558228835489ffff$var$lengthOfArrayLike$d = function(obj) {
    return $558228835489ffff$var$toLength(obj.length);
};
var $558228835489ffff$var$$TypeError$a = TypeError;
var $558228835489ffff$var$MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991
var $558228835489ffff$var$doesNotExceedSafeInteger$4 = function(it) {
    if (it > $558228835489ffff$var$MAX_SAFE_INTEGER) throw $558228835489ffff$var$$TypeError$a('Maximum allowed index exceeded');
    return it;
};
var $558228835489ffff$var$toPropertyKey$1 = $558228835489ffff$var$toPropertyKey$4;
var $558228835489ffff$var$definePropertyModule$3 = $558228835489ffff$var$objectDefineProperty;
var $558228835489ffff$var$createPropertyDescriptor$4 = $558228835489ffff$var$createPropertyDescriptor$7;
var $558228835489ffff$var$createProperty$6 = function(object, key, value) {
    var propertyKey = $558228835489ffff$var$toPropertyKey$1(key);
    if (propertyKey in object) $558228835489ffff$var$definePropertyModule$3.f(object, propertyKey, $558228835489ffff$var$createPropertyDescriptor$4(0, value));
    else object[propertyKey] = value;
};
var $558228835489ffff$var$wellKnownSymbol$l = $558228835489ffff$var$wellKnownSymbol$n;
var $558228835489ffff$var$TO_STRING_TAG$4 = $558228835489ffff$var$wellKnownSymbol$l('toStringTag');
var $558228835489ffff$var$test$2 = {};
$558228835489ffff$var$test$2[$558228835489ffff$var$TO_STRING_TAG$4] = 'z';
var $558228835489ffff$var$toStringTagSupport = String($558228835489ffff$var$test$2) === '[object z]';
var $558228835489ffff$var$TO_STRING_TAG_SUPPORT$2 = $558228835489ffff$var$toStringTagSupport;
var $558228835489ffff$var$isCallable$e = $558228835489ffff$var$isCallable$m;
var $558228835489ffff$var$classofRaw = $558228835489ffff$var$classofRaw$2;
var $558228835489ffff$var$wellKnownSymbol$k = $558228835489ffff$var$wellKnownSymbol$n;
var $558228835489ffff$var$TO_STRING_TAG$3 = $558228835489ffff$var$wellKnownSymbol$k('toStringTag');
var $558228835489ffff$var$$Object$1 = Object;
// ES3 wrong here
var $558228835489ffff$var$CORRECT_ARGUMENTS = $558228835489ffff$var$classofRaw(function() {
    return arguments;
}()) === 'Arguments';
// fallback for IE11 Script Access Denied error
var $558228835489ffff$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
var $558228835489ffff$var$classof$d = $558228835489ffff$var$TO_STRING_TAG_SUPPORT$2 ? $558228835489ffff$var$classofRaw : function(it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = $558228835489ffff$var$tryGet(O = $558228835489ffff$var$$Object$1(it), $558228835489ffff$var$TO_STRING_TAG$3)) == 'string' ? tag : $558228835489ffff$var$CORRECT_ARGUMENTS ? $558228835489ffff$var$classofRaw(O) : (result = $558228835489ffff$var$classofRaw(O)) === 'Object' && $558228835489ffff$var$isCallable$e(O.callee) ? 'Arguments' : result;
};
var $558228835489ffff$var$uncurryThis$i = $558228835489ffff$var$functionUncurryThis;
var $558228835489ffff$var$isCallable$d = $558228835489ffff$var$isCallable$m;
var $558228835489ffff$var$store$1 = $558228835489ffff$var$sharedStore;
var $558228835489ffff$var$functionToString = $558228835489ffff$var$uncurryThis$i(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$558228835489ffff$var$isCallable$d($558228835489ffff$var$store$1.inspectSource)) $558228835489ffff$var$store$1.inspectSource = function(it) {
    return $558228835489ffff$var$functionToString(it);
};
var $558228835489ffff$var$inspectSource$2 = $558228835489ffff$var$store$1.inspectSource;
var $558228835489ffff$var$uncurryThis$h = $558228835489ffff$var$functionUncurryThis;
var $558228835489ffff$var$fails$m = $558228835489ffff$var$fails$u;
var $558228835489ffff$var$isCallable$c = $558228835489ffff$var$isCallable$m;
var $558228835489ffff$var$classof$c = $558228835489ffff$var$classof$d;
var $558228835489ffff$var$getBuiltIn$d = $558228835489ffff$var$getBuiltIn$f;
var $558228835489ffff$var$inspectSource$1 = $558228835489ffff$var$inspectSource$2;
var $558228835489ffff$var$noop = function() {};
var $558228835489ffff$var$empty = [];
var $558228835489ffff$var$construct$4 = $558228835489ffff$var$getBuiltIn$d('Reflect', 'construct');
var $558228835489ffff$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $558228835489ffff$var$exec$1 = $558228835489ffff$var$uncurryThis$h($558228835489ffff$var$constructorRegExp.exec);
var $558228835489ffff$var$INCORRECT_TO_STRING = !$558228835489ffff$var$constructorRegExp.test($558228835489ffff$var$noop);
var $558228835489ffff$var$isConstructorModern = function isConstructor(argument) {
    if (!$558228835489ffff$var$isCallable$c(argument)) return false;
    try {
        $558228835489ffff$var$construct$4($558228835489ffff$var$noop, $558228835489ffff$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $558228835489ffff$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$558228835489ffff$var$isCallable$c(argument)) return false;
    switch($558228835489ffff$var$classof$c(argument)){
        case 'AsyncFunction':
        case 'GeneratorFunction':
        case 'AsyncGeneratorFunction':
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $558228835489ffff$var$INCORRECT_TO_STRING || !!$558228835489ffff$var$exec$1($558228835489ffff$var$constructorRegExp, $558228835489ffff$var$inspectSource$1(argument));
    } catch (error) {
        return true;
    }
};
$558228835489ffff$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var $558228835489ffff$var$isConstructor$4 = !$558228835489ffff$var$construct$4 || $558228835489ffff$var$fails$m(function() {
    var called;
    return $558228835489ffff$var$isConstructorModern($558228835489ffff$var$isConstructorModern.call) || !$558228835489ffff$var$isConstructorModern(Object) || !$558228835489ffff$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $558228835489ffff$var$isConstructorLegacy : $558228835489ffff$var$isConstructorModern;
var $558228835489ffff$var$isArray$d = $558228835489ffff$var$isArray$e;
var $558228835489ffff$var$isConstructor$3 = $558228835489ffff$var$isConstructor$4;
var $558228835489ffff$var$isObject$c = $558228835489ffff$var$isObject$h;
var $558228835489ffff$var$wellKnownSymbol$j = $558228835489ffff$var$wellKnownSymbol$n;
var $558228835489ffff$var$SPECIES$5 = $558228835489ffff$var$wellKnownSymbol$j('species');
var $558228835489ffff$var$$Array$3 = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var $558228835489ffff$var$arraySpeciesConstructor$1 = function(originalArray) {
    var C;
    if ($558228835489ffff$var$isArray$d(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($558228835489ffff$var$isConstructor$3(C) && (C === $558228835489ffff$var$$Array$3 || $558228835489ffff$var$isArray$d(C.prototype))) C = undefined;
        else if ($558228835489ffff$var$isObject$c(C)) {
            C = C[$558228835489ffff$var$SPECIES$5];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $558228835489ffff$var$$Array$3 : C;
};
var $558228835489ffff$var$arraySpeciesConstructor = $558228835489ffff$var$arraySpeciesConstructor$1;
// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var $558228835489ffff$var$arraySpeciesCreate$4 = function(originalArray, length) {
    return new ($558228835489ffff$var$arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};
var $558228835489ffff$var$fails$l = $558228835489ffff$var$fails$u;
var $558228835489ffff$var$wellKnownSymbol$i = $558228835489ffff$var$wellKnownSymbol$n;
var $558228835489ffff$var$V8_VERSION$2 = $558228835489ffff$var$engineV8Version;
var $558228835489ffff$var$SPECIES$4 = $558228835489ffff$var$wellKnownSymbol$i('species');
var $558228835489ffff$var$arrayMethodHasSpeciesSupport$5 = function(METHOD_NAME) {
    // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/677
    return $558228835489ffff$var$V8_VERSION$2 >= 51 || !$558228835489ffff$var$fails$l(function() {
        var array = [];
        var constructor = array.constructor = {};
        constructor[$558228835489ffff$var$SPECIES$4] = function() {
            return {
                foo: 1
            };
        };
        return array[METHOD_NAME](Boolean).foo !== 1;
    });
};
var $558228835489ffff$var$$$O = $558228835489ffff$var$_export;
var $558228835489ffff$var$fails$k = $558228835489ffff$var$fails$u;
var $558228835489ffff$var$isArray$c = $558228835489ffff$var$isArray$e;
var $558228835489ffff$var$isObject$b = $558228835489ffff$var$isObject$h;
var $558228835489ffff$var$toObject$c = $558228835489ffff$var$toObject$e;
var $558228835489ffff$var$lengthOfArrayLike$c = $558228835489ffff$var$lengthOfArrayLike$d;
var $558228835489ffff$var$doesNotExceedSafeInteger$3 = $558228835489ffff$var$doesNotExceedSafeInteger$4;
var $558228835489ffff$var$createProperty$5 = $558228835489ffff$var$createProperty$6;
var $558228835489ffff$var$arraySpeciesCreate$3 = $558228835489ffff$var$arraySpeciesCreate$4;
var $558228835489ffff$var$arrayMethodHasSpeciesSupport$4 = $558228835489ffff$var$arrayMethodHasSpeciesSupport$5;
var $558228835489ffff$var$wellKnownSymbol$h = $558228835489ffff$var$wellKnownSymbol$n;
var $558228835489ffff$var$V8_VERSION$1 = $558228835489ffff$var$engineV8Version;
var $558228835489ffff$var$IS_CONCAT_SPREADABLE = $558228835489ffff$var$wellKnownSymbol$h('isConcatSpreadable');
// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var $558228835489ffff$var$IS_CONCAT_SPREADABLE_SUPPORT = $558228835489ffff$var$V8_VERSION$1 >= 51 || !$558228835489ffff$var$fails$k(function() {
    var array = [];
    array[$558228835489ffff$var$IS_CONCAT_SPREADABLE] = false;
    return array.concat()[0] !== array;
});
var $558228835489ffff$var$isConcatSpreadable = function(O) {
    if (!$558228835489ffff$var$isObject$b(O)) return false;
    var spreadable = O[$558228835489ffff$var$IS_CONCAT_SPREADABLE];
    return spreadable !== undefined ? !!spreadable : $558228835489ffff$var$isArray$c(O);
};
var $558228835489ffff$var$FORCED$6 = !$558228835489ffff$var$IS_CONCAT_SPREADABLE_SUPPORT || !$558228835489ffff$var$arrayMethodHasSpeciesSupport$4('concat');
// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$558228835489ffff$var$$$O({
    target: 'Array',
    proto: true,
    arity: 1,
    forced: $558228835489ffff$var$FORCED$6
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    concat: function concat(arg) {
        var O = $558228835489ffff$var$toObject$c(this);
        var A = $558228835489ffff$var$arraySpeciesCreate$3(O, 0);
        var n = 0;
        var i, k, length, len, E;
        for(i = -1, length = arguments.length; i < length; i++){
            E = i === -1 ? O : arguments[i];
            if ($558228835489ffff$var$isConcatSpreadable(E)) {
                len = $558228835489ffff$var$lengthOfArrayLike$c(E);
                $558228835489ffff$var$doesNotExceedSafeInteger$3(n + len);
                for(k = 0; k < len; k++, n++)if (k in E) $558228835489ffff$var$createProperty$5(A, n, E[k]);
            } else {
                $558228835489ffff$var$doesNotExceedSafeInteger$3(n + 1);
                $558228835489ffff$var$createProperty$5(A, n++, E);
            }
        }
        A.length = n;
        return A;
    }
});
var $558228835489ffff$var$classof$b = $558228835489ffff$var$classof$d;
var $558228835489ffff$var$$String$2 = String;
var $558228835489ffff$var$toString$7 = function(argument) {
    if ($558228835489ffff$var$classof$b(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
    return $558228835489ffff$var$$String$2(argument);
};
var $558228835489ffff$var$objectDefineProperties = {};
var $558228835489ffff$var$toIntegerOrInfinity$2 = $558228835489ffff$var$toIntegerOrInfinity$4;
var $558228835489ffff$var$max$3 = Math.max;
var $558228835489ffff$var$min$1 = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var $558228835489ffff$var$toAbsoluteIndex$4 = function(index, length) {
    var integer = $558228835489ffff$var$toIntegerOrInfinity$2(index);
    return integer < 0 ? $558228835489ffff$var$max$3(integer + length, 0) : $558228835489ffff$var$min$1(integer, length);
};
var $558228835489ffff$var$toIndexedObject$8 = $558228835489ffff$var$toIndexedObject$a;
var $558228835489ffff$var$toAbsoluteIndex$3 = $558228835489ffff$var$toAbsoluteIndex$4;
var $558228835489ffff$var$lengthOfArrayLike$b = $558228835489ffff$var$lengthOfArrayLike$d;
// `Array.prototype.{ indexOf, includes }` methods implementation
var $558228835489ffff$var$createMethod$3 = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $558228835489ffff$var$toIndexedObject$8($this);
        var length = $558228835489ffff$var$lengthOfArrayLike$b(O);
        var index = $558228835489ffff$var$toAbsoluteIndex$3(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
var $558228835489ffff$var$arrayIncludes = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $558228835489ffff$var$createMethod$3(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $558228835489ffff$var$createMethod$3(false)
};
var $558228835489ffff$var$hiddenKeys$6 = {};
var $558228835489ffff$var$uncurryThis$g = $558228835489ffff$var$functionUncurryThis;
var $558228835489ffff$var$hasOwn$g = $558228835489ffff$var$hasOwnProperty_1;
var $558228835489ffff$var$toIndexedObject$7 = $558228835489ffff$var$toIndexedObject$a;
var $558228835489ffff$var$indexOf = $558228835489ffff$var$arrayIncludes.indexOf;
var $558228835489ffff$var$hiddenKeys$5 = $558228835489ffff$var$hiddenKeys$6;
var $558228835489ffff$var$push$c = $558228835489ffff$var$uncurryThis$g([].push);
var $558228835489ffff$var$objectKeysInternal = function(object, names) {
    var O = $558228835489ffff$var$toIndexedObject$7(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$558228835489ffff$var$hasOwn$g($558228835489ffff$var$hiddenKeys$5, key) && $558228835489ffff$var$hasOwn$g(O, key) && $558228835489ffff$var$push$c(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($558228835489ffff$var$hasOwn$g(O, key = names[i++])) ~$558228835489ffff$var$indexOf(result, key) || $558228835489ffff$var$push$c(result, key);
    return result;
};
// IE8- don't enum bug keys
var $558228835489ffff$var$enumBugKeys$3 = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];
var $558228835489ffff$var$internalObjectKeys$1 = $558228835489ffff$var$objectKeysInternal;
var $558228835489ffff$var$enumBugKeys$2 = $558228835489ffff$var$enumBugKeys$3;
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var $558228835489ffff$var$objectKeys$3 = Object.keys || function keys(O) {
    return $558228835489ffff$var$internalObjectKeys$1(O, $558228835489ffff$var$enumBugKeys$2);
};
var $558228835489ffff$var$DESCRIPTORS$b = $558228835489ffff$var$descriptors;
var $558228835489ffff$var$V8_PROTOTYPE_DEFINE_BUG = $558228835489ffff$var$v8PrototypeDefineBug;
var $558228835489ffff$var$definePropertyModule$2 = $558228835489ffff$var$objectDefineProperty;
var $558228835489ffff$var$anObject$b = $558228835489ffff$var$anObject$d;
var $558228835489ffff$var$toIndexedObject$6 = $558228835489ffff$var$toIndexedObject$a;
var $558228835489ffff$var$objectKeys$2 = $558228835489ffff$var$objectKeys$3;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
$558228835489ffff$var$objectDefineProperties.f = $558228835489ffff$var$DESCRIPTORS$b && !$558228835489ffff$var$V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
    $558228835489ffff$var$anObject$b(O);
    var props = $558228835489ffff$var$toIndexedObject$6(Properties);
    var keys = $558228835489ffff$var$objectKeys$2(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$558228835489ffff$var$definePropertyModule$2.f(O, key = keys[index++], props[key]);
    return O;
};
var $558228835489ffff$var$getBuiltIn$c = $558228835489ffff$var$getBuiltIn$f;
var $558228835489ffff$var$html$2 = $558228835489ffff$var$getBuiltIn$c('document', 'documentElement');
var $558228835489ffff$var$shared$5 = $558228835489ffff$var$sharedExports;
var $558228835489ffff$var$uid$2 = $558228835489ffff$var$uid$4;
var $558228835489ffff$var$keys$7 = $558228835489ffff$var$shared$5('keys');
var $558228835489ffff$var$sharedKey$4 = function(key) {
    return $558228835489ffff$var$keys$7[key] || ($558228835489ffff$var$keys$7[key] = $558228835489ffff$var$uid$2(key));
};
/* global ActiveXObject -- old IE, WSH */ var $558228835489ffff$var$anObject$a = $558228835489ffff$var$anObject$d;
var $558228835489ffff$var$definePropertiesModule$1 = $558228835489ffff$var$objectDefineProperties;
var $558228835489ffff$var$enumBugKeys$1 = $558228835489ffff$var$enumBugKeys$3;
var $558228835489ffff$var$hiddenKeys$4 = $558228835489ffff$var$hiddenKeys$6;
var $558228835489ffff$var$html$1 = $558228835489ffff$var$html$2;
var $558228835489ffff$var$documentCreateElement = $558228835489ffff$var$documentCreateElement$1;
var $558228835489ffff$var$sharedKey$3 = $558228835489ffff$var$sharedKey$4;
var $558228835489ffff$var$GT = '>';
var $558228835489ffff$var$LT = '<';
var $558228835489ffff$var$PROTOTYPE$1 = 'prototype';
var $558228835489ffff$var$SCRIPT = 'script';
var $558228835489ffff$var$IE_PROTO$1 = $558228835489ffff$var$sharedKey$3('IE_PROTO');
var $558228835489ffff$var$EmptyConstructor = function() {};
var $558228835489ffff$var$scriptTag = function(content) {
    return $558228835489ffff$var$LT + $558228835489ffff$var$SCRIPT + $558228835489ffff$var$GT + content + $558228835489ffff$var$LT + '/' + $558228835489ffff$var$SCRIPT + $558228835489ffff$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $558228835489ffff$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($558228835489ffff$var$scriptTag(''));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $558228835489ffff$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $558228835489ffff$var$documentCreateElement('iframe');
    var JS = 'java' + $558228835489ffff$var$SCRIPT + ':';
    var iframeDocument;
    iframe.style.display = 'none';
    $558228835489ffff$var$html$1.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($558228835489ffff$var$scriptTag('document.F=Object'));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $558228835489ffff$var$activeXDocument;
var $558228835489ffff$var$NullProtoObject = function() {
    try {
        $558228835489ffff$var$activeXDocument = new ActiveXObject('htmlfile');
    } catch (error) {}
    $558228835489ffff$var$NullProtoObject = typeof document != 'undefined' ? document.domain && $558228835489ffff$var$activeXDocument ? $558228835489ffff$var$NullProtoObjectViaActiveX($558228835489ffff$var$activeXDocument) // old IE
     : $558228835489ffff$var$NullProtoObjectViaIFrame() : $558228835489ffff$var$NullProtoObjectViaActiveX($558228835489ffff$var$activeXDocument); // WSH
    var length = $558228835489ffff$var$enumBugKeys$1.length;
    while(length--)delete $558228835489ffff$var$NullProtoObject[$558228835489ffff$var$PROTOTYPE$1][$558228835489ffff$var$enumBugKeys$1[length]];
    return $558228835489ffff$var$NullProtoObject();
};
$558228835489ffff$var$hiddenKeys$4[$558228835489ffff$var$IE_PROTO$1] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var $558228835489ffff$var$objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $558228835489ffff$var$EmptyConstructor[$558228835489ffff$var$PROTOTYPE$1] = $558228835489ffff$var$anObject$a(O);
        result = new $558228835489ffff$var$EmptyConstructor();
        $558228835489ffff$var$EmptyConstructor[$558228835489ffff$var$PROTOTYPE$1] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$558228835489ffff$var$IE_PROTO$1] = O;
    } else result = $558228835489ffff$var$NullProtoObject();
    return Properties === undefined ? result : $558228835489ffff$var$definePropertiesModule$1.f(result, Properties);
};
var $558228835489ffff$var$objectGetOwnPropertyNames = {};
var $558228835489ffff$var$internalObjectKeys = $558228835489ffff$var$objectKeysInternal;
var $558228835489ffff$var$enumBugKeys = $558228835489ffff$var$enumBugKeys$3;
var $558228835489ffff$var$hiddenKeys$3 = $558228835489ffff$var$enumBugKeys.concat('length', 'prototype');
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
$558228835489ffff$var$objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $558228835489ffff$var$internalObjectKeys(O, $558228835489ffff$var$hiddenKeys$3);
};
var $558228835489ffff$var$objectGetOwnPropertyNamesExternal = {};
var $558228835489ffff$var$toAbsoluteIndex$2 = $558228835489ffff$var$toAbsoluteIndex$4;
var $558228835489ffff$var$lengthOfArrayLike$a = $558228835489ffff$var$lengthOfArrayLike$d;
var $558228835489ffff$var$createProperty$4 = $558228835489ffff$var$createProperty$6;
var $558228835489ffff$var$$Array$2 = Array;
var $558228835489ffff$var$max$2 = Math.max;
var $558228835489ffff$var$arraySliceSimple = function(O, start, end) {
    var length = $558228835489ffff$var$lengthOfArrayLike$a(O);
    var k = $558228835489ffff$var$toAbsoluteIndex$2(start, length);
    var fin = $558228835489ffff$var$toAbsoluteIndex$2(end === undefined ? length : end, length);
    var result = $558228835489ffff$var$$Array$2($558228835489ffff$var$max$2(fin - k, 0));
    var n = 0;
    for(; k < fin; k++, n++)$558228835489ffff$var$createProperty$4(result, n, O[k]);
    result.length = n;
    return result;
};
/* eslint-disable es/no-object-getownpropertynames -- safe */ var $558228835489ffff$var$classof$a = $558228835489ffff$var$classofRaw$2;
var $558228835489ffff$var$toIndexedObject$5 = $558228835489ffff$var$toIndexedObject$a;
var $558228835489ffff$var$$getOwnPropertyNames$1 = $558228835489ffff$var$objectGetOwnPropertyNames.f;
var $558228835489ffff$var$arraySlice$6 = $558228835489ffff$var$arraySliceSimple;
var $558228835489ffff$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $558228835489ffff$var$getWindowNames = function(it) {
    try {
        return $558228835489ffff$var$$getOwnPropertyNames$1(it);
    } catch (error) {
        return $558228835489ffff$var$arraySlice$6($558228835489ffff$var$windowNames);
    }
};
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
$558228835489ffff$var$objectGetOwnPropertyNamesExternal.f = function getOwnPropertyNames(it) {
    return $558228835489ffff$var$windowNames && $558228835489ffff$var$classof$a(it) === 'Window' ? $558228835489ffff$var$getWindowNames(it) : $558228835489ffff$var$$getOwnPropertyNames$1($558228835489ffff$var$toIndexedObject$5(it));
};
var $558228835489ffff$var$objectGetOwnPropertySymbols = {};
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
$558228835489ffff$var$objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var $558228835489ffff$var$createNonEnumerableProperty$7 = $558228835489ffff$var$createNonEnumerableProperty$9;
var $558228835489ffff$var$defineBuiltIn$6 = function(target, key, value, options) {
    if (options && options.enumerable) target[key] = value;
    else $558228835489ffff$var$createNonEnumerableProperty$7(target, key, value);
    return target;
};
var $558228835489ffff$var$defineProperty$7 = $558228835489ffff$var$objectDefineProperty;
var $558228835489ffff$var$defineBuiltInAccessor$3 = function(target, name, descriptor) {
    return $558228835489ffff$var$defineProperty$7.f(target, name, descriptor);
};
var $558228835489ffff$var$wellKnownSymbolWrapped = {};
var $558228835489ffff$var$wellKnownSymbol$g = $558228835489ffff$var$wellKnownSymbol$n;
$558228835489ffff$var$wellKnownSymbolWrapped.f = $558228835489ffff$var$wellKnownSymbol$g;
var $558228835489ffff$var$path$k = $558228835489ffff$var$path$o;
var $558228835489ffff$var$hasOwn$f = $558228835489ffff$var$hasOwnProperty_1;
var $558228835489ffff$var$wrappedWellKnownSymbolModule$1 = $558228835489ffff$var$wellKnownSymbolWrapped;
var $558228835489ffff$var$defineProperty$6 = $558228835489ffff$var$objectDefineProperty.f;
var $558228835489ffff$var$wellKnownSymbolDefine = function(NAME) {
    var Symbol1 = $558228835489ffff$var$path$k.Symbol || ($558228835489ffff$var$path$k.Symbol = {});
    if (!$558228835489ffff$var$hasOwn$f(Symbol1, NAME)) $558228835489ffff$var$defineProperty$6(Symbol1, NAME, {
        value: $558228835489ffff$var$wrappedWellKnownSymbolModule$1.f(NAME)
    });
};
var $558228835489ffff$var$call$e = $558228835489ffff$var$functionCall;
var $558228835489ffff$var$getBuiltIn$b = $558228835489ffff$var$getBuiltIn$f;
var $558228835489ffff$var$wellKnownSymbol$f = $558228835489ffff$var$wellKnownSymbol$n;
var $558228835489ffff$var$defineBuiltIn$5 = $558228835489ffff$var$defineBuiltIn$6;
var $558228835489ffff$var$symbolDefineToPrimitive = function() {
    var Symbol1 = $558228835489ffff$var$getBuiltIn$b('Symbol');
    var SymbolPrototype = Symbol1 && Symbol1.prototype;
    var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
    var TO_PRIMITIVE = $558228835489ffff$var$wellKnownSymbol$f('toPrimitive');
    if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    $558228835489ffff$var$defineBuiltIn$5(SymbolPrototype, TO_PRIMITIVE, function(hint) {
        return $558228835489ffff$var$call$e(valueOf, this);
    }, {
        arity: 1
    });
};
var $558228835489ffff$var$TO_STRING_TAG_SUPPORT$1 = $558228835489ffff$var$toStringTagSupport;
var $558228835489ffff$var$classof$9 = $558228835489ffff$var$classof$d;
// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
var $558228835489ffff$var$objectToString = $558228835489ffff$var$TO_STRING_TAG_SUPPORT$1 ? ({}).toString : function toString() {
    return '[object ' + $558228835489ffff$var$classof$9(this) + ']';
};
var $558228835489ffff$var$TO_STRING_TAG_SUPPORT = $558228835489ffff$var$toStringTagSupport;
var $558228835489ffff$var$defineProperty$5 = $558228835489ffff$var$objectDefineProperty.f;
var $558228835489ffff$var$createNonEnumerableProperty$6 = $558228835489ffff$var$createNonEnumerableProperty$9;
var $558228835489ffff$var$hasOwn$e = $558228835489ffff$var$hasOwnProperty_1;
var $558228835489ffff$var$toString$6 = $558228835489ffff$var$objectToString;
var $558228835489ffff$var$wellKnownSymbol$e = $558228835489ffff$var$wellKnownSymbol$n;
var $558228835489ffff$var$TO_STRING_TAG$2 = $558228835489ffff$var$wellKnownSymbol$e('toStringTag');
var $558228835489ffff$var$setToStringTag$7 = function(it, TAG, STATIC, SET_METHOD) {
    if (it) {
        var target = STATIC ? it : it.prototype;
        if (!$558228835489ffff$var$hasOwn$e(target, $558228835489ffff$var$TO_STRING_TAG$2)) $558228835489ffff$var$defineProperty$5(target, $558228835489ffff$var$TO_STRING_TAG$2, {
            configurable: true,
            value: TAG
        });
        if (SET_METHOD && !$558228835489ffff$var$TO_STRING_TAG_SUPPORT) $558228835489ffff$var$createNonEnumerableProperty$6(target, 'toString', $558228835489ffff$var$toString$6);
    }
};
var $558228835489ffff$var$global$g = $558228835489ffff$var$global$p;
var $558228835489ffff$var$isCallable$b = $558228835489ffff$var$isCallable$m;
var $558228835489ffff$var$WeakMap$1 = $558228835489ffff$var$global$g.WeakMap;
var $558228835489ffff$var$weakMapBasicDetection = $558228835489ffff$var$isCallable$b($558228835489ffff$var$WeakMap$1) && /native code/.test(String($558228835489ffff$var$WeakMap$1));
var $558228835489ffff$var$NATIVE_WEAK_MAP = $558228835489ffff$var$weakMapBasicDetection;
var $558228835489ffff$var$global$f = $558228835489ffff$var$global$p;
var $558228835489ffff$var$isObject$a = $558228835489ffff$var$isObject$h;
var $558228835489ffff$var$createNonEnumerableProperty$5 = $558228835489ffff$var$createNonEnumerableProperty$9;
var $558228835489ffff$var$hasOwn$d = $558228835489ffff$var$hasOwnProperty_1;
var $558228835489ffff$var$shared$4 = $558228835489ffff$var$sharedStore;
var $558228835489ffff$var$sharedKey$2 = $558228835489ffff$var$sharedKey$4;
var $558228835489ffff$var$hiddenKeys$2 = $558228835489ffff$var$hiddenKeys$6;
var $558228835489ffff$var$OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var $558228835489ffff$var$TypeError$3 = $558228835489ffff$var$global$f.TypeError;
var $558228835489ffff$var$WeakMap = $558228835489ffff$var$global$f.WeakMap;
var $558228835489ffff$var$set$4, $558228835489ffff$var$get, $558228835489ffff$var$has;
var $558228835489ffff$var$enforce = function(it) {
    return $558228835489ffff$var$has(it) ? $558228835489ffff$var$get(it) : $558228835489ffff$var$set$4(it, {});
};
var $558228835489ffff$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$558228835489ffff$var$isObject$a(it) || (state = $558228835489ffff$var$get(it)).type !== TYPE) throw new $558228835489ffff$var$TypeError$3('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if ($558228835489ffff$var$NATIVE_WEAK_MAP || $558228835489ffff$var$shared$4.state) {
    var $558228835489ffff$var$store = $558228835489ffff$var$shared$4.state || ($558228835489ffff$var$shared$4.state = new $558228835489ffff$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $558228835489ffff$var$store.get = $558228835489ffff$var$store.get;
    $558228835489ffff$var$store.has = $558228835489ffff$var$store.has;
    $558228835489ffff$var$store.set = $558228835489ffff$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $558228835489ffff$var$set$4 = function(it, metadata) {
        if ($558228835489ffff$var$store.has(it)) throw new $558228835489ffff$var$TypeError$3($558228835489ffff$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $558228835489ffff$var$store.set(it, metadata);
        return metadata;
    };
    $558228835489ffff$var$get = function(it) {
        return $558228835489ffff$var$store.get(it) || {};
    };
    $558228835489ffff$var$has = function(it) {
        return $558228835489ffff$var$store.has(it);
    };
} else {
    var $558228835489ffff$var$STATE = $558228835489ffff$var$sharedKey$2('state');
    $558228835489ffff$var$hiddenKeys$2[$558228835489ffff$var$STATE] = true;
    $558228835489ffff$var$set$4 = function(it, metadata) {
        if ($558228835489ffff$var$hasOwn$d(it, $558228835489ffff$var$STATE)) throw new $558228835489ffff$var$TypeError$3($558228835489ffff$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $558228835489ffff$var$createNonEnumerableProperty$5(it, $558228835489ffff$var$STATE, metadata);
        return metadata;
    };
    $558228835489ffff$var$get = function(it) {
        return $558228835489ffff$var$hasOwn$d(it, $558228835489ffff$var$STATE) ? it[$558228835489ffff$var$STATE] : {};
    };
    $558228835489ffff$var$has = function(it) {
        return $558228835489ffff$var$hasOwn$d(it, $558228835489ffff$var$STATE);
    };
}
var $558228835489ffff$var$internalState = {
    set: $558228835489ffff$var$set$4,
    get: $558228835489ffff$var$get,
    has: $558228835489ffff$var$has,
    enforce: $558228835489ffff$var$enforce,
    getterFor: $558228835489ffff$var$getterFor
};
var $558228835489ffff$var$bind$g = $558228835489ffff$var$functionBindContext;
var $558228835489ffff$var$uncurryThis$f = $558228835489ffff$var$functionUncurryThis;
var $558228835489ffff$var$IndexedObject$2 = $558228835489ffff$var$indexedObject;
var $558228835489ffff$var$toObject$b = $558228835489ffff$var$toObject$e;
var $558228835489ffff$var$lengthOfArrayLike$9 = $558228835489ffff$var$lengthOfArrayLike$d;
var $558228835489ffff$var$arraySpeciesCreate$2 = $558228835489ffff$var$arraySpeciesCreate$4;
var $558228835489ffff$var$push$b = $558228835489ffff$var$uncurryThis$f([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $558228835489ffff$var$createMethod$2 = function(TYPE) {
    var IS_MAP = TYPE === 1;
    var IS_FILTER = TYPE === 2;
    var IS_SOME = TYPE === 3;
    var IS_EVERY = TYPE === 4;
    var IS_FIND_INDEX = TYPE === 6;
    var IS_FILTER_REJECT = TYPE === 7;
    var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $558228835489ffff$var$toObject$b($this);
        var self1 = $558228835489ffff$var$IndexedObject$2(O);
        var boundFunction = $558228835489ffff$var$bind$g(callbackfn, that);
        var length = $558228835489ffff$var$lengthOfArrayLike$9(self1);
        var index = 0;
        var create = specificCreate || $558228835489ffff$var$arraySpeciesCreate$2;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self1) {
            value = self1[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $558228835489ffff$var$push$b(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $558228835489ffff$var$push$b(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
var $558228835489ffff$var$arrayIteration = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $558228835489ffff$var$createMethod$2(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $558228835489ffff$var$createMethod$2(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $558228835489ffff$var$createMethod$2(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $558228835489ffff$var$createMethod$2(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $558228835489ffff$var$createMethod$2(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $558228835489ffff$var$createMethod$2(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $558228835489ffff$var$createMethod$2(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $558228835489ffff$var$createMethod$2(7)
};
var $558228835489ffff$var$$$N = $558228835489ffff$var$_export;
var $558228835489ffff$var$global$e = $558228835489ffff$var$global$p;
var $558228835489ffff$var$call$d = $558228835489ffff$var$functionCall;
var $558228835489ffff$var$uncurryThis$e = $558228835489ffff$var$functionUncurryThis;
var $558228835489ffff$var$DESCRIPTORS$a = $558228835489ffff$var$descriptors;
var $558228835489ffff$var$NATIVE_SYMBOL$3 = $558228835489ffff$var$symbolConstructorDetection;
var $558228835489ffff$var$fails$j = $558228835489ffff$var$fails$u;
var $558228835489ffff$var$hasOwn$c = $558228835489ffff$var$hasOwnProperty_1;
var $558228835489ffff$var$isPrototypeOf$j = $558228835489ffff$var$objectIsPrototypeOf;
var $558228835489ffff$var$anObject$9 = $558228835489ffff$var$anObject$d;
var $558228835489ffff$var$toIndexedObject$4 = $558228835489ffff$var$toIndexedObject$a;
var $558228835489ffff$var$toPropertyKey = $558228835489ffff$var$toPropertyKey$4;
var $558228835489ffff$var$$toString = $558228835489ffff$var$toString$7;
var $558228835489ffff$var$createPropertyDescriptor$3 = $558228835489ffff$var$createPropertyDescriptor$7;
var $558228835489ffff$var$nativeObjectCreate = $558228835489ffff$var$objectCreate;
var $558228835489ffff$var$objectKeys$1 = $558228835489ffff$var$objectKeys$3;
var $558228835489ffff$var$getOwnPropertyNamesModule$2 = $558228835489ffff$var$objectGetOwnPropertyNames;
var $558228835489ffff$var$getOwnPropertyNamesExternal = $558228835489ffff$var$objectGetOwnPropertyNamesExternal;
var $558228835489ffff$var$getOwnPropertySymbolsModule$3 = $558228835489ffff$var$objectGetOwnPropertySymbols;
var $558228835489ffff$var$getOwnPropertyDescriptorModule$2 = $558228835489ffff$var$objectGetOwnPropertyDescriptor;
var $558228835489ffff$var$definePropertyModule$1 = $558228835489ffff$var$objectDefineProperty;
var $558228835489ffff$var$definePropertiesModule = $558228835489ffff$var$objectDefineProperties;
var $558228835489ffff$var$propertyIsEnumerableModule$1 = $558228835489ffff$var$objectPropertyIsEnumerable;
var $558228835489ffff$var$defineBuiltIn$4 = $558228835489ffff$var$defineBuiltIn$6;
var $558228835489ffff$var$defineBuiltInAccessor$2 = $558228835489ffff$var$defineBuiltInAccessor$3;
var $558228835489ffff$var$shared$3 = $558228835489ffff$var$sharedExports;
var $558228835489ffff$var$sharedKey$1 = $558228835489ffff$var$sharedKey$4;
var $558228835489ffff$var$hiddenKeys$1 = $558228835489ffff$var$hiddenKeys$6;
var $558228835489ffff$var$uid$1 = $558228835489ffff$var$uid$4;
var $558228835489ffff$var$wellKnownSymbol$d = $558228835489ffff$var$wellKnownSymbol$n;
var $558228835489ffff$var$wrappedWellKnownSymbolModule = $558228835489ffff$var$wellKnownSymbolWrapped;
var $558228835489ffff$var$defineWellKnownSymbol$l = $558228835489ffff$var$wellKnownSymbolDefine;
var $558228835489ffff$var$defineSymbolToPrimitive$1 = $558228835489ffff$var$symbolDefineToPrimitive;
var $558228835489ffff$var$setToStringTag$6 = $558228835489ffff$var$setToStringTag$7;
var $558228835489ffff$var$InternalStateModule$5 = $558228835489ffff$var$internalState;
var $558228835489ffff$var$$forEach$1 = $558228835489ffff$var$arrayIteration.forEach;
var $558228835489ffff$var$HIDDEN = $558228835489ffff$var$sharedKey$1('hidden');
var $558228835489ffff$var$SYMBOL = 'Symbol';
var $558228835489ffff$var$PROTOTYPE = 'prototype';
var $558228835489ffff$var$setInternalState$5 = $558228835489ffff$var$InternalStateModule$5.set;
var $558228835489ffff$var$getInternalState$2 = $558228835489ffff$var$InternalStateModule$5.getterFor($558228835489ffff$var$SYMBOL);
var $558228835489ffff$var$ObjectPrototype$2 = Object[$558228835489ffff$var$PROTOTYPE];
var $558228835489ffff$var$$Symbol = $558228835489ffff$var$global$e.Symbol;
var $558228835489ffff$var$SymbolPrototype = $558228835489ffff$var$$Symbol && $558228835489ffff$var$$Symbol[$558228835489ffff$var$PROTOTYPE];
var $558228835489ffff$var$RangeError = $558228835489ffff$var$global$e.RangeError;
var $558228835489ffff$var$TypeError$2 = $558228835489ffff$var$global$e.TypeError;
var $558228835489ffff$var$QObject = $558228835489ffff$var$global$e.QObject;
var $558228835489ffff$var$nativeGetOwnPropertyDescriptor$1 = $558228835489ffff$var$getOwnPropertyDescriptorModule$2.f;
var $558228835489ffff$var$nativeDefineProperty = $558228835489ffff$var$definePropertyModule$1.f;
var $558228835489ffff$var$nativeGetOwnPropertyNames = $558228835489ffff$var$getOwnPropertyNamesExternal.f;
var $558228835489ffff$var$nativePropertyIsEnumerable = $558228835489ffff$var$propertyIsEnumerableModule$1.f;
var $558228835489ffff$var$push$a = $558228835489ffff$var$uncurryThis$e([].push);
var $558228835489ffff$var$AllSymbols = $558228835489ffff$var$shared$3('symbols');
var $558228835489ffff$var$ObjectPrototypeSymbols = $558228835489ffff$var$shared$3('op-symbols');
var $558228835489ffff$var$WellKnownSymbolsStore$1 = $558228835489ffff$var$shared$3('wks');
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $558228835489ffff$var$USE_SETTER = !$558228835489ffff$var$QObject || !$558228835489ffff$var$QObject[$558228835489ffff$var$PROTOTYPE] || !$558228835489ffff$var$QObject[$558228835489ffff$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $558228835489ffff$var$fallbackDefineProperty = function(O, P, Attributes) {
    var ObjectPrototypeDescriptor = $558228835489ffff$var$nativeGetOwnPropertyDescriptor$1($558228835489ffff$var$ObjectPrototype$2, P);
    if (ObjectPrototypeDescriptor) delete $558228835489ffff$var$ObjectPrototype$2[P];
    $558228835489ffff$var$nativeDefineProperty(O, P, Attributes);
    if (ObjectPrototypeDescriptor && O !== $558228835489ffff$var$ObjectPrototype$2) $558228835489ffff$var$nativeDefineProperty($558228835489ffff$var$ObjectPrototype$2, P, ObjectPrototypeDescriptor);
};
var $558228835489ffff$var$setSymbolDescriptor = $558228835489ffff$var$DESCRIPTORS$a && $558228835489ffff$var$fails$j(function() {
    return $558228835489ffff$var$nativeObjectCreate($558228835489ffff$var$nativeDefineProperty({}, 'a', {
        get: function() {
            return $558228835489ffff$var$nativeDefineProperty(this, 'a', {
                value: 7
            }).a;
        }
    })).a !== 7;
}) ? $558228835489ffff$var$fallbackDefineProperty : $558228835489ffff$var$nativeDefineProperty;
var $558228835489ffff$var$wrap = function(tag, description) {
    var symbol = $558228835489ffff$var$AllSymbols[tag] = $558228835489ffff$var$nativeObjectCreate($558228835489ffff$var$SymbolPrototype);
    $558228835489ffff$var$setInternalState$5(symbol, {
        type: $558228835489ffff$var$SYMBOL,
        tag: tag,
        description: description
    });
    if (!$558228835489ffff$var$DESCRIPTORS$a) symbol.description = description;
    return symbol;
};
var $558228835489ffff$var$$defineProperty = function defineProperty(O, P, Attributes) {
    if (O === $558228835489ffff$var$ObjectPrototype$2) $558228835489ffff$var$$defineProperty($558228835489ffff$var$ObjectPrototypeSymbols, P, Attributes);
    $558228835489ffff$var$anObject$9(O);
    var key = $558228835489ffff$var$toPropertyKey(P);
    $558228835489ffff$var$anObject$9(Attributes);
    if ($558228835489ffff$var$hasOwn$c($558228835489ffff$var$AllSymbols, key)) {
        if (!Attributes.enumerable) {
            if (!$558228835489ffff$var$hasOwn$c(O, $558228835489ffff$var$HIDDEN)) $558228835489ffff$var$nativeDefineProperty(O, $558228835489ffff$var$HIDDEN, $558228835489ffff$var$createPropertyDescriptor$3(1, {}));
            O[$558228835489ffff$var$HIDDEN][key] = true;
        } else {
            if ($558228835489ffff$var$hasOwn$c(O, $558228835489ffff$var$HIDDEN) && O[$558228835489ffff$var$HIDDEN][key]) O[$558228835489ffff$var$HIDDEN][key] = false;
            Attributes = $558228835489ffff$var$nativeObjectCreate(Attributes, {
                enumerable: $558228835489ffff$var$createPropertyDescriptor$3(0, false)
            });
        }
        return $558228835489ffff$var$setSymbolDescriptor(O, key, Attributes);
    }
    return $558228835489ffff$var$nativeDefineProperty(O, key, Attributes);
};
var $558228835489ffff$var$$defineProperties = function defineProperties(O, Properties) {
    $558228835489ffff$var$anObject$9(O);
    var properties = $558228835489ffff$var$toIndexedObject$4(Properties);
    var keys = $558228835489ffff$var$objectKeys$1(properties).concat($558228835489ffff$var$$getOwnPropertySymbols(properties));
    $558228835489ffff$var$$forEach$1(keys, function(key) {
        if (!$558228835489ffff$var$DESCRIPTORS$a || $558228835489ffff$var$call$d($558228835489ffff$var$$propertyIsEnumerable, properties, key)) $558228835489ffff$var$$defineProperty(O, key, properties[key]);
    });
    return O;
};
var $558228835489ffff$var$$create = function create(O, Properties) {
    return Properties === undefined ? $558228835489ffff$var$nativeObjectCreate(O) : $558228835489ffff$var$$defineProperties($558228835489ffff$var$nativeObjectCreate(O), Properties);
};
var $558228835489ffff$var$$propertyIsEnumerable = function propertyIsEnumerable(V) {
    var P = $558228835489ffff$var$toPropertyKey(V);
    var enumerable = $558228835489ffff$var$call$d($558228835489ffff$var$nativePropertyIsEnumerable, this, P);
    if (this === $558228835489ffff$var$ObjectPrototype$2 && $558228835489ffff$var$hasOwn$c($558228835489ffff$var$AllSymbols, P) && !$558228835489ffff$var$hasOwn$c($558228835489ffff$var$ObjectPrototypeSymbols, P)) return false;
    return enumerable || !$558228835489ffff$var$hasOwn$c(this, P) || !$558228835489ffff$var$hasOwn$c($558228835489ffff$var$AllSymbols, P) || $558228835489ffff$var$hasOwn$c(this, $558228835489ffff$var$HIDDEN) && this[$558228835489ffff$var$HIDDEN][P] ? enumerable : true;
};
var $558228835489ffff$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
    var it = $558228835489ffff$var$toIndexedObject$4(O);
    var key = $558228835489ffff$var$toPropertyKey(P);
    if (it === $558228835489ffff$var$ObjectPrototype$2 && $558228835489ffff$var$hasOwn$c($558228835489ffff$var$AllSymbols, key) && !$558228835489ffff$var$hasOwn$c($558228835489ffff$var$ObjectPrototypeSymbols, key)) return;
    var descriptor = $558228835489ffff$var$nativeGetOwnPropertyDescriptor$1(it, key);
    if (descriptor && $558228835489ffff$var$hasOwn$c($558228835489ffff$var$AllSymbols, key) && !($558228835489ffff$var$hasOwn$c(it, $558228835489ffff$var$HIDDEN) && it[$558228835489ffff$var$HIDDEN][key])) descriptor.enumerable = true;
    return descriptor;
};
var $558228835489ffff$var$$getOwnPropertyNames = function getOwnPropertyNames(O) {
    var names = $558228835489ffff$var$nativeGetOwnPropertyNames($558228835489ffff$var$toIndexedObject$4(O));
    var result = [];
    $558228835489ffff$var$$forEach$1(names, function(key) {
        if (!$558228835489ffff$var$hasOwn$c($558228835489ffff$var$AllSymbols, key) && !$558228835489ffff$var$hasOwn$c($558228835489ffff$var$hiddenKeys$1, key)) $558228835489ffff$var$push$a(result, key);
    });
    return result;
};
var $558228835489ffff$var$$getOwnPropertySymbols = function(O) {
    var IS_OBJECT_PROTOTYPE = O === $558228835489ffff$var$ObjectPrototype$2;
    var names = $558228835489ffff$var$nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? $558228835489ffff$var$ObjectPrototypeSymbols : $558228835489ffff$var$toIndexedObject$4(O));
    var result = [];
    $558228835489ffff$var$$forEach$1(names, function(key) {
        if ($558228835489ffff$var$hasOwn$c($558228835489ffff$var$AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || $558228835489ffff$var$hasOwn$c($558228835489ffff$var$ObjectPrototype$2, key))) $558228835489ffff$var$push$a(result, $558228835489ffff$var$AllSymbols[key]);
    });
    return result;
};
// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!$558228835489ffff$var$NATIVE_SYMBOL$3) {
    $558228835489ffff$var$$Symbol = function Symbol1() {
        if ($558228835489ffff$var$isPrototypeOf$j($558228835489ffff$var$SymbolPrototype, this)) throw new $558228835489ffff$var$TypeError$2('Symbol is not a constructor');
        var description = !arguments.length || arguments[0] === undefined ? undefined : $558228835489ffff$var$$toString(arguments[0]);
        var tag = $558228835489ffff$var$uid$1(description);
        var setter = function(value) {
            var $this = this === undefined ? $558228835489ffff$var$global$e : this;
            if ($this === $558228835489ffff$var$ObjectPrototype$2) $558228835489ffff$var$call$d(setter, $558228835489ffff$var$ObjectPrototypeSymbols, value);
            if ($558228835489ffff$var$hasOwn$c($this, $558228835489ffff$var$HIDDEN) && $558228835489ffff$var$hasOwn$c($this[$558228835489ffff$var$HIDDEN], tag)) $this[$558228835489ffff$var$HIDDEN][tag] = false;
            var descriptor = $558228835489ffff$var$createPropertyDescriptor$3(1, value);
            try {
                $558228835489ffff$var$setSymbolDescriptor($this, tag, descriptor);
            } catch (error) {
                if (!(error instanceof $558228835489ffff$var$RangeError)) throw error;
                $558228835489ffff$var$fallbackDefineProperty($this, tag, descriptor);
            }
        };
        if ($558228835489ffff$var$DESCRIPTORS$a && $558228835489ffff$var$USE_SETTER) $558228835489ffff$var$setSymbolDescriptor($558228835489ffff$var$ObjectPrototype$2, tag, {
            configurable: true,
            set: setter
        });
        return $558228835489ffff$var$wrap(tag, description);
    };
    $558228835489ffff$var$SymbolPrototype = $558228835489ffff$var$$Symbol[$558228835489ffff$var$PROTOTYPE];
    $558228835489ffff$var$defineBuiltIn$4($558228835489ffff$var$SymbolPrototype, 'toString', function toString() {
        return $558228835489ffff$var$getInternalState$2(this).tag;
    });
    $558228835489ffff$var$defineBuiltIn$4($558228835489ffff$var$$Symbol, 'withoutSetter', function(description) {
        return $558228835489ffff$var$wrap($558228835489ffff$var$uid$1(description), description);
    });
    $558228835489ffff$var$propertyIsEnumerableModule$1.f = $558228835489ffff$var$$propertyIsEnumerable;
    $558228835489ffff$var$definePropertyModule$1.f = $558228835489ffff$var$$defineProperty;
    $558228835489ffff$var$definePropertiesModule.f = $558228835489ffff$var$$defineProperties;
    $558228835489ffff$var$getOwnPropertyDescriptorModule$2.f = $558228835489ffff$var$$getOwnPropertyDescriptor;
    $558228835489ffff$var$getOwnPropertyNamesModule$2.f = $558228835489ffff$var$getOwnPropertyNamesExternal.f = $558228835489ffff$var$$getOwnPropertyNames;
    $558228835489ffff$var$getOwnPropertySymbolsModule$3.f = $558228835489ffff$var$$getOwnPropertySymbols;
    $558228835489ffff$var$wrappedWellKnownSymbolModule.f = function(name) {
        return $558228835489ffff$var$wrap($558228835489ffff$var$wellKnownSymbol$d(name), name);
    };
    if ($558228835489ffff$var$DESCRIPTORS$a) // https://github.com/tc39/proposal-Symbol-description
    $558228835489ffff$var$defineBuiltInAccessor$2($558228835489ffff$var$SymbolPrototype, 'description', {
        configurable: true,
        get: function description() {
            return $558228835489ffff$var$getInternalState$2(this).description;
        }
    });
}
$558228835489ffff$var$$$N({
    global: true,
    constructor: true,
    wrap: true,
    forced: !$558228835489ffff$var$NATIVE_SYMBOL$3,
    sham: !$558228835489ffff$var$NATIVE_SYMBOL$3
}, {
    Symbol: $558228835489ffff$var$$Symbol
});
$558228835489ffff$var$$forEach$1($558228835489ffff$var$objectKeys$1($558228835489ffff$var$WellKnownSymbolsStore$1), function(name) {
    $558228835489ffff$var$defineWellKnownSymbol$l(name);
});
$558228835489ffff$var$$$N({
    target: $558228835489ffff$var$SYMBOL,
    stat: true,
    forced: !$558228835489ffff$var$NATIVE_SYMBOL$3
}, {
    useSetter: function() {
        $558228835489ffff$var$USE_SETTER = true;
    },
    useSimple: function() {
        $558228835489ffff$var$USE_SETTER = false;
    }
});
$558228835489ffff$var$$$N({
    target: 'Object',
    stat: true,
    forced: !$558228835489ffff$var$NATIVE_SYMBOL$3,
    sham: !$558228835489ffff$var$DESCRIPTORS$a
}, {
    // `Object.create` method
    // https://tc39.es/ecma262/#sec-object.create
    create: $558228835489ffff$var$$create,
    // `Object.defineProperty` method
    // https://tc39.es/ecma262/#sec-object.defineproperty
    defineProperty: $558228835489ffff$var$$defineProperty,
    // `Object.defineProperties` method
    // https://tc39.es/ecma262/#sec-object.defineproperties
    defineProperties: $558228835489ffff$var$$defineProperties,
    // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
    getOwnPropertyDescriptor: $558228835489ffff$var$$getOwnPropertyDescriptor
});
$558228835489ffff$var$$$N({
    target: 'Object',
    stat: true,
    forced: !$558228835489ffff$var$NATIVE_SYMBOL$3
}, {
    // `Object.getOwnPropertyNames` method
    // https://tc39.es/ecma262/#sec-object.getownpropertynames
    getOwnPropertyNames: $558228835489ffff$var$$getOwnPropertyNames
});
// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
$558228835489ffff$var$defineSymbolToPrimitive$1();
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
$558228835489ffff$var$setToStringTag$6($558228835489ffff$var$$Symbol, $558228835489ffff$var$SYMBOL);
$558228835489ffff$var$hiddenKeys$1[$558228835489ffff$var$HIDDEN] = true;
var $558228835489ffff$var$NATIVE_SYMBOL$2 = $558228835489ffff$var$symbolConstructorDetection;
/* eslint-disable es/no-symbol -- safe */ var $558228835489ffff$var$symbolRegistryDetection = $558228835489ffff$var$NATIVE_SYMBOL$2 && !!Symbol['for'] && !!Symbol.keyFor;
var $558228835489ffff$var$$$M = $558228835489ffff$var$_export;
var $558228835489ffff$var$getBuiltIn$a = $558228835489ffff$var$getBuiltIn$f;
var $558228835489ffff$var$hasOwn$b = $558228835489ffff$var$hasOwnProperty_1;
var $558228835489ffff$var$toString$5 = $558228835489ffff$var$toString$7;
var $558228835489ffff$var$shared$2 = $558228835489ffff$var$sharedExports;
var $558228835489ffff$var$NATIVE_SYMBOL_REGISTRY$1 = $558228835489ffff$var$symbolRegistryDetection;
var $558228835489ffff$var$StringToSymbolRegistry = $558228835489ffff$var$shared$2('string-to-symbol-registry');
var $558228835489ffff$var$SymbolToStringRegistry$1 = $558228835489ffff$var$shared$2('symbol-to-string-registry');
// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$558228835489ffff$var$$$M({
    target: 'Symbol',
    stat: true,
    forced: !$558228835489ffff$var$NATIVE_SYMBOL_REGISTRY$1
}, {
    'for': function(key) {
        var string = $558228835489ffff$var$toString$5(key);
        if ($558228835489ffff$var$hasOwn$b($558228835489ffff$var$StringToSymbolRegistry, string)) return $558228835489ffff$var$StringToSymbolRegistry[string];
        var symbol = $558228835489ffff$var$getBuiltIn$a('Symbol')(string);
        $558228835489ffff$var$StringToSymbolRegistry[string] = symbol;
        $558228835489ffff$var$SymbolToStringRegistry$1[symbol] = string;
        return symbol;
    }
});
var $558228835489ffff$var$$$L = $558228835489ffff$var$_export;
var $558228835489ffff$var$hasOwn$a = $558228835489ffff$var$hasOwnProperty_1;
var $558228835489ffff$var$isSymbol$2 = $558228835489ffff$var$isSymbol$5;
var $558228835489ffff$var$tryToString$4 = $558228835489ffff$var$tryToString$6;
var $558228835489ffff$var$shared$1 = $558228835489ffff$var$sharedExports;
var $558228835489ffff$var$NATIVE_SYMBOL_REGISTRY = $558228835489ffff$var$symbolRegistryDetection;
var $558228835489ffff$var$SymbolToStringRegistry = $558228835489ffff$var$shared$1('symbol-to-string-registry');
// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$558228835489ffff$var$$$L({
    target: 'Symbol',
    stat: true,
    forced: !$558228835489ffff$var$NATIVE_SYMBOL_REGISTRY
}, {
    keyFor: function keyFor(sym) {
        if (!$558228835489ffff$var$isSymbol$2(sym)) throw new TypeError($558228835489ffff$var$tryToString$4(sym) + ' is not a symbol');
        if ($558228835489ffff$var$hasOwn$a($558228835489ffff$var$SymbolToStringRegistry, sym)) return $558228835489ffff$var$SymbolToStringRegistry[sym];
    }
});
var $558228835489ffff$var$uncurryThis$d = $558228835489ffff$var$functionUncurryThis;
var $558228835489ffff$var$arraySlice$5 = $558228835489ffff$var$uncurryThis$d([].slice);
var $558228835489ffff$var$uncurryThis$c = $558228835489ffff$var$functionUncurryThis;
var $558228835489ffff$var$isArray$b = $558228835489ffff$var$isArray$e;
var $558228835489ffff$var$isCallable$a = $558228835489ffff$var$isCallable$m;
var $558228835489ffff$var$classof$8 = $558228835489ffff$var$classofRaw$2;
var $558228835489ffff$var$toString$4 = $558228835489ffff$var$toString$7;
var $558228835489ffff$var$push$9 = $558228835489ffff$var$uncurryThis$c([].push);
var $558228835489ffff$var$getJsonReplacerFunction = function(replacer) {
    if ($558228835489ffff$var$isCallable$a(replacer)) return replacer;
    if (!$558228835489ffff$var$isArray$b(replacer)) return;
    var rawLength = replacer.length;
    var keys = [];
    for(var i = 0; i < rawLength; i++){
        var element = replacer[i];
        if (typeof element == 'string') $558228835489ffff$var$push$9(keys, element);
        else if (typeof element == 'number' || $558228835489ffff$var$classof$8(element) === 'Number' || $558228835489ffff$var$classof$8(element) === 'String') $558228835489ffff$var$push$9(keys, $558228835489ffff$var$toString$4(element));
    }
    var keysLength = keys.length;
    var root = true;
    return function(key, value) {
        if (root) {
            root = false;
            return value;
        }
        if ($558228835489ffff$var$isArray$b(this)) return value;
        for(var j = 0; j < keysLength; j++)if (keys[j] === key) return value;
    };
};
var $558228835489ffff$var$$$K = $558228835489ffff$var$_export;
var $558228835489ffff$var$getBuiltIn$9 = $558228835489ffff$var$getBuiltIn$f;
var $558228835489ffff$var$apply$4 = $558228835489ffff$var$functionApply;
var $558228835489ffff$var$call$c = $558228835489ffff$var$functionCall;
var $558228835489ffff$var$uncurryThis$b = $558228835489ffff$var$functionUncurryThis;
var $558228835489ffff$var$fails$i = $558228835489ffff$var$fails$u;
var $558228835489ffff$var$isCallable$9 = $558228835489ffff$var$isCallable$m;
var $558228835489ffff$var$isSymbol$1 = $558228835489ffff$var$isSymbol$5;
var $558228835489ffff$var$arraySlice$4 = $558228835489ffff$var$arraySlice$5;
var $558228835489ffff$var$getReplacerFunction = $558228835489ffff$var$getJsonReplacerFunction;
var $558228835489ffff$var$NATIVE_SYMBOL$1 = $558228835489ffff$var$symbolConstructorDetection;
var $558228835489ffff$var$$String$1 = String;
var $558228835489ffff$var$$stringify = $558228835489ffff$var$getBuiltIn$9('JSON', 'stringify');
var $558228835489ffff$var$exec = $558228835489ffff$var$uncurryThis$b(/./.exec);
var $558228835489ffff$var$charAt$2 = $558228835489ffff$var$uncurryThis$b(''.charAt);
var $558228835489ffff$var$charCodeAt$1 = $558228835489ffff$var$uncurryThis$b(''.charCodeAt);
var $558228835489ffff$var$replace$1 = $558228835489ffff$var$uncurryThis$b(''.replace);
var $558228835489ffff$var$numberToString = $558228835489ffff$var$uncurryThis$b(1.0.toString);
var $558228835489ffff$var$tester = /[\uD800-\uDFFF]/g;
var $558228835489ffff$var$low = /^[\uD800-\uDBFF]$/;
var $558228835489ffff$var$hi = /^[\uDC00-\uDFFF]$/;
var $558228835489ffff$var$WRONG_SYMBOLS_CONVERSION = !$558228835489ffff$var$NATIVE_SYMBOL$1 || $558228835489ffff$var$fails$i(function() {
    var symbol = $558228835489ffff$var$getBuiltIn$9('Symbol')('stringify detection');
    // MS Edge converts symbol values to JSON as {}
    return $558228835489ffff$var$$stringify([
        symbol
    ]) !== '[null]' || $558228835489ffff$var$$stringify({
        a: symbol
    }) !== '{}' || $558228835489ffff$var$$stringify(Object(symbol)) !== '{}';
});
// https://github.com/tc39/proposal-well-formed-stringify
var $558228835489ffff$var$ILL_FORMED_UNICODE = $558228835489ffff$var$fails$i(function() {
    return $558228835489ffff$var$$stringify('\uDF06\uD834') !== '"\\udf06\\ud834"' || $558228835489ffff$var$$stringify('\uDEAD') !== '"\\udead"';
});
var $558228835489ffff$var$stringifyWithSymbolsFix = function(it, replacer) {
    var args = $558228835489ffff$var$arraySlice$4(arguments);
    var $replacer = $558228835489ffff$var$getReplacerFunction(replacer);
    if (!$558228835489ffff$var$isCallable$9($replacer) && (it === undefined || $558228835489ffff$var$isSymbol$1(it))) return; // IE8 returns string on undefined
    args[1] = function(key, value) {
        // some old implementations (like WebKit) could pass numbers as keys
        if ($558228835489ffff$var$isCallable$9($replacer)) value = $558228835489ffff$var$call$c($replacer, this, $558228835489ffff$var$$String$1(key), value);
        if (!$558228835489ffff$var$isSymbol$1(value)) return value;
    };
    return $558228835489ffff$var$apply$4($558228835489ffff$var$$stringify, null, args);
};
var $558228835489ffff$var$fixIllFormed = function(match, offset, string) {
    var prev = $558228835489ffff$var$charAt$2(string, offset - 1);
    var next = $558228835489ffff$var$charAt$2(string, offset + 1);
    if ($558228835489ffff$var$exec($558228835489ffff$var$low, match) && !$558228835489ffff$var$exec($558228835489ffff$var$hi, next) || $558228835489ffff$var$exec($558228835489ffff$var$hi, match) && !$558228835489ffff$var$exec($558228835489ffff$var$low, prev)) return '\\u' + $558228835489ffff$var$numberToString($558228835489ffff$var$charCodeAt$1(match, 0), 16);
    return match;
};
if ($558228835489ffff$var$$stringify) // `JSON.stringify` method
// https://tc39.es/ecma262/#sec-json.stringify
$558228835489ffff$var$$$K({
    target: 'JSON',
    stat: true,
    arity: 3,
    forced: $558228835489ffff$var$WRONG_SYMBOLS_CONVERSION || $558228835489ffff$var$ILL_FORMED_UNICODE
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
        var args = $558228835489ffff$var$arraySlice$4(arguments);
        var result = $558228835489ffff$var$apply$4($558228835489ffff$var$WRONG_SYMBOLS_CONVERSION ? $558228835489ffff$var$stringifyWithSymbolsFix : $558228835489ffff$var$$stringify, null, args);
        return $558228835489ffff$var$ILL_FORMED_UNICODE && typeof result == 'string' ? $558228835489ffff$var$replace$1(result, $558228835489ffff$var$tester, $558228835489ffff$var$fixIllFormed) : result;
    }
});
var $558228835489ffff$var$$$J = $558228835489ffff$var$_export;
var $558228835489ffff$var$NATIVE_SYMBOL = $558228835489ffff$var$symbolConstructorDetection;
var $558228835489ffff$var$fails$h = $558228835489ffff$var$fails$u;
var $558228835489ffff$var$getOwnPropertySymbolsModule$2 = $558228835489ffff$var$objectGetOwnPropertySymbols;
var $558228835489ffff$var$toObject$a = $558228835489ffff$var$toObject$e;
// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $558228835489ffff$var$FORCED$5 = !$558228835489ffff$var$NATIVE_SYMBOL || $558228835489ffff$var$fails$h(function() {
    $558228835489ffff$var$getOwnPropertySymbolsModule$2.f(1);
});
// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$558228835489ffff$var$$$J({
    target: 'Object',
    stat: true,
    forced: $558228835489ffff$var$FORCED$5
}, {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        var $getOwnPropertySymbols = $558228835489ffff$var$getOwnPropertySymbolsModule$2.f;
        return $getOwnPropertySymbols ? $getOwnPropertySymbols($558228835489ffff$var$toObject$a(it)) : [];
    }
});
var $558228835489ffff$var$defineWellKnownSymbol$k = $558228835489ffff$var$wellKnownSymbolDefine;
// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
$558228835489ffff$var$defineWellKnownSymbol$k('asyncIterator');
var $558228835489ffff$var$defineWellKnownSymbol$j = $558228835489ffff$var$wellKnownSymbolDefine;
// `Symbol.hasInstance` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.hasinstance
$558228835489ffff$var$defineWellKnownSymbol$j('hasInstance');
var $558228835489ffff$var$defineWellKnownSymbol$i = $558228835489ffff$var$wellKnownSymbolDefine;
// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
$558228835489ffff$var$defineWellKnownSymbol$i('isConcatSpreadable');
var $558228835489ffff$var$defineWellKnownSymbol$h = $558228835489ffff$var$wellKnownSymbolDefine;
// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
$558228835489ffff$var$defineWellKnownSymbol$h('iterator');
var $558228835489ffff$var$defineWellKnownSymbol$g = $558228835489ffff$var$wellKnownSymbolDefine;
// `Symbol.match` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.match
$558228835489ffff$var$defineWellKnownSymbol$g('match');
var $558228835489ffff$var$defineWellKnownSymbol$f = $558228835489ffff$var$wellKnownSymbolDefine;
// `Symbol.matchAll` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.matchall
$558228835489ffff$var$defineWellKnownSymbol$f('matchAll');
var $558228835489ffff$var$defineWellKnownSymbol$e = $558228835489ffff$var$wellKnownSymbolDefine;
// `Symbol.replace` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.replace
$558228835489ffff$var$defineWellKnownSymbol$e('replace');
var $558228835489ffff$var$defineWellKnownSymbol$d = $558228835489ffff$var$wellKnownSymbolDefine;
// `Symbol.search` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.search
$558228835489ffff$var$defineWellKnownSymbol$d('search');
var $558228835489ffff$var$defineWellKnownSymbol$c = $558228835489ffff$var$wellKnownSymbolDefine;
// `Symbol.species` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.species
$558228835489ffff$var$defineWellKnownSymbol$c('species');
var $558228835489ffff$var$defineWellKnownSymbol$b = $558228835489ffff$var$wellKnownSymbolDefine;
// `Symbol.split` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.split
$558228835489ffff$var$defineWellKnownSymbol$b('split');
var $558228835489ffff$var$defineWellKnownSymbol$a = $558228835489ffff$var$wellKnownSymbolDefine;
var $558228835489ffff$var$defineSymbolToPrimitive = $558228835489ffff$var$symbolDefineToPrimitive;
// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
$558228835489ffff$var$defineWellKnownSymbol$a('toPrimitive');
// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
$558228835489ffff$var$defineSymbolToPrimitive();
var $558228835489ffff$var$getBuiltIn$8 = $558228835489ffff$var$getBuiltIn$f;
var $558228835489ffff$var$defineWellKnownSymbol$9 = $558228835489ffff$var$wellKnownSymbolDefine;
var $558228835489ffff$var$setToStringTag$5 = $558228835489ffff$var$setToStringTag$7;
// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
$558228835489ffff$var$defineWellKnownSymbol$9('toStringTag');
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
$558228835489ffff$var$setToStringTag$5($558228835489ffff$var$getBuiltIn$8('Symbol'), 'Symbol');
var $558228835489ffff$var$defineWellKnownSymbol$8 = $558228835489ffff$var$wellKnownSymbolDefine;
// `Symbol.unscopables` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.unscopables
$558228835489ffff$var$defineWellKnownSymbol$8('unscopables');
var $558228835489ffff$var$global$d = $558228835489ffff$var$global$p;
var $558228835489ffff$var$setToStringTag$4 = $558228835489ffff$var$setToStringTag$7;
// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
$558228835489ffff$var$setToStringTag$4($558228835489ffff$var$global$d.JSON, 'JSON', true);
var $558228835489ffff$var$path$j = $558228835489ffff$var$path$o;
var $558228835489ffff$var$symbol$5 = $558228835489ffff$var$path$j.Symbol;
var $558228835489ffff$var$iterators = {};
var $558228835489ffff$var$DESCRIPTORS$9 = $558228835489ffff$var$descriptors;
var $558228835489ffff$var$hasOwn$9 = $558228835489ffff$var$hasOwnProperty_1;
var $558228835489ffff$var$FunctionPrototype$2 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $558228835489ffff$var$getDescriptor = $558228835489ffff$var$DESCRIPTORS$9 && Object.getOwnPropertyDescriptor;
var $558228835489ffff$var$EXISTS = $558228835489ffff$var$hasOwn$9($558228835489ffff$var$FunctionPrototype$2, 'name');
// additional protection from minified / mangled / dropped function names
var $558228835489ffff$var$PROPER = $558228835489ffff$var$EXISTS && (function something() {}).name === 'something';
var $558228835489ffff$var$CONFIGURABLE = $558228835489ffff$var$EXISTS && (!$558228835489ffff$var$DESCRIPTORS$9 || $558228835489ffff$var$DESCRIPTORS$9 && $558228835489ffff$var$getDescriptor($558228835489ffff$var$FunctionPrototype$2, 'name').configurable);
var $558228835489ffff$var$functionName = {
    EXISTS: $558228835489ffff$var$EXISTS,
    PROPER: $558228835489ffff$var$PROPER,
    CONFIGURABLE: $558228835489ffff$var$CONFIGURABLE
};
var $558228835489ffff$var$fails$g = $558228835489ffff$var$fails$u;
var $558228835489ffff$var$correctPrototypeGetter = !$558228835489ffff$var$fails$g(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});
var $558228835489ffff$var$hasOwn$8 = $558228835489ffff$var$hasOwnProperty_1;
var $558228835489ffff$var$isCallable$8 = $558228835489ffff$var$isCallable$m;
var $558228835489ffff$var$toObject$9 = $558228835489ffff$var$toObject$e;
var $558228835489ffff$var$sharedKey = $558228835489ffff$var$sharedKey$4;
var $558228835489ffff$var$CORRECT_PROTOTYPE_GETTER$1 = $558228835489ffff$var$correctPrototypeGetter;
var $558228835489ffff$var$IE_PROTO = $558228835489ffff$var$sharedKey('IE_PROTO');
var $558228835489ffff$var$$Object = Object;
var $558228835489ffff$var$ObjectPrototype$1 = $558228835489ffff$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var $558228835489ffff$var$objectGetPrototypeOf = $558228835489ffff$var$CORRECT_PROTOTYPE_GETTER$1 ? $558228835489ffff$var$$Object.getPrototypeOf : function(O) {
    var object = $558228835489ffff$var$toObject$9(O);
    if ($558228835489ffff$var$hasOwn$8(object, $558228835489ffff$var$IE_PROTO)) return object[$558228835489ffff$var$IE_PROTO];
    var constructor = object.constructor;
    if ($558228835489ffff$var$isCallable$8(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $558228835489ffff$var$$Object ? $558228835489ffff$var$ObjectPrototype$1 : null;
};
var $558228835489ffff$var$fails$f = $558228835489ffff$var$fails$u;
var $558228835489ffff$var$isCallable$7 = $558228835489ffff$var$isCallable$m;
var $558228835489ffff$var$isObject$9 = $558228835489ffff$var$isObject$h;
var $558228835489ffff$var$create$b = $558228835489ffff$var$objectCreate;
var $558228835489ffff$var$getPrototypeOf$7 = $558228835489ffff$var$objectGetPrototypeOf;
var $558228835489ffff$var$defineBuiltIn$3 = $558228835489ffff$var$defineBuiltIn$6;
var $558228835489ffff$var$wellKnownSymbol$c = $558228835489ffff$var$wellKnownSymbol$n;
var $558228835489ffff$var$ITERATOR$4 = $558228835489ffff$var$wellKnownSymbol$c('iterator');
var $558228835489ffff$var$BUGGY_SAFARI_ITERATORS$1 = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $558228835489ffff$var$IteratorPrototype$1, $558228835489ffff$var$PrototypeOfArrayIteratorPrototype, $558228835489ffff$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $558228835489ffff$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!('next' in $558228835489ffff$var$arrayIterator)) $558228835489ffff$var$BUGGY_SAFARI_ITERATORS$1 = true;
    else {
        $558228835489ffff$var$PrototypeOfArrayIteratorPrototype = $558228835489ffff$var$getPrototypeOf$7($558228835489ffff$var$getPrototypeOf$7($558228835489ffff$var$arrayIterator));
        if ($558228835489ffff$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $558228835489ffff$var$IteratorPrototype$1 = $558228835489ffff$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $558228835489ffff$var$NEW_ITERATOR_PROTOTYPE = !$558228835489ffff$var$isObject$9($558228835489ffff$var$IteratorPrototype$1) || $558228835489ffff$var$fails$f(function() {
    var test = {};
    // FF44- legacy iterators case
    return $558228835489ffff$var$IteratorPrototype$1[$558228835489ffff$var$ITERATOR$4].call(test) !== test;
});
if ($558228835489ffff$var$NEW_ITERATOR_PROTOTYPE) $558228835489ffff$var$IteratorPrototype$1 = {};
else $558228835489ffff$var$IteratorPrototype$1 = $558228835489ffff$var$create$b($558228835489ffff$var$IteratorPrototype$1);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$558228835489ffff$var$isCallable$7($558228835489ffff$var$IteratorPrototype$1[$558228835489ffff$var$ITERATOR$4])) $558228835489ffff$var$defineBuiltIn$3($558228835489ffff$var$IteratorPrototype$1, $558228835489ffff$var$ITERATOR$4, function() {
    return this;
});
var $558228835489ffff$var$iteratorsCore = {
    IteratorPrototype: $558228835489ffff$var$IteratorPrototype$1,
    BUGGY_SAFARI_ITERATORS: $558228835489ffff$var$BUGGY_SAFARI_ITERATORS$1
};
var $558228835489ffff$var$IteratorPrototype = $558228835489ffff$var$iteratorsCore.IteratorPrototype;
var $558228835489ffff$var$create$a = $558228835489ffff$var$objectCreate;
var $558228835489ffff$var$createPropertyDescriptor$2 = $558228835489ffff$var$createPropertyDescriptor$7;
var $558228835489ffff$var$setToStringTag$3 = $558228835489ffff$var$setToStringTag$7;
var $558228835489ffff$var$Iterators$5 = $558228835489ffff$var$iterators;
var $558228835489ffff$var$returnThis$1 = function() {
    return this;
};
var $558228835489ffff$var$iteratorCreateConstructor = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + ' Iterator';
    IteratorConstructor.prototype = $558228835489ffff$var$create$a($558228835489ffff$var$IteratorPrototype, {
        next: $558228835489ffff$var$createPropertyDescriptor$2(+!ENUMERABLE_NEXT, next)
    });
    $558228835489ffff$var$setToStringTag$3(IteratorConstructor, TO_STRING_TAG, false, true);
    $558228835489ffff$var$Iterators$5[TO_STRING_TAG] = $558228835489ffff$var$returnThis$1;
    return IteratorConstructor;
};
var $558228835489ffff$var$uncurryThis$a = $558228835489ffff$var$functionUncurryThis;
var $558228835489ffff$var$aCallable$b = $558228835489ffff$var$aCallable$e;
var $558228835489ffff$var$functionUncurryThisAccessor = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $558228835489ffff$var$uncurryThis$a($558228835489ffff$var$aCallable$b(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};
var $558228835489ffff$var$isCallable$6 = $558228835489ffff$var$isCallable$m;
var $558228835489ffff$var$$String = String;
var $558228835489ffff$var$$TypeError$9 = TypeError;
var $558228835489ffff$var$aPossiblePrototype$1 = function(argument) {
    if (typeof argument == 'object' || $558228835489ffff$var$isCallable$6(argument)) return argument;
    throw new $558228835489ffff$var$$TypeError$9("Can't set " + $558228835489ffff$var$$String(argument) + ' as a prototype');
};
/* eslint-disable no-proto -- safe */ var $558228835489ffff$var$uncurryThisAccessor = $558228835489ffff$var$functionUncurryThisAccessor;
var $558228835489ffff$var$anObject$8 = $558228835489ffff$var$anObject$d;
var $558228835489ffff$var$aPossiblePrototype = $558228835489ffff$var$aPossiblePrototype$1;
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var $558228835489ffff$var$objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $558228835489ffff$var$uncurryThisAccessor(Object.prototype, '__proto__', 'set');
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $558228835489ffff$var$anObject$8(O);
        $558228835489ffff$var$aPossiblePrototype(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);
var $558228835489ffff$var$$$I = $558228835489ffff$var$_export;
var $558228835489ffff$var$call$b = $558228835489ffff$var$functionCall;
var $558228835489ffff$var$FunctionName = $558228835489ffff$var$functionName;
var $558228835489ffff$var$createIteratorConstructor = $558228835489ffff$var$iteratorCreateConstructor;
var $558228835489ffff$var$getPrototypeOf$6 = $558228835489ffff$var$objectGetPrototypeOf;
var $558228835489ffff$var$setToStringTag$2 = $558228835489ffff$var$setToStringTag$7;
var $558228835489ffff$var$defineBuiltIn$2 = $558228835489ffff$var$defineBuiltIn$6;
var $558228835489ffff$var$wellKnownSymbol$b = $558228835489ffff$var$wellKnownSymbol$n;
var $558228835489ffff$var$Iterators$4 = $558228835489ffff$var$iterators;
var $558228835489ffff$var$IteratorsCore = $558228835489ffff$var$iteratorsCore;
var $558228835489ffff$var$PROPER_FUNCTION_NAME = $558228835489ffff$var$FunctionName.PROPER;
$558228835489ffff$var$FunctionName.CONFIGURABLE;
$558228835489ffff$var$IteratorsCore.IteratorPrototype;
var $558228835489ffff$var$BUGGY_SAFARI_ITERATORS = $558228835489ffff$var$IteratorsCore.BUGGY_SAFARI_ITERATORS;
var $558228835489ffff$var$ITERATOR$3 = $558228835489ffff$var$wellKnownSymbol$b('iterator');
var $558228835489ffff$var$KEYS = 'keys';
var $558228835489ffff$var$VALUES = 'values';
var $558228835489ffff$var$ENTRIES = 'entries';
var $558228835489ffff$var$returnThis = function() {
    return this;
};
var $558228835489ffff$var$iteratorDefine = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $558228835489ffff$var$createIteratorConstructor(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$558228835489ffff$var$BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $558228835489ffff$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $558228835489ffff$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $558228835489ffff$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + ' Iterator';
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$558228835489ffff$var$ITERATOR$3] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$558228835489ffff$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $558228835489ffff$var$getPrototypeOf$6(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            $558228835489ffff$var$setToStringTag$2(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            $558228835489ffff$var$Iterators$4[TO_STRING_TAG] = $558228835489ffff$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($558228835489ffff$var$PROPER_FUNCTION_NAME && DEFAULT === $558228835489ffff$var$VALUES && nativeIterator && nativeIterator.name !== $558228835489ffff$var$VALUES) {
        INCORRECT_VALUES_NAME = true;
        defaultIterator = function values() {
            return $558228835489ffff$var$call$b(nativeIterator, this);
        };
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($558228835489ffff$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($558228835489ffff$var$KEYS),
            entries: getIterationMethod($558228835489ffff$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($558228835489ffff$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $558228835489ffff$var$defineBuiltIn$2(IterablePrototype, KEY, methods[KEY]);
        } else $558228835489ffff$var$$$I({
            target: NAME,
            proto: true,
            forced: $558228835489ffff$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if (FORCED && IterablePrototype[$558228835489ffff$var$ITERATOR$3] !== defaultIterator) $558228835489ffff$var$defineBuiltIn$2(IterablePrototype, $558228835489ffff$var$ITERATOR$3, defaultIterator, {
        name: DEFAULT
    });
    $558228835489ffff$var$Iterators$4[NAME] = defaultIterator;
    return methods;
};
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var $558228835489ffff$var$createIterResultObject$3 = function(value, done) {
    return {
        value: value,
        done: done
    };
};
var $558228835489ffff$var$toIndexedObject$3 = $558228835489ffff$var$toIndexedObject$a;
var $558228835489ffff$var$Iterators$3 = $558228835489ffff$var$iterators;
var $558228835489ffff$var$InternalStateModule$4 = $558228835489ffff$var$internalState;
$558228835489ffff$var$objectDefineProperty.f;
var $558228835489ffff$var$defineIterator$2 = $558228835489ffff$var$iteratorDefine;
var $558228835489ffff$var$createIterResultObject$2 = $558228835489ffff$var$createIterResultObject$3;
var $558228835489ffff$var$ARRAY_ITERATOR = 'Array Iterator';
var $558228835489ffff$var$setInternalState$4 = $558228835489ffff$var$InternalStateModule$4.set;
var $558228835489ffff$var$getInternalState$1 = $558228835489ffff$var$InternalStateModule$4.getterFor($558228835489ffff$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
$558228835489ffff$var$defineIterator$2(Array, 'Array', function(iterated, kind) {
    $558228835489ffff$var$setInternalState$4(this, {
        type: $558228835489ffff$var$ARRAY_ITERATOR,
        target: $558228835489ffff$var$toIndexedObject$3(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $558228835489ffff$var$getInternalState$1(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return $558228835489ffff$var$createIterResultObject$2(undefined, true);
    }
    switch(state.kind){
        case 'keys':
            return $558228835489ffff$var$createIterResultObject$2(index, false);
        case 'values':
            return $558228835489ffff$var$createIterResultObject$2(target[index], false);
    }
    return $558228835489ffff$var$createIterResultObject$2([
        index,
        target[index]
    ], false);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
$558228835489ffff$var$Iterators$3.Arguments = $558228835489ffff$var$Iterators$3.Array;
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var $558228835489ffff$var$domIterables = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};
var $558228835489ffff$var$DOMIterables$4 = $558228835489ffff$var$domIterables;
var $558228835489ffff$var$global$c = $558228835489ffff$var$global$p;
var $558228835489ffff$var$classof$7 = $558228835489ffff$var$classof$d;
var $558228835489ffff$var$createNonEnumerableProperty$4 = $558228835489ffff$var$createNonEnumerableProperty$9;
var $558228835489ffff$var$Iterators$2 = $558228835489ffff$var$iterators;
var $558228835489ffff$var$wellKnownSymbol$a = $558228835489ffff$var$wellKnownSymbol$n;
var $558228835489ffff$var$TO_STRING_TAG$1 = $558228835489ffff$var$wellKnownSymbol$a('toStringTag');
for(var $558228835489ffff$var$COLLECTION_NAME in $558228835489ffff$var$DOMIterables$4){
    var $558228835489ffff$var$Collection = $558228835489ffff$var$global$c[$558228835489ffff$var$COLLECTION_NAME];
    var $558228835489ffff$var$CollectionPrototype = $558228835489ffff$var$Collection && $558228835489ffff$var$Collection.prototype;
    if ($558228835489ffff$var$CollectionPrototype && $558228835489ffff$var$classof$7($558228835489ffff$var$CollectionPrototype) !== $558228835489ffff$var$TO_STRING_TAG$1) $558228835489ffff$var$createNonEnumerableProperty$4($558228835489ffff$var$CollectionPrototype, $558228835489ffff$var$TO_STRING_TAG$1, $558228835489ffff$var$COLLECTION_NAME);
    $558228835489ffff$var$Iterators$2[$558228835489ffff$var$COLLECTION_NAME] = $558228835489ffff$var$Iterators$2.Array;
}
var $558228835489ffff$var$parent$15 = $558228835489ffff$var$symbol$5;
var $558228835489ffff$var$symbol$4 = $558228835489ffff$var$parent$15;
var $558228835489ffff$var$wellKnownSymbol$9 = $558228835489ffff$var$wellKnownSymbol$n;
var $558228835489ffff$var$defineProperty$4 = $558228835489ffff$var$objectDefineProperty.f;
var $558228835489ffff$var$METADATA$1 = $558228835489ffff$var$wellKnownSymbol$9('metadata');
var $558228835489ffff$var$FunctionPrototype$1 = Function.prototype;
// Function.prototype[@@metadata]
// https://github.com/tc39/proposal-decorator-metadata
if ($558228835489ffff$var$FunctionPrototype$1[$558228835489ffff$var$METADATA$1] === undefined) $558228835489ffff$var$defineProperty$4($558228835489ffff$var$FunctionPrototype$1, $558228835489ffff$var$METADATA$1, {
    value: null
});
var $558228835489ffff$var$defineWellKnownSymbol$7 = $558228835489ffff$var$wellKnownSymbolDefine;
// `Symbol.asyncDispose` well-known symbol
// https://github.com/tc39/proposal-async-explicit-resource-management
$558228835489ffff$var$defineWellKnownSymbol$7('asyncDispose');
var $558228835489ffff$var$defineWellKnownSymbol$6 = $558228835489ffff$var$wellKnownSymbolDefine;
// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-explicit-resource-management
$558228835489ffff$var$defineWellKnownSymbol$6('dispose');
var $558228835489ffff$var$defineWellKnownSymbol$5 = $558228835489ffff$var$wellKnownSymbolDefine;
// `Symbol.metadata` well-known symbol
// https://github.com/tc39/proposal-decorators
$558228835489ffff$var$defineWellKnownSymbol$5('metadata');
var $558228835489ffff$var$parent$14 = $558228835489ffff$var$symbol$4;
var $558228835489ffff$var$symbol$3 = $558228835489ffff$var$parent$14;
var $558228835489ffff$var$getBuiltIn$7 = $558228835489ffff$var$getBuiltIn$f;
var $558228835489ffff$var$uncurryThis$9 = $558228835489ffff$var$functionUncurryThis;
var $558228835489ffff$var$Symbol$2 = $558228835489ffff$var$getBuiltIn$7('Symbol');
var $558228835489ffff$var$keyFor = $558228835489ffff$var$Symbol$2.keyFor;
var $558228835489ffff$var$thisSymbolValue$1 = $558228835489ffff$var$uncurryThis$9($558228835489ffff$var$Symbol$2.prototype.valueOf);
// `Symbol.isRegisteredSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
var $558228835489ffff$var$symbolIsRegistered = $558228835489ffff$var$Symbol$2.isRegisteredSymbol || function isRegisteredSymbol(value) {
    try {
        return $558228835489ffff$var$keyFor($558228835489ffff$var$thisSymbolValue$1(value)) !== undefined;
    } catch (error) {
        return false;
    }
};
var $558228835489ffff$var$$$H = $558228835489ffff$var$_export;
var $558228835489ffff$var$isRegisteredSymbol$1 = $558228835489ffff$var$symbolIsRegistered;
// `Symbol.isRegisteredSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
$558228835489ffff$var$$$H({
    target: 'Symbol',
    stat: true
}, {
    isRegisteredSymbol: $558228835489ffff$var$isRegisteredSymbol$1
});
var $558228835489ffff$var$shared = $558228835489ffff$var$sharedExports;
var $558228835489ffff$var$getBuiltIn$6 = $558228835489ffff$var$getBuiltIn$f;
var $558228835489ffff$var$uncurryThis$8 = $558228835489ffff$var$functionUncurryThis;
var $558228835489ffff$var$isSymbol = $558228835489ffff$var$isSymbol$5;
var $558228835489ffff$var$wellKnownSymbol$8 = $558228835489ffff$var$wellKnownSymbol$n;
var $558228835489ffff$var$Symbol$1 = $558228835489ffff$var$getBuiltIn$6('Symbol');
var $558228835489ffff$var$$isWellKnownSymbol = $558228835489ffff$var$Symbol$1.isWellKnownSymbol;
var $558228835489ffff$var$getOwnPropertyNames = $558228835489ffff$var$getBuiltIn$6('Object', 'getOwnPropertyNames');
var $558228835489ffff$var$thisSymbolValue = $558228835489ffff$var$uncurryThis$8($558228835489ffff$var$Symbol$1.prototype.valueOf);
var $558228835489ffff$var$WellKnownSymbolsStore = $558228835489ffff$var$shared('wks');
for(var $558228835489ffff$var$i = 0, $558228835489ffff$var$symbolKeys = $558228835489ffff$var$getOwnPropertyNames($558228835489ffff$var$Symbol$1), $558228835489ffff$var$symbolKeysLength = $558228835489ffff$var$symbolKeys.length; $558228835489ffff$var$i < $558228835489ffff$var$symbolKeysLength; $558228835489ffff$var$i++)// some old engines throws on access to some keys like `arguments` or `caller`
try {
    var $558228835489ffff$var$symbolKey = $558228835489ffff$var$symbolKeys[$558228835489ffff$var$i];
    if ($558228835489ffff$var$isSymbol($558228835489ffff$var$Symbol$1[$558228835489ffff$var$symbolKey])) $558228835489ffff$var$wellKnownSymbol$8($558228835489ffff$var$symbolKey);
} catch (error) {}
// `Symbol.isWellKnownSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
var $558228835489ffff$var$symbolIsWellKnown = function isWellKnownSymbol(value) {
    if ($558228835489ffff$var$$isWellKnownSymbol && $558228835489ffff$var$$isWellKnownSymbol(value)) return true;
    try {
        var symbol = $558228835489ffff$var$thisSymbolValue(value);
        for(var j = 0, keys = $558228835489ffff$var$getOwnPropertyNames($558228835489ffff$var$WellKnownSymbolsStore), keysLength = keys.length; j < keysLength; j++){
            // eslint-disable-next-line eqeqeq -- polyfilled symbols case
            if ($558228835489ffff$var$WellKnownSymbolsStore[keys[j]] == symbol) return true;
        }
    } catch (error) {}
    return false;
};
var $558228835489ffff$var$$$G = $558228835489ffff$var$_export;
var $558228835489ffff$var$isWellKnownSymbol$1 = $558228835489ffff$var$symbolIsWellKnown;
// `Symbol.isWellKnownSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
$558228835489ffff$var$$$G({
    target: 'Symbol',
    stat: true,
    forced: true
}, {
    isWellKnownSymbol: $558228835489ffff$var$isWellKnownSymbol$1
});
var $558228835489ffff$var$defineWellKnownSymbol$4 = $558228835489ffff$var$wellKnownSymbolDefine;
// `Symbol.matcher` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
$558228835489ffff$var$defineWellKnownSymbol$4('matcher');
var $558228835489ffff$var$defineWellKnownSymbol$3 = $558228835489ffff$var$wellKnownSymbolDefine;
// `Symbol.observable` well-known symbol
// https://github.com/tc39/proposal-observable
$558228835489ffff$var$defineWellKnownSymbol$3('observable');
var $558228835489ffff$var$$$F = $558228835489ffff$var$_export;
var $558228835489ffff$var$isRegisteredSymbol = $558228835489ffff$var$symbolIsRegistered;
// `Symbol.isRegistered` method
// obsolete version of https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
$558228835489ffff$var$$$F({
    target: 'Symbol',
    stat: true,
    name: 'isRegisteredSymbol'
}, {
    isRegistered: $558228835489ffff$var$isRegisteredSymbol
});
var $558228835489ffff$var$$$E = $558228835489ffff$var$_export;
var $558228835489ffff$var$isWellKnownSymbol = $558228835489ffff$var$symbolIsWellKnown;
// `Symbol.isWellKnown` method
// obsolete version of https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
$558228835489ffff$var$$$E({
    target: 'Symbol',
    stat: true,
    name: 'isWellKnownSymbol',
    forced: true
}, {
    isWellKnown: $558228835489ffff$var$isWellKnownSymbol
});
// TODO: Remove from `core-js@4`
var $558228835489ffff$var$defineWellKnownSymbol$2 = $558228835489ffff$var$wellKnownSymbolDefine;
// `Symbol.metadataKey` well-known symbol
// https://github.com/tc39/proposal-decorator-metadata
$558228835489ffff$var$defineWellKnownSymbol$2('metadataKey');
// TODO: remove from `core-js@4`
var $558228835489ffff$var$defineWellKnownSymbol$1 = $558228835489ffff$var$wellKnownSymbolDefine;
// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
$558228835489ffff$var$defineWellKnownSymbol$1('patternMatch');
// TODO: remove from `core-js@4`
var $558228835489ffff$var$defineWellKnownSymbol = $558228835489ffff$var$wellKnownSymbolDefine;
$558228835489ffff$var$defineWellKnownSymbol('replaceAll');
var $558228835489ffff$var$parent$13 = $558228835489ffff$var$symbol$3;
// TODO: Remove from `core-js@4`
var $558228835489ffff$var$symbol$2 = $558228835489ffff$var$parent$13;
var $558228835489ffff$var$symbol$1 = $558228835489ffff$var$symbol$2;
var $558228835489ffff$var$_Symbol$1 = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$symbol$1);
var $558228835489ffff$var$uncurryThis$7 = $558228835489ffff$var$functionUncurryThis;
var $558228835489ffff$var$toIntegerOrInfinity$1 = $558228835489ffff$var$toIntegerOrInfinity$4;
var $558228835489ffff$var$toString$3 = $558228835489ffff$var$toString$7;
var $558228835489ffff$var$requireObjectCoercible = $558228835489ffff$var$requireObjectCoercible$3;
var $558228835489ffff$var$charAt$1 = $558228835489ffff$var$uncurryThis$7(''.charAt);
var $558228835489ffff$var$charCodeAt = $558228835489ffff$var$uncurryThis$7(''.charCodeAt);
var $558228835489ffff$var$stringSlice = $558228835489ffff$var$uncurryThis$7(''.slice);
var $558228835489ffff$var$createMethod$1 = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $558228835489ffff$var$toString$3($558228835489ffff$var$requireObjectCoercible($this));
        var position = $558228835489ffff$var$toIntegerOrInfinity$1(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
        first = $558228835489ffff$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $558228835489ffff$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $558228835489ffff$var$charAt$1(S, position) : first : CONVERT_TO_STRING ? $558228835489ffff$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
var $558228835489ffff$var$stringMultibyte = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $558228835489ffff$var$createMethod$1(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $558228835489ffff$var$createMethod$1(true)
};
var $558228835489ffff$var$charAt = $558228835489ffff$var$stringMultibyte.charAt;
var $558228835489ffff$var$toString$2 = $558228835489ffff$var$toString$7;
var $558228835489ffff$var$InternalStateModule$3 = $558228835489ffff$var$internalState;
var $558228835489ffff$var$defineIterator$1 = $558228835489ffff$var$iteratorDefine;
var $558228835489ffff$var$createIterResultObject$1 = $558228835489ffff$var$createIterResultObject$3;
var $558228835489ffff$var$STRING_ITERATOR = 'String Iterator';
var $558228835489ffff$var$setInternalState$3 = $558228835489ffff$var$InternalStateModule$3.set;
var $558228835489ffff$var$getInternalState = $558228835489ffff$var$InternalStateModule$3.getterFor($558228835489ffff$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$558228835489ffff$var$defineIterator$1(String, 'String', function(iterated) {
    $558228835489ffff$var$setInternalState$3(this, {
        type: $558228835489ffff$var$STRING_ITERATOR,
        string: $558228835489ffff$var$toString$2(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $558228835489ffff$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $558228835489ffff$var$createIterResultObject$1(undefined, true);
    point = $558228835489ffff$var$charAt(string, index);
    state.index += point.length;
    return $558228835489ffff$var$createIterResultObject$1(point, false);
});
var $558228835489ffff$var$WrappedWellKnownSymbolModule$1 = $558228835489ffff$var$wellKnownSymbolWrapped;
var $558228835489ffff$var$iterator$5 = $558228835489ffff$var$WrappedWellKnownSymbolModule$1.f('iterator');
var $558228835489ffff$var$parent$12 = $558228835489ffff$var$iterator$5;
var $558228835489ffff$var$iterator$4 = $558228835489ffff$var$parent$12;
var $558228835489ffff$var$parent$11 = $558228835489ffff$var$iterator$4;
var $558228835489ffff$var$iterator$3 = $558228835489ffff$var$parent$11;
var $558228835489ffff$var$parent$10 = $558228835489ffff$var$iterator$3;
var $558228835489ffff$var$iterator$2 = $558228835489ffff$var$parent$10;
var $558228835489ffff$var$iterator$1 = $558228835489ffff$var$iterator$2;
var $558228835489ffff$var$_Symbol$iterator$1 = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$iterator$1);
function $558228835489ffff$var$_typeof$1(o) {
    "@babel/helpers - typeof";
    return $558228835489ffff$var$_typeof$1 = "function" == typeof $558228835489ffff$var$_Symbol$1 && "symbol" == typeof $558228835489ffff$var$_Symbol$iterator$1 ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof $558228835489ffff$var$_Symbol$1 && o.constructor === $558228835489ffff$var$_Symbol$1 && o !== $558228835489ffff$var$_Symbol$1.prototype ? "symbol" : typeof o;
    }, $558228835489ffff$var$_typeof$1(o);
}
var $558228835489ffff$var$WrappedWellKnownSymbolModule = $558228835489ffff$var$wellKnownSymbolWrapped;
var $558228835489ffff$var$toPrimitive$4 = $558228835489ffff$var$WrappedWellKnownSymbolModule.f('toPrimitive');
var $558228835489ffff$var$parent$$ = $558228835489ffff$var$toPrimitive$4;
var $558228835489ffff$var$toPrimitive$3 = $558228835489ffff$var$parent$$;
var $558228835489ffff$var$parent$_ = $558228835489ffff$var$toPrimitive$3;
var $558228835489ffff$var$toPrimitive$2 = $558228835489ffff$var$parent$_;
var $558228835489ffff$var$parent$Z = $558228835489ffff$var$toPrimitive$2;
var $558228835489ffff$var$toPrimitive$1 = $558228835489ffff$var$parent$Z;
var $558228835489ffff$var$toPrimitive = $558228835489ffff$var$toPrimitive$1;
var $558228835489ffff$var$_Symbol$toPrimitive = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$toPrimitive);
function $558228835489ffff$var$_toPrimitive(input, hint) {
    if ($558228835489ffff$var$_typeof$1(input) !== "object" || input === null) return input;
    var prim = input[$558228835489ffff$var$_Symbol$toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($558228835489ffff$var$_typeof$1(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $558228835489ffff$var$_toPropertyKey(arg) {
    var key = $558228835489ffff$var$_toPrimitive(arg, "string");
    return $558228835489ffff$var$_typeof$1(key) === "symbol" ? key : String(key);
}
function $558228835489ffff$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        $558228835489ffff$var$_Object$defineProperty$1(target, $558228835489ffff$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $558228835489ffff$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $558228835489ffff$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $558228835489ffff$var$_defineProperties(Constructor, staticProps);
    $558228835489ffff$var$_Object$defineProperty$1(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $558228835489ffff$var$_defineProperty(obj, key, value) {
    key = $558228835489ffff$var$_toPropertyKey(key);
    if (key in obj) $558228835489ffff$var$_Object$defineProperty$1(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $558228835489ffff$var$uncurryThis$6 = $558228835489ffff$var$functionUncurryThis;
var $558228835489ffff$var$aCallable$a = $558228835489ffff$var$aCallable$e;
var $558228835489ffff$var$isObject$8 = $558228835489ffff$var$isObject$h;
var $558228835489ffff$var$hasOwn$7 = $558228835489ffff$var$hasOwnProperty_1;
var $558228835489ffff$var$arraySlice$3 = $558228835489ffff$var$arraySlice$5;
var $558228835489ffff$var$NATIVE_BIND = $558228835489ffff$var$functionBindNative;
var $558228835489ffff$var$$Function = Function;
var $558228835489ffff$var$concat$6 = $558228835489ffff$var$uncurryThis$6([].concat);
var $558228835489ffff$var$join = $558228835489ffff$var$uncurryThis$6([].join);
var $558228835489ffff$var$factories = {};
var $558228835489ffff$var$construct$3 = function(C, argsLength, args) {
    if (!$558228835489ffff$var$hasOwn$7($558228835489ffff$var$factories, argsLength)) {
        var list = [];
        var i = 0;
        for(; i < argsLength; i++)list[i] = 'a[' + i + ']';
        $558228835489ffff$var$factories[argsLength] = $558228835489ffff$var$$Function('C,a', 'return new C(' + $558228835489ffff$var$join(list, ',') + ')');
    }
    return $558228835489ffff$var$factories[argsLength](C, args);
};
// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
var $558228835489ffff$var$functionBind = $558228835489ffff$var$NATIVE_BIND ? $558228835489ffff$var$$Function.bind : function bind(that /* , ...args */ ) {
    var F = $558228835489ffff$var$aCallable$a(this);
    var Prototype = F.prototype;
    var partArgs = $558228835489ffff$var$arraySlice$3(arguments, 1);
    var boundFunction = function bound() {
        var args = $558228835489ffff$var$concat$6(partArgs, $558228835489ffff$var$arraySlice$3(arguments));
        return this instanceof boundFunction ? $558228835489ffff$var$construct$3(F, args.length, args) : F.apply(that, args);
    };
    if ($558228835489ffff$var$isObject$8(Prototype)) boundFunction.prototype = Prototype;
    return boundFunction;
};
// TODO: Remove from `core-js@4`
var $558228835489ffff$var$$$D = $558228835489ffff$var$_export;
var $558228835489ffff$var$bind$f = $558228835489ffff$var$functionBind;
// `Function.prototype.bind` method
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
$558228835489ffff$var$$$D({
    target: 'Function',
    proto: true,
    forced: Function.bind !== $558228835489ffff$var$bind$f
}, {
    bind: $558228835489ffff$var$bind$f
});
var $558228835489ffff$var$global$b = $558228835489ffff$var$global$p;
var $558228835489ffff$var$path$i = $558228835489ffff$var$path$o;
var $558228835489ffff$var$getBuiltInPrototypeMethod$g = function(CONSTRUCTOR, METHOD) {
    var Namespace = $558228835489ffff$var$path$i[CONSTRUCTOR + 'Prototype'];
    var pureMethod = Namespace && Namespace[METHOD];
    if (pureMethod) return pureMethod;
    var NativeConstructor = $558228835489ffff$var$global$b[CONSTRUCTOR];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    return NativePrototype && NativePrototype[METHOD];
};
var $558228835489ffff$var$getBuiltInPrototypeMethod$f = $558228835489ffff$var$getBuiltInPrototypeMethod$g;
var $558228835489ffff$var$bind$e = $558228835489ffff$var$getBuiltInPrototypeMethod$f('Function', 'bind');
var $558228835489ffff$var$isPrototypeOf$i = $558228835489ffff$var$objectIsPrototypeOf;
var $558228835489ffff$var$method$f = $558228835489ffff$var$bind$e;
var $558228835489ffff$var$FunctionPrototype = Function.prototype;
var $558228835489ffff$var$bind$d = function(it) {
    var own = it.bind;
    return it === $558228835489ffff$var$FunctionPrototype || $558228835489ffff$var$isPrototypeOf$i($558228835489ffff$var$FunctionPrototype, it) && own === $558228835489ffff$var$FunctionPrototype.bind ? $558228835489ffff$var$method$f : own;
};
var $558228835489ffff$var$parent$Y = $558228835489ffff$var$bind$d;
var $558228835489ffff$var$bind$c = $558228835489ffff$var$parent$Y;
var $558228835489ffff$var$bind$b = $558228835489ffff$var$bind$c;
var $558228835489ffff$var$_bindInstanceProperty$1 = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$bind$b);
var $558228835489ffff$var$aCallable$9 = $558228835489ffff$var$aCallable$e;
var $558228835489ffff$var$toObject$8 = $558228835489ffff$var$toObject$e;
var $558228835489ffff$var$IndexedObject$1 = $558228835489ffff$var$indexedObject;
var $558228835489ffff$var$lengthOfArrayLike$8 = $558228835489ffff$var$lengthOfArrayLike$d;
var $558228835489ffff$var$$TypeError$8 = TypeError;
// `Array.prototype.{ reduce, reduceRight }` methods implementation
var $558228835489ffff$var$createMethod = function(IS_RIGHT) {
    return function(that, callbackfn, argumentsLength, memo) {
        $558228835489ffff$var$aCallable$9(callbackfn);
        var O = $558228835489ffff$var$toObject$8(that);
        var self1 = $558228835489ffff$var$IndexedObject$1(O);
        var length = $558228835489ffff$var$lengthOfArrayLike$8(O);
        var index = IS_RIGHT ? length - 1 : 0;
        var i = IS_RIGHT ? -1 : 1;
        if (argumentsLength < 2) while(true){
            if (index in self1) {
                memo = self1[index];
                index += i;
                break;
            }
            index += i;
            if (IS_RIGHT ? index < 0 : length <= index) throw new $558228835489ffff$var$$TypeError$8('Reduce of empty array with no initial value');
        }
        for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self1) memo = callbackfn(memo, self1[index], index, O);
        return memo;
    };
};
var $558228835489ffff$var$arrayReduce = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: $558228835489ffff$var$createMethod(false),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: $558228835489ffff$var$createMethod(true)
};
var $558228835489ffff$var$fails$e = $558228835489ffff$var$fails$u;
var $558228835489ffff$var$arrayMethodIsStrict$4 = function(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && $558228835489ffff$var$fails$e(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};
var $558228835489ffff$var$global$a = $558228835489ffff$var$global$p;
var $558228835489ffff$var$classof$6 = $558228835489ffff$var$classofRaw$2;
var $558228835489ffff$var$engineIsNode = $558228835489ffff$var$classof$6($558228835489ffff$var$global$a.process) === 'process';
var $558228835489ffff$var$$$C = $558228835489ffff$var$_export;
var $558228835489ffff$var$$reduce = $558228835489ffff$var$arrayReduce.left;
var $558228835489ffff$var$arrayMethodIsStrict$3 = $558228835489ffff$var$arrayMethodIsStrict$4;
var $558228835489ffff$var$CHROME_VERSION = $558228835489ffff$var$engineV8Version;
var $558228835489ffff$var$IS_NODE$4 = $558228835489ffff$var$engineIsNode;
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var $558228835489ffff$var$CHROME_BUG = !$558228835489ffff$var$IS_NODE$4 && $558228835489ffff$var$CHROME_VERSION > 79 && $558228835489ffff$var$CHROME_VERSION < 83;
var $558228835489ffff$var$FORCED$4 = $558228835489ffff$var$CHROME_BUG || !$558228835489ffff$var$arrayMethodIsStrict$3('reduce');
// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$558228835489ffff$var$$$C({
    target: 'Array',
    proto: true,
    forced: $558228835489ffff$var$FORCED$4
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var length = arguments.length;
        return $558228835489ffff$var$$reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
    }
});
var $558228835489ffff$var$getBuiltInPrototypeMethod$e = $558228835489ffff$var$getBuiltInPrototypeMethod$g;
var $558228835489ffff$var$reduce$3 = $558228835489ffff$var$getBuiltInPrototypeMethod$e('Array', 'reduce');
var $558228835489ffff$var$isPrototypeOf$h = $558228835489ffff$var$objectIsPrototypeOf;
var $558228835489ffff$var$method$e = $558228835489ffff$var$reduce$3;
var $558228835489ffff$var$ArrayPrototype$f = Array.prototype;
var $558228835489ffff$var$reduce$2 = function(it) {
    var own = it.reduce;
    return it === $558228835489ffff$var$ArrayPrototype$f || $558228835489ffff$var$isPrototypeOf$h($558228835489ffff$var$ArrayPrototype$f, it) && own === $558228835489ffff$var$ArrayPrototype$f.reduce ? $558228835489ffff$var$method$e : own;
};
var $558228835489ffff$var$parent$X = $558228835489ffff$var$reduce$2;
var $558228835489ffff$var$reduce$1 = $558228835489ffff$var$parent$X;
var $558228835489ffff$var$reduce = $558228835489ffff$var$reduce$1;
var $558228835489ffff$var$_reduceInstanceProperty = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$reduce);
var $558228835489ffff$var$$$B = $558228835489ffff$var$_export;
var $558228835489ffff$var$$filter = $558228835489ffff$var$arrayIteration.filter;
var $558228835489ffff$var$arrayMethodHasSpeciesSupport$3 = $558228835489ffff$var$arrayMethodHasSpeciesSupport$5;
var $558228835489ffff$var$HAS_SPECIES_SUPPORT$3 = $558228835489ffff$var$arrayMethodHasSpeciesSupport$3('filter');
// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$558228835489ffff$var$$$B({
    target: 'Array',
    proto: true,
    forced: !$558228835489ffff$var$HAS_SPECIES_SUPPORT$3
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        return $558228835489ffff$var$$filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
var $558228835489ffff$var$getBuiltInPrototypeMethod$d = $558228835489ffff$var$getBuiltInPrototypeMethod$g;
var $558228835489ffff$var$filter$3 = $558228835489ffff$var$getBuiltInPrototypeMethod$d('Array', 'filter');
var $558228835489ffff$var$isPrototypeOf$g = $558228835489ffff$var$objectIsPrototypeOf;
var $558228835489ffff$var$method$d = $558228835489ffff$var$filter$3;
var $558228835489ffff$var$ArrayPrototype$e = Array.prototype;
var $558228835489ffff$var$filter$2 = function(it) {
    var own = it.filter;
    return it === $558228835489ffff$var$ArrayPrototype$e || $558228835489ffff$var$isPrototypeOf$g($558228835489ffff$var$ArrayPrototype$e, it) && own === $558228835489ffff$var$ArrayPrototype$e.filter ? $558228835489ffff$var$method$d : own;
};
var $558228835489ffff$var$parent$W = $558228835489ffff$var$filter$2;
var $558228835489ffff$var$filter$1 = $558228835489ffff$var$parent$W;
var $558228835489ffff$var$filter = $558228835489ffff$var$filter$1;
var $558228835489ffff$var$_filterInstanceProperty = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$filter);
var $558228835489ffff$var$$$A = $558228835489ffff$var$_export;
var $558228835489ffff$var$$map = $558228835489ffff$var$arrayIteration.map;
var $558228835489ffff$var$arrayMethodHasSpeciesSupport$2 = $558228835489ffff$var$arrayMethodHasSpeciesSupport$5;
var $558228835489ffff$var$HAS_SPECIES_SUPPORT$2 = $558228835489ffff$var$arrayMethodHasSpeciesSupport$2('map');
// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$558228835489ffff$var$$$A({
    target: 'Array',
    proto: true,
    forced: !$558228835489ffff$var$HAS_SPECIES_SUPPORT$2
}, {
    map: function map(callbackfn /* , thisArg */ ) {
        return $558228835489ffff$var$$map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
var $558228835489ffff$var$getBuiltInPrototypeMethod$c = $558228835489ffff$var$getBuiltInPrototypeMethod$g;
var $558228835489ffff$var$map$6 = $558228835489ffff$var$getBuiltInPrototypeMethod$c('Array', 'map');
var $558228835489ffff$var$isPrototypeOf$f = $558228835489ffff$var$objectIsPrototypeOf;
var $558228835489ffff$var$method$c = $558228835489ffff$var$map$6;
var $558228835489ffff$var$ArrayPrototype$d = Array.prototype;
var $558228835489ffff$var$map$5 = function(it) {
    var own = it.map;
    return it === $558228835489ffff$var$ArrayPrototype$d || $558228835489ffff$var$isPrototypeOf$f($558228835489ffff$var$ArrayPrototype$d, it) && own === $558228835489ffff$var$ArrayPrototype$d.map ? $558228835489ffff$var$method$c : own;
};
var $558228835489ffff$var$parent$V = $558228835489ffff$var$map$5;
var $558228835489ffff$var$map$4 = $558228835489ffff$var$parent$V;
var $558228835489ffff$var$map$3 = $558228835489ffff$var$map$4;
var $558228835489ffff$var$_mapInstanceProperty = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$map$3);
var $558228835489ffff$var$isArray$a = $558228835489ffff$var$isArray$e;
var $558228835489ffff$var$lengthOfArrayLike$7 = $558228835489ffff$var$lengthOfArrayLike$d;
var $558228835489ffff$var$doesNotExceedSafeInteger$2 = $558228835489ffff$var$doesNotExceedSafeInteger$4;
var $558228835489ffff$var$bind$a = $558228835489ffff$var$functionBindContext;
// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var $558228835489ffff$var$flattenIntoArray$1 = function(target, original, source, sourceLen, start, depth, mapper, thisArg) {
    var targetIndex = start;
    var sourceIndex = 0;
    var mapFn = mapper ? $558228835489ffff$var$bind$a(mapper, thisArg) : false;
    var element, elementLen;
    while(sourceIndex < sourceLen){
        if (sourceIndex in source) {
            element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
            if (depth > 0 && $558228835489ffff$var$isArray$a(element)) {
                elementLen = $558228835489ffff$var$lengthOfArrayLike$7(element);
                targetIndex = $558228835489ffff$var$flattenIntoArray$1(target, original, element, elementLen, targetIndex, depth - 1) - 1;
            } else {
                $558228835489ffff$var$doesNotExceedSafeInteger$2(targetIndex + 1);
                target[targetIndex] = element;
            }
            targetIndex++;
        }
        sourceIndex++;
    }
    return targetIndex;
};
var $558228835489ffff$var$flattenIntoArray_1 = $558228835489ffff$var$flattenIntoArray$1;
var $558228835489ffff$var$$$z = $558228835489ffff$var$_export;
var $558228835489ffff$var$flattenIntoArray = $558228835489ffff$var$flattenIntoArray_1;
var $558228835489ffff$var$aCallable$8 = $558228835489ffff$var$aCallable$e;
var $558228835489ffff$var$toObject$7 = $558228835489ffff$var$toObject$e;
var $558228835489ffff$var$lengthOfArrayLike$6 = $558228835489ffff$var$lengthOfArrayLike$d;
var $558228835489ffff$var$arraySpeciesCreate$1 = $558228835489ffff$var$arraySpeciesCreate$4;
// `Array.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-array.prototype.flatmap
$558228835489ffff$var$$$z({
    target: 'Array',
    proto: true
}, {
    flatMap: function flatMap(callbackfn /* , thisArg */ ) {
        var O = $558228835489ffff$var$toObject$7(this);
        var sourceLen = $558228835489ffff$var$lengthOfArrayLike$6(O);
        var A;
        $558228835489ffff$var$aCallable$8(callbackfn);
        A = $558228835489ffff$var$arraySpeciesCreate$1(O, 0);
        A.length = $558228835489ffff$var$flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        return A;
    }
});
var $558228835489ffff$var$getBuiltInPrototypeMethod$b = $558228835489ffff$var$getBuiltInPrototypeMethod$g;
var $558228835489ffff$var$flatMap$3 = $558228835489ffff$var$getBuiltInPrototypeMethod$b('Array', 'flatMap');
var $558228835489ffff$var$isPrototypeOf$e = $558228835489ffff$var$objectIsPrototypeOf;
var $558228835489ffff$var$method$b = $558228835489ffff$var$flatMap$3;
var $558228835489ffff$var$ArrayPrototype$c = Array.prototype;
var $558228835489ffff$var$flatMap$2 = function(it) {
    var own = it.flatMap;
    return it === $558228835489ffff$var$ArrayPrototype$c || $558228835489ffff$var$isPrototypeOf$e($558228835489ffff$var$ArrayPrototype$c, it) && own === $558228835489ffff$var$ArrayPrototype$c.flatMap ? $558228835489ffff$var$method$b : own;
};
var $558228835489ffff$var$parent$U = $558228835489ffff$var$flatMap$2;
var $558228835489ffff$var$flatMap$1 = $558228835489ffff$var$parent$U;
var $558228835489ffff$var$flatMap = $558228835489ffff$var$flatMap$1;
var $558228835489ffff$var$_flatMapInstanceProperty = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$flatMap);
/**
 * Create new data pipe.
 *
 * @param from - The source data set or data view.
 * @remarks
 * Example usage:
 * ```typescript
 * interface AppItem {
 *   whoami: string;
 *   appData: unknown;
 *   visData: VisItem;
 * }
 * interface VisItem {
 *   id: number;
 *   label: string;
 *   color: string;
 *   x: number;
 *   y: number;
 * }
 *
 * const ds1 = new DataSet<AppItem, "whoami">([], { fieldId: "whoami" });
 * const ds2 = new DataSet<VisItem, "id">();
 *
 * const pipe = createNewDataPipeFrom(ds1)
 *   .filter((item): boolean => item.enabled === true)
 *   .map<VisItem, "id">((item): VisItem => item.visData)
 *   .to(ds2);
 *
 * pipe.start();
 * ```
 * @returns A factory whose methods can be used to configure the pipe.
 */ function $558228835489ffff$export$2368b95f8b170c1e(from) {
    return new $558228835489ffff$var$DataPipeUnderConstruction(from);
}
/**
 * Internal implementation of the pipe. This should be accessible only through
 * `createNewDataPipeFrom` from the outside.
 *
 * @typeParam SI - Source item type.
 * @typeParam SP - Source item type's id property name.
 * @typeParam TI - Target item type.
 * @typeParam TP - Target item type's id property name.
 */ var $558228835489ffff$var$SimpleDataPipe = /*#__PURE__*/ function() {
    /**
   * Create a new data pipe.
   *
   * @param _source - The data set or data view that will be observed.
   * @param _transformers - An array of transforming functions to be used to
   * filter or transform the items in the pipe.
   * @param _target - The data set or data view that will receive the items.
   */ function SimpleDataPipe(_source, _transformers, _target) {
        var _context, _context2, _context3;
        $558228835489ffff$var$_classCallCheck(this, SimpleDataPipe);
        /**
     * Bound listeners for use with `DataInterface['on' | 'off']`.
     */ $558228835489ffff$var$_defineProperty(this, "_listeners", {
            add: $558228835489ffff$var$_bindInstanceProperty$1(_context = this._add).call(_context, this),
            remove: $558228835489ffff$var$_bindInstanceProperty$1(_context2 = this._remove).call(_context2, this),
            update: $558228835489ffff$var$_bindInstanceProperty$1(_context3 = this._update).call(_context3, this)
        });
        this._source = _source;
        this._transformers = _transformers;
        this._target = _target;
    }
    /** @inheritDoc */ $558228835489ffff$var$_createClass(SimpleDataPipe, [
        {
            key: "all",
            value: function all() {
                this._target.update(this._transformItems(this._source.get()));
                return this;
            }
        },
        {
            key: "start",
            value: function start() {
                this._source.on("add", this._listeners.add);
                this._source.on("remove", this._listeners.remove);
                this._source.on("update", this._listeners.update);
                return this;
            }
        },
        {
            key: "stop",
            value: function stop() {
                this._source.off("add", this._listeners.add);
                this._source.off("remove", this._listeners.remove);
                this._source.off("update", this._listeners.update);
                return this;
            }
        },
        {
            key: "_transformItems",
            value: function _transformItems(items) {
                var _context4;
                return $558228835489ffff$var$_reduceInstanceProperty(_context4 = this._transformers).call(_context4, function(items, transform) {
                    return transform(items);
                }, items);
            }
        },
        {
            key: "_add",
            value: function _add(_name, payload) {
                if (payload == null) return;
                this._target.add(this._transformItems(this._source.get(payload.items)));
            }
        },
        {
            key: "_update",
            value: function _update(_name, payload) {
                if (payload == null) return;
                this._target.update(this._transformItems(this._source.get(payload.items)));
            }
        },
        {
            key: "_remove",
            value: function _remove(_name, payload) {
                if (payload == null) return;
                this._target.remove(this._transformItems(payload.oldData));
            }
        }
    ]);
    return SimpleDataPipe;
}();
/**
 * Internal implementation of the pipe factory. This should be accessible
 * only through `createNewDataPipeFrom` from the outside.
 *
 * @typeParam TI - Target item type.
 * @typeParam TP - Target item type's id property name.
 */ var $558228835489ffff$var$DataPipeUnderConstruction = /*#__PURE__*/ function() {
    /**
   * Create a new data pipe factory. This is an internal constructor that
   * should never be called from outside of this file.
   *
   * @param _source - The source data set or data view for this pipe.
   */ function DataPipeUnderConstruction(_source) {
        $558228835489ffff$var$_classCallCheck(this, DataPipeUnderConstruction);
        /**
     * Array transformers used to transform items within the pipe. This is typed
     * as any for the sake of simplicity.
     */ $558228835489ffff$var$_defineProperty(this, "_transformers", []);
        this._source = _source;
    }
    /**
   * Filter the items.
   *
   * @param callback - A filtering function that returns true if given item
   * should be piped and false if not.
   * @returns This factory for further configuration.
   */ $558228835489ffff$var$_createClass(DataPipeUnderConstruction, [
        {
            key: "filter",
            value: function filter(callback) {
                this._transformers.push(function(input) {
                    return $558228835489ffff$var$_filterInstanceProperty(input).call(input, callback);
                });
                return this;
            }
        },
        {
            key: "map",
            value: function map(callback) {
                this._transformers.push(function(input) {
                    return $558228835489ffff$var$_mapInstanceProperty(input).call(input, callback);
                });
                return this;
            }
        },
        {
            key: "flatMap",
            value: function flatMap(callback) {
                this._transformers.push(function(input) {
                    return $558228835489ffff$var$_flatMapInstanceProperty(input).call(input, callback);
                });
                return this;
            }
        },
        {
            key: "to",
            value: function to(target) {
                return new $558228835489ffff$var$SimpleDataPipe(this._source, this._transformers, target);
            }
        }
    ]);
    return DataPipeUnderConstruction;
}();
var $558228835489ffff$var$call$a = $558228835489ffff$var$functionCall;
var $558228835489ffff$var$anObject$7 = $558228835489ffff$var$anObject$d;
var $558228835489ffff$var$getMethod$1 = $558228835489ffff$var$getMethod$3;
var $558228835489ffff$var$iteratorClose$2 = function(iterator, kind, value) {
    var innerResult, innerError;
    $558228835489ffff$var$anObject$7(iterator);
    try {
        innerResult = $558228835489ffff$var$getMethod$1(iterator, 'return');
        if (!innerResult) {
            if (kind === 'throw') throw value;
            return value;
        }
        innerResult = $558228835489ffff$var$call$a(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === 'throw') throw value;
    if (innerError) throw innerResult;
    $558228835489ffff$var$anObject$7(innerResult);
    return value;
};
var $558228835489ffff$var$anObject$6 = $558228835489ffff$var$anObject$d;
var $558228835489ffff$var$iteratorClose$1 = $558228835489ffff$var$iteratorClose$2;
// call something on iterator step with safe closing on error
var $558228835489ffff$var$callWithSafeIterationClosing$1 = function(iterator, fn, value, ENTRIES) {
    try {
        return ENTRIES ? fn($558228835489ffff$var$anObject$6(value)[0], value[1]) : fn(value);
    } catch (error) {
        $558228835489ffff$var$iteratorClose$1(iterator, 'throw', error);
    }
};
var $558228835489ffff$var$wellKnownSymbol$7 = $558228835489ffff$var$wellKnownSymbol$n;
var $558228835489ffff$var$Iterators$1 = $558228835489ffff$var$iterators;
var $558228835489ffff$var$ITERATOR$2 = $558228835489ffff$var$wellKnownSymbol$7('iterator');
var $558228835489ffff$var$ArrayPrototype$b = Array.prototype;
// check on default Array iterator
var $558228835489ffff$var$isArrayIteratorMethod$2 = function(it) {
    return it !== undefined && ($558228835489ffff$var$Iterators$1.Array === it || $558228835489ffff$var$ArrayPrototype$b[$558228835489ffff$var$ITERATOR$2] === it);
};
var $558228835489ffff$var$classof$5 = $558228835489ffff$var$classof$d;
var $558228835489ffff$var$getMethod = $558228835489ffff$var$getMethod$3;
var $558228835489ffff$var$isNullOrUndefined$3 = $558228835489ffff$var$isNullOrUndefined$6;
var $558228835489ffff$var$Iterators = $558228835489ffff$var$iterators;
var $558228835489ffff$var$wellKnownSymbol$6 = $558228835489ffff$var$wellKnownSymbol$n;
var $558228835489ffff$var$ITERATOR$1 = $558228835489ffff$var$wellKnownSymbol$6('iterator');
var $558228835489ffff$var$getIteratorMethod$9 = function(it) {
    if (!$558228835489ffff$var$isNullOrUndefined$3(it)) return $558228835489ffff$var$getMethod(it, $558228835489ffff$var$ITERATOR$1) || $558228835489ffff$var$getMethod(it, '@@iterator') || $558228835489ffff$var$Iterators[$558228835489ffff$var$classof$5(it)];
};
var $558228835489ffff$var$call$9 = $558228835489ffff$var$functionCall;
var $558228835489ffff$var$aCallable$7 = $558228835489ffff$var$aCallable$e;
var $558228835489ffff$var$anObject$5 = $558228835489ffff$var$anObject$d;
var $558228835489ffff$var$tryToString$3 = $558228835489ffff$var$tryToString$6;
var $558228835489ffff$var$getIteratorMethod$8 = $558228835489ffff$var$getIteratorMethod$9;
var $558228835489ffff$var$$TypeError$7 = TypeError;
var $558228835489ffff$var$getIterator$8 = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $558228835489ffff$var$getIteratorMethod$8(argument) : usingIterator;
    if ($558228835489ffff$var$aCallable$7(iteratorMethod)) return $558228835489ffff$var$anObject$5($558228835489ffff$var$call$9(iteratorMethod, argument));
    throw new $558228835489ffff$var$$TypeError$7($558228835489ffff$var$tryToString$3(argument) + ' is not iterable');
};
var $558228835489ffff$var$bind$9 = $558228835489ffff$var$functionBindContext;
var $558228835489ffff$var$call$8 = $558228835489ffff$var$functionCall;
var $558228835489ffff$var$toObject$6 = $558228835489ffff$var$toObject$e;
var $558228835489ffff$var$callWithSafeIterationClosing = $558228835489ffff$var$callWithSafeIterationClosing$1;
var $558228835489ffff$var$isArrayIteratorMethod$1 = $558228835489ffff$var$isArrayIteratorMethod$2;
var $558228835489ffff$var$isConstructor$2 = $558228835489ffff$var$isConstructor$4;
var $558228835489ffff$var$lengthOfArrayLike$5 = $558228835489ffff$var$lengthOfArrayLike$d;
var $558228835489ffff$var$createProperty$3 = $558228835489ffff$var$createProperty$6;
var $558228835489ffff$var$getIterator$7 = $558228835489ffff$var$getIterator$8;
var $558228835489ffff$var$getIteratorMethod$7 = $558228835489ffff$var$getIteratorMethod$9;
var $558228835489ffff$var$$Array$1 = Array;
// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
var $558228835489ffff$var$arrayFrom = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
    var O = $558228835489ffff$var$toObject$6(arrayLike);
    var IS_CONSTRUCTOR = $558228835489ffff$var$isConstructor$2(this);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    if (mapping) mapfn = $558228835489ffff$var$bind$9(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
    var iteratorMethod = $558228835489ffff$var$getIteratorMethod$7(O);
    var index = 0;
    var length, result, step, iterator, next, value;
    // if the target is not iterable or it's an array with the default iterator - use a simple case
    if (iteratorMethod && !(this === $558228835489ffff$var$$Array$1 && $558228835489ffff$var$isArrayIteratorMethod$1(iteratorMethod))) {
        iterator = $558228835489ffff$var$getIterator$7(O, iteratorMethod);
        next = iterator.next;
        result = IS_CONSTRUCTOR ? new this() : [];
        for(; !(step = $558228835489ffff$var$call$8(next, iterator)).done; index++){
            value = mapping ? $558228835489ffff$var$callWithSafeIterationClosing(iterator, mapfn, [
                step.value,
                index
            ], true) : step.value;
            $558228835489ffff$var$createProperty$3(result, index, value);
        }
    } else {
        length = $558228835489ffff$var$lengthOfArrayLike$5(O);
        result = IS_CONSTRUCTOR ? new this(length) : $558228835489ffff$var$$Array$1(length);
        for(; length > index; index++){
            value = mapping ? mapfn(O[index], index) : O[index];
            $558228835489ffff$var$createProperty$3(result, index, value);
        }
    }
    result.length = index;
    return result;
};
var $558228835489ffff$var$wellKnownSymbol$5 = $558228835489ffff$var$wellKnownSymbol$n;
var $558228835489ffff$var$ITERATOR = $558228835489ffff$var$wellKnownSymbol$5('iterator');
var $558228835489ffff$var$SAFE_CLOSING = false;
try {
    var $558228835489ffff$var$called = 0;
    var $558228835489ffff$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$558228835489ffff$var$called++
            };
        },
        'return': function() {
            $558228835489ffff$var$SAFE_CLOSING = true;
        }
    };
    $558228835489ffff$var$iteratorWithReturn[$558228835489ffff$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($558228835489ffff$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
var $558228835489ffff$var$checkCorrectnessOfIteration$2 = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !$558228835489ffff$var$SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$558228835489ffff$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};
var $558228835489ffff$var$$$y = $558228835489ffff$var$_export;
var $558228835489ffff$var$from$6 = $558228835489ffff$var$arrayFrom;
var $558228835489ffff$var$checkCorrectnessOfIteration$1 = $558228835489ffff$var$checkCorrectnessOfIteration$2;
var $558228835489ffff$var$INCORRECT_ITERATION = !$558228835489ffff$var$checkCorrectnessOfIteration$1(function(iterable) {
    // eslint-disable-next-line es/no-array-from -- required for testing
    Array.from(iterable);
});
// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$558228835489ffff$var$$$y({
    target: 'Array',
    stat: true,
    forced: $558228835489ffff$var$INCORRECT_ITERATION
}, {
    from: $558228835489ffff$var$from$6
});
var $558228835489ffff$var$path$h = $558228835489ffff$var$path$o;
var $558228835489ffff$var$from$5 = $558228835489ffff$var$path$h.Array.from;
var $558228835489ffff$var$parent$T = $558228835489ffff$var$from$5;
var $558228835489ffff$var$from$4 = $558228835489ffff$var$parent$T;
var $558228835489ffff$var$from$3 = $558228835489ffff$var$from$4;
var $558228835489ffff$var$_Array$from$1 = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$from$3);
var $558228835489ffff$var$getIteratorMethod$6 = $558228835489ffff$var$getIteratorMethod$9;
var $558228835489ffff$var$getIteratorMethod_1 = $558228835489ffff$var$getIteratorMethod$6;
var $558228835489ffff$var$parent$S = $558228835489ffff$var$getIteratorMethod_1;
var $558228835489ffff$var$getIteratorMethod$5 = $558228835489ffff$var$parent$S;
var $558228835489ffff$var$parent$R = $558228835489ffff$var$getIteratorMethod$5;
var $558228835489ffff$var$getIteratorMethod$4 = $558228835489ffff$var$parent$R;
var $558228835489ffff$var$parent$Q = $558228835489ffff$var$getIteratorMethod$4;
var $558228835489ffff$var$getIteratorMethod$3 = $558228835489ffff$var$parent$Q;
var $558228835489ffff$var$getIteratorMethod$2 = $558228835489ffff$var$getIteratorMethod$3;
var $558228835489ffff$var$_getIteratorMethod$1 = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$getIteratorMethod$2);
var $558228835489ffff$var$getIteratorMethod$1 = $558228835489ffff$var$getIteratorMethod$2;
var $558228835489ffff$var$_getIteratorMethod = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$getIteratorMethod$1);
var $558228835489ffff$var$$$x = $558228835489ffff$var$_export;
var $558228835489ffff$var$isArray$9 = $558228835489ffff$var$isArray$e;
// `Array.isArray` method
// https://tc39.es/ecma262/#sec-array.isarray
$558228835489ffff$var$$$x({
    target: 'Array',
    stat: true
}, {
    isArray: $558228835489ffff$var$isArray$9
});
var $558228835489ffff$var$path$g = $558228835489ffff$var$path$o;
var $558228835489ffff$var$isArray$8 = $558228835489ffff$var$path$g.Array.isArray;
var $558228835489ffff$var$parent$P = $558228835489ffff$var$isArray$8;
var $558228835489ffff$var$isArray$7 = $558228835489ffff$var$parent$P;
var $558228835489ffff$var$parent$O = $558228835489ffff$var$isArray$7;
var $558228835489ffff$var$isArray$6 = $558228835489ffff$var$parent$O;
var $558228835489ffff$var$parent$N = $558228835489ffff$var$isArray$6;
var $558228835489ffff$var$isArray$5 = $558228835489ffff$var$parent$N;
var $558228835489ffff$var$isArray$4 = $558228835489ffff$var$isArray$5;
var $558228835489ffff$var$_Array$isArray$1 = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$isArray$4);
function $558228835489ffff$var$_arrayWithHoles(arr) {
    if ($558228835489ffff$var$_Array$isArray$1(arr)) return arr;
}
var $558228835489ffff$var$DESCRIPTORS$8 = $558228835489ffff$var$descriptors;
var $558228835489ffff$var$isArray$3 = $558228835489ffff$var$isArray$e;
var $558228835489ffff$var$$TypeError$6 = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $558228835489ffff$var$getOwnPropertyDescriptor$5 = Object.getOwnPropertyDescriptor;
// Safari < 13 does not throw an error in this case
var $558228835489ffff$var$SILENT_ON_NON_WRITABLE_LENGTH_SET = $558228835489ffff$var$DESCRIPTORS$8 && !function() {
    // makes no sense without proper strict mode support
    if (this !== undefined) return true;
    try {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty([], 'length', {
            writable: false
        }).length = 1;
    } catch (error) {
        return error instanceof TypeError;
    }
}();
var $558228835489ffff$var$arraySetLength = $558228835489ffff$var$SILENT_ON_NON_WRITABLE_LENGTH_SET ? function(O, length) {
    if ($558228835489ffff$var$isArray$3(O) && !$558228835489ffff$var$getOwnPropertyDescriptor$5(O, 'length').writable) throw new $558228835489ffff$var$$TypeError$6('Cannot set read only .length');
    return O.length = length;
} : function(O, length) {
    return O.length = length;
};
var $558228835489ffff$var$$$w = $558228835489ffff$var$_export;
var $558228835489ffff$var$toObject$5 = $558228835489ffff$var$toObject$e;
var $558228835489ffff$var$lengthOfArrayLike$4 = $558228835489ffff$var$lengthOfArrayLike$d;
var $558228835489ffff$var$setArrayLength$1 = $558228835489ffff$var$arraySetLength;
var $558228835489ffff$var$doesNotExceedSafeInteger$1 = $558228835489ffff$var$doesNotExceedSafeInteger$4;
var $558228835489ffff$var$fails$d = $558228835489ffff$var$fails$u;
var $558228835489ffff$var$INCORRECT_TO_LENGTH = $558228835489ffff$var$fails$d(function() {
    return [].push.call({
        length: 0x100000000
    }, 1) !== 4294967297;
});
// V8 and Safari <= 15.4, FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var $558228835489ffff$var$properErrorOnNonWritableLength = function() {
    try {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty([], 'length', {
            writable: false
        }).push();
    } catch (error) {
        return error instanceof TypeError;
    }
};
var $558228835489ffff$var$FORCED$3 = $558228835489ffff$var$INCORRECT_TO_LENGTH || !$558228835489ffff$var$properErrorOnNonWritableLength();
// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$558228835489ffff$var$$$w({
    target: 'Array',
    proto: true,
    arity: 1,
    forced: $558228835489ffff$var$FORCED$3
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    push: function push(item) {
        var O = $558228835489ffff$var$toObject$5(this);
        var len = $558228835489ffff$var$lengthOfArrayLike$4(O);
        var argCount = arguments.length;
        $558228835489ffff$var$doesNotExceedSafeInteger$1(len + argCount);
        for(var i = 0; i < argCount; i++){
            O[len] = arguments[i];
            len++;
        }
        $558228835489ffff$var$setArrayLength$1(O, len);
        return len;
    }
});
var $558228835489ffff$var$getBuiltInPrototypeMethod$a = $558228835489ffff$var$getBuiltInPrototypeMethod$g;
var $558228835489ffff$var$push$8 = $558228835489ffff$var$getBuiltInPrototypeMethod$a('Array', 'push');
var $558228835489ffff$var$isPrototypeOf$d = $558228835489ffff$var$objectIsPrototypeOf;
var $558228835489ffff$var$method$a = $558228835489ffff$var$push$8;
var $558228835489ffff$var$ArrayPrototype$a = Array.prototype;
var $558228835489ffff$var$push$7 = function(it) {
    var own = it.push;
    return it === $558228835489ffff$var$ArrayPrototype$a || $558228835489ffff$var$isPrototypeOf$d($558228835489ffff$var$ArrayPrototype$a, it) && own === $558228835489ffff$var$ArrayPrototype$a.push ? $558228835489ffff$var$method$a : own;
};
var $558228835489ffff$var$parent$M = $558228835489ffff$var$push$7;
var $558228835489ffff$var$push$6 = $558228835489ffff$var$parent$M;
var $558228835489ffff$var$parent$L = $558228835489ffff$var$push$6;
var $558228835489ffff$var$push$5 = $558228835489ffff$var$parent$L;
var $558228835489ffff$var$parent$K = $558228835489ffff$var$push$5;
var $558228835489ffff$var$push$4 = $558228835489ffff$var$parent$K;
var $558228835489ffff$var$push$3 = $558228835489ffff$var$push$4;
var $558228835489ffff$var$_pushInstanceProperty = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$push$3);
function $558228835489ffff$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof $558228835489ffff$var$_Symbol$1 && $558228835489ffff$var$_getIteratorMethod$1(r) || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && ($558228835489ffff$var$_pushInstanceProperty(a).call(a, e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
var $558228835489ffff$var$$$v = $558228835489ffff$var$_export;
var $558228835489ffff$var$isArray$2 = $558228835489ffff$var$isArray$e;
var $558228835489ffff$var$isConstructor$1 = $558228835489ffff$var$isConstructor$4;
var $558228835489ffff$var$isObject$7 = $558228835489ffff$var$isObject$h;
var $558228835489ffff$var$toAbsoluteIndex$1 = $558228835489ffff$var$toAbsoluteIndex$4;
var $558228835489ffff$var$lengthOfArrayLike$3 = $558228835489ffff$var$lengthOfArrayLike$d;
var $558228835489ffff$var$toIndexedObject$2 = $558228835489ffff$var$toIndexedObject$a;
var $558228835489ffff$var$createProperty$2 = $558228835489ffff$var$createProperty$6;
var $558228835489ffff$var$wellKnownSymbol$4 = $558228835489ffff$var$wellKnownSymbol$n;
var $558228835489ffff$var$arrayMethodHasSpeciesSupport$1 = $558228835489ffff$var$arrayMethodHasSpeciesSupport$5;
var $558228835489ffff$var$nativeSlice = $558228835489ffff$var$arraySlice$5;
var $558228835489ffff$var$HAS_SPECIES_SUPPORT$1 = $558228835489ffff$var$arrayMethodHasSpeciesSupport$1('slice');
var $558228835489ffff$var$SPECIES$3 = $558228835489ffff$var$wellKnownSymbol$4('species');
var $558228835489ffff$var$$Array = Array;
var $558228835489ffff$var$max$1 = Math.max;
// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$558228835489ffff$var$$$v({
    target: 'Array',
    proto: true,
    forced: !$558228835489ffff$var$HAS_SPECIES_SUPPORT$1
}, {
    slice: function slice(start, end) {
        var O = $558228835489ffff$var$toIndexedObject$2(this);
        var length = $558228835489ffff$var$lengthOfArrayLike$3(O);
        var k = $558228835489ffff$var$toAbsoluteIndex$1(start, length);
        var fin = $558228835489ffff$var$toAbsoluteIndex$1(end === undefined ? length : end, length);
        // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
        var Constructor, result, n;
        if ($558228835489ffff$var$isArray$2(O)) {
            Constructor = O.constructor;
            // cross-realm fallback
            if ($558228835489ffff$var$isConstructor$1(Constructor) && (Constructor === $558228835489ffff$var$$Array || $558228835489ffff$var$isArray$2(Constructor.prototype))) Constructor = undefined;
            else if ($558228835489ffff$var$isObject$7(Constructor)) {
                Constructor = Constructor[$558228835489ffff$var$SPECIES$3];
                if (Constructor === null) Constructor = undefined;
            }
            if (Constructor === $558228835489ffff$var$$Array || Constructor === undefined) return $558228835489ffff$var$nativeSlice(O, k, fin);
        }
        result = new (Constructor === undefined ? $558228835489ffff$var$$Array : Constructor)($558228835489ffff$var$max$1(fin - k, 0));
        for(n = 0; k < fin; k++, n++)if (k in O) $558228835489ffff$var$createProperty$2(result, n, O[k]);
        result.length = n;
        return result;
    }
});
var $558228835489ffff$var$getBuiltInPrototypeMethod$9 = $558228835489ffff$var$getBuiltInPrototypeMethod$g;
var $558228835489ffff$var$slice$6 = $558228835489ffff$var$getBuiltInPrototypeMethod$9('Array', 'slice');
var $558228835489ffff$var$isPrototypeOf$c = $558228835489ffff$var$objectIsPrototypeOf;
var $558228835489ffff$var$method$9 = $558228835489ffff$var$slice$6;
var $558228835489ffff$var$ArrayPrototype$9 = Array.prototype;
var $558228835489ffff$var$slice$5 = function(it) {
    var own = it.slice;
    return it === $558228835489ffff$var$ArrayPrototype$9 || $558228835489ffff$var$isPrototypeOf$c($558228835489ffff$var$ArrayPrototype$9, it) && own === $558228835489ffff$var$ArrayPrototype$9.slice ? $558228835489ffff$var$method$9 : own;
};
var $558228835489ffff$var$parent$J = $558228835489ffff$var$slice$5;
var $558228835489ffff$var$slice$4 = $558228835489ffff$var$parent$J;
var $558228835489ffff$var$parent$I = $558228835489ffff$var$slice$4;
var $558228835489ffff$var$slice$3 = $558228835489ffff$var$parent$I;
var $558228835489ffff$var$parent$H = $558228835489ffff$var$slice$3;
var $558228835489ffff$var$slice$2 = $558228835489ffff$var$parent$H;
var $558228835489ffff$var$slice$1 = $558228835489ffff$var$slice$2;
var $558228835489ffff$var$_sliceInstanceProperty$1 = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$slice$1);
var $558228835489ffff$var$parent$G = $558228835489ffff$var$from$4;
var $558228835489ffff$var$from$2 = $558228835489ffff$var$parent$G;
var $558228835489ffff$var$parent$F = $558228835489ffff$var$from$2;
var $558228835489ffff$var$from$1 = $558228835489ffff$var$parent$F;
var $558228835489ffff$var$from = $558228835489ffff$var$from$1;
var $558228835489ffff$var$_Array$from = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$from);
function $558228835489ffff$var$_arrayLikeToArray$4(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $558228835489ffff$var$_unsupportedIterableToArray$4(o, minLen) {
    var _context;
    if (!o) return;
    if (typeof o === "string") return $558228835489ffff$var$_arrayLikeToArray$4(o, minLen);
    var n = $558228835489ffff$var$_sliceInstanceProperty$1(_context = Object.prototype.toString.call(o)).call(_context, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return $558228835489ffff$var$_Array$from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $558228835489ffff$var$_arrayLikeToArray$4(o, minLen);
}
function $558228835489ffff$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $558228835489ffff$var$_slicedToArray(arr, i) {
    return $558228835489ffff$var$_arrayWithHoles(arr) || $558228835489ffff$var$_iterableToArrayLimit(arr, i) || $558228835489ffff$var$_unsupportedIterableToArray$4(arr, i) || $558228835489ffff$var$_nonIterableRest();
}
function $558228835489ffff$var$_arrayWithoutHoles(arr) {
    if ($558228835489ffff$var$_Array$isArray$1(arr)) return $558228835489ffff$var$_arrayLikeToArray$4(arr);
}
function $558228835489ffff$var$_iterableToArray(iter) {
    if (typeof $558228835489ffff$var$_Symbol$1 !== "undefined" && $558228835489ffff$var$_getIteratorMethod$1(iter) != null || iter["@@iterator"] != null) return $558228835489ffff$var$_Array$from(iter);
}
function $558228835489ffff$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $558228835489ffff$var$_toConsumableArray(arr) {
    return $558228835489ffff$var$_arrayWithoutHoles(arr) || $558228835489ffff$var$_iterableToArray(arr) || $558228835489ffff$var$_unsupportedIterableToArray$4(arr) || $558228835489ffff$var$_nonIterableSpread();
}
var $558228835489ffff$var$symbol = $558228835489ffff$var$symbol$4;
var $558228835489ffff$var$_Symbol = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$symbol);
var $558228835489ffff$var$getBuiltInPrototypeMethod$8 = $558228835489ffff$var$getBuiltInPrototypeMethod$g;
var $558228835489ffff$var$concat$5 = $558228835489ffff$var$getBuiltInPrototypeMethod$8('Array', 'concat');
var $558228835489ffff$var$isPrototypeOf$b = $558228835489ffff$var$objectIsPrototypeOf;
var $558228835489ffff$var$method$8 = $558228835489ffff$var$concat$5;
var $558228835489ffff$var$ArrayPrototype$8 = Array.prototype;
var $558228835489ffff$var$concat$4 = function(it) {
    var own = it.concat;
    return it === $558228835489ffff$var$ArrayPrototype$8 || $558228835489ffff$var$isPrototypeOf$b($558228835489ffff$var$ArrayPrototype$8, it) && own === $558228835489ffff$var$ArrayPrototype$8.concat ? $558228835489ffff$var$method$8 : own;
};
var $558228835489ffff$var$parent$E = $558228835489ffff$var$concat$4;
var $558228835489ffff$var$concat$3 = $558228835489ffff$var$parent$E;
var $558228835489ffff$var$concat$2 = $558228835489ffff$var$concat$3;
var $558228835489ffff$var$_concatInstanceProperty = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$concat$2);
var $558228835489ffff$var$slice = $558228835489ffff$var$slice$4;
var $558228835489ffff$var$_sliceInstanceProperty = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$slice);
var $558228835489ffff$var$getBuiltIn$5 = $558228835489ffff$var$getBuiltIn$f;
var $558228835489ffff$var$uncurryThis$5 = $558228835489ffff$var$functionUncurryThis;
var $558228835489ffff$var$getOwnPropertyNamesModule$1 = $558228835489ffff$var$objectGetOwnPropertyNames;
var $558228835489ffff$var$getOwnPropertySymbolsModule$1 = $558228835489ffff$var$objectGetOwnPropertySymbols;
var $558228835489ffff$var$anObject$4 = $558228835489ffff$var$anObject$d;
var $558228835489ffff$var$concat$1 = $558228835489ffff$var$uncurryThis$5([].concat);
// all object keys, includes non-enumerable and symbols
var $558228835489ffff$var$ownKeys$7 = $558228835489ffff$var$getBuiltIn$5('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = $558228835489ffff$var$getOwnPropertyNamesModule$1.f($558228835489ffff$var$anObject$4(it));
    var getOwnPropertySymbols = $558228835489ffff$var$getOwnPropertySymbolsModule$1.f;
    return getOwnPropertySymbols ? $558228835489ffff$var$concat$1(keys, getOwnPropertySymbols(it)) : keys;
};
var $558228835489ffff$var$$$u = $558228835489ffff$var$_export;
var $558228835489ffff$var$ownKeys$6 = $558228835489ffff$var$ownKeys$7;
// `Reflect.ownKeys` method
// https://tc39.es/ecma262/#sec-reflect.ownkeys
$558228835489ffff$var$$$u({
    target: 'Reflect',
    stat: true
}, {
    ownKeys: $558228835489ffff$var$ownKeys$6
});
var $558228835489ffff$var$path$f = $558228835489ffff$var$path$o;
var $558228835489ffff$var$ownKeys$5 = $558228835489ffff$var$path$f.Reflect.ownKeys;
var $558228835489ffff$var$parent$D = $558228835489ffff$var$ownKeys$5;
var $558228835489ffff$var$ownKeys$4 = $558228835489ffff$var$parent$D;
var $558228835489ffff$var$ownKeys$3 = $558228835489ffff$var$ownKeys$4;
var $558228835489ffff$var$_Reflect$ownKeys = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$ownKeys$3);
var $558228835489ffff$var$isArray$1 = $558228835489ffff$var$isArray$7;
var $558228835489ffff$var$_Array$isArray = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$isArray$1);
var $558228835489ffff$var$$$t = $558228835489ffff$var$_export;
var $558228835489ffff$var$toObject$4 = $558228835489ffff$var$toObject$e;
var $558228835489ffff$var$nativeKeys = $558228835489ffff$var$objectKeys$3;
var $558228835489ffff$var$fails$c = $558228835489ffff$var$fails$u;
var $558228835489ffff$var$FAILS_ON_PRIMITIVES$2 = $558228835489ffff$var$fails$c(function() {
    $558228835489ffff$var$nativeKeys(1);
});
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$558228835489ffff$var$$$t({
    target: 'Object',
    stat: true,
    forced: $558228835489ffff$var$FAILS_ON_PRIMITIVES$2
}, {
    keys: function keys(it) {
        return $558228835489ffff$var$nativeKeys($558228835489ffff$var$toObject$4(it));
    }
});
var $558228835489ffff$var$path$e = $558228835489ffff$var$path$o;
var $558228835489ffff$var$keys$6 = $558228835489ffff$var$path$e.Object.keys;
var $558228835489ffff$var$parent$C = $558228835489ffff$var$keys$6;
var $558228835489ffff$var$keys$5 = $558228835489ffff$var$parent$C;
var $558228835489ffff$var$keys$4 = $558228835489ffff$var$keys$5;
var $558228835489ffff$var$_Object$keys = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$keys$4);
var $558228835489ffff$var$$forEach = $558228835489ffff$var$arrayIteration.forEach;
var $558228835489ffff$var$arrayMethodIsStrict$2 = $558228835489ffff$var$arrayMethodIsStrict$4;
var $558228835489ffff$var$STRICT_METHOD$2 = $558228835489ffff$var$arrayMethodIsStrict$2('forEach');
// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
var $558228835489ffff$var$arrayForEach = !$558228835489ffff$var$STRICT_METHOD$2 ? function forEach(callbackfn /* , thisArg */ ) {
    return $558228835489ffff$var$$forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;
var $558228835489ffff$var$$$s = $558228835489ffff$var$_export;
var $558228835489ffff$var$forEach$8 = $558228835489ffff$var$arrayForEach;
// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
$558228835489ffff$var$$$s({
    target: 'Array',
    proto: true,
    forced: [].forEach !== $558228835489ffff$var$forEach$8
}, {
    forEach: $558228835489ffff$var$forEach$8
});
var $558228835489ffff$var$getBuiltInPrototypeMethod$7 = $558228835489ffff$var$getBuiltInPrototypeMethod$g;
var $558228835489ffff$var$forEach$7 = $558228835489ffff$var$getBuiltInPrototypeMethod$7('Array', 'forEach');
var $558228835489ffff$var$parent$B = $558228835489ffff$var$forEach$7;
var $558228835489ffff$var$forEach$6 = $558228835489ffff$var$parent$B;
var $558228835489ffff$var$classof$4 = $558228835489ffff$var$classof$d;
var $558228835489ffff$var$hasOwn$6 = $558228835489ffff$var$hasOwnProperty_1;
var $558228835489ffff$var$isPrototypeOf$a = $558228835489ffff$var$objectIsPrototypeOf;
var $558228835489ffff$var$method$7 = $558228835489ffff$var$forEach$6;
var $558228835489ffff$var$ArrayPrototype$7 = Array.prototype;
var $558228835489ffff$var$DOMIterables$3 = {
    DOMTokenList: true,
    NodeList: true
};
var $558228835489ffff$var$forEach$5 = function(it) {
    var own = it.forEach;
    return it === $558228835489ffff$var$ArrayPrototype$7 || $558228835489ffff$var$isPrototypeOf$a($558228835489ffff$var$ArrayPrototype$7, it) && own === $558228835489ffff$var$ArrayPrototype$7.forEach || $558228835489ffff$var$hasOwn$6($558228835489ffff$var$DOMIterables$3, $558228835489ffff$var$classof$4(it)) ? $558228835489ffff$var$method$7 : own;
};
var $558228835489ffff$var$forEach$4 = $558228835489ffff$var$forEach$5;
var $558228835489ffff$var$_forEachInstanceProperty = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$forEach$4);
var $558228835489ffff$var$$$r = $558228835489ffff$var$_export;
var $558228835489ffff$var$uncurryThis$4 = $558228835489ffff$var$functionUncurryThis;
var $558228835489ffff$var$isArray = $558228835489ffff$var$isArray$e;
var $558228835489ffff$var$nativeReverse = $558228835489ffff$var$uncurryThis$4([].reverse);
var $558228835489ffff$var$test$1 = [
    1,
    2
];
// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$558228835489ffff$var$$$r({
    target: 'Array',
    proto: true,
    forced: String($558228835489ffff$var$test$1) === String($558228835489ffff$var$test$1.reverse())
}, {
    reverse: function reverse() {
        // eslint-disable-next-line no-self-assign -- dirty hack
        if ($558228835489ffff$var$isArray(this)) this.length = this.length;
        return $558228835489ffff$var$nativeReverse(this);
    }
});
var $558228835489ffff$var$getBuiltInPrototypeMethod$6 = $558228835489ffff$var$getBuiltInPrototypeMethod$g;
var $558228835489ffff$var$reverse$6 = $558228835489ffff$var$getBuiltInPrototypeMethod$6('Array', 'reverse');
var $558228835489ffff$var$isPrototypeOf$9 = $558228835489ffff$var$objectIsPrototypeOf;
var $558228835489ffff$var$method$6 = $558228835489ffff$var$reverse$6;
var $558228835489ffff$var$ArrayPrototype$6 = Array.prototype;
var $558228835489ffff$var$reverse$5 = function(it) {
    var own = it.reverse;
    return it === $558228835489ffff$var$ArrayPrototype$6 || $558228835489ffff$var$isPrototypeOf$9($558228835489ffff$var$ArrayPrototype$6, it) && own === $558228835489ffff$var$ArrayPrototype$6.reverse ? $558228835489ffff$var$method$6 : own;
};
var $558228835489ffff$var$parent$A = $558228835489ffff$var$reverse$5;
var $558228835489ffff$var$reverse$4 = $558228835489ffff$var$parent$A;
var $558228835489ffff$var$reverse$3 = $558228835489ffff$var$reverse$4;
var $558228835489ffff$var$_reverseInstanceProperty = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$reverse$3);
var $558228835489ffff$var$tryToString$2 = $558228835489ffff$var$tryToString$6;
var $558228835489ffff$var$$TypeError$5 = TypeError;
var $558228835489ffff$var$deletePropertyOrThrow$2 = function(O, P) {
    if (!delete O[P]) throw new $558228835489ffff$var$$TypeError$5('Cannot delete property ' + $558228835489ffff$var$tryToString$2(P) + ' of ' + $558228835489ffff$var$tryToString$2(O));
};
var $558228835489ffff$var$$$q = $558228835489ffff$var$_export;
var $558228835489ffff$var$toObject$3 = $558228835489ffff$var$toObject$e;
var $558228835489ffff$var$toAbsoluteIndex = $558228835489ffff$var$toAbsoluteIndex$4;
var $558228835489ffff$var$toIntegerOrInfinity = $558228835489ffff$var$toIntegerOrInfinity$4;
var $558228835489ffff$var$lengthOfArrayLike$2 = $558228835489ffff$var$lengthOfArrayLike$d;
var $558228835489ffff$var$setArrayLength = $558228835489ffff$var$arraySetLength;
var $558228835489ffff$var$doesNotExceedSafeInteger = $558228835489ffff$var$doesNotExceedSafeInteger$4;
var $558228835489ffff$var$arraySpeciesCreate = $558228835489ffff$var$arraySpeciesCreate$4;
var $558228835489ffff$var$createProperty$1 = $558228835489ffff$var$createProperty$6;
var $558228835489ffff$var$deletePropertyOrThrow$1 = $558228835489ffff$var$deletePropertyOrThrow$2;
var $558228835489ffff$var$arrayMethodHasSpeciesSupport = $558228835489ffff$var$arrayMethodHasSpeciesSupport$5;
var $558228835489ffff$var$HAS_SPECIES_SUPPORT = $558228835489ffff$var$arrayMethodHasSpeciesSupport('splice');
var $558228835489ffff$var$max = Math.max;
var $558228835489ffff$var$min = Math.min;
// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$558228835489ffff$var$$$q({
    target: 'Array',
    proto: true,
    forced: !$558228835489ffff$var$HAS_SPECIES_SUPPORT
}, {
    splice: function splice(start, deleteCount /* , ...items */ ) {
        var O = $558228835489ffff$var$toObject$3(this);
        var len = $558228835489ffff$var$lengthOfArrayLike$2(O);
        var actualStart = $558228835489ffff$var$toAbsoluteIndex(start, len);
        var argumentsLength = arguments.length;
        var insertCount, actualDeleteCount, A, k, from, to;
        if (argumentsLength === 0) insertCount = actualDeleteCount = 0;
        else if (argumentsLength === 1) {
            insertCount = 0;
            actualDeleteCount = len - actualStart;
        } else {
            insertCount = argumentsLength - 2;
            actualDeleteCount = $558228835489ffff$var$min($558228835489ffff$var$max($558228835489ffff$var$toIntegerOrInfinity(deleteCount), 0), len - actualStart);
        }
        $558228835489ffff$var$doesNotExceedSafeInteger(len + insertCount - actualDeleteCount);
        A = $558228835489ffff$var$arraySpeciesCreate(O, actualDeleteCount);
        for(k = 0; k < actualDeleteCount; k++){
            from = actualStart + k;
            if (from in O) $558228835489ffff$var$createProperty$1(A, k, O[from]);
        }
        A.length = actualDeleteCount;
        if (insertCount < actualDeleteCount) {
            for(k = actualStart; k < len - actualDeleteCount; k++){
                from = k + actualDeleteCount;
                to = k + insertCount;
                if (from in O) O[to] = O[from];
                else $558228835489ffff$var$deletePropertyOrThrow$1(O, to);
            }
            for(k = len; k > len - actualDeleteCount + insertCount; k--)$558228835489ffff$var$deletePropertyOrThrow$1(O, k - 1);
        } else if (insertCount > actualDeleteCount) for(k = len - actualDeleteCount; k > actualStart; k--){
            from = k + actualDeleteCount - 1;
            to = k + insertCount - 1;
            if (from in O) O[to] = O[from];
            else $558228835489ffff$var$deletePropertyOrThrow$1(O, to);
        }
        for(k = 0; k < insertCount; k++)O[k + actualStart] = arguments[k + 2];
        $558228835489ffff$var$setArrayLength(O, len - actualDeleteCount + insertCount);
        return A;
    }
});
var $558228835489ffff$var$getBuiltInPrototypeMethod$5 = $558228835489ffff$var$getBuiltInPrototypeMethod$g;
var $558228835489ffff$var$splice$3 = $558228835489ffff$var$getBuiltInPrototypeMethod$5('Array', 'splice');
var $558228835489ffff$var$isPrototypeOf$8 = $558228835489ffff$var$objectIsPrototypeOf;
var $558228835489ffff$var$method$5 = $558228835489ffff$var$splice$3;
var $558228835489ffff$var$ArrayPrototype$5 = Array.prototype;
var $558228835489ffff$var$splice$2 = function(it) {
    var own = it.splice;
    return it === $558228835489ffff$var$ArrayPrototype$5 || $558228835489ffff$var$isPrototypeOf$8($558228835489ffff$var$ArrayPrototype$5, it) && own === $558228835489ffff$var$ArrayPrototype$5.splice ? $558228835489ffff$var$method$5 : own;
};
var $558228835489ffff$var$parent$z = $558228835489ffff$var$splice$2;
var $558228835489ffff$var$splice$1 = $558228835489ffff$var$parent$z;
var $558228835489ffff$var$splice = $558228835489ffff$var$splice$1;
var $558228835489ffff$var$_spliceInstanceProperty = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$splice);
var $558228835489ffff$var$DESCRIPTORS$7 = $558228835489ffff$var$descriptors;
var $558228835489ffff$var$uncurryThis$3 = $558228835489ffff$var$functionUncurryThis;
var $558228835489ffff$var$call$7 = $558228835489ffff$var$functionCall;
var $558228835489ffff$var$fails$b = $558228835489ffff$var$fails$u;
var $558228835489ffff$var$objectKeys = $558228835489ffff$var$objectKeys$3;
var $558228835489ffff$var$getOwnPropertySymbolsModule = $558228835489ffff$var$objectGetOwnPropertySymbols;
var $558228835489ffff$var$propertyIsEnumerableModule = $558228835489ffff$var$objectPropertyIsEnumerable;
var $558228835489ffff$var$toObject$2 = $558228835489ffff$var$toObject$e;
var $558228835489ffff$var$IndexedObject = $558228835489ffff$var$indexedObject;
// eslint-disable-next-line es/no-object-assign -- safe
var $558228835489ffff$var$$assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var $558228835489ffff$var$defineProperty$3 = Object.defineProperty;
var $558228835489ffff$var$concat = $558228835489ffff$var$uncurryThis$3([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var $558228835489ffff$var$objectAssign = !$558228835489ffff$var$$assign || $558228835489ffff$var$fails$b(function() {
    // should have correct order of operations (Edge bug)
    if ($558228835489ffff$var$DESCRIPTORS$7 && $558228835489ffff$var$$assign({
        b: 1
    }, $558228835489ffff$var$$assign($558228835489ffff$var$defineProperty$3({}, 'a', {
        enumerable: true,
        get: function() {
            $558228835489ffff$var$defineProperty$3(this, 'b', {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es/no-symbol -- safe
    var symbol = Symbol('assign detection');
    var alphabet = 'abcdefghijklmnopqrst';
    A[symbol] = 7;
    alphabet.split('').forEach(function(chr) {
        B[chr] = chr;
    });
    return $558228835489ffff$var$$assign({}, A)[symbol] !== 7 || $558228835489ffff$var$objectKeys($558228835489ffff$var$$assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) {
    var T = $558228835489ffff$var$toObject$2(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $558228835489ffff$var$getOwnPropertySymbolsModule.f;
    var propertyIsEnumerable = $558228835489ffff$var$propertyIsEnumerableModule.f;
    while(argumentsLength > index){
        var S = $558228835489ffff$var$IndexedObject(arguments[index++]);
        var keys = getOwnPropertySymbols ? $558228835489ffff$var$concat($558228835489ffff$var$objectKeys(S), getOwnPropertySymbols(S)) : $558228835489ffff$var$objectKeys(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$558228835489ffff$var$DESCRIPTORS$7 || $558228835489ffff$var$call$7(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $558228835489ffff$var$$assign;
var $558228835489ffff$var$$$p = $558228835489ffff$var$_export;
var $558228835489ffff$var$assign$5 = $558228835489ffff$var$objectAssign;
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$558228835489ffff$var$$$p({
    target: 'Object',
    stat: true,
    arity: 2,
    forced: Object.assign !== $558228835489ffff$var$assign$5
}, {
    assign: $558228835489ffff$var$assign$5
});
var $558228835489ffff$var$path$d = $558228835489ffff$var$path$o;
var $558228835489ffff$var$assign$4 = $558228835489ffff$var$path$d.Object.assign;
var $558228835489ffff$var$parent$y = $558228835489ffff$var$assign$4;
var $558228835489ffff$var$assign$3 = $558228835489ffff$var$parent$y;
var $558228835489ffff$var$assign$2 = $558228835489ffff$var$assign$3;
var $558228835489ffff$var$_Object$assign = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$assign$2);
var $558228835489ffff$var$$$o = $558228835489ffff$var$_export;
var $558228835489ffff$var$fails$a = $558228835489ffff$var$fails$u;
var $558228835489ffff$var$toObject$1 = $558228835489ffff$var$toObject$e;
var $558228835489ffff$var$nativeGetPrototypeOf = $558228835489ffff$var$objectGetPrototypeOf;
var $558228835489ffff$var$CORRECT_PROTOTYPE_GETTER = $558228835489ffff$var$correctPrototypeGetter;
var $558228835489ffff$var$FAILS_ON_PRIMITIVES$1 = $558228835489ffff$var$fails$a(function() {
    $558228835489ffff$var$nativeGetPrototypeOf(1);
});
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$558228835489ffff$var$$$o({
    target: 'Object',
    stat: true,
    forced: $558228835489ffff$var$FAILS_ON_PRIMITIVES$1,
    sham: !$558228835489ffff$var$CORRECT_PROTOTYPE_GETTER
}, {
    getPrototypeOf: function getPrototypeOf(it) {
        return $558228835489ffff$var$nativeGetPrototypeOf($558228835489ffff$var$toObject$1(it));
    }
});
var $558228835489ffff$var$path$c = $558228835489ffff$var$path$o;
var $558228835489ffff$var$getPrototypeOf$5 = $558228835489ffff$var$path$c.Object.getPrototypeOf;
var $558228835489ffff$var$parent$x = $558228835489ffff$var$getPrototypeOf$5;
var $558228835489ffff$var$getPrototypeOf$4 = $558228835489ffff$var$parent$x;
// TODO: Remove from `core-js@4`
var $558228835489ffff$var$$$n = $558228835489ffff$var$_export;
var $558228835489ffff$var$DESCRIPTORS$6 = $558228835489ffff$var$descriptors;
var $558228835489ffff$var$create$9 = $558228835489ffff$var$objectCreate;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
$558228835489ffff$var$$$n({
    target: 'Object',
    stat: true,
    sham: !$558228835489ffff$var$DESCRIPTORS$6
}, {
    create: $558228835489ffff$var$create$9
});
var $558228835489ffff$var$path$b = $558228835489ffff$var$path$o;
var $558228835489ffff$var$Object$3 = $558228835489ffff$var$path$b.Object;
var $558228835489ffff$var$create$8 = function create(P, D) {
    return $558228835489ffff$var$Object$3.create(P, D);
};
var $558228835489ffff$var$parent$w = $558228835489ffff$var$create$8;
var $558228835489ffff$var$create$7 = $558228835489ffff$var$parent$w;
var $558228835489ffff$var$create$6 = $558228835489ffff$var$create$7;
var $558228835489ffff$var$_Object$create$1 = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$create$6);
var $558228835489ffff$var$path$a = $558228835489ffff$var$path$o;
var $558228835489ffff$var$apply$3 = $558228835489ffff$var$functionApply;
// eslint-disable-next-line es/no-json -- safe
if (!$558228835489ffff$var$path$a.JSON) $558228835489ffff$var$path$a.JSON = {
    stringify: JSON.stringify
};
// eslint-disable-next-line no-unused-vars -- required for `.length`
var $558228835489ffff$var$stringify$2 = function stringify(it, replacer, space) {
    return $558228835489ffff$var$apply$3($558228835489ffff$var$path$a.JSON.stringify, null, arguments);
};
var $558228835489ffff$var$parent$v = $558228835489ffff$var$stringify$2;
var $558228835489ffff$var$stringify$1 = $558228835489ffff$var$parent$v;
var $558228835489ffff$var$stringify = $558228835489ffff$var$stringify$1;
var $558228835489ffff$var$_JSON$stringify = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$stringify);
/* global Bun -- Deno case */ var $558228835489ffff$var$engineIsBun = typeof Bun == 'function' && Bun && typeof Bun.version == 'string';
var $558228835489ffff$var$$TypeError$4 = TypeError;
var $558228835489ffff$var$validateArgumentsLength$2 = function(passed, required) {
    if (passed < required) throw new $558228835489ffff$var$$TypeError$4('Not enough arguments');
    return passed;
};
var $558228835489ffff$var$global$9 = $558228835489ffff$var$global$p;
var $558228835489ffff$var$apply$2 = $558228835489ffff$var$functionApply;
var $558228835489ffff$var$isCallable$5 = $558228835489ffff$var$isCallable$m;
var $558228835489ffff$var$ENGINE_IS_BUN = $558228835489ffff$var$engineIsBun;
var $558228835489ffff$var$USER_AGENT = $558228835489ffff$var$engineUserAgent;
var $558228835489ffff$var$arraySlice$2 = $558228835489ffff$var$arraySlice$5;
var $558228835489ffff$var$validateArgumentsLength$1 = $558228835489ffff$var$validateArgumentsLength$2;
var $558228835489ffff$var$Function$2 = $558228835489ffff$var$global$9.Function;
// dirty IE9- and Bun 0.3.0- checks
var $558228835489ffff$var$WRAP = /MSIE .\./.test($558228835489ffff$var$USER_AGENT) || $558228835489ffff$var$ENGINE_IS_BUN && function() {
    var version = $558228835489ffff$var$global$9.Bun.version.split('.');
    return version.length < 3 || version[0] === '0' && (version[1] < 3 || version[1] === '3' && version[2] === '0');
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
var $558228835489ffff$var$schedulersFix$2 = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $558228835489ffff$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $558228835489ffff$var$validateArgumentsLength$1(arguments.length, 1) > firstParamIndex;
        var fn = $558228835489ffff$var$isCallable$5(handler) ? handler : $558228835489ffff$var$Function$2(handler);
        var params = boundArgs ? $558228835489ffff$var$arraySlice$2(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $558228835489ffff$var$apply$2(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};
var $558228835489ffff$var$$$m = $558228835489ffff$var$_export;
var $558228835489ffff$var$global$8 = $558228835489ffff$var$global$p;
var $558228835489ffff$var$schedulersFix$1 = $558228835489ffff$var$schedulersFix$2;
var $558228835489ffff$var$setInterval = $558228835489ffff$var$schedulersFix$1($558228835489ffff$var$global$8.setInterval, true);
// Bun / IE9- setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
$558228835489ffff$var$$$m({
    global: true,
    bind: true,
    forced: $558228835489ffff$var$global$8.setInterval !== $558228835489ffff$var$setInterval
}, {
    setInterval: $558228835489ffff$var$setInterval
});
var $558228835489ffff$var$$$l = $558228835489ffff$var$_export;
var $558228835489ffff$var$global$7 = $558228835489ffff$var$global$p;
var $558228835489ffff$var$schedulersFix = $558228835489ffff$var$schedulersFix$2;
var $558228835489ffff$var$setTimeout$3 = $558228835489ffff$var$schedulersFix($558228835489ffff$var$global$7.setTimeout, true);
// Bun / IE9- setTimeout additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
$558228835489ffff$var$$$l({
    global: true,
    bind: true,
    forced: $558228835489ffff$var$global$7.setTimeout !== $558228835489ffff$var$setTimeout$3
}, {
    setTimeout: $558228835489ffff$var$setTimeout$3
});
var $558228835489ffff$var$path$9 = $558228835489ffff$var$path$o;
var $558228835489ffff$var$setTimeout$2 = $558228835489ffff$var$path$9.setTimeout;
var $558228835489ffff$var$setTimeout$1 = $558228835489ffff$var$setTimeout$2;
var $558228835489ffff$var$_setTimeout = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$setTimeout$1);
var $558228835489ffff$var$componentEmitter = {
    exports: {}
};
(function(module) {
    function Emitter(object) {
        if (object) return mixin(object);
        this._callbacks = new Map();
    }
    function mixin(object) {
        Object.assign(object, Emitter.prototype);
        object._callbacks = new Map();
        return object;
    }
    Emitter.prototype.on = function(event, listener) {
        const callbacks = this._callbacks.get(event) ?? [];
        callbacks.push(listener);
        this._callbacks.set(event, callbacks);
        return this;
    };
    Emitter.prototype.once = function(event, listener) {
        const on = (...arguments_)=>{
            this.off(event, on);
            listener.apply(this, arguments_);
        };
        on.fn = listener;
        this.on(event, on);
        return this;
    };
    Emitter.prototype.off = function(event, listener) {
        if (event === undefined && listener === undefined) {
            this._callbacks.clear();
            return this;
        }
        if (listener === undefined) {
            this._callbacks.delete(event);
            return this;
        }
        const callbacks = this._callbacks.get(event);
        if (callbacks) {
            for (const [index, callback] of callbacks.entries())if (callback === listener || callback.fn === listener) {
                callbacks.splice(index, 1);
                break;
            }
            if (callbacks.length === 0) this._callbacks.delete(event);
            else this._callbacks.set(event, callbacks);
        }
        return this;
    };
    Emitter.prototype.emit = function(event, ...arguments_) {
        const callbacks = this._callbacks.get(event);
        if (callbacks) {
            // Create a copy of the callbacks array to avoid issues if it's modified during iteration
            const callbacksCopy = [
                ...callbacks
            ];
            for (const callback of callbacksCopy)callback.apply(this, arguments_);
        }
        return this;
    };
    Emitter.prototype.listeners = function(event) {
        return this._callbacks.get(event) ?? [];
    };
    Emitter.prototype.listenerCount = function(event) {
        if (event) return this.listeners(event).length;
        let totalCount = 0;
        for (const callbacks of this._callbacks.values())totalCount += callbacks.length;
        return totalCount;
    };
    Emitter.prototype.hasListeners = function(event) {
        return this.listenerCount(event) > 0;
    };
    // Aliases
    Emitter.prototype.addEventListener = Emitter.prototype.on;
    Emitter.prototype.removeListener = Emitter.prototype.off;
    Emitter.prototype.removeEventListener = Emitter.prototype.off;
    Emitter.prototype.removeAllListeners = Emitter.prototype.off;
    module.exports = Emitter;
})($558228835489ffff$var$componentEmitter);
var $558228835489ffff$var$componentEmitterExports = $558228835489ffff$var$componentEmitter.exports;
var $558228835489ffff$var$Emitter = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$componentEmitterExports);
/*! Hammer.JS - v2.0.17-rc - 2019-12-16
 * http://naver.github.io/egjs
 *
 * Forked By Naver egjs
 * Copyright (c) hammerjs
 * Licensed under the MIT license */ function $558228835489ffff$var$_extends() {
    $558228835489ffff$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $558228835489ffff$var$_extends.apply(this, arguments);
}
function $558228835489ffff$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $558228835489ffff$var$_assertThisInitialized$1(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
/**
 * @private
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */ var $558228835489ffff$var$assign;
if (typeof Object.assign !== 'function') $558228835489ffff$var$assign = function assign(target) {
    if (target === undefined || target === null) throw new TypeError('Cannot convert undefined or null to object');
    var output = Object(target);
    for(var index = 1; index < arguments.length; index++){
        var source = arguments[index];
        if (source !== undefined && source !== null) {
            for(var nextKey in source)if (source.hasOwnProperty(nextKey)) output[nextKey] = source[nextKey];
        }
    }
    return output;
};
else $558228835489ffff$var$assign = Object.assign;
var $558228835489ffff$var$assign$1 = $558228835489ffff$var$assign;
var $558228835489ffff$var$VENDOR_PREFIXES = [
    '',
    'webkit',
    'Moz',
    'MS',
    'ms',
    'o'
];
var $558228835489ffff$var$TEST_ELEMENT = typeof document === "undefined" ? {
    style: {}
} : document.createElement('div');
var $558228835489ffff$var$TYPE_FUNCTION = 'function';
var $558228835489ffff$var$round = Math.round, $558228835489ffff$var$abs = Math.abs;
var $558228835489ffff$var$now = Date.now;
/**
 * @private
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */ function $558228835489ffff$var$prefixed(obj, property) {
    var prefix;
    var prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);
    var i = 0;
    while(i < $558228835489ffff$var$VENDOR_PREFIXES.length){
        prefix = $558228835489ffff$var$VENDOR_PREFIXES[i];
        prop = prefix ? prefix + camelProp : property;
        if (prop in obj) return prop;
        i++;
    }
    return undefined;
}
/* eslint-disable no-new-func, no-nested-ternary */ var $558228835489ffff$var$win;
if (typeof window === "undefined") // window is undefined in node.js
$558228835489ffff$var$win = {};
else $558228835489ffff$var$win = window;
var $558228835489ffff$var$PREFIXED_TOUCH_ACTION = $558228835489ffff$var$prefixed($558228835489ffff$var$TEST_ELEMENT.style, 'touchAction');
var $558228835489ffff$var$NATIVE_TOUCH_ACTION = $558228835489ffff$var$PREFIXED_TOUCH_ACTION !== undefined;
function $558228835489ffff$var$getTouchActionProps() {
    if (!$558228835489ffff$var$NATIVE_TOUCH_ACTION) return false;
    var touchMap = {};
    var cssSupports = $558228835489ffff$var$win.CSS && $558228835489ffff$var$win.CSS.supports;
    [
        'auto',
        'manipulation',
        'pan-y',
        'pan-x',
        'pan-x pan-y',
        'none'
    ].forEach(function(val) {
        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        return touchMap[val] = cssSupports ? $558228835489ffff$var$win.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}
var $558228835489ffff$var$TOUCH_ACTION_COMPUTE = 'compute';
var $558228835489ffff$var$TOUCH_ACTION_AUTO = 'auto';
var $558228835489ffff$var$TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var $558228835489ffff$var$TOUCH_ACTION_NONE = 'none';
var $558228835489ffff$var$TOUCH_ACTION_PAN_X = 'pan-x';
var $558228835489ffff$var$TOUCH_ACTION_PAN_Y = 'pan-y';
var $558228835489ffff$var$TOUCH_ACTION_MAP = $558228835489ffff$var$getTouchActionProps();
var $558228835489ffff$var$MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
var $558228835489ffff$var$SUPPORT_TOUCH = 'ontouchstart' in $558228835489ffff$var$win;
var $558228835489ffff$var$SUPPORT_POINTER_EVENTS = $558228835489ffff$var$prefixed($558228835489ffff$var$win, 'PointerEvent') !== undefined;
var $558228835489ffff$var$SUPPORT_ONLY_TOUCH = $558228835489ffff$var$SUPPORT_TOUCH && $558228835489ffff$var$MOBILE_REGEX.test(navigator.userAgent);
var $558228835489ffff$var$INPUT_TYPE_TOUCH = 'touch';
var $558228835489ffff$var$INPUT_TYPE_PEN = 'pen';
var $558228835489ffff$var$INPUT_TYPE_MOUSE = 'mouse';
var $558228835489ffff$var$INPUT_TYPE_KINECT = 'kinect';
var $558228835489ffff$var$COMPUTE_INTERVAL = 25;
var $558228835489ffff$var$INPUT_START = 1;
var $558228835489ffff$var$INPUT_MOVE = 2;
var $558228835489ffff$var$INPUT_END = 4;
var $558228835489ffff$var$INPUT_CANCEL = 8;
var $558228835489ffff$var$DIRECTION_NONE = 1;
var $558228835489ffff$var$DIRECTION_LEFT = 2;
var $558228835489ffff$var$DIRECTION_RIGHT = 4;
var $558228835489ffff$var$DIRECTION_UP = 8;
var $558228835489ffff$var$DIRECTION_DOWN = 16;
var $558228835489ffff$var$DIRECTION_HORIZONTAL = $558228835489ffff$var$DIRECTION_LEFT | $558228835489ffff$var$DIRECTION_RIGHT;
var $558228835489ffff$var$DIRECTION_VERTICAL = $558228835489ffff$var$DIRECTION_UP | $558228835489ffff$var$DIRECTION_DOWN;
var $558228835489ffff$var$DIRECTION_ALL = $558228835489ffff$var$DIRECTION_HORIZONTAL | $558228835489ffff$var$DIRECTION_VERTICAL;
var $558228835489ffff$var$PROPS_XY = [
    'x',
    'y'
];
var $558228835489ffff$var$PROPS_CLIENT_XY = [
    'clientX',
    'clientY'
];
/**
 * @private
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */ function $558228835489ffff$var$each(obj, iterator, context) {
    var i;
    if (!obj) return;
    if (obj.forEach) obj.forEach(iterator, context);
    else if (obj.length !== undefined) {
        i = 0;
        while(i < obj.length){
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else for(i in obj)obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
}
/**
 * @private
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */ function $558228835489ffff$var$boolOrFn(val, args) {
    if (typeof val === $558228835489ffff$var$TYPE_FUNCTION) return val.apply(args ? args[0] || undefined : undefined, args);
    return val;
}
/**
 * @private
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */ function $558228835489ffff$var$inStr(str, find) {
    return str.indexOf(find) > -1;
}
/**
 * @private
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */ function $558228835489ffff$var$cleanTouchActions(actions) {
    // none
    if ($558228835489ffff$var$inStr(actions, $558228835489ffff$var$TOUCH_ACTION_NONE)) return $558228835489ffff$var$TOUCH_ACTION_NONE;
    var hasPanX = $558228835489ffff$var$inStr(actions, $558228835489ffff$var$TOUCH_ACTION_PAN_X);
    var hasPanY = $558228835489ffff$var$inStr(actions, $558228835489ffff$var$TOUCH_ACTION_PAN_Y); // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) return $558228835489ffff$var$TOUCH_ACTION_NONE;
     // pan-x OR pan-y
    if (hasPanX || hasPanY) return hasPanX ? $558228835489ffff$var$TOUCH_ACTION_PAN_X : $558228835489ffff$var$TOUCH_ACTION_PAN_Y;
     // manipulation
    if ($558228835489ffff$var$inStr(actions, $558228835489ffff$var$TOUCH_ACTION_MANIPULATION)) return $558228835489ffff$var$TOUCH_ACTION_MANIPULATION;
    return $558228835489ffff$var$TOUCH_ACTION_AUTO;
}
/**
 * @private
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */ var $558228835489ffff$var$TouchAction = /*#__PURE__*/ function() {
    function TouchAction(manager, value) {
        this.manager = manager;
        this.set(value);
    }
    /**
   * @private
   * set the touchAction value on the element or enable the polyfill
   * @param {String} value
   */ var _proto = TouchAction.prototype;
    _proto.set = function set(value) {
        // find out the touch-action by the event handlers
        if (value === $558228835489ffff$var$TOUCH_ACTION_COMPUTE) value = this.compute();
        if ($558228835489ffff$var$NATIVE_TOUCH_ACTION && this.manager.element.style && $558228835489ffff$var$TOUCH_ACTION_MAP[value]) this.manager.element.style[$558228835489ffff$var$PREFIXED_TOUCH_ACTION] = value;
        this.actions = value.toLowerCase().trim();
    };
    /**
   * @private
   * just re-set the touchAction value
   */ _proto.update = function update() {
        this.set(this.manager.options.touchAction);
    };
    /**
   * @private
   * compute the value for the touchAction property based on the recognizer's settings
   * @returns {String} value
   */ _proto.compute = function compute() {
        var actions = [];
        $558228835489ffff$var$each(this.manager.recognizers, function(recognizer) {
            if ($558228835489ffff$var$boolOrFn(recognizer.options.enable, [
                recognizer
            ])) actions = actions.concat(recognizer.getTouchAction());
        });
        return $558228835489ffff$var$cleanTouchActions(actions.join(' '));
    };
    /**
   * @private
   * this method is called on each input cycle and provides the preventing of the browser behavior
   * @param {Object} input
   */ _proto.preventDefaults = function preventDefaults(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection; // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }
        var actions = this.actions;
        var hasNone = $558228835489ffff$var$inStr(actions, $558228835489ffff$var$TOUCH_ACTION_NONE) && !$558228835489ffff$var$TOUCH_ACTION_MAP[$558228835489ffff$var$TOUCH_ACTION_NONE];
        var hasPanY = $558228835489ffff$var$inStr(actions, $558228835489ffff$var$TOUCH_ACTION_PAN_Y) && !$558228835489ffff$var$TOUCH_ACTION_MAP[$558228835489ffff$var$TOUCH_ACTION_PAN_Y];
        var hasPanX = $558228835489ffff$var$inStr(actions, $558228835489ffff$var$TOUCH_ACTION_PAN_X) && !$558228835489ffff$var$TOUCH_ACTION_MAP[$558228835489ffff$var$TOUCH_ACTION_PAN_X];
        if (hasNone) {
            // do not prevent defaults if this is a tap gesture
            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;
            if (isTapPointer && isTapMovement && isTapTouchTime) return;
        }
        if (hasPanX && hasPanY) // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
        return;
        if (hasNone || hasPanY && direction & $558228835489ffff$var$DIRECTION_HORIZONTAL || hasPanX && direction & $558228835489ffff$var$DIRECTION_VERTICAL) return this.preventSrc(srcEvent);
    };
    /**
   * @private
   * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
   * @param {Object} srcEvent
   */ _proto.preventSrc = function preventSrc(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    };
    return TouchAction;
}();
/**
 * @private
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */ function $558228835489ffff$var$hasParent(node, parent) {
    while(node){
        if (node === parent) return true;
        node = node.parentNode;
    }
    return false;
}
/**
 * @private
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */ function $558228835489ffff$var$getCenter(pointers) {
    var pointersLength = pointers.length; // no need to loop when only one touch
    if (pointersLength === 1) return {
        x: $558228835489ffff$var$round(pointers[0].clientX),
        y: $558228835489ffff$var$round(pointers[0].clientY)
    };
    var x = 0;
    var y = 0;
    var i = 0;
    while(i < pointersLength){
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }
    return {
        x: $558228835489ffff$var$round(x / pointersLength),
        y: $558228835489ffff$var$round(y / pointersLength)
    };
}
/**
 * @private
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */ function $558228835489ffff$var$simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while(i < input.pointers.length){
        pointers[i] = {
            clientX: $558228835489ffff$var$round(input.pointers[i].clientX),
            clientY: $558228835489ffff$var$round(input.pointers[i].clientY)
        };
        i++;
    }
    return {
        timeStamp: $558228835489ffff$var$now(),
        pointers: pointers,
        center: $558228835489ffff$var$getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}
/**
 * @private
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */ function $558228835489ffff$var$getDistance(p1, p2, props) {
    if (!props) props = $558228835489ffff$var$PROPS_XY;
    var x = p2[props[0]] - p1[props[0]];
    var y = p2[props[1]] - p1[props[1]];
    return Math.sqrt(x * x + y * y);
}
/**
 * @private
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */ function $558228835489ffff$var$getAngle(p1, p2, props) {
    if (!props) props = $558228835489ffff$var$PROPS_XY;
    var x = p2[props[0]] - p1[props[0]];
    var y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}
/**
 * @private
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */ function $558228835489ffff$var$getDirection(x, y) {
    if (x === y) return $558228835489ffff$var$DIRECTION_NONE;
    if ($558228835489ffff$var$abs(x) >= $558228835489ffff$var$abs(y)) return x < 0 ? $558228835489ffff$var$DIRECTION_LEFT : $558228835489ffff$var$DIRECTION_RIGHT;
    return y < 0 ? $558228835489ffff$var$DIRECTION_UP : $558228835489ffff$var$DIRECTION_DOWN;
}
function $558228835489ffff$var$computeDeltaXY(session, input) {
    var center = input.center; // let { offsetDelta:offset = {}, prevDelta = {}, prevInput = {} } = session;
    // jscs throwing error on defalut destructured values and without defaults tests fail
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};
    if (input.eventType === $558228835489ffff$var$INPUT_START || prevInput.eventType === $558228835489ffff$var$INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };
        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }
    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}
/**
 * @private
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */ function $558228835489ffff$var$getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}
/**
 * @private
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */ function $558228835489ffff$var$getScale(start, end) {
    return $558228835489ffff$var$getDistance(end[0], end[1], $558228835489ffff$var$PROPS_CLIENT_XY) / $558228835489ffff$var$getDistance(start[0], start[1], $558228835489ffff$var$PROPS_CLIENT_XY);
}
/**
 * @private
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */ function $558228835489ffff$var$getRotation(start, end) {
    return $558228835489ffff$var$getAngle(end[1], end[0], $558228835489ffff$var$PROPS_CLIENT_XY) + $558228835489ffff$var$getAngle(start[1], start[0], $558228835489ffff$var$PROPS_CLIENT_XY);
}
/**
 * @private
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */ function $558228835489ffff$var$computeIntervalInputData(session, input) {
    var last = session.lastInterval || input;
    var deltaTime = input.timeStamp - last.timeStamp;
    var velocity;
    var velocityX;
    var velocityY;
    var direction;
    if (input.eventType !== $558228835489ffff$var$INPUT_CANCEL && (deltaTime > $558228835489ffff$var$COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;
        var v = $558228835489ffff$var$getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = $558228835489ffff$var$abs(v.x) > $558228835489ffff$var$abs(v.y) ? v.x : v.y;
        direction = $558228835489ffff$var$getDirection(deltaX, deltaY);
        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }
    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}
/**
* @private
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */ function $558228835489ffff$var$computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length; // store the first input to calculate the distance and direction
    if (!session.firstInput) session.firstInput = $558228835489ffff$var$simpleCloneInputData(input);
     // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) session.firstMultiple = $558228835489ffff$var$simpleCloneInputData(input);
    else if (pointersLength === 1) session.firstMultiple = false;
    var firstInput = session.firstInput, firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
    var center = input.center = $558228835489ffff$var$getCenter(pointers);
    input.timeStamp = $558228835489ffff$var$now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;
    input.angle = $558228835489ffff$var$getAngle(offsetCenter, center);
    input.distance = $558228835489ffff$var$getDistance(offsetCenter, center);
    $558228835489ffff$var$computeDeltaXY(session, input);
    input.offsetDirection = $558228835489ffff$var$getDirection(input.deltaX, input.deltaY);
    var overallVelocity = $558228835489ffff$var$getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = $558228835489ffff$var$abs(overallVelocity.x) > $558228835489ffff$var$abs(overallVelocity.y) ? overallVelocity.x : overallVelocity.y;
    input.scale = firstMultiple ? $558228835489ffff$var$getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? $558228835489ffff$var$getRotation(firstMultiple.pointers, pointers) : 0;
    input.maxPointers = !session.prevInput ? input.pointers.length : input.pointers.length > session.prevInput.maxPointers ? input.pointers.length : session.prevInput.maxPointers;
    $558228835489ffff$var$computeIntervalInputData(session, input); // find the correct target
    var target = manager.element;
    var srcEvent = input.srcEvent;
    var srcEventTarget;
    if (srcEvent.composedPath) srcEventTarget = srcEvent.composedPath()[0];
    else if (srcEvent.path) srcEventTarget = srcEvent.path[0];
    else srcEventTarget = srcEvent.target;
    if ($558228835489ffff$var$hasParent(srcEventTarget, target)) target = srcEventTarget;
    input.target = target;
}
/**
 * @private
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */ function $558228835489ffff$var$inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = eventType & $558228835489ffff$var$INPUT_START && pointersLen - changedPointersLen === 0;
    var isFinal = eventType & ($558228835489ffff$var$INPUT_END | $558228835489ffff$var$INPUT_CANCEL) && pointersLen - changedPointersLen === 0;
    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;
    if (isFirst) manager.session = {};
     // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType; // compute scale, rotation etc
    $558228835489ffff$var$computeInputData(manager, input); // emit secret event
    manager.emit('hammer.input', input);
    manager.recognize(input);
    manager.session.prevInput = input;
}
/**
 * @private
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */ function $558228835489ffff$var$splitStr(str) {
    return str.trim().split(/\s+/g);
}
/**
 * @private
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */ function $558228835489ffff$var$addEventListeners(target, types, handler) {
    $558228835489ffff$var$each($558228835489ffff$var$splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}
/**
 * @private
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */ function $558228835489ffff$var$removeEventListeners(target, types, handler) {
    $558228835489ffff$var$each($558228835489ffff$var$splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}
/**
 * @private
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */ function $558228835489ffff$var$getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return doc.defaultView || doc.parentWindow || window;
}
/**
 * @private
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */ var $558228835489ffff$var$Input = /*#__PURE__*/ function() {
    function Input(manager, callback) {
        var self1 = this;
        this.manager = manager;
        this.callback = callback;
        this.element = manager.element;
        this.target = manager.options.inputTarget; // smaller wrapper around the handler, for the scope and the enabled state of the manager,
        // so when disabled the input events are completely bypassed.
        this.domHandler = function(ev) {
            if ($558228835489ffff$var$boolOrFn(manager.options.enable, [
                manager
            ])) self1.handler(ev);
        };
        this.init();
    }
    /**
   * @private
   * should handle the inputEvent data and trigger the callback
   * @virtual
   */ var _proto = Input.prototype;
    _proto.handler = function handler() {};
    /**
   * @private
   * bind the events
   */ _proto.init = function init() {
        this.evEl && $558228835489ffff$var$addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && $558228835489ffff$var$addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && $558228835489ffff$var$addEventListeners($558228835489ffff$var$getWindowForElement(this.element), this.evWin, this.domHandler);
    };
    /**
   * @private
   * unbind the events
   */ _proto.destroy = function destroy() {
        this.evEl && $558228835489ffff$var$removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && $558228835489ffff$var$removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && $558228835489ffff$var$removeEventListeners($558228835489ffff$var$getWindowForElement(this.element), this.evWin, this.domHandler);
    };
    return Input;
}();
/**
 * @private
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */ function $558228835489ffff$var$inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) return src.indexOf(find);
    else {
        var i = 0;
        while(i < src.length){
            if (findByKey && src[i][findByKey] == find || !findByKey && src[i] === find) // do not use === here, test fails
            return i;
            i++;
        }
        return -1;
    }
}
var $558228835489ffff$var$POINTER_INPUT_MAP = {
    pointerdown: $558228835489ffff$var$INPUT_START,
    pointermove: $558228835489ffff$var$INPUT_MOVE,
    pointerup: $558228835489ffff$var$INPUT_END,
    pointercancel: $558228835489ffff$var$INPUT_CANCEL,
    pointerout: $558228835489ffff$var$INPUT_CANCEL
}; // in IE10 the pointer types is defined as an enum
var $558228835489ffff$var$IE10_POINTER_TYPE_ENUM = {
    2: $558228835489ffff$var$INPUT_TYPE_TOUCH,
    3: $558228835489ffff$var$INPUT_TYPE_PEN,
    4: $558228835489ffff$var$INPUT_TYPE_MOUSE,
    5: $558228835489ffff$var$INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};
var $558228835489ffff$var$POINTER_ELEMENT_EVENTS = 'pointerdown';
var $558228835489ffff$var$POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel'; // IE10 has prefixed support, and case-sensitive
if ($558228835489ffff$var$win.MSPointerEvent && !$558228835489ffff$var$win.PointerEvent) {
    $558228835489ffff$var$POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    $558228835489ffff$var$POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}
/**
 * @private
 * Pointer events input
 * @constructor
 * @extends Input
 */ var $558228835489ffff$var$PointerEventInput = /*#__PURE__*/ function(_Input) {
    $558228835489ffff$var$_inheritsLoose(PointerEventInput, _Input);
    function PointerEventInput() {
        var _this;
        var proto = PointerEventInput.prototype;
        proto.evEl = $558228835489ffff$var$POINTER_ELEMENT_EVENTS;
        proto.evWin = $558228835489ffff$var$POINTER_WINDOW_EVENTS;
        _this = _Input.apply(this, arguments) || this;
        _this.store = _this.manager.session.pointerEvents = [];
        return _this;
    }
    /**
   * @private
   * handle mouse events
   * @param {Object} ev
   */ var _proto = PointerEventInput.prototype;
    _proto.handler = function handler(ev) {
        var store = this.store;
        var removePointer = false;
        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = $558228835489ffff$var$POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = $558228835489ffff$var$IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
        var isTouch = pointerType === $558228835489ffff$var$INPUT_TYPE_TOUCH; // get index of the event in the store
        var storeIndex = $558228835489ffff$var$inArray(store, ev.pointerId, 'pointerId'); // start and mouse must be down
        if (eventType & $558228835489ffff$var$INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & ($558228835489ffff$var$INPUT_END | $558228835489ffff$var$INPUT_CANCEL)) removePointer = true;
         // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) return;
         // update the event in the store
        store[storeIndex] = ev;
        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [
                ev
            ],
            pointerType: pointerType,
            srcEvent: ev
        });
        if (removePointer) // remove from the store
        store.splice(storeIndex, 1);
    };
    return PointerEventInput;
}($558228835489ffff$var$Input);
/**
 * @private
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */ function $558228835489ffff$var$toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}
/**
 * @private
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */ function $558228835489ffff$var$uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;
    while(i < src.length){
        var val = key ? src[i][key] : src[i];
        if ($558228835489ffff$var$inArray(values, val) < 0) results.push(src[i]);
        values[i] = val;
        i++;
    }
    if (sort) {
        if (!key) results = results.sort();
        else results = results.sort(function(a, b) {
            return a[key] > b[key];
        });
    }
    return results;
}
var $558228835489ffff$var$TOUCH_INPUT_MAP = {
    touchstart: $558228835489ffff$var$INPUT_START,
    touchmove: $558228835489ffff$var$INPUT_MOVE,
    touchend: $558228835489ffff$var$INPUT_END,
    touchcancel: $558228835489ffff$var$INPUT_CANCEL
};
var $558228835489ffff$var$TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';
/**
 * @private
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */ var $558228835489ffff$var$TouchInput = /*#__PURE__*/ function(_Input) {
    $558228835489ffff$var$_inheritsLoose(TouchInput, _Input);
    function TouchInput() {
        var _this;
        TouchInput.prototype.evTarget = $558228835489ffff$var$TOUCH_TARGET_EVENTS;
        _this = _Input.apply(this, arguments) || this;
        _this.targetIds = {}; // this.evTarget = TOUCH_TARGET_EVENTS;
        return _this;
    }
    var _proto = TouchInput.prototype;
    _proto.handler = function handler(ev) {
        var type = $558228835489ffff$var$TOUCH_INPUT_MAP[ev.type];
        var touches = $558228835489ffff$var$getTouches.call(this, ev, type);
        if (!touches) return;
        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: $558228835489ffff$var$INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    };
    return TouchInput;
}($558228835489ffff$var$Input);
function $558228835489ffff$var$getTouches(ev, type) {
    var allTouches = $558228835489ffff$var$toArray(ev.touches);
    var targetIds = this.targetIds; // when there is only one touch, the process can be simplified
    if (type & ($558228835489ffff$var$INPUT_START | $558228835489ffff$var$INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [
            allTouches,
            allTouches
        ];
    }
    var i;
    var targetTouches;
    var changedTouches = $558228835489ffff$var$toArray(ev.changedTouches);
    var changedTargetTouches = [];
    var target = this.target; // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return $558228835489ffff$var$hasParent(touch.target, target);
    }); // collect touches
    if (type === $558228835489ffff$var$INPUT_START) {
        i = 0;
        while(i < targetTouches.length){
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    } // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while(i < changedTouches.length){
        if (targetIds[changedTouches[i].identifier]) changedTargetTouches.push(changedTouches[i]);
         // cleanup removed touches
        if (type & ($558228835489ffff$var$INPUT_END | $558228835489ffff$var$INPUT_CANCEL)) delete targetIds[changedTouches[i].identifier];
        i++;
    }
    if (!changedTargetTouches.length) return;
    return [
        $558228835489ffff$var$uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}
var $558228835489ffff$var$MOUSE_INPUT_MAP = {
    mousedown: $558228835489ffff$var$INPUT_START,
    mousemove: $558228835489ffff$var$INPUT_MOVE,
    mouseup: $558228835489ffff$var$INPUT_END
};
var $558228835489ffff$var$MOUSE_ELEMENT_EVENTS = 'mousedown';
var $558228835489ffff$var$MOUSE_WINDOW_EVENTS = 'mousemove mouseup';
/**
 * @private
 * Mouse events input
 * @constructor
 * @extends Input
 */ var $558228835489ffff$var$MouseInput = /*#__PURE__*/ function(_Input) {
    $558228835489ffff$var$_inheritsLoose(MouseInput, _Input);
    function MouseInput() {
        var _this;
        var proto = MouseInput.prototype;
        proto.evEl = $558228835489ffff$var$MOUSE_ELEMENT_EVENTS;
        proto.evWin = $558228835489ffff$var$MOUSE_WINDOW_EVENTS;
        _this = _Input.apply(this, arguments) || this;
        _this.pressed = false; // mousedown state
        return _this;
    }
    /**
   * @private
   * handle mouse events
   * @param {Object} ev
   */ var _proto = MouseInput.prototype;
    _proto.handler = function handler(ev) {
        var eventType = $558228835489ffff$var$MOUSE_INPUT_MAP[ev.type]; // on start we want to have the left mouse button down
        if (eventType & $558228835489ffff$var$INPUT_START && ev.button === 0) this.pressed = true;
        if (eventType & $558228835489ffff$var$INPUT_MOVE && ev.which !== 1) eventType = $558228835489ffff$var$INPUT_END;
         // mouse must be down
        if (!this.pressed) return;
        if (eventType & $558228835489ffff$var$INPUT_END) this.pressed = false;
        this.callback(this.manager, eventType, {
            pointers: [
                ev
            ],
            changedPointers: [
                ev
            ],
            pointerType: $558228835489ffff$var$INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    };
    return MouseInput;
}($558228835489ffff$var$Input);
/**
 * @private
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */ var $558228835489ffff$var$DEDUP_TIMEOUT = 2500;
var $558228835489ffff$var$DEDUP_DISTANCE = 25;
function $558228835489ffff$var$setLastTouch(eventData) {
    var _eventData$changedPoi = eventData.changedPointers, touch = _eventData$changedPoi[0];
    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {
            x: touch.clientX,
            y: touch.clientY
        };
        var lts = this.lastTouches;
        this.lastTouches.push(lastTouch);
        var removeLastTouch = function removeLastTouch() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) lts.splice(i, 1);
        };
        setTimeout(removeLastTouch, $558228835489ffff$var$DEDUP_TIMEOUT);
    }
}
function $558228835489ffff$var$recordTouches(eventType, eventData) {
    if (eventType & $558228835489ffff$var$INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        $558228835489ffff$var$setLastTouch.call(this, eventData);
    } else if (eventType & ($558228835489ffff$var$INPUT_END | $558228835489ffff$var$INPUT_CANCEL)) $558228835489ffff$var$setLastTouch.call(this, eventData);
}
function $558228835489ffff$var$isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX;
    var y = eventData.srcEvent.clientY;
    for(var i = 0; i < this.lastTouches.length; i++){
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x);
        var dy = Math.abs(y - t.y);
        if (dx <= $558228835489ffff$var$DEDUP_DISTANCE && dy <= $558228835489ffff$var$DEDUP_DISTANCE) return true;
    }
    return false;
}
var $558228835489ffff$var$TouchMouseInput = /*#__PURE__*/ function() {
    var TouchMouseInput = /*#__PURE__*/ function(_Input) {
        $558228835489ffff$var$_inheritsLoose(TouchMouseInput, _Input);
        function TouchMouseInput(_manager, callback) {
            var _this;
            _this = _Input.call(this, _manager, callback) || this;
            _this.handler = function(manager, inputEvent, inputData) {
                var isTouch = inputData.pointerType === $558228835489ffff$var$INPUT_TYPE_TOUCH;
                var isMouse = inputData.pointerType === $558228835489ffff$var$INPUT_TYPE_MOUSE;
                if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) return;
                 // when we're in a touch event, record touches to  de-dupe synthetic mouse event
                if (isTouch) $558228835489ffff$var$recordTouches.call($558228835489ffff$var$_assertThisInitialized$1($558228835489ffff$var$_assertThisInitialized$1(_this)), inputEvent, inputData);
                else if (isMouse && $558228835489ffff$var$isSyntheticEvent.call($558228835489ffff$var$_assertThisInitialized$1($558228835489ffff$var$_assertThisInitialized$1(_this)), inputData)) return;
                _this.callback(manager, inputEvent, inputData);
            };
            _this.touch = new $558228835489ffff$var$TouchInput(_this.manager, _this.handler);
            _this.mouse = new $558228835489ffff$var$MouseInput(_this.manager, _this.handler);
            _this.primaryTouch = null;
            _this.lastTouches = [];
            return _this;
        }
        /**
     * @private
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */ var _proto = TouchMouseInput.prototype;
        /**
     * @private
     * remove the event listeners
     */ _proto.destroy = function destroy() {
            this.touch.destroy();
            this.mouse.destroy();
        };
        return TouchMouseInput;
    }($558228835489ffff$var$Input);
    return TouchMouseInput;
}();
/**
 * @private
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */ function $558228835489ffff$var$createInputInstance(manager) {
    var Type; // let inputClass = manager.options.inputClass;
    var inputClass = manager.options.inputClass;
    if (inputClass) Type = inputClass;
    else if ($558228835489ffff$var$SUPPORT_POINTER_EVENTS) Type = $558228835489ffff$var$PointerEventInput;
    else if ($558228835489ffff$var$SUPPORT_ONLY_TOUCH) Type = $558228835489ffff$var$TouchInput;
    else if (!$558228835489ffff$var$SUPPORT_TOUCH) Type = $558228835489ffff$var$MouseInput;
    else Type = $558228835489ffff$var$TouchMouseInput;
    return new Type(manager, $558228835489ffff$var$inputHandler);
}
/**
 * @private
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */ function $558228835489ffff$var$invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        $558228835489ffff$var$each(arg, context[fn], context);
        return true;
    }
    return false;
}
var $558228835489ffff$var$STATE_POSSIBLE = 1;
var $558228835489ffff$var$STATE_BEGAN = 2;
var $558228835489ffff$var$STATE_CHANGED = 4;
var $558228835489ffff$var$STATE_ENDED = 8;
var $558228835489ffff$var$STATE_RECOGNIZED = $558228835489ffff$var$STATE_ENDED;
var $558228835489ffff$var$STATE_CANCELLED = 16;
var $558228835489ffff$var$STATE_FAILED = 32;
/**
 * @private
 * get a unique id
 * @returns {number} uniqueId
 */ var $558228835489ffff$var$_uniqueId = 1;
function $558228835489ffff$var$uniqueId() {
    return $558228835489ffff$var$_uniqueId++;
}
/**
 * @private
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */ function $558228835489ffff$var$getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) return manager.get(otherRecognizer);
    return otherRecognizer;
}
/**
 * @private
 * get a usable string, used as event postfix
 * @param {constant} state
 * @returns {String} state
 */ function $558228835489ffff$var$stateStr(state) {
    if (state & $558228835489ffff$var$STATE_CANCELLED) return 'cancel';
    else if (state & $558228835489ffff$var$STATE_ENDED) return 'end';
    else if (state & $558228835489ffff$var$STATE_CHANGED) return 'move';
    else if (state & $558228835489ffff$var$STATE_BEGAN) return 'start';
    return '';
}
/**
 * @private
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */ /**
 * @private
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */ var $558228835489ffff$var$Recognizer = /*#__PURE__*/ function() {
    function Recognizer(options) {
        if (options === void 0) options = {};
        this.options = $558228835489ffff$var$_extends({
            enable: true
        }, options);
        this.id = $558228835489ffff$var$uniqueId();
        this.manager = null; // default is enable true
        this.state = $558228835489ffff$var$STATE_POSSIBLE;
        this.simultaneous = {};
        this.requireFail = [];
    }
    /**
   * @private
   * set options
   * @param {Object} options
   * @return {Recognizer}
   */ var _proto = Recognizer.prototype;
    _proto.set = function set(options) {
        $558228835489ffff$var$assign$1(this.options, options); // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    };
    /**
   * @private
   * recognize simultaneous with an other recognizer.
   * @param {Recognizer} otherRecognizer
   * @returns {Recognizer} this
   */ _proto.recognizeWith = function recognizeWith(otherRecognizer) {
        if ($558228835489ffff$var$invokeArrayArg(otherRecognizer, 'recognizeWith', this)) return this;
        var simultaneous = this.simultaneous;
        otherRecognizer = $558228835489ffff$var$getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    };
    /**
   * @private
   * drop the simultaneous link. it doesnt remove the link on the other recognizer.
   * @param {Recognizer} otherRecognizer
   * @returns {Recognizer} this
   */ _proto.dropRecognizeWith = function dropRecognizeWith(otherRecognizer) {
        if ($558228835489ffff$var$invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) return this;
        otherRecognizer = $558228835489ffff$var$getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    };
    /**
   * @private
   * recognizer can only run when an other is failing
   * @param {Recognizer} otherRecognizer
   * @returns {Recognizer} this
   */ _proto.requireFailure = function requireFailure(otherRecognizer) {
        if ($558228835489ffff$var$invokeArrayArg(otherRecognizer, 'requireFailure', this)) return this;
        var requireFail = this.requireFail;
        otherRecognizer = $558228835489ffff$var$getRecognizerByNameIfManager(otherRecognizer, this);
        if ($558228835489ffff$var$inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    };
    /**
   * @private
   * drop the requireFailure link. it does not remove the link on the other recognizer.
   * @param {Recognizer} otherRecognizer
   * @returns {Recognizer} this
   */ _proto.dropRequireFailure = function dropRequireFailure(otherRecognizer) {
        if ($558228835489ffff$var$invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) return this;
        otherRecognizer = $558228835489ffff$var$getRecognizerByNameIfManager(otherRecognizer, this);
        var index = $558228835489ffff$var$inArray(this.requireFail, otherRecognizer);
        if (index > -1) this.requireFail.splice(index, 1);
        return this;
    };
    /**
   * @private
   * has require failures boolean
   * @returns {boolean}
   */ _proto.hasRequireFailures = function hasRequireFailures() {
        return this.requireFail.length > 0;
    };
    /**
   * @private
   * if the recognizer can recognize simultaneous with an other recognizer
   * @param {Recognizer} otherRecognizer
   * @returns {Boolean}
   */ _proto.canRecognizeWith = function canRecognizeWith(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    };
    /**
   * @private
   * You should use `tryEmit` instead of `emit` directly to check
   * that all the needed recognizers has failed before emitting.
   * @param {Object} input
   */ _proto.emit = function emit(input) {
        var self1 = this;
        var state = this.state;
        function emit(event) {
            self1.manager.emit(event, input);
        } // 'panstart' and 'panmove'
        if (state < $558228835489ffff$var$STATE_ENDED) emit(self1.options.event + $558228835489ffff$var$stateStr(state));
        emit(self1.options.event); // simple 'eventName' events
        if (input.additionalEvent) // additional event(panleft, panright, pinchin, pinchout...)
        emit(input.additionalEvent);
         // panend and pancancel
        if (state >= $558228835489ffff$var$STATE_ENDED) emit(self1.options.event + $558228835489ffff$var$stateStr(state));
    };
    /**
   * @private
   * Check that all the require failure recognizers has failed,
   * if true, it emits a gesture event,
   * otherwise, setup the state to FAILED.
   * @param {Object} input
   */ _proto.tryEmit = function tryEmit(input) {
        if (this.canEmit()) return this.emit(input);
         // it's failing anyway
        this.state = $558228835489ffff$var$STATE_FAILED;
    };
    /**
   * @private
   * can we emit?
   * @returns {boolean}
   */ _proto.canEmit = function canEmit() {
        var i = 0;
        while(i < this.requireFail.length){
            if (!(this.requireFail[i].state & ($558228835489ffff$var$STATE_FAILED | $558228835489ffff$var$STATE_POSSIBLE))) return false;
            i++;
        }
        return true;
    };
    /**
   * @private
   * update the recognizer
   * @param {Object} inputData
   */ _proto.recognize = function recognize(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = $558228835489ffff$var$assign$1({}, inputData); // is is enabled and allow recognizing?
        if (!$558228835489ffff$var$boolOrFn(this.options.enable, [
            this,
            inputDataClone
        ])) {
            this.reset();
            this.state = $558228835489ffff$var$STATE_FAILED;
            return;
        } // reset when we've reached the end
        if (this.state & ($558228835489ffff$var$STATE_RECOGNIZED | $558228835489ffff$var$STATE_CANCELLED | $558228835489ffff$var$STATE_FAILED)) this.state = $558228835489ffff$var$STATE_POSSIBLE;
        this.state = this.process(inputDataClone); // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & ($558228835489ffff$var$STATE_BEGAN | $558228835489ffff$var$STATE_CHANGED | $558228835489ffff$var$STATE_ENDED | $558228835489ffff$var$STATE_CANCELLED)) this.tryEmit(inputDataClone);
    };
    /**
   * @private
   * return the state of the recognizer
   * the actual recognizing happens in this method
   * @virtual
   * @param {Object} inputData
   * @returns {constant} STATE
   */ /* jshint ignore:start */ _proto.process = function process(inputData) {};
    /* jshint ignore:end */ /**
   * @private
   * return the preferred touch-action
   * @virtual
   * @returns {Array}
   */ _proto.getTouchAction = function getTouchAction() {};
    /**
   * @private
   * called when the gesture isn't allowed to recognize
   * like when another is being recognized or it is disabled
   * @virtual
   */ _proto.reset = function reset() {};
    return Recognizer;
}();
/**
 * @private
 * A tap is recognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */ var $558228835489ffff$var$TapRecognizer = /*#__PURE__*/ function(_Recognizer) {
    $558228835489ffff$var$_inheritsLoose(TapRecognizer, _Recognizer);
    function TapRecognizer(options) {
        var _this;
        if (options === void 0) options = {};
        _this = _Recognizer.call(this, $558228835489ffff$var$_extends({
            event: 'tap',
            pointers: 1,
            taps: 1,
            interval: 300,
            // max time between the multi-tap taps
            time: 250,
            // max time of the pointer to be down (like finger on the screen)
            threshold: 9,
            // a minimal movement is ok, but keep it low
            posThreshold: 10
        }, options)) || this; // previous time and center,
        // used for tap counting
        _this.pTime = false;
        _this.pCenter = false;
        _this._timer = null;
        _this._input = null;
        _this.count = 0;
        return _this;
    }
    var _proto = TapRecognizer.prototype;
    _proto.getTouchAction = function getTouchAction() {
        return [
            $558228835489ffff$var$TOUCH_ACTION_MANIPULATION
        ];
    };
    _proto.process = function process(input) {
        var _this2 = this;
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;
        this.reset();
        if (input.eventType & $558228835489ffff$var$INPUT_START && this.count === 0) return this.failTimeout();
         // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType !== $558228835489ffff$var$INPUT_END) return this.failTimeout();
            var validInterval = this.pTime ? input.timeStamp - this.pTime < options.interval : true;
            var validMultiTap = !this.pCenter || $558228835489ffff$var$getDistance(this.pCenter, input.center) < options.posThreshold;
            this.pTime = input.timeStamp;
            this.pCenter = input.center;
            if (!validMultiTap || !validInterval) this.count = 1;
            else this.count += 1;
            this._input = input; // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) return $558228835489ffff$var$STATE_RECOGNIZED;
                else {
                    this._timer = setTimeout(function() {
                        _this2.state = $558228835489ffff$var$STATE_RECOGNIZED;
                        _this2.tryEmit();
                    }, options.interval);
                    return $558228835489ffff$var$STATE_BEGAN;
                }
            }
        }
        return $558228835489ffff$var$STATE_FAILED;
    };
    _proto.failTimeout = function failTimeout() {
        var _this3 = this;
        this._timer = setTimeout(function() {
            _this3.state = $558228835489ffff$var$STATE_FAILED;
        }, this.options.interval);
        return $558228835489ffff$var$STATE_FAILED;
    };
    _proto.reset = function reset() {
        clearTimeout(this._timer);
    };
    _proto.emit = function emit() {
        if (this.state === $558228835489ffff$var$STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    };
    return TapRecognizer;
}($558228835489ffff$var$Recognizer);
/**
 * @private
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */ var $558228835489ffff$var$AttrRecognizer = /*#__PURE__*/ function(_Recognizer) {
    $558228835489ffff$var$_inheritsLoose(AttrRecognizer, _Recognizer);
    function AttrRecognizer(options) {
        if (options === void 0) options = {};
        return _Recognizer.call(this, $558228835489ffff$var$_extends({
            pointers: 1
        }, options)) || this;
    }
    /**
   * @private
   * Used to check if it the recognizer receives valid input, like input.distance > 10.
   * @memberof AttrRecognizer
   * @param {Object} input
   * @returns {Boolean} recognized
   */ var _proto = AttrRecognizer.prototype;
    _proto.attrTest = function attrTest(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    };
    /**
   * @private
   * Process the input and return the state for the recognizer
   * @memberof AttrRecognizer
   * @param {Object} input
   * @returns {*} State
   */ _proto.process = function process(input) {
        var state = this.state;
        var eventType = input.eventType;
        var isRecognized = state & ($558228835489ffff$var$STATE_BEGAN | $558228835489ffff$var$STATE_CHANGED);
        var isValid = this.attrTest(input); // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & $558228835489ffff$var$INPUT_CANCEL || !isValid)) return state | $558228835489ffff$var$STATE_CANCELLED;
        else if (isRecognized || isValid) {
            if (eventType & $558228835489ffff$var$INPUT_END) return state | $558228835489ffff$var$STATE_ENDED;
            else if (!(state & $558228835489ffff$var$STATE_BEGAN)) return $558228835489ffff$var$STATE_BEGAN;
            return state | $558228835489ffff$var$STATE_CHANGED;
        }
        return $558228835489ffff$var$STATE_FAILED;
    };
    return AttrRecognizer;
}($558228835489ffff$var$Recognizer);
/**
 * @private
 * direction cons to string
 * @param {constant} direction
 * @returns {String}
 */ function $558228835489ffff$var$directionStr(direction) {
    if (direction === $558228835489ffff$var$DIRECTION_DOWN) return 'down';
    else if (direction === $558228835489ffff$var$DIRECTION_UP) return 'up';
    else if (direction === $558228835489ffff$var$DIRECTION_LEFT) return 'left';
    else if (direction === $558228835489ffff$var$DIRECTION_RIGHT) return 'right';
    return '';
}
/**
 * @private
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */ var $558228835489ffff$var$PanRecognizer = /*#__PURE__*/ function(_AttrRecognizer) {
    $558228835489ffff$var$_inheritsLoose(PanRecognizer, _AttrRecognizer);
    function PanRecognizer(options) {
        var _this;
        if (options === void 0) options = {};
        _this = _AttrRecognizer.call(this, $558228835489ffff$var$_extends({
            event: 'pan',
            threshold: 10,
            pointers: 1,
            direction: $558228835489ffff$var$DIRECTION_ALL
        }, options)) || this;
        _this.pX = null;
        _this.pY = null;
        return _this;
    }
    var _proto = PanRecognizer.prototype;
    _proto.getTouchAction = function getTouchAction() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & $558228835489ffff$var$DIRECTION_HORIZONTAL) actions.push($558228835489ffff$var$TOUCH_ACTION_PAN_Y);
        if (direction & $558228835489ffff$var$DIRECTION_VERTICAL) actions.push($558228835489ffff$var$TOUCH_ACTION_PAN_X);
        return actions;
    };
    _proto.directionTest = function directionTest(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY; // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & $558228835489ffff$var$DIRECTION_HORIZONTAL) {
                direction = x === 0 ? $558228835489ffff$var$DIRECTION_NONE : x < 0 ? $558228835489ffff$var$DIRECTION_LEFT : $558228835489ffff$var$DIRECTION_RIGHT;
                hasMoved = x !== this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = y === 0 ? $558228835489ffff$var$DIRECTION_NONE : y < 0 ? $558228835489ffff$var$DIRECTION_UP : $558228835489ffff$var$DIRECTION_DOWN;
                hasMoved = y !== this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    };
    _proto.attrTest = function attrTest(input) {
        return $558228835489ffff$var$AttrRecognizer.prototype.attrTest.call(this, input) && (this.state & $558228835489ffff$var$STATE_BEGAN || !(this.state & $558228835489ffff$var$STATE_BEGAN) && this.directionTest(input));
    };
    _proto.emit = function emit(input) {
        this.pX = input.deltaX;
        this.pY = input.deltaY;
        var direction = $558228835489ffff$var$directionStr(input.direction);
        if (direction) input.additionalEvent = this.options.event + direction;
        _AttrRecognizer.prototype.emit.call(this, input);
    };
    return PanRecognizer;
}($558228835489ffff$var$AttrRecognizer);
/**
 * @private
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */ var $558228835489ffff$var$SwipeRecognizer = /*#__PURE__*/ function(_AttrRecognizer) {
    $558228835489ffff$var$_inheritsLoose(SwipeRecognizer, _AttrRecognizer);
    function SwipeRecognizer(options) {
        if (options === void 0) options = {};
        return _AttrRecognizer.call(this, $558228835489ffff$var$_extends({
            event: 'swipe',
            threshold: 10,
            velocity: 0.3,
            direction: $558228835489ffff$var$DIRECTION_HORIZONTAL | $558228835489ffff$var$DIRECTION_VERTICAL,
            pointers: 1
        }, options)) || this;
    }
    var _proto = SwipeRecognizer.prototype;
    _proto.getTouchAction = function getTouchAction() {
        return $558228835489ffff$var$PanRecognizer.prototype.getTouchAction.call(this);
    };
    _proto.attrTest = function attrTest(input) {
        var direction = this.options.direction;
        var velocity;
        if (direction & ($558228835489ffff$var$DIRECTION_HORIZONTAL | $558228835489ffff$var$DIRECTION_VERTICAL)) velocity = input.overallVelocity;
        else if (direction & $558228835489ffff$var$DIRECTION_HORIZONTAL) velocity = input.overallVelocityX;
        else if (direction & $558228835489ffff$var$DIRECTION_VERTICAL) velocity = input.overallVelocityY;
        return _AttrRecognizer.prototype.attrTest.call(this, input) && direction & input.offsetDirection && input.distance > this.options.threshold && input.maxPointers === this.options.pointers && $558228835489ffff$var$abs(velocity) > this.options.velocity && input.eventType & $558228835489ffff$var$INPUT_END;
    };
    _proto.emit = function emit(input) {
        var direction = $558228835489ffff$var$directionStr(input.offsetDirection);
        if (direction) this.manager.emit(this.options.event + direction, input);
        this.manager.emit(this.options.event, input);
    };
    return SwipeRecognizer;
}($558228835489ffff$var$AttrRecognizer);
/**
 * @private
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */ var $558228835489ffff$var$PinchRecognizer = /*#__PURE__*/ function(_AttrRecognizer) {
    $558228835489ffff$var$_inheritsLoose(PinchRecognizer, _AttrRecognizer);
    function PinchRecognizer(options) {
        if (options === void 0) options = {};
        return _AttrRecognizer.call(this, $558228835489ffff$var$_extends({
            event: 'pinch',
            threshold: 0,
            pointers: 2
        }, options)) || this;
    }
    var _proto = PinchRecognizer.prototype;
    _proto.getTouchAction = function getTouchAction() {
        return [
            $558228835489ffff$var$TOUCH_ACTION_NONE
        ];
    };
    _proto.attrTest = function attrTest(input) {
        return _AttrRecognizer.prototype.attrTest.call(this, input) && (Math.abs(input.scale - 1) > this.options.threshold || this.state & $558228835489ffff$var$STATE_BEGAN);
    };
    _proto.emit = function emit(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        _AttrRecognizer.prototype.emit.call(this, input);
    };
    return PinchRecognizer;
}($558228835489ffff$var$AttrRecognizer);
/**
 * @private
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */ var $558228835489ffff$var$RotateRecognizer = /*#__PURE__*/ function(_AttrRecognizer) {
    $558228835489ffff$var$_inheritsLoose(RotateRecognizer, _AttrRecognizer);
    function RotateRecognizer(options) {
        if (options === void 0) options = {};
        return _AttrRecognizer.call(this, $558228835489ffff$var$_extends({
            event: 'rotate',
            threshold: 0,
            pointers: 2
        }, options)) || this;
    }
    var _proto = RotateRecognizer.prototype;
    _proto.getTouchAction = function getTouchAction() {
        return [
            $558228835489ffff$var$TOUCH_ACTION_NONE
        ];
    };
    _proto.attrTest = function attrTest(input) {
        return _AttrRecognizer.prototype.attrTest.call(this, input) && (Math.abs(input.rotation) > this.options.threshold || this.state & $558228835489ffff$var$STATE_BEGAN);
    };
    return RotateRecognizer;
}($558228835489ffff$var$AttrRecognizer);
/**
 * @private
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */ var $558228835489ffff$var$PressRecognizer = /*#__PURE__*/ function(_Recognizer) {
    $558228835489ffff$var$_inheritsLoose(PressRecognizer, _Recognizer);
    function PressRecognizer(options) {
        var _this;
        if (options === void 0) options = {};
        _this = _Recognizer.call(this, $558228835489ffff$var$_extends({
            event: 'press',
            pointers: 1,
            time: 251,
            // minimal time of the pointer to be pressed
            threshold: 9
        }, options)) || this;
        _this._timer = null;
        _this._input = null;
        return _this;
    }
    var _proto = PressRecognizer.prototype;
    _proto.getTouchAction = function getTouchAction() {
        return [
            $558228835489ffff$var$TOUCH_ACTION_AUTO
        ];
    };
    _proto.process = function process(input) {
        var _this2 = this;
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;
        this._input = input; // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || input.eventType & ($558228835489ffff$var$INPUT_END | $558228835489ffff$var$INPUT_CANCEL) && !validTime) this.reset();
        else if (input.eventType & $558228835489ffff$var$INPUT_START) {
            this.reset();
            this._timer = setTimeout(function() {
                _this2.state = $558228835489ffff$var$STATE_RECOGNIZED;
                _this2.tryEmit();
            }, options.time);
        } else if (input.eventType & $558228835489ffff$var$INPUT_END) return $558228835489ffff$var$STATE_RECOGNIZED;
        return $558228835489ffff$var$STATE_FAILED;
    };
    _proto.reset = function reset() {
        clearTimeout(this._timer);
    };
    _proto.emit = function emit(input) {
        if (this.state !== $558228835489ffff$var$STATE_RECOGNIZED) return;
        if (input && input.eventType & $558228835489ffff$var$INPUT_END) this.manager.emit(this.options.event + "up", input);
        else {
            this._input.timeStamp = $558228835489ffff$var$now();
            this.manager.emit(this.options.event, this._input);
        }
    };
    return PressRecognizer;
}($558228835489ffff$var$Recognizer);
var $558228835489ffff$var$defaults = {
    /**
   * @private
   * set if DOM events are being triggered.
   * But this is slower and unused by simple implementations, so disabled by default.
   * @type {Boolean}
   * @default false
   */ domEvents: false,
    /**
   * @private
   * The value for the touchAction property/fallback.
   * When set to `compute` it will magically set the correct value based on the added recognizers.
   * @type {String}
   * @default compute
   */ touchAction: $558228835489ffff$var$TOUCH_ACTION_COMPUTE,
    /**
   * @private
   * @type {Boolean}
   * @default true
   */ enable: true,
    /**
   * @private
   * EXPERIMENTAL FEATURE -- can be removed/changed
   * Change the parent input target element.
   * If Null, then it is being set the to main element.
   * @type {Null|EventTarget}
   * @default null
   */ inputTarget: null,
    /**
   * @private
   * force an input class
   * @type {Null|Function}
   * @default null
   */ inputClass: null,
    /**
   * @private
   * Some CSS properties can be used to improve the working of Hammer.
   * Add them to this method and they will be set when creating a new Manager.
   * @namespace
   */ cssProps: {
        /**
     * @private
     * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
     * @type {String}
     * @default 'none'
     */ userSelect: "none",
        /**
     * @private
     * Disable the Windows Phone grippers when pressing an element.
     * @type {String}
     * @default 'none'
     */ touchSelect: "none",
        /**
     * @private
     * Disables the default callout shown when you touch and hold a touch target.
     * On iOS, when you touch and hold a touch target such as a link, Safari displays
     * a callout containing information about the link. This property allows you to disable that callout.
     * @type {String}
     * @default 'none'
     */ touchCallout: "none",
        /**
     * @private
     * Specifies whether zooming is enabled. Used by IE10>
     * @type {String}
     * @default 'none'
     */ contentZooming: "none",
        /**
     * @private
     * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
     * @type {String}
     * @default 'none'
     */ userDrag: "none",
        /**
     * @private
     * Overrides the highlight color shown when the user taps a link or a JavaScript
     * clickable element in iOS. This property obeys the alpha value, if specified.
     * @type {String}
     * @default 'rgba(0,0,0,0)'
     */ tapHighlightColor: "rgba(0,0,0,0)"
    }
};
/**
 * @private
 * Default recognizer setup when calling `Hammer()`
 * When creating a new Manager these will be skipped.
 * This is separated with other defaults because of tree-shaking.
 * @type {Array}
 */ var $558228835489ffff$var$preset = [
    [
        $558228835489ffff$var$RotateRecognizer,
        {
            enable: false
        }
    ],
    [
        $558228835489ffff$var$PinchRecognizer,
        {
            enable: false
        },
        [
            'rotate'
        ]
    ],
    [
        $558228835489ffff$var$SwipeRecognizer,
        {
            direction: $558228835489ffff$var$DIRECTION_HORIZONTAL
        }
    ],
    [
        $558228835489ffff$var$PanRecognizer,
        {
            direction: $558228835489ffff$var$DIRECTION_HORIZONTAL
        },
        [
            'swipe'
        ]
    ],
    [
        $558228835489ffff$var$TapRecognizer
    ],
    [
        $558228835489ffff$var$TapRecognizer,
        {
            event: 'doubletap',
            taps: 2
        },
        [
            'tap'
        ]
    ],
    [
        $558228835489ffff$var$PressRecognizer
    ]
];
var $558228835489ffff$var$STOP = 1;
var $558228835489ffff$var$FORCED_STOP = 2;
/**
 * @private
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */ function $558228835489ffff$var$toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) return;
    var prop;
    $558228835489ffff$var$each(manager.options.cssProps, function(value, name) {
        prop = $558228835489ffff$var$prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else element.style[prop] = manager.oldCssProps[prop] || "";
    });
    if (!add) manager.oldCssProps = {};
}
/**
 * @private
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */ function $558228835489ffff$var$triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent("Event");
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}
/**
* @private
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */ var $558228835489ffff$var$Manager = /*#__PURE__*/ function() {
    function Manager(element, options) {
        var _this = this;
        this.options = $558228835489ffff$var$assign$1({}, $558228835489ffff$var$defaults, options || {});
        this.options.inputTarget = this.options.inputTarget || element;
        this.handlers = {};
        this.session = {};
        this.recognizers = [];
        this.oldCssProps = {};
        this.element = element;
        this.input = $558228835489ffff$var$createInputInstance(this);
        this.touchAction = new $558228835489ffff$var$TouchAction(this, this.options.touchAction);
        $558228835489ffff$var$toggleCssProps(this, true);
        $558228835489ffff$var$each(this.options.recognizers, function(item) {
            var recognizer = _this.add(new item[0](item[1]));
            item[2] && recognizer.recognizeWith(item[2]);
            item[3] && recognizer.requireFailure(item[3]);
        }, this);
    }
    /**
   * @private
   * set options
   * @param {Object} options
   * @returns {Manager}
   */ var _proto = Manager.prototype;
    _proto.set = function set(options) {
        $558228835489ffff$var$assign$1(this.options, options); // Options that need a little more setup
        if (options.touchAction) this.touchAction.update();
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    };
    /**
   * @private
   * stop recognizing for this session.
   * This session will be discarded, when a new [input]start event is fired.
   * When forced, the recognizer cycle is stopped immediately.
   * @param {Boolean} [force]
   */ _proto.stop = function stop(force) {
        this.session.stopped = force ? $558228835489ffff$var$FORCED_STOP : $558228835489ffff$var$STOP;
    };
    /**
   * @private
   * run the recognizers!
   * called by the inputHandler function on every movement of the pointers (touches)
   * it walks through all the recognizers and tries to detect the gesture that is being made
   * @param {Object} inputData
   */ _proto.recognize = function recognize(inputData) {
        var session = this.session;
        if (session.stopped) return;
         // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);
        var recognizer;
        var recognizers = this.recognizers; // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer; // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || curRecognizer && curRecognizer.state & $558228835489ffff$var$STATE_RECOGNIZED) {
            session.curRecognizer = null;
            curRecognizer = null;
        }
        var i = 0;
        while(i < recognizers.length){
            recognizer = recognizers[i]; // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== $558228835489ffff$var$FORCED_STOP && (!curRecognizer || recognizer === curRecognizer || // 2
            recognizer.canRecognizeWith(curRecognizer))) // 3
            recognizer.recognize(inputData);
            else recognizer.reset();
             // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & ($558228835489ffff$var$STATE_BEGAN | $558228835489ffff$var$STATE_CHANGED | $558228835489ffff$var$STATE_ENDED)) {
                session.curRecognizer = recognizer;
                curRecognizer = recognizer;
            }
            i++;
        }
    };
    /**
   * @private
   * get a recognizer by its event name.
   * @param {Recognizer|String} recognizer
   * @returns {Recognizer|Null}
   */ _proto.get = function get(recognizer) {
        if (recognizer instanceof $558228835489ffff$var$Recognizer) return recognizer;
        var recognizers = this.recognizers;
        for(var i = 0; i < recognizers.length; i++){
            if (recognizers[i].options.event === recognizer) return recognizers[i];
        }
        return null;
    };
    /**
   * @private add a recognizer to the manager
   * existing recognizers with the same event name will be removed
   * @param {Recognizer} recognizer
   * @returns {Recognizer|Manager}
   */ _proto.add = function add(recognizer) {
        if ($558228835489ffff$var$invokeArrayArg(recognizer, "add", this)) return this;
         // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) this.remove(existing);
        this.recognizers.push(recognizer);
        recognizer.manager = this;
        this.touchAction.update();
        return recognizer;
    };
    /**
   * @private
   * remove a recognizer by name or instance
   * @param {Recognizer|String} recognizer
   * @returns {Manager}
   */ _proto.remove = function remove(recognizer) {
        if ($558228835489ffff$var$invokeArrayArg(recognizer, "remove", this)) return this;
        var targetRecognizer = this.get(recognizer); // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = $558228835489ffff$var$inArray(recognizers, targetRecognizer);
            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }
        return this;
    };
    /**
   * @private
   * bind event
   * @param {String} events
   * @param {Function} handler
   * @returns {EventEmitter} this
   */ _proto.on = function on(events, handler) {
        if (events === undefined || handler === undefined) return this;
        var handlers = this.handlers;
        $558228835489ffff$var$each($558228835489ffff$var$splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    };
    /**
   * @private unbind event, leave emit blank to remove all handlers
   * @param {String} events
   * @param {Function} [handler]
   * @returns {EventEmitter} this
   */ _proto.off = function off(events, handler) {
        if (events === undefined) return this;
        var handlers = this.handlers;
        $558228835489ffff$var$each($558228835489ffff$var$splitStr(events), function(event) {
            if (!handler) delete handlers[event];
            else handlers[event] && handlers[event].splice($558228835489ffff$var$inArray(handlers[event], handler), 1);
        });
        return this;
    };
    /**
   * @private emit event to the listeners
   * @param {String} event
   * @param {Object} data
   */ _proto.emit = function emit(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) $558228835489ffff$var$triggerDomEvent(event, data);
         // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) return;
        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };
        var i = 0;
        while(i < handlers.length){
            handlers[i](data);
            i++;
        }
    };
    /**
   * @private
   * destroy the manager and unbinds all events
   * it doesn't unbind dom events, that is the user own responsibility
   */ _proto.destroy = function destroy() {
        this.element && $558228835489ffff$var$toggleCssProps(this, false);
        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    };
    return Manager;
}();
var $558228835489ffff$var$SINGLE_TOUCH_INPUT_MAP = {
    touchstart: $558228835489ffff$var$INPUT_START,
    touchmove: $558228835489ffff$var$INPUT_MOVE,
    touchend: $558228835489ffff$var$INPUT_END,
    touchcancel: $558228835489ffff$var$INPUT_CANCEL
};
var $558228835489ffff$var$SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var $558228835489ffff$var$SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';
/**
 * @private
 * Touch events input
 * @constructor
 * @extends Input
 */ var $558228835489ffff$var$SingleTouchInput = /*#__PURE__*/ function(_Input) {
    $558228835489ffff$var$_inheritsLoose(SingleTouchInput, _Input);
    function SingleTouchInput() {
        var _this;
        var proto = SingleTouchInput.prototype;
        proto.evTarget = $558228835489ffff$var$SINGLE_TOUCH_TARGET_EVENTS;
        proto.evWin = $558228835489ffff$var$SINGLE_TOUCH_WINDOW_EVENTS;
        _this = _Input.apply(this, arguments) || this;
        _this.started = false;
        return _this;
    }
    var _proto = SingleTouchInput.prototype;
    _proto.handler = function handler(ev) {
        var type = $558228835489ffff$var$SINGLE_TOUCH_INPUT_MAP[ev.type]; // should we handle the touch events?
        if (type === $558228835489ffff$var$INPUT_START) this.started = true;
        if (!this.started) return;
        var touches = $558228835489ffff$var$normalizeSingleTouches.call(this, ev, type); // when done, reset the started state
        if (type & ($558228835489ffff$var$INPUT_END | $558228835489ffff$var$INPUT_CANCEL) && touches[0].length - touches[1].length === 0) this.started = false;
        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: $558228835489ffff$var$INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    };
    return SingleTouchInput;
}($558228835489ffff$var$Input);
function $558228835489ffff$var$normalizeSingleTouches(ev, type) {
    var all = $558228835489ffff$var$toArray(ev.touches);
    var changed = $558228835489ffff$var$toArray(ev.changedTouches);
    if (type & ($558228835489ffff$var$INPUT_END | $558228835489ffff$var$INPUT_CANCEL)) all = $558228835489ffff$var$uniqueArray(all.concat(changed), 'identifier', true);
    return [
        all,
        changed
    ];
}
/**
 * @private
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */ function $558228835489ffff$var$deprecate(method, name, message) {
    var deprecationMessage = "DEPRECATED METHOD: " + name + "\n" + message + " AT \n";
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '').replace(/^\s+at\s+/gm, '').replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';
        var log = window.console && (window.console.warn || window.console.log);
        if (log) log.call(window.console, deprecationMessage, stack);
        return method.apply(this, arguments);
    };
}
/**
 * @private
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */ var $558228835489ffff$var$extend = $558228835489ffff$var$deprecate(function(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while(i < keys.length){
        if (!merge || merge && dest[keys[i]] === undefined) dest[keys[i]] = src[keys[i]];
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');
/**
 * @private
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */ var $558228835489ffff$var$merge$1 = $558228835489ffff$var$deprecate(function(dest, src) {
    return $558228835489ffff$var$extend(dest, src, true);
}, 'merge', 'Use `assign`.');
/**
 * @private
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */ function $558228835489ffff$var$inherit(child, base, properties) {
    var baseP = base.prototype;
    var childP;
    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;
    if (properties) $558228835489ffff$var$assign$1(childP, properties);
}
/**
 * @private
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */ function $558228835489ffff$var$bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}
/**
 * @private
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */ var $558228835489ffff$var$Hammer = /*#__PURE__*/ function() {
    var Hammer = /**
    * @private
    * @const {string}
    */ function Hammer(element, options) {
        if (options === void 0) options = {};
        return new $558228835489ffff$var$Manager(element, $558228835489ffff$var$_extends({
            recognizers: $558228835489ffff$var$preset.concat()
        }, options));
    };
    Hammer.VERSION = "2.0.17-rc";
    Hammer.DIRECTION_ALL = $558228835489ffff$var$DIRECTION_ALL;
    Hammer.DIRECTION_DOWN = $558228835489ffff$var$DIRECTION_DOWN;
    Hammer.DIRECTION_LEFT = $558228835489ffff$var$DIRECTION_LEFT;
    Hammer.DIRECTION_RIGHT = $558228835489ffff$var$DIRECTION_RIGHT;
    Hammer.DIRECTION_UP = $558228835489ffff$var$DIRECTION_UP;
    Hammer.DIRECTION_HORIZONTAL = $558228835489ffff$var$DIRECTION_HORIZONTAL;
    Hammer.DIRECTION_VERTICAL = $558228835489ffff$var$DIRECTION_VERTICAL;
    Hammer.DIRECTION_NONE = $558228835489ffff$var$DIRECTION_NONE;
    Hammer.DIRECTION_DOWN = $558228835489ffff$var$DIRECTION_DOWN;
    Hammer.INPUT_START = $558228835489ffff$var$INPUT_START;
    Hammer.INPUT_MOVE = $558228835489ffff$var$INPUT_MOVE;
    Hammer.INPUT_END = $558228835489ffff$var$INPUT_END;
    Hammer.INPUT_CANCEL = $558228835489ffff$var$INPUT_CANCEL;
    Hammer.STATE_POSSIBLE = $558228835489ffff$var$STATE_POSSIBLE;
    Hammer.STATE_BEGAN = $558228835489ffff$var$STATE_BEGAN;
    Hammer.STATE_CHANGED = $558228835489ffff$var$STATE_CHANGED;
    Hammer.STATE_ENDED = $558228835489ffff$var$STATE_ENDED;
    Hammer.STATE_RECOGNIZED = $558228835489ffff$var$STATE_RECOGNIZED;
    Hammer.STATE_CANCELLED = $558228835489ffff$var$STATE_CANCELLED;
    Hammer.STATE_FAILED = $558228835489ffff$var$STATE_FAILED;
    Hammer.Manager = $558228835489ffff$var$Manager;
    Hammer.Input = $558228835489ffff$var$Input;
    Hammer.TouchAction = $558228835489ffff$var$TouchAction;
    Hammer.TouchInput = $558228835489ffff$var$TouchInput;
    Hammer.MouseInput = $558228835489ffff$var$MouseInput;
    Hammer.PointerEventInput = $558228835489ffff$var$PointerEventInput;
    Hammer.TouchMouseInput = $558228835489ffff$var$TouchMouseInput;
    Hammer.SingleTouchInput = $558228835489ffff$var$SingleTouchInput;
    Hammer.Recognizer = $558228835489ffff$var$Recognizer;
    Hammer.AttrRecognizer = $558228835489ffff$var$AttrRecognizer;
    Hammer.Tap = $558228835489ffff$var$TapRecognizer;
    Hammer.Pan = $558228835489ffff$var$PanRecognizer;
    Hammer.Swipe = $558228835489ffff$var$SwipeRecognizer;
    Hammer.Pinch = $558228835489ffff$var$PinchRecognizer;
    Hammer.Rotate = $558228835489ffff$var$RotateRecognizer;
    Hammer.Press = $558228835489ffff$var$PressRecognizer;
    Hammer.on = $558228835489ffff$var$addEventListeners;
    Hammer.off = $558228835489ffff$var$removeEventListeners;
    Hammer.each = $558228835489ffff$var$each;
    Hammer.merge = $558228835489ffff$var$merge$1;
    Hammer.extend = $558228835489ffff$var$extend;
    Hammer.bindFn = $558228835489ffff$var$bindFn;
    Hammer.assign = $558228835489ffff$var$assign$1;
    Hammer.inherit = $558228835489ffff$var$inherit;
    Hammer.bindFn = $558228835489ffff$var$bindFn;
    Hammer.prefixed = $558228835489ffff$var$prefixed;
    Hammer.toArray = $558228835489ffff$var$toArray;
    Hammer.inArray = $558228835489ffff$var$inArray;
    Hammer.uniqueArray = $558228835489ffff$var$uniqueArray;
    Hammer.splitStr = $558228835489ffff$var$splitStr;
    Hammer.boolOrFn = $558228835489ffff$var$boolOrFn;
    Hammer.hasParent = $558228835489ffff$var$hasParent;
    Hammer.addEventListeners = $558228835489ffff$var$addEventListeners;
    Hammer.removeEventListeners = $558228835489ffff$var$removeEventListeners;
    Hammer.defaults = $558228835489ffff$var$assign$1({}, $558228835489ffff$var$defaults, {
        preset: $558228835489ffff$var$preset
    });
    return Hammer;
}();
var $558228835489ffff$var$RealHammer = $558228835489ffff$var$Hammer;
function $558228835489ffff$var$_createForOfIteratorHelper$3(o, allowArrayLike) {
    var it = typeof $558228835489ffff$var$_Symbol !== "undefined" && $558228835489ffff$var$_getIteratorMethod(o) || o["@@iterator"];
    if (!it) {
        if ($558228835489ffff$var$_Array$isArray(o) || (it = $558228835489ffff$var$_unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $558228835489ffff$var$_unsupportedIterableToArray$3(o, minLen) {
    var _context15;
    if (!o) return;
    if (typeof o === "string") return $558228835489ffff$var$_arrayLikeToArray$3(o, minLen);
    var n = $558228835489ffff$var$_sliceInstanceProperty(_context15 = Object.prototype.toString.call(o)).call(_context15, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return $558228835489ffff$var$_Array$from$1(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $558228835489ffff$var$_arrayLikeToArray$3(o, minLen);
}
function $558228835489ffff$var$_arrayLikeToArray$3(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * Use this symbol to delete properies in deepObjectAssign.
 */ var $558228835489ffff$export$4bd2facc4a3e6aa1 = $558228835489ffff$var$_Symbol("DELETE");
/**
 * Pure version of deepObjectAssign, it doesn't modify any of it's arguments.
 *
 * @param base - The base object that fullfils the whole interface T.
 * @param updates - Updates that may change or delete props.
 * @returns A brand new instance with all the supplied objects deeply merged.
 */ function $558228835489ffff$var$pureDeepObjectAssign(base) {
    var _context;
    for(var _len = arguments.length, updates = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)updates[_key - 1] = arguments[_key];
    return $558228835489ffff$var$deepObjectAssign.apply(void 0, $558228835489ffff$var$_concatInstanceProperty(_context = [
        {},
        base
    ]).call(_context, updates));
}
/**
 * Deep version of object assign with additional deleting by the DELETE symbol.
 *
 * @param values - Objects to be deeply merged.
 * @returns The first object from values.
 */ function $558228835489ffff$var$deepObjectAssign() {
    var merged = $558228835489ffff$var$deepObjectAssignNonentry.apply(void 0, arguments);
    $558228835489ffff$var$stripDelete(merged);
    return merged;
}
/**
 * Deep version of object assign with additional deleting by the DELETE symbol.
 *
 * @remarks
 * This doesn't strip the DELETE symbols so they may end up in the final object.
 * @param values - Objects to be deeply merged.
 * @returns The first object from values.
 */ function $558228835489ffff$var$deepObjectAssignNonentry() {
    for(var _len2 = arguments.length, values = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)values[_key2] = arguments[_key2];
    if (values.length < 2) return values[0];
    else if (values.length > 2) {
        var _context2;
        return $558228835489ffff$var$deepObjectAssignNonentry.apply(void 0, $558228835489ffff$var$_concatInstanceProperty(_context2 = [
            $558228835489ffff$var$deepObjectAssign(values[0], values[1])
        ]).call(_context2, $558228835489ffff$var$_toConsumableArray($558228835489ffff$var$_sliceInstanceProperty(values).call(values, 2))));
    }
    var a = values[0];
    var b = values[1];
    if (a instanceof Date && b instanceof Date) {
        a.setTime(b.getTime());
        return a;
    }
    var _iterator = $558228835489ffff$var$_createForOfIteratorHelper$3($558228835489ffff$var$_Reflect$ownKeys(b)), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var prop = _step.value;
            if (!Object.prototype.propertyIsEnumerable.call(b, prop)) ;
            else if (b[prop] === $558228835489ffff$export$4bd2facc4a3e6aa1) delete a[prop];
            else if (a[prop] !== null && b[prop] !== null && typeof a[prop] === "object" && typeof b[prop] === "object" && !$558228835489ffff$var$_Array$isArray(a[prop]) && !$558228835489ffff$var$_Array$isArray(b[prop])) a[prop] = $558228835489ffff$var$deepObjectAssignNonentry(a[prop], b[prop]);
            else a[prop] = $558228835489ffff$var$clone(b[prop]);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return a;
}
/**
 * Deep clone given object or array. In case of primitive simply return.
 *
 * @param a - Anything.
 * @returns Deep cloned object/array or unchanged a.
 */ function $558228835489ffff$var$clone(a) {
    if ($558228835489ffff$var$_Array$isArray(a)) return $558228835489ffff$var$_mapInstanceProperty(a).call(a, function(value) {
        return $558228835489ffff$var$clone(value);
    });
    else if (typeof a === "object" && a !== null) {
        if (a instanceof Date) return new Date(a.getTime());
        return $558228835489ffff$var$deepObjectAssignNonentry({}, a);
    } else return a;
}
/**
 * Strip DELETE from given object.
 *
 * @param a - Object which may contain DELETE but won't after this is executed.
 */ function $558228835489ffff$var$stripDelete(a) {
    for(var _i = 0, _Object$keys$1 = $558228835489ffff$var$_Object$keys(a); _i < _Object$keys$1.length; _i++){
        var prop = _Object$keys$1[_i];
        if (a[prop] === $558228835489ffff$export$4bd2facc4a3e6aa1) delete a[prop];
        else if (typeof a[prop] === "object" && a[prop] !== null) $558228835489ffff$var$stripDelete(a[prop]);
    }
}
/**
 * Setup a mock hammer.js object, for unit testing.
 *
 * Inspiration: https://github.com/uber/deck.gl/pull/658
 *
 * @returns {{on: noop, off: noop, destroy: noop, emit: noop, get: get}}
 */ function $558228835489ffff$var$hammerMock() {
    var noop = function noop() {};
    return {
        on: noop,
        off: noop,
        destroy: noop,
        emit: noop,
        get () {
            return {
                set: noop
            };
        }
    };
}
var $558228835489ffff$var$Hammer$1 = typeof window !== "undefined" ? window.Hammer || $558228835489ffff$var$RealHammer : function() {
    // hammer.js is only available in a browser, not in node.js. Replacing it with a mock object.
    return $558228835489ffff$var$hammerMock();
};
/**
 * Turn an element into an clickToUse element.
 * When not active, the element has a transparent overlay. When the overlay is
 * clicked, the mode is changed to active.
 * When active, the element is displayed with a blue border around it, and
 * the interactive contents of the element can be used. When clicked outside
 * the element, the elements mode is changed to inactive.
 *
 * @param {Element} container
 * @class Activator
 */ function $558228835489ffff$var$Activator$1(container) {
    var _this = this, _context3;
    this._cleanupQueue = [];
    this.active = false;
    this._dom = {
        container: container,
        overlay: document.createElement("div")
    };
    this._dom.overlay.classList.add("vis-overlay");
    this._dom.container.appendChild(this._dom.overlay);
    this._cleanupQueue.push(function() {
        _this._dom.overlay.parentNode.removeChild(_this._dom.overlay);
    });
    var hammer = $558228835489ffff$var$Hammer$1(this._dom.overlay);
    hammer.on("tap", $558228835489ffff$var$_bindInstanceProperty$1(_context3 = this._onTapOverlay).call(_context3, this));
    this._cleanupQueue.push(function() {
        hammer.destroy();
    // FIXME: cleaning up hammer instances doesn't work (Timeline not removed
    // from memory)
    });
    // block all touch events (except tap)
    var events = [
        "tap",
        "doubletap",
        "press",
        "pinch",
        "pan",
        "panstart",
        "panmove",
        "panend"
    ];
    $558228835489ffff$var$_forEachInstanceProperty(events).call(events, function(event) {
        hammer.on(event, function(event) {
            event.srcEvent.stopPropagation();
        });
    });
    // attach a click event to the window, in order to deactivate when clicking outside the timeline
    if (document && document.body) {
        this._onClick = function(event) {
            if (!$558228835489ffff$var$_hasParent(event.target, container)) _this.deactivate();
        };
        document.body.addEventListener("click", this._onClick);
        this._cleanupQueue.push(function() {
            document.body.removeEventListener("click", _this._onClick);
        });
    }
    // prepare escape key listener for deactivating when active
    this._escListener = function(event) {
        if ("key" in event ? event.key === "Escape" : event.keyCode === 27 /* the keyCode is for IE11 */ ) _this.deactivate();
    };
}
// turn into an event emitter
$558228835489ffff$var$Emitter($558228835489ffff$var$Activator$1.prototype);
// The currently active activator
$558228835489ffff$var$Activator$1.current = null;
/**
 * Destroy the activator. Cleans up all created DOM and event listeners
 */ $558228835489ffff$var$Activator$1.prototype.destroy = function() {
    var _context4, _context5;
    this.deactivate();
    var _iterator2 = $558228835489ffff$var$_createForOfIteratorHelper$3($558228835489ffff$var$_reverseInstanceProperty(_context4 = $558228835489ffff$var$_spliceInstanceProperty(_context5 = this._cleanupQueue).call(_context5, 0)).call(_context4)), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var callback = _step2.value;
            callback();
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
};
/**
 * Activate the element
 * Overlay is hidden, element is decorated with a blue shadow border
 */ $558228835489ffff$var$Activator$1.prototype.activate = function() {
    // we allow only one active activator at a time
    if ($558228835489ffff$var$Activator$1.current) $558228835489ffff$var$Activator$1.current.deactivate();
    $558228835489ffff$var$Activator$1.current = this;
    this.active = true;
    this._dom.overlay.style.display = "none";
    this._dom.container.classList.add("vis-active");
    this.emit("change");
    this.emit("activate");
    // ugly hack: bind ESC after emitting the events, as the Network rebinds all
    // keyboard events on a 'change' event
    document.body.addEventListener("keydown", this._escListener);
};
/**
 * Deactivate the element
 * Overlay is displayed on top of the element
 */ $558228835489ffff$var$Activator$1.prototype.deactivate = function() {
    this.active = false;
    this._dom.overlay.style.display = "block";
    this._dom.container.classList.remove("vis-active");
    document.body.removeEventListener("keydown", this._escListener);
    this.emit("change");
    this.emit("deactivate");
};
/**
 * Handle a tap event: activate the container
 *
 * @param {Event}  event   The event
 * @private
 */ $558228835489ffff$var$Activator$1.prototype._onTapOverlay = function(event) {
    // activate the container
    this.activate();
    event.srcEvent.stopPropagation();
};
/**
 * Test whether the element has the requested parent element somewhere in
 * its chain of parent nodes.
 *
 * @param {HTMLElement} element
 * @param {HTMLElement} parent
 * @returns {boolean} Returns true when the parent is found somewhere in the
 *                    chain of parent nodes.
 * @private
 */ function $558228835489ffff$var$_hasParent(element, parent) {
    while(element){
        if (element === parent) return true;
        element = element.parentNode;
    }
    return false;
}
var $558228835489ffff$var$isConstructor = $558228835489ffff$var$isConstructor$4;
var $558228835489ffff$var$tryToString$1 = $558228835489ffff$var$tryToString$6;
var $558228835489ffff$var$$TypeError$3 = TypeError;
// `Assert: IsConstructor(argument) is true`
var $558228835489ffff$var$aConstructor$2 = function(argument) {
    if ($558228835489ffff$var$isConstructor(argument)) return argument;
    throw new $558228835489ffff$var$$TypeError$3($558228835489ffff$var$tryToString$1(argument) + ' is not a constructor');
};
var $558228835489ffff$var$$$k = $558228835489ffff$var$_export;
var $558228835489ffff$var$getBuiltIn$4 = $558228835489ffff$var$getBuiltIn$f;
var $558228835489ffff$var$apply$1 = $558228835489ffff$var$functionApply;
var $558228835489ffff$var$bind$8 = $558228835489ffff$var$functionBind;
var $558228835489ffff$var$aConstructor$1 = $558228835489ffff$var$aConstructor$2;
var $558228835489ffff$var$anObject$3 = $558228835489ffff$var$anObject$d;
var $558228835489ffff$var$isObject$6 = $558228835489ffff$var$isObject$h;
var $558228835489ffff$var$create$5 = $558228835489ffff$var$objectCreate;
var $558228835489ffff$var$fails$9 = $558228835489ffff$var$fails$u;
var $558228835489ffff$var$nativeConstruct = $558228835489ffff$var$getBuiltIn$4('Reflect', 'construct');
var $558228835489ffff$var$ObjectPrototype = Object.prototype;
var $558228835489ffff$var$push$2 = [].push;
// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var $558228835489ffff$var$NEW_TARGET_BUG = $558228835489ffff$var$fails$9(function() {
    function F() {}
    return !($558228835489ffff$var$nativeConstruct(function() {}, [], F) instanceof F);
});
var $558228835489ffff$var$ARGS_BUG = !$558228835489ffff$var$fails$9(function() {
    $558228835489ffff$var$nativeConstruct(function() {});
});
var $558228835489ffff$var$FORCED$2 = $558228835489ffff$var$NEW_TARGET_BUG || $558228835489ffff$var$ARGS_BUG;
$558228835489ffff$var$$$k({
    target: 'Reflect',
    stat: true,
    forced: $558228835489ffff$var$FORCED$2,
    sham: $558228835489ffff$var$FORCED$2
}, {
    construct: function construct(Target, args /* , newTarget */ ) {
        $558228835489ffff$var$aConstructor$1(Target);
        $558228835489ffff$var$anObject$3(args);
        var newTarget = arguments.length < 3 ? Target : $558228835489ffff$var$aConstructor$1(arguments[2]);
        if ($558228835489ffff$var$ARGS_BUG && !$558228835489ffff$var$NEW_TARGET_BUG) return $558228835489ffff$var$nativeConstruct(Target, args, newTarget);
        if (Target === newTarget) {
            // w/o altered newTarget, optimization for 0-4 arguments
            switch(args.length){
                case 0:
                    return new Target();
                case 1:
                    return new Target(args[0]);
                case 2:
                    return new Target(args[0], args[1]);
                case 3:
                    return new Target(args[0], args[1], args[2]);
                case 4:
                    return new Target(args[0], args[1], args[2], args[3]);
            }
            // w/o altered newTarget, lot of arguments case
            var $args = [
                null
            ];
            $558228835489ffff$var$apply$1($558228835489ffff$var$push$2, $args, args);
            return new ($558228835489ffff$var$apply$1($558228835489ffff$var$bind$8, Target, $args))();
        }
        // with altered newTarget, not support built-in constructors
        var proto = newTarget.prototype;
        var instance = $558228835489ffff$var$create$5($558228835489ffff$var$isObject$6(proto) ? proto : $558228835489ffff$var$ObjectPrototype);
        var result = $558228835489ffff$var$apply$1(Target, instance, args);
        return $558228835489ffff$var$isObject$6(result) ? result : instance;
    }
});
var $558228835489ffff$var$path$8 = $558228835489ffff$var$path$o;
var $558228835489ffff$var$construct$2 = $558228835489ffff$var$path$8.Reflect.construct;
var $558228835489ffff$var$parent$u = $558228835489ffff$var$construct$2;
var $558228835489ffff$var$construct$1 = $558228835489ffff$var$parent$u;
var $558228835489ffff$var$construct = $558228835489ffff$var$construct$1;
var $558228835489ffff$var$_Reflect$construct = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$construct);
var $558228835489ffff$var$path$7 = $558228835489ffff$var$path$o;
var $558228835489ffff$var$getOwnPropertySymbols$2 = $558228835489ffff$var$path$7.Object.getOwnPropertySymbols;
var $558228835489ffff$var$parent$t = $558228835489ffff$var$getOwnPropertySymbols$2;
var $558228835489ffff$var$getOwnPropertySymbols$1 = $558228835489ffff$var$parent$t;
var $558228835489ffff$var$getOwnPropertySymbols = $558228835489ffff$var$getOwnPropertySymbols$1;
var $558228835489ffff$var$_Object$getOwnPropertySymbols = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$getOwnPropertySymbols);
var $558228835489ffff$var$getOwnPropertyDescriptor$4 = {
    exports: {}
};
var $558228835489ffff$var$$$j = $558228835489ffff$var$_export;
var $558228835489ffff$var$fails$8 = $558228835489ffff$var$fails$u;
var $558228835489ffff$var$toIndexedObject$1 = $558228835489ffff$var$toIndexedObject$a;
var $558228835489ffff$var$nativeGetOwnPropertyDescriptor = $558228835489ffff$var$objectGetOwnPropertyDescriptor.f;
var $558228835489ffff$var$DESCRIPTORS$5 = $558228835489ffff$var$descriptors;
var $558228835489ffff$var$FORCED$1 = !$558228835489ffff$var$DESCRIPTORS$5 || $558228835489ffff$var$fails$8(function() {
    $558228835489ffff$var$nativeGetOwnPropertyDescriptor(1);
});
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$558228835489ffff$var$$$j({
    target: 'Object',
    stat: true,
    forced: $558228835489ffff$var$FORCED$1,
    sham: !$558228835489ffff$var$DESCRIPTORS$5
}, {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
        return $558228835489ffff$var$nativeGetOwnPropertyDescriptor($558228835489ffff$var$toIndexedObject$1(it), key);
    }
});
var $558228835489ffff$var$path$6 = $558228835489ffff$var$path$o;
var $558228835489ffff$var$Object$2 = $558228835489ffff$var$path$6.Object;
var $558228835489ffff$var$getOwnPropertyDescriptor$3 = $558228835489ffff$var$getOwnPropertyDescriptor$4.exports = function getOwnPropertyDescriptor(it, key) {
    return $558228835489ffff$var$Object$2.getOwnPropertyDescriptor(it, key);
};
if ($558228835489ffff$var$Object$2.getOwnPropertyDescriptor.sham) $558228835489ffff$var$getOwnPropertyDescriptor$3.sham = true;
var $558228835489ffff$var$getOwnPropertyDescriptorExports = $558228835489ffff$var$getOwnPropertyDescriptor$4.exports;
var $558228835489ffff$var$parent$s = $558228835489ffff$var$getOwnPropertyDescriptorExports;
var $558228835489ffff$var$getOwnPropertyDescriptor$2 = $558228835489ffff$var$parent$s;
var $558228835489ffff$var$getOwnPropertyDescriptor$1 = $558228835489ffff$var$getOwnPropertyDescriptor$2;
var $558228835489ffff$var$_Object$getOwnPropertyDescriptor = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$getOwnPropertyDescriptor$1);
var $558228835489ffff$var$$$i = $558228835489ffff$var$_export;
var $558228835489ffff$var$DESCRIPTORS$4 = $558228835489ffff$var$descriptors;
var $558228835489ffff$var$ownKeys$2 = $558228835489ffff$var$ownKeys$7;
var $558228835489ffff$var$toIndexedObject = $558228835489ffff$var$toIndexedObject$a;
var $558228835489ffff$var$getOwnPropertyDescriptorModule$1 = $558228835489ffff$var$objectGetOwnPropertyDescriptor;
var $558228835489ffff$var$createProperty = $558228835489ffff$var$createProperty$6;
// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$558228835489ffff$var$$$i({
    target: 'Object',
    stat: true,
    sham: !$558228835489ffff$var$DESCRIPTORS$4
}, {
    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
        var O = $558228835489ffff$var$toIndexedObject(object);
        var getOwnPropertyDescriptor = $558228835489ffff$var$getOwnPropertyDescriptorModule$1.f;
        var keys = $558228835489ffff$var$ownKeys$2(O);
        var result = {};
        var index = 0;
        var key, descriptor;
        while(keys.length > index){
            descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
            if (descriptor !== undefined) $558228835489ffff$var$createProperty(result, key, descriptor);
        }
        return result;
    }
});
var $558228835489ffff$var$path$5 = $558228835489ffff$var$path$o;
var $558228835489ffff$var$getOwnPropertyDescriptors$2 = $558228835489ffff$var$path$5.Object.getOwnPropertyDescriptors;
var $558228835489ffff$var$parent$r = $558228835489ffff$var$getOwnPropertyDescriptors$2;
var $558228835489ffff$var$getOwnPropertyDescriptors$1 = $558228835489ffff$var$parent$r;
var $558228835489ffff$var$getOwnPropertyDescriptors = $558228835489ffff$var$getOwnPropertyDescriptors$1;
var $558228835489ffff$var$_Object$getOwnPropertyDescriptors = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$getOwnPropertyDescriptors);
var $558228835489ffff$var$defineProperties$4 = {
    exports: {}
};
var $558228835489ffff$var$$$h = $558228835489ffff$var$_export;
var $558228835489ffff$var$DESCRIPTORS$3 = $558228835489ffff$var$descriptors;
var $558228835489ffff$var$defineProperties$3 = $558228835489ffff$var$objectDefineProperties.f;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
$558228835489ffff$var$$$h({
    target: 'Object',
    stat: true,
    forced: Object.defineProperties !== $558228835489ffff$var$defineProperties$3,
    sham: !$558228835489ffff$var$DESCRIPTORS$3
}, {
    defineProperties: $558228835489ffff$var$defineProperties$3
});
var $558228835489ffff$var$path$4 = $558228835489ffff$var$path$o;
var $558228835489ffff$var$Object$1 = $558228835489ffff$var$path$4.Object;
var $558228835489ffff$var$defineProperties$2 = $558228835489ffff$var$defineProperties$4.exports = function defineProperties(T, D) {
    return $558228835489ffff$var$Object$1.defineProperties(T, D);
};
if ($558228835489ffff$var$Object$1.defineProperties.sham) $558228835489ffff$var$defineProperties$2.sham = true;
var $558228835489ffff$var$definePropertiesExports = $558228835489ffff$var$defineProperties$4.exports;
var $558228835489ffff$var$parent$q = $558228835489ffff$var$definePropertiesExports;
var $558228835489ffff$var$defineProperties$1 = $558228835489ffff$var$parent$q;
var $558228835489ffff$var$defineProperties = $558228835489ffff$var$defineProperties$1;
var $558228835489ffff$var$_Object$defineProperties = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$defineProperties);
var $558228835489ffff$var$defineProperty$2 = $558228835489ffff$var$defineProperty$b;
var $558228835489ffff$var$_Object$defineProperty = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$defineProperty$2);
function $558228835489ffff$var$_assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
var $558228835489ffff$var$parent$p = $558228835489ffff$var$create$7;
var $558228835489ffff$var$create$4 = $558228835489ffff$var$parent$p;
var $558228835489ffff$var$parent$o = $558228835489ffff$var$create$4;
var $558228835489ffff$var$create$3 = $558228835489ffff$var$parent$o;
var $558228835489ffff$var$create$2 = $558228835489ffff$var$create$3;
var $558228835489ffff$var$_Object$create = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$create$2);
var $558228835489ffff$var$$$g = $558228835489ffff$var$_export;
var $558228835489ffff$var$setPrototypeOf$6 = $558228835489ffff$var$objectSetPrototypeOf;
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$558228835489ffff$var$$$g({
    target: 'Object',
    stat: true
}, {
    setPrototypeOf: $558228835489ffff$var$setPrototypeOf$6
});
var $558228835489ffff$var$path$3 = $558228835489ffff$var$path$o;
var $558228835489ffff$var$setPrototypeOf$5 = $558228835489ffff$var$path$3.Object.setPrototypeOf;
var $558228835489ffff$var$parent$n = $558228835489ffff$var$setPrototypeOf$5;
var $558228835489ffff$var$setPrototypeOf$4 = $558228835489ffff$var$parent$n;
var $558228835489ffff$var$parent$m = $558228835489ffff$var$setPrototypeOf$4;
var $558228835489ffff$var$setPrototypeOf$3 = $558228835489ffff$var$parent$m;
var $558228835489ffff$var$parent$l = $558228835489ffff$var$setPrototypeOf$3;
var $558228835489ffff$var$setPrototypeOf$2 = $558228835489ffff$var$parent$l;
var $558228835489ffff$var$setPrototypeOf$1 = $558228835489ffff$var$setPrototypeOf$2;
var $558228835489ffff$var$_Object$setPrototypeOf = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$setPrototypeOf$1);
var $558228835489ffff$var$parent$k = $558228835489ffff$var$bind$c;
var $558228835489ffff$var$bind$7 = $558228835489ffff$var$parent$k;
var $558228835489ffff$var$parent$j = $558228835489ffff$var$bind$7;
var $558228835489ffff$var$bind$6 = $558228835489ffff$var$parent$j;
var $558228835489ffff$var$bind$5 = $558228835489ffff$var$bind$6;
var $558228835489ffff$var$_bindInstanceProperty = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$bind$5);
function $558228835489ffff$var$_setPrototypeOf(o, p) {
    var _context;
    $558228835489ffff$var$_setPrototypeOf = $558228835489ffff$var$_Object$setPrototypeOf ? $558228835489ffff$var$_bindInstanceProperty(_context = $558228835489ffff$var$_Object$setPrototypeOf).call(_context) : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $558228835489ffff$var$_setPrototypeOf(o, p);
}
function $558228835489ffff$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = $558228835489ffff$var$_Object$create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    $558228835489ffff$var$_Object$defineProperty$1(subClass, "prototype", {
        writable: false
    });
    if (superClass) $558228835489ffff$var$_setPrototypeOf(subClass, superClass);
}
function $558228835489ffff$var$_possibleConstructorReturn(self1, call) {
    if (call && ($558228835489ffff$var$_typeof$1(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $558228835489ffff$var$_assertThisInitialized(self1);
}
var $558228835489ffff$var$parent$i = $558228835489ffff$var$getPrototypeOf$4;
var $558228835489ffff$var$getPrototypeOf$3 = $558228835489ffff$var$parent$i;
var $558228835489ffff$var$parent$h = $558228835489ffff$var$getPrototypeOf$3;
var $558228835489ffff$var$getPrototypeOf$2 = $558228835489ffff$var$parent$h;
var $558228835489ffff$var$getPrototypeOf$1 = $558228835489ffff$var$getPrototypeOf$2;
var $558228835489ffff$var$_Object$getPrototypeOf = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$getPrototypeOf$1);
function $558228835489ffff$var$_getPrototypeOf(o) {
    var _context;
    $558228835489ffff$var$_getPrototypeOf = $558228835489ffff$var$_Object$setPrototypeOf ? $558228835489ffff$var$_bindInstanceProperty(_context = $558228835489ffff$var$_Object$getPrototypeOf).call(_context) : function _getPrototypeOf(o) {
        return o.__proto__ || $558228835489ffff$var$_Object$getPrototypeOf(o);
    };
    return $558228835489ffff$var$_getPrototypeOf(o);
}
var $558228835489ffff$var$regeneratorRuntime$1 = {
    exports: {}
};
var $558228835489ffff$var$_typeof = {
    exports: {}
};
(function(module) {
    var _Symbol = $558228835489ffff$var$symbol$1;
    var _Symbol$iterator = $558228835489ffff$var$iterator$1;
    function _typeof(o) {
        "@babel/helpers - typeof";
        return module.exports = _typeof = "function" == typeof _Symbol && "symbol" == typeof _Symbol$iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof _Symbol && o.constructor === _Symbol && o !== _Symbol.prototype ? "symbol" : typeof o;
        }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
    }
    module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
})($558228835489ffff$var$_typeof);
var $558228835489ffff$var$_typeofExports = $558228835489ffff$var$_typeof.exports;
var $558228835489ffff$var$parent$g = $558228835489ffff$var$forEach$5;
var $558228835489ffff$var$forEach$3 = $558228835489ffff$var$parent$g;
var $558228835489ffff$var$parent$f = $558228835489ffff$var$forEach$3;
var $558228835489ffff$var$forEach$2 = $558228835489ffff$var$parent$f;
var $558228835489ffff$var$forEach$1 = $558228835489ffff$var$forEach$2;
var $558228835489ffff$var$hasOwn$5 = $558228835489ffff$var$hasOwnProperty_1;
var $558228835489ffff$var$ownKeys$1 = $558228835489ffff$var$ownKeys$7;
var $558228835489ffff$var$getOwnPropertyDescriptorModule = $558228835489ffff$var$objectGetOwnPropertyDescriptor;
var $558228835489ffff$var$definePropertyModule = $558228835489ffff$var$objectDefineProperty;
var $558228835489ffff$var$copyConstructorProperties$1 = function(target, source, exceptions) {
    var keys = $558228835489ffff$var$ownKeys$1(source);
    var defineProperty = $558228835489ffff$var$definePropertyModule.f;
    var getOwnPropertyDescriptor = $558228835489ffff$var$getOwnPropertyDescriptorModule.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$558228835489ffff$var$hasOwn$5(target, key) && !(exceptions && $558228835489ffff$var$hasOwn$5(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};
var $558228835489ffff$var$isObject$5 = $558228835489ffff$var$isObject$h;
var $558228835489ffff$var$createNonEnumerableProperty$3 = $558228835489ffff$var$createNonEnumerableProperty$9;
// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
var $558228835489ffff$var$installErrorCause$1 = function(O, options) {
    if ($558228835489ffff$var$isObject$5(options) && 'cause' in options) $558228835489ffff$var$createNonEnumerableProperty$3(O, 'cause', options.cause);
};
var $558228835489ffff$var$uncurryThis$2 = $558228835489ffff$var$functionUncurryThis;
var $558228835489ffff$var$$Error$1 = Error;
var $558228835489ffff$var$replace = $558228835489ffff$var$uncurryThis$2(''.replace);
var $558228835489ffff$var$TEST = function(arg) {
    return String(new $558228835489ffff$var$$Error$1(arg).stack);
}('zxcasd');
// eslint-disable-next-line redos/no-vulnerable -- safe
var $558228835489ffff$var$V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var $558228835489ffff$var$IS_V8_OR_CHAKRA_STACK = $558228835489ffff$var$V8_OR_CHAKRA_STACK_ENTRY.test($558228835489ffff$var$TEST);
var $558228835489ffff$var$errorStackClear = function(stack, dropEntries) {
    if ($558228835489ffff$var$IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$558228835489ffff$var$$Error$1.prepareStackTrace) while(dropEntries--)stack = $558228835489ffff$var$replace(stack, $558228835489ffff$var$V8_OR_CHAKRA_STACK_ENTRY, '');
    return stack;
};
var $558228835489ffff$var$fails$7 = $558228835489ffff$var$fails$u;
var $558228835489ffff$var$createPropertyDescriptor$1 = $558228835489ffff$var$createPropertyDescriptor$7;
var $558228835489ffff$var$errorStackInstallable = !$558228835489ffff$var$fails$7(function() {
    var error = new Error('a');
    if (!('stack' in error)) return true;
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(error, 'stack', $558228835489ffff$var$createPropertyDescriptor$1(1, 7));
    return error.stack !== 7;
});
var $558228835489ffff$var$createNonEnumerableProperty$2 = $558228835489ffff$var$createNonEnumerableProperty$9;
var $558228835489ffff$var$clearErrorStack = $558228835489ffff$var$errorStackClear;
var $558228835489ffff$var$ERROR_STACK_INSTALLABLE = $558228835489ffff$var$errorStackInstallable;
// non-standard V8
var $558228835489ffff$var$captureStackTrace = Error.captureStackTrace;
var $558228835489ffff$var$errorStackInstall = function(error, C, stack, dropEntries) {
    if ($558228835489ffff$var$ERROR_STACK_INSTALLABLE) {
        if ($558228835489ffff$var$captureStackTrace) $558228835489ffff$var$captureStackTrace(error, C);
        else $558228835489ffff$var$createNonEnumerableProperty$2(error, 'stack', $558228835489ffff$var$clearErrorStack(stack, dropEntries));
    }
};
var $558228835489ffff$var$bind$4 = $558228835489ffff$var$functionBindContext;
var $558228835489ffff$var$call$6 = $558228835489ffff$var$functionCall;
var $558228835489ffff$var$anObject$2 = $558228835489ffff$var$anObject$d;
var $558228835489ffff$var$tryToString = $558228835489ffff$var$tryToString$6;
var $558228835489ffff$var$isArrayIteratorMethod = $558228835489ffff$var$isArrayIteratorMethod$2;
var $558228835489ffff$var$lengthOfArrayLike$1 = $558228835489ffff$var$lengthOfArrayLike$d;
var $558228835489ffff$var$isPrototypeOf$7 = $558228835489ffff$var$objectIsPrototypeOf;
var $558228835489ffff$var$getIterator$6 = $558228835489ffff$var$getIterator$8;
var $558228835489ffff$var$getIteratorMethod = $558228835489ffff$var$getIteratorMethod$9;
var $558228835489ffff$var$iteratorClose = $558228835489ffff$var$iteratorClose$2;
var $558228835489ffff$var$$TypeError$2 = TypeError;
var $558228835489ffff$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $558228835489ffff$var$ResultPrototype = $558228835489ffff$var$Result.prototype;
var $558228835489ffff$var$iterate$7 = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $558228835489ffff$var$bind$4(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $558228835489ffff$var$iteratorClose(iterator, 'normal', condition);
        return new $558228835489ffff$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $558228835489ffff$var$anObject$2(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $558228835489ffff$var$getIteratorMethod(iterable);
        if (!iterFn) throw new $558228835489ffff$var$$TypeError$2($558228835489ffff$var$tryToString(iterable) + ' is not iterable');
        // optimisation for array iterators
        if ($558228835489ffff$var$isArrayIteratorMethod(iterFn)) {
            for(index = 0, length = $558228835489ffff$var$lengthOfArrayLike$1(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $558228835489ffff$var$isPrototypeOf$7($558228835489ffff$var$ResultPrototype, result)) return result;
            }
            return new $558228835489ffff$var$Result(false);
        }
        iterator = $558228835489ffff$var$getIterator$6(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $558228835489ffff$var$call$6(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $558228835489ffff$var$iteratorClose(iterator, 'throw', error);
        }
        if (typeof result == 'object' && result && $558228835489ffff$var$isPrototypeOf$7($558228835489ffff$var$ResultPrototype, result)) return result;
    }
    return new $558228835489ffff$var$Result(false);
};
var $558228835489ffff$var$toString$1 = $558228835489ffff$var$toString$7;
var $558228835489ffff$var$normalizeStringArgument$1 = function(argument, $default) {
    return argument === undefined ? arguments.length < 2 ? '' : $default : $558228835489ffff$var$toString$1(argument);
};
var $558228835489ffff$var$$$f = $558228835489ffff$var$_export;
var $558228835489ffff$var$isPrototypeOf$6 = $558228835489ffff$var$objectIsPrototypeOf;
var $558228835489ffff$var$getPrototypeOf = $558228835489ffff$var$objectGetPrototypeOf;
var $558228835489ffff$var$setPrototypeOf = $558228835489ffff$var$objectSetPrototypeOf;
var $558228835489ffff$var$copyConstructorProperties = $558228835489ffff$var$copyConstructorProperties$1;
var $558228835489ffff$var$create$1 = $558228835489ffff$var$objectCreate;
var $558228835489ffff$var$createNonEnumerableProperty$1 = $558228835489ffff$var$createNonEnumerableProperty$9;
var $558228835489ffff$var$createPropertyDescriptor = $558228835489ffff$var$createPropertyDescriptor$7;
var $558228835489ffff$var$installErrorCause = $558228835489ffff$var$installErrorCause$1;
var $558228835489ffff$var$installErrorStack = $558228835489ffff$var$errorStackInstall;
var $558228835489ffff$var$iterate$6 = $558228835489ffff$var$iterate$7;
var $558228835489ffff$var$normalizeStringArgument = $558228835489ffff$var$normalizeStringArgument$1;
var $558228835489ffff$var$wellKnownSymbol$3 = $558228835489ffff$var$wellKnownSymbol$n;
var $558228835489ffff$var$TO_STRING_TAG = $558228835489ffff$var$wellKnownSymbol$3('toStringTag');
var $558228835489ffff$var$$Error = Error;
var $558228835489ffff$var$push$1 = [].push;
var $558228835489ffff$var$$AggregateError = function AggregateError(errors, message /* , options */ ) {
    var isInstance = $558228835489ffff$var$isPrototypeOf$6($558228835489ffff$var$AggregateErrorPrototype, this);
    var that;
    if ($558228835489ffff$var$setPrototypeOf) that = $558228835489ffff$var$setPrototypeOf(new $558228835489ffff$var$$Error(), isInstance ? $558228835489ffff$var$getPrototypeOf(this) : $558228835489ffff$var$AggregateErrorPrototype);
    else {
        that = isInstance ? this : $558228835489ffff$var$create$1($558228835489ffff$var$AggregateErrorPrototype);
        $558228835489ffff$var$createNonEnumerableProperty$1(that, $558228835489ffff$var$TO_STRING_TAG, 'Error');
    }
    if (message !== undefined) $558228835489ffff$var$createNonEnumerableProperty$1(that, 'message', $558228835489ffff$var$normalizeStringArgument(message));
    $558228835489ffff$var$installErrorStack(that, $558228835489ffff$var$$AggregateError, that.stack, 1);
    if (arguments.length > 2) $558228835489ffff$var$installErrorCause(that, arguments[2]);
    var errorsArray = [];
    $558228835489ffff$var$iterate$6(errors, $558228835489ffff$var$push$1, {
        that: errorsArray
    });
    $558228835489ffff$var$createNonEnumerableProperty$1(that, 'errors', errorsArray);
    return that;
};
if ($558228835489ffff$var$setPrototypeOf) $558228835489ffff$var$setPrototypeOf($558228835489ffff$var$$AggregateError, $558228835489ffff$var$$Error);
else $558228835489ffff$var$copyConstructorProperties($558228835489ffff$var$$AggregateError, $558228835489ffff$var$$Error, {
    name: true
});
var $558228835489ffff$var$AggregateErrorPrototype = $558228835489ffff$var$$AggregateError.prototype = $558228835489ffff$var$create$1($558228835489ffff$var$$Error.prototype, {
    constructor: $558228835489ffff$var$createPropertyDescriptor(1, $558228835489ffff$var$$AggregateError),
    message: $558228835489ffff$var$createPropertyDescriptor(1, ''),
    name: $558228835489ffff$var$createPropertyDescriptor(1, 'AggregateError')
});
// `AggregateError` constructor
// https://tc39.es/ecma262/#sec-aggregate-error-constructor
$558228835489ffff$var$$$f({
    global: true,
    constructor: true,
    arity: 2
}, {
    AggregateError: $558228835489ffff$var$$AggregateError
});
var $558228835489ffff$var$getBuiltIn$3 = $558228835489ffff$var$getBuiltIn$f;
var $558228835489ffff$var$defineBuiltInAccessor$1 = $558228835489ffff$var$defineBuiltInAccessor$3;
var $558228835489ffff$var$wellKnownSymbol$2 = $558228835489ffff$var$wellKnownSymbol$n;
var $558228835489ffff$var$DESCRIPTORS$2 = $558228835489ffff$var$descriptors;
var $558228835489ffff$var$SPECIES$2 = $558228835489ffff$var$wellKnownSymbol$2('species');
var $558228835489ffff$var$setSpecies$2 = function(CONSTRUCTOR_NAME) {
    var Constructor = $558228835489ffff$var$getBuiltIn$3(CONSTRUCTOR_NAME);
    if ($558228835489ffff$var$DESCRIPTORS$2 && Constructor && !Constructor[$558228835489ffff$var$SPECIES$2]) $558228835489ffff$var$defineBuiltInAccessor$1(Constructor, $558228835489ffff$var$SPECIES$2, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};
var $558228835489ffff$var$isPrototypeOf$5 = $558228835489ffff$var$objectIsPrototypeOf;
var $558228835489ffff$var$$TypeError$1 = TypeError;
var $558228835489ffff$var$anInstance$3 = function(it, Prototype) {
    if ($558228835489ffff$var$isPrototypeOf$5(Prototype, it)) return it;
    throw new $558228835489ffff$var$$TypeError$1('Incorrect invocation');
};
var $558228835489ffff$var$anObject$1 = $558228835489ffff$var$anObject$d;
var $558228835489ffff$var$aConstructor = $558228835489ffff$var$aConstructor$2;
var $558228835489ffff$var$isNullOrUndefined$2 = $558228835489ffff$var$isNullOrUndefined$6;
var $558228835489ffff$var$wellKnownSymbol$1 = $558228835489ffff$var$wellKnownSymbol$n;
var $558228835489ffff$var$SPECIES$1 = $558228835489ffff$var$wellKnownSymbol$1('species');
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var $558228835489ffff$var$speciesConstructor$2 = function(O, defaultConstructor) {
    var C = $558228835489ffff$var$anObject$1(O).constructor;
    var S;
    return C === undefined || $558228835489ffff$var$isNullOrUndefined$2(S = $558228835489ffff$var$anObject$1(C)[$558228835489ffff$var$SPECIES$1]) ? defaultConstructor : $558228835489ffff$var$aConstructor(S);
};
var $558228835489ffff$var$userAgent$4 = $558228835489ffff$var$engineUserAgent;
// eslint-disable-next-line redos/no-vulnerable -- safe
var $558228835489ffff$var$engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test($558228835489ffff$var$userAgent$4);
var $558228835489ffff$var$global$6 = $558228835489ffff$var$global$p;
var $558228835489ffff$var$apply = $558228835489ffff$var$functionApply;
var $558228835489ffff$var$bind$3 = $558228835489ffff$var$functionBindContext;
var $558228835489ffff$var$isCallable$4 = $558228835489ffff$var$isCallable$m;
var $558228835489ffff$var$hasOwn$4 = $558228835489ffff$var$hasOwnProperty_1;
var $558228835489ffff$var$fails$6 = $558228835489ffff$var$fails$u;
var $558228835489ffff$var$html = $558228835489ffff$var$html$2;
var $558228835489ffff$var$arraySlice$1 = $558228835489ffff$var$arraySlice$5;
var $558228835489ffff$var$createElement = $558228835489ffff$var$documentCreateElement$1;
var $558228835489ffff$var$validateArgumentsLength = $558228835489ffff$var$validateArgumentsLength$2;
var $558228835489ffff$var$IS_IOS$1 = $558228835489ffff$var$engineIsIos;
var $558228835489ffff$var$IS_NODE$3 = $558228835489ffff$var$engineIsNode;
var $558228835489ffff$var$set$3 = $558228835489ffff$var$global$6.setImmediate;
var $558228835489ffff$var$clear = $558228835489ffff$var$global$6.clearImmediate;
var $558228835489ffff$var$process$2 = $558228835489ffff$var$global$6.process;
var $558228835489ffff$var$Dispatch = $558228835489ffff$var$global$6.Dispatch;
var $558228835489ffff$var$Function$1 = $558228835489ffff$var$global$6.Function;
var $558228835489ffff$var$MessageChannel = $558228835489ffff$var$global$6.MessageChannel;
var $558228835489ffff$var$String$1 = $558228835489ffff$var$global$6.String;
var $558228835489ffff$var$counter = 0;
var $558228835489ffff$var$queue$2 = {};
var $558228835489ffff$var$ONREADYSTATECHANGE = 'onreadystatechange';
var $558228835489ffff$var$$location, $558228835489ffff$var$defer, $558228835489ffff$var$channel, $558228835489ffff$var$port;
$558228835489ffff$var$fails$6(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $558228835489ffff$var$$location = $558228835489ffff$var$global$6.location;
});
var $558228835489ffff$var$run = function(id) {
    if ($558228835489ffff$var$hasOwn$4($558228835489ffff$var$queue$2, id)) {
        var fn = $558228835489ffff$var$queue$2[id];
        delete $558228835489ffff$var$queue$2[id];
        fn();
    }
};
var $558228835489ffff$var$runner = function(id) {
    return function() {
        $558228835489ffff$var$run(id);
    };
};
var $558228835489ffff$var$eventListener = function(event) {
    $558228835489ffff$var$run(event.data);
};
var $558228835489ffff$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $558228835489ffff$var$global$6.postMessage($558228835489ffff$var$String$1(id), $558228835489ffff$var$$location.protocol + '//' + $558228835489ffff$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$558228835489ffff$var$set$3 || !$558228835489ffff$var$clear) {
    $558228835489ffff$var$set$3 = function setImmediate(handler) {
        $558228835489ffff$var$validateArgumentsLength(arguments.length, 1);
        var fn = $558228835489ffff$var$isCallable$4(handler) ? handler : $558228835489ffff$var$Function$1(handler);
        var args = $558228835489ffff$var$arraySlice$1(arguments, 1);
        $558228835489ffff$var$queue$2[++$558228835489ffff$var$counter] = function() {
            $558228835489ffff$var$apply(fn, undefined, args);
        };
        $558228835489ffff$var$defer($558228835489ffff$var$counter);
        return $558228835489ffff$var$counter;
    };
    $558228835489ffff$var$clear = function clearImmediate(id) {
        delete $558228835489ffff$var$queue$2[id];
    };
    // Node.js 0.8-
    if ($558228835489ffff$var$IS_NODE$3) $558228835489ffff$var$defer = function(id) {
        $558228835489ffff$var$process$2.nextTick($558228835489ffff$var$runner(id));
    };
    else if ($558228835489ffff$var$Dispatch && $558228835489ffff$var$Dispatch.now) $558228835489ffff$var$defer = function(id) {
        $558228835489ffff$var$Dispatch.now($558228835489ffff$var$runner(id));
    };
    else if ($558228835489ffff$var$MessageChannel && !$558228835489ffff$var$IS_IOS$1) {
        $558228835489ffff$var$channel = new $558228835489ffff$var$MessageChannel();
        $558228835489ffff$var$port = $558228835489ffff$var$channel.port2;
        $558228835489ffff$var$channel.port1.onmessage = $558228835489ffff$var$eventListener;
        $558228835489ffff$var$defer = $558228835489ffff$var$bind$3($558228835489ffff$var$port.postMessage, $558228835489ffff$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($558228835489ffff$var$global$6.addEventListener && $558228835489ffff$var$isCallable$4($558228835489ffff$var$global$6.postMessage) && !$558228835489ffff$var$global$6.importScripts && $558228835489ffff$var$$location && $558228835489ffff$var$$location.protocol !== 'file:' && !$558228835489ffff$var$fails$6($558228835489ffff$var$globalPostMessageDefer)) {
        $558228835489ffff$var$defer = $558228835489ffff$var$globalPostMessageDefer;
        $558228835489ffff$var$global$6.addEventListener('message', $558228835489ffff$var$eventListener, false);
    // IE8-
    } else if ($558228835489ffff$var$ONREADYSTATECHANGE in $558228835489ffff$var$createElement('script')) $558228835489ffff$var$defer = function(id) {
        $558228835489ffff$var$html.appendChild($558228835489ffff$var$createElement('script'))[$558228835489ffff$var$ONREADYSTATECHANGE] = function() {
            $558228835489ffff$var$html.removeChild(this);
            $558228835489ffff$var$run(id);
        };
    };
    else $558228835489ffff$var$defer = function(id) {
        setTimeout($558228835489ffff$var$runner(id), 0);
    };
}
var $558228835489ffff$var$task$1 = {
    set: $558228835489ffff$var$set$3,
    clear: $558228835489ffff$var$clear
};
var $558228835489ffff$var$Queue$3 = function() {
    this.head = null;
    this.tail = null;
};
$558228835489ffff$var$Queue$3.prototype = {
    add: function(item) {
        var entry = {
            item: item,
            next: null
        };
        var tail = this.tail;
        if (tail) tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function() {
        var entry = this.head;
        if (entry) {
            var next = this.head = entry.next;
            if (next === null) this.tail = null;
            return entry.item;
        }
    }
};
var $558228835489ffff$var$queue$1 = $558228835489ffff$var$Queue$3;
var $558228835489ffff$var$userAgent$3 = $558228835489ffff$var$engineUserAgent;
var $558228835489ffff$var$engineIsIosPebble = /ipad|iphone|ipod/i.test($558228835489ffff$var$userAgent$3) && typeof Pebble != 'undefined';
var $558228835489ffff$var$userAgent$2 = $558228835489ffff$var$engineUserAgent;
var $558228835489ffff$var$engineIsWebosWebkit = /web0s(?!.*chrome)/i.test($558228835489ffff$var$userAgent$2);
var $558228835489ffff$var$global$5 = $558228835489ffff$var$global$p;
var $558228835489ffff$var$bind$2 = $558228835489ffff$var$functionBindContext;
var $558228835489ffff$var$getOwnPropertyDescriptor = $558228835489ffff$var$objectGetOwnPropertyDescriptor.f;
var $558228835489ffff$var$macrotask = $558228835489ffff$var$task$1.set;
var $558228835489ffff$var$Queue$2 = $558228835489ffff$var$queue$1;
var $558228835489ffff$var$IS_IOS = $558228835489ffff$var$engineIsIos;
var $558228835489ffff$var$IS_IOS_PEBBLE = $558228835489ffff$var$engineIsIosPebble;
var $558228835489ffff$var$IS_WEBOS_WEBKIT = $558228835489ffff$var$engineIsWebosWebkit;
var $558228835489ffff$var$IS_NODE$2 = $558228835489ffff$var$engineIsNode;
var $558228835489ffff$var$MutationObserver = $558228835489ffff$var$global$5.MutationObserver || $558228835489ffff$var$global$5.WebKitMutationObserver;
var $558228835489ffff$var$document$2 = $558228835489ffff$var$global$5.document;
var $558228835489ffff$var$process$1 = $558228835489ffff$var$global$5.process;
var $558228835489ffff$var$Promise$1 = $558228835489ffff$var$global$5.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var $558228835489ffff$var$queueMicrotaskDescriptor = $558228835489ffff$var$getOwnPropertyDescriptor($558228835489ffff$var$global$5, 'queueMicrotask');
var $558228835489ffff$var$microtask$1 = $558228835489ffff$var$queueMicrotaskDescriptor && $558228835489ffff$var$queueMicrotaskDescriptor.value;
var $558228835489ffff$var$notify$1, $558228835489ffff$var$toggle, $558228835489ffff$var$node, $558228835489ffff$var$promise$5, $558228835489ffff$var$then;
// modern engines have queueMicrotask method
if (!$558228835489ffff$var$microtask$1) {
    var $558228835489ffff$var$queue = new $558228835489ffff$var$Queue$2();
    var $558228835489ffff$var$flush = function() {
        var parent, fn;
        if ($558228835489ffff$var$IS_NODE$2 && (parent = $558228835489ffff$var$process$1.domain)) parent.exit();
        while(fn = $558228835489ffff$var$queue.get())try {
            fn();
        } catch (error) {
            if ($558228835489ffff$var$queue.head) $558228835489ffff$var$notify$1();
            throw error;
        }
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$558228835489ffff$var$IS_IOS && !$558228835489ffff$var$IS_NODE$2 && !$558228835489ffff$var$IS_WEBOS_WEBKIT && $558228835489ffff$var$MutationObserver && $558228835489ffff$var$document$2) {
        $558228835489ffff$var$toggle = true;
        $558228835489ffff$var$node = $558228835489ffff$var$document$2.createTextNode('');
        new $558228835489ffff$var$MutationObserver($558228835489ffff$var$flush).observe($558228835489ffff$var$node, {
            characterData: true
        });
        $558228835489ffff$var$notify$1 = function() {
            $558228835489ffff$var$node.data = $558228835489ffff$var$toggle = !$558228835489ffff$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!$558228835489ffff$var$IS_IOS_PEBBLE && $558228835489ffff$var$Promise$1 && $558228835489ffff$var$Promise$1.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $558228835489ffff$var$promise$5 = $558228835489ffff$var$Promise$1.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $558228835489ffff$var$promise$5.constructor = $558228835489ffff$var$Promise$1;
        $558228835489ffff$var$then = $558228835489ffff$var$bind$2($558228835489ffff$var$promise$5.then, $558228835489ffff$var$promise$5);
        $558228835489ffff$var$notify$1 = function() {
            $558228835489ffff$var$then($558228835489ffff$var$flush);
        };
    // Node.js without promises
    } else if ($558228835489ffff$var$IS_NODE$2) $558228835489ffff$var$notify$1 = function() {
        $558228835489ffff$var$process$1.nextTick($558228835489ffff$var$flush);
    };
    else {
        // `webpack` dev server bug on IE global methods - use bind(fn, global)
        $558228835489ffff$var$macrotask = $558228835489ffff$var$bind$2($558228835489ffff$var$macrotask, $558228835489ffff$var$global$5);
        $558228835489ffff$var$notify$1 = function() {
            $558228835489ffff$var$macrotask($558228835489ffff$var$flush);
        };
    }
    $558228835489ffff$var$microtask$1 = function(fn) {
        if (!$558228835489ffff$var$queue.head) $558228835489ffff$var$notify$1();
        $558228835489ffff$var$queue.add(fn);
    };
}
var $558228835489ffff$var$microtask_1 = $558228835489ffff$var$microtask$1;
var $558228835489ffff$var$hostReportErrors$1 = function(a, b) {
    try {
        // eslint-disable-next-line no-console -- safe
        arguments.length === 1 ? console.error(a) : console.error(a, b);
    } catch (error) {}
};
var $558228835489ffff$var$perform$6 = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};
var $558228835489ffff$var$global$4 = $558228835489ffff$var$global$p;
var $558228835489ffff$var$promiseNativeConstructor = $558228835489ffff$var$global$4.Promise;
/* global Deno -- Deno case */ var $558228835489ffff$var$engineIsDeno = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';
var $558228835489ffff$var$IS_DENO$1 = $558228835489ffff$var$engineIsDeno;
var $558228835489ffff$var$IS_NODE$1 = $558228835489ffff$var$engineIsNode;
var $558228835489ffff$var$engineIsBrowser = !$558228835489ffff$var$IS_DENO$1 && !$558228835489ffff$var$IS_NODE$1 && typeof window == 'object' && typeof document == 'object';
var $558228835489ffff$var$global$3 = $558228835489ffff$var$global$p;
var $558228835489ffff$var$NativePromiseConstructor$5 = $558228835489ffff$var$promiseNativeConstructor;
var $558228835489ffff$var$isCallable$3 = $558228835489ffff$var$isCallable$m;
var $558228835489ffff$var$isForced = $558228835489ffff$var$isForced_1;
var $558228835489ffff$var$inspectSource = $558228835489ffff$var$inspectSource$2;
var $558228835489ffff$var$wellKnownSymbol = $558228835489ffff$var$wellKnownSymbol$n;
var $558228835489ffff$var$IS_BROWSER = $558228835489ffff$var$engineIsBrowser;
var $558228835489ffff$var$IS_DENO = $558228835489ffff$var$engineIsDeno;
var $558228835489ffff$var$V8_VERSION = $558228835489ffff$var$engineV8Version;
var $558228835489ffff$var$NativePromisePrototype$2 = $558228835489ffff$var$NativePromiseConstructor$5 && $558228835489ffff$var$NativePromiseConstructor$5.prototype;
var $558228835489ffff$var$SPECIES = $558228835489ffff$var$wellKnownSymbol('species');
var $558228835489ffff$var$SUBCLASSING = false;
var $558228835489ffff$var$NATIVE_PROMISE_REJECTION_EVENT$1 = $558228835489ffff$var$isCallable$3($558228835489ffff$var$global$3.PromiseRejectionEvent);
var $558228835489ffff$var$FORCED_PROMISE_CONSTRUCTOR$5 = $558228835489ffff$var$isForced('Promise', function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $558228835489ffff$var$inspectSource($558228835489ffff$var$NativePromiseConstructor$5);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($558228835489ffff$var$NativePromiseConstructor$5);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $558228835489ffff$var$V8_VERSION === 66) return true;
    // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
    if (!($558228835489ffff$var$NativePromisePrototype$2['catch'] && $558228835489ffff$var$NativePromisePrototype$2['finally'])) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if (!$558228835489ffff$var$V8_VERSION || $558228835489ffff$var$V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
        // Detect correctness of subclassing with @@species support
        var promise = new $558228835489ffff$var$NativePromiseConstructor$5(function(resolve) {
            resolve(1);
        });
        var FakePromise = function(exec) {
            exec(function() {}, function() {});
        };
        var constructor = promise.constructor = {};
        constructor[$558228835489ffff$var$SPECIES] = FakePromise;
        $558228835489ffff$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
        if (!$558228835489ffff$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    }
    return !GLOBAL_CORE_JS_PROMISE && ($558228835489ffff$var$IS_BROWSER || $558228835489ffff$var$IS_DENO) && !$558228835489ffff$var$NATIVE_PROMISE_REJECTION_EVENT$1;
});
var $558228835489ffff$var$promiseConstructorDetection = {
    CONSTRUCTOR: $558228835489ffff$var$FORCED_PROMISE_CONSTRUCTOR$5,
    REJECTION_EVENT: $558228835489ffff$var$NATIVE_PROMISE_REJECTION_EVENT$1,
    SUBCLASSING: $558228835489ffff$var$SUBCLASSING
};
var $558228835489ffff$var$newPromiseCapability$2 = {};
var $558228835489ffff$var$aCallable$6 = $558228835489ffff$var$aCallable$e;
var $558228835489ffff$var$$TypeError = TypeError;
var $558228835489ffff$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw new $558228835489ffff$var$$TypeError('Bad Promise constructor');
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $558228835489ffff$var$aCallable$6(resolve);
    this.reject = $558228835489ffff$var$aCallable$6(reject);
};
// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
$558228835489ffff$var$newPromiseCapability$2.f = function(C) {
    return new $558228835489ffff$var$PromiseCapability(C);
};
var $558228835489ffff$var$$$e = $558228835489ffff$var$_export;
var $558228835489ffff$var$IS_NODE = $558228835489ffff$var$engineIsNode;
var $558228835489ffff$var$global$2 = $558228835489ffff$var$global$p;
var $558228835489ffff$var$call$5 = $558228835489ffff$var$functionCall;
var $558228835489ffff$var$defineBuiltIn$1 = $558228835489ffff$var$defineBuiltIn$6;
var $558228835489ffff$var$setToStringTag$1 = $558228835489ffff$var$setToStringTag$7;
var $558228835489ffff$var$setSpecies$1 = $558228835489ffff$var$setSpecies$2;
var $558228835489ffff$var$aCallable$5 = $558228835489ffff$var$aCallable$e;
var $558228835489ffff$var$isCallable$2 = $558228835489ffff$var$isCallable$m;
var $558228835489ffff$var$isObject$4 = $558228835489ffff$var$isObject$h;
var $558228835489ffff$var$anInstance$2 = $558228835489ffff$var$anInstance$3;
var $558228835489ffff$var$speciesConstructor$1 = $558228835489ffff$var$speciesConstructor$2;
var $558228835489ffff$var$task = $558228835489ffff$var$task$1.set;
var $558228835489ffff$var$microtask = $558228835489ffff$var$microtask_1;
var $558228835489ffff$var$hostReportErrors = $558228835489ffff$var$hostReportErrors$1;
var $558228835489ffff$var$perform$5 = $558228835489ffff$var$perform$6;
var $558228835489ffff$var$Queue$1 = $558228835489ffff$var$queue$1;
var $558228835489ffff$var$InternalStateModule$2 = $558228835489ffff$var$internalState;
var $558228835489ffff$var$NativePromiseConstructor$4 = $558228835489ffff$var$promiseNativeConstructor;
var $558228835489ffff$var$PromiseConstructorDetection = $558228835489ffff$var$promiseConstructorDetection;
var $558228835489ffff$var$newPromiseCapabilityModule$7 = $558228835489ffff$var$newPromiseCapability$2;
var $558228835489ffff$var$PROMISE = 'Promise';
var $558228835489ffff$var$FORCED_PROMISE_CONSTRUCTOR$4 = $558228835489ffff$var$PromiseConstructorDetection.CONSTRUCTOR;
var $558228835489ffff$var$NATIVE_PROMISE_REJECTION_EVENT = $558228835489ffff$var$PromiseConstructorDetection.REJECTION_EVENT;
$558228835489ffff$var$PromiseConstructorDetection.SUBCLASSING;
var $558228835489ffff$var$getInternalPromiseState = $558228835489ffff$var$InternalStateModule$2.getterFor($558228835489ffff$var$PROMISE);
var $558228835489ffff$var$setInternalState$2 = $558228835489ffff$var$InternalStateModule$2.set;
var $558228835489ffff$var$NativePromisePrototype$1 = $558228835489ffff$var$NativePromiseConstructor$4 && $558228835489ffff$var$NativePromiseConstructor$4.prototype;
var $558228835489ffff$var$PromiseConstructor = $558228835489ffff$var$NativePromiseConstructor$4;
var $558228835489ffff$var$PromisePrototype = $558228835489ffff$var$NativePromisePrototype$1;
var $558228835489ffff$var$TypeError$1 = $558228835489ffff$var$global$2.TypeError;
var $558228835489ffff$var$document$1 = $558228835489ffff$var$global$2.document;
var $558228835489ffff$var$process = $558228835489ffff$var$global$2.process;
var $558228835489ffff$var$newPromiseCapability$1 = $558228835489ffff$var$newPromiseCapabilityModule$7.f;
var $558228835489ffff$var$newGenericPromiseCapability = $558228835489ffff$var$newPromiseCapability$1;
var $558228835489ffff$var$DISPATCH_EVENT = !!($558228835489ffff$var$document$1 && $558228835489ffff$var$document$1.createEvent && $558228835489ffff$var$global$2.dispatchEvent);
var $558228835489ffff$var$UNHANDLED_REJECTION = 'unhandledrejection';
var $558228835489ffff$var$REJECTION_HANDLED = 'rejectionhandled';
var $558228835489ffff$var$PENDING = 0;
var $558228835489ffff$var$FULFILLED = 1;
var $558228835489ffff$var$REJECTED = 2;
var $558228835489ffff$var$HANDLED = 1;
var $558228835489ffff$var$UNHANDLED = 2;
var $558228835489ffff$var$Internal, $558228835489ffff$var$OwnPromiseCapability, $558228835489ffff$var$PromiseWrapper;
// helpers
var $558228835489ffff$var$isThenable = function(it) {
    var then;
    return $558228835489ffff$var$isObject$4(it) && $558228835489ffff$var$isCallable$2(then = it.then) ? then : false;
};
var $558228835489ffff$var$callReaction = function(reaction, state) {
    var value = state.value;
    var ok = state.state === $558228835489ffff$var$FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === $558228835489ffff$var$UNHANDLED) $558228835489ffff$var$onHandleUnhandled(state);
                state.rejection = $558228835489ffff$var$HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject(new $558228835489ffff$var$TypeError$1('Promise-chain cycle'));
            else if (then = $558228835489ffff$var$isThenable(result)) $558228835489ffff$var$call$5(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var $558228835489ffff$var$notify = function(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    $558228835489ffff$var$microtask(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())$558228835489ffff$var$callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) $558228835489ffff$var$onUnhandled(state);
    });
};
var $558228835489ffff$var$dispatchEvent = function(name, promise, reason) {
    var event, handler;
    if ($558228835489ffff$var$DISPATCH_EVENT) {
        event = $558228835489ffff$var$document$1.createEvent('Event');
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $558228835489ffff$var$global$2.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$558228835489ffff$var$NATIVE_PROMISE_REJECTION_EVENT && (handler = $558228835489ffff$var$global$2['on' + name])) handler(event);
    else if (name === $558228835489ffff$var$UNHANDLED_REJECTION) $558228835489ffff$var$hostReportErrors('Unhandled promise rejection', reason);
};
var $558228835489ffff$var$onUnhandled = function(state) {
    $558228835489ffff$var$call$5($558228835489ffff$var$task, $558228835489ffff$var$global$2, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $558228835489ffff$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $558228835489ffff$var$perform$5(function() {
                if ($558228835489ffff$var$IS_NODE) $558228835489ffff$var$process.emit('unhandledRejection', value, promise);
                else $558228835489ffff$var$dispatchEvent($558228835489ffff$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $558228835489ffff$var$IS_NODE || $558228835489ffff$var$isUnhandled(state) ? $558228835489ffff$var$UNHANDLED : $558228835489ffff$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $558228835489ffff$var$isUnhandled = function(state) {
    return state.rejection !== $558228835489ffff$var$HANDLED && !state.parent;
};
var $558228835489ffff$var$onHandleUnhandled = function(state) {
    $558228835489ffff$var$call$5($558228835489ffff$var$task, $558228835489ffff$var$global$2, function() {
        var promise = state.facade;
        if ($558228835489ffff$var$IS_NODE) $558228835489ffff$var$process.emit('rejectionHandled', promise);
        else $558228835489ffff$var$dispatchEvent($558228835489ffff$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $558228835489ffff$var$bind$1 = function(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $558228835489ffff$var$internalReject = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $558228835489ffff$var$REJECTED;
    $558228835489ffff$var$notify(state, true);
};
var $558228835489ffff$var$internalResolve = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw new $558228835489ffff$var$TypeError$1("Promise can't be resolved itself");
        var then = $558228835489ffff$var$isThenable(value);
        if (then) $558228835489ffff$var$microtask(function() {
            var wrapper = {
                done: false
            };
            try {
                $558228835489ffff$var$call$5(then, value, $558228835489ffff$var$bind$1($558228835489ffff$var$internalResolve, wrapper, state), $558228835489ffff$var$bind$1($558228835489ffff$var$internalReject, wrapper, state));
            } catch (error) {
                $558228835489ffff$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $558228835489ffff$var$FULFILLED;
            $558228835489ffff$var$notify(state, false);
        }
    } catch (error) {
        $558228835489ffff$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($558228835489ffff$var$FORCED_PROMISE_CONSTRUCTOR$4) {
    // 25.4.3.1 Promise(executor)
    $558228835489ffff$var$PromiseConstructor = function Promise(executor) {
        $558228835489ffff$var$anInstance$2(this, $558228835489ffff$var$PromisePrototype);
        $558228835489ffff$var$aCallable$5(executor);
        $558228835489ffff$var$call$5($558228835489ffff$var$Internal, this);
        var state = $558228835489ffff$var$getInternalPromiseState(this);
        try {
            executor($558228835489ffff$var$bind$1($558228835489ffff$var$internalResolve, state), $558228835489ffff$var$bind$1($558228835489ffff$var$internalReject, state));
        } catch (error) {
            $558228835489ffff$var$internalReject(state, error);
        }
    };
    $558228835489ffff$var$PromisePrototype = $558228835489ffff$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $558228835489ffff$var$Internal = function Promise(executor) {
        $558228835489ffff$var$setInternalState$2(this, {
            type: $558228835489ffff$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new $558228835489ffff$var$Queue$1(),
            rejection: false,
            state: $558228835489ffff$var$PENDING,
            value: undefined
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    $558228835489ffff$var$Internal.prototype = $558228835489ffff$var$defineBuiltIn$1($558228835489ffff$var$PromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var state = $558228835489ffff$var$getInternalPromiseState(this);
        var reaction = $558228835489ffff$var$newPromiseCapability$1($558228835489ffff$var$speciesConstructor$1(this, $558228835489ffff$var$PromiseConstructor));
        state.parent = true;
        reaction.ok = $558228835489ffff$var$isCallable$2(onFulfilled) ? onFulfilled : true;
        reaction.fail = $558228835489ffff$var$isCallable$2(onRejected) && onRejected;
        reaction.domain = $558228835489ffff$var$IS_NODE ? $558228835489ffff$var$process.domain : undefined;
        if (state.state === $558228835489ffff$var$PENDING) state.reactions.add(reaction);
        else $558228835489ffff$var$microtask(function() {
            $558228835489ffff$var$callReaction(reaction, state);
        });
        return reaction.promise;
    });
    $558228835489ffff$var$OwnPromiseCapability = function() {
        var promise = new $558228835489ffff$var$Internal();
        var state = $558228835489ffff$var$getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = $558228835489ffff$var$bind$1($558228835489ffff$var$internalResolve, state);
        this.reject = $558228835489ffff$var$bind$1($558228835489ffff$var$internalReject, state);
    };
    $558228835489ffff$var$newPromiseCapabilityModule$7.f = $558228835489ffff$var$newPromiseCapability$1 = function(C) {
        return C === $558228835489ffff$var$PromiseConstructor || C === $558228835489ffff$var$PromiseWrapper ? new $558228835489ffff$var$OwnPromiseCapability(C) : $558228835489ffff$var$newGenericPromiseCapability(C);
    };
}
$558228835489ffff$var$$$e({
    global: true,
    constructor: true,
    wrap: true,
    forced: $558228835489ffff$var$FORCED_PROMISE_CONSTRUCTOR$4
}, {
    Promise: $558228835489ffff$var$PromiseConstructor
});
$558228835489ffff$var$setToStringTag$1($558228835489ffff$var$PromiseConstructor, $558228835489ffff$var$PROMISE, false, true);
$558228835489ffff$var$setSpecies$1($558228835489ffff$var$PROMISE);
var $558228835489ffff$var$NativePromiseConstructor$3 = $558228835489ffff$var$promiseNativeConstructor;
var $558228835489ffff$var$checkCorrectnessOfIteration = $558228835489ffff$var$checkCorrectnessOfIteration$2;
var $558228835489ffff$var$FORCED_PROMISE_CONSTRUCTOR$3 = $558228835489ffff$var$promiseConstructorDetection.CONSTRUCTOR;
var $558228835489ffff$var$promiseStaticsIncorrectIteration = $558228835489ffff$var$FORCED_PROMISE_CONSTRUCTOR$3 || !$558228835489ffff$var$checkCorrectnessOfIteration(function(iterable) {
    $558228835489ffff$var$NativePromiseConstructor$3.all(iterable).then(undefined, function() {});
});
var $558228835489ffff$var$$$d = $558228835489ffff$var$_export;
var $558228835489ffff$var$call$4 = $558228835489ffff$var$functionCall;
var $558228835489ffff$var$aCallable$4 = $558228835489ffff$var$aCallable$e;
var $558228835489ffff$var$newPromiseCapabilityModule$6 = $558228835489ffff$var$newPromiseCapability$2;
var $558228835489ffff$var$perform$4 = $558228835489ffff$var$perform$6;
var $558228835489ffff$var$iterate$5 = $558228835489ffff$var$iterate$7;
var $558228835489ffff$var$PROMISE_STATICS_INCORRECT_ITERATION$3 = $558228835489ffff$var$promiseStaticsIncorrectIteration;
// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$558228835489ffff$var$$$d({
    target: 'Promise',
    stat: true,
    forced: $558228835489ffff$var$PROMISE_STATICS_INCORRECT_ITERATION$3
}, {
    all: function all(iterable) {
        var C = this;
        var capability = $558228835489ffff$var$newPromiseCapabilityModule$6.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $558228835489ffff$var$perform$4(function() {
            var $promiseResolve = $558228835489ffff$var$aCallable$4(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $558228835489ffff$var$iterate$5(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $558228835489ffff$var$call$4($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $558228835489ffff$var$$$c = $558228835489ffff$var$_export;
var $558228835489ffff$var$FORCED_PROMISE_CONSTRUCTOR$2 = $558228835489ffff$var$promiseConstructorDetection.CONSTRUCTOR;
var $558228835489ffff$var$NativePromiseConstructor$2 = $558228835489ffff$var$promiseNativeConstructor;
$558228835489ffff$var$NativePromiseConstructor$2 && $558228835489ffff$var$NativePromiseConstructor$2.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$558228835489ffff$var$$$c({
    target: 'Promise',
    proto: true,
    forced: $558228835489ffff$var$FORCED_PROMISE_CONSTRUCTOR$2,
    real: true
}, {
    'catch': function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
var $558228835489ffff$var$$$b = $558228835489ffff$var$_export;
var $558228835489ffff$var$call$3 = $558228835489ffff$var$functionCall;
var $558228835489ffff$var$aCallable$3 = $558228835489ffff$var$aCallable$e;
var $558228835489ffff$var$newPromiseCapabilityModule$5 = $558228835489ffff$var$newPromiseCapability$2;
var $558228835489ffff$var$perform$3 = $558228835489ffff$var$perform$6;
var $558228835489ffff$var$iterate$4 = $558228835489ffff$var$iterate$7;
var $558228835489ffff$var$PROMISE_STATICS_INCORRECT_ITERATION$2 = $558228835489ffff$var$promiseStaticsIncorrectIteration;
// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$558228835489ffff$var$$$b({
    target: 'Promise',
    stat: true,
    forced: $558228835489ffff$var$PROMISE_STATICS_INCORRECT_ITERATION$2
}, {
    race: function race(iterable) {
        var C = this;
        var capability = $558228835489ffff$var$newPromiseCapabilityModule$5.f(C);
        var reject = capability.reject;
        var result = $558228835489ffff$var$perform$3(function() {
            var $promiseResolve = $558228835489ffff$var$aCallable$3(C.resolve);
            $558228835489ffff$var$iterate$4(iterable, function(promise) {
                $558228835489ffff$var$call$3($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $558228835489ffff$var$$$a = $558228835489ffff$var$_export;
var $558228835489ffff$var$call$2 = $558228835489ffff$var$functionCall;
var $558228835489ffff$var$newPromiseCapabilityModule$4 = $558228835489ffff$var$newPromiseCapability$2;
var $558228835489ffff$var$FORCED_PROMISE_CONSTRUCTOR$1 = $558228835489ffff$var$promiseConstructorDetection.CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$558228835489ffff$var$$$a({
    target: 'Promise',
    stat: true,
    forced: $558228835489ffff$var$FORCED_PROMISE_CONSTRUCTOR$1
}, {
    reject: function reject(r) {
        var capability = $558228835489ffff$var$newPromiseCapabilityModule$4.f(this);
        $558228835489ffff$var$call$2(capability.reject, undefined, r);
        return capability.promise;
    }
});
var $558228835489ffff$var$anObject = $558228835489ffff$var$anObject$d;
var $558228835489ffff$var$isObject$3 = $558228835489ffff$var$isObject$h;
var $558228835489ffff$var$newPromiseCapability = $558228835489ffff$var$newPromiseCapability$2;
var $558228835489ffff$var$promiseResolve$2 = function(C, x) {
    $558228835489ffff$var$anObject(C);
    if ($558228835489ffff$var$isObject$3(x) && x.constructor === C) return x;
    var promiseCapability = $558228835489ffff$var$newPromiseCapability.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};
var $558228835489ffff$var$$$9 = $558228835489ffff$var$_export;
var $558228835489ffff$var$getBuiltIn$2 = $558228835489ffff$var$getBuiltIn$f;
var $558228835489ffff$var$IS_PURE = $558228835489ffff$var$isPure;
var $558228835489ffff$var$NativePromiseConstructor$1 = $558228835489ffff$var$promiseNativeConstructor;
var $558228835489ffff$var$FORCED_PROMISE_CONSTRUCTOR = $558228835489ffff$var$promiseConstructorDetection.CONSTRUCTOR;
var $558228835489ffff$var$promiseResolve$1 = $558228835489ffff$var$promiseResolve$2;
var $558228835489ffff$var$PromiseConstructorWrapper = $558228835489ffff$var$getBuiltIn$2('Promise');
var $558228835489ffff$var$CHECK_WRAPPER = !$558228835489ffff$var$FORCED_PROMISE_CONSTRUCTOR;
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$558228835489ffff$var$$$9({
    target: 'Promise',
    stat: true,
    forced: $558228835489ffff$var$IS_PURE
}, {
    resolve: function resolve(x) {
        return $558228835489ffff$var$promiseResolve$1($558228835489ffff$var$CHECK_WRAPPER && this === $558228835489ffff$var$PromiseConstructorWrapper ? $558228835489ffff$var$NativePromiseConstructor$1 : this, x);
    }
});
var $558228835489ffff$var$$$8 = $558228835489ffff$var$_export;
var $558228835489ffff$var$call$1 = $558228835489ffff$var$functionCall;
var $558228835489ffff$var$aCallable$2 = $558228835489ffff$var$aCallable$e;
var $558228835489ffff$var$newPromiseCapabilityModule$3 = $558228835489ffff$var$newPromiseCapability$2;
var $558228835489ffff$var$perform$2 = $558228835489ffff$var$perform$6;
var $558228835489ffff$var$iterate$3 = $558228835489ffff$var$iterate$7;
var $558228835489ffff$var$PROMISE_STATICS_INCORRECT_ITERATION$1 = $558228835489ffff$var$promiseStaticsIncorrectIteration;
// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$558228835489ffff$var$$$8({
    target: 'Promise',
    stat: true,
    forced: $558228835489ffff$var$PROMISE_STATICS_INCORRECT_ITERATION$1
}, {
    allSettled: function allSettled(iterable) {
        var C = this;
        var capability = $558228835489ffff$var$newPromiseCapabilityModule$3.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $558228835489ffff$var$perform$2(function() {
            var promiseResolve = $558228835489ffff$var$aCallable$2(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $558228835489ffff$var$iterate$3(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $558228835489ffff$var$call$1(promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: 'fulfilled',
                        value: value
                    };
                    --remaining || resolve(values);
                }, function(error) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: 'rejected',
                        reason: error
                    };
                    --remaining || resolve(values);
                });
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $558228835489ffff$var$$$7 = $558228835489ffff$var$_export;
var $558228835489ffff$var$call = $558228835489ffff$var$functionCall;
var $558228835489ffff$var$aCallable$1 = $558228835489ffff$var$aCallable$e;
var $558228835489ffff$var$getBuiltIn$1 = $558228835489ffff$var$getBuiltIn$f;
var $558228835489ffff$var$newPromiseCapabilityModule$2 = $558228835489ffff$var$newPromiseCapability$2;
var $558228835489ffff$var$perform$1 = $558228835489ffff$var$perform$6;
var $558228835489ffff$var$iterate$2 = $558228835489ffff$var$iterate$7;
var $558228835489ffff$var$PROMISE_STATICS_INCORRECT_ITERATION = $558228835489ffff$var$promiseStaticsIncorrectIteration;
var $558228835489ffff$var$PROMISE_ANY_ERROR = 'No one promise resolved';
// `Promise.any` method
// https://tc39.es/ecma262/#sec-promise.any
$558228835489ffff$var$$$7({
    target: 'Promise',
    stat: true,
    forced: $558228835489ffff$var$PROMISE_STATICS_INCORRECT_ITERATION
}, {
    any: function any(iterable) {
        var C = this;
        var AggregateError = $558228835489ffff$var$getBuiltIn$1('AggregateError');
        var capability = $558228835489ffff$var$newPromiseCapabilityModule$2.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $558228835489ffff$var$perform$1(function() {
            var promiseResolve = $558228835489ffff$var$aCallable$1(C.resolve);
            var errors = [];
            var counter = 0;
            var remaining = 1;
            var alreadyResolved = false;
            $558228835489ffff$var$iterate$2(iterable, function(promise) {
                var index = counter++;
                var alreadyRejected = false;
                remaining++;
                $558228835489ffff$var$call(promiseResolve, C, promise).then(function(value) {
                    if (alreadyRejected || alreadyResolved) return;
                    alreadyResolved = true;
                    resolve(value);
                }, function(error) {
                    if (alreadyRejected || alreadyResolved) return;
                    alreadyRejected = true;
                    errors[index] = error;
                    --remaining || reject(new AggregateError(errors, $558228835489ffff$var$PROMISE_ANY_ERROR));
                });
            });
            --remaining || reject(new AggregateError(errors, $558228835489ffff$var$PROMISE_ANY_ERROR));
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $558228835489ffff$var$$$6 = $558228835489ffff$var$_export;
var $558228835489ffff$var$NativePromiseConstructor = $558228835489ffff$var$promiseNativeConstructor;
var $558228835489ffff$var$fails$5 = $558228835489ffff$var$fails$u;
var $558228835489ffff$var$getBuiltIn = $558228835489ffff$var$getBuiltIn$f;
var $558228835489ffff$var$isCallable$1 = $558228835489ffff$var$isCallable$m;
var $558228835489ffff$var$speciesConstructor = $558228835489ffff$var$speciesConstructor$2;
var $558228835489ffff$var$promiseResolve = $558228835489ffff$var$promiseResolve$2;
var $558228835489ffff$var$NativePromisePrototype = $558228835489ffff$var$NativePromiseConstructor && $558228835489ffff$var$NativePromiseConstructor.prototype;
// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var $558228835489ffff$var$NON_GENERIC = !!$558228835489ffff$var$NativePromiseConstructor && $558228835489ffff$var$fails$5(function() {
    // eslint-disable-next-line unicorn/no-thenable -- required for testing
    $558228835489ffff$var$NativePromisePrototype['finally'].call({
        then: function() {}
    }, function() {});
});
// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$558228835489ffff$var$$$6({
    target: 'Promise',
    proto: true,
    real: true,
    forced: $558228835489ffff$var$NON_GENERIC
}, {
    'finally': function(onFinally) {
        var C = $558228835489ffff$var$speciesConstructor(this, $558228835489ffff$var$getBuiltIn('Promise'));
        var isFunction = $558228835489ffff$var$isCallable$1(onFinally);
        return this.then(isFunction ? function(x) {
            return $558228835489ffff$var$promiseResolve(C, onFinally()).then(function() {
                return x;
            });
        } : onFinally, isFunction ? function(e) {
            return $558228835489ffff$var$promiseResolve(C, onFinally()).then(function() {
                throw e;
            });
        } : onFinally);
    }
});
var $558228835489ffff$var$path$2 = $558228835489ffff$var$path$o;
var $558228835489ffff$var$promise$4 = $558228835489ffff$var$path$2.Promise;
var $558228835489ffff$var$parent$e = $558228835489ffff$var$promise$4;
var $558228835489ffff$var$promise$3 = $558228835489ffff$var$parent$e;
var $558228835489ffff$var$$$5 = $558228835489ffff$var$_export;
var $558228835489ffff$var$newPromiseCapabilityModule$1 = $558228835489ffff$var$newPromiseCapability$2;
// `Promise.withResolvers` method
// https://github.com/tc39/proposal-promise-with-resolvers
$558228835489ffff$var$$$5({
    target: 'Promise',
    stat: true
}, {
    withResolvers: function withResolvers() {
        var promiseCapability = $558228835489ffff$var$newPromiseCapabilityModule$1.f(this);
        return {
            promise: promiseCapability.promise,
            resolve: promiseCapability.resolve,
            reject: promiseCapability.reject
        };
    }
});
var $558228835489ffff$var$parent$d = $558228835489ffff$var$promise$3;
var $558228835489ffff$var$promise$2 = $558228835489ffff$var$parent$d;
// TODO: Remove from `core-js@4`
var $558228835489ffff$var$$$4 = $558228835489ffff$var$_export;
var $558228835489ffff$var$newPromiseCapabilityModule = $558228835489ffff$var$newPromiseCapability$2;
var $558228835489ffff$var$perform = $558228835489ffff$var$perform$6;
// `Promise.try` method
// https://github.com/tc39/proposal-promise-try
$558228835489ffff$var$$$4({
    target: 'Promise',
    stat: true,
    forced: true
}, {
    'try': function(callbackfn) {
        var promiseCapability = $558228835489ffff$var$newPromiseCapabilityModule.f(this);
        var result = $558228835489ffff$var$perform(callbackfn);
        (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
        return promiseCapability.promise;
    }
});
var $558228835489ffff$var$parent$c = $558228835489ffff$var$promise$2;
// TODO: Remove from `core-js@4`
var $558228835489ffff$var$promise$1 = $558228835489ffff$var$parent$c;
var $558228835489ffff$var$promise = $558228835489ffff$var$promise$1;
var $558228835489ffff$var$parent$b = $558228835489ffff$var$reverse$4;
var $558228835489ffff$var$reverse$2 = $558228835489ffff$var$parent$b;
var $558228835489ffff$var$parent$a = $558228835489ffff$var$reverse$2;
var $558228835489ffff$var$reverse$1 = $558228835489ffff$var$parent$a;
var $558228835489ffff$var$reverse = $558228835489ffff$var$reverse$1;
(function(module) {
    var _typeof = $558228835489ffff$var$_typeofExports["default"];
    var _Object$defineProperty = $558228835489ffff$var$defineProperty$8;
    var _Symbol = $558228835489ffff$var$symbol$1;
    var _Object$create = $558228835489ffff$var$create$2;
    var _Object$getPrototypeOf = $558228835489ffff$var$getPrototypeOf$1;
    var _forEachInstanceProperty = $558228835489ffff$var$forEach$1;
    var _pushInstanceProperty = $558228835489ffff$var$push$3;
    var _Object$setPrototypeOf = $558228835489ffff$var$setPrototypeOf$1;
    var _Promise = $558228835489ffff$var$promise;
    var _reverseInstanceProperty = $558228835489ffff$var$reverse;
    var _sliceInstanceProperty = $558228835489ffff$var$slice$1;
    function _regeneratorRuntime() {
        module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
            return e;
        }, module.exports.__esModule = true, module.exports["default"] = module.exports;
        var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = _Object$defineProperty || function(t, e, r) {
            t[e] = r.value;
        }, i = "function" == typeof _Symbol ? _Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
        function define(t, e, r) {
            return _Object$defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }), t[e];
        }
        try {
            define({}, "");
        } catch (t) {
            define = function define(t, e, r) {
                return t[e] = r;
            };
        }
        function wrap(t, e, r, n) {
            var i = e && e.prototype instanceof Generator ? e : Generator, a = _Object$create(i.prototype), c = new Context(n || []);
            return o(a, "_invoke", {
                value: makeInvokeMethod(t, r, c)
            }), a;
        }
        function tryCatch(t, e, r) {
            try {
                return {
                    type: "normal",
                    arg: t.call(e, r)
                };
            } catch (t) {
                return {
                    type: "throw",
                    arg: t
                };
            }
        }
        e.wrap = wrap;
        var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
        function Generator() {}
        function GeneratorFunction() {}
        function GeneratorFunctionPrototype() {}
        var p = {};
        define(p, a, function() {
            return this;
        });
        var d = _Object$getPrototypeOf, v = d && d(d(values([])));
        v && v !== r && n.call(v, a) && (p = v);
        var g = GeneratorFunctionPrototype.prototype = Generator.prototype = _Object$create(p);
        function defineIteratorMethods(t) {
            var _context;
            _forEachInstanceProperty(_context = [
                "next",
                "throw",
                "return"
            ]).call(_context, function(e) {
                define(t, e, function(t) {
                    return this._invoke(e, t);
                });
            });
        }
        function AsyncIterator(t, e) {
            function invoke(r, o, i, a) {
                var c = tryCatch(t[r], t, o);
                if ("throw" !== c.type) {
                    var u = c.arg, h = u.value;
                    return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                        invoke("next", t, i, a);
                    }, function(t) {
                        invoke("throw", t, i, a);
                    }) : e.resolve(h).then(function(t) {
                        u.value = t, i(u);
                    }, function(t) {
                        return invoke("throw", t, i, a);
                    });
                }
                a(c.arg);
            }
            var r;
            o(this, "_invoke", {
                value: function value(t, n) {
                    function callInvokeWithMethodAndArg() {
                        return new e(function(e, r) {
                            invoke(t, n, e, r);
                        });
                    }
                    return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
                }
            });
        }
        function makeInvokeMethod(e, r, n) {
            var o = h;
            return function(i, a) {
                if (o === f) throw new Error("Generator is already running");
                if (o === s) {
                    if ("throw" === i) throw a;
                    return {
                        value: t,
                        done: !0
                    };
                }
                for(n.method = i, n.arg = a;;){
                    var c = n.delegate;
                    if (c) {
                        var u = maybeInvokeDelegate(c, n);
                        if (u) {
                            if (u === y) continue;
                            return u;
                        }
                    }
                    if ("next" === n.method) n.sent = n._sent = n.arg;
                    else if ("throw" === n.method) {
                        if (o === h) throw o = s, n.arg;
                        n.dispatchException(n.arg);
                    } else "return" === n.method && n.abrupt("return", n.arg);
                    o = f;
                    var p = tryCatch(e, r, n);
                    if ("normal" === p.type) {
                        if (o = n.done ? s : l, p.arg === y) continue;
                        return {
                            value: p.arg,
                            done: n.done
                        };
                    }
                    "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
                }
            };
        }
        function maybeInvokeDelegate(e, r) {
            var n = r.method, o = e.iterator[n];
            if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
            var i = tryCatch(o, e.iterator, r.arg);
            if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
            var a = i.arg;
            return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
        }
        function pushTryEntry(t) {
            var _context2;
            var e = {
                tryLoc: t[0]
            };
            1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), _pushInstanceProperty(_context2 = this.tryEntries).call(_context2, e);
        }
        function resetTryEntry(t) {
            var e = t.completion || {};
            e.type = "normal", delete e.arg, t.completion = e;
        }
        function Context(t) {
            this.tryEntries = [
                {
                    tryLoc: "root"
                }
            ], _forEachInstanceProperty(t).call(t, pushTryEntry, this), this.reset(!0);
        }
        function values(e) {
            if (e || "" === e) {
                var r = e[a];
                if (r) return r.call(e);
                if ("function" == typeof e.next) return e;
                if (!isNaN(e.length)) {
                    var o = -1, i = function next() {
                        for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                        return next.value = t, next.done = !0, next;
                    };
                    return i.next = i;
                }
            }
            throw new TypeError(_typeof(e) + " is not iterable");
        }
        return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
            value: GeneratorFunctionPrototype,
            configurable: !0
        }), o(GeneratorFunctionPrototype, "constructor", {
            value: GeneratorFunction,
            configurable: !0
        }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
            var e = "function" == typeof t && t.constructor;
            return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
        }, e.mark = function(t) {
            return _Object$setPrototypeOf ? _Object$setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = _Object$create(g), t;
        }, e.awrap = function(t) {
            return {
                __await: t
            };
        }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
            return this;
        }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
            void 0 === i && (i = _Promise);
            var a = new AsyncIterator(wrap(t, r, n, o), i);
            return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
                return t.done ? t.value : a.next();
            });
        }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
            return this;
        }), define(g, "toString", function() {
            return "[object Generator]";
        }), e.keys = function(t) {
            var e = Object(t), r = [];
            for(var n in e)_pushInstanceProperty(r).call(r, n);
            return _reverseInstanceProperty(r).call(r), function next() {
                for(; r.length;){
                    var t = r.pop();
                    if (t in e) return next.value = t, next.done = !1, next;
                }
                return next.done = !0, next;
            };
        }, e.values = values, Context.prototype = {
            constructor: Context,
            reset: function reset(e) {
                var _context3;
                if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, _forEachInstanceProperty(_context3 = this.tryEntries).call(_context3, resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+_sliceInstanceProperty(r).call(r, 1)) && (this[r] = t);
            },
            stop: function stop() {
                this.done = !0;
                var t = this.tryEntries[0].completion;
                if ("throw" === t.type) throw t.arg;
                return this.rval;
            },
            dispatchException: function dispatchException(e) {
                if (this.done) throw e;
                var r = this;
                function handle(n, o) {
                    return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
                }
                for(var o = this.tryEntries.length - 1; o >= 0; --o){
                    var i = this.tryEntries[o], a = i.completion;
                    if ("root" === i.tryLoc) return handle("end");
                    if (i.tryLoc <= this.prev) {
                        var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                        if (c && u) {
                            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                        } else if (c) {
                            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        } else {
                            if (!u) throw new Error("try statement without catch or finally");
                            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                        }
                    }
                }
            },
            abrupt: function abrupt(t, e) {
                for(var r = this.tryEntries.length - 1; r >= 0; --r){
                    var o = this.tryEntries[r];
                    if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                        var i = o;
                        break;
                    }
                }
                i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                var a = i ? i.completion : {};
                return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
            },
            complete: function complete(t, e) {
                if ("throw" === t.type) throw t.arg;
                return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
            },
            finish: function finish(t) {
                for(var e = this.tryEntries.length - 1; e >= 0; --e){
                    var r = this.tryEntries[e];
                    if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
                }
            },
            "catch": function _catch(t) {
                for(var e = this.tryEntries.length - 1; e >= 0; --e){
                    var r = this.tryEntries[e];
                    if (r.tryLoc === t) {
                        var n = r.completion;
                        if ("throw" === n.type) {
                            var o = n.arg;
                            resetTryEntry(r);
                        }
                        return o;
                    }
                }
                throw new Error("illegal catch attempt");
            },
            delegateYield: function delegateYield(e, r, n) {
                return this.delegate = {
                    iterator: values(e),
                    resultName: r,
                    nextLoc: n
                }, "next" === this.method && (this.arg = t), y;
            }
        }, e;
    }
    module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;
})($558228835489ffff$var$regeneratorRuntime$1);
var $558228835489ffff$var$regeneratorRuntimeExports = $558228835489ffff$var$regeneratorRuntime$1.exports;
// TODO(Babel 8): Remove this file.
var $558228835489ffff$var$runtime = $558228835489ffff$var$regeneratorRuntimeExports();
var $558228835489ffff$var$regenerator = $558228835489ffff$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $558228835489ffff$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $558228835489ffff$var$runtime;
    else Function("r", "regeneratorRuntime = r")($558228835489ffff$var$runtime);
}
var $558228835489ffff$var$_regeneratorRuntime = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$regenerator);
var $558228835489ffff$var$internalMetadata = {
    exports: {}
};
// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
var $558228835489ffff$var$fails$4 = $558228835489ffff$var$fails$u;
var $558228835489ffff$var$arrayBufferNonExtensible = $558228835489ffff$var$fails$4(function() {
    if (typeof ArrayBuffer == 'function') {
        var buffer = new ArrayBuffer(8);
        // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
        if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', {
            value: 8
        });
    }
});
var $558228835489ffff$var$fails$3 = $558228835489ffff$var$fails$u;
var $558228835489ffff$var$isObject$2 = $558228835489ffff$var$isObject$h;
var $558228835489ffff$var$classof$3 = $558228835489ffff$var$classofRaw$2;
var $558228835489ffff$var$ARRAY_BUFFER_NON_EXTENSIBLE = $558228835489ffff$var$arrayBufferNonExtensible;
// eslint-disable-next-line es/no-object-isextensible -- safe
var $558228835489ffff$var$$isExtensible = Object.isExtensible;
var $558228835489ffff$var$FAILS_ON_PRIMITIVES = $558228835489ffff$var$fails$3(function() {
    $558228835489ffff$var$$isExtensible(1);
});
// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
var $558228835489ffff$var$objectIsExtensible = $558228835489ffff$var$FAILS_ON_PRIMITIVES || $558228835489ffff$var$ARRAY_BUFFER_NON_EXTENSIBLE ? function isExtensible(it) {
    if (!$558228835489ffff$var$isObject$2(it)) return false;
    if ($558228835489ffff$var$ARRAY_BUFFER_NON_EXTENSIBLE && $558228835489ffff$var$classof$3(it) === 'ArrayBuffer') return false;
    return $558228835489ffff$var$$isExtensible ? $558228835489ffff$var$$isExtensible(it) : true;
} : $558228835489ffff$var$$isExtensible;
var $558228835489ffff$var$fails$2 = $558228835489ffff$var$fails$u;
var $558228835489ffff$var$freezing = !$558228835489ffff$var$fails$2(function() {
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
    return Object.isExtensible(Object.preventExtensions({}));
});
var $558228835489ffff$var$$$3 = $558228835489ffff$var$_export;
var $558228835489ffff$var$uncurryThis$1 = $558228835489ffff$var$functionUncurryThis;
var $558228835489ffff$var$hiddenKeys = $558228835489ffff$var$hiddenKeys$6;
var $558228835489ffff$var$isObject$1 = $558228835489ffff$var$isObject$h;
var $558228835489ffff$var$hasOwn$3 = $558228835489ffff$var$hasOwnProperty_1;
var $558228835489ffff$var$defineProperty$1 = $558228835489ffff$var$objectDefineProperty.f;
var $558228835489ffff$var$getOwnPropertyNamesModule = $558228835489ffff$var$objectGetOwnPropertyNames;
var $558228835489ffff$var$getOwnPropertyNamesExternalModule = $558228835489ffff$var$objectGetOwnPropertyNamesExternal;
var $558228835489ffff$var$isExtensible = $558228835489ffff$var$objectIsExtensible;
var $558228835489ffff$var$uid = $558228835489ffff$var$uid$4;
var $558228835489ffff$var$FREEZING = $558228835489ffff$var$freezing;
var $558228835489ffff$var$REQUIRED = false;
var $558228835489ffff$var$METADATA = $558228835489ffff$var$uid('meta');
var $558228835489ffff$var$id = 0;
var $558228835489ffff$var$setMetadata = function(it) {
    $558228835489ffff$var$defineProperty$1(it, $558228835489ffff$var$METADATA, {
        value: {
            objectID: 'O' + $558228835489ffff$var$id++,
            weakData: {} // weak collections IDs
        }
    });
};
var $558228835489ffff$var$fastKey$1 = function(it, create) {
    // return a primitive with prefix
    if (!$558228835489ffff$var$isObject$1(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$558228835489ffff$var$hasOwn$3(it, $558228835489ffff$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$558228835489ffff$var$isExtensible(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $558228835489ffff$var$setMetadata(it);
    // return object ID
    }
    return it[$558228835489ffff$var$METADATA].objectID;
};
var $558228835489ffff$var$getWeakData = function(it, create) {
    if (!$558228835489ffff$var$hasOwn$3(it, $558228835489ffff$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$558228835489ffff$var$isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $558228835489ffff$var$setMetadata(it);
    // return the store of weak collections IDs
    }
    return it[$558228835489ffff$var$METADATA].weakData;
};
// add metadata on freeze-family methods calling
var $558228835489ffff$var$onFreeze = function(it) {
    if ($558228835489ffff$var$FREEZING && $558228835489ffff$var$REQUIRED && $558228835489ffff$var$isExtensible(it) && !$558228835489ffff$var$hasOwn$3(it, $558228835489ffff$var$METADATA)) $558228835489ffff$var$setMetadata(it);
    return it;
};
var $558228835489ffff$var$enable = function() {
    $558228835489ffff$var$meta.enable = function() {};
    $558228835489ffff$var$REQUIRED = true;
    var getOwnPropertyNames = $558228835489ffff$var$getOwnPropertyNamesModule.f;
    var splice = $558228835489ffff$var$uncurryThis$1([].splice);
    var test = {};
    test[$558228835489ffff$var$METADATA] = 1;
    // prevent exposing of metadata key
    if (getOwnPropertyNames(test).length) {
        $558228835489ffff$var$getOwnPropertyNamesModule.f = function(it) {
            var result = getOwnPropertyNames(it);
            for(var i = 0, length = result.length; i < length; i++)if (result[i] === $558228835489ffff$var$METADATA) {
                splice(result, i, 1);
                break;
            }
            return result;
        };
        $558228835489ffff$var$$$3({
            target: 'Object',
            stat: true,
            forced: true
        }, {
            getOwnPropertyNames: $558228835489ffff$var$getOwnPropertyNamesExternalModule.f
        });
    }
};
var $558228835489ffff$var$meta = $558228835489ffff$var$internalMetadata.exports = {
    enable: $558228835489ffff$var$enable,
    fastKey: $558228835489ffff$var$fastKey$1,
    getWeakData: $558228835489ffff$var$getWeakData,
    onFreeze: $558228835489ffff$var$onFreeze
};
$558228835489ffff$var$hiddenKeys[$558228835489ffff$var$METADATA] = true;
var $558228835489ffff$var$internalMetadataExports = $558228835489ffff$var$internalMetadata.exports;
var $558228835489ffff$var$$$2 = $558228835489ffff$var$_export;
var $558228835489ffff$var$global$1 = $558228835489ffff$var$global$p;
var $558228835489ffff$var$InternalMetadataModule = $558228835489ffff$var$internalMetadataExports;
var $558228835489ffff$var$fails$1 = $558228835489ffff$var$fails$u;
var $558228835489ffff$var$createNonEnumerableProperty = $558228835489ffff$var$createNonEnumerableProperty$9;
var $558228835489ffff$var$iterate$1 = $558228835489ffff$var$iterate$7;
var $558228835489ffff$var$anInstance$1 = $558228835489ffff$var$anInstance$3;
var $558228835489ffff$var$isCallable = $558228835489ffff$var$isCallable$m;
var $558228835489ffff$var$isObject = $558228835489ffff$var$isObject$h;
var $558228835489ffff$var$isNullOrUndefined$1 = $558228835489ffff$var$isNullOrUndefined$6;
var $558228835489ffff$var$setToStringTag = $558228835489ffff$var$setToStringTag$7;
var $558228835489ffff$var$defineProperty = $558228835489ffff$var$objectDefineProperty.f;
var $558228835489ffff$var$forEach = $558228835489ffff$var$arrayIteration.forEach;
var $558228835489ffff$var$DESCRIPTORS$1 = $558228835489ffff$var$descriptors;
var $558228835489ffff$var$InternalStateModule$1 = $558228835489ffff$var$internalState;
var $558228835489ffff$var$setInternalState$1 = $558228835489ffff$var$InternalStateModule$1.set;
var $558228835489ffff$var$internalStateGetterFor$1 = $558228835489ffff$var$InternalStateModule$1.getterFor;
var $558228835489ffff$var$collection$2 = function(CONSTRUCTOR_NAME, wrapper, common) {
    var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
    var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
    var ADDER = IS_MAP ? 'set' : 'add';
    var NativeConstructor = $558228835489ffff$var$global$1[CONSTRUCTOR_NAME];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    var exported = {};
    var Constructor;
    if (!$558228835489ffff$var$DESCRIPTORS$1 || !$558228835489ffff$var$isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !$558228835489ffff$var$fails$1(function() {
        new NativeConstructor().entries().next();
    }))) {
        // create collection constructor
        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
        $558228835489ffff$var$InternalMetadataModule.enable();
    } else {
        Constructor = wrapper(function(target, iterable) {
            $558228835489ffff$var$setInternalState$1($558228835489ffff$var$anInstance$1(target, Prototype), {
                type: CONSTRUCTOR_NAME,
                collection: new NativeConstructor()
            });
            if (!$558228835489ffff$var$isNullOrUndefined$1(iterable)) $558228835489ffff$var$iterate$1(iterable, target[ADDER], {
                that: target,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $558228835489ffff$var$internalStateGetterFor$1(CONSTRUCTOR_NAME);
        $558228835489ffff$var$forEach([
            'add',
            'clear',
            'delete',
            'forEach',
            'get',
            'has',
            'set',
            'keys',
            'values',
            'entries'
        ], function(KEY) {
            var IS_ADDER = KEY === 'add' || KEY === 'set';
            if (KEY in NativePrototype && !(IS_WEAK && KEY === 'clear')) $558228835489ffff$var$createNonEnumerableProperty(Prototype, KEY, function(a, b) {
                var collection = getInternalState(this).collection;
                if (!IS_ADDER && IS_WEAK && !$558228835489ffff$var$isObject(a)) return KEY === 'get' ? undefined : false;
                var result = collection[KEY](a === 0 ? 0 : a, b);
                return IS_ADDER ? this : result;
            });
        });
        IS_WEAK || $558228835489ffff$var$defineProperty(Prototype, 'size', {
            configurable: true,
            get: function() {
                return getInternalState(this).collection.size;
            }
        });
    }
    $558228835489ffff$var$setToStringTag(Constructor, CONSTRUCTOR_NAME, false, true);
    exported[CONSTRUCTOR_NAME] = Constructor;
    $558228835489ffff$var$$$2({
        global: true,
        forced: true
    }, exported);
    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
    return Constructor;
};
var $558228835489ffff$var$defineBuiltIn = $558228835489ffff$var$defineBuiltIn$6;
var $558228835489ffff$var$defineBuiltIns$1 = function(target, src, options) {
    for(var key in src)if (options && options.unsafe && target[key]) target[key] = src[key];
    else $558228835489ffff$var$defineBuiltIn(target, key, src[key], options);
    return target;
};
var $558228835489ffff$var$create = $558228835489ffff$var$objectCreate;
var $558228835489ffff$var$defineBuiltInAccessor = $558228835489ffff$var$defineBuiltInAccessor$3;
var $558228835489ffff$var$defineBuiltIns = $558228835489ffff$var$defineBuiltIns$1;
var $558228835489ffff$var$bind = $558228835489ffff$var$functionBindContext;
var $558228835489ffff$var$anInstance = $558228835489ffff$var$anInstance$3;
var $558228835489ffff$var$isNullOrUndefined = $558228835489ffff$var$isNullOrUndefined$6;
var $558228835489ffff$var$iterate = $558228835489ffff$var$iterate$7;
var $558228835489ffff$var$defineIterator = $558228835489ffff$var$iteratorDefine;
var $558228835489ffff$var$createIterResultObject = $558228835489ffff$var$createIterResultObject$3;
var $558228835489ffff$var$setSpecies = $558228835489ffff$var$setSpecies$2;
var $558228835489ffff$var$DESCRIPTORS = $558228835489ffff$var$descriptors;
var $558228835489ffff$var$fastKey = $558228835489ffff$var$internalMetadataExports.fastKey;
var $558228835489ffff$var$InternalStateModule = $558228835489ffff$var$internalState;
var $558228835489ffff$var$setInternalState = $558228835489ffff$var$InternalStateModule.set;
var $558228835489ffff$var$internalStateGetterFor = $558228835489ffff$var$InternalStateModule.getterFor;
var $558228835489ffff$var$collectionStrong$2 = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $558228835489ffff$var$anInstance(that, Prototype);
            $558228835489ffff$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                index: $558228835489ffff$var$create(null),
                first: undefined,
                last: undefined,
                size: 0
            });
            if (!$558228835489ffff$var$DESCRIPTORS) that.size = 0;
            if (!$558228835489ffff$var$isNullOrUndefined(iterable)) $558228835489ffff$var$iterate(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $558228835489ffff$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var entry = getEntry(that, key);
            var previous, index;
            // change existing entry
            if (entry) entry.value = value;
            else {
                state.last = entry = {
                    index: index = $558228835489ffff$var$fastKey(key, true),
                    key: key,
                    value: value,
                    previous: previous = state.last,
                    next: undefined,
                    removed: false
                };
                if (!state.first) state.first = entry;
                if (previous) previous.next = entry;
                if ($558228835489ffff$var$DESCRIPTORS) state.size++;
                else that.size++;
                // add to index
                if (index !== 'F') state.index[index] = entry;
            }
            return that;
        };
        var getEntry = function(that, key) {
            var state = getInternalState(that);
            // fast case
            var index = $558228835489ffff$var$fastKey(key);
            var entry;
            if (index !== 'F') return state.index[index];
            // frozen object case
            for(entry = state.first; entry; entry = entry.next){
                if (entry.key === key) return entry;
            }
        };
        $558228835489ffff$var$defineBuiltIns(Prototype, {
            // `{ Map, Set }.prototype.clear()` methods
            // https://tc39.es/ecma262/#sec-map.prototype.clear
            // https://tc39.es/ecma262/#sec-set.prototype.clear
            clear: function clear() {
                var that = this;
                var state = getInternalState(that);
                var data = state.index;
                var entry = state.first;
                while(entry){
                    entry.removed = true;
                    if (entry.previous) entry.previous = entry.previous.next = undefined;
                    delete data[entry.index];
                    entry = entry.next;
                }
                state.first = state.last = undefined;
                if ($558228835489ffff$var$DESCRIPTORS) state.size = 0;
                else that.size = 0;
            },
            // `{ Map, Set }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.delete
            // https://tc39.es/ecma262/#sec-set.prototype.delete
            'delete': function(key) {
                var that = this;
                var state = getInternalState(that);
                var entry = getEntry(that, key);
                if (entry) {
                    var next = entry.next;
                    var prev = entry.previous;
                    delete state.index[entry.index];
                    entry.removed = true;
                    if (prev) prev.next = next;
                    if (next) next.previous = prev;
                    if (state.first === entry) state.first = next;
                    if (state.last === entry) state.last = prev;
                    if ($558228835489ffff$var$DESCRIPTORS) state.size--;
                    else that.size--;
                }
                return !!entry;
            },
            // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.foreach
            // https://tc39.es/ecma262/#sec-set.prototype.foreach
            forEach: function forEach(callbackfn /* , that = undefined */ ) {
                var state = getInternalState(this);
                var boundFunction = $558228835489ffff$var$bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                var entry;
                while(entry = entry ? entry.next : state.first){
                    boundFunction(entry.value, entry.key, this);
                    // revert to the last existing entry
                    while(entry && entry.removed)entry = entry.previous;
                }
            },
            // `{ Map, Set}.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.has
            // https://tc39.es/ecma262/#sec-set.prototype.has
            has: function has(key) {
                return !!getEntry(this, key);
            }
        });
        $558228835489ffff$var$defineBuiltIns(Prototype, IS_MAP ? {
            // `Map.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-map.prototype.get
            get: function get(key) {
                var entry = getEntry(this, key);
                return entry && entry.value;
            },
            // `Map.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-map.prototype.set
            set: function set(key, value) {
                return define(this, key === 0 ? 0 : key, value);
            }
        } : {
            // `Set.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-set.prototype.add
            add: function add(value) {
                return define(this, value = value === 0 ? 0 : value, value);
            }
        });
        if ($558228835489ffff$var$DESCRIPTORS) $558228835489ffff$var$defineBuiltInAccessor(Prototype, 'size', {
            configurable: true,
            get: function() {
                return getInternalState(this).size;
            }
        });
        return Constructor;
    },
    setStrong: function(Constructor, CONSTRUCTOR_NAME, IS_MAP) {
        var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
        var getInternalCollectionState = $558228835489ffff$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var getInternalIteratorState = $558228835489ffff$var$internalStateGetterFor(ITERATOR_NAME);
        // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
        // https://tc39.es/ecma262/#sec-map.prototype.entries
        // https://tc39.es/ecma262/#sec-map.prototype.keys
        // https://tc39.es/ecma262/#sec-map.prototype.values
        // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
        // https://tc39.es/ecma262/#sec-set.prototype.entries
        // https://tc39.es/ecma262/#sec-set.prototype.keys
        // https://tc39.es/ecma262/#sec-set.prototype.values
        // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
        $558228835489ffff$var$defineIterator(Constructor, CONSTRUCTOR_NAME, function(iterated, kind) {
            $558228835489ffff$var$setInternalState(this, {
                type: ITERATOR_NAME,
                target: iterated,
                state: getInternalCollectionState(iterated),
                kind: kind,
                last: undefined
            });
        }, function() {
            var state = getInternalIteratorState(this);
            var kind = state.kind;
            var entry = state.last;
            // revert to the last existing entry
            while(entry && entry.removed)entry = entry.previous;
            // get next entry
            if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
                // or finish the iteration
                state.target = undefined;
                return $558228835489ffff$var$createIterResultObject(undefined, true);
            }
            // return step by kind
            if (kind === 'keys') return $558228835489ffff$var$createIterResultObject(entry.key, false);
            if (kind === 'values') return $558228835489ffff$var$createIterResultObject(entry.value, false);
            return $558228835489ffff$var$createIterResultObject([
                entry.key,
                entry.value
            ], false);
        }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
        // `{ Map, Set }.prototype[@@species]` accessors
        // https://tc39.es/ecma262/#sec-get-map-@@species
        // https://tc39.es/ecma262/#sec-get-set-@@species
        $558228835489ffff$var$setSpecies(CONSTRUCTOR_NAME);
    }
};
var $558228835489ffff$var$collection$1 = $558228835489ffff$var$collection$2;
var $558228835489ffff$var$collectionStrong$1 = $558228835489ffff$var$collectionStrong$2;
// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
$558228835489ffff$var$collection$1('Map', function(init) {
    return function Map1() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, $558228835489ffff$var$collectionStrong$1);
var $558228835489ffff$var$path$1 = $558228835489ffff$var$path$o;
var $558228835489ffff$var$map$2 = $558228835489ffff$var$path$1.Map;
var $558228835489ffff$var$parent$9 = $558228835489ffff$var$map$2;
var $558228835489ffff$var$map$1 = $558228835489ffff$var$parent$9;
var $558228835489ffff$var$map = $558228835489ffff$var$map$1;
var $558228835489ffff$var$_Map = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$map);
var $558228835489ffff$var$$$1 = $558228835489ffff$var$_export;
var $558228835489ffff$var$$some = $558228835489ffff$var$arrayIteration.some;
var $558228835489ffff$var$arrayMethodIsStrict$1 = $558228835489ffff$var$arrayMethodIsStrict$4;
var $558228835489ffff$var$STRICT_METHOD$1 = $558228835489ffff$var$arrayMethodIsStrict$1('some');
// `Array.prototype.some` method
// https://tc39.es/ecma262/#sec-array.prototype.some
$558228835489ffff$var$$$1({
    target: 'Array',
    proto: true,
    forced: !$558228835489ffff$var$STRICT_METHOD$1
}, {
    some: function some(callbackfn /* , thisArg */ ) {
        return $558228835489ffff$var$$some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
var $558228835489ffff$var$getBuiltInPrototypeMethod$4 = $558228835489ffff$var$getBuiltInPrototypeMethod$g;
var $558228835489ffff$var$some$3 = $558228835489ffff$var$getBuiltInPrototypeMethod$4('Array', 'some');
var $558228835489ffff$var$isPrototypeOf$4 = $558228835489ffff$var$objectIsPrototypeOf;
var $558228835489ffff$var$method$4 = $558228835489ffff$var$some$3;
var $558228835489ffff$var$ArrayPrototype$4 = Array.prototype;
var $558228835489ffff$var$some$2 = function(it) {
    var own = it.some;
    return it === $558228835489ffff$var$ArrayPrototype$4 || $558228835489ffff$var$isPrototypeOf$4($558228835489ffff$var$ArrayPrototype$4, it) && own === $558228835489ffff$var$ArrayPrototype$4.some ? $558228835489ffff$var$method$4 : own;
};
var $558228835489ffff$var$parent$8 = $558228835489ffff$var$some$2;
var $558228835489ffff$var$some$1 = $558228835489ffff$var$parent$8;
var $558228835489ffff$var$some = $558228835489ffff$var$some$1;
var $558228835489ffff$var$_someInstanceProperty = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$some);
var $558228835489ffff$var$getBuiltInPrototypeMethod$3 = $558228835489ffff$var$getBuiltInPrototypeMethod$g;
var $558228835489ffff$var$keys$3 = $558228835489ffff$var$getBuiltInPrototypeMethod$3('Array', 'keys');
var $558228835489ffff$var$parent$7 = $558228835489ffff$var$keys$3;
var $558228835489ffff$var$keys$2 = $558228835489ffff$var$parent$7;
var $558228835489ffff$var$classof$2 = $558228835489ffff$var$classof$d;
var $558228835489ffff$var$hasOwn$2 = $558228835489ffff$var$hasOwnProperty_1;
var $558228835489ffff$var$isPrototypeOf$3 = $558228835489ffff$var$objectIsPrototypeOf;
var $558228835489ffff$var$method$3 = $558228835489ffff$var$keys$2;
var $558228835489ffff$var$ArrayPrototype$3 = Array.prototype;
var $558228835489ffff$var$DOMIterables$2 = {
    DOMTokenList: true,
    NodeList: true
};
var $558228835489ffff$var$keys$1 = function(it) {
    var own = it.keys;
    return it === $558228835489ffff$var$ArrayPrototype$3 || $558228835489ffff$var$isPrototypeOf$3($558228835489ffff$var$ArrayPrototype$3, it) && own === $558228835489ffff$var$ArrayPrototype$3.keys || $558228835489ffff$var$hasOwn$2($558228835489ffff$var$DOMIterables$2, $558228835489ffff$var$classof$2(it)) ? $558228835489ffff$var$method$3 : own;
};
var $558228835489ffff$var$keys = $558228835489ffff$var$keys$1;
var $558228835489ffff$var$_keysInstanceProperty = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$keys);
var $558228835489ffff$var$arraySlice = $558228835489ffff$var$arraySliceSimple;
var $558228835489ffff$var$floor = Math.floor;
var $558228835489ffff$var$mergeSort = function(array, comparefn) {
    var length = array.length;
    var middle = $558228835489ffff$var$floor(length / 2);
    return length < 8 ? $558228835489ffff$var$insertionSort(array, comparefn) : $558228835489ffff$var$merge(array, $558228835489ffff$var$mergeSort($558228835489ffff$var$arraySlice(array, 0, middle), comparefn), $558228835489ffff$var$mergeSort($558228835489ffff$var$arraySlice(array, middle), comparefn), comparefn);
};
var $558228835489ffff$var$insertionSort = function(array, comparefn) {
    var length = array.length;
    var i = 1;
    var element, j;
    while(i < length){
        j = i;
        element = array[i];
        while(j && comparefn(array[j - 1], element) > 0)array[j] = array[--j];
        if (j !== i++) array[j] = element;
    }
    return array;
};
var $558228835489ffff$var$merge = function(array, left, right, comparefn) {
    var llength = left.length;
    var rlength = right.length;
    var lindex = 0;
    var rindex = 0;
    while(lindex < llength || rindex < rlength)array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
    return array;
};
var $558228835489ffff$var$arraySort = $558228835489ffff$var$mergeSort;
var $558228835489ffff$var$userAgent$1 = $558228835489ffff$var$engineUserAgent;
var $558228835489ffff$var$firefox = $558228835489ffff$var$userAgent$1.match(/firefox\/(\d+)/i);
var $558228835489ffff$var$engineFfVersion = !!$558228835489ffff$var$firefox && +$558228835489ffff$var$firefox[1];
var $558228835489ffff$var$UA = $558228835489ffff$var$engineUserAgent;
var $558228835489ffff$var$engineIsIeOrEdge = /MSIE|Trident/.test($558228835489ffff$var$UA);
var $558228835489ffff$var$userAgent = $558228835489ffff$var$engineUserAgent;
var $558228835489ffff$var$webkit = $558228835489ffff$var$userAgent.match(/AppleWebKit\/(\d+)\./);
var $558228835489ffff$var$engineWebkitVersion = !!$558228835489ffff$var$webkit && +$558228835489ffff$var$webkit[1];
var $558228835489ffff$var$$ = $558228835489ffff$var$_export;
var $558228835489ffff$var$uncurryThis = $558228835489ffff$var$functionUncurryThis;
var $558228835489ffff$var$aCallable = $558228835489ffff$var$aCallable$e;
var $558228835489ffff$var$toObject = $558228835489ffff$var$toObject$e;
var $558228835489ffff$var$lengthOfArrayLike = $558228835489ffff$var$lengthOfArrayLike$d;
var $558228835489ffff$var$deletePropertyOrThrow = $558228835489ffff$var$deletePropertyOrThrow$2;
var $558228835489ffff$var$toString = $558228835489ffff$var$toString$7;
var $558228835489ffff$var$fails = $558228835489ffff$var$fails$u;
var $558228835489ffff$var$internalSort = $558228835489ffff$var$arraySort;
var $558228835489ffff$var$arrayMethodIsStrict = $558228835489ffff$var$arrayMethodIsStrict$4;
var $558228835489ffff$var$FF = $558228835489ffff$var$engineFfVersion;
var $558228835489ffff$var$IE_OR_EDGE = $558228835489ffff$var$engineIsIeOrEdge;
var $558228835489ffff$var$V8 = $558228835489ffff$var$engineV8Version;
var $558228835489ffff$var$WEBKIT = $558228835489ffff$var$engineWebkitVersion;
var $558228835489ffff$var$test = [];
var $558228835489ffff$var$nativeSort = $558228835489ffff$var$uncurryThis($558228835489ffff$var$test.sort);
var $558228835489ffff$var$push = $558228835489ffff$var$uncurryThis($558228835489ffff$var$test.push);
// IE8-
var $558228835489ffff$var$FAILS_ON_UNDEFINED = $558228835489ffff$var$fails(function() {
    $558228835489ffff$var$test.sort(undefined);
});
// V8 bug
var $558228835489ffff$var$FAILS_ON_NULL = $558228835489ffff$var$fails(function() {
    $558228835489ffff$var$test.sort(null);
});
// Old WebKit
var $558228835489ffff$var$STRICT_METHOD = $558228835489ffff$var$arrayMethodIsStrict('sort');
var $558228835489ffff$var$STABLE_SORT = !$558228835489ffff$var$fails(function() {
    // feature detection can be too slow, so check engines versions
    if ($558228835489ffff$var$V8) return $558228835489ffff$var$V8 < 70;
    if ($558228835489ffff$var$FF && $558228835489ffff$var$FF > 3) return;
    if ($558228835489ffff$var$IE_OR_EDGE) return true;
    if ($558228835489ffff$var$WEBKIT) return $558228835489ffff$var$WEBKIT < 603;
    var result = '';
    var code, chr, value, index;
    // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
    for(code = 65; code < 76; code++){
        chr = String.fromCharCode(code);
        switch(code){
            case 66:
            case 69:
            case 70:
            case 72:
                value = 3;
                break;
            case 68:
            case 71:
                value = 4;
                break;
            default:
                value = 2;
        }
        for(index = 0; index < 47; index++)$558228835489ffff$var$test.push({
            k: chr + index,
            v: value
        });
    }
    $558228835489ffff$var$test.sort(function(a, b) {
        return b.v - a.v;
    });
    for(index = 0; index < $558228835489ffff$var$test.length; index++){
        chr = $558228835489ffff$var$test[index].k.charAt(0);
        if (result.charAt(result.length - 1) !== chr) result += chr;
    }
    return result !== 'DGBEFHACIJK';
});
var $558228835489ffff$var$FORCED = $558228835489ffff$var$FAILS_ON_UNDEFINED || !$558228835489ffff$var$FAILS_ON_NULL || !$558228835489ffff$var$STRICT_METHOD || !$558228835489ffff$var$STABLE_SORT;
var $558228835489ffff$var$getSortCompare = function(comparefn) {
    return function(x, y) {
        if (y === undefined) return -1;
        if (x === undefined) return 1;
        if (comparefn !== undefined) return +comparefn(x, y) || 0;
        return $558228835489ffff$var$toString(x) > $558228835489ffff$var$toString(y) ? 1 : -1;
    };
};
// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$558228835489ffff$var$$({
    target: 'Array',
    proto: true,
    forced: $558228835489ffff$var$FORCED
}, {
    sort: function sort(comparefn) {
        if (comparefn !== undefined) $558228835489ffff$var$aCallable(comparefn);
        var array = $558228835489ffff$var$toObject(this);
        if ($558228835489ffff$var$STABLE_SORT) return comparefn === undefined ? $558228835489ffff$var$nativeSort(array) : $558228835489ffff$var$nativeSort(array, comparefn);
        var items = [];
        var arrayLength = $558228835489ffff$var$lengthOfArrayLike(array);
        var itemsLength, index;
        for(index = 0; index < arrayLength; index++)if (index in array) $558228835489ffff$var$push(items, array[index]);
        $558228835489ffff$var$internalSort(items, $558228835489ffff$var$getSortCompare(comparefn));
        itemsLength = $558228835489ffff$var$lengthOfArrayLike(items);
        index = 0;
        while(index < itemsLength)array[index] = items[index++];
        while(index < arrayLength)$558228835489ffff$var$deletePropertyOrThrow(array, index++);
        return array;
    }
});
var $558228835489ffff$var$getBuiltInPrototypeMethod$2 = $558228835489ffff$var$getBuiltInPrototypeMethod$g;
var $558228835489ffff$var$sort$3 = $558228835489ffff$var$getBuiltInPrototypeMethod$2('Array', 'sort');
var $558228835489ffff$var$isPrototypeOf$2 = $558228835489ffff$var$objectIsPrototypeOf;
var $558228835489ffff$var$method$2 = $558228835489ffff$var$sort$3;
var $558228835489ffff$var$ArrayPrototype$2 = Array.prototype;
var $558228835489ffff$var$sort$2 = function(it) {
    var own = it.sort;
    return it === $558228835489ffff$var$ArrayPrototype$2 || $558228835489ffff$var$isPrototypeOf$2($558228835489ffff$var$ArrayPrototype$2, it) && own === $558228835489ffff$var$ArrayPrototype$2.sort ? $558228835489ffff$var$method$2 : own;
};
var $558228835489ffff$var$parent$6 = $558228835489ffff$var$sort$2;
var $558228835489ffff$var$sort$1 = $558228835489ffff$var$parent$6;
var $558228835489ffff$var$sort = $558228835489ffff$var$sort$1;
var $558228835489ffff$var$_sortInstanceProperty = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$sort);
var $558228835489ffff$var$getBuiltInPrototypeMethod$1 = $558228835489ffff$var$getBuiltInPrototypeMethod$g;
var $558228835489ffff$var$values$3 = $558228835489ffff$var$getBuiltInPrototypeMethod$1('Array', 'values');
var $558228835489ffff$var$parent$5 = $558228835489ffff$var$values$3;
var $558228835489ffff$var$values$2 = $558228835489ffff$var$parent$5;
var $558228835489ffff$var$classof$1 = $558228835489ffff$var$classof$d;
var $558228835489ffff$var$hasOwn$1 = $558228835489ffff$var$hasOwnProperty_1;
var $558228835489ffff$var$isPrototypeOf$1 = $558228835489ffff$var$objectIsPrototypeOf;
var $558228835489ffff$var$method$1 = $558228835489ffff$var$values$2;
var $558228835489ffff$var$ArrayPrototype$1 = Array.prototype;
var $558228835489ffff$var$DOMIterables$1 = {
    DOMTokenList: true,
    NodeList: true
};
var $558228835489ffff$var$values$1 = function(it) {
    var own = it.values;
    return it === $558228835489ffff$var$ArrayPrototype$1 || $558228835489ffff$var$isPrototypeOf$1($558228835489ffff$var$ArrayPrototype$1, it) && own === $558228835489ffff$var$ArrayPrototype$1.values || $558228835489ffff$var$hasOwn$1($558228835489ffff$var$DOMIterables$1, $558228835489ffff$var$classof$1(it)) ? $558228835489ffff$var$method$1 : own;
};
var $558228835489ffff$var$values = $558228835489ffff$var$values$1;
var $558228835489ffff$var$_valuesInstanceProperty = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$values);
var $558228835489ffff$var$iterator = $558228835489ffff$var$iterator$4;
var $558228835489ffff$var$_Symbol$iterator = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$iterator);
var $558228835489ffff$var$getBuiltInPrototypeMethod = $558228835489ffff$var$getBuiltInPrototypeMethod$g;
var $558228835489ffff$var$entries$3 = $558228835489ffff$var$getBuiltInPrototypeMethod('Array', 'entries');
var $558228835489ffff$var$parent$4 = $558228835489ffff$var$entries$3;
var $558228835489ffff$var$entries$2 = $558228835489ffff$var$parent$4;
var $558228835489ffff$var$classof = $558228835489ffff$var$classof$d;
var $558228835489ffff$var$hasOwn = $558228835489ffff$var$hasOwnProperty_1;
var $558228835489ffff$var$isPrototypeOf = $558228835489ffff$var$objectIsPrototypeOf;
var $558228835489ffff$var$method = $558228835489ffff$var$entries$2;
var $558228835489ffff$var$ArrayPrototype = Array.prototype;
var $558228835489ffff$var$DOMIterables = {
    DOMTokenList: true,
    NodeList: true
};
var $558228835489ffff$var$entries$1 = function(it) {
    var own = it.entries;
    return it === $558228835489ffff$var$ArrayPrototype || $558228835489ffff$var$isPrototypeOf($558228835489ffff$var$ArrayPrototype, it) && own === $558228835489ffff$var$ArrayPrototype.entries || $558228835489ffff$var$hasOwn($558228835489ffff$var$DOMIterables, $558228835489ffff$var$classof(it)) ? $558228835489ffff$var$method : own;
};
var $558228835489ffff$var$entries = $558228835489ffff$var$entries$1;
var $558228835489ffff$var$_entriesInstanceProperty = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$entries);
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $558228835489ffff$var$getRandomValues;
const $558228835489ffff$var$rnds8 = new Uint8Array(16);
function $558228835489ffff$var$rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$558228835489ffff$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $558228835489ffff$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$558228835489ffff$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $558228835489ffff$var$getRandomValues($558228835489ffff$var$rnds8);
}
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $558228835489ffff$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$558228835489ffff$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $558228835489ffff$var$unsafeStringify(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $558228835489ffff$var$byteToHex[arr[offset + 0]] + $558228835489ffff$var$byteToHex[arr[offset + 1]] + $558228835489ffff$var$byteToHex[arr[offset + 2]] + $558228835489ffff$var$byteToHex[arr[offset + 3]] + '-' + $558228835489ffff$var$byteToHex[arr[offset + 4]] + $558228835489ffff$var$byteToHex[arr[offset + 5]] + '-' + $558228835489ffff$var$byteToHex[arr[offset + 6]] + $558228835489ffff$var$byteToHex[arr[offset + 7]] + '-' + $558228835489ffff$var$byteToHex[arr[offset + 8]] + $558228835489ffff$var$byteToHex[arr[offset + 9]] + '-' + $558228835489ffff$var$byteToHex[arr[offset + 10]] + $558228835489ffff$var$byteToHex[arr[offset + 11]] + $558228835489ffff$var$byteToHex[arr[offset + 12]] + $558228835489ffff$var$byteToHex[arr[offset + 13]] + $558228835489ffff$var$byteToHex[arr[offset + 14]] + $558228835489ffff$var$byteToHex[arr[offset + 15]];
}
const $558228835489ffff$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $558228835489ffff$var$native = {
    randomUUID: $558228835489ffff$var$randomUUID
};
function $558228835489ffff$var$v4(options, buf, offset) {
    if ($558228835489ffff$var$native.randomUUID && !buf && !options) return $558228835489ffff$var$native.randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || $558228835489ffff$var$rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return $558228835489ffff$var$unsafeStringify(rnds);
}
/**
 * Determine whether a value can be used as an id.
 *
 * @param value - Input value of unknown type.
 * @returns True if the value is valid id, false otherwise.
 */ function $558228835489ffff$var$isId(value) {
    return typeof value === "string" || typeof value === "number";
}
/**
 * A queue.
 *
 * @typeParam T - The type of method names to be replaced by queued versions.
 */ var $558228835489ffff$export$3dc07afe418952bc = /*#__PURE__*/ function() {
    /**
   * Construct a new Queue.
   *
   * @param options - Queue configuration.
   */ function Queue(options) {
        $558228835489ffff$var$_classCallCheck(this, Queue);
        /** Delay in milliseconds. If defined the queue will be periodically flushed. */ /** Maximum number of entries in the queue before it will be flushed. */ $558228835489ffff$var$_defineProperty(this, "_queue", []);
        $558228835489ffff$var$_defineProperty(this, "_timeout", null);
        $558228835489ffff$var$_defineProperty(this, "_extended", null);
        // options
        this.delay = null;
        this.max = Infinity;
        this.setOptions(options);
    }
    /**
   * Update the configuration of the queue.
   *
   * @param options - Queue configuration.
   */ $558228835489ffff$var$_createClass(Queue, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                if (options && typeof options.delay !== "undefined") this.delay = options.delay;
                if (options && typeof options.max !== "undefined") this.max = options.max;
                this._flushIfNeeded();
            }
        },
        {
            key: "destroy",
            value: /**
     * Destroy the queue. The queue will first flush all queued actions, and in case it has extended an object, will restore the original object.
     */ function destroy() {
                this.flush();
                if (this._extended) {
                    var object = this._extended.object;
                    var methods = this._extended.methods;
                    for(var i = 0; i < methods.length; i++){
                        var method = methods[i];
                        if (method.original) // @TODO: better solution?
                        object[method.name] = method.original;
                        else // @TODO: better solution?
                        delete object[method.name];
                    }
                    this._extended = null;
                }
            }
        },
        {
            key: "replace",
            value: function replace(object, method) {
                /* eslint-disable-next-line @typescript-eslint/no-this-alias -- Function this is necessary in the function bellow, so class this has to be saved into a variable here. */ var me = this;
                var original = object[method];
                if (!original) throw new Error("Method " + method + " undefined");
                object[method] = function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    // add this call to the queue
                    me.queue({
                        args: args,
                        fn: original,
                        context: this
                    });
                };
            }
        },
        {
            key: "queue",
            value: function queue(entry) {
                if (typeof entry === "function") this._queue.push({
                    fn: entry
                });
                else this._queue.push(entry);
                this._flushIfNeeded();
            }
        },
        {
            key: "_flushIfNeeded",
            value: function _flushIfNeeded() {
                var _this = this;
                // flush when the maximum is exceeded.
                if (this._queue.length > this.max) this.flush();
                // flush after a period of inactivity when a delay is configured
                if (this._timeout != null) {
                    clearTimeout(this._timeout);
                    this._timeout = null;
                }
                if (this.queue.length > 0 && typeof this.delay === "number") this._timeout = $558228835489ffff$var$_setTimeout(function() {
                    _this.flush();
                }, this.delay);
            }
        },
        {
            key: "flush",
            value: function flush() {
                var _context, _context2;
                $558228835489ffff$var$_forEachInstanceProperty(_context = $558228835489ffff$var$_spliceInstanceProperty(_context2 = this._queue).call(_context2, 0)).call(_context, function(entry) {
                    entry.fn.apply(entry.context || entry.fn, entry.args || []);
                });
            }
        }
    ], [
        {
            key: "extend",
            value: function extend(object, options) {
                var queue = new Queue(options);
                if (object.flush !== undefined) throw new Error("Target object already has a property flush");
                object.flush = function() {
                    queue.flush();
                };
                var methods = [
                    {
                        name: "flush",
                        original: undefined
                    }
                ];
                if (options && options.replace) for(var i = 0; i < options.replace.length; i++){
                    var name = options.replace[i];
                    methods.push({
                        name: name,
                        // @TODO: better solution?
                        original: object[name]
                    });
                    // @TODO: better solution?
                    queue.replace(object, name);
                }
                queue._extended = {
                    object: object,
                    methods: methods
                };
                return queue;
            }
        }
    ]);
    return Queue;
}();
/**
 * {@link DataSet} code that can be reused in {@link DataView} or other similar implementations of {@link DataInterface}.
 *
 * @typeParam Item - Item type that may or may not have an id.
 * @typeParam IdProp - Name of the property that contains the id.
 */ var $558228835489ffff$var$DataSetPart = /*#__PURE__*/ function() {
    function DataSetPart() {
        $558228835489ffff$var$_classCallCheck(this, DataSetPart);
        $558228835489ffff$var$_defineProperty(this, "_subscribers", {
            "*": [],
            add: [],
            remove: [],
            update: []
        });
        /**
     * @deprecated Use on instead (PS: DataView.subscribe === DataView.on).
     */ $558228835489ffff$var$_defineProperty(this, "subscribe", DataSetPart.prototype.on);
        /**
     * @deprecated Use off instead (PS: DataView.unsubscribe === DataView.off).
     */ $558228835489ffff$var$_defineProperty(this, "unsubscribe", DataSetPart.prototype.off);
    }
    $558228835489ffff$var$_createClass(DataSetPart, [
        {
            key: "_trigger",
            value: /**
     * Trigger an event
     *
     * @param event - Event name.
     * @param payload - Event payload.
     * @param senderId - Id of the sender.
     */ function _trigger(event, payload, senderId) {
                var _context, _context2;
                if (event === "*") throw new Error("Cannot trigger event *");
                $558228835489ffff$var$_forEachInstanceProperty(_context = $558228835489ffff$var$_concatInstanceProperty(_context2 = []).call(_context2, $558228835489ffff$var$_toConsumableArray(this._subscribers[event]), $558228835489ffff$var$_toConsumableArray(this._subscribers["*"]))).call(_context, function(subscriber) {
                    subscriber(event, payload, senderId != null ? senderId : null);
                });
            }
        },
        {
            key: "on",
            value: function on(event, callback) {
                if (typeof callback === "function") this._subscribers[event].push(callback);
            // @TODO: Maybe throw for invalid callbacks?
            }
        },
        {
            key: "off",
            value: function off(event, callback) {
                var _context3;
                this._subscribers[event] = $558228835489ffff$var$_filterInstanceProperty(_context3 = this._subscribers[event]).call(_context3, function(subscriber) {
                    return subscriber !== callback;
                });
            }
        }
    ]);
    return DataSetPart;
}();
var $558228835489ffff$var$collection = $558228835489ffff$var$collection$2;
var $558228835489ffff$var$collectionStrong = $558228835489ffff$var$collectionStrong$2;
// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
$558228835489ffff$var$collection('Set', function(init) {
    return function Set() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, $558228835489ffff$var$collectionStrong);
var $558228835489ffff$var$path = $558228835489ffff$var$path$o;
var $558228835489ffff$var$set$2 = $558228835489ffff$var$path.Set;
var $558228835489ffff$var$parent$3 = $558228835489ffff$var$set$2;
var $558228835489ffff$var$set$1 = $558228835489ffff$var$parent$3;
var $558228835489ffff$var$set = $558228835489ffff$var$set$1;
var $558228835489ffff$var$_Set = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$set);
var $558228835489ffff$var$getIterator$5 = $558228835489ffff$var$getIterator$8;
var $558228835489ffff$var$getIterator_1 = $558228835489ffff$var$getIterator$5;
var $558228835489ffff$var$parent$2 = $558228835489ffff$var$getIterator_1;
var $558228835489ffff$var$getIterator$4 = $558228835489ffff$var$parent$2;
var $558228835489ffff$var$parent$1 = $558228835489ffff$var$getIterator$4;
var $558228835489ffff$var$getIterator$3 = $558228835489ffff$var$parent$1;
var $558228835489ffff$var$parent = $558228835489ffff$var$getIterator$3;
var $558228835489ffff$var$getIterator$2 = $558228835489ffff$var$parent;
var $558228835489ffff$var$getIterator$1 = $558228835489ffff$var$getIterator$2;
var $558228835489ffff$var$getIterator = $558228835489ffff$var$getIterator$1;
var $558228835489ffff$var$_getIterator = /*@__PURE__*/ $558228835489ffff$var$getDefaultExportFromCjs($558228835489ffff$var$getIterator);
function $558228835489ffff$var$_createForOfIteratorHelper$2(o, allowArrayLike) {
    var it = typeof $558228835489ffff$var$_Symbol !== "undefined" && $558228835489ffff$var$_getIteratorMethod(o) || o["@@iterator"];
    if (!it) {
        if ($558228835489ffff$var$_Array$isArray(o) || (it = $558228835489ffff$var$_unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $558228835489ffff$var$_unsupportedIterableToArray$2(o, minLen) {
    var _context10;
    if (!o) return;
    if (typeof o === "string") return $558228835489ffff$var$_arrayLikeToArray$2(o, minLen);
    var n = $558228835489ffff$var$_sliceInstanceProperty(_context10 = Object.prototype.toString.call(o)).call(_context10, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return $558228835489ffff$var$_Array$from$1(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $558228835489ffff$var$_arrayLikeToArray$2(o, minLen);
}
function $558228835489ffff$var$_arrayLikeToArray$2(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * Data stream
 *
 * @remarks
 * {@link DataStream} offers an always up to date stream of items from a {@link DataSet} or {@link DataView}.
 * That means that the stream is evaluated at the time of iteration, conversion to another data type or when {@link cache} is called, not when the {@link DataStream} was created.
 * Multiple invocations of for example {@link toItemArray} may yield different results (if the data source like for example {@link DataSet} gets modified).
 * @typeParam Item - The item type this stream is going to work with.
 */ var $558228835489ffff$export$521135ae501c2f0e = /*#__PURE__*/ function(_Symbol$iterator$1) {
    /**
   * Create a new data stream.
   *
   * @param pairs - The id, item pairs.
   */ function DataStream(pairs) {
        $558228835489ffff$var$_classCallCheck(this, DataStream);
        this._pairs = pairs;
    }
    /**
   * Return an iterable of key, value pairs for every entry in the stream.
   */ $558228835489ffff$var$_createClass(DataStream, [
        {
            key: _Symbol$iterator$1,
            value: /*#__PURE__*/ $558228835489ffff$var$_regeneratorRuntime.mark(function value() {
                var _iterator, _step, _step$value, id, item;
                return $558228835489ffff$var$_regeneratorRuntime.wrap(function value$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            _iterator = $558228835489ffff$var$_createForOfIteratorHelper$2(this._pairs);
                            _context.prev = 1;
                            _iterator.s();
                        case 3:
                            if ((_step = _iterator.n()).done) {
                                _context.next = 9;
                                break;
                            }
                            _step$value = $558228835489ffff$var$_slicedToArray(_step.value, 2), id = _step$value[0], item = _step$value[1];
                            _context.next = 7;
                            return [
                                id,
                                item
                            ];
                        case 7:
                            _context.next = 3;
                            break;
                        case 9:
                            _context.next = 14;
                            break;
                        case 11:
                            _context.prev = 11;
                            _context.t0 = _context["catch"](1);
                            _iterator.e(_context.t0);
                        case 14:
                            _context.prev = 14;
                            _iterator.f();
                            return _context.finish(14);
                        case 17:
                        case "end":
                            return _context.stop();
                    }
                }, value, this, [
                    [
                        1,
                        11,
                        14,
                        17
                    ]
                ]);
            })
        },
        {
            key: "entries",
            value: /*#__PURE__*/ $558228835489ffff$var$_regeneratorRuntime.mark(function entries() {
                var _iterator2, _step2, _step2$value, id, item;
                return $558228835489ffff$var$_regeneratorRuntime.wrap(function entries$(_context2) {
                    while(true)switch(_context2.prev = _context2.next){
                        case 0:
                            _iterator2 = $558228835489ffff$var$_createForOfIteratorHelper$2(this._pairs);
                            _context2.prev = 1;
                            _iterator2.s();
                        case 3:
                            if ((_step2 = _iterator2.n()).done) {
                                _context2.next = 9;
                                break;
                            }
                            _step2$value = $558228835489ffff$var$_slicedToArray(_step2.value, 2), id = _step2$value[0], item = _step2$value[1];
                            _context2.next = 7;
                            return [
                                id,
                                item
                            ];
                        case 7:
                            _context2.next = 3;
                            break;
                        case 9:
                            _context2.next = 14;
                            break;
                        case 11:
                            _context2.prev = 11;
                            _context2.t0 = _context2["catch"](1);
                            _iterator2.e(_context2.t0);
                        case 14:
                            _context2.prev = 14;
                            _iterator2.f();
                            return _context2.finish(14);
                        case 17:
                        case "end":
                            return _context2.stop();
                    }
                }, entries, this, [
                    [
                        1,
                        11,
                        14,
                        17
                    ]
                ]);
            })
        },
        {
            key: "keys",
            value: /*#__PURE__*/ $558228835489ffff$var$_regeneratorRuntime.mark(function keys() {
                var _iterator3, _step3, _step3$value, id;
                return $558228835489ffff$var$_regeneratorRuntime.wrap(function keys$(_context3) {
                    while(true)switch(_context3.prev = _context3.next){
                        case 0:
                            _iterator3 = $558228835489ffff$var$_createForOfIteratorHelper$2(this._pairs);
                            _context3.prev = 1;
                            _iterator3.s();
                        case 3:
                            if ((_step3 = _iterator3.n()).done) {
                                _context3.next = 9;
                                break;
                            }
                            _step3$value = $558228835489ffff$var$_slicedToArray(_step3.value, 1), id = _step3$value[0];
                            _context3.next = 7;
                            return id;
                        case 7:
                            _context3.next = 3;
                            break;
                        case 9:
                            _context3.next = 14;
                            break;
                        case 11:
                            _context3.prev = 11;
                            _context3.t0 = _context3["catch"](1);
                            _iterator3.e(_context3.t0);
                        case 14:
                            _context3.prev = 14;
                            _iterator3.f();
                            return _context3.finish(14);
                        case 17:
                        case "end":
                            return _context3.stop();
                    }
                }, keys, this, [
                    [
                        1,
                        11,
                        14,
                        17
                    ]
                ]);
            })
        },
        {
            key: "values",
            value: /*#__PURE__*/ $558228835489ffff$var$_regeneratorRuntime.mark(function values() {
                var _iterator4, _step4, _step4$value, item;
                return $558228835489ffff$var$_regeneratorRuntime.wrap(function values$(_context4) {
                    while(true)switch(_context4.prev = _context4.next){
                        case 0:
                            _iterator4 = $558228835489ffff$var$_createForOfIteratorHelper$2(this._pairs);
                            _context4.prev = 1;
                            _iterator4.s();
                        case 3:
                            if ((_step4 = _iterator4.n()).done) {
                                _context4.next = 9;
                                break;
                            }
                            _step4$value = $558228835489ffff$var$_slicedToArray(_step4.value, 2), item = _step4$value[1];
                            _context4.next = 7;
                            return item;
                        case 7:
                            _context4.next = 3;
                            break;
                        case 9:
                            _context4.next = 14;
                            break;
                        case 11:
                            _context4.prev = 11;
                            _context4.t0 = _context4["catch"](1);
                            _iterator4.e(_context4.t0);
                        case 14:
                            _context4.prev = 14;
                            _iterator4.f();
                            return _context4.finish(14);
                        case 17:
                        case "end":
                            return _context4.stop();
                    }
                }, values, this, [
                    [
                        1,
                        11,
                        14,
                        17
                    ]
                ]);
            })
        },
        {
            key: "toIdArray",
            value: function toIdArray() {
                var _context5;
                return $558228835489ffff$var$_mapInstanceProperty(_context5 = $558228835489ffff$var$_toConsumableArray(this._pairs)).call(_context5, function(pair) {
                    return pair[0];
                });
            }
        },
        {
            key: "toItemArray",
            value: function toItemArray() {
                var _context6;
                return $558228835489ffff$var$_mapInstanceProperty(_context6 = $558228835489ffff$var$_toConsumableArray(this._pairs)).call(_context6, function(pair) {
                    return pair[1];
                });
            }
        },
        {
            key: "toEntryArray",
            value: function toEntryArray() {
                return $558228835489ffff$var$_toConsumableArray(this._pairs);
            }
        },
        {
            key: "toObjectMap",
            value: function toObjectMap() {
                var map = $558228835489ffff$var$_Object$create$1(null);
                var _iterator5 = $558228835489ffff$var$_createForOfIteratorHelper$2(this._pairs), _step5;
                try {
                    for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                        var _step5$value = $558228835489ffff$var$_slicedToArray(_step5.value, 2), id = _step5$value[0], item = _step5$value[1];
                        map[id] = item;
                    }
                } catch (err) {
                    _iterator5.e(err);
                } finally{
                    _iterator5.f();
                }
                return map;
            }
        },
        {
            key: "toMap",
            value: function toMap() {
                return new $558228835489ffff$var$_Map(this._pairs);
            }
        },
        {
            key: "toIdSet",
            value: function toIdSet() {
                return new $558228835489ffff$var$_Set(this.toIdArray());
            }
        },
        {
            key: "toItemSet",
            value: function toItemSet() {
                return new $558228835489ffff$var$_Set(this.toItemArray());
            }
        },
        {
            key: "cache",
            value: function cache() {
                return new DataStream($558228835489ffff$var$_toConsumableArray(this._pairs));
            }
        },
        {
            key: "distinct",
            value: function distinct(callback) {
                var set = new $558228835489ffff$var$_Set();
                var _iterator6 = $558228835489ffff$var$_createForOfIteratorHelper$2(this._pairs), _step6;
                try {
                    for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                        var _step6$value = $558228835489ffff$var$_slicedToArray(_step6.value, 2), id = _step6$value[0], item = _step6$value[1];
                        set.add(callback(item, id));
                    }
                } catch (err) {
                    _iterator6.e(err);
                } finally{
                    _iterator6.f();
                }
                return set;
            }
        },
        {
            key: "filter",
            value: function filter(callback) {
                var pairs = this._pairs;
                return new DataStream({
                    [$558228835489ffff$var$_Symbol$iterator] () {
                        return /*#__PURE__*/ $558228835489ffff$var$_regeneratorRuntime.mark(function _callee() {
                            var _iterator7, _step7, _step7$value, id, item;
                            return $558228835489ffff$var$_regeneratorRuntime.wrap(function _callee$(_context7) {
                                while(true)switch(_context7.prev = _context7.next){
                                    case 0:
                                        _iterator7 = $558228835489ffff$var$_createForOfIteratorHelper$2(pairs);
                                        _context7.prev = 1;
                                        _iterator7.s();
                                    case 3:
                                        if ((_step7 = _iterator7.n()).done) {
                                            _context7.next = 10;
                                            break;
                                        }
                                        _step7$value = $558228835489ffff$var$_slicedToArray(_step7.value, 2), id = _step7$value[0], item = _step7$value[1];
                                        if (!callback(item, id)) {
                                            _context7.next = 8;
                                            break;
                                        }
                                        _context7.next = 8;
                                        return [
                                            id,
                                            item
                                        ];
                                    case 8:
                                        _context7.next = 3;
                                        break;
                                    case 10:
                                        _context7.next = 15;
                                        break;
                                    case 12:
                                        _context7.prev = 12;
                                        _context7.t0 = _context7["catch"](1);
                                        _iterator7.e(_context7.t0);
                                    case 15:
                                        _context7.prev = 15;
                                        _iterator7.f();
                                        return _context7.finish(15);
                                    case 18:
                                    case "end":
                                        return _context7.stop();
                                }
                            }, _callee, null, [
                                [
                                    1,
                                    12,
                                    15,
                                    18
                                ]
                            ]);
                        })();
                    }
                });
            }
        },
        {
            key: "forEach",
            value: function forEach(callback) {
                var _iterator8 = $558228835489ffff$var$_createForOfIteratorHelper$2(this._pairs), _step8;
                try {
                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                        var _step8$value = $558228835489ffff$var$_slicedToArray(_step8.value, 2), id = _step8$value[0], item = _step8$value[1];
                        callback(item, id);
                    }
                } catch (err) {
                    _iterator8.e(err);
                } finally{
                    _iterator8.f();
                }
            }
        },
        {
            key: "map",
            value: function map(callback) {
                var pairs = this._pairs;
                return new DataStream({
                    [$558228835489ffff$var$_Symbol$iterator] () {
                        return /*#__PURE__*/ $558228835489ffff$var$_regeneratorRuntime.mark(function _callee2() {
                            var _iterator9, _step9, _step9$value, id, item;
                            return $558228835489ffff$var$_regeneratorRuntime.wrap(function _callee2$(_context8) {
                                while(true)switch(_context8.prev = _context8.next){
                                    case 0:
                                        _iterator9 = $558228835489ffff$var$_createForOfIteratorHelper$2(pairs);
                                        _context8.prev = 1;
                                        _iterator9.s();
                                    case 3:
                                        if ((_step9 = _iterator9.n()).done) {
                                            _context8.next = 9;
                                            break;
                                        }
                                        _step9$value = $558228835489ffff$var$_slicedToArray(_step9.value, 2), id = _step9$value[0], item = _step9$value[1];
                                        _context8.next = 7;
                                        return [
                                            id,
                                            callback(item, id)
                                        ];
                                    case 7:
                                        _context8.next = 3;
                                        break;
                                    case 9:
                                        _context8.next = 14;
                                        break;
                                    case 11:
                                        _context8.prev = 11;
                                        _context8.t0 = _context8["catch"](1);
                                        _iterator9.e(_context8.t0);
                                    case 14:
                                        _context8.prev = 14;
                                        _iterator9.f();
                                        return _context8.finish(14);
                                    case 17:
                                    case "end":
                                        return _context8.stop();
                                }
                            }, _callee2, null, [
                                [
                                    1,
                                    11,
                                    14,
                                    17
                                ]
                            ]);
                        })();
                    }
                });
            }
        },
        {
            key: "max",
            value: function max(callback) {
                var iter = $558228835489ffff$var$_getIterator(this._pairs);
                var curr = iter.next();
                if (curr.done) return null;
                var maxItem = curr.value[1];
                var maxValue = callback(curr.value[1], curr.value[0]);
                while(!(curr = iter.next()).done){
                    var _curr$value = $558228835489ffff$var$_slicedToArray(curr.value, 2), id = _curr$value[0], item = _curr$value[1];
                    var _value = callback(item, id);
                    if (_value > maxValue) {
                        maxValue = _value;
                        maxItem = item;
                    }
                }
                return maxItem;
            }
        },
        {
            key: "min",
            value: function min(callback) {
                var iter = $558228835489ffff$var$_getIterator(this._pairs);
                var curr = iter.next();
                if (curr.done) return null;
                var minItem = curr.value[1];
                var minValue = callback(curr.value[1], curr.value[0]);
                while(!(curr = iter.next()).done){
                    var _curr$value2 = $558228835489ffff$var$_slicedToArray(curr.value, 2), id = _curr$value2[0], item = _curr$value2[1];
                    var _value2 = callback(item, id);
                    if (_value2 < minValue) {
                        minValue = _value2;
                        minItem = item;
                    }
                }
                return minItem;
            }
        },
        {
            key: "reduce",
            value: function reduce(callback, accumulator) {
                var _iterator10 = $558228835489ffff$var$_createForOfIteratorHelper$2(this._pairs), _step10;
                try {
                    for(_iterator10.s(); !(_step10 = _iterator10.n()).done;){
                        var _step10$value = $558228835489ffff$var$_slicedToArray(_step10.value, 2), id = _step10$value[0], item = _step10$value[1];
                        accumulator = callback(accumulator, item, id);
                    }
                } catch (err) {
                    _iterator10.e(err);
                } finally{
                    _iterator10.f();
                }
                return accumulator;
            }
        },
        {
            key: "sort",
            value: function sort(callback) {
                var _this = this;
                return new DataStream({
                    [$558228835489ffff$var$_Symbol$iterator]: function() {
                        var _context9;
                        return $558228835489ffff$var$_getIterator($558228835489ffff$var$_sortInstanceProperty(_context9 = $558228835489ffff$var$_toConsumableArray(_this._pairs)).call(_context9, function(_ref, _ref2) {
                            var _ref3 = $558228835489ffff$var$_slicedToArray(_ref, 2), idA = _ref3[0], itemA = _ref3[1];
                            var _ref4 = $558228835489ffff$var$_slicedToArray(_ref2, 2), idB = _ref4[0], itemB = _ref4[1];
                            return callback(itemA, itemB, idA, idB);
                        }));
                    }
                });
            }
        }
    ]);
    return DataStream;
}($558228835489ffff$var$_Symbol$iterator);
function $558228835489ffff$var$ownKeys(e, r) {
    var t = $558228835489ffff$var$_Object$keys(e);
    if ($558228835489ffff$var$_Object$getOwnPropertySymbols) {
        var o = $558228835489ffff$var$_Object$getOwnPropertySymbols(e);
        r && (o = $558228835489ffff$var$_filterInstanceProperty(o).call(o, function(r) {
            return $558228835489ffff$var$_Object$getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $558228835489ffff$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var _context10, _context11;
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $558228835489ffff$var$_forEachInstanceProperty(_context10 = $558228835489ffff$var$ownKeys(Object(t), !0)).call(_context10, function(r) {
            $558228835489ffff$var$_defineProperty(e, r, t[r]);
        }) : $558228835489ffff$var$_Object$getOwnPropertyDescriptors ? $558228835489ffff$var$_Object$defineProperties(e, $558228835489ffff$var$_Object$getOwnPropertyDescriptors(t)) : $558228835489ffff$var$_forEachInstanceProperty(_context11 = $558228835489ffff$var$ownKeys(Object(t))).call(_context11, function(r) {
            $558228835489ffff$var$_Object$defineProperty(e, r, $558228835489ffff$var$_Object$getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $558228835489ffff$var$_createForOfIteratorHelper$1(o, allowArrayLike) {
    var it = typeof $558228835489ffff$var$_Symbol !== "undefined" && $558228835489ffff$var$_getIteratorMethod(o) || o["@@iterator"];
    if (!it) {
        if ($558228835489ffff$var$_Array$isArray(o) || (it = $558228835489ffff$var$_unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $558228835489ffff$var$_unsupportedIterableToArray$1(o, minLen) {
    var _context9;
    if (!o) return;
    if (typeof o === "string") return $558228835489ffff$var$_arrayLikeToArray$1(o, minLen);
    var n = $558228835489ffff$var$_sliceInstanceProperty(_context9 = Object.prototype.toString.call(o)).call(_context9, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return $558228835489ffff$var$_Array$from$1(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $558228835489ffff$var$_arrayLikeToArray$1(o, minLen);
}
function $558228835489ffff$var$_arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $558228835489ffff$var$_createSuper$1(Derived) {
    var hasNativeReflectConstruct = $558228835489ffff$var$_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = $558228835489ffff$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $558228835489ffff$var$_getPrototypeOf(this).constructor;
            result = $558228835489ffff$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $558228835489ffff$var$_possibleConstructorReturn(this, result);
    };
}
function $558228835489ffff$var$_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !$558228835489ffff$var$_Reflect$construct) return false;
    if ($558228835489ffff$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($558228835489ffff$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Add an id to given item if it doesn't have one already.
 *
 * @remarks
 * The item will be modified.
 * @param item - The item that will have an id after a call to this function.
 * @param idProp - The key of the id property.
 * @typeParam Item - Item type that may or may not have an id.
 * @typeParam IdProp - Name of the property that contains the id.
 * @returns true
 */ function $558228835489ffff$var$ensureFullItem(item, idProp) {
    if (item[idProp] == null) // generate an id
    item[idProp] = $558228835489ffff$var$v4();
    return item;
}
/**
 * # DataSet
 *
 * Vis.js comes with a flexible DataSet, which can be used to hold and
 * manipulate unstructured data and listen for changes in the data. The DataSet
 * is key/value based. Data items can be added, updated and removed from the
 * DataSet, and one can subscribe to changes in the DataSet. The data in the
 * DataSet can be filtered and ordered. Data can be normalized when appending it
 * to the DataSet as well.
 *
 * ## Example
 *
 * The following example shows how to use a DataSet.
 *
 * ```javascript
 * // create a DataSet
 * var options = {};
 * var data = new vis.DataSet(options);
 *
 * // add items
 * // note that the data items can contain different properties and data formats
 * data.add([
 *   {id: 1, text: 'item 1', date: new Date(2013, 6, 20), group: 1, first: true},
 *   {id: 2, text: 'item 2', date: '2013-06-23', group: 2},
 *   {id: 3, text: 'item 3', date: '2013-06-25', group: 2},
 *   {id: 4, text: 'item 4'}
 * ]);
 *
 * // subscribe to any change in the DataSet
 * data.on('*', function (event, properties, senderId) {
 *   console.log('event', event, properties);
 * });
 *
 * // update an existing item
 * data.update({id: 2, group: 1});
 *
 * // remove an item
 * data.remove(4);
 *
 * // get all ids
 * var ids = data.getIds();
 * console.log('ids', ids);
 *
 * // get a specific item
 * var item1 = data.get(1);
 * console.log('item1', item1);
 *
 * // retrieve a filtered subset of the data
 * var items = data.get({
 *   filter: function (item) {
 *     return item.group == 1;
 *   }
 * });
 * console.log('filtered items', items);
 * ```
 *
 * @typeParam Item - Item type that may or may not have an id.
 * @typeParam IdProp - Name of the property that contains the id.
 */ var $558228835489ffff$export$486059efd2d2dabe = /*#__PURE__*/ function(_DataSetPart) {
    $558228835489ffff$var$_inherits(DataSet, _DataSetPart);
    var _super = $558228835489ffff$var$_createSuper$1(DataSet);
    /**
   * Construct a new DataSet.
   *
   * @param data - Initial data or options.
   * @param options - Options (type error if data is also options).
   */ function DataSet(data, options) {
        var _this;
        $558228835489ffff$var$_classCallCheck(this, DataSet);
        _this = _super.call(this);
        // correctly read optional arguments
        $558228835489ffff$var$_defineProperty($558228835489ffff$var$_assertThisInitialized(_this), "_queue", null);
        if (data && !$558228835489ffff$var$_Array$isArray(data)) {
            options = data;
            data = [];
        }
        _this._options = options || {};
        _this._data = new $558228835489ffff$var$_Map(); // map with data indexed by id
        _this.length = 0; // number of items in the DataSet
        _this._idProp = _this._options.fieldId || "id"; // name of the field containing id
        // add initial data when provided
        if (data && data.length) _this.add(data);
        _this.setOptions(options);
        return _this;
    }
    /**
   * Set new options.
   *
   * @param options - The new options.
   */ $558228835489ffff$var$_createClass(DataSet, [
        {
            key: "idProp",
            get: /** Flush all queued calls. */ /** @inheritDoc */ /** @inheritDoc */ function get() {
                return this._idProp;
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                if (options && options.queue !== undefined) {
                    if (options.queue === false) // delete queue if loaded
                    {
                        if (this._queue) {
                            this._queue.destroy();
                            this._queue = null;
                        }
                    } else {
                        // create queue and update its options
                        if (!this._queue) this._queue = $558228835489ffff$export$3dc07afe418952bc.extend(this, {
                            replace: [
                                "add",
                                "update",
                                "remove"
                            ]
                        });
                        if (options.queue && typeof options.queue === "object") this._queue.setOptions(options.queue);
                    }
                }
            }
        },
        {
            key: "add",
            value: function add(data, senderId) {
                var _this2 = this;
                var addedIds = [];
                var id;
                if ($558228835489ffff$var$_Array$isArray(data)) {
                    // Array
                    var idsToAdd = $558228835489ffff$var$_mapInstanceProperty(data).call(data, function(d) {
                        return d[_this2._idProp];
                    });
                    if ($558228835489ffff$var$_someInstanceProperty(idsToAdd).call(idsToAdd, function(id) {
                        return _this2._data.has(id);
                    })) throw new Error("A duplicate id was found in the parameter array.");
                    for(var i = 0, len = data.length; i < len; i++){
                        id = this._addItem(data[i]);
                        addedIds.push(id);
                    }
                } else if (data && typeof data === "object") {
                    // Single item
                    id = this._addItem(data);
                    addedIds.push(id);
                } else throw new Error("Unknown dataType");
                if (addedIds.length) this._trigger("add", {
                    items: addedIds
                }, senderId);
                return addedIds;
            }
        },
        {
            key: "update",
            value: function update(data, senderId) {
                var _this3 = this;
                var addedIds = [];
                var updatedIds = [];
                var oldData = [];
                var updatedData = [];
                var idProp = this._idProp;
                var addOrUpdate = function addOrUpdate(item) {
                    var origId = item[idProp];
                    if (origId != null && _this3._data.has(origId)) {
                        var fullItem = item; // it has an id, therefore it is a fullitem
                        var oldItem = $558228835489ffff$var$_Object$assign({}, _this3._data.get(origId));
                        // update item
                        var id = _this3._updateItem(fullItem);
                        updatedIds.push(id);
                        updatedData.push(fullItem);
                        oldData.push(oldItem);
                    } else {
                        // add new item
                        var _id = _this3._addItem(item);
                        addedIds.push(_id);
                    }
                };
                if ($558228835489ffff$var$_Array$isArray(data)) {
                    // Array
                    for(var i = 0, len = data.length; i < len; i++)if (data[i] && typeof data[i] === "object") addOrUpdate(data[i]);
                    else console.warn("Ignoring input item, which is not an object at index " + i);
                } else if (data && typeof data === "object") // Single item
                addOrUpdate(data);
                else throw new Error("Unknown dataType");
                if (addedIds.length) this._trigger("add", {
                    items: addedIds
                }, senderId);
                if (updatedIds.length) {
                    var props = {
                        items: updatedIds,
                        oldData: oldData,
                        data: updatedData
                    };
                    // TODO: remove deprecated property 'data' some day
                    //Object.defineProperty(props, 'data', {
                    //  'get': (function() {
                    //    console.warn('Property data is deprecated. Use DataSet.get(ids) to retrieve the new data, use the oldData property on this object to get the old data');
                    //    return updatedData;
                    //  }).bind(this)
                    //});
                    this._trigger("update", props, senderId);
                }
                return $558228835489ffff$var$_concatInstanceProperty(addedIds).call(addedIds, updatedIds);
            }
        },
        {
            key: "updateOnly",
            value: function updateOnly(data, senderId) {
                var _context, _this4 = this;
                if (!$558228835489ffff$var$_Array$isArray(data)) data = [
                    data
                ];
                var updateEventData = $558228835489ffff$var$_mapInstanceProperty(_context = $558228835489ffff$var$_mapInstanceProperty(data).call(data, function(update) {
                    var oldData = _this4._data.get(update[_this4._idProp]);
                    if (oldData == null) throw new Error("Updating non-existent items is not allowed.");
                    return {
                        oldData: oldData,
                        update: update
                    };
                })).call(_context, function(_ref) {
                    var oldData = _ref.oldData, update = _ref.update;
                    var id = oldData[_this4._idProp];
                    var updatedData = $558228835489ffff$var$pureDeepObjectAssign(oldData, update);
                    _this4._data.set(id, updatedData);
                    return {
                        id: id,
                        oldData: oldData,
                        updatedData: updatedData
                    };
                });
                if (updateEventData.length) {
                    var props = {
                        items: $558228835489ffff$var$_mapInstanceProperty(updateEventData).call(updateEventData, function(value) {
                            return value.id;
                        }),
                        oldData: $558228835489ffff$var$_mapInstanceProperty(updateEventData).call(updateEventData, function(value) {
                            return value.oldData;
                        }),
                        data: $558228835489ffff$var$_mapInstanceProperty(updateEventData).call(updateEventData, function(value) {
                            return value.updatedData;
                        })
                    };
                    // TODO: remove deprecated property 'data' some day
                    //Object.defineProperty(props, 'data', {
                    //  'get': (function() {
                    //    console.warn('Property data is deprecated. Use DataSet.get(ids) to retrieve the new data, use the oldData property on this object to get the old data');
                    //    return updatedData;
                    //  }).bind(this)
                    //});
                    this._trigger("update", props, senderId);
                    return props.items;
                } else return [];
            }
        },
        {
            key: "get",
            value: function get(first, second) {
                // @TODO: Woudn't it be better to split this into multiple methods?
                // parse the arguments
                var id = undefined;
                var ids = undefined;
                var options = undefined;
                if ($558228835489ffff$var$isId(first)) {
                    // get(id [, options])
                    id = first;
                    options = second;
                } else if ($558228835489ffff$var$_Array$isArray(first)) {
                    // get(ids [, options])
                    ids = first;
                    options = second;
                } else // get([, options])
                options = first;
                // determine the return type
                var returnType = options && options.returnType === "Object" ? "Object" : "Array";
                // @TODO: WTF is this? Or am I missing something?
                // var returnType
                // if (options && options.returnType) {
                //   var allowedValues = ['Array', 'Object']
                //   returnType =
                //     allowedValues.indexOf(options.returnType) == -1
                //       ? 'Array'
                //       : options.returnType
                // } else {
                //   returnType = 'Array'
                // }
                // build options
                var filter = options && $558228835489ffff$var$_filterInstanceProperty(options);
                var items = [];
                var item = undefined;
                var itemIds = undefined;
                var itemId = undefined;
                // convert items
                if (id != null) {
                    // return a single item
                    item = this._data.get(id);
                    if (item && filter && !filter(item)) item = undefined;
                } else if (ids != null) // return a subset of items
                for(var i = 0, len = ids.length; i < len; i++){
                    item = this._data.get(ids[i]);
                    if (item != null && (!filter || filter(item))) items.push(item);
                }
                else {
                    var _context2;
                    // return all items
                    itemIds = $558228835489ffff$var$_toConsumableArray($558228835489ffff$var$_keysInstanceProperty(_context2 = this._data).call(_context2));
                    for(var _i = 0, _len = itemIds.length; _i < _len; _i++){
                        itemId = itemIds[_i];
                        item = this._data.get(itemId);
                        if (item != null && (!filter || filter(item))) items.push(item);
                    }
                }
                // order the results
                if (options && options.order && id == undefined) this._sort(items, options.order);
                // filter fields of the items
                if (options && options.fields) {
                    var fields = options.fields;
                    if (id != undefined && item != null) item = this._filterFields(item, fields);
                    else for(var _i2 = 0, _len2 = items.length; _i2 < _len2; _i2++)items[_i2] = this._filterFields(items[_i2], fields);
                }
                // return the results
                if (returnType == "Object") {
                    var result = {};
                    for(var _i3 = 0, _len3 = items.length; _i3 < _len3; _i3++){
                        var resultant = items[_i3];
                        // @TODO: Shoudn't this be this._fieldId?
                        // result[resultant.id] = resultant
                        var _id2 = resultant[this._idProp];
                        result[_id2] = resultant;
                    }
                    return result;
                } else {
                    if (id != null) {
                        var _item;
                        // a single item
                        return (_item = item) !== null && _item !== void 0 ? _item : null;
                    } else // just return our array
                    return items;
                }
            }
        },
        {
            key: "getIds",
            value: function getIds(options) {
                var data = this._data;
                var filter = options && $558228835489ffff$var$_filterInstanceProperty(options);
                var order = options && options.order;
                var itemIds = $558228835489ffff$var$_toConsumableArray($558228835489ffff$var$_keysInstanceProperty(data).call(data));
                var ids = [];
                if (filter) {
                    // get filtered items
                    if (order) {
                        // create ordered list
                        var items = [];
                        for(var i = 0, len = itemIds.length; i < len; i++){
                            var id = itemIds[i];
                            var item = this._data.get(id);
                            if (item != null && filter(item)) items.push(item);
                        }
                        this._sort(items, order);
                        for(var _i4 = 0, _len4 = items.length; _i4 < _len4; _i4++)ids.push(items[_i4][this._idProp]);
                    } else // create unordered list
                    for(var _i5 = 0, _len5 = itemIds.length; _i5 < _len5; _i5++){
                        var _id3 = itemIds[_i5];
                        var _item2 = this._data.get(_id3);
                        if (_item2 != null && filter(_item2)) ids.push(_item2[this._idProp]);
                    }
                } else {
                    // get all items
                    if (order) {
                        // create an ordered list
                        var _items = [];
                        for(var _i6 = 0, _len6 = itemIds.length; _i6 < _len6; _i6++){
                            var _id4 = itemIds[_i6];
                            _items.push(data.get(_id4));
                        }
                        this._sort(_items, order);
                        for(var _i7 = 0, _len7 = _items.length; _i7 < _len7; _i7++)ids.push(_items[_i7][this._idProp]);
                    } else // create unordered list
                    for(var _i8 = 0, _len8 = itemIds.length; _i8 < _len8; _i8++){
                        var _id5 = itemIds[_i8];
                        var _item3 = data.get(_id5);
                        if (_item3 != null) ids.push(_item3[this._idProp]);
                    }
                }
                return ids;
            }
        },
        {
            key: "getDataSet",
            value: function getDataSet() {
                return this;
            }
        },
        {
            key: "forEach",
            value: function forEach(callback, options) {
                var filter = options && $558228835489ffff$var$_filterInstanceProperty(options);
                var data = this._data;
                var itemIds = $558228835489ffff$var$_toConsumableArray($558228835489ffff$var$_keysInstanceProperty(data).call(data));
                if (options && options.order) {
                    // execute forEach on ordered list
                    var items = this.get(options);
                    for(var i = 0, len = items.length; i < len; i++){
                        var item = items[i];
                        var id = item[this._idProp];
                        callback(item, id);
                    }
                } else // unordered
                for(var _i9 = 0, _len9 = itemIds.length; _i9 < _len9; _i9++){
                    var _id6 = itemIds[_i9];
                    var _item4 = this._data.get(_id6);
                    if (_item4 != null && (!filter || filter(_item4))) callback(_item4, _id6);
                }
            }
        },
        {
            key: "map",
            value: function map(callback, options) {
                var filter = options && $558228835489ffff$var$_filterInstanceProperty(options);
                var mappedItems = [];
                var data = this._data;
                var itemIds = $558228835489ffff$var$_toConsumableArray($558228835489ffff$var$_keysInstanceProperty(data).call(data));
                // convert and filter items
                for(var i = 0, len = itemIds.length; i < len; i++){
                    var id = itemIds[i];
                    var item = this._data.get(id);
                    if (item != null && (!filter || filter(item))) mappedItems.push(callback(item, id));
                }
                // order items
                if (options && options.order) this._sort(mappedItems, options.order);
                return mappedItems;
            }
        },
        {
            key: "_filterFields",
            value: function _filterFields(item, fields) {
                var _context3;
                if (!item) // item is null
                return item;
                return $558228835489ffff$var$_reduceInstanceProperty(_context3 = $558228835489ffff$var$_Array$isArray(fields) ? // Use the supplied array
                fields : // Use the keys of the supplied object
                $558228835489ffff$var$_Object$keys(fields)).call(_context3, function(filteredItem, field) {
                    filteredItem[field] = item[field];
                    return filteredItem;
                }, {});
            }
        },
        {
            key: "_sort",
            value: function _sort(items, order) {
                if (typeof order === "string") {
                    // order by provided field name
                    var name = order; // field name
                    $558228835489ffff$var$_sortInstanceProperty(items).call(items, function(a, b) {
                        // @TODO: How to treat missing properties?
                        var av = a[name];
                        var bv = b[name];
                        return av > bv ? 1 : av < bv ? -1 : 0;
                    });
                } else if (typeof order === "function") // order by sort function
                $558228835489ffff$var$_sortInstanceProperty(items).call(items, order);
                else // TODO: extend order by an Object {field:string, direction:string}
                //       where direction can be 'asc' or 'desc'
                throw new TypeError("Order must be a function or a string");
            }
        },
        {
            key: "remove",
            value: function remove(id, senderId) {
                var removedIds = [];
                var removedItems = [];
                // force everything to be an array for simplicity
                var ids = $558228835489ffff$var$_Array$isArray(id) ? id : [
                    id
                ];
                for(var i = 0, len = ids.length; i < len; i++){
                    var item = this._remove(ids[i]);
                    if (item) {
                        var itemId = item[this._idProp];
                        if (itemId != null) {
                            removedIds.push(itemId);
                            removedItems.push(item);
                        }
                    }
                }
                if (removedIds.length) this._trigger("remove", {
                    items: removedIds,
                    oldData: removedItems
                }, senderId);
                return removedIds;
            }
        },
        {
            key: "_remove",
            value: function _remove(id) {
                // @TODO: It origianlly returned the item although the docs say id.
                // The code expects the item, so probably an error in the docs.
                var ident;
                // confirm the id to use based on the args type
                if ($558228835489ffff$var$isId(id)) ident = id;
                else if (id && typeof id === "object") ident = id[this._idProp]; // look for the identifier field using ._idProp
                // do the removing if the item is found
                if (ident != null && this._data.has(ident)) {
                    var item = this._data.get(ident) || null;
                    this._data.delete(ident);
                    --this.length;
                    return item;
                }
                return null;
            }
        },
        {
            key: "clear",
            value: function clear(senderId) {
                var _context4;
                var ids = $558228835489ffff$var$_toConsumableArray($558228835489ffff$var$_keysInstanceProperty(_context4 = this._data).call(_context4));
                var items = [];
                for(var i = 0, len = ids.length; i < len; i++)items.push(this._data.get(ids[i]));
                this._data.clear();
                this.length = 0;
                this._trigger("remove", {
                    items: ids,
                    oldData: items
                }, senderId);
                return ids;
            }
        },
        {
            key: "max",
            value: function max(field) {
                var _context5;
                var max = null;
                var maxField = null;
                var _iterator = $558228835489ffff$var$_createForOfIteratorHelper$1($558228835489ffff$var$_valuesInstanceProperty(_context5 = this._data).call(_context5)), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var item = _step.value;
                        var itemField = item[field];
                        if (typeof itemField === "number" && (maxField == null || itemField > maxField)) {
                            max = item;
                            maxField = itemField;
                        }
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return max || null;
            }
        },
        {
            key: "min",
            value: function min(field) {
                var _context6;
                var min = null;
                var minField = null;
                var _iterator2 = $558228835489ffff$var$_createForOfIteratorHelper$1($558228835489ffff$var$_valuesInstanceProperty(_context6 = this._data).call(_context6)), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var item = _step2.value;
                        var itemField = item[field];
                        if (typeof itemField === "number" && (minField == null || itemField < minField)) {
                            min = item;
                            minField = itemField;
                        }
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
                return min || null;
            }
        },
        {
            key: "distinct",
            value: function distinct(prop) {
                var data = this._data;
                var itemIds = $558228835489ffff$var$_toConsumableArray($558228835489ffff$var$_keysInstanceProperty(data).call(data));
                var values = [];
                var count = 0;
                for(var i = 0, len = itemIds.length; i < len; i++){
                    var id = itemIds[i];
                    var item = data.get(id);
                    var value = item[prop];
                    var exists = false;
                    for(var j = 0; j < count; j++)if (values[j] == value) {
                        exists = true;
                        break;
                    }
                    if (!exists && value !== undefined) {
                        values[count] = value;
                        count++;
                    }
                }
                return values;
            }
        },
        {
            key: "_addItem",
            value: function _addItem(item) {
                var fullItem = $558228835489ffff$var$ensureFullItem(item, this._idProp);
                var id = fullItem[this._idProp];
                // check whether this id is already taken
                if (this._data.has(id)) // item already exists
                throw new Error("Cannot add item: item with id " + id + " already exists");
                this._data.set(id, fullItem);
                ++this.length;
                return id;
            }
        },
        {
            key: "_updateItem",
            value: function _updateItem(update) {
                var id = update[this._idProp];
                if (id == null) throw new Error("Cannot update item: item has no id (item: " + $558228835489ffff$var$_JSON$stringify(update) + ")");
                var item = this._data.get(id);
                if (!item) // item doesn't exist
                throw new Error("Cannot update item: no item with id " + id + " found");
                this._data.set(id, $558228835489ffff$var$_objectSpread($558228835489ffff$var$_objectSpread({}, item), update));
                return id;
            }
        },
        {
            key: "stream",
            value: function stream(ids) {
                if (ids) {
                    var data = this._data;
                    return new $558228835489ffff$export$521135ae501c2f0e({
                        [$558228835489ffff$var$_Symbol$iterator] () {
                            return /*#__PURE__*/ $558228835489ffff$var$_regeneratorRuntime.mark(function _callee() {
                                var _iterator3, _step3, id, item;
                                return $558228835489ffff$var$_regeneratorRuntime.wrap(function _callee$(_context7) {
                                    while(true)switch(_context7.prev = _context7.next){
                                        case 0:
                                            _iterator3 = $558228835489ffff$var$_createForOfIteratorHelper$1(ids);
                                            _context7.prev = 1;
                                            _iterator3.s();
                                        case 3:
                                            if ((_step3 = _iterator3.n()).done) {
                                                _context7.next = 11;
                                                break;
                                            }
                                            id = _step3.value;
                                            item = data.get(id);
                                            if (!(item != null)) {
                                                _context7.next = 9;
                                                break;
                                            }
                                            _context7.next = 9;
                                            return [
                                                id,
                                                item
                                            ];
                                        case 9:
                                            _context7.next = 3;
                                            break;
                                        case 11:
                                            _context7.next = 16;
                                            break;
                                        case 13:
                                            _context7.prev = 13;
                                            _context7.t0 = _context7["catch"](1);
                                            _iterator3.e(_context7.t0);
                                        case 16:
                                            _context7.prev = 16;
                                            _iterator3.f();
                                            return _context7.finish(16);
                                        case 19:
                                        case "end":
                                            return _context7.stop();
                                    }
                                }, _callee, null, [
                                    [
                                        1,
                                        13,
                                        16,
                                        19
                                    ]
                                ]);
                            })();
                        }
                    });
                } else {
                    var _context8;
                    return new $558228835489ffff$export$521135ae501c2f0e({
                        [$558228835489ffff$var$_Symbol$iterator]: $558228835489ffff$var$_bindInstanceProperty$1(_context8 = $558228835489ffff$var$_entriesInstanceProperty(this._data)).call(_context8, this._data)
                    });
                }
            }
        }
    ]);
    return DataSet;
}($558228835489ffff$var$DataSetPart);
function $558228835489ffff$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof $558228835489ffff$var$_Symbol !== "undefined" && $558228835489ffff$var$_getIteratorMethod(o) || o["@@iterator"];
    if (!it) {
        if ($558228835489ffff$var$_Array$isArray(o) || (it = $558228835489ffff$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $558228835489ffff$var$_unsupportedIterableToArray(o, minLen) {
    var _context5;
    if (!o) return;
    if (typeof o === "string") return $558228835489ffff$var$_arrayLikeToArray(o, minLen);
    var n = $558228835489ffff$var$_sliceInstanceProperty(_context5 = Object.prototype.toString.call(o)).call(_context5, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return $558228835489ffff$var$_Array$from$1(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $558228835489ffff$var$_arrayLikeToArray(o, minLen);
}
function $558228835489ffff$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $558228835489ffff$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $558228835489ffff$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $558228835489ffff$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $558228835489ffff$var$_getPrototypeOf(this).constructor;
            result = $558228835489ffff$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $558228835489ffff$var$_possibleConstructorReturn(this, result);
    };
}
function $558228835489ffff$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !$558228835489ffff$var$_Reflect$construct) return false;
    if ($558228835489ffff$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($558228835489ffff$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * DataView
 *
 * A DataView offers a filtered and/or formatted view on a DataSet. One can subscribe to changes in a DataView, and easily get filtered or formatted data without having to specify filters and field types all the time.
 *
 * ## Example
 * ```javascript
 * // create a DataSet
 * var data = new vis.DataSet();
 * data.add([
 *   {id: 1, text: 'item 1', date: new Date(2013, 6, 20), group: 1, first: true},
 *   {id: 2, text: 'item 2', date: '2013-06-23', group: 2},
 *   {id: 3, text: 'item 3', date: '2013-06-25', group: 2},
 *   {id: 4, text: 'item 4'}
 * ]);
 *
 * // create a DataView
 * // the view will only contain items having a property group with value 1,
 * // and will only output fields id, text, and date.
 * var view = new vis.DataView(data, {
 *   filter: function (item) {
 *     return (item.group == 1);
 *   },
 *   fields: ['id', 'text', 'date']
 * });
 *
 * // subscribe to any change in the DataView
 * view.on('*', function (event, properties, senderId) {
 *   console.log('event', event, properties);
 * });
 *
 * // update an item in the data set
 * data.update({id: 2, group: 1});
 *
 * // get all ids in the view
 * var ids = view.getIds();
 * console.log('ids', ids); // will output [1, 2]
 *
 * // get all items in the view
 * var items = view.get();
 * ```
 *
 * @typeParam Item - Item type that may or may not have an id.
 * @typeParam IdProp - Name of the property that contains the id.
 */ var $558228835489ffff$export$5e15d737b33a1c27 = /*#__PURE__*/ function(_DataSetPart) {
    $558228835489ffff$var$_inherits(DataView, _DataSetPart);
    var _super = $558228835489ffff$var$_createSuper(DataView);
    // ids of the items currently in memory (just contains a boolean true)
    /**
   * Create a DataView.
   *
   * @param data - The instance containing data (directly or indirectly).
   * @param options - Options to configure this data view.
   */ function DataView(data, options) {
        var _context;
        var _this;
        $558228835489ffff$var$_classCallCheck(this, DataView);
        _this = _super.call(this);
        /** @inheritDoc */ $558228835489ffff$var$_defineProperty($558228835489ffff$var$_assertThisInitialized(_this), "length", 0);
        // constructor → setData
        $558228835489ffff$var$_defineProperty($558228835489ffff$var$_assertThisInitialized(_this), "_ids", new $558228835489ffff$var$_Set());
        _this._options = options || {};
        _this._listener = $558228835489ffff$var$_bindInstanceProperty$1(_context = _this._onEvent).call(_context, $558228835489ffff$var$_assertThisInitialized(_this));
        _this.setData(data);
        return _this;
    }
    // TODO: implement a function .config() to dynamically update things like configured filter
    // and trigger changes accordingly
    /**
   * Set a data source for the view.
   *
   * @param data - The instance containing data (directly or indirectly).
   * @remarks
   * Note that when the data view is bound to a data set it won't be garbage
   * collected unless the data set is too. Use `dataView.setData(null)` or
   * `dataView.dispose()` to enable garbage collection before you lose the last
   * reference.
   */ $558228835489ffff$var$_createClass(DataView, [
        {
            key: "idProp",
            get: /** @inheritDoc */ function get() {
                return this.getDataSet().idProp;
            }
        },
        {
            key: "setData",
            value: function setData(data) {
                if (this._data) {
                    // unsubscribe from current dataset
                    if (this._data.off) this._data.off("*", this._listener);
                    // trigger a remove of all items in memory
                    var ids = this._data.getIds({
                        filter: $558228835489ffff$var$_filterInstanceProperty(this._options)
                    });
                    var items = this._data.get(ids);
                    this._ids.clear();
                    this.length = 0;
                    this._trigger("remove", {
                        items: ids,
                        oldData: items
                    });
                }
                if (data != null) {
                    this._data = data;
                    // trigger an add of all added items
                    var _ids = this._data.getIds({
                        filter: $558228835489ffff$var$_filterInstanceProperty(this._options)
                    });
                    for(var i = 0, len = _ids.length; i < len; i++){
                        var id = _ids[i];
                        this._ids.add(id);
                    }
                    this.length = _ids.length;
                    this._trigger("add", {
                        items: _ids
                    });
                } else this._data = new $558228835489ffff$export$486059efd2d2dabe();
                // subscribe to new dataset
                if (this._data.on) this._data.on("*", this._listener);
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                var ids = this._data.getIds({
                    filter: $558228835489ffff$var$_filterInstanceProperty(this._options)
                });
                var oldIds = $558228835489ffff$var$_toConsumableArray(this._ids);
                var newIds = {};
                var addedIds = [];
                var removedIds = [];
                var removedItems = [];
                // check for additions
                for(var i = 0, len = ids.length; i < len; i++){
                    var id = ids[i];
                    newIds[id] = true;
                    if (!this._ids.has(id)) {
                        addedIds.push(id);
                        this._ids.add(id);
                    }
                }
                // check for removals
                for(var _i = 0, _len = oldIds.length; _i < _len; _i++){
                    var _id = oldIds[_i];
                    var item = this._data.get(_id);
                    if (item == null) // @TODO: Investigate.
                    // Doesn't happen during tests or examples.
                    // Is it really impossible or could it eventually happen?
                    // How to handle it if it does? The types guarantee non-nullable items.
                    console.error("If you see this, report it please.");
                    else if (!newIds[_id]) {
                        removedIds.push(_id);
                        removedItems.push(item);
                        this._ids.delete(_id);
                    }
                }
                this.length += addedIds.length - removedIds.length;
                // trigger events
                if (addedIds.length) this._trigger("add", {
                    items: addedIds
                });
                if (removedIds.length) this._trigger("remove", {
                    items: removedIds,
                    oldData: removedItems
                });
            }
        },
        {
            key: "get",
            value: function get(first, second) {
                if (this._data == null) return null;
                // parse the arguments
                var ids = null;
                var options;
                if ($558228835489ffff$var$isId(first) || $558228835489ffff$var$_Array$isArray(first)) {
                    ids = first;
                    options = second;
                } else options = first;
                // extend the options with the default options and provided options
                var viewOptions = $558228835489ffff$var$_Object$assign({}, this._options, options);
                // create a combined filter method when needed
                var thisFilter = $558228835489ffff$var$_filterInstanceProperty(this._options);
                var optionsFilter = options && $558228835489ffff$var$_filterInstanceProperty(options);
                if (thisFilter && optionsFilter) viewOptions.filter = function(item) {
                    return thisFilter(item) && optionsFilter(item);
                };
                if (ids == null) return this._data.get(viewOptions);
                else return this._data.get(ids, viewOptions);
            }
        },
        {
            key: "getIds",
            value: function getIds(options) {
                if (this._data.length) {
                    var defaultFilter = $558228835489ffff$var$_filterInstanceProperty(this._options);
                    var optionsFilter = options != null ? $558228835489ffff$var$_filterInstanceProperty(options) : null;
                    var filter;
                    if (optionsFilter) {
                        if (defaultFilter) filter = function filter(item) {
                            return defaultFilter(item) && optionsFilter(item);
                        };
                        else filter = optionsFilter;
                    } else filter = defaultFilter;
                    return this._data.getIds({
                        filter: filter,
                        order: options && options.order
                    });
                } else return [];
            }
        },
        {
            key: "forEach",
            value: function forEach(callback, options) {
                if (this._data) {
                    var _context2;
                    var defaultFilter = $558228835489ffff$var$_filterInstanceProperty(this._options);
                    var optionsFilter = options && $558228835489ffff$var$_filterInstanceProperty(options);
                    var filter;
                    if (optionsFilter) {
                        if (defaultFilter) filter = function filter(item) {
                            return defaultFilter(item) && optionsFilter(item);
                        };
                        else filter = optionsFilter;
                    } else filter = defaultFilter;
                    $558228835489ffff$var$_forEachInstanceProperty(_context2 = this._data).call(_context2, callback, {
                        filter: filter,
                        order: options && options.order
                    });
                }
            }
        },
        {
            key: "map",
            value: function map(callback, options) {
                if (this._data) {
                    var _context3;
                    var defaultFilter = $558228835489ffff$var$_filterInstanceProperty(this._options);
                    var optionsFilter = options && $558228835489ffff$var$_filterInstanceProperty(options);
                    var filter;
                    if (optionsFilter) {
                        if (defaultFilter) filter = function filter(item) {
                            return defaultFilter(item) && optionsFilter(item);
                        };
                        else filter = optionsFilter;
                    } else filter = defaultFilter;
                    return $558228835489ffff$var$_mapInstanceProperty(_context3 = this._data).call(_context3, callback, {
                        filter: filter,
                        order: options && options.order
                    });
                } else return [];
            }
        },
        {
            key: "getDataSet",
            value: function getDataSet() {
                return this._data.getDataSet();
            }
        },
        {
            key: "stream",
            value: function stream(ids) {
                var _context4;
                return this._data.stream(ids || {
                    [$558228835489ffff$var$_Symbol$iterator]: $558228835489ffff$var$_bindInstanceProperty$1(_context4 = $558228835489ffff$var$_keysInstanceProperty(this._ids)).call(_context4, this._ids)
                });
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                var _this$_data;
                if ((_this$_data = this._data) !== null && _this$_data !== void 0 && _this$_data.off) this._data.off("*", this._listener);
                var message = "This data view has already been disposed of.";
                var replacement = {
                    get: function get() {
                        throw new Error(message);
                    },
                    set: function set() {
                        throw new Error(message);
                    },
                    configurable: false
                };
                var _iterator = $558228835489ffff$var$_createForOfIteratorHelper($558228835489ffff$var$_Reflect$ownKeys(DataView.prototype)), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var key = _step.value;
                        $558228835489ffff$var$_Object$defineProperty(this, key, replacement);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        },
        {
            key: "_onEvent",
            value: function _onEvent(event, params, senderId) {
                if (!params || !params.items || !this._data) return;
                var ids = params.items;
                var addedIds = [];
                var updatedIds = [];
                var removedIds = [];
                var oldItems = [];
                var updatedItems = [];
                var removedItems = [];
                switch(event){
                    case "add":
                        // filter the ids of the added items
                        for(var i = 0, len = ids.length; i < len; i++){
                            var id = ids[i];
                            var item = this.get(id);
                            if (item) {
                                this._ids.add(id);
                                addedIds.push(id);
                            }
                        }
                        break;
                    case "update":
                        // determine the event from the views viewpoint: an updated
                        // item can be added, updated, or removed from this view.
                        for(var _i2 = 0, _len2 = ids.length; _i2 < _len2; _i2++){
                            var _id2 = ids[_i2];
                            var _item = this.get(_id2);
                            if (_item) {
                                if (this._ids.has(_id2)) {
                                    updatedIds.push(_id2);
                                    updatedItems.push(params.data[_i2]);
                                    oldItems.push(params.oldData[_i2]);
                                } else {
                                    this._ids.add(_id2);
                                    addedIds.push(_id2);
                                }
                            } else if (this._ids.has(_id2)) {
                                this._ids.delete(_id2);
                                removedIds.push(_id2);
                                removedItems.push(params.oldData[_i2]);
                            }
                        }
                        break;
                    case "remove":
                        // filter the ids of the removed items
                        for(var _i3 = 0, _len3 = ids.length; _i3 < _len3; _i3++){
                            var _id3 = ids[_i3];
                            if (this._ids.has(_id3)) {
                                this._ids.delete(_id3);
                                removedIds.push(_id3);
                                removedItems.push(params.oldData[_i3]);
                            }
                        }
                        break;
                }
                this.length += addedIds.length - removedIds.length;
                if (addedIds.length) this._trigger("add", {
                    items: addedIds
                }, senderId);
                if (updatedIds.length) this._trigger("update", {
                    items: updatedIds,
                    oldData: oldItems,
                    data: updatedItems
                }, senderId);
                if (removedIds.length) this._trigger("remove", {
                    items: removedIds,
                    oldData: removedItems
                }, senderId);
            }
        }
    ]);
    return DataView;
}($558228835489ffff$var$DataSetPart);
/**
 * Check that given value is compatible with Vis Data Set interface.
 *
 * @param idProp - The expected property to contain item id.
 * @param v - The value to be tested.
 * @returns True if all expected values and methods match, false otherwise.
 */ function $558228835489ffff$export$c64ccc11d58144ed(idProp, v) {
    return typeof v === "object" && v !== null && idProp === v.idProp && typeof v.add === "function" && typeof v.clear === "function" && typeof v.distinct === "function" && typeof $558228835489ffff$var$_forEachInstanceProperty(v) === "function" && typeof v.get === "function" && typeof v.getDataSet === "function" && typeof v.getIds === "function" && typeof v.length === "number" && typeof $558228835489ffff$var$_mapInstanceProperty(v) === "function" && typeof v.max === "function" && typeof v.min === "function" && typeof v.off === "function" && typeof v.on === "function" && typeof v.remove === "function" && typeof v.setOptions === "function" && typeof v.stream === "function" && typeof v.update === "function" && typeof v.updateOnly === "function";
}
/**
 * Check that given value is compatible with Vis Data View interface.
 *
 * @param idProp - The expected property to contain item id.
 * @param v - The value to be tested.
 * @returns True if all expected values and methods match, false otherwise.
 */ function $558228835489ffff$export$fd220aa21eb2fcbc(idProp, v) {
    return typeof v === "object" && v !== null && idProp === v.idProp && typeof $558228835489ffff$var$_forEachInstanceProperty(v) === "function" && typeof v.get === "function" && typeof v.getDataSet === "function" && typeof v.getIds === "function" && typeof v.length === "number" && typeof $558228835489ffff$var$_mapInstanceProperty(v) === "function" && typeof v.off === "function" && typeof v.on === "function" && typeof v.stream === "function" && $558228835489ffff$export$c64ccc11d58144ed(idProp, v.getDataSet());
}


var $bebd28704f2536ea$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
function $bebd28704f2536ea$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var $bebd28704f2536ea$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $bebd28704f2536ea$var$global$n = // eslint-disable-next-line es/no-global-this -- safe
$bebd28704f2536ea$var$check(typeof globalThis == 'object' && globalThis) || $bebd28704f2536ea$var$check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
$bebd28704f2536ea$var$check(typeof self == 'object' && self) || $bebd28704f2536ea$var$check(typeof $bebd28704f2536ea$var$commonjsGlobal == 'object' && $bebd28704f2536ea$var$commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || $bebd28704f2536ea$var$commonjsGlobal || Function('return this')();
var $bebd28704f2536ea$var$fails$w = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};
var $bebd28704f2536ea$var$fails$v = $bebd28704f2536ea$var$fails$w;
var $bebd28704f2536ea$var$functionBindNative = !$bebd28704f2536ea$var$fails$v(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != 'function' || test.hasOwnProperty('prototype');
});
var $bebd28704f2536ea$var$NATIVE_BIND$4 = $bebd28704f2536ea$var$functionBindNative;
var $bebd28704f2536ea$var$FunctionPrototype$4 = Function.prototype;
var $bebd28704f2536ea$var$apply$5 = $bebd28704f2536ea$var$FunctionPrototype$4.apply;
var $bebd28704f2536ea$var$call$f = $bebd28704f2536ea$var$FunctionPrototype$4.call;
// eslint-disable-next-line es/no-reflect -- safe
var $bebd28704f2536ea$var$functionApply = typeof Reflect == 'object' && Reflect.apply || ($bebd28704f2536ea$var$NATIVE_BIND$4 ? $bebd28704f2536ea$var$call$f.bind($bebd28704f2536ea$var$apply$5) : function() {
    return $bebd28704f2536ea$var$call$f.apply($bebd28704f2536ea$var$apply$5, arguments);
});
var $bebd28704f2536ea$var$NATIVE_BIND$3 = $bebd28704f2536ea$var$functionBindNative;
var $bebd28704f2536ea$var$FunctionPrototype$3 = Function.prototype;
var $bebd28704f2536ea$var$call$e = $bebd28704f2536ea$var$FunctionPrototype$3.call;
var $bebd28704f2536ea$var$uncurryThisWithBind = $bebd28704f2536ea$var$NATIVE_BIND$3 && $bebd28704f2536ea$var$FunctionPrototype$3.bind.bind($bebd28704f2536ea$var$call$e, $bebd28704f2536ea$var$call$e);
var $bebd28704f2536ea$var$functionUncurryThis = $bebd28704f2536ea$var$NATIVE_BIND$3 ? $bebd28704f2536ea$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $bebd28704f2536ea$var$call$e.apply(fn, arguments);
    };
};
var $bebd28704f2536ea$var$uncurryThis$x = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$toString$c = $bebd28704f2536ea$var$uncurryThis$x({}.toString);
var $bebd28704f2536ea$var$stringSlice$1 = $bebd28704f2536ea$var$uncurryThis$x(''.slice);
var $bebd28704f2536ea$var$classofRaw$2 = function(it) {
    return $bebd28704f2536ea$var$stringSlice$1($bebd28704f2536ea$var$toString$c(it), 8, -1);
};
var $bebd28704f2536ea$var$classofRaw$1 = $bebd28704f2536ea$var$classofRaw$2;
var $bebd28704f2536ea$var$uncurryThis$w = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$functionUncurryThisClause = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($bebd28704f2536ea$var$classofRaw$1(fn) === 'Function') return $bebd28704f2536ea$var$uncurryThis$w(fn);
};
var $bebd28704f2536ea$var$documentAll$2 = typeof document == 'object' && document.all;
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var $bebd28704f2536ea$var$IS_HTMLDDA = typeof $bebd28704f2536ea$var$documentAll$2 == 'undefined' && $bebd28704f2536ea$var$documentAll$2 !== undefined;
var $bebd28704f2536ea$var$documentAll_1 = {
    all: $bebd28704f2536ea$var$documentAll$2,
    IS_HTMLDDA: $bebd28704f2536ea$var$IS_HTMLDDA
};
var $bebd28704f2536ea$var$$documentAll$1 = $bebd28704f2536ea$var$documentAll_1;
var $bebd28704f2536ea$var$documentAll$1 = $bebd28704f2536ea$var$$documentAll$1.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var $bebd28704f2536ea$var$isCallable$i = $bebd28704f2536ea$var$$documentAll$1.IS_HTMLDDA ? function(argument) {
    return typeof argument == 'function' || argument === $bebd28704f2536ea$var$documentAll$1;
} : function(argument) {
    return typeof argument == 'function';
};
var $bebd28704f2536ea$var$objectGetOwnPropertyDescriptor = {};
var $bebd28704f2536ea$var$fails$u = $bebd28704f2536ea$var$fails$w;
// Detect IE8's incomplete defineProperty implementation
var $bebd28704f2536ea$var$descriptors = !$bebd28704f2536ea$var$fails$u(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});
var $bebd28704f2536ea$var$NATIVE_BIND$2 = $bebd28704f2536ea$var$functionBindNative;
var $bebd28704f2536ea$var$call$d = Function.prototype.call;
var $bebd28704f2536ea$var$functionCall = $bebd28704f2536ea$var$NATIVE_BIND$2 ? $bebd28704f2536ea$var$call$d.bind($bebd28704f2536ea$var$call$d) : function() {
    return $bebd28704f2536ea$var$call$d.apply($bebd28704f2536ea$var$call$d, arguments);
};
var $bebd28704f2536ea$var$objectPropertyIsEnumerable = {};
var $bebd28704f2536ea$var$$propertyIsEnumerable$1 = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $bebd28704f2536ea$var$getOwnPropertyDescriptor$9 = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $bebd28704f2536ea$var$NASHORN_BUG = $bebd28704f2536ea$var$getOwnPropertyDescriptor$9 && !$bebd28704f2536ea$var$$propertyIsEnumerable$1.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
$bebd28704f2536ea$var$objectPropertyIsEnumerable.f = $bebd28704f2536ea$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $bebd28704f2536ea$var$getOwnPropertyDescriptor$9(this, V);
    return !!descriptor && descriptor.enumerable;
} : $bebd28704f2536ea$var$$propertyIsEnumerable$1;
var $bebd28704f2536ea$var$createPropertyDescriptor$5 = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};
var $bebd28704f2536ea$var$uncurryThis$v = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$fails$t = $bebd28704f2536ea$var$fails$w;
var $bebd28704f2536ea$var$classof$e = $bebd28704f2536ea$var$classofRaw$2;
var $bebd28704f2536ea$var$$Object$5 = Object;
var $bebd28704f2536ea$var$split = $bebd28704f2536ea$var$uncurryThis$v(''.split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var $bebd28704f2536ea$var$indexedObject = $bebd28704f2536ea$var$fails$t(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$bebd28704f2536ea$var$$Object$5('z').propertyIsEnumerable(0);
}) ? function(it) {
    return $bebd28704f2536ea$var$classof$e(it) === 'String' ? $bebd28704f2536ea$var$split(it, '') : $bebd28704f2536ea$var$$Object$5(it);
} : $bebd28704f2536ea$var$$Object$5;
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var $bebd28704f2536ea$var$isNullOrUndefined$6 = function(it) {
    return it === null || it === undefined;
};
var $bebd28704f2536ea$var$isNullOrUndefined$5 = $bebd28704f2536ea$var$isNullOrUndefined$6;
var $bebd28704f2536ea$var$$TypeError$g = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var $bebd28704f2536ea$var$requireObjectCoercible$5 = function(it) {
    if ($bebd28704f2536ea$var$isNullOrUndefined$5(it)) throw new $bebd28704f2536ea$var$$TypeError$g("Can't call method on " + it);
    return it;
};
// toObject with fallback for non-array-like ES3 strings
var $bebd28704f2536ea$var$IndexedObject$3 = $bebd28704f2536ea$var$indexedObject;
var $bebd28704f2536ea$var$requireObjectCoercible$4 = $bebd28704f2536ea$var$requireObjectCoercible$5;
var $bebd28704f2536ea$var$toIndexedObject$a = function(it) {
    return $bebd28704f2536ea$var$IndexedObject$3($bebd28704f2536ea$var$requireObjectCoercible$4(it));
};
var $bebd28704f2536ea$var$isCallable$h = $bebd28704f2536ea$var$isCallable$i;
var $bebd28704f2536ea$var$$documentAll = $bebd28704f2536ea$var$documentAll_1;
var $bebd28704f2536ea$var$documentAll = $bebd28704f2536ea$var$$documentAll.all;
var $bebd28704f2536ea$var$isObject$j = $bebd28704f2536ea$var$$documentAll.IS_HTMLDDA ? function(it) {
    return typeof it == 'object' ? it !== null : $bebd28704f2536ea$var$isCallable$h(it) || it === $bebd28704f2536ea$var$documentAll;
} : function(it) {
    return typeof it == 'object' ? it !== null : $bebd28704f2536ea$var$isCallable$h(it);
};
var $bebd28704f2536ea$var$path$w = {};
var $bebd28704f2536ea$var$path$v = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$global$m = $bebd28704f2536ea$var$global$n;
var $bebd28704f2536ea$var$isCallable$g = $bebd28704f2536ea$var$isCallable$i;
var $bebd28704f2536ea$var$aFunction = function(variable) {
    return $bebd28704f2536ea$var$isCallable$g(variable) ? variable : undefined;
};
var $bebd28704f2536ea$var$getBuiltIn$c = function(namespace, method) {
    return arguments.length < 2 ? $bebd28704f2536ea$var$aFunction($bebd28704f2536ea$var$path$v[namespace]) || $bebd28704f2536ea$var$aFunction($bebd28704f2536ea$var$global$m[namespace]) : $bebd28704f2536ea$var$path$v[namespace] && $bebd28704f2536ea$var$path$v[namespace][method] || $bebd28704f2536ea$var$global$m[namespace] && $bebd28704f2536ea$var$global$m[namespace][method];
};
var $bebd28704f2536ea$var$uncurryThis$u = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$objectIsPrototypeOf = $bebd28704f2536ea$var$uncurryThis$u({}.isPrototypeOf);
var $bebd28704f2536ea$var$engineUserAgent = typeof navigator != 'undefined' && String(navigator.userAgent) || '';
var $bebd28704f2536ea$var$global$l = $bebd28704f2536ea$var$global$n;
var $bebd28704f2536ea$var$userAgent$2 = $bebd28704f2536ea$var$engineUserAgent;
var $bebd28704f2536ea$var$process = $bebd28704f2536ea$var$global$l.process;
var $bebd28704f2536ea$var$Deno = $bebd28704f2536ea$var$global$l.Deno;
var $bebd28704f2536ea$var$versions = $bebd28704f2536ea$var$process && $bebd28704f2536ea$var$process.versions || $bebd28704f2536ea$var$Deno && $bebd28704f2536ea$var$Deno.version;
var $bebd28704f2536ea$var$v8 = $bebd28704f2536ea$var$versions && $bebd28704f2536ea$var$versions.v8;
var $bebd28704f2536ea$var$match, $bebd28704f2536ea$var$version;
if ($bebd28704f2536ea$var$v8) {
    $bebd28704f2536ea$var$match = $bebd28704f2536ea$var$v8.split('.');
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $bebd28704f2536ea$var$version = $bebd28704f2536ea$var$match[0] > 0 && $bebd28704f2536ea$var$match[0] < 4 ? 1 : +($bebd28704f2536ea$var$match[0] + $bebd28704f2536ea$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$bebd28704f2536ea$var$version && $bebd28704f2536ea$var$userAgent$2) {
    $bebd28704f2536ea$var$match = $bebd28704f2536ea$var$userAgent$2.match(/Edge\/(\d+)/);
    if (!$bebd28704f2536ea$var$match || $bebd28704f2536ea$var$match[1] >= 74) {
        $bebd28704f2536ea$var$match = $bebd28704f2536ea$var$userAgent$2.match(/Chrome\/(\d+)/);
        if ($bebd28704f2536ea$var$match) $bebd28704f2536ea$var$version = +$bebd28704f2536ea$var$match[1];
    }
}
var $bebd28704f2536ea$var$engineV8Version = $bebd28704f2536ea$var$version;
/* eslint-disable es/no-symbol -- required for testing */ var $bebd28704f2536ea$var$V8_VERSION$2 = $bebd28704f2536ea$var$engineV8Version;
var $bebd28704f2536ea$var$fails$s = $bebd28704f2536ea$var$fails$w;
var $bebd28704f2536ea$var$global$k = $bebd28704f2536ea$var$global$n;
var $bebd28704f2536ea$var$$String$5 = $bebd28704f2536ea$var$global$k.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var $bebd28704f2536ea$var$symbolConstructorDetection = !!Object.getOwnPropertySymbols && !$bebd28704f2536ea$var$fails$s(function() {
    var symbol = Symbol('symbol detection');
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$bebd28704f2536ea$var$$String$5(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $bebd28704f2536ea$var$V8_VERSION$2 && $bebd28704f2536ea$var$V8_VERSION$2 < 41;
});
/* eslint-disable es/no-symbol -- required for testing */ var $bebd28704f2536ea$var$NATIVE_SYMBOL$5 = $bebd28704f2536ea$var$symbolConstructorDetection;
var $bebd28704f2536ea$var$useSymbolAsUid = $bebd28704f2536ea$var$NATIVE_SYMBOL$5 && !Symbol.sham && typeof Symbol.iterator == 'symbol';
var $bebd28704f2536ea$var$getBuiltIn$b = $bebd28704f2536ea$var$getBuiltIn$c;
var $bebd28704f2536ea$var$isCallable$f = $bebd28704f2536ea$var$isCallable$i;
var $bebd28704f2536ea$var$isPrototypeOf$k = $bebd28704f2536ea$var$objectIsPrototypeOf;
var $bebd28704f2536ea$var$USE_SYMBOL_AS_UID$1 = $bebd28704f2536ea$var$useSymbolAsUid;
var $bebd28704f2536ea$var$$Object$4 = Object;
var $bebd28704f2536ea$var$isSymbol$5 = $bebd28704f2536ea$var$USE_SYMBOL_AS_UID$1 ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    var $Symbol = $bebd28704f2536ea$var$getBuiltIn$b('Symbol');
    return $bebd28704f2536ea$var$isCallable$f($Symbol) && $bebd28704f2536ea$var$isPrototypeOf$k($Symbol.prototype, $bebd28704f2536ea$var$$Object$4(it));
};
var $bebd28704f2536ea$var$$String$4 = String;
var $bebd28704f2536ea$var$tryToString$6 = function(argument) {
    try {
        return $bebd28704f2536ea$var$$String$4(argument);
    } catch (error) {
        return 'Object';
    }
};
var $bebd28704f2536ea$var$isCallable$e = $bebd28704f2536ea$var$isCallable$i;
var $bebd28704f2536ea$var$tryToString$5 = $bebd28704f2536ea$var$tryToString$6;
var $bebd28704f2536ea$var$$TypeError$f = TypeError;
// `Assert: IsCallable(argument) is true`
var $bebd28704f2536ea$var$aCallable$7 = function(argument) {
    if ($bebd28704f2536ea$var$isCallable$e(argument)) return argument;
    throw new $bebd28704f2536ea$var$$TypeError$f($bebd28704f2536ea$var$tryToString$5(argument) + ' is not a function');
};
var $bebd28704f2536ea$var$aCallable$6 = $bebd28704f2536ea$var$aCallable$7;
var $bebd28704f2536ea$var$isNullOrUndefined$4 = $bebd28704f2536ea$var$isNullOrUndefined$6;
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var $bebd28704f2536ea$var$getMethod$3 = function(V, P) {
    var func = V[P];
    return $bebd28704f2536ea$var$isNullOrUndefined$4(func) ? undefined : $bebd28704f2536ea$var$aCallable$6(func);
};
var $bebd28704f2536ea$var$call$c = $bebd28704f2536ea$var$functionCall;
var $bebd28704f2536ea$var$isCallable$d = $bebd28704f2536ea$var$isCallable$i;
var $bebd28704f2536ea$var$isObject$i = $bebd28704f2536ea$var$isObject$j;
var $bebd28704f2536ea$var$$TypeError$e = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var $bebd28704f2536ea$var$ordinaryToPrimitive$1 = function(input, pref) {
    var fn, val;
    if (pref === 'string' && $bebd28704f2536ea$var$isCallable$d(fn = input.toString) && !$bebd28704f2536ea$var$isObject$i(val = $bebd28704f2536ea$var$call$c(fn, input))) return val;
    if ($bebd28704f2536ea$var$isCallable$d(fn = input.valueOf) && !$bebd28704f2536ea$var$isObject$i(val = $bebd28704f2536ea$var$call$c(fn, input))) return val;
    if (pref !== 'string' && $bebd28704f2536ea$var$isCallable$d(fn = input.toString) && !$bebd28704f2536ea$var$isObject$i(val = $bebd28704f2536ea$var$call$c(fn, input))) return val;
    throw new $bebd28704f2536ea$var$$TypeError$e("Can't convert object to primitive value");
};
var $bebd28704f2536ea$var$shared$7 = {
    exports: {}
};
var $bebd28704f2536ea$var$global$j = $bebd28704f2536ea$var$global$n;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $bebd28704f2536ea$var$defineProperty$f = Object.defineProperty;
var $bebd28704f2536ea$var$defineGlobalProperty$1 = function(key, value) {
    try {
        $bebd28704f2536ea$var$defineProperty$f($bebd28704f2536ea$var$global$j, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $bebd28704f2536ea$var$global$j[key] = value;
    }
    return value;
};
var $bebd28704f2536ea$var$global$i = $bebd28704f2536ea$var$global$n;
var $bebd28704f2536ea$var$defineGlobalProperty = $bebd28704f2536ea$var$defineGlobalProperty$1;
var $bebd28704f2536ea$var$SHARED = '__core-js_shared__';
var $bebd28704f2536ea$var$store$3 = $bebd28704f2536ea$var$global$i[$bebd28704f2536ea$var$SHARED] || $bebd28704f2536ea$var$defineGlobalProperty($bebd28704f2536ea$var$SHARED, {});
var $bebd28704f2536ea$var$sharedStore = $bebd28704f2536ea$var$store$3;
var $bebd28704f2536ea$var$store$2 = $bebd28704f2536ea$var$sharedStore;
($bebd28704f2536ea$var$shared$7.exports = function(key, value) {
    return $bebd28704f2536ea$var$store$2[key] || ($bebd28704f2536ea$var$store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: '3.33.0',
    mode: 'pure',
    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
    license: 'https://github.com/zloirock/core-js/blob/v3.33.0/LICENSE',
    source: 'https://github.com/zloirock/core-js'
});
var $bebd28704f2536ea$var$sharedExports = $bebd28704f2536ea$var$shared$7.exports;
var $bebd28704f2536ea$var$requireObjectCoercible$3 = $bebd28704f2536ea$var$requireObjectCoercible$5;
var $bebd28704f2536ea$var$$Object$3 = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var $bebd28704f2536ea$var$toObject$e = function(argument) {
    return $bebd28704f2536ea$var$$Object$3($bebd28704f2536ea$var$requireObjectCoercible$3(argument));
};
var $bebd28704f2536ea$var$uncurryThis$t = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$toObject$d = $bebd28704f2536ea$var$toObject$e;
var $bebd28704f2536ea$var$hasOwnProperty = $bebd28704f2536ea$var$uncurryThis$t({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var $bebd28704f2536ea$var$hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
    return $bebd28704f2536ea$var$hasOwnProperty($bebd28704f2536ea$var$toObject$d(it), key);
};
var $bebd28704f2536ea$var$uncurryThis$s = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$id$2 = 0;
var $bebd28704f2536ea$var$postfix = Math.random();
var $bebd28704f2536ea$var$toString$b = $bebd28704f2536ea$var$uncurryThis$s(1.0.toString);
var $bebd28704f2536ea$var$uid$4 = function(key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + $bebd28704f2536ea$var$toString$b(++$bebd28704f2536ea$var$id$2 + $bebd28704f2536ea$var$postfix, 36);
};
var $bebd28704f2536ea$var$global$h = $bebd28704f2536ea$var$global$n;
var $bebd28704f2536ea$var$shared$6 = $bebd28704f2536ea$var$sharedExports;
var $bebd28704f2536ea$var$hasOwn$h = $bebd28704f2536ea$var$hasOwnProperty_1;
var $bebd28704f2536ea$var$uid$3 = $bebd28704f2536ea$var$uid$4;
var $bebd28704f2536ea$var$NATIVE_SYMBOL$4 = $bebd28704f2536ea$var$symbolConstructorDetection;
var $bebd28704f2536ea$var$USE_SYMBOL_AS_UID = $bebd28704f2536ea$var$useSymbolAsUid;
var $bebd28704f2536ea$var$Symbol$5 = $bebd28704f2536ea$var$global$h.Symbol;
var $bebd28704f2536ea$var$WellKnownSymbolsStore$2 = $bebd28704f2536ea$var$shared$6('wks');
var $bebd28704f2536ea$var$createWellKnownSymbol = $bebd28704f2536ea$var$USE_SYMBOL_AS_UID ? $bebd28704f2536ea$var$Symbol$5['for'] || $bebd28704f2536ea$var$Symbol$5 : $bebd28704f2536ea$var$Symbol$5 && $bebd28704f2536ea$var$Symbol$5.withoutSetter || $bebd28704f2536ea$var$uid$3;
var $bebd28704f2536ea$var$wellKnownSymbol$m = function(name) {
    if (!$bebd28704f2536ea$var$hasOwn$h($bebd28704f2536ea$var$WellKnownSymbolsStore$2, name)) $bebd28704f2536ea$var$WellKnownSymbolsStore$2[name] = $bebd28704f2536ea$var$NATIVE_SYMBOL$4 && $bebd28704f2536ea$var$hasOwn$h($bebd28704f2536ea$var$Symbol$5, name) ? $bebd28704f2536ea$var$Symbol$5[name] : $bebd28704f2536ea$var$createWellKnownSymbol('Symbol.' + name);
    return $bebd28704f2536ea$var$WellKnownSymbolsStore$2[name];
};
var $bebd28704f2536ea$var$call$b = $bebd28704f2536ea$var$functionCall;
var $bebd28704f2536ea$var$isObject$h = $bebd28704f2536ea$var$isObject$j;
var $bebd28704f2536ea$var$isSymbol$4 = $bebd28704f2536ea$var$isSymbol$5;
var $bebd28704f2536ea$var$getMethod$2 = $bebd28704f2536ea$var$getMethod$3;
var $bebd28704f2536ea$var$ordinaryToPrimitive = $bebd28704f2536ea$var$ordinaryToPrimitive$1;
var $bebd28704f2536ea$var$wellKnownSymbol$l = $bebd28704f2536ea$var$wellKnownSymbol$m;
var $bebd28704f2536ea$var$$TypeError$d = TypeError;
var $bebd28704f2536ea$var$TO_PRIMITIVE = $bebd28704f2536ea$var$wellKnownSymbol$l('toPrimitive');
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var $bebd28704f2536ea$var$toPrimitive$6 = function(input, pref) {
    if (!$bebd28704f2536ea$var$isObject$h(input) || $bebd28704f2536ea$var$isSymbol$4(input)) return input;
    var exoticToPrim = $bebd28704f2536ea$var$getMethod$2(input, $bebd28704f2536ea$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = $bebd28704f2536ea$var$call$b(exoticToPrim, input, pref);
        if (!$bebd28704f2536ea$var$isObject$h(result) || $bebd28704f2536ea$var$isSymbol$4(result)) return result;
        throw new $bebd28704f2536ea$var$$TypeError$d("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = 'number';
    return $bebd28704f2536ea$var$ordinaryToPrimitive(input, pref);
};
var $bebd28704f2536ea$var$toPrimitive$5 = $bebd28704f2536ea$var$toPrimitive$6;
var $bebd28704f2536ea$var$isSymbol$3 = $bebd28704f2536ea$var$isSymbol$5;
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var $bebd28704f2536ea$var$toPropertyKey$4 = function(argument) {
    var key = $bebd28704f2536ea$var$toPrimitive$5(argument, 'string');
    return $bebd28704f2536ea$var$isSymbol$3(key) ? key : key + '';
};
var $bebd28704f2536ea$var$global$g = $bebd28704f2536ea$var$global$n;
var $bebd28704f2536ea$var$isObject$g = $bebd28704f2536ea$var$isObject$j;
var $bebd28704f2536ea$var$document$1 = $bebd28704f2536ea$var$global$g.document;
// typeof document.createElement is 'object' in old IE
var $bebd28704f2536ea$var$EXISTS$1 = $bebd28704f2536ea$var$isObject$g($bebd28704f2536ea$var$document$1) && $bebd28704f2536ea$var$isObject$g($bebd28704f2536ea$var$document$1.createElement);
var $bebd28704f2536ea$var$documentCreateElement$1 = function(it) {
    return $bebd28704f2536ea$var$EXISTS$1 ? $bebd28704f2536ea$var$document$1.createElement(it) : {};
};
var $bebd28704f2536ea$var$DESCRIPTORS$h = $bebd28704f2536ea$var$descriptors;
var $bebd28704f2536ea$var$fails$r = $bebd28704f2536ea$var$fails$w;
var $bebd28704f2536ea$var$createElement = $bebd28704f2536ea$var$documentCreateElement$1;
// Thanks to IE8 for its funny defineProperty
var $bebd28704f2536ea$var$ie8DomDefine = !$bebd28704f2536ea$var$DESCRIPTORS$h && !$bebd28704f2536ea$var$fails$r(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($bebd28704f2536ea$var$createElement('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a !== 7;
});
var $bebd28704f2536ea$var$DESCRIPTORS$g = $bebd28704f2536ea$var$descriptors;
var $bebd28704f2536ea$var$call$a = $bebd28704f2536ea$var$functionCall;
var $bebd28704f2536ea$var$propertyIsEnumerableModule$2 = $bebd28704f2536ea$var$objectPropertyIsEnumerable;
var $bebd28704f2536ea$var$createPropertyDescriptor$4 = $bebd28704f2536ea$var$createPropertyDescriptor$5;
var $bebd28704f2536ea$var$toIndexedObject$9 = $bebd28704f2536ea$var$toIndexedObject$a;
var $bebd28704f2536ea$var$toPropertyKey$3 = $bebd28704f2536ea$var$toPropertyKey$4;
var $bebd28704f2536ea$var$hasOwn$g = $bebd28704f2536ea$var$hasOwnProperty_1;
var $bebd28704f2536ea$var$IE8_DOM_DEFINE$1 = $bebd28704f2536ea$var$ie8DomDefine;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $bebd28704f2536ea$var$$getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$bebd28704f2536ea$var$objectGetOwnPropertyDescriptor.f = $bebd28704f2536ea$var$DESCRIPTORS$g ? $bebd28704f2536ea$var$$getOwnPropertyDescriptor$2 : function getOwnPropertyDescriptor(O, P) {
    O = $bebd28704f2536ea$var$toIndexedObject$9(O);
    P = $bebd28704f2536ea$var$toPropertyKey$3(P);
    if ($bebd28704f2536ea$var$IE8_DOM_DEFINE$1) try {
        return $bebd28704f2536ea$var$$getOwnPropertyDescriptor$2(O, P);
    } catch (error) {}
    if ($bebd28704f2536ea$var$hasOwn$g(O, P)) return $bebd28704f2536ea$var$createPropertyDescriptor$4(!$bebd28704f2536ea$var$call$a($bebd28704f2536ea$var$propertyIsEnumerableModule$2.f, O, P), O[P]);
};
var $bebd28704f2536ea$var$fails$q = $bebd28704f2536ea$var$fails$w;
var $bebd28704f2536ea$var$isCallable$c = $bebd28704f2536ea$var$isCallable$i;
var $bebd28704f2536ea$var$replacement = /#|\.prototype\./;
var $bebd28704f2536ea$var$isForced$1 = function(feature, detection) {
    var value = $bebd28704f2536ea$var$data[$bebd28704f2536ea$var$normalize(feature)];
    return value === $bebd28704f2536ea$var$POLYFILL ? true : value === $bebd28704f2536ea$var$NATIVE ? false : $bebd28704f2536ea$var$isCallable$c(detection) ? $bebd28704f2536ea$var$fails$q(detection) : !!detection;
};
var $bebd28704f2536ea$var$normalize = $bebd28704f2536ea$var$isForced$1.normalize = function(string) {
    return String(string).replace($bebd28704f2536ea$var$replacement, '.').toLowerCase();
};
var $bebd28704f2536ea$var$data = $bebd28704f2536ea$var$isForced$1.data = {};
var $bebd28704f2536ea$var$NATIVE = $bebd28704f2536ea$var$isForced$1.NATIVE = 'N';
var $bebd28704f2536ea$var$POLYFILL = $bebd28704f2536ea$var$isForced$1.POLYFILL = 'P';
var $bebd28704f2536ea$var$isForced_1 = $bebd28704f2536ea$var$isForced$1;
var $bebd28704f2536ea$var$uncurryThis$r = $bebd28704f2536ea$var$functionUncurryThisClause;
var $bebd28704f2536ea$var$aCallable$5 = $bebd28704f2536ea$var$aCallable$7;
var $bebd28704f2536ea$var$NATIVE_BIND$1 = $bebd28704f2536ea$var$functionBindNative;
var $bebd28704f2536ea$var$bind$e = $bebd28704f2536ea$var$uncurryThis$r($bebd28704f2536ea$var$uncurryThis$r.bind);
// optional / simple context binding
var $bebd28704f2536ea$var$functionBindContext = function(fn, that) {
    $bebd28704f2536ea$var$aCallable$5(fn);
    return that === undefined ? fn : $bebd28704f2536ea$var$NATIVE_BIND$1 ? $bebd28704f2536ea$var$bind$e(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};
var $bebd28704f2536ea$var$objectDefineProperty = {};
var $bebd28704f2536ea$var$DESCRIPTORS$f = $bebd28704f2536ea$var$descriptors;
var $bebd28704f2536ea$var$fails$p = $bebd28704f2536ea$var$fails$w;
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var $bebd28704f2536ea$var$v8PrototypeDefineBug = $bebd28704f2536ea$var$DESCRIPTORS$f && $bebd28704f2536ea$var$fails$p(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, 'prototype', {
        value: 42,
        writable: false
    }).prototype !== 42;
});
var $bebd28704f2536ea$var$isObject$f = $bebd28704f2536ea$var$isObject$j;
var $bebd28704f2536ea$var$$String$3 = String;
var $bebd28704f2536ea$var$$TypeError$c = TypeError;
// `Assert: Type(argument) is Object`
var $bebd28704f2536ea$var$anObject$d = function(argument) {
    if ($bebd28704f2536ea$var$isObject$f(argument)) return argument;
    throw new $bebd28704f2536ea$var$$TypeError$c($bebd28704f2536ea$var$$String$3(argument) + ' is not an object');
};
var $bebd28704f2536ea$var$DESCRIPTORS$e = $bebd28704f2536ea$var$descriptors;
var $bebd28704f2536ea$var$IE8_DOM_DEFINE = $bebd28704f2536ea$var$ie8DomDefine;
var $bebd28704f2536ea$var$V8_PROTOTYPE_DEFINE_BUG$1 = $bebd28704f2536ea$var$v8PrototypeDefineBug;
var $bebd28704f2536ea$var$anObject$c = $bebd28704f2536ea$var$anObject$d;
var $bebd28704f2536ea$var$toPropertyKey$2 = $bebd28704f2536ea$var$toPropertyKey$4;
var $bebd28704f2536ea$var$$TypeError$b = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $bebd28704f2536ea$var$$defineProperty$1 = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $bebd28704f2536ea$var$$getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var $bebd28704f2536ea$var$ENUMERABLE = 'enumerable';
var $bebd28704f2536ea$var$CONFIGURABLE$1 = 'configurable';
var $bebd28704f2536ea$var$WRITABLE = 'writable';
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
$bebd28704f2536ea$var$objectDefineProperty.f = $bebd28704f2536ea$var$DESCRIPTORS$e ? $bebd28704f2536ea$var$V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
    $bebd28704f2536ea$var$anObject$c(O);
    P = $bebd28704f2536ea$var$toPropertyKey$2(P);
    $bebd28704f2536ea$var$anObject$c(Attributes);
    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && $bebd28704f2536ea$var$WRITABLE in Attributes && !Attributes[$bebd28704f2536ea$var$WRITABLE]) {
        var current = $bebd28704f2536ea$var$$getOwnPropertyDescriptor$1(O, P);
        if (current && current[$bebd28704f2536ea$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $bebd28704f2536ea$var$CONFIGURABLE$1 in Attributes ? Attributes[$bebd28704f2536ea$var$CONFIGURABLE$1] : current[$bebd28704f2536ea$var$CONFIGURABLE$1],
                enumerable: $bebd28704f2536ea$var$ENUMERABLE in Attributes ? Attributes[$bebd28704f2536ea$var$ENUMERABLE] : current[$bebd28704f2536ea$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $bebd28704f2536ea$var$$defineProperty$1(O, P, Attributes);
} : $bebd28704f2536ea$var$$defineProperty$1 : function defineProperty(O, P, Attributes) {
    $bebd28704f2536ea$var$anObject$c(O);
    P = $bebd28704f2536ea$var$toPropertyKey$2(P);
    $bebd28704f2536ea$var$anObject$c(Attributes);
    if ($bebd28704f2536ea$var$IE8_DOM_DEFINE) try {
        return $bebd28704f2536ea$var$$defineProperty$1(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw new $bebd28704f2536ea$var$$TypeError$b('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};
var $bebd28704f2536ea$var$DESCRIPTORS$d = $bebd28704f2536ea$var$descriptors;
var $bebd28704f2536ea$var$definePropertyModule$3 = $bebd28704f2536ea$var$objectDefineProperty;
var $bebd28704f2536ea$var$createPropertyDescriptor$3 = $bebd28704f2536ea$var$createPropertyDescriptor$5;
var $bebd28704f2536ea$var$createNonEnumerableProperty$6 = $bebd28704f2536ea$var$DESCRIPTORS$d ? function(object, key, value) {
    return $bebd28704f2536ea$var$definePropertyModule$3.f(object, key, $bebd28704f2536ea$var$createPropertyDescriptor$3(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};
var $bebd28704f2536ea$var$global$f = $bebd28704f2536ea$var$global$n;
var $bebd28704f2536ea$var$apply$4 = $bebd28704f2536ea$var$functionApply;
var $bebd28704f2536ea$var$uncurryThis$q = $bebd28704f2536ea$var$functionUncurryThisClause;
var $bebd28704f2536ea$var$isCallable$b = $bebd28704f2536ea$var$isCallable$i;
var $bebd28704f2536ea$var$getOwnPropertyDescriptor$8 = $bebd28704f2536ea$var$objectGetOwnPropertyDescriptor.f;
var $bebd28704f2536ea$var$isForced = $bebd28704f2536ea$var$isForced_1;
var $bebd28704f2536ea$var$path$u = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$bind$d = $bebd28704f2536ea$var$functionBindContext;
var $bebd28704f2536ea$var$createNonEnumerableProperty$5 = $bebd28704f2536ea$var$createNonEnumerableProperty$6;
var $bebd28704f2536ea$var$hasOwn$f = $bebd28704f2536ea$var$hasOwnProperty_1;
var $bebd28704f2536ea$var$wrapConstructor = function(NativeConstructor) {
    var Wrapper = function(a, b, c) {
        if (this instanceof Wrapper) {
            switch(arguments.length){
                case 0:
                    return new NativeConstructor();
                case 1:
                    return new NativeConstructor(a);
                case 2:
                    return new NativeConstructor(a, b);
            }
            return new NativeConstructor(a, b, c);
        }
        return $bebd28704f2536ea$var$apply$4(NativeConstructor, this, arguments);
    };
    Wrapper.prototype = NativeConstructor.prototype;
    return Wrapper;
};
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ var $bebd28704f2536ea$var$_export = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var PROTO = options.proto;
    var nativeSource = GLOBAL ? $bebd28704f2536ea$var$global$f : STATIC ? $bebd28704f2536ea$var$global$f[TARGET] : ($bebd28704f2536ea$var$global$f[TARGET] || {}).prototype;
    var target = GLOBAL ? $bebd28704f2536ea$var$path$u : $bebd28704f2536ea$var$path$u[TARGET] || $bebd28704f2536ea$var$createNonEnumerableProperty$5($bebd28704f2536ea$var$path$u, TARGET, {})[TARGET];
    var targetPrototype = target.prototype;
    var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
    var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;
    for(key in source){
        FORCED = $bebd28704f2536ea$var$isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contains in native
        USE_NATIVE = !FORCED && nativeSource && $bebd28704f2536ea$var$hasOwn$f(nativeSource, key);
        targetProperty = target[key];
        if (USE_NATIVE) {
            if (options.dontCallGetSet) {
                descriptor = $bebd28704f2536ea$var$getOwnPropertyDescriptor$8(nativeSource, key);
                nativeProperty = descriptor && descriptor.value;
            } else nativeProperty = nativeSource[key];
        }
        // export native or implementation
        sourceProperty = USE_NATIVE && nativeProperty ? nativeProperty : source[key];
        if (USE_NATIVE && typeof targetProperty == typeof sourceProperty) continue;
        // bind methods to global for calling from export context
        if (options.bind && USE_NATIVE) resultProperty = $bebd28704f2536ea$var$bind$d(sourceProperty, $bebd28704f2536ea$var$global$f);
        else if (options.wrap && USE_NATIVE) resultProperty = $bebd28704f2536ea$var$wrapConstructor(sourceProperty);
        else if (PROTO && $bebd28704f2536ea$var$isCallable$b(sourceProperty)) resultProperty = $bebd28704f2536ea$var$uncurryThis$q(sourceProperty);
        else resultProperty = sourceProperty;
        // add a flag to not completely full polyfills
        if (options.sham || sourceProperty && sourceProperty.sham || targetProperty && targetProperty.sham) $bebd28704f2536ea$var$createNonEnumerableProperty$5(resultProperty, 'sham', true);
        $bebd28704f2536ea$var$createNonEnumerableProperty$5(target, key, resultProperty);
        if (PROTO) {
            VIRTUAL_PROTOTYPE = TARGET + 'Prototype';
            if (!$bebd28704f2536ea$var$hasOwn$f($bebd28704f2536ea$var$path$u, VIRTUAL_PROTOTYPE)) $bebd28704f2536ea$var$createNonEnumerableProperty$5($bebd28704f2536ea$var$path$u, VIRTUAL_PROTOTYPE, {});
            // export virtual prototype methods
            $bebd28704f2536ea$var$createNonEnumerableProperty$5($bebd28704f2536ea$var$path$u[VIRTUAL_PROTOTYPE], key, sourceProperty);
            // export real prototype methods
            if (options.real && targetPrototype && (FORCED || !targetPrototype[key])) $bebd28704f2536ea$var$createNonEnumerableProperty$5(targetPrototype, key, sourceProperty);
        }
    }
};
var $bebd28704f2536ea$var$ceil = Math.ceil;
var $bebd28704f2536ea$var$floor$1 = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var $bebd28704f2536ea$var$mathTrunc = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $bebd28704f2536ea$var$floor$1 : $bebd28704f2536ea$var$ceil)(n);
};
var $bebd28704f2536ea$var$trunc = $bebd28704f2536ea$var$mathTrunc;
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var $bebd28704f2536ea$var$toIntegerOrInfinity$4 = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $bebd28704f2536ea$var$trunc(number);
};
var $bebd28704f2536ea$var$toIntegerOrInfinity$3 = $bebd28704f2536ea$var$toIntegerOrInfinity$4;
var $bebd28704f2536ea$var$max$3 = Math.max;
var $bebd28704f2536ea$var$min$2 = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var $bebd28704f2536ea$var$toAbsoluteIndex$5 = function(index, length1) {
    var integer = $bebd28704f2536ea$var$toIntegerOrInfinity$3(index);
    return integer < 0 ? $bebd28704f2536ea$var$max$3(integer + length1, 0) : $bebd28704f2536ea$var$min$2(integer, length1);
};
var $bebd28704f2536ea$var$toIntegerOrInfinity$2 = $bebd28704f2536ea$var$toIntegerOrInfinity$4;
var $bebd28704f2536ea$var$min$1 = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var $bebd28704f2536ea$var$toLength$1 = function(argument) {
    return argument > 0 ? $bebd28704f2536ea$var$min$1($bebd28704f2536ea$var$toIntegerOrInfinity$2(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
var $bebd28704f2536ea$var$toLength = $bebd28704f2536ea$var$toLength$1;
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var $bebd28704f2536ea$var$lengthOfArrayLike$c = function(obj) {
    return $bebd28704f2536ea$var$toLength(obj.length);
};
var $bebd28704f2536ea$var$toIndexedObject$8 = $bebd28704f2536ea$var$toIndexedObject$a;
var $bebd28704f2536ea$var$toAbsoluteIndex$4 = $bebd28704f2536ea$var$toAbsoluteIndex$5;
var $bebd28704f2536ea$var$lengthOfArrayLike$b = $bebd28704f2536ea$var$lengthOfArrayLike$c;
// `Array.prototype.{ indexOf, includes }` methods implementation
var $bebd28704f2536ea$var$createMethod$4 = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $bebd28704f2536ea$var$toIndexedObject$8($this);
        var length1 = $bebd28704f2536ea$var$lengthOfArrayLike$b(O);
        var index = $bebd28704f2536ea$var$toAbsoluteIndex$4(fromIndex, length1);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length1 > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length1 > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
var $bebd28704f2536ea$var$arrayIncludes = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $bebd28704f2536ea$var$createMethod$4(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $bebd28704f2536ea$var$createMethod$4(false)
};
var $bebd28704f2536ea$var$hiddenKeys$6 = {};
var $bebd28704f2536ea$var$uncurryThis$p = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$hasOwn$e = $bebd28704f2536ea$var$hasOwnProperty_1;
var $bebd28704f2536ea$var$toIndexedObject$7 = $bebd28704f2536ea$var$toIndexedObject$a;
var $bebd28704f2536ea$var$indexOf$4 = $bebd28704f2536ea$var$arrayIncludes.indexOf;
var $bebd28704f2536ea$var$hiddenKeys$5 = $bebd28704f2536ea$var$hiddenKeys$6;
var $bebd28704f2536ea$var$push$b = $bebd28704f2536ea$var$uncurryThis$p([].push);
var $bebd28704f2536ea$var$objectKeysInternal = function(object, names) {
    var O = $bebd28704f2536ea$var$toIndexedObject$7(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$bebd28704f2536ea$var$hasOwn$e($bebd28704f2536ea$var$hiddenKeys$5, key) && $bebd28704f2536ea$var$hasOwn$e(O, key) && $bebd28704f2536ea$var$push$b(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($bebd28704f2536ea$var$hasOwn$e(O, key = names[i++])) ~$bebd28704f2536ea$var$indexOf$4(result, key) || $bebd28704f2536ea$var$push$b(result, key);
    return result;
};
// IE8- don't enum bug keys
var $bebd28704f2536ea$var$enumBugKeys$3 = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];
var $bebd28704f2536ea$var$internalObjectKeys$1 = $bebd28704f2536ea$var$objectKeysInternal;
var $bebd28704f2536ea$var$enumBugKeys$2 = $bebd28704f2536ea$var$enumBugKeys$3;
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var $bebd28704f2536ea$var$objectKeys$3 = Object.keys || function keys(O) {
    return $bebd28704f2536ea$var$internalObjectKeys$1(O, $bebd28704f2536ea$var$enumBugKeys$2);
};
var $bebd28704f2536ea$var$objectGetOwnPropertySymbols = {};
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
$bebd28704f2536ea$var$objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var $bebd28704f2536ea$var$DESCRIPTORS$c = $bebd28704f2536ea$var$descriptors;
var $bebd28704f2536ea$var$uncurryThis$o = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$call$9 = $bebd28704f2536ea$var$functionCall;
var $bebd28704f2536ea$var$fails$o = $bebd28704f2536ea$var$fails$w;
var $bebd28704f2536ea$var$objectKeys$2 = $bebd28704f2536ea$var$objectKeys$3;
var $bebd28704f2536ea$var$getOwnPropertySymbolsModule$3 = $bebd28704f2536ea$var$objectGetOwnPropertySymbols;
var $bebd28704f2536ea$var$propertyIsEnumerableModule$1 = $bebd28704f2536ea$var$objectPropertyIsEnumerable;
var $bebd28704f2536ea$var$toObject$c = $bebd28704f2536ea$var$toObject$e;
var $bebd28704f2536ea$var$IndexedObject$2 = $bebd28704f2536ea$var$indexedObject;
// eslint-disable-next-line es/no-object-assign -- safe
var $bebd28704f2536ea$var$$assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var $bebd28704f2536ea$var$defineProperty$e = Object.defineProperty;
var $bebd28704f2536ea$var$concat$6 = $bebd28704f2536ea$var$uncurryThis$o([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var $bebd28704f2536ea$var$objectAssign = !$bebd28704f2536ea$var$$assign || $bebd28704f2536ea$var$fails$o(function() {
    // should have correct order of operations (Edge bug)
    if ($bebd28704f2536ea$var$DESCRIPTORS$c && $bebd28704f2536ea$var$$assign({
        b: 1
    }, $bebd28704f2536ea$var$$assign($bebd28704f2536ea$var$defineProperty$e({}, 'a', {
        enumerable: true,
        get: function() {
            $bebd28704f2536ea$var$defineProperty$e(this, 'b', {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es/no-symbol -- safe
    var symbol = Symbol('assign detection');
    var alphabet = 'abcdefghijklmnopqrst';
    A[symbol] = 7;
    alphabet.split('').forEach(function(chr) {
        B[chr] = chr;
    });
    return $bebd28704f2536ea$var$$assign({}, A)[symbol] !== 7 || $bebd28704f2536ea$var$objectKeys$2($bebd28704f2536ea$var$$assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) {
    var T = $bebd28704f2536ea$var$toObject$c(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $bebd28704f2536ea$var$getOwnPropertySymbolsModule$3.f;
    var propertyIsEnumerable = $bebd28704f2536ea$var$propertyIsEnumerableModule$1.f;
    while(argumentsLength > index){
        var S = $bebd28704f2536ea$var$IndexedObject$2(arguments[index++]);
        var keys = getOwnPropertySymbols ? $bebd28704f2536ea$var$concat$6($bebd28704f2536ea$var$objectKeys$2(S), getOwnPropertySymbols(S)) : $bebd28704f2536ea$var$objectKeys$2(S);
        var length1 = keys.length;
        var j = 0;
        var key;
        while(length1 > j){
            key = keys[j++];
            if (!$bebd28704f2536ea$var$DESCRIPTORS$c || $bebd28704f2536ea$var$call$9(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $bebd28704f2536ea$var$$assign;
var $bebd28704f2536ea$var$$$O = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$assign$5 = $bebd28704f2536ea$var$objectAssign;
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$bebd28704f2536ea$var$$$O({
    target: 'Object',
    stat: true,
    arity: 2,
    forced: Object.assign !== $bebd28704f2536ea$var$assign$5
}, {
    assign: $bebd28704f2536ea$var$assign$5
});
var $bebd28704f2536ea$var$path$t = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$assign$4 = $bebd28704f2536ea$var$path$t.Object.assign;
var $bebd28704f2536ea$var$parent$1b = $bebd28704f2536ea$var$assign$4;
var $bebd28704f2536ea$var$assign$3 = $bebd28704f2536ea$var$parent$1b;
var $bebd28704f2536ea$var$assign$2 = $bebd28704f2536ea$var$assign$3;
var $bebd28704f2536ea$var$_Object$assign = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$assign$2);
var $bebd28704f2536ea$var$uncurryThis$n = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$arraySlice$5 = $bebd28704f2536ea$var$uncurryThis$n([].slice);
var $bebd28704f2536ea$var$uncurryThis$m = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$aCallable$4 = $bebd28704f2536ea$var$aCallable$7;
var $bebd28704f2536ea$var$isObject$e = $bebd28704f2536ea$var$isObject$j;
var $bebd28704f2536ea$var$hasOwn$d = $bebd28704f2536ea$var$hasOwnProperty_1;
var $bebd28704f2536ea$var$arraySlice$4 = $bebd28704f2536ea$var$arraySlice$5;
var $bebd28704f2536ea$var$NATIVE_BIND = $bebd28704f2536ea$var$functionBindNative;
var $bebd28704f2536ea$var$$Function = Function;
var $bebd28704f2536ea$var$concat$5 = $bebd28704f2536ea$var$uncurryThis$m([].concat);
var $bebd28704f2536ea$var$join = $bebd28704f2536ea$var$uncurryThis$m([].join);
var $bebd28704f2536ea$var$factories = {};
var $bebd28704f2536ea$var$construct$4 = function(C, argsLength, args) {
    if (!$bebd28704f2536ea$var$hasOwn$d($bebd28704f2536ea$var$factories, argsLength)) {
        var list = [];
        var i = 0;
        for(; i < argsLength; i++)list[i] = 'a[' + i + ']';
        $bebd28704f2536ea$var$factories[argsLength] = $bebd28704f2536ea$var$$Function('C,a', 'return new C(' + $bebd28704f2536ea$var$join(list, ',') + ')');
    }
    return $bebd28704f2536ea$var$factories[argsLength](C, args);
};
// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
var $bebd28704f2536ea$var$functionBind = $bebd28704f2536ea$var$NATIVE_BIND ? $bebd28704f2536ea$var$$Function.bind : function bind(that /* , ...args */ ) {
    var F = $bebd28704f2536ea$var$aCallable$4(this);
    var Prototype = F.prototype;
    var partArgs = $bebd28704f2536ea$var$arraySlice$4(arguments, 1);
    var boundFunction = function bound() {
        var args = $bebd28704f2536ea$var$concat$5(partArgs, $bebd28704f2536ea$var$arraySlice$4(arguments));
        return this instanceof boundFunction ? $bebd28704f2536ea$var$construct$4(F, args.length, args) : F.apply(that, args);
    };
    if ($bebd28704f2536ea$var$isObject$e(Prototype)) boundFunction.prototype = Prototype;
    return boundFunction;
};
// TODO: Remove from `core-js@4`
var $bebd28704f2536ea$var$$$N = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$bind$c = $bebd28704f2536ea$var$functionBind;
// `Function.prototype.bind` method
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
$bebd28704f2536ea$var$$$N({
    target: 'Function',
    proto: true,
    forced: Function.bind !== $bebd28704f2536ea$var$bind$c
}, {
    bind: $bebd28704f2536ea$var$bind$c
});
var $bebd28704f2536ea$var$path$s = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$entryVirtual$i = function(CONSTRUCTOR) {
    return $bebd28704f2536ea$var$path$s[CONSTRUCTOR + 'Prototype'];
};
var $bebd28704f2536ea$var$entryVirtual$h = $bebd28704f2536ea$var$entryVirtual$i;
var $bebd28704f2536ea$var$bind$b = $bebd28704f2536ea$var$entryVirtual$h('Function').bind;
var $bebd28704f2536ea$var$isPrototypeOf$j = $bebd28704f2536ea$var$objectIsPrototypeOf;
var $bebd28704f2536ea$var$method$f = $bebd28704f2536ea$var$bind$b;
var $bebd28704f2536ea$var$FunctionPrototype$2 = Function.prototype;
var $bebd28704f2536ea$var$bind$a = function(it) {
    var own = it.bind;
    return it === $bebd28704f2536ea$var$FunctionPrototype$2 || $bebd28704f2536ea$var$isPrototypeOf$j($bebd28704f2536ea$var$FunctionPrototype$2, it) && own === $bebd28704f2536ea$var$FunctionPrototype$2.bind ? $bebd28704f2536ea$var$method$f : own;
};
var $bebd28704f2536ea$var$parent$1a = $bebd28704f2536ea$var$bind$a;
var $bebd28704f2536ea$var$bind$9 = $bebd28704f2536ea$var$parent$1a;
var $bebd28704f2536ea$var$bind$8 = $bebd28704f2536ea$var$bind$9;
var $bebd28704f2536ea$var$_bindInstanceProperty$1 = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$bind$8);
/**
 * Draw a circle.
 *
 * @param ctx - The context this shape will be rendered to.
 * @param x - The position of the center on the x axis.
 * @param y - The position of the center on the y axis.
 * @param r - The radius of the circle.
 */ function $bebd28704f2536ea$var$drawCircle(ctx, x, y, r) {
    ctx.beginPath();
    ctx.arc(x, y, r, 0, 2 * Math.PI, false);
    ctx.closePath();
}
/**
 * Draw a square.
 *
 * @param ctx - The context this shape will be rendered to.
 * @param x - The position of the center on the x axis.
 * @param y - The position of the center on the y axis.
 * @param r - Half of the width and height of the square.
 */ function $bebd28704f2536ea$var$drawSquare(ctx, x, y, r) {
    ctx.beginPath();
    ctx.rect(x - r, y - r, r * 2, r * 2);
    ctx.closePath();
}
/**
 * Draw an equilateral triangle standing on a side.
 *
 * @param ctx - The context this shape will be rendered to.
 * @param x - The position of the center on the x axis.
 * @param y - The position of the center on the y axis.
 * @param r - Half of the length of the sides.
 * @remarks
 * http://en.wikipedia.org/wiki/Equilateral_triangle
 */ function $bebd28704f2536ea$var$drawTriangle(ctx, x, y, r) {
    ctx.beginPath();
    // the change in radius and the offset is here to center the shape
    r *= 1.15;
    y += 0.275 * r;
    var s = r * 2;
    var s2 = s / 2;
    var ir = Math.sqrt(3) / 6 * s; // radius of inner circle
    var h = Math.sqrt(s * s - s2 * s2); // height
    ctx.moveTo(x, y - (h - ir));
    ctx.lineTo(x + s2, y + ir);
    ctx.lineTo(x - s2, y + ir);
    ctx.lineTo(x, y - (h - ir));
    ctx.closePath();
}
/**
 * Draw an equilateral triangle standing on a vertex.
 *
 * @param ctx - The context this shape will be rendered to.
 * @param x - The position of the center on the x axis.
 * @param y - The position of the center on the y axis.
 * @param r - Half of the length of the sides.
 * @remarks
 * http://en.wikipedia.org/wiki/Equilateral_triangle
 */ function $bebd28704f2536ea$var$drawTriangleDown(ctx, x, y, r) {
    ctx.beginPath();
    // the change in radius and the offset is here to center the shape
    r *= 1.15;
    y -= 0.275 * r;
    var s = r * 2;
    var s2 = s / 2;
    var ir = Math.sqrt(3) / 6 * s; // radius of inner circle
    var h = Math.sqrt(s * s - s2 * s2); // height
    ctx.moveTo(x, y + (h - ir));
    ctx.lineTo(x + s2, y - ir);
    ctx.lineTo(x - s2, y - ir);
    ctx.lineTo(x, y + (h - ir));
    ctx.closePath();
}
/**
 * Draw a star.
 *
 * @param ctx - The context this shape will be rendered to.
 * @param x - The position of the center on the x axis.
 * @param y - The position of the center on the y axis.
 * @param r - The outer radius of the star.
 */ function $bebd28704f2536ea$var$drawStar(ctx, x, y, r) {
    // http://www.html5canvastutorials.com/labs/html5-canvas-star-spinner/
    ctx.beginPath();
    // the change in radius and the offset is here to center the shape
    r *= 0.82;
    y += 0.1 * r;
    for(var n = 0; n < 10; n++){
        var radius = n % 2 === 0 ? r * 1.3 : r * 0.5;
        ctx.lineTo(x + radius * Math.sin(n * 2 * Math.PI / 10), y - radius * Math.cos(n * 2 * Math.PI / 10));
    }
    ctx.closePath();
}
/**
 * Draw a diamond.
 *
 * @param ctx - The context this shape will be rendered to.
 * @param x - The position of the center on the x axis.
 * @param y - The position of the center on the y axis.
 * @param r - Half of the width and height of the diamond.
 * @remarks
 * http://www.html5canvastutorials.com/labs/html5-canvas-star-spinner/
 */ function $bebd28704f2536ea$var$drawDiamond(ctx, x, y, r) {
    ctx.beginPath();
    ctx.lineTo(x, y + r);
    ctx.lineTo(x + r, y);
    ctx.lineTo(x, y - r);
    ctx.lineTo(x - r, y);
    ctx.closePath();
}
/**
 * Draw a rectangle with rounded corners.
 *
 * @param ctx - The context this shape will be rendered to.
 * @param x - The position of the center on the x axis.
 * @param y - The position of the center on the y axis.
 * @param w - The width of the rectangle.
 * @param h - The height of the rectangle.
 * @param r - The radius of the corners.
 * @remarks
 * http://stackoverflow.com/questions/1255512/how-to-draw-a-rounded-rectangle-on-html-canvas
 */ function $bebd28704f2536ea$var$drawRoundRect(ctx, x, y, w, h, r) {
    var r2d = Math.PI / 180;
    if (w - 2 * r < 0) r = w / 2;
     //ensure that the radius isn't too large for x
    if (h - 2 * r < 0) r = h / 2;
     //ensure that the radius isn't too large for y
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.lineTo(x + w - r, y);
    ctx.arc(x + w - r, y + r, r, r2d * 270, r2d * 360, false);
    ctx.lineTo(x + w, y + h - r);
    ctx.arc(x + w - r, y + h - r, r, 0, r2d * 90, false);
    ctx.lineTo(x + r, y + h);
    ctx.arc(x + r, y + h - r, r, r2d * 90, r2d * 180, false);
    ctx.lineTo(x, y + r);
    ctx.arc(x + r, y + r, r, r2d * 180, r2d * 270, false);
    ctx.closePath();
}
/**
 * Draw an ellipse.
 *
 * @param ctx - The context this shape will be rendered to.
 * @param x - The position of the center on the x axis.
 * @param y - The position of the center on the y axis.
 * @param w - The width of the ellipse.
 * @param h - The height of the ellipse.
 * @remarks
 * http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas
 *
 * Postfix '_vis' added to discern it from standard method ellipse().
 */ function $bebd28704f2536ea$var$drawEllipse(ctx, x, y, w, h) {
    var kappa = 0.5522848, ox = w / 2 * kappa, // control point offset horizontal
    oy = h / 2 * kappa, // control point offset vertical
    xe = x + w, // x-end
    ye = y + h, // y-end
    xm = x + w / 2, // x-middle
    ym = y + h / 2; // y-middle
    ctx.beginPath();
    ctx.moveTo(x, ym);
    ctx.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
    ctx.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
    ctx.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
    ctx.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
    ctx.closePath();
}
/**
 * Draw an isometric cylinder.
 *
 * @param ctx - The context this shape will be rendered to.
 * @param x - The position of the center on the x axis.
 * @param y - The position of the center on the y axis.
 * @param w - The width of the database.
 * @param h - The height of the database.
 * @remarks
 * http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas
 */ function $bebd28704f2536ea$var$drawDatabase(ctx, x, y, w, h) {
    var f = 1 / 3;
    var wEllipse = w;
    var hEllipse = h * f;
    var kappa = 0.5522848, ox = wEllipse / 2 * kappa, // control point offset horizontal
    oy = hEllipse / 2 * kappa, // control point offset vertical
    xe = x + wEllipse, // x-end
    ye = y + hEllipse, // y-end
    xm = x + wEllipse / 2, // x-middle
    ym = y + hEllipse / 2, // y-middle
    ymb = y + (h - hEllipse / 2), // y-midlle, bottom ellipse
    yeb = y + h; // y-end, bottom ellipse
    ctx.beginPath();
    ctx.moveTo(xe, ym);
    ctx.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
    ctx.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
    ctx.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
    ctx.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
    ctx.lineTo(xe, ymb);
    ctx.bezierCurveTo(xe, ymb + oy, xm + ox, yeb, xm, yeb);
    ctx.bezierCurveTo(xm - ox, yeb, x, ymb + oy, x, ymb);
    ctx.lineTo(x, ym);
}
/**
 * Draw a dashed line.
 *
 * @param ctx - The context this shape will be rendered to.
 * @param x - The start position on the x axis.
 * @param y - The start position on the y axis.
 * @param x2 - The end position on the x axis.
 * @param y2 - The end position on the y axis.
 * @param pattern - List of lengths starting with line and then alternating between space and line.
 * @author David Jordan
 * @remarks
 * date 2012-08-08
 * http://stackoverflow.com/questions/4576724/dotted-stroke-in-canvas
 */ function $bebd28704f2536ea$var$drawDashedLine(ctx, x, y, x2, y2, pattern) {
    ctx.beginPath();
    ctx.moveTo(x, y);
    var patternLength = pattern.length;
    var dx = x2 - x;
    var dy = y2 - y;
    var slope = dy / dx;
    var distRemaining = Math.sqrt(dx * dx + dy * dy);
    var patternIndex = 0;
    var draw = true;
    var xStep = 0;
    var dashLength = +pattern[0];
    while(distRemaining >= 0.1){
        dashLength = +pattern[patternIndex++ % patternLength];
        if (dashLength > distRemaining) dashLength = distRemaining;
        xStep = Math.sqrt(dashLength * dashLength / (1 + slope * slope));
        xStep = dx < 0 ? -xStep : xStep;
        x += xStep;
        y += slope * xStep;
        if (draw === true) ctx.lineTo(x, y);
        else ctx.moveTo(x, y);
        distRemaining -= dashLength;
        draw = !draw;
    }
}
/**
 * Draw a hexagon.
 *
 * @param ctx - The context this shape will be rendered to.
 * @param x - The position of the center on the x axis.
 * @param y - The position of the center on the y axis.
 * @param r - The radius of the hexagon.
 */ function $bebd28704f2536ea$var$drawHexagon(ctx, x, y, r) {
    ctx.beginPath();
    var sides = 6;
    var a = Math.PI * 2 / sides;
    ctx.moveTo(x + r, y);
    for(var i = 1; i < sides; i++)ctx.lineTo(x + r * Math.cos(a * i), y + r * Math.sin(a * i));
    ctx.closePath();
}
var $bebd28704f2536ea$var$shapeMap = {
    circle: $bebd28704f2536ea$var$drawCircle,
    dashedLine: $bebd28704f2536ea$var$drawDashedLine,
    database: $bebd28704f2536ea$var$drawDatabase,
    diamond: $bebd28704f2536ea$var$drawDiamond,
    ellipse: $bebd28704f2536ea$var$drawEllipse,
    ellipse_vis: $bebd28704f2536ea$var$drawEllipse,
    hexagon: $bebd28704f2536ea$var$drawHexagon,
    roundRect: $bebd28704f2536ea$var$drawRoundRect,
    square: $bebd28704f2536ea$var$drawSquare,
    star: $bebd28704f2536ea$var$drawStar,
    triangle: $bebd28704f2536ea$var$drawTriangle,
    triangleDown: $bebd28704f2536ea$var$drawTriangleDown
};
/**
 * Returns either custom or native drawing function base on supplied name.
 *
 * @param name - The name of the function. Either the name of a
 * CanvasRenderingContext2D property or an export from shapes.ts without the
 * draw prefix.
 * @returns The function that can be used for rendering. In case of native
 * CanvasRenderingContext2D function the API is normalized to
 * `(ctx: CanvasRenderingContext2D, ...originalArgs) => void`.
 */ function $bebd28704f2536ea$var$getShape(name) {
    if (Object.prototype.hasOwnProperty.call($bebd28704f2536ea$var$shapeMap, name)) return $bebd28704f2536ea$var$shapeMap[name];
    else return function(ctx) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        CanvasRenderingContext2D.prototype[name].call(ctx, args);
    };
}
var $bebd28704f2536ea$var$componentEmitter = {
    exports: {}
};
(function(module) {
    module.exports = Emitter;
    /**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */ function Emitter(obj) {
        if (obj) return mixin(obj);
    }
    /**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */ function mixin(obj) {
        for(var key in Emitter.prototype)obj[key] = Emitter.prototype[key];
        return obj;
    }
    /**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */ Emitter.prototype.on = Emitter.prototype.addEventListener = function(event, fn) {
        this._callbacks = this._callbacks || {};
        (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
        return this;
    };
    /**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */ Emitter.prototype.once = function(event, fn) {
        function on() {
            this.off(event, on);
            fn.apply(this, arguments);
        }
        on.fn = fn;
        this.on(event, on);
        return this;
    };
    /**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */ Emitter.prototype.off = Emitter.prototype.removeListener = Emitter.prototype.removeAllListeners = Emitter.prototype.removeEventListener = function(event, fn) {
        this._callbacks = this._callbacks || {};
        // all
        if (0 == arguments.length) {
            this._callbacks = {};
            return this;
        }
        // specific event
        var callbacks = this._callbacks['$' + event];
        if (!callbacks) return this;
        // remove all handlers
        if (1 == arguments.length) {
            delete this._callbacks['$' + event];
            return this;
        }
        // remove specific handler
        var cb;
        for(var i = 0; i < callbacks.length; i++){
            cb = callbacks[i];
            if (cb === fn || cb.fn === fn) {
                callbacks.splice(i, 1);
                break;
            }
        }
        // Remove event specific arrays for event types that no
        // one is subscribed for to avoid memory leak.
        if (callbacks.length === 0) delete this._callbacks['$' + event];
        return this;
    };
    /**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */ Emitter.prototype.emit = function(event) {
        this._callbacks = this._callbacks || {};
        var args = new Array(arguments.length - 1), callbacks = this._callbacks['$' + event];
        for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
        if (callbacks) {
            callbacks = callbacks.slice(0);
            for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
        }
        return this;
    };
    /**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */ Emitter.prototype.listeners = function(event) {
        this._callbacks = this._callbacks || {};
        return this._callbacks['$' + event] || [];
    };
    /**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */ Emitter.prototype.hasListeners = function(event) {
        return !!this.listeners(event).length;
    };
})($bebd28704f2536ea$var$componentEmitter);
var $bebd28704f2536ea$var$componentEmitterExports = $bebd28704f2536ea$var$componentEmitter.exports;
var $bebd28704f2536ea$var$Emitter = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$componentEmitterExports);
var $bebd28704f2536ea$var$wellKnownSymbol$k = $bebd28704f2536ea$var$wellKnownSymbol$m;
var $bebd28704f2536ea$var$TO_STRING_TAG$3 = $bebd28704f2536ea$var$wellKnownSymbol$k('toStringTag');
var $bebd28704f2536ea$var$test$2 = {};
$bebd28704f2536ea$var$test$2[$bebd28704f2536ea$var$TO_STRING_TAG$3] = 'z';
var $bebd28704f2536ea$var$toStringTagSupport = String($bebd28704f2536ea$var$test$2) === '[object z]';
var $bebd28704f2536ea$var$TO_STRING_TAG_SUPPORT$2 = $bebd28704f2536ea$var$toStringTagSupport;
var $bebd28704f2536ea$var$isCallable$a = $bebd28704f2536ea$var$isCallable$i;
var $bebd28704f2536ea$var$classofRaw = $bebd28704f2536ea$var$classofRaw$2;
var $bebd28704f2536ea$var$wellKnownSymbol$j = $bebd28704f2536ea$var$wellKnownSymbol$m;
var $bebd28704f2536ea$var$TO_STRING_TAG$2 = $bebd28704f2536ea$var$wellKnownSymbol$j('toStringTag');
var $bebd28704f2536ea$var$$Object$2 = Object;
// ES3 wrong here
var $bebd28704f2536ea$var$CORRECT_ARGUMENTS = $bebd28704f2536ea$var$classofRaw(function() {
    return arguments;
}()) === 'Arguments';
// fallback for IE11 Script Access Denied error
var $bebd28704f2536ea$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
var $bebd28704f2536ea$var$classof$d = $bebd28704f2536ea$var$TO_STRING_TAG_SUPPORT$2 ? $bebd28704f2536ea$var$classofRaw : function(it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = $bebd28704f2536ea$var$tryGet(O = $bebd28704f2536ea$var$$Object$2(it), $bebd28704f2536ea$var$TO_STRING_TAG$2)) == 'string' ? tag : $bebd28704f2536ea$var$CORRECT_ARGUMENTS ? $bebd28704f2536ea$var$classofRaw(O) : (result = $bebd28704f2536ea$var$classofRaw(O)) === 'Object' && $bebd28704f2536ea$var$isCallable$a(O.callee) ? 'Arguments' : result;
};
var $bebd28704f2536ea$var$classof$c = $bebd28704f2536ea$var$classof$d;
var $bebd28704f2536ea$var$$String$2 = String;
var $bebd28704f2536ea$var$toString$a = function(argument) {
    if ($bebd28704f2536ea$var$classof$c(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
    return $bebd28704f2536ea$var$$String$2(argument);
};
var $bebd28704f2536ea$var$uncurryThis$l = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$toIntegerOrInfinity$1 = $bebd28704f2536ea$var$toIntegerOrInfinity$4;
var $bebd28704f2536ea$var$toString$9 = $bebd28704f2536ea$var$toString$a;
var $bebd28704f2536ea$var$requireObjectCoercible$2 = $bebd28704f2536ea$var$requireObjectCoercible$5;
var $bebd28704f2536ea$var$charAt$3 = $bebd28704f2536ea$var$uncurryThis$l(''.charAt);
var $bebd28704f2536ea$var$charCodeAt$1 = $bebd28704f2536ea$var$uncurryThis$l(''.charCodeAt);
var $bebd28704f2536ea$var$stringSlice = $bebd28704f2536ea$var$uncurryThis$l(''.slice);
var $bebd28704f2536ea$var$createMethod$3 = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $bebd28704f2536ea$var$toString$9($bebd28704f2536ea$var$requireObjectCoercible$2($this));
        var position = $bebd28704f2536ea$var$toIntegerOrInfinity$1(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
        first = $bebd28704f2536ea$var$charCodeAt$1(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $bebd28704f2536ea$var$charCodeAt$1(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $bebd28704f2536ea$var$charAt$3(S, position) : first : CONVERT_TO_STRING ? $bebd28704f2536ea$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
var $bebd28704f2536ea$var$stringMultibyte = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $bebd28704f2536ea$var$createMethod$3(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $bebd28704f2536ea$var$createMethod$3(true)
};
var $bebd28704f2536ea$var$global$e = $bebd28704f2536ea$var$global$n;
var $bebd28704f2536ea$var$isCallable$9 = $bebd28704f2536ea$var$isCallable$i;
var $bebd28704f2536ea$var$WeakMap$1 = $bebd28704f2536ea$var$global$e.WeakMap;
var $bebd28704f2536ea$var$weakMapBasicDetection = $bebd28704f2536ea$var$isCallable$9($bebd28704f2536ea$var$WeakMap$1) && /native code/.test(String($bebd28704f2536ea$var$WeakMap$1));
var $bebd28704f2536ea$var$shared$5 = $bebd28704f2536ea$var$sharedExports;
var $bebd28704f2536ea$var$uid$2 = $bebd28704f2536ea$var$uid$4;
var $bebd28704f2536ea$var$keys$3 = $bebd28704f2536ea$var$shared$5('keys');
var $bebd28704f2536ea$var$sharedKey$4 = function(key) {
    return $bebd28704f2536ea$var$keys$3[key] || ($bebd28704f2536ea$var$keys$3[key] = $bebd28704f2536ea$var$uid$2(key));
};
var $bebd28704f2536ea$var$NATIVE_WEAK_MAP$1 = $bebd28704f2536ea$var$weakMapBasicDetection;
var $bebd28704f2536ea$var$global$d = $bebd28704f2536ea$var$global$n;
var $bebd28704f2536ea$var$isObject$d = $bebd28704f2536ea$var$isObject$j;
var $bebd28704f2536ea$var$createNonEnumerableProperty$4 = $bebd28704f2536ea$var$createNonEnumerableProperty$6;
var $bebd28704f2536ea$var$hasOwn$c = $bebd28704f2536ea$var$hasOwnProperty_1;
var $bebd28704f2536ea$var$shared$4 = $bebd28704f2536ea$var$sharedStore;
var $bebd28704f2536ea$var$sharedKey$3 = $bebd28704f2536ea$var$sharedKey$4;
var $bebd28704f2536ea$var$hiddenKeys$4 = $bebd28704f2536ea$var$hiddenKeys$6;
var $bebd28704f2536ea$var$OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var $bebd28704f2536ea$var$TypeError$2 = $bebd28704f2536ea$var$global$d.TypeError;
var $bebd28704f2536ea$var$WeakMap = $bebd28704f2536ea$var$global$d.WeakMap;
var $bebd28704f2536ea$var$set$3, $bebd28704f2536ea$var$get$6, $bebd28704f2536ea$var$has;
var $bebd28704f2536ea$var$enforce = function(it) {
    return $bebd28704f2536ea$var$has(it) ? $bebd28704f2536ea$var$get$6(it) : $bebd28704f2536ea$var$set$3(it, {});
};
var $bebd28704f2536ea$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$bebd28704f2536ea$var$isObject$d(it) || (state = $bebd28704f2536ea$var$get$6(it)).type !== TYPE) throw new $bebd28704f2536ea$var$TypeError$2('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if ($bebd28704f2536ea$var$NATIVE_WEAK_MAP$1 || $bebd28704f2536ea$var$shared$4.state) {
    var $bebd28704f2536ea$var$store$1 = $bebd28704f2536ea$var$shared$4.state || ($bebd28704f2536ea$var$shared$4.state = new $bebd28704f2536ea$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $bebd28704f2536ea$var$store$1.get = $bebd28704f2536ea$var$store$1.get;
    $bebd28704f2536ea$var$store$1.has = $bebd28704f2536ea$var$store$1.has;
    $bebd28704f2536ea$var$store$1.set = $bebd28704f2536ea$var$store$1.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $bebd28704f2536ea$var$set$3 = function(it, metadata) {
        if ($bebd28704f2536ea$var$store$1.has(it)) throw new $bebd28704f2536ea$var$TypeError$2($bebd28704f2536ea$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $bebd28704f2536ea$var$store$1.set(it, metadata);
        return metadata;
    };
    $bebd28704f2536ea$var$get$6 = function(it) {
        return $bebd28704f2536ea$var$store$1.get(it) || {};
    };
    $bebd28704f2536ea$var$has = function(it) {
        return $bebd28704f2536ea$var$store$1.has(it);
    };
} else {
    var $bebd28704f2536ea$var$STATE = $bebd28704f2536ea$var$sharedKey$3('state');
    $bebd28704f2536ea$var$hiddenKeys$4[$bebd28704f2536ea$var$STATE] = true;
    $bebd28704f2536ea$var$set$3 = function(it, metadata) {
        if ($bebd28704f2536ea$var$hasOwn$c(it, $bebd28704f2536ea$var$STATE)) throw new $bebd28704f2536ea$var$TypeError$2($bebd28704f2536ea$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $bebd28704f2536ea$var$createNonEnumerableProperty$4(it, $bebd28704f2536ea$var$STATE, metadata);
        return metadata;
    };
    $bebd28704f2536ea$var$get$6 = function(it) {
        return $bebd28704f2536ea$var$hasOwn$c(it, $bebd28704f2536ea$var$STATE) ? it[$bebd28704f2536ea$var$STATE] : {};
    };
    $bebd28704f2536ea$var$has = function(it) {
        return $bebd28704f2536ea$var$hasOwn$c(it, $bebd28704f2536ea$var$STATE);
    };
}
var $bebd28704f2536ea$var$internalState = {
    set: $bebd28704f2536ea$var$set$3,
    get: $bebd28704f2536ea$var$get$6,
    has: $bebd28704f2536ea$var$has,
    enforce: $bebd28704f2536ea$var$enforce,
    getterFor: $bebd28704f2536ea$var$getterFor
};
var $bebd28704f2536ea$var$DESCRIPTORS$b = $bebd28704f2536ea$var$descriptors;
var $bebd28704f2536ea$var$hasOwn$b = $bebd28704f2536ea$var$hasOwnProperty_1;
var $bebd28704f2536ea$var$FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $bebd28704f2536ea$var$getDescriptor = $bebd28704f2536ea$var$DESCRIPTORS$b && Object.getOwnPropertyDescriptor;
var $bebd28704f2536ea$var$EXISTS = $bebd28704f2536ea$var$hasOwn$b($bebd28704f2536ea$var$FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var $bebd28704f2536ea$var$PROPER = $bebd28704f2536ea$var$EXISTS && (function something() {}).name === 'something';
var $bebd28704f2536ea$var$CONFIGURABLE = $bebd28704f2536ea$var$EXISTS && (!$bebd28704f2536ea$var$DESCRIPTORS$b || $bebd28704f2536ea$var$DESCRIPTORS$b && $bebd28704f2536ea$var$getDescriptor($bebd28704f2536ea$var$FunctionPrototype$1, 'name').configurable);
var $bebd28704f2536ea$var$functionName = {
    EXISTS: $bebd28704f2536ea$var$EXISTS,
    PROPER: $bebd28704f2536ea$var$PROPER,
    CONFIGURABLE: $bebd28704f2536ea$var$CONFIGURABLE
};
var $bebd28704f2536ea$var$objectDefineProperties = {};
var $bebd28704f2536ea$var$DESCRIPTORS$a = $bebd28704f2536ea$var$descriptors;
var $bebd28704f2536ea$var$V8_PROTOTYPE_DEFINE_BUG = $bebd28704f2536ea$var$v8PrototypeDefineBug;
var $bebd28704f2536ea$var$definePropertyModule$2 = $bebd28704f2536ea$var$objectDefineProperty;
var $bebd28704f2536ea$var$anObject$b = $bebd28704f2536ea$var$anObject$d;
var $bebd28704f2536ea$var$toIndexedObject$6 = $bebd28704f2536ea$var$toIndexedObject$a;
var $bebd28704f2536ea$var$objectKeys$1 = $bebd28704f2536ea$var$objectKeys$3;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
$bebd28704f2536ea$var$objectDefineProperties.f = $bebd28704f2536ea$var$DESCRIPTORS$a && !$bebd28704f2536ea$var$V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
    $bebd28704f2536ea$var$anObject$b(O);
    var props = $bebd28704f2536ea$var$toIndexedObject$6(Properties);
    var keys = $bebd28704f2536ea$var$objectKeys$1(Properties);
    var length1 = keys.length;
    var index = 0;
    var key;
    while(length1 > index)$bebd28704f2536ea$var$definePropertyModule$2.f(O, key = keys[index++], props[key]);
    return O;
};
var $bebd28704f2536ea$var$getBuiltIn$a = $bebd28704f2536ea$var$getBuiltIn$c;
var $bebd28704f2536ea$var$html$1 = $bebd28704f2536ea$var$getBuiltIn$a('document', 'documentElement');
/* global ActiveXObject -- old IE, WSH */ var $bebd28704f2536ea$var$anObject$a = $bebd28704f2536ea$var$anObject$d;
var $bebd28704f2536ea$var$definePropertiesModule$1 = $bebd28704f2536ea$var$objectDefineProperties;
var $bebd28704f2536ea$var$enumBugKeys$1 = $bebd28704f2536ea$var$enumBugKeys$3;
var $bebd28704f2536ea$var$hiddenKeys$3 = $bebd28704f2536ea$var$hiddenKeys$6;
var $bebd28704f2536ea$var$html = $bebd28704f2536ea$var$html$1;
var $bebd28704f2536ea$var$documentCreateElement = $bebd28704f2536ea$var$documentCreateElement$1;
var $bebd28704f2536ea$var$sharedKey$2 = $bebd28704f2536ea$var$sharedKey$4;
var $bebd28704f2536ea$var$GT = '>';
var $bebd28704f2536ea$var$LT = '<';
var $bebd28704f2536ea$var$PROTOTYPE$1 = 'prototype';
var $bebd28704f2536ea$var$SCRIPT = 'script';
var $bebd28704f2536ea$var$IE_PROTO$1 = $bebd28704f2536ea$var$sharedKey$2('IE_PROTO');
var $bebd28704f2536ea$var$EmptyConstructor = function() {};
var $bebd28704f2536ea$var$scriptTag = function(content) {
    return $bebd28704f2536ea$var$LT + $bebd28704f2536ea$var$SCRIPT + $bebd28704f2536ea$var$GT + content + $bebd28704f2536ea$var$LT + '/' + $bebd28704f2536ea$var$SCRIPT + $bebd28704f2536ea$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $bebd28704f2536ea$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($bebd28704f2536ea$var$scriptTag(''));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $bebd28704f2536ea$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $bebd28704f2536ea$var$documentCreateElement('iframe');
    var JS = 'java' + $bebd28704f2536ea$var$SCRIPT + ':';
    var iframeDocument;
    iframe.style.display = 'none';
    $bebd28704f2536ea$var$html.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($bebd28704f2536ea$var$scriptTag('document.F=Object'));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $bebd28704f2536ea$var$activeXDocument;
var $bebd28704f2536ea$var$NullProtoObject = function() {
    try {
        $bebd28704f2536ea$var$activeXDocument = new ActiveXObject('htmlfile');
    } catch (error) {}
    $bebd28704f2536ea$var$NullProtoObject = typeof document != 'undefined' ? document.domain && $bebd28704f2536ea$var$activeXDocument ? $bebd28704f2536ea$var$NullProtoObjectViaActiveX($bebd28704f2536ea$var$activeXDocument) // old IE
     : $bebd28704f2536ea$var$NullProtoObjectViaIFrame() : $bebd28704f2536ea$var$NullProtoObjectViaActiveX($bebd28704f2536ea$var$activeXDocument); // WSH
    var length1 = $bebd28704f2536ea$var$enumBugKeys$1.length;
    while(length1--)delete $bebd28704f2536ea$var$NullProtoObject[$bebd28704f2536ea$var$PROTOTYPE$1][$bebd28704f2536ea$var$enumBugKeys$1[length1]];
    return $bebd28704f2536ea$var$NullProtoObject();
};
$bebd28704f2536ea$var$hiddenKeys$3[$bebd28704f2536ea$var$IE_PROTO$1] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var $bebd28704f2536ea$var$objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $bebd28704f2536ea$var$EmptyConstructor[$bebd28704f2536ea$var$PROTOTYPE$1] = $bebd28704f2536ea$var$anObject$a(O);
        result = new $bebd28704f2536ea$var$EmptyConstructor();
        $bebd28704f2536ea$var$EmptyConstructor[$bebd28704f2536ea$var$PROTOTYPE$1] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$bebd28704f2536ea$var$IE_PROTO$1] = O;
    } else result = $bebd28704f2536ea$var$NullProtoObject();
    return Properties === undefined ? result : $bebd28704f2536ea$var$definePropertiesModule$1.f(result, Properties);
};
var $bebd28704f2536ea$var$fails$n = $bebd28704f2536ea$var$fails$w;
var $bebd28704f2536ea$var$correctPrototypeGetter = !$bebd28704f2536ea$var$fails$n(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});
var $bebd28704f2536ea$var$hasOwn$a = $bebd28704f2536ea$var$hasOwnProperty_1;
var $bebd28704f2536ea$var$isCallable$8 = $bebd28704f2536ea$var$isCallable$i;
var $bebd28704f2536ea$var$toObject$b = $bebd28704f2536ea$var$toObject$e;
var $bebd28704f2536ea$var$sharedKey$1 = $bebd28704f2536ea$var$sharedKey$4;
var $bebd28704f2536ea$var$CORRECT_PROTOTYPE_GETTER$1 = $bebd28704f2536ea$var$correctPrototypeGetter;
var $bebd28704f2536ea$var$IE_PROTO = $bebd28704f2536ea$var$sharedKey$1('IE_PROTO');
var $bebd28704f2536ea$var$$Object$1 = Object;
var $bebd28704f2536ea$var$ObjectPrototype$2 = $bebd28704f2536ea$var$$Object$1.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var $bebd28704f2536ea$var$objectGetPrototypeOf = $bebd28704f2536ea$var$CORRECT_PROTOTYPE_GETTER$1 ? $bebd28704f2536ea$var$$Object$1.getPrototypeOf : function(O) {
    var object = $bebd28704f2536ea$var$toObject$b(O);
    if ($bebd28704f2536ea$var$hasOwn$a(object, $bebd28704f2536ea$var$IE_PROTO)) return object[$bebd28704f2536ea$var$IE_PROTO];
    var constructor = object.constructor;
    if ($bebd28704f2536ea$var$isCallable$8(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $bebd28704f2536ea$var$$Object$1 ? $bebd28704f2536ea$var$ObjectPrototype$2 : null;
};
var $bebd28704f2536ea$var$createNonEnumerableProperty$3 = $bebd28704f2536ea$var$createNonEnumerableProperty$6;
var $bebd28704f2536ea$var$defineBuiltIn$5 = function(target, key, value, options) {
    if (options && options.enumerable) target[key] = value;
    else $bebd28704f2536ea$var$createNonEnumerableProperty$3(target, key, value);
    return target;
};
var $bebd28704f2536ea$var$fails$m = $bebd28704f2536ea$var$fails$w;
var $bebd28704f2536ea$var$isCallable$7 = $bebd28704f2536ea$var$isCallable$i;
var $bebd28704f2536ea$var$isObject$c = $bebd28704f2536ea$var$isObject$j;
var $bebd28704f2536ea$var$create$a = $bebd28704f2536ea$var$objectCreate;
var $bebd28704f2536ea$var$getPrototypeOf$8 = $bebd28704f2536ea$var$objectGetPrototypeOf;
var $bebd28704f2536ea$var$defineBuiltIn$4 = $bebd28704f2536ea$var$defineBuiltIn$5;
var $bebd28704f2536ea$var$wellKnownSymbol$i = $bebd28704f2536ea$var$wellKnownSymbol$m;
var $bebd28704f2536ea$var$ITERATOR$6 = $bebd28704f2536ea$var$wellKnownSymbol$i('iterator');
var $bebd28704f2536ea$var$BUGGY_SAFARI_ITERATORS$1 = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $bebd28704f2536ea$var$IteratorPrototype$1, $bebd28704f2536ea$var$PrototypeOfArrayIteratorPrototype, $bebd28704f2536ea$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $bebd28704f2536ea$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!('next' in $bebd28704f2536ea$var$arrayIterator)) $bebd28704f2536ea$var$BUGGY_SAFARI_ITERATORS$1 = true;
    else {
        $bebd28704f2536ea$var$PrototypeOfArrayIteratorPrototype = $bebd28704f2536ea$var$getPrototypeOf$8($bebd28704f2536ea$var$getPrototypeOf$8($bebd28704f2536ea$var$arrayIterator));
        if ($bebd28704f2536ea$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $bebd28704f2536ea$var$IteratorPrototype$1 = $bebd28704f2536ea$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $bebd28704f2536ea$var$NEW_ITERATOR_PROTOTYPE = !$bebd28704f2536ea$var$isObject$c($bebd28704f2536ea$var$IteratorPrototype$1) || $bebd28704f2536ea$var$fails$m(function() {
    var test = {};
    // FF44- legacy iterators case
    return $bebd28704f2536ea$var$IteratorPrototype$1[$bebd28704f2536ea$var$ITERATOR$6].call(test) !== test;
});
if ($bebd28704f2536ea$var$NEW_ITERATOR_PROTOTYPE) $bebd28704f2536ea$var$IteratorPrototype$1 = {};
else $bebd28704f2536ea$var$IteratorPrototype$1 = $bebd28704f2536ea$var$create$a($bebd28704f2536ea$var$IteratorPrototype$1);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$bebd28704f2536ea$var$isCallable$7($bebd28704f2536ea$var$IteratorPrototype$1[$bebd28704f2536ea$var$ITERATOR$6])) $bebd28704f2536ea$var$defineBuiltIn$4($bebd28704f2536ea$var$IteratorPrototype$1, $bebd28704f2536ea$var$ITERATOR$6, function() {
    return this;
});
var $bebd28704f2536ea$var$iteratorsCore = {
    IteratorPrototype: $bebd28704f2536ea$var$IteratorPrototype$1,
    BUGGY_SAFARI_ITERATORS: $bebd28704f2536ea$var$BUGGY_SAFARI_ITERATORS$1
};
var $bebd28704f2536ea$var$TO_STRING_TAG_SUPPORT$1 = $bebd28704f2536ea$var$toStringTagSupport;
var $bebd28704f2536ea$var$classof$b = $bebd28704f2536ea$var$classof$d;
// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
var $bebd28704f2536ea$var$objectToString = $bebd28704f2536ea$var$TO_STRING_TAG_SUPPORT$1 ? ({}).toString : function toString() {
    return '[object ' + $bebd28704f2536ea$var$classof$b(this) + ']';
};
var $bebd28704f2536ea$var$TO_STRING_TAG_SUPPORT = $bebd28704f2536ea$var$toStringTagSupport;
var $bebd28704f2536ea$var$defineProperty$d = $bebd28704f2536ea$var$objectDefineProperty.f;
var $bebd28704f2536ea$var$createNonEnumerableProperty$2 = $bebd28704f2536ea$var$createNonEnumerableProperty$6;
var $bebd28704f2536ea$var$hasOwn$9 = $bebd28704f2536ea$var$hasOwnProperty_1;
var $bebd28704f2536ea$var$toString$8 = $bebd28704f2536ea$var$objectToString;
var $bebd28704f2536ea$var$wellKnownSymbol$h = $bebd28704f2536ea$var$wellKnownSymbol$m;
var $bebd28704f2536ea$var$TO_STRING_TAG$1 = $bebd28704f2536ea$var$wellKnownSymbol$h('toStringTag');
var $bebd28704f2536ea$var$setToStringTag$6 = function(it, TAG, STATIC, SET_METHOD) {
    if (it) {
        var target = STATIC ? it : it.prototype;
        if (!$bebd28704f2536ea$var$hasOwn$9(target, $bebd28704f2536ea$var$TO_STRING_TAG$1)) $bebd28704f2536ea$var$defineProperty$d(target, $bebd28704f2536ea$var$TO_STRING_TAG$1, {
            configurable: true,
            value: TAG
        });
        if (SET_METHOD && !$bebd28704f2536ea$var$TO_STRING_TAG_SUPPORT) $bebd28704f2536ea$var$createNonEnumerableProperty$2(target, 'toString', $bebd28704f2536ea$var$toString$8);
    }
};
var $bebd28704f2536ea$var$iterators = {};
var $bebd28704f2536ea$var$IteratorPrototype = $bebd28704f2536ea$var$iteratorsCore.IteratorPrototype;
var $bebd28704f2536ea$var$create$9 = $bebd28704f2536ea$var$objectCreate;
var $bebd28704f2536ea$var$createPropertyDescriptor$2 = $bebd28704f2536ea$var$createPropertyDescriptor$5;
var $bebd28704f2536ea$var$setToStringTag$5 = $bebd28704f2536ea$var$setToStringTag$6;
var $bebd28704f2536ea$var$Iterators$5 = $bebd28704f2536ea$var$iterators;
var $bebd28704f2536ea$var$returnThis$1 = function() {
    return this;
};
var $bebd28704f2536ea$var$iteratorCreateConstructor = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + ' Iterator';
    IteratorConstructor.prototype = $bebd28704f2536ea$var$create$9($bebd28704f2536ea$var$IteratorPrototype, {
        next: $bebd28704f2536ea$var$createPropertyDescriptor$2(+!ENUMERABLE_NEXT, next)
    });
    $bebd28704f2536ea$var$setToStringTag$5(IteratorConstructor, TO_STRING_TAG, false, true);
    $bebd28704f2536ea$var$Iterators$5[TO_STRING_TAG] = $bebd28704f2536ea$var$returnThis$1;
    return IteratorConstructor;
};
var $bebd28704f2536ea$var$uncurryThis$k = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$aCallable$3 = $bebd28704f2536ea$var$aCallable$7;
var $bebd28704f2536ea$var$functionUncurryThisAccessor = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $bebd28704f2536ea$var$uncurryThis$k($bebd28704f2536ea$var$aCallable$3(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};
var $bebd28704f2536ea$var$isCallable$6 = $bebd28704f2536ea$var$isCallable$i;
var $bebd28704f2536ea$var$$String$1 = String;
var $bebd28704f2536ea$var$$TypeError$a = TypeError;
var $bebd28704f2536ea$var$aPossiblePrototype$1 = function(argument) {
    if (typeof argument == 'object' || $bebd28704f2536ea$var$isCallable$6(argument)) return argument;
    throw new $bebd28704f2536ea$var$$TypeError$a("Can't set " + $bebd28704f2536ea$var$$String$1(argument) + ' as a prototype');
};
/* eslint-disable no-proto -- safe */ var $bebd28704f2536ea$var$uncurryThisAccessor = $bebd28704f2536ea$var$functionUncurryThisAccessor;
var $bebd28704f2536ea$var$anObject$9 = $bebd28704f2536ea$var$anObject$d;
var $bebd28704f2536ea$var$aPossiblePrototype = $bebd28704f2536ea$var$aPossiblePrototype$1;
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var $bebd28704f2536ea$var$objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $bebd28704f2536ea$var$uncurryThisAccessor(Object.prototype, '__proto__', 'set');
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $bebd28704f2536ea$var$anObject$9(O);
        $bebd28704f2536ea$var$aPossiblePrototype(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);
var $bebd28704f2536ea$var$$$M = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$call$8 = $bebd28704f2536ea$var$functionCall;
var $bebd28704f2536ea$var$FunctionName = $bebd28704f2536ea$var$functionName;
var $bebd28704f2536ea$var$createIteratorConstructor = $bebd28704f2536ea$var$iteratorCreateConstructor;
var $bebd28704f2536ea$var$getPrototypeOf$7 = $bebd28704f2536ea$var$objectGetPrototypeOf;
var $bebd28704f2536ea$var$setToStringTag$4 = $bebd28704f2536ea$var$setToStringTag$6;
var $bebd28704f2536ea$var$defineBuiltIn$3 = $bebd28704f2536ea$var$defineBuiltIn$5;
var $bebd28704f2536ea$var$wellKnownSymbol$g = $bebd28704f2536ea$var$wellKnownSymbol$m;
var $bebd28704f2536ea$var$Iterators$4 = $bebd28704f2536ea$var$iterators;
var $bebd28704f2536ea$var$IteratorsCore = $bebd28704f2536ea$var$iteratorsCore;
var $bebd28704f2536ea$var$PROPER_FUNCTION_NAME = $bebd28704f2536ea$var$FunctionName.PROPER;
$bebd28704f2536ea$var$FunctionName.CONFIGURABLE;
$bebd28704f2536ea$var$IteratorsCore.IteratorPrototype;
var $bebd28704f2536ea$var$BUGGY_SAFARI_ITERATORS = $bebd28704f2536ea$var$IteratorsCore.BUGGY_SAFARI_ITERATORS;
var $bebd28704f2536ea$var$ITERATOR$5 = $bebd28704f2536ea$var$wellKnownSymbol$g('iterator');
var $bebd28704f2536ea$var$KEYS = 'keys';
var $bebd28704f2536ea$var$VALUES = 'values';
var $bebd28704f2536ea$var$ENTRIES = 'entries';
var $bebd28704f2536ea$var$returnThis = function() {
    return this;
};
var $bebd28704f2536ea$var$iteratorDefine = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $bebd28704f2536ea$var$createIteratorConstructor(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$bebd28704f2536ea$var$BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $bebd28704f2536ea$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $bebd28704f2536ea$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $bebd28704f2536ea$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + ' Iterator';
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$bebd28704f2536ea$var$ITERATOR$5] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$bebd28704f2536ea$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $bebd28704f2536ea$var$getPrototypeOf$7(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            $bebd28704f2536ea$var$setToStringTag$4(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            $bebd28704f2536ea$var$Iterators$4[TO_STRING_TAG] = $bebd28704f2536ea$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($bebd28704f2536ea$var$PROPER_FUNCTION_NAME && DEFAULT === $bebd28704f2536ea$var$VALUES && nativeIterator && nativeIterator.name !== $bebd28704f2536ea$var$VALUES) {
        INCORRECT_VALUES_NAME = true;
        defaultIterator = function values() {
            return $bebd28704f2536ea$var$call$8(nativeIterator, this);
        };
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($bebd28704f2536ea$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($bebd28704f2536ea$var$KEYS),
            entries: getIterationMethod($bebd28704f2536ea$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($bebd28704f2536ea$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $bebd28704f2536ea$var$defineBuiltIn$3(IterablePrototype, KEY, methods[KEY]);
        } else $bebd28704f2536ea$var$$$M({
            target: NAME,
            proto: true,
            forced: $bebd28704f2536ea$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if (FORCED && IterablePrototype[$bebd28704f2536ea$var$ITERATOR$5] !== defaultIterator) $bebd28704f2536ea$var$defineBuiltIn$3(IterablePrototype, $bebd28704f2536ea$var$ITERATOR$5, defaultIterator, {
        name: DEFAULT
    });
    $bebd28704f2536ea$var$Iterators$4[NAME] = defaultIterator;
    return methods;
};
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var $bebd28704f2536ea$var$createIterResultObject$3 = function(value, done) {
    return {
        value: value,
        done: done
    };
};
var $bebd28704f2536ea$var$charAt$2 = $bebd28704f2536ea$var$stringMultibyte.charAt;
var $bebd28704f2536ea$var$toString$7 = $bebd28704f2536ea$var$toString$a;
var $bebd28704f2536ea$var$InternalStateModule$5 = $bebd28704f2536ea$var$internalState;
var $bebd28704f2536ea$var$defineIterator$2 = $bebd28704f2536ea$var$iteratorDefine;
var $bebd28704f2536ea$var$createIterResultObject$2 = $bebd28704f2536ea$var$createIterResultObject$3;
var $bebd28704f2536ea$var$STRING_ITERATOR = 'String Iterator';
var $bebd28704f2536ea$var$setInternalState$5 = $bebd28704f2536ea$var$InternalStateModule$5.set;
var $bebd28704f2536ea$var$getInternalState$2 = $bebd28704f2536ea$var$InternalStateModule$5.getterFor($bebd28704f2536ea$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$bebd28704f2536ea$var$defineIterator$2(String, 'String', function(iterated) {
    $bebd28704f2536ea$var$setInternalState$5(this, {
        type: $bebd28704f2536ea$var$STRING_ITERATOR,
        string: $bebd28704f2536ea$var$toString$7(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $bebd28704f2536ea$var$getInternalState$2(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $bebd28704f2536ea$var$createIterResultObject$2(undefined, true);
    point = $bebd28704f2536ea$var$charAt$2(string, index);
    state.index += point.length;
    return $bebd28704f2536ea$var$createIterResultObject$2(point, false);
});
var $bebd28704f2536ea$var$call$7 = $bebd28704f2536ea$var$functionCall;
var $bebd28704f2536ea$var$anObject$8 = $bebd28704f2536ea$var$anObject$d;
var $bebd28704f2536ea$var$getMethod$1 = $bebd28704f2536ea$var$getMethod$3;
var $bebd28704f2536ea$var$iteratorClose$2 = function(iterator, kind, value) {
    var innerResult, innerError;
    $bebd28704f2536ea$var$anObject$8(iterator);
    try {
        innerResult = $bebd28704f2536ea$var$getMethod$1(iterator, 'return');
        if (!innerResult) {
            if (kind === 'throw') throw value;
            return value;
        }
        innerResult = $bebd28704f2536ea$var$call$7(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === 'throw') throw value;
    if (innerError) throw innerResult;
    $bebd28704f2536ea$var$anObject$8(innerResult);
    return value;
};
var $bebd28704f2536ea$var$anObject$7 = $bebd28704f2536ea$var$anObject$d;
var $bebd28704f2536ea$var$iteratorClose$1 = $bebd28704f2536ea$var$iteratorClose$2;
// call something on iterator step with safe closing on error
var $bebd28704f2536ea$var$callWithSafeIterationClosing$1 = function(iterator, fn, value, ENTRIES) {
    try {
        return ENTRIES ? fn($bebd28704f2536ea$var$anObject$7(value)[0], value[1]) : fn(value);
    } catch (error) {
        $bebd28704f2536ea$var$iteratorClose$1(iterator, 'throw', error);
    }
};
var $bebd28704f2536ea$var$wellKnownSymbol$f = $bebd28704f2536ea$var$wellKnownSymbol$m;
var $bebd28704f2536ea$var$Iterators$3 = $bebd28704f2536ea$var$iterators;
var $bebd28704f2536ea$var$ITERATOR$4 = $bebd28704f2536ea$var$wellKnownSymbol$f('iterator');
var $bebd28704f2536ea$var$ArrayPrototype$g = Array.prototype;
// check on default Array iterator
var $bebd28704f2536ea$var$isArrayIteratorMethod$2 = function(it) {
    return it !== undefined && ($bebd28704f2536ea$var$Iterators$3.Array === it || $bebd28704f2536ea$var$ArrayPrototype$g[$bebd28704f2536ea$var$ITERATOR$4] === it);
};
var $bebd28704f2536ea$var$uncurryThis$j = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$isCallable$5 = $bebd28704f2536ea$var$isCallable$i;
var $bebd28704f2536ea$var$store = $bebd28704f2536ea$var$sharedStore;
var $bebd28704f2536ea$var$functionToString = $bebd28704f2536ea$var$uncurryThis$j(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$bebd28704f2536ea$var$isCallable$5($bebd28704f2536ea$var$store.inspectSource)) $bebd28704f2536ea$var$store.inspectSource = function(it) {
    return $bebd28704f2536ea$var$functionToString(it);
};
var $bebd28704f2536ea$var$inspectSource$1 = $bebd28704f2536ea$var$store.inspectSource;
var $bebd28704f2536ea$var$uncurryThis$i = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$fails$l = $bebd28704f2536ea$var$fails$w;
var $bebd28704f2536ea$var$isCallable$4 = $bebd28704f2536ea$var$isCallable$i;
var $bebd28704f2536ea$var$classof$a = $bebd28704f2536ea$var$classof$d;
var $bebd28704f2536ea$var$getBuiltIn$9 = $bebd28704f2536ea$var$getBuiltIn$c;
var $bebd28704f2536ea$var$inspectSource = $bebd28704f2536ea$var$inspectSource$1;
var $bebd28704f2536ea$var$noop = function() {};
var $bebd28704f2536ea$var$empty = [];
var $bebd28704f2536ea$var$construct$3 = $bebd28704f2536ea$var$getBuiltIn$9('Reflect', 'construct');
var $bebd28704f2536ea$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $bebd28704f2536ea$var$exec$2 = $bebd28704f2536ea$var$uncurryThis$i($bebd28704f2536ea$var$constructorRegExp.exec);
var $bebd28704f2536ea$var$INCORRECT_TO_STRING = !$bebd28704f2536ea$var$constructorRegExp.test($bebd28704f2536ea$var$noop);
var $bebd28704f2536ea$var$isConstructorModern = function isConstructor(argument) {
    if (!$bebd28704f2536ea$var$isCallable$4(argument)) return false;
    try {
        $bebd28704f2536ea$var$construct$3($bebd28704f2536ea$var$noop, $bebd28704f2536ea$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $bebd28704f2536ea$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$bebd28704f2536ea$var$isCallable$4(argument)) return false;
    switch($bebd28704f2536ea$var$classof$a(argument)){
        case 'AsyncFunction':
        case 'GeneratorFunction':
        case 'AsyncGeneratorFunction':
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $bebd28704f2536ea$var$INCORRECT_TO_STRING || !!$bebd28704f2536ea$var$exec$2($bebd28704f2536ea$var$constructorRegExp, $bebd28704f2536ea$var$inspectSource(argument));
    } catch (error) {
        return true;
    }
};
$bebd28704f2536ea$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var $bebd28704f2536ea$var$isConstructor$4 = !$bebd28704f2536ea$var$construct$3 || $bebd28704f2536ea$var$fails$l(function() {
    var called;
    return $bebd28704f2536ea$var$isConstructorModern($bebd28704f2536ea$var$isConstructorModern.call) || !$bebd28704f2536ea$var$isConstructorModern(Object) || !$bebd28704f2536ea$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $bebd28704f2536ea$var$isConstructorLegacy : $bebd28704f2536ea$var$isConstructorModern;
var $bebd28704f2536ea$var$toPropertyKey$1 = $bebd28704f2536ea$var$toPropertyKey$4;
var $bebd28704f2536ea$var$definePropertyModule$1 = $bebd28704f2536ea$var$objectDefineProperty;
var $bebd28704f2536ea$var$createPropertyDescriptor$1 = $bebd28704f2536ea$var$createPropertyDescriptor$5;
var $bebd28704f2536ea$var$createProperty$6 = function(object, key, value) {
    var propertyKey = $bebd28704f2536ea$var$toPropertyKey$1(key);
    if (propertyKey in object) $bebd28704f2536ea$var$definePropertyModule$1.f(object, propertyKey, $bebd28704f2536ea$var$createPropertyDescriptor$1(0, value));
    else object[propertyKey] = value;
};
var $bebd28704f2536ea$var$classof$9 = $bebd28704f2536ea$var$classof$d;
var $bebd28704f2536ea$var$getMethod = $bebd28704f2536ea$var$getMethod$3;
var $bebd28704f2536ea$var$isNullOrUndefined$3 = $bebd28704f2536ea$var$isNullOrUndefined$6;
var $bebd28704f2536ea$var$Iterators$2 = $bebd28704f2536ea$var$iterators;
var $bebd28704f2536ea$var$wellKnownSymbol$e = $bebd28704f2536ea$var$wellKnownSymbol$m;
var $bebd28704f2536ea$var$ITERATOR$3 = $bebd28704f2536ea$var$wellKnownSymbol$e('iterator');
var $bebd28704f2536ea$var$getIteratorMethod$9 = function(it) {
    if (!$bebd28704f2536ea$var$isNullOrUndefined$3(it)) return $bebd28704f2536ea$var$getMethod(it, $bebd28704f2536ea$var$ITERATOR$3) || $bebd28704f2536ea$var$getMethod(it, '@@iterator') || $bebd28704f2536ea$var$Iterators$2[$bebd28704f2536ea$var$classof$9(it)];
};
var $bebd28704f2536ea$var$call$6 = $bebd28704f2536ea$var$functionCall;
var $bebd28704f2536ea$var$aCallable$2 = $bebd28704f2536ea$var$aCallable$7;
var $bebd28704f2536ea$var$anObject$6 = $bebd28704f2536ea$var$anObject$d;
var $bebd28704f2536ea$var$tryToString$4 = $bebd28704f2536ea$var$tryToString$6;
var $bebd28704f2536ea$var$getIteratorMethod$8 = $bebd28704f2536ea$var$getIteratorMethod$9;
var $bebd28704f2536ea$var$$TypeError$9 = TypeError;
var $bebd28704f2536ea$var$getIterator$2 = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $bebd28704f2536ea$var$getIteratorMethod$8(argument) : usingIterator;
    if ($bebd28704f2536ea$var$aCallable$2(iteratorMethod)) return $bebd28704f2536ea$var$anObject$6($bebd28704f2536ea$var$call$6(iteratorMethod, argument));
    throw new $bebd28704f2536ea$var$$TypeError$9($bebd28704f2536ea$var$tryToString$4(argument) + ' is not iterable');
};
var $bebd28704f2536ea$var$bind$7 = $bebd28704f2536ea$var$functionBindContext;
var $bebd28704f2536ea$var$call$5 = $bebd28704f2536ea$var$functionCall;
var $bebd28704f2536ea$var$toObject$a = $bebd28704f2536ea$var$toObject$e;
var $bebd28704f2536ea$var$callWithSafeIterationClosing = $bebd28704f2536ea$var$callWithSafeIterationClosing$1;
var $bebd28704f2536ea$var$isArrayIteratorMethod$1 = $bebd28704f2536ea$var$isArrayIteratorMethod$2;
var $bebd28704f2536ea$var$isConstructor$3 = $bebd28704f2536ea$var$isConstructor$4;
var $bebd28704f2536ea$var$lengthOfArrayLike$a = $bebd28704f2536ea$var$lengthOfArrayLike$c;
var $bebd28704f2536ea$var$createProperty$5 = $bebd28704f2536ea$var$createProperty$6;
var $bebd28704f2536ea$var$getIterator$1 = $bebd28704f2536ea$var$getIterator$2;
var $bebd28704f2536ea$var$getIteratorMethod$7 = $bebd28704f2536ea$var$getIteratorMethod$9;
var $bebd28704f2536ea$var$$Array$3 = Array;
// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
var $bebd28704f2536ea$var$arrayFrom = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
    var O = $bebd28704f2536ea$var$toObject$a(arrayLike);
    var IS_CONSTRUCTOR = $bebd28704f2536ea$var$isConstructor$3(this);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    if (mapping) mapfn = $bebd28704f2536ea$var$bind$7(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
    var iteratorMethod = $bebd28704f2536ea$var$getIteratorMethod$7(O);
    var index = 0;
    var length1, result, step, iterator, next, value;
    // if the target is not iterable or it's an array with the default iterator - use a simple case
    if (iteratorMethod && !(this === $bebd28704f2536ea$var$$Array$3 && $bebd28704f2536ea$var$isArrayIteratorMethod$1(iteratorMethod))) {
        iterator = $bebd28704f2536ea$var$getIterator$1(O, iteratorMethod);
        next = iterator.next;
        result = IS_CONSTRUCTOR ? new this() : [];
        for(; !(step = $bebd28704f2536ea$var$call$5(next, iterator)).done; index++){
            value = mapping ? $bebd28704f2536ea$var$callWithSafeIterationClosing(iterator, mapfn, [
                step.value,
                index
            ], true) : step.value;
            $bebd28704f2536ea$var$createProperty$5(result, index, value);
        }
    } else {
        length1 = $bebd28704f2536ea$var$lengthOfArrayLike$a(O);
        result = IS_CONSTRUCTOR ? new this(length1) : $bebd28704f2536ea$var$$Array$3(length1);
        for(; length1 > index; index++){
            value = mapping ? mapfn(O[index], index) : O[index];
            $bebd28704f2536ea$var$createProperty$5(result, index, value);
        }
    }
    result.length = index;
    return result;
};
var $bebd28704f2536ea$var$wellKnownSymbol$d = $bebd28704f2536ea$var$wellKnownSymbol$m;
var $bebd28704f2536ea$var$ITERATOR$2 = $bebd28704f2536ea$var$wellKnownSymbol$d('iterator');
var $bebd28704f2536ea$var$SAFE_CLOSING = false;
try {
    var $bebd28704f2536ea$var$called = 0;
    var $bebd28704f2536ea$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$bebd28704f2536ea$var$called++
            };
        },
        'return': function() {
            $bebd28704f2536ea$var$SAFE_CLOSING = true;
        }
    };
    $bebd28704f2536ea$var$iteratorWithReturn[$bebd28704f2536ea$var$ITERATOR$2] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($bebd28704f2536ea$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
var $bebd28704f2536ea$var$checkCorrectnessOfIteration$1 = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !$bebd28704f2536ea$var$SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$bebd28704f2536ea$var$ITERATOR$2] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};
var $bebd28704f2536ea$var$$$L = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$from$6 = $bebd28704f2536ea$var$arrayFrom;
var $bebd28704f2536ea$var$checkCorrectnessOfIteration = $bebd28704f2536ea$var$checkCorrectnessOfIteration$1;
var $bebd28704f2536ea$var$INCORRECT_ITERATION = !$bebd28704f2536ea$var$checkCorrectnessOfIteration(function(iterable) {
    // eslint-disable-next-line es/no-array-from -- required for testing
    Array.from(iterable);
});
// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$bebd28704f2536ea$var$$$L({
    target: 'Array',
    stat: true,
    forced: $bebd28704f2536ea$var$INCORRECT_ITERATION
}, {
    from: $bebd28704f2536ea$var$from$6
});
var $bebd28704f2536ea$var$path$r = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$from$5 = $bebd28704f2536ea$var$path$r.Array.from;
var $bebd28704f2536ea$var$parent$19 = $bebd28704f2536ea$var$from$5;
var $bebd28704f2536ea$var$from$4 = $bebd28704f2536ea$var$parent$19;
var $bebd28704f2536ea$var$from$3 = $bebd28704f2536ea$var$from$4;
var $bebd28704f2536ea$var$_Array$from$1 = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$from$3);
var $bebd28704f2536ea$var$toIndexedObject$5 = $bebd28704f2536ea$var$toIndexedObject$a;
var $bebd28704f2536ea$var$Iterators$1 = $bebd28704f2536ea$var$iterators;
var $bebd28704f2536ea$var$InternalStateModule$4 = $bebd28704f2536ea$var$internalState;
$bebd28704f2536ea$var$objectDefineProperty.f;
var $bebd28704f2536ea$var$defineIterator$1 = $bebd28704f2536ea$var$iteratorDefine;
var $bebd28704f2536ea$var$createIterResultObject$1 = $bebd28704f2536ea$var$createIterResultObject$3;
var $bebd28704f2536ea$var$ARRAY_ITERATOR = 'Array Iterator';
var $bebd28704f2536ea$var$setInternalState$4 = $bebd28704f2536ea$var$InternalStateModule$4.set;
var $bebd28704f2536ea$var$getInternalState$1 = $bebd28704f2536ea$var$InternalStateModule$4.getterFor($bebd28704f2536ea$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
$bebd28704f2536ea$var$defineIterator$1(Array, 'Array', function(iterated, kind) {
    $bebd28704f2536ea$var$setInternalState$4(this, {
        type: $bebd28704f2536ea$var$ARRAY_ITERATOR,
        target: $bebd28704f2536ea$var$toIndexedObject$5(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $bebd28704f2536ea$var$getInternalState$1(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return $bebd28704f2536ea$var$createIterResultObject$1(undefined, true);
    }
    switch(kind){
        case 'keys':
            return $bebd28704f2536ea$var$createIterResultObject$1(index, false);
        case 'values':
            return $bebd28704f2536ea$var$createIterResultObject$1(target[index], false);
    }
    return $bebd28704f2536ea$var$createIterResultObject$1([
        index,
        target[index]
    ], false);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
$bebd28704f2536ea$var$Iterators$1.Arguments = $bebd28704f2536ea$var$Iterators$1.Array;
var $bebd28704f2536ea$var$getIteratorMethod$6 = $bebd28704f2536ea$var$getIteratorMethod$9;
var $bebd28704f2536ea$var$getIteratorMethod_1 = $bebd28704f2536ea$var$getIteratorMethod$6;
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var $bebd28704f2536ea$var$domIterables = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};
var $bebd28704f2536ea$var$DOMIterables$2 = $bebd28704f2536ea$var$domIterables;
var $bebd28704f2536ea$var$global$c = $bebd28704f2536ea$var$global$n;
var $bebd28704f2536ea$var$classof$8 = $bebd28704f2536ea$var$classof$d;
var $bebd28704f2536ea$var$createNonEnumerableProperty$1 = $bebd28704f2536ea$var$createNonEnumerableProperty$6;
var $bebd28704f2536ea$var$Iterators = $bebd28704f2536ea$var$iterators;
var $bebd28704f2536ea$var$wellKnownSymbol$c = $bebd28704f2536ea$var$wellKnownSymbol$m;
var $bebd28704f2536ea$var$TO_STRING_TAG = $bebd28704f2536ea$var$wellKnownSymbol$c('toStringTag');
for(var $bebd28704f2536ea$var$COLLECTION_NAME in $bebd28704f2536ea$var$DOMIterables$2){
    var $bebd28704f2536ea$var$Collection = $bebd28704f2536ea$var$global$c[$bebd28704f2536ea$var$COLLECTION_NAME];
    var $bebd28704f2536ea$var$CollectionPrototype = $bebd28704f2536ea$var$Collection && $bebd28704f2536ea$var$Collection.prototype;
    if ($bebd28704f2536ea$var$CollectionPrototype && $bebd28704f2536ea$var$classof$8($bebd28704f2536ea$var$CollectionPrototype) !== $bebd28704f2536ea$var$TO_STRING_TAG) $bebd28704f2536ea$var$createNonEnumerableProperty$1($bebd28704f2536ea$var$CollectionPrototype, $bebd28704f2536ea$var$TO_STRING_TAG, $bebd28704f2536ea$var$COLLECTION_NAME);
    $bebd28704f2536ea$var$Iterators[$bebd28704f2536ea$var$COLLECTION_NAME] = $bebd28704f2536ea$var$Iterators.Array;
}
var $bebd28704f2536ea$var$parent$18 = $bebd28704f2536ea$var$getIteratorMethod_1;
var $bebd28704f2536ea$var$getIteratorMethod$5 = $bebd28704f2536ea$var$parent$18;
var $bebd28704f2536ea$var$parent$17 = $bebd28704f2536ea$var$getIteratorMethod$5;
var $bebd28704f2536ea$var$getIteratorMethod$4 = $bebd28704f2536ea$var$parent$17;
var $bebd28704f2536ea$var$parent$16 = $bebd28704f2536ea$var$getIteratorMethod$4;
var $bebd28704f2536ea$var$getIteratorMethod$3 = $bebd28704f2536ea$var$parent$16;
var $bebd28704f2536ea$var$getIteratorMethod$2 = $bebd28704f2536ea$var$getIteratorMethod$3;
var $bebd28704f2536ea$var$_getIteratorMethod$1 = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$getIteratorMethod$2);
var $bebd28704f2536ea$var$getIteratorMethod$1 = $bebd28704f2536ea$var$getIteratorMethod$2;
var $bebd28704f2536ea$var$_getIteratorMethod = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$getIteratorMethod$1);
function $bebd28704f2536ea$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $bebd28704f2536ea$var$defineProperty$c = {
    exports: {}
};
var $bebd28704f2536ea$var$$$K = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$DESCRIPTORS$9 = $bebd28704f2536ea$var$descriptors;
var $bebd28704f2536ea$var$defineProperty$b = $bebd28704f2536ea$var$objectDefineProperty.f;
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
// eslint-disable-next-line es/no-object-defineproperty -- safe
$bebd28704f2536ea$var$$$K({
    target: 'Object',
    stat: true,
    forced: Object.defineProperty !== $bebd28704f2536ea$var$defineProperty$b,
    sham: !$bebd28704f2536ea$var$DESCRIPTORS$9
}, {
    defineProperty: $bebd28704f2536ea$var$defineProperty$b
});
var $bebd28704f2536ea$var$path$q = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$Object$5 = $bebd28704f2536ea$var$path$q.Object;
var $bebd28704f2536ea$var$defineProperty$a = $bebd28704f2536ea$var$defineProperty$c.exports = function defineProperty(it, key, desc) {
    return $bebd28704f2536ea$var$Object$5.defineProperty(it, key, desc);
};
if ($bebd28704f2536ea$var$Object$5.defineProperty.sham) $bebd28704f2536ea$var$defineProperty$a.sham = true;
var $bebd28704f2536ea$var$definePropertyExports = $bebd28704f2536ea$var$defineProperty$c.exports;
var $bebd28704f2536ea$var$parent$15 = $bebd28704f2536ea$var$definePropertyExports;
var $bebd28704f2536ea$var$defineProperty$9 = $bebd28704f2536ea$var$parent$15;
var $bebd28704f2536ea$var$parent$14 = $bebd28704f2536ea$var$defineProperty$9;
var $bebd28704f2536ea$var$defineProperty$8 = $bebd28704f2536ea$var$parent$14;
var $bebd28704f2536ea$var$parent$13 = $bebd28704f2536ea$var$defineProperty$8;
var $bebd28704f2536ea$var$defineProperty$7 = $bebd28704f2536ea$var$parent$13;
var $bebd28704f2536ea$var$defineProperty$6 = $bebd28704f2536ea$var$defineProperty$7;
var $bebd28704f2536ea$var$_Object$defineProperty$1 = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$defineProperty$6);
var $bebd28704f2536ea$var$classof$7 = $bebd28704f2536ea$var$classofRaw$2;
// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var $bebd28704f2536ea$var$isArray$e = Array.isArray || function isArray(argument) {
    return $bebd28704f2536ea$var$classof$7(argument) === 'Array';
};
var $bebd28704f2536ea$var$$TypeError$8 = TypeError;
var $bebd28704f2536ea$var$MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991
var $bebd28704f2536ea$var$doesNotExceedSafeInteger$3 = function(it) {
    if (it > $bebd28704f2536ea$var$MAX_SAFE_INTEGER) throw $bebd28704f2536ea$var$$TypeError$8('Maximum allowed index exceeded');
    return it;
};
var $bebd28704f2536ea$var$isArray$d = $bebd28704f2536ea$var$isArray$e;
var $bebd28704f2536ea$var$isConstructor$2 = $bebd28704f2536ea$var$isConstructor$4;
var $bebd28704f2536ea$var$isObject$b = $bebd28704f2536ea$var$isObject$j;
var $bebd28704f2536ea$var$wellKnownSymbol$b = $bebd28704f2536ea$var$wellKnownSymbol$m;
var $bebd28704f2536ea$var$SPECIES$3 = $bebd28704f2536ea$var$wellKnownSymbol$b('species');
var $bebd28704f2536ea$var$$Array$2 = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var $bebd28704f2536ea$var$arraySpeciesConstructor$1 = function(originalArray) {
    var C;
    if ($bebd28704f2536ea$var$isArray$d(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($bebd28704f2536ea$var$isConstructor$2(C) && (C === $bebd28704f2536ea$var$$Array$2 || $bebd28704f2536ea$var$isArray$d(C.prototype))) C = undefined;
        else if ($bebd28704f2536ea$var$isObject$b(C)) {
            C = C[$bebd28704f2536ea$var$SPECIES$3];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $bebd28704f2536ea$var$$Array$2 : C;
};
var $bebd28704f2536ea$var$arraySpeciesConstructor = $bebd28704f2536ea$var$arraySpeciesConstructor$1;
// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var $bebd28704f2536ea$var$arraySpeciesCreate$3 = function(originalArray, length1) {
    return new ($bebd28704f2536ea$var$arraySpeciesConstructor(originalArray))(length1 === 0 ? 0 : length1);
};
var $bebd28704f2536ea$var$fails$k = $bebd28704f2536ea$var$fails$w;
var $bebd28704f2536ea$var$wellKnownSymbol$a = $bebd28704f2536ea$var$wellKnownSymbol$m;
var $bebd28704f2536ea$var$V8_VERSION$1 = $bebd28704f2536ea$var$engineV8Version;
var $bebd28704f2536ea$var$SPECIES$2 = $bebd28704f2536ea$var$wellKnownSymbol$a('species');
var $bebd28704f2536ea$var$arrayMethodHasSpeciesSupport$5 = function(METHOD_NAME) {
    // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/677
    return $bebd28704f2536ea$var$V8_VERSION$1 >= 51 || !$bebd28704f2536ea$var$fails$k(function() {
        var array = [];
        var constructor = array.constructor = {};
        constructor[$bebd28704f2536ea$var$SPECIES$2] = function() {
            return {
                foo: 1
            };
        };
        return array[METHOD_NAME](Boolean).foo !== 1;
    });
};
var $bebd28704f2536ea$var$$$J = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$fails$j = $bebd28704f2536ea$var$fails$w;
var $bebd28704f2536ea$var$isArray$c = $bebd28704f2536ea$var$isArray$e;
var $bebd28704f2536ea$var$isObject$a = $bebd28704f2536ea$var$isObject$j;
var $bebd28704f2536ea$var$toObject$9 = $bebd28704f2536ea$var$toObject$e;
var $bebd28704f2536ea$var$lengthOfArrayLike$9 = $bebd28704f2536ea$var$lengthOfArrayLike$c;
var $bebd28704f2536ea$var$doesNotExceedSafeInteger$2 = $bebd28704f2536ea$var$doesNotExceedSafeInteger$3;
var $bebd28704f2536ea$var$createProperty$4 = $bebd28704f2536ea$var$createProperty$6;
var $bebd28704f2536ea$var$arraySpeciesCreate$2 = $bebd28704f2536ea$var$arraySpeciesCreate$3;
var $bebd28704f2536ea$var$arrayMethodHasSpeciesSupport$4 = $bebd28704f2536ea$var$arrayMethodHasSpeciesSupport$5;
var $bebd28704f2536ea$var$wellKnownSymbol$9 = $bebd28704f2536ea$var$wellKnownSymbol$m;
var $bebd28704f2536ea$var$V8_VERSION = $bebd28704f2536ea$var$engineV8Version;
var $bebd28704f2536ea$var$IS_CONCAT_SPREADABLE = $bebd28704f2536ea$var$wellKnownSymbol$9('isConcatSpreadable');
// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var $bebd28704f2536ea$var$IS_CONCAT_SPREADABLE_SUPPORT = $bebd28704f2536ea$var$V8_VERSION >= 51 || !$bebd28704f2536ea$var$fails$j(function() {
    var array = [];
    array[$bebd28704f2536ea$var$IS_CONCAT_SPREADABLE] = false;
    return array.concat()[0] !== array;
});
var $bebd28704f2536ea$var$isConcatSpreadable = function(O) {
    if (!$bebd28704f2536ea$var$isObject$a(O)) return false;
    var spreadable = O[$bebd28704f2536ea$var$IS_CONCAT_SPREADABLE];
    return spreadable !== undefined ? !!spreadable : $bebd28704f2536ea$var$isArray$c(O);
};
var $bebd28704f2536ea$var$FORCED$a = !$bebd28704f2536ea$var$IS_CONCAT_SPREADABLE_SUPPORT || !$bebd28704f2536ea$var$arrayMethodHasSpeciesSupport$4('concat');
// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$bebd28704f2536ea$var$$$J({
    target: 'Array',
    proto: true,
    arity: 1,
    forced: $bebd28704f2536ea$var$FORCED$a
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    concat: function concat(arg) {
        var O = $bebd28704f2536ea$var$toObject$9(this);
        var A = $bebd28704f2536ea$var$arraySpeciesCreate$2(O, 0);
        var n = 0;
        var i, k, length1, len, E;
        for(i = -1, length1 = arguments.length; i < length1; i++){
            E = i === -1 ? O : arguments[i];
            if ($bebd28704f2536ea$var$isConcatSpreadable(E)) {
                len = $bebd28704f2536ea$var$lengthOfArrayLike$9(E);
                $bebd28704f2536ea$var$doesNotExceedSafeInteger$2(n + len);
                for(k = 0; k < len; k++, n++)if (k in E) $bebd28704f2536ea$var$createProperty$4(A, n, E[k]);
            } else {
                $bebd28704f2536ea$var$doesNotExceedSafeInteger$2(n + 1);
                $bebd28704f2536ea$var$createProperty$4(A, n++, E);
            }
        }
        A.length = n;
        return A;
    }
});
var $bebd28704f2536ea$var$objectGetOwnPropertyNames = {};
var $bebd28704f2536ea$var$internalObjectKeys = $bebd28704f2536ea$var$objectKeysInternal;
var $bebd28704f2536ea$var$enumBugKeys = $bebd28704f2536ea$var$enumBugKeys$3;
var $bebd28704f2536ea$var$hiddenKeys$2 = $bebd28704f2536ea$var$enumBugKeys.concat('length', 'prototype');
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
$bebd28704f2536ea$var$objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $bebd28704f2536ea$var$internalObjectKeys(O, $bebd28704f2536ea$var$hiddenKeys$2);
};
var $bebd28704f2536ea$var$objectGetOwnPropertyNamesExternal = {};
var $bebd28704f2536ea$var$toAbsoluteIndex$3 = $bebd28704f2536ea$var$toAbsoluteIndex$5;
var $bebd28704f2536ea$var$lengthOfArrayLike$8 = $bebd28704f2536ea$var$lengthOfArrayLike$c;
var $bebd28704f2536ea$var$createProperty$3 = $bebd28704f2536ea$var$createProperty$6;
var $bebd28704f2536ea$var$$Array$1 = Array;
var $bebd28704f2536ea$var$max$2 = Math.max;
var $bebd28704f2536ea$var$arraySliceSimple = function(O, start, end) {
    var length1 = $bebd28704f2536ea$var$lengthOfArrayLike$8(O);
    var k = $bebd28704f2536ea$var$toAbsoluteIndex$3(start, length1);
    var fin = $bebd28704f2536ea$var$toAbsoluteIndex$3(end === undefined ? length1 : end, length1);
    var result = $bebd28704f2536ea$var$$Array$1($bebd28704f2536ea$var$max$2(fin - k, 0));
    var n = 0;
    for(; k < fin; k++, n++)$bebd28704f2536ea$var$createProperty$3(result, n, O[k]);
    result.length = n;
    return result;
};
/* eslint-disable es/no-object-getownpropertynames -- safe */ var $bebd28704f2536ea$var$classof$6 = $bebd28704f2536ea$var$classofRaw$2;
var $bebd28704f2536ea$var$toIndexedObject$4 = $bebd28704f2536ea$var$toIndexedObject$a;
var $bebd28704f2536ea$var$$getOwnPropertyNames$1 = $bebd28704f2536ea$var$objectGetOwnPropertyNames.f;
var $bebd28704f2536ea$var$arraySlice$3 = $bebd28704f2536ea$var$arraySliceSimple;
var $bebd28704f2536ea$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $bebd28704f2536ea$var$getWindowNames = function(it) {
    try {
        return $bebd28704f2536ea$var$$getOwnPropertyNames$1(it);
    } catch (error) {
        return $bebd28704f2536ea$var$arraySlice$3($bebd28704f2536ea$var$windowNames);
    }
};
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
$bebd28704f2536ea$var$objectGetOwnPropertyNamesExternal.f = function getOwnPropertyNames(it) {
    return $bebd28704f2536ea$var$windowNames && $bebd28704f2536ea$var$classof$6(it) === 'Window' ? $bebd28704f2536ea$var$getWindowNames(it) : $bebd28704f2536ea$var$$getOwnPropertyNames$1($bebd28704f2536ea$var$toIndexedObject$4(it));
};
var $bebd28704f2536ea$var$defineProperty$5 = $bebd28704f2536ea$var$objectDefineProperty;
var $bebd28704f2536ea$var$defineBuiltInAccessor$3 = function(target, name, descriptor) {
    return $bebd28704f2536ea$var$defineProperty$5.f(target, name, descriptor);
};
var $bebd28704f2536ea$var$wellKnownSymbolWrapped = {};
var $bebd28704f2536ea$var$wellKnownSymbol$8 = $bebd28704f2536ea$var$wellKnownSymbol$m;
$bebd28704f2536ea$var$wellKnownSymbolWrapped.f = $bebd28704f2536ea$var$wellKnownSymbol$8;
var $bebd28704f2536ea$var$path$p = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$hasOwn$8 = $bebd28704f2536ea$var$hasOwnProperty_1;
var $bebd28704f2536ea$var$wrappedWellKnownSymbolModule$1 = $bebd28704f2536ea$var$wellKnownSymbolWrapped;
var $bebd28704f2536ea$var$defineProperty$4 = $bebd28704f2536ea$var$objectDefineProperty.f;
var $bebd28704f2536ea$var$wellKnownSymbolDefine = function(NAME) {
    var Symbol1 = $bebd28704f2536ea$var$path$p.Symbol || ($bebd28704f2536ea$var$path$p.Symbol = {});
    if (!$bebd28704f2536ea$var$hasOwn$8(Symbol1, NAME)) $bebd28704f2536ea$var$defineProperty$4(Symbol1, NAME, {
        value: $bebd28704f2536ea$var$wrappedWellKnownSymbolModule$1.f(NAME)
    });
};
var $bebd28704f2536ea$var$call$4 = $bebd28704f2536ea$var$functionCall;
var $bebd28704f2536ea$var$getBuiltIn$8 = $bebd28704f2536ea$var$getBuiltIn$c;
var $bebd28704f2536ea$var$wellKnownSymbol$7 = $bebd28704f2536ea$var$wellKnownSymbol$m;
var $bebd28704f2536ea$var$defineBuiltIn$2 = $bebd28704f2536ea$var$defineBuiltIn$5;
var $bebd28704f2536ea$var$symbolDefineToPrimitive = function() {
    var Symbol1 = $bebd28704f2536ea$var$getBuiltIn$8('Symbol');
    var SymbolPrototype = Symbol1 && Symbol1.prototype;
    var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
    var TO_PRIMITIVE = $bebd28704f2536ea$var$wellKnownSymbol$7('toPrimitive');
    if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    $bebd28704f2536ea$var$defineBuiltIn$2(SymbolPrototype, TO_PRIMITIVE, function(hint) {
        return $bebd28704f2536ea$var$call$4(valueOf, this);
    }, {
        arity: 1
    });
};
var $bebd28704f2536ea$var$bind$6 = $bebd28704f2536ea$var$functionBindContext;
var $bebd28704f2536ea$var$uncurryThis$h = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$IndexedObject$1 = $bebd28704f2536ea$var$indexedObject;
var $bebd28704f2536ea$var$toObject$8 = $bebd28704f2536ea$var$toObject$e;
var $bebd28704f2536ea$var$lengthOfArrayLike$7 = $bebd28704f2536ea$var$lengthOfArrayLike$c;
var $bebd28704f2536ea$var$arraySpeciesCreate$1 = $bebd28704f2536ea$var$arraySpeciesCreate$3;
var $bebd28704f2536ea$var$push$a = $bebd28704f2536ea$var$uncurryThis$h([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $bebd28704f2536ea$var$createMethod$2 = function(TYPE) {
    var IS_MAP = TYPE === 1;
    var IS_FILTER = TYPE === 2;
    var IS_SOME = TYPE === 3;
    var IS_EVERY = TYPE === 4;
    var IS_FIND_INDEX = TYPE === 6;
    var IS_FILTER_REJECT = TYPE === 7;
    var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $bebd28704f2536ea$var$toObject$8($this);
        var self1 = $bebd28704f2536ea$var$IndexedObject$1(O);
        var boundFunction = $bebd28704f2536ea$var$bind$6(callbackfn, that);
        var length1 = $bebd28704f2536ea$var$lengthOfArrayLike$7(self1);
        var index = 0;
        var create = specificCreate || $bebd28704f2536ea$var$arraySpeciesCreate$1;
        var target = IS_MAP ? create($this, length1) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length1 > index; index++)if (NO_HOLES || index in self1) {
            value = self1[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $bebd28704f2536ea$var$push$a(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $bebd28704f2536ea$var$push$a(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
var $bebd28704f2536ea$var$arrayIteration = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $bebd28704f2536ea$var$createMethod$2(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $bebd28704f2536ea$var$createMethod$2(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $bebd28704f2536ea$var$createMethod$2(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $bebd28704f2536ea$var$createMethod$2(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $bebd28704f2536ea$var$createMethod$2(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $bebd28704f2536ea$var$createMethod$2(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $bebd28704f2536ea$var$createMethod$2(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $bebd28704f2536ea$var$createMethod$2(7)
};
var $bebd28704f2536ea$var$$$I = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$global$b = $bebd28704f2536ea$var$global$n;
var $bebd28704f2536ea$var$call$3 = $bebd28704f2536ea$var$functionCall;
var $bebd28704f2536ea$var$uncurryThis$g = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$DESCRIPTORS$8 = $bebd28704f2536ea$var$descriptors;
var $bebd28704f2536ea$var$NATIVE_SYMBOL$3 = $bebd28704f2536ea$var$symbolConstructorDetection;
var $bebd28704f2536ea$var$fails$i = $bebd28704f2536ea$var$fails$w;
var $bebd28704f2536ea$var$hasOwn$7 = $bebd28704f2536ea$var$hasOwnProperty_1;
var $bebd28704f2536ea$var$isPrototypeOf$i = $bebd28704f2536ea$var$objectIsPrototypeOf;
var $bebd28704f2536ea$var$anObject$5 = $bebd28704f2536ea$var$anObject$d;
var $bebd28704f2536ea$var$toIndexedObject$3 = $bebd28704f2536ea$var$toIndexedObject$a;
var $bebd28704f2536ea$var$toPropertyKey = $bebd28704f2536ea$var$toPropertyKey$4;
var $bebd28704f2536ea$var$$toString = $bebd28704f2536ea$var$toString$a;
var $bebd28704f2536ea$var$createPropertyDescriptor = $bebd28704f2536ea$var$createPropertyDescriptor$5;
var $bebd28704f2536ea$var$nativeObjectCreate = $bebd28704f2536ea$var$objectCreate;
var $bebd28704f2536ea$var$objectKeys = $bebd28704f2536ea$var$objectKeys$3;
var $bebd28704f2536ea$var$getOwnPropertyNamesModule$2 = $bebd28704f2536ea$var$objectGetOwnPropertyNames;
var $bebd28704f2536ea$var$getOwnPropertyNamesExternal = $bebd28704f2536ea$var$objectGetOwnPropertyNamesExternal;
var $bebd28704f2536ea$var$getOwnPropertySymbolsModule$2 = $bebd28704f2536ea$var$objectGetOwnPropertySymbols;
var $bebd28704f2536ea$var$getOwnPropertyDescriptorModule$2 = $bebd28704f2536ea$var$objectGetOwnPropertyDescriptor;
var $bebd28704f2536ea$var$definePropertyModule = $bebd28704f2536ea$var$objectDefineProperty;
var $bebd28704f2536ea$var$definePropertiesModule = $bebd28704f2536ea$var$objectDefineProperties;
var $bebd28704f2536ea$var$propertyIsEnumerableModule = $bebd28704f2536ea$var$objectPropertyIsEnumerable;
var $bebd28704f2536ea$var$defineBuiltIn$1 = $bebd28704f2536ea$var$defineBuiltIn$5;
var $bebd28704f2536ea$var$defineBuiltInAccessor$2 = $bebd28704f2536ea$var$defineBuiltInAccessor$3;
var $bebd28704f2536ea$var$shared$3 = $bebd28704f2536ea$var$sharedExports;
var $bebd28704f2536ea$var$sharedKey = $bebd28704f2536ea$var$sharedKey$4;
var $bebd28704f2536ea$var$hiddenKeys$1 = $bebd28704f2536ea$var$hiddenKeys$6;
var $bebd28704f2536ea$var$uid$1 = $bebd28704f2536ea$var$uid$4;
var $bebd28704f2536ea$var$wellKnownSymbol$6 = $bebd28704f2536ea$var$wellKnownSymbol$m;
var $bebd28704f2536ea$var$wrappedWellKnownSymbolModule = $bebd28704f2536ea$var$wellKnownSymbolWrapped;
var $bebd28704f2536ea$var$defineWellKnownSymbol$l = $bebd28704f2536ea$var$wellKnownSymbolDefine;
var $bebd28704f2536ea$var$defineSymbolToPrimitive$1 = $bebd28704f2536ea$var$symbolDefineToPrimitive;
var $bebd28704f2536ea$var$setToStringTag$3 = $bebd28704f2536ea$var$setToStringTag$6;
var $bebd28704f2536ea$var$InternalStateModule$3 = $bebd28704f2536ea$var$internalState;
var $bebd28704f2536ea$var$$forEach$1 = $bebd28704f2536ea$var$arrayIteration.forEach;
var $bebd28704f2536ea$var$HIDDEN = $bebd28704f2536ea$var$sharedKey('hidden');
var $bebd28704f2536ea$var$SYMBOL = 'Symbol';
var $bebd28704f2536ea$var$PROTOTYPE = 'prototype';
var $bebd28704f2536ea$var$setInternalState$3 = $bebd28704f2536ea$var$InternalStateModule$3.set;
var $bebd28704f2536ea$var$getInternalState = $bebd28704f2536ea$var$InternalStateModule$3.getterFor($bebd28704f2536ea$var$SYMBOL);
var $bebd28704f2536ea$var$ObjectPrototype$1 = Object[$bebd28704f2536ea$var$PROTOTYPE];
var $bebd28704f2536ea$var$$Symbol = $bebd28704f2536ea$var$global$b.Symbol;
var $bebd28704f2536ea$var$SymbolPrototype = $bebd28704f2536ea$var$$Symbol && $bebd28704f2536ea$var$$Symbol[$bebd28704f2536ea$var$PROTOTYPE];
var $bebd28704f2536ea$var$RangeError$1 = $bebd28704f2536ea$var$global$b.RangeError;
var $bebd28704f2536ea$var$TypeError$1 = $bebd28704f2536ea$var$global$b.TypeError;
var $bebd28704f2536ea$var$QObject = $bebd28704f2536ea$var$global$b.QObject;
var $bebd28704f2536ea$var$nativeGetOwnPropertyDescriptor$1 = $bebd28704f2536ea$var$getOwnPropertyDescriptorModule$2.f;
var $bebd28704f2536ea$var$nativeDefineProperty = $bebd28704f2536ea$var$definePropertyModule.f;
var $bebd28704f2536ea$var$nativeGetOwnPropertyNames = $bebd28704f2536ea$var$getOwnPropertyNamesExternal.f;
var $bebd28704f2536ea$var$nativePropertyIsEnumerable = $bebd28704f2536ea$var$propertyIsEnumerableModule.f;
var $bebd28704f2536ea$var$push$9 = $bebd28704f2536ea$var$uncurryThis$g([].push);
var $bebd28704f2536ea$var$AllSymbols = $bebd28704f2536ea$var$shared$3('symbols');
var $bebd28704f2536ea$var$ObjectPrototypeSymbols = $bebd28704f2536ea$var$shared$3('op-symbols');
var $bebd28704f2536ea$var$WellKnownSymbolsStore$1 = $bebd28704f2536ea$var$shared$3('wks');
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $bebd28704f2536ea$var$USE_SETTER = !$bebd28704f2536ea$var$QObject || !$bebd28704f2536ea$var$QObject[$bebd28704f2536ea$var$PROTOTYPE] || !$bebd28704f2536ea$var$QObject[$bebd28704f2536ea$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $bebd28704f2536ea$var$fallbackDefineProperty = function(O, P, Attributes) {
    var ObjectPrototypeDescriptor = $bebd28704f2536ea$var$nativeGetOwnPropertyDescriptor$1($bebd28704f2536ea$var$ObjectPrototype$1, P);
    if (ObjectPrototypeDescriptor) delete $bebd28704f2536ea$var$ObjectPrototype$1[P];
    $bebd28704f2536ea$var$nativeDefineProperty(O, P, Attributes);
    if (ObjectPrototypeDescriptor && O !== $bebd28704f2536ea$var$ObjectPrototype$1) $bebd28704f2536ea$var$nativeDefineProperty($bebd28704f2536ea$var$ObjectPrototype$1, P, ObjectPrototypeDescriptor);
};
var $bebd28704f2536ea$var$setSymbolDescriptor = $bebd28704f2536ea$var$DESCRIPTORS$8 && $bebd28704f2536ea$var$fails$i(function() {
    return $bebd28704f2536ea$var$nativeObjectCreate($bebd28704f2536ea$var$nativeDefineProperty({}, 'a', {
        get: function() {
            return $bebd28704f2536ea$var$nativeDefineProperty(this, 'a', {
                value: 7
            }).a;
        }
    })).a !== 7;
}) ? $bebd28704f2536ea$var$fallbackDefineProperty : $bebd28704f2536ea$var$nativeDefineProperty;
var $bebd28704f2536ea$var$wrap = function(tag, description) {
    var symbol = $bebd28704f2536ea$var$AllSymbols[tag] = $bebd28704f2536ea$var$nativeObjectCreate($bebd28704f2536ea$var$SymbolPrototype);
    $bebd28704f2536ea$var$setInternalState$3(symbol, {
        type: $bebd28704f2536ea$var$SYMBOL,
        tag: tag,
        description: description
    });
    if (!$bebd28704f2536ea$var$DESCRIPTORS$8) symbol.description = description;
    return symbol;
};
var $bebd28704f2536ea$var$$defineProperty = function defineProperty(O, P, Attributes) {
    if (O === $bebd28704f2536ea$var$ObjectPrototype$1) $bebd28704f2536ea$var$$defineProperty($bebd28704f2536ea$var$ObjectPrototypeSymbols, P, Attributes);
    $bebd28704f2536ea$var$anObject$5(O);
    var key = $bebd28704f2536ea$var$toPropertyKey(P);
    $bebd28704f2536ea$var$anObject$5(Attributes);
    if ($bebd28704f2536ea$var$hasOwn$7($bebd28704f2536ea$var$AllSymbols, key)) {
        if (!Attributes.enumerable) {
            if (!$bebd28704f2536ea$var$hasOwn$7(O, $bebd28704f2536ea$var$HIDDEN)) $bebd28704f2536ea$var$nativeDefineProperty(O, $bebd28704f2536ea$var$HIDDEN, $bebd28704f2536ea$var$createPropertyDescriptor(1, {}));
            O[$bebd28704f2536ea$var$HIDDEN][key] = true;
        } else {
            if ($bebd28704f2536ea$var$hasOwn$7(O, $bebd28704f2536ea$var$HIDDEN) && O[$bebd28704f2536ea$var$HIDDEN][key]) O[$bebd28704f2536ea$var$HIDDEN][key] = false;
            Attributes = $bebd28704f2536ea$var$nativeObjectCreate(Attributes, {
                enumerable: $bebd28704f2536ea$var$createPropertyDescriptor(0, false)
            });
        }
        return $bebd28704f2536ea$var$setSymbolDescriptor(O, key, Attributes);
    }
    return $bebd28704f2536ea$var$nativeDefineProperty(O, key, Attributes);
};
var $bebd28704f2536ea$var$$defineProperties = function defineProperties(O, Properties) {
    $bebd28704f2536ea$var$anObject$5(O);
    var properties = $bebd28704f2536ea$var$toIndexedObject$3(Properties);
    var keys = $bebd28704f2536ea$var$objectKeys(properties).concat($bebd28704f2536ea$var$$getOwnPropertySymbols(properties));
    $bebd28704f2536ea$var$$forEach$1(keys, function(key) {
        if (!$bebd28704f2536ea$var$DESCRIPTORS$8 || $bebd28704f2536ea$var$call$3($bebd28704f2536ea$var$$propertyIsEnumerable, properties, key)) $bebd28704f2536ea$var$$defineProperty(O, key, properties[key]);
    });
    return O;
};
var $bebd28704f2536ea$var$$create = function create(O, Properties) {
    return Properties === undefined ? $bebd28704f2536ea$var$nativeObjectCreate(O) : $bebd28704f2536ea$var$$defineProperties($bebd28704f2536ea$var$nativeObjectCreate(O), Properties);
};
var $bebd28704f2536ea$var$$propertyIsEnumerable = function propertyIsEnumerable(V) {
    var P = $bebd28704f2536ea$var$toPropertyKey(V);
    var enumerable = $bebd28704f2536ea$var$call$3($bebd28704f2536ea$var$nativePropertyIsEnumerable, this, P);
    if (this === $bebd28704f2536ea$var$ObjectPrototype$1 && $bebd28704f2536ea$var$hasOwn$7($bebd28704f2536ea$var$AllSymbols, P) && !$bebd28704f2536ea$var$hasOwn$7($bebd28704f2536ea$var$ObjectPrototypeSymbols, P)) return false;
    return enumerable || !$bebd28704f2536ea$var$hasOwn$7(this, P) || !$bebd28704f2536ea$var$hasOwn$7($bebd28704f2536ea$var$AllSymbols, P) || $bebd28704f2536ea$var$hasOwn$7(this, $bebd28704f2536ea$var$HIDDEN) && this[$bebd28704f2536ea$var$HIDDEN][P] ? enumerable : true;
};
var $bebd28704f2536ea$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
    var it = $bebd28704f2536ea$var$toIndexedObject$3(O);
    var key = $bebd28704f2536ea$var$toPropertyKey(P);
    if (it === $bebd28704f2536ea$var$ObjectPrototype$1 && $bebd28704f2536ea$var$hasOwn$7($bebd28704f2536ea$var$AllSymbols, key) && !$bebd28704f2536ea$var$hasOwn$7($bebd28704f2536ea$var$ObjectPrototypeSymbols, key)) return;
    var descriptor = $bebd28704f2536ea$var$nativeGetOwnPropertyDescriptor$1(it, key);
    if (descriptor && $bebd28704f2536ea$var$hasOwn$7($bebd28704f2536ea$var$AllSymbols, key) && !($bebd28704f2536ea$var$hasOwn$7(it, $bebd28704f2536ea$var$HIDDEN) && it[$bebd28704f2536ea$var$HIDDEN][key])) descriptor.enumerable = true;
    return descriptor;
};
var $bebd28704f2536ea$var$$getOwnPropertyNames = function getOwnPropertyNames(O) {
    var names = $bebd28704f2536ea$var$nativeGetOwnPropertyNames($bebd28704f2536ea$var$toIndexedObject$3(O));
    var result = [];
    $bebd28704f2536ea$var$$forEach$1(names, function(key) {
        if (!$bebd28704f2536ea$var$hasOwn$7($bebd28704f2536ea$var$AllSymbols, key) && !$bebd28704f2536ea$var$hasOwn$7($bebd28704f2536ea$var$hiddenKeys$1, key)) $bebd28704f2536ea$var$push$9(result, key);
    });
    return result;
};
var $bebd28704f2536ea$var$$getOwnPropertySymbols = function(O) {
    var IS_OBJECT_PROTOTYPE = O === $bebd28704f2536ea$var$ObjectPrototype$1;
    var names = $bebd28704f2536ea$var$nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? $bebd28704f2536ea$var$ObjectPrototypeSymbols : $bebd28704f2536ea$var$toIndexedObject$3(O));
    var result = [];
    $bebd28704f2536ea$var$$forEach$1(names, function(key) {
        if ($bebd28704f2536ea$var$hasOwn$7($bebd28704f2536ea$var$AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || $bebd28704f2536ea$var$hasOwn$7($bebd28704f2536ea$var$ObjectPrototype$1, key))) $bebd28704f2536ea$var$push$9(result, $bebd28704f2536ea$var$AllSymbols[key]);
    });
    return result;
};
// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!$bebd28704f2536ea$var$NATIVE_SYMBOL$3) {
    $bebd28704f2536ea$var$$Symbol = function Symbol1() {
        if ($bebd28704f2536ea$var$isPrototypeOf$i($bebd28704f2536ea$var$SymbolPrototype, this)) throw new $bebd28704f2536ea$var$TypeError$1('Symbol is not a constructor');
        var description = !arguments.length || arguments[0] === undefined ? undefined : $bebd28704f2536ea$var$$toString(arguments[0]);
        var tag = $bebd28704f2536ea$var$uid$1(description);
        var setter = function(value) {
            if (this === $bebd28704f2536ea$var$ObjectPrototype$1) $bebd28704f2536ea$var$call$3(setter, $bebd28704f2536ea$var$ObjectPrototypeSymbols, value);
            if ($bebd28704f2536ea$var$hasOwn$7(this, $bebd28704f2536ea$var$HIDDEN) && $bebd28704f2536ea$var$hasOwn$7(this[$bebd28704f2536ea$var$HIDDEN], tag)) this[$bebd28704f2536ea$var$HIDDEN][tag] = false;
            var descriptor = $bebd28704f2536ea$var$createPropertyDescriptor(1, value);
            try {
                $bebd28704f2536ea$var$setSymbolDescriptor(this, tag, descriptor);
            } catch (error) {
                if (!(error instanceof $bebd28704f2536ea$var$RangeError$1)) throw error;
                $bebd28704f2536ea$var$fallbackDefineProperty(this, tag, descriptor);
            }
        };
        if ($bebd28704f2536ea$var$DESCRIPTORS$8 && $bebd28704f2536ea$var$USE_SETTER) $bebd28704f2536ea$var$setSymbolDescriptor($bebd28704f2536ea$var$ObjectPrototype$1, tag, {
            configurable: true,
            set: setter
        });
        return $bebd28704f2536ea$var$wrap(tag, description);
    };
    $bebd28704f2536ea$var$SymbolPrototype = $bebd28704f2536ea$var$$Symbol[$bebd28704f2536ea$var$PROTOTYPE];
    $bebd28704f2536ea$var$defineBuiltIn$1($bebd28704f2536ea$var$SymbolPrototype, 'toString', function toString() {
        return $bebd28704f2536ea$var$getInternalState(this).tag;
    });
    $bebd28704f2536ea$var$defineBuiltIn$1($bebd28704f2536ea$var$$Symbol, 'withoutSetter', function(description) {
        return $bebd28704f2536ea$var$wrap($bebd28704f2536ea$var$uid$1(description), description);
    });
    $bebd28704f2536ea$var$propertyIsEnumerableModule.f = $bebd28704f2536ea$var$$propertyIsEnumerable;
    $bebd28704f2536ea$var$definePropertyModule.f = $bebd28704f2536ea$var$$defineProperty;
    $bebd28704f2536ea$var$definePropertiesModule.f = $bebd28704f2536ea$var$$defineProperties;
    $bebd28704f2536ea$var$getOwnPropertyDescriptorModule$2.f = $bebd28704f2536ea$var$$getOwnPropertyDescriptor;
    $bebd28704f2536ea$var$getOwnPropertyNamesModule$2.f = $bebd28704f2536ea$var$getOwnPropertyNamesExternal.f = $bebd28704f2536ea$var$$getOwnPropertyNames;
    $bebd28704f2536ea$var$getOwnPropertySymbolsModule$2.f = $bebd28704f2536ea$var$$getOwnPropertySymbols;
    $bebd28704f2536ea$var$wrappedWellKnownSymbolModule.f = function(name) {
        return $bebd28704f2536ea$var$wrap($bebd28704f2536ea$var$wellKnownSymbol$6(name), name);
    };
    if ($bebd28704f2536ea$var$DESCRIPTORS$8) // https://github.com/tc39/proposal-Symbol-description
    $bebd28704f2536ea$var$defineBuiltInAccessor$2($bebd28704f2536ea$var$SymbolPrototype, 'description', {
        configurable: true,
        get: function description() {
            return $bebd28704f2536ea$var$getInternalState(this).description;
        }
    });
}
$bebd28704f2536ea$var$$$I({
    global: true,
    constructor: true,
    wrap: true,
    forced: !$bebd28704f2536ea$var$NATIVE_SYMBOL$3,
    sham: !$bebd28704f2536ea$var$NATIVE_SYMBOL$3
}, {
    Symbol: $bebd28704f2536ea$var$$Symbol
});
$bebd28704f2536ea$var$$forEach$1($bebd28704f2536ea$var$objectKeys($bebd28704f2536ea$var$WellKnownSymbolsStore$1), function(name) {
    $bebd28704f2536ea$var$defineWellKnownSymbol$l(name);
});
$bebd28704f2536ea$var$$$I({
    target: $bebd28704f2536ea$var$SYMBOL,
    stat: true,
    forced: !$bebd28704f2536ea$var$NATIVE_SYMBOL$3
}, {
    useSetter: function() {
        $bebd28704f2536ea$var$USE_SETTER = true;
    },
    useSimple: function() {
        $bebd28704f2536ea$var$USE_SETTER = false;
    }
});
$bebd28704f2536ea$var$$$I({
    target: 'Object',
    stat: true,
    forced: !$bebd28704f2536ea$var$NATIVE_SYMBOL$3,
    sham: !$bebd28704f2536ea$var$DESCRIPTORS$8
}, {
    // `Object.create` method
    // https://tc39.es/ecma262/#sec-object.create
    create: $bebd28704f2536ea$var$$create,
    // `Object.defineProperty` method
    // https://tc39.es/ecma262/#sec-object.defineproperty
    defineProperty: $bebd28704f2536ea$var$$defineProperty,
    // `Object.defineProperties` method
    // https://tc39.es/ecma262/#sec-object.defineproperties
    defineProperties: $bebd28704f2536ea$var$$defineProperties,
    // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
    getOwnPropertyDescriptor: $bebd28704f2536ea$var$$getOwnPropertyDescriptor
});
$bebd28704f2536ea$var$$$I({
    target: 'Object',
    stat: true,
    forced: !$bebd28704f2536ea$var$NATIVE_SYMBOL$3
}, {
    // `Object.getOwnPropertyNames` method
    // https://tc39.es/ecma262/#sec-object.getownpropertynames
    getOwnPropertyNames: $bebd28704f2536ea$var$$getOwnPropertyNames
});
// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
$bebd28704f2536ea$var$defineSymbolToPrimitive$1();
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
$bebd28704f2536ea$var$setToStringTag$3($bebd28704f2536ea$var$$Symbol, $bebd28704f2536ea$var$SYMBOL);
$bebd28704f2536ea$var$hiddenKeys$1[$bebd28704f2536ea$var$HIDDEN] = true;
var $bebd28704f2536ea$var$NATIVE_SYMBOL$2 = $bebd28704f2536ea$var$symbolConstructorDetection;
/* eslint-disable es/no-symbol -- safe */ var $bebd28704f2536ea$var$symbolRegistryDetection = $bebd28704f2536ea$var$NATIVE_SYMBOL$2 && !!Symbol['for'] && !!Symbol.keyFor;
var $bebd28704f2536ea$var$$$H = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$getBuiltIn$7 = $bebd28704f2536ea$var$getBuiltIn$c;
var $bebd28704f2536ea$var$hasOwn$6 = $bebd28704f2536ea$var$hasOwnProperty_1;
var $bebd28704f2536ea$var$toString$6 = $bebd28704f2536ea$var$toString$a;
var $bebd28704f2536ea$var$shared$2 = $bebd28704f2536ea$var$sharedExports;
var $bebd28704f2536ea$var$NATIVE_SYMBOL_REGISTRY$1 = $bebd28704f2536ea$var$symbolRegistryDetection;
var $bebd28704f2536ea$var$StringToSymbolRegistry = $bebd28704f2536ea$var$shared$2('string-to-symbol-registry');
var $bebd28704f2536ea$var$SymbolToStringRegistry$1 = $bebd28704f2536ea$var$shared$2('symbol-to-string-registry');
// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$bebd28704f2536ea$var$$$H({
    target: 'Symbol',
    stat: true,
    forced: !$bebd28704f2536ea$var$NATIVE_SYMBOL_REGISTRY$1
}, {
    'for': function(key) {
        var string = $bebd28704f2536ea$var$toString$6(key);
        if ($bebd28704f2536ea$var$hasOwn$6($bebd28704f2536ea$var$StringToSymbolRegistry, string)) return $bebd28704f2536ea$var$StringToSymbolRegistry[string];
        var symbol = $bebd28704f2536ea$var$getBuiltIn$7('Symbol')(string);
        $bebd28704f2536ea$var$StringToSymbolRegistry[string] = symbol;
        $bebd28704f2536ea$var$SymbolToStringRegistry$1[symbol] = string;
        return symbol;
    }
});
var $bebd28704f2536ea$var$$$G = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$hasOwn$5 = $bebd28704f2536ea$var$hasOwnProperty_1;
var $bebd28704f2536ea$var$isSymbol$2 = $bebd28704f2536ea$var$isSymbol$5;
var $bebd28704f2536ea$var$tryToString$3 = $bebd28704f2536ea$var$tryToString$6;
var $bebd28704f2536ea$var$shared$1 = $bebd28704f2536ea$var$sharedExports;
var $bebd28704f2536ea$var$NATIVE_SYMBOL_REGISTRY = $bebd28704f2536ea$var$symbolRegistryDetection;
var $bebd28704f2536ea$var$SymbolToStringRegistry = $bebd28704f2536ea$var$shared$1('symbol-to-string-registry');
// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$bebd28704f2536ea$var$$$G({
    target: 'Symbol',
    stat: true,
    forced: !$bebd28704f2536ea$var$NATIVE_SYMBOL_REGISTRY
}, {
    keyFor: function keyFor(sym) {
        if (!$bebd28704f2536ea$var$isSymbol$2(sym)) throw new TypeError($bebd28704f2536ea$var$tryToString$3(sym) + ' is not a symbol');
        if ($bebd28704f2536ea$var$hasOwn$5($bebd28704f2536ea$var$SymbolToStringRegistry, sym)) return $bebd28704f2536ea$var$SymbolToStringRegistry[sym];
    }
});
var $bebd28704f2536ea$var$uncurryThis$f = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$isArray$b = $bebd28704f2536ea$var$isArray$e;
var $bebd28704f2536ea$var$isCallable$3 = $bebd28704f2536ea$var$isCallable$i;
var $bebd28704f2536ea$var$classof$5 = $bebd28704f2536ea$var$classofRaw$2;
var $bebd28704f2536ea$var$toString$5 = $bebd28704f2536ea$var$toString$a;
var $bebd28704f2536ea$var$push$8 = $bebd28704f2536ea$var$uncurryThis$f([].push);
var $bebd28704f2536ea$var$getJsonReplacerFunction = function(replacer) {
    if ($bebd28704f2536ea$var$isCallable$3(replacer)) return replacer;
    if (!$bebd28704f2536ea$var$isArray$b(replacer)) return;
    var rawLength = replacer.length;
    var keys = [];
    for(var i = 0; i < rawLength; i++){
        var element = replacer[i];
        if (typeof element == 'string') $bebd28704f2536ea$var$push$8(keys, element);
        else if (typeof element == 'number' || $bebd28704f2536ea$var$classof$5(element) === 'Number' || $bebd28704f2536ea$var$classof$5(element) === 'String') $bebd28704f2536ea$var$push$8(keys, $bebd28704f2536ea$var$toString$5(element));
    }
    var keysLength = keys.length;
    var root = true;
    return function(key, value) {
        if (root) {
            root = false;
            return value;
        }
        if ($bebd28704f2536ea$var$isArray$b(this)) return value;
        for(var j = 0; j < keysLength; j++)if (keys[j] === key) return value;
    };
};
var $bebd28704f2536ea$var$$$F = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$getBuiltIn$6 = $bebd28704f2536ea$var$getBuiltIn$c;
var $bebd28704f2536ea$var$apply$3 = $bebd28704f2536ea$var$functionApply;
var $bebd28704f2536ea$var$call$2 = $bebd28704f2536ea$var$functionCall;
var $bebd28704f2536ea$var$uncurryThis$e = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$fails$h = $bebd28704f2536ea$var$fails$w;
var $bebd28704f2536ea$var$isCallable$2 = $bebd28704f2536ea$var$isCallable$i;
var $bebd28704f2536ea$var$isSymbol$1 = $bebd28704f2536ea$var$isSymbol$5;
var $bebd28704f2536ea$var$arraySlice$2 = $bebd28704f2536ea$var$arraySlice$5;
var $bebd28704f2536ea$var$getReplacerFunction = $bebd28704f2536ea$var$getJsonReplacerFunction;
var $bebd28704f2536ea$var$NATIVE_SYMBOL$1 = $bebd28704f2536ea$var$symbolConstructorDetection;
var $bebd28704f2536ea$var$$String = String;
var $bebd28704f2536ea$var$$stringify = $bebd28704f2536ea$var$getBuiltIn$6('JSON', 'stringify');
var $bebd28704f2536ea$var$exec$1 = $bebd28704f2536ea$var$uncurryThis$e(/./.exec);
var $bebd28704f2536ea$var$charAt$1 = $bebd28704f2536ea$var$uncurryThis$e(''.charAt);
var $bebd28704f2536ea$var$charCodeAt = $bebd28704f2536ea$var$uncurryThis$e(''.charCodeAt);
var $bebd28704f2536ea$var$replace$1 = $bebd28704f2536ea$var$uncurryThis$e(''.replace);
var $bebd28704f2536ea$var$numberToString = $bebd28704f2536ea$var$uncurryThis$e(1.0.toString);
var $bebd28704f2536ea$var$tester = /[\uD800-\uDFFF]/g;
var $bebd28704f2536ea$var$low = /^[\uD800-\uDBFF]$/;
var $bebd28704f2536ea$var$hi = /^[\uDC00-\uDFFF]$/;
var $bebd28704f2536ea$var$WRONG_SYMBOLS_CONVERSION = !$bebd28704f2536ea$var$NATIVE_SYMBOL$1 || $bebd28704f2536ea$var$fails$h(function() {
    var symbol = $bebd28704f2536ea$var$getBuiltIn$6('Symbol')('stringify detection');
    // MS Edge converts symbol values to JSON as {}
    return $bebd28704f2536ea$var$$stringify([
        symbol
    ]) !== '[null]' || $bebd28704f2536ea$var$$stringify({
        a: symbol
    }) !== '{}' || $bebd28704f2536ea$var$$stringify(Object(symbol)) !== '{}';
});
// https://github.com/tc39/proposal-well-formed-stringify
var $bebd28704f2536ea$var$ILL_FORMED_UNICODE = $bebd28704f2536ea$var$fails$h(function() {
    return $bebd28704f2536ea$var$$stringify('\uDF06\uD834') !== '"\\udf06\\ud834"' || $bebd28704f2536ea$var$$stringify('\uDEAD') !== '"\\udead"';
});
var $bebd28704f2536ea$var$stringifyWithSymbolsFix = function(it, replacer) {
    var args = $bebd28704f2536ea$var$arraySlice$2(arguments);
    var $replacer = $bebd28704f2536ea$var$getReplacerFunction(replacer);
    if (!$bebd28704f2536ea$var$isCallable$2($replacer) && (it === undefined || $bebd28704f2536ea$var$isSymbol$1(it))) return; // IE8 returns string on undefined
    args[1] = function(key, value) {
        // some old implementations (like WebKit) could pass numbers as keys
        if ($bebd28704f2536ea$var$isCallable$2($replacer)) value = $bebd28704f2536ea$var$call$2($replacer, this, $bebd28704f2536ea$var$$String(key), value);
        if (!$bebd28704f2536ea$var$isSymbol$1(value)) return value;
    };
    return $bebd28704f2536ea$var$apply$3($bebd28704f2536ea$var$$stringify, null, args);
};
var $bebd28704f2536ea$var$fixIllFormed = function(match, offset, string) {
    var prev = $bebd28704f2536ea$var$charAt$1(string, offset - 1);
    var next = $bebd28704f2536ea$var$charAt$1(string, offset + 1);
    if ($bebd28704f2536ea$var$exec$1($bebd28704f2536ea$var$low, match) && !$bebd28704f2536ea$var$exec$1($bebd28704f2536ea$var$hi, next) || $bebd28704f2536ea$var$exec$1($bebd28704f2536ea$var$hi, match) && !$bebd28704f2536ea$var$exec$1($bebd28704f2536ea$var$low, prev)) return '\\u' + $bebd28704f2536ea$var$numberToString($bebd28704f2536ea$var$charCodeAt(match, 0), 16);
    return match;
};
if ($bebd28704f2536ea$var$$stringify) // `JSON.stringify` method
// https://tc39.es/ecma262/#sec-json.stringify
$bebd28704f2536ea$var$$$F({
    target: 'JSON',
    stat: true,
    arity: 3,
    forced: $bebd28704f2536ea$var$WRONG_SYMBOLS_CONVERSION || $bebd28704f2536ea$var$ILL_FORMED_UNICODE
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
        var args = $bebd28704f2536ea$var$arraySlice$2(arguments);
        var result = $bebd28704f2536ea$var$apply$3($bebd28704f2536ea$var$WRONG_SYMBOLS_CONVERSION ? $bebd28704f2536ea$var$stringifyWithSymbolsFix : $bebd28704f2536ea$var$$stringify, null, args);
        return $bebd28704f2536ea$var$ILL_FORMED_UNICODE && typeof result == 'string' ? $bebd28704f2536ea$var$replace$1(result, $bebd28704f2536ea$var$tester, $bebd28704f2536ea$var$fixIllFormed) : result;
    }
});
var $bebd28704f2536ea$var$$$E = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$NATIVE_SYMBOL = $bebd28704f2536ea$var$symbolConstructorDetection;
var $bebd28704f2536ea$var$fails$g = $bebd28704f2536ea$var$fails$w;
var $bebd28704f2536ea$var$getOwnPropertySymbolsModule$1 = $bebd28704f2536ea$var$objectGetOwnPropertySymbols;
var $bebd28704f2536ea$var$toObject$7 = $bebd28704f2536ea$var$toObject$e;
// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $bebd28704f2536ea$var$FORCED$9 = !$bebd28704f2536ea$var$NATIVE_SYMBOL || $bebd28704f2536ea$var$fails$g(function() {
    $bebd28704f2536ea$var$getOwnPropertySymbolsModule$1.f(1);
});
// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$bebd28704f2536ea$var$$$E({
    target: 'Object',
    stat: true,
    forced: $bebd28704f2536ea$var$FORCED$9
}, {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        var $getOwnPropertySymbols = $bebd28704f2536ea$var$getOwnPropertySymbolsModule$1.f;
        return $getOwnPropertySymbols ? $getOwnPropertySymbols($bebd28704f2536ea$var$toObject$7(it)) : [];
    }
});
var $bebd28704f2536ea$var$defineWellKnownSymbol$k = $bebd28704f2536ea$var$wellKnownSymbolDefine;
// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
$bebd28704f2536ea$var$defineWellKnownSymbol$k('asyncIterator');
var $bebd28704f2536ea$var$defineWellKnownSymbol$j = $bebd28704f2536ea$var$wellKnownSymbolDefine;
// `Symbol.hasInstance` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.hasinstance
$bebd28704f2536ea$var$defineWellKnownSymbol$j('hasInstance');
var $bebd28704f2536ea$var$defineWellKnownSymbol$i = $bebd28704f2536ea$var$wellKnownSymbolDefine;
// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
$bebd28704f2536ea$var$defineWellKnownSymbol$i('isConcatSpreadable');
var $bebd28704f2536ea$var$defineWellKnownSymbol$h = $bebd28704f2536ea$var$wellKnownSymbolDefine;
// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
$bebd28704f2536ea$var$defineWellKnownSymbol$h('iterator');
var $bebd28704f2536ea$var$defineWellKnownSymbol$g = $bebd28704f2536ea$var$wellKnownSymbolDefine;
// `Symbol.match` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.match
$bebd28704f2536ea$var$defineWellKnownSymbol$g('match');
var $bebd28704f2536ea$var$defineWellKnownSymbol$f = $bebd28704f2536ea$var$wellKnownSymbolDefine;
// `Symbol.matchAll` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.matchall
$bebd28704f2536ea$var$defineWellKnownSymbol$f('matchAll');
var $bebd28704f2536ea$var$defineWellKnownSymbol$e = $bebd28704f2536ea$var$wellKnownSymbolDefine;
// `Symbol.replace` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.replace
$bebd28704f2536ea$var$defineWellKnownSymbol$e('replace');
var $bebd28704f2536ea$var$defineWellKnownSymbol$d = $bebd28704f2536ea$var$wellKnownSymbolDefine;
// `Symbol.search` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.search
$bebd28704f2536ea$var$defineWellKnownSymbol$d('search');
var $bebd28704f2536ea$var$defineWellKnownSymbol$c = $bebd28704f2536ea$var$wellKnownSymbolDefine;
// `Symbol.species` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.species
$bebd28704f2536ea$var$defineWellKnownSymbol$c('species');
var $bebd28704f2536ea$var$defineWellKnownSymbol$b = $bebd28704f2536ea$var$wellKnownSymbolDefine;
// `Symbol.split` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.split
$bebd28704f2536ea$var$defineWellKnownSymbol$b('split');
var $bebd28704f2536ea$var$defineWellKnownSymbol$a = $bebd28704f2536ea$var$wellKnownSymbolDefine;
var $bebd28704f2536ea$var$defineSymbolToPrimitive = $bebd28704f2536ea$var$symbolDefineToPrimitive;
// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
$bebd28704f2536ea$var$defineWellKnownSymbol$a('toPrimitive');
// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
$bebd28704f2536ea$var$defineSymbolToPrimitive();
var $bebd28704f2536ea$var$getBuiltIn$5 = $bebd28704f2536ea$var$getBuiltIn$c;
var $bebd28704f2536ea$var$defineWellKnownSymbol$9 = $bebd28704f2536ea$var$wellKnownSymbolDefine;
var $bebd28704f2536ea$var$setToStringTag$2 = $bebd28704f2536ea$var$setToStringTag$6;
// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
$bebd28704f2536ea$var$defineWellKnownSymbol$9('toStringTag');
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
$bebd28704f2536ea$var$setToStringTag$2($bebd28704f2536ea$var$getBuiltIn$5('Symbol'), 'Symbol');
var $bebd28704f2536ea$var$defineWellKnownSymbol$8 = $bebd28704f2536ea$var$wellKnownSymbolDefine;
// `Symbol.unscopables` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.unscopables
$bebd28704f2536ea$var$defineWellKnownSymbol$8('unscopables');
var $bebd28704f2536ea$var$global$a = $bebd28704f2536ea$var$global$n;
var $bebd28704f2536ea$var$setToStringTag$1 = $bebd28704f2536ea$var$setToStringTag$6;
// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
$bebd28704f2536ea$var$setToStringTag$1($bebd28704f2536ea$var$global$a.JSON, 'JSON', true);
var $bebd28704f2536ea$var$path$o = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$symbol$5 = $bebd28704f2536ea$var$path$o.Symbol;
var $bebd28704f2536ea$var$parent$12 = $bebd28704f2536ea$var$symbol$5;
var $bebd28704f2536ea$var$symbol$4 = $bebd28704f2536ea$var$parent$12;
var $bebd28704f2536ea$var$wellKnownSymbol$5 = $bebd28704f2536ea$var$wellKnownSymbol$m;
var $bebd28704f2536ea$var$defineProperty$3 = $bebd28704f2536ea$var$objectDefineProperty.f;
var $bebd28704f2536ea$var$METADATA$1 = $bebd28704f2536ea$var$wellKnownSymbol$5('metadata');
var $bebd28704f2536ea$var$FunctionPrototype = Function.prototype;
// Function.prototype[@@metadata]
// https://github.com/tc39/proposal-decorator-metadata
if ($bebd28704f2536ea$var$FunctionPrototype[$bebd28704f2536ea$var$METADATA$1] === undefined) $bebd28704f2536ea$var$defineProperty$3($bebd28704f2536ea$var$FunctionPrototype, $bebd28704f2536ea$var$METADATA$1, {
    value: null
});
var $bebd28704f2536ea$var$defineWellKnownSymbol$7 = $bebd28704f2536ea$var$wellKnownSymbolDefine;
// `Symbol.asyncDispose` well-known symbol
// https://github.com/tc39/proposal-async-explicit-resource-management
$bebd28704f2536ea$var$defineWellKnownSymbol$7('asyncDispose');
var $bebd28704f2536ea$var$defineWellKnownSymbol$6 = $bebd28704f2536ea$var$wellKnownSymbolDefine;
// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-explicit-resource-management
$bebd28704f2536ea$var$defineWellKnownSymbol$6('dispose');
// TODO: Remove from `core-js@4`
var $bebd28704f2536ea$var$defineWellKnownSymbol$5 = $bebd28704f2536ea$var$wellKnownSymbolDefine;
// `Symbol.metadata` well-known symbol
// https://github.com/tc39/proposal-decorators
$bebd28704f2536ea$var$defineWellKnownSymbol$5('metadata');
var $bebd28704f2536ea$var$parent$11 = $bebd28704f2536ea$var$symbol$4;
var $bebd28704f2536ea$var$symbol$3 = $bebd28704f2536ea$var$parent$11;
var $bebd28704f2536ea$var$getBuiltIn$4 = $bebd28704f2536ea$var$getBuiltIn$c;
var $bebd28704f2536ea$var$uncurryThis$d = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$Symbol$4 = $bebd28704f2536ea$var$getBuiltIn$4('Symbol');
var $bebd28704f2536ea$var$keyFor = $bebd28704f2536ea$var$Symbol$4.keyFor;
var $bebd28704f2536ea$var$thisSymbolValue$1 = $bebd28704f2536ea$var$uncurryThis$d($bebd28704f2536ea$var$Symbol$4.prototype.valueOf);
// `Symbol.isRegisteredSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
var $bebd28704f2536ea$var$symbolIsRegistered = $bebd28704f2536ea$var$Symbol$4.isRegisteredSymbol || function isRegisteredSymbol(value) {
    try {
        return $bebd28704f2536ea$var$keyFor($bebd28704f2536ea$var$thisSymbolValue$1(value)) !== undefined;
    } catch (error) {
        return false;
    }
};
var $bebd28704f2536ea$var$$$D = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$isRegisteredSymbol$1 = $bebd28704f2536ea$var$symbolIsRegistered;
// `Symbol.isRegisteredSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
$bebd28704f2536ea$var$$$D({
    target: 'Symbol',
    stat: true
}, {
    isRegisteredSymbol: $bebd28704f2536ea$var$isRegisteredSymbol$1
});
var $bebd28704f2536ea$var$shared = $bebd28704f2536ea$var$sharedExports;
var $bebd28704f2536ea$var$getBuiltIn$3 = $bebd28704f2536ea$var$getBuiltIn$c;
var $bebd28704f2536ea$var$uncurryThis$c = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$isSymbol = $bebd28704f2536ea$var$isSymbol$5;
var $bebd28704f2536ea$var$wellKnownSymbol$4 = $bebd28704f2536ea$var$wellKnownSymbol$m;
var $bebd28704f2536ea$var$Symbol$3 = $bebd28704f2536ea$var$getBuiltIn$3('Symbol');
var $bebd28704f2536ea$var$$isWellKnownSymbol = $bebd28704f2536ea$var$Symbol$3.isWellKnownSymbol;
var $bebd28704f2536ea$var$getOwnPropertyNames$4 = $bebd28704f2536ea$var$getBuiltIn$3('Object', 'getOwnPropertyNames');
var $bebd28704f2536ea$var$thisSymbolValue = $bebd28704f2536ea$var$uncurryThis$c($bebd28704f2536ea$var$Symbol$3.prototype.valueOf);
var $bebd28704f2536ea$var$WellKnownSymbolsStore = $bebd28704f2536ea$var$shared('wks');
for(var $bebd28704f2536ea$var$i = 0, $bebd28704f2536ea$var$symbolKeys = $bebd28704f2536ea$var$getOwnPropertyNames$4($bebd28704f2536ea$var$Symbol$3), $bebd28704f2536ea$var$symbolKeysLength = $bebd28704f2536ea$var$symbolKeys.length; $bebd28704f2536ea$var$i < $bebd28704f2536ea$var$symbolKeysLength; $bebd28704f2536ea$var$i++)// some old engines throws on access to some keys like `arguments` or `caller`
try {
    var $bebd28704f2536ea$var$symbolKey = $bebd28704f2536ea$var$symbolKeys[$bebd28704f2536ea$var$i];
    if ($bebd28704f2536ea$var$isSymbol($bebd28704f2536ea$var$Symbol$3[$bebd28704f2536ea$var$symbolKey])) $bebd28704f2536ea$var$wellKnownSymbol$4($bebd28704f2536ea$var$symbolKey);
} catch (error) {}
// `Symbol.isWellKnownSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
var $bebd28704f2536ea$var$symbolIsWellKnown = function isWellKnownSymbol(value) {
    if ($bebd28704f2536ea$var$$isWellKnownSymbol && $bebd28704f2536ea$var$$isWellKnownSymbol(value)) return true;
    try {
        var symbol = $bebd28704f2536ea$var$thisSymbolValue(value);
        for(var j = 0, keys = $bebd28704f2536ea$var$getOwnPropertyNames$4($bebd28704f2536ea$var$WellKnownSymbolsStore), keysLength = keys.length; j < keysLength; j++){
            // eslint-disable-next-line eqeqeq -- polyfilled symbols case
            if ($bebd28704f2536ea$var$WellKnownSymbolsStore[keys[j]] == symbol) return true;
        }
    } catch (error) {}
    return false;
};
var $bebd28704f2536ea$var$$$C = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$isWellKnownSymbol$1 = $bebd28704f2536ea$var$symbolIsWellKnown;
// `Symbol.isWellKnownSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
$bebd28704f2536ea$var$$$C({
    target: 'Symbol',
    stat: true,
    forced: true
}, {
    isWellKnownSymbol: $bebd28704f2536ea$var$isWellKnownSymbol$1
});
var $bebd28704f2536ea$var$defineWellKnownSymbol$4 = $bebd28704f2536ea$var$wellKnownSymbolDefine;
// `Symbol.matcher` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
$bebd28704f2536ea$var$defineWellKnownSymbol$4('matcher');
var $bebd28704f2536ea$var$defineWellKnownSymbol$3 = $bebd28704f2536ea$var$wellKnownSymbolDefine;
// `Symbol.observable` well-known symbol
// https://github.com/tc39/proposal-observable
$bebd28704f2536ea$var$defineWellKnownSymbol$3('observable');
var $bebd28704f2536ea$var$$$B = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$isRegisteredSymbol = $bebd28704f2536ea$var$symbolIsRegistered;
// `Symbol.isRegistered` method
// obsolete version of https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
$bebd28704f2536ea$var$$$B({
    target: 'Symbol',
    stat: true,
    name: 'isRegisteredSymbol'
}, {
    isRegistered: $bebd28704f2536ea$var$isRegisteredSymbol
});
var $bebd28704f2536ea$var$$$A = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$isWellKnownSymbol = $bebd28704f2536ea$var$symbolIsWellKnown;
// `Symbol.isWellKnown` method
// obsolete version of https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
$bebd28704f2536ea$var$$$A({
    target: 'Symbol',
    stat: true,
    name: 'isWellKnownSymbol',
    forced: true
}, {
    isWellKnown: $bebd28704f2536ea$var$isWellKnownSymbol
});
var $bebd28704f2536ea$var$defineWellKnownSymbol$2 = $bebd28704f2536ea$var$wellKnownSymbolDefine;
// `Symbol.metadataKey` well-known symbol
// https://github.com/tc39/proposal-decorator-metadata
$bebd28704f2536ea$var$defineWellKnownSymbol$2('metadataKey');
// TODO: remove from `core-js@4`
var $bebd28704f2536ea$var$defineWellKnownSymbol$1 = $bebd28704f2536ea$var$wellKnownSymbolDefine;
// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
$bebd28704f2536ea$var$defineWellKnownSymbol$1('patternMatch');
// TODO: remove from `core-js@4`
var $bebd28704f2536ea$var$defineWellKnownSymbol = $bebd28704f2536ea$var$wellKnownSymbolDefine;
$bebd28704f2536ea$var$defineWellKnownSymbol('replaceAll');
var $bebd28704f2536ea$var$parent$10 = $bebd28704f2536ea$var$symbol$3;
// TODO: Remove from `core-js@4`
var $bebd28704f2536ea$var$symbol$2 = $bebd28704f2536ea$var$parent$10;
var $bebd28704f2536ea$var$symbol$1 = $bebd28704f2536ea$var$symbol$2;
var $bebd28704f2536ea$var$_Symbol$1 = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$symbol$1);
var $bebd28704f2536ea$var$WrappedWellKnownSymbolModule$1 = $bebd28704f2536ea$var$wellKnownSymbolWrapped;
var $bebd28704f2536ea$var$iterator$4 = $bebd28704f2536ea$var$WrappedWellKnownSymbolModule$1.f('iterator');
var $bebd28704f2536ea$var$parent$$ = $bebd28704f2536ea$var$iterator$4;
var $bebd28704f2536ea$var$iterator$3 = $bebd28704f2536ea$var$parent$$;
var $bebd28704f2536ea$var$parent$_ = $bebd28704f2536ea$var$iterator$3;
var $bebd28704f2536ea$var$iterator$2 = $bebd28704f2536ea$var$parent$_;
var $bebd28704f2536ea$var$parent$Z = $bebd28704f2536ea$var$iterator$2;
var $bebd28704f2536ea$var$iterator$1 = $bebd28704f2536ea$var$parent$Z;
var $bebd28704f2536ea$var$iterator = $bebd28704f2536ea$var$iterator$1;
var $bebd28704f2536ea$var$_Symbol$iterator = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$iterator);
function $bebd28704f2536ea$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $bebd28704f2536ea$var$_typeof = "function" == typeof $bebd28704f2536ea$var$_Symbol$1 && "symbol" == typeof $bebd28704f2536ea$var$_Symbol$iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof $bebd28704f2536ea$var$_Symbol$1 && o.constructor === $bebd28704f2536ea$var$_Symbol$1 && o !== $bebd28704f2536ea$var$_Symbol$1.prototype ? "symbol" : typeof o;
    }, $bebd28704f2536ea$var$_typeof(o);
}
var $bebd28704f2536ea$var$WrappedWellKnownSymbolModule = $bebd28704f2536ea$var$wellKnownSymbolWrapped;
var $bebd28704f2536ea$var$toPrimitive$4 = $bebd28704f2536ea$var$WrappedWellKnownSymbolModule.f('toPrimitive');
var $bebd28704f2536ea$var$parent$Y = $bebd28704f2536ea$var$toPrimitive$4;
var $bebd28704f2536ea$var$toPrimitive$3 = $bebd28704f2536ea$var$parent$Y;
var $bebd28704f2536ea$var$parent$X = $bebd28704f2536ea$var$toPrimitive$3;
var $bebd28704f2536ea$var$toPrimitive$2 = $bebd28704f2536ea$var$parent$X;
var $bebd28704f2536ea$var$parent$W = $bebd28704f2536ea$var$toPrimitive$2;
var $bebd28704f2536ea$var$toPrimitive$1 = $bebd28704f2536ea$var$parent$W;
var $bebd28704f2536ea$var$toPrimitive = $bebd28704f2536ea$var$toPrimitive$1;
var $bebd28704f2536ea$var$_Symbol$toPrimitive = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$toPrimitive);
function $bebd28704f2536ea$var$_toPrimitive(input, hint) {
    if ($bebd28704f2536ea$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[$bebd28704f2536ea$var$_Symbol$toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($bebd28704f2536ea$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $bebd28704f2536ea$var$_toPropertyKey(arg) {
    var key = $bebd28704f2536ea$var$_toPrimitive(arg, "string");
    return $bebd28704f2536ea$var$_typeof(key) === "symbol" ? key : String(key);
}
function $bebd28704f2536ea$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        $bebd28704f2536ea$var$_Object$defineProperty$1(target, $bebd28704f2536ea$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $bebd28704f2536ea$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bebd28704f2536ea$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bebd28704f2536ea$var$_defineProperties(Constructor, staticProps);
    $bebd28704f2536ea$var$_Object$defineProperty$1(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $bebd28704f2536ea$var$$$z = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$isArray$a = $bebd28704f2536ea$var$isArray$e;
// `Array.isArray` method
// https://tc39.es/ecma262/#sec-array.isarray
$bebd28704f2536ea$var$$$z({
    target: 'Array',
    stat: true
}, {
    isArray: $bebd28704f2536ea$var$isArray$a
});
var $bebd28704f2536ea$var$path$n = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$isArray$9 = $bebd28704f2536ea$var$path$n.Array.isArray;
var $bebd28704f2536ea$var$parent$V = $bebd28704f2536ea$var$isArray$9;
var $bebd28704f2536ea$var$isArray$8 = $bebd28704f2536ea$var$parent$V;
var $bebd28704f2536ea$var$parent$U = $bebd28704f2536ea$var$isArray$8;
var $bebd28704f2536ea$var$isArray$7 = $bebd28704f2536ea$var$parent$U;
var $bebd28704f2536ea$var$parent$T = $bebd28704f2536ea$var$isArray$7;
var $bebd28704f2536ea$var$isArray$6 = $bebd28704f2536ea$var$parent$T;
var $bebd28704f2536ea$var$isArray$5 = $bebd28704f2536ea$var$isArray$6;
var $bebd28704f2536ea$var$_Array$isArray$1 = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$isArray$5);
function $bebd28704f2536ea$var$_arrayWithHoles(arr) {
    if ($bebd28704f2536ea$var$_Array$isArray$1(arr)) return arr;
}
var $bebd28704f2536ea$var$DESCRIPTORS$7 = $bebd28704f2536ea$var$descriptors;
var $bebd28704f2536ea$var$isArray$4 = $bebd28704f2536ea$var$isArray$e;
var $bebd28704f2536ea$var$$TypeError$7 = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $bebd28704f2536ea$var$getOwnPropertyDescriptor$7 = Object.getOwnPropertyDescriptor;
// Safari < 13 does not throw an error in this case
var $bebd28704f2536ea$var$SILENT_ON_NON_WRITABLE_LENGTH_SET = $bebd28704f2536ea$var$DESCRIPTORS$7 && !function() {
    // makes no sense without proper strict mode support
    if (this !== undefined) return true;
    try {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty([], 'length', {
            writable: false
        }).length = 1;
    } catch (error) {
        return error instanceof TypeError;
    }
}();
var $bebd28704f2536ea$var$arraySetLength = $bebd28704f2536ea$var$SILENT_ON_NON_WRITABLE_LENGTH_SET ? function(O, length1) {
    if ($bebd28704f2536ea$var$isArray$4(O) && !$bebd28704f2536ea$var$getOwnPropertyDescriptor$7(O, 'length').writable) throw new $bebd28704f2536ea$var$$TypeError$7('Cannot set read only .length');
    return O.length = length1;
} : function(O, length1) {
    return O.length = length1;
};
var $bebd28704f2536ea$var$$$y = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$toObject$6 = $bebd28704f2536ea$var$toObject$e;
var $bebd28704f2536ea$var$lengthOfArrayLike$6 = $bebd28704f2536ea$var$lengthOfArrayLike$c;
var $bebd28704f2536ea$var$setArrayLength$1 = $bebd28704f2536ea$var$arraySetLength;
var $bebd28704f2536ea$var$doesNotExceedSafeInteger$1 = $bebd28704f2536ea$var$doesNotExceedSafeInteger$3;
var $bebd28704f2536ea$var$fails$f = $bebd28704f2536ea$var$fails$w;
var $bebd28704f2536ea$var$INCORRECT_TO_LENGTH = $bebd28704f2536ea$var$fails$f(function() {
    return [].push.call({
        length: 0x100000000
    }, 1) !== 4294967297;
});
// V8 and Safari <= 15.4, FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var $bebd28704f2536ea$var$properErrorOnNonWritableLength = function() {
    try {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty([], 'length', {
            writable: false
        }).push();
    } catch (error) {
        return error instanceof TypeError;
    }
};
var $bebd28704f2536ea$var$FORCED$8 = $bebd28704f2536ea$var$INCORRECT_TO_LENGTH || !$bebd28704f2536ea$var$properErrorOnNonWritableLength();
// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$bebd28704f2536ea$var$$$y({
    target: 'Array',
    proto: true,
    arity: 1,
    forced: $bebd28704f2536ea$var$FORCED$8
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    push: function push(item) {
        var O = $bebd28704f2536ea$var$toObject$6(this);
        var len = $bebd28704f2536ea$var$lengthOfArrayLike$6(O);
        var argCount = arguments.length;
        $bebd28704f2536ea$var$doesNotExceedSafeInteger$1(len + argCount);
        for(var i = 0; i < argCount; i++){
            O[len] = arguments[i];
            len++;
        }
        $bebd28704f2536ea$var$setArrayLength$1(O, len);
        return len;
    }
});
var $bebd28704f2536ea$var$entryVirtual$g = $bebd28704f2536ea$var$entryVirtual$i;
var $bebd28704f2536ea$var$push$7 = $bebd28704f2536ea$var$entryVirtual$g('Array').push;
var $bebd28704f2536ea$var$isPrototypeOf$h = $bebd28704f2536ea$var$objectIsPrototypeOf;
var $bebd28704f2536ea$var$method$e = $bebd28704f2536ea$var$push$7;
var $bebd28704f2536ea$var$ArrayPrototype$f = Array.prototype;
var $bebd28704f2536ea$var$push$6 = function(it) {
    var own = it.push;
    return it === $bebd28704f2536ea$var$ArrayPrototype$f || $bebd28704f2536ea$var$isPrototypeOf$h($bebd28704f2536ea$var$ArrayPrototype$f, it) && own === $bebd28704f2536ea$var$ArrayPrototype$f.push ? $bebd28704f2536ea$var$method$e : own;
};
var $bebd28704f2536ea$var$parent$S = $bebd28704f2536ea$var$push$6;
var $bebd28704f2536ea$var$push$5 = $bebd28704f2536ea$var$parent$S;
var $bebd28704f2536ea$var$parent$R = $bebd28704f2536ea$var$push$5;
var $bebd28704f2536ea$var$push$4 = $bebd28704f2536ea$var$parent$R;
var $bebd28704f2536ea$var$parent$Q = $bebd28704f2536ea$var$push$4;
var $bebd28704f2536ea$var$push$3 = $bebd28704f2536ea$var$parent$Q;
var $bebd28704f2536ea$var$push$2 = $bebd28704f2536ea$var$push$3;
var $bebd28704f2536ea$var$_pushInstanceProperty = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$push$2);
function $bebd28704f2536ea$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof $bebd28704f2536ea$var$_Symbol$1 && $bebd28704f2536ea$var$_getIteratorMethod$1(r) || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && ($bebd28704f2536ea$var$_pushInstanceProperty(a).call(a, e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
var $bebd28704f2536ea$var$$$x = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$isArray$3 = $bebd28704f2536ea$var$isArray$e;
var $bebd28704f2536ea$var$isConstructor$1 = $bebd28704f2536ea$var$isConstructor$4;
var $bebd28704f2536ea$var$isObject$9 = $bebd28704f2536ea$var$isObject$j;
var $bebd28704f2536ea$var$toAbsoluteIndex$2 = $bebd28704f2536ea$var$toAbsoluteIndex$5;
var $bebd28704f2536ea$var$lengthOfArrayLike$5 = $bebd28704f2536ea$var$lengthOfArrayLike$c;
var $bebd28704f2536ea$var$toIndexedObject$2 = $bebd28704f2536ea$var$toIndexedObject$a;
var $bebd28704f2536ea$var$createProperty$2 = $bebd28704f2536ea$var$createProperty$6;
var $bebd28704f2536ea$var$wellKnownSymbol$3 = $bebd28704f2536ea$var$wellKnownSymbol$m;
var $bebd28704f2536ea$var$arrayMethodHasSpeciesSupport$3 = $bebd28704f2536ea$var$arrayMethodHasSpeciesSupport$5;
var $bebd28704f2536ea$var$nativeSlice = $bebd28704f2536ea$var$arraySlice$5;
var $bebd28704f2536ea$var$HAS_SPECIES_SUPPORT$3 = $bebd28704f2536ea$var$arrayMethodHasSpeciesSupport$3('slice');
var $bebd28704f2536ea$var$SPECIES$1 = $bebd28704f2536ea$var$wellKnownSymbol$3('species');
var $bebd28704f2536ea$var$$Array = Array;
var $bebd28704f2536ea$var$max$1 = Math.max;
// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$bebd28704f2536ea$var$$$x({
    target: 'Array',
    proto: true,
    forced: !$bebd28704f2536ea$var$HAS_SPECIES_SUPPORT$3
}, {
    slice: function slice(start, end) {
        var O = $bebd28704f2536ea$var$toIndexedObject$2(this);
        var length1 = $bebd28704f2536ea$var$lengthOfArrayLike$5(O);
        var k = $bebd28704f2536ea$var$toAbsoluteIndex$2(start, length1);
        var fin = $bebd28704f2536ea$var$toAbsoluteIndex$2(end === undefined ? length1 : end, length1);
        // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
        var Constructor, result, n;
        if ($bebd28704f2536ea$var$isArray$3(O)) {
            Constructor = O.constructor;
            // cross-realm fallback
            if ($bebd28704f2536ea$var$isConstructor$1(Constructor) && (Constructor === $bebd28704f2536ea$var$$Array || $bebd28704f2536ea$var$isArray$3(Constructor.prototype))) Constructor = undefined;
            else if ($bebd28704f2536ea$var$isObject$9(Constructor)) {
                Constructor = Constructor[$bebd28704f2536ea$var$SPECIES$1];
                if (Constructor === null) Constructor = undefined;
            }
            if (Constructor === $bebd28704f2536ea$var$$Array || Constructor === undefined) return $bebd28704f2536ea$var$nativeSlice(O, k, fin);
        }
        result = new (Constructor === undefined ? $bebd28704f2536ea$var$$Array : Constructor)($bebd28704f2536ea$var$max$1(fin - k, 0));
        for(n = 0; k < fin; k++, n++)if (k in O) $bebd28704f2536ea$var$createProperty$2(result, n, O[k]);
        result.length = n;
        return result;
    }
});
var $bebd28704f2536ea$var$entryVirtual$f = $bebd28704f2536ea$var$entryVirtual$i;
var $bebd28704f2536ea$var$slice$6 = $bebd28704f2536ea$var$entryVirtual$f('Array').slice;
var $bebd28704f2536ea$var$isPrototypeOf$g = $bebd28704f2536ea$var$objectIsPrototypeOf;
var $bebd28704f2536ea$var$method$d = $bebd28704f2536ea$var$slice$6;
var $bebd28704f2536ea$var$ArrayPrototype$e = Array.prototype;
var $bebd28704f2536ea$var$slice$5 = function(it) {
    var own = it.slice;
    return it === $bebd28704f2536ea$var$ArrayPrototype$e || $bebd28704f2536ea$var$isPrototypeOf$g($bebd28704f2536ea$var$ArrayPrototype$e, it) && own === $bebd28704f2536ea$var$ArrayPrototype$e.slice ? $bebd28704f2536ea$var$method$d : own;
};
var $bebd28704f2536ea$var$parent$P = $bebd28704f2536ea$var$slice$5;
var $bebd28704f2536ea$var$slice$4 = $bebd28704f2536ea$var$parent$P;
var $bebd28704f2536ea$var$parent$O = $bebd28704f2536ea$var$slice$4;
var $bebd28704f2536ea$var$slice$3 = $bebd28704f2536ea$var$parent$O;
var $bebd28704f2536ea$var$parent$N = $bebd28704f2536ea$var$slice$3;
var $bebd28704f2536ea$var$slice$2 = $bebd28704f2536ea$var$parent$N;
var $bebd28704f2536ea$var$slice$1 = $bebd28704f2536ea$var$slice$2;
var $bebd28704f2536ea$var$_sliceInstanceProperty$1 = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$slice$1);
var $bebd28704f2536ea$var$parent$M = $bebd28704f2536ea$var$from$4;
var $bebd28704f2536ea$var$from$2 = $bebd28704f2536ea$var$parent$M;
var $bebd28704f2536ea$var$parent$L = $bebd28704f2536ea$var$from$2;
var $bebd28704f2536ea$var$from$1 = $bebd28704f2536ea$var$parent$L;
var $bebd28704f2536ea$var$from = $bebd28704f2536ea$var$from$1;
var $bebd28704f2536ea$var$_Array$from = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$from);
function $bebd28704f2536ea$var$_arrayLikeToArray$7(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $bebd28704f2536ea$var$_unsupportedIterableToArray$7(o, minLen) {
    var _context;
    if (!o) return;
    if (typeof o === "string") return $bebd28704f2536ea$var$_arrayLikeToArray$7(o, minLen);
    var n = $bebd28704f2536ea$var$_sliceInstanceProperty$1(_context = Object.prototype.toString.call(o)).call(_context, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return $bebd28704f2536ea$var$_Array$from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bebd28704f2536ea$var$_arrayLikeToArray$7(o, minLen);
}
function $bebd28704f2536ea$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $bebd28704f2536ea$var$_slicedToArray(arr, i) {
    return $bebd28704f2536ea$var$_arrayWithHoles(arr) || $bebd28704f2536ea$var$_iterableToArrayLimit(arr, i) || $bebd28704f2536ea$var$_unsupportedIterableToArray$7(arr, i) || $bebd28704f2536ea$var$_nonIterableRest();
}
function $bebd28704f2536ea$var$_arrayWithoutHoles(arr) {
    if ($bebd28704f2536ea$var$_Array$isArray$1(arr)) return $bebd28704f2536ea$var$_arrayLikeToArray$7(arr);
}
function $bebd28704f2536ea$var$_iterableToArray(iter) {
    if (typeof $bebd28704f2536ea$var$_Symbol$1 !== "undefined" && $bebd28704f2536ea$var$_getIteratorMethod$1(iter) != null || iter["@@iterator"] != null) return $bebd28704f2536ea$var$_Array$from(iter);
}
function $bebd28704f2536ea$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $bebd28704f2536ea$var$_toConsumableArray(arr) {
    return $bebd28704f2536ea$var$_arrayWithoutHoles(arr) || $bebd28704f2536ea$var$_iterableToArray(arr) || $bebd28704f2536ea$var$_unsupportedIterableToArray$7(arr) || $bebd28704f2536ea$var$_nonIterableSpread();
}
var $bebd28704f2536ea$var$symbol = $bebd28704f2536ea$var$symbol$4;
var $bebd28704f2536ea$var$_Symbol = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$symbol);
var $bebd28704f2536ea$var$entryVirtual$e = $bebd28704f2536ea$var$entryVirtual$i;
var $bebd28704f2536ea$var$concat$4 = $bebd28704f2536ea$var$entryVirtual$e('Array').concat;
var $bebd28704f2536ea$var$isPrototypeOf$f = $bebd28704f2536ea$var$objectIsPrototypeOf;
var $bebd28704f2536ea$var$method$c = $bebd28704f2536ea$var$concat$4;
var $bebd28704f2536ea$var$ArrayPrototype$d = Array.prototype;
var $bebd28704f2536ea$var$concat$3 = function(it) {
    var own = it.concat;
    return it === $bebd28704f2536ea$var$ArrayPrototype$d || $bebd28704f2536ea$var$isPrototypeOf$f($bebd28704f2536ea$var$ArrayPrototype$d, it) && own === $bebd28704f2536ea$var$ArrayPrototype$d.concat ? $bebd28704f2536ea$var$method$c : own;
};
var $bebd28704f2536ea$var$parent$K = $bebd28704f2536ea$var$concat$3;
var $bebd28704f2536ea$var$concat$2 = $bebd28704f2536ea$var$parent$K;
var $bebd28704f2536ea$var$concat$1 = $bebd28704f2536ea$var$concat$2;
var $bebd28704f2536ea$var$_concatInstanceProperty = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$concat$1);
var $bebd28704f2536ea$var$slice = $bebd28704f2536ea$var$slice$4;
var $bebd28704f2536ea$var$_sliceInstanceProperty = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$slice);
var $bebd28704f2536ea$var$getBuiltIn$2 = $bebd28704f2536ea$var$getBuiltIn$c;
var $bebd28704f2536ea$var$uncurryThis$b = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$getOwnPropertyNamesModule$1 = $bebd28704f2536ea$var$objectGetOwnPropertyNames;
var $bebd28704f2536ea$var$getOwnPropertySymbolsModule = $bebd28704f2536ea$var$objectGetOwnPropertySymbols;
var $bebd28704f2536ea$var$anObject$4 = $bebd28704f2536ea$var$anObject$d;
var $bebd28704f2536ea$var$concat = $bebd28704f2536ea$var$uncurryThis$b([].concat);
// all object keys, includes non-enumerable and symbols
var $bebd28704f2536ea$var$ownKeys$5 = $bebd28704f2536ea$var$getBuiltIn$2('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = $bebd28704f2536ea$var$getOwnPropertyNamesModule$1.f($bebd28704f2536ea$var$anObject$4(it));
    var getOwnPropertySymbols = $bebd28704f2536ea$var$getOwnPropertySymbolsModule.f;
    return getOwnPropertySymbols ? $bebd28704f2536ea$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};
var $bebd28704f2536ea$var$isArray$2 = $bebd28704f2536ea$var$isArray$8;
var $bebd28704f2536ea$var$_Array$isArray = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$isArray$2);
var $bebd28704f2536ea$var$$$w = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$$map = $bebd28704f2536ea$var$arrayIteration.map;
var $bebd28704f2536ea$var$arrayMethodHasSpeciesSupport$2 = $bebd28704f2536ea$var$arrayMethodHasSpeciesSupport$5;
var $bebd28704f2536ea$var$HAS_SPECIES_SUPPORT$2 = $bebd28704f2536ea$var$arrayMethodHasSpeciesSupport$2('map');
// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$bebd28704f2536ea$var$$$w({
    target: 'Array',
    proto: true,
    forced: !$bebd28704f2536ea$var$HAS_SPECIES_SUPPORT$2
}, {
    map: function map(callbackfn /* , thisArg */ ) {
        return $bebd28704f2536ea$var$$map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
var $bebd28704f2536ea$var$entryVirtual$d = $bebd28704f2536ea$var$entryVirtual$i;
var $bebd28704f2536ea$var$map$6 = $bebd28704f2536ea$var$entryVirtual$d('Array').map;
var $bebd28704f2536ea$var$isPrototypeOf$e = $bebd28704f2536ea$var$objectIsPrototypeOf;
var $bebd28704f2536ea$var$method$b = $bebd28704f2536ea$var$map$6;
var $bebd28704f2536ea$var$ArrayPrototype$c = Array.prototype;
var $bebd28704f2536ea$var$map$5 = function(it) {
    var own = it.map;
    return it === $bebd28704f2536ea$var$ArrayPrototype$c || $bebd28704f2536ea$var$isPrototypeOf$e($bebd28704f2536ea$var$ArrayPrototype$c, it) && own === $bebd28704f2536ea$var$ArrayPrototype$c.map ? $bebd28704f2536ea$var$method$b : own;
};
var $bebd28704f2536ea$var$parent$J = $bebd28704f2536ea$var$map$5;
var $bebd28704f2536ea$var$map$4 = $bebd28704f2536ea$var$parent$J;
var $bebd28704f2536ea$var$map$3 = $bebd28704f2536ea$var$map$4;
var $bebd28704f2536ea$var$_mapInstanceProperty = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$map$3);
var $bebd28704f2536ea$var$$$v = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$toObject$5 = $bebd28704f2536ea$var$toObject$e;
var $bebd28704f2536ea$var$nativeKeys = $bebd28704f2536ea$var$objectKeys$3;
var $bebd28704f2536ea$var$fails$e = $bebd28704f2536ea$var$fails$w;
var $bebd28704f2536ea$var$FAILS_ON_PRIMITIVES$3 = $bebd28704f2536ea$var$fails$e(function() {
    $bebd28704f2536ea$var$nativeKeys(1);
});
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$bebd28704f2536ea$var$$$v({
    target: 'Object',
    stat: true,
    forced: $bebd28704f2536ea$var$FAILS_ON_PRIMITIVES$3
}, {
    keys: function keys(it) {
        return $bebd28704f2536ea$var$nativeKeys($bebd28704f2536ea$var$toObject$5(it));
    }
});
var $bebd28704f2536ea$var$path$m = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$keys$2 = $bebd28704f2536ea$var$path$m.Object.keys;
var $bebd28704f2536ea$var$parent$I = $bebd28704f2536ea$var$keys$2;
var $bebd28704f2536ea$var$keys$1 = $bebd28704f2536ea$var$parent$I;
var $bebd28704f2536ea$var$keys = $bebd28704f2536ea$var$keys$1;
var $bebd28704f2536ea$var$_Object$keys = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$keys);
// TODO: Remove from `core-js@4`
var $bebd28704f2536ea$var$$$u = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$uncurryThis$a = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$$Date = Date;
var $bebd28704f2536ea$var$thisTimeValue = $bebd28704f2536ea$var$uncurryThis$a($bebd28704f2536ea$var$$Date.prototype.getTime);
// `Date.now` method
// https://tc39.es/ecma262/#sec-date.now
$bebd28704f2536ea$var$$$u({
    target: 'Date',
    stat: true
}, {
    now: function now() {
        return $bebd28704f2536ea$var$thisTimeValue(new $bebd28704f2536ea$var$$Date());
    }
});
var $bebd28704f2536ea$var$path$l = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$now$3 = $bebd28704f2536ea$var$path$l.Date.now;
var $bebd28704f2536ea$var$parent$H = $bebd28704f2536ea$var$now$3;
var $bebd28704f2536ea$var$now$2 = $bebd28704f2536ea$var$parent$H;
var $bebd28704f2536ea$var$now$1 = $bebd28704f2536ea$var$now$2;
var $bebd28704f2536ea$var$_Date$now = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$now$1);
var $bebd28704f2536ea$var$fails$d = $bebd28704f2536ea$var$fails$w;
var $bebd28704f2536ea$var$arrayMethodIsStrict$6 = function(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && $bebd28704f2536ea$var$fails$d(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};
var $bebd28704f2536ea$var$$forEach = $bebd28704f2536ea$var$arrayIteration.forEach;
var $bebd28704f2536ea$var$arrayMethodIsStrict$5 = $bebd28704f2536ea$var$arrayMethodIsStrict$6;
var $bebd28704f2536ea$var$STRICT_METHOD$3 = $bebd28704f2536ea$var$arrayMethodIsStrict$5('forEach');
// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
var $bebd28704f2536ea$var$arrayForEach = !$bebd28704f2536ea$var$STRICT_METHOD$3 ? function forEach(callbackfn /* , thisArg */ ) {
    return $bebd28704f2536ea$var$$forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;
var $bebd28704f2536ea$var$$$t = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$forEach$6 = $bebd28704f2536ea$var$arrayForEach;
// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
$bebd28704f2536ea$var$$$t({
    target: 'Array',
    proto: true,
    forced: [].forEach !== $bebd28704f2536ea$var$forEach$6
}, {
    forEach: $bebd28704f2536ea$var$forEach$6
});
var $bebd28704f2536ea$var$entryVirtual$c = $bebd28704f2536ea$var$entryVirtual$i;
var $bebd28704f2536ea$var$forEach$5 = $bebd28704f2536ea$var$entryVirtual$c('Array').forEach;
var $bebd28704f2536ea$var$parent$G = $bebd28704f2536ea$var$forEach$5;
var $bebd28704f2536ea$var$forEach$4 = $bebd28704f2536ea$var$parent$G;
var $bebd28704f2536ea$var$classof$4 = $bebd28704f2536ea$var$classof$d;
var $bebd28704f2536ea$var$hasOwn$4 = $bebd28704f2536ea$var$hasOwnProperty_1;
var $bebd28704f2536ea$var$isPrototypeOf$d = $bebd28704f2536ea$var$objectIsPrototypeOf;
var $bebd28704f2536ea$var$method$a = $bebd28704f2536ea$var$forEach$4;
var $bebd28704f2536ea$var$ArrayPrototype$b = Array.prototype;
var $bebd28704f2536ea$var$DOMIterables$1 = {
    DOMTokenList: true,
    NodeList: true
};
var $bebd28704f2536ea$var$forEach$3 = function(it) {
    var own = it.forEach;
    return it === $bebd28704f2536ea$var$ArrayPrototype$b || $bebd28704f2536ea$var$isPrototypeOf$d($bebd28704f2536ea$var$ArrayPrototype$b, it) && own === $bebd28704f2536ea$var$ArrayPrototype$b.forEach || $bebd28704f2536ea$var$hasOwn$4($bebd28704f2536ea$var$DOMIterables$1, $bebd28704f2536ea$var$classof$4(it)) ? $bebd28704f2536ea$var$method$a : own;
};
var $bebd28704f2536ea$var$forEach$2 = $bebd28704f2536ea$var$forEach$3;
var $bebd28704f2536ea$var$_forEachInstanceProperty = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$forEach$2);
var $bebd28704f2536ea$var$$$s = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$uncurryThis$9 = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$isArray$1 = $bebd28704f2536ea$var$isArray$e;
var $bebd28704f2536ea$var$nativeReverse = $bebd28704f2536ea$var$uncurryThis$9([].reverse);
var $bebd28704f2536ea$var$test$1 = [
    1,
    2
];
// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$bebd28704f2536ea$var$$$s({
    target: 'Array',
    proto: true,
    forced: String($bebd28704f2536ea$var$test$1) === String($bebd28704f2536ea$var$test$1.reverse())
}, {
    reverse: function reverse() {
        // eslint-disable-next-line no-self-assign -- dirty hack
        if ($bebd28704f2536ea$var$isArray$1(this)) this.length = this.length;
        return $bebd28704f2536ea$var$nativeReverse(this);
    }
});
var $bebd28704f2536ea$var$entryVirtual$b = $bebd28704f2536ea$var$entryVirtual$i;
var $bebd28704f2536ea$var$reverse$3 = $bebd28704f2536ea$var$entryVirtual$b('Array').reverse;
var $bebd28704f2536ea$var$isPrototypeOf$c = $bebd28704f2536ea$var$objectIsPrototypeOf;
var $bebd28704f2536ea$var$method$9 = $bebd28704f2536ea$var$reverse$3;
var $bebd28704f2536ea$var$ArrayPrototype$a = Array.prototype;
var $bebd28704f2536ea$var$reverse$2 = function(it) {
    var own = it.reverse;
    return it === $bebd28704f2536ea$var$ArrayPrototype$a || $bebd28704f2536ea$var$isPrototypeOf$c($bebd28704f2536ea$var$ArrayPrototype$a, it) && own === $bebd28704f2536ea$var$ArrayPrototype$a.reverse ? $bebd28704f2536ea$var$method$9 : own;
};
var $bebd28704f2536ea$var$parent$F = $bebd28704f2536ea$var$reverse$2;
var $bebd28704f2536ea$var$reverse$1 = $bebd28704f2536ea$var$parent$F;
var $bebd28704f2536ea$var$reverse = $bebd28704f2536ea$var$reverse$1;
var $bebd28704f2536ea$var$_reverseInstanceProperty = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$reverse);
var $bebd28704f2536ea$var$tryToString$2 = $bebd28704f2536ea$var$tryToString$6;
var $bebd28704f2536ea$var$$TypeError$6 = TypeError;
var $bebd28704f2536ea$var$deletePropertyOrThrow$2 = function(O, P) {
    if (!delete O[P]) throw new $bebd28704f2536ea$var$$TypeError$6('Cannot delete property ' + $bebd28704f2536ea$var$tryToString$2(P) + ' of ' + $bebd28704f2536ea$var$tryToString$2(O));
};
var $bebd28704f2536ea$var$$$r = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$toObject$4 = $bebd28704f2536ea$var$toObject$e;
var $bebd28704f2536ea$var$toAbsoluteIndex$1 = $bebd28704f2536ea$var$toAbsoluteIndex$5;
var $bebd28704f2536ea$var$toIntegerOrInfinity = $bebd28704f2536ea$var$toIntegerOrInfinity$4;
var $bebd28704f2536ea$var$lengthOfArrayLike$4 = $bebd28704f2536ea$var$lengthOfArrayLike$c;
var $bebd28704f2536ea$var$setArrayLength = $bebd28704f2536ea$var$arraySetLength;
var $bebd28704f2536ea$var$doesNotExceedSafeInteger = $bebd28704f2536ea$var$doesNotExceedSafeInteger$3;
var $bebd28704f2536ea$var$arraySpeciesCreate = $bebd28704f2536ea$var$arraySpeciesCreate$3;
var $bebd28704f2536ea$var$createProperty$1 = $bebd28704f2536ea$var$createProperty$6;
var $bebd28704f2536ea$var$deletePropertyOrThrow$1 = $bebd28704f2536ea$var$deletePropertyOrThrow$2;
var $bebd28704f2536ea$var$arrayMethodHasSpeciesSupport$1 = $bebd28704f2536ea$var$arrayMethodHasSpeciesSupport$5;
var $bebd28704f2536ea$var$HAS_SPECIES_SUPPORT$1 = $bebd28704f2536ea$var$arrayMethodHasSpeciesSupport$1('splice');
var $bebd28704f2536ea$var$max = Math.max;
var $bebd28704f2536ea$var$min = Math.min;
// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$bebd28704f2536ea$var$$$r({
    target: 'Array',
    proto: true,
    forced: !$bebd28704f2536ea$var$HAS_SPECIES_SUPPORT$1
}, {
    splice: function splice(start, deleteCount /* , ...items */ ) {
        var O = $bebd28704f2536ea$var$toObject$4(this);
        var len = $bebd28704f2536ea$var$lengthOfArrayLike$4(O);
        var actualStart = $bebd28704f2536ea$var$toAbsoluteIndex$1(start, len);
        var argumentsLength = arguments.length;
        var insertCount, actualDeleteCount, A, k, from, to;
        if (argumentsLength === 0) insertCount = actualDeleteCount = 0;
        else if (argumentsLength === 1) {
            insertCount = 0;
            actualDeleteCount = len - actualStart;
        } else {
            insertCount = argumentsLength - 2;
            actualDeleteCount = $bebd28704f2536ea$var$min($bebd28704f2536ea$var$max($bebd28704f2536ea$var$toIntegerOrInfinity(deleteCount), 0), len - actualStart);
        }
        $bebd28704f2536ea$var$doesNotExceedSafeInteger(len + insertCount - actualDeleteCount);
        A = $bebd28704f2536ea$var$arraySpeciesCreate(O, actualDeleteCount);
        for(k = 0; k < actualDeleteCount; k++){
            from = actualStart + k;
            if (from in O) $bebd28704f2536ea$var$createProperty$1(A, k, O[from]);
        }
        A.length = actualDeleteCount;
        if (insertCount < actualDeleteCount) {
            for(k = actualStart; k < len - actualDeleteCount; k++){
                from = k + actualDeleteCount;
                to = k + insertCount;
                if (from in O) O[to] = O[from];
                else $bebd28704f2536ea$var$deletePropertyOrThrow$1(O, to);
            }
            for(k = len; k > len - actualDeleteCount + insertCount; k--)$bebd28704f2536ea$var$deletePropertyOrThrow$1(O, k - 1);
        } else if (insertCount > actualDeleteCount) for(k = len - actualDeleteCount; k > actualStart; k--){
            from = k + actualDeleteCount - 1;
            to = k + insertCount - 1;
            if (from in O) O[to] = O[from];
            else $bebd28704f2536ea$var$deletePropertyOrThrow$1(O, to);
        }
        for(k = 0; k < insertCount; k++)O[k + actualStart] = arguments[k + 2];
        $bebd28704f2536ea$var$setArrayLength(O, len - actualDeleteCount + insertCount);
        return A;
    }
});
var $bebd28704f2536ea$var$entryVirtual$a = $bebd28704f2536ea$var$entryVirtual$i;
var $bebd28704f2536ea$var$splice$4 = $bebd28704f2536ea$var$entryVirtual$a('Array').splice;
var $bebd28704f2536ea$var$isPrototypeOf$b = $bebd28704f2536ea$var$objectIsPrototypeOf;
var $bebd28704f2536ea$var$method$8 = $bebd28704f2536ea$var$splice$4;
var $bebd28704f2536ea$var$ArrayPrototype$9 = Array.prototype;
var $bebd28704f2536ea$var$splice$3 = function(it) {
    var own = it.splice;
    return it === $bebd28704f2536ea$var$ArrayPrototype$9 || $bebd28704f2536ea$var$isPrototypeOf$b($bebd28704f2536ea$var$ArrayPrototype$9, it) && own === $bebd28704f2536ea$var$ArrayPrototype$9.splice ? $bebd28704f2536ea$var$method$8 : own;
};
var $bebd28704f2536ea$var$parent$E = $bebd28704f2536ea$var$splice$3;
var $bebd28704f2536ea$var$splice$2 = $bebd28704f2536ea$var$parent$E;
var $bebd28704f2536ea$var$splice$1 = $bebd28704f2536ea$var$splice$2;
var $bebd28704f2536ea$var$_spliceInstanceProperty = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$splice$1);
var $bebd28704f2536ea$var$$$q = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$$includes = $bebd28704f2536ea$var$arrayIncludes.includes;
var $bebd28704f2536ea$var$fails$c = $bebd28704f2536ea$var$fails$w;
// FF99+ bug
var $bebd28704f2536ea$var$BROKEN_ON_SPARSE = $bebd28704f2536ea$var$fails$c(function() {
    // eslint-disable-next-line es/no-array-prototype-includes -- detection
    return !Array(1).includes();
});
// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$bebd28704f2536ea$var$$$q({
    target: 'Array',
    proto: true,
    forced: $bebd28704f2536ea$var$BROKEN_ON_SPARSE
}, {
    includes: function includes(el /* , fromIndex = 0 */ ) {
        return $bebd28704f2536ea$var$$includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
});
var $bebd28704f2536ea$var$entryVirtual$9 = $bebd28704f2536ea$var$entryVirtual$i;
var $bebd28704f2536ea$var$includes$4 = $bebd28704f2536ea$var$entryVirtual$9('Array').includes;
var $bebd28704f2536ea$var$isObject$8 = $bebd28704f2536ea$var$isObject$j;
var $bebd28704f2536ea$var$classof$3 = $bebd28704f2536ea$var$classofRaw$2;
var $bebd28704f2536ea$var$wellKnownSymbol$2 = $bebd28704f2536ea$var$wellKnownSymbol$m;
var $bebd28704f2536ea$var$MATCH$1 = $bebd28704f2536ea$var$wellKnownSymbol$2('match');
// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var $bebd28704f2536ea$var$isRegexp = function(it) {
    var isRegExp;
    return $bebd28704f2536ea$var$isObject$8(it) && ((isRegExp = it[$bebd28704f2536ea$var$MATCH$1]) !== undefined ? !!isRegExp : $bebd28704f2536ea$var$classof$3(it) === 'RegExp');
};
var $bebd28704f2536ea$var$isRegExp = $bebd28704f2536ea$var$isRegexp;
var $bebd28704f2536ea$var$$TypeError$5 = TypeError;
var $bebd28704f2536ea$var$notARegexp = function(it) {
    if ($bebd28704f2536ea$var$isRegExp(it)) throw new $bebd28704f2536ea$var$$TypeError$5("The method doesn't accept regular expressions");
    return it;
};
var $bebd28704f2536ea$var$wellKnownSymbol$1 = $bebd28704f2536ea$var$wellKnownSymbol$m;
var $bebd28704f2536ea$var$MATCH = $bebd28704f2536ea$var$wellKnownSymbol$1('match');
var $bebd28704f2536ea$var$correctIsRegexpLogic = function(METHOD_NAME) {
    var regexp = /./;
    try {
        '/./'[METHOD_NAME](regexp);
    } catch (error1) {
        try {
            regexp[$bebd28704f2536ea$var$MATCH] = false;
            return '/./'[METHOD_NAME](regexp);
        } catch (error2) {}
    }
    return false;
};
var $bebd28704f2536ea$var$$$p = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$uncurryThis$8 = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$notARegExp = $bebd28704f2536ea$var$notARegexp;
var $bebd28704f2536ea$var$requireObjectCoercible$1 = $bebd28704f2536ea$var$requireObjectCoercible$5;
var $bebd28704f2536ea$var$toString$4 = $bebd28704f2536ea$var$toString$a;
var $bebd28704f2536ea$var$correctIsRegExpLogic = $bebd28704f2536ea$var$correctIsRegexpLogic;
var $bebd28704f2536ea$var$stringIndexOf = $bebd28704f2536ea$var$uncurryThis$8(''.indexOf);
// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$bebd28704f2536ea$var$$$p({
    target: 'String',
    proto: true,
    forced: !$bebd28704f2536ea$var$correctIsRegExpLogic('includes')
}, {
    includes: function includes(searchString /* , position = 0 */ ) {
        return !!~$bebd28704f2536ea$var$stringIndexOf($bebd28704f2536ea$var$toString$4($bebd28704f2536ea$var$requireObjectCoercible$1(this)), $bebd28704f2536ea$var$toString$4($bebd28704f2536ea$var$notARegExp(searchString)), arguments.length > 1 ? arguments[1] : undefined);
    }
});
var $bebd28704f2536ea$var$entryVirtual$8 = $bebd28704f2536ea$var$entryVirtual$i;
var $bebd28704f2536ea$var$includes$3 = $bebd28704f2536ea$var$entryVirtual$8('String').includes;
var $bebd28704f2536ea$var$isPrototypeOf$a = $bebd28704f2536ea$var$objectIsPrototypeOf;
var $bebd28704f2536ea$var$arrayMethod = $bebd28704f2536ea$var$includes$4;
var $bebd28704f2536ea$var$stringMethod = $bebd28704f2536ea$var$includes$3;
var $bebd28704f2536ea$var$ArrayPrototype$8 = Array.prototype;
var $bebd28704f2536ea$var$StringPrototype = String.prototype;
var $bebd28704f2536ea$var$includes$2 = function(it) {
    var own = it.includes;
    if (it === $bebd28704f2536ea$var$ArrayPrototype$8 || $bebd28704f2536ea$var$isPrototypeOf$a($bebd28704f2536ea$var$ArrayPrototype$8, it) && own === $bebd28704f2536ea$var$ArrayPrototype$8.includes) return $bebd28704f2536ea$var$arrayMethod;
    if (typeof it == 'string' || it === $bebd28704f2536ea$var$StringPrototype || $bebd28704f2536ea$var$isPrototypeOf$a($bebd28704f2536ea$var$StringPrototype, it) && own === $bebd28704f2536ea$var$StringPrototype.includes) return $bebd28704f2536ea$var$stringMethod;
    return own;
};
var $bebd28704f2536ea$var$parent$D = $bebd28704f2536ea$var$includes$2;
var $bebd28704f2536ea$var$includes$1 = $bebd28704f2536ea$var$parent$D;
var $bebd28704f2536ea$var$includes = $bebd28704f2536ea$var$includes$1;
var $bebd28704f2536ea$var$_includesInstanceProperty = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$includes);
var $bebd28704f2536ea$var$$$o = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$fails$b = $bebd28704f2536ea$var$fails$w;
var $bebd28704f2536ea$var$toObject$3 = $bebd28704f2536ea$var$toObject$e;
var $bebd28704f2536ea$var$nativeGetPrototypeOf = $bebd28704f2536ea$var$objectGetPrototypeOf;
var $bebd28704f2536ea$var$CORRECT_PROTOTYPE_GETTER = $bebd28704f2536ea$var$correctPrototypeGetter;
var $bebd28704f2536ea$var$FAILS_ON_PRIMITIVES$2 = $bebd28704f2536ea$var$fails$b(function() {
    $bebd28704f2536ea$var$nativeGetPrototypeOf(1);
});
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$bebd28704f2536ea$var$$$o({
    target: 'Object',
    stat: true,
    forced: $bebd28704f2536ea$var$FAILS_ON_PRIMITIVES$2,
    sham: !$bebd28704f2536ea$var$CORRECT_PROTOTYPE_GETTER
}, {
    getPrototypeOf: function getPrototypeOf(it) {
        return $bebd28704f2536ea$var$nativeGetPrototypeOf($bebd28704f2536ea$var$toObject$3(it));
    }
});
var $bebd28704f2536ea$var$path$k = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$getPrototypeOf$6 = $bebd28704f2536ea$var$path$k.Object.getPrototypeOf;
var $bebd28704f2536ea$var$parent$C = $bebd28704f2536ea$var$getPrototypeOf$6;
var $bebd28704f2536ea$var$getPrototypeOf$5 = $bebd28704f2536ea$var$parent$C;
var $bebd28704f2536ea$var$getPrototypeOf$4 = $bebd28704f2536ea$var$getPrototypeOf$5;
var $bebd28704f2536ea$var$_Object$getPrototypeOf$1 = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$getPrototypeOf$4);
var $bebd28704f2536ea$var$$$n = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$$filter = $bebd28704f2536ea$var$arrayIteration.filter;
var $bebd28704f2536ea$var$arrayMethodHasSpeciesSupport = $bebd28704f2536ea$var$arrayMethodHasSpeciesSupport$5;
var $bebd28704f2536ea$var$HAS_SPECIES_SUPPORT = $bebd28704f2536ea$var$arrayMethodHasSpeciesSupport('filter');
// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$bebd28704f2536ea$var$$$n({
    target: 'Array',
    proto: true,
    forced: !$bebd28704f2536ea$var$HAS_SPECIES_SUPPORT
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        return $bebd28704f2536ea$var$$filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
var $bebd28704f2536ea$var$entryVirtual$7 = $bebd28704f2536ea$var$entryVirtual$i;
var $bebd28704f2536ea$var$filter$3 = $bebd28704f2536ea$var$entryVirtual$7('Array').filter;
var $bebd28704f2536ea$var$isPrototypeOf$9 = $bebd28704f2536ea$var$objectIsPrototypeOf;
var $bebd28704f2536ea$var$method$7 = $bebd28704f2536ea$var$filter$3;
var $bebd28704f2536ea$var$ArrayPrototype$7 = Array.prototype;
var $bebd28704f2536ea$var$filter$2 = function(it) {
    var own = it.filter;
    return it === $bebd28704f2536ea$var$ArrayPrototype$7 || $bebd28704f2536ea$var$isPrototypeOf$9($bebd28704f2536ea$var$ArrayPrototype$7, it) && own === $bebd28704f2536ea$var$ArrayPrototype$7.filter ? $bebd28704f2536ea$var$method$7 : own;
};
var $bebd28704f2536ea$var$parent$B = $bebd28704f2536ea$var$filter$2;
var $bebd28704f2536ea$var$filter$1 = $bebd28704f2536ea$var$parent$B;
var $bebd28704f2536ea$var$filter = $bebd28704f2536ea$var$filter$1;
var $bebd28704f2536ea$var$_filterInstanceProperty = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$filter);
// a string of all valid unicode whitespaces
var $bebd28704f2536ea$var$whitespaces$3 = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
var $bebd28704f2536ea$var$uncurryThis$7 = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$requireObjectCoercible = $bebd28704f2536ea$var$requireObjectCoercible$5;
var $bebd28704f2536ea$var$toString$3 = $bebd28704f2536ea$var$toString$a;
var $bebd28704f2536ea$var$whitespaces$2 = $bebd28704f2536ea$var$whitespaces$3;
var $bebd28704f2536ea$var$replace = $bebd28704f2536ea$var$uncurryThis$7(''.replace);
var $bebd28704f2536ea$var$ltrim = RegExp('^[' + $bebd28704f2536ea$var$whitespaces$2 + ']+');
var $bebd28704f2536ea$var$rtrim = RegExp('(^|[^' + $bebd28704f2536ea$var$whitespaces$2 + '])[' + $bebd28704f2536ea$var$whitespaces$2 + ']+$');
// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var $bebd28704f2536ea$var$createMethod$1 = function(TYPE) {
    return function($this) {
        var string = $bebd28704f2536ea$var$toString$3($bebd28704f2536ea$var$requireObjectCoercible($this));
        if (TYPE & 1) string = $bebd28704f2536ea$var$replace(string, $bebd28704f2536ea$var$ltrim, '');
        if (TYPE & 2) string = $bebd28704f2536ea$var$replace(string, $bebd28704f2536ea$var$rtrim, '$1');
        return string;
    };
};
var $bebd28704f2536ea$var$stringTrim = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: $bebd28704f2536ea$var$createMethod$1(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: $bebd28704f2536ea$var$createMethod$1(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: $bebd28704f2536ea$var$createMethod$1(3)
};
var $bebd28704f2536ea$var$global$9 = $bebd28704f2536ea$var$global$n;
var $bebd28704f2536ea$var$fails$a = $bebd28704f2536ea$var$fails$w;
var $bebd28704f2536ea$var$uncurryThis$6 = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$toString$2 = $bebd28704f2536ea$var$toString$a;
var $bebd28704f2536ea$var$trim$1 = $bebd28704f2536ea$var$stringTrim.trim;
var $bebd28704f2536ea$var$whitespaces$1 = $bebd28704f2536ea$var$whitespaces$3;
var $bebd28704f2536ea$var$$parseInt$1 = $bebd28704f2536ea$var$global$9.parseInt;
var $bebd28704f2536ea$var$Symbol$2 = $bebd28704f2536ea$var$global$9.Symbol;
var $bebd28704f2536ea$var$ITERATOR$1 = $bebd28704f2536ea$var$Symbol$2 && $bebd28704f2536ea$var$Symbol$2.iterator;
var $bebd28704f2536ea$var$hex = /^[+-]?0x/i;
var $bebd28704f2536ea$var$exec = $bebd28704f2536ea$var$uncurryThis$6($bebd28704f2536ea$var$hex.exec);
var $bebd28704f2536ea$var$FORCED$7 = $bebd28704f2536ea$var$$parseInt$1($bebd28704f2536ea$var$whitespaces$1 + '08') !== 8 || $bebd28704f2536ea$var$$parseInt$1($bebd28704f2536ea$var$whitespaces$1 + '0x16') !== 22 || $bebd28704f2536ea$var$ITERATOR$1 && !$bebd28704f2536ea$var$fails$a(function() {
    $bebd28704f2536ea$var$$parseInt$1(Object($bebd28704f2536ea$var$ITERATOR$1));
});
// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
var $bebd28704f2536ea$var$numberParseInt = $bebd28704f2536ea$var$FORCED$7 ? function parseInt1(string, radix) {
    var S = $bebd28704f2536ea$var$trim$1($bebd28704f2536ea$var$toString$2(string));
    return $bebd28704f2536ea$var$$parseInt$1(S, radix >>> 0 || ($bebd28704f2536ea$var$exec($bebd28704f2536ea$var$hex, S) ? 16 : 10));
} : $bebd28704f2536ea$var$$parseInt$1;
var $bebd28704f2536ea$var$$$m = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$$parseInt = $bebd28704f2536ea$var$numberParseInt;
// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$bebd28704f2536ea$var$$$m({
    global: true,
    forced: parseInt !== $bebd28704f2536ea$var$$parseInt
}, {
    parseInt: $bebd28704f2536ea$var$$parseInt
});
var $bebd28704f2536ea$var$path$j = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$_parseInt$3 = $bebd28704f2536ea$var$path$j.parseInt;
var $bebd28704f2536ea$var$parent$A = $bebd28704f2536ea$var$_parseInt$3;
var $bebd28704f2536ea$var$_parseInt$2 = $bebd28704f2536ea$var$parent$A;
var $bebd28704f2536ea$var$_parseInt = $bebd28704f2536ea$var$_parseInt$2;
var $bebd28704f2536ea$var$_parseInt$1 = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$_parseInt);
/* eslint-disable es/no-array-prototype-indexof -- required for testing */ var $bebd28704f2536ea$var$$$l = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$uncurryThis$5 = $bebd28704f2536ea$var$functionUncurryThisClause;
var $bebd28704f2536ea$var$$indexOf = $bebd28704f2536ea$var$arrayIncludes.indexOf;
var $bebd28704f2536ea$var$arrayMethodIsStrict$4 = $bebd28704f2536ea$var$arrayMethodIsStrict$6;
var $bebd28704f2536ea$var$nativeIndexOf = $bebd28704f2536ea$var$uncurryThis$5([].indexOf);
var $bebd28704f2536ea$var$NEGATIVE_ZERO = !!$bebd28704f2536ea$var$nativeIndexOf && 1 / $bebd28704f2536ea$var$nativeIndexOf([
    1
], 1, -0) < 0;
var $bebd28704f2536ea$var$FORCED$6 = $bebd28704f2536ea$var$NEGATIVE_ZERO || !$bebd28704f2536ea$var$arrayMethodIsStrict$4('indexOf');
// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
$bebd28704f2536ea$var$$$l({
    target: 'Array',
    proto: true,
    forced: $bebd28704f2536ea$var$FORCED$6
}, {
    indexOf: function indexOf(searchElement /* , fromIndex = 0 */ ) {
        var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
        return $bebd28704f2536ea$var$NEGATIVE_ZERO ? $bebd28704f2536ea$var$nativeIndexOf(this, searchElement, fromIndex) || 0 : $bebd28704f2536ea$var$$indexOf(this, searchElement, fromIndex);
    }
});
var $bebd28704f2536ea$var$entryVirtual$6 = $bebd28704f2536ea$var$entryVirtual$i;
var $bebd28704f2536ea$var$indexOf$3 = $bebd28704f2536ea$var$entryVirtual$6('Array').indexOf;
var $bebd28704f2536ea$var$isPrototypeOf$8 = $bebd28704f2536ea$var$objectIsPrototypeOf;
var $bebd28704f2536ea$var$method$6 = $bebd28704f2536ea$var$indexOf$3;
var $bebd28704f2536ea$var$ArrayPrototype$6 = Array.prototype;
var $bebd28704f2536ea$var$indexOf$2 = function(it) {
    var own = it.indexOf;
    return it === $bebd28704f2536ea$var$ArrayPrototype$6 || $bebd28704f2536ea$var$isPrototypeOf$8($bebd28704f2536ea$var$ArrayPrototype$6, it) && own === $bebd28704f2536ea$var$ArrayPrototype$6.indexOf ? $bebd28704f2536ea$var$method$6 : own;
};
var $bebd28704f2536ea$var$parent$z = $bebd28704f2536ea$var$indexOf$2;
var $bebd28704f2536ea$var$indexOf$1 = $bebd28704f2536ea$var$parent$z;
var $bebd28704f2536ea$var$indexOf = $bebd28704f2536ea$var$indexOf$1;
var $bebd28704f2536ea$var$_indexOfInstanceProperty = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$indexOf);
// TODO: Remove from `core-js@4`
var $bebd28704f2536ea$var$$$k = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$DESCRIPTORS$6 = $bebd28704f2536ea$var$descriptors;
var $bebd28704f2536ea$var$create$8 = $bebd28704f2536ea$var$objectCreate;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
$bebd28704f2536ea$var$$$k({
    target: 'Object',
    stat: true,
    sham: !$bebd28704f2536ea$var$DESCRIPTORS$6
}, {
    create: $bebd28704f2536ea$var$create$8
});
var $bebd28704f2536ea$var$path$i = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$Object$4 = $bebd28704f2536ea$var$path$i.Object;
var $bebd28704f2536ea$var$create$7 = function create(P, D) {
    return $bebd28704f2536ea$var$Object$4.create(P, D);
};
var $bebd28704f2536ea$var$parent$y = $bebd28704f2536ea$var$create$7;
var $bebd28704f2536ea$var$create$6 = $bebd28704f2536ea$var$parent$y;
var $bebd28704f2536ea$var$create$5 = $bebd28704f2536ea$var$create$6;
var $bebd28704f2536ea$var$_Object$create$1 = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$create$5);
var $bebd28704f2536ea$var$path$h = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$apply$2 = $bebd28704f2536ea$var$functionApply;
// eslint-disable-next-line es/no-json -- safe
if (!$bebd28704f2536ea$var$path$h.JSON) $bebd28704f2536ea$var$path$h.JSON = {
    stringify: JSON.stringify
};
// eslint-disable-next-line no-unused-vars -- required for `.length`
var $bebd28704f2536ea$var$stringify$2 = function stringify(it, replacer, space) {
    return $bebd28704f2536ea$var$apply$2($bebd28704f2536ea$var$path$h.JSON.stringify, null, arguments);
};
var $bebd28704f2536ea$var$parent$x = $bebd28704f2536ea$var$stringify$2;
var $bebd28704f2536ea$var$stringify$1 = $bebd28704f2536ea$var$parent$x;
var $bebd28704f2536ea$var$stringify = $bebd28704f2536ea$var$stringify$1;
var $bebd28704f2536ea$var$_JSON$stringify = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$stringify);
/* global Bun -- Deno case */ var $bebd28704f2536ea$var$engineIsBun = typeof Bun == 'function' && Bun && typeof Bun.version == 'string';
var $bebd28704f2536ea$var$$TypeError$4 = TypeError;
var $bebd28704f2536ea$var$validateArgumentsLength$1 = function(passed, required) {
    if (passed < required) throw new $bebd28704f2536ea$var$$TypeError$4('Not enough arguments');
    return passed;
};
var $bebd28704f2536ea$var$global$8 = $bebd28704f2536ea$var$global$n;
var $bebd28704f2536ea$var$apply$1 = $bebd28704f2536ea$var$functionApply;
var $bebd28704f2536ea$var$isCallable$1 = $bebd28704f2536ea$var$isCallable$i;
var $bebd28704f2536ea$var$ENGINE_IS_BUN = $bebd28704f2536ea$var$engineIsBun;
var $bebd28704f2536ea$var$USER_AGENT = $bebd28704f2536ea$var$engineUserAgent;
var $bebd28704f2536ea$var$arraySlice$1 = $bebd28704f2536ea$var$arraySlice$5;
var $bebd28704f2536ea$var$validateArgumentsLength = $bebd28704f2536ea$var$validateArgumentsLength$1;
var $bebd28704f2536ea$var$Function$1 = $bebd28704f2536ea$var$global$8.Function;
// dirty IE9- and Bun 0.3.0- checks
var $bebd28704f2536ea$var$WRAP = /MSIE .\./.test($bebd28704f2536ea$var$USER_AGENT) || $bebd28704f2536ea$var$ENGINE_IS_BUN && function() {
    var version = $bebd28704f2536ea$var$global$8.Bun.version.split('.');
    return version.length < 3 || version[0] === '0' && (version[1] < 3 || version[1] === '3' && version[2] === '0');
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
var $bebd28704f2536ea$var$schedulersFix$2 = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $bebd28704f2536ea$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $bebd28704f2536ea$var$validateArgumentsLength(arguments.length, 1) > firstParamIndex;
        var fn = $bebd28704f2536ea$var$isCallable$1(handler) ? handler : $bebd28704f2536ea$var$Function$1(handler);
        var params = boundArgs ? $bebd28704f2536ea$var$arraySlice$1(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $bebd28704f2536ea$var$apply$1(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};
var $bebd28704f2536ea$var$$$j = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$global$7 = $bebd28704f2536ea$var$global$n;
var $bebd28704f2536ea$var$schedulersFix$1 = $bebd28704f2536ea$var$schedulersFix$2;
var $bebd28704f2536ea$var$setInterval$2 = $bebd28704f2536ea$var$schedulersFix$1($bebd28704f2536ea$var$global$7.setInterval, true);
// Bun / IE9- setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
$bebd28704f2536ea$var$$$j({
    global: true,
    bind: true,
    forced: $bebd28704f2536ea$var$global$7.setInterval !== $bebd28704f2536ea$var$setInterval$2
}, {
    setInterval: $bebd28704f2536ea$var$setInterval$2
});
var $bebd28704f2536ea$var$$$i = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$global$6 = $bebd28704f2536ea$var$global$n;
var $bebd28704f2536ea$var$schedulersFix = $bebd28704f2536ea$var$schedulersFix$2;
var $bebd28704f2536ea$var$setTimeout$3 = $bebd28704f2536ea$var$schedulersFix($bebd28704f2536ea$var$global$6.setTimeout, true);
// Bun / IE9- setTimeout additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
$bebd28704f2536ea$var$$$i({
    global: true,
    bind: true,
    forced: $bebd28704f2536ea$var$global$6.setTimeout !== $bebd28704f2536ea$var$setTimeout$3
}, {
    setTimeout: $bebd28704f2536ea$var$setTimeout$3
});
var $bebd28704f2536ea$var$path$g = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$setTimeout$2 = $bebd28704f2536ea$var$path$g.setTimeout;
var $bebd28704f2536ea$var$setTimeout$1 = $bebd28704f2536ea$var$setTimeout$2;
var $bebd28704f2536ea$var$_setTimeout = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$setTimeout$1);
var $bebd28704f2536ea$var$toObject$2 = $bebd28704f2536ea$var$toObject$e;
var $bebd28704f2536ea$var$toAbsoluteIndex = $bebd28704f2536ea$var$toAbsoluteIndex$5;
var $bebd28704f2536ea$var$lengthOfArrayLike$3 = $bebd28704f2536ea$var$lengthOfArrayLike$c;
// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
var $bebd28704f2536ea$var$arrayFill = function fill(value /* , start = 0, end = @length */ ) {
    var O = $bebd28704f2536ea$var$toObject$2(this);
    var length1 = $bebd28704f2536ea$var$lengthOfArrayLike$3(O);
    var argumentsLength = arguments.length;
    var index = $bebd28704f2536ea$var$toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length1);
    var end = argumentsLength > 2 ? arguments[2] : undefined;
    var endPos = end === undefined ? length1 : $bebd28704f2536ea$var$toAbsoluteIndex(end, length1);
    while(endPos > index)O[index++] = value;
    return O;
};
var $bebd28704f2536ea$var$$$h = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$fill$4 = $bebd28704f2536ea$var$arrayFill;
// `Array.prototype.fill` method
// https://tc39.es/ecma262/#sec-array.prototype.fill
$bebd28704f2536ea$var$$$h({
    target: 'Array',
    proto: true
}, {
    fill: $bebd28704f2536ea$var$fill$4
});
var $bebd28704f2536ea$var$entryVirtual$5 = $bebd28704f2536ea$var$entryVirtual$i;
var $bebd28704f2536ea$var$fill$3 = $bebd28704f2536ea$var$entryVirtual$5('Array').fill;
var $bebd28704f2536ea$var$isPrototypeOf$7 = $bebd28704f2536ea$var$objectIsPrototypeOf;
var $bebd28704f2536ea$var$method$5 = $bebd28704f2536ea$var$fill$3;
var $bebd28704f2536ea$var$ArrayPrototype$5 = Array.prototype;
var $bebd28704f2536ea$var$fill$2 = function(it) {
    var own = it.fill;
    return it === $bebd28704f2536ea$var$ArrayPrototype$5 || $bebd28704f2536ea$var$isPrototypeOf$7($bebd28704f2536ea$var$ArrayPrototype$5, it) && own === $bebd28704f2536ea$var$ArrayPrototype$5.fill ? $bebd28704f2536ea$var$method$5 : own;
};
var $bebd28704f2536ea$var$parent$w = $bebd28704f2536ea$var$fill$2;
var $bebd28704f2536ea$var$fill$1 = $bebd28704f2536ea$var$parent$w;
var $bebd28704f2536ea$var$fill = $bebd28704f2536ea$var$fill$1;
var $bebd28704f2536ea$var$_fillInstanceProperty = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$fill);
/*! Hammer.JS - v2.0.17-rc - 2019-12-16
 * http://naver.github.io/egjs
 *
 * Forked By Naver egjs
 * Copyright (c) hammerjs
 * Licensed under the MIT license */ function $bebd28704f2536ea$var$_extends() {
    $bebd28704f2536ea$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bebd28704f2536ea$var$_extends.apply(this, arguments);
}
function $bebd28704f2536ea$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $bebd28704f2536ea$var$_assertThisInitialized$1(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
/**
 * @private
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */ var $bebd28704f2536ea$var$assign;
if (typeof Object.assign !== 'function') $bebd28704f2536ea$var$assign = function assign(target) {
    if (target === undefined || target === null) throw new TypeError('Cannot convert undefined or null to object');
    var output = Object(target);
    for(var index = 1; index < arguments.length; index++){
        var source = arguments[index];
        if (source !== undefined && source !== null) {
            for(var nextKey in source)if (source.hasOwnProperty(nextKey)) output[nextKey] = source[nextKey];
        }
    }
    return output;
};
else $bebd28704f2536ea$var$assign = Object.assign;
var $bebd28704f2536ea$var$assign$1 = $bebd28704f2536ea$var$assign;
var $bebd28704f2536ea$var$VENDOR_PREFIXES = [
    '',
    'webkit',
    'Moz',
    'MS',
    'ms',
    'o'
];
var $bebd28704f2536ea$var$TEST_ELEMENT = typeof document === "undefined" ? {
    style: {}
} : document.createElement('div');
var $bebd28704f2536ea$var$TYPE_FUNCTION = 'function';
var $bebd28704f2536ea$var$round = Math.round, $bebd28704f2536ea$var$abs$1 = Math.abs;
var $bebd28704f2536ea$var$now = Date.now;
/**
 * @private
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */ function $bebd28704f2536ea$var$prefixed(obj, property) {
    var prefix;
    var prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);
    var i = 0;
    while(i < $bebd28704f2536ea$var$VENDOR_PREFIXES.length){
        prefix = $bebd28704f2536ea$var$VENDOR_PREFIXES[i];
        prop = prefix ? prefix + camelProp : property;
        if (prop in obj) return prop;
        i++;
    }
    return undefined;
}
/* eslint-disable no-new-func, no-nested-ternary */ var $bebd28704f2536ea$var$win;
if (typeof window === "undefined") // window is undefined in node.js
$bebd28704f2536ea$var$win = {};
else $bebd28704f2536ea$var$win = window;
var $bebd28704f2536ea$var$PREFIXED_TOUCH_ACTION = $bebd28704f2536ea$var$prefixed($bebd28704f2536ea$var$TEST_ELEMENT.style, 'touchAction');
var $bebd28704f2536ea$var$NATIVE_TOUCH_ACTION = $bebd28704f2536ea$var$PREFIXED_TOUCH_ACTION !== undefined;
function $bebd28704f2536ea$var$getTouchActionProps() {
    if (!$bebd28704f2536ea$var$NATIVE_TOUCH_ACTION) return false;
    var touchMap = {};
    var cssSupports = $bebd28704f2536ea$var$win.CSS && $bebd28704f2536ea$var$win.CSS.supports;
    [
        'auto',
        'manipulation',
        'pan-y',
        'pan-x',
        'pan-x pan-y',
        'none'
    ].forEach(function(val) {
        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        return touchMap[val] = cssSupports ? $bebd28704f2536ea$var$win.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}
var $bebd28704f2536ea$var$TOUCH_ACTION_COMPUTE = 'compute';
var $bebd28704f2536ea$var$TOUCH_ACTION_AUTO = 'auto';
var $bebd28704f2536ea$var$TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var $bebd28704f2536ea$var$TOUCH_ACTION_NONE = 'none';
var $bebd28704f2536ea$var$TOUCH_ACTION_PAN_X = 'pan-x';
var $bebd28704f2536ea$var$TOUCH_ACTION_PAN_Y = 'pan-y';
var $bebd28704f2536ea$var$TOUCH_ACTION_MAP = $bebd28704f2536ea$var$getTouchActionProps();
var $bebd28704f2536ea$var$MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
var $bebd28704f2536ea$var$SUPPORT_TOUCH = 'ontouchstart' in $bebd28704f2536ea$var$win;
var $bebd28704f2536ea$var$SUPPORT_POINTER_EVENTS = $bebd28704f2536ea$var$prefixed($bebd28704f2536ea$var$win, 'PointerEvent') !== undefined;
var $bebd28704f2536ea$var$SUPPORT_ONLY_TOUCH = $bebd28704f2536ea$var$SUPPORT_TOUCH && $bebd28704f2536ea$var$MOBILE_REGEX.test(navigator.userAgent);
var $bebd28704f2536ea$var$INPUT_TYPE_TOUCH = 'touch';
var $bebd28704f2536ea$var$INPUT_TYPE_PEN = 'pen';
var $bebd28704f2536ea$var$INPUT_TYPE_MOUSE = 'mouse';
var $bebd28704f2536ea$var$INPUT_TYPE_KINECT = 'kinect';
var $bebd28704f2536ea$var$COMPUTE_INTERVAL = 25;
var $bebd28704f2536ea$var$INPUT_START = 1;
var $bebd28704f2536ea$var$INPUT_MOVE = 2;
var $bebd28704f2536ea$var$INPUT_END = 4;
var $bebd28704f2536ea$var$INPUT_CANCEL = 8;
var $bebd28704f2536ea$var$DIRECTION_NONE = 1;
var $bebd28704f2536ea$var$DIRECTION_LEFT = 2;
var $bebd28704f2536ea$var$DIRECTION_RIGHT = 4;
var $bebd28704f2536ea$var$DIRECTION_UP = 8;
var $bebd28704f2536ea$var$DIRECTION_DOWN = 16;
var $bebd28704f2536ea$var$DIRECTION_HORIZONTAL = $bebd28704f2536ea$var$DIRECTION_LEFT | $bebd28704f2536ea$var$DIRECTION_RIGHT;
var $bebd28704f2536ea$var$DIRECTION_VERTICAL = $bebd28704f2536ea$var$DIRECTION_UP | $bebd28704f2536ea$var$DIRECTION_DOWN;
var $bebd28704f2536ea$var$DIRECTION_ALL = $bebd28704f2536ea$var$DIRECTION_HORIZONTAL | $bebd28704f2536ea$var$DIRECTION_VERTICAL;
var $bebd28704f2536ea$var$PROPS_XY = [
    'x',
    'y'
];
var $bebd28704f2536ea$var$PROPS_CLIENT_XY = [
    'clientX',
    'clientY'
];
/**
 * @private
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */ function $bebd28704f2536ea$var$each(obj, iterator, context) {
    var i;
    if (!obj) return;
    if (obj.forEach) obj.forEach(iterator, context);
    else if (obj.length !== undefined) {
        i = 0;
        while(i < obj.length){
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else for(i in obj)obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
}
/**
 * @private
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */ function $bebd28704f2536ea$var$boolOrFn(val, args) {
    if (typeof val === $bebd28704f2536ea$var$TYPE_FUNCTION) return val.apply(args ? args[0] || undefined : undefined, args);
    return val;
}
/**
 * @private
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */ function $bebd28704f2536ea$var$inStr(str, find) {
    return str.indexOf(find) > -1;
}
/**
 * @private
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */ function $bebd28704f2536ea$var$cleanTouchActions(actions) {
    // none
    if ($bebd28704f2536ea$var$inStr(actions, $bebd28704f2536ea$var$TOUCH_ACTION_NONE)) return $bebd28704f2536ea$var$TOUCH_ACTION_NONE;
    var hasPanX = $bebd28704f2536ea$var$inStr(actions, $bebd28704f2536ea$var$TOUCH_ACTION_PAN_X);
    var hasPanY = $bebd28704f2536ea$var$inStr(actions, $bebd28704f2536ea$var$TOUCH_ACTION_PAN_Y); // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) return $bebd28704f2536ea$var$TOUCH_ACTION_NONE;
     // pan-x OR pan-y
    if (hasPanX || hasPanY) return hasPanX ? $bebd28704f2536ea$var$TOUCH_ACTION_PAN_X : $bebd28704f2536ea$var$TOUCH_ACTION_PAN_Y;
     // manipulation
    if ($bebd28704f2536ea$var$inStr(actions, $bebd28704f2536ea$var$TOUCH_ACTION_MANIPULATION)) return $bebd28704f2536ea$var$TOUCH_ACTION_MANIPULATION;
    return $bebd28704f2536ea$var$TOUCH_ACTION_AUTO;
}
/**
 * @private
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */ var $bebd28704f2536ea$var$TouchAction = /*#__PURE__*/ function() {
    function TouchAction(manager, value) {
        this.manager = manager;
        this.set(value);
    }
    /**
   * @private
   * set the touchAction value on the element or enable the polyfill
   * @param {String} value
   */ var _proto = TouchAction.prototype;
    _proto.set = function set(value) {
        // find out the touch-action by the event handlers
        if (value === $bebd28704f2536ea$var$TOUCH_ACTION_COMPUTE) value = this.compute();
        if ($bebd28704f2536ea$var$NATIVE_TOUCH_ACTION && this.manager.element.style && $bebd28704f2536ea$var$TOUCH_ACTION_MAP[value]) this.manager.element.style[$bebd28704f2536ea$var$PREFIXED_TOUCH_ACTION] = value;
        this.actions = value.toLowerCase().trim();
    };
    /**
   * @private
   * just re-set the touchAction value
   */ _proto.update = function update() {
        this.set(this.manager.options.touchAction);
    };
    /**
   * @private
   * compute the value for the touchAction property based on the recognizer's settings
   * @returns {String} value
   */ _proto.compute = function compute() {
        var actions = [];
        $bebd28704f2536ea$var$each(this.manager.recognizers, function(recognizer) {
            if ($bebd28704f2536ea$var$boolOrFn(recognizer.options.enable, [
                recognizer
            ])) actions = actions.concat(recognizer.getTouchAction());
        });
        return $bebd28704f2536ea$var$cleanTouchActions(actions.join(' '));
    };
    /**
   * @private
   * this method is called on each input cycle and provides the preventing of the browser behavior
   * @param {Object} input
   */ _proto.preventDefaults = function preventDefaults(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection; // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }
        var actions = this.actions;
        var hasNone = $bebd28704f2536ea$var$inStr(actions, $bebd28704f2536ea$var$TOUCH_ACTION_NONE) && !$bebd28704f2536ea$var$TOUCH_ACTION_MAP[$bebd28704f2536ea$var$TOUCH_ACTION_NONE];
        var hasPanY = $bebd28704f2536ea$var$inStr(actions, $bebd28704f2536ea$var$TOUCH_ACTION_PAN_Y) && !$bebd28704f2536ea$var$TOUCH_ACTION_MAP[$bebd28704f2536ea$var$TOUCH_ACTION_PAN_Y];
        var hasPanX = $bebd28704f2536ea$var$inStr(actions, $bebd28704f2536ea$var$TOUCH_ACTION_PAN_X) && !$bebd28704f2536ea$var$TOUCH_ACTION_MAP[$bebd28704f2536ea$var$TOUCH_ACTION_PAN_X];
        if (hasNone) {
            // do not prevent defaults if this is a tap gesture
            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;
            if (isTapPointer && isTapMovement && isTapTouchTime) return;
        }
        if (hasPanX && hasPanY) // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
        return;
        if (hasNone || hasPanY && direction & $bebd28704f2536ea$var$DIRECTION_HORIZONTAL || hasPanX && direction & $bebd28704f2536ea$var$DIRECTION_VERTICAL) return this.preventSrc(srcEvent);
    };
    /**
   * @private
   * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
   * @param {Object} srcEvent
   */ _proto.preventSrc = function preventSrc(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    };
    return TouchAction;
}();
/**
 * @private
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */ function $bebd28704f2536ea$var$hasParent(node, parent) {
    while(node){
        if (node === parent) return true;
        node = node.parentNode;
    }
    return false;
}
/**
 * @private
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */ function $bebd28704f2536ea$var$getCenter(pointers) {
    var pointersLength = pointers.length; // no need to loop when only one touch
    if (pointersLength === 1) return {
        x: $bebd28704f2536ea$var$round(pointers[0].clientX),
        y: $bebd28704f2536ea$var$round(pointers[0].clientY)
    };
    var x = 0;
    var y = 0;
    var i = 0;
    while(i < pointersLength){
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }
    return {
        x: $bebd28704f2536ea$var$round(x / pointersLength),
        y: $bebd28704f2536ea$var$round(y / pointersLength)
    };
}
/**
 * @private
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */ function $bebd28704f2536ea$var$simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while(i < input.pointers.length){
        pointers[i] = {
            clientX: $bebd28704f2536ea$var$round(input.pointers[i].clientX),
            clientY: $bebd28704f2536ea$var$round(input.pointers[i].clientY)
        };
        i++;
    }
    return {
        timeStamp: $bebd28704f2536ea$var$now(),
        pointers: pointers,
        center: $bebd28704f2536ea$var$getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}
/**
 * @private
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */ function $bebd28704f2536ea$var$getDistance(p1, p2, props) {
    if (!props) props = $bebd28704f2536ea$var$PROPS_XY;
    var x = p2[props[0]] - p1[props[0]];
    var y = p2[props[1]] - p1[props[1]];
    return Math.sqrt(x * x + y * y);
}
/**
 * @private
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */ function $bebd28704f2536ea$var$getAngle(p1, p2, props) {
    if (!props) props = $bebd28704f2536ea$var$PROPS_XY;
    var x = p2[props[0]] - p1[props[0]];
    var y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}
/**
 * @private
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */ function $bebd28704f2536ea$var$getDirection(x, y) {
    if (x === y) return $bebd28704f2536ea$var$DIRECTION_NONE;
    if ($bebd28704f2536ea$var$abs$1(x) >= $bebd28704f2536ea$var$abs$1(y)) return x < 0 ? $bebd28704f2536ea$var$DIRECTION_LEFT : $bebd28704f2536ea$var$DIRECTION_RIGHT;
    return y < 0 ? $bebd28704f2536ea$var$DIRECTION_UP : $bebd28704f2536ea$var$DIRECTION_DOWN;
}
function $bebd28704f2536ea$var$computeDeltaXY(session, input) {
    var center = input.center; // let { offsetDelta:offset = {}, prevDelta = {}, prevInput = {} } = session;
    // jscs throwing error on defalut destructured values and without defaults tests fail
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};
    if (input.eventType === $bebd28704f2536ea$var$INPUT_START || prevInput.eventType === $bebd28704f2536ea$var$INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };
        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }
    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}
/**
 * @private
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */ function $bebd28704f2536ea$var$getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}
/**
 * @private
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */ function $bebd28704f2536ea$var$getScale(start, end) {
    return $bebd28704f2536ea$var$getDistance(end[0], end[1], $bebd28704f2536ea$var$PROPS_CLIENT_XY) / $bebd28704f2536ea$var$getDistance(start[0], start[1], $bebd28704f2536ea$var$PROPS_CLIENT_XY);
}
/**
 * @private
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */ function $bebd28704f2536ea$var$getRotation(start, end) {
    return $bebd28704f2536ea$var$getAngle(end[1], end[0], $bebd28704f2536ea$var$PROPS_CLIENT_XY) + $bebd28704f2536ea$var$getAngle(start[1], start[0], $bebd28704f2536ea$var$PROPS_CLIENT_XY);
}
/**
 * @private
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */ function $bebd28704f2536ea$var$computeIntervalInputData(session, input) {
    var last = session.lastInterval || input;
    var deltaTime = input.timeStamp - last.timeStamp;
    var velocity;
    var velocityX;
    var velocityY;
    var direction;
    if (input.eventType !== $bebd28704f2536ea$var$INPUT_CANCEL && (deltaTime > $bebd28704f2536ea$var$COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;
        var v = $bebd28704f2536ea$var$getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = $bebd28704f2536ea$var$abs$1(v.x) > $bebd28704f2536ea$var$abs$1(v.y) ? v.x : v.y;
        direction = $bebd28704f2536ea$var$getDirection(deltaX, deltaY);
        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }
    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}
/**
* @private
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */ function $bebd28704f2536ea$var$computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length; // store the first input to calculate the distance and direction
    if (!session.firstInput) session.firstInput = $bebd28704f2536ea$var$simpleCloneInputData(input);
     // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) session.firstMultiple = $bebd28704f2536ea$var$simpleCloneInputData(input);
    else if (pointersLength === 1) session.firstMultiple = false;
    var firstInput = session.firstInput, firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
    var center = input.center = $bebd28704f2536ea$var$getCenter(pointers);
    input.timeStamp = $bebd28704f2536ea$var$now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;
    input.angle = $bebd28704f2536ea$var$getAngle(offsetCenter, center);
    input.distance = $bebd28704f2536ea$var$getDistance(offsetCenter, center);
    $bebd28704f2536ea$var$computeDeltaXY(session, input);
    input.offsetDirection = $bebd28704f2536ea$var$getDirection(input.deltaX, input.deltaY);
    var overallVelocity = $bebd28704f2536ea$var$getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = $bebd28704f2536ea$var$abs$1(overallVelocity.x) > $bebd28704f2536ea$var$abs$1(overallVelocity.y) ? overallVelocity.x : overallVelocity.y;
    input.scale = firstMultiple ? $bebd28704f2536ea$var$getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? $bebd28704f2536ea$var$getRotation(firstMultiple.pointers, pointers) : 0;
    input.maxPointers = !session.prevInput ? input.pointers.length : input.pointers.length > session.prevInput.maxPointers ? input.pointers.length : session.prevInput.maxPointers;
    $bebd28704f2536ea$var$computeIntervalInputData(session, input); // find the correct target
    var target = manager.element;
    var srcEvent = input.srcEvent;
    var srcEventTarget;
    if (srcEvent.composedPath) srcEventTarget = srcEvent.composedPath()[0];
    else if (srcEvent.path) srcEventTarget = srcEvent.path[0];
    else srcEventTarget = srcEvent.target;
    if ($bebd28704f2536ea$var$hasParent(srcEventTarget, target)) target = srcEventTarget;
    input.target = target;
}
/**
 * @private
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */ function $bebd28704f2536ea$var$inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = eventType & $bebd28704f2536ea$var$INPUT_START && pointersLen - changedPointersLen === 0;
    var isFinal = eventType & ($bebd28704f2536ea$var$INPUT_END | $bebd28704f2536ea$var$INPUT_CANCEL) && pointersLen - changedPointersLen === 0;
    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;
    if (isFirst) manager.session = {};
     // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType; // compute scale, rotation etc
    $bebd28704f2536ea$var$computeInputData(manager, input); // emit secret event
    manager.emit('hammer.input', input);
    manager.recognize(input);
    manager.session.prevInput = input;
}
/**
 * @private
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */ function $bebd28704f2536ea$var$splitStr(str) {
    return str.trim().split(/\s+/g);
}
/**
 * @private
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */ function $bebd28704f2536ea$var$addEventListeners(target, types, handler) {
    $bebd28704f2536ea$var$each($bebd28704f2536ea$var$splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}
/**
 * @private
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */ function $bebd28704f2536ea$var$removeEventListeners(target, types, handler) {
    $bebd28704f2536ea$var$each($bebd28704f2536ea$var$splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}
/**
 * @private
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */ function $bebd28704f2536ea$var$getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return doc.defaultView || doc.parentWindow || window;
}
/**
 * @private
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */ var $bebd28704f2536ea$var$Input = /*#__PURE__*/ function() {
    function Input(manager, callback) {
        var self1 = this;
        this.manager = manager;
        this.callback = callback;
        this.element = manager.element;
        this.target = manager.options.inputTarget; // smaller wrapper around the handler, for the scope and the enabled state of the manager,
        // so when disabled the input events are completely bypassed.
        this.domHandler = function(ev) {
            if ($bebd28704f2536ea$var$boolOrFn(manager.options.enable, [
                manager
            ])) self1.handler(ev);
        };
        this.init();
    }
    /**
   * @private
   * should handle the inputEvent data and trigger the callback
   * @virtual
   */ var _proto = Input.prototype;
    _proto.handler = function handler() {};
    /**
   * @private
   * bind the events
   */ _proto.init = function init() {
        this.evEl && $bebd28704f2536ea$var$addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && $bebd28704f2536ea$var$addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && $bebd28704f2536ea$var$addEventListeners($bebd28704f2536ea$var$getWindowForElement(this.element), this.evWin, this.domHandler);
    };
    /**
   * @private
   * unbind the events
   */ _proto.destroy = function destroy() {
        this.evEl && $bebd28704f2536ea$var$removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && $bebd28704f2536ea$var$removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && $bebd28704f2536ea$var$removeEventListeners($bebd28704f2536ea$var$getWindowForElement(this.element), this.evWin, this.domHandler);
    };
    return Input;
}();
/**
 * @private
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */ function $bebd28704f2536ea$var$inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) return src.indexOf(find);
    else {
        var i = 0;
        while(i < src.length){
            if (findByKey && src[i][findByKey] == find || !findByKey && src[i] === find) // do not use === here, test fails
            return i;
            i++;
        }
        return -1;
    }
}
var $bebd28704f2536ea$var$POINTER_INPUT_MAP = {
    pointerdown: $bebd28704f2536ea$var$INPUT_START,
    pointermove: $bebd28704f2536ea$var$INPUT_MOVE,
    pointerup: $bebd28704f2536ea$var$INPUT_END,
    pointercancel: $bebd28704f2536ea$var$INPUT_CANCEL,
    pointerout: $bebd28704f2536ea$var$INPUT_CANCEL
}; // in IE10 the pointer types is defined as an enum
var $bebd28704f2536ea$var$IE10_POINTER_TYPE_ENUM = {
    2: $bebd28704f2536ea$var$INPUT_TYPE_TOUCH,
    3: $bebd28704f2536ea$var$INPUT_TYPE_PEN,
    4: $bebd28704f2536ea$var$INPUT_TYPE_MOUSE,
    5: $bebd28704f2536ea$var$INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};
var $bebd28704f2536ea$var$POINTER_ELEMENT_EVENTS = 'pointerdown';
var $bebd28704f2536ea$var$POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel'; // IE10 has prefixed support, and case-sensitive
if ($bebd28704f2536ea$var$win.MSPointerEvent && !$bebd28704f2536ea$var$win.PointerEvent) {
    $bebd28704f2536ea$var$POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    $bebd28704f2536ea$var$POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}
/**
 * @private
 * Pointer events input
 * @constructor
 * @extends Input
 */ var $bebd28704f2536ea$var$PointerEventInput = /*#__PURE__*/ function(_Input) {
    $bebd28704f2536ea$var$_inheritsLoose(PointerEventInput, _Input);
    function PointerEventInput() {
        var _this;
        var proto = PointerEventInput.prototype;
        proto.evEl = $bebd28704f2536ea$var$POINTER_ELEMENT_EVENTS;
        proto.evWin = $bebd28704f2536ea$var$POINTER_WINDOW_EVENTS;
        _this = _Input.apply(this, arguments) || this;
        _this.store = _this.manager.session.pointerEvents = [];
        return _this;
    }
    /**
   * @private
   * handle mouse events
   * @param {Object} ev
   */ var _proto = PointerEventInput.prototype;
    _proto.handler = function handler(ev) {
        var store = this.store;
        var removePointer = false;
        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = $bebd28704f2536ea$var$POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = $bebd28704f2536ea$var$IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
        var isTouch = pointerType === $bebd28704f2536ea$var$INPUT_TYPE_TOUCH; // get index of the event in the store
        var storeIndex = $bebd28704f2536ea$var$inArray(store, ev.pointerId, 'pointerId'); // start and mouse must be down
        if (eventType & $bebd28704f2536ea$var$INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & ($bebd28704f2536ea$var$INPUT_END | $bebd28704f2536ea$var$INPUT_CANCEL)) removePointer = true;
         // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) return;
         // update the event in the store
        store[storeIndex] = ev;
        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [
                ev
            ],
            pointerType: pointerType,
            srcEvent: ev
        });
        if (removePointer) // remove from the store
        store.splice(storeIndex, 1);
    };
    return PointerEventInput;
}($bebd28704f2536ea$var$Input);
/**
 * @private
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */ function $bebd28704f2536ea$var$toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}
/**
 * @private
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */ function $bebd28704f2536ea$var$uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;
    while(i < src.length){
        var val = key ? src[i][key] : src[i];
        if ($bebd28704f2536ea$var$inArray(values, val) < 0) results.push(src[i]);
        values[i] = val;
        i++;
    }
    if (sort) {
        if (!key) results = results.sort();
        else results = results.sort(function(a, b) {
            return a[key] > b[key];
        });
    }
    return results;
}
var $bebd28704f2536ea$var$TOUCH_INPUT_MAP = {
    touchstart: $bebd28704f2536ea$var$INPUT_START,
    touchmove: $bebd28704f2536ea$var$INPUT_MOVE,
    touchend: $bebd28704f2536ea$var$INPUT_END,
    touchcancel: $bebd28704f2536ea$var$INPUT_CANCEL
};
var $bebd28704f2536ea$var$TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';
/**
 * @private
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */ var $bebd28704f2536ea$var$TouchInput = /*#__PURE__*/ function(_Input) {
    $bebd28704f2536ea$var$_inheritsLoose(TouchInput, _Input);
    function TouchInput() {
        var _this;
        TouchInput.prototype.evTarget = $bebd28704f2536ea$var$TOUCH_TARGET_EVENTS;
        _this = _Input.apply(this, arguments) || this;
        _this.targetIds = {}; // this.evTarget = TOUCH_TARGET_EVENTS;
        return _this;
    }
    var _proto = TouchInput.prototype;
    _proto.handler = function handler(ev) {
        var type = $bebd28704f2536ea$var$TOUCH_INPUT_MAP[ev.type];
        var touches = $bebd28704f2536ea$var$getTouches.call(this, ev, type);
        if (!touches) return;
        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: $bebd28704f2536ea$var$INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    };
    return TouchInput;
}($bebd28704f2536ea$var$Input);
function $bebd28704f2536ea$var$getTouches(ev, type) {
    var allTouches = $bebd28704f2536ea$var$toArray(ev.touches);
    var targetIds = this.targetIds; // when there is only one touch, the process can be simplified
    if (type & ($bebd28704f2536ea$var$INPUT_START | $bebd28704f2536ea$var$INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [
            allTouches,
            allTouches
        ];
    }
    var i;
    var targetTouches;
    var changedTouches = $bebd28704f2536ea$var$toArray(ev.changedTouches);
    var changedTargetTouches = [];
    var target = this.target; // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return $bebd28704f2536ea$var$hasParent(touch.target, target);
    }); // collect touches
    if (type === $bebd28704f2536ea$var$INPUT_START) {
        i = 0;
        while(i < targetTouches.length){
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    } // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while(i < changedTouches.length){
        if (targetIds[changedTouches[i].identifier]) changedTargetTouches.push(changedTouches[i]);
         // cleanup removed touches
        if (type & ($bebd28704f2536ea$var$INPUT_END | $bebd28704f2536ea$var$INPUT_CANCEL)) delete targetIds[changedTouches[i].identifier];
        i++;
    }
    if (!changedTargetTouches.length) return;
    return [
        $bebd28704f2536ea$var$uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}
var $bebd28704f2536ea$var$MOUSE_INPUT_MAP = {
    mousedown: $bebd28704f2536ea$var$INPUT_START,
    mousemove: $bebd28704f2536ea$var$INPUT_MOVE,
    mouseup: $bebd28704f2536ea$var$INPUT_END
};
var $bebd28704f2536ea$var$MOUSE_ELEMENT_EVENTS = 'mousedown';
var $bebd28704f2536ea$var$MOUSE_WINDOW_EVENTS = 'mousemove mouseup';
/**
 * @private
 * Mouse events input
 * @constructor
 * @extends Input
 */ var $bebd28704f2536ea$var$MouseInput = /*#__PURE__*/ function(_Input) {
    $bebd28704f2536ea$var$_inheritsLoose(MouseInput, _Input);
    function MouseInput() {
        var _this;
        var proto = MouseInput.prototype;
        proto.evEl = $bebd28704f2536ea$var$MOUSE_ELEMENT_EVENTS;
        proto.evWin = $bebd28704f2536ea$var$MOUSE_WINDOW_EVENTS;
        _this = _Input.apply(this, arguments) || this;
        _this.pressed = false; // mousedown state
        return _this;
    }
    /**
   * @private
   * handle mouse events
   * @param {Object} ev
   */ var _proto = MouseInput.prototype;
    _proto.handler = function handler(ev) {
        var eventType = $bebd28704f2536ea$var$MOUSE_INPUT_MAP[ev.type]; // on start we want to have the left mouse button down
        if (eventType & $bebd28704f2536ea$var$INPUT_START && ev.button === 0) this.pressed = true;
        if (eventType & $bebd28704f2536ea$var$INPUT_MOVE && ev.which !== 1) eventType = $bebd28704f2536ea$var$INPUT_END;
         // mouse must be down
        if (!this.pressed) return;
        if (eventType & $bebd28704f2536ea$var$INPUT_END) this.pressed = false;
        this.callback(this.manager, eventType, {
            pointers: [
                ev
            ],
            changedPointers: [
                ev
            ],
            pointerType: $bebd28704f2536ea$var$INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    };
    return MouseInput;
}($bebd28704f2536ea$var$Input);
/**
 * @private
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */ var $bebd28704f2536ea$var$DEDUP_TIMEOUT = 2500;
var $bebd28704f2536ea$var$DEDUP_DISTANCE = 25;
function $bebd28704f2536ea$var$setLastTouch(eventData) {
    var _eventData$changedPoi = eventData.changedPointers, touch = _eventData$changedPoi[0];
    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {
            x: touch.clientX,
            y: touch.clientY
        };
        var lts = this.lastTouches;
        this.lastTouches.push(lastTouch);
        var removeLastTouch = function removeLastTouch() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) lts.splice(i, 1);
        };
        setTimeout(removeLastTouch, $bebd28704f2536ea$var$DEDUP_TIMEOUT);
    }
}
function $bebd28704f2536ea$var$recordTouches(eventType, eventData) {
    if (eventType & $bebd28704f2536ea$var$INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        $bebd28704f2536ea$var$setLastTouch.call(this, eventData);
    } else if (eventType & ($bebd28704f2536ea$var$INPUT_END | $bebd28704f2536ea$var$INPUT_CANCEL)) $bebd28704f2536ea$var$setLastTouch.call(this, eventData);
}
function $bebd28704f2536ea$var$isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX;
    var y = eventData.srcEvent.clientY;
    for(var i = 0; i < this.lastTouches.length; i++){
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x);
        var dy = Math.abs(y - t.y);
        if (dx <= $bebd28704f2536ea$var$DEDUP_DISTANCE && dy <= $bebd28704f2536ea$var$DEDUP_DISTANCE) return true;
    }
    return false;
}
var $bebd28704f2536ea$var$TouchMouseInput = /*#__PURE__*/ function() {
    var TouchMouseInput = /*#__PURE__*/ function(_Input) {
        $bebd28704f2536ea$var$_inheritsLoose(TouchMouseInput, _Input);
        function TouchMouseInput(_manager, callback) {
            var _this;
            _this = _Input.call(this, _manager, callback) || this;
            _this.handler = function(manager, inputEvent, inputData) {
                var isTouch = inputData.pointerType === $bebd28704f2536ea$var$INPUT_TYPE_TOUCH;
                var isMouse = inputData.pointerType === $bebd28704f2536ea$var$INPUT_TYPE_MOUSE;
                if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) return;
                 // when we're in a touch event, record touches to  de-dupe synthetic mouse event
                if (isTouch) $bebd28704f2536ea$var$recordTouches.call($bebd28704f2536ea$var$_assertThisInitialized$1($bebd28704f2536ea$var$_assertThisInitialized$1(_this)), inputEvent, inputData);
                else if (isMouse && $bebd28704f2536ea$var$isSyntheticEvent.call($bebd28704f2536ea$var$_assertThisInitialized$1($bebd28704f2536ea$var$_assertThisInitialized$1(_this)), inputData)) return;
                _this.callback(manager, inputEvent, inputData);
            };
            _this.touch = new $bebd28704f2536ea$var$TouchInput(_this.manager, _this.handler);
            _this.mouse = new $bebd28704f2536ea$var$MouseInput(_this.manager, _this.handler);
            _this.primaryTouch = null;
            _this.lastTouches = [];
            return _this;
        }
        /**
     * @private
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */ var _proto = TouchMouseInput.prototype;
        /**
     * @private
     * remove the event listeners
     */ _proto.destroy = function destroy() {
            this.touch.destroy();
            this.mouse.destroy();
        };
        return TouchMouseInput;
    }($bebd28704f2536ea$var$Input);
    return TouchMouseInput;
}();
/**
 * @private
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */ function $bebd28704f2536ea$var$createInputInstance(manager) {
    var Type; // let inputClass = manager.options.inputClass;
    var inputClass = manager.options.inputClass;
    if (inputClass) Type = inputClass;
    else if ($bebd28704f2536ea$var$SUPPORT_POINTER_EVENTS) Type = $bebd28704f2536ea$var$PointerEventInput;
    else if ($bebd28704f2536ea$var$SUPPORT_ONLY_TOUCH) Type = $bebd28704f2536ea$var$TouchInput;
    else if (!$bebd28704f2536ea$var$SUPPORT_TOUCH) Type = $bebd28704f2536ea$var$MouseInput;
    else Type = $bebd28704f2536ea$var$TouchMouseInput;
    return new Type(manager, $bebd28704f2536ea$var$inputHandler);
}
/**
 * @private
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */ function $bebd28704f2536ea$var$invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        $bebd28704f2536ea$var$each(arg, context[fn], context);
        return true;
    }
    return false;
}
var $bebd28704f2536ea$var$STATE_POSSIBLE = 1;
var $bebd28704f2536ea$var$STATE_BEGAN = 2;
var $bebd28704f2536ea$var$STATE_CHANGED = 4;
var $bebd28704f2536ea$var$STATE_ENDED = 8;
var $bebd28704f2536ea$var$STATE_RECOGNIZED = $bebd28704f2536ea$var$STATE_ENDED;
var $bebd28704f2536ea$var$STATE_CANCELLED = 16;
var $bebd28704f2536ea$var$STATE_FAILED = 32;
/**
 * @private
 * get a unique id
 * @returns {number} uniqueId
 */ var $bebd28704f2536ea$var$_uniqueId = 1;
function $bebd28704f2536ea$var$uniqueId() {
    return $bebd28704f2536ea$var$_uniqueId++;
}
/**
 * @private
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */ function $bebd28704f2536ea$var$getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) return manager.get(otherRecognizer);
    return otherRecognizer;
}
/**
 * @private
 * get a usable string, used as event postfix
 * @param {constant} state
 * @returns {String} state
 */ function $bebd28704f2536ea$var$stateStr(state) {
    if (state & $bebd28704f2536ea$var$STATE_CANCELLED) return 'cancel';
    else if (state & $bebd28704f2536ea$var$STATE_ENDED) return 'end';
    else if (state & $bebd28704f2536ea$var$STATE_CHANGED) return 'move';
    else if (state & $bebd28704f2536ea$var$STATE_BEGAN) return 'start';
    return '';
}
/**
 * @private
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */ /**
 * @private
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */ var $bebd28704f2536ea$var$Recognizer = /*#__PURE__*/ function() {
    function Recognizer(options) {
        if (options === void 0) options = {};
        this.options = $bebd28704f2536ea$var$_extends({
            enable: true
        }, options);
        this.id = $bebd28704f2536ea$var$uniqueId();
        this.manager = null; // default is enable true
        this.state = $bebd28704f2536ea$var$STATE_POSSIBLE;
        this.simultaneous = {};
        this.requireFail = [];
    }
    /**
   * @private
   * set options
   * @param {Object} options
   * @return {Recognizer}
   */ var _proto = Recognizer.prototype;
    _proto.set = function set(options) {
        $bebd28704f2536ea$var$assign$1(this.options, options); // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    };
    /**
   * @private
   * recognize simultaneous with an other recognizer.
   * @param {Recognizer} otherRecognizer
   * @returns {Recognizer} this
   */ _proto.recognizeWith = function recognizeWith(otherRecognizer) {
        if ($bebd28704f2536ea$var$invokeArrayArg(otherRecognizer, 'recognizeWith', this)) return this;
        var simultaneous = this.simultaneous;
        otherRecognizer = $bebd28704f2536ea$var$getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    };
    /**
   * @private
   * drop the simultaneous link. it doesnt remove the link on the other recognizer.
   * @param {Recognizer} otherRecognizer
   * @returns {Recognizer} this
   */ _proto.dropRecognizeWith = function dropRecognizeWith(otherRecognizer) {
        if ($bebd28704f2536ea$var$invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) return this;
        otherRecognizer = $bebd28704f2536ea$var$getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    };
    /**
   * @private
   * recognizer can only run when an other is failing
   * @param {Recognizer} otherRecognizer
   * @returns {Recognizer} this
   */ _proto.requireFailure = function requireFailure(otherRecognizer) {
        if ($bebd28704f2536ea$var$invokeArrayArg(otherRecognizer, 'requireFailure', this)) return this;
        var requireFail = this.requireFail;
        otherRecognizer = $bebd28704f2536ea$var$getRecognizerByNameIfManager(otherRecognizer, this);
        if ($bebd28704f2536ea$var$inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    };
    /**
   * @private
   * drop the requireFailure link. it does not remove the link on the other recognizer.
   * @param {Recognizer} otherRecognizer
   * @returns {Recognizer} this
   */ _proto.dropRequireFailure = function dropRequireFailure(otherRecognizer) {
        if ($bebd28704f2536ea$var$invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) return this;
        otherRecognizer = $bebd28704f2536ea$var$getRecognizerByNameIfManager(otherRecognizer, this);
        var index = $bebd28704f2536ea$var$inArray(this.requireFail, otherRecognizer);
        if (index > -1) this.requireFail.splice(index, 1);
        return this;
    };
    /**
   * @private
   * has require failures boolean
   * @returns {boolean}
   */ _proto.hasRequireFailures = function hasRequireFailures() {
        return this.requireFail.length > 0;
    };
    /**
   * @private
   * if the recognizer can recognize simultaneous with an other recognizer
   * @param {Recognizer} otherRecognizer
   * @returns {Boolean}
   */ _proto.canRecognizeWith = function canRecognizeWith(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    };
    /**
   * @private
   * You should use `tryEmit` instead of `emit` directly to check
   * that all the needed recognizers has failed before emitting.
   * @param {Object} input
   */ _proto.emit = function emit(input) {
        var self1 = this;
        var state = this.state;
        function emit(event) {
            self1.manager.emit(event, input);
        } // 'panstart' and 'panmove'
        if (state < $bebd28704f2536ea$var$STATE_ENDED) emit(self1.options.event + $bebd28704f2536ea$var$stateStr(state));
        emit(self1.options.event); // simple 'eventName' events
        if (input.additionalEvent) // additional event(panleft, panright, pinchin, pinchout...)
        emit(input.additionalEvent);
         // panend and pancancel
        if (state >= $bebd28704f2536ea$var$STATE_ENDED) emit(self1.options.event + $bebd28704f2536ea$var$stateStr(state));
    };
    /**
   * @private
   * Check that all the require failure recognizers has failed,
   * if true, it emits a gesture event,
   * otherwise, setup the state to FAILED.
   * @param {Object} input
   */ _proto.tryEmit = function tryEmit(input) {
        if (this.canEmit()) return this.emit(input);
         // it's failing anyway
        this.state = $bebd28704f2536ea$var$STATE_FAILED;
    };
    /**
   * @private
   * can we emit?
   * @returns {boolean}
   */ _proto.canEmit = function canEmit() {
        var i = 0;
        while(i < this.requireFail.length){
            if (!(this.requireFail[i].state & ($bebd28704f2536ea$var$STATE_FAILED | $bebd28704f2536ea$var$STATE_POSSIBLE))) return false;
            i++;
        }
        return true;
    };
    /**
   * @private
   * update the recognizer
   * @param {Object} inputData
   */ _proto.recognize = function recognize(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = $bebd28704f2536ea$var$assign$1({}, inputData); // is is enabled and allow recognizing?
        if (!$bebd28704f2536ea$var$boolOrFn(this.options.enable, [
            this,
            inputDataClone
        ])) {
            this.reset();
            this.state = $bebd28704f2536ea$var$STATE_FAILED;
            return;
        } // reset when we've reached the end
        if (this.state & ($bebd28704f2536ea$var$STATE_RECOGNIZED | $bebd28704f2536ea$var$STATE_CANCELLED | $bebd28704f2536ea$var$STATE_FAILED)) this.state = $bebd28704f2536ea$var$STATE_POSSIBLE;
        this.state = this.process(inputDataClone); // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & ($bebd28704f2536ea$var$STATE_BEGAN | $bebd28704f2536ea$var$STATE_CHANGED | $bebd28704f2536ea$var$STATE_ENDED | $bebd28704f2536ea$var$STATE_CANCELLED)) this.tryEmit(inputDataClone);
    };
    /**
   * @private
   * return the state of the recognizer
   * the actual recognizing happens in this method
   * @virtual
   * @param {Object} inputData
   * @returns {constant} STATE
   */ /* jshint ignore:start */ _proto.process = function process(inputData) {};
    /* jshint ignore:end */ /**
   * @private
   * return the preferred touch-action
   * @virtual
   * @returns {Array}
   */ _proto.getTouchAction = function getTouchAction() {};
    /**
   * @private
   * called when the gesture isn't allowed to recognize
   * like when another is being recognized or it is disabled
   * @virtual
   */ _proto.reset = function reset() {};
    return Recognizer;
}();
/**
 * @private
 * A tap is recognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */ var $bebd28704f2536ea$var$TapRecognizer = /*#__PURE__*/ function(_Recognizer) {
    $bebd28704f2536ea$var$_inheritsLoose(TapRecognizer, _Recognizer);
    function TapRecognizer(options) {
        var _this;
        if (options === void 0) options = {};
        _this = _Recognizer.call(this, $bebd28704f2536ea$var$_extends({
            event: 'tap',
            pointers: 1,
            taps: 1,
            interval: 300,
            // max time between the multi-tap taps
            time: 250,
            // max time of the pointer to be down (like finger on the screen)
            threshold: 9,
            // a minimal movement is ok, but keep it low
            posThreshold: 10
        }, options)) || this; // previous time and center,
        // used for tap counting
        _this.pTime = false;
        _this.pCenter = false;
        _this._timer = null;
        _this._input = null;
        _this.count = 0;
        return _this;
    }
    var _proto = TapRecognizer.prototype;
    _proto.getTouchAction = function getTouchAction() {
        return [
            $bebd28704f2536ea$var$TOUCH_ACTION_MANIPULATION
        ];
    };
    _proto.process = function process(input) {
        var _this2 = this;
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;
        this.reset();
        if (input.eventType & $bebd28704f2536ea$var$INPUT_START && this.count === 0) return this.failTimeout();
         // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType !== $bebd28704f2536ea$var$INPUT_END) return this.failTimeout();
            var validInterval = this.pTime ? input.timeStamp - this.pTime < options.interval : true;
            var validMultiTap = !this.pCenter || $bebd28704f2536ea$var$getDistance(this.pCenter, input.center) < options.posThreshold;
            this.pTime = input.timeStamp;
            this.pCenter = input.center;
            if (!validMultiTap || !validInterval) this.count = 1;
            else this.count += 1;
            this._input = input; // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) return $bebd28704f2536ea$var$STATE_RECOGNIZED;
                else {
                    this._timer = setTimeout(function() {
                        _this2.state = $bebd28704f2536ea$var$STATE_RECOGNIZED;
                        _this2.tryEmit();
                    }, options.interval);
                    return $bebd28704f2536ea$var$STATE_BEGAN;
                }
            }
        }
        return $bebd28704f2536ea$var$STATE_FAILED;
    };
    _proto.failTimeout = function failTimeout() {
        var _this3 = this;
        this._timer = setTimeout(function() {
            _this3.state = $bebd28704f2536ea$var$STATE_FAILED;
        }, this.options.interval);
        return $bebd28704f2536ea$var$STATE_FAILED;
    };
    _proto.reset = function reset() {
        clearTimeout(this._timer);
    };
    _proto.emit = function emit() {
        if (this.state === $bebd28704f2536ea$var$STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    };
    return TapRecognizer;
}($bebd28704f2536ea$var$Recognizer);
/**
 * @private
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */ var $bebd28704f2536ea$var$AttrRecognizer = /*#__PURE__*/ function(_Recognizer) {
    $bebd28704f2536ea$var$_inheritsLoose(AttrRecognizer, _Recognizer);
    function AttrRecognizer(options) {
        if (options === void 0) options = {};
        return _Recognizer.call(this, $bebd28704f2536ea$var$_extends({
            pointers: 1
        }, options)) || this;
    }
    /**
   * @private
   * Used to check if it the recognizer receives valid input, like input.distance > 10.
   * @memberof AttrRecognizer
   * @param {Object} input
   * @returns {Boolean} recognized
   */ var _proto = AttrRecognizer.prototype;
    _proto.attrTest = function attrTest(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    };
    /**
   * @private
   * Process the input and return the state for the recognizer
   * @memberof AttrRecognizer
   * @param {Object} input
   * @returns {*} State
   */ _proto.process = function process(input) {
        var state = this.state;
        var eventType = input.eventType;
        var isRecognized = state & ($bebd28704f2536ea$var$STATE_BEGAN | $bebd28704f2536ea$var$STATE_CHANGED);
        var isValid = this.attrTest(input); // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & $bebd28704f2536ea$var$INPUT_CANCEL || !isValid)) return state | $bebd28704f2536ea$var$STATE_CANCELLED;
        else if (isRecognized || isValid) {
            if (eventType & $bebd28704f2536ea$var$INPUT_END) return state | $bebd28704f2536ea$var$STATE_ENDED;
            else if (!(state & $bebd28704f2536ea$var$STATE_BEGAN)) return $bebd28704f2536ea$var$STATE_BEGAN;
            return state | $bebd28704f2536ea$var$STATE_CHANGED;
        }
        return $bebd28704f2536ea$var$STATE_FAILED;
    };
    return AttrRecognizer;
}($bebd28704f2536ea$var$Recognizer);
/**
 * @private
 * direction cons to string
 * @param {constant} direction
 * @returns {String}
 */ function $bebd28704f2536ea$var$directionStr(direction) {
    if (direction === $bebd28704f2536ea$var$DIRECTION_DOWN) return 'down';
    else if (direction === $bebd28704f2536ea$var$DIRECTION_UP) return 'up';
    else if (direction === $bebd28704f2536ea$var$DIRECTION_LEFT) return 'left';
    else if (direction === $bebd28704f2536ea$var$DIRECTION_RIGHT) return 'right';
    return '';
}
/**
 * @private
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */ var $bebd28704f2536ea$var$PanRecognizer = /*#__PURE__*/ function(_AttrRecognizer) {
    $bebd28704f2536ea$var$_inheritsLoose(PanRecognizer, _AttrRecognizer);
    function PanRecognizer(options) {
        var _this;
        if (options === void 0) options = {};
        _this = _AttrRecognizer.call(this, $bebd28704f2536ea$var$_extends({
            event: 'pan',
            threshold: 10,
            pointers: 1,
            direction: $bebd28704f2536ea$var$DIRECTION_ALL
        }, options)) || this;
        _this.pX = null;
        _this.pY = null;
        return _this;
    }
    var _proto = PanRecognizer.prototype;
    _proto.getTouchAction = function getTouchAction() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & $bebd28704f2536ea$var$DIRECTION_HORIZONTAL) actions.push($bebd28704f2536ea$var$TOUCH_ACTION_PAN_Y);
        if (direction & $bebd28704f2536ea$var$DIRECTION_VERTICAL) actions.push($bebd28704f2536ea$var$TOUCH_ACTION_PAN_X);
        return actions;
    };
    _proto.directionTest = function directionTest(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY; // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & $bebd28704f2536ea$var$DIRECTION_HORIZONTAL) {
                direction = x === 0 ? $bebd28704f2536ea$var$DIRECTION_NONE : x < 0 ? $bebd28704f2536ea$var$DIRECTION_LEFT : $bebd28704f2536ea$var$DIRECTION_RIGHT;
                hasMoved = x !== this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = y === 0 ? $bebd28704f2536ea$var$DIRECTION_NONE : y < 0 ? $bebd28704f2536ea$var$DIRECTION_UP : $bebd28704f2536ea$var$DIRECTION_DOWN;
                hasMoved = y !== this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    };
    _proto.attrTest = function attrTest(input) {
        return $bebd28704f2536ea$var$AttrRecognizer.prototype.attrTest.call(this, input) && (this.state & $bebd28704f2536ea$var$STATE_BEGAN || !(this.state & $bebd28704f2536ea$var$STATE_BEGAN) && this.directionTest(input));
    };
    _proto.emit = function emit(input) {
        this.pX = input.deltaX;
        this.pY = input.deltaY;
        var direction = $bebd28704f2536ea$var$directionStr(input.direction);
        if (direction) input.additionalEvent = this.options.event + direction;
        _AttrRecognizer.prototype.emit.call(this, input);
    };
    return PanRecognizer;
}($bebd28704f2536ea$var$AttrRecognizer);
/**
 * @private
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */ var $bebd28704f2536ea$var$SwipeRecognizer = /*#__PURE__*/ function(_AttrRecognizer) {
    $bebd28704f2536ea$var$_inheritsLoose(SwipeRecognizer, _AttrRecognizer);
    function SwipeRecognizer(options) {
        if (options === void 0) options = {};
        return _AttrRecognizer.call(this, $bebd28704f2536ea$var$_extends({
            event: 'swipe',
            threshold: 10,
            velocity: 0.3,
            direction: $bebd28704f2536ea$var$DIRECTION_HORIZONTAL | $bebd28704f2536ea$var$DIRECTION_VERTICAL,
            pointers: 1
        }, options)) || this;
    }
    var _proto = SwipeRecognizer.prototype;
    _proto.getTouchAction = function getTouchAction() {
        return $bebd28704f2536ea$var$PanRecognizer.prototype.getTouchAction.call(this);
    };
    _proto.attrTest = function attrTest(input) {
        var direction = this.options.direction;
        var velocity;
        if (direction & ($bebd28704f2536ea$var$DIRECTION_HORIZONTAL | $bebd28704f2536ea$var$DIRECTION_VERTICAL)) velocity = input.overallVelocity;
        else if (direction & $bebd28704f2536ea$var$DIRECTION_HORIZONTAL) velocity = input.overallVelocityX;
        else if (direction & $bebd28704f2536ea$var$DIRECTION_VERTICAL) velocity = input.overallVelocityY;
        return _AttrRecognizer.prototype.attrTest.call(this, input) && direction & input.offsetDirection && input.distance > this.options.threshold && input.maxPointers === this.options.pointers && $bebd28704f2536ea$var$abs$1(velocity) > this.options.velocity && input.eventType & $bebd28704f2536ea$var$INPUT_END;
    };
    _proto.emit = function emit(input) {
        var direction = $bebd28704f2536ea$var$directionStr(input.offsetDirection);
        if (direction) this.manager.emit(this.options.event + direction, input);
        this.manager.emit(this.options.event, input);
    };
    return SwipeRecognizer;
}($bebd28704f2536ea$var$AttrRecognizer);
/**
 * @private
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */ var $bebd28704f2536ea$var$PinchRecognizer = /*#__PURE__*/ function(_AttrRecognizer) {
    $bebd28704f2536ea$var$_inheritsLoose(PinchRecognizer, _AttrRecognizer);
    function PinchRecognizer(options) {
        if (options === void 0) options = {};
        return _AttrRecognizer.call(this, $bebd28704f2536ea$var$_extends({
            event: 'pinch',
            threshold: 0,
            pointers: 2
        }, options)) || this;
    }
    var _proto = PinchRecognizer.prototype;
    _proto.getTouchAction = function getTouchAction() {
        return [
            $bebd28704f2536ea$var$TOUCH_ACTION_NONE
        ];
    };
    _proto.attrTest = function attrTest(input) {
        return _AttrRecognizer.prototype.attrTest.call(this, input) && (Math.abs(input.scale - 1) > this.options.threshold || this.state & $bebd28704f2536ea$var$STATE_BEGAN);
    };
    _proto.emit = function emit(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        _AttrRecognizer.prototype.emit.call(this, input);
    };
    return PinchRecognizer;
}($bebd28704f2536ea$var$AttrRecognizer);
/**
 * @private
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */ var $bebd28704f2536ea$var$RotateRecognizer = /*#__PURE__*/ function(_AttrRecognizer) {
    $bebd28704f2536ea$var$_inheritsLoose(RotateRecognizer, _AttrRecognizer);
    function RotateRecognizer(options) {
        if (options === void 0) options = {};
        return _AttrRecognizer.call(this, $bebd28704f2536ea$var$_extends({
            event: 'rotate',
            threshold: 0,
            pointers: 2
        }, options)) || this;
    }
    var _proto = RotateRecognizer.prototype;
    _proto.getTouchAction = function getTouchAction() {
        return [
            $bebd28704f2536ea$var$TOUCH_ACTION_NONE
        ];
    };
    _proto.attrTest = function attrTest(input) {
        return _AttrRecognizer.prototype.attrTest.call(this, input) && (Math.abs(input.rotation) > this.options.threshold || this.state & $bebd28704f2536ea$var$STATE_BEGAN);
    };
    return RotateRecognizer;
}($bebd28704f2536ea$var$AttrRecognizer);
/**
 * @private
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */ var $bebd28704f2536ea$var$PressRecognizer = /*#__PURE__*/ function(_Recognizer) {
    $bebd28704f2536ea$var$_inheritsLoose(PressRecognizer, _Recognizer);
    function PressRecognizer(options) {
        var _this;
        if (options === void 0) options = {};
        _this = _Recognizer.call(this, $bebd28704f2536ea$var$_extends({
            event: 'press',
            pointers: 1,
            time: 251,
            // minimal time of the pointer to be pressed
            threshold: 9
        }, options)) || this;
        _this._timer = null;
        _this._input = null;
        return _this;
    }
    var _proto = PressRecognizer.prototype;
    _proto.getTouchAction = function getTouchAction() {
        return [
            $bebd28704f2536ea$var$TOUCH_ACTION_AUTO
        ];
    };
    _proto.process = function process(input) {
        var _this2 = this;
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;
        this._input = input; // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || input.eventType & ($bebd28704f2536ea$var$INPUT_END | $bebd28704f2536ea$var$INPUT_CANCEL) && !validTime) this.reset();
        else if (input.eventType & $bebd28704f2536ea$var$INPUT_START) {
            this.reset();
            this._timer = setTimeout(function() {
                _this2.state = $bebd28704f2536ea$var$STATE_RECOGNIZED;
                _this2.tryEmit();
            }, options.time);
        } else if (input.eventType & $bebd28704f2536ea$var$INPUT_END) return $bebd28704f2536ea$var$STATE_RECOGNIZED;
        return $bebd28704f2536ea$var$STATE_FAILED;
    };
    _proto.reset = function reset() {
        clearTimeout(this._timer);
    };
    _proto.emit = function emit(input) {
        if (this.state !== $bebd28704f2536ea$var$STATE_RECOGNIZED) return;
        if (input && input.eventType & $bebd28704f2536ea$var$INPUT_END) this.manager.emit(this.options.event + "up", input);
        else {
            this._input.timeStamp = $bebd28704f2536ea$var$now();
            this.manager.emit(this.options.event, this._input);
        }
    };
    return PressRecognizer;
}($bebd28704f2536ea$var$Recognizer);
var $bebd28704f2536ea$var$defaults = {
    /**
   * @private
   * set if DOM events are being triggered.
   * But this is slower and unused by simple implementations, so disabled by default.
   * @type {Boolean}
   * @default false
   */ domEvents: false,
    /**
   * @private
   * The value for the touchAction property/fallback.
   * When set to `compute` it will magically set the correct value based on the added recognizers.
   * @type {String}
   * @default compute
   */ touchAction: $bebd28704f2536ea$var$TOUCH_ACTION_COMPUTE,
    /**
   * @private
   * @type {Boolean}
   * @default true
   */ enable: true,
    /**
   * @private
   * EXPERIMENTAL FEATURE -- can be removed/changed
   * Change the parent input target element.
   * If Null, then it is being set the to main element.
   * @type {Null|EventTarget}
   * @default null
   */ inputTarget: null,
    /**
   * @private
   * force an input class
   * @type {Null|Function}
   * @default null
   */ inputClass: null,
    /**
   * @private
   * Some CSS properties can be used to improve the working of Hammer.
   * Add them to this method and they will be set when creating a new Manager.
   * @namespace
   */ cssProps: {
        /**
     * @private
     * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
     * @type {String}
     * @default 'none'
     */ userSelect: "none",
        /**
     * @private
     * Disable the Windows Phone grippers when pressing an element.
     * @type {String}
     * @default 'none'
     */ touchSelect: "none",
        /**
     * @private
     * Disables the default callout shown when you touch and hold a touch target.
     * On iOS, when you touch and hold a touch target such as a link, Safari displays
     * a callout containing information about the link. This property allows you to disable that callout.
     * @type {String}
     * @default 'none'
     */ touchCallout: "none",
        /**
     * @private
     * Specifies whether zooming is enabled. Used by IE10>
     * @type {String}
     * @default 'none'
     */ contentZooming: "none",
        /**
     * @private
     * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
     * @type {String}
     * @default 'none'
     */ userDrag: "none",
        /**
     * @private
     * Overrides the highlight color shown when the user taps a link or a JavaScript
     * clickable element in iOS. This property obeys the alpha value, if specified.
     * @type {String}
     * @default 'rgba(0,0,0,0)'
     */ tapHighlightColor: "rgba(0,0,0,0)"
    }
};
/**
 * @private
 * Default recognizer setup when calling `Hammer()`
 * When creating a new Manager these will be skipped.
 * This is separated with other defaults because of tree-shaking.
 * @type {Array}
 */ var $bebd28704f2536ea$var$preset = [
    [
        $bebd28704f2536ea$var$RotateRecognizer,
        {
            enable: false
        }
    ],
    [
        $bebd28704f2536ea$var$PinchRecognizer,
        {
            enable: false
        },
        [
            'rotate'
        ]
    ],
    [
        $bebd28704f2536ea$var$SwipeRecognizer,
        {
            direction: $bebd28704f2536ea$var$DIRECTION_HORIZONTAL
        }
    ],
    [
        $bebd28704f2536ea$var$PanRecognizer,
        {
            direction: $bebd28704f2536ea$var$DIRECTION_HORIZONTAL
        },
        [
            'swipe'
        ]
    ],
    [
        $bebd28704f2536ea$var$TapRecognizer
    ],
    [
        $bebd28704f2536ea$var$TapRecognizer,
        {
            event: 'doubletap',
            taps: 2
        },
        [
            'tap'
        ]
    ],
    [
        $bebd28704f2536ea$var$PressRecognizer
    ]
];
var $bebd28704f2536ea$var$STOP = 1;
var $bebd28704f2536ea$var$FORCED_STOP = 2;
/**
 * @private
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */ function $bebd28704f2536ea$var$toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) return;
    var prop;
    $bebd28704f2536ea$var$each(manager.options.cssProps, function(value, name) {
        prop = $bebd28704f2536ea$var$prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else element.style[prop] = manager.oldCssProps[prop] || "";
    });
    if (!add) manager.oldCssProps = {};
}
/**
 * @private
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */ function $bebd28704f2536ea$var$triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent("Event");
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}
/**
* @private
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */ var $bebd28704f2536ea$var$Manager = /*#__PURE__*/ function() {
    function Manager(element, options) {
        var _this = this;
        this.options = $bebd28704f2536ea$var$assign$1({}, $bebd28704f2536ea$var$defaults, options || {});
        this.options.inputTarget = this.options.inputTarget || element;
        this.handlers = {};
        this.session = {};
        this.recognizers = [];
        this.oldCssProps = {};
        this.element = element;
        this.input = $bebd28704f2536ea$var$createInputInstance(this);
        this.touchAction = new $bebd28704f2536ea$var$TouchAction(this, this.options.touchAction);
        $bebd28704f2536ea$var$toggleCssProps(this, true);
        $bebd28704f2536ea$var$each(this.options.recognizers, function(item) {
            var recognizer = _this.add(new item[0](item[1]));
            item[2] && recognizer.recognizeWith(item[2]);
            item[3] && recognizer.requireFailure(item[3]);
        }, this);
    }
    /**
   * @private
   * set options
   * @param {Object} options
   * @returns {Manager}
   */ var _proto = Manager.prototype;
    _proto.set = function set(options) {
        $bebd28704f2536ea$var$assign$1(this.options, options); // Options that need a little more setup
        if (options.touchAction) this.touchAction.update();
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    };
    /**
   * @private
   * stop recognizing for this session.
   * This session will be discarded, when a new [input]start event is fired.
   * When forced, the recognizer cycle is stopped immediately.
   * @param {Boolean} [force]
   */ _proto.stop = function stop(force) {
        this.session.stopped = force ? $bebd28704f2536ea$var$FORCED_STOP : $bebd28704f2536ea$var$STOP;
    };
    /**
   * @private
   * run the recognizers!
   * called by the inputHandler function on every movement of the pointers (touches)
   * it walks through all the recognizers and tries to detect the gesture that is being made
   * @param {Object} inputData
   */ _proto.recognize = function recognize(inputData) {
        var session = this.session;
        if (session.stopped) return;
         // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);
        var recognizer;
        var recognizers = this.recognizers; // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer; // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || curRecognizer && curRecognizer.state & $bebd28704f2536ea$var$STATE_RECOGNIZED) {
            session.curRecognizer = null;
            curRecognizer = null;
        }
        var i = 0;
        while(i < recognizers.length){
            recognizer = recognizers[i]; // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== $bebd28704f2536ea$var$FORCED_STOP && (!curRecognizer || recognizer === curRecognizer || // 2
            recognizer.canRecognizeWith(curRecognizer))) // 3
            recognizer.recognize(inputData);
            else recognizer.reset();
             // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & ($bebd28704f2536ea$var$STATE_BEGAN | $bebd28704f2536ea$var$STATE_CHANGED | $bebd28704f2536ea$var$STATE_ENDED)) {
                session.curRecognizer = recognizer;
                curRecognizer = recognizer;
            }
            i++;
        }
    };
    /**
   * @private
   * get a recognizer by its event name.
   * @param {Recognizer|String} recognizer
   * @returns {Recognizer|Null}
   */ _proto.get = function get(recognizer) {
        if (recognizer instanceof $bebd28704f2536ea$var$Recognizer) return recognizer;
        var recognizers = this.recognizers;
        for(var i = 0; i < recognizers.length; i++){
            if (recognizers[i].options.event === recognizer) return recognizers[i];
        }
        return null;
    };
    /**
   * @private add a recognizer to the manager
   * existing recognizers with the same event name will be removed
   * @param {Recognizer} recognizer
   * @returns {Recognizer|Manager}
   */ _proto.add = function add(recognizer) {
        if ($bebd28704f2536ea$var$invokeArrayArg(recognizer, "add", this)) return this;
         // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) this.remove(existing);
        this.recognizers.push(recognizer);
        recognizer.manager = this;
        this.touchAction.update();
        return recognizer;
    };
    /**
   * @private
   * remove a recognizer by name or instance
   * @param {Recognizer|String} recognizer
   * @returns {Manager}
   */ _proto.remove = function remove(recognizer) {
        if ($bebd28704f2536ea$var$invokeArrayArg(recognizer, "remove", this)) return this;
        var targetRecognizer = this.get(recognizer); // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = $bebd28704f2536ea$var$inArray(recognizers, targetRecognizer);
            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }
        return this;
    };
    /**
   * @private
   * bind event
   * @param {String} events
   * @param {Function} handler
   * @returns {EventEmitter} this
   */ _proto.on = function on(events, handler) {
        if (events === undefined || handler === undefined) return this;
        var handlers = this.handlers;
        $bebd28704f2536ea$var$each($bebd28704f2536ea$var$splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    };
    /**
   * @private unbind event, leave emit blank to remove all handlers
   * @param {String} events
   * @param {Function} [handler]
   * @returns {EventEmitter} this
   */ _proto.off = function off(events, handler) {
        if (events === undefined) return this;
        var handlers = this.handlers;
        $bebd28704f2536ea$var$each($bebd28704f2536ea$var$splitStr(events), function(event) {
            if (!handler) delete handlers[event];
            else handlers[event] && handlers[event].splice($bebd28704f2536ea$var$inArray(handlers[event], handler), 1);
        });
        return this;
    };
    /**
   * @private emit event to the listeners
   * @param {String} event
   * @param {Object} data
   */ _proto.emit = function emit(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) $bebd28704f2536ea$var$triggerDomEvent(event, data);
         // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) return;
        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };
        var i = 0;
        while(i < handlers.length){
            handlers[i](data);
            i++;
        }
    };
    /**
   * @private
   * destroy the manager and unbinds all events
   * it doesn't unbind dom events, that is the user own responsibility
   */ _proto.destroy = function destroy() {
        this.element && $bebd28704f2536ea$var$toggleCssProps(this, false);
        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    };
    return Manager;
}();
var $bebd28704f2536ea$var$SINGLE_TOUCH_INPUT_MAP = {
    touchstart: $bebd28704f2536ea$var$INPUT_START,
    touchmove: $bebd28704f2536ea$var$INPUT_MOVE,
    touchend: $bebd28704f2536ea$var$INPUT_END,
    touchcancel: $bebd28704f2536ea$var$INPUT_CANCEL
};
var $bebd28704f2536ea$var$SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var $bebd28704f2536ea$var$SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';
/**
 * @private
 * Touch events input
 * @constructor
 * @extends Input
 */ var $bebd28704f2536ea$var$SingleTouchInput = /*#__PURE__*/ function(_Input) {
    $bebd28704f2536ea$var$_inheritsLoose(SingleTouchInput, _Input);
    function SingleTouchInput() {
        var _this;
        var proto = SingleTouchInput.prototype;
        proto.evTarget = $bebd28704f2536ea$var$SINGLE_TOUCH_TARGET_EVENTS;
        proto.evWin = $bebd28704f2536ea$var$SINGLE_TOUCH_WINDOW_EVENTS;
        _this = _Input.apply(this, arguments) || this;
        _this.started = false;
        return _this;
    }
    var _proto = SingleTouchInput.prototype;
    _proto.handler = function handler(ev) {
        var type = $bebd28704f2536ea$var$SINGLE_TOUCH_INPUT_MAP[ev.type]; // should we handle the touch events?
        if (type === $bebd28704f2536ea$var$INPUT_START) this.started = true;
        if (!this.started) return;
        var touches = $bebd28704f2536ea$var$normalizeSingleTouches.call(this, ev, type); // when done, reset the started state
        if (type & ($bebd28704f2536ea$var$INPUT_END | $bebd28704f2536ea$var$INPUT_CANCEL) && touches[0].length - touches[1].length === 0) this.started = false;
        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: $bebd28704f2536ea$var$INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    };
    return SingleTouchInput;
}($bebd28704f2536ea$var$Input);
function $bebd28704f2536ea$var$normalizeSingleTouches(ev, type) {
    var all = $bebd28704f2536ea$var$toArray(ev.touches);
    var changed = $bebd28704f2536ea$var$toArray(ev.changedTouches);
    if (type & ($bebd28704f2536ea$var$INPUT_END | $bebd28704f2536ea$var$INPUT_CANCEL)) all = $bebd28704f2536ea$var$uniqueArray(all.concat(changed), 'identifier', true);
    return [
        all,
        changed
    ];
}
/**
 * @private
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */ function $bebd28704f2536ea$var$deprecate(method, name, message) {
    var deprecationMessage = "DEPRECATED METHOD: " + name + "\n" + message + " AT \n";
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '').replace(/^\s+at\s+/gm, '').replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';
        var log = window.console && (window.console.warn || window.console.log);
        if (log) log.call(window.console, deprecationMessage, stack);
        return method.apply(this, arguments);
    };
}
/**
 * @private
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */ var $bebd28704f2536ea$var$extend = $bebd28704f2536ea$var$deprecate(function(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while(i < keys.length){
        if (!merge || merge && dest[keys[i]] === undefined) dest[keys[i]] = src[keys[i]];
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');
/**
 * @private
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */ var $bebd28704f2536ea$var$merge$2 = $bebd28704f2536ea$var$deprecate(function(dest, src) {
    return $bebd28704f2536ea$var$extend(dest, src, true);
}, 'merge', 'Use `assign`.');
/**
 * @private
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */ function $bebd28704f2536ea$var$inherit(child, base, properties) {
    var baseP = base.prototype;
    var childP;
    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;
    if (properties) $bebd28704f2536ea$var$assign$1(childP, properties);
}
/**
 * @private
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */ function $bebd28704f2536ea$var$bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}
/**
 * @private
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */ var $bebd28704f2536ea$var$Hammer$2 = /*#__PURE__*/ function() {
    var Hammer = /**
    * @private
    * @const {string}
    */ function Hammer(element, options) {
        if (options === void 0) options = {};
        return new $bebd28704f2536ea$var$Manager(element, $bebd28704f2536ea$var$_extends({
            recognizers: $bebd28704f2536ea$var$preset.concat()
        }, options));
    };
    Hammer.VERSION = "2.0.17-rc";
    Hammer.DIRECTION_ALL = $bebd28704f2536ea$var$DIRECTION_ALL;
    Hammer.DIRECTION_DOWN = $bebd28704f2536ea$var$DIRECTION_DOWN;
    Hammer.DIRECTION_LEFT = $bebd28704f2536ea$var$DIRECTION_LEFT;
    Hammer.DIRECTION_RIGHT = $bebd28704f2536ea$var$DIRECTION_RIGHT;
    Hammer.DIRECTION_UP = $bebd28704f2536ea$var$DIRECTION_UP;
    Hammer.DIRECTION_HORIZONTAL = $bebd28704f2536ea$var$DIRECTION_HORIZONTAL;
    Hammer.DIRECTION_VERTICAL = $bebd28704f2536ea$var$DIRECTION_VERTICAL;
    Hammer.DIRECTION_NONE = $bebd28704f2536ea$var$DIRECTION_NONE;
    Hammer.DIRECTION_DOWN = $bebd28704f2536ea$var$DIRECTION_DOWN;
    Hammer.INPUT_START = $bebd28704f2536ea$var$INPUT_START;
    Hammer.INPUT_MOVE = $bebd28704f2536ea$var$INPUT_MOVE;
    Hammer.INPUT_END = $bebd28704f2536ea$var$INPUT_END;
    Hammer.INPUT_CANCEL = $bebd28704f2536ea$var$INPUT_CANCEL;
    Hammer.STATE_POSSIBLE = $bebd28704f2536ea$var$STATE_POSSIBLE;
    Hammer.STATE_BEGAN = $bebd28704f2536ea$var$STATE_BEGAN;
    Hammer.STATE_CHANGED = $bebd28704f2536ea$var$STATE_CHANGED;
    Hammer.STATE_ENDED = $bebd28704f2536ea$var$STATE_ENDED;
    Hammer.STATE_RECOGNIZED = $bebd28704f2536ea$var$STATE_RECOGNIZED;
    Hammer.STATE_CANCELLED = $bebd28704f2536ea$var$STATE_CANCELLED;
    Hammer.STATE_FAILED = $bebd28704f2536ea$var$STATE_FAILED;
    Hammer.Manager = $bebd28704f2536ea$var$Manager;
    Hammer.Input = $bebd28704f2536ea$var$Input;
    Hammer.TouchAction = $bebd28704f2536ea$var$TouchAction;
    Hammer.TouchInput = $bebd28704f2536ea$var$TouchInput;
    Hammer.MouseInput = $bebd28704f2536ea$var$MouseInput;
    Hammer.PointerEventInput = $bebd28704f2536ea$var$PointerEventInput;
    Hammer.TouchMouseInput = $bebd28704f2536ea$var$TouchMouseInput;
    Hammer.SingleTouchInput = $bebd28704f2536ea$var$SingleTouchInput;
    Hammer.Recognizer = $bebd28704f2536ea$var$Recognizer;
    Hammer.AttrRecognizer = $bebd28704f2536ea$var$AttrRecognizer;
    Hammer.Tap = $bebd28704f2536ea$var$TapRecognizer;
    Hammer.Pan = $bebd28704f2536ea$var$PanRecognizer;
    Hammer.Swipe = $bebd28704f2536ea$var$SwipeRecognizer;
    Hammer.Pinch = $bebd28704f2536ea$var$PinchRecognizer;
    Hammer.Rotate = $bebd28704f2536ea$var$RotateRecognizer;
    Hammer.Press = $bebd28704f2536ea$var$PressRecognizer;
    Hammer.on = $bebd28704f2536ea$var$addEventListeners;
    Hammer.off = $bebd28704f2536ea$var$removeEventListeners;
    Hammer.each = $bebd28704f2536ea$var$each;
    Hammer.merge = $bebd28704f2536ea$var$merge$2;
    Hammer.extend = $bebd28704f2536ea$var$extend;
    Hammer.bindFn = $bebd28704f2536ea$var$bindFn;
    Hammer.assign = $bebd28704f2536ea$var$assign$1;
    Hammer.inherit = $bebd28704f2536ea$var$inherit;
    Hammer.bindFn = $bebd28704f2536ea$var$bindFn;
    Hammer.prefixed = $bebd28704f2536ea$var$prefixed;
    Hammer.toArray = $bebd28704f2536ea$var$toArray;
    Hammer.inArray = $bebd28704f2536ea$var$inArray;
    Hammer.uniqueArray = $bebd28704f2536ea$var$uniqueArray;
    Hammer.splitStr = $bebd28704f2536ea$var$splitStr;
    Hammer.boolOrFn = $bebd28704f2536ea$var$boolOrFn;
    Hammer.hasParent = $bebd28704f2536ea$var$hasParent;
    Hammer.addEventListeners = $bebd28704f2536ea$var$addEventListeners;
    Hammer.removeEventListeners = $bebd28704f2536ea$var$removeEventListeners;
    Hammer.defaults = $bebd28704f2536ea$var$assign$1({}, $bebd28704f2536ea$var$defaults, {
        preset: $bebd28704f2536ea$var$preset
    });
    return Hammer;
}();
//  style loader but by script tag, not by the loader.
$bebd28704f2536ea$var$Hammer$2.defaults;
var $bebd28704f2536ea$var$RealHammer = $bebd28704f2536ea$var$Hammer$2;
function $bebd28704f2536ea$var$_createForOfIteratorHelper$6(o, allowArrayLike) {
    var it = typeof $bebd28704f2536ea$var$_Symbol !== "undefined" && $bebd28704f2536ea$var$_getIteratorMethod(o) || o["@@iterator"];
    if (!it) {
        if ($bebd28704f2536ea$var$_Array$isArray(o) || (it = $bebd28704f2536ea$var$_unsupportedIterableToArray$6(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $bebd28704f2536ea$var$_unsupportedIterableToArray$6(o, minLen) {
    var _context17;
    if (!o) return;
    if (typeof o === "string") return $bebd28704f2536ea$var$_arrayLikeToArray$6(o, minLen);
    var n = $bebd28704f2536ea$var$_sliceInstanceProperty(_context17 = Object.prototype.toString.call(o)).call(_context17, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return $bebd28704f2536ea$var$_Array$from$1(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bebd28704f2536ea$var$_arrayLikeToArray$6(o, minLen);
}
function $bebd28704f2536ea$var$_arrayLikeToArray$6(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * Use this symbol to delete properies in deepObjectAssign.
 */ $bebd28704f2536ea$var$_Symbol("DELETE");
/**
 * Seedable, fast and reasonably good (not crypto but more than okay for our
 * needs) random number generator.
 *
 * @remarks
 * Adapted from {@link https://web.archive.org/web/20110429100736/http://baagoe.com:80/en/RandomMusings/javascript}.
 * Original algorithm created by Johannes Baagøe \<baagoe\@baagoe.com\> in 2010.
 */ /**
 * Create a seeded pseudo random generator based on Alea by Johannes Baagøe.
 *
 * @param seed - All supplied arguments will be used as a seed. In case nothing
 * is supplied the current time will be used to seed the generator.
 * @returns A ready to use seeded generator.
 */ function $bebd28704f2536ea$var$Alea() {
    for(var _len3 = arguments.length, seed = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)seed[_key3] = arguments[_key3];
    return $bebd28704f2536ea$var$AleaImplementation(seed.length ? seed : [
        $bebd28704f2536ea$var$_Date$now()
    ]);
}
/**
 * An implementation of [[Alea]] without user input validation.
 *
 * @param seed - The data that will be used to seed the generator.
 * @returns A ready to use seeded generator.
 */ function $bebd28704f2536ea$var$AleaImplementation(seed) {
    var _mashSeed = $bebd28704f2536ea$var$mashSeed(seed), _mashSeed2 = $bebd28704f2536ea$var$_slicedToArray(_mashSeed, 3), s0 = _mashSeed2[0], s1 = _mashSeed2[1], s2 = _mashSeed2[2];
    var c = 1;
    var random = function random() {
        var t = 2091639 * s0 + c * 2.3283064365386963e-10; // 2^-32
        s0 = s1;
        s1 = s2;
        return s2 = t - (c = t | 0);
    };
    random.uint32 = function() {
        return random() * 0x100000000;
    }; // 2^32
    random.fract53 = function() {
        return random() + (random() * 0x200000 | 0) * 1.1102230246251565e-16;
    }; // 2^-53
    random.algorithm = "Alea";
    random.seed = seed;
    random.version = "0.9";
    return random;
}
/**
 * Turn arbitrary data into values [[AleaImplementation]] can use to generate
 * random numbers.
 *
 * @param seed - Arbitrary data that will be used as the seed.
 * @returns Three numbers to use as initial values for [[AleaImplementation]].
 */ function $bebd28704f2536ea$var$mashSeed() {
    var mash = $bebd28704f2536ea$var$Mash();
    var s0 = mash(" ");
    var s1 = mash(" ");
    var s2 = mash(" ");
    for(var i = 0; i < arguments.length; i++){
        s0 -= mash(i < 0 || arguments.length <= i ? undefined : arguments[i]);
        if (s0 < 0) s0 += 1;
        s1 -= mash(i < 0 || arguments.length <= i ? undefined : arguments[i]);
        if (s1 < 0) s1 += 1;
        s2 -= mash(i < 0 || arguments.length <= i ? undefined : arguments[i]);
        if (s2 < 0) s2 += 1;
    }
    return [
        s0,
        s1,
        s2
    ];
}
/**
 * Create a new mash function.
 *
 * @returns A nonpure function that takes arbitrary [[Mashable]] data and turns
 * them into numbers.
 */ function $bebd28704f2536ea$var$Mash() {
    var n = 0xefc8249d;
    return function(data) {
        var string = data.toString();
        for(var i = 0; i < string.length; i++){
            n += string.charCodeAt(i);
            var h = 0.02519603282416938 * n;
            n = h >>> 0;
            h -= n;
            h *= n;
            n = h >>> 0;
            h -= n;
            n += h * 0x100000000; // 2^32
        }
        return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
    };
}
/**
 * Setup a mock hammer.js object, for unit testing.
 *
 * Inspiration: https://github.com/uber/deck.gl/pull/658
 *
 * @returns {{on: noop, off: noop, destroy: noop, emit: noop, get: get}}
 */ function $bebd28704f2536ea$var$hammerMock() {
    var noop = function noop() {};
    return {
        on: noop,
        off: noop,
        destroy: noop,
        emit: noop,
        get: function get() {
            return {
                set: noop
            };
        }
    };
}
var $bebd28704f2536ea$var$Hammer$1 = typeof window !== "undefined" ? window.Hammer || $bebd28704f2536ea$var$RealHammer : function() {
    // hammer.js is only available in a browser, not in node.js. Replacing it with a mock object.
    return $bebd28704f2536ea$var$hammerMock();
};
/**
 * Turn an element into an clickToUse element.
 * When not active, the element has a transparent overlay. When the overlay is
 * clicked, the mode is changed to active.
 * When active, the element is displayed with a blue border around it, and
 * the interactive contents of the element can be used. When clicked outside
 * the element, the elements mode is changed to inactive.
 *
 * @param {Element} container
 * @class Activator
 */ function $bebd28704f2536ea$var$Activator$1(container) {
    var _this = this, _context3;
    this._cleanupQueue = [];
    this.active = false;
    this._dom = {
        container: container,
        overlay: document.createElement("div")
    };
    this._dom.overlay.classList.add("vis-overlay");
    this._dom.container.appendChild(this._dom.overlay);
    this._cleanupQueue.push(function() {
        _this._dom.overlay.parentNode.removeChild(_this._dom.overlay);
    });
    var hammer = $bebd28704f2536ea$var$Hammer$1(this._dom.overlay);
    hammer.on("tap", $bebd28704f2536ea$var$_bindInstanceProperty$1(_context3 = this._onTapOverlay).call(_context3, this));
    this._cleanupQueue.push(function() {
        hammer.destroy();
    // FIXME: cleaning up hammer instances doesn't work (Timeline not removed
    // from memory)
    });
    // block all touch events (except tap)
    var events = [
        "tap",
        "doubletap",
        "press",
        "pinch",
        "pan",
        "panstart",
        "panmove",
        "panend"
    ];
    $bebd28704f2536ea$var$_forEachInstanceProperty(events).call(events, function(event) {
        hammer.on(event, function(event) {
            event.srcEvent.stopPropagation();
        });
    });
    // attach a click event to the window, in order to deactivate when clicking outside the timeline
    if (document && document.body) {
        this._onClick = function(event) {
            if (!$bebd28704f2536ea$var$_hasParent(event.target, container)) _this.deactivate();
        };
        document.body.addEventListener("click", this._onClick);
        this._cleanupQueue.push(function() {
            document.body.removeEventListener("click", _this._onClick);
        });
    }
    // prepare escape key listener for deactivating when active
    this._escListener = function(event) {
        if ("key" in event ? event.key === "Escape" : event.keyCode === 27 /* the keyCode is for IE11 */ ) _this.deactivate();
    };
}
// turn into an event emitter
$bebd28704f2536ea$var$Emitter($bebd28704f2536ea$var$Activator$1.prototype);
// The currently active activator
$bebd28704f2536ea$var$Activator$1.current = null;
/**
 * Destroy the activator. Cleans up all created DOM and event listeners
 */ $bebd28704f2536ea$var$Activator$1.prototype.destroy = function() {
    var _context4, _context5;
    this.deactivate();
    var _iterator2 = $bebd28704f2536ea$var$_createForOfIteratorHelper$6($bebd28704f2536ea$var$_reverseInstanceProperty(_context4 = $bebd28704f2536ea$var$_spliceInstanceProperty(_context5 = this._cleanupQueue).call(_context5, 0)).call(_context4)), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var callback = _step2.value;
            callback();
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
};
/**
 * Activate the element
 * Overlay is hidden, element is decorated with a blue shadow border
 */ $bebd28704f2536ea$var$Activator$1.prototype.activate = function() {
    // we allow only one active activator at a time
    if ($bebd28704f2536ea$var$Activator$1.current) $bebd28704f2536ea$var$Activator$1.current.deactivate();
    $bebd28704f2536ea$var$Activator$1.current = this;
    this.active = true;
    this._dom.overlay.style.display = "none";
    this._dom.container.classList.add("vis-active");
    this.emit("change");
    this.emit("activate");
    // ugly hack: bind ESC after emitting the events, as the Network rebinds all
    // keyboard events on a 'change' event
    document.body.addEventListener("keydown", this._escListener);
};
/**
 * Deactivate the element
 * Overlay is displayed on top of the element
 */ $bebd28704f2536ea$var$Activator$1.prototype.deactivate = function() {
    this.active = false;
    this._dom.overlay.style.display = "block";
    this._dom.container.classList.remove("vis-active");
    document.body.removeEventListener("keydown", this._escListener);
    this.emit("change");
    this.emit("deactivate");
};
/**
 * Handle a tap event: activate the container
 *
 * @param {Event}  event   The event
 * @private
 */ $bebd28704f2536ea$var$Activator$1.prototype._onTapOverlay = function(event) {
    // activate the container
    this.activate();
    event.srcEvent.stopPropagation();
};
/**
 * Test whether the element has the requested parent element somewhere in
 * its chain of parent nodes.
 *
 * @param {HTMLElement} element
 * @param {HTMLElement} parent
 * @returns {boolean} Returns true when the parent is found somewhere in the
 *                    chain of parent nodes.
 * @private
 */ function $bebd28704f2536ea$var$_hasParent(element, parent) {
    while(element){
        if (element === parent) return true;
        element = element.parentNode;
    }
    return false;
}
// Color REs
var $bebd28704f2536ea$var$fullHexRE = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
var $bebd28704f2536ea$var$shortHexRE = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
var $bebd28704f2536ea$var$rgbRE = /^rgb\( *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *\)$/i;
var $bebd28704f2536ea$var$rgbaRE = /^rgba\( *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *([01]|0?\.\d+) *\)$/i;
/**
 * Remove everything in the DOM object.
 *
 * @param DOMobject - Node whose child nodes will be recursively deleted.
 */ function $bebd28704f2536ea$var$recursiveDOMDelete(DOMobject) {
    if (DOMobject) while(DOMobject.hasChildNodes() === true){
        var child = DOMobject.firstChild;
        if (child) {
            $bebd28704f2536ea$var$recursiveDOMDelete(child);
            DOMobject.removeChild(child);
        }
    }
}
/**
 * Test whether given object is a string.
 *
 * @param value - Input value of unknown type.
 * @returns True if string, false otherwise.
 */ function $bebd28704f2536ea$var$isString(value) {
    return value instanceof String || typeof value === "string";
}
/**
 * Test whether given object is a object (not primitive or null).
 *
 * @param value - Input value of unknown type.
 * @returns True if not null object, false otherwise.
 */ function $bebd28704f2536ea$var$isObject$7(value) {
    return $bebd28704f2536ea$var$_typeof(value) === "object" && value !== null;
}
/**
 * Copy property from b to a if property present in a.
 * If property in b explicitly set to null, delete it if `allowDeletion` set.
 *
 * Internal helper routine, should not be exported. Not added to `exports` for that reason.
 *
 * @param a - Target object.
 * @param b - Source object.
 * @param prop - Name of property to copy from b to a.
 * @param allowDeletion - If true, delete property in a if explicitly set to null in b.
 */ function $bebd28704f2536ea$var$copyOrDelete(a, b, prop, allowDeletion) {
    var doDeletion = false;
    if (allowDeletion === true) doDeletion = b[prop] === null && a[prop] !== undefined;
    if (doDeletion) delete a[prop];
    else a[prop] = b[prop]; // Remember, this is a reference copy!
}
/**
 * Fill an object with a possibly partially defined other object.
 *
 * Only copies values for the properties already present in a.
 * That means an object is not created on a property if only the b object has it.
 *
 * @param a - The object that will have it's properties updated.
 * @param b - The object with property updates.
 * @param allowDeletion - If true, delete properties in a that are explicitly set to null in b.
 */ function $bebd28704f2536ea$var$fillIfDefined(a, b) {
    var allowDeletion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // NOTE: iteration of properties of a
    // NOTE: prototype properties iterated over as well
    for(var prop in a)if (b[prop] !== undefined) {
        if (b[prop] === null || $bebd28704f2536ea$var$_typeof(b[prop]) !== "object") // Note: typeof null === 'object'
        $bebd28704f2536ea$var$copyOrDelete(a, b, prop, allowDeletion);
        else {
            var aProp = a[prop];
            var bProp = b[prop];
            if ($bebd28704f2536ea$var$isObject$7(aProp) && $bebd28704f2536ea$var$isObject$7(bProp)) $bebd28704f2536ea$var$fillIfDefined(aProp, bProp, allowDeletion);
        }
    }
}
/**
 * Extend object a with selected properties of object b.
 * Only properties with defined values are copied.
 *
 * @remarks
 * Previous version of this routine implied that multiple source objects could
 * be used; however, the implementation was **wrong**. Since multiple (\>1)
 * sources weren't used anywhere in the `vis.js` code, this has been removed
 * @param props - Names of first-level properties to copy over.
 * @param a - Target object.
 * @param b - Source object.
 * @param allowDeletion - If true, delete property in a if explicitly set to null in b.
 * @returns Argument a.
 */ function $bebd28704f2536ea$var$selectiveDeepExtend(props, a, b) {
    var allowDeletion = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // TODO: add support for Arrays to deepExtend
    if ($bebd28704f2536ea$var$_Array$isArray(b)) throw new TypeError("Arrays are not supported by deepExtend");
    for(var p = 0; p < props.length; p++){
        var prop = props[p];
        if (Object.prototype.hasOwnProperty.call(b, prop)) {
            if (b[prop] && b[prop].constructor === Object) {
                if (a[prop] === undefined) a[prop] = {};
                if (a[prop].constructor === Object) $bebd28704f2536ea$var$deepExtend(a[prop], b[prop], false, allowDeletion);
                else $bebd28704f2536ea$var$copyOrDelete(a, b, prop, allowDeletion);
            } else if ($bebd28704f2536ea$var$_Array$isArray(b[prop])) throw new TypeError("Arrays are not supported by deepExtend");
            else $bebd28704f2536ea$var$copyOrDelete(a, b, prop, allowDeletion);
        }
    }
    return a;
}
/**
 * Extend object `a` with properties of object `b`, ignoring properties which
 * are explicitly specified to be excluded.
 *
 * @remarks
 * The properties of `b` are considered for copying. Properties which are
 * themselves objects are are also extended. Only properties with defined
 * values are copied.
 * @param propsToExclude - Names of properties which should *not* be copied.
 * @param a - Object to extend.
 * @param b - Object to take properties from for extension.
 * @param allowDeletion - If true, delete properties in a that are explicitly
 * set to null in b.
 * @returns Argument a.
 */ function $bebd28704f2536ea$var$selectiveNotDeepExtend(propsToExclude, a, b) {
    var allowDeletion = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // TODO: add support for Arrays to deepExtend
    // NOTE: array properties have an else-below; apparently, there is a problem here.
    if ($bebd28704f2536ea$var$_Array$isArray(b)) throw new TypeError("Arrays are not supported by deepExtend");
    for(var prop in b){
        if (!Object.prototype.hasOwnProperty.call(b, prop)) continue;
         // Handle local properties only
        if ($bebd28704f2536ea$var$_includesInstanceProperty(propsToExclude).call(propsToExclude, prop)) continue;
         // In exclusion list, skip
        if (b[prop] && b[prop].constructor === Object) {
            if (a[prop] === undefined) a[prop] = {};
            if (a[prop].constructor === Object) $bebd28704f2536ea$var$deepExtend(a[prop], b[prop]); // NOTE: allowDeletion not propagated!
            else $bebd28704f2536ea$var$copyOrDelete(a, b, prop, allowDeletion);
        } else if ($bebd28704f2536ea$var$_Array$isArray(b[prop])) {
            a[prop] = [];
            for(var i = 0; i < b[prop].length; i++)a[prop].push(b[prop][i]);
        } else $bebd28704f2536ea$var$copyOrDelete(a, b, prop, allowDeletion);
    }
    return a;
}
/**
 * Deep extend an object a with the properties of object b.
 *
 * @param a - Target object.
 * @param b - Source object.
 * @param protoExtend - If true, the prototype values will also be extended.
 * (That is the options objects that inherit from others will also get the
 * inherited options).
 * @param allowDeletion - If true, the values of fields that are null will be deleted.
 * @returns Argument a.
 */ function $bebd28704f2536ea$var$deepExtend(a, b) {
    var protoExtend = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var allowDeletion = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    for(var prop in b)if (Object.prototype.hasOwnProperty.call(b, prop) || protoExtend === true) {
        if ($bebd28704f2536ea$var$_typeof(b[prop]) === "object" && b[prop] !== null && $bebd28704f2536ea$var$_Object$getPrototypeOf$1(b[prop]) === Object.prototype) {
            if (a[prop] === undefined) a[prop] = $bebd28704f2536ea$var$deepExtend({}, b[prop], protoExtend); // NOTE: allowDeletion not propagated!
            else if ($bebd28704f2536ea$var$_typeof(a[prop]) === "object" && a[prop] !== null && $bebd28704f2536ea$var$_Object$getPrototypeOf$1(a[prop]) === Object.prototype) $bebd28704f2536ea$var$deepExtend(a[prop], b[prop], protoExtend); // NOTE: allowDeletion not propagated!
            else $bebd28704f2536ea$var$copyOrDelete(a, b, prop, allowDeletion);
        } else if ($bebd28704f2536ea$var$_Array$isArray(b[prop])) {
            var _context6;
            a[prop] = $bebd28704f2536ea$var$_sliceInstanceProperty(_context6 = b[prop]).call(_context6);
        } else $bebd28704f2536ea$var$copyOrDelete(a, b, prop, allowDeletion);
    }
    return a;
}
/**
 * Used to extend an array and copy it. This is used to propagate paths recursively.
 *
 * @param arr - First part.
 * @param newValue - The value to be aadded into the array.
 * @returns A new array with all items from arr and newValue (which is last).
 */ function $bebd28704f2536ea$var$copyAndExtendArray(arr, newValue) {
    var _context7;
    return $bebd28704f2536ea$var$_concatInstanceProperty(_context7 = []).call(_context7, $bebd28704f2536ea$var$_toConsumableArray(arr), [
        newValue
    ]);
}
/**
 * Used to extend an array and copy it. This is used to propagate paths recursively.
 *
 * @param arr - The array to be copied.
 * @returns Shallow copy of arr.
 */ function $bebd28704f2536ea$var$copyArray(arr) {
    return $bebd28704f2536ea$var$_sliceInstanceProperty(arr).call(arr);
}
/**
 * Retrieve the absolute left value of a DOM element.
 *
 * @param elem - A dom element, for example a div.
 * @returns The absolute left position of this element in the browser page.
 */ function $bebd28704f2536ea$var$getAbsoluteLeft(elem) {
    return elem.getBoundingClientRect().left;
}
/**
 * Retrieve the absolute top value of a DOM element.
 *
 * @param elem - A dom element, for example a div.
 * @returns The absolute top position of this element in the browser page.
 */ function $bebd28704f2536ea$var$getAbsoluteTop(elem) {
    return elem.getBoundingClientRect().top;
}
/**
 * For each method for both arrays and objects.
 * In case of an array, the built-in Array.forEach() is applied (**No, it's not!**).
 * In case of an Object, the method loops over all properties of the object.
 *
 * @param object - An Object or Array to be iterated over.
 * @param callback - Array.forEach-like callback.
 */ function $bebd28704f2536ea$var$forEach$1(object, callback) {
    if ($bebd28704f2536ea$var$_Array$isArray(object)) {
        // array
        var len = object.length;
        for(var i = 0; i < len; i++)callback(object[i], i, object);
    } else {
        // object
        for(var key in object)if (Object.prototype.hasOwnProperty.call(object, key)) callback(object[key], key, object);
    }
}
/**
 * Convert hex color string into RGB color object.
 *
 * @remarks
 * {@link http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb}
 * @param hex - Hex color string (3 or 6 digits, with or without #).
 * @returns RGB color object.
 */ function $bebd28704f2536ea$var$hexToRGB(hex) {
    var result;
    switch(hex.length){
        case 3:
        case 4:
            result = $bebd28704f2536ea$var$shortHexRE.exec(hex);
            return result ? {
                r: $bebd28704f2536ea$var$_parseInt$1(result[1] + result[1], 16),
                g: $bebd28704f2536ea$var$_parseInt$1(result[2] + result[2], 16),
                b: $bebd28704f2536ea$var$_parseInt$1(result[3] + result[3], 16)
            } : null;
        case 6:
        case 7:
            result = $bebd28704f2536ea$var$fullHexRE.exec(hex);
            return result ? {
                r: $bebd28704f2536ea$var$_parseInt$1(result[1], 16),
                g: $bebd28704f2536ea$var$_parseInt$1(result[2], 16),
                b: $bebd28704f2536ea$var$_parseInt$1(result[3], 16)
            } : null;
        default:
            return null;
    }
}
/**
 * This function takes string color in hex or RGB format and adds the opacity, RGBA is passed through unchanged.
 *
 * @param color - The color string (hex, RGB, RGBA).
 * @param opacity - The new opacity.
 * @returns RGBA string, for example 'rgba(255, 0, 127, 0.3)'.
 */ function $bebd28704f2536ea$var$overrideOpacity(color, opacity) {
    if ($bebd28704f2536ea$var$_includesInstanceProperty(color).call(color, "rgba")) return color;
    else if ($bebd28704f2536ea$var$_includesInstanceProperty(color).call(color, "rgb")) {
        var rgb = color.substr($bebd28704f2536ea$var$_indexOfInstanceProperty(color).call(color, "(") + 1).replace(")", "").split(",");
        return "rgba(" + rgb[0] + "," + rgb[1] + "," + rgb[2] + "," + opacity + ")";
    } else {
        var _rgb = $bebd28704f2536ea$var$hexToRGB(color);
        if (_rgb == null) return color;
        else return "rgba(" + _rgb.r + "," + _rgb.g + "," + _rgb.b + "," + opacity + ")";
    }
}
/**
 * Convert RGB \<0, 255\> into hex color string.
 *
 * @param red - Red channel.
 * @param green - Green channel.
 * @param blue - Blue channel.
 * @returns Hex color string (for example: '#0acdc0').
 */ function $bebd28704f2536ea$var$RGBToHex(red, green, blue) {
    var _context10;
    return "#" + $bebd28704f2536ea$var$_sliceInstanceProperty(_context10 = (16777216 + (red << 16) + (green << 8) + blue).toString(16)).call(_context10, 1);
}
/**
 * Parse a color property into an object with border, background, and highlight colors.
 *
 * @param inputColor - Shorthand color string or input color object.
 * @param defaultColor - Full color object to fill in missing values in inputColor.
 * @returns Color object.
 */ function $bebd28704f2536ea$var$parseColor(inputColor, defaultColor) {
    if ($bebd28704f2536ea$var$isString(inputColor)) {
        var colorStr = inputColor;
        if ($bebd28704f2536ea$var$isValidRGB(colorStr)) {
            var _context11;
            var rgb = $bebd28704f2536ea$var$_mapInstanceProperty(_context11 = colorStr.substr(4).substr(0, colorStr.length - 5).split(",")).call(_context11, function(value) {
                return $bebd28704f2536ea$var$_parseInt$1(value);
            });
            colorStr = $bebd28704f2536ea$var$RGBToHex(rgb[0], rgb[1], rgb[2]);
        }
        if ($bebd28704f2536ea$var$isValidHex(colorStr) === true) {
            var hsv = $bebd28704f2536ea$var$hexToHSV(colorStr);
            var lighterColorHSV = {
                h: hsv.h,
                s: hsv.s * 0.8,
                v: Math.min(1, hsv.v * 1.02)
            };
            var darkerColorHSV = {
                h: hsv.h,
                s: Math.min(1, hsv.s * 1.25),
                v: hsv.v * 0.8
            };
            var darkerColorHex = $bebd28704f2536ea$var$HSVToHex(darkerColorHSV.h, darkerColorHSV.s, darkerColorHSV.v);
            var lighterColorHex = $bebd28704f2536ea$var$HSVToHex(lighterColorHSV.h, lighterColorHSV.s, lighterColorHSV.v);
            return {
                background: colorStr,
                border: darkerColorHex,
                highlight: {
                    background: lighterColorHex,
                    border: darkerColorHex
                },
                hover: {
                    background: lighterColorHex,
                    border: darkerColorHex
                }
            };
        } else return {
            background: colorStr,
            border: colorStr,
            highlight: {
                background: colorStr,
                border: colorStr
            },
            hover: {
                background: colorStr,
                border: colorStr
            }
        };
    } else if (defaultColor) {
        var color = {
            background: inputColor.background || defaultColor.background,
            border: inputColor.border || defaultColor.border,
            highlight: $bebd28704f2536ea$var$isString(inputColor.highlight) ? {
                border: inputColor.highlight,
                background: inputColor.highlight
            } : {
                background: inputColor.highlight && inputColor.highlight.background || defaultColor.highlight.background,
                border: inputColor.highlight && inputColor.highlight.border || defaultColor.highlight.border
            },
            hover: $bebd28704f2536ea$var$isString(inputColor.hover) ? {
                border: inputColor.hover,
                background: inputColor.hover
            } : {
                border: inputColor.hover && inputColor.hover.border || defaultColor.hover.border,
                background: inputColor.hover && inputColor.hover.background || defaultColor.hover.background
            }
        };
        return color;
    } else {
        var _color = {
            background: inputColor.background || undefined,
            border: inputColor.border || undefined,
            highlight: $bebd28704f2536ea$var$isString(inputColor.highlight) ? {
                border: inputColor.highlight,
                background: inputColor.highlight
            } : {
                background: inputColor.highlight && inputColor.highlight.background || undefined,
                border: inputColor.highlight && inputColor.highlight.border || undefined
            },
            hover: $bebd28704f2536ea$var$isString(inputColor.hover) ? {
                border: inputColor.hover,
                background: inputColor.hover
            } : {
                border: inputColor.hover && inputColor.hover.border || undefined,
                background: inputColor.hover && inputColor.hover.background || undefined
            }
        };
        return _color;
    }
}
/**
 * Convert RGB \<0, 255\> into HSV object.
 *
 * @remarks
 * {@link http://www.javascripter.net/faq/rgb2hsv.htm}
 * @param red - Red channel.
 * @param green - Green channel.
 * @param blue - Blue channel.
 * @returns HSV color object.
 */ function $bebd28704f2536ea$var$RGBToHSV(red, green, blue) {
    red = red / 255;
    green = green / 255;
    blue = blue / 255;
    var minRGB = Math.min(red, Math.min(green, blue));
    var maxRGB = Math.max(red, Math.max(green, blue));
    // Black-gray-white
    if (minRGB === maxRGB) return {
        h: 0,
        s: 0,
        v: minRGB
    };
    // Colors other than black-gray-white:
    var d = red === minRGB ? green - blue : blue === minRGB ? red - green : blue - red;
    var h = red === minRGB ? 3 : blue === minRGB ? 1 : 5;
    var hue = 60 * (h - d / (maxRGB - minRGB)) / 360;
    var saturation = (maxRGB - minRGB) / maxRGB;
    var value = maxRGB;
    return {
        h: hue,
        s: saturation,
        v: value
    };
}
/**
 * Convert HSV \<0, 1\> into RGB color object.
 *
 * @remarks
 * {@link https://gist.github.com/mjijackson/5311256}
 * @param h - Hue.
 * @param s - Saturation.
 * @param v - Value.
 * @returns RGB color object.
 */ function $bebd28704f2536ea$var$HSVToRGB(h, s, v) {
    var r;
    var g;
    var b;
    var i = Math.floor(h * 6);
    var f = h * 6 - i;
    var p = v * (1 - s);
    var q = v * (1 - f * s);
    var t = v * (1 - (1 - f) * s);
    switch(i % 6){
        case 0:
            r = v, g = t, b = p;
            break;
        case 1:
            r = q, g = v, b = p;
            break;
        case 2:
            r = p, g = v, b = t;
            break;
        case 3:
            r = p, g = q, b = v;
            break;
        case 4:
            r = t, g = p, b = v;
            break;
        case 5:
            r = v, g = p, b = q;
            break;
    }
    return {
        r: Math.floor(r * 255),
        g: Math.floor(g * 255),
        b: Math.floor(b * 255)
    };
}
/**
 * Convert HSV \<0, 1\> into hex color string.
 *
 * @param h - Hue.
 * @param s - Saturation.
 * @param v - Value.
 * @returns Hex color string.
 */ function $bebd28704f2536ea$var$HSVToHex(h, s, v) {
    var rgb = $bebd28704f2536ea$var$HSVToRGB(h, s, v);
    return $bebd28704f2536ea$var$RGBToHex(rgb.r, rgb.g, rgb.b);
}
/**
 * Convert hex color string into HSV \<0, 1\>.
 *
 * @param hex - Hex color string.
 * @returns HSV color object.
 */ function $bebd28704f2536ea$var$hexToHSV(hex) {
    var rgb = $bebd28704f2536ea$var$hexToRGB(hex);
    if (!rgb) throw new TypeError("'".concat(hex, "' is not a valid color."));
    return $bebd28704f2536ea$var$RGBToHSV(rgb.r, rgb.g, rgb.b);
}
/**
 * Validate hex color string.
 *
 * @param hex - Unknown string that may contain a color.
 * @returns True if the string is valid, false otherwise.
 */ function $bebd28704f2536ea$var$isValidHex(hex) {
    var isOk = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(hex);
    return isOk;
}
/**
 * Validate RGB color string.
 *
 * @param rgb - Unknown string that may contain a color.
 * @returns True if the string is valid, false otherwise.
 */ function $bebd28704f2536ea$var$isValidRGB(rgb) {
    return $bebd28704f2536ea$var$rgbRE.test(rgb);
}
/**
 * Validate RGBA color string.
 *
 * @param rgba - Unknown string that may contain a color.
 * @returns True if the string is valid, false otherwise.
 */ function $bebd28704f2536ea$var$isValidRGBA(rgba) {
    return $bebd28704f2536ea$var$rgbaRE.test(rgba);
}
/**
 * This recursively redirects the prototype of JSON objects to the referenceObject.
 * This is used for default options.
 *
 * @param referenceObject - The original object.
 * @returns The Element if the referenceObject is an Element, or a new object inheriting from the referenceObject.
 */ function $bebd28704f2536ea$var$bridgeObject(referenceObject) {
    if (referenceObject === null || $bebd28704f2536ea$var$_typeof(referenceObject) !== "object") return null;
    if (referenceObject instanceof Element) // Avoid bridging DOM objects
    return referenceObject;
    var objectTo = $bebd28704f2536ea$var$_Object$create$1(referenceObject);
    for(var i in referenceObject){
        if (Object.prototype.hasOwnProperty.call(referenceObject, i)) {
            if ($bebd28704f2536ea$var$_typeof(referenceObject[i]) == "object") objectTo[i] = $bebd28704f2536ea$var$bridgeObject(referenceObject[i]);
        }
    }
    return objectTo;
}
/**
 * This is used to set the options of subobjects in the options object.
 *
 * A requirement of these subobjects is that they have an 'enabled' element
 * which is optional for the user but mandatory for the program.
 *
 * The added value here of the merge is that option 'enabled' is set as required.
 *
 * @param mergeTarget - Either this.options or the options used for the groups.
 * @param options - Options.
 * @param option - Option key in the options argument.
 * @param globalOptions - Global options, passed in to determine value of option 'enabled'.
 */ function $bebd28704f2536ea$var$mergeOptions(mergeTarget, options, option) {
    var globalOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    // Local helpers
    var isPresent = function isPresent(obj) {
        return obj !== null && obj !== undefined;
    };
    var isObject = function isObject(obj) {
        return obj !== null && $bebd28704f2536ea$var$_typeof(obj) === "object";
    };
    // https://stackoverflow.com/a/34491287/1223531
    var isEmpty = function isEmpty(obj) {
        for(var x in obj){
            if (Object.prototype.hasOwnProperty.call(obj, x)) return false;
        }
        return true;
    };
    // Guards
    if (!isObject(mergeTarget)) throw new Error("Parameter mergeTarget must be an object");
    if (!isObject(options)) throw new Error("Parameter options must be an object");
    if (!isPresent(option)) throw new Error("Parameter option must have a value");
    if (!isObject(globalOptions)) throw new Error("Parameter globalOptions must be an object");
    //
    // Actual merge routine, separated from main logic
    // Only a single level of options is merged. Deeper levels are ref'd. This may actually be an issue.
    //
    var doMerge = function doMerge(target, options, option) {
        if (!isObject(target[option])) target[option] = {};
        var src = options[option];
        var dst = target[option];
        for(var prop in src)if (Object.prototype.hasOwnProperty.call(src, prop)) dst[prop] = src[prop];
    };
    // Local initialization
    var srcOption = options[option];
    var globalPassed = isObject(globalOptions) && !isEmpty(globalOptions);
    var globalOption = globalPassed ? globalOptions[option] : undefined;
    var globalEnabled = globalOption ? globalOption.enabled : undefined;
    /////////////////////////////////////////
    // Main routine
    /////////////////////////////////////////
    if (srcOption === undefined) return; // Nothing to do
    if (typeof srcOption === "boolean") {
        if (!isObject(mergeTarget[option])) mergeTarget[option] = {};
        mergeTarget[option].enabled = srcOption;
        return;
    }
    if (srcOption === null && !isObject(mergeTarget[option])) {
        // If possible, explicit copy from globals
        if (isPresent(globalOption)) mergeTarget[option] = $bebd28704f2536ea$var$_Object$create$1(globalOption);
        else return; // Nothing to do
    }
    if (!isObject(srcOption)) return;
    //
    // Ensure that 'enabled' is properly set. It is required internally
    // Note that the value from options will always overwrite the existing value
    //
    var enabled = true; // default value
    if (srcOption.enabled !== undefined) enabled = srcOption.enabled;
    else // Take from globals, if present
    if (globalEnabled !== undefined) enabled = globalOption.enabled;
    doMerge(mergeTarget, options, option);
    mergeTarget[option].enabled = enabled;
}
/*
 * Easing Functions.
 * Only considering the t value for the range [0, 1] => [0, 1].
 *
 * Inspiration: from http://gizma.com/easing/
 * https://gist.github.com/gre/1650294
 */ var $bebd28704f2536ea$var$easingFunctions = {
    /**
   * Provides no easing and no acceleration.
   *
   * @param t - Time.
   * @returns Value at time t.
   */ linear: function linear(t) {
        return t;
    },
    /**
   * Accelerate from zero velocity.
   *
   * @param t - Time.
   * @returns Value at time t.
   */ easeInQuad: function easeInQuad(t) {
        return t * t;
    },
    /**
   * Decelerate to zero velocity.
   *
   * @param t - Time.
   * @returns Value at time t.
   */ easeOutQuad: function easeOutQuad(t) {
        return t * (2 - t);
    },
    /**
   * Accelerate until halfway, then decelerate.
   *
   * @param t - Time.
   * @returns Value at time t.
   */ easeInOutQuad: function easeInOutQuad(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
    /**
   * Accelerate from zero velocity.
   *
   * @param t - Time.
   * @returns Value at time t.
   */ easeInCubic: function easeInCubic(t) {
        return t * t * t;
    },
    /**
   * Decelerate to zero velocity.
   *
   * @param t - Time.
   * @returns Value at time t.
   */ easeOutCubic: function easeOutCubic(t) {
        return --t * t * t + 1;
    },
    /**
   * Accelerate until halfway, then decelerate.
   *
   * @param t - Time.
   * @returns Value at time t.
   */ easeInOutCubic: function easeInOutCubic(t) {
        return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    },
    /**
   * Accelerate from zero velocity.
   *
   * @param t - Time.
   * @returns Value at time t.
   */ easeInQuart: function easeInQuart(t) {
        return t * t * t * t;
    },
    /**
   * Decelerate to zero velocity.
   *
   * @param t - Time.
   * @returns Value at time t.
   */ easeOutQuart: function easeOutQuart(t) {
        return 1 - --t * t * t * t;
    },
    /**
   * Accelerate until halfway, then decelerate.
   *
   * @param t - Time.
   * @returns Value at time t.
   */ easeInOutQuart: function easeInOutQuart(t) {
        return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
    },
    /**
   * Accelerate from zero velocity.
   *
   * @param t - Time.
   * @returns Value at time t.
   */ easeInQuint: function easeInQuint(t) {
        return t * t * t * t * t;
    },
    /**
   * Decelerate to zero velocity.
   *
   * @param t - Time.
   * @returns Value at time t.
   */ easeOutQuint: function easeOutQuint(t) {
        return 1 + --t * t * t * t * t;
    },
    /**
   * Accelerate until halfway, then decelerate.
   *
   * @param t - Time.
   * @returns Value at time t.
   */ easeInOutQuint: function easeInOutQuint(t) {
        return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
    }
};
// @TODO: This doesn't work properly.
// It works only for single property objects,
// otherwise it combines all of the types in a union.
// export function topMost<K1 extends string, V1> (
//   pile: Record<K1, undefined | V1>[],
//   accessors: K1 | [K1]
// ): undefined | V1
// export function topMost<K1 extends string, K2 extends string, V1, V2> (
//   pile: Record<K1, undefined | V1 | Record<K2, undefined | V2>>[],
//   accessors: [K1, K2]
// ): undefined | V1 | V2
// export function topMost<K1 extends string, K2 extends string, K3 extends string, V1, V2, V3> (
//   pile: Record<K1, undefined | V1 | Record<K2, undefined | V2 | Record<K3, undefined | V3>>>[],
//   accessors: [K1, K2, K3]
// ): undefined | V1 | V2 | V3
/**
 * Get the top most property value from a pile of objects.
 *
 * @param pile - Array of objects, no required format.
 * @param accessors - Array of property names.
 * For example `object['foo']['bar']` → `['foo', 'bar']`.
 * @returns Value of the property with given accessors path from the first pile item where it's not undefined.
 */ function $bebd28704f2536ea$var$topMost(pile, accessors) {
    var candidate;
    if (!$bebd28704f2536ea$var$_Array$isArray(accessors)) accessors = [
        accessors
    ];
    var _iterator3 = $bebd28704f2536ea$var$_createForOfIteratorHelper$6(pile), _step3;
    try {
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
            var member = _step3.value;
            if (member) {
                candidate = member[accessors[0]];
                for(var i = 1; i < accessors.length; i++)if (candidate) candidate = candidate[accessors[i]];
                if (typeof candidate !== "undefined") break;
            }
        }
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
    return candidate;
}
var $bebd28704f2536ea$var$htmlColors = {
    black: "#000000",
    navy: "#000080",
    darkblue: "#00008B",
    mediumblue: "#0000CD",
    blue: "#0000FF",
    darkgreen: "#006400",
    green: "#008000",
    teal: "#008080",
    darkcyan: "#008B8B",
    deepskyblue: "#00BFFF",
    darkturquoise: "#00CED1",
    mediumspringgreen: "#00FA9A",
    lime: "#00FF00",
    springgreen: "#00FF7F",
    aqua: "#00FFFF",
    cyan: "#00FFFF",
    midnightblue: "#191970",
    dodgerblue: "#1E90FF",
    lightseagreen: "#20B2AA",
    forestgreen: "#228B22",
    seagreen: "#2E8B57",
    darkslategray: "#2F4F4F",
    limegreen: "#32CD32",
    mediumseagreen: "#3CB371",
    turquoise: "#40E0D0",
    royalblue: "#4169E1",
    steelblue: "#4682B4",
    darkslateblue: "#483D8B",
    mediumturquoise: "#48D1CC",
    indigo: "#4B0082",
    darkolivegreen: "#556B2F",
    cadetblue: "#5F9EA0",
    cornflowerblue: "#6495ED",
    mediumaquamarine: "#66CDAA",
    dimgray: "#696969",
    slateblue: "#6A5ACD",
    olivedrab: "#6B8E23",
    slategray: "#708090",
    lightslategray: "#778899",
    mediumslateblue: "#7B68EE",
    lawngreen: "#7CFC00",
    chartreuse: "#7FFF00",
    aquamarine: "#7FFFD4",
    maroon: "#800000",
    purple: "#800080",
    olive: "#808000",
    gray: "#808080",
    skyblue: "#87CEEB",
    lightskyblue: "#87CEFA",
    blueviolet: "#8A2BE2",
    darkred: "#8B0000",
    darkmagenta: "#8B008B",
    saddlebrown: "#8B4513",
    darkseagreen: "#8FBC8F",
    lightgreen: "#90EE90",
    mediumpurple: "#9370D8",
    darkviolet: "#9400D3",
    palegreen: "#98FB98",
    darkorchid: "#9932CC",
    yellowgreen: "#9ACD32",
    sienna: "#A0522D",
    brown: "#A52A2A",
    darkgray: "#A9A9A9",
    lightblue: "#ADD8E6",
    greenyellow: "#ADFF2F",
    paleturquoise: "#AFEEEE",
    lightsteelblue: "#B0C4DE",
    powderblue: "#B0E0E6",
    firebrick: "#B22222",
    darkgoldenrod: "#B8860B",
    mediumorchid: "#BA55D3",
    rosybrown: "#BC8F8F",
    darkkhaki: "#BDB76B",
    silver: "#C0C0C0",
    mediumvioletred: "#C71585",
    indianred: "#CD5C5C",
    peru: "#CD853F",
    chocolate: "#D2691E",
    tan: "#D2B48C",
    lightgrey: "#D3D3D3",
    palevioletred: "#D87093",
    thistle: "#D8BFD8",
    orchid: "#DA70D6",
    goldenrod: "#DAA520",
    crimson: "#DC143C",
    gainsboro: "#DCDCDC",
    plum: "#DDA0DD",
    burlywood: "#DEB887",
    lightcyan: "#E0FFFF",
    lavender: "#E6E6FA",
    darksalmon: "#E9967A",
    violet: "#EE82EE",
    palegoldenrod: "#EEE8AA",
    lightcoral: "#F08080",
    khaki: "#F0E68C",
    aliceblue: "#F0F8FF",
    honeydew: "#F0FFF0",
    azure: "#F0FFFF",
    sandybrown: "#F4A460",
    wheat: "#F5DEB3",
    beige: "#F5F5DC",
    whitesmoke: "#F5F5F5",
    mintcream: "#F5FFFA",
    ghostwhite: "#F8F8FF",
    salmon: "#FA8072",
    antiquewhite: "#FAEBD7",
    linen: "#FAF0E6",
    lightgoldenrodyellow: "#FAFAD2",
    oldlace: "#FDF5E6",
    red: "#FF0000",
    fuchsia: "#FF00FF",
    magenta: "#FF00FF",
    deeppink: "#FF1493",
    orangered: "#FF4500",
    tomato: "#FF6347",
    hotpink: "#FF69B4",
    coral: "#FF7F50",
    darkorange: "#FF8C00",
    lightsalmon: "#FFA07A",
    orange: "#FFA500",
    lightpink: "#FFB6C1",
    pink: "#FFC0CB",
    gold: "#FFD700",
    peachpuff: "#FFDAB9",
    navajowhite: "#FFDEAD",
    moccasin: "#FFE4B5",
    bisque: "#FFE4C4",
    mistyrose: "#FFE4E1",
    blanchedalmond: "#FFEBCD",
    papayawhip: "#FFEFD5",
    lavenderblush: "#FFF0F5",
    seashell: "#FFF5EE",
    cornsilk: "#FFF8DC",
    lemonchiffon: "#FFFACD",
    floralwhite: "#FFFAF0",
    snow: "#FFFAFA",
    yellow: "#FFFF00",
    lightyellow: "#FFFFE0",
    ivory: "#FFFFF0",
    white: "#FFFFFF"
};
/**
 * @param {number} [pixelRatio=1]
 */ var $bebd28704f2536ea$var$ColorPicker$1 = /*#__PURE__*/ function() {
    /**
   * @param {number} [pixelRatio=1]
   */ function ColorPicker() {
        var pixelRatio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        $bebd28704f2536ea$var$_classCallCheck(this, ColorPicker);
        this.pixelRatio = pixelRatio;
        this.generated = false;
        this.centerCoordinates = {
            x: 144.5,
            y: 144.5
        };
        this.r = 289 * 0.49;
        this.color = {
            r: 255,
            g: 255,
            b: 255,
            a: 1.0
        };
        this.hueCircle = undefined;
        this.initialColor = {
            r: 255,
            g: 255,
            b: 255,
            a: 1.0
        };
        this.previousColor = undefined;
        this.applied = false;
        // bound by
        this.updateCallback = function() {};
        this.closeCallback = function() {};
        // create all DOM elements
        this._create();
    }
    /**
   * this inserts the colorPicker into a div from the DOM
   *
   * @param {Element} container
   */ $bebd28704f2536ea$var$_createClass(ColorPicker, [
        {
            key: "insertTo",
            value: function insertTo(container) {
                if (this.hammer !== undefined) {
                    this.hammer.destroy();
                    this.hammer = undefined;
                }
                this.container = container;
                this.container.appendChild(this.frame);
                this._bindHammer();
                this._setSize();
            }
        },
        {
            key: "setUpdateCallback",
            value: function setUpdateCallback(callback) {
                if (typeof callback === "function") this.updateCallback = callback;
                else throw new Error("Function attempted to set as colorPicker update callback is not a function.");
            }
        },
        {
            key: "setCloseCallback",
            value: function setCloseCallback(callback) {
                if (typeof callback === "function") this.closeCallback = callback;
                else throw new Error("Function attempted to set as colorPicker closing callback is not a function.");
            }
        },
        {
            key: "_isColorString",
            value: function _isColorString(color) {
                if (typeof color === "string") return $bebd28704f2536ea$var$htmlColors[color];
            }
        },
        {
            key: "setColor",
            value: function setColor(color) {
                var setInitial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                if (color === "none") return;
                var rgba;
                // if a html color shorthand is used, convert to hex
                var htmlColor = this._isColorString(color);
                if (htmlColor !== undefined) color = htmlColor;
                // check format
                if ($bebd28704f2536ea$var$isString(color) === true) {
                    if ($bebd28704f2536ea$var$isValidRGB(color) === true) {
                        var rgbaArray = color.substr(4).substr(0, color.length - 5).split(",");
                        rgba = {
                            r: rgbaArray[0],
                            g: rgbaArray[1],
                            b: rgbaArray[2],
                            a: 1.0
                        };
                    } else if ($bebd28704f2536ea$var$isValidRGBA(color) === true) {
                        var _rgbaArray = color.substr(5).substr(0, color.length - 6).split(",");
                        rgba = {
                            r: _rgbaArray[0],
                            g: _rgbaArray[1],
                            b: _rgbaArray[2],
                            a: _rgbaArray[3]
                        };
                    } else if ($bebd28704f2536ea$var$isValidHex(color) === true) {
                        var rgbObj = $bebd28704f2536ea$var$hexToRGB(color);
                        rgba = {
                            r: rgbObj.r,
                            g: rgbObj.g,
                            b: rgbObj.b,
                            a: 1.0
                        };
                    }
                } else {
                    if (color instanceof Object) {
                        if (color.r !== undefined && color.g !== undefined && color.b !== undefined) {
                            var alpha = color.a !== undefined ? color.a : "1.0";
                            rgba = {
                                r: color.r,
                                g: color.g,
                                b: color.b,
                                a: alpha
                            };
                        }
                    }
                }
                // set color
                if (rgba === undefined) throw new Error("Unknown color passed to the colorPicker. Supported are strings: rgb, hex, rgba. Object: rgb ({r:r,g:g,b:b,[a:a]}). Supplied: " + $bebd28704f2536ea$var$_JSON$stringify(color));
                else this._setColor(rgba, setInitial);
            }
        },
        {
            key: "show",
            value: function show() {
                if (this.closeCallback !== undefined) {
                    this.closeCallback();
                    this.closeCallback = undefined;
                }
                this.applied = false;
                this.frame.style.display = "block";
                this._generateHueCircle();
            }
        },
        {
            key: "_hide",
            value: function _hide() {
                var _this2 = this;
                var storePrevious = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                // store the previous color for next time;
                if (storePrevious === true) this.previousColor = $bebd28704f2536ea$var$_Object$assign({}, this.color);
                if (this.applied === true) this.updateCallback(this.initialColor);
                this.frame.style.display = "none";
                // call the closing callback, restoring the onclick method.
                // this is in a setTimeout because it will trigger the show again before the click is done.
                $bebd28704f2536ea$var$_setTimeout(function() {
                    if (_this2.closeCallback !== undefined) {
                        _this2.closeCallback();
                        _this2.closeCallback = undefined;
                    }
                }, 0);
            }
        },
        {
            key: "_save",
            value: function _save() {
                this.updateCallback(this.color);
                this.applied = false;
                this._hide();
            }
        },
        {
            key: "_apply",
            value: function _apply() {
                this.applied = true;
                this.updateCallback(this.color);
                this._updatePicker(this.color);
            }
        },
        {
            key: "_loadLast",
            value: function _loadLast() {
                if (this.previousColor !== undefined) this.setColor(this.previousColor, false);
                else alert("There is no last color to load...");
            }
        },
        {
            key: "_setColor",
            value: function _setColor(rgba) {
                var setInitial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                // store the initial color
                if (setInitial === true) this.initialColor = $bebd28704f2536ea$var$_Object$assign({}, rgba);
                this.color = rgba;
                var hsv = $bebd28704f2536ea$var$RGBToHSV(rgba.r, rgba.g, rgba.b);
                var angleConvert = 2 * Math.PI;
                var radius = this.r * hsv.s;
                var x = this.centerCoordinates.x + radius * Math.sin(angleConvert * hsv.h);
                var y = this.centerCoordinates.y + radius * Math.cos(angleConvert * hsv.h);
                this.colorPickerSelector.style.left = x - 0.5 * this.colorPickerSelector.clientWidth + "px";
                this.colorPickerSelector.style.top = y - 0.5 * this.colorPickerSelector.clientHeight + "px";
                this._updatePicker(rgba);
            }
        },
        {
            key: "_setOpacity",
            value: function _setOpacity(value) {
                this.color.a = value / 100;
                this._updatePicker(this.color);
            }
        },
        {
            key: "_setBrightness",
            value: function _setBrightness(value) {
                var hsv = $bebd28704f2536ea$var$RGBToHSV(this.color.r, this.color.g, this.color.b);
                hsv.v = value / 100;
                var rgba = $bebd28704f2536ea$var$HSVToRGB(hsv.h, hsv.s, hsv.v);
                rgba["a"] = this.color.a;
                this.color = rgba;
                this._updatePicker();
            }
        },
        {
            key: "_updatePicker",
            value: function _updatePicker() {
                var rgba = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.color;
                var hsv = $bebd28704f2536ea$var$RGBToHSV(rgba.r, rgba.g, rgba.b);
                var ctx = this.colorPickerCanvas.getContext("2d");
                if (this.pixelRation === undefined) this.pixelRatio = (window.devicePixelRatio || 1) / (ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1);
                ctx.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
                // clear the canvas
                var w = this.colorPickerCanvas.clientWidth;
                var h = this.colorPickerCanvas.clientHeight;
                ctx.clearRect(0, 0, w, h);
                ctx.putImageData(this.hueCircle, 0, 0);
                ctx.fillStyle = "rgba(0,0,0," + (1 - hsv.v) + ")";
                ctx.circle(this.centerCoordinates.x, this.centerCoordinates.y, this.r);
                $bebd28704f2536ea$var$_fillInstanceProperty(ctx).call(ctx);
                this.brightnessRange.value = 100 * hsv.v;
                this.opacityRange.value = 100 * rgba.a;
                this.initialColorDiv.style.backgroundColor = "rgba(" + this.initialColor.r + "," + this.initialColor.g + "," + this.initialColor.b + "," + this.initialColor.a + ")";
                this.newColorDiv.style.backgroundColor = "rgba(" + this.color.r + "," + this.color.g + "," + this.color.b + "," + this.color.a + ")";
            }
        },
        {
            key: "_setSize",
            value: function _setSize() {
                this.colorPickerCanvas.style.width = "100%";
                this.colorPickerCanvas.style.height = "100%";
                this.colorPickerCanvas.width = 289 * this.pixelRatio;
                this.colorPickerCanvas.height = 289 * this.pixelRatio;
            }
        },
        {
            key: "_create",
            value: function _create() {
                var _context12, _context13, _context14, _context15;
                this.frame = document.createElement("div");
                this.frame.className = "vis-color-picker";
                this.colorPickerDiv = document.createElement("div");
                this.colorPickerSelector = document.createElement("div");
                this.colorPickerSelector.className = "vis-selector";
                this.colorPickerDiv.appendChild(this.colorPickerSelector);
                this.colorPickerCanvas = document.createElement("canvas");
                this.colorPickerDiv.appendChild(this.colorPickerCanvas);
                if (!this.colorPickerCanvas.getContext) {
                    var noCanvas = document.createElement("DIV");
                    noCanvas.style.color = "red";
                    noCanvas.style.fontWeight = "bold";
                    noCanvas.style.padding = "10px";
                    noCanvas.innerText = "Error: your browser does not support HTML canvas";
                    this.colorPickerCanvas.appendChild(noCanvas);
                } else {
                    var ctx = this.colorPickerCanvas.getContext("2d");
                    this.pixelRatio = (window.devicePixelRatio || 1) / (ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1);
                    this.colorPickerCanvas.getContext("2d").setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
                }
                this.colorPickerDiv.className = "vis-color";
                this.opacityDiv = document.createElement("div");
                this.opacityDiv.className = "vis-opacity";
                this.brightnessDiv = document.createElement("div");
                this.brightnessDiv.className = "vis-brightness";
                this.arrowDiv = document.createElement("div");
                this.arrowDiv.className = "vis-arrow";
                this.opacityRange = document.createElement("input");
                try {
                    this.opacityRange.type = "range"; // Not supported on IE9
                    this.opacityRange.min = "0";
                    this.opacityRange.max = "100";
                } catch (err) {
                // TODO: Add some error handling.
                }
                this.opacityRange.value = "100";
                this.opacityRange.className = "vis-range";
                this.brightnessRange = document.createElement("input");
                try {
                    this.brightnessRange.type = "range"; // Not supported on IE9
                    this.brightnessRange.min = "0";
                    this.brightnessRange.max = "100";
                } catch (err) {
                // TODO: Add some error handling.
                }
                this.brightnessRange.value = "100";
                this.brightnessRange.className = "vis-range";
                this.opacityDiv.appendChild(this.opacityRange);
                this.brightnessDiv.appendChild(this.brightnessRange);
                var me = this;
                this.opacityRange.onchange = function() {
                    me._setOpacity(this.value);
                };
                this.opacityRange.oninput = function() {
                    me._setOpacity(this.value);
                };
                this.brightnessRange.onchange = function() {
                    me._setBrightness(this.value);
                };
                this.brightnessRange.oninput = function() {
                    me._setBrightness(this.value);
                };
                this.brightnessLabel = document.createElement("div");
                this.brightnessLabel.className = "vis-label vis-brightness";
                this.brightnessLabel.innerText = "brightness:";
                this.opacityLabel = document.createElement("div");
                this.opacityLabel.className = "vis-label vis-opacity";
                this.opacityLabel.innerText = "opacity:";
                this.newColorDiv = document.createElement("div");
                this.newColorDiv.className = "vis-new-color";
                this.newColorDiv.innerText = "new";
                this.initialColorDiv = document.createElement("div");
                this.initialColorDiv.className = "vis-initial-color";
                this.initialColorDiv.innerText = "initial";
                this.cancelButton = document.createElement("div");
                this.cancelButton.className = "vis-button vis-cancel";
                this.cancelButton.innerText = "cancel";
                this.cancelButton.onclick = $bebd28704f2536ea$var$_bindInstanceProperty$1(_context12 = this._hide).call(_context12, this, false);
                this.applyButton = document.createElement("div");
                this.applyButton.className = "vis-button vis-apply";
                this.applyButton.innerText = "apply";
                this.applyButton.onclick = $bebd28704f2536ea$var$_bindInstanceProperty$1(_context13 = this._apply).call(_context13, this);
                this.saveButton = document.createElement("div");
                this.saveButton.className = "vis-button vis-save";
                this.saveButton.innerText = "save";
                this.saveButton.onclick = $bebd28704f2536ea$var$_bindInstanceProperty$1(_context14 = this._save).call(_context14, this);
                this.loadButton = document.createElement("div");
                this.loadButton.className = "vis-button vis-load";
                this.loadButton.innerText = "load last";
                this.loadButton.onclick = $bebd28704f2536ea$var$_bindInstanceProperty$1(_context15 = this._loadLast).call(_context15, this);
                this.frame.appendChild(this.colorPickerDiv);
                this.frame.appendChild(this.arrowDiv);
                this.frame.appendChild(this.brightnessLabel);
                this.frame.appendChild(this.brightnessDiv);
                this.frame.appendChild(this.opacityLabel);
                this.frame.appendChild(this.opacityDiv);
                this.frame.appendChild(this.newColorDiv);
                this.frame.appendChild(this.initialColorDiv);
                this.frame.appendChild(this.cancelButton);
                this.frame.appendChild(this.applyButton);
                this.frame.appendChild(this.saveButton);
                this.frame.appendChild(this.loadButton);
            }
        },
        {
            key: "_bindHammer",
            value: function _bindHammer() {
                var _this3 = this;
                this.drag = {};
                this.pinch = {};
                this.hammer = new $bebd28704f2536ea$var$Hammer$1(this.colorPickerCanvas);
                this.hammer.get("pinch").set({
                    enable: true
                });
                this.hammer.on("hammer.input", function(event) {
                    if (event.isFirst) _this3._moveSelector(event);
                });
                this.hammer.on("tap", function(event) {
                    _this3._moveSelector(event);
                });
                this.hammer.on("panstart", function(event) {
                    _this3._moveSelector(event);
                });
                this.hammer.on("panmove", function(event) {
                    _this3._moveSelector(event);
                });
                this.hammer.on("panend", function(event) {
                    _this3._moveSelector(event);
                });
            }
        },
        {
            key: "_generateHueCircle",
            value: function _generateHueCircle() {
                if (this.generated === false) {
                    var ctx = this.colorPickerCanvas.getContext("2d");
                    if (this.pixelRation === undefined) this.pixelRatio = (window.devicePixelRatio || 1) / (ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1);
                    ctx.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
                    // clear the canvas
                    var w = this.colorPickerCanvas.clientWidth;
                    var h = this.colorPickerCanvas.clientHeight;
                    ctx.clearRect(0, 0, w, h);
                    // draw hue circle
                    var x, y, hue, sat;
                    this.centerCoordinates = {
                        x: w * 0.5,
                        y: h * 0.5
                    };
                    this.r = 0.49 * w;
                    var angleConvert = 2 * Math.PI / 360;
                    var hfac = 1 / 360;
                    var sfac = 1 / this.r;
                    var rgb;
                    for(hue = 0; hue < 360; hue++)for(sat = 0; sat < this.r; sat++){
                        x = this.centerCoordinates.x + sat * Math.sin(angleConvert * hue);
                        y = this.centerCoordinates.y + sat * Math.cos(angleConvert * hue);
                        rgb = $bebd28704f2536ea$var$HSVToRGB(hue * hfac, sat * sfac, 1);
                        ctx.fillStyle = "rgb(" + rgb.r + "," + rgb.g + "," + rgb.b + ")";
                        ctx.fillRect(x - 0.5, y - 0.5, 2, 2);
                    }
                    ctx.strokeStyle = "rgba(0,0,0,1)";
                    ctx.circle(this.centerCoordinates.x, this.centerCoordinates.y, this.r);
                    ctx.stroke();
                    this.hueCircle = ctx.getImageData(0, 0, w, h);
                }
                this.generated = true;
            }
        },
        {
            key: "_moveSelector",
            value: function _moveSelector(event) {
                var rect = this.colorPickerDiv.getBoundingClientRect();
                var left = event.center.x - rect.left;
                var top = event.center.y - rect.top;
                var centerY = 0.5 * this.colorPickerDiv.clientHeight;
                var centerX = 0.5 * this.colorPickerDiv.clientWidth;
                var x = left - centerX;
                var y = top - centerY;
                var angle = Math.atan2(x, y);
                var radius = 0.98 * Math.min(Math.sqrt(x * x + y * y), centerX);
                var newTop = Math.cos(angle) * radius + centerY;
                var newLeft = Math.sin(angle) * radius + centerX;
                this.colorPickerSelector.style.top = newTop - 0.5 * this.colorPickerSelector.clientHeight + "px";
                this.colorPickerSelector.style.left = newLeft - 0.5 * this.colorPickerSelector.clientWidth + "px";
                // set color
                var h = angle / (2 * Math.PI);
                h = h < 0 ? h + 1 : h;
                var s = radius / this.r;
                var hsv = $bebd28704f2536ea$var$RGBToHSV(this.color.r, this.color.g, this.color.b);
                hsv.h = h;
                hsv.s = s;
                var rgba = $bebd28704f2536ea$var$HSVToRGB(hsv.h, hsv.s, hsv.v);
                rgba["a"] = this.color.a;
                this.color = rgba;
                // update previews
                this.initialColorDiv.style.backgroundColor = "rgba(" + this.initialColor.r + "," + this.initialColor.g + "," + this.initialColor.b + "," + this.initialColor.a + ")";
                this.newColorDiv.style.backgroundColor = "rgba(" + this.color.r + "," + this.color.g + "," + this.color.b + "," + this.color.a + ")";
            }
        }
    ]);
    return ColorPicker;
}();
/**
 * Wrap given text (last argument) in HTML elements (all preceding arguments).
 *
 * @param {...any} rest - List of tag names followed by inner text.
 * @returns An element or a text node.
 */ function $bebd28704f2536ea$var$wrapInTag() {
    for(var _len5 = arguments.length, rest = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)rest[_key5] = arguments[_key5];
    if (rest.length < 1) throw new TypeError("Invalid arguments.");
    else if (rest.length === 1) return document.createTextNode(rest[0]);
    else {
        var element = document.createElement(rest[0]);
        element.appendChild($bebd28704f2536ea$var$wrapInTag.apply(void 0, $bebd28704f2536ea$var$_toConsumableArray($bebd28704f2536ea$var$_sliceInstanceProperty(rest).call(rest, 1))));
        return element;
    }
}
/**
 * The way this works is for all properties of this.possible options, you can supply the property name in any form to list the options.
 * Boolean options are recognised as Boolean
 * Number options should be written as array: [default value, min value, max value, stepsize]
 * Colors should be written as array: ['color', '#ffffff']
 * Strings with should be written as array: [option1, option2, option3, ..]
 *
 * The options are matched with their counterparts in each of the modules and the values used in the configuration are
 */ var $bebd28704f2536ea$var$Configurator$1 = /*#__PURE__*/ function() {
    /**
   * @param {object} parentModule        | the location where parentModule.setOptions() can be called
   * @param {object} defaultContainer    | the default container of the module
   * @param {object} configureOptions    | the fully configured and predefined options set found in allOptions.js
   * @param {number} pixelRatio          | canvas pixel ratio
   * @param {Function} hideOption        | custom logic to dynamically hide options
   */ function Configurator(parentModule, defaultContainer, configureOptions) {
        var pixelRatio = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
        var hideOption = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function() {
            return false;
        };
        $bebd28704f2536ea$var$_classCallCheck(this, Configurator);
        this.parent = parentModule;
        this.changedOptions = [];
        this.container = defaultContainer;
        this.allowCreation = false;
        this.hideOption = hideOption;
        this.options = {};
        this.initialized = false;
        this.popupCounter = 0;
        this.defaultOptions = {
            enabled: false,
            filter: true,
            container: undefined,
            showButton: true
        };
        $bebd28704f2536ea$var$_Object$assign(this.options, this.defaultOptions);
        this.configureOptions = configureOptions;
        this.moduleOptions = {};
        this.domElements = [];
        this.popupDiv = {};
        this.popupLimit = 5;
        this.popupHistory = {};
        this.colorPicker = new $bebd28704f2536ea$var$ColorPicker$1(pixelRatio);
        this.wrapper = undefined;
    }
    /**
   * refresh all options.
   * Because all modules parse their options by themselves, we just use their options. We copy them here.
   *
   * @param {object} options
   */ $bebd28704f2536ea$var$_createClass(Configurator, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                if (options !== undefined) {
                    // reset the popup history because the indices may have been changed.
                    this.popupHistory = {};
                    this._removePopup();
                    var enabled = true;
                    if (typeof options === "string") this.options.filter = options;
                    else if ($bebd28704f2536ea$var$_Array$isArray(options)) this.options.filter = options.join();
                    else if ($bebd28704f2536ea$var$_typeof(options) === "object") {
                        if (options == null) throw new TypeError("options cannot be null");
                        if (options.container !== undefined) this.options.container = options.container;
                        if ($bebd28704f2536ea$var$_filterInstanceProperty(options) !== undefined) this.options.filter = $bebd28704f2536ea$var$_filterInstanceProperty(options);
                        if (options.showButton !== undefined) this.options.showButton = options.showButton;
                        if (options.enabled !== undefined) enabled = options.enabled;
                    } else if (typeof options === "boolean") {
                        this.options.filter = true;
                        enabled = options;
                    } else if (typeof options === "function") {
                        this.options.filter = options;
                        enabled = true;
                    }
                    if ($bebd28704f2536ea$var$_filterInstanceProperty(this.options) === false) enabled = false;
                    this.options.enabled = enabled;
                }
                this._clean();
            }
        },
        {
            key: "setModuleOptions",
            value: function setModuleOptions(moduleOptions) {
                this.moduleOptions = moduleOptions;
                if (this.options.enabled === true) {
                    this._clean();
                    if (this.options.container !== undefined) this.container = this.options.container;
                    this._create();
                }
            }
        },
        {
            key: "_create",
            value: function _create() {
                this._clean();
                this.changedOptions = [];
                var filter = $bebd28704f2536ea$var$_filterInstanceProperty(this.options);
                var counter = 0;
                var show = false;
                for(var _option in this.configureOptions)if (Object.prototype.hasOwnProperty.call(this.configureOptions, _option)) {
                    this.allowCreation = false;
                    show = false;
                    if (typeof filter === "function") {
                        show = filter(_option, []);
                        show = show || this._handleObject(this.configureOptions[_option], [
                            _option
                        ], true);
                    } else if (filter === true || $bebd28704f2536ea$var$_indexOfInstanceProperty(filter).call(filter, _option) !== -1) show = true;
                    if (show !== false) {
                        this.allowCreation = true;
                        // linebreak between categories
                        if (counter > 0) this._makeItem([]);
                        // a header for the category
                        this._makeHeader(_option);
                        // get the sub options
                        this._handleObject(this.configureOptions[_option], [
                            _option
                        ]);
                    }
                    counter++;
                }
                this._makeButton();
                this._push();
            //~ this.colorPicker.insertTo(this.container);
            }
        },
        {
            key: "_push",
            value: function _push() {
                this.wrapper = document.createElement("div");
                this.wrapper.className = "vis-configuration-wrapper";
                this.container.appendChild(this.wrapper);
                for(var i = 0; i < this.domElements.length; i++)this.wrapper.appendChild(this.domElements[i]);
                this._showPopupIfNeeded();
            }
        },
        {
            key: "_clean",
            value: function _clean() {
                for(var i = 0; i < this.domElements.length; i++)this.wrapper.removeChild(this.domElements[i]);
                if (this.wrapper !== undefined) {
                    this.container.removeChild(this.wrapper);
                    this.wrapper = undefined;
                }
                this.domElements = [];
                this._removePopup();
            }
        },
        {
            key: "_getValue",
            value: function _getValue(path) {
                var base = this.moduleOptions;
                for(var i = 0; i < path.length; i++)if (base[path[i]] !== undefined) base = base[path[i]];
                else {
                    base = undefined;
                    break;
                }
                return base;
            }
        },
        {
            key: "_makeItem",
            value: function _makeItem(path) {
                if (this.allowCreation === true) {
                    var item = document.createElement("div");
                    item.className = "vis-configuration vis-config-item vis-config-s" + path.length;
                    for(var _len6 = arguments.length, domElements = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++)domElements[_key6 - 1] = arguments[_key6];
                    $bebd28704f2536ea$var$_forEachInstanceProperty(domElements).call(domElements, function(element) {
                        item.appendChild(element);
                    });
                    this.domElements.push(item);
                    return this.domElements.length;
                }
                return 0;
            }
        },
        {
            key: "_makeHeader",
            value: function _makeHeader(name) {
                var div = document.createElement("div");
                div.className = "vis-configuration vis-config-header";
                div.innerText = name;
                this._makeItem([], div);
            }
        },
        {
            key: "_makeLabel",
            value: function _makeLabel(name, path) {
                var objectLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var div = document.createElement("div");
                div.className = "vis-configuration vis-config-label vis-config-s" + path.length;
                if (objectLabel === true) {
                    while(div.firstChild)div.removeChild(div.firstChild);
                    div.appendChild($bebd28704f2536ea$var$wrapInTag("i", "b", name));
                } else div.innerText = name + ":";
                return div;
            }
        },
        {
            key: "_makeDropdown",
            value: function _makeDropdown(arr, value, path) {
                var select = document.createElement("select");
                select.className = "vis-configuration vis-config-select";
                var selectedValue = 0;
                if (value !== undefined) {
                    if ($bebd28704f2536ea$var$_indexOfInstanceProperty(arr).call(arr, value) !== -1) selectedValue = $bebd28704f2536ea$var$_indexOfInstanceProperty(arr).call(arr, value);
                }
                for(var i = 0; i < arr.length; i++){
                    var _option2 = document.createElement("option");
                    _option2.value = arr[i];
                    if (i === selectedValue) _option2.selected = "selected";
                    _option2.innerText = arr[i];
                    select.appendChild(_option2);
                }
                var me = this;
                select.onchange = function() {
                    me._update(this.value, path);
                };
                var label = this._makeLabel(path[path.length - 1], path);
                this._makeItem(path, label, select);
            }
        },
        {
            key: "_makeRange",
            value: function _makeRange(arr, value, path) {
                var defaultValue = arr[0];
                var min = arr[1];
                var max = arr[2];
                var step = arr[3];
                var range = document.createElement("input");
                range.className = "vis-configuration vis-config-range";
                try {
                    range.type = "range"; // not supported on IE9
                    range.min = min;
                    range.max = max;
                } catch (err) {
                // TODO: Add some error handling.
                }
                range.step = step;
                // set up the popup settings in case they are needed.
                var popupString = "";
                var popupValue = 0;
                if (value !== undefined) {
                    var factor = 1.2;
                    if (value < 0 && value * factor < min) {
                        range.min = Math.ceil(value * factor);
                        popupValue = range.min;
                        popupString = "range increased";
                    } else if (value / factor < min) {
                        range.min = Math.ceil(value / factor);
                        popupValue = range.min;
                        popupString = "range increased";
                    }
                    if (value * factor > max && max !== 1) {
                        range.max = Math.ceil(value * factor);
                        popupValue = range.max;
                        popupString = "range increased";
                    }
                    range.value = value;
                } else range.value = defaultValue;
                var input = document.createElement("input");
                input.className = "vis-configuration vis-config-rangeinput";
                input.value = range.value;
                var me = this;
                range.onchange = function() {
                    input.value = this.value;
                    me._update(Number(this.value), path);
                };
                range.oninput = function() {
                    input.value = this.value;
                };
                var label = this._makeLabel(path[path.length - 1], path);
                var itemIndex = this._makeItem(path, label, range, input);
                // if a popup is needed AND it has not been shown for this value, show it.
                if (popupString !== "" && this.popupHistory[itemIndex] !== popupValue) {
                    this.popupHistory[itemIndex] = popupValue;
                    this._setupPopup(popupString, itemIndex);
                }
            }
        },
        {
            key: "_makeButton",
            value: function _makeButton() {
                var _this4 = this;
                if (this.options.showButton === true) {
                    var generateButton = document.createElement("div");
                    generateButton.className = "vis-configuration vis-config-button";
                    generateButton.innerText = "generate options";
                    generateButton.onclick = function() {
                        _this4._printOptions();
                    };
                    generateButton.onmouseover = function() {
                        generateButton.className = "vis-configuration vis-config-button hover";
                    };
                    generateButton.onmouseout = function() {
                        generateButton.className = "vis-configuration vis-config-button";
                    };
                    this.optionsContainer = document.createElement("div");
                    this.optionsContainer.className = "vis-configuration vis-config-option-container";
                    this.domElements.push(this.optionsContainer);
                    this.domElements.push(generateButton);
                }
            }
        },
        {
            key: "_setupPopup",
            value: function _setupPopup(string, index) {
                var _this5 = this;
                if (this.initialized === true && this.allowCreation === true && this.popupCounter < this.popupLimit) {
                    var div = document.createElement("div");
                    div.id = "vis-configuration-popup";
                    div.className = "vis-configuration-popup";
                    div.innerText = string;
                    div.onclick = function() {
                        _this5._removePopup();
                    };
                    this.popupCounter += 1;
                    this.popupDiv = {
                        html: div,
                        index: index
                    };
                }
            }
        },
        {
            key: "_removePopup",
            value: function _removePopup() {
                if (this.popupDiv.html !== undefined) {
                    this.popupDiv.html.parentNode.removeChild(this.popupDiv.html);
                    clearTimeout(this.popupDiv.hideTimeout);
                    clearTimeout(this.popupDiv.deleteTimeout);
                    this.popupDiv = {};
                }
            }
        },
        {
            key: "_showPopupIfNeeded",
            value: function _showPopupIfNeeded() {
                var _this6 = this;
                if (this.popupDiv.html !== undefined) {
                    var correspondingElement = this.domElements[this.popupDiv.index];
                    var rect = correspondingElement.getBoundingClientRect();
                    this.popupDiv.html.style.left = rect.left + "px";
                    this.popupDiv.html.style.top = rect.top - 30 + "px"; // 30 is the height;
                    document.body.appendChild(this.popupDiv.html);
                    this.popupDiv.hideTimeout = $bebd28704f2536ea$var$_setTimeout(function() {
                        _this6.popupDiv.html.style.opacity = 0;
                    }, 1500);
                    this.popupDiv.deleteTimeout = $bebd28704f2536ea$var$_setTimeout(function() {
                        _this6._removePopup();
                    }, 1800);
                }
            }
        },
        {
            key: "_makeCheckbox",
            value: function _makeCheckbox(defaultValue, value, path) {
                var checkbox = document.createElement("input");
                checkbox.type = "checkbox";
                checkbox.className = "vis-configuration vis-config-checkbox";
                checkbox.checked = defaultValue;
                if (value !== undefined) {
                    checkbox.checked = value;
                    if (value !== defaultValue) {
                        if ($bebd28704f2536ea$var$_typeof(defaultValue) === "object") {
                            if (value !== defaultValue.enabled) this.changedOptions.push({
                                path: path,
                                value: value
                            });
                        } else this.changedOptions.push({
                            path: path,
                            value: value
                        });
                    }
                }
                var me = this;
                checkbox.onchange = function() {
                    me._update(this.checked, path);
                };
                var label = this._makeLabel(path[path.length - 1], path);
                this._makeItem(path, label, checkbox);
            }
        },
        {
            key: "_makeTextInput",
            value: function _makeTextInput(defaultValue, value, path) {
                var checkbox = document.createElement("input");
                checkbox.type = "text";
                checkbox.className = "vis-configuration vis-config-text";
                checkbox.value = value;
                if (value !== defaultValue) this.changedOptions.push({
                    path: path,
                    value: value
                });
                var me = this;
                checkbox.onchange = function() {
                    me._update(this.value, path);
                };
                var label = this._makeLabel(path[path.length - 1], path);
                this._makeItem(path, label, checkbox);
            }
        },
        {
            key: "_makeColorField",
            value: function _makeColorField(arr, value, path) {
                var _this7 = this;
                var defaultColor = arr[1];
                var div = document.createElement("div");
                value = value === undefined ? defaultColor : value;
                if (value !== "none") {
                    div.className = "vis-configuration vis-config-colorBlock";
                    div.style.backgroundColor = value;
                } else div.className = "vis-configuration vis-config-colorBlock none";
                value = value === undefined ? defaultColor : value;
                div.onclick = function() {
                    _this7._showColorPicker(value, div, path);
                };
                var label = this._makeLabel(path[path.length - 1], path);
                this._makeItem(path, label, div);
            }
        },
        {
            key: "_showColorPicker",
            value: function _showColorPicker(value, div, path) {
                var _this8 = this;
                // clear the callback from this div
                div.onclick = function() {};
                this.colorPicker.insertTo(div);
                this.colorPicker.show();
                this.colorPicker.setColor(value);
                this.colorPicker.setUpdateCallback(function(color) {
                    var colorString = "rgba(" + color.r + "," + color.g + "," + color.b + "," + color.a + ")";
                    div.style.backgroundColor = colorString;
                    _this8._update(colorString, path);
                });
                // on close of the colorpicker, restore the callback.
                this.colorPicker.setCloseCallback(function() {
                    div.onclick = function() {
                        _this8._showColorPicker(value, div, path);
                    };
                });
            }
        },
        {
            key: "_handleObject",
            value: function _handleObject(obj) {
                var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                var checkOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var show = false;
                var filter = $bebd28704f2536ea$var$_filterInstanceProperty(this.options);
                var visibleInSet = false;
                for(var subObj in obj)if (Object.prototype.hasOwnProperty.call(obj, subObj)) {
                    show = true;
                    var item = obj[subObj];
                    var newPath = $bebd28704f2536ea$var$copyAndExtendArray(path, subObj);
                    if (typeof filter === "function") {
                        show = filter(subObj, path);
                        // if needed we must go deeper into the object.
                        if (show === false) {
                            if (!$bebd28704f2536ea$var$_Array$isArray(item) && typeof item !== "string" && typeof item !== "boolean" && item instanceof Object) {
                                this.allowCreation = false;
                                show = this._handleObject(item, newPath, true);
                                this.allowCreation = checkOnly === false;
                            }
                        }
                    }
                    if (show !== false) {
                        visibleInSet = true;
                        var value = this._getValue(newPath);
                        if ($bebd28704f2536ea$var$_Array$isArray(item)) this._handleArray(item, value, newPath);
                        else if (typeof item === "string") this._makeTextInput(item, value, newPath);
                        else if (typeof item === "boolean") this._makeCheckbox(item, value, newPath);
                        else if (item instanceof Object) // skip the options that are not enabled
                        {
                            if (!this.hideOption(path, subObj, this.moduleOptions)) {
                                // initially collapse options with an disabled enabled option.
                                if (item.enabled !== undefined) {
                                    var enabledPath = $bebd28704f2536ea$var$copyAndExtendArray(newPath, "enabled");
                                    var enabledValue = this._getValue(enabledPath);
                                    if (enabledValue === true) {
                                        var label = this._makeLabel(subObj, newPath, true);
                                        this._makeItem(newPath, label);
                                        visibleInSet = this._handleObject(item, newPath) || visibleInSet;
                                    } else this._makeCheckbox(item, enabledValue, newPath);
                                } else {
                                    var _label = this._makeLabel(subObj, newPath, true);
                                    this._makeItem(newPath, _label);
                                    visibleInSet = this._handleObject(item, newPath) || visibleInSet;
                                }
                            }
                        } else console.error("dont know how to handle", item, subObj, newPath);
                    }
                }
                return visibleInSet;
            }
        },
        {
            key: "_handleArray",
            value: function _handleArray(arr, value, path) {
                if (typeof arr[0] === "string" && arr[0] === "color") {
                    this._makeColorField(arr, value, path);
                    if (arr[1] !== value) this.changedOptions.push({
                        path: path,
                        value: value
                    });
                } else if (typeof arr[0] === "string") {
                    this._makeDropdown(arr, value, path);
                    if (arr[0] !== value) this.changedOptions.push({
                        path: path,
                        value: value
                    });
                } else if (typeof arr[0] === "number") {
                    this._makeRange(arr, value, path);
                    if (arr[0] !== value) this.changedOptions.push({
                        path: path,
                        value: Number(value)
                    });
                }
            }
        },
        {
            key: "_update",
            value: function _update(value, path) {
                var options = this._constructOptions(value, path);
                if (this.parent.body && this.parent.body.emitter && this.parent.body.emitter.emit) this.parent.body.emitter.emit("configChange", options);
                this.initialized = true;
                this.parent.setOptions(options);
            }
        },
        {
            key: "_constructOptions",
            value: function _constructOptions(value, path) {
                var optionsObj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var pointer = optionsObj;
                // when dropdown boxes can be string or boolean, we typecast it into correct types
                value = value === "true" ? true : value;
                value = value === "false" ? false : value;
                for(var i = 0; i < path.length; i++)if (path[i] !== "global") {
                    if (pointer[path[i]] === undefined) pointer[path[i]] = {};
                    if (i !== path.length - 1) pointer = pointer[path[i]];
                    else pointer[path[i]] = value;
                }
                return optionsObj;
            }
        },
        {
            key: "_printOptions",
            value: function _printOptions() {
                var options = this.getOptions();
                while(this.optionsContainer.firstChild)this.optionsContainer.removeChild(this.optionsContainer.firstChild);
                this.optionsContainer.appendChild($bebd28704f2536ea$var$wrapInTag("pre", "const options = " + $bebd28704f2536ea$var$_JSON$stringify(options, null, 2)));
            }
        },
        {
            key: "getOptions",
            value: function getOptions() {
                var options = {};
                for(var i = 0; i < this.changedOptions.length; i++)this._constructOptions(this.changedOptions[i].value, this.changedOptions[i].path, options);
                return options;
            }
        }
    ]);
    return Configurator;
}();
/**
 * Popup is a class to create a popup window with some text
 */ var $bebd28704f2536ea$var$Popup$1 = /*#__PURE__*/ function() {
    /**
   * @param {Element} container       The container object.
   * @param {string}  overflowMethod  How the popup should act to overflowing ('flip' or 'cap')
   */ function Popup(container, overflowMethod) {
        $bebd28704f2536ea$var$_classCallCheck(this, Popup);
        this.container = container;
        this.overflowMethod = overflowMethod || "cap";
        this.x = 0;
        this.y = 0;
        this.padding = 5;
        this.hidden = false;
        // create the frame
        this.frame = document.createElement("div");
        this.frame.className = "vis-tooltip";
        this.container.appendChild(this.frame);
    }
    /**
   * @param {number} x   Horizontal position of the popup window
   * @param {number} y   Vertical position of the popup window
   */ $bebd28704f2536ea$var$_createClass(Popup, [
        {
            key: "setPosition",
            value: function setPosition(x, y) {
                this.x = $bebd28704f2536ea$var$_parseInt$1(x);
                this.y = $bebd28704f2536ea$var$_parseInt$1(y);
            }
        },
        {
            key: "setText",
            value: function setText(content) {
                if (content instanceof Element) {
                    while(this.frame.firstChild)this.frame.removeChild(this.frame.firstChild);
                    this.frame.appendChild(content);
                } else // String containing literal text, element has to be used for HTML due to
                // XSS risks associated with innerHTML (i.e. prevent XSS by accident).
                this.frame.innerText = content;
            }
        },
        {
            key: "show",
            value: function show(doShow) {
                if (doShow === undefined) doShow = true;
                if (doShow === true) {
                    var height = this.frame.clientHeight;
                    var width = this.frame.clientWidth;
                    var maxHeight = this.frame.parentNode.clientHeight;
                    var maxWidth = this.frame.parentNode.clientWidth;
                    var left = 0, top = 0;
                    if (this.overflowMethod == "flip") {
                        var isLeft = false, isTop = true; // Where around the position it's located
                        if (this.y - height < this.padding) isTop = false;
                        if (this.x + width > maxWidth - this.padding) isLeft = true;
                        if (isLeft) left = this.x - width;
                        else left = this.x;
                        if (isTop) top = this.y - height;
                        else top = this.y;
                    } else {
                        top = this.y - height;
                        if (top + height + this.padding > maxHeight) top = maxHeight - height - this.padding;
                        if (top < this.padding) top = this.padding;
                        left = this.x;
                        if (left + width + this.padding > maxWidth) left = maxWidth - width - this.padding;
                        if (left < this.padding) left = this.padding;
                    }
                    this.frame.style.left = left + "px";
                    this.frame.style.top = top + "px";
                    this.frame.style.visibility = "visible";
                    this.hidden = false;
                } else this.hide();
            }
        },
        {
            key: "hide",
            value: function hide() {
                this.hidden = true;
                this.frame.style.left = "0";
                this.frame.style.top = "0";
                this.frame.style.visibility = "hidden";
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.frame.parentNode.removeChild(this.frame); // Remove element from DOM
            }
        }
    ]);
    return Popup;
}();
var $bebd28704f2536ea$var$errorFound = false;
var $bebd28704f2536ea$var$allOptions$1;
var $bebd28704f2536ea$var$VALIDATOR_PRINT_STYLE$1 = "background: #FFeeee; color: #dd0000";
/**
 *  Used to validate options.
 */ var $bebd28704f2536ea$var$Validator$1 = /*#__PURE__*/ function() {
    function Validator() {
        $bebd28704f2536ea$var$_classCallCheck(this, Validator);
    }
    $bebd28704f2536ea$var$_createClass(Validator, null, [
        {
            key: "validate",
            value: /**
     * Main function to be called
     *
     * @param {object} options
     * @param {object} referenceOptions
     * @param {object} subObject
     * @returns {boolean}
     * @static
     */ function validate(options, referenceOptions, subObject) {
                $bebd28704f2536ea$var$errorFound = false;
                $bebd28704f2536ea$var$allOptions$1 = referenceOptions;
                var usedOptions = referenceOptions;
                if (subObject !== undefined) usedOptions = referenceOptions[subObject];
                Validator.parse(options, usedOptions, []);
                return $bebd28704f2536ea$var$errorFound;
            }
        },
        {
            key: "parse",
            value: function parse(options, referenceOptions, path) {
                for(var _option3 in options)if (Object.prototype.hasOwnProperty.call(options, _option3)) Validator.check(_option3, options, referenceOptions, path);
            }
        },
        {
            key: "check",
            value: function check(option, options, referenceOptions, path) {
                if (referenceOptions[option] === undefined && referenceOptions.__any__ === undefined) {
                    Validator.getSuggestion(option, referenceOptions, path);
                    return;
                }
                var referenceOption = option;
                var is_object = true;
                if (referenceOptions[option] === undefined && referenceOptions.__any__ !== undefined) {
                    // NOTE: This only triggers if the __any__ is in the top level of the options object.
                    //       THAT'S A REALLY BAD PLACE TO ALLOW IT!!!!
                    // TODO: Examine if needed, remove if possible
                    // __any__ is a wildcard. Any value is accepted and will be further analysed by reference.
                    referenceOption = "__any__";
                    // if the any-subgroup is not a predefined object in the configurator,
                    // we do not look deeper into the object.
                    is_object = Validator.getType(options[option]) === "object";
                }
                var refOptionObj = referenceOptions[referenceOption];
                if (is_object && refOptionObj.__type__ !== undefined) refOptionObj = refOptionObj.__type__;
                Validator.checkFields(option, options, referenceOptions, referenceOption, refOptionObj, path);
            }
        },
        {
            key: "checkFields",
            value: function checkFields(option, options, referenceOptions, referenceOption, refOptionObj, path) {
                var log = function log(message) {
                    console.error("%c" + message + Validator.printLocation(path, option), $bebd28704f2536ea$var$VALIDATOR_PRINT_STYLE$1);
                };
                var optionType = Validator.getType(options[option]);
                var refOptionType = refOptionObj[optionType];
                if (refOptionType !== undefined) {
                    // if the type is correct, we check if it is supposed to be one of a few select values
                    if (Validator.getType(refOptionType) === "array" && $bebd28704f2536ea$var$_indexOfInstanceProperty(refOptionType).call(refOptionType, options[option]) === -1) {
                        log('Invalid option detected in "' + option + '".' + " Allowed values are:" + Validator.print(refOptionType) + ' not "' + options[option] + '". ');
                        $bebd28704f2536ea$var$errorFound = true;
                    } else if (optionType === "object" && referenceOption !== "__any__") {
                        path = $bebd28704f2536ea$var$copyAndExtendArray(path, option);
                        Validator.parse(options[option], referenceOptions[referenceOption], path);
                    }
                } else if (refOptionObj["any"] === undefined) {
                    // type of the field is incorrect and the field cannot be any
                    log('Invalid type received for "' + option + '". Expected: ' + Validator.print($bebd28704f2536ea$var$_Object$keys(refOptionObj)) + ". Received [" + optionType + '] "' + options[option] + '"');
                    $bebd28704f2536ea$var$errorFound = true;
                }
            }
        },
        {
            key: "getType",
            value: function getType(object) {
                var type = $bebd28704f2536ea$var$_typeof(object);
                if (type === "object") {
                    if (object === null) return "null";
                    if (object instanceof Boolean) return "boolean";
                    if (object instanceof Number) return "number";
                    if (object instanceof String) return "string";
                    if ($bebd28704f2536ea$var$_Array$isArray(object)) return "array";
                    if (object instanceof Date) return "date";
                    if (object.nodeType !== undefined) return "dom";
                    if (object._isAMomentObject === true) return "moment";
                    return "object";
                } else if (type === "number") return "number";
                else if (type === "boolean") return "boolean";
                else if (type === "string") return "string";
                else if (type === undefined) return "undefined";
                return type;
            }
        },
        {
            key: "getSuggestion",
            value: function getSuggestion(option, options, path) {
                var localSearch = Validator.findInOptions(option, options, path, false);
                var globalSearch = Validator.findInOptions(option, $bebd28704f2536ea$var$allOptions$1, [], true);
                var localSearchThreshold = 8;
                var globalSearchThreshold = 4;
                var msg;
                if (localSearch.indexMatch !== undefined) msg = " in " + Validator.printLocation(localSearch.path, option, "") + 'Perhaps it was incomplete? Did you mean: "' + localSearch.indexMatch + '"?\n\n';
                else if (globalSearch.distance <= globalSearchThreshold && localSearch.distance > globalSearch.distance) msg = " in " + Validator.printLocation(localSearch.path, option, "") + "Perhaps it was misplaced? Matching option found at: " + Validator.printLocation(globalSearch.path, globalSearch.closestMatch, "");
                else if (localSearch.distance <= localSearchThreshold) msg = '. Did you mean "' + localSearch.closestMatch + '"?' + Validator.printLocation(localSearch.path, option);
                else msg = ". Did you mean one of these: " + Validator.print($bebd28704f2536ea$var$_Object$keys(options)) + Validator.printLocation(path, option);
                console.error('%cUnknown option detected: "' + option + '"' + msg, $bebd28704f2536ea$var$VALIDATOR_PRINT_STYLE$1);
                $bebd28704f2536ea$var$errorFound = true;
            }
        },
        {
            key: "findInOptions",
            value: function findInOptions(option, options, path) {
                var recursive = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                var min = 1e9;
                var closestMatch = "";
                var closestMatchPath = [];
                var lowerCaseOption = option.toLowerCase();
                var indexMatch = undefined;
                for(var op in options){
                    var distance = void 0;
                    if (options[op].__type__ !== undefined && recursive === true) {
                        var result = Validator.findInOptions(option, options[op], $bebd28704f2536ea$var$copyAndExtendArray(path, op));
                        if (min > result.distance) {
                            closestMatch = result.closestMatch;
                            closestMatchPath = result.path;
                            min = result.distance;
                            indexMatch = result.indexMatch;
                        }
                    } else {
                        var _context16;
                        if ($bebd28704f2536ea$var$_indexOfInstanceProperty(_context16 = op.toLowerCase()).call(_context16, lowerCaseOption) !== -1) indexMatch = op;
                        distance = Validator.levenshteinDistance(option, op);
                        if (min > distance) {
                            closestMatch = op;
                            closestMatchPath = $bebd28704f2536ea$var$copyArray(path);
                            min = distance;
                        }
                    }
                }
                return {
                    closestMatch: closestMatch,
                    path: closestMatchPath,
                    distance: min,
                    indexMatch: indexMatch
                };
            }
        },
        {
            key: "printLocation",
            value: function printLocation(path, option) {
                var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "Problem value found at: \n";
                var str = "\n\n" + prefix + "options = {\n";
                for(var i = 0; i < path.length; i++){
                    for(var j = 0; j < i + 1; j++)str += "  ";
                    str += path[i] + ": {\n";
                }
                for(var _j = 0; _j < path.length + 1; _j++)str += "  ";
                str += option + "\n";
                for(var _i5 = 0; _i5 < path.length + 1; _i5++){
                    for(var _j2 = 0; _j2 < path.length - _i5; _j2++)str += "  ";
                    str += "}\n";
                }
                return str + "\n\n";
            }
        },
        {
            key: "print",
            value: function print(options) {
                return $bebd28704f2536ea$var$_JSON$stringify(options).replace(/(")|(\[)|(\])|(,"__type__")/g, "").replace(/(,)/g, ", ");
            }
        },
        {
            key: "levenshteinDistance",
            value: function levenshteinDistance(a, b) {
                if (a.length === 0) return b.length;
                if (b.length === 0) return a.length;
                var matrix = [];
                // increment along the first column of each row
                var i;
                for(i = 0; i <= b.length; i++)matrix[i] = [
                    i
                ];
                // increment each column in the first row
                var j;
                for(j = 0; j <= a.length; j++)matrix[0][j] = j;
                // Fill in the rest of the matrix
                for(i = 1; i <= b.length; i++){
                    for(j = 1; j <= a.length; j++)if (b.charAt(i - 1) == a.charAt(j - 1)) matrix[i][j] = matrix[i - 1][j - 1];
                    else matrix[i][j] = Math.min(matrix[i - 1][j - 1] + 1, // substitution
                    Math.min(matrix[i][j - 1] + 1, // insertion
                    matrix[i - 1][j] + 1)); // deletion
                }
                return matrix[b.length][a.length];
            }
        }
    ]);
    return Validator;
}();
var $bebd28704f2536ea$var$Activator = $bebd28704f2536ea$var$Activator$1;
var $bebd28704f2536ea$var$Configurator = $bebd28704f2536ea$var$Configurator$1;
var $bebd28704f2536ea$var$Hammer = $bebd28704f2536ea$var$Hammer$1;
var $bebd28704f2536ea$var$Popup = $bebd28704f2536ea$var$Popup$1;
var $bebd28704f2536ea$var$VALIDATOR_PRINT_STYLE = $bebd28704f2536ea$var$VALIDATOR_PRINT_STYLE$1;
var $bebd28704f2536ea$var$Validator = $bebd28704f2536ea$var$Validator$1;
/* eslint-disable no-prototype-builtins */ /* eslint-disable no-unused-vars */ /* eslint-disable no-var */ /**
 * Parse a text source containing data in DOT language into a JSON object.
 * The object contains two lists: one with nodes and one with edges.
 *
 * DOT language reference: http://www.graphviz.org/doc/info/lang.html
 *
 * DOT language attributes: http://graphviz.org/content/attrs
 *
 * @param {string} data     Text containing a graph in DOT-notation
 * @returns {object} graph   An object containing two parameters:
 *                          {Object[]} nodes
 *                          {Object[]} edges
 *
 * -------------------------------------------
 * TODO
 * ====
 *
 * For label handling, this is an incomplete implementation. From docs (quote #3015):
 *
 * > the escape sequences "\n", "\l" and "\r" divide the label into lines, centered,
 * > left-justified, and right-justified, respectively.
 *
 * Source: http://www.graphviz.org/content/attrs#kescString
 *
 * > As another aid for readability, dot allows double-quoted strings to span multiple physical
 * > lines using the standard C convention of a backslash immediately preceding a newline
 * > character
 * > In addition, double-quoted strings can be concatenated using a '+' operator.
 * > As HTML strings can contain newline characters, which are used solely for formatting,
 * > the language does not allow escaped newlines or concatenation operators to be used
 * > within them.
 *
 * - Currently, only '\\n' is handled
 * - Note that text explicitly says 'labels'; the dot parser currently handles escape
 *   sequences in **all** strings.
 */ function $bebd28704f2536ea$var$parseDOT(data) {
    $bebd28704f2536ea$var$dot = data;
    return $bebd28704f2536ea$var$parseGraph();
}
// mapping of attributes from DOT (the keys) to vis.js (the values)
var $bebd28704f2536ea$var$NODE_ATTR_MAPPING = {
    fontsize: "font.size",
    fontcolor: "font.color",
    labelfontcolor: "font.color",
    fontname: "font.face",
    color: [
        "color.border",
        "color.background"
    ],
    fillcolor: "color.background",
    tooltip: "title",
    labeltooltip: "title"
};
var $bebd28704f2536ea$var$EDGE_ATTR_MAPPING = $bebd28704f2536ea$var$_Object$create$1($bebd28704f2536ea$var$NODE_ATTR_MAPPING);
$bebd28704f2536ea$var$EDGE_ATTR_MAPPING.color = "color.color";
$bebd28704f2536ea$var$EDGE_ATTR_MAPPING.style = "dashes";
// token types enumeration
var $bebd28704f2536ea$var$TOKENTYPE = {
    NULL: 0,
    DELIMITER: 1,
    IDENTIFIER: 2,
    UNKNOWN: 3
};
// map with all delimiters
var $bebd28704f2536ea$var$DELIMITERS = {
    "{": true,
    "}": true,
    "[": true,
    "]": true,
    ";": true,
    "=": true,
    ",": true,
    "->": true,
    "--": true
};
var $bebd28704f2536ea$var$dot = ""; // current dot file
var $bebd28704f2536ea$var$index = 0; // current index in dot file
var $bebd28704f2536ea$var$c = ""; // current token character in expr
var $bebd28704f2536ea$var$token = ""; // current token
var $bebd28704f2536ea$var$tokenType = $bebd28704f2536ea$var$TOKENTYPE.NULL; // type of the token
/**
 * Get the first character from the dot file.
 * The character is stored into the char c. If the end of the dot file is
 * reached, the function puts an empty string in c.
 */ function $bebd28704f2536ea$var$first() {
    $bebd28704f2536ea$var$index = 0;
    $bebd28704f2536ea$var$c = $bebd28704f2536ea$var$dot.charAt(0);
}
/**
 * Get the next character from the dot file.
 * The character is stored into the char c. If the end of the dot file is
 * reached, the function puts an empty string in c.
 */ function $bebd28704f2536ea$var$next() {
    $bebd28704f2536ea$var$index++;
    $bebd28704f2536ea$var$c = $bebd28704f2536ea$var$dot.charAt($bebd28704f2536ea$var$index);
}
/**
 * Preview the next character from the dot file.
 *
 * @returns {string} cNext
 */ function $bebd28704f2536ea$var$nextPreview() {
    return $bebd28704f2536ea$var$dot.charAt($bebd28704f2536ea$var$index + 1);
}
/**
 * Test whether given character is alphabetic or numeric ( a-zA-Z_0-9.:# )
 *
 * @param {string} c
 * @returns {boolean} isAlphaNumeric
 */ function $bebd28704f2536ea$var$isAlphaNumeric(c) {
    var charCode = c.charCodeAt(0);
    if (charCode < 47) // #.
    return charCode === 35 || charCode === 46;
    if (charCode < 59) // 0-9 and :
    return charCode > 47;
    if (charCode < 91) // A-Z
    return charCode > 64;
    if (charCode < 96) // _
    return charCode === 95;
    if (charCode < 123) // a-z
    return charCode > 96;
    return false;
}
/**
 * Merge all options of object b into object b
 *
 * @param {object} a
 * @param {object} b
 * @returns {object} a
 */ function $bebd28704f2536ea$var$merge$1(a, b) {
    if (!a) a = {};
    if (b) {
        for(var name in b)if (b.hasOwnProperty(name)) a[name] = b[name];
    }
    return a;
}
/**
 * Set a value in an object, where the provided parameter name can be a
 * path with nested parameters. For example:
 *
 *     var obj = {a: 2};
 *     setValue(obj, 'b.c', 3);     // obj = {a: 2, b: {c: 3}}
 *
 * @param {object} obj
 * @param {string} path  A parameter name or dot-separated parameter path,
 *                      like "color.highlight.border".
 * @param {*} value
 */ function $bebd28704f2536ea$var$setValue(obj, path, value) {
    var keys = path.split(".");
    var o = obj;
    while(keys.length){
        var key = keys.shift();
        if (keys.length) {
            // this isn't the end point
            if (!o[key]) o[key] = {};
            o = o[key];
        } else // this is the end point
        o[key] = value;
    }
}
/**
 * Add a node to a graph object. If there is already a node with
 * the same id, their attributes will be merged.
 *
 * @param {object} graph
 * @param {object} node
 */ function $bebd28704f2536ea$var$addNode(graph, node) {
    var i, len;
    var current = null;
    // find root graph (in case of subgraph)
    var graphs = [
        graph
    ]; // list with all graphs from current graph to root graph
    var root = graph;
    while(root.parent){
        graphs.push(root.parent);
        root = root.parent;
    }
    // find existing node (at root level) by its id
    if (root.nodes) {
        for(i = 0, len = root.nodes.length; i < len; i++)if (node.id === root.nodes[i].id) {
            current = root.nodes[i];
            break;
        }
    }
    if (!current) {
        // this is a new node
        current = {
            id: node.id
        };
        if (graph.node) // clone default attributes
        current.attr = $bebd28704f2536ea$var$merge$1(current.attr, graph.node);
    }
    // add node to this (sub)graph and all its parent graphs
    for(i = graphs.length - 1; i >= 0; i--){
        var _context;
        var g = graphs[i];
        if (!g.nodes) g.nodes = [];
        if ($bebd28704f2536ea$var$_indexOfInstanceProperty(_context = g.nodes).call(_context, current) === -1) g.nodes.push(current);
    }
    // merge attributes
    if (node.attr) current.attr = $bebd28704f2536ea$var$merge$1(current.attr, node.attr);
}
/**
 * Add an edge to a graph object
 *
 * @param {object} graph
 * @param {object} edge
 */ function $bebd28704f2536ea$var$addEdge(graph, edge) {
    if (!graph.edges) graph.edges = [];
    graph.edges.push(edge);
    if (graph.edge) {
        var attr = $bebd28704f2536ea$var$merge$1({}, graph.edge); // clone default attributes
        edge.attr = $bebd28704f2536ea$var$merge$1(attr, edge.attr); // merge attributes
    }
}
/**
 * Create an edge to a graph object
 *
 * @param {object} graph
 * @param {string | number | object} from
 * @param {string | number | object} to
 * @param {string} type
 * @param {object | null} attr
 * @returns {object} edge
 */ function $bebd28704f2536ea$var$createEdge(graph, from, to, type, attr) {
    var edge = {
        from: from,
        to: to,
        type: type
    };
    if (graph.edge) edge.attr = $bebd28704f2536ea$var$merge$1({}, graph.edge); // clone default attributes
    edge.attr = $bebd28704f2536ea$var$merge$1(edge.attr || {}, attr); // merge attributes
    // Move arrows attribute from attr to edge temporally created in
    // parseAttributeList().
    if (attr != null) {
        if (attr.hasOwnProperty("arrows") && attr["arrows"] != null) {
            edge["arrows"] = {
                to: {
                    enabled: true,
                    type: attr.arrows.type
                }
            };
            attr["arrows"] = null;
        }
    }
    return edge;
}
/**
 * Get next token in the current dot file.
 * The token and token type are available as token and tokenType
 */ function $bebd28704f2536ea$var$getToken() {
    $bebd28704f2536ea$var$tokenType = $bebd28704f2536ea$var$TOKENTYPE.NULL;
    $bebd28704f2536ea$var$token = "";
    // skip over whitespaces
    while($bebd28704f2536ea$var$c === " " || $bebd28704f2536ea$var$c === "\t" || $bebd28704f2536ea$var$c === "\n" || $bebd28704f2536ea$var$c === "\r")// space, tab, enter
    $bebd28704f2536ea$var$next();
    do {
        var isComment = false;
        // skip comment
        if ($bebd28704f2536ea$var$c === "#") {
            // find the previous non-space character
            var i = $bebd28704f2536ea$var$index - 1;
            while($bebd28704f2536ea$var$dot.charAt(i) === " " || $bebd28704f2536ea$var$dot.charAt(i) === "\t")i--;
            if ($bebd28704f2536ea$var$dot.charAt(i) === "\n" || $bebd28704f2536ea$var$dot.charAt(i) === "") {
                // the # is at the start of a line, this is indeed a line comment
                while($bebd28704f2536ea$var$c != "" && $bebd28704f2536ea$var$c != "\n")$bebd28704f2536ea$var$next();
                isComment = true;
            }
        }
        if ($bebd28704f2536ea$var$c === "/" && $bebd28704f2536ea$var$nextPreview() === "/") {
            // skip line comment
            while($bebd28704f2536ea$var$c != "" && $bebd28704f2536ea$var$c != "\n")$bebd28704f2536ea$var$next();
            isComment = true;
        }
        if ($bebd28704f2536ea$var$c === "/" && $bebd28704f2536ea$var$nextPreview() === "*") {
            // skip block comment
            while($bebd28704f2536ea$var$c != "")if ($bebd28704f2536ea$var$c === "*" && $bebd28704f2536ea$var$nextPreview() === "/") {
                // end of block comment found. skip these last two characters
                $bebd28704f2536ea$var$next();
                $bebd28704f2536ea$var$next();
                break;
            } else $bebd28704f2536ea$var$next();
            isComment = true;
        }
        // skip over whitespaces
        while($bebd28704f2536ea$var$c === " " || $bebd28704f2536ea$var$c === "\t" || $bebd28704f2536ea$var$c === "\n" || $bebd28704f2536ea$var$c === "\r")// space, tab, enter
        $bebd28704f2536ea$var$next();
    }while (isComment);
    // check for end of dot file
    if ($bebd28704f2536ea$var$c === "") {
        // token is still empty
        $bebd28704f2536ea$var$tokenType = $bebd28704f2536ea$var$TOKENTYPE.DELIMITER;
        return;
    }
    // check for delimiters consisting of 2 characters
    var c2 = $bebd28704f2536ea$var$c + $bebd28704f2536ea$var$nextPreview();
    if ($bebd28704f2536ea$var$DELIMITERS[c2]) {
        $bebd28704f2536ea$var$tokenType = $bebd28704f2536ea$var$TOKENTYPE.DELIMITER;
        $bebd28704f2536ea$var$token = c2;
        $bebd28704f2536ea$var$next();
        $bebd28704f2536ea$var$next();
        return;
    }
    // check for delimiters consisting of 1 character
    if ($bebd28704f2536ea$var$DELIMITERS[$bebd28704f2536ea$var$c]) {
        $bebd28704f2536ea$var$tokenType = $bebd28704f2536ea$var$TOKENTYPE.DELIMITER;
        $bebd28704f2536ea$var$token = $bebd28704f2536ea$var$c;
        $bebd28704f2536ea$var$next();
        return;
    }
    // check for an identifier (number or string)
    // TODO: more precise parsing of numbers/strings (and the port separator ':')
    if ($bebd28704f2536ea$var$isAlphaNumeric($bebd28704f2536ea$var$c) || $bebd28704f2536ea$var$c === "-") {
        $bebd28704f2536ea$var$token += $bebd28704f2536ea$var$c;
        $bebd28704f2536ea$var$next();
        while($bebd28704f2536ea$var$isAlphaNumeric($bebd28704f2536ea$var$c)){
            $bebd28704f2536ea$var$token += $bebd28704f2536ea$var$c;
            $bebd28704f2536ea$var$next();
        }
        if ($bebd28704f2536ea$var$token === "false") $bebd28704f2536ea$var$token = false; // convert to boolean
        else if ($bebd28704f2536ea$var$token === "true") $bebd28704f2536ea$var$token = true; // convert to boolean
        else if (!isNaN(Number($bebd28704f2536ea$var$token))) $bebd28704f2536ea$var$token = Number($bebd28704f2536ea$var$token); // convert to number
        $bebd28704f2536ea$var$tokenType = $bebd28704f2536ea$var$TOKENTYPE.IDENTIFIER;
        return;
    }
    // check for a string enclosed by double quotes
    if ($bebd28704f2536ea$var$c === '"') {
        $bebd28704f2536ea$var$next();
        while($bebd28704f2536ea$var$c != "" && ($bebd28704f2536ea$var$c != '"' || $bebd28704f2536ea$var$c === '"' && $bebd28704f2536ea$var$nextPreview() === '"')){
            if ($bebd28704f2536ea$var$c === '"') {
                // skip the escape character
                $bebd28704f2536ea$var$token += $bebd28704f2536ea$var$c;
                $bebd28704f2536ea$var$next();
            } else if ($bebd28704f2536ea$var$c === "\\" && $bebd28704f2536ea$var$nextPreview() === "n") {
                // Honor a newline escape sequence
                $bebd28704f2536ea$var$token += "\n";
                $bebd28704f2536ea$var$next();
            } else $bebd28704f2536ea$var$token += $bebd28704f2536ea$var$c;
            $bebd28704f2536ea$var$next();
        }
        if ($bebd28704f2536ea$var$c != '"') throw $bebd28704f2536ea$var$newSyntaxError('End of string " expected');
        $bebd28704f2536ea$var$next();
        $bebd28704f2536ea$var$tokenType = $bebd28704f2536ea$var$TOKENTYPE.IDENTIFIER;
        return;
    }
    // something unknown is found, wrong characters, a syntax error
    $bebd28704f2536ea$var$tokenType = $bebd28704f2536ea$var$TOKENTYPE.UNKNOWN;
    while($bebd28704f2536ea$var$c != ""){
        $bebd28704f2536ea$var$token += $bebd28704f2536ea$var$c;
        $bebd28704f2536ea$var$next();
    }
    throw new SyntaxError('Syntax error in part "' + $bebd28704f2536ea$var$chop($bebd28704f2536ea$var$token, 30) + '"');
}
/**
 * Parse a graph.
 *
 * @returns {object} graph
 */ function $bebd28704f2536ea$var$parseGraph() {
    var graph = {};
    $bebd28704f2536ea$var$first();
    $bebd28704f2536ea$var$getToken();
    // optional strict keyword
    if ($bebd28704f2536ea$var$token === "strict") {
        graph.strict = true;
        $bebd28704f2536ea$var$getToken();
    }
    // graph or digraph keyword
    if ($bebd28704f2536ea$var$token === "graph" || $bebd28704f2536ea$var$token === "digraph") {
        graph.type = $bebd28704f2536ea$var$token;
        $bebd28704f2536ea$var$getToken();
    }
    // optional graph id
    if ($bebd28704f2536ea$var$tokenType === $bebd28704f2536ea$var$TOKENTYPE.IDENTIFIER) {
        graph.id = $bebd28704f2536ea$var$token;
        $bebd28704f2536ea$var$getToken();
    }
    // open angle bracket
    if ($bebd28704f2536ea$var$token != "{") throw $bebd28704f2536ea$var$newSyntaxError("Angle bracket { expected");
    $bebd28704f2536ea$var$getToken();
    // statements
    $bebd28704f2536ea$var$parseStatements(graph);
    // close angle bracket
    if ($bebd28704f2536ea$var$token != "}") throw $bebd28704f2536ea$var$newSyntaxError("Angle bracket } expected");
    $bebd28704f2536ea$var$getToken();
    // end of file
    if ($bebd28704f2536ea$var$token !== "") throw $bebd28704f2536ea$var$newSyntaxError("End of file expected");
    $bebd28704f2536ea$var$getToken();
    // remove temporary default options
    delete graph.node;
    delete graph.edge;
    delete graph.graph;
    return graph;
}
/**
 * Parse a list with statements.
 *
 * @param {object} graph
 */ function $bebd28704f2536ea$var$parseStatements(graph) {
    while($bebd28704f2536ea$var$token !== "" && $bebd28704f2536ea$var$token != "}"){
        $bebd28704f2536ea$var$parseStatement(graph);
        if ($bebd28704f2536ea$var$token === ";") $bebd28704f2536ea$var$getToken();
    }
}
/**
 * Parse a single statement. Can be a an attribute statement, node
 * statement, a series of node statements and edge statements, or a
 * parameter.
 *
 * @param {object} graph
 */ function $bebd28704f2536ea$var$parseStatement(graph) {
    // parse subgraph
    var subgraph = $bebd28704f2536ea$var$parseSubgraph(graph);
    if (subgraph) {
        // edge statements
        $bebd28704f2536ea$var$parseEdge(graph, subgraph);
        return;
    }
    // parse an attribute statement
    var attr = $bebd28704f2536ea$var$parseAttributeStatement(graph);
    if (attr) return;
    // parse node
    if ($bebd28704f2536ea$var$tokenType != $bebd28704f2536ea$var$TOKENTYPE.IDENTIFIER) throw $bebd28704f2536ea$var$newSyntaxError("Identifier expected");
    var id = $bebd28704f2536ea$var$token; // id can be a string or a number
    $bebd28704f2536ea$var$getToken();
    if ($bebd28704f2536ea$var$token === "=") {
        // id statement
        $bebd28704f2536ea$var$getToken();
        if ($bebd28704f2536ea$var$tokenType != $bebd28704f2536ea$var$TOKENTYPE.IDENTIFIER) throw $bebd28704f2536ea$var$newSyntaxError("Identifier expected");
        graph[id] = $bebd28704f2536ea$var$token;
        $bebd28704f2536ea$var$getToken();
    // TODO: implement comma separated list with "a_list: ID=ID [','] [a_list] "
    } else $bebd28704f2536ea$var$parseNodeStatement(graph, id);
}
/**
 * Parse a subgraph
 *
 * @param {object} graph    parent graph object
 * @returns {object | null} subgraph
 */ function $bebd28704f2536ea$var$parseSubgraph(graph) {
    var subgraph = null;
    // optional subgraph keyword
    if ($bebd28704f2536ea$var$token === "subgraph") {
        subgraph = {};
        subgraph.type = "subgraph";
        $bebd28704f2536ea$var$getToken();
        // optional graph id
        if ($bebd28704f2536ea$var$tokenType === $bebd28704f2536ea$var$TOKENTYPE.IDENTIFIER) {
            subgraph.id = $bebd28704f2536ea$var$token;
            $bebd28704f2536ea$var$getToken();
        }
    }
    // open angle bracket
    if ($bebd28704f2536ea$var$token === "{") {
        $bebd28704f2536ea$var$getToken();
        if (!subgraph) subgraph = {};
        subgraph.parent = graph;
        subgraph.node = graph.node;
        subgraph.edge = graph.edge;
        subgraph.graph = graph.graph;
        // statements
        $bebd28704f2536ea$var$parseStatements(subgraph);
        // close angle bracket
        if ($bebd28704f2536ea$var$token != "}") throw $bebd28704f2536ea$var$newSyntaxError("Angle bracket } expected");
        $bebd28704f2536ea$var$getToken();
        // remove temporary default options
        delete subgraph.node;
        delete subgraph.edge;
        delete subgraph.graph;
        delete subgraph.parent;
        // register at the parent graph
        if (!graph.subgraphs) graph.subgraphs = [];
        graph.subgraphs.push(subgraph);
    }
    return subgraph;
}
/**
 * parse an attribute statement like "node [shape=circle fontSize=16]".
 * Available keywords are 'node', 'edge', 'graph'.
 * The previous list with default attributes will be replaced
 *
 * @param {object} graph
 * @returns {string | null} keyword Returns the name of the parsed attribute
 *                                  (node, edge, graph), or null if nothing
 *                                  is parsed.
 */ function $bebd28704f2536ea$var$parseAttributeStatement(graph) {
    // attribute statements
    if ($bebd28704f2536ea$var$token === "node") {
        $bebd28704f2536ea$var$getToken();
        // node attributes
        graph.node = $bebd28704f2536ea$var$parseAttributeList();
        return "node";
    } else if ($bebd28704f2536ea$var$token === "edge") {
        $bebd28704f2536ea$var$getToken();
        // edge attributes
        graph.edge = $bebd28704f2536ea$var$parseAttributeList();
        return "edge";
    } else if ($bebd28704f2536ea$var$token === "graph") {
        $bebd28704f2536ea$var$getToken();
        // graph attributes
        graph.graph = $bebd28704f2536ea$var$parseAttributeList();
        return "graph";
    }
    return null;
}
/**
 * parse a node statement
 *
 * @param {object} graph
 * @param {string | number} id
 */ function $bebd28704f2536ea$var$parseNodeStatement(graph, id) {
    // node statement
    var node = {
        id: id
    };
    var attr = $bebd28704f2536ea$var$parseAttributeList();
    if (attr) node.attr = attr;
    $bebd28704f2536ea$var$addNode(graph, node);
    // edge statements
    $bebd28704f2536ea$var$parseEdge(graph, id);
}
/**
 * Parse an edge or a series of edges
 *
 * @param {object} graph
 * @param {string | number} from        Id of the from node
 */ function $bebd28704f2536ea$var$parseEdge(graph, from) {
    while($bebd28704f2536ea$var$token === "->" || $bebd28704f2536ea$var$token === "--"){
        var to;
        var type = $bebd28704f2536ea$var$token;
        $bebd28704f2536ea$var$getToken();
        var subgraph = $bebd28704f2536ea$var$parseSubgraph(graph);
        if (subgraph) to = subgraph;
        else {
            if ($bebd28704f2536ea$var$tokenType != $bebd28704f2536ea$var$TOKENTYPE.IDENTIFIER) throw $bebd28704f2536ea$var$newSyntaxError("Identifier or subgraph expected");
            to = $bebd28704f2536ea$var$token;
            $bebd28704f2536ea$var$addNode(graph, {
                id: to
            });
            $bebd28704f2536ea$var$getToken();
        }
        // parse edge attributes
        var attr = $bebd28704f2536ea$var$parseAttributeList();
        // create edge
        var edge = $bebd28704f2536ea$var$createEdge(graph, from, to, type, attr);
        $bebd28704f2536ea$var$addEdge(graph, edge);
        from = to;
    }
}
/**
 * Parse a set with attributes,
 * for example [label="1.000", shape=solid]
 *
 * @returns {object | null} attr
 */ function $bebd28704f2536ea$var$parseAttributeList() {
    var i;
    var attr = null;
    // edge styles of dot and vis
    var edgeStyles = {
        dashed: true,
        solid: false,
        dotted: [
            1,
            5
        ]
    };
    /**
   * Define arrow types.
   * vis currently supports types defined in 'arrowTypes'.
   * Details of arrow shapes are described in
   * http://www.graphviz.org/content/arrow-shapes
   */ var arrowTypes = {
        dot: "circle",
        box: "box",
        crow: "crow",
        curve: "curve",
        icurve: "inv_curve",
        normal: "triangle",
        inv: "inv_triangle",
        diamond: "diamond",
        tee: "bar",
        vee: "vee"
    };
    /**
   * 'attr_list' contains attributes for checking if some of them are affected
   * later. For instance, both of 'arrowhead' and 'dir' (edge style defined
   * in DOT) make changes to 'arrows' attribute in vis.
   */ var attr_list = new Array();
    var attr_names = new Array(); // used for checking the case.
    // parse attributes
    while($bebd28704f2536ea$var$token === "["){
        $bebd28704f2536ea$var$getToken();
        attr = {};
        while($bebd28704f2536ea$var$token !== "" && $bebd28704f2536ea$var$token != "]"){
            if ($bebd28704f2536ea$var$tokenType != $bebd28704f2536ea$var$TOKENTYPE.IDENTIFIER) throw $bebd28704f2536ea$var$newSyntaxError("Attribute name expected");
            var name = $bebd28704f2536ea$var$token;
            $bebd28704f2536ea$var$getToken();
            if ($bebd28704f2536ea$var$token != "=") throw $bebd28704f2536ea$var$newSyntaxError("Equal sign = expected");
            $bebd28704f2536ea$var$getToken();
            if ($bebd28704f2536ea$var$tokenType != $bebd28704f2536ea$var$TOKENTYPE.IDENTIFIER) throw $bebd28704f2536ea$var$newSyntaxError("Attribute value expected");
            var value = $bebd28704f2536ea$var$token;
            // convert from dot style to vis
            if (name === "style") value = edgeStyles[value];
            var arrowType;
            if (name === "arrowhead") {
                arrowType = arrowTypes[value];
                name = "arrows";
                value = {
                    to: {
                        enabled: true,
                        type: arrowType
                    }
                };
            }
            if (name === "arrowtail") {
                arrowType = arrowTypes[value];
                name = "arrows";
                value = {
                    from: {
                        enabled: true,
                        type: arrowType
                    }
                };
            }
            attr_list.push({
                attr: attr,
                name: name,
                value: value
            });
            attr_names.push(name);
            $bebd28704f2536ea$var$getToken();
            if ($bebd28704f2536ea$var$token == ",") $bebd28704f2536ea$var$getToken();
        }
        if ($bebd28704f2536ea$var$token != "]") throw $bebd28704f2536ea$var$newSyntaxError("Bracket ] expected");
        $bebd28704f2536ea$var$getToken();
    }
    /**
   * As explained in [1], graphviz has limitations for combination of
   * arrow[head|tail] and dir. If attribute list includes 'dir',
   * following cases just be supported.
   *   1. both or none + arrowhead, arrowtail
   *   2. forward + arrowhead (arrowtail is not affedted)
   *   3. back + arrowtail (arrowhead is not affected)
   * [1] https://www.graphviz.org/doc/info/attrs.html#h:undir_note
   */ if ($bebd28704f2536ea$var$_includesInstanceProperty(attr_names).call(attr_names, "dir")) {
        var idx = {}; // get index of 'arrows' and 'dir'
        idx.arrows = {};
        for(i = 0; i < attr_list.length; i++){
            if (attr_list[i].name === "arrows") {
                if (attr_list[i].value.to != null) idx.arrows.to = i;
                else if (attr_list[i].value.from != null) idx.arrows.from = i;
                else throw $bebd28704f2536ea$var$newSyntaxError("Invalid value of arrows");
            } else if (attr_list[i].name === "dir") idx.dir = i;
        }
        // first, add default arrow shape if it is not assigned to avoid error
        var dir_type = attr_list[idx.dir].value;
        if (!$bebd28704f2536ea$var$_includesInstanceProperty(attr_names).call(attr_names, "arrows")) {
            if (dir_type === "both") {
                attr_list.push({
                    attr: attr_list[idx.dir].attr,
                    name: "arrows",
                    value: {
                        to: {
                            enabled: true
                        }
                    }
                });
                idx.arrows.to = attr_list.length - 1;
                attr_list.push({
                    attr: attr_list[idx.dir].attr,
                    name: "arrows",
                    value: {
                        from: {
                            enabled: true
                        }
                    }
                });
                idx.arrows.from = attr_list.length - 1;
            } else if (dir_type === "forward") {
                attr_list.push({
                    attr: attr_list[idx.dir].attr,
                    name: "arrows",
                    value: {
                        to: {
                            enabled: true
                        }
                    }
                });
                idx.arrows.to = attr_list.length - 1;
            } else if (dir_type === "back") {
                attr_list.push({
                    attr: attr_list[idx.dir].attr,
                    name: "arrows",
                    value: {
                        from: {
                            enabled: true
                        }
                    }
                });
                idx.arrows.from = attr_list.length - 1;
            } else if (dir_type === "none") {
                attr_list.push({
                    attr: attr_list[idx.dir].attr,
                    name: "arrows",
                    value: ""
                });
                idx.arrows.to = attr_list.length - 1;
            } else throw $bebd28704f2536ea$var$newSyntaxError('Invalid dir type "' + dir_type + '"');
        }
        var from_type;
        var to_type;
        // update 'arrows' attribute from 'dir'.
        if (dir_type === "both") {
            // both of shapes of 'from' and 'to' are given
            if (idx.arrows.to && idx.arrows.from) {
                to_type = attr_list[idx.arrows.to].value.to.type;
                from_type = attr_list[idx.arrows.from].value.from.type;
                attr_list[idx.arrows.to] = {
                    attr: attr_list[idx.arrows.to].attr,
                    name: attr_list[idx.arrows.to].name,
                    value: {
                        to: {
                            enabled: true,
                            type: to_type
                        },
                        from: {
                            enabled: true,
                            type: from_type
                        }
                    }
                };
                $bebd28704f2536ea$var$_spliceInstanceProperty(attr_list).call(attr_list, idx.arrows.from, 1);
            // shape of 'to' is assigned and use default to 'from'
            } else if (idx.arrows.to) {
                to_type = attr_list[idx.arrows.to].value.to.type;
                from_type = "arrow";
                attr_list[idx.arrows.to] = {
                    attr: attr_list[idx.arrows.to].attr,
                    name: attr_list[idx.arrows.to].name,
                    value: {
                        to: {
                            enabled: true,
                            type: to_type
                        },
                        from: {
                            enabled: true,
                            type: from_type
                        }
                    }
                };
            // only shape of 'from' is assigned and use default for 'to'
            } else if (idx.arrows.from) {
                to_type = "arrow";
                from_type = attr_list[idx.arrows.from].value.from.type;
                attr_list[idx.arrows.from] = {
                    attr: attr_list[idx.arrows.from].attr,
                    name: attr_list[idx.arrows.from].name,
                    value: {
                        to: {
                            enabled: true,
                            type: to_type
                        },
                        from: {
                            enabled: true,
                            type: from_type
                        }
                    }
                };
            }
        } else if (dir_type === "back") {
            // given both of shapes, but use only 'from'
            if (idx.arrows.to && idx.arrows.from) {
                to_type = "";
                from_type = attr_list[idx.arrows.from].value.from.type;
                attr_list[idx.arrows.from] = {
                    attr: attr_list[idx.arrows.from].attr,
                    name: attr_list[idx.arrows.from].name,
                    value: {
                        to: {
                            enabled: true,
                            type: to_type
                        },
                        from: {
                            enabled: true,
                            type: from_type
                        }
                    }
                };
            // given shape of 'to', but does not use it
            } else if (idx.arrows.to) {
                to_type = "";
                from_type = "arrow";
                idx.arrows.from = idx.arrows.to;
                attr_list[idx.arrows.from] = {
                    attr: attr_list[idx.arrows.from].attr,
                    name: attr_list[idx.arrows.from].name,
                    value: {
                        to: {
                            enabled: true,
                            type: to_type
                        },
                        from: {
                            enabled: true,
                            type: from_type
                        }
                    }
                };
            // assign given 'from' shape
            } else if (idx.arrows.from) {
                to_type = "";
                from_type = attr_list[idx.arrows.from].value.from.type;
                attr_list[idx.arrows.to] = {
                    attr: attr_list[idx.arrows.from].attr,
                    name: attr_list[idx.arrows.from].name,
                    value: {
                        to: {
                            enabled: true,
                            type: to_type
                        },
                        from: {
                            enabled: true,
                            type: from_type
                        }
                    }
                };
            }
            attr_list[idx.arrows.from] = {
                attr: attr_list[idx.arrows.from].attr,
                name: attr_list[idx.arrows.from].name,
                value: {
                    from: {
                        enabled: true,
                        type: attr_list[idx.arrows.from].value.from.type
                    }
                }
            };
        } else if (dir_type === "none") {
            var idx_arrow;
            if (idx.arrows.to) idx_arrow = idx.arrows.to;
            else idx_arrow = idx.arrows.from;
            attr_list[idx_arrow] = {
                attr: attr_list[idx_arrow].attr,
                name: attr_list[idx_arrow].name,
                value: ""
            };
        } else if (dir_type === "forward") {
            // given both of shapes, but use only 'to'
            if (idx.arrows.to && idx.arrows.from) {
                to_type = attr_list[idx.arrows.to].value.to.type;
                from_type = "";
                attr_list[idx.arrows.to] = {
                    attr: attr_list[idx.arrows.to].attr,
                    name: attr_list[idx.arrows.to].name,
                    value: {
                        to: {
                            enabled: true,
                            type: to_type
                        },
                        from: {
                            enabled: true,
                            type: from_type
                        }
                    }
                };
            // assign given 'to' shape
            } else if (idx.arrows.to) {
                to_type = attr_list[idx.arrows.to].value.to.type;
                from_type = "";
                attr_list[idx.arrows.to] = {
                    attr: attr_list[idx.arrows.to].attr,
                    name: attr_list[idx.arrows.to].name,
                    value: {
                        to: {
                            enabled: true,
                            type: to_type
                        },
                        from: {
                            enabled: true,
                            type: from_type
                        }
                    }
                };
            // given shape of 'from', but does not use it
            } else if (idx.arrows.from) {
                to_type = "arrow";
                from_type = "";
                idx.arrows.to = idx.arrows.from;
                attr_list[idx.arrows.to] = {
                    attr: attr_list[idx.arrows.to].attr,
                    name: attr_list[idx.arrows.to].name,
                    value: {
                        to: {
                            enabled: true,
                            type: to_type
                        },
                        from: {
                            enabled: true,
                            type: from_type
                        }
                    }
                };
            }
            attr_list[idx.arrows.to] = {
                attr: attr_list[idx.arrows.to].attr,
                name: attr_list[idx.arrows.to].name,
                value: {
                    to: {
                        enabled: true,
                        type: attr_list[idx.arrows.to].value.to.type
                    }
                }
            };
        } else throw $bebd28704f2536ea$var$newSyntaxError('Invalid dir type "' + dir_type + '"');
        // remove 'dir' attribute no need anymore
        $bebd28704f2536ea$var$_spliceInstanceProperty(attr_list).call(attr_list, idx.dir, 1);
    }
    // parse 'penwidth'
    var nof_attr_list;
    if ($bebd28704f2536ea$var$_includesInstanceProperty(attr_names).call(attr_names, "penwidth")) {
        var tmp_attr_list = [];
        nof_attr_list = attr_list.length;
        for(i = 0; i < nof_attr_list; i++)// exclude 'width' from attr_list if 'penwidth' exists
        if (attr_list[i].name !== "width") {
            if (attr_list[i].name === "penwidth") attr_list[i].name = "width";
            tmp_attr_list.push(attr_list[i]);
        }
        attr_list = tmp_attr_list;
    }
    nof_attr_list = attr_list.length;
    for(i = 0; i < nof_attr_list; i++)$bebd28704f2536ea$var$setValue(attr_list[i].attr, attr_list[i].name, attr_list[i].value);
    return attr;
}
/**
 * Create a syntax error with extra information on current token and index.
 *
 * @param {string} message
 * @returns {SyntaxError} err
 */ function $bebd28704f2536ea$var$newSyntaxError(message) {
    return new SyntaxError(message + ', got "' + $bebd28704f2536ea$var$chop($bebd28704f2536ea$var$token, 30) + '" (char ' + $bebd28704f2536ea$var$index + ")");
}
/**
 * Chop off text after a maximum length
 *
 * @param {string} text
 * @param {number} maxLength
 * @returns {string}
 */ function $bebd28704f2536ea$var$chop(text, maxLength) {
    return text.length <= maxLength ? text : text.substr(0, 27) + "...";
}
/**
 * Execute a function fn for each pair of elements in two arrays
 *
 * @param {Array | *} array1
 * @param {Array | *} array2
 * @param {Function} fn
 */ function $bebd28704f2536ea$var$forEach2(array1, array2, fn) {
    if ($bebd28704f2536ea$var$_Array$isArray(array1)) $bebd28704f2536ea$var$_forEachInstanceProperty(array1).call(array1, function(elem1) {
        if ($bebd28704f2536ea$var$_Array$isArray(array2)) $bebd28704f2536ea$var$_forEachInstanceProperty(array2).call(array2, function(elem2) {
            fn(elem1, elem2);
        });
        else fn(elem1, array2);
    });
    else if ($bebd28704f2536ea$var$_Array$isArray(array2)) $bebd28704f2536ea$var$_forEachInstanceProperty(array2).call(array2, function(elem2) {
        fn(array1, elem2);
    });
    else fn(array1, array2);
}
/**
 * Set a nested property on an object
 * When nested objects are missing, they will be created.
 * For example setProp({}, 'font.color', 'red') will return {font: {color: 'red'}}
 *
 * @param {object} object
 * @param {string} path   A dot separated string like 'font.color'
 * @param {*} value       Value for the property
 * @returns {object} Returns the original object, allows for chaining.
 */ function $bebd28704f2536ea$var$setProp(object, path, value) {
    var names = path.split(".");
    var prop = names.pop();
    // traverse over the nested objects
    var obj = object;
    for(var i = 0; i < names.length; i++){
        var name = names[i];
        if (!(name in obj)) obj[name] = {};
        obj = obj[name];
    }
    // set the property value
    obj[prop] = value;
    return object;
}
/**
 * Convert an object with DOT attributes to their vis.js equivalents.
 *
 * @param {object} attr     Object with DOT attributes
 * @param {object} mapping
 * @returns {object}         Returns an object with vis.js attributes
 */ function $bebd28704f2536ea$var$convertAttr(attr, mapping) {
    var converted = {};
    for(var prop in attr)if (attr.hasOwnProperty(prop)) {
        var visProp = mapping[prop];
        if ($bebd28704f2536ea$var$_Array$isArray(visProp)) $bebd28704f2536ea$var$_forEachInstanceProperty(visProp).call(visProp, function(visPropI) {
            $bebd28704f2536ea$var$setProp(converted, visPropI, attr[prop]);
        });
        else if (typeof visProp === "string") $bebd28704f2536ea$var$setProp(converted, visProp, attr[prop]);
        else $bebd28704f2536ea$var$setProp(converted, prop, attr[prop]);
    }
    return converted;
}
/**
 * Convert a string containing a graph in DOT language into a map containing
 * with nodes and edges in the format of graph.
 *
 * @param {string} data         Text containing a graph in DOT-notation
 * @returns {object} graphData
 */ function $bebd28704f2536ea$var$DOTToGraph(data) {
    // parse the DOT file
    var dotData = $bebd28704f2536ea$var$parseDOT(data);
    var graphData = {
        nodes: [],
        edges: [],
        options: {}
    };
    // copy the nodes
    if (dotData.nodes) {
        var _context2;
        $bebd28704f2536ea$var$_forEachInstanceProperty(_context2 = dotData.nodes).call(_context2, function(dotNode) {
            var graphNode = {
                id: dotNode.id,
                label: String(dotNode.label || dotNode.id)
            };
            $bebd28704f2536ea$var$merge$1(graphNode, $bebd28704f2536ea$var$convertAttr(dotNode.attr, $bebd28704f2536ea$var$NODE_ATTR_MAPPING));
            if (graphNode.image) graphNode.shape = "image";
            graphData.nodes.push(graphNode);
        });
    }
    // copy the edges
    if (dotData.edges) {
        var _context3;
        /**
     * Convert an edge in DOT format to an edge with VisGraph format
     *
     * @param {object} dotEdge
     * @returns {object} graphEdge
     */ var convertEdge = function convertEdge(dotEdge) {
            var graphEdge = {
                from: dotEdge.from,
                to: dotEdge.to
            };
            $bebd28704f2536ea$var$merge$1(graphEdge, $bebd28704f2536ea$var$convertAttr(dotEdge.attr, $bebd28704f2536ea$var$EDGE_ATTR_MAPPING));
            // Add arrows attribute to default styled arrow.
            // The reason why default style is not added in parseAttributeList() is
            // because only default is cleared before here.
            if (graphEdge.arrows == null && dotEdge.type === "->") graphEdge.arrows = "to";
            return graphEdge;
        };
        $bebd28704f2536ea$var$_forEachInstanceProperty(_context3 = dotData.edges).call(_context3, function(dotEdge) {
            var from, to;
            if (dotEdge.from instanceof Object) from = dotEdge.from.nodes;
            else from = {
                id: dotEdge.from
            };
            if (dotEdge.to instanceof Object) to = dotEdge.to.nodes;
            else to = {
                id: dotEdge.to
            };
            if (dotEdge.from instanceof Object && dotEdge.from.edges) {
                var _context4;
                $bebd28704f2536ea$var$_forEachInstanceProperty(_context4 = dotEdge.from.edges).call(_context4, function(subEdge) {
                    var graphEdge = convertEdge(subEdge);
                    graphData.edges.push(graphEdge);
                });
            }
            $bebd28704f2536ea$var$forEach2(from, to, function(from, to) {
                var subEdge = $bebd28704f2536ea$var$createEdge(graphData, from.id, to.id, dotEdge.type, dotEdge.attr);
                var graphEdge = convertEdge(subEdge);
                graphData.edges.push(graphEdge);
            });
            if (dotEdge.to instanceof Object && dotEdge.to.edges) {
                var _context5;
                $bebd28704f2536ea$var$_forEachInstanceProperty(_context5 = dotEdge.to.edges).call(_context5, function(subEdge) {
                    var graphEdge = convertEdge(subEdge);
                    graphData.edges.push(graphEdge);
                });
            }
        });
    }
    // copy the options
    if (dotData.attr) graphData.options = dotData.attr;
    return graphData;
}
/* eslint-enable no-var */ /* eslint-enable no-unused-vars */ /* eslint-enable no-prototype-builtins */ var $bebd28704f2536ea$export$5b876ae2b6a90060 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    DOTToGraph: $bebd28704f2536ea$var$DOTToGraph,
    parseDOT: $bebd28704f2536ea$var$parseDOT
});
/**
 * Convert Gephi to Vis.
 *
 * @param gephiJSON - The parsed JSON data in Gephi format.
 * @param optionsObj - Additional options.
 * @returns The converted data ready to be used in Vis.
 */ function $bebd28704f2536ea$export$63f58ee125a505f5(gephiJSON, optionsObj) {
    var _context;
    var options = {
        edges: {
            inheritColor: false
        },
        nodes: {
            fixed: false,
            parseColor: false
        }
    };
    if (optionsObj != null) {
        if (optionsObj.fixed != null) options.nodes.fixed = optionsObj.fixed;
        if (optionsObj.parseColor != null) options.nodes.parseColor = optionsObj.parseColor;
        if (optionsObj.inheritColor != null) options.edges.inheritColor = optionsObj.inheritColor;
    }
    var gEdges = gephiJSON.edges;
    var vEdges = $bebd28704f2536ea$var$_mapInstanceProperty(gEdges).call(gEdges, function(gEdge) {
        var vEdge = {
            from: gEdge.source,
            id: gEdge.id,
            to: gEdge.target
        };
        if (gEdge.attributes != null) vEdge.attributes = gEdge.attributes;
        if (gEdge.label != null) vEdge.label = gEdge.label;
        if (gEdge.attributes != null && gEdge.attributes.title != null) vEdge.title = gEdge.attributes.title;
        if (gEdge.type === "Directed") vEdge.arrows = "to";
        // edge['value'] = gEdge.attributes != null ? gEdge.attributes.Weight : undefined;
        // edge['width'] = edge['value'] != null ? undefined : edgegEdge.size;
        if (gEdge.color && options.edges.inheritColor === false) vEdge.color = gEdge.color;
        return vEdge;
    });
    var vNodes = $bebd28704f2536ea$var$_mapInstanceProperty(_context = gephiJSON.nodes).call(_context, function(gNode) {
        var vNode = {
            id: gNode.id,
            fixed: options.nodes.fixed && gNode.x != null && gNode.y != null
        };
        if (gNode.attributes != null) vNode.attributes = gNode.attributes;
        if (gNode.label != null) vNode.label = gNode.label;
        if (gNode.size != null) vNode.size = gNode.size;
        if (gNode.attributes != null && gNode.attributes.title != null) vNode.title = gNode.attributes.title;
        if (gNode.title != null) vNode.title = gNode.title;
        if (gNode.x != null) vNode.x = gNode.x;
        if (gNode.y != null) vNode.y = gNode.y;
        if (gNode.color != null) {
            if (options.nodes.parseColor === true) vNode.color = gNode.color;
            else vNode.color = {
                background: gNode.color,
                border: gNode.color,
                highlight: {
                    background: gNode.color,
                    border: gNode.color
                },
                hover: {
                    background: gNode.color,
                    border: gNode.color
                }
            };
        }
        return vNode;
    });
    return {
        nodes: vNodes,
        edges: vEdges
    };
}
var $bebd28704f2536ea$export$8438f891a3acc0a3 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    parseGephi: $bebd28704f2536ea$export$63f58ee125a505f5
});
// English
var $bebd28704f2536ea$var$en = {
    addDescription: "Click in an empty space to place a new node.",
    addEdge: "Add Edge",
    addNode: "Add Node",
    back: "Back",
    close: "Close",
    createEdgeError: "Cannot link edges to a cluster.",
    del: "Delete selected",
    deleteClusterError: "Clusters cannot be deleted.",
    edgeDescription: "Click on a node and drag the edge to another node to connect them.",
    edit: "Edit",
    editClusterError: "Clusters cannot be edited.",
    editEdge: "Edit Edge",
    editEdgeDescription: "Click on the control points and drag them to a node to connect to it.",
    editNode: "Edit Node"
};
// German
var $bebd28704f2536ea$var$de = {
    addDescription: "Klicke auf eine freie Stelle, um einen neuen Knoten zu plazieren.",
    addEdge: "Kante hinzuf\xFCgen",
    addNode: "Knoten hinzuf\xFCgen",
    back: "Zur\xFCck",
    close: "Schlie\xdfen",
    createEdgeError: "Es ist nicht m\xF6glich, Kanten mit Clustern zu verbinden.",
    del: "L\xF6sche Auswahl",
    deleteClusterError: "Cluster k\xF6nnen nicht gel\xF6scht werden.",
    edgeDescription: "Klicke auf einen Knoten und ziehe die Kante zu einem anderen Knoten, um diese zu verbinden.",
    edit: "Editieren",
    editClusterError: "Cluster k\xF6nnen nicht editiert werden.",
    editEdge: "Kante editieren",
    editEdgeDescription: "Klicke auf die Verbindungspunkte und ziehe diese auf einen Knoten, um sie zu verbinden.",
    editNode: "Knoten editieren"
};
// Spanish
var $bebd28704f2536ea$var$es = {
    addDescription: "Haga clic en un lugar vac\xEDo para colocar un nuevo nodo.",
    addEdge: "A\xF1adir arista",
    addNode: "A\xF1adir nodo",
    back: "Atr\xE1s",
    close: "Cerrar",
    createEdgeError: "No se puede conectar una arista a un grupo.",
    del: "Eliminar selecci\xF3n",
    deleteClusterError: "No es posible eliminar grupos.",
    edgeDescription: "Haga clic en un nodo y arrastre la arista hacia otro nodo para conectarlos.",
    edit: "Editar",
    editClusterError: "No es posible editar grupos.",
    editEdge: "Editar arista",
    editEdgeDescription: "Haga clic en un punto de control y arrastrelo a un nodo para conectarlo.",
    editNode: "Editar nodo"
};
//Italiano
var $bebd28704f2536ea$var$it = {
    addDescription: "Clicca per aggiungere un nuovo nodo",
    addEdge: "Aggiungi un vertice",
    addNode: "Aggiungi un nodo",
    back: "Indietro",
    close: "Chiudere",
    createEdgeError: "Non si possono collegare vertici ad un cluster",
    del: "Cancella la selezione",
    deleteClusterError: "I cluster non possono essere cancellati",
    edgeDescription: "Clicca su un nodo e trascinalo ad un altro nodo per connetterli.",
    edit: "Modifica",
    editClusterError: "I clusters non possono essere modificati.",
    editEdge: "Modifica il vertice",
    editEdgeDescription: "Clicca sui Punti di controllo e trascinali ad un nodo per connetterli.",
    editNode: "Modifica il nodo"
};
// Dutch
var $bebd28704f2536ea$var$nl = {
    addDescription: "Klik op een leeg gebied om een nieuwe node te maken.",
    addEdge: "Link toevoegen",
    addNode: "Node toevoegen",
    back: "Terug",
    close: "Sluiten",
    createEdgeError: "Kan geen link maken naar een cluster.",
    del: "Selectie verwijderen",
    deleteClusterError: "Clusters kunnen niet worden verwijderd.",
    edgeDescription: "Klik op een node en sleep de link naar een andere node om ze te verbinden.",
    edit: "Wijzigen",
    editClusterError: "Clusters kunnen niet worden aangepast.",
    editEdge: "Link wijzigen",
    editEdgeDescription: "Klik op de verbindingspunten en sleep ze naar een node om daarmee te verbinden.",
    editNode: "Node wijzigen"
};
// Portuguese Brazil
var $bebd28704f2536ea$var$pt = {
    addDescription: "Clique em um espa\xe7o em branco para adicionar um novo n\xf3",
    addEdge: "Adicionar aresta",
    addNode: "Adicionar n\xf3",
    back: "Voltar",
    close: "Fechar",
    createEdgeError: "N\xe3o foi poss\xedvel linkar arestas a um cluster.",
    del: "Remover selecionado",
    deleteClusterError: "Clusters n\xe3o puderam ser removidos.",
    edgeDescription: "Clique em um n\xf3 e arraste a aresta at\xe9 outro n\xf3 para conect\xe1-los",
    edit: "Editar",
    editClusterError: "Clusters n\xe3o puderam ser editados.",
    editEdge: "Editar aresta",
    editEdgeDescription: "Clique nos pontos de controle e os arraste para um n\xf3 para conect\xe1-los",
    editNode: "Editar n\xf3"
};
// Russian
var $bebd28704f2536ea$var$ru = {
    addDescription: "\u041A\u043B\u0438\u043A\u043D\u0438\u0442\u0435 \u0432 \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u043E\u0435 \u043C\u0435\u0441\u0442\u043E, \u0447\u0442\u043E\u0431\u044B \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0443\u0437\u0435\u043B.",
    addEdge: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0440\u0435\u0431\u0440\u043E",
    addNode: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0443\u0437\u0435\u043B",
    back: "\u041D\u0430\u0437\u0430\u0434",
    close: "\u0417\u0430\u043A\u0440\u044B\u0432\u0430\u0442\u044C",
    createEdgeError: "\u041D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C \u0440\u0435\u0431\u0440\u0430 \u0432 \u043A\u043B\u0430\u0441\u0442\u0435\u0440.",
    del: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0435",
    deleteClusterError: "\u041A\u043B\u0430\u0441\u0442\u0435\u0440\u044B \u043D\u0435 \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u0443\u0434\u0430\u043B\u0435\u043D\u044B",
    edgeDescription: "\u041A\u043B\u0438\u043A\u043D\u0438\u0442\u0435 \u043D\u0430 \u0443\u0437\u0435\u043B \u0438 \u043F\u0440\u043E\u0442\u044F\u043D\u0438\u0442\u0435 \u0440\u0435\u0431\u0440\u043E \u043A \u0434\u0440\u0443\u0433\u043E\u043C\u0443 \u0443\u0437\u043B\u0443, \u0447\u0442\u043E\u0431\u044B \u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C \u0438\u0445.",
    edit: "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
    editClusterError: "\u041A\u043B\u0430\u0441\u0442\u0435\u0440\u044B \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u0434\u043B\u044F \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F.",
    editEdge: "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0440\u0435\u0431\u0440\u043E",
    editEdgeDescription: "\u041A\u043B\u0438\u043A\u043D\u0438\u0442\u0435 \u043D\u0430 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044C\u043D\u044B\u0435 \u0442\u043E\u0447\u043A\u0438 \u0438 \u043F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u0435 \u0438\u0445 \u0432 \u0443\u0437\u0435\u043B, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0441\u044F \u043A \u043D\u0435\u043C\u0443.",
    editNode: "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0443\u0437\u0435\u043B"
};
// Chinese
var $bebd28704f2536ea$var$cn = {
    addDescription: "\u5355\u51FB\u7A7A\u767D\u5904\u653E\u7F6E\u65B0\u8282\u70B9\u3002",
    addEdge: "\u6DFB\u52A0\u8FDE\u63A5\u7EBF",
    addNode: "\u6DFB\u52A0\u8282\u70B9",
    back: "\u8FD4\u56DE",
    close: "\u95DC\u9589",
    createEdgeError: "\u65E0\u6CD5\u5C06\u8FDE\u63A5\u7EBF\u8FDE\u63A5\u5230\u7FA4\u96C6\u3002",
    del: "\u5220\u9664\u9009\u5B9A",
    deleteClusterError: "\u65E0\u6CD5\u5220\u9664\u7FA4\u96C6\u3002",
    edgeDescription: "\u5355\u51FB\u67D0\u4E2A\u8282\u70B9\u5E76\u5C06\u8BE5\u8FDE\u63A5\u7EBF\u62D6\u52A8\u5230\u53E6\u4E00\u4E2A\u8282\u70B9\u4EE5\u8FDE\u63A5\u5B83\u4EEC\u3002",
    edit: "\u7F16\u8F91",
    editClusterError: "\u65E0\u6CD5\u7F16\u8F91\u7FA4\u96C6\u3002",
    editEdge: "\u7F16\u8F91\u8FDE\u63A5\u7EBF",
    editEdgeDescription: "\u5355\u51FB\u63A7\u5236\u8282\u70B9\u5E76\u5C06\u5B83\u4EEC\u62D6\u5230\u8282\u70B9\u4E0A\u8FDE\u63A5\u3002",
    editNode: "\u7F16\u8F91\u8282\u70B9"
};
// Ukrainian
var $bebd28704f2536ea$var$uk = {
    addDescription: "K\u043B\u0456\u043A\u043D\u0456\u0442\u044C \u043D\u0430 \u0432\u0456\u043B\u044C\u043D\u0435 \u043C\u0456\u0441\u0446\u0435, \u0449\u043E\u0431 \u0434\u043E\u0434\u0430\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0432\u0443\u0437\u043E\u043B.",
    addEdge: "\u0414\u043E\u0434\u0430\u0442\u0438 \u043A\u0440\u0430\u0439",
    addNode: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0432\u0443\u0437\u043E\u043B",
    back: "\u041D\u0430\u0437\u0430\u0434",
    close: "\u0417\u0430\u043A\u0440\u0438\u0442\u0438",
    createEdgeError: "\u041D\u0435 \u043C\u043E\u0436\u043B\u0438\u0432\u043E \u043E\u0431'\u0454\u0434\u043D\u0430\u0442\u0438 \u043A\u0440\u0430\u0457 \u0432 \u0433\u0440\u0443\u043F\u0443.",
    del: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u043E\u0431\u0440\u0430\u043D\u0435",
    deleteClusterError: "\u0413\u0440\u0443\u043F\u0438 \u043D\u0435 \u043C\u043E\u0436\u0443\u0442\u044C \u0431\u0443\u0442\u0438 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u0456.",
    edgeDescription: "\u041A\u043B\u0456\u043A\u043D\u0456\u0442\u044C \u043D\u0430 \u0432\u0443\u0437\u043E\u043B \u0456 \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0456\u0442\u044C \u043A\u0440\u0430\u0439 \u0434\u043E \u0456\u043D\u0448\u043E\u0433\u043E \u0432\u0443\u0437\u043B\u0430, \u0449\u043E\u0431 \u0457\u0445 \u0437'\u0454\u0434\u043D\u0430\u0442\u0438.",
    edit: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438",
    editClusterError: "\u0413\u0440\u0443\u043F\u0438 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0456 \u0434\u043B\u044F \u0440\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u043D\u043D\u044F.",
    editEdge: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u043A\u0440\u0430\u0439",
    editEdgeDescription: "\u041A\u043B\u0456\u043A\u043D\u0456\u0442\u044C \u043D\u0430 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044C\u043D\u0456 \u0442\u043E\u0447\u043A\u0438 \u0456 \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0456\u0442\u044C \u0457\u0445 \u0443 \u0432\u0443\u0437\u043E\u043B, \u0449\u043E\u0431 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438\u0441\u044F \u0434\u043E \u043D\u044C\u043E\u0433\u043E.",
    editNode: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0432\u0443\u0437\u043E\u043B"
};
// French
var $bebd28704f2536ea$var$fr = {
    addDescription: "Cliquez dans un endroit vide pour placer un n\u0153ud.",
    addEdge: "Ajouter un lien",
    addNode: "Ajouter un n\u0153ud",
    back: "Retour",
    close: "Fermer",
    createEdgeError: "Impossible de cr\xe9er un lien vers un cluster.",
    del: "Effacer la s\xe9lection",
    deleteClusterError: "Les clusters ne peuvent pas \xeatre effac\xe9s.",
    edgeDescription: "Cliquez sur un n\u0153ud et glissez le lien vers un autre n\u0153ud pour les connecter.",
    edit: "\xc9diter",
    editClusterError: "Les clusters ne peuvent pas \xeatre \xe9dit\xe9s.",
    editEdge: "\xc9diter le lien",
    editEdgeDescription: "Cliquez sur les points de contr\xf4le et glissez-les pour connecter un n\u0153ud.",
    editNode: "\xc9diter le n\u0153ud"
};
// Czech
var $bebd28704f2536ea$var$cs = {
    addDescription: "Kluknut\xedm do pr\xe1zdn\xe9ho prostoru m\u016F\u017Eete p\u0159idat nov\xfd vrchol.",
    addEdge: "P\u0159idat hranu",
    addNode: "P\u0159idat vrchol",
    back: "Zp\u011Bt",
    close: "Zav\u0159\xedt",
    createEdgeError: "Nelze p\u0159ipojit hranu ke shluku.",
    del: "Smazat v\xfdb\u011Br",
    deleteClusterError: "Nelze mazat shluky.",
    edgeDescription: "P\u0159eta\u017Een\xedm z jednoho vrcholu do druh\xe9ho m\u016F\u017Eete spojit tyto vrcholy novou hranou.",
    edit: "Upravit",
    editClusterError: "Nelze upravovat shluky.",
    editEdge: "Upravit hranu",
    editEdgeDescription: "P\u0159eta\u017Een\xedm kontroln\xedho vrcholu hrany ji m\u016F\u017Eete p\u0159ipojit k jin\xe9mu vrcholu.",
    editNode: "Upravit vrchol"
};
var $bebd28704f2536ea$var$locales = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    cn: $bebd28704f2536ea$var$cn,
    cs: $bebd28704f2536ea$var$cs,
    de: $bebd28704f2536ea$var$de,
    en: $bebd28704f2536ea$var$en,
    es: $bebd28704f2536ea$var$es,
    fr: $bebd28704f2536ea$var$fr,
    it: $bebd28704f2536ea$var$it,
    nl: $bebd28704f2536ea$var$nl,
    pt: $bebd28704f2536ea$var$pt,
    ru: $bebd28704f2536ea$var$ru,
    uk: $bebd28704f2536ea$var$uk
});
/**
 * Normalizes language code into the format used internally.
 *
 * @param locales - All the available locales.
 * @param rawCode - The original code as supplied by the user.
 * @returns Language code in the format language-COUNTRY or language, eventually
 * fallbacks to en.
 */ function $bebd28704f2536ea$var$normalizeLanguageCode(locales, rawCode) {
    try {
        var _rawCode$split = rawCode.split(/[-_ /]/, 2), _rawCode$split2 = $bebd28704f2536ea$var$_slicedToArray(_rawCode$split, 2), rawLanguage = _rawCode$split2[0], rawCountry = _rawCode$split2[1];
        var language = rawLanguage != null ? rawLanguage.toLowerCase() : null;
        var country = rawCountry != null ? rawCountry.toUpperCase() : null;
        if (language && country) {
            var code = language + "-" + country;
            if (Object.prototype.hasOwnProperty.call(locales, code)) return code;
            else {
                var _context;
                console.warn($bebd28704f2536ea$var$_concatInstanceProperty(_context = "Unknown variant ".concat(country, " of language ")).call(_context, language, "."));
            }
        }
        if (language) {
            var _code = language;
            if (Object.prototype.hasOwnProperty.call(locales, _code)) return _code;
            else console.warn("Unknown language ".concat(language));
        }
        console.warn("Unknown locale ".concat(rawCode, ", falling back to English."));
        return "en";
    } catch (error) {
        console.error(error);
        console.warn("Unexpected error while normalizing locale ".concat(rawCode, ", falling back to English."));
        return "en";
    }
}
/**
 * Associates a canvas to a given image, containing a number of renderings
 * of the image at various sizes.
 *
 * This technique is known as 'mipmapping'.
 *
 * NOTE: Images can also be of type 'data:svg+xml`. This code also works
 *       for svg, but the mipmapping may not be necessary.
 *
 * @param {Image} image
 */ var $bebd28704f2536ea$var$CachedImage = /*#__PURE__*/ function() {
    /**
   * @ignore
   */ function CachedImage() {
        $bebd28704f2536ea$var$_classCallCheck(this, CachedImage);
        this.NUM_ITERATIONS = 4; // Number of items in the coordinates array
        this.image = new Image();
        this.canvas = document.createElement("canvas");
    }
    /**
   * Called when the image has been successfully loaded.
   */ $bebd28704f2536ea$var$_createClass(CachedImage, [
        {
            key: "init",
            value: function init() {
                if (this.initialized()) return;
                this.src = this.image.src; // For same interface with Image
                var w = this.image.width;
                var h = this.image.height;
                // Ease external access
                this.width = w;
                this.height = h;
                var h2 = Math.floor(h / 2);
                var h4 = Math.floor(h / 4);
                var h8 = Math.floor(h / 8);
                var h16 = Math.floor(h / 16);
                var w2 = Math.floor(w / 2);
                var w4 = Math.floor(w / 4);
                var w8 = Math.floor(w / 8);
                var w16 = Math.floor(w / 16);
                // Make canvas as small as possible
                this.canvas.width = 3 * w4;
                this.canvas.height = h2;
                // Coordinates and sizes of images contained in the canvas
                // Values per row:  [top x, left y, width, height]
                this.coordinates = [
                    [
                        0,
                        0,
                        w2,
                        h2
                    ],
                    [
                        w2,
                        0,
                        w4,
                        h4
                    ],
                    [
                        w2,
                        h4,
                        w8,
                        h8
                    ],
                    [
                        5 * w8,
                        h4,
                        w16,
                        h16
                    ]
                ];
                this._fillMipMap();
            }
        },
        {
            key: "initialized",
            value: function initialized() {
                return this.coordinates !== undefined;
            }
        },
        {
            key: "_fillMipMap",
            value: function _fillMipMap() {
                var ctx = this.canvas.getContext("2d");
                // First zoom-level comes from the image
                var to = this.coordinates[0];
                ctx.drawImage(this.image, to[0], to[1], to[2], to[3]);
                // The rest are copy actions internal to the canvas/context
                for(var iterations = 1; iterations < this.NUM_ITERATIONS; iterations++){
                    var from = this.coordinates[iterations - 1];
                    var _to = this.coordinates[iterations];
                    ctx.drawImage(this.canvas, from[0], from[1], from[2], from[3], _to[0], _to[1], _to[2], _to[3]);
                }
            }
        },
        {
            key: "drawImageAtPosition",
            value: function drawImageAtPosition(ctx, factor, left, top, width, height) {
                if (!this.initialized()) return; //can't draw image yet not intialized
                if (factor > 2) {
                    // Determine which zoomed image to use
                    factor *= 0.5;
                    var iterations = 0;
                    while(factor > 2 && iterations < this.NUM_ITERATIONS){
                        factor *= 0.5;
                        iterations += 1;
                    }
                    if (iterations >= this.NUM_ITERATIONS) iterations = this.NUM_ITERATIONS - 1;
                    //console.log("iterations: " + iterations);
                    var from = this.coordinates[iterations];
                    ctx.drawImage(this.canvas, from[0], from[1], from[2], from[3], left, top, width, height);
                } else // Draw image directly
                ctx.drawImage(this.image, left, top, width, height);
            }
        }
    ]);
    return CachedImage;
}();
/**
 * This callback is a callback that accepts an Image.
 *
 * @callback ImageCallback
 * @param {Image} image
 */ /**
 * This class loads images and keeps them stored.
 *
 * @param {ImageCallback} callback
 */ var $bebd28704f2536ea$export$55d75908a8cadbee = /*#__PURE__*/ function() {
    /**
   * @param {ImageCallback} callback
   */ function Images(callback) {
        $bebd28704f2536ea$var$_classCallCheck(this, Images);
        this.images = {};
        this.imageBroken = {};
        this.callback = callback;
    }
    /**
   * @param {string} url                      The original Url that failed to load, if the broken image is successfully loaded it will be added to the cache using this Url as the key so that subsequent requests for this Url will return the broken image
   * @param {string} brokenUrl                Url the broken image to try and load
   * @param {Image} imageToLoadBrokenUrlOn   The image object
   */ $bebd28704f2536ea$var$_createClass(Images, [
        {
            key: "_tryloadBrokenUrl",
            value: function _tryloadBrokenUrl(url, brokenUrl, imageToLoadBrokenUrlOn) {
                //If these parameters aren't specified then exit the function because nothing constructive can be done
                if (url === undefined || imageToLoadBrokenUrlOn === undefined) return;
                if (brokenUrl === undefined) {
                    console.warn("No broken url image defined");
                    return;
                }
                //Clear the old subscription to the error event and put a new in place that only handle errors in loading the brokenImageUrl
                imageToLoadBrokenUrlOn.image.onerror = function() {
                    console.error("Could not load brokenImage:", brokenUrl);
                // cache item will contain empty image, this should be OK for default
                };
                //Set the source of the image to the brokenUrl, this is actually what kicks off the loading of the broken image
                imageToLoadBrokenUrlOn.image.src = brokenUrl;
            }
        },
        {
            key: "_redrawWithImage",
            value: function _redrawWithImage(imageToRedrawWith) {
                if (this.callback) this.callback(imageToRedrawWith);
            }
        },
        {
            key: "load",
            value: function load(url, brokenUrl) {
                var _this = this;
                //Try and get the image from the cache, if successful then return the cached image
                var cachedImage = this.images[url];
                if (cachedImage) return cachedImage;
                //Create a new image
                var img = new $bebd28704f2536ea$var$CachedImage();
                // Need to add to cache here, otherwise final return will spawn different copies of the same image,
                // Also, there will be multiple loads of the same image.
                this.images[url] = img;
                //Subscribe to the event that is raised if the image loads successfully
                img.image.onload = function() {
                    // Properly init the cached item and then request a redraw
                    _this._fixImageCoordinates(img.image);
                    img.init();
                    _this._redrawWithImage(img);
                };
                //Subscribe to the event that is raised if the image fails to load
                img.image.onerror = function() {
                    console.error("Could not load image:", url);
                    //Try and load the image specified by the brokenUrl using
                    _this._tryloadBrokenUrl(url, brokenUrl, img);
                };
                //Set the source of the image to the url, this is what actually kicks off the loading of the image
                img.image.src = url;
                //Return the new image
                return img;
            }
        },
        {
            key: "_fixImageCoordinates",
            value: function _fixImageCoordinates(imageToCache) {
                if (imageToCache.width === 0) {
                    document.body.appendChild(imageToCache);
                    imageToCache.width = imageToCache.offsetWidth;
                    imageToCache.height = imageToCache.offsetHeight;
                    document.body.removeChild(imageToCache);
                }
            }
        }
    ]);
    return Images;
}();
var $bebd28704f2536ea$var$internalMetadata = {
    exports: {}
};
// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
var $bebd28704f2536ea$var$fails$9 = $bebd28704f2536ea$var$fails$w;
var $bebd28704f2536ea$var$arrayBufferNonExtensible = $bebd28704f2536ea$var$fails$9(function() {
    if (typeof ArrayBuffer == 'function') {
        var buffer = new ArrayBuffer(8);
        // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
        if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', {
            value: 8
        });
    }
});
var $bebd28704f2536ea$var$fails$8 = $bebd28704f2536ea$var$fails$w;
var $bebd28704f2536ea$var$isObject$6 = $bebd28704f2536ea$var$isObject$j;
var $bebd28704f2536ea$var$classof$2 = $bebd28704f2536ea$var$classofRaw$2;
var $bebd28704f2536ea$var$ARRAY_BUFFER_NON_EXTENSIBLE = $bebd28704f2536ea$var$arrayBufferNonExtensible;
// eslint-disable-next-line es/no-object-isextensible -- safe
var $bebd28704f2536ea$var$$isExtensible = Object.isExtensible;
var $bebd28704f2536ea$var$FAILS_ON_PRIMITIVES$1 = $bebd28704f2536ea$var$fails$8(function() {
    $bebd28704f2536ea$var$$isExtensible(1);
});
// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
var $bebd28704f2536ea$var$objectIsExtensible = $bebd28704f2536ea$var$FAILS_ON_PRIMITIVES$1 || $bebd28704f2536ea$var$ARRAY_BUFFER_NON_EXTENSIBLE ? function isExtensible(it) {
    if (!$bebd28704f2536ea$var$isObject$6(it)) return false;
    if ($bebd28704f2536ea$var$ARRAY_BUFFER_NON_EXTENSIBLE && $bebd28704f2536ea$var$classof$2(it) === 'ArrayBuffer') return false;
    return $bebd28704f2536ea$var$$isExtensible ? $bebd28704f2536ea$var$$isExtensible(it) : true;
} : $bebd28704f2536ea$var$$isExtensible;
var $bebd28704f2536ea$var$fails$7 = $bebd28704f2536ea$var$fails$w;
var $bebd28704f2536ea$var$freezing = !$bebd28704f2536ea$var$fails$7(function() {
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
    return Object.isExtensible(Object.preventExtensions({}));
});
var $bebd28704f2536ea$var$$$g = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$uncurryThis$4 = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$hiddenKeys = $bebd28704f2536ea$var$hiddenKeys$6;
var $bebd28704f2536ea$var$isObject$5 = $bebd28704f2536ea$var$isObject$j;
var $bebd28704f2536ea$var$hasOwn$3 = $bebd28704f2536ea$var$hasOwnProperty_1;
var $bebd28704f2536ea$var$defineProperty$2 = $bebd28704f2536ea$var$objectDefineProperty.f;
var $bebd28704f2536ea$var$getOwnPropertyNamesModule = $bebd28704f2536ea$var$objectGetOwnPropertyNames;
var $bebd28704f2536ea$var$getOwnPropertyNamesExternalModule = $bebd28704f2536ea$var$objectGetOwnPropertyNamesExternal;
var $bebd28704f2536ea$var$isExtensible$1 = $bebd28704f2536ea$var$objectIsExtensible;
var $bebd28704f2536ea$var$uid = $bebd28704f2536ea$var$uid$4;
var $bebd28704f2536ea$var$FREEZING$1 = $bebd28704f2536ea$var$freezing;
var $bebd28704f2536ea$var$REQUIRED = false;
var $bebd28704f2536ea$var$METADATA = $bebd28704f2536ea$var$uid('meta');
var $bebd28704f2536ea$var$id$1 = 0;
var $bebd28704f2536ea$var$setMetadata = function(it) {
    $bebd28704f2536ea$var$defineProperty$2(it, $bebd28704f2536ea$var$METADATA, {
        value: {
            objectID: 'O' + $bebd28704f2536ea$var$id$1++,
            weakData: {} // weak collections IDs
        }
    });
};
var $bebd28704f2536ea$var$fastKey$1 = function(it, create) {
    // return a primitive with prefix
    if (!$bebd28704f2536ea$var$isObject$5(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$bebd28704f2536ea$var$hasOwn$3(it, $bebd28704f2536ea$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$bebd28704f2536ea$var$isExtensible$1(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $bebd28704f2536ea$var$setMetadata(it);
    // return object ID
    }
    return it[$bebd28704f2536ea$var$METADATA].objectID;
};
var $bebd28704f2536ea$var$getWeakData$1 = function(it, create) {
    if (!$bebd28704f2536ea$var$hasOwn$3(it, $bebd28704f2536ea$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$bebd28704f2536ea$var$isExtensible$1(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $bebd28704f2536ea$var$setMetadata(it);
    // return the store of weak collections IDs
    }
    return it[$bebd28704f2536ea$var$METADATA].weakData;
};
// add metadata on freeze-family methods calling
var $bebd28704f2536ea$var$onFreeze = function(it) {
    if ($bebd28704f2536ea$var$FREEZING$1 && $bebd28704f2536ea$var$REQUIRED && $bebd28704f2536ea$var$isExtensible$1(it) && !$bebd28704f2536ea$var$hasOwn$3(it, $bebd28704f2536ea$var$METADATA)) $bebd28704f2536ea$var$setMetadata(it);
    return it;
};
var $bebd28704f2536ea$var$enable = function() {
    $bebd28704f2536ea$var$meta.enable = function() {};
    $bebd28704f2536ea$var$REQUIRED = true;
    var getOwnPropertyNames = $bebd28704f2536ea$var$getOwnPropertyNamesModule.f;
    var splice = $bebd28704f2536ea$var$uncurryThis$4([].splice);
    var test = {};
    test[$bebd28704f2536ea$var$METADATA] = 1;
    // prevent exposing of metadata key
    if (getOwnPropertyNames(test).length) {
        $bebd28704f2536ea$var$getOwnPropertyNamesModule.f = function(it) {
            var result = getOwnPropertyNames(it);
            for(var i = 0, length1 = result.length; i < length1; i++)if (result[i] === $bebd28704f2536ea$var$METADATA) {
                splice(result, i, 1);
                break;
            }
            return result;
        };
        $bebd28704f2536ea$var$$$g({
            target: 'Object',
            stat: true,
            forced: true
        }, {
            getOwnPropertyNames: $bebd28704f2536ea$var$getOwnPropertyNamesExternalModule.f
        });
    }
};
var $bebd28704f2536ea$var$meta = $bebd28704f2536ea$var$internalMetadata.exports = {
    enable: $bebd28704f2536ea$var$enable,
    fastKey: $bebd28704f2536ea$var$fastKey$1,
    getWeakData: $bebd28704f2536ea$var$getWeakData$1,
    onFreeze: $bebd28704f2536ea$var$onFreeze
};
$bebd28704f2536ea$var$hiddenKeys[$bebd28704f2536ea$var$METADATA] = true;
var $bebd28704f2536ea$var$internalMetadataExports = $bebd28704f2536ea$var$internalMetadata.exports;
var $bebd28704f2536ea$var$bind$5 = $bebd28704f2536ea$var$functionBindContext;
var $bebd28704f2536ea$var$call$1 = $bebd28704f2536ea$var$functionCall;
var $bebd28704f2536ea$var$anObject$3 = $bebd28704f2536ea$var$anObject$d;
var $bebd28704f2536ea$var$tryToString$1 = $bebd28704f2536ea$var$tryToString$6;
var $bebd28704f2536ea$var$isArrayIteratorMethod = $bebd28704f2536ea$var$isArrayIteratorMethod$2;
var $bebd28704f2536ea$var$lengthOfArrayLike$2 = $bebd28704f2536ea$var$lengthOfArrayLike$c;
var $bebd28704f2536ea$var$isPrototypeOf$6 = $bebd28704f2536ea$var$objectIsPrototypeOf;
var $bebd28704f2536ea$var$getIterator = $bebd28704f2536ea$var$getIterator$2;
var $bebd28704f2536ea$var$getIteratorMethod = $bebd28704f2536ea$var$getIteratorMethod$9;
var $bebd28704f2536ea$var$iteratorClose = $bebd28704f2536ea$var$iteratorClose$2;
var $bebd28704f2536ea$var$$TypeError$3 = TypeError;
var $bebd28704f2536ea$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $bebd28704f2536ea$var$ResultPrototype = $bebd28704f2536ea$var$Result.prototype;
var $bebd28704f2536ea$var$iterate$3 = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $bebd28704f2536ea$var$bind$5(unboundFunction, that);
    var iterator, iterFn, index, length1, result, next, step;
    var stop = function(condition) {
        if (iterator) $bebd28704f2536ea$var$iteratorClose(iterator, 'normal', condition);
        return new $bebd28704f2536ea$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $bebd28704f2536ea$var$anObject$3(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $bebd28704f2536ea$var$getIteratorMethod(iterable);
        if (!iterFn) throw new $bebd28704f2536ea$var$$TypeError$3($bebd28704f2536ea$var$tryToString$1(iterable) + ' is not iterable');
        // optimisation for array iterators
        if ($bebd28704f2536ea$var$isArrayIteratorMethod(iterFn)) {
            for(index = 0, length1 = $bebd28704f2536ea$var$lengthOfArrayLike$2(iterable); length1 > index; index++){
                result = callFn(iterable[index]);
                if (result && $bebd28704f2536ea$var$isPrototypeOf$6($bebd28704f2536ea$var$ResultPrototype, result)) return result;
            }
            return new $bebd28704f2536ea$var$Result(false);
        }
        iterator = $bebd28704f2536ea$var$getIterator(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $bebd28704f2536ea$var$call$1(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $bebd28704f2536ea$var$iteratorClose(iterator, 'throw', error);
        }
        if (typeof result == 'object' && result && $bebd28704f2536ea$var$isPrototypeOf$6($bebd28704f2536ea$var$ResultPrototype, result)) return result;
    }
    return new $bebd28704f2536ea$var$Result(false);
};
var $bebd28704f2536ea$var$isPrototypeOf$5 = $bebd28704f2536ea$var$objectIsPrototypeOf;
var $bebd28704f2536ea$var$$TypeError$2 = TypeError;
var $bebd28704f2536ea$var$anInstance$3 = function(it, Prototype) {
    if ($bebd28704f2536ea$var$isPrototypeOf$5(Prototype, it)) return it;
    throw new $bebd28704f2536ea$var$$TypeError$2('Incorrect invocation');
};
var $bebd28704f2536ea$var$$$f = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$global$5 = $bebd28704f2536ea$var$global$n;
var $bebd28704f2536ea$var$InternalMetadataModule$1 = $bebd28704f2536ea$var$internalMetadataExports;
var $bebd28704f2536ea$var$fails$6 = $bebd28704f2536ea$var$fails$w;
var $bebd28704f2536ea$var$createNonEnumerableProperty = $bebd28704f2536ea$var$createNonEnumerableProperty$6;
var $bebd28704f2536ea$var$iterate$2 = $bebd28704f2536ea$var$iterate$3;
var $bebd28704f2536ea$var$anInstance$2 = $bebd28704f2536ea$var$anInstance$3;
var $bebd28704f2536ea$var$isCallable = $bebd28704f2536ea$var$isCallable$i;
var $bebd28704f2536ea$var$isObject$4 = $bebd28704f2536ea$var$isObject$j;
var $bebd28704f2536ea$var$isNullOrUndefined$2 = $bebd28704f2536ea$var$isNullOrUndefined$6;
var $bebd28704f2536ea$var$setToStringTag = $bebd28704f2536ea$var$setToStringTag$6;
var $bebd28704f2536ea$var$defineProperty$1 = $bebd28704f2536ea$var$objectDefineProperty.f;
var $bebd28704f2536ea$var$forEach = $bebd28704f2536ea$var$arrayIteration.forEach;
var $bebd28704f2536ea$var$DESCRIPTORS$5 = $bebd28704f2536ea$var$descriptors;
var $bebd28704f2536ea$var$InternalStateModule$2 = $bebd28704f2536ea$var$internalState;
var $bebd28704f2536ea$var$setInternalState$2 = $bebd28704f2536ea$var$InternalStateModule$2.set;
var $bebd28704f2536ea$var$internalStateGetterFor$2 = $bebd28704f2536ea$var$InternalStateModule$2.getterFor;
var $bebd28704f2536ea$var$collection$3 = function(CONSTRUCTOR_NAME, wrapper, common) {
    var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
    var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
    var ADDER = IS_MAP ? 'set' : 'add';
    var NativeConstructor = $bebd28704f2536ea$var$global$5[CONSTRUCTOR_NAME];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    var exported = {};
    var Constructor;
    if (!$bebd28704f2536ea$var$DESCRIPTORS$5 || !$bebd28704f2536ea$var$isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !$bebd28704f2536ea$var$fails$6(function() {
        new NativeConstructor().entries().next();
    }))) {
        // create collection constructor
        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
        $bebd28704f2536ea$var$InternalMetadataModule$1.enable();
    } else {
        Constructor = wrapper(function(target, iterable) {
            $bebd28704f2536ea$var$setInternalState$2($bebd28704f2536ea$var$anInstance$2(target, Prototype), {
                type: CONSTRUCTOR_NAME,
                collection: new NativeConstructor()
            });
            if (!$bebd28704f2536ea$var$isNullOrUndefined$2(iterable)) $bebd28704f2536ea$var$iterate$2(iterable, target[ADDER], {
                that: target,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $bebd28704f2536ea$var$internalStateGetterFor$2(CONSTRUCTOR_NAME);
        $bebd28704f2536ea$var$forEach([
            'add',
            'clear',
            'delete',
            'forEach',
            'get',
            'has',
            'set',
            'keys',
            'values',
            'entries'
        ], function(KEY) {
            var IS_ADDER = KEY === 'add' || KEY === 'set';
            if (KEY in NativePrototype && !(IS_WEAK && KEY === 'clear')) $bebd28704f2536ea$var$createNonEnumerableProperty(Prototype, KEY, function(a, b) {
                var collection = getInternalState(this).collection;
                if (!IS_ADDER && IS_WEAK && !$bebd28704f2536ea$var$isObject$4(a)) return KEY === 'get' ? undefined : false;
                var result = collection[KEY](a === 0 ? 0 : a, b);
                return IS_ADDER ? this : result;
            });
        });
        IS_WEAK || $bebd28704f2536ea$var$defineProperty$1(Prototype, 'size', {
            configurable: true,
            get: function() {
                return getInternalState(this).collection.size;
            }
        });
    }
    $bebd28704f2536ea$var$setToStringTag(Constructor, CONSTRUCTOR_NAME, false, true);
    exported[CONSTRUCTOR_NAME] = Constructor;
    $bebd28704f2536ea$var$$$f({
        global: true,
        forced: true
    }, exported);
    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
    return Constructor;
};
var $bebd28704f2536ea$var$defineBuiltIn = $bebd28704f2536ea$var$defineBuiltIn$5;
var $bebd28704f2536ea$var$defineBuiltIns$3 = function(target, src, options) {
    for(var key in src)if (options && options.unsafe && target[key]) target[key] = src[key];
    else $bebd28704f2536ea$var$defineBuiltIn(target, key, src[key], options);
    return target;
};
var $bebd28704f2536ea$var$getBuiltIn$1 = $bebd28704f2536ea$var$getBuiltIn$c;
var $bebd28704f2536ea$var$defineBuiltInAccessor$1 = $bebd28704f2536ea$var$defineBuiltInAccessor$3;
var $bebd28704f2536ea$var$wellKnownSymbol = $bebd28704f2536ea$var$wellKnownSymbol$m;
var $bebd28704f2536ea$var$DESCRIPTORS$4 = $bebd28704f2536ea$var$descriptors;
var $bebd28704f2536ea$var$SPECIES = $bebd28704f2536ea$var$wellKnownSymbol('species');
var $bebd28704f2536ea$var$setSpecies$1 = function(CONSTRUCTOR_NAME) {
    var Constructor = $bebd28704f2536ea$var$getBuiltIn$1(CONSTRUCTOR_NAME);
    if ($bebd28704f2536ea$var$DESCRIPTORS$4 && Constructor && !Constructor[$bebd28704f2536ea$var$SPECIES]) $bebd28704f2536ea$var$defineBuiltInAccessor$1(Constructor, $bebd28704f2536ea$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};
var $bebd28704f2536ea$var$create$4 = $bebd28704f2536ea$var$objectCreate;
var $bebd28704f2536ea$var$defineBuiltInAccessor = $bebd28704f2536ea$var$defineBuiltInAccessor$3;
var $bebd28704f2536ea$var$defineBuiltIns$2 = $bebd28704f2536ea$var$defineBuiltIns$3;
var $bebd28704f2536ea$var$bind$4 = $bebd28704f2536ea$var$functionBindContext;
var $bebd28704f2536ea$var$anInstance$1 = $bebd28704f2536ea$var$anInstance$3;
var $bebd28704f2536ea$var$isNullOrUndefined$1 = $bebd28704f2536ea$var$isNullOrUndefined$6;
var $bebd28704f2536ea$var$iterate$1 = $bebd28704f2536ea$var$iterate$3;
var $bebd28704f2536ea$var$defineIterator = $bebd28704f2536ea$var$iteratorDefine;
var $bebd28704f2536ea$var$createIterResultObject = $bebd28704f2536ea$var$createIterResultObject$3;
var $bebd28704f2536ea$var$setSpecies = $bebd28704f2536ea$var$setSpecies$1;
var $bebd28704f2536ea$var$DESCRIPTORS$3 = $bebd28704f2536ea$var$descriptors;
var $bebd28704f2536ea$var$fastKey = $bebd28704f2536ea$var$internalMetadataExports.fastKey;
var $bebd28704f2536ea$var$InternalStateModule$1 = $bebd28704f2536ea$var$internalState;
var $bebd28704f2536ea$var$setInternalState$1 = $bebd28704f2536ea$var$InternalStateModule$1.set;
var $bebd28704f2536ea$var$internalStateGetterFor$1 = $bebd28704f2536ea$var$InternalStateModule$1.getterFor;
var $bebd28704f2536ea$var$collectionStrong$2 = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $bebd28704f2536ea$var$anInstance$1(that, Prototype);
            $bebd28704f2536ea$var$setInternalState$1(that, {
                type: CONSTRUCTOR_NAME,
                index: $bebd28704f2536ea$var$create$4(null),
                first: undefined,
                last: undefined,
                size: 0
            });
            if (!$bebd28704f2536ea$var$DESCRIPTORS$3) that.size = 0;
            if (!$bebd28704f2536ea$var$isNullOrUndefined$1(iterable)) $bebd28704f2536ea$var$iterate$1(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $bebd28704f2536ea$var$internalStateGetterFor$1(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var entry = getEntry(that, key);
            var previous, index;
            // change existing entry
            if (entry) entry.value = value;
            else {
                state.last = entry = {
                    index: index = $bebd28704f2536ea$var$fastKey(key, true),
                    key: key,
                    value: value,
                    previous: previous = state.last,
                    next: undefined,
                    removed: false
                };
                if (!state.first) state.first = entry;
                if (previous) previous.next = entry;
                if ($bebd28704f2536ea$var$DESCRIPTORS$3) state.size++;
                else that.size++;
                // add to index
                if (index !== 'F') state.index[index] = entry;
            }
            return that;
        };
        var getEntry = function(that, key) {
            var state = getInternalState(that);
            // fast case
            var index = $bebd28704f2536ea$var$fastKey(key);
            var entry;
            if (index !== 'F') return state.index[index];
            // frozen object case
            for(entry = state.first; entry; entry = entry.next){
                if (entry.key === key) return entry;
            }
        };
        $bebd28704f2536ea$var$defineBuiltIns$2(Prototype, {
            // `{ Map, Set }.prototype.clear()` methods
            // https://tc39.es/ecma262/#sec-map.prototype.clear
            // https://tc39.es/ecma262/#sec-set.prototype.clear
            clear: function clear() {
                var that = this;
                var state = getInternalState(that);
                var data = state.index;
                var entry = state.first;
                while(entry){
                    entry.removed = true;
                    if (entry.previous) entry.previous = entry.previous.next = undefined;
                    delete data[entry.index];
                    entry = entry.next;
                }
                state.first = state.last = undefined;
                if ($bebd28704f2536ea$var$DESCRIPTORS$3) state.size = 0;
                else that.size = 0;
            },
            // `{ Map, Set }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.delete
            // https://tc39.es/ecma262/#sec-set.prototype.delete
            'delete': function(key) {
                var that = this;
                var state = getInternalState(that);
                var entry = getEntry(that, key);
                if (entry) {
                    var next = entry.next;
                    var prev = entry.previous;
                    delete state.index[entry.index];
                    entry.removed = true;
                    if (prev) prev.next = next;
                    if (next) next.previous = prev;
                    if (state.first === entry) state.first = next;
                    if (state.last === entry) state.last = prev;
                    if ($bebd28704f2536ea$var$DESCRIPTORS$3) state.size--;
                    else that.size--;
                }
                return !!entry;
            },
            // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.foreach
            // https://tc39.es/ecma262/#sec-set.prototype.foreach
            forEach: function forEach(callbackfn /* , that = undefined */ ) {
                var state = getInternalState(this);
                var boundFunction = $bebd28704f2536ea$var$bind$4(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                var entry;
                while(entry = entry ? entry.next : state.first){
                    boundFunction(entry.value, entry.key, this);
                    // revert to the last existing entry
                    while(entry && entry.removed)entry = entry.previous;
                }
            },
            // `{ Map, Set}.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.has
            // https://tc39.es/ecma262/#sec-set.prototype.has
            has: function has(key) {
                return !!getEntry(this, key);
            }
        });
        $bebd28704f2536ea$var$defineBuiltIns$2(Prototype, IS_MAP ? {
            // `Map.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-map.prototype.get
            get: function get(key) {
                var entry = getEntry(this, key);
                return entry && entry.value;
            },
            // `Map.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-map.prototype.set
            set: function set(key, value) {
                return define(this, key === 0 ? 0 : key, value);
            }
        } : {
            // `Set.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-set.prototype.add
            add: function add(value) {
                return define(this, value = value === 0 ? 0 : value, value);
            }
        });
        if ($bebd28704f2536ea$var$DESCRIPTORS$3) $bebd28704f2536ea$var$defineBuiltInAccessor(Prototype, 'size', {
            configurable: true,
            get: function() {
                return getInternalState(this).size;
            }
        });
        return Constructor;
    },
    setStrong: function(Constructor, CONSTRUCTOR_NAME, IS_MAP) {
        var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
        var getInternalCollectionState = $bebd28704f2536ea$var$internalStateGetterFor$1(CONSTRUCTOR_NAME);
        var getInternalIteratorState = $bebd28704f2536ea$var$internalStateGetterFor$1(ITERATOR_NAME);
        // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
        // https://tc39.es/ecma262/#sec-map.prototype.entries
        // https://tc39.es/ecma262/#sec-map.prototype.keys
        // https://tc39.es/ecma262/#sec-map.prototype.values
        // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
        // https://tc39.es/ecma262/#sec-set.prototype.entries
        // https://tc39.es/ecma262/#sec-set.prototype.keys
        // https://tc39.es/ecma262/#sec-set.prototype.values
        // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
        $bebd28704f2536ea$var$defineIterator(Constructor, CONSTRUCTOR_NAME, function(iterated, kind) {
            $bebd28704f2536ea$var$setInternalState$1(this, {
                type: ITERATOR_NAME,
                target: iterated,
                state: getInternalCollectionState(iterated),
                kind: kind,
                last: undefined
            });
        }, function() {
            var state = getInternalIteratorState(this);
            var kind = state.kind;
            var entry = state.last;
            // revert to the last existing entry
            while(entry && entry.removed)entry = entry.previous;
            // get next entry
            if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
                // or finish the iteration
                state.target = undefined;
                return $bebd28704f2536ea$var$createIterResultObject(undefined, true);
            }
            // return step by kind
            if (kind === 'keys') return $bebd28704f2536ea$var$createIterResultObject(entry.key, false);
            if (kind === 'values') return $bebd28704f2536ea$var$createIterResultObject(entry.value, false);
            return $bebd28704f2536ea$var$createIterResultObject([
                entry.key,
                entry.value
            ], false);
        }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
        // `{ Map, Set }.prototype[@@species]` accessors
        // https://tc39.es/ecma262/#sec-get-map-@@species
        // https://tc39.es/ecma262/#sec-get-set-@@species
        $bebd28704f2536ea$var$setSpecies(CONSTRUCTOR_NAME);
    }
};
var $bebd28704f2536ea$var$collection$2 = $bebd28704f2536ea$var$collection$3;
var $bebd28704f2536ea$var$collectionStrong$1 = $bebd28704f2536ea$var$collectionStrong$2;
// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
$bebd28704f2536ea$var$collection$2('Map', function(init) {
    return function Map() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, $bebd28704f2536ea$var$collectionStrong$1);
var $bebd28704f2536ea$var$path$f = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$map$2 = $bebd28704f2536ea$var$path$f.Map;
var $bebd28704f2536ea$var$parent$v = $bebd28704f2536ea$var$map$2;
var $bebd28704f2536ea$var$map$1 = $bebd28704f2536ea$var$parent$v;
var $bebd28704f2536ea$var$map = $bebd28704f2536ea$var$map$1;
var $bebd28704f2536ea$var$_Map = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$map);
/**
 * This class can store groups and options specific for groups.
 */ var $bebd28704f2536ea$var$Groups = /*#__PURE__*/ function() {
    /**
   * @ignore
   */ function Groups() {
        $bebd28704f2536ea$var$_classCallCheck(this, Groups);
        this.clear();
        this._defaultIndex = 0;
        this._groupIndex = 0;
        this._defaultGroups = [
            {
                border: "#2B7CE9",
                background: "#97C2FC",
                highlight: {
                    border: "#2B7CE9",
                    background: "#D2E5FF"
                },
                hover: {
                    border: "#2B7CE9",
                    background: "#D2E5FF"
                }
            },
            // 0: blue
            {
                border: "#FFA500",
                background: "#FFFF00",
                highlight: {
                    border: "#FFA500",
                    background: "#FFFFA3"
                },
                hover: {
                    border: "#FFA500",
                    background: "#FFFFA3"
                }
            },
            // 1: yellow
            {
                border: "#FA0A10",
                background: "#FB7E81",
                highlight: {
                    border: "#FA0A10",
                    background: "#FFAFB1"
                },
                hover: {
                    border: "#FA0A10",
                    background: "#FFAFB1"
                }
            },
            // 2: red
            {
                border: "#41A906",
                background: "#7BE141",
                highlight: {
                    border: "#41A906",
                    background: "#A1EC76"
                },
                hover: {
                    border: "#41A906",
                    background: "#A1EC76"
                }
            },
            // 3: green
            {
                border: "#E129F0",
                background: "#EB7DF4",
                highlight: {
                    border: "#E129F0",
                    background: "#F0B3F5"
                },
                hover: {
                    border: "#E129F0",
                    background: "#F0B3F5"
                }
            },
            // 4: magenta
            {
                border: "#7C29F0",
                background: "#AD85E4",
                highlight: {
                    border: "#7C29F0",
                    background: "#D3BDF0"
                },
                hover: {
                    border: "#7C29F0",
                    background: "#D3BDF0"
                }
            },
            // 5: purple
            {
                border: "#C37F00",
                background: "#FFA807",
                highlight: {
                    border: "#C37F00",
                    background: "#FFCA66"
                },
                hover: {
                    border: "#C37F00",
                    background: "#FFCA66"
                }
            },
            // 6: orange
            {
                border: "#4220FB",
                background: "#6E6EFD",
                highlight: {
                    border: "#4220FB",
                    background: "#9B9BFD"
                },
                hover: {
                    border: "#4220FB",
                    background: "#9B9BFD"
                }
            },
            // 7: darkblue
            {
                border: "#FD5A77",
                background: "#FFC0CB",
                highlight: {
                    border: "#FD5A77",
                    background: "#FFD1D9"
                },
                hover: {
                    border: "#FD5A77",
                    background: "#FFD1D9"
                }
            },
            // 8: pink
            {
                border: "#4AD63A",
                background: "#C2FABC",
                highlight: {
                    border: "#4AD63A",
                    background: "#E6FFE3"
                },
                hover: {
                    border: "#4AD63A",
                    background: "#E6FFE3"
                }
            },
            // 9: mint
            {
                border: "#990000",
                background: "#EE0000",
                highlight: {
                    border: "#BB0000",
                    background: "#FF3333"
                },
                hover: {
                    border: "#BB0000",
                    background: "#FF3333"
                }
            },
            // 10:bright red
            {
                border: "#FF6000",
                background: "#FF6000",
                highlight: {
                    border: "#FF6000",
                    background: "#FF6000"
                },
                hover: {
                    border: "#FF6000",
                    background: "#FF6000"
                }
            },
            // 12: real orange
            {
                border: "#97C2FC",
                background: "#2B7CE9",
                highlight: {
                    border: "#D2E5FF",
                    background: "#2B7CE9"
                },
                hover: {
                    border: "#D2E5FF",
                    background: "#2B7CE9"
                }
            },
            // 13: blue
            {
                border: "#399605",
                background: "#255C03",
                highlight: {
                    border: "#399605",
                    background: "#255C03"
                },
                hover: {
                    border: "#399605",
                    background: "#255C03"
                }
            },
            // 14: green
            {
                border: "#B70054",
                background: "#FF007E",
                highlight: {
                    border: "#B70054",
                    background: "#FF007E"
                },
                hover: {
                    border: "#B70054",
                    background: "#FF007E"
                }
            },
            // 15: magenta
            {
                border: "#AD85E4",
                background: "#7C29F0",
                highlight: {
                    border: "#D3BDF0",
                    background: "#7C29F0"
                },
                hover: {
                    border: "#D3BDF0",
                    background: "#7C29F0"
                }
            },
            // 16: purple
            {
                border: "#4557FA",
                background: "#000EA1",
                highlight: {
                    border: "#6E6EFD",
                    background: "#000EA1"
                },
                hover: {
                    border: "#6E6EFD",
                    background: "#000EA1"
                }
            },
            // 17: darkblue
            {
                border: "#FFC0CB",
                background: "#FD5A77",
                highlight: {
                    border: "#FFD1D9",
                    background: "#FD5A77"
                },
                hover: {
                    border: "#FFD1D9",
                    background: "#FD5A77"
                }
            },
            // 18: pink
            {
                border: "#C2FABC",
                background: "#74D66A",
                highlight: {
                    border: "#E6FFE3",
                    background: "#74D66A"
                },
                hover: {
                    border: "#E6FFE3",
                    background: "#74D66A"
                }
            },
            // 19: mint
            {
                border: "#EE0000",
                background: "#990000",
                highlight: {
                    border: "#FF3333",
                    background: "#BB0000"
                },
                hover: {
                    border: "#FF3333",
                    background: "#BB0000"
                }
            } // 20:bright red
        ];
        this.options = {};
        this.defaultOptions = {
            useDefaultGroups: true
        };
        $bebd28704f2536ea$var$_Object$assign(this.options, this.defaultOptions);
    }
    /**
   *
   * @param {object} options
   */ $bebd28704f2536ea$var$_createClass(Groups, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                var optionFields = [
                    "useDefaultGroups"
                ];
                if (options !== undefined) for(var groupName in options){
                    if (Object.prototype.hasOwnProperty.call(options, groupName)) {
                        if ($bebd28704f2536ea$var$_indexOfInstanceProperty(optionFields).call(optionFields, groupName) === -1) {
                            var group = options[groupName];
                            this.add(groupName, group);
                        }
                    }
                }
            }
        },
        {
            key: "clear",
            value: function clear() {
                this._groups = new $bebd28704f2536ea$var$_Map();
                this._groupNames = [];
            }
        },
        {
            key: "get",
            value: function get(groupname) {
                var shouldCreate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                var group = this._groups.get(groupname);
                if (group === undefined && shouldCreate) {
                    if (this.options.useDefaultGroups === false && this._groupNames.length > 0) {
                        // create new group
                        var index = this._groupIndex % this._groupNames.length;
                        ++this._groupIndex;
                        group = {};
                        group.color = this._groups.get(this._groupNames[index]);
                        this._groups.set(groupname, group);
                    } else {
                        // create new group
                        var _index = this._defaultIndex % this._defaultGroups.length;
                        this._defaultIndex++;
                        group = {};
                        group.color = this._defaultGroups[_index];
                        this._groups.set(groupname, group);
                    }
                }
                return group;
            }
        },
        {
            key: "add",
            value: function add(groupName, style) {
                // Only push group name once to prevent duplicates which would consume more
                // RAM and also skew the distribution towards more often updated groups,
                // neither of which is desirable.
                if (!this._groups.has(groupName)) this._groupNames.push(groupName);
                this._groups.set(groupName, style);
                return style;
            }
        }
    ]);
    return Groups;
}();
var $bebd28704f2536ea$var$$$e = $bebd28704f2536ea$var$_export;
// `Number.isNaN` method
// https://tc39.es/ecma262/#sec-number.isnan
$bebd28704f2536ea$var$$$e({
    target: 'Number',
    stat: true
}, {
    isNaN: function isNaN1(number) {
        // eslint-disable-next-line no-self-compare -- NaN check
        return number !== number;
    }
});
var $bebd28704f2536ea$var$path$e = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$isNan$2 = $bebd28704f2536ea$var$path$e.Number.isNaN;
var $bebd28704f2536ea$var$parent$u = $bebd28704f2536ea$var$isNan$2;
var $bebd28704f2536ea$var$isNan$1 = $bebd28704f2536ea$var$parent$u;
var $bebd28704f2536ea$var$isNan = $bebd28704f2536ea$var$isNan$1;
var $bebd28704f2536ea$var$_Number$isNaN = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$isNan);
var $bebd28704f2536ea$var$global$4 = $bebd28704f2536ea$var$global$n;
var $bebd28704f2536ea$var$globalIsFinite = $bebd28704f2536ea$var$global$4.isFinite;
// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
// eslint-disable-next-line es/no-number-isfinite -- safe
var $bebd28704f2536ea$var$numberIsFinite$1 = Number.isFinite || function isFinite(it) {
    return typeof it == 'number' && $bebd28704f2536ea$var$globalIsFinite(it);
};
var $bebd28704f2536ea$var$$$d = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$numberIsFinite = $bebd28704f2536ea$var$numberIsFinite$1;
// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
$bebd28704f2536ea$var$$$d({
    target: 'Number',
    stat: true
}, {
    isFinite: $bebd28704f2536ea$var$numberIsFinite
});
var $bebd28704f2536ea$var$path$d = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$_isFinite$2 = $bebd28704f2536ea$var$path$d.Number.isFinite;
var $bebd28704f2536ea$var$parent$t = $bebd28704f2536ea$var$_isFinite$2;
var $bebd28704f2536ea$var$_isFinite$1 = $bebd28704f2536ea$var$parent$t;
var $bebd28704f2536ea$var$_isFinite = $bebd28704f2536ea$var$_isFinite$1;
var $bebd28704f2536ea$var$_Number$isFinite = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$_isFinite);
var $bebd28704f2536ea$var$$$c = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$$some = $bebd28704f2536ea$var$arrayIteration.some;
var $bebd28704f2536ea$var$arrayMethodIsStrict$3 = $bebd28704f2536ea$var$arrayMethodIsStrict$6;
var $bebd28704f2536ea$var$STRICT_METHOD$2 = $bebd28704f2536ea$var$arrayMethodIsStrict$3('some');
// `Array.prototype.some` method
// https://tc39.es/ecma262/#sec-array.prototype.some
$bebd28704f2536ea$var$$$c({
    target: 'Array',
    proto: true,
    forced: !$bebd28704f2536ea$var$STRICT_METHOD$2
}, {
    some: function some(callbackfn /* , thisArg */ ) {
        return $bebd28704f2536ea$var$$some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
var $bebd28704f2536ea$var$entryVirtual$4 = $bebd28704f2536ea$var$entryVirtual$i;
var $bebd28704f2536ea$var$some$3 = $bebd28704f2536ea$var$entryVirtual$4('Array').some;
var $bebd28704f2536ea$var$isPrototypeOf$4 = $bebd28704f2536ea$var$objectIsPrototypeOf;
var $bebd28704f2536ea$var$method$4 = $bebd28704f2536ea$var$some$3;
var $bebd28704f2536ea$var$ArrayPrototype$4 = Array.prototype;
var $bebd28704f2536ea$var$some$2 = function(it) {
    var own = it.some;
    return it === $bebd28704f2536ea$var$ArrayPrototype$4 || $bebd28704f2536ea$var$isPrototypeOf$4($bebd28704f2536ea$var$ArrayPrototype$4, it) && own === $bebd28704f2536ea$var$ArrayPrototype$4.some ? $bebd28704f2536ea$var$method$4 : own;
};
var $bebd28704f2536ea$var$parent$s = $bebd28704f2536ea$var$some$2;
var $bebd28704f2536ea$var$some$1 = $bebd28704f2536ea$var$parent$s;
var $bebd28704f2536ea$var$some = $bebd28704f2536ea$var$some$1;
var $bebd28704f2536ea$var$_someInstanceProperty = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$some);
var $bebd28704f2536ea$var$path$c = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$getOwnPropertySymbols$2 = $bebd28704f2536ea$var$path$c.Object.getOwnPropertySymbols;
var $bebd28704f2536ea$var$parent$r = $bebd28704f2536ea$var$getOwnPropertySymbols$2;
var $bebd28704f2536ea$var$getOwnPropertySymbols$1 = $bebd28704f2536ea$var$parent$r;
var $bebd28704f2536ea$var$getOwnPropertySymbols = $bebd28704f2536ea$var$getOwnPropertySymbols$1;
var $bebd28704f2536ea$var$_Object$getOwnPropertySymbols = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$getOwnPropertySymbols);
var $bebd28704f2536ea$var$getOwnPropertyDescriptor$6 = {
    exports: {}
};
var $bebd28704f2536ea$var$$$b = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$fails$5 = $bebd28704f2536ea$var$fails$w;
var $bebd28704f2536ea$var$toIndexedObject$1 = $bebd28704f2536ea$var$toIndexedObject$a;
var $bebd28704f2536ea$var$nativeGetOwnPropertyDescriptor = $bebd28704f2536ea$var$objectGetOwnPropertyDescriptor.f;
var $bebd28704f2536ea$var$DESCRIPTORS$2 = $bebd28704f2536ea$var$descriptors;
var $bebd28704f2536ea$var$FORCED$5 = !$bebd28704f2536ea$var$DESCRIPTORS$2 || $bebd28704f2536ea$var$fails$5(function() {
    $bebd28704f2536ea$var$nativeGetOwnPropertyDescriptor(1);
});
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$bebd28704f2536ea$var$$$b({
    target: 'Object',
    stat: true,
    forced: $bebd28704f2536ea$var$FORCED$5,
    sham: !$bebd28704f2536ea$var$DESCRIPTORS$2
}, {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
        return $bebd28704f2536ea$var$nativeGetOwnPropertyDescriptor($bebd28704f2536ea$var$toIndexedObject$1(it), key);
    }
});
var $bebd28704f2536ea$var$path$b = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$Object$3 = $bebd28704f2536ea$var$path$b.Object;
var $bebd28704f2536ea$var$getOwnPropertyDescriptor$5 = $bebd28704f2536ea$var$getOwnPropertyDescriptor$6.exports = function getOwnPropertyDescriptor(it, key) {
    return $bebd28704f2536ea$var$Object$3.getOwnPropertyDescriptor(it, key);
};
if ($bebd28704f2536ea$var$Object$3.getOwnPropertyDescriptor.sham) $bebd28704f2536ea$var$getOwnPropertyDescriptor$5.sham = true;
var $bebd28704f2536ea$var$getOwnPropertyDescriptorExports = $bebd28704f2536ea$var$getOwnPropertyDescriptor$6.exports;
var $bebd28704f2536ea$var$parent$q = $bebd28704f2536ea$var$getOwnPropertyDescriptorExports;
var $bebd28704f2536ea$var$getOwnPropertyDescriptor$4 = $bebd28704f2536ea$var$parent$q;
var $bebd28704f2536ea$var$getOwnPropertyDescriptor$3 = $bebd28704f2536ea$var$getOwnPropertyDescriptor$4;
var $bebd28704f2536ea$var$_Object$getOwnPropertyDescriptor$1 = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$getOwnPropertyDescriptor$3);
var $bebd28704f2536ea$var$$$a = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$DESCRIPTORS$1 = $bebd28704f2536ea$var$descriptors;
var $bebd28704f2536ea$var$ownKeys$4 = $bebd28704f2536ea$var$ownKeys$5;
var $bebd28704f2536ea$var$toIndexedObject = $bebd28704f2536ea$var$toIndexedObject$a;
var $bebd28704f2536ea$var$getOwnPropertyDescriptorModule$1 = $bebd28704f2536ea$var$objectGetOwnPropertyDescriptor;
var $bebd28704f2536ea$var$createProperty = $bebd28704f2536ea$var$createProperty$6;
// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$bebd28704f2536ea$var$$$a({
    target: 'Object',
    stat: true,
    sham: !$bebd28704f2536ea$var$DESCRIPTORS$1
}, {
    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
        var O = $bebd28704f2536ea$var$toIndexedObject(object);
        var getOwnPropertyDescriptor = $bebd28704f2536ea$var$getOwnPropertyDescriptorModule$1.f;
        var keys = $bebd28704f2536ea$var$ownKeys$4(O);
        var result = {};
        var index = 0;
        var key, descriptor;
        while(keys.length > index){
            descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
            if (descriptor !== undefined) $bebd28704f2536ea$var$createProperty(result, key, descriptor);
        }
        return result;
    }
});
var $bebd28704f2536ea$var$path$a = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$getOwnPropertyDescriptors$2 = $bebd28704f2536ea$var$path$a.Object.getOwnPropertyDescriptors;
var $bebd28704f2536ea$var$parent$p = $bebd28704f2536ea$var$getOwnPropertyDescriptors$2;
var $bebd28704f2536ea$var$getOwnPropertyDescriptors$1 = $bebd28704f2536ea$var$parent$p;
var $bebd28704f2536ea$var$getOwnPropertyDescriptors = $bebd28704f2536ea$var$getOwnPropertyDescriptors$1;
var $bebd28704f2536ea$var$_Object$getOwnPropertyDescriptors = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$getOwnPropertyDescriptors);
var $bebd28704f2536ea$var$defineProperties$4 = {
    exports: {}
};
var $bebd28704f2536ea$var$$$9 = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$DESCRIPTORS = $bebd28704f2536ea$var$descriptors;
var $bebd28704f2536ea$var$defineProperties$3 = $bebd28704f2536ea$var$objectDefineProperties.f;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
$bebd28704f2536ea$var$$$9({
    target: 'Object',
    stat: true,
    forced: Object.defineProperties !== $bebd28704f2536ea$var$defineProperties$3,
    sham: !$bebd28704f2536ea$var$DESCRIPTORS
}, {
    defineProperties: $bebd28704f2536ea$var$defineProperties$3
});
var $bebd28704f2536ea$var$path$9 = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$Object$2 = $bebd28704f2536ea$var$path$9.Object;
var $bebd28704f2536ea$var$defineProperties$2 = $bebd28704f2536ea$var$defineProperties$4.exports = function defineProperties(T, D) {
    return $bebd28704f2536ea$var$Object$2.defineProperties(T, D);
};
if ($bebd28704f2536ea$var$Object$2.defineProperties.sham) $bebd28704f2536ea$var$defineProperties$2.sham = true;
var $bebd28704f2536ea$var$definePropertiesExports = $bebd28704f2536ea$var$defineProperties$4.exports;
var $bebd28704f2536ea$var$parent$o = $bebd28704f2536ea$var$definePropertiesExports;
var $bebd28704f2536ea$var$defineProperties$1 = $bebd28704f2536ea$var$parent$o;
var $bebd28704f2536ea$var$defineProperties = $bebd28704f2536ea$var$defineProperties$1;
var $bebd28704f2536ea$var$_Object$defineProperties = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$defineProperties);
var $bebd28704f2536ea$var$defineProperty = $bebd28704f2536ea$var$defineProperty$9;
var $bebd28704f2536ea$var$_Object$defineProperty = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$defineProperty);
function $bebd28704f2536ea$var$_defineProperty(obj, key, value) {
    key = $bebd28704f2536ea$var$_toPropertyKey(key);
    if (key in obj) $bebd28704f2536ea$var$_Object$defineProperty$1(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $bebd28704f2536ea$var$global$3 = $bebd28704f2536ea$var$global$n;
var $bebd28704f2536ea$var$fails$4 = $bebd28704f2536ea$var$fails$w;
var $bebd28704f2536ea$var$uncurryThis$3 = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$toString$1 = $bebd28704f2536ea$var$toString$a;
var $bebd28704f2536ea$var$trim = $bebd28704f2536ea$var$stringTrim.trim;
var $bebd28704f2536ea$var$whitespaces = $bebd28704f2536ea$var$whitespaces$3;
var $bebd28704f2536ea$var$charAt = $bebd28704f2536ea$var$uncurryThis$3(''.charAt);
var $bebd28704f2536ea$var$$parseFloat$1 = $bebd28704f2536ea$var$global$3.parseFloat;
var $bebd28704f2536ea$var$Symbol$1 = $bebd28704f2536ea$var$global$3.Symbol;
var $bebd28704f2536ea$var$ITERATOR = $bebd28704f2536ea$var$Symbol$1 && $bebd28704f2536ea$var$Symbol$1.iterator;
var $bebd28704f2536ea$var$FORCED$4 = 1 / $bebd28704f2536ea$var$$parseFloat$1($bebd28704f2536ea$var$whitespaces + '-0') !== -Infinity || $bebd28704f2536ea$var$ITERATOR && !$bebd28704f2536ea$var$fails$4(function() {
    $bebd28704f2536ea$var$$parseFloat$1(Object($bebd28704f2536ea$var$ITERATOR));
});
// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
var $bebd28704f2536ea$var$numberParseFloat = $bebd28704f2536ea$var$FORCED$4 ? function parseFloat1(string) {
    var trimmedString = $bebd28704f2536ea$var$trim($bebd28704f2536ea$var$toString$1(string));
    var result = $bebd28704f2536ea$var$$parseFloat$1(trimmedString);
    return result === 0 && $bebd28704f2536ea$var$charAt(trimmedString, 0) === '-' ? -0 : result;
} : $bebd28704f2536ea$var$$parseFloat$1;
var $bebd28704f2536ea$var$$$8 = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$$parseFloat = $bebd28704f2536ea$var$numberParseFloat;
// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
$bebd28704f2536ea$var$$$8({
    global: true,
    forced: parseFloat !== $bebd28704f2536ea$var$$parseFloat
}, {
    parseFloat: $bebd28704f2536ea$var$$parseFloat
});
var $bebd28704f2536ea$var$path$8 = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$_parseFloat$3 = $bebd28704f2536ea$var$path$8.parseFloat;
var $bebd28704f2536ea$var$parent$n = $bebd28704f2536ea$var$_parseFloat$3;
var $bebd28704f2536ea$var$_parseFloat$2 = $bebd28704f2536ea$var$parent$n;
var $bebd28704f2536ea$var$_parseFloat = $bebd28704f2536ea$var$_parseFloat$2;
var $bebd28704f2536ea$var$_parseFloat$1 = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$_parseFloat);
var $bebd28704f2536ea$var$$$7 = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$fails$3 = $bebd28704f2536ea$var$fails$w;
var $bebd28704f2536ea$var$getOwnPropertyNames$3 = $bebd28704f2536ea$var$objectGetOwnPropertyNamesExternal.f;
// eslint-disable-next-line es/no-object-getownpropertynames -- required for testing
var $bebd28704f2536ea$var$FAILS_ON_PRIMITIVES = $bebd28704f2536ea$var$fails$3(function() {
    return !Object.getOwnPropertyNames(1);
});
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
$bebd28704f2536ea$var$$$7({
    target: 'Object',
    stat: true,
    forced: $bebd28704f2536ea$var$FAILS_ON_PRIMITIVES
}, {
    getOwnPropertyNames: $bebd28704f2536ea$var$getOwnPropertyNames$3
});
var $bebd28704f2536ea$var$path$7 = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$Object$1 = $bebd28704f2536ea$var$path$7.Object;
var $bebd28704f2536ea$var$getOwnPropertyNames$2 = function getOwnPropertyNames(it) {
    return $bebd28704f2536ea$var$Object$1.getOwnPropertyNames(it);
};
var $bebd28704f2536ea$var$parent$m = $bebd28704f2536ea$var$getOwnPropertyNames$2;
var $bebd28704f2536ea$var$getOwnPropertyNames$1 = $bebd28704f2536ea$var$parent$m;
var $bebd28704f2536ea$var$getOwnPropertyNames = $bebd28704f2536ea$var$getOwnPropertyNames$1;
var $bebd28704f2536ea$var$_Object$getOwnPropertyNames = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$getOwnPropertyNames);
/**
 * Helper functions for components
 */ /**
 * Determine values to use for (sub)options of 'chosen'.
 *
 * This option is either a boolean or an object whose values should be examined further.
 * The relevant structures are:
 *
 * - chosen: <boolean value>
 * - chosen: { subOption: <boolean or function> }
 *
 * Where subOption is 'node', 'edge' or 'label'.
 *
 * The intention of this method appears to be to set a specific priority to the options;
 * Since most properties are either bridged or merged into the local options objects, there
 * is not much point in handling them separately.
 * TODO: examine if 'most' in previous sentence can be replaced with 'all'. In that case, we
 *       should be able to get rid of this method.
 *
 * @param {string}  subOption  option within object 'chosen' to consider; either 'node', 'edge' or 'label'
 * @param {object}  pile       array of options objects to consider
 * @returns {boolean | Function}  value for passed subOption of 'chosen' to use
 */ function $bebd28704f2536ea$var$choosify(subOption, pile) {
    // allowed values for subOption
    var allowed = [
        "node",
        "edge",
        "label"
    ];
    var value = true;
    var chosen = $bebd28704f2536ea$var$topMost(pile, "chosen");
    if (typeof chosen === "boolean") value = chosen;
    else if ($bebd28704f2536ea$var$_typeof(chosen) === "object") {
        if ($bebd28704f2536ea$var$_indexOfInstanceProperty(allowed).call(allowed, subOption) === -1) throw new Error("choosify: subOption '" + subOption + "' should be one of " + "'" + allowed.join("', '") + "'");
        var chosenEdge = $bebd28704f2536ea$var$topMost(pile, [
            "chosen",
            subOption
        ]);
        if (typeof chosenEdge === "boolean" || typeof chosenEdge === "function") value = chosenEdge;
    }
    return value;
}
/**
 * Check if the point falls within the given rectangle.
 *
 * @param {rect} rect
 * @param {point} point
 * @param {rotationPoint} [rotationPoint] if specified, the rotation that applies to the rectangle.
 * @returns {boolean}  true if point within rectangle, false otherwise
 */ function $bebd28704f2536ea$var$pointInRect(rect, point, rotationPoint) {
    if (rect.width <= 0 || rect.height <= 0) return false; // early out
    if (rotationPoint !== undefined) {
        // Rotate the point the same amount as the rectangle
        var tmp = {
            x: point.x - rotationPoint.x,
            y: point.y - rotationPoint.y
        };
        if (rotationPoint.angle !== 0) {
            // In order to get the coordinates the same, you need to
            // rotate in the reverse direction
            var angle = -rotationPoint.angle;
            var tmp2 = {
                x: Math.cos(angle) * tmp.x - Math.sin(angle) * tmp.y,
                y: Math.sin(angle) * tmp.x + Math.cos(angle) * tmp.y
            };
            point = tmp2;
        } else point = tmp;
    // Note that if a rotation is specified, the rectangle coordinates
    // are **not* the full canvas coordinates. They are relative to the
    // rotationPoint. Hence, the point coordinates need not be translated
    // back in this case.
    }
    var right = rect.x + rect.width;
    var bottom = rect.y + rect.width;
    return rect.left < point.x && right > point.x && rect.top < point.y && bottom > point.y;
}
/**
 * Check if given value is acceptable as a label text.
 *
 * @param {*} text value to check; can be anything at this point
 * @returns {boolean} true if valid label value, false otherwise
 */ function $bebd28704f2536ea$var$isValidLabel(text) {
    // Note that this is quite strict: types that *might* be converted to string are disallowed
    return typeof text === "string" && text !== "";
}
/**
 * Returns x, y of self reference circle based on provided angle
 *
 * @param {object} ctx
 * @param {number} angle
 * @param {number} radius
 * @param {VisNode} node
 * @returns {object} x and y coordinates
 */ function $bebd28704f2536ea$var$getSelfRefCoordinates(ctx, angle, radius, node) {
    var x = node.x;
    var y = node.y;
    if (typeof node.distanceToBorder === "function") {
        //calculating opposite and adjacent
        //distaneToBorder becomes Hypotenuse.
        //Formulas sin(a) = Opposite / Hypotenuse and cos(a) = Adjacent / Hypotenuse
        var toBorderDist = node.distanceToBorder(ctx, angle);
        var yFromNodeCenter = Math.sin(angle) * toBorderDist;
        var xFromNodeCenter = Math.cos(angle) * toBorderDist;
        //xFromNodeCenter is basically x and if xFromNodeCenter equals to the distance to border then it means
        //that y does not need calculation because it is equal node.height / 2 or node.y
        //same thing with yFromNodeCenter and if yFromNodeCenter equals to the distance to border then it means
        //that x is equal node.width / 2 or node.x
        if (xFromNodeCenter === toBorderDist) {
            x += toBorderDist;
            y = node.y;
        } else if (yFromNodeCenter === toBorderDist) {
            x = node.x;
            y -= toBorderDist;
        } else {
            x += xFromNodeCenter;
            y -= yFromNodeCenter;
        }
    } else if (node.shape.width > node.shape.height) {
        x = node.x + node.shape.width * 0.5;
        y = node.y - radius;
    } else {
        x = node.x + radius;
        y = node.y - node.shape.height * 0.5;
    }
    return {
        x: x,
        y: y
    };
}
var $bebd28704f2536ea$var$entryVirtual$3 = $bebd28704f2536ea$var$entryVirtual$i;
var $bebd28704f2536ea$var$values$3 = $bebd28704f2536ea$var$entryVirtual$3('Array').values;
var $bebd28704f2536ea$var$parent$l = $bebd28704f2536ea$var$values$3;
var $bebd28704f2536ea$var$values$2 = $bebd28704f2536ea$var$parent$l;
var $bebd28704f2536ea$var$classof$1 = $bebd28704f2536ea$var$classof$d;
var $bebd28704f2536ea$var$hasOwn$2 = $bebd28704f2536ea$var$hasOwnProperty_1;
var $bebd28704f2536ea$var$isPrototypeOf$3 = $bebd28704f2536ea$var$objectIsPrototypeOf;
var $bebd28704f2536ea$var$method$3 = $bebd28704f2536ea$var$values$2;
var $bebd28704f2536ea$var$ArrayPrototype$3 = Array.prototype;
var $bebd28704f2536ea$var$DOMIterables = {
    DOMTokenList: true,
    NodeList: true
};
var $bebd28704f2536ea$var$values$1 = function(it) {
    var own = it.values;
    return it === $bebd28704f2536ea$var$ArrayPrototype$3 || $bebd28704f2536ea$var$isPrototypeOf$3($bebd28704f2536ea$var$ArrayPrototype$3, it) && own === $bebd28704f2536ea$var$ArrayPrototype$3.values || $bebd28704f2536ea$var$hasOwn$2($bebd28704f2536ea$var$DOMIterables, $bebd28704f2536ea$var$classof$1(it)) ? $bebd28704f2536ea$var$method$3 : own;
};
var $bebd28704f2536ea$var$values = $bebd28704f2536ea$var$values$1;
var $bebd28704f2536ea$var$_valuesInstanceProperty = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$values);
/**
 * Callback to determine text dimensions, using the parent label settings.
 *
 * @callback MeasureText
 * @param {text} text
 * @param {text} mod
 * @returns {object} { width, values} width in pixels and font attributes
 */ /**
 * Helper class for Label which collects results of splitting labels into lines and blocks.
 *
 * @private
 */ var $bebd28704f2536ea$var$LabelAccumulator = /*#__PURE__*/ function() {
    /**
   * @param {MeasureText} measureText
   */ function LabelAccumulator(measureText) {
        $bebd28704f2536ea$var$_classCallCheck(this, LabelAccumulator);
        this.measureText = measureText;
        this.current = 0;
        this.width = 0;
        this.height = 0;
        this.lines = [];
    }
    /**
   * Append given text to the given line.
   *
   * @param {number}  l    index of line to add to
   * @param {string}  text string to append to line
   * @param {'bold'|'ital'|'boldital'|'mono'|'normal'} [mod='normal']
   * @private
   */ $bebd28704f2536ea$var$_createClass(LabelAccumulator, [
        {
            key: "_add",
            value: function _add(l, text) {
                var mod = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "normal";
                if (this.lines[l] === undefined) this.lines[l] = {
                    width: 0,
                    height: 0,
                    blocks: []
                };
                // We still need to set a block for undefined and empty texts, hence return at this point
                // This is necessary because we don't know at this point if we're at the
                // start of an empty line or not.
                // To compensate, empty blocks are removed in `finalize()`.
                //
                // Empty strings should still have a height
                var tmpText = text;
                if (text === undefined || text === "") tmpText = " ";
                // Determine width and get the font properties
                var result = this.measureText(tmpText, mod);
                var block = $bebd28704f2536ea$var$_Object$assign({}, $bebd28704f2536ea$var$_valuesInstanceProperty(result));
                block.text = text;
                block.width = result.width;
                block.mod = mod;
                if (text === undefined || text === "") block.width = 0;
                this.lines[l].blocks.push(block);
                // Update the line width. We need this for determining if a string goes over max width
                this.lines[l].width += block.width;
            }
        },
        {
            key: "curWidth",
            value: function curWidth() {
                var line = this.lines[this.current];
                if (line === undefined) return 0;
                return line.width;
            }
        },
        {
            key: "append",
            value: function append(text) {
                var mod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "normal";
                this._add(this.current, text, mod);
            }
        },
        {
            key: "newLine",
            value: function newLine(text) {
                var mod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "normal";
                this._add(this.current, text, mod);
                this.current++;
            }
        },
        {
            key: "determineLineHeights",
            value: function determineLineHeights() {
                for(var k = 0; k < this.lines.length; k++){
                    var line = this.lines[k];
                    // Looking for max height of blocks in line
                    var height = 0;
                    if (line.blocks !== undefined) // Can happen if text contains e.g. '\n '
                    for(var l = 0; l < line.blocks.length; l++){
                        var block = line.blocks[l];
                        if (height < block.height) height = block.height;
                    }
                    line.height = height;
                }
            }
        },
        {
            key: "determineLabelSize",
            value: function determineLabelSize() {
                var width = 0;
                var height = 0;
                for(var k = 0; k < this.lines.length; k++){
                    var line = this.lines[k];
                    if (line.width > width) width = line.width;
                    height += line.height;
                }
                this.width = width;
                this.height = height;
            }
        },
        {
            key: "removeEmptyBlocks",
            value: function removeEmptyBlocks() {
                var tmpLines = [];
                for(var k = 0; k < this.lines.length; k++){
                    var line = this.lines[k];
                    // Note: an empty line in between text has width zero but is still relevant to layout.
                    // So we can't use width for testing empty line here
                    if (line.blocks.length === 0) continue;
                    // Discard final empty line always
                    if (k === this.lines.length - 1) {
                        if (line.width === 0) continue;
                    }
                    var tmpLine = {};
                    $bebd28704f2536ea$var$_Object$assign(tmpLine, line);
                    tmpLine.blocks = [];
                    var firstEmptyBlock = void 0;
                    var tmpBlocks = [];
                    for(var l = 0; l < line.blocks.length; l++){
                        var block = line.blocks[l];
                        if (block.width !== 0) tmpBlocks.push(block);
                        else if (firstEmptyBlock === undefined) firstEmptyBlock = block;
                    }
                    // Ensure that there is *some* text present
                    if (tmpBlocks.length === 0 && firstEmptyBlock !== undefined) tmpBlocks.push(firstEmptyBlock);
                    tmpLine.blocks = tmpBlocks;
                    tmpLines.push(tmpLine);
                }
                return tmpLines;
            }
        },
        {
            key: "finalize",
            value: function finalize() {
                //console.log(JSON.stringify(this.lines, null, 2));
                this.determineLineHeights();
                this.determineLabelSize();
                var tmpLines = this.removeEmptyBlocks();
                // Return a simple hash object for further processing.
                return {
                    width: this.width,
                    height: this.height,
                    lines: tmpLines
                };
            }
        }
    ]);
    return LabelAccumulator;
}();
// Hash of prepared regexp's for tags
var $bebd28704f2536ea$var$tagPattern = {
    // HTML
    "<b>": /<b>/,
    "<i>": /<i>/,
    "<code>": /<code>/,
    "</b>": /<\/b>/,
    "</i>": /<\/i>/,
    "</code>": /<\/code>/,
    // Markdown
    "*": /\*/,
    // bold
    _: /_/,
    // ital
    "`": /`/,
    // mono
    afterBold: /[^*]/,
    afterItal: /[^_]/,
    afterMono: /[^`]/
};
/**
 * Internal helper class for parsing the markup tags for HTML and Markdown.
 *
 * NOTE: Sequences of tabs and spaces are reduced to single space.
 *       Scan usage of `this.spacing` within method
 */ var $bebd28704f2536ea$var$MarkupAccumulator = /*#__PURE__*/ function() {
    /**
   * Create an instance
   *
   * @param {string} text  text to parse for markup
   */ function MarkupAccumulator(text) {
        $bebd28704f2536ea$var$_classCallCheck(this, MarkupAccumulator);
        this.text = text;
        this.bold = false;
        this.ital = false;
        this.mono = false;
        this.spacing = false;
        this.position = 0;
        this.buffer = "";
        this.modStack = [];
        this.blocks = [];
    }
    /**
   * Return the mod label currently on the top of the stack
   *
   * @returns {string}  label of topmost mod
   * @private
   */ $bebd28704f2536ea$var$_createClass(MarkupAccumulator, [
        {
            key: "mod",
            value: function mod() {
                return this.modStack.length === 0 ? "normal" : this.modStack[0];
            }
        },
        {
            key: "modName",
            value: function modName() {
                if (this.modStack.length === 0) return "normal";
                else if (this.modStack[0] === "mono") return "mono";
                else {
                    if (this.bold && this.ital) return "boldital";
                    else if (this.bold) return "bold";
                    else if (this.ital) return "ital";
                }
            }
        },
        {
            key: "emitBlock",
            value: function emitBlock() {
                if (this.spacing) {
                    this.add(" ");
                    this.spacing = false;
                }
                if (this.buffer.length > 0) {
                    this.blocks.push({
                        text: this.buffer,
                        mod: this.modName()
                    });
                    this.buffer = "";
                }
            }
        },
        {
            key: "add",
            value: function add(text) {
                if (text === " ") this.spacing = true;
                if (this.spacing) {
                    this.buffer += " ";
                    this.spacing = false;
                }
                if (text != " ") this.buffer += text;
            }
        },
        {
            key: "parseWS",
            value: function parseWS(ch) {
                if (/[ \t]/.test(ch)) {
                    if (!this.mono) this.spacing = true;
                    else this.add(ch);
                    return true;
                }
                return false;
            }
        },
        {
            key: "setTag",
            value: function setTag(tagName) {
                this.emitBlock();
                this[tagName] = true;
                this.modStack.unshift(tagName);
            }
        },
        {
            key: "unsetTag",
            value: function unsetTag(tagName) {
                this.emitBlock();
                this[tagName] = false;
                this.modStack.shift();
            }
        },
        {
            key: "parseStartTag",
            value: function parseStartTag(tagName, tag) {
                // Note: if 'mono' passed as tagName, there is a double check here. This is OK
                if (!this.mono && !this[tagName] && this.match(tag)) {
                    this.setTag(tagName);
                    return true;
                }
                return false;
            }
        },
        {
            key: "match",
            value: function match(tag) {
                var advance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                var _this$prepareRegExp = this.prepareRegExp(tag), _this$prepareRegExp2 = $bebd28704f2536ea$var$_slicedToArray(_this$prepareRegExp, 2), regExp = _this$prepareRegExp2[0], length1 = _this$prepareRegExp2[1];
                var matched = regExp.test(this.text.substr(this.position, length1));
                if (matched && advance) this.position += length1 - 1;
                return matched;
            }
        },
        {
            key: "parseEndTag",
            value: function parseEndTag(tagName, tag, nextTag) {
                var checkTag = this.mod() === tagName;
                if (tagName === "mono") // special handling for 'mono'
                checkTag = checkTag && this.mono;
                else checkTag = checkTag && !this.mono;
                if (checkTag && this.match(tag)) {
                    if (nextTag !== undefined) // Purpose of the following match is to prevent a direct unset/set of a given tag
                    // E.g. '*bold **still bold*' => '*bold still bold*'
                    {
                        if (this.position === this.text.length - 1 || this.match(nextTag, false)) this.unsetTag(tagName);
                    } else this.unsetTag(tagName);
                    return true;
                }
                return false;
            }
        },
        {
            key: "replace",
            value: function replace(tag, value) {
                if (this.match(tag)) {
                    this.add(value);
                    this.position += length - 1;
                    return true;
                }
                return false;
            }
        },
        {
            key: "prepareRegExp",
            value: function prepareRegExp(tag) {
                var length1;
                var regExp;
                if (tag instanceof RegExp) {
                    regExp = tag;
                    length1 = 1; // ASSUMPTION: regexp only tests one character
                } else {
                    // use prepared regexp if present
                    var prepared = $bebd28704f2536ea$var$tagPattern[tag];
                    if (prepared !== undefined) regExp = prepared;
                    else regExp = new RegExp(tag);
                    length1 = tag.length;
                }
                return [
                    regExp,
                    length1
                ];
            }
        }
    ]);
    return MarkupAccumulator;
}();
/**
 * Helper class for Label which explodes the label text into lines and blocks within lines
 *
 * @private
 */ var $bebd28704f2536ea$var$LabelSplitter = /*#__PURE__*/ function() {
    /**
   * @param {CanvasRenderingContext2D} ctx Canvas rendering context
   * @param {Label} parent reference to the Label instance using current instance
   * @param {boolean} selected
   * @param {boolean} hover
   */ function LabelSplitter(ctx, parent, selected, hover) {
        var _this = this;
        $bebd28704f2536ea$var$_classCallCheck(this, LabelSplitter);
        this.ctx = ctx;
        this.parent = parent;
        this.selected = selected;
        this.hover = hover;
        /**
     * Callback to determine text width; passed to LabelAccumulator instance
     *
     * @param  {string} text string to determine width of
     * @param  {string} mod  font type to use for this text
     * @returns {object} { width, values} width in pixels and font attributes
     */ var textWidth = function textWidth(text, mod) {
            if (text === undefined) return 0;
            // TODO: This can be done more efficiently with caching
            // This will set the ctx.font correctly, depending on selected/hover and mod - so that ctx.measureText() will be accurate.
            var values = _this.parent.getFormattingValues(ctx, selected, hover, mod);
            var width = 0;
            if (text !== "") {
                var measure = _this.ctx.measureText(text);
                width = measure.width;
            }
            return {
                width: width,
                values: values
            };
        };
        this.lines = new $bebd28704f2536ea$var$LabelAccumulator(textWidth);
    }
    /**
   * Split passed text of a label into lines and blocks.
   *
   * # NOTE
   *
   * The handling of spacing is option dependent:
   *
   * - if `font.multi : false`, all spaces are retained
   * - if `font.multi : true`, every sequence of spaces is compressed to a single space
   *
   * This might not be the best way to do it, but this is as it has been working till now.
   * In order not to break existing functionality, for the time being this behaviour will
   * be retained in any code changes.
   *
   * @param {string} text  text to split
   * @returns {Array<line>}
   */ $bebd28704f2536ea$var$_createClass(LabelSplitter, [
        {
            key: "process",
            value: function process(text) {
                if (!$bebd28704f2536ea$var$isValidLabel(text)) return this.lines.finalize();
                var font = this.parent.fontOptions;
                // Normalize the end-of-line's to a single representation - order important
                text = text.replace(/\r\n/g, "\n"); // Dos EOL's
                text = text.replace(/\r/g, "\n"); // Mac EOL's
                // Note that at this point, there can be no \r's in the text.
                // This is used later on splitStringIntoLines() to split multifont texts.
                var nlLines = String(text).split("\n");
                var lineCount = nlLines.length;
                if (font.multi) // Multi-font case: styling tags active
                for(var i = 0; i < lineCount; i++){
                    var blocks = this.splitBlocks(nlLines[i], font.multi);
                    // Post: Sequences of tabs and spaces are reduced to single space
                    if (blocks === undefined) continue;
                    if (blocks.length === 0) {
                        this.lines.newLine("");
                        continue;
                    }
                    if (font.maxWdt > 0) // widthConstraint.maximum defined
                    //console.log('Running widthConstraint multi, max: ' + this.fontOptions.maxWdt);
                    for(var j = 0; j < blocks.length; j++){
                        var mod = blocks[j].mod;
                        var _text = blocks[j].text;
                        this.splitStringIntoLines(_text, mod, true);
                    }
                    else // widthConstraint.maximum NOT defined
                    for(var _j = 0; _j < blocks.length; _j++){
                        var _mod = blocks[_j].mod;
                        var _text2 = blocks[_j].text;
                        this.lines.append(_text2, _mod);
                    }
                    this.lines.newLine();
                }
                else {
                    // Single-font case
                    if (font.maxWdt > 0) // widthConstraint.maximum defined
                    // console.log('Running widthConstraint normal, max: ' + this.fontOptions.maxWdt);
                    for(var _i = 0; _i < lineCount; _i++)this.splitStringIntoLines(nlLines[_i]);
                    else // widthConstraint.maximum NOT defined
                    for(var _i2 = 0; _i2 < lineCount; _i2++)this.lines.newLine(nlLines[_i2]);
                }
                return this.lines.finalize();
            }
        },
        {
            key: "decodeMarkupSystem",
            value: function decodeMarkupSystem(markupSystem) {
                var system = "none";
                if (markupSystem === "markdown" || markupSystem === "md") system = "markdown";
                else if (markupSystem === true || markupSystem === "html") system = "html";
                return system;
            }
        },
        {
            key: "splitHtmlBlocks",
            value: function splitHtmlBlocks(text) {
                var s = new $bebd28704f2536ea$var$MarkupAccumulator(text);
                var parseEntities = function parseEntities(ch) {
                    if (/&/.test(ch)) {
                        var parsed = s.replace(s.text, "&lt;", "<") || s.replace(s.text, "&amp;", "&");
                        if (!parsed) s.add("&");
                        return true;
                    }
                    return false;
                };
                while(s.position < s.text.length){
                    var ch = s.text.charAt(s.position);
                    var parsed = s.parseWS(ch) || /</.test(ch) && (s.parseStartTag("bold", "<b>") || s.parseStartTag("ital", "<i>") || s.parseStartTag("mono", "<code>") || s.parseEndTag("bold", "</b>") || s.parseEndTag("ital", "</i>") || s.parseEndTag("mono", "</code>")) || parseEntities(ch);
                    if (!parsed) s.add(ch);
                    s.position++;
                }
                s.emitBlock();
                return s.blocks;
            }
        },
        {
            key: "splitMarkdownBlocks",
            value: function splitMarkdownBlocks(text) {
                var _this2 = this;
                var s = new $bebd28704f2536ea$var$MarkupAccumulator(text);
                var beginable = true;
                var parseOverride = function parseOverride(ch) {
                    if (/\\/.test(ch)) {
                        if (s.position < _this2.text.length + 1) {
                            s.position++;
                            ch = _this2.text.charAt(s.position);
                            if (/ \t/.test(ch)) s.spacing = true;
                            else {
                                s.add(ch);
                                beginable = false;
                            }
                        }
                        return true;
                    }
                    return false;
                };
                while(s.position < s.text.length){
                    var ch = s.text.charAt(s.position);
                    var parsed = s.parseWS(ch) || parseOverride(ch) || (beginable || s.spacing) && (s.parseStartTag("bold", "*") || s.parseStartTag("ital", "_") || s.parseStartTag("mono", "`")) || s.parseEndTag("bold", "*", "afterBold") || s.parseEndTag("ital", "_", "afterItal") || s.parseEndTag("mono", "`", "afterMono");
                    if (!parsed) {
                        s.add(ch);
                        beginable = false;
                    }
                    s.position++;
                }
                s.emitBlock();
                return s.blocks;
            }
        },
        {
            key: "splitBlocks",
            value: function splitBlocks(text, markupSystem) {
                var system = this.decodeMarkupSystem(markupSystem);
                if (system === "none") return [
                    {
                        text: text,
                        mod: "normal"
                    }
                ];
                else if (system === "markdown") return this.splitMarkdownBlocks(text);
                else if (system === "html") return this.splitHtmlBlocks(text);
            }
        },
        {
            key: "overMaxWidth",
            value: function overMaxWidth(text) {
                var width = this.ctx.measureText(text).width;
                return this.lines.curWidth() + width > this.parent.fontOptions.maxWdt;
            }
        },
        {
            key: "getLongestFit",
            value: function getLongestFit(words) {
                var text = "";
                var w = 0;
                while(w < words.length){
                    var pre = text === "" ? "" : " ";
                    var newText = text + pre + words[w];
                    if (this.overMaxWidth(newText)) break;
                    text = newText;
                    w++;
                }
                return w;
            }
        },
        {
            key: "getLongestFitWord",
            value: function getLongestFitWord(words) {
                var w = 0;
                while(w < words.length){
                    if (this.overMaxWidth($bebd28704f2536ea$var$_sliceInstanceProperty(words).call(words, 0, w))) break;
                    w++;
                }
                return w;
            }
        },
        {
            key: "splitStringIntoLines",
            value: function splitStringIntoLines(str) {
                var mod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "normal";
                var appendLast = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                // Set the canvas context font, based upon the current selected/hover state
                // and the provided mod, so the text measurement performed by getLongestFit
                // will be accurate - and not just use the font of whoever last used the canvas.
                this.parent.getFormattingValues(this.ctx, this.selected, this.hover, mod);
                // Still-present spaces are relevant, retain them
                str = str.replace(/^( +)/g, "$1\r");
                str = str.replace(/([^\r][^ ]*)( +)/g, "$1\r$2\r");
                var words = str.split("\r");
                while(words.length > 0){
                    var w = this.getLongestFit(words);
                    if (w === 0) {
                        // Special case: the first word is already larger than the max width.
                        var word = words[0];
                        // Break the word to the largest part that fits the line
                        var x = this.getLongestFitWord(word);
                        this.lines.newLine($bebd28704f2536ea$var$_sliceInstanceProperty(word).call(word, 0, x), mod);
                        // Adjust the word, so that the rest will be done next iteration
                        words[0] = $bebd28704f2536ea$var$_sliceInstanceProperty(word).call(word, x);
                    } else {
                        // skip any space that is replaced by a newline
                        var newW = w;
                        if (words[w - 1] === " ") w--;
                        else if (words[newW] === " ") newW++;
                        var text = $bebd28704f2536ea$var$_sliceInstanceProperty(words).call(words, 0, w).join("");
                        if (w == words.length && appendLast) this.lines.append(text, mod);
                        else this.lines.newLine(text, mod);
                        // Adjust the word, so that the rest will be done next iteration
                        words = $bebd28704f2536ea$var$_sliceInstanceProperty(words).call(words, newW);
                    }
                }
            }
        }
    ]);
    return LabelSplitter;
}();
/**
 * List of special styles for multi-fonts
 *
 * @private
 */ var $bebd28704f2536ea$var$multiFontStyle = [
    "bold",
    "ital",
    "boldital",
    "mono"
];
/**
 * A Label to be used for Nodes or Edges.
 */ var $bebd28704f2536ea$var$Label = /*#__PURE__*/ function() {
    /**
   * @param {object} body
   * @param {object} options
   * @param {boolean} [edgelabel=false]
   */ function Label(body, options) {
        var edgelabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        $bebd28704f2536ea$var$_classCallCheck(this, Label);
        this.body = body;
        this.pointToSelf = false;
        this.baseSize = undefined;
        this.fontOptions = {}; // instance variable containing the *instance-local* font options
        this.setOptions(options);
        this.size = {
            top: 0,
            left: 0,
            width: 0,
            height: 0,
            yLine: 0
        };
        this.isEdgeLabel = edgelabel;
    }
    /**
   * @param {object} options the options of the parent Node-instance
   */ $bebd28704f2536ea$var$_createClass(Label, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                this.elementOptions = options; // Reference to the options of the parent Node-instance
                this.initFontOptions(options.font);
                if ($bebd28704f2536ea$var$isValidLabel(options.label)) this.labelDirty = true;
                else // Bad label! Change the option value to prevent bad stuff happening
                options.label = undefined;
                if (options.font !== undefined && options.font !== null) {
                    // font options can be deleted at various levels
                    if (typeof options.font === "string") this.baseSize = this.fontOptions.size;
                    else if ($bebd28704f2536ea$var$_typeof(options.font) === "object") {
                        var size = options.font.size;
                        if (size !== undefined) this.baseSize = size;
                    }
                }
            }
        },
        {
            key: "initFontOptions",
            value: function initFontOptions(newFontOptions) {
                var _this = this;
                // Prepare the multi-font option objects.
                // These will be filled in propagateFonts(), if required
                $bebd28704f2536ea$var$forEach$1($bebd28704f2536ea$var$multiFontStyle, function(style) {
                    _this.fontOptions[style] = {};
                });
                // Handle shorthand option, if present
                if (Label.parseFontString(this.fontOptions, newFontOptions)) {
                    this.fontOptions.vadjust = 0;
                    return;
                }
                // Copy over the non-multifont options, if specified
                $bebd28704f2536ea$var$forEach$1(newFontOptions, function(prop, n) {
                    if (prop !== undefined && prop !== null && $bebd28704f2536ea$var$_typeof(prop) !== "object") _this.fontOptions[n] = prop;
                });
            }
        },
        {
            key: "constrain",
            value: /**
     * Set the width and height constraints based on 'nearest' value
     *
     * @param {Array} pile array of option objects to consider
     * @returns {object} the actual constraint values to use
     * @private
     */ function constrain(pile) {
                // NOTE: constrainWidth and  constrainHeight never set!
                // NOTE: for edge labels, only 'maxWdt' set
                // Node labels can set all the fields
                var fontOptions = {
                    constrainWidth: false,
                    maxWdt: -1,
                    minWdt: -1,
                    constrainHeight: false,
                    minHgt: -1,
                    valign: "middle"
                };
                var widthConstraint = $bebd28704f2536ea$var$topMost(pile, "widthConstraint");
                if (typeof widthConstraint === "number") {
                    fontOptions.maxWdt = Number(widthConstraint);
                    fontOptions.minWdt = Number(widthConstraint);
                } else if ($bebd28704f2536ea$var$_typeof(widthConstraint) === "object") {
                    var widthConstraintMaximum = $bebd28704f2536ea$var$topMost(pile, [
                        "widthConstraint",
                        "maximum"
                    ]);
                    if (typeof widthConstraintMaximum === "number") fontOptions.maxWdt = Number(widthConstraintMaximum);
                    var widthConstraintMinimum = $bebd28704f2536ea$var$topMost(pile, [
                        "widthConstraint",
                        "minimum"
                    ]);
                    if (typeof widthConstraintMinimum === "number") fontOptions.minWdt = Number(widthConstraintMinimum);
                }
                var heightConstraint = $bebd28704f2536ea$var$topMost(pile, "heightConstraint");
                if (typeof heightConstraint === "number") fontOptions.minHgt = Number(heightConstraint);
                else if ($bebd28704f2536ea$var$_typeof(heightConstraint) === "object") {
                    var heightConstraintMinimum = $bebd28704f2536ea$var$topMost(pile, [
                        "heightConstraint",
                        "minimum"
                    ]);
                    if (typeof heightConstraintMinimum === "number") fontOptions.minHgt = Number(heightConstraintMinimum);
                    var heightConstraintValign = $bebd28704f2536ea$var$topMost(pile, [
                        "heightConstraint",
                        "valign"
                    ]);
                    if (typeof heightConstraintValign === "string") {
                        if (heightConstraintValign === "top" || heightConstraintValign === "bottom") fontOptions.valign = heightConstraintValign;
                    }
                }
                return fontOptions;
            }
        },
        {
            key: "update",
            value: function update(options, pile) {
                this.setOptions(options, true);
                this.propagateFonts(pile);
                $bebd28704f2536ea$var$deepExtend(this.fontOptions, this.constrain(pile));
                this.fontOptions.chooser = $bebd28704f2536ea$var$choosify("label", pile);
            }
        },
        {
            key: "adjustSizes",
            value: function adjustSizes(margins) {
                var widthBias = margins ? margins.right + margins.left : 0;
                if (this.fontOptions.constrainWidth) {
                    this.fontOptions.maxWdt -= widthBias;
                    this.fontOptions.minWdt -= widthBias;
                }
                var heightBias = margins ? margins.top + margins.bottom : 0;
                if (this.fontOptions.constrainHeight) this.fontOptions.minHgt -= heightBias;
            }
        },
        {
            key: "addFontOptionsToPile",
            value: function addFontOptionsToPile(dstPile, srcPile) {
                for(var i = 0; i < srcPile.length; ++i)this.addFontToPile(dstPile, srcPile[i]);
            }
        },
        {
            key: "addFontToPile",
            value: function addFontToPile(pile, options) {
                if (options === undefined) return;
                if (options.font === undefined || options.font === null) return;
                var item = options.font;
                pile.push(item);
            }
        },
        {
            key: "getBasicOptions",
            value: function getBasicOptions(pile) {
                var ret = {};
                // Scans the whole pile to get all options present
                for(var n = 0; n < pile.length; ++n){
                    var fontOptions = pile[n];
                    // Convert shorthand if necessary
                    var tmpShorthand = {};
                    if (Label.parseFontString(tmpShorthand, fontOptions)) fontOptions = tmpShorthand;
                    $bebd28704f2536ea$var$forEach$1(fontOptions, function(opt, name) {
                        if (opt === undefined) return; // multi-font option need not be present
                        if (Object.prototype.hasOwnProperty.call(ret, name)) return; // Keep first value we encounter
                        if ($bebd28704f2536ea$var$_indexOfInstanceProperty($bebd28704f2536ea$var$multiFontStyle).call($bebd28704f2536ea$var$multiFontStyle, name) !== -1) // Skip multi-font properties but we do need the structure
                        ret[name] = {};
                        else ret[name] = opt;
                    });
                }
                return ret;
            }
        },
        {
            key: "getFontOption",
            value: function getFontOption(pile, multiName, option) {
                var multiFont;
                // Search multi font in local properties
                for(var n = 0; n < pile.length; ++n){
                    var fontOptions = pile[n];
                    if (Object.prototype.hasOwnProperty.call(fontOptions, multiName)) {
                        multiFont = fontOptions[multiName];
                        if (multiFont === undefined || multiFont === null) continue;
                        // Convert shorthand if necessary
                        // TODO: inefficient to do this conversion every time; find a better way.
                        var tmpShorthand = {};
                        if (Label.parseFontString(tmpShorthand, multiFont)) multiFont = tmpShorthand;
                        if (Object.prototype.hasOwnProperty.call(multiFont, option)) return multiFont[option];
                    }
                }
                // Option is not mentioned in the multi font options; take it from the parent font options.
                // These have already been converted with getBasicOptions(), so use the converted values.
                if (Object.prototype.hasOwnProperty.call(this.fontOptions, option)) return this.fontOptions[option];
                // A value **must** be found; you should never get here.
                throw new Error("Did not find value for multi-font for property: '" + option + "'");
            }
        },
        {
            key: "getFontOptions",
            value: function getFontOptions(pile, multiName) {
                var result = {};
                var optionNames = [
                    "color",
                    "size",
                    "face",
                    "mod",
                    "vadjust"
                ]; // List of allowed options per multi-font
                for(var i = 0; i < optionNames.length; ++i){
                    var mod = optionNames[i];
                    result[mod] = this.getFontOption(pile, multiName, mod);
                }
                return result;
            }
        },
        {
            key: "propagateFonts",
            value: function propagateFonts(pile) {
                var _this2 = this;
                var fontPile = []; // sequence of font objects to consider, order important
                // Note that this.elementOptions is not used here.
                this.addFontOptionsToPile(fontPile, pile);
                this.fontOptions = this.getBasicOptions(fontPile);
                // We set multifont values even if multi === false, for consistency (things break otherwise)
                var _loop = function _loop() {
                    var mod = $bebd28704f2536ea$var$multiFontStyle[i];
                    var modOptions = _this2.fontOptions[mod];
                    var tmpMultiFontOptions = _this2.getFontOptions(fontPile, mod);
                    // Copy over found values
                    $bebd28704f2536ea$var$forEach$1(tmpMultiFontOptions, function(option, n) {
                        modOptions[n] = option;
                    });
                    modOptions.size = Number(modOptions.size);
                    modOptions.vadjust = Number(modOptions.vadjust);
                };
                for(var i = 0; i < $bebd28704f2536ea$var$multiFontStyle.length; ++i)_loop();
            }
        },
        {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover) {
                var baseline = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "middle";
                // if no label, return
                if (this.elementOptions.label === undefined) return;
                // check if we have to render the label
                var viewFontSize = this.fontOptions.size * this.body.view.scale;
                if (this.elementOptions.label && viewFontSize < this.elementOptions.scaling.label.drawThreshold - 1) return;
                // This ensures that there will not be HUGE letters on screen
                // by setting an upper limit on the visible text size (regardless of zoomLevel)
                if (viewFontSize >= this.elementOptions.scaling.label.maxVisible) viewFontSize = Number(this.elementOptions.scaling.label.maxVisible) / this.body.view.scale;
                // update the size cache if required
                this.calculateLabelSize(ctx, selected, hover, x, y, baseline);
                this._drawBackground(ctx);
                this._drawText(ctx, x, this.size.yLine, baseline, viewFontSize);
            }
        },
        {
            key: "_drawBackground",
            value: function _drawBackground(ctx) {
                if (this.fontOptions.background !== undefined && this.fontOptions.background !== "none") {
                    ctx.fillStyle = this.fontOptions.background;
                    var size = this.getSize();
                    ctx.fillRect(size.left, size.top, size.width, size.height);
                }
            }
        },
        {
            key: "_drawText",
            value: function _drawText(ctx, x, y) {
                var baseline = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "middle";
                var viewFontSize = arguments.length > 4 ? arguments[4] : undefined;
                var _this$_setAlignment = this._setAlignment(ctx, x, y, baseline);
                var _this$_setAlignment2 = $bebd28704f2536ea$var$_slicedToArray(_this$_setAlignment, 2);
                x = _this$_setAlignment2[0];
                y = _this$_setAlignment2[1];
                ctx.textAlign = "left";
                x = x - this.size.width / 2; // Shift label 1/2-distance to the left
                if (this.fontOptions.valign && this.size.height > this.size.labelHeight) {
                    if (this.fontOptions.valign === "top") y -= (this.size.height - this.size.labelHeight) / 2;
                    if (this.fontOptions.valign === "bottom") y += (this.size.height - this.size.labelHeight) / 2;
                }
                // draw the text
                for(var i = 0; i < this.lineCount; i++){
                    var line = this.lines[i];
                    if (line && line.blocks) {
                        var width = 0;
                        if (this.isEdgeLabel || this.fontOptions.align === "center") width += (this.size.width - line.width) / 2;
                        else if (this.fontOptions.align === "right") width += this.size.width - line.width;
                        for(var j = 0; j < line.blocks.length; j++){
                            var block = line.blocks[j];
                            ctx.font = block.font;
                            var _this$_getColor = this._getColor(block.color, viewFontSize, block.strokeColor), _this$_getColor2 = $bebd28704f2536ea$var$_slicedToArray(_this$_getColor, 2), fontColor = _this$_getColor2[0], strokeColor = _this$_getColor2[1];
                            if (block.strokeWidth > 0) {
                                ctx.lineWidth = block.strokeWidth;
                                ctx.strokeStyle = strokeColor;
                                ctx.lineJoin = "round";
                            }
                            ctx.fillStyle = fontColor;
                            if (block.strokeWidth > 0) ctx.strokeText(block.text, x + width, y + block.vadjust);
                            ctx.fillText(block.text, x + width, y + block.vadjust);
                            width += block.width;
                        }
                        y += line.height;
                    }
                }
            }
        },
        {
            key: "_setAlignment",
            value: function _setAlignment(ctx, x, y, baseline) {
                // check for label alignment (for edges)
                // TODO: make alignment for nodes
                if (this.isEdgeLabel && this.fontOptions.align !== "horizontal" && this.pointToSelf === false) {
                    x = 0;
                    y = 0;
                    var lineMargin = 2;
                    if (this.fontOptions.align === "top") {
                        ctx.textBaseline = "alphabetic";
                        y -= 2 * lineMargin; // distance from edge, required because we use alphabetic. Alphabetic has less difference between browsers
                    } else if (this.fontOptions.align === "bottom") {
                        ctx.textBaseline = "hanging";
                        y += 2 * lineMargin; // distance from edge, required because we use hanging. Hanging has less difference between browsers
                    } else ctx.textBaseline = "middle";
                } else ctx.textBaseline = baseline;
                return [
                    x,
                    y
                ];
            }
        },
        {
            key: "_getColor",
            value: function _getColor(color, viewFontSize, initialStrokeColor) {
                var fontColor = color || "#000000";
                var strokeColor = initialStrokeColor || "#ffffff";
                if (viewFontSize <= this.elementOptions.scaling.label.drawThreshold) {
                    var opacity = Math.max(0, Math.min(1, 1 - (this.elementOptions.scaling.label.drawThreshold - viewFontSize)));
                    fontColor = $bebd28704f2536ea$var$overrideOpacity(fontColor, opacity);
                    strokeColor = $bebd28704f2536ea$var$overrideOpacity(strokeColor, opacity);
                }
                return [
                    fontColor,
                    strokeColor
                ];
            }
        },
        {
            key: "getTextSize",
            value: function getTextSize(ctx) {
                var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var hover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                this._processLabel(ctx, selected, hover);
                return {
                    width: this.size.width,
                    height: this.size.height,
                    lineCount: this.lineCount
                };
            }
        },
        {
            key: "getSize",
            value: function getSize() {
                var lineMargin = 2;
                var x = this.size.left; // default values which might be overridden below
                var y = this.size.top - 0.5 * lineMargin; // idem
                if (this.isEdgeLabel) {
                    var x2 = -this.size.width * 0.5;
                    switch(this.fontOptions.align){
                        case "middle":
                            x = x2;
                            y = -this.size.height * 0.5;
                            break;
                        case "top":
                            x = x2;
                            y = -(this.size.height + lineMargin);
                            break;
                        case "bottom":
                            x = x2;
                            y = lineMargin;
                            break;
                    }
                }
                var ret = {
                    left: x,
                    top: y,
                    width: this.size.width,
                    height: this.size.height
                };
                return ret;
            }
        },
        {
            key: "calculateLabelSize",
            value: function calculateLabelSize(ctx, selected, hover) {
                var x = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var y = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
                var baseline = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "middle";
                this._processLabel(ctx, selected, hover);
                this.size.left = x - this.size.width * 0.5;
                this.size.top = y - this.size.height * 0.5;
                this.size.yLine = y + (1 - this.lineCount) * 0.5 * this.fontOptions.size;
                if (baseline === "hanging") {
                    this.size.top += 0.5 * this.fontOptions.size;
                    this.size.top += 4; // distance from node, required because we use hanging. Hanging has less difference between browsers
                    this.size.yLine += 4; // distance from node
                }
            }
        },
        {
            key: "getFormattingValues",
            value: function getFormattingValues(ctx, selected, hover, mod) {
                var getValue = function getValue(fontOptions, mod, option) {
                    if (mod === "normal") {
                        if (option === "mod") return "";
                        return fontOptions[option];
                    }
                    if (fontOptions[mod][option] !== undefined) // Grumbl leaving out test on undefined equals false for ""
                    return fontOptions[mod][option];
                    else // Take from parent font option
                    return fontOptions[option];
                };
                var values = {
                    color: getValue(this.fontOptions, mod, "color"),
                    size: getValue(this.fontOptions, mod, "size"),
                    face: getValue(this.fontOptions, mod, "face"),
                    mod: getValue(this.fontOptions, mod, "mod"),
                    vadjust: getValue(this.fontOptions, mod, "vadjust"),
                    strokeWidth: this.fontOptions.strokeWidth,
                    strokeColor: this.fontOptions.strokeColor
                };
                if (selected || hover) {
                    if (mod === "normal" && this.fontOptions.chooser === true && this.elementOptions.labelHighlightBold) values.mod = "bold";
                    else if (typeof this.fontOptions.chooser === "function") this.fontOptions.chooser(values, this.elementOptions.id, selected, hover);
                }
                var fontString = "";
                if (values.mod !== undefined && values.mod !== "") // safeguard for undefined - this happened
                fontString += values.mod + " ";
                fontString += values.size + "px " + values.face;
                ctx.font = fontString.replace(/"/g, "");
                values.font = ctx.font;
                values.height = values.size;
                return values;
            }
        },
        {
            key: "differentState",
            value: function differentState(selected, hover) {
                return selected !== this.selectedState || hover !== this.hoverState;
            }
        },
        {
            key: "_processLabelText",
            value: function _processLabelText(ctx, selected, hover, inText) {
                var splitter = new $bebd28704f2536ea$var$LabelSplitter(ctx, this, selected, hover);
                return splitter.process(inText);
            }
        },
        {
            key: "_processLabel",
            value: function _processLabel(ctx, selected, hover) {
                if (this.labelDirty === false && !this.differentState(selected, hover)) return;
                var state = this._processLabelText(ctx, selected, hover, this.elementOptions.label);
                if (this.fontOptions.minWdt > 0 && state.width < this.fontOptions.minWdt) state.width = this.fontOptions.minWdt;
                this.size.labelHeight = state.height;
                if (this.fontOptions.minHgt > 0 && state.height < this.fontOptions.minHgt) state.height = this.fontOptions.minHgt;
                this.lines = state.lines;
                this.lineCount = state.lines.length;
                this.size.width = state.width;
                this.size.height = state.height;
                this.selectedState = selected;
                this.hoverState = hover;
                this.labelDirty = false;
            }
        },
        {
            key: "visible",
            value: function visible() {
                if (this.size.width === 0 || this.size.height === 0 || this.elementOptions.label === undefined) return false; // nothing to display
                var viewFontSize = this.fontOptions.size * this.body.view.scale;
                if (viewFontSize < this.elementOptions.scaling.label.drawThreshold - 1) return false; // Too small or too far away to show
                return true;
            }
        }
    ], [
        {
            key: "parseFontString",
            value: function parseFontString(outOptions, inOptions) {
                if (!inOptions || typeof inOptions !== "string") return false;
                var newOptionsArray = inOptions.split(" ");
                outOptions.size = +newOptionsArray[0].replace("px", "");
                outOptions.face = newOptionsArray[1];
                outOptions.color = newOptionsArray[2];
                return true;
            }
        }
    ]);
    return Label;
}();
var $bebd28704f2536ea$var$isConstructor = $bebd28704f2536ea$var$isConstructor$4;
var $bebd28704f2536ea$var$tryToString = $bebd28704f2536ea$var$tryToString$6;
var $bebd28704f2536ea$var$$TypeError$1 = TypeError;
// `Assert: IsConstructor(argument) is true`
var $bebd28704f2536ea$var$aConstructor$1 = function(argument) {
    if ($bebd28704f2536ea$var$isConstructor(argument)) return argument;
    throw new $bebd28704f2536ea$var$$TypeError$1($bebd28704f2536ea$var$tryToString(argument) + ' is not a constructor');
};
var $bebd28704f2536ea$var$$$6 = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$getBuiltIn = $bebd28704f2536ea$var$getBuiltIn$c;
var $bebd28704f2536ea$var$apply = $bebd28704f2536ea$var$functionApply;
var $bebd28704f2536ea$var$bind$3 = $bebd28704f2536ea$var$functionBind;
var $bebd28704f2536ea$var$aConstructor = $bebd28704f2536ea$var$aConstructor$1;
var $bebd28704f2536ea$var$anObject$2 = $bebd28704f2536ea$var$anObject$d;
var $bebd28704f2536ea$var$isObject$3 = $bebd28704f2536ea$var$isObject$j;
var $bebd28704f2536ea$var$create$3 = $bebd28704f2536ea$var$objectCreate;
var $bebd28704f2536ea$var$fails$2 = $bebd28704f2536ea$var$fails$w;
var $bebd28704f2536ea$var$nativeConstruct = $bebd28704f2536ea$var$getBuiltIn('Reflect', 'construct');
var $bebd28704f2536ea$var$ObjectPrototype = Object.prototype;
var $bebd28704f2536ea$var$push$1 = [].push;
// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var $bebd28704f2536ea$var$NEW_TARGET_BUG = $bebd28704f2536ea$var$fails$2(function() {
    function F() {}
    return !($bebd28704f2536ea$var$nativeConstruct(function() {}, [], F) instanceof F);
});
var $bebd28704f2536ea$var$ARGS_BUG = !$bebd28704f2536ea$var$fails$2(function() {
    $bebd28704f2536ea$var$nativeConstruct(function() {});
});
var $bebd28704f2536ea$var$FORCED$3 = $bebd28704f2536ea$var$NEW_TARGET_BUG || $bebd28704f2536ea$var$ARGS_BUG;
$bebd28704f2536ea$var$$$6({
    target: 'Reflect',
    stat: true,
    forced: $bebd28704f2536ea$var$FORCED$3,
    sham: $bebd28704f2536ea$var$FORCED$3
}, {
    construct: function construct(Target, args /* , newTarget */ ) {
        $bebd28704f2536ea$var$aConstructor(Target);
        $bebd28704f2536ea$var$anObject$2(args);
        var newTarget = arguments.length < 3 ? Target : $bebd28704f2536ea$var$aConstructor(arguments[2]);
        if ($bebd28704f2536ea$var$ARGS_BUG && !$bebd28704f2536ea$var$NEW_TARGET_BUG) return $bebd28704f2536ea$var$nativeConstruct(Target, args, newTarget);
        if (Target === newTarget) {
            // w/o altered newTarget, optimization for 0-4 arguments
            switch(args.length){
                case 0:
                    return new Target();
                case 1:
                    return new Target(args[0]);
                case 2:
                    return new Target(args[0], args[1]);
                case 3:
                    return new Target(args[0], args[1], args[2]);
                case 4:
                    return new Target(args[0], args[1], args[2], args[3]);
            }
            // w/o altered newTarget, lot of arguments case
            var $args = [
                null
            ];
            $bebd28704f2536ea$var$apply($bebd28704f2536ea$var$push$1, $args, args);
            return new ($bebd28704f2536ea$var$apply($bebd28704f2536ea$var$bind$3, Target, $args))();
        }
        // with altered newTarget, not support built-in constructors
        var proto = newTarget.prototype;
        var instance = $bebd28704f2536ea$var$create$3($bebd28704f2536ea$var$isObject$3(proto) ? proto : $bebd28704f2536ea$var$ObjectPrototype);
        var result = $bebd28704f2536ea$var$apply(Target, instance, args);
        return $bebd28704f2536ea$var$isObject$3(result) ? result : instance;
    }
});
var $bebd28704f2536ea$var$path$6 = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$construct$2 = $bebd28704f2536ea$var$path$6.Reflect.construct;
var $bebd28704f2536ea$var$parent$k = $bebd28704f2536ea$var$construct$2;
var $bebd28704f2536ea$var$construct$1 = $bebd28704f2536ea$var$parent$k;
var $bebd28704f2536ea$var$construct = $bebd28704f2536ea$var$construct$1;
var $bebd28704f2536ea$var$_Reflect$construct = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$construct);
var $bebd28704f2536ea$var$parent$j = $bebd28704f2536ea$var$create$6;
var $bebd28704f2536ea$var$create$2 = $bebd28704f2536ea$var$parent$j;
var $bebd28704f2536ea$var$parent$i = $bebd28704f2536ea$var$create$2;
var $bebd28704f2536ea$var$create$1 = $bebd28704f2536ea$var$parent$i;
var $bebd28704f2536ea$var$create = $bebd28704f2536ea$var$create$1;
var $bebd28704f2536ea$var$_Object$create = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$create);
var $bebd28704f2536ea$var$$$5 = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$setPrototypeOf$5 = $bebd28704f2536ea$var$objectSetPrototypeOf;
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$bebd28704f2536ea$var$$$5({
    target: 'Object',
    stat: true
}, {
    setPrototypeOf: $bebd28704f2536ea$var$setPrototypeOf$5
});
var $bebd28704f2536ea$var$path$5 = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$setPrototypeOf$4 = $bebd28704f2536ea$var$path$5.Object.setPrototypeOf;
var $bebd28704f2536ea$var$parent$h = $bebd28704f2536ea$var$setPrototypeOf$4;
var $bebd28704f2536ea$var$setPrototypeOf$3 = $bebd28704f2536ea$var$parent$h;
var $bebd28704f2536ea$var$parent$g = $bebd28704f2536ea$var$setPrototypeOf$3;
var $bebd28704f2536ea$var$setPrototypeOf$2 = $bebd28704f2536ea$var$parent$g;
var $bebd28704f2536ea$var$parent$f = $bebd28704f2536ea$var$setPrototypeOf$2;
var $bebd28704f2536ea$var$setPrototypeOf$1 = $bebd28704f2536ea$var$parent$f;
var $bebd28704f2536ea$var$setPrototypeOf = $bebd28704f2536ea$var$setPrototypeOf$1;
var $bebd28704f2536ea$var$_Object$setPrototypeOf = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$setPrototypeOf);
var $bebd28704f2536ea$var$parent$e = $bebd28704f2536ea$var$bind$9;
var $bebd28704f2536ea$var$bind$2 = $bebd28704f2536ea$var$parent$e;
var $bebd28704f2536ea$var$parent$d = $bebd28704f2536ea$var$bind$2;
var $bebd28704f2536ea$var$bind$1 = $bebd28704f2536ea$var$parent$d;
var $bebd28704f2536ea$var$bind = $bebd28704f2536ea$var$bind$1;
var $bebd28704f2536ea$var$_bindInstanceProperty = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$bind);
function $bebd28704f2536ea$var$_setPrototypeOf(o, p) {
    var _context;
    $bebd28704f2536ea$var$_setPrototypeOf = $bebd28704f2536ea$var$_Object$setPrototypeOf ? $bebd28704f2536ea$var$_bindInstanceProperty(_context = $bebd28704f2536ea$var$_Object$setPrototypeOf).call(_context) : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bebd28704f2536ea$var$_setPrototypeOf(o, p);
}
function $bebd28704f2536ea$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = $bebd28704f2536ea$var$_Object$create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    $bebd28704f2536ea$var$_Object$defineProperty$1(subClass, "prototype", {
        writable: false
    });
    if (superClass) $bebd28704f2536ea$var$_setPrototypeOf(subClass, superClass);
}
function $bebd28704f2536ea$var$_assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function $bebd28704f2536ea$var$_possibleConstructorReturn(self1, call) {
    if (call && ($bebd28704f2536ea$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $bebd28704f2536ea$var$_assertThisInitialized(self1);
}
var $bebd28704f2536ea$var$parent$c = $bebd28704f2536ea$var$getPrototypeOf$5;
var $bebd28704f2536ea$var$getPrototypeOf$3 = $bebd28704f2536ea$var$parent$c;
var $bebd28704f2536ea$var$parent$b = $bebd28704f2536ea$var$getPrototypeOf$3;
var $bebd28704f2536ea$var$getPrototypeOf$2 = $bebd28704f2536ea$var$parent$b;
var $bebd28704f2536ea$var$getPrototypeOf$1 = $bebd28704f2536ea$var$getPrototypeOf$2;
var $bebd28704f2536ea$var$_Object$getPrototypeOf = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$getPrototypeOf$1);
function $bebd28704f2536ea$var$_getPrototypeOf(o) {
    var _context;
    $bebd28704f2536ea$var$_getPrototypeOf = $bebd28704f2536ea$var$_Object$setPrototypeOf ? $bebd28704f2536ea$var$_bindInstanceProperty(_context = $bebd28704f2536ea$var$_Object$getPrototypeOf).call(_context) : function _getPrototypeOf(o) {
        return o.__proto__ || $bebd28704f2536ea$var$_Object$getPrototypeOf(o);
    };
    return $bebd28704f2536ea$var$_getPrototypeOf(o);
}
/**
 * The Base class for all Nodes.
 */ var $bebd28704f2536ea$var$NodeBase = /*#__PURE__*/ function() {
    /**
   * @param {object} options
   * @param {object} body
   * @param {Label} labelModule
   */ function NodeBase(options, body, labelModule) {
        $bebd28704f2536ea$var$_classCallCheck(this, NodeBase);
        this.body = body;
        this.labelModule = labelModule;
        this.setOptions(options);
        this.top = undefined;
        this.left = undefined;
        this.height = undefined;
        this.width = undefined;
        this.radius = undefined;
        this.margin = undefined;
        this.refreshNeeded = true;
        this.boundingBox = {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
        };
    }
    /**
   *
   * @param {object} options
   */ $bebd28704f2536ea$var$_createClass(NodeBase, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
            }
        },
        {
            key: "_setMargins",
            value: function _setMargins(labelModule) {
                this.margin = {};
                if (this.options.margin) {
                    if ($bebd28704f2536ea$var$_typeof(this.options.margin) == "object") {
                        this.margin.top = this.options.margin.top;
                        this.margin.right = this.options.margin.right;
                        this.margin.bottom = this.options.margin.bottom;
                        this.margin.left = this.options.margin.left;
                    } else {
                        this.margin.top = this.options.margin;
                        this.margin.right = this.options.margin;
                        this.margin.bottom = this.options.margin;
                        this.margin.left = this.options.margin;
                    }
                }
                labelModule.adjustSizes(this.margin);
            }
        },
        {
            key: "_distanceToBorder",
            value: function _distanceToBorder(ctx, angle) {
                var borderWidth = this.options.borderWidth;
                if (ctx) this.resize(ctx);
                return Math.min(Math.abs(this.width / 2 / Math.cos(angle)), Math.abs(this.height / 2 / Math.sin(angle))) + borderWidth;
            }
        },
        {
            key: "enableShadow",
            value: function enableShadow(ctx, values) {
                if (values.shadow) {
                    ctx.shadowColor = values.shadowColor;
                    ctx.shadowBlur = values.shadowSize;
                    ctx.shadowOffsetX = values.shadowX;
                    ctx.shadowOffsetY = values.shadowY;
                }
            }
        },
        {
            key: "disableShadow",
            value: function disableShadow(ctx, values) {
                if (values.shadow) {
                    ctx.shadowColor = "rgba(0,0,0,0)";
                    ctx.shadowBlur = 0;
                    ctx.shadowOffsetX = 0;
                    ctx.shadowOffsetY = 0;
                }
            }
        },
        {
            key: "enableBorderDashes",
            value: function enableBorderDashes(ctx, values) {
                if (values.borderDashes !== false) {
                    if (ctx.setLineDash !== undefined) {
                        var dashes = values.borderDashes;
                        if (dashes === true) dashes = [
                            5,
                            15
                        ];
                        ctx.setLineDash(dashes);
                    } else {
                        console.warn("setLineDash is not supported in this browser. The dashed borders cannot be used.");
                        this.options.shapeProperties.borderDashes = false;
                        values.borderDashes = false;
                    }
                }
            }
        },
        {
            key: "disableBorderDashes",
            value: function disableBorderDashes(ctx, values) {
                if (values.borderDashes !== false) {
                    if (ctx.setLineDash !== undefined) ctx.setLineDash([
                        0
                    ]);
                    else {
                        console.warn("setLineDash is not supported in this browser. The dashed borders cannot be used.");
                        this.options.shapeProperties.borderDashes = false;
                        values.borderDashes = false;
                    }
                }
            }
        },
        {
            key: "needsRefresh",
            value: function needsRefresh(selected, hover) {
                if (this.refreshNeeded === true) {
                    // This is probably not the best location to reset this member.
                    // However, in the current logic, it is the most convenient one.
                    this.refreshNeeded = false;
                    return true;
                }
                return this.width === undefined || this.labelModule.differentState(selected, hover);
            }
        },
        {
            key: "initContextForDraw",
            value: function initContextForDraw(ctx, values) {
                var borderWidth = values.borderWidth / this.body.view.scale;
                ctx.lineWidth = Math.min(this.width, borderWidth);
                ctx.strokeStyle = values.borderColor;
                ctx.fillStyle = values.color;
            }
        },
        {
            key: "performStroke",
            value: function performStroke(ctx, values) {
                var borderWidth = values.borderWidth / this.body.view.scale;
                //draw dashed border if enabled, save and restore is required for firefox not to crash on unix.
                ctx.save();
                // if borders are zero width, they will be drawn with width 1 by default. This prevents that
                if (borderWidth > 0) {
                    this.enableBorderDashes(ctx, values);
                    //draw the border
                    ctx.stroke();
                    //disable dashed border for other elements
                    this.disableBorderDashes(ctx, values);
                }
                ctx.restore();
            }
        },
        {
            key: "performFill",
            value: function performFill(ctx, values) {
                ctx.save();
                ctx.fillStyle = values.color;
                // draw shadow if enabled
                this.enableShadow(ctx, values);
                // draw the background
                $bebd28704f2536ea$var$_fillInstanceProperty(ctx).call(ctx);
                // disable shadows for other elements.
                this.disableShadow(ctx, values);
                ctx.restore();
                this.performStroke(ctx, values);
            }
        },
        {
            key: "_addBoundingBoxMargin",
            value: function _addBoundingBoxMargin(margin) {
                this.boundingBox.left -= margin;
                this.boundingBox.top -= margin;
                this.boundingBox.bottom += margin;
                this.boundingBox.right += margin;
            }
        },
        {
            key: "_updateBoundingBox",
            value: function _updateBoundingBox(x, y, ctx, selected, hover) {
                if (ctx !== undefined) this.resize(ctx, selected, hover);
                this.left = x - this.width / 2;
                this.top = y - this.height / 2;
                this.boundingBox.left = this.left;
                this.boundingBox.top = this.top;
                this.boundingBox.bottom = this.top + this.height;
                this.boundingBox.right = this.left + this.width;
            }
        },
        {
            key: "updateBoundingBox",
            value: function updateBoundingBox(x, y, ctx, selected, hover) {
                this._updateBoundingBox(x, y, ctx, selected, hover);
            }
        },
        {
            key: "getDimensionsFromLabel",
            value: function getDimensionsFromLabel(ctx, selected, hover) {
                // NOTE: previously 'textSize' was not put in 'this' for Ellipse
                // TODO: examine the consequences.
                this.textSize = this.labelModule.getTextSize(ctx, selected, hover);
                var width = this.textSize.width;
                var height = this.textSize.height;
                var DEFAULT_SIZE = 14;
                if (width === 0) {
                    // This happens when there is no label text set
                    width = DEFAULT_SIZE; // use a decent default
                    height = DEFAULT_SIZE; // if width zero, then height also always zero
                }
                return {
                    width: width,
                    height: height
                };
            }
        }
    ]);
    return NodeBase;
}();
function $bebd28704f2536ea$var$_createSuper$s(Derived) {
    var hasNativeReflectConstruct = $bebd28704f2536ea$var$_isNativeReflectConstruct$s();
    return function _createSuperInternal() {
        var Super = $bebd28704f2536ea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bebd28704f2536ea$var$_getPrototypeOf(this).constructor;
            result = $bebd28704f2536ea$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bebd28704f2536ea$var$_possibleConstructorReturn(this, result);
    };
}
function $bebd28704f2536ea$var$_isNativeReflectConstruct$s() {
    if (typeof Reflect === "undefined" || !$bebd28704f2536ea$var$_Reflect$construct) return false;
    if ($bebd28704f2536ea$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($bebd28704f2536ea$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * A Box Node/Cluster shape.
 *
 * @augments NodeBase
 */ var $bebd28704f2536ea$var$Box$1 = /*#__PURE__*/ function(_NodeBase) {
    $bebd28704f2536ea$var$_inherits(Box, _NodeBase);
    var _super = $bebd28704f2536ea$var$_createSuper$s(Box);
    /**
   * @param {object} options
   * @param {object} body
   * @param {Label} labelModule
   */ function Box(options, body, labelModule) {
        var _this;
        $bebd28704f2536ea$var$_classCallCheck(this, Box);
        _this = _super.call(this, options, body, labelModule);
        _this._setMargins(labelModule);
        return _this;
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {boolean} [selected]
   * @param {boolean} [hover]
   */ $bebd28704f2536ea$var$_createClass(Box, [
        {
            key: "resize",
            value: function resize(ctx) {
                var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selected;
                var hover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.hover;
                if (this.needsRefresh(selected, hover)) {
                    var dimensions = this.getDimensionsFromLabel(ctx, selected, hover);
                    this.width = dimensions.width + this.margin.right + this.margin.left;
                    this.height = dimensions.height + this.margin.top + this.margin.bottom;
                    this.radius = this.width / 2;
                }
            }
        },
        {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                this.resize(ctx, selected, hover);
                this.left = x - this.width / 2;
                this.top = y - this.height / 2;
                this.initContextForDraw(ctx, values);
                $bebd28704f2536ea$var$drawRoundRect(ctx, this.left, this.top, this.width, this.height, values.borderRadius);
                this.performFill(ctx, values);
                this.updateBoundingBox(x, y, ctx, selected, hover);
                this.labelModule.draw(ctx, this.left + this.textSize.width / 2 + this.margin.left, this.top + this.textSize.height / 2 + this.margin.top, selected, hover);
            }
        },
        {
            key: "updateBoundingBox",
            value: function updateBoundingBox(x, y, ctx, selected, hover) {
                this._updateBoundingBox(x, y, ctx, selected, hover);
                var borderRadius = this.options.shapeProperties.borderRadius; // only effective for box
                this._addBoundingBoxMargin(borderRadius);
            }
        },
        {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                if (ctx) this.resize(ctx);
                var borderWidth = this.options.borderWidth;
                return Math.min(Math.abs(this.width / 2 / Math.cos(angle)), Math.abs(this.height / 2 / Math.sin(angle))) + borderWidth;
            }
        }
    ]);
    return Box;
}($bebd28704f2536ea$var$NodeBase);
function $bebd28704f2536ea$var$_createSuper$r(Derived) {
    var hasNativeReflectConstruct = $bebd28704f2536ea$var$_isNativeReflectConstruct$r();
    return function _createSuperInternal() {
        var Super = $bebd28704f2536ea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bebd28704f2536ea$var$_getPrototypeOf(this).constructor;
            result = $bebd28704f2536ea$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bebd28704f2536ea$var$_possibleConstructorReturn(this, result);
    };
}
function $bebd28704f2536ea$var$_isNativeReflectConstruct$r() {
    if (typeof Reflect === "undefined" || !$bebd28704f2536ea$var$_Reflect$construct) return false;
    if ($bebd28704f2536ea$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($bebd28704f2536ea$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * NOTE: This is a bad base class
 *
 * Child classes are:
 *
 *   Image       - uses *only* image methods
 *   Circle      - uses *only* _drawRawCircle
 *   CircleImage - uses all
 *
 * TODO: Refactor, move _drawRawCircle to different module, derive Circle from NodeBase
 *       Rename this to ImageBase
 *       Consolidate common code in Image and CircleImage to base class
 *
 * @augments NodeBase
 */ var $bebd28704f2536ea$var$CircleImageBase = /*#__PURE__*/ function(_NodeBase) {
    $bebd28704f2536ea$var$_inherits(CircleImageBase, _NodeBase);
    var _super = $bebd28704f2536ea$var$_createSuper$r(CircleImageBase);
    /**
   * @param {object} options
   * @param {object} body
   * @param {Label} labelModule
   */ function CircleImageBase(options, body, labelModule) {
        var _this;
        $bebd28704f2536ea$var$_classCallCheck(this, CircleImageBase);
        _this = _super.call(this, options, body, labelModule);
        _this.labelOffset = 0;
        _this.selected = false;
        return _this;
    }
    /**
   *
   * @param {object} options
   * @param {object} [imageObj]
   * @param {object} [imageObjAlt]
   */ $bebd28704f2536ea$var$_createClass(CircleImageBase, [
        {
            key: "setOptions",
            value: function setOptions(options, imageObj, imageObjAlt) {
                this.options = options;
                if (!(imageObj === undefined && imageObjAlt === undefined)) this.setImages(imageObj, imageObjAlt);
            }
        },
        {
            key: "setImages",
            value: function setImages(imageObj, imageObjAlt) {
                if (imageObjAlt && this.selected) {
                    this.imageObj = imageObjAlt;
                    this.imageObjAlt = imageObj;
                } else {
                    this.imageObj = imageObj;
                    this.imageObjAlt = imageObjAlt;
                }
            }
        },
        {
            key: "switchImages",
            value: function switchImages(selected) {
                var selection_changed = selected && !this.selected || !selected && this.selected;
                this.selected = selected; // Remember new selection
                if (this.imageObjAlt !== undefined && selection_changed) {
                    var imageTmp = this.imageObj;
                    this.imageObj = this.imageObjAlt;
                    this.imageObjAlt = imageTmp;
                }
            }
        },
        {
            key: "_getImagePadding",
            value: function _getImagePadding() {
                var imgPadding = {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                };
                if (this.options.imagePadding) {
                    var optImgPadding = this.options.imagePadding;
                    if ($bebd28704f2536ea$var$_typeof(optImgPadding) == "object") {
                        imgPadding.top = optImgPadding.top;
                        imgPadding.right = optImgPadding.right;
                        imgPadding.bottom = optImgPadding.bottom;
                        imgPadding.left = optImgPadding.left;
                    } else {
                        imgPadding.top = optImgPadding;
                        imgPadding.right = optImgPadding;
                        imgPadding.bottom = optImgPadding;
                        imgPadding.left = optImgPadding;
                    }
                }
                return imgPadding;
            }
        },
        {
            key: "_resizeImage",
            value: function _resizeImage() {
                var width, height;
                if (this.options.shapeProperties.useImageSize === false) {
                    // Use the size property
                    var ratio_width = 1;
                    var ratio_height = 1;
                    // Only calculate the proper ratio if both width and height not zero
                    if (this.imageObj.width && this.imageObj.height) {
                        if (this.imageObj.width > this.imageObj.height) ratio_width = this.imageObj.width / this.imageObj.height;
                        else ratio_height = this.imageObj.height / this.imageObj.width;
                    }
                    width = this.options.size * 2 * ratio_width;
                    height = this.options.size * 2 * ratio_height;
                } else {
                    // Use the image size with image padding
                    var imgPadding = this._getImagePadding();
                    width = this.imageObj.width + imgPadding.left + imgPadding.right;
                    height = this.imageObj.height + imgPadding.top + imgPadding.bottom;
                }
                this.width = width;
                this.height = height;
                this.radius = 0.5 * this.width;
            }
        },
        {
            key: "_drawRawCircle",
            value: function _drawRawCircle(ctx, x, y, values) {
                this.initContextForDraw(ctx, values);
                $bebd28704f2536ea$var$drawCircle(ctx, x, y, values.size);
                this.performFill(ctx, values);
            }
        },
        {
            key: "_drawImageAtPosition",
            value: function _drawImageAtPosition(ctx, values) {
                if (this.imageObj.width != 0) {
                    // draw the image
                    ctx.globalAlpha = values.opacity !== undefined ? values.opacity : 1;
                    // draw shadow if enabled
                    this.enableShadow(ctx, values);
                    var factor = 1;
                    if (this.options.shapeProperties.interpolation === true) factor = this.imageObj.width / this.width / this.body.view.scale;
                    var imgPadding = this._getImagePadding();
                    var imgPosLeft = this.left + imgPadding.left;
                    var imgPosTop = this.top + imgPadding.top;
                    var imgWidth = this.width - imgPadding.left - imgPadding.right;
                    var imgHeight = this.height - imgPadding.top - imgPadding.bottom;
                    this.imageObj.drawImageAtPosition(ctx, factor, imgPosLeft, imgPosTop, imgWidth, imgHeight);
                    // disable shadows for other elements.
                    this.disableShadow(ctx, values);
                }
            }
        },
        {
            key: "_drawImageLabel",
            value: function _drawImageLabel(ctx, x, y, selected, hover) {
                var offset = 0;
                if (this.height !== undefined) {
                    offset = this.height * 0.5;
                    var labelDimensions = this.labelModule.getTextSize(ctx, selected, hover);
                    if (labelDimensions.lineCount >= 1) offset += labelDimensions.height / 2;
                }
                var yLabel = y + offset;
                if (this.options.label) this.labelOffset = offset;
                this.labelModule.draw(ctx, x, yLabel, selected, hover, "hanging");
            }
        }
    ]);
    return CircleImageBase;
}($bebd28704f2536ea$var$NodeBase);
function $bebd28704f2536ea$var$_createSuper$q(Derived) {
    var hasNativeReflectConstruct = $bebd28704f2536ea$var$_isNativeReflectConstruct$q();
    return function _createSuperInternal() {
        var Super = $bebd28704f2536ea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bebd28704f2536ea$var$_getPrototypeOf(this).constructor;
            result = $bebd28704f2536ea$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bebd28704f2536ea$var$_possibleConstructorReturn(this, result);
    };
}
function $bebd28704f2536ea$var$_isNativeReflectConstruct$q() {
    if (typeof Reflect === "undefined" || !$bebd28704f2536ea$var$_Reflect$construct) return false;
    if ($bebd28704f2536ea$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($bebd28704f2536ea$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * A Circle Node/Cluster shape.
 *
 * @augments CircleImageBase
 */ var $bebd28704f2536ea$var$Circle$1 = /*#__PURE__*/ function(_CircleImageBase) {
    $bebd28704f2536ea$var$_inherits(Circle, _CircleImageBase);
    var _super = $bebd28704f2536ea$var$_createSuper$q(Circle);
    /**
   * @param {object} options
   * @param {object} body
   * @param {Label} labelModule
   */ function Circle(options, body, labelModule) {
        var _this;
        $bebd28704f2536ea$var$_classCallCheck(this, Circle);
        _this = _super.call(this, options, body, labelModule);
        _this._setMargins(labelModule);
        return _this;
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {boolean} [selected]
   * @param {boolean} [hover]
   */ $bebd28704f2536ea$var$_createClass(Circle, [
        {
            key: "resize",
            value: function resize(ctx) {
                var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selected;
                var hover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.hover;
                if (this.needsRefresh(selected, hover)) {
                    var dimensions = this.getDimensionsFromLabel(ctx, selected, hover);
                    var diameter = Math.max(dimensions.width + this.margin.right + this.margin.left, dimensions.height + this.margin.top + this.margin.bottom);
                    this.options.size = diameter / 2; // NOTE: this size field only set here, not in Ellipse, Database, Box
                    this.width = diameter;
                    this.height = diameter;
                    this.radius = this.width / 2;
                }
            }
        },
        {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                this.resize(ctx, selected, hover);
                this.left = x - this.width / 2;
                this.top = y - this.height / 2;
                this._drawRawCircle(ctx, x, y, values);
                this.updateBoundingBox(x, y);
                this.labelModule.draw(ctx, this.left + this.textSize.width / 2 + this.margin.left, y, selected, hover);
            }
        },
        {
            key: "updateBoundingBox",
            value: function updateBoundingBox(x, y) {
                this.boundingBox.top = y - this.options.size;
                this.boundingBox.left = x - this.options.size;
                this.boundingBox.right = x + this.options.size;
                this.boundingBox.bottom = y + this.options.size;
            }
        },
        {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx) {
                if (ctx) this.resize(ctx);
                return this.width * 0.5;
            }
        }
    ]);
    return Circle;
}($bebd28704f2536ea$var$CircleImageBase);
function $bebd28704f2536ea$var$_createSuper$p(Derived) {
    var hasNativeReflectConstruct = $bebd28704f2536ea$var$_isNativeReflectConstruct$p();
    return function _createSuperInternal() {
        var Super = $bebd28704f2536ea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bebd28704f2536ea$var$_getPrototypeOf(this).constructor;
            result = $bebd28704f2536ea$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bebd28704f2536ea$var$_possibleConstructorReturn(this, result);
    };
}
function $bebd28704f2536ea$var$_isNativeReflectConstruct$p() {
    if (typeof Reflect === "undefined" || !$bebd28704f2536ea$var$_Reflect$construct) return false;
    if ($bebd28704f2536ea$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($bebd28704f2536ea$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * A CircularImage Node/Cluster shape.
 *
 * @augments CircleImageBase
 */ var $bebd28704f2536ea$var$CircularImage = /*#__PURE__*/ function(_CircleImageBase) {
    $bebd28704f2536ea$var$_inherits(CircularImage, _CircleImageBase);
    var _super = $bebd28704f2536ea$var$_createSuper$p(CircularImage);
    /**
   * @param {object} options
   * @param {object} body
   * @param {Label} labelModule
   * @param {Image} imageObj
   * @param {Image} imageObjAlt
   */ function CircularImage(options, body, labelModule, imageObj, imageObjAlt) {
        var _this;
        $bebd28704f2536ea$var$_classCallCheck(this, CircularImage);
        _this = _super.call(this, options, body, labelModule);
        _this.setImages(imageObj, imageObjAlt);
        return _this;
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {boolean} [selected]
   * @param {boolean} [hover]
   */ $bebd28704f2536ea$var$_createClass(CircularImage, [
        {
            key: "resize",
            value: function resize(ctx) {
                var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selected;
                var hover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.hover;
                var imageAbsent = this.imageObj.src === undefined || this.imageObj.width === undefined || this.imageObj.height === undefined;
                if (imageAbsent) {
                    var diameter = this.options.size * 2;
                    this.width = diameter;
                    this.height = diameter;
                    this.radius = 0.5 * this.width;
                    return;
                }
                // At this point, an image is present, i.e. this.imageObj is valid.
                if (this.needsRefresh(selected, hover)) this._resizeImage();
            }
        },
        {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                this.switchImages(selected);
                this.resize();
                var labelX = x, labelY = y;
                if (this.options.shapeProperties.coordinateOrigin === "top-left") {
                    this.left = x;
                    this.top = y;
                    labelX += this.width / 2;
                    labelY += this.height / 2;
                } else {
                    this.left = x - this.width / 2;
                    this.top = y - this.height / 2;
                }
                // draw the background circle. IMPORTANT: the stroke in this method is used by the clip method below.
                this._drawRawCircle(ctx, labelX, labelY, values);
                // now we draw in the circle, we save so we can revert the clip operation after drawing.
                ctx.save();
                // clip is used to use the stroke in drawRawCircle as an area that we can draw in.
                ctx.clip();
                // draw the image
                this._drawImageAtPosition(ctx, values);
                // restore so we can again draw on the full canvas
                ctx.restore();
                this._drawImageLabel(ctx, labelX, labelY, selected, hover);
                this.updateBoundingBox(x, y);
            }
        },
        {
            key: "updateBoundingBox",
            value: function updateBoundingBox(x, y) {
                if (this.options.shapeProperties.coordinateOrigin === "top-left") {
                    this.boundingBox.top = y;
                    this.boundingBox.left = x;
                    this.boundingBox.right = x + this.options.size * 2;
                    this.boundingBox.bottom = y + this.options.size * 2;
                } else {
                    this.boundingBox.top = y - this.options.size;
                    this.boundingBox.left = x - this.options.size;
                    this.boundingBox.right = x + this.options.size;
                    this.boundingBox.bottom = y + this.options.size;
                }
                // TODO: compare with Image.updateBoundingBox(), consolidate?
                this.boundingBox.left = Math.min(this.boundingBox.left, this.labelModule.size.left);
                this.boundingBox.right = Math.max(this.boundingBox.right, this.labelModule.size.left + this.labelModule.size.width);
                this.boundingBox.bottom = Math.max(this.boundingBox.bottom, this.boundingBox.bottom + this.labelOffset);
            }
        },
        {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx) {
                if (ctx) this.resize(ctx);
                return this.width * 0.5;
            }
        }
    ]);
    return CircularImage;
}($bebd28704f2536ea$var$CircleImageBase);
function $bebd28704f2536ea$var$_createSuper$o(Derived) {
    var hasNativeReflectConstruct = $bebd28704f2536ea$var$_isNativeReflectConstruct$o();
    return function _createSuperInternal() {
        var Super = $bebd28704f2536ea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bebd28704f2536ea$var$_getPrototypeOf(this).constructor;
            result = $bebd28704f2536ea$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bebd28704f2536ea$var$_possibleConstructorReturn(this, result);
    };
}
function $bebd28704f2536ea$var$_isNativeReflectConstruct$o() {
    if (typeof Reflect === "undefined" || !$bebd28704f2536ea$var$_Reflect$construct) return false;
    if ($bebd28704f2536ea$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($bebd28704f2536ea$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Base class for constructing Node/Cluster Shapes.
 *
 * @augments NodeBase
 */ var $bebd28704f2536ea$var$ShapeBase = /*#__PURE__*/ function(_NodeBase) {
    $bebd28704f2536ea$var$_inherits(ShapeBase, _NodeBase);
    var _super = $bebd28704f2536ea$var$_createSuper$o(ShapeBase);
    /**
   * @param {object} options
   * @param {object} body
   * @param {Label} labelModule
   */ function ShapeBase(options, body, labelModule) {
        $bebd28704f2536ea$var$_classCallCheck(this, ShapeBase);
        return _super.call(this, options, body, labelModule);
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {boolean} [selected]
   * @param {boolean} [hover]
   * @param {object} [values={size: this.options.size}]
   */ $bebd28704f2536ea$var$_createClass(ShapeBase, [
        {
            key: "resize",
            value: function resize(ctx) {
                var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selected;
                var hover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.hover;
                var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    size: this.options.size
                };
                if (this.needsRefresh(selected, hover)) {
                    var _this$customSizeWidth, _this$customSizeHeigh;
                    this.labelModule.getTextSize(ctx, selected, hover);
                    var size = 2 * values.size;
                    this.width = (_this$customSizeWidth = this.customSizeWidth) !== null && _this$customSizeWidth !== void 0 ? _this$customSizeWidth : size;
                    this.height = (_this$customSizeHeigh = this.customSizeHeight) !== null && _this$customSizeHeigh !== void 0 ? _this$customSizeHeigh : size;
                    this.radius = 0.5 * this.width;
                }
            }
        },
        {
            key: "_drawShape",
            value: function _drawShape(ctx, shape, sizeMultiplier, x, y, selected, hover, values) {
                var _this = this;
                this.resize(ctx, selected, hover, values);
                this.left = x - this.width / 2;
                this.top = y - this.height / 2;
                this.initContextForDraw(ctx, values);
                $bebd28704f2536ea$var$getShape(shape)(ctx, x, y, values.size);
                this.performFill(ctx, values);
                if (this.options.icon !== undefined) {
                    if (this.options.icon.code !== undefined) {
                        ctx.font = (selected ? "bold " : "") + this.height / 2 + "px " + (this.options.icon.face || "FontAwesome");
                        ctx.fillStyle = this.options.icon.color || "black";
                        ctx.textAlign = "center";
                        ctx.textBaseline = "middle";
                        ctx.fillText(this.options.icon.code, x, y);
                    }
                }
                return {
                    drawExternalLabel: function drawExternalLabel() {
                        if (_this.options.label !== undefined) {
                            // Need to call following here in order to ensure value for
                            // `this.labelModule.size.height`.
                            _this.labelModule.calculateLabelSize(ctx, selected, hover, x, y, "hanging");
                            var yLabel = y + 0.5 * _this.height + 0.5 * _this.labelModule.size.height;
                            _this.labelModule.draw(ctx, x, yLabel, selected, hover, "hanging");
                        }
                        _this.updateBoundingBox(x, y);
                    }
                };
            }
        },
        {
            key: "updateBoundingBox",
            value: function updateBoundingBox(x, y) {
                this.boundingBox.top = y - this.options.size;
                this.boundingBox.left = x - this.options.size;
                this.boundingBox.right = x + this.options.size;
                this.boundingBox.bottom = y + this.options.size;
                if (this.options.label !== undefined && this.labelModule.size.width > 0) {
                    this.boundingBox.left = Math.min(this.boundingBox.left, this.labelModule.size.left);
                    this.boundingBox.right = Math.max(this.boundingBox.right, this.labelModule.size.left + this.labelModule.size.width);
                    this.boundingBox.bottom = Math.max(this.boundingBox.bottom, this.boundingBox.bottom + this.labelModule.size.height);
                }
            }
        }
    ]);
    return ShapeBase;
}($bebd28704f2536ea$var$NodeBase);
function $bebd28704f2536ea$var$ownKeys$3(e, r) {
    var t = $bebd28704f2536ea$var$_Object$keys(e);
    if ($bebd28704f2536ea$var$_Object$getOwnPropertySymbols) {
        var o = $bebd28704f2536ea$var$_Object$getOwnPropertySymbols(e);
        r && (o = $bebd28704f2536ea$var$_filterInstanceProperty(o).call(o, function(r) {
            return $bebd28704f2536ea$var$_Object$getOwnPropertyDescriptor$1(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bebd28704f2536ea$var$_objectSpread$3(e) {
    for(var r = 1; r < arguments.length; r++){
        var _context, _context2;
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bebd28704f2536ea$var$_forEachInstanceProperty(_context = $bebd28704f2536ea$var$ownKeys$3(Object(t), !0)).call(_context, function(r) {
            $bebd28704f2536ea$var$_defineProperty(e, r, t[r]);
        }) : $bebd28704f2536ea$var$_Object$getOwnPropertyDescriptors ? $bebd28704f2536ea$var$_Object$defineProperties(e, $bebd28704f2536ea$var$_Object$getOwnPropertyDescriptors(t)) : $bebd28704f2536ea$var$_forEachInstanceProperty(_context2 = $bebd28704f2536ea$var$ownKeys$3(Object(t))).call(_context2, function(r) {
            $bebd28704f2536ea$var$_Object$defineProperty(e, r, $bebd28704f2536ea$var$_Object$getOwnPropertyDescriptor$1(t, r));
        });
    }
    return e;
}
function $bebd28704f2536ea$var$_createSuper$n(Derived) {
    var hasNativeReflectConstruct = $bebd28704f2536ea$var$_isNativeReflectConstruct$n();
    return function _createSuperInternal() {
        var Super = $bebd28704f2536ea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bebd28704f2536ea$var$_getPrototypeOf(this).constructor;
            result = $bebd28704f2536ea$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bebd28704f2536ea$var$_possibleConstructorReturn(this, result);
    };
}
function $bebd28704f2536ea$var$_isNativeReflectConstruct$n() {
    if (typeof Reflect === "undefined" || !$bebd28704f2536ea$var$_Reflect$construct) return false;
    if ($bebd28704f2536ea$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($bebd28704f2536ea$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * A CustomShape Node/Cluster shape.
 *
 * @augments ShapeBase
 */ var $bebd28704f2536ea$var$CustomShape = /*#__PURE__*/ function(_ShapeBase) {
    $bebd28704f2536ea$var$_inherits(CustomShape, _ShapeBase);
    var _super = $bebd28704f2536ea$var$_createSuper$n(CustomShape);
    /**
   * @param {object} options
   * @param {object} body
   * @param {Label} labelModule
   * @param {Function} ctxRenderer
   */ function CustomShape(options, body, labelModule, ctxRenderer) {
        var _this;
        $bebd28704f2536ea$var$_classCallCheck(this, CustomShape);
        _this = _super.call(this, options, body, labelModule, ctxRenderer);
        _this.ctxRenderer = ctxRenderer;
        return _this;
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} x width
   * @param {number} y height
   * @param {boolean} selected
   * @param {boolean} hover
   * @param {ArrowOptions} values
   * @returns {object} Callbacks to draw later on different layers.
   */ $bebd28704f2536ea$var$_createClass(CustomShape, [
        {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                this.resize(ctx, selected, hover, values);
                this.left = x - this.width / 2;
                this.top = y - this.height / 2;
                // Guard right away because someone may just draw in the function itself.
                ctx.save();
                var drawLater = this.ctxRenderer({
                    ctx: ctx,
                    id: this.options.id,
                    x: x,
                    y: y,
                    state: {
                        selected: selected,
                        hover: hover
                    },
                    style: $bebd28704f2536ea$var$_objectSpread$3({}, values),
                    label: this.options.label
                });
                // Render the node shape bellow arrows.
                if (drawLater.drawNode != null) drawLater.drawNode();
                ctx.restore();
                if (drawLater.drawExternalLabel) {
                    // Guard the external label (above arrows) drawing function.
                    var drawExternalLabel = drawLater.drawExternalLabel;
                    drawLater.drawExternalLabel = function() {
                        ctx.save();
                        drawExternalLabel();
                        ctx.restore();
                    };
                }
                if (drawLater.nodeDimensions) {
                    this.customSizeWidth = drawLater.nodeDimensions.width;
                    this.customSizeHeight = drawLater.nodeDimensions.height;
                }
                return drawLater;
            }
        },
        {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }
    ]);
    return CustomShape;
}($bebd28704f2536ea$var$ShapeBase);
function $bebd28704f2536ea$var$_createSuper$m(Derived) {
    var hasNativeReflectConstruct = $bebd28704f2536ea$var$_isNativeReflectConstruct$m();
    return function _createSuperInternal() {
        var Super = $bebd28704f2536ea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bebd28704f2536ea$var$_getPrototypeOf(this).constructor;
            result = $bebd28704f2536ea$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bebd28704f2536ea$var$_possibleConstructorReturn(this, result);
    };
}
function $bebd28704f2536ea$var$_isNativeReflectConstruct$m() {
    if (typeof Reflect === "undefined" || !$bebd28704f2536ea$var$_Reflect$construct) return false;
    if ($bebd28704f2536ea$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($bebd28704f2536ea$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * A Database Node/Cluster shape.
 *
 * @augments NodeBase
 */ var $bebd28704f2536ea$var$Database = /*#__PURE__*/ function(_NodeBase) {
    $bebd28704f2536ea$var$_inherits(Database, _NodeBase);
    var _super = $bebd28704f2536ea$var$_createSuper$m(Database);
    /**
   * @param {object} options
   * @param {object} body
   * @param {Label} labelModule
   */ function Database(options, body, labelModule) {
        var _this;
        $bebd28704f2536ea$var$_classCallCheck(this, Database);
        _this = _super.call(this, options, body, labelModule);
        _this._setMargins(labelModule);
        return _this;
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {boolean} selected
   * @param {boolean} hover
   */ $bebd28704f2536ea$var$_createClass(Database, [
        {
            key: "resize",
            value: function resize(ctx, selected, hover) {
                if (this.needsRefresh(selected, hover)) {
                    var dimensions = this.getDimensionsFromLabel(ctx, selected, hover);
                    var size = dimensions.width + this.margin.right + this.margin.left;
                    this.width = size;
                    this.height = size;
                    this.radius = this.width / 2;
                }
            }
        },
        {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                this.resize(ctx, selected, hover);
                this.left = x - this.width / 2;
                this.top = y - this.height / 2;
                this.initContextForDraw(ctx, values);
                $bebd28704f2536ea$var$drawDatabase(ctx, x - this.width / 2, y - this.height / 2, this.width, this.height);
                this.performFill(ctx, values);
                this.updateBoundingBox(x, y, ctx, selected, hover);
                this.labelModule.draw(ctx, this.left + this.textSize.width / 2 + this.margin.left, this.top + this.textSize.height / 2 + this.margin.top, selected, hover);
            }
        },
        {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }
    ]);
    return Database;
}($bebd28704f2536ea$var$NodeBase);
function $bebd28704f2536ea$var$_createSuper$l(Derived) {
    var hasNativeReflectConstruct = $bebd28704f2536ea$var$_isNativeReflectConstruct$l();
    return function _createSuperInternal() {
        var Super = $bebd28704f2536ea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bebd28704f2536ea$var$_getPrototypeOf(this).constructor;
            result = $bebd28704f2536ea$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bebd28704f2536ea$var$_possibleConstructorReturn(this, result);
    };
}
function $bebd28704f2536ea$var$_isNativeReflectConstruct$l() {
    if (typeof Reflect === "undefined" || !$bebd28704f2536ea$var$_Reflect$construct) return false;
    if ($bebd28704f2536ea$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($bebd28704f2536ea$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * A Diamond Node/Cluster shape.
 *
 * @augments ShapeBase
 */ var $bebd28704f2536ea$var$Diamond$1 = /*#__PURE__*/ function(_ShapeBase) {
    $bebd28704f2536ea$var$_inherits(Diamond, _ShapeBase);
    var _super = $bebd28704f2536ea$var$_createSuper$l(Diamond);
    /**
   * @param {object} options
   * @param {object} body
   * @param {Label} labelModule
   */ function Diamond(options, body, labelModule) {
        $bebd28704f2536ea$var$_classCallCheck(this, Diamond);
        return _super.call(this, options, body, labelModule);
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} x width
   * @param {number} y height
   * @param {boolean} selected
   * @param {boolean} hover
   * @param {ArrowOptions} values
   * @returns {object} Callbacks to draw later on higher layers.
   */ $bebd28704f2536ea$var$_createClass(Diamond, [
        {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                return this._drawShape(ctx, "diamond", 4, x, y, selected, hover, values);
            }
        },
        {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }
    ]);
    return Diamond;
}($bebd28704f2536ea$var$ShapeBase);
function $bebd28704f2536ea$var$_createSuper$k(Derived) {
    var hasNativeReflectConstruct = $bebd28704f2536ea$var$_isNativeReflectConstruct$k();
    return function _createSuperInternal() {
        var Super = $bebd28704f2536ea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bebd28704f2536ea$var$_getPrototypeOf(this).constructor;
            result = $bebd28704f2536ea$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bebd28704f2536ea$var$_possibleConstructorReturn(this, result);
    };
}
function $bebd28704f2536ea$var$_isNativeReflectConstruct$k() {
    if (typeof Reflect === "undefined" || !$bebd28704f2536ea$var$_Reflect$construct) return false;
    if ($bebd28704f2536ea$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($bebd28704f2536ea$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * A Dot Node/Cluster shape.
 *
 * @augments ShapeBase
 */ var $bebd28704f2536ea$var$Dot = /*#__PURE__*/ function(_ShapeBase) {
    $bebd28704f2536ea$var$_inherits(Dot, _ShapeBase);
    var _super = $bebd28704f2536ea$var$_createSuper$k(Dot);
    /**
   * @param {object} options
   * @param {object} body
   * @param {Label} labelModule
   */ function Dot(options, body, labelModule) {
        $bebd28704f2536ea$var$_classCallCheck(this, Dot);
        return _super.call(this, options, body, labelModule);
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} x width
   * @param {number} y height
   * @param {boolean} selected
   * @param {boolean} hover
   * @param {ArrowOptions} values
   * @returns {object} Callbacks to draw later on higher layers.
   */ $bebd28704f2536ea$var$_createClass(Dot, [
        {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                return this._drawShape(ctx, "circle", 2, x, y, selected, hover, values);
            }
        },
        {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx) {
                if (ctx) this.resize(ctx);
                return this.options.size;
            }
        }
    ]);
    return Dot;
}($bebd28704f2536ea$var$ShapeBase);
function $bebd28704f2536ea$var$_createSuper$j(Derived) {
    var hasNativeReflectConstruct = $bebd28704f2536ea$var$_isNativeReflectConstruct$j();
    return function _createSuperInternal() {
        var Super = $bebd28704f2536ea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bebd28704f2536ea$var$_getPrototypeOf(this).constructor;
            result = $bebd28704f2536ea$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bebd28704f2536ea$var$_possibleConstructorReturn(this, result);
    };
}
function $bebd28704f2536ea$var$_isNativeReflectConstruct$j() {
    if (typeof Reflect === "undefined" || !$bebd28704f2536ea$var$_Reflect$construct) return false;
    if ($bebd28704f2536ea$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($bebd28704f2536ea$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Am Ellipse Node/Cluster shape.
 *
 * @augments NodeBase
 */ var $bebd28704f2536ea$var$Ellipse = /*#__PURE__*/ function(_NodeBase) {
    $bebd28704f2536ea$var$_inherits(Ellipse, _NodeBase);
    var _super = $bebd28704f2536ea$var$_createSuper$j(Ellipse);
    /**
   * @param {object} options
   * @param {object} body
   * @param {Label} labelModule
   */ function Ellipse(options, body, labelModule) {
        $bebd28704f2536ea$var$_classCallCheck(this, Ellipse);
        return _super.call(this, options, body, labelModule);
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {boolean} [selected]
   * @param {boolean} [hover]
   */ $bebd28704f2536ea$var$_createClass(Ellipse, [
        {
            key: "resize",
            value: function resize(ctx) {
                var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selected;
                var hover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.hover;
                if (this.needsRefresh(selected, hover)) {
                    var dimensions = this.getDimensionsFromLabel(ctx, selected, hover);
                    this.height = dimensions.height * 2;
                    this.width = dimensions.width + dimensions.height;
                    this.radius = 0.5 * this.width;
                }
            }
        },
        {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                this.resize(ctx, selected, hover);
                this.left = x - this.width * 0.5;
                this.top = y - this.height * 0.5;
                this.initContextForDraw(ctx, values);
                $bebd28704f2536ea$var$drawEllipse(ctx, this.left, this.top, this.width, this.height);
                this.performFill(ctx, values);
                this.updateBoundingBox(x, y, ctx, selected, hover);
                this.labelModule.draw(ctx, x, y, selected, hover);
            }
        },
        {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                if (ctx) this.resize(ctx);
                var a = this.width * 0.5;
                var b = this.height * 0.5;
                var w = Math.sin(angle) * a;
                var h = Math.cos(angle) * b;
                return a * b / Math.sqrt(w * w + h * h);
            }
        }
    ]);
    return Ellipse;
}($bebd28704f2536ea$var$NodeBase);
function $bebd28704f2536ea$var$_createSuper$i(Derived) {
    var hasNativeReflectConstruct = $bebd28704f2536ea$var$_isNativeReflectConstruct$i();
    return function _createSuperInternal() {
        var Super = $bebd28704f2536ea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bebd28704f2536ea$var$_getPrototypeOf(this).constructor;
            result = $bebd28704f2536ea$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bebd28704f2536ea$var$_possibleConstructorReturn(this, result);
    };
}
function $bebd28704f2536ea$var$_isNativeReflectConstruct$i() {
    if (typeof Reflect === "undefined" || !$bebd28704f2536ea$var$_Reflect$construct) return false;
    if ($bebd28704f2536ea$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($bebd28704f2536ea$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * An icon replacement for the default Node shape.
 *
 * @augments NodeBase
 */ var $bebd28704f2536ea$var$Icon = /*#__PURE__*/ function(_NodeBase) {
    $bebd28704f2536ea$var$_inherits(Icon, _NodeBase);
    var _super = $bebd28704f2536ea$var$_createSuper$i(Icon);
    /**
   * @param {object} options
   * @param {object} body
   * @param {Label} labelModule
   */ function Icon(options, body, labelModule) {
        var _this;
        $bebd28704f2536ea$var$_classCallCheck(this, Icon);
        _this = _super.call(this, options, body, labelModule);
        _this._setMargins(labelModule);
        return _this;
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx - Unused.
   * @param {boolean} [selected]
   * @param {boolean} [hover]
   */ $bebd28704f2536ea$var$_createClass(Icon, [
        {
            key: "resize",
            value: function resize(ctx, selected, hover) {
                if (this.needsRefresh(selected, hover)) {
                    this.iconSize = {
                        width: Number(this.options.icon.size),
                        height: Number(this.options.icon.size)
                    };
                    this.width = this.iconSize.width + this.margin.right + this.margin.left;
                    this.height = this.iconSize.height + this.margin.top + this.margin.bottom;
                    this.radius = 0.5 * this.width;
                }
            }
        },
        {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                var _this2 = this;
                this.resize(ctx, selected, hover);
                this.options.icon.size = this.options.icon.size || 50;
                this.left = x - this.width / 2;
                this.top = y - this.height / 2;
                this._icon(ctx, x, y, selected, hover, values);
                return {
                    drawExternalLabel: function drawExternalLabel() {
                        if (_this2.options.label !== undefined) {
                            var iconTextSpacing = 5;
                            _this2.labelModule.draw(ctx, _this2.left + _this2.iconSize.width / 2 + _this2.margin.left, y + _this2.height / 2 + iconTextSpacing, selected);
                        }
                        _this2.updateBoundingBox(x, y);
                    }
                };
            }
        },
        {
            key: "updateBoundingBox",
            value: function updateBoundingBox(x, y) {
                this.boundingBox.top = y - this.options.icon.size * 0.5;
                this.boundingBox.left = x - this.options.icon.size * 0.5;
                this.boundingBox.right = x + this.options.icon.size * 0.5;
                this.boundingBox.bottom = y + this.options.icon.size * 0.5;
                if (this.options.label !== undefined && this.labelModule.size.width > 0) {
                    var iconTextSpacing = 5;
                    this.boundingBox.left = Math.min(this.boundingBox.left, this.labelModule.size.left);
                    this.boundingBox.right = Math.max(this.boundingBox.right, this.labelModule.size.left + this.labelModule.size.width);
                    this.boundingBox.bottom = Math.max(this.boundingBox.bottom, this.boundingBox.bottom + this.labelModule.size.height + iconTextSpacing);
                }
            }
        },
        {
            key: "_icon",
            value: function _icon(ctx, x, y, selected, hover, values) {
                var iconSize = Number(this.options.icon.size);
                if (this.options.icon.code !== undefined) {
                    ctx.font = [
                        this.options.icon.weight != null ? this.options.icon.weight : selected ? "bold" : "",
                        // If the weight is forced (for example to make Font Awesome 5 work
                        // properly) substitute slightly bigger size for bold font face.
                        (this.options.icon.weight != null && selected ? 5 : 0) + iconSize + "px",
                        this.options.icon.face
                    ].join(" ");
                    // draw icon
                    ctx.fillStyle = this.options.icon.color || "black";
                    ctx.textAlign = "center";
                    ctx.textBaseline = "middle";
                    // draw shadow if enabled
                    this.enableShadow(ctx, values);
                    ctx.fillText(this.options.icon.code, x, y);
                    // disable shadows for other elements.
                    this.disableShadow(ctx, values);
                } else console.error("When using the icon shape, you need to define the code in the icon options object. This can be done per node or globally.");
            }
        },
        {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }
    ]);
    return Icon;
}($bebd28704f2536ea$var$NodeBase);
function $bebd28704f2536ea$var$_createSuper$h(Derived) {
    var hasNativeReflectConstruct = $bebd28704f2536ea$var$_isNativeReflectConstruct$h();
    return function _createSuperInternal() {
        var Super = $bebd28704f2536ea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bebd28704f2536ea$var$_getPrototypeOf(this).constructor;
            result = $bebd28704f2536ea$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bebd28704f2536ea$var$_possibleConstructorReturn(this, result);
    };
}
function $bebd28704f2536ea$var$_isNativeReflectConstruct$h() {
    if (typeof Reflect === "undefined" || !$bebd28704f2536ea$var$_Reflect$construct) return false;
    if ($bebd28704f2536ea$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($bebd28704f2536ea$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * An image-based replacement for the default Node shape.
 *
 * @augments CircleImageBase
 */ var $bebd28704f2536ea$var$Image$2 = /*#__PURE__*/ function(_CircleImageBase) {
    $bebd28704f2536ea$var$_inherits(Image1, _CircleImageBase);
    var _super = $bebd28704f2536ea$var$_createSuper$h(Image1);
    /**
   * @param {object} options
   * @param {object} body
   * @param {Label} labelModule
   * @param {Image} imageObj
   * @param {Image} imageObjAlt
   */ function Image1(options, body, labelModule, imageObj, imageObjAlt) {
        var _this;
        $bebd28704f2536ea$var$_classCallCheck(this, Image1);
        _this = _super.call(this, options, body, labelModule);
        _this.setImages(imageObj, imageObjAlt);
        return _this;
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx - Unused.
   * @param {boolean} [selected]
   * @param {boolean} [hover]
   */ $bebd28704f2536ea$var$_createClass(Image1, [
        {
            key: "resize",
            value: function resize(ctx) {
                var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selected;
                var hover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.hover;
                var imageAbsent = this.imageObj.src === undefined || this.imageObj.width === undefined || this.imageObj.height === undefined;
                if (imageAbsent) {
                    var side = this.options.size * 2;
                    this.width = side;
                    this.height = side;
                    return;
                }
                if (this.needsRefresh(selected, hover)) this._resizeImage();
            }
        },
        {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                ctx.save();
                this.switchImages(selected);
                this.resize();
                var labelX = x, labelY = y;
                if (this.options.shapeProperties.coordinateOrigin === "top-left") {
                    this.left = x;
                    this.top = y;
                    labelX += this.width / 2;
                    labelY += this.height / 2;
                } else {
                    this.left = x - this.width / 2;
                    this.top = y - this.height / 2;
                }
                if (this.options.shapeProperties.useBorderWithImage === true) {
                    var neutralborderWidth = this.options.borderWidth;
                    var selectionLineWidth = this.options.borderWidthSelected || 2 * this.options.borderWidth;
                    var borderWidth = (selected ? selectionLineWidth : neutralborderWidth) / this.body.view.scale;
                    ctx.lineWidth = Math.min(this.width, borderWidth);
                    ctx.beginPath();
                    var strokeStyle = selected ? this.options.color.highlight.border : hover ? this.options.color.hover.border : this.options.color.border;
                    var fillStyle = selected ? this.options.color.highlight.background : hover ? this.options.color.hover.background : this.options.color.background;
                    if (values.opacity !== undefined) {
                        strokeStyle = $bebd28704f2536ea$var$overrideOpacity(strokeStyle, values.opacity);
                        fillStyle = $bebd28704f2536ea$var$overrideOpacity(fillStyle, values.opacity);
                    }
                    // setup the line properties.
                    ctx.strokeStyle = strokeStyle;
                    // set a fillstyle
                    ctx.fillStyle = fillStyle;
                    // draw a rectangle to form the border around. This rectangle is filled so the opacity of a picture (in future vis releases?) can be used to tint the image
                    ctx.rect(this.left - 0.5 * ctx.lineWidth, this.top - 0.5 * ctx.lineWidth, this.width + ctx.lineWidth, this.height + ctx.lineWidth);
                    $bebd28704f2536ea$var$_fillInstanceProperty(ctx).call(ctx);
                    this.performStroke(ctx, values);
                    ctx.closePath();
                }
                this._drawImageAtPosition(ctx, values);
                this._drawImageLabel(ctx, labelX, labelY, selected, hover);
                this.updateBoundingBox(x, y);
                ctx.restore();
            }
        },
        {
            key: "updateBoundingBox",
            value: function updateBoundingBox(x, y) {
                this.resize();
                if (this.options.shapeProperties.coordinateOrigin === "top-left") {
                    this.left = x;
                    this.top = y;
                } else {
                    this.left = x - this.width / 2;
                    this.top = y - this.height / 2;
                }
                this.boundingBox.left = this.left;
                this.boundingBox.top = this.top;
                this.boundingBox.bottom = this.top + this.height;
                this.boundingBox.right = this.left + this.width;
                if (this.options.label !== undefined && this.labelModule.size.width > 0) {
                    this.boundingBox.left = Math.min(this.boundingBox.left, this.labelModule.size.left);
                    this.boundingBox.right = Math.max(this.boundingBox.right, this.labelModule.size.left + this.labelModule.size.width);
                    this.boundingBox.bottom = Math.max(this.boundingBox.bottom, this.boundingBox.bottom + this.labelOffset);
                }
            }
        },
        {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }
    ]);
    return Image1;
}($bebd28704f2536ea$var$CircleImageBase);
function $bebd28704f2536ea$var$_createSuper$g(Derived) {
    var hasNativeReflectConstruct = $bebd28704f2536ea$var$_isNativeReflectConstruct$g();
    return function _createSuperInternal() {
        var Super = $bebd28704f2536ea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bebd28704f2536ea$var$_getPrototypeOf(this).constructor;
            result = $bebd28704f2536ea$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bebd28704f2536ea$var$_possibleConstructorReturn(this, result);
    };
}
function $bebd28704f2536ea$var$_isNativeReflectConstruct$g() {
    if (typeof Reflect === "undefined" || !$bebd28704f2536ea$var$_Reflect$construct) return false;
    if ($bebd28704f2536ea$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($bebd28704f2536ea$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * A Square Node/Cluster shape.
 *
 * @augments ShapeBase
 */ var $bebd28704f2536ea$var$Square = /*#__PURE__*/ function(_ShapeBase) {
    $bebd28704f2536ea$var$_inherits(Square, _ShapeBase);
    var _super = $bebd28704f2536ea$var$_createSuper$g(Square);
    /**
   * @param {object} options
   * @param {object} body
   * @param {Label} labelModule
   */ function Square(options, body, labelModule) {
        $bebd28704f2536ea$var$_classCallCheck(this, Square);
        return _super.call(this, options, body, labelModule);
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} x width
   * @param {number} y height
   * @param {boolean} selected
   * @param {boolean} hover
   * @param {ArrowOptions} values
   * @returns {object} Callbacks to draw later on higher layers.
   */ $bebd28704f2536ea$var$_createClass(Square, [
        {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                return this._drawShape(ctx, "square", 2, x, y, selected, hover, values);
            }
        },
        {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }
    ]);
    return Square;
}($bebd28704f2536ea$var$ShapeBase);
function $bebd28704f2536ea$var$_createSuper$f(Derived) {
    var hasNativeReflectConstruct = $bebd28704f2536ea$var$_isNativeReflectConstruct$f();
    return function _createSuperInternal() {
        var Super = $bebd28704f2536ea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bebd28704f2536ea$var$_getPrototypeOf(this).constructor;
            result = $bebd28704f2536ea$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bebd28704f2536ea$var$_possibleConstructorReturn(this, result);
    };
}
function $bebd28704f2536ea$var$_isNativeReflectConstruct$f() {
    if (typeof Reflect === "undefined" || !$bebd28704f2536ea$var$_Reflect$construct) return false;
    if ($bebd28704f2536ea$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($bebd28704f2536ea$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * A Hexagon Node/Cluster shape.
 *
 * @augments ShapeBase
 */ var $bebd28704f2536ea$var$Hexagon = /*#__PURE__*/ function(_ShapeBase) {
    $bebd28704f2536ea$var$_inherits(Hexagon, _ShapeBase);
    var _super = $bebd28704f2536ea$var$_createSuper$f(Hexagon);
    /**
   * @param {object} options
   * @param {object} body
   * @param {Label} labelModule
   */ function Hexagon(options, body, labelModule) {
        $bebd28704f2536ea$var$_classCallCheck(this, Hexagon);
        return _super.call(this, options, body, labelModule);
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} x width
   * @param {number} y height
   * @param {boolean} selected
   * @param {boolean} hover
   * @param {ArrowOptions} values
   * @returns {object} Callbacks to draw later on higher layers.
   */ $bebd28704f2536ea$var$_createClass(Hexagon, [
        {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                return this._drawShape(ctx, "hexagon", 4, x, y, selected, hover, values);
            }
        },
        {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }
    ]);
    return Hexagon;
}($bebd28704f2536ea$var$ShapeBase);
function $bebd28704f2536ea$var$_createSuper$e(Derived) {
    var hasNativeReflectConstruct = $bebd28704f2536ea$var$_isNativeReflectConstruct$e();
    return function _createSuperInternal() {
        var Super = $bebd28704f2536ea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bebd28704f2536ea$var$_getPrototypeOf(this).constructor;
            result = $bebd28704f2536ea$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bebd28704f2536ea$var$_possibleConstructorReturn(this, result);
    };
}
function $bebd28704f2536ea$var$_isNativeReflectConstruct$e() {
    if (typeof Reflect === "undefined" || !$bebd28704f2536ea$var$_Reflect$construct) return false;
    if ($bebd28704f2536ea$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($bebd28704f2536ea$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * A Star Node/Cluster shape.
 *
 * @augments ShapeBase
 */ var $bebd28704f2536ea$var$Star = /*#__PURE__*/ function(_ShapeBase) {
    $bebd28704f2536ea$var$_inherits(Star, _ShapeBase);
    var _super = $bebd28704f2536ea$var$_createSuper$e(Star);
    /**
   * @param {object} options
   * @param {object} body
   * @param {Label} labelModule
   */ function Star(options, body, labelModule) {
        $bebd28704f2536ea$var$_classCallCheck(this, Star);
        return _super.call(this, options, body, labelModule);
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} x width
   * @param {number} y height
   * @param {boolean} selected
   * @param {boolean} hover
   * @param {ArrowOptions} values
   * @returns {object} Callbacks to draw later on higher layers.
   */ $bebd28704f2536ea$var$_createClass(Star, [
        {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                return this._drawShape(ctx, "star", 4, x, y, selected, hover, values);
            }
        },
        {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }
    ]);
    return Star;
}($bebd28704f2536ea$var$ShapeBase);
function $bebd28704f2536ea$var$_createSuper$d(Derived) {
    var hasNativeReflectConstruct = $bebd28704f2536ea$var$_isNativeReflectConstruct$d();
    return function _createSuperInternal() {
        var Super = $bebd28704f2536ea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bebd28704f2536ea$var$_getPrototypeOf(this).constructor;
            result = $bebd28704f2536ea$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bebd28704f2536ea$var$_possibleConstructorReturn(this, result);
    };
}
function $bebd28704f2536ea$var$_isNativeReflectConstruct$d() {
    if (typeof Reflect === "undefined" || !$bebd28704f2536ea$var$_Reflect$construct) return false;
    if ($bebd28704f2536ea$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($bebd28704f2536ea$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * A text-based replacement for the default Node shape.
 *
 * @augments NodeBase
 */ var $bebd28704f2536ea$var$Text = /*#__PURE__*/ function(_NodeBase) {
    $bebd28704f2536ea$var$_inherits(Text, _NodeBase);
    var _super = $bebd28704f2536ea$var$_createSuper$d(Text);
    /**
   * @param {object} options
   * @param {object} body
   * @param {Label} labelModule
   */ function Text(options, body, labelModule) {
        var _this;
        $bebd28704f2536ea$var$_classCallCheck(this, Text);
        _this = _super.call(this, options, body, labelModule);
        _this._setMargins(labelModule);
        return _this;
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {boolean} selected
   * @param {boolean} hover
   */ $bebd28704f2536ea$var$_createClass(Text, [
        {
            key: "resize",
            value: function resize(ctx, selected, hover) {
                if (this.needsRefresh(selected, hover)) {
                    this.textSize = this.labelModule.getTextSize(ctx, selected, hover);
                    this.width = this.textSize.width + this.margin.right + this.margin.left;
                    this.height = this.textSize.height + this.margin.top + this.margin.bottom;
                    this.radius = 0.5 * this.width;
                }
            }
        },
        {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                this.resize(ctx, selected, hover);
                this.left = x - this.width / 2;
                this.top = y - this.height / 2;
                // draw shadow if enabled
                this.enableShadow(ctx, values);
                this.labelModule.draw(ctx, this.left + this.textSize.width / 2 + this.margin.left, this.top + this.textSize.height / 2 + this.margin.top, selected, hover);
                // disable shadows for other elements.
                this.disableShadow(ctx, values);
                this.updateBoundingBox(x, y, ctx, selected, hover);
            }
        },
        {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }
    ]);
    return Text;
}($bebd28704f2536ea$var$NodeBase);
function $bebd28704f2536ea$var$_createSuper$c(Derived) {
    var hasNativeReflectConstruct = $bebd28704f2536ea$var$_isNativeReflectConstruct$c();
    return function _createSuperInternal() {
        var Super = $bebd28704f2536ea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bebd28704f2536ea$var$_getPrototypeOf(this).constructor;
            result = $bebd28704f2536ea$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bebd28704f2536ea$var$_possibleConstructorReturn(this, result);
    };
}
function $bebd28704f2536ea$var$_isNativeReflectConstruct$c() {
    if (typeof Reflect === "undefined" || !$bebd28704f2536ea$var$_Reflect$construct) return false;
    if ($bebd28704f2536ea$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($bebd28704f2536ea$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * A Triangle Node/Cluster shape.
 *
 * @augments ShapeBase
 */ var $bebd28704f2536ea$var$Triangle$1 = /*#__PURE__*/ function(_ShapeBase) {
    $bebd28704f2536ea$var$_inherits(Triangle, _ShapeBase);
    var _super = $bebd28704f2536ea$var$_createSuper$c(Triangle);
    /**
   * @param {object} options
   * @param {object} body
   * @param {Label} labelModule
   */ function Triangle(options, body, labelModule) {
        $bebd28704f2536ea$var$_classCallCheck(this, Triangle);
        return _super.call(this, options, body, labelModule);
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} x
   * @param {number} y
   * @param {boolean} selected
   * @param {boolean} hover
   * @param {ArrowOptions} values
   * @returns {object} Callbacks to draw later on higher layers.
   */ $bebd28704f2536ea$var$_createClass(Triangle, [
        {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                return this._drawShape(ctx, "triangle", 3, x, y, selected, hover, values);
            }
        },
        {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }
    ]);
    return Triangle;
}($bebd28704f2536ea$var$ShapeBase);
function $bebd28704f2536ea$var$_createSuper$b(Derived) {
    var hasNativeReflectConstruct = $bebd28704f2536ea$var$_isNativeReflectConstruct$b();
    return function _createSuperInternal() {
        var Super = $bebd28704f2536ea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bebd28704f2536ea$var$_getPrototypeOf(this).constructor;
            result = $bebd28704f2536ea$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bebd28704f2536ea$var$_possibleConstructorReturn(this, result);
    };
}
function $bebd28704f2536ea$var$_isNativeReflectConstruct$b() {
    if (typeof Reflect === "undefined" || !$bebd28704f2536ea$var$_Reflect$construct) return false;
    if ($bebd28704f2536ea$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($bebd28704f2536ea$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * A downward facing Triangle Node/Cluster shape.
 *
 * @augments ShapeBase
 */ var $bebd28704f2536ea$var$TriangleDown = /*#__PURE__*/ function(_ShapeBase) {
    $bebd28704f2536ea$var$_inherits(TriangleDown, _ShapeBase);
    var _super = $bebd28704f2536ea$var$_createSuper$b(TriangleDown);
    /**
   * @param {object} options
   * @param {object} body
   * @param {Label} labelModule
   */ function TriangleDown(options, body, labelModule) {
        $bebd28704f2536ea$var$_classCallCheck(this, TriangleDown);
        return _super.call(this, options, body, labelModule);
    }
    /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} x
   * @param {number} y
   * @param {boolean} selected
   * @param {boolean} hover
   * @param {ArrowOptions} values
   * @returns {object} Callbacks to draw later on higher layers.
   */ $bebd28704f2536ea$var$_createClass(TriangleDown, [
        {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                return this._drawShape(ctx, "triangleDown", 3, x, y, selected, hover, values);
            }
        },
        {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }
    ]);
    return TriangleDown;
}($bebd28704f2536ea$var$ShapeBase);
function $bebd28704f2536ea$var$ownKeys$2(e, r) {
    var t = $bebd28704f2536ea$var$_Object$keys(e);
    if ($bebd28704f2536ea$var$_Object$getOwnPropertySymbols) {
        var o = $bebd28704f2536ea$var$_Object$getOwnPropertySymbols(e);
        r && (o = $bebd28704f2536ea$var$_filterInstanceProperty(o).call(o, function(r) {
            return $bebd28704f2536ea$var$_Object$getOwnPropertyDescriptor$1(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bebd28704f2536ea$var$_objectSpread$2(e) {
    for(var r = 1; r < arguments.length; r++){
        var _context5, _context6;
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bebd28704f2536ea$var$_forEachInstanceProperty(_context5 = $bebd28704f2536ea$var$ownKeys$2(Object(t), !0)).call(_context5, function(r) {
            $bebd28704f2536ea$var$_defineProperty(e, r, t[r]);
        }) : $bebd28704f2536ea$var$_Object$getOwnPropertyDescriptors ? $bebd28704f2536ea$var$_Object$defineProperties(e, $bebd28704f2536ea$var$_Object$getOwnPropertyDescriptors(t)) : $bebd28704f2536ea$var$_forEachInstanceProperty(_context6 = $bebd28704f2536ea$var$ownKeys$2(Object(t))).call(_context6, function(r) {
            $bebd28704f2536ea$var$_Object$defineProperty(e, r, $bebd28704f2536ea$var$_Object$getOwnPropertyDescriptor$1(t, r));
        });
    }
    return e;
}
/**
 * A node. A node can be connected to other nodes via one or multiple edges.
 */ var $bebd28704f2536ea$var$Node = /*#__PURE__*/ function() {
    /**
   *
   * @param {object} options An object containing options for the node. All
   *                            options are optional, except for the id.
   *                              {number} id     Id of the node. Required
   *                              {string} label  Text label for the node
   *                              {number} x      Horizontal position of the node
   *                              {number} y      Vertical position of the node
   *                              {string} shape  Node shape
   *                              {string} image  An image url
   *                              {string} title  A title text, can be HTML
   *                              {anytype} group A group name or number
   * @param {object} body               Shared state of current network instance
   * @param {Network.Images} imagelist  A list with images. Only needed when the node has an image
   * @param {Groups} grouplist          A list with groups. Needed for retrieving group options
   * @param {object} globalOptions      Current global node options; these serve as defaults for the node instance
   * @param {object} defaultOptions     Global default options for nodes; note that this is also the prototype
   *                                    for parameter `globalOptions`.
   */ function Node(options, body, imagelist, grouplist, globalOptions, defaultOptions) {
        $bebd28704f2536ea$var$_classCallCheck(this, Node);
        this.options = $bebd28704f2536ea$var$bridgeObject(globalOptions);
        this.globalOptions = globalOptions;
        this.defaultOptions = defaultOptions;
        this.body = body;
        this.edges = []; // all edges connected to this node
        // set defaults for the options
        this.id = undefined;
        this.imagelist = imagelist;
        this.grouplist = grouplist;
        // state options
        this.x = undefined;
        this.y = undefined;
        this.baseSize = this.options.size;
        this.baseFontSize = this.options.font.size;
        this.predefinedPosition = false; // used to check if initial fit should just take the range or approximate
        this.selected = false;
        this.hover = false;
        this.labelModule = new $bebd28704f2536ea$var$Label(this.body, this.options, false);
        this.setOptions(options);
    }
    /**
   * Attach a edge to the node
   *
   * @param {Edge} edge
   */ $bebd28704f2536ea$var$_createClass(Node, [
        {
            key: "attachEdge",
            value: function attachEdge(edge) {
                var _context;
                if ($bebd28704f2536ea$var$_indexOfInstanceProperty(_context = this.edges).call(_context, edge) === -1) this.edges.push(edge);
            }
        },
        {
            key: "detachEdge",
            value: function detachEdge(edge) {
                var _context2;
                var index = $bebd28704f2536ea$var$_indexOfInstanceProperty(_context2 = this.edges).call(_context2, edge);
                if (index != -1) {
                    var _context3;
                    $bebd28704f2536ea$var$_spliceInstanceProperty(_context3 = this.edges).call(_context3, index, 1);
                }
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                var currentShape = this.options.shape;
                if (!options) return; // Note that the return value will be 'undefined'! This is OK.
                // Save the color for later.
                // This is necessary in order to prevent local color from being overwritten by group color.
                // TODO: To prevent such workarounds the way options are handled should be rewritten from scratch.
                // This is not the only problem with current options handling.
                if (typeof options.color !== "undefined") this._localColor = options.color;
                // basic options
                if (options.id !== undefined) this.id = options.id;
                if (this.id === undefined) throw new Error("Node must have an id");
                Node.checkMass(options, this.id);
                // set these options locally
                // clear x and y positions
                if (options.x !== undefined) {
                    if (options.x === null) {
                        this.x = undefined;
                        this.predefinedPosition = false;
                    } else {
                        this.x = $bebd28704f2536ea$var$_parseInt$1(options.x);
                        this.predefinedPosition = true;
                    }
                }
                if (options.y !== undefined) {
                    if (options.y === null) {
                        this.y = undefined;
                        this.predefinedPosition = false;
                    } else {
                        this.y = $bebd28704f2536ea$var$_parseInt$1(options.y);
                        this.predefinedPosition = true;
                    }
                }
                if (options.size !== undefined) this.baseSize = options.size;
                if (options.value !== undefined) options.value = $bebd28704f2536ea$var$_parseFloat$1(options.value);
                // this transforms all shorthands into fully defined options
                Node.parseOptions(this.options, options, true, this.globalOptions, this.grouplist);
                var pile = [
                    options,
                    this.options,
                    this.defaultOptions
                ];
                this.chooser = $bebd28704f2536ea$var$choosify("node", pile);
                this._load_images();
                this.updateLabelModule(options);
                // Need to set local opacity after `this.updateLabelModule(options);` because `this.updateLabelModule(options);` overrites local opacity with group opacity
                if (options.opacity !== undefined && Node.checkOpacity(options.opacity)) this.options.opacity = options.opacity;
                this.updateShape(currentShape);
                return options.hidden !== undefined || options.physics !== undefined;
            }
        },
        {
            key: "_load_images",
            value: function _load_images() {
                if (this.options.shape === "circularImage" || this.options.shape === "image") {
                    if (this.options.image === undefined) throw new Error("Option image must be defined for node type '" + this.options.shape + "'");
                }
                if (this.options.image === undefined) return;
                if (this.imagelist === undefined) throw new Error("Internal Error: No images provided");
                if (typeof this.options.image === "string") this.imageObj = this.imagelist.load(this.options.image, this.options.brokenImage, this.id);
                else {
                    if (this.options.image.unselected === undefined) throw new Error("No unselected image provided");
                    this.imageObj = this.imagelist.load(this.options.image.unselected, this.options.brokenImage, this.id);
                    if (this.options.image.selected !== undefined) this.imageObjAlt = this.imagelist.load(this.options.image.selected, this.options.brokenImage, this.id);
                    else this.imageObjAlt = undefined;
                }
            }
        },
        {
            key: "getFormattingValues",
            value: /**
     *
     * @returns {{color: *, borderWidth: *, borderColor: *, size: *, borderDashes: (boolean|Array|allOptions.nodes.shapeProperties.borderDashes|{boolean, array}), borderRadius: (number|allOptions.nodes.shapeProperties.borderRadius|{number}|Array), shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *}}
     */ function getFormattingValues() {
                var values = {
                    color: this.options.color.background,
                    opacity: this.options.opacity,
                    borderWidth: this.options.borderWidth,
                    borderColor: this.options.color.border,
                    size: this.options.size,
                    borderDashes: this.options.shapeProperties.borderDashes,
                    borderRadius: this.options.shapeProperties.borderRadius,
                    shadow: this.options.shadow.enabled,
                    shadowColor: this.options.shadow.color,
                    shadowSize: this.options.shadow.size,
                    shadowX: this.options.shadow.x,
                    shadowY: this.options.shadow.y
                };
                if (this.selected || this.hover) {
                    if (this.chooser === true) {
                        if (this.selected) {
                            if (this.options.borderWidthSelected != null) values.borderWidth = this.options.borderWidthSelected;
                            else values.borderWidth *= 2;
                            values.color = this.options.color.highlight.background;
                            values.borderColor = this.options.color.highlight.border;
                            values.shadow = this.options.shadow.enabled;
                        } else if (this.hover) {
                            values.color = this.options.color.hover.background;
                            values.borderColor = this.options.color.hover.border;
                            values.shadow = this.options.shadow.enabled;
                        }
                    } else if (typeof this.chooser === "function") {
                        this.chooser(values, this.options.id, this.selected, this.hover);
                        if (values.shadow === false) {
                            if (values.shadowColor !== this.options.shadow.color || values.shadowSize !== this.options.shadow.size || values.shadowX !== this.options.shadow.x || values.shadowY !== this.options.shadow.y) values.shadow = true;
                        }
                    }
                } else values.shadow = this.options.shadow.enabled;
                if (this.options.opacity !== undefined) {
                    var opacity = this.options.opacity;
                    values.borderColor = $bebd28704f2536ea$var$overrideOpacity(values.borderColor, opacity);
                    values.color = $bebd28704f2536ea$var$overrideOpacity(values.color, opacity);
                    values.shadowColor = $bebd28704f2536ea$var$overrideOpacity(values.shadowColor, opacity);
                }
                return values;
            }
        },
        {
            key: "updateLabelModule",
            value: function updateLabelModule(options) {
                if (this.options.label === undefined || this.options.label === null) this.options.label = "";
                Node.updateGroupOptions(this.options, $bebd28704f2536ea$var$_objectSpread$2($bebd28704f2536ea$var$_objectSpread$2({}, options), {}, {
                    color: options && options.color || this._localColor || undefined
                }), this.grouplist);
                //
                // Note:The prototype chain for this.options is:
                //
                // this.options ->    NodesHandler.options    -> NodesHandler.defaultOptions
                //                 (also: this.globalOptions)
                //
                // Note that the prototypes are mentioned explicitly in the pile list below;
                // WE DON'T WANT THE ORDER OF THE PROTOTYPES!!!! At least, not for font handling of labels.
                // This is a good indication that the prototype usage of options is deficient.
                //
                var currentGroup = this.grouplist.get(this.options.group, false);
                var pile = [
                    options,
                    // new options
                    this.options,
                    // current node options, see comment above for prototype
                    currentGroup,
                    // group options, if any
                    this.globalOptions,
                    // Currently set global node options
                    this.defaultOptions // Default global node options
                ];
                this.labelModule.update(this.options, pile);
                if (this.labelModule.baseSize !== undefined) this.baseFontSize = this.labelModule.baseSize;
            }
        },
        {
            key: "updateShape",
            value: function updateShape(currentShape) {
                if (currentShape === this.options.shape && this.shape) this.shape.setOptions(this.options, this.imageObj, this.imageObjAlt);
                else // choose draw method depending on the shape
                switch(this.options.shape){
                    case "box":
                        this.shape = new $bebd28704f2536ea$var$Box$1(this.options, this.body, this.labelModule);
                        break;
                    case "circle":
                        this.shape = new $bebd28704f2536ea$var$Circle$1(this.options, this.body, this.labelModule);
                        break;
                    case "circularImage":
                        this.shape = new $bebd28704f2536ea$var$CircularImage(this.options, this.body, this.labelModule, this.imageObj, this.imageObjAlt);
                        break;
                    case "custom":
                        this.shape = new $bebd28704f2536ea$var$CustomShape(this.options, this.body, this.labelModule, this.options.ctxRenderer);
                        break;
                    case "database":
                        this.shape = new $bebd28704f2536ea$var$Database(this.options, this.body, this.labelModule);
                        break;
                    case "diamond":
                        this.shape = new $bebd28704f2536ea$var$Diamond$1(this.options, this.body, this.labelModule);
                        break;
                    case "dot":
                        this.shape = new $bebd28704f2536ea$var$Dot(this.options, this.body, this.labelModule);
                        break;
                    case "ellipse":
                        this.shape = new $bebd28704f2536ea$var$Ellipse(this.options, this.body, this.labelModule);
                        break;
                    case "icon":
                        this.shape = new $bebd28704f2536ea$var$Icon(this.options, this.body, this.labelModule);
                        break;
                    case "image":
                        this.shape = new $bebd28704f2536ea$var$Image$2(this.options, this.body, this.labelModule, this.imageObj, this.imageObjAlt);
                        break;
                    case "square":
                        this.shape = new $bebd28704f2536ea$var$Square(this.options, this.body, this.labelModule);
                        break;
                    case "hexagon":
                        this.shape = new $bebd28704f2536ea$var$Hexagon(this.options, this.body, this.labelModule);
                        break;
                    case "star":
                        this.shape = new $bebd28704f2536ea$var$Star(this.options, this.body, this.labelModule);
                        break;
                    case "text":
                        this.shape = new $bebd28704f2536ea$var$Text(this.options, this.body, this.labelModule);
                        break;
                    case "triangle":
                        this.shape = new $bebd28704f2536ea$var$Triangle$1(this.options, this.body, this.labelModule);
                        break;
                    case "triangleDown":
                        this.shape = new $bebd28704f2536ea$var$TriangleDown(this.options, this.body, this.labelModule);
                        break;
                    default:
                        this.shape = new $bebd28704f2536ea$var$Ellipse(this.options, this.body, this.labelModule);
                        break;
                }
                this.needsRefresh();
            }
        },
        {
            key: "select",
            value: function select() {
                this.selected = true;
                this.needsRefresh();
            }
        },
        {
            key: "unselect",
            value: function unselect() {
                this.selected = false;
                this.needsRefresh();
            }
        },
        {
            key: "needsRefresh",
            value: function needsRefresh() {
                this.shape.refreshNeeded = true;
            }
        },
        {
            key: "getTitle",
            value: function getTitle() {
                return this.options.title;
            }
        },
        {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this.shape.distanceToBorder(ctx, angle);
            }
        },
        {
            key: "isFixed",
            value: function isFixed() {
                return this.options.fixed.x && this.options.fixed.y;
            }
        },
        {
            key: "isSelected",
            value: function isSelected() {
                return this.selected;
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this.options.value;
            }
        },
        {
            key: "getLabelSize",
            value: function getLabelSize() {
                return this.labelModule.size();
            }
        },
        {
            key: "setValueRange",
            value: function setValueRange(min, max, total) {
                if (this.options.value !== undefined) {
                    var scale = this.options.scaling.customScalingFunction(min, max, total, this.options.value);
                    var sizeDiff = this.options.scaling.max - this.options.scaling.min;
                    if (this.options.scaling.label.enabled === true) {
                        var fontDiff = this.options.scaling.label.max - this.options.scaling.label.min;
                        this.options.font.size = this.options.scaling.label.min + scale * fontDiff;
                    }
                    this.options.size = this.options.scaling.min + scale * sizeDiff;
                } else {
                    this.options.size = this.baseSize;
                    this.options.font.size = this.baseFontSize;
                }
                this.updateLabelModule();
            }
        },
        {
            key: "draw",
            value: function draw(ctx) {
                var values = this.getFormattingValues();
                return this.shape.draw(ctx, this.x, this.y, this.selected, this.hover, values) || {};
            }
        },
        {
            key: "updateBoundingBox",
            value: function updateBoundingBox(ctx) {
                this.shape.updateBoundingBox(this.x, this.y, ctx);
            }
        },
        {
            key: "resize",
            value: function resize(ctx) {
                var values = this.getFormattingValues();
                this.shape.resize(ctx, this.selected, this.hover, values);
            }
        },
        {
            key: "getItemsOnPoint",
            value: function getItemsOnPoint(point) {
                var ret = [];
                if (this.labelModule.visible()) {
                    if ($bebd28704f2536ea$var$pointInRect(this.labelModule.getSize(), point)) ret.push({
                        nodeId: this.id,
                        labelId: 0
                    });
                }
                if ($bebd28704f2536ea$var$pointInRect(this.shape.boundingBox, point)) ret.push({
                    nodeId: this.id
                });
                return ret;
            }
        },
        {
            key: "isOverlappingWith",
            value: function isOverlappingWith(obj) {
                return this.shape.left < obj.right && this.shape.left + this.shape.width > obj.left && this.shape.top < obj.bottom && this.shape.top + this.shape.height > obj.top;
            }
        },
        {
            key: "isBoundingBoxOverlappingWith",
            value: function isBoundingBoxOverlappingWith(obj) {
                return this.shape.boundingBox.left < obj.right && this.shape.boundingBox.right > obj.left && this.shape.boundingBox.top < obj.bottom && this.shape.boundingBox.bottom > obj.top;
            }
        }
    ], [
        {
            key: "checkOpacity",
            value: function checkOpacity(opacity) {
                return 0 <= opacity && opacity <= 1;
            }
        },
        {
            key: "checkCoordinateOrigin",
            value: function checkCoordinateOrigin(origin) {
                return origin === undefined || origin === "center" || origin === "top-left";
            }
        },
        {
            key: "updateGroupOptions",
            value: function updateGroupOptions(parentOptions, newOptions, groupList) {
                var _context4;
                if (groupList === undefined) return; // No groups, nothing to do
                var group = parentOptions.group;
                // paranoia: the selected group is already merged into node options, check.
                if (newOptions !== undefined && newOptions.group !== undefined && group !== newOptions.group) throw new Error("updateGroupOptions: group values in options don't match.");
                var hasGroup = typeof group === "number" || typeof group === "string" && group != "";
                if (!hasGroup) return; // current node has no group, no need to merge
                var groupObj = groupList.get(group);
                if (groupObj.opacity !== undefined && newOptions.opacity === undefined) {
                    if (!Node.checkOpacity(groupObj.opacity)) {
                        console.error("Invalid option for node opacity. Value must be between 0 and 1, found: " + groupObj.opacity);
                        groupObj.opacity = undefined;
                    }
                }
                // Skip any new option to avoid them being overridden by the group options.
                var skipProperties = $bebd28704f2536ea$var$_filterInstanceProperty(_context4 = $bebd28704f2536ea$var$_Object$getOwnPropertyNames(newOptions)).call(_context4, function(p) {
                    return newOptions[p] != null;
                });
                // Always skip merging group font options into parent; these are required to be distinct for labels
                skipProperties.push("font");
                $bebd28704f2536ea$var$selectiveNotDeepExtend(skipProperties, parentOptions, groupObj);
                // the color object needs to be completely defined.
                // Since groups can partially overwrite the colors, we parse it again, just in case.
                parentOptions.color = $bebd28704f2536ea$var$parseColor(parentOptions.color);
            }
        },
        {
            key: "parseOptions",
            value: function parseOptions(parentOptions, newOptions) {
                var allowDeletion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var globalOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var groupList = arguments.length > 4 ? arguments[4] : undefined;
                var fields = [
                    "color",
                    "fixed",
                    "shadow"
                ];
                $bebd28704f2536ea$var$selectiveNotDeepExtend(fields, parentOptions, newOptions, allowDeletion);
                Node.checkMass(newOptions);
                if (parentOptions.opacity !== undefined) {
                    if (!Node.checkOpacity(parentOptions.opacity)) {
                        console.error("Invalid option for node opacity. Value must be between 0 and 1, found: " + parentOptions.opacity);
                        parentOptions.opacity = undefined;
                    }
                }
                if (newOptions.opacity !== undefined) {
                    if (!Node.checkOpacity(newOptions.opacity)) {
                        console.error("Invalid option for node opacity. Value must be between 0 and 1, found: " + newOptions.opacity);
                        newOptions.opacity = undefined;
                    }
                }
                if (newOptions.shapeProperties && !Node.checkCoordinateOrigin(newOptions.shapeProperties.coordinateOrigin)) console.error("Invalid option for node coordinateOrigin, found: " + newOptions.shapeProperties.coordinateOrigin);
                // merge the shadow options into the parent.
                $bebd28704f2536ea$var$mergeOptions(parentOptions, newOptions, "shadow", globalOptions);
                // individual shape newOptions
                if (newOptions.color !== undefined && newOptions.color !== null) {
                    var parsedColor = $bebd28704f2536ea$var$parseColor(newOptions.color);
                    $bebd28704f2536ea$var$fillIfDefined(parentOptions.color, parsedColor);
                } else if (allowDeletion === true && newOptions.color === null) parentOptions.color = $bebd28704f2536ea$var$bridgeObject(globalOptions.color); // set the object back to the global options
                // handle the fixed options
                if (newOptions.fixed !== undefined && newOptions.fixed !== null) {
                    if (typeof newOptions.fixed === "boolean") {
                        parentOptions.fixed.x = newOptions.fixed;
                        parentOptions.fixed.y = newOptions.fixed;
                    } else {
                        if (newOptions.fixed.x !== undefined && typeof newOptions.fixed.x === "boolean") parentOptions.fixed.x = newOptions.fixed.x;
                        if (newOptions.fixed.y !== undefined && typeof newOptions.fixed.y === "boolean") parentOptions.fixed.y = newOptions.fixed.y;
                    }
                }
                if (allowDeletion === true && newOptions.font === null) parentOptions.font = $bebd28704f2536ea$var$bridgeObject(globalOptions.font); // set the object back to the global options
                Node.updateGroupOptions(parentOptions, newOptions, groupList);
                // handle the scaling options, specifically the label part
                if (newOptions.scaling !== undefined) $bebd28704f2536ea$var$mergeOptions(parentOptions.scaling, newOptions.scaling, "label", globalOptions.scaling);
            }
        },
        {
            key: "checkMass",
            value: function checkMass(options, id) {
                if (options.mass !== undefined && options.mass <= 0) {
                    var strId = "";
                    if (id !== undefined) strId = " in node id: " + id;
                    console.error("%cNegative or zero mass disallowed" + strId + ", setting mass to 1.", $bebd28704f2536ea$var$VALIDATOR_PRINT_STYLE);
                    options.mass = 1;
                }
            }
        }
    ]);
    return Node;
}();
function $bebd28704f2536ea$var$_createForOfIteratorHelper$5(o, allowArrayLike) {
    var it = typeof $bebd28704f2536ea$var$_Symbol !== "undefined" && $bebd28704f2536ea$var$_getIteratorMethod(o) || o["@@iterator"];
    if (!it) {
        if ($bebd28704f2536ea$var$_Array$isArray(o) || (it = $bebd28704f2536ea$var$_unsupportedIterableToArray$5(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $bebd28704f2536ea$var$_unsupportedIterableToArray$5(o, minLen) {
    var _context4;
    if (!o) return;
    if (typeof o === "string") return $bebd28704f2536ea$var$_arrayLikeToArray$5(o, minLen);
    var n = $bebd28704f2536ea$var$_sliceInstanceProperty(_context4 = Object.prototype.toString.call(o)).call(_context4, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return $bebd28704f2536ea$var$_Array$from$1(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bebd28704f2536ea$var$_arrayLikeToArray$5(o, minLen);
}
function $bebd28704f2536ea$var$_arrayLikeToArray$5(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * Handler for Nodes
 */ var $bebd28704f2536ea$var$NodesHandler = /*#__PURE__*/ function() {
    /**
   * @param {object} body
   * @param {Images} images
   * @param {Array.<Group>} groups
   * @param {LayoutEngine} layoutEngine
   */ function NodesHandler(body, images, groups, layoutEngine) {
        var _context, _this = this;
        $bebd28704f2536ea$var$_classCallCheck(this, NodesHandler);
        this.body = body;
        this.images = images;
        this.groups = groups;
        this.layoutEngine = layoutEngine;
        // create the node API in the body container
        this.body.functions.createNode = $bebd28704f2536ea$var$_bindInstanceProperty$1(_context = this.create).call(_context, this);
        this.nodesListeners = {
            add: function add(event, params) {
                _this.add(params.items);
            },
            update: function update(event, params) {
                _this.update(params.items, params.data, params.oldData);
            },
            remove: function remove(event, params) {
                _this.remove(params.items);
            }
        };
        this.defaultOptions = {
            borderWidth: 1,
            borderWidthSelected: undefined,
            brokenImage: undefined,
            color: {
                border: "#2B7CE9",
                background: "#97C2FC",
                highlight: {
                    border: "#2B7CE9",
                    background: "#D2E5FF"
                },
                hover: {
                    border: "#2B7CE9",
                    background: "#D2E5FF"
                }
            },
            opacity: undefined,
            // number between 0 and 1
            fixed: {
                x: false,
                y: false
            },
            font: {
                color: "#343434",
                size: 14,
                // px
                face: "arial",
                background: "none",
                strokeWidth: 0,
                // px
                strokeColor: "#ffffff",
                align: "center",
                vadjust: 0,
                multi: false,
                bold: {
                    mod: "bold"
                },
                boldital: {
                    mod: "bold italic"
                },
                ital: {
                    mod: "italic"
                },
                mono: {
                    mod: "",
                    size: 15,
                    // px
                    face: "monospace",
                    vadjust: 2
                }
            },
            group: undefined,
            hidden: false,
            icon: {
                face: "FontAwesome",
                //'FontAwesome',
                code: undefined,
                //'\uf007',
                size: 50,
                //50,
                color: "#2B7CE9" //'#aa00ff'
            },
            image: undefined,
            // --> URL
            imagePadding: {
                // only for image shape
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            },
            label: undefined,
            labelHighlightBold: true,
            level: undefined,
            margin: {
                top: 5,
                right: 5,
                bottom: 5,
                left: 5
            },
            mass: 1,
            physics: true,
            scaling: {
                min: 10,
                max: 30,
                label: {
                    enabled: false,
                    min: 14,
                    max: 30,
                    maxVisible: 30,
                    drawThreshold: 5
                },
                customScalingFunction: function customScalingFunction(min, max, total, value) {
                    if (max === min) return 0.5;
                    else {
                        var scale = 1 / (max - min);
                        return Math.max(0, (value - min) * scale);
                    }
                }
            },
            shadow: {
                enabled: false,
                color: "rgba(0,0,0,0.5)",
                size: 10,
                x: 5,
                y: 5
            },
            shape: "ellipse",
            shapeProperties: {
                borderDashes: false,
                // only for borders
                borderRadius: 6,
                // only for box shape
                interpolation: true,
                // only for image and circularImage shapes
                useImageSize: false,
                // only for image and circularImage shapes
                useBorderWithImage: false,
                // only for image shape
                coordinateOrigin: "center" // only for image and circularImage shapes
            },
            size: 25,
            title: undefined,
            value: undefined,
            x: undefined,
            y: undefined
        };
        // Protect from idiocy
        if (this.defaultOptions.mass <= 0) throw "Internal error: mass in defaultOptions of NodesHandler may not be zero or negative";
        this.options = $bebd28704f2536ea$var$bridgeObject(this.defaultOptions);
        this.bindEventListeners();
    }
    /**
   * Binds event listeners
   */ $bebd28704f2536ea$var$_createClass(NodesHandler, [
        {
            key: "bindEventListeners",
            value: function bindEventListeners() {
                var _context2, _context3, _this2 = this;
                // refresh the nodes. Used when reverting from hierarchical layout
                this.body.emitter.on("refreshNodes", $bebd28704f2536ea$var$_bindInstanceProperty$1(_context2 = this.refresh).call(_context2, this));
                this.body.emitter.on("refresh", $bebd28704f2536ea$var$_bindInstanceProperty$1(_context3 = this.refresh).call(_context3, this));
                this.body.emitter.on("destroy", function() {
                    $bebd28704f2536ea$var$forEach$1(_this2.nodesListeners, function(callback, event) {
                        if (_this2.body.data.nodes) _this2.body.data.nodes.off(event, callback);
                    });
                    delete _this2.body.functions.createNode;
                    delete _this2.nodesListeners.add;
                    delete _this2.nodesListeners.update;
                    delete _this2.nodesListeners.remove;
                    delete _this2.nodesListeners;
                });
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                if (options !== undefined) {
                    $bebd28704f2536ea$var$Node.parseOptions(this.options, options);
                    // Need to set opacity here because Node.parseOptions is also used for groups,
                    // if you set opacity in Node.parseOptions it overwrites group opacity.
                    if (options.opacity !== undefined) {
                        if ($bebd28704f2536ea$var$_Number$isNaN(options.opacity) || !$bebd28704f2536ea$var$_Number$isFinite(options.opacity) || options.opacity < 0 || options.opacity > 1) console.error("Invalid option for node opacity. Value must be between 0 and 1, found: " + options.opacity);
                        else this.options.opacity = options.opacity;
                    }
                    // update the shape in all nodes
                    if (options.shape !== undefined) {
                        for(var nodeId in this.body.nodes)if (Object.prototype.hasOwnProperty.call(this.body.nodes, nodeId)) this.body.nodes[nodeId].updateShape();
                    }
                    // Update the labels of nodes if any relevant options changed.
                    if (typeof options.font !== "undefined" || typeof options.widthConstraint !== "undefined" || typeof options.heightConstraint !== "undefined") for(var _i = 0, _Object$keys$1 = $bebd28704f2536ea$var$_Object$keys(this.body.nodes); _i < _Object$keys$1.length; _i++){
                        var _nodeId = _Object$keys$1[_i];
                        this.body.nodes[_nodeId].updateLabelModule();
                        this.body.nodes[_nodeId].needsRefresh();
                    }
                    // update the shape size in all nodes
                    if (options.size !== undefined) {
                        for(var _nodeId2 in this.body.nodes)if (Object.prototype.hasOwnProperty.call(this.body.nodes, _nodeId2)) this.body.nodes[_nodeId2].needsRefresh();
                    }
                    // update the state of the variables if needed
                    if (options.hidden !== undefined || options.physics !== undefined) this.body.emitter.emit("_dataChanged");
                }
            }
        },
        {
            key: "setData",
            value: function setData(nodes) {
                var doNotEmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var oldNodesData = this.body.data.nodes;
                if ((0, $558228835489ffff$export$fd220aa21eb2fcbc)("id", nodes)) this.body.data.nodes = nodes;
                else if ($bebd28704f2536ea$var$_Array$isArray(nodes)) {
                    this.body.data.nodes = new (0, $558228835489ffff$export$486059efd2d2dabe)();
                    this.body.data.nodes.add(nodes);
                } else if (!nodes) this.body.data.nodes = new (0, $558228835489ffff$export$486059efd2d2dabe)();
                else throw new TypeError("Array or DataSet expected");
                if (oldNodesData) // unsubscribe from old dataset
                $bebd28704f2536ea$var$forEach$1(this.nodesListeners, function(callback, event) {
                    oldNodesData.off(event, callback);
                });
                // remove drawn nodes
                this.body.nodes = {};
                if (this.body.data.nodes) {
                    // subscribe to new dataset
                    var me = this;
                    $bebd28704f2536ea$var$forEach$1(this.nodesListeners, function(callback, event) {
                        me.body.data.nodes.on(event, callback);
                    });
                    // draw all new nodes
                    var ids = this.body.data.nodes.getIds();
                    this.add(ids, true);
                }
                if (doNotEmit === false) this.body.emitter.emit("_dataChanged");
            }
        },
        {
            key: "add",
            value: function add(ids) {
                var doNotEmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var id;
                var newNodes = [];
                for(var i = 0; i < ids.length; i++){
                    id = ids[i];
                    var properties = this.body.data.nodes.get(id);
                    var node = this.create(properties);
                    newNodes.push(node);
                    this.body.nodes[id] = node; // note: this may replace an existing node
                }
                this.layoutEngine.positionInitially(newNodes);
                if (doNotEmit === false) this.body.emitter.emit("_dataChanged");
            }
        },
        {
            key: "update",
            value: function update(ids, changedData, oldData) {
                var nodes = this.body.nodes;
                var dataChanged = false;
                for(var i = 0; i < ids.length; i++){
                    var id = ids[i];
                    var node = nodes[id];
                    var data = changedData[i];
                    if (node !== undefined) // update node
                    {
                        if (node.setOptions(data)) dataChanged = true;
                    } else {
                        dataChanged = true;
                        // create node
                        node = this.create(data);
                        nodes[id] = node;
                    }
                }
                if (!dataChanged && oldData !== undefined) // Check for any changes which should trigger a layout recalculation
                // For now, this is just 'level' for hierarchical layout
                // Assumption: old and new data arranged in same order; at time of writing, this holds.
                dataChanged = $bebd28704f2536ea$var$_someInstanceProperty(changedData).call(changedData, function(newValue, index) {
                    var oldValue = oldData[index];
                    return oldValue && oldValue.level !== newValue.level;
                });
                if (dataChanged === true) this.body.emitter.emit("_dataChanged");
                else this.body.emitter.emit("_dataUpdated");
            }
        },
        {
            key: "remove",
            value: function remove(ids) {
                var nodes = this.body.nodes;
                for(var i = 0; i < ids.length; i++){
                    var id = ids[i];
                    delete nodes[id];
                }
                this.body.emitter.emit("_dataChanged");
            }
        },
        {
            key: "create",
            value: function create(properties) {
                var constructorClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $bebd28704f2536ea$var$Node;
                return new constructorClass(properties, this.body, this.images, this.groups, this.options, this.defaultOptions);
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                var _this3 = this;
                var clearPositions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                $bebd28704f2536ea$var$forEach$1(this.body.nodes, function(node, nodeId) {
                    var data = _this3.body.data.nodes.get(nodeId);
                    if (data !== undefined) {
                        if (clearPositions === true) node.setOptions({
                            x: null,
                            y: null
                        });
                        node.setOptions({
                            fixed: false
                        });
                        node.setOptions(data);
                    }
                });
            }
        },
        {
            key: "getPositions",
            value: function getPositions(ids) {
                var dataArray = {};
                if (ids !== undefined) {
                    if ($bebd28704f2536ea$var$_Array$isArray(ids) === true) {
                        for(var i = 0; i < ids.length; i++)if (this.body.nodes[ids[i]] !== undefined) {
                            var node = this.body.nodes[ids[i]];
                            dataArray[ids[i]] = {
                                x: Math.round(node.x),
                                y: Math.round(node.y)
                            };
                        }
                    } else if (this.body.nodes[ids] !== undefined) {
                        var _node = this.body.nodes[ids];
                        dataArray[ids] = {
                            x: Math.round(_node.x),
                            y: Math.round(_node.y)
                        };
                    }
                } else for(var _i2 = 0; _i2 < this.body.nodeIndices.length; _i2++){
                    var _node2 = this.body.nodes[this.body.nodeIndices[_i2]];
                    dataArray[this.body.nodeIndices[_i2]] = {
                        x: Math.round(_node2.x),
                        y: Math.round(_node2.y)
                    };
                }
                return dataArray;
            }
        },
        {
            key: "getPosition",
            value: function getPosition(id) {
                if (id == undefined) throw new TypeError("No id was specified for getPosition method.");
                else if (this.body.nodes[id] == undefined) throw new ReferenceError("NodeId provided for getPosition does not exist. Provided: ".concat(id));
                else return {
                    x: Math.round(this.body.nodes[id].x),
                    y: Math.round(this.body.nodes[id].y)
                };
            }
        },
        {
            key: "storePositions",
            value: function storePositions() {
                // todo: add support for clusters and hierarchical.
                var dataArray = [];
                var dataset = this.body.data.nodes.getDataSet();
                var _iterator = $bebd28704f2536ea$var$_createForOfIteratorHelper$5(dataset.get()), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var dsNode = _step.value;
                        var id = dsNode.id;
                        var bodyNode = this.body.nodes[id];
                        var x = Math.round(bodyNode.x);
                        var y = Math.round(bodyNode.y);
                        if (dsNode.x !== x || dsNode.y !== y) dataArray.push({
                            id: id,
                            x: x,
                            y: y
                        });
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                dataset.update(dataArray);
            }
        },
        {
            key: "getBoundingBox",
            value: function getBoundingBox(nodeId) {
                if (this.body.nodes[nodeId] !== undefined) return this.body.nodes[nodeId].shape.boundingBox;
            }
        },
        {
            key: "getConnectedNodes",
            value: function getConnectedNodes(nodeId, direction) {
                var nodeList = [];
                if (this.body.nodes[nodeId] !== undefined) {
                    var node = this.body.nodes[nodeId];
                    var nodeObj = {}; // used to quickly check if node already exists
                    for(var i = 0; i < node.edges.length; i++){
                        var edge = node.edges[i];
                        if (direction !== "to" && edge.toId == node.id) // these are double equals since ids can be numeric or string
                        {
                            if (nodeObj[edge.fromId] === undefined) {
                                nodeList.push(edge.fromId);
                                nodeObj[edge.fromId] = true;
                            }
                        } else if (direction !== "from" && edge.fromId == node.id) // these are double equals since ids can be numeric or string
                        {
                            if (nodeObj[edge.toId] === undefined) {
                                nodeList.push(edge.toId);
                                nodeObj[edge.toId] = true;
                            }
                        }
                    }
                }
                return nodeList;
            }
        },
        {
            key: "getConnectedEdges",
            value: function getConnectedEdges(nodeId) {
                var edgeList = [];
                if (this.body.nodes[nodeId] !== undefined) {
                    var node = this.body.nodes[nodeId];
                    for(var i = 0; i < node.edges.length; i++)edgeList.push(node.edges[i].id);
                } else console.error("NodeId provided for getConnectedEdges does not exist. Provided: ", nodeId);
                return edgeList;
            }
        },
        {
            key: "moveNode",
            value: function moveNode(nodeId, x, y) {
                var _this4 = this;
                if (this.body.nodes[nodeId] !== undefined) {
                    this.body.nodes[nodeId].x = Number(x);
                    this.body.nodes[nodeId].y = Number(y);
                    $bebd28704f2536ea$var$_setTimeout(function() {
                        _this4.body.emitter.emit("startSimulation");
                    }, 0);
                } else console.error("Node id supplied to moveNode does not exist. Provided: ", nodeId);
            }
        }
    ]);
    return NodesHandler;
}();
var $bebd28704f2536ea$var$hasOwn$1 = $bebd28704f2536ea$var$hasOwnProperty_1;
var $bebd28704f2536ea$var$isDataDescriptor$1 = function(descriptor) {
    return descriptor !== undefined && ($bebd28704f2536ea$var$hasOwn$1(descriptor, 'value') || $bebd28704f2536ea$var$hasOwn$1(descriptor, 'writable'));
};
var $bebd28704f2536ea$var$$$4 = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$call = $bebd28704f2536ea$var$functionCall;
var $bebd28704f2536ea$var$isObject$2 = $bebd28704f2536ea$var$isObject$j;
var $bebd28704f2536ea$var$anObject$1 = $bebd28704f2536ea$var$anObject$d;
var $bebd28704f2536ea$var$isDataDescriptor = $bebd28704f2536ea$var$isDataDescriptor$1;
var $bebd28704f2536ea$var$getOwnPropertyDescriptorModule = $bebd28704f2536ea$var$objectGetOwnPropertyDescriptor;
var $bebd28704f2536ea$var$getPrototypeOf = $bebd28704f2536ea$var$objectGetPrototypeOf;
// `Reflect.get` method
// https://tc39.es/ecma262/#sec-reflect.get
function $bebd28704f2536ea$var$get$5(target, propertyKey /* , receiver */ ) {
    var receiver = arguments.length < 3 ? target : arguments[2];
    var descriptor, prototype;
    if ($bebd28704f2536ea$var$anObject$1(target) === receiver) return target[propertyKey];
    descriptor = $bebd28704f2536ea$var$getOwnPropertyDescriptorModule.f(target, propertyKey);
    if (descriptor) return $bebd28704f2536ea$var$isDataDescriptor(descriptor) ? descriptor.value : descriptor.get === undefined ? undefined : $bebd28704f2536ea$var$call(descriptor.get, receiver);
    if ($bebd28704f2536ea$var$isObject$2(prototype = $bebd28704f2536ea$var$getPrototypeOf(target))) return $bebd28704f2536ea$var$get$5(prototype, propertyKey, receiver);
}
$bebd28704f2536ea$var$$$4({
    target: 'Reflect',
    stat: true
}, {
    get: $bebd28704f2536ea$var$get$5
});
var $bebd28704f2536ea$var$path$4 = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$get$4 = $bebd28704f2536ea$var$path$4.Reflect.get;
var $bebd28704f2536ea$var$parent$a = $bebd28704f2536ea$var$get$4;
var $bebd28704f2536ea$var$get$3 = $bebd28704f2536ea$var$parent$a;
var $bebd28704f2536ea$var$parent$9 = $bebd28704f2536ea$var$get$3;
var $bebd28704f2536ea$var$get$2 = $bebd28704f2536ea$var$parent$9;
var $bebd28704f2536ea$var$parent$8 = $bebd28704f2536ea$var$get$2;
var $bebd28704f2536ea$var$get$1 = $bebd28704f2536ea$var$parent$8;
var $bebd28704f2536ea$var$get = $bebd28704f2536ea$var$get$1;
var $bebd28704f2536ea$var$_Reflect$get = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$get);
var $bebd28704f2536ea$var$parent$7 = $bebd28704f2536ea$var$getOwnPropertyDescriptor$4;
var $bebd28704f2536ea$var$getOwnPropertyDescriptor$2 = $bebd28704f2536ea$var$parent$7;
var $bebd28704f2536ea$var$parent$6 = $bebd28704f2536ea$var$getOwnPropertyDescriptor$2;
var $bebd28704f2536ea$var$getOwnPropertyDescriptor$1 = $bebd28704f2536ea$var$parent$6;
var $bebd28704f2536ea$var$getOwnPropertyDescriptor = $bebd28704f2536ea$var$getOwnPropertyDescriptor$1;
var $bebd28704f2536ea$var$_Object$getOwnPropertyDescriptor = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$getOwnPropertyDescriptor);
function $bebd28704f2536ea$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $bebd28704f2536ea$var$_getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
function $bebd28704f2536ea$var$_get() {
    if (typeof Reflect !== "undefined" && $bebd28704f2536ea$var$_Reflect$get) {
        var _context;
        $bebd28704f2536ea$var$_get = $bebd28704f2536ea$var$_bindInstanceProperty(_context = $bebd28704f2536ea$var$_Reflect$get).call(_context);
    } else $bebd28704f2536ea$var$_get = function _get(target, property, receiver) {
        var base = $bebd28704f2536ea$var$_superPropBase(target, property);
        if (!base) return;
        var desc = $bebd28704f2536ea$var$_Object$getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(arguments.length < 3 ? target : receiver);
        return desc.value;
    };
    return $bebd28704f2536ea$var$_get.apply(this, arguments);
}
var $bebd28704f2536ea$var$$$3 = $bebd28704f2536ea$var$_export;
// eslint-disable-next-line es/no-math-hypot -- required for testing
var $bebd28704f2536ea$var$$hypot = Math.hypot;
var $bebd28704f2536ea$var$abs = Math.abs;
var $bebd28704f2536ea$var$sqrt = Math.sqrt;
// Chrome 77 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=9546
var $bebd28704f2536ea$var$FORCED$2 = !!$bebd28704f2536ea$var$$hypot && $bebd28704f2536ea$var$$hypot(Infinity, NaN) !== Infinity;
// `Math.hypot` method
// https://tc39.es/ecma262/#sec-math.hypot
$bebd28704f2536ea$var$$$3({
    target: 'Math',
    stat: true,
    arity: 2,
    forced: $bebd28704f2536ea$var$FORCED$2
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    hypot: function hypot(value1, value2) {
        var sum = 0;
        var i = 0;
        var aLen = arguments.length;
        var larg = 0;
        var arg, div;
        while(i < aLen){
            arg = $bebd28704f2536ea$var$abs(arguments[i++]);
            if (larg < arg) {
                div = larg / arg;
                sum = sum * div * div + 1;
                larg = arg;
            } else if (arg > 0) {
                div = arg / larg;
                sum += div * div;
            } else sum += arg;
        }
        return larg === Infinity ? Infinity : larg * $bebd28704f2536ea$var$sqrt(sum);
    }
});
var $bebd28704f2536ea$var$path$3 = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$hypot$2 = $bebd28704f2536ea$var$path$3.Math.hypot;
var $bebd28704f2536ea$var$parent$5 = $bebd28704f2536ea$var$hypot$2;
var $bebd28704f2536ea$var$hypot$1 = $bebd28704f2536ea$var$parent$5;
var $bebd28704f2536ea$var$hypot = $bebd28704f2536ea$var$hypot$1;
var $bebd28704f2536ea$var$_Math$hypot = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$hypot);
function $bebd28704f2536ea$var$_createSuper$a(Derived) {
    var hasNativeReflectConstruct = $bebd28704f2536ea$var$_isNativeReflectConstruct$a();
    return function _createSuperInternal() {
        var Super = $bebd28704f2536ea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bebd28704f2536ea$var$_getPrototypeOf(this).constructor;
            result = $bebd28704f2536ea$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bebd28704f2536ea$var$_possibleConstructorReturn(this, result);
    };
}
function $bebd28704f2536ea$var$_isNativeReflectConstruct$a() {
    if (typeof Reflect === "undefined" || !$bebd28704f2536ea$var$_Reflect$construct) return false;
    if ($bebd28704f2536ea$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($bebd28704f2536ea$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Common methods for endpoints
 *
 * @class
 */ var $bebd28704f2536ea$var$EndPoint = /*#__PURE__*/ function() {
    function EndPoint() {
        $bebd28704f2536ea$var$_classCallCheck(this, EndPoint);
    }
    $bebd28704f2536ea$var$_createClass(EndPoint, null, [
        {
            key: "transform",
            value: /**
     * Apply transformation on points for display.
     *
     * The following is done:
     * - rotate by the specified angle
     * - multiply the (normalized) coordinates by the passed length
     * - offset by the target coordinates
     *
     * @param points - The point(s) to be transformed.
     * @param arrowData - The data determining the result of the transformation.
     */ function transform(points, arrowData) {
                if (!$bebd28704f2536ea$var$_Array$isArray(points)) points = [
                    points
                ];
                var x = arrowData.point.x;
                var y = arrowData.point.y;
                var angle = arrowData.angle;
                var length1 = arrowData.length;
                for(var i = 0; i < points.length; ++i){
                    var p = points[i];
                    var xt = p.x * Math.cos(angle) - p.y * Math.sin(angle);
                    var yt = p.x * Math.sin(angle) + p.y * Math.cos(angle);
                    p.x = x + length1 * xt;
                    p.y = y + length1 * yt;
                }
            }
        },
        {
            key: "drawPath",
            value: function drawPath(ctx, points) {
                ctx.beginPath();
                ctx.moveTo(points[0].x, points[0].y);
                for(var i = 1; i < points.length; ++i)ctx.lineTo(points[i].x, points[i].y);
                ctx.closePath();
            }
        }
    ]);
    return EndPoint;
}();
/**
 * Drawing methods for the arrow endpoint.
 */ var $bebd28704f2536ea$var$Image$1 = /*#__PURE__*/ function(_EndPoint) {
    $bebd28704f2536ea$var$_inherits(Image1, _EndPoint);
    var _super = $bebd28704f2536ea$var$_createSuper$a(Image1);
    function Image1() {
        $bebd28704f2536ea$var$_classCallCheck(this, Image1);
        return _super.apply(this, arguments);
    }
    $bebd28704f2536ea$var$_createClass(Image1, null, [
        {
            key: "draw",
            value: /**
     * Draw this shape at the end of a line.
     *
     * @param ctx - The shape will be rendered into this context.
     * @param arrowData - The data determining the shape.
     * @returns False as there is no way to fill an image.
     */ function draw(ctx, arrowData) {
                if (arrowData.image) {
                    ctx.save();
                    ctx.translate(arrowData.point.x, arrowData.point.y);
                    ctx.rotate(Math.PI / 2 + arrowData.angle);
                    var width = arrowData.imageWidth != null ? arrowData.imageWidth : arrowData.image.width;
                    var height = arrowData.imageHeight != null ? arrowData.imageHeight : arrowData.image.height;
                    arrowData.image.drawImageAtPosition(ctx, 1, // scale
                    -width / 2, // x
                    0, // y
                    width, height);
                    ctx.restore();
                }
                return false;
            }
        }
    ]);
    return Image1;
}($bebd28704f2536ea$var$EndPoint);
/**
 * Drawing methods for the arrow endpoint.
 */ var $bebd28704f2536ea$var$Arrow = /*#__PURE__*/ function(_EndPoint2) {
    $bebd28704f2536ea$var$_inherits(Arrow, _EndPoint2);
    var _super2 = $bebd28704f2536ea$var$_createSuper$a(Arrow);
    function Arrow() {
        $bebd28704f2536ea$var$_classCallCheck(this, Arrow);
        return _super2.apply(this, arguments);
    }
    $bebd28704f2536ea$var$_createClass(Arrow, null, [
        {
            key: "draw",
            value: /**
     * Draw this shape at the end of a line.
     *
     * @param ctx - The shape will be rendered into this context.
     * @param arrowData - The data determining the shape.
     * @returns True because ctx.fill() can be used to fill the arrow.
     */ function draw(ctx, arrowData) {
                // Normalized points of closed path, in the order that they should be drawn.
                // (0, 0) is the attachment point, and the point around which should be rotated
                var points = [
                    {
                        x: 0,
                        y: 0
                    },
                    {
                        x: -1,
                        y: 0.3
                    },
                    {
                        x: -0.9,
                        y: 0
                    },
                    {
                        x: -1,
                        y: -0.3
                    }
                ];
                $bebd28704f2536ea$var$EndPoint.transform(points, arrowData);
                $bebd28704f2536ea$var$EndPoint.drawPath(ctx, points);
                return true;
            }
        }
    ]);
    return Arrow;
}($bebd28704f2536ea$var$EndPoint);
/**
 * Drawing methods for the crow endpoint.
 */ var $bebd28704f2536ea$var$Crow = /*#__PURE__*/ function() {
    function Crow() {
        $bebd28704f2536ea$var$_classCallCheck(this, Crow);
    }
    $bebd28704f2536ea$var$_createClass(Crow, null, [
        {
            key: "draw",
            value: /**
     * Draw this shape at the end of a line.
     *
     * @param ctx - The shape will be rendered into this context.
     * @param arrowData - The data determining the shape.
     * @returns True because ctx.fill() can be used to fill the arrow.
     */ function draw(ctx, arrowData) {
                // Normalized points of closed path, in the order that they should be drawn.
                // (0, 0) is the attachment point, and the point around which should be rotated
                var points = [
                    {
                        x: -1,
                        y: 0
                    },
                    {
                        x: 0,
                        y: 0.3
                    },
                    {
                        x: -0.4,
                        y: 0
                    },
                    {
                        x: 0,
                        y: -0.3
                    }
                ];
                $bebd28704f2536ea$var$EndPoint.transform(points, arrowData);
                $bebd28704f2536ea$var$EndPoint.drawPath(ctx, points);
                return true;
            }
        }
    ]);
    return Crow;
}();
/**
 * Drawing methods for the curve endpoint.
 */ var $bebd28704f2536ea$var$Curve = /*#__PURE__*/ function() {
    function Curve() {
        $bebd28704f2536ea$var$_classCallCheck(this, Curve);
    }
    $bebd28704f2536ea$var$_createClass(Curve, null, [
        {
            key: "draw",
            value: /**
     * Draw this shape at the end of a line.
     *
     * @param ctx - The shape will be rendered into this context.
     * @param arrowData - The data determining the shape.
     * @returns True because ctx.fill() can be used to fill the arrow.
     */ function draw(ctx, arrowData) {
                // Normalized points of closed path, in the order that they should be drawn.
                // (0, 0) is the attachment point, and the point around which should be rotated
                var point = {
                    x: -0.4,
                    y: 0
                };
                $bebd28704f2536ea$var$EndPoint.transform(point, arrowData);
                // Update endpoint style for drawing transparent arc.
                ctx.strokeStyle = ctx.fillStyle;
                ctx.fillStyle = "rgba(0, 0, 0, 0)";
                // Define curve endpoint as semicircle.
                var pi = Math.PI;
                var startAngle = arrowData.angle - pi / 2;
                var endAngle = arrowData.angle + pi / 2;
                ctx.beginPath();
                ctx.arc(point.x, point.y, arrowData.length * 0.4, startAngle, endAngle, false);
                ctx.stroke();
                return true;
            }
        }
    ]);
    return Curve;
}();
/**
 * Drawing methods for the inverted curve endpoint.
 */ var $bebd28704f2536ea$var$InvertedCurve = /*#__PURE__*/ function() {
    function InvertedCurve() {
        $bebd28704f2536ea$var$_classCallCheck(this, InvertedCurve);
    }
    $bebd28704f2536ea$var$_createClass(InvertedCurve, null, [
        {
            key: "draw",
            value: /**
     * Draw this shape at the end of a line.
     *
     * @param ctx - The shape will be rendered into this context.
     * @param arrowData - The data determining the shape.
     * @returns True because ctx.fill() can be used to fill the arrow.
     */ function draw(ctx, arrowData) {
                // Normalized points of closed path, in the order that they should be drawn.
                // (0, 0) is the attachment point, and the point around which should be rotated
                var point = {
                    x: -0.3,
                    y: 0
                };
                $bebd28704f2536ea$var$EndPoint.transform(point, arrowData);
                // Update endpoint style for drawing transparent arc.
                ctx.strokeStyle = ctx.fillStyle;
                ctx.fillStyle = "rgba(0, 0, 0, 0)";
                // Define inverted curve endpoint as semicircle.
                var pi = Math.PI;
                var startAngle = arrowData.angle + pi / 2;
                var endAngle = arrowData.angle + 3 * pi / 2;
                ctx.beginPath();
                ctx.arc(point.x, point.y, arrowData.length * 0.4, startAngle, endAngle, false);
                ctx.stroke();
                return true;
            }
        }
    ]);
    return InvertedCurve;
}();
/**
 * Drawing methods for the trinagle endpoint.
 */ var $bebd28704f2536ea$var$Triangle = /*#__PURE__*/ function() {
    function Triangle() {
        $bebd28704f2536ea$var$_classCallCheck(this, Triangle);
    }
    $bebd28704f2536ea$var$_createClass(Triangle, null, [
        {
            key: "draw",
            value: /**
     * Draw this shape at the end of a line.
     *
     * @param ctx - The shape will be rendered into this context.
     * @param arrowData - The data determining the shape.
     * @returns True because ctx.fill() can be used to fill the arrow.
     */ function draw(ctx, arrowData) {
                // Normalized points of closed path, in the order that they should be drawn.
                // (0, 0) is the attachment point, and the point around which should be rotated
                var points = [
                    {
                        x: 0.02,
                        y: 0
                    },
                    {
                        x: -1,
                        y: 0.3
                    },
                    {
                        x: -1,
                        y: -0.3
                    }
                ];
                $bebd28704f2536ea$var$EndPoint.transform(points, arrowData);
                $bebd28704f2536ea$var$EndPoint.drawPath(ctx, points);
                return true;
            }
        }
    ]);
    return Triangle;
}();
/**
 * Drawing methods for the inverted trinagle endpoint.
 */ var $bebd28704f2536ea$var$InvertedTriangle = /*#__PURE__*/ function() {
    function InvertedTriangle() {
        $bebd28704f2536ea$var$_classCallCheck(this, InvertedTriangle);
    }
    $bebd28704f2536ea$var$_createClass(InvertedTriangle, null, [
        {
            key: "draw",
            value: /**
     * Draw this shape at the end of a line.
     *
     * @param ctx - The shape will be rendered into this context.
     * @param arrowData - The data determining the shape.
     * @returns True because ctx.fill() can be used to fill the arrow.
     */ function draw(ctx, arrowData) {
                // Normalized points of closed path, in the order that they should be drawn.
                // (0, 0) is the attachment point, and the point around which should be rotated
                var points = [
                    {
                        x: 0,
                        y: 0.3
                    },
                    {
                        x: 0,
                        y: -0.3
                    },
                    {
                        x: -1,
                        y: 0
                    }
                ];
                $bebd28704f2536ea$var$EndPoint.transform(points, arrowData);
                $bebd28704f2536ea$var$EndPoint.drawPath(ctx, points);
                return true;
            }
        }
    ]);
    return InvertedTriangle;
}();
/**
 * Drawing methods for the circle endpoint.
 */ var $bebd28704f2536ea$var$Circle = /*#__PURE__*/ function() {
    function Circle() {
        $bebd28704f2536ea$var$_classCallCheck(this, Circle);
    }
    $bebd28704f2536ea$var$_createClass(Circle, null, [
        {
            key: "draw",
            value: /**
     * Draw this shape at the end of a line.
     *
     * @param ctx - The shape will be rendered into this context.
     * @param arrowData - The data determining the shape.
     * @returns True because ctx.fill() can be used to fill the arrow.
     */ function draw(ctx, arrowData) {
                var point = {
                    x: -0.4,
                    y: 0
                };
                $bebd28704f2536ea$var$EndPoint.transform(point, arrowData);
                $bebd28704f2536ea$var$drawCircle(ctx, point.x, point.y, arrowData.length * 0.4);
                return true;
            }
        }
    ]);
    return Circle;
}();
/**
 * Drawing methods for the bar endpoint.
 */ var $bebd28704f2536ea$var$Bar = /*#__PURE__*/ function() {
    function Bar() {
        $bebd28704f2536ea$var$_classCallCheck(this, Bar);
    }
    $bebd28704f2536ea$var$_createClass(Bar, null, [
        {
            key: "draw",
            value: /**
     * Draw this shape at the end of a line.
     *
     * @param ctx - The shape will be rendered into this context.
     * @param arrowData - The data determining the shape.
     * @returns True because ctx.fill() can be used to fill the arrow.
     */ function draw(ctx, arrowData) {
                /*
      var points = [
        {x:0, y:0.5},
        {x:0, y:-0.5}
      ];
           EndPoint.transform(points, arrowData);
      ctx.beginPath();
      ctx.moveTo(points[0].x, points[0].y);
      ctx.lineTo(points[1].x, points[1].y);
      ctx.stroke();
      */ var points = [
                    {
                        x: 0,
                        y: 0.5
                    },
                    {
                        x: 0,
                        y: -0.5
                    },
                    {
                        x: -0.15,
                        y: -0.5
                    },
                    {
                        x: -0.15,
                        y: 0.5
                    }
                ];
                $bebd28704f2536ea$var$EndPoint.transform(points, arrowData);
                $bebd28704f2536ea$var$EndPoint.drawPath(ctx, points);
                return true;
            }
        }
    ]);
    return Bar;
}();
/**
 * Drawing methods for the box endpoint.
 */ var $bebd28704f2536ea$var$Box = /*#__PURE__*/ function() {
    function Box() {
        $bebd28704f2536ea$var$_classCallCheck(this, Box);
    }
    $bebd28704f2536ea$var$_createClass(Box, null, [
        {
            key: "draw",
            value: /**
     * Draw this shape at the end of a line.
     *
     * @param ctx - The shape will be rendered into this context.
     * @param arrowData - The data determining the shape.
     * @returns True because ctx.fill() can be used to fill the arrow.
     */ function draw(ctx, arrowData) {
                var points = [
                    {
                        x: 0,
                        y: 0.3
                    },
                    {
                        x: 0,
                        y: -0.3
                    },
                    {
                        x: -0.6,
                        y: -0.3
                    },
                    {
                        x: -0.6,
                        y: 0.3
                    }
                ];
                $bebd28704f2536ea$var$EndPoint.transform(points, arrowData);
                $bebd28704f2536ea$var$EndPoint.drawPath(ctx, points);
                return true;
            }
        }
    ]);
    return Box;
}();
/**
 * Drawing methods for the diamond endpoint.
 */ var $bebd28704f2536ea$var$Diamond = /*#__PURE__*/ function() {
    function Diamond() {
        $bebd28704f2536ea$var$_classCallCheck(this, Diamond);
    }
    $bebd28704f2536ea$var$_createClass(Diamond, null, [
        {
            key: "draw",
            value: /**
     * Draw this shape at the end of a line.
     *
     * @param ctx - The shape will be rendered into this context.
     * @param arrowData - The data determining the shape.
     * @returns True because ctx.fill() can be used to fill the arrow.
     */ function draw(ctx, arrowData) {
                var points = [
                    {
                        x: 0,
                        y: 0
                    },
                    {
                        x: -0.5,
                        y: -0.3
                    },
                    {
                        x: -1,
                        y: 0
                    },
                    {
                        x: -0.5,
                        y: 0.3
                    }
                ];
                $bebd28704f2536ea$var$EndPoint.transform(points, arrowData);
                $bebd28704f2536ea$var$EndPoint.drawPath(ctx, points);
                return true;
            }
        }
    ]);
    return Diamond;
}();
/**
 * Drawing methods for the vee endpoint.
 */ var $bebd28704f2536ea$var$Vee = /*#__PURE__*/ function() {
    function Vee() {
        $bebd28704f2536ea$var$_classCallCheck(this, Vee);
    }
    $bebd28704f2536ea$var$_createClass(Vee, null, [
        {
            key: "draw",
            value: /**
     * Draw this shape at the end of a line.
     *
     * @param ctx - The shape will be rendered into this context.
     * @param arrowData - The data determining the shape.
     * @returns True because ctx.fill() can be used to fill the arrow.
     */ function draw(ctx, arrowData) {
                // Normalized points of closed path, in the order that they should be drawn.
                // (0, 0) is the attachment point, and the point around which should be rotated
                var points = [
                    {
                        x: -1,
                        y: 0.3
                    },
                    {
                        x: -0.5,
                        y: 0
                    },
                    {
                        x: -1,
                        y: -0.3
                    },
                    {
                        x: 0,
                        y: 0
                    }
                ];
                $bebd28704f2536ea$var$EndPoint.transform(points, arrowData);
                $bebd28704f2536ea$var$EndPoint.drawPath(ctx, points);
                return true;
            }
        }
    ]);
    return Vee;
}();
/**
 * Drawing methods for the endpoints.
 */ var $bebd28704f2536ea$var$EndPoints = /*#__PURE__*/ function() {
    function EndPoints() {
        $bebd28704f2536ea$var$_classCallCheck(this, EndPoints);
    }
    $bebd28704f2536ea$var$_createClass(EndPoints, null, [
        {
            key: "draw",
            value: /**
     * Draw an endpoint.
     *
     * @param ctx - The shape will be rendered into this context.
     * @param arrowData - The data determining the shape.
     * @returns True if ctx.fill() can be used to fill the arrow, false otherwise.
     */ function draw(ctx, arrowData) {
                var type;
                if (arrowData.type) type = arrowData.type.toLowerCase();
                switch(type){
                    case "image":
                        return $bebd28704f2536ea$var$Image$1.draw(ctx, arrowData);
                    case "circle":
                        return $bebd28704f2536ea$var$Circle.draw(ctx, arrowData);
                    case "box":
                        return $bebd28704f2536ea$var$Box.draw(ctx, arrowData);
                    case "crow":
                        return $bebd28704f2536ea$var$Crow.draw(ctx, arrowData);
                    case "curve":
                        return $bebd28704f2536ea$var$Curve.draw(ctx, arrowData);
                    case "diamond":
                        return $bebd28704f2536ea$var$Diamond.draw(ctx, arrowData);
                    case "inv_curve":
                        return $bebd28704f2536ea$var$InvertedCurve.draw(ctx, arrowData);
                    case "triangle":
                        return $bebd28704f2536ea$var$Triangle.draw(ctx, arrowData);
                    case "inv_triangle":
                        return $bebd28704f2536ea$var$InvertedTriangle.draw(ctx, arrowData);
                    case "bar":
                        return $bebd28704f2536ea$var$Bar.draw(ctx, arrowData);
                    case "vee":
                        return $bebd28704f2536ea$var$Vee.draw(ctx, arrowData);
                    case "arrow":
                    default:
                        return $bebd28704f2536ea$var$Arrow.draw(ctx, arrowData);
                }
            }
        }
    ]);
    return EndPoints;
}();
function $bebd28704f2536ea$var$ownKeys$1(e, r) {
    var t = $bebd28704f2536ea$var$_Object$keys(e);
    if ($bebd28704f2536ea$var$_Object$getOwnPropertySymbols) {
        var o = $bebd28704f2536ea$var$_Object$getOwnPropertySymbols(e);
        r && (o = $bebd28704f2536ea$var$_filterInstanceProperty(o).call(o, function(r) {
            return $bebd28704f2536ea$var$_Object$getOwnPropertyDescriptor$1(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bebd28704f2536ea$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var _context2, _context3;
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bebd28704f2536ea$var$_forEachInstanceProperty(_context2 = $bebd28704f2536ea$var$ownKeys$1(Object(t), !0)).call(_context2, function(r) {
            $bebd28704f2536ea$var$_defineProperty(e, r, t[r]);
        }) : $bebd28704f2536ea$var$_Object$getOwnPropertyDescriptors ? $bebd28704f2536ea$var$_Object$defineProperties(e, $bebd28704f2536ea$var$_Object$getOwnPropertyDescriptors(t)) : $bebd28704f2536ea$var$_forEachInstanceProperty(_context3 = $bebd28704f2536ea$var$ownKeys$1(Object(t))).call(_context3, function(r) {
            $bebd28704f2536ea$var$_Object$defineProperty(e, r, $bebd28704f2536ea$var$_Object$getOwnPropertyDescriptor$1(t, r));
        });
    }
    return e;
}
/**
 * The Base Class for all edges.
 */ var $bebd28704f2536ea$var$EdgeBase = /*#__PURE__*/ function() {
    /**
   * Create a new instance.
   *
   * @param options - The options object of given edge.
   * @param _body - The body of the network.
   * @param _labelModule - Label module.
   */ function EdgeBase(options, _body, _labelModule) {
        $bebd28704f2536ea$var$_classCallCheck(this, EdgeBase);
        this._body = _body;
        this._labelModule = _labelModule;
        this.color = {};
        this.colorDirty = true;
        this.hoverWidth = 1.5;
        this.selectionWidth = 2;
        this.setOptions(options);
        this.fromPoint = this.from;
        this.toPoint = this.to;
    }
    /** @inheritDoc */ $bebd28704f2536ea$var$_createClass(EdgeBase, [
        {
            key: "connect",
            value: function connect() {
                this.from = this._body.nodes[this.options.from];
                this.to = this._body.nodes[this.options.to];
            }
        },
        {
            key: "cleanup",
            value: function cleanup() {
                return false;
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
                this.from = this._body.nodes[this.options.from];
                this.to = this._body.nodes[this.options.to];
                this.id = this.options.id;
            }
        },
        {
            key: "drawLine",
            value: function drawLine(ctx, values, _selected, _hover) {
                var viaNode = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.getViaNode();
                // set style
                ctx.strokeStyle = this.getColor(ctx, values);
                ctx.lineWidth = values.width;
                if (values.dashes !== false) this._drawDashedLine(ctx, values, viaNode);
                else this._drawLine(ctx, values, viaNode);
            }
        },
        {
            key: "_drawLine",
            value: function _drawLine(ctx, values, viaNode, fromPoint, toPoint) {
                if (this.from != this.to) // draw line
                this._line(ctx, values, viaNode, fromPoint, toPoint);
                else {
                    var _this$_getCircleData = this._getCircleData(ctx), _this$_getCircleData2 = $bebd28704f2536ea$var$_slicedToArray(_this$_getCircleData, 3), x = _this$_getCircleData2[0], y = _this$_getCircleData2[1], radius = _this$_getCircleData2[2];
                    this._circle(ctx, values, x, y, radius);
                }
            }
        },
        {
            key: "_drawDashedLine",
            value: function _drawDashedLine(ctx, values, viaNode, _fromPoint, _toPoint) {
                ctx.lineCap = "round";
                var pattern = $bebd28704f2536ea$var$_Array$isArray(values.dashes) ? values.dashes : [
                    5,
                    5
                ];
                // only firefox and chrome support this method, else we use the legacy one.
                if (ctx.setLineDash !== undefined) {
                    ctx.save();
                    // set dash settings for chrome or firefox
                    ctx.setLineDash(pattern);
                    ctx.lineDashOffset = 0;
                    // draw the line
                    if (this.from != this.to) // draw line
                    this._line(ctx, values, viaNode);
                    else {
                        var _this$_getCircleData3 = this._getCircleData(ctx), _this$_getCircleData4 = $bebd28704f2536ea$var$_slicedToArray(_this$_getCircleData3, 3), x = _this$_getCircleData4[0], y = _this$_getCircleData4[1], radius = _this$_getCircleData4[2];
                        this._circle(ctx, values, x, y, radius);
                    }
                    // restore the dash settings.
                    ctx.setLineDash([
                        0
                    ]);
                    ctx.lineDashOffset = 0;
                    ctx.restore();
                } else {
                    // unsupporting smooth lines
                    if (this.from != this.to) // draw line
                    $bebd28704f2536ea$var$drawDashedLine(ctx, this.from.x, this.from.y, this.to.x, this.to.y, pattern);
                    else {
                        var _this$_getCircleData5 = this._getCircleData(ctx), _this$_getCircleData6 = $bebd28704f2536ea$var$_slicedToArray(_this$_getCircleData5, 3), _x = _this$_getCircleData6[0], _y = _this$_getCircleData6[1], _radius = _this$_getCircleData6[2];
                        this._circle(ctx, values, _x, _y, _radius);
                    }
                    // draw shadow if enabled
                    this.enableShadow(ctx, values);
                    ctx.stroke();
                    // disable shadows for other elements.
                    this.disableShadow(ctx, values);
                }
            }
        },
        {
            key: "findBorderPosition",
            value: function findBorderPosition(node, ctx, options) {
                if (this.from != this.to) return this._findBorderPosition(node, ctx, options);
                else return this._findBorderPositionCircle(node, ctx, options);
            }
        },
        {
            key: "findBorderPositions",
            value: function findBorderPositions(ctx) {
                if (this.from != this.to) return {
                    from: this._findBorderPosition(this.from, ctx),
                    to: this._findBorderPosition(this.to, ctx)
                };
                else {
                    var _context;
                    var _this$_getCircleData$ = $bebd28704f2536ea$var$_sliceInstanceProperty(_context = this._getCircleData(ctx)).call(_context, 0, 2), _this$_getCircleData$2 = $bebd28704f2536ea$var$_slicedToArray(_this$_getCircleData$, 2), x = _this$_getCircleData$2[0], y = _this$_getCircleData$2[1];
                    return {
                        from: this._findBorderPositionCircle(this.from, ctx, {
                            x: x,
                            y: y,
                            low: 0.25,
                            high: 0.6,
                            direction: -1
                        }),
                        to: this._findBorderPositionCircle(this.from, ctx, {
                            x: x,
                            y: y,
                            low: 0.6,
                            high: 0.8,
                            direction: 1
                        })
                    };
                }
            }
        },
        {
            key: "_getCircleData",
            value: function _getCircleData(ctx) {
                var radius = this.options.selfReference.size;
                if (ctx !== undefined) {
                    if (this.from.shape.width === undefined) this.from.shape.resize(ctx);
                }
                // get circle coordinates
                var coordinates = $bebd28704f2536ea$var$getSelfRefCoordinates(ctx, this.options.selfReference.angle, radius, this.from);
                return [
                    coordinates.x,
                    coordinates.y,
                    radius
                ];
            }
        },
        {
            key: "_pointOnCircle",
            value: function _pointOnCircle(x, y, radius, position) {
                var angle = position * 2 * Math.PI;
                return {
                    x: x + radius * Math.cos(angle),
                    y: y - radius * Math.sin(angle)
                };
            }
        },
        {
            key: "_findBorderPositionCircle",
            value: function _findBorderPositionCircle(nearNode, ctx, options) {
                var x = options.x;
                var y = options.y;
                var low = options.low;
                var high = options.high;
                var direction = options.direction;
                var maxIterations = 10;
                var radius = this.options.selfReference.size;
                var threshold = 0.05;
                var pos;
                var middle = (low + high) * 0.5;
                var endPointOffset = 0;
                if (this.options.arrowStrikethrough === true) {
                    if (direction === -1) endPointOffset = this.options.endPointOffset.from;
                    else if (direction === 1) endPointOffset = this.options.endPointOffset.to;
                }
                var iteration = 0;
                do {
                    middle = (low + high) * 0.5;
                    pos = this._pointOnCircle(x, y, radius, middle);
                    var angle = Math.atan2(nearNode.y - pos.y, nearNode.x - pos.x);
                    var distanceToBorder = nearNode.distanceToBorder(ctx, angle) + endPointOffset;
                    var distanceToPoint = Math.sqrt(Math.pow(pos.x - nearNode.x, 2) + Math.pow(pos.y - nearNode.y, 2));
                    var difference = distanceToBorder - distanceToPoint;
                    if (Math.abs(difference) < threshold) break; // found
                    else if (difference > 0) {
                        // distance to nodes is larger than distance to border --> t needs to be bigger if we're looking at the to node.
                        if (direction > 0) low = middle;
                        else high = middle;
                    } else if (direction > 0) high = middle;
                    else low = middle;
                    ++iteration;
                }while (low <= high && iteration < maxIterations);
                return $bebd28704f2536ea$var$_objectSpread$1($bebd28704f2536ea$var$_objectSpread$1({}, pos), {}, {
                    t: middle
                });
            }
        },
        {
            key: "getLineWidth",
            value: function getLineWidth(selected, hover) {
                if (selected === true) return Math.max(this.selectionWidth, 0.3 / this._body.view.scale);
                else if (hover === true) return Math.max(this.hoverWidth, 0.3 / this._body.view.scale);
                else return Math.max(this.options.width, 0.3 / this._body.view.scale);
            }
        },
        {
            key: "getColor",
            value: function getColor(ctx, values) {
                if (values.inheritsColor !== false) {
                    // when this is a loop edge, just use the 'from' method
                    if (values.inheritsColor === "both" && this.from.id !== this.to.id) {
                        var grd = ctx.createLinearGradient(this.from.x, this.from.y, this.to.x, this.to.y);
                        var fromColor = this.from.options.color.highlight.border;
                        var toColor = this.to.options.color.highlight.border;
                        if (this.from.selected === false && this.to.selected === false) {
                            fromColor = $bebd28704f2536ea$var$overrideOpacity(this.from.options.color.border, values.opacity);
                            toColor = $bebd28704f2536ea$var$overrideOpacity(this.to.options.color.border, values.opacity);
                        } else if (this.from.selected === true && this.to.selected === false) toColor = this.to.options.color.border;
                        else if (this.from.selected === false && this.to.selected === true) fromColor = this.from.options.color.border;
                        grd.addColorStop(0, fromColor);
                        grd.addColorStop(1, toColor);
                        // -------------------- this returns -------------------- //
                        return grd;
                    }
                    if (values.inheritsColor === "to") return $bebd28704f2536ea$var$overrideOpacity(this.to.options.color.border, values.opacity);
                    else // "from"
                    return $bebd28704f2536ea$var$overrideOpacity(this.from.options.color.border, values.opacity);
                } else return $bebd28704f2536ea$var$overrideOpacity(values.color, values.opacity);
            }
        },
        {
            key: "_circle",
            value: function _circle(ctx, values, x, y, radius) {
                // draw shadow if enabled
                this.enableShadow(ctx, values);
                //full circle
                var angleFrom = 0;
                var angleTo = Math.PI * 2;
                if (!this.options.selfReference.renderBehindTheNode) {
                    //render only parts which are not overlaping with parent node
                    //need to find x,y of from point and x,y to point
                    //calculating radians
                    var low = this.options.selfReference.angle;
                    var high = this.options.selfReference.angle + Math.PI;
                    var pointTFrom = this._findBorderPositionCircle(this.from, ctx, {
                        x: x,
                        y: y,
                        low: low,
                        high: high,
                        direction: -1
                    });
                    var pointTTo = this._findBorderPositionCircle(this.from, ctx, {
                        x: x,
                        y: y,
                        low: low,
                        high: high,
                        direction: 1
                    });
                    angleFrom = Math.atan2(pointTFrom.y - y, pointTFrom.x - x);
                    angleTo = Math.atan2(pointTTo.y - y, pointTTo.x - x);
                }
                // draw a circle
                ctx.beginPath();
                ctx.arc(x, y, radius, angleFrom, angleTo, false);
                ctx.stroke();
                // disable shadows for other elements.
                this.disableShadow(ctx, values);
            }
        },
        {
            key: "getDistanceToEdge",
            value: function getDistanceToEdge(x1, y1, x2, y2, x3, y3) {
                if (this.from != this.to) return this._getDistanceToEdge(x1, y1, x2, y2, x3, y3);
                else {
                    var _this$_getCircleData7 = this._getCircleData(undefined), _this$_getCircleData8 = $bebd28704f2536ea$var$_slicedToArray(_this$_getCircleData7, 3), x = _this$_getCircleData8[0], y = _this$_getCircleData8[1], radius = _this$_getCircleData8[2];
                    var dx = x - x3;
                    var dy = y - y3;
                    return Math.abs(Math.sqrt(dx * dx + dy * dy) - radius);
                }
            }
        },
        {
            key: "_getDistanceToLine",
            value: function _getDistanceToLine(x1, y1, x2, y2, x3, y3) {
                var px = x2 - x1;
                var py = y2 - y1;
                var something = px * px + py * py;
                var u = ((x3 - x1) * px + (y3 - y1) * py) / something;
                if (u > 1) u = 1;
                else if (u < 0) u = 0;
                var x = x1 + u * px;
                var y = y1 + u * py;
                var dx = x - x3;
                var dy = y - y3;
                //# Note: If the actual distance does not matter,
                //# if you only want to compare what this function
                //# returns to other results of this function, you
                //# can just return the squared distance instead
                //# (i.e. remove the sqrt) to gain a little performance
                return Math.sqrt(dx * dx + dy * dy);
            }
        },
        {
            key: "getArrowData",
            value: function getArrowData(ctx, position, viaNode, _selected, _hover, values) {
                // set lets
                var angle;
                var arrowPoint;
                var node1;
                var node2;
                var reversed;
                var scaleFactor;
                var type;
                var lineWidth = values.width;
                if (position === "from") {
                    node1 = this.from;
                    node2 = this.to;
                    reversed = values.fromArrowScale < 0;
                    scaleFactor = Math.abs(values.fromArrowScale);
                    type = values.fromArrowType;
                } else if (position === "to") {
                    node1 = this.to;
                    node2 = this.from;
                    reversed = values.toArrowScale < 0;
                    scaleFactor = Math.abs(values.toArrowScale);
                    type = values.toArrowType;
                } else {
                    node1 = this.to;
                    node2 = this.from;
                    reversed = values.middleArrowScale < 0;
                    scaleFactor = Math.abs(values.middleArrowScale);
                    type = values.middleArrowType;
                }
                var length1 = 15 * scaleFactor + 3 * lineWidth; // 3* lineWidth is the width of the edge.
                // if not connected to itself
                if (node1 != node2) {
                    var approximateEdgeLength = $bebd28704f2536ea$var$_Math$hypot(node1.x - node2.x, node1.y - node2.y);
                    var relativeLength = length1 / approximateEdgeLength;
                    if (position !== "middle") {
                        // draw arrow head
                        if (this.options.smooth.enabled === true) {
                            var pointT = this._findBorderPosition(node1, ctx, {
                                via: viaNode
                            });
                            var guidePos = this.getPoint(pointT.t + relativeLength * (position === "from" ? 1 : -1), viaNode);
                            angle = Math.atan2(pointT.y - guidePos.y, pointT.x - guidePos.x);
                            arrowPoint = pointT;
                        } else {
                            angle = Math.atan2(node1.y - node2.y, node1.x - node2.x);
                            arrowPoint = this._findBorderPosition(node1, ctx);
                        }
                    } else {
                        // Negative half length reverses arrow direction.
                        var halfLength = (reversed ? -relativeLength : relativeLength) / 2;
                        var guidePos1 = this.getPoint(0.5 + halfLength, viaNode);
                        var guidePos2 = this.getPoint(0.5 - halfLength, viaNode);
                        angle = Math.atan2(guidePos1.y - guidePos2.y, guidePos1.x - guidePos2.x);
                        arrowPoint = this.getPoint(0.5, viaNode);
                    }
                } else {
                    // draw circle
                    var _this$_getCircleData9 = this._getCircleData(ctx), _this$_getCircleData10 = $bebd28704f2536ea$var$_slicedToArray(_this$_getCircleData9, 3), x = _this$_getCircleData10[0], y = _this$_getCircleData10[1], radius = _this$_getCircleData10[2];
                    if (position === "from") {
                        var low = this.options.selfReference.angle;
                        var high = this.options.selfReference.angle + Math.PI;
                        var _pointT = this._findBorderPositionCircle(this.from, ctx, {
                            x: x,
                            y: y,
                            low: low,
                            high: high,
                            direction: -1
                        });
                        angle = _pointT.t * -2 * Math.PI + 1.5 * Math.PI + 0.1 * Math.PI;
                        arrowPoint = _pointT;
                    } else if (position === "to") {
                        var _low = this.options.selfReference.angle;
                        var _high = this.options.selfReference.angle + Math.PI;
                        var _pointT2 = this._findBorderPositionCircle(this.from, ctx, {
                            x: x,
                            y: y,
                            low: _low,
                            high: _high,
                            direction: 1
                        });
                        angle = _pointT2.t * -2 * Math.PI + 1.5 * Math.PI - 1.1 * Math.PI;
                        arrowPoint = _pointT2;
                    } else {
                        var pos = this.options.selfReference.angle / (2 * Math.PI);
                        arrowPoint = this._pointOnCircle(x, y, radius, pos);
                        angle = pos * -2 * Math.PI + 1.5 * Math.PI + 0.1 * Math.PI;
                    }
                }
                var xi = arrowPoint.x - length1 * 0.9 * Math.cos(angle);
                var yi = arrowPoint.y - length1 * 0.9 * Math.sin(angle);
                var arrowCore = {
                    x: xi,
                    y: yi
                };
                return {
                    point: arrowPoint,
                    core: arrowCore,
                    angle: angle,
                    length: length1,
                    type: type
                };
            }
        },
        {
            key: "drawArrowHead",
            value: function drawArrowHead(ctx, values, _selected, _hover, arrowData) {
                // set style
                ctx.strokeStyle = this.getColor(ctx, values);
                ctx.fillStyle = ctx.strokeStyle;
                ctx.lineWidth = values.width;
                var canFill = $bebd28704f2536ea$var$EndPoints.draw(ctx, arrowData);
                if (canFill) {
                    // draw shadow if enabled
                    this.enableShadow(ctx, values);
                    $bebd28704f2536ea$var$_fillInstanceProperty(ctx).call(ctx);
                    // disable shadows for other elements.
                    this.disableShadow(ctx, values);
                }
            }
        },
        {
            key: "enableShadow",
            value: function enableShadow(ctx, values) {
                if (values.shadow === true) {
                    ctx.shadowColor = values.shadowColor;
                    ctx.shadowBlur = values.shadowSize;
                    ctx.shadowOffsetX = values.shadowX;
                    ctx.shadowOffsetY = values.shadowY;
                }
            }
        },
        {
            key: "disableShadow",
            value: function disableShadow(ctx, values) {
                if (values.shadow === true) {
                    ctx.shadowColor = "rgba(0,0,0,0)";
                    ctx.shadowBlur = 0;
                    ctx.shadowOffsetX = 0;
                    ctx.shadowOffsetY = 0;
                }
            }
        },
        {
            key: "drawBackground",
            value: function drawBackground(ctx, values) {
                if (values.background !== false) {
                    // save original line attrs
                    var origCtxAttr = {
                        strokeStyle: ctx.strokeStyle,
                        lineWidth: ctx.lineWidth,
                        dashes: ctx.dashes
                    };
                    ctx.strokeStyle = values.backgroundColor;
                    ctx.lineWidth = values.backgroundSize;
                    this.setStrokeDashed(ctx, values.backgroundDashes);
                    ctx.stroke();
                    // restore original line attrs
                    ctx.strokeStyle = origCtxAttr.strokeStyle;
                    ctx.lineWidth = origCtxAttr.lineWidth;
                    ctx.dashes = origCtxAttr.dashes;
                    this.setStrokeDashed(ctx, values.dashes);
                }
            }
        },
        {
            key: "setStrokeDashed",
            value: function setStrokeDashed(ctx, dashes) {
                if (dashes !== false) {
                    if (ctx.setLineDash !== undefined) {
                        var pattern = $bebd28704f2536ea$var$_Array$isArray(dashes) ? dashes : [
                            5,
                            5
                        ];
                        ctx.setLineDash(pattern);
                    } else console.warn("setLineDash is not supported in this browser. The dashed stroke cannot be used.");
                } else if (ctx.setLineDash !== undefined) ctx.setLineDash([]);
                else console.warn("setLineDash is not supported in this browser. The dashed stroke cannot be used.");
            }
        }
    ]);
    return EdgeBase;
}();
function $bebd28704f2536ea$var$ownKeys(e, r) {
    var t = $bebd28704f2536ea$var$_Object$keys(e);
    if ($bebd28704f2536ea$var$_Object$getOwnPropertySymbols) {
        var o = $bebd28704f2536ea$var$_Object$getOwnPropertySymbols(e);
        r && (o = $bebd28704f2536ea$var$_filterInstanceProperty(o).call(o, function(r) {
            return $bebd28704f2536ea$var$_Object$getOwnPropertyDescriptor$1(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bebd28704f2536ea$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var _context, _context2;
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bebd28704f2536ea$var$_forEachInstanceProperty(_context = $bebd28704f2536ea$var$ownKeys(Object(t), !0)).call(_context, function(r) {
            $bebd28704f2536ea$var$_defineProperty(e, r, t[r]);
        }) : $bebd28704f2536ea$var$_Object$getOwnPropertyDescriptors ? $bebd28704f2536ea$var$_Object$defineProperties(e, $bebd28704f2536ea$var$_Object$getOwnPropertyDescriptors(t)) : $bebd28704f2536ea$var$_forEachInstanceProperty(_context2 = $bebd28704f2536ea$var$ownKeys(Object(t))).call(_context2, function(r) {
            $bebd28704f2536ea$var$_Object$defineProperty(e, r, $bebd28704f2536ea$var$_Object$getOwnPropertyDescriptor$1(t, r));
        });
    }
    return e;
}
function $bebd28704f2536ea$var$_createSuper$9(Derived) {
    var hasNativeReflectConstruct = $bebd28704f2536ea$var$_isNativeReflectConstruct$9();
    return function _createSuperInternal() {
        var Super = $bebd28704f2536ea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bebd28704f2536ea$var$_getPrototypeOf(this).constructor;
            result = $bebd28704f2536ea$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bebd28704f2536ea$var$_possibleConstructorReturn(this, result);
    };
}
function $bebd28704f2536ea$var$_isNativeReflectConstruct$9() {
    if (typeof Reflect === "undefined" || !$bebd28704f2536ea$var$_Reflect$construct) return false;
    if ($bebd28704f2536ea$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($bebd28704f2536ea$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * The Base Class for all Bezier edges.
 * Bezier curves are used to model smooth gradual curves in paths between nodes.
 */ var $bebd28704f2536ea$var$BezierEdgeBase = /*#__PURE__*/ function(_EdgeBase) {
    $bebd28704f2536ea$var$_inherits(BezierEdgeBase, _EdgeBase);
    var _super = $bebd28704f2536ea$var$_createSuper$9(BezierEdgeBase);
    /**
   * Create a new instance.
   *
   * @param options - The options object of given edge.
   * @param body - The body of the network.
   * @param labelModule - Label module.
   */ function BezierEdgeBase(options, body, labelModule) {
        $bebd28704f2536ea$var$_classCallCheck(this, BezierEdgeBase);
        return _super.call(this, options, body, labelModule);
    }
    /**
   * Find the intersection between the border of the node and the edge.
   *
   * @remarks
   * This function uses binary search to look for the point where the bezier curve crosses the border of the node.
   * @param nearNode - The node (either from or to node of the edge).
   * @param ctx - The context that will be used for rendering.
   * @param viaNode - Additional node(s) the edge passes through.
   * @returns Cartesian coordinates of the intersection between the border of the node and the edge.
   */ $bebd28704f2536ea$var$_createClass(BezierEdgeBase, [
        {
            key: "_findBorderPositionBezier",
            value: function _findBorderPositionBezier(nearNode, ctx) {
                var viaNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this._getViaCoordinates();
                var maxIterations = 10;
                var threshold = 0.2;
                var from = false;
                var high = 1;
                var low = 0;
                var node = this.to;
                var pos;
                var middle;
                var endPointOffset = this.options.endPointOffset ? this.options.endPointOffset.to : 0;
                if (nearNode.id === this.from.id) {
                    node = this.from;
                    from = true;
                    endPointOffset = this.options.endPointOffset ? this.options.endPointOffset.from : 0;
                }
                if (this.options.arrowStrikethrough === false) endPointOffset = 0;
                var iteration = 0;
                do {
                    middle = (low + high) * 0.5;
                    pos = this.getPoint(middle, viaNode);
                    var angle = Math.atan2(node.y - pos.y, node.x - pos.x);
                    var distanceToBorder = node.distanceToBorder(ctx, angle) + endPointOffset;
                    var distanceToPoint = Math.sqrt(Math.pow(pos.x - node.x, 2) + Math.pow(pos.y - node.y, 2));
                    var difference = distanceToBorder - distanceToPoint;
                    if (Math.abs(difference) < threshold) break; // found
                    else if (difference < 0) {
                        // distance to nodes is larger than distance to border --> t needs to be bigger if we're looking at the to node.
                        if (from === false) low = middle;
                        else high = middle;
                    } else if (from === false) high = middle;
                    else low = middle;
                    ++iteration;
                }while (low <= high && iteration < maxIterations);
                return $bebd28704f2536ea$var$_objectSpread($bebd28704f2536ea$var$_objectSpread({}, pos), {}, {
                    t: middle
                });
            }
        },
        {
            key: "_getDistanceToBezierEdge",
            value: function _getDistanceToBezierEdge(x1, y1, x2, y2, x3, y3, via) {
                // x3,y3 is the point
                var minDistance = 1e9;
                var distance;
                var i, t, x, y;
                var lastX = x1;
                var lastY = y1;
                for(i = 1; i < 10; i++){
                    t = 0.1 * i;
                    x = Math.pow(1 - t, 2) * x1 + 2 * t * (1 - t) * via.x + Math.pow(t, 2) * x2;
                    y = Math.pow(1 - t, 2) * y1 + 2 * t * (1 - t) * via.y + Math.pow(t, 2) * y2;
                    if (i > 0) {
                        distance = this._getDistanceToLine(lastX, lastY, x, y, x3, y3);
                        minDistance = distance < minDistance ? distance : minDistance;
                    }
                    lastX = x;
                    lastY = y;
                }
                return minDistance;
            }
        },
        {
            key: "_bezierCurve",
            value: function _bezierCurve(ctx, values, viaNode1, viaNode2) {
                ctx.beginPath();
                ctx.moveTo(this.fromPoint.x, this.fromPoint.y);
                if (viaNode1 != null && viaNode1.x != null) {
                    if (viaNode2 != null && viaNode2.x != null) ctx.bezierCurveTo(viaNode1.x, viaNode1.y, viaNode2.x, viaNode2.y, this.toPoint.x, this.toPoint.y);
                    else ctx.quadraticCurveTo(viaNode1.x, viaNode1.y, this.toPoint.x, this.toPoint.y);
                } else // fallback to normal straight edge
                ctx.lineTo(this.toPoint.x, this.toPoint.y);
                // draw a background
                this.drawBackground(ctx, values);
                // draw shadow if enabled
                this.enableShadow(ctx, values);
                ctx.stroke();
                this.disableShadow(ctx, values);
            }
        },
        {
            key: "getViaNode",
            value: function getViaNode() {
                return this._getViaCoordinates();
            }
        }
    ]);
    return BezierEdgeBase;
}($bebd28704f2536ea$var$EdgeBase);
function $bebd28704f2536ea$var$_createSuper$8(Derived) {
    var hasNativeReflectConstruct = $bebd28704f2536ea$var$_isNativeReflectConstruct$8();
    return function _createSuperInternal() {
        var Super = $bebd28704f2536ea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bebd28704f2536ea$var$_getPrototypeOf(this).constructor;
            result = $bebd28704f2536ea$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bebd28704f2536ea$var$_possibleConstructorReturn(this, result);
    };
}
function $bebd28704f2536ea$var$_isNativeReflectConstruct$8() {
    if (typeof Reflect === "undefined" || !$bebd28704f2536ea$var$_Reflect$construct) return false;
    if ($bebd28704f2536ea$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($bebd28704f2536ea$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * A Dynamic Bezier Edge. Bezier curves are used to model smooth gradual
 * curves in paths between nodes. The Dynamic piece refers to how the curve
 * reacts to physics changes.
 *
 * @augments BezierEdgeBase
 */ var $bebd28704f2536ea$var$BezierEdgeDynamic = /*#__PURE__*/ function(_BezierEdgeBase) {
    $bebd28704f2536ea$var$_inherits(BezierEdgeDynamic, _BezierEdgeBase);
    var _super = $bebd28704f2536ea$var$_createSuper$8(BezierEdgeDynamic);
    /**
   * Create a new instance.
   *
   * @param options - The options object of given edge.
   * @param body - The body of the network.
   * @param labelModule - Label module.
   */ function BezierEdgeDynamic(options, body, labelModule) {
        var _this;
        $bebd28704f2536ea$var$_classCallCheck(this, BezierEdgeDynamic);
        //this.via = undefined; // Here for completeness but not allowed to defined before super() is invoked.
        _this = _super.call(this, options, body, labelModule); // --> this calls the setOptions below
        _this.via = _this.via; // constructor → super → super → setOptions → setupSupportNode
        _this._boundFunction = function() {
            _this.positionBezierNode();
        };
        _this._body.emitter.on("_repositionBezierNodes", _this._boundFunction);
        return _this;
    }
    /** @inheritDoc */ $bebd28704f2536ea$var$_createClass(BezierEdgeDynamic, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                $bebd28704f2536ea$var$_get($bebd28704f2536ea$var$_getPrototypeOf(BezierEdgeDynamic.prototype), "setOptions", this).call(this, options);
                // check if the physics has changed.
                var physicsChange = false;
                if (this.options.physics !== options.physics) physicsChange = true;
                // set the options and the to and from nodes
                this.options = options;
                this.id = this.options.id;
                this.from = this._body.nodes[this.options.from];
                this.to = this._body.nodes[this.options.to];
                // setup the support node and connect
                this.setupSupportNode();
                this.connect();
                // when we change the physics state of the edge, we reposition the support node.
                if (physicsChange === true) {
                    this.via.setOptions({
                        physics: this.options.physics
                    });
                    this.positionBezierNode();
                }
            }
        },
        {
            key: "connect",
            value: function connect() {
                this.from = this._body.nodes[this.options.from];
                this.to = this._body.nodes[this.options.to];
                if (this.from === undefined || this.to === undefined || this.options.physics === false) this.via.setOptions({
                    physics: false
                });
                else // fix weird behaviour where a self referencing node has physics enabled
                if (this.from.id === this.to.id) this.via.setOptions({
                    physics: false
                });
                else this.via.setOptions({
                    physics: true
                });
            }
        },
        {
            key: "cleanup",
            value: function cleanup() {
                this._body.emitter.off("_repositionBezierNodes", this._boundFunction);
                if (this.via !== undefined) {
                    delete this._body.nodes[this.via.id];
                    this.via = undefined;
                    return true;
                }
                return false;
            }
        },
        {
            key: "setupSupportNode",
            value: function setupSupportNode() {
                if (this.via === undefined) {
                    var nodeId = "edgeId:" + this.id;
                    var node = this._body.functions.createNode({
                        id: nodeId,
                        shape: "circle",
                        physics: true,
                        hidden: true
                    });
                    this._body.nodes[nodeId] = node;
                    this.via = node;
                    this.via.parentEdgeId = this.id;
                    this.positionBezierNode();
                }
            }
        },
        {
            key: "positionBezierNode",
            value: function positionBezierNode() {
                if (this.via !== undefined && this.from !== undefined && this.to !== undefined) {
                    this.via.x = 0.5 * (this.from.x + this.to.x);
                    this.via.y = 0.5 * (this.from.y + this.to.y);
                } else if (this.via !== undefined) {
                    this.via.x = 0;
                    this.via.y = 0;
                }
            }
        },
        {
            key: "_line",
            value: function _line(ctx, values, viaNode) {
                this._bezierCurve(ctx, values, viaNode);
            }
        },
        {
            key: "_getViaCoordinates",
            value: function _getViaCoordinates() {
                return this.via;
            }
        },
        {
            key: "getViaNode",
            value: function getViaNode() {
                return this.via;
            }
        },
        {
            key: "getPoint",
            value: function getPoint(position) {
                var viaNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.via;
                if (this.from === this.to) {
                    var _this$_getCircleData = this._getCircleData(), _this$_getCircleData2 = $bebd28704f2536ea$var$_slicedToArray(_this$_getCircleData, 3), cx = _this$_getCircleData2[0], cy = _this$_getCircleData2[1], cr = _this$_getCircleData2[2];
                    var a = 2 * Math.PI * (1 - position);
                    return {
                        x: cx + cr * Math.sin(a),
                        y: cy + cr - cr * (1 - Math.cos(a))
                    };
                } else return {
                    x: Math.pow(1 - position, 2) * this.fromPoint.x + 2 * position * (1 - position) * viaNode.x + Math.pow(position, 2) * this.toPoint.x,
                    y: Math.pow(1 - position, 2) * this.fromPoint.y + 2 * position * (1 - position) * viaNode.y + Math.pow(position, 2) * this.toPoint.y
                };
            }
        },
        {
            key: "_findBorderPosition",
            value: function _findBorderPosition(nearNode, ctx) {
                return this._findBorderPositionBezier(nearNode, ctx, this.via);
            }
        },
        {
            key: "_getDistanceToEdge",
            value: function _getDistanceToEdge(x1, y1, x2, y2, x3, y3) {
                // x3,y3 is the point
                return this._getDistanceToBezierEdge(x1, y1, x2, y2, x3, y3, this.via);
            }
        }
    ]);
    return BezierEdgeDynamic;
}($bebd28704f2536ea$var$BezierEdgeBase);
function $bebd28704f2536ea$var$_createSuper$7(Derived) {
    var hasNativeReflectConstruct = $bebd28704f2536ea$var$_isNativeReflectConstruct$7();
    return function _createSuperInternal() {
        var Super = $bebd28704f2536ea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bebd28704f2536ea$var$_getPrototypeOf(this).constructor;
            result = $bebd28704f2536ea$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bebd28704f2536ea$var$_possibleConstructorReturn(this, result);
    };
}
function $bebd28704f2536ea$var$_isNativeReflectConstruct$7() {
    if (typeof Reflect === "undefined" || !$bebd28704f2536ea$var$_Reflect$construct) return false;
    if ($bebd28704f2536ea$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($bebd28704f2536ea$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * A Static Bezier Edge. Bezier curves are used to model smooth gradual curves in paths between nodes.
 */ var $bebd28704f2536ea$var$BezierEdgeStatic = /*#__PURE__*/ function(_BezierEdgeBase) {
    $bebd28704f2536ea$var$_inherits(BezierEdgeStatic, _BezierEdgeBase);
    var _super = $bebd28704f2536ea$var$_createSuper$7(BezierEdgeStatic);
    /**
   * Create a new instance.
   *
   * @param options - The options object of given edge.
   * @param body - The body of the network.
   * @param labelModule - Label module.
   */ function BezierEdgeStatic(options, body, labelModule) {
        $bebd28704f2536ea$var$_classCallCheck(this, BezierEdgeStatic);
        return _super.call(this, options, body, labelModule);
    }
    /** @inheritDoc */ $bebd28704f2536ea$var$_createClass(BezierEdgeStatic, [
        {
            key: "_line",
            value: function _line(ctx, values, viaNode) {
                this._bezierCurve(ctx, values, viaNode);
            }
        },
        {
            key: "getViaNode",
            value: function getViaNode() {
                return this._getViaCoordinates();
            }
        },
        {
            key: "_getViaCoordinates",
            value: function _getViaCoordinates() {
                // Assumption: x/y coordinates in from/to always defined
                var factor = this.options.smooth.roundness;
                var type = this.options.smooth.type;
                var dx = Math.abs(this.from.x - this.to.x);
                var dy = Math.abs(this.from.y - this.to.y);
                if (type === "discrete" || type === "diagonalCross") {
                    var stepX;
                    var stepY;
                    if (dx <= dy) stepX = stepY = factor * dy;
                    else stepX = stepY = factor * dx;
                    if (this.from.x > this.to.x) stepX = -stepX;
                    if (this.from.y >= this.to.y) stepY = -stepY;
                    var xVia = this.from.x + stepX;
                    var yVia = this.from.y + stepY;
                    if (type === "discrete") {
                        if (dx <= dy) xVia = dx < factor * dy ? this.from.x : xVia;
                        else yVia = dy < factor * dx ? this.from.y : yVia;
                    }
                    return {
                        x: xVia,
                        y: yVia
                    };
                } else if (type === "straightCross") {
                    var _stepX = (1 - factor) * dx;
                    var _stepY = (1 - factor) * dy;
                    if (dx <= dy) {
                        // up - down
                        _stepX = 0;
                        if (this.from.y < this.to.y) _stepY = -_stepY;
                    } else {
                        // left - right
                        if (this.from.x < this.to.x) _stepX = -_stepX;
                        _stepY = 0;
                    }
                    return {
                        x: this.to.x + _stepX,
                        y: this.to.y + _stepY
                    };
                } else if (type === "horizontal") {
                    var _stepX2 = (1 - factor) * dx;
                    if (this.from.x < this.to.x) _stepX2 = -_stepX2;
                    return {
                        x: this.to.x + _stepX2,
                        y: this.from.y
                    };
                } else if (type === "vertical") {
                    var _stepY2 = (1 - factor) * dy;
                    if (this.from.y < this.to.y) _stepY2 = -_stepY2;
                    return {
                        x: this.from.x,
                        y: this.to.y + _stepY2
                    };
                } else if (type === "curvedCW") {
                    dx = this.to.x - this.from.x;
                    dy = this.from.y - this.to.y;
                    var radius = Math.sqrt(dx * dx + dy * dy);
                    var pi = Math.PI;
                    var originalAngle = Math.atan2(dy, dx);
                    var myAngle = (originalAngle + (factor * 0.5 + 0.5) * pi) % (2 * pi);
                    return {
                        x: this.from.x + (factor * 0.5 + 0.5) * radius * Math.sin(myAngle),
                        y: this.from.y + (factor * 0.5 + 0.5) * radius * Math.cos(myAngle)
                    };
                } else if (type === "curvedCCW") {
                    dx = this.to.x - this.from.x;
                    dy = this.from.y - this.to.y;
                    var _radius = Math.sqrt(dx * dx + dy * dy);
                    var _pi = Math.PI;
                    var _originalAngle = Math.atan2(dy, dx);
                    var _myAngle = (_originalAngle + (-factor * 0.5 + 0.5) * _pi) % (2 * _pi);
                    return {
                        x: this.from.x + (factor * 0.5 + 0.5) * _radius * Math.sin(_myAngle),
                        y: this.from.y + (factor * 0.5 + 0.5) * _radius * Math.cos(_myAngle)
                    };
                } else {
                    // continuous
                    var _stepX3;
                    var _stepY3;
                    if (dx <= dy) _stepX3 = _stepY3 = factor * dy;
                    else _stepX3 = _stepY3 = factor * dx;
                    if (this.from.x > this.to.x) _stepX3 = -_stepX3;
                    if (this.from.y >= this.to.y) _stepY3 = -_stepY3;
                    var _xVia = this.from.x + _stepX3;
                    var _yVia = this.from.y + _stepY3;
                    if (dx <= dy) {
                        if (this.from.x <= this.to.x) _xVia = this.to.x < _xVia ? this.to.x : _xVia;
                        else _xVia = this.to.x > _xVia ? this.to.x : _xVia;
                    } else if (this.from.y >= this.to.y) _yVia = this.to.y > _yVia ? this.to.y : _yVia;
                    else _yVia = this.to.y < _yVia ? this.to.y : _yVia;
                    return {
                        x: _xVia,
                        y: _yVia
                    };
                }
            }
        },
        {
            key: "_findBorderPosition",
            value: function _findBorderPosition(nearNode, ctx) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return this._findBorderPositionBezier(nearNode, ctx, options.via);
            }
        },
        {
            key: "_getDistanceToEdge",
            value: function _getDistanceToEdge(x1, y1, x2, y2, x3, y3) {
                var viaNode = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : this._getViaCoordinates();
                // x3,y3 is the point
                return this._getDistanceToBezierEdge(x1, y1, x2, y2, x3, y3, viaNode);
            }
        },
        {
            key: "getPoint",
            value: function getPoint(position) {
                var viaNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._getViaCoordinates();
                var t = position;
                var x = Math.pow(1 - t, 2) * this.fromPoint.x + 2 * t * (1 - t) * viaNode.x + Math.pow(t, 2) * this.toPoint.x;
                var y = Math.pow(1 - t, 2) * this.fromPoint.y + 2 * t * (1 - t) * viaNode.y + Math.pow(t, 2) * this.toPoint.y;
                return {
                    x: x,
                    y: y
                };
            }
        }
    ]);
    return BezierEdgeStatic;
}($bebd28704f2536ea$var$BezierEdgeBase);
function $bebd28704f2536ea$var$_createSuper$6(Derived) {
    var hasNativeReflectConstruct = $bebd28704f2536ea$var$_isNativeReflectConstruct$6();
    return function _createSuperInternal() {
        var Super = $bebd28704f2536ea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bebd28704f2536ea$var$_getPrototypeOf(this).constructor;
            result = $bebd28704f2536ea$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bebd28704f2536ea$var$_possibleConstructorReturn(this, result);
    };
}
function $bebd28704f2536ea$var$_isNativeReflectConstruct$6() {
    if (typeof Reflect === "undefined" || !$bebd28704f2536ea$var$_Reflect$construct) return false;
    if ($bebd28704f2536ea$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($bebd28704f2536ea$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * A Base Class for all Cubic Bezier Edges. Bezier curves are used to model
 * smooth gradual curves in paths between nodes.
 *
 * @augments BezierEdgeBase
 */ var $bebd28704f2536ea$var$CubicBezierEdgeBase = /*#__PURE__*/ function(_BezierEdgeBase) {
    $bebd28704f2536ea$var$_inherits(CubicBezierEdgeBase, _BezierEdgeBase);
    var _super = $bebd28704f2536ea$var$_createSuper$6(CubicBezierEdgeBase);
    /**
   * Create a new instance.
   *
   * @param options - The options object of given edge.
   * @param body - The body of the network.
   * @param labelModule - Label module.
   */ function CubicBezierEdgeBase(options, body, labelModule) {
        $bebd28704f2536ea$var$_classCallCheck(this, CubicBezierEdgeBase);
        return _super.call(this, options, body, labelModule);
    }
    /**
   * Calculate the distance between a point (x3,y3) and a line segment from (x1,y1) to (x2,y2).
   *
   * @remarks
   * http://stackoverflow.com/questions/849211/shortest-distancae-between-a-point-and-a-line-segment
   * https://en.wikipedia.org/wiki/B%C3%A9zier_curve
   * @param x1 - First end of the line segment on the x axis.
   * @param y1 - First end of the line segment on the y axis.
   * @param x2 - Second end of the line segment on the x axis.
   * @param y2 - Second end of the line segment on the y axis.
   * @param x3 - Position of the point on the x axis.
   * @param y3 - Position of the point on the y axis.
   * @param via1 - The first point this edge passes through.
   * @param via2 - The second point this edge passes through.
   * @returns The distance between the line segment and the point.
   */ $bebd28704f2536ea$var$_createClass(CubicBezierEdgeBase, [
        {
            key: "_getDistanceToBezierEdge2",
            value: function _getDistanceToBezierEdge2(x1, y1, x2, y2, x3, y3, via1, via2) {
                // x3,y3 is the point
                var minDistance = 1e9;
                var lastX = x1;
                var lastY = y1;
                var vec = [
                    0,
                    0,
                    0,
                    0
                ];
                for(var i = 1; i < 10; i++){
                    var t = 0.1 * i;
                    vec[0] = Math.pow(1 - t, 3);
                    vec[1] = 3 * t * Math.pow(1 - t, 2);
                    vec[2] = 3 * Math.pow(t, 2) * (1 - t);
                    vec[3] = Math.pow(t, 3);
                    var x = vec[0] * x1 + vec[1] * via1.x + vec[2] * via2.x + vec[3] * x2;
                    var y = vec[0] * y1 + vec[1] * via1.y + vec[2] * via2.y + vec[3] * y2;
                    if (i > 0) {
                        var distance = this._getDistanceToLine(lastX, lastY, x, y, x3, y3);
                        minDistance = distance < minDistance ? distance : minDistance;
                    }
                    lastX = x;
                    lastY = y;
                }
                return minDistance;
            }
        }
    ]);
    return CubicBezierEdgeBase;
}($bebd28704f2536ea$var$BezierEdgeBase);
function $bebd28704f2536ea$var$_createSuper$5(Derived) {
    var hasNativeReflectConstruct = $bebd28704f2536ea$var$_isNativeReflectConstruct$5();
    return function _createSuperInternal() {
        var Super = $bebd28704f2536ea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bebd28704f2536ea$var$_getPrototypeOf(this).constructor;
            result = $bebd28704f2536ea$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bebd28704f2536ea$var$_possibleConstructorReturn(this, result);
    };
}
function $bebd28704f2536ea$var$_isNativeReflectConstruct$5() {
    if (typeof Reflect === "undefined" || !$bebd28704f2536ea$var$_Reflect$construct) return false;
    if ($bebd28704f2536ea$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($bebd28704f2536ea$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * A Cubic Bezier Edge. Bezier curves are used to model smooth gradual curves in paths between nodes.
 */ var $bebd28704f2536ea$var$CubicBezierEdge = /*#__PURE__*/ function(_CubicBezierEdgeBase) {
    $bebd28704f2536ea$var$_inherits(CubicBezierEdge, _CubicBezierEdgeBase);
    var _super = $bebd28704f2536ea$var$_createSuper$5(CubicBezierEdge);
    /**
   * Create a new instance.
   *
   * @param options - The options object of given edge.
   * @param body - The body of the network.
   * @param labelModule - Label module.
   */ function CubicBezierEdge(options, body, labelModule) {
        $bebd28704f2536ea$var$_classCallCheck(this, CubicBezierEdge);
        return _super.call(this, options, body, labelModule);
    }
    /** @inheritDoc */ $bebd28704f2536ea$var$_createClass(CubicBezierEdge, [
        {
            key: "_line",
            value: function _line(ctx, values, viaNodes) {
                // get the coordinates of the support points.
                var via1 = viaNodes[0];
                var via2 = viaNodes[1];
                this._bezierCurve(ctx, values, via1, via2);
            }
        },
        {
            key: "_getViaCoordinates",
            value: function _getViaCoordinates() {
                var dx = this.from.x - this.to.x;
                var dy = this.from.y - this.to.y;
                var x1;
                var y1;
                var x2;
                var y2;
                var roundness = this.options.smooth.roundness;
                // horizontal if x > y or if direction is forced or if direction is horizontal
                if ((Math.abs(dx) > Math.abs(dy) || this.options.smooth.forceDirection === true || this.options.smooth.forceDirection === "horizontal") && this.options.smooth.forceDirection !== "vertical") {
                    y1 = this.from.y;
                    y2 = this.to.y;
                    x1 = this.from.x - roundness * dx;
                    x2 = this.to.x + roundness * dx;
                } else {
                    y1 = this.from.y - roundness * dy;
                    y2 = this.to.y + roundness * dy;
                    x1 = this.from.x;
                    x2 = this.to.x;
                }
                return [
                    {
                        x: x1,
                        y: y1
                    },
                    {
                        x: x2,
                        y: y2
                    }
                ];
            }
        },
        {
            key: "getViaNode",
            value: function getViaNode() {
                return this._getViaCoordinates();
            }
        },
        {
            key: "_findBorderPosition",
            value: function _findBorderPosition(nearNode, ctx) {
                return this._findBorderPositionBezier(nearNode, ctx);
            }
        },
        {
            key: "_getDistanceToEdge",
            value: function _getDistanceToEdge(x1, y1, x2, y2, x3, y3) {
                var _ref = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : this._getViaCoordinates(), _ref2 = $bebd28704f2536ea$var$_slicedToArray(_ref, 2), via1 = _ref2[0], via2 = _ref2[1];
                // x3,y3 is the point
                return this._getDistanceToBezierEdge2(x1, y1, x2, y2, x3, y3, via1, via2);
            }
        },
        {
            key: "getPoint",
            value: function getPoint(position) {
                var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._getViaCoordinates(), _ref4 = $bebd28704f2536ea$var$_slicedToArray(_ref3, 2), via1 = _ref4[0], via2 = _ref4[1];
                var t = position;
                var vec = [
                    Math.pow(1 - t, 3),
                    3 * t * Math.pow(1 - t, 2),
                    3 * Math.pow(t, 2) * (1 - t),
                    Math.pow(t, 3)
                ];
                var x = vec[0] * this.fromPoint.x + vec[1] * via1.x + vec[2] * via2.x + vec[3] * this.toPoint.x;
                var y = vec[0] * this.fromPoint.y + vec[1] * via1.y + vec[2] * via2.y + vec[3] * this.toPoint.y;
                return {
                    x: x,
                    y: y
                };
            }
        }
    ]);
    return CubicBezierEdge;
}($bebd28704f2536ea$var$CubicBezierEdgeBase);
function $bebd28704f2536ea$var$_createSuper$4(Derived) {
    var hasNativeReflectConstruct = $bebd28704f2536ea$var$_isNativeReflectConstruct$4();
    return function _createSuperInternal() {
        var Super = $bebd28704f2536ea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bebd28704f2536ea$var$_getPrototypeOf(this).constructor;
            result = $bebd28704f2536ea$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bebd28704f2536ea$var$_possibleConstructorReturn(this, result);
    };
}
function $bebd28704f2536ea$var$_isNativeReflectConstruct$4() {
    if (typeof Reflect === "undefined" || !$bebd28704f2536ea$var$_Reflect$construct) return false;
    if ($bebd28704f2536ea$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($bebd28704f2536ea$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * A Straight Edge.
 */ var $bebd28704f2536ea$var$StraightEdge = /*#__PURE__*/ function(_EdgeBase) {
    $bebd28704f2536ea$var$_inherits(StraightEdge, _EdgeBase);
    var _super = $bebd28704f2536ea$var$_createSuper$4(StraightEdge);
    /**
   * Create a new instance.
   *
   * @param options - The options object of given edge.
   * @param body - The body of the network.
   * @param labelModule - Label module.
   */ function StraightEdge(options, body, labelModule) {
        $bebd28704f2536ea$var$_classCallCheck(this, StraightEdge);
        return _super.call(this, options, body, labelModule);
    }
    /** @inheritDoc */ $bebd28704f2536ea$var$_createClass(StraightEdge, [
        {
            key: "_line",
            value: function _line(ctx, values) {
                // draw a straight line
                ctx.beginPath();
                ctx.moveTo(this.fromPoint.x, this.fromPoint.y);
                ctx.lineTo(this.toPoint.x, this.toPoint.y);
                // draw shadow if enabled
                this.enableShadow(ctx, values);
                ctx.stroke();
                this.disableShadow(ctx, values);
            }
        },
        {
            key: "getViaNode",
            value: function getViaNode() {
                return undefined;
            }
        },
        {
            key: "getPoint",
            value: function getPoint(position) {
                return {
                    x: (1 - position) * this.fromPoint.x + position * this.toPoint.x,
                    y: (1 - position) * this.fromPoint.y + position * this.toPoint.y
                };
            }
        },
        {
            key: "_findBorderPosition",
            value: function _findBorderPosition(nearNode, ctx) {
                var node1 = this.to;
                var node2 = this.from;
                if (nearNode.id === this.from.id) {
                    node1 = this.from;
                    node2 = this.to;
                }
                var angle = Math.atan2(node1.y - node2.y, node1.x - node2.x);
                var dx = node1.x - node2.x;
                var dy = node1.y - node2.y;
                var edgeSegmentLength = Math.sqrt(dx * dx + dy * dy);
                var toBorderDist = nearNode.distanceToBorder(ctx, angle);
                var toBorderPoint = (edgeSegmentLength - toBorderDist) / edgeSegmentLength;
                return {
                    x: (1 - toBorderPoint) * node2.x + toBorderPoint * node1.x,
                    y: (1 - toBorderPoint) * node2.y + toBorderPoint * node1.y,
                    t: 0
                };
            }
        },
        {
            key: "_getDistanceToEdge",
            value: function _getDistanceToEdge(x1, y1, x2, y2, x3, y3) {
                // x3,y3 is the point
                return this._getDistanceToLine(x1, y1, x2, y2, x3, y3);
            }
        }
    ]);
    return StraightEdge;
}($bebd28704f2536ea$var$EdgeBase);
/**
 * An edge connects two nodes and has a specific direction.
 */ var $bebd28704f2536ea$var$Edge = /*#__PURE__*/ function() {
    /**
   * @param {object} options        values specific to this edge, must contain at least 'from' and 'to'
   * @param {object} body           shared state from Network instance
   * @param {Network.Images} imagelist  A list with images. Only needed when the edge has image arrows.
   * @param {object} globalOptions  options from the EdgesHandler instance
   * @param {object} defaultOptions default options from the EdgeHandler instance. Value and reference are constant
   */ function Edge(options, body, imagelist, globalOptions, defaultOptions) {
        $bebd28704f2536ea$var$_classCallCheck(this, Edge);
        if (body === undefined) throw new Error("No body provided");
        // Since globalOptions is constant in values as well as reference,
        // Following needs to be done only once.
        this.options = $bebd28704f2536ea$var$bridgeObject(globalOptions);
        this.globalOptions = globalOptions;
        this.defaultOptions = defaultOptions;
        this.body = body;
        this.imagelist = imagelist;
        // initialize variables
        this.id = undefined;
        this.fromId = undefined;
        this.toId = undefined;
        this.selected = false;
        this.hover = false;
        this.labelDirty = true;
        this.baseWidth = this.options.width;
        this.baseFontSize = this.options.font.size;
        this.from = undefined; // a node
        this.to = undefined; // a node
        this.edgeType = undefined;
        this.connected = false;
        this.labelModule = new $bebd28704f2536ea$var$Label(this.body, this.options, true);
        this.setOptions(options);
    }
    /**
   * Set or overwrite options for the edge
   *
   * @param {object} options  an object with options
   * @returns {undefined|boolean} undefined if no options, true if layout affecting data changed, false otherwise.
   */ $bebd28704f2536ea$var$_createClass(Edge, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                if (!options) return;
                // Following options if changed affect the layout.
                var affectsLayout = typeof options.physics !== "undefined" && this.options.physics !== options.physics || typeof options.hidden !== "undefined" && (this.options.hidden || false) !== (options.hidden || false) || typeof options.from !== "undefined" && this.options.from !== options.from || typeof options.to !== "undefined" && this.options.to !== options.to;
                Edge.parseOptions(this.options, options, true, this.globalOptions);
                if (options.id !== undefined) this.id = options.id;
                if (options.from !== undefined) this.fromId = options.from;
                if (options.to !== undefined) this.toId = options.to;
                if (options.title !== undefined) this.title = options.title;
                if (options.value !== undefined) options.value = $bebd28704f2536ea$var$_parseFloat$1(options.value);
                var pile = [
                    options,
                    this.options,
                    this.defaultOptions
                ];
                this.chooser = $bebd28704f2536ea$var$choosify("edge", pile);
                // update label Module
                this.updateLabelModule(options);
                // Update edge type, this if changed affects the layout.
                affectsLayout = this.updateEdgeType() || affectsLayout;
                // if anything has been updates, reset the selection width and the hover width
                this._setInteractionWidths();
                // A node is connected when it has a from and to node that both exist in the network.body.nodes.
                this.connect();
                return affectsLayout;
            }
        },
        {
            key: "getFormattingValues",
            value: /**
     *
     * @returns {ArrowOptions}
     */ function getFormattingValues() {
                var toArrow = this.options.arrows.to === true || this.options.arrows.to.enabled === true;
                var fromArrow = this.options.arrows.from === true || this.options.arrows.from.enabled === true;
                var middleArrow = this.options.arrows.middle === true || this.options.arrows.middle.enabled === true;
                var inheritsColor = this.options.color.inherit;
                var values = {
                    toArrow: toArrow,
                    toArrowScale: this.options.arrows.to.scaleFactor,
                    toArrowType: this.options.arrows.to.type,
                    toArrowSrc: this.options.arrows.to.src,
                    toArrowImageWidth: this.options.arrows.to.imageWidth,
                    toArrowImageHeight: this.options.arrows.to.imageHeight,
                    middleArrow: middleArrow,
                    middleArrowScale: this.options.arrows.middle.scaleFactor,
                    middleArrowType: this.options.arrows.middle.type,
                    middleArrowSrc: this.options.arrows.middle.src,
                    middleArrowImageWidth: this.options.arrows.middle.imageWidth,
                    middleArrowImageHeight: this.options.arrows.middle.imageHeight,
                    fromArrow: fromArrow,
                    fromArrowScale: this.options.arrows.from.scaleFactor,
                    fromArrowType: this.options.arrows.from.type,
                    fromArrowSrc: this.options.arrows.from.src,
                    fromArrowImageWidth: this.options.arrows.from.imageWidth,
                    fromArrowImageHeight: this.options.arrows.from.imageHeight,
                    arrowStrikethrough: this.options.arrowStrikethrough,
                    color: inheritsColor ? undefined : this.options.color.color,
                    inheritsColor: inheritsColor,
                    opacity: this.options.color.opacity,
                    hidden: this.options.hidden,
                    length: this.options.length,
                    shadow: this.options.shadow.enabled,
                    shadowColor: this.options.shadow.color,
                    shadowSize: this.options.shadow.size,
                    shadowX: this.options.shadow.x,
                    shadowY: this.options.shadow.y,
                    dashes: this.options.dashes,
                    width: this.options.width,
                    background: this.options.background.enabled,
                    backgroundColor: this.options.background.color,
                    backgroundSize: this.options.background.size,
                    backgroundDashes: this.options.background.dashes
                };
                if (this.selected || this.hover) {
                    if (this.chooser === true) {
                        if (this.selected) {
                            var selectedWidth = this.options.selectionWidth;
                            if (typeof selectedWidth === "function") values.width = selectedWidth(values.width);
                            else if (typeof selectedWidth === "number") values.width += selectedWidth;
                            values.width = Math.max(values.width, 0.3 / this.body.view.scale);
                            values.color = this.options.color.highlight;
                            values.shadow = this.options.shadow.enabled;
                        } else if (this.hover) {
                            var hoverWidth = this.options.hoverWidth;
                            if (typeof hoverWidth === "function") values.width = hoverWidth(values.width);
                            else if (typeof hoverWidth === "number") values.width += hoverWidth;
                            values.width = Math.max(values.width, 0.3 / this.body.view.scale);
                            values.color = this.options.color.hover;
                            values.shadow = this.options.shadow.enabled;
                        }
                    } else if (typeof this.chooser === "function") {
                        this.chooser(values, this.options.id, this.selected, this.hover);
                        if (values.color !== undefined) values.inheritsColor = false;
                        if (values.shadow === false) {
                            if (values.shadowColor !== this.options.shadow.color || values.shadowSize !== this.options.shadow.size || values.shadowX !== this.options.shadow.x || values.shadowY !== this.options.shadow.y) values.shadow = true;
                        }
                    }
                } else {
                    values.shadow = this.options.shadow.enabled;
                    values.width = Math.max(values.width, 0.3 / this.body.view.scale);
                }
                return values;
            }
        },
        {
            key: "updateLabelModule",
            value: function updateLabelModule(options) {
                var pile = [
                    options,
                    this.options,
                    this.globalOptions,
                    // Currently set global edge options
                    this.defaultOptions
                ];
                this.labelModule.update(this.options, pile);
                if (this.labelModule.baseSize !== undefined) this.baseFontSize = this.labelModule.baseSize;
            }
        },
        {
            key: "updateEdgeType",
            value: function updateEdgeType() {
                var smooth = this.options.smooth;
                var dataChanged = false;
                var changeInType = true;
                if (this.edgeType !== undefined) {
                    if (this.edgeType instanceof $bebd28704f2536ea$var$BezierEdgeDynamic && smooth.enabled === true && smooth.type === "dynamic" || this.edgeType instanceof $bebd28704f2536ea$var$CubicBezierEdge && smooth.enabled === true && smooth.type === "cubicBezier" || this.edgeType instanceof $bebd28704f2536ea$var$BezierEdgeStatic && smooth.enabled === true && smooth.type !== "dynamic" && smooth.type !== "cubicBezier" || this.edgeType instanceof $bebd28704f2536ea$var$StraightEdge && smooth.type.enabled === false) changeInType = false;
                    if (changeInType === true) dataChanged = this.cleanup();
                }
                if (changeInType === true) {
                    if (smooth.enabled === true) {
                        if (smooth.type === "dynamic") {
                            dataChanged = true;
                            this.edgeType = new $bebd28704f2536ea$var$BezierEdgeDynamic(this.options, this.body, this.labelModule);
                        } else if (smooth.type === "cubicBezier") this.edgeType = new $bebd28704f2536ea$var$CubicBezierEdge(this.options, this.body, this.labelModule);
                        else this.edgeType = new $bebd28704f2536ea$var$BezierEdgeStatic(this.options, this.body, this.labelModule);
                    } else this.edgeType = new $bebd28704f2536ea$var$StraightEdge(this.options, this.body, this.labelModule);
                } else // if nothing changes, we just set the options.
                this.edgeType.setOptions(this.options);
                return dataChanged;
            }
        },
        {
            key: "connect",
            value: function connect() {
                this.disconnect();
                this.from = this.body.nodes[this.fromId] || undefined;
                this.to = this.body.nodes[this.toId] || undefined;
                this.connected = this.from !== undefined && this.to !== undefined;
                if (this.connected === true) {
                    this.from.attachEdge(this);
                    this.to.attachEdge(this);
                } else {
                    if (this.from) this.from.detachEdge(this);
                    if (this.to) this.to.detachEdge(this);
                }
                this.edgeType.connect();
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.from) {
                    this.from.detachEdge(this);
                    this.from = undefined;
                }
                if (this.to) {
                    this.to.detachEdge(this);
                    this.to = undefined;
                }
                this.connected = false;
            }
        },
        {
            key: "getTitle",
            value: function getTitle() {
                return this.title;
            }
        },
        {
            key: "isSelected",
            value: function isSelected() {
                return this.selected;
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this.options.value;
            }
        },
        {
            key: "setValueRange",
            value: function setValueRange(min, max, total) {
                if (this.options.value !== undefined) {
                    var scale = this.options.scaling.customScalingFunction(min, max, total, this.options.value);
                    var widthDiff = this.options.scaling.max - this.options.scaling.min;
                    if (this.options.scaling.label.enabled === true) {
                        var fontDiff = this.options.scaling.label.max - this.options.scaling.label.min;
                        this.options.font.size = this.options.scaling.label.min + scale * fontDiff;
                    }
                    this.options.width = this.options.scaling.min + scale * widthDiff;
                } else {
                    this.options.width = this.baseWidth;
                    this.options.font.size = this.baseFontSize;
                }
                this._setInteractionWidths();
                this.updateLabelModule();
            }
        },
        {
            key: "_setInteractionWidths",
            value: function _setInteractionWidths() {
                if (typeof this.options.hoverWidth === "function") this.edgeType.hoverWidth = this.options.hoverWidth(this.options.width);
                else this.edgeType.hoverWidth = this.options.hoverWidth + this.options.width;
                if (typeof this.options.selectionWidth === "function") this.edgeType.selectionWidth = this.options.selectionWidth(this.options.width);
                else this.edgeType.selectionWidth = this.options.selectionWidth + this.options.width;
            }
        },
        {
            key: "draw",
            value: function draw(ctx) {
                var values = this.getFormattingValues();
                if (values.hidden) return;
                // get the via node from the edge type
                var viaNode = this.edgeType.getViaNode();
                // draw line and label
                this.edgeType.drawLine(ctx, values, this.selected, this.hover, viaNode);
                this.drawLabel(ctx, viaNode);
            }
        },
        {
            key: "drawArrows",
            value: function drawArrows(ctx) {
                var values = this.getFormattingValues();
                if (values.hidden) return;
                // get the via node from the edge type
                var viaNode = this.edgeType.getViaNode();
                var arrowData = {};
                // restore edge targets to defaults
                this.edgeType.fromPoint = this.edgeType.from;
                this.edgeType.toPoint = this.edgeType.to;
                // from and to arrows give a different end point for edges. we set them here
                if (values.fromArrow) {
                    arrowData.from = this.edgeType.getArrowData(ctx, "from", viaNode, this.selected, this.hover, values);
                    if (values.arrowStrikethrough === false) this.edgeType.fromPoint = arrowData.from.core;
                    if (values.fromArrowSrc) arrowData.from.image = this.imagelist.load(values.fromArrowSrc);
                    if (values.fromArrowImageWidth) arrowData.from.imageWidth = values.fromArrowImageWidth;
                    if (values.fromArrowImageHeight) arrowData.from.imageHeight = values.fromArrowImageHeight;
                }
                if (values.toArrow) {
                    arrowData.to = this.edgeType.getArrowData(ctx, "to", viaNode, this.selected, this.hover, values);
                    if (values.arrowStrikethrough === false) this.edgeType.toPoint = arrowData.to.core;
                    if (values.toArrowSrc) arrowData.to.image = this.imagelist.load(values.toArrowSrc);
                    if (values.toArrowImageWidth) arrowData.to.imageWidth = values.toArrowImageWidth;
                    if (values.toArrowImageHeight) arrowData.to.imageHeight = values.toArrowImageHeight;
                }
                // the middle arrow depends on the line, which can depend on the to and from arrows so we do this one lastly.
                if (values.middleArrow) {
                    arrowData.middle = this.edgeType.getArrowData(ctx, "middle", viaNode, this.selected, this.hover, values);
                    if (values.middleArrowSrc) arrowData.middle.image = this.imagelist.load(values.middleArrowSrc);
                    if (values.middleArrowImageWidth) arrowData.middle.imageWidth = values.middleArrowImageWidth;
                    if (values.middleArrowImageHeight) arrowData.middle.imageHeight = values.middleArrowImageHeight;
                }
                if (values.fromArrow) this.edgeType.drawArrowHead(ctx, values, this.selected, this.hover, arrowData.from);
                if (values.middleArrow) this.edgeType.drawArrowHead(ctx, values, this.selected, this.hover, arrowData.middle);
                if (values.toArrow) this.edgeType.drawArrowHead(ctx, values, this.selected, this.hover, arrowData.to);
            }
        },
        {
            key: "drawLabel",
            value: function drawLabel(ctx, viaNode) {
                if (this.options.label !== undefined) {
                    // set style
                    var node1 = this.from;
                    var node2 = this.to;
                    if (this.labelModule.differentState(this.selected, this.hover)) this.labelModule.getTextSize(ctx, this.selected, this.hover);
                    var point;
                    if (node1.id != node2.id) {
                        this.labelModule.pointToSelf = false;
                        point = this.edgeType.getPoint(0.5, viaNode);
                        ctx.save();
                        var rotationPoint = this._getRotation(ctx);
                        if (rotationPoint.angle != 0) {
                            ctx.translate(rotationPoint.x, rotationPoint.y);
                            ctx.rotate(rotationPoint.angle);
                        }
                        // draw the label
                        this.labelModule.draw(ctx, point.x, point.y, this.selected, this.hover);
                        /*
          // Useful debug code: draw a border around the label
          // This should **not** be enabled in production!
          var size = this.labelModule.getSize();; // ;; intentional so lint catches it
          ctx.strokeStyle = "#ff0000";
          ctx.strokeRect(size.left, size.top, size.width, size.height);
          // End  debug code
          */ ctx.restore();
                    } else {
                        // Ignore the orientations.
                        this.labelModule.pointToSelf = true;
                        // get circle coordinates
                        var coordinates = $bebd28704f2536ea$var$getSelfRefCoordinates(ctx, this.options.selfReference.angle, this.options.selfReference.size, node1);
                        point = this._pointOnCircle(coordinates.x, coordinates.y, this.options.selfReference.size, this.options.selfReference.angle);
                        this.labelModule.draw(ctx, point.x, point.y, this.selected, this.hover);
                    }
                }
            }
        },
        {
            key: "getItemsOnPoint",
            value: function getItemsOnPoint(point) {
                var ret = [];
                if (this.labelModule.visible()) {
                    var rotationPoint = this._getRotation();
                    if ($bebd28704f2536ea$var$pointInRect(this.labelModule.getSize(), point, rotationPoint)) ret.push({
                        edgeId: this.id,
                        labelId: 0
                    });
                }
                var obj = {
                    left: point.x,
                    top: point.y
                };
                if (this.isOverlappingWith(obj)) ret.push({
                    edgeId: this.id
                });
                return ret;
            }
        },
        {
            key: "isOverlappingWith",
            value: function isOverlappingWith(obj) {
                if (this.connected) {
                    var distMax = 10;
                    var xFrom = this.from.x;
                    var yFrom = this.from.y;
                    var xTo = this.to.x;
                    var yTo = this.to.y;
                    var xObj = obj.left;
                    var yObj = obj.top;
                    var dist = this.edgeType.getDistanceToEdge(xFrom, yFrom, xTo, yTo, xObj, yObj);
                    return dist < distMax;
                } else return false;
            }
        },
        {
            key: "_getRotation",
            value: function _getRotation(ctx) {
                var viaNode = this.edgeType.getViaNode();
                var point = this.edgeType.getPoint(0.5, viaNode);
                if (ctx !== undefined) this.labelModule.calculateLabelSize(ctx, this.selected, this.hover, point.x, point.y);
                var ret = {
                    x: point.x,
                    y: this.labelModule.size.yLine,
                    angle: 0
                };
                if (!this.labelModule.visible()) return ret; // Don't even bother doing the atan2, there's nothing to draw
                if (this.options.font.align === "horizontal") return ret; // No need to calculate angle
                var dy = this.from.y - this.to.y;
                var dx = this.from.x - this.to.x;
                var angle = Math.atan2(dy, dx); // radians
                // rotate so that label is readable
                if (angle < -1 && dx < 0 || angle > 0 && dx < 0) angle += Math.PI;
                ret.angle = angle;
                return ret;
            }
        },
        {
            key: "_pointOnCircle",
            value: function _pointOnCircle(x, y, radius, angle) {
                return {
                    x: x + radius * Math.cos(angle),
                    y: y - radius * Math.sin(angle)
                };
            }
        },
        {
            key: "select",
            value: function select() {
                this.selected = true;
            }
        },
        {
            key: "unselect",
            value: function unselect() {
                this.selected = false;
            }
        },
        {
            key: "cleanup",
            value: function cleanup() {
                return this.edgeType.cleanup();
            }
        },
        {
            key: "remove",
            value: function remove() {
                this.cleanup();
                this.disconnect();
                delete this.body.edges[this.id];
            }
        },
        {
            key: "endPointsValid",
            value: function endPointsValid() {
                return this.body.nodes[this.fromId] !== undefined && this.body.nodes[this.toId] !== undefined;
            }
        }
    ], [
        {
            key: "parseOptions",
            value: function parseOptions(parentOptions, newOptions) {
                var allowDeletion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var globalOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var copyFromGlobals = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
                var fields = [
                    "endPointOffset",
                    "arrowStrikethrough",
                    "id",
                    "from",
                    "hidden",
                    "hoverWidth",
                    "labelHighlightBold",
                    "length",
                    "line",
                    "opacity",
                    "physics",
                    "scaling",
                    "selectionWidth",
                    "selfReferenceSize",
                    "selfReference",
                    "to",
                    "title",
                    "value",
                    "width",
                    "font",
                    "chosen",
                    "widthConstraint"
                ];
                // only deep extend the items in the field array. These do not have shorthand.
                $bebd28704f2536ea$var$selectiveDeepExtend(fields, parentOptions, newOptions, allowDeletion);
                // Only use endPointOffset values (from and to) if it's valid values
                if (newOptions.endPointOffset !== undefined && newOptions.endPointOffset.from !== undefined) {
                    if ($bebd28704f2536ea$var$_Number$isFinite(newOptions.endPointOffset.from)) parentOptions.endPointOffset.from = newOptions.endPointOffset.from;
                    else {
                        parentOptions.endPointOffset.from = globalOptions.endPointOffset.from !== undefined ? globalOptions.endPointOffset.from : 0;
                        console.error("endPointOffset.from is not a valid number");
                    }
                }
                if (newOptions.endPointOffset !== undefined && newOptions.endPointOffset.to !== undefined) {
                    if ($bebd28704f2536ea$var$_Number$isFinite(newOptions.endPointOffset.to)) parentOptions.endPointOffset.to = newOptions.endPointOffset.to;
                    else {
                        parentOptions.endPointOffset.to = globalOptions.endPointOffset.to !== undefined ? globalOptions.endPointOffset.to : 0;
                        console.error("endPointOffset.to is not a valid number");
                    }
                }
                // Only copy label if it's a legal value.
                if ($bebd28704f2536ea$var$isValidLabel(newOptions.label)) parentOptions.label = newOptions.label;
                else if (!$bebd28704f2536ea$var$isValidLabel(parentOptions.label)) parentOptions.label = undefined;
                $bebd28704f2536ea$var$mergeOptions(parentOptions, newOptions, "smooth", globalOptions);
                $bebd28704f2536ea$var$mergeOptions(parentOptions, newOptions, "shadow", globalOptions);
                $bebd28704f2536ea$var$mergeOptions(parentOptions, newOptions, "background", globalOptions);
                if (newOptions.dashes !== undefined && newOptions.dashes !== null) parentOptions.dashes = newOptions.dashes;
                else if (allowDeletion === true && newOptions.dashes === null) parentOptions.dashes = $bebd28704f2536ea$var$_Object$create$1(globalOptions.dashes); // this sets the pointer of the option back to the global option.
                // set the scaling newOptions
                if (newOptions.scaling !== undefined && newOptions.scaling !== null) {
                    if (newOptions.scaling.min !== undefined) parentOptions.scaling.min = newOptions.scaling.min;
                    if (newOptions.scaling.max !== undefined) parentOptions.scaling.max = newOptions.scaling.max;
                    $bebd28704f2536ea$var$mergeOptions(parentOptions.scaling, newOptions.scaling, "label", globalOptions.scaling);
                } else if (allowDeletion === true && newOptions.scaling === null) parentOptions.scaling = $bebd28704f2536ea$var$_Object$create$1(globalOptions.scaling); // this sets the pointer of the option back to the global option.
                // handle multiple input cases for arrows
                if (newOptions.arrows !== undefined && newOptions.arrows !== null) {
                    if (typeof newOptions.arrows === "string") {
                        var arrows = newOptions.arrows.toLowerCase();
                        parentOptions.arrows.to.enabled = $bebd28704f2536ea$var$_indexOfInstanceProperty(arrows).call(arrows, "to") != -1;
                        parentOptions.arrows.middle.enabled = $bebd28704f2536ea$var$_indexOfInstanceProperty(arrows).call(arrows, "middle") != -1;
                        parentOptions.arrows.from.enabled = $bebd28704f2536ea$var$_indexOfInstanceProperty(arrows).call(arrows, "from") != -1;
                    } else if ($bebd28704f2536ea$var$_typeof(newOptions.arrows) === "object") {
                        $bebd28704f2536ea$var$mergeOptions(parentOptions.arrows, newOptions.arrows, "to", globalOptions.arrows);
                        $bebd28704f2536ea$var$mergeOptions(parentOptions.arrows, newOptions.arrows, "middle", globalOptions.arrows);
                        $bebd28704f2536ea$var$mergeOptions(parentOptions.arrows, newOptions.arrows, "from", globalOptions.arrows);
                    } else throw new Error("The arrow newOptions can only be an object or a string. Refer to the documentation. You used:" + $bebd28704f2536ea$var$_JSON$stringify(newOptions.arrows));
                } else if (allowDeletion === true && newOptions.arrows === null) parentOptions.arrows = $bebd28704f2536ea$var$_Object$create$1(globalOptions.arrows); // this sets the pointer of the option back to the global option.
                // handle multiple input cases for color
                if (newOptions.color !== undefined && newOptions.color !== null) {
                    var fromColor = $bebd28704f2536ea$var$isString(newOptions.color) ? {
                        color: newOptions.color,
                        highlight: newOptions.color,
                        hover: newOptions.color,
                        inherit: false,
                        opacity: 1
                    } : newOptions.color;
                    var toColor = parentOptions.color;
                    // If passed, fill in values from default options - required in the case of no prototype bridging
                    if (copyFromGlobals) $bebd28704f2536ea$var$deepExtend(toColor, globalOptions.color, false, allowDeletion);
                    else {
                        // Clear local properties - need to do it like this in order to retain prototype bridges
                        for(var i in toColor)if (Object.prototype.hasOwnProperty.call(toColor, i)) delete toColor[i];
                    }
                    if ($bebd28704f2536ea$var$isString(toColor)) {
                        toColor.color = toColor;
                        toColor.highlight = toColor;
                        toColor.hover = toColor;
                        toColor.inherit = false;
                        if (fromColor.opacity === undefined) toColor.opacity = 1.0; // set default
                    } else {
                        var colorsDefined = false;
                        if (fromColor.color !== undefined) {
                            toColor.color = fromColor.color;
                            colorsDefined = true;
                        }
                        if (fromColor.highlight !== undefined) {
                            toColor.highlight = fromColor.highlight;
                            colorsDefined = true;
                        }
                        if (fromColor.hover !== undefined) {
                            toColor.hover = fromColor.hover;
                            colorsDefined = true;
                        }
                        if (fromColor.inherit !== undefined) toColor.inherit = fromColor.inherit;
                        if (fromColor.opacity !== undefined) toColor.opacity = Math.min(1, Math.max(0, fromColor.opacity));
                        if (colorsDefined === true) toColor.inherit = false;
                        else if (toColor.inherit === undefined) toColor.inherit = "from"; // Set default
                    }
                } else if (allowDeletion === true && newOptions.color === null) parentOptions.color = $bebd28704f2536ea$var$bridgeObject(globalOptions.color); // set the object back to the global options
                if (allowDeletion === true && newOptions.font === null) parentOptions.font = $bebd28704f2536ea$var$bridgeObject(globalOptions.font); // set the object back to the global options
                if (Object.prototype.hasOwnProperty.call(newOptions, "selfReferenceSize")) {
                    console.warn("The selfReferenceSize property has been deprecated. Please use selfReference property instead. The selfReference can be set like thise selfReference:{size:30, angle:Math.PI / 4}");
                    parentOptions.selfReference.size = newOptions.selfReferenceSize;
                }
            }
        }
    ]);
    return Edge;
}();
/**
 * Handler for Edges
 */ var $bebd28704f2536ea$var$EdgesHandler = /*#__PURE__*/ function() {
    /**
   * @param {object} body
   * @param {Array.<Image>} images
   * @param {Array.<Group>} groups
   */ function EdgesHandler(body, images, groups) {
        var _context, _this = this;
        $bebd28704f2536ea$var$_classCallCheck(this, EdgesHandler);
        this.body = body;
        this.images = images;
        this.groups = groups;
        // create the edge API in the body container
        this.body.functions.createEdge = $bebd28704f2536ea$var$_bindInstanceProperty$1(_context = this.create).call(_context, this);
        this.edgesListeners = {
            add: function add(event, params) {
                _this.add(params.items);
            },
            update: function update(event, params) {
                _this.update(params.items);
            },
            remove: function remove(event, params) {
                _this.remove(params.items);
            }
        };
        this.options = {};
        this.defaultOptions = {
            arrows: {
                to: {
                    enabled: false,
                    scaleFactor: 1,
                    type: "arrow"
                },
                // boolean / {arrowScaleFactor:1} / {enabled: false, arrowScaleFactor:1}
                middle: {
                    enabled: false,
                    scaleFactor: 1,
                    type: "arrow"
                },
                from: {
                    enabled: false,
                    scaleFactor: 1,
                    type: "arrow"
                }
            },
            endPointOffset: {
                from: 0,
                to: 0
            },
            arrowStrikethrough: true,
            color: {
                color: "#848484",
                highlight: "#848484",
                hover: "#848484",
                inherit: "from",
                opacity: 1.0
            },
            dashes: false,
            font: {
                color: "#343434",
                size: 14,
                // px
                face: "arial",
                background: "none",
                strokeWidth: 2,
                // px
                strokeColor: "#ffffff",
                align: "horizontal",
                multi: false,
                vadjust: 0,
                bold: {
                    mod: "bold"
                },
                boldital: {
                    mod: "bold italic"
                },
                ital: {
                    mod: "italic"
                },
                mono: {
                    mod: "",
                    size: 15,
                    // px
                    face: "courier new",
                    vadjust: 2
                }
            },
            hidden: false,
            hoverWidth: 1.5,
            label: undefined,
            labelHighlightBold: true,
            length: undefined,
            physics: true,
            scaling: {
                min: 1,
                max: 15,
                label: {
                    enabled: true,
                    min: 14,
                    max: 30,
                    maxVisible: 30,
                    drawThreshold: 5
                },
                customScalingFunction: function customScalingFunction(min, max, total, value) {
                    if (max === min) return 0.5;
                    else {
                        var scale = 1 / (max - min);
                        return Math.max(0, (value - min) * scale);
                    }
                }
            },
            selectionWidth: 1.5,
            selfReference: {
                size: 20,
                angle: Math.PI / 4,
                renderBehindTheNode: true
            },
            shadow: {
                enabled: false,
                color: "rgba(0,0,0,0.5)",
                size: 10,
                x: 5,
                y: 5
            },
            background: {
                enabled: false,
                color: "rgba(111,111,111,1)",
                size: 10,
                dashes: false
            },
            smooth: {
                enabled: true,
                type: "dynamic",
                forceDirection: "none",
                roundness: 0.5
            },
            title: undefined,
            width: 1,
            value: undefined
        };
        $bebd28704f2536ea$var$deepExtend(this.options, this.defaultOptions);
        this.bindEventListeners();
    }
    /**
   * Binds event listeners
   */ $bebd28704f2536ea$var$_createClass(EdgesHandler, [
        {
            key: "bindEventListeners",
            value: function bindEventListeners() {
                var _this2 = this, _context2, _context3;
                // this allows external modules to force all dynamic curves to turn static.
                this.body.emitter.on("_forceDisableDynamicCurves", function(type) {
                    var emit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                    if (type === "dynamic") type = "continuous";
                    var dataChanged = false;
                    for(var edgeId in _this2.body.edges)if (Object.prototype.hasOwnProperty.call(_this2.body.edges, edgeId)) {
                        var edge = _this2.body.edges[edgeId];
                        var edgeData = _this2.body.data.edges.get(edgeId);
                        // only forcibly remove the smooth curve if the data has been set of the edge has the smooth curves defined.
                        // this is because a change in the global would not affect these curves.
                        if (edgeData != null) {
                            var smoothOptions = edgeData.smooth;
                            if (smoothOptions !== undefined) {
                                if (smoothOptions.enabled === true && smoothOptions.type === "dynamic") {
                                    if (type === undefined) edge.setOptions({
                                        smooth: false
                                    });
                                    else edge.setOptions({
                                        smooth: {
                                            type: type
                                        }
                                    });
                                    dataChanged = true;
                                }
                            }
                        }
                    }
                    if (emit === true && dataChanged === true) _this2.body.emitter.emit("_dataChanged");
                });
                // this is called when options of EXISTING nodes or edges have changed.
                //
                // NOTE: Not true, called when options have NOT changed, for both existing as well as new nodes.
                //       See update() for logic.
                // TODO: Verify and examine the consequences of this. It might still trigger when
                //       non-option fields have changed, but then reconnecting edges is still useless.
                //       Alternatively, it might also be called when edges are removed.
                //
                this.body.emitter.on("_dataUpdated", function() {
                    _this2.reconnectEdges();
                });
                // refresh the edges. Used when reverting from hierarchical layout
                this.body.emitter.on("refreshEdges", $bebd28704f2536ea$var$_bindInstanceProperty$1(_context2 = this.refresh).call(_context2, this));
                this.body.emitter.on("refresh", $bebd28704f2536ea$var$_bindInstanceProperty$1(_context3 = this.refresh).call(_context3, this));
                this.body.emitter.on("destroy", function() {
                    $bebd28704f2536ea$var$forEach$1(_this2.edgesListeners, function(callback, event) {
                        if (_this2.body.data.edges) _this2.body.data.edges.off(event, callback);
                    });
                    delete _this2.body.functions.createEdge;
                    delete _this2.edgesListeners.add;
                    delete _this2.edgesListeners.update;
                    delete _this2.edgesListeners.remove;
                    delete _this2.edgesListeners;
                });
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                if (options !== undefined) {
                    // use the parser from the Edge class to fill in all shorthand notations
                    $bebd28704f2536ea$var$Edge.parseOptions(this.options, options, true, this.defaultOptions, true);
                    // update smooth settings in all edges
                    var dataChanged = false;
                    if (options.smooth !== undefined) {
                        for(var edgeId in this.body.edges)if (Object.prototype.hasOwnProperty.call(this.body.edges, edgeId)) dataChanged = this.body.edges[edgeId].updateEdgeType() || dataChanged;
                    }
                    // update fonts in all edges
                    if (options.font !== undefined) {
                        for(var _edgeId in this.body.edges)if (Object.prototype.hasOwnProperty.call(this.body.edges, _edgeId)) this.body.edges[_edgeId].updateLabelModule();
                    }
                    // update the state of the variables if needed
                    if (options.hidden !== undefined || options.physics !== undefined || dataChanged === true) this.body.emitter.emit("_dataChanged");
                }
            }
        },
        {
            key: "setData",
            value: function setData(edges) {
                var _this3 = this;
                var doNotEmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var oldEdgesData = this.body.data.edges;
                if ((0, $558228835489ffff$export$fd220aa21eb2fcbc)("id", edges)) this.body.data.edges = edges;
                else if ($bebd28704f2536ea$var$_Array$isArray(edges)) {
                    this.body.data.edges = new (0, $558228835489ffff$export$486059efd2d2dabe)();
                    this.body.data.edges.add(edges);
                } else if (!edges) this.body.data.edges = new (0, $558228835489ffff$export$486059efd2d2dabe)();
                else throw new TypeError("Array or DataSet expected");
                // TODO: is this null or undefined or false?
                if (oldEdgesData) // unsubscribe from old dataset
                $bebd28704f2536ea$var$forEach$1(this.edgesListeners, function(callback, event) {
                    oldEdgesData.off(event, callback);
                });
                // remove drawn edges
                this.body.edges = {};
                // TODO: is this null or undefined or false?
                if (this.body.data.edges) {
                    // subscribe to new dataset
                    $bebd28704f2536ea$var$forEach$1(this.edgesListeners, function(callback, event) {
                        _this3.body.data.edges.on(event, callback);
                    });
                    // draw all new nodes
                    var ids = this.body.data.edges.getIds();
                    this.add(ids, true);
                }
                this.body.emitter.emit("_adjustEdgesForHierarchicalLayout");
                if (doNotEmit === false) this.body.emitter.emit("_dataChanged");
            }
        },
        {
            key: "add",
            value: function add(ids) {
                var doNotEmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var edges = this.body.edges;
                var edgesData = this.body.data.edges;
                for(var i = 0; i < ids.length; i++){
                    var id = ids[i];
                    var oldEdge = edges[id];
                    if (oldEdge) oldEdge.disconnect();
                    var data = edgesData.get(id, {
                        showInternalIds: true
                    });
                    edges[id] = this.create(data);
                }
                this.body.emitter.emit("_adjustEdgesForHierarchicalLayout");
                if (doNotEmit === false) this.body.emitter.emit("_dataChanged");
            }
        },
        {
            key: "update",
            value: function update(ids) {
                var edges = this.body.edges;
                var edgesData = this.body.data.edges;
                var dataChanged = false;
                for(var i = 0; i < ids.length; i++){
                    var id = ids[i];
                    var data = edgesData.get(id);
                    var edge = edges[id];
                    if (edge !== undefined) {
                        // update edge
                        edge.disconnect();
                        dataChanged = edge.setOptions(data) || dataChanged; // if a support node is added, data can be changed.
                        edge.connect();
                    } else {
                        // create edge
                        this.body.edges[id] = this.create(data);
                        dataChanged = true;
                    }
                }
                if (dataChanged === true) {
                    this.body.emitter.emit("_adjustEdgesForHierarchicalLayout");
                    this.body.emitter.emit("_dataChanged");
                } else this.body.emitter.emit("_dataUpdated");
            }
        },
        {
            key: "remove",
            value: function remove(ids) {
                var emit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                if (ids.length === 0) return; // early out
                var edges = this.body.edges;
                $bebd28704f2536ea$var$forEach$1(ids, function(id) {
                    var edge = edges[id];
                    if (edge !== undefined) edge.remove();
                });
                if (emit) this.body.emitter.emit("_dataChanged");
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                var _this4 = this;
                $bebd28704f2536ea$var$forEach$1(this.body.edges, function(edge, edgeId) {
                    var data = _this4.body.data.edges.get(edgeId);
                    if (data !== undefined) edge.setOptions(data);
                });
            }
        },
        {
            key: "create",
            value: function create(properties) {
                return new $bebd28704f2536ea$var$Edge(properties, this.body, this.images, this.options, this.defaultOptions);
            }
        },
        {
            key: "reconnectEdges",
            value: function reconnectEdges() {
                var id;
                var nodes = this.body.nodes;
                var edges = this.body.edges;
                for(id in nodes)if (Object.prototype.hasOwnProperty.call(nodes, id)) nodes[id].edges = [];
                for(id in edges)if (Object.prototype.hasOwnProperty.call(edges, id)) {
                    var edge = edges[id];
                    edge.from = null;
                    edge.to = null;
                    edge.connect();
                }
            }
        },
        {
            key: "getConnectedNodes",
            value: function getConnectedNodes(edgeId) {
                var nodeList = [];
                if (this.body.edges[edgeId] !== undefined) {
                    var edge = this.body.edges[edgeId];
                    if (edge.fromId !== undefined) nodeList.push(edge.fromId);
                    if (edge.toId !== undefined) nodeList.push(edge.toId);
                }
                return nodeList;
            }
        },
        {
            key: "_updateState",
            value: function _updateState() {
                this._addMissingEdges();
                this._removeInvalidEdges();
            }
        },
        {
            key: "_removeInvalidEdges",
            value: function _removeInvalidEdges() {
                var _this5 = this;
                var edgesToDelete = [];
                $bebd28704f2536ea$var$forEach$1(this.body.edges, function(edge, id) {
                    var toNode = _this5.body.nodes[edge.toId];
                    var fromNode = _this5.body.nodes[edge.fromId];
                    // Skip clustering edges here, let the Clustering module handle those
                    if (toNode !== undefined && toNode.isCluster === true || fromNode !== undefined && fromNode.isCluster === true) return;
                    if (toNode === undefined || fromNode === undefined) edgesToDelete.push(id);
                });
                this.remove(edgesToDelete, false);
            }
        },
        {
            key: "_addMissingEdges",
            value: function _addMissingEdges() {
                var edgesData = this.body.data.edges;
                if (edgesData === undefined || edgesData === null) return; // No edges DataSet yet; can happen on startup
                var edges = this.body.edges;
                var addIds = [];
                $bebd28704f2536ea$var$_forEachInstanceProperty(edgesData).call(edgesData, function(edgeData, edgeId) {
                    var edge = edges[edgeId];
                    if (edge === undefined) addIds.push(edgeId);
                });
                this.add(addIds, true);
            }
        }
    ]);
    return EdgesHandler;
}();
/**
 * Barnes Hut Solver
 */ var $bebd28704f2536ea$var$BarnesHutSolver = /*#__PURE__*/ function() {
    /**
   * @param {object} body
   * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
   * @param {object} options
   */ function BarnesHutSolver(body, physicsBody, options) {
        $bebd28704f2536ea$var$_classCallCheck(this, BarnesHutSolver);
        this.body = body;
        this.physicsBody = physicsBody;
        this.barnesHutTree;
        this.setOptions(options);
        this._rng = $bebd28704f2536ea$var$Alea("BARNES HUT SOLVER");
    // debug: show grid
    // this.body.emitter.on("afterDrawing", (ctx) => {this._debug(ctx,'#ff0000')})
    }
    /**
   *
   * @param {object} options
   */ $bebd28704f2536ea$var$_createClass(BarnesHutSolver, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
                this.thetaInversed = 1 / this.options.theta;
                // if 1 then min distance = 0.5, if 0.5 then min distance = 0.5 + 0.5*node.shape.radius
                this.overlapAvoidanceFactor = 1 - Math.max(0, Math.min(1, this.options.avoidOverlap));
            }
        },
        {
            key: "solve",
            value: function solve() {
                if (this.options.gravitationalConstant !== 0 && this.physicsBody.physicsNodeIndices.length > 0) {
                    var node;
                    var nodes = this.body.nodes;
                    var nodeIndices = this.physicsBody.physicsNodeIndices;
                    var nodeCount = nodeIndices.length;
                    // create the tree
                    var barnesHutTree = this._formBarnesHutTree(nodes, nodeIndices);
                    // for debugging
                    this.barnesHutTree = barnesHutTree;
                    // place the nodes one by one recursively
                    for(var i = 0; i < nodeCount; i++){
                        node = nodes[nodeIndices[i]];
                        if (node.options.mass > 0) // starting with root is irrelevant, it never passes the BarnesHutSolver condition
                        this._getForceContributions(barnesHutTree.root, node);
                    }
                }
            }
        },
        {
            key: "_getForceContributions",
            value: function _getForceContributions(parentBranch, node) {
                this._getForceContribution(parentBranch.children.NW, node);
                this._getForceContribution(parentBranch.children.NE, node);
                this._getForceContribution(parentBranch.children.SW, node);
                this._getForceContribution(parentBranch.children.SE, node);
            }
        },
        {
            key: "_getForceContribution",
            value: function _getForceContribution(parentBranch, node) {
                // we get no force contribution from an empty region
                if (parentBranch.childrenCount > 0) {
                    // get the distance from the center of mass to the node.
                    var dx = parentBranch.centerOfMass.x - node.x;
                    var dy = parentBranch.centerOfMass.y - node.y;
                    var distance = Math.sqrt(dx * dx + dy * dy);
                    // BarnesHutSolver condition
                    // original condition : s/d < theta = passed  ===  d/s > 1/theta = passed
                    // calcSize = 1/s --> d * 1/s > 1/theta = passed
                    if (distance * parentBranch.calcSize > this.thetaInversed) this._calculateForces(distance, dx, dy, node, parentBranch);
                    else {
                        // Did not pass the condition, go into children if available
                        if (parentBranch.childrenCount === 4) this._getForceContributions(parentBranch, node);
                        else // parentBranch must have only one node, if it was empty we wouldnt be here
                        if (parentBranch.children.data.id != node.id) // if it is not self
                        this._calculateForces(distance, dx, dy, node, parentBranch);
                    }
                }
            }
        },
        {
            key: "_calculateForces",
            value: function _calculateForces(distance, dx, dy, node, parentBranch) {
                if (distance === 0) {
                    distance = 0.1;
                    dx = distance;
                }
                if (this.overlapAvoidanceFactor < 1 && node.shape.radius) distance = Math.max(0.1 + this.overlapAvoidanceFactor * node.shape.radius, distance - node.shape.radius);
                // the dividing by the distance cubed instead of squared allows us to get the fx and fy components without sines and cosines
                // it is shorthand for gravityforce with distance squared and fx = dx/distance * gravityForce
                var gravityForce = this.options.gravitationalConstant * parentBranch.mass * node.options.mass / Math.pow(distance, 3);
                var fx = dx * gravityForce;
                var fy = dy * gravityForce;
                this.physicsBody.forces[node.id].x += fx;
                this.physicsBody.forces[node.id].y += fy;
            }
        },
        {
            key: "_formBarnesHutTree",
            value: function _formBarnesHutTree(nodes, nodeIndices) {
                var node;
                var nodeCount = nodeIndices.length;
                var minX = nodes[nodeIndices[0]].x;
                var minY = nodes[nodeIndices[0]].y;
                var maxX = nodes[nodeIndices[0]].x;
                var maxY = nodes[nodeIndices[0]].y;
                // get the range of the nodes
                for(var i = 1; i < nodeCount; i++){
                    var _node = nodes[nodeIndices[i]];
                    var x = _node.x;
                    var y = _node.y;
                    if (_node.options.mass > 0) {
                        if (x < minX) minX = x;
                        if (x > maxX) maxX = x;
                        if (y < minY) minY = y;
                        if (y > maxY) maxY = y;
                    }
                }
                // make the range a square
                var sizeDiff = Math.abs(maxX - minX) - Math.abs(maxY - minY); // difference between X and Y
                if (sizeDiff > 0) {
                    minY -= 0.5 * sizeDiff;
                    maxY += 0.5 * sizeDiff;
                } else {
                    minX += 0.5 * sizeDiff;
                    maxX -= 0.5 * sizeDiff;
                } // xSize < ySize
                var minimumTreeSize = 1e-5;
                var rootSize = Math.max(minimumTreeSize, Math.abs(maxX - minX));
                var halfRootSize = 0.5 * rootSize;
                var centerX = 0.5 * (minX + maxX), centerY = 0.5 * (minY + maxY);
                // construct the barnesHutTree
                var barnesHutTree = {
                    root: {
                        centerOfMass: {
                            x: 0,
                            y: 0
                        },
                        mass: 0,
                        range: {
                            minX: centerX - halfRootSize,
                            maxX: centerX + halfRootSize,
                            minY: centerY - halfRootSize,
                            maxY: centerY + halfRootSize
                        },
                        size: rootSize,
                        calcSize: 1 / rootSize,
                        children: {
                            data: null
                        },
                        maxWidth: 0,
                        level: 0,
                        childrenCount: 4
                    }
                };
                this._splitBranch(barnesHutTree.root);
                // place the nodes one by one recursively
                for(var _i = 0; _i < nodeCount; _i++){
                    node = nodes[nodeIndices[_i]];
                    if (node.options.mass > 0) this._placeInTree(barnesHutTree.root, node);
                }
                // make global
                return barnesHutTree;
            }
        },
        {
            key: "_updateBranchMass",
            value: function _updateBranchMass(parentBranch, node) {
                var centerOfMass = parentBranch.centerOfMass;
                var totalMass = parentBranch.mass + node.options.mass;
                var totalMassInv = 1 / totalMass;
                centerOfMass.x = centerOfMass.x * parentBranch.mass + node.x * node.options.mass;
                centerOfMass.x *= totalMassInv;
                centerOfMass.y = centerOfMass.y * parentBranch.mass + node.y * node.options.mass;
                centerOfMass.y *= totalMassInv;
                parentBranch.mass = totalMass;
                var biggestSize = Math.max(Math.max(node.height, node.radius), node.width);
                parentBranch.maxWidth = parentBranch.maxWidth < biggestSize ? biggestSize : parentBranch.maxWidth;
            }
        },
        {
            key: "_placeInTree",
            value: function _placeInTree(parentBranch, node, skipMassUpdate) {
                if (skipMassUpdate != true || skipMassUpdate === undefined) // update the mass of the branch.
                this._updateBranchMass(parentBranch, node);
                var range = parentBranch.children.NW.range;
                var region;
                if (range.maxX > node.x) {
                    // in NW or SW
                    if (range.maxY > node.y) region = "NW";
                    else region = "SW";
                } else // in NE or SE
                if (range.maxY > node.y) region = "NE";
                else region = "SE";
                this._placeInRegion(parentBranch, node, region);
            }
        },
        {
            key: "_placeInRegion",
            value: function _placeInRegion(parentBranch, node, region) {
                var children = parentBranch.children[region];
                switch(children.childrenCount){
                    case 0:
                        // place node here
                        children.children.data = node;
                        children.childrenCount = 1;
                        this._updateBranchMass(children, node);
                        break;
                    case 1:
                        // convert into children
                        // if there are two nodes exactly overlapping (on init, on opening of cluster etc.)
                        // we move one node a little bit and we do not put it in the tree.
                        if (children.children.data.x === node.x && children.children.data.y === node.y) {
                            node.x += this._rng();
                            node.y += this._rng();
                        } else {
                            this._splitBranch(children);
                            this._placeInTree(children, node);
                        }
                        break;
                    case 4:
                        // place in branch
                        this._placeInTree(children, node);
                        break;
                }
            }
        },
        {
            key: "_splitBranch",
            value: function _splitBranch(parentBranch) {
                // if the branch is shaded with a node, replace the node in the new subset.
                var containedNode = null;
                if (parentBranch.childrenCount === 1) {
                    containedNode = parentBranch.children.data;
                    parentBranch.mass = 0;
                    parentBranch.centerOfMass.x = 0;
                    parentBranch.centerOfMass.y = 0;
                }
                parentBranch.childrenCount = 4;
                parentBranch.children.data = null;
                this._insertRegion(parentBranch, "NW");
                this._insertRegion(parentBranch, "NE");
                this._insertRegion(parentBranch, "SW");
                this._insertRegion(parentBranch, "SE");
                if (containedNode != null) this._placeInTree(parentBranch, containedNode);
            }
        },
        {
            key: "_insertRegion",
            value: function _insertRegion(parentBranch, region) {
                var minX, maxX, minY, maxY;
                var childSize = 0.5 * parentBranch.size;
                switch(region){
                    case "NW":
                        minX = parentBranch.range.minX;
                        maxX = parentBranch.range.minX + childSize;
                        minY = parentBranch.range.minY;
                        maxY = parentBranch.range.minY + childSize;
                        break;
                    case "NE":
                        minX = parentBranch.range.minX + childSize;
                        maxX = parentBranch.range.maxX;
                        minY = parentBranch.range.minY;
                        maxY = parentBranch.range.minY + childSize;
                        break;
                    case "SW":
                        minX = parentBranch.range.minX;
                        maxX = parentBranch.range.minX + childSize;
                        minY = parentBranch.range.minY + childSize;
                        maxY = parentBranch.range.maxY;
                        break;
                    case "SE":
                        minX = parentBranch.range.minX + childSize;
                        maxX = parentBranch.range.maxX;
                        minY = parentBranch.range.minY + childSize;
                        maxY = parentBranch.range.maxY;
                        break;
                }
                parentBranch.children[region] = {
                    centerOfMass: {
                        x: 0,
                        y: 0
                    },
                    mass: 0,
                    range: {
                        minX: minX,
                        maxX: maxX,
                        minY: minY,
                        maxY: maxY
                    },
                    size: 0.5 * parentBranch.size,
                    calcSize: 2 * parentBranch.calcSize,
                    children: {
                        data: null
                    },
                    maxWidth: 0,
                    level: parentBranch.level + 1,
                    childrenCount: 0
                };
            }
        },
        {
            key: "_debug",
            value: function _debug(ctx, color) {
                if (this.barnesHutTree !== undefined) {
                    ctx.lineWidth = 1;
                    this._drawBranch(this.barnesHutTree.root, ctx, color);
                }
            }
        },
        {
            key: "_drawBranch",
            value: function _drawBranch(branch, ctx, color) {
                if (color === undefined) color = "#FF0000";
                if (branch.childrenCount === 4) {
                    this._drawBranch(branch.children.NW, ctx);
                    this._drawBranch(branch.children.NE, ctx);
                    this._drawBranch(branch.children.SE, ctx);
                    this._drawBranch(branch.children.SW, ctx);
                }
                ctx.strokeStyle = color;
                ctx.beginPath();
                ctx.moveTo(branch.range.minX, branch.range.minY);
                ctx.lineTo(branch.range.maxX, branch.range.minY);
                ctx.stroke();
                ctx.beginPath();
                ctx.moveTo(branch.range.maxX, branch.range.minY);
                ctx.lineTo(branch.range.maxX, branch.range.maxY);
                ctx.stroke();
                ctx.beginPath();
                ctx.moveTo(branch.range.maxX, branch.range.maxY);
                ctx.lineTo(branch.range.minX, branch.range.maxY);
                ctx.stroke();
                ctx.beginPath();
                ctx.moveTo(branch.range.minX, branch.range.maxY);
                ctx.lineTo(branch.range.minX, branch.range.minY);
                ctx.stroke();
            /*
       if (branch.mass > 0) {
       ctx.circle(branch.centerOfMass.x, branch.centerOfMass.y, 3*branch.mass);
       ctx.stroke();
       }
       */ }
        }
    ]);
    return BarnesHutSolver;
}();
/**
 * Repulsion Solver
 */ var $bebd28704f2536ea$var$RepulsionSolver = /*#__PURE__*/ function() {
    /**
   * @param {object} body
   * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
   * @param {object} options
   */ function RepulsionSolver(body, physicsBody, options) {
        $bebd28704f2536ea$var$_classCallCheck(this, RepulsionSolver);
        this._rng = $bebd28704f2536ea$var$Alea("REPULSION SOLVER");
        this.body = body;
        this.physicsBody = physicsBody;
        this.setOptions(options);
    }
    /**
   *
   * @param {object} options
   */ $bebd28704f2536ea$var$_createClass(RepulsionSolver, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
            }
        },
        {
            key: "solve",
            value: function solve() {
                var dx, dy, distance, fx, fy, repulsingForce, node1, node2;
                var nodes = this.body.nodes;
                var nodeIndices = this.physicsBody.physicsNodeIndices;
                var forces = this.physicsBody.forces;
                // repulsing forces between nodes
                var nodeDistance = this.options.nodeDistance;
                // approximation constants
                var a = -2 / 3 / nodeDistance;
                var b = 4 / 3;
                // we loop from i over all but the last entree in the array
                // j loops from i+1 to the last. This way we do not double count any of the indices, nor i === j
                for(var i = 0; i < nodeIndices.length - 1; i++){
                    node1 = nodes[nodeIndices[i]];
                    for(var j = i + 1; j < nodeIndices.length; j++){
                        node2 = nodes[nodeIndices[j]];
                        dx = node2.x - node1.x;
                        dy = node2.y - node1.y;
                        distance = Math.sqrt(dx * dx + dy * dy);
                        // same condition as BarnesHutSolver, making sure nodes are never 100% overlapping.
                        if (distance === 0) {
                            distance = 0.1 * this._rng();
                            dx = distance;
                        }
                        if (distance < 2 * nodeDistance) {
                            if (distance < 0.5 * nodeDistance) repulsingForce = 1.0;
                            else repulsingForce = a * distance + b; // linear approx of  1 / (1 + Math.exp((distance / nodeDistance - 1) * steepness))
                            repulsingForce = repulsingForce / distance;
                            fx = dx * repulsingForce;
                            fy = dy * repulsingForce;
                            forces[node1.id].x -= fx;
                            forces[node1.id].y -= fy;
                            forces[node2.id].x += fx;
                            forces[node2.id].y += fy;
                        }
                    }
                }
            }
        }
    ]);
    return RepulsionSolver;
}();
/**
 * Hierarchical Repulsion Solver
 */ var $bebd28704f2536ea$var$HierarchicalRepulsionSolver = /*#__PURE__*/ function() {
    /**
   * @param {object} body
   * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
   * @param {object} options
   */ function HierarchicalRepulsionSolver(body, physicsBody, options) {
        $bebd28704f2536ea$var$_classCallCheck(this, HierarchicalRepulsionSolver);
        this.body = body;
        this.physicsBody = physicsBody;
        this.setOptions(options);
    }
    /**
   *
   * @param {object} options
   */ $bebd28704f2536ea$var$_createClass(HierarchicalRepulsionSolver, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
                this.overlapAvoidanceFactor = Math.max(0, Math.min(1, this.options.avoidOverlap || 0));
            }
        },
        {
            key: "solve",
            value: function solve() {
                var nodes = this.body.nodes;
                var nodeIndices = this.physicsBody.physicsNodeIndices;
                var forces = this.physicsBody.forces;
                // repulsing forces between nodes
                var nodeDistance = this.options.nodeDistance;
                // we loop from i over all but the last entree in the array
                // j loops from i+1 to the last. This way we do not double count any of the indices, nor i === j
                for(var i = 0; i < nodeIndices.length - 1; i++){
                    var node1 = nodes[nodeIndices[i]];
                    for(var j = i + 1; j < nodeIndices.length; j++){
                        var node2 = nodes[nodeIndices[j]];
                        // nodes only affect nodes on their level
                        if (node1.level === node2.level) {
                            var theseNodesDistance = nodeDistance + this.overlapAvoidanceFactor * ((node1.shape.radius || 0) / 2 + (node2.shape.radius || 0) / 2);
                            var dx = node2.x - node1.x;
                            var dy = node2.y - node1.y;
                            var distance = Math.sqrt(dx * dx + dy * dy);
                            var steepness = 0.05;
                            var repulsingForce = void 0;
                            if (distance < theseNodesDistance) repulsingForce = -Math.pow(steepness * distance, 2) + Math.pow(steepness * theseNodesDistance, 2);
                            else repulsingForce = 0;
                            // normalize force with
                            if (distance !== 0) repulsingForce = repulsingForce / distance;
                            var fx = dx * repulsingForce;
                            var fy = dy * repulsingForce;
                            forces[node1.id].x -= fx;
                            forces[node1.id].y -= fy;
                            forces[node2.id].x += fx;
                            forces[node2.id].y += fy;
                        }
                    }
                }
            }
        }
    ]);
    return HierarchicalRepulsionSolver;
}();
/**
 * Spring Solver
 */ var $bebd28704f2536ea$var$SpringSolver = /*#__PURE__*/ function() {
    /**
   * @param {object} body
   * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
   * @param {object} options
   */ function SpringSolver(body, physicsBody, options) {
        $bebd28704f2536ea$var$_classCallCheck(this, SpringSolver);
        this.body = body;
        this.physicsBody = physicsBody;
        this.setOptions(options);
    }
    /**
   *
   * @param {object} options
   */ $bebd28704f2536ea$var$_createClass(SpringSolver, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
            }
        },
        {
            key: "solve",
            value: function solve() {
                var edgeLength, edge;
                var edgeIndices = this.physicsBody.physicsEdgeIndices;
                var edges = this.body.edges;
                var node1, node2, node3;
                // forces caused by the edges, modelled as springs
                for(var i = 0; i < edgeIndices.length; i++){
                    edge = edges[edgeIndices[i]];
                    if (edge.connected === true && edge.toId !== edge.fromId) // only calculate forces if nodes are in the same sector
                    {
                        if (this.body.nodes[edge.toId] !== undefined && this.body.nodes[edge.fromId] !== undefined) {
                            if (edge.edgeType.via !== undefined) {
                                edgeLength = edge.options.length === undefined ? this.options.springLength : edge.options.length;
                                node1 = edge.to;
                                node2 = edge.edgeType.via;
                                node3 = edge.from;
                                this._calculateSpringForce(node1, node2, 0.5 * edgeLength);
                                this._calculateSpringForce(node2, node3, 0.5 * edgeLength);
                            } else {
                                // the * 1.5 is here so the edge looks as large as a smooth edge. It does not initially because the smooth edges use
                                // the support nodes which exert a repulsive force on the to and from nodes, making the edge appear larger.
                                edgeLength = edge.options.length === undefined ? this.options.springLength * 1.5 : edge.options.length;
                                this._calculateSpringForce(edge.from, edge.to, edgeLength);
                            }
                        }
                    }
                }
            }
        },
        {
            key: "_calculateSpringForce",
            value: function _calculateSpringForce(node1, node2, edgeLength) {
                var dx = node1.x - node2.x;
                var dy = node1.y - node2.y;
                var distance = Math.max(Math.sqrt(dx * dx + dy * dy), 0.01);
                // the 1/distance is so the fx and fy can be calculated without sine or cosine.
                var springForce = this.options.springConstant * (edgeLength - distance) / distance;
                var fx = dx * springForce;
                var fy = dy * springForce;
                // handle the case where one node is not part of the physcis
                if (this.physicsBody.forces[node1.id] !== undefined) {
                    this.physicsBody.forces[node1.id].x += fx;
                    this.physicsBody.forces[node1.id].y += fy;
                }
                if (this.physicsBody.forces[node2.id] !== undefined) {
                    this.physicsBody.forces[node2.id].x -= fx;
                    this.physicsBody.forces[node2.id].y -= fy;
                }
            }
        }
    ]);
    return SpringSolver;
}();
/**
 * Hierarchical Spring Solver
 */ var $bebd28704f2536ea$var$HierarchicalSpringSolver = /*#__PURE__*/ function() {
    /**
   * @param {object} body
   * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
   * @param {object} options
   */ function HierarchicalSpringSolver(body, physicsBody, options) {
        $bebd28704f2536ea$var$_classCallCheck(this, HierarchicalSpringSolver);
        this.body = body;
        this.physicsBody = physicsBody;
        this.setOptions(options);
    }
    /**
   *
   * @param {object} options
   */ $bebd28704f2536ea$var$_createClass(HierarchicalSpringSolver, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
            }
        },
        {
            key: "solve",
            value: function solve() {
                var edgeLength, edge;
                var dx, dy, fx, fy, springForce, distance;
                var edges = this.body.edges;
                var factor = 0.5;
                var edgeIndices = this.physicsBody.physicsEdgeIndices;
                var nodeIndices = this.physicsBody.physicsNodeIndices;
                var forces = this.physicsBody.forces;
                // initialize the spring force counters
                for(var i = 0; i < nodeIndices.length; i++){
                    var nodeId = nodeIndices[i];
                    forces[nodeId].springFx = 0;
                    forces[nodeId].springFy = 0;
                }
                // forces caused by the edges, modelled as springs
                for(var _i = 0; _i < edgeIndices.length; _i++){
                    edge = edges[edgeIndices[_i]];
                    if (edge.connected === true) {
                        edgeLength = edge.options.length === undefined ? this.options.springLength : edge.options.length;
                        dx = edge.from.x - edge.to.x;
                        dy = edge.from.y - edge.to.y;
                        distance = Math.sqrt(dx * dx + dy * dy);
                        distance = distance === 0 ? 0.01 : distance;
                        // the 1/distance is so the fx and fy can be calculated without sine or cosine.
                        springForce = this.options.springConstant * (edgeLength - distance) / distance;
                        fx = dx * springForce;
                        fy = dy * springForce;
                        if (edge.to.level != edge.from.level) {
                            if (forces[edge.toId] !== undefined) {
                                forces[edge.toId].springFx -= fx;
                                forces[edge.toId].springFy -= fy;
                            }
                            if (forces[edge.fromId] !== undefined) {
                                forces[edge.fromId].springFx += fx;
                                forces[edge.fromId].springFy += fy;
                            }
                        } else {
                            if (forces[edge.toId] !== undefined) {
                                forces[edge.toId].x -= factor * fx;
                                forces[edge.toId].y -= factor * fy;
                            }
                            if (forces[edge.fromId] !== undefined) {
                                forces[edge.fromId].x += factor * fx;
                                forces[edge.fromId].y += factor * fy;
                            }
                        }
                    }
                }
                // normalize spring forces
                springForce = 1;
                var springFx, springFy;
                for(var _i2 = 0; _i2 < nodeIndices.length; _i2++){
                    var _nodeId = nodeIndices[_i2];
                    springFx = Math.min(springForce, Math.max(-springForce, forces[_nodeId].springFx));
                    springFy = Math.min(springForce, Math.max(-springForce, forces[_nodeId].springFy));
                    forces[_nodeId].x += springFx;
                    forces[_nodeId].y += springFy;
                }
                // retain energy balance
                var totalFx = 0;
                var totalFy = 0;
                for(var _i3 = 0; _i3 < nodeIndices.length; _i3++){
                    var _nodeId2 = nodeIndices[_i3];
                    totalFx += forces[_nodeId2].x;
                    totalFy += forces[_nodeId2].y;
                }
                var correctionFx = totalFx / nodeIndices.length;
                var correctionFy = totalFy / nodeIndices.length;
                for(var _i4 = 0; _i4 < nodeIndices.length; _i4++){
                    var _nodeId3 = nodeIndices[_i4];
                    forces[_nodeId3].x -= correctionFx;
                    forces[_nodeId3].y -= correctionFy;
                }
            }
        }
    ]);
    return HierarchicalSpringSolver;
}();
/**
 * Central Gravity Solver
 */ var $bebd28704f2536ea$var$CentralGravitySolver = /*#__PURE__*/ function() {
    /**
   * @param {object} body
   * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
   * @param {object} options
   */ function CentralGravitySolver(body, physicsBody, options) {
        $bebd28704f2536ea$var$_classCallCheck(this, CentralGravitySolver);
        this.body = body;
        this.physicsBody = physicsBody;
        this.setOptions(options);
    }
    /**
   *
   * @param {object} options
   */ $bebd28704f2536ea$var$_createClass(CentralGravitySolver, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
            }
        },
        {
            key: "solve",
            value: function solve() {
                var dx, dy, distance, node;
                var nodes = this.body.nodes;
                var nodeIndices = this.physicsBody.physicsNodeIndices;
                var forces = this.physicsBody.forces;
                for(var i = 0; i < nodeIndices.length; i++){
                    var nodeId = nodeIndices[i];
                    node = nodes[nodeId];
                    dx = -node.x;
                    dy = -node.y;
                    distance = Math.sqrt(dx * dx + dy * dy);
                    this._calculateForces(distance, dx, dy, forces, node);
                }
            }
        },
        {
            key: "_calculateForces",
            value: function _calculateForces(distance, dx, dy, forces, node) {
                var gravityForce = distance === 0 ? 0 : this.options.centralGravity / distance;
                forces[node.id].x = dx * gravityForce;
                forces[node.id].y = dy * gravityForce;
            }
        }
    ]);
    return CentralGravitySolver;
}();
function $bebd28704f2536ea$var$_createSuper$3(Derived) {
    var hasNativeReflectConstruct = $bebd28704f2536ea$var$_isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = $bebd28704f2536ea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bebd28704f2536ea$var$_getPrototypeOf(this).constructor;
            result = $bebd28704f2536ea$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bebd28704f2536ea$var$_possibleConstructorReturn(this, result);
    };
}
function $bebd28704f2536ea$var$_isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !$bebd28704f2536ea$var$_Reflect$construct) return false;
    if ($bebd28704f2536ea$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($bebd28704f2536ea$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * @augments BarnesHutSolver
 */ var $bebd28704f2536ea$var$ForceAtlas2BasedRepulsionSolver = /*#__PURE__*/ function(_BarnesHutSolver) {
    $bebd28704f2536ea$var$_inherits(ForceAtlas2BasedRepulsionSolver, _BarnesHutSolver);
    var _super = $bebd28704f2536ea$var$_createSuper$3(ForceAtlas2BasedRepulsionSolver);
    /**
   * @param {object} body
   * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
   * @param {object} options
   */ function ForceAtlas2BasedRepulsionSolver(body, physicsBody, options) {
        var _this;
        $bebd28704f2536ea$var$_classCallCheck(this, ForceAtlas2BasedRepulsionSolver);
        _this = _super.call(this, body, physicsBody, options);
        _this._rng = $bebd28704f2536ea$var$Alea("FORCE ATLAS 2 BASED REPULSION SOLVER");
        return _this;
    }
    /**
   * Calculate the forces based on the distance.
   *
   * @param {number} distance
   * @param {number} dx
   * @param {number} dy
   * @param {Node} node
   * @param {object} parentBranch
   * @private
   */ $bebd28704f2536ea$var$_createClass(ForceAtlas2BasedRepulsionSolver, [
        {
            key: "_calculateForces",
            value: function _calculateForces(distance, dx, dy, node, parentBranch) {
                if (distance === 0) {
                    distance = 0.1 * this._rng();
                    dx = distance;
                }
                if (this.overlapAvoidanceFactor < 1 && node.shape.radius) distance = Math.max(0.1 + this.overlapAvoidanceFactor * node.shape.radius, distance - node.shape.radius);
                var degree = node.edges.length + 1;
                // the dividing by the distance cubed instead of squared allows us to get the fx and fy components without sines and cosines
                // it is shorthand for gravityforce with distance squared and fx = dx/distance * gravityForce
                var gravityForce = this.options.gravitationalConstant * parentBranch.mass * node.options.mass * degree / Math.pow(distance, 2);
                var fx = dx * gravityForce;
                var fy = dy * gravityForce;
                this.physicsBody.forces[node.id].x += fx;
                this.physicsBody.forces[node.id].y += fy;
            }
        }
    ]);
    return ForceAtlas2BasedRepulsionSolver;
}($bebd28704f2536ea$var$BarnesHutSolver);
function $bebd28704f2536ea$var$_createSuper$2(Derived) {
    var hasNativeReflectConstruct = $bebd28704f2536ea$var$_isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = $bebd28704f2536ea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bebd28704f2536ea$var$_getPrototypeOf(this).constructor;
            result = $bebd28704f2536ea$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bebd28704f2536ea$var$_possibleConstructorReturn(this, result);
    };
}
function $bebd28704f2536ea$var$_isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !$bebd28704f2536ea$var$_Reflect$construct) return false;
    if ($bebd28704f2536ea$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($bebd28704f2536ea$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * @augments CentralGravitySolver
 */ var $bebd28704f2536ea$var$ForceAtlas2BasedCentralGravitySolver = /*#__PURE__*/ function(_CentralGravitySolver) {
    $bebd28704f2536ea$var$_inherits(ForceAtlas2BasedCentralGravitySolver, _CentralGravitySolver);
    var _super = $bebd28704f2536ea$var$_createSuper$2(ForceAtlas2BasedCentralGravitySolver);
    /**
   * @param {object} body
   * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
   * @param {object} options
   */ function ForceAtlas2BasedCentralGravitySolver(body, physicsBody, options) {
        $bebd28704f2536ea$var$_classCallCheck(this, ForceAtlas2BasedCentralGravitySolver);
        return _super.call(this, body, physicsBody, options);
    }
    /**
   * Calculate the forces based on the distance.
   *
   * @param {number} distance
   * @param {number} dx
   * @param {number} dy
   * @param {Object<Node.id, Node>} forces
   * @param {Node} node
   * @private
   */ $bebd28704f2536ea$var$_createClass(ForceAtlas2BasedCentralGravitySolver, [
        {
            key: "_calculateForces",
            value: function _calculateForces(distance, dx, dy, forces, node) {
                if (distance > 0) {
                    var degree = node.edges.length + 1;
                    var gravityForce = this.options.centralGravity * degree * node.options.mass;
                    forces[node.id].x = dx * gravityForce;
                    forces[node.id].y = dy * gravityForce;
                }
            }
        }
    ]);
    return ForceAtlas2BasedCentralGravitySolver;
}($bebd28704f2536ea$var$CentralGravitySolver);
/**
 * The physics engine
 */ var $bebd28704f2536ea$var$PhysicsEngine = /*#__PURE__*/ function() {
    /**
   * @param {object} body
   */ function PhysicsEngine(body) {
        $bebd28704f2536ea$var$_classCallCheck(this, PhysicsEngine);
        this.body = body;
        this.physicsBody = {
            physicsNodeIndices: [],
            physicsEdgeIndices: [],
            forces: {},
            velocities: {}
        };
        this.physicsEnabled = true;
        this.simulationInterval = 1000 / 60;
        this.requiresTimeout = true;
        this.previousStates = {};
        this.referenceState = {};
        this.freezeCache = {};
        this.renderTimer = undefined;
        // parameters for the adaptive timestep
        this.adaptiveTimestep = false;
        this.adaptiveTimestepEnabled = false;
        this.adaptiveCounter = 0;
        this.adaptiveInterval = 3;
        this.stabilized = false;
        this.startedStabilization = false;
        this.stabilizationIterations = 0;
        this.ready = false; // will be set to true if the stabilize
        // default options
        this.options = {};
        this.defaultOptions = {
            enabled: true,
            barnesHut: {
                theta: 0.5,
                gravitationalConstant: -2000,
                centralGravity: 0.3,
                springLength: 95,
                springConstant: 0.04,
                damping: 0.09,
                avoidOverlap: 0
            },
            forceAtlas2Based: {
                theta: 0.5,
                gravitationalConstant: -50,
                centralGravity: 0.01,
                springConstant: 0.08,
                springLength: 100,
                damping: 0.4,
                avoidOverlap: 0
            },
            repulsion: {
                centralGravity: 0.2,
                springLength: 200,
                springConstant: 0.05,
                nodeDistance: 100,
                damping: 0.09,
                avoidOverlap: 0
            },
            hierarchicalRepulsion: {
                centralGravity: 0.0,
                springLength: 100,
                springConstant: 0.01,
                nodeDistance: 120,
                damping: 0.09
            },
            maxVelocity: 50,
            minVelocity: 0.75,
            // px/s
            solver: "barnesHut",
            stabilization: {
                enabled: true,
                iterations: 1000,
                // maximum number of iteration to stabilize
                updateInterval: 50,
                onlyDynamicEdges: false,
                fit: true
            },
            timestep: 0.5,
            adaptiveTimestep: true,
            wind: {
                x: 0,
                y: 0
            }
        };
        $bebd28704f2536ea$var$_Object$assign(this.options, this.defaultOptions);
        this.timestep = 0.5;
        this.layoutFailed = false;
        this.bindEventListeners();
    }
    /**
   * Binds event listeners
   */ $bebd28704f2536ea$var$_createClass(PhysicsEngine, [
        {
            key: "bindEventListeners",
            value: function bindEventListeners() {
                var _this = this;
                this.body.emitter.on("initPhysics", function() {
                    _this.initPhysics();
                });
                this.body.emitter.on("_layoutFailed", function() {
                    _this.layoutFailed = true;
                });
                this.body.emitter.on("resetPhysics", function() {
                    _this.stopSimulation();
                    _this.ready = false;
                });
                this.body.emitter.on("disablePhysics", function() {
                    _this.physicsEnabled = false;
                    _this.stopSimulation();
                });
                this.body.emitter.on("restorePhysics", function() {
                    _this.setOptions(_this.options);
                    if (_this.ready === true) _this.startSimulation();
                });
                this.body.emitter.on("startSimulation", function() {
                    if (_this.ready === true) _this.startSimulation();
                });
                this.body.emitter.on("stopSimulation", function() {
                    _this.stopSimulation();
                });
                this.body.emitter.on("destroy", function() {
                    _this.stopSimulation(false);
                    _this.body.emitter.off();
                });
                this.body.emitter.on("_dataChanged", function() {
                    // Nodes and/or edges have been added or removed, update shortcut lists.
                    _this.updatePhysicsData();
                });
            // debug: show forces
            // this.body.emitter.on("afterDrawing", (ctx) => {this._drawForces(ctx);});
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                if (options !== undefined) {
                    if (options === false) {
                        this.options.enabled = false;
                        this.physicsEnabled = false;
                        this.stopSimulation();
                    } else if (options === true) {
                        this.options.enabled = true;
                        this.physicsEnabled = true;
                        this.startSimulation();
                    } else {
                        this.physicsEnabled = true;
                        $bebd28704f2536ea$var$selectiveNotDeepExtend([
                            "stabilization"
                        ], this.options, options);
                        $bebd28704f2536ea$var$mergeOptions(this.options, options, "stabilization");
                        if (options.enabled === undefined) this.options.enabled = true;
                        if (this.options.enabled === false) {
                            this.physicsEnabled = false;
                            this.stopSimulation();
                        }
                        var wind = this.options.wind;
                        if (wind) {
                            if (typeof wind.x !== "number" || $bebd28704f2536ea$var$_Number$isNaN(wind.x)) wind.x = 0;
                            if (typeof wind.y !== "number" || $bebd28704f2536ea$var$_Number$isNaN(wind.y)) wind.y = 0;
                        }
                        // set the timestep
                        this.timestep = this.options.timestep;
                    }
                }
                this.init();
            }
        },
        {
            key: "init",
            value: function init() {
                var options;
                if (this.options.solver === "forceAtlas2Based") {
                    options = this.options.forceAtlas2Based;
                    this.nodesSolver = new $bebd28704f2536ea$var$ForceAtlas2BasedRepulsionSolver(this.body, this.physicsBody, options);
                    this.edgesSolver = new $bebd28704f2536ea$var$SpringSolver(this.body, this.physicsBody, options);
                    this.gravitySolver = new $bebd28704f2536ea$var$ForceAtlas2BasedCentralGravitySolver(this.body, this.physicsBody, options);
                } else if (this.options.solver === "repulsion") {
                    options = this.options.repulsion;
                    this.nodesSolver = new $bebd28704f2536ea$var$RepulsionSolver(this.body, this.physicsBody, options);
                    this.edgesSolver = new $bebd28704f2536ea$var$SpringSolver(this.body, this.physicsBody, options);
                    this.gravitySolver = new $bebd28704f2536ea$var$CentralGravitySolver(this.body, this.physicsBody, options);
                } else if (this.options.solver === "hierarchicalRepulsion") {
                    options = this.options.hierarchicalRepulsion;
                    this.nodesSolver = new $bebd28704f2536ea$var$HierarchicalRepulsionSolver(this.body, this.physicsBody, options);
                    this.edgesSolver = new $bebd28704f2536ea$var$HierarchicalSpringSolver(this.body, this.physicsBody, options);
                    this.gravitySolver = new $bebd28704f2536ea$var$CentralGravitySolver(this.body, this.physicsBody, options);
                } else {
                    // barnesHut
                    options = this.options.barnesHut;
                    this.nodesSolver = new $bebd28704f2536ea$var$BarnesHutSolver(this.body, this.physicsBody, options);
                    this.edgesSolver = new $bebd28704f2536ea$var$SpringSolver(this.body, this.physicsBody, options);
                    this.gravitySolver = new $bebd28704f2536ea$var$CentralGravitySolver(this.body, this.physicsBody, options);
                }
                this.modelOptions = options;
            }
        },
        {
            key: "initPhysics",
            value: function initPhysics() {
                if (this.physicsEnabled === true && this.options.enabled === true) {
                    if (this.options.stabilization.enabled === true) this.stabilize();
                    else {
                        this.stabilized = false;
                        this.ready = true;
                        this.body.emitter.emit("fit", {}, this.layoutFailed); // if the layout failed, we use the approximation for the zoom
                        this.startSimulation();
                    }
                } else {
                    this.ready = true;
                    this.body.emitter.emit("fit");
                }
            }
        },
        {
            key: "startSimulation",
            value: function startSimulation() {
                if (this.physicsEnabled === true && this.options.enabled === true) {
                    this.stabilized = false;
                    // when visible, adaptivity is disabled.
                    this.adaptiveTimestep = false;
                    // this sets the width of all nodes initially which could be required for the avoidOverlap
                    this.body.emitter.emit("_resizeNodes");
                    if (this.viewFunction === undefined) {
                        var _context;
                        this.viewFunction = $bebd28704f2536ea$var$_bindInstanceProperty$1(_context = this.simulationStep).call(_context, this);
                        this.body.emitter.on("initRedraw", this.viewFunction);
                        this.body.emitter.emit("_startRendering");
                    }
                } else this.body.emitter.emit("_redraw");
            }
        },
        {
            key: "stopSimulation",
            value: function stopSimulation() {
                var emit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                this.stabilized = true;
                if (emit === true) this._emitStabilized();
                if (this.viewFunction !== undefined) {
                    this.body.emitter.off("initRedraw", this.viewFunction);
                    this.viewFunction = undefined;
                    if (emit === true) this.body.emitter.emit("_stopRendering");
                }
            }
        },
        {
            key: "simulationStep",
            value: function simulationStep() {
                // check if the physics have settled
                var startTime = $bebd28704f2536ea$var$_Date$now();
                this.physicsTick();
                var physicsTime = $bebd28704f2536ea$var$_Date$now() - startTime;
                // run double speed if it is a little graph
                if ((physicsTime < 0.4 * this.simulationInterval || this.runDoubleSpeed === true) && this.stabilized === false) {
                    this.physicsTick();
                    // this makes sure there is no jitter. The decision is taken once to run it at double speed.
                    this.runDoubleSpeed = true;
                }
                if (this.stabilized === true) this.stopSimulation();
            }
        },
        {
            key: "_emitStabilized",
            value: function _emitStabilized() {
                var _this2 = this;
                var amountOfIterations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.stabilizationIterations;
                if (this.stabilizationIterations > 1 || this.startedStabilization === true) $bebd28704f2536ea$var$_setTimeout(function() {
                    _this2.body.emitter.emit("stabilized", {
                        iterations: amountOfIterations
                    });
                    _this2.startedStabilization = false;
                    _this2.stabilizationIterations = 0;
                }, 0);
            }
        },
        {
            key: "physicsStep",
            value: function physicsStep() {
                this.gravitySolver.solve();
                this.nodesSolver.solve();
                this.edgesSolver.solve();
                this.moveNodes();
            }
        },
        {
            key: "adjustTimeStep",
            value: function adjustTimeStep() {
                var factor = 1.2; // Factor for increasing the timestep on success.
                // we compare the two steps. if it is acceptable we double the step.
                if (this._evaluateStepQuality() === true) this.timestep = factor * this.timestep;
                else // if not, we decrease the step to a minimum of the options timestep.
                // if the decreased timestep is smaller than the options step, we do not reset the counter
                // we assume that the options timestep is stable enough.
                if (this.timestep / factor < this.options.timestep) this.timestep = this.options.timestep;
                else {
                    // if the timestep was larger than 2 times the option one we check the adaptivity again to ensure
                    // that large instabilities do not form.
                    this.adaptiveCounter = -1; // check again next iteration
                    this.timestep = Math.max(this.options.timestep, this.timestep / factor);
                }
            }
        },
        {
            key: "physicsTick",
            value: function physicsTick() {
                this._startStabilizing(); // this ensures that there is no start event when the network is already stable.
                if (this.stabilized === true) return;
                // adaptivity means the timestep adapts to the situation, only applicable for stabilization
                if (this.adaptiveTimestep === true && this.adaptiveTimestepEnabled === true) {
                    // timestep remains stable for "interval" iterations.
                    var doAdaptive = this.adaptiveCounter % this.adaptiveInterval === 0;
                    if (doAdaptive) {
                        // first the big step and revert.
                        this.timestep = 2 * this.timestep;
                        this.physicsStep();
                        this.revert(); // saves the reference state
                        // now the normal step. Since this is the last step, it is the more stable one and we will take this.
                        this.timestep = 0.5 * this.timestep;
                        // since it's half the step, we do it twice.
                        this.physicsStep();
                        this.physicsStep();
                        this.adjustTimeStep();
                    } else this.physicsStep(); // normal step, keeping timestep constant
                    this.adaptiveCounter += 1;
                } else {
                    // case for the static timestep, we reset it to the one in options and take a normal step.
                    this.timestep = this.options.timestep;
                    this.physicsStep();
                }
                if (this.stabilized === true) this.revert();
                this.stabilizationIterations++;
            }
        },
        {
            key: "updatePhysicsData",
            value: function updatePhysicsData() {
                this.physicsBody.forces = {};
                this.physicsBody.physicsNodeIndices = [];
                this.physicsBody.physicsEdgeIndices = [];
                var nodes = this.body.nodes;
                var edges = this.body.edges;
                // get node indices for physics
                for(var nodeId in nodes){
                    if (Object.prototype.hasOwnProperty.call(nodes, nodeId)) {
                        if (nodes[nodeId].options.physics === true) this.physicsBody.physicsNodeIndices.push(nodes[nodeId].id);
                    }
                }
                // get edge indices for physics
                for(var edgeId in edges){
                    if (Object.prototype.hasOwnProperty.call(edges, edgeId)) {
                        if (edges[edgeId].options.physics === true) this.physicsBody.physicsEdgeIndices.push(edges[edgeId].id);
                    }
                }
                // get the velocity and the forces vector
                for(var i = 0; i < this.physicsBody.physicsNodeIndices.length; i++){
                    var _nodeId = this.physicsBody.physicsNodeIndices[i];
                    this.physicsBody.forces[_nodeId] = {
                        x: 0,
                        y: 0
                    };
                    // forces can be reset because they are recalculated. Velocities have to persist.
                    if (this.physicsBody.velocities[_nodeId] === undefined) this.physicsBody.velocities[_nodeId] = {
                        x: 0,
                        y: 0
                    };
                }
                // clean deleted nodes from the velocity vector
                for(var _nodeId2 in this.physicsBody.velocities)if (nodes[_nodeId2] === undefined) delete this.physicsBody.velocities[_nodeId2];
            }
        },
        {
            key: "revert",
            value: function revert() {
                var nodeIds = $bebd28704f2536ea$var$_Object$keys(this.previousStates);
                var nodes = this.body.nodes;
                var velocities = this.physicsBody.velocities;
                this.referenceState = {};
                for(var i = 0; i < nodeIds.length; i++){
                    var nodeId = nodeIds[i];
                    if (nodes[nodeId] !== undefined) {
                        if (nodes[nodeId].options.physics === true) {
                            this.referenceState[nodeId] = {
                                positions: {
                                    x: nodes[nodeId].x,
                                    y: nodes[nodeId].y
                                }
                            };
                            velocities[nodeId].x = this.previousStates[nodeId].vx;
                            velocities[nodeId].y = this.previousStates[nodeId].vy;
                            nodes[nodeId].x = this.previousStates[nodeId].x;
                            nodes[nodeId].y = this.previousStates[nodeId].y;
                        }
                    } else delete this.previousStates[nodeId];
                }
            }
        },
        {
            key: "_evaluateStepQuality",
            value: function _evaluateStepQuality() {
                var dx, dy, dpos;
                var nodes = this.body.nodes;
                var reference = this.referenceState;
                var posThreshold = 0.3;
                for(var nodeId in this.referenceState)if (Object.prototype.hasOwnProperty.call(this.referenceState, nodeId) && nodes[nodeId] !== undefined) {
                    dx = nodes[nodeId].x - reference[nodeId].positions.x;
                    dy = nodes[nodeId].y - reference[nodeId].positions.y;
                    dpos = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
                    if (dpos > posThreshold) return false;
                }
                return true;
            }
        },
        {
            key: "moveNodes",
            value: function moveNodes() {
                var nodeIndices = this.physicsBody.physicsNodeIndices;
                var maxNodeVelocity = 0;
                var averageNodeVelocity = 0;
                // the velocity threshold (energy in the system) for the adaptivity toggle
                var velocityAdaptiveThreshold = 5;
                for(var i = 0; i < nodeIndices.length; i++){
                    var nodeId = nodeIndices[i];
                    var nodeVelocity = this._performStep(nodeId);
                    // stabilized is true if stabilized is true and velocity is smaller than vmin --> all nodes must be stabilized
                    maxNodeVelocity = Math.max(maxNodeVelocity, nodeVelocity);
                    averageNodeVelocity += nodeVelocity;
                }
                // evaluating the stabilized and adaptiveTimestepEnabled conditions
                this.adaptiveTimestepEnabled = averageNodeVelocity / nodeIndices.length < velocityAdaptiveThreshold;
                this.stabilized = maxNodeVelocity < this.options.minVelocity;
            }
        },
        {
            key: "calculateComponentVelocity",
            value: function calculateComponentVelocity(v, f, m) {
                var df = this.modelOptions.damping * v; // damping force
                var a = (f - df) / m; // acceleration
                v += a * this.timestep;
                // Put a limit on the velocities if it is really high
                var maxV = this.options.maxVelocity || 1e9;
                if (Math.abs(v) > maxV) v = v > 0 ? maxV : -maxV;
                return v;
            }
        },
        {
            key: "_performStep",
            value: function _performStep(nodeId) {
                var node = this.body.nodes[nodeId];
                var force = this.physicsBody.forces[nodeId];
                if (this.options.wind) {
                    force.x += this.options.wind.x;
                    force.y += this.options.wind.y;
                }
                var velocity = this.physicsBody.velocities[nodeId];
                // store the state so we can revert
                this.previousStates[nodeId] = {
                    x: node.x,
                    y: node.y,
                    vx: velocity.x,
                    vy: velocity.y
                };
                if (node.options.fixed.x === false) {
                    velocity.x = this.calculateComponentVelocity(velocity.x, force.x, node.options.mass);
                    node.x += velocity.x * this.timestep;
                } else {
                    force.x = 0;
                    velocity.x = 0;
                }
                if (node.options.fixed.y === false) {
                    velocity.y = this.calculateComponentVelocity(velocity.y, force.y, node.options.mass);
                    node.y += velocity.y * this.timestep;
                } else {
                    force.y = 0;
                    velocity.y = 0;
                }
                var totalVelocity = Math.sqrt(Math.pow(velocity.x, 2) + Math.pow(velocity.y, 2));
                return totalVelocity;
            }
        },
        {
            key: "_freezeNodes",
            value: function _freezeNodes() {
                var nodes = this.body.nodes;
                for(var id in nodes){
                    if (Object.prototype.hasOwnProperty.call(nodes, id)) {
                        if (nodes[id].x && nodes[id].y) {
                            var fixed = nodes[id].options.fixed;
                            this.freezeCache[id] = {
                                x: fixed.x,
                                y: fixed.y
                            };
                            fixed.x = true;
                            fixed.y = true;
                        }
                    }
                }
            }
        },
        {
            key: "_restoreFrozenNodes",
            value: function _restoreFrozenNodes() {
                var nodes = this.body.nodes;
                for(var id in nodes){
                    if (Object.prototype.hasOwnProperty.call(nodes, id)) {
                        if (this.freezeCache[id] !== undefined) {
                            nodes[id].options.fixed.x = this.freezeCache[id].x;
                            nodes[id].options.fixed.y = this.freezeCache[id].y;
                        }
                    }
                }
                this.freezeCache = {};
            }
        },
        {
            key: "stabilize",
            value: function stabilize() {
                var _this3 = this;
                var iterations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.stabilization.iterations;
                if (typeof iterations !== "number") {
                    iterations = this.options.stabilization.iterations;
                    console.error("The stabilize method needs a numeric amount of iterations. Switching to default: ", iterations);
                }
                if (this.physicsBody.physicsNodeIndices.length === 0) {
                    this.ready = true;
                    return;
                }
                // enable adaptive timesteps
                this.adaptiveTimestep = this.options.adaptiveTimestep;
                // this sets the width of all nodes initially which could be required for the avoidOverlap
                this.body.emitter.emit("_resizeNodes");
                this.stopSimulation(); // stop the render loop
                this.stabilized = false;
                // block redraw requests
                this.body.emitter.emit("_blockRedraw");
                this.targetIterations = iterations;
                // start the stabilization
                if (this.options.stabilization.onlyDynamicEdges === true) this._freezeNodes();
                this.stabilizationIterations = 0;
                $bebd28704f2536ea$var$_setTimeout(function() {
                    return _this3._stabilizationBatch();
                }, 0);
            }
        },
        {
            key: "_startStabilizing",
            value: function _startStabilizing() {
                if (this.startedStabilization === true) return false;
                this.body.emitter.emit("startStabilizing");
                this.startedStabilization = true;
                return true;
            }
        },
        {
            key: "_stabilizationBatch",
            value: function _stabilizationBatch() {
                var _this4 = this;
                var running = function running() {
                    return _this4.stabilized === false && _this4.stabilizationIterations < _this4.targetIterations;
                };
                var sendProgress = function sendProgress() {
                    _this4.body.emitter.emit("stabilizationProgress", {
                        iterations: _this4.stabilizationIterations,
                        total: _this4.targetIterations
                    });
                };
                if (this._startStabilizing()) sendProgress(); // Ensure that there is at least one start event.
                var count = 0;
                while(running() && count < this.options.stabilization.updateInterval){
                    this.physicsTick();
                    count++;
                }
                sendProgress();
                if (running()) {
                    var _context2;
                    $bebd28704f2536ea$var$_setTimeout($bebd28704f2536ea$var$_bindInstanceProperty$1(_context2 = this._stabilizationBatch).call(_context2, this), 0);
                } else this._finalizeStabilization();
            }
        },
        {
            key: "_finalizeStabilization",
            value: function _finalizeStabilization() {
                this.body.emitter.emit("_allowRedraw");
                if (this.options.stabilization.fit === true) this.body.emitter.emit("fit");
                if (this.options.stabilization.onlyDynamicEdges === true) this._restoreFrozenNodes();
                this.body.emitter.emit("stabilizationIterationsDone");
                this.body.emitter.emit("_requestRedraw");
                if (this.stabilized === true) this._emitStabilized();
                else this.startSimulation();
                this.ready = true;
            }
        },
        {
            key: "_drawForces",
            value: function _drawForces(ctx) {
                for(var i = 0; i < this.physicsBody.physicsNodeIndices.length; i++){
                    var index = this.physicsBody.physicsNodeIndices[i];
                    var node = this.body.nodes[index];
                    var force = this.physicsBody.forces[index];
                    var factor = 20;
                    var colorFactor = 0.03;
                    var forceSize = Math.sqrt(Math.pow(force.x, 2) + Math.pow(force.x, 2));
                    var size = Math.min(Math.max(5, forceSize), 15);
                    var arrowSize = 3 * size;
                    var color = $bebd28704f2536ea$var$HSVToHex((180 - Math.min(1, Math.max(0, colorFactor * forceSize)) * 180) / 360, 1, 1);
                    var point = {
                        x: node.x + factor * force.x,
                        y: node.y + factor * force.y
                    };
                    ctx.lineWidth = size;
                    ctx.strokeStyle = color;
                    ctx.beginPath();
                    ctx.moveTo(node.x, node.y);
                    ctx.lineTo(point.x, point.y);
                    ctx.stroke();
                    var angle = Math.atan2(force.y, force.x);
                    ctx.fillStyle = color;
                    $bebd28704f2536ea$var$EndPoints.draw(ctx, {
                        type: "arrow",
                        point: point,
                        angle: angle,
                        length: arrowSize
                    });
                    $bebd28704f2536ea$var$_fillInstanceProperty(ctx).call(ctx);
                }
            }
        }
    ]);
    return PhysicsEngine;
}();
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $bebd28704f2536ea$var$getRandomValues;
const $bebd28704f2536ea$var$rnds8 = new Uint8Array(16);
function $bebd28704f2536ea$var$rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$bebd28704f2536ea$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $bebd28704f2536ea$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$bebd28704f2536ea$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $bebd28704f2536ea$var$getRandomValues($bebd28704f2536ea$var$rnds8);
}
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $bebd28704f2536ea$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$bebd28704f2536ea$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $bebd28704f2536ea$var$unsafeStringify(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $bebd28704f2536ea$var$byteToHex[arr[offset + 0]] + $bebd28704f2536ea$var$byteToHex[arr[offset + 1]] + $bebd28704f2536ea$var$byteToHex[arr[offset + 2]] + $bebd28704f2536ea$var$byteToHex[arr[offset + 3]] + '-' + $bebd28704f2536ea$var$byteToHex[arr[offset + 4]] + $bebd28704f2536ea$var$byteToHex[arr[offset + 5]] + '-' + $bebd28704f2536ea$var$byteToHex[arr[offset + 6]] + $bebd28704f2536ea$var$byteToHex[arr[offset + 7]] + '-' + $bebd28704f2536ea$var$byteToHex[arr[offset + 8]] + $bebd28704f2536ea$var$byteToHex[arr[offset + 9]] + '-' + $bebd28704f2536ea$var$byteToHex[arr[offset + 10]] + $bebd28704f2536ea$var$byteToHex[arr[offset + 11]] + $bebd28704f2536ea$var$byteToHex[arr[offset + 12]] + $bebd28704f2536ea$var$byteToHex[arr[offset + 13]] + $bebd28704f2536ea$var$byteToHex[arr[offset + 14]] + $bebd28704f2536ea$var$byteToHex[arr[offset + 15]];
}
const $bebd28704f2536ea$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $bebd28704f2536ea$var$native = {
    randomUUID: $bebd28704f2536ea$var$randomUUID
};
function $bebd28704f2536ea$var$v4(options, buf, offset) {
    if ($bebd28704f2536ea$var$native.randomUUID && !buf && !options) return $bebd28704f2536ea$var$native.randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || $bebd28704f2536ea$var$rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return $bebd28704f2536ea$var$unsafeStringify(rnds);
}
/**
 * Utility Class
 */ var $bebd28704f2536ea$var$NetworkUtil = /*#__PURE__*/ function() {
    /**
   * @ignore
   */ function NetworkUtil() {
        $bebd28704f2536ea$var$_classCallCheck(this, NetworkUtil);
    }
    /**
   * Find the center position of the network considering the bounding boxes
   *
   * @param {Array.<Node>} allNodes
   * @param {Array.<Node>} [specificNodes=[]]
   * @returns {{minX: number, maxX: number, minY: number, maxY: number}}
   * @static
   */ $bebd28704f2536ea$var$_createClass(NetworkUtil, null, [
        {
            key: "getRange",
            value: function getRange(allNodes) {
                var specificNodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                var minY = 1e9, maxY = -1000000000, minX = 1e9, maxX = -1000000000, node;
                if (specificNodes.length > 0) for(var i = 0; i < specificNodes.length; i++){
                    node = allNodes[specificNodes[i]];
                    if (minX > node.shape.boundingBox.left) minX = node.shape.boundingBox.left;
                    if (maxX < node.shape.boundingBox.right) maxX = node.shape.boundingBox.right;
                    if (minY > node.shape.boundingBox.top) minY = node.shape.boundingBox.top;
                     // top is negative, bottom is positive
                    if (maxY < node.shape.boundingBox.bottom) maxY = node.shape.boundingBox.bottom;
                     // top is negative, bottom is positive
                }
                if (minX === 1e9 && maxX === -1000000000 && minY === 1e9 && maxY === -1000000000) minY = 0, maxY = 0, minX = 0, maxX = 0;
                return {
                    minX: minX,
                    maxX: maxX,
                    minY: minY,
                    maxY: maxY
                };
            }
        },
        {
            key: "getRangeCore",
            value: function getRangeCore(allNodes) {
                var specificNodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                var minY = 1e9, maxY = -1000000000, minX = 1e9, maxX = -1000000000, node;
                if (specificNodes.length > 0) for(var i = 0; i < specificNodes.length; i++){
                    node = allNodes[specificNodes[i]];
                    if (minX > node.x) minX = node.x;
                    if (maxX < node.x) maxX = node.x;
                    if (minY > node.y) minY = node.y;
                     // top is negative, bottom is positive
                    if (maxY < node.y) maxY = node.y;
                     // top is negative, bottom is positive
                }
                if (minX === 1e9 && maxX === -1000000000 && minY === 1e9 && maxY === -1000000000) minY = 0, maxY = 0, minX = 0, maxX = 0;
                return {
                    minX: minX,
                    maxX: maxX,
                    minY: minY,
                    maxY: maxY
                };
            }
        },
        {
            key: "findCenter",
            value: function findCenter(range) {
                return {
                    x: 0.5 * (range.maxX + range.minX),
                    y: 0.5 * (range.maxY + range.minY)
                };
            }
        },
        {
            key: "cloneOptions",
            value: function cloneOptions(item, type) {
                var clonedOptions = {};
                if (type === undefined || type === "node") {
                    $bebd28704f2536ea$var$deepExtend(clonedOptions, item.options, true);
                    clonedOptions.x = item.x;
                    clonedOptions.y = item.y;
                    clonedOptions.amountOfConnections = item.edges.length;
                } else $bebd28704f2536ea$var$deepExtend(clonedOptions, item.options, true);
                return clonedOptions;
            }
        }
    ]);
    return NetworkUtil;
}();
function $bebd28704f2536ea$var$_createSuper$1(Derived) {
    var hasNativeReflectConstruct = $bebd28704f2536ea$var$_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = $bebd28704f2536ea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bebd28704f2536ea$var$_getPrototypeOf(this).constructor;
            result = $bebd28704f2536ea$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bebd28704f2536ea$var$_possibleConstructorReturn(this, result);
    };
}
function $bebd28704f2536ea$var$_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !$bebd28704f2536ea$var$_Reflect$construct) return false;
    if ($bebd28704f2536ea$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($bebd28704f2536ea$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * A Cluster is a special Node that allows a group of Nodes positioned closely together
 * to be represented by a single Cluster Node.
 *
 * @augments Node
 */ var $bebd28704f2536ea$var$Cluster = /*#__PURE__*/ function(_Node) {
    $bebd28704f2536ea$var$_inherits(Cluster, _Node);
    var _super = $bebd28704f2536ea$var$_createSuper$1(Cluster);
    /**
   * @param {object} options
   * @param {object} body
   * @param {Array.<HTMLImageElement>}imagelist
   * @param {Array} grouplist
   * @param {object} globalOptions
   * @param {object} defaultOptions     Global default options for nodes
   */ function Cluster(options, body, imagelist, grouplist, globalOptions, defaultOptions) {
        var _this;
        $bebd28704f2536ea$var$_classCallCheck(this, Cluster);
        _this = _super.call(this, options, body, imagelist, grouplist, globalOptions, defaultOptions);
        _this.isCluster = true;
        _this.containedNodes = {};
        _this.containedEdges = {};
        return _this;
    }
    /**
   * Transfer child cluster data to current and disconnect the child cluster.
   *
   * Please consult the header comment in 'Clustering.js' for the fields set here.
   *
   * @param {string|number} childClusterId  id of child cluster to open
   */ $bebd28704f2536ea$var$_createClass(Cluster, [
        {
            key: "_openChildCluster",
            value: function _openChildCluster(childClusterId) {
                var _this2 = this;
                var childCluster = this.body.nodes[childClusterId];
                if (this.containedNodes[childClusterId] === undefined) throw new Error("node with id: " + childClusterId + " not in current cluster");
                if (!childCluster.isCluster) throw new Error("node with id: " + childClusterId + " is not a cluster");
                // Disconnect child cluster from current cluster
                delete this.containedNodes[childClusterId];
                $bebd28704f2536ea$var$forEach$1(childCluster.edges, function(edge) {
                    delete _this2.containedEdges[edge.id];
                });
                // Transfer nodes and edges
                $bebd28704f2536ea$var$forEach$1(childCluster.containedNodes, function(node, nodeId) {
                    _this2.containedNodes[nodeId] = node;
                });
                childCluster.containedNodes = {};
                $bebd28704f2536ea$var$forEach$1(childCluster.containedEdges, function(edge, edgeId) {
                    _this2.containedEdges[edgeId] = edge;
                });
                childCluster.containedEdges = {};
                // Transfer edges within cluster edges which are clustered
                $bebd28704f2536ea$var$forEach$1(childCluster.edges, function(clusterEdge) {
                    $bebd28704f2536ea$var$forEach$1(_this2.edges, function(parentClusterEdge) {
                        var _context, _context2;
                        // Assumption: a clustered edge can only be present in a single clustering edge
                        // Not tested here
                        var index = $bebd28704f2536ea$var$_indexOfInstanceProperty(_context = parentClusterEdge.clusteringEdgeReplacingIds).call(_context, clusterEdge.id);
                        if (index === -1) return;
                        $bebd28704f2536ea$var$forEach$1(clusterEdge.clusteringEdgeReplacingIds, function(srcId) {
                            parentClusterEdge.clusteringEdgeReplacingIds.push(srcId);
                            // Maintain correct bookkeeping for transferred edge
                            _this2.body.edges[srcId].edgeReplacedById = parentClusterEdge.id;
                        });
                        // Remove cluster edge from parent cluster edge
                        $bebd28704f2536ea$var$_spliceInstanceProperty(_context2 = parentClusterEdge.clusteringEdgeReplacingIds).call(_context2, index, 1);
                    });
                });
                childCluster.edges = [];
            }
        }
    ]);
    return Cluster;
}($bebd28704f2536ea$var$Node);
/**
 * The clustering engine
 */ var $bebd28704f2536ea$var$ClusterEngine = /*#__PURE__*/ function() {
    /**
   * @param {object} body
   */ function ClusterEngine(body) {
        var _this = this;
        $bebd28704f2536ea$var$_classCallCheck(this, ClusterEngine);
        this.body = body;
        this.clusteredNodes = {}; // key: node id, value: { clusterId: <id of cluster>, node: <node instance>}
        this.clusteredEdges = {}; // key: edge id, value: restore information for given edge
        this.options = {};
        this.defaultOptions = {};
        $bebd28704f2536ea$var$_Object$assign(this.options, this.defaultOptions);
        this.body.emitter.on("_resetData", function() {
            _this.clusteredNodes = {};
            _this.clusteredEdges = {};
        });
    }
    /**
   *
   * @param {number} hubsize
   * @param {object} options
   */ $bebd28704f2536ea$var$_createClass(ClusterEngine, [
        {
            key: "clusterByHubsize",
            value: function clusterByHubsize(hubsize, options) {
                if (hubsize === undefined) hubsize = this._getHubSize();
                else if ($bebd28704f2536ea$var$_typeof(hubsize) === "object") {
                    options = this._checkOptions(hubsize);
                    hubsize = this._getHubSize();
                }
                var nodesToCluster = [];
                for(var i = 0; i < this.body.nodeIndices.length; i++){
                    var node = this.body.nodes[this.body.nodeIndices[i]];
                    if (node.edges.length >= hubsize) nodesToCluster.push(node.id);
                }
                for(var _i = 0; _i < nodesToCluster.length; _i++)this.clusterByConnection(nodesToCluster[_i], options, true);
                this.body.emitter.emit("_dataChanged");
            }
        },
        {
            key: "cluster",
            value: function cluster() {
                var _this2 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var refreshData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                if (options.joinCondition === undefined) throw new Error("Cannot call clusterByNodeData without a joinCondition function in the options.");
                // check if the options object is fine, append if needed
                options = this._checkOptions(options);
                var childNodesObj = {};
                var childEdgesObj = {};
                // collect the nodes that will be in the cluster
                $bebd28704f2536ea$var$forEach$1(this.body.nodes, function(node, nodeId) {
                    if (node.options && options.joinCondition(node.options) === true) {
                        childNodesObj[nodeId] = node;
                        // collect the edges that will be in the cluster
                        $bebd28704f2536ea$var$forEach$1(node.edges, function(edge) {
                            if (_this2.clusteredEdges[edge.id] === undefined) childEdgesObj[edge.id] = edge;
                        });
                    }
                });
                this._cluster(childNodesObj, childEdgesObj, options, refreshData);
            }
        },
        {
            key: "clusterByEdgeCount",
            value: function clusterByEdgeCount(edgeCount, options) {
                var _this3 = this;
                var refreshData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
                options = this._checkOptions(options);
                var clusters = [];
                var usedNodes = {};
                var edge, edges, relevantEdgeCount;
                // collect the nodes that will be in the cluster
                var _loop = function _loop() {
                    var childNodesObj = {};
                    var childEdgesObj = {};
                    var nodeId = _this3.body.nodeIndices[i];
                    var node = _this3.body.nodes[nodeId];
                    // if this node is already used in another cluster this session, we do not have to re-evaluate it.
                    if (usedNodes[nodeId] === undefined) {
                        relevantEdgeCount = 0;
                        edges = [];
                        for(var j = 0; j < node.edges.length; j++){
                            edge = node.edges[j];
                            if (_this3.clusteredEdges[edge.id] === undefined) {
                                if (edge.toId !== edge.fromId) relevantEdgeCount++;
                                edges.push(edge);
                            }
                        }
                        // this node qualifies, we collect its neighbours to start the clustering process.
                        if (relevantEdgeCount === edgeCount) {
                            var checkJoinCondition = function checkJoinCondition(node) {
                                if (options.joinCondition === undefined || options.joinCondition === null) return true;
                                var clonedOptions = $bebd28704f2536ea$var$NetworkUtil.cloneOptions(node);
                                return options.joinCondition(clonedOptions);
                            };
                            var gatheringSuccessful = true;
                            for(var _j = 0; _j < edges.length; _j++){
                                edge = edges[_j];
                                var childNodeId = _this3._getConnectedId(edge, nodeId);
                                // add the nodes to the list by the join condition.
                                if (checkJoinCondition(node)) {
                                    childEdgesObj[edge.id] = edge;
                                    childNodesObj[nodeId] = node;
                                    childNodesObj[childNodeId] = _this3.body.nodes[childNodeId];
                                    usedNodes[nodeId] = true;
                                } else {
                                    // this node does not qualify after all.
                                    gatheringSuccessful = false;
                                    break;
                                }
                            }
                            // add to the cluster queue
                            if ($bebd28704f2536ea$var$_Object$keys(childNodesObj).length > 0 && $bebd28704f2536ea$var$_Object$keys(childEdgesObj).length > 0 && gatheringSuccessful === true) {
                                /**
               * Search for cluster data that contains any of the node id's
               *
               * @returns {boolean} true if no joinCondition, otherwise return value of joinCondition
               */ var findClusterData = function findClusterData() {
                                    for(var n = 0; n < clusters.length; ++n)// Search for a cluster containing any of the node id's
                                    for(var m in childNodesObj){
                                        if (clusters[n].nodes[m] !== undefined) return clusters[n];
                                    }
                                    return undefined;
                                };
                                // If any of the found nodes is part of a cluster found in this method,
                                // add the current values to that cluster
                                var foundCluster = findClusterData();
                                if (foundCluster !== undefined) {
                                    // Add nodes to found cluster if not present
                                    for(var m in childNodesObj)if (foundCluster.nodes[m] === undefined) foundCluster.nodes[m] = childNodesObj[m];
                                    // Add edges to found cluster, if not present
                                    for(var _m in childEdgesObj)if (foundCluster.edges[_m] === undefined) foundCluster.edges[_m] = childEdgesObj[_m];
                                } else // Create a new cluster group
                                clusters.push({
                                    nodes: childNodesObj,
                                    edges: childEdgesObj
                                });
                            }
                        }
                    }
                };
                for(var i = 0; i < this.body.nodeIndices.length; i++)_loop();
                for(var _i2 = 0; _i2 < clusters.length; _i2++)this._cluster(clusters[_i2].nodes, clusters[_i2].edges, options, false);
                if (refreshData === true) this.body.emitter.emit("_dataChanged");
            }
        },
        {
            key: "clusterOutliers",
            value: function clusterOutliers(options) {
                var refreshData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                this.clusterByEdgeCount(1, options, refreshData);
            }
        },
        {
            key: "clusterBridges",
            value: function clusterBridges(options) {
                var refreshData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                this.clusterByEdgeCount(2, options, refreshData);
            }
        },
        {
            key: "clusterByConnection",
            value: function clusterByConnection(nodeId, options) {
                var _context;
                var refreshData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
                // kill conditions
                if (nodeId === undefined) throw new Error("No nodeId supplied to clusterByConnection!");
                if (this.body.nodes[nodeId] === undefined) throw new Error("The nodeId given to clusterByConnection does not exist!");
                var node = this.body.nodes[nodeId];
                options = this._checkOptions(options, node);
                if (options.clusterNodeProperties.x === undefined) options.clusterNodeProperties.x = node.x;
                if (options.clusterNodeProperties.y === undefined) options.clusterNodeProperties.y = node.y;
                if (options.clusterNodeProperties.fixed === undefined) {
                    options.clusterNodeProperties.fixed = {};
                    options.clusterNodeProperties.fixed.x = node.options.fixed.x;
                    options.clusterNodeProperties.fixed.y = node.options.fixed.y;
                }
                var childNodesObj = {};
                var childEdgesObj = {};
                var parentNodeId = node.id;
                var parentClonedOptions = $bebd28704f2536ea$var$NetworkUtil.cloneOptions(node);
                childNodesObj[parentNodeId] = node;
                // collect the nodes that will be in the cluster
                for(var i = 0; i < node.edges.length; i++){
                    var edge = node.edges[i];
                    if (this.clusteredEdges[edge.id] === undefined) {
                        var childNodeId = this._getConnectedId(edge, parentNodeId);
                        // if the child node is not in a cluster
                        if (this.clusteredNodes[childNodeId] === undefined) {
                            if (childNodeId !== parentNodeId) {
                                if (options.joinCondition === undefined) {
                                    childEdgesObj[edge.id] = edge;
                                    childNodesObj[childNodeId] = this.body.nodes[childNodeId];
                                } else {
                                    // clone the options and insert some additional parameters that could be interesting.
                                    var childClonedOptions = $bebd28704f2536ea$var$NetworkUtil.cloneOptions(this.body.nodes[childNodeId]);
                                    if (options.joinCondition(parentClonedOptions, childClonedOptions) === true) {
                                        childEdgesObj[edge.id] = edge;
                                        childNodesObj[childNodeId] = this.body.nodes[childNodeId];
                                    }
                                }
                            } else // swallow the edge if it is self-referencing.
                            childEdgesObj[edge.id] = edge;
                        }
                    }
                }
                var childNodeIDs = $bebd28704f2536ea$var$_mapInstanceProperty(_context = $bebd28704f2536ea$var$_Object$keys(childNodesObj)).call(_context, function(childNode) {
                    return childNodesObj[childNode].id;
                });
                for(var childNodeKey in childNodesObj){
                    if (!Object.prototype.hasOwnProperty.call(childNodesObj, childNodeKey)) continue;
                    var childNode = childNodesObj[childNodeKey];
                    for(var y = 0; y < childNode.edges.length; y++){
                        var childEdge = childNode.edges[y];
                        if ($bebd28704f2536ea$var$_indexOfInstanceProperty(childNodeIDs).call(childNodeIDs, this._getConnectedId(childEdge, childNode.id)) > -1) childEdgesObj[childEdge.id] = childEdge;
                    }
                }
                this._cluster(childNodesObj, childEdgesObj, options, refreshData);
            }
        },
        {
            key: "_createClusterEdges",
            value: function _createClusterEdges(childNodesObj, childEdgesObj, clusterNodeProperties, clusterEdgeProperties) {
                var edge, childNodeId, childNode, toId, fromId, otherNodeId;
                // loop over all child nodes and their edges to find edges going out of the cluster
                // these edges will be replaced by clusterEdges.
                var childKeys = $bebd28704f2536ea$var$_Object$keys(childNodesObj);
                var createEdges = [];
                for(var i = 0; i < childKeys.length; i++){
                    childNodeId = childKeys[i];
                    childNode = childNodesObj[childNodeId];
                    // construct new edges from the cluster to others
                    for(var j = 0; j < childNode.edges.length; j++){
                        edge = childNode.edges[j];
                        // we only handle edges that are visible to the system, not the disabled ones from the clustering process.
                        if (this.clusteredEdges[edge.id] === undefined) {
                            // self-referencing edges will be added to the "hidden" list
                            if (edge.toId == edge.fromId) childEdgesObj[edge.id] = edge;
                            else // set up the from and to.
                            if (edge.toId == childNodeId) {
                                // this is a double equals because ints and strings can be interchanged here.
                                toId = clusterNodeProperties.id;
                                fromId = edge.fromId;
                                otherNodeId = fromId;
                            } else {
                                toId = edge.toId;
                                fromId = clusterNodeProperties.id;
                                otherNodeId = toId;
                            }
                            // Only edges from the cluster outwards are being replaced.
                            if (childNodesObj[otherNodeId] === undefined) createEdges.push({
                                edge: edge,
                                fromId: fromId,
                                toId: toId
                            });
                        }
                    }
                }
                //
                // Here we actually create the replacement edges.
                //
                // We could not do this in the loop above as the creation process
                // would add an edge to the edges array we are iterating over.
                //
                // NOTE: a clustered edge can have multiple base edges!
                //
                var newEdges = [];
                /**
       * Find a cluster edge which matches the given created edge.
       *
       * @param {vis.Edge} createdEdge
       * @returns {vis.Edge}
       */ var getNewEdge = function getNewEdge(createdEdge) {
                    for(var _j2 = 0; _j2 < newEdges.length; _j2++){
                        var newEdge = newEdges[_j2];
                        // We replace both to and from edges with a single cluster edge
                        var matchToDirection = createdEdge.fromId === newEdge.fromId && createdEdge.toId === newEdge.toId;
                        var matchFromDirection = createdEdge.fromId === newEdge.toId && createdEdge.toId === newEdge.fromId;
                        if (matchToDirection || matchFromDirection) return newEdge;
                    }
                    return null;
                };
                for(var _j3 = 0; _j3 < createEdges.length; _j3++){
                    var createdEdge = createEdges[_j3];
                    var _edge = createdEdge.edge;
                    var newEdge = getNewEdge(createdEdge);
                    if (newEdge === null) {
                        // Create a clustered edge for this connection
                        newEdge = this._createClusteredEdge(createdEdge.fromId, createdEdge.toId, _edge, clusterEdgeProperties);
                        newEdges.push(newEdge);
                    } else newEdge.clusteringEdgeReplacingIds.push(_edge.id);
                    // also reference the new edge in the old edge
                    this.body.edges[_edge.id].edgeReplacedById = newEdge.id;
                    // hide the replaced edge
                    this._backupEdgeOptions(_edge);
                    _edge.setOptions({
                        physics: false
                    });
                }
            }
        },
        {
            key: "_checkOptions",
            value: function _checkOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (options.clusterEdgeProperties === undefined) options.clusterEdgeProperties = {};
                if (options.clusterNodeProperties === undefined) options.clusterNodeProperties = {};
                return options;
            }
        },
        {
            key: "_cluster",
            value: function _cluster(childNodesObj, childEdgesObj, options) {
                var refreshData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
                // Remove nodes which are already clustered
                var tmpNodesToRemove = [];
                for(var nodeId in childNodesObj){
                    if (Object.prototype.hasOwnProperty.call(childNodesObj, nodeId)) {
                        if (this.clusteredNodes[nodeId] !== undefined) tmpNodesToRemove.push(nodeId);
                    }
                }
                for(var n = 0; n < tmpNodesToRemove.length; ++n)delete childNodesObj[tmpNodesToRemove[n]];
                // kill condition: no nodes don't bother
                if ($bebd28704f2536ea$var$_Object$keys(childNodesObj).length == 0) return;
                // allow clusters of 1 if options allow
                if ($bebd28704f2536ea$var$_Object$keys(childNodesObj).length == 1 && options.clusterNodeProperties.allowSingleNodeCluster != true) return;
                var clusterNodeProperties = $bebd28704f2536ea$var$deepExtend({}, options.clusterNodeProperties);
                // construct the clusterNodeProperties
                if (options.processProperties !== undefined) {
                    // get the childNode options
                    var childNodesOptions = [];
                    for(var _nodeId in childNodesObj)if (Object.prototype.hasOwnProperty.call(childNodesObj, _nodeId)) {
                        var clonedOptions = $bebd28704f2536ea$var$NetworkUtil.cloneOptions(childNodesObj[_nodeId]);
                        childNodesOptions.push(clonedOptions);
                    }
                    // get cluster properties based on childNodes
                    var childEdgesOptions = [];
                    for(var edgeId in childEdgesObj){
                        if (Object.prototype.hasOwnProperty.call(childEdgesObj, edgeId)) // these cluster edges will be removed on creation of the cluster.
                        {
                            if (edgeId.substr(0, 12) !== "clusterEdge:") {
                                var _clonedOptions = $bebd28704f2536ea$var$NetworkUtil.cloneOptions(childEdgesObj[edgeId], "edge");
                                childEdgesOptions.push(_clonedOptions);
                            }
                        }
                    }
                    clusterNodeProperties = options.processProperties(clusterNodeProperties, childNodesOptions, childEdgesOptions);
                    if (!clusterNodeProperties) throw new Error("The processProperties function does not return properties!");
                }
                // check if we have an unique id;
                if (clusterNodeProperties.id === undefined) clusterNodeProperties.id = "cluster:" + $bebd28704f2536ea$var$v4();
                var clusterId = clusterNodeProperties.id;
                if (clusterNodeProperties.label === undefined) clusterNodeProperties.label = "cluster";
                // give the clusterNode a position if it does not have one.
                var pos = undefined;
                if (clusterNodeProperties.x === undefined) {
                    pos = this._getClusterPosition(childNodesObj);
                    clusterNodeProperties.x = pos.x;
                }
                if (clusterNodeProperties.y === undefined) {
                    if (pos === undefined) pos = this._getClusterPosition(childNodesObj);
                    clusterNodeProperties.y = pos.y;
                }
                // force the ID to remain the same
                clusterNodeProperties.id = clusterId;
                // create the cluster Node
                // Note that allowSingleNodeCluster, if present, is stored in the options as well
                var clusterNode = this.body.functions.createNode(clusterNodeProperties, $bebd28704f2536ea$var$Cluster);
                clusterNode.containedNodes = childNodesObj;
                clusterNode.containedEdges = childEdgesObj;
                // cache a copy from the cluster edge properties if we have to reconnect others later on
                clusterNode.clusterEdgeProperties = options.clusterEdgeProperties;
                // finally put the cluster node into global
                this.body.nodes[clusterNodeProperties.id] = clusterNode;
                this._clusterEdges(childNodesObj, childEdgesObj, clusterNodeProperties, options.clusterEdgeProperties);
                // set ID to undefined so no duplicates arise
                clusterNodeProperties.id = undefined;
                // wrap up
                if (refreshData === true) this.body.emitter.emit("_dataChanged");
            }
        },
        {
            key: "_backupEdgeOptions",
            value: function _backupEdgeOptions(edge) {
                if (this.clusteredEdges[edge.id] === undefined) this.clusteredEdges[edge.id] = {
                    physics: edge.options.physics
                };
            }
        },
        {
            key: "_restoreEdge",
            value: function _restoreEdge(edge) {
                var originalOptions = this.clusteredEdges[edge.id];
                if (originalOptions !== undefined) {
                    edge.setOptions({
                        physics: originalOptions.physics
                    });
                    delete this.clusteredEdges[edge.id];
                }
            }
        },
        {
            key: "isCluster",
            value: function isCluster(nodeId) {
                if (this.body.nodes[nodeId] !== undefined) return this.body.nodes[nodeId].isCluster === true;
                else {
                    console.error("Node does not exist.");
                    return false;
                }
            }
        },
        {
            key: "_getClusterPosition",
            value: function _getClusterPosition(childNodesObj) {
                var childKeys = $bebd28704f2536ea$var$_Object$keys(childNodesObj);
                var minX = childNodesObj[childKeys[0]].x;
                var maxX = childNodesObj[childKeys[0]].x;
                var minY = childNodesObj[childKeys[0]].y;
                var maxY = childNodesObj[childKeys[0]].y;
                var node;
                for(var i = 1; i < childKeys.length; i++){
                    node = childNodesObj[childKeys[i]];
                    minX = node.x < minX ? node.x : minX;
                    maxX = node.x > maxX ? node.x : maxX;
                    minY = node.y < minY ? node.y : minY;
                    maxY = node.y > maxY ? node.y : maxY;
                }
                return {
                    x: 0.5 * (minX + maxX),
                    y: 0.5 * (minY + maxY)
                };
            }
        },
        {
            key: "openCluster",
            value: function openCluster(clusterNodeId, options) {
                var refreshData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
                // kill conditions
                if (clusterNodeId === undefined) throw new Error("No clusterNodeId supplied to openCluster.");
                var clusterNode = this.body.nodes[clusterNodeId];
                if (clusterNode === undefined) throw new Error("The clusterNodeId supplied to openCluster does not exist.");
                if (clusterNode.isCluster !== true || clusterNode.containedNodes === undefined || clusterNode.containedEdges === undefined) throw new Error("The node:" + clusterNodeId + " is not a valid cluster.");
                // Check if current cluster is clustered itself
                var stack = this.findNode(clusterNodeId);
                var parentIndex = $bebd28704f2536ea$var$_indexOfInstanceProperty(stack).call(stack, clusterNodeId) - 1;
                if (parentIndex >= 0) {
                    // Current cluster is clustered; transfer contained nodes and edges to parent
                    var parentClusterNodeId = stack[parentIndex];
                    var parentClusterNode = this.body.nodes[parentClusterNodeId];
                    // clustering.clusteredNodes and clustering.clusteredEdges remain unchanged
                    parentClusterNode._openChildCluster(clusterNodeId);
                    // All components of child cluster node have been transferred. It can die now.
                    delete this.body.nodes[clusterNodeId];
                    if (refreshData === true) this.body.emitter.emit("_dataChanged");
                    return;
                }
                // main body
                var containedNodes = clusterNode.containedNodes;
                var containedEdges = clusterNode.containedEdges;
                // allow the user to position the nodes after release.
                if (options !== undefined && options.releaseFunction !== undefined && typeof options.releaseFunction === "function") {
                    var positions = {};
                    var clusterPosition = {
                        x: clusterNode.x,
                        y: clusterNode.y
                    };
                    for(var nodeId in containedNodes)if (Object.prototype.hasOwnProperty.call(containedNodes, nodeId)) {
                        var containedNode = this.body.nodes[nodeId];
                        positions[nodeId] = {
                            x: containedNode.x,
                            y: containedNode.y
                        };
                    }
                    var newPositions = options.releaseFunction(clusterPosition, positions);
                    for(var _nodeId2 in containedNodes)if (Object.prototype.hasOwnProperty.call(containedNodes, _nodeId2)) {
                        var _containedNode = this.body.nodes[_nodeId2];
                        if (newPositions[_nodeId2] !== undefined) {
                            _containedNode.x = newPositions[_nodeId2].x === undefined ? clusterNode.x : newPositions[_nodeId2].x;
                            _containedNode.y = newPositions[_nodeId2].y === undefined ? clusterNode.y : newPositions[_nodeId2].y;
                        }
                    }
                } else // copy the position from the cluster
                $bebd28704f2536ea$var$forEach$1(containedNodes, function(containedNode) {
                    // inherit position
                    if (containedNode.options.fixed.x === false) containedNode.x = clusterNode.x;
                    if (containedNode.options.fixed.y === false) containedNode.y = clusterNode.y;
                });
                // release nodes
                for(var _nodeId3 in containedNodes)if (Object.prototype.hasOwnProperty.call(containedNodes, _nodeId3)) {
                    var _containedNode2 = this.body.nodes[_nodeId3];
                    // inherit speed
                    _containedNode2.vx = clusterNode.vx;
                    _containedNode2.vy = clusterNode.vy;
                    _containedNode2.setOptions({
                        physics: true
                    });
                    delete this.clusteredNodes[_nodeId3];
                }
                // copy the clusterNode edges because we cannot iterate over an object that we add or remove from.
                var edgesToBeDeleted = [];
                for(var i = 0; i < clusterNode.edges.length; i++)edgesToBeDeleted.push(clusterNode.edges[i]);
                // actually handling the deleting.
                for(var _i3 = 0; _i3 < edgesToBeDeleted.length; _i3++){
                    var edge = edgesToBeDeleted[_i3];
                    var otherNodeId = this._getConnectedId(edge, clusterNodeId);
                    var otherNode = this.clusteredNodes[otherNodeId];
                    for(var j = 0; j < edge.clusteringEdgeReplacingIds.length; j++){
                        var transferId = edge.clusteringEdgeReplacingIds[j];
                        var transferEdge = this.body.edges[transferId];
                        if (transferEdge === undefined) continue;
                        // if the other node is in another cluster, we transfer ownership of this edge to the other cluster
                        if (otherNode !== undefined) {
                            // transfer ownership:
                            var otherCluster = this.body.nodes[otherNode.clusterId];
                            otherCluster.containedEdges[transferEdge.id] = transferEdge;
                            // delete local reference
                            delete containedEdges[transferEdge.id];
                            // get to and from
                            var fromId = transferEdge.fromId;
                            var toId = transferEdge.toId;
                            if (transferEdge.toId == otherNodeId) toId = otherNode.clusterId;
                            else fromId = otherNode.clusterId;
                            // create new cluster edge from the otherCluster
                            this._createClusteredEdge(fromId, toId, transferEdge, otherCluster.clusterEdgeProperties, {
                                hidden: false,
                                physics: true
                            });
                        } else this._restoreEdge(transferEdge);
                    }
                    edge.remove();
                }
                // handle the releasing of the edges
                for(var edgeId in containedEdges)if (Object.prototype.hasOwnProperty.call(containedEdges, edgeId)) this._restoreEdge(containedEdges[edgeId]);
                // remove clusterNode
                delete this.body.nodes[clusterNodeId];
                if (refreshData === true) this.body.emitter.emit("_dataChanged");
            }
        },
        {
            key: "getNodesInCluster",
            value: function getNodesInCluster(clusterId) {
                var nodesArray = [];
                if (this.isCluster(clusterId) === true) {
                    var containedNodes = this.body.nodes[clusterId].containedNodes;
                    for(var nodeId in containedNodes)if (Object.prototype.hasOwnProperty.call(containedNodes, nodeId)) nodesArray.push(this.body.nodes[nodeId].id);
                }
                return nodesArray;
            }
        },
        {
            key: "findNode",
            value: function findNode(nodeId) {
                var stack = [];
                var max = 100;
                var counter = 0;
                var node;
                while(this.clusteredNodes[nodeId] !== undefined && counter < max){
                    node = this.body.nodes[nodeId];
                    if (node === undefined) return [];
                    stack.push(node.id);
                    nodeId = this.clusteredNodes[nodeId].clusterId;
                    counter++;
                }
                node = this.body.nodes[nodeId];
                if (node === undefined) return [];
                stack.push(node.id);
                $bebd28704f2536ea$var$_reverseInstanceProperty(stack).call(stack);
                return stack;
            }
        },
        {
            key: "updateClusteredNode",
            value: function updateClusteredNode(clusteredNodeId, newOptions) {
                if (clusteredNodeId === undefined) throw new Error("No clusteredNodeId supplied to updateClusteredNode.");
                if (newOptions === undefined) throw new Error("No newOptions supplied to updateClusteredNode.");
                if (this.body.nodes[clusteredNodeId] === undefined) throw new Error("The clusteredNodeId supplied to updateClusteredNode does not exist.");
                this.body.nodes[clusteredNodeId].setOptions(newOptions);
                this.body.emitter.emit("_dataChanged");
            }
        },
        {
            key: "updateEdge",
            value: function updateEdge(startEdgeId, newOptions) {
                if (startEdgeId === undefined) throw new Error("No startEdgeId supplied to updateEdge.");
                if (newOptions === undefined) throw new Error("No newOptions supplied to updateEdge.");
                if (this.body.edges[startEdgeId] === undefined) throw new Error("The startEdgeId supplied to updateEdge does not exist.");
                var allEdgeIds = this.getClusteredEdges(startEdgeId);
                for(var i = 0; i < allEdgeIds.length; i++){
                    var edge = this.body.edges[allEdgeIds[i]];
                    edge.setOptions(newOptions);
                }
                this.body.emitter.emit("_dataChanged");
            }
        },
        {
            key: "getClusteredEdges",
            value: function getClusteredEdges(edgeId) {
                var stack = [];
                var max = 100;
                var counter = 0;
                while(edgeId !== undefined && this.body.edges[edgeId] !== undefined && counter < max){
                    stack.push(this.body.edges[edgeId].id);
                    edgeId = this.body.edges[edgeId].edgeReplacedById;
                    counter++;
                }
                $bebd28704f2536ea$var$_reverseInstanceProperty(stack).call(stack);
                return stack;
            }
        },
        {
            key: "getBaseEdge",
            value: function getBaseEdge(clusteredEdgeId) {
                // Just kludge this by returning the first base edge id found
                return this.getBaseEdges(clusteredEdgeId)[0];
            }
        },
        {
            key: "getBaseEdges",
            value: function getBaseEdges(clusteredEdgeId) {
                var IdsToHandle = [
                    clusteredEdgeId
                ];
                var doneIds = [];
                var foundIds = [];
                var max = 100;
                var counter = 0;
                while(IdsToHandle.length > 0 && counter < max){
                    var nextId = IdsToHandle.pop();
                    if (nextId === undefined) continue; // Paranoia here and onwards
                    var nextEdge = this.body.edges[nextId];
                    if (nextEdge === undefined) continue;
                    counter++;
                    var replacingIds = nextEdge.clusteringEdgeReplacingIds;
                    if (replacingIds === undefined) // nextId is a base id
                    foundIds.push(nextId);
                    else // Another cluster edge, unravel this one as well
                    for(var i = 0; i < replacingIds.length; ++i){
                        var replacingId = replacingIds[i];
                        // Don't add if already handled
                        // TODO: never triggers; find a test-case which does
                        if ($bebd28704f2536ea$var$_indexOfInstanceProperty(IdsToHandle).call(IdsToHandle, replacingIds) !== -1 || $bebd28704f2536ea$var$_indexOfInstanceProperty(doneIds).call(doneIds, replacingIds) !== -1) continue;
                        IdsToHandle.push(replacingId);
                    }
                    doneIds.push(nextId);
                }
                return foundIds;
            }
        },
        {
            key: "_getConnectedId",
            value: function _getConnectedId(edge, nodeId) {
                if (edge.toId != nodeId) return edge.toId;
                else if (edge.fromId != nodeId) return edge.fromId;
                else return edge.fromId;
            }
        },
        {
            key: "_getHubSize",
            value: function _getHubSize() {
                var average = 0;
                var averageSquared = 0;
                var hubCounter = 0;
                var largestHub = 0;
                for(var i = 0; i < this.body.nodeIndices.length; i++){
                    var node = this.body.nodes[this.body.nodeIndices[i]];
                    if (node.edges.length > largestHub) largestHub = node.edges.length;
                    average += node.edges.length;
                    averageSquared += Math.pow(node.edges.length, 2);
                    hubCounter += 1;
                }
                average = average / hubCounter;
                averageSquared = averageSquared / hubCounter;
                var variance = averageSquared - Math.pow(average, 2);
                var standardDeviation = Math.sqrt(variance);
                var hubThreshold = Math.floor(average + 2 * standardDeviation);
                // always have at least one to cluster
                if (hubThreshold > largestHub) hubThreshold = largestHub;
                return hubThreshold;
            }
        },
        {
            key: "_createClusteredEdge",
            value: function _createClusteredEdge(fromId, toId, baseEdge, clusterEdgeProperties, extraOptions) {
                // copy the options of the edge we will replace
                var clonedOptions = $bebd28704f2536ea$var$NetworkUtil.cloneOptions(baseEdge, "edge");
                // make sure the properties of clusterEdges are superimposed on it
                $bebd28704f2536ea$var$deepExtend(clonedOptions, clusterEdgeProperties);
                // set up the edge
                clonedOptions.from = fromId;
                clonedOptions.to = toId;
                clonedOptions.id = "clusterEdge:" + $bebd28704f2536ea$var$v4();
                // apply the edge specific options to it if specified
                if (extraOptions !== undefined) $bebd28704f2536ea$var$deepExtend(clonedOptions, extraOptions);
                var newEdge = this.body.functions.createEdge(clonedOptions);
                newEdge.clusteringEdgeReplacingIds = [
                    baseEdge.id
                ];
                newEdge.connect();
                // Register the new edge
                this.body.edges[newEdge.id] = newEdge;
                return newEdge;
            }
        },
        {
            key: "_clusterEdges",
            value: function _clusterEdges(childNodes, childEdges, clusterNode, clusterEdgeProperties) {
                if (childEdges instanceof $bebd28704f2536ea$var$Edge) {
                    var edge = childEdges;
                    var obj = {};
                    obj[edge.id] = edge;
                    childEdges = obj;
                }
                if (childNodes instanceof $bebd28704f2536ea$var$Node) {
                    var node = childNodes;
                    var _obj = {};
                    _obj[node.id] = node;
                    childNodes = _obj;
                }
                if (clusterNode === undefined || clusterNode === null) throw new Error("_clusterEdges: parameter clusterNode required");
                if (clusterEdgeProperties === undefined) // Take the required properties from the cluster node
                clusterEdgeProperties = clusterNode.clusterEdgeProperties;
                // create the new edges that will connect to the cluster.
                // All self-referencing edges will be added to childEdges here.
                this._createClusterEdges(childNodes, childEdges, clusterNode, clusterEdgeProperties);
                // disable the childEdges
                for(var edgeId in childEdges){
                    if (Object.prototype.hasOwnProperty.call(childEdges, edgeId)) {
                        if (this.body.edges[edgeId] !== undefined) {
                            var _edge2 = this.body.edges[edgeId];
                            // cache the options before changing
                            this._backupEdgeOptions(_edge2);
                            // disable physics and hide the edge
                            _edge2.setOptions({
                                physics: false
                            });
                        }
                    }
                }
                // disable the childNodes
                for(var nodeId in childNodes)if (Object.prototype.hasOwnProperty.call(childNodes, nodeId)) {
                    this.clusteredNodes[nodeId] = {
                        clusterId: clusterNode.id,
                        node: this.body.nodes[nodeId]
                    };
                    this.body.nodes[nodeId].setOptions({
                        physics: false
                    });
                }
            }
        },
        {
            key: "_getClusterNodeForNode",
            value: function _getClusterNodeForNode(nodeId) {
                if (nodeId === undefined) return undefined;
                var clusteredNode = this.clusteredNodes[nodeId];
                // NOTE: If no cluster info found, it should actually be an error
                if (clusteredNode === undefined) return undefined;
                var clusterId = clusteredNode.clusterId;
                if (clusterId === undefined) return undefined;
                return this.body.nodes[clusterId];
            }
        },
        {
            key: "_filter",
            value: function _filter(arr, callback) {
                var ret = [];
                $bebd28704f2536ea$var$forEach$1(arr, function(item) {
                    if (callback(item)) ret.push(item);
                });
                return ret;
            }
        },
        {
            key: "_updateState",
            value: function _updateState() {
                var _this4 = this;
                var nodeId;
                var deletedNodeIds = [];
                var deletedEdgeIds = {};
                /**
       * Utility function to iterate over clustering nodes only
       *
       * @param {Function} callback  function to call for each cluster node
       */ var eachClusterNode = function eachClusterNode(callback) {
                    $bebd28704f2536ea$var$forEach$1(_this4.body.nodes, function(node) {
                        if (node.isCluster === true) callback(node);
                    });
                };
                //
                // Remove deleted regular nodes from clustering
                //
                // Determine the deleted nodes
                for(nodeId in this.clusteredNodes){
                    if (!Object.prototype.hasOwnProperty.call(this.clusteredNodes, nodeId)) continue;
                    var node = this.body.nodes[nodeId];
                    if (node === undefined) deletedNodeIds.push(nodeId);
                }
                // Remove nodes from cluster nodes
                eachClusterNode(function(clusterNode) {
                    for(var n = 0; n < deletedNodeIds.length; n++)delete clusterNode.containedNodes[deletedNodeIds[n]];
                });
                // Remove nodes from cluster list
                for(var n = 0; n < deletedNodeIds.length; n++)delete this.clusteredNodes[deletedNodeIds[n]];
                //
                // Remove deleted edges from clustering
                //
                // Add the deleted clustered edges to the list
                $bebd28704f2536ea$var$forEach$1(this.clusteredEdges, function(edgeId) {
                    var edge = _this4.body.edges[edgeId];
                    if (edge === undefined || !edge.endPointsValid()) deletedEdgeIds[edgeId] = edgeId;
                });
                // Cluster nodes can also contain edges which are not clustered,
                // i.e. nodes 1-2 within cluster with an edge in between.
                // So the cluster nodes also need to be scanned for invalid edges
                eachClusterNode(function(clusterNode) {
                    $bebd28704f2536ea$var$forEach$1(clusterNode.containedEdges, function(edge, edgeId) {
                        if (!edge.endPointsValid() && !deletedEdgeIds[edgeId]) deletedEdgeIds[edgeId] = edgeId;
                    });
                });
                // Also scan for cluster edges which need to be removed in the active list.
                // Regular edges have been removed beforehand, so this only picks up the cluster edges.
                $bebd28704f2536ea$var$forEach$1(this.body.edges, function(edge, edgeId) {
                    // Explicitly scan the contained edges for validity
                    var isValid = true;
                    var replacedIds = edge.clusteringEdgeReplacingIds;
                    if (replacedIds !== undefined) {
                        var numValid = 0;
                        $bebd28704f2536ea$var$forEach$1(replacedIds, function(containedEdgeId) {
                            var containedEdge = _this4.body.edges[containedEdgeId];
                            if (containedEdge !== undefined && containedEdge.endPointsValid()) numValid += 1;
                        });
                        isValid = numValid > 0;
                    }
                    if (!edge.endPointsValid() || !isValid) deletedEdgeIds[edgeId] = edgeId;
                });
                // Remove edges from cluster nodes
                eachClusterNode(function(clusterNode) {
                    $bebd28704f2536ea$var$forEach$1(deletedEdgeIds, function(deletedEdgeId) {
                        delete clusterNode.containedEdges[deletedEdgeId];
                        $bebd28704f2536ea$var$forEach$1(clusterNode.edges, function(edge, m) {
                            if (edge.id === deletedEdgeId) {
                                clusterNode.edges[m] = null; // Don't want to directly delete here, because in the loop
                                return;
                            }
                            edge.clusteringEdgeReplacingIds = _this4._filter(edge.clusteringEdgeReplacingIds, function(id) {
                                return !deletedEdgeIds[id];
                            });
                        });
                        // Clean up the nulls
                        clusterNode.edges = _this4._filter(clusterNode.edges, function(item) {
                            return item !== null;
                        });
                    });
                });
                // Remove from cluster list
                $bebd28704f2536ea$var$forEach$1(deletedEdgeIds, function(edgeId) {
                    delete _this4.clusteredEdges[edgeId];
                });
                // Remove cluster edges from active list (this.body.edges).
                // deletedEdgeIds still contains id of regular edges, but these should all
                // be gone when you reach here.
                $bebd28704f2536ea$var$forEach$1(deletedEdgeIds, function(edgeId) {
                    delete _this4.body.edges[edgeId];
                });
                //
                // Check changed cluster state of edges
                //
                // Iterating over keys here, because edges may be removed in the loop
                var ids = $bebd28704f2536ea$var$_Object$keys(this.body.edges);
                $bebd28704f2536ea$var$forEach$1(ids, function(edgeId) {
                    var edge = _this4.body.edges[edgeId];
                    var shouldBeClustered = _this4._isClusteredNode(edge.fromId) || _this4._isClusteredNode(edge.toId);
                    if (shouldBeClustered === _this4._isClusteredEdge(edge.id)) return; // all is well
                    if (shouldBeClustered) {
                        // add edge to clustering
                        var clusterFrom = _this4._getClusterNodeForNode(edge.fromId);
                        if (clusterFrom !== undefined) _this4._clusterEdges(_this4.body.nodes[edge.fromId], edge, clusterFrom);
                        var clusterTo = _this4._getClusterNodeForNode(edge.toId);
                        if (clusterTo !== undefined) _this4._clusterEdges(_this4.body.nodes[edge.toId], edge, clusterTo);
                    // TODO: check that it works for both edges clustered
                    //       (This might be paranoia)
                    } else {
                        delete _this4._clusterEdges[edgeId];
                        _this4._restoreEdge(edge);
                    // This should not be happening, the state should
                    // be properly updated at this point.
                    //
                    // If it *is* reached during normal operation, then we have to implement
                    // undo clustering for this edge here.
                    // throw new Error('remove edge from clustering not implemented!')
                    }
                });
                // Clusters may be nested to any level. Keep on opening until nothing to open
                var changed = false;
                var continueLoop = true;
                var _loop2 = function _loop2() {
                    var clustersToOpen = [];
                    // Determine the id's of clusters that need opening
                    eachClusterNode(function(clusterNode) {
                        var numNodes = $bebd28704f2536ea$var$_Object$keys(clusterNode.containedNodes).length;
                        var allowSingle = clusterNode.options.allowSingleNodeCluster === true;
                        if (allowSingle && numNodes < 1 || !allowSingle && numNodes < 2) clustersToOpen.push(clusterNode.id);
                    });
                    // Open them
                    for(var _n = 0; _n < clustersToOpen.length; ++_n)_this4.openCluster(clustersToOpen[_n], {}, false);
                    continueLoop = clustersToOpen.length > 0;
                    changed = changed || continueLoop;
                };
                while(continueLoop)_loop2();
                if (changed) this._updateState(); // Redo this method (recursion possible! should be safe)
            }
        },
        {
            key: "_isClusteredNode",
            value: function _isClusteredNode(nodeId) {
                return this.clusteredNodes[nodeId] !== undefined;
            }
        },
        {
            key: "_isClusteredEdge",
            value: function _isClusteredEdge(edgeId) {
                return this.clusteredEdges[edgeId] !== undefined;
            }
        }
    ]);
    return ClusterEngine;
}();
/**
 * Initializes window.requestAnimationFrame() to a usable form.
 *
 * Specifically, set up this method for the case of running on node.js with jsdom enabled.
 *
 * NOTES:
 *
 * On node.js, when calling this directly outside of this class, `window` is not defined.
 *   This happens even if jsdom is used.
 * For node.js + jsdom, `window` is available at the moment the constructor is called.
 *   For this reason, the called is placed within the constructor.
 * Even then, `window.requestAnimationFrame()` is not defined, so it still needs to be added.
 * During unit testing, it happens that the window object is reset during execution, causing
 *   a runtime error due to missing `requestAnimationFrame()`. This needs to be compensated for,
 *   see `_requestNextFrame()`.
 * Since this is a global object, it may affect other modules besides `Network`. With normal
 *   usage, this does not cause any problems. During unit testing, errors may occur. These have
 *   been compensated for, see comment block in _requestNextFrame().
 *
 * @private
 */ function $bebd28704f2536ea$var$_initRequestAnimationFrame() {
    var func;
    if (window !== undefined) func = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
    if (func === undefined) // window or method not present, setting mock requestAnimationFrame
    window.requestAnimationFrame = function(callback) {
        //console.log("Called mock requestAnimationFrame");
        callback();
    };
    else window.requestAnimationFrame = func;
}
/**
 * The canvas renderer
 */ var $bebd28704f2536ea$var$CanvasRenderer = /*#__PURE__*/ function() {
    /**
   * @param {object} body
   * @param {Canvas} canvas
   */ function CanvasRenderer(body, canvas) {
        $bebd28704f2536ea$var$_classCallCheck(this, CanvasRenderer);
        $bebd28704f2536ea$var$_initRequestAnimationFrame();
        this.body = body;
        this.canvas = canvas;
        this.redrawRequested = false;
        this.renderTimer = undefined;
        this.requiresTimeout = true;
        this.renderingActive = false;
        this.renderRequests = 0;
        this.allowRedraw = true;
        this.dragging = false;
        this.zooming = false;
        this.options = {};
        this.defaultOptions = {
            hideEdgesOnDrag: false,
            hideEdgesOnZoom: false,
            hideNodesOnDrag: false
        };
        $bebd28704f2536ea$var$_Object$assign(this.options, this.defaultOptions);
        this._determineBrowserMethod();
        this.bindEventListeners();
    }
    /**
   * Binds event listeners
   */ $bebd28704f2536ea$var$_createClass(CanvasRenderer, [
        {
            key: "bindEventListeners",
            value: function bindEventListeners() {
                var _this = this, _context2;
                this.body.emitter.on("dragStart", function() {
                    _this.dragging = true;
                });
                this.body.emitter.on("dragEnd", function() {
                    _this.dragging = false;
                });
                this.body.emitter.on("zoom", function() {
                    _this.zooming = true;
                    window.clearTimeout(_this.zoomTimeoutId);
                    _this.zoomTimeoutId = $bebd28704f2536ea$var$_setTimeout(function() {
                        var _context;
                        _this.zooming = false;
                        $bebd28704f2536ea$var$_bindInstanceProperty$1(_context = _this._requestRedraw).call(_context, _this)();
                    }, 250);
                });
                this.body.emitter.on("_resizeNodes", function() {
                    _this._resizeNodes();
                });
                this.body.emitter.on("_redraw", function() {
                    if (_this.renderingActive === false) _this._redraw();
                });
                this.body.emitter.on("_blockRedraw", function() {
                    _this.allowRedraw = false;
                });
                this.body.emitter.on("_allowRedraw", function() {
                    _this.allowRedraw = true;
                    _this.redrawRequested = false;
                });
                this.body.emitter.on("_requestRedraw", $bebd28704f2536ea$var$_bindInstanceProperty$1(_context2 = this._requestRedraw).call(_context2, this));
                this.body.emitter.on("_startRendering", function() {
                    _this.renderRequests += 1;
                    _this.renderingActive = true;
                    _this._startRendering();
                });
                this.body.emitter.on("_stopRendering", function() {
                    _this.renderRequests -= 1;
                    _this.renderingActive = _this.renderRequests > 0;
                    _this.renderTimer = undefined;
                });
                this.body.emitter.on("destroy", function() {
                    _this.renderRequests = 0;
                    _this.allowRedraw = false;
                    _this.renderingActive = false;
                    if (_this.requiresTimeout === true) clearTimeout(_this.renderTimer);
                    else window.cancelAnimationFrame(_this.renderTimer);
                    _this.body.emitter.off();
                });
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                if (options !== undefined) {
                    var fields = [
                        "hideEdgesOnDrag",
                        "hideEdgesOnZoom",
                        "hideNodesOnDrag"
                    ];
                    $bebd28704f2536ea$var$selectiveDeepExtend(fields, this.options, options);
                }
            }
        },
        {
            key: "_requestNextFrame",
            value: function _requestNextFrame(callback, delay) {
                // During unit testing, it happens that the mock window object is reset while
                // the next frame is still pending. Then, either 'window' is not present, or
                // 'requestAnimationFrame()' is not present because it is not defined on the
                // mock window object.
                //
                // As a consequence, unrelated unit tests may appear to fail, even if the problem
                // described happens in the current unit test.
                //
                // This is not something that will happen in normal operation, but we still need
                // to take it into account.
                //
                if (typeof window === "undefined") return; // Doing `if (window === undefined)` does not work here!
                var timer;
                var myWindow = window; // Grab a reference to reduce the possibility that 'window' is reset
                // while running this method.
                if (this.requiresTimeout === true) // wait given number of milliseconds and perform the animation step function
                timer = $bebd28704f2536ea$var$_setTimeout(callback, delay);
                else if (myWindow.requestAnimationFrame) timer = myWindow.requestAnimationFrame(callback);
                return timer;
            }
        },
        {
            key: "_startRendering",
            value: function _startRendering() {
                if (this.renderingActive === true) {
                    if (this.renderTimer === undefined) {
                        var _context3;
                        this.renderTimer = this._requestNextFrame($bebd28704f2536ea$var$_bindInstanceProperty$1(_context3 = this._renderStep).call(_context3, this), this.simulationInterval);
                    }
                }
            }
        },
        {
            key: "_renderStep",
            value: function _renderStep() {
                if (this.renderingActive === true) {
                    // reset the renderTimer so a new scheduled animation step can be set
                    this.renderTimer = undefined;
                    if (this.requiresTimeout === true) // this schedules a new simulation step
                    this._startRendering();
                    this._redraw();
                    if (this.requiresTimeout === false) // this schedules a new simulation step
                    this._startRendering();
                }
            }
        },
        {
            key: "redraw",
            value: function redraw() {
                this.body.emitter.emit("setSize");
                this._redraw();
            }
        },
        {
            key: "_requestRedraw",
            value: function _requestRedraw() {
                var _this2 = this;
                if (this.redrawRequested !== true && this.renderingActive === false && this.allowRedraw === true) {
                    this.redrawRequested = true;
                    this._requestNextFrame(function() {
                        _this2._redraw(false);
                    }, 0);
                }
            }
        },
        {
            key: "_redraw",
            value: function _redraw() {
                var hidden = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                if (this.allowRedraw === true) {
                    this.body.emitter.emit("initRedraw");
                    this.redrawRequested = false;
                    var drawLater = {
                        drawExternalLabels: null
                    };
                    // when the container div was hidden, this fixes it back up!
                    if (this.canvas.frame.canvas.width === 0 || this.canvas.frame.canvas.height === 0) this.canvas.setSize();
                    this.canvas.setTransform();
                    var ctx = this.canvas.getContext();
                    // clear the canvas
                    var w = this.canvas.frame.canvas.clientWidth;
                    var h = this.canvas.frame.canvas.clientHeight;
                    ctx.clearRect(0, 0, w, h);
                    // if the div is hidden, we stop the redraw here for performance.
                    if (this.canvas.frame.clientWidth === 0) return;
                    // set scaling and translation
                    ctx.save();
                    ctx.translate(this.body.view.translation.x, this.body.view.translation.y);
                    ctx.scale(this.body.view.scale, this.body.view.scale);
                    ctx.beginPath();
                    this.body.emitter.emit("beforeDrawing", ctx);
                    ctx.closePath();
                    if (hidden === false) {
                        if ((this.dragging === false || this.dragging === true && this.options.hideEdgesOnDrag === false) && (this.zooming === false || this.zooming === true && this.options.hideEdgesOnZoom === false)) this._drawEdges(ctx);
                    }
                    if (this.dragging === false || this.dragging === true && this.options.hideNodesOnDrag === false) {
                        var _this$_drawNodes = this._drawNodes(ctx, hidden), drawExternalLabels = _this$_drawNodes.drawExternalLabels;
                        drawLater.drawExternalLabels = drawExternalLabels;
                    }
                    // draw the arrows last so they will be at the top
                    if (hidden === false) {
                        if ((this.dragging === false || this.dragging === true && this.options.hideEdgesOnDrag === false) && (this.zooming === false || this.zooming === true && this.options.hideEdgesOnZoom === false)) this._drawArrows(ctx);
                    }
                    if (drawLater.drawExternalLabels != null) drawLater.drawExternalLabels();
                    if (hidden === false) this._drawSelectionBox(ctx);
                    ctx.beginPath();
                    this.body.emitter.emit("afterDrawing", ctx);
                    ctx.closePath();
                    // restore original scaling and translation
                    ctx.restore();
                    if (hidden === true) ctx.clearRect(0, 0, w, h);
                }
            }
        },
        {
            key: "_resizeNodes",
            value: function _resizeNodes() {
                this.canvas.setTransform();
                var ctx = this.canvas.getContext();
                ctx.save();
                ctx.translate(this.body.view.translation.x, this.body.view.translation.y);
                ctx.scale(this.body.view.scale, this.body.view.scale);
                var nodes = this.body.nodes;
                var node;
                // resize all nodes
                for(var nodeId in nodes)if (Object.prototype.hasOwnProperty.call(nodes, nodeId)) {
                    node = nodes[nodeId];
                    node.resize(ctx);
                    node.updateBoundingBox(ctx, node.selected);
                }
                // restore original scaling and translation
                ctx.restore();
            }
        },
        {
            key: "_drawNodes",
            value: function _drawNodes(ctx) {
                var alwaysShow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var nodes = this.body.nodes;
                var nodeIndices = this.body.nodeIndices;
                var node;
                var selected = [];
                var hovered = [];
                var margin = 20;
                var topLeft = this.canvas.DOMtoCanvas({
                    x: -margin,
                    y: -margin
                });
                var bottomRight = this.canvas.DOMtoCanvas({
                    x: this.canvas.frame.canvas.clientWidth + margin,
                    y: this.canvas.frame.canvas.clientHeight + margin
                });
                var viewableArea = {
                    top: topLeft.y,
                    left: topLeft.x,
                    bottom: bottomRight.y,
                    right: bottomRight.x
                };
                var _drawExternalLabels = [];
                // draw unselected nodes;
                for(var _i = 0; _i < nodeIndices.length; _i++){
                    node = nodes[nodeIndices[_i]];
                    // set selected and hovered nodes aside
                    if (node.hover) hovered.push(nodeIndices[_i]);
                    else if (node.isSelected()) selected.push(nodeIndices[_i]);
                    else {
                        if (alwaysShow === true) {
                            var drawLater = node.draw(ctx);
                            if (drawLater.drawExternalLabel != null) _drawExternalLabels.push(drawLater.drawExternalLabel);
                        } else if (node.isBoundingBoxOverlappingWith(viewableArea) === true) {
                            var _drawLater = node.draw(ctx);
                            if (_drawLater.drawExternalLabel != null) _drawExternalLabels.push(_drawLater.drawExternalLabel);
                        } else node.updateBoundingBox(ctx, node.selected);
                    }
                }
                var i;
                var selectedLength = selected.length;
                var hoveredLength = hovered.length;
                // draw the selected nodes on top
                for(i = 0; i < selectedLength; i++){
                    node = nodes[selected[i]];
                    var _drawLater2 = node.draw(ctx);
                    if (_drawLater2.drawExternalLabel != null) _drawExternalLabels.push(_drawLater2.drawExternalLabel);
                }
                // draw hovered nodes above everything else: fixes https://github.com/visjs/vis-network/issues/226
                for(i = 0; i < hoveredLength; i++){
                    node = nodes[hovered[i]];
                    var _drawLater3 = node.draw(ctx);
                    if (_drawLater3.drawExternalLabel != null) _drawExternalLabels.push(_drawLater3.drawExternalLabel);
                }
                return {
                    drawExternalLabels: function drawExternalLabels() {
                        for(var _i2 = 0, _drawExternalLabels2 = _drawExternalLabels; _i2 < _drawExternalLabels2.length; _i2++){
                            var draw = _drawExternalLabels2[_i2];
                            draw();
                        }
                    }
                };
            }
        },
        {
            key: "_drawEdges",
            value: function _drawEdges(ctx) {
                var edges = this.body.edges;
                var edgeIndices = this.body.edgeIndices;
                for(var i = 0; i < edgeIndices.length; i++){
                    var edge = edges[edgeIndices[i]];
                    if (edge.connected === true) edge.draw(ctx);
                }
            }
        },
        {
            key: "_drawArrows",
            value: function _drawArrows(ctx) {
                var edges = this.body.edges;
                var edgeIndices = this.body.edgeIndices;
                for(var i = 0; i < edgeIndices.length; i++){
                    var edge = edges[edgeIndices[i]];
                    if (edge.connected === true) edge.drawArrows(ctx);
                }
            }
        },
        {
            key: "_determineBrowserMethod",
            value: function _determineBrowserMethod() {
                if (typeof window !== "undefined") {
                    var browserType = navigator.userAgent.toLowerCase();
                    this.requiresTimeout = false;
                    if ($bebd28704f2536ea$var$_indexOfInstanceProperty(browserType).call(browserType, "msie 9.0") != -1) // IE 9
                    this.requiresTimeout = true;
                    else if ($bebd28704f2536ea$var$_indexOfInstanceProperty(browserType).call(browserType, "safari") != -1) // safari
                    {
                        if ($bebd28704f2536ea$var$_indexOfInstanceProperty(browserType).call(browserType, "chrome") <= -1) this.requiresTimeout = true;
                    }
                } else this.requiresTimeout = true;
            }
        },
        {
            key: "_drawSelectionBox",
            value: function _drawSelectionBox(ctx) {
                if (this.body.selectionBox.show) {
                    ctx.beginPath();
                    var width = this.body.selectionBox.position.end.x - this.body.selectionBox.position.start.x;
                    var height = this.body.selectionBox.position.end.y - this.body.selectionBox.position.start.y;
                    ctx.rect(this.body.selectionBox.position.start.x, this.body.selectionBox.position.start.y, width, height);
                    ctx.fillStyle = "rgba(151, 194, 252, 0.2)";
                    ctx.fillRect(this.body.selectionBox.position.start.x, this.body.selectionBox.position.start.y, width, height);
                    ctx.strokeStyle = "rgba(151, 194, 252, 1)";
                    ctx.stroke();
                } else ctx.closePath();
            }
        }
    ]);
    return CanvasRenderer;
}();
var $bebd28704f2536ea$var$path$2 = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$setInterval$1 = $bebd28704f2536ea$var$path$2.setInterval;
var $bebd28704f2536ea$var$setInterval = $bebd28704f2536ea$var$setInterval$1;
var $bebd28704f2536ea$var$_setInterval = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$setInterval);
/**
 * Register a touch event, taking place before a gesture
 *
 * @param {Hammer} hammer       A hammer instance
 * @param {Function} callback   Callback, called as callback(event)
 */ function $bebd28704f2536ea$var$onTouch(hammer, callback) {
    callback.inputHandler = function(event) {
        if (event.isFirst) callback(event);
    };
    hammer.on("hammer.input", callback.inputHandler);
}
/**
 * Register a release event, taking place after a gesture
 *
 * @param {Hammer} hammer       A hammer instance
 * @param {Function} callback   Callback, called as callback(event)
 * @returns {*}
 */ function $bebd28704f2536ea$var$onRelease(hammer, callback) {
    callback.inputHandler = function(event) {
        if (event.isFinal) callback(event);
    };
    return hammer.on("hammer.input", callback.inputHandler);
}
/**
 * Create the main frame for the Network.
 * This function is executed once when a Network object is created. The frame
 * contains a canvas, and this canvas contains all objects like the axis and
 * nodes.
 */ var $bebd28704f2536ea$var$Canvas = /*#__PURE__*/ function() {
    /**
   * @param {object} body
   */ function Canvas(body) {
        $bebd28704f2536ea$var$_classCallCheck(this, Canvas);
        this.body = body;
        this.pixelRatio = 1;
        this.cameraState = {};
        this.initialized = false;
        this.canvasViewCenter = {};
        this._cleanupCallbacks = [];
        this.options = {};
        this.defaultOptions = {
            autoResize: true,
            height: "100%",
            width: "100%"
        };
        $bebd28704f2536ea$var$_Object$assign(this.options, this.defaultOptions);
        this.bindEventListeners();
    }
    /**
   * Binds event listeners
   */ $bebd28704f2536ea$var$_createClass(Canvas, [
        {
            key: "bindEventListeners",
            value: function bindEventListeners() {
                var _this = this, _context;
                // bind the events
                this.body.emitter.once("resize", function(obj) {
                    if (obj.width !== 0) _this.body.view.translation.x = obj.width * 0.5;
                    if (obj.height !== 0) _this.body.view.translation.y = obj.height * 0.5;
                });
                this.body.emitter.on("setSize", $bebd28704f2536ea$var$_bindInstanceProperty$1(_context = this.setSize).call(_context, this));
                this.body.emitter.on("destroy", function() {
                    _this.hammerFrame.destroy();
                    _this.hammer.destroy();
                    _this._cleanUp();
                });
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                var _this2 = this;
                if (options !== undefined) {
                    var fields = [
                        "width",
                        "height",
                        "autoResize"
                    ];
                    $bebd28704f2536ea$var$selectiveDeepExtend(fields, this.options, options);
                }
                // Automatically adapt to changing size of the container element.
                this._cleanUp();
                if (this.options.autoResize === true) {
                    var _context2;
                    if (window.ResizeObserver) {
                        // decent browsers, immediate reactions
                        var observer = new ResizeObserver(function() {
                            var changed = _this2.setSize();
                            if (changed === true) _this2.body.emitter.emit("_requestRedraw");
                        });
                        var frame = this.frame;
                        observer.observe(frame);
                        this._cleanupCallbacks.push(function() {
                            observer.unobserve(frame);
                        });
                    } else {
                        // IE11, continous polling
                        var resizeTimer = $bebd28704f2536ea$var$_setInterval(function() {
                            var changed = _this2.setSize();
                            if (changed === true) _this2.body.emitter.emit("_requestRedraw");
                        }, 1000);
                        this._cleanupCallbacks.push(function() {
                            clearInterval(resizeTimer);
                        });
                    }
                    // Automatically adapt to changing size of the browser.
                    var resizeFunction = $bebd28704f2536ea$var$_bindInstanceProperty$1(_context2 = this._onResize).call(_context2, this);
                    window.addEventListener("resize", resizeFunction);
                    this._cleanupCallbacks.push(function() {
                        window.removeEventListener("resize", resizeFunction);
                    });
                }
            }
        },
        {
            key: "_cleanUp",
            value: function _cleanUp() {
                var _context3, _context4, _context5;
                $bebd28704f2536ea$var$_forEachInstanceProperty(_context3 = $bebd28704f2536ea$var$_reverseInstanceProperty(_context4 = $bebd28704f2536ea$var$_spliceInstanceProperty(_context5 = this._cleanupCallbacks).call(_context5, 0)).call(_context4)).call(_context3, function(callback) {
                    try {
                        callback();
                    } catch (error) {
                        console.error(error);
                    }
                });
            }
        },
        {
            key: "_onResize",
            value: function _onResize() {
                this.setSize();
                this.body.emitter.emit("_redraw");
            }
        },
        {
            key: "_getCameraState",
            value: function _getCameraState() {
                var pixelRatio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.pixelRatio;
                if (this.initialized === true) {
                    this.cameraState.previousWidth = this.frame.canvas.width / pixelRatio;
                    this.cameraState.previousHeight = this.frame.canvas.height / pixelRatio;
                    this.cameraState.scale = this.body.view.scale;
                    this.cameraState.position = this.DOMtoCanvas({
                        x: 0.5 * this.frame.canvas.width / pixelRatio,
                        y: 0.5 * this.frame.canvas.height / pixelRatio
                    });
                }
            }
        },
        {
            key: "_setCameraState",
            value: function _setCameraState() {
                if (this.cameraState.scale !== undefined && this.frame.canvas.clientWidth !== 0 && this.frame.canvas.clientHeight !== 0 && this.pixelRatio !== 0 && this.cameraState.previousWidth > 0 && this.cameraState.previousHeight > 0) {
                    var widthRatio = this.frame.canvas.width / this.pixelRatio / this.cameraState.previousWidth;
                    var heightRatio = this.frame.canvas.height / this.pixelRatio / this.cameraState.previousHeight;
                    var newScale = this.cameraState.scale;
                    if (widthRatio != 1 && heightRatio != 1) newScale = this.cameraState.scale * 0.5 * (widthRatio + heightRatio);
                    else if (widthRatio != 1) newScale = this.cameraState.scale * widthRatio;
                    else if (heightRatio != 1) newScale = this.cameraState.scale * heightRatio;
                    this.body.view.scale = newScale;
                    // this comes from the view module.
                    var currentViewCenter = this.DOMtoCanvas({
                        x: 0.5 * this.frame.canvas.clientWidth,
                        y: 0.5 * this.frame.canvas.clientHeight
                    });
                    var distanceFromCenter = {
                        // offset from view, distance view has to change by these x and y to center the node
                        x: currentViewCenter.x - this.cameraState.position.x,
                        y: currentViewCenter.y - this.cameraState.position.y
                    };
                    this.body.view.translation.x += distanceFromCenter.x * this.body.view.scale;
                    this.body.view.translation.y += distanceFromCenter.y * this.body.view.scale;
                }
            }
        },
        {
            key: "_prepareValue",
            value: function _prepareValue(value) {
                if (typeof value === "number") return value + "px";
                else if (typeof value === "string") {
                    if ($bebd28704f2536ea$var$_indexOfInstanceProperty(value).call(value, "%") !== -1 || $bebd28704f2536ea$var$_indexOfInstanceProperty(value).call(value, "px") !== -1) return value;
                    else if ($bebd28704f2536ea$var$_indexOfInstanceProperty(value).call(value, "%") === -1) return value + "px";
                }
                throw new Error("Could not use the value supplied for width or height:" + value);
            }
        },
        {
            key: "_create",
            value: function _create() {
                // remove all elements from the container element.
                while(this.body.container.hasChildNodes())this.body.container.removeChild(this.body.container.firstChild);
                this.frame = document.createElement("div");
                this.frame.className = "vis-network";
                this.frame.style.position = "relative";
                this.frame.style.overflow = "hidden";
                this.frame.tabIndex = 0; // tab index is required for keycharm to bind keystrokes to the div instead of the window
                //////////////////////////////////////////////////////////////////
                this.frame.canvas = document.createElement("canvas");
                this.frame.canvas.style.position = "relative";
                this.frame.appendChild(this.frame.canvas);
                if (!this.frame.canvas.getContext) {
                    var noCanvas = document.createElement("DIV");
                    noCanvas.style.color = "red";
                    noCanvas.style.fontWeight = "bold";
                    noCanvas.style.padding = "10px";
                    noCanvas.innerText = "Error: your browser does not support HTML canvas";
                    this.frame.canvas.appendChild(noCanvas);
                } else {
                    this._setPixelRatio();
                    this.setTransform();
                }
                // add the frame to the container element
                this.body.container.appendChild(this.frame);
                this.body.view.scale = 1;
                this.body.view.translation = {
                    x: 0.5 * this.frame.canvas.clientWidth,
                    y: 0.5 * this.frame.canvas.clientHeight
                };
                this._bindHammer();
            }
        },
        {
            key: "_bindHammer",
            value: function _bindHammer() {
                var _this3 = this;
                if (this.hammer !== undefined) this.hammer.destroy();
                this.drag = {};
                this.pinch = {};
                // init hammer
                this.hammer = new $bebd28704f2536ea$var$Hammer(this.frame.canvas);
                this.hammer.get("pinch").set({
                    enable: true
                });
                // enable to get better response, todo: test on mobile.
                this.hammer.get("pan").set({
                    threshold: 5,
                    direction: $bebd28704f2536ea$var$Hammer.DIRECTION_ALL
                });
                $bebd28704f2536ea$var$onTouch(this.hammer, function(event) {
                    _this3.body.eventListeners.onTouch(event);
                });
                this.hammer.on("tap", function(event) {
                    _this3.body.eventListeners.onTap(event);
                });
                this.hammer.on("doubletap", function(event) {
                    _this3.body.eventListeners.onDoubleTap(event);
                });
                this.hammer.on("press", function(event) {
                    _this3.body.eventListeners.onHold(event);
                });
                this.hammer.on("panstart", function(event) {
                    _this3.body.eventListeners.onDragStart(event);
                });
                this.hammer.on("panmove", function(event) {
                    _this3.body.eventListeners.onDrag(event);
                });
                this.hammer.on("panend", function(event) {
                    _this3.body.eventListeners.onDragEnd(event);
                });
                this.hammer.on("pinch", function(event) {
                    _this3.body.eventListeners.onPinch(event);
                });
                // TODO: neatly cleanup these handlers when re-creating the Canvas, IF these are done with hammer, event.stopPropagation will not work?
                this.frame.canvas.addEventListener("wheel", function(event) {
                    _this3.body.eventListeners.onMouseWheel(event);
                });
                this.frame.canvas.addEventListener("mousemove", function(event) {
                    _this3.body.eventListeners.onMouseMove(event);
                });
                this.frame.canvas.addEventListener("contextmenu", function(event) {
                    _this3.body.eventListeners.onContext(event);
                });
                this.hammerFrame = new $bebd28704f2536ea$var$Hammer(this.frame);
                $bebd28704f2536ea$var$onRelease(this.hammerFrame, function(event) {
                    _this3.body.eventListeners.onRelease(event);
                });
            }
        },
        {
            key: "setSize",
            value: function setSize() {
                var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.width;
                var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options.height;
                width = this._prepareValue(width);
                height = this._prepareValue(height);
                var emitEvent = false;
                var oldWidth = this.frame.canvas.width;
                var oldHeight = this.frame.canvas.height;
                // update the pixel ratio
                //
                // NOTE: Comment in following is rather inconsistent; this is the ONLY place in the code
                //       where it is assumed that the pixel ratio could change at runtime.
                //       The only way I can think of this happening is a rotating screen or tablet; but then
                //       there should be a mechanism for reloading the data (TODO: check if this is present).
                //
                //       If the assumption is true (i.e. pixel ratio can change at runtime), then *all* usage
                //       of pixel ratio must be overhauled for this.
                //
                //       For the time being, I will humor the assumption here, and in the rest of the code assume it is
                //       constant.
                var previousRatio = this.pixelRatio; // we cache this because the camera state storage needs the old value
                this._setPixelRatio();
                if (width != this.options.width || height != this.options.height || this.frame.style.width != width || this.frame.style.height != height) {
                    this._getCameraState(previousRatio);
                    this.frame.style.width = width;
                    this.frame.style.height = height;
                    this.frame.canvas.style.width = "100%";
                    this.frame.canvas.style.height = "100%";
                    this.frame.canvas.width = Math.round(this.frame.canvas.clientWidth * this.pixelRatio);
                    this.frame.canvas.height = Math.round(this.frame.canvas.clientHeight * this.pixelRatio);
                    this.options.width = width;
                    this.options.height = height;
                    this.canvasViewCenter = {
                        x: 0.5 * this.frame.clientWidth,
                        y: 0.5 * this.frame.clientHeight
                    };
                    emitEvent = true;
                } else {
                    // this would adapt the width of the canvas to the width from 100% if and only if
                    // there is a change.
                    var newWidth = Math.round(this.frame.canvas.clientWidth * this.pixelRatio);
                    var newHeight = Math.round(this.frame.canvas.clientHeight * this.pixelRatio);
                    // store the camera if there is a change in size.
                    if (this.frame.canvas.width !== newWidth || this.frame.canvas.height !== newHeight) this._getCameraState(previousRatio);
                    if (this.frame.canvas.width !== newWidth) {
                        this.frame.canvas.width = newWidth;
                        emitEvent = true;
                    }
                    if (this.frame.canvas.height !== newHeight) {
                        this.frame.canvas.height = newHeight;
                        emitEvent = true;
                    }
                }
                if (emitEvent === true) {
                    this.body.emitter.emit("resize", {
                        width: Math.round(this.frame.canvas.width / this.pixelRatio),
                        height: Math.round(this.frame.canvas.height / this.pixelRatio),
                        oldWidth: Math.round(oldWidth / this.pixelRatio),
                        oldHeight: Math.round(oldHeight / this.pixelRatio)
                    });
                    // restore the camera on change.
                    this._setCameraState();
                }
                // set initialized so the get and set camera will work from now on.
                this.initialized = true;
                return emitEvent;
            }
        },
        {
            key: "getContext",
            value: function getContext() {
                return this.frame.canvas.getContext("2d");
            }
        },
        {
            key: "_determinePixelRatio",
            value: function _determinePixelRatio() {
                var ctx = this.getContext();
                if (ctx === undefined) throw new Error("Could not get canvax context");
                var numerator = 1;
                if (typeof window !== "undefined") // (window !== undefined) doesn't work here!
                // Protection during unit tests, where 'window' can be missing
                numerator = window.devicePixelRatio || 1;
                var denominator = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
                return numerator / denominator;
            }
        },
        {
            key: "_setPixelRatio",
            value: function _setPixelRatio() {
                this.pixelRatio = this._determinePixelRatio();
            }
        },
        {
            key: "setTransform",
            value: function setTransform() {
                var ctx = this.getContext();
                if (ctx === undefined) throw new Error("Could not get canvax context");
                ctx.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
            }
        },
        {
            key: "_XconvertDOMtoCanvas",
            value: function _XconvertDOMtoCanvas(x) {
                return (x - this.body.view.translation.x) / this.body.view.scale;
            }
        },
        {
            key: "_XconvertCanvasToDOM",
            value: function _XconvertCanvasToDOM(x) {
                return x * this.body.view.scale + this.body.view.translation.x;
            }
        },
        {
            key: "_YconvertDOMtoCanvas",
            value: function _YconvertDOMtoCanvas(y) {
                return (y - this.body.view.translation.y) / this.body.view.scale;
            }
        },
        {
            key: "_YconvertCanvasToDOM",
            value: function _YconvertCanvasToDOM(y) {
                return y * this.body.view.scale + this.body.view.translation.y;
            }
        },
        {
            key: "canvasToDOM",
            value: function canvasToDOM(pos) {
                return {
                    x: this._XconvertCanvasToDOM(pos.x),
                    y: this._YconvertCanvasToDOM(pos.y)
                };
            }
        },
        {
            key: "DOMtoCanvas",
            value: function DOMtoCanvas(pos) {
                return {
                    x: this._XconvertDOMtoCanvas(pos.x),
                    y: this._YconvertDOMtoCanvas(pos.y)
                };
            }
        }
    ]);
    return Canvas;
}();
/**
 * Validate the fit options, replace missing optional values by defaults etc.
 *
 * @param rawOptions - The raw options.
 * @param allNodeIds - All node ids that will be used if nodes are omitted in
 * the raw options.
 * @returns Options with everything filled in and validated.
 */ function $bebd28704f2536ea$var$normalizeFitOptions(rawOptions, allNodeIds) {
    var options = $bebd28704f2536ea$var$_Object$assign({
        nodes: allNodeIds,
        minZoomLevel: Number.MIN_VALUE,
        maxZoomLevel: 1
    }, rawOptions !== null && rawOptions !== void 0 ? rawOptions : {});
    if (!$bebd28704f2536ea$var$_Array$isArray(options.nodes)) throw new TypeError("Nodes has to be an array of ids.");
    if (options.nodes.length === 0) options.nodes = allNodeIds;
    if (!(typeof options.minZoomLevel === "number" && options.minZoomLevel > 0)) throw new TypeError("Min zoom level has to be a number higher than zero.");
    if (!(typeof options.maxZoomLevel === "number" && options.minZoomLevel <= options.maxZoomLevel)) throw new TypeError("Max zoom level has to be a number higher than min zoom level.");
    return options;
}
/**
 * The view
 */ var $bebd28704f2536ea$var$View = /*#__PURE__*/ function() {
    /**
   * @param {object} body
   * @param {Canvas} canvas
   */ function View(body, canvas) {
        var _context, _this = this, _context2;
        $bebd28704f2536ea$var$_classCallCheck(this, View);
        this.body = body;
        this.canvas = canvas;
        this.animationSpeed = 1 / this.renderRefreshRate;
        this.animationEasingFunction = "easeInOutQuint";
        this.easingTime = 0;
        this.sourceScale = 0;
        this.targetScale = 0;
        this.sourceTranslation = 0;
        this.targetTranslation = 0;
        this.lockedOnNodeId = undefined;
        this.lockedOnNodeOffset = undefined;
        this.touchTime = 0;
        this.viewFunction = undefined;
        this.body.emitter.on("fit", $bebd28704f2536ea$var$_bindInstanceProperty$1(_context = this.fit).call(_context, this));
        this.body.emitter.on("animationFinished", function() {
            _this.body.emitter.emit("_stopRendering");
        });
        this.body.emitter.on("unlockNode", $bebd28704f2536ea$var$_bindInstanceProperty$1(_context2 = this.releaseNode).call(_context2, this));
    }
    /**
   *
   * @param {object} [options={}]
   */ $bebd28704f2536ea$var$_createClass(View, [
        {
            key: "setOptions",
            value: function setOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                this.options = options;
            }
        },
        {
            key: "fit",
            value: function fit(options) {
                var initialZoom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                options = $bebd28704f2536ea$var$normalizeFitOptions(options, this.body.nodeIndices);
                var canvasWidth = this.canvas.frame.canvas.clientWidth;
                var canvasHeight = this.canvas.frame.canvas.clientHeight;
                var range;
                var zoomLevel;
                if (canvasWidth === 0 || canvasHeight === 0) {
                    // There's no point in trying to fit into zero sized canvas. This could
                    // potentially even result in invalid values being computed. For example
                    // for network without nodes and zero sized canvas the zoom level would
                    // end up being computed as 0/0 which results in NaN. In any other case
                    // this would be 0/something which is again pointless to compute.
                    zoomLevel = 1;
                    range = $bebd28704f2536ea$var$NetworkUtil.getRange(this.body.nodes, options.nodes);
                } else if (initialZoom === true) {
                    // check if more than half of the nodes have a predefined position. If so, we use the range, not the approximation.
                    var positionDefined = 0;
                    for(var nodeId in this.body.nodes)if (Object.prototype.hasOwnProperty.call(this.body.nodes, nodeId)) {
                        var node = this.body.nodes[nodeId];
                        if (node.predefinedPosition === true) positionDefined += 1;
                    }
                    if (positionDefined > 0.5 * this.body.nodeIndices.length) {
                        this.fit(options, false);
                        return;
                    }
                    range = $bebd28704f2536ea$var$NetworkUtil.getRange(this.body.nodes, options.nodes);
                    var numberOfNodes = this.body.nodeIndices.length;
                    zoomLevel = 12.662 / (numberOfNodes + 7.4147) + 0.0964822; // this is obtained from fitting a dataset from 5 points with scale levels that looked good.
                    // correct for larger canvasses.
                    var factor = Math.min(canvasWidth / 600, canvasHeight / 600);
                    zoomLevel *= factor;
                } else {
                    this.body.emitter.emit("_resizeNodes");
                    range = $bebd28704f2536ea$var$NetworkUtil.getRange(this.body.nodes, options.nodes);
                    var xDistance = Math.abs(range.maxX - range.minX) * 1.1;
                    var yDistance = Math.abs(range.maxY - range.minY) * 1.1;
                    var xZoomLevel = canvasWidth / xDistance;
                    var yZoomLevel = canvasHeight / yDistance;
                    zoomLevel = xZoomLevel <= yZoomLevel ? xZoomLevel : yZoomLevel;
                }
                if (zoomLevel > options.maxZoomLevel) zoomLevel = options.maxZoomLevel;
                else if (zoomLevel < options.minZoomLevel) zoomLevel = options.minZoomLevel;
                var center = $bebd28704f2536ea$var$NetworkUtil.findCenter(range);
                var animationOptions = {
                    position: center,
                    scale: zoomLevel,
                    animation: options.animation
                };
                this.moveTo(animationOptions);
            }
        },
        {
            key: "focus",
            value: function focus(nodeId) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (this.body.nodes[nodeId] !== undefined) {
                    var nodePosition = {
                        x: this.body.nodes[nodeId].x,
                        y: this.body.nodes[nodeId].y
                    };
                    options.position = nodePosition;
                    options.lockedOnNode = nodeId;
                    this.moveTo(options);
                } else console.error("Node: " + nodeId + " cannot be found.");
            }
        },
        {
            key: "moveTo",
            value: function moveTo(options) {
                if (options === undefined) {
                    options = {};
                    return;
                }
                if (options.offset != null) {
                    if (options.offset.x != null) {
                        // Coerce and verify that x is valid.
                        options.offset.x = +options.offset.x;
                        if (!$bebd28704f2536ea$var$_Number$isFinite(options.offset.x)) throw new TypeError('The option "offset.x" has to be a finite number.');
                    } else options.offset.x = 0;
                    if (options.offset.y != null) {
                        // Coerce and verify that y is valid.
                        options.offset.y = +options.offset.y;
                        if (!$bebd28704f2536ea$var$_Number$isFinite(options.offset.y)) throw new TypeError('The option "offset.y" has to be a finite number.');
                    } else options.offset.x = 0;
                } else options.offset = {
                    x: 0,
                    y: 0
                };
                if (options.position != null) {
                    if (options.position.x != null) {
                        // Coerce and verify that x is valid.
                        options.position.x = +options.position.x;
                        if (!$bebd28704f2536ea$var$_Number$isFinite(options.position.x)) throw new TypeError('The option "position.x" has to be a finite number.');
                    } else options.position.x = 0;
                    if (options.position.y != null) {
                        // Coerce and verify that y is valid.
                        options.position.y = +options.position.y;
                        if (!$bebd28704f2536ea$var$_Number$isFinite(options.position.y)) throw new TypeError('The option "position.y" has to be a finite number.');
                    } else options.position.x = 0;
                } else options.position = this.getViewPosition();
                if (options.scale != null) {
                    // Coerce and verify that the scale is valid.
                    options.scale = +options.scale;
                    if (!(options.scale > 0)) throw new TypeError('The option "scale" has to be a number greater than zero.');
                } else options.scale = this.body.view.scale;
                if (options.animation === undefined) options.animation = {
                    duration: 0
                };
                if (options.animation === false) options.animation = {
                    duration: 0
                };
                if (options.animation === true) options.animation = {};
                if (options.animation.duration === undefined) options.animation.duration = 1000;
                 // default duration
                if (options.animation.easingFunction === undefined) options.animation.easingFunction = "easeInOutQuad";
                 // default easing function
                this.animateView(options);
            }
        },
        {
            key: "animateView",
            value: function animateView(options) {
                if (options === undefined) return;
                this.animationEasingFunction = options.animation.easingFunction;
                // release if something focussed on the node
                this.releaseNode();
                if (options.locked === true) {
                    this.lockedOnNodeId = options.lockedOnNode;
                    this.lockedOnNodeOffset = options.offset;
                }
                // forcefully complete the old animation if it was still running
                if (this.easingTime != 0) this._transitionRedraw(true); // by setting easingtime to 1, we finish the animation.
                this.sourceScale = this.body.view.scale;
                this.sourceTranslation = this.body.view.translation;
                this.targetScale = options.scale;
                // set the scale so the viewCenter is based on the correct zoom level. This is overridden in the transitionRedraw
                // but at least then we'll have the target transition
                this.body.view.scale = this.targetScale;
                var viewCenter = this.canvas.DOMtoCanvas({
                    x: 0.5 * this.canvas.frame.canvas.clientWidth,
                    y: 0.5 * this.canvas.frame.canvas.clientHeight
                });
                var distanceFromCenter = {
                    // offset from view, distance view has to change by these x and y to center the node
                    x: viewCenter.x - options.position.x,
                    y: viewCenter.y - options.position.y
                };
                this.targetTranslation = {
                    x: this.sourceTranslation.x + distanceFromCenter.x * this.targetScale + options.offset.x,
                    y: this.sourceTranslation.y + distanceFromCenter.y * this.targetScale + options.offset.y
                };
                // if the time is set to 0, don't do an animation
                if (options.animation.duration === 0) {
                    if (this.lockedOnNodeId != undefined) {
                        var _context3;
                        this.viewFunction = $bebd28704f2536ea$var$_bindInstanceProperty$1(_context3 = this._lockedRedraw).call(_context3, this);
                        this.body.emitter.on("initRedraw", this.viewFunction);
                    } else {
                        this.body.view.scale = this.targetScale;
                        this.body.view.translation = this.targetTranslation;
                        this.body.emitter.emit("_requestRedraw");
                    }
                } else {
                    var _context4;
                    this.animationSpeed = 1 / (60 * options.animation.duration * 0.001) || 1 / 60; // 60 for 60 seconds, 0.001 for milli's
                    this.animationEasingFunction = options.animation.easingFunction;
                    this.viewFunction = $bebd28704f2536ea$var$_bindInstanceProperty$1(_context4 = this._transitionRedraw).call(_context4, this);
                    this.body.emitter.on("initRedraw", this.viewFunction);
                    this.body.emitter.emit("_startRendering");
                }
            }
        },
        {
            key: "_lockedRedraw",
            value: function _lockedRedraw() {
                var nodePosition = {
                    x: this.body.nodes[this.lockedOnNodeId].x,
                    y: this.body.nodes[this.lockedOnNodeId].y
                };
                var viewCenter = this.canvas.DOMtoCanvas({
                    x: 0.5 * this.canvas.frame.canvas.clientWidth,
                    y: 0.5 * this.canvas.frame.canvas.clientHeight
                });
                var distanceFromCenter = {
                    // offset from view, distance view has to change by these x and y to center the node
                    x: viewCenter.x - nodePosition.x,
                    y: viewCenter.y - nodePosition.y
                };
                var sourceTranslation = this.body.view.translation;
                var targetTranslation = {
                    x: sourceTranslation.x + distanceFromCenter.x * this.body.view.scale + this.lockedOnNodeOffset.x,
                    y: sourceTranslation.y + distanceFromCenter.y * this.body.view.scale + this.lockedOnNodeOffset.y
                };
                this.body.view.translation = targetTranslation;
            }
        },
        {
            key: "releaseNode",
            value: function releaseNode() {
                if (this.lockedOnNodeId !== undefined && this.viewFunction !== undefined) {
                    this.body.emitter.off("initRedraw", this.viewFunction);
                    this.lockedOnNodeId = undefined;
                    this.lockedOnNodeOffset = undefined;
                }
            }
        },
        {
            key: "_transitionRedraw",
            value: function _transitionRedraw() {
                var finished = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                this.easingTime += this.animationSpeed;
                this.easingTime = finished === true ? 1.0 : this.easingTime;
                var progress = $bebd28704f2536ea$var$easingFunctions[this.animationEasingFunction](this.easingTime);
                this.body.view.scale = this.sourceScale + (this.targetScale - this.sourceScale) * progress;
                this.body.view.translation = {
                    x: this.sourceTranslation.x + (this.targetTranslation.x - this.sourceTranslation.x) * progress,
                    y: this.sourceTranslation.y + (this.targetTranslation.y - this.sourceTranslation.y) * progress
                };
                // cleanup
                if (this.easingTime >= 1.0) {
                    this.body.emitter.off("initRedraw", this.viewFunction);
                    this.easingTime = 0;
                    if (this.lockedOnNodeId != undefined) {
                        var _context5;
                        this.viewFunction = $bebd28704f2536ea$var$_bindInstanceProperty$1(_context5 = this._lockedRedraw).call(_context5, this);
                        this.body.emitter.on("initRedraw", this.viewFunction);
                    }
                    this.body.emitter.emit("animationFinished");
                }
            }
        },
        {
            key: "getScale",
            value: function getScale() {
                return this.body.view.scale;
            }
        },
        {
            key: "getViewPosition",
            value: function getViewPosition() {
                return this.canvas.DOMtoCanvas({
                    x: 0.5 * this.canvas.frame.canvas.clientWidth,
                    y: 0.5 * this.canvas.frame.canvas.clientHeight
                });
            }
        }
    ]);
    return View;
}();
/**
 * Created by Alex on 11/6/2014.
 */ function $bebd28704f2536ea$var$keycharm(options) {
    var preventDefault = options && options.preventDefault || false;
    var container = options && options.container || window;
    var _exportFunctions = {};
    var _bound = {
        keydown: {},
        keyup: {}
    };
    var _keys = {};
    var i;
    // a - z
    for(i = 97; i <= 122; i++)_keys[String.fromCharCode(i)] = {
        code: 65 + (i - 97),
        shift: false
    };
    // A - Z
    for(i = 65; i <= 90; i++)_keys[String.fromCharCode(i)] = {
        code: i,
        shift: true
    };
    // 0 - 9
    for(i = 0; i <= 9; i++)_keys['' + i] = {
        code: 48 + i,
        shift: false
    };
    // F1 - F12
    for(i = 1; i <= 12; i++)_keys['F' + i] = {
        code: 111 + i,
        shift: false
    };
    // num0 - num9
    for(i = 0; i <= 9; i++)_keys['num' + i] = {
        code: 96 + i,
        shift: false
    };
    // numpad misc
    _keys['num*'] = {
        code: 106,
        shift: false
    };
    _keys['num+'] = {
        code: 107,
        shift: false
    };
    _keys['num-'] = {
        code: 109,
        shift: false
    };
    _keys['num/'] = {
        code: 111,
        shift: false
    };
    _keys['num.'] = {
        code: 110,
        shift: false
    };
    // arrows
    _keys['left'] = {
        code: 37,
        shift: false
    };
    _keys['up'] = {
        code: 38,
        shift: false
    };
    _keys['right'] = {
        code: 39,
        shift: false
    };
    _keys['down'] = {
        code: 40,
        shift: false
    };
    // extra keys
    _keys['space'] = {
        code: 32,
        shift: false
    };
    _keys['enter'] = {
        code: 13,
        shift: false
    };
    _keys['shift'] = {
        code: 16,
        shift: undefined
    };
    _keys['esc'] = {
        code: 27,
        shift: false
    };
    _keys['backspace'] = {
        code: 8,
        shift: false
    };
    _keys['tab'] = {
        code: 9,
        shift: false
    };
    _keys['ctrl'] = {
        code: 17,
        shift: false
    };
    _keys['alt'] = {
        code: 18,
        shift: false
    };
    _keys['delete'] = {
        code: 46,
        shift: false
    };
    _keys['pageup'] = {
        code: 33,
        shift: false
    };
    _keys['pagedown'] = {
        code: 34,
        shift: false
    };
    // symbols
    _keys['='] = {
        code: 187,
        shift: false
    };
    _keys['-'] = {
        code: 189,
        shift: false
    };
    _keys[']'] = {
        code: 221,
        shift: false
    };
    _keys['['] = {
        code: 219,
        shift: false
    };
    var down = function(event) {
        handleEvent(event, 'keydown');
    };
    var up = function(event) {
        handleEvent(event, 'keyup');
    };
    // handle the actualy bound key with the event
    var handleEvent = function(event, type) {
        if (_bound[type][event.keyCode] !== undefined) {
            var bound = _bound[type][event.keyCode];
            for(var i = 0; i < bound.length; i++){
                if (bound[i].shift === undefined) bound[i].fn(event);
                else if (bound[i].shift == true && event.shiftKey == true) bound[i].fn(event);
                else if (bound[i].shift == false && event.shiftKey == false) bound[i].fn(event);
            }
            if (preventDefault == true) event.preventDefault();
        }
    };
    // bind a key to a callback
    _exportFunctions.bind = function(key, callback, type) {
        if (type === undefined) type = 'keydown';
        if (_keys[key] === undefined) throw new Error("unsupported key: " + key);
        if (_bound[type][_keys[key].code] === undefined) _bound[type][_keys[key].code] = [];
        _bound[type][_keys[key].code].push({
            fn: callback,
            shift: _keys[key].shift
        });
    };
    // bind all keys to a call back (demo purposes)
    _exportFunctions.bindAll = function(callback, type) {
        if (type === undefined) type = 'keydown';
        for(var key in _keys)if (_keys.hasOwnProperty(key)) _exportFunctions.bind(key, callback, type);
    };
    // get the key label from an event
    _exportFunctions.getKey = function(event) {
        for(var key in _keys)if (_keys.hasOwnProperty(key)) {
            if (event.shiftKey == true && _keys[key].shift == true && event.keyCode == _keys[key].code) return key;
            else if (event.shiftKey == false && _keys[key].shift == false && event.keyCode == _keys[key].code) return key;
            else if (event.keyCode == _keys[key].code && key == 'shift') return key;
        }
        return "unknown key, currently not supported";
    };
    // unbind either a specific callback from a key or all of them (by leaving callback undefined)
    _exportFunctions.unbind = function(key, callback, type) {
        if (type === undefined) type = 'keydown';
        if (_keys[key] === undefined) throw new Error("unsupported key: " + key);
        if (callback !== undefined) {
            var newBindings = [];
            var bound = _bound[type][_keys[key].code];
            if (bound !== undefined) {
                for(var i = 0; i < bound.length; i++)if (!(bound[i].fn == callback && bound[i].shift == _keys[key].shift)) newBindings.push(_bound[type][_keys[key].code][i]);
            }
            _bound[type][_keys[key].code] = newBindings;
        } else _bound[type][_keys[key].code] = [];
    };
    // reset all bound variables.
    _exportFunctions.reset = function() {
        _bound = {
            keydown: {},
            keyup: {}
        };
    };
    // unbind all listeners and reset all variables.
    _exportFunctions.destroy = function() {
        _bound = {
            keydown: {},
            keyup: {}
        };
        container.removeEventListener('keydown', down, true);
        container.removeEventListener('keyup', up, true);
    };
    // create listeners.
    container.addEventListener('keydown', down, true);
    container.addEventListener('keyup', up, true);
    // return the public functions.
    return _exportFunctions;
}
/**
 * Navigation Handler
 */ var $bebd28704f2536ea$var$NavigationHandler = /*#__PURE__*/ function() {
    /**
   * @param {object} body
   * @param {Canvas} canvas
   */ function NavigationHandler(body, canvas) {
        var _this = this;
        $bebd28704f2536ea$var$_classCallCheck(this, NavigationHandler);
        this.body = body;
        this.canvas = canvas;
        this.iconsCreated = false;
        this.navigationHammers = [];
        this.boundFunctions = {};
        this.touchTime = 0;
        this.activated = false;
        this.body.emitter.on("activate", function() {
            _this.activated = true;
            _this.configureKeyboardBindings();
        });
        this.body.emitter.on("deactivate", function() {
            _this.activated = false;
            _this.configureKeyboardBindings();
        });
        this.body.emitter.on("destroy", function() {
            if (_this.keycharm !== undefined) _this.keycharm.destroy();
        });
        this.options = {};
    }
    /**
   *
   * @param {object} options
   */ $bebd28704f2536ea$var$_createClass(NavigationHandler, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                if (options !== undefined) {
                    this.options = options;
                    this.create();
                }
            }
        },
        {
            key: "create",
            value: function create() {
                if (this.options.navigationButtons === true) {
                    if (this.iconsCreated === false) this.loadNavigationElements();
                } else if (this.iconsCreated === true) this.cleanNavigation();
                this.configureKeyboardBindings();
            }
        },
        {
            key: "cleanNavigation",
            value: function cleanNavigation() {
                // clean hammer bindings
                if (this.navigationHammers.length != 0) {
                    for(var i = 0; i < this.navigationHammers.length; i++)this.navigationHammers[i].destroy();
                    this.navigationHammers = [];
                }
                // clean up previous navigation items
                if (this.navigationDOM && this.navigationDOM["wrapper"] && this.navigationDOM["wrapper"].parentNode) this.navigationDOM["wrapper"].parentNode.removeChild(this.navigationDOM["wrapper"]);
                this.iconsCreated = false;
            }
        },
        {
            key: "loadNavigationElements",
            value: function loadNavigationElements() {
                var _this2 = this;
                this.cleanNavigation();
                this.navigationDOM = {};
                var navigationDivs = [
                    "up",
                    "down",
                    "left",
                    "right",
                    "zoomIn",
                    "zoomOut",
                    "zoomExtends"
                ];
                var navigationDivActions = [
                    "_moveUp",
                    "_moveDown",
                    "_moveLeft",
                    "_moveRight",
                    "_zoomIn",
                    "_zoomOut",
                    "_fit"
                ];
                this.navigationDOM["wrapper"] = document.createElement("div");
                this.navigationDOM["wrapper"].className = "vis-navigation";
                this.canvas.frame.appendChild(this.navigationDOM["wrapper"]);
                for(var i = 0; i < navigationDivs.length; i++){
                    this.navigationDOM[navigationDivs[i]] = document.createElement("div");
                    this.navigationDOM[navigationDivs[i]].className = "vis-button vis-" + navigationDivs[i];
                    this.navigationDOM["wrapper"].appendChild(this.navigationDOM[navigationDivs[i]]);
                    var hammer = new $bebd28704f2536ea$var$Hammer(this.navigationDOM[navigationDivs[i]]);
                    if (navigationDivActions[i] === "_fit") {
                        var _context;
                        $bebd28704f2536ea$var$onTouch(hammer, $bebd28704f2536ea$var$_bindInstanceProperty$1(_context = this._fit).call(_context, this));
                    } else {
                        var _context2;
                        $bebd28704f2536ea$var$onTouch(hammer, $bebd28704f2536ea$var$_bindInstanceProperty$1(_context2 = this.bindToRedraw).call(_context2, this, navigationDivActions[i]));
                    }
                    this.navigationHammers.push(hammer);
                }
                // use a hammer for the release so we do not require the one used in the rest of the network
                // the one the rest uses can be overloaded by the manipulation system.
                var hammerFrame = new $bebd28704f2536ea$var$Hammer(this.canvas.frame);
                $bebd28704f2536ea$var$onRelease(hammerFrame, function() {
                    _this2._stopMovement();
                });
                this.navigationHammers.push(hammerFrame);
                this.iconsCreated = true;
            }
        },
        {
            key: "bindToRedraw",
            value: function bindToRedraw(action) {
                if (this.boundFunctions[action] === undefined) {
                    var _context3;
                    this.boundFunctions[action] = $bebd28704f2536ea$var$_bindInstanceProperty$1(_context3 = this[action]).call(_context3, this);
                    this.body.emitter.on("initRedraw", this.boundFunctions[action]);
                    this.body.emitter.emit("_startRendering");
                }
            }
        },
        {
            key: "unbindFromRedraw",
            value: function unbindFromRedraw(action) {
                if (this.boundFunctions[action] !== undefined) {
                    this.body.emitter.off("initRedraw", this.boundFunctions[action]);
                    this.body.emitter.emit("_stopRendering");
                    delete this.boundFunctions[action];
                }
            }
        },
        {
            key: "_fit",
            value: function _fit() {
                if (new Date().valueOf() - this.touchTime > 700) {
                    // TODO: fix ugly hack to avoid hammer's double fireing of event (because we use release?)
                    this.body.emitter.emit("fit", {
                        duration: 700
                    });
                    this.touchTime = new Date().valueOf();
                }
            }
        },
        {
            key: "_stopMovement",
            value: function _stopMovement() {
                for(var boundAction in this.boundFunctions)if (Object.prototype.hasOwnProperty.call(this.boundFunctions, boundAction)) {
                    this.body.emitter.off("initRedraw", this.boundFunctions[boundAction]);
                    this.body.emitter.emit("_stopRendering");
                }
                this.boundFunctions = {};
            }
        },
        {
            key: "_moveUp",
            value: function _moveUp() {
                this.body.view.translation.y += this.options.keyboard.speed.y;
            }
        },
        {
            key: "_moveDown",
            value: function _moveDown() {
                this.body.view.translation.y -= this.options.keyboard.speed.y;
            }
        },
        {
            key: "_moveLeft",
            value: function _moveLeft() {
                this.body.view.translation.x += this.options.keyboard.speed.x;
            }
        },
        {
            key: "_moveRight",
            value: function _moveRight() {
                this.body.view.translation.x -= this.options.keyboard.speed.x;
            }
        },
        {
            key: "_zoomIn",
            value: function _zoomIn() {
                var scaleOld = this.body.view.scale;
                var scale = this.body.view.scale * (1 + this.options.keyboard.speed.zoom);
                var translation = this.body.view.translation;
                var scaleFrac = scale / scaleOld;
                var tx = (1 - scaleFrac) * this.canvas.canvasViewCenter.x + translation.x * scaleFrac;
                var ty = (1 - scaleFrac) * this.canvas.canvasViewCenter.y + translation.y * scaleFrac;
                this.body.view.scale = scale;
                this.body.view.translation = {
                    x: tx,
                    y: ty
                };
                this.body.emitter.emit("zoom", {
                    direction: "+",
                    scale: this.body.view.scale,
                    pointer: null
                });
            }
        },
        {
            key: "_zoomOut",
            value: function _zoomOut() {
                var scaleOld = this.body.view.scale;
                var scale = this.body.view.scale / (1 + this.options.keyboard.speed.zoom);
                var translation = this.body.view.translation;
                var scaleFrac = scale / scaleOld;
                var tx = (1 - scaleFrac) * this.canvas.canvasViewCenter.x + translation.x * scaleFrac;
                var ty = (1 - scaleFrac) * this.canvas.canvasViewCenter.y + translation.y * scaleFrac;
                this.body.view.scale = scale;
                this.body.view.translation = {
                    x: tx,
                    y: ty
                };
                this.body.emitter.emit("zoom", {
                    direction: "-",
                    scale: this.body.view.scale,
                    pointer: null
                });
            }
        },
        {
            key: "configureKeyboardBindings",
            value: function configureKeyboardBindings() {
                var _this3 = this;
                if (this.keycharm !== undefined) this.keycharm.destroy();
                if (this.options.keyboard.enabled === true) {
                    if (this.options.keyboard.bindToWindow === true) this.keycharm = $bebd28704f2536ea$var$keycharm({
                        container: window,
                        preventDefault: true
                    });
                    else this.keycharm = $bebd28704f2536ea$var$keycharm({
                        container: this.canvas.frame,
                        preventDefault: true
                    });
                    this.keycharm.reset();
                    if (this.activated === true) {
                        var _context4, _context5, _context6, _context7, _context8, _context9, _context10, _context11, _context12, _context13, _context14, _context15, _context16, _context17, _context18, _context19, _context20, _context21, _context22, _context23, _context24, _context25, _context26, _context27;
                        $bebd28704f2536ea$var$_bindInstanceProperty$1(_context4 = this.keycharm).call(_context4, "up", function() {
                            _this3.bindToRedraw("_moveUp");
                        }, "keydown");
                        $bebd28704f2536ea$var$_bindInstanceProperty$1(_context5 = this.keycharm).call(_context5, "down", function() {
                            _this3.bindToRedraw("_moveDown");
                        }, "keydown");
                        $bebd28704f2536ea$var$_bindInstanceProperty$1(_context6 = this.keycharm).call(_context6, "left", function() {
                            _this3.bindToRedraw("_moveLeft");
                        }, "keydown");
                        $bebd28704f2536ea$var$_bindInstanceProperty$1(_context7 = this.keycharm).call(_context7, "right", function() {
                            _this3.bindToRedraw("_moveRight");
                        }, "keydown");
                        $bebd28704f2536ea$var$_bindInstanceProperty$1(_context8 = this.keycharm).call(_context8, "=", function() {
                            _this3.bindToRedraw("_zoomIn");
                        }, "keydown");
                        $bebd28704f2536ea$var$_bindInstanceProperty$1(_context9 = this.keycharm).call(_context9, "num+", function() {
                            _this3.bindToRedraw("_zoomIn");
                        }, "keydown");
                        $bebd28704f2536ea$var$_bindInstanceProperty$1(_context10 = this.keycharm).call(_context10, "num-", function() {
                            _this3.bindToRedraw("_zoomOut");
                        }, "keydown");
                        $bebd28704f2536ea$var$_bindInstanceProperty$1(_context11 = this.keycharm).call(_context11, "-", function() {
                            _this3.bindToRedraw("_zoomOut");
                        }, "keydown");
                        $bebd28704f2536ea$var$_bindInstanceProperty$1(_context12 = this.keycharm).call(_context12, "[", function() {
                            _this3.bindToRedraw("_zoomOut");
                        }, "keydown");
                        $bebd28704f2536ea$var$_bindInstanceProperty$1(_context13 = this.keycharm).call(_context13, "]", function() {
                            _this3.bindToRedraw("_zoomIn");
                        }, "keydown");
                        $bebd28704f2536ea$var$_bindInstanceProperty$1(_context14 = this.keycharm).call(_context14, "pageup", function() {
                            _this3.bindToRedraw("_zoomIn");
                        }, "keydown");
                        $bebd28704f2536ea$var$_bindInstanceProperty$1(_context15 = this.keycharm).call(_context15, "pagedown", function() {
                            _this3.bindToRedraw("_zoomOut");
                        }, "keydown");
                        $bebd28704f2536ea$var$_bindInstanceProperty$1(_context16 = this.keycharm).call(_context16, "up", function() {
                            _this3.unbindFromRedraw("_moveUp");
                        }, "keyup");
                        $bebd28704f2536ea$var$_bindInstanceProperty$1(_context17 = this.keycharm).call(_context17, "down", function() {
                            _this3.unbindFromRedraw("_moveDown");
                        }, "keyup");
                        $bebd28704f2536ea$var$_bindInstanceProperty$1(_context18 = this.keycharm).call(_context18, "left", function() {
                            _this3.unbindFromRedraw("_moveLeft");
                        }, "keyup");
                        $bebd28704f2536ea$var$_bindInstanceProperty$1(_context19 = this.keycharm).call(_context19, "right", function() {
                            _this3.unbindFromRedraw("_moveRight");
                        }, "keyup");
                        $bebd28704f2536ea$var$_bindInstanceProperty$1(_context20 = this.keycharm).call(_context20, "=", function() {
                            _this3.unbindFromRedraw("_zoomIn");
                        }, "keyup");
                        $bebd28704f2536ea$var$_bindInstanceProperty$1(_context21 = this.keycharm).call(_context21, "num+", function() {
                            _this3.unbindFromRedraw("_zoomIn");
                        }, "keyup");
                        $bebd28704f2536ea$var$_bindInstanceProperty$1(_context22 = this.keycharm).call(_context22, "num-", function() {
                            _this3.unbindFromRedraw("_zoomOut");
                        }, "keyup");
                        $bebd28704f2536ea$var$_bindInstanceProperty$1(_context23 = this.keycharm).call(_context23, "-", function() {
                            _this3.unbindFromRedraw("_zoomOut");
                        }, "keyup");
                        $bebd28704f2536ea$var$_bindInstanceProperty$1(_context24 = this.keycharm).call(_context24, "[", function() {
                            _this3.unbindFromRedraw("_zoomOut");
                        }, "keyup");
                        $bebd28704f2536ea$var$_bindInstanceProperty$1(_context25 = this.keycharm).call(_context25, "]", function() {
                            _this3.unbindFromRedraw("_zoomIn");
                        }, "keyup");
                        $bebd28704f2536ea$var$_bindInstanceProperty$1(_context26 = this.keycharm).call(_context26, "pageup", function() {
                            _this3.unbindFromRedraw("_zoomIn");
                        }, "keyup");
                        $bebd28704f2536ea$var$_bindInstanceProperty$1(_context27 = this.keycharm).call(_context27, "pagedown", function() {
                            _this3.unbindFromRedraw("_zoomOut");
                        }, "keyup");
                    }
                }
            }
        }
    ]);
    return NavigationHandler;
}();
function $bebd28704f2536ea$var$_createForOfIteratorHelper$4(o, allowArrayLike) {
    var it = typeof $bebd28704f2536ea$var$_Symbol !== "undefined" && $bebd28704f2536ea$var$_getIteratorMethod(o) || o["@@iterator"];
    if (!it) {
        if ($bebd28704f2536ea$var$_Array$isArray(o) || (it = $bebd28704f2536ea$var$_unsupportedIterableToArray$4(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $bebd28704f2536ea$var$_unsupportedIterableToArray$4(o, minLen) {
    var _context15;
    if (!o) return;
    if (typeof o === "string") return $bebd28704f2536ea$var$_arrayLikeToArray$4(o, minLen);
    var n = $bebd28704f2536ea$var$_sliceInstanceProperty(_context15 = Object.prototype.toString.call(o)).call(_context15, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return $bebd28704f2536ea$var$_Array$from$1(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bebd28704f2536ea$var$_arrayLikeToArray$4(o, minLen);
}
function $bebd28704f2536ea$var$_arrayLikeToArray$4(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * Handler for interactions
 */ var $bebd28704f2536ea$var$InteractionHandler = /*#__PURE__*/ function() {
    /**
   * @param {object} body
   * @param {Canvas} canvas
   * @param {SelectionHandler} selectionHandler
   */ function InteractionHandler(body, canvas, selectionHandler) {
        var _context, _context2, _context3, _context4, _context5, _context6, _context7, _context8, _context9, _context10, _context11, _context12, _context13;
        $bebd28704f2536ea$var$_classCallCheck(this, InteractionHandler);
        this.body = body;
        this.canvas = canvas;
        this.selectionHandler = selectionHandler;
        this.navigationHandler = new $bebd28704f2536ea$var$NavigationHandler(body, canvas);
        // bind the events from hammer to functions in this object
        this.body.eventListeners.onTap = $bebd28704f2536ea$var$_bindInstanceProperty$1(_context = this.onTap).call(_context, this);
        this.body.eventListeners.onTouch = $bebd28704f2536ea$var$_bindInstanceProperty$1(_context2 = this.onTouch).call(_context2, this);
        this.body.eventListeners.onDoubleTap = $bebd28704f2536ea$var$_bindInstanceProperty$1(_context3 = this.onDoubleTap).call(_context3, this);
        this.body.eventListeners.onHold = $bebd28704f2536ea$var$_bindInstanceProperty$1(_context4 = this.onHold).call(_context4, this);
        this.body.eventListeners.onDragStart = $bebd28704f2536ea$var$_bindInstanceProperty$1(_context5 = this.onDragStart).call(_context5, this);
        this.body.eventListeners.onDrag = $bebd28704f2536ea$var$_bindInstanceProperty$1(_context6 = this.onDrag).call(_context6, this);
        this.body.eventListeners.onDragEnd = $bebd28704f2536ea$var$_bindInstanceProperty$1(_context7 = this.onDragEnd).call(_context7, this);
        this.body.eventListeners.onMouseWheel = $bebd28704f2536ea$var$_bindInstanceProperty$1(_context8 = this.onMouseWheel).call(_context8, this);
        this.body.eventListeners.onPinch = $bebd28704f2536ea$var$_bindInstanceProperty$1(_context9 = this.onPinch).call(_context9, this);
        this.body.eventListeners.onMouseMove = $bebd28704f2536ea$var$_bindInstanceProperty$1(_context10 = this.onMouseMove).call(_context10, this);
        this.body.eventListeners.onRelease = $bebd28704f2536ea$var$_bindInstanceProperty$1(_context11 = this.onRelease).call(_context11, this);
        this.body.eventListeners.onContext = $bebd28704f2536ea$var$_bindInstanceProperty$1(_context12 = this.onContext).call(_context12, this);
        this.touchTime = 0;
        this.drag = {};
        this.pinch = {};
        this.popup = undefined;
        this.popupObj = undefined;
        this.popupTimer = undefined;
        this.body.functions.getPointer = $bebd28704f2536ea$var$_bindInstanceProperty$1(_context13 = this.getPointer).call(_context13, this);
        this.options = {};
        this.defaultOptions = {
            dragNodes: true,
            dragView: true,
            hover: false,
            keyboard: {
                enabled: false,
                speed: {
                    x: 10,
                    y: 10,
                    zoom: 0.02
                },
                bindToWindow: true,
                autoFocus: true
            },
            navigationButtons: false,
            tooltipDelay: 300,
            zoomView: true,
            zoomSpeed: 1
        };
        $bebd28704f2536ea$var$_Object$assign(this.options, this.defaultOptions);
        this.bindEventListeners();
    }
    /**
   * Binds event listeners
   */ $bebd28704f2536ea$var$_createClass(InteractionHandler, [
        {
            key: "bindEventListeners",
            value: function bindEventListeners() {
                var _this = this;
                this.body.emitter.on("destroy", function() {
                    clearTimeout(_this.popupTimer);
                    delete _this.body.functions.getPointer;
                });
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                if (options !== undefined) {
                    // extend all but the values in fields
                    var fields = [
                        "hideEdgesOnDrag",
                        "hideEdgesOnZoom",
                        "hideNodesOnDrag",
                        "keyboard",
                        "multiselect",
                        "selectable",
                        "selectConnectedEdges"
                    ];
                    $bebd28704f2536ea$var$selectiveNotDeepExtend(fields, this.options, options);
                    // merge the keyboard options in.
                    $bebd28704f2536ea$var$mergeOptions(this.options, options, "keyboard");
                    if (options.tooltip) {
                        $bebd28704f2536ea$var$_Object$assign(this.options.tooltip, options.tooltip);
                        if (options.tooltip.color) this.options.tooltip.color = $bebd28704f2536ea$var$parseColor(options.tooltip.color);
                    }
                }
                this.navigationHandler.setOptions(this.options);
            }
        },
        {
            key: "getPointer",
            value: function getPointer(touch) {
                return {
                    x: touch.x - $bebd28704f2536ea$var$getAbsoluteLeft(this.canvas.frame.canvas),
                    y: touch.y - $bebd28704f2536ea$var$getAbsoluteTop(this.canvas.frame.canvas)
                };
            }
        },
        {
            key: "onTouch",
            value: function onTouch(event) {
                if (new Date().valueOf() - this.touchTime > 50) {
                    this.drag.pointer = this.getPointer(event.center);
                    this.drag.pinched = false;
                    this.pinch.scale = this.body.view.scale;
                    // to avoid double fireing of this event because we have two hammer instances. (on canvas and on frame)
                    this.touchTime = new Date().valueOf();
                }
            }
        },
        {
            key: "onTap",
            value: function onTap(event) {
                var pointer = this.getPointer(event.center);
                var multiselect = this.selectionHandler.options.multiselect && (event.changedPointers[0].ctrlKey || event.changedPointers[0].metaKey);
                this.checkSelectionChanges(pointer, multiselect);
                this.selectionHandler.commitAndEmit(pointer, event);
                this.selectionHandler.generateClickEvent("click", event, pointer);
            }
        },
        {
            key: "onDoubleTap",
            value: function onDoubleTap(event) {
                var pointer = this.getPointer(event.center);
                this.selectionHandler.generateClickEvent("doubleClick", event, pointer);
            }
        },
        {
            key: "onHold",
            value: function onHold(event) {
                var pointer = this.getPointer(event.center);
                var multiselect = this.selectionHandler.options.multiselect;
                this.checkSelectionChanges(pointer, multiselect);
                this.selectionHandler.commitAndEmit(pointer, event);
                this.selectionHandler.generateClickEvent("click", event, pointer);
                this.selectionHandler.generateClickEvent("hold", event, pointer);
            }
        },
        {
            key: "onRelease",
            value: function onRelease(event) {
                if (new Date().valueOf() - this.touchTime > 10) {
                    var pointer = this.getPointer(event.center);
                    this.selectionHandler.generateClickEvent("release", event, pointer);
                    // to avoid double fireing of this event because we have two hammer instances. (on canvas and on frame)
                    this.touchTime = new Date().valueOf();
                }
            }
        },
        {
            key: "onContext",
            value: function onContext(event) {
                var pointer = this.getPointer({
                    x: event.clientX,
                    y: event.clientY
                });
                this.selectionHandler.generateClickEvent("oncontext", event, pointer);
            }
        },
        {
            key: "checkSelectionChanges",
            value: function checkSelectionChanges(pointer) {
                var add = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                if (add === true) this.selectionHandler.selectAdditionalOnPoint(pointer);
                else this.selectionHandler.selectOnPoint(pointer);
            }
        },
        {
            key: "_determineDifference",
            value: function _determineDifference(firstSet, secondSet) {
                var arrayDiff = function arrayDiff(firstArr, secondArr) {
                    var result = [];
                    for(var i = 0; i < firstArr.length; i++){
                        var value = firstArr[i];
                        if ($bebd28704f2536ea$var$_indexOfInstanceProperty(secondArr).call(secondArr, value) === -1) result.push(value);
                    }
                    return result;
                };
                return {
                    nodes: arrayDiff(firstSet.nodes, secondSet.nodes),
                    edges: arrayDiff(firstSet.edges, secondSet.edges)
                };
            }
        },
        {
            key: "onDragStart",
            value: function onDragStart(event) {
                // if already dragging, do not start
                // this can happen on touch screens with multiple fingers
                if (this.drag.dragging) return;
                //in case the touch event was triggered on an external div, do the initial touch now.
                if (this.drag.pointer === undefined) this.onTouch(event);
                // note: drag.pointer is set in onTouch to get the initial touch location
                var node = this.selectionHandler.getNodeAt(this.drag.pointer);
                this.drag.dragging = true;
                this.drag.selection = [];
                this.drag.translation = $bebd28704f2536ea$var$_Object$assign({}, this.body.view.translation); // copy the object
                this.drag.nodeId = undefined;
                if (event.srcEvent.shiftKey) {
                    this.body.selectionBox.show = true;
                    var pointer = this.getPointer(event.center);
                    this.body.selectionBox.position.start = {
                        x: this.canvas._XconvertDOMtoCanvas(pointer.x),
                        y: this.canvas._YconvertDOMtoCanvas(pointer.y)
                    };
                    this.body.selectionBox.position.end = {
                        x: this.canvas._XconvertDOMtoCanvas(pointer.x),
                        y: this.canvas._YconvertDOMtoCanvas(pointer.y)
                    };
                } else if (node !== undefined && this.options.dragNodes === true) {
                    this.drag.nodeId = node.id;
                    // select the clicked node if not yet selected
                    if (node.isSelected() === false) this.selectionHandler.setSelection({
                        nodes: [
                            node.id
                        ]
                    });
                    // after select to contain the node
                    this.selectionHandler.generateClickEvent("dragStart", event, this.drag.pointer);
                    // create an array with the selected nodes and their original location and status
                    var _iterator = $bebd28704f2536ea$var$_createForOfIteratorHelper$4(this.selectionHandler.getSelectedNodes()), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var _node = _step.value;
                            var s = {
                                id: _node.id,
                                node: _node,
                                // store original x, y, xFixed and yFixed, make the node temporarily Fixed
                                x: _node.x,
                                y: _node.y,
                                xFixed: _node.options.fixed.x,
                                yFixed: _node.options.fixed.y
                            };
                            _node.options.fixed.x = true;
                            _node.options.fixed.y = true;
                            this.drag.selection.push(s);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                } else // fallback if no node is selected and thus the view is dragged.
                this.selectionHandler.generateClickEvent("dragStart", event, this.drag.pointer, undefined, true);
            }
        },
        {
            key: "onDrag",
            value: function onDrag(event) {
                var _this2 = this;
                if (this.drag.pinched === true) return;
                // remove the focus on node if it is focussed on by the focusOnNode
                this.body.emitter.emit("unlockNode");
                var pointer = this.getPointer(event.center);
                var selection = this.drag.selection;
                if (selection && selection.length && this.options.dragNodes === true) {
                    this.selectionHandler.generateClickEvent("dragging", event, pointer);
                    // calculate delta's and new location
                    var deltaX = pointer.x - this.drag.pointer.x;
                    var deltaY = pointer.y - this.drag.pointer.y;
                    // update position of all selected nodes
                    $bebd28704f2536ea$var$_forEachInstanceProperty(selection).call(selection, function(selection) {
                        var node = selection.node;
                        // only move the node if it was not fixed initially
                        if (selection.xFixed === false) node.x = _this2.canvas._XconvertDOMtoCanvas(_this2.canvas._XconvertCanvasToDOM(selection.x) + deltaX);
                        // only move the node if it was not fixed initially
                        if (selection.yFixed === false) node.y = _this2.canvas._YconvertDOMtoCanvas(_this2.canvas._YconvertCanvasToDOM(selection.y) + deltaY);
                    });
                    // start the simulation of the physics
                    this.body.emitter.emit("startSimulation");
                } else {
                    // create selection box
                    if (event.srcEvent.shiftKey) {
                        this.selectionHandler.generateClickEvent("dragging", event, pointer, undefined, true);
                        // if the drag was not started properly because the click started outside the network div, start it now.
                        if (this.drag.pointer === undefined) {
                            this.onDragStart(event);
                            return;
                        }
                        this.body.selectionBox.position.end = {
                            x: this.canvas._XconvertDOMtoCanvas(pointer.x),
                            y: this.canvas._YconvertDOMtoCanvas(pointer.y)
                        };
                        this.body.emitter.emit("_requestRedraw");
                    }
                    // move the network
                    if (this.options.dragView === true && !event.srcEvent.shiftKey) {
                        this.selectionHandler.generateClickEvent("dragging", event, pointer, undefined, true);
                        // if the drag was not started properly because the click started outside the network div, start it now.
                        if (this.drag.pointer === undefined) {
                            this.onDragStart(event);
                            return;
                        }
                        var diffX = pointer.x - this.drag.pointer.x;
                        var diffY = pointer.y - this.drag.pointer.y;
                        this.body.view.translation = {
                            x: this.drag.translation.x + diffX,
                            y: this.drag.translation.y + diffY
                        };
                        this.body.emitter.emit("_requestRedraw");
                    }
                }
            }
        },
        {
            key: "onDragEnd",
            value: function onDragEnd(event) {
                var _this3 = this;
                this.drag.dragging = false;
                if (this.body.selectionBox.show) {
                    var _context14;
                    this.body.selectionBox.show = false;
                    var selectionBoxPosition = this.body.selectionBox.position;
                    var selectionBoxPositionMinMax = {
                        minX: Math.min(selectionBoxPosition.start.x, selectionBoxPosition.end.x),
                        minY: Math.min(selectionBoxPosition.start.y, selectionBoxPosition.end.y),
                        maxX: Math.max(selectionBoxPosition.start.x, selectionBoxPosition.end.x),
                        maxY: Math.max(selectionBoxPosition.start.y, selectionBoxPosition.end.y)
                    };
                    var toBeSelectedNodes = $bebd28704f2536ea$var$_filterInstanceProperty(_context14 = this.body.nodeIndices).call(_context14, function(nodeId) {
                        var node = _this3.body.nodes[nodeId];
                        return node.x >= selectionBoxPositionMinMax.minX && node.x <= selectionBoxPositionMinMax.maxX && node.y >= selectionBoxPositionMinMax.minY && node.y <= selectionBoxPositionMinMax.maxY;
                    });
                    $bebd28704f2536ea$var$_forEachInstanceProperty(toBeSelectedNodes).call(toBeSelectedNodes, function(nodeId) {
                        return _this3.selectionHandler.selectObject(_this3.body.nodes[nodeId]);
                    });
                    var pointer = this.getPointer(event.center);
                    this.selectionHandler.commitAndEmit(pointer, event);
                    this.selectionHandler.generateClickEvent("dragEnd", event, this.getPointer(event.center), undefined, true);
                    this.body.emitter.emit("_requestRedraw");
                } else {
                    var selection = this.drag.selection;
                    if (selection && selection.length) {
                        $bebd28704f2536ea$var$_forEachInstanceProperty(selection).call(selection, function(s) {
                            // restore original xFixed and yFixed
                            s.node.options.fixed.x = s.xFixed;
                            s.node.options.fixed.y = s.yFixed;
                        });
                        this.selectionHandler.generateClickEvent("dragEnd", event, this.getPointer(event.center));
                        this.body.emitter.emit("startSimulation");
                    } else {
                        this.selectionHandler.generateClickEvent("dragEnd", event, this.getPointer(event.center), undefined, true);
                        this.body.emitter.emit("_requestRedraw");
                    }
                }
            }
        },
        {
            key: "onPinch",
            value: function onPinch(event) {
                var pointer = this.getPointer(event.center);
                this.drag.pinched = true;
                if (this.pinch["scale"] === undefined) this.pinch.scale = 1;
                // TODO: enabled moving while pinching?
                var scale = this.pinch.scale * event.scale;
                this.zoom(scale, pointer);
            }
        },
        {
            key: "zoom",
            value: function zoom(scale, pointer) {
                if (this.options.zoomView === true) {
                    var scaleOld = this.body.view.scale;
                    if (scale < 0.00001) scale = 0.00001;
                    if (scale > 10) scale = 10;
                    var preScaleDragPointer = undefined;
                    if (this.drag !== undefined) {
                        if (this.drag.dragging === true) preScaleDragPointer = this.canvas.DOMtoCanvas(this.drag.pointer);
                    }
                    // + this.canvas.frame.canvas.clientHeight / 2
                    var translation = this.body.view.translation;
                    var scaleFrac = scale / scaleOld;
                    var tx = (1 - scaleFrac) * pointer.x + translation.x * scaleFrac;
                    var ty = (1 - scaleFrac) * pointer.y + translation.y * scaleFrac;
                    this.body.view.scale = scale;
                    this.body.view.translation = {
                        x: tx,
                        y: ty
                    };
                    if (preScaleDragPointer != undefined) {
                        var postScaleDragPointer = this.canvas.canvasToDOM(preScaleDragPointer);
                        this.drag.pointer.x = postScaleDragPointer.x;
                        this.drag.pointer.y = postScaleDragPointer.y;
                    }
                    this.body.emitter.emit("_requestRedraw");
                    if (scaleOld < scale) this.body.emitter.emit("zoom", {
                        direction: "+",
                        scale: this.body.view.scale,
                        pointer: pointer
                    });
                    else this.body.emitter.emit("zoom", {
                        direction: "-",
                        scale: this.body.view.scale,
                        pointer: pointer
                    });
                }
            }
        },
        {
            key: "onMouseWheel",
            value: function onMouseWheel(event) {
                if (this.options.zoomView === true) {
                    // If delta is nonzero, handle it.
                    // Basically, delta is now positive if wheel was scrolled up,
                    // and negative, if wheel was scrolled down.
                    if (event.deltaY !== 0) {
                        // calculate the new scale
                        var scale = this.body.view.scale;
                        scale *= 1 + (event.deltaY < 0 ? 1 : -1) * (this.options.zoomSpeed * 0.1);
                        // calculate the pointer location
                        var pointer = this.getPointer({
                            x: event.clientX,
                            y: event.clientY
                        });
                        // apply the new scale
                        this.zoom(scale, pointer);
                    }
                    // Prevent default actions caused by mouse wheel.
                    event.preventDefault();
                }
            }
        },
        {
            key: "onMouseMove",
            value: function onMouseMove(event) {
                var _this4 = this;
                var pointer = this.getPointer({
                    x: event.clientX,
                    y: event.clientY
                });
                var popupVisible = false;
                // check if the previously selected node is still selected
                if (this.popup !== undefined) {
                    if (this.popup.hidden === false) this._checkHidePopup(pointer);
                    // if the popup was not hidden above
                    if (this.popup.hidden === false) {
                        popupVisible = true;
                        this.popup.setPosition(pointer.x + 3, pointer.y - 5);
                        this.popup.show();
                    }
                }
                // if we bind the keyboard to the div, we have to highlight it to use it. This highlights it on mouse over.
                if (this.options.keyboard.autoFocus && this.options.keyboard.bindToWindow === false && this.options.keyboard.enabled === true) this.canvas.frame.focus();
                // start a timeout that will check if the mouse is positioned above an element
                if (popupVisible === false) {
                    if (this.popupTimer !== undefined) {
                        clearInterval(this.popupTimer); // stop any running calculationTimer
                        this.popupTimer = undefined;
                    }
                    if (!this.drag.dragging) this.popupTimer = $bebd28704f2536ea$var$_setTimeout(function() {
                        return _this4._checkShowPopup(pointer);
                    }, this.options.tooltipDelay);
                }
                // adding hover highlights
                if (this.options.hover === true) this.selectionHandler.hoverObject(event, pointer);
            }
        },
        {
            key: "_checkShowPopup",
            value: function _checkShowPopup(pointer) {
                var x = this.canvas._XconvertDOMtoCanvas(pointer.x);
                var y = this.canvas._YconvertDOMtoCanvas(pointer.y);
                var pointerObj = {
                    left: x,
                    top: y,
                    right: x,
                    bottom: y
                };
                var previousPopupObjId = this.popupObj === undefined ? undefined : this.popupObj.id;
                var nodeUnderCursor = false;
                var popupType = "node";
                // check if a node is under the cursor.
                if (this.popupObj === undefined) {
                    // search the nodes for overlap, select the top one in case of multiple nodes
                    var nodeIndices = this.body.nodeIndices;
                    var nodes = this.body.nodes;
                    var node;
                    var overlappingNodes = [];
                    for(var i = 0; i < nodeIndices.length; i++){
                        node = nodes[nodeIndices[i]];
                        if (node.isOverlappingWith(pointerObj) === true) {
                            nodeUnderCursor = true;
                            if (node.getTitle() !== undefined) overlappingNodes.push(nodeIndices[i]);
                        }
                    }
                    if (overlappingNodes.length > 0) {
                        // if there are overlapping nodes, select the last one, this is the one which is drawn on top of the others
                        this.popupObj = nodes[overlappingNodes[overlappingNodes.length - 1]];
                        // if you hover over a node, the title of the edge is not supposed to be shown.
                        nodeUnderCursor = true;
                    }
                }
                if (this.popupObj === undefined && nodeUnderCursor === false) {
                    // search the edges for overlap
                    var edgeIndices = this.body.edgeIndices;
                    var edges = this.body.edges;
                    var edge;
                    var overlappingEdges = [];
                    for(var _i = 0; _i < edgeIndices.length; _i++){
                        edge = edges[edgeIndices[_i]];
                        if (edge.isOverlappingWith(pointerObj) === true) {
                            if (edge.connected === true && edge.getTitle() !== undefined) overlappingEdges.push(edgeIndices[_i]);
                        }
                    }
                    if (overlappingEdges.length > 0) {
                        this.popupObj = edges[overlappingEdges[overlappingEdges.length - 1]];
                        popupType = "edge";
                    }
                }
                if (this.popupObj !== undefined) // show popup message window
                {
                    if (this.popupObj.id !== previousPopupObjId) {
                        if (this.popup === undefined) this.popup = new $bebd28704f2536ea$var$Popup(this.canvas.frame);
                        this.popup.popupTargetType = popupType;
                        this.popup.popupTargetId = this.popupObj.id;
                        // adjust a small offset such that the mouse cursor is located in the
                        // bottom left location of the popup, and you can easily move over the
                        // popup area
                        this.popup.setPosition(pointer.x + 3, pointer.y - 5);
                        this.popup.setText(this.popupObj.getTitle());
                        this.popup.show();
                        this.body.emitter.emit("showPopup", this.popupObj.id);
                    }
                } else if (this.popup !== undefined) {
                    this.popup.hide();
                    this.body.emitter.emit("hidePopup");
                }
            }
        },
        {
            key: "_checkHidePopup",
            value: function _checkHidePopup(pointer) {
                var pointerObj = this.selectionHandler._pointerToPositionObject(pointer);
                var stillOnObj = false;
                if (this.popup.popupTargetType === "node") {
                    if (this.body.nodes[this.popup.popupTargetId] !== undefined) {
                        stillOnObj = this.body.nodes[this.popup.popupTargetId].isOverlappingWith(pointerObj);
                        // if the mouse is still one the node, we have to check if it is not also on one that is drawn on top of it.
                        // we initially only check stillOnObj because this is much faster.
                        if (stillOnObj === true) {
                            var overNode = this.selectionHandler.getNodeAt(pointer);
                            stillOnObj = overNode === undefined ? false : overNode.id === this.popup.popupTargetId;
                        }
                    }
                } else {
                    if (this.selectionHandler.getNodeAt(pointer) === undefined) {
                        if (this.body.edges[this.popup.popupTargetId] !== undefined) stillOnObj = this.body.edges[this.popup.popupTargetId].isOverlappingWith(pointerObj);
                    }
                }
                if (stillOnObj === false) {
                    this.popupObj = undefined;
                    this.popup.hide();
                    this.body.emitter.emit("hidePopup");
                }
            }
        }
    ]);
    return InteractionHandler;
}();
var $bebd28704f2536ea$var$collection$1 = $bebd28704f2536ea$var$collection$3;
var $bebd28704f2536ea$var$collectionStrong = $bebd28704f2536ea$var$collectionStrong$2;
// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
$bebd28704f2536ea$var$collection$1('Set', function(init) {
    return function Set() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, $bebd28704f2536ea$var$collectionStrong);
var $bebd28704f2536ea$var$path$1 = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$set$2 = $bebd28704f2536ea$var$path$1.Set;
var $bebd28704f2536ea$var$parent$4 = $bebd28704f2536ea$var$set$2;
var $bebd28704f2536ea$var$set$1 = $bebd28704f2536ea$var$parent$4;
var $bebd28704f2536ea$var$set = $bebd28704f2536ea$var$set$1;
var $bebd28704f2536ea$var$_Set = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$set);
var $bebd28704f2536ea$var$uncurryThis$2 = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$defineBuiltIns$1 = $bebd28704f2536ea$var$defineBuiltIns$3;
var $bebd28704f2536ea$var$getWeakData = $bebd28704f2536ea$var$internalMetadataExports.getWeakData;
var $bebd28704f2536ea$var$anInstance = $bebd28704f2536ea$var$anInstance$3;
var $bebd28704f2536ea$var$anObject = $bebd28704f2536ea$var$anObject$d;
var $bebd28704f2536ea$var$isNullOrUndefined = $bebd28704f2536ea$var$isNullOrUndefined$6;
var $bebd28704f2536ea$var$isObject$1 = $bebd28704f2536ea$var$isObject$j;
var $bebd28704f2536ea$var$iterate = $bebd28704f2536ea$var$iterate$3;
var $bebd28704f2536ea$var$ArrayIterationModule = $bebd28704f2536ea$var$arrayIteration;
var $bebd28704f2536ea$var$hasOwn = $bebd28704f2536ea$var$hasOwnProperty_1;
var $bebd28704f2536ea$var$InternalStateModule = $bebd28704f2536ea$var$internalState;
var $bebd28704f2536ea$var$setInternalState = $bebd28704f2536ea$var$InternalStateModule.set;
var $bebd28704f2536ea$var$internalStateGetterFor = $bebd28704f2536ea$var$InternalStateModule.getterFor;
var $bebd28704f2536ea$var$find = $bebd28704f2536ea$var$ArrayIterationModule.find;
var $bebd28704f2536ea$var$findIndex = $bebd28704f2536ea$var$ArrayIterationModule.findIndex;
var $bebd28704f2536ea$var$splice = $bebd28704f2536ea$var$uncurryThis$2([].splice);
var $bebd28704f2536ea$var$id = 0;
// fallback for uncaught frozen keys
var $bebd28704f2536ea$var$uncaughtFrozenStore = function(state) {
    return state.frozen || (state.frozen = new $bebd28704f2536ea$var$UncaughtFrozenStore());
};
var $bebd28704f2536ea$var$UncaughtFrozenStore = function() {
    this.entries = [];
};
var $bebd28704f2536ea$var$findUncaughtFrozen = function(store, key) {
    return $bebd28704f2536ea$var$find(store.entries, function(it) {
        return it[0] === key;
    });
};
$bebd28704f2536ea$var$UncaughtFrozenStore.prototype = {
    get: function(key) {
        var entry = $bebd28704f2536ea$var$findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function(key) {
        return !!$bebd28704f2536ea$var$findUncaughtFrozen(this, key);
    },
    set: function(key, value) {
        var entry = $bebd28704f2536ea$var$findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.entries.push([
            key,
            value
        ]);
    },
    'delete': function(key) {
        var index = $bebd28704f2536ea$var$findIndex(this.entries, function(it) {
            return it[0] === key;
        });
        if (~index) $bebd28704f2536ea$var$splice(this.entries, index, 1);
        return !!~index;
    }
};
var $bebd28704f2536ea$var$collectionWeak$1 = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $bebd28704f2536ea$var$anInstance(that, Prototype);
            $bebd28704f2536ea$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                id: $bebd28704f2536ea$var$id++,
                frozen: undefined
            });
            if (!$bebd28704f2536ea$var$isNullOrUndefined(iterable)) $bebd28704f2536ea$var$iterate(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $bebd28704f2536ea$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var data = $bebd28704f2536ea$var$getWeakData($bebd28704f2536ea$var$anObject(key), true);
            if (data === true) $bebd28704f2536ea$var$uncaughtFrozenStore(state).set(key, value);
            else data[state.id] = value;
            return that;
        };
        $bebd28704f2536ea$var$defineBuiltIns$1(Prototype, {
            // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
            // https://tc39.es/ecma262/#sec-weakset.prototype.delete
            'delete': function(key) {
                var state = getInternalState(this);
                if (!$bebd28704f2536ea$var$isObject$1(key)) return false;
                var data = $bebd28704f2536ea$var$getWeakData(key);
                if (data === true) return $bebd28704f2536ea$var$uncaughtFrozenStore(state)['delete'](key);
                return data && $bebd28704f2536ea$var$hasOwn(data, state.id) && delete data[state.id];
            },
            // `{ WeakMap, WeakSet }.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.has
            // https://tc39.es/ecma262/#sec-weakset.prototype.has
            has: function has(key) {
                var state = getInternalState(this);
                if (!$bebd28704f2536ea$var$isObject$1(key)) return false;
                var data = $bebd28704f2536ea$var$getWeakData(key);
                if (data === true) return $bebd28704f2536ea$var$uncaughtFrozenStore(state).has(key);
                return data && $bebd28704f2536ea$var$hasOwn(data, state.id);
            }
        });
        $bebd28704f2536ea$var$defineBuiltIns$1(Prototype, IS_MAP ? {
            // `WeakMap.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.get
            get: function get(key) {
                var state = getInternalState(this);
                if ($bebd28704f2536ea$var$isObject$1(key)) {
                    var data = $bebd28704f2536ea$var$getWeakData(key);
                    if (data === true) return $bebd28704f2536ea$var$uncaughtFrozenStore(state).get(key);
                    return data ? data[state.id] : undefined;
                }
            },
            // `WeakMap.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.set
            set: function set(key, value) {
                return define(this, key, value);
            }
        } : {
            // `WeakSet.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-weakset.prototype.add
            add: function add(value) {
                return define(this, value, true);
            }
        });
        return Constructor;
    }
};
var $bebd28704f2536ea$var$FREEZING = $bebd28704f2536ea$var$freezing;
var $bebd28704f2536ea$var$global$2 = $bebd28704f2536ea$var$global$n;
var $bebd28704f2536ea$var$uncurryThis$1 = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$defineBuiltIns = $bebd28704f2536ea$var$defineBuiltIns$3;
var $bebd28704f2536ea$var$InternalMetadataModule = $bebd28704f2536ea$var$internalMetadataExports;
var $bebd28704f2536ea$var$collection = $bebd28704f2536ea$var$collection$3;
var $bebd28704f2536ea$var$collectionWeak = $bebd28704f2536ea$var$collectionWeak$1;
var $bebd28704f2536ea$var$isObject = $bebd28704f2536ea$var$isObject$j;
var $bebd28704f2536ea$var$enforceInternalState = $bebd28704f2536ea$var$internalState.enforce;
var $bebd28704f2536ea$var$fails$1 = $bebd28704f2536ea$var$fails$w;
var $bebd28704f2536ea$var$NATIVE_WEAK_MAP = $bebd28704f2536ea$var$weakMapBasicDetection;
var $bebd28704f2536ea$var$$Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var $bebd28704f2536ea$var$isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var $bebd28704f2536ea$var$isExtensible = $bebd28704f2536ea$var$$Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var $bebd28704f2536ea$var$isFrozen = $bebd28704f2536ea$var$$Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var $bebd28704f2536ea$var$isSealed = $bebd28704f2536ea$var$$Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var $bebd28704f2536ea$var$freeze = $bebd28704f2536ea$var$$Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var $bebd28704f2536ea$var$seal = $bebd28704f2536ea$var$$Object.seal;
var $bebd28704f2536ea$var$FROZEN = {};
var $bebd28704f2536ea$var$SEALED = {};
var $bebd28704f2536ea$var$IS_IE11 = !$bebd28704f2536ea$var$global$2.ActiveXObject && 'ActiveXObject' in $bebd28704f2536ea$var$global$2;
var $bebd28704f2536ea$var$InternalWeakMap;
var $bebd28704f2536ea$var$wrapper = function(init) {
    return function WeakMap() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
};
// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $bebd28704f2536ea$var$$WeakMap = $bebd28704f2536ea$var$collection('WeakMap', $bebd28704f2536ea$var$wrapper, $bebd28704f2536ea$var$collectionWeak);
var $bebd28704f2536ea$var$WeakMapPrototype = $bebd28704f2536ea$var$$WeakMap.prototype;
var $bebd28704f2536ea$var$nativeSet = $bebd28704f2536ea$var$uncurryThis$1($bebd28704f2536ea$var$WeakMapPrototype.set);
// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var $bebd28704f2536ea$var$hasMSEdgeFreezingBug = function() {
    return $bebd28704f2536ea$var$FREEZING && $bebd28704f2536ea$var$fails$1(function() {
        var frozenArray = $bebd28704f2536ea$var$freeze([]);
        $bebd28704f2536ea$var$nativeSet(new $bebd28704f2536ea$var$$WeakMap(), frozenArray, 1);
        return !$bebd28704f2536ea$var$isFrozen(frozenArray);
    });
};
// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if ($bebd28704f2536ea$var$NATIVE_WEAK_MAP) {
    if ($bebd28704f2536ea$var$IS_IE11) {
        $bebd28704f2536ea$var$InternalWeakMap = $bebd28704f2536ea$var$collectionWeak.getConstructor($bebd28704f2536ea$var$wrapper, 'WeakMap', true);
        $bebd28704f2536ea$var$InternalMetadataModule.enable();
        var $bebd28704f2536ea$var$nativeDelete = $bebd28704f2536ea$var$uncurryThis$1($bebd28704f2536ea$var$WeakMapPrototype['delete']);
        var $bebd28704f2536ea$var$nativeHas = $bebd28704f2536ea$var$uncurryThis$1($bebd28704f2536ea$var$WeakMapPrototype.has);
        var $bebd28704f2536ea$var$nativeGet = $bebd28704f2536ea$var$uncurryThis$1($bebd28704f2536ea$var$WeakMapPrototype.get);
        $bebd28704f2536ea$var$defineBuiltIns($bebd28704f2536ea$var$WeakMapPrototype, {
            'delete': function(key) {
                if ($bebd28704f2536ea$var$isObject(key) && !$bebd28704f2536ea$var$isExtensible(key)) {
                    var state = $bebd28704f2536ea$var$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $bebd28704f2536ea$var$InternalWeakMap();
                    return $bebd28704f2536ea$var$nativeDelete(this, key) || state.frozen['delete'](key);
                }
                return $bebd28704f2536ea$var$nativeDelete(this, key);
            },
            has: function has(key) {
                if ($bebd28704f2536ea$var$isObject(key) && !$bebd28704f2536ea$var$isExtensible(key)) {
                    var state = $bebd28704f2536ea$var$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $bebd28704f2536ea$var$InternalWeakMap();
                    return $bebd28704f2536ea$var$nativeHas(this, key) || state.frozen.has(key);
                }
                return $bebd28704f2536ea$var$nativeHas(this, key);
            },
            get: function get(key) {
                if ($bebd28704f2536ea$var$isObject(key) && !$bebd28704f2536ea$var$isExtensible(key)) {
                    var state = $bebd28704f2536ea$var$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $bebd28704f2536ea$var$InternalWeakMap();
                    return $bebd28704f2536ea$var$nativeHas(this, key) ? $bebd28704f2536ea$var$nativeGet(this, key) : state.frozen.get(key);
                }
                return $bebd28704f2536ea$var$nativeGet(this, key);
            },
            set: function set(key, value) {
                if ($bebd28704f2536ea$var$isObject(key) && !$bebd28704f2536ea$var$isExtensible(key)) {
                    var state = $bebd28704f2536ea$var$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $bebd28704f2536ea$var$InternalWeakMap();
                    $bebd28704f2536ea$var$nativeHas(this, key) ? $bebd28704f2536ea$var$nativeSet(this, key, value) : state.frozen.set(key, value);
                } else $bebd28704f2536ea$var$nativeSet(this, key, value);
                return this;
            }
        });
    // Chakra Edge frozen keys fix
    } else if ($bebd28704f2536ea$var$hasMSEdgeFreezingBug()) $bebd28704f2536ea$var$defineBuiltIns($bebd28704f2536ea$var$WeakMapPrototype, {
        set: function set(key, value) {
            var arrayIntegrityLevel;
            if ($bebd28704f2536ea$var$isArray(key)) {
                if ($bebd28704f2536ea$var$isFrozen(key)) arrayIntegrityLevel = $bebd28704f2536ea$var$FROZEN;
                else if ($bebd28704f2536ea$var$isSealed(key)) arrayIntegrityLevel = $bebd28704f2536ea$var$SEALED;
            }
            $bebd28704f2536ea$var$nativeSet(this, key, value);
            if (arrayIntegrityLevel === $bebd28704f2536ea$var$FROZEN) $bebd28704f2536ea$var$freeze(key);
            if (arrayIntegrityLevel === $bebd28704f2536ea$var$SEALED) $bebd28704f2536ea$var$seal(key);
            return this;
        }
    });
}
var $bebd28704f2536ea$var$path = $bebd28704f2536ea$var$path$w;
var $bebd28704f2536ea$var$weakMap$2 = $bebd28704f2536ea$var$path.WeakMap;
var $bebd28704f2536ea$var$parent$3 = $bebd28704f2536ea$var$weakMap$2;
var $bebd28704f2536ea$var$weakMap$1 = $bebd28704f2536ea$var$parent$3;
var $bebd28704f2536ea$var$weakMap = $bebd28704f2536ea$var$weakMap$1;
var $bebd28704f2536ea$var$_WeakMap = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$weakMap);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ function $bebd28704f2536ea$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $bebd28704f2536ea$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
typeof SuppressedError === "function" && SuppressedError;
function $bebd28704f2536ea$var$_createForOfIteratorHelper$3(o, allowArrayLike) {
    var it = typeof $bebd28704f2536ea$var$_Symbol !== "undefined" && $bebd28704f2536ea$var$_getIteratorMethod(o) || o["@@iterator"];
    if (!it) {
        if ($bebd28704f2536ea$var$_Array$isArray(o) || (it = $bebd28704f2536ea$var$_unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $bebd28704f2536ea$var$_unsupportedIterableToArray$3(o, minLen) {
    var _context2;
    if (!o) return;
    if (typeof o === "string") return $bebd28704f2536ea$var$_arrayLikeToArray$3(o, minLen);
    var n = $bebd28704f2536ea$var$_sliceInstanceProperty(_context2 = Object.prototype.toString.call(o)).call(_context2, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return $bebd28704f2536ea$var$_Array$from$1(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bebd28704f2536ea$var$_arrayLikeToArray$3(o, minLen);
}
function $bebd28704f2536ea$var$_arrayLikeToArray$3(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $bebd28704f2536ea$var$_SingleTypeSelectionAccumulator_previousSelection, $bebd28704f2536ea$var$_SingleTypeSelectionAccumulator_selection, $bebd28704f2536ea$var$_SelectionAccumulator_nodes, $bebd28704f2536ea$var$_SelectionAccumulator_edges, $bebd28704f2536ea$var$_SelectionAccumulator_commitHandler;
/**
 * @param prev
 * @param next
 */ function $bebd28704f2536ea$var$diffSets(prev, next) {
    var diff = new $bebd28704f2536ea$var$_Set();
    var _iterator = $bebd28704f2536ea$var$_createForOfIteratorHelper$3(next), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var item = _step.value;
            if (!prev.has(item)) diff.add(item);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return diff;
}
var $bebd28704f2536ea$var$SingleTypeSelectionAccumulator = /*#__PURE__*/ function() {
    function SingleTypeSelectionAccumulator() {
        $bebd28704f2536ea$var$_classCallCheck(this, SingleTypeSelectionAccumulator);
        $bebd28704f2536ea$var$_SingleTypeSelectionAccumulator_previousSelection.set(this, new $bebd28704f2536ea$var$_Set());
        $bebd28704f2536ea$var$_SingleTypeSelectionAccumulator_selection.set(this, new $bebd28704f2536ea$var$_Set());
    }
    $bebd28704f2536ea$var$_createClass(SingleTypeSelectionAccumulator, [
        {
            key: "size",
            get: function get() {
                return $bebd28704f2536ea$var$__classPrivateFieldGet(this, $bebd28704f2536ea$var$_SingleTypeSelectionAccumulator_selection, "f").size;
            }
        },
        {
            key: "add",
            value: function add() {
                for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++)items[_key] = arguments[_key];
                for(var _i = 0, _items = items; _i < _items.length; _i++){
                    var item = _items[_i];
                    $bebd28704f2536ea$var$__classPrivateFieldGet(this, $bebd28704f2536ea$var$_SingleTypeSelectionAccumulator_selection, "f").add(item);
                }
            }
        },
        {
            key: "delete",
            value: function _delete() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                for(var _i2 = 0, _items2 = items; _i2 < _items2.length; _i2++){
                    var item = _items2[_i2];
                    $bebd28704f2536ea$var$__classPrivateFieldGet(this, $bebd28704f2536ea$var$_SingleTypeSelectionAccumulator_selection, "f").delete(item);
                }
            }
        },
        {
            key: "clear",
            value: function clear() {
                $bebd28704f2536ea$var$__classPrivateFieldGet(this, $bebd28704f2536ea$var$_SingleTypeSelectionAccumulator_selection, "f").clear();
            }
        },
        {
            key: "getSelection",
            value: function getSelection() {
                return $bebd28704f2536ea$var$_toConsumableArray($bebd28704f2536ea$var$__classPrivateFieldGet(this, $bebd28704f2536ea$var$_SingleTypeSelectionAccumulator_selection, "f"));
            }
        },
        {
            key: "getChanges",
            value: function getChanges() {
                return {
                    added: $bebd28704f2536ea$var$_toConsumableArray($bebd28704f2536ea$var$diffSets($bebd28704f2536ea$var$__classPrivateFieldGet(this, $bebd28704f2536ea$var$_SingleTypeSelectionAccumulator_previousSelection, "f"), $bebd28704f2536ea$var$__classPrivateFieldGet(this, $bebd28704f2536ea$var$_SingleTypeSelectionAccumulator_selection, "f"))),
                    deleted: $bebd28704f2536ea$var$_toConsumableArray($bebd28704f2536ea$var$diffSets($bebd28704f2536ea$var$__classPrivateFieldGet(this, $bebd28704f2536ea$var$_SingleTypeSelectionAccumulator_selection, "f"), $bebd28704f2536ea$var$__classPrivateFieldGet(this, $bebd28704f2536ea$var$_SingleTypeSelectionAccumulator_previousSelection, "f"))),
                    previous: $bebd28704f2536ea$var$_toConsumableArray(new $bebd28704f2536ea$var$_Set($bebd28704f2536ea$var$__classPrivateFieldGet(this, $bebd28704f2536ea$var$_SingleTypeSelectionAccumulator_previousSelection, "f"))),
                    current: $bebd28704f2536ea$var$_toConsumableArray(new $bebd28704f2536ea$var$_Set($bebd28704f2536ea$var$__classPrivateFieldGet(this, $bebd28704f2536ea$var$_SingleTypeSelectionAccumulator_selection, "f")))
                };
            }
        },
        {
            key: "commit",
            value: function commit() {
                var changes = this.getChanges();
                $bebd28704f2536ea$var$__classPrivateFieldSet(this, $bebd28704f2536ea$var$_SingleTypeSelectionAccumulator_previousSelection, $bebd28704f2536ea$var$__classPrivateFieldGet(this, $bebd28704f2536ea$var$_SingleTypeSelectionAccumulator_selection, "f"), "f");
                $bebd28704f2536ea$var$__classPrivateFieldSet(this, $bebd28704f2536ea$var$_SingleTypeSelectionAccumulator_selection, new $bebd28704f2536ea$var$_Set($bebd28704f2536ea$var$__classPrivateFieldGet(this, $bebd28704f2536ea$var$_SingleTypeSelectionAccumulator_previousSelection, "f")), "f");
                var _iterator2 = $bebd28704f2536ea$var$_createForOfIteratorHelper$3(changes.added), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var item = _step2.value;
                        item.select();
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
                var _iterator3 = $bebd28704f2536ea$var$_createForOfIteratorHelper$3(changes.deleted), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var _item = _step3.value;
                        _item.unselect();
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                return changes;
            }
        }
    ]);
    return SingleTypeSelectionAccumulator;
}();
$bebd28704f2536ea$var$_SingleTypeSelectionAccumulator_previousSelection = new $bebd28704f2536ea$var$_WeakMap(), $bebd28704f2536ea$var$_SingleTypeSelectionAccumulator_selection = new $bebd28704f2536ea$var$_WeakMap();
var $bebd28704f2536ea$var$SelectionAccumulator = /*#__PURE__*/ function() {
    function SelectionAccumulator() {
        var commitHandler = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function() {};
        $bebd28704f2536ea$var$_classCallCheck(this, SelectionAccumulator);
        $bebd28704f2536ea$var$_SelectionAccumulator_nodes.set(this, new $bebd28704f2536ea$var$SingleTypeSelectionAccumulator());
        $bebd28704f2536ea$var$_SelectionAccumulator_edges.set(this, new $bebd28704f2536ea$var$SingleTypeSelectionAccumulator());
        $bebd28704f2536ea$var$_SelectionAccumulator_commitHandler.set(this, void 0);
        $bebd28704f2536ea$var$__classPrivateFieldSet(this, $bebd28704f2536ea$var$_SelectionAccumulator_commitHandler, commitHandler, "f");
    }
    $bebd28704f2536ea$var$_createClass(SelectionAccumulator, [
        {
            key: "sizeNodes",
            get: function get() {
                return $bebd28704f2536ea$var$__classPrivateFieldGet(this, $bebd28704f2536ea$var$_SelectionAccumulator_nodes, "f").size;
            }
        },
        {
            key: "sizeEdges",
            get: function get() {
                return $bebd28704f2536ea$var$__classPrivateFieldGet(this, $bebd28704f2536ea$var$_SelectionAccumulator_edges, "f").size;
            }
        },
        {
            key: "getNodes",
            value: function getNodes() {
                return $bebd28704f2536ea$var$__classPrivateFieldGet(this, $bebd28704f2536ea$var$_SelectionAccumulator_nodes, "f").getSelection();
            }
        },
        {
            key: "getEdges",
            value: function getEdges() {
                return $bebd28704f2536ea$var$__classPrivateFieldGet(this, $bebd28704f2536ea$var$_SelectionAccumulator_edges, "f").getSelection();
            }
        },
        {
            key: "addNodes",
            value: function addNodes() {
                var _classPrivateFieldGe;
                (_classPrivateFieldGe = $bebd28704f2536ea$var$__classPrivateFieldGet(this, $bebd28704f2536ea$var$_SelectionAccumulator_nodes, "f")).add.apply(_classPrivateFieldGe, arguments);
            }
        },
        {
            key: "addEdges",
            value: function addEdges() {
                var _classPrivateFieldGe2;
                (_classPrivateFieldGe2 = $bebd28704f2536ea$var$__classPrivateFieldGet(this, $bebd28704f2536ea$var$_SelectionAccumulator_edges, "f")).add.apply(_classPrivateFieldGe2, arguments);
            }
        },
        {
            key: "deleteNodes",
            value: function deleteNodes(node) {
                $bebd28704f2536ea$var$__classPrivateFieldGet(this, $bebd28704f2536ea$var$_SelectionAccumulator_nodes, "f").delete(node);
            }
        },
        {
            key: "deleteEdges",
            value: function deleteEdges(edge) {
                $bebd28704f2536ea$var$__classPrivateFieldGet(this, $bebd28704f2536ea$var$_SelectionAccumulator_edges, "f").delete(edge);
            }
        },
        {
            key: "clear",
            value: function clear() {
                $bebd28704f2536ea$var$__classPrivateFieldGet(this, $bebd28704f2536ea$var$_SelectionAccumulator_nodes, "f").clear();
                $bebd28704f2536ea$var$__classPrivateFieldGet(this, $bebd28704f2536ea$var$_SelectionAccumulator_edges, "f").clear();
            }
        },
        {
            key: "commit",
            value: function commit() {
                var _classPrivateFieldGe3, _context;
                var summary = {
                    nodes: $bebd28704f2536ea$var$__classPrivateFieldGet(this, $bebd28704f2536ea$var$_SelectionAccumulator_nodes, "f").commit(),
                    edges: $bebd28704f2536ea$var$__classPrivateFieldGet(this, $bebd28704f2536ea$var$_SelectionAccumulator_edges, "f").commit()
                };
                for(var _len3 = arguments.length, rest = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)rest[_key3] = arguments[_key3];
                (_classPrivateFieldGe3 = $bebd28704f2536ea$var$__classPrivateFieldGet(this, $bebd28704f2536ea$var$_SelectionAccumulator_commitHandler, "f")).call.apply(_classPrivateFieldGe3, $bebd28704f2536ea$var$_concatInstanceProperty(_context = [
                    this,
                    summary
                ]).call(_context, rest));
                return summary;
            }
        }
    ]);
    return SelectionAccumulator;
}();
$bebd28704f2536ea$var$_SelectionAccumulator_nodes = new $bebd28704f2536ea$var$_WeakMap(), $bebd28704f2536ea$var$_SelectionAccumulator_edges = new $bebd28704f2536ea$var$_WeakMap(), $bebd28704f2536ea$var$_SelectionAccumulator_commitHandler = new $bebd28704f2536ea$var$_WeakMap();
function $bebd28704f2536ea$var$_createForOfIteratorHelper$2(o, allowArrayLike) {
    var it = typeof $bebd28704f2536ea$var$_Symbol !== "undefined" && $bebd28704f2536ea$var$_getIteratorMethod(o) || o["@@iterator"];
    if (!it) {
        if ($bebd28704f2536ea$var$_Array$isArray(o) || (it = $bebd28704f2536ea$var$_unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $bebd28704f2536ea$var$_unsupportedIterableToArray$2(o, minLen) {
    var _context3;
    if (!o) return;
    if (typeof o === "string") return $bebd28704f2536ea$var$_arrayLikeToArray$2(o, minLen);
    var n = $bebd28704f2536ea$var$_sliceInstanceProperty(_context3 = Object.prototype.toString.call(o)).call(_context3, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return $bebd28704f2536ea$var$_Array$from$1(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bebd28704f2536ea$var$_arrayLikeToArray$2(o, minLen);
}
function $bebd28704f2536ea$var$_arrayLikeToArray$2(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * The handler for selections
 */ var $bebd28704f2536ea$var$SelectionHandler = /*#__PURE__*/ function() {
    /**
   * @param {object} body
   * @param {Canvas} canvas
   */ function SelectionHandler(body, canvas) {
        var _this = this;
        $bebd28704f2536ea$var$_classCallCheck(this, SelectionHandler);
        this.body = body;
        this.canvas = canvas;
        // TODO: Consider firing an event on any change to the selection, not
        // only those caused by clicks and taps. It would be easy to implement
        // now and (at least to me) it seems like something that could be
        // quite useful.
        this._selectionAccumulator = new $bebd28704f2536ea$var$SelectionAccumulator();
        this.hoverObj = {
            nodes: {},
            edges: {}
        };
        this.options = {};
        this.defaultOptions = {
            multiselect: false,
            selectable: true,
            selectConnectedEdges: true,
            hoverConnectedEdges: true
        };
        $bebd28704f2536ea$var$_Object$assign(this.options, this.defaultOptions);
        this.body.emitter.on("_dataChanged", function() {
            _this.updateSelection();
        });
    }
    /**
   *
   * @param {object} [options]
   */ $bebd28704f2536ea$var$_createClass(SelectionHandler, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                if (options !== undefined) {
                    var fields = [
                        "multiselect",
                        "hoverConnectedEdges",
                        "selectable",
                        "selectConnectedEdges"
                    ];
                    $bebd28704f2536ea$var$selectiveDeepExtend(fields, this.options, options);
                }
            }
        },
        {
            key: "selectOnPoint",
            value: function selectOnPoint(pointer) {
                var selected = false;
                if (this.options.selectable === true) {
                    var obj = this.getNodeAt(pointer) || this.getEdgeAt(pointer);
                    // unselect after getting the objects in order to restore width and height.
                    this.unselectAll();
                    if (obj !== undefined) selected = this.selectObject(obj);
                    this.body.emitter.emit("_requestRedraw");
                }
                return selected;
            }
        },
        {
            key: "selectAdditionalOnPoint",
            value: function selectAdditionalOnPoint(pointer) {
                var selectionChanged = false;
                if (this.options.selectable === true) {
                    var obj = this.getNodeAt(pointer) || this.getEdgeAt(pointer);
                    if (obj !== undefined) {
                        selectionChanged = true;
                        if (obj.isSelected() === true) this.deselectObject(obj);
                        else this.selectObject(obj);
                        this.body.emitter.emit("_requestRedraw");
                    }
                }
                return selectionChanged;
            }
        },
        {
            key: "_initBaseEvent",
            value: function _initBaseEvent(event, pointer) {
                var properties = {};
                properties["pointer"] = {
                    DOM: {
                        x: pointer.x,
                        y: pointer.y
                    },
                    canvas: this.canvas.DOMtoCanvas(pointer)
                };
                properties["event"] = event;
                return properties;
            }
        },
        {
            key: "generateClickEvent",
            value: function generateClickEvent(eventType, event, pointer, oldSelection) {
                var emptySelection = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
                var properties = this._initBaseEvent(event, pointer);
                if (emptySelection === true) {
                    properties.nodes = [];
                    properties.edges = [];
                } else {
                    var tmp = this.getSelection();
                    properties.nodes = tmp.nodes;
                    properties.edges = tmp.edges;
                }
                if (oldSelection !== undefined) properties["previousSelection"] = oldSelection;
                if (eventType == "click") // For the time being, restrict this functionality to
                // just the click event.
                properties.items = this.getClickedItems(pointer);
                if (event.controlEdge !== undefined) properties.controlEdge = event.controlEdge;
                this.body.emitter.emit(eventType, properties);
            }
        },
        {
            key: "selectObject",
            value: function selectObject(obj) {
                var highlightEdges = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options.selectConnectedEdges;
                if (obj !== undefined) {
                    if (obj instanceof $bebd28704f2536ea$var$Node) {
                        if (highlightEdges === true) {
                            var _this$_selectionAccum;
                            (_this$_selectionAccum = this._selectionAccumulator).addEdges.apply(_this$_selectionAccum, $bebd28704f2536ea$var$_toConsumableArray(obj.edges));
                        }
                        this._selectionAccumulator.addNodes(obj);
                    } else this._selectionAccumulator.addEdges(obj);
                    return true;
                }
                return false;
            }
        },
        {
            key: "deselectObject",
            value: function deselectObject(obj) {
                if (obj.isSelected() === true) {
                    obj.selected = false;
                    this._removeFromSelection(obj);
                }
            }
        },
        {
            key: "_getAllNodesOverlappingWith",
            value: function _getAllNodesOverlappingWith(object) {
                var overlappingNodes = [];
                var nodes = this.body.nodes;
                for(var i = 0; i < this.body.nodeIndices.length; i++){
                    var nodeId = this.body.nodeIndices[i];
                    if (nodes[nodeId].isOverlappingWith(object)) overlappingNodes.push(nodeId);
                }
                return overlappingNodes;
            }
        },
        {
            key: "_pointerToPositionObject",
            value: function _pointerToPositionObject(pointer) {
                var canvasPos = this.canvas.DOMtoCanvas(pointer);
                return {
                    left: canvasPos.x - 1,
                    top: canvasPos.y + 1,
                    right: canvasPos.x + 1,
                    bottom: canvasPos.y - 1
                };
            }
        },
        {
            key: "getNodeAt",
            value: function getNodeAt(pointer) {
                var returnNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                // we first check if this is an navigation controls element
                var positionObject = this._pointerToPositionObject(pointer);
                var overlappingNodes = this._getAllNodesOverlappingWith(positionObject);
                // if there are overlapping nodes, select the last one, this is the
                // one which is drawn on top of the others
                if (overlappingNodes.length > 0) {
                    if (returnNode === true) return this.body.nodes[overlappingNodes[overlappingNodes.length - 1]];
                    else return overlappingNodes[overlappingNodes.length - 1];
                } else return undefined;
            }
        },
        {
            key: "_getEdgesOverlappingWith",
            value: function _getEdgesOverlappingWith(object, overlappingEdges) {
                var edges = this.body.edges;
                for(var i = 0; i < this.body.edgeIndices.length; i++){
                    var edgeId = this.body.edgeIndices[i];
                    if (edges[edgeId].isOverlappingWith(object)) overlappingEdges.push(edgeId);
                }
            }
        },
        {
            key: "_getAllEdgesOverlappingWith",
            value: function _getAllEdgesOverlappingWith(object) {
                var overlappingEdges = [];
                this._getEdgesOverlappingWith(object, overlappingEdges);
                return overlappingEdges;
            }
        },
        {
            key: "getEdgeAt",
            value: function getEdgeAt(pointer) {
                var returnEdge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                // Iterate over edges, pick closest within 10
                var canvasPos = this.canvas.DOMtoCanvas(pointer);
                var mindist = 10;
                var overlappingEdge = null;
                var edges = this.body.edges;
                for(var i = 0; i < this.body.edgeIndices.length; i++){
                    var edgeId = this.body.edgeIndices[i];
                    var edge = edges[edgeId];
                    if (edge.connected) {
                        var xFrom = edge.from.x;
                        var yFrom = edge.from.y;
                        var xTo = edge.to.x;
                        var yTo = edge.to.y;
                        var dist = edge.edgeType.getDistanceToEdge(xFrom, yFrom, xTo, yTo, canvasPos.x, canvasPos.y);
                        if (dist < mindist) {
                            overlappingEdge = edgeId;
                            mindist = dist;
                        }
                    }
                }
                if (overlappingEdge !== null) {
                    if (returnEdge === true) return this.body.edges[overlappingEdge];
                    else return overlappingEdge;
                } else return undefined;
            }
        },
        {
            key: "_addToHover",
            value: function _addToHover(obj) {
                if (obj instanceof $bebd28704f2536ea$var$Node) this.hoverObj.nodes[obj.id] = obj;
                else this.hoverObj.edges[obj.id] = obj;
            }
        },
        {
            key: "_removeFromSelection",
            value: function _removeFromSelection(obj) {
                if (obj instanceof $bebd28704f2536ea$var$Node) {
                    var _this$_selectionAccum2;
                    this._selectionAccumulator.deleteNodes(obj);
                    (_this$_selectionAccum2 = this._selectionAccumulator).deleteEdges.apply(_this$_selectionAccum2, $bebd28704f2536ea$var$_toConsumableArray(obj.edges));
                } else this._selectionAccumulator.deleteEdges(obj);
            }
        },
        {
            key: "unselectAll",
            value: function unselectAll() {
                this._selectionAccumulator.clear();
            }
        },
        {
            key: "getSelectedNodeCount",
            value: function getSelectedNodeCount() {
                return this._selectionAccumulator.sizeNodes;
            }
        },
        {
            key: "getSelectedEdgeCount",
            value: function getSelectedEdgeCount() {
                return this._selectionAccumulator.sizeEdges;
            }
        },
        {
            key: "_hoverConnectedEdges",
            value: function _hoverConnectedEdges(node) {
                for(var i = 0; i < node.edges.length; i++){
                    var edge = node.edges[i];
                    edge.hover = true;
                    this._addToHover(edge);
                }
            }
        },
        {
            key: "emitBlurEvent",
            value: function emitBlurEvent(event, pointer, object) {
                var properties = this._initBaseEvent(event, pointer);
                if (object.hover === true) {
                    object.hover = false;
                    if (object instanceof $bebd28704f2536ea$var$Node) {
                        properties.node = object.id;
                        this.body.emitter.emit("blurNode", properties);
                    } else {
                        properties.edge = object.id;
                        this.body.emitter.emit("blurEdge", properties);
                    }
                }
            }
        },
        {
            key: "emitHoverEvent",
            value: function emitHoverEvent(event, pointer, object) {
                var properties = this._initBaseEvent(event, pointer);
                var hoverChanged = false;
                if (object.hover === false) {
                    object.hover = true;
                    this._addToHover(object);
                    hoverChanged = true;
                    if (object instanceof $bebd28704f2536ea$var$Node) {
                        properties.node = object.id;
                        this.body.emitter.emit("hoverNode", properties);
                    } else {
                        properties.edge = object.id;
                        this.body.emitter.emit("hoverEdge", properties);
                    }
                }
                return hoverChanged;
            }
        },
        {
            key: "hoverObject",
            value: function hoverObject(event, pointer) {
                var object = this.getNodeAt(pointer);
                if (object === undefined) object = this.getEdgeAt(pointer);
                var hoverChanged = false;
                // remove all node hover highlights
                for(var nodeId in this.hoverObj.nodes){
                    if (Object.prototype.hasOwnProperty.call(this.hoverObj.nodes, nodeId)) {
                        if (object === undefined || object instanceof $bebd28704f2536ea$var$Node && object.id != nodeId || object instanceof $bebd28704f2536ea$var$Edge) {
                            this.emitBlurEvent(event, pointer, this.hoverObj.nodes[nodeId]);
                            delete this.hoverObj.nodes[nodeId];
                            hoverChanged = true;
                        }
                    }
                }
                // removing all edge hover highlights
                for(var edgeId in this.hoverObj.edges)if (Object.prototype.hasOwnProperty.call(this.hoverObj.edges, edgeId)) {
                    // if the hover has been changed here it means that the node has been hovered over or off
                    // we then do not use the emitBlurEvent method here.
                    if (hoverChanged === true) {
                        this.hoverObj.edges[edgeId].hover = false;
                        delete this.hoverObj.edges[edgeId];
                    } else if (object === undefined || object instanceof $bebd28704f2536ea$var$Edge && object.id != edgeId || object instanceof $bebd28704f2536ea$var$Node && !object.hover) {
                        this.emitBlurEvent(event, pointer, this.hoverObj.edges[edgeId]);
                        delete this.hoverObj.edges[edgeId];
                        hoverChanged = true;
                    }
                }
                if (object !== undefined) {
                    var hoveredEdgesCount = $bebd28704f2536ea$var$_Object$keys(this.hoverObj.edges).length;
                    var hoveredNodesCount = $bebd28704f2536ea$var$_Object$keys(this.hoverObj.nodes).length;
                    var newOnlyHoveredEdge = object instanceof $bebd28704f2536ea$var$Edge && hoveredEdgesCount === 0 && hoveredNodesCount === 0;
                    var newOnlyHoveredNode = object instanceof $bebd28704f2536ea$var$Node && hoveredEdgesCount === 0 && hoveredNodesCount === 0;
                    if (hoverChanged || newOnlyHoveredEdge || newOnlyHoveredNode) hoverChanged = this.emitHoverEvent(event, pointer, object);
                    if (object instanceof $bebd28704f2536ea$var$Node && this.options.hoverConnectedEdges === true) this._hoverConnectedEdges(object);
                }
                if (hoverChanged === true) this.body.emitter.emit("_requestRedraw");
            }
        },
        {
            key: "commitWithoutEmitting",
            value: function commitWithoutEmitting() {
                this._selectionAccumulator.commit();
            }
        },
        {
            key: "commitAndEmit",
            value: function commitAndEmit(pointer, event) {
                var selected = false;
                var selectionChanges = this._selectionAccumulator.commit();
                var previousSelection = {
                    nodes: selectionChanges.nodes.previous,
                    edges: selectionChanges.edges.previous
                };
                if (selectionChanges.edges.deleted.length > 0) {
                    this.generateClickEvent("deselectEdge", event, pointer, previousSelection);
                    selected = true;
                }
                if (selectionChanges.nodes.deleted.length > 0) {
                    this.generateClickEvent("deselectNode", event, pointer, previousSelection);
                    selected = true;
                }
                if (selectionChanges.nodes.added.length > 0) {
                    this.generateClickEvent("selectNode", event, pointer);
                    selected = true;
                }
                if (selectionChanges.edges.added.length > 0) {
                    this.generateClickEvent("selectEdge", event, pointer);
                    selected = true;
                }
                // fire the select event if anything has been selected or deselected
                if (selected === true) // select or unselect
                this.generateClickEvent("select", event, pointer);
            }
        },
        {
            key: "getSelection",
            value: function getSelection() {
                return {
                    nodes: this.getSelectedNodeIds(),
                    edges: this.getSelectedEdgeIds()
                };
            }
        },
        {
            key: "getSelectedNodes",
            value: function getSelectedNodes() {
                return this._selectionAccumulator.getNodes();
            }
        },
        {
            key: "getSelectedEdges",
            value: function getSelectedEdges() {
                return this._selectionAccumulator.getEdges();
            }
        },
        {
            key: "getSelectedNodeIds",
            value: function getSelectedNodeIds() {
                var _context;
                return $bebd28704f2536ea$var$_mapInstanceProperty(_context = this._selectionAccumulator.getNodes()).call(_context, function(node) {
                    return node.id;
                });
            }
        },
        {
            key: "getSelectedEdgeIds",
            value: function getSelectedEdgeIds() {
                var _context2;
                return $bebd28704f2536ea$var$_mapInstanceProperty(_context2 = this._selectionAccumulator.getEdges()).call(_context2, function(edge) {
                    return edge.id;
                });
            }
        },
        {
            key: "setSelection",
            value: function setSelection(selection) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!selection || !selection.nodes && !selection.edges) throw new TypeError("Selection must be an object with nodes and/or edges properties");
                // first unselect any selected node, if option is true or undefined
                if (options.unselectAll || options.unselectAll === undefined) this.unselectAll();
                if (selection.nodes) {
                    var _iterator = $bebd28704f2536ea$var$_createForOfIteratorHelper$2(selection.nodes), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var id = _step.value;
                            var node = this.body.nodes[id];
                            if (!node) throw new RangeError('Node with id "' + id + '" not found');
                            // don't select edges with it
                            this.selectObject(node, options.highlightEdges);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                if (selection.edges) {
                    var _iterator2 = $bebd28704f2536ea$var$_createForOfIteratorHelper$2(selection.edges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var _id = _step2.value;
                            var edge = this.body.edges[_id];
                            if (!edge) throw new RangeError('Edge with id "' + _id + '" not found');
                            this.selectObject(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
                this.body.emitter.emit("_requestRedraw");
                this._selectionAccumulator.commit();
            }
        },
        {
            key: "selectNodes",
            value: function selectNodes(selection) {
                var highlightEdges = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                if (!selection || selection.length === undefined) throw "Selection must be an array with ids";
                this.setSelection({
                    nodes: selection
                }, {
                    highlightEdges: highlightEdges
                });
            }
        },
        {
            key: "selectEdges",
            value: function selectEdges(selection) {
                if (!selection || selection.length === undefined) throw "Selection must be an array with ids";
                this.setSelection({
                    edges: selection
                });
            }
        },
        {
            key: "updateSelection",
            value: function updateSelection() {
                for(var node in this._selectionAccumulator.getNodes())if (!Object.prototype.hasOwnProperty.call(this.body.nodes, node.id)) this._selectionAccumulator.deleteNodes(node);
                for(var edge in this._selectionAccumulator.getEdges())if (!Object.prototype.hasOwnProperty.call(this.body.edges, edge.id)) this._selectionAccumulator.deleteEdges(edge);
            }
        },
        {
            key: "getClickedItems",
            value: function getClickedItems(pointer) {
                var point = this.canvas.DOMtoCanvas(pointer);
                var items = [];
                // Note reverse order; we want the topmost clicked items to be first in the array
                // Also note that selected nodes are disregarded here; these normally display on top
                var nodeIndices = this.body.nodeIndices;
                var nodes = this.body.nodes;
                for(var i = nodeIndices.length - 1; i >= 0; i--){
                    var node = nodes[nodeIndices[i]];
                    var ret = node.getItemsOnPoint(point);
                    items.push.apply(items, ret); // Append the return value to the running list.
                }
                var edgeIndices = this.body.edgeIndices;
                var edges = this.body.edges;
                for(var _i = edgeIndices.length - 1; _i >= 0; _i--){
                    var edge = edges[edgeIndices[_i]];
                    var _ret = edge.getItemsOnPoint(point);
                    items.push.apply(items, _ret); // Append the return value to the running list.
                }
                return items;
            }
        }
    ]);
    return SelectionHandler;
}();
var $bebd28704f2536ea$var$arraySlice = $bebd28704f2536ea$var$arraySliceSimple;
var $bebd28704f2536ea$var$floor = Math.floor;
var $bebd28704f2536ea$var$mergeSort = function(array, comparefn) {
    var length1 = array.length;
    var middle = $bebd28704f2536ea$var$floor(length1 / 2);
    return length1 < 8 ? $bebd28704f2536ea$var$insertionSort(array, comparefn) : $bebd28704f2536ea$var$merge(array, $bebd28704f2536ea$var$mergeSort($bebd28704f2536ea$var$arraySlice(array, 0, middle), comparefn), $bebd28704f2536ea$var$mergeSort($bebd28704f2536ea$var$arraySlice(array, middle), comparefn), comparefn);
};
var $bebd28704f2536ea$var$insertionSort = function(array, comparefn) {
    var length1 = array.length;
    var i = 1;
    var element, j;
    while(i < length1){
        j = i;
        element = array[i];
        while(j && comparefn(array[j - 1], element) > 0)array[j] = array[--j];
        if (j !== i++) array[j] = element;
    }
    return array;
};
var $bebd28704f2536ea$var$merge = function(array, left, right, comparefn) {
    var llength = left.length;
    var rlength = right.length;
    var lindex = 0;
    var rindex = 0;
    while(lindex < llength || rindex < rlength)array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
    return array;
};
var $bebd28704f2536ea$var$arraySort = $bebd28704f2536ea$var$mergeSort;
var $bebd28704f2536ea$var$userAgent$1 = $bebd28704f2536ea$var$engineUserAgent;
var $bebd28704f2536ea$var$firefox = $bebd28704f2536ea$var$userAgent$1.match(/firefox\/(\d+)/i);
var $bebd28704f2536ea$var$engineFfVersion = !!$bebd28704f2536ea$var$firefox && +$bebd28704f2536ea$var$firefox[1];
var $bebd28704f2536ea$var$UA = $bebd28704f2536ea$var$engineUserAgent;
var $bebd28704f2536ea$var$engineIsIeOrEdge = /MSIE|Trident/.test($bebd28704f2536ea$var$UA);
var $bebd28704f2536ea$var$userAgent = $bebd28704f2536ea$var$engineUserAgent;
var $bebd28704f2536ea$var$webkit = $bebd28704f2536ea$var$userAgent.match(/AppleWebKit\/(\d+)\./);
var $bebd28704f2536ea$var$engineWebkitVersion = !!$bebd28704f2536ea$var$webkit && +$bebd28704f2536ea$var$webkit[1];
var $bebd28704f2536ea$var$$$2 = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$uncurryThis = $bebd28704f2536ea$var$functionUncurryThis;
var $bebd28704f2536ea$var$aCallable$1 = $bebd28704f2536ea$var$aCallable$7;
var $bebd28704f2536ea$var$toObject$1 = $bebd28704f2536ea$var$toObject$e;
var $bebd28704f2536ea$var$lengthOfArrayLike$1 = $bebd28704f2536ea$var$lengthOfArrayLike$c;
var $bebd28704f2536ea$var$deletePropertyOrThrow = $bebd28704f2536ea$var$deletePropertyOrThrow$2;
var $bebd28704f2536ea$var$toString = $bebd28704f2536ea$var$toString$a;
var $bebd28704f2536ea$var$fails = $bebd28704f2536ea$var$fails$w;
var $bebd28704f2536ea$var$internalSort = $bebd28704f2536ea$var$arraySort;
var $bebd28704f2536ea$var$arrayMethodIsStrict$2 = $bebd28704f2536ea$var$arrayMethodIsStrict$6;
var $bebd28704f2536ea$var$FF = $bebd28704f2536ea$var$engineFfVersion;
var $bebd28704f2536ea$var$IE_OR_EDGE = $bebd28704f2536ea$var$engineIsIeOrEdge;
var $bebd28704f2536ea$var$V8 = $bebd28704f2536ea$var$engineV8Version;
var $bebd28704f2536ea$var$WEBKIT = $bebd28704f2536ea$var$engineWebkitVersion;
var $bebd28704f2536ea$var$test = [];
var $bebd28704f2536ea$var$nativeSort = $bebd28704f2536ea$var$uncurryThis($bebd28704f2536ea$var$test.sort);
var $bebd28704f2536ea$var$push = $bebd28704f2536ea$var$uncurryThis($bebd28704f2536ea$var$test.push);
// IE8-
var $bebd28704f2536ea$var$FAILS_ON_UNDEFINED = $bebd28704f2536ea$var$fails(function() {
    $bebd28704f2536ea$var$test.sort(undefined);
});
// V8 bug
var $bebd28704f2536ea$var$FAILS_ON_NULL = $bebd28704f2536ea$var$fails(function() {
    $bebd28704f2536ea$var$test.sort(null);
});
// Old WebKit
var $bebd28704f2536ea$var$STRICT_METHOD$1 = $bebd28704f2536ea$var$arrayMethodIsStrict$2('sort');
var $bebd28704f2536ea$var$STABLE_SORT = !$bebd28704f2536ea$var$fails(function() {
    // feature detection can be too slow, so check engines versions
    if ($bebd28704f2536ea$var$V8) return $bebd28704f2536ea$var$V8 < 70;
    if ($bebd28704f2536ea$var$FF && $bebd28704f2536ea$var$FF > 3) return;
    if ($bebd28704f2536ea$var$IE_OR_EDGE) return true;
    if ($bebd28704f2536ea$var$WEBKIT) return $bebd28704f2536ea$var$WEBKIT < 603;
    var result = '';
    var code, chr, value, index;
    // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
    for(code = 65; code < 76; code++){
        chr = String.fromCharCode(code);
        switch(code){
            case 66:
            case 69:
            case 70:
            case 72:
                value = 3;
                break;
            case 68:
            case 71:
                value = 4;
                break;
            default:
                value = 2;
        }
        for(index = 0; index < 47; index++)$bebd28704f2536ea$var$test.push({
            k: chr + index,
            v: value
        });
    }
    $bebd28704f2536ea$var$test.sort(function(a, b) {
        return b.v - a.v;
    });
    for(index = 0; index < $bebd28704f2536ea$var$test.length; index++){
        chr = $bebd28704f2536ea$var$test[index].k.charAt(0);
        if (result.charAt(result.length - 1) !== chr) result += chr;
    }
    return result !== 'DGBEFHACIJK';
});
var $bebd28704f2536ea$var$FORCED$1 = $bebd28704f2536ea$var$FAILS_ON_UNDEFINED || !$bebd28704f2536ea$var$FAILS_ON_NULL || !$bebd28704f2536ea$var$STRICT_METHOD$1 || !$bebd28704f2536ea$var$STABLE_SORT;
var $bebd28704f2536ea$var$getSortCompare = function(comparefn) {
    return function(x, y) {
        if (y === undefined) return -1;
        if (x === undefined) return 1;
        if (comparefn !== undefined) return +comparefn(x, y) || 0;
        return $bebd28704f2536ea$var$toString(x) > $bebd28704f2536ea$var$toString(y) ? 1 : -1;
    };
};
// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$bebd28704f2536ea$var$$$2({
    target: 'Array',
    proto: true,
    forced: $bebd28704f2536ea$var$FORCED$1
}, {
    sort: function sort(comparefn) {
        if (comparefn !== undefined) $bebd28704f2536ea$var$aCallable$1(comparefn);
        var array = $bebd28704f2536ea$var$toObject$1(this);
        if ($bebd28704f2536ea$var$STABLE_SORT) return comparefn === undefined ? $bebd28704f2536ea$var$nativeSort(array) : $bebd28704f2536ea$var$nativeSort(array, comparefn);
        var items = [];
        var arrayLength = $bebd28704f2536ea$var$lengthOfArrayLike$1(array);
        var itemsLength, index;
        for(index = 0; index < arrayLength; index++)if (index in array) $bebd28704f2536ea$var$push(items, array[index]);
        $bebd28704f2536ea$var$internalSort(items, $bebd28704f2536ea$var$getSortCompare(comparefn));
        itemsLength = $bebd28704f2536ea$var$lengthOfArrayLike$1(items);
        index = 0;
        while(index < itemsLength)array[index] = items[index++];
        while(index < arrayLength)$bebd28704f2536ea$var$deletePropertyOrThrow(array, index++);
        return array;
    }
});
var $bebd28704f2536ea$var$entryVirtual$2 = $bebd28704f2536ea$var$entryVirtual$i;
var $bebd28704f2536ea$var$sort$3 = $bebd28704f2536ea$var$entryVirtual$2('Array').sort;
var $bebd28704f2536ea$var$isPrototypeOf$2 = $bebd28704f2536ea$var$objectIsPrototypeOf;
var $bebd28704f2536ea$var$method$2 = $bebd28704f2536ea$var$sort$3;
var $bebd28704f2536ea$var$ArrayPrototype$2 = Array.prototype;
var $bebd28704f2536ea$var$sort$2 = function(it) {
    var own = it.sort;
    return it === $bebd28704f2536ea$var$ArrayPrototype$2 || $bebd28704f2536ea$var$isPrototypeOf$2($bebd28704f2536ea$var$ArrayPrototype$2, it) && own === $bebd28704f2536ea$var$ArrayPrototype$2.sort ? $bebd28704f2536ea$var$method$2 : own;
};
var $bebd28704f2536ea$var$parent$2 = $bebd28704f2536ea$var$sort$2;
var $bebd28704f2536ea$var$sort$1 = $bebd28704f2536ea$var$parent$2;
var $bebd28704f2536ea$var$sort = $bebd28704f2536ea$var$sort$1;
var $bebd28704f2536ea$var$_sortInstanceProperty = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$sort);
var $bebd28704f2536ea$var$aCallable = $bebd28704f2536ea$var$aCallable$7;
var $bebd28704f2536ea$var$toObject = $bebd28704f2536ea$var$toObject$e;
var $bebd28704f2536ea$var$IndexedObject = $bebd28704f2536ea$var$indexedObject;
var $bebd28704f2536ea$var$lengthOfArrayLike = $bebd28704f2536ea$var$lengthOfArrayLike$c;
var $bebd28704f2536ea$var$$TypeError = TypeError;
// `Array.prototype.{ reduce, reduceRight }` methods implementation
var $bebd28704f2536ea$var$createMethod = function(IS_RIGHT) {
    return function(that, callbackfn, argumentsLength, memo) {
        $bebd28704f2536ea$var$aCallable(callbackfn);
        var O = $bebd28704f2536ea$var$toObject(that);
        var self1 = $bebd28704f2536ea$var$IndexedObject(O);
        var length1 = $bebd28704f2536ea$var$lengthOfArrayLike(O);
        var index = IS_RIGHT ? length1 - 1 : 0;
        var i = IS_RIGHT ? -1 : 1;
        if (argumentsLength < 2) while(true){
            if (index in self1) {
                memo = self1[index];
                index += i;
                break;
            }
            index += i;
            if (IS_RIGHT ? index < 0 : length1 <= index) throw new $bebd28704f2536ea$var$$TypeError('Reduce of empty array with no initial value');
        }
        for(; IS_RIGHT ? index >= 0 : length1 > index; index += i)if (index in self1) memo = callbackfn(memo, self1[index], index, O);
        return memo;
    };
};
var $bebd28704f2536ea$var$arrayReduce = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: $bebd28704f2536ea$var$createMethod(false),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: $bebd28704f2536ea$var$createMethod(true)
};
var $bebd28704f2536ea$var$global$1 = $bebd28704f2536ea$var$global$n;
var $bebd28704f2536ea$var$classof = $bebd28704f2536ea$var$classofRaw$2;
var $bebd28704f2536ea$var$engineIsNode = $bebd28704f2536ea$var$classof($bebd28704f2536ea$var$global$1.process) === 'process';
var $bebd28704f2536ea$var$$$1 = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$$reduce = $bebd28704f2536ea$var$arrayReduce.left;
var $bebd28704f2536ea$var$arrayMethodIsStrict$1 = $bebd28704f2536ea$var$arrayMethodIsStrict$6;
var $bebd28704f2536ea$var$CHROME_VERSION = $bebd28704f2536ea$var$engineV8Version;
var $bebd28704f2536ea$var$IS_NODE = $bebd28704f2536ea$var$engineIsNode;
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var $bebd28704f2536ea$var$CHROME_BUG = !$bebd28704f2536ea$var$IS_NODE && $bebd28704f2536ea$var$CHROME_VERSION > 79 && $bebd28704f2536ea$var$CHROME_VERSION < 83;
var $bebd28704f2536ea$var$FORCED = $bebd28704f2536ea$var$CHROME_BUG || !$bebd28704f2536ea$var$arrayMethodIsStrict$1('reduce');
// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$bebd28704f2536ea$var$$$1({
    target: 'Array',
    proto: true,
    forced: $bebd28704f2536ea$var$FORCED
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var length1 = arguments.length;
        return $bebd28704f2536ea$var$$reduce(this, callbackfn, length1, length1 > 1 ? arguments[1] : undefined);
    }
});
var $bebd28704f2536ea$var$entryVirtual$1 = $bebd28704f2536ea$var$entryVirtual$i;
var $bebd28704f2536ea$var$reduce$3 = $bebd28704f2536ea$var$entryVirtual$1('Array').reduce;
var $bebd28704f2536ea$var$isPrototypeOf$1 = $bebd28704f2536ea$var$objectIsPrototypeOf;
var $bebd28704f2536ea$var$method$1 = $bebd28704f2536ea$var$reduce$3;
var $bebd28704f2536ea$var$ArrayPrototype$1 = Array.prototype;
var $bebd28704f2536ea$var$reduce$2 = function(it) {
    var own = it.reduce;
    return it === $bebd28704f2536ea$var$ArrayPrototype$1 || $bebd28704f2536ea$var$isPrototypeOf$1($bebd28704f2536ea$var$ArrayPrototype$1, it) && own === $bebd28704f2536ea$var$ArrayPrototype$1.reduce ? $bebd28704f2536ea$var$method$1 : own;
};
var $bebd28704f2536ea$var$parent$1 = $bebd28704f2536ea$var$reduce$2;
var $bebd28704f2536ea$var$reduce$1 = $bebd28704f2536ea$var$parent$1;
var $bebd28704f2536ea$var$reduce = $bebd28704f2536ea$var$reduce$1;
var $bebd28704f2536ea$var$_reduceInstanceProperty = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$reduce);
function $bebd28704f2536ea$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $bebd28704f2536ea$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $bebd28704f2536ea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bebd28704f2536ea$var$_getPrototypeOf(this).constructor;
            result = $bebd28704f2536ea$var$_Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bebd28704f2536ea$var$_possibleConstructorReturn(this, result);
    };
}
function $bebd28704f2536ea$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !$bebd28704f2536ea$var$_Reflect$construct) return false;
    if ($bebd28704f2536ea$var$_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($bebd28704f2536ea$var$_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Helper classes for LayoutEngine.
 *
 * Strategy pattern for usage of direction methods for hierarchical layouts.
 */ /**
 * Interface definition for direction strategy classes.
 *
 * This class describes the interface for the Strategy
 * pattern classes used to differentiate horizontal and vertical
 * direction of hierarchical results.
 *
 * For a given direction, one coordinate will be 'fixed', meaning that it is
 * determined by level.
 * The other coordinate is 'unfixed', meaning that the nodes on a given level
 * can still move along that coordinate. So:
 *
 * - `vertical` layout: `x` unfixed, `y` fixed per level
 * - `horizontal` layout: `x` fixed per level, `y` unfixed
 *
 * The local methods are stubs and should be regarded as abstract.
 * Derived classes **must** implement all the methods themselves.
 *
 * @private
 */ var $bebd28704f2536ea$var$DirectionInterface = /*#__PURE__*/ function() {
    function DirectionInterface() {
        $bebd28704f2536ea$var$_classCallCheck(this, DirectionInterface);
    }
    $bebd28704f2536ea$var$_createClass(DirectionInterface, [
        {
            key: "abstract",
            value: /**
     * @ignore
     */ function abstract() {
                throw new Error("Can't instantiate abstract class!");
            }
        },
        {
            key: "fake_use",
            value: function fake_use() {
            // Do nothing special
            }
        },
        {
            key: "curveType",
            value: function curveType() {
                return this.abstract();
            }
        },
        {
            key: "getPosition",
            value: function getPosition(node) {
                this.fake_use(node);
                return this.abstract();
            }
        },
        {
            key: "setPosition",
            value: function setPosition(node, position) {
                var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                this.fake_use(node, position, level);
                this.abstract();
            }
        },
        {
            key: "getTreeSize",
            value: function getTreeSize(index) {
                this.fake_use(index);
                return this.abstract();
            }
        },
        {
            key: "sort",
            value: function sort(nodeArray) {
                this.fake_use(nodeArray);
                this.abstract();
            }
        },
        {
            key: "fix",
            value: function fix(node, level) {
                this.fake_use(node, level);
                this.abstract();
            }
        },
        {
            key: "shift",
            value: function shift(nodeId, diff) {
                this.fake_use(nodeId, diff);
                this.abstract();
            }
        }
    ]);
    return DirectionInterface;
}();
/**
 * Vertical Strategy
 *
 * Coordinate `y` is fixed on levels, coordinate `x` is unfixed.
 *
 * @augments DirectionInterface
 * @private
 */ var $bebd28704f2536ea$var$VerticalStrategy = /*#__PURE__*/ function(_DirectionInterface) {
    $bebd28704f2536ea$var$_inherits(VerticalStrategy, _DirectionInterface);
    var _super = $bebd28704f2536ea$var$_createSuper(VerticalStrategy);
    /**
   * Constructor
   *
   * @param {object} layout reference to the parent LayoutEngine instance.
   */ function VerticalStrategy(layout) {
        var _this;
        $bebd28704f2536ea$var$_classCallCheck(this, VerticalStrategy);
        _this = _super.call(this);
        _this.layout = layout;
        return _this;
    }
    /** @inheritDoc */ $bebd28704f2536ea$var$_createClass(VerticalStrategy, [
        {
            key: "curveType",
            value: function curveType() {
                return "horizontal";
            }
        },
        {
            key: "getPosition",
            value: function getPosition(node) {
                return node.x;
            }
        },
        {
            key: "setPosition",
            value: function setPosition(node, position) {
                var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                if (level !== undefined) this.layout.hierarchical.addToOrdering(node, level);
                node.x = position;
            }
        },
        {
            key: "getTreeSize",
            value: function getTreeSize(index) {
                var res = this.layout.hierarchical.getTreeSize(this.layout.body.nodes, index);
                return {
                    min: res.min_x,
                    max: res.max_x
                };
            }
        },
        {
            key: "sort",
            value: function sort(nodeArray) {
                $bebd28704f2536ea$var$_sortInstanceProperty(nodeArray).call(nodeArray, function(a, b) {
                    return a.x - b.x;
                });
            }
        },
        {
            key: "fix",
            value: function fix(node, level) {
                node.y = this.layout.options.hierarchical.levelSeparation * level;
                node.options.fixed.y = true;
            }
        },
        {
            key: "shift",
            value: function shift(nodeId, diff) {
                this.layout.body.nodes[nodeId].x += diff;
            }
        }
    ]);
    return VerticalStrategy;
}($bebd28704f2536ea$var$DirectionInterface);
/**
 * Horizontal Strategy
 *
 * Coordinate `x` is fixed on levels, coordinate `y` is unfixed.
 *
 * @augments DirectionInterface
 * @private
 */ var $bebd28704f2536ea$var$HorizontalStrategy = /*#__PURE__*/ function(_DirectionInterface2) {
    $bebd28704f2536ea$var$_inherits(HorizontalStrategy, _DirectionInterface2);
    var _super2 = $bebd28704f2536ea$var$_createSuper(HorizontalStrategy);
    /**
   * Constructor
   *
   * @param {object} layout reference to the parent LayoutEngine instance.
   */ function HorizontalStrategy(layout) {
        var _this2;
        $bebd28704f2536ea$var$_classCallCheck(this, HorizontalStrategy);
        _this2 = _super2.call(this);
        _this2.layout = layout;
        return _this2;
    }
    /** @inheritDoc */ $bebd28704f2536ea$var$_createClass(HorizontalStrategy, [
        {
            key: "curveType",
            value: function curveType() {
                return "vertical";
            }
        },
        {
            key: "getPosition",
            value: function getPosition(node) {
                return node.y;
            }
        },
        {
            key: "setPosition",
            value: function setPosition(node, position) {
                var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                if (level !== undefined) this.layout.hierarchical.addToOrdering(node, level);
                node.y = position;
            }
        },
        {
            key: "getTreeSize",
            value: function getTreeSize(index) {
                var res = this.layout.hierarchical.getTreeSize(this.layout.body.nodes, index);
                return {
                    min: res.min_y,
                    max: res.max_y
                };
            }
        },
        {
            key: "sort",
            value: function sort(nodeArray) {
                $bebd28704f2536ea$var$_sortInstanceProperty(nodeArray).call(nodeArray, function(a, b) {
                    return a.y - b.y;
                });
            }
        },
        {
            key: "fix",
            value: function fix(node, level) {
                node.x = this.layout.options.hierarchical.levelSeparation * level;
                node.options.fixed.x = true;
            }
        },
        {
            key: "shift",
            value: function shift(nodeId, diff) {
                this.layout.body.nodes[nodeId].y += diff;
            }
        }
    ]);
    return HorizontalStrategy;
}($bebd28704f2536ea$var$DirectionInterface);
var $bebd28704f2536ea$var$$ = $bebd28704f2536ea$var$_export;
var $bebd28704f2536ea$var$$every = $bebd28704f2536ea$var$arrayIteration.every;
var $bebd28704f2536ea$var$arrayMethodIsStrict = $bebd28704f2536ea$var$arrayMethodIsStrict$6;
var $bebd28704f2536ea$var$STRICT_METHOD = $bebd28704f2536ea$var$arrayMethodIsStrict('every');
// `Array.prototype.every` method
// https://tc39.es/ecma262/#sec-array.prototype.every
$bebd28704f2536ea$var$$({
    target: 'Array',
    proto: true,
    forced: !$bebd28704f2536ea$var$STRICT_METHOD
}, {
    every: function every(callbackfn /* , thisArg */ ) {
        return $bebd28704f2536ea$var$$every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
var $bebd28704f2536ea$var$entryVirtual = $bebd28704f2536ea$var$entryVirtual$i;
var $bebd28704f2536ea$var$every$3 = $bebd28704f2536ea$var$entryVirtual('Array').every;
var $bebd28704f2536ea$var$isPrototypeOf = $bebd28704f2536ea$var$objectIsPrototypeOf;
var $bebd28704f2536ea$var$method = $bebd28704f2536ea$var$every$3;
var $bebd28704f2536ea$var$ArrayPrototype = Array.prototype;
var $bebd28704f2536ea$var$every$2 = function(it) {
    var own = it.every;
    return it === $bebd28704f2536ea$var$ArrayPrototype || $bebd28704f2536ea$var$isPrototypeOf($bebd28704f2536ea$var$ArrayPrototype, it) && own === $bebd28704f2536ea$var$ArrayPrototype.every ? $bebd28704f2536ea$var$method : own;
};
var $bebd28704f2536ea$var$parent = $bebd28704f2536ea$var$every$2;
var $bebd28704f2536ea$var$every$1 = $bebd28704f2536ea$var$parent;
var $bebd28704f2536ea$var$every = $bebd28704f2536ea$var$every$1;
var $bebd28704f2536ea$var$_everyInstanceProperty = /*@__PURE__*/ $bebd28704f2536ea$var$getDefaultExportFromCjs($bebd28704f2536ea$var$every);
function $bebd28704f2536ea$var$_createForOfIteratorHelper$1(o, allowArrayLike) {
    var it = typeof $bebd28704f2536ea$var$_Symbol !== "undefined" && $bebd28704f2536ea$var$_getIteratorMethod(o) || o["@@iterator"];
    if (!it) {
        if ($bebd28704f2536ea$var$_Array$isArray(o) || (it = $bebd28704f2536ea$var$_unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $bebd28704f2536ea$var$_unsupportedIterableToArray$1(o, minLen) {
    var _context9;
    if (!o) return;
    if (typeof o === "string") return $bebd28704f2536ea$var$_arrayLikeToArray$1(o, minLen);
    var n = $bebd28704f2536ea$var$_sliceInstanceProperty(_context9 = Object.prototype.toString.call(o)).call(_context9, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return $bebd28704f2536ea$var$_Array$from$1(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bebd28704f2536ea$var$_arrayLikeToArray$1(o, minLen);
}
function $bebd28704f2536ea$var$_arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * Try to assign levels to nodes according to their positions in the cyclic “hierarchy”.
 *
 * @param nodes - Visible nodes of the graph.
 * @param levels - If present levels will be added to it, if not a new object will be created.
 * @returns Populated node levels.
 */ function $bebd28704f2536ea$var$fillLevelsByDirectionCyclic(nodes, levels) {
    var edges = new $bebd28704f2536ea$var$_Set();
    $bebd28704f2536ea$var$_forEachInstanceProperty(nodes).call(nodes, function(node) {
        var _context;
        $bebd28704f2536ea$var$_forEachInstanceProperty(_context = node.edges).call(_context, function(edge) {
            if (edge.connected) edges.add(edge);
        });
    });
    $bebd28704f2536ea$var$_forEachInstanceProperty(edges).call(edges, function(edge) {
        var fromId = edge.from.id;
        var toId = edge.to.id;
        if (levels[fromId] == null) levels[fromId] = 0;
        if (levels[toId] == null || levels[fromId] >= levels[toId]) levels[toId] = levels[fromId] + 1;
    });
    return levels;
}
/**
 * Assign levels to nodes according to their positions in the hierarchy. Leaves will be lined up at the bottom and all other nodes as close to their children as possible.
 *
 * @param nodes - Visible nodes of the graph.
 * @returns Populated node levels.
 */ function $bebd28704f2536ea$var$fillLevelsByDirectionLeaves(nodes) {
    return $bebd28704f2536ea$var$fillLevelsByDirection(// Pick only leaves (nodes without children).
    function(node) {
        var _context2, _context3;
        return $bebd28704f2536ea$var$_everyInstanceProperty(_context2 = $bebd28704f2536ea$var$_filterInstanceProperty(_context3 = node.edges).call(_context3, function(edge) {
            return nodes.has(edge.toId);
        })).call(_context2, function(edge) {
            return edge.to === node;
        });
    }, // Use the lowest level.
    function(newLevel, oldLevel) {
        return oldLevel > newLevel;
    }, // Go against the direction of the edges.
    "from", nodes);
}
/**
 * Assign levels to nodes according to their positions in the hierarchy. Roots will be lined up at the top and all nodes as close to their parents as possible.
 *
 * @param nodes - Visible nodes of the graph.
 * @returns Populated node levels.
 */ function $bebd28704f2536ea$var$fillLevelsByDirectionRoots(nodes) {
    return $bebd28704f2536ea$var$fillLevelsByDirection(// Pick only roots (nodes without parents).
    function(node) {
        var _context4, _context5;
        return $bebd28704f2536ea$var$_everyInstanceProperty(_context4 = $bebd28704f2536ea$var$_filterInstanceProperty(_context5 = node.edges).call(_context5, function(edge) {
            return nodes.has(edge.toId);
        })).call(_context4, function(edge) {
            return edge.from === node;
        });
    }, // Use the highest level.
    function(newLevel, oldLevel) {
        return oldLevel < newLevel;
    }, // Go in the direction of the edges.
    "to", nodes);
}
/**
 * Assign levels to nodes according to their positions in the hierarchy.
 *
 * @param isEntryNode - Checks and return true if the graph should be traversed from this node.
 * @param shouldLevelBeReplaced - Checks and returns true if the level of given node should be updated to the new value.
 * @param direction - Wheter the graph should be traversed in the direction of the edges `"to"` or in the other way `"from"`.
 * @param nodes - Visible nodes of the graph.
 * @returns Populated node levels.
 */ function $bebd28704f2536ea$var$fillLevelsByDirection(isEntryNode, shouldLevelBeReplaced, direction, nodes) {
    var _context6;
    var levels = $bebd28704f2536ea$var$_Object$create$1(null);
    // If acyclic, the graph can be walked through with (most likely way) fewer
    // steps than the number bellow. The exact value isn't too important as long
    // as it's quick to compute (doesn't impact acyclic graphs too much), is
    // higher than the number of steps actually needed (doesn't cut off before
    // acyclic graph is walked through) and prevents infinite loops (cuts off for
    // cyclic graphs).
    var limit = $bebd28704f2536ea$var$_reduceInstanceProperty(_context6 = $bebd28704f2536ea$var$_toConsumableArray($bebd28704f2536ea$var$_valuesInstanceProperty(nodes).call(nodes))).call(_context6, function(acc, node) {
        return acc + 1 + node.edges.length;
    }, 0);
    var edgeIdProp = direction + "Id";
    var newLevelDiff = direction === "to" ? 1 : -1;
    var _iterator = $bebd28704f2536ea$var$_createForOfIteratorHelper$1(nodes), _step;
    try {
        var _loop = function _loop() {
            var _step$value = $bebd28704f2536ea$var$_slicedToArray(_step.value, 2), entryNodeId = _step$value[0], entryNode = _step$value[1];
            if (// Skip if the node is not visible.
            !nodes.has(entryNodeId) || // Skip if the node is not an entry node.
            !isEntryNode(entryNode)) return 0; // continue
            // Line up all the entry nodes on level 0.
            levels[entryNodeId] = 0;
            var stack = [
                entryNode
            ];
            var done = 0;
            var node;
            var _loop2 = function _loop2() {
                var _context7, _context8;
                if (!nodes.has(entryNodeId)) // Skip if the node is not visible.
                return 0; // continue
                var newLevel = levels[node.id] + newLevelDiff;
                $bebd28704f2536ea$var$_forEachInstanceProperty(_context7 = $bebd28704f2536ea$var$_filterInstanceProperty(_context8 = node.edges).call(_context8, function(edge) {
                    return(// Ignore disconnected edges.
                    edge.connected && // Ignore circular edges.
                    edge.to !== edge.from && // Ignore edges leading to the node that's currently being processed.
                    edge[direction] !== node && // Ignore edges connecting to an invisible node.
                    nodes.has(edge.toId) && // Ignore edges connecting from an invisible node.
                    nodes.has(edge.fromId));
                })).call(_context7, function(edge) {
                    var targetNodeId = edge[edgeIdProp];
                    var oldLevel = levels[targetNodeId];
                    if (oldLevel == null || shouldLevelBeReplaced(newLevel, oldLevel)) {
                        levels[targetNodeId] = newLevel;
                        stack.push(edge[direction]);
                    }
                });
                if (done > limit) // This would run forever on a cyclic graph.
                return {
                    v: {
                        v: $bebd28704f2536ea$var$fillLevelsByDirectionCyclic(nodes, levels)
                    }
                };
                else ++done;
            }, _ret2;
            while(node = stack.pop()){
                _ret2 = _loop2();
                if (_ret2 === 0) continue;
                if (_ret2) return _ret2.v;
            }
        }, _ret;
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            _ret = _loop();
            if (_ret === 0) continue;
            if (_ret) return _ret.v;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return levels;
}
/**
 * There's a mix-up with terms in the code. Following are the formal definitions:
 *
 *   tree   - a strict hierarchical network, i.e. every node has at most one parent
 *   forest - a collection of trees. These distinct trees are thus not connected.
 *
 * So:
 * - in a network that is not a tree, there exist nodes with multiple parents.
 * - a network consisting of unconnected sub-networks, of which at least one
 *   is not a tree, is not a forest.
 *
 * In the code, the definitions are:
 *
 *   tree   - any disconnected sub-network, strict hierarchical or not.
 *   forest - a bunch of these sub-networks
 *
 * The difference between tree and not-tree is important in the code, notably within
 * to the block-shifting algorithm. The algorithm assumes formal trees and fails
 * for not-trees, often in a spectacular manner (search for 'exploding network' in the issues).
 *
 * In order to distinguish the definitions in the following code, the adjective 'formal' is
 * used. If 'formal' is absent, you must assume the non-formal definition.
 *
 * ----------------------------------------------------------------------------------
 * NOTES
 * =====
 *
 * A hierarchical layout is a different thing from a hierarchical network.
 * The layout is a way to arrange the nodes in the view; this can be done
 * on non-hierarchical networks as well. The converse is also possible.
 */ /**
 * Container for derived data on current network, relating to hierarchy.
 *
 * @private
 */ var $bebd28704f2536ea$var$HierarchicalStatus = /*#__PURE__*/ function() {
    /**
   * @ignore
   */ function HierarchicalStatus() {
        $bebd28704f2536ea$var$_classCallCheck(this, HierarchicalStatus);
        this.childrenReference = {}; // child id's per node id
        this.parentReference = {}; // parent id's per node id
        this.trees = {}; // tree id per node id; i.e. to which tree does given node id belong
        this.distributionOrdering = {}; // The nodes per level, in the display order
        this.levels = {}; // hierarchy level per node id
        this.distributionIndex = {}; // The position of the node in the level sorting order, per node id.
        this.isTree = false; // True if current network is a formal tree
        this.treeIndex = -1; // Highest tree id in current network.
    }
    /**
   * Add the relation between given nodes to the current state.
   *
   * @param {Node.id} parentNodeId
   * @param {Node.id} childNodeId
   */ $bebd28704f2536ea$var$_createClass(HierarchicalStatus, [
        {
            key: "addRelation",
            value: function addRelation(parentNodeId, childNodeId) {
                if (this.childrenReference[parentNodeId] === undefined) this.childrenReference[parentNodeId] = [];
                this.childrenReference[parentNodeId].push(childNodeId);
                if (this.parentReference[childNodeId] === undefined) this.parentReference[childNodeId] = [];
                this.parentReference[childNodeId].push(parentNodeId);
            }
        },
        {
            key: "checkIfTree",
            value: function checkIfTree() {
                for(var i in this.parentReference)if (this.parentReference[i].length > 1) {
                    this.isTree = false;
                    return;
                }
                this.isTree = true;
            }
        },
        {
            key: "numTrees",
            value: function numTrees() {
                return this.treeIndex + 1; // This assumes the indexes are assigned consecitively
            }
        },
        {
            key: "setTreeIndex",
            value: function setTreeIndex(node, treeId) {
                if (treeId === undefined) return; // Don't bother
                if (this.trees[node.id] === undefined) {
                    this.trees[node.id] = treeId;
                    this.treeIndex = Math.max(treeId, this.treeIndex);
                }
            }
        },
        {
            key: "ensureLevel",
            value: function ensureLevel(nodeId) {
                if (this.levels[nodeId] === undefined) this.levels[nodeId] = 0;
            }
        },
        {
            key: "getMaxLevel",
            value: function getMaxLevel(nodeId) {
                var _this = this;
                var accumulator = {};
                var _getMaxLevel = function _getMaxLevel(nodeId) {
                    if (accumulator[nodeId] !== undefined) return accumulator[nodeId];
                    var level = _this.levels[nodeId];
                    if (_this.childrenReference[nodeId]) {
                        var children = _this.childrenReference[nodeId];
                        if (children.length > 0) for(var i = 0; i < children.length; i++)level = Math.max(level, _getMaxLevel(children[i]));
                    }
                    accumulator[nodeId] = level;
                    return level;
                };
                return _getMaxLevel(nodeId);
            }
        },
        {
            key: "levelDownstream",
            value: function levelDownstream(nodeA, nodeB) {
                if (this.levels[nodeB.id] === undefined) {
                    // set initial level
                    if (this.levels[nodeA.id] === undefined) this.levels[nodeA.id] = 0;
                    // set level
                    this.levels[nodeB.id] = this.levels[nodeA.id] + 1;
                }
            }
        },
        {
            key: "setMinLevelToZero",
            value: function setMinLevelToZero(nodes) {
                var minLevel = 1e9;
                // get the minimum level
                for(var nodeId in nodes){
                    if (Object.prototype.hasOwnProperty.call(nodes, nodeId)) {
                        if (this.levels[nodeId] !== undefined) minLevel = Math.min(this.levels[nodeId], minLevel);
                    }
                }
                // subtract the minimum from the set so we have a range starting from 0
                for(var _nodeId in nodes){
                    if (Object.prototype.hasOwnProperty.call(nodes, _nodeId)) {
                        if (this.levels[_nodeId] !== undefined) this.levels[_nodeId] -= minLevel;
                    }
                }
            }
        },
        {
            key: "getTreeSize",
            value: function getTreeSize(nodes, index) {
                var min_x = 1e9;
                var max_x = -1000000000;
                var min_y = 1e9;
                var max_y = -1000000000;
                for(var nodeId in this.trees){
                    if (Object.prototype.hasOwnProperty.call(this.trees, nodeId)) {
                        if (this.trees[nodeId] === index) {
                            var node = nodes[nodeId];
                            min_x = Math.min(node.x, min_x);
                            max_x = Math.max(node.x, max_x);
                            min_y = Math.min(node.y, min_y);
                            max_y = Math.max(node.y, max_y);
                        }
                    }
                }
                return {
                    min_x: min_x,
                    max_x: max_x,
                    min_y: min_y,
                    max_y: max_y
                };
            }
        },
        {
            key: "hasSameParent",
            value: function hasSameParent(node1, node2) {
                var parents1 = this.parentReference[node1.id];
                var parents2 = this.parentReference[node2.id];
                if (parents1 === undefined || parents2 === undefined) return false;
                for(var i = 0; i < parents1.length; i++)for(var j = 0; j < parents2.length; j++){
                    if (parents1[i] == parents2[j]) return true;
                }
                return false;
            }
        },
        {
            key: "inSameSubNetwork",
            value: function inSameSubNetwork(node1, node2) {
                return this.trees[node1.id] === this.trees[node2.id];
            }
        },
        {
            key: "getLevels",
            value: function getLevels() {
                return $bebd28704f2536ea$var$_Object$keys(this.distributionOrdering);
            }
        },
        {
            key: "addToOrdering",
            value: function addToOrdering(node, level) {
                if (this.distributionOrdering[level] === undefined) this.distributionOrdering[level] = [];
                var isPresent = false;
                var curLevel = this.distributionOrdering[level];
                for(var n in curLevel)//if (curLevel[n].id === node.id) {
                if (curLevel[n] === node) {
                    isPresent = true;
                    break;
                }
                if (!isPresent) {
                    this.distributionOrdering[level].push(node);
                    this.distributionIndex[node.id] = this.distributionOrdering[level].length - 1;
                }
            }
        }
    ]);
    return HierarchicalStatus;
}();
/**
 * The Layout Engine
 */ var $bebd28704f2536ea$var$LayoutEngine = /*#__PURE__*/ function() {
    /**
   * @param {object} body
   */ function LayoutEngine(body) {
        $bebd28704f2536ea$var$_classCallCheck(this, LayoutEngine);
        this.body = body;
        // Make sure there always is some RNG because the setOptions method won't
        // set it unless there's a seed for it.
        this._resetRNG(Math.random() + ":" + $bebd28704f2536ea$var$_Date$now());
        this.setPhysics = false;
        this.options = {};
        this.optionsBackup = {
            physics: {}
        };
        this.defaultOptions = {
            randomSeed: undefined,
            improvedLayout: true,
            clusterThreshold: 150,
            hierarchical: {
                enabled: false,
                levelSeparation: 150,
                nodeSpacing: 100,
                treeSpacing: 200,
                blockShifting: true,
                edgeMinimization: true,
                parentCentralization: true,
                direction: "UD",
                // UD, DU, LR, RL
                sortMethod: "hubsize" // hubsize, directed
            }
        };
        $bebd28704f2536ea$var$_Object$assign(this.options, this.defaultOptions);
        this.bindEventListeners();
    }
    /**
   * Binds event listeners
   */ $bebd28704f2536ea$var$_createClass(LayoutEngine, [
        {
            key: "bindEventListeners",
            value: function bindEventListeners() {
                var _this2 = this;
                this.body.emitter.on("_dataChanged", function() {
                    _this2.setupHierarchicalLayout();
                });
                this.body.emitter.on("_dataLoaded", function() {
                    _this2.layoutNetwork();
                });
                this.body.emitter.on("_resetHierarchicalLayout", function() {
                    _this2.setupHierarchicalLayout();
                });
                this.body.emitter.on("_adjustEdgesForHierarchicalLayout", function() {
                    if (_this2.options.hierarchical.enabled !== true) return;
                    // get the type of static smooth curve in case it is required
                    var type = _this2.direction.curveType();
                    // force all edges into static smooth curves.
                    _this2.body.emitter.emit("_forceDisableDynamicCurves", type, false);
                });
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options, allOptions) {
                if (options !== undefined) {
                    var hierarchical = this.options.hierarchical;
                    var prevHierarchicalState = hierarchical.enabled;
                    $bebd28704f2536ea$var$selectiveDeepExtend([
                        "randomSeed",
                        "improvedLayout",
                        "clusterThreshold"
                    ], this.options, options);
                    $bebd28704f2536ea$var$mergeOptions(this.options, options, "hierarchical");
                    if (options.randomSeed !== undefined) this._resetRNG(options.randomSeed);
                    if (hierarchical.enabled === true) {
                        if (prevHierarchicalState === true) // refresh the overridden options for nodes and edges.
                        this.body.emitter.emit("refresh", true);
                        // make sure the level separation is the right way up
                        if (hierarchical.direction === "RL" || hierarchical.direction === "DU") {
                            if (hierarchical.levelSeparation > 0) hierarchical.levelSeparation *= -1;
                        } else if (hierarchical.levelSeparation < 0) hierarchical.levelSeparation *= -1;
                        this.setDirectionStrategy();
                        this.body.emitter.emit("_resetHierarchicalLayout");
                        // because the hierarchical system needs it's own physics and smooth curve settings,
                        // we adapt the other options if needed.
                        return this.adaptAllOptionsForHierarchicalLayout(allOptions);
                    } else if (prevHierarchicalState === true) {
                        // refresh the overridden options for nodes and edges.
                        this.body.emitter.emit("refresh");
                        return $bebd28704f2536ea$var$deepExtend(allOptions, this.optionsBackup);
                    }
                }
                return allOptions;
            }
        },
        {
            key: "_resetRNG",
            value: function _resetRNG(seed) {
                this.initialRandomSeed = seed;
                this._rng = $bebd28704f2536ea$var$Alea(this.initialRandomSeed);
            }
        },
        {
            key: "adaptAllOptionsForHierarchicalLayout",
            value: function adaptAllOptionsForHierarchicalLayout(allOptions) {
                if (this.options.hierarchical.enabled === true) {
                    var backupPhysics = this.optionsBackup.physics;
                    // set the physics
                    if (allOptions.physics === undefined || allOptions.physics === true) {
                        allOptions.physics = {
                            enabled: backupPhysics.enabled === undefined ? true : backupPhysics.enabled,
                            solver: "hierarchicalRepulsion"
                        };
                        backupPhysics.enabled = backupPhysics.enabled === undefined ? true : backupPhysics.enabled;
                        backupPhysics.solver = backupPhysics.solver || "barnesHut";
                    } else if ($bebd28704f2536ea$var$_typeof(allOptions.physics) === "object") {
                        backupPhysics.enabled = allOptions.physics.enabled === undefined ? true : allOptions.physics.enabled;
                        backupPhysics.solver = allOptions.physics.solver || "barnesHut";
                        allOptions.physics.solver = "hierarchicalRepulsion";
                    } else if (allOptions.physics !== false) {
                        backupPhysics.solver = "barnesHut";
                        allOptions.physics = {
                            solver: "hierarchicalRepulsion"
                        };
                    }
                    // get the type of static smooth curve in case it is required
                    var type = this.direction.curveType();
                    // disable smooth curves if nothing is defined. If smooth curves have been turned on,
                    // turn them into static smooth curves.
                    if (allOptions.edges === undefined) {
                        this.optionsBackup.edges = {
                            smooth: {
                                enabled: true,
                                type: "dynamic"
                            }
                        };
                        allOptions.edges = {
                            smooth: false
                        };
                    } else if (allOptions.edges.smooth === undefined) {
                        this.optionsBackup.edges = {
                            smooth: {
                                enabled: true,
                                type: "dynamic"
                            }
                        };
                        allOptions.edges.smooth = false;
                    } else if (typeof allOptions.edges.smooth === "boolean") {
                        this.optionsBackup.edges = {
                            smooth: allOptions.edges.smooth
                        };
                        allOptions.edges.smooth = {
                            enabled: allOptions.edges.smooth,
                            type: type
                        };
                    } else {
                        var smooth = allOptions.edges.smooth;
                        // allow custom types except for dynamic
                        if (smooth.type !== undefined && smooth.type !== "dynamic") type = smooth.type;
                        // TODO: this is options merging; see if the standard routines can be used here.
                        this.optionsBackup.edges = {
                            smooth: {
                                enabled: smooth.enabled === undefined ? true : smooth.enabled,
                                type: smooth.type === undefined ? "dynamic" : smooth.type,
                                roundness: smooth.roundness === undefined ? 0.5 : smooth.roundness,
                                forceDirection: smooth.forceDirection === undefined ? false : smooth.forceDirection
                            }
                        };
                        // NOTE: Copying an object to self; this is basically setting defaults for undefined variables
                        allOptions.edges.smooth = {
                            enabled: smooth.enabled === undefined ? true : smooth.enabled,
                            type: type,
                            roundness: smooth.roundness === undefined ? 0.5 : smooth.roundness,
                            forceDirection: smooth.forceDirection === undefined ? false : smooth.forceDirection
                        };
                    }
                    // Force all edges into static smooth curves.
                    // Only applies to edges that do not use the global options for smooth.
                    this.body.emitter.emit("_forceDisableDynamicCurves", type);
                }
                return allOptions;
            }
        },
        {
            key: "positionInitially",
            value: function positionInitially(nodesArray) {
                if (this.options.hierarchical.enabled !== true) {
                    this._resetRNG(this.initialRandomSeed);
                    var radius = nodesArray.length + 50;
                    for(var i = 0; i < nodesArray.length; i++){
                        var node = nodesArray[i];
                        var angle = 2 * Math.PI * this._rng();
                        if (node.x === undefined) node.x = radius * Math.cos(angle);
                        if (node.y === undefined) node.y = radius * Math.sin(angle);
                    }
                }
            }
        },
        {
            key: "layoutNetwork",
            value: function layoutNetwork() {
                if (this.options.hierarchical.enabled !== true && this.options.improvedLayout === true) {
                    var indices = this.body.nodeIndices;
                    // first check if we should Kamada Kawai to layout. The threshold is if less than half of the visible
                    // nodes have predefined positions we use this.
                    var positionDefined = 0;
                    for(var i = 0; i < indices.length; i++){
                        var node = this.body.nodes[indices[i]];
                        if (node.predefinedPosition === true) positionDefined += 1;
                    }
                    // if less than half of the nodes have a predefined position we continue
                    if (positionDefined < 0.5 * indices.length) {
                        var MAX_LEVELS = 10;
                        var level = 0;
                        var clusterThreshold = this.options.clusterThreshold;
                        //
                        // Define the options for the hidden cluster nodes
                        // These options don't propagate outside the clustering phase.
                        //
                        // Some options are explicitly disabled, because they may be set in group or default node options.
                        // The clusters are never displayed, so most explicit settings here serve as performance optimizations.
                        //
                        // The explicit setting of 'shape' is to avoid `shape: 'image'`; images are not passed to the hidden
                        // cluster nodes, leading to an exception on creation.
                        //
                        // All settings here are performance related, except when noted otherwise.
                        //
                        var clusterOptions = {
                            clusterNodeProperties: {
                                shape: "ellipse",
                                // Bugfix: avoid type 'image', no images supplied
                                label: "",
                                // avoid label handling
                                group: "",
                                // avoid group handling
                                font: {
                                    multi: false
                                } // avoid font propagation
                            },
                            clusterEdgeProperties: {
                                label: "",
                                // avoid label handling
                                font: {
                                    multi: false
                                },
                                // avoid font propagation
                                smooth: {
                                    enabled: false // avoid drawing penalty for complex edges
                                }
                            }
                        };
                        // if there are a lot of nodes, we cluster before we run the algorithm.
                        // NOTE: this part fails to find clusters for large scale-free networks, which should
                        //       be easily clusterable.
                        // TODO: examine why this is so
                        if (indices.length > clusterThreshold) {
                            var startLength = indices.length;
                            while(indices.length > clusterThreshold && level <= MAX_LEVELS){
                                //console.time("clustering")
                                level += 1;
                                var before = indices.length;
                                // if there are many nodes we do a hubsize cluster
                                if (level % 3 === 0) this.body.modules.clustering.clusterBridges(clusterOptions);
                                else this.body.modules.clustering.clusterOutliers(clusterOptions);
                                var after = indices.length;
                                if (before == after && level % 3 !== 0) {
                                    this._declusterAll();
                                    this.body.emitter.emit("_layoutFailed");
                                    console.info("This network could not be positioned by this version of the improved layout algorithm. Please disable improvedLayout for better performance.");
                                    return;
                                }
                            //console.timeEnd("clustering")
                            //console.log(before,level,after);
                            }
                            // increase the size of the edges
                            this.body.modules.kamadaKawai.setOptions({
                                springLength: Math.max(150, 2 * startLength)
                            });
                        }
                        if (level > MAX_LEVELS) console.info("The clustering didn't succeed within the amount of interations allowed, progressing with partial result.");
                        // position the system for these nodes and edges
                        this.body.modules.kamadaKawai.solve(indices, this.body.edgeIndices, true);
                        // shift to center point
                        this._shiftToCenter();
                        // perturb the nodes a little bit to force the physics to kick in
                        var offset = 70;
                        for(var _i = 0; _i < indices.length; _i++){
                            // Only perturb the nodes that aren't fixed
                            var _node = this.body.nodes[indices[_i]];
                            if (_node.predefinedPosition === false) {
                                _node.x += (0.5 - this._rng()) * offset;
                                _node.y += (0.5 - this._rng()) * offset;
                            }
                        }
                        // uncluster all clusters
                        this._declusterAll();
                        // reposition all bezier nodes.
                        this.body.emitter.emit("_repositionBezierNodes");
                    }
                }
            }
        },
        {
            key: "_shiftToCenter",
            value: function _shiftToCenter() {
                var range = $bebd28704f2536ea$var$NetworkUtil.getRangeCore(this.body.nodes, this.body.nodeIndices);
                var center = $bebd28704f2536ea$var$NetworkUtil.findCenter(range);
                for(var i = 0; i < this.body.nodeIndices.length; i++){
                    var node = this.body.nodes[this.body.nodeIndices[i]];
                    node.x -= center.x;
                    node.y -= center.y;
                }
            }
        },
        {
            key: "_declusterAll",
            value: function _declusterAll() {
                var clustersPresent = true;
                while(clustersPresent === true){
                    clustersPresent = false;
                    for(var i = 0; i < this.body.nodeIndices.length; i++)if (this.body.nodes[this.body.nodeIndices[i]].isCluster === true) {
                        clustersPresent = true;
                        this.body.modules.clustering.openCluster(this.body.nodeIndices[i], {}, false);
                    }
                    if (clustersPresent === true) this.body.emitter.emit("_dataChanged");
                }
            }
        },
        {
            key: "getSeed",
            value: function getSeed() {
                return this.initialRandomSeed;
            }
        },
        {
            key: "setupHierarchicalLayout",
            value: function setupHierarchicalLayout() {
                if (this.options.hierarchical.enabled === true && this.body.nodeIndices.length > 0) {
                    // get the size of the largest hubs and check if the user has defined a level for a node.
                    var node, nodeId;
                    var definedLevel = false;
                    var undefinedLevel = false;
                    this.lastNodeOnLevel = {};
                    this.hierarchical = new $bebd28704f2536ea$var$HierarchicalStatus();
                    for(nodeId in this.body.nodes)if (Object.prototype.hasOwnProperty.call(this.body.nodes, nodeId)) {
                        node = this.body.nodes[nodeId];
                        if (node.options.level !== undefined) {
                            definedLevel = true;
                            this.hierarchical.levels[nodeId] = node.options.level;
                        } else undefinedLevel = true;
                    }
                    // if the user defined some levels but not all, alert and run without hierarchical layout
                    if (undefinedLevel === true && definedLevel === true) throw new Error("To use the hierarchical layout, nodes require either no predefined levels or levels have to be defined for all nodes.");
                    else {
                        // define levels if undefined by the users. Based on hubsize.
                        if (undefinedLevel === true) {
                            var sortMethod = this.options.hierarchical.sortMethod;
                            if (sortMethod === "hubsize") this._determineLevelsByHubsize();
                            else if (sortMethod === "directed") this._determineLevelsDirected();
                            else if (sortMethod === "custom") this._determineLevelsCustomCallback();
                        }
                        // fallback for cases where there are nodes but no edges
                        for(var _nodeId2 in this.body.nodes)if (Object.prototype.hasOwnProperty.call(this.body.nodes, _nodeId2)) this.hierarchical.ensureLevel(_nodeId2);
                        // check the distribution of the nodes per level.
                        var distribution = this._getDistribution();
                        // get the parent children relations.
                        this._generateMap();
                        // place the nodes on the canvas.
                        this._placeNodesByHierarchy(distribution);
                        // condense the whitespace.
                        this._condenseHierarchy();
                        // shift to center so gravity does not have to do much
                        this._shiftToCenter();
                    }
                }
            }
        },
        {
            key: "_condenseHierarchy",
            value: function _condenseHierarchy() {
                var _this3 = this;
                // Global var in this scope to define when the movement has stopped.
                var stillShifting = false;
                var branches = {};
                // first we have some methods to help shifting trees around.
                // the main method to shift the trees
                var shiftTrees = function shiftTrees() {
                    var treeSizes = getTreeSizes();
                    var shiftBy = 0;
                    for(var i = 0; i < treeSizes.length - 1; i++){
                        var diff = treeSizes[i].max - treeSizes[i + 1].min;
                        shiftBy += diff + _this3.options.hierarchical.treeSpacing;
                        shiftTree(i + 1, shiftBy);
                    }
                };
                // shift a single tree by an offset
                var shiftTree = function shiftTree(index, offset) {
                    var trees = _this3.hierarchical.trees;
                    for(var nodeId in trees){
                        if (Object.prototype.hasOwnProperty.call(trees, nodeId)) {
                            if (trees[nodeId] === index) _this3.direction.shift(nodeId, offset);
                        }
                    }
                };
                // get the width of all trees
                var getTreeSizes = function getTreeSizes() {
                    var treeWidths = [];
                    for(var i = 0; i < _this3.hierarchical.numTrees(); i++)treeWidths.push(_this3.direction.getTreeSize(i));
                    return treeWidths;
                };
                // get a map of all nodes in this branch
                var getBranchNodes = function getBranchNodes(source, map) {
                    if (map[source.id]) return;
                    map[source.id] = true;
                    if (_this3.hierarchical.childrenReference[source.id]) {
                        var children = _this3.hierarchical.childrenReference[source.id];
                        if (children.length > 0) for(var i = 0; i < children.length; i++)getBranchNodes(_this3.body.nodes[children[i]], map);
                    }
                };
                // get a min max width as well as the maximum movement space it has on either sides
                // we use min max terminology because width and height can interchange depending on the direction of the layout
                var getBranchBoundary = function getBranchBoundary(branchMap) {
                    var maxLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1e9;
                    var minSpace = 1e9;
                    var maxSpace = 1e9;
                    var min = 1e9;
                    var max = -1000000000;
                    for(var branchNode in branchMap)if (Object.prototype.hasOwnProperty.call(branchMap, branchNode)) {
                        var node = _this3.body.nodes[branchNode];
                        var level = _this3.hierarchical.levels[node.id];
                        var position = _this3.direction.getPosition(node);
                        // get the space around the node.
                        var _this3$_getSpaceAroun = _this3._getSpaceAroundNode(node, branchMap), _this3$_getSpaceAroun2 = $bebd28704f2536ea$var$_slicedToArray(_this3$_getSpaceAroun, 2), minSpaceNode = _this3$_getSpaceAroun2[0], maxSpaceNode = _this3$_getSpaceAroun2[1];
                        minSpace = Math.min(minSpaceNode, minSpace);
                        maxSpace = Math.min(maxSpaceNode, maxSpace);
                        // the width is only relevant for the levels two nodes have in common. This is why we filter on this.
                        if (level <= maxLevel) {
                            min = Math.min(position, min);
                            max = Math.max(position, max);
                        }
                    }
                    return [
                        min,
                        max,
                        minSpace,
                        maxSpace
                    ];
                };
                // check what the maximum level is these nodes have in common.
                var getCollisionLevel = function getCollisionLevel(node1, node2) {
                    var maxLevel1 = _this3.hierarchical.getMaxLevel(node1.id);
                    var maxLevel2 = _this3.hierarchical.getMaxLevel(node2.id);
                    return Math.min(maxLevel1, maxLevel2);
                };
                /**
       * Condense elements. These can be nodes or branches depending on the callback.
       *
       * @param {Function} callback
       * @param {Array.<number>} levels
       * @param {*} centerParents
       */ var shiftElementsCloser = function shiftElementsCloser(callback, levels, centerParents) {
                    var hier = _this3.hierarchical;
                    for(var i = 0; i < levels.length; i++){
                        var level = levels[i];
                        var levelNodes = hier.distributionOrdering[level];
                        if (levelNodes.length > 1) for(var j = 0; j < levelNodes.length - 1; j++){
                            var node1 = levelNodes[j];
                            var node2 = levelNodes[j + 1];
                            // NOTE: logic maintained as it was; if nodes have same ancestor,
                            //       then of course they are in the same sub-network.
                            if (hier.hasSameParent(node1, node2) && hier.inSameSubNetwork(node1, node2)) callback(node1, node2, centerParents);
                        }
                    }
                };
                // callback for shifting branches
                var branchShiftCallback = function branchShiftCallback(node1, node2) {
                    var centerParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                    //window.CALLBACKS.push(() => {
                    var pos1 = _this3.direction.getPosition(node1);
                    var pos2 = _this3.direction.getPosition(node2);
                    var diffAbs = Math.abs(pos2 - pos1);
                    var nodeSpacing = _this3.options.hierarchical.nodeSpacing;
                    //console.log("NOW CHECKING:", node1.id, node2.id, diffAbs);
                    if (diffAbs > nodeSpacing) {
                        var branchNodes1 = {};
                        var branchNodes2 = {};
                        getBranchNodes(node1, branchNodes1);
                        getBranchNodes(node2, branchNodes2);
                        // check the largest distance between the branches
                        var maxLevel = getCollisionLevel(node1, node2);
                        var branchNodeBoundary1 = getBranchBoundary(branchNodes1, maxLevel);
                        var branchNodeBoundary2 = getBranchBoundary(branchNodes2, maxLevel);
                        var max1 = branchNodeBoundary1[1];
                        var min2 = branchNodeBoundary2[0];
                        var minSpace2 = branchNodeBoundary2[2];
                        //console.log(node1.id, getBranchBoundary(branchNodes1, maxLevel), node2.id,
                        //            getBranchBoundary(branchNodes2, maxLevel), maxLevel);
                        var diffBranch = Math.abs(max1 - min2);
                        if (diffBranch > nodeSpacing) {
                            var offset = max1 - min2 + nodeSpacing;
                            if (offset < -minSpace2 + nodeSpacing) offset = -minSpace2 + nodeSpacing;
                            if (offset < 0) {
                                //console.log("SHIFTING", node2.id, offset);
                                _this3._shiftBlock(node2.id, offset);
                                stillShifting = true;
                                if (centerParent === true) _this3._centerParent(node2);
                            }
                        }
                    }
                //this.body.emitter.emit("_redraw");})
                };
                var minimizeEdgeLength = function minimizeEdgeLength(iterations, node) {
                    //window.CALLBACKS.push(() => {
                    //  console.log("ts",node.id);
                    var nodeId = node.id;
                    var allEdges = node.edges;
                    var nodeLevel = _this3.hierarchical.levels[node.id];
                    // gather constants
                    var C2 = _this3.options.hierarchical.levelSeparation * _this3.options.hierarchical.levelSeparation;
                    var referenceNodes = {};
                    var aboveEdges = [];
                    for(var i = 0; i < allEdges.length; i++){
                        var edge = allEdges[i];
                        if (edge.toId != edge.fromId) {
                            var otherNode = edge.toId == nodeId ? edge.from : edge.to;
                            referenceNodes[allEdges[i].id] = otherNode;
                            if (_this3.hierarchical.levels[otherNode.id] < nodeLevel) aboveEdges.push(edge);
                        }
                    }
                    // differentiated sum of lengths based on only moving one node over one axis
                    var getFx = function getFx(point, edges) {
                        var sum = 0;
                        for(var _i2 = 0; _i2 < edges.length; _i2++)if (referenceNodes[edges[_i2].id] !== undefined) {
                            var a = _this3.direction.getPosition(referenceNodes[edges[_i2].id]) - point;
                            sum += a / Math.sqrt(a * a + C2);
                        }
                        return sum;
                    };
                    // doubly differentiated sum of lengths based on only moving one node over one axis
                    var getDFx = function getDFx(point, edges) {
                        var sum = 0;
                        for(var _i3 = 0; _i3 < edges.length; _i3++)if (referenceNodes[edges[_i3].id] !== undefined) {
                            var a = _this3.direction.getPosition(referenceNodes[edges[_i3].id]) - point;
                            sum -= C2 * Math.pow(a * a + C2, -1.5);
                        }
                        return sum;
                    };
                    var getGuess = function getGuess(iterations, edges) {
                        var guess = _this3.direction.getPosition(node);
                        // Newton's method for optimization
                        var guessMap = {};
                        for(var _i4 = 0; _i4 < iterations; _i4++){
                            var fx = getFx(guess, edges);
                            var dfx = getDFx(guess, edges);
                            // we limit the movement to avoid instability.
                            var limit = 40;
                            var ratio = Math.max(-limit, Math.min(limit, Math.round(fx / dfx)));
                            guess = guess - ratio;
                            // reduce duplicates
                            if (guessMap[guess] !== undefined) break;
                            guessMap[guess] = _i4;
                        }
                        return guess;
                    };
                    var moveBranch = function moveBranch(guess) {
                        // position node if there is space
                        var nodePosition = _this3.direction.getPosition(node);
                        // check movable area of the branch
                        if (branches[node.id] === undefined) {
                            var branchNodes = {};
                            getBranchNodes(node, branchNodes);
                            branches[node.id] = branchNodes;
                        }
                        var branchBoundary = getBranchBoundary(branches[node.id]);
                        var minSpaceBranch = branchBoundary[2];
                        var maxSpaceBranch = branchBoundary[3];
                        var diff = guess - nodePosition;
                        // check if we are allowed to move the node:
                        var branchOffset = 0;
                        if (diff > 0) branchOffset = Math.min(diff, maxSpaceBranch - _this3.options.hierarchical.nodeSpacing);
                        else if (diff < 0) branchOffset = -Math.min(-diff, minSpaceBranch - _this3.options.hierarchical.nodeSpacing);
                        if (branchOffset != 0) {
                            //console.log("moving branch:",branchOffset, maxSpaceBranch, minSpaceBranch)
                            _this3._shiftBlock(node.id, branchOffset);
                            //this.body.emitter.emit("_redraw");
                            stillShifting = true;
                        }
                    };
                    var moveNode = function moveNode(guess) {
                        var nodePosition = _this3.direction.getPosition(node);
                        // position node if there is space
                        var _this3$_getSpaceAroun3 = _this3._getSpaceAroundNode(node), _this3$_getSpaceAroun4 = $bebd28704f2536ea$var$_slicedToArray(_this3$_getSpaceAroun3, 2), minSpace = _this3$_getSpaceAroun4[0], maxSpace = _this3$_getSpaceAroun4[1];
                        var diff = guess - nodePosition;
                        // check if we are allowed to move the node:
                        var newPosition = nodePosition;
                        if (diff > 0) newPosition = Math.min(nodePosition + (maxSpace - _this3.options.hierarchical.nodeSpacing), guess);
                        else if (diff < 0) newPosition = Math.max(nodePosition - (minSpace - _this3.options.hierarchical.nodeSpacing), guess);
                        if (newPosition !== nodePosition) {
                            //console.log("moving Node:",diff, minSpace, maxSpace);
                            _this3.direction.setPosition(node, newPosition);
                            //this.body.emitter.emit("_redraw");
                            stillShifting = true;
                        }
                    };
                    var guess = getGuess(iterations, aboveEdges);
                    moveBranch(guess);
                    guess = getGuess(iterations, allEdges);
                    moveNode(guess);
                //})
                };
                // method to remove whitespace between branches. Because we do bottom up, we can center the parents.
                var minimizeEdgeLengthBottomUp = function minimizeEdgeLengthBottomUp(iterations) {
                    var levels = _this3.hierarchical.getLevels();
                    levels = $bebd28704f2536ea$var$_reverseInstanceProperty(levels).call(levels);
                    for(var i = 0; i < iterations; i++){
                        stillShifting = false;
                        for(var j = 0; j < levels.length; j++){
                            var level = levels[j];
                            var levelNodes = _this3.hierarchical.distributionOrdering[level];
                            for(var k = 0; k < levelNodes.length; k++)minimizeEdgeLength(1000, levelNodes[k]);
                        }
                        if (stillShifting !== true) break;
                    }
                };
                // method to remove whitespace between branches. Because we do bottom up, we can center the parents.
                var shiftBranchesCloserBottomUp = function shiftBranchesCloserBottomUp(iterations) {
                    var levels = _this3.hierarchical.getLevels();
                    levels = $bebd28704f2536ea$var$_reverseInstanceProperty(levels).call(levels);
                    for(var i = 0; i < iterations; i++){
                        stillShifting = false;
                        shiftElementsCloser(branchShiftCallback, levels, true);
                        if (stillShifting !== true) break;
                    }
                };
                // center all parents
                var centerAllParents = function centerAllParents() {
                    for(var nodeId in _this3.body.nodes)if (Object.prototype.hasOwnProperty.call(_this3.body.nodes, nodeId)) _this3._centerParent(_this3.body.nodes[nodeId]);
                };
                // center all parents
                var centerAllParentsBottomUp = function centerAllParentsBottomUp() {
                    var levels = _this3.hierarchical.getLevels();
                    levels = $bebd28704f2536ea$var$_reverseInstanceProperty(levels).call(levels);
                    for(var i = 0; i < levels.length; i++){
                        var level = levels[i];
                        var levelNodes = _this3.hierarchical.distributionOrdering[level];
                        for(var j = 0; j < levelNodes.length; j++)_this3._centerParent(levelNodes[j]);
                    }
                };
                // the actual work is done here.
                if (this.options.hierarchical.blockShifting === true) {
                    shiftBranchesCloserBottomUp(5);
                    centerAllParents();
                }
                // minimize edge length
                if (this.options.hierarchical.edgeMinimization === true) minimizeEdgeLengthBottomUp(20);
                if (this.options.hierarchical.parentCentralization === true) centerAllParentsBottomUp();
                shiftTrees();
            }
        },
        {
            key: "_getSpaceAroundNode",
            value: function _getSpaceAroundNode(node, map) {
                var useMap = true;
                if (map === undefined) useMap = false;
                var level = this.hierarchical.levels[node.id];
                if (level !== undefined) {
                    var index = this.hierarchical.distributionIndex[node.id];
                    var position = this.direction.getPosition(node);
                    var ordering = this.hierarchical.distributionOrdering[level];
                    var minSpace = 1e9;
                    var maxSpace = 1e9;
                    if (index !== 0) {
                        var prevNode = ordering[index - 1];
                        if (useMap === true && map[prevNode.id] === undefined || useMap === false) {
                            var prevPos = this.direction.getPosition(prevNode);
                            minSpace = position - prevPos;
                        }
                    }
                    if (index != ordering.length - 1) {
                        var nextNode = ordering[index + 1];
                        if (useMap === true && map[nextNode.id] === undefined || useMap === false) {
                            var nextPos = this.direction.getPosition(nextNode);
                            maxSpace = Math.min(maxSpace, nextPos - position);
                        }
                    }
                    return [
                        minSpace,
                        maxSpace
                    ];
                } else return [
                    0,
                    0
                ];
            }
        },
        {
            key: "_centerParent",
            value: function _centerParent(node) {
                if (this.hierarchical.parentReference[node.id]) {
                    var parents = this.hierarchical.parentReference[node.id];
                    for(var i = 0; i < parents.length; i++){
                        var parentId = parents[i];
                        var parentNode = this.body.nodes[parentId];
                        var children = this.hierarchical.childrenReference[parentId];
                        if (children !== undefined) {
                            // get the range of the children
                            var newPosition = this._getCenterPosition(children);
                            var position = this.direction.getPosition(parentNode);
                            var _this$_getSpaceAround = this._getSpaceAroundNode(parentNode), _this$_getSpaceAround2 = $bebd28704f2536ea$var$_slicedToArray(_this$_getSpaceAround, 2), minSpace = _this$_getSpaceAround2[0], maxSpace = _this$_getSpaceAround2[1];
                            var diff = position - newPosition;
                            if (diff < 0 && Math.abs(diff) < maxSpace - this.options.hierarchical.nodeSpacing || diff > 0 && Math.abs(diff) < minSpace - this.options.hierarchical.nodeSpacing) this.direction.setPosition(parentNode, newPosition);
                        }
                    }
                }
            }
        },
        {
            key: "_placeNodesByHierarchy",
            value: function _placeNodesByHierarchy(distribution) {
                this.positionedNodes = {};
                // start placing all the level 0 nodes first. Then recursively position their branches.
                for(var level in distribution)if (Object.prototype.hasOwnProperty.call(distribution, level)) {
                    var _context;
                    // sort nodes in level by position:
                    var nodeArray = $bebd28704f2536ea$var$_Object$keys(distribution[level]);
                    nodeArray = this._indexArrayToNodes(nodeArray);
                    $bebd28704f2536ea$var$_sortInstanceProperty(_context = this.direction).call(_context, nodeArray);
                    var handledNodeCount = 0;
                    for(var i = 0; i < nodeArray.length; i++){
                        var node = nodeArray[i];
                        if (this.positionedNodes[node.id] === undefined) {
                            var spacing = this.options.hierarchical.nodeSpacing;
                            var pos = spacing * handledNodeCount;
                            // We get the X or Y values we need and store them in pos and previousPos.
                            // The get and set make sure we get X or Y
                            if (handledNodeCount > 0) pos = this.direction.getPosition(nodeArray[i - 1]) + spacing;
                            this.direction.setPosition(node, pos, level);
                            this._validatePositionAndContinue(node, level, pos);
                            handledNodeCount++;
                        }
                    }
                }
            }
        },
        {
            key: "_placeBranchNodes",
            value: function _placeBranchNodes(parentId, parentLevel) {
                var _context2;
                var childRef = this.hierarchical.childrenReference[parentId];
                // if this is not a parent, cancel the placing. This can happen with multiple parents to one child.
                if (childRef === undefined) return;
                // get a list of childNodes
                var childNodes = [];
                for(var i = 0; i < childRef.length; i++)childNodes.push(this.body.nodes[childRef[i]]);
                // use the positions to order the nodes.
                $bebd28704f2536ea$var$_sortInstanceProperty(_context2 = this.direction).call(_context2, childNodes);
                // position the childNodes
                for(var _i5 = 0; _i5 < childNodes.length; _i5++){
                    var childNode = childNodes[_i5];
                    var childNodeLevel = this.hierarchical.levels[childNode.id];
                    // check if the child node is below the parent node and if it has already been positioned.
                    if (childNodeLevel > parentLevel && this.positionedNodes[childNode.id] === undefined) {
                        // get the amount of space required for this node. If parent the width is based on the amount of children.
                        var spacing = this.options.hierarchical.nodeSpacing;
                        var pos = void 0;
                        // we get the X or Y values we need and store them in pos and previousPos.
                        // The get and set make sure we get X or Y
                        if (_i5 === 0) pos = this.direction.getPosition(this.body.nodes[parentId]);
                        else pos = this.direction.getPosition(childNodes[_i5 - 1]) + spacing;
                        this.direction.setPosition(childNode, pos, childNodeLevel);
                        this._validatePositionAndContinue(childNode, childNodeLevel, pos);
                    } else return;
                }
                // center the parent nodes.
                var center = this._getCenterPosition(childNodes);
                this.direction.setPosition(this.body.nodes[parentId], center, parentLevel);
            }
        },
        {
            key: "_validatePositionAndContinue",
            value: function _validatePositionAndContinue(node, level, pos) {
                // This method only works for formal trees and formal forests
                // Early exit if this is not the case
                if (!this.hierarchical.isTree) return;
                // if overlap has been detected, we shift the branch
                if (this.lastNodeOnLevel[level] !== undefined) {
                    var previousPos = this.direction.getPosition(this.body.nodes[this.lastNodeOnLevel[level]]);
                    if (pos - previousPos < this.options.hierarchical.nodeSpacing) {
                        var diff = previousPos + this.options.hierarchical.nodeSpacing - pos;
                        var sharedParent = this._findCommonParent(this.lastNodeOnLevel[level], node.id);
                        this._shiftBlock(sharedParent.withChild, diff);
                    }
                }
                this.lastNodeOnLevel[level] = node.id; // store change in position.
                this.positionedNodes[node.id] = true;
                this._placeBranchNodes(node.id, level);
            }
        },
        {
            key: "_indexArrayToNodes",
            value: function _indexArrayToNodes(idArray) {
                var array = [];
                for(var i = 0; i < idArray.length; i++)array.push(this.body.nodes[idArray[i]]);
                return array;
            }
        },
        {
            key: "_getDistribution",
            value: function _getDistribution() {
                var distribution = {};
                var nodeId, node;
                // we fix Y because the hierarchy is vertical,
                // we fix X so we do not give a node an x position for a second time.
                // the fix of X is removed after the x value has been set.
                for(nodeId in this.body.nodes)if (Object.prototype.hasOwnProperty.call(this.body.nodes, nodeId)) {
                    node = this.body.nodes[nodeId];
                    var level = this.hierarchical.levels[nodeId] === undefined ? 0 : this.hierarchical.levels[nodeId];
                    this.direction.fix(node, level);
                    if (distribution[level] === undefined) distribution[level] = {};
                    distribution[level][nodeId] = node;
                }
                return distribution;
            }
        },
        {
            key: "_getActiveEdges",
            value: function _getActiveEdges(node) {
                var _this4 = this;
                var result = [];
                $bebd28704f2536ea$var$forEach$1(node.edges, function(edge) {
                    var _context3;
                    if ($bebd28704f2536ea$var$_indexOfInstanceProperty(_context3 = _this4.body.edgeIndices).call(_context3, edge.id) !== -1) result.push(edge);
                });
                return result;
            }
        },
        {
            key: "_getHubSizes",
            value: function _getHubSizes() {
                var _this5 = this;
                var hubSizes = {};
                var nodeIds = this.body.nodeIndices;
                $bebd28704f2536ea$var$forEach$1(nodeIds, function(nodeId) {
                    var node = _this5.body.nodes[nodeId];
                    var hubSize = _this5._getActiveEdges(node).length;
                    hubSizes[hubSize] = true;
                });
                // Make an array of the size sorted descending
                var result = [];
                $bebd28704f2536ea$var$forEach$1(hubSizes, function(size) {
                    result.push(Number(size));
                });
                $bebd28704f2536ea$var$_sortInstanceProperty(result).call(result, function(a, b) {
                    return b - a;
                });
                return result;
            }
        },
        {
            key: "_determineLevelsByHubsize",
            value: function _determineLevelsByHubsize() {
                var _this6 = this;
                var levelDownstream = function levelDownstream(nodeA, nodeB) {
                    _this6.hierarchical.levelDownstream(nodeA, nodeB);
                };
                var hubSizes = this._getHubSizes();
                var _loop = function _loop() {
                    var hubSize = hubSizes[i];
                    if (hubSize === 0) return 1; // break
                    $bebd28704f2536ea$var$forEach$1(_this6.body.nodeIndices, function(nodeId) {
                        var node = _this6.body.nodes[nodeId];
                        if (hubSize === _this6._getActiveEdges(node).length) _this6._crawlNetwork(levelDownstream, nodeId);
                    });
                };
                for(var i = 0; i < hubSizes.length; ++i){
                    if (_loop()) break;
                }
            }
        },
        {
            key: "_determineLevelsCustomCallback",
            value: function _determineLevelsCustomCallback() {
                var _this7 = this;
                var minLevel = 100000;
                // TODO: this should come from options.
                // eslint-disable-next-line no-unused-vars -- This should eventually be implemented with these parameters used.
                var customCallback = function customCallback(nodeA, nodeB, edge) {};
                // TODO: perhaps move to HierarchicalStatus.
                //       But I currently don't see the point, this method is not used.
                var levelByDirection = function levelByDirection(nodeA, nodeB, edge) {
                    var levelA = _this7.hierarchical.levels[nodeA.id];
                    // set initial level
                    if (levelA === undefined) levelA = _this7.hierarchical.levels[nodeA.id] = minLevel;
                    var diff = customCallback($bebd28704f2536ea$var$NetworkUtil.cloneOptions(nodeA, "node"), $bebd28704f2536ea$var$NetworkUtil.cloneOptions(nodeB, "node"), $bebd28704f2536ea$var$NetworkUtil.cloneOptions(edge, "edge"));
                    _this7.hierarchical.levels[nodeB.id] = levelA + diff;
                };
                this._crawlNetwork(levelByDirection);
                this.hierarchical.setMinLevelToZero(this.body.nodes);
            }
        },
        {
            key: "_determineLevelsDirected",
            value: function _determineLevelsDirected() {
                var _context4, _this8 = this;
                var nodes = $bebd28704f2536ea$var$_reduceInstanceProperty(_context4 = this.body.nodeIndices).call(_context4, function(acc, id) {
                    acc.set(id, _this8.body.nodes[id]);
                    return acc;
                }, new $bebd28704f2536ea$var$_Map());
                if (this.options.hierarchical.shakeTowards === "roots") this.hierarchical.levels = $bebd28704f2536ea$var$fillLevelsByDirectionRoots(nodes);
                else this.hierarchical.levels = $bebd28704f2536ea$var$fillLevelsByDirectionLeaves(nodes);
                this.hierarchical.setMinLevelToZero(this.body.nodes);
            }
        },
        {
            key: "_generateMap",
            value: function _generateMap() {
                var _this9 = this;
                var fillInRelations = function fillInRelations(parentNode, childNode) {
                    if (_this9.hierarchical.levels[childNode.id] > _this9.hierarchical.levels[parentNode.id]) _this9.hierarchical.addRelation(parentNode.id, childNode.id);
                };
                this._crawlNetwork(fillInRelations);
                this.hierarchical.checkIfTree();
            }
        },
        {
            key: "_crawlNetwork",
            value: function _crawlNetwork() {
                var _this10 = this;
                var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function() {};
                var startingNodeId = arguments.length > 1 ? arguments[1] : undefined;
                var progress = {};
                var crawler = function crawler(node, tree) {
                    if (progress[node.id] === undefined) {
                        _this10.hierarchical.setTreeIndex(node, tree);
                        progress[node.id] = true;
                        var childNode;
                        var edges = _this10._getActiveEdges(node);
                        for(var i = 0; i < edges.length; i++){
                            var edge = edges[i];
                            if (edge.connected === true) {
                                if (edge.toId == node.id) // Not '===' because id's can be string and numeric
                                childNode = edge.from;
                                else childNode = edge.to;
                                if (node.id != childNode.id) {
                                    // Not '!==' because id's can be string and numeric
                                    callback(node, childNode, edge);
                                    crawler(childNode, tree);
                                }
                            }
                        }
                    }
                };
                if (startingNodeId === undefined) {
                    // Crawl over all nodes
                    var treeIndex = 0; // Serves to pass a unique id for the current distinct tree
                    for(var i = 0; i < this.body.nodeIndices.length; i++){
                        var nodeId = this.body.nodeIndices[i];
                        if (progress[nodeId] === undefined) {
                            var node = this.body.nodes[nodeId];
                            crawler(node, treeIndex);
                            treeIndex += 1;
                        }
                    }
                } else {
                    // Crawl from the given starting node
                    var _node2 = this.body.nodes[startingNodeId];
                    if (_node2 === undefined) {
                        console.error("Node not found:", startingNodeId);
                        return;
                    }
                    crawler(_node2);
                }
            }
        },
        {
            key: "_shiftBlock",
            value: function _shiftBlock(parentId, diff) {
                var _this11 = this;
                var progress = {};
                var shifter = function shifter(parentId) {
                    if (progress[parentId]) return;
                    progress[parentId] = true;
                    _this11.direction.shift(parentId, diff);
                    var childRef = _this11.hierarchical.childrenReference[parentId];
                    if (childRef !== undefined) for(var i = 0; i < childRef.length; i++)shifter(childRef[i]);
                };
                shifter(parentId);
            }
        },
        {
            key: "_findCommonParent",
            value: function _findCommonParent(childA, childB) {
                var _this12 = this;
                var parents = {};
                var iterateParents = function iterateParents(parents, child) {
                    var parentRef = _this12.hierarchical.parentReference[child];
                    if (parentRef !== undefined) for(var i = 0; i < parentRef.length; i++){
                        var parent = parentRef[i];
                        parents[parent] = true;
                        iterateParents(parents, parent);
                    }
                };
                var findParent = function findParent(parents, child) {
                    var parentRef = _this12.hierarchical.parentReference[child];
                    if (parentRef !== undefined) for(var i = 0; i < parentRef.length; i++){
                        var parent = parentRef[i];
                        if (parents[parent] !== undefined) return {
                            foundParent: parent,
                            withChild: child
                        };
                        var branch = findParent(parents, parent);
                        if (branch.foundParent !== null) return branch;
                    }
                    return {
                        foundParent: null,
                        withChild: child
                    };
                };
                iterateParents(parents, childA);
                return findParent(parents, childB);
            }
        },
        {
            key: "setDirectionStrategy",
            value: function setDirectionStrategy() {
                var isVertical = this.options.hierarchical.direction === "UD" || this.options.hierarchical.direction === "DU";
                if (isVertical) this.direction = new $bebd28704f2536ea$var$VerticalStrategy(this);
                else this.direction = new $bebd28704f2536ea$var$HorizontalStrategy(this);
            }
        },
        {
            key: "_getCenterPosition",
            value: function _getCenterPosition(childNodes) {
                var minPos = 1e9;
                var maxPos = -1000000000;
                for(var i = 0; i < childNodes.length; i++){
                    var childNode = void 0;
                    if (childNodes[i].id !== undefined) childNode = childNodes[i];
                    else {
                        var childNodeId = childNodes[i];
                        childNode = this.body.nodes[childNodeId];
                    }
                    var position = this.direction.getPosition(childNode);
                    minPos = Math.min(minPos, position);
                    maxPos = Math.max(maxPos, position);
                }
                return 0.5 * (minPos + maxPos);
            }
        }
    ]);
    return LayoutEngine;
}();
function $bebd28704f2536ea$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof $bebd28704f2536ea$var$_Symbol !== "undefined" && $bebd28704f2536ea$var$_getIteratorMethod(o) || o["@@iterator"];
    if (!it) {
        if ($bebd28704f2536ea$var$_Array$isArray(o) || (it = $bebd28704f2536ea$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $bebd28704f2536ea$var$_unsupportedIterableToArray(o, minLen) {
    var _context32;
    if (!o) return;
    if (typeof o === "string") return $bebd28704f2536ea$var$_arrayLikeToArray(o, minLen);
    var n = $bebd28704f2536ea$var$_sliceInstanceProperty(_context32 = Object.prototype.toString.call(o)).call(_context32, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return $bebd28704f2536ea$var$_Array$from$1(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bebd28704f2536ea$var$_arrayLikeToArray(o, minLen);
}
function $bebd28704f2536ea$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * Clears the toolbar div element of children
 *
 * @private
 */ var $bebd28704f2536ea$var$ManipulationSystem = /*#__PURE__*/ function() {
    /**
   * @param {object} body
   * @param {Canvas} canvas
   * @param {SelectionHandler} selectionHandler
   * @param {InteractionHandler} interactionHandler
   */ function ManipulationSystem(body, canvas, selectionHandler, interactionHandler) {
        var _this = this, _context, _context2;
        $bebd28704f2536ea$var$_classCallCheck(this, ManipulationSystem);
        this.body = body;
        this.canvas = canvas;
        this.selectionHandler = selectionHandler;
        this.interactionHandler = interactionHandler;
        this.editMode = false;
        this.manipulationDiv = undefined;
        this.editModeDiv = undefined;
        this.closeDiv = undefined;
        this._domEventListenerCleanupQueue = [];
        this.temporaryUIFunctions = {};
        this.temporaryEventFunctions = [];
        this.touchTime = 0;
        this.temporaryIds = {
            nodes: [],
            edges: []
        };
        this.guiEnabled = false;
        this.inMode = false;
        this.selectedControlNode = undefined;
        this.options = {};
        this.defaultOptions = {
            enabled: false,
            initiallyActive: false,
            addNode: true,
            addEdge: true,
            editNode: undefined,
            editEdge: true,
            deleteNode: true,
            deleteEdge: true,
            controlNodeStyle: {
                shape: "dot",
                size: 6,
                color: {
                    background: "#ff0000",
                    border: "#3c3c3c",
                    highlight: {
                        background: "#07f968",
                        border: "#3c3c3c"
                    }
                },
                borderWidth: 2,
                borderWidthSelected: 2
            }
        };
        $bebd28704f2536ea$var$_Object$assign(this.options, this.defaultOptions);
        this.body.emitter.on("destroy", function() {
            _this._clean();
        });
        this.body.emitter.on("_dataChanged", $bebd28704f2536ea$var$_bindInstanceProperty$1(_context = this._restore).call(_context, this));
        this.body.emitter.on("_resetData", $bebd28704f2536ea$var$_bindInstanceProperty$1(_context2 = this._restore).call(_context2, this));
    }
    /**
   * If something changes in the data during editing, switch back to the initial datamanipulation state and close all edit modes.
   *
   * @private
   */ $bebd28704f2536ea$var$_createClass(ManipulationSystem, [
        {
            key: "_restore",
            value: function _restore() {
                if (this.inMode !== false) {
                    if (this.options.initiallyActive === true) this.enableEditMode();
                    else this.disableEditMode();
                }
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options, allOptions, globalOptions) {
                if (allOptions !== undefined) {
                    if (allOptions.locale !== undefined) this.options.locale = allOptions.locale;
                    else this.options.locale = globalOptions.locale;
                    if (allOptions.locales !== undefined) this.options.locales = allOptions.locales;
                    else this.options.locales = globalOptions.locales;
                }
                if (options !== undefined) {
                    if (typeof options === "boolean") this.options.enabled = options;
                    else {
                        this.options.enabled = true;
                        $bebd28704f2536ea$var$deepExtend(this.options, options);
                    }
                    if (this.options.initiallyActive === true) this.editMode = true;
                    this._setup();
                }
            }
        },
        {
            key: "toggleEditMode",
            value: function toggleEditMode() {
                if (this.editMode === true) this.disableEditMode();
                else this.enableEditMode();
            }
        },
        {
            key: "enableEditMode",
            value: function enableEditMode() {
                this.editMode = true;
                this._clean();
                if (this.guiEnabled === true) {
                    this.manipulationDiv.style.display = "block";
                    this.closeDiv.style.display = "block";
                    this.editModeDiv.style.display = "none";
                    this.showManipulatorToolbar();
                }
            }
        },
        {
            key: "disableEditMode",
            value: function disableEditMode() {
                this.editMode = false;
                this._clean();
                if (this.guiEnabled === true) {
                    this.manipulationDiv.style.display = "none";
                    this.closeDiv.style.display = "none";
                    this.editModeDiv.style.display = "block";
                    this._createEditButton();
                }
            }
        },
        {
            key: "showManipulatorToolbar",
            value: function showManipulatorToolbar() {
                // restore the state of any bound functions or events, remove control nodes, restore physics
                this._clean();
                // reset global variables
                this.manipulationDOM = {};
                // if the gui is enabled, draw all elements.
                if (this.guiEnabled === true) {
                    var _context3, _context4;
                    // a _restore will hide these menus
                    this.editMode = true;
                    this.manipulationDiv.style.display = "block";
                    this.closeDiv.style.display = "block";
                    var selectedNodeCount = this.selectionHandler.getSelectedNodeCount();
                    var selectedEdgeCount = this.selectionHandler.getSelectedEdgeCount();
                    var selectedTotalCount = selectedNodeCount + selectedEdgeCount;
                    var locale = this.options.locales[this.options.locale];
                    var needSeperator = false;
                    if (this.options.addNode !== false) {
                        this._createAddNodeButton(locale);
                        needSeperator = true;
                    }
                    if (this.options.addEdge !== false) {
                        if (needSeperator === true) this._createSeperator(1);
                        else needSeperator = true;
                        this._createAddEdgeButton(locale);
                    }
                    if (selectedNodeCount === 1 && typeof this.options.editNode === "function") {
                        if (needSeperator === true) this._createSeperator(2);
                        else needSeperator = true;
                        this._createEditNodeButton(locale);
                    } else if (selectedEdgeCount === 1 && selectedNodeCount === 0 && this.options.editEdge !== false) {
                        if (needSeperator === true) this._createSeperator(3);
                        else needSeperator = true;
                        this._createEditEdgeButton(locale);
                    }
                    // remove buttons
                    if (selectedTotalCount !== 0) {
                        if (selectedNodeCount > 0 && this.options.deleteNode !== false) {
                            if (needSeperator === true) this._createSeperator(4);
                            this._createDeleteButton(locale);
                        } else if (selectedNodeCount === 0 && this.options.deleteEdge !== false) {
                            if (needSeperator === true) this._createSeperator(4);
                            this._createDeleteButton(locale);
                        }
                    }
                    // bind the close button
                    this._bindElementEvents(this.closeDiv, $bebd28704f2536ea$var$_bindInstanceProperty$1(_context3 = this.toggleEditMode).call(_context3, this));
                    // refresh this bar based on what has been selected
                    this._temporaryBindEvent("select", $bebd28704f2536ea$var$_bindInstanceProperty$1(_context4 = this.showManipulatorToolbar).call(_context4, this));
                }
                // redraw to show any possible changes
                this.body.emitter.emit("_redraw");
            }
        },
        {
            key: "addNodeMode",
            value: function addNodeMode() {
                var _context6;
                // when using the gui, enable edit mode if it wasnt already.
                if (this.editMode !== true) this.enableEditMode();
                // restore the state of any bound functions or events, remove control nodes, restore physics
                this._clean();
                this.inMode = "addNode";
                if (this.guiEnabled === true) {
                    var _context5;
                    var locale = this.options.locales[this.options.locale];
                    this.manipulationDOM = {};
                    this._createBackButton(locale);
                    this._createSeperator();
                    this._createDescription(locale["addDescription"] || this.options.locales["en"]["addDescription"]);
                    // bind the close button
                    this._bindElementEvents(this.closeDiv, $bebd28704f2536ea$var$_bindInstanceProperty$1(_context5 = this.toggleEditMode).call(_context5, this));
                }
                this._temporaryBindEvent("click", $bebd28704f2536ea$var$_bindInstanceProperty$1(_context6 = this._performAddNode).call(_context6, this));
            }
        },
        {
            key: "editNode",
            value: function editNode() {
                var _this2 = this;
                // when using the gui, enable edit mode if it wasnt already.
                if (this.editMode !== true) this.enableEditMode();
                // restore the state of any bound functions or events, remove control nodes, restore physics
                this._clean();
                var node = this.selectionHandler.getSelectedNodes()[0];
                if (node !== undefined) {
                    this.inMode = "editNode";
                    if (typeof this.options.editNode === "function") {
                        if (node.isCluster !== true) {
                            var data = $bebd28704f2536ea$var$deepExtend({}, node.options, false);
                            data.x = node.x;
                            data.y = node.y;
                            if (this.options.editNode.length === 2) this.options.editNode(data, function(finalizedData) {
                                if (finalizedData !== null && finalizedData !== undefined && _this2.inMode === "editNode") // if for whatever reason the mode has changes (due to dataset change) disregard the callback) {
                                _this2.body.data.nodes.getDataSet().update(finalizedData);
                                _this2.showManipulatorToolbar();
                            });
                            else throw new Error("The function for edit does not support two arguments (data, callback)");
                        } else alert(this.options.locales[this.options.locale]["editClusterError"] || this.options.locales["en"]["editClusterError"]);
                    } else throw new Error("No function has been configured to handle the editing of nodes.");
                } else this.showManipulatorToolbar();
            }
        },
        {
            key: "addEdgeMode",
            value: function addEdgeMode() {
                var _context8, _context9, _context10, _context11, _context12;
                // when using the gui, enable edit mode if it wasnt already.
                if (this.editMode !== true) this.enableEditMode();
                // restore the state of any bound functions or events, remove control nodes, restore physics
                this._clean();
                this.inMode = "addEdge";
                if (this.guiEnabled === true) {
                    var _context7;
                    var locale = this.options.locales[this.options.locale];
                    this.manipulationDOM = {};
                    this._createBackButton(locale);
                    this._createSeperator();
                    this._createDescription(locale["edgeDescription"] || this.options.locales["en"]["edgeDescription"]);
                    // bind the close button
                    this._bindElementEvents(this.closeDiv, $bebd28704f2536ea$var$_bindInstanceProperty$1(_context7 = this.toggleEditMode).call(_context7, this));
                }
                // temporarily overload functions
                this._temporaryBindUI("onTouch", $bebd28704f2536ea$var$_bindInstanceProperty$1(_context8 = this._handleConnect).call(_context8, this));
                this._temporaryBindUI("onDragEnd", $bebd28704f2536ea$var$_bindInstanceProperty$1(_context9 = this._finishConnect).call(_context9, this));
                this._temporaryBindUI("onDrag", $bebd28704f2536ea$var$_bindInstanceProperty$1(_context10 = this._dragControlNode).call(_context10, this));
                this._temporaryBindUI("onRelease", $bebd28704f2536ea$var$_bindInstanceProperty$1(_context11 = this._finishConnect).call(_context11, this));
                this._temporaryBindUI("onDragStart", $bebd28704f2536ea$var$_bindInstanceProperty$1(_context12 = this._dragStartEdge).call(_context12, this));
                this._temporaryBindUI("onHold", function() {});
            }
        },
        {
            key: "editEdgeMode",
            value: function editEdgeMode() {
                // when using the gui, enable edit mode if it wasn't already.
                if (this.editMode !== true) this.enableEditMode();
                // restore the state of any bound functions or events, remove control nodes, restore physics
                this._clean();
                this.inMode = "editEdge";
                if ($bebd28704f2536ea$var$_typeof(this.options.editEdge) === "object" && typeof this.options.editEdge.editWithoutDrag === "function") {
                    this.edgeBeingEditedId = this.selectionHandler.getSelectedEdgeIds()[0];
                    if (this.edgeBeingEditedId !== undefined) {
                        var edge = this.body.edges[this.edgeBeingEditedId];
                        this._performEditEdge(edge.from.id, edge.to.id);
                        return;
                    }
                }
                if (this.guiEnabled === true) {
                    var _context13;
                    var locale = this.options.locales[this.options.locale];
                    this.manipulationDOM = {};
                    this._createBackButton(locale);
                    this._createSeperator();
                    this._createDescription(locale["editEdgeDescription"] || this.options.locales["en"]["editEdgeDescription"]);
                    // bind the close button
                    this._bindElementEvents(this.closeDiv, $bebd28704f2536ea$var$_bindInstanceProperty$1(_context13 = this.toggleEditMode).call(_context13, this));
                }
                this.edgeBeingEditedId = this.selectionHandler.getSelectedEdgeIds()[0];
                if (this.edgeBeingEditedId !== undefined) {
                    var _context14, _context15, _context16, _context17;
                    var _edge = this.body.edges[this.edgeBeingEditedId];
                    // create control nodes
                    var controlNodeFrom = this._getNewTargetNode(_edge.from.x, _edge.from.y);
                    var controlNodeTo = this._getNewTargetNode(_edge.to.x, _edge.to.y);
                    this.temporaryIds.nodes.push(controlNodeFrom.id);
                    this.temporaryIds.nodes.push(controlNodeTo.id);
                    this.body.nodes[controlNodeFrom.id] = controlNodeFrom;
                    this.body.nodeIndices.push(controlNodeFrom.id);
                    this.body.nodes[controlNodeTo.id] = controlNodeTo;
                    this.body.nodeIndices.push(controlNodeTo.id);
                    // temporarily overload UI functions, cleaned up automatically because of _temporaryBindUI
                    this._temporaryBindUI("onTouch", $bebd28704f2536ea$var$_bindInstanceProperty$1(_context14 = this._controlNodeTouch).call(_context14, this)); // used to get the position
                    this._temporaryBindUI("onTap", function() {}); // disabled
                    this._temporaryBindUI("onHold", function() {}); // disabled
                    this._temporaryBindUI("onDragStart", $bebd28704f2536ea$var$_bindInstanceProperty$1(_context15 = this._controlNodeDragStart).call(_context15, this)); // used to select control node
                    this._temporaryBindUI("onDrag", $bebd28704f2536ea$var$_bindInstanceProperty$1(_context16 = this._controlNodeDrag).call(_context16, this)); // used to drag control node
                    this._temporaryBindUI("onDragEnd", $bebd28704f2536ea$var$_bindInstanceProperty$1(_context17 = this._controlNodeDragEnd).call(_context17, this)); // used to connect or revert control nodes
                    this._temporaryBindUI("onMouseMove", function() {}); // disabled
                    // create function to position control nodes correctly on movement
                    // automatically cleaned up because we use the temporary bind
                    this._temporaryBindEvent("beforeDrawing", function(ctx) {
                        var positions = _edge.edgeType.findBorderPositions(ctx);
                        if (controlNodeFrom.selected === false) {
                            controlNodeFrom.x = positions.from.x;
                            controlNodeFrom.y = positions.from.y;
                        }
                        if (controlNodeTo.selected === false) {
                            controlNodeTo.x = positions.to.x;
                            controlNodeTo.y = positions.to.y;
                        }
                    });
                    this.body.emitter.emit("_redraw");
                } else this.showManipulatorToolbar();
            }
        },
        {
            key: "deleteSelected",
            value: function deleteSelected() {
                var _this3 = this;
                // when using the gui, enable edit mode if it wasnt already.
                if (this.editMode !== true) this.enableEditMode();
                // restore the state of any bound functions or events, remove control nodes, restore physics
                this._clean();
                this.inMode = "delete";
                var selectedNodes = this.selectionHandler.getSelectedNodeIds();
                var selectedEdges = this.selectionHandler.getSelectedEdgeIds();
                var deleteFunction = undefined;
                if (selectedNodes.length > 0) {
                    for(var i = 0; i < selectedNodes.length; i++)if (this.body.nodes[selectedNodes[i]].isCluster === true) {
                        alert(this.options.locales[this.options.locale]["deleteClusterError"] || this.options.locales["en"]["deleteClusterError"]);
                        return;
                    }
                    if (typeof this.options.deleteNode === "function") deleteFunction = this.options.deleteNode;
                } else if (selectedEdges.length > 0) {
                    if (typeof this.options.deleteEdge === "function") deleteFunction = this.options.deleteEdge;
                }
                if (typeof deleteFunction === "function") {
                    var data = {
                        nodes: selectedNodes,
                        edges: selectedEdges
                    };
                    if (deleteFunction.length === 2) deleteFunction(data, function(finalizedData) {
                        if (finalizedData !== null && finalizedData !== undefined && _this3.inMode === "delete") {
                            // if for whatever reason the mode has changes (due to dataset change) disregard the callback) {
                            _this3.body.data.edges.getDataSet().remove(finalizedData.edges);
                            _this3.body.data.nodes.getDataSet().remove(finalizedData.nodes);
                            _this3.body.emitter.emit("startSimulation");
                            _this3.showManipulatorToolbar();
                        } else {
                            _this3.body.emitter.emit("startSimulation");
                            _this3.showManipulatorToolbar();
                        }
                    });
                    else throw new Error("The function for delete does not support two arguments (data, callback)");
                } else {
                    this.body.data.edges.getDataSet().remove(selectedEdges);
                    this.body.data.nodes.getDataSet().remove(selectedNodes);
                    this.body.emitter.emit("startSimulation");
                    this.showManipulatorToolbar();
                }
            }
        },
        {
            key: "_setup",
            value: function _setup() {
                if (this.options.enabled === true) {
                    // Enable the GUI
                    this.guiEnabled = true;
                    this._createWrappers();
                    if (this.editMode === false) this._createEditButton();
                    else this.showManipulatorToolbar();
                } else {
                    this._removeManipulationDOM();
                    // disable the gui
                    this.guiEnabled = false;
                }
            }
        },
        {
            key: "_createWrappers",
            value: function _createWrappers() {
                // load the manipulator HTML elements. All styling done in css.
                if (this.manipulationDiv === undefined) {
                    this.manipulationDiv = document.createElement("div");
                    this.manipulationDiv.className = "vis-manipulation";
                    if (this.editMode === true) this.manipulationDiv.style.display = "block";
                    else this.manipulationDiv.style.display = "none";
                    this.canvas.frame.appendChild(this.manipulationDiv);
                }
                // container for the edit button.
                if (this.editModeDiv === undefined) {
                    this.editModeDiv = document.createElement("div");
                    this.editModeDiv.className = "vis-edit-mode";
                    if (this.editMode === true) this.editModeDiv.style.display = "none";
                    else this.editModeDiv.style.display = "block";
                    this.canvas.frame.appendChild(this.editModeDiv);
                }
                // container for the close div button
                if (this.closeDiv === undefined) {
                    var _this$options$locales, _this$options$locales2;
                    this.closeDiv = document.createElement("button");
                    this.closeDiv.className = "vis-close";
                    this.closeDiv.setAttribute("aria-label", (_this$options$locales = (_this$options$locales2 = this.options.locales[this.options.locale]) === null || _this$options$locales2 === void 0 ? void 0 : _this$options$locales2["close"]) !== null && _this$options$locales !== void 0 ? _this$options$locales : this.options.locales["en"]["close"]);
                    this.closeDiv.style.display = this.manipulationDiv.style.display;
                    this.canvas.frame.appendChild(this.closeDiv);
                }
            }
        },
        {
            key: "_getNewTargetNode",
            value: function _getNewTargetNode(x, y) {
                var controlNodeStyle = $bebd28704f2536ea$var$deepExtend({}, this.options.controlNodeStyle);
                controlNodeStyle.id = "targetNode" + $bebd28704f2536ea$var$v4();
                controlNodeStyle.hidden = false;
                controlNodeStyle.physics = false;
                controlNodeStyle.x = x;
                controlNodeStyle.y = y;
                // we have to define the bounding box in order for the nodes to be drawn immediately
                var node = this.body.functions.createNode(controlNodeStyle);
                node.shape.boundingBox = {
                    left: x,
                    right: x,
                    top: y,
                    bottom: y
                };
                return node;
            }
        },
        {
            key: "_createEditButton",
            value: function _createEditButton() {
                var _context18;
                // restore everything to it's original state (if applicable)
                this._clean();
                // reset the manipulationDOM
                this.manipulationDOM = {};
                // empty the editModeDiv
                $bebd28704f2536ea$var$recursiveDOMDelete(this.editModeDiv);
                // create the contents for the editMode button
                var locale = this.options.locales[this.options.locale];
                var button = this._createButton("editMode", "vis-edit vis-edit-mode", locale["edit"] || this.options.locales["en"]["edit"]);
                this.editModeDiv.appendChild(button);
                // bind a hammer listener to the button, calling the function toggleEditMode.
                this._bindElementEvents(button, $bebd28704f2536ea$var$_bindInstanceProperty$1(_context18 = this.toggleEditMode).call(_context18, this));
            }
        },
        {
            key: "_clean",
            value: function _clean() {
                // not in mode
                this.inMode = false;
                // _clean the divs
                if (this.guiEnabled === true) {
                    $bebd28704f2536ea$var$recursiveDOMDelete(this.editModeDiv);
                    $bebd28704f2536ea$var$recursiveDOMDelete(this.manipulationDiv);
                    // removes all the bindings and overloads
                    this._cleanupDOMEventListeners();
                }
                // remove temporary nodes and edges
                this._cleanupTemporaryNodesAndEdges();
                // restore overloaded UI functions
                this._unbindTemporaryUIs();
                // remove the temporaryEventFunctions
                this._unbindTemporaryEvents();
                // restore the physics if required
                this.body.emitter.emit("restorePhysics");
            }
        },
        {
            key: "_cleanupDOMEventListeners",
            value: function _cleanupDOMEventListeners() {
                var _context19;
                // _clean DOM event listener bindings
                var _iterator = $bebd28704f2536ea$var$_createForOfIteratorHelper($bebd28704f2536ea$var$_spliceInstanceProperty(_context19 = this._domEventListenerCleanupQueue).call(_context19, 0)), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var callback = _step.value;
                        callback();
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        },
        {
            key: "_removeManipulationDOM",
            value: function _removeManipulationDOM() {
                // removes all the bindings and overloads
                this._clean();
                // empty the manipulation divs
                $bebd28704f2536ea$var$recursiveDOMDelete(this.manipulationDiv);
                $bebd28704f2536ea$var$recursiveDOMDelete(this.editModeDiv);
                $bebd28704f2536ea$var$recursiveDOMDelete(this.closeDiv);
                // remove the manipulation divs
                if (this.manipulationDiv) this.canvas.frame.removeChild(this.manipulationDiv);
                if (this.editModeDiv) this.canvas.frame.removeChild(this.editModeDiv);
                if (this.closeDiv) this.canvas.frame.removeChild(this.closeDiv);
                // set the references to undefined
                this.manipulationDiv = undefined;
                this.editModeDiv = undefined;
                this.closeDiv = undefined;
            }
        },
        {
            key: "_createSeperator",
            value: function _createSeperator() {
                var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
                this.manipulationDOM["seperatorLineDiv" + index] = document.createElement("div");
                this.manipulationDOM["seperatorLineDiv" + index].className = "vis-separator-line";
                this.manipulationDiv.appendChild(this.manipulationDOM["seperatorLineDiv" + index]);
            }
        },
        {
            key: "_createAddNodeButton",
            value: function _createAddNodeButton(locale) {
                var _context20;
                var button = this._createButton("addNode", "vis-add", locale["addNode"] || this.options.locales["en"]["addNode"]);
                this.manipulationDiv.appendChild(button);
                this._bindElementEvents(button, $bebd28704f2536ea$var$_bindInstanceProperty$1(_context20 = this.addNodeMode).call(_context20, this));
            }
        },
        {
            key: "_createAddEdgeButton",
            value: function _createAddEdgeButton(locale) {
                var _context21;
                var button = this._createButton("addEdge", "vis-connect", locale["addEdge"] || this.options.locales["en"]["addEdge"]);
                this.manipulationDiv.appendChild(button);
                this._bindElementEvents(button, $bebd28704f2536ea$var$_bindInstanceProperty$1(_context21 = this.addEdgeMode).call(_context21, this));
            }
        },
        {
            key: "_createEditNodeButton",
            value: function _createEditNodeButton(locale) {
                var _context22;
                var button = this._createButton("editNode", "vis-edit", locale["editNode"] || this.options.locales["en"]["editNode"]);
                this.manipulationDiv.appendChild(button);
                this._bindElementEvents(button, $bebd28704f2536ea$var$_bindInstanceProperty$1(_context22 = this.editNode).call(_context22, this));
            }
        },
        {
            key: "_createEditEdgeButton",
            value: function _createEditEdgeButton(locale) {
                var _context23;
                var button = this._createButton("editEdge", "vis-edit", locale["editEdge"] || this.options.locales["en"]["editEdge"]);
                this.manipulationDiv.appendChild(button);
                this._bindElementEvents(button, $bebd28704f2536ea$var$_bindInstanceProperty$1(_context23 = this.editEdgeMode).call(_context23, this));
            }
        },
        {
            key: "_createDeleteButton",
            value: function _createDeleteButton(locale) {
                var _context24;
                var deleteBtnClass;
                if (this.options.rtl) deleteBtnClass = "vis-delete-rtl";
                else deleteBtnClass = "vis-delete";
                var button = this._createButton("delete", deleteBtnClass, locale["del"] || this.options.locales["en"]["del"]);
                this.manipulationDiv.appendChild(button);
                this._bindElementEvents(button, $bebd28704f2536ea$var$_bindInstanceProperty$1(_context24 = this.deleteSelected).call(_context24, this));
            }
        },
        {
            key: "_createBackButton",
            value: function _createBackButton(locale) {
                var _context25;
                var button = this._createButton("back", "vis-back", locale["back"] || this.options.locales["en"]["back"]);
                this.manipulationDiv.appendChild(button);
                this._bindElementEvents(button, $bebd28704f2536ea$var$_bindInstanceProperty$1(_context25 = this.showManipulatorToolbar).call(_context25, this));
            }
        },
        {
            key: "_createButton",
            value: function _createButton(id, className, label) {
                var labelClassName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "vis-label";
                this.manipulationDOM[id + "Div"] = document.createElement("button");
                this.manipulationDOM[id + "Div"].className = "vis-button " + className;
                this.manipulationDOM[id + "Label"] = document.createElement("div");
                this.manipulationDOM[id + "Label"].className = labelClassName;
                this.manipulationDOM[id + "Label"].innerText = label;
                this.manipulationDOM[id + "Div"].appendChild(this.manipulationDOM[id + "Label"]);
                return this.manipulationDOM[id + "Div"];
            }
        },
        {
            key: "_createDescription",
            value: function _createDescription(label) {
                this.manipulationDOM["descriptionLabel"] = document.createElement("div");
                this.manipulationDOM["descriptionLabel"].className = "vis-none";
                this.manipulationDOM["descriptionLabel"].innerText = label;
                this.manipulationDiv.appendChild(this.manipulationDOM["descriptionLabel"]);
            }
        },
        {
            key: "_temporaryBindEvent",
            value: function _temporaryBindEvent(event, newFunction) {
                this.temporaryEventFunctions.push({
                    event: event,
                    boundFunction: newFunction
                });
                this.body.emitter.on(event, newFunction);
            }
        },
        {
            key: "_temporaryBindUI",
            value: function _temporaryBindUI(UIfunctionName, newFunction) {
                if (this.body.eventListeners[UIfunctionName] !== undefined) {
                    this.temporaryUIFunctions[UIfunctionName] = this.body.eventListeners[UIfunctionName];
                    this.body.eventListeners[UIfunctionName] = newFunction;
                } else throw new Error("This UI function does not exist. Typo? You tried: " + UIfunctionName + " possible are: " + $bebd28704f2536ea$var$_JSON$stringify($bebd28704f2536ea$var$_Object$keys(this.body.eventListeners)));
            }
        },
        {
            key: "_unbindTemporaryUIs",
            value: function _unbindTemporaryUIs() {
                for(var functionName in this.temporaryUIFunctions)if (Object.prototype.hasOwnProperty.call(this.temporaryUIFunctions, functionName)) {
                    this.body.eventListeners[functionName] = this.temporaryUIFunctions[functionName];
                    delete this.temporaryUIFunctions[functionName];
                }
                this.temporaryUIFunctions = {};
            }
        },
        {
            key: "_unbindTemporaryEvents",
            value: function _unbindTemporaryEvents() {
                for(var i = 0; i < this.temporaryEventFunctions.length; i++){
                    var eventName = this.temporaryEventFunctions[i].event;
                    var boundFunction = this.temporaryEventFunctions[i].boundFunction;
                    this.body.emitter.off(eventName, boundFunction);
                }
                this.temporaryEventFunctions = [];
            }
        },
        {
            key: "_bindElementEvents",
            value: function _bindElementEvents(domElement, boundFunction) {
                // Bind touch events.
                var hammer = new $bebd28704f2536ea$var$Hammer(domElement, {});
                $bebd28704f2536ea$var$onTouch(hammer, boundFunction);
                this._domEventListenerCleanupQueue.push(function() {
                    hammer.destroy();
                });
                // Bind keyboard events.
                var keyupListener = function keyupListener(_ref) {
                    var keyCode = _ref.keyCode, key = _ref.key;
                    if (key === "Enter" || key === " " || keyCode === 13 || keyCode === 32) boundFunction();
                };
                domElement.addEventListener("keyup", keyupListener, false);
                this._domEventListenerCleanupQueue.push(function() {
                    domElement.removeEventListener("keyup", keyupListener, false);
                });
            }
        },
        {
            key: "_cleanupTemporaryNodesAndEdges",
            value: function _cleanupTemporaryNodesAndEdges() {
                // _clean temporary edges
                for(var i = 0; i < this.temporaryIds.edges.length; i++){
                    var _context26;
                    this.body.edges[this.temporaryIds.edges[i]].disconnect();
                    delete this.body.edges[this.temporaryIds.edges[i]];
                    var indexTempEdge = $bebd28704f2536ea$var$_indexOfInstanceProperty(_context26 = this.body.edgeIndices).call(_context26, this.temporaryIds.edges[i]);
                    if (indexTempEdge !== -1) {
                        var _context27;
                        $bebd28704f2536ea$var$_spliceInstanceProperty(_context27 = this.body.edgeIndices).call(_context27, indexTempEdge, 1);
                    }
                }
                // _clean temporary nodes
                for(var _i = 0; _i < this.temporaryIds.nodes.length; _i++){
                    var _context28;
                    delete this.body.nodes[this.temporaryIds.nodes[_i]];
                    var indexTempNode = $bebd28704f2536ea$var$_indexOfInstanceProperty(_context28 = this.body.nodeIndices).call(_context28, this.temporaryIds.nodes[_i]);
                    if (indexTempNode !== -1) {
                        var _context29;
                        $bebd28704f2536ea$var$_spliceInstanceProperty(_context29 = this.body.nodeIndices).call(_context29, indexTempNode, 1);
                    }
                }
                this.temporaryIds = {
                    nodes: [],
                    edges: []
                };
            }
        },
        {
            key: "_controlNodeTouch",
            value: function _controlNodeTouch(event) {
                this.selectionHandler.unselectAll();
                this.lastTouch = this.body.functions.getPointer(event.center);
                this.lastTouch.translation = $bebd28704f2536ea$var$_Object$assign({}, this.body.view.translation); // copy the object
            }
        },
        {
            key: "_controlNodeDragStart",
            value: function _controlNodeDragStart() {
                var pointer = this.lastTouch;
                var pointerObj = this.selectionHandler._pointerToPositionObject(pointer);
                var from = this.body.nodes[this.temporaryIds.nodes[0]];
                var to = this.body.nodes[this.temporaryIds.nodes[1]];
                var edge = this.body.edges[this.edgeBeingEditedId];
                this.selectedControlNode = undefined;
                var fromSelect = from.isOverlappingWith(pointerObj);
                var toSelect = to.isOverlappingWith(pointerObj);
                if (fromSelect === true) {
                    this.selectedControlNode = from;
                    edge.edgeType.from = from;
                } else if (toSelect === true) {
                    this.selectedControlNode = to;
                    edge.edgeType.to = to;
                }
                // we use the selection to find the node that is being dragged. We explicitly select it here.
                if (this.selectedControlNode !== undefined) this.selectionHandler.selectObject(this.selectedControlNode);
                this.body.emitter.emit("_redraw");
            }
        },
        {
            key: "_controlNodeDrag",
            value: function _controlNodeDrag(event) {
                this.body.emitter.emit("disablePhysics");
                var pointer = this.body.functions.getPointer(event.center);
                var pos = this.canvas.DOMtoCanvas(pointer);
                if (this.selectedControlNode !== undefined) {
                    this.selectedControlNode.x = pos.x;
                    this.selectedControlNode.y = pos.y;
                } else this.interactionHandler.onDrag(event);
                this.body.emitter.emit("_redraw");
            }
        },
        {
            key: "_controlNodeDragEnd",
            value: function _controlNodeDragEnd(event) {
                var pointer = this.body.functions.getPointer(event.center);
                var pointerObj = this.selectionHandler._pointerToPositionObject(pointer);
                var edge = this.body.edges[this.edgeBeingEditedId];
                // if the node that was dragged is not a control node, return
                if (this.selectedControlNode === undefined) return;
                // we use the selection to find the node that is being dragged. We explicitly DEselect the control node here.
                this.selectionHandler.unselectAll();
                var overlappingNodeIds = this.selectionHandler._getAllNodesOverlappingWith(pointerObj);
                var node = undefined;
                for(var i = overlappingNodeIds.length - 1; i >= 0; i--)if (overlappingNodeIds[i] !== this.selectedControlNode.id) {
                    node = this.body.nodes[overlappingNodeIds[i]];
                    break;
                }
                // perform the connection
                if (node !== undefined && this.selectedControlNode !== undefined) {
                    if (node.isCluster === true) alert(this.options.locales[this.options.locale]["createEdgeError"] || this.options.locales["en"]["createEdgeError"]);
                    else {
                        var from = this.body.nodes[this.temporaryIds.nodes[0]];
                        if (this.selectedControlNode.id === from.id) this._performEditEdge(node.id, edge.to.id);
                        else this._performEditEdge(edge.from.id, node.id);
                    }
                } else {
                    edge.updateEdgeType();
                    this.body.emitter.emit("restorePhysics");
                }
                this.body.emitter.emit("_redraw");
            }
        },
        {
            key: "_handleConnect",
            value: function _handleConnect(event) {
                // check to avoid double fireing of this function.
                if (new Date().valueOf() - this.touchTime > 100) {
                    this.lastTouch = this.body.functions.getPointer(event.center);
                    this.lastTouch.translation = $bebd28704f2536ea$var$_Object$assign({}, this.body.view.translation); // copy the object
                    this.interactionHandler.drag.pointer = this.lastTouch; // Drag pointer is not updated when adding edges
                    this.interactionHandler.drag.translation = this.lastTouch.translation;
                    var pointer = this.lastTouch;
                    var node = this.selectionHandler.getNodeAt(pointer);
                    if (node !== undefined) {
                        if (node.isCluster === true) alert(this.options.locales[this.options.locale]["createEdgeError"] || this.options.locales["en"]["createEdgeError"]);
                        else {
                            // create a node the temporary line can look at
                            var targetNode = this._getNewTargetNode(node.x, node.y);
                            this.body.nodes[targetNode.id] = targetNode;
                            this.body.nodeIndices.push(targetNode.id);
                            // create a temporary edge
                            var connectionEdge = this.body.functions.createEdge({
                                id: "connectionEdge" + $bebd28704f2536ea$var$v4(),
                                from: node.id,
                                to: targetNode.id,
                                physics: false,
                                smooth: {
                                    enabled: true,
                                    type: "continuous",
                                    roundness: 0.5
                                }
                            });
                            this.body.edges[connectionEdge.id] = connectionEdge;
                            this.body.edgeIndices.push(connectionEdge.id);
                            this.temporaryIds.nodes.push(targetNode.id);
                            this.temporaryIds.edges.push(connectionEdge.id);
                        }
                    }
                    this.touchTime = new Date().valueOf();
                }
            }
        },
        {
            key: "_dragControlNode",
            value: function _dragControlNode(event) {
                var pointer = this.body.functions.getPointer(event.center);
                var pointerObj = this.selectionHandler._pointerToPositionObject(pointer);
                // remember the edge id
                var connectFromId = undefined;
                if (this.temporaryIds.edges[0] !== undefined) connectFromId = this.body.edges[this.temporaryIds.edges[0]].fromId;
                // get the overlapping node but NOT the temporary node;
                var overlappingNodeIds = this.selectionHandler._getAllNodesOverlappingWith(pointerObj);
                var node = undefined;
                for(var i = overlappingNodeIds.length - 1; i >= 0; i--){
                    var _context30;
                    // if the node id is NOT a temporary node, accept the node.
                    if ($bebd28704f2536ea$var$_indexOfInstanceProperty(_context30 = this.temporaryIds.nodes).call(_context30, overlappingNodeIds[i]) === -1) {
                        node = this.body.nodes[overlappingNodeIds[i]];
                        break;
                    }
                }
                event.controlEdge = {
                    from: connectFromId,
                    to: node ? node.id : undefined
                };
                this.selectionHandler.generateClickEvent("controlNodeDragging", event, pointer);
                if (this.temporaryIds.nodes[0] !== undefined) {
                    var targetNode = this.body.nodes[this.temporaryIds.nodes[0]]; // there is only one temp node in the add edge mode.
                    targetNode.x = this.canvas._XconvertDOMtoCanvas(pointer.x);
                    targetNode.y = this.canvas._YconvertDOMtoCanvas(pointer.y);
                    this.body.emitter.emit("_redraw");
                } else this.interactionHandler.onDrag(event);
            }
        },
        {
            key: "_finishConnect",
            value: function _finishConnect(event) {
                var pointer = this.body.functions.getPointer(event.center);
                var pointerObj = this.selectionHandler._pointerToPositionObject(pointer);
                // remember the edge id
                var connectFromId = undefined;
                if (this.temporaryIds.edges[0] !== undefined) connectFromId = this.body.edges[this.temporaryIds.edges[0]].fromId;
                // get the overlapping node but NOT the temporary node;
                var overlappingNodeIds = this.selectionHandler._getAllNodesOverlappingWith(pointerObj);
                var node = undefined;
                for(var i = overlappingNodeIds.length - 1; i >= 0; i--){
                    var _context31;
                    // if the node id is NOT a temporary node, accept the node.
                    if ($bebd28704f2536ea$var$_indexOfInstanceProperty(_context31 = this.temporaryIds.nodes).call(_context31, overlappingNodeIds[i]) === -1) {
                        node = this.body.nodes[overlappingNodeIds[i]];
                        break;
                    }
                }
                // clean temporary nodes and edges.
                this._cleanupTemporaryNodesAndEdges();
                // perform the connection
                if (node !== undefined) {
                    if (node.isCluster === true) alert(this.options.locales[this.options.locale]["createEdgeError"] || this.options.locales["en"]["createEdgeError"]);
                    else if (this.body.nodes[connectFromId] !== undefined && this.body.nodes[node.id] !== undefined) this._performAddEdge(connectFromId, node.id);
                }
                event.controlEdge = {
                    from: connectFromId,
                    to: node ? node.id : undefined
                };
                this.selectionHandler.generateClickEvent("controlNodeDragEnd", event, pointer);
                // No need to do _generateclickevent('dragEnd') here, the regular dragEnd event fires.
                this.body.emitter.emit("_redraw");
            }
        },
        {
            key: "_dragStartEdge",
            value: function _dragStartEdge(event) {
                var pointer = this.lastTouch;
                this.selectionHandler.generateClickEvent("dragStart", event, pointer, undefined, true);
            }
        },
        {
            key: "_performAddNode",
            value: function _performAddNode(clickData) {
                var _this4 = this;
                var defaultData = {
                    id: $bebd28704f2536ea$var$v4(),
                    x: clickData.pointer.canvas.x,
                    y: clickData.pointer.canvas.y,
                    label: "new"
                };
                if (typeof this.options.addNode === "function") {
                    if (this.options.addNode.length === 2) this.options.addNode(defaultData, function(finalizedData) {
                        if (finalizedData !== null && finalizedData !== undefined && _this4.inMode === "addNode") // if for whatever reason the mode has changes (due to dataset change) disregard the callback
                        _this4.body.data.nodes.getDataSet().add(finalizedData);
                        _this4.showManipulatorToolbar();
                    });
                    else {
                        this.showManipulatorToolbar();
                        throw new Error("The function for add does not support two arguments (data,callback)");
                    }
                } else {
                    this.body.data.nodes.getDataSet().add(defaultData);
                    this.showManipulatorToolbar();
                }
            }
        },
        {
            key: "_performAddEdge",
            value: function _performAddEdge(sourceNodeId, targetNodeId) {
                var _this5 = this;
                var defaultData = {
                    from: sourceNodeId,
                    to: targetNodeId
                };
                if (typeof this.options.addEdge === "function") {
                    if (this.options.addEdge.length === 2) this.options.addEdge(defaultData, function(finalizedData) {
                        if (finalizedData !== null && finalizedData !== undefined && _this5.inMode === "addEdge") {
                            // if for whatever reason the mode has changes (due to dataset change) disregard the callback
                            _this5.body.data.edges.getDataSet().add(finalizedData);
                            _this5.selectionHandler.unselectAll();
                            _this5.showManipulatorToolbar();
                        }
                    });
                    else throw new Error("The function for connect does not support two arguments (data,callback)");
                } else {
                    this.body.data.edges.getDataSet().add(defaultData);
                    this.selectionHandler.unselectAll();
                    this.showManipulatorToolbar();
                }
            }
        },
        {
            key: "_performEditEdge",
            value: function _performEditEdge(sourceNodeId, targetNodeId) {
                var _this6 = this;
                var defaultData = {
                    id: this.edgeBeingEditedId,
                    from: sourceNodeId,
                    to: targetNodeId,
                    label: this.body.data.edges.get(this.edgeBeingEditedId).label
                };
                var eeFunct = this.options.editEdge;
                if ($bebd28704f2536ea$var$_typeof(eeFunct) === "object") eeFunct = eeFunct.editWithoutDrag;
                if (typeof eeFunct === "function") {
                    if (eeFunct.length === 2) eeFunct(defaultData, function(finalizedData) {
                        if (finalizedData === null || finalizedData === undefined || _this6.inMode !== "editEdge") {
                            // if for whatever reason the mode has changes (due to dataset change) disregard the callback) {
                            _this6.body.edges[defaultData.id].updateEdgeType();
                            _this6.body.emitter.emit("_redraw");
                            _this6.showManipulatorToolbar();
                        } else {
                            _this6.body.data.edges.getDataSet().update(finalizedData);
                            _this6.selectionHandler.unselectAll();
                            _this6.showManipulatorToolbar();
                        }
                    });
                    else throw new Error("The function for edit does not support two arguments (data, callback)");
                } else {
                    this.body.data.edges.getDataSet().update(defaultData);
                    this.selectionHandler.unselectAll();
                    this.showManipulatorToolbar();
                }
            }
        }
    ]);
    return ManipulationSystem;
}();
/**
 * This object contains all possible options. It will check if the types are correct, if required if the option is one
 * of the allowed values.
 *
 * __any__ means that the name of the property does not matter.
 * __type__ is a required field for all objects and contains the allowed types of all objects
 */ var $bebd28704f2536ea$var$string = "string";
var $bebd28704f2536ea$var$bool = "boolean";
var $bebd28704f2536ea$var$number = "number";
var $bebd28704f2536ea$var$array = "array";
var $bebd28704f2536ea$var$object = "object"; // should only be in a __type__ property
var $bebd28704f2536ea$var$dom = "dom";
var $bebd28704f2536ea$var$any = "any";
// List of endpoints
var $bebd28704f2536ea$var$endPoints = [
    "arrow",
    "bar",
    "box",
    "circle",
    "crow",
    "curve",
    "diamond",
    "image",
    "inv_curve",
    "inv_triangle",
    "triangle",
    "vee"
];
/* eslint-disable @typescript-eslint/naming-convention -- The __*__ format is used to prevent collisions with actual option names. */ var $bebd28704f2536ea$var$nodeOptions = {
    borderWidth: {
        number: $bebd28704f2536ea$var$number
    },
    borderWidthSelected: {
        number: $bebd28704f2536ea$var$number,
        undefined: "undefined"
    },
    brokenImage: {
        string: $bebd28704f2536ea$var$string,
        undefined: "undefined"
    },
    chosen: {
        label: {
            boolean: $bebd28704f2536ea$var$bool,
            function: "function"
        },
        node: {
            boolean: $bebd28704f2536ea$var$bool,
            function: "function"
        },
        __type__: {
            object: $bebd28704f2536ea$var$object,
            boolean: $bebd28704f2536ea$var$bool
        }
    },
    color: {
        border: {
            string: $bebd28704f2536ea$var$string
        },
        background: {
            string: $bebd28704f2536ea$var$string
        },
        highlight: {
            border: {
                string: $bebd28704f2536ea$var$string
            },
            background: {
                string: $bebd28704f2536ea$var$string
            },
            __type__: {
                object: $bebd28704f2536ea$var$object,
                string: $bebd28704f2536ea$var$string
            }
        },
        hover: {
            border: {
                string: $bebd28704f2536ea$var$string
            },
            background: {
                string: $bebd28704f2536ea$var$string
            },
            __type__: {
                object: $bebd28704f2536ea$var$object,
                string: $bebd28704f2536ea$var$string
            }
        },
        __type__: {
            object: $bebd28704f2536ea$var$object,
            string: $bebd28704f2536ea$var$string
        }
    },
    opacity: {
        number: $bebd28704f2536ea$var$number,
        undefined: "undefined"
    },
    fixed: {
        x: {
            boolean: $bebd28704f2536ea$var$bool
        },
        y: {
            boolean: $bebd28704f2536ea$var$bool
        },
        __type__: {
            object: $bebd28704f2536ea$var$object,
            boolean: $bebd28704f2536ea$var$bool
        }
    },
    font: {
        align: {
            string: $bebd28704f2536ea$var$string
        },
        color: {
            string: $bebd28704f2536ea$var$string
        },
        size: {
            number: $bebd28704f2536ea$var$number
        },
        face: {
            string: $bebd28704f2536ea$var$string
        },
        background: {
            string: $bebd28704f2536ea$var$string
        },
        strokeWidth: {
            number: $bebd28704f2536ea$var$number
        },
        strokeColor: {
            string: $bebd28704f2536ea$var$string
        },
        vadjust: {
            number: $bebd28704f2536ea$var$number
        },
        multi: {
            boolean: $bebd28704f2536ea$var$bool,
            string: $bebd28704f2536ea$var$string
        },
        bold: {
            color: {
                string: $bebd28704f2536ea$var$string
            },
            size: {
                number: $bebd28704f2536ea$var$number
            },
            face: {
                string: $bebd28704f2536ea$var$string
            },
            mod: {
                string: $bebd28704f2536ea$var$string
            },
            vadjust: {
                number: $bebd28704f2536ea$var$number
            },
            __type__: {
                object: $bebd28704f2536ea$var$object,
                string: $bebd28704f2536ea$var$string
            }
        },
        boldital: {
            color: {
                string: $bebd28704f2536ea$var$string
            },
            size: {
                number: $bebd28704f2536ea$var$number
            },
            face: {
                string: $bebd28704f2536ea$var$string
            },
            mod: {
                string: $bebd28704f2536ea$var$string
            },
            vadjust: {
                number: $bebd28704f2536ea$var$number
            },
            __type__: {
                object: $bebd28704f2536ea$var$object,
                string: $bebd28704f2536ea$var$string
            }
        },
        ital: {
            color: {
                string: $bebd28704f2536ea$var$string
            },
            size: {
                number: $bebd28704f2536ea$var$number
            },
            face: {
                string: $bebd28704f2536ea$var$string
            },
            mod: {
                string: $bebd28704f2536ea$var$string
            },
            vadjust: {
                number: $bebd28704f2536ea$var$number
            },
            __type__: {
                object: $bebd28704f2536ea$var$object,
                string: $bebd28704f2536ea$var$string
            }
        },
        mono: {
            color: {
                string: $bebd28704f2536ea$var$string
            },
            size: {
                number: $bebd28704f2536ea$var$number
            },
            face: {
                string: $bebd28704f2536ea$var$string
            },
            mod: {
                string: $bebd28704f2536ea$var$string
            },
            vadjust: {
                number: $bebd28704f2536ea$var$number
            },
            __type__: {
                object: $bebd28704f2536ea$var$object,
                string: $bebd28704f2536ea$var$string
            }
        },
        __type__: {
            object: $bebd28704f2536ea$var$object,
            string: $bebd28704f2536ea$var$string
        }
    },
    group: {
        string: $bebd28704f2536ea$var$string,
        number: $bebd28704f2536ea$var$number,
        undefined: "undefined"
    },
    heightConstraint: {
        minimum: {
            number: $bebd28704f2536ea$var$number
        },
        valign: {
            string: $bebd28704f2536ea$var$string
        },
        __type__: {
            object: $bebd28704f2536ea$var$object,
            boolean: $bebd28704f2536ea$var$bool,
            number: $bebd28704f2536ea$var$number
        }
    },
    hidden: {
        boolean: $bebd28704f2536ea$var$bool
    },
    icon: {
        face: {
            string: $bebd28704f2536ea$var$string
        },
        code: {
            string: $bebd28704f2536ea$var$string
        },
        size: {
            number: $bebd28704f2536ea$var$number
        },
        color: {
            string: $bebd28704f2536ea$var$string
        },
        weight: {
            string: $bebd28704f2536ea$var$string,
            number: $bebd28704f2536ea$var$number
        },
        __type__: {
            object: $bebd28704f2536ea$var$object
        }
    },
    id: {
        string: $bebd28704f2536ea$var$string,
        number: $bebd28704f2536ea$var$number
    },
    image: {
        selected: {
            string: $bebd28704f2536ea$var$string,
            undefined: "undefined"
        },
        unselected: {
            string: $bebd28704f2536ea$var$string,
            undefined: "undefined"
        },
        __type__: {
            object: $bebd28704f2536ea$var$object,
            string: $bebd28704f2536ea$var$string
        }
    },
    imagePadding: {
        top: {
            number: $bebd28704f2536ea$var$number
        },
        right: {
            number: $bebd28704f2536ea$var$number
        },
        bottom: {
            number: $bebd28704f2536ea$var$number
        },
        left: {
            number: $bebd28704f2536ea$var$number
        },
        __type__: {
            object: $bebd28704f2536ea$var$object,
            number: $bebd28704f2536ea$var$number
        }
    },
    label: {
        string: $bebd28704f2536ea$var$string,
        undefined: "undefined"
    },
    labelHighlightBold: {
        boolean: $bebd28704f2536ea$var$bool
    },
    level: {
        number: $bebd28704f2536ea$var$number,
        undefined: "undefined"
    },
    margin: {
        top: {
            number: $bebd28704f2536ea$var$number
        },
        right: {
            number: $bebd28704f2536ea$var$number
        },
        bottom: {
            number: $bebd28704f2536ea$var$number
        },
        left: {
            number: $bebd28704f2536ea$var$number
        },
        __type__: {
            object: $bebd28704f2536ea$var$object,
            number: $bebd28704f2536ea$var$number
        }
    },
    mass: {
        number: $bebd28704f2536ea$var$number
    },
    physics: {
        boolean: $bebd28704f2536ea$var$bool
    },
    scaling: {
        min: {
            number: $bebd28704f2536ea$var$number
        },
        max: {
            number: $bebd28704f2536ea$var$number
        },
        label: {
            enabled: {
                boolean: $bebd28704f2536ea$var$bool
            },
            min: {
                number: $bebd28704f2536ea$var$number
            },
            max: {
                number: $bebd28704f2536ea$var$number
            },
            maxVisible: {
                number: $bebd28704f2536ea$var$number
            },
            drawThreshold: {
                number: $bebd28704f2536ea$var$number
            },
            __type__: {
                object: $bebd28704f2536ea$var$object,
                boolean: $bebd28704f2536ea$var$bool
            }
        },
        customScalingFunction: {
            function: "function"
        },
        __type__: {
            object: $bebd28704f2536ea$var$object
        }
    },
    shadow: {
        enabled: {
            boolean: $bebd28704f2536ea$var$bool
        },
        color: {
            string: $bebd28704f2536ea$var$string
        },
        size: {
            number: $bebd28704f2536ea$var$number
        },
        x: {
            number: $bebd28704f2536ea$var$number
        },
        y: {
            number: $bebd28704f2536ea$var$number
        },
        __type__: {
            object: $bebd28704f2536ea$var$object,
            boolean: $bebd28704f2536ea$var$bool
        }
    },
    shape: {
        string: [
            "custom",
            "ellipse",
            "circle",
            "database",
            "box",
            "text",
            "image",
            "circularImage",
            "diamond",
            "dot",
            "star",
            "triangle",
            "triangleDown",
            "square",
            "icon",
            "hexagon"
        ]
    },
    ctxRenderer: {
        function: "function"
    },
    shapeProperties: {
        borderDashes: {
            boolean: $bebd28704f2536ea$var$bool,
            array: $bebd28704f2536ea$var$array
        },
        borderRadius: {
            number: $bebd28704f2536ea$var$number
        },
        interpolation: {
            boolean: $bebd28704f2536ea$var$bool
        },
        useImageSize: {
            boolean: $bebd28704f2536ea$var$bool
        },
        useBorderWithImage: {
            boolean: $bebd28704f2536ea$var$bool
        },
        coordinateOrigin: {
            string: [
                "center",
                "top-left"
            ]
        },
        __type__: {
            object: $bebd28704f2536ea$var$object
        }
    },
    size: {
        number: $bebd28704f2536ea$var$number
    },
    title: {
        string: $bebd28704f2536ea$var$string,
        dom: $bebd28704f2536ea$var$dom,
        undefined: "undefined"
    },
    value: {
        number: $bebd28704f2536ea$var$number,
        undefined: "undefined"
    },
    widthConstraint: {
        minimum: {
            number: $bebd28704f2536ea$var$number
        },
        maximum: {
            number: $bebd28704f2536ea$var$number
        },
        __type__: {
            object: $bebd28704f2536ea$var$object,
            boolean: $bebd28704f2536ea$var$bool,
            number: $bebd28704f2536ea$var$number
        }
    },
    x: {
        number: $bebd28704f2536ea$var$number
    },
    y: {
        number: $bebd28704f2536ea$var$number
    },
    __type__: {
        object: $bebd28704f2536ea$var$object
    }
};
var $bebd28704f2536ea$var$allOptions = {
    configure: {
        enabled: {
            boolean: $bebd28704f2536ea$var$bool
        },
        filter: {
            boolean: $bebd28704f2536ea$var$bool,
            string: $bebd28704f2536ea$var$string,
            array: $bebd28704f2536ea$var$array,
            function: "function"
        },
        container: {
            dom: $bebd28704f2536ea$var$dom
        },
        showButton: {
            boolean: $bebd28704f2536ea$var$bool
        },
        __type__: {
            object: $bebd28704f2536ea$var$object,
            boolean: $bebd28704f2536ea$var$bool,
            string: $bebd28704f2536ea$var$string,
            array: $bebd28704f2536ea$var$array,
            function: "function"
        }
    },
    edges: {
        arrows: {
            to: {
                enabled: {
                    boolean: $bebd28704f2536ea$var$bool
                },
                scaleFactor: {
                    number: $bebd28704f2536ea$var$number
                },
                type: {
                    string: $bebd28704f2536ea$var$endPoints
                },
                imageHeight: {
                    number: $bebd28704f2536ea$var$number
                },
                imageWidth: {
                    number: $bebd28704f2536ea$var$number
                },
                src: {
                    string: $bebd28704f2536ea$var$string
                },
                __type__: {
                    object: $bebd28704f2536ea$var$object,
                    boolean: $bebd28704f2536ea$var$bool
                }
            },
            middle: {
                enabled: {
                    boolean: $bebd28704f2536ea$var$bool
                },
                scaleFactor: {
                    number: $bebd28704f2536ea$var$number
                },
                type: {
                    string: $bebd28704f2536ea$var$endPoints
                },
                imageWidth: {
                    number: $bebd28704f2536ea$var$number
                },
                imageHeight: {
                    number: $bebd28704f2536ea$var$number
                },
                src: {
                    string: $bebd28704f2536ea$var$string
                },
                __type__: {
                    object: $bebd28704f2536ea$var$object,
                    boolean: $bebd28704f2536ea$var$bool
                }
            },
            from: {
                enabled: {
                    boolean: $bebd28704f2536ea$var$bool
                },
                scaleFactor: {
                    number: $bebd28704f2536ea$var$number
                },
                type: {
                    string: $bebd28704f2536ea$var$endPoints
                },
                imageWidth: {
                    number: $bebd28704f2536ea$var$number
                },
                imageHeight: {
                    number: $bebd28704f2536ea$var$number
                },
                src: {
                    string: $bebd28704f2536ea$var$string
                },
                __type__: {
                    object: $bebd28704f2536ea$var$object,
                    boolean: $bebd28704f2536ea$var$bool
                }
            },
            __type__: {
                string: [
                    "from",
                    "to",
                    "middle"
                ],
                object: $bebd28704f2536ea$var$object
            }
        },
        endPointOffset: {
            from: {
                number: $bebd28704f2536ea$var$number
            },
            to: {
                number: $bebd28704f2536ea$var$number
            },
            __type__: {
                object: $bebd28704f2536ea$var$object,
                number: $bebd28704f2536ea$var$number
            }
        },
        arrowStrikethrough: {
            boolean: $bebd28704f2536ea$var$bool
        },
        background: {
            enabled: {
                boolean: $bebd28704f2536ea$var$bool
            },
            color: {
                string: $bebd28704f2536ea$var$string
            },
            size: {
                number: $bebd28704f2536ea$var$number
            },
            dashes: {
                boolean: $bebd28704f2536ea$var$bool,
                array: $bebd28704f2536ea$var$array
            },
            __type__: {
                object: $bebd28704f2536ea$var$object,
                boolean: $bebd28704f2536ea$var$bool
            }
        },
        chosen: {
            label: {
                boolean: $bebd28704f2536ea$var$bool,
                function: "function"
            },
            edge: {
                boolean: $bebd28704f2536ea$var$bool,
                function: "function"
            },
            __type__: {
                object: $bebd28704f2536ea$var$object,
                boolean: $bebd28704f2536ea$var$bool
            }
        },
        color: {
            color: {
                string: $bebd28704f2536ea$var$string
            },
            highlight: {
                string: $bebd28704f2536ea$var$string
            },
            hover: {
                string: $bebd28704f2536ea$var$string
            },
            inherit: {
                string: [
                    "from",
                    "to",
                    "both"
                ],
                boolean: $bebd28704f2536ea$var$bool
            },
            opacity: {
                number: $bebd28704f2536ea$var$number
            },
            __type__: {
                object: $bebd28704f2536ea$var$object,
                string: $bebd28704f2536ea$var$string
            }
        },
        dashes: {
            boolean: $bebd28704f2536ea$var$bool,
            array: $bebd28704f2536ea$var$array
        },
        font: {
            color: {
                string: $bebd28704f2536ea$var$string
            },
            size: {
                number: $bebd28704f2536ea$var$number
            },
            face: {
                string: $bebd28704f2536ea$var$string
            },
            background: {
                string: $bebd28704f2536ea$var$string
            },
            strokeWidth: {
                number: $bebd28704f2536ea$var$number
            },
            strokeColor: {
                string: $bebd28704f2536ea$var$string
            },
            align: {
                string: [
                    "horizontal",
                    "top",
                    "middle",
                    "bottom"
                ]
            },
            vadjust: {
                number: $bebd28704f2536ea$var$number
            },
            multi: {
                boolean: $bebd28704f2536ea$var$bool,
                string: $bebd28704f2536ea$var$string
            },
            bold: {
                color: {
                    string: $bebd28704f2536ea$var$string
                },
                size: {
                    number: $bebd28704f2536ea$var$number
                },
                face: {
                    string: $bebd28704f2536ea$var$string
                },
                mod: {
                    string: $bebd28704f2536ea$var$string
                },
                vadjust: {
                    number: $bebd28704f2536ea$var$number
                },
                __type__: {
                    object: $bebd28704f2536ea$var$object,
                    string: $bebd28704f2536ea$var$string
                }
            },
            boldital: {
                color: {
                    string: $bebd28704f2536ea$var$string
                },
                size: {
                    number: $bebd28704f2536ea$var$number
                },
                face: {
                    string: $bebd28704f2536ea$var$string
                },
                mod: {
                    string: $bebd28704f2536ea$var$string
                },
                vadjust: {
                    number: $bebd28704f2536ea$var$number
                },
                __type__: {
                    object: $bebd28704f2536ea$var$object,
                    string: $bebd28704f2536ea$var$string
                }
            },
            ital: {
                color: {
                    string: $bebd28704f2536ea$var$string
                },
                size: {
                    number: $bebd28704f2536ea$var$number
                },
                face: {
                    string: $bebd28704f2536ea$var$string
                },
                mod: {
                    string: $bebd28704f2536ea$var$string
                },
                vadjust: {
                    number: $bebd28704f2536ea$var$number
                },
                __type__: {
                    object: $bebd28704f2536ea$var$object,
                    string: $bebd28704f2536ea$var$string
                }
            },
            mono: {
                color: {
                    string: $bebd28704f2536ea$var$string
                },
                size: {
                    number: $bebd28704f2536ea$var$number
                },
                face: {
                    string: $bebd28704f2536ea$var$string
                },
                mod: {
                    string: $bebd28704f2536ea$var$string
                },
                vadjust: {
                    number: $bebd28704f2536ea$var$number
                },
                __type__: {
                    object: $bebd28704f2536ea$var$object,
                    string: $bebd28704f2536ea$var$string
                }
            },
            __type__: {
                object: $bebd28704f2536ea$var$object,
                string: $bebd28704f2536ea$var$string
            }
        },
        hidden: {
            boolean: $bebd28704f2536ea$var$bool
        },
        hoverWidth: {
            function: "function",
            number: $bebd28704f2536ea$var$number
        },
        label: {
            string: $bebd28704f2536ea$var$string,
            undefined: "undefined"
        },
        labelHighlightBold: {
            boolean: $bebd28704f2536ea$var$bool
        },
        length: {
            number: $bebd28704f2536ea$var$number,
            undefined: "undefined"
        },
        physics: {
            boolean: $bebd28704f2536ea$var$bool
        },
        scaling: {
            min: {
                number: $bebd28704f2536ea$var$number
            },
            max: {
                number: $bebd28704f2536ea$var$number
            },
            label: {
                enabled: {
                    boolean: $bebd28704f2536ea$var$bool
                },
                min: {
                    number: $bebd28704f2536ea$var$number
                },
                max: {
                    number: $bebd28704f2536ea$var$number
                },
                maxVisible: {
                    number: $bebd28704f2536ea$var$number
                },
                drawThreshold: {
                    number: $bebd28704f2536ea$var$number
                },
                __type__: {
                    object: $bebd28704f2536ea$var$object,
                    boolean: $bebd28704f2536ea$var$bool
                }
            },
            customScalingFunction: {
                function: "function"
            },
            __type__: {
                object: $bebd28704f2536ea$var$object
            }
        },
        selectionWidth: {
            function: "function",
            number: $bebd28704f2536ea$var$number
        },
        selfReferenceSize: {
            number: $bebd28704f2536ea$var$number
        },
        selfReference: {
            size: {
                number: $bebd28704f2536ea$var$number
            },
            angle: {
                number: $bebd28704f2536ea$var$number
            },
            renderBehindTheNode: {
                boolean: $bebd28704f2536ea$var$bool
            },
            __type__: {
                object: $bebd28704f2536ea$var$object
            }
        },
        shadow: {
            enabled: {
                boolean: $bebd28704f2536ea$var$bool
            },
            color: {
                string: $bebd28704f2536ea$var$string
            },
            size: {
                number: $bebd28704f2536ea$var$number
            },
            x: {
                number: $bebd28704f2536ea$var$number
            },
            y: {
                number: $bebd28704f2536ea$var$number
            },
            __type__: {
                object: $bebd28704f2536ea$var$object,
                boolean: $bebd28704f2536ea$var$bool
            }
        },
        smooth: {
            enabled: {
                boolean: $bebd28704f2536ea$var$bool
            },
            type: {
                string: [
                    "dynamic",
                    "continuous",
                    "discrete",
                    "diagonalCross",
                    "straightCross",
                    "horizontal",
                    "vertical",
                    "curvedCW",
                    "curvedCCW",
                    "cubicBezier"
                ]
            },
            roundness: {
                number: $bebd28704f2536ea$var$number
            },
            forceDirection: {
                string: [
                    "horizontal",
                    "vertical",
                    "none"
                ],
                boolean: $bebd28704f2536ea$var$bool
            },
            __type__: {
                object: $bebd28704f2536ea$var$object,
                boolean: $bebd28704f2536ea$var$bool
            }
        },
        title: {
            string: $bebd28704f2536ea$var$string,
            undefined: "undefined"
        },
        width: {
            number: $bebd28704f2536ea$var$number
        },
        widthConstraint: {
            maximum: {
                number: $bebd28704f2536ea$var$number
            },
            __type__: {
                object: $bebd28704f2536ea$var$object,
                boolean: $bebd28704f2536ea$var$bool,
                number: $bebd28704f2536ea$var$number
            }
        },
        value: {
            number: $bebd28704f2536ea$var$number,
            undefined: "undefined"
        },
        __type__: {
            object: $bebd28704f2536ea$var$object
        }
    },
    groups: {
        useDefaultGroups: {
            boolean: $bebd28704f2536ea$var$bool
        },
        __any__: $bebd28704f2536ea$var$nodeOptions,
        __type__: {
            object: $bebd28704f2536ea$var$object
        }
    },
    interaction: {
        dragNodes: {
            boolean: $bebd28704f2536ea$var$bool
        },
        dragView: {
            boolean: $bebd28704f2536ea$var$bool
        },
        hideEdgesOnDrag: {
            boolean: $bebd28704f2536ea$var$bool
        },
        hideEdgesOnZoom: {
            boolean: $bebd28704f2536ea$var$bool
        },
        hideNodesOnDrag: {
            boolean: $bebd28704f2536ea$var$bool
        },
        hover: {
            boolean: $bebd28704f2536ea$var$bool
        },
        keyboard: {
            enabled: {
                boolean: $bebd28704f2536ea$var$bool
            },
            speed: {
                x: {
                    number: $bebd28704f2536ea$var$number
                },
                y: {
                    number: $bebd28704f2536ea$var$number
                },
                zoom: {
                    number: $bebd28704f2536ea$var$number
                },
                __type__: {
                    object: $bebd28704f2536ea$var$object
                }
            },
            bindToWindow: {
                boolean: $bebd28704f2536ea$var$bool
            },
            autoFocus: {
                boolean: $bebd28704f2536ea$var$bool
            },
            __type__: {
                object: $bebd28704f2536ea$var$object,
                boolean: $bebd28704f2536ea$var$bool
            }
        },
        multiselect: {
            boolean: $bebd28704f2536ea$var$bool
        },
        navigationButtons: {
            boolean: $bebd28704f2536ea$var$bool
        },
        selectable: {
            boolean: $bebd28704f2536ea$var$bool
        },
        selectConnectedEdges: {
            boolean: $bebd28704f2536ea$var$bool
        },
        hoverConnectedEdges: {
            boolean: $bebd28704f2536ea$var$bool
        },
        tooltipDelay: {
            number: $bebd28704f2536ea$var$number
        },
        zoomView: {
            boolean: $bebd28704f2536ea$var$bool
        },
        zoomSpeed: {
            number: $bebd28704f2536ea$var$number
        },
        __type__: {
            object: $bebd28704f2536ea$var$object
        }
    },
    layout: {
        randomSeed: {
            undefined: "undefined",
            number: $bebd28704f2536ea$var$number,
            string: $bebd28704f2536ea$var$string
        },
        improvedLayout: {
            boolean: $bebd28704f2536ea$var$bool
        },
        clusterThreshold: {
            number: $bebd28704f2536ea$var$number
        },
        hierarchical: {
            enabled: {
                boolean: $bebd28704f2536ea$var$bool
            },
            levelSeparation: {
                number: $bebd28704f2536ea$var$number
            },
            nodeSpacing: {
                number: $bebd28704f2536ea$var$number
            },
            treeSpacing: {
                number: $bebd28704f2536ea$var$number
            },
            blockShifting: {
                boolean: $bebd28704f2536ea$var$bool
            },
            edgeMinimization: {
                boolean: $bebd28704f2536ea$var$bool
            },
            parentCentralization: {
                boolean: $bebd28704f2536ea$var$bool
            },
            direction: {
                string: [
                    "UD",
                    "DU",
                    "LR",
                    "RL"
                ]
            },
            sortMethod: {
                string: [
                    "hubsize",
                    "directed"
                ]
            },
            shakeTowards: {
                string: [
                    "leaves",
                    "roots"
                ]
            },
            __type__: {
                object: $bebd28704f2536ea$var$object,
                boolean: $bebd28704f2536ea$var$bool
            }
        },
        __type__: {
            object: $bebd28704f2536ea$var$object
        }
    },
    manipulation: {
        enabled: {
            boolean: $bebd28704f2536ea$var$bool
        },
        initiallyActive: {
            boolean: $bebd28704f2536ea$var$bool
        },
        addNode: {
            boolean: $bebd28704f2536ea$var$bool,
            function: "function"
        },
        addEdge: {
            boolean: $bebd28704f2536ea$var$bool,
            function: "function"
        },
        editNode: {
            function: "function"
        },
        editEdge: {
            editWithoutDrag: {
                function: "function"
            },
            __type__: {
                object: $bebd28704f2536ea$var$object,
                boolean: $bebd28704f2536ea$var$bool,
                function: "function"
            }
        },
        deleteNode: {
            boolean: $bebd28704f2536ea$var$bool,
            function: "function"
        },
        deleteEdge: {
            boolean: $bebd28704f2536ea$var$bool,
            function: "function"
        },
        controlNodeStyle: $bebd28704f2536ea$var$nodeOptions,
        __type__: {
            object: $bebd28704f2536ea$var$object,
            boolean: $bebd28704f2536ea$var$bool
        }
    },
    nodes: $bebd28704f2536ea$var$nodeOptions,
    physics: {
        enabled: {
            boolean: $bebd28704f2536ea$var$bool
        },
        barnesHut: {
            theta: {
                number: $bebd28704f2536ea$var$number
            },
            gravitationalConstant: {
                number: $bebd28704f2536ea$var$number
            },
            centralGravity: {
                number: $bebd28704f2536ea$var$number
            },
            springLength: {
                number: $bebd28704f2536ea$var$number
            },
            springConstant: {
                number: $bebd28704f2536ea$var$number
            },
            damping: {
                number: $bebd28704f2536ea$var$number
            },
            avoidOverlap: {
                number: $bebd28704f2536ea$var$number
            },
            __type__: {
                object: $bebd28704f2536ea$var$object
            }
        },
        forceAtlas2Based: {
            theta: {
                number: $bebd28704f2536ea$var$number
            },
            gravitationalConstant: {
                number: $bebd28704f2536ea$var$number
            },
            centralGravity: {
                number: $bebd28704f2536ea$var$number
            },
            springLength: {
                number: $bebd28704f2536ea$var$number
            },
            springConstant: {
                number: $bebd28704f2536ea$var$number
            },
            damping: {
                number: $bebd28704f2536ea$var$number
            },
            avoidOverlap: {
                number: $bebd28704f2536ea$var$number
            },
            __type__: {
                object: $bebd28704f2536ea$var$object
            }
        },
        repulsion: {
            centralGravity: {
                number: $bebd28704f2536ea$var$number
            },
            springLength: {
                number: $bebd28704f2536ea$var$number
            },
            springConstant: {
                number: $bebd28704f2536ea$var$number
            },
            nodeDistance: {
                number: $bebd28704f2536ea$var$number
            },
            damping: {
                number: $bebd28704f2536ea$var$number
            },
            __type__: {
                object: $bebd28704f2536ea$var$object
            }
        },
        hierarchicalRepulsion: {
            centralGravity: {
                number: $bebd28704f2536ea$var$number
            },
            springLength: {
                number: $bebd28704f2536ea$var$number
            },
            springConstant: {
                number: $bebd28704f2536ea$var$number
            },
            nodeDistance: {
                number: $bebd28704f2536ea$var$number
            },
            damping: {
                number: $bebd28704f2536ea$var$number
            },
            avoidOverlap: {
                number: $bebd28704f2536ea$var$number
            },
            __type__: {
                object: $bebd28704f2536ea$var$object
            }
        },
        maxVelocity: {
            number: $bebd28704f2536ea$var$number
        },
        minVelocity: {
            number: $bebd28704f2536ea$var$number
        },
        solver: {
            string: [
                "barnesHut",
                "repulsion",
                "hierarchicalRepulsion",
                "forceAtlas2Based"
            ]
        },
        stabilization: {
            enabled: {
                boolean: $bebd28704f2536ea$var$bool
            },
            iterations: {
                number: $bebd28704f2536ea$var$number
            },
            updateInterval: {
                number: $bebd28704f2536ea$var$number
            },
            onlyDynamicEdges: {
                boolean: $bebd28704f2536ea$var$bool
            },
            fit: {
                boolean: $bebd28704f2536ea$var$bool
            },
            __type__: {
                object: $bebd28704f2536ea$var$object,
                boolean: $bebd28704f2536ea$var$bool
            }
        },
        timestep: {
            number: $bebd28704f2536ea$var$number
        },
        adaptiveTimestep: {
            boolean: $bebd28704f2536ea$var$bool
        },
        wind: {
            x: {
                number: $bebd28704f2536ea$var$number
            },
            y: {
                number: $bebd28704f2536ea$var$number
            },
            __type__: {
                object: $bebd28704f2536ea$var$object
            }
        },
        __type__: {
            object: $bebd28704f2536ea$var$object,
            boolean: $bebd28704f2536ea$var$bool
        }
    },
    //globals :
    autoResize: {
        boolean: $bebd28704f2536ea$var$bool
    },
    clickToUse: {
        boolean: $bebd28704f2536ea$var$bool
    },
    locale: {
        string: $bebd28704f2536ea$var$string
    },
    locales: {
        __any__: {
            any: $bebd28704f2536ea$var$any
        },
        __type__: {
            object: $bebd28704f2536ea$var$object
        }
    },
    height: {
        string: $bebd28704f2536ea$var$string
    },
    width: {
        string: $bebd28704f2536ea$var$string
    },
    __type__: {
        object: $bebd28704f2536ea$var$object
    }
};
/* eslint-enable @typescript-eslint/naming-convention */ /**
 * This provides ranges, initial values, steps and dropdown menu choices for the
 * configuration.
 *
 * @remarks
 * Checkbox: `boolean`
 *   The value supllied will be used as the initial value.
 *
 * Text field: `string`
 *   The passed text will be used as the initial value. Any text will be
 *   accepted afterwards.
 *
 * Number range: `[number, number, number, number]`
 *   The meanings are `[initial value, min, max, step]`.
 *
 * Dropdown: `[Exclude<string, "color">, ...(string | number | boolean)[]]`
 *   Translations for people with poor understanding of TypeScript: the first
 *   value always has to be a string but never `"color"`, the rest can be any
 *   combination of strings, numbers and booleans.
 *
 * Color picker: `["color", string]`
 *   The first value says this will be a color picker not a dropdown menu. The
 *   next value is the initial color.
 */ var $bebd28704f2536ea$var$configureOptions = {
    nodes: {
        borderWidth: [
            1,
            0,
            10,
            1
        ],
        borderWidthSelected: [
            2,
            0,
            10,
            1
        ],
        color: {
            border: [
                "color",
                "#2B7CE9"
            ],
            background: [
                "color",
                "#97C2FC"
            ],
            highlight: {
                border: [
                    "color",
                    "#2B7CE9"
                ],
                background: [
                    "color",
                    "#D2E5FF"
                ]
            },
            hover: {
                border: [
                    "color",
                    "#2B7CE9"
                ],
                background: [
                    "color",
                    "#D2E5FF"
                ]
            }
        },
        opacity: [
            0,
            0,
            1,
            0.1
        ],
        fixed: {
            x: false,
            y: false
        },
        font: {
            color: [
                "color",
                "#343434"
            ],
            size: [
                14,
                0,
                100,
                1
            ],
            face: [
                "arial",
                "verdana",
                "tahoma"
            ],
            background: [
                "color",
                "none"
            ],
            strokeWidth: [
                0,
                0,
                50,
                1
            ],
            strokeColor: [
                "color",
                "#ffffff"
            ]
        },
        //group: 'string',
        hidden: false,
        labelHighlightBold: true,
        //icon: {
        //  face: 'string',  //'FontAwesome',
        //  code: 'string',  //'\uf007',
        //  size: [50, 0, 200, 1],  //50,
        //  color: ['color','#2B7CE9']   //'#aa00ff'
        //},
        //image: 'string', // --> URL
        physics: true,
        scaling: {
            min: [
                10,
                0,
                200,
                1
            ],
            max: [
                30,
                0,
                200,
                1
            ],
            label: {
                enabled: false,
                min: [
                    14,
                    0,
                    200,
                    1
                ],
                max: [
                    30,
                    0,
                    200,
                    1
                ],
                maxVisible: [
                    30,
                    0,
                    200,
                    1
                ],
                drawThreshold: [
                    5,
                    0,
                    20,
                    1
                ]
            }
        },
        shadow: {
            enabled: false,
            color: "rgba(0,0,0,0.5)",
            size: [
                10,
                0,
                20,
                1
            ],
            x: [
                5,
                -30,
                30,
                1
            ],
            y: [
                5,
                -30,
                30,
                1
            ]
        },
        shape: [
            "ellipse",
            "box",
            "circle",
            "database",
            "diamond",
            "dot",
            "square",
            "star",
            "text",
            "triangle",
            "triangleDown",
            "hexagon"
        ],
        shapeProperties: {
            borderDashes: false,
            borderRadius: [
                6,
                0,
                20,
                1
            ],
            interpolation: true,
            useImageSize: false
        },
        size: [
            25,
            0,
            200,
            1
        ]
    },
    edges: {
        arrows: {
            to: {
                enabled: false,
                scaleFactor: [
                    1,
                    0,
                    3,
                    0.05
                ],
                type: "arrow"
            },
            middle: {
                enabled: false,
                scaleFactor: [
                    1,
                    0,
                    3,
                    0.05
                ],
                type: "arrow"
            },
            from: {
                enabled: false,
                scaleFactor: [
                    1,
                    0,
                    3,
                    0.05
                ],
                type: "arrow"
            }
        },
        endPointOffset: {
            from: [
                0,
                -10,
                10,
                1
            ],
            to: [
                0,
                -10,
                10,
                1
            ]
        },
        arrowStrikethrough: true,
        color: {
            color: [
                "color",
                "#848484"
            ],
            highlight: [
                "color",
                "#848484"
            ],
            hover: [
                "color",
                "#848484"
            ],
            inherit: [
                "from",
                "to",
                "both",
                true,
                false
            ],
            opacity: [
                1,
                0,
                1,
                0.05
            ]
        },
        dashes: false,
        font: {
            color: [
                "color",
                "#343434"
            ],
            size: [
                14,
                0,
                100,
                1
            ],
            face: [
                "arial",
                "verdana",
                "tahoma"
            ],
            background: [
                "color",
                "none"
            ],
            strokeWidth: [
                2,
                0,
                50,
                1
            ],
            strokeColor: [
                "color",
                "#ffffff"
            ],
            align: [
                "horizontal",
                "top",
                "middle",
                "bottom"
            ]
        },
        hidden: false,
        hoverWidth: [
            1.5,
            0,
            5,
            0.1
        ],
        labelHighlightBold: true,
        physics: true,
        scaling: {
            min: [
                1,
                0,
                100,
                1
            ],
            max: [
                15,
                0,
                100,
                1
            ],
            label: {
                enabled: true,
                min: [
                    14,
                    0,
                    200,
                    1
                ],
                max: [
                    30,
                    0,
                    200,
                    1
                ],
                maxVisible: [
                    30,
                    0,
                    200,
                    1
                ],
                drawThreshold: [
                    5,
                    0,
                    20,
                    1
                ]
            }
        },
        selectionWidth: [
            1.5,
            0,
            5,
            0.1
        ],
        selfReferenceSize: [
            20,
            0,
            200,
            1
        ],
        selfReference: {
            size: [
                20,
                0,
                200,
                1
            ],
            angle: [
                Math.PI / 2,
                -6 * Math.PI,
                6 * Math.PI,
                Math.PI / 8
            ],
            renderBehindTheNode: true
        },
        shadow: {
            enabled: false,
            color: "rgba(0,0,0,0.5)",
            size: [
                10,
                0,
                20,
                1
            ],
            x: [
                5,
                -30,
                30,
                1
            ],
            y: [
                5,
                -30,
                30,
                1
            ]
        },
        smooth: {
            enabled: true,
            type: [
                "dynamic",
                "continuous",
                "discrete",
                "diagonalCross",
                "straightCross",
                "horizontal",
                "vertical",
                "curvedCW",
                "curvedCCW",
                "cubicBezier"
            ],
            forceDirection: [
                "horizontal",
                "vertical",
                "none"
            ],
            roundness: [
                0.5,
                0,
                1,
                0.05
            ]
        },
        width: [
            1,
            0,
            30,
            1
        ]
    },
    layout: {
        //randomSeed: [0, 0, 500, 1],
        //improvedLayout: true,
        hierarchical: {
            enabled: false,
            levelSeparation: [
                150,
                20,
                500,
                5
            ],
            nodeSpacing: [
                100,
                20,
                500,
                5
            ],
            treeSpacing: [
                200,
                20,
                500,
                5
            ],
            blockShifting: true,
            edgeMinimization: true,
            parentCentralization: true,
            direction: [
                "UD",
                "DU",
                "LR",
                "RL"
            ],
            sortMethod: [
                "hubsize",
                "directed"
            ],
            shakeTowards: [
                "leaves",
                "roots"
            ] // leaves, roots
        }
    },
    interaction: {
        dragNodes: true,
        dragView: true,
        hideEdgesOnDrag: false,
        hideEdgesOnZoom: false,
        hideNodesOnDrag: false,
        hover: false,
        keyboard: {
            enabled: false,
            speed: {
                x: [
                    10,
                    0,
                    40,
                    1
                ],
                y: [
                    10,
                    0,
                    40,
                    1
                ],
                zoom: [
                    0.02,
                    0,
                    0.1,
                    0.005
                ]
            },
            bindToWindow: true,
            autoFocus: true
        },
        multiselect: false,
        navigationButtons: false,
        selectable: true,
        selectConnectedEdges: true,
        hoverConnectedEdges: true,
        tooltipDelay: [
            300,
            0,
            1000,
            25
        ],
        zoomView: true,
        zoomSpeed: [
            1,
            0.1,
            2,
            0.1
        ]
    },
    manipulation: {
        enabled: false,
        initiallyActive: false
    },
    physics: {
        enabled: true,
        barnesHut: {
            theta: [
                0.5,
                0.1,
                1,
                0.05
            ],
            gravitationalConstant: [
                -2000,
                -30000,
                0,
                50
            ],
            centralGravity: [
                0.3,
                0,
                10,
                0.05
            ],
            springLength: [
                95,
                0,
                500,
                5
            ],
            springConstant: [
                0.04,
                0,
                1.2,
                0.005
            ],
            damping: [
                0.09,
                0,
                1,
                0.01
            ],
            avoidOverlap: [
                0,
                0,
                1,
                0.01
            ]
        },
        forceAtlas2Based: {
            theta: [
                0.5,
                0.1,
                1,
                0.05
            ],
            gravitationalConstant: [
                -50,
                -500,
                0,
                1
            ],
            centralGravity: [
                0.01,
                0,
                1,
                0.005
            ],
            springLength: [
                95,
                0,
                500,
                5
            ],
            springConstant: [
                0.08,
                0,
                1.2,
                0.005
            ],
            damping: [
                0.4,
                0,
                1,
                0.01
            ],
            avoidOverlap: [
                0,
                0,
                1,
                0.01
            ]
        },
        repulsion: {
            centralGravity: [
                0.2,
                0,
                10,
                0.05
            ],
            springLength: [
                200,
                0,
                500,
                5
            ],
            springConstant: [
                0.05,
                0,
                1.2,
                0.005
            ],
            nodeDistance: [
                100,
                0,
                500,
                5
            ],
            damping: [
                0.09,
                0,
                1,
                0.01
            ]
        },
        hierarchicalRepulsion: {
            centralGravity: [
                0.2,
                0,
                10,
                0.05
            ],
            springLength: [
                100,
                0,
                500,
                5
            ],
            springConstant: [
                0.01,
                0,
                1.2,
                0.005
            ],
            nodeDistance: [
                120,
                0,
                500,
                5
            ],
            damping: [
                0.09,
                0,
                1,
                0.01
            ],
            avoidOverlap: [
                0,
                0,
                1,
                0.01
            ]
        },
        maxVelocity: [
            50,
            0,
            150,
            1
        ],
        minVelocity: [
            0.1,
            0.01,
            0.5,
            0.01
        ],
        solver: [
            "barnesHut",
            "forceAtlas2Based",
            "repulsion",
            "hierarchicalRepulsion"
        ],
        timestep: [
            0.5,
            0.01,
            1,
            0.01
        ],
        wind: {
            x: [
                0,
                -10,
                10,
                0.1
            ],
            y: [
                0,
                -10,
                10,
                0.1
            ]
        }
    }
};
var $bebd28704f2536ea$var$configuratorHideOption = function configuratorHideOption(parentPath, optionName, options) {
    var _context;
    if ($bebd28704f2536ea$var$_includesInstanceProperty(parentPath).call(parentPath, "physics") && $bebd28704f2536ea$var$_includesInstanceProperty(_context = $bebd28704f2536ea$var$configureOptions.physics.solver).call(_context, optionName) && options.physics.solver !== optionName && optionName !== "wind") return true;
    return false;
};
var $bebd28704f2536ea$export$816f4f54d0e19aa = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    allOptions: $bebd28704f2536ea$var$allOptions,
    configuratorHideOption: $bebd28704f2536ea$var$configuratorHideOption,
    configureOptions: $bebd28704f2536ea$var$configureOptions
});
/**
 *  The Floyd–Warshall algorithm is an algorithm for finding shortest paths in
 *  a weighted graph with positive or negative edge weights (but with no negative
 *  cycles). - https://en.wikipedia.org/wiki/Floyd–Warshall_algorithm
 */ var $bebd28704f2536ea$var$FloydWarshall = /*#__PURE__*/ function() {
    /**
   * @ignore
   */ function FloydWarshall() {
        $bebd28704f2536ea$var$_classCallCheck(this, FloydWarshall);
    }
    /**
   *
   * @param {object} body
   * @param {Array.<Node>} nodesArray
   * @param {Array.<Edge>} edgesArray
   * @returns {{}}
   */ $bebd28704f2536ea$var$_createClass(FloydWarshall, [
        {
            key: "getDistances",
            value: function getDistances(body, nodesArray, edgesArray) {
                var D_matrix = {};
                var edges = body.edges;
                // prepare matrix with large numbers
                for(var i = 0; i < nodesArray.length; i++){
                    var node = nodesArray[i];
                    var cell = {};
                    D_matrix[node] = cell;
                    for(var j = 0; j < nodesArray.length; j++)cell[nodesArray[j]] = i == j ? 0 : 1e9;
                }
                // put the weights for the edges in. This assumes unidirectionality.
                for(var _i = 0; _i < edgesArray.length; _i++){
                    var edge = edges[edgesArray[_i]];
                    // edge has to be connected if it counts to the distances. If it is connected to inner clusters it will crash so we also check if it is in the D_matrix
                    if (edge.connected === true && D_matrix[edge.fromId] !== undefined && D_matrix[edge.toId] !== undefined) {
                        D_matrix[edge.fromId][edge.toId] = 1;
                        D_matrix[edge.toId][edge.fromId] = 1;
                    }
                }
                var nodeCount = nodesArray.length;
                // Adapted FloydWarshall based on unidirectionality to greatly reduce complexity.
                for(var k = 0; k < nodeCount; k++){
                    var knode = nodesArray[k];
                    var kcolm = D_matrix[knode];
                    for(var _i2 = 0; _i2 < nodeCount - 1; _i2++){
                        var inode = nodesArray[_i2];
                        var icolm = D_matrix[inode];
                        for(var _j = _i2 + 1; _j < nodeCount; _j++){
                            var jnode = nodesArray[_j];
                            var jcolm = D_matrix[jnode];
                            var val = Math.min(icolm[jnode], icolm[knode] + kcolm[jnode]);
                            icolm[jnode] = val;
                            jcolm[inode] = val;
                        }
                    }
                }
                return D_matrix;
            }
        }
    ]);
    return FloydWarshall;
}();
/**
 * KamadaKawai positions the nodes initially based on
 *
 * "AN ALGORITHM FOR DRAWING GENERAL UNDIRECTED GRAPHS"
 * -- Tomihisa KAMADA and Satoru KAWAI in 1989
 *
 * Possible optimizations in the distance calculation can be implemented.
 */ var $bebd28704f2536ea$var$KamadaKawai = /*#__PURE__*/ function() {
    /**
   * @param {object} body
   * @param {number} edgeLength
   * @param {number} edgeStrength
   */ function KamadaKawai(body, edgeLength, edgeStrength) {
        $bebd28704f2536ea$var$_classCallCheck(this, KamadaKawai);
        this.body = body;
        this.springLength = edgeLength;
        this.springConstant = edgeStrength;
        this.distanceSolver = new $bebd28704f2536ea$var$FloydWarshall();
    }
    /**
   * Not sure if needed but can be used to update the spring length and spring constant
   *
   * @param {object} options
   */ $bebd28704f2536ea$var$_createClass(KamadaKawai, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                if (options) {
                    if (options.springLength) this.springLength = options.springLength;
                    if (options.springConstant) this.springConstant = options.springConstant;
                }
            }
        },
        {
            key: "solve",
            value: function solve(nodesArray, edgesArray) {
                var ignoreClusters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                // get distance matrix
                var D_matrix = this.distanceSolver.getDistances(this.body, nodesArray, edgesArray); // distance matrix
                // get the L Matrix
                this._createL_matrix(D_matrix);
                // get the K Matrix
                this._createK_matrix(D_matrix);
                // initial E Matrix
                this._createE_matrix();
                // calculate positions
                var threshold = 0.01;
                var innerThreshold = 1;
                var iterations = 0;
                var maxIterations = Math.max(1000, Math.min(10 * this.body.nodeIndices.length, 6000));
                var maxInnerIterations = 5;
                var maxEnergy = 1e9;
                var highE_nodeId = 0, dE_dx = 0, dE_dy = 0, delta_m = 0, subIterations = 0;
                while(maxEnergy > threshold && iterations < maxIterations){
                    iterations += 1;
                    var _this$_getHighestEner = this._getHighestEnergyNode(ignoreClusters);
                    var _this$_getHighestEner2 = $bebd28704f2536ea$var$_slicedToArray(_this$_getHighestEner, 4);
                    highE_nodeId = _this$_getHighestEner2[0];
                    maxEnergy = _this$_getHighestEner2[1];
                    dE_dx = _this$_getHighestEner2[2];
                    dE_dy = _this$_getHighestEner2[3];
                    delta_m = maxEnergy;
                    subIterations = 0;
                    while(delta_m > innerThreshold && subIterations < maxInnerIterations){
                        subIterations += 1;
                        this._moveNode(highE_nodeId, dE_dx, dE_dy);
                        var _this$_getEnergy = this._getEnergy(highE_nodeId);
                        var _this$_getEnergy2 = $bebd28704f2536ea$var$_slicedToArray(_this$_getEnergy, 3);
                        delta_m = _this$_getEnergy2[0];
                        dE_dx = _this$_getEnergy2[1];
                        dE_dy = _this$_getEnergy2[2];
                    }
                }
            }
        },
        {
            key: "_getHighestEnergyNode",
            value: function _getHighestEnergyNode(ignoreClusters) {
                var nodesArray = this.body.nodeIndices;
                var nodes = this.body.nodes;
                var maxEnergy = 0;
                var maxEnergyNodeId = nodesArray[0];
                var dE_dx_max = 0, dE_dy_max = 0;
                for(var nodeIdx = 0; nodeIdx < nodesArray.length; nodeIdx++){
                    var m = nodesArray[nodeIdx];
                    // by not evaluating nodes with predefined positions we should only move nodes that have no positions.
                    if (nodes[m].predefinedPosition !== true || nodes[m].isCluster === true && ignoreClusters === true || nodes[m].options.fixed.x !== true || nodes[m].options.fixed.y !== true) {
                        var _this$_getEnergy3 = this._getEnergy(m), _this$_getEnergy4 = $bebd28704f2536ea$var$_slicedToArray(_this$_getEnergy3, 3), delta_m = _this$_getEnergy4[0], dE_dx = _this$_getEnergy4[1], dE_dy = _this$_getEnergy4[2];
                        if (maxEnergy < delta_m) {
                            maxEnergy = delta_m;
                            maxEnergyNodeId = m;
                            dE_dx_max = dE_dx;
                            dE_dy_max = dE_dy;
                        }
                    }
                }
                return [
                    maxEnergyNodeId,
                    maxEnergy,
                    dE_dx_max,
                    dE_dy_max
                ];
            }
        },
        {
            key: "_getEnergy",
            value: function _getEnergy(m) {
                var _this$E_sums$m = $bebd28704f2536ea$var$_slicedToArray(this.E_sums[m], 2), dE_dx = _this$E_sums$m[0], dE_dy = _this$E_sums$m[1];
                var delta_m = Math.sqrt(Math.pow(dE_dx, 2) + Math.pow(dE_dy, 2));
                return [
                    delta_m,
                    dE_dx,
                    dE_dy
                ];
            }
        },
        {
            key: "_moveNode",
            value: function _moveNode(m, dE_dx, dE_dy) {
                var nodesArray = this.body.nodeIndices;
                var nodes = this.body.nodes;
                var d2E_dx2 = 0;
                var d2E_dxdy = 0;
                var d2E_dy2 = 0;
                var x_m = nodes[m].x;
                var y_m = nodes[m].y;
                var km = this.K_matrix[m];
                var lm = this.L_matrix[m];
                for(var iIdx = 0; iIdx < nodesArray.length; iIdx++){
                    var i = nodesArray[iIdx];
                    if (i !== m) {
                        var x_i = nodes[i].x;
                        var y_i = nodes[i].y;
                        var kmat = km[i];
                        var lmat = lm[i];
                        var denominator = 1.0 / Math.pow(Math.pow(x_m - x_i, 2) + Math.pow(y_m - y_i, 2), 1.5);
                        d2E_dx2 += kmat * (1 - lmat * Math.pow(y_m - y_i, 2) * denominator);
                        d2E_dxdy += kmat * (lmat * (x_m - x_i) * (y_m - y_i) * denominator);
                        d2E_dy2 += kmat * (1 - lmat * Math.pow(x_m - x_i, 2) * denominator);
                    }
                }
                // make the variable names easier to make the solving of the linear system easier to read
                var A = d2E_dx2, B = d2E_dxdy, C = dE_dx, D = d2E_dy2, E = dE_dy;
                // solve the linear system for dx and dy
                var dy = (C / A + E / B) / (B / A - D / B);
                var dx = -(B * dy + C) / A;
                // move the node
                nodes[m].x += dx;
                nodes[m].y += dy;
                // Recalculate E_matrix (should be incremental)
                this._updateE_matrix(m);
            }
        },
        {
            key: "_createL_matrix",
            value: function _createL_matrix(D_matrix) {
                var nodesArray = this.body.nodeIndices;
                var edgeLength = this.springLength;
                this.L_matrix = [];
                for(var i = 0; i < nodesArray.length; i++){
                    this.L_matrix[nodesArray[i]] = {};
                    for(var j = 0; j < nodesArray.length; j++)this.L_matrix[nodesArray[i]][nodesArray[j]] = edgeLength * D_matrix[nodesArray[i]][nodesArray[j]];
                }
            }
        },
        {
            key: "_createK_matrix",
            value: function _createK_matrix(D_matrix) {
                var nodesArray = this.body.nodeIndices;
                var edgeStrength = this.springConstant;
                this.K_matrix = [];
                for(var i = 0; i < nodesArray.length; i++){
                    this.K_matrix[nodesArray[i]] = {};
                    for(var j = 0; j < nodesArray.length; j++)this.K_matrix[nodesArray[i]][nodesArray[j]] = edgeStrength * Math.pow(D_matrix[nodesArray[i]][nodesArray[j]], -2);
                }
            }
        },
        {
            key: "_createE_matrix",
            value: function _createE_matrix() {
                var nodesArray = this.body.nodeIndices;
                var nodes = this.body.nodes;
                this.E_matrix = {};
                this.E_sums = {};
                for(var mIdx = 0; mIdx < nodesArray.length; mIdx++)this.E_matrix[nodesArray[mIdx]] = [];
                for(var _mIdx = 0; _mIdx < nodesArray.length; _mIdx++){
                    var m = nodesArray[_mIdx];
                    var x_m = nodes[m].x;
                    var y_m = nodes[m].y;
                    var dE_dx = 0;
                    var dE_dy = 0;
                    for(var iIdx = _mIdx; iIdx < nodesArray.length; iIdx++){
                        var i = nodesArray[iIdx];
                        if (i !== m) {
                            var x_i = nodes[i].x;
                            var y_i = nodes[i].y;
                            var denominator = 1.0 / Math.sqrt(Math.pow(x_m - x_i, 2) + Math.pow(y_m - y_i, 2));
                            this.E_matrix[m][iIdx] = [
                                this.K_matrix[m][i] * (x_m - x_i - this.L_matrix[m][i] * (x_m - x_i) * denominator),
                                this.K_matrix[m][i] * (y_m - y_i - this.L_matrix[m][i] * (y_m - y_i) * denominator)
                            ];
                            this.E_matrix[i][_mIdx] = this.E_matrix[m][iIdx];
                            dE_dx += this.E_matrix[m][iIdx][0];
                            dE_dy += this.E_matrix[m][iIdx][1];
                        }
                    }
                    //Store sum
                    this.E_sums[m] = [
                        dE_dx,
                        dE_dy
                    ];
                }
            }
        },
        {
            key: "_updateE_matrix",
            value: function _updateE_matrix(m) {
                var nodesArray = this.body.nodeIndices;
                var nodes = this.body.nodes;
                var colm = this.E_matrix[m];
                var kcolm = this.K_matrix[m];
                var lcolm = this.L_matrix[m];
                var x_m = nodes[m].x;
                var y_m = nodes[m].y;
                var dE_dx = 0;
                var dE_dy = 0;
                for(var iIdx = 0; iIdx < nodesArray.length; iIdx++){
                    var i = nodesArray[iIdx];
                    if (i !== m) {
                        //Keep old energy value for sum modification below
                        var cell = colm[iIdx];
                        var oldDx = cell[0];
                        var oldDy = cell[1];
                        //Calc new energy:
                        var x_i = nodes[i].x;
                        var y_i = nodes[i].y;
                        var denominator = 1.0 / Math.sqrt(Math.pow(x_m - x_i, 2) + Math.pow(y_m - y_i, 2));
                        var dx = kcolm[i] * (x_m - x_i - lcolm[i] * (x_m - x_i) * denominator);
                        var dy = kcolm[i] * (y_m - y_i - lcolm[i] * (y_m - y_i) * denominator);
                        colm[iIdx] = [
                            dx,
                            dy
                        ];
                        dE_dx += dx;
                        dE_dy += dy;
                        //add new energy to sum of each column
                        var sum = this.E_sums[i];
                        sum[0] += dx - oldDx;
                        sum[1] += dy - oldDy;
                    }
                }
                //Store sum at -1 index
                this.E_sums[m] = [
                    dE_dx,
                    dE_dy
                ];
            }
        }
    ]);
    return KamadaKawai;
}();
/**
 * Create a network visualization, displaying nodes and edges.
 *
 * @param {Element} container   The DOM element in which the Network will
 *                                  be created. Normally a div element.
 * @param {object} data         An object containing parameters
 *                              {Array} nodes
 *                              {Array} edges
 * @param {object} options      Options
 * @class Network
 */ function $bebd28704f2536ea$export$95be4ae94445245a(container, data, options) {
    var _context, _context2, _context3, _context4, _this = this;
    if (!(this instanceof $bebd28704f2536ea$export$95be4ae94445245a)) throw new SyntaxError("Constructor must be called with the new operator");
    // set constant values
    this.options = {};
    this.defaultOptions = {
        locale: "en",
        locales: $bebd28704f2536ea$var$locales,
        clickToUse: false
    };
    $bebd28704f2536ea$var$_Object$assign(this.options, this.defaultOptions);
    /**
   * Containers for nodes and edges.
   *
   * 'edges' and 'nodes' contain the full definitions of all the network elements.
   * 'nodeIndices' and 'edgeIndices' contain the id's of the active elements.
   *
   * The distinction is important, because a defined node need not be active, i.e.
   * visible on the canvas. This happens in particular when clusters are defined, in
   * that case there will be nodes and edges not displayed.
   * The bottom line is that all code with actions related to visibility, *must* use
   * 'nodeIndices' and 'edgeIndices', not 'nodes' and 'edges' directly.
   */ this.body = {
        container: container,
        // See comment above for following fields
        nodes: {},
        nodeIndices: [],
        edges: {},
        edgeIndices: [],
        emitter: {
            on: $bebd28704f2536ea$var$_bindInstanceProperty$1(_context = this.on).call(_context, this),
            off: $bebd28704f2536ea$var$_bindInstanceProperty$1(_context2 = this.off).call(_context2, this),
            emit: $bebd28704f2536ea$var$_bindInstanceProperty$1(_context3 = this.emit).call(_context3, this),
            once: $bebd28704f2536ea$var$_bindInstanceProperty$1(_context4 = this.once).call(_context4, this)
        },
        eventListeners: {
            onTap: function onTap() {},
            onTouch: function onTouch() {},
            onDoubleTap: function onDoubleTap() {},
            onHold: function onHold() {},
            onDragStart: function onDragStart() {},
            onDrag: function onDrag() {},
            onDragEnd: function onDragEnd() {},
            onMouseWheel: function onMouseWheel() {},
            onPinch: function onPinch() {},
            onMouseMove: function onMouseMove() {},
            onRelease: function onRelease() {},
            onContext: function onContext() {}
        },
        data: {
            nodes: null,
            // A DataSet or DataView
            edges: null // A DataSet or DataView
        },
        functions: {
            createNode: function createNode() {},
            createEdge: function createEdge() {},
            getPointer: function getPointer() {}
        },
        modules: {},
        view: {
            scale: 1,
            translation: {
                x: 0,
                y: 0
            }
        },
        selectionBox: {
            show: false,
            position: {
                start: {
                    x: 0,
                    y: 0
                },
                end: {
                    x: 0,
                    y: 0
                }
            }
        }
    };
    // bind the event listeners
    this.bindEventListeners();
    // setting up all modules
    this.images = new $bebd28704f2536ea$export$55d75908a8cadbee(function() {
        return _this.body.emitter.emit("_requestRedraw");
    }); // object with images
    this.groups = new $bebd28704f2536ea$var$Groups(); // object with groups
    this.canvas = new $bebd28704f2536ea$var$Canvas(this.body); // DOM handler
    this.selectionHandler = new $bebd28704f2536ea$var$SelectionHandler(this.body, this.canvas); // Selection handler
    this.interactionHandler = new $bebd28704f2536ea$var$InteractionHandler(this.body, this.canvas, this.selectionHandler); // Interaction handler handles all the hammer bindings (that are bound by canvas), key
    this.view = new $bebd28704f2536ea$var$View(this.body, this.canvas); // camera handler, does animations and zooms
    this.renderer = new $bebd28704f2536ea$var$CanvasRenderer(this.body, this.canvas); // renderer, starts renderloop, has events that modules can hook into
    this.physics = new $bebd28704f2536ea$var$PhysicsEngine(this.body); // physics engine, does all the simulations
    this.layoutEngine = new $bebd28704f2536ea$var$LayoutEngine(this.body); // layout engine for inital layout and hierarchical layout
    this.clustering = new $bebd28704f2536ea$var$ClusterEngine(this.body); // clustering api
    this.manipulation = new $bebd28704f2536ea$var$ManipulationSystem(this.body, this.canvas, this.selectionHandler, this.interactionHandler); // data manipulation system
    this.nodesHandler = new $bebd28704f2536ea$var$NodesHandler(this.body, this.images, this.groups, this.layoutEngine); // Handle adding, deleting and updating of nodes as well as global options
    this.edgesHandler = new $bebd28704f2536ea$var$EdgesHandler(this.body, this.images, this.groups); // Handle adding, deleting and updating of edges as well as global options
    this.body.modules["kamadaKawai"] = new $bebd28704f2536ea$var$KamadaKawai(this.body, 150, 0.05); // Layouting algorithm.
    this.body.modules["clustering"] = this.clustering;
    // create the DOM elements
    this.canvas._create();
    // apply options
    this.setOptions(options);
    // load data (the disable start variable will be the same as the enabled clustering)
    this.setData(data);
}
// Extend Network with an Emitter mixin
$bebd28704f2536ea$var$Emitter($bebd28704f2536ea$export$95be4ae94445245a.prototype);
/**
 * Set options
 *
 * @param {object} options
 */ $bebd28704f2536ea$export$95be4ae94445245a.prototype.setOptions = function(options) {
    var _this2 = this;
    if (options === null) options = undefined; // This ensures that options handling doesn't crash in the handling
    if (options !== undefined) {
        var errorFound = $bebd28704f2536ea$var$Validator.validate(options, $bebd28704f2536ea$var$allOptions);
        if (errorFound === true) console.error("%cErrors have been found in the supplied options object.", $bebd28704f2536ea$var$VALIDATOR_PRINT_STYLE);
        // copy the global fields over
        var fields = [
            "locale",
            "locales",
            "clickToUse"
        ];
        $bebd28704f2536ea$var$selectiveDeepExtend(fields, this.options, options);
        // normalize the locale or use English
        if (options.locale !== undefined) options.locale = $bebd28704f2536ea$var$normalizeLanguageCode(options.locales || this.options.locales, options.locale);
        // the hierarchical system can adapt the edges and the physics to it's own options because not all combinations work with the hierarichical system.
        options = this.layoutEngine.setOptions(options.layout, options);
        this.canvas.setOptions(options); // options for canvas are in globals
        // pass the options to the modules
        this.groups.setOptions(options.groups);
        this.nodesHandler.setOptions(options.nodes);
        this.edgesHandler.setOptions(options.edges);
        this.physics.setOptions(options.physics);
        this.manipulation.setOptions(options.manipulation, options, this.options); // manipulation uses the locales in the globals
        this.interactionHandler.setOptions(options.interaction);
        this.renderer.setOptions(options.interaction); // options for rendering are in interaction
        this.selectionHandler.setOptions(options.interaction); // options for selection are in interaction
        // reload the settings of the nodes to apply changes in groups that are not referenced by pointer.
        if (options.groups !== undefined) this.body.emitter.emit("refreshNodes");
        // these two do not have options at the moment, here for completeness
        //this.view.setOptions(options.view);
        //this.clustering.setOptions(options.clustering);
        if ("configure" in options) {
            if (!this.configurator) this.configurator = new $bebd28704f2536ea$var$Configurator(this, this.body.container, $bebd28704f2536ea$var$configureOptions, this.canvas.pixelRatio, $bebd28704f2536ea$var$configuratorHideOption);
            this.configurator.setOptions(options.configure);
        }
        // if the configuration system is enabled, copy all options and put them into the config system
        if (this.configurator && this.configurator.options.enabled === true) {
            var networkOptions = {
                nodes: {},
                edges: {},
                layout: {},
                interaction: {},
                manipulation: {},
                physics: {},
                global: {}
            };
            $bebd28704f2536ea$var$deepExtend(networkOptions.nodes, this.nodesHandler.options);
            $bebd28704f2536ea$var$deepExtend(networkOptions.edges, this.edgesHandler.options);
            $bebd28704f2536ea$var$deepExtend(networkOptions.layout, this.layoutEngine.options);
            // load the selectionHandler and render default options in to the interaction group
            $bebd28704f2536ea$var$deepExtend(networkOptions.interaction, this.selectionHandler.options);
            $bebd28704f2536ea$var$deepExtend(networkOptions.interaction, this.renderer.options);
            $bebd28704f2536ea$var$deepExtend(networkOptions.interaction, this.interactionHandler.options);
            $bebd28704f2536ea$var$deepExtend(networkOptions.manipulation, this.manipulation.options);
            $bebd28704f2536ea$var$deepExtend(networkOptions.physics, this.physics.options);
            // load globals into the global object
            $bebd28704f2536ea$var$deepExtend(networkOptions.global, this.canvas.options);
            $bebd28704f2536ea$var$deepExtend(networkOptions.global, this.options);
            this.configurator.setModuleOptions(networkOptions);
        }
        // handle network global options
        if (options.clickToUse !== undefined) {
            if (options.clickToUse === true) {
                if (this.activator === undefined) {
                    this.activator = new $bebd28704f2536ea$var$Activator(this.canvas.frame);
                    this.activator.on("change", function() {
                        _this2.body.emitter.emit("activate");
                    });
                }
            } else {
                if (this.activator !== undefined) {
                    this.activator.destroy();
                    delete this.activator;
                }
                this.body.emitter.emit("activate");
            }
        } else this.body.emitter.emit("activate");
        this.canvas.setSize();
        // start the physics simulation. Can be safely called multiple times.
        this.body.emitter.emit("startSimulation");
    }
};
/**
 * Update the visible nodes and edges list with the most recent node state.
 *
 * Visible nodes are stored in this.body.nodeIndices.
 * Visible edges are stored in this.body.edgeIndices.
 * A node or edges is visible if it is not hidden or clustered.
 *
 * @private
 */ $bebd28704f2536ea$export$95be4ae94445245a.prototype._updateVisibleIndices = function() {
    var nodes = this.body.nodes;
    var edges = this.body.edges;
    this.body.nodeIndices = [];
    this.body.edgeIndices = [];
    for(var nodeId in nodes){
        if (Object.prototype.hasOwnProperty.call(nodes, nodeId)) {
            if (!this.clustering._isClusteredNode(nodeId) && nodes[nodeId].options.hidden === false) this.body.nodeIndices.push(nodes[nodeId].id);
        }
    }
    for(var edgeId in edges)if (Object.prototype.hasOwnProperty.call(edges, edgeId)) {
        var edge = edges[edgeId];
        // It can happen that this is executed *after* a node edge has been removed,
        // but *before* the edge itself has been removed. Taking this into account.
        var fromNode = nodes[edge.fromId];
        var toNode = nodes[edge.toId];
        var edgeNodesPresent = fromNode !== undefined && toNode !== undefined;
        var isVisible = !this.clustering._isClusteredEdge(edgeId) && edge.options.hidden === false && edgeNodesPresent && fromNode.options.hidden === false && // Also hidden if any of its connecting nodes are hidden
        toNode.options.hidden === false; // idem
        if (isVisible) this.body.edgeIndices.push(edge.id);
    }
};
/**
 * Bind all events
 */ $bebd28704f2536ea$export$95be4ae94445245a.prototype.bindEventListeners = function() {
    var _this3 = this;
    // This event will trigger a rebuilding of the cache everything.
    // Used when nodes or edges have been added or removed.
    this.body.emitter.on("_dataChanged", function() {
        _this3.edgesHandler._updateState();
        _this3.body.emitter.emit("_dataUpdated");
    });
    // this is called when options of EXISTING nodes or edges have changed.
    this.body.emitter.on("_dataUpdated", function() {
        // Order important in following block
        _this3.clustering._updateState();
        _this3._updateVisibleIndices();
        _this3._updateValueRange(_this3.body.nodes);
        _this3._updateValueRange(_this3.body.edges);
        // start simulation (can be called safely, even if already running)
        _this3.body.emitter.emit("startSimulation");
        _this3.body.emitter.emit("_requestRedraw");
    });
};
/**
 * Set nodes and edges, and optionally options as well.
 *
 * @param {object} data              Object containing parameters:
 *                                   {Array | DataSet | DataView} [nodes] Array with nodes
 *                                   {Array | DataSet | DataView} [edges] Array with edges
 *                                   {String} [dot] String containing data in DOT format
 *                                   {String} [gephi] String containing data in gephi JSON format
 *                                   {Options} [options] Object with options
 */ $bebd28704f2536ea$export$95be4ae94445245a.prototype.setData = function(data) {
    // reset the physics engine.
    this.body.emitter.emit("resetPhysics");
    this.body.emitter.emit("_resetData");
    // unselect all to ensure no selections from old data are carried over.
    this.selectionHandler.unselectAll();
    if (data && data.dot && (data.nodes || data.edges)) throw new SyntaxError('Data must contain either parameter "dot" or  parameter pair "nodes" and "edges", but not both.');
    // set options
    this.setOptions(data && data.options);
    // set all data
    if (data && data.dot) {
        console.warn("The dot property has been deprecated. Please use the static convertDot method to convert DOT into vis.network format and use the normal data format with nodes and edges. This converter is used like this: var data = vis.network.convertDot(dotString);");
        // parse DOT file
        var dotData = $bebd28704f2536ea$var$DOTToGraph(data.dot);
        this.setData(dotData);
        return;
    } else if (data && data.gephi) {
        // parse DOT file
        console.warn("The gephi property has been deprecated. Please use the static convertGephi method to convert gephi into vis.network format and use the normal data format with nodes and edges. This converter is used like this: var data = vis.network.convertGephi(gephiJson);");
        var gephiData = $bebd28704f2536ea$export$63f58ee125a505f5(data.gephi);
        this.setData(gephiData);
        return;
    } else {
        this.nodesHandler.setData(data && data.nodes, true);
        this.edgesHandler.setData(data && data.edges, true);
    }
    // emit change in data
    this.body.emitter.emit("_dataChanged");
    // emit data loaded
    this.body.emitter.emit("_dataLoaded");
    // find a stable position or start animating to a stable position
    this.body.emitter.emit("initPhysics");
};
/**
 * Cleans up all bindings of the network, removing it fully from the memory IF the variable is set to null after calling this function.
 * var network = new vis.Network(..);
 * network.destroy();
 * network = null;
 */ $bebd28704f2536ea$export$95be4ae94445245a.prototype.destroy = function() {
    this.body.emitter.emit("destroy");
    // clear events
    this.body.emitter.off();
    this.off();
    // delete modules
    delete this.groups;
    delete this.canvas;
    delete this.selectionHandler;
    delete this.interactionHandler;
    delete this.view;
    delete this.renderer;
    delete this.physics;
    delete this.layoutEngine;
    delete this.clustering;
    delete this.manipulation;
    delete this.nodesHandler;
    delete this.edgesHandler;
    delete this.configurator;
    delete this.images;
    for(var nodeId in this.body.nodes){
        if (!Object.prototype.hasOwnProperty.call(this.body.nodes, nodeId)) continue;
        delete this.body.nodes[nodeId];
    }
    for(var edgeId in this.body.edges){
        if (!Object.prototype.hasOwnProperty.call(this.body.edges, edgeId)) continue;
        delete this.body.edges[edgeId];
    }
    // remove the container and everything inside it recursively
    $bebd28704f2536ea$var$recursiveDOMDelete(this.body.container);
};
/**
 * Update the values of all object in the given array according to the current
 * value range of the objects in the array.
 *
 * @param {object} obj    An object containing a set of Edges or Nodes
 *                        The objects must have a method getValue() and
 *                        setValueRange(min, max).
 * @private
 */ $bebd28704f2536ea$export$95be4ae94445245a.prototype._updateValueRange = function(obj) {
    var id;
    // determine the range of the objects
    var valueMin = undefined;
    var valueMax = undefined;
    var valueTotal = 0;
    for(id in obj)if (Object.prototype.hasOwnProperty.call(obj, id)) {
        var value = obj[id].getValue();
        if (value !== undefined) {
            valueMin = valueMin === undefined ? value : Math.min(value, valueMin);
            valueMax = valueMax === undefined ? value : Math.max(value, valueMax);
            valueTotal += value;
        }
    }
    // adjust the range of all objects
    if (valueMin !== undefined && valueMax !== undefined) {
        for(id in obj)if (Object.prototype.hasOwnProperty.call(obj, id)) obj[id].setValueRange(valueMin, valueMax, valueTotal);
    }
};
/**
 * Returns true when the Network is active.
 *
 * @returns {boolean}
 */ $bebd28704f2536ea$export$95be4ae94445245a.prototype.isActive = function() {
    return !this.activator || this.activator.active;
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.setSize = function() {
    return this.canvas.setSize.apply(this.canvas, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.canvasToDOM = function() {
    return this.canvas.canvasToDOM.apply(this.canvas, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.DOMtoCanvas = function() {
    return this.canvas.DOMtoCanvas.apply(this.canvas, arguments);
};
/**
 * Nodes can be in clusters. Clusters can also be in clusters. This function returns and array of
 * nodeIds showing where the node is.
 *
 * If any nodeId in the chain, especially the first passed in as a parameter, is not present in
 * the current nodes list, an empty array is returned.
 *
 * Example:
 * cluster 'A' contains cluster 'B',
 * cluster 'B' contains cluster 'C',
 * cluster 'C' contains node 'fred'.
 * `jsnetwork.clustering.findNode('fred')` will return `['A','B','C','fred']`.
 *
 * @param {string|number} nodeId
 * @returns {Array}
 */ $bebd28704f2536ea$export$95be4ae94445245a.prototype.findNode = function() {
    return this.clustering.findNode.apply(this.clustering, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.isCluster = function() {
    return this.clustering.isCluster.apply(this.clustering, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.openCluster = function() {
    return this.clustering.openCluster.apply(this.clustering, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.cluster = function() {
    return this.clustering.cluster.apply(this.clustering, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.getNodesInCluster = function() {
    return this.clustering.getNodesInCluster.apply(this.clustering, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.clusterByConnection = function() {
    return this.clustering.clusterByConnection.apply(this.clustering, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.clusterByHubsize = function() {
    return this.clustering.clusterByHubsize.apply(this.clustering, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.updateClusteredNode = function() {
    return this.clustering.updateClusteredNode.apply(this.clustering, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.getClusteredEdges = function() {
    return this.clustering.getClusteredEdges.apply(this.clustering, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.getBaseEdge = function() {
    return this.clustering.getBaseEdge.apply(this.clustering, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.getBaseEdges = function() {
    return this.clustering.getBaseEdges.apply(this.clustering, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.updateEdge = function() {
    return this.clustering.updateEdge.apply(this.clustering, arguments);
};
/**
 * This method will cluster all nodes with 1 edge with their respective connected node.
 * The options object is explained in full <a data-scroll="" data-options="{ &quot;easing&quot;: &quot;easeInCubic&quot; }" href="#optionsObject">below</a>.
 *
 * @param {object} [options]
 * @returns {undefined}
 */ $bebd28704f2536ea$export$95be4ae94445245a.prototype.clusterOutliers = function() {
    return this.clustering.clusterOutliers.apply(this.clustering, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.getSeed = function() {
    return this.layoutEngine.getSeed.apply(this.layoutEngine, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.enableEditMode = function() {
    return this.manipulation.enableEditMode.apply(this.manipulation, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.disableEditMode = function() {
    return this.manipulation.disableEditMode.apply(this.manipulation, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.addNodeMode = function() {
    return this.manipulation.addNodeMode.apply(this.manipulation, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.editNode = function() {
    return this.manipulation.editNode.apply(this.manipulation, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.editNodeMode = function() {
    console.warn("Deprecated: Please use editNode instead of editNodeMode.");
    return this.manipulation.editNode.apply(this.manipulation, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.addEdgeMode = function() {
    return this.manipulation.addEdgeMode.apply(this.manipulation, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.editEdgeMode = function() {
    return this.manipulation.editEdgeMode.apply(this.manipulation, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.deleteSelected = function() {
    return this.manipulation.deleteSelected.apply(this.manipulation, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.getPositions = function() {
    return this.nodesHandler.getPositions.apply(this.nodesHandler, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.getPosition = function() {
    return this.nodesHandler.getPosition.apply(this.nodesHandler, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.storePositions = function() {
    return this.nodesHandler.storePositions.apply(this.nodesHandler, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.moveNode = function() {
    return this.nodesHandler.moveNode.apply(this.nodesHandler, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.getBoundingBox = function() {
    return this.nodesHandler.getBoundingBox.apply(this.nodesHandler, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.getConnectedNodes = function(objectId) {
    if (this.body.nodes[objectId] !== undefined) return this.nodesHandler.getConnectedNodes.apply(this.nodesHandler, arguments);
    else return this.edgesHandler.getConnectedNodes.apply(this.edgesHandler, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.getConnectedEdges = function() {
    return this.nodesHandler.getConnectedEdges.apply(this.nodesHandler, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.startSimulation = function() {
    return this.physics.startSimulation.apply(this.physics, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.stopSimulation = function() {
    return this.physics.stopSimulation.apply(this.physics, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.stabilize = function() {
    return this.physics.stabilize.apply(this.physics, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.getSelection = function() {
    return this.selectionHandler.getSelection.apply(this.selectionHandler, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.setSelection = function() {
    return this.selectionHandler.setSelection.apply(this.selectionHandler, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.getSelectedNodes = function() {
    return this.selectionHandler.getSelectedNodeIds.apply(this.selectionHandler, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.getSelectedEdges = function() {
    return this.selectionHandler.getSelectedEdgeIds.apply(this.selectionHandler, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.getNodeAt = function() {
    var node = this.selectionHandler.getNodeAt.apply(this.selectionHandler, arguments);
    if (node !== undefined && node.id !== undefined) return node.id;
    return node;
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.getEdgeAt = function() {
    var edge = this.selectionHandler.getEdgeAt.apply(this.selectionHandler, arguments);
    if (edge !== undefined && edge.id !== undefined) return edge.id;
    return edge;
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.selectNodes = function() {
    return this.selectionHandler.selectNodes.apply(this.selectionHandler, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.selectEdges = function() {
    return this.selectionHandler.selectEdges.apply(this.selectionHandler, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.unselectAll = function() {
    this.selectionHandler.unselectAll.apply(this.selectionHandler, arguments);
    this.selectionHandler.commitWithoutEmitting.apply(this.selectionHandler);
    this.redraw();
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.redraw = function() {
    return this.renderer.redraw.apply(this.renderer, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.getScale = function() {
    return this.view.getScale.apply(this.view, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.getViewPosition = function() {
    return this.view.getViewPosition.apply(this.view, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.fit = function() {
    return this.view.fit.apply(this.view, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.moveTo = function() {
    return this.view.moveTo.apply(this.view, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.focus = function() {
    return this.view.focus.apply(this.view, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.releaseNode = function() {
    return this.view.releaseNode.apply(this.view, arguments);
};
$bebd28704f2536ea$export$95be4ae94445245a.prototype.getOptionsFromConfigurator = function() {
    var options = {};
    if (this.configurator) options = this.configurator.getOptions.apply(this.configurator);
    return options;
};
var $bebd28704f2536ea$export$79fd918c7a17d782 = $bebd28704f2536ea$var$DOTToGraph;











const $7576ef8bb573c40c$var$richTypes = {
    Date: true,
    RegExp: true,
    String: true,
    Number: true
};
function $7576ef8bb573c40c$export$2e2bcd8739ae039(obj, newObj, options = {
    cyclesFix: true
}, _stack = []) {
    let diffs = [];
    const isObjArray = Array.isArray(obj);
    for(const key in obj){
        const objKey = obj[key];
        const path = isObjArray ? +key : key;
        if (!(key in newObj)) {
            diffs.push({
                type: "REMOVE",
                path: [
                    path
                ],
                oldValue: obj[key]
            });
            continue;
        }
        const newObjKey = newObj[key];
        const areCompatibleObjects = typeof objKey === "object" && typeof newObjKey === "object" && Array.isArray(objKey) === Array.isArray(newObjKey);
        if (objKey && newObjKey && areCompatibleObjects && !$7576ef8bb573c40c$var$richTypes[Object.getPrototypeOf(objKey)?.constructor?.name] && (!options.cyclesFix || !_stack.includes(objKey))) diffs.push.apply(diffs, $7576ef8bb573c40c$export$2e2bcd8739ae039(objKey, newObjKey, options, options.cyclesFix ? _stack.concat([
            objKey
        ]) : []).map((difference)=>{
            difference.path.unshift(path);
            return difference;
        }));
        else if (objKey !== newObjKey && // treat NaN values as equivalent
        !(Number.isNaN(objKey) && Number.isNaN(newObjKey)) && !(areCompatibleObjects && (isNaN(objKey) ? objKey + "" === newObjKey + "" : +objKey === +newObjKey))) diffs.push({
            path: [
                path
            ],
            type: "CHANGE",
            value: newObjKey,
            oldValue: objKey
        });
    }
    const isNewObjArray = Array.isArray(newObj);
    for(const key in newObj)if (!(key in obj)) diffs.push({
        type: "CREATE",
        path: [
            isNewObjArray ? +key : key
        ],
        value: newObj[key]
    });
    return diffs;
}



var $gFW3W = parcelRequire("gFW3W");
/*********************************************************************************************************************  

PRSM Participatory System Mapper 

	Copyright (C) 2022  Nigel Gilbert prsm@prsm.uk

	This program is free software: you can redistribute it and/or modify
	it under the terms of the GNU General Public License as published by
	the Free Software Foundation, either version 3 of the License, or
	(at your option) any later version.

	This program is distributed in the hope that it will be useful,
	but WITHOUT ANY WARRANTY; without even the implied warranty of
	MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	GNU General Public License for more details.

	You should have received a copy of the GNU General Public License
	along with this program.  If not, see <https://www.gnu.org/licenses/>.


This module provides import and export functions, to read and save map files in a variety of formats.  
 ******************************************************************************************************************** */ 


var $gFW3W = parcelRequire("gFW3W");
/*********************************************************************************************************************  

PRSM Participatory System Mapper 

	Copyright (C) 2022  Nigel Gilbert prsm@prsm.uk

	This program is free software: you can redistribute it and/or modify
	it under the terms of the GNU General Public License as published by
	the Free Software Foundation, either version 3 of the License, or
	(at your option) any later version.

	This program is distributed in the hope that it will be useful,
	but WITHOUT ANY WARRANTY; without even the implied warranty of
	MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	GNU General Public License for more details.

	You should have received a copy of the GNU General Public License
	along with this program.  If not, see <https://www.gnu.org/licenses/>.


This module provides the standard set of Styles for Factors and Links.  
 ******************************************************************************************************************** */ const $09258687963db43e$export$9dd6ff9ea0189349 = {
    nodes: {
        base: {
            groupLabel: 'Sample',
            borderWidth: 0,
            borderWidthSelected: 4,
            color: {
                border: 'rgb(0, 0, 0)',
                background: 'rgb(255, 255, 255)',
                highlight: {
                    border: 'rgb(0, 0, 0)',
                    background: 'rgb(255, 255, 255)'
                },
                hover: {
                    border: 'rgb(0, 0, 0)',
                    background: 'rgb(255, 255, 255)'
                }
            },
            fixed: false,
            font: {
                face: 'Oxygen',
                color: 'rgb(0, 0, 0)',
                size: 14
            },
            labelHighlightBold: true,
            margin: 20,
            shape: 'ellipse',
            shapeProperties: {
                borderDashes: false
            },
            scaling: {
                min: 10,
                max: 40,
                label: {
                    enabled: false,
                    min: 10,
                    max: 40
                }
            },
            size: 25,
            heightConstraint: false,
            widthConstraint: false
        },
        group0: {
            color: {
                border: 'rgb(154, 219, 180)',
                background: 'rgb(154, 219, 180)'
            },
            shape: 'box'
        },
        group1: {
            color: {
                border: 'rgb(202, 219, 92)',
                background: 'rgb(202, 219, 92)'
            },
            shape: 'box'
        },
        group2: {
            color: {
                border: 'rgb(219, 165, 66)',
                background: 'rgb(219, 165, 66)'
            },
            shape: 'box'
        },
        group3: {
            color: {
                border: 'rgb(219, 110, 103)',
                background: 'rgb(219, 110, 103)'
            },
            font: {
                color: 'rgb(255, 255, 255)'
            },
            shape: 'box'
        },
        group4: {
            color: {
                border: 'rgb(131, 113, 183)',
                background: 'rgb(131, 113, 183)'
            },
            font: {
                color: 'rgb(255, 255, 255)'
            },
            shape: 'box'
        },
        group5: {
            font: {
                color: 'rgb(28, 95, 27)'
            },
            shape: 'text'
        },
        group6: {
            borderWidth: 4,
            color: {
                border: 'rgb(0, 0, 255)',
                background: 'rgb(179, 204, 255)'
            },
            shape: 'diamond'
        },
        group7: {
            borderWidth: 4,
            color: {
                border: 'rgb(0, 0, 0)',
                background: 'rgb(255, 255, 153)'
            },
            shape: 'circle',
            shapeProperties: {
                borderDashes: [
                    3,
                    3
                ]
            }
        },
        group8: {
            color: {
                border: 'rgb(2, 71, 254)',
                background: 'rgb(2, 71, 254)'
            },
            font: {
                color: 'rgb(255, 0, 0)'
            },
            shape: 'star'
        },
        group9: {
            color: {
                border: 'rgb(255, 0, 0)',
                background: 'rgb(255, 0, 0)'
            },
            font: {
                color: 'rgb(255, 255, 255)'
            },
            shape: 'box'
        },
        group10: {
            color: {
                border: 'rgb(0, 0, 255)',
                background: 'rgb(0, 0, 255)'
            },
            font: {
                color: 'rgb(255, 255, 255)'
            },
            shape: 'box'
        },
        group11: {
            color: {
                border: 'rgb(0, 255, 0)',
                background: 'rgb(0, 255, 0)'
            },
            font: {
                color: 'rgb(0, 0, 0)'
            },
            shape: 'box'
        },
        group12: {
            color: {
                border: 'rgb(254, 254, 51)',
                background: 'rgb(254, 254, 51)'
            },
            font: {
                color: 'rgb(0, 0, 0)'
            },
            shape: 'box'
        },
        group13: {
            color: {
                border: 'rgb(255, 0, 255)',
                background: 'rgb(255, 0, 255)'
            },
            font: {
                color: 'rgb(255, 255, 255)'
            },
            shape: 'box'
        },
        group14: {
            color: {
                border: 'rgb(0, 255, 255)',
                background: 'rgb(0, 255, 255)'
            },
            font: {
                color: 'rgb(0, 0, 0)'
            },
            shape: 'box'
        },
        cluster: {
            borderWidth: 3,
            color: {
                border: 'rgb(0, 0, 0)',
                background: 'rgb(221, 44, 0)'
            },
            font: {
                color: 'rgb(255, 255, 255)'
            },
            shape: 'database',
            margin: {
                top: 40,
                right: 20,
                bottom: 20,
                left: 20
            }
        }
    },
    edges: {
        base: {
            arrows: {
                to: {
                    enabled: true,
                    type: 'vee'
                },
                middle: {
                    enabled: false
                },
                from: {
                    enabled: false
                }
            },
            color: {
                color: 'rgb(0, 0, 0)',
                highlight: 'rgb(0, 0, 0)',
                hover: 'rgb(0, 0, 0)',
                inherit: false,
                opacity: 1
            },
            dashes: false,
            font: {
                size: 14,
                align: 'top',
                background: 'rgb(255,255,255)',
                vadjust: -5,
                strokeWidth: 0
            },
            groupLabel: 'Sample',
            hoverWidth: 1,
            selectionWidth: 0,
            width: 1
        },
        edge0: {
            color: {
                color: 'rgb(0, 0, 0)'
            }
        },
        edge1: {
            color: {
                color: 'rgb(0, 204, 0)'
            }
        },
        edge2: {
            color: {
                color: 'rgb(255, 0, 0)'
            }
        },
        edge3: {
            color: {
                color: 'rgb(0, 0, 255)'
            }
        },
        edge4: {
            color: {
                color: 'rgb(128, 128, 128)'
            }
        },
        edge5: {
            color: {
                color: 'rgb(230, 184, 0)'
            }
        },
        edge6: {
            color: {
                color: 'rgb(0, 0, 0)'
            },
            dashes: [
                3,
                3
            ]
        },
        edge7: {
            color: {
                color: 'rgb(0, 128, 0)'
            },
            dashes: [
                10,
                10
            ],
            width: 3
        },
        edge8: {
            arrows: {
                to: {
                    enabled: false
                },
                middle: {
                    enabled: true,
                    type: 'arrow'
                }
            },
            color: {
                color: 'rgb(0, 0, 0)'
            }
        },
        cluster: {
            color: {
                color: 'rgb(141, 110, 99)'
            },
            width: 3
        }
    }
};


/********************************************************************************************* 

PRSM Participatory System Mapper 

MIT License

Copyright (c) [2022] Nigel Gilbert email: prsm@prsm.uk

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.


This module provides the background objet-oriented drawing for PRSM
********************************************************************************************/ 
var $79564f678731bf19$exports = {};
/* build: `node build.js modules=ALL exclude=gestures,accessors,erasing requirejs minifier=uglifyjs` */ /*! Fabric.js Copyright 2008-2015, Printio (Juriy Zaytsev, Maxim Chernyak) */ 
var $djTVs = parcelRequire("djTVs");
var $79564f678731bf19$require$Buffer = $djTVs.Buffer;
var $79564f678731bf19$var$fabric = $79564f678731bf19$var$fabric || {
    version: '5.4.2'
};
$79564f678731bf19$exports.fabric = $79564f678731bf19$var$fabric;



/* _AMD_END_ */ if (typeof document !== 'undefined' && typeof window !== 'undefined') {
    if (document instanceof (typeof HTMLDocument !== 'undefined' ? HTMLDocument : Document)) $79564f678731bf19$var$fabric.document = document;
    else $79564f678731bf19$var$fabric.document = document.implementation.createHTMLDocument('');
    $79564f678731bf19$var$fabric.window = window;
} else {
    // assume we're running under node.js when document/window are not present
    var $79564f678731bf19$var$jsdom = (parcelRequire("l52Gj"));
    var $79564f678731bf19$var$virtualWindow = new $79564f678731bf19$var$jsdom.JSDOM(decodeURIComponent('%3C!DOCTYPE%20html%3E%3Chtml%3E%3Chead%3E%3C%2Fhead%3E%3Cbody%3E%3C%2Fbody%3E%3C%2Fhtml%3E'), {
        features: {
            FetchExternalResources: [
                'img'
            ]
        },
        resources: 'usable'
    }).window;
    $79564f678731bf19$var$fabric.document = $79564f678731bf19$var$virtualWindow.document;
    $79564f678731bf19$var$fabric.jsdomImplForWrapper = (parcelRequire("l52Gj")).implForWrapper;
    $79564f678731bf19$var$fabric.nodeCanvas = (parcelRequire("l52Gj")).Canvas;
    $79564f678731bf19$var$fabric.window = $79564f678731bf19$var$virtualWindow;
    DOMParser = $79564f678731bf19$var$fabric.window.DOMParser;
}
/**
 * True when in environment that supports touch events
 * @type boolean
 */ $79564f678731bf19$var$fabric.isTouchSupported = 'ontouchstart' in $79564f678731bf19$var$fabric.window || 'ontouchstart' in $79564f678731bf19$var$fabric.document || $79564f678731bf19$var$fabric.window && $79564f678731bf19$var$fabric.window.navigator && $79564f678731bf19$var$fabric.window.navigator.maxTouchPoints > 0;
/**
 * True when in environment that's probably Node.js
 * @type boolean
 */ $79564f678731bf19$var$fabric.isLikelyNode = typeof $79564f678731bf19$require$Buffer !== 'undefined' && typeof window === 'undefined';
/* _FROM_SVG_START_ */ /**
 * Attributes parsed from all SVG elements
 * @type array
 */ $79564f678731bf19$var$fabric.SHARED_ATTRIBUTES = [
    'display',
    'transform',
    'fill',
    'fill-opacity',
    'fill-rule',
    'opacity',
    'stroke',
    'stroke-dasharray',
    'stroke-linecap',
    'stroke-dashoffset',
    'stroke-linejoin',
    'stroke-miterlimit',
    'stroke-opacity',
    'stroke-width',
    'id',
    'paint-order',
    'vector-effect',
    'instantiated_by_use',
    'clip-path'
];
/* _FROM_SVG_END_ */ /**
 * Pixel per Inch as a default value set to 96. Can be changed for more realistic conversion.
 */ $79564f678731bf19$var$fabric.DPI = 96;
$79564f678731bf19$var$fabric.reNum = '(?:[-+]?(?:\\d+|\\d*\\.\\d+)(?:[eE][-+]?\\d+)?)';
$79564f678731bf19$var$fabric.commaWsp = '(?:\\s+,?\\s*|,\\s*)';
$79564f678731bf19$var$fabric.rePathCommand = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:[eE][-+]?\d+)?)/ig;
$79564f678731bf19$var$fabric.reNonWord = /[ \n\.,;!\?\-]/;
$79564f678731bf19$var$fabric.fontPaths = {};
$79564f678731bf19$var$fabric.iMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
];
$79564f678731bf19$var$fabric.svgNS = 'http://www.w3.org/2000/svg';
/**
 * Pixel limit for cache canvases. 1Mpx , 4Mpx should be fine.
 * @since 1.7.14
 * @type Number
 * @default
 */ $79564f678731bf19$var$fabric.perfLimitSizeTotal = 2097152;
/**
 * Pixel limit for cache canvases width or height. IE fixes the maximum at 5000
 * @since 1.7.14
 * @type Number
 * @default
 */ $79564f678731bf19$var$fabric.maxCacheSideLimit = 4096;
/**
 * Lowest pixel limit for cache canvases, set at 256PX
 * @since 1.7.14
 * @type Number
 * @default
 */ $79564f678731bf19$var$fabric.minCacheSideLimit = 256;
/**
 * Cache Object for widths of chars in text rendering.
 */ $79564f678731bf19$var$fabric.charWidthsCache = {};
/**
 * if webgl is enabled and available, textureSize will determine the size
 * of the canvas backend
 * @since 2.0.0
 * @type Number
 * @default
 */ $79564f678731bf19$var$fabric.textureSize = 2048;
/**
 * When 'true', style information is not retained when copy/pasting text, making
 * pasted text use destination style.
 * Defaults to 'false'.
 * @type Boolean
 * @default
 */ $79564f678731bf19$var$fabric.disableStyleCopyPaste = false;
/**
 * Enable webgl for filtering picture is available
 * A filtering backend will be initialized, this will both take memory and
 * time since a default 2048x2048 canvas will be created for the gl context
 * @since 2.0.0
 * @type Boolean
 * @default
 */ $79564f678731bf19$var$fabric.enableGLFiltering = true;
/**
 * Device Pixel Ratio
 * @see https://developer.apple.com/library/safari/documentation/AudioVideo/Conceptual/HTML-canvas-guide/SettingUptheCanvas/SettingUptheCanvas.html
 */ $79564f678731bf19$var$fabric.devicePixelRatio = $79564f678731bf19$var$fabric.window.devicePixelRatio || $79564f678731bf19$var$fabric.window.webkitDevicePixelRatio || $79564f678731bf19$var$fabric.window.mozDevicePixelRatio || 1;
/**
 * Browser-specific constant to adjust CanvasRenderingContext2D.shadowBlur value,
 * which is unitless and not rendered equally across browsers.
 *
 * Values that work quite well (as of October 2017) are:
 * - Chrome: 1.5
 * - Edge: 1.75
 * - Firefox: 0.9
 * - Safari: 0.95
 *
 * @since 2.0.0
 * @type Number
 * @default 1
 */ $79564f678731bf19$var$fabric.browserShadowBlurConstant = 1;
/**
 * This object contains the result of arc to bezier conversion for faster retrieving if the same arc needs to be converted again.
 * It was an internal variable, is accessible since version 2.3.4
 */ $79564f678731bf19$var$fabric.arcToSegmentsCache = {};
/**
 * This object keeps the results of the boundsOfCurve calculation mapped by the joined arguments necessary to calculate it.
 * It does speed up calculation, if you parse and add always the same paths, but in case of heavy usage of freedrawing
 * you do not get any speed benefit and you get a big object in memory.
 * The object was a private variable before, while now is appended to the lib so that you have access to it and you
 * can eventually clear it.
 * It was an internal variable, is accessible since version 2.3.4
 */ $79564f678731bf19$var$fabric.boundsOfCurveCache = {};
/**
 * If disabled boundsOfCurveCache is not used. For apps that make heavy usage of pencil drawing probably disabling it is better
 * @default true
 */ $79564f678731bf19$var$fabric.cachesBoundsOfCurve = true;
/**
 * Skip performance testing of setupGLContext and force the use of putImageData that seems to be the one that works best on
 * Chrome + old hardware. if your users are experiencing empty images after filtering you may try to force this to true
 * this has to be set before instantiating the filtering backend ( before filtering the first image )
 * @type Boolean
 * @default false
 */ $79564f678731bf19$var$fabric.forceGLPutImageData = false;
$79564f678731bf19$var$fabric.initFilterBackend = function() {
    if ($79564f678731bf19$var$fabric.enableGLFiltering && $79564f678731bf19$var$fabric.isWebglSupported && $79564f678731bf19$var$fabric.isWebglSupported($79564f678731bf19$var$fabric.textureSize)) {
        console.log('max texture size: ' + $79564f678731bf19$var$fabric.maxTextureSize);
        return new $79564f678731bf19$var$fabric.WebglFilterBackend({
            tileSize: $79564f678731bf19$var$fabric.textureSize
        });
    } else if ($79564f678731bf19$var$fabric.Canvas2dFilterBackend) return new $79564f678731bf19$var$fabric.Canvas2dFilterBackend();
};
if (typeof document !== 'undefined' && typeof window !== 'undefined') // ensure globality even if entire library were function wrapped (as in Meteor.js packaging system)
window.fabric = $79564f678731bf19$var$fabric;
(function() {
    /**
   * @private
   * @param {String} eventName
   * @param {Function} handler
   */ function _removeEventListener(eventName, handler) {
        if (!this.__eventListeners[eventName]) return;
        var eventListener = this.__eventListeners[eventName];
        if (handler) eventListener[eventListener.indexOf(handler)] = false;
        else $79564f678731bf19$var$fabric.util.array.fill(eventListener, false);
    }
    /**
   * Observes specified event
   * @memberOf fabric.Observable
   * @alias on
   * @param {String|Object} eventName Event name (eg. 'after:render') or object with key/value pairs (eg. {'after:render': handler, 'selection:cleared': handler})
   * @param {Function} handler Function that receives a notification when an event of the specified type occurs
   * @return {Self} thisArg
   * @chainable
   */ function on(eventName, handler) {
        if (!this.__eventListeners) this.__eventListeners = {};
        // one object with key/value pairs was passed
        if (arguments.length === 1) for(var prop in eventName)this.on(prop, eventName[prop]);
        else {
            if (!this.__eventListeners[eventName]) this.__eventListeners[eventName] = [];
            this.__eventListeners[eventName].push(handler);
        }
        return this;
    }
    function _once(eventName, handler) {
        var _handler = (function() {
            handler.apply(this, arguments);
            this.off(eventName, _handler);
        }).bind(this);
        this.on(eventName, _handler);
    }
    function once(eventName, handler) {
        // one object with key/value pairs was passed
        if (arguments.length === 1) for(var prop in eventName)_once.call(this, prop, eventName[prop]);
        else _once.call(this, eventName, handler);
        return this;
    }
    /**
   * Stops event observing for a particular event handler. Calling this method
   * without arguments removes all handlers for all events
   * @memberOf fabric.Observable
   * @alias off
   * @param {String|Object} eventName Event name (eg. 'after:render') or object with key/value pairs (eg. {'after:render': handler, 'selection:cleared': handler})
   * @param {Function} handler Function to be deleted from EventListeners
   * @return {Self} thisArg
   * @chainable
   */ function off(eventName, handler) {
        if (!this.__eventListeners) return this;
        // remove all key/value pairs (event name -> event handler)
        if (arguments.length === 0) for(eventName in this.__eventListeners)_removeEventListener.call(this, eventName);
        else if (arguments.length === 1 && typeof arguments[0] === 'object') for(var prop in eventName)_removeEventListener.call(this, prop, eventName[prop]);
        else _removeEventListener.call(this, eventName, handler);
        return this;
    }
    /**
   * Fires event with an optional options object
   * @memberOf fabric.Observable
   * @param {String} eventName Event name to fire
   * @param {Object} [options] Options object
   * @return {Self} thisArg
   * @chainable
   */ function fire(eventName, options) {
        if (!this.__eventListeners) return this;
        var listenersForEvent = this.__eventListeners[eventName];
        if (!listenersForEvent) return this;
        for(var i = 0, len = listenersForEvent.length; i < len; i++)listenersForEvent[i] && listenersForEvent[i].call(this, options || {});
        this.__eventListeners[eventName] = listenersForEvent.filter(function(value) {
            return value !== false;
        });
        return this;
    }
    /**
   * @namespace fabric.Observable
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#events}
   * @see {@link http://fabricjs.com/events|Events demo}
   */ $79564f678731bf19$var$fabric.Observable = {
        fire: fire,
        on: on,
        once: once,
        off: off
    };
})();
/**
 * @namespace fabric.Collection
 */ $79564f678731bf19$var$fabric.Collection = {
    _objects: [],
    /**
   * Adds objects to collection, Canvas or Group, then renders canvas
   * (if `renderOnAddRemove` is not `false`).
   * in case of Group no changes to bounding box are made.
   * Objects should be instances of (or inherit from) fabric.Object
   * Use of this function is highly discouraged for groups.
   * you can add a bunch of objects with the add method but then you NEED
   * to run a addWithUpdate call for the Group class or position/bbox will be wrong.
   * @param {...fabric.Object} object Zero or more fabric instances
   * @return {Self} thisArg
   * @chainable
   */ add: function() {
        this._objects.push.apply(this._objects, arguments);
        if (this._onObjectAdded) for(var i = 0, length = arguments.length; i < length; i++)this._onObjectAdded(arguments[i]);
        this.renderOnAddRemove && this.requestRenderAll();
        return this;
    },
    /**
   * Inserts an object into collection at specified index, then renders canvas (if `renderOnAddRemove` is not `false`)
   * An object should be an instance of (or inherit from) fabric.Object
   * Use of this function is highly discouraged for groups.
   * you can add a bunch of objects with the insertAt method but then you NEED
   * to run a addWithUpdate call for the Group class or position/bbox will be wrong.
   * @param {Object} object Object to insert
   * @param {Number} index Index to insert object at
   * @param {Boolean} nonSplicing When `true`, no splicing (shifting) of objects occurs
   * @return {Self} thisArg
   * @chainable
   */ insertAt: function(object, index, nonSplicing) {
        var objects = this._objects;
        if (nonSplicing) objects[index] = object;
        else objects.splice(index, 0, object);
        this._onObjectAdded && this._onObjectAdded(object);
        this.renderOnAddRemove && this.requestRenderAll();
        return this;
    },
    /**
   * Removes objects from a collection, then renders canvas (if `renderOnAddRemove` is not `false`)
   * @param {...fabric.Object} object Zero or more fabric instances
   * @return {Self} thisArg
   * @chainable
   */ remove: function() {
        var objects = this._objects, index, somethingRemoved = false;
        for(var i = 0, length = arguments.length; i < length; i++){
            index = objects.indexOf(arguments[i]);
            // only call onObjectRemoved if an object was actually removed
            if (index !== -1) {
                somethingRemoved = true;
                objects.splice(index, 1);
                this._onObjectRemoved && this._onObjectRemoved(arguments[i]);
            }
        }
        this.renderOnAddRemove && somethingRemoved && this.requestRenderAll();
        return this;
    },
    /**
   * Executes given function for each object in this group
   * @param {Function} callback
   *                   Callback invoked with current object as first argument,
   *                   index - as second and an array of all objects - as third.
   *                   Callback is invoked in a context of Global Object (e.g. `window`)
   *                   when no `context` argument is given
   *
   * @param {Object} context Context (aka thisObject)
   * @return {Self} thisArg
   * @chainable
   */ forEachObject: function(callback, context) {
        var objects = this.getObjects();
        for(var i = 0, len = objects.length; i < len; i++)callback.call(context, objects[i], i, objects);
        return this;
    },
    /**
   * Returns an array of children objects of this instance
   * Type parameter introduced in 1.3.10
   * since 2.3.5 this method return always a COPY of the array;
   * @param {String} [type] When specified, only objects of this type are returned
   * @return {Array}
   */ getObjects: function(type) {
        if (typeof type === 'undefined') return this._objects.concat();
        return this._objects.filter(function(o) {
            return o.type === type;
        });
    },
    /**
   * Returns object at specified index
   * @param {Number} index
   * @return {Self} thisArg
   */ item: function(index) {
        return this._objects[index];
    },
    /**
   * Returns true if collection contains no objects
   * @return {Boolean} true if collection is empty
   */ isEmpty: function() {
        return this._objects.length === 0;
    },
    /**
   * Returns a size of a collection (i.e: length of an array containing its objects)
   * @return {Number} Collection size
   */ size: function() {
        return this._objects.length;
    },
    /**
   * Returns true if collection contains an object
   * @param {Object} object Object to check against
   * @param {Boolean} [deep=false] `true` to check all descendants, `false` to check only `_objects`
   * @return {Boolean} `true` if collection contains an object
   */ contains: function(object, deep) {
        if (this._objects.indexOf(object) > -1) return true;
        else if (deep) return this._objects.some(function(obj) {
            return typeof obj.contains === 'function' && obj.contains(object, true);
        });
        return false;
    },
    /**
   * Returns number representation of a collection complexity
   * @return {Number} complexity
   */ complexity: function() {
        return this._objects.reduce(function(memo, current) {
            memo += current.complexity ? current.complexity() : 0;
            return memo;
        }, 0);
    }
};
/**
 * @namespace fabric.CommonMethods
 */ $79564f678731bf19$var$fabric.CommonMethods = {
    /**
   * Sets object's properties from options
   * @param {Object} [options] Options object
   */ _setOptions: function(options) {
        for(var prop in options)this.set(prop, options[prop]);
    },
    /**
   * @private
   * @param {Object} [filler] Options object
   * @param {String} [property] property to set the Gradient to
   */ _initGradient: function(filler, property) {
        if (filler && filler.colorStops && !(filler instanceof $79564f678731bf19$var$fabric.Gradient)) this.set(property, new $79564f678731bf19$var$fabric.Gradient(filler));
    },
    /**
   * @private
   * @param {Object} [filler] Options object
   * @param {String} [property] property to set the Pattern to
   * @param {Function} [callback] callback to invoke after pattern load
   */ _initPattern: function(filler, property, callback) {
        if (filler && filler.source && !(filler instanceof $79564f678731bf19$var$fabric.Pattern)) this.set(property, new $79564f678731bf19$var$fabric.Pattern(filler, callback));
        else callback && callback();
    },
    /**
   * @private
   */ _setObject: function(obj) {
        for(var prop in obj)this._set(prop, obj[prop]);
    },
    /**
   * Sets property to a given value. When changing position/dimension -related properties (left, top, scale, angle, etc.) `set` does not update position of object's borders/controls. If you need to update those, call `setCoords()`.
   * @param {String|Object} key Property name or object (if object, iterate over the object properties)
   * @param {Object|Function} value Property value (if function, the value is passed into it and its return value is used as a new one)
   * @return {fabric.Object} thisArg
   * @chainable
   */ set: function(key, value) {
        if (typeof key === 'object') this._setObject(key);
        else this._set(key, value);
        return this;
    },
    _set: function(key, value) {
        this[key] = value;
    },
    /**
   * Toggles specified property from `true` to `false` or from `false` to `true`
   * @param {String} property Property to toggle
   * @return {fabric.Object} thisArg
   * @chainable
   */ toggle: function(property) {
        var value = this.get(property);
        if (typeof value === 'boolean') this.set(property, !value);
        return this;
    },
    /**
   * Basic getter
   * @param {String} property Property name
   * @return {*} value of a property
   */ get: function(property) {
        return this[property];
    }
};
(function(global) {
    var sqrt = Math.sqrt, atan2 = Math.atan2, pow = Math.pow, PiBy180 = Math.PI / 180, PiBy2 = Math.PI / 2;
    /**
   * @namespace fabric.util
   */ $79564f678731bf19$var$fabric.util = {
        /**
     * Calculate the cos of an angle, avoiding returning floats for known results
     * @static
     * @memberOf fabric.util
     * @param {Number} angle the angle in radians or in degree
     * @return {Number}
     */ cos: function(angle) {
            if (angle === 0) return 1;
            if (angle < 0) // cos(a) = cos(-a)
            angle = -angle;
            var angleSlice = angle / PiBy2;
            switch(angleSlice){
                case 1:
                case 3:
                    return 0;
                case 2:
                    return -1;
            }
            return Math.cos(angle);
        },
        /**
     * Calculate the sin of an angle, avoiding returning floats for known results
     * @static
     * @memberOf fabric.util
     * @param {Number} angle the angle in radians or in degree
     * @return {Number}
     */ sin: function(angle) {
            if (angle === 0) return 0;
            var angleSlice = angle / PiBy2, sign = 1;
            if (angle < 0) // sin(-a) = -sin(a)
            sign = -1;
            switch(angleSlice){
                case 1:
                    return sign;
                case 2:
                    return 0;
                case 3:
                    return -sign;
            }
            return Math.sin(angle);
        },
        /**
     * Removes value from an array.
     * Presence of value (and its position in an array) is determined via `Array.prototype.indexOf`
     * @static
     * @memberOf fabric.util
     * @param {Array} array
     * @param {*} value
     * @return {Array} original array
     */ removeFromArray: function(array, value) {
            var idx = array.indexOf(value);
            if (idx !== -1) array.splice(idx, 1);
            return array;
        },
        /**
     * Returns random number between 2 specified ones.
     * @static
     * @memberOf fabric.util
     * @param {Number} min lower limit
     * @param {Number} max upper limit
     * @return {Number} random value (between min and max)
     */ getRandomInt: function(min, max) {
            return Math.floor(Math.random() * (max - min + 1)) + min;
        },
        /**
     * Transforms degrees to radians.
     * @static
     * @memberOf fabric.util
     * @param {Number} degrees value in degrees
     * @return {Number} value in radians
     */ degreesToRadians: function(degrees) {
            return degrees * PiBy180;
        },
        /**
     * Transforms radians to degrees.
     * @static
     * @memberOf fabric.util
     * @param {Number} radians value in radians
     * @return {Number} value in degrees
     */ radiansToDegrees: function(radians) {
            return radians / PiBy180;
        },
        /**
     * Rotates `point` around `origin` with `radians`
     * @static
     * @memberOf fabric.util
     * @param {fabric.Point} point The point to rotate
     * @param {fabric.Point} origin The origin of the rotation
     * @param {Number} radians The radians of the angle for the rotation
     * @return {fabric.Point} The new rotated point
     */ rotatePoint: function(point, origin, radians) {
            var newPoint = new $79564f678731bf19$var$fabric.Point(point.x - origin.x, point.y - origin.y), v = $79564f678731bf19$var$fabric.util.rotateVector(newPoint, radians);
            return new $79564f678731bf19$var$fabric.Point(v.x, v.y).addEquals(origin);
        },
        /**
     * Rotates `vector` with `radians`
     * @static
     * @memberOf fabric.util
     * @param {Object} vector The vector to rotate (x and y)
     * @param {Number} radians The radians of the angle for the rotation
     * @return {Object} The new rotated point
     */ rotateVector: function(vector, radians) {
            var sin = $79564f678731bf19$var$fabric.util.sin(radians), cos = $79564f678731bf19$var$fabric.util.cos(radians), rx = vector.x * cos - vector.y * sin, ry = vector.x * sin + vector.y * cos;
            return {
                x: rx,
                y: ry
            };
        },
        /**
     * Creates a vetor from points represented as a point
     * @static
     * @memberOf fabric.util
     *
     * @typedef {Object} Point
     * @property {number} x
     * @property {number} y
     *
     * @param {Point} from
     * @param {Point} to
     * @returns {Point} vector
     */ createVector: function(from, to) {
            return new $79564f678731bf19$var$fabric.Point(to.x - from.x, to.y - from.y);
        },
        /**
     * Calculates angle between 2 vectors using dot product
     * @static
     * @memberOf fabric.util
     * @param {Point} a
     * @param {Point} b
     * @returns the angle in radian between the vectors
     */ calcAngleBetweenVectors: function(a, b) {
            return Math.acos((a.x * b.x + a.y * b.y) / (Math.hypot(a.x, a.y) * Math.hypot(b.x, b.y)));
        },
        /**
     * @static
     * @memberOf fabric.util
     * @param {Point} v
     * @returns {Point} vector representing the unit vector of pointing to the direction of `v`
     */ getHatVector: function(v) {
            return new $79564f678731bf19$var$fabric.Point(v.x, v.y).multiply(1 / Math.hypot(v.x, v.y));
        },
        /**
     * @static
     * @memberOf fabric.util
     * @param {Point} A
     * @param {Point} B
     * @param {Point} C
     * @returns {{ vector: Point, angle: number }} vector representing the bisector of A and A's angle
     */ getBisector: function(A, B, C) {
            var AB = $79564f678731bf19$var$fabric.util.createVector(A, B), AC = $79564f678731bf19$var$fabric.util.createVector(A, C);
            var alpha = $79564f678731bf19$var$fabric.util.calcAngleBetweenVectors(AB, AC);
            //  check if alpha is relative to AB->BC
            var ro = $79564f678731bf19$var$fabric.util.calcAngleBetweenVectors($79564f678731bf19$var$fabric.util.rotateVector(AB, alpha), AC);
            var phi = alpha * (ro === 0 ? 1 : -1) / 2;
            return {
                vector: $79564f678731bf19$var$fabric.util.getHatVector($79564f678731bf19$var$fabric.util.rotateVector(AB, phi)),
                angle: alpha
            };
        },
        /**
     * Project stroke width on points returning 2 projections for each point as follows:
     * - `miter`: 2 points corresponding to the outer boundary and the inner boundary of stroke.
     * - `bevel`: 2 points corresponding to the bevel boundaries, tangent to the bisector.
     * - `round`: same as `bevel`
     * Used to calculate object's bounding box
     * @static
     * @memberOf fabric.util
     * @param {Point[]} points
     * @param {Object} options
     * @param {number} options.strokeWidth
     * @param {'miter'|'bevel'|'round'} options.strokeLineJoin
     * @param {number} options.strokeMiterLimit https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/stroke-miterlimit
     * @param {boolean} options.strokeUniform
     * @param {number} options.scaleX
     * @param {number} options.scaleY
     * @param {boolean} [openPath] whether the shape is open or not, affects the calculations of the first and last points
     * @returns {fabric.Point[]} array of size 2n/4n of all suspected points
     */ projectStrokeOnPoints: function(points, options, openPath) {
            var coords = [], s = options.strokeWidth / 2, strokeUniformScalar = options.strokeUniform ? new $79564f678731bf19$var$fabric.Point(1 / options.scaleX, 1 / options.scaleY) : new $79564f678731bf19$var$fabric.Point(1, 1), getStrokeHatVector = function(v) {
                var scalar = s / Math.hypot(v.x, v.y);
                return new $79564f678731bf19$var$fabric.Point(v.x * scalar * strokeUniformScalar.x, v.y * scalar * strokeUniformScalar.y);
            };
            if (points.length <= 1) return coords;
            points.forEach(function(p, index) {
                var A = new $79564f678731bf19$var$fabric.Point(p.x, p.y), B, C;
                if (index === 0) {
                    C = points[index + 1];
                    B = openPath ? getStrokeHatVector($79564f678731bf19$var$fabric.util.createVector(C, A)).addEquals(A) : points[points.length - 1];
                } else if (index === points.length - 1) {
                    B = points[index - 1];
                    C = openPath ? getStrokeHatVector($79564f678731bf19$var$fabric.util.createVector(B, A)).addEquals(A) : points[0];
                } else {
                    B = points[index - 1];
                    C = points[index + 1];
                }
                var bisector = $79564f678731bf19$var$fabric.util.getBisector(A, B, C), bisectorVector = bisector.vector, alpha = bisector.angle, scalar, miterVector;
                if (options.strokeLineJoin === 'miter') {
                    scalar = -s / Math.sin(alpha / 2);
                    miterVector = new $79564f678731bf19$var$fabric.Point(bisectorVector.x * scalar * strokeUniformScalar.x, bisectorVector.y * scalar * strokeUniformScalar.y);
                    if (Math.hypot(miterVector.x, miterVector.y) / s <= options.strokeMiterLimit) {
                        coords.push(A.add(miterVector));
                        coords.push(A.subtract(miterVector));
                        return;
                    }
                }
                scalar = -s * Math.SQRT2;
                miterVector = new $79564f678731bf19$var$fabric.Point(bisectorVector.x * scalar * strokeUniformScalar.x, bisectorVector.y * scalar * strokeUniformScalar.y);
                coords.push(A.add(miterVector));
                coords.push(A.subtract(miterVector));
            });
            return coords;
        },
        /**
     * Apply transform t to point p
     * @static
     * @memberOf fabric.util
     * @param  {fabric.Point} p The point to transform
     * @param  {Array} t The transform
     * @param  {Boolean} [ignoreOffset] Indicates that the offset should not be applied
     * @return {fabric.Point} The transformed point
     */ transformPoint: function(p, t, ignoreOffset) {
            if (ignoreOffset) return new $79564f678731bf19$var$fabric.Point(t[0] * p.x + t[2] * p.y, t[1] * p.x + t[3] * p.y);
            return new $79564f678731bf19$var$fabric.Point(t[0] * p.x + t[2] * p.y + t[4], t[1] * p.x + t[3] * p.y + t[5]);
        },
        /**
     * Returns coordinates of points's bounding rectangle (left, top, width, height)
     * @param {Array} points 4 points array
     * @param {Array} [transform] an array of 6 numbers representing a 2x3 transform matrix
     * @return {Object} Object with left, top, width, height properties
     */ makeBoundingBoxFromPoints: function(points, transform) {
            if (transform) for(var i = 0; i < points.length; i++)points[i] = $79564f678731bf19$var$fabric.util.transformPoint(points[i], transform);
            var xPoints = [
                points[0].x,
                points[1].x,
                points[2].x,
                points[3].x
            ], minX = $79564f678731bf19$var$fabric.util.array.min(xPoints), maxX = $79564f678731bf19$var$fabric.util.array.max(xPoints), width = maxX - minX, yPoints = [
                points[0].y,
                points[1].y,
                points[2].y,
                points[3].y
            ], minY = $79564f678731bf19$var$fabric.util.array.min(yPoints), maxY = $79564f678731bf19$var$fabric.util.array.max(yPoints), height = maxY - minY;
            return {
                left: minX,
                top: minY,
                width: width,
                height: height
            };
        },
        /**
     * Invert transformation t
     * @static
     * @memberOf fabric.util
     * @param {Array} t The transform
     * @return {Array} The inverted transform
     */ invertTransform: function(t) {
            var a = 1 / (t[0] * t[3] - t[1] * t[2]), r = [
                a * t[3],
                -a * t[1],
                -a * t[2],
                a * t[0]
            ], o = $79564f678731bf19$var$fabric.util.transformPoint({
                x: t[4],
                y: t[5]
            }, r, true);
            r[4] = -o.x;
            r[5] = -o.y;
            return r;
        },
        /**
     * A wrapper around Number#toFixed, which contrary to native method returns number, not string.
     * @static
     * @memberOf fabric.util
     * @param {Number|String} number number to operate on
     * @param {Number} fractionDigits number of fraction digits to "leave"
     * @return {Number}
     */ toFixed: function(number, fractionDigits) {
            return parseFloat(Number(number).toFixed(fractionDigits));
        },
        /**
     * Converts from attribute value to pixel value if applicable.
     * Returns converted pixels or original value not converted.
     * @param {Number|String} value number to operate on
     * @param {Number} fontSize
     * @return {Number|String}
     */ parseUnit: function(value, fontSize) {
            var unit = /\D{0,2}$/.exec(value), number = parseFloat(value);
            if (!fontSize) fontSize = $79564f678731bf19$var$fabric.Text.DEFAULT_SVG_FONT_SIZE;
            switch(unit[0]){
                case 'mm':
                    return number * $79564f678731bf19$var$fabric.DPI / 25.4;
                case 'cm':
                    return number * $79564f678731bf19$var$fabric.DPI / 2.54;
                case 'in':
                    return number * $79564f678731bf19$var$fabric.DPI;
                case 'pt':
                    return number * $79564f678731bf19$var$fabric.DPI / 72; // or * 4 / 3
                case 'pc':
                    return number * $79564f678731bf19$var$fabric.DPI / 72 * 12; // or * 16
                case 'em':
                    return number * fontSize;
                default:
                    return number;
            }
        },
        /**
     * Function which always returns `false`.
     * @static
     * @memberOf fabric.util
     * @return {Boolean}
     */ falseFunction: function() {
            return false;
        },
        /**
     * Returns klass "Class" object of given namespace
     * @memberOf fabric.util
     * @param {String} type Type of object (eg. 'circle')
     * @param {String} namespace Namespace to get klass "Class" object from
     * @return {Object} klass "Class"
     */ getKlass: function(type, namespace) {
            // capitalize first letter only
            type = $79564f678731bf19$var$fabric.util.string.camelize(type.charAt(0).toUpperCase() + type.slice(1));
            return $79564f678731bf19$var$fabric.util.resolveNamespace(namespace)[type];
        },
        /**
     * Returns array of attributes for given svg that fabric parses
     * @memberOf fabric.util
     * @param {String} type Type of svg element (eg. 'circle')
     * @return {Array} string names of supported attributes
     */ getSvgAttributes: function(type) {
            var attributes = [
                'instantiated_by_use',
                'style',
                'id',
                'class'
            ];
            switch(type){
                case 'linearGradient':
                    attributes = attributes.concat([
                        'x1',
                        'y1',
                        'x2',
                        'y2',
                        'gradientUnits',
                        'gradientTransform'
                    ]);
                    break;
                case 'radialGradient':
                    attributes = attributes.concat([
                        'gradientUnits',
                        'gradientTransform',
                        'cx',
                        'cy',
                        'r',
                        'fx',
                        'fy',
                        'fr'
                    ]);
                    break;
                case 'stop':
                    attributes = attributes.concat([
                        'offset',
                        'stop-color',
                        'stop-opacity'
                    ]);
                    break;
            }
            return attributes;
        },
        /**
     * Returns object of given namespace
     * @memberOf fabric.util
     * @param {String} namespace Namespace string e.g. 'fabric.Image.filter' or 'fabric'
     * @return {Object} Object for given namespace (default fabric)
     */ resolveNamespace: function(namespace) {
            if (!namespace) return $79564f678731bf19$var$fabric;
            var parts = namespace.split('.'), len = parts.length, i, obj = global || $79564f678731bf19$var$fabric.window;
            for(i = 0; i < len; ++i)obj = obj[parts[i]];
            return obj;
        },
        /**
     * Loads image element from given url and passes it to a callback
     * @memberOf fabric.util
     * @param {String} url URL representing an image
     * @param {Function} callback Callback; invoked with loaded image
     * @param {*} [context] Context to invoke callback in
     * @param {Object} [crossOrigin] crossOrigin value to set image element to
     */ loadImage: function(url, callback, context, crossOrigin) {
            if (!url) {
                callback && callback.call(context, url);
                return;
            }
            var img = $79564f678731bf19$var$fabric.util.createImage();
            /** @ignore */ var onLoadCallback = function() {
                callback && callback.call(context, img, false);
                img = img.onload = img.onerror = null;
            };
            img.onload = onLoadCallback;
            /** @ignore */ img.onerror = function() {
                $79564f678731bf19$var$fabric.log('Error loading ' + img.src);
                callback && callback.call(context, null, true);
                img = img.onload = img.onerror = null;
            };
            // data-urls appear to be buggy with crossOrigin
            // https://github.com/kangax/fabric.js/commit/d0abb90f1cd5c5ef9d2a94d3fb21a22330da3e0a#commitcomment-4513767
            // see https://code.google.com/p/chromium/issues/detail?id=315152
            //     https://bugzilla.mozilla.org/show_bug.cgi?id=935069
            // crossOrigin null is the same as not set.
            if (url.indexOf('data') !== 0 && crossOrigin !== undefined && crossOrigin !== null) img.crossOrigin = crossOrigin;
            // IE10 / IE11-Fix: SVG contents from data: URI
            // will only be available if the IMG is present
            // in the DOM (and visible)
            if (url.substring(0, 14) === 'data:image/svg') {
                img.onload = null;
                $79564f678731bf19$var$fabric.util.loadImageInDom(img, onLoadCallback);
            }
            img.src = url;
        },
        /**
     * Attaches SVG image with data: URL to the dom
     * @memberOf fabric.util
     * @param {Object} img Image object with data:image/svg src
     * @param {Function} callback Callback; invoked with loaded image
     * @return {Object} DOM element (div containing the SVG image)
     */ loadImageInDom: function(img, onLoadCallback) {
            var div = $79564f678731bf19$var$fabric.document.createElement('div');
            div.style.width = div.style.height = '1px';
            div.style.left = div.style.top = '-100%';
            div.style.position = 'absolute';
            div.appendChild(img);
            $79564f678731bf19$var$fabric.document.querySelector('body').appendChild(div);
            /**
       * Wrap in function to:
       *   1. Call existing callback
       *   2. Cleanup DOM
       */ img.onload = function() {
                onLoadCallback();
                div.parentNode.removeChild(div);
                div = null;
            };
        },
        /**
     * Creates corresponding fabric instances from their object representations
     * @static
     * @memberOf fabric.util
     * @param {Array} objects Objects to enliven
     * @param {Function} callback Callback to invoke when all objects are created
     * @param {String} namespace Namespace to get klass "Class" object from
     * @param {Function} reviver Method for further parsing of object elements,
     * called after each fabric object created.
     */ enlivenObjects: function(objects, callback, namespace, reviver) {
            objects = objects || [];
            var enlivenedObjects = [], numLoadedObjects = 0, numTotalObjects = objects.length;
            function onLoaded() {
                if (++numLoadedObjects === numTotalObjects) callback && callback(enlivenedObjects.filter(function(obj) {
                    // filter out undefined objects (objects that gave error)
                    return obj;
                }));
            }
            if (!numTotalObjects) {
                callback && callback(enlivenedObjects);
                return;
            }
            objects.forEach(function(o, index) {
                // if sparse array
                if (!o || !o.type) {
                    onLoaded();
                    return;
                }
                var klass = $79564f678731bf19$var$fabric.util.getKlass(o.type, namespace);
                klass.fromObject(o, function(obj, error) {
                    error || (enlivenedObjects[index] = obj);
                    reviver && reviver(o, obj, error);
                    onLoaded();
                });
            });
        },
        /**
     * Creates corresponding fabric instances residing in an object, e.g. `clipPath`
     * @see {@link fabric.Object.ENLIVEN_PROPS}
     * @param {Object} object
     * @param {Object} [context] assign enlived props to this object (pass null to skip this)
     * @param {(objects:fabric.Object[]) => void} callback
     */ enlivenObjectEnlivables: function(object, context, callback) {
            var enlivenProps = $79564f678731bf19$var$fabric.Object.ENLIVEN_PROPS.filter(function(key) {
                return !!object[key];
            });
            $79564f678731bf19$var$fabric.util.enlivenObjects(enlivenProps.map(function(key) {
                return object[key];
            }), function(enlivedProps) {
                var objects = {};
                enlivenProps.forEach(function(key, index) {
                    objects[key] = enlivedProps[index];
                    context && (context[key] = enlivedProps[index]);
                });
                callback && callback(objects);
            });
        },
        /**
     * Create and wait for loading of patterns
     * @static
     * @memberOf fabric.util
     * @param {Array} patterns Objects to enliven
     * @param {Function} callback Callback to invoke when all objects are created
     * called after each fabric object created.
     */ enlivenPatterns: function(patterns, callback) {
            patterns = patterns || [];
            function onLoaded() {
                if (++numLoadedPatterns === numPatterns) callback && callback(enlivenedPatterns);
            }
            var enlivenedPatterns = [], numLoadedPatterns = 0, numPatterns = patterns.length;
            if (!numPatterns) {
                callback && callback(enlivenedPatterns);
                return;
            }
            patterns.forEach(function(p, index) {
                if (p && p.source) new $79564f678731bf19$var$fabric.Pattern(p, function(pattern) {
                    enlivenedPatterns[index] = pattern;
                    onLoaded();
                });
                else {
                    enlivenedPatterns[index] = p;
                    onLoaded();
                }
            });
        },
        /**
     * Groups SVG elements (usually those retrieved from SVG document)
     * @static
     * @memberOf fabric.util
     * @param {Array} elements SVG elements to group
     * @param {Object} [options] Options object
     * @param {String} path Value to set sourcePath to
     * @return {fabric.Object|fabric.Group}
     */ groupSVGElements: function(elements, options, path) {
            var object;
            if (elements && elements.length === 1) {
                if (typeof path !== 'undefined') elements[0].sourcePath = path;
                return elements[0];
            }
            if (options) {
                if (options.width && options.height) options.centerPoint = {
                    x: options.width / 2,
                    y: options.height / 2
                };
                else {
                    delete options.width;
                    delete options.height;
                }
            }
            object = new $79564f678731bf19$var$fabric.Group(elements, options);
            if (typeof path !== 'undefined') object.sourcePath = path;
            return object;
        },
        /**
     * Populates an object with properties of another object
     * @static
     * @memberOf fabric.util
     * @param {Object} source Source object
     * @param {Object} destination Destination object
     * @return {Array} properties Properties names to include
     */ populateWithProperties: function(source, destination, properties) {
            if (properties && Array.isArray(properties)) {
                for(var i = 0, len = properties.length; i < len; i++)if (properties[i] in source) destination[properties[i]] = source[properties[i]];
            }
        },
        /**
     * Creates canvas element
     * @static
     * @memberOf fabric.util
     * @return {CanvasElement} initialized canvas element
     */ createCanvasElement: function() {
            return $79564f678731bf19$var$fabric.document.createElement('canvas');
        },
        /**
     * Creates a canvas element that is a copy of another and is also painted
     * @param {CanvasElement} canvas to copy size and content of
     * @static
     * @memberOf fabric.util
     * @return {CanvasElement} initialized canvas element
     */ copyCanvasElement: function(canvas) {
            var newCanvas = $79564f678731bf19$var$fabric.util.createCanvasElement();
            newCanvas.width = canvas.width;
            newCanvas.height = canvas.height;
            newCanvas.getContext('2d').drawImage(canvas, 0, 0);
            return newCanvas;
        },
        /**
     * since 2.6.0 moved from canvas instance to utility.
     * @param {CanvasElement} canvasEl to copy size and content of
     * @param {String} format 'jpeg' or 'png', in some browsers 'webp' is ok too
     * @param {Number} quality <= 1 and > 0
     * @static
     * @memberOf fabric.util
     * @return {String} data url
     */ toDataURL: function(canvasEl, format, quality) {
            return canvasEl.toDataURL('image/' + format, quality);
        },
        /**
     * Creates image element (works on client and node)
     * @static
     * @memberOf fabric.util
     * @return {HTMLImageElement} HTML image element
     */ createImage: function() {
            return $79564f678731bf19$var$fabric.document.createElement('img');
        },
        /**
     * Multiply matrix A by matrix B to nest transformations
     * @static
     * @memberOf fabric.util
     * @param  {Array} a First transformMatrix
     * @param  {Array} b Second transformMatrix
     * @param  {Boolean} is2x2 flag to multiply matrices as 2x2 matrices
     * @return {Array} The product of the two transform matrices
     */ multiplyTransformMatrices: function(a, b, is2x2) {
            // Matrix multiply a * b
            return [
                a[0] * b[0] + a[2] * b[1],
                a[1] * b[0] + a[3] * b[1],
                a[0] * b[2] + a[2] * b[3],
                a[1] * b[2] + a[3] * b[3],
                is2x2 ? 0 : a[0] * b[4] + a[2] * b[5] + a[4],
                is2x2 ? 0 : a[1] * b[4] + a[3] * b[5] + a[5]
            ];
        },
        /**
     * Decomposes standard 2x3 matrix into transform components
     * @static
     * @memberOf fabric.util
     * @param  {Array} a transformMatrix
     * @return {Object} Components of transform
     */ qrDecompose: function(a) {
            var angle = atan2(a[1], a[0]), denom = pow(a[0], 2) + pow(a[1], 2), scaleX = sqrt(denom), scaleY = (a[0] * a[3] - a[2] * a[1]) / scaleX, skewX = atan2(a[0] * a[2] + a[1] * a[3], denom);
            return {
                angle: angle / PiBy180,
                scaleX: scaleX,
                scaleY: scaleY,
                skewX: skewX / PiBy180,
                skewY: 0,
                translateX: a[4],
                translateY: a[5]
            };
        },
        /**
     * Returns a transform matrix starting from an object of the same kind of
     * the one returned from qrDecompose, useful also if you want to calculate some
     * transformations from an object that is not enlived yet
     * @static
     * @memberOf fabric.util
     * @param  {Object} options
     * @param  {Number} [options.angle] angle in degrees
     * @return {Number[]} transform matrix
     */ calcRotateMatrix: function(options) {
            if (!options.angle) return $79564f678731bf19$var$fabric.iMatrix.concat();
            var theta = $79564f678731bf19$var$fabric.util.degreesToRadians(options.angle), cos = $79564f678731bf19$var$fabric.util.cos(theta), sin = $79564f678731bf19$var$fabric.util.sin(theta);
            return [
                cos,
                sin,
                -sin,
                cos,
                0,
                0
            ];
        },
        /**
     * Returns a transform matrix starting from an object of the same kind of
     * the one returned from qrDecompose, useful also if you want to calculate some
     * transformations from an object that is not enlived yet.
     * is called DimensionsTransformMatrix because those properties are the one that influence
     * the size of the resulting box of the object.
     * @static
     * @memberOf fabric.util
     * @param  {Object} options
     * @param  {Number} [options.scaleX]
     * @param  {Number} [options.scaleY]
     * @param  {Boolean} [options.flipX]
     * @param  {Boolean} [options.flipY]
     * @param  {Number} [options.skewX]
     * @param  {Number} [options.skewY]
     * @return {Number[]} transform matrix
     */ calcDimensionsMatrix: function(options) {
            var scaleX = typeof options.scaleX === 'undefined' ? 1 : options.scaleX, scaleY = typeof options.scaleY === 'undefined' ? 1 : options.scaleY, scaleMatrix = [
                options.flipX ? -scaleX : scaleX,
                0,
                0,
                options.flipY ? -scaleY : scaleY,
                0,
                0
            ], multiply = $79564f678731bf19$var$fabric.util.multiplyTransformMatrices, degreesToRadians = $79564f678731bf19$var$fabric.util.degreesToRadians;
            if (options.skewX) scaleMatrix = multiply(scaleMatrix, [
                1,
                0,
                Math.tan(degreesToRadians(options.skewX)),
                1
            ], true);
            if (options.skewY) scaleMatrix = multiply(scaleMatrix, [
                1,
                Math.tan(degreesToRadians(options.skewY)),
                0,
                1
            ], true);
            return scaleMatrix;
        },
        /**
     * Returns a transform matrix starting from an object of the same kind of
     * the one returned from qrDecompose, useful also if you want to calculate some
     * transformations from an object that is not enlived yet
     * @static
     * @memberOf fabric.util
     * @param  {Object} options
     * @param  {Number} [options.angle]
     * @param  {Number} [options.scaleX]
     * @param  {Number} [options.scaleY]
     * @param  {Boolean} [options.flipX]
     * @param  {Boolean} [options.flipY]
     * @param  {Number} [options.skewX]
     * @param  {Number} [options.skewX]
     * @param  {Number} [options.translateX]
     * @param  {Number} [options.translateY]
     * @return {Number[]} transform matrix
     */ composeMatrix: function(options) {
            var matrix = [
                1,
                0,
                0,
                1,
                options.translateX || 0,
                options.translateY || 0
            ], multiply = $79564f678731bf19$var$fabric.util.multiplyTransformMatrices;
            if (options.angle) matrix = multiply(matrix, $79564f678731bf19$var$fabric.util.calcRotateMatrix(options));
            if (options.scaleX !== 1 || options.scaleY !== 1 || options.skewX || options.skewY || options.flipX || options.flipY) matrix = multiply(matrix, $79564f678731bf19$var$fabric.util.calcDimensionsMatrix(options));
            return matrix;
        },
        /**
     * reset an object transform state to neutral. Top and left are not accounted for
     * @static
     * @memberOf fabric.util
     * @param  {fabric.Object} target object to transform
     */ resetObjectTransform: function(target) {
            target.scaleX = 1;
            target.scaleY = 1;
            target.skewX = 0;
            target.skewY = 0;
            target.flipX = false;
            target.flipY = false;
            target.rotate(0);
        },
        /**
     * Extract Object transform values
     * @static
     * @memberOf fabric.util
     * @param  {fabric.Object} target object to read from
     * @return {Object} Components of transform
     */ saveObjectTransform: function(target) {
            return {
                scaleX: target.scaleX,
                scaleY: target.scaleY,
                skewX: target.skewX,
                skewY: target.skewY,
                angle: target.angle,
                left: target.left,
                flipX: target.flipX,
                flipY: target.flipY,
                top: target.top
            };
        },
        /**
     * Returns true if context has transparent pixel
     * at specified location (taking tolerance into account)
     * @param {CanvasRenderingContext2D} ctx context
     * @param {Number} x x coordinate
     * @param {Number} y y coordinate
     * @param {Number} tolerance Tolerance
     */ isTransparent: function(ctx, x, y, tolerance) {
            // If tolerance is > 0 adjust start coords to take into account.
            // If moves off Canvas fix to 0
            if (tolerance > 0) {
                if (x > tolerance) x -= tolerance;
                else x = 0;
                if (y > tolerance) y -= tolerance;
                else y = 0;
            }
            var _isTransparent = true, i, temp, imageData = ctx.getImageData(x, y, tolerance * 2 || 1, tolerance * 2 || 1), l = imageData.data.length;
            // Split image data - for tolerance > 1, pixelDataSize = 4;
            for(i = 3; i < l; i += 4){
                temp = imageData.data[i];
                _isTransparent = temp <= 0;
                if (_isTransparent === false) break; // Stop if colour found
            }
            imageData = null;
            return _isTransparent;
        },
        /**
     * Parse preserveAspectRatio attribute from element
     * @param {string} attribute to be parsed
     * @return {Object} an object containing align and meetOrSlice attribute
     */ parsePreserveAspectRatioAttribute: function(attribute) {
            var meetOrSlice = 'meet', alignX = 'Mid', alignY = 'Mid', aspectRatioAttrs = attribute.split(' '), align;
            if (aspectRatioAttrs && aspectRatioAttrs.length) {
                meetOrSlice = aspectRatioAttrs.pop();
                if (meetOrSlice !== 'meet' && meetOrSlice !== 'slice') {
                    align = meetOrSlice;
                    meetOrSlice = 'meet';
                } else if (aspectRatioAttrs.length) align = aspectRatioAttrs.pop();
            }
            //divide align in alignX and alignY
            alignX = align !== 'none' ? align.slice(1, 4) : 'none';
            alignY = align !== 'none' ? align.slice(5, 8) : 'none';
            return {
                meetOrSlice: meetOrSlice,
                alignX: alignX,
                alignY: alignY
            };
        },
        /**
     * Clear char widths cache for the given font family or all the cache if no
     * fontFamily is specified.
     * Use it if you know you are loading fonts in a lazy way and you are not waiting
     * for custom fonts to load properly when adding text objects to the canvas.
     * If a text object is added when its own font is not loaded yet, you will get wrong
     * measurement and so wrong bounding boxes.
     * After the font cache is cleared, either change the textObject text content or call
     * initDimensions() to trigger a recalculation
     * @memberOf fabric.util
     * @param {String} [fontFamily] font family to clear
     */ clearFabricFontCache: function(fontFamily) {
            fontFamily = (fontFamily || '').toLowerCase();
            if (!fontFamily) $79564f678731bf19$var$fabric.charWidthsCache = {};
            else if ($79564f678731bf19$var$fabric.charWidthsCache[fontFamily]) delete $79564f678731bf19$var$fabric.charWidthsCache[fontFamily];
        },
        /**
     * Given current aspect ratio, determines the max width and height that can
     * respect the total allowed area for the cache.
     * @memberOf fabric.util
     * @param {Number} ar aspect ratio
     * @param {Number} maximumArea Maximum area you want to achieve
     * @return {Object.x} Limited dimensions by X
     * @return {Object.y} Limited dimensions by Y
     */ limitDimsByArea: function(ar, maximumArea) {
            var roughWidth = Math.sqrt(maximumArea * ar), perfLimitSizeY = Math.floor(maximumArea / roughWidth);
            return {
                x: Math.floor(roughWidth),
                y: perfLimitSizeY
            };
        },
        capValue: function(min, value, max) {
            return Math.max(min, Math.min(value, max));
        },
        /**
     * Finds the scale for the object source to fit inside the object destination,
     * keeping aspect ratio intact.
     * respect the total allowed area for the cache.
     * @memberOf fabric.util
     * @param {Object | fabric.Object} source
     * @param {Number} source.height natural unscaled height of the object
     * @param {Number} source.width natural unscaled width of the object
     * @param {Object | fabric.Object} destination
     * @param {Number} destination.height natural unscaled height of the object
     * @param {Number} destination.width natural unscaled width of the object
     * @return {Number} scale factor to apply to source to fit into destination
     */ findScaleToFit: function(source, destination) {
            return Math.min(destination.width / source.width, destination.height / source.height);
        },
        /**
     * Finds the scale for the object source to cover entirely the object destination,
     * keeping aspect ratio intact.
     * respect the total allowed area for the cache.
     * @memberOf fabric.util
     * @param {Object | fabric.Object} source
     * @param {Number} source.height natural unscaled height of the object
     * @param {Number} source.width natural unscaled width of the object
     * @param {Object | fabric.Object} destination
     * @param {Number} destination.height natural unscaled height of the object
     * @param {Number} destination.width natural unscaled width of the object
     * @return {Number} scale factor to apply to source to cover destination
     */ findScaleToCover: function(source, destination) {
            return Math.max(destination.width / source.width, destination.height / source.height);
        },
        /**
     * given an array of 6 number returns something like `"matrix(...numbers)"`
     * @memberOf fabric.util
     * @param {Array} transform an array with 6 numbers
     * @return {String} transform matrix for svg
     * @return {Object.y} Limited dimensions by Y
     */ matrixToSVG: function(transform) {
            return 'matrix(' + transform.map(function(value) {
                return $79564f678731bf19$var$fabric.util.toFixed(value, $79564f678731bf19$var$fabric.Object.NUM_FRACTION_DIGITS);
            }).join(' ') + ')';
        },
        /**
     * given an object and a transform, apply the inverse transform to the object,
     * this is equivalent to remove from that object that transformation, so that
     * added in a space with the removed transform, the object will be the same as before.
     * Removing from an object a transform that scale by 2 is like scaling it by 1/2.
     * Removing from an object a transfrom that rotate by 30deg is like rotating by 30deg
     * in the opposite direction.
     * This util is used to add objects inside transformed groups or nested groups.
     * @memberOf fabric.util
     * @param {fabric.Object} object the object you want to transform
     * @param {Array} transform the destination transform
     */ removeTransformFromObject: function(object, transform) {
            var inverted = $79564f678731bf19$var$fabric.util.invertTransform(transform), finalTransform = $79564f678731bf19$var$fabric.util.multiplyTransformMatrices(inverted, object.calcOwnMatrix());
            $79564f678731bf19$var$fabric.util.applyTransformToObject(object, finalTransform);
        },
        /**
     * given an object and a transform, apply the transform to the object.
     * this is equivalent to change the space where the object is drawn.
     * Adding to an object a transform that scale by 2 is like scaling it by 2.
     * This is used when removing an object from an active selection for example.
     * @memberOf fabric.util
     * @param {fabric.Object} object the object you want to transform
     * @param {Array} transform the destination transform
     */ addTransformToObject: function(object, transform) {
            $79564f678731bf19$var$fabric.util.applyTransformToObject(object, $79564f678731bf19$var$fabric.util.multiplyTransformMatrices(transform, object.calcOwnMatrix()));
        },
        /**
     * discard an object transform state and apply the one from the matrix.
     * @memberOf fabric.util
     * @param {fabric.Object} object the object you want to transform
     * @param {Array} transform the destination transform
     */ applyTransformToObject: function(object, transform) {
            var options = $79564f678731bf19$var$fabric.util.qrDecompose(transform), center = new $79564f678731bf19$var$fabric.Point(options.translateX, options.translateY);
            object.flipX = false;
            object.flipY = false;
            object.set('scaleX', options.scaleX);
            object.set('scaleY', options.scaleY);
            object.skewX = options.skewX;
            object.skewY = options.skewY;
            object.angle = options.angle;
            object.setPositionByOrigin(center, 'center', 'center');
        },
        /**
     * given a width and height, return the size of the bounding box
     * that can contains the box with width/height with applied transform
     * described in options.
     * Use to calculate the boxes around objects for controls.
     * @memberOf fabric.util
     * @param {Number} width
     * @param {Number} height
     * @param {Object} options
     * @param {Number} options.scaleX
     * @param {Number} options.scaleY
     * @param {Number} options.skewX
     * @param {Number} options.skewY
     * @return {Object.x} width of containing
     * @return {Object.y} height of containing
     */ sizeAfterTransform: function(width, height, options) {
            var dimX = width / 2, dimY = height / 2, points = [
                {
                    x: -dimX,
                    y: -dimY
                },
                {
                    x: dimX,
                    y: -dimY
                },
                {
                    x: -dimX,
                    y: dimY
                },
                {
                    x: dimX,
                    y: dimY
                }
            ], transformMatrix = $79564f678731bf19$var$fabric.util.calcDimensionsMatrix(options), bbox = $79564f678731bf19$var$fabric.util.makeBoundingBoxFromPoints(points, transformMatrix);
            return {
                x: bbox.width,
                y: bbox.height
            };
        },
        /**
     * Merges 2 clip paths into one visually equal clip path
     *
     * **IMPORTANT**:\
     * Does **NOT** clone the arguments, clone them proir if necessary.
     *
     * Creates a wrapper (group) that contains one clip path and is clipped by the other so content is kept where both overlap.
     * Use this method if both the clip paths may have nested clip paths of their own, so assigning one to the other's clip path property is not possible.
     *
     * In order to handle the `inverted` property we follow logic described in the following cases:\
     * **(1)** both clip paths are inverted - the clip paths pass the inverted prop to the wrapper and loose it themselves.\
     * **(2)** one is inverted and the other isn't - the wrapper shouldn't become inverted and the inverted clip path must clip the non inverted one to produce an identical visual effect.\
     * **(3)** both clip paths are not inverted - wrapper and clip paths remain unchanged.
     *
     * @memberOf fabric.util
     * @param {fabric.Object} c1
     * @param {fabric.Object} c2
     * @returns {fabric.Object} merged clip path
     */ mergeClipPaths: function(c1, c2) {
            var a = c1, b = c2;
            if (a.inverted && !b.inverted) {
                //  case (2)
                a = c2;
                b = c1;
            }
            //  `b` becomes `a`'s clip path so we transform `b` to `a` coordinate plane
            $79564f678731bf19$var$fabric.util.applyTransformToObject(b, $79564f678731bf19$var$fabric.util.multiplyTransformMatrices($79564f678731bf19$var$fabric.util.invertTransform(a.calcTransformMatrix()), b.calcTransformMatrix()));
            //  assign the `inverted` prop to the wrapping group
            var inverted = a.inverted && b.inverted;
            if (inverted) //  case (1)
            a.inverted = b.inverted = false;
            return new $79564f678731bf19$var$fabric.Group([
                a
            ], {
                clipPath: b,
                inverted: inverted
            });
        },
        /**
     * @memberOf fabric.util
     * @param {Object} prevStyle first style to compare
     * @param {Object} thisStyle second style to compare
     * @param {boolean} forTextSpans whether to check overline, underline, and line-through properties
     * @return {boolean} true if the style changed
     */ hasStyleChanged: function(prevStyle, thisStyle, forTextSpans) {
            forTextSpans = forTextSpans || false;
            return prevStyle.fill !== thisStyle.fill || prevStyle.stroke !== thisStyle.stroke || prevStyle.strokeWidth !== thisStyle.strokeWidth || prevStyle.fontSize !== thisStyle.fontSize || prevStyle.fontFamily !== thisStyle.fontFamily || prevStyle.fontWeight !== thisStyle.fontWeight || prevStyle.fontStyle !== thisStyle.fontStyle || prevStyle.textBackgroundColor !== thisStyle.textBackgroundColor || prevStyle.deltaY !== thisStyle.deltaY || forTextSpans && (prevStyle.overline !== thisStyle.overline || prevStyle.underline !== thisStyle.underline || prevStyle.linethrough !== thisStyle.linethrough);
        },
        /**
     * Returns the array form of a text object's inline styles property with styles grouped in ranges
     * rather than per character. This format is less verbose, and is better suited for storage
     * so it is used in serialization (not during runtime).
     * @memberOf fabric.util
     * @param {object} styles per character styles for a text object
     * @param {String} text the text string that the styles are applied to
     * @return {{start: number, end: number, style: object}[]}
     */ stylesToArray: function(styles, text) {
            // clone style structure to prevent mutation
            var styles = $79564f678731bf19$var$fabric.util.object.clone(styles, true), textLines = text.split('\n'), charIndex = -1, prevStyle = {}, stylesArray = [];
            //loop through each textLine
            for(var i = 0; i < textLines.length; i++){
                if (!styles[i]) {
                    //no styles exist for this line, so add the line's length to the charIndex total
                    charIndex += textLines[i].length;
                    continue;
                }
                //loop through each character of the current line
                for(var c = 0; c < textLines[i].length; c++){
                    charIndex++;
                    var thisStyle = styles[i][c];
                    //check if style exists for this character
                    if (thisStyle && Object.keys(thisStyle).length > 0) {
                        var styleChanged = $79564f678731bf19$var$fabric.util.hasStyleChanged(prevStyle, thisStyle, true);
                        if (styleChanged) stylesArray.push({
                            start: charIndex,
                            end: charIndex + 1,
                            style: thisStyle
                        });
                        else //if style is the same as previous character, increase end index
                        stylesArray[stylesArray.length - 1].end++;
                    }
                    prevStyle = thisStyle || {};
                }
            }
            return stylesArray;
        },
        /**
     * Returns the object form of the styles property with styles that are assigned per
     * character rather than grouped by range. This format is more verbose, and is
     * only used during runtime (not for serialization/storage)
     * @memberOf fabric.util
     * @param {Array} styles the serialized form of a text object's styles
     * @param {String} text the text string that the styles are applied to
     * @return {Object}
     */ stylesFromArray: function(styles, text) {
            if (!Array.isArray(styles)) return styles;
            var textLines = text.split('\n'), charIndex = -1, styleIndex = 0, stylesObject = {};
            //loop through each textLine
            for(var i = 0; i < textLines.length; i++)//loop through each character of the current line
            for(var c = 0; c < textLines[i].length; c++){
                charIndex++;
                //check if there's a style collection that includes the current character
                if (styles[styleIndex] && styles[styleIndex].start <= charIndex && charIndex < styles[styleIndex].end) {
                    //create object for line index if it doesn't exist
                    stylesObject[i] = stylesObject[i] || {};
                    //assign a style at this character's index
                    stylesObject[i][c] = Object.assign({}, styles[styleIndex].style);
                    //if character is at the end of the current style collection, move to the next
                    if (charIndex === styles[styleIndex].end - 1) styleIndex++;
                }
            }
            return stylesObject;
        }
    };
})($79564f678731bf19$exports);
(function() {
    var _join = Array.prototype.join, commandLengths = {
        m: 2,
        l: 2,
        h: 1,
        v: 1,
        c: 6,
        s: 4,
        q: 4,
        t: 2,
        a: 7
    }, repeatedCommands = {
        m: 'l',
        M: 'L'
    };
    function segmentToBezier(th2, th3, cosTh, sinTh, rx, ry, cx1, cy1, mT, fromX, fromY) {
        var costh2 = $79564f678731bf19$var$fabric.util.cos(th2), sinth2 = $79564f678731bf19$var$fabric.util.sin(th2), costh3 = $79564f678731bf19$var$fabric.util.cos(th3), sinth3 = $79564f678731bf19$var$fabric.util.sin(th3), toX = cosTh * rx * costh3 - sinTh * ry * sinth3 + cx1, toY = sinTh * rx * costh3 + cosTh * ry * sinth3 + cy1, cp1X = fromX + mT * (-cosTh * rx * sinth2 - sinTh * ry * costh2), cp1Y = fromY + mT * (-sinTh * rx * sinth2 + cosTh * ry * costh2), cp2X = toX + mT * (cosTh * rx * sinth3 + sinTh * ry * costh3), cp2Y = toY + mT * (sinTh * rx * sinth3 - cosTh * ry * costh3);
        return [
            'C',
            cp1X,
            cp1Y,
            cp2X,
            cp2Y,
            toX,
            toY
        ];
    }
    /* Adapted from http://dxr.mozilla.org/mozilla-central/source/content/svg/content/src/nsSVGPathDataParser.cpp
   * by Andrea Bogazzi code is under MPL. if you don't have a copy of the license you can take it here
   * http://mozilla.org/MPL/2.0/
   */ function arcToSegments(toX, toY, rx, ry, large, sweep, rotateX) {
        var PI = Math.PI, th = rotateX * PI / 180, sinTh = $79564f678731bf19$var$fabric.util.sin(th), cosTh = $79564f678731bf19$var$fabric.util.cos(th), fromX = 0, fromY = 0;
        rx = Math.abs(rx);
        ry = Math.abs(ry);
        var px = -cosTh * toX * 0.5 - sinTh * toY * 0.5, py = -cosTh * toY * 0.5 + sinTh * toX * 0.5, rx2 = rx * rx, ry2 = ry * ry, py2 = py * py, px2 = px * px, pl = rx2 * ry2 - rx2 * py2 - ry2 * px2, root = 0;
        if (pl < 0) {
            var s = Math.sqrt(1 - pl / (rx2 * ry2));
            rx *= s;
            ry *= s;
        } else root = (large === sweep ? -1 : 1.0) * Math.sqrt(pl / (rx2 * py2 + ry2 * px2));
        var cx = root * rx * py / ry, cy = -root * ry * px / rx, cx1 = cosTh * cx - sinTh * cy + toX * 0.5, cy1 = sinTh * cx + cosTh * cy + toY * 0.5, mTheta = calcVectorAngle(1, 0, (px - cx) / rx, (py - cy) / ry), dtheta = calcVectorAngle((px - cx) / rx, (py - cy) / ry, (-px - cx) / rx, (-py - cy) / ry);
        if (sweep === 0 && dtheta > 0) dtheta -= 2 * PI;
        else if (sweep === 1 && dtheta < 0) dtheta += 2 * PI;
        // Convert into cubic bezier segments <= 90deg
        var segments = Math.ceil(Math.abs(dtheta / PI * 2)), result = [], mDelta = dtheta / segments, mT = 8 / 3 * Math.sin(mDelta / 4) * Math.sin(mDelta / 4) / Math.sin(mDelta / 2), th3 = mTheta + mDelta;
        for(var i = 0; i < segments; i++){
            result[i] = segmentToBezier(mTheta, th3, cosTh, sinTh, rx, ry, cx1, cy1, mT, fromX, fromY);
            fromX = result[i][5];
            fromY = result[i][6];
            mTheta = th3;
            th3 += mDelta;
        }
        return result;
    }
    /*
   * Private
   */ function calcVectorAngle(ux, uy, vx, vy) {
        var ta = Math.atan2(uy, ux), tb = Math.atan2(vy, vx);
        if (tb >= ta) return tb - ta;
        else return 2 * Math.PI - (ta - tb);
    }
    /**
   * Calculate bounding box of a beziercurve
   * @param {Number} x0 starting point
   * @param {Number} y0
   * @param {Number} x1 first control point
   * @param {Number} y1
   * @param {Number} x2 secondo control point
   * @param {Number} y2
   * @param {Number} x3 end of bezier
   * @param {Number} y3
   */ // taken from http://jsbin.com/ivomiq/56/edit  no credits available for that.
    // TODO: can we normalize this with the starting points set at 0 and then translated the bbox?
    function getBoundsOfCurve(x0, y0, x1, y1, x2, y2, x3, y3) {
        var argsString;
        if ($79564f678731bf19$var$fabric.cachesBoundsOfCurve) {
            argsString = _join.call(arguments);
            if ($79564f678731bf19$var$fabric.boundsOfCurveCache[argsString]) return $79564f678731bf19$var$fabric.boundsOfCurveCache[argsString];
        }
        var sqrt = Math.sqrt, min = Math.min, max = Math.max, abs = Math.abs, tvalues = [], bounds = [
            [],
            []
        ], a, b, c, t, t1, t2, b2ac, sqrtb2ac;
        b = 6 * x0 - 12 * x1 + 6 * x2;
        a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
        c = 3 * x1 - 3 * x0;
        for(var i = 0; i < 2; ++i){
            if (i > 0) {
                b = 6 * y0 - 12 * y1 + 6 * y2;
                a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
                c = 3 * y1 - 3 * y0;
            }
            if (abs(a) < 1e-12) {
                if (abs(b) < 1e-12) continue;
                t = -c / b;
                if (0 < t && t < 1) tvalues.push(t);
                continue;
            }
            b2ac = b * b - 4 * c * a;
            if (b2ac < 0) continue;
            sqrtb2ac = sqrt(b2ac);
            t1 = (-b + sqrtb2ac) / (2 * a);
            if (0 < t1 && t1 < 1) tvalues.push(t1);
            t2 = (-b - sqrtb2ac) / (2 * a);
            if (0 < t2 && t2 < 1) tvalues.push(t2);
        }
        var x, y, j = tvalues.length, jlen = j, mt;
        while(j--){
            t = tvalues[j];
            mt = 1 - t;
            x = mt * mt * mt * x0 + 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t * x3;
            bounds[0][j] = x;
            y = mt * mt * mt * y0 + 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t * y3;
            bounds[1][j] = y;
        }
        bounds[0][jlen] = x0;
        bounds[1][jlen] = y0;
        bounds[0][jlen + 1] = x3;
        bounds[1][jlen + 1] = y3;
        var result = [
            {
                x: min.apply(null, bounds[0]),
                y: min.apply(null, bounds[1])
            },
            {
                x: max.apply(null, bounds[0]),
                y: max.apply(null, bounds[1])
            }
        ];
        if ($79564f678731bf19$var$fabric.cachesBoundsOfCurve) $79564f678731bf19$var$fabric.boundsOfCurveCache[argsString] = result;
        return result;
    }
    /**
   * Converts arc to a bunch of bezier curves
   * @param {Number} fx starting point x
   * @param {Number} fy starting point y
   * @param {Array} coords Arc command
   */ function fromArcToBeziers(fx, fy, coords) {
        var rx = coords[1], ry = coords[2], rot = coords[3], large = coords[4], sweep = coords[5], tx = coords[6], ty = coords[7], segsNorm = arcToSegments(tx - fx, ty - fy, rx, ry, large, sweep, rot);
        for(var i = 0, len = segsNorm.length; i < len; i++){
            segsNorm[i][1] += fx;
            segsNorm[i][2] += fy;
            segsNorm[i][3] += fx;
            segsNorm[i][4] += fy;
            segsNorm[i][5] += fx;
            segsNorm[i][6] += fy;
        }
        return segsNorm;
    }
    /**
   * This function take a parsed SVG path and make it simpler for fabricJS logic.
   * simplification consist of: only UPPERCASE absolute commands ( relative converted to absolute )
   * S converted in C, T converted in Q, A converted in C.
   * @param {Array} path the array of commands of a parsed svg path for fabric.Path
   * @return {Array} the simplified array of commands of a parsed svg path for fabric.Path
   */ function makePathSimpler(path) {
        // x and y represent the last point of the path. the previous command point.
        // we add them to each relative command to make it an absolute comment.
        // we also swap the v V h H with L, because are easier to transform.
        var x = 0, y = 0, len = path.length, // x1 and y1 represent the last point of the subpath. the subpath is started with
        // m or M command. When a z or Z command is drawn, x and y need to be resetted to
        // the last x1 and y1.
        x1 = 0, y1 = 0, current, i, converted, // previous will host the letter of the previous command, to handle S and T.
        // controlX and controlY will host the previous reflected control point
        destinationPath = [], previous, controlX, controlY;
        for(i = 0; i < len; ++i){
            converted = false;
            current = path[i].slice(0);
            switch(current[0]){
                case 'l':
                    current[0] = 'L';
                    current[1] += x;
                    current[2] += y;
                // falls through
                case 'L':
                    x = current[1];
                    y = current[2];
                    break;
                case 'h':
                    current[1] += x;
                // falls through
                case 'H':
                    current[0] = 'L';
                    current[2] = y;
                    x = current[1];
                    break;
                case 'v':
                    current[1] += y;
                // falls through
                case 'V':
                    current[0] = 'L';
                    y = current[1];
                    current[1] = x;
                    current[2] = y;
                    break;
                case 'm':
                    current[0] = 'M';
                    current[1] += x;
                    current[2] += y;
                // falls through
                case 'M':
                    x = current[1];
                    y = current[2];
                    x1 = current[1];
                    y1 = current[2];
                    break;
                case 'c':
                    current[0] = 'C';
                    current[1] += x;
                    current[2] += y;
                    current[3] += x;
                    current[4] += y;
                    current[5] += x;
                    current[6] += y;
                // falls through
                case 'C':
                    controlX = current[3];
                    controlY = current[4];
                    x = current[5];
                    y = current[6];
                    break;
                case 's':
                    current[0] = 'S';
                    current[1] += x;
                    current[2] += y;
                    current[3] += x;
                    current[4] += y;
                // falls through
                case 'S':
                    // would be sScC but since we are swapping sSc for C, we check just that.
                    if (previous === 'C') {
                        // calculate reflection of previous control points
                        controlX = 2 * x - controlX;
                        controlY = 2 * y - controlY;
                    } else {
                        // If there is no previous command or if the previous command was not a C, c, S, or s,
                        // the control point is coincident with the current point
                        controlX = x;
                        controlY = y;
                    }
                    x = current[3];
                    y = current[4];
                    current[0] = 'C';
                    current[5] = current[3];
                    current[6] = current[4];
                    current[3] = current[1];
                    current[4] = current[2];
                    current[1] = controlX;
                    current[2] = controlY;
                    // current[3] and current[4] are NOW the second control point.
                    // we keep it for the next reflection.
                    controlX = current[3];
                    controlY = current[4];
                    break;
                case 'q':
                    current[0] = 'Q';
                    current[1] += x;
                    current[2] += y;
                    current[3] += x;
                    current[4] += y;
                // falls through
                case 'Q':
                    controlX = current[1];
                    controlY = current[2];
                    x = current[3];
                    y = current[4];
                    break;
                case 't':
                    current[0] = 'T';
                    current[1] += x;
                    current[2] += y;
                // falls through
                case 'T':
                    if (previous === 'Q') {
                        // calculate reflection of previous control point
                        controlX = 2 * x - controlX;
                        controlY = 2 * y - controlY;
                    } else {
                        // If there is no previous command or if the previous command was not a Q, q, T or t,
                        // assume the control point is coincident with the current point
                        controlX = x;
                        controlY = y;
                    }
                    current[0] = 'Q';
                    x = current[1];
                    y = current[2];
                    current[1] = controlX;
                    current[2] = controlY;
                    current[3] = x;
                    current[4] = y;
                    break;
                case 'a':
                    current[0] = 'A';
                    current[6] += x;
                    current[7] += y;
                // falls through
                case 'A':
                    converted = true;
                    destinationPath = destinationPath.concat(fromArcToBeziers(x, y, current));
                    x = current[6];
                    y = current[7];
                    break;
                case 'z':
                case 'Z':
                    x = x1;
                    y = y1;
                    break;
                default:
            }
            if (!converted) destinationPath.push(current);
            previous = current[0];
        }
        return destinationPath;
    }
    /**
   * Calc length from point x1,y1 to x2,y2
   * @param {Number} x1 starting point x
   * @param {Number} y1 starting point y
   * @param {Number} x2 starting point x
   * @param {Number} y2 starting point y
   * @return {Number} length of segment
   */ function calcLineLength(x1, y1, x2, y2) {
        return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }
    // functions for the Cubic beizer
    // taken from: https://github.com/konvajs/konva/blob/7.0.5/src/shapes/Path.ts#L350
    function CB1(t) {
        return t * t * t;
    }
    function CB2(t) {
        return 3 * t * t * (1 - t);
    }
    function CB3(t) {
        return 3 * t * (1 - t) * (1 - t);
    }
    function CB4(t) {
        return (1 - t) * (1 - t) * (1 - t);
    }
    function getPointOnCubicBezierIterator(p1x, p1y, p2x, p2y, p3x, p3y, p4x, p4y) {
        return function(pct) {
            var c1 = CB1(pct), c2 = CB2(pct), c3 = CB3(pct), c4 = CB4(pct);
            return {
                x: p4x * c1 + p3x * c2 + p2x * c3 + p1x * c4,
                y: p4y * c1 + p3y * c2 + p2y * c3 + p1y * c4
            };
        };
    }
    function getTangentCubicIterator(p1x, p1y, p2x, p2y, p3x, p3y, p4x, p4y) {
        return function(pct) {
            var invT = 1 - pct, tangentX = 3 * invT * invT * (p2x - p1x) + 6 * invT * pct * (p3x - p2x) + 3 * pct * pct * (p4x - p3x), tangentY = 3 * invT * invT * (p2y - p1y) + 6 * invT * pct * (p3y - p2y) + 3 * pct * pct * (p4y - p3y);
            return Math.atan2(tangentY, tangentX);
        };
    }
    function QB1(t) {
        return t * t;
    }
    function QB2(t) {
        return 2 * t * (1 - t);
    }
    function QB3(t) {
        return (1 - t) * (1 - t);
    }
    function getPointOnQuadraticBezierIterator(p1x, p1y, p2x, p2y, p3x, p3y) {
        return function(pct) {
            var c1 = QB1(pct), c2 = QB2(pct), c3 = QB3(pct);
            return {
                x: p3x * c1 + p2x * c2 + p1x * c3,
                y: p3y * c1 + p2y * c2 + p1y * c3
            };
        };
    }
    function getTangentQuadraticIterator(p1x, p1y, p2x, p2y, p3x, p3y) {
        return function(pct) {
            var invT = 1 - pct, tangentX = 2 * invT * (p2x - p1x) + 2 * pct * (p3x - p2x), tangentY = 2 * invT * (p2y - p1y) + 2 * pct * (p3y - p2y);
            return Math.atan2(tangentY, tangentX);
        };
    }
    // this will run over a path segment ( a cubic or quadratic segment) and approximate it
    // with 100 segemnts. This will good enough to calculate the length of the curve
    function pathIterator(iterator, x1, y1) {
        var tempP = {
            x: x1,
            y: y1
        }, p, tmpLen = 0, perc;
        for(perc = 1; perc <= 100; perc += 1){
            p = iterator(perc / 100);
            tmpLen += calcLineLength(tempP.x, tempP.y, p.x, p.y);
            tempP = p;
        }
        return tmpLen;
    }
    /**
   * Given a pathInfo, and a distance in pixels, find the percentage from 0 to 1
   * that correspond to that pixels run over the path.
   * The percentage will be then used to find the correct point on the canvas for the path.
   * @param {Array} segInfo fabricJS collection of information on a parsed path
   * @param {Number} distance from starting point, in pixels.
   * @return {Object} info object with x and y ( the point on canvas ) and angle, the tangent on that point;
   */ function findPercentageForDistance(segInfo, distance) {
        var perc = 0, tmpLen = 0, iterator = segInfo.iterator, tempP = {
            x: segInfo.x,
            y: segInfo.y
        }, p, nextLen, nextStep = 0.01, angleFinder = segInfo.angleFinder, lastPerc;
        // nextStep > 0.0001 covers 0.00015625 that 1/64th of 1/100
        // the path
        while(tmpLen < distance && nextStep > 0.0001){
            p = iterator(perc);
            lastPerc = perc;
            nextLen = calcLineLength(tempP.x, tempP.y, p.x, p.y);
            // compare tmpLen each cycle with distance, decide next perc to test.
            if (nextLen + tmpLen > distance) {
                // we discard this step and we make smaller steps.
                perc -= nextStep;
                nextStep /= 2;
            } else {
                tempP = p;
                perc += nextStep;
                tmpLen += nextLen;
            }
        }
        p.angle = angleFinder(lastPerc);
        return p;
    }
    /**
   * Run over a parsed and simplifed path and extrac some informations.
   * informations are length of each command and starting point
   * @param {Array} path fabricJS parsed path commands
   * @return {Array} path commands informations
   */ function getPathSegmentsInfo(path) {
        var totalLength = 0, len = path.length, current, //x2 and y2 are the coords of segment start
        //x1 and y1 are the coords of the current point
        x1 = 0, y1 = 0, x2 = 0, y2 = 0, info = [], iterator, tempInfo, angleFinder;
        for(var i = 0; i < len; i++){
            current = path[i];
            tempInfo = {
                x: x1,
                y: y1,
                command: current[0]
            };
            switch(current[0]){
                case 'M':
                    tempInfo.length = 0;
                    x2 = x1 = current[1];
                    y2 = y1 = current[2];
                    break;
                case 'L':
                    tempInfo.length = calcLineLength(x1, y1, current[1], current[2]);
                    x1 = current[1];
                    y1 = current[2];
                    break;
                case 'C':
                    iterator = getPointOnCubicBezierIterator(x1, y1, current[1], current[2], current[3], current[4], current[5], current[6]);
                    angleFinder = getTangentCubicIterator(x1, y1, current[1], current[2], current[3], current[4], current[5], current[6]);
                    tempInfo.iterator = iterator;
                    tempInfo.angleFinder = angleFinder;
                    tempInfo.length = pathIterator(iterator, x1, y1);
                    x1 = current[5];
                    y1 = current[6];
                    break;
                case 'Q':
                    iterator = getPointOnQuadraticBezierIterator(x1, y1, current[1], current[2], current[3], current[4]);
                    angleFinder = getTangentQuadraticIterator(x1, y1, current[1], current[2], current[3], current[4]);
                    tempInfo.iterator = iterator;
                    tempInfo.angleFinder = angleFinder;
                    tempInfo.length = pathIterator(iterator, x1, y1);
                    x1 = current[3];
                    y1 = current[4];
                    break;
                case 'Z':
                case 'z':
                    // we add those in order to ease calculations later
                    tempInfo.destX = x2;
                    tempInfo.destY = y2;
                    tempInfo.length = calcLineLength(x1, y1, x2, y2);
                    x1 = x2;
                    y1 = y2;
                    break;
            }
            totalLength += tempInfo.length;
            info.push(tempInfo);
        }
        info.push({
            length: totalLength,
            x: x1,
            y: y1
        });
        return info;
    }
    function getPointOnPath(path, distance, infos) {
        if (!infos) infos = getPathSegmentsInfo(path);
        var i = 0;
        while(distance - infos[i].length > 0 && i < infos.length - 2){
            distance -= infos[i].length;
            i++;
        }
        // var distance = infos[infos.length - 1] * perc;
        var segInfo = infos[i], segPercent = distance / segInfo.length, command = segInfo.command, segment = path[i], info;
        switch(command){
            case 'M':
                return {
                    x: segInfo.x,
                    y: segInfo.y,
                    angle: 0
                };
            case 'Z':
            case 'z':
                info = new $79564f678731bf19$var$fabric.Point(segInfo.x, segInfo.y).lerp(new $79564f678731bf19$var$fabric.Point(segInfo.destX, segInfo.destY), segPercent);
                info.angle = Math.atan2(segInfo.destY - segInfo.y, segInfo.destX - segInfo.x);
                return info;
            case 'L':
                info = new $79564f678731bf19$var$fabric.Point(segInfo.x, segInfo.y).lerp(new $79564f678731bf19$var$fabric.Point(segment[1], segment[2]), segPercent);
                info.angle = Math.atan2(segment[2] - segInfo.y, segment[1] - segInfo.x);
                return info;
            case 'C':
                return findPercentageForDistance(segInfo, distance);
            case 'Q':
                return findPercentageForDistance(segInfo, distance);
        }
    }
    /**
   *
   * @param {string} pathString
   * @return {(string|number)[][]} An array of SVG path commands
   * @example <caption>Usage</caption>
   * parsePath('M 3 4 Q 3 5 2 1 4 0 Q 9 12 2 1 4 0') === [
   *   ['M', 3, 4],
   *   ['Q', 3, 5, 2, 1, 4, 0],
   *   ['Q', 9, 12, 2, 1, 4, 0],
   * ];
   *
   */ function parsePath(pathString) {
        var result = [], coords = [], currentPath, parsed, re = $79564f678731bf19$var$fabric.rePathCommand, rNumber = '[-+]?(?:\\d*\\.\\d+|\\d+\\.?)(?:[eE][-+]?\\d+)?\\s*', rNumberCommaWsp = '(' + rNumber + ')' + $79564f678731bf19$var$fabric.commaWsp, rFlagCommaWsp = '([01])' + $79564f678731bf19$var$fabric.commaWsp + '?', rArcSeq = rNumberCommaWsp + '?' + rNumberCommaWsp + '?' + rNumberCommaWsp + rFlagCommaWsp + rFlagCommaWsp + rNumberCommaWsp + '?(' + rNumber + ')', regArcArgumentSequence = new RegExp(rArcSeq, 'g'), match, coordsStr, // one of commands (m,M,l,L,q,Q,c,C,etc.) followed by non-command characters (i.e. command values)
        path;
        if (!pathString || !pathString.match) return result;
        path = pathString.match(/[mzlhvcsqta][^mzlhvcsqta]*/gi);
        for(var i = 0, coordsParsed, len = path.length; i < len; i++){
            currentPath = path[i];
            coordsStr = currentPath.slice(1).trim();
            coords.length = 0;
            var command = currentPath.charAt(0);
            coordsParsed = [
                command
            ];
            if (command.toLowerCase() === 'a') {
                // arcs have special flags that apparently don't require spaces so handle special
                for(var args; args = regArcArgumentSequence.exec(coordsStr);)for(var j = 1; j < args.length; j++)coords.push(args[j]);
            } else while(match = re.exec(coordsStr))coords.push(match[0]);
            for(var j = 0, jlen = coords.length; j < jlen; j++){
                parsed = parseFloat(coords[j]);
                if (!isNaN(parsed)) coordsParsed.push(parsed);
            }
            var commandLength = commandLengths[command.toLowerCase()], repeatedCommand = repeatedCommands[command] || command;
            if (coordsParsed.length - 1 > commandLength) for(var k = 1, klen = coordsParsed.length; k < klen; k += commandLength){
                result.push([
                    command
                ].concat(coordsParsed.slice(k, k + commandLength)));
                command = repeatedCommand;
            }
            else result.push(coordsParsed);
        }
        return result;
    }
    /**
   *
   * Converts points to a smooth SVG path
   * @param {{ x: number,y: number }[]} points Array of points
   * @param {number} [correction] Apply a correction to the path (usually we use `width / 1000`). If value is undefined 0 is used as the correction value.
   * @return {(string|number)[][]} An array of SVG path commands
   */ function getSmoothPathFromPoints(points, correction) {
        var path = [], i, p1 = new $79564f678731bf19$var$fabric.Point(points[0].x, points[0].y), p2 = new $79564f678731bf19$var$fabric.Point(points[1].x, points[1].y), len = points.length, multSignX = 1, multSignY = 0, manyPoints = len > 2;
        correction = correction || 0;
        if (manyPoints) {
            multSignX = points[2].x < p2.x ? -1 : points[2].x === p2.x ? 0 : 1;
            multSignY = points[2].y < p2.y ? -1 : points[2].y === p2.y ? 0 : 1;
        }
        path.push([
            'M',
            p1.x - multSignX * correction,
            p1.y - multSignY * correction
        ]);
        for(i = 1; i < len; i++){
            if (!p1.eq(p2)) {
                var midPoint = p1.midPointFrom(p2);
                // p1 is our bezier control point
                // midpoint is our endpoint
                // start point is p(i-1) value.
                path.push([
                    'Q',
                    p1.x,
                    p1.y,
                    midPoint.x,
                    midPoint.y
                ]);
            }
            p1 = points[i];
            if (i + 1 < points.length) p2 = points[i + 1];
        }
        if (manyPoints) {
            multSignX = p1.x > points[i - 2].x ? 1 : p1.x === points[i - 2].x ? 0 : -1;
            multSignY = p1.y > points[i - 2].y ? 1 : p1.y === points[i - 2].y ? 0 : -1;
        }
        path.push([
            'L',
            p1.x + multSignX * correction,
            p1.y + multSignY * correction
        ]);
        return path;
    }
    /**
   * Transform a path by transforming each segment.
   * it has to be a simplified path or it won't work.
   * WARNING: this depends from pathOffset for correct operation
   * @param {Array} path fabricJS parsed and simplified path commands
   * @param {Array} transform matrix that represent the transformation
   * @param {Object} [pathOffset] the fabric.Path pathOffset
   * @param {Number} pathOffset.x
   * @param {Number} pathOffset.y
   * @returns {Array} the transformed path
   */ function transformPath(path, transform, pathOffset) {
        if (pathOffset) transform = $79564f678731bf19$var$fabric.util.multiplyTransformMatrices(transform, [
            1,
            0,
            0,
            1,
            -pathOffset.x,
            -pathOffset.y
        ]);
        return path.map(function(pathSegment) {
            var newSegment = pathSegment.slice(0), point = {};
            for(var i = 1; i < pathSegment.length - 1; i += 2){
                point.x = pathSegment[i];
                point.y = pathSegment[i + 1];
                point = $79564f678731bf19$var$fabric.util.transformPoint(point, transform);
                newSegment[i] = point.x;
                newSegment[i + 1] = point.y;
            }
            return newSegment;
        });
    }
    /**
   * Join path commands to go back to svg format
   * @param {Array} pathData fabricJS parsed path commands
   * @return {String} joined path 'M 0 0 L 20 30'
   */ $79564f678731bf19$var$fabric.util.joinPath = function(pathData) {
        return pathData.map(function(segment) {
            return segment.join(' ');
        }).join(' ');
    };
    $79564f678731bf19$var$fabric.util.parsePath = parsePath;
    $79564f678731bf19$var$fabric.util.makePathSimpler = makePathSimpler;
    $79564f678731bf19$var$fabric.util.getSmoothPathFromPoints = getSmoothPathFromPoints;
    $79564f678731bf19$var$fabric.util.getPathSegmentsInfo = getPathSegmentsInfo;
    $79564f678731bf19$var$fabric.util.getBoundsOfCurve = getBoundsOfCurve;
    $79564f678731bf19$var$fabric.util.getPointOnPath = getPointOnPath;
    $79564f678731bf19$var$fabric.util.transformPath = transformPath;
})();
(function() {
    var slice = Array.prototype.slice;
    /**
   * Invokes method on all items in a given array
   * @memberOf fabric.util.array
   * @param {Array} array Array to iterate over
   * @param {String} method Name of a method to invoke
   * @return {Array}
   */ function invoke(array, method) {
        var args = slice.call(arguments, 2), result = [];
        for(var i = 0, len = array.length; i < len; i++)result[i] = args.length ? array[i][method].apply(array[i], args) : array[i][method].call(array[i]);
        return result;
    }
    /**
   * Finds maximum value in array (not necessarily "first" one)
   * @memberOf fabric.util.array
   * @param {Array} array Array to iterate over
   * @param {String} byProperty
   * @return {*}
   */ function max(array, byProperty) {
        return find(array, byProperty, function(value1, value2) {
            return value1 >= value2;
        });
    }
    /**
   * Finds minimum value in array (not necessarily "first" one)
   * @memberOf fabric.util.array
   * @param {Array} array Array to iterate over
   * @param {String} byProperty
   * @return {*}
   */ function min(array, byProperty) {
        return find(array, byProperty, function(value1, value2) {
            return value1 < value2;
        });
    }
    /**
   * @private
   */ function fill(array, value) {
        var k = array.length;
        while(k--)array[k] = value;
        return array;
    }
    /**
   * @private
   */ function find(array, byProperty, condition) {
        if (!array || array.length === 0) return;
        var i = array.length - 1, result = byProperty ? array[i][byProperty] : array[i];
        if (byProperty) {
            while(i--)if (condition(array[i][byProperty], result)) result = array[i][byProperty];
        } else {
            while(i--)if (condition(array[i], result)) result = array[i];
        }
        return result;
    }
    /**
   * @namespace fabric.util.array
   */ $79564f678731bf19$var$fabric.util.array = {
        fill: fill,
        invoke: invoke,
        min: min,
        max: max
    };
})();
(function() {
    /**
   * Copies all enumerable properties of one js object to another
   * this does not and cannot compete with generic utils.
   * Does not clone or extend fabric.Object subclasses.
   * This is mostly for internal use and has extra handling for fabricJS objects
   * it skips the canvas and group properties in deep cloning.
   * @memberOf fabric.util.object
   * @param {Object} destination Where to copy to
   * @param {Object} source Where to copy from
   * @param {Boolean} [deep] Whether to extend nested objects
   * @return {Object}
   */ function extend(destination, source, deep) {
        // JScript DontEnum bug is not taken care of
        // the deep clone is for internal use, is not meant to avoid
        // javascript traps or cloning html element or self referenced objects.
        if (deep) {
            if (!$79564f678731bf19$var$fabric.isLikelyNode && source instanceof Element) // avoid cloning deep images, canvases,
            destination = source;
            else if (source instanceof Array) {
                destination = [];
                for(var i = 0, len = source.length; i < len; i++)destination[i] = extend({}, source[i], deep);
            } else if (source && typeof source === 'object') for(var property in source){
                if (property === 'canvas' || property === 'group') // we do not want to clone this props at all.
                // we want to keep the keys in the copy
                destination[property] = null;
                else if (source.hasOwnProperty(property)) destination[property] = extend({}, source[property], deep);
            }
            else // this sounds odd for an extend but is ok for recursive use
            destination = source;
        } else for(var property in source)destination[property] = source[property];
        return destination;
    }
    /**
   * Creates an empty object and copies all enumerable properties of another object to it
   * This method is mostly for internal use, and not intended for duplicating shapes in canvas. 
   * @memberOf fabric.util.object
   * @param {Object} object Object to clone
   * @param {Boolean} [deep] Whether to clone nested objects
   * @return {Object}
   */ //TODO: this function return an empty object if you try to clone null
    function clone(object, deep) {
        return extend({}, object, deep);
    }
    /** @namespace fabric.util.object */ $79564f678731bf19$var$fabric.util.object = {
        extend: extend,
        clone: clone
    };
    $79564f678731bf19$var$fabric.util.object.extend($79564f678731bf19$var$fabric.util, $79564f678731bf19$var$fabric.Observable);
})();
(function() {
    /**
   * Camelizes a string
   * @memberOf fabric.util.string
   * @param {String} string String to camelize
   * @return {String} Camelized version of a string
   */ function camelize(string) {
        return string.replace(/-+(.)?/g, function(match, character) {
            return character ? character.toUpperCase() : '';
        });
    }
    /**
   * Capitalizes a string
   * @memberOf fabric.util.string
   * @param {String} string String to capitalize
   * @param {Boolean} [firstLetterOnly] If true only first letter is capitalized
   * and other letters stay untouched, if false first letter is capitalized
   * and other letters are converted to lowercase.
   * @return {String} Capitalized version of a string
   */ function capitalize(string, firstLetterOnly) {
        return string.charAt(0).toUpperCase() + (firstLetterOnly ? string.slice(1) : string.slice(1).toLowerCase());
    }
    /**
   * Escapes XML in a string
   * @memberOf fabric.util.string
   * @param {String} string String to escape
   * @return {String} Escaped version of a string
   */ function escapeXml(string) {
        return string.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&apos;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    /**
   * Divide a string in the user perceived single units
   * @memberOf fabric.util.string
   * @param {String} textstring String to escape
   * @return {Array} array containing the graphemes
   */ function graphemeSplit(textstring) {
        var i = 0, chr, graphemes = [];
        for(i = 0, chr; i < textstring.length; i++){
            if ((chr = getWholeChar(textstring, i)) === false) continue;
            graphemes.push(chr);
        }
        return graphemes;
    }
    // taken from mdn in the charAt doc page.
    function getWholeChar(str, i) {
        var code = str.charCodeAt(i);
        if (isNaN(code)) return ''; // Position not found
        if (code < 0xD800 || code > 0xDFFF) return str.charAt(i);
        // High surrogate (could change last hex to 0xDB7F to treat high private
        // surrogates as single characters)
        if (0xD800 <= code && code <= 0xDBFF) {
            if (str.length <= i + 1) throw 'High surrogate without following low surrogate';
            var next = str.charCodeAt(i + 1);
            if (0xDC00 > next || next > 0xDFFF) throw 'High surrogate without following low surrogate';
            return str.charAt(i) + str.charAt(i + 1);
        }
        // Low surrogate (0xDC00 <= code && code <= 0xDFFF)
        if (i === 0) throw 'Low surrogate without preceding high surrogate';
        var prev = str.charCodeAt(i - 1);
        // (could change last hex to 0xDB7F to treat high private
        // surrogates as single characters)
        if (0xD800 > prev || prev > 0xDBFF) throw 'Low surrogate without preceding high surrogate';
        // We can pass over low surrogates now as the second component
        // in a pair which we have already processed
        return false;
    }
    /**
   * String utilities
   * @namespace fabric.util.string
   */ $79564f678731bf19$var$fabric.util.string = {
        camelize: camelize,
        capitalize: capitalize,
        escapeXml: escapeXml,
        graphemeSplit: graphemeSplit
    };
})();
(function() {
    var slice = Array.prototype.slice, emptyFunction = function() {}, IS_DONTENUM_BUGGY = function() {
        for(var p in {
            toString: 1
        }){
            if (p === 'toString') return false;
        }
        return true;
    }(), /** @ignore */ addMethods = function(klass, source, parent) {
        for(var property in source){
            if (property in klass.prototype && typeof klass.prototype[property] === 'function' && (source[property] + '').indexOf('callSuper') > -1) klass.prototype[property] = function(property) {
                return function() {
                    var superclass = this.constructor.superclass;
                    this.constructor.superclass = parent;
                    var returnValue = source[property].apply(this, arguments);
                    this.constructor.superclass = superclass;
                    if (property !== 'initialize') return returnValue;
                };
            }(property);
            else klass.prototype[property] = source[property];
            if (IS_DONTENUM_BUGGY) {
                if (source.toString !== Object.prototype.toString) klass.prototype.toString = source.toString;
                if (source.valueOf !== Object.prototype.valueOf) klass.prototype.valueOf = source.valueOf;
            }
        }
    };
    function Subclass() {}
    function callSuper(methodName) {
        var parentMethod = null, _this = this;
        // climb prototype chain to find method not equal to callee's method
        while(_this.constructor.superclass){
            var superClassMethod = _this.constructor.superclass.prototype[methodName];
            if (_this[methodName] !== superClassMethod) {
                parentMethod = superClassMethod;
                break;
            }
            // eslint-disable-next-line
            _this = _this.constructor.superclass.prototype;
        }
        if (!parentMethod) return console.log('tried to callSuper ' + methodName + ', method not found in prototype chain', this);
        return arguments.length > 1 ? parentMethod.apply(this, slice.call(arguments, 1)) : parentMethod.call(this);
    }
    /**
   * Helper for creation of "classes".
   * @memberOf fabric.util
   * @param {Function} [parent] optional "Class" to inherit from
   * @param {Object} [properties] Properties shared by all instances of this class
   *                  (be careful modifying objects defined here as this would affect all instances)
   */ function createClass() {
        var parent = null, properties = slice.call(arguments, 0);
        if (typeof properties[0] === 'function') parent = properties.shift();
        function klass() {
            this.initialize.apply(this, arguments);
        }
        klass.superclass = parent;
        klass.subclasses = [];
        if (parent) {
            Subclass.prototype = parent.prototype;
            klass.prototype = new Subclass();
            parent.subclasses.push(klass);
        }
        for(var i = 0, length = properties.length; i < length; i++)addMethods(klass, properties[i], parent);
        if (!klass.prototype.initialize) klass.prototype.initialize = emptyFunction;
        klass.prototype.constructor = klass;
        klass.prototype.callSuper = callSuper;
        return klass;
    }
    $79564f678731bf19$var$fabric.util.createClass = createClass;
})();
(function() {
    // since ie11 can use addEventListener but they do not support options, i need to check
    var couldUseAttachEvent = !!$79564f678731bf19$var$fabric.document.createElement('div').attachEvent, touchEvents = [
        'touchstart',
        'touchmove',
        'touchend'
    ];
    /**
   * Adds an event listener to an element
   * @function
   * @memberOf fabric.util
   * @param {HTMLElement} element
   * @param {String} eventName
   * @param {Function} handler
   */ $79564f678731bf19$var$fabric.util.addListener = function(element, eventName, handler, options) {
        element && element.addEventListener(eventName, handler, couldUseAttachEvent ? false : options);
    };
    /**
   * Removes an event listener from an element
   * @function
   * @memberOf fabric.util
   * @param {HTMLElement} element
   * @param {String} eventName
   * @param {Function} handler
   */ $79564f678731bf19$var$fabric.util.removeListener = function(element, eventName, handler, options) {
        element && element.removeEventListener(eventName, handler, couldUseAttachEvent ? false : options);
    };
    function getTouchInfo(event) {
        var touchProp = event.changedTouches;
        if (touchProp && touchProp[0]) return touchProp[0];
        return event;
    }
    $79564f678731bf19$var$fabric.util.getPointer = function(event) {
        var element = event.target, scroll = $79564f678731bf19$var$fabric.util.getScrollLeftTop(element), _evt = getTouchInfo(event);
        return {
            x: _evt.clientX + scroll.left,
            y: _evt.clientY + scroll.top
        };
    };
    $79564f678731bf19$var$fabric.util.isTouchEvent = function(event) {
        return touchEvents.indexOf(event.type) > -1 || event.pointerType === 'touch';
    };
})();
(function() {
    /**
   * Cross-browser wrapper for setting element's style
   * @memberOf fabric.util
   * @param {HTMLElement} element
   * @param {Object} styles
   * @return {HTMLElement} Element that was passed as a first argument
   */ function setStyle(element, styles) {
        var elementStyle = element.style;
        if (!elementStyle) return element;
        if (typeof styles === 'string') {
            element.style.cssText += ';' + styles;
            return styles.indexOf('opacity') > -1 ? setOpacity(element, styles.match(/opacity:\s*(\d?\.?\d*)/)[1]) : element;
        }
        for(var property in styles)if (property === 'opacity') setOpacity(element, styles[property]);
        else {
            var normalizedProperty = property === 'float' || property === 'cssFloat' ? typeof elementStyle.styleFloat === 'undefined' ? 'cssFloat' : 'styleFloat' : property;
            elementStyle.setProperty(normalizedProperty, styles[property]);
        }
        return element;
    }
    var parseEl = $79564f678731bf19$var$fabric.document.createElement('div'), supportsOpacity = typeof parseEl.style.opacity === 'string', supportsFilters = typeof parseEl.style.filter === 'string', reOpacity = /alpha\s*\(\s*opacity\s*=\s*([^\)]+)\)/, /** @ignore */ setOpacity = function(element) {
        return element;
    };
    if (supportsOpacity) /** @ignore */ setOpacity = function(element, value) {
        element.style.opacity = value;
        return element;
    };
    else if (supportsFilters) /** @ignore */ setOpacity = function(element, value) {
        var es = element.style;
        if (element.currentStyle && !element.currentStyle.hasLayout) es.zoom = 1;
        if (reOpacity.test(es.filter)) {
            value = value >= 0.9999 ? '' : 'alpha(opacity=' + value * 100 + ')';
            es.filter = es.filter.replace(reOpacity, value);
        } else es.filter += ' alpha(opacity=' + value * 100 + ')';
        return element;
    };
    $79564f678731bf19$var$fabric.util.setStyle = setStyle;
})();
(function() {
    var _slice = Array.prototype.slice;
    /**
   * Takes id and returns an element with that id (if one exists in a document)
   * @memberOf fabric.util
   * @param {String|HTMLElement} id
   * @return {HTMLElement|null}
   */ function getById(id) {
        return typeof id === 'string' ? $79564f678731bf19$var$fabric.document.getElementById(id) : id;
    }
    var sliceCanConvertNodelists, /**
       * Converts an array-like object (e.g. arguments or NodeList) to an array
       * @memberOf fabric.util
       * @param {Object} arrayLike
       * @return {Array}
       */ toArray = function(arrayLike) {
        return _slice.call(arrayLike, 0);
    };
    try {
        sliceCanConvertNodelists = toArray($79564f678731bf19$var$fabric.document.childNodes) instanceof Array;
    } catch (err) {}
    if (!sliceCanConvertNodelists) toArray = function(arrayLike) {
        var arr = new Array(arrayLike.length), i = arrayLike.length;
        while(i--)arr[i] = arrayLike[i];
        return arr;
    };
    /**
   * Creates specified element with specified attributes
   * @memberOf fabric.util
   * @param {String} tagName Type of an element to create
   * @param {Object} [attributes] Attributes to set on an element
   * @return {HTMLElement} Newly created element
   */ function makeElement(tagName, attributes) {
        var el = $79564f678731bf19$var$fabric.document.createElement(tagName);
        for(var prop in attributes){
            if (prop === 'class') el.className = attributes[prop];
            else if (prop === 'for') el.htmlFor = attributes[prop];
            else el.setAttribute(prop, attributes[prop]);
        }
        return el;
    }
    /**
   * Adds class to an element
   * @memberOf fabric.util
   * @param {HTMLElement} element Element to add class to
   * @param {String} className Class to add to an element
   */ function addClass(element, className) {
        if (element && (' ' + element.className + ' ').indexOf(' ' + className + ' ') === -1) element.className += (element.className ? ' ' : '') + className;
    }
    /**
   * Wraps element with another element
   * @memberOf fabric.util
   * @param {HTMLElement} element Element to wrap
   * @param {HTMLElement|String} wrapper Element to wrap with
   * @param {Object} [attributes] Attributes to set on a wrapper
   * @return {HTMLElement} wrapper
   */ function wrapElement(element, wrapper, attributes) {
        if (typeof wrapper === 'string') wrapper = makeElement(wrapper, attributes);
        if (element.parentNode) element.parentNode.replaceChild(wrapper, element);
        wrapper.appendChild(element);
        return wrapper;
    }
    /**
   * Returns element scroll offsets
   * @memberOf fabric.util
   * @param {HTMLElement} element Element to operate on
   * @return {Object} Object with left/top values
   */ function getScrollLeftTop(element) {
        var left = 0, top = 0, docElement = $79564f678731bf19$var$fabric.document.documentElement, body = $79564f678731bf19$var$fabric.document.body || {
            scrollLeft: 0,
            scrollTop: 0
        };
        // While loop checks (and then sets element to) .parentNode OR .host
        //  to account for ShadowDOM. We still want to traverse up out of ShadowDOM,
        //  but the .parentNode of a root ShadowDOM node will always be null, instead
        //  it should be accessed through .host. See http://stackoverflow.com/a/24765528/4383938
        while(element && (element.parentNode || element.host)){
            // Set element to element parent, or 'host' in case of ShadowDOM
            element = element.parentNode || element.host;
            if (element === $79564f678731bf19$var$fabric.document) {
                left = body.scrollLeft || docElement.scrollLeft || 0;
                top = body.scrollTop || docElement.scrollTop || 0;
            } else {
                left += element.scrollLeft || 0;
                top += element.scrollTop || 0;
            }
            if (element.nodeType === 1 && element.style.position === 'fixed') break;
        }
        return {
            left: left,
            top: top
        };
    }
    /**
   * Returns offset for a given element
   * @function
   * @memberOf fabric.util
   * @param {HTMLElement} element Element to get offset for
   * @return {Object} Object with "left" and "top" properties
   */ function getElementOffset(element) {
        var docElem, doc = element && element.ownerDocument, box = {
            left: 0,
            top: 0
        }, offset = {
            left: 0,
            top: 0
        }, scrollLeftTop, offsetAttributes = {
            borderLeftWidth: 'left',
            borderTopWidth: 'top',
            paddingLeft: 'left',
            paddingTop: 'top'
        };
        if (!doc) return offset;
        for(var attr in offsetAttributes)offset[offsetAttributes[attr]] += parseInt(getElementStyle(element, attr), 10) || 0;
        docElem = doc.documentElement;
        if (typeof element.getBoundingClientRect !== 'undefined') box = element.getBoundingClientRect();
        scrollLeftTop = getScrollLeftTop(element);
        return {
            left: box.left + scrollLeftTop.left - (docElem.clientLeft || 0) + offset.left,
            top: box.top + scrollLeftTop.top - (docElem.clientTop || 0) + offset.top
        };
    }
    /**
   * Returns style attribute value of a given element
   * @memberOf fabric.util
   * @param {HTMLElement} element Element to get style attribute for
   * @param {String} attr Style attribute to get for element
   * @return {String} Style attribute value of the given element.
   */ var getElementStyle;
    if ($79564f678731bf19$var$fabric.document.defaultView && $79564f678731bf19$var$fabric.document.defaultView.getComputedStyle) getElementStyle = function(element, attr) {
        var style = $79564f678731bf19$var$fabric.document.defaultView.getComputedStyle(element, null);
        return style ? style[attr] : undefined;
    };
    else getElementStyle = function(element, attr) {
        var value = element.style[attr];
        if (!value && element.currentStyle) value = element.currentStyle[attr];
        return value;
    };
    (function() {
        var style = $79564f678731bf19$var$fabric.document.documentElement.style, selectProp = 'userSelect' in style ? 'userSelect' : 'MozUserSelect' in style ? 'MozUserSelect' : 'WebkitUserSelect' in style ? 'WebkitUserSelect' : 'KhtmlUserSelect' in style ? 'KhtmlUserSelect' : '';
        /**
     * Makes element unselectable
     * @memberOf fabric.util
     * @param {HTMLElement} element Element to make unselectable
     * @return {HTMLElement} Element that was passed in
     */ function makeElementUnselectable(element) {
            if (typeof element.onselectstart !== 'undefined') element.onselectstart = $79564f678731bf19$var$fabric.util.falseFunction;
            if (selectProp) element.style[selectProp] = 'none';
            else if (typeof element.unselectable === 'string') element.unselectable = 'on';
            return element;
        }
        /**
     * Makes element selectable
     * @memberOf fabric.util
     * @param {HTMLElement} element Element to make selectable
     * @return {HTMLElement} Element that was passed in
     */ function makeElementSelectable(element) {
            if (typeof element.onselectstart !== 'undefined') element.onselectstart = null;
            if (selectProp) element.style[selectProp] = '';
            else if (typeof element.unselectable === 'string') element.unselectable = '';
            return element;
        }
        $79564f678731bf19$var$fabric.util.makeElementUnselectable = makeElementUnselectable;
        $79564f678731bf19$var$fabric.util.makeElementSelectable = makeElementSelectable;
    })();
    function getNodeCanvas(element) {
        var impl = $79564f678731bf19$var$fabric.jsdomImplForWrapper(element);
        return impl._canvas || impl._image;
    }
    function cleanUpJsdomNode(element) {
        if (!$79564f678731bf19$var$fabric.isLikelyNode) return;
        var impl = $79564f678731bf19$var$fabric.jsdomImplForWrapper(element);
        if (impl) {
            impl._image = null;
            impl._canvas = null;
            // unsure if necessary
            impl._currentSrc = null;
            impl._attributes = null;
            impl._classList = null;
        }
    }
    function setImageSmoothing(ctx, value) {
        ctx.imageSmoothingEnabled = ctx.imageSmoothingEnabled || ctx.webkitImageSmoothingEnabled || ctx.mozImageSmoothingEnabled || ctx.msImageSmoothingEnabled || ctx.oImageSmoothingEnabled;
        ctx.imageSmoothingEnabled = value;
    }
    /**
   * setImageSmoothing sets the context imageSmoothingEnabled property.
   * Used by canvas and by ImageObject.
   * @memberOf fabric.util
   * @since 4.0.0
   * @param {HTMLRenderingContext2D} ctx to set on
   * @param {Boolean} value true or false
   */ $79564f678731bf19$var$fabric.util.setImageSmoothing = setImageSmoothing;
    $79564f678731bf19$var$fabric.util.getById = getById;
    $79564f678731bf19$var$fabric.util.toArray = toArray;
    $79564f678731bf19$var$fabric.util.addClass = addClass;
    $79564f678731bf19$var$fabric.util.makeElement = makeElement;
    $79564f678731bf19$var$fabric.util.wrapElement = wrapElement;
    $79564f678731bf19$var$fabric.util.getScrollLeftTop = getScrollLeftTop;
    $79564f678731bf19$var$fabric.util.getElementOffset = getElementOffset;
    $79564f678731bf19$var$fabric.util.getNodeCanvas = getNodeCanvas;
    $79564f678731bf19$var$fabric.util.cleanUpJsdomNode = cleanUpJsdomNode;
})();
(function() {
    function addParamToUrl(url, param) {
        return url + (/\?/.test(url) ? '&' : '?') + param;
    }
    function emptyFn() {}
    /**
   * Cross-browser abstraction for sending XMLHttpRequest
   * @memberOf fabric.util
   * @param {String} url URL to send XMLHttpRequest to
   * @param {Object} [options] Options object
   * @param {String} [options.method="GET"]
   * @param {String} [options.parameters] parameters to append to url in GET or in body
   * @param {String} [options.body] body to send with POST or PUT request
   * @param {Function} options.onComplete Callback to invoke when request is completed
   * @return {XMLHttpRequest} request
   */ function request(url, options) {
        options || (options = {});
        var method = options.method ? options.method.toUpperCase() : 'GET', onComplete = options.onComplete || function() {}, xhr = new $79564f678731bf19$var$fabric.window.XMLHttpRequest(), body = options.body || options.parameters;
        /** @ignore */ xhr.onreadystatechange = function() {
            if (xhr.readyState === 4) {
                onComplete(xhr);
                xhr.onreadystatechange = emptyFn;
            }
        };
        if (method === 'GET') {
            body = null;
            if (typeof options.parameters === 'string') url = addParamToUrl(url, options.parameters);
        }
        xhr.open(method, url, true);
        if (method === 'POST' || method === 'PUT') xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.send(body);
        return xhr;
    }
    $79564f678731bf19$var$fabric.util.request = request;
})();
/**
 * Wrapper around `console.log` (when available)
 * @param {*} [values] Values to log
 */ $79564f678731bf19$var$fabric.log = console.log;
/**
 * Wrapper around `console.warn` (when available)
 * @param {*} [values] Values to log as a warning
 */ $79564f678731bf19$var$fabric.warn = console.warn;
(function() {
    var extend = $79564f678731bf19$var$fabric.util.object.extend, clone = $79564f678731bf19$var$fabric.util.object.clone;
    /**
   * @typedef {Object} AnimationOptions
   * Animation of a value or list of values.
   * When using lists, think of something like this:
   * fabric.util.animate({
   *   startValue: [1, 2, 3],
   *   endValue: [2, 4, 6],
   *   onChange: function([a, b, c]) {
   *     canvas.zoomToPoint({x: b, y: c}, a)
   *     canvas.renderAll()
   *   }
   * });
   * @example
   * @property {Function} [onChange] Callback; invoked on every value change
   * @property {Function} [onComplete] Callback; invoked when value change is completed
   * @example
   * // Note: startValue, endValue, and byValue must match the type
   * var animationOptions = { startValue: 0, endValue: 1, byValue: 0.25 }
   * var animationOptions = { startValue: [0, 1], endValue: [1, 2], byValue: [0.25, 0.25] }
   * @property {number | number[]} [startValue=0] Starting value
   * @property {number | number[]} [endValue=100] Ending value
   * @property {number | number[]} [byValue=100] Value to modify the property by
   * @property {Function} [easing] Easing function
   * @property {Number} [duration=500] Duration of change (in ms)
   * @property {Function} [abort] Additional function with logic. If returns true, animation aborts.
   *
   * @typedef {() => void} CancelFunction
   *
   * @typedef {Object} AnimationCurrentState
   * @property {number | number[]} currentValue value in range [`startValue`, `endValue`]
   * @property {number} completionRate value in range [0, 1]
   * @property {number} durationRate value in range [0, 1]
   *
   * @typedef {(AnimationOptions & AnimationCurrentState & { cancel: CancelFunction }} AnimationContext
   */ /**
   * Array holding all running animations
   * @memberof fabric
   * @type {AnimationContext[]}
   */ var RUNNING_ANIMATIONS = [];
    $79564f678731bf19$var$fabric.util.object.extend(RUNNING_ANIMATIONS, {
        /**
     * cancel all running animations at the next requestAnimFrame
     * @returns {AnimationContext[]}
     */ cancelAll: function() {
            var animations = this.splice(0);
            animations.forEach(function(animation) {
                animation.cancel();
            });
            return animations;
        },
        /**
     * cancel all running animations attached to canvas at the next requestAnimFrame
     * @param {fabric.Canvas} canvas
     * @returns {AnimationContext[]}
     */ cancelByCanvas: function(canvas) {
            if (!canvas) return [];
            var cancelled = this.filter(function(animation) {
                return typeof animation.target === 'object' && animation.target.canvas === canvas;
            });
            cancelled.forEach(function(animation) {
                animation.cancel();
            });
            return cancelled;
        },
        /**
     * cancel all running animations for target at the next requestAnimFrame
     * @param {*} target
     * @returns {AnimationContext[]}
     */ cancelByTarget: function(target) {
            var cancelled = this.findAnimationsByTarget(target);
            cancelled.forEach(function(animation) {
                animation.cancel();
            });
            return cancelled;
        },
        /**
     *
     * @param {CancelFunction} cancelFunc the function returned by animate
     * @returns {number}
     */ findAnimationIndex: function(cancelFunc) {
            return this.indexOf(this.findAnimation(cancelFunc));
        },
        /**
     *
     * @param {CancelFunction} cancelFunc the function returned by animate
     * @returns {AnimationContext | undefined} animation's options object
     */ findAnimation: function(cancelFunc) {
            return this.find(function(animation) {
                return animation.cancel === cancelFunc;
            });
        },
        /**
     *
     * @param {*} target the object that is assigned to the target property of the animation context
     * @returns {AnimationContext[]} array of animation options object associated with target
     */ findAnimationsByTarget: function(target) {
            if (!target) return [];
            return this.filter(function(animation) {
                return animation.target === target;
            });
        }
    });
    function noop() {
        return false;
    }
    function defaultEasing(t, b, c, d) {
        return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
    }
    /**
   * Changes value from one to another within certain period of time, invoking callbacks as value is being changed.
   * @memberOf fabric.util
   * @param {AnimationOptions} [options] Animation options
   * @example
   * // Note: startValue, endValue, and byValue must match the type
   * fabric.util.animate({ startValue: 0, endValue: 1, byValue: 0.25 })
   * fabric.util.animate({ startValue: [0, 1], endValue: [1, 2], byValue: [0.25, 0.25] })
   * @returns {CancelFunction} cancel function
   */ function animate(options) {
        options || (options = {});
        var cancel = false, context, removeFromRegistry = function() {
            var index = $79564f678731bf19$var$fabric.runningAnimations.indexOf(context);
            return index > -1 && $79564f678731bf19$var$fabric.runningAnimations.splice(index, 1)[0];
        };
        context = extend(clone(options), {
            cancel: function() {
                cancel = true;
                return removeFromRegistry();
            },
            currentValue: 'startValue' in options ? options.startValue : 0,
            completionRate: 0,
            durationRate: 0
        });
        $79564f678731bf19$var$fabric.runningAnimations.push(context);
        requestAnimFrame(function(timestamp) {
            var start = timestamp || +new Date(), duration = options.duration || 500, finish = start + duration, time, onChange = options.onChange || noop, abort = options.abort || noop, onComplete = options.onComplete || noop, easing = options.easing || defaultEasing, isMany = 'startValue' in options ? options.startValue.length > 0 : false, startValue = 'startValue' in options ? options.startValue : 0, endValue = 'endValue' in options ? options.endValue : 100, byValue = options.byValue || (isMany ? startValue.map(function(value, i) {
                return endValue[i] - startValue[i];
            }) : endValue - startValue);
            options.onStart && options.onStart();
            (function tick(ticktime) {
                time = ticktime || +new Date();
                var currentTime = time > finish ? duration : time - start, timePerc = currentTime / duration, current = isMany ? startValue.map(function(_value, i) {
                    return easing(currentTime, startValue[i], byValue[i], duration);
                }) : easing(currentTime, startValue, byValue, duration), valuePerc = isMany ? Math.abs((current[0] - startValue[0]) / byValue[0]) : Math.abs((current - startValue) / byValue);
                //  update context
                context.currentValue = isMany ? current.slice() : current;
                context.completionRate = valuePerc;
                context.durationRate = timePerc;
                if (cancel) return;
                if (abort(current, valuePerc, timePerc)) {
                    removeFromRegistry();
                    return;
                }
                if (time > finish) {
                    //  update context
                    context.currentValue = isMany ? endValue.slice() : endValue;
                    context.completionRate = 1;
                    context.durationRate = 1;
                    //  execute callbacks
                    onChange(isMany ? endValue.slice() : endValue, 1, 1);
                    onComplete(endValue, 1, 1);
                    removeFromRegistry();
                    return;
                } else {
                    onChange(current, valuePerc, timePerc);
                    requestAnimFrame(tick);
                }
            })(start);
        });
        return context.cancel;
    }
    var _requestAnimFrame = $79564f678731bf19$var$fabric.window.requestAnimationFrame || $79564f678731bf19$var$fabric.window.webkitRequestAnimationFrame || $79564f678731bf19$var$fabric.window.mozRequestAnimationFrame || $79564f678731bf19$var$fabric.window.oRequestAnimationFrame || $79564f678731bf19$var$fabric.window.msRequestAnimationFrame || function(callback) {
        return $79564f678731bf19$var$fabric.window.setTimeout(callback, 1000 / 60);
    };
    var _cancelAnimFrame = $79564f678731bf19$var$fabric.window.cancelAnimationFrame || $79564f678731bf19$var$fabric.window.clearTimeout;
    /**
   * requestAnimationFrame polyfill based on http://paulirish.com/2011/requestanimationframe-for-smart-animating/
   * In order to get a precise start time, `requestAnimFrame` should be called as an entry into the method
   * @memberOf fabric.util
   * @param {Function} callback Callback to invoke
   * @param {DOMElement} element optional Element to associate with animation
   */ function requestAnimFrame() {
        return _requestAnimFrame.apply($79564f678731bf19$var$fabric.window, arguments);
    }
    function cancelAnimFrame() {
        return _cancelAnimFrame.apply($79564f678731bf19$var$fabric.window, arguments);
    }
    $79564f678731bf19$var$fabric.util.animate = animate;
    $79564f678731bf19$var$fabric.util.requestAnimFrame = requestAnimFrame;
    $79564f678731bf19$var$fabric.util.cancelAnimFrame = cancelAnimFrame;
    $79564f678731bf19$var$fabric.runningAnimations = RUNNING_ANIMATIONS;
})();
(function() {
    // Calculate an in-between color. Returns a "rgba()" string.
    // Credit: Edwin Martin <edwin@bitstorm.org>
    //         http://www.bitstorm.org/jquery/color-animation/jquery.animate-colors.js
    function calculateColor(begin, end, pos) {
        var color = 'rgba(' + parseInt(begin[0] + pos * (end[0] - begin[0]), 10) + ',' + parseInt(begin[1] + pos * (end[1] - begin[1]), 10) + ',' + parseInt(begin[2] + pos * (end[2] - begin[2]), 10);
        color += ',' + (begin && end ? parseFloat(begin[3] + pos * (end[3] - begin[3])) : 1);
        color += ')';
        return color;
    }
    /**
   * Changes the color from one to another within certain period of time, invoking callbacks as value is being changed.
   * @memberOf fabric.util
   * @param {String} fromColor The starting color in hex or rgb(a) format.
   * @param {String} toColor The starting color in hex or rgb(a) format.
   * @param {Number} [duration] Duration of change (in ms).
   * @param {Object} [options] Animation options
   * @param {Function} [options.onChange] Callback; invoked on every value change
   * @param {Function} [options.onComplete] Callback; invoked when value change is completed
   * @param {Function} [options.colorEasing] Easing function. Note that this function only take two arguments (currentTime, duration). Thus the regular animation easing functions cannot be used.
   * @param {Function} [options.abort] Additional function with logic. If returns true, onComplete is called.
   * @returns {Function} abort function
   */ function animateColor(fromColor, toColor, duration, options) {
        var startColor = new $79564f678731bf19$var$fabric.Color(fromColor).getSource(), endColor = new $79564f678731bf19$var$fabric.Color(toColor).getSource(), originalOnComplete = options.onComplete, originalOnChange = options.onChange;
        options = options || {};
        return $79564f678731bf19$var$fabric.util.animate($79564f678731bf19$var$fabric.util.object.extend(options, {
            duration: duration || 500,
            startValue: startColor,
            endValue: endColor,
            byValue: endColor,
            easing: function(currentTime, startValue, byValue, duration) {
                var posValue = options.colorEasing ? options.colorEasing(currentTime, duration) : 1 - Math.cos(currentTime / duration * (Math.PI / 2));
                return calculateColor(startValue, byValue, posValue);
            },
            // has to take in account for color restoring;
            onComplete: function(current, valuePerc, timePerc) {
                if (originalOnComplete) return originalOnComplete(calculateColor(endColor, endColor, 0), valuePerc, timePerc);
            },
            onChange: function(current, valuePerc, timePerc) {
                if (originalOnChange) {
                    if (Array.isArray(current)) return originalOnChange(calculateColor(current, current, 0), valuePerc, timePerc);
                    originalOnChange(current, valuePerc, timePerc);
                }
            }
        }));
    }
    $79564f678731bf19$var$fabric.util.animateColor = animateColor;
})();
(function() {
    function normalize(a, c, p, s) {
        if (a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else //handle the 0/0 case:
        if (c === 0 && a === 0) s = p / (2 * Math.PI) * Math.asin(1);
        else s = p / (2 * Math.PI) * Math.asin(c / a);
        return {
            a: a,
            c: c,
            p: p,
            s: s
        };
    }
    function elastic(opts, t, d) {
        return opts.a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - opts.s) * (2 * Math.PI) / opts.p);
    }
    /**
   * Cubic easing out
   * @memberOf fabric.util.ease
   */ function easeOutCubic(t, b, c, d) {
        return c * ((t = t / d - 1) * t * t + 1) + b;
    }
    /**
   * Cubic easing in and out
   * @memberOf fabric.util.ease
   */ function easeInOutCubic(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t * t + b;
        return c / 2 * ((t -= 2) * t * t + 2) + b;
    }
    /**
   * Quartic easing in
   * @memberOf fabric.util.ease
   */ function easeInQuart(t, b, c, d) {
        return c * (t /= d) * t * t * t + b;
    }
    /**
   * Quartic easing out
   * @memberOf fabric.util.ease
   */ function easeOutQuart(t, b, c, d) {
        return -c * ((t = t / d - 1) * t * t * t - 1) + b;
    }
    /**
   * Quartic easing in and out
   * @memberOf fabric.util.ease
   */ function easeInOutQuart(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t * t * t + b;
        return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
    }
    /**
   * Quintic easing in
   * @memberOf fabric.util.ease
   */ function easeInQuint(t, b, c, d) {
        return c * (t /= d) * t * t * t * t + b;
    }
    /**
   * Quintic easing out
   * @memberOf fabric.util.ease
   */ function easeOutQuint(t, b, c, d) {
        return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
    }
    /**
   * Quintic easing in and out
   * @memberOf fabric.util.ease
   */ function easeInOutQuint(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t * t * t * t + b;
        return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
    }
    /**
   * Sinusoidal easing in
   * @memberOf fabric.util.ease
   */ function easeInSine(t, b, c, d) {
        return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
    }
    /**
   * Sinusoidal easing out
   * @memberOf fabric.util.ease
   */ function easeOutSine(t, b, c, d) {
        return c * Math.sin(t / d * (Math.PI / 2)) + b;
    }
    /**
   * Sinusoidal easing in and out
   * @memberOf fabric.util.ease
   */ function easeInOutSine(t, b, c, d) {
        return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
    }
    /**
   * Exponential easing in
   * @memberOf fabric.util.ease
   */ function easeInExpo(t, b, c, d) {
        return t === 0 ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
    }
    /**
   * Exponential easing out
   * @memberOf fabric.util.ease
   */ function easeOutExpo(t, b, c, d) {
        return t === d ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
    }
    /**
   * Exponential easing in and out
   * @memberOf fabric.util.ease
   */ function easeInOutExpo(t, b, c, d) {
        if (t === 0) return b;
        if (t === d) return b + c;
        t /= d / 2;
        if (t < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
        return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
    }
    /**
   * Circular easing in
   * @memberOf fabric.util.ease
   */ function easeInCirc(t, b, c, d) {
        return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
    }
    /**
   * Circular easing out
   * @memberOf fabric.util.ease
   */ function easeOutCirc(t, b, c, d) {
        return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
    }
    /**
   * Circular easing in and out
   * @memberOf fabric.util.ease
   */ function easeInOutCirc(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
        return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
    }
    /**
   * Elastic easing in
   * @memberOf fabric.util.ease
   */ function easeInElastic(t, b, c, d) {
        var s = 1.70158, p = 0, a = c;
        if (t === 0) return b;
        t /= d;
        if (t === 1) return b + c;
        if (!p) p = d * 0.3;
        var opts = normalize(a, c, p, s);
        return -elastic(opts, t, d) + b;
    }
    /**
   * Elastic easing out
   * @memberOf fabric.util.ease
   */ function easeOutElastic(t, b, c, d) {
        var s = 1.70158, p = 0, a = c;
        if (t === 0) return b;
        t /= d;
        if (t === 1) return b + c;
        if (!p) p = d * 0.3;
        var opts = normalize(a, c, p, s);
        return opts.a * Math.pow(2, -10 * t) * Math.sin((t * d - opts.s) * (2 * Math.PI) / opts.p) + opts.c + b;
    }
    /**
   * Elastic easing in and out
   * @memberOf fabric.util.ease
   */ function easeInOutElastic(t, b, c, d) {
        var s = 1.70158, p = 0, a = c;
        if (t === 0) return b;
        t /= d / 2;
        if (t === 2) return b + c;
        if (!p) p = d * (0.3 * 1.5);
        var opts = normalize(a, c, p, s);
        if (t < 1) return -0.5 * elastic(opts, t, d) + b;
        return opts.a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - opts.s) * (2 * Math.PI) / opts.p) * 0.5 + opts.c + b;
    }
    /**
   * Backwards easing in
   * @memberOf fabric.util.ease
   */ function easeInBack(t, b, c, d, s) {
        if (s === undefined) s = 1.70158;
        return c * (t /= d) * t * ((s + 1) * t - s) + b;
    }
    /**
   * Backwards easing out
   * @memberOf fabric.util.ease
   */ function easeOutBack(t, b, c, d, s) {
        if (s === undefined) s = 1.70158;
        return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
    }
    /**
   * Backwards easing in and out
   * @memberOf fabric.util.ease
   */ function easeInOutBack(t, b, c, d, s) {
        if (s === undefined) s = 1.70158;
        t /= d / 2;
        if (t < 1) return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
        return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
    }
    /**
   * Bouncing easing in
   * @memberOf fabric.util.ease
   */ function easeInBounce(t, b, c, d) {
        return c - easeOutBounce(d - t, 0, c, d) + b;
    }
    /**
   * Bouncing easing out
   * @memberOf fabric.util.ease
   */ function easeOutBounce(t, b, c, d) {
        if ((t /= d) < 1 / 2.75) return c * (7.5625 * t * t) + b;
        else if (t < 2 / 2.75) return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
        else if (t < 2.5 / 2.75) return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
        else return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
    }
    /**
   * Bouncing easing in and out
   * @memberOf fabric.util.ease
   */ function easeInOutBounce(t, b, c, d) {
        if (t < d / 2) return easeInBounce(t * 2, 0, c, d) * 0.5 + b;
        return easeOutBounce(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;
    }
    /**
   * Easing functions
   * See <a href="http://gizma.com/easing/">Easing Equations by Robert Penner</a>
   * @namespace fabric.util.ease
   */ $79564f678731bf19$var$fabric.util.ease = {
        /**
     * Quadratic easing in
     * @memberOf fabric.util.ease
     */ easeInQuad: function(t, b, c, d) {
            return c * (t /= d) * t + b;
        },
        /**
     * Quadratic easing out
     * @memberOf fabric.util.ease
     */ easeOutQuad: function(t, b, c, d) {
            return -c * (t /= d) * (t - 2) + b;
        },
        /**
     * Quadratic easing in and out
     * @memberOf fabric.util.ease
     */ easeInOutQuad: function(t, b, c, d) {
            t /= d / 2;
            if (t < 1) return c / 2 * t * t + b;
            return -c / 2 * (--t * (t - 2) - 1) + b;
        },
        /**
     * Cubic easing in
     * @memberOf fabric.util.ease
     */ easeInCubic: function(t, b, c, d) {
            return c * (t /= d) * t * t + b;
        },
        easeOutCubic: easeOutCubic,
        easeInOutCubic: easeInOutCubic,
        easeInQuart: easeInQuart,
        easeOutQuart: easeOutQuart,
        easeInOutQuart: easeInOutQuart,
        easeInQuint: easeInQuint,
        easeOutQuint: easeOutQuint,
        easeInOutQuint: easeInOutQuint,
        easeInSine: easeInSine,
        easeOutSine: easeOutSine,
        easeInOutSine: easeInOutSine,
        easeInExpo: easeInExpo,
        easeOutExpo: easeOutExpo,
        easeInOutExpo: easeInOutExpo,
        easeInCirc: easeInCirc,
        easeOutCirc: easeOutCirc,
        easeInOutCirc: easeInOutCirc,
        easeInElastic: easeInElastic,
        easeOutElastic: easeOutElastic,
        easeInOutElastic: easeInOutElastic,
        easeInBack: easeInBack,
        easeOutBack: easeOutBack,
        easeInOutBack: easeInOutBack,
        easeInBounce: easeInBounce,
        easeOutBounce: easeOutBounce,
        easeInOutBounce: easeInOutBounce
    };
})();
(function(global) {
    'use strict';
    /**
   * @name fabric
   * @namespace
   */ var fabric = global.fabric || (global.fabric = {}), extend = fabric.util.object.extend, clone = fabric.util.object.clone, toFixed = fabric.util.toFixed, parseUnit = fabric.util.parseUnit, multiplyTransformMatrices = fabric.util.multiplyTransformMatrices, svgValidTagNames = [
        'path',
        'circle',
        'polygon',
        'polyline',
        'ellipse',
        'rect',
        'line',
        'image',
        'text'
    ], svgViewBoxElements = [
        'symbol',
        'image',
        'marker',
        'pattern',
        'view',
        'svg'
    ], svgInvalidAncestors = [
        'pattern',
        'defs',
        'symbol',
        'metadata',
        'clipPath',
        'mask',
        'desc'
    ], svgValidParents = [
        'symbol',
        'g',
        'a',
        'svg',
        'clipPath',
        'defs'
    ], attributesMap = {
        cx: 'left',
        x: 'left',
        r: 'radius',
        cy: 'top',
        y: 'top',
        display: 'visible',
        visibility: 'visible',
        transform: 'transformMatrix',
        'fill-opacity': 'fillOpacity',
        'fill-rule': 'fillRule',
        'font-family': 'fontFamily',
        'font-size': 'fontSize',
        'font-style': 'fontStyle',
        'font-weight': 'fontWeight',
        'letter-spacing': 'charSpacing',
        'paint-order': 'paintFirst',
        'stroke-dasharray': 'strokeDashArray',
        'stroke-dashoffset': 'strokeDashOffset',
        'stroke-linecap': 'strokeLineCap',
        'stroke-linejoin': 'strokeLineJoin',
        'stroke-miterlimit': 'strokeMiterLimit',
        'stroke-opacity': 'strokeOpacity',
        'stroke-width': 'strokeWidth',
        'text-decoration': 'textDecoration',
        'text-anchor': 'textAnchor',
        opacity: 'opacity',
        'clip-path': 'clipPath',
        'clip-rule': 'clipRule',
        'vector-effect': 'strokeUniform',
        'image-rendering': 'imageSmoothing'
    }, colorAttributes = {
        stroke: 'strokeOpacity',
        fill: 'fillOpacity'
    }, fSize = 'font-size', cPath = 'clip-path';
    fabric.svgValidTagNamesRegEx = getSvgRegex(svgValidTagNames);
    fabric.svgViewBoxElementsRegEx = getSvgRegex(svgViewBoxElements);
    fabric.svgInvalidAncestorsRegEx = getSvgRegex(svgInvalidAncestors);
    fabric.svgValidParentsRegEx = getSvgRegex(svgValidParents);
    fabric.cssRules = {};
    fabric.gradientDefs = {};
    fabric.clipPaths = {};
    function normalizeAttr(attr) {
        // transform attribute names
        if (attr in attributesMap) return attributesMap[attr];
        return attr;
    }
    function normalizeValue(attr, value, parentAttributes, fontSize) {
        var isArray = Array.isArray(value), parsed;
        if ((attr === 'fill' || attr === 'stroke') && value === 'none') value = '';
        else if (attr === 'strokeUniform') return value === 'non-scaling-stroke';
        else if (attr === 'strokeDashArray') {
            if (value === 'none') value = null;
            else value = value.replace(/,/g, ' ').split(/\s+/).map(parseFloat);
        } else if (attr === 'transformMatrix') {
            if (parentAttributes && parentAttributes.transformMatrix) value = multiplyTransformMatrices(parentAttributes.transformMatrix, fabric.parseTransformAttribute(value));
            else value = fabric.parseTransformAttribute(value);
        } else if (attr === 'visible') {
            value = value !== 'none' && value !== 'hidden';
            // display=none on parent element always takes precedence over child element
            if (parentAttributes && parentAttributes.visible === false) value = false;
        } else if (attr === 'opacity') {
            value = parseFloat(value);
            if (parentAttributes && typeof parentAttributes.opacity !== 'undefined') value *= parentAttributes.opacity;
        } else if (attr === 'textAnchor' /* text-anchor */ ) value = value === 'start' ? 'left' : value === 'end' ? 'right' : 'center';
        else if (attr === 'charSpacing') // parseUnit returns px and we convert it to em
        parsed = parseUnit(value, fontSize) / fontSize * 1000;
        else if (attr === 'paintFirst') {
            var fillIndex = value.indexOf('fill');
            var strokeIndex = value.indexOf('stroke');
            var value = 'fill';
            if (fillIndex > -1 && strokeIndex > -1 && strokeIndex < fillIndex) value = 'stroke';
            else if (fillIndex === -1 && strokeIndex > -1) value = 'stroke';
        } else if (attr === 'href' || attr === 'xlink:href' || attr === 'font') return value;
        else if (attr === 'imageSmoothing') return value === 'optimizeQuality';
        else parsed = isArray ? value.map(parseUnit) : parseUnit(value, fontSize);
        return !isArray && isNaN(parsed) ? value : parsed;
    }
    /**
    * @private
    */ function getSvgRegex(arr) {
        return new RegExp('^(' + arr.join('|') + ')\\b', 'i');
    }
    /**
   * @private
   * @param {Object} attributes Array of attributes to parse
   */ function _setStrokeFillOpacity(attributes) {
        for(var attr in colorAttributes){
            if (typeof attributes[colorAttributes[attr]] === 'undefined' || attributes[attr] === '') continue;
            if (typeof attributes[attr] === 'undefined') {
                if (!fabric.Object.prototype[attr]) continue;
                attributes[attr] = fabric.Object.prototype[attr];
            }
            if (attributes[attr].indexOf('url(') === 0) continue;
            var color = new fabric.Color(attributes[attr]);
            attributes[attr] = color.setAlpha(toFixed(color.getAlpha() * attributes[colorAttributes[attr]], 2)).toRgba();
        }
        return attributes;
    }
    /**
   * @private
   */ function _getMultipleNodes(doc, nodeNames) {
        var nodeName, nodeArray = [], nodeList, i, len;
        for(i = 0, len = nodeNames.length; i < len; i++){
            nodeName = nodeNames[i];
            nodeList = doc.getElementsByTagName(nodeName);
            nodeArray = nodeArray.concat(Array.prototype.slice.call(nodeList));
        }
        return nodeArray;
    }
    /**
   * Parses "transform" attribute, returning an array of values
   * @static
   * @function
   * @memberOf fabric
   * @param {String} attributeValue String containing attribute value
   * @return {Array} Array of 6 elements representing transformation matrix
   */ fabric.parseTransformAttribute = function() {
        function rotateMatrix(matrix, args) {
            var cos = fabric.util.cos(args[0]), sin = fabric.util.sin(args[0]), x = 0, y = 0;
            if (args.length === 3) {
                x = args[1];
                y = args[2];
            }
            matrix[0] = cos;
            matrix[1] = sin;
            matrix[2] = -sin;
            matrix[3] = cos;
            matrix[4] = x - (cos * x - sin * y);
            matrix[5] = y - (sin * x + cos * y);
        }
        function scaleMatrix(matrix, args) {
            var multiplierX = args[0], multiplierY = args.length === 2 ? args[1] : args[0];
            matrix[0] = multiplierX;
            matrix[3] = multiplierY;
        }
        function skewMatrix(matrix, args, pos) {
            matrix[pos] = Math.tan(fabric.util.degreesToRadians(args[0]));
        }
        function translateMatrix(matrix, args) {
            matrix[4] = args[0];
            if (args.length === 2) matrix[5] = args[1];
        }
        // identity matrix
        var iMatrix = fabric.iMatrix, // == begin transform regexp
        number = fabric.reNum, commaWsp = fabric.commaWsp, skewX = '(?:(skewX)\\s*\\(\\s*(' + number + ')\\s*\\))', skewY = '(?:(skewY)\\s*\\(\\s*(' + number + ')\\s*\\))', rotate = '(?:(rotate)\\s*\\(\\s*(' + number + ')(?:' + commaWsp + '(' + number + ')' + commaWsp + '(' + number + '))?\\s*\\))', scale = '(?:(scale)\\s*\\(\\s*(' + number + ')(?:' + commaWsp + '(' + number + '))?\\s*\\))', translate = '(?:(translate)\\s*\\(\\s*(' + number + ')(?:' + commaWsp + '(' + number + '))?\\s*\\))', matrix = "(?:(matrix)\\s*\\(\\s*(" + number + ')' + commaWsp + '(' + number + ')' + commaWsp + '(' + number + ')' + commaWsp + '(' + number + ')' + commaWsp + '(' + number + ')' + commaWsp + '(' + number + ')' + '\\s*\\))', transform = '(?:' + matrix + '|' + translate + '|' + scale + '|' + rotate + '|' + skewX + '|' + skewY + ')', transforms = '(?:' + transform + '(?:' + commaWsp + '*' + transform + ')*' + ')', transformList = '^\\s*(?:' + transforms + '?)\\s*$', // http://www.w3.org/TR/SVG/coords.html#TransformAttribute
        reTransformList = new RegExp(transformList), // == end transform regexp
        reTransform = new RegExp(transform, 'g');
        return function(attributeValue) {
            // start with identity matrix
            var matrix = iMatrix.concat(), matrices = [];
            // return if no argument was given or
            // an argument does not match transform attribute regexp
            if (!attributeValue || attributeValue && !reTransformList.test(attributeValue)) return matrix;
            attributeValue.replace(reTransform, function(match) {
                var m = new RegExp(transform).exec(match).filter(function(match) {
                    // match !== '' && match != null
                    return !!match;
                }), operation = m[1], args = m.slice(2).map(parseFloat);
                switch(operation){
                    case 'translate':
                        translateMatrix(matrix, args);
                        break;
                    case 'rotate':
                        args[0] = fabric.util.degreesToRadians(args[0]);
                        rotateMatrix(matrix, args);
                        break;
                    case 'scale':
                        scaleMatrix(matrix, args);
                        break;
                    case 'skewX':
                        skewMatrix(matrix, args, 2);
                        break;
                    case 'skewY':
                        skewMatrix(matrix, args, 1);
                        break;
                    case 'matrix':
                        matrix = args;
                        break;
                }
                // snapshot current matrix into matrices array
                matrices.push(matrix.concat());
                // reset
                matrix = iMatrix.concat();
            });
            var combinedMatrix = matrices[0];
            while(matrices.length > 1){
                matrices.shift();
                combinedMatrix = fabric.util.multiplyTransformMatrices(combinedMatrix, matrices[0]);
            }
            return combinedMatrix;
        };
    }();
    /**
   * @private
   */ function parseStyleString(style, oStyle) {
        var attr, value;
        style.replace(/;\s*$/, '').split(';').forEach(function(chunk) {
            var pair = chunk.split(':');
            attr = pair[0].trim().toLowerCase();
            value = pair[1].trim();
            oStyle[attr] = value;
        });
    }
    /**
   * @private
   */ function parseStyleObject(style, oStyle) {
        var attr, value;
        for(var prop in style){
            if (typeof style[prop] === 'undefined') continue;
            attr = prop.toLowerCase();
            value = style[prop];
            oStyle[attr] = value;
        }
    }
    /**
   * @private
   */ function getGlobalStylesForElement(element, svgUid) {
        var styles = {};
        for(var rule in fabric.cssRules[svgUid]){
            if (elementMatchesRule(element, rule.split(' '))) for(var property in fabric.cssRules[svgUid][rule])styles[property] = fabric.cssRules[svgUid][rule][property];
        }
        return styles;
    }
    /**
   * @private
   */ function elementMatchesRule(element, selectors) {
        var firstMatching, parentMatching = true;
        //start from rightmost selector.
        firstMatching = selectorMatches(element, selectors.pop());
        if (firstMatching && selectors.length) parentMatching = doesSomeParentMatch(element, selectors);
        return firstMatching && parentMatching && selectors.length === 0;
    }
    function doesSomeParentMatch(element, selectors) {
        var selector, parentMatching = true;
        while(element.parentNode && element.parentNode.nodeType === 1 && selectors.length){
            if (parentMatching) selector = selectors.pop();
            element = element.parentNode;
            parentMatching = selectorMatches(element, selector);
        }
        return selectors.length === 0;
    }
    /**
   * @private
   */ function selectorMatches(element, selector) {
        var nodeName = element.nodeName, classNames = element.getAttribute('class'), id = element.getAttribute('id'), matcher, i;
        // i check if a selector matches slicing away part from it.
        // if i get empty string i should match
        matcher = new RegExp('^' + nodeName, 'i');
        selector = selector.replace(matcher, '');
        if (id && selector.length) {
            matcher = new RegExp('#' + id + '(?![a-zA-Z\\-]+)', 'i');
            selector = selector.replace(matcher, '');
        }
        if (classNames && selector.length) {
            classNames = classNames.split(' ');
            for(i = classNames.length; i--;){
                matcher = new RegExp('\\.' + classNames[i] + '(?![a-zA-Z\\-]+)', 'i');
                selector = selector.replace(matcher, '');
            }
        }
        return selector.length === 0;
    }
    /**
   * @private
   * to support IE8 missing getElementById on SVGdocument and on node xmlDOM
   */ function elementById(doc, id) {
        var el;
        doc.getElementById && (el = doc.getElementById(id));
        if (el) return el;
        var node, i, len, nodelist = doc.getElementsByTagName('*');
        for(i = 0, len = nodelist.length; i < len; i++){
            node = nodelist[i];
            if (id === node.getAttribute('id')) return node;
        }
    }
    /**
   * @private
   */ function parseUseDirectives(doc) {
        var nodelist = _getMultipleNodes(doc, [
            'use',
            'svg:use'
        ]), i = 0;
        while(nodelist.length && i < nodelist.length){
            var el = nodelist[i], xlinkAttribute = el.getAttribute('xlink:href') || el.getAttribute('href');
            if (xlinkAttribute === null) return;
            var xlink = xlinkAttribute.slice(1), x = el.getAttribute('x') || 0, y = el.getAttribute('y') || 0, el2 = elementById(doc, xlink).cloneNode(true), currentTrans = (el2.getAttribute('transform') || '') + ' translate(' + x + ', ' + y + ')', parentNode, oldLength = nodelist.length, attr, j, attrs, len, namespace = fabric.svgNS;
            applyViewboxTransform(el2);
            if (/^svg$/i.test(el2.nodeName)) {
                var el3 = el2.ownerDocument.createElementNS(namespace, 'g');
                for(j = 0, attrs = el2.attributes, len = attrs.length; j < len; j++){
                    attr = attrs.item(j);
                    el3.setAttributeNS(namespace, attr.nodeName, attr.nodeValue);
                }
                // el2.firstChild != null
                while(el2.firstChild)el3.appendChild(el2.firstChild);
                el2 = el3;
            }
            for(j = 0, attrs = el.attributes, len = attrs.length; j < len; j++){
                attr = attrs.item(j);
                if (attr.nodeName === 'x' || attr.nodeName === 'y' || attr.nodeName === 'xlink:href' || attr.nodeName === 'href') continue;
                if (attr.nodeName === 'transform') currentTrans = attr.nodeValue + ' ' + currentTrans;
                else el2.setAttribute(attr.nodeName, attr.nodeValue);
            }
            el2.setAttribute('transform', currentTrans);
            el2.setAttribute('instantiated_by_use', '1');
            el2.removeAttribute('id');
            parentNode = el.parentNode;
            parentNode.replaceChild(el2, el);
            // some browsers do not shorten nodelist after replaceChild (IE8)
            if (nodelist.length === oldLength) i++;
        }
    }
    // http://www.w3.org/TR/SVG/coords.html#ViewBoxAttribute
    // matches, e.g.: +14.56e-12, etc.
    var reViewBoxAttrValue = new RegExp("^\\s*(" + fabric.reNum + '+)\\s*,?' + '\\s*(' + fabric.reNum + '+)\\s*,?' + '\\s*(' + fabric.reNum + '+)\\s*,?' + '\\s*(' + fabric.reNum + '+)\\s*' + '$');
    /**
   * Add a <g> element that envelop all child elements and makes the viewbox transformMatrix descend on all elements
   */ function applyViewboxTransform(element) {
        if (!fabric.svgViewBoxElementsRegEx.test(element.nodeName)) return {};
        var viewBoxAttr = element.getAttribute('viewBox'), scaleX = 1, scaleY = 1, minX = 0, minY = 0, viewBoxWidth, viewBoxHeight, matrix, el, widthAttr = element.getAttribute('width'), heightAttr = element.getAttribute('height'), x = element.getAttribute('x') || 0, y = element.getAttribute('y') || 0, preserveAspectRatio = element.getAttribute('preserveAspectRatio') || '', missingViewBox = !viewBoxAttr || !(viewBoxAttr = viewBoxAttr.match(reViewBoxAttrValue)), missingDimAttr = !widthAttr || !heightAttr || widthAttr === '100%' || heightAttr === '100%', toBeParsed = missingViewBox && missingDimAttr, parsedDim = {}, translateMatrix = '', widthDiff = 0, heightDiff = 0;
        parsedDim.width = 0;
        parsedDim.height = 0;
        parsedDim.toBeParsed = toBeParsed;
        if (missingViewBox) {
            if ((x || y) && element.parentNode && element.parentNode.nodeName !== '#document') {
                translateMatrix = ' translate(' + parseUnit(x) + ' ' + parseUnit(y) + ') ';
                matrix = (element.getAttribute('transform') || '') + translateMatrix;
                element.setAttribute('transform', matrix);
                element.removeAttribute('x');
                element.removeAttribute('y');
            }
        }
        if (toBeParsed) return parsedDim;
        if (missingViewBox) {
            parsedDim.width = parseUnit(widthAttr);
            parsedDim.height = parseUnit(heightAttr);
            // set a transform for elements that have x y and are inner(only) SVGs
            return parsedDim;
        }
        minX = -parseFloat(viewBoxAttr[1]);
        minY = -parseFloat(viewBoxAttr[2]);
        viewBoxWidth = parseFloat(viewBoxAttr[3]);
        viewBoxHeight = parseFloat(viewBoxAttr[4]);
        parsedDim.minX = minX;
        parsedDim.minY = minY;
        parsedDim.viewBoxWidth = viewBoxWidth;
        parsedDim.viewBoxHeight = viewBoxHeight;
        if (!missingDimAttr) {
            parsedDim.width = parseUnit(widthAttr);
            parsedDim.height = parseUnit(heightAttr);
            scaleX = parsedDim.width / viewBoxWidth;
            scaleY = parsedDim.height / viewBoxHeight;
        } else {
            parsedDim.width = viewBoxWidth;
            parsedDim.height = viewBoxHeight;
        }
        // default is to preserve aspect ratio
        preserveAspectRatio = fabric.util.parsePreserveAspectRatioAttribute(preserveAspectRatio);
        if (preserveAspectRatio.alignX !== 'none') {
            //translate all container for the effect of Mid, Min, Max
            if (preserveAspectRatio.meetOrSlice === 'meet') scaleY = scaleX = scaleX > scaleY ? scaleY : scaleX;
            if (preserveAspectRatio.meetOrSlice === 'slice') scaleY = scaleX = scaleX > scaleY ? scaleX : scaleY;
            widthDiff = parsedDim.width - viewBoxWidth * scaleX;
            heightDiff = parsedDim.height - viewBoxHeight * scaleX;
            if (preserveAspectRatio.alignX === 'Mid') widthDiff /= 2;
            if (preserveAspectRatio.alignY === 'Mid') heightDiff /= 2;
            if (preserveAspectRatio.alignX === 'Min') widthDiff = 0;
            if (preserveAspectRatio.alignY === 'Min') heightDiff = 0;
        }
        if (scaleX === 1 && scaleY === 1 && minX === 0 && minY === 0 && x === 0 && y === 0) return parsedDim;
        if ((x || y) && element.parentNode.nodeName !== '#document') translateMatrix = ' translate(' + parseUnit(x) + ' ' + parseUnit(y) + ') ';
        matrix = translateMatrix + ' matrix(' + scaleX + ' 0' + ' 0 ' + scaleY + ' ' + (minX * scaleX + widthDiff) + ' ' + (minY * scaleY + heightDiff) + ') ';
        // seems unused.
        // parsedDim.viewboxTransform = fabric.parseTransformAttribute(matrix);
        if (element.nodeName === 'svg') {
            el = element.ownerDocument.createElementNS(fabric.svgNS, 'g');
            // element.firstChild != null
            while(element.firstChild)el.appendChild(element.firstChild);
            element.appendChild(el);
        } else {
            el = element;
            el.removeAttribute('x');
            el.removeAttribute('y');
            matrix = el.getAttribute('transform') + matrix;
        }
        el.setAttribute('transform', matrix);
        return parsedDim;
    }
    function hasAncestorWithNodeName(element, nodeName) {
        while(element && (element = element.parentNode)){
            if (element.nodeName && nodeName.test(element.nodeName.replace('svg:', '')) && !element.getAttribute('instantiated_by_use')) return true;
        }
        return false;
    }
    /**
   * Parses an SVG document, converts it to an array of corresponding fabric.* instances and passes them to a callback
   * @static
   * @function
   * @memberOf fabric
   * @param {SVGDocument} doc SVG document to parse
   * @param {Function} callback Callback to call when parsing is finished;
   * It's being passed an array of elements (parsed from a document).
   * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
   * @param {Object} [parsingOptions] options for parsing document
   * @param {String} [parsingOptions.crossOrigin] crossOrigin settings
   */ fabric.parseSVGDocument = function(doc, callback, reviver, parsingOptions) {
        if (!doc) return;
        parseUseDirectives(doc);
        var svgUid = fabric.Object.__uid++, i, len, options = applyViewboxTransform(doc), descendants = fabric.util.toArray(doc.getElementsByTagName('*'));
        options.crossOrigin = parsingOptions && parsingOptions.crossOrigin;
        options.svgUid = svgUid;
        if (descendants.length === 0 && fabric.isLikelyNode) {
            // we're likely in node, where "o3-xml" library fails to gEBTN("*")
            // https://github.com/ajaxorg/node-o3-xml/issues/21
            descendants = doc.selectNodes('//*[name(.)!="svg"]');
            var arr = [];
            for(i = 0, len = descendants.length; i < len; i++)arr[i] = descendants[i];
            descendants = arr;
        }
        var elements = descendants.filter(function(el) {
            applyViewboxTransform(el);
            return fabric.svgValidTagNamesRegEx.test(el.nodeName.replace('svg:', '')) && !hasAncestorWithNodeName(el, fabric.svgInvalidAncestorsRegEx); // http://www.w3.org/TR/SVG/struct.html#DefsElement
        });
        if (!elements || elements && !elements.length) {
            callback && callback([], {});
            return;
        }
        var clipPaths = {};
        descendants.filter(function(el) {
            return el.nodeName.replace('svg:', '') === 'clipPath';
        }).forEach(function(el) {
            var id = el.getAttribute('id');
            clipPaths[id] = fabric.util.toArray(el.getElementsByTagName('*')).filter(function(el) {
                return fabric.svgValidTagNamesRegEx.test(el.nodeName.replace('svg:', ''));
            });
        });
        fabric.gradientDefs[svgUid] = fabric.getGradientDefs(doc);
        fabric.cssRules[svgUid] = fabric.getCSSRules(doc);
        fabric.clipPaths[svgUid] = clipPaths;
        // Precedence of rules:   style > class > attribute
        fabric.parseElements(elements, function(instances, elements) {
            if (callback) {
                callback(instances, options, elements, descendants);
                delete fabric.gradientDefs[svgUid];
                delete fabric.cssRules[svgUid];
                delete fabric.clipPaths[svgUid];
            }
        }, clone(options), reviver, parsingOptions);
    };
    function recursivelyParseGradientsXlink(doc, gradient) {
        var gradientsAttrs = [
            'gradientTransform',
            'x1',
            'x2',
            'y1',
            'y2',
            'gradientUnits',
            'cx',
            'cy',
            'r',
            'fx',
            'fy'
        ], xlinkAttr = 'xlink:href', xLink = gradient.getAttribute(xlinkAttr).slice(1), referencedGradient = elementById(doc, xLink);
        if (referencedGradient && referencedGradient.getAttribute(xlinkAttr)) recursivelyParseGradientsXlink(doc, referencedGradient);
        gradientsAttrs.forEach(function(attr) {
            if (referencedGradient && !gradient.hasAttribute(attr) && referencedGradient.hasAttribute(attr)) gradient.setAttribute(attr, referencedGradient.getAttribute(attr));
        });
        if (!gradient.children.length) {
            var referenceClone = referencedGradient.cloneNode(true);
            while(referenceClone.firstChild)gradient.appendChild(referenceClone.firstChild);
        }
        gradient.removeAttribute(xlinkAttr);
    }
    var reFontDeclaration = new RegExp("(normal|italic)?\\s*(normal|small-caps)?\\s*(normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900)?\\s*(" + fabric.reNum + '(?:px|cm|mm|em|pt|pc|in)*)(?:\\/(normal|' + fabric.reNum + '))?\\s+(.*)');
    extend(fabric, {
        /**
     * Parses a short font declaration, building adding its properties to a style object
     * @static
     * @function
     * @memberOf fabric
     * @param {String} value font declaration
     * @param {Object} oStyle definition
     */ parseFontDeclaration: function(value, oStyle) {
            var match = value.match(reFontDeclaration);
            if (!match) return;
            var fontStyle = match[1], // font variant is not used
            // fontVariant = match[2],
            fontWeight = match[3], fontSize = match[4], lineHeight = match[5], fontFamily = match[6];
            if (fontStyle) oStyle.fontStyle = fontStyle;
            if (fontWeight) oStyle.fontWeight = isNaN(parseFloat(fontWeight)) ? fontWeight : parseFloat(fontWeight);
            if (fontSize) oStyle.fontSize = parseUnit(fontSize);
            if (fontFamily) oStyle.fontFamily = fontFamily;
            if (lineHeight) oStyle.lineHeight = lineHeight === 'normal' ? 1 : lineHeight;
        },
        /**
     * Parses an SVG document, returning all of the gradient declarations found in it
     * @static
     * @function
     * @memberOf fabric
     * @param {SVGDocument} doc SVG document to parse
     * @return {Object} Gradient definitions; key corresponds to element id, value -- to gradient definition element
     */ getGradientDefs: function(doc) {
            var tagArray = [
                'linearGradient',
                'radialGradient',
                'svg:linearGradient',
                'svg:radialGradient'
            ], elList = _getMultipleNodes(doc, tagArray), el, j = 0, gradientDefs = {};
            j = elList.length;
            while(j--){
                el = elList[j];
                if (el.getAttribute('xlink:href')) recursivelyParseGradientsXlink(doc, el);
                gradientDefs[el.getAttribute('id')] = el;
            }
            return gradientDefs;
        },
        /**
     * Returns an object of attributes' name/value, given element and an array of attribute names;
     * Parses parent "g" nodes recursively upwards.
     * @static
     * @memberOf fabric
     * @param {DOMElement} element Element to parse
     * @param {Array} attributes Array of attributes to parse
     * @return {Object} object containing parsed attributes' names/values
     */ parseAttributes: function(element, attributes, svgUid) {
            if (!element) return;
            var value, parentAttributes = {}, fontSize, parentFontSize;
            if (typeof svgUid === 'undefined') svgUid = element.getAttribute('svgUid');
            // if there's a parent container (`g` or `a` or `symbol` node), parse its attributes recursively upwards
            if (element.parentNode && fabric.svgValidParentsRegEx.test(element.parentNode.nodeName)) parentAttributes = fabric.parseAttributes(element.parentNode, attributes, svgUid);
            var ownAttributes = attributes.reduce(function(memo, attr) {
                value = element.getAttribute(attr);
                if (value) memo[attr] = value;
                return memo;
            }, {});
            // add values parsed from style, which take precedence over attributes
            // (see: http://www.w3.org/TR/SVG/styling.html#UsingPresentationAttributes)
            var cssAttrs = extend(getGlobalStylesForElement(element, svgUid), fabric.parseStyleAttribute(element));
            ownAttributes = extend(ownAttributes, cssAttrs);
            if (cssAttrs[cPath]) element.setAttribute(cPath, cssAttrs[cPath]);
            fontSize = parentFontSize = parentAttributes.fontSize || fabric.Text.DEFAULT_SVG_FONT_SIZE;
            if (ownAttributes[fSize]) // looks like the minimum should be 9px when dealing with ems. this is what looks like in browsers.
            ownAttributes[fSize] = fontSize = parseUnit(ownAttributes[fSize], parentFontSize);
            var normalizedAttr, normalizedValue, normalizedStyle = {};
            for(var attr in ownAttributes){
                normalizedAttr = normalizeAttr(attr);
                normalizedValue = normalizeValue(normalizedAttr, ownAttributes[attr], parentAttributes, fontSize);
                normalizedStyle[normalizedAttr] = normalizedValue;
            }
            if (normalizedStyle && normalizedStyle.font) fabric.parseFontDeclaration(normalizedStyle.font, normalizedStyle);
            var mergedAttrs = extend(parentAttributes, normalizedStyle);
            return fabric.svgValidParentsRegEx.test(element.nodeName) ? mergedAttrs : _setStrokeFillOpacity(mergedAttrs);
        },
        /**
     * Transforms an array of svg elements to corresponding fabric.* instances
     * @static
     * @memberOf fabric
     * @param {Array} elements Array of elements to parse
     * @param {Function} callback Being passed an array of fabric instances (transformed from SVG elements)
     * @param {Object} [options] Options object
     * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
     */ parseElements: function(elements, callback, options, reviver, parsingOptions) {
            new fabric.ElementsParser(elements, callback, options, reviver, parsingOptions).parse();
        },
        /**
     * Parses "style" attribute, retuning an object with values
     * @static
     * @memberOf fabric
     * @param {SVGElement} element Element to parse
     * @return {Object} Objects with values parsed from style attribute of an element
     */ parseStyleAttribute: function(element) {
            var oStyle = {}, style = element.getAttribute('style');
            if (!style) return oStyle;
            if (typeof style === 'string') parseStyleString(style, oStyle);
            else parseStyleObject(style, oStyle);
            return oStyle;
        },
        /**
     * Parses "points" attribute, returning an array of values
     * @static
     * @memberOf fabric
     * @param {String} points points attribute string
     * @return {Array} array of points
     */ parsePointsAttribute: function(points) {
            // points attribute is required and must not be empty
            if (!points) return null;
            // replace commas with whitespace and remove bookending whitespace
            points = points.replace(/,/g, ' ').trim();
            points = points.split(/\s+/);
            var parsedPoints = [], i, len;
            for(i = 0, len = points.length; i < len; i += 2)parsedPoints.push({
                x: parseFloat(points[i]),
                y: parseFloat(points[i + 1])
            });
            // odd number of points is an error
            // if (parsedPoints.length % 2 !== 0) {
            //   return null;
            // }
            return parsedPoints;
        },
        /**
     * Returns CSS rules for a given SVG document
     * @static
     * @function
     * @memberOf fabric
     * @param {SVGDocument} doc SVG document to parse
     * @return {Object} CSS rules of this document
     */ getCSSRules: function(doc) {
            var styles = doc.getElementsByTagName('style'), i, len, allRules = {}, rules;
            // very crude parsing of style contents
            for(i = 0, len = styles.length; i < len; i++){
                var styleContents = styles[i].textContent;
                // remove comments
                styleContents = styleContents.replace(/\/\*[\s\S]*?\*\//g, '');
                if (styleContents.trim() === '') continue;
                // recovers all the rule in this form `body { style code... }`
                // rules = styleContents.match(/[^{]*\{[\s\S]*?\}/g);
                rules = styleContents.split('}');
                // remove empty rules.
                rules = rules.filter(function(rule) {
                    return rule.trim();
                });
                // at this point we have hopefully an array of rules `body { style code... `
                // eslint-disable-next-line no-loop-func
                rules.forEach(function(rule) {
                    var match = rule.split('{'), ruleObj = {}, declaration = match[1].trim(), propertyValuePairs = declaration.split(';').filter(function(pair) {
                        return pair.trim();
                    });
                    for(i = 0, len = propertyValuePairs.length; i < len; i++){
                        var pair = propertyValuePairs[i].split(':'), property = pair[0].trim(), value = pair[1].trim();
                        ruleObj[property] = value;
                    }
                    rule = match[0].trim();
                    rule.split(',').forEach(function(_rule) {
                        _rule = _rule.replace(/^svg/i, '').trim();
                        if (_rule === '') return;
                        if (allRules[_rule]) fabric.util.object.extend(allRules[_rule], ruleObj);
                        else allRules[_rule] = fabric.util.object.clone(ruleObj);
                    });
                });
            }
            return allRules;
        },
        /**
     * Takes url corresponding to an SVG document, and parses it into a set of fabric objects.
     * Note that SVG is fetched via XMLHttpRequest, so it needs to conform to SOP (Same Origin Policy)
     * @memberOf fabric
     * @param {String} url
     * @param {Function} callback
     * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
     * @param {Object} [options] Object containing options for parsing
     * @param {String} [options.crossOrigin] crossOrigin crossOrigin setting to use for external resources
     */ loadSVGFromURL: function(url, callback, reviver, options) {
            url = url.replace(/^\n\s*/, '').trim();
            new fabric.util.request(url, {
                method: 'get',
                onComplete: onComplete
            });
            function onComplete(r) {
                var xml = r.responseXML;
                if (!xml || !xml.documentElement) {
                    callback && callback(null);
                    return false;
                }
                fabric.parseSVGDocument(xml.documentElement, function(results, _options, elements, allElements) {
                    callback && callback(results, _options, elements, allElements);
                }, reviver, options);
            }
        },
        /**
     * Takes string corresponding to an SVG document, and parses it into a set of fabric objects
     * @memberOf fabric
     * @param {String} string
     * @param {Function} callback
     * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
     * @param {Object} [options] Object containing options for parsing
     * @param {String} [options.crossOrigin] crossOrigin crossOrigin setting to use for external resources
     */ loadSVGFromString: function(string, callback, reviver, options) {
            var parser = new fabric.window.DOMParser(), doc = parser.parseFromString(string.trim(), 'text/xml');
            fabric.parseSVGDocument(doc.documentElement, function(results, _options, elements, allElements) {
                callback(results, _options, elements, allElements);
            }, reviver, options);
        }
    });
})($79564f678731bf19$exports);
$79564f678731bf19$var$fabric.ElementsParser = function(elements, callback, options, reviver, parsingOptions, doc) {
    this.elements = elements;
    this.callback = callback;
    this.options = options;
    this.reviver = reviver;
    this.svgUid = options && options.svgUid || 0;
    this.parsingOptions = parsingOptions;
    this.regexUrl = /^url\(['"]?#([^'"]+)['"]?\)/g;
    this.doc = doc;
};
(function(proto) {
    proto.parse = function() {
        this.instances = new Array(this.elements.length);
        this.numElements = this.elements.length;
        this.createObjects();
    };
    proto.createObjects = function() {
        var _this = this;
        this.elements.forEach(function(element, i) {
            element.setAttribute('svgUid', _this.svgUid);
            _this.createObject(element, i);
        });
    };
    proto.findTag = function(el) {
        return $79564f678731bf19$var$fabric[$79564f678731bf19$var$fabric.util.string.capitalize(el.tagName.replace('svg:', ''))];
    };
    proto.createObject = function(el, index) {
        var klass = this.findTag(el);
        if (klass && klass.fromElement) try {
            klass.fromElement(el, this.createCallback(index, el), this.options);
        } catch (err) {
            $79564f678731bf19$var$fabric.log(err);
        }
        else this.checkIfDone();
    };
    proto.createCallback = function(index, el) {
        var _this = this;
        return function(obj) {
            var _options;
            _this.resolveGradient(obj, el, 'fill');
            _this.resolveGradient(obj, el, 'stroke');
            if (obj instanceof $79564f678731bf19$var$fabric.Image && obj._originalElement) _options = obj.parsePreserveAspectRatioAttribute(el);
            obj._removeTransformMatrix(_options);
            _this.resolveClipPath(obj, el);
            _this.reviver && _this.reviver(el, obj);
            _this.instances[index] = obj;
            _this.checkIfDone();
        };
    };
    proto.extractPropertyDefinition = function(obj, property, storage) {
        var value = obj[property], regex = this.regexUrl;
        if (!regex.test(value)) return;
        regex.lastIndex = 0;
        var id = regex.exec(value)[1];
        regex.lastIndex = 0;
        return $79564f678731bf19$var$fabric[storage][this.svgUid][id];
    };
    proto.resolveGradient = function(obj, el, property) {
        var gradientDef = this.extractPropertyDefinition(obj, property, 'gradientDefs');
        if (gradientDef) {
            var opacityAttr = el.getAttribute(property + '-opacity');
            var gradient = $79564f678731bf19$var$fabric.Gradient.fromElement(gradientDef, obj, opacityAttr, this.options);
            obj.set(property, gradient);
        }
    };
    proto.createClipPathCallback = function(obj, container) {
        return function(_newObj) {
            _newObj._removeTransformMatrix();
            _newObj.fillRule = _newObj.clipRule;
            container.push(_newObj);
        };
    };
    proto.resolveClipPath = function(obj, usingElement) {
        var clipPath = this.extractPropertyDefinition(obj, 'clipPath', 'clipPaths'), element, klass, objTransformInv, container, gTransform, options;
        if (clipPath) {
            container = [];
            objTransformInv = $79564f678731bf19$var$fabric.util.invertTransform(obj.calcTransformMatrix());
            // move the clipPath tag as sibling to the real element that is using it
            var clipPathTag = clipPath[0].parentNode;
            var clipPathOwner = usingElement;
            while(clipPathOwner.parentNode && clipPathOwner.getAttribute('clip-path') !== obj.clipPath)clipPathOwner = clipPathOwner.parentNode;
            clipPathOwner.parentNode.appendChild(clipPathTag);
            for(var i = 0; i < clipPath.length; i++){
                element = clipPath[i];
                klass = this.findTag(element);
                klass.fromElement(element, this.createClipPathCallback(obj, container), this.options);
            }
            if (container.length === 1) clipPath = container[0];
            else clipPath = new $79564f678731bf19$var$fabric.Group(container);
            gTransform = $79564f678731bf19$var$fabric.util.multiplyTransformMatrices(objTransformInv, clipPath.calcTransformMatrix());
            if (clipPath.clipPath) this.resolveClipPath(clipPath, clipPathOwner);
            var options = $79564f678731bf19$var$fabric.util.qrDecompose(gTransform);
            clipPath.flipX = false;
            clipPath.flipY = false;
            clipPath.set('scaleX', options.scaleX);
            clipPath.set('scaleY', options.scaleY);
            clipPath.angle = options.angle;
            clipPath.skewX = options.skewX;
            clipPath.skewY = 0;
            clipPath.setPositionByOrigin({
                x: options.translateX,
                y: options.translateY
            }, 'center', 'center');
            obj.clipPath = clipPath;
        } else // if clip-path does not resolve to any element, delete the property.
        delete obj.clipPath;
    };
    proto.checkIfDone = function() {
        if (--this.numElements === 0) {
            this.instances = this.instances.filter(function(el) {
                // eslint-disable-next-line no-eq-null, eqeqeq
                return el != null;
            });
            this.callback(this.instances, this.elements);
        }
    };
})($79564f678731bf19$var$fabric.ElementsParser.prototype);
(function(global) {
    'use strict';
    /* Adaptation of work of Kevin Lindsey (kevin@kevlindev.com) */ var fabric = global.fabric || (global.fabric = {});
    if (fabric.Point) {
        fabric.warn('fabric.Point is already defined');
        return;
    }
    fabric.Point = Point;
    /**
   * Point class
   * @class fabric.Point
   * @memberOf fabric
   * @constructor
   * @param {Number} x
   * @param {Number} y
   * @return {fabric.Point} thisArg
   */ function Point(x, y) {
        this.x = x;
        this.y = y;
    }
    Point.prototype = /** @lends fabric.Point.prototype */ {
        type: 'point',
        constructor: Point,
        /**
     * Adds another point to this one and returns another one
     * @param {fabric.Point} that
     * @return {fabric.Point} new Point instance with added values
     */ add: function(that) {
            return new Point(this.x + that.x, this.y + that.y);
        },
        /**
     * Adds another point to this one
     * @param {fabric.Point} that
     * @return {fabric.Point} thisArg
     * @chainable
     */ addEquals: function(that) {
            this.x += that.x;
            this.y += that.y;
            return this;
        },
        /**
     * Adds value to this point and returns a new one
     * @param {Number} scalar
     * @return {fabric.Point} new Point with added value
     */ scalarAdd: function(scalar) {
            return new Point(this.x + scalar, this.y + scalar);
        },
        /**
     * Adds value to this point
     * @param {Number} scalar
     * @return {fabric.Point} thisArg
     * @chainable
     */ scalarAddEquals: function(scalar) {
            this.x += scalar;
            this.y += scalar;
            return this;
        },
        /**
     * Subtracts another point from this point and returns a new one
     * @param {fabric.Point} that
     * @return {fabric.Point} new Point object with subtracted values
     */ subtract: function(that) {
            return new Point(this.x - that.x, this.y - that.y);
        },
        /**
     * Subtracts another point from this point
     * @param {fabric.Point} that
     * @return {fabric.Point} thisArg
     * @chainable
     */ subtractEquals: function(that) {
            this.x -= that.x;
            this.y -= that.y;
            return this;
        },
        /**
     * Subtracts value from this point and returns a new one
     * @param {Number} scalar
     * @return {fabric.Point}
     */ scalarSubtract: function(scalar) {
            return new Point(this.x - scalar, this.y - scalar);
        },
        /**
     * Subtracts value from this point
     * @param {Number} scalar
     * @return {fabric.Point} thisArg
     * @chainable
     */ scalarSubtractEquals: function(scalar) {
            this.x -= scalar;
            this.y -= scalar;
            return this;
        },
        /**
     * Multiplies this point by a value and returns a new one
     * TODO: rename in scalarMultiply in 2.0
     * @param {Number} scalar
     * @return {fabric.Point}
     */ multiply: function(scalar) {
            return new Point(this.x * scalar, this.y * scalar);
        },
        /**
     * Multiplies this point by a value
     * TODO: rename in scalarMultiplyEquals in 2.0
     * @param {Number} scalar
     * @return {fabric.Point} thisArg
     * @chainable
     */ multiplyEquals: function(scalar) {
            this.x *= scalar;
            this.y *= scalar;
            return this;
        },
        /**
     * Divides this point by a value and returns a new one
     * TODO: rename in scalarDivide in 2.0
     * @param {Number} scalar
     * @return {fabric.Point}
     */ divide: function(scalar) {
            return new Point(this.x / scalar, this.y / scalar);
        },
        /**
     * Divides this point by a value
     * TODO: rename in scalarDivideEquals in 2.0
     * @param {Number} scalar
     * @return {fabric.Point} thisArg
     * @chainable
     */ divideEquals: function(scalar) {
            this.x /= scalar;
            this.y /= scalar;
            return this;
        },
        /**
     * Returns true if this point is equal to another one
     * @param {fabric.Point} that
     * @return {Boolean}
     */ eq: function(that) {
            return this.x === that.x && this.y === that.y;
        },
        /**
     * Returns true if this point is less than another one
     * @param {fabric.Point} that
     * @return {Boolean}
     */ lt: function(that) {
            return this.x < that.x && this.y < that.y;
        },
        /**
     * Returns true if this point is less than or equal to another one
     * @param {fabric.Point} that
     * @return {Boolean}
     */ lte: function(that) {
            return this.x <= that.x && this.y <= that.y;
        },
        /**

     * Returns true if this point is greater another one
     * @param {fabric.Point} that
     * @return {Boolean}
     */ gt: function(that) {
            return this.x > that.x && this.y > that.y;
        },
        /**
     * Returns true if this point is greater than or equal to another one
     * @param {fabric.Point} that
     * @return {Boolean}
     */ gte: function(that) {
            return this.x >= that.x && this.y >= that.y;
        },
        /**
     * Returns new point which is the result of linear interpolation with this one and another one
     * @param {fabric.Point} that
     * @param {Number} t , position of interpolation, between 0 and 1 default 0.5
     * @return {fabric.Point}
     */ lerp: function(that, t) {
            if (typeof t === 'undefined') t = 0.5;
            t = Math.max(Math.min(1, t), 0);
            return new Point(this.x + (that.x - this.x) * t, this.y + (that.y - this.y) * t);
        },
        /**
     * Returns distance from this point and another one
     * @param {fabric.Point} that
     * @return {Number}
     */ distanceFrom: function(that) {
            var dx = this.x - that.x, dy = this.y - that.y;
            return Math.sqrt(dx * dx + dy * dy);
        },
        /**
     * Returns the point between this point and another one
     * @param {fabric.Point} that
     * @return {fabric.Point}
     */ midPointFrom: function(that) {
            return this.lerp(that);
        },
        /**
     * Returns a new point which is the min of this and another one
     * @param {fabric.Point} that
     * @return {fabric.Point}
     */ min: function(that) {
            return new Point(Math.min(this.x, that.x), Math.min(this.y, that.y));
        },
        /**
     * Returns a new point which is the max of this and another one
     * @param {fabric.Point} that
     * @return {fabric.Point}
     */ max: function(that) {
            return new Point(Math.max(this.x, that.x), Math.max(this.y, that.y));
        },
        /**
     * Returns string representation of this point
     * @return {String}
     */ toString: function() {
            return this.x + ',' + this.y;
        },
        /**
     * Sets x/y of this point
     * @param {Number} x
     * @param {Number} y
     * @chainable
     */ setXY: function(x, y) {
            this.x = x;
            this.y = y;
            return this;
        },
        /**
     * Sets x of this point
     * @param {Number} x
     * @chainable
     */ setX: function(x) {
            this.x = x;
            return this;
        },
        /**
     * Sets y of this point
     * @param {Number} y
     * @chainable
     */ setY: function(y) {
            this.y = y;
            return this;
        },
        /**
     * Sets x/y of this point from another point
     * @param {fabric.Point} that
     * @chainable
     */ setFromPoint: function(that) {
            this.x = that.x;
            this.y = that.y;
            return this;
        },
        /**
     * Swaps x/y of this point and another point
     * @param {fabric.Point} that
     */ swap: function(that) {
            var x = this.x, y = this.y;
            this.x = that.x;
            this.y = that.y;
            that.x = x;
            that.y = y;
        },
        /**
     * return a cloned instance of the point
     * @return {fabric.Point}
     */ clone: function() {
            return new Point(this.x, this.y);
        }
    };
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    /* Adaptation of work of Kevin Lindsey (kevin@kevlindev.com) */ var fabric = global.fabric || (global.fabric = {});
    if (fabric.Intersection) {
        fabric.warn('fabric.Intersection is already defined');
        return;
    }
    /**
   * Intersection class
   * @class fabric.Intersection
   * @memberOf fabric
   * @constructor
   */ function Intersection(status) {
        this.status = status;
        this.points = [];
    }
    fabric.Intersection = Intersection;
    fabric.Intersection.prototype = /** @lends fabric.Intersection.prototype */ {
        constructor: Intersection,
        /**
     * Appends a point to intersection
     * @param {fabric.Point} point
     * @return {fabric.Intersection} thisArg
     * @chainable
     */ appendPoint: function(point) {
            this.points.push(point);
            return this;
        },
        /**
     * Appends points to intersection
     * @param {Array} points
     * @return {fabric.Intersection} thisArg
     * @chainable
     */ appendPoints: function(points) {
            this.points = this.points.concat(points);
            return this;
        }
    };
    /**
   * Checks if one line intersects another
   * TODO: rename in intersectSegmentSegment
   * @static
   * @param {fabric.Point} a1
   * @param {fabric.Point} a2
   * @param {fabric.Point} b1
   * @param {fabric.Point} b2
   * @return {fabric.Intersection}
   */ fabric.Intersection.intersectLineLine = function(a1, a2, b1, b2) {
        var result, uaT = (b2.x - b1.x) * (a1.y - b1.y) - (b2.y - b1.y) * (a1.x - b1.x), ubT = (a2.x - a1.x) * (a1.y - b1.y) - (a2.y - a1.y) * (a1.x - b1.x), uB = (b2.y - b1.y) * (a2.x - a1.x) - (b2.x - b1.x) * (a2.y - a1.y);
        if (uB !== 0) {
            var ua = uaT / uB, ub = ubT / uB;
            if (0 <= ua && ua <= 1 && 0 <= ub && ub <= 1) {
                result = new Intersection('Intersection');
                result.appendPoint(new fabric.Point(a1.x + ua * (a2.x - a1.x), a1.y + ua * (a2.y - a1.y)));
            } else result = new Intersection();
        } else if (uaT === 0 || ubT === 0) result = new Intersection('Coincident');
        else result = new Intersection('Parallel');
        return result;
    };
    /**
   * Checks if line intersects polygon
   * TODO: rename in intersectSegmentPolygon
   * fix detection of coincident
   * @static
   * @param {fabric.Point} a1
   * @param {fabric.Point} a2
   * @param {Array} points
   * @return {fabric.Intersection}
   */ fabric.Intersection.intersectLinePolygon = function(a1, a2, points) {
        var result = new Intersection(), length = points.length, b1, b2, inter, i;
        for(i = 0; i < length; i++){
            b1 = points[i];
            b2 = points[(i + 1) % length];
            inter = Intersection.intersectLineLine(a1, a2, b1, b2);
            result.appendPoints(inter.points);
        }
        if (result.points.length > 0) result.status = 'Intersection';
        return result;
    };
    /**
   * Checks if polygon intersects another polygon
   * @static
   * @param {Array} points1
   * @param {Array} points2
   * @return {fabric.Intersection}
   */ fabric.Intersection.intersectPolygonPolygon = function(points1, points2) {
        var result = new Intersection(), length = points1.length, i;
        for(i = 0; i < length; i++){
            var a1 = points1[i], a2 = points1[(i + 1) % length], inter = Intersection.intersectLinePolygon(a1, a2, points2);
            result.appendPoints(inter.points);
        }
        if (result.points.length > 0) result.status = 'Intersection';
        return result;
    };
    /**
   * Checks if polygon intersects rectangle
   * @static
   * @param {Array} points
   * @param {fabric.Point} r1
   * @param {fabric.Point} r2
   * @return {fabric.Intersection}
   */ fabric.Intersection.intersectPolygonRectangle = function(points, r1, r2) {
        var min = r1.min(r2), max = r1.max(r2), topRight = new fabric.Point(max.x, min.y), bottomLeft = new fabric.Point(min.x, max.y), inter1 = Intersection.intersectLinePolygon(min, topRight, points), inter2 = Intersection.intersectLinePolygon(topRight, max, points), inter3 = Intersection.intersectLinePolygon(max, bottomLeft, points), inter4 = Intersection.intersectLinePolygon(bottomLeft, min, points), result = new Intersection();
        result.appendPoints(inter1.points);
        result.appendPoints(inter2.points);
        result.appendPoints(inter3.points);
        result.appendPoints(inter4.points);
        if (result.points.length > 0) result.status = 'Intersection';
        return result;
    };
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {});
    if (fabric.Color) {
        fabric.warn('fabric.Color is already defined.');
        return;
    }
    /**
   * Color class
   * The purpose of {@link fabric.Color} is to abstract and encapsulate common color operations;
   * {@link fabric.Color} is a constructor and creates instances of {@link fabric.Color} objects.
   *
   * @class fabric.Color
   * @param {String} color optional in hex or rgb(a) or hsl format or from known color list
   * @return {fabric.Color} thisArg
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2/#colors}
   */ function Color(color) {
        if (!color) this.setSource([
            0,
            0,
            0,
            1
        ]);
        else this._tryParsingColor(color);
    }
    fabric.Color = Color;
    fabric.Color.prototype = /** @lends fabric.Color.prototype */ {
        /**
     * @private
     * @param {String|Array} color Color value to parse
     */ _tryParsingColor: function(color) {
            var source;
            if (color in Color.colorNameMap) color = Color.colorNameMap[color];
            if (color === 'transparent') source = [
                255,
                255,
                255,
                0
            ];
            if (!source) source = Color.sourceFromHex(color);
            if (!source) source = Color.sourceFromRgb(color);
            if (!source) source = Color.sourceFromHsl(color);
            if (!source) //if color is not recognize let's make black as canvas does
            source = [
                0,
                0,
                0,
                1
            ];
            if (source) this.setSource(source);
        },
        /**
     * Adapted from <a href="https://rawgithub.com/mjijackson/mjijackson.github.com/master/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript.html">https://github.com/mjijackson</a>
     * @private
     * @param {Number} r Red color value
     * @param {Number} g Green color value
     * @param {Number} b Blue color value
     * @return {Array} Hsl color
     */ _rgbToHsl: function(r, g, b) {
            r /= 255;
            g /= 255;
            b /= 255;
            var h, s, l, max = fabric.util.array.max([
                r,
                g,
                b
            ]), min = fabric.util.array.min([
                r,
                g,
                b
            ]);
            l = (max + min) / 2;
            if (max === min) h = s = 0; // achromatic
            else {
                var d = max - min;
                s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
                switch(max){
                    case r:
                        h = (g - b) / d + (g < b ? 6 : 0);
                        break;
                    case g:
                        h = (b - r) / d + 2;
                        break;
                    case b:
                        h = (r - g) / d + 4;
                        break;
                }
                h /= 6;
            }
            return [
                Math.round(h * 360),
                Math.round(s * 100),
                Math.round(l * 100)
            ];
        },
        /**
     * Returns source of this color (where source is an array representation; ex: [200, 200, 100, 1])
     * @return {Array}
     */ getSource: function() {
            return this._source;
        },
        /**
     * Sets source of this color (where source is an array representation; ex: [200, 200, 100, 1])
     * @param {Array} source
     */ setSource: function(source) {
            this._source = source;
        },
        /**
     * Returns color representation in RGB format
     * @return {String} ex: rgb(0-255,0-255,0-255)
     */ toRgb: function() {
            var source = this.getSource();
            return 'rgb(' + source[0] + ',' + source[1] + ',' + source[2] + ')';
        },
        /**
     * Returns color representation in RGBA format
     * @return {String} ex: rgba(0-255,0-255,0-255,0-1)
     */ toRgba: function() {
            var source = this.getSource();
            return 'rgba(' + source[0] + ',' + source[1] + ',' + source[2] + ',' + source[3] + ')';
        },
        /**
     * Returns color representation in HSL format
     * @return {String} ex: hsl(0-360,0%-100%,0%-100%)
     */ toHsl: function() {
            var source = this.getSource(), hsl = this._rgbToHsl(source[0], source[1], source[2]);
            return 'hsl(' + hsl[0] + ',' + hsl[1] + '%,' + hsl[2] + '%)';
        },
        /**
     * Returns color representation in HSLA format
     * @return {String} ex: hsla(0-360,0%-100%,0%-100%,0-1)
     */ toHsla: function() {
            var source = this.getSource(), hsl = this._rgbToHsl(source[0], source[1], source[2]);
            return 'hsla(' + hsl[0] + ',' + hsl[1] + '%,' + hsl[2] + '%,' + source[3] + ')';
        },
        /**
     * Returns color representation in HEX format
     * @return {String} ex: FF5555
     */ toHex: function() {
            var source = this.getSource(), r, g, b;
            r = source[0].toString(16);
            r = r.length === 1 ? '0' + r : r;
            g = source[1].toString(16);
            g = g.length === 1 ? '0' + g : g;
            b = source[2].toString(16);
            b = b.length === 1 ? '0' + b : b;
            return r.toUpperCase() + g.toUpperCase() + b.toUpperCase();
        },
        /**
     * Returns color representation in HEXA format
     * @return {String} ex: FF5555CC
     */ toHexa: function() {
            var source = this.getSource(), a;
            a = Math.round(source[3] * 255);
            a = a.toString(16);
            a = a.length === 1 ? '0' + a : a;
            return this.toHex() + a.toUpperCase();
        },
        /**
     * Gets value of alpha channel for this color
     * @return {Number} 0-1
     */ getAlpha: function() {
            return this.getSource()[3];
        },
        /**
     * Sets value of alpha channel for this color
     * @param {Number} alpha Alpha value 0-1
     * @return {fabric.Color} thisArg
     */ setAlpha: function(alpha) {
            var source = this.getSource();
            source[3] = alpha;
            this.setSource(source);
            return this;
        },
        /**
     * Transforms color to its grayscale representation
     * @return {fabric.Color} thisArg
     */ toGrayscale: function() {
            var source = this.getSource(), average = parseInt((source[0] * 0.3 + source[1] * 0.59 + source[2] * 0.11).toFixed(0), 10), currentAlpha = source[3];
            this.setSource([
                average,
                average,
                average,
                currentAlpha
            ]);
            return this;
        },
        /**
     * Transforms color to its black and white representation
     * @param {Number} threshold
     * @return {fabric.Color} thisArg
     */ toBlackWhite: function(threshold) {
            var source = this.getSource(), average = (source[0] * 0.3 + source[1] * 0.59 + source[2] * 0.11).toFixed(0), currentAlpha = source[3];
            threshold = threshold || 127;
            average = Number(average) < Number(threshold) ? 0 : 255;
            this.setSource([
                average,
                average,
                average,
                currentAlpha
            ]);
            return this;
        },
        /**
     * Overlays color with another color
     * @param {String|fabric.Color} otherColor
     * @return {fabric.Color} thisArg
     */ overlayWith: function(otherColor) {
            if (!(otherColor instanceof Color)) otherColor = new Color(otherColor);
            var result = [], alpha = this.getAlpha(), otherAlpha = 0.5, source = this.getSource(), otherSource = otherColor.getSource(), i;
            for(i = 0; i < 3; i++)result.push(Math.round(source[i] * (1 - otherAlpha) + otherSource[i] * otherAlpha));
            result[3] = alpha;
            this.setSource(result);
            return this;
        }
    };
    /**
   * Regex matching color in RGB or RGBA formats (ex: rgb(0, 0, 0), rgba(255, 100, 10, 0.5), rgba( 255 , 100 , 10 , 0.5 ), rgb(1,1,1), rgba(100%, 60%, 10%, 0.5))
   * @static
   * @field
   * @memberOf fabric.Color
   */ // eslint-disable-next-line max-len
    fabric.Color.reRGBa = /^rgba?\(\s*(\d{1,3}(?:\.\d+)?\%?)\s*,\s*(\d{1,3}(?:\.\d+)?\%?)\s*,\s*(\d{1,3}(?:\.\d+)?\%?)\s*(?:\s*,\s*((?:\d*\.?\d+)?)\s*)?\)$/i;
    /**
   * Regex matching color in HSL or HSLA formats (ex: hsl(200, 80%, 10%), hsla(300, 50%, 80%, 0.5), hsla( 300 , 50% , 80% , 0.5 ))
   * @static
   * @field
   * @memberOf fabric.Color
   */ fabric.Color.reHSLa = /^hsla?\(\s*(\d{1,3})\s*,\s*(\d{1,3}\%)\s*,\s*(\d{1,3}\%)\s*(?:\s*,\s*(\d+(?:\.\d+)?)\s*)?\)$/i;
    /**
   * Regex matching color in HEX format (ex: #FF5544CC, #FF5555, 010155, aff)
   * @static
   * @field
   * @memberOf fabric.Color
   */ fabric.Color.reHex = /^#?([0-9a-f]{8}|[0-9a-f]{6}|[0-9a-f]{4}|[0-9a-f]{3})$/i;
    /**
   * Map of the 148 color names with HEX code
   * @static
   * @field
   * @memberOf fabric.Color
   * @see: https://www.w3.org/TR/css3-color/#svg-color
   */ fabric.Color.colorNameMap = {
        aliceblue: '#F0F8FF',
        antiquewhite: '#FAEBD7',
        aqua: '#00FFFF',
        aquamarine: '#7FFFD4',
        azure: '#F0FFFF',
        beige: '#F5F5DC',
        bisque: '#FFE4C4',
        black: '#000000',
        blanchedalmond: '#FFEBCD',
        blue: '#0000FF',
        blueviolet: '#8A2BE2',
        brown: '#A52A2A',
        burlywood: '#DEB887',
        cadetblue: '#5F9EA0',
        chartreuse: '#7FFF00',
        chocolate: '#D2691E',
        coral: '#FF7F50',
        cornflowerblue: '#6495ED',
        cornsilk: '#FFF8DC',
        crimson: '#DC143C',
        cyan: '#00FFFF',
        darkblue: '#00008B',
        darkcyan: '#008B8B',
        darkgoldenrod: '#B8860B',
        darkgray: '#A9A9A9',
        darkgrey: '#A9A9A9',
        darkgreen: '#006400',
        darkkhaki: '#BDB76B',
        darkmagenta: '#8B008B',
        darkolivegreen: '#556B2F',
        darkorange: '#FF8C00',
        darkorchid: '#9932CC',
        darkred: '#8B0000',
        darksalmon: '#E9967A',
        darkseagreen: '#8FBC8F',
        darkslateblue: '#483D8B',
        darkslategray: '#2F4F4F',
        darkslategrey: '#2F4F4F',
        darkturquoise: '#00CED1',
        darkviolet: '#9400D3',
        deeppink: '#FF1493',
        deepskyblue: '#00BFFF',
        dimgray: '#696969',
        dimgrey: '#696969',
        dodgerblue: '#1E90FF',
        firebrick: '#B22222',
        floralwhite: '#FFFAF0',
        forestgreen: '#228B22',
        fuchsia: '#FF00FF',
        gainsboro: '#DCDCDC',
        ghostwhite: '#F8F8FF',
        gold: '#FFD700',
        goldenrod: '#DAA520',
        gray: '#808080',
        grey: '#808080',
        green: '#008000',
        greenyellow: '#ADFF2F',
        honeydew: '#F0FFF0',
        hotpink: '#FF69B4',
        indianred: '#CD5C5C',
        indigo: '#4B0082',
        ivory: '#FFFFF0',
        khaki: '#F0E68C',
        lavender: '#E6E6FA',
        lavenderblush: '#FFF0F5',
        lawngreen: '#7CFC00',
        lemonchiffon: '#FFFACD',
        lightblue: '#ADD8E6',
        lightcoral: '#F08080',
        lightcyan: '#E0FFFF',
        lightgoldenrodyellow: '#FAFAD2',
        lightgray: '#D3D3D3',
        lightgrey: '#D3D3D3',
        lightgreen: '#90EE90',
        lightpink: '#FFB6C1',
        lightsalmon: '#FFA07A',
        lightseagreen: '#20B2AA',
        lightskyblue: '#87CEFA',
        lightslategray: '#778899',
        lightslategrey: '#778899',
        lightsteelblue: '#B0C4DE',
        lightyellow: '#FFFFE0',
        lime: '#00FF00',
        limegreen: '#32CD32',
        linen: '#FAF0E6',
        magenta: '#FF00FF',
        maroon: '#800000',
        mediumaquamarine: '#66CDAA',
        mediumblue: '#0000CD',
        mediumorchid: '#BA55D3',
        mediumpurple: '#9370DB',
        mediumseagreen: '#3CB371',
        mediumslateblue: '#7B68EE',
        mediumspringgreen: '#00FA9A',
        mediumturquoise: '#48D1CC',
        mediumvioletred: '#C71585',
        midnightblue: '#191970',
        mintcream: '#F5FFFA',
        mistyrose: '#FFE4E1',
        moccasin: '#FFE4B5',
        navajowhite: '#FFDEAD',
        navy: '#000080',
        oldlace: '#FDF5E6',
        olive: '#808000',
        olivedrab: '#6B8E23',
        orange: '#FFA500',
        orangered: '#FF4500',
        orchid: '#DA70D6',
        palegoldenrod: '#EEE8AA',
        palegreen: '#98FB98',
        paleturquoise: '#AFEEEE',
        palevioletred: '#DB7093',
        papayawhip: '#FFEFD5',
        peachpuff: '#FFDAB9',
        peru: '#CD853F',
        pink: '#FFC0CB',
        plum: '#DDA0DD',
        powderblue: '#B0E0E6',
        purple: '#800080',
        rebeccapurple: '#663399',
        red: '#FF0000',
        rosybrown: '#BC8F8F',
        royalblue: '#4169E1',
        saddlebrown: '#8B4513',
        salmon: '#FA8072',
        sandybrown: '#F4A460',
        seagreen: '#2E8B57',
        seashell: '#FFF5EE',
        sienna: '#A0522D',
        silver: '#C0C0C0',
        skyblue: '#87CEEB',
        slateblue: '#6A5ACD',
        slategray: '#708090',
        slategrey: '#708090',
        snow: '#FFFAFA',
        springgreen: '#00FF7F',
        steelblue: '#4682B4',
        tan: '#D2B48C',
        teal: '#008080',
        thistle: '#D8BFD8',
        tomato: '#FF6347',
        turquoise: '#40E0D0',
        violet: '#EE82EE',
        wheat: '#F5DEB3',
        white: '#FFFFFF',
        whitesmoke: '#F5F5F5',
        yellow: '#FFFF00',
        yellowgreen: '#9ACD32'
    };
    /**
   * @private
   * @param {Number} p
   * @param {Number} q
   * @param {Number} t
   * @return {Number}
   */ function hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 0.5) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    }
    /**
   * Returns new color object, when given a color in RGB format
   * @memberOf fabric.Color
   * @param {String} color Color value ex: rgb(0-255,0-255,0-255)
   * @return {fabric.Color}
   */ fabric.Color.fromRgb = function(color) {
        return Color.fromSource(Color.sourceFromRgb(color));
    };
    /**
   * Returns array representation (ex: [100, 100, 200, 1]) of a color that's in RGB or RGBA format
   * @memberOf fabric.Color
   * @param {String} color Color value ex: rgb(0-255,0-255,0-255), rgb(0%-100%,0%-100%,0%-100%)
   * @return {Array} source
   */ fabric.Color.sourceFromRgb = function(color) {
        var match = color.match(Color.reRGBa);
        if (match) {
            var r = parseInt(match[1], 10) / (/%$/.test(match[1]) ? 100 : 1) * (/%$/.test(match[1]) ? 255 : 1), g = parseInt(match[2], 10) / (/%$/.test(match[2]) ? 100 : 1) * (/%$/.test(match[2]) ? 255 : 1), b = parseInt(match[3], 10) / (/%$/.test(match[3]) ? 100 : 1) * (/%$/.test(match[3]) ? 255 : 1);
            return [
                parseInt(r, 10),
                parseInt(g, 10),
                parseInt(b, 10),
                match[4] ? parseFloat(match[4]) : 1
            ];
        }
    };
    /**
   * Returns new color object, when given a color in RGBA format
   * @static
   * @function
   * @memberOf fabric.Color
   * @param {String} color
   * @return {fabric.Color}
   */ fabric.Color.fromRgba = Color.fromRgb;
    /**
   * Returns new color object, when given a color in HSL format
   * @param {String} color Color value ex: hsl(0-260,0%-100%,0%-100%)
   * @memberOf fabric.Color
   * @return {fabric.Color}
   */ fabric.Color.fromHsl = function(color) {
        return Color.fromSource(Color.sourceFromHsl(color));
    };
    /**
   * Returns array representation (ex: [100, 100, 200, 1]) of a color that's in HSL or HSLA format.
   * Adapted from <a href="https://rawgithub.com/mjijackson/mjijackson.github.com/master/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript.html">https://github.com/mjijackson</a>
   * @memberOf fabric.Color
   * @param {String} color Color value ex: hsl(0-360,0%-100%,0%-100%) or hsla(0-360,0%-100%,0%-100%, 0-1)
   * @return {Array} source
   * @see http://http://www.w3.org/TR/css3-color/#hsl-color
   */ fabric.Color.sourceFromHsl = function(color) {
        var match = color.match(Color.reHSLa);
        if (!match) return;
        var h = (parseFloat(match[1]) % 360 + 360) % 360 / 360, s = parseFloat(match[2]) / (/%$/.test(match[2]) ? 100 : 1), l = parseFloat(match[3]) / (/%$/.test(match[3]) ? 100 : 1), r, g, b;
        if (s === 0) r = g = b = l;
        else {
            var q = l <= 0.5 ? l * (s + 1) : l + s - l * s, p = l * 2 - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }
        return [
            Math.round(r * 255),
            Math.round(g * 255),
            Math.round(b * 255),
            match[4] ? parseFloat(match[4]) : 1
        ];
    };
    /**
   * Returns new color object, when given a color in HSLA format
   * @static
   * @function
   * @memberOf fabric.Color
   * @param {String} color
   * @return {fabric.Color}
   */ fabric.Color.fromHsla = Color.fromHsl;
    /**
   * Returns new color object, when given a color in HEX format
   * @static
   * @memberOf fabric.Color
   * @param {String} color Color value ex: FF5555
   * @return {fabric.Color}
   */ fabric.Color.fromHex = function(color) {
        return Color.fromSource(Color.sourceFromHex(color));
    };
    /**
   * Returns array representation (ex: [100, 100, 200, 1]) of a color that's in HEX format
   * @static
   * @memberOf fabric.Color
   * @param {String} color ex: FF5555 or FF5544CC (RGBa)
   * @return {Array} source
   */ fabric.Color.sourceFromHex = function(color) {
        if (color.match(Color.reHex)) {
            var value = color.slice(color.indexOf('#') + 1), isShortNotation = value.length === 3 || value.length === 4, isRGBa = value.length === 8 || value.length === 4, r = isShortNotation ? value.charAt(0) + value.charAt(0) : value.substring(0, 2), g = isShortNotation ? value.charAt(1) + value.charAt(1) : value.substring(2, 4), b = isShortNotation ? value.charAt(2) + value.charAt(2) : value.substring(4, 6), a = isRGBa ? isShortNotation ? value.charAt(3) + value.charAt(3) : value.substring(6, 8) : 'FF';
            return [
                parseInt(r, 16),
                parseInt(g, 16),
                parseInt(b, 16),
                parseFloat((parseInt(a, 16) / 255).toFixed(2))
            ];
        }
    };
    /**
   * Returns new color object, when given color in array representation (ex: [200, 100, 100, 0.5])
   * @static
   * @memberOf fabric.Color
   * @param {Array} source
   * @return {fabric.Color}
   */ fabric.Color.fromSource = function(source) {
        var oColor = new Color();
        oColor.setSource(source);
        return oColor;
    };
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {}), scaleMap = [
        'e',
        'se',
        's',
        'sw',
        'w',
        'nw',
        'n',
        'ne',
        'e'
    ], skewMap = [
        'ns',
        'nesw',
        'ew',
        'nwse'
    ], controls = {}, LEFT = 'left', TOP = 'top', RIGHT = 'right', BOTTOM = 'bottom', CENTER = 'center', opposite = {
        top: BOTTOM,
        bottom: TOP,
        left: RIGHT,
        right: LEFT,
        center: CENTER
    }, radiansToDegrees = fabric.util.radiansToDegrees, sign = Math.sign || function(x) {
        return (x > 0) - (x < 0) || +x;
    };
    /**
   * Combine control position and object angle to find the control direction compared
   * to the object center.
   * @param {fabric.Object} fabricObject the fabric object for which we are rendering controls
   * @param {fabric.Control} control the control class
   * @return {Number} 0 - 7 a quadrant number
   */ function findCornerQuadrant(fabricObject, control) {
        var cornerAngle = fabricObject.angle + radiansToDegrees(Math.atan2(control.y, control.x)) + 360;
        return Math.round(cornerAngle % 360 / 45);
    }
    function fireEvent(eventName, options) {
        var target = options.transform.target, canvas = target.canvas, canvasOptions = fabric.util.object.clone(options);
        canvasOptions.target = target;
        canvas && canvas.fire('object:' + eventName, canvasOptions);
        target.fire(eventName, options);
    }
    /**
   * Inspect event and fabricObject properties to understand if the scaling action
   * @param {Event} eventData from the user action
   * @param {fabric.Object} fabricObject the fabric object about to scale
   * @return {Boolean} true if scale is proportional
   */ function scaleIsProportional(eventData, fabricObject) {
        var canvas = fabricObject.canvas, uniScaleKey = canvas.uniScaleKey, uniformIsToggled = eventData[uniScaleKey];
        return canvas.uniformScaling && !uniformIsToggled || !canvas.uniformScaling && uniformIsToggled;
    }
    /**
   * Checks if transform is centered
   * @param {Object} transform transform data
   * @return {Boolean} true if transform is centered
   */ function isTransformCentered(transform) {
        return transform.originX === CENTER && transform.originY === CENTER;
    }
    /**
   * Inspect fabricObject to understand if the current scaling action is allowed
   * @param {fabric.Object} fabricObject the fabric object about to scale
   * @param {String} by 'x' or 'y' or ''
   * @param {Boolean} scaleProportionally true if we are trying to scale proportionally
   * @return {Boolean} true if scaling is not allowed at current conditions
   */ function scalingIsForbidden(fabricObject, by, scaleProportionally) {
        var lockX = fabricObject.lockScalingX, lockY = fabricObject.lockScalingY;
        if (lockX && lockY) return true;
        if (!by && (lockX || lockY) && scaleProportionally) return true;
        if (lockX && by === 'x') return true;
        if (lockY && by === 'y') return true;
        return false;
    }
    /**
   * return the correct cursor style for the scale action
   * @param {Event} eventData the javascript event that is causing the scale
   * @param {fabric.Control} control the control that is interested in the action
   * @param {fabric.Object} fabricObject the fabric object that is interested in the action
   * @return {String} a valid css string for the cursor
   */ function scaleCursorStyleHandler(eventData, control, fabricObject) {
        var notAllowed = 'not-allowed', scaleProportionally = scaleIsProportional(eventData, fabricObject), by = '';
        if (control.x !== 0 && control.y === 0) by = 'x';
        else if (control.x === 0 && control.y !== 0) by = 'y';
        if (scalingIsForbidden(fabricObject, by, scaleProportionally)) return notAllowed;
        var n = findCornerQuadrant(fabricObject, control);
        return scaleMap[n] + '-resize';
    }
    /**
   * return the correct cursor style for the skew action
   * @param {Event} eventData the javascript event that is causing the scale
   * @param {fabric.Control} control the control that is interested in the action
   * @param {fabric.Object} fabricObject the fabric object that is interested in the action
   * @return {String} a valid css string for the cursor
   */ function skewCursorStyleHandler(eventData, control, fabricObject) {
        var notAllowed = 'not-allowed';
        if (control.x !== 0 && fabricObject.lockSkewingY) return notAllowed;
        if (control.y !== 0 && fabricObject.lockSkewingX) return notAllowed;
        var n = findCornerQuadrant(fabricObject, control) % 4;
        return skewMap[n] + '-resize';
    }
    /**
   * Combine skew and scale style handlers to cover fabric standard use case
   * @param {Event} eventData the javascript event that is causing the scale
   * @param {fabric.Control} control the control that is interested in the action
   * @param {fabric.Object} fabricObject the fabric object that is interested in the action
   * @return {String} a valid css string for the cursor
   */ function scaleSkewCursorStyleHandler(eventData, control, fabricObject) {
        if (eventData[fabricObject.canvas.altActionKey]) return controls.skewCursorStyleHandler(eventData, control, fabricObject);
        return controls.scaleCursorStyleHandler(eventData, control, fabricObject);
    }
    /**
   * Inspect event, control and fabricObject to return the correct action name
   * @param {Event} eventData the javascript event that is causing the scale
   * @param {fabric.Control} control the control that is interested in the action
   * @param {fabric.Object} fabricObject the fabric object that is interested in the action
   * @return {String} an action name
   */ function scaleOrSkewActionName(eventData, control, fabricObject) {
        var isAlternative = eventData[fabricObject.canvas.altActionKey];
        if (control.x === 0) // then is scaleY or skewX
        return isAlternative ? 'skewX' : 'scaleY';
        if (control.y === 0) // then is scaleY or skewX
        return isAlternative ? 'skewY' : 'scaleX';
    }
    /**
   * Find the correct style for the control that is used for rotation.
   * this function is very simple and it just take care of not-allowed or standard cursor
   * @param {Event} eventData the javascript event that is causing the scale
   * @param {fabric.Control} control the control that is interested in the action
   * @param {fabric.Object} fabricObject the fabric object that is interested in the action
   * @return {String} a valid css string for the cursor
   */ function rotationStyleHandler(eventData, control, fabricObject) {
        if (fabricObject.lockRotation) return 'not-allowed';
        return control.cursorStyle;
    }
    function commonEventInfo(eventData, transform, x, y) {
        return {
            e: eventData,
            transform: transform,
            pointer: {
                x: x,
                y: y
            }
        };
    }
    /**
   * Wrap an action handler with saving/restoring object position on the transform.
   * this is the code that permits to objects to keep their position while transforming.
   * @param {Function} actionHandler the function to wrap
   * @return {Function} a function with an action handler signature
   */ function wrapWithFixedAnchor(actionHandler) {
        return function(eventData, transform, x, y) {
            var target = transform.target, centerPoint = target.getCenterPoint(), constraint = target.translateToOriginPoint(centerPoint, transform.originX, transform.originY), actionPerformed = actionHandler(eventData, transform, x, y);
            target.setPositionByOrigin(constraint, transform.originX, transform.originY);
            return actionPerformed;
        };
    }
    /**
   * Wrap an action handler with firing an event if the action is performed
   * @param {Function} actionHandler the function to wrap
   * @return {Function} a function with an action handler signature
   */ function wrapWithFireEvent(eventName, actionHandler) {
        return function(eventData, transform, x, y) {
            var actionPerformed = actionHandler(eventData, transform, x, y);
            if (actionPerformed) fireEvent(eventName, commonEventInfo(eventData, transform, x, y));
            return actionPerformed;
        };
    }
    /**
   * Transforms a point described by x and y in a distance from the top left corner of the object
   * bounding box.
   * @param {Object} transform
   * @param {String} originX
   * @param {String} originY
   * @param {number} x
   * @param {number} y
   * @return {Fabric.Point} the normalized point
   */ function getLocalPoint(transform, originX, originY, x, y) {
        var target = transform.target, control = target.controls[transform.corner], zoom = target.canvas.getZoom(), padding = target.padding / zoom, localPoint = target.toLocalPoint(new fabric.Point(x, y), originX, originY);
        if (localPoint.x >= padding) localPoint.x -= padding;
        if (localPoint.x <= -padding) localPoint.x += padding;
        if (localPoint.y >= padding) localPoint.y -= padding;
        if (localPoint.y <= padding) localPoint.y += padding;
        localPoint.x -= control.offsetX;
        localPoint.y -= control.offsetY;
        return localPoint;
    }
    /**
   * Detect if the fabric object is flipped on one side.
   * @param {fabric.Object} target
   * @return {Boolean} true if one flip, but not two.
   */ function targetHasOneFlip(target) {
        return target.flipX !== target.flipY;
    }
    /**
   * Utility function to compensate the scale factor when skew is applied on both axes
   * @private
   */ function compensateScaleForSkew(target, oppositeSkew, scaleToCompensate, axis, reference) {
        if (target[oppositeSkew] !== 0) {
            var newDim = target._getTransformedDimensions()[axis];
            var newValue = reference / newDim * target[scaleToCompensate];
            target.set(scaleToCompensate, newValue);
        }
    }
    /**
   * Action handler for skewing on the X axis
   * @private
   */ function skewObjectX(eventData, transform, x, y) {
        var target = transform.target, // find how big the object would be, if there was no skewX. takes in account scaling
        dimNoSkew = target._getTransformedDimensions(0, target.skewY), localPoint = getLocalPoint(transform, transform.originX, transform.originY, x, y), // the mouse is in the center of the object, and we want it to stay there.
        // so the object will grow twice as much as the mouse.
        // this makes the skew growth to localPoint * 2 - dimNoSkew.
        totalSkewSize = Math.abs(localPoint.x * 2) - dimNoSkew.x, currentSkew = target.skewX, newSkew;
        if (totalSkewSize < 2) // let's make it easy to go back to position 0.
        newSkew = 0;
        else {
            newSkew = radiansToDegrees(Math.atan2(totalSkewSize / target.scaleX, dimNoSkew.y / target.scaleY));
            // now we have to find the sign of the skew.
            // it mostly depend on the origin of transformation.
            if (transform.originX === LEFT && transform.originY === BOTTOM) newSkew = -newSkew;
            if (transform.originX === RIGHT && transform.originY === TOP) newSkew = -newSkew;
            if (targetHasOneFlip(target)) newSkew = -newSkew;
        }
        var hasSkewed = currentSkew !== newSkew;
        if (hasSkewed) {
            var dimBeforeSkewing = target._getTransformedDimensions().y;
            target.set('skewX', newSkew);
            compensateScaleForSkew(target, 'skewY', 'scaleY', 'y', dimBeforeSkewing);
        }
        return hasSkewed;
    }
    /**
   * Action handler for skewing on the Y axis
   * @private
   */ function skewObjectY(eventData, transform, x, y) {
        var target = transform.target, // find how big the object would be, if there was no skewX. takes in account scaling
        dimNoSkew = target._getTransformedDimensions(target.skewX, 0), localPoint = getLocalPoint(transform, transform.originX, transform.originY, x, y), // the mouse is in the center of the object, and we want it to stay there.
        // so the object will grow twice as much as the mouse.
        // this makes the skew growth to localPoint * 2 - dimNoSkew.
        totalSkewSize = Math.abs(localPoint.y * 2) - dimNoSkew.y, currentSkew = target.skewY, newSkew;
        if (totalSkewSize < 2) // let's make it easy to go back to position 0.
        newSkew = 0;
        else {
            newSkew = radiansToDegrees(Math.atan2(totalSkewSize / target.scaleY, dimNoSkew.x / target.scaleX));
            // now we have to find the sign of the skew.
            // it mostly depend on the origin of transformation.
            if (transform.originX === LEFT && transform.originY === BOTTOM) newSkew = -newSkew;
            if (transform.originX === RIGHT && transform.originY === TOP) newSkew = -newSkew;
            if (targetHasOneFlip(target)) newSkew = -newSkew;
        }
        var hasSkewed = currentSkew !== newSkew;
        if (hasSkewed) {
            var dimBeforeSkewing = target._getTransformedDimensions().x;
            target.set('skewY', newSkew);
            compensateScaleForSkew(target, 'skewX', 'scaleX', 'x', dimBeforeSkewing);
        }
        return hasSkewed;
    }
    /**
   * Wrapped Action handler for skewing on the Y axis, takes care of the
   * skew direction and determine the correct transform origin for the anchor point
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */ function skewHandlerX(eventData, transform, x, y) {
        // step1 figure out and change transform origin.
        // if skewX > 0 and originY bottom we anchor on right
        // if skewX > 0 and originY top we anchor on left
        // if skewX < 0 and originY bottom we anchor on left
        // if skewX < 0 and originY top we anchor on right
        // if skewX is 0, we look for mouse position to understand where are we going.
        var target = transform.target, currentSkew = target.skewX, originX, originY = transform.originY;
        if (target.lockSkewingX) return false;
        if (currentSkew === 0) {
            var localPointFromCenter = getLocalPoint(transform, CENTER, CENTER, x, y);
            if (localPointFromCenter.x > 0) // we are pulling right, anchor left;
            originX = LEFT;
            else // we are pulling right, anchor right
            originX = RIGHT;
        } else {
            if (currentSkew > 0) originX = originY === TOP ? LEFT : RIGHT;
            if (currentSkew < 0) originX = originY === TOP ? RIGHT : LEFT;
            // is the object flipped on one side only? swap the origin.
            if (targetHasOneFlip(target)) originX = originX === LEFT ? RIGHT : LEFT;
        }
        // once we have the origin, we find the anchor point
        transform.originX = originX;
        var finalHandler = wrapWithFireEvent('skewing', wrapWithFixedAnchor(skewObjectX));
        return finalHandler(eventData, transform, x, y);
    }
    /**
   * Wrapped Action handler for skewing on the Y axis, takes care of the
   * skew direction and determine the correct transform origin for the anchor point
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */ function skewHandlerY(eventData, transform, x, y) {
        // step1 figure out and change transform origin.
        // if skewY > 0 and originX left we anchor on top
        // if skewY > 0 and originX right we anchor on bottom
        // if skewY < 0 and originX left we anchor on bottom
        // if skewY < 0 and originX right we anchor on top
        // if skewY is 0, we look for mouse position to understand where are we going.
        var target = transform.target, currentSkew = target.skewY, originY, originX = transform.originX;
        if (target.lockSkewingY) return false;
        if (currentSkew === 0) {
            var localPointFromCenter = getLocalPoint(transform, CENTER, CENTER, x, y);
            if (localPointFromCenter.y > 0) // we are pulling down, anchor up;
            originY = TOP;
            else // we are pulling up, anchor down
            originY = BOTTOM;
        } else {
            if (currentSkew > 0) originY = originX === LEFT ? TOP : BOTTOM;
            if (currentSkew < 0) originY = originX === LEFT ? BOTTOM : TOP;
            // is the object flipped on one side only? swap the origin.
            if (targetHasOneFlip(target)) originY = originY === TOP ? BOTTOM : TOP;
        }
        // once we have the origin, we find the anchor point
        transform.originY = originY;
        var finalHandler = wrapWithFireEvent('skewing', wrapWithFixedAnchor(skewObjectY));
        return finalHandler(eventData, transform, x, y);
    }
    /**
   * Action handler for rotation and snapping, without anchor point.
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   * @private
   */ function rotationWithSnapping(eventData, transform, x, y) {
        var t = transform, target = t.target, pivotPoint = target.translateToOriginPoint(target.getCenterPoint(), t.originX, t.originY);
        if (target.lockRotation) return false;
        var lastAngle = Math.atan2(t.ey - pivotPoint.y, t.ex - pivotPoint.x), curAngle = Math.atan2(y - pivotPoint.y, x - pivotPoint.x), angle = radiansToDegrees(curAngle - lastAngle + t.theta), hasRotated = true;
        if (target.snapAngle > 0) {
            var snapAngle = target.snapAngle, snapThreshold = target.snapThreshold || snapAngle, rightAngleLocked = Math.ceil(angle / snapAngle) * snapAngle, leftAngleLocked = Math.floor(angle / snapAngle) * snapAngle;
            if (Math.abs(angle - leftAngleLocked) < snapThreshold) angle = leftAngleLocked;
            else if (Math.abs(angle - rightAngleLocked) < snapThreshold) angle = rightAngleLocked;
        }
        // normalize angle to positive value
        if (angle < 0) angle = 360 + angle;
        angle %= 360;
        hasRotated = target.angle !== angle;
        target.angle = angle;
        return hasRotated;
    }
    /**
   * Basic scaling logic, reused with different constrain for scaling X,Y, freely or equally.
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @param {Object} options additional information for scaling
   * @param {String} options.by 'x', 'y', 'equally' or '' to indicate type of scaling
   * @return {Boolean} true if some change happened
   * @private
   */ function scaleObject(eventData, transform, x, y, options) {
        options = options || {};
        var target = transform.target, lockScalingX = target.lockScalingX, lockScalingY = target.lockScalingY, by = options.by, newPoint, scaleX, scaleY, dim, scaleProportionally = scaleIsProportional(eventData, target), forbidScaling = scalingIsForbidden(target, by, scaleProportionally), signX, signY, gestureScale = transform.gestureScale;
        if (forbidScaling) return false;
        if (gestureScale) {
            scaleX = transform.scaleX * gestureScale;
            scaleY = transform.scaleY * gestureScale;
        } else {
            newPoint = getLocalPoint(transform, transform.originX, transform.originY, x, y);
            // use of sign: We use sign to detect change of direction of an action. sign usually change when
            // we cross the origin point with the mouse. So a scale flip for example. There is an issue when scaling
            // by center and scaling using one middle control ( default: mr, mt, ml, mb), the mouse movement can easily
            // cross many time the origin point and flip the object. so we need a way to filter out the noise.
            // This ternary here should be ok to filter out X scaling when we want Y only and vice versa.
            signX = by !== 'y' ? sign(newPoint.x) : 1;
            signY = by !== 'x' ? sign(newPoint.y) : 1;
            if (!transform.signX) transform.signX = signX;
            if (!transform.signY) transform.signY = signY;
            if (target.lockScalingFlip && (transform.signX !== signX || transform.signY !== signY)) return false;
            dim = target._getTransformedDimensions();
            // missing detection of flip and logic to switch the origin
            if (scaleProportionally && !by) {
                // uniform scaling
                var distance = Math.abs(newPoint.x) + Math.abs(newPoint.y), original = transform.original, originalDistance = Math.abs(dim.x * original.scaleX / target.scaleX) + Math.abs(dim.y * original.scaleY / target.scaleY), scale = distance / originalDistance;
                scaleX = original.scaleX * scale;
                scaleY = original.scaleY * scale;
            } else {
                scaleX = Math.abs(newPoint.x * target.scaleX / dim.x);
                scaleY = Math.abs(newPoint.y * target.scaleY / dim.y);
            }
            // if we are scaling by center, we need to double the scale
            if (isTransformCentered(transform)) {
                scaleX *= 2;
                scaleY *= 2;
            }
            if (transform.signX !== signX && by !== 'y') {
                transform.originX = opposite[transform.originX];
                scaleX *= -1;
                transform.signX = signX;
            }
            if (transform.signY !== signY && by !== 'x') {
                transform.originY = opposite[transform.originY];
                scaleY *= -1;
                transform.signY = signY;
            }
        }
        // minScale is taken are in the setter.
        var oldScaleX = target.scaleX, oldScaleY = target.scaleY;
        if (!by) {
            !lockScalingX && target.set('scaleX', scaleX);
            !lockScalingY && target.set('scaleY', scaleY);
        } else {
            // forbidden cases already handled on top here.
            by === 'x' && target.set('scaleX', scaleX);
            by === 'y' && target.set('scaleY', scaleY);
        }
        return oldScaleX !== target.scaleX || oldScaleY !== target.scaleY;
    }
    /**
   * Generic scaling logic, to scale from corners either equally or freely.
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */ function scaleObjectFromCorner(eventData, transform, x, y) {
        return scaleObject(eventData, transform, x, y);
    }
    /**
   * Scaling logic for the X axis.
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */ function scaleObjectX(eventData, transform, x, y) {
        return scaleObject(eventData, transform, x, y, {
            by: 'x'
        });
    }
    /**
   * Scaling logic for the Y axis.
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */ function scaleObjectY(eventData, transform, x, y) {
        return scaleObject(eventData, transform, x, y, {
            by: 'y'
        });
    }
    /**
   * Composed action handler to either scale Y or skew X
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */ function scalingYOrSkewingX(eventData, transform, x, y) {
        // ok some safety needed here.
        if (eventData[transform.target.canvas.altActionKey]) return controls.skewHandlerX(eventData, transform, x, y);
        return controls.scalingY(eventData, transform, x, y);
    }
    /**
   * Composed action handler to either scale X or skew Y
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */ function scalingXOrSkewingY(eventData, transform, x, y) {
        // ok some safety needed here.
        if (eventData[transform.target.canvas.altActionKey]) return controls.skewHandlerY(eventData, transform, x, y);
        return controls.scalingX(eventData, transform, x, y);
    }
    /**
   * Action handler to change textbox width
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */ function changeWidth(eventData, transform, x, y) {
        var target = transform.target, localPoint = getLocalPoint(transform, transform.originX, transform.originY, x, y), strokePadding = target.strokeWidth / (target.strokeUniform ? target.scaleX : 1), multiplier = isTransformCentered(transform) ? 2 : 1, oldWidth = target.width, newWidth = Math.abs(localPoint.x * multiplier / target.scaleX) - strokePadding;
        target.set('width', Math.max(newWidth, 0));
        return oldWidth !== newWidth;
    }
    /**
   * Action handler
   * @private
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if the translation occurred
   */ function dragHandler(eventData, transform, x, y) {
        var target = transform.target, newLeft = x - transform.offsetX, newTop = y - transform.offsetY, moveX = !target.get('lockMovementX') && target.left !== newLeft, moveY = !target.get('lockMovementY') && target.top !== newTop;
        moveX && target.set('left', newLeft);
        moveY && target.set('top', newTop);
        if (moveX || moveY) fireEvent('moving', commonEventInfo(eventData, transform, x, y));
        return moveX || moveY;
    }
    controls.scaleCursorStyleHandler = scaleCursorStyleHandler;
    controls.skewCursorStyleHandler = skewCursorStyleHandler;
    controls.scaleSkewCursorStyleHandler = scaleSkewCursorStyleHandler;
    controls.rotationWithSnapping = wrapWithFireEvent('rotating', wrapWithFixedAnchor(rotationWithSnapping));
    controls.scalingEqually = wrapWithFireEvent('scaling', wrapWithFixedAnchor(scaleObjectFromCorner));
    controls.scalingX = wrapWithFireEvent('scaling', wrapWithFixedAnchor(scaleObjectX));
    controls.scalingY = wrapWithFireEvent('scaling', wrapWithFixedAnchor(scaleObjectY));
    controls.scalingYOrSkewingX = scalingYOrSkewingX;
    controls.scalingXOrSkewingY = scalingXOrSkewingY;
    controls.changeWidth = wrapWithFireEvent('resizing', wrapWithFixedAnchor(changeWidth));
    controls.skewHandlerX = skewHandlerX;
    controls.skewHandlerY = skewHandlerY;
    controls.dragHandler = dragHandler;
    controls.scaleOrSkewActionName = scaleOrSkewActionName;
    controls.rotationStyleHandler = rotationStyleHandler;
    controls.fireEvent = fireEvent;
    controls.wrapWithFixedAnchor = wrapWithFixedAnchor;
    controls.wrapWithFireEvent = wrapWithFireEvent;
    controls.getLocalPoint = getLocalPoint;
    fabric.controlsUtils = controls;
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {}), degreesToRadians = fabric.util.degreesToRadians, controls = fabric.controlsUtils;
    /**
   * Render a round control, as per fabric features.
   * This function is written to respect object properties like transparentCorners, cornerSize
   * cornerColor, cornerStrokeColor
   * plus the addition of offsetY and offsetX.
   * @param {CanvasRenderingContext2D} ctx context to render on
   * @param {Number} left x coordinate where the control center should be
   * @param {Number} top y coordinate where the control center should be
   * @param {Object} styleOverride override for fabric.Object controls style
   * @param {fabric.Object} fabricObject the fabric object for which we are rendering controls
   */ function renderCircleControl(ctx, left, top, styleOverride, fabricObject) {
        styleOverride = styleOverride || {};
        var xSize = this.sizeX || styleOverride.cornerSize || fabricObject.cornerSize, ySize = this.sizeY || styleOverride.cornerSize || fabricObject.cornerSize, transparentCorners = typeof styleOverride.transparentCorners !== 'undefined' ? styleOverride.transparentCorners : fabricObject.transparentCorners, methodName = transparentCorners ? 'stroke' : 'fill', stroke = !transparentCorners && (styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor), myLeft = left, myTop = top, size;
        ctx.save();
        ctx.fillStyle = styleOverride.cornerColor || fabricObject.cornerColor;
        ctx.strokeStyle = styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor;
        // as soon as fabric react v5, remove ie11, use proper ellipse code.
        if (xSize > ySize) {
            size = xSize;
            ctx.scale(1.0, ySize / xSize);
            myTop = top * xSize / ySize;
        } else if (ySize > xSize) {
            size = ySize;
            ctx.scale(xSize / ySize, 1.0);
            myLeft = left * ySize / xSize;
        } else size = xSize;
        // this is still wrong
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.arc(myLeft, myTop, size / 2, 0, 2 * Math.PI, false);
        ctx[methodName]();
        if (stroke) ctx.stroke();
        ctx.restore();
    }
    /**
   * Render a square control, as per fabric features.
   * This function is written to respect object properties like transparentCorners, cornerSize
   * cornerColor, cornerStrokeColor
   * plus the addition of offsetY and offsetX.
   * @param {CanvasRenderingContext2D} ctx context to render on
   * @param {Number} left x coordinate where the control center should be
   * @param {Number} top y coordinate where the control center should be
   * @param {Object} styleOverride override for fabric.Object controls style
   * @param {fabric.Object} fabricObject the fabric object for which we are rendering controls
   */ function renderSquareControl(ctx, left, top, styleOverride, fabricObject) {
        styleOverride = styleOverride || {};
        var xSize = this.sizeX || styleOverride.cornerSize || fabricObject.cornerSize, ySize = this.sizeY || styleOverride.cornerSize || fabricObject.cornerSize, transparentCorners = typeof styleOverride.transparentCorners !== 'undefined' ? styleOverride.transparentCorners : fabricObject.transparentCorners, methodName = transparentCorners ? 'stroke' : 'fill', stroke = !transparentCorners && (styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor), xSizeBy2 = xSize / 2, ySizeBy2 = ySize / 2;
        ctx.save();
        ctx.fillStyle = styleOverride.cornerColor || fabricObject.cornerColor;
        ctx.strokeStyle = styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor;
        // this is still wrong
        ctx.lineWidth = 1;
        ctx.translate(left, top);
        ctx.rotate(degreesToRadians(fabricObject.angle));
        // this does not work, and fixed with ( && ) does not make sense.
        // to have real transparent corners we need the controls on upperCanvas
        // transparentCorners || ctx.clearRect(-xSizeBy2, -ySizeBy2, xSize, ySize);
        ctx[methodName + 'Rect'](-xSizeBy2, -ySizeBy2, xSize, ySize);
        if (stroke) ctx.strokeRect(-xSizeBy2, -ySizeBy2, xSize, ySize);
        ctx.restore();
    }
    controls.renderCircleControl = renderCircleControl;
    controls.renderSquareControl = renderSquareControl;
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {});
    function Control(options) {
        for(var i in options)this[i] = options[i];
    }
    fabric.Control = Control;
    fabric.Control.prototype = /** @lends fabric.Control.prototype */ {
        /**
     * keep track of control visibility.
     * mainly for backward compatibility.
     * if you do not want to see a control, you can remove it
     * from the controlset.
     * @type {Boolean}
     * @default true
     */ visible: true,
        /**
     * Name of the action that the control will likely execute.
     * This is optional. FabricJS uses to identify what the user is doing for some
     * extra optimizations. If you are writing a custom control and you want to know
     * somewhere else in the code what is going on, you can use this string here.
     * you can also provide a custom getActionName if your control run multiple actions
     * depending on some external state.
     * default to scale since is the most common, used on 4 corners by default
     * @type {String}
     * @default 'scale'
     */ actionName: 'scale',
        /**
     * Drawing angle of the control.
     * NOT used for now, but name marked as needed for internal logic
     * example: to reuse the same drawing function for different rotated controls
     * @type {Number}
     * @default 0
     */ angle: 0,
        /**
     * Relative position of the control. X
     * 0,0 is the center of the Object, while -0.5 (left) or 0.5 (right) are the extremities
     * of the bounding box.
     * @type {Number}
     * @default 0
     */ x: 0,
        /**
     * Relative position of the control. Y
     * 0,0 is the center of the Object, while -0.5 (top) or 0.5 (bottom) are the extremities
     * of the bounding box.
     * @type {Number}
     * @default 0
     */ y: 0,
        /**
     * Horizontal offset of the control from the defined position. In pixels
     * Positive offset moves the control to the right, negative to the left.
     * It used when you want to have position of control that does not scale with
     * the bounding box. Example: rotation control is placed at x:0, y: 0.5 on
     * the boundindbox, with an offset of 30 pixels vertically. Those 30 pixels will
     * stay 30 pixels no matter how the object is big. Another example is having 2
     * controls in the corner, that stay in the same position when the object scale.
     * of the bounding box.
     * @type {Number}
     * @default 0
     */ offsetX: 0,
        /**
     * Vertical offset of the control from the defined position. In pixels
     * Positive offset moves the control to the bottom, negative to the top.
     * @type {Number}
     * @default 0
     */ offsetY: 0,
        /**
     * Sets the length of the control. If null, defaults to object's cornerSize.
     * Expects both sizeX and sizeY to be set when set.
     * @type {?Number}
     * @default null
     */ sizeX: null,
        /**
     * Sets the height of the control. If null, defaults to object's cornerSize.
     * Expects both sizeX and sizeY to be set when set.
     * @type {?Number}
     * @default null
     */ sizeY: null,
        /**
     * Sets the length of the touch area of the control. If null, defaults to object's touchCornerSize.
     * Expects both touchSizeX and touchSizeY to be set when set.
     * @type {?Number}
     * @default null
     */ touchSizeX: null,
        /**
     * Sets the height of the touch area of the control. If null, defaults to object's touchCornerSize.
     * Expects both touchSizeX and touchSizeY to be set when set.
     * @type {?Number}
     * @default null
     */ touchSizeY: null,
        /**
     * Css cursor style to display when the control is hovered.
     * if the method `cursorStyleHandler` is provided, this property is ignored.
     * @type {String}
     * @default 'crosshair'
     */ cursorStyle: 'crosshair',
        /**
     * If controls has an offsetY or offsetX, draw a line that connects
     * the control to the bounding box
     * @type {Boolean}
     * @default false
     */ withConnection: false,
        /**
     * The control actionHandler, provide one to handle action ( control being moved )
     * @param {Event} eventData the native mouse event
     * @param {Object} transformData properties of the current transform
     * @param {Number} x x position of the cursor
     * @param {Number} y y position of the cursor
     * @return {Boolean} true if the action/event modified the object
     */ actionHandler: function() {},
        /**
     * The control handler for mouse down, provide one to handle mouse down on control
     * @param {Event} eventData the native mouse event
     * @param {Object} transformData properties of the current transform
     * @param {Number} x x position of the cursor
     * @param {Number} y y position of the cursor
     * @return {Boolean} true if the action/event modified the object
     */ mouseDownHandler: function() {},
        /**
     * The control mouseUpHandler, provide one to handle an effect on mouse up.
     * @param {Event} eventData the native mouse event
     * @param {Object} transformData properties of the current transform
     * @param {Number} x x position of the cursor
     * @param {Number} y y position of the cursor
     * @return {Boolean} true if the action/event modified the object
     */ mouseUpHandler: function() {},
        /**
     * Returns control actionHandler
     * @param {Event} eventData the native mouse event
     * @param {fabric.Object} fabricObject on which the control is displayed
     * @param {fabric.Control} control control for which the action handler is being asked
     * @return {Function} the action handler
     */ getActionHandler: function() {
            return this.actionHandler;
        },
        /**
     * Returns control mouseDown handler
     * @param {Event} eventData the native mouse event
     * @param {fabric.Object} fabricObject on which the control is displayed
     * @param {fabric.Control} control control for which the action handler is being asked
     * @return {Function} the action handler
     */ getMouseDownHandler: function() {
            return this.mouseDownHandler;
        },
        /**
     * Returns control mouseUp handler
     * @param {Event} eventData the native mouse event
     * @param {fabric.Object} fabricObject on which the control is displayed
     * @param {fabric.Control} control control for which the action handler is being asked
     * @return {Function} the action handler
     */ getMouseUpHandler: function() {
            return this.mouseUpHandler;
        },
        /**
     * Returns control cursorStyle for css using cursorStyle. If you need a more elaborate
     * function you can pass one in the constructor
     * the cursorStyle property
     * @param {Event} eventData the native mouse event
     * @param {fabric.Control} control the current control ( likely this)
     * @param {fabric.Object} object on which the control is displayed
     * @return {String}
     */ cursorStyleHandler: function(eventData, control /* fabricObject */ ) {
            return control.cursorStyle;
        },
        /**
     * Returns the action name. The basic implementation just return the actionName property.
     * @param {Event} eventData the native mouse event
     * @param {fabric.Control} control the current control ( likely this)
     * @param {fabric.Object} object on which the control is displayed
     * @return {String}
     */ getActionName: function(eventData, control /* fabricObject */ ) {
            return control.actionName;
        },
        /**
     * Returns controls visibility
     * @param {fabric.Object} object on which the control is displayed
     * @param {String} controlKey key where the control is memorized on the
     * @return {Boolean}
     */ getVisibility: function(fabricObject, controlKey) {
            var objectVisibility = fabricObject._controlsVisibility;
            if (objectVisibility && typeof objectVisibility[controlKey] !== 'undefined') return objectVisibility[controlKey];
            return this.visible;
        },
        /**
     * Sets controls visibility
     * @param {Boolean} visibility for the object
     * @return {Void}
     */ setVisibility: function(visibility /* name, fabricObject */ ) {
            this.visible = visibility;
        },
        positionHandler: function(dim, finalMatrix /*, fabricObject, currentControl */ ) {
            var point = fabric.util.transformPoint({
                x: this.x * dim.x + this.offsetX,
                y: this.y * dim.y + this.offsetY
            }, finalMatrix);
            return point;
        },
        /**
     * Returns the coords for this control based on object values.
     * @param {Number} objectAngle angle from the fabric object holding the control
     * @param {Number} objectCornerSize cornerSize from the fabric object holding the control (or touchCornerSize if
     *   isTouch is true)
     * @param {Number} centerX x coordinate where the control center should be
     * @param {Number} centerY y coordinate where the control center should be
     * @param {boolean} isTouch true if touch corner, false if normal corner
     */ calcCornerCoords: function(objectAngle, objectCornerSize, centerX, centerY, isTouch) {
            var cosHalfOffset, sinHalfOffset, cosHalfOffsetComp, sinHalfOffsetComp, xSize = isTouch ? this.touchSizeX : this.sizeX, ySize = isTouch ? this.touchSizeY : this.sizeY;
            if (xSize && ySize && xSize !== ySize) {
                // handle rectangular corners
                var controlTriangleAngle = Math.atan2(ySize, xSize);
                var cornerHypotenuse = Math.sqrt(xSize * xSize + ySize * ySize) / 2;
                var newTheta = controlTriangleAngle - fabric.util.degreesToRadians(objectAngle);
                var newThetaComp = Math.PI / 2 - controlTriangleAngle - fabric.util.degreesToRadians(objectAngle);
                cosHalfOffset = cornerHypotenuse * fabric.util.cos(newTheta);
                sinHalfOffset = cornerHypotenuse * fabric.util.sin(newTheta);
                // use complementary angle for two corners
                cosHalfOffsetComp = cornerHypotenuse * fabric.util.cos(newThetaComp);
                sinHalfOffsetComp = cornerHypotenuse * fabric.util.sin(newThetaComp);
            } else {
                // handle square corners
                // use default object corner size unless size is defined
                var cornerSize = xSize && ySize ? xSize : objectCornerSize;
                /* 0.7071067812 stands for sqrt(2)/2 */ cornerHypotenuse = cornerSize * 0.7071067812;
                // complementary angles are equal since they're both 45 degrees
                var newTheta = fabric.util.degreesToRadians(45 - objectAngle);
                cosHalfOffset = cosHalfOffsetComp = cornerHypotenuse * fabric.util.cos(newTheta);
                sinHalfOffset = sinHalfOffsetComp = cornerHypotenuse * fabric.util.sin(newTheta);
            }
            return {
                tl: {
                    x: centerX - sinHalfOffsetComp,
                    y: centerY - cosHalfOffsetComp
                },
                tr: {
                    x: centerX + cosHalfOffset,
                    y: centerY - sinHalfOffset
                },
                bl: {
                    x: centerX - cosHalfOffset,
                    y: centerY + sinHalfOffset
                },
                br: {
                    x: centerX + sinHalfOffsetComp,
                    y: centerY + cosHalfOffsetComp
                }
            };
        },
        /**
    * Render function for the control.
    * When this function runs the context is unscaled. unrotate. Just retina scaled.
    * all the functions will have to translate to the point left,top before starting Drawing
    * if they want to draw a control where the position is detected.
    * left and top are the result of the positionHandler function
    * @param {RenderingContext2D} ctx the context where the control will be drawn
    * @param {Number} left position of the canvas where we are about to render the control.
    * @param {Number} top position of the canvas where we are about to render the control.
    * @param {Object} styleOverride
    * @param {fabric.Object} fabricObject the object where the control is about to be rendered
    */ render: function(ctx, left, top, styleOverride, fabricObject) {
            styleOverride = styleOverride || {};
            switch(styleOverride.cornerStyle || fabricObject.cornerStyle){
                case 'circle':
                    fabric.controlsUtils.renderCircleControl.call(this, ctx, left, top, styleOverride, fabricObject);
                    break;
                default:
                    fabric.controlsUtils.renderSquareControl.call(this, ctx, left, top, styleOverride, fabricObject);
            }
        }
    };
})($79564f678731bf19$exports);
(function() {
    /* _FROM_SVG_START_ */ function getColorStop(el, multiplier) {
        var style = el.getAttribute('style'), offset = el.getAttribute('offset') || 0, color, colorAlpha, opacity, i;
        // convert percents to absolute values
        offset = parseFloat(offset) / (/%$/.test(offset) ? 100 : 1);
        offset = offset < 0 ? 0 : offset > 1 ? 1 : offset;
        if (style) {
            var keyValuePairs = style.split(/\s*;\s*/);
            if (keyValuePairs[keyValuePairs.length - 1] === '') keyValuePairs.pop();
            for(i = keyValuePairs.length; i--;){
                var split = keyValuePairs[i].split(/\s*:\s*/), key = split[0].trim(), value = split[1].trim();
                if (key === 'stop-color') color = value;
                else if (key === 'stop-opacity') opacity = value;
            }
        }
        if (!color) color = el.getAttribute('stop-color') || 'rgb(0,0,0)';
        if (!opacity) opacity = el.getAttribute('stop-opacity');
        color = new $79564f678731bf19$var$fabric.Color(color);
        colorAlpha = color.getAlpha();
        opacity = isNaN(parseFloat(opacity)) ? 1 : parseFloat(opacity);
        opacity *= colorAlpha * multiplier;
        return {
            offset: offset,
            color: color.toRgb(),
            opacity: opacity
        };
    }
    function getLinearCoords(el) {
        return {
            x1: el.getAttribute('x1') || 0,
            y1: el.getAttribute('y1') || 0,
            x2: el.getAttribute('x2') || '100%',
            y2: el.getAttribute('y2') || 0
        };
    }
    function getRadialCoords(el) {
        return {
            x1: el.getAttribute('fx') || el.getAttribute('cx') || '50%',
            y1: el.getAttribute('fy') || el.getAttribute('cy') || '50%',
            r1: 0,
            x2: el.getAttribute('cx') || '50%',
            y2: el.getAttribute('cy') || '50%',
            r2: el.getAttribute('r') || '50%'
        };
    }
    /* _FROM_SVG_END_ */ var clone = $79564f678731bf19$var$fabric.util.object.clone;
    /**
   * Gradient class
   * @class fabric.Gradient
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#gradients}
   * @see {@link fabric.Gradient#initialize} for constructor definition
   */ $79564f678731bf19$var$fabric.Gradient = $79564f678731bf19$var$fabric.util.createClass(/** @lends fabric.Gradient.prototype */ {
        /**
     * Horizontal offset for aligning gradients coming from SVG when outside pathgroups
     * @type Number
     * @default 0
     */ offsetX: 0,
        /**
     * Vertical offset for aligning gradients coming from SVG when outside pathgroups
     * @type Number
     * @default 0
     */ offsetY: 0,
        /**
     * A transform matrix to apply to the gradient before painting.
     * Imported from svg gradients, is not applied with the current transform in the center.
     * Before this transform is applied, the origin point is at the top left corner of the object
     * plus the addition of offsetY and offsetX.
     * @type Number[]
     * @default null
     */ gradientTransform: null,
        /**
     * coordinates units for coords.
     * If `pixels`, the number of coords are in the same unit of width / height.
     * If set as `percentage` the coords are still a number, but 1 means 100% of width
     * for the X and 100% of the height for the y. It can be bigger than 1 and negative.
     * allowed values pixels or percentage.
     * @type String
     * @default 'pixels'
     */ gradientUnits: 'pixels',
        /**
     * Gradient type linear or radial
     * @type String
     * @default 'pixels'
     */ type: 'linear',
        /**
     * Constructor
     * @param {Object} options Options object with type, coords, gradientUnits and colorStops
     * @param {Object} [options.type] gradient type linear or radial
     * @param {Object} [options.gradientUnits] gradient units
     * @param {Object} [options.offsetX] SVG import compatibility
     * @param {Object} [options.offsetY] SVG import compatibility
     * @param {Object[]} options.colorStops contains the colorstops.
     * @param {Object} options.coords contains the coords of the gradient
     * @param {Number} [options.coords.x1] X coordiante of the first point for linear or of the focal point for radial
     * @param {Number} [options.coords.y1] Y coordiante of the first point for linear or of the focal point for radial
     * @param {Number} [options.coords.x2] X coordiante of the second point for linear or of the center point for radial
     * @param {Number} [options.coords.y2] Y coordiante of the second point for linear or of the center point for radial
     * @param {Number} [options.coords.r1] only for radial gradient, radius of the inner circle
     * @param {Number} [options.coords.r2] only for radial gradient, radius of the external circle
     * @return {fabric.Gradient} thisArg
     */ initialize: function(options) {
            options || (options = {});
            options.coords || (options.coords = {});
            var coords, _this = this;
            // sets everything, then coords and colorstops get sets again
            Object.keys(options).forEach(function(option) {
                _this[option] = options[option];
            });
            if (this.id) this.id += '_' + $79564f678731bf19$var$fabric.Object.__uid++;
            else this.id = $79564f678731bf19$var$fabric.Object.__uid++;
            coords = {
                x1: options.coords.x1 || 0,
                y1: options.coords.y1 || 0,
                x2: options.coords.x2 || 0,
                y2: options.coords.y2 || 0
            };
            if (this.type === 'radial') {
                coords.r1 = options.coords.r1 || 0;
                coords.r2 = options.coords.r2 || 0;
            }
            this.coords = coords;
            this.colorStops = options.colorStops.slice();
        },
        /**
     * Adds another colorStop
     * @param {Object} colorStop Object with offset and color
     * @return {fabric.Gradient} thisArg
     */ addColorStop: function(colorStops) {
            for(var position in colorStops){
                var color = new $79564f678731bf19$var$fabric.Color(colorStops[position]);
                this.colorStops.push({
                    offset: parseFloat(position),
                    color: color.toRgb(),
                    opacity: color.getAlpha()
                });
            }
            return this;
        },
        /**
     * Returns object representation of a gradient
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object}
     */ toObject: function(propertiesToInclude) {
            var object = {
                type: this.type,
                coords: this.coords,
                colorStops: this.colorStops,
                offsetX: this.offsetX,
                offsetY: this.offsetY,
                gradientUnits: this.gradientUnits,
                gradientTransform: this.gradientTransform ? this.gradientTransform.concat() : this.gradientTransform
            };
            $79564f678731bf19$var$fabric.util.populateWithProperties(this, object, propertiesToInclude);
            return object;
        },
        /* _TO_SVG_START_ */ /**
     * Returns SVG representation of an gradient
     * @param {Object} object Object to create a gradient for
     * @return {String} SVG representation of an gradient (linear/radial)
     */ toSVG: function(object, options) {
            var coords = clone(this.coords, true), i, len, options = options || {}, markup, commonAttributes, colorStops = clone(this.colorStops, true), needsSwap = coords.r1 > coords.r2, transform = this.gradientTransform ? this.gradientTransform.concat() : $79564f678731bf19$var$fabric.iMatrix.concat(), offsetX = -this.offsetX, offsetY = -this.offsetY, withViewport = !!options.additionalTransform, gradientUnits = this.gradientUnits === 'pixels' ? 'userSpaceOnUse' : 'objectBoundingBox';
            // colorStops must be sorted ascending
            colorStops.sort(function(a, b) {
                return a.offset - b.offset;
            });
            if (gradientUnits === 'objectBoundingBox') {
                offsetX /= object.width;
                offsetY /= object.height;
            } else {
                offsetX += object.width / 2;
                offsetY += object.height / 2;
            }
            if (object.type === 'path' && this.gradientUnits !== 'percentage') {
                offsetX -= object.pathOffset.x;
                offsetY -= object.pathOffset.y;
            }
            transform[4] -= offsetX;
            transform[5] -= offsetY;
            commonAttributes = 'id="SVGID_' + this.id + '" gradientUnits="' + gradientUnits + '"';
            commonAttributes += ' gradientTransform="' + (withViewport ? options.additionalTransform + ' ' : '') + $79564f678731bf19$var$fabric.util.matrixToSVG(transform) + '" ';
            if (this.type === 'linear') markup = [
                '<linearGradient ',
                commonAttributes,
                ' x1="',
                coords.x1,
                '" y1="',
                coords.y1,
                '" x2="',
                coords.x2,
                '" y2="',
                coords.y2,
                '">\n'
            ];
            else if (this.type === 'radial') // svg radial gradient has just 1 radius. the biggest.
            markup = [
                '<radialGradient ',
                commonAttributes,
                ' cx="',
                needsSwap ? coords.x1 : coords.x2,
                '" cy="',
                needsSwap ? coords.y1 : coords.y2,
                '" r="',
                needsSwap ? coords.r1 : coords.r2,
                '" fx="',
                needsSwap ? coords.x2 : coords.x1,
                '" fy="',
                needsSwap ? coords.y2 : coords.y1,
                '">\n'
            ];
            if (this.type === 'radial') {
                if (needsSwap) {
                    // svg goes from internal to external radius. if radius are inverted, swap color stops.
                    colorStops = colorStops.concat();
                    colorStops.reverse();
                    for(i = 0, len = colorStops.length; i < len; i++)colorStops[i].offset = 1 - colorStops[i].offset;
                }
                var minRadius = Math.min(coords.r1, coords.r2);
                if (minRadius > 0) {
                    // i have to shift all colorStops and add new one in 0.
                    var maxRadius = Math.max(coords.r1, coords.r2), percentageShift = minRadius / maxRadius;
                    for(i = 0, len = colorStops.length; i < len; i++)colorStops[i].offset += percentageShift * (1 - colorStops[i].offset);
                }
            }
            for(i = 0, len = colorStops.length; i < len; i++){
                var colorStop = colorStops[i];
                markup.push('<stop ', 'offset="', colorStop.offset * 100 + '%', '" style="stop-color:', colorStop.color, typeof colorStop.opacity !== 'undefined' ? ';stop-opacity: ' + colorStop.opacity : ';', '"/>\n');
            }
            markup.push(this.type === 'linear' ? '</linearGradient>\n' : '</radialGradient>\n');
            return markup.join('');
        },
        /* _TO_SVG_END_ */ /**
     * Returns an instance of CanvasGradient
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @return {CanvasGradient}
     */ toLive: function(ctx) {
            var gradient, coords = $79564f678731bf19$var$fabric.util.object.clone(this.coords), i, len;
            if (!this.type) return;
            if (this.type === 'linear') gradient = ctx.createLinearGradient(coords.x1, coords.y1, coords.x2, coords.y2);
            else if (this.type === 'radial') gradient = ctx.createRadialGradient(coords.x1, coords.y1, coords.r1, coords.x2, coords.y2, coords.r2);
            for(i = 0, len = this.colorStops.length; i < len; i++){
                var color = this.colorStops[i].color, opacity = this.colorStops[i].opacity, offset = this.colorStops[i].offset;
                if (typeof opacity !== 'undefined') color = new $79564f678731bf19$var$fabric.Color(color).setAlpha(opacity).toRgba();
                gradient.addColorStop(offset, color);
            }
            return gradient;
        }
    });
    $79564f678731bf19$var$fabric.util.object.extend($79564f678731bf19$var$fabric.Gradient, {
        /* _FROM_SVG_START_ */ /**
     * Returns {@link fabric.Gradient} instance from an SVG element
     * @static
     * @memberOf fabric.Gradient
     * @param {SVGGradientElement} el SVG gradient element
     * @param {fabric.Object} instance
     * @param {String} opacityAttr A fill-opacity or stroke-opacity attribute to multiply to each stop's opacity.
     * @param {Object} svgOptions an object containing the size of the SVG in order to parse correctly gradients
     * that uses gradientUnits as 'userSpaceOnUse' and percentages.
     * @param {Object.number} viewBoxWidth width part of the viewBox attribute on svg
     * @param {Object.number} viewBoxHeight height part of the viewBox attribute on svg
     * @param {Object.number} width width part of the svg tag if viewBox is not specified
     * @param {Object.number} height height part of the svg tag if viewBox is not specified
     * @return {fabric.Gradient} Gradient instance
     * @see http://www.w3.org/TR/SVG/pservers.html#LinearGradientElement
     * @see http://www.w3.org/TR/SVG/pservers.html#RadialGradientElement
     */ fromElement: function(el, instance, opacityAttr, svgOptions) {
            /**
       *  @example:
       *
       *  <linearGradient id="linearGrad1">
       *    <stop offset="0%" stop-color="white"/>
       *    <stop offset="100%" stop-color="black"/>
       *  </linearGradient>
       *
       *  OR
       *
       *  <linearGradient id="linearGrad2">
       *    <stop offset="0" style="stop-color:rgb(255,255,255)"/>
       *    <stop offset="1" style="stop-color:rgb(0,0,0)"/>
       *  </linearGradient>
       *
       *  OR
       *
       *  <radialGradient id="radialGrad1">
       *    <stop offset="0%" stop-color="white" stop-opacity="1" />
       *    <stop offset="50%" stop-color="black" stop-opacity="0.5" />
       *    <stop offset="100%" stop-color="white" stop-opacity="1" />
       *  </radialGradient>
       *
       *  OR
       *
       *  <radialGradient id="radialGrad2">
       *    <stop offset="0" stop-color="rgb(255,255,255)" />
       *    <stop offset="0.5" stop-color="rgb(0,0,0)" />
       *    <stop offset="1" stop-color="rgb(255,255,255)" />
       *  </radialGradient>
       *
       */ var multiplier = parseFloat(opacityAttr) / (/%$/.test(opacityAttr) ? 100 : 1);
            multiplier = multiplier < 0 ? 0 : multiplier > 1 ? 1 : multiplier;
            if (isNaN(multiplier)) multiplier = 1;
            var colorStopEls = el.getElementsByTagName('stop'), type, gradientUnits = el.getAttribute('gradientUnits') === 'userSpaceOnUse' ? 'pixels' : 'percentage', gradientTransform = el.getAttribute('gradientTransform') || '', colorStops = [], coords, i, offsetX = 0, offsetY = 0, transformMatrix;
            if (el.nodeName === 'linearGradient' || el.nodeName === 'LINEARGRADIENT') {
                type = 'linear';
                coords = getLinearCoords(el);
            } else {
                type = 'radial';
                coords = getRadialCoords(el);
            }
            for(i = colorStopEls.length; i--;)colorStops.push(getColorStop(colorStopEls[i], multiplier));
            transformMatrix = $79564f678731bf19$var$fabric.parseTransformAttribute(gradientTransform);
            __convertPercentUnitsToValues(instance, coords, svgOptions, gradientUnits);
            if (gradientUnits === 'pixels') {
                offsetX = -instance.left;
                offsetY = -instance.top;
            }
            var gradient = new $79564f678731bf19$var$fabric.Gradient({
                id: el.getAttribute('id'),
                type: type,
                coords: coords,
                colorStops: colorStops,
                gradientUnits: gradientUnits,
                gradientTransform: transformMatrix,
                offsetX: offsetX,
                offsetY: offsetY
            });
            return gradient;
        }
    });
    /**
   * @private
   */ function __convertPercentUnitsToValues(instance, options, svgOptions, gradientUnits) {
        var propValue, finalValue;
        Object.keys(options).forEach(function(prop) {
            propValue = options[prop];
            if (propValue === 'Infinity') finalValue = 1;
            else if (propValue === '-Infinity') finalValue = 0;
            else {
                finalValue = parseFloat(options[prop], 10);
                if (typeof propValue === 'string' && /^(\d+\.\d+)%|(\d+)%$/.test(propValue)) {
                    finalValue *= 0.01;
                    if (gradientUnits === 'pixels') {
                        // then we need to fix those percentages here in svg parsing
                        if (prop === 'x1' || prop === 'x2' || prop === 'r2') finalValue *= svgOptions.viewBoxWidth || svgOptions.width;
                        if (prop === 'y1' || prop === 'y2') finalValue *= svgOptions.viewBoxHeight || svgOptions.height;
                    }
                }
            }
            options[prop] = finalValue;
        });
    }
})();
(function() {
    'use strict';
    var toFixed = $79564f678731bf19$var$fabric.util.toFixed;
    /**
   * Pattern class
   * @class fabric.Pattern
   * @see {@link http://fabricjs.com/patterns|Pattern demo}
   * @see {@link http://fabricjs.com/dynamic-patterns|DynamicPattern demo}
   * @see {@link fabric.Pattern#initialize} for constructor definition
   */ $79564f678731bf19$var$fabric.Pattern = $79564f678731bf19$var$fabric.util.createClass(/** @lends fabric.Pattern.prototype */ {
        /**
     * Repeat property of a pattern (one of repeat, repeat-x, repeat-y or no-repeat)
     * @type String
     * @default
     */ repeat: 'repeat',
        /**
     * Pattern horizontal offset from object's left/top corner
     * @type Number
     * @default
     */ offsetX: 0,
        /**
     * Pattern vertical offset from object's left/top corner
     * @type Number
     * @default
     */ offsetY: 0,
        /**
     * crossOrigin value (one of "", "anonymous", "use-credentials")
     * @see https://developer.mozilla.org/en-US/docs/HTML/CORS_settings_attributes
     * @type String
     * @default
     */ crossOrigin: '',
        /**
     * transform matrix to change the pattern, imported from svgs.
     * @type Array
     * @default
     */ patternTransform: null,
        /**
     * Constructor
     * @param {Object} [options] Options object
     * @param {Function} [callback] function to invoke after callback init.
     * @return {fabric.Pattern} thisArg
     */ initialize: function(options, callback) {
            options || (options = {});
            this.id = $79564f678731bf19$var$fabric.Object.__uid++;
            this.setOptions(options);
            if (!options.source || options.source && typeof options.source !== 'string') {
                callback && callback(this);
                return;
            } else {
                // img src string
                var _this = this;
                this.source = $79564f678731bf19$var$fabric.util.createImage();
                $79564f678731bf19$var$fabric.util.loadImage(options.source, function(img, isError) {
                    _this.source = img;
                    callback && callback(_this, isError);
                }, null, this.crossOrigin);
            }
        },
        /**
     * Returns object representation of a pattern
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of a pattern instance
     */ toObject: function(propertiesToInclude) {
            var NUM_FRACTION_DIGITS = $79564f678731bf19$var$fabric.Object.NUM_FRACTION_DIGITS, source, object;
            // <img> element
            if (typeof this.source.src === 'string') source = this.source.src;
            else if (typeof this.source === 'object' && this.source.toDataURL) source = this.source.toDataURL();
            object = {
                type: 'pattern',
                source: source,
                repeat: this.repeat,
                crossOrigin: this.crossOrigin,
                offsetX: toFixed(this.offsetX, NUM_FRACTION_DIGITS),
                offsetY: toFixed(this.offsetY, NUM_FRACTION_DIGITS),
                patternTransform: this.patternTransform ? this.patternTransform.concat() : null
            };
            $79564f678731bf19$var$fabric.util.populateWithProperties(this, object, propertiesToInclude);
            return object;
        },
        /* _TO_SVG_START_ */ /**
     * Returns SVG representation of a pattern
     * @param {fabric.Object} object
     * @return {String} SVG representation of a pattern
     */ toSVG: function(object) {
            var patternSource = typeof this.source === 'function' ? this.source() : this.source, patternWidth = patternSource.width / object.width, patternHeight = patternSource.height / object.height, patternOffsetX = this.offsetX / object.width, patternOffsetY = this.offsetY / object.height, patternImgSrc = '';
            if (this.repeat === 'repeat-x' || this.repeat === 'no-repeat') {
                patternHeight = 1;
                if (patternOffsetY) patternHeight += Math.abs(patternOffsetY);
            }
            if (this.repeat === 'repeat-y' || this.repeat === 'no-repeat') {
                patternWidth = 1;
                if (patternOffsetX) patternWidth += Math.abs(patternOffsetX);
            }
            if (patternSource.src) patternImgSrc = patternSource.src;
            else if (patternSource.toDataURL) patternImgSrc = patternSource.toDataURL();
            return '<pattern id="SVGID_' + this.id + '" x="' + patternOffsetX + '" y="' + patternOffsetY + '" width="' + patternWidth + '" height="' + patternHeight + '">\n' + '<image x="0" y="0"' + ' width="' + patternSource.width + '" height="' + patternSource.height + '" xlink:href="' + patternImgSrc + '"></image>\n' + '</pattern>\n';
        },
        /* _TO_SVG_END_ */ setOptions: function(options) {
            for(var prop in options)this[prop] = options[prop];
        },
        /**
     * Returns an instance of CanvasPattern
     * @param {CanvasRenderingContext2D} ctx Context to create pattern
     * @return {CanvasPattern}
     */ toLive: function(ctx) {
            var source = this.source;
            // if the image failed to load, return, and allow rest to continue loading
            if (!source) return '';
            // if an image
            if (typeof source.src !== 'undefined') {
                if (!source.complete) return '';
                if (source.naturalWidth === 0 || source.naturalHeight === 0) return '';
            }
            return ctx.createPattern(source, this.repeat);
        }
    });
})();
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {}), toFixed = fabric.util.toFixed;
    if (fabric.Shadow) {
        fabric.warn('fabric.Shadow is already defined.');
        return;
    }
    /**
   * Shadow class
   * @class fabric.Shadow
   * @see {@link http://fabricjs.com/shadows|Shadow demo}
   * @see {@link fabric.Shadow#initialize} for constructor definition
   */ fabric.Shadow = fabric.util.createClass(/** @lends fabric.Shadow.prototype */ {
        /**
     * Shadow color
     * @type String
     * @default
     */ color: 'rgb(0,0,0)',
        /**
     * Shadow blur
     * @type Number
     */ blur: 0,
        /**
     * Shadow horizontal offset
     * @type Number
     * @default
     */ offsetX: 0,
        /**
     * Shadow vertical offset
     * @type Number
     * @default
     */ offsetY: 0,
        /**
     * Whether the shadow should affect stroke operations
     * @type Boolean
     * @default
     */ affectStroke: false,
        /**
     * Indicates whether toObject should include default values
     * @type Boolean
     * @default
     */ includeDefaultValues: true,
        /**
     * When `false`, the shadow will scale with the object.
     * When `true`, the shadow's offsetX, offsetY, and blur will not be affected by the object's scale.
     * default to false
     * @type Boolean
     * @default
     */ nonScaling: false,
        /**
     * Constructor
     * @param {Object|String} [options] Options object with any of color, blur, offsetX, offsetY properties or string (e.g. "rgba(0,0,0,0.2) 2px 2px 10px")
     * @return {fabric.Shadow} thisArg
     */ initialize: function(options) {
            if (typeof options === 'string') options = this._parseShadow(options);
            for(var prop in options)this[prop] = options[prop];
            this.id = fabric.Object.__uid++;
        },
        /**
     * @private
     * @param {String} shadow Shadow value to parse
     * @return {Object} Shadow object with color, offsetX, offsetY and blur
     */ _parseShadow: function(shadow) {
            var shadowStr = shadow.trim(), offsetsAndBlur = fabric.Shadow.reOffsetsAndBlur.exec(shadowStr) || [], color = shadowStr.replace(fabric.Shadow.reOffsetsAndBlur, '') || 'rgb(0,0,0)';
            return {
                color: color.trim(),
                offsetX: parseFloat(offsetsAndBlur[1], 10) || 0,
                offsetY: parseFloat(offsetsAndBlur[2], 10) || 0,
                blur: parseFloat(offsetsAndBlur[3], 10) || 0
            };
        },
        /**
     * Returns a string representation of an instance
     * @see http://www.w3.org/TR/css-text-decor-3/#text-shadow
     * @return {String} Returns CSS3 text-shadow declaration
     */ toString: function() {
            return [
                this.offsetX,
                this.offsetY,
                this.blur,
                this.color
            ].join('px ');
        },
        /* _TO_SVG_START_ */ /**
     * Returns SVG representation of a shadow
     * @param {fabric.Object} object
     * @return {String} SVG representation of a shadow
     */ toSVG: function(object) {
            var fBoxX = 40, fBoxY = 40, NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS, offset = fabric.util.rotateVector({
                x: this.offsetX,
                y: this.offsetY
            }, fabric.util.degreesToRadians(-object.angle)), BLUR_BOX = 20, color = new fabric.Color(this.color);
            if (object.width && object.height) {
                //http://www.w3.org/TR/SVG/filters.html#FilterEffectsRegion
                // we add some extra space to filter box to contain the blur ( 20 )
                fBoxX = toFixed((Math.abs(offset.x) + this.blur) / object.width, NUM_FRACTION_DIGITS) * 100 + BLUR_BOX;
                fBoxY = toFixed((Math.abs(offset.y) + this.blur) / object.height, NUM_FRACTION_DIGITS) * 100 + BLUR_BOX;
            }
            if (object.flipX) offset.x *= -1;
            if (object.flipY) offset.y *= -1;
            return '<filter id="SVGID_' + this.id + '" y="-' + fBoxY + '%" height="' + (100 + 2 * fBoxY) + '%" ' + 'x="-' + fBoxX + '%" width="' + (100 + 2 * fBoxX) + '%" ' + '>\n' + '\t<feGaussianBlur in="SourceAlpha" stdDeviation="' + toFixed(this.blur ? this.blur / 2 : 0, NUM_FRACTION_DIGITS) + '"></feGaussianBlur>\n' + '\t<feOffset dx="' + toFixed(offset.x, NUM_FRACTION_DIGITS) + '" dy="' + toFixed(offset.y, NUM_FRACTION_DIGITS) + '" result="oBlur" ></feOffset>\n' + '\t<feFlood flood-color="' + color.toRgb() + '" flood-opacity="' + color.getAlpha() + '"/>\n' + '\t<feComposite in2="oBlur" operator="in" />\n' + '\t<feMerge>\n' + '\t\t<feMergeNode></feMergeNode>\n' + '\t\t<feMergeNode in="SourceGraphic"></feMergeNode>\n' + '\t</feMerge>\n' + '</filter>\n';
        },
        /* _TO_SVG_END_ */ /**
     * Returns object representation of a shadow
     * @return {Object} Object representation of a shadow instance
     */ toObject: function() {
            if (this.includeDefaultValues) return {
                color: this.color,
                blur: this.blur,
                offsetX: this.offsetX,
                offsetY: this.offsetY,
                affectStroke: this.affectStroke,
                nonScaling: this.nonScaling
            };
            var obj = {}, proto = fabric.Shadow.prototype;
            [
                'color',
                'blur',
                'offsetX',
                'offsetY',
                'affectStroke',
                'nonScaling'
            ].forEach(function(prop) {
                if (this[prop] !== proto[prop]) obj[prop] = this[prop];
            }, this);
            return obj;
        }
    });
    /**
   * Regex matching shadow offsetX, offsetY and blur (ex: "2px 2px 10px rgba(0,0,0,0.2)", "rgb(0,255,0) 2px 2px")
   * @static
   * @field
   * @memberOf fabric.Shadow
   */ // eslint-disable-next-line max-len
    fabric.Shadow.reOffsetsAndBlur = /(?:\s|^)(-?\d+(?:\.\d*)?(?:px)?(?:\s?|$))?(-?\d+(?:\.\d*)?(?:px)?(?:\s?|$))?(\d+(?:\.\d*)?(?:px)?)?(?:\s?|$)(?:$|\s)/;
})($79564f678731bf19$exports);
(function() {
    'use strict';
    if ($79564f678731bf19$var$fabric.StaticCanvas) {
        $79564f678731bf19$var$fabric.warn('fabric.StaticCanvas is already defined.');
        return;
    }
    // aliases for faster resolution
    var extend = $79564f678731bf19$var$fabric.util.object.extend, getElementOffset = $79564f678731bf19$var$fabric.util.getElementOffset, removeFromArray = $79564f678731bf19$var$fabric.util.removeFromArray, toFixed = $79564f678731bf19$var$fabric.util.toFixed, transformPoint = $79564f678731bf19$var$fabric.util.transformPoint, invertTransform = $79564f678731bf19$var$fabric.util.invertTransform, getNodeCanvas = $79564f678731bf19$var$fabric.util.getNodeCanvas, createCanvasElement = $79564f678731bf19$var$fabric.util.createCanvasElement, CANVAS_INIT_ERROR = new Error('Could not initialize `canvas` element');
    /**
   * Static canvas class
   * @class fabric.StaticCanvas
   * @mixes fabric.Collection
   * @mixes fabric.Observable
   * @see {@link http://fabricjs.com/static_canvas|StaticCanvas demo}
   * @see {@link fabric.StaticCanvas#initialize} for constructor definition
   * @fires before:render
   * @fires after:render
   * @fires canvas:cleared
   * @fires object:added
   * @fires object:removed
   */ $79564f678731bf19$var$fabric.StaticCanvas = $79564f678731bf19$var$fabric.util.createClass($79564f678731bf19$var$fabric.CommonMethods, /** @lends fabric.StaticCanvas.prototype */ {
        /**
     * Constructor
     * @param {HTMLElement | String} el &lt;canvas> element to initialize instance on
     * @param {Object} [options] Options object
     * @return {Object} thisArg
     */ initialize: function(el, options) {
            options || (options = {});
            this.renderAndResetBound = this.renderAndReset.bind(this);
            this.requestRenderAllBound = this.requestRenderAll.bind(this);
            this._initStatic(el, options);
        },
        /**
     * Background color of canvas instance.
     * Should be set via {@link fabric.StaticCanvas#setBackgroundColor}.
     * @type {(String|fabric.Pattern)}
     * @default
     */ backgroundColor: '',
        /**
     * Background image of canvas instance.
     * since 2.4.0 image caching is active, please when putting an image as background, add to the
     * canvas property a reference to the canvas it is on. Otherwise the image cannot detect the zoom
     * vale. As an alternative you can disable image objectCaching
     * @type fabric.Image
     * @default
     */ backgroundImage: null,
        /**
     * Overlay color of canvas instance.
     * Should be set via {@link fabric.StaticCanvas#setOverlayColor}
     * @since 1.3.9
     * @type {(String|fabric.Pattern)}
     * @default
     */ overlayColor: '',
        /**
     * Overlay image of canvas instance.
     * since 2.4.0 image caching is active, please when putting an image as overlay, add to the
     * canvas property a reference to the canvas it is on. Otherwise the image cannot detect the zoom
     * vale. As an alternative you can disable image objectCaching
     * @type fabric.Image
     * @default
     */ overlayImage: null,
        /**
     * Indicates whether toObject/toDatalessObject should include default values
     * if set to false, takes precedence over the object value.
     * @type Boolean
     * @default
     */ includeDefaultValues: true,
        /**
     * Indicates whether objects' state should be saved
     * @type Boolean
     * @default
     */ stateful: false,
        /**
     * Indicates whether {@link fabric.Collection.add}, {@link fabric.Collection.insertAt} and {@link fabric.Collection.remove},
     * {@link fabric.StaticCanvas.moveTo}, {@link fabric.StaticCanvas.clear} and many more, should also re-render canvas.
     * Disabling this option will not give a performance boost when adding/removing a lot of objects to/from canvas at once
     * since the renders are quequed and executed one per frame.
     * Disabling is suggested anyway and managing the renders of the app manually is not a big effort ( canvas.requestRenderAll() )
     * Left default to true to do not break documentation and old app, fiddles.
     * @type Boolean
     * @default
     */ renderOnAddRemove: true,
        /**
     * Indicates whether object controls (borders/controls) are rendered above overlay image
     * @type Boolean
     * @default
     */ controlsAboveOverlay: false,
        /**
     * Indicates whether the browser can be scrolled when using a touchscreen and dragging on the canvas
     * @type Boolean
     * @default
     */ allowTouchScrolling: false,
        /**
     * Indicates whether this canvas will use image smoothing, this is on by default in browsers
     * @type Boolean
     * @default
     */ imageSmoothingEnabled: true,
        /**
     * The transformation (a Canvas 2D API transform matrix) which focuses the viewport
     * @type Array
     * @example <caption>Default transform</caption>
     * canvas.viewportTransform = [1, 0, 0, 1, 0, 0];
     * @example <caption>Scale by 70% and translate toward bottom-right by 50, without skewing</caption>
     * canvas.viewportTransform = [0.7, 0, 0, 0.7, 50, 50];
     * @default
     */ viewportTransform: $79564f678731bf19$var$fabric.iMatrix.concat(),
        /**
     * if set to false background image is not affected by viewport transform
     * @since 1.6.3
     * @type Boolean
     * @default
     */ backgroundVpt: true,
        /**
     * if set to false overlya image is not affected by viewport transform
     * @since 1.6.3
     * @type Boolean
     * @default
     */ overlayVpt: true,
        /**
     * When true, canvas is scaled by devicePixelRatio for better rendering on retina screens
     * @type Boolean
     * @default
     */ enableRetinaScaling: true,
        /**
     * Describe canvas element extension over design
     * properties are tl,tr,bl,br.
     * if canvas is not zoomed/panned those points are the four corner of canvas
     * if canvas is viewportTransformed you those points indicate the extension
     * of canvas element in plain untrasformed coordinates
     * The coordinates get updated with @method calcViewportBoundaries.
     * @memberOf fabric.StaticCanvas.prototype
     */ vptCoords: {},
        /**
     * Based on vptCoords and object.aCoords, skip rendering of objects that
     * are not included in current viewport.
     * May greatly help in applications with crowded canvas and use of zoom/pan
     * If One of the corner of the bounding box of the object is on the canvas
     * the objects get rendered.
     * @memberOf fabric.StaticCanvas.prototype
     * @type Boolean
     * @default
     */ skipOffscreen: true,
        /**
     * a fabricObject that, without stroke define a clipping area with their shape. filled in black
     * the clipPath object gets used when the canvas has rendered, and the context is placed in the
     * top left corner of the canvas.
     * clipPath will clip away controls, if you do not want this to happen use controlsAboveOverlay = true
     * @type fabric.Object
     */ clipPath: undefined,
        /**
     * @private
     * @param {HTMLElement | String} el &lt;canvas> element to initialize instance on
     * @param {Object} [options] Options object
     */ _initStatic: function(el, options) {
            var cb = this.requestRenderAllBound;
            this._objects = [];
            this._createLowerCanvas(el);
            this._initOptions(options);
            // only initialize retina scaling once
            if (!this.interactive) this._initRetinaScaling();
            if (options.overlayImage) this.setOverlayImage(options.overlayImage, cb);
            if (options.backgroundImage) this.setBackgroundImage(options.backgroundImage, cb);
            if (options.backgroundColor) this.setBackgroundColor(options.backgroundColor, cb);
            if (options.overlayColor) this.setOverlayColor(options.overlayColor, cb);
            this.calcOffset();
        },
        /**
     * @private
     */ _isRetinaScaling: function() {
            return $79564f678731bf19$var$fabric.devicePixelRatio > 1 && this.enableRetinaScaling;
        },
        /**
     * @private
     * @return {Number} retinaScaling if applied, otherwise 1;
     */ getRetinaScaling: function() {
            return this._isRetinaScaling() ? Math.max(1, $79564f678731bf19$var$fabric.devicePixelRatio) : 1;
        },
        /**
     * @private
     */ _initRetinaScaling: function() {
            if (!this._isRetinaScaling()) return;
            var scaleRatio = $79564f678731bf19$var$fabric.devicePixelRatio;
            this.__initRetinaScaling(scaleRatio, this.lowerCanvasEl, this.contextContainer);
            if (this.upperCanvasEl) this.__initRetinaScaling(scaleRatio, this.upperCanvasEl, this.contextTop);
        },
        __initRetinaScaling: function(scaleRatio, canvas, context) {
            canvas.setAttribute('width', this.width * scaleRatio);
            canvas.setAttribute('height', this.height * scaleRatio);
            context.scale(scaleRatio, scaleRatio);
        },
        /**
     * Calculates canvas element offset relative to the document
     * This method is also attached as "resize" event handler of window
     * @return {fabric.Canvas} instance
     * @chainable
     */ calcOffset: function() {
            this._offset = getElementOffset(this.lowerCanvasEl);
            return this;
        },
        /**
     * Sets {@link fabric.StaticCanvas#overlayImage|overlay image} for this canvas
     * @param {(fabric.Image|String)} image fabric.Image instance or URL of an image to set overlay to
     * @param {Function} callback callback to invoke when image is loaded and set as an overlay
     * @param {Object} [options] Optional options to set for the {@link fabric.Image|overlay image}.
     * @return {fabric.Canvas} thisArg
     * @chainable
     * @see {@link http://jsfiddle.net/fabricjs/MnzHT/|jsFiddle demo}
     * @example <caption>Normal overlayImage with left/top = 0</caption>
     * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
     *   // Needed to position overlayImage at 0/0
     *   originX: 'left',
     *   originY: 'top'
     * });
     * @example <caption>overlayImage with different properties</caption>
     * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
     *   opacity: 0.5,
     *   angle: 45,
     *   left: 400,
     *   top: 400,
     *   originX: 'left',
     *   originY: 'top'
     * });
     * @example <caption>Stretched overlayImage #1 - width/height correspond to canvas width/height</caption>
     * fabric.Image.fromURL('http://fabricjs.com/assets/jail_cell_bars.png', function(img, isError) {
     *    img.set({width: canvas.width, height: canvas.height, originX: 'left', originY: 'top'});
     *    canvas.setOverlayImage(img, canvas.renderAll.bind(canvas));
     * });
     * @example <caption>Stretched overlayImage #2 - width/height correspond to canvas width/height</caption>
     * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
     *   width: canvas.width,
     *   height: canvas.height,
     *   // Needed to position overlayImage at 0/0
     *   originX: 'left',
     *   originY: 'top'
     * });
     * @example <caption>overlayImage loaded from cross-origin</caption>
     * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
     *   opacity: 0.5,
     *   angle: 45,
     *   left: 400,
     *   top: 400,
     *   originX: 'left',
     *   originY: 'top',
     *   crossOrigin: 'anonymous'
     * });
     */ setOverlayImage: function(image, callback, options) {
            return this.__setBgOverlayImage('overlayImage', image, callback, options);
        },
        /**
     * Sets {@link fabric.StaticCanvas#backgroundImage|background image} for this canvas
     * @param {(fabric.Image|String)} image fabric.Image instance or URL of an image to set background to
     * @param {Function} callback Callback to invoke when image is loaded and set as background
     * @param {Object} [options] Optional options to set for the {@link fabric.Image|background image}.
     * @return {fabric.Canvas} thisArg
     * @chainable
     * @see {@link http://jsfiddle.net/djnr8o7a/28/|jsFiddle demo}
     * @example <caption>Normal backgroundImage with left/top = 0</caption>
     * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
     *   // Needed to position backgroundImage at 0/0
     *   originX: 'left',
     *   originY: 'top'
     * });
     * @example <caption>backgroundImage with different properties</caption>
     * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
     *   opacity: 0.5,
     *   angle: 45,
     *   left: 400,
     *   top: 400,
     *   originX: 'left',
     *   originY: 'top'
     * });
     * @example <caption>Stretched backgroundImage #1 - width/height correspond to canvas width/height</caption>
     * fabric.Image.fromURL('http://fabricjs.com/assets/honey_im_subtle.png', function(img, isError) {
     *    img.set({width: canvas.width, height: canvas.height, originX: 'left', originY: 'top'});
     *    canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas));
     * });
     * @example <caption>Stretched backgroundImage #2 - width/height correspond to canvas width/height</caption>
     * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
     *   width: canvas.width,
     *   height: canvas.height,
     *   // Needed to position backgroundImage at 0/0
     *   originX: 'left',
     *   originY: 'top'
     * });
     * @example <caption>backgroundImage loaded from cross-origin</caption>
     * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
     *   opacity: 0.5,
     *   angle: 45,
     *   left: 400,
     *   top: 400,
     *   originX: 'left',
     *   originY: 'top',
     *   crossOrigin: 'anonymous'
     * });
     */ // TODO: fix stretched examples
        setBackgroundImage: function(image, callback, options) {
            return this.__setBgOverlayImage('backgroundImage', image, callback, options);
        },
        /**
     * Sets {@link fabric.StaticCanvas#overlayColor|foreground color} for this canvas
     * @param {(String|fabric.Pattern)} overlayColor Color or pattern to set foreground color to
     * @param {Function} callback Callback to invoke when foreground color is set
     * @return {fabric.Canvas} thisArg
     * @chainable
     * @see {@link http://jsfiddle.net/fabricjs/pB55h/|jsFiddle demo}
     * @example <caption>Normal overlayColor - color value</caption>
     * canvas.setOverlayColor('rgba(255, 73, 64, 0.6)', canvas.renderAll.bind(canvas));
     * @example <caption>fabric.Pattern used as overlayColor</caption>
     * canvas.setOverlayColor({
     *   source: 'http://fabricjs.com/assets/escheresque_ste.png'
     * }, canvas.renderAll.bind(canvas));
     * @example <caption>fabric.Pattern used as overlayColor with repeat and offset</caption>
     * canvas.setOverlayColor({
     *   source: 'http://fabricjs.com/assets/escheresque_ste.png',
     *   repeat: 'repeat',
     *   offsetX: 200,
     *   offsetY: 100
     * }, canvas.renderAll.bind(canvas));
     */ setOverlayColor: function(overlayColor, callback) {
            return this.__setBgOverlayColor('overlayColor', overlayColor, callback);
        },
        /**
     * Sets {@link fabric.StaticCanvas#backgroundColor|background color} for this canvas
     * @param {(String|fabric.Pattern)} backgroundColor Color or pattern to set background color to
     * @param {Function} callback Callback to invoke when background color is set
     * @return {fabric.Canvas} thisArg
     * @chainable
     * @see {@link http://jsfiddle.net/fabricjs/hXzvk/|jsFiddle demo}
     * @example <caption>Normal backgroundColor - color value</caption>
     * canvas.setBackgroundColor('rgba(255, 73, 64, 0.6)', canvas.renderAll.bind(canvas));
     * @example <caption>fabric.Pattern used as backgroundColor</caption>
     * canvas.setBackgroundColor({
     *   source: 'http://fabricjs.com/assets/escheresque_ste.png'
     * }, canvas.renderAll.bind(canvas));
     * @example <caption>fabric.Pattern used as backgroundColor with repeat and offset</caption>
     * canvas.setBackgroundColor({
     *   source: 'http://fabricjs.com/assets/escheresque_ste.png',
     *   repeat: 'repeat',
     *   offsetX: 200,
     *   offsetY: 100
     * }, canvas.renderAll.bind(canvas));
     */ setBackgroundColor: function(backgroundColor, callback) {
            return this.__setBgOverlayColor('backgroundColor', backgroundColor, callback);
        },
        /**
     * @private
     * @param {String} property Property to set ({@link fabric.StaticCanvas#backgroundImage|backgroundImage}
     * or {@link fabric.StaticCanvas#overlayImage|overlayImage})
     * @param {(fabric.Image|String|null)} image fabric.Image instance, URL of an image or null to set background or overlay to
     * @param {Function} callback Callback to invoke when image is loaded and set as background or overlay. The first argument is the created image, the second argument is a flag indicating whether an error occurred or not.
     * @param {Object} [options] Optional options to set for the {@link fabric.Image|image}.
     */ __setBgOverlayImage: function(property, image, callback, options) {
            if (typeof image === 'string') $79564f678731bf19$var$fabric.util.loadImage(image, function(img, isError) {
                if (img) {
                    var instance = new $79564f678731bf19$var$fabric.Image(img, options);
                    this[property] = instance;
                    instance.canvas = this;
                }
                callback && callback(img, isError);
            }, this, options && options.crossOrigin);
            else {
                options && image.setOptions(options);
                this[property] = image;
                image && (image.canvas = this);
                callback && callback(image, false);
            }
            return this;
        },
        /**
     * @private
     * @param {String} property Property to set ({@link fabric.StaticCanvas#backgroundColor|backgroundColor}
     * or {@link fabric.StaticCanvas#overlayColor|overlayColor})
     * @param {(Object|String|null)} color Object with pattern information, color value or null
     * @param {Function} [callback] Callback is invoked when color is set
     */ __setBgOverlayColor: function(property, color, callback) {
            this[property] = color;
            this._initGradient(color, property);
            this._initPattern(color, property, callback);
            return this;
        },
        /**
     * @private
     */ _createCanvasElement: function() {
            var element = createCanvasElement();
            if (!element) throw CANVAS_INIT_ERROR;
            if (!element.style) element.style = {};
            if (typeof element.getContext === 'undefined') throw CANVAS_INIT_ERROR;
            return element;
        },
        /**
     * @private
     * @param {Object} [options] Options object
     */ _initOptions: function(options) {
            var lowerCanvasEl = this.lowerCanvasEl;
            this._setOptions(options);
            this.width = this.width || parseInt(lowerCanvasEl.width, 10) || 0;
            this.height = this.height || parseInt(lowerCanvasEl.height, 10) || 0;
            if (!this.lowerCanvasEl.style) return;
            lowerCanvasEl.width = this.width;
            lowerCanvasEl.height = this.height;
            lowerCanvasEl.style.width = this.width + 'px';
            lowerCanvasEl.style.height = this.height + 'px';
            this.viewportTransform = this.viewportTransform.slice();
        },
        /**
     * Creates a bottom canvas
     * @private
     * @param {HTMLElement} [canvasEl]
     */ _createLowerCanvas: function(canvasEl) {
            // canvasEl === 'HTMLCanvasElement' does not work on jsdom/node
            if (canvasEl && canvasEl.getContext) this.lowerCanvasEl = canvasEl;
            else this.lowerCanvasEl = $79564f678731bf19$var$fabric.util.getById(canvasEl) || this._createCanvasElement();
            $79564f678731bf19$var$fabric.util.addClass(this.lowerCanvasEl, 'lower-canvas');
            this._originalCanvasStyle = this.lowerCanvasEl.style;
            if (this.interactive) this._applyCanvasStyle(this.lowerCanvasEl);
            this.contextContainer = this.lowerCanvasEl.getContext('2d');
        },
        /**
     * Returns canvas width (in px)
     * @return {Number}
     */ getWidth: function() {
            return this.width;
        },
        /**
     * Returns canvas height (in px)
     * @return {Number}
     */ getHeight: function() {
            return this.height;
        },
        /**
     * Sets width of this canvas instance
     * @param {Number|String} value                         Value to set width to
     * @param {Object}        [options]                     Options object
     * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
     * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
     * @return {fabric.Canvas} instance
     * @chainable true
     */ setWidth: function(value, options) {
            return this.setDimensions({
                width: value
            }, options);
        },
        /**
     * Sets height of this canvas instance
     * @param {Number|String} value                         Value to set height to
     * @param {Object}        [options]                     Options object
     * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
     * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
     * @return {fabric.Canvas} instance
     * @chainable true
     */ setHeight: function(value, options) {
            return this.setDimensions({
                height: value
            }, options);
        },
        /**
     * Sets dimensions (width, height) of this canvas instance. when options.cssOnly flag active you should also supply the unit of measure (px/%/em)
     * @param {Object}        dimensions                    Object with width/height properties
     * @param {Number|String} [dimensions.width]            Width of canvas element
     * @param {Number|String} [dimensions.height]           Height of canvas element
     * @param {Object}        [options]                     Options object
     * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
     * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ setDimensions: function(dimensions, options) {
            var cssValue;
            options = options || {};
            for(var prop in dimensions){
                cssValue = dimensions[prop];
                if (!options.cssOnly) {
                    this._setBackstoreDimension(prop, dimensions[prop]);
                    cssValue += 'px';
                    this.hasLostContext = true;
                }
                if (!options.backstoreOnly) this._setCssDimension(prop, cssValue);
            }
            if (this._isCurrentlyDrawing) this.freeDrawingBrush && this.freeDrawingBrush._setBrushStyles(this.contextTop);
            this._initRetinaScaling();
            this.calcOffset();
            if (!options.cssOnly) this.requestRenderAll();
            return this;
        },
        /**
     * Helper for setting width/height
     * @private
     * @param {String} prop property (width|height)
     * @param {Number} value value to set property to
     * @return {fabric.Canvas} instance
     * @chainable true
     */ _setBackstoreDimension: function(prop, value) {
            this.lowerCanvasEl[prop] = value;
            if (this.upperCanvasEl) this.upperCanvasEl[prop] = value;
            if (this.cacheCanvasEl) this.cacheCanvasEl[prop] = value;
            this[prop] = value;
            return this;
        },
        /**
     * Helper for setting css width/height
     * @private
     * @param {String} prop property (width|height)
     * @param {String} value value to set property to
     * @return {fabric.Canvas} instance
     * @chainable true
     */ _setCssDimension: function(prop, value) {
            this.lowerCanvasEl.style[prop] = value;
            if (this.upperCanvasEl) this.upperCanvasEl.style[prop] = value;
            if (this.wrapperEl) this.wrapperEl.style[prop] = value;
            return this;
        },
        /**
     * Returns canvas zoom level
     * @return {Number}
     */ getZoom: function() {
            return this.viewportTransform[0];
        },
        /**
     * Sets viewport transformation of this canvas instance
     * @param {Array} vpt a Canvas 2D API transform matrix
     * @return {fabric.Canvas} instance
     * @chainable true
     */ setViewportTransform: function(vpt) {
            var activeObject = this._activeObject, backgroundObject = this.backgroundImage, overlayObject = this.overlayImage, object, i, len;
            this.viewportTransform = vpt;
            for(i = 0, len = this._objects.length; i < len; i++){
                object = this._objects[i];
                object.group || object.setCoords(true);
            }
            if (activeObject) activeObject.setCoords();
            if (backgroundObject) backgroundObject.setCoords(true);
            if (overlayObject) overlayObject.setCoords(true);
            this.calcViewportBoundaries();
            this.renderOnAddRemove && this.requestRenderAll();
            return this;
        },
        /**
     * Sets zoom level of this canvas instance, the zoom centered around point
     * meaning that following zoom to point with the same point will have the visual
     * effect of the zoom originating from that point. The point won't move.
     * It has nothing to do with canvas center or visual center of the viewport.
     * @param {fabric.Point} point to zoom with respect to
     * @param {Number} value to set zoom to, less than 1 zooms out
     * @return {fabric.Canvas} instance
     * @chainable true
     */ zoomToPoint: function(point, value) {
            // TODO: just change the scale, preserve other transformations
            var before = point, vpt = this.viewportTransform.slice(0);
            point = transformPoint(point, invertTransform(this.viewportTransform));
            vpt[0] = value;
            vpt[3] = value;
            var after = transformPoint(point, vpt);
            vpt[4] += before.x - after.x;
            vpt[5] += before.y - after.y;
            return this.setViewportTransform(vpt);
        },
        /**
     * Sets zoom level of this canvas instance
     * @param {Number} value to set zoom to, less than 1 zooms out
     * @return {fabric.Canvas} instance
     * @chainable true
     */ setZoom: function(value) {
            this.zoomToPoint(new $79564f678731bf19$var$fabric.Point(0, 0), value);
            return this;
        },
        /**
     * Pan viewport so as to place point at top left corner of canvas
     * @param {fabric.Point} point to move to
     * @return {fabric.Canvas} instance
     * @chainable true
     */ absolutePan: function(point) {
            var vpt = this.viewportTransform.slice(0);
            vpt[4] = -point.x;
            vpt[5] = -point.y;
            return this.setViewportTransform(vpt);
        },
        /**
     * Pans viewpoint relatively
     * @param {fabric.Point} point (position vector) to move by
     * @return {fabric.Canvas} instance
     * @chainable true
     */ relativePan: function(point) {
            return this.absolutePan(new $79564f678731bf19$var$fabric.Point(-point.x - this.viewportTransform[4], -point.y - this.viewportTransform[5]));
        },
        /**
     * Returns &lt;canvas> element corresponding to this instance
     * @return {HTMLCanvasElement}
     */ getElement: function() {
            return this.lowerCanvasEl;
        },
        /**
     * @private
     * @param {fabric.Object} obj Object that was added
     */ _onObjectAdded: function(obj) {
            this.stateful && obj.setupState();
            obj._set('canvas', this);
            obj.setCoords();
            this.fire('object:added', {
                target: obj
            });
            obj.fire('added');
        },
        /**
     * @private
     * @param {fabric.Object} obj Object that was removed
     */ _onObjectRemoved: function(obj) {
            this.fire('object:removed', {
                target: obj
            });
            obj.fire('removed');
            delete obj.canvas;
        },
        /**
     * Clears specified context of canvas element
     * @param {CanvasRenderingContext2D} ctx Context to clear
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ clearContext: function(ctx) {
            ctx.clearRect(0, 0, this.width, this.height);
            return this;
        },
        /**
     * Returns context of canvas where objects are drawn
     * @return {CanvasRenderingContext2D}
     */ getContext: function() {
            return this.contextContainer;
        },
        /**
     * Clears all contexts (background, main, top) of an instance
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ clear: function() {
            this.remove.apply(this, this.getObjects());
            this.backgroundImage = null;
            this.overlayImage = null;
            this.backgroundColor = '';
            this.overlayColor = '';
            if (this._hasITextHandlers) {
                this.off('mouse:up', this._mouseUpITextHandler);
                this._iTextInstances = null;
                this._hasITextHandlers = false;
            }
            this.clearContext(this.contextContainer);
            this.fire('canvas:cleared');
            this.renderOnAddRemove && this.requestRenderAll();
            return this;
        },
        /**
     * Renders the canvas
     * @return {fabric.Canvas} instance
     * @chainable
     */ renderAll: function() {
            var canvasToDrawOn = this.contextContainer;
            this.renderCanvas(canvasToDrawOn, this._objects);
            return this;
        },
        /**
     * Function created to be instance bound at initialization
     * used in requestAnimationFrame rendering
     * Let the fabricJS call it. If you call it manually you could have more
     * animationFrame stacking on to of each other
     * for an imperative rendering, use canvas.renderAll
     * @private
     * @return {fabric.Canvas} instance
     * @chainable
     */ renderAndReset: function() {
            this.isRendering = 0;
            this.renderAll();
        },
        /**
     * Append a renderAll request to next animation frame.
     * unless one is already in progress, in that case nothing is done
     * a boolean flag will avoid appending more.
     * @return {fabric.Canvas} instance
     * @chainable
     */ requestRenderAll: function() {
            if (!this.isRendering) this.isRendering = $79564f678731bf19$var$fabric.util.requestAnimFrame(this.renderAndResetBound);
            return this;
        },
        /**
     * Calculate the position of the 4 corner of canvas with current viewportTransform.
     * helps to determinate when an object is in the current rendering viewport using
     * object absolute coordinates ( aCoords )
     * @return {Object} points.tl
     * @chainable
     */ calcViewportBoundaries: function() {
            var points = {}, width = this.width, height = this.height, iVpt = invertTransform(this.viewportTransform);
            points.tl = transformPoint({
                x: 0,
                y: 0
            }, iVpt);
            points.br = transformPoint({
                x: width,
                y: height
            }, iVpt);
            points.tr = new $79564f678731bf19$var$fabric.Point(points.br.x, points.tl.y);
            points.bl = new $79564f678731bf19$var$fabric.Point(points.tl.x, points.br.y);
            this.vptCoords = points;
            return points;
        },
        cancelRequestedRender: function() {
            if (this.isRendering) {
                $79564f678731bf19$var$fabric.util.cancelAnimFrame(this.isRendering);
                this.isRendering = 0;
            }
        },
        /**
     * Renders background, objects, overlay and controls.
     * @param {CanvasRenderingContext2D} ctx
     * @param {Array} objects to render
     * @return {fabric.Canvas} instance
     * @chainable
     */ renderCanvas: function(ctx, objects) {
            var v = this.viewportTransform, path = this.clipPath;
            this.cancelRequestedRender();
            this.calcViewportBoundaries();
            this.clearContext(ctx);
            $79564f678731bf19$var$fabric.util.setImageSmoothing(ctx, this.imageSmoothingEnabled);
            this.fire('before:render', {
                ctx: ctx
            });
            this._renderBackground(ctx);
            ctx.save();
            //apply viewport transform once for all rendering process
            ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
            this._renderObjects(ctx, objects);
            ctx.restore();
            if (!this.controlsAboveOverlay && this.interactive) this.drawControls(ctx);
            if (path) {
                path.canvas = this;
                // needed to setup a couple of variables
                path.shouldCache();
                path._transformDone = true;
                path.renderCache({
                    forClipping: true
                });
                this.drawClipPathOnCanvas(ctx);
            }
            this._renderOverlay(ctx);
            if (this.controlsAboveOverlay && this.interactive) this.drawControls(ctx);
            this.fire('after:render', {
                ctx: ctx
            });
        },
        /**
     * Paint the cached clipPath on the lowerCanvasEl
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ drawClipPathOnCanvas: function(ctx) {
            var v = this.viewportTransform, path = this.clipPath;
            ctx.save();
            ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
            // DEBUG: uncomment this line, comment the following
            // ctx.globalAlpha = 0.4;
            ctx.globalCompositeOperation = 'destination-in';
            path.transform(ctx);
            ctx.scale(1 / path.zoomX, 1 / path.zoomY);
            ctx.drawImage(path._cacheCanvas, -path.cacheTranslationX, -path.cacheTranslationY);
            ctx.restore();
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Array} objects to render
     */ _renderObjects: function(ctx, objects) {
            var i, len;
            for(i = 0, len = objects.length; i < len; ++i)objects[i] && objects[i].render(ctx);
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {string} property 'background' or 'overlay'
     */ _renderBackgroundOrOverlay: function(ctx, property) {
            var fill = this[property + 'Color'], object = this[property + 'Image'], v = this.viewportTransform, needsVpt = this[property + 'Vpt'];
            if (!fill && !object) return;
            if (fill) {
                ctx.save();
                ctx.beginPath();
                ctx.moveTo(0, 0);
                ctx.lineTo(this.width, 0);
                ctx.lineTo(this.width, this.height);
                ctx.lineTo(0, this.height);
                ctx.closePath();
                ctx.fillStyle = fill.toLive ? fill.toLive(ctx, this) : fill;
                if (needsVpt) ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
                ctx.transform(1, 0, 0, 1, fill.offsetX || 0, fill.offsetY || 0);
                var m = fill.gradientTransform || fill.patternTransform;
                m && ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
                ctx.fill();
                ctx.restore();
            }
            if (object) {
                ctx.save();
                var skipOffscreen = this.skipOffscreen;
                // if the object doesn't move with the viewport,
                // the offscreen concept does not apply;
                this.skipOffscreen = needsVpt;
                if (needsVpt) ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
                object.render(ctx);
                this.skipOffscreen = skipOffscreen;
                ctx.restore();
            }
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _renderBackground: function(ctx) {
            this._renderBackgroundOrOverlay(ctx, 'background');
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _renderOverlay: function(ctx) {
            this._renderBackgroundOrOverlay(ctx, 'overlay');
        },
        /**
     * Returns coordinates of a center of canvas.
     * Returned value is an object with top and left properties
     * @return {Object} object with "top" and "left" number values
     * @deprecated migrate to `getCenterPoint`
     */ getCenter: function() {
            return {
                top: this.height / 2,
                left: this.width / 2
            };
        },
        /**
     * Returns coordinates of a center of canvas.
     * @return {fabric.Point} 
     */ getCenterPoint: function() {
            return new $79564f678731bf19$var$fabric.Point(this.width / 2, this.height / 2);
        },
        /**
     * Centers object horizontally in the canvas
     * @param {fabric.Object} object Object to center horizontally
     * @return {fabric.Canvas} thisArg
     */ centerObjectH: function(object) {
            return this._centerObject(object, new $79564f678731bf19$var$fabric.Point(this.getCenterPoint().x, object.getCenterPoint().y));
        },
        /**
     * Centers object vertically in the canvas
     * @param {fabric.Object} object Object to center vertically
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ centerObjectV: function(object) {
            return this._centerObject(object, new $79564f678731bf19$var$fabric.Point(object.getCenterPoint().x, this.getCenterPoint().y));
        },
        /**
     * Centers object vertically and horizontally in the canvas
     * @param {fabric.Object} object Object to center vertically and horizontally
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ centerObject: function(object) {
            var center = this.getCenterPoint();
            return this._centerObject(object, center);
        },
        /**
     * Centers object vertically and horizontally in the viewport
     * @param {fabric.Object} object Object to center vertically and horizontally
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ viewportCenterObject: function(object) {
            var vpCenter = this.getVpCenter();
            return this._centerObject(object, vpCenter);
        },
        /**
     * Centers object horizontally in the viewport, object.top is unchanged
     * @param {fabric.Object} object Object to center vertically and horizontally
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ viewportCenterObjectH: function(object) {
            var vpCenter = this.getVpCenter();
            this._centerObject(object, new $79564f678731bf19$var$fabric.Point(vpCenter.x, object.getCenterPoint().y));
            return this;
        },
        /**
     * Centers object Vertically in the viewport, object.top is unchanged
     * @param {fabric.Object} object Object to center vertically and horizontally
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ viewportCenterObjectV: function(object) {
            var vpCenter = this.getVpCenter();
            return this._centerObject(object, new $79564f678731bf19$var$fabric.Point(object.getCenterPoint().x, vpCenter.y));
        },
        /**
     * Calculate the point in canvas that correspond to the center of actual viewport.
     * @return {fabric.Point} vpCenter, viewport center
     * @chainable
     */ getVpCenter: function() {
            var center = this.getCenterPoint(), iVpt = invertTransform(this.viewportTransform);
            return transformPoint(center, iVpt);
        },
        /**
     * @private
     * @param {fabric.Object} object Object to center
     * @param {fabric.Point} center Center point
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ _centerObject: function(object, center) {
            object.setPositionByOrigin(center, 'center', 'center');
            object.setCoords();
            this.renderOnAddRemove && this.requestRenderAll();
            return this;
        },
        /**
     * Returns dataless JSON representation of canvas
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {String} json string
     */ toDatalessJSON: function(propertiesToInclude) {
            return this.toDatalessObject(propertiesToInclude);
        },
        /**
     * Returns object representation of canvas
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */ toObject: function(propertiesToInclude) {
            return this._toObjectMethod('toObject', propertiesToInclude);
        },
        /**
     * Returns dataless object representation of canvas
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */ toDatalessObject: function(propertiesToInclude) {
            return this._toObjectMethod('toDatalessObject', propertiesToInclude);
        },
        /**
     * @private
     */ _toObjectMethod: function(methodName, propertiesToInclude) {
            var clipPath = this.clipPath, data = {
                version: $79564f678731bf19$var$fabric.version,
                objects: this._toObjects(methodName, propertiesToInclude)
            };
            if (clipPath && !clipPath.excludeFromExport) data.clipPath = this._toObject(this.clipPath, methodName, propertiesToInclude);
            extend(data, this.__serializeBgOverlay(methodName, propertiesToInclude));
            $79564f678731bf19$var$fabric.util.populateWithProperties(this, data, propertiesToInclude);
            return data;
        },
        /**
     * @private
     */ _toObjects: function(methodName, propertiesToInclude) {
            return this._objects.filter(function(object) {
                return !object.excludeFromExport;
            }).map(function(instance) {
                return this._toObject(instance, methodName, propertiesToInclude);
            }, this);
        },
        /**
     * @private
     */ _toObject: function(instance, methodName, propertiesToInclude) {
            var originalValue;
            if (!this.includeDefaultValues) {
                originalValue = instance.includeDefaultValues;
                instance.includeDefaultValues = false;
            }
            var object = instance[methodName](propertiesToInclude);
            if (!this.includeDefaultValues) instance.includeDefaultValues = originalValue;
            return object;
        },
        /**
     * @private
     */ __serializeBgOverlay: function(methodName, propertiesToInclude) {
            var data = {}, bgImage = this.backgroundImage, overlayImage = this.overlayImage, bgColor = this.backgroundColor, overlayColor = this.overlayColor;
            if (bgColor && bgColor.toObject) {
                if (!bgColor.excludeFromExport) data.background = bgColor.toObject(propertiesToInclude);
            } else if (bgColor) data.background = bgColor;
            if (overlayColor && overlayColor.toObject) {
                if (!overlayColor.excludeFromExport) data.overlay = overlayColor.toObject(propertiesToInclude);
            } else if (overlayColor) data.overlay = overlayColor;
            if (bgImage && !bgImage.excludeFromExport) data.backgroundImage = this._toObject(bgImage, methodName, propertiesToInclude);
            if (overlayImage && !overlayImage.excludeFromExport) data.overlayImage = this._toObject(overlayImage, methodName, propertiesToInclude);
            return data;
        },
        /* _TO_SVG_START_ */ /**
     * When true, getSvgTransform() will apply the StaticCanvas.viewportTransform to the SVG transformation. When true,
     * a zoomed canvas will then produce zoomed SVG output.
     * @type Boolean
     * @default
     */ svgViewportTransformation: true,
        /**
     * Returns SVG representation of canvas
     * @function
     * @param {Object} [options] Options object for SVG output
     * @param {Boolean} [options.suppressPreamble=false] If true xml tag is not included
     * @param {Object} [options.viewBox] SVG viewbox object
     * @param {Number} [options.viewBox.x] x-coordinate of viewbox
     * @param {Number} [options.viewBox.y] y-coordinate of viewbox
     * @param {Number} [options.viewBox.width] Width of viewbox
     * @param {Number} [options.viewBox.height] Height of viewbox
     * @param {String} [options.encoding=UTF-8] Encoding of SVG output
     * @param {String} [options.width] desired width of svg with or without units
     * @param {String} [options.height] desired height of svg with or without units
     * @param {Function} [reviver] Method for further parsing of svg elements, called after each fabric object converted into svg representation.
     * @return {String} SVG string
     * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#serialization}
     * @see {@link http://jsfiddle.net/fabricjs/jQ3ZZ/|jsFiddle demo}
     * @example <caption>Normal SVG output</caption>
     * var svg = canvas.toSVG();
     * @example <caption>SVG output without preamble (without &lt;?xml ../>)</caption>
     * var svg = canvas.toSVG({suppressPreamble: true});
     * @example <caption>SVG output with viewBox attribute</caption>
     * var svg = canvas.toSVG({
     *   viewBox: {
     *     x: 100,
     *     y: 100,
     *     width: 200,
     *     height: 300
     *   }
     * });
     * @example <caption>SVG output with different encoding (default: UTF-8)</caption>
     * var svg = canvas.toSVG({encoding: 'ISO-8859-1'});
     * @example <caption>Modify SVG output with reviver function</caption>
     * var svg = canvas.toSVG(null, function(svg) {
     *   return svg.replace('stroke-dasharray: ; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; ', '');
     * });
     */ toSVG: function(options, reviver) {
            options || (options = {});
            options.reviver = reviver;
            var markup = [];
            this._setSVGPreamble(markup, options);
            this._setSVGHeader(markup, options);
            if (this.clipPath) markup.push('<g clip-path="url(#' + this.clipPath.clipPathId + ')" >\n');
            this._setSVGBgOverlayColor(markup, 'background');
            this._setSVGBgOverlayImage(markup, 'backgroundImage', reviver);
            this._setSVGObjects(markup, reviver);
            if (this.clipPath) markup.push('</g>\n');
            this._setSVGBgOverlayColor(markup, 'overlay');
            this._setSVGBgOverlayImage(markup, 'overlayImage', reviver);
            markup.push('</svg>');
            return markup.join('');
        },
        /**
     * @private
     */ _setSVGPreamble: function(markup, options) {
            if (options.suppressPreamble) return;
            markup.push('<?xml version="1.0" encoding="', options.encoding || 'UTF-8', '" standalone="no" ?>\n', '<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" ', '"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\n');
        },
        /**
     * @private
     */ _setSVGHeader: function(markup, options) {
            var width = options.width || this.width, height = options.height || this.height, vpt, viewBox = 'viewBox="0 0 ' + this.width + ' ' + this.height + '" ', NUM_FRACTION_DIGITS = $79564f678731bf19$var$fabric.Object.NUM_FRACTION_DIGITS;
            if (options.viewBox) viewBox = 'viewBox="' + options.viewBox.x + ' ' + options.viewBox.y + ' ' + options.viewBox.width + ' ' + options.viewBox.height + '" ';
            else if (this.svgViewportTransformation) {
                vpt = this.viewportTransform;
                viewBox = 'viewBox="' + toFixed(-vpt[4] / vpt[0], NUM_FRACTION_DIGITS) + ' ' + toFixed(-vpt[5] / vpt[3], NUM_FRACTION_DIGITS) + ' ' + toFixed(this.width / vpt[0], NUM_FRACTION_DIGITS) + ' ' + toFixed(this.height / vpt[3], NUM_FRACTION_DIGITS) + '" ';
            }
            markup.push('<svg ', 'xmlns="http://www.w3.org/2000/svg" ', 'xmlns:xlink="http://www.w3.org/1999/xlink" ', 'version="1.1" ', 'width="', width, '" ', 'height="', height, '" ', viewBox, 'xml:space="preserve">\n', '<desc>Created with Fabric.js ', $79564f678731bf19$var$fabric.version, '</desc>\n', '<defs>\n', this.createSVGFontFacesMarkup(), this.createSVGRefElementsMarkup(), this.createSVGClipPathMarkup(options), '</defs>\n');
        },
        createSVGClipPathMarkup: function(options) {
            var clipPath = this.clipPath;
            if (clipPath) {
                clipPath.clipPathId = 'CLIPPATH_' + $79564f678731bf19$var$fabric.Object.__uid++;
                return '<clipPath id="' + clipPath.clipPathId + '" >\n' + this.clipPath.toClipPathSVG(options.reviver) + '</clipPath>\n';
            }
            return '';
        },
        /**
     * Creates markup containing SVG referenced elements like patterns, gradients etc.
     * @return {String}
     */ createSVGRefElementsMarkup: function() {
            var _this = this, markup = [
                'background',
                'overlay'
            ].map(function(prop) {
                var fill = _this[prop + 'Color'];
                if (fill && fill.toLive) {
                    var shouldTransform = _this[prop + 'Vpt'], vpt = _this.viewportTransform, object = {
                        width: _this.width / (shouldTransform ? vpt[0] : 1),
                        height: _this.height / (shouldTransform ? vpt[3] : 1)
                    };
                    return fill.toSVG(object, {
                        additionalTransform: shouldTransform ? $79564f678731bf19$var$fabric.util.matrixToSVG(vpt) : ''
                    });
                }
            });
            return markup.join('');
        },
        /**
     * Creates markup containing SVG font faces,
     * font URLs for font faces must be collected by developers
     * and are not extracted from the DOM by fabricjs
     * @param {Array} objects Array of fabric objects
     * @return {String}
     */ createSVGFontFacesMarkup: function() {
            var markup = '', fontList = {}, obj, fontFamily, style, row, rowIndex, _char, charIndex, i, len, fontPaths = $79564f678731bf19$var$fabric.fontPaths, objects = [];
            this._objects.forEach(function add(object) {
                objects.push(object);
                if (object._objects) object._objects.forEach(add);
            });
            for(i = 0, len = objects.length; i < len; i++){
                obj = objects[i];
                fontFamily = obj.fontFamily;
                if (obj.type.indexOf('text') === -1 || fontList[fontFamily] || !fontPaths[fontFamily]) continue;
                fontList[fontFamily] = true;
                if (!obj.styles) continue;
                style = obj.styles;
                for(rowIndex in style){
                    row = style[rowIndex];
                    for(charIndex in row){
                        _char = row[charIndex];
                        fontFamily = _char.fontFamily;
                        if (!fontList[fontFamily] && fontPaths[fontFamily]) fontList[fontFamily] = true;
                    }
                }
            }
            for(var j in fontList)markup += [
                '\t\t@font-face {\n',
                '\t\t\tfont-family: \'',
                j,
                '\';\n',
                '\t\t\tsrc: url(\'',
                fontPaths[j],
                '\');\n',
                '\t\t}\n'
            ].join('');
            if (markup) markup = [
                '\t<style type="text/css">',
                '<![CDATA[\n',
                markup,
                ']]>',
                '</style>\n'
            ].join('');
            return markup;
        },
        /**
     * @private
     */ _setSVGObjects: function(markup, reviver) {
            var instance, i, len, objects = this._objects;
            for(i = 0, len = objects.length; i < len; i++){
                instance = objects[i];
                if (instance.excludeFromExport) continue;
                this._setSVGObject(markup, instance, reviver);
            }
        },
        /**
     * @private
     */ _setSVGObject: function(markup, instance, reviver) {
            markup.push(instance.toSVG(reviver));
        },
        /**
     * @private
     */ _setSVGBgOverlayImage: function(markup, property, reviver) {
            if (this[property] && !this[property].excludeFromExport && this[property].toSVG) markup.push(this[property].toSVG(reviver));
        },
        /**
     * @private
     */ _setSVGBgOverlayColor: function(markup, property) {
            var filler = this[property + 'Color'], vpt = this.viewportTransform, finalWidth = this.width, finalHeight = this.height;
            if (!filler) return;
            if (filler.toLive) {
                var repeat = filler.repeat, iVpt = $79564f678731bf19$var$fabric.util.invertTransform(vpt), shouldInvert = this[property + 'Vpt'], additionalTransform = shouldInvert ? $79564f678731bf19$var$fabric.util.matrixToSVG(iVpt) : '';
                markup.push('<rect transform="' + additionalTransform + ' translate(', finalWidth / 2, ',', finalHeight / 2, ')"', ' x="', filler.offsetX - finalWidth / 2, '" y="', filler.offsetY - finalHeight / 2, '" ', 'width="', repeat === 'repeat-y' || repeat === 'no-repeat' ? filler.source.width : finalWidth, '" height="', repeat === 'repeat-x' || repeat === 'no-repeat' ? filler.source.height : finalHeight, '" fill="url(#SVGID_' + filler.id + ')"', '></rect>\n');
            } else markup.push('<rect x="0" y="0" width="100%" height="100%" ', 'fill="', filler, '"', '></rect>\n');
        },
        /* _TO_SVG_END_ */ /**
     * Moves an object or the objects of a multiple selection
     * to the bottom of the stack of drawn objects
     * @param {fabric.Object} object Object to send to back
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ sendToBack: function(object) {
            if (!object) return this;
            var activeSelection = this._activeObject, i, obj, objs;
            if (object === activeSelection && object.type === 'activeSelection') {
                objs = activeSelection._objects;
                for(i = objs.length; i--;){
                    obj = objs[i];
                    removeFromArray(this._objects, obj);
                    this._objects.unshift(obj);
                }
            } else {
                removeFromArray(this._objects, object);
                this._objects.unshift(object);
            }
            this.renderOnAddRemove && this.requestRenderAll();
            return this;
        },
        /**
     * Moves an object or the objects of a multiple selection
     * to the top of the stack of drawn objects
     * @param {fabric.Object} object Object to send
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ bringToFront: function(object) {
            if (!object) return this;
            var activeSelection = this._activeObject, i, obj, objs;
            if (object === activeSelection && object.type === 'activeSelection') {
                objs = activeSelection._objects;
                for(i = 0; i < objs.length; i++){
                    obj = objs[i];
                    removeFromArray(this._objects, obj);
                    this._objects.push(obj);
                }
            } else {
                removeFromArray(this._objects, object);
                this._objects.push(object);
            }
            this.renderOnAddRemove && this.requestRenderAll();
            return this;
        },
        /**
     * Moves an object or a selection down in stack of drawn objects
     * An optional parameter, intersecting allows to move the object in behind
     * the first intersecting object. Where intersection is calculated with
     * bounding box. If no intersection is found, there will not be change in the
     * stack.
     * @param {fabric.Object} object Object to send
     * @param {Boolean} [intersecting] If `true`, send object behind next lower intersecting object
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ sendBackwards: function(object, intersecting) {
            if (!object) return this;
            var activeSelection = this._activeObject, i, obj, idx, newIdx, objs, objsMoved = 0;
            if (object === activeSelection && object.type === 'activeSelection') {
                objs = activeSelection._objects;
                for(i = 0; i < objs.length; i++){
                    obj = objs[i];
                    idx = this._objects.indexOf(obj);
                    if (idx > 0 + objsMoved) {
                        newIdx = idx - 1;
                        removeFromArray(this._objects, obj);
                        this._objects.splice(newIdx, 0, obj);
                    }
                    objsMoved++;
                }
            } else {
                idx = this._objects.indexOf(object);
                if (idx !== 0) {
                    // if object is not on the bottom of stack
                    newIdx = this._findNewLowerIndex(object, idx, intersecting);
                    removeFromArray(this._objects, object);
                    this._objects.splice(newIdx, 0, object);
                }
            }
            this.renderOnAddRemove && this.requestRenderAll();
            return this;
        },
        /**
     * @private
     */ _findNewLowerIndex: function(object, idx, intersecting) {
            var newIdx, i;
            if (intersecting) {
                newIdx = idx;
                // traverse down the stack looking for the nearest intersecting object
                for(i = idx - 1; i >= 0; --i){
                    var isIntersecting = object.intersectsWithObject(this._objects[i]) || object.isContainedWithinObject(this._objects[i]) || this._objects[i].isContainedWithinObject(object);
                    if (isIntersecting) {
                        newIdx = i;
                        break;
                    }
                }
            } else newIdx = idx - 1;
            return newIdx;
        },
        /**
     * Moves an object or a selection up in stack of drawn objects
     * An optional parameter, intersecting allows to move the object in front
     * of the first intersecting object. Where intersection is calculated with
     * bounding box. If no intersection is found, there will not be change in the
     * stack.
     * @param {fabric.Object} object Object to send
     * @param {Boolean} [intersecting] If `true`, send object in front of next upper intersecting object
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ bringForward: function(object, intersecting) {
            if (!object) return this;
            var activeSelection = this._activeObject, i, obj, idx, newIdx, objs, objsMoved = 0;
            if (object === activeSelection && object.type === 'activeSelection') {
                objs = activeSelection._objects;
                for(i = objs.length; i--;){
                    obj = objs[i];
                    idx = this._objects.indexOf(obj);
                    if (idx < this._objects.length - 1 - objsMoved) {
                        newIdx = idx + 1;
                        removeFromArray(this._objects, obj);
                        this._objects.splice(newIdx, 0, obj);
                    }
                    objsMoved++;
                }
            } else {
                idx = this._objects.indexOf(object);
                if (idx !== this._objects.length - 1) {
                    // if object is not on top of stack (last item in an array)
                    newIdx = this._findNewUpperIndex(object, idx, intersecting);
                    removeFromArray(this._objects, object);
                    this._objects.splice(newIdx, 0, object);
                }
            }
            this.renderOnAddRemove && this.requestRenderAll();
            return this;
        },
        /**
     * @private
     */ _findNewUpperIndex: function(object, idx, intersecting) {
            var newIdx, i, len;
            if (intersecting) {
                newIdx = idx;
                // traverse up the stack looking for the nearest intersecting object
                for(i = idx + 1, len = this._objects.length; i < len; ++i){
                    var isIntersecting = object.intersectsWithObject(this._objects[i]) || object.isContainedWithinObject(this._objects[i]) || this._objects[i].isContainedWithinObject(object);
                    if (isIntersecting) {
                        newIdx = i;
                        break;
                    }
                }
            } else newIdx = idx + 1;
            return newIdx;
        },
        /**
     * Moves an object to specified level in stack of drawn objects
     * @param {fabric.Object} object Object to send
     * @param {Number} index Position to move to
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ moveTo: function(object, index) {
            removeFromArray(this._objects, object);
            this._objects.splice(index, 0, object);
            return this.renderOnAddRemove && this.requestRenderAll();
        },
        /**
     * Clears a canvas element and dispose objects
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ dispose: function() {
            // cancel eventually ongoing renders
            if (this.isRendering) {
                $79564f678731bf19$var$fabric.util.cancelAnimFrame(this.isRendering);
                this.isRendering = 0;
            }
            this.forEachObject(function(object) {
                object.dispose && object.dispose();
            });
            this._objects = [];
            if (this.backgroundImage && this.backgroundImage.dispose) this.backgroundImage.dispose();
            this.backgroundImage = null;
            if (this.overlayImage && this.overlayImage.dispose) this.overlayImage.dispose();
            this.overlayImage = null;
            this._iTextInstances = null;
            this.contextContainer = null;
            // restore canvas style
            this.lowerCanvasEl.classList.remove('lower-canvas');
            $79564f678731bf19$var$fabric.util.setStyle(this.lowerCanvasEl, this._originalCanvasStyle);
            delete this._originalCanvasStyle;
            // restore canvas size to original size in case retina scaling was applied
            this.lowerCanvasEl.setAttribute('width', this.width);
            this.lowerCanvasEl.setAttribute('height', this.height);
            $79564f678731bf19$var$fabric.util.cleanUpJsdomNode(this.lowerCanvasEl);
            this.lowerCanvasEl = undefined;
            return this;
        },
        /**
     * Returns a string representation of an instance
     * @return {String} string representation of an instance
     */ toString: function() {
            return '#<fabric.Canvas (' + this.complexity() + '): ' + '{ objects: ' + this._objects.length + ' }>';
        }
    });
    extend($79564f678731bf19$var$fabric.StaticCanvas.prototype, $79564f678731bf19$var$fabric.Observable);
    extend($79564f678731bf19$var$fabric.StaticCanvas.prototype, $79564f678731bf19$var$fabric.Collection);
    extend($79564f678731bf19$var$fabric.StaticCanvas.prototype, $79564f678731bf19$var$fabric.DataURLExporter);
    extend($79564f678731bf19$var$fabric.StaticCanvas, /** @lends fabric.StaticCanvas */ {
        /**
     * @static
     * @type String
     * @default
     */ EMPTY_JSON: '{"objects": [], "background": "white"}',
        /**
     * Provides a way to check support of some of the canvas methods
     * (either those of HTMLCanvasElement itself, or rendering context)
     *
     * @param {String} methodName Method to check support for;
     *                            Could be one of "setLineDash"
     * @return {Boolean | null} `true` if method is supported (or at least exists),
     *                          `null` if canvas element or context can not be initialized
     */ supports: function(methodName) {
            var el = createCanvasElement();
            if (!el || !el.getContext) return null;
            var ctx = el.getContext('2d');
            if (!ctx) return null;
            switch(methodName){
                case 'setLineDash':
                    return typeof ctx.setLineDash !== 'undefined';
                default:
                    return null;
            }
        }
    });
    /**
   * Returns Object representation of canvas
   * this alias is provided because if you call JSON.stringify on an instance,
   * the toJSON object will be invoked if it exists.
   * Having a toJSON method means you can do JSON.stringify(myCanvas)
   * @function
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} JSON compatible object
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#serialization}
   * @see {@link http://jsfiddle.net/fabricjs/pec86/|jsFiddle demo}
   * @example <caption>JSON without additional properties</caption>
   * var json = canvas.toJSON();
   * @example <caption>JSON with additional properties included</caption>
   * var json = canvas.toJSON(['lockMovementX', 'lockMovementY', 'lockRotation', 'lockScalingX', 'lockScalingY']);
   * @example <caption>JSON without default values</caption>
   * canvas.includeDefaultValues = false;
   * var json = canvas.toJSON();
   */ $79564f678731bf19$var$fabric.StaticCanvas.prototype.toJSON = $79564f678731bf19$var$fabric.StaticCanvas.prototype.toObject;
    if ($79564f678731bf19$var$fabric.isLikelyNode) {
        $79564f678731bf19$var$fabric.StaticCanvas.prototype.createPNGStream = function() {
            var impl = getNodeCanvas(this.lowerCanvasEl);
            return impl && impl.createPNGStream();
        };
        $79564f678731bf19$var$fabric.StaticCanvas.prototype.createJPEGStream = function(opts) {
            var impl = getNodeCanvas(this.lowerCanvasEl);
            return impl && impl.createJPEGStream(opts);
        };
    }
})();
/**
 * BaseBrush class
 * @class fabric.BaseBrush
 * @see {@link http://fabricjs.com/freedrawing|Freedrawing demo}
 */ $79564f678731bf19$var$fabric.BaseBrush = $79564f678731bf19$var$fabric.util.createClass(/** @lends fabric.BaseBrush.prototype */ {
    /**
   * Color of a brush
   * @type String
   * @default
   */ color: 'rgb(0, 0, 0)',
    /**
   * Width of a brush, has to be a Number, no string literals
   * @type Number
   * @default
   */ width: 1,
    /**
   * Shadow object representing shadow of this shape.
   * <b>Backwards incompatibility note:</b> This property replaces "shadowColor" (String), "shadowOffsetX" (Number),
   * "shadowOffsetY" (Number) and "shadowBlur" (Number) since v1.2.12
   * @type fabric.Shadow
   * @default
   */ shadow: null,
    /**
   * Line endings style of a brush (one of "butt", "round", "square")
   * @type String
   * @default
   */ strokeLineCap: 'round',
    /**
   * Corner style of a brush (one of "bevel", "round", "miter")
   * @type String
   * @default
   */ strokeLineJoin: 'round',
    /**
   * Maximum miter length (used for strokeLineJoin = "miter") of a brush's
   * @type Number
   * @default
   */ strokeMiterLimit: 10,
    /**
   * Stroke Dash Array.
   * @type Array
   * @default
   */ strokeDashArray: null,
    /**
   * When `true`, the free drawing is limited to the whiteboard size. Default to false.
   * @type Boolean
   * @default false
  */ limitedToCanvasSize: false,
    /**
   * Sets brush styles
   * @private
   * @param {CanvasRenderingContext2D} ctx
   */ _setBrushStyles: function(ctx) {
        ctx.strokeStyle = this.color;
        ctx.lineWidth = this.width;
        ctx.lineCap = this.strokeLineCap;
        ctx.miterLimit = this.strokeMiterLimit;
        ctx.lineJoin = this.strokeLineJoin;
        ctx.setLineDash(this.strokeDashArray || []);
    },
    /**
   * Sets the transformation on given context
   * @param {RenderingContext2d} ctx context to render on
   * @private
   */ _saveAndTransform: function(ctx) {
        var v = this.canvas.viewportTransform;
        ctx.save();
        ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
    },
    /**
   * Sets brush shadow styles
   * @private
   */ _setShadow: function() {
        if (!this.shadow) return;
        var canvas = this.canvas, shadow = this.shadow, ctx = canvas.contextTop, zoom = canvas.getZoom();
        if (canvas && canvas._isRetinaScaling()) zoom *= $79564f678731bf19$var$fabric.devicePixelRatio;
        ctx.shadowColor = shadow.color;
        ctx.shadowBlur = shadow.blur * zoom;
        ctx.shadowOffsetX = shadow.offsetX * zoom;
        ctx.shadowOffsetY = shadow.offsetY * zoom;
    },
    needsFullRender: function() {
        var color = new $79564f678731bf19$var$fabric.Color(this.color);
        return color.getAlpha() < 1 || !!this.shadow;
    },
    /**
   * Removes brush shadow styles
   * @private
   */ _resetShadow: function() {
        var ctx = this.canvas.contextTop;
        ctx.shadowColor = '';
        ctx.shadowBlur = ctx.shadowOffsetX = ctx.shadowOffsetY = 0;
    },
    /**
   * Check is pointer is outside canvas boundaries
   * @param {Object} pointer
   * @private
  */ _isOutSideCanvas: function(pointer) {
        return pointer.x < 0 || pointer.x > this.canvas.getWidth() || pointer.y < 0 || pointer.y > this.canvas.getHeight();
    }
});
(function() {
    /**
   * PencilBrush class
   * @class fabric.PencilBrush
   * @extends fabric.BaseBrush
   */ $79564f678731bf19$var$fabric.PencilBrush = $79564f678731bf19$var$fabric.util.createClass($79564f678731bf19$var$fabric.BaseBrush, /** @lends fabric.PencilBrush.prototype */ {
        /**
     * Discard points that are less than `decimate` pixel distant from each other
     * @type Number
     * @default 0.4
     */ decimate: 0.4,
        /**
     * Draws a straight line between last recorded point to current pointer
     * Used for `shift` functionality
     *
     * @type boolean
     * @default false
     */ drawStraightLine: false,
        /**
     * The event modifier key that makes the brush draw a straight line.
     * If `null` or 'none' or any other string that is not a modifier key the feature is disabled.
     * @type {'altKey' | 'shiftKey' | 'ctrlKey' | 'none' | undefined | null}
     */ straightLineKey: 'shiftKey',
        /**
     * Constructor
     * @param {fabric.Canvas} canvas
     * @return {fabric.PencilBrush} Instance of a pencil brush
     */ initialize: function(canvas) {
            this.canvas = canvas;
            this._points = [];
        },
        needsFullRender: function() {
            return this.callSuper('needsFullRender') || this._hasStraightLine;
        },
        /**
     * Invoked inside on mouse down and mouse move
     * @param {Object} pointer
     */ _drawSegment: function(ctx, p1, p2) {
            var midPoint = p1.midPointFrom(p2);
            ctx.quadraticCurveTo(p1.x, p1.y, midPoint.x, midPoint.y);
            return midPoint;
        },
        /**
     * Invoked on mouse down
     * @param {Object} pointer
     */ onMouseDown: function(pointer, options) {
            if (!this.canvas._isMainEvent(options.e)) return;
            this.drawStraightLine = options.e[this.straightLineKey];
            this._prepareForDrawing(pointer);
            // capture coordinates immediately
            // this allows to draw dots (when movement never occurs)
            this._captureDrawingPath(pointer);
            this._render();
        },
        /**
     * Invoked on mouse move
     * @param {Object} pointer
     */ onMouseMove: function(pointer, options) {
            if (!this.canvas._isMainEvent(options.e)) return;
            this.drawStraightLine = options.e[this.straightLineKey];
            if (this.limitedToCanvasSize === true && this._isOutSideCanvas(pointer)) return;
            if (this._captureDrawingPath(pointer) && this._points.length > 1) {
                if (this.needsFullRender()) {
                    // redraw curve
                    // clear top canvas
                    this.canvas.clearContext(this.canvas.contextTop);
                    this._render();
                } else {
                    var points = this._points, length = points.length, ctx = this.canvas.contextTop;
                    // draw the curve update
                    this._saveAndTransform(ctx);
                    if (this.oldEnd) {
                        ctx.beginPath();
                        ctx.moveTo(this.oldEnd.x, this.oldEnd.y);
                    }
                    this.oldEnd = this._drawSegment(ctx, points[length - 2], points[length - 1], true);
                    ctx.stroke();
                    ctx.restore();
                }
            }
        },
        /**
     * Invoked on mouse up
     */ onMouseUp: function(options) {
            if (!this.canvas._isMainEvent(options.e)) return true;
            this.drawStraightLine = false;
            this.oldEnd = undefined;
            this._finalizeAndAddPath();
            return false;
        },
        /**
     * @private
     * @param {Object} pointer Actual mouse position related to the canvas.
     */ _prepareForDrawing: function(pointer) {
            var p = new $79564f678731bf19$var$fabric.Point(pointer.x, pointer.y);
            this._reset();
            this._addPoint(p);
            this.canvas.contextTop.moveTo(p.x, p.y);
        },
        /**
     * @private
     * @param {fabric.Point} point Point to be added to points array
     */ _addPoint: function(point) {
            if (this._points.length > 1 && point.eq(this._points[this._points.length - 1])) return false;
            if (this.drawStraightLine && this._points.length > 1) {
                this._hasStraightLine = true;
                this._points.pop();
            }
            this._points.push(point);
            return true;
        },
        /**
     * Clear points array and set contextTop canvas style.
     * @private
     */ _reset: function() {
            this._points = [];
            this._setBrushStyles(this.canvas.contextTop);
            this._setShadow();
            this._hasStraightLine = false;
        },
        /**
     * @private
     * @param {Object} pointer Actual mouse position related to the canvas.
     */ _captureDrawingPath: function(pointer) {
            var pointerPoint = new $79564f678731bf19$var$fabric.Point(pointer.x, pointer.y);
            return this._addPoint(pointerPoint);
        },
        /**
     * Draw a smooth path on the topCanvas using quadraticCurveTo
     * @private
     * @param {CanvasRenderingContext2D} [ctx]
     */ _render: function(ctx) {
            var i, len, p1 = this._points[0], p2 = this._points[1];
            ctx = ctx || this.canvas.contextTop;
            this._saveAndTransform(ctx);
            ctx.beginPath();
            //if we only have 2 points in the path and they are the same
            //it means that the user only clicked the canvas without moving the mouse
            //then we should be drawing a dot. A path isn't drawn between two identical dots
            //that's why we set them apart a bit
            if (this._points.length === 2 && p1.x === p2.x && p1.y === p2.y) {
                var width = this.width / 1000;
                p1 = new $79564f678731bf19$var$fabric.Point(p1.x, p1.y);
                p2 = new $79564f678731bf19$var$fabric.Point(p2.x, p2.y);
                p1.x -= width;
                p2.x += width;
            }
            ctx.moveTo(p1.x, p1.y);
            for(i = 1, len = this._points.length; i < len; i++){
                // we pick the point between pi + 1 & pi + 2 as the
                // end point and p1 as our control point.
                this._drawSegment(ctx, p1, p2);
                p1 = this._points[i];
                p2 = this._points[i + 1];
            }
            // Draw last line as a straight line while
            // we wait for the next point to be able to calculate
            // the bezier control point
            ctx.lineTo(p1.x, p1.y);
            ctx.stroke();
            ctx.restore();
        },
        /**
     * Converts points to SVG path
     * @param {Array} points Array of points
     * @return {(string|number)[][]} SVG path commands
     */ convertPointsToSVGPath: function(points) {
            var correction = this.width / 1000;
            return $79564f678731bf19$var$fabric.util.getSmoothPathFromPoints(points, correction);
        },
        /**
     * @private
     * @param {(string|number)[][]} pathData SVG path commands
     * @returns {boolean}
     */ _isEmptySVGPath: function(pathData) {
            var pathString = $79564f678731bf19$var$fabric.util.joinPath(pathData);
            return pathString === 'M 0 0 Q 0 0 0 0 L 0 0';
        },
        /**
     * Creates fabric.Path object to add on canvas
     * @param {(string|number)[][]} pathData Path data
     * @return {fabric.Path} Path to add on canvas
     */ createPath: function(pathData) {
            var path = new $79564f678731bf19$var$fabric.Path(pathData, {
                fill: null,
                stroke: this.color,
                strokeWidth: this.width,
                strokeLineCap: this.strokeLineCap,
                strokeMiterLimit: this.strokeMiterLimit,
                strokeLineJoin: this.strokeLineJoin,
                strokeDashArray: this.strokeDashArray
            });
            if (this.shadow) {
                this.shadow.affectStroke = true;
                path.shadow = new $79564f678731bf19$var$fabric.Shadow(this.shadow);
            }
            return path;
        },
        /**
     * Decimate points array with the decimate value
     */ decimatePoints: function(points, distance) {
            if (points.length <= 2) return points;
            var zoom = this.canvas.getZoom(), adjustedDistance = Math.pow(distance / zoom, 2), i, l = points.length - 1, lastPoint = points[0], newPoints = [
                lastPoint
            ], cDistance;
            for(i = 1; i < l - 1; i++){
                cDistance = Math.pow(lastPoint.x - points[i].x, 2) + Math.pow(lastPoint.y - points[i].y, 2);
                if (cDistance >= adjustedDistance) {
                    lastPoint = points[i];
                    newPoints.push(lastPoint);
                }
            }
            /**
       * Add the last point from the original line to the end of the array.
       * This ensures decimate doesn't delete the last point on the line, and ensures the line is > 1 point.
       */ newPoints.push(points[l]);
            return newPoints;
        },
        /**
     * On mouseup after drawing the path on contextTop canvas
     * we use the points captured to create an new fabric path object
     * and add it to the fabric canvas.
     */ _finalizeAndAddPath: function() {
            var ctx = this.canvas.contextTop;
            ctx.closePath();
            if (this.decimate) this._points = this.decimatePoints(this._points, this.decimate);
            var pathData = this.convertPointsToSVGPath(this._points);
            if (this._isEmptySVGPath(pathData)) {
                // do not create 0 width/height paths, as they are
                // rendered inconsistently across browsers
                // Firefox 4, for example, renders a dot,
                // whereas Chrome 10 renders nothing
                this.canvas.requestRenderAll();
                return;
            }
            var path = this.createPath(pathData);
            this.canvas.clearContext(this.canvas.contextTop);
            this.canvas.fire('before:path:created', {
                path: path
            });
            this.canvas.add(path);
            this.canvas.requestRenderAll();
            path.setCoords();
            this._resetShadow();
            // fire event 'path' created
            this.canvas.fire('path:created', {
                path: path
            });
        }
    });
})();
/**
 * CircleBrush class
 * @class fabric.CircleBrush
 */ $79564f678731bf19$var$fabric.CircleBrush = $79564f678731bf19$var$fabric.util.createClass($79564f678731bf19$var$fabric.BaseBrush, /** @lends fabric.CircleBrush.prototype */ {
    /**
   * Width of a brush
   * @type Number
   * @default
   */ width: 10,
    /**
   * Constructor
   * @param {fabric.Canvas} canvas
   * @return {fabric.CircleBrush} Instance of a circle brush
   */ initialize: function(canvas) {
        this.canvas = canvas;
        this.points = [];
    },
    /**
   * Invoked inside on mouse down and mouse move
   * @param {Object} pointer
   */ drawDot: function(pointer) {
        var point = this.addPoint(pointer), ctx = this.canvas.contextTop;
        this._saveAndTransform(ctx);
        this.dot(ctx, point);
        ctx.restore();
    },
    dot: function(ctx, point) {
        ctx.fillStyle = point.fill;
        ctx.beginPath();
        ctx.arc(point.x, point.y, point.radius, 0, Math.PI * 2, false);
        ctx.closePath();
        ctx.fill();
    },
    /**
   * Invoked on mouse down
   */ onMouseDown: function(pointer) {
        this.points.length = 0;
        this.canvas.clearContext(this.canvas.contextTop);
        this._setShadow();
        this.drawDot(pointer);
    },
    /**
   * Render the full state of the brush
   * @private
   */ _render: function() {
        var ctx = this.canvas.contextTop, i, len, points = this.points;
        this._saveAndTransform(ctx);
        for(i = 0, len = points.length; i < len; i++)this.dot(ctx, points[i]);
        ctx.restore();
    },
    /**
   * Invoked on mouse move
   * @param {Object} pointer
   */ onMouseMove: function(pointer) {
        if (this.limitedToCanvasSize === true && this._isOutSideCanvas(pointer)) return;
        if (this.needsFullRender()) {
            this.canvas.clearContext(this.canvas.contextTop);
            this.addPoint(pointer);
            this._render();
        } else this.drawDot(pointer);
    },
    /**
   * Invoked on mouse up
   */ onMouseUp: function() {
        var originalRenderOnAddRemove = this.canvas.renderOnAddRemove, i, len;
        this.canvas.renderOnAddRemove = false;
        var circles = [];
        for(i = 0, len = this.points.length; i < len; i++){
            var point = this.points[i], circle = new $79564f678731bf19$var$fabric.Circle({
                radius: point.radius,
                left: point.x,
                top: point.y,
                originX: 'center',
                originY: 'center',
                fill: point.fill
            });
            this.shadow && (circle.shadow = new $79564f678731bf19$var$fabric.Shadow(this.shadow));
            circles.push(circle);
        }
        var group = new $79564f678731bf19$var$fabric.Group(circles);
        group.canvas = this.canvas;
        this.canvas.fire('before:path:created', {
            path: group
        });
        this.canvas.add(group);
        this.canvas.fire('path:created', {
            path: group
        });
        this.canvas.clearContext(this.canvas.contextTop);
        this._resetShadow();
        this.canvas.renderOnAddRemove = originalRenderOnAddRemove;
        this.canvas.requestRenderAll();
    },
    /**
   * @param {Object} pointer
   * @return {fabric.Point} Just added pointer point
   */ addPoint: function(pointer) {
        var pointerPoint = new $79564f678731bf19$var$fabric.Point(pointer.x, pointer.y), circleRadius = $79564f678731bf19$var$fabric.util.getRandomInt(Math.max(0, this.width - 20), this.width + 20) / 2, circleColor = new $79564f678731bf19$var$fabric.Color(this.color).setAlpha($79564f678731bf19$var$fabric.util.getRandomInt(0, 100) / 100).toRgba();
        pointerPoint.radius = circleRadius;
        pointerPoint.fill = circleColor;
        this.points.push(pointerPoint);
        return pointerPoint;
    }
});
/**
 * SprayBrush class
 * @class fabric.SprayBrush
 */ $79564f678731bf19$var$fabric.SprayBrush = $79564f678731bf19$var$fabric.util.createClass($79564f678731bf19$var$fabric.BaseBrush, /** @lends fabric.SprayBrush.prototype */ {
    /**
   * Width of a spray
   * @type Number
   * @default
   */ width: 10,
    /**
   * Density of a spray (number of dots per chunk)
   * @type Number
   * @default
   */ density: 20,
    /**
   * Width of spray dots
   * @type Number
   * @default
   */ dotWidth: 1,
    /**
   * Width variance of spray dots
   * @type Number
   * @default
   */ dotWidthVariance: 1,
    /**
   * Whether opacity of a dot should be random
   * @type Boolean
   * @default
   */ randomOpacity: false,
    /**
   * Whether overlapping dots (rectangles) should be removed (for performance reasons)
   * @type Boolean
   * @default
   */ optimizeOverlapping: true,
    /**
   * Constructor
   * @param {fabric.Canvas} canvas
   * @return {fabric.SprayBrush} Instance of a spray brush
   */ initialize: function(canvas) {
        this.canvas = canvas;
        this.sprayChunks = [];
    },
    /**
   * Invoked on mouse down
   * @param {Object} pointer
   */ onMouseDown: function(pointer) {
        this.sprayChunks.length = 0;
        this.canvas.clearContext(this.canvas.contextTop);
        this._setShadow();
        this.addSprayChunk(pointer);
        this.render(this.sprayChunkPoints);
    },
    /**
   * Invoked on mouse move
   * @param {Object} pointer
   */ onMouseMove: function(pointer) {
        if (this.limitedToCanvasSize === true && this._isOutSideCanvas(pointer)) return;
        this.addSprayChunk(pointer);
        this.render(this.sprayChunkPoints);
    },
    /**
   * Invoked on mouse up
   */ onMouseUp: function() {
        var originalRenderOnAddRemove = this.canvas.renderOnAddRemove;
        this.canvas.renderOnAddRemove = false;
        var rects = [];
        for(var i = 0, ilen = this.sprayChunks.length; i < ilen; i++){
            var sprayChunk = this.sprayChunks[i];
            for(var j = 0, jlen = sprayChunk.length; j < jlen; j++){
                var rect = new $79564f678731bf19$var$fabric.Rect({
                    width: sprayChunk[j].width,
                    height: sprayChunk[j].width,
                    left: sprayChunk[j].x + 1,
                    top: sprayChunk[j].y + 1,
                    originX: 'center',
                    originY: 'center',
                    fill: this.color
                });
                rects.push(rect);
            }
        }
        if (this.optimizeOverlapping) rects = this._getOptimizedRects(rects);
        var group = new $79564f678731bf19$var$fabric.Group(rects);
        this.shadow && group.set('shadow', new $79564f678731bf19$var$fabric.Shadow(this.shadow));
        this.canvas.fire('before:path:created', {
            path: group
        });
        this.canvas.add(group);
        this.canvas.fire('path:created', {
            path: group
        });
        this.canvas.clearContext(this.canvas.contextTop);
        this._resetShadow();
        this.canvas.renderOnAddRemove = originalRenderOnAddRemove;
        this.canvas.requestRenderAll();
    },
    /**
   * @private
   * @param {Array} rects
   */ _getOptimizedRects: function(rects) {
        // avoid creating duplicate rects at the same coordinates
        var uniqueRects = {}, key, i, len;
        for(i = 0, len = rects.length; i < len; i++){
            key = rects[i].left + '' + rects[i].top;
            if (!uniqueRects[key]) uniqueRects[key] = rects[i];
        }
        var uniqueRectsArray = [];
        for(key in uniqueRects)uniqueRectsArray.push(uniqueRects[key]);
        return uniqueRectsArray;
    },
    /**
   * Render new chunk of spray brush
   */ render: function(sprayChunk) {
        var ctx = this.canvas.contextTop, i, len;
        ctx.fillStyle = this.color;
        this._saveAndTransform(ctx);
        for(i = 0, len = sprayChunk.length; i < len; i++){
            var point = sprayChunk[i];
            if (typeof point.opacity !== 'undefined') ctx.globalAlpha = point.opacity;
            ctx.fillRect(point.x, point.y, point.width, point.width);
        }
        ctx.restore();
    },
    /**
   * Render all spray chunks
   */ _render: function() {
        var ctx = this.canvas.contextTop, i, ilen;
        ctx.fillStyle = this.color;
        this._saveAndTransform(ctx);
        for(i = 0, ilen = this.sprayChunks.length; i < ilen; i++)this.render(this.sprayChunks[i]);
        ctx.restore();
    },
    /**
   * @param {Object} pointer
   */ addSprayChunk: function(pointer) {
        this.sprayChunkPoints = [];
        var x, y, width, radius = this.width / 2, i;
        for(i = 0; i < this.density; i++){
            x = $79564f678731bf19$var$fabric.util.getRandomInt(pointer.x - radius, pointer.x + radius);
            y = $79564f678731bf19$var$fabric.util.getRandomInt(pointer.y - radius, pointer.y + radius);
            if (this.dotWidthVariance) width = $79564f678731bf19$var$fabric.util.getRandomInt(// bottom clamp width to 1
            Math.max(1, this.dotWidth - this.dotWidthVariance), this.dotWidth + this.dotWidthVariance);
            else width = this.dotWidth;
            var point = new $79564f678731bf19$var$fabric.Point(x, y);
            point.width = width;
            if (this.randomOpacity) point.opacity = $79564f678731bf19$var$fabric.util.getRandomInt(0, 100) / 100;
            this.sprayChunkPoints.push(point);
        }
        this.sprayChunks.push(this.sprayChunkPoints);
    }
});
/**
 * PatternBrush class
 * @class fabric.PatternBrush
 * @extends fabric.BaseBrush
 */ $79564f678731bf19$var$fabric.PatternBrush = $79564f678731bf19$var$fabric.util.createClass($79564f678731bf19$var$fabric.PencilBrush, /** @lends fabric.PatternBrush.prototype */ {
    getPatternSrc: function() {
        var dotWidth = 20, dotDistance = 5, patternCanvas = $79564f678731bf19$var$fabric.util.createCanvasElement(), patternCtx = patternCanvas.getContext('2d');
        patternCanvas.width = patternCanvas.height = dotWidth + dotDistance;
        patternCtx.fillStyle = this.color;
        patternCtx.beginPath();
        patternCtx.arc(dotWidth / 2, dotWidth / 2, dotWidth / 2, 0, Math.PI * 2, false);
        patternCtx.closePath();
        patternCtx.fill();
        return patternCanvas;
    },
    getPatternSrcFunction: function() {
        return String(this.getPatternSrc).replace('this.color', '"' + this.color + '"');
    },
    /**
   * Creates "pattern" instance property
   * @param {CanvasRenderingContext2D} ctx
   */ getPattern: function(ctx) {
        return ctx.createPattern(this.source || this.getPatternSrc(), 'repeat');
    },
    /**
   * Sets brush styles
   * @param {CanvasRenderingContext2D} ctx
   */ _setBrushStyles: function(ctx) {
        this.callSuper('_setBrushStyles', ctx);
        ctx.strokeStyle = this.getPattern(ctx);
    },
    /**
   * Creates path
   */ createPath: function(pathData) {
        var path = this.callSuper('createPath', pathData), topLeft = path._getLeftTopCoords().scalarAdd(path.strokeWidth / 2);
        path.stroke = new $79564f678731bf19$var$fabric.Pattern({
            source: this.source || this.getPatternSrcFunction(),
            offsetX: -topLeft.x,
            offsetY: -topLeft.y
        });
        return path;
    }
});
(function() {
    var getPointer = $79564f678731bf19$var$fabric.util.getPointer, degreesToRadians = $79564f678731bf19$var$fabric.util.degreesToRadians, isTouchEvent = $79564f678731bf19$var$fabric.util.isTouchEvent;
    /**
   * Canvas class
   * @class fabric.Canvas
   * @extends fabric.StaticCanvas
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#canvas}
   * @see {@link fabric.Canvas#initialize} for constructor definition
   *
   * @fires object:modified at the end of a transform or any change when statefull is true
   * @fires object:rotating while an object is being rotated from the control
   * @fires object:scaling while an object is being scaled by controls
   * @fires object:moving while an object is being dragged
   * @fires object:skewing while an object is being skewed from the controls
   *
   * @fires before:transform before a transform is is started
   * @fires before:selection:cleared
   * @fires selection:cleared
   * @fires selection:updated
   * @fires selection:created
   *
   * @fires path:created after a drawing operation ends and the path is added
   * @fires mouse:down
   * @fires mouse:move
   * @fires mouse:up
   * @fires mouse:down:before  on mouse down, before the inner fabric logic runs
   * @fires mouse:move:before on mouse move, before the inner fabric logic runs
   * @fires mouse:up:before on mouse up, before the inner fabric logic runs
   * @fires mouse:over
   * @fires mouse:out
   * @fires mouse:dblclick whenever a native dbl click event fires on the canvas.
   *
   * @fires dragover
   * @fires dragenter
   * @fires dragleave
   * @fires drop:before before drop event. same native event. This is added to handle edge cases
   * @fires drop
   * @fires after:render at the end of the render process, receives the context in the callback
   * @fires before:render at start the render process, receives the context in the callback
   *
   */ $79564f678731bf19$var$fabric.Canvas = $79564f678731bf19$var$fabric.util.createClass($79564f678731bf19$var$fabric.StaticCanvas, /** @lends fabric.Canvas.prototype */ {
        /**
     * Constructor
     * @param {HTMLElement | String} el &lt;canvas> element to initialize instance on
     * @param {Object} [options] Options object
     * @return {Object} thisArg
     */ initialize: function(el, options) {
            options || (options = {});
            this.renderAndResetBound = this.renderAndReset.bind(this);
            this.requestRenderAllBound = this.requestRenderAll.bind(this);
            this._initStatic(el, options);
            this._initInteractive();
            this._createCacheCanvas();
        },
        /**
     * When true, objects can be transformed by one side (unproportionally)
     * when dragged on the corners that normally would not do that.
     * @type Boolean
     * @default
     * @since fabric 4.0 // changed name and default value
     */ uniformScaling: true,
        /**
     * Indicates which key switches uniform scaling.
     * values: 'altKey', 'shiftKey', 'ctrlKey'.
     * If `null` or 'none' or any other string that is not a modifier key
     * feature is disabled.
     * totally wrong named. this sounds like `uniform scaling`
     * if Canvas.uniformScaling is true, pressing this will set it to false
     * and viceversa.
     * @since 1.6.2
     * @type String
     * @default
     */ uniScaleKey: 'shiftKey',
        /**
     * When true, objects use center point as the origin of scale transformation.
     * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
     * @since 1.3.4
     * @type Boolean
     * @default
     */ centeredScaling: false,
        /**
     * When true, objects use center point as the origin of rotate transformation.
     * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
     * @since 1.3.4
     * @type Boolean
     * @default
     */ centeredRotation: false,
        /**
     * Indicates which key enable centered Transform
     * values: 'altKey', 'shiftKey', 'ctrlKey'.
     * If `null` or 'none' or any other string that is not a modifier key
     * feature is disabled feature disabled.
     * @since 1.6.2
     * @type String
     * @default
     */ centeredKey: 'altKey',
        /**
     * Indicates which key enable alternate action on corner
     * values: 'altKey', 'shiftKey', 'ctrlKey'.
     * If `null` or 'none' or any other string that is not a modifier key
     * feature is disabled feature disabled.
     * @since 1.6.2
     * @type String
     * @default
     */ altActionKey: 'shiftKey',
        /**
     * Indicates that canvas is interactive. This property should not be changed.
     * @type Boolean
     * @default
     */ interactive: true,
        /**
     * Indicates whether group selection should be enabled
     * @type Boolean
     * @default
     */ selection: true,
        /**
     * Indicates which key or keys enable multiple click selection
     * Pass value as a string or array of strings
     * values: 'altKey', 'shiftKey', 'ctrlKey'.
     * If `null` or empty or containing any other string that is not a modifier key
     * feature is disabled.
     * @since 1.6.2
     * @type String|Array
     * @default
     */ selectionKey: 'shiftKey',
        /**
     * Indicates which key enable alternative selection
     * in case of target overlapping with active object
     * values: 'altKey', 'shiftKey', 'ctrlKey'.
     * For a series of reason that come from the general expectations on how
     * things should work, this feature works only for preserveObjectStacking true.
     * If `null` or 'none' or any other string that is not a modifier key
     * feature is disabled.
     * @since 1.6.5
     * @type null|String
     * @default
     */ altSelectionKey: null,
        /**
     * Color of selection
     * @type String
     * @default
     */ selectionColor: 'rgba(100, 100, 255, 0.3)',
        /**
     * Default dash array pattern
     * If not empty the selection border is dashed
     * @type Array
     */ selectionDashArray: [],
        /**
     * Color of the border of selection (usually slightly darker than color of selection itself)
     * @type String
     * @default
     */ selectionBorderColor: 'rgba(255, 255, 255, 0.3)',
        /**
     * Width of a line used in object/group selection
     * @type Number
     * @default
     */ selectionLineWidth: 1,
        /**
     * Select only shapes that are fully contained in the dragged selection rectangle.
     * @type Boolean
     * @default
     */ selectionFullyContained: false,
        /**
     * Default cursor value used when hovering over an object on canvas
     * @type String
     * @default
     */ hoverCursor: 'move',
        /**
     * Default cursor value used when moving an object on canvas
     * @type String
     * @default
     */ moveCursor: 'move',
        /**
     * Default cursor value used for the entire canvas
     * @type String
     * @default
     */ defaultCursor: 'default',
        /**
     * Cursor value used during free drawing
     * @type String
     * @default
     */ freeDrawingCursor: 'crosshair',
        /**
     * Cursor value used for disabled elements ( corners with disabled action )
     * @type String
     * @since 2.0.0
     * @default
     */ notAllowedCursor: 'not-allowed',
        /**
     * Default element class that's given to wrapper (div) element of canvas
     * @type String
     * @default
     */ containerClass: 'canvas-container',
        /**
     * When true, object detection happens on per-pixel basis rather than on per-bounding-box
     * @type Boolean
     * @default
     */ perPixelTargetFind: false,
        /**
     * Number of pixels around target pixel to tolerate (consider active) during object detection
     * @type Number
     * @default
     */ targetFindTolerance: 0,
        /**
     * When true, target detection is skipped. Target detection will return always undefined.
     * click selection won't work anymore, events will fire with no targets.
     * if something is selected before setting it to true, it will be deselected at the first click.
     * area selection will still work. check the `selection` property too.
     * if you deactivate both, you should look into staticCanvas.
     * @type Boolean
     * @default
     */ skipTargetFind: false,
        /**
     * When true, mouse events on canvas (mousedown/mousemove/mouseup) result in free drawing.
     * After mousedown, mousemove creates a shape,
     * and then mouseup finalizes it and adds an instance of `fabric.Path` onto canvas.
     * @tutorial {@link http://fabricjs.com/fabric-intro-part-4#free_drawing}
     * @type Boolean
     * @default
     */ isDrawingMode: false,
        /**
     * Indicates whether objects should remain in current stack position when selected.
     * When false objects are brought to top and rendered as part of the selection group
     * @type Boolean
     * @default
     */ preserveObjectStacking: false,
        /**
     * Indicates the angle that an object will lock to while rotating.
     * @type Number
     * @since 1.6.7
     * @default
     */ snapAngle: 0,
        /**
     * Indicates the distance from the snapAngle the rotation will lock to the snapAngle.
     * When `null`, the snapThreshold will default to the snapAngle.
     * @type null|Number
     * @since 1.6.7
     * @default
     */ snapThreshold: null,
        /**
     * Indicates if the right click on canvas can output the context menu or not
     * @type Boolean
     * @since 1.6.5
     * @default
     */ stopContextMenu: false,
        /**
     * Indicates if the canvas can fire right click events
     * @type Boolean
     * @since 1.6.5
     * @default
     */ fireRightClick: false,
        /**
     * Indicates if the canvas can fire middle click events
     * @type Boolean
     * @since 1.7.8
     * @default
     */ fireMiddleClick: false,
        /**
     * Keep track of the subTargets for Mouse Events
     * @type fabric.Object[]
     */ targets: [],
        /**
     * When the option is enabled, PointerEvent is used instead of MouseEvent.
     * @type Boolean
     * @default
     */ enablePointerEvents: false,
        /**
     * Keep track of the hovered target
     * @type fabric.Object
     * @private
     */ _hoveredTarget: null,
        /**
     * hold the list of nested targets hovered
     * @type fabric.Object[]
     * @private
     */ _hoveredTargets: [],
        /**
     * @private
     */ _initInteractive: function() {
            this._currentTransform = null;
            this._groupSelector = null;
            this._initWrapperElement();
            this._createUpperCanvas();
            this._initEventListeners();
            this._initRetinaScaling();
            this.freeDrawingBrush = $79564f678731bf19$var$fabric.PencilBrush && new $79564f678731bf19$var$fabric.PencilBrush(this);
            this.calcOffset();
        },
        /**
     * Divides objects in two groups, one to render immediately
     * and one to render as activeGroup.
     * @return {Array} objects to render immediately and pushes the other in the activeGroup.
     */ _chooseObjectsToRender: function() {
            var activeObjects = this.getActiveObjects(), object, objsToRender, activeGroupObjects;
            if (activeObjects.length > 0 && !this.preserveObjectStacking) {
                objsToRender = [];
                activeGroupObjects = [];
                for(var i = 0, length = this._objects.length; i < length; i++){
                    object = this._objects[i];
                    if (activeObjects.indexOf(object) === -1) objsToRender.push(object);
                    else activeGroupObjects.push(object);
                }
                if (activeObjects.length > 1) this._activeObject._objects = activeGroupObjects;
                objsToRender.push.apply(objsToRender, activeGroupObjects);
            } else objsToRender = this._objects;
            return objsToRender;
        },
        /**
     * Renders both the top canvas and the secondary container canvas.
     * @return {fabric.Canvas} instance
     * @chainable
     */ renderAll: function() {
            if (this.contextTopDirty && !this._groupSelector && !this.isDrawingMode) {
                this.clearContext(this.contextTop);
                this.contextTopDirty = false;
            }
            if (this.hasLostContext) {
                this.renderTopLayer(this.contextTop);
                this.hasLostContext = false;
            }
            var canvasToDrawOn = this.contextContainer;
            this.renderCanvas(canvasToDrawOn, this._chooseObjectsToRender());
            return this;
        },
        renderTopLayer: function(ctx) {
            ctx.save();
            if (this.isDrawingMode && this._isCurrentlyDrawing) {
                this.freeDrawingBrush && this.freeDrawingBrush._render();
                this.contextTopDirty = true;
            }
            // we render the top context - last object
            if (this.selection && this._groupSelector) {
                this._drawSelection(ctx);
                this.contextTopDirty = true;
            }
            ctx.restore();
        },
        /**
     * Method to render only the top canvas.
     * Also used to render the group selection box.
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ renderTop: function() {
            var ctx = this.contextTop;
            this.clearContext(ctx);
            this.renderTopLayer(ctx);
            this.fire('after:render');
            return this;
        },
        /**
     * @private
     */ _normalizePointer: function(object, pointer) {
            var m = object.calcTransformMatrix(), invertedM = $79564f678731bf19$var$fabric.util.invertTransform(m), vptPointer = this.restorePointerVpt(pointer);
            return $79564f678731bf19$var$fabric.util.transformPoint(vptPointer, invertedM);
        },
        /**
     * Returns true if object is transparent at a certain location
     * @param {fabric.Object} target Object to check
     * @param {Number} x Left coordinate
     * @param {Number} y Top coordinate
     * @return {Boolean}
     */ isTargetTransparent: function(target, x, y) {
            // in case the target is the activeObject, we cannot execute this optimization
            // because we need to draw controls too.
            if (target.shouldCache() && target._cacheCanvas && target !== this._activeObject) {
                var normalizedPointer = this._normalizePointer(target, {
                    x: x,
                    y: y
                }), targetRelativeX = Math.max(target.cacheTranslationX + normalizedPointer.x * target.zoomX, 0), targetRelativeY = Math.max(target.cacheTranslationY + normalizedPointer.y * target.zoomY, 0);
                var isTransparent = $79564f678731bf19$var$fabric.util.isTransparent(target._cacheContext, Math.round(targetRelativeX), Math.round(targetRelativeY), this.targetFindTolerance);
                return isTransparent;
            }
            var ctx = this.contextCache, originalColor = target.selectionBackgroundColor, v = this.viewportTransform;
            target.selectionBackgroundColor = '';
            this.clearContext(ctx);
            ctx.save();
            ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
            target.render(ctx);
            ctx.restore();
            target.selectionBackgroundColor = originalColor;
            var isTransparent = $79564f678731bf19$var$fabric.util.isTransparent(ctx, x, y, this.targetFindTolerance);
            return isTransparent;
        },
        /**
     * takes an event and determines if selection key has been pressed
     * @private
     * @param {Event} e Event object
     */ _isSelectionKeyPressed: function(e) {
            var selectionKeyPressed = false;
            if (Array.isArray(this.selectionKey)) selectionKeyPressed = !!this.selectionKey.find(function(key) {
                return e[key] === true;
            });
            else selectionKeyPressed = e[this.selectionKey];
            return selectionKeyPressed;
        },
        /**
     * @private
     * @param {Event} e Event object
     * @param {fabric.Object} target
     */ _shouldClearSelection: function(e, target) {
            var activeObjects = this.getActiveObjects(), activeObject = this._activeObject;
            return !target || target && activeObject && activeObjects.length > 1 && activeObjects.indexOf(target) === -1 && activeObject !== target && !this._isSelectionKeyPressed(e) || target && !target.evented || target && !target.selectable && activeObject && activeObject !== target;
        },
        /**
     * centeredScaling from object can't override centeredScaling from canvas.
     * this should be fixed, since object setting should take precedence over canvas.
     * also this should be something that will be migrated in the control properties.
     * as ability to define the origin of the transformation that the control provide.
     * @private
     * @param {fabric.Object} target
     * @param {String} action
     * @param {Boolean} altKey
     */ _shouldCenterTransform: function(target, action, altKey) {
            if (!target) return;
            var centerTransform;
            if (action === 'scale' || action === 'scaleX' || action === 'scaleY' || action === 'resizing') centerTransform = this.centeredScaling || target.centeredScaling;
            else if (action === 'rotate') centerTransform = this.centeredRotation || target.centeredRotation;
            return centerTransform ? !altKey : altKey;
        },
        /**
     * should disappear before release 4.0
     * @private
     */ _getOriginFromCorner: function(target, corner) {
            var origin = {
                x: target.originX,
                y: target.originY
            };
            if (corner === 'ml' || corner === 'tl' || corner === 'bl') origin.x = 'right';
            else if (corner === 'mr' || corner === 'tr' || corner === 'br') origin.x = 'left';
            if (corner === 'tl' || corner === 'mt' || corner === 'tr') origin.y = 'bottom';
            else if (corner === 'bl' || corner === 'mb' || corner === 'br') origin.y = 'top';
            return origin;
        },
        /**
     * @private
     * @param {Boolean} alreadySelected true if target is already selected
     * @param {String} corner a string representing the corner ml, mr, tl ...
     * @param {Event} e Event object
     * @param {fabric.Object} [target] inserted back to help overriding. Unused
     */ _getActionFromCorner: function(alreadySelected, corner, e, target) {
            if (!corner || !alreadySelected) return 'drag';
            var control = target.controls[corner];
            return control.getActionName(e, control, target);
        },
        /**
     * @private
     * @param {Event} e Event object
     * @param {fabric.Object} target
     */ _setupCurrentTransform: function(e, target, alreadySelected) {
            if (!target) return;
            var pointer = this.getPointer(e), corner = target.__corner, control = target.controls[corner], actionHandler = alreadySelected && corner ? control.getActionHandler(e, target, control) : $79564f678731bf19$var$fabric.controlsUtils.dragHandler, action = this._getActionFromCorner(alreadySelected, corner, e, target), origin = this._getOriginFromCorner(target, corner), altKey = e[this.centeredKey], transform = {
                target: target,
                action: action,
                actionHandler: actionHandler,
                corner: corner,
                scaleX: target.scaleX,
                scaleY: target.scaleY,
                skewX: target.skewX,
                skewY: target.skewY,
                // used by transation
                offsetX: pointer.x - target.left,
                offsetY: pointer.y - target.top,
                originX: origin.x,
                originY: origin.y,
                ex: pointer.x,
                ey: pointer.y,
                lastX: pointer.x,
                lastY: pointer.y,
                // unsure they are useful anymore.
                // left: target.left,
                // top: target.top,
                theta: degreesToRadians(target.angle),
                // end of unsure
                width: target.width * target.scaleX,
                shiftKey: e.shiftKey,
                altKey: altKey,
                original: $79564f678731bf19$var$fabric.util.saveObjectTransform(target)
            };
            if (this._shouldCenterTransform(target, action, altKey)) {
                transform.originX = 'center';
                transform.originY = 'center';
            }
            transform.original.originX = origin.x;
            transform.original.originY = origin.y;
            this._currentTransform = transform;
            this._beforeTransform(e);
        },
        /**
     * Set the cursor type of the canvas element
     * @param {String} value Cursor type of the canvas element.
     * @see http://www.w3.org/TR/css3-ui/#cursor
     */ setCursor: function(value) {
            this.upperCanvasEl.style.cursor = value;
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx to draw the selection on
     */ _drawSelection: function(ctx) {
            var selector = this._groupSelector, viewportStart = new $79564f678731bf19$var$fabric.Point(selector.ex, selector.ey), start = $79564f678731bf19$var$fabric.util.transformPoint(viewportStart, this.viewportTransform), viewportExtent = new $79564f678731bf19$var$fabric.Point(selector.ex + selector.left, selector.ey + selector.top), extent = $79564f678731bf19$var$fabric.util.transformPoint(viewportExtent, this.viewportTransform), minX = Math.min(start.x, extent.x), minY = Math.min(start.y, extent.y), maxX = Math.max(start.x, extent.x), maxY = Math.max(start.y, extent.y), strokeOffset = this.selectionLineWidth / 2;
            if (this.selectionColor) {
                ctx.fillStyle = this.selectionColor;
                ctx.fillRect(minX, minY, maxX - minX, maxY - minY);
            }
            if (!this.selectionLineWidth || !this.selectionBorderColor) return;
            ctx.lineWidth = this.selectionLineWidth;
            ctx.strokeStyle = this.selectionBorderColor;
            minX += strokeOffset;
            minY += strokeOffset;
            maxX -= strokeOffset;
            maxY -= strokeOffset;
            // selection border
            $79564f678731bf19$var$fabric.Object.prototype._setLineDash.call(this, ctx, this.selectionDashArray);
            ctx.strokeRect(minX, minY, maxX - minX, maxY - minY);
        },
        /**
     * Method that determines what object we are clicking on
     * the skipGroup parameter is for internal use, is needed for shift+click action
     * 11/09/2018 TODO: would be cool if findTarget could discern between being a full target
     * or the outside part of the corner.
     * @param {Event} e mouse event
     * @param {Boolean} skipGroup when true, activeGroup is skipped and only objects are traversed through
     * @return {fabric.Object} the target found
     */ findTarget: function(e, skipGroup) {
            if (this.skipTargetFind) return;
            var ignoreZoom = true, pointer = this.getPointer(e, ignoreZoom), activeObject = this._activeObject, aObjects = this.getActiveObjects(), activeTarget, activeTargetSubs, isTouch = isTouchEvent(e), shouldLookForActive = aObjects.length > 1 && !skipGroup || aObjects.length === 1;
            // first check current group (if one exists)
            // active group does not check sub targets like normal groups.
            // if active group just exits.
            this.targets = [];
            // if we hit the corner of an activeObject, let's return that.
            if (shouldLookForActive && activeObject._findTargetCorner(pointer, isTouch)) return activeObject;
            if (aObjects.length > 1 && !skipGroup && activeObject === this._searchPossibleTargets([
                activeObject
            ], pointer)) return activeObject;
            if (aObjects.length === 1 && activeObject === this._searchPossibleTargets([
                activeObject
            ], pointer)) {
                if (!this.preserveObjectStacking) return activeObject;
                else {
                    activeTarget = activeObject;
                    activeTargetSubs = this.targets;
                    this.targets = [];
                }
            }
            var target = this._searchPossibleTargets(this._objects, pointer);
            if (e[this.altSelectionKey] && target && activeTarget && target !== activeTarget) {
                target = activeTarget;
                this.targets = activeTargetSubs;
            }
            return target;
        },
        /**
     * Checks point is inside the object.
     * @param {Object} [pointer] x,y object of point coordinates we want to check.
     * @param {fabric.Object} obj Object to test against
     * @param {Object} [globalPointer] x,y object of point coordinates relative to canvas used to search per pixel target.
     * @return {Boolean} true if point is contained within an area of given object
     * @private
     */ _checkTarget: function(pointer, obj, globalPointer) {
            if (obj && obj.visible && obj.evented && // http://www.geog.ubc.ca/courses/klink/gis.notes/ncgia/u32.html
            // http://idav.ucdavis.edu/~okreylos/TAship/Spring2000/PointInPolygon.html
            obj.containsPoint(pointer)) {
                if ((this.perPixelTargetFind || obj.perPixelTargetFind) && !obj.isEditing) {
                    var isTransparent = this.isTargetTransparent(obj, globalPointer.x, globalPointer.y);
                    if (!isTransparent) return true;
                } else return true;
            }
        },
        /**
     * Function used to search inside objects an object that contains pointer in bounding box or that contains pointerOnCanvas when painted
     * @param {Array} [objects] objects array to look into
     * @param {Object} [pointer] x,y object of point coordinates we want to check.
     * @return {fabric.Object} object that contains pointer
     * @private
     */ _searchPossibleTargets: function(objects, pointer) {
            // Cache all targets where their bounding box contains point.
            var target, i = objects.length, subTarget;
            // Do not check for currently grouped objects, since we check the parent group itself.
            // until we call this function specifically to search inside the activeGroup
            while(i--){
                var objToCheck = objects[i];
                var pointerToUse = objToCheck.group ? this._normalizePointer(objToCheck.group, pointer) : pointer;
                if (this._checkTarget(pointerToUse, objToCheck, pointer)) {
                    target = objects[i];
                    if (target.subTargetCheck && target instanceof $79564f678731bf19$var$fabric.Group) {
                        subTarget = this._searchPossibleTargets(target._objects, pointer);
                        subTarget && this.targets.push(subTarget);
                    }
                    break;
                }
            }
            return target;
        },
        /**
     * Returns pointer coordinates without the effect of the viewport
     * @param {Object} pointer with "x" and "y" number values
     * @return {Object} object with "x" and "y" number values
     */ restorePointerVpt: function(pointer) {
            return $79564f678731bf19$var$fabric.util.transformPoint(pointer, $79564f678731bf19$var$fabric.util.invertTransform(this.viewportTransform));
        },
        /**
     * Returns pointer coordinates relative to canvas.
     * Can return coordinates with or without viewportTransform.
     * ignoreZoom false gives back coordinates that represent
     * the point clicked on canvas element.
     * ignoreZoom true gives back coordinates after being processed
     * by the viewportTransform ( sort of coordinates of what is displayed
     * on the canvas where you are clicking.
     * ignoreZoom true = HTMLElement coordinates relative to top,left
     * ignoreZoom false, default = fabric space coordinates, the same used for shape position
     * To interact with your shapes top and left you want to use ignoreZoom true
     * most of the time, while ignoreZoom false will give you coordinates
     * compatible with the object.oCoords system.
     * of the time.
     * @param {Event} e
     * @param {Boolean} ignoreZoom
     * @return {Object} object with "x" and "y" number values
     */ getPointer: function(e, ignoreZoom) {
            // return cached values if we are in the event processing chain
            if (this._absolutePointer && !ignoreZoom) return this._absolutePointer;
            if (this._pointer && ignoreZoom) return this._pointer;
            var pointer = getPointer(e), upperCanvasEl = this.upperCanvasEl, bounds = upperCanvasEl.getBoundingClientRect(), boundsWidth = bounds.width || 0, boundsHeight = bounds.height || 0, cssScale;
            if (!boundsWidth || !boundsHeight) {
                if ('top' in bounds && 'bottom' in bounds) boundsHeight = Math.abs(bounds.top - bounds.bottom);
                if ('right' in bounds && 'left' in bounds) boundsWidth = Math.abs(bounds.right - bounds.left);
            }
            this.calcOffset();
            pointer.x = pointer.x - this._offset.left;
            pointer.y = pointer.y - this._offset.top;
            if (!ignoreZoom) pointer = this.restorePointerVpt(pointer);
            var retinaScaling = this.getRetinaScaling();
            if (retinaScaling !== 1) {
                pointer.x /= retinaScaling;
                pointer.y /= retinaScaling;
            }
            if (boundsWidth === 0 || boundsHeight === 0) // If bounds are not available (i.e. not visible), do not apply scale.
            cssScale = {
                width: 1,
                height: 1
            };
            else cssScale = {
                width: upperCanvasEl.width / boundsWidth,
                height: upperCanvasEl.height / boundsHeight
            };
            return {
                x: pointer.x * cssScale.width,
                y: pointer.y * cssScale.height
            };
        },
        /**
     * @private
     * @throws {CANVAS_INIT_ERROR} If canvas can not be initialized
     */ _createUpperCanvas: function() {
            var lowerCanvasClass = this.lowerCanvasEl.className.replace(/\s*lower-canvas\s*/, ''), lowerCanvasEl = this.lowerCanvasEl, upperCanvasEl = this.upperCanvasEl;
            // there is no need to create a new upperCanvas element if we have already one.
            if (upperCanvasEl) upperCanvasEl.className = '';
            else {
                upperCanvasEl = this._createCanvasElement();
                this.upperCanvasEl = upperCanvasEl;
            }
            $79564f678731bf19$var$fabric.util.addClass(upperCanvasEl, 'upper-canvas ' + lowerCanvasClass);
            this.wrapperEl.appendChild(upperCanvasEl);
            this._copyCanvasStyle(lowerCanvasEl, upperCanvasEl);
            this._applyCanvasStyle(upperCanvasEl);
            this.contextTop = upperCanvasEl.getContext('2d');
        },
        /**
     * Returns context of top canvas where interactions are drawn
     * @returns {CanvasRenderingContext2D}
     */ getTopContext: function() {
            return this.contextTop;
        },
        /**
     * @private
     */ _createCacheCanvas: function() {
            this.cacheCanvasEl = this._createCanvasElement();
            this.cacheCanvasEl.setAttribute('width', this.width);
            this.cacheCanvasEl.setAttribute('height', this.height);
            this.contextCache = this.cacheCanvasEl.getContext('2d');
        },
        /**
     * @private
     */ _initWrapperElement: function() {
            this.wrapperEl = $79564f678731bf19$var$fabric.util.wrapElement(this.lowerCanvasEl, 'div', {
                'class': this.containerClass
            });
            $79564f678731bf19$var$fabric.util.setStyle(this.wrapperEl, {
                width: this.width + 'px',
                height: this.height + 'px',
                position: 'relative'
            });
            $79564f678731bf19$var$fabric.util.makeElementUnselectable(this.wrapperEl);
        },
        /**
     * @private
     * @param {HTMLElement} element canvas element to apply styles on
     */ _applyCanvasStyle: function(element) {
            var width = this.width || element.width, height = this.height || element.height;
            $79564f678731bf19$var$fabric.util.setStyle(element, {
                position: 'absolute',
                width: width + 'px',
                height: height + 'px',
                left: 0,
                top: 0,
                'touch-action': this.allowTouchScrolling ? 'manipulation' : 'none',
                '-ms-touch-action': this.allowTouchScrolling ? 'manipulation' : 'none'
            });
            element.width = width;
            element.height = height;
            $79564f678731bf19$var$fabric.util.makeElementUnselectable(element);
        },
        /**
     * Copy the entire inline style from one element (fromEl) to another (toEl)
     * @private
     * @param {Element} fromEl Element style is copied from
     * @param {Element} toEl Element copied style is applied to
     */ _copyCanvasStyle: function(fromEl, toEl) {
            toEl.style.cssText = fromEl.style.cssText;
        },
        /**
     * Returns context of canvas where object selection is drawn
     * @return {CanvasRenderingContext2D}
     */ getSelectionContext: function() {
            return this.contextTop;
        },
        /**
     * Returns &lt;canvas> element on which object selection is drawn
     * @return {HTMLCanvasElement}
     */ getSelectionElement: function() {
            return this.upperCanvasEl;
        },
        /**
     * Returns currently active object
     * @return {fabric.Object} active object
     */ getActiveObject: function() {
            return this._activeObject;
        },
        /**
     * Returns an array with the current selected objects
     * @return {fabric.Object} active object
     */ getActiveObjects: function() {
            var active = this._activeObject;
            if (active) {
                if (active.type === 'activeSelection' && active._objects) return active._objects.slice(0);
                else return [
                    active
                ];
            }
            return [];
        },
        /**
     * @private
     * @param {fabric.Object} obj Object that was removed
     */ _onObjectRemoved: function(obj) {
            // removing active object should fire "selection:cleared" events
            if (obj === this._activeObject) {
                this.fire('before:selection:cleared', {
                    target: obj
                });
                this._discardActiveObject();
                this.fire('selection:cleared', {
                    target: obj
                });
                obj.fire('deselected');
            }
            if (obj === this._hoveredTarget) {
                this._hoveredTarget = null;
                this._hoveredTargets = [];
            }
            this.callSuper('_onObjectRemoved', obj);
        },
        /**
     * @private
     * Compares the old activeObject with the current one and fires correct events
     * @param {fabric.Object} obj old activeObject
     */ _fireSelectionEvents: function(oldObjects, e) {
            var somethingChanged = false, objects = this.getActiveObjects(), added = [], removed = [];
            oldObjects.forEach(function(oldObject) {
                if (objects.indexOf(oldObject) === -1) {
                    somethingChanged = true;
                    oldObject.fire('deselected', {
                        e: e,
                        target: oldObject
                    });
                    removed.push(oldObject);
                }
            });
            objects.forEach(function(object) {
                if (oldObjects.indexOf(object) === -1) {
                    somethingChanged = true;
                    object.fire('selected', {
                        e: e,
                        target: object
                    });
                    added.push(object);
                }
            });
            if (oldObjects.length > 0 && objects.length > 0) somethingChanged && this.fire('selection:updated', {
                e: e,
                selected: added,
                deselected: removed
            });
            else if (objects.length > 0) this.fire('selection:created', {
                e: e,
                selected: added
            });
            else if (oldObjects.length > 0) this.fire('selection:cleared', {
                e: e,
                deselected: removed
            });
        },
        /**
     * Sets given object as the only active object on canvas
     * @param {fabric.Object} object Object to set as an active one
     * @param {Event} [e] Event (passed along when firing "object:selected")
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ setActiveObject: function(object, e) {
            var currentActives = this.getActiveObjects();
            this._setActiveObject(object, e);
            this._fireSelectionEvents(currentActives, e);
            return this;
        },
        /**
     * This is a private method for now.
     * This is supposed to be equivalent to setActiveObject but without firing
     * any event. There is commitment to have this stay this way.
     * This is the functional part of setActiveObject.
     * @private
     * @param {Object} object to set as active
     * @param {Event} [e] Event (passed along when firing "object:selected")
     * @return {Boolean} true if the selection happened
     */ _setActiveObject: function(object, e) {
            if (this._activeObject === object) return false;
            if (!this._discardActiveObject(e, object)) return false;
            if (object.onSelect({
                e: e
            })) return false;
            this._activeObject = object;
            return true;
        },
        /**
     * This is a private method for now.
     * This is supposed to be equivalent to discardActiveObject but without firing
     * any events. There is commitment to have this stay this way.
     * This is the functional part of discardActiveObject.
     * @param {Event} [e] Event (passed along when firing "object:deselected")
     * @param {Object} object to set as active
     * @return {Boolean} true if the selection happened
     * @private
     */ _discardActiveObject: function(e, object) {
            var obj = this._activeObject;
            if (obj) {
                // onDeselect return TRUE to cancel selection;
                if (obj.onDeselect({
                    e: e,
                    object: object
                })) return false;
                this._activeObject = null;
            }
            return true;
        },
        /**
     * Discards currently active object and fire events. If the function is called by fabric
     * as a consequence of a mouse event, the event is passed as a parameter and
     * sent to the fire function for the custom events. When used as a method the
     * e param does not have any application.
     * @param {event} e
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ discardActiveObject: function(e) {
            var currentActives = this.getActiveObjects(), activeObject = this.getActiveObject();
            if (currentActives.length) this.fire('before:selection:cleared', {
                target: activeObject,
                e: e
            });
            this._discardActiveObject(e);
            this._fireSelectionEvents(currentActives, e);
            return this;
        },
        /**
     * Clears a canvas element and removes all event listeners
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ dispose: function() {
            var wrapper = this.wrapperEl;
            this.removeListeners();
            wrapper.removeChild(this.upperCanvasEl);
            wrapper.removeChild(this.lowerCanvasEl);
            this.contextCache = null;
            this.contextTop = null;
            [
                'upperCanvasEl',
                'cacheCanvasEl'
            ].forEach((function(element) {
                $79564f678731bf19$var$fabric.util.cleanUpJsdomNode(this[element]);
                this[element] = undefined;
            }).bind(this));
            if (wrapper.parentNode) wrapper.parentNode.replaceChild(this.lowerCanvasEl, this.wrapperEl);
            delete this.wrapperEl;
            $79564f678731bf19$var$fabric.StaticCanvas.prototype.dispose.call(this);
            return this;
        },
        /**
     * Clears all contexts (background, main, top) of an instance
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ clear: function() {
            // this.discardActiveGroup();
            this.discardActiveObject();
            this.clearContext(this.contextTop);
            return this.callSuper('clear');
        },
        /**
     * Draws objects' controls (borders/controls)
     * @param {CanvasRenderingContext2D} ctx Context to render controls on
     */ drawControls: function(ctx) {
            var activeObject = this._activeObject;
            if (activeObject) activeObject._renderControls(ctx);
        },
        /**
     * @private
     */ _toObject: function(instance, methodName, propertiesToInclude) {
            //If the object is part of the current selection group, it should
            //be transformed appropriately
            //i.e. it should be serialised as it would appear if the selection group
            //were to be destroyed.
            var originalProperties = this._realizeGroupTransformOnObject(instance), object = this.callSuper('_toObject', instance, methodName, propertiesToInclude);
            //Undo the damage we did by changing all of its properties
            this._unwindGroupTransformOnObject(instance, originalProperties);
            return object;
        },
        /**
     * Realises an object's group transformation on it
     * @private
     * @param {fabric.Object} [instance] the object to transform (gets mutated)
     * @returns the original values of instance which were changed
     */ _realizeGroupTransformOnObject: function(instance) {
            if (instance.group && instance.group.type === 'activeSelection' && this._activeObject === instance.group) {
                var layoutProps = [
                    'angle',
                    'flipX',
                    'flipY',
                    'left',
                    'scaleX',
                    'scaleY',
                    'skewX',
                    'skewY',
                    'top'
                ];
                //Copy all the positionally relevant properties across now
                var originalValues = {};
                layoutProps.forEach(function(prop) {
                    originalValues[prop] = instance[prop];
                });
                $79564f678731bf19$var$fabric.util.addTransformToObject(instance, this._activeObject.calcOwnMatrix());
                return originalValues;
            } else return null;
        },
        /**
     * Restores the changed properties of instance
     * @private
     * @param {fabric.Object} [instance] the object to un-transform (gets mutated)
     * @param {Object} [originalValues] the original values of instance, as returned by _realizeGroupTransformOnObject
     */ _unwindGroupTransformOnObject: function(instance, originalValues) {
            if (originalValues) instance.set(originalValues);
        },
        /**
     * @private
     */ _setSVGObject: function(markup, instance, reviver) {
            //If the object is in a selection group, simulate what would happen to that
            //object when the group is deselected
            var originalProperties = this._realizeGroupTransformOnObject(instance);
            this.callSuper('_setSVGObject', markup, instance, reviver);
            this._unwindGroupTransformOnObject(instance, originalProperties);
        },
        setViewportTransform: function(vpt) {
            if (this.renderOnAddRemove && this._activeObject && this._activeObject.isEditing) this._activeObject.clearContextTop();
            $79564f678731bf19$var$fabric.StaticCanvas.prototype.setViewportTransform.call(this, vpt);
        }
    });
    // copying static properties manually to work around Opera's bug,
    // where "prototype" property is enumerable and overrides existing prototype
    for(var prop in $79564f678731bf19$var$fabric.StaticCanvas)if (prop !== 'prototype') $79564f678731bf19$var$fabric.Canvas[prop] = $79564f678731bf19$var$fabric.StaticCanvas[prop];
})();
(function() {
    var addListener = $79564f678731bf19$var$fabric.util.addListener, removeListener = $79564f678731bf19$var$fabric.util.removeListener, RIGHT_CLICK = 3, MIDDLE_CLICK = 2, LEFT_CLICK = 1, addEventOptions = {
        passive: false
    };
    function checkClick(e, value) {
        return e.button && e.button === value - 1;
    }
    $79564f678731bf19$var$fabric.util.object.extend($79564f678731bf19$var$fabric.Canvas.prototype, /** @lends fabric.Canvas.prototype */ {
        /**
     * Contains the id of the touch event that owns the fabric transform
     * @type Number
     * @private
     */ mainTouchId: null,
        /**
     * Adds mouse listeners to canvas
     * @private
     */ _initEventListeners: function() {
            // in case we initialized the class twice. This should not happen normally
            // but in some kind of applications where the canvas element may be changed
            // this is a workaround to having double listeners.
            this.removeListeners();
            this._bindEvents();
            this.addOrRemove(addListener, 'add');
        },
        /**
     * return an event prefix pointer or mouse.
     * @private
     */ _getEventPrefix: function() {
            return this.enablePointerEvents ? 'pointer' : 'mouse';
        },
        addOrRemove: function(functor, eventjsFunctor) {
            var canvasElement = this.upperCanvasEl, eventTypePrefix = this._getEventPrefix();
            functor($79564f678731bf19$var$fabric.window, 'resize', this._onResize);
            functor(canvasElement, eventTypePrefix + 'down', this._onMouseDown);
            functor(canvasElement, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
            functor(canvasElement, eventTypePrefix + 'out', this._onMouseOut);
            functor(canvasElement, eventTypePrefix + 'enter', this._onMouseEnter);
            functor(canvasElement, 'wheel', this._onMouseWheel);
            functor(canvasElement, 'contextmenu', this._onContextMenu);
            functor(canvasElement, 'dblclick', this._onDoubleClick);
            functor(canvasElement, 'dragover', this._onDragOver);
            functor(canvasElement, 'dragenter', this._onDragEnter);
            functor(canvasElement, 'dragleave', this._onDragLeave);
            functor(canvasElement, 'drop', this._onDrop);
            if (!this.enablePointerEvents) functor(canvasElement, 'touchstart', this._onTouchStart, addEventOptions);
            if (typeof eventjs !== 'undefined' && eventjsFunctor in eventjs) {
                eventjs[eventjsFunctor](canvasElement, 'gesture', this._onGesture);
                eventjs[eventjsFunctor](canvasElement, 'drag', this._onDrag);
                eventjs[eventjsFunctor](canvasElement, 'orientation', this._onOrientationChange);
                eventjs[eventjsFunctor](canvasElement, 'shake', this._onShake);
                eventjs[eventjsFunctor](canvasElement, 'longpress', this._onLongPress);
            }
        },
        /**
     * Removes all event listeners
     */ removeListeners: function() {
            this.addOrRemove(removeListener, 'remove');
            // if you dispose on a mouseDown, before mouse up, you need to clean document to...
            var eventTypePrefix = this._getEventPrefix();
            removeListener($79564f678731bf19$var$fabric.document, eventTypePrefix + 'up', this._onMouseUp);
            removeListener($79564f678731bf19$var$fabric.document, 'touchend', this._onTouchEnd, addEventOptions);
            removeListener($79564f678731bf19$var$fabric.document, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
            removeListener($79564f678731bf19$var$fabric.document, 'touchmove', this._onMouseMove, addEventOptions);
        },
        /**
     * @private
     */ _bindEvents: function() {
            if (this.eventsBound) // for any reason we pass here twice we do not want to bind events twice.
            return;
            this._onMouseDown = this._onMouseDown.bind(this);
            this._onTouchStart = this._onTouchStart.bind(this);
            this._onMouseMove = this._onMouseMove.bind(this);
            this._onMouseUp = this._onMouseUp.bind(this);
            this._onTouchEnd = this._onTouchEnd.bind(this);
            this._onResize = this._onResize.bind(this);
            this._onGesture = this._onGesture.bind(this);
            this._onDrag = this._onDrag.bind(this);
            this._onShake = this._onShake.bind(this);
            this._onLongPress = this._onLongPress.bind(this);
            this._onOrientationChange = this._onOrientationChange.bind(this);
            this._onMouseWheel = this._onMouseWheel.bind(this);
            this._onMouseOut = this._onMouseOut.bind(this);
            this._onMouseEnter = this._onMouseEnter.bind(this);
            this._onContextMenu = this._onContextMenu.bind(this);
            this._onDoubleClick = this._onDoubleClick.bind(this);
            this._onDragOver = this._onDragOver.bind(this);
            this._onDragEnter = this._simpleEventHandler.bind(this, 'dragenter');
            this._onDragLeave = this._simpleEventHandler.bind(this, 'dragleave');
            this._onDrop = this._onDrop.bind(this);
            this.eventsBound = true;
        },
        /**
     * @private
     * @param {Event} [e] Event object fired on Event.js gesture
     * @param {Event} [self] Inner Event object
     */ _onGesture: function(e, self) {
            this.__onTransformGesture && this.__onTransformGesture(e, self);
        },
        /**
     * @private
     * @param {Event} [e] Event object fired on Event.js drag
     * @param {Event} [self] Inner Event object
     */ _onDrag: function(e, self) {
            this.__onDrag && this.__onDrag(e, self);
        },
        /**
     * @private
     * @param {Event} [e] Event object fired on wheel event
     */ _onMouseWheel: function(e) {
            this.__onMouseWheel(e);
        },
        /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */ _onMouseOut: function(e) {
            var target = this._hoveredTarget;
            this.fire('mouse:out', {
                target: target,
                e: e
            });
            this._hoveredTarget = null;
            target && target.fire('mouseout', {
                e: e
            });
            var _this = this;
            this._hoveredTargets.forEach(function(_target) {
                _this.fire('mouse:out', {
                    target: _target,
                    e: e
                });
                _target && _target.fire('mouseout', {
                    e: e
                });
            });
            this._hoveredTargets = [];
        },
        /**
     * @private
     * @param {Event} e Event object fired on mouseenter
     */ _onMouseEnter: function(e) {
            // This find target and consequent 'mouse:over' is used to
            // clear old instances on hovered target.
            // calling findTarget has the side effect of killing target.__corner.
            // as a short term fix we are not firing this if we are currently transforming.
            // as a long term fix we need to separate the action of finding a target with the
            // side effects we added to it.
            if (!this._currentTransform && !this.findTarget(e)) {
                this.fire('mouse:over', {
                    target: null,
                    e: e
                });
                this._hoveredTarget = null;
                this._hoveredTargets = [];
            }
        },
        /**
     * @private
     * @param {Event} [e] Event object fired on Event.js orientation change
     * @param {Event} [self] Inner Event object
     */ _onOrientationChange: function(e, self) {
            this.__onOrientationChange && this.__onOrientationChange(e, self);
        },
        /**
     * @private
     * @param {Event} [e] Event object fired on Event.js shake
     * @param {Event} [self] Inner Event object
     */ _onShake: function(e, self) {
            this.__onShake && this.__onShake(e, self);
        },
        /**
     * @private
     * @param {Event} [e] Event object fired on Event.js shake
     * @param {Event} [self] Inner Event object
     */ _onLongPress: function(e, self) {
            this.__onLongPress && this.__onLongPress(e, self);
        },
        /**
     * prevent default to allow drop event to be fired
     * @private
     * @param {Event} [e] Event object fired on Event.js shake
     */ _onDragOver: function(e) {
            e.preventDefault();
            var target = this._simpleEventHandler('dragover', e);
            this._fireEnterLeaveEvents(target, e);
        },
        /**
     * `drop:before` is a an event that allow you to schedule logic
     * before the `drop` event. Prefer `drop` event always, but if you need
     * to run some drop-disabling logic on an event, since there is no way
     * to handle event handlers ordering, use `drop:before`
     * @param {Event} e
     */ _onDrop: function(e) {
            this._simpleEventHandler('drop:before', e);
            return this._simpleEventHandler('drop', e);
        },
        /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */ _onContextMenu: function(e) {
            if (this.stopContextMenu) {
                e.stopPropagation();
                e.preventDefault();
            }
            return false;
        },
        /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */ _onDoubleClick: function(e) {
            this._cacheTransformEventData(e);
            this._handleEvent(e, 'dblclick');
            this._resetTransformEventData(e);
        },
        /**
     * Return a the id of an event.
     * returns either the pointerId or the identifier or 0 for the mouse event
     * @private
     * @param {Event} evt Event object
     */ getPointerId: function(evt) {
            var changedTouches = evt.changedTouches;
            if (changedTouches) return changedTouches[0] && changedTouches[0].identifier;
            if (this.enablePointerEvents) return evt.pointerId;
            return -1;
        },
        /**
     * Determines if an event has the id of the event that is considered main
     * @private
     * @param {evt} event Event object
     */ _isMainEvent: function(evt) {
            if (evt.isPrimary === true) return true;
            if (evt.isPrimary === false) return false;
            if (evt.type === 'touchend' && evt.touches.length === 0) return true;
            if (evt.changedTouches) return evt.changedTouches[0].identifier === this.mainTouchId;
            return true;
        },
        /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */ _onTouchStart: function(e) {
            e.preventDefault();
            if (this.mainTouchId === null) this.mainTouchId = this.getPointerId(e);
            this.__onMouseDown(e);
            this._resetTransformEventData();
            var canvasElement = this.upperCanvasEl, eventTypePrefix = this._getEventPrefix();
            addListener($79564f678731bf19$var$fabric.document, 'touchend', this._onTouchEnd, addEventOptions);
            addListener($79564f678731bf19$var$fabric.document, 'touchmove', this._onMouseMove, addEventOptions);
            // Unbind mousedown to prevent double triggers from touch devices
            removeListener(canvasElement, eventTypePrefix + 'down', this._onMouseDown);
        },
        /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */ _onMouseDown: function(e) {
            this.__onMouseDown(e);
            this._resetTransformEventData();
            var canvasElement = this.upperCanvasEl, eventTypePrefix = this._getEventPrefix();
            removeListener(canvasElement, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
            addListener($79564f678731bf19$var$fabric.document, eventTypePrefix + 'up', this._onMouseUp);
            addListener($79564f678731bf19$var$fabric.document, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
        },
        /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */ _onTouchEnd: function(e) {
            if (e.touches.length > 0) // if there are still touches stop here
            return;
            this.__onMouseUp(e);
            this._resetTransformEventData();
            this.mainTouchId = null;
            var eventTypePrefix = this._getEventPrefix();
            removeListener($79564f678731bf19$var$fabric.document, 'touchend', this._onTouchEnd, addEventOptions);
            removeListener($79564f678731bf19$var$fabric.document, 'touchmove', this._onMouseMove, addEventOptions);
            var _this = this;
            if (this._willAddMouseDown) clearTimeout(this._willAddMouseDown);
            this._willAddMouseDown = setTimeout(function() {
                // Wait 400ms before rebinding mousedown to prevent double triggers
                // from touch devices
                addListener(_this.upperCanvasEl, eventTypePrefix + 'down', _this._onMouseDown);
                _this._willAddMouseDown = 0;
            }, 400);
        },
        /**
     * @private
     * @param {Event} e Event object fired on mouseup
     */ _onMouseUp: function(e) {
            this.__onMouseUp(e);
            this._resetTransformEventData();
            var canvasElement = this.upperCanvasEl, eventTypePrefix = this._getEventPrefix();
            if (this._isMainEvent(e)) {
                removeListener($79564f678731bf19$var$fabric.document, eventTypePrefix + 'up', this._onMouseUp);
                removeListener($79564f678731bf19$var$fabric.document, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
                addListener(canvasElement, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
            }
        },
        /**
     * @private
     * @param {Event} e Event object fired on mousemove
     */ _onMouseMove: function(e) {
            !this.allowTouchScrolling && e.preventDefault && e.preventDefault();
            this.__onMouseMove(e);
        },
        /**
     * @private
     */ _onResize: function() {
            this.calcOffset();
        },
        /**
     * Decides whether the canvas should be redrawn in mouseup and mousedown events.
     * @private
     * @param {Object} target
     */ _shouldRender: function(target) {
            var activeObject = this._activeObject;
            if (!!activeObject !== !!target || activeObject && target && activeObject !== target) // this covers: switch of target, from target to no target, selection of target
            // multiSelection with key and mouse
            return true;
            else if (activeObject && activeObject.isEditing) // if we mouse up/down over a editing textbox a cursor change,
            // there is no need to re render
            return false;
            return false;
        },
        /**
     * Method that defines the actions when mouse is released on canvas.
     * The method resets the currentTransform parameters, store the image corner
     * position in the image object and render the canvas on top.
     * @private
     * @param {Event} e Event object fired on mouseup
     */ __onMouseUp: function(e) {
            var target, transform = this._currentTransform, groupSelector = this._groupSelector, shouldRender = false, isClick = !groupSelector || groupSelector.left === 0 && groupSelector.top === 0;
            this._cacheTransformEventData(e);
            target = this._target;
            this._handleEvent(e, 'up:before');
            // if right/middle click just fire events and return
            // target undefined will make the _handleEvent search the target
            if (checkClick(e, RIGHT_CLICK)) {
                if (this.fireRightClick) this._handleEvent(e, 'up', RIGHT_CLICK, isClick);
                return;
            }
            if (checkClick(e, MIDDLE_CLICK)) {
                if (this.fireMiddleClick) this._handleEvent(e, 'up', MIDDLE_CLICK, isClick);
                this._resetTransformEventData();
                return;
            }
            if (this.isDrawingMode && this._isCurrentlyDrawing) {
                this._onMouseUpInDrawingMode(e);
                return;
            }
            if (!this._isMainEvent(e)) return;
            if (transform) {
                this._finalizeCurrentTransform(e);
                shouldRender = transform.actionPerformed;
            }
            if (!isClick) {
                var targetWasActive = target === this._activeObject;
                this._maybeGroupObjects(e);
                if (!shouldRender) shouldRender = this._shouldRender(target) || !targetWasActive && target === this._activeObject;
            }
            var corner, pointer;
            if (target) {
                corner = target._findTargetCorner(this.getPointer(e, true), $79564f678731bf19$var$fabric.util.isTouchEvent(e));
                if (target.selectable && target !== this._activeObject && target.activeOn === 'up') {
                    this.setActiveObject(target, e);
                    shouldRender = true;
                } else {
                    var control = target.controls[corner], mouseUpHandler = control && control.getMouseUpHandler(e, target, control);
                    if (mouseUpHandler) {
                        pointer = this.getPointer(e);
                        mouseUpHandler(e, transform, pointer.x, pointer.y);
                    }
                }
                target.isMoving = false;
            }
            // if we are ending up a transform on a different control or a new object
            // fire the original mouse up from the corner that started the transform
            if (transform && (transform.target !== target || transform.corner !== corner)) {
                var originalControl = transform.target && transform.target.controls[transform.corner], originalMouseUpHandler = originalControl && originalControl.getMouseUpHandler(e, target, control);
                pointer = pointer || this.getPointer(e);
                originalMouseUpHandler && originalMouseUpHandler(e, transform, pointer.x, pointer.y);
            }
            this._setCursorFromEvent(e, target);
            this._handleEvent(e, 'up', LEFT_CLICK, isClick);
            this._groupSelector = null;
            this._currentTransform = null;
            // reset the target information about which corner is selected
            target && (target.__corner = 0);
            if (shouldRender) this.requestRenderAll();
            else if (!isClick) this.renderTop();
        },
        /**
     * @private
     * Handle event firing for target and subtargets
     * @param {Event} e event from mouse
     * @param {String} eventType event to fire (up, down or move)
     * @return {Fabric.Object} target return the the target found, for internal reasons.
     */ _simpleEventHandler: function(eventType, e) {
            var target = this.findTarget(e), targets = this.targets, options = {
                e: e,
                target: target,
                subTargets: targets
            };
            this.fire(eventType, options);
            target && target.fire(eventType, options);
            if (!targets) return target;
            for(var i = 0; i < targets.length; i++)targets[i].fire(eventType, options);
            return target;
        },
        /**
     * @private
     * Handle event firing for target and subtargets
     * @param {Event} e event from mouse
     * @param {String} eventType event to fire (up, down or move)
     * @param {fabric.Object} targetObj receiving event
     * @param {Number} [button] button used in the event 1 = left, 2 = middle, 3 = right
     * @param {Boolean} isClick for left button only, indicates that the mouse up happened without move.
     */ _handleEvent: function(e, eventType, button, isClick) {
            var target = this._target, targets = this.targets || [], options = {
                e: e,
                target: target,
                subTargets: targets,
                button: button || LEFT_CLICK,
                isClick: isClick || false,
                pointer: this._pointer,
                absolutePointer: this._absolutePointer,
                transform: this._currentTransform
            };
            if (eventType === 'up') {
                options.currentTarget = this.findTarget(e);
                options.currentSubTargets = this.targets;
            }
            this.fire('mouse:' + eventType, options);
            target && target.fire('mouse' + eventType, options);
            for(var i = 0; i < targets.length; i++)targets[i].fire('mouse' + eventType, options);
        },
        /**
     * @private
     * @param {Event} e send the mouse event that generate the finalize down, so it can be used in the event
     */ _finalizeCurrentTransform: function(e) {
            var transform = this._currentTransform, target = transform.target, options = {
                e: e,
                target: target,
                transform: transform,
                action: transform.action
            };
            if (target._scaling) target._scaling = false;
            target.setCoords();
            if (transform.actionPerformed || this.stateful && target.hasStateChanged()) this._fire('modified', options);
        },
        /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */ _onMouseDownInDrawingMode: function(e) {
            this._isCurrentlyDrawing = true;
            if (this.getActiveObject()) this.discardActiveObject(e).requestRenderAll();
            var pointer = this.getPointer(e);
            this.freeDrawingBrush.onMouseDown(pointer, {
                e: e,
                pointer: pointer
            });
            this._handleEvent(e, 'down');
        },
        /**
     * @private
     * @param {Event} e Event object fired on mousemove
     */ _onMouseMoveInDrawingMode: function(e) {
            if (this._isCurrentlyDrawing) {
                var pointer = this.getPointer(e);
                this.freeDrawingBrush.onMouseMove(pointer, {
                    e: e,
                    pointer: pointer
                });
            }
            this.setCursor(this.freeDrawingCursor);
            this._handleEvent(e, 'move');
        },
        /**
     * @private
     * @param {Event} e Event object fired on mouseup
     */ _onMouseUpInDrawingMode: function(e) {
            var pointer = this.getPointer(e);
            this._isCurrentlyDrawing = this.freeDrawingBrush.onMouseUp({
                e: e,
                pointer: pointer
            });
            this._handleEvent(e, 'up');
        },
        /**
     * Method that defines the actions when mouse is clicked on canvas.
     * The method inits the currentTransform parameters and renders all the
     * canvas so the current image can be placed on the top canvas and the rest
     * in on the container one.
     * @private
     * @param {Event} e Event object fired on mousedown
     */ __onMouseDown: function(e) {
            this._cacheTransformEventData(e);
            this._handleEvent(e, 'down:before');
            var target = this._target;
            // if right click just fire events
            if (checkClick(e, RIGHT_CLICK)) {
                if (this.fireRightClick) this._handleEvent(e, 'down', RIGHT_CLICK);
                return;
            }
            if (checkClick(e, MIDDLE_CLICK)) {
                if (this.fireMiddleClick) this._handleEvent(e, 'down', MIDDLE_CLICK);
                return;
            }
            if (this.isDrawingMode) {
                this._onMouseDownInDrawingMode(e);
                return;
            }
            if (!this._isMainEvent(e)) return;
            // ignore if some object is being transformed at this moment
            if (this._currentTransform) return;
            var pointer = this._pointer;
            // save pointer for check in __onMouseUp event
            this._previousPointer = pointer;
            var shouldRender = this._shouldRender(target), shouldGroup = this._shouldGroup(e, target);
            if (this._shouldClearSelection(e, target)) this.discardActiveObject(e);
            else if (shouldGroup) {
                this._handleGrouping(e, target);
                target = this._activeObject;
            }
            if (this.selection && (!target || !target.selectable && !target.isEditing && target !== this._activeObject)) this._groupSelector = {
                ex: this._absolutePointer.x,
                ey: this._absolutePointer.y,
                top: 0,
                left: 0
            };
            if (target) {
                var alreadySelected = target === this._activeObject;
                if (target.selectable && target.activeOn === 'down') this.setActiveObject(target, e);
                var corner = target._findTargetCorner(this.getPointer(e, true), $79564f678731bf19$var$fabric.util.isTouchEvent(e));
                target.__corner = corner;
                if (target === this._activeObject && (corner || !shouldGroup)) {
                    this._setupCurrentTransform(e, target, alreadySelected);
                    var control = target.controls[corner], pointer = this.getPointer(e), mouseDownHandler = control && control.getMouseDownHandler(e, target, control);
                    if (mouseDownHandler) mouseDownHandler(e, this._currentTransform, pointer.x, pointer.y);
                }
            }
            this._handleEvent(e, 'down');
            // we must renderAll so that we update the visuals
            (shouldRender || shouldGroup) && this.requestRenderAll();
        },
        /**
     * reset cache form common information needed during event processing
     * @private
     */ _resetTransformEventData: function() {
            this._target = null;
            this._pointer = null;
            this._absolutePointer = null;
        },
        /**
     * Cache common information needed during event processing
     * @private
     * @param {Event} e Event object fired on event
     */ _cacheTransformEventData: function(e) {
            // reset in order to avoid stale caching
            this._resetTransformEventData();
            this._pointer = this.getPointer(e, true);
            this._absolutePointer = this.restorePointerVpt(this._pointer);
            this._target = this._currentTransform ? this._currentTransform.target : this.findTarget(e) || null;
        },
        /**
     * @private
     */ _beforeTransform: function(e) {
            var t = this._currentTransform;
            this.stateful && t.target.saveState();
            this.fire('before:transform', {
                e: e,
                transform: t
            });
        },
        /**
     * Method that defines the actions when mouse is hovering the canvas.
     * The currentTransform parameter will define whether the user is rotating/scaling/translating
     * an image or neither of them (only hovering). A group selection is also possible and would cancel
     * all any other type of action.
     * In case of an image transformation only the top canvas will be rendered.
     * @private
     * @param {Event} e Event object fired on mousemove
     */ __onMouseMove: function(e) {
            this._handleEvent(e, 'move:before');
            this._cacheTransformEventData(e);
            var target, pointer;
            if (this.isDrawingMode) {
                this._onMouseMoveInDrawingMode(e);
                return;
            }
            if (!this._isMainEvent(e)) return;
            var groupSelector = this._groupSelector;
            // We initially clicked in an empty area, so we draw a box for multiple selection
            if (groupSelector) {
                pointer = this._absolutePointer;
                groupSelector.left = pointer.x - groupSelector.ex;
                groupSelector.top = pointer.y - groupSelector.ey;
                this.renderTop();
            } else if (!this._currentTransform) {
                target = this.findTarget(e) || null;
                this._setCursorFromEvent(e, target);
                this._fireOverOutEvents(target, e);
            } else this._transformObject(e);
            this._handleEvent(e, 'move');
            this._resetTransformEventData();
        },
        /**
     * Manage the mouseout, mouseover events for the fabric object on the canvas
     * @param {Fabric.Object} target the target where the target from the mousemove event
     * @param {Event} e Event object fired on mousemove
     * @private
     */ _fireOverOutEvents: function(target, e) {
            var _hoveredTarget = this._hoveredTarget, _hoveredTargets = this._hoveredTargets, targets = this.targets, length = Math.max(_hoveredTargets.length, targets.length);
            this.fireSyntheticInOutEvents(target, e, {
                oldTarget: _hoveredTarget,
                evtOut: 'mouseout',
                canvasEvtOut: 'mouse:out',
                evtIn: 'mouseover',
                canvasEvtIn: 'mouse:over'
            });
            for(var i = 0; i < length; i++)this.fireSyntheticInOutEvents(targets[i], e, {
                oldTarget: _hoveredTargets[i],
                evtOut: 'mouseout',
                evtIn: 'mouseover'
            });
            this._hoveredTarget = target;
            this._hoveredTargets = this.targets.concat();
        },
        /**
     * Manage the dragEnter, dragLeave events for the fabric objects on the canvas
     * @param {Fabric.Object} target the target where the target from the onDrag event
     * @param {Event} e Event object fired on ondrag
     * @private
     */ _fireEnterLeaveEvents: function(target, e) {
            var _draggedoverTarget = this._draggedoverTarget, _hoveredTargets = this._hoveredTargets, targets = this.targets, length = Math.max(_hoveredTargets.length, targets.length);
            this.fireSyntheticInOutEvents(target, e, {
                oldTarget: _draggedoverTarget,
                evtOut: 'dragleave',
                evtIn: 'dragenter'
            });
            for(var i = 0; i < length; i++)this.fireSyntheticInOutEvents(targets[i], e, {
                oldTarget: _hoveredTargets[i],
                evtOut: 'dragleave',
                evtIn: 'dragenter'
            });
            this._draggedoverTarget = target;
        },
        /**
     * Manage the synthetic in/out events for the fabric objects on the canvas
     * @param {Fabric.Object} target the target where the target from the supported events
     * @param {Event} e Event object fired
     * @param {Object} config configuration for the function to work
     * @param {String} config.targetName property on the canvas where the old target is stored
     * @param {String} [config.canvasEvtOut] name of the event to fire at canvas level for out
     * @param {String} config.evtOut name of the event to fire for out
     * @param {String} [config.canvasEvtIn] name of the event to fire at canvas level for in
     * @param {String} config.evtIn name of the event to fire for in
     * @private
     */ fireSyntheticInOutEvents: function(target, e, config) {
            var inOpt, outOpt, oldTarget = config.oldTarget, outFires, inFires, targetChanged = oldTarget !== target, canvasEvtIn = config.canvasEvtIn, canvasEvtOut = config.canvasEvtOut;
            if (targetChanged) {
                inOpt = {
                    e: e,
                    target: target,
                    previousTarget: oldTarget
                };
                outOpt = {
                    e: e,
                    target: oldTarget,
                    nextTarget: target
                };
            }
            inFires = target && targetChanged;
            outFires = oldTarget && targetChanged;
            if (outFires) {
                canvasEvtOut && this.fire(canvasEvtOut, outOpt);
                oldTarget.fire(config.evtOut, outOpt);
            }
            if (inFires) {
                canvasEvtIn && this.fire(canvasEvtIn, inOpt);
                target.fire(config.evtIn, inOpt);
            }
        },
        /**
     * Method that defines actions when an Event Mouse Wheel
     * @param {Event} e Event object fired on mouseup
     */ __onMouseWheel: function(e) {
            this._cacheTransformEventData(e);
            this._handleEvent(e, 'wheel');
            this._resetTransformEventData();
        },
        /**
     * @private
     * @param {Event} e Event fired on mousemove
     */ _transformObject: function(e) {
            var pointer = this.getPointer(e), transform = this._currentTransform;
            transform.reset = false;
            transform.shiftKey = e.shiftKey;
            transform.altKey = e[this.centeredKey];
            this._performTransformAction(e, transform, pointer);
            transform.actionPerformed && this.requestRenderAll();
        },
        /**
     * @private
     */ _performTransformAction: function(e, transform, pointer) {
            var x = pointer.x, y = pointer.y, action = transform.action, actionPerformed = false, actionHandler = transform.actionHandler;
            // this object could be created from the function in the control handlers
            if (actionHandler) actionPerformed = actionHandler(e, transform, x, y);
            if (action === 'drag' && actionPerformed) {
                transform.target.isMoving = true;
                this.setCursor(transform.target.moveCursor || this.moveCursor);
            }
            transform.actionPerformed = transform.actionPerformed || actionPerformed;
        },
        /**
     * @private
     */ _fire: $79564f678731bf19$var$fabric.controlsUtils.fireEvent,
        /**
     * Sets the cursor depending on where the canvas is being hovered.
     * Note: very buggy in Opera
     * @param {Event} e Event object
     * @param {Object} target Object that the mouse is hovering, if so.
     */ _setCursorFromEvent: function(e, target) {
            if (!target) {
                this.setCursor(this.defaultCursor);
                return false;
            }
            var hoverCursor = target.hoverCursor || this.hoverCursor, activeSelection = this._activeObject && this._activeObject.type === 'activeSelection' ? this._activeObject : null, // only show proper corner when group selection is not active
            corner = (!activeSelection || !activeSelection.contains(target)) && target._findTargetCorner(this.getPointer(e, true));
            if (!corner) {
                if (target.subTargetCheck) // hoverCursor should come from top-most subTarget,
                // so we walk the array backwards
                this.targets.concat().reverse().map(function(_target) {
                    hoverCursor = _target.hoverCursor || hoverCursor;
                });
                this.setCursor(hoverCursor);
            } else this.setCursor(this.getCornerCursor(corner, target, e));
        },
        /**
     * @private
     */ getCornerCursor: function(corner, target, e) {
            var control = target.controls[corner];
            return control.cursorStyleHandler(e, control, target);
        }
    });
})();
(function() {
    var min = Math.min, max = Math.max;
    $79564f678731bf19$var$fabric.util.object.extend($79564f678731bf19$var$fabric.Canvas.prototype, /** @lends fabric.Canvas.prototype */ {
        /**
     * @private
     * @param {Event} e Event object
     * @param {fabric.Object} target
     * @return {Boolean}
     */ _shouldGroup: function(e, target) {
            var activeObject = this._activeObject;
            return activeObject && this._isSelectionKeyPressed(e) && target && target.selectable && this.selection && (activeObject !== target || activeObject.type === 'activeSelection') && !target.onSelect({
                e: e
            });
        },
        /**
     * @private
     * @param {Event} e Event object
     * @param {fabric.Object} target
     */ _handleGrouping: function(e, target) {
            var activeObject = this._activeObject;
            // avoid multi select when shift click on a corner
            if (activeObject.__corner) return;
            if (target === activeObject) {
                // if it's a group, find target again, using activeGroup objects
                target = this.findTarget(e, true);
                // if even object is not found or we are on activeObjectCorner, bail out
                if (!target || !target.selectable) return;
            }
            if (activeObject && activeObject.type === 'activeSelection') this._updateActiveSelection(target, e);
            else this._createActiveSelection(target, e);
        },
        /**
     * @private
     */ _updateActiveSelection: function(target, e) {
            var activeSelection = this._activeObject, currentActiveObjects = activeSelection._objects.slice(0);
            if (activeSelection.contains(target)) {
                activeSelection.removeWithUpdate(target);
                this._hoveredTarget = target;
                this._hoveredTargets = this.targets.concat();
                if (activeSelection.size() === 1) // activate last remaining object
                this._setActiveObject(activeSelection.item(0), e);
            } else {
                activeSelection.addWithUpdate(target);
                this._hoveredTarget = activeSelection;
                this._hoveredTargets = this.targets.concat();
            }
            this._fireSelectionEvents(currentActiveObjects, e);
        },
        /**
     * @private
     */ _createActiveSelection: function(target, e) {
            var currentActives = this.getActiveObjects(), group = this._createGroup(target);
            this._hoveredTarget = group;
            // ISSUE 4115: should we consider subTargets here?
            // this._hoveredTargets = [];
            // this._hoveredTargets = this.targets.concat();
            this._setActiveObject(group, e);
            this._fireSelectionEvents(currentActives, e);
        },
        /**
     * @private
     * @param {Object} target
     */ _createGroup: function(target) {
            var objects = this._objects, isActiveLower = objects.indexOf(this._activeObject) < objects.indexOf(target), groupObjects = isActiveLower ? [
                this._activeObject,
                target
            ] : [
                target,
                this._activeObject
            ];
            this._activeObject.isEditing && this._activeObject.exitEditing();
            return new $79564f678731bf19$var$fabric.ActiveSelection(groupObjects, {
                canvas: this
            });
        },
        /**
     * @private
     * @param {Event} e mouse event
     */ _groupSelectedObjects: function(e) {
            var group = this._collectObjects(e), aGroup;
            // do not create group for 1 element only
            if (group.length === 1) this.setActiveObject(group[0], e);
            else if (group.length > 1) {
                aGroup = new $79564f678731bf19$var$fabric.ActiveSelection(group.reverse(), {
                    canvas: this
                });
                this.setActiveObject(aGroup, e);
            }
        },
        /**
     * @private
     */ _collectObjects: function(e) {
            var group = [], currentObject, x1 = this._groupSelector.ex, y1 = this._groupSelector.ey, x2 = x1 + this._groupSelector.left, y2 = y1 + this._groupSelector.top, selectionX1Y1 = new $79564f678731bf19$var$fabric.Point(min(x1, x2), min(y1, y2)), selectionX2Y2 = new $79564f678731bf19$var$fabric.Point(max(x1, x2), max(y1, y2)), allowIntersect = !this.selectionFullyContained, isClick = x1 === x2 && y1 === y2;
            // we iterate reverse order to collect top first in case of click.
            for(var i = this._objects.length; i--;){
                currentObject = this._objects[i];
                if (!currentObject || !currentObject.selectable || !currentObject.visible) continue;
                if (allowIntersect && currentObject.intersectsWithRect(selectionX1Y1, selectionX2Y2, true) || currentObject.isContainedWithinRect(selectionX1Y1, selectionX2Y2, true) || allowIntersect && currentObject.containsPoint(selectionX1Y1, null, true) || allowIntersect && currentObject.containsPoint(selectionX2Y2, null, true)) {
                    group.push(currentObject);
                    // only add one object if it's a click
                    if (isClick) break;
                }
            }
            if (group.length > 1) group = group.filter(function(object) {
                return !object.onSelect({
                    e: e
                });
            });
            return group;
        },
        /**
     * @private
     */ _maybeGroupObjects: function(e) {
            if (this.selection && this._groupSelector) this._groupSelectedObjects(e);
            this.setCursor(this.defaultCursor);
            // clear selection and current transformation
            this._groupSelector = null;
        }
    });
})();
(function() {
    $79564f678731bf19$var$fabric.util.object.extend($79564f678731bf19$var$fabric.StaticCanvas.prototype, /** @lends fabric.StaticCanvas.prototype */ {
        /**
     * Exports canvas element to a dataurl image. Note that when multiplier is used, cropping is scaled appropriately
     * @param {Object} [options] Options object
     * @param {String} [options.format=png] The format of the output image. Either "jpeg" or "png"
     * @param {Number} [options.quality=1] Quality level (0..1). Only used for jpeg.
     * @param {Number} [options.multiplier=1] Multiplier to scale by, to have consistent
     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 2.0.0
     * @return {String} Returns a data: URL containing a representation of the object in the format specified by options.format
     * @see {@link http://jsfiddle.net/fabricjs/NfZVb/|jsFiddle demo}
     * @example <caption>Generate jpeg dataURL with lower quality</caption>
     * var dataURL = canvas.toDataURL({
     *   format: 'jpeg',
     *   quality: 0.8
     * });
     * @example <caption>Generate cropped png dataURL (clipping of canvas)</caption>
     * var dataURL = canvas.toDataURL({
     *   format: 'png',
     *   left: 100,
     *   top: 100,
     *   width: 200,
     *   height: 200
     * });
     * @example <caption>Generate double scaled png dataURL</caption>
     * var dataURL = canvas.toDataURL({
     *   format: 'png',
     *   multiplier: 2
     * });
     */ toDataURL: function(options) {
            options || (options = {});
            var format = options.format || 'png', quality = options.quality || 1, multiplier = (options.multiplier || 1) * (options.enableRetinaScaling ? this.getRetinaScaling() : 1), canvasEl = this.toCanvasElement(multiplier, options);
            return $79564f678731bf19$var$fabric.util.toDataURL(canvasEl, format, quality);
        },
        /**
     * Create a new HTMLCanvas element painted with the current canvas content.
     * No need to resize the actual one or repaint it.
     * Will transfer object ownership to a new canvas, paint it, and set everything back.
     * This is an intermediary step used to get to a dataUrl but also it is useful to
     * create quick image copies of a canvas without passing for the dataUrl string
     * @param {Number} [multiplier] a zoom factor.
     * @param {Object} [cropping] Cropping informations
     * @param {Number} [cropping.left] Cropping left offset.
     * @param {Number} [cropping.top] Cropping top offset.
     * @param {Number} [cropping.width] Cropping width.
     * @param {Number} [cropping.height] Cropping height.
     */ toCanvasElement: function(multiplier, cropping) {
            multiplier = multiplier || 1;
            cropping = cropping || {};
            var scaledWidth = (cropping.width || this.width) * multiplier, scaledHeight = (cropping.height || this.height) * multiplier, zoom = this.getZoom(), originalWidth = this.width, originalHeight = this.height, newZoom = zoom * multiplier, vp = this.viewportTransform, translateX = (vp[4] - (cropping.left || 0)) * multiplier, translateY = (vp[5] - (cropping.top || 0)) * multiplier, originalInteractive = this.interactive, newVp = [
                newZoom,
                0,
                0,
                newZoom,
                translateX,
                translateY
            ], originalRetina = this.enableRetinaScaling, canvasEl = $79564f678731bf19$var$fabric.util.createCanvasElement(), originalContextTop = this.contextTop;
            canvasEl.width = scaledWidth;
            canvasEl.height = scaledHeight;
            this.contextTop = null;
            this.enableRetinaScaling = false;
            this.interactive = false;
            this.viewportTransform = newVp;
            this.width = scaledWidth;
            this.height = scaledHeight;
            this.calcViewportBoundaries();
            this.renderCanvas(canvasEl.getContext('2d'), this._objects);
            this.viewportTransform = vp;
            this.width = originalWidth;
            this.height = originalHeight;
            this.calcViewportBoundaries();
            this.interactive = originalInteractive;
            this.enableRetinaScaling = originalRetina;
            this.contextTop = originalContextTop;
            return canvasEl;
        }
    });
})();
$79564f678731bf19$var$fabric.util.object.extend($79564f678731bf19$var$fabric.StaticCanvas.prototype, /** @lends fabric.StaticCanvas.prototype */ {
    /**
   * Populates canvas with data from the specified JSON.
   * JSON format must conform to the one of {@link fabric.Canvas#toJSON}
   * @param {String|Object} json JSON string or object
   * @param {Function} callback Callback, invoked when json is parsed
   *                            and corresponding objects (e.g: {@link fabric.Image})
   *                            are initialized
   * @param {Function} [reviver] Method for further parsing of JSON elements, called after each fabric object created.
   * @return {fabric.Canvas} instance
   * @chainable
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#deserialization}
   * @see {@link http://jsfiddle.net/fabricjs/fmgXt/|jsFiddle demo}
   * @example <caption>loadFromJSON</caption>
   * canvas.loadFromJSON(json, canvas.renderAll.bind(canvas));
   * @example <caption>loadFromJSON with reviver</caption>
   * canvas.loadFromJSON(json, canvas.renderAll.bind(canvas), function(o, object) {
   *   // `o` = json object
   *   // `object` = fabric.Object instance
   *   // ... do some stuff ...
   * });
   */ loadFromJSON: function(json, callback, reviver) {
        if (!json) return;
        // serialize if it wasn't already
        var serialized = typeof json === 'string' ? JSON.parse(json) : $79564f678731bf19$var$fabric.util.object.clone(json);
        var _this = this, clipPath = serialized.clipPath, renderOnAddRemove = this.renderOnAddRemove;
        this.renderOnAddRemove = false;
        delete serialized.clipPath;
        this._enlivenObjects(serialized.objects, function(enlivenedObjects) {
            _this.clear();
            _this._setBgOverlay(serialized, function() {
                if (clipPath) _this._enlivenObjects([
                    clipPath
                ], function(enlivenedCanvasClip) {
                    _this.clipPath = enlivenedCanvasClip[0];
                    _this.__setupCanvas.call(_this, serialized, enlivenedObjects, renderOnAddRemove, callback);
                });
                else _this.__setupCanvas.call(_this, serialized, enlivenedObjects, renderOnAddRemove, callback);
            });
        }, reviver);
        return this;
    },
    /**
   * @private
   * @param {Object} serialized Object with background and overlay information
   * @param {Array} restored canvas objects
   * @param {Function} cached renderOnAddRemove callback
   * @param {Function} callback Invoked after all background and overlay images/patterns loaded
   */ __setupCanvas: function(serialized, enlivenedObjects, renderOnAddRemove, callback) {
        var _this = this;
        enlivenedObjects.forEach(function(obj, index) {
            // we splice the array just in case some custom classes restored from JSON
            // will add more object to canvas at canvas init.
            _this.insertAt(obj, index);
        });
        this.renderOnAddRemove = renderOnAddRemove;
        // remove parts i cannot set as options
        delete serialized.objects;
        delete serialized.backgroundImage;
        delete serialized.overlayImage;
        delete serialized.background;
        delete serialized.overlay;
        // this._initOptions does too many things to just
        // call it. Normally loading an Object from JSON
        // create the Object instance. Here the Canvas is
        // already an instance and we are just loading things over it
        this._setOptions(serialized);
        this.renderAll();
        callback && callback();
    },
    /**
   * @private
   * @param {Object} serialized Object with background and overlay information
   * @param {Function} callback Invoked after all background and overlay images/patterns loaded
   */ _setBgOverlay: function(serialized, callback) {
        var loaded = {
            backgroundColor: false,
            overlayColor: false,
            backgroundImage: false,
            overlayImage: false
        };
        if (!serialized.backgroundImage && !serialized.overlayImage && !serialized.background && !serialized.overlay) {
            callback && callback();
            return;
        }
        var cbIfLoaded = function() {
            if (loaded.backgroundImage && loaded.overlayImage && loaded.backgroundColor && loaded.overlayColor) callback && callback();
        };
        this.__setBgOverlay('backgroundImage', serialized.backgroundImage, loaded, cbIfLoaded);
        this.__setBgOverlay('overlayImage', serialized.overlayImage, loaded, cbIfLoaded);
        this.__setBgOverlay('backgroundColor', serialized.background, loaded, cbIfLoaded);
        this.__setBgOverlay('overlayColor', serialized.overlay, loaded, cbIfLoaded);
    },
    /**
   * @private
   * @param {String} property Property to set (backgroundImage, overlayImage, backgroundColor, overlayColor)
   * @param {(Object|String)} value Value to set
   * @param {Object} loaded Set loaded property to true if property is set
   * @param {Object} callback Callback function to invoke after property is set
   */ __setBgOverlay: function(property, value, loaded, callback) {
        var _this = this;
        if (!value) {
            loaded[property] = true;
            callback && callback();
            return;
        }
        if (property === 'backgroundImage' || property === 'overlayImage') $79564f678731bf19$var$fabric.util.enlivenObjects([
            value
        ], function(enlivedObject) {
            _this[property] = enlivedObject[0];
            loaded[property] = true;
            callback && callback();
        });
        else this['set' + $79564f678731bf19$var$fabric.util.string.capitalize(property, true)](value, function() {
            loaded[property] = true;
            callback && callback();
        });
    },
    /**
   * @private
   * @param {Array} objects
   * @param {Function} callback
   * @param {Function} [reviver]
   */ _enlivenObjects: function(objects, callback, reviver) {
        if (!objects || objects.length === 0) {
            callback && callback([]);
            return;
        }
        $79564f678731bf19$var$fabric.util.enlivenObjects(objects, function(enlivenedObjects) {
            callback && callback(enlivenedObjects);
        }, null, reviver);
    },
    /**
   * @private
   * @param {String} format
   * @param {Function} callback
   */ _toDataURL: function(format, callback) {
        this.clone(function(clone) {
            callback(clone.toDataURL(format));
        });
    },
    /**
   * @private
   * @param {String} format
   * @param {Number} multiplier
   * @param {Function} callback
   */ _toDataURLWithMultiplier: function(format, multiplier, callback) {
        this.clone(function(clone) {
            callback(clone.toDataURLWithMultiplier(format, multiplier));
        });
    },
    /**
   * Clones canvas instance
   * @param {Object} [callback] Receives cloned instance as a first argument
   * @param {Array} [properties] Array of properties to include in the cloned canvas and children
   */ clone: function(callback, properties) {
        var data = JSON.stringify(this.toJSON(properties));
        this.cloneWithoutData(function(clone) {
            clone.loadFromJSON(data, function() {
                callback && callback(clone);
            });
        });
    },
    /**
   * Clones canvas instance without cloning existing data.
   * This essentially copies canvas dimensions, clipping properties, etc.
   * but leaves data empty (so that you can populate it with your own)
   * @param {Object} [callback] Receives cloned instance as a first argument
   */ cloneWithoutData: function(callback) {
        var el = $79564f678731bf19$var$fabric.util.createCanvasElement();
        el.width = this.width;
        el.height = this.height;
        var clone = new $79564f678731bf19$var$fabric.Canvas(el);
        if (this.backgroundImage) {
            clone.setBackgroundImage(this.backgroundImage.src, function() {
                clone.renderAll();
                callback && callback(clone);
            });
            clone.backgroundImageOpacity = this.backgroundImageOpacity;
            clone.backgroundImageStretch = this.backgroundImageStretch;
        } else callback && callback(clone);
    }
});
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {}), extend = fabric.util.object.extend, clone = fabric.util.object.clone, toFixed = fabric.util.toFixed, capitalize = fabric.util.string.capitalize, degreesToRadians = fabric.util.degreesToRadians, objectCaching = !fabric.isLikelyNode, ALIASING_LIMIT = 2;
    if (fabric.Object) return;
    /**
   * Root object class from which all 2d shape classes inherit from
   * @class fabric.Object
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#objects}
   * @see {@link fabric.Object#initialize} for constructor definition
   *
   * @fires added
   * @fires removed
   *
   * @fires selected
   * @fires deselected
   * @fires modified
   * @fires modified
   * @fires moved
   * @fires scaled
   * @fires rotated
   * @fires skewed
   *
   * @fires rotating
   * @fires scaling
   * @fires moving
   * @fires skewing
   *
   * @fires mousedown
   * @fires mouseup
   * @fires mouseover
   * @fires mouseout
   * @fires mousewheel
   * @fires mousedblclick
   *
   * @fires dragover
   * @fires dragenter
   * @fires dragleave
   * @fires drop
   */ fabric.Object = fabric.util.createClass(fabric.CommonMethods, /** @lends fabric.Object.prototype */ {
        /**
     * Type of an object (rect, circle, path, etc.).
     * Note that this property is meant to be read-only and not meant to be modified.
     * If you modify, certain parts of Fabric (such as JSON loading) won't work correctly.
     * @type String
     * @default
     */ type: 'object',
        /**
     * Horizontal origin of transformation of an object (one of "left", "right", "center")
     * See http://jsfiddle.net/1ow02gea/244/ on how originX/originY affect objects in groups
     * @type String
     * @default
     */ originX: 'left',
        /**
     * Vertical origin of transformation of an object (one of "top", "bottom", "center")
     * See http://jsfiddle.net/1ow02gea/244/ on how originX/originY affect objects in groups
     * @type String
     * @default
     */ originY: 'top',
        /**
     * Top position of an object. Note that by default it's relative to object top. You can change this by setting originY={top/center/bottom}
     * @type Number
     * @default
     */ top: 0,
        /**
     * Left position of an object. Note that by default it's relative to object left. You can change this by setting originX={left/center/right}
     * @type Number
     * @default
     */ left: 0,
        /**
     * Object width
     * @type Number
     * @default
     */ width: 0,
        /**
     * Object height
     * @type Number
     * @default
     */ height: 0,
        /**
     * Object scale factor (horizontal)
     * @type Number
     * @default
     */ scaleX: 1,
        /**
     * Object scale factor (vertical)
     * @type Number
     * @default
     */ scaleY: 1,
        /**
     * When true, an object is rendered as flipped horizontally
     * @type Boolean
     * @default
     */ flipX: false,
        /**
     * When true, an object is rendered as flipped vertically
     * @type Boolean
     * @default
     */ flipY: false,
        /**
     * Opacity of an object
     * @type Number
     * @default
     */ opacity: 1,
        /**
     * Angle of rotation of an object (in degrees)
     * @type Number
     * @default
     */ angle: 0,
        /**
     * Angle of skew on x axes of an object (in degrees)
     * @type Number
     * @default
     */ skewX: 0,
        /**
     * Angle of skew on y axes of an object (in degrees)
     * @type Number
     * @default
     */ skewY: 0,
        /**
     * Size of object's controlling corners (in pixels)
     * @type Number
     * @default
     */ cornerSize: 13,
        /**
     * Size of object's controlling corners when touch interaction is detected
     * @type Number
     * @default
     */ touchCornerSize: 24,
        /**
     * When true, object's controlling corners are rendered as transparent inside (i.e. stroke instead of fill)
     * @type Boolean
     * @default
     */ transparentCorners: true,
        /**
     * Default cursor value used when hovering over this object on canvas
     * @type String
     * @default
     */ hoverCursor: null,
        /**
     * Default cursor value used when moving this object on canvas
     * @type String
     * @default
     */ moveCursor: null,
        /**
     * Padding between object and its controlling borders (in pixels)
     * @type Number
     * @default
     */ padding: 0,
        /**
     * Color of controlling borders of an object (when it's active)
     * @type String
     * @default
     */ borderColor: 'rgb(178,204,255)',
        /**
     * Array specifying dash pattern of an object's borders (hasBorder must be true)
     * @since 1.6.2
     * @type Array
     */ borderDashArray: null,
        /**
     * Color of controlling corners of an object (when it's active)
     * @type String
     * @default
     */ cornerColor: 'rgb(178,204,255)',
        /**
     * Color of controlling corners of an object (when it's active and transparentCorners false)
     * @since 1.6.2
     * @type String
     * @default
     */ cornerStrokeColor: null,
        /**
     * Specify style of control, 'rect' or 'circle'
     * @since 1.6.2
     * @type String
     */ cornerStyle: 'rect',
        /**
     * Array specifying dash pattern of an object's control (hasBorder must be true)
     * @since 1.6.2
     * @type Array
     */ cornerDashArray: null,
        /**
     * When true, this object will use center point as the origin of transformation
     * when being scaled via the controls.
     * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
     * @since 1.3.4
     * @type Boolean
     * @default
     */ centeredScaling: false,
        /**
     * When true, this object will use center point as the origin of transformation
     * when being rotated via the controls.
     * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
     * @since 1.3.4
     * @type Boolean
     * @default
     */ centeredRotation: true,
        /**
     * Color of object's fill
     * takes css colors https://www.w3.org/TR/css-color-3/
     * @type String
     * @default
     */ fill: 'rgb(0,0,0)',
        /**
     * Fill rule used to fill an object
     * accepted values are nonzero, evenodd
     * <b>Backwards incompatibility note:</b> This property was used for setting globalCompositeOperation until v1.4.12 (use `fabric.Object#globalCompositeOperation` instead)
     * @type String
     * @default
     */ fillRule: 'nonzero',
        /**
     * Composite rule used for canvas globalCompositeOperation
     * @type String
     * @default
     */ globalCompositeOperation: 'source-over',
        /**
     * Background color of an object.
     * takes css colors https://www.w3.org/TR/css-color-3/
     * @type String
     * @default
     */ backgroundColor: '',
        /**
     * Selection Background color of an object. colored layer behind the object when it is active.
     * does not mix good with globalCompositeOperation methods.
     * @type String
     * @default
     */ selectionBackgroundColor: '',
        /**
     * When defined, an object is rendered via stroke and this property specifies its color
     * takes css colors https://www.w3.org/TR/css-color-3/
     * @type String
     * @default
     */ stroke: null,
        /**
     * Width of a stroke used to render this object
     * @type Number
     * @default
     */ strokeWidth: 1,
        /**
     * Array specifying dash pattern of an object's stroke (stroke must be defined)
     * @type Array
     */ strokeDashArray: null,
        /**
     * Line offset of an object's stroke
     * @type Number
     * @default
     */ strokeDashOffset: 0,
        /**
     * Line endings style of an object's stroke (one of "butt", "round", "square")
     * @type String
     * @default
     */ strokeLineCap: 'butt',
        /**
     * Corner style of an object's stroke (one of "bevel", "round", "miter")
     * @type String
     * @default
     */ strokeLineJoin: 'miter',
        /**
     * Maximum miter length (used for strokeLineJoin = "miter") of an object's stroke
     * @type Number
     * @default
     */ strokeMiterLimit: 4,
        /**
     * Shadow object representing shadow of this shape
     * @type fabric.Shadow
     * @default
     */ shadow: null,
        /**
     * Opacity of object's controlling borders when object is active and moving
     * @type Number
     * @default
     */ borderOpacityWhenMoving: 0.4,
        /**
     * Scale factor of object's controlling borders
     * bigger number will make a thicker border
     * border is 1, so this is basically a border thickness
     * since there is no way to change the border itself.
     * @type Number
     * @default
     */ borderScaleFactor: 1,
        /**
     * Minimum allowed scale value of an object
     * @type Number
     * @default
     */ minScaleLimit: 0,
        /**
     * When set to `false`, an object can not be selected for modification (using either point-click-based or group-based selection).
     * But events still fire on it.
     * @type Boolean
     * @default
     */ selectable: true,
        /**
     * When set to `false`, an object can not be a target of events. All events propagate through it. Introduced in v1.3.4
     * @type Boolean
     * @default
     */ evented: true,
        /**
     * When set to `false`, an object is not rendered on canvas
     * @type Boolean
     * @default
     */ visible: true,
        /**
     * When set to `false`, object's controls are not displayed and can not be used to manipulate object
     * @type Boolean
     * @default
     */ hasControls: true,
        /**
     * When set to `false`, object's controlling borders are not rendered
     * @type Boolean
     * @default
     */ hasBorders: true,
        /**
     * When set to `true`, objects are "found" on canvas on per-pixel basis rather than according to bounding box
     * @type Boolean
     * @default
     */ perPixelTargetFind: false,
        /**
     * When `false`, default object's values are not included in its serialization
     * @type Boolean
     * @default
     */ includeDefaultValues: true,
        /**
     * When `true`, object horizontal movement is locked
     * @type Boolean
     * @default
     */ lockMovementX: false,
        /**
     * When `true`, object vertical movement is locked
     * @type Boolean
     * @default
     */ lockMovementY: false,
        /**
     * When `true`, object rotation is locked
     * @type Boolean
     * @default
     */ lockRotation: false,
        /**
     * When `true`, object horizontal scaling is locked
     * @type Boolean
     * @default
     */ lockScalingX: false,
        /**
     * When `true`, object vertical scaling is locked
     * @type Boolean
     * @default
     */ lockScalingY: false,
        /**
     * When `true`, object horizontal skewing is locked
     * @type Boolean
     * @default
     */ lockSkewingX: false,
        /**
     * When `true`, object vertical skewing is locked
     * @type Boolean
     * @default
     */ lockSkewingY: false,
        /**
     * When `true`, object cannot be flipped by scaling into negative values
     * @type Boolean
     * @default
     */ lockScalingFlip: false,
        /**
     * When `true`, object is not exported in OBJECT/JSON
     * @since 1.6.3
     * @type Boolean
     * @default
     */ excludeFromExport: false,
        /**
     * When `true`, object is cached on an additional canvas.
     * When `false`, object is not cached unless necessary ( clipPath )
     * default to true
     * @since 1.7.0
     * @type Boolean
     * @default true
     */ objectCaching: objectCaching,
        /**
     * When `true`, object properties are checked for cache invalidation. In some particular
     * situation you may want this to be disabled ( spray brush, very big, groups)
     * or if your application does not allow you to modify properties for groups child you want
     * to disable it for groups.
     * default to false
     * since 1.7.0
     * @type Boolean
     * @default false
     */ statefullCache: false,
        /**
     * When `true`, cache does not get updated during scaling. The picture will get blocky if scaled
     * too much and will be redrawn with correct details at the end of scaling.
     * this setting is performance and application dependant.
     * default to true
     * since 1.7.0
     * @type Boolean
     * @default true
     */ noScaleCache: true,
        /**
     * When `false`, the stoke width will scale with the object.
     * When `true`, the stroke will always match the exact pixel size entered for stroke width.
     * this Property does not work on Text classes or drawing call that uses strokeText,fillText methods
     * default to false
     * @since 2.6.0
     * @type Boolean
     * @default false
     * @type Boolean
     * @default false
     */ strokeUniform: false,
        /**
     * When set to `true`, object's cache will be rerendered next render call.
     * since 1.7.0
     * @type Boolean
     * @default true
     */ dirty: true,
        /**
     * keeps the value of the last hovered corner during mouse move.
     * 0 is no corner, or 'mt', 'ml', 'mtr' etc..
     * It should be private, but there is no harm in using it as
     * a read-only property.
     * @type number|string|any
     * @default 0
     */ __corner: 0,
        /**
     * Determines if the fill or the stroke is drawn first (one of "fill" or "stroke")
     * @type String
     * @default
     */ paintFirst: 'fill',
        /**
     * When 'down', object is set to active on mousedown/touchstart
     * When 'up', object is set to active on mouseup/touchend
     * Experimental. Let's see if this breaks anything before supporting officially
     * @private
     * since 4.4.0
     * @type String
     * @default 'down'
     */ activeOn: 'down',
        /**
     * List of properties to consider when checking if state
     * of an object is changed (fabric.Object#hasStateChanged)
     * as well as for history (undo/redo) purposes
     * @type Array
     */ stateProperties: "top left width height scaleX scaleY flipX flipY originX originY transformMatrix stroke strokeWidth strokeDashArray strokeLineCap strokeDashOffset strokeLineJoin strokeMiterLimit angle opacity fill globalCompositeOperation shadow visible backgroundColor skewX skewY fillRule paintFirst clipPath strokeUniform".split(' '),
        /**
     * List of properties to consider when checking if cache needs refresh
     * Those properties are checked by statefullCache ON ( or lazy mode if we want ) or from single
     * calls to Object.set(key, value). If the key is in this list, the object is marked as dirty
     * and refreshed at the next render
     * @type Array
     */ cacheProperties: "fill stroke strokeWidth strokeDashArray width height paintFirst strokeUniform strokeLineCap strokeDashOffset strokeLineJoin strokeMiterLimit backgroundColor clipPath".split(' '),
        /**
     * List of properties to consider for animating colors.
     * @type Array
     */ colorProperties: 'fill stroke backgroundColor'.split(' '),
        /**
     * a fabricObject that, without stroke define a clipping area with their shape. filled in black
     * the clipPath object gets used when the object has rendered, and the context is placed in the center
     * of the object cacheCanvas.
     * If you want 0,0 of a clipPath to align with an object center, use clipPath.originX/Y to 'center'
     * @type fabric.Object
     */ clipPath: undefined,
        /**
     * Meaningful ONLY when the object is used as clipPath.
     * if true, the clipPath will make the object clip to the outside of the clipPath
     * since 2.4.0
     * @type boolean
     * @default false
     */ inverted: false,
        /**
     * Meaningful ONLY when the object is used as clipPath.
     * if true, the clipPath will have its top and left relative to canvas, and will
     * not be influenced by the object transform. This will make the clipPath relative
     * to the canvas, but clipping just a particular object.
     * WARNING this is beta, this feature may change or be renamed.
     * since 2.4.0
     * @type boolean
     * @default false
     */ absolutePositioned: false,
        /**
     * Constructor
     * @param {Object} [options] Options object
     */ initialize: function(options) {
            if (options) this.setOptions(options);
        },
        /**
     * Create a the canvas used to keep the cached copy of the object
     * @private
     */ _createCacheCanvas: function() {
            this._cacheProperties = {};
            this._cacheCanvas = fabric.util.createCanvasElement();
            this._cacheContext = this._cacheCanvas.getContext('2d');
            this._updateCacheCanvas();
            // if canvas gets created, is empty, so dirty.
            this.dirty = true;
        },
        /**
     * Limit the cache dimensions so that X * Y do not cross fabric.perfLimitSizeTotal
     * and each side do not cross fabric.cacheSideLimit
     * those numbers are configurable so that you can get as much detail as you want
     * making bargain with performances.
     * @param {Object} dims
     * @param {Object} dims.width width of canvas
     * @param {Object} dims.height height of canvas
     * @param {Object} dims.zoomX zoomX zoom value to unscale the canvas before drawing cache
     * @param {Object} dims.zoomY zoomY zoom value to unscale the canvas before drawing cache
     * @return {Object}.width width of canvas
     * @return {Object}.height height of canvas
     * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
     * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
     */ _limitCacheSize: function(dims) {
            var perfLimitSizeTotal = fabric.perfLimitSizeTotal, width = dims.width, height = dims.height, max = fabric.maxCacheSideLimit, min = fabric.minCacheSideLimit;
            if (width <= max && height <= max && width * height <= perfLimitSizeTotal) {
                if (width < min) dims.width = min;
                if (height < min) dims.height = min;
                return dims;
            }
            var ar = width / height, limitedDims = fabric.util.limitDimsByArea(ar, perfLimitSizeTotal), capValue = fabric.util.capValue, x = capValue(min, limitedDims.x, max), y = capValue(min, limitedDims.y, max);
            if (width > x) {
                dims.zoomX /= width / x;
                dims.width = x;
                dims.capped = true;
            }
            if (height > y) {
                dims.zoomY /= height / y;
                dims.height = y;
                dims.capped = true;
            }
            return dims;
        },
        /**
     * Return the dimension and the zoom level needed to create a cache canvas
     * big enough to host the object to be cached.
     * @private
     * @return {Object}.x width of object to be cached
     * @return {Object}.y height of object to be cached
     * @return {Object}.width width of canvas
     * @return {Object}.height height of canvas
     * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
     * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
     */ _getCacheCanvasDimensions: function() {
            var objectScale = this.getTotalObjectScaling(), // caculate dimensions without skewing
            dim = this._getTransformedDimensions(0, 0), neededX = dim.x * objectScale.scaleX / this.scaleX, neededY = dim.y * objectScale.scaleY / this.scaleY;
            return {
                // for sure this ALIASING_LIMIT is slightly creating problem
                // in situation in which the cache canvas gets an upper limit
                // also objectScale contains already scaleX and scaleY
                width: Math.ceil(neededX + ALIASING_LIMIT),
                height: Math.ceil(neededY + ALIASING_LIMIT),
                zoomX: objectScale.scaleX,
                zoomY: objectScale.scaleY,
                x: neededX,
                y: neededY
            };
        },
        /**
     * Update width and height of the canvas for cache
     * returns true or false if canvas needed resize.
     * @private
     * @return {Boolean} true if the canvas has been resized
     */ _updateCacheCanvas: function() {
            var targetCanvas = this.canvas;
            if (this.noScaleCache && targetCanvas && targetCanvas._currentTransform) {
                var target = targetCanvas._currentTransform.target, action = targetCanvas._currentTransform.action;
                if (this === target && action.slice && action.slice(0, 5) === 'scale') return false;
            }
            var canvas = this._cacheCanvas, dims = this._limitCacheSize(this._getCacheCanvasDimensions()), width = dims.width, height = dims.height, drawingWidth, drawingHeight, zoomX = dims.zoomX, zoomY = dims.zoomY, dimensionsChanged = width !== this.cacheWidth || height !== this.cacheHeight, zoomChanged = this.zoomX !== zoomX || this.zoomY !== zoomY, shouldRedraw = dimensionsChanged || zoomChanged;
            if (shouldRedraw) {
                if (dimensionsChanged) {
                    canvas.width = width;
                    canvas.height = height;
                } else {
                    this._cacheContext.setTransform(1, 0, 0, 1, 0, 0);
                    this._cacheContext.clearRect(0, 0, canvas.width, canvas.height);
                }
                drawingWidth = dims.x / 2;
                drawingHeight = dims.y / 2;
                this.cacheTranslationX = Math.round(canvas.width / 2 - drawingWidth) + drawingWidth;
                this.cacheTranslationY = Math.round(canvas.height / 2 - drawingHeight) + drawingHeight;
                this.cacheWidth = width;
                this.cacheHeight = height;
                this._cacheContext.translate(this.cacheTranslationX, this.cacheTranslationY);
                this._cacheContext.scale(zoomX, zoomY);
                this.zoomX = zoomX;
                this.zoomY = zoomY;
                return true;
            }
            return false;
        },
        /**
     * Sets object's properties from options
     * @param {Object} [options] Options object
     */ setOptions: function(options) {
            this._setOptions(options);
            this._initGradient(options.fill, 'fill');
            this._initGradient(options.stroke, 'stroke');
            this._initPattern(options.fill, 'fill');
            this._initPattern(options.stroke, 'stroke');
        },
        /**
     * Transforms context when rendering an object
     * @param {CanvasRenderingContext2D} ctx Context
     */ transform: function(ctx) {
            var needFullTransform = this.group && !this.group._transformDone || this.group && this.canvas && ctx === this.canvas.contextTop;
            var m = this.calcTransformMatrix(!needFullTransform);
            ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
        },
        /**
     * Returns an object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of an instance
     */ toObject: function(propertiesToInclude) {
            var NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS, object = {
                type: this.type,
                version: fabric.version,
                originX: this.originX,
                originY: this.originY,
                left: toFixed(this.left, NUM_FRACTION_DIGITS),
                top: toFixed(this.top, NUM_FRACTION_DIGITS),
                width: toFixed(this.width, NUM_FRACTION_DIGITS),
                height: toFixed(this.height, NUM_FRACTION_DIGITS),
                fill: this.fill && this.fill.toObject ? this.fill.toObject() : this.fill,
                stroke: this.stroke && this.stroke.toObject ? this.stroke.toObject() : this.stroke,
                strokeWidth: toFixed(this.strokeWidth, NUM_FRACTION_DIGITS),
                strokeDashArray: this.strokeDashArray ? this.strokeDashArray.concat() : this.strokeDashArray,
                strokeLineCap: this.strokeLineCap,
                strokeDashOffset: this.strokeDashOffset,
                strokeLineJoin: this.strokeLineJoin,
                strokeUniform: this.strokeUniform,
                strokeMiterLimit: toFixed(this.strokeMiterLimit, NUM_FRACTION_DIGITS),
                scaleX: toFixed(this.scaleX, NUM_FRACTION_DIGITS),
                scaleY: toFixed(this.scaleY, NUM_FRACTION_DIGITS),
                angle: toFixed(this.angle, NUM_FRACTION_DIGITS),
                flipX: this.flipX,
                flipY: this.flipY,
                opacity: toFixed(this.opacity, NUM_FRACTION_DIGITS),
                shadow: this.shadow && this.shadow.toObject ? this.shadow.toObject() : this.shadow,
                visible: this.visible,
                backgroundColor: this.backgroundColor,
                fillRule: this.fillRule,
                paintFirst: this.paintFirst,
                globalCompositeOperation: this.globalCompositeOperation,
                skewX: toFixed(this.skewX, NUM_FRACTION_DIGITS),
                skewY: toFixed(this.skewY, NUM_FRACTION_DIGITS)
            };
            if (this.clipPath && !this.clipPath.excludeFromExport) {
                object.clipPath = this.clipPath.toObject(propertiesToInclude);
                object.clipPath.inverted = this.clipPath.inverted;
                object.clipPath.absolutePositioned = this.clipPath.absolutePositioned;
            }
            fabric.util.populateWithProperties(this, object, propertiesToInclude);
            if (!this.includeDefaultValues) object = this._removeDefaultValues(object);
            return object;
        },
        /**
     * Returns (dataless) object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of an instance
     */ toDatalessObject: function(propertiesToInclude) {
            // will be overwritten by subclasses
            return this.toObject(propertiesToInclude);
        },
        /**
     * @private
     * @param {Object} object
     */ _removeDefaultValues: function(object) {
            var prototype = fabric.util.getKlass(object.type).prototype, stateProperties = prototype.stateProperties;
            stateProperties.forEach(function(prop) {
                if (prop === 'left' || prop === 'top') return;
                if (object[prop] === prototype[prop]) delete object[prop];
                // basically a check for [] === []
                if (Array.isArray(object[prop]) && Array.isArray(prototype[prop]) && object[prop].length === 0 && prototype[prop].length === 0) delete object[prop];
            });
            return object;
        },
        /**
     * Returns a string representation of an instance
     * @return {String}
     */ toString: function() {
            return '#<fabric.' + capitalize(this.type) + '>';
        },
        /**
     * Return the object scale factor counting also the group scaling
     * @return {Object} object with scaleX and scaleY properties
     */ getObjectScaling: function() {
            // if the object is a top level one, on the canvas, we go for simple aritmetic
            // otherwise the complex method with angles will return approximations and decimals
            // and will likely kill the cache when not needed
            // https://github.com/fabricjs/fabric.js/issues/7157
            if (!this.group) return {
                scaleX: this.scaleX,
                scaleY: this.scaleY
            };
            // if we are inside a group total zoom calculation is complex, we defer to generic matrices
            var options = fabric.util.qrDecompose(this.calcTransformMatrix());
            return {
                scaleX: Math.abs(options.scaleX),
                scaleY: Math.abs(options.scaleY)
            };
        },
        /**
     * Return the object scale factor counting also the group scaling, zoom and retina
     * @return {Object} object with scaleX and scaleY properties
     */ getTotalObjectScaling: function() {
            var scale = this.getObjectScaling(), scaleX = scale.scaleX, scaleY = scale.scaleY;
            if (this.canvas) {
                var zoom = this.canvas.getZoom();
                var retina = this.canvas.getRetinaScaling();
                scaleX *= zoom * retina;
                scaleY *= zoom * retina;
            }
            return {
                scaleX: scaleX,
                scaleY: scaleY
            };
        },
        /**
     * Return the object opacity counting also the group property
     * @return {Number}
     */ getObjectOpacity: function() {
            var opacity = this.opacity;
            if (this.group) opacity *= this.group.getObjectOpacity();
            return opacity;
        },
        /**
     * @private
     * @param {String} key
     * @param {*} value
     * @return {fabric.Object} thisArg
     */ _set: function(key, value) {
            var shouldConstrainValue = key === 'scaleX' || key === 'scaleY', isChanged = this[key] !== value, groupNeedsUpdate = false;
            if (shouldConstrainValue) value = this._constrainScale(value);
            if (key === 'scaleX' && value < 0) {
                this.flipX = !this.flipX;
                value *= -1;
            } else if (key === 'scaleY' && value < 0) {
                this.flipY = !this.flipY;
                value *= -1;
            } else if (key === 'shadow' && value && !(value instanceof fabric.Shadow)) value = new fabric.Shadow(value);
            else if (key === 'dirty' && this.group) this.group.set('dirty', value);
            this[key] = value;
            if (isChanged) {
                groupNeedsUpdate = this.group && this.group.isOnACache();
                if (this.cacheProperties.indexOf(key) > -1) {
                    this.dirty = true;
                    groupNeedsUpdate && this.group.set('dirty', true);
                } else if (groupNeedsUpdate && this.stateProperties.indexOf(key) > -1) this.group.set('dirty', true);
            }
            return this;
        },
        /**
     * This callback function is called by the parent group of an object every
     * time a non-delegated property changes on the group. It is passed the key
     * and value as parameters. Not adding in this function's signature to avoid
     * Travis build error about unused variables.
     */ setOnGroup: function() {
        // implemented by sub-classes, as needed.
        },
        /**
     * Retrieves viewportTransform from Object's canvas if possible
     * @method getViewportTransform
     * @memberOf fabric.Object.prototype
     * @return {Array}
     */ getViewportTransform: function() {
            if (this.canvas && this.canvas.viewportTransform) return this.canvas.viewportTransform;
            return fabric.iMatrix.concat();
        },
        /*
     * @private
     * return if the object would be visible in rendering
     * @memberOf fabric.Object.prototype
     * @return {Boolean}
     */ isNotVisible: function() {
            return this.opacity === 0 || !this.width && !this.height && this.strokeWidth === 0 || !this.visible;
        },
        /**
     * Renders an object on a specified context
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ render: function(ctx) {
            // do not render if width/height are zeros or object is not visible
            if (this.isNotVisible()) return;
            if (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen()) return;
            ctx.save();
            this._setupCompositeOperation(ctx);
            this.drawSelectionBackground(ctx);
            this.transform(ctx);
            this._setOpacity(ctx);
            this._setShadow(ctx, this);
            if (this.shouldCache()) {
                this.renderCache();
                this.drawCacheOnCanvas(ctx);
            } else {
                this._removeCacheCanvas();
                this.dirty = false;
                this.drawObject(ctx);
                if (this.objectCaching && this.statefullCache) this.saveState({
                    propertySet: 'cacheProperties'
                });
            }
            ctx.restore();
        },
        renderCache: function(options) {
            options = options || {};
            if (!this._cacheCanvas || !this._cacheContext) this._createCacheCanvas();
            if (this.isCacheDirty()) {
                this.statefullCache && this.saveState({
                    propertySet: 'cacheProperties'
                });
                this.drawObject(this._cacheContext, options.forClipping);
                this.dirty = false;
            }
        },
        /**
     * Remove cacheCanvas and its dimensions from the objects
     */ _removeCacheCanvas: function() {
            this._cacheCanvas = null;
            this._cacheContext = null;
            this.cacheWidth = 0;
            this.cacheHeight = 0;
        },
        /**
     * return true if the object will draw a stroke
     * Does not consider text styles. This is just a shortcut used at rendering time
     * We want it to be an approximation and be fast.
     * wrote to avoid extra caching, it has to return true when stroke happens,
     * can guess when it will not happen at 100% chance, does not matter if it misses
     * some use case where the stroke is invisible.
     * @since 3.0.0
     * @returns Boolean
     */ hasStroke: function() {
            return this.stroke && this.stroke !== 'transparent' && this.strokeWidth !== 0;
        },
        /**
     * return true if the object will draw a fill
     * Does not consider text styles. This is just a shortcut used at rendering time
     * We want it to be an approximation and be fast.
     * wrote to avoid extra caching, it has to return true when fill happens,
     * can guess when it will not happen at 100% chance, does not matter if it misses
     * some use case where the fill is invisible.
     * @since 3.0.0
     * @returns Boolean
     */ hasFill: function() {
            return this.fill && this.fill !== 'transparent';
        },
        /**
     * When set to `true`, force the object to have its own cache, even if it is inside a group
     * it may be needed when your object behave in a particular way on the cache and always needs
     * its own isolated canvas to render correctly.
     * Created to be overridden
     * since 1.7.12
     * @returns Boolean
     */ needsItsOwnCache: function() {
            if (this.paintFirst === 'stroke' && this.hasFill() && this.hasStroke() && typeof this.shadow === 'object') return true;
            if (this.clipPath) return true;
            return false;
        },
        /**
     * Decide if the object should cache or not. Create its own cache level
     * objectCaching is a global flag, wins over everything
     * needsItsOwnCache should be used when the object drawing method requires
     * a cache step. None of the fabric classes requires it.
     * Generally you do not cache objects in groups because the group outside is cached.
     * Read as: cache if is needed, or if the feature is enabled but we are not already caching.
     * @return {Boolean}
     */ shouldCache: function() {
            this.ownCaching = this.needsItsOwnCache() || this.objectCaching && (!this.group || !this.group.isOnACache());
            return this.ownCaching;
        },
        /**
     * Check if this object or a child object will cast a shadow
     * used by Group.shouldCache to know if child has a shadow recursively
     * @return {Boolean}
     */ willDrawShadow: function() {
            return !!this.shadow && (this.shadow.offsetX !== 0 || this.shadow.offsetY !== 0);
        },
        /**
     * Execute the drawing operation for an object clipPath
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {fabric.Object} clipPath
     */ drawClipPathOnCache: function(ctx, clipPath) {
            ctx.save();
            // DEBUG: uncomment this line, comment the following
            // ctx.globalAlpha = 0.4
            if (clipPath.inverted) ctx.globalCompositeOperation = 'destination-out';
            else ctx.globalCompositeOperation = 'destination-in';
            //ctx.scale(1 / 2, 1 / 2);
            if (clipPath.absolutePositioned) {
                var m = fabric.util.invertTransform(this.calcTransformMatrix());
                ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            }
            clipPath.transform(ctx);
            ctx.scale(1 / clipPath.zoomX, 1 / clipPath.zoomY);
            ctx.drawImage(clipPath._cacheCanvas, -clipPath.cacheTranslationX, -clipPath.cacheTranslationY);
            ctx.restore();
        },
        /**
     * Execute the drawing operation for an object on a specified context
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ drawObject: function(ctx, forClipping) {
            var originalFill = this.fill, originalStroke = this.stroke;
            if (forClipping) {
                this.fill = 'black';
                this.stroke = '';
                this._setClippingProperties(ctx);
            } else this._renderBackground(ctx);
            this._render(ctx);
            this._drawClipPath(ctx, this.clipPath);
            this.fill = originalFill;
            this.stroke = originalStroke;
        },
        /**
     * Prepare clipPath state and cache and draw it on instance's cache
     * @param {CanvasRenderingContext2D} ctx
     * @param {fabric.Object} clipPath
     */ _drawClipPath: function(ctx, clipPath) {
            if (!clipPath) return;
            // needed to setup a couple of variables
            // path canvas gets overridden with this one.
            // TODO find a better solution?
            clipPath.canvas = this.canvas;
            clipPath.shouldCache();
            clipPath._transformDone = true;
            clipPath.renderCache({
                forClipping: true
            });
            this.drawClipPathOnCache(ctx, clipPath);
        },
        /**
     * Paint the cached copy of the object on the target context.
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ drawCacheOnCanvas: function(ctx) {
            ctx.scale(1 / this.zoomX, 1 / this.zoomY);
            ctx.drawImage(this._cacheCanvas, -this.cacheTranslationX, -this.cacheTranslationY);
        },
        /**
     * Check if cache is dirty
     * @param {Boolean} skipCanvas skip canvas checks because this object is painted
     * on parent canvas.
     */ isCacheDirty: function(skipCanvas) {
            if (this.isNotVisible()) return false;
            if (this._cacheCanvas && this._cacheContext && !skipCanvas && this._updateCacheCanvas()) // in this case the context is already cleared.
            return true;
            else if (this.dirty || this.clipPath && this.clipPath.absolutePositioned || this.statefullCache && this.hasStateChanged('cacheProperties')) {
                if (this._cacheCanvas && this._cacheContext && !skipCanvas) {
                    var width = this.cacheWidth / this.zoomX;
                    var height = this.cacheHeight / this.zoomY;
                    this._cacheContext.clearRect(-width / 2, -height / 2, width, height);
                }
                return true;
            }
            return false;
        },
        /**
     * Draws a background for the object big as its untransformed dimensions
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _renderBackground: function(ctx) {
            if (!this.backgroundColor) return;
            var dim = this._getNonTransformedDimensions();
            ctx.fillStyle = this.backgroundColor;
            ctx.fillRect(-dim.x / 2, -dim.y / 2, dim.x, dim.y);
            // if there is background color no other shadows
            // should be casted
            this._removeShadow(ctx);
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _setOpacity: function(ctx) {
            if (this.group && !this.group._transformDone) ctx.globalAlpha = this.getObjectOpacity();
            else ctx.globalAlpha *= this.opacity;
        },
        _setStrokeStyles: function(ctx, decl) {
            var stroke = decl.stroke;
            if (stroke) {
                ctx.lineWidth = decl.strokeWidth;
                ctx.lineCap = decl.strokeLineCap;
                ctx.lineDashOffset = decl.strokeDashOffset;
                ctx.lineJoin = decl.strokeLineJoin;
                ctx.miterLimit = decl.strokeMiterLimit;
                if (stroke.toLive) {
                    if (stroke.gradientUnits === 'percentage' || stroke.gradientTransform || stroke.patternTransform) // need to transform gradient in a pattern.
                    // this is a slow process. If you are hitting this codepath, and the object
                    // is not using caching, you should consider switching it on.
                    // we need a canvas as big as the current object caching canvas.
                    this._applyPatternForTransformedGradient(ctx, stroke);
                    else {
                        // is a simple gradient or pattern
                        ctx.strokeStyle = stroke.toLive(ctx, this);
                        this._applyPatternGradientTransform(ctx, stroke);
                    }
                } else // is a color
                ctx.strokeStyle = decl.stroke;
            }
        },
        _setFillStyles: function(ctx, decl) {
            var fill = decl.fill;
            if (fill) {
                if (fill.toLive) {
                    ctx.fillStyle = fill.toLive(ctx, this);
                    this._applyPatternGradientTransform(ctx, decl.fill);
                } else ctx.fillStyle = fill;
            }
        },
        _setClippingProperties: function(ctx) {
            ctx.globalAlpha = 1;
            ctx.strokeStyle = 'transparent';
            ctx.fillStyle = '#000000';
        },
        /**
     * @private
     * Sets line dash
     * @param {CanvasRenderingContext2D} ctx Context to set the dash line on
     * @param {Array} dashArray array representing dashes
     */ _setLineDash: function(ctx, dashArray) {
            if (!dashArray || dashArray.length === 0) return;
            // Spec requires the concatenation of two copies the dash list when the number of elements is odd
            if (1 & dashArray.length) dashArray.push.apply(dashArray, dashArray);
            ctx.setLineDash(dashArray);
        },
        /**
     * Renders controls and borders for the object
     * the context here is not transformed
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Object} [styleOverride] properties to override the object style
     */ _renderControls: function(ctx, styleOverride) {
            var vpt = this.getViewportTransform(), matrix = this.calcTransformMatrix(), options, drawBorders, drawControls;
            styleOverride = styleOverride || {};
            drawBorders = typeof styleOverride.hasBorders !== 'undefined' ? styleOverride.hasBorders : this.hasBorders;
            drawControls = typeof styleOverride.hasControls !== 'undefined' ? styleOverride.hasControls : this.hasControls;
            matrix = fabric.util.multiplyTransformMatrices(vpt, matrix);
            options = fabric.util.qrDecompose(matrix);
            ctx.save();
            ctx.translate(options.translateX, options.translateY);
            ctx.lineWidth = 1 * this.borderScaleFactor;
            if (!this.group) ctx.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
            if (this.flipX) options.angle -= 180;
            ctx.rotate(degreesToRadians(this.group ? options.angle : this.angle));
            if (styleOverride.forActiveSelection || this.group) drawBorders && this.drawBordersInGroup(ctx, options, styleOverride);
            else drawBorders && this.drawBorders(ctx, styleOverride);
            drawControls && this.drawControls(ctx, styleOverride);
            ctx.restore();
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _setShadow: function(ctx) {
            if (!this.shadow) return;
            var shadow = this.shadow, canvas = this.canvas, scaling, multX = canvas && canvas.viewportTransform[0] || 1, multY = canvas && canvas.viewportTransform[3] || 1;
            if (shadow.nonScaling) scaling = {
                scaleX: 1,
                scaleY: 1
            };
            else scaling = this.getObjectScaling();
            if (canvas && canvas._isRetinaScaling()) {
                multX *= fabric.devicePixelRatio;
                multY *= fabric.devicePixelRatio;
            }
            ctx.shadowColor = shadow.color;
            ctx.shadowBlur = shadow.blur * fabric.browserShadowBlurConstant * (multX + multY) * (scaling.scaleX + scaling.scaleY) / 4;
            ctx.shadowOffsetX = shadow.offsetX * multX * scaling.scaleX;
            ctx.shadowOffsetY = shadow.offsetY * multY * scaling.scaleY;
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _removeShadow: function(ctx) {
            if (!this.shadow) return;
            ctx.shadowColor = '';
            ctx.shadowBlur = ctx.shadowOffsetX = ctx.shadowOffsetY = 0;
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Object} filler fabric.Pattern or fabric.Gradient
     * @return {Object} offset.offsetX offset for text rendering
     * @return {Object} offset.offsetY offset for text rendering
     */ _applyPatternGradientTransform: function(ctx, filler) {
            if (!filler || !filler.toLive) return {
                offsetX: 0,
                offsetY: 0
            };
            var t = filler.gradientTransform || filler.patternTransform;
            var offsetX = -this.width / 2 + filler.offsetX || 0, offsetY = -this.height / 2 + filler.offsetY || 0;
            if (filler.gradientUnits === 'percentage') ctx.transform(this.width, 0, 0, this.height, offsetX, offsetY);
            else ctx.transform(1, 0, 0, 1, offsetX, offsetY);
            if (t) ctx.transform(t[0], t[1], t[2], t[3], t[4], t[5]);
            return {
                offsetX: offsetX,
                offsetY: offsetY
            };
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _renderPaintInOrder: function(ctx) {
            if (this.paintFirst === 'stroke') {
                this._renderStroke(ctx);
                this._renderFill(ctx);
            } else {
                this._renderFill(ctx);
                this._renderStroke(ctx);
            }
        },
        /**
     * @private
     * function that actually render something on the context.
     * empty here to allow Obects to work on tests to benchmark fabric functionalites
     * not related to rendering
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _render: function() {},
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _renderFill: function(ctx) {
            if (!this.fill) return;
            ctx.save();
            this._setFillStyles(ctx, this);
            if (this.fillRule === 'evenodd') ctx.fill('evenodd');
            else ctx.fill();
            ctx.restore();
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _renderStroke: function(ctx) {
            if (!this.stroke || this.strokeWidth === 0) return;
            if (this.shadow && !this.shadow.affectStroke) this._removeShadow(ctx);
            ctx.save();
            if (this.strokeUniform && this.group) {
                var scaling = this.getObjectScaling();
                ctx.scale(1 / scaling.scaleX, 1 / scaling.scaleY);
            } else if (this.strokeUniform) ctx.scale(1 / this.scaleX, 1 / this.scaleY);
            this._setLineDash(ctx, this.strokeDashArray);
            this._setStrokeStyles(ctx, this);
            ctx.stroke();
            ctx.restore();
        },
        /**
     * This function try to patch the missing gradientTransform on canvas gradients.
     * transforming a context to transform the gradient, is going to transform the stroke too.
     * we want to transform the gradient but not the stroke operation, so we create
     * a transformed gradient on a pattern and then we use the pattern instead of the gradient.
     * this method has drwabacks: is slow, is in low resolution, needs a patch for when the size
     * is limited.
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {fabric.Gradient} filler a fabric gradient instance
     */ _applyPatternForTransformedGradient: function(ctx, filler) {
            var dims = this._limitCacheSize(this._getCacheCanvasDimensions()), pCanvas = fabric.util.createCanvasElement(), pCtx, retinaScaling = this.canvas.getRetinaScaling(), width = dims.x / this.scaleX / retinaScaling, height = dims.y / this.scaleY / retinaScaling;
            pCanvas.width = Math.ceil(width);
            pCanvas.height = Math.ceil(height);
            pCtx = pCanvas.getContext('2d');
            pCtx.beginPath();
            pCtx.moveTo(0, 0);
            pCtx.lineTo(width, 0);
            pCtx.lineTo(width, height);
            pCtx.lineTo(0, height);
            pCtx.closePath();
            pCtx.translate(width / 2, height / 2);
            pCtx.scale(dims.zoomX / this.scaleX / retinaScaling, dims.zoomY / this.scaleY / retinaScaling);
            this._applyPatternGradientTransform(pCtx, filler);
            pCtx.fillStyle = filler.toLive(ctx);
            pCtx.fill();
            ctx.translate(-this.width / 2 - this.strokeWidth / 2, -this.height / 2 - this.strokeWidth / 2);
            ctx.scale(retinaScaling * this.scaleX / dims.zoomX, retinaScaling * this.scaleY / dims.zoomY);
            ctx.strokeStyle = pCtx.createPattern(pCanvas, 'no-repeat');
        },
        /**
     * This function is an helper for svg import. it returns the center of the object in the svg
     * untransformed coordinates
     * @private
     * @return {Object} center point from element coordinates
     */ _findCenterFromElement: function() {
            return {
                x: this.left + this.width / 2,
                y: this.top + this.height / 2
            };
        },
        /**
     * This function is an helper for svg import. it decompose the transformMatrix
     * and assign properties to object.
     * untransformed coordinates
     * @private
     * @chainable
     */ _assignTransformMatrixProps: function() {
            if (this.transformMatrix) {
                var options = fabric.util.qrDecompose(this.transformMatrix);
                this.flipX = false;
                this.flipY = false;
                this.set('scaleX', options.scaleX);
                this.set('scaleY', options.scaleY);
                this.angle = options.angle;
                this.skewX = options.skewX;
                this.skewY = 0;
            }
        },
        /**
     * This function is an helper for svg import. it removes the transform matrix
     * and set to object properties that fabricjs can handle
     * @private
     * @param {Object} preserveAspectRatioOptions
     * @return {thisArg}
     */ _removeTransformMatrix: function(preserveAspectRatioOptions) {
            var center = this._findCenterFromElement();
            if (this.transformMatrix) {
                this._assignTransformMatrixProps();
                center = fabric.util.transformPoint(center, this.transformMatrix);
            }
            this.transformMatrix = null;
            if (preserveAspectRatioOptions) {
                this.scaleX *= preserveAspectRatioOptions.scaleX;
                this.scaleY *= preserveAspectRatioOptions.scaleY;
                this.cropX = preserveAspectRatioOptions.cropX;
                this.cropY = preserveAspectRatioOptions.cropY;
                center.x += preserveAspectRatioOptions.offsetLeft;
                center.y += preserveAspectRatioOptions.offsetTop;
                this.width = preserveAspectRatioOptions.width;
                this.height = preserveAspectRatioOptions.height;
            }
            this.setPositionByOrigin(center, 'center', 'center');
        },
        /**
     * Clones an instance, using a callback method will work for every object.
     * @param {Function} callback Callback is invoked with a clone as a first argument
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     */ clone: function(callback, propertiesToInclude) {
            var objectForm = this.toObject(propertiesToInclude);
            if (this.constructor.fromObject) this.constructor.fromObject(objectForm, callback);
            else fabric.Object._fromObject('Object', objectForm, callback);
        },
        /**
     * Creates an instance of fabric.Image out of an object
     * makes use of toCanvasElement.
     * Once this method was based on toDataUrl and loadImage, so it also had a quality
     * and format option. toCanvasElement is faster and produce no loss of quality.
     * If you need to get a real Jpeg or Png from an object, using toDataURL is the right way to do it.
     * toCanvasElement and then toBlob from the obtained canvas is also a good option.
     * This method is sync now, but still support the callback because we did not want to break.
     * When fabricJS 5.0 will be planned, this will probably be changed to not have a callback.
     * @param {Function} callback callback, invoked with an instance as a first argument
     * @param {Object} [options] for clone as image, passed to toDataURL
     * @param {Number} [options.multiplier=1] Multiplier to scale by
     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
     * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
     * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
     * @return {fabric.Object} thisArg
     */ cloneAsImage: function(callback, options) {
            var canvasEl = this.toCanvasElement(options);
            if (callback) callback(new fabric.Image(canvasEl));
            return this;
        },
        /**
     * Converts an object into a HTMLCanvas element
     * @param {Object} options Options object
     * @param {Number} [options.multiplier=1] Multiplier to scale by
     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
     * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
     * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
     * @return {HTMLCanvasElement} Returns DOM element <canvas> with the fabric.Object
     */ toCanvasElement: function(options) {
            options || (options = {});
            var utils = fabric.util, origParams = utils.saveObjectTransform(this), originalGroup = this.group, originalShadow = this.shadow, abs = Math.abs, multiplier = (options.multiplier || 1) * (options.enableRetinaScaling ? fabric.devicePixelRatio : 1);
            delete this.group;
            if (options.withoutTransform) utils.resetObjectTransform(this);
            if (options.withoutShadow) this.shadow = null;
            var el = fabric.util.createCanvasElement(), // skip canvas zoom and calculate with setCoords now.
            boundingRect = this.getBoundingRect(true, true), shadow = this.shadow, scaling, shadowOffset = {
                x: 0,
                y: 0
            }, shadowBlur, width, height;
            if (shadow) {
                shadowBlur = shadow.blur;
                if (shadow.nonScaling) scaling = {
                    scaleX: 1,
                    scaleY: 1
                };
                else scaling = this.getObjectScaling();
                // consider non scaling shadow.
                shadowOffset.x = 2 * Math.round(abs(shadow.offsetX) + shadowBlur) * abs(scaling.scaleX);
                shadowOffset.y = 2 * Math.round(abs(shadow.offsetY) + shadowBlur) * abs(scaling.scaleY);
            }
            width = boundingRect.width + shadowOffset.x;
            height = boundingRect.height + shadowOffset.y;
            // if the current width/height is not an integer
            // we need to make it so.
            el.width = Math.ceil(width);
            el.height = Math.ceil(height);
            var canvas = new fabric.StaticCanvas(el, {
                enableRetinaScaling: false,
                renderOnAddRemove: false,
                skipOffscreen: false
            });
            if (options.format === 'jpeg') canvas.backgroundColor = '#fff';
            this.setPositionByOrigin(new fabric.Point(canvas.width / 2, canvas.height / 2), 'center', 'center');
            var originalCanvas = this.canvas;
            canvas.add(this);
            var canvasEl = canvas.toCanvasElement(multiplier || 1, options);
            this.shadow = originalShadow;
            this.set('canvas', originalCanvas);
            if (originalGroup) this.group = originalGroup;
            this.set(origParams).setCoords();
            // canvas.dispose will call image.dispose that will nullify the elements
            // since this canvas is a simple element for the process, we remove references
            // to objects in this way in order to avoid object trashing.
            canvas._objects = [];
            canvas.dispose();
            canvas = null;
            return canvasEl;
        },
        /**
     * Converts an object into a data-url-like string
     * @param {Object} options Options object
     * @param {String} [options.format=png] The format of the output image. Either "jpeg" or "png"
     * @param {Number} [options.quality=1] Quality level (0..1). Only used for jpeg.
     * @param {Number} [options.multiplier=1] Multiplier to scale by
     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
     * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
     * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
     * @return {String} Returns a data: URL containing a representation of the object in the format specified by options.format
     */ toDataURL: function(options) {
            options || (options = {});
            return fabric.util.toDataURL(this.toCanvasElement(options), options.format || 'png', options.quality || 1);
        },
        /**
     * Returns true if specified type is identical to the type of an instance
     * @param {String} type Type to check against
     * @return {Boolean}
     */ isType: function(type) {
            return arguments.length > 1 ? Array.from(arguments).includes(this.type) : this.type === type;
        },
        /**
     * Returns complexity of an instance
     * @return {Number} complexity of this instance (is 1 unless subclassed)
     */ complexity: function() {
            return 1;
        },
        /**
     * Returns a JSON representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} JSON
     */ toJSON: function(propertiesToInclude) {
            // delegate, not alias
            return this.toObject(propertiesToInclude);
        },
        /**
     * Sets "angle" of an instance with centered rotation
     * @param {Number} angle Angle value (in degrees)
     * @return {fabric.Object} thisArg
     * @chainable
     */ rotate: function(angle) {
            var shouldCenterOrigin = (this.originX !== 'center' || this.originY !== 'center') && this.centeredRotation;
            if (shouldCenterOrigin) this._setOriginToCenter();
            this.set('angle', angle);
            if (shouldCenterOrigin) this._resetOrigin();
            return this;
        },
        /**
     * Centers object horizontally on canvas to which it was added last.
     * You might need to call `setCoords` on an object after centering, to update controls area.
     * @return {fabric.Object} thisArg
     * @chainable
     */ centerH: function() {
            this.canvas && this.canvas.centerObjectH(this);
            return this;
        },
        /**
     * Centers object horizontally on current viewport of canvas to which it was added last.
     * You might need to call `setCoords` on an object after centering, to update controls area.
     * @return {fabric.Object} thisArg
     * @chainable
     */ viewportCenterH: function() {
            this.canvas && this.canvas.viewportCenterObjectH(this);
            return this;
        },
        /**
     * Centers object vertically on canvas to which it was added last.
     * You might need to call `setCoords` on an object after centering, to update controls area.
     * @return {fabric.Object} thisArg
     * @chainable
     */ centerV: function() {
            this.canvas && this.canvas.centerObjectV(this);
            return this;
        },
        /**
     * Centers object vertically on current viewport of canvas to which it was added last.
     * You might need to call `setCoords` on an object after centering, to update controls area.
     * @return {fabric.Object} thisArg
     * @chainable
     */ viewportCenterV: function() {
            this.canvas && this.canvas.viewportCenterObjectV(this);
            return this;
        },
        /**
     * Centers object vertically and horizontally on canvas to which is was added last
     * You might need to call `setCoords` on an object after centering, to update controls area.
     * @return {fabric.Object} thisArg
     * @chainable
     */ center: function() {
            this.canvas && this.canvas.centerObject(this);
            return this;
        },
        /**
     * Centers object on current viewport of canvas to which it was added last.
     * You might need to call `setCoords` on an object after centering, to update controls area.
     * @return {fabric.Object} thisArg
     * @chainable
     */ viewportCenter: function() {
            this.canvas && this.canvas.viewportCenterObject(this);
            return this;
        },
        /**
     * Returns coordinates of a pointer relative to an object
     * @param {Event} e Event to operate upon
     * @param {Object} [pointer] Pointer to operate upon (instead of event)
     * @return {Object} Coordinates of a pointer (x, y)
     */ getLocalPointer: function(e, pointer) {
            pointer = pointer || this.canvas.getPointer(e);
            var pClicked = new fabric.Point(pointer.x, pointer.y), objectLeftTop = this._getLeftTopCoords();
            if (this.angle) pClicked = fabric.util.rotatePoint(pClicked, objectLeftTop, degreesToRadians(-this.angle));
            return {
                x: pClicked.x - objectLeftTop.x,
                y: pClicked.y - objectLeftTop.y
            };
        },
        /**
     * Sets canvas globalCompositeOperation for specific object
     * custom composition operation for the particular object can be specified using globalCompositeOperation property
     * @param {CanvasRenderingContext2D} ctx Rendering canvas context
     */ _setupCompositeOperation: function(ctx) {
            if (this.globalCompositeOperation) ctx.globalCompositeOperation = this.globalCompositeOperation;
        },
        /**
     * cancel instance's running animations
     * override if necessary to dispose artifacts such as `clipPath`
     */ dispose: function() {
            if (fabric.runningAnimations) fabric.runningAnimations.cancelByTarget(this);
        }
    });
    fabric.util.createAccessors && fabric.util.createAccessors(fabric.Object);
    extend(fabric.Object.prototype, fabric.Observable);
    /**
   * Defines the number of fraction digits to use when serializing object values.
   * You can use it to increase/decrease precision of such values like left, top, scaleX, scaleY, etc.
   * @static
   * @memberOf fabric.Object
   * @constant
   * @type Number
   */ fabric.Object.NUM_FRACTION_DIGITS = 2;
    /**
   * Defines which properties should be enlivened from the object passed to {@link fabric.Object._fromObject}
   * @static
   * @memberOf fabric.Object
   * @constant
   * @type string[]
   */ fabric.Object.ENLIVEN_PROPS = [
        'clipPath'
    ];
    fabric.Object._fromObject = function(className, object, callback, extraParam) {
        var klass = fabric[className];
        object = clone(object, true);
        fabric.util.enlivenPatterns([
            object.fill,
            object.stroke
        ], function(patterns) {
            if (typeof patterns[0] !== 'undefined') object.fill = patterns[0];
            if (typeof patterns[1] !== 'undefined') object.stroke = patterns[1];
            fabric.util.enlivenObjectEnlivables(object, object, function() {
                var instance = extraParam ? new klass(object[extraParam], object) : new klass(object);
                callback && callback(instance);
            });
        });
    };
    /**
   * Unique id used internally when creating SVG elements
   * @static
   * @memberOf fabric.Object
   * @type Number
   */ fabric.Object.__uid = 0;
})($79564f678731bf19$exports);
(function() {
    var degreesToRadians = $79564f678731bf19$var$fabric.util.degreesToRadians, originXOffset = {
        left: -0.5,
        center: 0,
        right: 0.5
    }, originYOffset = {
        top: -0.5,
        center: 0,
        bottom: 0.5
    };
    $79564f678731bf19$var$fabric.util.object.extend($79564f678731bf19$var$fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
        /**
     * Translates the coordinates from a set of origin to another (based on the object's dimensions)
     * @param {fabric.Point} point The point which corresponds to the originX and originY params
     * @param {String} fromOriginX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} fromOriginY Vertical origin: 'top', 'center' or 'bottom'
     * @param {String} toOriginX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} toOriginY Vertical origin: 'top', 'center' or 'bottom'
     * @return {fabric.Point}
     */ translateToGivenOrigin: function(point, fromOriginX, fromOriginY, toOriginX, toOriginY) {
            var x = point.x, y = point.y, offsetX, offsetY, dim;
            if (typeof fromOriginX === 'string') fromOriginX = originXOffset[fromOriginX];
            else fromOriginX -= 0.5;
            if (typeof toOriginX === 'string') toOriginX = originXOffset[toOriginX];
            else toOriginX -= 0.5;
            offsetX = toOriginX - fromOriginX;
            if (typeof fromOriginY === 'string') fromOriginY = originYOffset[fromOriginY];
            else fromOriginY -= 0.5;
            if (typeof toOriginY === 'string') toOriginY = originYOffset[toOriginY];
            else toOriginY -= 0.5;
            offsetY = toOriginY - fromOriginY;
            if (offsetX || offsetY) {
                dim = this._getTransformedDimensions();
                x = point.x + offsetX * dim.x;
                y = point.y + offsetY * dim.y;
            }
            return new $79564f678731bf19$var$fabric.Point(x, y);
        },
        /**
     * Translates the coordinates from origin to center coordinates (based on the object's dimensions)
     * @param {fabric.Point} point The point which corresponds to the originX and originY params
     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
     * @return {fabric.Point}
     */ translateToCenterPoint: function(point, originX, originY) {
            var p = this.translateToGivenOrigin(point, originX, originY, 'center', 'center');
            if (this.angle) return $79564f678731bf19$var$fabric.util.rotatePoint(p, point, degreesToRadians(this.angle));
            return p;
        },
        /**
     * Translates the coordinates from center to origin coordinates (based on the object's dimensions)
     * @param {fabric.Point} center The point which corresponds to center of the object
     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
     * @return {fabric.Point}
     */ translateToOriginPoint: function(center, originX, originY) {
            var p = this.translateToGivenOrigin(center, 'center', 'center', originX, originY);
            if (this.angle) return $79564f678731bf19$var$fabric.util.rotatePoint(p, center, degreesToRadians(this.angle));
            return p;
        },
        /**
     * Returns the real center coordinates of the object
     * @return {fabric.Point}
     */ getCenterPoint: function() {
            var leftTop = new $79564f678731bf19$var$fabric.Point(this.left, this.top);
            return this.translateToCenterPoint(leftTop, this.originX, this.originY);
        },
        /**
     * Returns the coordinates of the object based on center coordinates
     * @param {fabric.Point} point The point which corresponds to the originX and originY params
     * @return {fabric.Point}
     */ // getOriginPoint: function(center) {
        //   return this.translateToOriginPoint(center, this.originX, this.originY);
        // },
        /**
     * Returns the coordinates of the object as if it has a different origin
     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
     * @return {fabric.Point}
     */ getPointByOrigin: function(originX, originY) {
            var center = this.getCenterPoint();
            return this.translateToOriginPoint(center, originX, originY);
        },
        /**
     * Returns the point in local coordinates
     * @param {fabric.Point} point The point relative to the global coordinate system
     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
     * @return {fabric.Point}
     */ toLocalPoint: function(point, originX, originY) {
            var center = this.getCenterPoint(), p, p2;
            if (typeof originX !== 'undefined' && typeof originY !== 'undefined') p = this.translateToGivenOrigin(center, 'center', 'center', originX, originY);
            else p = new $79564f678731bf19$var$fabric.Point(this.left, this.top);
            p2 = new $79564f678731bf19$var$fabric.Point(point.x, point.y);
            if (this.angle) p2 = $79564f678731bf19$var$fabric.util.rotatePoint(p2, center, -degreesToRadians(this.angle));
            return p2.subtractEquals(p);
        },
        /**
     * Returns the point in global coordinates
     * @param {fabric.Point} The point relative to the local coordinate system
     * @return {fabric.Point}
     */ // toGlobalPoint: function(point) {
        //   return fabric.util.rotatePoint(point, this.getCenterPoint(), degreesToRadians(this.angle)).addEquals(new fabric.Point(this.left, this.top));
        // },
        /**
     * Sets the position of the object taking into consideration the object's origin
     * @param {fabric.Point} pos The new position of the object
     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
     * @return {void}
     */ setPositionByOrigin: function(pos, originX, originY) {
            var center = this.translateToCenterPoint(pos, originX, originY), position = this.translateToOriginPoint(center, this.originX, this.originY);
            this.set('left', position.x);
            this.set('top', position.y);
        },
        /**
     * @param {String} to One of 'left', 'center', 'right'
     */ adjustPosition: function(to) {
            var angle = degreesToRadians(this.angle), hypotFull = this.getScaledWidth(), xFull = $79564f678731bf19$var$fabric.util.cos(angle) * hypotFull, yFull = $79564f678731bf19$var$fabric.util.sin(angle) * hypotFull, offsetFrom, offsetTo;
            //TODO: this function does not consider mixed situation like top, center.
            if (typeof this.originX === 'string') offsetFrom = originXOffset[this.originX];
            else offsetFrom = this.originX - 0.5;
            if (typeof to === 'string') offsetTo = originXOffset[to];
            else offsetTo = to - 0.5;
            this.left += xFull * (offsetTo - offsetFrom);
            this.top += yFull * (offsetTo - offsetFrom);
            this.setCoords();
            this.originX = to;
        },
        /**
     * Sets the origin/position of the object to it's center point
     * @private
     * @return {void}
     */ _setOriginToCenter: function() {
            this._originalOriginX = this.originX;
            this._originalOriginY = this.originY;
            var center = this.getCenterPoint();
            this.originX = 'center';
            this.originY = 'center';
            this.left = center.x;
            this.top = center.y;
        },
        /**
     * Resets the origin/position of the object to it's original origin
     * @private
     * @return {void}
     */ _resetOrigin: function() {
            var originPoint = this.translateToOriginPoint(this.getCenterPoint(), this._originalOriginX, this._originalOriginY);
            this.originX = this._originalOriginX;
            this.originY = this._originalOriginY;
            this.left = originPoint.x;
            this.top = originPoint.y;
            this._originalOriginX = null;
            this._originalOriginY = null;
        },
        /**
     * @private
     */ _getLeftTopCoords: function() {
            return this.translateToOriginPoint(this.getCenterPoint(), 'left', 'top');
        }
    });
})();
(function() {
    function arrayFromCoords(coords) {
        return [
            new $79564f678731bf19$var$fabric.Point(coords.tl.x, coords.tl.y),
            new $79564f678731bf19$var$fabric.Point(coords.tr.x, coords.tr.y),
            new $79564f678731bf19$var$fabric.Point(coords.br.x, coords.br.y),
            new $79564f678731bf19$var$fabric.Point(coords.bl.x, coords.bl.y)
        ];
    }
    var util = $79564f678731bf19$var$fabric.util, degreesToRadians = util.degreesToRadians, multiplyMatrices = util.multiplyTransformMatrices, transformPoint = util.transformPoint;
    util.object.extend($79564f678731bf19$var$fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
        /**
     * Describe object's corner position in canvas element coordinates.
     * properties are depending on control keys and padding the main controls.
     * each property is an object with x, y and corner.
     * The `corner` property contains in a similar manner the 4 points of the
     * interactive area of the corner.
     * The coordinates depends from the controls positionHandler and are used
     * to draw and locate controls
     * @memberOf fabric.Object.prototype
     */ oCoords: null,
        /**
     * Describe object's corner position in canvas object absolute coordinates
     * properties are tl,tr,bl,br and describe the four main corner.
     * each property is an object with x, y, instance of Fabric.Point.
     * The coordinates depends from this properties: width, height, scaleX, scaleY
     * skewX, skewY, angle, strokeWidth, top, left.
     * Those coordinates are useful to understand where an object is. They get updated
     * with oCoords but they do not need to be updated when zoom or panning change.
     * The coordinates get updated with @method setCoords.
     * You can calculate them without updating with @method calcACoords();
     * @memberOf fabric.Object.prototype
     */ aCoords: null,
        /**
     * Describe object's corner position in canvas element coordinates.
     * includes padding. Used of object detection.
     * set and refreshed with setCoords.
     * @memberOf fabric.Object.prototype
     */ lineCoords: null,
        /**
     * storage for object transform matrix
     */ ownMatrixCache: null,
        /**
     * storage for object full transform matrix
     */ matrixCache: null,
        /**
     * custom controls interface
     * controls are added by default_controls.js
     */ controls: {},
        /**
     * return correct set of coordinates for intersection
     * this will return either aCoords or lineCoords.
     * @param {Boolean} absolute will return aCoords if true or lineCoords
     * @return {Object} {tl, tr, br, bl} points
     */ _getCoords: function(absolute, calculate) {
            if (calculate) return absolute ? this.calcACoords() : this.calcLineCoords();
            if (!this.aCoords || !this.lineCoords) this.setCoords(true);
            return absolute ? this.aCoords : this.lineCoords;
        },
        /**
     * return correct set of coordinates for intersection
     * this will return either aCoords or lineCoords.
     * The coords are returned in an array.
     * @return {Array} [tl, tr, br, bl] of points
     */ getCoords: function(absolute, calculate) {
            return arrayFromCoords(this._getCoords(absolute, calculate));
        },
        /**
     * Checks if object intersects with an area formed by 2 points
     * @param {Object} pointTL top-left point of area
     * @param {Object} pointBR bottom-right point of area
     * @param {Boolean} [absolute] use coordinates without viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
     * @return {Boolean} true if object intersects with an area formed by 2 points
     */ intersectsWithRect: function(pointTL, pointBR, absolute, calculate) {
            var coords = this.getCoords(absolute, calculate), intersection = $79564f678731bf19$var$fabric.Intersection.intersectPolygonRectangle(coords, pointTL, pointBR);
            return intersection.status === 'Intersection';
        },
        /**
     * Checks if object intersects with another object
     * @param {Object} other Object to test
     * @param {Boolean} [absolute] use coordinates without viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
     * @return {Boolean} true if object intersects with another object
     */ intersectsWithObject: function(other, absolute, calculate) {
            var intersection = $79564f678731bf19$var$fabric.Intersection.intersectPolygonPolygon(this.getCoords(absolute, calculate), other.getCoords(absolute, calculate));
            return intersection.status === 'Intersection' || other.isContainedWithinObject(this, absolute, calculate) || this.isContainedWithinObject(other, absolute, calculate);
        },
        /**
     * Checks if object is fully contained within area of another object
     * @param {Object} other Object to test
     * @param {Boolean} [absolute] use coordinates without viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
     * @return {Boolean} true if object is fully contained within area of another object
     */ isContainedWithinObject: function(other, absolute, calculate) {
            var points = this.getCoords(absolute, calculate), otherCoords = absolute ? other.aCoords : other.lineCoords, i = 0, lines = other._getImageLines(otherCoords);
            for(; i < 4; i++){
                if (!other.containsPoint(points[i], lines)) return false;
            }
            return true;
        },
        /**
     * Checks if object is fully contained within area formed by 2 points
     * @param {Object} pointTL top-left point of area
     * @param {Object} pointBR bottom-right point of area
     * @param {Boolean} [absolute] use coordinates without viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
     * @return {Boolean} true if object is fully contained within area formed by 2 points
     */ isContainedWithinRect: function(pointTL, pointBR, absolute, calculate) {
            var boundingRect = this.getBoundingRect(absolute, calculate);
            return boundingRect.left >= pointTL.x && boundingRect.left + boundingRect.width <= pointBR.x && boundingRect.top >= pointTL.y && boundingRect.top + boundingRect.height <= pointBR.y;
        },
        /**
     * Checks if point is inside the object
     * @param {fabric.Point} point Point to check against
     * @param {Object} [lines] object returned from @method _getImageLines
     * @param {Boolean} [absolute] use coordinates without viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
     * @return {Boolean} true if point is inside the object
     */ containsPoint: function(point, lines, absolute, calculate) {
            var coords = this._getCoords(absolute, calculate), lines = lines || this._getImageLines(coords), xPoints = this._findCrossPoints(point, lines);
            // if xPoints is odd then point is inside the object
            return xPoints !== 0 && xPoints % 2 === 1;
        },
        /**
     * Checks if object is contained within the canvas with current viewportTransform
     * the check is done stopping at first point that appears on screen
     * @param {Boolean} [calculate] use coordinates of current position instead of .aCoords
     * @return {Boolean} true if object is fully or partially contained within canvas
     */ isOnScreen: function(calculate) {
            if (!this.canvas) return false;
            var pointTL = this.canvas.vptCoords.tl, pointBR = this.canvas.vptCoords.br;
            var points = this.getCoords(true, calculate);
            // if some point is on screen, the object is on screen.
            if (points.some(function(point) {
                return point.x <= pointBR.x && point.x >= pointTL.x && point.y <= pointBR.y && point.y >= pointTL.y;
            })) return true;
            // no points on screen, check intersection with absolute coordinates
            if (this.intersectsWithRect(pointTL, pointBR, true, calculate)) return true;
            return this._containsCenterOfCanvas(pointTL, pointBR, calculate);
        },
        /**
     * Checks if the object contains the midpoint between canvas extremities
     * Does not make sense outside the context of isOnScreen and isPartiallyOnScreen
     * @private
     * @param {Fabric.Point} pointTL Top Left point
     * @param {Fabric.Point} pointBR Top Right point
     * @param {Boolean} calculate use coordinates of current position instead of .oCoords
     * @return {Boolean} true if the object contains the point
     */ _containsCenterOfCanvas: function(pointTL, pointBR, calculate) {
            // worst case scenario the object is so big that contains the screen
            var centerPoint = {
                x: (pointTL.x + pointBR.x) / 2,
                y: (pointTL.y + pointBR.y) / 2
            };
            if (this.containsPoint(centerPoint, null, true, calculate)) return true;
            return false;
        },
        /**
     * Checks if object is partially contained within the canvas with current viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
     * @return {Boolean} true if object is partially contained within canvas
     */ isPartiallyOnScreen: function(calculate) {
            if (!this.canvas) return false;
            var pointTL = this.canvas.vptCoords.tl, pointBR = this.canvas.vptCoords.br;
            if (this.intersectsWithRect(pointTL, pointBR, true, calculate)) return true;
            var allPointsAreOutside = this.getCoords(true, calculate).every(function(point) {
                return (point.x >= pointBR.x || point.x <= pointTL.x) && (point.y >= pointBR.y || point.y <= pointTL.y);
            });
            return allPointsAreOutside && this._containsCenterOfCanvas(pointTL, pointBR, calculate);
        },
        /**
     * Method that returns an object with the object edges in it, given the coordinates of the corners
     * @private
     * @param {Object} oCoords Coordinates of the object corners
     */ _getImageLines: function(oCoords) {
            var lines = {
                topline: {
                    o: oCoords.tl,
                    d: oCoords.tr
                },
                rightline: {
                    o: oCoords.tr,
                    d: oCoords.br
                },
                bottomline: {
                    o: oCoords.br,
                    d: oCoords.bl
                },
                leftline: {
                    o: oCoords.bl,
                    d: oCoords.tl
                }
            };
            // // debugging
            // if (this.canvas.contextTop) {
            //   this.canvas.contextTop.fillRect(lines.bottomline.d.x, lines.bottomline.d.y, 2, 2);
            //   this.canvas.contextTop.fillRect(lines.bottomline.o.x, lines.bottomline.o.y, 2, 2);
            //
            //   this.canvas.contextTop.fillRect(lines.leftline.d.x, lines.leftline.d.y, 2, 2);
            //   this.canvas.contextTop.fillRect(lines.leftline.o.x, lines.leftline.o.y, 2, 2);
            //
            //   this.canvas.contextTop.fillRect(lines.topline.d.x, lines.topline.d.y, 2, 2);
            //   this.canvas.contextTop.fillRect(lines.topline.o.x, lines.topline.o.y, 2, 2);
            //
            //   this.canvas.contextTop.fillRect(lines.rightline.d.x, lines.rightline.d.y, 2, 2);
            //   this.canvas.contextTop.fillRect(lines.rightline.o.x, lines.rightline.o.y, 2, 2);
            // }
            return lines;
        },
        /**
     * Helper method to determine how many cross points are between the 4 object edges
     * and the horizontal line determined by a point on canvas
     * @private
     * @param {fabric.Point} point Point to check
     * @param {Object} lines Coordinates of the object being evaluated
     */ // remove yi, not used but left code here just in case.
        _findCrossPoints: function(point, lines) {
            var b1, b2, a1, a2, xi, xcount = 0, iLine;
            for(var lineKey in lines){
                iLine = lines[lineKey];
                // optimisation 1: line below point. no cross
                if (iLine.o.y < point.y && iLine.d.y < point.y) continue;
                // optimisation 2: line above point. no cross
                if (iLine.o.y >= point.y && iLine.d.y >= point.y) continue;
                // optimisation 3: vertical line case
                if (iLine.o.x === iLine.d.x && iLine.o.x >= point.x) xi = iLine.o.x;
                else {
                    b1 = 0;
                    b2 = (iLine.d.y - iLine.o.y) / (iLine.d.x - iLine.o.x);
                    a1 = point.y - b1 * point.x;
                    a2 = iLine.o.y - b2 * iLine.o.x;
                    xi = -(a1 - a2) / (b1 - b2);
                // yi = a1 + b1 * xi;
                }
                // dont count xi < point.x cases
                if (xi >= point.x) xcount += 1;
                // optimisation 4: specific for square images
                if (xcount === 2) break;
            }
            return xcount;
        },
        /**
     * Returns coordinates of object's bounding rectangle (left, top, width, height)
     * the box is intended as aligned to axis of canvas.
     * @param {Boolean} [absolute] use coordinates without viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords / .aCoords
     * @return {Object} Object with left, top, width, height properties
     */ getBoundingRect: function(absolute, calculate) {
            var coords = this.getCoords(absolute, calculate);
            return util.makeBoundingBoxFromPoints(coords);
        },
        /**
     * Returns width of an object's bounding box counting transformations
     * before 2.0 it was named getWidth();
     * @return {Number} width value
     */ getScaledWidth: function() {
            return this._getTransformedDimensions().x;
        },
        /**
     * Returns height of an object bounding box counting transformations
     * before 2.0 it was named getHeight();
     * @return {Number} height value
     */ getScaledHeight: function() {
            return this._getTransformedDimensions().y;
        },
        /**
     * Makes sure the scale is valid and modifies it if necessary
     * @private
     * @param {Number} value
     * @return {Number}
     */ _constrainScale: function(value) {
            if (Math.abs(value) < this.minScaleLimit) {
                if (value < 0) return -this.minScaleLimit;
                else return this.minScaleLimit;
            } else if (value === 0) return 0.0001;
            return value;
        },
        /**
     * Scales an object (equally by x and y)
     * @param {Number} value Scale factor
     * @return {fabric.Object} thisArg
     * @chainable
     */ scale: function(value) {
            this._set('scaleX', value);
            this._set('scaleY', value);
            return this.setCoords();
        },
        /**
     * Scales an object to a given width, with respect to bounding box (scaling by x/y equally)
     * @param {Number} value New width value
     * @param {Boolean} absolute ignore viewport
     * @return {fabric.Object} thisArg
     * @chainable
     */ scaleToWidth: function(value, absolute) {
            // adjust to bounding rect factor so that rotated shapes would fit as well
            var boundingRectFactor = this.getBoundingRect(absolute).width / this.getScaledWidth();
            return this.scale(value / this.width / boundingRectFactor);
        },
        /**
     * Scales an object to a given height, with respect to bounding box (scaling by x/y equally)
     * @param {Number} value New height value
     * @param {Boolean} absolute ignore viewport
     * @return {fabric.Object} thisArg
     * @chainable
     */ scaleToHeight: function(value, absolute) {
            // adjust to bounding rect factor so that rotated shapes would fit as well
            var boundingRectFactor = this.getBoundingRect(absolute).height / this.getScaledHeight();
            return this.scale(value / this.height / boundingRectFactor);
        },
        calcLineCoords: function() {
            var vpt = this.getViewportTransform(), padding = this.padding, angle = degreesToRadians(this.angle), cos = util.cos(angle), sin = util.sin(angle), cosP = cos * padding, sinP = sin * padding, cosPSinP = cosP + sinP, cosPMinusSinP = cosP - sinP, aCoords = this.calcACoords();
            var lineCoords = {
                tl: transformPoint(aCoords.tl, vpt),
                tr: transformPoint(aCoords.tr, vpt),
                bl: transformPoint(aCoords.bl, vpt),
                br: transformPoint(aCoords.br, vpt)
            };
            if (padding) {
                lineCoords.tl.x -= cosPMinusSinP;
                lineCoords.tl.y -= cosPSinP;
                lineCoords.tr.x += cosPSinP;
                lineCoords.tr.y -= cosPMinusSinP;
                lineCoords.bl.x -= cosPSinP;
                lineCoords.bl.y += cosPMinusSinP;
                lineCoords.br.x += cosPMinusSinP;
                lineCoords.br.y += cosPSinP;
            }
            return lineCoords;
        },
        calcOCoords: function() {
            var rotateMatrix = this._calcRotateMatrix(), translateMatrix = this._calcTranslateMatrix(), vpt = this.getViewportTransform(), startMatrix = multiplyMatrices(vpt, translateMatrix), finalMatrix = multiplyMatrices(startMatrix, rotateMatrix), finalMatrix = multiplyMatrices(finalMatrix, [
                1 / vpt[0],
                0,
                0,
                1 / vpt[3],
                0,
                0
            ]), dim = this._calculateCurrentDimensions(), coords = {};
            this.forEachControl(function(control, key, fabricObject) {
                coords[key] = control.positionHandler(dim, finalMatrix, fabricObject);
            });
            // debug code
            // var canvas = this.canvas;
            // setTimeout(function() {
            //   canvas.contextTop.clearRect(0, 0, 700, 700);
            //   canvas.contextTop.fillStyle = 'green';
            //   Object.keys(coords).forEach(function(key) {
            //     var control = coords[key];
            //     canvas.contextTop.fillRect(control.x, control.y, 3, 3);
            //   });
            // }, 50);
            return coords;
        },
        calcACoords: function() {
            var rotateMatrix = this._calcRotateMatrix(), translateMatrix = this._calcTranslateMatrix(), finalMatrix = multiplyMatrices(translateMatrix, rotateMatrix), dim = this._getTransformedDimensions(), w = dim.x / 2, h = dim.y / 2;
            return {
                // corners
                tl: transformPoint({
                    x: -w,
                    y: -h
                }, finalMatrix),
                tr: transformPoint({
                    x: w,
                    y: -h
                }, finalMatrix),
                bl: transformPoint({
                    x: -w,
                    y: h
                }, finalMatrix),
                br: transformPoint({
                    x: w,
                    y: h
                }, finalMatrix)
            };
        },
        /**
     * Sets corner and controls position coordinates based on current angle, width and height, left and top.
     * oCoords are used to find the corners
     * aCoords are used to quickly find an object on the canvas
     * lineCoords are used to quickly find object during pointer events.
     * See {@link https://github.com/fabricjs/fabric.js/wiki/When-to-call-setCoords} and {@link http://fabricjs.com/fabric-gotchas}
     *
     * @param {Boolean} [skipCorners] skip calculation of oCoords.
     * @return {fabric.Object} thisArg
     * @chainable
     */ setCoords: function(skipCorners) {
            this.aCoords = this.calcACoords();
            // in case we are in a group, for how the inner group target check works,
            // lineCoords are exactly aCoords. Since the vpt gets absorbed by the normalized pointer.
            this.lineCoords = this.group ? this.aCoords : this.calcLineCoords();
            if (skipCorners) return this;
            // set coordinates of the draggable boxes in the corners used to scale/rotate the image
            this.oCoords = this.calcOCoords();
            this._setCornerCoords && this._setCornerCoords();
            return this;
        },
        /**
     * calculate rotation matrix of an object
     * @return {Array} rotation matrix for the object
     */ _calcRotateMatrix: function() {
            return util.calcRotateMatrix(this);
        },
        /**
     * calculate the translation matrix for an object transform
     * @return {Array} rotation matrix for the object
     */ _calcTranslateMatrix: function() {
            var center = this.getCenterPoint();
            return [
                1,
                0,
                0,
                1,
                center.x,
                center.y
            ];
        },
        transformMatrixKey: function(skipGroup) {
            var sep = '_', prefix = '';
            if (!skipGroup && this.group) prefix = this.group.transformMatrixKey(skipGroup) + sep;
            return prefix + this.top + sep + this.left + sep + this.scaleX + sep + this.scaleY + sep + this.skewX + sep + this.skewY + sep + this.angle + sep + this.originX + sep + this.originY + sep + this.width + sep + this.height + sep + this.strokeWidth + this.flipX + this.flipY;
        },
        /**
     * calculate transform matrix that represents the current transformations from the
     * object's properties.
     * @param {Boolean} [skipGroup] return transform matrix for object not counting parent transformations
     * There are some situation in which this is useful to avoid the fake rotation.
     * @return {Array} transform matrix for the object
     */ calcTransformMatrix: function(skipGroup) {
            var matrix = this.calcOwnMatrix();
            if (skipGroup || !this.group) return matrix;
            var key = this.transformMatrixKey(skipGroup), cache = this.matrixCache || (this.matrixCache = {});
            if (cache.key === key) return cache.value;
            if (this.group) matrix = multiplyMatrices(this.group.calcTransformMatrix(false), matrix);
            cache.key = key;
            cache.value = matrix;
            return matrix;
        },
        /**
     * calculate transform matrix that represents the current transformations from the
     * object's properties, this matrix does not include the group transformation
     * @return {Array} transform matrix for the object
     */ calcOwnMatrix: function() {
            var key = this.transformMatrixKey(true), cache = this.ownMatrixCache || (this.ownMatrixCache = {});
            if (cache.key === key) return cache.value;
            var tMatrix = this._calcTranslateMatrix(), options = {
                angle: this.angle,
                translateX: tMatrix[4],
                translateY: tMatrix[5],
                scaleX: this.scaleX,
                scaleY: this.scaleY,
                skewX: this.skewX,
                skewY: this.skewY,
                flipX: this.flipX,
                flipY: this.flipY
            };
            cache.key = key;
            cache.value = util.composeMatrix(options);
            return cache.value;
        },
        /*
     * Calculate object dimensions from its properties
     * @private
     * @return {Object} .x width dimension
     * @return {Object} .y height dimension
     */ _getNonTransformedDimensions: function() {
            var strokeWidth = this.strokeWidth, w = this.width + strokeWidth, h = this.height + strokeWidth;
            return {
                x: w,
                y: h
            };
        },
        /*
     * Calculate object bounding box dimensions from its properties scale, skew.
     * @param {Number} skewX, a value to override current skewX
     * @param {Number} skewY, a value to override current skewY
     * @private
     * @return {Object} .x width dimension
     * @return {Object} .y height dimension
     */ _getTransformedDimensions: function(skewX, skewY) {
            if (typeof skewX === 'undefined') skewX = this.skewX;
            if (typeof skewY === 'undefined') skewY = this.skewY;
            var dimensions, dimX, dimY, noSkew = skewX === 0 && skewY === 0;
            if (this.strokeUniform) {
                dimX = this.width;
                dimY = this.height;
            } else {
                dimensions = this._getNonTransformedDimensions();
                dimX = dimensions.x;
                dimY = dimensions.y;
            }
            if (noSkew) return this._finalizeDimensions(dimX * this.scaleX, dimY * this.scaleY);
            var bbox = util.sizeAfterTransform(dimX, dimY, {
                scaleX: this.scaleX,
                scaleY: this.scaleY,
                skewX: skewX,
                skewY: skewY
            });
            return this._finalizeDimensions(bbox.x, bbox.y);
        },
        /*
     * Calculate object bounding box dimensions from its properties scale, skew.
     * @param Number width width of the bbox
     * @param Number height height of the bbox
     * @private
     * @return {Object} .x finalized width dimension
     * @return {Object} .y finalized height dimension
     */ _finalizeDimensions: function(width, height) {
            return this.strokeUniform ? {
                x: width + this.strokeWidth,
                y: height + this.strokeWidth
            } : {
                x: width,
                y: height
            };
        },
        /*
     * Calculate object dimensions for controls box, including padding and canvas zoom.
     * and active selection
     * private
     */ _calculateCurrentDimensions: function() {
            var vpt = this.getViewportTransform(), dim = this._getTransformedDimensions(), p = transformPoint(dim, vpt, true);
            return p.scalarAdd(2 * this.padding);
        }
    });
})();
$79564f678731bf19$var$fabric.util.object.extend($79564f678731bf19$var$fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
    /**
   * Moves an object to the bottom of the stack of drawn objects
   * @return {fabric.Object} thisArg
   * @chainable
   */ sendToBack: function() {
        if (this.group) $79564f678731bf19$var$fabric.StaticCanvas.prototype.sendToBack.call(this.group, this);
        else if (this.canvas) this.canvas.sendToBack(this);
        return this;
    },
    /**
   * Moves an object to the top of the stack of drawn objects
   * @return {fabric.Object} thisArg
   * @chainable
   */ bringToFront: function() {
        if (this.group) $79564f678731bf19$var$fabric.StaticCanvas.prototype.bringToFront.call(this.group, this);
        else if (this.canvas) this.canvas.bringToFront(this);
        return this;
    },
    /**
   * Moves an object down in stack of drawn objects
   * @param {Boolean} [intersecting] If `true`, send object behind next lower intersecting object
   * @return {fabric.Object} thisArg
   * @chainable
   */ sendBackwards: function(intersecting) {
        if (this.group) $79564f678731bf19$var$fabric.StaticCanvas.prototype.sendBackwards.call(this.group, this, intersecting);
        else if (this.canvas) this.canvas.sendBackwards(this, intersecting);
        return this;
    },
    /**
   * Moves an object up in stack of drawn objects
   * @param {Boolean} [intersecting] If `true`, send object in front of next upper intersecting object
   * @return {fabric.Object} thisArg
   * @chainable
   */ bringForward: function(intersecting) {
        if (this.group) $79564f678731bf19$var$fabric.StaticCanvas.prototype.bringForward.call(this.group, this, intersecting);
        else if (this.canvas) this.canvas.bringForward(this, intersecting);
        return this;
    },
    /**
   * Moves an object to specified level in stack of drawn objects
   * @param {Number} index New position of object
   * @return {fabric.Object} thisArg
   * @chainable
   */ moveTo: function(index) {
        if (this.group && this.group.type !== 'activeSelection') $79564f678731bf19$var$fabric.StaticCanvas.prototype.moveTo.call(this.group, this, index);
        else if (this.canvas) this.canvas.moveTo(this, index);
        return this;
    }
});
/* _TO_SVG_START_ */ (function() {
    function getSvgColorString(prop, value) {
        if (!value) return prop + ': none; ';
        else if (value.toLive) return prop + ': url(#SVGID_' + value.id + '); ';
        else {
            var color = new $79564f678731bf19$var$fabric.Color(value), str = prop + ': ' + color.toRgb() + '; ', opacity = color.getAlpha();
            if (opacity !== 1) //change the color in rgb + opacity
            str += prop + '-opacity: ' + opacity.toString() + '; ';
            return str;
        }
    }
    var toFixed = $79564f678731bf19$var$fabric.util.toFixed;
    $79564f678731bf19$var$fabric.util.object.extend($79564f678731bf19$var$fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
        /**
     * Returns styles-string for svg-export
     * @param {Boolean} skipShadow a boolean to skip shadow filter output
     * @return {String}
     */ getSvgStyles: function(skipShadow) {
            var fillRule = this.fillRule ? this.fillRule : 'nonzero', strokeWidth = this.strokeWidth ? this.strokeWidth : '0', strokeDashArray = this.strokeDashArray ? this.strokeDashArray.join(' ') : 'none', strokeDashOffset = this.strokeDashOffset ? this.strokeDashOffset : '0', strokeLineCap = this.strokeLineCap ? this.strokeLineCap : 'butt', strokeLineJoin = this.strokeLineJoin ? this.strokeLineJoin : 'miter', strokeMiterLimit = this.strokeMiterLimit ? this.strokeMiterLimit : '4', opacity = typeof this.opacity !== 'undefined' ? this.opacity : '1', visibility = this.visible ? '' : ' visibility: hidden;', filter = skipShadow ? '' : this.getSvgFilter(), fill = getSvgColorString('fill', this.fill), stroke = getSvgColorString('stroke', this.stroke);
            return [
                stroke,
                'stroke-width: ',
                strokeWidth,
                '; ',
                'stroke-dasharray: ',
                strokeDashArray,
                '; ',
                'stroke-linecap: ',
                strokeLineCap,
                '; ',
                'stroke-dashoffset: ',
                strokeDashOffset,
                '; ',
                'stroke-linejoin: ',
                strokeLineJoin,
                '; ',
                'stroke-miterlimit: ',
                strokeMiterLimit,
                '; ',
                fill,
                'fill-rule: ',
                fillRule,
                '; ',
                'opacity: ',
                opacity,
                ';',
                filter,
                visibility
            ].join('');
        },
        /**
     * Returns styles-string for svg-export
     * @param {Object} style the object from which to retrieve style properties
     * @param {Boolean} useWhiteSpace a boolean to include an additional attribute in the style.
     * @return {String}
     */ getSvgSpanStyles: function(style, useWhiteSpace) {
            var term = '; ';
            var fontFamily = style.fontFamily ? 'font-family: ' + (style.fontFamily.indexOf('\'') === -1 && style.fontFamily.indexOf('"') === -1 ? '\'' + style.fontFamily + '\'' : style.fontFamily) + term : '';
            var strokeWidth = style.strokeWidth ? 'stroke-width: ' + style.strokeWidth + term : '', fontFamily = fontFamily, fontSize = style.fontSize ? 'font-size: ' + style.fontSize + 'px' + term : '', fontStyle = style.fontStyle ? 'font-style: ' + style.fontStyle + term : '', fontWeight = style.fontWeight ? 'font-weight: ' + style.fontWeight + term : '', fill = style.fill ? getSvgColorString('fill', style.fill) : '', stroke = style.stroke ? getSvgColorString('stroke', style.stroke) : '', textDecoration = this.getSvgTextDecoration(style), deltaY = style.deltaY ? 'baseline-shift: ' + -style.deltaY + '; ' : '';
            if (textDecoration) textDecoration = 'text-decoration: ' + textDecoration + term;
            return [
                stroke,
                strokeWidth,
                fontFamily,
                fontSize,
                fontStyle,
                fontWeight,
                textDecoration,
                fill,
                deltaY,
                useWhiteSpace ? 'white-space: pre; ' : ''
            ].join('');
        },
        /**
     * Returns text-decoration property for svg-export
     * @param {Object} style the object from which to retrieve style properties
     * @return {String}
     */ getSvgTextDecoration: function(style) {
            return [
                'overline',
                'underline',
                'line-through'
            ].filter(function(decoration) {
                return style[decoration.replace('-', '')];
            }).join(' ');
        },
        /**
     * Returns filter for svg shadow
     * @return {String}
     */ getSvgFilter: function() {
            return this.shadow ? 'filter: url(#SVGID_' + this.shadow.id + ');' : '';
        },
        /**
     * Returns id attribute for svg output
     * @return {String}
     */ getSvgCommons: function() {
            return [
                this.id ? 'id="' + this.id + '" ' : '',
                this.clipPath ? 'clip-path="url(#' + this.clipPath.clipPathId + ')" ' : ''
            ].join('');
        },
        /**
     * Returns transform-string for svg-export
     * @param {Boolean} use the full transform or the single object one.
     * @return {String}
     */ getSvgTransform: function(full, additionalTransform) {
            var transform = full ? this.calcTransformMatrix() : this.calcOwnMatrix(), svgTransform = 'transform="' + $79564f678731bf19$var$fabric.util.matrixToSVG(transform);
            return svgTransform + (additionalTransform || '') + '" ';
        },
        _setSVGBg: function(textBgRects) {
            if (this.backgroundColor) {
                var NUM_FRACTION_DIGITS = $79564f678731bf19$var$fabric.Object.NUM_FRACTION_DIGITS;
                textBgRects.push('\t\t<rect ', this._getFillAttributes(this.backgroundColor), ' x="', toFixed(-this.width / 2, NUM_FRACTION_DIGITS), '" y="', toFixed(-this.height / 2, NUM_FRACTION_DIGITS), '" width="', toFixed(this.width, NUM_FRACTION_DIGITS), '" height="', toFixed(this.height, NUM_FRACTION_DIGITS), '"></rect>\n');
            }
        },
        /**
     * Returns svg representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */ toSVG: function(reviver) {
            return this._createBaseSVGMarkup(this._toSVG(reviver), {
                reviver: reviver
            });
        },
        /**
     * Returns svg clipPath representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */ toClipPathSVG: function(reviver) {
            return '\t' + this._createBaseClipPathSVGMarkup(this._toSVG(reviver), {
                reviver: reviver
            });
        },
        /**
     * @private
     */ _createBaseClipPathSVGMarkup: function(objectMarkup, options) {
            options = options || {};
            var reviver = options.reviver, additionalTransform = options.additionalTransform || '', commonPieces = [
                this.getSvgTransform(true, additionalTransform),
                this.getSvgCommons()
            ].join(''), // insert commons in the markup, style and svgCommons
            index = objectMarkup.indexOf('COMMON_PARTS');
            objectMarkup[index] = commonPieces;
            return reviver ? reviver(objectMarkup.join('')) : objectMarkup.join('');
        },
        /**
     * @private
     */ _createBaseSVGMarkup: function(objectMarkup, options) {
            options = options || {};
            var noStyle = options.noStyle, reviver = options.reviver, styleInfo = noStyle ? '' : 'style="' + this.getSvgStyles() + '" ', shadowInfo = options.withShadow ? 'style="' + this.getSvgFilter() + '" ' : '', clipPath = this.clipPath, vectorEffect = this.strokeUniform ? 'vector-effect="non-scaling-stroke" ' : '', absoluteClipPath = clipPath && clipPath.absolutePositioned, stroke = this.stroke, fill = this.fill, shadow = this.shadow, commonPieces, markup = [], clipPathMarkup, // insert commons in the markup, style and svgCommons
            index = objectMarkup.indexOf('COMMON_PARTS'), additionalTransform = options.additionalTransform;
            if (clipPath) {
                clipPath.clipPathId = 'CLIPPATH_' + $79564f678731bf19$var$fabric.Object.__uid++;
                clipPathMarkup = '<clipPath id="' + clipPath.clipPathId + '" >\n' + clipPath.toClipPathSVG(reviver) + '</clipPath>\n';
            }
            if (absoluteClipPath) markup.push('<g ', shadowInfo, this.getSvgCommons(), ' >\n');
            markup.push('<g ', this.getSvgTransform(false), !absoluteClipPath ? shadowInfo + this.getSvgCommons() : '', ' >\n');
            commonPieces = [
                styleInfo,
                vectorEffect,
                noStyle ? '' : this.addPaintOrder(),
                ' ',
                additionalTransform ? 'transform="' + additionalTransform + '" ' : ''
            ].join('');
            objectMarkup[index] = commonPieces;
            if (fill && fill.toLive) markup.push(fill.toSVG(this));
            if (stroke && stroke.toLive) markup.push(stroke.toSVG(this));
            if (shadow) markup.push(shadow.toSVG(this));
            if (clipPath) markup.push(clipPathMarkup);
            markup.push(objectMarkup.join(''));
            markup.push('</g>\n');
            absoluteClipPath && markup.push('</g>\n');
            return reviver ? reviver(markup.join('')) : markup.join('');
        },
        addPaintOrder: function() {
            return this.paintFirst !== 'fill' ? ' paint-order="' + this.paintFirst + '" ' : '';
        }
    });
})();
/* _TO_SVG_END_ */ (function() {
    var extend = $79564f678731bf19$var$fabric.util.object.extend, originalSet = 'stateProperties';
    /*
    Depends on `stateProperties`
  */ function saveProps(origin, destination, props) {
        var tmpObj = {}, deep = true;
        props.forEach(function(prop) {
            tmpObj[prop] = origin[prop];
        });
        extend(origin[destination], tmpObj, deep);
    }
    function _isEqual(origValue, currentValue, firstPass) {
        if (origValue === currentValue) // if the objects are identical, return
        return true;
        else if (Array.isArray(origValue)) {
            if (!Array.isArray(currentValue) || origValue.length !== currentValue.length) return false;
            for(var i = 0, len = origValue.length; i < len; i++){
                if (!_isEqual(origValue[i], currentValue[i])) return false;
            }
            return true;
        } else if (origValue && typeof origValue === 'object') {
            var keys = Object.keys(origValue), key;
            if (!currentValue || typeof currentValue !== 'object' || !firstPass && keys.length !== Object.keys(currentValue).length) return false;
            for(var i = 0, len = keys.length; i < len; i++){
                key = keys[i];
                // since clipPath is in the statefull cache list and the clipPath objects
                // would be iterated as an object, this would lead to possible infinite recursion
                // we do not want to compare those.
                if (key === 'canvas' || key === 'group') continue;
                if (!_isEqual(origValue[key], currentValue[key])) return false;
            }
            return true;
        }
    }
    $79564f678731bf19$var$fabric.util.object.extend($79564f678731bf19$var$fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
        /**
     * Returns true if object state (one of its state properties) was changed
     * @param {String} [propertySet] optional name for the set of property we want to save
     * @return {Boolean} true if instance' state has changed since `{@link fabric.Object#saveState}` was called
     */ hasStateChanged: function(propertySet) {
            propertySet = propertySet || originalSet;
            var dashedPropertySet = '_' + propertySet;
            if (Object.keys(this[dashedPropertySet]).length < this[propertySet].length) return true;
            return !_isEqual(this[dashedPropertySet], this, true);
        },
        /**
     * Saves state of an object
     * @param {Object} [options] Object with additional `stateProperties` array to include when saving state
     * @return {fabric.Object} thisArg
     */ saveState: function(options) {
            var propertySet = options && options.propertySet || originalSet, destination = '_' + propertySet;
            if (!this[destination]) return this.setupState(options);
            saveProps(this, destination, this[propertySet]);
            if (options && options.stateProperties) saveProps(this, destination, options.stateProperties);
            return this;
        },
        /**
     * Setups state of an object
     * @param {Object} [options] Object with additional `stateProperties` array to include when saving state
     * @return {fabric.Object} thisArg
     */ setupState: function(options) {
            options = options || {};
            var propertySet = options.propertySet || originalSet;
            options.propertySet = propertySet;
            this['_' + propertySet] = {};
            this.saveState(options);
            return this;
        }
    });
})();
(function() {
    var degreesToRadians = $79564f678731bf19$var$fabric.util.degreesToRadians;
    $79564f678731bf19$var$fabric.util.object.extend($79564f678731bf19$var$fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
        /**
     * Determines which corner has been clicked
     * @private
     * @param {Object} pointer The pointer indicating the mouse position
     * @return {String|Boolean} corner code (tl, tr, bl, br, etc.), or false if nothing is found
     */ _findTargetCorner: function(pointer, forTouch) {
            // objects in group, anykind, are not self modificable,
            // must not return an hovered corner.
            if (!this.hasControls || this.group || !this.canvas || this.canvas._activeObject !== this) return false;
            var ex = pointer.x, ey = pointer.y, xPoints, lines, keys = Object.keys(this.oCoords), j = keys.length - 1, i;
            this.__corner = 0;
            // cycle in reverse order so we pick first the one on top
            for(; j >= 0; j--){
                i = keys[j];
                if (!this.isControlVisible(i)) continue;
                lines = this._getImageLines(forTouch ? this.oCoords[i].touchCorner : this.oCoords[i].corner);
                // // debugging
                //
                // this.canvas.contextTop.fillRect(lines.bottomline.d.x, lines.bottomline.d.y, 2, 2);
                // this.canvas.contextTop.fillRect(lines.bottomline.o.x, lines.bottomline.o.y, 2, 2);
                //
                // this.canvas.contextTop.fillRect(lines.leftline.d.x, lines.leftline.d.y, 2, 2);
                // this.canvas.contextTop.fillRect(lines.leftline.o.x, lines.leftline.o.y, 2, 2);
                //
                // this.canvas.contextTop.fillRect(lines.topline.d.x, lines.topline.d.y, 2, 2);
                // this.canvas.contextTop.fillRect(lines.topline.o.x, lines.topline.o.y, 2, 2);
                //
                // this.canvas.contextTop.fillRect(lines.rightline.d.x, lines.rightline.d.y, 2, 2);
                // this.canvas.contextTop.fillRect(lines.rightline.o.x, lines.rightline.o.y, 2, 2);
                xPoints = this._findCrossPoints({
                    x: ex,
                    y: ey
                }, lines);
                if (xPoints !== 0 && xPoints % 2 === 1) {
                    this.__corner = i;
                    return i;
                }
            }
            return false;
        },
        /**
     * Calls a function for each control. The function gets called,
     * with the control, the object that is calling the iterator and the control's key
     * @param {Function} fn function to iterate over the controls over
     */ forEachControl: function(fn) {
            for(var i in this.controls)fn(this.controls[i], i, this);
        },
        /**
     * Sets the coordinates of the draggable boxes in the corners of
     * the image used to scale/rotate it.
     * note: if we would switch to ROUND corner area, all of this would disappear.
     * everything would resolve to a single point and a pythagorean theorem for the distance
     * @private
     */ _setCornerCoords: function() {
            var coords = this.oCoords;
            for(var control in coords){
                var controlObject = this.controls[control];
                coords[control].corner = controlObject.calcCornerCoords(this.angle, this.cornerSize, coords[control].x, coords[control].y, false);
                coords[control].touchCorner = controlObject.calcCornerCoords(this.angle, this.touchCornerSize, coords[control].x, coords[control].y, true);
            }
        },
        /**
     * Draws a colored layer behind the object, inside its selection borders.
     * Requires public options: padding, selectionBackgroundColor
     * this function is called when the context is transformed
     * has checks to be skipped when the object is on a staticCanvas
     * @param {CanvasRenderingContext2D} ctx Context to draw on
     * @return {fabric.Object} thisArg
     * @chainable
     */ drawSelectionBackground: function(ctx) {
            if (!this.selectionBackgroundColor || this.canvas && !this.canvas.interactive || this.canvas && this.canvas._activeObject !== this) return this;
            ctx.save();
            var center = this.getCenterPoint(), wh = this._calculateCurrentDimensions(), vpt = this.canvas.viewportTransform;
            ctx.translate(center.x, center.y);
            ctx.scale(1 / vpt[0], 1 / vpt[3]);
            ctx.rotate(degreesToRadians(this.angle));
            ctx.fillStyle = this.selectionBackgroundColor;
            ctx.fillRect(-wh.x / 2, -wh.y / 2, wh.x, wh.y);
            ctx.restore();
            return this;
        },
        /**
     * Draws borders of an object's bounding box.
     * Requires public properties: width, height
     * Requires public options: padding, borderColor
     * @param {CanvasRenderingContext2D} ctx Context to draw on
     * @param {Object} styleOverride object to override the object style
     * @return {fabric.Object} thisArg
     * @chainable
     */ drawBorders: function(ctx, styleOverride) {
            styleOverride = styleOverride || {};
            var wh = this._calculateCurrentDimensions(), strokeWidth = this.borderScaleFactor, width = wh.x + strokeWidth, height = wh.y + strokeWidth, hasControls = typeof styleOverride.hasControls !== 'undefined' ? styleOverride.hasControls : this.hasControls, shouldStroke = false;
            ctx.save();
            ctx.strokeStyle = styleOverride.borderColor || this.borderColor;
            this._setLineDash(ctx, styleOverride.borderDashArray || this.borderDashArray);
            ctx.strokeRect(-width / 2, -height / 2, width, height);
            if (hasControls) {
                ctx.beginPath();
                this.forEachControl(function(control, key, fabricObject) {
                    // in this moment, the ctx is centered on the object.
                    // width and height of the above function are the size of the bbox.
                    if (control.withConnection && control.getVisibility(fabricObject, key)) {
                        // reset movement for each control
                        shouldStroke = true;
                        ctx.moveTo(control.x * width, control.y * height);
                        ctx.lineTo(control.x * width + control.offsetX, control.y * height + control.offsetY);
                    }
                });
                if (shouldStroke) ctx.stroke();
            }
            ctx.restore();
            return this;
        },
        /**
     * Draws borders of an object's bounding box when it is inside a group.
     * Requires public properties: width, height
     * Requires public options: padding, borderColor
     * @param {CanvasRenderingContext2D} ctx Context to draw on
     * @param {object} options object representing current object parameters
     * @param {Object} styleOverride object to override the object style
     * @return {fabric.Object} thisArg
     * @chainable
     */ drawBordersInGroup: function(ctx, options, styleOverride) {
            styleOverride = styleOverride || {};
            var bbox = $79564f678731bf19$var$fabric.util.sizeAfterTransform(this.width, this.height, options), strokeWidth = this.strokeWidth, strokeUniform = this.strokeUniform, borderScaleFactor = this.borderScaleFactor, width = bbox.x + strokeWidth * (strokeUniform ? this.canvas.getZoom() : options.scaleX) + borderScaleFactor, height = bbox.y + strokeWidth * (strokeUniform ? this.canvas.getZoom() : options.scaleY) + borderScaleFactor;
            ctx.save();
            this._setLineDash(ctx, styleOverride.borderDashArray || this.borderDashArray);
            ctx.strokeStyle = styleOverride.borderColor || this.borderColor;
            ctx.strokeRect(-width / 2, -height / 2, width, height);
            ctx.restore();
            return this;
        },
        /**
     * Draws corners of an object's bounding box.
     * Requires public properties: width, height
     * Requires public options: cornerSize, padding
     * @param {CanvasRenderingContext2D} ctx Context to draw on
     * @param {Object} styleOverride object to override the object style
     * @return {fabric.Object} thisArg
     * @chainable
     */ drawControls: function(ctx, styleOverride) {
            styleOverride = styleOverride || {};
            ctx.save();
            var retinaScaling = 1, matrix, p;
            if (this.canvas) retinaScaling = this.canvas.getRetinaScaling();
            ctx.setTransform(retinaScaling, 0, 0, retinaScaling, 0, 0);
            ctx.strokeStyle = ctx.fillStyle = styleOverride.cornerColor || this.cornerColor;
            if (!this.transparentCorners) ctx.strokeStyle = styleOverride.cornerStrokeColor || this.cornerStrokeColor;
            this._setLineDash(ctx, styleOverride.cornerDashArray || this.cornerDashArray);
            this.setCoords();
            if (this.group) // fabricJS does not really support drawing controls inside groups,
            // this piece of code here helps having at least the control in places.
            // If an application needs to show some objects as selected because of some UI state
            // can still call Object._renderControls() on any object they desire, independently of groups.
            // using no padding, circular controls and hiding the rotating cursor is higly suggested,
            matrix = this.group.calcTransformMatrix();
            this.forEachControl(function(control, key, fabricObject) {
                p = fabricObject.oCoords[key];
                if (control.getVisibility(fabricObject, key)) {
                    if (matrix) p = $79564f678731bf19$var$fabric.util.transformPoint(p, matrix);
                    control.render(ctx, p.x, p.y, styleOverride, fabricObject);
                }
            });
            ctx.restore();
            return this;
        },
        /**
     * Returns true if the specified control is visible, false otherwise.
     * @param {String} controlKey The key of the control. Possible values are 'tl', 'tr', 'br', 'bl', 'ml', 'mt', 'mr', 'mb', 'mtr'.
     * @returns {Boolean} true if the specified control is visible, false otherwise
     */ isControlVisible: function(controlKey) {
            return this.controls[controlKey] && this.controls[controlKey].getVisibility(this, controlKey);
        },
        /**
     * Sets the visibility of the specified control.
     * @param {String} controlKey The key of the control. Possible values are 'tl', 'tr', 'br', 'bl', 'ml', 'mt', 'mr', 'mb', 'mtr'.
     * @param {Boolean} visible true to set the specified control visible, false otherwise
     * @return {fabric.Object} thisArg
     * @chainable
     */ setControlVisible: function(controlKey, visible) {
            if (!this._controlsVisibility) this._controlsVisibility = {};
            this._controlsVisibility[controlKey] = visible;
            return this;
        },
        /**
     * Sets the visibility state of object controls.
     * @param {Object} [options] Options object
     * @param {Boolean} [options.bl] true to enable the bottom-left control, false to disable it
     * @param {Boolean} [options.br] true to enable the bottom-right control, false to disable it
     * @param {Boolean} [options.mb] true to enable the middle-bottom control, false to disable it
     * @param {Boolean} [options.ml] true to enable the middle-left control, false to disable it
     * @param {Boolean} [options.mr] true to enable the middle-right control, false to disable it
     * @param {Boolean} [options.mt] true to enable the middle-top control, false to disable it
     * @param {Boolean} [options.tl] true to enable the top-left control, false to disable it
     * @param {Boolean} [options.tr] true to enable the top-right control, false to disable it
     * @param {Boolean} [options.mtr] true to enable the middle-top-rotate control, false to disable it
     * @return {fabric.Object} thisArg
     * @chainable
     */ setControlsVisibility: function(options) {
            options || (options = {});
            for(var p in options)this.setControlVisible(p, options[p]);
            return this;
        },
        /**
     * This callback function is called every time _discardActiveObject or _setActiveObject
     * try to to deselect this object. If the function returns true, the process is cancelled
     * @param {Object} [options] options sent from the upper functions
     * @param {Event} [options.e] event if the process is generated by an event
     */ onDeselect: function() {
        // implemented by sub-classes, as needed.
        },
        /**
     * This callback function is called every time _discardActiveObject or _setActiveObject
     * try to to select this object. If the function returns true, the process is cancelled
     * @param {Object} [options] options sent from the upper functions
     * @param {Event} [options.e] event if the process is generated by an event
     */ onSelect: function() {
        // implemented by sub-classes, as needed.
        }
    });
})();
$79564f678731bf19$var$fabric.util.object.extend($79564f678731bf19$var$fabric.StaticCanvas.prototype, /** @lends fabric.StaticCanvas.prototype */ {
    /**
   * Animation duration (in ms) for fx* methods
   * @type Number
   * @default
   */ FX_DURATION: 500,
    /**
   * Centers object horizontally with animation.
   * @param {fabric.Object} object Object to center
   * @param {Object} [callbacks] Callbacks object with optional "onComplete" and/or "onChange" properties
   * @param {Function} [callbacks.onComplete] Invoked on completion
   * @param {Function} [callbacks.onChange] Invoked on every step of animation
   * @return {fabric.AnimationContext} context
   */ fxCenterObjectH: function(object, callbacks) {
        callbacks = callbacks || {};
        var empty = function() {}, onComplete = callbacks.onComplete || empty, onChange = callbacks.onChange || empty, _this = this;
        return $79564f678731bf19$var$fabric.util.animate({
            target: this,
            startValue: object.left,
            endValue: this.getCenterPoint().x,
            duration: this.FX_DURATION,
            onChange: function(value) {
                object.set('left', value);
                _this.requestRenderAll();
                onChange();
            },
            onComplete: function() {
                object.setCoords();
                onComplete();
            }
        });
    },
    /**
   * Centers object vertically with animation.
   * @param {fabric.Object} object Object to center
   * @param {Object} [callbacks] Callbacks object with optional "onComplete" and/or "onChange" properties
   * @param {Function} [callbacks.onComplete] Invoked on completion
   * @param {Function} [callbacks.onChange] Invoked on every step of animation
   * @return {fabric.AnimationContext} context
   */ fxCenterObjectV: function(object, callbacks) {
        callbacks = callbacks || {};
        var empty = function() {}, onComplete = callbacks.onComplete || empty, onChange = callbacks.onChange || empty, _this = this;
        return $79564f678731bf19$var$fabric.util.animate({
            target: this,
            startValue: object.top,
            endValue: this.getCenterPoint().y,
            duration: this.FX_DURATION,
            onChange: function(value) {
                object.set('top', value);
                _this.requestRenderAll();
                onChange();
            },
            onComplete: function() {
                object.setCoords();
                onComplete();
            }
        });
    },
    /**
   * Same as `fabric.Canvas#remove` but animated
   * @param {fabric.Object} object Object to remove
   * @param {Object} [callbacks] Callbacks object with optional "onComplete" and/or "onChange" properties
   * @param {Function} [callbacks.onComplete] Invoked on completion
   * @param {Function} [callbacks.onChange] Invoked on every step of animation
   * @return {fabric.AnimationContext} context
   */ fxRemove: function(object, callbacks) {
        callbacks = callbacks || {};
        var empty = function() {}, onComplete = callbacks.onComplete || empty, onChange = callbacks.onChange || empty, _this = this;
        return $79564f678731bf19$var$fabric.util.animate({
            target: this,
            startValue: object.opacity,
            endValue: 0,
            duration: this.FX_DURATION,
            onChange: function(value) {
                object.set('opacity', value);
                _this.requestRenderAll();
                onChange();
            },
            onComplete: function() {
                _this.remove(object);
                onComplete();
            }
        });
    }
});
$79564f678731bf19$var$fabric.util.object.extend($79564f678731bf19$var$fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
    /**
   * Animates object's properties
   * @param {String|Object} property Property to animate (if string) or properties to animate (if object)
   * @param {Number|Object} value Value to animate property to (if string was given first) or options object
   * @return {fabric.Object} thisArg
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#animation}
   * @return {fabric.AnimationContext | fabric.AnimationContext[]} animation context (or an array if passed multiple properties)
   *
   * As object — multiple properties
   *
   * object.animate({ left: ..., top: ... });
   * object.animate({ left: ..., top: ... }, { duration: ... });
   *
   * As string — one property
   *
   * object.animate('left', ...);
   * object.animate('left', { duration: ... });
   *
   */ animate: function() {
        if (arguments[0] && typeof arguments[0] === 'object') {
            var propsToAnimate = [], prop, skipCallbacks, out = [];
            for(prop in arguments[0])propsToAnimate.push(prop);
            for(var i = 0, len = propsToAnimate.length; i < len; i++){
                prop = propsToAnimate[i];
                skipCallbacks = i !== len - 1;
                out.push(this._animate(prop, arguments[0][prop], arguments[1], skipCallbacks));
            }
            return out;
        } else return this._animate.apply(this, arguments);
    },
    /**
   * @private
   * @param {String} property Property to animate
   * @param {String} to Value to animate to
   * @param {Object} [options] Options object
   * @param {Boolean} [skipCallbacks] When true, callbacks like onchange and oncomplete are not invoked
   */ _animate: function(property, to, options, skipCallbacks) {
        var _this = this, propPair;
        to = to.toString();
        if (!options) options = {};
        else options = $79564f678731bf19$var$fabric.util.object.clone(options);
        if (~property.indexOf('.')) propPair = property.split('.');
        var propIsColor = _this.colorProperties.indexOf(property) > -1 || propPair && _this.colorProperties.indexOf(propPair[1]) > -1;
        var currentValue = propPair ? this.get(propPair[0])[propPair[1]] : this.get(property);
        if (!('from' in options)) options.from = currentValue;
        if (!propIsColor) {
            if (~to.indexOf('=')) to = currentValue + parseFloat(to.replace('=', ''));
            else to = parseFloat(to);
        }
        var _options = {
            target: this,
            startValue: options.from,
            endValue: to,
            byValue: options.by,
            easing: options.easing,
            duration: options.duration,
            abort: options.abort && function(value, valueProgress, timeProgress) {
                return options.abort.call(_this, value, valueProgress, timeProgress);
            },
            onChange: function(value, valueProgress, timeProgress) {
                if (propPair) _this[propPair[0]][propPair[1]] = value;
                else _this.set(property, value);
                if (skipCallbacks) return;
                options.onChange && options.onChange(value, valueProgress, timeProgress);
            },
            onComplete: function(value, valueProgress, timeProgress) {
                if (skipCallbacks) return;
                _this.setCoords();
                options.onComplete && options.onComplete(value, valueProgress, timeProgress);
            }
        };
        if (propIsColor) return $79564f678731bf19$var$fabric.util.animateColor(_options.startValue, _options.endValue, _options.duration, _options);
        else return $79564f678731bf19$var$fabric.util.animate(_options);
    }
});
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {}), extend = fabric.util.object.extend, clone = fabric.util.object.clone, coordProps = {
        x1: 1,
        x2: 1,
        y1: 1,
        y2: 1
    };
    if (fabric.Line) {
        fabric.warn('fabric.Line is already defined');
        return;
    }
    /**
   * Line class
   * @class fabric.Line
   * @extends fabric.Object
   * @see {@link fabric.Line#initialize} for constructor definition
   */ fabric.Line = fabric.util.createClass(fabric.Object, /** @lends fabric.Line.prototype */ {
        /**
     * Type of an object
     * @type String
     * @default
     */ type: 'line',
        /**
     * x value or first line edge
     * @type Number
     * @default
     */ x1: 0,
        /**
     * y value or first line edge
     * @type Number
     * @default
     */ y1: 0,
        /**
     * x value or second line edge
     * @type Number
     * @default
     */ x2: 0,
        /**
     * y value or second line edge
     * @type Number
     * @default
     */ y2: 0,
        cacheProperties: fabric.Object.prototype.cacheProperties.concat('x1', 'x2', 'y1', 'y2'),
        /**
     * Constructor
     * @param {Array} [points] Array of points
     * @param {Object} [options] Options object
     * @return {fabric.Line} thisArg
     */ initialize: function(points, options) {
            if (!points) points = [
                0,
                0,
                0,
                0
            ];
            this.callSuper('initialize', options);
            this.set('x1', points[0]);
            this.set('y1', points[1]);
            this.set('x2', points[2]);
            this.set('y2', points[3]);
            this._setWidthHeight(options);
        },
        /**
     * @private
     * @param {Object} [options] Options
     */ _setWidthHeight: function(options) {
            options || (options = {});
            this.width = Math.abs(this.x2 - this.x1);
            this.height = Math.abs(this.y2 - this.y1);
            this.left = 'left' in options ? options.left : this._getLeftToOriginX();
            this.top = 'top' in options ? options.top : this._getTopToOriginY();
        },
        /**
     * @private
     * @param {String} key
     * @param {*} value
     */ _set: function(key, value) {
            this.callSuper('_set', key, value);
            if (typeof coordProps[key] !== 'undefined') this._setWidthHeight();
            return this;
        },
        /**
     * @private
     * @return {Number} leftToOriginX Distance from left edge of canvas to originX of Line.
     */ _getLeftToOriginX: makeEdgeToOriginGetter({
            origin: 'originX',
            axis1: 'x1',
            axis2: 'x2',
            dimension: 'width'
        }, {
            nearest: 'left',
            center: 'center',
            farthest: 'right'
        }),
        /**
     * @private
     * @return {Number} topToOriginY Distance from top edge of canvas to originY of Line.
     */ _getTopToOriginY: makeEdgeToOriginGetter({
            origin: 'originY',
            axis1: 'y1',
            axis2: 'y2',
            dimension: 'height'
        }, {
            nearest: 'top',
            center: 'center',
            farthest: 'bottom'
        }),
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _render: function(ctx) {
            ctx.beginPath();
            var p = this.calcLinePoints();
            ctx.moveTo(p.x1, p.y1);
            ctx.lineTo(p.x2, p.y2);
            ctx.lineWidth = this.strokeWidth;
            // TODO: test this
            // make sure setting "fill" changes color of a line
            // (by copying fillStyle to strokeStyle, since line is stroked, not filled)
            var origStrokeStyle = ctx.strokeStyle;
            ctx.strokeStyle = this.stroke || ctx.fillStyle;
            this.stroke && this._renderStroke(ctx);
            ctx.strokeStyle = origStrokeStyle;
        },
        /**
     * This function is an helper for svg import. it returns the center of the object in the svg
     * untransformed coordinates
     * @private
     * @return {Object} center point from element coordinates
     */ _findCenterFromElement: function() {
            return {
                x: (this.x1 + this.x2) / 2,
                y: (this.y1 + this.y2) / 2
            };
        },
        /**
     * Returns object representation of an instance
     * @method toObject
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */ toObject: function(propertiesToInclude) {
            return extend(this.callSuper('toObject', propertiesToInclude), this.calcLinePoints());
        },
        /*
     * Calculate object dimensions from its properties
     * @private
     */ _getNonTransformedDimensions: function() {
            var dim = this.callSuper('_getNonTransformedDimensions');
            if (this.strokeLineCap === 'butt') {
                if (this.width === 0) dim.y -= this.strokeWidth;
                if (this.height === 0) dim.x -= this.strokeWidth;
            }
            return dim;
        },
        /**
     * Recalculates line points given width and height
     * @private
     */ calcLinePoints: function() {
            var xMult = this.x1 <= this.x2 ? -1 : 1, yMult = this.y1 <= this.y2 ? -1 : 1, x1 = xMult * this.width * 0.5, y1 = yMult * this.height * 0.5, x2 = xMult * this.width * -0.5, y2 = yMult * this.height * -0.5;
            return {
                x1: x1,
                x2: x2,
                y1: y1,
                y2: y2
            };
        },
        /* _TO_SVG_START_ */ /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */ _toSVG: function() {
            var p = this.calcLinePoints();
            return [
                '<line ',
                'COMMON_PARTS',
                'x1="',
                p.x1,
                '" y1="',
                p.y1,
                '" x2="',
                p.x2,
                '" y2="',
                p.y2,
                '" />\n'
            ];
        }
    });
    /* _FROM_SVG_START_ */ /**
   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Line.fromElement})
   * @static
   * @memberOf fabric.Line
   * @see http://www.w3.org/TR/SVG/shapes.html#LineElement
   */ fabric.Line.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat('x1 y1 x2 y2'.split(' '));
    /**
   * Returns fabric.Line instance from an SVG element
   * @static
   * @memberOf fabric.Line
   * @param {SVGElement} element Element to parse
   * @param {Object} [options] Options object
   * @param {Function} [callback] callback function invoked after parsing
   */ fabric.Line.fromElement = function(element, callback, options) {
        options = options || {};
        var parsedAttributes = fabric.parseAttributes(element, fabric.Line.ATTRIBUTE_NAMES), points = [
            parsedAttributes.x1 || 0,
            parsedAttributes.y1 || 0,
            parsedAttributes.x2 || 0,
            parsedAttributes.y2 || 0
        ];
        callback(new fabric.Line(points, extend(parsedAttributes, options)));
    };
    /* _FROM_SVG_END_ */ /**
   * Returns fabric.Line instance from an object representation
   * @static
   * @memberOf fabric.Line
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] invoked with new instance as first argument
   */ fabric.Line.fromObject = function(object, callback) {
        function _callback(instance) {
            delete instance.points;
            callback && callback(instance);
        }
        var options = clone(object, true);
        options.points = [
            object.x1,
            object.y1,
            object.x2,
            object.y2
        ];
        fabric.Object._fromObject('Line', options, _callback, 'points');
    };
    /**
   * Produces a function that calculates distance from canvas edge to Line origin.
   */ function makeEdgeToOriginGetter(propertyNames, originValues) {
        var origin = propertyNames.origin, axis1 = propertyNames.axis1, axis2 = propertyNames.axis2, dimension = propertyNames.dimension, nearest = originValues.nearest, center = originValues.center, farthest = originValues.farthest;
        return function() {
            switch(this.get(origin)){
                case nearest:
                    return Math.min(this.get(axis1), this.get(axis2));
                case center:
                    return Math.min(this.get(axis1), this.get(axis2)) + 0.5 * this.get(dimension);
                case farthest:
                    return Math.max(this.get(axis1), this.get(axis2));
            }
        };
    }
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {}), degreesToRadians = fabric.util.degreesToRadians;
    if (fabric.Circle) {
        fabric.warn('fabric.Circle is already defined.');
        return;
    }
    /**
   * Circle class
   * @class fabric.Circle
   * @extends fabric.Object
   * @see {@link fabric.Circle#initialize} for constructor definition
   */ fabric.Circle = fabric.util.createClass(fabric.Object, /** @lends fabric.Circle.prototype */ {
        /**
     * Type of an object
     * @type String
     * @default
     */ type: 'circle',
        /**
     * Radius of this circle
     * @type Number
     * @default
     */ radius: 0,
        /**
     * degrees of start of the circle.
     * probably will change to degrees in next major version
     * @type Number 0 - 359
     * @default 0
     */ startAngle: 0,
        /**
     * End angle of the circle
     * probably will change to degrees in next major version
     * @type Number 1 - 360
     * @default 360
     */ endAngle: 360,
        cacheProperties: fabric.Object.prototype.cacheProperties.concat('radius', 'startAngle', 'endAngle'),
        /**
     * @private
     * @param {String} key
     * @param {*} value
     * @return {fabric.Circle} thisArg
     */ _set: function(key, value) {
            this.callSuper('_set', key, value);
            if (key === 'radius') this.setRadius(value);
            return this;
        },
        /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */ toObject: function(propertiesToInclude) {
            return this.callSuper('toObject', [
                'radius',
                'startAngle',
                'endAngle'
            ].concat(propertiesToInclude));
        },
        /* _TO_SVG_START_ */ /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */ _toSVG: function() {
            var svgString, x = 0, y = 0, angle = (this.endAngle - this.startAngle) % 360;
            if (angle === 0) svgString = [
                '<circle ',
                'COMMON_PARTS',
                'cx="' + x + '" cy="' + y + '" ',
                'r="',
                this.radius,
                '" />\n'
            ];
            else {
                var start = degreesToRadians(this.startAngle), end = degreesToRadians(this.endAngle), radius = this.radius, startX = fabric.util.cos(start) * radius, startY = fabric.util.sin(start) * radius, endX = fabric.util.cos(end) * radius, endY = fabric.util.sin(end) * radius, largeFlag = angle > 180 ? '1' : '0';
                svgString = [
                    '<path d="M ' + startX + ' ' + startY,
                    ' A ' + radius + ' ' + radius,
                    ' 0 ',
                    +largeFlag + ' 1',
                    ' ' + endX + ' ' + endY,
                    '" ',
                    'COMMON_PARTS',
                    ' />\n'
                ];
            }
            return svgString;
        },
        /* _TO_SVG_END_ */ /**
     * @private
     * @param {CanvasRenderingContext2D} ctx context to render on
     */ _render: function(ctx) {
            ctx.beginPath();
            ctx.arc(0, 0, this.radius, degreesToRadians(this.startAngle), degreesToRadians(this.endAngle), false);
            this._renderPaintInOrder(ctx);
        },
        /**
     * Returns horizontal radius of an object (according to how an object is scaled)
     * @return {Number}
     */ getRadiusX: function() {
            return this.get('radius') * this.get('scaleX');
        },
        /**
     * Returns vertical radius of an object (according to how an object is scaled)
     * @return {Number}
     */ getRadiusY: function() {
            return this.get('radius') * this.get('scaleY');
        },
        /**
     * Sets radius of an object (and updates width accordingly)
     * @return {fabric.Circle} thisArg
     */ setRadius: function(value) {
            this.radius = value;
            return this.set('width', value * 2).set('height', value * 2);
        }
    });
    /* _FROM_SVG_START_ */ /**
   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Circle.fromElement})
   * @static
   * @memberOf fabric.Circle
   * @see: http://www.w3.org/TR/SVG/shapes.html#CircleElement
   */ fabric.Circle.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat('cx cy r'.split(' '));
    /**
   * Returns {@link fabric.Circle} instance from an SVG element
   * @static
   * @memberOf fabric.Circle
   * @param {SVGElement} element Element to parse
   * @param {Function} [callback] Options callback invoked after parsing is finished
   * @param {Object} [options] Options object
   * @throws {Error} If value of `r` attribute is missing or invalid
   */ fabric.Circle.fromElement = function(element, callback) {
        var parsedAttributes = fabric.parseAttributes(element, fabric.Circle.ATTRIBUTE_NAMES);
        if (!isValidRadius(parsedAttributes)) throw new Error('value of `r` attribute is required and can not be negative');
        parsedAttributes.left = (parsedAttributes.left || 0) - parsedAttributes.radius;
        parsedAttributes.top = (parsedAttributes.top || 0) - parsedAttributes.radius;
        callback(new fabric.Circle(parsedAttributes));
    };
    /**
   * @private
   */ function isValidRadius(attributes) {
        return 'radius' in attributes && attributes.radius >= 0;
    }
    /* _FROM_SVG_END_ */ /**
   * Returns {@link fabric.Circle} instance from an object representation
   * @static
   * @memberOf fabric.Circle
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] invoked with new instance as first argument
   * @return {void}
   */ fabric.Circle.fromObject = function(object, callback) {
        fabric.Object._fromObject('Circle', object, callback);
    };
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {});
    if (fabric.Triangle) {
        fabric.warn('fabric.Triangle is already defined');
        return;
    }
    /**
   * Triangle class
   * @class fabric.Triangle
   * @extends fabric.Object
   * @return {fabric.Triangle} thisArg
   * @see {@link fabric.Triangle#initialize} for constructor definition
   */ fabric.Triangle = fabric.util.createClass(fabric.Object, /** @lends fabric.Triangle.prototype */ {
        /**
     * Type of an object
     * @type String
     * @default
     */ type: 'triangle',
        /**
     * Width is set to 100 to compensate the old initialize code that was setting it to 100
     * @type Number
     * @default
     */ width: 100,
        /**
     * Height is set to 100 to compensate the old initialize code that was setting it to 100
     * @type Number
     * @default
     */ height: 100,
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _render: function(ctx) {
            var widthBy2 = this.width / 2, heightBy2 = this.height / 2;
            ctx.beginPath();
            ctx.moveTo(-widthBy2, heightBy2);
            ctx.lineTo(0, -heightBy2);
            ctx.lineTo(widthBy2, heightBy2);
            ctx.closePath();
            this._renderPaintInOrder(ctx);
        },
        /* _TO_SVG_START_ */ /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */ _toSVG: function() {
            var widthBy2 = this.width / 2, heightBy2 = this.height / 2, points = [
                -widthBy2 + ' ' + heightBy2,
                '0 ' + -heightBy2,
                widthBy2 + ' ' + heightBy2
            ].join(',');
            return [
                '<polygon ',
                'COMMON_PARTS',
                'points="',
                points,
                '" />'
            ];
        }
    });
    /**
   * Returns {@link fabric.Triangle} instance from an object representation
   * @static
   * @memberOf fabric.Triangle
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] invoked with new instance as first argument
   */ fabric.Triangle.fromObject = function(object, callback) {
        return fabric.Object._fromObject('Triangle', object, callback);
    };
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {}), piBy2 = Math.PI * 2;
    if (fabric.Ellipse) {
        fabric.warn('fabric.Ellipse is already defined.');
        return;
    }
    /**
   * Ellipse class
   * @class fabric.Ellipse
   * @extends fabric.Object
   * @return {fabric.Ellipse} thisArg
   * @see {@link fabric.Ellipse#initialize} for constructor definition
   */ fabric.Ellipse = fabric.util.createClass(fabric.Object, /** @lends fabric.Ellipse.prototype */ {
        /**
     * Type of an object
     * @type String
     * @default
     */ type: 'ellipse',
        /**
     * Horizontal radius
     * @type Number
     * @default
     */ rx: 0,
        /**
     * Vertical radius
     * @type Number
     * @default
     */ ry: 0,
        cacheProperties: fabric.Object.prototype.cacheProperties.concat('rx', 'ry'),
        /**
     * Constructor
     * @param {Object} [options] Options object
     * @return {fabric.Ellipse} thisArg
     */ initialize: function(options) {
            this.callSuper('initialize', options);
            this.set('rx', options && options.rx || 0);
            this.set('ry', options && options.ry || 0);
        },
        /**
     * @private
     * @param {String} key
     * @param {*} value
     * @return {fabric.Ellipse} thisArg
     */ _set: function(key, value) {
            this.callSuper('_set', key, value);
            switch(key){
                case 'rx':
                    this.rx = value;
                    this.set('width', value * 2);
                    break;
                case 'ry':
                    this.ry = value;
                    this.set('height', value * 2);
                    break;
            }
            return this;
        },
        /**
     * Returns horizontal radius of an object (according to how an object is scaled)
     * @return {Number}
     */ getRx: function() {
            return this.get('rx') * this.get('scaleX');
        },
        /**
     * Returns Vertical radius of an object (according to how an object is scaled)
     * @return {Number}
     */ getRy: function() {
            return this.get('ry') * this.get('scaleY');
        },
        /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */ toObject: function(propertiesToInclude) {
            return this.callSuper('toObject', [
                'rx',
                'ry'
            ].concat(propertiesToInclude));
        },
        /* _TO_SVG_START_ */ /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */ _toSVG: function() {
            return [
                '<ellipse ',
                'COMMON_PARTS',
                'cx="0" cy="0" ',
                'rx="',
                this.rx,
                '" ry="',
                this.ry,
                '" />\n'
            ];
        },
        /* _TO_SVG_END_ */ /**
     * @private
     * @param {CanvasRenderingContext2D} ctx context to render on
     */ _render: function(ctx) {
            ctx.beginPath();
            ctx.save();
            ctx.transform(1, 0, 0, this.ry / this.rx, 0, 0);
            ctx.arc(0, 0, this.rx, 0, piBy2, false);
            ctx.restore();
            this._renderPaintInOrder(ctx);
        }
    });
    /* _FROM_SVG_START_ */ /**
   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Ellipse.fromElement})
   * @static
   * @memberOf fabric.Ellipse
   * @see http://www.w3.org/TR/SVG/shapes.html#EllipseElement
   */ fabric.Ellipse.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat('cx cy rx ry'.split(' '));
    /**
   * Returns {@link fabric.Ellipse} instance from an SVG element
   * @static
   * @memberOf fabric.Ellipse
   * @param {SVGElement} element Element to parse
   * @param {Function} [callback] Options callback invoked after parsing is finished
   * @return {fabric.Ellipse}
   */ fabric.Ellipse.fromElement = function(element, callback) {
        var parsedAttributes = fabric.parseAttributes(element, fabric.Ellipse.ATTRIBUTE_NAMES);
        parsedAttributes.left = (parsedAttributes.left || 0) - parsedAttributes.rx;
        parsedAttributes.top = (parsedAttributes.top || 0) - parsedAttributes.ry;
        callback(new fabric.Ellipse(parsedAttributes));
    };
    /* _FROM_SVG_END_ */ /**
   * Returns {@link fabric.Ellipse} instance from an object representation
   * @static
   * @memberOf fabric.Ellipse
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] invoked with new instance as first argument
   * @return {void}
   */ fabric.Ellipse.fromObject = function(object, callback) {
        fabric.Object._fromObject('Ellipse', object, callback);
    };
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {}), extend = fabric.util.object.extend;
    if (fabric.Rect) {
        fabric.warn('fabric.Rect is already defined');
        return;
    }
    /**
   * Rectangle class
   * @class fabric.Rect
   * @extends fabric.Object
   * @return {fabric.Rect} thisArg
   * @see {@link fabric.Rect#initialize} for constructor definition
   */ fabric.Rect = fabric.util.createClass(fabric.Object, /** @lends fabric.Rect.prototype */ {
        /**
     * List of properties to consider when checking if state of an object is changed ({@link fabric.Object#hasStateChanged})
     * as well as for history (undo/redo) purposes
     * @type Array
     */ stateProperties: fabric.Object.prototype.stateProperties.concat('rx', 'ry'),
        /**
     * Type of an object
     * @type String
     * @default
     */ type: 'rect',
        /**
     * Horizontal border radius
     * @type Number
     * @default
     */ rx: 0,
        /**
     * Vertical border radius
     * @type Number
     * @default
     */ ry: 0,
        cacheProperties: fabric.Object.prototype.cacheProperties.concat('rx', 'ry'),
        /**
     * Constructor
     * @param {Object} [options] Options object
     * @return {Object} thisArg
     */ initialize: function(options) {
            this.callSuper('initialize', options);
            this._initRxRy();
        },
        /**
     * Initializes rx/ry attributes
     * @private
     */ _initRxRy: function() {
            if (this.rx && !this.ry) this.ry = this.rx;
            else if (this.ry && !this.rx) this.rx = this.ry;
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _render: function(ctx) {
            // 1x1 case (used in spray brush) optimization was removed because
            // with caching and higher zoom level this makes more damage than help
            var rx = this.rx ? Math.min(this.rx, this.width / 2) : 0, ry = this.ry ? Math.min(this.ry, this.height / 2) : 0, w = this.width, h = this.height, x = -this.width / 2, y = -this.height / 2, isRounded = rx !== 0 || ry !== 0, /* "magic number" for bezier approximations of arcs (http://itc.ktu.lt/itc354/Riskus354.pdf) */ k = 0.4477152502;
            ctx.beginPath();
            ctx.moveTo(x + rx, y);
            ctx.lineTo(x + w - rx, y);
            isRounded && ctx.bezierCurveTo(x + w - k * rx, y, x + w, y + k * ry, x + w, y + ry);
            ctx.lineTo(x + w, y + h - ry);
            isRounded && ctx.bezierCurveTo(x + w, y + h - k * ry, x + w - k * rx, y + h, x + w - rx, y + h);
            ctx.lineTo(x + rx, y + h);
            isRounded && ctx.bezierCurveTo(x + k * rx, y + h, x, y + h - k * ry, x, y + h - ry);
            ctx.lineTo(x, y + ry);
            isRounded && ctx.bezierCurveTo(x, y + k * ry, x + k * rx, y, x + rx, y);
            ctx.closePath();
            this._renderPaintInOrder(ctx);
        },
        /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */ toObject: function(propertiesToInclude) {
            return this.callSuper('toObject', [
                'rx',
                'ry'
            ].concat(propertiesToInclude));
        },
        /* _TO_SVG_START_ */ /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */ _toSVG: function() {
            var x = -this.width / 2, y = -this.height / 2;
            return [
                '<rect ',
                'COMMON_PARTS',
                'x="',
                x,
                '" y="',
                y,
                '" rx="',
                this.rx,
                '" ry="',
                this.ry,
                '" width="',
                this.width,
                '" height="',
                this.height,
                '" />\n'
            ];
        }
    });
    /* _FROM_SVG_START_ */ /**
   * List of attribute names to account for when parsing SVG element (used by `fabric.Rect.fromElement`)
   * @static
   * @memberOf fabric.Rect
   * @see: http://www.w3.org/TR/SVG/shapes.html#RectElement
   */ fabric.Rect.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat('x y rx ry width height'.split(' '));
    /**
   * Returns {@link fabric.Rect} instance from an SVG element
   * @static
   * @memberOf fabric.Rect
   * @param {SVGElement} element Element to parse
   * @param {Function} callback callback function invoked after parsing
   * @param {Object} [options] Options object
   */ fabric.Rect.fromElement = function(element, callback, options) {
        if (!element) return callback(null);
        options = options || {};
        var parsedAttributes = fabric.parseAttributes(element, fabric.Rect.ATTRIBUTE_NAMES);
        parsedAttributes.left = parsedAttributes.left || 0;
        parsedAttributes.top = parsedAttributes.top || 0;
        parsedAttributes.height = parsedAttributes.height || 0;
        parsedAttributes.width = parsedAttributes.width || 0;
        var rect = new fabric.Rect(extend(options ? fabric.util.object.clone(options) : {}, parsedAttributes));
        rect.visible = rect.visible && rect.width > 0 && rect.height > 0;
        callback(rect);
    };
    /* _FROM_SVG_END_ */ /**
   * Returns {@link fabric.Rect} instance from an object representation
   * @static
   * @memberOf fabric.Rect
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] Callback to invoke when an fabric.Rect instance is created
   */ fabric.Rect.fromObject = function(object, callback) {
        return fabric.Object._fromObject('Rect', object, callback);
    };
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {}), extend = fabric.util.object.extend, min = fabric.util.array.min, max = fabric.util.array.max, toFixed = fabric.util.toFixed, projectStrokeOnPoints = fabric.util.projectStrokeOnPoints;
    if (fabric.Polyline) {
        fabric.warn('fabric.Polyline is already defined');
        return;
    }
    /**
   * Polyline class
   * @class fabric.Polyline
   * @extends fabric.Object
   * @see {@link fabric.Polyline#initialize} for constructor definition
   */ fabric.Polyline = fabric.util.createClass(fabric.Object, /** @lends fabric.Polyline.prototype */ {
        /**
     * Type of an object
     * @type String
     * @default
     */ type: 'polyline',
        /**
     * Points array
     * @type Array
     * @default
     */ points: null,
        /**
     * WARNING: Feature in progress
     * Calculate the exact bounding box taking in account strokeWidth on acute angles
     * this will be turned to true by default on fabric 6.0
     * maybe will be left in as an optimization since calculations may be slow
     * @deprecated
     * @type Boolean
     * @default false
     */ exactBoundingBox: false,
        cacheProperties: fabric.Object.prototype.cacheProperties.concat('points'),
        /**
     * Constructor
     * @param {Array} points Array of points (where each point is an object with x and y)
     * @param {Object} [options] Options object
     * @return {fabric.Polyline} thisArg
     * @example
     * var poly = new fabric.Polyline([
     *     { x: 10, y: 10 },
     *     { x: 50, y: 30 },
     *     { x: 40, y: 70 },
     *     { x: 60, y: 50 },
     *     { x: 100, y: 150 },
     *     { x: 40, y: 100 }
     *   ], {
     *   stroke: 'red',
     *   left: 100,
     *   top: 100
     * });
     */ initialize: function(points, options) {
            options = options || {};
            this.points = points || [];
            this.callSuper('initialize', options);
            this._setPositionDimensions(options);
        },
        /**
     * @private
     */ _projectStrokeOnPoints: function() {
            return projectStrokeOnPoints(this.points, this, true);
        },
        _setPositionDimensions: function(options) {
            var calcDim = this._calcDimensions(options), correctLeftTop, correctSize = this.exactBoundingBox ? this.strokeWidth : 0;
            this.width = calcDim.width - correctSize;
            this.height = calcDim.height - correctSize;
            if (!options.fromSVG) correctLeftTop = this.translateToGivenOrigin({
                // this looks bad, but is one way to keep it optional for now.
                x: calcDim.left - this.strokeWidth / 2 + correctSize / 2,
                y: calcDim.top - this.strokeWidth / 2 + correctSize / 2
            }, 'left', 'top', this.originX, this.originY);
            if (typeof options.left === 'undefined') this.left = options.fromSVG ? calcDim.left : correctLeftTop.x;
            if (typeof options.top === 'undefined') this.top = options.fromSVG ? calcDim.top : correctLeftTop.y;
            this.pathOffset = {
                x: calcDim.left + this.width / 2 + correctSize / 2,
                y: calcDim.top + this.height / 2 + correctSize / 2
            };
        },
        /**
     * Calculate the polygon min and max point from points array,
     * returning an object with left, top, width, height to measure the
     * polygon size
     * @return {Object} object.left X coordinate of the polygon leftmost point
     * @return {Object} object.top Y coordinate of the polygon topmost point
     * @return {Object} object.width distance between X coordinates of the polygon leftmost and rightmost point
     * @return {Object} object.height distance between Y coordinates of the polygon topmost and bottommost point
     * @private
     */ _calcDimensions: function() {
            var points = this.exactBoundingBox ? this._projectStrokeOnPoints() : this.points, minX = min(points, 'x') || 0, minY = min(points, 'y') || 0, maxX = max(points, 'x') || 0, maxY = max(points, 'y') || 0, width = maxX - minX, height = maxY - minY;
            return {
                left: minX,
                top: minY,
                width: width,
                height: height
            };
        },
        /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of an instance
     */ toObject: function(propertiesToInclude) {
            return extend(this.callSuper('toObject', propertiesToInclude), {
                points: this.points.concat()
            });
        },
        /* _TO_SVG_START_ */ /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */ _toSVG: function() {
            var points = [], diffX = this.pathOffset.x, diffY = this.pathOffset.y, NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS;
            for(var i = 0, len = this.points.length; i < len; i++)points.push(toFixed(this.points[i].x - diffX, NUM_FRACTION_DIGITS), ',', toFixed(this.points[i].y - diffY, NUM_FRACTION_DIGITS), ' ');
            return [
                '<' + this.type + ' ',
                'COMMON_PARTS',
                'points="',
                points.join(''),
                '" />\n'
            ];
        },
        /* _TO_SVG_END_ */ /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ commonRender: function(ctx) {
            var point, len = this.points.length, x = this.pathOffset.x, y = this.pathOffset.y;
            if (!len || isNaN(this.points[len - 1].y)) // do not draw if no points or odd points
            // NaN comes from parseFloat of a empty string in parser
            return false;
            ctx.beginPath();
            ctx.moveTo(this.points[0].x - x, this.points[0].y - y);
            for(var i = 0; i < len; i++){
                point = this.points[i];
                ctx.lineTo(point.x - x, point.y - y);
            }
            return true;
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _render: function(ctx) {
            if (!this.commonRender(ctx)) return;
            this._renderPaintInOrder(ctx);
        },
        /**
     * Returns complexity of an instance
     * @return {Number} complexity of this instance
     */ complexity: function() {
            return this.get('points').length;
        }
    });
    /* _FROM_SVG_START_ */ /**
   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Polyline.fromElement})
   * @static
   * @memberOf fabric.Polyline
   * @see: http://www.w3.org/TR/SVG/shapes.html#PolylineElement
   */ fabric.Polyline.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat();
    /**
   * Returns fabric.Polyline instance from an SVG element
   * @static
   * @memberOf fabric.Polyline
   * @param {SVGElement} element Element to parser
   * @param {Function} callback callback function invoked after parsing
   * @param {Object} [options] Options object
   */ fabric.Polyline.fromElementGenerator = function(_class) {
        return function(element, callback, options) {
            if (!element) return callback(null);
            options || (options = {});
            var points = fabric.parsePointsAttribute(element.getAttribute('points')), parsedAttributes = fabric.parseAttributes(element, fabric[_class].ATTRIBUTE_NAMES);
            parsedAttributes.fromSVG = true;
            callback(new fabric[_class](points, extend(parsedAttributes, options)));
        };
    };
    fabric.Polyline.fromElement = fabric.Polyline.fromElementGenerator('Polyline');
    /* _FROM_SVG_END_ */ /**
   * Returns fabric.Polyline instance from an object representation
   * @static
   * @memberOf fabric.Polyline
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] Callback to invoke when an fabric.Path instance is created
   */ fabric.Polyline.fromObject = function(object, callback) {
        return fabric.Object._fromObject('Polyline', object, callback, 'points');
    };
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {}), projectStrokeOnPoints = fabric.util.projectStrokeOnPoints;
    if (fabric.Polygon) {
        fabric.warn('fabric.Polygon is already defined');
        return;
    }
    /**
   * Polygon class
   * @class fabric.Polygon
   * @extends fabric.Polyline
   * @see {@link fabric.Polygon#initialize} for constructor definition
   */ fabric.Polygon = fabric.util.createClass(fabric.Polyline, /** @lends fabric.Polygon.prototype */ {
        /**
     * Type of an object
     * @type String
     * @default
     */ type: 'polygon',
        /**
     * @private
     */ _projectStrokeOnPoints: function() {
            return projectStrokeOnPoints(this.points, this);
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _render: function(ctx) {
            if (!this.commonRender(ctx)) return;
            ctx.closePath();
            this._renderPaintInOrder(ctx);
        }
    });
    /* _FROM_SVG_START_ */ /**
   * List of attribute names to account for when parsing SVG element (used by `fabric.Polygon.fromElement`)
   * @static
   * @memberOf fabric.Polygon
   * @see: http://www.w3.org/TR/SVG/shapes.html#PolygonElement
   */ fabric.Polygon.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat();
    /**
   * Returns {@link fabric.Polygon} instance from an SVG element
   * @static
   * @memberOf fabric.Polygon
   * @param {SVGElement} element Element to parse
   * @param {Function} callback callback function invoked after parsing
   * @param {Object} [options] Options object
   */ fabric.Polygon.fromElement = fabric.Polyline.fromElementGenerator('Polygon');
    /* _FROM_SVG_END_ */ /**
   * Returns fabric.Polygon instance from an object representation
   * @static
   * @memberOf fabric.Polygon
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] Callback to invoke when an fabric.Path instance is created
   * @return {void}
   */ fabric.Polygon.fromObject = function(object, callback) {
        fabric.Object._fromObject('Polygon', object, callback, 'points');
    };
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {}), min = fabric.util.array.min, max = fabric.util.array.max, extend = fabric.util.object.extend, clone = fabric.util.object.clone, toFixed = fabric.util.toFixed;
    if (fabric.Path) {
        fabric.warn('fabric.Path is already defined');
        return;
    }
    /**
   * Path class
   * @class fabric.Path
   * @extends fabric.Object
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#path_and_pathgroup}
   * @see {@link fabric.Path#initialize} for constructor definition
   */ fabric.Path = fabric.util.createClass(fabric.Object, /** @lends fabric.Path.prototype */ {
        /**
     * Type of an object
     * @type String
     * @default
     */ type: 'path',
        /**
     * Array of path points
     * @type Array
     * @default
     */ path: null,
        cacheProperties: fabric.Object.prototype.cacheProperties.concat('path', 'fillRule'),
        stateProperties: fabric.Object.prototype.stateProperties.concat('path'),
        /**
     * Constructor
     * @param {Array|String} path Path data (sequence of coordinates and corresponding "command" tokens)
     * @param {Object} [options] Options object
     * @return {fabric.Path} thisArg
     */ initialize: function(path, options) {
            options = clone(options || {});
            delete options.path;
            this.callSuper('initialize', options);
            this._setPath(path || [], options);
        },
        /**
    * @private
    * @param {Array|String} path Path data (sequence of coordinates and corresponding "command" tokens)
    * @param {Object} [options] Options object
    */ _setPath: function(path, options) {
            this.path = fabric.util.makePathSimpler(Array.isArray(path) ? path : fabric.util.parsePath(path));
            fabric.Polyline.prototype._setPositionDimensions.call(this, options || {});
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx context to render path on
     */ _renderPathCommands: function(ctx) {
            var current, subpathStartX = 0, subpathStartY = 0, x = 0, y = 0, controlX = 0, controlY = 0, l = -this.pathOffset.x, t = -this.pathOffset.y;
            ctx.beginPath();
            for(var i = 0, len = this.path.length; i < len; ++i){
                current = this.path[i];
                switch(current[0]){
                    case 'L':
                        x = current[1];
                        y = current[2];
                        ctx.lineTo(x + l, y + t);
                        break;
                    case 'M':
                        x = current[1];
                        y = current[2];
                        subpathStartX = x;
                        subpathStartY = y;
                        ctx.moveTo(x + l, y + t);
                        break;
                    case 'C':
                        x = current[5];
                        y = current[6];
                        controlX = current[3];
                        controlY = current[4];
                        ctx.bezierCurveTo(current[1] + l, current[2] + t, controlX + l, controlY + t, x + l, y + t);
                        break;
                    case 'Q':
                        ctx.quadraticCurveTo(current[1] + l, current[2] + t, current[3] + l, current[4] + t);
                        x = current[3];
                        y = current[4];
                        controlX = current[1];
                        controlY = current[2];
                        break;
                    case 'z':
                    case 'Z':
                        x = subpathStartX;
                        y = subpathStartY;
                        ctx.closePath();
                        break;
                }
            }
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx context to render path on
     */ _render: function(ctx) {
            this._renderPathCommands(ctx);
            this._renderPaintInOrder(ctx);
        },
        /**
     * Returns string representation of an instance
     * @return {String} string representation of an instance
     */ toString: function() {
            return '#<fabric.Path (' + this.complexity() + '): { "top": ' + this.top + ', "left": ' + this.left + ' }>';
        },
        /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */ toObject: function(propertiesToInclude) {
            return extend(this.callSuper('toObject', propertiesToInclude), {
                path: this.path.map(function(item) {
                    return item.slice();
                })
            });
        },
        /**
     * Returns dataless object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */ toDatalessObject: function(propertiesToInclude) {
            var o = this.toObject([
                'sourcePath'
            ].concat(propertiesToInclude));
            if (o.sourcePath) delete o.path;
            return o;
        },
        /* _TO_SVG_START_ */ /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */ _toSVG: function() {
            var path = fabric.util.joinPath(this.path);
            return [
                '<path ',
                'COMMON_PARTS',
                'd="',
                path,
                '" stroke-linecap="round" ',
                '/>\n'
            ];
        },
        _getOffsetTransform: function() {
            var digits = fabric.Object.NUM_FRACTION_DIGITS;
            return ' translate(' + toFixed(-this.pathOffset.x, digits) + ', ' + toFixed(-this.pathOffset.y, digits) + ')';
        },
        /**
     * Returns svg clipPath representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */ toClipPathSVG: function(reviver) {
            var additionalTransform = this._getOffsetTransform();
            return '\t' + this._createBaseClipPathSVGMarkup(this._toSVG(), {
                reviver: reviver,
                additionalTransform: additionalTransform
            });
        },
        /**
     * Returns svg representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */ toSVG: function(reviver) {
            var additionalTransform = this._getOffsetTransform();
            return this._createBaseSVGMarkup(this._toSVG(), {
                reviver: reviver,
                additionalTransform: additionalTransform
            });
        },
        /* _TO_SVG_END_ */ /**
     * Returns number representation of an instance complexity
     * @return {Number} complexity of this instance
     */ complexity: function() {
            return this.path.length;
        },
        /**
     * @private
     */ _calcDimensions: function() {
            var aX = [], aY = [], current, subpathStartX = 0, subpathStartY = 0, x = 0, y = 0, bounds;
            for(var i = 0, len = this.path.length; i < len; ++i){
                current = this.path[i];
                switch(current[0]){
                    case 'L':
                        x = current[1];
                        y = current[2];
                        bounds = [];
                        break;
                    case 'M':
                        x = current[1];
                        y = current[2];
                        subpathStartX = x;
                        subpathStartY = y;
                        bounds = [];
                        break;
                    case 'C':
                        bounds = fabric.util.getBoundsOfCurve(x, y, current[1], current[2], current[3], current[4], current[5], current[6]);
                        x = current[5];
                        y = current[6];
                        break;
                    case 'Q':
                        bounds = fabric.util.getBoundsOfCurve(x, y, current[1], current[2], current[1], current[2], current[3], current[4]);
                        x = current[3];
                        y = current[4];
                        break;
                    case 'z':
                    case 'Z':
                        x = subpathStartX;
                        y = subpathStartY;
                        break;
                }
                bounds.forEach(function(point) {
                    aX.push(point.x);
                    aY.push(point.y);
                });
                aX.push(x);
                aY.push(y);
            }
            var minX = min(aX) || 0, minY = min(aY) || 0, maxX = max(aX) || 0, maxY = max(aY) || 0, deltaX = maxX - minX, deltaY = maxY - minY;
            return {
                left: minX,
                top: minY,
                width: deltaX,
                height: deltaY
            };
        }
    });
    /**
   * Creates an instance of fabric.Path from an object
   * @static
   * @memberOf fabric.Path
   * @param {Object} object
   * @param {Function} [callback] Callback to invoke when an fabric.Path instance is created
   */ fabric.Path.fromObject = function(object, callback) {
        if (typeof object.sourcePath === 'string') {
            var pathUrl = object.sourcePath;
            fabric.loadSVGFromURL(pathUrl, function(elements) {
                var path = elements[0];
                path.setOptions(object);
                if (object.clipPath) fabric.util.enlivenObjects([
                    object.clipPath
                ], function(elivenedObjects) {
                    path.clipPath = elivenedObjects[0];
                    callback && callback(path);
                });
                else callback && callback(path);
            });
        } else fabric.Object._fromObject('Path', object, callback, 'path');
    };
    /* _FROM_SVG_START_ */ /**
   * List of attribute names to account for when parsing SVG element (used by `fabric.Path.fromElement`)
   * @static
   * @memberOf fabric.Path
   * @see http://www.w3.org/TR/SVG/paths.html#PathElement
   */ fabric.Path.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat([
        'd'
    ]);
    /**
   * Creates an instance of fabric.Path from an SVG <path> element
   * @static
   * @memberOf fabric.Path
   * @param {SVGElement} element to parse
   * @param {Function} callback Callback to invoke when an fabric.Path instance is created
   * @param {Object} [options] Options object
   * @param {Function} [callback] Options callback invoked after parsing is finished
   */ fabric.Path.fromElement = function(element, callback, options) {
        var parsedAttributes = fabric.parseAttributes(element, fabric.Path.ATTRIBUTE_NAMES);
        parsedAttributes.fromSVG = true;
        callback(new fabric.Path(parsedAttributes.d, extend(parsedAttributes, options)));
    };
/* _FROM_SVG_END_ */ })($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {}), min = fabric.util.array.min, max = fabric.util.array.max;
    if (fabric.Group) return;
    /**
   * Group class
   * @class fabric.Group
   * @extends fabric.Object
   * @mixes fabric.Collection
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#groups}
   * @see {@link fabric.Group#initialize} for constructor definition
   */ fabric.Group = fabric.util.createClass(fabric.Object, fabric.Collection, /** @lends fabric.Group.prototype */ {
        /**
     * Type of an object
     * @type String
     * @default
     */ type: 'group',
        /**
     * Width of stroke
     * @type Number
     * @default
     */ strokeWidth: 0,
        /**
     * Indicates if click, mouseover, mouseout events & hoverCursor should also check for subtargets
     * @type Boolean
     * @default
     */ subTargetCheck: false,
        /**
     * Groups are container, do not render anything on theyr own, ence no cache properties
     * @type Array
     * @default
     */ cacheProperties: [],
        /**
     * setOnGroup is a method used for TextBox that is no more used since 2.0.0 The behavior is still
     * available setting this boolean to true.
     * @type Boolean
     * @since 2.0.0
     * @default
     */ useSetOnGroup: false,
        /**
     * Constructor
     * @param {Object} objects Group objects
     * @param {Object} [options] Options object
     * @param {Boolean} [isAlreadyGrouped] if true, objects have been grouped already.
     * @return {Object} thisArg
     */ initialize: function(objects, options, isAlreadyGrouped) {
            options = options || {};
            this._objects = [];
            // if objects enclosed in a group have been grouped already,
            // we cannot change properties of objects.
            // Thus we need to set options to group without objects,
            isAlreadyGrouped && this.callSuper('initialize', options);
            this._objects = objects || [];
            for(var i = this._objects.length; i--;)this._objects[i].group = this;
            if (!isAlreadyGrouped) {
                var center = options && options.centerPoint;
                // we want to set origins before calculating the bounding box.
                // so that the topleft can be set with that in mind.
                // if specific top and left are passed, are overwritten later
                // with the callSuper('initialize', options)
                if (options.originX !== undefined) this.originX = options.originX;
                if (options.originY !== undefined) this.originY = options.originY;
                // if coming from svg i do not want to calc bounds.
                // i assume width and height are passed along options
                center || this._calcBounds();
                this._updateObjectsCoords(center);
                delete options.centerPoint;
                this.callSuper('initialize', options);
            } else this._updateObjectsACoords();
            this.setCoords();
        },
        /**
     * @private
     */ _updateObjectsACoords: function() {
            var skipControls = true;
            for(var i = this._objects.length; i--;)this._objects[i].setCoords(skipControls);
        },
        /**
     * @private
     * @param {Boolean} [skipCoordsChange] if true, coordinates of objects enclosed in a group do not change
     */ _updateObjectsCoords: function(center) {
            var center = center || this.getCenterPoint();
            for(var i = this._objects.length; i--;)this._updateObjectCoords(this._objects[i], center);
        },
        /**
     * @private
     * @param {Object} object
     * @param {fabric.Point} center, current center of group.
     */ _updateObjectCoords: function(object, center) {
            var objectLeft = object.left, objectTop = object.top, skipControls = true;
            object.set({
                left: objectLeft - center.x,
                top: objectTop - center.y
            });
            object.group = this;
            object.setCoords(skipControls);
        },
        /**
     * Returns string represenation of a group
     * @return {String}
     */ toString: function() {
            return '#<fabric.Group: (' + this.complexity() + ')>';
        },
        /**
     * Adds an object to a group; Then recalculates group's dimension, position.
     * @param {Object} object
     * @return {fabric.Group} thisArg
     * @chainable
     */ addWithUpdate: function(object) {
            var nested = !!this.group;
            this._restoreObjectsState();
            fabric.util.resetObjectTransform(this);
            if (object) {
                if (nested) // if this group is inside another group, we need to pre transform the object
                fabric.util.removeTransformFromObject(object, this.group.calcTransformMatrix());
                this._objects.push(object);
                object.group = this;
                object._set('canvas', this.canvas);
            }
            this._calcBounds();
            this._updateObjectsCoords();
            this.dirty = true;
            if (nested) this.group.addWithUpdate();
            else this.setCoords();
            return this;
        },
        /**
     * Removes an object from a group; Then recalculates group's dimension, position.
     * @param {Object} object
     * @return {fabric.Group} thisArg
     * @chainable
     */ removeWithUpdate: function(object) {
            this._restoreObjectsState();
            fabric.util.resetObjectTransform(this);
            this.remove(object);
            this._calcBounds();
            this._updateObjectsCoords();
            this.setCoords();
            this.dirty = true;
            return this;
        },
        /**
     * @private
     */ _onObjectAdded: function(object) {
            this.dirty = true;
            object.group = this;
            object._set('canvas', this.canvas);
        },
        /**
     * @private
     */ _onObjectRemoved: function(object) {
            this.dirty = true;
            delete object.group;
        },
        /**
     * @private
     */ _set: function(key, value) {
            var i = this._objects.length;
            if (this.useSetOnGroup) while(i--)this._objects[i].setOnGroup(key, value);
            if (key === 'canvas') while(i--)this._objects[i]._set(key, value);
            fabric.Object.prototype._set.call(this, key, value);
        },
        /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */ toObject: function(propertiesToInclude) {
            var _includeDefaultValues = this.includeDefaultValues;
            var objsToObject = this._objects.filter(function(obj) {
                return !obj.excludeFromExport;
            }).map(function(obj) {
                var originalDefaults = obj.includeDefaultValues;
                obj.includeDefaultValues = _includeDefaultValues;
                var _obj = obj.toObject(propertiesToInclude);
                obj.includeDefaultValues = originalDefaults;
                return _obj;
            });
            var obj = fabric.Object.prototype.toObject.call(this, propertiesToInclude);
            obj.objects = objsToObject;
            return obj;
        },
        /**
     * Returns object representation of an instance, in dataless mode.
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */ toDatalessObject: function(propertiesToInclude) {
            var objsToObject, sourcePath = this.sourcePath;
            if (sourcePath) objsToObject = sourcePath;
            else {
                var _includeDefaultValues = this.includeDefaultValues;
                objsToObject = this._objects.map(function(obj) {
                    var originalDefaults = obj.includeDefaultValues;
                    obj.includeDefaultValues = _includeDefaultValues;
                    var _obj = obj.toDatalessObject(propertiesToInclude);
                    obj.includeDefaultValues = originalDefaults;
                    return _obj;
                });
            }
            var obj = fabric.Object.prototype.toDatalessObject.call(this, propertiesToInclude);
            obj.objects = objsToObject;
            return obj;
        },
        /**
     * Renders instance on a given context
     * @param {CanvasRenderingContext2D} ctx context to render instance on
     */ render: function(ctx) {
            this._transformDone = true;
            this.callSuper('render', ctx);
            this._transformDone = false;
        },
        /**
     * Decide if the object should cache or not. Create its own cache level
     * needsItsOwnCache should be used when the object drawing method requires
     * a cache step. None of the fabric classes requires it.
     * Generally you do not cache objects in groups because the group is already cached.
     * @return {Boolean}
     */ shouldCache: function() {
            var ownCache = fabric.Object.prototype.shouldCache.call(this);
            if (ownCache) {
                for(var i = 0, len = this._objects.length; i < len; i++)if (this._objects[i].willDrawShadow()) {
                    this.ownCaching = false;
                    return false;
                }
            }
            return ownCache;
        },
        /**
     * Check if this object or a child object will cast a shadow
     * @return {Boolean}
     */ willDrawShadow: function() {
            if (fabric.Object.prototype.willDrawShadow.call(this)) return true;
            for(var i = 0, len = this._objects.length; i < len; i++){
                if (this._objects[i].willDrawShadow()) return true;
            }
            return false;
        },
        /**
     * Check if this group or its parent group are caching, recursively up
     * @return {Boolean}
     */ isOnACache: function() {
            return this.ownCaching || this.group && this.group.isOnACache();
        },
        /**
     * Execute the drawing operation for an object on a specified context
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ drawObject: function(ctx) {
            for(var i = 0, len = this._objects.length; i < len; i++)this._objects[i].render(ctx);
            this._drawClipPath(ctx, this.clipPath);
        },
        /**
     * Check if cache is dirty
     */ isCacheDirty: function(skipCanvas) {
            if (this.callSuper('isCacheDirty', skipCanvas)) return true;
            if (!this.statefullCache) return false;
            for(var i = 0, len = this._objects.length; i < len; i++)if (this._objects[i].isCacheDirty(true)) {
                if (this._cacheCanvas) {
                    // if this group has not a cache canvas there is nothing to clean
                    var x = this.cacheWidth / this.zoomX, y = this.cacheHeight / this.zoomY;
                    this._cacheContext.clearRect(-x / 2, -y / 2, x, y);
                }
                return true;
            }
            return false;
        },
        /**
     * Restores original state of each of group objects (original state is that which was before group was created).
     * if the nested boolean is true, the original state will be restored just for the
     * first group and not for all the group chain
     * @private
     * @param {Boolean} nested tell the function to restore object state up to the parent group and not more
     * @return {fabric.Group} thisArg
     * @chainable
     */ _restoreObjectsState: function() {
            var groupMatrix = this.calcOwnMatrix();
            this._objects.forEach(function(object) {
                // instead of using _this = this;
                fabric.util.addTransformToObject(object, groupMatrix);
                delete object.group;
                object.setCoords();
            });
            return this;
        },
        /**
     * Destroys a group (restoring state of its objects)
     * @return {fabric.Group} thisArg
     * @chainable
     */ destroy: function() {
            // when group is destroyed objects needs to get a repaint to be eventually
            // displayed on canvas.
            this._objects.forEach(function(object) {
                object.set('dirty', true);
            });
            return this._restoreObjectsState();
        },
        dispose: function() {
            this.callSuper('dispose');
            this.forEachObject(function(object) {
                object.dispose && object.dispose();
            });
            this._objects = [];
        },
        /**
     * make a group an active selection, remove the group from canvas
     * the group has to be on canvas for this to work.
     * @return {fabric.ActiveSelection} thisArg
     * @chainable
     */ toActiveSelection: function() {
            if (!this.canvas) return;
            var objects = this._objects, canvas = this.canvas;
            this._objects = [];
            var options = this.toObject();
            delete options.objects;
            var activeSelection = new fabric.ActiveSelection([]);
            activeSelection.set(options);
            activeSelection.type = 'activeSelection';
            canvas.remove(this);
            objects.forEach(function(object) {
                object.group = activeSelection;
                object.dirty = true;
                canvas.add(object);
            });
            activeSelection.canvas = canvas;
            activeSelection._objects = objects;
            canvas._activeObject = activeSelection;
            activeSelection.setCoords();
            return activeSelection;
        },
        /**
     * Destroys a group (restoring state of its objects)
     * @return {fabric.Group} thisArg
     * @chainable
     */ ungroupOnCanvas: function() {
            return this._restoreObjectsState();
        },
        /**
     * Sets coordinates of all objects inside group
     * @return {fabric.Group} thisArg
     * @chainable
     */ setObjectsCoords: function() {
            var skipControls = true;
            this.forEachObject(function(object) {
                object.setCoords(skipControls);
            });
            return this;
        },
        /**
     * @private
     */ _calcBounds: function(onlyWidthHeight) {
            var aX = [], aY = [], o, prop, coords, props = [
                'tr',
                'br',
                'bl',
                'tl'
            ], i = 0, iLen = this._objects.length, j, jLen = props.length;
            for(; i < iLen; ++i){
                o = this._objects[i];
                coords = o.calcACoords();
                for(j = 0; j < jLen; j++){
                    prop = props[j];
                    aX.push(coords[prop].x);
                    aY.push(coords[prop].y);
                }
                o.aCoords = coords;
            }
            this._getBounds(aX, aY, onlyWidthHeight);
        },
        /**
     * @private
     */ _getBounds: function(aX, aY, onlyWidthHeight) {
            var minXY = new fabric.Point(min(aX), min(aY)), maxXY = new fabric.Point(max(aX), max(aY)), top = minXY.y || 0, left = minXY.x || 0, width = maxXY.x - minXY.x || 0, height = maxXY.y - minXY.y || 0;
            this.width = width;
            this.height = height;
            if (!onlyWidthHeight) // the bounding box always finds the topleft most corner.
            // whatever is the group origin, we set up here the left/top position.
            this.setPositionByOrigin({
                x: left,
                y: top
            }, 'left', 'top');
        },
        /* _TO_SVG_START_ */ /**
     * Returns svg representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */ _toSVG: function(reviver) {
            var svgString = [
                '<g ',
                'COMMON_PARTS',
                ' >\n'
            ];
            for(var i = 0, len = this._objects.length; i < len; i++)svgString.push('\t\t', this._objects[i].toSVG(reviver));
            svgString.push('</g>\n');
            return svgString;
        },
        /**
     * Returns styles-string for svg-export, specific version for group
     * @return {String}
     */ getSvgStyles: function() {
            var opacity = typeof this.opacity !== 'undefined' && this.opacity !== 1 ? 'opacity: ' + this.opacity + ';' : '', visibility = this.visible ? '' : ' visibility: hidden;';
            return [
                opacity,
                this.getSvgFilter(),
                visibility
            ].join('');
        },
        /**
     * Returns svg clipPath representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */ toClipPathSVG: function(reviver) {
            var svgString = [];
            for(var i = 0, len = this._objects.length; i < len; i++)svgString.push('\t', this._objects[i].toClipPathSVG(reviver));
            return this._createBaseClipPathSVGMarkup(svgString, {
                reviver: reviver
            });
        }
    });
    /**
   * Returns {@link fabric.Group} instance from an object representation
   * @static
   * @memberOf fabric.Group
   * @param {Object} object Object to create a group from
   * @param {Function} [callback] Callback to invoke when an group instance is created
   */ fabric.Group.fromObject = function(object, callback) {
        var objects = object.objects, options = fabric.util.object.clone(object, true);
        delete options.objects;
        if (typeof objects === 'string') {
            // it has to be an url or something went wrong.
            fabric.loadSVGFromURL(objects, function(elements) {
                var group = fabric.util.groupSVGElements(elements, object, objects);
                var clipPath = options.clipPath;
                delete options.clipPath;
                group.set(options);
                if (clipPath) fabric.util.enlivenObjects([
                    clipPath
                ], function(elivenedObjects) {
                    group.clipPath = elivenedObjects[0];
                    callback && callback(group);
                });
                else callback && callback(group);
            });
            return;
        }
        fabric.util.enlivenObjects(objects, function(enlivenedObjects) {
            fabric.util.enlivenObjectEnlivables(object, options, function() {
                callback && callback(new fabric.Group(enlivenedObjects, options, true));
            });
        });
    };
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {});
    if (fabric.ActiveSelection) return;
    /**
   * Group class
   * @class fabric.ActiveSelection
   * @extends fabric.Group
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#groups}
   * @see {@link fabric.ActiveSelection#initialize} for constructor definition
   */ fabric.ActiveSelection = fabric.util.createClass(fabric.Group, /** @lends fabric.ActiveSelection.prototype */ {
        /**
     * Type of an object
     * @type String
     * @default
     */ type: 'activeSelection',
        /**
     * Constructor
     * @param {Object} objects ActiveSelection objects
     * @param {Object} [options] Options object
     * @return {Object} thisArg
     */ initialize: function(objects, options) {
            options = options || {};
            this._objects = objects || [];
            for(var i = this._objects.length; i--;)this._objects[i].group = this;
            if (options.originX) this.originX = options.originX;
            if (options.originY) this.originY = options.originY;
            this._calcBounds();
            this._updateObjectsCoords();
            fabric.Object.prototype.initialize.call(this, options);
            this.setCoords();
        },
        /**
     * Change te activeSelection to a normal group,
     * High level function that automatically adds it to canvas as
     * active object. no events fired.
     * @since 2.0.0
     * @return {fabric.Group}
     */ toGroup: function() {
            var objects = this._objects.concat();
            this._objects = [];
            var options = fabric.Object.prototype.toObject.call(this);
            var newGroup = new fabric.Group([]);
            delete options.type;
            newGroup.set(options);
            objects.forEach(function(object) {
                object.canvas.remove(object);
                object.group = newGroup;
            });
            newGroup._objects = objects;
            if (!this.canvas) return newGroup;
            var canvas = this.canvas;
            canvas.add(newGroup);
            canvas._activeObject = newGroup;
            newGroup.setCoords();
            return newGroup;
        },
        /**
     * If returns true, deselection is cancelled.
     * @since 2.0.0
     * @return {Boolean} [cancel]
     */ onDeselect: function() {
            this.destroy();
            return false;
        },
        /**
     * Returns string representation of a group
     * @return {String}
     */ toString: function() {
            return '#<fabric.ActiveSelection: (' + this.complexity() + ')>';
        },
        /**
     * Decide if the object should cache or not. Create its own cache level
     * objectCaching is a global flag, wins over everything
     * needsItsOwnCache should be used when the object drawing method requires
     * a cache step. None of the fabric classes requires it.
     * Generally you do not cache objects in groups because the group outside is cached.
     * @return {Boolean}
     */ shouldCache: function() {
            return false;
        },
        /**
     * Check if this group or its parent group are caching, recursively up
     * @return {Boolean}
     */ isOnACache: function() {
            return false;
        },
        /**
     * Renders controls and borders for the object
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Object} [styleOverride] properties to override the object style
     * @param {Object} [childrenOverride] properties to override the children overrides
     */ _renderControls: function(ctx, styleOverride, childrenOverride) {
            ctx.save();
            ctx.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
            childrenOverride = childrenOverride || {};
            if (typeof childrenOverride.hasControls === 'undefined') childrenOverride.hasControls = false;
            childrenOverride.forActiveSelection = true;
            for(var i = 0, len = this._objects.length; i < len; i++)this._objects[i]._renderControls(ctx, childrenOverride);
            this.callSuper('_renderControls', ctx, styleOverride);
            ctx.restore();
        }
    });
    /**
   * Returns {@link fabric.ActiveSelection} instance from an object representation
   * @static
   * @memberOf fabric.ActiveSelection
   * @param {Object} object Object to create a group from
   * @param {Function} [callback] Callback to invoke when an ActiveSelection instance is created
   */ fabric.ActiveSelection.fromObject = function(object, callback) {
        fabric.util.enlivenObjects(object.objects, function(enlivenedObjects) {
            delete object.objects;
            callback && callback(new fabric.ActiveSelection(enlivenedObjects, object, true));
        });
    };
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var extend = $79564f678731bf19$var$fabric.util.object.extend;
    if (!global.fabric) global.fabric = {};
    if (global.fabric.Image) {
        $79564f678731bf19$var$fabric.warn('fabric.Image is already defined.');
        return;
    }
    /**
   * Image class
   * @class fabric.Image
   * @extends fabric.Object
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#images}
   * @see {@link fabric.Image#initialize} for constructor definition
   */ $79564f678731bf19$var$fabric.Image = $79564f678731bf19$var$fabric.util.createClass($79564f678731bf19$var$fabric.Object, /** @lends fabric.Image.prototype */ {
        /**
     * Type of an object
     * @type String
     * @default
     */ type: 'image',
        /**
     * Width of a stroke.
     * For image quality a stroke multiple of 2 gives better results.
     * @type Number
     * @default
     */ strokeWidth: 0,
        /**
     * When calling {@link fabric.Image.getSrc}, return value from element src with `element.getAttribute('src')`.
     * This allows for relative urls as image src.
     * @since 2.7.0
     * @type Boolean
     * @default
     */ srcFromAttribute: false,
        /**
     * private
     * contains last value of scaleX to detect
     * if the Image got resized after the last Render
     * @type Number
     */ _lastScaleX: 1,
        /**
     * private
     * contains last value of scaleY to detect
     * if the Image got resized after the last Render
     * @type Number
     */ _lastScaleY: 1,
        /**
     * private
     * contains last value of scaling applied by the apply filter chain
     * @type Number
     */ _filterScalingX: 1,
        /**
     * private
     * contains last value of scaling applied by the apply filter chain
     * @type Number
     */ _filterScalingY: 1,
        /**
     * minimum scale factor under which any resizeFilter is triggered to resize the image
     * 0 will disable the automatic resize. 1 will trigger automatically always.
     * number bigger than 1 are not implemented yet.
     * @type Number
     */ minimumScaleTrigger: 0.5,
        /**
     * List of properties to consider when checking if
     * state of an object is changed ({@link fabric.Object#hasStateChanged})
     * as well as for history (undo/redo) purposes
     * @type Array
     */ stateProperties: $79564f678731bf19$var$fabric.Object.prototype.stateProperties.concat('cropX', 'cropY'),
        /**
     * List of properties to consider when checking if cache needs refresh
     * Those properties are checked by statefullCache ON ( or lazy mode if we want ) or from single
     * calls to Object.set(key, value). If the key is in this list, the object is marked as dirty
     * and refreshed at the next render
     * @type Array
     */ cacheProperties: $79564f678731bf19$var$fabric.Object.prototype.cacheProperties.concat('cropX', 'cropY'),
        /**
     * key used to retrieve the texture representing this image
     * @since 2.0.0
     * @type String
     * @default
     */ cacheKey: '',
        /**
     * Image crop in pixels from original image size.
     * @since 2.0.0
     * @type Number
     * @default
     */ cropX: 0,
        /**
     * Image crop in pixels from original image size.
     * @since 2.0.0
     * @type Number
     * @default
     */ cropY: 0,
        /**
     * Indicates whether this canvas will use image smoothing when painting this image.
     * Also influence if the cacheCanvas for this image uses imageSmoothing
     * @since 4.0.0-beta.11
     * @type Boolean
     * @default
     */ imageSmoothing: true,
        /**
     * Constructor
     * Image can be initialized with any canvas drawable or a string.
     * The string should be a url and will be loaded as an image.
     * Canvas and Image element work out of the box, while videos require extra code to work.
     * Please check video element events for seeking.
     * @param {HTMLImageElement | HTMLCanvasElement | HTMLVideoElement | String} element Image element
     * @param {Object} [options] Options object
     * @param {function} [callback] callback function to call after eventual filters applied.
     * @return {fabric.Image} thisArg
     */ initialize: function(element, options) {
            options || (options = {});
            this.filters = [];
            this.cacheKey = 'texture' + $79564f678731bf19$var$fabric.Object.__uid++;
            this.callSuper('initialize', options);
            this._initElement(element, options);
        },
        /**
     * Returns image element which this instance if based on
     * @return {HTMLImageElement} Image element
     */ getElement: function() {
            return this._element || {};
        },
        /**
     * Sets image element for this instance to a specified one.
     * If filters defined they are applied to new image.
     * You might need to call `canvas.renderAll` and `object.setCoords` after replacing, to render new image and update controls area.
     * @param {HTMLImageElement} element
     * @param {Object} [options] Options object
     * @return {fabric.Image} thisArg
     * @chainable
     */ setElement: function(element, options) {
            this.removeTexture(this.cacheKey);
            this.removeTexture(this.cacheKey + '_filtered');
            this._element = element;
            this._originalElement = element;
            this._initConfig(options);
            if (this.filters.length !== 0) this.applyFilters();
            // resizeFilters work on the already filtered copy.
            // we need to apply resizeFilters AFTER normal filters.
            // applyResizeFilters is run more often than normal filters
            // and is triggered by user interactions rather than dev code
            if (this.resizeFilter) this.applyResizeFilters();
            return this;
        },
        /**
     * Delete a single texture if in webgl mode
     */ removeTexture: function(key) {
            var backend = $79564f678731bf19$var$fabric.filterBackend;
            if (backend && backend.evictCachesForKey) backend.evictCachesForKey(key);
        },
        /**
     * Delete textures, reference to elements and eventually JSDOM cleanup
     */ dispose: function() {
            this.callSuper('dispose');
            this.removeTexture(this.cacheKey);
            this.removeTexture(this.cacheKey + '_filtered');
            this._cacheContext = undefined;
            [
                '_originalElement',
                '_element',
                '_filteredEl',
                '_cacheCanvas'
            ].forEach((function(element) {
                $79564f678731bf19$var$fabric.util.cleanUpJsdomNode(this[element]);
                this[element] = undefined;
            }).bind(this));
        },
        /**
     * Get the crossOrigin value (of the corresponding image element)
     */ getCrossOrigin: function() {
            return this._originalElement && (this._originalElement.crossOrigin || null);
        },
        /**
     * Returns original size of an image
     * @return {Object} Object with "width" and "height" properties
     */ getOriginalSize: function() {
            var element = this.getElement();
            return {
                width: element.naturalWidth || element.width,
                height: element.naturalHeight || element.height
            };
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _stroke: function(ctx) {
            if (!this.stroke || this.strokeWidth === 0) return;
            var w = this.width / 2, h = this.height / 2;
            ctx.beginPath();
            ctx.moveTo(-w, -h);
            ctx.lineTo(w, -h);
            ctx.lineTo(w, h);
            ctx.lineTo(-w, h);
            ctx.lineTo(-w, -h);
            ctx.closePath();
        },
        /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of an instance
     */ toObject: function(propertiesToInclude) {
            var filters = [];
            this.filters.forEach(function(filterObj) {
                if (filterObj) filters.push(filterObj.toObject());
            });
            var object = extend(this.callSuper('toObject', [
                'cropX',
                'cropY'
            ].concat(propertiesToInclude)), {
                src: this.getSrc(),
                crossOrigin: this.getCrossOrigin(),
                filters: filters
            });
            if (this.resizeFilter) object.resizeFilter = this.resizeFilter.toObject();
            return object;
        },
        /**
     * Returns true if an image has crop applied, inspecting values of cropX,cropY,width,height.
     * @return {Boolean}
     */ hasCrop: function() {
            return this.cropX || this.cropY || this.width < this._element.width || this.height < this._element.height;
        },
        /* _TO_SVG_START_ */ /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */ _toSVG: function() {
            var svgString = [], imageMarkup = [], strokeSvg, element = this._element, x = -this.width / 2, y = -this.height / 2, clipPath = '', imageRendering = '';
            if (!element) return [];
            if (this.hasCrop()) {
                var clipPathId = $79564f678731bf19$var$fabric.Object.__uid++;
                svgString.push('<clipPath id="imageCrop_' + clipPathId + '">\n', '\t<rect x="' + x + '" y="' + y + '" width="' + this.width + '" height="' + this.height + '" />\n', '</clipPath>\n');
                clipPath = ' clip-path="url(#imageCrop_' + clipPathId + ')" ';
            }
            if (!this.imageSmoothing) imageRendering = '" image-rendering="optimizeSpeed';
            imageMarkup.push('\t<image ', 'COMMON_PARTS', 'xlink:href="', this.getSvgSrc(true), '" x="', x - this.cropX, '" y="', y - this.cropY, // we're essentially moving origin of transformation from top/left corner to the center of the shape
            // by wrapping it in container <g> element with actual transformation, then offsetting object to the top/left
            // so that object's center aligns with container's left/top
            '" width="', element.width || element.naturalWidth, '" height="', element.height || element.height, imageRendering, '"', clipPath, '></image>\n');
            if (this.stroke || this.strokeDashArray) {
                var origFill = this.fill;
                this.fill = null;
                strokeSvg = [
                    '\t<rect ',
                    'x="',
                    x,
                    '" y="',
                    y,
                    '" width="',
                    this.width,
                    '" height="',
                    this.height,
                    '" style="',
                    this.getSvgStyles(),
                    '"/>\n'
                ];
                this.fill = origFill;
            }
            if (this.paintFirst !== 'fill') svgString = svgString.concat(strokeSvg, imageMarkup);
            else svgString = svgString.concat(imageMarkup, strokeSvg);
            return svgString;
        },
        /* _TO_SVG_END_ */ /**
     * Returns source of an image
     * @param {Boolean} filtered indicates if the src is needed for svg
     * @return {String} Source of an image
     */ getSrc: function(filtered) {
            var element = filtered ? this._element : this._originalElement;
            if (element) {
                if (element.toDataURL) return element.toDataURL();
                if (this.srcFromAttribute) return element.getAttribute('src');
                else return element.src;
            } else return this.src || '';
        },
        /**
     * Sets source of an image
     * @param {String} src Source string (URL)
     * @param {Function} [callback] Callback is invoked when image has been loaded (and all filters have been applied)
     * @param {Object} [options] Options object
     * @param {String} [options.crossOrigin] crossOrigin value (one of "", "anonymous", "use-credentials")
     * @see https://developer.mozilla.org/en-US/docs/HTML/CORS_settings_attributes
     * @return {fabric.Image} thisArg
     * @chainable
     */ setSrc: function(src, callback, options) {
            $79564f678731bf19$var$fabric.util.loadImage(src, function(img, isError) {
                this.setElement(img, options);
                this._setWidthHeight();
                callback && callback(this, isError);
            }, this, options && options.crossOrigin);
            return this;
        },
        /**
     * Returns string representation of an instance
     * @return {String} String representation of an instance
     */ toString: function() {
            return '#<fabric.Image: { src: "' + this.getSrc() + '" }>';
        },
        applyResizeFilters: function() {
            var filter = this.resizeFilter, minimumScale = this.minimumScaleTrigger, objectScale = this.getTotalObjectScaling(), scaleX = objectScale.scaleX, scaleY = objectScale.scaleY, elementToFilter = this._filteredEl || this._originalElement;
            if (this.group) this.set('dirty', true);
            if (!filter || scaleX > minimumScale && scaleY > minimumScale) {
                this._element = elementToFilter;
                this._filterScalingX = 1;
                this._filterScalingY = 1;
                this._lastScaleX = scaleX;
                this._lastScaleY = scaleY;
                return;
            }
            if (!$79564f678731bf19$var$fabric.filterBackend) $79564f678731bf19$var$fabric.filterBackend = $79564f678731bf19$var$fabric.initFilterBackend();
            var canvasEl = $79564f678731bf19$var$fabric.util.createCanvasElement(), cacheKey = this._filteredEl ? this.cacheKey + '_filtered' : this.cacheKey, sourceWidth = elementToFilter.width, sourceHeight = elementToFilter.height;
            canvasEl.width = sourceWidth;
            canvasEl.height = sourceHeight;
            this._element = canvasEl;
            this._lastScaleX = filter.scaleX = scaleX;
            this._lastScaleY = filter.scaleY = scaleY;
            $79564f678731bf19$var$fabric.filterBackend.applyFilters([
                filter
            ], elementToFilter, sourceWidth, sourceHeight, this._element, cacheKey);
            this._filterScalingX = canvasEl.width / this._originalElement.width;
            this._filterScalingY = canvasEl.height / this._originalElement.height;
        },
        /**
     * Applies filters assigned to this image (from "filters" array) or from filter param
     * @method applyFilters
     * @param {Array} filters to be applied
     * @param {Boolean} forResizing specify if the filter operation is a resize operation
     * @return {thisArg} return the fabric.Image object
     * @chainable
     */ applyFilters: function(filters) {
            filters = filters || this.filters || [];
            filters = filters.filter(function(filter) {
                return filter && !filter.isNeutralState();
            });
            this.set('dirty', true);
            // needs to clear out or WEBGL will not resize correctly
            this.removeTexture(this.cacheKey + '_filtered');
            if (filters.length === 0) {
                this._element = this._originalElement;
                this._filteredEl = null;
                this._filterScalingX = 1;
                this._filterScalingY = 1;
                return this;
            }
            var imgElement = this._originalElement, sourceWidth = imgElement.naturalWidth || imgElement.width, sourceHeight = imgElement.naturalHeight || imgElement.height;
            if (this._element === this._originalElement) {
                // if the element is the same we need to create a new element
                var canvasEl = $79564f678731bf19$var$fabric.util.createCanvasElement();
                canvasEl.width = sourceWidth;
                canvasEl.height = sourceHeight;
                this._element = canvasEl;
                this._filteredEl = canvasEl;
            } else {
                // clear the existing element to get new filter data
                // also dereference the eventual resized _element
                this._element = this._filteredEl;
                this._filteredEl.getContext('2d').clearRect(0, 0, sourceWidth, sourceHeight);
                // we also need to resize again at next renderAll, so remove saved _lastScaleX/Y
                this._lastScaleX = 1;
                this._lastScaleY = 1;
            }
            if (!$79564f678731bf19$var$fabric.filterBackend) $79564f678731bf19$var$fabric.filterBackend = $79564f678731bf19$var$fabric.initFilterBackend();
            $79564f678731bf19$var$fabric.filterBackend.applyFilters(filters, this._originalElement, sourceWidth, sourceHeight, this._element, this.cacheKey);
            if (this._originalElement.width !== this._element.width || this._originalElement.height !== this._element.height) {
                this._filterScalingX = this._element.width / this._originalElement.width;
                this._filterScalingY = this._element.height / this._originalElement.height;
            }
            return this;
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _render: function(ctx) {
            $79564f678731bf19$var$fabric.util.setImageSmoothing(ctx, this.imageSmoothing);
            if (this.isMoving !== true && this.resizeFilter && this._needsResize()) this.applyResizeFilters();
            this._stroke(ctx);
            this._renderPaintInOrder(ctx);
        },
        /**
     * Paint the cached copy of the object on the target context.
     * it will set the imageSmoothing for the draw operation
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ drawCacheOnCanvas: function(ctx) {
            $79564f678731bf19$var$fabric.util.setImageSmoothing(ctx, this.imageSmoothing);
            $79564f678731bf19$var$fabric.Object.prototype.drawCacheOnCanvas.call(this, ctx);
        },
        /**
     * Decide if the object should cache or not. Create its own cache level
     * needsItsOwnCache should be used when the object drawing method requires
     * a cache step. None of the fabric classes requires it.
     * Generally you do not cache objects in groups because the group outside is cached.
     * This is the special image version where we would like to avoid caching where possible.
     * Essentially images do not benefit from caching. They may require caching, and in that
     * case we do it. Also caching an image usually ends in a loss of details.
     * A full performance audit should be done.
     * @return {Boolean}
     */ shouldCache: function() {
            return this.needsItsOwnCache();
        },
        _renderFill: function(ctx) {
            var elementToDraw = this._element;
            if (!elementToDraw) return;
            var scaleX = this._filterScalingX, scaleY = this._filterScalingY, w = this.width, h = this.height, min = Math.min, max = Math.max, // crop values cannot be lesser than 0.
            cropX = max(this.cropX, 0), cropY = max(this.cropY, 0), elWidth = elementToDraw.naturalWidth || elementToDraw.width, elHeight = elementToDraw.naturalHeight || elementToDraw.height, sX = cropX * scaleX, sY = cropY * scaleY, // the width height cannot exceed element width/height, starting from the crop offset.
            sW = min(w * scaleX, elWidth - sX), sH = min(h * scaleY, elHeight - sY), x = -w / 2, y = -h / 2, maxDestW = min(w, elWidth / scaleX - cropX), maxDestH = min(h, elHeight / scaleY - cropY);
            elementToDraw && ctx.drawImage(elementToDraw, sX, sY, sW, sH, x, y, maxDestW, maxDestH);
        },
        /**
     * needed to check if image needs resize
     * @private
     */ _needsResize: function() {
            var scale = this.getTotalObjectScaling();
            return scale.scaleX !== this._lastScaleX || scale.scaleY !== this._lastScaleY;
        },
        /**
     * @private
     */ _resetWidthHeight: function() {
            this.set(this.getOriginalSize());
        },
        /**
     * The Image class's initialization method. This method is automatically
     * called by the constructor.
     * @private
     * @param {HTMLImageElement|String} element The element representing the image
     * @param {Object} [options] Options object
     */ _initElement: function(element, options) {
            this.setElement($79564f678731bf19$var$fabric.util.getById(element), options);
            $79564f678731bf19$var$fabric.util.addClass(this.getElement(), $79564f678731bf19$var$fabric.Image.CSS_CANVAS);
        },
        /**
     * @private
     * @param {Object} [options] Options object
     */ _initConfig: function(options) {
            options || (options = {});
            this.setOptions(options);
            this._setWidthHeight(options);
        },
        /**
     * @private
     * @param {Array} filters to be initialized
     * @param {Function} callback Callback to invoke when all fabric.Image.filters instances are created
     */ _initFilters: function(filters, callback) {
            if (filters && filters.length) $79564f678731bf19$var$fabric.util.enlivenObjects(filters, function(enlivenedObjects) {
                callback && callback(enlivenedObjects);
            }, 'fabric.Image.filters');
            else callback && callback();
        },
        /**
     * @private
     * Set the width and the height of the image object, using the element or the
     * options.
     * @param {Object} [options] Object with width/height properties
     */ _setWidthHeight: function(options) {
            options || (options = {});
            var el = this.getElement();
            this.width = options.width || el.naturalWidth || el.width || 0;
            this.height = options.height || el.naturalHeight || el.height || 0;
        },
        /**
     * Calculate offset for center and scale factor for the image in order to respect
     * the preserveAspectRatio attribute
     * @private
     * @return {Object}
     */ parsePreserveAspectRatioAttribute: function() {
            var pAR = $79564f678731bf19$var$fabric.util.parsePreserveAspectRatioAttribute(this.preserveAspectRatio || ''), rWidth = this._element.width, rHeight = this._element.height, scaleX = 1, scaleY = 1, offsetLeft = 0, offsetTop = 0, cropX = 0, cropY = 0, offset, pWidth = this.width, pHeight = this.height, parsedAttributes = {
                width: pWidth,
                height: pHeight
            };
            if (pAR && (pAR.alignX !== 'none' || pAR.alignY !== 'none')) {
                if (pAR.meetOrSlice === 'meet') {
                    scaleX = scaleY = $79564f678731bf19$var$fabric.util.findScaleToFit(this._element, parsedAttributes);
                    offset = (pWidth - rWidth * scaleX) / 2;
                    if (pAR.alignX === 'Min') offsetLeft = -offset;
                    if (pAR.alignX === 'Max') offsetLeft = offset;
                    offset = (pHeight - rHeight * scaleY) / 2;
                    if (pAR.alignY === 'Min') offsetTop = -offset;
                    if (pAR.alignY === 'Max') offsetTop = offset;
                }
                if (pAR.meetOrSlice === 'slice') {
                    scaleX = scaleY = $79564f678731bf19$var$fabric.util.findScaleToCover(this._element, parsedAttributes);
                    offset = rWidth - pWidth / scaleX;
                    if (pAR.alignX === 'Mid') cropX = offset / 2;
                    if (pAR.alignX === 'Max') cropX = offset;
                    offset = rHeight - pHeight / scaleY;
                    if (pAR.alignY === 'Mid') cropY = offset / 2;
                    if (pAR.alignY === 'Max') cropY = offset;
                    rWidth = pWidth / scaleX;
                    rHeight = pHeight / scaleY;
                }
            } else {
                scaleX = pWidth / rWidth;
                scaleY = pHeight / rHeight;
            }
            return {
                width: rWidth,
                height: rHeight,
                scaleX: scaleX,
                scaleY: scaleY,
                offsetLeft: offsetLeft,
                offsetTop: offsetTop,
                cropX: cropX,
                cropY: cropY
            };
        }
    });
    /**
   * Default CSS class name for canvas
   * @static
   * @type String
   * @default
   */ $79564f678731bf19$var$fabric.Image.CSS_CANVAS = 'canvas-img';
    /**
   * Alias for getSrc
   * @static
   */ $79564f678731bf19$var$fabric.Image.prototype.getSvgSrc = $79564f678731bf19$var$fabric.Image.prototype.getSrc;
    /**
   * Creates an instance of fabric.Image from its object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} callback Callback to invoke when an image instance is created
   */ $79564f678731bf19$var$fabric.Image.fromObject = function(_object, callback) {
        var object = $79564f678731bf19$var$fabric.util.object.clone(_object);
        $79564f678731bf19$var$fabric.util.loadImage(object.src, function(img, isError) {
            if (isError) {
                callback && callback(null, true);
                return;
            }
            $79564f678731bf19$var$fabric.Image.prototype._initFilters.call(object, object.filters, function(filters) {
                object.filters = filters || [];
                $79564f678731bf19$var$fabric.Image.prototype._initFilters.call(object, [
                    object.resizeFilter
                ], function(resizeFilters) {
                    object.resizeFilter = resizeFilters[0];
                    $79564f678731bf19$var$fabric.util.enlivenObjectEnlivables(object, object, function() {
                        var image = new $79564f678731bf19$var$fabric.Image(img, object);
                        callback(image, false);
                    });
                });
            });
        }, null, object.crossOrigin);
    };
    /**
   * Creates an instance of fabric.Image from an URL string
   * @static
   * @param {String} url URL to create an image from
   * @param {Function} [callback] Callback to invoke when image is created (newly created image is passed as a first argument). Second argument is a boolean indicating if an error occurred or not.
   * @param {Object} [imgOptions] Options object
   */ $79564f678731bf19$var$fabric.Image.fromURL = function(url, callback, imgOptions) {
        $79564f678731bf19$var$fabric.util.loadImage(url, function(img, isError) {
            callback && callback(new $79564f678731bf19$var$fabric.Image(img, imgOptions), isError);
        }, null, imgOptions && imgOptions.crossOrigin);
    };
    /* _FROM_SVG_START_ */ /**
   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Image.fromElement})
   * @static
   * @see {@link http://www.w3.org/TR/SVG/struct.html#ImageElement}
   */ $79564f678731bf19$var$fabric.Image.ATTRIBUTE_NAMES = $79564f678731bf19$var$fabric.SHARED_ATTRIBUTES.concat('x y width height preserveAspectRatio xlink:href crossOrigin image-rendering'.split(' '));
    /**
   * Returns {@link fabric.Image} instance from an SVG element
   * @static
   * @param {SVGElement} element Element to parse
   * @param {Object} [options] Options object
   * @param {Function} callback Callback to execute when fabric.Image object is created
   * @return {fabric.Image} Instance of fabric.Image
   */ $79564f678731bf19$var$fabric.Image.fromElement = function(element, callback, options) {
        var parsedAttributes = $79564f678731bf19$var$fabric.parseAttributes(element, $79564f678731bf19$var$fabric.Image.ATTRIBUTE_NAMES);
        $79564f678731bf19$var$fabric.Image.fromURL(parsedAttributes['xlink:href'], callback, extend(options ? $79564f678731bf19$var$fabric.util.object.clone(options) : {}, parsedAttributes));
    };
/* _FROM_SVG_END_ */ })($79564f678731bf19$exports);
$79564f678731bf19$var$fabric.util.object.extend($79564f678731bf19$var$fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
    /**
   * @private
   * @return {Number} angle value
   */ _getAngleValueForStraighten: function() {
        var angle = this.angle % 360;
        if (angle > 0) return Math.round((angle - 1) / 90) * 90;
        return Math.round(angle / 90) * 90;
    },
    /**
   * Straightens an object (rotating it from current angle to one of 0, 90, 180, 270, etc. depending on which is closer)
   * @return {fabric.Object} thisArg
   * @chainable
   */ straighten: function() {
        return this.rotate(this._getAngleValueForStraighten());
    },
    /**
   * Same as {@link fabric.Object.prototype.straighten} but with animation
   * @param {Object} callbacks Object with callback functions
   * @param {Function} [callbacks.onComplete] Invoked on completion
   * @param {Function} [callbacks.onChange] Invoked on every step of animation
   * @return {fabric.Object} thisArg
   */ fxStraighten: function(callbacks) {
        callbacks = callbacks || {};
        var empty = function() {}, onComplete = callbacks.onComplete || empty, onChange = callbacks.onChange || empty, _this = this;
        return $79564f678731bf19$var$fabric.util.animate({
            target: this,
            startValue: this.get('angle'),
            endValue: this._getAngleValueForStraighten(),
            duration: this.FX_DURATION,
            onChange: function(value) {
                _this.rotate(value);
                onChange();
            },
            onComplete: function() {
                _this.setCoords();
                onComplete();
            }
        });
    }
});
$79564f678731bf19$var$fabric.util.object.extend($79564f678731bf19$var$fabric.StaticCanvas.prototype, /** @lends fabric.StaticCanvas.prototype */ {
    /**
   * Straightens object, then rerenders canvas
   * @param {fabric.Object} object Object to straighten
   * @return {fabric.Canvas} thisArg
   * @chainable
   */ straightenObject: function(object) {
        object.straighten();
        this.requestRenderAll();
        return this;
    },
    /**
   * Same as {@link fabric.Canvas.prototype.straightenObject}, but animated
   * @param {fabric.Object} object Object to straighten
   * @return {fabric.Canvas} thisArg
   */ fxStraightenObject: function(object) {
        return object.fxStraighten({
            onChange: this.requestRenderAllBound
        });
    }
});
(function() {
    'use strict';
    /**
   * Tests if webgl supports certain precision
   * @param {WebGL} Canvas WebGL context to test on
   * @param {String} Precision to test can be any of following: 'lowp', 'mediump', 'highp'
   * @returns {Boolean} Whether the user's browser WebGL supports given precision.
   */ function testPrecision(gl, precision) {
        var fragmentSource = 'precision ' + precision + ' float;\nvoid main(){}';
        var fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
        gl.shaderSource(fragmentShader, fragmentSource);
        gl.compileShader(fragmentShader);
        if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) return false;
        return true;
    }
    /**
   * Indicate whether this filtering backend is supported by the user's browser.
   * @param {Number} tileSize check if the tileSize is supported
   * @returns {Boolean} Whether the user's browser supports WebGL.
   */ $79564f678731bf19$var$fabric.isWebglSupported = function(tileSize) {
        if ($79564f678731bf19$var$fabric.isLikelyNode) return false;
        tileSize = tileSize || $79564f678731bf19$var$fabric.WebglFilterBackend.prototype.tileSize;
        var canvas = document.createElement('canvas');
        var gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
        var isSupported = false;
        // eslint-disable-next-line
        if (gl) {
            $79564f678731bf19$var$fabric.maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
            isSupported = $79564f678731bf19$var$fabric.maxTextureSize >= tileSize;
            var precisions = [
                'highp',
                'mediump',
                'lowp'
            ];
            for(var i = 0; i < 3; i++)if (testPrecision(gl, precisions[i])) {
                $79564f678731bf19$var$fabric.webGlPrecision = precisions[i];
                break;
            }
        }
        this.isSupported = isSupported;
        return isSupported;
    };
    $79564f678731bf19$var$fabric.WebglFilterBackend = WebglFilterBackend;
    /**
   * WebGL filter backend.
   */ function WebglFilterBackend(options) {
        if (options && options.tileSize) this.tileSize = options.tileSize;
        this.setupGLContext(this.tileSize, this.tileSize);
        this.captureGPUInfo();
    }
    WebglFilterBackend.prototype = /** @lends fabric.WebglFilterBackend.prototype */ {
        tileSize: 2048,
        /**
     * Experimental. This object is a sort of repository of help layers used to avoid
     * of recreating them during frequent filtering. If you are previewing a filter with
     * a slider you probably do not want to create help layers every filter step.
     * in this object there will be appended some canvases, created once, resized sometimes
     * cleared never. Clearing is left to the developer.
     **/ resources: {},
        /**
     * Setup a WebGL context suitable for filtering, and bind any needed event handlers.
     */ setupGLContext: function(width, height) {
            this.dispose();
            this.createWebGLCanvas(width, height);
            // eslint-disable-next-line
            this.aPosition = new Float32Array([
                0,
                0,
                0,
                1,
                1,
                0,
                1,
                1
            ]);
            this.chooseFastestCopyGLTo2DMethod(width, height);
        },
        /**
     * Pick a method to copy data from GL context to 2d canvas.  In some browsers using
     * putImageData is faster than drawImage for that specific operation.
     */ chooseFastestCopyGLTo2DMethod: function(width, height) {
            var canMeasurePerf = typeof window.performance !== 'undefined', canUseImageData;
            try {
                new ImageData(1, 1);
                canUseImageData = true;
            } catch (e) {
                canUseImageData = false;
            }
            // eslint-disable-next-line no-undef
            var canUseArrayBuffer = typeof ArrayBuffer !== 'undefined';
            // eslint-disable-next-line no-undef
            var canUseUint8Clamped = typeof Uint8ClampedArray !== 'undefined';
            if (!(canMeasurePerf && canUseImageData && canUseArrayBuffer && canUseUint8Clamped)) return;
            var targetCanvas = $79564f678731bf19$var$fabric.util.createCanvasElement();
            // eslint-disable-next-line no-undef
            var imageBuffer = new ArrayBuffer(width * height * 4);
            if ($79564f678731bf19$var$fabric.forceGLPutImageData) {
                this.imageBuffer = imageBuffer;
                this.copyGLTo2D = $79564f678731bf19$var$copyGLTo2DPutImageData;
                return;
            }
            var testContext = {
                imageBuffer: imageBuffer,
                destinationWidth: width,
                destinationHeight: height,
                targetCanvas: targetCanvas
            };
            var startTime, drawImageTime, putImageDataTime;
            targetCanvas.width = width;
            targetCanvas.height = height;
            startTime = window.performance.now();
            $79564f678731bf19$var$copyGLTo2DDrawImage.call(testContext, this.gl, testContext);
            drawImageTime = window.performance.now() - startTime;
            startTime = window.performance.now();
            $79564f678731bf19$var$copyGLTo2DPutImageData.call(testContext, this.gl, testContext);
            putImageDataTime = window.performance.now() - startTime;
            if (drawImageTime > putImageDataTime) {
                this.imageBuffer = imageBuffer;
                this.copyGLTo2D = $79564f678731bf19$var$copyGLTo2DPutImageData;
            } else this.copyGLTo2D = $79564f678731bf19$var$copyGLTo2DDrawImage;
        },
        /**
     * Create a canvas element and associated WebGL context and attaches them as
     * class properties to the GLFilterBackend class.
     */ createWebGLCanvas: function(width, height) {
            var canvas = $79564f678731bf19$var$fabric.util.createCanvasElement();
            canvas.width = width;
            canvas.height = height;
            var glOptions = {
                alpha: true,
                premultipliedAlpha: false,
                depth: false,
                stencil: false,
                antialias: false
            }, gl = canvas.getContext('webgl', glOptions);
            if (!gl) gl = canvas.getContext('experimental-webgl', glOptions);
            if (!gl) return;
            gl.clearColor(0, 0, 0, 0);
            // this canvas can fire webglcontextlost and webglcontextrestored
            this.canvas = canvas;
            this.gl = gl;
        },
        /**
     * Attempts to apply the requested filters to the source provided, drawing the filtered output
     * to the provided target canvas.
     *
     * @param {Array} filters The filters to apply.
     * @param {HTMLImageElement|HTMLCanvasElement} source The source to be filtered.
     * @param {Number} width The width of the source input.
     * @param {Number} height The height of the source input.
     * @param {HTMLCanvasElement} targetCanvas The destination for filtered output to be drawn.
     * @param {String|undefined} cacheKey A key used to cache resources related to the source. If
     * omitted, caching will be skipped.
     */ applyFilters: function(filters, source, width, height, targetCanvas, cacheKey) {
            var gl = this.gl;
            var cachedTexture;
            if (cacheKey) cachedTexture = this.getCachedTexture(cacheKey, source);
            var pipelineState = {
                originalWidth: source.width || source.originalWidth,
                originalHeight: source.height || source.originalHeight,
                sourceWidth: width,
                sourceHeight: height,
                destinationWidth: width,
                destinationHeight: height,
                context: gl,
                sourceTexture: this.createTexture(gl, width, height, !cachedTexture && source),
                targetTexture: this.createTexture(gl, width, height),
                originalTexture: cachedTexture || this.createTexture(gl, width, height, !cachedTexture && source),
                passes: filters.length,
                webgl: true,
                aPosition: this.aPosition,
                programCache: this.programCache,
                pass: 0,
                filterBackend: this,
                targetCanvas: targetCanvas
            };
            var tempFbo = gl.createFramebuffer();
            gl.bindFramebuffer(gl.FRAMEBUFFER, tempFbo);
            filters.forEach(function(filter) {
                filter && filter.applyTo(pipelineState);
            });
            $79564f678731bf19$var$resizeCanvasIfNeeded(pipelineState);
            this.copyGLTo2D(gl, pipelineState);
            gl.bindTexture(gl.TEXTURE_2D, null);
            gl.deleteTexture(pipelineState.sourceTexture);
            gl.deleteTexture(pipelineState.targetTexture);
            gl.deleteFramebuffer(tempFbo);
            targetCanvas.getContext('2d').setTransform(1, 0, 0, 1, 0, 0);
            return pipelineState;
        },
        /**
     * Detach event listeners, remove references, and clean up caches.
     */ dispose: function() {
            if (this.canvas) {
                this.canvas = null;
                this.gl = null;
            }
            this.clearWebGLCaches();
        },
        /**
     * Wipe out WebGL-related caches.
     */ clearWebGLCaches: function() {
            this.programCache = {};
            this.textureCache = {};
        },
        /**
     * Create a WebGL texture object.
     *
     * Accepts specific dimensions to initialize the texture to or a source image.
     *
     * @param {WebGLRenderingContext} gl The GL context to use for creating the texture.
     * @param {Number} width The width to initialize the texture at.
     * @param {Number} height The height to initialize the texture.
     * @param {HTMLImageElement|HTMLCanvasElement} textureImageSource A source for the texture data.
     * @param {Number} filterType gl.NEAREST or gl.LINEAR usually, webgl numeri constants
     * @returns {WebGLTexture}
     */ createTexture: function(gl, width, height, textureImageSource, filterType) {
            var texture = gl.createTexture();
            gl.bindTexture(gl.TEXTURE_2D, texture);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, filterType || gl.NEAREST);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, filterType || gl.NEAREST);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
            if (textureImageSource) gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, textureImageSource);
            else gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
            return texture;
        },
        /**
     * Can be optionally used to get a texture from the cache array
     *
     * If an existing texture is not found, a new texture is created and cached.
     *
     * @param {String} uniqueId A cache key to use to find an existing texture.
     * @param {HTMLImageElement|HTMLCanvasElement} textureImageSource A source to use to create the
     * texture cache entry if one does not already exist.
     */ getCachedTexture: function(uniqueId, textureImageSource) {
            if (this.textureCache[uniqueId]) return this.textureCache[uniqueId];
            else {
                var texture = this.createTexture(this.gl, textureImageSource.width, textureImageSource.height, textureImageSource);
                this.textureCache[uniqueId] = texture;
                return texture;
            }
        },
        /**
     * Clear out cached resources related to a source image that has been
     * filtered previously.
     *
     * @param {String} cacheKey The cache key provided when the source image was filtered.
     */ evictCachesForKey: function(cacheKey) {
            if (this.textureCache[cacheKey]) {
                this.gl.deleteTexture(this.textureCache[cacheKey]);
                delete this.textureCache[cacheKey];
            }
        },
        copyGLTo2D: $79564f678731bf19$var$copyGLTo2DDrawImage,
        /**
     * Attempt to extract GPU information strings from a WebGL context.
     *
     * Useful information when debugging or blacklisting specific GPUs.
     *
     * @returns {Object} A GPU info object with renderer and vendor strings.
     */ captureGPUInfo: function() {
            if (this.gpuInfo) return this.gpuInfo;
            var gl = this.gl, gpuInfo = {
                renderer: '',
                vendor: ''
            };
            if (!gl) return gpuInfo;
            var ext = gl.getExtension('WEBGL_debug_renderer_info');
            if (ext) {
                var renderer = gl.getParameter(ext.UNMASKED_RENDERER_WEBGL);
                var vendor = gl.getParameter(ext.UNMASKED_VENDOR_WEBGL);
                if (renderer) gpuInfo.renderer = renderer.toLowerCase();
                if (vendor) gpuInfo.vendor = vendor.toLowerCase();
            }
            this.gpuInfo = gpuInfo;
            return gpuInfo;
        }
    };
})();
function $79564f678731bf19$var$resizeCanvasIfNeeded(pipelineState) {
    var targetCanvas = pipelineState.targetCanvas, width = targetCanvas.width, height = targetCanvas.height, dWidth = pipelineState.destinationWidth, dHeight = pipelineState.destinationHeight;
    if (width !== dWidth || height !== dHeight) {
        targetCanvas.width = dWidth;
        targetCanvas.height = dHeight;
    }
}
/**
 * Copy an input WebGL canvas on to an output 2D canvas.
 *
 * The WebGL canvas is assumed to be upside down, with the top-left pixel of the
 * desired output image appearing in the bottom-left corner of the WebGL canvas.
 *
 * @param {WebGLRenderingContext} sourceContext The WebGL context to copy from.
 * @param {HTMLCanvasElement} targetCanvas The 2D target canvas to copy on to.
 * @param {Object} pipelineState The 2D target canvas to copy on to.
 */ function $79564f678731bf19$var$copyGLTo2DDrawImage(gl, pipelineState) {
    var glCanvas = gl.canvas, targetCanvas = pipelineState.targetCanvas, ctx = targetCanvas.getContext('2d');
    ctx.translate(0, targetCanvas.height); // move it down again
    ctx.scale(1, -1); // vertical flip
    // where is my image on the big glcanvas?
    var sourceY = glCanvas.height - targetCanvas.height;
    ctx.drawImage(glCanvas, 0, sourceY, targetCanvas.width, targetCanvas.height, 0, 0, targetCanvas.width, targetCanvas.height);
}
/**
 * Copy an input WebGL canvas on to an output 2D canvas using 2d canvas' putImageData
 * API. Measurably faster than using ctx.drawImage in Firefox (version 54 on OSX Sierra).
 *
 * @param {WebGLRenderingContext} sourceContext The WebGL context to copy from.
 * @param {HTMLCanvasElement} targetCanvas The 2D target canvas to copy on to.
 * @param {Object} pipelineState The 2D target canvas to copy on to.
 */ function $79564f678731bf19$var$copyGLTo2DPutImageData(gl, pipelineState) {
    var targetCanvas = pipelineState.targetCanvas, ctx = targetCanvas.getContext('2d'), dWidth = pipelineState.destinationWidth, dHeight = pipelineState.destinationHeight, numBytes = dWidth * dHeight * 4;
    // eslint-disable-next-line no-undef
    var u8 = new Uint8Array(this.imageBuffer, 0, numBytes);
    // eslint-disable-next-line no-undef
    var u8Clamped = new Uint8ClampedArray(this.imageBuffer, 0, numBytes);
    gl.readPixels(0, 0, dWidth, dHeight, gl.RGBA, gl.UNSIGNED_BYTE, u8);
    var imgData = new ImageData(u8Clamped, dWidth, dHeight);
    ctx.putImageData(imgData, 0, 0);
}
(function() {
    'use strict';
    var noop = function() {};
    $79564f678731bf19$var$fabric.Canvas2dFilterBackend = Canvas2dFilterBackend;
    /**
   * Canvas 2D filter backend.
   */ function Canvas2dFilterBackend() {}
    Canvas2dFilterBackend.prototype = /** @lends fabric.Canvas2dFilterBackend.prototype */ {
        evictCachesForKey: noop,
        dispose: noop,
        clearWebGLCaches: noop,
        /**
     * Experimental. This object is a sort of repository of help layers used to avoid
     * of recreating them during frequent filtering. If you are previewing a filter with
     * a slider you probably do not want to create help layers every filter step.
     * in this object there will be appended some canvases, created once, resized sometimes
     * cleared never. Clearing is left to the developer.
     **/ resources: {},
        /**
     * Apply a set of filters against a source image and draw the filtered output
     * to the provided destination canvas.
     *
     * @param {EnhancedFilter} filters The filter to apply.
     * @param {HTMLImageElement|HTMLCanvasElement} sourceElement The source to be filtered.
     * @param {Number} sourceWidth The width of the source input.
     * @param {Number} sourceHeight The height of the source input.
     * @param {HTMLCanvasElement} targetCanvas The destination for filtered output to be drawn.
     */ applyFilters: function(filters, sourceElement, sourceWidth, sourceHeight, targetCanvas) {
            var ctx = targetCanvas.getContext('2d');
            ctx.drawImage(sourceElement, 0, 0, sourceWidth, sourceHeight);
            var imageData = ctx.getImageData(0, 0, sourceWidth, sourceHeight);
            var originalImageData = ctx.getImageData(0, 0, sourceWidth, sourceHeight);
            var pipelineState = {
                sourceWidth: sourceWidth,
                sourceHeight: sourceHeight,
                imageData: imageData,
                originalEl: sourceElement,
                originalImageData: originalImageData,
                canvasEl: targetCanvas,
                ctx: ctx,
                filterBackend: this
            };
            filters.forEach(function(filter) {
                filter.applyTo(pipelineState);
            });
            if (pipelineState.imageData.width !== sourceWidth || pipelineState.imageData.height !== sourceHeight) {
                targetCanvas.width = pipelineState.imageData.width;
                targetCanvas.height = pipelineState.imageData.height;
            }
            ctx.putImageData(pipelineState.imageData, 0, 0);
            return pipelineState;
        }
    };
})();
/**
 * @namespace fabric.Image.filters
 * @memberOf fabric.Image
 * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#image_filters}
 * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
 */ $79564f678731bf19$var$fabric.Image = $79564f678731bf19$var$fabric.Image || {};
$79564f678731bf19$var$fabric.Image.filters = $79564f678731bf19$var$fabric.Image.filters || {};
/**
 * Root filter class from which all filter classes inherit from
 * @class fabric.Image.filters.BaseFilter
 * @memberOf fabric.Image.filters
 */ $79564f678731bf19$var$fabric.Image.filters.BaseFilter = $79564f678731bf19$var$fabric.util.createClass(/** @lends fabric.Image.filters.BaseFilter.prototype */ {
    /**
   * Filter type
   * @param {String} type
   * @default
   */ type: 'BaseFilter',
    /**
   * Array of attributes to send with buffers. do not modify
   * @private
   */ vertexSource: "attribute vec2 aPosition;\nvarying vec2 vTexCoord;\nvoid main() {\nvTexCoord = aPosition;\ngl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);\n}",
    fragmentSource: "precision highp float;\nvarying vec2 vTexCoord;\nuniform sampler2D uTexture;\nvoid main() {\ngl_FragColor = texture2D(uTexture, vTexCoord);\n}",
    /**
   * Constructor
   * @param {Object} [options] Options object
   */ initialize: function(options) {
        if (options) this.setOptions(options);
    },
    /**
   * Sets filter's properties from options
   * @param {Object} [options] Options object
   */ setOptions: function(options) {
        for(var prop in options)this[prop] = options[prop];
    },
    /**
   * Compile this filter's shader program.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context to use for shader compilation.
   * @param {String} fragmentSource fragmentShader source for compilation
   * @param {String} vertexSource vertexShader source for compilation
   */ createProgram: function(gl, fragmentSource, vertexSource) {
        fragmentSource = fragmentSource || this.fragmentSource;
        vertexSource = vertexSource || this.vertexSource;
        if ($79564f678731bf19$var$fabric.webGlPrecision !== 'highp') fragmentSource = fragmentSource.replace(/precision highp float/g, 'precision ' + $79564f678731bf19$var$fabric.webGlPrecision + ' float');
        var vertexShader = gl.createShader(gl.VERTEX_SHADER);
        gl.shaderSource(vertexShader, vertexSource);
        gl.compileShader(vertexShader);
        if (!gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS)) throw new Error(// eslint-disable-next-line prefer-template
        'Vertex shader compile error for ' + this.type + ': ' + gl.getShaderInfoLog(vertexShader));
        var fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
        gl.shaderSource(fragmentShader, fragmentSource);
        gl.compileShader(fragmentShader);
        if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) throw new Error(// eslint-disable-next-line prefer-template
        'Fragment shader compile error for ' + this.type + ': ' + gl.getShaderInfoLog(fragmentShader));
        var program = gl.createProgram();
        gl.attachShader(program, vertexShader);
        gl.attachShader(program, fragmentShader);
        gl.linkProgram(program);
        if (!gl.getProgramParameter(program, gl.LINK_STATUS)) throw new Error(// eslint-disable-next-line prefer-template
        'Shader link error for "${this.type}" ' + gl.getProgramInfoLog(program));
        var attributeLocations = this.getAttributeLocations(gl, program);
        var uniformLocations = this.getUniformLocations(gl, program) || {};
        uniformLocations.uStepW = gl.getUniformLocation(program, 'uStepW');
        uniformLocations.uStepH = gl.getUniformLocation(program, 'uStepH');
        return {
            program: program,
            attributeLocations: attributeLocations,
            uniformLocations: uniformLocations
        };
    },
    /**
   * Return a map of attribute names to WebGLAttributeLocation objects.
   *
   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
   * @param {WebGLShaderProgram} program The shader program from which to take attribute locations.
   * @returns {Object} A map of attribute names to attribute locations.
   */ getAttributeLocations: function(gl, program) {
        return {
            aPosition: gl.getAttribLocation(program, 'aPosition')
        };
    },
    /**
   * Return a map of uniform names to WebGLUniformLocation objects.
   *
   * Intended to be overridden by subclasses.
   *
   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
   * @param {WebGLShaderProgram} program The shader program from which to take uniform locations.
   * @returns {Object} A map of uniform names to uniform locations.
   */ getUniformLocations: function() {
        // in case i do not need any special uniform i need to return an empty object
        return {};
    },
    /**
   * Send attribute data from this filter to its shader program on the GPU.
   *
   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
   * @param {Object} attributeLocations A map of shader attribute names to their locations.
   */ sendAttributeData: function(gl, attributeLocations, aPositionData) {
        var attributeLocation = attributeLocations.aPosition;
        var buffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
        gl.enableVertexAttribArray(attributeLocation);
        gl.vertexAttribPointer(attributeLocation, 2, gl.FLOAT, false, 0, 0);
        gl.bufferData(gl.ARRAY_BUFFER, aPositionData, gl.STATIC_DRAW);
    },
    _setupFrameBuffer: function(options) {
        var gl = options.context, width, height;
        if (options.passes > 1) {
            width = options.destinationWidth;
            height = options.destinationHeight;
            if (options.sourceWidth !== width || options.sourceHeight !== height) {
                gl.deleteTexture(options.targetTexture);
                options.targetTexture = options.filterBackend.createTexture(gl, width, height);
            }
            gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, options.targetTexture, 0);
        } else {
            // draw last filter on canvas and not to framebuffer.
            gl.bindFramebuffer(gl.FRAMEBUFFER, null);
            gl.finish();
        }
    },
    _swapTextures: function(options) {
        options.passes--;
        options.pass++;
        var temp = options.targetTexture;
        options.targetTexture = options.sourceTexture;
        options.sourceTexture = temp;
    },
    /**
   * Generic isNeutral implementation for one parameter based filters.
   * Used only in image applyFilters to discard filters that will not have an effect
   * on the image
   * Other filters may need their own version ( ColorMatrix, HueRotation, gamma, ComposedFilter )
   * @param {Object} options
   **/ isNeutralState: function() {
        var main = this.mainParameter, _class = $79564f678731bf19$var$fabric.Image.filters[this.type].prototype;
        if (main) {
            if (Array.isArray(_class[main])) {
                for(var i = _class[main].length; i--;){
                    if (this[main][i] !== _class[main][i]) return false;
                }
                return true;
            } else return _class[main] === this[main];
        } else return false;
    },
    /**
   * Apply this filter to the input image data provided.
   *
   * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
   *
   * @param {Object} options
   * @param {Number} options.passes The number of filters remaining to be executed
   * @param {Boolean} options.webgl Whether to use webgl to render the filter.
   * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
   * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
   */ applyTo: function(options) {
        if (options.webgl) {
            this._setupFrameBuffer(options);
            this.applyToWebGL(options);
            this._swapTextures(options);
        } else this.applyTo2d(options);
    },
    /**
   * Retrieves the cached shader.
   * @param {Object} options
   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
   */ retrieveShader: function(options) {
        if (!options.programCache.hasOwnProperty(this.type)) options.programCache[this.type] = this.createProgram(options.context);
        return options.programCache[this.type];
    },
    /**
   * Apply this filter using webgl.
   *
   * @param {Object} options
   * @param {Number} options.passes The number of filters remaining to be executed
   * @param {Boolean} options.webgl Whether to use webgl to render the filter.
   * @param {WebGLTexture} options.originalTexture The texture of the original input image.
   * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
   * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
   */ applyToWebGL: function(options) {
        var gl = options.context;
        var shader = this.retrieveShader(options);
        if (options.pass === 0 && options.originalTexture) gl.bindTexture(gl.TEXTURE_2D, options.originalTexture);
        else gl.bindTexture(gl.TEXTURE_2D, options.sourceTexture);
        gl.useProgram(shader.program);
        this.sendAttributeData(gl, shader.attributeLocations, options.aPosition);
        gl.uniform1f(shader.uniformLocations.uStepW, 1 / options.sourceWidth);
        gl.uniform1f(shader.uniformLocations.uStepH, 1 / options.sourceHeight);
        this.sendUniformData(gl, shader.uniformLocations);
        gl.viewport(0, 0, options.destinationWidth, options.destinationHeight);
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    },
    bindAdditionalTexture: function(gl, texture, textureUnit) {
        gl.activeTexture(textureUnit);
        gl.bindTexture(gl.TEXTURE_2D, texture);
        // reset active texture to 0 as usual
        gl.activeTexture(gl.TEXTURE0);
    },
    unbindAdditionalTexture: function(gl, textureUnit) {
        gl.activeTexture(textureUnit);
        gl.bindTexture(gl.TEXTURE_2D, null);
        gl.activeTexture(gl.TEXTURE0);
    },
    getMainParameter: function() {
        return this[this.mainParameter];
    },
    setMainParameter: function(value) {
        this[this.mainParameter] = value;
    },
    /**
   * Send uniform data from this filter to its shader program on the GPU.
   *
   * Intended to be overridden by subclasses.
   *
   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
   * @param {Object} uniformLocations A map of shader uniform names to their locations.
   */ sendUniformData: function() {
    // Intentionally left blank.  Override me in subclasses.
    },
    /**
   * If needed by a 2d filter, this functions can create an helper canvas to be used
   * remember that options.targetCanvas is available for use till end of chain.
   */ createHelpLayer: function(options) {
        if (!options.helpLayer) {
            var helpLayer = document.createElement('canvas');
            helpLayer.width = options.sourceWidth;
            helpLayer.height = options.sourceHeight;
            options.helpLayer = helpLayer;
        }
    },
    /**
   * Returns object representation of an instance
   * @return {Object} Object representation of an instance
   */ toObject: function() {
        var object = {
            type: this.type
        }, mainP = this.mainParameter;
        if (mainP) object[mainP] = this[mainP];
        return object;
    },
    /**
   * Returns a JSON representation of an instance
   * @return {Object} JSON
   */ toJSON: function() {
        // delegate, not alias
        return this.toObject();
    }
});
$79564f678731bf19$var$fabric.Image.filters.BaseFilter.fromObject = function(object, callback) {
    var filter = new $79564f678731bf19$var$fabric.Image.filters[object.type](object);
    callback && callback(filter);
    return filter;
};
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {}), filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Color Matrix filter class
   * @class fabric.Image.filters.ColorMatrix
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.ColorMatrix#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @see {@Link http://www.webwasp.co.uk/tutorials/219/Color_Matrix_Filter.php}
   * @see {@Link http://phoboslab.org/log/2013/11/fast-image-filters-with-webgl}
   * @example <caption>Kodachrome filter</caption>
   * var filter = new fabric.Image.filters.ColorMatrix({
   *  matrix: [
       1.1285582396593525, -0.3967382283601348, -0.03992559172921793, 0, 63.72958762196502,
       -0.16404339962244616, 1.0835251566291304, -0.05498805115633132, 0, 24.732407896706203,
       -0.16786010706155763, -0.5603416277695248, 1.6014850761964943, 0, 35.62982807460946,
       0, 0, 0, 1, 0
      ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */ filters.ColorMatrix = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.ColorMatrix.prototype */ {
        /**
     * Filter type
     * @param {String} type
     * @default
     */ type: 'ColorMatrix',
        fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nvarying vec2 vTexCoord;\nuniform mat4 uColorMatrix;\nuniform vec4 uConstants;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\ncolor *= uColorMatrix;\ncolor += uConstants;\ngl_FragColor = color;\n}",
        /**
     * Colormatrix for pixels.
     * array of 20 floats. Numbers in positions 4, 9, 14, 19 loose meaning
     * outside the -1, 1 range.
     * 0.0039215686 is the part of 1 that get translated to 1 in 2d
     * @param {Array} matrix array of 20 numbers.
     * @default
     */ matrix: [
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ],
        mainParameter: 'matrix',
        /**
     * Lock the colormatrix on the color part, skipping alpha, mainly for non webgl scenario
     * to save some calculation
     * @type Boolean
     * @default true
     */ colorsOnly: true,
        /**
     * Constructor
     * @param {Object} [options] Options object
     */ initialize: function(options) {
            this.callSuper('initialize', options);
            // create a new array instead mutating the prototype with push
            this.matrix = this.matrix.slice(0);
        },
        /**
     * Apply the ColorMatrix operation to a Uint8Array representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8Array to be filtered.
     */ applyTo2d: function(options) {
            var imageData = options.imageData, data = imageData.data, iLen = data.length, m = this.matrix, r, g, b, a, i, colorsOnly = this.colorsOnly;
            for(i = 0; i < iLen; i += 4){
                r = data[i];
                g = data[i + 1];
                b = data[i + 2];
                if (colorsOnly) {
                    data[i] = r * m[0] + g * m[1] + b * m[2] + m[4] * 255;
                    data[i + 1] = r * m[5] + g * m[6] + b * m[7] + m[9] * 255;
                    data[i + 2] = r * m[10] + g * m[11] + b * m[12] + m[14] * 255;
                } else {
                    a = data[i + 3];
                    data[i] = r * m[0] + g * m[1] + b * m[2] + a * m[3] + m[4] * 255;
                    data[i + 1] = r * m[5] + g * m[6] + b * m[7] + a * m[8] + m[9] * 255;
                    data[i + 2] = r * m[10] + g * m[11] + b * m[12] + a * m[13] + m[14] * 255;
                    data[i + 3] = r * m[15] + g * m[16] + b * m[17] + a * m[18] + m[19] * 255;
                }
            }
        },
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                uColorMatrix: gl.getUniformLocation(program, 'uColorMatrix'),
                uConstants: gl.getUniformLocation(program, 'uConstants')
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            var m = this.matrix, matrix = [
                m[0],
                m[1],
                m[2],
                m[3],
                m[5],
                m[6],
                m[7],
                m[8],
                m[10],
                m[11],
                m[12],
                m[13],
                m[15],
                m[16],
                m[17],
                m[18]
            ], constants = [
                m[4],
                m[9],
                m[14],
                m[19]
            ];
            gl.uniformMatrix4fv(uniformLocations.uColorMatrix, false, matrix);
            gl.uniform4fv(uniformLocations.uConstants, constants);
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] function to invoke after filter creation
   * @return {fabric.Image.filters.ColorMatrix} Instance of fabric.Image.filters.ColorMatrix
   */ fabric.Image.filters.ColorMatrix.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {}), filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Brightness filter class
   * @class fabric.Image.filters.Brightness
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Brightness#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Brightness({
   *   brightness: 0.05
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */ filters.Brightness = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Brightness.prototype */ {
        /**
     * Filter type
     * @param {String} type
     * @default
     */ type: 'Brightness',
        /**
     * Fragment source for the brightness program
     */ fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uBrightness;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\ncolor.rgb += uBrightness;\ngl_FragColor = color;\n}",
        /**
     * Brightness value, from -1 to 1.
     * translated to -255 to 255 for 2d
     * 0.0039215686 is the part of 1 that get translated to 1 in 2d
     * @param {Number} brightness
     * @default
     */ brightness: 0,
        /**
     * Describe the property that is the filter parameter
     * @param {String} m
     * @default
     */ mainParameter: 'brightness',
        /**
    * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
    *
    * @param {Object} options
    * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
    */ applyTo2d: function(options) {
            if (this.brightness === 0) return;
            var imageData = options.imageData, data = imageData.data, i, len = data.length, brightness = Math.round(this.brightness * 255);
            for(i = 0; i < len; i += 4){
                data[i] = data[i] + brightness;
                data[i + 1] = data[i + 1] + brightness;
                data[i + 2] = data[i + 2] + brightness;
            }
        },
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                uBrightness: gl.getUniformLocation(program, 'uBrightness')
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            gl.uniform1f(uniformLocations.uBrightness, this.brightness);
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Brightness} Instance of fabric.Image.filters.Brightness
   */ fabric.Image.filters.Brightness.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {}), extend = fabric.util.object.extend, filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Adapted from <a href="http://www.html5rocks.com/en/tutorials/canvas/imagefilters/">html5rocks article</a>
   * @class fabric.Image.filters.Convolute
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Convolute#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example <caption>Sharpen filter</caption>
   * var filter = new fabric.Image.filters.Convolute({
   *   matrix: [ 0, -1,  0,
   *            -1,  5, -1,
   *             0, -1,  0 ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   * @example <caption>Blur filter</caption>
   * var filter = new fabric.Image.filters.Convolute({
   *   matrix: [ 1/9, 1/9, 1/9,
   *             1/9, 1/9, 1/9,
   *             1/9, 1/9, 1/9 ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   * @example <caption>Emboss filter</caption>
   * var filter = new fabric.Image.filters.Convolute({
   *   matrix: [ 1,   1,  1,
   *             1, 0.7, -1,
   *            -1,  -1, -1 ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   * @example <caption>Emboss filter with opaqueness</caption>
   * var filter = new fabric.Image.filters.Convolute({
   *   opaque: true,
   *   matrix: [ 1,   1,  1,
   *             1, 0.7, -1,
   *            -1,  -1, -1 ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */ filters.Convolute = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Convolute.prototype */ {
        /**
     * Filter type
     * @param {String} type
     * @default
     */ type: 'Convolute',
        /*
     * Opaque value (true/false)
     */ opaque: false,
        /*
     * matrix for the filter, max 9x9
     */ matrix: [
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0
        ],
        /**
     * Fragment source for the brightness program
     */ fragmentSource: {
            Convolute_3_1: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[9];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 0);\nfor (float h = 0.0; h < 3.0; h+=1.0) {\nfor (float w = 0.0; w < 3.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 1), uStepH * (h - 1));\ncolor += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 3.0 + w)];\n}\n}\ngl_FragColor = color;\n}",
            Convolute_3_0: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[9];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 1);\nfor (float h = 0.0; h < 3.0; h+=1.0) {\nfor (float w = 0.0; w < 3.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 1.0), uStepH * (h - 1.0));\ncolor.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 3.0 + w)];\n}\n}\nfloat alpha = texture2D(uTexture, vTexCoord).a;\ngl_FragColor = color;\ngl_FragColor.a = alpha;\n}",
            Convolute_5_1: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[25];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 0);\nfor (float h = 0.0; h < 5.0; h+=1.0) {\nfor (float w = 0.0; w < 5.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));\ncolor += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 5.0 + w)];\n}\n}\ngl_FragColor = color;\n}",
            Convolute_5_0: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[25];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 1);\nfor (float h = 0.0; h < 5.0; h+=1.0) {\nfor (float w = 0.0; w < 5.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));\ncolor.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 5.0 + w)];\n}\n}\nfloat alpha = texture2D(uTexture, vTexCoord).a;\ngl_FragColor = color;\ngl_FragColor.a = alpha;\n}",
            Convolute_7_1: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[49];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 0);\nfor (float h = 0.0; h < 7.0; h+=1.0) {\nfor (float w = 0.0; w < 7.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));\ncolor += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 7.0 + w)];\n}\n}\ngl_FragColor = color;\n}",
            Convolute_7_0: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[49];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 1);\nfor (float h = 0.0; h < 7.0; h+=1.0) {\nfor (float w = 0.0; w < 7.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));\ncolor.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 7.0 + w)];\n}\n}\nfloat alpha = texture2D(uTexture, vTexCoord).a;\ngl_FragColor = color;\ngl_FragColor.a = alpha;\n}",
            Convolute_9_1: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[81];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 0);\nfor (float h = 0.0; h < 9.0; h+=1.0) {\nfor (float w = 0.0; w < 9.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));\ncolor += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 9.0 + w)];\n}\n}\ngl_FragColor = color;\n}",
            Convolute_9_0: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[81];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 1);\nfor (float h = 0.0; h < 9.0; h+=1.0) {\nfor (float w = 0.0; w < 9.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));\ncolor.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 9.0 + w)];\n}\n}\nfloat alpha = texture2D(uTexture, vTexCoord).a;\ngl_FragColor = color;\ngl_FragColor.a = alpha;\n}"
        },
        /**
     * Constructor
     * @memberOf fabric.Image.filters.Convolute.prototype
     * @param {Object} [options] Options object
     * @param {Boolean} [options.opaque=false] Opaque value (true/false)
     * @param {Array} [options.matrix] Filter matrix
     */ /**
    * Retrieves the cached shader.
    * @param {Object} options
    * @param {WebGLRenderingContext} options.context The GL context used for rendering.
    * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
    */ retrieveShader: function(options) {
            var size = Math.sqrt(this.matrix.length);
            var cacheKey = this.type + '_' + size + '_' + (this.opaque ? 1 : 0);
            var shaderSource = this.fragmentSource[cacheKey];
            if (!options.programCache.hasOwnProperty(cacheKey)) options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
            return options.programCache[cacheKey];
        },
        /**
     * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */ applyTo2d: function(options) {
            var imageData = options.imageData, data = imageData.data, weights = this.matrix, side = Math.round(Math.sqrt(weights.length)), halfSide = Math.floor(side / 2), sw = imageData.width, sh = imageData.height, output = options.ctx.createImageData(sw, sh), dst = output.data, // go through the destination image pixels
            alphaFac = this.opaque ? 1 : 0, r, g, b, a, dstOff, scx, scy, srcOff, wt, x, y, cx, cy;
            for(y = 0; y < sh; y++)for(x = 0; x < sw; x++){
                dstOff = (y * sw + x) * 4;
                // calculate the weighed sum of the source image pixels that
                // fall under the convolution matrix
                r = 0;
                g = 0;
                b = 0;
                a = 0;
                for(cy = 0; cy < side; cy++)for(cx = 0; cx < side; cx++){
                    scy = y + cy - halfSide;
                    scx = x + cx - halfSide;
                    // eslint-disable-next-line max-depth
                    if (scy < 0 || scy >= sh || scx < 0 || scx >= sw) continue;
                    srcOff = (scy * sw + scx) * 4;
                    wt = weights[cy * side + cx];
                    r += data[srcOff] * wt;
                    g += data[srcOff + 1] * wt;
                    b += data[srcOff + 2] * wt;
                    // eslint-disable-next-line max-depth
                    if (!alphaFac) a += data[srcOff + 3] * wt;
                }
                dst[dstOff] = r;
                dst[dstOff + 1] = g;
                dst[dstOff + 2] = b;
                if (!alphaFac) dst[dstOff + 3] = a;
                else dst[dstOff + 3] = data[dstOff + 3];
            }
            options.imageData = output;
        },
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                uMatrix: gl.getUniformLocation(program, 'uMatrix'),
                uOpaque: gl.getUniformLocation(program, 'uOpaque'),
                uHalfSize: gl.getUniformLocation(program, 'uHalfSize'),
                uSize: gl.getUniformLocation(program, 'uSize')
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            gl.uniform1fv(uniformLocations.uMatrix, this.matrix);
        },
        /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */ toObject: function() {
            return extend(this.callSuper('toObject'), {
                opaque: this.opaque,
                matrix: this.matrix
            });
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Convolute} Instance of fabric.Image.filters.Convolute
   */ fabric.Image.filters.Convolute.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {}), filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Grayscale image filter class
   * @class fabric.Image.filters.Grayscale
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Grayscale();
   * object.filters.push(filter);
   * object.applyFilters();
   */ filters.Grayscale = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Grayscale.prototype */ {
        /**
     * Filter type
     * @param {String} type
     * @default
     */ type: 'Grayscale',
        fragmentSource: {
            average: "precision highp float;\nuniform sampler2D uTexture;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nfloat average = (color.r + color.b + color.g) / 3.0;\ngl_FragColor = vec4(average, average, average, color.a);\n}",
            lightness: "precision highp float;\nuniform sampler2D uTexture;\nuniform int uMode;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 col = texture2D(uTexture, vTexCoord);\nfloat average = (max(max(col.r, col.g),col.b) + min(min(col.r, col.g),col.b)) / 2.0;\ngl_FragColor = vec4(average, average, average, col.a);\n}",
            luminosity: "precision highp float;\nuniform sampler2D uTexture;\nuniform int uMode;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 col = texture2D(uTexture, vTexCoord);\nfloat average = 0.21 * col.r + 0.72 * col.g + 0.07 * col.b;\ngl_FragColor = vec4(average, average, average, col.a);\n}"
        },
        /**
     * Grayscale mode, between 'average', 'lightness', 'luminosity'
     * @param {String} type
     * @default
     */ mode: 'average',
        mainParameter: 'mode',
        /**
     * Apply the Grayscale operation to a Uint8Array representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8Array to be filtered.
     */ applyTo2d: function(options) {
            var imageData = options.imageData, data = imageData.data, i, len = data.length, value, mode = this.mode;
            for(i = 0; i < len; i += 4){
                if (mode === 'average') value = (data[i] + data[i + 1] + data[i + 2]) / 3;
                else if (mode === 'lightness') value = (Math.min(data[i], data[i + 1], data[i + 2]) + Math.max(data[i], data[i + 1], data[i + 2])) / 2;
                else if (mode === 'luminosity') value = 0.21 * data[i] + 0.72 * data[i + 1] + 0.07 * data[i + 2];
                data[i] = value;
                data[i + 1] = value;
                data[i + 2] = value;
            }
        },
        /**
     * Retrieves the cached shader.
     * @param {Object} options
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */ retrieveShader: function(options) {
            var cacheKey = this.type + '_' + this.mode;
            if (!options.programCache.hasOwnProperty(cacheKey)) {
                var shaderSource = this.fragmentSource[this.mode];
                options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
            }
            return options.programCache[cacheKey];
        },
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                uMode: gl.getUniformLocation(program, 'uMode')
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            // default average mode.
            var mode = 1;
            gl.uniform1i(uniformLocations.uMode, mode);
        },
        /**
     * Grayscale filter isNeutralState implementation
     * The filter is never neutral
     * on the image
     **/ isNeutralState: function() {
            return false;
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Grayscale} Instance of fabric.Image.filters.Grayscale
   */ fabric.Image.filters.Grayscale.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {}), filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Invert filter class
   * @class fabric.Image.filters.Invert
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Invert();
   * object.filters.push(filter);
   * object.applyFilters(canvas.renderAll.bind(canvas));
   */ filters.Invert = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Invert.prototype */ {
        /**
     * Filter type
     * @param {String} type
     * @default
     */ type: 'Invert',
        fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform int uInvert;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nif (uInvert == 1) {\ngl_FragColor = vec4(1.0 - color.r,1.0 -color.g,1.0 -color.b,color.a);\n} else {\ngl_FragColor = color;\n}\n}",
        /**
     * Filter invert. if false, does nothing
     * @param {Boolean} invert
     * @default
     */ invert: true,
        mainParameter: 'invert',
        /**
     * Apply the Invert operation to a Uint8Array representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8Array to be filtered.
     */ applyTo2d: function(options) {
            var imageData = options.imageData, data = imageData.data, i, len = data.length;
            for(i = 0; i < len; i += 4){
                data[i] = 255 - data[i];
                data[i + 1] = 255 - data[i + 1];
                data[i + 2] = 255 - data[i + 2];
            }
        },
        /**
     * Invert filter isNeutralState implementation
     * Used only in image applyFilters to discard filters that will not have an effect
     * on the image
     * @param {Object} options
     **/ isNeutralState: function() {
            return !this.invert;
        },
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                uInvert: gl.getUniformLocation(program, 'uInvert')
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            gl.uniform1i(uniformLocations.uInvert, this.invert);
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Invert} Instance of fabric.Image.filters.Invert
   */ fabric.Image.filters.Invert.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {}), extend = fabric.util.object.extend, filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Noise filter class
   * @class fabric.Image.filters.Noise
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Noise#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Noise({
   *   noise: 700
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */ filters.Noise = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Noise.prototype */ {
        /**
     * Filter type
     * @param {String} type
     * @default
     */ type: 'Noise',
        /**
     * Fragment source for the noise program
     */ fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uStepH;\nuniform float uNoise;\nuniform float uSeed;\nvarying vec2 vTexCoord;\nfloat rand(vec2 co, float seed, float vScale) {\nreturn fract(sin(dot(co.xy * vScale ,vec2(12.9898 , 78.233))) * 43758.5453 * (seed + 0.01) / 2.0);\n}\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\ncolor.rgb += (0.5 - rand(vTexCoord, uSeed, 0.1 / uStepH)) * uNoise;\ngl_FragColor = color;\n}",
        /**
     * Describe the property that is the filter parameter
     * @param {String} m
     * @default
     */ mainParameter: 'noise',
        /**
     * Noise value, from
     * @param {Number} noise
     * @default
     */ noise: 0,
        /**
     * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */ applyTo2d: function(options) {
            if (this.noise === 0) return;
            var imageData = options.imageData, data = imageData.data, i, len = data.length, noise = this.noise, rand;
            for(i = 0, len = data.length; i < len; i += 4){
                rand = (0.5 - Math.random()) * noise;
                data[i] += rand;
                data[i + 1] += rand;
                data[i + 2] += rand;
            }
        },
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                uNoise: gl.getUniformLocation(program, 'uNoise'),
                uSeed: gl.getUniformLocation(program, 'uSeed')
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            gl.uniform1f(uniformLocations.uNoise, this.noise / 255);
            gl.uniform1f(uniformLocations.uSeed, Math.random());
        },
        /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */ toObject: function() {
            return extend(this.callSuper('toObject'), {
                noise: this.noise
            });
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Noise} Instance of fabric.Image.filters.Noise
   */ fabric.Image.filters.Noise.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {}), filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Pixelate filter class
   * @class fabric.Image.filters.Pixelate
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Pixelate#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Pixelate({
   *   blocksize: 8
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */ filters.Pixelate = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Pixelate.prototype */ {
        /**
     * Filter type
     * @param {String} type
     * @default
     */ type: 'Pixelate',
        blocksize: 4,
        mainParameter: 'blocksize',
        /**
     * Fragment source for the Pixelate program
     */ fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uBlocksize;\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nfloat blockW = uBlocksize * uStepW;\nfloat blockH = uBlocksize * uStepW;\nint posX = int(vTexCoord.x / blockW);\nint posY = int(vTexCoord.y / blockH);\nfloat fposX = float(posX);\nfloat fposY = float(posY);\nvec2 squareCoords = vec2(fposX * blockW, fposY * blockH);\nvec4 color = texture2D(uTexture, squareCoords);\ngl_FragColor = color;\n}",
        /**
     * Apply the Pixelate operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */ applyTo2d: function(options) {
            var imageData = options.imageData, data = imageData.data, iLen = imageData.height, jLen = imageData.width, index, i, j, r, g, b, a, _i, _j, _iLen, _jLen;
            for(i = 0; i < iLen; i += this.blocksize)for(j = 0; j < jLen; j += this.blocksize){
                index = i * 4 * jLen + j * 4;
                r = data[index];
                g = data[index + 1];
                b = data[index + 2];
                a = data[index + 3];
                _iLen = Math.min(i + this.blocksize, iLen);
                _jLen = Math.min(j + this.blocksize, jLen);
                for(_i = i; _i < _iLen; _i++)for(_j = j; _j < _jLen; _j++){
                    index = _i * 4 * jLen + _j * 4;
                    data[index] = r;
                    data[index + 1] = g;
                    data[index + 2] = b;
                    data[index + 3] = a;
                }
            }
        },
        /**
     * Indicate when the filter is not gonna apply changes to the image
     **/ isNeutralState: function() {
            return this.blocksize === 1;
        },
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                uBlocksize: gl.getUniformLocation(program, 'uBlocksize'),
                uStepW: gl.getUniformLocation(program, 'uStepW'),
                uStepH: gl.getUniformLocation(program, 'uStepH')
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            gl.uniform1f(uniformLocations.uBlocksize, this.blocksize);
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Pixelate} Instance of fabric.Image.filters.Pixelate
   */ fabric.Image.filters.Pixelate.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {}), extend = fabric.util.object.extend, filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Remove white filter class
   * @class fabric.Image.filters.RemoveColor
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.RemoveColor#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.RemoveColor({
   *   threshold: 0.2,
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */ filters.RemoveColor = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.RemoveColor.prototype */ {
        /**
     * Filter type
     * @param {String} type
     * @default
     */ type: 'RemoveColor',
        /**
     * Color to remove, in any format understood by fabric.Color.
     * @param {String} type
     * @default
     */ color: '#FFFFFF',
        /**
     * Fragment source for the brightness program
     */ fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform vec4 uLow;\nuniform vec4 uHigh;\nvarying vec2 vTexCoord;\nvoid main() {\ngl_FragColor = texture2D(uTexture, vTexCoord);\nif(all(greaterThan(gl_FragColor.rgb,uLow.rgb)) && all(greaterThan(uHigh.rgb,gl_FragColor.rgb))) {\ngl_FragColor.a = 0.0;\n}\n}",
        /**
     * distance to actual color, as value up or down from each r,g,b
     * between 0 and 1
     **/ distance: 0.02,
        /**
     * For color to remove inside distance, use alpha channel for a smoother deletion
     * NOT IMPLEMENTED YET
     **/ useAlpha: false,
        /**
     * Constructor
     * @memberOf fabric.Image.filters.RemoveWhite.prototype
     * @param {Object} [options] Options object
     * @param {Number} [options.color=#RRGGBB] Threshold value
     * @param {Number} [options.distance=10] Distance value
     */ /**
     * Applies filter to canvas element
     * @param {Object} canvasEl Canvas element to apply filter to
     */ applyTo2d: function(options) {
            var imageData = options.imageData, data = imageData.data, i, distance = this.distance * 255, r, g, b, source = new fabric.Color(this.color).getSource(), lowC = [
                source[0] - distance,
                source[1] - distance,
                source[2] - distance
            ], highC = [
                source[0] + distance,
                source[1] + distance,
                source[2] + distance
            ];
            for(i = 0; i < data.length; i += 4){
                r = data[i];
                g = data[i + 1];
                b = data[i + 2];
                if (r > lowC[0] && g > lowC[1] && b > lowC[2] && r < highC[0] && g < highC[1] && b < highC[2]) data[i + 3] = 0;
            }
        },
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                uLow: gl.getUniformLocation(program, 'uLow'),
                uHigh: gl.getUniformLocation(program, 'uHigh')
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            var source = new fabric.Color(this.color).getSource(), distance = parseFloat(this.distance), lowC = [
                0 + source[0] / 255 - distance,
                0 + source[1] / 255 - distance,
                0 + source[2] / 255 - distance,
                1
            ], highC = [
                source[0] / 255 + distance,
                source[1] / 255 + distance,
                source[2] / 255 + distance,
                1
            ];
            gl.uniform4fv(uniformLocations.uLow, lowC);
            gl.uniform4fv(uniformLocations.uHigh, highC);
        },
        /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */ toObject: function() {
            return extend(this.callSuper('toObject'), {
                color: this.color,
                distance: this.distance
            });
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.RemoveColor} Instance of fabric.Image.filters.RemoveWhite
   */ fabric.Image.filters.RemoveColor.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {}), filters = fabric.Image.filters, createClass = fabric.util.createClass;
    var matrices = {
        Brownie: [
            0.59970,
            0.34553,
            -0.27082,
            0,
            0.186,
            -0.0377,
            0.86095,
            0.15059,
            0,
            -0.1449,
            0.24113,
            -0.07441,
            0.44972,
            0,
            -0.02965,
            0,
            0,
            0,
            1,
            0
        ],
        Vintage: [
            0.62793,
            0.32021,
            -0.03965,
            0,
            0.03784,
            0.02578,
            0.64411,
            0.03259,
            0,
            0.02926,
            0.04660,
            -0.08512,
            0.52416,
            0,
            0.02023,
            0,
            0,
            0,
            1,
            0
        ],
        Kodachrome: [
            1.12855,
            -0.39673,
            -0.03992,
            0,
            0.24991,
            -0.16404,
            1.08352,
            -0.05498,
            0,
            0.09698,
            -0.16786,
            -0.56034,
            1.60148,
            0,
            0.13972,
            0,
            0,
            0,
            1,
            0
        ],
        Technicolor: [
            1.91252,
            -0.85453,
            -0.09155,
            0,
            0.04624,
            -0.30878,
            1.76589,
            -0.10601,
            0,
            -0.27589,
            -0.2311,
            -0.75018,
            1.84759,
            0,
            0.12137,
            0,
            0,
            0,
            1,
            0
        ],
        Polaroid: [
            1.438,
            -0.062,
            -0.062,
            0,
            0,
            -0.122,
            1.378,
            -0.122,
            0,
            0,
            -0.016,
            -0.016,
            1.483,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ],
        Sepia: [
            0.393,
            0.769,
            0.189,
            0,
            0,
            0.349,
            0.686,
            0.168,
            0,
            0,
            0.272,
            0.534,
            0.131,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ],
        BlackWhite: [
            1.5,
            1.5,
            1.5,
            0,
            -1,
            1.5,
            1.5,
            1.5,
            0,
            -1,
            1.5,
            1.5,
            1.5,
            0,
            -1,
            0,
            0,
            0,
            1,
            0
        ]
    };
    for(var key in matrices){
        filters[key] = createClass(filters.ColorMatrix, /** @lends fabric.Image.filters.Sepia.prototype */ {
            /**
       * Filter type
       * @param {String} type
       * @default
       */ type: key,
            /**
       * Colormatrix for the effect
       * array of 20 floats. Numbers in positions 4, 9, 14, 19 loose meaning
       * outside the -1, 1 range.
       * @param {Array} matrix array of 20 numbers.
       * @default
       */ matrix: matrices[key],
            /**
       * Lock the matrix export for this kind of static, parameter less filters.
       */ mainParameter: false,
            /**
       * Lock the colormatrix on the color part, skipping alpha
       */ colorsOnly: true
        });
        fabric.Image.filters[key].fromObject = fabric.Image.filters.BaseFilter.fromObject;
    }
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric, filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Color Blend filter class
   * @class fabric.Image.filter.BlendColor
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @example
   * var filter = new fabric.Image.filters.BlendColor({
   *  color: '#000',
   *  mode: 'multiply'
   * });
   *
   * var filter = new fabric.Image.filters.BlendImage({
   *  image: fabricImageObject,
   *  mode: 'multiply',
   *  alpha: 0.5
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */ filters.BlendColor = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Blend.prototype */ {
        type: 'BlendColor',
        /**
     * Color to make the blend operation with. default to a reddish color since black or white
     * gives always strong result.
     * @type String
     * @default
     **/ color: '#F95C63',
        /**
     * Blend mode for the filter: one of multiply, add, diff, screen, subtract,
     * darken, lighten, overlay, exclusion, tint.
     * @type String
     * @default
     **/ mode: 'multiply',
        /**
     * alpha value. represent the strength of the blend color operation.
     * @type Number
     * @default
     **/ alpha: 1,
        /**
     * Fragment source for the Multiply program
     */ fragmentSource: {
            multiply: 'gl_FragColor.rgb *= uColor.rgb;\n',
            screen: 'gl_FragColor.rgb = 1.0 - (1.0 - gl_FragColor.rgb) * (1.0 - uColor.rgb);\n',
            add: 'gl_FragColor.rgb += uColor.rgb;\n',
            diff: 'gl_FragColor.rgb = abs(gl_FragColor.rgb - uColor.rgb);\n',
            subtract: 'gl_FragColor.rgb -= uColor.rgb;\n',
            lighten: 'gl_FragColor.rgb = max(gl_FragColor.rgb, uColor.rgb);\n',
            darken: 'gl_FragColor.rgb = min(gl_FragColor.rgb, uColor.rgb);\n',
            exclusion: 'gl_FragColor.rgb += uColor.rgb - 2.0 * (uColor.rgb * gl_FragColor.rgb);\n',
            overlay: "if (uColor.r < 0.5) {\ngl_FragColor.r *= 2.0 * uColor.r;\n} else {\ngl_FragColor.r = 1.0 - 2.0 * (1.0 - gl_FragColor.r) * (1.0 - uColor.r);\n}\nif (uColor.g < 0.5) {\ngl_FragColor.g *= 2.0 * uColor.g;\n} else {\ngl_FragColor.g = 1.0 - 2.0 * (1.0 - gl_FragColor.g) * (1.0 - uColor.g);\n}\nif (uColor.b < 0.5) {\ngl_FragColor.b *= 2.0 * uColor.b;\n} else {\ngl_FragColor.b = 1.0 - 2.0 * (1.0 - gl_FragColor.b) * (1.0 - uColor.b);\n}\n",
            tint: "gl_FragColor.rgb *= (1.0 - uColor.a);\ngl_FragColor.rgb += uColor.rgb;\n"
        },
        /**
     * build the fragment source for the filters, joining the common part with
     * the specific one.
     * @param {String} mode the mode of the filter, a key of this.fragmentSource
     * @return {String} the source to be compiled
     * @private
     */ buildSource: function(mode) {
            return "precision highp float;\nuniform sampler2D uTexture;\nuniform vec4 uColor;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\ngl_FragColor = color;\nif (color.a > 0.0) {\n" + this.fragmentSource[mode] + '}\n' + '}';
        },
        /**
     * Retrieves the cached shader.
     * @param {Object} options
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */ retrieveShader: function(options) {
            var cacheKey = this.type + '_' + this.mode, shaderSource;
            if (!options.programCache.hasOwnProperty(cacheKey)) {
                shaderSource = this.buildSource(this.mode);
                options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
            }
            return options.programCache[cacheKey];
        },
        /**
     * Apply the Blend operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */ applyTo2d: function(options) {
            var imageData = options.imageData, data = imageData.data, iLen = data.length, tr, tg, tb, r, g, b, source, alpha1 = 1 - this.alpha;
            source = new fabric.Color(this.color).getSource();
            tr = source[0] * this.alpha;
            tg = source[1] * this.alpha;
            tb = source[2] * this.alpha;
            for(var i = 0; i < iLen; i += 4){
                r = data[i];
                g = data[i + 1];
                b = data[i + 2];
                switch(this.mode){
                    case 'multiply':
                        data[i] = r * tr / 255;
                        data[i + 1] = g * tg / 255;
                        data[i + 2] = b * tb / 255;
                        break;
                    case 'screen':
                        data[i] = 255 - (255 - r) * (255 - tr) / 255;
                        data[i + 1] = 255 - (255 - g) * (255 - tg) / 255;
                        data[i + 2] = 255 - (255 - b) * (255 - tb) / 255;
                        break;
                    case 'add':
                        data[i] = r + tr;
                        data[i + 1] = g + tg;
                        data[i + 2] = b + tb;
                        break;
                    case 'diff':
                    case 'difference':
                        data[i] = Math.abs(r - tr);
                        data[i + 1] = Math.abs(g - tg);
                        data[i + 2] = Math.abs(b - tb);
                        break;
                    case 'subtract':
                        data[i] = r - tr;
                        data[i + 1] = g - tg;
                        data[i + 2] = b - tb;
                        break;
                    case 'darken':
                        data[i] = Math.min(r, tr);
                        data[i + 1] = Math.min(g, tg);
                        data[i + 2] = Math.min(b, tb);
                        break;
                    case 'lighten':
                        data[i] = Math.max(r, tr);
                        data[i + 1] = Math.max(g, tg);
                        data[i + 2] = Math.max(b, tb);
                        break;
                    case 'overlay':
                        data[i] = tr < 128 ? 2 * r * tr / 255 : 255 - 2 * (255 - r) * (255 - tr) / 255;
                        data[i + 1] = tg < 128 ? 2 * g * tg / 255 : 255 - 2 * (255 - g) * (255 - tg) / 255;
                        data[i + 2] = tb < 128 ? 2 * b * tb / 255 : 255 - 2 * (255 - b) * (255 - tb) / 255;
                        break;
                    case 'exclusion':
                        data[i] = tr + r - 2 * tr * r / 255;
                        data[i + 1] = tg + g - 2 * tg * g / 255;
                        data[i + 2] = tb + b - 2 * tb * b / 255;
                        break;
                    case 'tint':
                        data[i] = tr + r * alpha1;
                        data[i + 1] = tg + g * alpha1;
                        data[i + 2] = tb + b * alpha1;
                }
            }
        },
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                uColor: gl.getUniformLocation(program, 'uColor')
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            var source = new fabric.Color(this.color).getSource();
            source[0] = this.alpha * source[0] / 255;
            source[1] = this.alpha * source[1] / 255;
            source[2] = this.alpha * source[2] / 255;
            source[3] = this.alpha;
            gl.uniform4fv(uniformLocations.uColor, source);
        },
        /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */ toObject: function() {
            return {
                type: this.type,
                color: this.color,
                mode: this.mode,
                alpha: this.alpha
            };
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.BlendColor} Instance of fabric.Image.filters.BlendColor
   */ fabric.Image.filters.BlendColor.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric, filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Image Blend filter class
   * @class fabric.Image.filter.BlendImage
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @example
   * var filter = new fabric.Image.filters.BlendColor({
   *  color: '#000',
   *  mode: 'multiply'
   * });
   *
   * var filter = new fabric.Image.filters.BlendImage({
   *  image: fabricImageObject,
   *  mode: 'multiply',
   *  alpha: 0.5
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */ filters.BlendImage = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.BlendImage.prototype */ {
        type: 'BlendImage',
        /**
     * Color to make the blend operation with. default to a reddish color since black or white
     * gives always strong result.
     **/ image: null,
        /**
     * Blend mode for the filter (one of "multiply", "mask")
     * @type String
     * @default
     **/ mode: 'multiply',
        /**
     * alpha value. represent the strength of the blend image operation.
     * not implemented.
     **/ alpha: 1,
        vertexSource: "attribute vec2 aPosition;\nvarying vec2 vTexCoord;\nvarying vec2 vTexCoord2;\nuniform mat3 uTransformMatrix;\nvoid main() {\nvTexCoord = aPosition;\nvTexCoord2 = (uTransformMatrix * vec3(aPosition, 1.0)).xy;\ngl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);\n}",
        /**
     * Fragment source for the Multiply program
     */ fragmentSource: {
            multiply: "precision highp float;\nuniform sampler2D uTexture;\nuniform sampler2D uImage;\nuniform vec4 uColor;\nvarying vec2 vTexCoord;\nvarying vec2 vTexCoord2;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nvec4 color2 = texture2D(uImage, vTexCoord2);\ncolor.rgba *= color2.rgba;\ngl_FragColor = color;\n}",
            mask: "precision highp float;\nuniform sampler2D uTexture;\nuniform sampler2D uImage;\nuniform vec4 uColor;\nvarying vec2 vTexCoord;\nvarying vec2 vTexCoord2;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nvec4 color2 = texture2D(uImage, vTexCoord2);\ncolor.a = color2.a;\ngl_FragColor = color;\n}"
        },
        /**
     * Retrieves the cached shader.
     * @param {Object} options
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */ retrieveShader: function(options) {
            var cacheKey = this.type + '_' + this.mode;
            var shaderSource = this.fragmentSource[this.mode];
            if (!options.programCache.hasOwnProperty(cacheKey)) options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
            return options.programCache[cacheKey];
        },
        applyToWebGL: function(options) {
            // load texture to blend.
            var gl = options.context, texture = this.createTexture(options.filterBackend, this.image);
            this.bindAdditionalTexture(gl, texture, gl.TEXTURE1);
            this.callSuper('applyToWebGL', options);
            this.unbindAdditionalTexture(gl, gl.TEXTURE1);
        },
        createTexture: function(backend, image) {
            return backend.getCachedTexture(image.cacheKey, image._element);
        },
        /**
     * Calculate a transformMatrix to adapt the image to blend over
     * @param {Object} options
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */ calculateMatrix: function() {
            var image = this.image, width = image._element.width, height = image._element.height;
            return [
                1 / image.scaleX,
                0,
                0,
                0,
                1 / image.scaleY,
                0,
                -image.left / width,
                -image.top / height,
                1
            ];
        },
        /**
     * Apply the Blend operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */ applyTo2d: function(options) {
            var imageData = options.imageData, resources = options.filterBackend.resources, data = imageData.data, iLen = data.length, width = imageData.width, height = imageData.height, tr, tg, tb, ta, r, g, b, a, canvas1, context, image = this.image, blendData;
            if (!resources.blendImage) resources.blendImage = fabric.util.createCanvasElement();
            canvas1 = resources.blendImage;
            context = canvas1.getContext('2d');
            if (canvas1.width !== width || canvas1.height !== height) {
                canvas1.width = width;
                canvas1.height = height;
            } else context.clearRect(0, 0, width, height);
            context.setTransform(image.scaleX, 0, 0, image.scaleY, image.left, image.top);
            context.drawImage(image._element, 0, 0, width, height);
            blendData = context.getImageData(0, 0, width, height).data;
            for(var i = 0; i < iLen; i += 4){
                r = data[i];
                g = data[i + 1];
                b = data[i + 2];
                a = data[i + 3];
                tr = blendData[i];
                tg = blendData[i + 1];
                tb = blendData[i + 2];
                ta = blendData[i + 3];
                switch(this.mode){
                    case 'multiply':
                        data[i] = r * tr / 255;
                        data[i + 1] = g * tg / 255;
                        data[i + 2] = b * tb / 255;
                        data[i + 3] = a * ta / 255;
                        break;
                    case 'mask':
                        data[i + 3] = ta;
                        break;
                }
            }
        },
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                uTransformMatrix: gl.getUniformLocation(program, 'uTransformMatrix'),
                uImage: gl.getUniformLocation(program, 'uImage')
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            var matrix = this.calculateMatrix();
            gl.uniform1i(uniformLocations.uImage, 1); // texture unit 1.
            gl.uniformMatrix3fv(uniformLocations.uTransformMatrix, false, matrix);
        },
        /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */ toObject: function() {
            return {
                type: this.type,
                image: this.image && this.image.toObject(),
                mode: this.mode,
                alpha: this.alpha
            };
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} callback to be invoked after filter creation
   * @return {fabric.Image.filters.BlendImage} Instance of fabric.Image.filters.BlendImage
   */ fabric.Image.filters.BlendImage.fromObject = function(object, callback) {
        fabric.Image.fromObject(object.image, function(image) {
            var options = fabric.util.object.clone(object);
            options.image = image;
            callback(new fabric.Image.filters.BlendImage(options));
        });
    };
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {}), pow = Math.pow, floor = Math.floor, sqrt = Math.sqrt, abs = Math.abs, round = Math.round, sin = Math.sin, ceil = Math.ceil, filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Resize image filter class
   * @class fabric.Image.filters.Resize
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Resize();
   * object.filters.push(filter);
   * object.applyFilters(canvas.renderAll.bind(canvas));
   */ filters.Resize = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Resize.prototype */ {
        /**
     * Filter type
     * @param {String} type
     * @default
     */ type: 'Resize',
        /**
     * Resize type
     * for webgl resizeType is just lanczos, for canvas2d can be:
     * bilinear, hermite, sliceHack, lanczos.
     * @param {String} resizeType
     * @default
     */ resizeType: 'hermite',
        /**
     * Scale factor for resizing, x axis
     * @param {Number} scaleX
     * @default
     */ scaleX: 1,
        /**
     * Scale factor for resizing, y axis
     * @param {Number} scaleY
     * @default
     */ scaleY: 1,
        /**
     * LanczosLobes parameter for lanczos filter, valid for resizeType lanczos
     * @param {Number} lanczosLobes
     * @default
     */ lanczosLobes: 3,
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                uDelta: gl.getUniformLocation(program, 'uDelta'),
                uTaps: gl.getUniformLocation(program, 'uTaps')
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            gl.uniform2fv(uniformLocations.uDelta, this.horizontal ? [
                1 / this.width,
                0
            ] : [
                0,
                1 / this.height
            ]);
            gl.uniform1fv(uniformLocations.uTaps, this.taps);
        },
        /**
     * Retrieves the cached shader.
     * @param {Object} options
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */ retrieveShader: function(options) {
            var filterWindow = this.getFilterWindow(), cacheKey = this.type + '_' + filterWindow;
            if (!options.programCache.hasOwnProperty(cacheKey)) {
                var fragmentShader = this.generateShader(filterWindow);
                options.programCache[cacheKey] = this.createProgram(options.context, fragmentShader);
            }
            return options.programCache[cacheKey];
        },
        getFilterWindow: function() {
            var scale = this.tempScale;
            return Math.ceil(this.lanczosLobes / scale);
        },
        getTaps: function() {
            var lobeFunction = this.lanczosCreate(this.lanczosLobes), scale = this.tempScale, filterWindow = this.getFilterWindow(), taps = new Array(filterWindow);
            for(var i = 1; i <= filterWindow; i++)taps[i - 1] = lobeFunction(i * scale);
            return taps;
        },
        /**
     * Generate vertex and shader sources from the necessary steps numbers
     * @param {Number} filterWindow
     */ generateShader: function(filterWindow) {
            var offsets = new Array(filterWindow), fragmentShader = this.fragmentSourceTOP, filterWindow;
            for(var i = 1; i <= filterWindow; i++)offsets[i - 1] = i + '.0 * uDelta';
            fragmentShader += 'uniform float uTaps[' + filterWindow + '];\n';
            fragmentShader += 'void main() {\n';
            fragmentShader += '  vec4 color = texture2D(uTexture, vTexCoord);\n';
            fragmentShader += '  float sum = 1.0;\n';
            offsets.forEach(function(offset, i) {
                fragmentShader += '  color += texture2D(uTexture, vTexCoord + ' + offset + ') * uTaps[' + i + '];\n';
                fragmentShader += '  color += texture2D(uTexture, vTexCoord - ' + offset + ') * uTaps[' + i + '];\n';
                fragmentShader += '  sum += 2.0 * uTaps[' + i + '];\n';
            });
            fragmentShader += '  gl_FragColor = color / sum;\n';
            fragmentShader += '}';
            return fragmentShader;
        },
        fragmentSourceTOP: "precision highp float;\nuniform sampler2D uTexture;\nuniform vec2 uDelta;\nvarying vec2 vTexCoord;\n",
        /**
     * Apply the resize filter to the image
     * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
     *
     * @param {Object} options
     * @param {Number} options.passes The number of filters remaining to be executed
     * @param {Boolean} options.webgl Whether to use webgl to render the filter.
     * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
     * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */ applyTo: function(options) {
            if (options.webgl) {
                options.passes++;
                this.width = options.sourceWidth;
                this.horizontal = true;
                this.dW = Math.round(this.width * this.scaleX);
                this.dH = options.sourceHeight;
                this.tempScale = this.dW / this.width;
                this.taps = this.getTaps();
                options.destinationWidth = this.dW;
                this._setupFrameBuffer(options);
                this.applyToWebGL(options);
                this._swapTextures(options);
                options.sourceWidth = options.destinationWidth;
                this.height = options.sourceHeight;
                this.horizontal = false;
                this.dH = Math.round(this.height * this.scaleY);
                this.tempScale = this.dH / this.height;
                this.taps = this.getTaps();
                options.destinationHeight = this.dH;
                this._setupFrameBuffer(options);
                this.applyToWebGL(options);
                this._swapTextures(options);
                options.sourceHeight = options.destinationHeight;
            } else this.applyTo2d(options);
        },
        isNeutralState: function() {
            return this.scaleX === 1 && this.scaleY === 1;
        },
        lanczosCreate: function(lobes) {
            return function(x) {
                if (x >= lobes || x <= -lobes) return 0.0;
                if (x < 1.19209290E-07 && x > -0.00000011920929) return 1.0;
                x *= Math.PI;
                var xx = x / lobes;
                return sin(x) / x * sin(xx) / xx;
            };
        },
        /**
     * Applies filter to canvas element
     * @memberOf fabric.Image.filters.Resize.prototype
     * @param {Object} canvasEl Canvas element to apply filter to
     * @param {Number} scaleX
     * @param {Number} scaleY
     */ applyTo2d: function(options) {
            var imageData = options.imageData, scaleX = this.scaleX, scaleY = this.scaleY;
            this.rcpScaleX = 1 / scaleX;
            this.rcpScaleY = 1 / scaleY;
            var oW = imageData.width, oH = imageData.height, dW = round(oW * scaleX), dH = round(oH * scaleY), newData;
            if (this.resizeType === 'sliceHack') newData = this.sliceByTwo(options, oW, oH, dW, dH);
            else if (this.resizeType === 'hermite') newData = this.hermiteFastResize(options, oW, oH, dW, dH);
            else if (this.resizeType === 'bilinear') newData = this.bilinearFiltering(options, oW, oH, dW, dH);
            else if (this.resizeType === 'lanczos') newData = this.lanczosResize(options, oW, oH, dW, dH);
            options.imageData = newData;
        },
        /**
     * Filter sliceByTwo
     * @param {Object} canvasEl Canvas element to apply filter to
     * @param {Number} oW Original Width
     * @param {Number} oH Original Height
     * @param {Number} dW Destination Width
     * @param {Number} dH Destination Height
     * @returns {ImageData}
     */ sliceByTwo: function(options, oW, oH, dW, dH) {
            var imageData = options.imageData, mult = 0.5, doneW = false, doneH = false, stepW = oW * mult, stepH = oH * mult, resources = fabric.filterBackend.resources, tmpCanvas, ctx, sX = 0, sY = 0, dX = oW, dY = 0;
            if (!resources.sliceByTwo) resources.sliceByTwo = document.createElement('canvas');
            tmpCanvas = resources.sliceByTwo;
            if (tmpCanvas.width < oW * 1.5 || tmpCanvas.height < oH) {
                tmpCanvas.width = oW * 1.5;
                tmpCanvas.height = oH;
            }
            ctx = tmpCanvas.getContext('2d');
            ctx.clearRect(0, 0, oW * 1.5, oH);
            ctx.putImageData(imageData, 0, 0);
            dW = floor(dW);
            dH = floor(dH);
            while(!doneW || !doneH){
                oW = stepW;
                oH = stepH;
                if (dW < floor(stepW * mult)) stepW = floor(stepW * mult);
                else {
                    stepW = dW;
                    doneW = true;
                }
                if (dH < floor(stepH * mult)) stepH = floor(stepH * mult);
                else {
                    stepH = dH;
                    doneH = true;
                }
                ctx.drawImage(tmpCanvas, sX, sY, oW, oH, dX, dY, stepW, stepH);
                sX = dX;
                sY = dY;
                dY += stepH;
            }
            return ctx.getImageData(sX, sY, dW, dH);
        },
        /**
     * Filter lanczosResize
     * @param {Object} canvasEl Canvas element to apply filter to
     * @param {Number} oW Original Width
     * @param {Number} oH Original Height
     * @param {Number} dW Destination Width
     * @param {Number} dH Destination Height
     * @returns {ImageData}
     */ lanczosResize: function(options, oW, oH, dW, dH) {
            function process(u) {
                var v, i, weight, idx, a, red, green, blue, alpha, fX, fY;
                center.x = (u + 0.5) * ratioX;
                icenter.x = floor(center.x);
                for(v = 0; v < dH; v++){
                    center.y = (v + 0.5) * ratioY;
                    icenter.y = floor(center.y);
                    a = 0;
                    red = 0;
                    green = 0;
                    blue = 0;
                    alpha = 0;
                    for(i = icenter.x - range2X; i <= icenter.x + range2X; i++){
                        if (i < 0 || i >= oW) continue;
                        fX = floor(1000 * abs(i - center.x));
                        if (!cacheLanc[fX]) cacheLanc[fX] = {};
                        for(var j = icenter.y - range2Y; j <= icenter.y + range2Y; j++){
                            if (j < 0 || j >= oH) continue;
                            fY = floor(1000 * abs(j - center.y));
                            if (!cacheLanc[fX][fY]) cacheLanc[fX][fY] = lanczos(sqrt(pow(fX * rcpRatioX, 2) + pow(fY * rcpRatioY, 2)) / 1000);
                            weight = cacheLanc[fX][fY];
                            if (weight > 0) {
                                idx = (j * oW + i) * 4;
                                a += weight;
                                red += weight * srcData[idx];
                                green += weight * srcData[idx + 1];
                                blue += weight * srcData[idx + 2];
                                alpha += weight * srcData[idx + 3];
                            }
                        }
                    }
                    idx = (v * dW + u) * 4;
                    destData[idx] = red / a;
                    destData[idx + 1] = green / a;
                    destData[idx + 2] = blue / a;
                    destData[idx + 3] = alpha / a;
                }
                if (++u < dW) return process(u);
                else return destImg;
            }
            var srcData = options.imageData.data, destImg = options.ctx.createImageData(dW, dH), destData = destImg.data, lanczos = this.lanczosCreate(this.lanczosLobes), ratioX = this.rcpScaleX, ratioY = this.rcpScaleY, rcpRatioX = 2 / this.rcpScaleX, rcpRatioY = 2 / this.rcpScaleY, range2X = ceil(ratioX * this.lanczosLobes / 2), range2Y = ceil(ratioY * this.lanczosLobes / 2), cacheLanc = {}, center = {}, icenter = {};
            return process(0);
        },
        /**
     * bilinearFiltering
     * @param {Object} canvasEl Canvas element to apply filter to
     * @param {Number} oW Original Width
     * @param {Number} oH Original Height
     * @param {Number} dW Destination Width
     * @param {Number} dH Destination Height
     * @returns {ImageData}
     */ bilinearFiltering: function(options, oW, oH, dW, dH) {
            var a, b, c, d, x, y, i, j, xDiff, yDiff, chnl, color, offset = 0, origPix, ratioX = this.rcpScaleX, ratioY = this.rcpScaleY, w4 = 4 * (oW - 1), img = options.imageData, pixels = img.data, destImage = options.ctx.createImageData(dW, dH), destPixels = destImage.data;
            for(i = 0; i < dH; i++)for(j = 0; j < dW; j++){
                x = floor(ratioX * j);
                y = floor(ratioY * i);
                xDiff = ratioX * j - x;
                yDiff = ratioY * i - y;
                origPix = 4 * (y * oW + x);
                for(chnl = 0; chnl < 4; chnl++){
                    a = pixels[origPix + chnl];
                    b = pixels[origPix + 4 + chnl];
                    c = pixels[origPix + w4 + chnl];
                    d = pixels[origPix + w4 + 4 + chnl];
                    color = a * (1 - xDiff) * (1 - yDiff) + b * xDiff * (1 - yDiff) + c * yDiff * (1 - xDiff) + d * xDiff * yDiff;
                    destPixels[offset++] = color;
                }
            }
            return destImage;
        },
        /**
     * hermiteFastResize
     * @param {Object} canvasEl Canvas element to apply filter to
     * @param {Number} oW Original Width
     * @param {Number} oH Original Height
     * @param {Number} dW Destination Width
     * @param {Number} dH Destination Height
     * @returns {ImageData}
     */ hermiteFastResize: function(options, oW, oH, dW, dH) {
            var ratioW = this.rcpScaleX, ratioH = this.rcpScaleY, ratioWHalf = ceil(ratioW / 2), ratioHHalf = ceil(ratioH / 2), img = options.imageData, data = img.data, img2 = options.ctx.createImageData(dW, dH), data2 = img2.data;
            for(var j = 0; j < dH; j++)for(var i = 0; i < dW; i++){
                var x2 = (i + j * dW) * 4, weight = 0, weights = 0, weightsAlpha = 0, gxR = 0, gxG = 0, gxB = 0, gxA = 0, centerY = (j + 0.5) * ratioH;
                for(var yy = floor(j * ratioH); yy < (j + 1) * ratioH; yy++){
                    var dy = abs(centerY - (yy + 0.5)) / ratioHHalf, centerX = (i + 0.5) * ratioW, w0 = dy * dy;
                    for(var xx = floor(i * ratioW); xx < (i + 1) * ratioW; xx++){
                        var dx = abs(centerX - (xx + 0.5)) / ratioWHalf, w = sqrt(w0 + dx * dx);
                        /* eslint-disable max-depth */ if (w > 1 && w < -1) continue;
                        //hermite filter
                        weight = 2 * w * w * w - 3 * w * w + 1;
                        if (weight > 0) {
                            dx = 4 * (xx + yy * oW);
                            //alpha
                            gxA += weight * data[dx + 3];
                            weightsAlpha += weight;
                            //colors
                            if (data[dx + 3] < 255) weight = weight * data[dx + 3] / 250;
                            gxR += weight * data[dx];
                            gxG += weight * data[dx + 1];
                            gxB += weight * data[dx + 2];
                            weights += weight;
                        }
                    /* eslint-enable max-depth */ }
                }
                data2[x2] = gxR / weights;
                data2[x2 + 1] = gxG / weights;
                data2[x2 + 2] = gxB / weights;
                data2[x2 + 3] = gxA / weightsAlpha;
            }
            return img2;
        },
        /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */ toObject: function() {
            return {
                type: this.type,
                scaleX: this.scaleX,
                scaleY: this.scaleY,
                resizeType: this.resizeType,
                lanczosLobes: this.lanczosLobes
            };
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Resize} Instance of fabric.Image.filters.Resize
   */ fabric.Image.filters.Resize.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {}), filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Contrast filter class
   * @class fabric.Image.filters.Contrast
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Contrast#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Contrast({
   *   contrast: 0.25
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */ filters.Contrast = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Contrast.prototype */ {
        /**
     * Filter type
     * @param {String} type
     * @default
     */ type: 'Contrast',
        fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uContrast;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nfloat contrastF = 1.015 * (uContrast + 1.0) / (1.0 * (1.015 - uContrast));\ncolor.rgb = contrastF * (color.rgb - 0.5) + 0.5;\ngl_FragColor = color;\n}",
        /**
     * contrast value, range from -1 to 1.
     * @param {Number} contrast
     * @default 0
     */ contrast: 0,
        mainParameter: 'contrast',
        /**
     * Constructor
     * @memberOf fabric.Image.filters.Contrast.prototype
     * @param {Object} [options] Options object
     * @param {Number} [options.contrast=0] Value to contrast the image up (-1...1)
     */ /**
      * Apply the Contrast operation to a Uint8Array representing the pixels of an image.
      *
      * @param {Object} options
      * @param {ImageData} options.imageData The Uint8Array to be filtered.
      */ applyTo2d: function(options) {
            if (this.contrast === 0) return;
            var imageData = options.imageData, i, len, data = imageData.data, len = data.length, contrast = Math.floor(this.contrast * 255), contrastF = 259 * (contrast + 255) / (255 * (259 - contrast));
            for(i = 0; i < len; i += 4){
                data[i] = contrastF * (data[i] - 128) + 128;
                data[i + 1] = contrastF * (data[i + 1] - 128) + 128;
                data[i + 2] = contrastF * (data[i + 2] - 128) + 128;
            }
        },
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                uContrast: gl.getUniformLocation(program, 'uContrast')
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            gl.uniform1f(uniformLocations.uContrast, this.contrast);
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Contrast} Instance of fabric.Image.filters.Contrast
   */ fabric.Image.filters.Contrast.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {}), filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Saturate filter class
   * @class fabric.Image.filters.Saturation
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Saturation#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Saturation({
   *   saturation: 1
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */ filters.Saturation = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Saturation.prototype */ {
        /**
     * Filter type
     * @param {String} type
     * @default
     */ type: 'Saturation',
        fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uSaturation;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nfloat rgMax = max(color.r, color.g);\nfloat rgbMax = max(rgMax, color.b);\ncolor.r += rgbMax != color.r ? (rgbMax - color.r) * uSaturation : 0.00;\ncolor.g += rgbMax != color.g ? (rgbMax - color.g) * uSaturation : 0.00;\ncolor.b += rgbMax != color.b ? (rgbMax - color.b) * uSaturation : 0.00;\ngl_FragColor = color;\n}",
        /**
     * Saturation value, from -1 to 1.
     * Increases/decreases the color saturation.
     * A value of 0 has no effect.
     * 
     * @param {Number} saturation
     * @default
     */ saturation: 0,
        mainParameter: 'saturation',
        /**
     * Constructor
     * @memberOf fabric.Image.filters.Saturate.prototype
     * @param {Object} [options] Options object
     * @param {Number} [options.saturate=0] Value to saturate the image (-1...1)
     */ /**
     * Apply the Saturation operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */ applyTo2d: function(options) {
            if (this.saturation === 0) return;
            var imageData = options.imageData, data = imageData.data, len = data.length, adjust = -this.saturation, i, max;
            for(i = 0; i < len; i += 4){
                max = Math.max(data[i], data[i + 1], data[i + 2]);
                data[i] += max !== data[i] ? (max - data[i]) * adjust : 0;
                data[i + 1] += max !== data[i + 1] ? (max - data[i + 1]) * adjust : 0;
                data[i + 2] += max !== data[i + 2] ? (max - data[i + 2]) * adjust : 0;
            }
        },
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                uSaturation: gl.getUniformLocation(program, 'uSaturation')
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            gl.uniform1f(uniformLocations.uSaturation, -this.saturation);
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Saturation} Instance of fabric.Image.filters.Saturate
   */ fabric.Image.filters.Saturation.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {}), filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Vibrance filter class
   * @class fabric.Image.filters.Vibrance
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Vibrance#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Vibrance({
   *   vibrance: 1
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */ filters.Vibrance = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Vibrance.prototype */ {
        /**
     * Filter type
     * @param {String} type
     * @default
     */ type: 'Vibrance',
        fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uVibrance;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nfloat max = max(color.r, max(color.g, color.b));\nfloat avg = (color.r + color.g + color.b) / 3.0;\nfloat amt = (abs(max - avg) * 2.0) * uVibrance;\ncolor.r += max != color.r ? (max - color.r) * amt : 0.00;\ncolor.g += max != color.g ? (max - color.g) * amt : 0.00;\ncolor.b += max != color.b ? (max - color.b) * amt : 0.00;\ngl_FragColor = color;\n}",
        /**
     * Vibrance value, from -1 to 1.
     * Increases/decreases the saturation of more muted colors with less effect on saturated colors.
     * A value of 0 has no effect.
     * 
     * @param {Number} vibrance
     * @default
     */ vibrance: 0,
        mainParameter: 'vibrance',
        /**
     * Constructor
     * @memberOf fabric.Image.filters.Vibrance.prototype
     * @param {Object} [options] Options object
     * @param {Number} [options.vibrance=0] Vibrance value for the image (between -1 and 1)
     */ /**
     * Apply the Vibrance operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */ applyTo2d: function(options) {
            if (this.vibrance === 0) return;
            var imageData = options.imageData, data = imageData.data, len = data.length, adjust = -this.vibrance, i, max, avg, amt;
            for(i = 0; i < len; i += 4){
                max = Math.max(data[i], data[i + 1], data[i + 2]);
                avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
                amt = Math.abs(max - avg) * 2 / 255 * adjust;
                data[i] += max !== data[i] ? (max - data[i]) * amt : 0;
                data[i + 1] += max !== data[i + 1] ? (max - data[i + 1]) * amt : 0;
                data[i + 2] += max !== data[i + 2] ? (max - data[i + 2]) * amt : 0;
            }
        },
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                uVibrance: gl.getUniformLocation(program, 'uVibrance')
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            gl.uniform1f(uniformLocations.uVibrance, -this.vibrance);
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Vibrance} Instance of fabric.Image.filters.Vibrance
   */ fabric.Image.filters.Vibrance.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {}), filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Blur filter class
   * @class fabric.Image.filters.Blur
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Blur#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Blur({
   *   blur: 0.5
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */ filters.Blur = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Blur.prototype */ {
        type: 'Blur',
        /*
'gl_FragColor = vec4(0.0);',
'gl_FragColor += texture2D(texture, vTexCoord + -7 * uDelta)*0.0044299121055113265;',
'gl_FragColor += texture2D(texture, vTexCoord + -6 * uDelta)*0.00895781211794;',
'gl_FragColor += texture2D(texture, vTexCoord + -5 * uDelta)*0.0215963866053;',
'gl_FragColor += texture2D(texture, vTexCoord + -4 * uDelta)*0.0443683338718;',
'gl_FragColor += texture2D(texture, vTexCoord + -3 * uDelta)*0.0776744219933;',
'gl_FragColor += texture2D(texture, vTexCoord + -2 * uDelta)*0.115876621105;',
'gl_FragColor += texture2D(texture, vTexCoord + -1 * uDelta)*0.147308056121;',
'gl_FragColor += texture2D(texture, vTexCoord              )*0.159576912161;',
'gl_FragColor += texture2D(texture, vTexCoord + 1 * uDelta)*0.147308056121;',
'gl_FragColor += texture2D(texture, vTexCoord + 2 * uDelta)*0.115876621105;',
'gl_FragColor += texture2D(texture, vTexCoord + 3 * uDelta)*0.0776744219933;',
'gl_FragColor += texture2D(texture, vTexCoord + 4 * uDelta)*0.0443683338718;',
'gl_FragColor += texture2D(texture, vTexCoord + 5 * uDelta)*0.0215963866053;',
'gl_FragColor += texture2D(texture, vTexCoord + 6 * uDelta)*0.00895781211794;',
'gl_FragColor += texture2D(texture, vTexCoord + 7 * uDelta)*0.0044299121055113265;',
*/ /* eslint-disable max-len */ fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform vec2 uDelta;\nvarying vec2 vTexCoord;\nconst float nSamples = 15.0;\nvec3 v3offset = vec3(12.9898, 78.233, 151.7182);\nfloat random(vec3 scale) {\nreturn fract(sin(dot(gl_FragCoord.xyz, scale)) * 43758.5453);\n}\nvoid main() {\nvec4 color = vec4(0.0);\nfloat total = 0.0;\nfloat offset = random(v3offset);\nfor (float t = -nSamples; t <= nSamples; t++) {\nfloat percent = (t + offset - 0.5) / nSamples;\nfloat weight = 1.0 - abs(percent);\ncolor += texture2D(uTexture, vTexCoord + uDelta * percent) * weight;\ntotal += weight;\n}\ngl_FragColor = color / total;\n}",
        /* eslint-enable max-len */ /**
     * blur value, in percentage of image dimensions.
     * specific to keep the image blur constant at different resolutions
     * range between 0 and 1.
     * @type Number
     * @default
     */ blur: 0,
        mainParameter: 'blur',
        applyTo: function(options) {
            if (options.webgl) {
                // this aspectRatio is used to give the same blur to vertical and horizontal
                this.aspectRatio = options.sourceWidth / options.sourceHeight;
                options.passes++;
                this._setupFrameBuffer(options);
                this.horizontal = true;
                this.applyToWebGL(options);
                this._swapTextures(options);
                this._setupFrameBuffer(options);
                this.horizontal = false;
                this.applyToWebGL(options);
                this._swapTextures(options);
            } else this.applyTo2d(options);
        },
        applyTo2d: function(options) {
            // paint canvasEl with current image data.
            //options.ctx.putImageData(options.imageData, 0, 0);
            options.imageData = this.simpleBlur(options);
        },
        simpleBlur: function(options) {
            var resources = options.filterBackend.resources, canvas1, canvas2, width = options.imageData.width, height = options.imageData.height;
            if (!resources.blurLayer1) {
                resources.blurLayer1 = fabric.util.createCanvasElement();
                resources.blurLayer2 = fabric.util.createCanvasElement();
            }
            canvas1 = resources.blurLayer1;
            canvas2 = resources.blurLayer2;
            if (canvas1.width !== width || canvas1.height !== height) {
                canvas2.width = canvas1.width = width;
                canvas2.height = canvas1.height = height;
            }
            var ctx1 = canvas1.getContext('2d'), ctx2 = canvas2.getContext('2d'), nSamples = 15, random, percent, j, i, blur = this.blur * 0.03;
            // load first canvas
            ctx1.putImageData(options.imageData, 0, 0);
            ctx2.clearRect(0, 0, width, height);
            for(i = -nSamples; i <= nSamples; i++){
                random = (Math.random() - 0.5) / 4;
                percent = i / nSamples;
                j = blur * percent * width + random;
                ctx2.globalAlpha = 1 - Math.abs(percent);
                ctx2.drawImage(canvas1, j, random);
                ctx1.drawImage(canvas2, 0, 0);
                ctx2.globalAlpha = 1;
                ctx2.clearRect(0, 0, canvas2.width, canvas2.height);
            }
            for(i = -nSamples; i <= nSamples; i++){
                random = (Math.random() - 0.5) / 4;
                percent = i / nSamples;
                j = blur * percent * height + random;
                ctx2.globalAlpha = 1 - Math.abs(percent);
                ctx2.drawImage(canvas1, random, j);
                ctx1.drawImage(canvas2, 0, 0);
                ctx2.globalAlpha = 1;
                ctx2.clearRect(0, 0, canvas2.width, canvas2.height);
            }
            options.ctx.drawImage(canvas1, 0, 0);
            var newImageData = options.ctx.getImageData(0, 0, canvas1.width, canvas1.height);
            ctx1.globalAlpha = 1;
            ctx1.clearRect(0, 0, canvas1.width, canvas1.height);
            return newImageData;
        },
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                delta: gl.getUniformLocation(program, 'uDelta')
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            var delta = this.chooseRightDelta();
            gl.uniform2fv(uniformLocations.delta, delta);
        },
        /**
     * choose right value of image percentage to blur with
     * @returns {Array} a numeric array with delta values
     */ chooseRightDelta: function() {
            var blurScale = 1, delta = [
                0,
                0
            ], blur;
            if (this.horizontal) {
                if (this.aspectRatio > 1) // image is wide, i want to shrink radius horizontal
                blurScale = 1 / this.aspectRatio;
            } else if (this.aspectRatio < 1) // image is tall, i want to shrink radius vertical
            blurScale = this.aspectRatio;
            blur = blurScale * this.blur * 0.12;
            if (this.horizontal) delta[0] = blur;
            else delta[1] = blur;
            return delta;
        }
    });
    /**
   * Deserialize a JSON definition of a BlurFilter into a concrete instance.
   */ filters.Blur.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {}), filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Gamma filter class
   * @class fabric.Image.filters.Gamma
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Gamma#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Gamma({
   *   gamma: [1, 0.5, 2.1]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */ filters.Gamma = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Gamma.prototype */ {
        /**
     * Filter type
     * @param {String} type
     * @default
     */ type: 'Gamma',
        fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform vec3 uGamma;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nvec3 correction = (1.0 / uGamma);\ncolor.r = pow(color.r, correction.r);\ncolor.g = pow(color.g, correction.g);\ncolor.b = pow(color.b, correction.b);\ngl_FragColor = color;\ngl_FragColor.rgb *= color.a;\n}",
        /**
     * Gamma array value, from 0.01 to 2.2.
     * @param {Array} gamma
     * @default
     */ gamma: [
            1,
            1,
            1
        ],
        /**
     * Describe the property that is the filter parameter
     * @param {String} m
     * @default
     */ mainParameter: 'gamma',
        /**
     * Constructor
     * @param {Object} [options] Options object
     */ initialize: function(options) {
            this.gamma = [
                1,
                1,
                1
            ];
            filters.BaseFilter.prototype.initialize.call(this, options);
        },
        /**
     * Apply the Gamma operation to a Uint8Array representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8Array to be filtered.
     */ applyTo2d: function(options) {
            var imageData = options.imageData, data = imageData.data, gamma = this.gamma, len = data.length, rInv = 1 / gamma[0], gInv = 1 / gamma[1], bInv = 1 / gamma[2], i;
            if (!this.rVals) {
                // eslint-disable-next-line
                this.rVals = new Uint8Array(256);
                // eslint-disable-next-line
                this.gVals = new Uint8Array(256);
                // eslint-disable-next-line
                this.bVals = new Uint8Array(256);
            }
            // This is an optimization - pre-compute a look-up table for each color channel
            // instead of performing these pow calls for each pixel in the image.
            for(i = 0, len = 256; i < len; i++){
                this.rVals[i] = Math.pow(i / 255, rInv) * 255;
                this.gVals[i] = Math.pow(i / 255, gInv) * 255;
                this.bVals[i] = Math.pow(i / 255, bInv) * 255;
            }
            for(i = 0, len = data.length; i < len; i += 4){
                data[i] = this.rVals[data[i]];
                data[i + 1] = this.gVals[data[i + 1]];
                data[i + 2] = this.bVals[data[i + 2]];
            }
        },
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                uGamma: gl.getUniformLocation(program, 'uGamma')
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            gl.uniform3fv(uniformLocations.uGamma, this.gamma);
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Gamma} Instance of fabric.Image.filters.Gamma
   */ fabric.Image.filters.Gamma.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {}), filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * A container class that knows how to apply a sequence of filters to an input image.
   */ filters.Composed = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Composed.prototype */ {
        type: 'Composed',
        /**
     * A non sparse array of filters to apply
     */ subFilters: [],
        /**
     * Constructor
     * @param {Object} [options] Options object
     */ initialize: function(options) {
            this.callSuper('initialize', options);
            // create a new array instead mutating the prototype with push
            this.subFilters = this.subFilters.slice(0);
        },
        /**
     * Apply this container's filters to the input image provided.
     *
     * @param {Object} options
     * @param {Number} options.passes The number of filters remaining to be applied.
     */ applyTo: function(options) {
            options.passes += this.subFilters.length - 1;
            this.subFilters.forEach(function(filter) {
                filter.applyTo(options);
            });
        },
        /**
     * Serialize this filter into JSON.
     *
     * @returns {Object} A JSON representation of this filter.
     */ toObject: function() {
            return fabric.util.object.extend(this.callSuper('toObject'), {
                subFilters: this.subFilters.map(function(filter) {
                    return filter.toObject();
                })
            });
        },
        isNeutralState: function() {
            return !this.subFilters.some(function(filter) {
                return !filter.isNeutralState();
            });
        }
    });
    /**
   * Deserialize a JSON definition of a ComposedFilter into a concrete instance.
   */ fabric.Image.filters.Composed.fromObject = function(object, callback) {
        var filters = object.subFilters || [], subFilters = filters.map(function(filter) {
            return new fabric.Image.filters[filter.type](filter);
        }), instance = new fabric.Image.filters.Composed({
            subFilters: subFilters
        });
        callback && callback(instance);
        return instance;
    };
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {}), filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * HueRotation filter class
   * @class fabric.Image.filters.HueRotation
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.HueRotation#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.HueRotation({
   *   rotation: -0.5
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */ filters.HueRotation = createClass(filters.ColorMatrix, /** @lends fabric.Image.filters.HueRotation.prototype */ {
        /**
     * Filter type
     * @param {String} type
     * @default
     */ type: 'HueRotation',
        /**
     * HueRotation value, from -1 to 1.
     * the unit is radians
     * @param {Number} myParameter
     * @default
     */ rotation: 0,
        /**
     * Describe the property that is the filter parameter
     * @param {String} m
     * @default
     */ mainParameter: 'rotation',
        calculateMatrix: function() {
            var rad = this.rotation * Math.PI, cos = fabric.util.cos(rad), sin = fabric.util.sin(rad), aThird = 1 / 3, aThirdSqtSin = Math.sqrt(aThird) * sin, OneMinusCos = 1 - cos;
            this.matrix = [
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0
            ];
            this.matrix[0] = cos + OneMinusCos / 3;
            this.matrix[1] = aThird * OneMinusCos - aThirdSqtSin;
            this.matrix[2] = aThird * OneMinusCos + aThirdSqtSin;
            this.matrix[5] = aThird * OneMinusCos + aThirdSqtSin;
            this.matrix[6] = cos + aThird * OneMinusCos;
            this.matrix[7] = aThird * OneMinusCos - aThirdSqtSin;
            this.matrix[10] = aThird * OneMinusCos - aThirdSqtSin;
            this.matrix[11] = aThird * OneMinusCos + aThirdSqtSin;
            this.matrix[12] = cos + aThird * OneMinusCos;
        },
        /**
     * HueRotation isNeutralState implementation
     * Used only in image applyFilters to discard filters that will not have an effect
     * on the image
     * @param {Object} options
     **/ isNeutralState: function(options) {
            this.calculateMatrix();
            return filters.BaseFilter.prototype.isNeutralState.call(this, options);
        },
        /**
     * Apply this filter to the input image data provided.
     *
     * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
     *
     * @param {Object} options
     * @param {Number} options.passes The number of filters remaining to be executed
     * @param {Boolean} options.webgl Whether to use webgl to render the filter.
     * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
     * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */ applyTo: function(options) {
            this.calculateMatrix();
            filters.BaseFilter.prototype.applyTo.call(this, options);
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.HueRotation} Instance of fabric.Image.filters.HueRotation
   */ fabric.Image.filters.HueRotation.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($79564f678731bf19$exports);
(function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {}), clone = fabric.util.object.clone;
    if (fabric.Text) {
        fabric.warn('fabric.Text is already defined');
        return;
    }
    var additionalProps = "fontFamily fontWeight fontSize text underline overline linethrough textAlign fontStyle lineHeight textBackgroundColor charSpacing styles direction path pathStartOffset pathSide pathAlign".split(' ');
    /**
   * Text class
   * @class fabric.Text
   * @extends fabric.Object
   * @return {fabric.Text} thisArg
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#text}
   * @see {@link fabric.Text#initialize} for constructor definition
   */ fabric.Text = fabric.util.createClass(fabric.Object, /** @lends fabric.Text.prototype */ {
        /**
     * Properties which when set cause object to change dimensions
     * @type Array
     * @private
     */ _dimensionAffectingProps: [
            'fontSize',
            'fontWeight',
            'fontFamily',
            'fontStyle',
            'lineHeight',
            'text',
            'charSpacing',
            'textAlign',
            'styles',
            'path',
            'pathStartOffset',
            'pathSide',
            'pathAlign'
        ],
        /**
     * @private
     */ _reNewline: /\r?\n/,
        /**
     * Use this regular expression to filter for whitespaces that is not a new line.
     * Mostly used when text is 'justify' aligned.
     * @private
     */ _reSpacesAndTabs: /[ \t\r]/g,
        /**
     * Use this regular expression to filter for whitespace that is not a new line.
     * Mostly used when text is 'justify' aligned.
     * @private
     */ _reSpaceAndTab: /[ \t\r]/,
        /**
     * Use this regular expression to filter consecutive groups of non spaces.
     * Mostly used when text is 'justify' aligned.
     * @private
     */ _reWords: /\S+/g,
        /**
     * Type of an object
     * @type String
     * @default
     */ type: 'text',
        /**
     * Font size (in pixels)
     * @type Number
     * @default
     */ fontSize: 40,
        /**
     * Font weight (e.g. bold, normal, 400, 600, 800)
     * @type {(Number|String)}
     * @default
     */ fontWeight: 'normal',
        /**
     * Font family
     * @type String
     * @default
     */ fontFamily: 'Times New Roman',
        /**
     * Text decoration underline.
     * @type Boolean
     * @default
     */ underline: false,
        /**
     * Text decoration overline.
     * @type Boolean
     * @default
     */ overline: false,
        /**
     * Text decoration linethrough.
     * @type Boolean
     * @default
     */ linethrough: false,
        /**
     * Text alignment. Possible values: "left", "center", "right", "justify",
     * "justify-left", "justify-center" or "justify-right".
     * @type String
     * @default
     */ textAlign: 'left',
        /**
     * Font style . Possible values: "", "normal", "italic" or "oblique".
     * @type String
     * @default
     */ fontStyle: 'normal',
        /**
     * Line height
     * @type Number
     * @default
     */ lineHeight: 1.16,
        /**
     * Superscript schema object (minimum overlap)
     * @type {Object}
     * @default
     */ superscript: {
            size: 0.60,
            baseline: -0.35 // baseline-shift factor (upwards)
        },
        /**
     * Subscript schema object (minimum overlap)
     * @type {Object}
     * @default
     */ subscript: {
            size: 0.60,
            baseline: 0.11 // baseline-shift factor (downwards)
        },
        /**
     * Background color of text lines
     * @type String
     * @default
     */ textBackgroundColor: '',
        /**
     * List of properties to consider when checking if
     * state of an object is changed ({@link fabric.Object#hasStateChanged})
     * as well as for history (undo/redo) purposes
     * @type Array
     */ stateProperties: fabric.Object.prototype.stateProperties.concat(additionalProps),
        /**
     * List of properties to consider when checking if cache needs refresh
     * @type Array
     */ cacheProperties: fabric.Object.prototype.cacheProperties.concat(additionalProps),
        /**
     * When defined, an object is rendered via stroke and this property specifies its color.
     * <b>Backwards incompatibility note:</b> This property was named "strokeStyle" until v1.1.6
     * @type String
     * @default
     */ stroke: null,
        /**
     * Shadow object representing shadow of this shape.
     * <b>Backwards incompatibility note:</b> This property was named "textShadow" (String) until v1.2.11
     * @type fabric.Shadow
     * @default
     */ shadow: null,
        /**
     * fabric.Path that the text should follow.
     * since 4.6.0 the path will be drawn automatically.
     * if you want to make the path visible, give it a stroke and strokeWidth or fill value
     * if you want it to be hidden, assign visible = false to the path.
     * This feature is in BETA, and SVG import/export is not yet supported.
     * @type fabric.Path
     * @example
     * var textPath = new fabric.Text('Text on a path', {
     *     top: 150,
     *     left: 150,
     *     textAlign: 'center',
     *     charSpacing: -50,
     *     path: new fabric.Path('M 0 0 C 50 -100 150 -100 200 0', {
     *         strokeWidth: 1,
     *         visible: false
     *     }),
     *     pathSide: 'left',
     *     pathStartOffset: 0
     * });
     * @default
     */ path: null,
        /**
     * Offset amount for text path starting position
     * Only used when text has a path
     * @type Number
     * @default
     */ pathStartOffset: 0,
        /**
     * Which side of the path the text should be drawn on.
     * Only used when text has a path
     * @type {String} 'left|right'
     * @default
     */ pathSide: 'left',
        /**
     * How text is aligned to the path. This property determines
     * the perpendicular position of each character relative to the path.
     * (one of "baseline", "center", "ascender", "descender")
     * This feature is in BETA, and its behavior may change
     * @type String
     * @default
     */ pathAlign: 'baseline',
        /**
     * @private
     */ _fontSizeFraction: 0.222,
        /**
     * @private
     */ offsets: {
            underline: 0.10,
            linethrough: -0.315,
            overline: -0.88
        },
        /**
     * Text Line proportion to font Size (in pixels)
     * @type Number
     * @default
     */ _fontSizeMult: 1.13,
        /**
     * additional space between characters
     * expressed in thousands of em unit
     * @type Number
     * @default
     */ charSpacing: 0,
        /**
     * Object containing character styles - top-level properties -> line numbers,
     * 2nd-level properties - character numbers
     * @type Object
     * @default
     */ styles: null,
        /**
     * Reference to a context to measure text char or couple of chars
     * the cacheContext of the canvas will be used or a freshly created one if the object is not on canvas
     * once created it will be referenced on fabric._measuringContext to avoid creating a canvas for every
     * text object created.
     * @type {CanvasRenderingContext2D}
     * @default
     */ _measuringContext: null,
        /**
     * Baseline shift, styles only, keep at 0 for the main text object
     * @type {Number}
     * @default
     */ deltaY: 0,
        /**
     * WARNING: EXPERIMENTAL. NOT SUPPORTED YET
     * determine the direction of the text.
     * This has to be set manually together with textAlign and originX for proper
     * experience.
     * some interesting link for the future
     * https://www.w3.org/International/questions/qa-bidi-unicode-controls
     * @since 4.5.0
     * @type {String} 'ltr|rtl'
     * @default
     */ direction: 'ltr',
        /**
     * Array of properties that define a style unit (of 'styles').
     * @type {Array}
     * @default
     */ _styleProperties: [
            'stroke',
            'strokeWidth',
            'fill',
            'fontFamily',
            'fontSize',
            'fontWeight',
            'fontStyle',
            'underline',
            'overline',
            'linethrough',
            'deltaY',
            'textBackgroundColor'
        ],
        /**
     * contains characters bounding boxes
     */ __charBounds: [],
        /**
     * use this size when measuring text. To avoid IE11 rounding errors
     * @type {Number}
     * @default
     * @readonly
     * @private
     */ CACHE_FONT_SIZE: 400,
        /**
     * contains the min text width to avoid getting 0
     * @type {Number}
     * @default
     */ MIN_TEXT_WIDTH: 2,
        /**
     * Constructor
     * @param {String} text Text string
     * @param {Object} [options] Options object
     * @return {fabric.Text} thisArg
     */ initialize: function(text, options) {
            this.styles = options ? options.styles || {} : {};
            this.text = text;
            this.__skipDimension = true;
            this.callSuper('initialize', options);
            if (this.path) this.setPathInfo();
            this.__skipDimension = false;
            this.initDimensions();
            this.setCoords();
            this.setupState({
                propertySet: '_dimensionAffectingProps'
            });
        },
        /**
     * If text has a path, it will add the extra information needed
     * for path and text calculations
     * @return {fabric.Text} thisArg
     */ setPathInfo: function() {
            var path = this.path;
            if (path) path.segmentsInfo = fabric.util.getPathSegmentsInfo(path.path);
        },
        /**
     * Return a context for measurement of text string.
     * if created it gets stored for reuse
     * this is for internal use, please do not use it
     * @private
     * @param {String} text Text string
     * @param {Object} [options] Options object
     * @return {fabric.Text} thisArg
     */ getMeasuringContext: function() {
            // if we did not return we have to measure something.
            if (!fabric._measuringContext) fabric._measuringContext = this.canvas && this.canvas.contextCache || fabric.util.createCanvasElement().getContext('2d');
            return fabric._measuringContext;
        },
        /**
     * @private
     * Divides text into lines of text and lines of graphemes.
     */ _splitText: function() {
            var newLines = this._splitTextIntoLines(this.text);
            this.textLines = newLines.lines;
            this._textLines = newLines.graphemeLines;
            this._unwrappedTextLines = newLines._unwrappedLines;
            this._text = newLines.graphemeText;
            return newLines;
        },
        /**
     * Initialize or update text dimensions.
     * Updates this.width and this.height with the proper values.
     * Does not return dimensions.
     */ initDimensions: function() {
            if (this.__skipDimension) return;
            this._splitText();
            this._clearCache();
            if (this.path) {
                // Add the space of a line around the path. This is an approximation
                var additionalWidth = this.getHeightOfLine(0) * 1.1;
                this.width = this.path.width + additionalWidth;
                this.height = this.path.height + additionalWidth;
            } else {
                this.width = this.calcTextWidth() || this.cursorWidth || this.MIN_TEXT_WIDTH;
                this.height = this.calcTextHeight();
            }
            if (this.textAlign.indexOf('justify') !== -1) // once text is measured we need to make space fatter to make justified text.
            this.enlargeSpaces();
            this.saveState({
                propertySet: '_dimensionAffectingProps'
            });
        },
        /**
     * Enlarge space boxes and shift the others
     */ enlargeSpaces: function() {
            var diffSpace, currentLineWidth, numberOfSpaces, accumulatedSpace, line, charBound, spaces;
            for(var i = 0, len = this._textLines.length; i < len; i++){
                if (this.textAlign !== 'justify' && (i === len - 1 || this.isEndOfWrapping(i))) continue;
                accumulatedSpace = 0;
                line = this._textLines[i];
                currentLineWidth = this.getLineWidth(i);
                if (currentLineWidth < this.width && (spaces = this.textLines[i].match(this._reSpacesAndTabs))) {
                    numberOfSpaces = spaces.length;
                    diffSpace = (this.width - currentLineWidth) / numberOfSpaces;
                    for(var j = 0, jlen = line.length; j <= jlen; j++){
                        charBound = this.__charBounds[i][j];
                        if (this._reSpaceAndTab.test(line[j])) {
                            charBound.width += diffSpace;
                            charBound.kernedWidth += diffSpace;
                            charBound.left += accumulatedSpace;
                            accumulatedSpace += diffSpace;
                        } else charBound.left += accumulatedSpace;
                    }
                }
            }
        },
        /**
     * Detect if the text line is ended with an hard break
     * text and itext do not have wrapping, return false
     * @return {Boolean}
     */ isEndOfWrapping: function(lineIndex) {
            return lineIndex === this._textLines.length - 1;
        },
        /**
     * Detect if a line has a linebreak and so we need to account for it when moving
     * and counting style.
     * It return always for text and Itext.
     * @return Number
     */ missingNewlineOffset: function() {
            return 1;
        },
        /**
     * Returns string representation of an instance
     * @return {String} String representation of text object
     */ toString: function() {
            return '#<fabric.Text (' + this.complexity() + '): { "text": "' + this.text + '", "fontFamily": "' + this.fontFamily + '" }>';
        },
        /**
     * Return the dimension and the zoom level needed to create a cache canvas
     * big enough to host the object to be cached.
     * @private
     * @param {Object} dim.x width of object to be cached
     * @param {Object} dim.y height of object to be cached
     * @return {Object}.width width of canvas
     * @return {Object}.height height of canvas
     * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
     * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
     */ _getCacheCanvasDimensions: function() {
            var dims = this.callSuper('_getCacheCanvasDimensions');
            var fontSize = this.fontSize;
            dims.width += fontSize * dims.zoomX;
            dims.height += fontSize * dims.zoomY;
            return dims;
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _render: function(ctx) {
            var path = this.path;
            path && !path.isNotVisible() && path._render(ctx);
            this._setTextStyles(ctx);
            this._renderTextLinesBackground(ctx);
            this._renderTextDecoration(ctx, 'underline');
            this._renderText(ctx);
            this._renderTextDecoration(ctx, 'overline');
            this._renderTextDecoration(ctx, 'linethrough');
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _renderText: function(ctx) {
            if (this.paintFirst === 'stroke') {
                this._renderTextStroke(ctx);
                this._renderTextFill(ctx);
            } else {
                this._renderTextFill(ctx);
                this._renderTextStroke(ctx);
            }
        },
        /**
     * Set the font parameter of the context with the object properties or with charStyle
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Object} [charStyle] object with font style properties
     * @param {String} [charStyle.fontFamily] Font Family
     * @param {Number} [charStyle.fontSize] Font size in pixels. ( without px suffix )
     * @param {String} [charStyle.fontWeight] Font weight
     * @param {String} [charStyle.fontStyle] Font style (italic|normal)
     */ _setTextStyles: function(ctx, charStyle, forMeasuring) {
            ctx.textBaseline = 'alphabetical';
            if (this.path) switch(this.pathAlign){
                case 'center':
                    ctx.textBaseline = 'middle';
                    break;
                case 'ascender':
                    ctx.textBaseline = 'top';
                    break;
                case 'descender':
                    ctx.textBaseline = 'bottom';
                    break;
            }
            ctx.font = this._getFontDeclaration(charStyle, forMeasuring);
        },
        /**
     * calculate and return the text Width measuring each line.
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @return {Number} Maximum width of fabric.Text object
     */ calcTextWidth: function() {
            var maxWidth = this.getLineWidth(0);
            for(var i = 1, len = this._textLines.length; i < len; i++){
                var currentLineWidth = this.getLineWidth(i);
                if (currentLineWidth > maxWidth) maxWidth = currentLineWidth;
            }
            return maxWidth;
        },
        /**
     * @private
     * @param {String} method Method name ("fillText" or "strokeText")
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {String} line Text to render
     * @param {Number} left Left position of text
     * @param {Number} top Top position of text
     * @param {Number} lineIndex Index of a line in a text
     */ _renderTextLine: function(method, ctx, line, left, top, lineIndex) {
            this._renderChars(method, ctx, line, left, top, lineIndex);
        },
        /**
     * Renders the text background for lines, taking care of style
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _renderTextLinesBackground: function(ctx) {
            if (!this.textBackgroundColor && !this.styleHas('textBackgroundColor')) return;
            var heightOfLine, lineLeftOffset, originalFill = ctx.fillStyle, line, lastColor, leftOffset = this._getLeftOffset(), lineTopOffset = this._getTopOffset(), boxStart = 0, boxWidth = 0, charBox, currentColor, path = this.path, drawStart;
            for(var i = 0, len = this._textLines.length; i < len; i++){
                heightOfLine = this.getHeightOfLine(i);
                if (!this.textBackgroundColor && !this.styleHas('textBackgroundColor', i)) {
                    lineTopOffset += heightOfLine;
                    continue;
                }
                line = this._textLines[i];
                lineLeftOffset = this._getLineLeftOffset(i);
                boxWidth = 0;
                boxStart = 0;
                lastColor = this.getValueOfPropertyAt(i, 0, 'textBackgroundColor');
                for(var j = 0, jlen = line.length; j < jlen; j++){
                    charBox = this.__charBounds[i][j];
                    currentColor = this.getValueOfPropertyAt(i, j, 'textBackgroundColor');
                    if (path) {
                        ctx.save();
                        ctx.translate(charBox.renderLeft, charBox.renderTop);
                        ctx.rotate(charBox.angle);
                        ctx.fillStyle = currentColor;
                        currentColor && ctx.fillRect(-charBox.width / 2, -heightOfLine / this.lineHeight * (1 - this._fontSizeFraction), charBox.width, heightOfLine / this.lineHeight);
                        ctx.restore();
                    } else if (currentColor !== lastColor) {
                        drawStart = leftOffset + lineLeftOffset + boxStart;
                        if (this.direction === 'rtl') drawStart = this.width - drawStart - boxWidth;
                        ctx.fillStyle = lastColor;
                        lastColor && ctx.fillRect(drawStart, lineTopOffset, boxWidth, heightOfLine / this.lineHeight);
                        boxStart = charBox.left;
                        boxWidth = charBox.width;
                        lastColor = currentColor;
                    } else boxWidth += charBox.kernedWidth;
                }
                if (currentColor && !path) {
                    drawStart = leftOffset + lineLeftOffset + boxStart;
                    if (this.direction === 'rtl') drawStart = this.width - drawStart - boxWidth;
                    ctx.fillStyle = currentColor;
                    ctx.fillRect(drawStart, lineTopOffset, boxWidth, heightOfLine / this.lineHeight);
                }
                lineTopOffset += heightOfLine;
            }
            ctx.fillStyle = originalFill;
            // if there is text background color no
            // other shadows should be casted
            this._removeShadow(ctx);
        },
        /**
     * @private
     * @param {Object} decl style declaration for cache
     * @param {String} decl.fontFamily fontFamily
     * @param {String} decl.fontStyle fontStyle
     * @param {String} decl.fontWeight fontWeight
     * @return {Object} reference to cache
     */ getFontCache: function(decl) {
            var fontFamily = decl.fontFamily.toLowerCase();
            if (!fabric.charWidthsCache[fontFamily]) fabric.charWidthsCache[fontFamily] = {};
            var cache = fabric.charWidthsCache[fontFamily], cacheProp = decl.fontStyle.toLowerCase() + '_' + (decl.fontWeight + '').toLowerCase();
            if (!cache[cacheProp]) cache[cacheProp] = {};
            return cache[cacheProp];
        },
        /**
     * measure and return the width of a single character.
     * possibly overridden to accommodate different measure logic or
     * to hook some external lib for character measurement
     * @private
     * @param {String} _char, char to be measured
     * @param {Object} charStyle style of char to be measured
     * @param {String} [previousChar] previous char
     * @param {Object} [prevCharStyle] style of previous char
     */ _measureChar: function(_char, charStyle, previousChar, prevCharStyle) {
            // first i try to return from cache
            var fontCache = this.getFontCache(charStyle), fontDeclaration = this._getFontDeclaration(charStyle), previousFontDeclaration = this._getFontDeclaration(prevCharStyle), couple = previousChar + _char, stylesAreEqual = fontDeclaration === previousFontDeclaration, width, coupleWidth, previousWidth, fontMultiplier = charStyle.fontSize / this.CACHE_FONT_SIZE, kernedWidth;
            if (previousChar && fontCache[previousChar] !== undefined) previousWidth = fontCache[previousChar];
            if (fontCache[_char] !== undefined) kernedWidth = width = fontCache[_char];
            if (stylesAreEqual && fontCache[couple] !== undefined) {
                coupleWidth = fontCache[couple];
                kernedWidth = coupleWidth - previousWidth;
            }
            if (width === undefined || previousWidth === undefined || coupleWidth === undefined) {
                var ctx = this.getMeasuringContext();
                // send a TRUE to specify measuring font size CACHE_FONT_SIZE
                this._setTextStyles(ctx, charStyle, true);
            }
            if (width === undefined) {
                kernedWidth = width = ctx.measureText(_char).width;
                fontCache[_char] = width;
            }
            if (previousWidth === undefined && stylesAreEqual && previousChar) {
                previousWidth = ctx.measureText(previousChar).width;
                fontCache[previousChar] = previousWidth;
            }
            if (stylesAreEqual && coupleWidth === undefined) {
                // we can measure the kerning couple and subtract the width of the previous character
                coupleWidth = ctx.measureText(couple).width;
                fontCache[couple] = coupleWidth;
                kernedWidth = coupleWidth - previousWidth;
            }
            return {
                width: width * fontMultiplier,
                kernedWidth: kernedWidth * fontMultiplier
            };
        },
        /**
     * Computes height of character at given position
     * @param {Number} line the line index number
     * @param {Number} _char the character index number
     * @return {Number} fontSize of the character
     */ getHeightOfChar: function(line, _char) {
            return this.getValueOfPropertyAt(line, _char, 'fontSize');
        },
        /**
     * measure a text line measuring all characters.
     * @param {Number} lineIndex line number
     * @return {Number} Line width
     */ measureLine: function(lineIndex) {
            var lineInfo = this._measureLine(lineIndex);
            if (this.charSpacing !== 0) lineInfo.width -= this._getWidthOfCharSpacing();
            if (lineInfo.width < 0) lineInfo.width = 0;
            return lineInfo;
        },
        /**
     * measure every grapheme of a line, populating __charBounds
     * @param {Number} lineIndex
     * @return {Object} object.width total width of characters
     * @return {Object} object.widthOfSpaces length of chars that match this._reSpacesAndTabs
     */ _measureLine: function(lineIndex) {
            var width = 0, i, grapheme, line = this._textLines[lineIndex], prevGrapheme, graphemeInfo, numOfSpaces = 0, lineBounds = new Array(line.length), positionInPath = 0, startingPoint, totalPathLength, path = this.path, reverse = this.pathSide === 'right';
            this.__charBounds[lineIndex] = lineBounds;
            for(i = 0; i < line.length; i++){
                grapheme = line[i];
                graphemeInfo = this._getGraphemeBox(grapheme, lineIndex, i, prevGrapheme);
                lineBounds[i] = graphemeInfo;
                width += graphemeInfo.kernedWidth;
                prevGrapheme = grapheme;
            }
            // this latest bound box represent the last character of the line
            // to simplify cursor handling in interactive mode.
            lineBounds[i] = {
                left: graphemeInfo ? graphemeInfo.left + graphemeInfo.width : 0,
                width: 0,
                kernedWidth: 0,
                height: this.fontSize
            };
            if (path) {
                totalPathLength = path.segmentsInfo[path.segmentsInfo.length - 1].length;
                startingPoint = fabric.util.getPointOnPath(path.path, 0, path.segmentsInfo);
                startingPoint.x += path.pathOffset.x;
                startingPoint.y += path.pathOffset.y;
                switch(this.textAlign){
                    case 'left':
                        positionInPath = reverse ? totalPathLength - width : 0;
                        break;
                    case 'center':
                        positionInPath = (totalPathLength - width) / 2;
                        break;
                    case 'right':
                        positionInPath = reverse ? 0 : totalPathLength - width;
                        break;
                }
                positionInPath += this.pathStartOffset * (reverse ? -1 : 1);
                for(i = reverse ? line.length - 1 : 0; reverse ? i >= 0 : i < line.length; reverse ? i-- : i++){
                    graphemeInfo = lineBounds[i];
                    if (positionInPath > totalPathLength) positionInPath %= totalPathLength;
                    else if (positionInPath < 0) positionInPath += totalPathLength;
                    // it would probably much faster to send all the grapheme position for a line
                    // and calculate path position/angle at once.
                    this._setGraphemeOnPath(positionInPath, graphemeInfo, startingPoint);
                    positionInPath += graphemeInfo.kernedWidth;
                }
            }
            return {
                width: width,
                numOfSpaces: numOfSpaces
            };
        },
        /**
     * Calculate the angle  and the left,top position of the char that follow a path.
     * It appends it to graphemeInfo to be reused later at rendering
     * @private
     * @param {Number} positionInPath to be measured
     * @param {Object} graphemeInfo current grapheme box information
     * @param {Object} startingPoint position of the point
     */ _setGraphemeOnPath: function(positionInPath, graphemeInfo, startingPoint) {
            var centerPosition = positionInPath + graphemeInfo.kernedWidth / 2, path = this.path;
            // we are at currentPositionOnPath. we want to know what point on the path is.
            var info = fabric.util.getPointOnPath(path.path, centerPosition, path.segmentsInfo);
            graphemeInfo.renderLeft = info.x - startingPoint.x;
            graphemeInfo.renderTop = info.y - startingPoint.y;
            graphemeInfo.angle = info.angle + (this.pathSide === 'right' ? Math.PI : 0);
        },
        /**
     * Measure and return the info of a single grapheme.
     * needs the the info of previous graphemes already filled
     * @private
     * @param {String} grapheme to be measured
     * @param {Number} lineIndex index of the line where the char is
     * @param {Number} charIndex position in the line
     * @param {String} [prevGrapheme] character preceding the one to be measured
     */ _getGraphemeBox: function(grapheme, lineIndex, charIndex, prevGrapheme, skipLeft) {
            var style = this.getCompleteStyleDeclaration(lineIndex, charIndex), prevStyle = prevGrapheme ? this.getCompleteStyleDeclaration(lineIndex, charIndex - 1) : {}, info = this._measureChar(grapheme, style, prevGrapheme, prevStyle), kernedWidth = info.kernedWidth, width = info.width, charSpacing;
            if (this.charSpacing !== 0) {
                charSpacing = this._getWidthOfCharSpacing();
                width += charSpacing;
                kernedWidth += charSpacing;
            }
            var box = {
                width: width,
                left: 0,
                height: style.fontSize,
                kernedWidth: kernedWidth,
                deltaY: style.deltaY
            };
            if (charIndex > 0 && !skipLeft) {
                var previousBox = this.__charBounds[lineIndex][charIndex - 1];
                box.left = previousBox.left + previousBox.width + info.kernedWidth - info.width;
            }
            return box;
        },
        /**
     * Calculate height of line at 'lineIndex'
     * @param {Number} lineIndex index of line to calculate
     * @return {Number}
     */ getHeightOfLine: function(lineIndex) {
            if (this.__lineHeights[lineIndex]) return this.__lineHeights[lineIndex];
            var line = this._textLines[lineIndex], // char 0 is measured before the line cycle because it nneds to char
            // emptylines
            maxHeight = this.getHeightOfChar(lineIndex, 0);
            for(var i = 1, len = line.length; i < len; i++)maxHeight = Math.max(this.getHeightOfChar(lineIndex, i), maxHeight);
            return this.__lineHeights[lineIndex] = maxHeight * this.lineHeight * this._fontSizeMult;
        },
        /**
     * Calculate text box height
     */ calcTextHeight: function() {
            var lineHeight, height = 0;
            for(var i = 0, len = this._textLines.length; i < len; i++){
                lineHeight = this.getHeightOfLine(i);
                height += i === len - 1 ? lineHeight / this.lineHeight : lineHeight;
            }
            return height;
        },
        /**
     * @private
     * @return {Number} Left offset
     */ _getLeftOffset: function() {
            return this.direction === 'ltr' ? -this.width / 2 : this.width / 2;
        },
        /**
     * @private
     * @return {Number} Top offset
     */ _getTopOffset: function() {
            return -this.height / 2;
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {String} method Method name ("fillText" or "strokeText")
     */ _renderTextCommon: function(ctx, method) {
            ctx.save();
            var lineHeights = 0, left = this._getLeftOffset(), top = this._getTopOffset();
            for(var i = 0, len = this._textLines.length; i < len; i++){
                var heightOfLine = this.getHeightOfLine(i), maxHeight = heightOfLine / this.lineHeight, leftOffset = this._getLineLeftOffset(i);
                this._renderTextLine(method, ctx, this._textLines[i], left + leftOffset, top + lineHeights + maxHeight, i);
                lineHeights += heightOfLine;
            }
            ctx.restore();
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _renderTextFill: function(ctx) {
            if (!this.fill && !this.styleHas('fill')) return;
            this._renderTextCommon(ctx, 'fillText');
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _renderTextStroke: function(ctx) {
            if ((!this.stroke || this.strokeWidth === 0) && this.isEmptyStyles()) return;
            if (this.shadow && !this.shadow.affectStroke) this._removeShadow(ctx);
            ctx.save();
            this._setLineDash(ctx, this.strokeDashArray);
            ctx.beginPath();
            this._renderTextCommon(ctx, 'strokeText');
            ctx.closePath();
            ctx.restore();
        },
        /**
     * @private
     * @param {String} method fillText or strokeText.
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Array} line Content of the line, splitted in an array by grapheme
     * @param {Number} left
     * @param {Number} top
     * @param {Number} lineIndex
     */ _renderChars: function(method, ctx, line, left, top, lineIndex) {
            // set proper line offset
            var lineHeight = this.getHeightOfLine(lineIndex), isJustify = this.textAlign.indexOf('justify') !== -1, actualStyle, nextStyle, charsToRender = '', charBox, boxWidth = 0, timeToRender, path = this.path, shortCut = !isJustify && this.charSpacing === 0 && this.isEmptyStyles(lineIndex) && !path, isLtr = this.direction === 'ltr', sign = this.direction === 'ltr' ? 1 : -1, drawingLeft, currentDirection = ctx.canvas.getAttribute('dir');
            ctx.save();
            if (currentDirection !== this.direction) {
                ctx.canvas.setAttribute('dir', isLtr ? 'ltr' : 'rtl');
                ctx.direction = isLtr ? 'ltr' : 'rtl';
                ctx.textAlign = isLtr ? 'left' : 'right';
            }
            top -= lineHeight * this._fontSizeFraction / this.lineHeight;
            if (shortCut) {
                // render all the line in one pass without checking
                // drawingLeft = isLtr ? left : left - this.getLineWidth(lineIndex);
                this._renderChar(method, ctx, lineIndex, 0, line.join(''), left, top, lineHeight);
                ctx.restore();
                return;
            }
            for(var i = 0, len = line.length - 1; i <= len; i++){
                timeToRender = i === len || this.charSpacing || path;
                charsToRender += line[i];
                charBox = this.__charBounds[lineIndex][i];
                if (boxWidth === 0) {
                    left += sign * (charBox.kernedWidth - charBox.width);
                    boxWidth += charBox.width;
                } else boxWidth += charBox.kernedWidth;
                if (isJustify && !timeToRender) {
                    if (this._reSpaceAndTab.test(line[i])) timeToRender = true;
                }
                if (!timeToRender) {
                    // if we have charSpacing, we render char by char
                    actualStyle = actualStyle || this.getCompleteStyleDeclaration(lineIndex, i);
                    nextStyle = this.getCompleteStyleDeclaration(lineIndex, i + 1);
                    timeToRender = fabric.util.hasStyleChanged(actualStyle, nextStyle, false);
                }
                if (timeToRender) {
                    if (path) {
                        ctx.save();
                        ctx.translate(charBox.renderLeft, charBox.renderTop);
                        ctx.rotate(charBox.angle);
                        this._renderChar(method, ctx, lineIndex, i, charsToRender, -boxWidth / 2, 0, lineHeight);
                        ctx.restore();
                    } else {
                        drawingLeft = left;
                        this._renderChar(method, ctx, lineIndex, i, charsToRender, drawingLeft, top, lineHeight);
                    }
                    charsToRender = '';
                    actualStyle = nextStyle;
                    left += sign * boxWidth;
                    boxWidth = 0;
                }
            }
            ctx.restore();
        },
        /**
     * This function try to patch the missing gradientTransform on canvas gradients.
     * transforming a context to transform the gradient, is going to transform the stroke too.
     * we want to transform the gradient but not the stroke operation, so we create
     * a transformed gradient on a pattern and then we use the pattern instead of the gradient.
     * this method has drawbacks: is slow, is in low resolution, needs a patch for when the size
     * is limited.
     * @private
     * @param {fabric.Gradient} filler a fabric gradient instance
     * @return {CanvasPattern} a pattern to use as fill/stroke style
     */ _applyPatternGradientTransformText: function(filler) {
            var pCanvas = fabric.util.createCanvasElement(), pCtx, // TODO: verify compatibility with strokeUniform
            width = this.width + this.strokeWidth, height = this.height + this.strokeWidth;
            pCanvas.width = width;
            pCanvas.height = height;
            pCtx = pCanvas.getContext('2d');
            pCtx.beginPath();
            pCtx.moveTo(0, 0);
            pCtx.lineTo(width, 0);
            pCtx.lineTo(width, height);
            pCtx.lineTo(0, height);
            pCtx.closePath();
            pCtx.translate(width / 2, height / 2);
            pCtx.fillStyle = filler.toLive(pCtx);
            this._applyPatternGradientTransform(pCtx, filler);
            pCtx.fill();
            return pCtx.createPattern(pCanvas, 'no-repeat');
        },
        handleFiller: function(ctx, property, filler) {
            var offsetX, offsetY;
            if (filler.toLive) {
                if (filler.gradientUnits === 'percentage' || filler.gradientTransform || filler.patternTransform) {
                    // need to transform gradient in a pattern.
                    // this is a slow process. If you are hitting this codepath, and the object
                    // is not using caching, you should consider switching it on.
                    // we need a canvas as big as the current object caching canvas.
                    offsetX = -this.width / 2;
                    offsetY = -this.height / 2;
                    ctx.translate(offsetX, offsetY);
                    ctx[property] = this._applyPatternGradientTransformText(filler);
                    return {
                        offsetX: offsetX,
                        offsetY: offsetY
                    };
                } else {
                    // is a simple gradient or pattern
                    ctx[property] = filler.toLive(ctx, this);
                    return this._applyPatternGradientTransform(ctx, filler);
                }
            } else // is a color
            ctx[property] = filler;
            return {
                offsetX: 0,
                offsetY: 0
            };
        },
        _setStrokeStyles: function(ctx, decl) {
            ctx.lineWidth = decl.strokeWidth;
            ctx.lineCap = this.strokeLineCap;
            ctx.lineDashOffset = this.strokeDashOffset;
            ctx.lineJoin = this.strokeLineJoin;
            ctx.miterLimit = this.strokeMiterLimit;
            return this.handleFiller(ctx, 'strokeStyle', decl.stroke);
        },
        _setFillStyles: function(ctx, decl) {
            return this.handleFiller(ctx, 'fillStyle', decl.fill);
        },
        /**
     * @private
     * @param {String} method
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @param {String} _char
     * @param {Number} left Left coordinate
     * @param {Number} top Top coordinate
     * @param {Number} lineHeight Height of the line
     */ _renderChar: function(method, ctx, lineIndex, charIndex, _char, left, top) {
            var decl = this._getStyleDeclaration(lineIndex, charIndex), fullDecl = this.getCompleteStyleDeclaration(lineIndex, charIndex), shouldFill = method === 'fillText' && fullDecl.fill, shouldStroke = method === 'strokeText' && fullDecl.stroke && fullDecl.strokeWidth, fillOffsets, strokeOffsets;
            if (!shouldStroke && !shouldFill) return;
            ctx.save();
            shouldFill && (fillOffsets = this._setFillStyles(ctx, fullDecl));
            shouldStroke && (strokeOffsets = this._setStrokeStyles(ctx, fullDecl));
            ctx.font = this._getFontDeclaration(fullDecl);
            if (decl && decl.textBackgroundColor) this._removeShadow(ctx);
            if (decl && decl.deltaY) top += decl.deltaY;
            shouldFill && ctx.fillText(_char, left - fillOffsets.offsetX, top - fillOffsets.offsetY);
            shouldStroke && ctx.strokeText(_char, left - strokeOffsets.offsetX, top - strokeOffsets.offsetY);
            ctx.restore();
        },
        /**
     * Turns the character into a 'superior figure' (i.e. 'superscript')
     * @param {Number} start selection start
     * @param {Number} end selection end
     * @returns {fabric.Text} thisArg
     * @chainable
     */ setSuperscript: function(start, end) {
            return this._setScript(start, end, this.superscript);
        },
        /**
     * Turns the character into an 'inferior figure' (i.e. 'subscript')
     * @param {Number} start selection start
     * @param {Number} end selection end
     * @returns {fabric.Text} thisArg
     * @chainable
     */ setSubscript: function(start, end) {
            return this._setScript(start, end, this.subscript);
        },
        /**
     * Applies 'schema' at given position
     * @private
     * @param {Number} start selection start
     * @param {Number} end selection end
     * @param {Number} schema
     * @returns {fabric.Text} thisArg
     * @chainable
     */ _setScript: function(start, end, schema) {
            var loc = this.get2DCursorLocation(start, true), fontSize = this.getValueOfPropertyAt(loc.lineIndex, loc.charIndex, 'fontSize'), dy = this.getValueOfPropertyAt(loc.lineIndex, loc.charIndex, 'deltaY'), style = {
                fontSize: fontSize * schema.size,
                deltaY: dy + fontSize * schema.baseline
            };
            this.setSelectionStyles(style, start, end);
            return this;
        },
        /**
     * @private
     * @param {Number} lineIndex index text line
     * @return {Number} Line left offset
     */ _getLineLeftOffset: function(lineIndex) {
            var lineWidth = this.getLineWidth(lineIndex), lineDiff = this.width - lineWidth, textAlign = this.textAlign, direction = this.direction, isEndOfWrapping, leftOffset = 0, isEndOfWrapping = this.isEndOfWrapping(lineIndex);
            if (textAlign === 'justify' || textAlign === 'justify-center' && !isEndOfWrapping || textAlign === 'justify-right' && !isEndOfWrapping || textAlign === 'justify-left' && !isEndOfWrapping) return 0;
            if (textAlign === 'center') leftOffset = lineDiff / 2;
            if (textAlign === 'right') leftOffset = lineDiff;
            if (textAlign === 'justify-center') leftOffset = lineDiff / 2;
            if (textAlign === 'justify-right') leftOffset = lineDiff;
            if (direction === 'rtl') leftOffset -= lineDiff;
            return leftOffset;
        },
        /**
     * @private
     */ _clearCache: function() {
            this.__lineWidths = [];
            this.__lineHeights = [];
            this.__charBounds = [];
        },
        /**
     * @private
     */ _shouldClearDimensionCache: function() {
            var shouldClear = this._forceClearCache;
            shouldClear || (shouldClear = this.hasStateChanged('_dimensionAffectingProps'));
            if (shouldClear) {
                this.dirty = true;
                this._forceClearCache = false;
            }
            return shouldClear;
        },
        /**
     * Measure a single line given its index. Used to calculate the initial
     * text bounding box. The values are calculated and stored in __lineWidths cache.
     * @private
     * @param {Number} lineIndex line number
     * @return {Number} Line width
     */ getLineWidth: function(lineIndex) {
            if (this.__lineWidths[lineIndex] !== undefined) return this.__lineWidths[lineIndex];
            var lineInfo = this.measureLine(lineIndex);
            var width = lineInfo.width;
            this.__lineWidths[lineIndex] = width;
            return width;
        },
        _getWidthOfCharSpacing: function() {
            if (this.charSpacing !== 0) return this.fontSize * this.charSpacing / 1000;
            return 0;
        },
        /**
     * Retrieves the value of property at given character position
     * @param {Number} lineIndex the line number
     * @param {Number} charIndex the character number
     * @param {String} property the property name
     * @returns the value of 'property'
     */ getValueOfPropertyAt: function(lineIndex, charIndex, property) {
            var charStyle = this._getStyleDeclaration(lineIndex, charIndex);
            if (charStyle && typeof charStyle[property] !== 'undefined') return charStyle[property];
            return this[property];
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _renderTextDecoration: function(ctx, type) {
            if (!this[type] && !this.styleHas(type)) return;
            ctx.save();
            // if type is overline or linethrough we shouldn't cast shadow
            if (type === 'overline' || type === 'linethrough') this._removeShadow(ctx);
            var heightOfLine, size, _size, lineLeftOffset, dy, _dy, line, lastDecoration, leftOffset = this._getLeftOffset(), topOffset = this._getTopOffset(), top, boxStart, boxWidth, charBox, currentDecoration, maxHeight, currentFill, lastFill, path = this.path, charSpacing = this._getWidthOfCharSpacing(), offsetY = this.offsets[type];
            for(var i = 0, len = this._textLines.length; i < len; i++){
                heightOfLine = this.getHeightOfLine(i);
                if (!this[type] && !this.styleHas(type, i)) {
                    topOffset += heightOfLine;
                    continue;
                }
                line = this._textLines[i];
                maxHeight = heightOfLine / this.lineHeight;
                lineLeftOffset = this._getLineLeftOffset(i);
                boxStart = 0;
                boxWidth = 0;
                lastDecoration = this.getValueOfPropertyAt(i, 0, type);
                lastFill = this.getValueOfPropertyAt(i, 0, 'fill');
                top = topOffset + maxHeight * (1 - this._fontSizeFraction);
                size = this.getHeightOfChar(i, 0);
                dy = this.getValueOfPropertyAt(i, 0, 'deltaY');
                for(var j = 0, jlen = line.length; j < jlen; j++){
                    charBox = this.__charBounds[i][j];
                    currentDecoration = this.getValueOfPropertyAt(i, j, type);
                    currentFill = this.getValueOfPropertyAt(i, j, 'fill');
                    _size = this.getHeightOfChar(i, j);
                    _dy = this.getValueOfPropertyAt(i, j, 'deltaY');
                    if (path && currentDecoration && currentFill) {
                        ctx.save();
                        ctx.fillStyle = lastFill;
                        ctx.translate(charBox.renderLeft, charBox.renderTop);
                        ctx.rotate(charBox.angle);
                        ctx.fillRect(-charBox.kernedWidth / 2, offsetY * _size + _dy, charBox.kernedWidth, this.fontSize / 15);
                        ctx.restore();
                    } else if ((currentDecoration !== lastDecoration || currentFill !== lastFill || _size !== size || _dy !== dy) && boxWidth > 0) {
                        var drawStart = leftOffset + lineLeftOffset + boxStart;
                        if (this.direction === 'rtl') drawStart = this.width - drawStart - boxWidth;
                        if (lastDecoration && lastFill) {
                            ctx.fillStyle = lastFill;
                            ctx.fillRect(drawStart, top + offsetY * size + dy, boxWidth, this.fontSize / 15);
                        }
                        boxStart = charBox.left;
                        boxWidth = charBox.width;
                        lastDecoration = currentDecoration;
                        lastFill = currentFill;
                        size = _size;
                        dy = _dy;
                    } else boxWidth += charBox.kernedWidth;
                }
                var drawStart = leftOffset + lineLeftOffset + boxStart;
                if (this.direction === 'rtl') drawStart = this.width - drawStart - boxWidth;
                ctx.fillStyle = currentFill;
                currentDecoration && currentFill && ctx.fillRect(drawStart, top + offsetY * size + dy, boxWidth - charSpacing, this.fontSize / 15);
                topOffset += heightOfLine;
            }
            ctx.restore();
        },
        /**
     * return font declaration string for canvas context
     * @param {Object} [styleObject] object
     * @returns {String} font declaration formatted for canvas context.
     */ _getFontDeclaration: function(styleObject, forMeasuring) {
            var style = styleObject || this, family = this.fontFamily, fontIsGeneric = fabric.Text.genericFonts.indexOf(family.toLowerCase()) > -1;
            var fontFamily = family === undefined || family.indexOf('\'') > -1 || family.indexOf(',') > -1 || family.indexOf('"') > -1 || fontIsGeneric ? style.fontFamily : '"' + style.fontFamily + '"';
            return [
                // node-canvas needs "weight style", while browsers need "style weight"
                // verify if this can be fixed in JSDOM
                fabric.isLikelyNode ? style.fontWeight : style.fontStyle,
                fabric.isLikelyNode ? style.fontStyle : style.fontWeight,
                forMeasuring ? this.CACHE_FONT_SIZE + 'px' : style.fontSize + 'px',
                fontFamily
            ].join(' ');
        },
        /**
     * Renders text instance on a specified context
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ render: function(ctx) {
            // do not render if object is not visible
            if (!this.visible) return;
            if (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen()) return;
            if (this._shouldClearDimensionCache()) this.initDimensions();
            this.callSuper('render', ctx);
        },
        /**
     * Returns the text as an array of lines.
     * @param {String} text text to split
     * @returns {Array} Lines in the text
     */ _splitTextIntoLines: function(text) {
            var lines = text.split(this._reNewline), newLines = new Array(lines.length), newLine = [
                '\n'
            ], newText = [];
            for(var i = 0; i < lines.length; i++){
                newLines[i] = fabric.util.string.graphemeSplit(lines[i]);
                newText = newText.concat(newLines[i], newLine);
            }
            newText.pop();
            return {
                _unwrappedLines: newLines,
                lines: lines,
                graphemeText: newText,
                graphemeLines: newLines
            };
        },
        /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of an instance
     */ toObject: function(propertiesToInclude) {
            var allProperties = additionalProps.concat(propertiesToInclude);
            var obj = this.callSuper('toObject', allProperties);
            obj.styles = fabric.util.stylesToArray(this.styles, this.text);
            if (obj.path) obj.path = this.path.toObject();
            return obj;
        },
        /**
     * Sets property to a given value. When changing position/dimension -related properties (left, top, scale, angle, etc.) `set` does not update position of object's borders/controls. If you need to update those, call `setCoords()`.
     * @param {String|Object} key Property name or object (if object, iterate over the object properties)
     * @param {Object|Function} value Property value (if function, the value is passed into it and its return value is used as a new one)
     * @return {fabric.Object} thisArg
     * @chainable
     */ set: function(key, value) {
            this.callSuper('set', key, value);
            var needsDims = false;
            var isAddingPath = false;
            if (typeof key === 'object') for(var _key in key){
                if (_key === 'path') this.setPathInfo();
                needsDims = needsDims || this._dimensionAffectingProps.indexOf(_key) !== -1;
                isAddingPath = isAddingPath || _key === 'path';
            }
            else {
                needsDims = this._dimensionAffectingProps.indexOf(key) !== -1;
                isAddingPath = key === 'path';
            }
            if (isAddingPath) this.setPathInfo();
            if (needsDims) {
                this.initDimensions();
                this.setCoords();
            }
            return this;
        },
        /**
     * Returns complexity of an instance
     * @return {Number} complexity
     */ complexity: function() {
            return 1;
        }
    });
    /* _FROM_SVG_START_ */ /**
   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Text.fromElement})
   * @static
   * @memberOf fabric.Text
   * @see: http://www.w3.org/TR/SVG/text.html#TextElement
   */ fabric.Text.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat('x y dx dy font-family font-style font-weight font-size letter-spacing text-decoration text-anchor'.split(' '));
    /**
   * Default SVG font size
   * @static
   * @memberOf fabric.Text
   */ fabric.Text.DEFAULT_SVG_FONT_SIZE = 16;
    /**
   * Returns fabric.Text instance from an SVG element (<b>not yet implemented</b>)
   * @static
   * @memberOf fabric.Text
   * @param {SVGElement} element Element to parse
   * @param {Function} callback callback function invoked after parsing
   * @param {Object} [options] Options object
   */ fabric.Text.fromElement = function(element, callback, options) {
        if (!element) return callback(null);
        var parsedAttributes = fabric.parseAttributes(element, fabric.Text.ATTRIBUTE_NAMES), parsedAnchor = parsedAttributes.textAnchor || 'left';
        options = fabric.util.object.extend(options ? clone(options) : {}, parsedAttributes);
        options.top = options.top || 0;
        options.left = options.left || 0;
        if (parsedAttributes.textDecoration) {
            var textDecoration = parsedAttributes.textDecoration;
            if (textDecoration.indexOf('underline') !== -1) options.underline = true;
            if (textDecoration.indexOf('overline') !== -1) options.overline = true;
            if (textDecoration.indexOf('line-through') !== -1) options.linethrough = true;
            delete options.textDecoration;
        }
        if ('dx' in parsedAttributes) options.left += parsedAttributes.dx;
        if ('dy' in parsedAttributes) options.top += parsedAttributes.dy;
        if (!('fontSize' in options)) options.fontSize = fabric.Text.DEFAULT_SVG_FONT_SIZE;
        var textContent = '';
        // The XML is not properly parsed in IE9 so a workaround to get
        // textContent is through firstChild.data. Another workaround would be
        // to convert XML loaded from a file to be converted using DOMParser (same way loadSVGFromString() does)
        if (!('textContent' in element)) {
            if ('firstChild' in element && element.firstChild !== null) {
                if ('data' in element.firstChild && element.firstChild.data !== null) textContent = element.firstChild.data;
            }
        } else textContent = element.textContent;
        textContent = textContent.replace(/^\s+|\s+$|\n+/g, '').replace(/\s+/g, ' ');
        var originalStrokeWidth = options.strokeWidth;
        options.strokeWidth = 0;
        var text = new fabric.Text(textContent, options), textHeightScaleFactor = text.getScaledHeight() / text.height, lineHeightDiff = (text.height + text.strokeWidth) * text.lineHeight - text.height, scaledDiff = lineHeightDiff * textHeightScaleFactor, textHeight = text.getScaledHeight() + scaledDiff, offX = 0;
        /*
      Adjust positioning:
        x/y attributes in SVG correspond to the bottom-left corner of text bounding box
        fabric output by default at top, left.
    */ if (parsedAnchor === 'center') offX = text.getScaledWidth() / 2;
        if (parsedAnchor === 'right') offX = text.getScaledWidth();
        text.set({
            left: text.left - offX,
            top: text.top - (textHeight - text.fontSize * (0.07 + text._fontSizeFraction)) / text.lineHeight,
            strokeWidth: typeof originalStrokeWidth !== 'undefined' ? originalStrokeWidth : 1
        });
        callback(text);
    };
    /* _FROM_SVG_END_ */ /**
   * Returns fabric.Text instance from an object representation
   * @static
   * @memberOf fabric.Text
   * @param {Object} object plain js Object to create an instance from
   * @param {Function} [callback] Callback to invoke when an fabric.Text instance is created
   */ fabric.Text.fromObject = function(object, callback) {
        var objectCopy = clone(object), path = object.path;
        delete objectCopy.path;
        return fabric.Object._fromObject('Text', objectCopy, function(textInstance) {
            textInstance.styles = fabric.util.stylesFromArray(object.styles, object.text);
            if (path) fabric.Object._fromObject('Path', path, function(pathInstance) {
                textInstance.set('path', pathInstance);
                callback(textInstance);
            }, 'path');
            else callback(textInstance);
        }, 'text');
    };
    fabric.Text.genericFonts = [
        'sans-serif',
        'serif',
        'cursive',
        'fantasy',
        'monospace'
    ];
    fabric.util.createAccessors && fabric.util.createAccessors(fabric.Text);
})($79564f678731bf19$exports);
(function() {
    $79564f678731bf19$var$fabric.util.object.extend($79564f678731bf19$var$fabric.Text.prototype, /** @lends fabric.Text.prototype */ {
        /**
     * Returns true if object has no styling or no styling in a line
     * @param {Number} lineIndex , lineIndex is on wrapped lines.
     * @return {Boolean}
     */ isEmptyStyles: function(lineIndex) {
            if (!this.styles) return true;
            if (typeof lineIndex !== 'undefined' && !this.styles[lineIndex]) return true;
            var obj = typeof lineIndex === 'undefined' ? this.styles : {
                line: this.styles[lineIndex]
            };
            for(var p1 in obj)for(var p2 in obj[p1]){
                // eslint-disable-next-line no-unused-vars
                for(var p3 in obj[p1][p2])return false;
            }
            return true;
        },
        /**
     * Returns true if object has a style property or has it ina specified line
     * This function is used to detect if a text will use a particular property or not.
     * @param {String} property to check for
     * @param {Number} lineIndex to check the style on
     * @return {Boolean}
     */ styleHas: function(property, lineIndex) {
            if (!this.styles || !property || property === '') return false;
            if (typeof lineIndex !== 'undefined' && !this.styles[lineIndex]) return false;
            var obj = typeof lineIndex === 'undefined' ? this.styles : {
                0: this.styles[lineIndex]
            };
            // eslint-disable-next-line
            for(var p1 in obj)// eslint-disable-next-line
            for(var p2 in obj[p1]){
                if (typeof obj[p1][p2][property] !== 'undefined') return true;
            }
            return false;
        },
        /**
     * Check if characters in a text have a value for a property
     * whose value matches the textbox's value for that property.  If so,
     * the character-level property is deleted.  If the character
     * has no other properties, then it is also deleted.  Finally,
     * if the line containing that character has no other characters
     * then it also is deleted.
     *
     * @param {string} property The property to compare between characters and text.
     */ cleanStyle: function(property) {
            if (!this.styles || !property || property === '') return false;
            var obj = this.styles, stylesCount = 0, letterCount, stylePropertyValue, allStyleObjectPropertiesMatch = true, graphemeCount = 0, styleObject;
            // eslint-disable-next-line
            for(var p1 in obj){
                letterCount = 0;
                // eslint-disable-next-line
                for(var p2 in obj[p1]){
                    var styleObject = obj[p1][p2], stylePropertyHasBeenSet = styleObject.hasOwnProperty(property);
                    stylesCount++;
                    if (stylePropertyHasBeenSet) {
                        if (!stylePropertyValue) stylePropertyValue = styleObject[property];
                        else if (styleObject[property] !== stylePropertyValue) allStyleObjectPropertiesMatch = false;
                        if (styleObject[property] === this[property]) delete styleObject[property];
                    } else allStyleObjectPropertiesMatch = false;
                    if (Object.keys(styleObject).length !== 0) letterCount++;
                    else delete obj[p1][p2];
                }
                if (letterCount === 0) delete obj[p1];
            }
            // if every grapheme has the same style set then
            // delete those styles and set it on the parent
            for(var i = 0; i < this._textLines.length; i++)graphemeCount += this._textLines[i].length;
            if (allStyleObjectPropertiesMatch && stylesCount === graphemeCount) {
                this[property] = stylePropertyValue;
                this.removeStyle(property);
            }
        },
        /**
     * Remove a style property or properties from all individual character styles
     * in a text object.  Deletes the character style object if it contains no other style
     * props.  Deletes a line style object if it contains no other character styles.
     *
     * @param {String} props The property to remove from character styles.
     */ removeStyle: function(property) {
            if (!this.styles || !property || property === '') return;
            var obj = this.styles, line, lineNum, charNum;
            for(lineNum in obj){
                line = obj[lineNum];
                for(charNum in line){
                    delete line[charNum][property];
                    if (Object.keys(line[charNum]).length === 0) delete line[charNum];
                }
                if (Object.keys(line).length === 0) delete obj[lineNum];
            }
        },
        /**
     * @private
     */ _extendStyles: function(index, styles) {
            var loc = this.get2DCursorLocation(index);
            if (!this._getLineStyle(loc.lineIndex)) this._setLineStyle(loc.lineIndex);
            if (!this._getStyleDeclaration(loc.lineIndex, loc.charIndex)) this._setStyleDeclaration(loc.lineIndex, loc.charIndex, {});
            $79564f678731bf19$var$fabric.util.object.extend(this._getStyleDeclaration(loc.lineIndex, loc.charIndex), styles);
        },
        /**
     * Returns 2d representation (lineIndex and charIndex) of cursor (or selection start)
     * @param {Number} [selectionStart] Optional index. When not given, current selectionStart is used.
     * @param {Boolean} [skipWrapping] consider the location for unwrapped lines. useful to manage styles.
     */ get2DCursorLocation: function(selectionStart, skipWrapping) {
            if (typeof selectionStart === 'undefined') selectionStart = this.selectionStart;
            var lines = skipWrapping ? this._unwrappedTextLines : this._textLines, len = lines.length;
            for(var i = 0; i < len; i++){
                if (selectionStart <= lines[i].length) return {
                    lineIndex: i,
                    charIndex: selectionStart
                };
                selectionStart -= lines[i].length + this.missingNewlineOffset(i, skipWrapping);
            }
            return {
                lineIndex: i - 1,
                charIndex: lines[i - 1].length < selectionStart ? lines[i - 1].length : selectionStart
            };
        },
        /**
     * Gets style of a current selection/cursor (at the start position)
     * if startIndex or endIndex are not provided, selectionStart or selectionEnd will be used.
     * @param {Number} [startIndex] Start index to get styles at
     * @param {Number} [endIndex] End index to get styles at, if not specified selectionEnd or startIndex + 1
     * @param {Boolean} [complete] get full style or not
     * @return {Array} styles an array with one, zero or more Style objects
     */ getSelectionStyles: function(startIndex, endIndex, complete) {
            if (typeof startIndex === 'undefined') startIndex = this.selectionStart || 0;
            if (typeof endIndex === 'undefined') endIndex = this.selectionEnd || startIndex;
            var styles = [];
            for(var i = startIndex; i < endIndex; i++)styles.push(this.getStyleAtPosition(i, complete));
            return styles;
        },
        /**
     * Gets style of a current selection/cursor position
     * @param {Number} position  to get styles at
     * @param {Boolean} [complete] full style if true
     * @return {Object} style Style object at a specified index
     * @private
     */ getStyleAtPosition: function(position, complete) {
            var loc = this.get2DCursorLocation(position), style = complete ? this.getCompleteStyleDeclaration(loc.lineIndex, loc.charIndex) : this._getStyleDeclaration(loc.lineIndex, loc.charIndex);
            return style || {};
        },
        /**
     * Sets style of a current selection, if no selection exist, do not set anything.
     * @param {Object} [styles] Styles object
     * @param {Number} [startIndex] Start index to get styles at
     * @param {Number} [endIndex] End index to get styles at, if not specified selectionEnd or startIndex + 1
     * @return {fabric.IText} thisArg
     * @chainable
     */ setSelectionStyles: function(styles, startIndex, endIndex) {
            if (typeof startIndex === 'undefined') startIndex = this.selectionStart || 0;
            if (typeof endIndex === 'undefined') endIndex = this.selectionEnd || startIndex;
            for(var i = startIndex; i < endIndex; i++)this._extendStyles(i, styles);
            /* not included in _extendStyles to avoid clearing cache more than once */ this._forceClearCache = true;
            return this;
        },
        /**
     * get the reference, not a clone, of the style object for a given character
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @return {Object} style object
     */ _getStyleDeclaration: function(lineIndex, charIndex) {
            var lineStyle = this.styles && this.styles[lineIndex];
            if (!lineStyle) return null;
            return lineStyle[charIndex];
        },
        /**
     * return a new object that contains all the style property for a character
     * the object returned is newly created
     * @param {Number} lineIndex of the line where the character is
     * @param {Number} charIndex position of the character on the line
     * @return {Object} style object
     */ getCompleteStyleDeclaration: function(lineIndex, charIndex) {
            var style = this._getStyleDeclaration(lineIndex, charIndex) || {}, styleObject = {}, prop;
            for(var i = 0; i < this._styleProperties.length; i++){
                prop = this._styleProperties[i];
                styleObject[prop] = typeof style[prop] === 'undefined' ? this[prop] : style[prop];
            }
            return styleObject;
        },
        /**
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @param {Object} style
     * @private
     */ _setStyleDeclaration: function(lineIndex, charIndex, style) {
            this.styles[lineIndex][charIndex] = style;
        },
        /**
     *
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @private
     */ _deleteStyleDeclaration: function(lineIndex, charIndex) {
            delete this.styles[lineIndex][charIndex];
        },
        /**
     * @param {Number} lineIndex
     * @return {Boolean} if the line exists or not
     * @private
     */ _getLineStyle: function(lineIndex) {
            return !!this.styles[lineIndex];
        },
        /**
     * Set the line style to an empty object so that is initialized
     * @param {Number} lineIndex
     * @private
     */ _setLineStyle: function(lineIndex) {
            this.styles[lineIndex] = {};
        },
        /**
     * @param {Number} lineIndex
     * @private
     */ _deleteLineStyle: function(lineIndex) {
            delete this.styles[lineIndex];
        }
    });
})();
(function() {
    function parseDecoration(object) {
        if (object.textDecoration) {
            object.textDecoration.indexOf('underline') > -1 && (object.underline = true);
            object.textDecoration.indexOf('line-through') > -1 && (object.linethrough = true);
            object.textDecoration.indexOf('overline') > -1 && (object.overline = true);
            delete object.textDecoration;
        }
    }
    /**
   * IText class (introduced in <b>v1.4</b>) Events are also fired with "text:"
   * prefix when observing canvas.
   * @class fabric.IText
   * @extends fabric.Text
   * @mixes fabric.Observable
   *
   * @fires changed
   * @fires selection:changed
   * @fires editing:entered
   * @fires editing:exited
   *
   * @return {fabric.IText} thisArg
   * @see {@link fabric.IText#initialize} for constructor definition
   *
   * <p>Supported key combinations:</p>
   * <pre>
   *   Move cursor:                    left, right, up, down
   *   Select character:               shift + left, shift + right
   *   Select text vertically:         shift + up, shift + down
   *   Move cursor by word:            alt + left, alt + right
   *   Select words:                   shift + alt + left, shift + alt + right
   *   Move cursor to line start/end:  cmd + left, cmd + right or home, end
   *   Select till start/end of line:  cmd + shift + left, cmd + shift + right or shift + home, shift + end
   *   Jump to start/end of text:      cmd + up, cmd + down
   *   Select till start/end of text:  cmd + shift + up, cmd + shift + down or shift + pgUp, shift + pgDown
   *   Delete character:               backspace
   *   Delete word:                    alt + backspace
   *   Delete line:                    cmd + backspace
   *   Forward delete:                 delete
   *   Copy text:                      ctrl/cmd + c
   *   Paste text:                     ctrl/cmd + v
   *   Cut text:                       ctrl/cmd + x
   *   Select entire text:             ctrl/cmd + a
   *   Quit editing                    tab or esc
   * </pre>
   *
   * <p>Supported mouse/touch combination</p>
   * <pre>
   *   Position cursor:                click/touch
   *   Create selection:               click/touch & drag
   *   Create selection:               click & shift + click
   *   Select word:                    double click
   *   Select line:                    triple click
   * </pre>
   */ $79564f678731bf19$var$fabric.IText = $79564f678731bf19$var$fabric.util.createClass($79564f678731bf19$var$fabric.Text, $79564f678731bf19$var$fabric.Observable, /** @lends fabric.IText.prototype */ {
        /**
     * Type of an object
     * @type String
     * @default
     */ type: 'i-text',
        /**
     * Index where text selection starts (or where cursor is when there is no selection)
     * @type Number
     * @default
     */ selectionStart: 0,
        /**
     * Index where text selection ends
     * @type Number
     * @default
     */ selectionEnd: 0,
        /**
     * Color of text selection
     * @type String
     * @default
     */ selectionColor: 'rgba(17,119,255,0.3)',
        /**
     * Indicates whether text is in editing mode
     * @type Boolean
     * @default
     */ isEditing: false,
        /**
     * Indicates whether a text can be edited
     * @type Boolean
     * @default
     */ editable: true,
        /**
     * Border color of text object while it's in editing mode
     * @type String
     * @default
     */ editingBorderColor: 'rgba(102,153,255,0.25)',
        /**
     * Width of cursor (in px)
     * @type Number
     * @default
     */ cursorWidth: 2,
        /**
     * Color of text cursor color in editing mode.
     * if not set (default) will take color from the text.
     * if set to a color value that fabric can understand, it will
     * be used instead of the color of the text at the current position.
     * @type String
     * @default
     */ cursorColor: '',
        /**
     * Delay between cursor blink (in ms)
     * @type Number
     * @default
     */ cursorDelay: 1000,
        /**
     * Duration of cursor fadein (in ms)
     * @type Number
     * @default
     */ cursorDuration: 600,
        /**
     * Indicates whether internal text char widths can be cached
     * @type Boolean
     * @default
     */ caching: true,
        /**
     * DOM container to append the hiddenTextarea.
     * An alternative to attaching to the document.body.
     * Useful to reduce laggish redraw of the full document.body tree and
     * also with modals event capturing that won't let the textarea take focus.
     * @type HTMLElement
     * @default
     */ hiddenTextareaContainer: null,
        /**
     * @private
     */ _reSpace: /\s|\n/,
        /**
     * @private
     */ _currentCursorOpacity: 0,
        /**
     * @private
     */ _selectionDirection: null,
        /**
     * @private
     */ _abortCursorAnimation: false,
        /**
     * @private
     */ __widthOfSpace: [],
        /**
     * Helps determining when the text is in composition, so that the cursor
     * rendering is altered.
     */ inCompositionMode: false,
        /**
     * Constructor
     * @param {String} text Text string
     * @param {Object} [options] Options object
     * @return {fabric.IText} thisArg
     */ initialize: function(text, options) {
            this.callSuper('initialize', text, options);
            this.initBehavior();
        },
        /**
     * Sets selection start (left boundary of a selection)
     * @param {Number} index Index to set selection start to
     */ setSelectionStart: function(index) {
            index = Math.max(index, 0);
            this._updateAndFire('selectionStart', index);
        },
        /**
     * Sets selection end (right boundary of a selection)
     * @param {Number} index Index to set selection end to
     */ setSelectionEnd: function(index) {
            index = Math.min(index, this.text.length);
            this._updateAndFire('selectionEnd', index);
        },
        /**
     * @private
     * @param {String} property 'selectionStart' or 'selectionEnd'
     * @param {Number} index new position of property
     */ _updateAndFire: function(property, index) {
            if (this[property] !== index) {
                this._fireSelectionChanged();
                this[property] = index;
            }
            this._updateTextarea();
        },
        /**
     * Fires the even of selection changed
     * @private
     */ _fireSelectionChanged: function() {
            this.fire('selection:changed');
            this.canvas && this.canvas.fire('text:selection:changed', {
                target: this
            });
        },
        /**
     * Initialize text dimensions. Render all text on given context
     * or on a offscreen canvas to get the text width with measureText.
     * Updates this.width and this.height with the proper values.
     * Does not return dimensions.
     * @private
     */ initDimensions: function() {
            this.isEditing && this.initDelayedCursor();
            this.clearContextTop();
            this.callSuper('initDimensions');
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ render: function(ctx) {
            this.clearContextTop();
            this.callSuper('render', ctx);
            // clear the cursorOffsetCache, so we ensure to calculate once per renderCursor
            // the correct position but not at every cursor animation.
            this.cursorOffsetCache = {};
            this.renderCursorOrSelection();
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _render: function(ctx) {
            this.callSuper('_render', ctx);
        },
        /**
     * Prepare and clean the contextTop
     */ clearContextTop: function(skipRestore) {
            if (!this.isEditing || !this.canvas || !this.canvas.contextTop) return;
            var ctx = this.canvas.contextTop, v = this.canvas.viewportTransform;
            ctx.save();
            ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
            this.transform(ctx);
            this._clearTextArea(ctx);
            skipRestore || ctx.restore();
        },
        /**
     * Renders cursor or selection (depending on what exists)
     * it does on the contextTop. If contextTop is not available, do nothing.
     */ renderCursorOrSelection: function() {
            if (!this.isEditing || !this.canvas || !this.canvas.contextTop) return;
            var boundaries = this._getCursorBoundaries(), ctx = this.canvas.contextTop;
            this.clearContextTop(true);
            if (this.selectionStart === this.selectionEnd) this.renderCursor(boundaries, ctx);
            else this.renderSelection(boundaries, ctx);
            ctx.restore();
        },
        _clearTextArea: function(ctx) {
            // we add 4 pixel, to be sure to do not leave any pixel out
            var width = this.width + 4, height = this.height + 4;
            ctx.clearRect(-width / 2, -height / 2, width, height);
        },
        /**
     * Returns cursor boundaries (left, top, leftOffset, topOffset)
     * @private
     * @param {Array} chars Array of characters
     * @param {String} typeOfBoundaries
     */ _getCursorBoundaries: function(position) {
            // left/top are left/top of entire text box
            // leftOffset/topOffset are offset from that left/top point of a text box
            if (typeof position === 'undefined') position = this.selectionStart;
            var left = this._getLeftOffset(), top = this._getTopOffset(), offsets = this._getCursorBoundariesOffsets(position);
            return {
                left: left,
                top: top,
                leftOffset: offsets.left,
                topOffset: offsets.top
            };
        },
        /**
     * @private
     */ _getCursorBoundariesOffsets: function(position) {
            if (this.cursorOffsetCache && 'top' in this.cursorOffsetCache) return this.cursorOffsetCache;
            var lineLeftOffset, lineIndex, charIndex, topOffset = 0, leftOffset = 0, boundaries, cursorPosition = this.get2DCursorLocation(position);
            charIndex = cursorPosition.charIndex;
            lineIndex = cursorPosition.lineIndex;
            for(var i = 0; i < lineIndex; i++)topOffset += this.getHeightOfLine(i);
            lineLeftOffset = this._getLineLeftOffset(lineIndex);
            var bound = this.__charBounds[lineIndex][charIndex];
            bound && (leftOffset = bound.left);
            if (this.charSpacing !== 0 && charIndex === this._textLines[lineIndex].length) leftOffset -= this._getWidthOfCharSpacing();
            boundaries = {
                top: topOffset,
                left: lineLeftOffset + (leftOffset > 0 ? leftOffset : 0)
            };
            if (this.direction === 'rtl') boundaries.left *= -1;
            this.cursorOffsetCache = boundaries;
            return this.cursorOffsetCache;
        },
        /**
     * Renders cursor
     * @param {Object} boundaries
     * @param {CanvasRenderingContext2D} ctx transformed context to draw on
     */ renderCursor: function(boundaries, ctx) {
            var cursorLocation = this.get2DCursorLocation(), lineIndex = cursorLocation.lineIndex, charIndex = cursorLocation.charIndex > 0 ? cursorLocation.charIndex - 1 : 0, charHeight = this.getValueOfPropertyAt(lineIndex, charIndex, 'fontSize'), multiplier = this.scaleX * this.canvas.getZoom(), cursorWidth = this.cursorWidth / multiplier, topOffset = boundaries.topOffset, dy = this.getValueOfPropertyAt(lineIndex, charIndex, 'deltaY');
            topOffset += (1 - this._fontSizeFraction) * this.getHeightOfLine(lineIndex) / this.lineHeight - charHeight * (1 - this._fontSizeFraction);
            if (this.inCompositionMode) this.renderSelection(boundaries, ctx);
            ctx.fillStyle = this.cursorColor || this.getValueOfPropertyAt(lineIndex, charIndex, 'fill');
            ctx.globalAlpha = this.__isMousedown ? 1 : this._currentCursorOpacity;
            ctx.fillRect(boundaries.left + boundaries.leftOffset - cursorWidth / 2, topOffset + boundaries.top + dy, cursorWidth, charHeight);
        },
        /**
     * Renders text selection
     * @param {Object} boundaries Object with left/top/leftOffset/topOffset
     * @param {CanvasRenderingContext2D} ctx transformed context to draw on
     */ renderSelection: function(boundaries, ctx) {
            var selectionStart = this.inCompositionMode ? this.hiddenTextarea.selectionStart : this.selectionStart, selectionEnd = this.inCompositionMode ? this.hiddenTextarea.selectionEnd : this.selectionEnd, isJustify = this.textAlign.indexOf('justify') !== -1, start = this.get2DCursorLocation(selectionStart), end = this.get2DCursorLocation(selectionEnd), startLine = start.lineIndex, endLine = end.lineIndex, startChar = start.charIndex < 0 ? 0 : start.charIndex, endChar = end.charIndex < 0 ? 0 : end.charIndex;
            for(var i = startLine; i <= endLine; i++){
                var lineOffset = this._getLineLeftOffset(i) || 0, lineHeight = this.getHeightOfLine(i), realLineHeight = 0, boxStart = 0, boxEnd = 0;
                if (i === startLine) boxStart = this.__charBounds[startLine][startChar].left;
                if (i >= startLine && i < endLine) boxEnd = isJustify && !this.isEndOfWrapping(i) ? this.width : this.getLineWidth(i) || 5; // WTF is this 5?
                else if (i === endLine) {
                    if (endChar === 0) boxEnd = this.__charBounds[endLine][endChar].left;
                    else {
                        var charSpacing = this._getWidthOfCharSpacing();
                        boxEnd = this.__charBounds[endLine][endChar - 1].left + this.__charBounds[endLine][endChar - 1].width - charSpacing;
                    }
                }
                realLineHeight = lineHeight;
                if (this.lineHeight < 1 || i === endLine && this.lineHeight > 1) lineHeight /= this.lineHeight;
                var drawStart = boundaries.left + lineOffset + boxStart, drawWidth = boxEnd - boxStart, drawHeight = lineHeight, extraTop = 0;
                if (this.inCompositionMode) {
                    ctx.fillStyle = this.compositionColor || 'black';
                    drawHeight = 1;
                    extraTop = lineHeight;
                } else ctx.fillStyle = this.selectionColor;
                if (this.direction === 'rtl') drawStart = this.width - drawStart - drawWidth;
                ctx.fillRect(drawStart, boundaries.top + boundaries.topOffset + extraTop, drawWidth, drawHeight);
                boundaries.topOffset += realLineHeight;
            }
        },
        /**
     * High level function to know the height of the cursor.
     * the currentChar is the one that precedes the cursor
     * Returns fontSize of char at the current cursor
     * Unused from the library, is for the end user
     * @return {Number} Character font size
     */ getCurrentCharFontSize: function() {
            var cp = this._getCurrentCharIndex();
            return this.getValueOfPropertyAt(cp.l, cp.c, 'fontSize');
        },
        /**
     * High level function to know the color of the cursor.
     * the currentChar is the one that precedes the cursor
     * Returns color (fill) of char at the current cursor
     * if the text object has a pattern or gradient for filler, it will return that.
     * Unused by the library, is for the end user
     * @return {String | fabric.Gradient | fabric.Pattern} Character color (fill)
     */ getCurrentCharColor: function() {
            var cp = this._getCurrentCharIndex();
            return this.getValueOfPropertyAt(cp.l, cp.c, 'fill');
        },
        /**
     * Returns the cursor position for the getCurrent.. functions
     * @private
     */ _getCurrentCharIndex: function() {
            var cursorPosition = this.get2DCursorLocation(this.selectionStart, true), charIndex = cursorPosition.charIndex > 0 ? cursorPosition.charIndex - 1 : 0;
            return {
                l: cursorPosition.lineIndex,
                c: charIndex
            };
        }
    });
    /**
   * Returns fabric.IText instance from an object representation
   * @static
   * @memberOf fabric.IText
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] invoked with new instance as argument
   */ $79564f678731bf19$var$fabric.IText.fromObject = function(object, callback) {
        var styles = $79564f678731bf19$var$fabric.util.stylesFromArray(object.styles, object.text);
        //copy object to prevent mutation
        var objCopy = Object.assign({}, object, {
            styles: styles
        });
        delete objCopy.path;
        parseDecoration(objCopy);
        if (objCopy.styles) {
            for(var i in objCopy.styles)for(var j in objCopy.styles[i])parseDecoration(objCopy.styles[i][j]);
        }
        $79564f678731bf19$var$fabric.Object._fromObject('IText', objCopy, function(textInstance) {
            if (object.path) $79564f678731bf19$var$fabric.Object._fromObject('Path', object.path, function(pathInstance) {
                textInstance.set('path', pathInstance);
                callback(textInstance);
            }, 'path');
            else callback(textInstance);
        }, 'text');
    };
})();
(function() {
    var clone = $79564f678731bf19$var$fabric.util.object.clone;
    $79564f678731bf19$var$fabric.util.object.extend($79564f678731bf19$var$fabric.IText.prototype, /** @lends fabric.IText.prototype */ {
        /**
     * Initializes all the interactive behavior of IText
     */ initBehavior: function() {
            this.initAddedHandler();
            this.initRemovedHandler();
            this.initCursorSelectionHandlers();
            this.initDoubleClickSimulation();
            this.mouseMoveHandler = this.mouseMoveHandler.bind(this);
        },
        onDeselect: function() {
            this.isEditing && this.exitEditing();
            this.selected = false;
        },
        /**
     * Initializes "added" event handler
     */ initAddedHandler: function() {
            var _this = this;
            this.on('added', function() {
                var canvas = _this.canvas;
                if (canvas) {
                    if (!canvas._hasITextHandlers) {
                        canvas._hasITextHandlers = true;
                        _this._initCanvasHandlers(canvas);
                    }
                    canvas._iTextInstances = canvas._iTextInstances || [];
                    canvas._iTextInstances.push(_this);
                }
            });
        },
        initRemovedHandler: function() {
            var _this = this;
            this.on('removed', function() {
                var canvas = _this.canvas;
                if (canvas) {
                    canvas._iTextInstances = canvas._iTextInstances || [];
                    $79564f678731bf19$var$fabric.util.removeFromArray(canvas._iTextInstances, _this);
                    if (canvas._iTextInstances.length === 0) {
                        canvas._hasITextHandlers = false;
                        _this._removeCanvasHandlers(canvas);
                    }
                }
            });
        },
        /**
     * register canvas event to manage exiting on other instances
     * @private
     */ _initCanvasHandlers: function(canvas) {
            canvas._mouseUpITextHandler = function() {
                if (canvas._iTextInstances) canvas._iTextInstances.forEach(function(obj) {
                    obj.__isMousedown = false;
                });
            };
            canvas.on('mouse:up', canvas._mouseUpITextHandler);
        },
        /**
     * remove canvas event to manage exiting on other instances
     * @private
     */ _removeCanvasHandlers: function(canvas) {
            canvas.off('mouse:up', canvas._mouseUpITextHandler);
        },
        /**
     * @private
     */ _tick: function() {
            this._currentTickState = this._animateCursor(this, 1, this.cursorDuration, '_onTickComplete');
        },
        /**
     * @private
     */ _animateCursor: function(obj, targetOpacity, duration, completeMethod) {
            var tickState;
            tickState = {
                isAborted: false,
                abort: function() {
                    this.isAborted = true;
                }
            };
            obj.animate('_currentCursorOpacity', targetOpacity, {
                duration: duration,
                onComplete: function() {
                    if (!tickState.isAborted) obj[completeMethod]();
                },
                onChange: function() {
                    // we do not want to animate a selection, only cursor
                    if (obj.canvas && obj.selectionStart === obj.selectionEnd) obj.renderCursorOrSelection();
                },
                abort: function() {
                    return tickState.isAborted;
                }
            });
            return tickState;
        },
        /**
     * @private
     */ _onTickComplete: function() {
            var _this = this;
            if (this._cursorTimeout1) clearTimeout(this._cursorTimeout1);
            this._cursorTimeout1 = setTimeout(function() {
                _this._currentTickCompleteState = _this._animateCursor(_this, 0, this.cursorDuration / 2, '_tick');
            }, 100);
        },
        /**
     * Initializes delayed cursor
     */ initDelayedCursor: function(restart) {
            var _this = this, delay = restart ? 0 : this.cursorDelay;
            this.abortCursorAnimation();
            this._currentCursorOpacity = 1;
            this._cursorTimeout2 = setTimeout(function() {
                _this._tick();
            }, delay);
        },
        /**
     * Aborts cursor animation and clears all timeouts
     */ abortCursorAnimation: function() {
            var shouldClear = this._currentTickState || this._currentTickCompleteState, canvas = this.canvas;
            this._currentTickState && this._currentTickState.abort();
            this._currentTickCompleteState && this._currentTickCompleteState.abort();
            clearTimeout(this._cursorTimeout1);
            clearTimeout(this._cursorTimeout2);
            this._currentCursorOpacity = 0;
            // to clear just itext area we need to transform the context
            // it may not be worth it
            if (shouldClear && canvas) canvas.clearContext(canvas.contextTop || canvas.contextContainer);
        },
        /**
     * Selects entire text
     * @return {fabric.IText} thisArg
     * @chainable
     */ selectAll: function() {
            this.selectionStart = 0;
            this.selectionEnd = this._text.length;
            this._fireSelectionChanged();
            this._updateTextarea();
            return this;
        },
        /**
     * Returns selected text
     * @return {String}
     */ getSelectedText: function() {
            return this._text.slice(this.selectionStart, this.selectionEnd).join('');
        },
        /**
     * Find new selection index representing start of current word according to current selection index
     * @param {Number} startFrom Current selection index
     * @return {Number} New selection index
     */ findWordBoundaryLeft: function(startFrom) {
            var offset = 0, index = startFrom - 1;
            // remove space before cursor first
            if (this._reSpace.test(this._text[index])) while(this._reSpace.test(this._text[index])){
                offset++;
                index--;
            }
            while(/\S/.test(this._text[index]) && index > -1){
                offset++;
                index--;
            }
            return startFrom - offset;
        },
        /**
     * Find new selection index representing end of current word according to current selection index
     * @param {Number} startFrom Current selection index
     * @return {Number} New selection index
     */ findWordBoundaryRight: function(startFrom) {
            var offset = 0, index = startFrom;
            // remove space after cursor first
            if (this._reSpace.test(this._text[index])) while(this._reSpace.test(this._text[index])){
                offset++;
                index++;
            }
            while(/\S/.test(this._text[index]) && index < this._text.length){
                offset++;
                index++;
            }
            return startFrom + offset;
        },
        /**
     * Find new selection index representing start of current line according to current selection index
     * @param {Number} startFrom Current selection index
     * @return {Number} New selection index
     */ findLineBoundaryLeft: function(startFrom) {
            var offset = 0, index = startFrom - 1;
            while(!/\n/.test(this._text[index]) && index > -1){
                offset++;
                index--;
            }
            return startFrom - offset;
        },
        /**
     * Find new selection index representing end of current line according to current selection index
     * @param {Number} startFrom Current selection index
     * @return {Number} New selection index
     */ findLineBoundaryRight: function(startFrom) {
            var offset = 0, index = startFrom;
            while(!/\n/.test(this._text[index]) && index < this._text.length){
                offset++;
                index++;
            }
            return startFrom + offset;
        },
        /**
     * Finds index corresponding to beginning or end of a word
     * @param {Number} selectionStart Index of a character
     * @param {Number} direction 1 or -1
     * @return {Number} Index of the beginning or end of a word
     */ searchWordBoundary: function(selectionStart, direction) {
            var text = this._text, index = this._reSpace.test(text[selectionStart]) ? selectionStart - 1 : selectionStart, _char = text[index], // wrong
            reNonWord = $79564f678731bf19$var$fabric.reNonWord;
            while(!reNonWord.test(_char) && index > 0 && index < text.length){
                index += direction;
                _char = text[index];
            }
            if (reNonWord.test(_char)) index += direction === 1 ? 0 : 1;
            return index;
        },
        /**
     * Selects a word based on the index
     * @param {Number} selectionStart Index of a character
     */ selectWord: function(selectionStart) {
            selectionStart = selectionStart || this.selectionStart;
            var newSelectionStart = this.searchWordBoundary(selectionStart, -1), /* search backwards */ newSelectionEnd = this.searchWordBoundary(selectionStart, 1); /* search forward */ 
            this.selectionStart = newSelectionStart;
            this.selectionEnd = newSelectionEnd;
            this._fireSelectionChanged();
            this._updateTextarea();
            this.renderCursorOrSelection();
        },
        /**
     * Selects a line based on the index
     * @param {Number} selectionStart Index of a character
     * @return {fabric.IText} thisArg
     * @chainable
     */ selectLine: function(selectionStart) {
            selectionStart = selectionStart || this.selectionStart;
            var newSelectionStart = this.findLineBoundaryLeft(selectionStart), newSelectionEnd = this.findLineBoundaryRight(selectionStart);
            this.selectionStart = newSelectionStart;
            this.selectionEnd = newSelectionEnd;
            this._fireSelectionChanged();
            this._updateTextarea();
            return this;
        },
        /**
     * Enters editing state
     * @return {fabric.IText} thisArg
     * @chainable
     */ enterEditing: function(e) {
            if (this.isEditing || !this.editable) return;
            if (this.canvas) {
                this.canvas.calcOffset();
                this.exitEditingOnOthers(this.canvas);
            }
            this.isEditing = true;
            this.initHiddenTextarea(e);
            this.hiddenTextarea.focus();
            this.hiddenTextarea.value = this.text;
            this._updateTextarea();
            this._saveEditingProps();
            this._setEditingProps();
            this._textBeforeEdit = this.text;
            this._tick();
            this.fire('editing:entered');
            this._fireSelectionChanged();
            if (!this.canvas) return this;
            this.canvas.fire('text:editing:entered', {
                target: this
            });
            this.initMouseMoveHandler();
            this.canvas.requestRenderAll();
            return this;
        },
        exitEditingOnOthers: function(canvas) {
            if (canvas._iTextInstances) canvas._iTextInstances.forEach(function(obj) {
                obj.selected = false;
                if (obj.isEditing) obj.exitEditing();
            });
        },
        /**
     * Initializes "mousemove" event handler
     */ initMouseMoveHandler: function() {
            this.canvas.on('mouse:move', this.mouseMoveHandler);
        },
        /**
     * @private
     */ mouseMoveHandler: function(options) {
            if (!this.__isMousedown || !this.isEditing) return;
            // regain focus
            document.activeElement !== this.hiddenTextarea && this.hiddenTextarea.focus();
            var newSelectionStart = this.getSelectionStartFromPointer(options.e), currentStart = this.selectionStart, currentEnd = this.selectionEnd;
            if ((newSelectionStart !== this.__selectionStartOnMouseDown || currentStart === currentEnd) && (currentStart === newSelectionStart || currentEnd === newSelectionStart)) return;
            if (newSelectionStart > this.__selectionStartOnMouseDown) {
                this.selectionStart = this.__selectionStartOnMouseDown;
                this.selectionEnd = newSelectionStart;
            } else {
                this.selectionStart = newSelectionStart;
                this.selectionEnd = this.__selectionStartOnMouseDown;
            }
            if (this.selectionStart !== currentStart || this.selectionEnd !== currentEnd) {
                this.restartCursorIfNeeded();
                this._fireSelectionChanged();
                this._updateTextarea();
                this.renderCursorOrSelection();
            }
        },
        /**
     * @private
     */ _setEditingProps: function() {
            this.hoverCursor = 'text';
            if (this.canvas) this.canvas.defaultCursor = this.canvas.moveCursor = 'text';
            this.borderColor = this.editingBorderColor;
            this.hasControls = this.selectable = false;
            this.lockMovementX = this.lockMovementY = true;
        },
        /**
     * convert from textarea to grapheme indexes
     */ fromStringToGraphemeSelection: function(start, end, text) {
            var smallerTextStart = text.slice(0, start), graphemeStart = $79564f678731bf19$var$fabric.util.string.graphemeSplit(smallerTextStart).length;
            if (start === end) return {
                selectionStart: graphemeStart,
                selectionEnd: graphemeStart
            };
            var smallerTextEnd = text.slice(start, end), graphemeEnd = $79564f678731bf19$var$fabric.util.string.graphemeSplit(smallerTextEnd).length;
            return {
                selectionStart: graphemeStart,
                selectionEnd: graphemeStart + graphemeEnd
            };
        },
        /**
     * convert from fabric to textarea values
     */ fromGraphemeToStringSelection: function(start, end, _text) {
            var smallerTextStart = _text.slice(0, start), graphemeStart = smallerTextStart.join('').length;
            if (start === end) return {
                selectionStart: graphemeStart,
                selectionEnd: graphemeStart
            };
            var smallerTextEnd = _text.slice(start, end), graphemeEnd = smallerTextEnd.join('').length;
            return {
                selectionStart: graphemeStart,
                selectionEnd: graphemeStart + graphemeEnd
            };
        },
        /**
     * @private
     */ _updateTextarea: function() {
            this.cursorOffsetCache = {};
            if (!this.hiddenTextarea) return;
            if (!this.inCompositionMode) {
                var newSelection = this.fromGraphemeToStringSelection(this.selectionStart, this.selectionEnd, this._text);
                this.hiddenTextarea.selectionStart = newSelection.selectionStart;
                this.hiddenTextarea.selectionEnd = newSelection.selectionEnd;
            }
            this.updateTextareaPosition();
        },
        /**
     * @private
     */ updateFromTextArea: function() {
            if (!this.hiddenTextarea) return;
            this.cursorOffsetCache = {};
            this.text = this.hiddenTextarea.value;
            if (this._shouldClearDimensionCache()) {
                this.initDimensions();
                this.setCoords();
            }
            var newSelection = this.fromStringToGraphemeSelection(this.hiddenTextarea.selectionStart, this.hiddenTextarea.selectionEnd, this.hiddenTextarea.value);
            this.selectionEnd = this.selectionStart = newSelection.selectionEnd;
            if (!this.inCompositionMode) this.selectionStart = newSelection.selectionStart;
            this.updateTextareaPosition();
        },
        /**
     * @private
     */ updateTextareaPosition: function() {
            if (this.selectionStart === this.selectionEnd) {
                var style = this._calcTextareaPosition();
                this.hiddenTextarea.style.left = style.left;
                this.hiddenTextarea.style.top = style.top;
            }
        },
        /**
     * @private
     * @return {Object} style contains style for hiddenTextarea
     */ _calcTextareaPosition: function() {
            if (!this.canvas) return {
                x: 1,
                y: 1
            };
            var desiredPosition = this.inCompositionMode ? this.compositionStart : this.selectionStart, boundaries = this._getCursorBoundaries(desiredPosition), cursorLocation = this.get2DCursorLocation(desiredPosition), lineIndex = cursorLocation.lineIndex, charIndex = cursorLocation.charIndex, charHeight = this.getValueOfPropertyAt(lineIndex, charIndex, 'fontSize') * this.lineHeight, leftOffset = boundaries.leftOffset, m = this.calcTransformMatrix(), p = {
                x: boundaries.left + leftOffset,
                y: boundaries.top + boundaries.topOffset + charHeight
            }, retinaScaling = this.canvas.getRetinaScaling(), upperCanvas = this.canvas.upperCanvasEl, upperCanvasWidth = upperCanvas.width / retinaScaling, upperCanvasHeight = upperCanvas.height / retinaScaling, maxWidth = upperCanvasWidth - charHeight, maxHeight = upperCanvasHeight - charHeight, scaleX = upperCanvas.clientWidth / upperCanvasWidth, scaleY = upperCanvas.clientHeight / upperCanvasHeight;
            p = $79564f678731bf19$var$fabric.util.transformPoint(p, m);
            p = $79564f678731bf19$var$fabric.util.transformPoint(p, this.canvas.viewportTransform);
            p.x *= scaleX;
            p.y *= scaleY;
            if (p.x < 0) p.x = 0;
            if (p.x > maxWidth) p.x = maxWidth;
            if (p.y < 0) p.y = 0;
            if (p.y > maxHeight) p.y = maxHeight;
            // add canvas offset on document
            p.x += this.canvas._offset.left;
            p.y += this.canvas._offset.top;
            return {
                left: p.x + 'px',
                top: p.y + 'px',
                fontSize: charHeight + 'px',
                charHeight: charHeight
            };
        },
        /**
     * @private
     */ _saveEditingProps: function() {
            this._savedProps = {
                hasControls: this.hasControls,
                borderColor: this.borderColor,
                lockMovementX: this.lockMovementX,
                lockMovementY: this.lockMovementY,
                hoverCursor: this.hoverCursor,
                selectable: this.selectable,
                defaultCursor: this.canvas && this.canvas.defaultCursor,
                moveCursor: this.canvas && this.canvas.moveCursor
            };
        },
        /**
     * @private
     */ _restoreEditingProps: function() {
            if (!this._savedProps) return;
            this.hoverCursor = this._savedProps.hoverCursor;
            this.hasControls = this._savedProps.hasControls;
            this.borderColor = this._savedProps.borderColor;
            this.selectable = this._savedProps.selectable;
            this.lockMovementX = this._savedProps.lockMovementX;
            this.lockMovementY = this._savedProps.lockMovementY;
            if (this.canvas) {
                this.canvas.defaultCursor = this._savedProps.defaultCursor;
                this.canvas.moveCursor = this._savedProps.moveCursor;
            }
        },
        /**
     * Exits from editing state
     * @return {fabric.IText} thisArg
     * @chainable
     */ exitEditing: function() {
            var isTextChanged = this._textBeforeEdit !== this.text;
            var hiddenTextarea = this.hiddenTextarea;
            this.selected = false;
            this.isEditing = false;
            this.selectionEnd = this.selectionStart;
            if (hiddenTextarea) {
                hiddenTextarea.blur && hiddenTextarea.blur();
                hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
            }
            this.hiddenTextarea = null;
            this.abortCursorAnimation();
            this._restoreEditingProps();
            this._currentCursorOpacity = 0;
            if (this._shouldClearDimensionCache()) {
                this.initDimensions();
                this.setCoords();
            }
            this.fire('editing:exited');
            isTextChanged && this.fire('modified');
            if (this.canvas) {
                this.canvas.off('mouse:move', this.mouseMoveHandler);
                this.canvas.fire('text:editing:exited', {
                    target: this
                });
                isTextChanged && this.canvas.fire('object:modified', {
                    target: this
                });
            }
            return this;
        },
        /**
     * @private
     */ _removeExtraneousStyles: function() {
            for(var prop in this.styles)if (!this._textLines[prop]) delete this.styles[prop];
        },
        /**
     * remove and reflow a style block from start to end.
     * @param {Number} start linear start position for removal (included in removal)
     * @param {Number} end linear end position for removal ( excluded from removal )
     */ removeStyleFromTo: function(start, end) {
            var cursorStart = this.get2DCursorLocation(start, true), cursorEnd = this.get2DCursorLocation(end, true), lineStart = cursorStart.lineIndex, charStart = cursorStart.charIndex, lineEnd = cursorEnd.lineIndex, charEnd = cursorEnd.charIndex, i, styleObj;
            if (lineStart !== lineEnd) {
                // step1 remove the trailing of lineStart
                if (this.styles[lineStart]) for(i = charStart; i < this._unwrappedTextLines[lineStart].length; i++)delete this.styles[lineStart][i];
                // step2 move the trailing of lineEnd to lineStart if needed
                if (this.styles[lineEnd]) for(i = charEnd; i < this._unwrappedTextLines[lineEnd].length; i++){
                    styleObj = this.styles[lineEnd][i];
                    if (styleObj) {
                        this.styles[lineStart] || (this.styles[lineStart] = {});
                        this.styles[lineStart][charStart + i - charEnd] = styleObj;
                    }
                }
                // step3 detects lines will be completely removed.
                for(i = lineStart + 1; i <= lineEnd; i++)delete this.styles[i];
                // step4 shift remaining lines.
                this.shiftLineStyles(lineEnd, lineStart - lineEnd);
            } else // remove and shift left on the same line
            if (this.styles[lineStart]) {
                styleObj = this.styles[lineStart];
                var diff = charEnd - charStart, numericChar, _char;
                for(i = charStart; i < charEnd; i++)delete styleObj[i];
                for(_char in this.styles[lineStart]){
                    numericChar = parseInt(_char, 10);
                    if (numericChar >= charEnd) {
                        styleObj[numericChar - diff] = styleObj[_char];
                        delete styleObj[_char];
                    }
                }
            }
        },
        /**
     * Shifts line styles up or down
     * @param {Number} lineIndex Index of a line
     * @param {Number} offset Can any number?
     */ shiftLineStyles: function(lineIndex, offset) {
            // shift all line styles by offset upward or downward
            // do not clone deep. we need new array, not new style objects
            var clonedStyles = clone(this.styles);
            for(var line in this.styles){
                var numericLine = parseInt(line, 10);
                if (numericLine > lineIndex) {
                    this.styles[numericLine + offset] = clonedStyles[numericLine];
                    if (!clonedStyles[numericLine - offset]) delete this.styles[numericLine];
                }
            }
        },
        restartCursorIfNeeded: function() {
            if (!this._currentTickState || this._currentTickState.isAborted || !this._currentTickCompleteState || this._currentTickCompleteState.isAborted) this.initDelayedCursor();
        },
        /**
     * Handle insertion of more consecutive style lines for when one or more
     * newlines gets added to the text. Since current style needs to be shifted
     * first we shift the current style of the number lines needed, then we add
     * new lines from the last to the first.
     * @param {Number} lineIndex Index of a line
     * @param {Number} charIndex Index of a char
     * @param {Number} qty number of lines to add
     * @param {Array} copiedStyle Array of objects styles
     */ insertNewlineStyleObject: function(lineIndex, charIndex, qty, copiedStyle) {
            var currentCharStyle, newLineStyles = {}, someStyleIsCarryingOver = false, originalLineLength = this._unwrappedTextLines[lineIndex].length, isEndOfLine = originalLineLength === charIndex;
            qty || (qty = 1);
            this.shiftLineStyles(lineIndex, qty);
            if (this.styles[lineIndex]) currentCharStyle = this.styles[lineIndex][charIndex === 0 ? charIndex : charIndex - 1];
            // we clone styles of all chars
            // after cursor onto the current line
            for(var index in this.styles[lineIndex]){
                var numIndex = parseInt(index, 10);
                if (numIndex >= charIndex) {
                    someStyleIsCarryingOver = true;
                    newLineStyles[numIndex - charIndex] = this.styles[lineIndex][index];
                    // remove lines from the previous line since they're on a new line now
                    if (!(isEndOfLine && charIndex === 0)) delete this.styles[lineIndex][index];
                }
            }
            var styleCarriedOver = false;
            if (someStyleIsCarryingOver && !isEndOfLine) {
                // if is end of line, the extra style we copied
                // is probably not something we want
                this.styles[lineIndex + qty] = newLineStyles;
                styleCarriedOver = true;
            }
            if (styleCarriedOver || originalLineLength > charIndex) // skip the last line of since we already prepared it
            // or contains text without style that we don't want to style
            // just because it changed lines
            qty--;
            // for the all the lines or all the other lines
            // we clone current char style onto the next (otherwise empty) line
            while(qty > 0){
                if (copiedStyle && copiedStyle[qty - 1]) this.styles[lineIndex + qty] = {
                    0: clone(copiedStyle[qty - 1])
                };
                else if (currentCharStyle) this.styles[lineIndex + qty] = {
                    0: clone(currentCharStyle)
                };
                else delete this.styles[lineIndex + qty];
                qty--;
            }
            this._forceClearCache = true;
        },
        /**
     * Inserts style object for a given line/char index
     * @param {Number} lineIndex Index of a line
     * @param {Number} charIndex Index of a char
     * @param {Number} quantity number Style object to insert, if given
     * @param {Array} copiedStyle array of style objects
     */ insertCharStyleObject: function(lineIndex, charIndex, quantity, copiedStyle) {
            if (!this.styles) this.styles = {};
            var currentLineStyles = this.styles[lineIndex], currentLineStylesCloned = currentLineStyles ? clone(currentLineStyles) : {};
            quantity || (quantity = 1);
            // shift all char styles by quantity forward
            // 0,1,2,3 -> (charIndex=2) -> 0,1,3,4 -> (insert 2) -> 0,1,2,3,4
            for(var index in currentLineStylesCloned){
                var numericIndex = parseInt(index, 10);
                if (numericIndex >= charIndex) {
                    currentLineStyles[numericIndex + quantity] = currentLineStylesCloned[numericIndex];
                    // only delete the style if there was nothing moved there
                    if (!currentLineStylesCloned[numericIndex - quantity]) delete currentLineStyles[numericIndex];
                }
            }
            this._forceClearCache = true;
            if (copiedStyle) {
                while(quantity--){
                    if (!Object.keys(copiedStyle[quantity]).length) continue;
                    if (!this.styles[lineIndex]) this.styles[lineIndex] = {};
                    this.styles[lineIndex][charIndex + quantity] = clone(copiedStyle[quantity]);
                }
                return;
            }
            if (!currentLineStyles) return;
            var newStyle = currentLineStyles[charIndex ? charIndex - 1 : 1];
            while(newStyle && quantity--)this.styles[lineIndex][charIndex + quantity] = clone(newStyle);
        },
        /**
     * Inserts style object(s)
     * @param {Array} insertedText Characters at the location where style is inserted
     * @param {Number} start cursor index for inserting style
     * @param {Array} [copiedStyle] array of style objects to insert.
     */ insertNewStyleBlock: function(insertedText, start, copiedStyle) {
            var cursorLoc = this.get2DCursorLocation(start, true), addedLines = [
                0
            ], linesLength = 0;
            // get an array of how many char per lines are being added.
            for(var i = 0; i < insertedText.length; i++)if (insertedText[i] === '\n') {
                linesLength++;
                addedLines[linesLength] = 0;
            } else addedLines[linesLength]++;
            // for the first line copy the style from the current char position.
            if (addedLines[0] > 0) {
                this.insertCharStyleObject(cursorLoc.lineIndex, cursorLoc.charIndex, addedLines[0], copiedStyle);
                copiedStyle = copiedStyle && copiedStyle.slice(addedLines[0] + 1);
            }
            linesLength && this.insertNewlineStyleObject(cursorLoc.lineIndex, cursorLoc.charIndex + addedLines[0], linesLength);
            for(var i = 1; i < linesLength; i++){
                if (addedLines[i] > 0) this.insertCharStyleObject(cursorLoc.lineIndex + i, 0, addedLines[i], copiedStyle);
                else if (copiedStyle) // this test is required in order to close #6841
                // when a pasted buffer begins with a newline then
                // this.styles[cursorLoc.lineIndex + i] and copiedStyle[0]
                // may be undefined for some reason
                {
                    if (this.styles[cursorLoc.lineIndex + i] && copiedStyle[0]) this.styles[cursorLoc.lineIndex + i][0] = copiedStyle[0];
                }
                copiedStyle = copiedStyle && copiedStyle.slice(addedLines[i] + 1);
            }
            // we use i outside the loop to get it like linesLength
            if (addedLines[i] > 0) this.insertCharStyleObject(cursorLoc.lineIndex + i, 0, addedLines[i], copiedStyle);
        },
        /**
     * Set the selectionStart and selectionEnd according to the new position of cursor
     * mimic the key - mouse navigation when shift is pressed.
     */ setSelectionStartEndWithShift: function(start, end, newSelection) {
            if (newSelection <= start) {
                if (end === start) this._selectionDirection = 'left';
                else if (this._selectionDirection === 'right') {
                    this._selectionDirection = 'left';
                    this.selectionEnd = start;
                }
                this.selectionStart = newSelection;
            } else if (newSelection > start && newSelection < end) {
                if (this._selectionDirection === 'right') this.selectionEnd = newSelection;
                else this.selectionStart = newSelection;
            } else {
                // newSelection is > selection start and end
                if (end === start) this._selectionDirection = 'right';
                else if (this._selectionDirection === 'left') {
                    this._selectionDirection = 'right';
                    this.selectionStart = end;
                }
                this.selectionEnd = newSelection;
            }
        },
        setSelectionInBoundaries: function() {
            var length = this.text.length;
            if (this.selectionStart > length) this.selectionStart = length;
            else if (this.selectionStart < 0) this.selectionStart = 0;
            if (this.selectionEnd > length) this.selectionEnd = length;
            else if (this.selectionEnd < 0) this.selectionEnd = 0;
        }
    });
})();
$79564f678731bf19$var$fabric.util.object.extend($79564f678731bf19$var$fabric.IText.prototype, /** @lends fabric.IText.prototype */ {
    /**
   * Initializes "dbclick" event handler
   */ initDoubleClickSimulation: function() {
        // for double click
        this.__lastClickTime = +new Date();
        // for triple click
        this.__lastLastClickTime = +new Date();
        this.__lastPointer = {};
        this.on('mousedown', this.onMouseDown);
    },
    /**
   * Default event handler to simulate triple click
   * @private
   */ onMouseDown: function(options) {
        if (!this.canvas) return;
        this.__newClickTime = +new Date();
        var newPointer = options.pointer;
        if (this.isTripleClick(newPointer)) {
            this.fire('tripleclick', options);
            this._stopEvent(options.e);
        }
        this.__lastLastClickTime = this.__lastClickTime;
        this.__lastClickTime = this.__newClickTime;
        this.__lastPointer = newPointer;
        this.__lastIsEditing = this.isEditing;
        this.__lastSelected = this.selected;
    },
    isTripleClick: function(newPointer) {
        return this.__newClickTime - this.__lastClickTime < 500 && this.__lastClickTime - this.__lastLastClickTime < 500 && this.__lastPointer.x === newPointer.x && this.__lastPointer.y === newPointer.y;
    },
    /**
   * @private
   */ _stopEvent: function(e) {
        e.preventDefault && e.preventDefault();
        e.stopPropagation && e.stopPropagation();
    },
    /**
   * Initializes event handlers related to cursor or selection
   */ initCursorSelectionHandlers: function() {
        this.initMousedownHandler();
        this.initMouseupHandler();
        this.initClicks();
    },
    /**
   * Default handler for double click, select a word
   */ doubleClickHandler: function(options) {
        if (!this.isEditing) return;
        this.selectWord(this.getSelectionStartFromPointer(options.e));
    },
    /**
   * Default handler for triple click, select a line
   */ tripleClickHandler: function(options) {
        if (!this.isEditing) return;
        this.selectLine(this.getSelectionStartFromPointer(options.e));
    },
    /**
   * Initializes double and triple click event handlers
   */ initClicks: function() {
        this.on('mousedblclick', this.doubleClickHandler);
        this.on('tripleclick', this.tripleClickHandler);
    },
    /**
   * Default event handler for the basic functionalities needed on _mouseDown
   * can be overridden to do something different.
   * Scope of this implementation is: find the click position, set selectionStart
   * find selectionEnd, initialize the drawing of either cursor or selection area
   * initializing a mousedDown on a text area will cancel fabricjs knowledge of
   * current compositionMode. It will be set to false.
   */ _mouseDownHandler: function(options) {
        if (!this.canvas || !this.editable || options.e.button && options.e.button !== 1) return;
        this.__isMousedown = true;
        if (this.selected) {
            this.inCompositionMode = false;
            this.setCursorByClick(options.e);
        }
        if (this.isEditing) {
            this.__selectionStartOnMouseDown = this.selectionStart;
            if (this.selectionStart === this.selectionEnd) this.abortCursorAnimation();
            this.renderCursorOrSelection();
        }
    },
    /**
   * Default event handler for the basic functionalities needed on mousedown:before
   * can be overridden to do something different.
   * Scope of this implementation is: verify the object is already selected when mousing down
   */ _mouseDownHandlerBefore: function(options) {
        if (!this.canvas || !this.editable || options.e.button && options.e.button !== 1) return;
        // we want to avoid that an object that was selected and then becomes unselectable,
        // may trigger editing mode in some way.
        this.selected = this === this.canvas._activeObject;
    },
    /**
   * Initializes "mousedown" event handler
   */ initMousedownHandler: function() {
        this.on('mousedown', this._mouseDownHandler);
        this.on('mousedown:before', this._mouseDownHandlerBefore);
    },
    /**
   * Initializes "mouseup" event handler
   */ initMouseupHandler: function() {
        this.on('mouseup', this.mouseUpHandler);
    },
    /**
   * standard handler for mouse up, overridable
   * @private
   */ mouseUpHandler: function(options) {
        this.__isMousedown = false;
        if (!this.editable || this.group || options.transform && options.transform.actionPerformed || options.e.button && options.e.button !== 1) return;
        if (this.canvas) {
            var currentActive = this.canvas._activeObject;
            if (currentActive && currentActive !== this) // avoid running this logic when there is an active object
            // this because is possible with shift click and fast clicks,
            // to rapidly deselect and reselect this object and trigger an enterEdit
            return;
        }
        if (this.__lastSelected && !this.__corner) {
            this.selected = false;
            this.__lastSelected = false;
            this.enterEditing(options.e);
            if (this.selectionStart === this.selectionEnd) this.initDelayedCursor(true);
            else this.renderCursorOrSelection();
        } else this.selected = true;
    },
    /**
   * Changes cursor location in a text depending on passed pointer (x/y) object
   * @param {Event} e Event object
   */ setCursorByClick: function(e) {
        var newSelection = this.getSelectionStartFromPointer(e), start = this.selectionStart, end = this.selectionEnd;
        if (e.shiftKey) this.setSelectionStartEndWithShift(start, end, newSelection);
        else {
            this.selectionStart = newSelection;
            this.selectionEnd = newSelection;
        }
        if (this.isEditing) {
            this._fireSelectionChanged();
            this._updateTextarea();
        }
    },
    /**
   * Returns index of a character corresponding to where an object was clicked
   * @param {Event} e Event object
   * @return {Number} Index of a character
   */ getSelectionStartFromPointer: function(e) {
        var mouseOffset = this.getLocalPointer(e), prevWidth = 0, width = 0, height = 0, charIndex = 0, lineIndex = 0, lineLeftOffset, line;
        for(var i = 0, len = this._textLines.length; i < len; i++){
            if (height <= mouseOffset.y) {
                height += this.getHeightOfLine(i) * this.scaleY;
                lineIndex = i;
                if (i > 0) charIndex += this._textLines[i - 1].length + this.missingNewlineOffset(i - 1);
            } else break;
        }
        lineLeftOffset = this._getLineLeftOffset(lineIndex);
        width = lineLeftOffset * this.scaleX;
        line = this._textLines[lineIndex];
        // handling of RTL: in order to get things work correctly,
        // we assume RTL writing is mirrored compared to LTR writing.
        // so in position detection we mirror the X offset, and when is time
        // of rendering it, we mirror it again.
        if (this.direction === 'rtl') mouseOffset.x = this.width * this.scaleX - mouseOffset.x + width;
        for(var j = 0, jlen = line.length; j < jlen; j++){
            prevWidth = width;
            // i removed something about flipX here, check.
            width += this.__charBounds[lineIndex][j].kernedWidth * this.scaleX;
            if (width <= mouseOffset.x) charIndex++;
            else break;
        }
        return this._getNewSelectionStartFromOffset(mouseOffset, prevWidth, width, charIndex, jlen);
    },
    /**
   * @private
   */ _getNewSelectionStartFromOffset: function(mouseOffset, prevWidth, width, index, jlen) {
        // we need Math.abs because when width is after the last char, the offset is given as 1, while is 0
        var distanceBtwLastCharAndCursor = mouseOffset.x - prevWidth, distanceBtwNextCharAndCursor = width - mouseOffset.x, offset = distanceBtwNextCharAndCursor > distanceBtwLastCharAndCursor || distanceBtwNextCharAndCursor < 0 ? 0 : 1, newSelectionStart = index + offset;
        // if object is horizontally flipped, mirror cursor location from the end
        if (this.flipX) newSelectionStart = jlen - newSelectionStart;
        if (newSelectionStart > this._text.length) newSelectionStart = this._text.length;
        return newSelectionStart;
    }
});
$79564f678731bf19$var$fabric.util.object.extend($79564f678731bf19$var$fabric.IText.prototype, /** @lends fabric.IText.prototype */ {
    /**
   * Initializes hidden textarea (needed to bring up keyboard in iOS)
   */ initHiddenTextarea: function() {
        this.hiddenTextarea = $79564f678731bf19$var$fabric.document.createElement('textarea');
        this.hiddenTextarea.setAttribute('autocapitalize', 'off');
        this.hiddenTextarea.setAttribute('autocorrect', 'off');
        this.hiddenTextarea.setAttribute('autocomplete', 'off');
        this.hiddenTextarea.setAttribute('spellcheck', 'false');
        this.hiddenTextarea.setAttribute('data-fabric-hiddentextarea', '');
        this.hiddenTextarea.setAttribute('wrap', 'off');
        var style = this._calcTextareaPosition();
        // line-height: 1px; was removed from the style to fix this:
        // https://bugs.chromium.org/p/chromium/issues/detail?id=870966
        this.hiddenTextarea.style.cssText = 'position: absolute; top: ' + style.top + '; left: ' + style.left + '; z-index: -999; opacity: 0; width: 1px; height: 1px; font-size: 1px;' + ' padding-top: ' + style.fontSize + ';';
        if (this.hiddenTextareaContainer) this.hiddenTextareaContainer.appendChild(this.hiddenTextarea);
        else $79564f678731bf19$var$fabric.document.body.appendChild(this.hiddenTextarea);
        $79564f678731bf19$var$fabric.util.addListener(this.hiddenTextarea, 'keydown', this.onKeyDown.bind(this));
        $79564f678731bf19$var$fabric.util.addListener(this.hiddenTextarea, 'keyup', this.onKeyUp.bind(this));
        $79564f678731bf19$var$fabric.util.addListener(this.hiddenTextarea, 'input', this.onInput.bind(this));
        $79564f678731bf19$var$fabric.util.addListener(this.hiddenTextarea, 'copy', this.copy.bind(this));
        $79564f678731bf19$var$fabric.util.addListener(this.hiddenTextarea, 'cut', this.copy.bind(this));
        $79564f678731bf19$var$fabric.util.addListener(this.hiddenTextarea, 'paste', this.paste.bind(this));
        $79564f678731bf19$var$fabric.util.addListener(this.hiddenTextarea, 'compositionstart', this.onCompositionStart.bind(this));
        $79564f678731bf19$var$fabric.util.addListener(this.hiddenTextarea, 'compositionupdate', this.onCompositionUpdate.bind(this));
        $79564f678731bf19$var$fabric.util.addListener(this.hiddenTextarea, 'compositionend', this.onCompositionEnd.bind(this));
        if (!this._clickHandlerInitialized && this.canvas) {
            $79564f678731bf19$var$fabric.util.addListener(this.canvas.upperCanvasEl, 'click', this.onClick.bind(this));
            this._clickHandlerInitialized = true;
        }
    },
    /**
   * For functionalities on keyDown
   * Map a special key to a function of the instance/prototype
   * If you need different behaviour for ESC or TAB or arrows, you have to change
   * this map setting the name of a function that you build on the fabric.Itext or
   * your prototype.
   * the map change will affect all Instances unless you need for only some text Instances
   * in that case you have to clone this object and assign your Instance.
   * this.keysMap = fabric.util.object.clone(this.keysMap);
   * The function must be in fabric.Itext.prototype.myFunction And will receive event as args[0]
   */ keysMap: {
        9: 'exitEditing',
        27: 'exitEditing',
        33: 'moveCursorUp',
        34: 'moveCursorDown',
        35: 'moveCursorRight',
        36: 'moveCursorLeft',
        37: 'moveCursorLeft',
        38: 'moveCursorUp',
        39: 'moveCursorRight',
        40: 'moveCursorDown'
    },
    keysMapRtl: {
        9: 'exitEditing',
        27: 'exitEditing',
        33: 'moveCursorUp',
        34: 'moveCursorDown',
        35: 'moveCursorLeft',
        36: 'moveCursorRight',
        37: 'moveCursorRight',
        38: 'moveCursorUp',
        39: 'moveCursorLeft',
        40: 'moveCursorDown'
    },
    /**
   * For functionalities on keyUp + ctrl || cmd
   */ ctrlKeysMapUp: {
        67: 'copy',
        88: 'cut'
    },
    /**
   * For functionalities on keyDown + ctrl || cmd
   */ ctrlKeysMapDown: {
        65: 'selectAll'
    },
    onClick: function() {
        // No need to trigger click event here, focus is enough to have the keyboard appear on Android
        this.hiddenTextarea && this.hiddenTextarea.focus();
    },
    /**
   * Handles keydown event
   * only used for arrows and combination of modifier keys.
   * @param {Event} e Event object
   */ onKeyDown: function(e) {
        if (!this.isEditing) return;
        var keyMap = this.direction === 'rtl' ? this.keysMapRtl : this.keysMap;
        if (e.keyCode in keyMap) this[keyMap[e.keyCode]](e);
        else if (e.keyCode in this.ctrlKeysMapDown && (e.ctrlKey || e.metaKey)) this[this.ctrlKeysMapDown[e.keyCode]](e);
        else return;
        e.stopImmediatePropagation();
        e.preventDefault();
        if (e.keyCode >= 33 && e.keyCode <= 40) {
            // if i press an arrow key just update selection
            this.inCompositionMode = false;
            this.clearContextTop();
            this.renderCursorOrSelection();
        } else this.canvas && this.canvas.requestRenderAll();
    },
    /**
   * Handles keyup event
   * We handle KeyUp because ie11 and edge have difficulties copy/pasting
   * if a copy/cut event fired, keyup is dismissed
   * @param {Event} e Event object
   */ onKeyUp: function(e) {
        if (!this.isEditing || this._copyDone || this.inCompositionMode) {
            this._copyDone = false;
            return;
        }
        if (e.keyCode in this.ctrlKeysMapUp && (e.ctrlKey || e.metaKey)) this[this.ctrlKeysMapUp[e.keyCode]](e);
        else return;
        e.stopImmediatePropagation();
        e.preventDefault();
        this.canvas && this.canvas.requestRenderAll();
    },
    /**
   * Handles onInput event
   * @param {Event} e Event object
   */ onInput: function(e) {
        var fromPaste = this.fromPaste;
        this.fromPaste = false;
        e && e.stopPropagation();
        if (!this.isEditing) return;
        // decisions about style changes.
        var nextText = this._splitTextIntoLines(this.hiddenTextarea.value).graphemeText, charCount = this._text.length, nextCharCount = nextText.length, removedText, insertedText, charDiff = nextCharCount - charCount, selectionStart = this.selectionStart, selectionEnd = this.selectionEnd, selection = selectionStart !== selectionEnd, copiedStyle, removeFrom, removeTo;
        if (this.hiddenTextarea.value === '') {
            this.styles = {};
            this.updateFromTextArea();
            this.fire('changed');
            if (this.canvas) {
                this.canvas.fire('text:changed', {
                    target: this
                });
                this.canvas.requestRenderAll();
            }
            return;
        }
        var textareaSelection = this.fromStringToGraphemeSelection(this.hiddenTextarea.selectionStart, this.hiddenTextarea.selectionEnd, this.hiddenTextarea.value);
        var backDelete = selectionStart > textareaSelection.selectionStart;
        if (selection) {
            removedText = this._text.slice(selectionStart, selectionEnd);
            charDiff += selectionEnd - selectionStart;
        } else if (nextCharCount < charCount) {
            if (backDelete) removedText = this._text.slice(selectionEnd + charDiff, selectionEnd);
            else removedText = this._text.slice(selectionStart, selectionStart - charDiff);
        }
        insertedText = nextText.slice(textareaSelection.selectionEnd - charDiff, textareaSelection.selectionEnd);
        if (removedText && removedText.length) {
            if (insertedText.length) {
                // let's copy some style before deleting.
                // we want to copy the style before the cursor OR the style at the cursor if selection
                // is bigger than 0.
                copiedStyle = this.getSelectionStyles(selectionStart, selectionStart + 1, false);
                // now duplicate the style one for each inserted text.
                copiedStyle = insertedText.map(function() {
                    // this return an array of references, but that is fine since we are
                    // copying the style later.
                    return copiedStyle[0];
                });
            }
            if (selection) {
                removeFrom = selectionStart;
                removeTo = selectionEnd;
            } else if (backDelete) {
                // detect differences between forwardDelete and backDelete
                removeFrom = selectionEnd - removedText.length;
                removeTo = selectionEnd;
            } else {
                removeFrom = selectionEnd;
                removeTo = selectionEnd + removedText.length;
            }
            this.removeStyleFromTo(removeFrom, removeTo);
        }
        if (insertedText.length) {
            if (fromPaste && insertedText.join('') === $79564f678731bf19$var$fabric.copiedText && !$79564f678731bf19$var$fabric.disableStyleCopyPaste) copiedStyle = $79564f678731bf19$var$fabric.copiedTextStyle;
            this.insertNewStyleBlock(insertedText, selectionStart, copiedStyle);
        }
        this.updateFromTextArea();
        this.fire('changed');
        if (this.canvas) {
            this.canvas.fire('text:changed', {
                target: this
            });
            this.canvas.requestRenderAll();
        }
    },
    /**
   * Composition start
   */ onCompositionStart: function() {
        this.inCompositionMode = true;
    },
    /**
   * Composition end
   */ onCompositionEnd: function() {
        this.inCompositionMode = false;
    },
    // /**
    //  * Composition update
    //  */
    onCompositionUpdate: function(e) {
        this.compositionStart = e.target.selectionStart;
        this.compositionEnd = e.target.selectionEnd;
        this.updateTextareaPosition();
    },
    /**
   * Copies selected text
   * @param {Event} e Event object
   */ copy: function() {
        if (this.selectionStart === this.selectionEnd) //do not cut-copy if no selection
        return;
        $79564f678731bf19$var$fabric.copiedText = this.getSelectedText();
        if (!$79564f678731bf19$var$fabric.disableStyleCopyPaste) $79564f678731bf19$var$fabric.copiedTextStyle = this.getSelectionStyles(this.selectionStart, this.selectionEnd, true);
        else $79564f678731bf19$var$fabric.copiedTextStyle = null;
        this._copyDone = true;
    },
    /**
   * Pastes text
   * @param {Event} e Event object
   */ paste: function() {
        this.fromPaste = true;
    },
    /**
   * @private
   * @param {Event} e Event object
   * @return {Object} Clipboard data object
   */ _getClipboardData: function(e) {
        return e && e.clipboardData || $79564f678731bf19$var$fabric.window.clipboardData;
    },
    /**
   * Finds the width in pixels before the cursor on the same line
   * @private
   * @param {Number} lineIndex
   * @param {Number} charIndex
   * @return {Number} widthBeforeCursor width before cursor
   */ _getWidthBeforeCursor: function(lineIndex, charIndex) {
        var widthBeforeCursor = this._getLineLeftOffset(lineIndex), bound;
        if (charIndex > 0) {
            bound = this.__charBounds[lineIndex][charIndex - 1];
            widthBeforeCursor += bound.left + bound.width;
        }
        return widthBeforeCursor;
    },
    /**
   * Gets start offset of a selection
   * @param {Event} e Event object
   * @param {Boolean} isRight
   * @return {Number}
   */ getDownCursorOffset: function(e, isRight) {
        var selectionProp = this._getSelectionForOffset(e, isRight), cursorLocation = this.get2DCursorLocation(selectionProp), lineIndex = cursorLocation.lineIndex;
        // if on last line, down cursor goes to end of line
        if (lineIndex === this._textLines.length - 1 || e.metaKey || e.keyCode === 34) // move to the end of a text
        return this._text.length - selectionProp;
        var charIndex = cursorLocation.charIndex, widthBeforeCursor = this._getWidthBeforeCursor(lineIndex, charIndex), indexOnOtherLine = this._getIndexOnLine(lineIndex + 1, widthBeforeCursor), textAfterCursor = this._textLines[lineIndex].slice(charIndex);
        return textAfterCursor.length + indexOnOtherLine + 1 + this.missingNewlineOffset(lineIndex);
    },
    /**
   * private
   * Helps finding if the offset should be counted from Start or End
   * @param {Event} e Event object
   * @param {Boolean} isRight
   * @return {Number}
   */ _getSelectionForOffset: function(e, isRight) {
        if (e.shiftKey && this.selectionStart !== this.selectionEnd && isRight) return this.selectionEnd;
        else return this.selectionStart;
    },
    /**
   * @param {Event} e Event object
   * @param {Boolean} isRight
   * @return {Number}
   */ getUpCursorOffset: function(e, isRight) {
        var selectionProp = this._getSelectionForOffset(e, isRight), cursorLocation = this.get2DCursorLocation(selectionProp), lineIndex = cursorLocation.lineIndex;
        if (lineIndex === 0 || e.metaKey || e.keyCode === 33) // if on first line, up cursor goes to start of line
        return -selectionProp;
        var charIndex = cursorLocation.charIndex, widthBeforeCursor = this._getWidthBeforeCursor(lineIndex, charIndex), indexOnOtherLine = this._getIndexOnLine(lineIndex - 1, widthBeforeCursor), textBeforeCursor = this._textLines[lineIndex].slice(0, charIndex), missingNewlineOffset = this.missingNewlineOffset(lineIndex - 1);
        // return a negative offset
        return -this._textLines[lineIndex - 1].length + indexOnOtherLine - textBeforeCursor.length + (1 - missingNewlineOffset);
    },
    /**
   * for a given width it founds the matching character.
   * @private
   */ _getIndexOnLine: function(lineIndex, width) {
        var line = this._textLines[lineIndex], lineLeftOffset = this._getLineLeftOffset(lineIndex), widthOfCharsOnLine = lineLeftOffset, indexOnLine = 0, charWidth, foundMatch;
        for(var j = 0, jlen = line.length; j < jlen; j++){
            charWidth = this.__charBounds[lineIndex][j].width;
            widthOfCharsOnLine += charWidth;
            if (widthOfCharsOnLine > width) {
                foundMatch = true;
                var leftEdge = widthOfCharsOnLine - charWidth, rightEdge = widthOfCharsOnLine, offsetFromLeftEdge = Math.abs(leftEdge - width), offsetFromRightEdge = Math.abs(rightEdge - width);
                indexOnLine = offsetFromRightEdge < offsetFromLeftEdge ? j : j - 1;
                break;
            }
        }
        // reached end
        if (!foundMatch) indexOnLine = line.length - 1;
        return indexOnLine;
    },
    /**
   * Moves cursor down
   * @param {Event} e Event object
   */ moveCursorDown: function(e) {
        if (this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length) return;
        this._moveCursorUpOrDown('Down', e);
    },
    /**
   * Moves cursor up
   * @param {Event} e Event object
   */ moveCursorUp: function(e) {
        if (this.selectionStart === 0 && this.selectionEnd === 0) return;
        this._moveCursorUpOrDown('Up', e);
    },
    /**
   * Moves cursor up or down, fires the events
   * @param {String} direction 'Up' or 'Down'
   * @param {Event} e Event object
   */ _moveCursorUpOrDown: function(direction, e) {
        // getUpCursorOffset
        // getDownCursorOffset
        var action = 'get' + direction + 'CursorOffset', offset = this[action](e, this._selectionDirection === 'right');
        if (e.shiftKey) this.moveCursorWithShift(offset);
        else this.moveCursorWithoutShift(offset);
        if (offset !== 0) {
            this.setSelectionInBoundaries();
            this.abortCursorAnimation();
            this._currentCursorOpacity = 1;
            this.initDelayedCursor();
            this._fireSelectionChanged();
            this._updateTextarea();
        }
    },
    /**
   * Moves cursor with shift
   * @param {Number} offset
   */ moveCursorWithShift: function(offset) {
        var newSelection = this._selectionDirection === 'left' ? this.selectionStart + offset : this.selectionEnd + offset;
        this.setSelectionStartEndWithShift(this.selectionStart, this.selectionEnd, newSelection);
        return offset !== 0;
    },
    /**
   * Moves cursor up without shift
   * @param {Number} offset
   */ moveCursorWithoutShift: function(offset) {
        if (offset < 0) {
            this.selectionStart += offset;
            this.selectionEnd = this.selectionStart;
        } else {
            this.selectionEnd += offset;
            this.selectionStart = this.selectionEnd;
        }
        return offset !== 0;
    },
    /**
   * Moves cursor left
   * @param {Event} e Event object
   */ moveCursorLeft: function(e) {
        if (this.selectionStart === 0 && this.selectionEnd === 0) return;
        this._moveCursorLeftOrRight('Left', e);
    },
    /**
   * @private
   * @return {Boolean} true if a change happened
   */ _move: function(e, prop, direction) {
        var newValue;
        if (e.altKey) newValue = this['findWordBoundary' + direction](this[prop]);
        else if (e.metaKey || e.keyCode === 35 || e.keyCode === 36) newValue = this['findLineBoundary' + direction](this[prop]);
        else {
            this[prop] += direction === 'Left' ? -1 : 1;
            return true;
        }
        if (typeof newValue !== 'undefined' && this[prop] !== newValue) {
            this[prop] = newValue;
            return true;
        }
    },
    /**
   * @private
   */ _moveLeft: function(e, prop) {
        return this._move(e, prop, 'Left');
    },
    /**
   * @private
   */ _moveRight: function(e, prop) {
        return this._move(e, prop, 'Right');
    },
    /**
   * Moves cursor left without keeping selection
   * @param {Event} e
   */ moveCursorLeftWithoutShift: function(e) {
        var change = true;
        this._selectionDirection = 'left';
        // only move cursor when there is no selection,
        // otherwise we discard it, and leave cursor on same place
        if (this.selectionEnd === this.selectionStart && this.selectionStart !== 0) change = this._moveLeft(e, 'selectionStart');
        this.selectionEnd = this.selectionStart;
        return change;
    },
    /**
   * Moves cursor left while keeping selection
   * @param {Event} e
   */ moveCursorLeftWithShift: function(e) {
        if (this._selectionDirection === 'right' && this.selectionStart !== this.selectionEnd) return this._moveLeft(e, 'selectionEnd');
        else if (this.selectionStart !== 0) {
            this._selectionDirection = 'left';
            return this._moveLeft(e, 'selectionStart');
        }
    },
    /**
   * Moves cursor right
   * @param {Event} e Event object
   */ moveCursorRight: function(e) {
        if (this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length) return;
        this._moveCursorLeftOrRight('Right', e);
    },
    /**
   * Moves cursor right or Left, fires event
   * @param {String} direction 'Left', 'Right'
   * @param {Event} e Event object
   */ _moveCursorLeftOrRight: function(direction, e) {
        var actionName = 'moveCursor' + direction + 'With';
        this._currentCursorOpacity = 1;
        if (e.shiftKey) actionName += 'Shift';
        else actionName += 'outShift';
        if (this[actionName](e)) {
            this.abortCursorAnimation();
            this.initDelayedCursor();
            this._fireSelectionChanged();
            this._updateTextarea();
        }
    },
    /**
   * Moves cursor right while keeping selection
   * @param {Event} e
   */ moveCursorRightWithShift: function(e) {
        if (this._selectionDirection === 'left' && this.selectionStart !== this.selectionEnd) return this._moveRight(e, 'selectionStart');
        else if (this.selectionEnd !== this._text.length) {
            this._selectionDirection = 'right';
            return this._moveRight(e, 'selectionEnd');
        }
    },
    /**
   * Moves cursor right without keeping selection
   * @param {Event} e Event object
   */ moveCursorRightWithoutShift: function(e) {
        var changed = true;
        this._selectionDirection = 'right';
        if (this.selectionStart === this.selectionEnd) {
            changed = this._moveRight(e, 'selectionStart');
            this.selectionEnd = this.selectionStart;
        } else this.selectionStart = this.selectionEnd;
        return changed;
    },
    /**
   * Removes characters from start/end
   * start/end ar per grapheme position in _text array.
   *
   * @param {Number} start
   * @param {Number} end default to start + 1
   */ removeChars: function(start, end) {
        if (typeof end === 'undefined') end = start + 1;
        this.removeStyleFromTo(start, end);
        this._text.splice(start, end - start);
        this.text = this._text.join('');
        this.set('dirty', true);
        if (this._shouldClearDimensionCache()) {
            this.initDimensions();
            this.setCoords();
        }
        this._removeExtraneousStyles();
    },
    /**
   * insert characters at start position, before start position.
   * start  equal 1 it means the text get inserted between actual grapheme 0 and 1
   * if style array is provided, it must be as the same length of text in graphemes
   * if end is provided and is bigger than start, old text is replaced.
   * start/end ar per grapheme position in _text array.
   *
   * @param {String} text text to insert
   * @param {Array} style array of style objects
   * @param {Number} start
   * @param {Number} end default to start + 1
   */ insertChars: function(text, style, start, end) {
        if (typeof end === 'undefined') end = start;
        if (end > start) this.removeStyleFromTo(start, end);
        var graphemes = $79564f678731bf19$var$fabric.util.string.graphemeSplit(text);
        this.insertNewStyleBlock(graphemes, start, style);
        this._text = [].concat(this._text.slice(0, start), graphemes, this._text.slice(end));
        this.text = this._text.join('');
        this.set('dirty', true);
        if (this._shouldClearDimensionCache()) {
            this.initDimensions();
            this.setCoords();
        }
        this._removeExtraneousStyles();
    }
});
/* _TO_SVG_START_ */ (function() {
    var toFixed = $79564f678731bf19$var$fabric.util.toFixed, radiansToDegrees = $79564f678731bf19$var$fabric.util.radiansToDegrees, calcRotateMatrix = $79564f678731bf19$var$fabric.util.calcRotateMatrix, transformPoint = $79564f678731bf19$var$fabric.util.transformPoint, multipleSpacesRegex = /  +/g;
    $79564f678731bf19$var$fabric.util.object.extend($79564f678731bf19$var$fabric.Text.prototype, /** @lends fabric.Text.prototype */ {
        /**
     * Returns SVG representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */ _toSVG: function() {
            var offsets = this._getSVGLeftTopOffsets(), textAndBg = this._getSVGTextAndBg(offsets.textTop, offsets.textLeft);
            return this._wrapSVGTextAndBg(textAndBg);
        },
        /**
     * Returns svg representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */ toSVG: function(reviver) {
            var textSvg = this._createBaseSVGMarkup(this._toSVG(), {
                reviver: reviver,
                noStyle: true,
                withShadow: true
            }), path = this.path;
            if (path) return textSvg + path._createBaseSVGMarkup(path._toSVG(), {
                reviver: reviver,
                withShadow: true
            });
            return textSvg;
        },
        /**
     * @private
     */ _getSVGLeftTopOffsets: function() {
            return {
                textLeft: -this.width / 2,
                textTop: -this.height / 2,
                lineTop: this.getHeightOfLine(0)
            };
        },
        /**
     * @private
     */ _wrapSVGTextAndBg: function(textAndBg) {
            var noShadow = true, textDecoration = this.getSvgTextDecoration(this);
            return [
                textAndBg.textBgRects.join(''),
                '\t\t<text xml:space="preserve" ',
                this.fontFamily ? 'font-family="' + this.fontFamily.replace(/"/g, '\'') + '" ' : '',
                this.fontSize ? 'font-size="' + this.fontSize + '" ' : '',
                this.fontStyle ? 'font-style="' + this.fontStyle + '" ' : '',
                this.fontWeight ? 'font-weight="' + this.fontWeight + '" ' : '',
                textDecoration ? 'text-decoration="' + textDecoration + '" ' : '',
                'style="',
                this.getSvgStyles(noShadow),
                '"',
                this.addPaintOrder(),
                ' >',
                textAndBg.textSpans.join(''),
                '</text>\n'
            ];
        },
        /**
     * @private
     * @param {Number} textTopOffset Text top offset
     * @param {Number} textLeftOffset Text left offset
     * @return {Object}
     */ _getSVGTextAndBg: function(textTopOffset, textLeftOffset) {
            var textSpans = [], textBgRects = [], height = textTopOffset, lineOffset;
            // bounding-box background
            this._setSVGBg(textBgRects);
            // text and text-background
            for(var i = 0, len = this._textLines.length; i < len; i++){
                lineOffset = this._getLineLeftOffset(i);
                if (this.textBackgroundColor || this.styleHas('textBackgroundColor', i)) this._setSVGTextLineBg(textBgRects, i, textLeftOffset + lineOffset, height);
                this._setSVGTextLineText(textSpans, i, textLeftOffset + lineOffset, height);
                height += this.getHeightOfLine(i);
            }
            return {
                textSpans: textSpans,
                textBgRects: textBgRects
            };
        },
        /**
     * @private
     */ _createTextCharSpan: function(_char, styleDecl, left, top, charBox) {
            var shouldUseWhitespace = _char !== _char.trim() || _char.match(multipleSpacesRegex), styleProps = this.getSvgSpanStyles(styleDecl, shouldUseWhitespace), fillStyles = styleProps ? 'style="' + styleProps + '"' : '', dy = styleDecl.deltaY, dySpan = '', NUM_FRACTION_DIGITS = $79564f678731bf19$var$fabric.Object.NUM_FRACTION_DIGITS, angleAttr = '';
            if (dy) dySpan = ' dy="' + toFixed(dy, NUM_FRACTION_DIGITS) + '" ';
            if (charBox.renderLeft !== undefined) {
                var angle = charBox.angle;
                angleAttr = ' rotate="' + toFixed(radiansToDegrees(angle), $79564f678731bf19$var$fabric.Object.NUM_FRACTION_DIGITS) + '" ';
                var wBy2 = charBox.width / 2, m = calcRotateMatrix({
                    angle: radiansToDegrees(angle)
                });
                m[4] = charBox.renderLeft;
                m[5] = charBox.renderTop;
                var renderPoint = transformPoint({
                    x: -wBy2,
                    y: 0
                }, m);
                left = renderPoint.x;
                top = renderPoint.y;
            }
            return [
                '<tspan x="',
                toFixed(left, NUM_FRACTION_DIGITS),
                '" y="',
                toFixed(top, NUM_FRACTION_DIGITS),
                '" ',
                dySpan,
                fillStyles,
                angleAttr,
                '>',
                $79564f678731bf19$var$fabric.util.string.escapeXml(_char),
                '</tspan>'
            ].join('');
        },
        _setSVGTextLineText: function(textSpans, lineIndex, textLeftOffset, textTopOffset) {
            // set proper line offset
            var lineHeight = this.getHeightOfLine(lineIndex), isJustify = this.textAlign.indexOf('justify') !== -1, actualStyle, nextStyle, charsToRender = '', charBox, style, boxWidth = 0, line = this._textLines[lineIndex], timeToRender;
            textTopOffset += lineHeight * (1 - this._fontSizeFraction) / this.lineHeight;
            for(var i = 0, len = line.length - 1; i <= len; i++){
                timeToRender = i === len || this.charSpacing || this.path;
                charsToRender += line[i];
                charBox = this.__charBounds[lineIndex][i];
                if (boxWidth === 0) {
                    textLeftOffset += charBox.kernedWidth - charBox.width;
                    boxWidth += charBox.width;
                } else boxWidth += charBox.kernedWidth;
                if (isJustify && !timeToRender) {
                    if (this._reSpaceAndTab.test(line[i])) timeToRender = true;
                }
                if (!timeToRender) {
                    // if we have charSpacing, we render char by char
                    actualStyle = actualStyle || this.getCompleteStyleDeclaration(lineIndex, i);
                    nextStyle = this.getCompleteStyleDeclaration(lineIndex, i + 1);
                    timeToRender = $79564f678731bf19$var$fabric.util.hasStyleChanged(actualStyle, nextStyle, true);
                }
                if (timeToRender) {
                    style = this._getStyleDeclaration(lineIndex, i) || {};
                    textSpans.push(this._createTextCharSpan(charsToRender, style, textLeftOffset, textTopOffset, charBox));
                    charsToRender = '';
                    actualStyle = nextStyle;
                    textLeftOffset += boxWidth;
                    boxWidth = 0;
                }
            }
        },
        _pushTextBgRect: function(textBgRects, color, left, top, width, height) {
            var NUM_FRACTION_DIGITS = $79564f678731bf19$var$fabric.Object.NUM_FRACTION_DIGITS;
            textBgRects.push('\t\t<rect ', this._getFillAttributes(color), ' x="', toFixed(left, NUM_FRACTION_DIGITS), '" y="', toFixed(top, NUM_FRACTION_DIGITS), '" width="', toFixed(width, NUM_FRACTION_DIGITS), '" height="', toFixed(height, NUM_FRACTION_DIGITS), '"></rect>\n');
        },
        _setSVGTextLineBg: function(textBgRects, i, leftOffset, textTopOffset) {
            var line = this._textLines[i], heightOfLine = this.getHeightOfLine(i) / this.lineHeight, boxWidth = 0, boxStart = 0, charBox, currentColor, lastColor = this.getValueOfPropertyAt(i, 0, 'textBackgroundColor');
            for(var j = 0, jlen = line.length; j < jlen; j++){
                charBox = this.__charBounds[i][j];
                currentColor = this.getValueOfPropertyAt(i, j, 'textBackgroundColor');
                if (currentColor !== lastColor) {
                    lastColor && this._pushTextBgRect(textBgRects, lastColor, leftOffset + boxStart, textTopOffset, boxWidth, heightOfLine);
                    boxStart = charBox.left;
                    boxWidth = charBox.width;
                    lastColor = currentColor;
                } else boxWidth += charBox.kernedWidth;
            }
            currentColor && this._pushTextBgRect(textBgRects, currentColor, leftOffset + boxStart, textTopOffset, boxWidth, heightOfLine);
        },
        /**
     * Adobe Illustrator (at least CS5) is unable to render rgba()-based fill values
     * we work around it by "moving" alpha channel into opacity attribute and setting fill's alpha to 1
     *
     * @private
     * @param {*} value
     * @return {String}
     */ _getFillAttributes: function(value) {
            var fillColor = value && typeof value === 'string' ? new $79564f678731bf19$var$fabric.Color(value) : '';
            if (!fillColor || !fillColor.getSource() || fillColor.getAlpha() === 1) return 'fill="' + value + '"';
            return 'opacity="' + fillColor.getAlpha() + '" fill="' + fillColor.setAlpha(1).toRgb() + '"';
        },
        /**
     * @private
     */ _getSVGLineTopOffset: function(lineIndex) {
            var lineTopOffset = 0, lastHeight = 0;
            for(var j = 0; j < lineIndex; j++)lineTopOffset += this.getHeightOfLine(j);
            lastHeight = this.getHeightOfLine(j);
            return {
                lineTop: lineTopOffset,
                offset: (this._fontSizeMult - this._fontSizeFraction) * lastHeight / (this.lineHeight * this._fontSizeMult)
            };
        },
        /**
     * Returns styles-string for svg-export
     * @param {Boolean} skipShadow a boolean to skip shadow filter output
     * @return {String}
     */ getSvgStyles: function(skipShadow) {
            var svgStyle = $79564f678731bf19$var$fabric.Object.prototype.getSvgStyles.call(this, skipShadow);
            return svgStyle + ' white-space: pre;';
        }
    });
})();
/* _TO_SVG_END_ */ (function(global) {
    'use strict';
    var fabric = global.fabric || (global.fabric = {});
    /**
   * Textbox class, based on IText, allows the user to resize the text rectangle
   * and wraps lines automatically. Textboxes have their Y scaling locked, the
   * user can only change width. Height is adjusted automatically based on the
   * wrapping of lines.
   * @class fabric.Textbox
   * @extends fabric.IText
   * @mixes fabric.Observable
   * @return {fabric.Textbox} thisArg
   * @see {@link fabric.Textbox#initialize} for constructor definition
   */ fabric.Textbox = fabric.util.createClass(fabric.IText, fabric.Observable, {
        /**
     * Type of an object
     * @type String
     * @default
     */ type: 'textbox',
        /**
     * Minimum width of textbox, in pixels.
     * @type Number
     * @default
     */ minWidth: 20,
        /**
     * Minimum calculated width of a textbox, in pixels.
     * fixed to 2 so that an empty textbox cannot go to 0
     * and is still selectable without text.
     * @type Number
     * @default
     */ dynamicMinWidth: 2,
        /**
     * Cached array of text wrapping.
     * @type Array
     */ __cachedLines: null,
        /**
     * Override standard Object class values
     */ lockScalingFlip: true,
        /**
     * Override standard Object class values
     * Textbox needs this on false
     */ noScaleCache: false,
        /**
     * Properties which when set cause object to change dimensions
     * @type Object
     * @private
     */ _dimensionAffectingProps: fabric.Text.prototype._dimensionAffectingProps.concat('width'),
        /**
     * Use this regular expression to split strings in breakable lines
     * @private
     */ _wordJoiners: /[ \t\r]/,
        /**
     * Use this boolean property in order to split strings that have no white space concept.
     * this is a cheap way to help with chinese/japanese
     * @type Boolean
     * @since 2.6.0
     */ splitByGrapheme: false,
        /**
     * Unlike superclass's version of this function, Textbox does not update
     * its width.
     * @private
     * @override
     */ initDimensions: function() {
            if (this.__skipDimension) return;
            this.isEditing && this.initDelayedCursor();
            this.clearContextTop();
            this._clearCache();
            // clear dynamicMinWidth as it will be different after we re-wrap line
            this.dynamicMinWidth = 0;
            // wrap lines
            this._styleMap = this._generateStyleMap(this._splitText());
            // if after wrapping, the width is smaller than dynamicMinWidth, change the width and re-wrap
            if (this.dynamicMinWidth > this.width) this._set('width', this.dynamicMinWidth);
            if (this.textAlign.indexOf('justify') !== -1) // once text is measured we need to make space fatter to make justified text.
            this.enlargeSpaces();
            // clear cache and re-calculate height
            this.height = this.calcTextHeight();
            this.saveState({
                propertySet: '_dimensionAffectingProps'
            });
        },
        /**
     * Generate an object that translates the style object so that it is
     * broken up by visual lines (new lines and automatic wrapping).
     * The original text styles object is broken up by actual lines (new lines only),
     * which is only sufficient for Text / IText
     * @private
     */ _generateStyleMap: function(textInfo) {
            var realLineCount = 0, realLineCharCount = 0, charCount = 0, map = {};
            for(var i = 0; i < textInfo.graphemeLines.length; i++){
                if (textInfo.graphemeText[charCount] === '\n' && i > 0) {
                    realLineCharCount = 0;
                    charCount++;
                    realLineCount++;
                } else if (!this.splitByGrapheme && this._reSpaceAndTab.test(textInfo.graphemeText[charCount]) && i > 0) {
                    // this case deals with space's that are removed from end of lines when wrapping
                    realLineCharCount++;
                    charCount++;
                }
                map[i] = {
                    line: realLineCount,
                    offset: realLineCharCount
                };
                charCount += textInfo.graphemeLines[i].length;
                realLineCharCount += textInfo.graphemeLines[i].length;
            }
            return map;
        },
        /**
     * Returns true if object has a style property or has it on a specified line
     * @param {Number} lineIndex
     * @return {Boolean}
     */ styleHas: function(property, lineIndex) {
            if (this._styleMap && !this.isWrapping) {
                var map = this._styleMap[lineIndex];
                if (map) lineIndex = map.line;
            }
            return fabric.Text.prototype.styleHas.call(this, property, lineIndex);
        },
        /**
     * Returns true if object has no styling or no styling in a line
     * @param {Number} lineIndex , lineIndex is on wrapped lines.
     * @return {Boolean}
     */ isEmptyStyles: function(lineIndex) {
            if (!this.styles) return true;
            var offset = 0, nextLineIndex = lineIndex + 1, nextOffset, obj, shouldLimit = false, map = this._styleMap[lineIndex], mapNextLine = this._styleMap[lineIndex + 1];
            if (map) {
                lineIndex = map.line;
                offset = map.offset;
            }
            if (mapNextLine) {
                nextLineIndex = mapNextLine.line;
                shouldLimit = nextLineIndex === lineIndex;
                nextOffset = mapNextLine.offset;
            }
            obj = typeof lineIndex === 'undefined' ? this.styles : {
                line: this.styles[lineIndex]
            };
            for(var p1 in obj){
                for(var p2 in obj[p1])if (p2 >= offset && (!shouldLimit || p2 < nextOffset)) {
                    // eslint-disable-next-line no-unused-vars
                    for(var p3 in obj[p1][p2])return false;
                }
            }
            return true;
        },
        /**
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @private
     */ _getStyleDeclaration: function(lineIndex, charIndex) {
            if (this._styleMap && !this.isWrapping) {
                var map = this._styleMap[lineIndex];
                if (!map) return null;
                lineIndex = map.line;
                charIndex = map.offset + charIndex;
            }
            return this.callSuper('_getStyleDeclaration', lineIndex, charIndex);
        },
        /**
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @param {Object} style
     * @private
     */ _setStyleDeclaration: function(lineIndex, charIndex, style) {
            var map = this._styleMap[lineIndex];
            lineIndex = map.line;
            charIndex = map.offset + charIndex;
            this.styles[lineIndex][charIndex] = style;
        },
        /**
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @private
     */ _deleteStyleDeclaration: function(lineIndex, charIndex) {
            var map = this._styleMap[lineIndex];
            lineIndex = map.line;
            charIndex = map.offset + charIndex;
            delete this.styles[lineIndex][charIndex];
        },
        /**
     * probably broken need a fix
     * Returns the real style line that correspond to the wrapped lineIndex line
     * Used just to verify if the line does exist or not.
     * @param {Number} lineIndex
     * @returns {Boolean} if the line exists or not
     * @private
     */ _getLineStyle: function(lineIndex) {
            var map = this._styleMap[lineIndex];
            return !!this.styles[map.line];
        },
        /**
     * Set the line style to an empty object so that is initialized
     * @param {Number} lineIndex
     * @param {Object} style
     * @private
     */ _setLineStyle: function(lineIndex) {
            var map = this._styleMap[lineIndex];
            this.styles[map.line] = {};
        },
        /**
     * Wraps text using the 'width' property of Textbox. First this function
     * splits text on newlines, so we preserve newlines entered by the user.
     * Then it wraps each line using the width of the Textbox by calling
     * _wrapLine().
     * @param {Array} lines The string array of text that is split into lines
     * @param {Number} desiredWidth width you want to wrap to
     * @returns {Array} Array of lines
     */ _wrapText: function(lines, desiredWidth) {
            var wrapped = [], i;
            this.isWrapping = true;
            for(i = 0; i < lines.length; i++)wrapped = wrapped.concat(this._wrapLine(lines[i], i, desiredWidth));
            this.isWrapping = false;
            return wrapped;
        },
        /**
     * Helper function to measure a string of text, given its lineIndex and charIndex offset
     * it gets called when charBounds are not available yet.
     * @param {CanvasRenderingContext2D} ctx
     * @param {String} text
     * @param {number} lineIndex
     * @param {number} charOffset
     * @returns {number}
     * @private
     */ _measureWord: function(word, lineIndex, charOffset) {
            var width = 0, prevGrapheme, skipLeft = true;
            charOffset = charOffset || 0;
            for(var i = 0, len = word.length; i < len; i++){
                var box = this._getGraphemeBox(word[i], lineIndex, i + charOffset, prevGrapheme, skipLeft);
                width += box.kernedWidth;
                prevGrapheme = word[i];
            }
            return width;
        },
        /**
     * Wraps a line of text using the width of the Textbox and a context.
     * @param {Array} line The grapheme array that represent the line
     * @param {Number} lineIndex
     * @param {Number} desiredWidth width you want to wrap the line to
     * @param {Number} reservedSpace space to remove from wrapping for custom functionalities
     * @returns {Array} Array of line(s) into which the given text is wrapped
     * to.
     */ _wrapLine: function(_line, lineIndex, desiredWidth, reservedSpace) {
            var lineWidth = 0, splitByGrapheme = this.splitByGrapheme, graphemeLines = [], line = [], // spaces in different languages?
            words = splitByGrapheme ? fabric.util.string.graphemeSplit(_line) : _line.split(this._wordJoiners), word = '', offset = 0, infix = splitByGrapheme ? '' : ' ', wordWidth = 0, infixWidth = 0, largestWordWidth = 0, lineJustStarted = true, additionalSpace = this._getWidthOfCharSpacing(), reservedSpace = reservedSpace || 0;
            // fix a difference between split and graphemeSplit
            if (words.length === 0) words.push([]);
            desiredWidth -= reservedSpace;
            for(var i = 0; i < words.length; i++){
                // if using splitByGrapheme words are already in graphemes.
                word = splitByGrapheme ? words[i] : fabric.util.string.graphemeSplit(words[i]);
                wordWidth = this._measureWord(word, lineIndex, offset);
                offset += word.length;
                lineWidth += infixWidth + wordWidth - additionalSpace;
                if (lineWidth > desiredWidth && !lineJustStarted) {
                    graphemeLines.push(line);
                    line = [];
                    lineWidth = wordWidth;
                    lineJustStarted = true;
                } else lineWidth += additionalSpace;
                if (!lineJustStarted && !splitByGrapheme) line.push(infix);
                line = line.concat(word);
                infixWidth = splitByGrapheme ? 0 : this._measureWord([
                    infix
                ], lineIndex, offset);
                offset++;
                lineJustStarted = false;
                // keep track of largest word
                if (wordWidth > largestWordWidth) largestWordWidth = wordWidth;
            }
            i && graphemeLines.push(line);
            if (largestWordWidth + reservedSpace > this.dynamicMinWidth) this.dynamicMinWidth = largestWordWidth - additionalSpace + reservedSpace;
            return graphemeLines;
        },
        /**
     * Detect if the text line is ended with an hard break
     * text and itext do not have wrapping, return false
     * @param {Number} lineIndex text to split
     * @return {Boolean}
     */ isEndOfWrapping: function(lineIndex) {
            if (!this._styleMap[lineIndex + 1]) // is last line, return true;
            return true;
            if (this._styleMap[lineIndex + 1].line !== this._styleMap[lineIndex].line) // this is last line before a line break, return true;
            return true;
            return false;
        },
        /**
     * Detect if a line has a linebreak and so we need to account for it when moving
     * and counting style.
     * This is important only for splitByGrapheme at the end of wrapping.
     * If we are not wrapping the offset is always 1
     * @return Number
     */ missingNewlineOffset: function(lineIndex, skipWrapping) {
            if (this.splitByGrapheme && !skipWrapping) return this.isEndOfWrapping(lineIndex) ? 1 : 0;
            return 1;
        },
        /**
    * Gets lines of text to render in the Textbox. This function calculates
    * text wrapping on the fly every time it is called.
    * @param {String} text text to split
    * @returns {Array} Array of lines in the Textbox.
    * @override
    */ _splitTextIntoLines: function(text) {
            var newText = fabric.Text.prototype._splitTextIntoLines.call(this, text), graphemeLines = this._wrapText(newText.lines, this.width), lines = new Array(graphemeLines.length);
            for(var i = 0; i < graphemeLines.length; i++)lines[i] = graphemeLines[i].join('');
            newText.lines = lines;
            newText.graphemeLines = graphemeLines;
            return newText;
        },
        getMinWidth: function() {
            return Math.max(this.minWidth, this.dynamicMinWidth);
        },
        _removeExtraneousStyles: function() {
            var linesToKeep = {};
            for(var prop in this._styleMap)if (this._textLines[prop]) linesToKeep[this._styleMap[prop].line] = 1;
            for(var prop in this.styles)if (!linesToKeep[prop]) delete this.styles[prop];
        },
        /**
     * Returns object representation of an instance
     * @method toObject
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */ toObject: function(propertiesToInclude) {
            return this.callSuper('toObject', [
                'minWidth',
                'splitByGrapheme'
            ].concat(propertiesToInclude));
        }
    });
    /**
   * Returns fabric.Textbox instance from an object representation
   * @static
   * @memberOf fabric.Textbox
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] Callback to invoke when an fabric.Textbox instance is created
   */ fabric.Textbox.fromObject = function(object, callback) {
        var styles = fabric.util.stylesFromArray(object.styles, object.text);
        //copy object to prevent mutation
        var objCopy = Object.assign({}, object, {
            styles: styles
        });
        delete objCopy.path;
        return fabric.Object._fromObject('Textbox', objCopy, function(textInstance) {
            if (object.path) fabric.Object._fromObject('Path', object.path, function(pathInstance) {
                textInstance.set('path', pathInstance);
                callback(textInstance);
            }, 'path');
            else callback(textInstance);
        }, 'text');
    };
})($79564f678731bf19$exports);
(function() {
    var controlsUtils = $79564f678731bf19$var$fabric.controlsUtils, scaleSkewStyleHandler = controlsUtils.scaleSkewCursorStyleHandler, scaleStyleHandler = controlsUtils.scaleCursorStyleHandler, scalingEqually = controlsUtils.scalingEqually, scalingYOrSkewingX = controlsUtils.scalingYOrSkewingX, scalingXOrSkewingY = controlsUtils.scalingXOrSkewingY, scaleOrSkewActionName = controlsUtils.scaleOrSkewActionName, objectControls = $79564f678731bf19$var$fabric.Object.prototype.controls;
    objectControls.ml = new $79564f678731bf19$var$fabric.Control({
        x: -0.5,
        y: 0,
        cursorStyleHandler: scaleSkewStyleHandler,
        actionHandler: scalingXOrSkewingY,
        getActionName: scaleOrSkewActionName
    });
    objectControls.mr = new $79564f678731bf19$var$fabric.Control({
        x: 0.5,
        y: 0,
        cursorStyleHandler: scaleSkewStyleHandler,
        actionHandler: scalingXOrSkewingY,
        getActionName: scaleOrSkewActionName
    });
    objectControls.mb = new $79564f678731bf19$var$fabric.Control({
        x: 0,
        y: 0.5,
        cursorStyleHandler: scaleSkewStyleHandler,
        actionHandler: scalingYOrSkewingX,
        getActionName: scaleOrSkewActionName
    });
    objectControls.mt = new $79564f678731bf19$var$fabric.Control({
        x: 0,
        y: -0.5,
        cursorStyleHandler: scaleSkewStyleHandler,
        actionHandler: scalingYOrSkewingX,
        getActionName: scaleOrSkewActionName
    });
    objectControls.tl = new $79564f678731bf19$var$fabric.Control({
        x: -0.5,
        y: -0.5,
        cursorStyleHandler: scaleStyleHandler,
        actionHandler: scalingEqually
    });
    objectControls.tr = new $79564f678731bf19$var$fabric.Control({
        x: 0.5,
        y: -0.5,
        cursorStyleHandler: scaleStyleHandler,
        actionHandler: scalingEqually
    });
    objectControls.bl = new $79564f678731bf19$var$fabric.Control({
        x: -0.5,
        y: 0.5,
        cursorStyleHandler: scaleStyleHandler,
        actionHandler: scalingEqually
    });
    objectControls.br = new $79564f678731bf19$var$fabric.Control({
        x: 0.5,
        y: 0.5,
        cursorStyleHandler: scaleStyleHandler,
        actionHandler: scalingEqually
    });
    objectControls.mtr = new $79564f678731bf19$var$fabric.Control({
        x: 0,
        y: -0.5,
        actionHandler: controlsUtils.rotationWithSnapping,
        cursorStyleHandler: controlsUtils.rotationStyleHandler,
        offsetY: -40,
        withConnection: true,
        actionName: 'rotate'
    });
    if ($79564f678731bf19$var$fabric.Textbox) {
        // this is breaking the prototype inheritance, no time / ideas to fix it.
        // is important to document that if you want to have all objects to have a
        // specific custom control, you have to add it to Object prototype and to Textbox
        // prototype. The controls are shared as references. So changes to control `tr`
        // can still apply to all objects if needed.
        var textBoxControls = $79564f678731bf19$var$fabric.Textbox.prototype.controls = {};
        textBoxControls.mtr = objectControls.mtr;
        textBoxControls.tr = objectControls.tr;
        textBoxControls.br = objectControls.br;
        textBoxControls.tl = objectControls.tl;
        textBoxControls.bl = objectControls.bl;
        textBoxControls.mt = objectControls.mt;
        textBoxControls.mb = objectControls.mb;
        textBoxControls.mr = new $79564f678731bf19$var$fabric.Control({
            x: 0.5,
            y: 0,
            actionHandler: controlsUtils.changeWidth,
            cursorStyleHandler: scaleSkewStyleHandler,
            actionName: 'resizing'
        });
        textBoxControls.ml = new $79564f678731bf19$var$fabric.Control({
            x: -0.5,
            y: 0,
            actionHandler: controlsUtils.changeWidth,
            cursorStyleHandler: scaleSkewStyleHandler,
            actionName: 'resizing'
        });
    }
})();



var $gFW3W = parcelRequire("gFW3W");
// essential to prevent scaling of borders
(0, $79564f678731bf19$exports.fabric).Object.prototype.noScaleCache = false;
var $a4a268d7686bbf3f$export$67ea982130081db = new (0, $79564f678731bf19$exports.fabric).Canvas('drawing-canvas', {
    enablePointerEvents: true,
    stopContextMenu: true,
    fireRightClick: true,
    uniformScaling: true,
    preserveObjectStacking: true
});
window.canvas = $a4a268d7686bbf3f$export$67ea982130081db;
let $a4a268d7686bbf3f$var$selectedTool = null //the id of the currently selected tool
;
let $a4a268d7686bbf3f$var$currentObject = null // the object implementing the tool currently selected, if any
;
var $a4a268d7686bbf3f$var$undos = [] // stack of user changes to objects for undo
;
var $a4a268d7686bbf3f$var$redos = [] // stack of undos for redoing
;
var $a4a268d7686bbf3f$export$f2efb2348b1e4771 = 0 // incremented when the background is amended
;
function $a4a268d7686bbf3f$export$cf606e54e8a9990d() {
    $a4a268d7686bbf3f$export$59b33278b5b2fc8a();
    $a4a268d7686bbf3f$var$initDraw();
}
(0, $gFW3W.listen)('drawing-canvas', 'keydown', $a4a268d7686bbf3f$var$checkKey);
function $a4a268d7686bbf3f$export$59b33278b5b2fc8a() {
    let underlay = (0, $gFW3W.elem)('underlay');
    let oldWidth = $a4a268d7686bbf3f$export$67ea982130081db.getWidth();
    let oldHeight = $a4a268d7686bbf3f$export$67ea982130081db.getHeight();
    $a4a268d7686bbf3f$export$8a6e5c2ddf85cd20(1.0);
    $a4a268d7686bbf3f$export$67ea982130081db.setHeight(underlay.offsetHeight);
    $a4a268d7686bbf3f$export$67ea982130081db.setWidth(underlay.offsetWidth);
    $a4a268d7686bbf3f$export$67ea982130081db.calcOffset();
    $a4a268d7686bbf3f$export$4ccc1b9eba0bcd20(($a4a268d7686bbf3f$export$67ea982130081db.getWidth() - oldWidth) / 2, ($a4a268d7686bbf3f$export$67ea982130081db.getHeight() - oldHeight) / 2, 1.0);
    $a4a268d7686bbf3f$export$8a6e5c2ddf85cd20((0, $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4) ? (0, $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4).getScale() : 1);
    $a4a268d7686bbf3f$export$67ea982130081db.requestRenderAll();
}
function $a4a268d7686bbf3f$export$8a6e5c2ddf85cd20(zoom) {
    $a4a268d7686bbf3f$export$67ea982130081db.zoomToPoint({
        x: $a4a268d7686bbf3f$export$67ea982130081db.getWidth() / 2,
        y: $a4a268d7686bbf3f$export$67ea982130081db.getHeight() / 2
    }, zoom);
}
function $a4a268d7686bbf3f$export$4ccc1b9eba0bcd20(x, y, zoom) {
    zoom = zoom || (0, $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4).getScale();
    $a4a268d7686bbf3f$export$67ea982130081db.relativePan(new (0, $79564f678731bf19$exports.fabric).Point(x * zoom, y * zoom));
}
/**
 * set up the fabric context, the grid drawn on it and the tools
 */ function $a4a268d7686bbf3f$var$initDraw() {
    (0, $79564f678731bf19$exports.fabric).Object.prototype.set({
        transparentCorners: false,
        cornerColor: 'blue',
        cornerSize: 5,
        cornerStyle: 'circle'
    });
    if (0, $e1c55b086cf8dd0e$export$c05995454a6ca00d) $a4a268d7686bbf3f$var$drawGrid();
    $a4a268d7686bbf3f$var$setUpToolbox();
    $a4a268d7686bbf3f$export$67ea982130081db.setViewportTransform([
        1,
        0,
        0,
        1,
        $a4a268d7686bbf3f$export$67ea982130081db.getWidth() / 2,
        $a4a268d7686bbf3f$export$67ea982130081db.getHeight() / 2
    ]);
    $a4a268d7686bbf3f$var$initAligningGuidelines();
}
function $a4a268d7686bbf3f$export$dfdc6d14987fb95e() {
    $a4a268d7686bbf3f$export$67ea982130081db.requestRenderAll();
    if (0, $e1c55b086cf8dd0e$export$c05995454a6ca00d) $a4a268d7686bbf3f$var$drawGrid();
}
function $a4a268d7686bbf3f$export$7ec610621a8fb67b(event) {
    if (event.transaction.local === false && event.keysChanged.size > 0) //oddly, keys changed includes old, cleared keys, so use this instead.
    $a4a268d7686bbf3f$export$8d588f71d329a9b1([
        ...event.changes.keys.keys()
    ]);
}
function $a4a268d7686bbf3f$export$234b64ec3262770a() {
    $a4a268d7686bbf3f$export$67ea982130081db.clear();
    $a4a268d7686bbf3f$export$8d588f71d329a9b1([
        ...(0, $e1c55b086cf8dd0e$export$da7062de5ac36f9c).keys()
    ]);
}
async function $a4a268d7686bbf3f$export$8d588f71d329a9b1(keys) {
    if (/back/.test((0, $e1c55b086cf8dd0e$export$1c9f709888824e05))) keys.forEach((key)=>console.log('Key:', key, 'value:', (0, $e1c55b086cf8dd0e$export$da7062de5ac36f9c).get(key)));
    let imageFound = false;
    for (let key of keys){
        /* active Selection and group have to be dealt with last, because they reference objects that may
		 * not have been put on the canvas yet */ let remoteParams = (0, $e1c55b086cf8dd0e$export$da7062de5ac36f9c).get(key);
        if (!remoteParams) {
            console.error('Empty remoteParams in refreshFromMap()', key);
            continue;
        }
        switch(key){
            case 'undos':
                $a4a268d7686bbf3f$var$undos = (0, $gFW3W.deepCopy)(remoteParams);
                $a4a268d7686bbf3f$var$updateActiveButtons();
                continue;
            case 'redos':
                $a4a268d7686bbf3f$var$redos = (0, $gFW3W.deepCopy)(remoteParams);
                $a4a268d7686bbf3f$var$updateActiveButtons();
                continue;
            case 'selection':
                continue;
            case 'activeSelection':
                continue;
            case 'sequence':
                continue;
            default:
                {
                    let localObj = $a4a268d7686bbf3f$export$67ea982130081db.getObjects().find((o)=>o.id === key);
                    // if object already exists, update it
                    if (localObj) {
                        if (remoteParams.type === 'ungroup') {
                            localObj.toActiveSelection();
                            $a4a268d7686bbf3f$export$67ea982130081db.discardActiveObject();
                        } else localObj.setOptions(remoteParams);
                    } else {
                        // create a new object
                        switch(remoteParams.type){
                            case 'rect':
                                localObj = new $a4a268d7686bbf3f$var$RectHandler();
                                break;
                            case 'circle':
                                localObj = new $a4a268d7686bbf3f$var$CircleHandler();
                                break;
                            case 'line':
                                localObj = new $a4a268d7686bbf3f$var$LineHandler();
                                break;
                            case 'text':
                                localObj = new $a4a268d7686bbf3f$var$TextHandler();
                                break;
                            case 'path':
                                localObj = new (0, $79564f678731bf19$exports.fabric).Path();
                                break;
                            case 'image':
                                (0, $79564f678731bf19$exports.fabric).Image.fromObject(remoteParams.imageObj, (image)=>{
                                    image.setCoords();
                                    image.id = key;
                                    $a4a268d7686bbf3f$export$67ea982130081db.add(image);
                                });
                                imageFound = true;
                                continue;
                            case 'group':
                                continue;
                            case 'ungroup':
                                continue;
                            default:
                                throw `bad fabric object type in yDrawingMap.observe: ${remoteParams.type}`;
                        }
                        localObj.setOptions(remoteParams);
                        localObj.id = key;
                        $a4a268d7686bbf3f$export$67ea982130081db.add(localObj);
                    }
                    localObj.setCoords();
                }
        }
    }
    /* This is a horrible hack, because fabric.js doesn't yet support Promises.  If there is an image to load,
	wait a while to ensure that it has been added to the canvas before proceeding. */ if (imageFound) await new Promise((r)=>setTimeout(r, 400));
    for (let key of keys){
        let remoteParams = (0, $e1c55b086cf8dd0e$export$da7062de5ac36f9c).get(key);
        if (remoteParams) switch(key){
            case 'selection':
                {
                    let activeObject = $a4a268d7686bbf3f$export$67ea982130081db.getActiveObject();
                    if (activeObject) {
                        // if selection has zero members, this means discard selection
                        if (remoteParams.members.length === 0) $a4a268d7686bbf3f$export$67ea982130081db.discardActiveObject();
                        else activeObject.set({
                            angle: remoteParams.angle,
                            left: remoteParams.left,
                            scaleX: remoteParams.scaleX,
                            scaleY: remoteParams.scaleY,
                            top: remoteParams.top
                        });
                    } else {
                        // no existing active selection, make one
                        let selectedObjects = remoteParams.members.map((id)=>$a4a268d7686bbf3f$export$67ea982130081db.getObjects().find((o)=>o.id === id));
                        let sel = new (0, $79564f678731bf19$exports.fabric).ActiveSelection(selectedObjects, {
                            canvas: $a4a268d7686bbf3f$export$67ea982130081db
                        });
                        sel.id = 'selection';
                        sel.members = remoteParams.members;
                        $a4a268d7686bbf3f$export$67ea982130081db.setActiveObject(sel);
                    }
                    $a4a268d7686bbf3f$var$updateActiveButtons();
                    break;
                }
            case 'sequence':
                break;
            default:
                if (remoteParams?.type === 'group') {
                    let objs = remoteParams.members.map((id)=>$a4a268d7686bbf3f$export$67ea982130081db.getObjects().find((o)=>o.id === id));
                    $a4a268d7686bbf3f$export$67ea982130081db.discardActiveObject();
                    let group = new (0, $79564f678731bf19$exports.fabric).Group(objs);
                    group.id = key;
                    group.members = remoteParams.members;
                    $a4a268d7686bbf3f$var$setGroupBorderColor(group);
                    group.set({
                        left: remoteParams.left,
                        top: remoteParams.top,
                        angle: remoteParams.angle,
                        scaleX: remoteParams.scaleX,
                        scaleY: remoteParams.scaleY
                    });
                    $a4a268d7686bbf3f$export$67ea982130081db.add(group);
                    $a4a268d7686bbf3f$export$67ea982130081db.setActiveObject(group);
                }
        }
    }
    // and lastly reorder the objects if necessary
    if (keys.includes('sequence')) {
        let remoteParams = (0, $e1c55b086cf8dd0e$export$da7062de5ac36f9c).get('sequence');
        let newObjects = [];
        remoteParams.forEach((id)=>{
            let newObject = $a4a268d7686bbf3f$export$67ea982130081db.getObjects().find((obj)=>obj.id === id);
            if (newObject) newObjects.push(newObject);
        });
        $a4a268d7686bbf3f$export$67ea982130081db._objects = newObjects;
    }
    // if at start up, so not in drawing mode, don't show active selection borders
    if (!(0, $e1c55b086cf8dd0e$export$c05995454a6ca00d)) $a4a268d7686bbf3f$export$67ea982130081db.discardActiveObject();
    $a4a268d7686bbf3f$export$67ea982130081db.requestRenderAll();
}
/**
 * Draw the background grid before rendering the fabric objects
 */ $a4a268d7686bbf3f$export$67ea982130081db.on('before:render', ()=>{
    if (0, $e1c55b086cf8dd0e$export$c05995454a6ca00d) $a4a268d7686bbf3f$var$drawGrid();
    $a4a268d7686bbf3f$export$67ea982130081db.clearContext($a4a268d7686bbf3f$export$67ea982130081db.contextTop);
});
$a4a268d7686bbf3f$export$67ea982130081db.on('selection:created', (e)=>$a4a268d7686bbf3f$var$updateSelection(e));
$a4a268d7686bbf3f$export$67ea982130081db.on('selection:updated', (e)=>$a4a268d7686bbf3f$var$updateSelection(e));
/**
 * save changes and update state when user has selected more than 1 object
 * @param {canvasEvent} evt
 */ function $a4a268d7686bbf3f$var$updateSelection(evt) {
    // only process updates caused by user (if evt.e is undefined, the update has been generated by remote activity)
    if (evt.e) {
        // ignore updates if user is in the middle of creating an object and happens to click on this one
        if ($a4a268d7686bbf3f$var$selectedTool) return;
        let activeObject = $a4a268d7686bbf3f$export$67ea982130081db.getActiveObject();
        let activeMembers = $a4a268d7686bbf3f$export$67ea982130081db.getActiveObjects();
        // only record selections with more than 1 member object
        if (activeObject.type === 'activeSelection' && activeMembers.length > 1) {
            activeObject.id = 'selection';
            activeObject.members = activeMembers.map((o)=>o.id);
            $a4a268d7686bbf3f$var$saveChange(activeObject, {}, 'add');
        }
        if (activeMembers.length > 1) $a4a268d7686bbf3f$var$closeOptionsDialogs();
        else {
            if (evt.selected[0].type !== $a4a268d7686bbf3f$var$selectedTool) $a4a268d7686bbf3f$var$closeOptionsDialogs();
            // no option possible when selecting path, group or image
            if (![
                'path',
                'group',
                'image'
            ].includes(evt.selected[0].type)) evt.selected[0].optionsDialog();
        }
        $a4a268d7686bbf3f$var$updateActiveButtons();
    }
}
// save changes and update state when user has unselected all objects
$a4a268d7686bbf3f$export$67ea982130081db.on('selection:cleared', (evt)=>{
    if (!evt.e) return;
    if (evt.deselected.length > 1) {
        let oldMembers = evt.deselected;
        $a4a268d7686bbf3f$var$saveChange({
            type: 'selection',
            id: 'selection'
        }, {
            members: [],
            oldMembers: oldMembers.map((o)=>o.id)
        }, 'discard');
    }
    $a4a268d7686bbf3f$export$f94e63f0099c362e();
    // only allow deletion of selected objects
    (0, $gFW3W.elem)('bin').classList.add('disabled');
    (0, $gFW3W.elem)('group').classList.add('disabled');
});
// user has just finished creating a path (with pencil or marker) - save it
$a4a268d7686bbf3f$export$67ea982130081db.on('path:created', ()=>{
    let obj = $a4a268d7686bbf3f$var$getLastPath();
    obj.id = (0, $gFW3W.uuidv4)();
    $a4a268d7686bbf3f$var$saveChange(obj, {
        path: obj.path,
        stroke: obj.stroke,
        strokeWidth: obj.strokeWidth,
        pathOffset: obj.pathOffset,
        fill: null
    }, 'insert');
});
// record object moves on undo stack and broadcast them
$a4a268d7686bbf3f$export$67ea982130081db.on('object:modified', (rec)=>{
    let obj = rec.target;
    if (!obj.id) obj.id = (0, $gFW3W.uuidv4)();
    $a4a268d7686bbf3f$var$saveChange(obj, {
        id: obj.id
    }, 'update');
});
/**
 * draw a grid on the drawing canvas
 * @param {Integer} grid_size - pixels between grid lines
 */ function $a4a268d7686bbf3f$var$drawGrid(grid_size = 25) {
    const grid_context = (0, $gFW3W.elem)('drawing-canvas').getContext('2d');
    const currentCanvasWidth = $a4a268d7686bbf3f$export$67ea982130081db.getWidth();
    const currentCanvasHeight = $a4a268d7686bbf3f$export$67ea982130081db.getHeight();
    grid_context.save();
    grid_context.clearRect(0, 0, currentCanvasWidth, currentCanvasHeight);
    grid_context.strokeStyle = 'rgba(0, 0, 0, 0.2)';
    // Drawing vertical lines
    for(let x = 0; x <= currentCanvasWidth; x += grid_size){
        grid_context.beginPath();
        grid_context.moveTo(x + 0.5, 0);
        grid_context.lineTo(x + 0.5, currentCanvasHeight);
        grid_context.stroke();
    }
    // Drawing horizontal lines
    for(let y = 0; y <= currentCanvasHeight; y += grid_size){
        grid_context.beginPath();
        grid_context.moveTo(0, y + 0.5);
        grid_context.lineTo(currentCanvasWidth, y + 0.5);
        grid_context.stroke();
    }
    grid_context.restore();
}
/**
 * add event listeners to the tools to receive user clicks to select a tool
 */ function $a4a268d7686bbf3f$var$setUpToolbox() {
    let tools = document.querySelectorAll('.tool');
    Array.from(tools).forEach((tool)=>{
        tool.addEventListener('click', $a4a268d7686bbf3f$var$selectTool);
    });
    (0, $gFW3W.dragElement)((0, $gFW3W.elem)('toolbox'), (0, $gFW3W.elem)('toolbox-header'));
}
/**
 *
 * Toolbox
 */ /**
 * When the user clicks a tool icon
 * unselect previous tool, select this one
 * and remember which tool is now selected
 * The undo, redo, delete and image tools are special, because they act
 * immediately when the icon is clicked
 *
 * @param {object} event
 */ function $a4a268d7686bbf3f$var$selectTool(event) {
    let tool = event.currentTarget;
    if (tool.id === 'undotool') {
        $a4a268d7686bbf3f$var$currentObject = null;
        $a4a268d7686bbf3f$var$toolHandler('undo').undo();
        return;
    }
    if (tool.id === 'redotool') {
        $a4a268d7686bbf3f$var$currentObject = null;
        $a4a268d7686bbf3f$var$toolHandler('undo').redo();
        return;
    }
    if (tool.id === 'group') {
        $a4a268d7686bbf3f$var$currentObject = null;
        let activeObj = $a4a268d7686bbf3f$export$67ea982130081db.getActiveObject();
        if (!activeObj) return;
        if (activeObj.type === 'group') $a4a268d7686bbf3f$var$unGroup();
        else $a4a268d7686bbf3f$var$makeGroup();
        return;
    }
    if (tool.id === 'bin') {
        $a4a268d7686bbf3f$var$currentObject = null;
        $a4a268d7686bbf3f$var$toolHandler('bin').delete();
        return;
    }
    //second click on selected tool - unselect it
    if ($a4a268d7686bbf3f$var$selectedTool === tool.id) {
        $a4a268d7686bbf3f$export$f94e63f0099c362e();
        return;
    }
    // changing tool; unselect previous one
    $a4a268d7686bbf3f$export$f94e63f0099c362e();
    $a4a268d7686bbf3f$var$selectedTool = tool.id;
    tool.classList.add('selected');
    // display options dialog
    $a4a268d7686bbf3f$var$toolHandler($a4a268d7686bbf3f$var$selectedTool).optionsDialog();
    $a4a268d7686bbf3f$export$67ea982130081db.isDrawingMode = tool.id === 'pencil' || tool.id === 'marker';
    // if tool is 'image', get image file from user
    if (tool.id === 'image') {
        let fileInput = document.createElement('input');
        fileInput.id = 'fileInput';
        fileInput.setAttribute('type', 'file');
        fileInput.setAttribute('accept', 'image/*');
        fileInput.addEventListener('change', $a4a268d7686bbf3f$var$toolHandler($a4a268d7686bbf3f$var$selectedTool).loadImage);
        fileInput.click();
    }
}
function $a4a268d7686bbf3f$export$f94e63f0099c362e() {
    $a4a268d7686bbf3f$var$unselectTool();
    $a4a268d7686bbf3f$export$67ea982130081db.isDrawingMode = false;
    $a4a268d7686bbf3f$export$67ea982130081db.discardActiveObject().requestRenderAll();
    $a4a268d7686bbf3f$var$closeOptionsDialogs();
    $a4a268d7686bbf3f$var$updateActiveButtons();
}
/**
 * unselect the current tool
 */ function $a4a268d7686bbf3f$var$unselectTool() {
    if ($a4a268d7686bbf3f$var$selectedTool) (0, $gFW3W.elem)($a4a268d7686bbf3f$var$selectedTool).classList.remove('selected');
    $a4a268d7686bbf3f$var$selectedTool = null;
    $a4a268d7686bbf3f$var$currentObject = null;
}
/**
 * remove any option dialog that is open
 */ function $a4a268d7686bbf3f$var$closeOptionsDialogs() {
    let box = (0, $gFW3W.elem)('optionsBox');
    if (box) box.remove();
}
/**
 * show whether some buttons are active or disabled, depending
 * on whether anything is selected and whether undo or redo is possible
 */ function $a4a268d7686bbf3f$var$updateActiveButtons() {
    if ($a4a268d7686bbf3f$var$undos.length > 0) (0, $gFW3W.elem)('undotool').classList.remove('disabled');
    else (0, $gFW3W.elem)('undotool').classList.add('disabled');
    if ($a4a268d7686bbf3f$var$redos.length > 0) (0, $gFW3W.elem)('redotool').classList.remove('disabled');
    else (0, $gFW3W.elem)('redotool').classList.add('disabled');
    let nActiveObjects = $a4a268d7686bbf3f$export$67ea982130081db.getActiveObjects().length;
    if (nActiveObjects > 0) (0, $gFW3W.elem)('bin').classList.remove('disabled');
    else (0, $gFW3W.elem)('bin').classList.add('disabled');
    if (nActiveObjects > 1) (0, $gFW3W.elem)('group').classList.remove('disabled');
    else if ($a4a268d7686bbf3f$export$67ea982130081db.getActiveObject()?.type === 'group') (0, $gFW3W.elem)('group').classList.remove('disabled');
    else (0, $gFW3W.elem)('group').classList.add('disabled');
}
/**
 * return the correct instance of toolHandler for the given tool
 * @param {string} tool
 * @returns {object}
 */ function $a4a268d7686bbf3f$var$toolHandler(tool) {
    if ($a4a268d7686bbf3f$var$currentObject) return $a4a268d7686bbf3f$var$currentObject;
    switch(tool){
        case 'rect':
            $a4a268d7686bbf3f$var$currentObject = new $a4a268d7686bbf3f$var$RectHandler();
            break;
        case 'circle':
            $a4a268d7686bbf3f$var$currentObject = new $a4a268d7686bbf3f$var$CircleHandler();
            break;
        case 'line':
            $a4a268d7686bbf3f$var$currentObject = new $a4a268d7686bbf3f$var$LineHandler();
            break;
        case 'text':
            $a4a268d7686bbf3f$var$currentObject = new $a4a268d7686bbf3f$var$TextHandler();
            break;
        case 'pencil':
            $a4a268d7686bbf3f$var$currentObject = new $a4a268d7686bbf3f$var$PencilHandler();
            break;
        case 'marker':
            $a4a268d7686bbf3f$var$currentObject = new $a4a268d7686bbf3f$var$MarkerHandler();
            break;
        case 'image':
            $a4a268d7686bbf3f$var$currentObject = new $a4a268d7686bbf3f$var$ImageHandler();
            break;
        case 'bin':
            $a4a268d7686bbf3f$var$currentObject = new $a4a268d7686bbf3f$var$DeleteHandler();
            break;
        case 'undo':
            $a4a268d7686bbf3f$var$currentObject = new $a4a268d7686bbf3f$var$UndoHandler();
            break;
    }
    return $a4a268d7686bbf3f$var$currentObject;
}
/**
 * react to key presses and mouse movements
 */ window.addEventListener('keydown', (e)=>{
    if ((0, $e1c55b086cf8dd0e$export$c05995454a6ca00d) && e.key === 'Backspace' || e.key === 'Delete') {
        let obj = $a4a268d7686bbf3f$export$67ea982130081db.getActiveObject();
        if (obj && !obj.isEditing) {
            e.preventDefault();
            $a4a268d7686bbf3f$var$currentObject = null;
            $a4a268d7686bbf3f$var$toolHandler('bin').delete();
        }
    }
});
window.addEventListener('keydown', (e)=>{
    if ((0, $e1c55b086cf8dd0e$export$c05995454a6ca00d) && (e.ctrlKey || e.metaKey) && e.key === 'z') {
        e.preventDefault();
        $a4a268d7686bbf3f$var$currentObject = null;
        $a4a268d7686bbf3f$var$toolHandler('undo').undo();
    }
});
window.addEventListener('keydown', (e)=>{
    if ((0, $e1c55b086cf8dd0e$export$c05995454a6ca00d) && (e.ctrlKey || e.metaKey) && e.key === 'y') {
        e.preventDefault();
        $a4a268d7686bbf3f$var$currentObject = null;
        $a4a268d7686bbf3f$var$toolHandler('undo').redo();
    }
});
window.addEventListener('keydown', (e)=>{
    if ((0, $e1c55b086cf8dd0e$export$c05995454a6ca00d) && e.key === 'ArrowUp') {
        e.preventDefault();
        $a4a268d7686bbf3f$var$arrowMove('ArrowUp');
    }
});
window.addEventListener('keydown', (e)=>{
    if ((0, $e1c55b086cf8dd0e$export$c05995454a6ca00d) && e.key === 'ArrowDown') {
        e.preventDefault();
        $a4a268d7686bbf3f$var$arrowMove('ArrowDown');
    }
});
window.addEventListener('keydown', (e)=>{
    if ((0, $e1c55b086cf8dd0e$export$c05995454a6ca00d) && e.key === 'ArrowLeft') {
        e.preventDefault();
        $a4a268d7686bbf3f$var$arrowMove('ArrowLeft');
    }
});
window.addEventListener('keydown', (e)=>{
    if ((0, $e1c55b086cf8dd0e$export$c05995454a6ca00d) && e.key === 'ArrowRight') {
        e.preventDefault();
        $a4a268d7686bbf3f$var$arrowMove('ArrowRight');
    }
});
/**
 *  handle mouse moves, despatching to tools or panning the canvas
 */ $a4a268d7686bbf3f$export$67ea982130081db.on('mouse:down', function(options) {
    let event = options.e;
    // if right click on an object, display 'Send to back/front' popup menu
    if (event.button === 2) {
        if (options.target) (0, $gFW3W.addContextMenu)(event.target, [
            {
                label: 'Send to back',
                action: ()=>$a4a268d7686bbf3f$var$sendToBack(options.target)
            },
            {
                label: 'Bring to front',
                action: ()=>$a4a268d7686bbf3f$var$bringToFront(options.target)
            }
        ]);
        return;
    }
    if ($a4a268d7686bbf3f$var$selectedTool) $a4a268d7686bbf3f$var$toolHandler($a4a268d7686bbf3f$var$selectedTool)[event.type](event);
    else if (!$a4a268d7686bbf3f$export$67ea982130081db.getActiveObject()) {
        this.isDragging = true;
        this.selection = false;
        this.lastPosX = event.clientX;
        this.lastPosY = event.clientY;
        this.defaultCursor = 'grabbing';
        this.setCursor(this.defaultCursor);
    }
});
function $a4a268d7686bbf3f$var$sendToBack(obj) {
    obj.sendToBack();
    $a4a268d7686bbf3f$var$saveChange(obj, {}, 'insert)');
}
function $a4a268d7686bbf3f$var$bringToFront(obj) {
    obj.bringToFront();
    $a4a268d7686bbf3f$var$saveChange(obj, {}, 'insert)');
}
$a4a268d7686bbf3f$export$67ea982130081db.on('mouse:move', function(options) {
    let event = options.e;
    if ($a4a268d7686bbf3f$var$selectedTool) $a4a268d7686bbf3f$var$toolHandler($a4a268d7686bbf3f$var$selectedTool)[event.type](event);
    else if (this.isDragging) {
        event.stopImmediatePropagation();
        let vpt = this.viewportTransform;
        let moveX = event.clientX - this.lastPosX;
        let moveY = event.clientY - this.lastPosY;
        vpt[4] += moveX;
        vpt[5] += moveY;
        let networkVP = (0, $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4).getViewPosition();
        (0, $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4).moveTo({
            position: {
                x: networkVP.x - moveX / vpt[0],
                y: networkVP.y - moveY / vpt[0]
            }
        });
        this.requestRenderAll();
        this.lastPosX = event.clientX;
        this.lastPosY = event.clientY;
    }
});
$a4a268d7686bbf3f$export$67ea982130081db.on('mouse:up', function(options) {
    let event = options.e;
    if ($a4a268d7686bbf3f$var$selectedTool) $a4a268d7686bbf3f$var$toolHandler($a4a268d7686bbf3f$var$selectedTool)[event.type](event);
    else {
        this.setViewportTransform(this.viewportTransform);
        this.isDragging = false;
        this.selection = true;
        this.defaultCursor = 'default';
        this.setCursor(this.defaultCursor);
    }
});
$a4a268d7686bbf3f$export$67ea982130081db.on('mouse:dblclick', ()=>(0, $e1c55b086cf8dd0e$export$1e044b7877db048c)());
const $a4a268d7686bbf3f$var$ARROOWINCR = 1;
function $a4a268d7686bbf3f$var$arrowMove(direction) {
    let activeObj = $a4a268d7686bbf3f$export$67ea982130081db.getActiveObject();
    if (!activeObj) return;
    let top = activeObj.top;
    let left = activeObj.left;
    switch(direction){
        case 'ArrowUp':
            top -= $a4a268d7686bbf3f$var$ARROOWINCR;
            break;
        case 'ArrowDown':
            top += $a4a268d7686bbf3f$var$ARROOWINCR;
            break;
        case 'ArrowLeft':
            left -= $a4a268d7686bbf3f$var$ARROOWINCR;
            break;
        case 'ArrowRight':
            left += $a4a268d7686bbf3f$var$ARROOWINCR;
            break;
    }
    activeObj.set({
        left: left,
        top: top
    });
    $a4a268d7686bbf3f$export$67ea982130081db.requestRenderAll();
}
/**
 * Create an HTMLElement that will hold the options dialog
 * @param {String} tool
 * @returns HTMLElement
 */ function $a4a268d7686bbf3f$var$makeOptionsDialog(tool) {
    if (!tool) return;
    let underlay = (0, $gFW3W.elem)('underlay');
    let box = document.createElement('div');
    box.className = 'options';
    box.id = 'optionsBox';
    box.style.top = `${(0, $gFW3W.elem)(tool).getBoundingClientRect().top - underlay.getBoundingClientRect().top}px`;
    box.style.left = `${(0, $gFW3W.elem)(tool).getBoundingClientRect().right + 10}px`;
    underlay.appendChild(box);
    return box;
}
/******************************************************************Rect ********************************************/ const $a4a268d7686bbf3f$var$cornerRadius = 10 // radius of rounded corners for rounded rectangle
;
let $a4a268d7686bbf3f$var$RectHandler = (0, $79564f678731bf19$exports.fabric).util.createClass((0, $79564f678731bf19$exports.fabric).Rect, {
    type: 'rect',
    initialize: function() {
        this.callSuper('initialize', {
            fill: '#ffffff',
            strokeWidth: 1,
            stroke: '#000000',
            strokeUniform: true
        });
        this.dragging = false;
        this.roundCorners = $a4a268d7686bbf3f$var$cornerRadius;
        this.id = (0, $gFW3W.uuidv4)();
        this.strokeUniform = true;
    },
    pointerdown: function(e) {
        this.setParams();
        this.dragging = true;
        this.start = $a4a268d7686bbf3f$export$67ea982130081db.getPointer(e);
        this.left = this.start.x;
        this.top = this.start.y;
        this.width = 0;
        this.height = 0;
        this.rx = this.roundCorners;
        this.ry = this.roundCorners;
        $a4a268d7686bbf3f$export$67ea982130081db.add(this);
        $a4a268d7686bbf3f$export$67ea982130081db.selection = false;
    },
    pointermove: function(e) {
        if (!this.dragging) return;
        let pointer = $a4a268d7686bbf3f$export$67ea982130081db.getPointer(e);
        // allow rect to be drawn from bottom right corner as well as from top left corner
        let left = Math.min(this.start.x, pointer.x);
        let top = Math.min(this.start.y, pointer.y);
        this.set({
            left: left,
            top: top,
            width: Math.abs(this.start.x - pointer.x),
            height: Math.abs(this.start.y - pointer.y)
        });
        $a4a268d7686bbf3f$export$67ea982130081db.requestRenderAll();
    },
    pointerup: function() {
        this.dragging = false;
        $a4a268d7686bbf3f$var$currentObject = null;
        if (this.width === 0 || this.height === 0) return;
        $a4a268d7686bbf3f$var$saveChange(this, {
            rx: this.rx,
            ry: this.ry,
            fill: this.fill,
            strokeWidth: this.strokeWidth,
            stroke: this.stroke
        }, 'insert');
        $a4a268d7686bbf3f$export$67ea982130081db.selection = true;
        $a4a268d7686bbf3f$export$67ea982130081db.setActiveObject(this).requestRenderAll();
        $a4a268d7686bbf3f$var$unselectTool();
    },
    update: function() {
        this.setParams();
        $a4a268d7686bbf3f$var$saveChange(this, {
            rx: this.rx,
            ry: this.ry,
            fill: this.fill,
            strokeWidth: this.strokeWidth,
            stroke: this.stroke
        }, 'update');
    },
    setParams: function() {
        if (!(0, $gFW3W.elem)('optionsBox')) return;
        this.roundCorners = (0, $gFW3W.elem)('rounded').checked ? $a4a268d7686bbf3f$var$cornerRadius : 0;
        let fill = (0, $gFW3W.elem)('fillColor').style.backgroundColor;
        // make white transparent
        if (fill === 'rgb(255, 255, 255)') fill = 'rgba(0, 0, 0, 0)';
        this.set({
            rx: this.roundCorners,
            ry: this.roundCorners,
            fill: fill,
            strokeWidth: parseInt((0, $gFW3W.elem)('borderWidth').value),
            stroke: (0, $gFW3W.elem)('borderColor').style.backgroundColor
        });
        $a4a268d7686bbf3f$export$67ea982130081db.requestRenderAll();
    },
    optionsDialog: function() {
        if ((0, $gFW3W.elem)('optionsBox')) return;
        this.box = $a4a268d7686bbf3f$var$makeOptionsDialog('rect');
        this.box.innerHTML = `
	<div>Border width</div><div><input id="borderWidth"  type="number" min="0" max="99" size="2"></div>
	<div>Border Colour</div><div class="input-color-container">
		<div class="color-well" id="borderColor"></div>
	</div>	
  	<div>Fill Colour</div><div class="input-color-container">
  		<div class="color-well" id="fillColor"></div>
	</div>
	<div>Rounded</div><input type="checkbox" id="rounded"></div>`;
        (0, $e1c55b086cf8dd0e$export$cd571ca6d1702b73).createColorPicker('fillColor', ()=>this.update(), ()=>this.setParams());
        (0, $e1c55b086cf8dd0e$export$cd571ca6d1702b73).createColorPicker('borderColor', ()=>this.update(), ()=>this.setParams());
        let widthInput = (0, $gFW3W.elem)('borderWidth');
        widthInput.value = this.strokeWidth;
        widthInput.addEventListener('change', ()=>{
            this.update();
        });
        let borderColor = (0, $gFW3W.elem)('borderColor');
        borderColor.style.backgroundColor = this.stroke;
        let fillColor = (0, $gFW3W.elem)('fillColor');
        fillColor.style.backgroundColor = this.fill;
        let rounded = (0, $gFW3W.elem)('rounded');
        rounded.checked = this.roundCorners !== 0;
        rounded.addEventListener('change', ()=>{
            this.update();
        });
    }
});
/******************************************************************Circle ********************************************/ let $a4a268d7686bbf3f$var$CircleHandler = (0, $79564f678731bf19$exports.fabric).util.createClass((0, $79564f678731bf19$exports.fabric).Circle, {
    type: 'circle',
    initialize: function() {
        this.callSuper('initialize', {
            fill: '#ffffff',
            strokeWidth: 1,
            stroke: '#000000',
            strokeUniform: true
        });
        this.dragging = false;
        this.id = (0, $gFW3W.uuidv4)();
        this.originX = 'left';
        this.originY = 'top';
    },
    pointerdown: function(e) {
        this.setParams();
        this.dragging = true;
        this.start = $a4a268d7686bbf3f$export$67ea982130081db.getPointer(e);
        this.left = this.start.x;
        this.top = this.start.y;
        this.radius = 0;
        $a4a268d7686bbf3f$export$67ea982130081db.add(this);
        $a4a268d7686bbf3f$export$67ea982130081db.selection = false;
    },
    pointermove: function(e) {
        if (!this.dragging) return;
        let pointer = $a4a268d7686bbf3f$export$67ea982130081db.getPointer(e);
        // allow drawing from bottom right corner as well as from top left corner
        let left = Math.min(this.start.x, pointer.x);
        let top = Math.min(this.start.y, pointer.y);
        this.set({
            left: left,
            top: top,
            radius: Math.sqrt((this.start.x - pointer.x) ** 2 + (this.start.y - pointer.y) ** 2) / 2
        });
        $a4a268d7686bbf3f$export$67ea982130081db.requestRenderAll();
    },
    pointerup: function() {
        this.dragging = false;
        $a4a268d7686bbf3f$var$currentObject = null;
        if (this.radius === 0) return;
        $a4a268d7686bbf3f$var$saveChange(this, {
            fill: this.fill,
            strokeWidth: this.strokeWidth,
            stroke: this.stroke
        }, 'insert');
        $a4a268d7686bbf3f$export$67ea982130081db.selection = true;
        $a4a268d7686bbf3f$export$67ea982130081db.setActiveObject(this).requestRenderAll();
        $a4a268d7686bbf3f$var$unselectTool();
    },
    update: function() {
        this.setParams();
        $a4a268d7686bbf3f$var$saveChange(this, {
            fill: this.fill,
            strokeWidth: this.strokeWidth,
            stroke: this.stroke
        }, 'update');
    },
    setParams: function() {
        if (!(0, $gFW3W.elem)('optionsBox')) return;
        let fill = (0, $gFW3W.elem)('fillColor').style.backgroundColor;
        // make white transparent
        if (fill === 'rgb(255, 255, 255)') fill = 'rgba(0, 0, 0, 0)';
        this.set({
            fill: fill,
            strokeWidth: parseInt((0, $gFW3W.elem)('borderWidth').value),
            stroke: (0, $gFW3W.elem)('borderColor').style.backgroundColor
        });
        $a4a268d7686bbf3f$export$67ea982130081db.requestRenderAll();
    },
    optionsDialog: function() {
        if ((0, $gFW3W.elem)('optionsBox')) return;
        this.box = $a4a268d7686bbf3f$var$makeOptionsDialog('circle');
        this.box.innerHTML = `
	<div>Border width</div><div><input id="borderWidth"  type="number" min="0" max="99" size="2"></div>
	<div>Border Colour</div><div class="input-color-container">
		<div class="color-well" id="borderColor"></div>
	</div>	
  	<div>Fill Colour</div><div class="input-color-container">
  		<div class="color-well" id="fillColor"></div>
	</div>`;
        (0, $e1c55b086cf8dd0e$export$cd571ca6d1702b73).createColorPicker('fillColor', ()=>this.update(), ()=>this.setParams());
        (0, $e1c55b086cf8dd0e$export$cd571ca6d1702b73).createColorPicker('borderColor', ()=>this.update(), ()=>this.setParams());
        let widthInput = (0, $gFW3W.elem)('borderWidth');
        widthInput.value = this.strokeWidth;
        widthInput.addEventListener('change', ()=>{
            this.update();
        });
        let borderColor = (0, $gFW3W.elem)('borderColor');
        borderColor.style.backgroundColor = this.stroke;
        let fillColor = (0, $gFW3W.elem)('fillColor');
        fillColor.style.backgroundColor = this.fill;
    }
});
/******************************************************************Line ********************************************/ let $a4a268d7686bbf3f$var$LineHandler = (0, $79564f678731bf19$exports.fabric).util.createClass((0, $79564f678731bf19$exports.fabric).Line, {
    type: 'line',
    initialize: function() {
        this.callSuper('initialize', {
            strokeWidth: 1,
            stroke: '#000000',
            strokeUniform: true
        });
        this.dragging = false;
        this.axes = false;
        this.dashed = false;
        this.id = (0, $gFW3W.uuidv4)();
        this.stroke = '#000000';
        this.strokeWidth = 2;
        this.strokeUniform = true;
    },
    pointerdown: function(e) {
        this.setParams();
        this.dragging = true;
        $a4a268d7686bbf3f$export$67ea982130081db.selection = false;
        this.start = $a4a268d7686bbf3f$export$67ea982130081db.getPointer(e);
        this.set({
            x1: this.start.x,
            y1: this.start.y,
            x2: this.start.x,
            y2: this.start.y
        });
        $a4a268d7686bbf3f$export$67ea982130081db.add(this);
    },
    pointermove: function(e) {
        if (!this.dragging) return;
        let endPoint = $a4a268d7686bbf3f$export$67ea982130081db.getPointer(e);
        let x2 = endPoint.x;
        let y2 = endPoint.y;
        let x1 = this.start.x;
        let y1 = this.start.y;
        if (this.axes) {
            if (x2 - x1 > y2 - y1) y2 = y1;
            else x2 = x1;
        }
        this.set({
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2
        });
        $a4a268d7686bbf3f$export$67ea982130081db.requestRenderAll();
    },
    pointerup: function() {
        this.dragging = false;
        $a4a268d7686bbf3f$var$currentObject = null;
        if (this.x1 === this.x2 && this.y1 === this.y2) return;
        $a4a268d7686bbf3f$var$saveChange(this, {
            axes: this.axes,
            strokeWidth: this.strokeWidth,
            stroke: this.stroke,
            strokeDashArray: this.strokeDashArray
        }, 'insert');
        $a4a268d7686bbf3f$export$67ea982130081db.selection = true;
        $a4a268d7686bbf3f$export$67ea982130081db.setActiveObject(this).requestRenderAll();
        $a4a268d7686bbf3f$var$unselectTool();
    },
    update: function() {
        this.setParams();
        $a4a268d7686bbf3f$var$saveChange(this, {
            axes: this.axes,
            strokeWidth: this.strokeWidth,
            stroke: this.stroke,
            strokeDashArray: this.strokeDashArray
        }, 'update');
    },
    setParams: function() {
        if (!(0, $gFW3W.elem)('optionsBox')) return;
        this.axes = (0, $gFW3W.elem)('axes').checked;
        if (this.axes) {
            if (this.x2 - this.x1 > this.y2 - this.y1) this.y2 = this.y1;
            else this.x2 = this.x1;
            this.set({
                x1: this.x1,
                y1: this.y1,
                x2: this.x2,
                y2: this.y2
            });
        }
        // if line is constrained to horizontal/vertical (axes is true),
        // don't display a rotate control point
        this.setControlsVisibility({
            mtr: !this.axes,
            bl: false,
            br: true,
            mb: false,
            ml: false,
            mr: false,
            mt: false,
            tl: true,
            tr: false
        });
        this.set({
            strokeWidth: parseInt((0, $gFW3W.elem)('lineWidth').value),
            stroke: (0, $gFW3W.elem)('lineColor').style.backgroundColor,
            strokeDashArray: (0, $gFW3W.elem)('dashed').checked ? [
                10,
                10
            ] : null
        });
        $a4a268d7686bbf3f$export$67ea982130081db.requestRenderAll();
    },
    optionsDialog: function() {
        if ((0, $gFW3W.elem)('optionsBox')) return;
        this.box = $a4a268d7686bbf3f$var$makeOptionsDialog('line');
        this.box.innerHTML = `
	<div>Line width</div><div><input id="lineWidth" type="number" min="0" max="99" size="1"></div>
	<div>Colour</div><div class="input-color-container">
		<div class="color-well" id="lineColor"></div>
	</div>
	<div>Dashed</div><div><input type="checkbox" id="dashed"></div>
	<div>Vert/Horiz</div><div><input type="checkbox" id="axes"></div>`;
        (0, $e1c55b086cf8dd0e$export$cd571ca6d1702b73).createColorPicker('lineColor', ()=>this.update(), ()=>this.setParams());
        let widthInput = (0, $gFW3W.elem)('lineWidth');
        widthInput.value = this.strokeWidth;
        widthInput.addEventListener('change', ()=>{
            this.update();
        });
        let lineColor = (0, $gFW3W.elem)('lineColor');
        lineColor.style.backgroundColor = this.stroke;
        let dashed = (0, $gFW3W.elem)('dashed');
        dashed.checked = this.strokeDashArray;
        dashed.addEventListener('change', ()=>{
            this.update();
        });
        let axes = (0, $gFW3W.elem)('axes');
        axes.checked = this.axes;
        this.setControlsVisibility(this.axes);
        axes.addEventListener('change', ()=>{
            this.update();
        });
    }
});
/******************************************************************Text ********************************************/ let $a4a268d7686bbf3f$var$TextHandler = (0, $79564f678731bf19$exports.fabric).util.createClass((0, $79564f678731bf19$exports.fabric).IText, {
    type: 'text',
    initialize: function() {
        this.callSuper('initialize', 'Text', {
            fontSize: 32,
            fill: '#000000',
            fontFamily: 'Oxygen'
        });
        this.id = (0, $gFW3W.uuidv4)();
    },
    pointerdown: function(e) {
        this.setParams();
        this.start = $a4a268d7686bbf3f$export$67ea982130081db.getPointer(e);
        this.left = this.start.x;
        this.top = this.start.y;
        this.fontFamily = 'Oxygen';
        $a4a268d7686bbf3f$export$67ea982130081db.add(this);
        $a4a268d7686bbf3f$export$67ea982130081db.setActiveObject(this).requestRenderAll();
        $a4a268d7686bbf3f$var$unselectTool();
        this.enterEditing();
        this.selectAll();
        this.on('editing:exited', ()=>{
            $a4a268d7686bbf3f$var$saveChange(this, {
                fontSize: this.fontSize,
                fill: this.fill,
                fontFamily: 'Oxygen',
                text: this.text
            }, 'insert');
        });
    },
    pointermove: function() {
        return;
    },
    pointerup: function() {
        return;
    },
    update: function() {
        this.setParams();
        $a4a268d7686bbf3f$var$saveChange(this, {
            fontSize: this.fontSize,
            fill: this.fill,
            text: this.text
        }, 'update');
    },
    setParams: function() {
        if (!(0, $gFW3W.elem)('optionsBox')) return;
        this.set({
            fontSize: parseInt((0, $gFW3W.elem)('fontSize').value),
            fill: (0, $gFW3W.elem)('fontColor').style.backgroundColor
        });
        $a4a268d7686bbf3f$export$67ea982130081db.requestRenderAll();
    },
    optionsDialog: function() {
        if (!(0, $gFW3W.elem)('optionsBox')) {
            this.box = $a4a268d7686bbf3f$var$makeOptionsDialog('text');
            this.box.innerHTML = `
	<div>Size</div><div><input id="fontSize"  type="number" min="0" max="99" size="2"></div>
	<div>Colour</div><div class="input-color-container">
		<div class="color-well" id="fontColor"></div>
	</div>`;
            (0, $e1c55b086cf8dd0e$export$cd571ca6d1702b73).createColorPicker('fontColor', ()=>this.update(), ()=>this.setParams());
        }
        let fontSizeInput = (0, $gFW3W.elem)('fontSize');
        fontSizeInput.value = parseInt(this.fontSize);
        fontSizeInput.addEventListener('change', ()=>{
            this.update();
        });
        let fontColor = (0, $gFW3W.elem)('fontColor');
        fontColor.style.backgroundColor = this.fill;
    }
});
/******************************************************************Pencil ********************************************/ let $a4a268d7686bbf3f$var$PencilHandler = (0, $79564f678731bf19$exports.fabric).util.createClass((0, $79564f678731bf19$exports.fabric).Object, {
    type: 'pencil',
    initialize: function() {
        this.callSuper('initialize', {
            width: 1,
            color: '#000000'
        });
        $a4a268d7686bbf3f$export$67ea982130081db.freeDrawingBrush.width = 1;
        $a4a268d7686bbf3f$export$67ea982130081db.freeDrawingBrush.color = '#000000';
    },
    pointerdown: function() {
        this.setParams();
    },
    pointermove: function() {},
    pointerup: function() {},
    update: function() {
        this.setParams();
        let pathObj = $a4a268d7686bbf3f$var$getLastPath();
        $a4a268d7686bbf3f$var$saveChange(pathObj, {
            path: pathObj.path
        }, 'update');
    },
    setParams: function() {
        if (!(0, $gFW3W.elem)('optionsBox')) return;
        this.width = parseInt((0, $gFW3W.elem)('pencilWidth').value);
        this.color = (0, $gFW3W.elem)('pencilColor').style.backgroundColor;
        $a4a268d7686bbf3f$export$67ea982130081db.freeDrawingBrush.width = this.width;
        $a4a268d7686bbf3f$export$67ea982130081db.freeDrawingBrush.color = this.color;
        $a4a268d7686bbf3f$export$67ea982130081db.requestRenderAll();
    },
    optionsDialog: function() {
        if (!(0, $gFW3W.elem)('optionsBox')) {
            this.box = $a4a268d7686bbf3f$var$makeOptionsDialog('pencil');
            this.box.innerHTML = `
		<div>Width</div><div><input id="pencilWidth"  type="number" min="0" max="99" size="2"></div>
		<div>Colour</div><div class="input-color-container">
			<div class="color-well" id="pencilColor"></div>
		</div>`;
            (0, $e1c55b086cf8dd0e$export$cd571ca6d1702b73).createColorPicker('pencilColor', ()=>this.update(), ()=>this.setParams());
        }
        let widthInput = document.getElementById('pencilWidth');
        widthInput.value = this.width;
        widthInput.addEventListener('change', ()=>{
            this.update();
        });
        let pencilColor = document.getElementById('pencilColor');
        pencilColor.style.backgroundColor = this.color;
    }
});
/******************************************************************Marker ********************************************/ let $a4a268d7686bbf3f$var$MarkerHandler = (0, $79564f678731bf19$exports.fabric).util.createClass((0, $79564f678731bf19$exports.fabric).Object, {
    type: 'marker',
    initialize: function() {
        this.callSuper('initialize', {
            width: 30,
            color: 'rgba(249, 255, 71, 0.5)',
            strokeLineCap: 'square',
            strokeLineJoin: 'bevel'
        });
        $a4a268d7686bbf3f$export$67ea982130081db.freeDrawingBrush.width = 30;
        $a4a268d7686bbf3f$export$67ea982130081db.freeDrawingBrush.color = 'rgba(249, 255, 71, 0.5)';
    },
    pointerdown: function() {
        this.setParams();
    },
    pointermove: function() {},
    pointerup: function() {},
    update: function() {
        this.setParams();
        $a4a268d7686bbf3f$var$saveChange($a4a268d7686bbf3f$var$getLastPath(), {}, 'update');
    },
    setParams: function() {
        if (!(0, $gFW3W.elem)('optionsBox')) return;
        this.width = parseInt((0, $gFW3W.elem)('pencilWidth').value);
        this.color = (0, $gFW3W.elem)('pencilColor').style.backgroundColor;
        $a4a268d7686bbf3f$export$67ea982130081db.freeDrawingBrush.width = this.width;
        $a4a268d7686bbf3f$export$67ea982130081db.freeDrawingBrush.color = this.color;
        $a4a268d7686bbf3f$export$67ea982130081db.requestRenderAll();
    },
    optionsDialog: function() {
        if (!(0, $gFW3W.elem)('optionsBox')) {
            this.box = $a4a268d7686bbf3f$var$makeOptionsDialog('marker');
            this.box.innerHTML = `		
			<div>Width</div><div><input id="pencilWidth"  type="number" min="0" max="99" size="2"></div>
			<div>Colour</div><div class="input-color-container">
			<div class="color-well" id="pencilColor"></div>
		</div>`;
            (0, $e1c55b086cf8dd0e$export$cd571ca6d1702b73).createColorPicker('pencilColor', ()=>this.update(), ()=>this.setParams());
        }
        let widthInput = document.getElementById('pencilWidth');
        widthInput.value = this.width;
        widthInput.addEventListener('change', ()=>{
            this.update();
        });
        let pencilColor = document.getElementById('pencilColor');
        pencilColor.style.backgroundColor = this.color;
    }
});
/**
 * called after a pencil or marker has been used to retrieve the path object that it created
 * @returns fabric path object
 */ function $a4a268d7686bbf3f$var$getLastPath() {
    let objs = $a4a268d7686bbf3f$export$67ea982130081db.getObjects();
    let path = objs[objs.length - 1];
    if (!path || path.type !== 'path') throw 'Last path is not a path';
    return path;
}
/******************************************************************Image ********************************************/ let $a4a268d7686bbf3f$var$ImageHandler = (0, $79564f678731bf19$exports.fabric).util.createClass((0, $79564f678731bf19$exports.fabric).Object, {
    type: 'image',
    initialize: function() {
        this.callSuper('initialize', {});
    },
    loadImage: function(e) {
        if (e.target.files) {
            let file = e.target.files[0];
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = function(e) {
                let image = new Image();
                image.onload = function(e) {
                    let imageElement = e.target;
                    // display image centred on viewport with max dimensions 300 x 300
                    if (imageElement.width > imageElement.height) {
                        if (imageElement.width > 300) imageElement.width = 300;
                    } else if (imageElement.height > 300) imageElement.height = 300;
                    this.imageInstance = new (0, $79564f678731bf19$exports.fabric).Image(imageElement);
                    this.imageInstance.set({
                        originX: 'center',
                        originY: 'center'
                    });
                    this.imageInstance.viewportCenter();
                    this.imageInstance.setCoords();
                    this.imageInstance.id = (0, $gFW3W.uuidv4)();
                    $a4a268d7686bbf3f$export$67ea982130081db.add(this.imageInstance);
                    $a4a268d7686bbf3f$var$saveChange(this.imageInstance, {}, 'insert');
                    $a4a268d7686bbf3f$var$unselectTool();
                    $a4a268d7686bbf3f$export$67ea982130081db.setActiveObject(this.imageInstance).requestRenderAll();
                };
                image.src = e.target.result;
            };
        }
    },
    pointerdown: function() {},
    pointermove: function() {},
    pointerup: function() {},
    update: function() {},
    optionsDialog: function() {}
});
/****************************************************************** Group ********************************************/ function $a4a268d7686bbf3f$var$makeGroup() {
    let activeObj = $a4a268d7686bbf3f$export$67ea982130081db.getActiveObject();
    if (!activeObj || activeObj.type !== 'activeSelection') return;
    let group = activeObj.toGroup();
    group.id = (0, $gFW3W.uuidv4)();
    group.members = group.getObjects().map((ob)=>ob.id);
    group.type = 'group';
    $a4a268d7686bbf3f$var$setGroupBorderColor(group);
    $a4a268d7686bbf3f$var$saveChange(group, {
        members: group.members
    }, 'insert');
    $a4a268d7686bbf3f$export$67ea982130081db.requestRenderAll();
    (0, $gFW3W.elem)('group').classList.remove('disabled');
    (0, $gFW3W.alertMsg)('Grouped', 'info');
}
function $a4a268d7686bbf3f$var$unGroup() {
    let activeObj = $a4a268d7686bbf3f$export$67ea982130081db.getActiveObject();
    if (!activeObj || activeObj.type !== 'group') return;
    let members = activeObj.getObjects();
    activeObj.toActiveSelection();
    $a4a268d7686bbf3f$var$saveChange(activeObj, {
        type: 'ungroup',
        members: members.map((ob)=>ob.id)
    }, 'delete');
    $a4a268d7686bbf3f$export$67ea982130081db.discardActiveObject();
    $a4a268d7686bbf3f$export$67ea982130081db.requestRenderAll();
    (0, $gFW3W.alertMsg)('Ungrouped', 'info');
}
function $a4a268d7686bbf3f$var$setGroupBorderColor(group) {
    group.borderColor = 'green';
    group.cornerColor = 'green';
}
/****************************************************** Bin (delete) ********************************************/ let $a4a268d7686bbf3f$var$DeleteHandler = (0, $79564f678731bf19$exports.fabric).util.createClass((0, $79564f678731bf19$exports.fabric).Object, {
    type: 'bin',
    initialize: function() {
        this.callSuper('initialize', {});
    },
    delete: function() {
        $a4a268d7686bbf3f$var$deleteActiveObjects();
        $a4a268d7686bbf3f$var$unselectTool();
    },
    pointerdown: function() {},
    pointermove: function() {},
    pointerup: function() {},
    optionsDialog: function() {}
});
/**
 * catch and branch to a handler for special Key commands
 * Delete, ^z (undo) and ^y (redo)
 * @param {event} e
 */ function $a4a268d7686bbf3f$var$checkKey(e) {
    //e.preventDefault()
    if (e.keyCode === 46 || e.key === 'Delete' || e.code === 'Delete' || e.key === 'Backspace') $a4a268d7686bbf3f$var$deleteActiveObjects();
    if ((e.ctrlKey || e.metaKey) && (e.key === 'z' || e.key === 'Z')) {
        $a4a268d7686bbf3f$var$currentObject = null;
        $a4a268d7686bbf3f$var$toolHandler('undo').undo();
    }
    if ((e.ctrlKey || e.metaKey) && (e.key === 'y' || e.key === 'Y')) {
        $a4a268d7686bbf3f$var$currentObject = null;
        $a4a268d7686bbf3f$var$toolHandler('undo').redo();
    }
}
/**
 * makes the active object invisible (unless it is a group, which is actually deleted)
 * this allows 'undo' to re-instate the object, by making it visible
 */ function $a4a268d7686bbf3f$var$deleteActiveObjects() {
    $a4a268d7686bbf3f$export$67ea982130081db.getActiveObjects().forEach((obj)=>{
        if (obj.isEditing) return;
        obj.set('visible', false);
        $a4a268d7686bbf3f$var$saveChange(obj, {
            visible: false
        }, 'delete');
        if (obj.type === 'group') obj.forEachObject((member)=>{
            member.set('visible', false);
            $a4a268d7686bbf3f$export$67ea982130081db.add(member);
            $a4a268d7686bbf3f$var$saveChange(member, {
                visible: false
            }, 'delete');
        });
    });
    $a4a268d7686bbf3f$export$67ea982130081db.discardActiveObject().requestRenderAll();
}
/******************************************************************Undo ********************************************/ let $a4a268d7686bbf3f$var$UndoHandler = (0, $79564f678731bf19$exports.fabric).util.createClass((0, $79564f678731bf19$exports.fabric).Object, {
    type: 'undo',
    initialize: function() {
        this.callSuper('initialize', {});
    },
    undo: function() {
        if ($a4a268d7686bbf3f$var$undos.length === 0) return; // nothing on the undo stack
        let undo = $a4a268d7686bbf3f$var$undos.pop();
        (0, $e1c55b086cf8dd0e$export$da7062de5ac36f9c).set('undos', $a4a268d7686bbf3f$var$undos);
        if ($a4a268d7686bbf3f$var$undos.length === 0) (0, $gFW3W.elem)('undotool').classList.add('disabled');
        if (undo.id === 'selection') {
            $a4a268d7686bbf3f$var$redos.push((0, $gFW3W.deepCopy)(undo));
            (0, $e1c55b086cf8dd0e$export$da7062de5ac36f9c).set('redos', $a4a268d7686bbf3f$var$redos);
            (0, $gFW3W.elem)('redotool').classList.remove('disabled');
            switch(undo.op){
                case 'add':
                    // reverse of add selection is dispose of it
                    $a4a268d7686bbf3f$export$67ea982130081db.discardActiveObject();
                    $a4a268d7686bbf3f$var$updateActiveButtons();
                    break;
                case 'update':
                    {
                        let prevSelParams = $a4a268d7686bbf3f$var$undos.findLast((d)=>d.id === 'selection').params;
                        $a4a268d7686bbf3f$export$67ea982130081db.getActiveObject().set({
                            angle: prevSelParams.angle,
                            left: prevSelParams.left,
                            scaleX: prevSelParams.scaleX,
                            scaleY: prevSelParams.scaleY,
                            top: prevSelParams.top
                        });
                    }
                    break;
                case 'discard':
                    {
                        // reverse of discard selection is add it
                        let selectedObjects = undo.params.oldMembers.map((id)=>$a4a268d7686bbf3f$export$67ea982130081db.getObjects().find((o)=>o.id === id));
                        let sel = new (0, $79564f678731bf19$exports.fabric).ActiveSelection(selectedObjects, {
                            canvas: $a4a268d7686bbf3f$export$67ea982130081db
                        });
                        $a4a268d7686bbf3f$export$67ea982130081db.setActiveObject(sel);
                        $a4a268d7686bbf3f$var$updateActiveButtons();
                    }
                    break;
            }
            $a4a268d7686bbf3f$export$67ea982130081db.requestRenderAll();
            return;
        }
        if (undo.params.type === 'group' || undo.params.type === 'ungroup') {
            $a4a268d7686bbf3f$var$redos.push((0, $gFW3W.deepCopy)(undo));
            (0, $e1c55b086cf8dd0e$export$da7062de5ac36f9c).set('redos', $a4a268d7686bbf3f$var$redos);
            (0, $gFW3W.elem)('redotool').classList.remove('disabled');
            let obj = $a4a268d7686bbf3f$export$67ea982130081db.getObjects().filter((o)=>o.id === undo.id)[0];
            switch(undo.op){
                case 'insert':
                    // reverse of add group is dispose of it
                    obj.set('visible', false);
                    $a4a268d7686bbf3f$var$saveChange(obj, {
                        members: undo.params.members,
                        type: 'group'
                    }, null);
                    $a4a268d7686bbf3f$export$67ea982130081db.discardActiveObject();
                    $a4a268d7686bbf3f$var$updateActiveButtons();
                    break;
                case 'update':
                    {
                        // find the previous param set for this group, and set the object to those params
                        let prevDelta = $a4a268d7686bbf3f$var$undos.findLast((d)=>d.id === undo.id);
                        obj.setOptions(prevDelta.params);
                        obj.setCoords();
                        $a4a268d7686bbf3f$var$saveChange(obj, prevDelta.params, null);
                    }
                    break;
                case 'delete':
                    // reverse of delete group is add it
                    $a4a268d7686bbf3f$export$67ea982130081db.discardActiveObject();
                    obj.set('visible', true);
                    $a4a268d7686bbf3f$var$saveChange(obj, {
                        members: undo.params.members,
                        type: 'group'
                    }, null);
                    $a4a268d7686bbf3f$export$67ea982130081db.setActiveObject(obj);
                    $a4a268d7686bbf3f$var$updateActiveButtons();
                    break;
            }
            $a4a268d7686bbf3f$export$67ea982130081db.requestRenderAll();
            return;
        }
        // find the object to be undone from its id
        let obj = $a4a268d7686bbf3f$export$67ea982130081db.getObjects().find((o)=>o.id === undo.id);
        // get the current state of the object, so that redo can return it to this state
        let newParams = {};
        for(const prop in undo.params)newParams[prop] = obj[prop];
        $a4a268d7686bbf3f$var$redos.push({
            id: undo.id,
            params: newParams,
            op: undo.op
        });
        (0, $e1c55b086cf8dd0e$export$da7062de5ac36f9c).set('redos', $a4a268d7686bbf3f$var$redos);
        (0, $gFW3W.elem)('redotool').classList.remove('disabled');
        switch(undo.op){
            case 'insert':
                obj.set('visible', false);
                $a4a268d7686bbf3f$var$saveChange(obj, {
                    visible: false
                }, null);
                break;
            case 'delete':
                obj.set('visible', true);
                $a4a268d7686bbf3f$var$saveChange(obj, {
                    visible: true
                }, null);
                break;
            case 'update':
                {
                    // find the previous param set for this object, and set the object to those params
                    let prevDelta = $a4a268d7686bbf3f$var$undos.findLast((d)=>d.id === obj.id);
                    obj.set('visible', true);
                    obj.setOptions(prevDelta.params);
                    obj.setCoords();
                    $a4a268d7686bbf3f$var$saveChange(obj, Object.assign(prevDelta.params, {
                        visible: true
                    }), null);
                }
                break;
        }
        $a4a268d7686bbf3f$export$67ea982130081db.discardActiveObject().requestRenderAll();
    },
    redo: function() {
        if ($a4a268d7686bbf3f$var$redos.length === 0) return;
        let redo = $a4a268d7686bbf3f$var$redos.pop();
        (0, $e1c55b086cf8dd0e$export$da7062de5ac36f9c).set('redos', $a4a268d7686bbf3f$var$redos);
        if ($a4a268d7686bbf3f$var$redos.length === 0) (0, $gFW3W.elem)('redotool').classList.add('disabled');
        if (redo.id === 'selection') {
            $a4a268d7686bbf3f$var$undos.push((0, $gFW3W.deepCopy)(redo));
            (0, $e1c55b086cf8dd0e$export$da7062de5ac36f9c).set('undos', $a4a268d7686bbf3f$var$undos);
            (0, $gFW3W.elem)('undotool').classList.remove('disabled');
            switch(redo.op){
                case 'add':
                    {
                        let selectedObjects = redo.params.members.map((id)=>$a4a268d7686bbf3f$export$67ea982130081db.getObjects().find((o)=>o.id === id));
                        let sel = new (0, $79564f678731bf19$exports.fabric).ActiveSelection(selectedObjects, {
                            canvas: $a4a268d7686bbf3f$export$67ea982130081db
                        });
                        $a4a268d7686bbf3f$export$67ea982130081db.setActiveObject(sel);
                        $a4a268d7686bbf3f$var$updateActiveButtons();
                    }
                    break;
                case 'update':
                    $a4a268d7686bbf3f$export$67ea982130081db.getActiveObject().set({
                        angle: redo.params.angle,
                        left: redo.params.left,
                        scaleX: redo.params.scaleX,
                        scaleY: redo.params.scaleY,
                        top: redo.params.top
                    });
                    break;
                case 'discard':
                    $a4a268d7686bbf3f$export$67ea982130081db.discardActiveObject();
                    $a4a268d7686bbf3f$var$updateActiveButtons();
                    break;
            }
            $a4a268d7686bbf3f$export$67ea982130081db.requestRenderAll();
            return;
        }
        if (redo.params.type === 'group' || redo.params.type === 'ungroup') {
            $a4a268d7686bbf3f$var$undos.push((0, $gFW3W.deepCopy)(redo));
            (0, $e1c55b086cf8dd0e$export$da7062de5ac36f9c).set('undos', $a4a268d7686bbf3f$var$undos);
            (0, $gFW3W.elem)('undotool').classList.remove('disabled');
            let obj = $a4a268d7686bbf3f$export$67ea982130081db.getObjects().filter((o)=>o.id === redo.id)[0];
            switch(redo.op){
                case 'delete':
                    // reverse of add group is dispose of it
                    obj.set('visible', false);
                    $a4a268d7686bbf3f$var$saveChange(obj, {
                        members: redo.params.members,
                        type: 'group'
                    }, null);
                    $a4a268d7686bbf3f$export$67ea982130081db.discardActiveObject();
                    $a4a268d7686bbf3f$var$updateActiveButtons();
                    break;
                case 'update':
                    {
                        // find the previous param set for this group, and set the object to those params
                        let prevDelta = $a4a268d7686bbf3f$var$undos.findLast((d)=>d.id === redo.id);
                        obj.setOptions(prevDelta.params);
                        obj.setCoords();
                        $a4a268d7686bbf3f$var$saveChange(obj, prevDelta.params, null);
                    }
                    break;
                case 'insert':
                    // reverse of delete group is add it
                    $a4a268d7686bbf3f$export$67ea982130081db.discardActiveObject();
                    obj.set('visible', true);
                    $a4a268d7686bbf3f$var$saveChange(obj, {
                        members: redo.params.members,
                        type: 'group'
                    }, null);
                    $a4a268d7686bbf3f$export$67ea982130081db.setActiveObject(obj);
                    $a4a268d7686bbf3f$var$updateActiveButtons();
                    break;
            }
            $a4a268d7686bbf3f$export$67ea982130081db.requestRenderAll();
            return;
        }
        let obj = $a4a268d7686bbf3f$export$67ea982130081db.getObjects().find((o)=>o.id === redo.id);
        let newParams = {};
        for(const prop in redo.params)newParams[prop] = obj[prop];
        $a4a268d7686bbf3f$var$undos.push({
            id: redo.id,
            params: newParams,
            op: redo.op
        });
        (0, $e1c55b086cf8dd0e$export$da7062de5ac36f9c).set('undos', $a4a268d7686bbf3f$var$undos);
        (0, $gFW3W.elem)('undotool').classList.remove('disabled');
        switch(redo.op){
            case 'insert':
                obj.set('visible', true);
                $a4a268d7686bbf3f$var$saveChange(obj, {
                    visible: true
                }, null);
                break;
            case 'delete':
                obj.set('visible', false);
                $a4a268d7686bbf3f$var$saveChange(obj, {
                    visible: false
                }, null);
                break;
            case 'update':
                obj.setOptions(redo.params);
                obj.setCoords();
                $a4a268d7686bbf3f$var$saveChange(obj, Object.assign(redo.params, {
                    visible: true
                }), null);
                break;
        }
        $a4a268d7686bbf3f$export$67ea982130081db.discardActiveObject().requestRenderAll();
    }
});
/****************************************************************** Broadcast ********************************************/ /**
 * Broadcast the changes to other clients and
 * save the current state of the object on the undo stack
 * @param {String} obj the object
 * @param {Object} params the current state
 * @param {String} op insert|delete|update|null (if null, don't save on the undo stack)
 */ function $a4a268d7686bbf3f$var$saveChange(obj, params = {}, op) {
    // save current object position as well as any format changes
    params = $a4a268d7686bbf3f$var$setParams(obj, params);
    // send the object to other clients
    (0, $e1c55b086cf8dd0e$export$da7062de5ac36f9c).set(obj.id, params);
    //check whether the order of objects has changed; if so, save the new order
    let oldSequence = (0, $e1c55b086cf8dd0e$export$da7062de5ac36f9c).get('sequence');
    let newSequence = $a4a268d7686bbf3f$export$67ea982130081db.getObjects().map((obj)=>obj.id);
    let different = true;
    if (oldSequence) {
        different = newSequence.length !== oldSequence.length;
        if (!different) {
            for(let i = 0; i < oldSequence.length; i++)if (newSequence[i] !== oldSequence[i]) {
                different = true;
                break;
            }
        }
    }
    if (different) (0, $e1c55b086cf8dd0e$export$da7062de5ac36f9c).set('sequence', newSequence);
    // save the change on the undo stack
    if (op) {
        $a4a268d7686bbf3f$var$undos.push({
            op: op,
            id: obj.id,
            params: params
        });
        (0, $e1c55b086cf8dd0e$export$da7062de5ac36f9c).set('undos', $a4a268d7686bbf3f$var$undos);
        (0, $gFW3W.elem)('undotool').classList.remove('disabled');
    }
    // count the number of changes, so we can log that the background has changed
    $a4a268d7686bbf3f$export$f2efb2348b1e4771++;
}
/**
 * Collect the parameters that would allow the reproduction of the object
 * @param {object} obj - fabric object
 * @param {object} params - initial parameters
 * @returns params
 */ function $a4a268d7686bbf3f$var$setParams(obj, params) {
    if (obj.cacheProperties) obj.cacheProperties.forEach((p)=>params[p] = obj[p]);
    params.left = params.left || obj.left;
    params.top = params.top || obj.top;
    params.angle = obj.angle;
    params.scaleX = obj.scaleX;
    params.scaleY = obj.scaleY;
    params.type = params.type || obj.type;
    if (obj.type === 'path') params.pathOffset = obj.pathOffset;
    if (obj.type === 'image') params.imageObj = obj.toObject();
    if (obj.type === 'group' || obj.type === 'activeSelection') params.members = obj.members;
    return params;
}
/************************************************** Smart Guides ********************************************/ const $a4a268d7686bbf3f$var$aligningLineOffset = 5;
const $a4a268d7686bbf3f$var$aligningLineMargin = 4;
const $a4a268d7686bbf3f$var$aligningLineWidth = 1;
const $a4a268d7686bbf3f$var$aligningLineColor = 'rgb(255,0,0)';
const $a4a268d7686bbf3f$var$aligningDash = [
    5,
    5
];
function $a4a268d7686bbf3f$var$initAligningGuidelines() {
    let ctx = $a4a268d7686bbf3f$export$67ea982130081db.getSelectionContext();
    let viewportTransform;
    let zoom = 1;
    let verticalLines = [];
    let horizontalLines = [];
    $a4a268d7686bbf3f$export$67ea982130081db.on('mouse:down', function() {
        viewportTransform = $a4a268d7686bbf3f$export$67ea982130081db.viewportTransform;
        zoom = $a4a268d7686bbf3f$export$67ea982130081db.getZoom();
    });
    $a4a268d7686bbf3f$export$67ea982130081db.on('object:moving', function(e) {
        if (!$a4a268d7686bbf3f$export$67ea982130081db._currentTransform) return;
        let activeObject = e.target;
        let activeObjectCenter = activeObject.getCenterPoint();
        let activeObjectBoundingRect = activeObject.getBoundingRect();
        let activeObjectHalfHeight = activeObjectBoundingRect.height / (2 * viewportTransform[3]);
        let activeObjectHalfWidth = activeObjectBoundingRect.width / (2 * viewportTransform[0]);
        $a4a268d7686bbf3f$export$67ea982130081db.getObjects().filter((object)=>object !== activeObject && object.visible).forEach((object)=>{
            let objectCenter = object.getCenterPoint();
            let objectBoundingRect = object.getBoundingRect();
            let objectHalfHeight = objectBoundingRect.height / (2 * viewportTransform[3]);
            let objectHalfWidth = objectBoundingRect.width / (2 * viewportTransform[0]);
            // snap by the horizontal center line
            snapVertical(objectCenter.x, activeObjectCenter.x, objectCenter.x);
            // snap by the left object edge matching left active edge
            snapVertical(objectCenter.x - objectHalfWidth, activeObjectCenter.x - activeObjectHalfWidth, objectCenter.x - objectHalfWidth + activeObjectHalfWidth);
            // snap by the left object edge matching right active edge
            snapVertical(objectCenter.x - objectHalfWidth, activeObjectCenter.x + activeObjectHalfWidth, objectCenter.x - objectHalfWidth - activeObjectHalfWidth);
            // snap by the right object edge matching right active edge
            snapVertical(objectCenter.x + objectHalfWidth, activeObjectCenter.x + activeObjectHalfWidth, objectCenter.x + objectHalfWidth - activeObjectHalfWidth);
            // snap by the right object edge matching left active edge
            snapVertical(objectCenter.x + objectHalfWidth, activeObjectCenter.x - activeObjectHalfWidth, objectCenter.x + objectHalfWidth + activeObjectHalfWidth);
            function snapVertical(objEdge, activeEdge, snapCenter) {
                if (isInRange(objEdge, activeEdge)) {
                    verticalLines.push({
                        x: objEdge,
                        y1: objectCenter.y < activeObjectCenter.y ? objectCenter.y - objectHalfHeight - $a4a268d7686bbf3f$var$aligningLineOffset : objectCenter.y + objectHalfHeight + $a4a268d7686bbf3f$var$aligningLineOffset,
                        y2: activeObjectCenter.y > objectCenter.y ? activeObjectCenter.y + activeObjectHalfHeight + $a4a268d7686bbf3f$var$aligningLineOffset : activeObjectCenter.y - activeObjectHalfHeight - $a4a268d7686bbf3f$var$aligningLineOffset
                    });
                    activeObject.setPositionByOrigin(new (0, $79564f678731bf19$exports.fabric).Point(snapCenter, activeObjectCenter.y), 'center', 'center');
                }
            }
            // snap by the vertical center line
            snapHorizontal(objectCenter.y, activeObjectCenter.y, objectCenter.y);
            // snap by the top object edge matching the top active edge
            snapHorizontal(objectCenter.y - objectHalfHeight, activeObjectCenter.y - activeObjectHalfHeight, objectCenter.y - objectHalfHeight + activeObjectHalfHeight);
            // snap by the top object edge matching the bottom active edge
            snapHorizontal(objectCenter.y - objectHalfHeight, activeObjectCenter.y + activeObjectHalfHeight, objectCenter.y - objectHalfHeight - activeObjectHalfHeight);
            // snap by the bottom object edge matching the bottom active edge
            snapHorizontal(objectCenter.y + objectHalfHeight, activeObjectCenter.y + activeObjectHalfHeight, objectCenter.y + objectHalfHeight - activeObjectHalfHeight);
            // snap by the bottom object edge matching the top active edge
            snapHorizontal(objectCenter.y + objectHalfHeight, activeObjectCenter.y - activeObjectHalfHeight, objectCenter.y + objectHalfHeight + activeObjectHalfHeight);
            function snapHorizontal(objEdge, activeObjEdge, snapCenter) {
                if (isInRange(objEdge, activeObjEdge)) {
                    horizontalLines.push({
                        y: objEdge,
                        x1: objectCenter.x < activeObjectCenter.x ? objectCenter.x - objectHalfWidth - $a4a268d7686bbf3f$var$aligningLineOffset : objectCenter.x + objectHalfWidth + $a4a268d7686bbf3f$var$aligningLineOffset,
                        x2: activeObjectCenter.x > objectCenter.x ? activeObjectCenter.x + activeObjectHalfWidth + $a4a268d7686bbf3f$var$aligningLineOffset : activeObjectCenter.x - activeObjectHalfWidth - $a4a268d7686bbf3f$var$aligningLineOffset
                    });
                    activeObject.setPositionByOrigin(new (0, $79564f678731bf19$exports.fabric).Point(activeObjectCenter.x, snapCenter), 'center', 'center');
                }
            }
        });
    });
    $a4a268d7686bbf3f$export$67ea982130081db.on('after:render', function() {
        verticalLines.forEach((line)=>drawVerticalLine(line));
        horizontalLines.forEach((line)=>drawHorizontalLine(line));
        verticalLines = [];
        horizontalLines = [];
    });
    $a4a268d7686bbf3f$export$67ea982130081db.on('mouse:up', function() {
        $a4a268d7686bbf3f$export$67ea982130081db.requestRenderAll();
    });
    function drawVerticalLine(coords) {
        drawLine(coords.x + 0.5, coords.y1 > coords.y2 ? coords.y2 : coords.y1, coords.x + 0.5, coords.y2 > coords.y1 ? coords.y2 : coords.y1);
    }
    function drawHorizontalLine(coords) {
        drawLine(coords.x1 > coords.x2 ? coords.x2 : coords.x1, coords.y + 0.5, coords.x2 > coords.x1 ? coords.x2 : coords.x1, coords.y + 0.5);
    }
    function drawLine(x1, y1, x2, y2) {
        ctx.save();
        ctx.lineWidth = $a4a268d7686bbf3f$var$aligningLineWidth;
        ctx.strokeStyle = $a4a268d7686bbf3f$var$aligningLineColor;
        ctx.setLineDash($a4a268d7686bbf3f$var$aligningDash);
        ctx.beginPath();
        ctx.moveTo(x1 * zoom + viewportTransform[4], y1 * zoom + viewportTransform[5]);
        ctx.lineTo(x2 * zoom + viewportTransform[4], y2 * zoom + viewportTransform[5]);
        ctx.stroke();
        ctx.restore();
    }
    /**
	 * return true if value2 is within value1 +/- aligningLineMargin
	 * @param {number} value1
	 * @param {number} value2
	 * @returns Boolean
	 */ function isInRange(value1, value2) {
        return value2 > value1 - $a4a268d7686bbf3f$var$aligningLineMargin && value2 < value1 + $a4a268d7686bbf3f$var$aligningLineMargin;
    }
}
/*************************************copy & paste ********************************************/ var $a4a268d7686bbf3f$var$displacement = 0;
function $a4a268d7686bbf3f$export$adee94ba21be2b8e(event) {
    if (document.getSelection().toString()) return; // only copy factors if there is no text selected (e.g. in Notes)
    let activeObjs = $a4a268d7686bbf3f$export$67ea982130081db.getActiveObjects();
    if (activeObjs.length === 0) return;
    event.preventDefault();
    let group = $a4a268d7686bbf3f$export$67ea982130081db.getActiveObject();
    let groupLeft = 0;
    let groupTop = 0;
    // if the active Object is a group, then the component object positions are relative to the
    // group top, left, not to the canvas.  Compensate for this
    if (group.type === 'activeSelection' || group.type === 'group') {
        groupTop = group.top + group.height / 2;
        groupLeft = group.left + group.width / 2;
    }
    $a4a268d7686bbf3f$var$copyText(JSON.stringify(activeObjs.map((obj)=>$a4a268d7686bbf3f$var$setParams(obj, {
            left: obj.left + groupLeft,
            top: obj.top + groupTop
        }))));
    $a4a268d7686bbf3f$var$displacement = 0;
}
async function $a4a268d7686bbf3f$var$copyText(text) {
    try {
        if (typeof navigator.clipboard.writeText !== 'function') throw new Error('navigator.clipboard.writeText not a function');
    } catch (e) {
        (0, $gFW3W.alertMsg)('Copying not implemented in this browser', 'error');
        return false;
    }
    try {
        await navigator.clipboard.writeText(text);
        (0, $gFW3W.alertMsg)('Copied', 'info');
        return true;
    } catch (err) {
        console.error('Failed to copy: ', err);
        (0, $gFW3W.alertMsg)('Copy failed', 'error');
        return false;
    }
}
async function $a4a268d7686bbf3f$export$8b0e49c4b227c2a() {
    let clip = await $a4a268d7686bbf3f$var$getClipboardContents();
    let paramsArray = JSON.parse(clip);
    $a4a268d7686bbf3f$export$67ea982130081db.discardActiveObject();
    $a4a268d7686bbf3f$var$displacement += 10;
    for (let params of paramsArray){
        let copiedObj;
        switch(params.type){
            case 'rect':
                copiedObj = new $a4a268d7686bbf3f$var$RectHandler();
                break;
            case 'circle':
                copiedObj = new $a4a268d7686bbf3f$var$CircleHandler();
                break;
            case 'line':
                copiedObj = new $a4a268d7686bbf3f$var$LineHandler();
                break;
            case 'text':
                copiedObj = new $a4a268d7686bbf3f$var$TextHandler();
                break;
            case 'path':
                copiedObj = new (0, $79564f678731bf19$exports.fabric).Path();
                break;
            case 'image':
                (0, $79564f678731bf19$exports.fabric).Image.fromObject(params.imageObj, (image)=>{
                    image.set({
                        left: params.left + $a4a268d7686bbf3f$var$displacement,
                        top: params.top + $a4a268d7686bbf3f$var$displacement,
                        id: (0, $gFW3W.uuidv4)()
                    });
                    $a4a268d7686bbf3f$export$67ea982130081db.add(image);
                    $a4a268d7686bbf3f$export$67ea982130081db.setActiveObject(image);
                    $a4a268d7686bbf3f$var$saveChange(image, {
                        imageObj: image.toObject()
                    }, 'insert');
                });
                continue;
            default:
                throw `bad fabric object type in pasteFromClipboard: ${params.type}`;
        }
        copiedObj.setOptions(params);
        copiedObj.left += $a4a268d7686bbf3f$var$displacement;
        copiedObj.top += $a4a268d7686bbf3f$var$displacement;
        copiedObj.id = (0, $gFW3W.uuidv4)();
        $a4a268d7686bbf3f$export$67ea982130081db.add(copiedObj);
        $a4a268d7686bbf3f$export$67ea982130081db.setActiveObject(copiedObj);
        $a4a268d7686bbf3f$var$saveChange(copiedObj, {}, 'insert');
    }
    (0, $gFW3W.alertMsg)('Pasted', 'info');
}
async function $a4a268d7686bbf3f$var$getClipboardContents() {
    try {
        if (typeof navigator.clipboard.readText !== 'function') throw new Error('navigator.clipboard.readText not a function');
    } catch (e) {
        (0, $gFW3W.alertMsg)('Pasting not implemented in this browser', 'error');
        return null;
    }
    try {
        return await navigator.clipboard.readText();
    } catch (err) {
        console.error('Failed to read clipboard contents: ', err);
        (0, $gFW3W.alertMsg)('Failed to paste', 'error');
        return null;
    }
}
function $a4a268d7686bbf3f$export$aab3aebcdfaf4b16(pointsArray) {
    // do nothing if either yPointsArray is empty or yDrawingMap  already contains objects
    if ((0, $e1c55b086cf8dd0e$export$ffba1a0e51177788).length === 0 || (0, $e1c55b086cf8dd0e$export$da7062de5ac36f9c).size > 0) return;
    (0, $e1c55b086cf8dd0e$export$da7062de5ac36f9c).clear();
    let options;
    let ids = [];
    $a4a268d7686bbf3f$export$67ea982130081db.setViewportTransform([
        1,
        0,
        0,
        1,
        $a4a268d7686bbf3f$export$67ea982130081db.getWidth() / 2,
        $a4a268d7686bbf3f$export$67ea982130081db.getHeight() / 2
    ]);
    (0, $e1c55b086cf8dd0e$export$2a111da947c407d2).transact(()=>{
        pointsArray = $a4a268d7686bbf3f$var$eraser(pointsArray);
        pointsArray.forEach((item)=>{
            let fabObj = {
                id: (0, $gFW3W.uuidv4)()
            };
            switch(item[0]){
                case 'options':
                    options = item[1];
                    break;
                case 'dashedLine':
                    fabObj.strokeDashArray = [
                        10,
                        10
                    ];
                // falls through
                case 'line':
                    fabObj.type = 'line';
                    fabObj.x1 = item[1][0];
                    fabObj.y1 = item[1][1];
                    fabObj.x2 = item[1][2];
                    fabObj.y2 = item[1][3];
                    fabObj.axes = false;
                    fabObj.stroke = options.strokeStyle;
                    fabObj.strokeWidth = options.lineWidth;
                    ids.push(fabObj.id);
                    (0, $e1c55b086cf8dd0e$export$da7062de5ac36f9c).set(fabObj.id, fabObj);
                    break;
                case 'rrect':
                    fabObj.rx = 10;
                    fabObj.ry = 10;
                // falls through
                case 'rect':
                    fabObj.type = 'rect';
                    fabObj.left = item[1][0];
                    fabObj.top = item[1][1];
                    fabObj.width = item[1][2];
                    fabObj.height = item[1][3];
                    fabObj.fill = options.fillStyle;
                    if (fabObj.fill === 'rgb(255, 255, 255)' || fabObj.fill === '#ffffff') fabObj.fill = 'rgba(0, 0, 0, 0)';
                    fabObj.stroke = options.strokeStyle;
                    fabObj.strokeWidth = options.lineWidth;
                    ids.push(fabObj.id);
                    (0, $e1c55b086cf8dd0e$export$da7062de5ac36f9c).set(fabObj.id, fabObj);
                    break;
                case 'text':
                    fabObj.type = 'text';
                    fabObj.fill = options.fillStyle;
                    fabObj.fontSize = Number.parseInt(options.font);
                    fabObj.text = item[1][0];
                    fabObj.left = item[1][1];
                    fabObj.top = item[1][2];
                    ids.push(fabObj.id);
                    (0, $e1c55b086cf8dd0e$export$da7062de5ac36f9c).set(fabObj.id, fabObj);
                    break;
                case 'image':
                    {
                        // this is a bit complicated because we have to allow for the async onload of the image
                        let image = new Image();
                        image.src = item[1][0];
                        let promise = new Promise((resolve)=>{
                            image.onload = function() {
                                let imageObj = new (0, $79564f678731bf19$exports.fabric).Image(image, {
                                    left: item[1][1],
                                    top: item[1][2],
                                    width: item[1][3],
                                    height: item[1][4]
                                });
                                fabObj.type = 'image';
                                fabObj.imageObj = imageObj.toObject();
                                resolve(fabObj);
                            };
                        });
                        promise.then(()=>{
                            (0, $e1c55b086cf8dd0e$export$da7062de5ac36f9c).set(fabObj.id, fabObj);
                            $a4a268d7686bbf3f$export$8d588f71d329a9b1([
                                fabObj.id
                            ]);
                        });
                    }
                    break;
                case 'pencil':
                    break;
                case 'marker':
                    fabObj.type = 'circle';
                    fabObj.fill = options.fillStyle;
                    fabObj.strokeWidth = 0;
                    fabObj.stroke = options.fillStyle;
                    fabObj.originX = 'center';
                    fabObj.originY = 'center';
                    fabObj.left = item[1][0];
                    fabObj.top = item[1][1];
                    fabObj.radius = item[1][2] / 2;
                    ids.push(fabObj.id);
                    (0, $e1c55b086cf8dd0e$export$da7062de5ac36f9c).set(fabObj.id, fabObj);
                    break;
                case 'endShape':
                    break;
            }
        });
    });
    console.log('Background converted from v1 to v2');
    $a4a268d7686bbf3f$export$8d588f71d329a9b1(ids);
}
/**
 * Simulate the effect of the v1 eraser by deleting all rects and textboxes that are overlapped by the
 * white circles produced by the v1 eraser
 * @returns a filtered version of yPointsArray, with 'erased' rects, texts and  white marker circles omitted
 */ function $a4a268d7686bbf3f$var$eraser() {
    let points = (0, $gFW3W.deepCopy)((0, $e1c55b086cf8dd0e$export$ffba1a0e51177788).toArray());
    let options = {};
    // work along pointsArray.
    for(let i = 0; i < points.length; i++){
        let point = points[i];
        // if not 'endShape' or 'options'
        if (point[0] === 'endShape') continue;
        if (point[0] === 'options') {
            options = point[1];
            continue;
        }
        //if circle and white
        if (point[0] === 'marker' && options.fillStyle === '#ffffff') {
            // starting at beginning test each array entry until reached current entry
            for(let j = 0; j < i; j++)// test whether circle overlaps shape
            if ($a4a268d7686bbf3f$var$intersect(point, points[j])) // if so, change shape to 'deleted'
            points[j][0] = 'deleted';
            // when reach current entry, change circle to 'deleted' and repeat until end of array.
            point[0] = 'deleted';
        }
    }
    return points.filter((p)=>p[0] !== 'deleted');
}
/**
 * returns true iff the circle overlaps the shape (tests only rects and text boxes, not lines or pencil)
 * @param {array} circle a marker item from yPointsArray
 * @param {array} shape an item form yPointsArray
 * @returns Boolean
 */ function $a4a268d7686bbf3f$var$intersect(circle, shape) {
    let circObj = {
        x: circle[1][0],
        y: circle[1][1],
        r: circle[1][2]
    };
    switch(shape[0]){
        case 'rect':
        case 'rrect':
            {
                let rectObj = {
                    x: shape[1][0],
                    y: shape[1][1],
                    w: shape[1][2],
                    h: shape[1][3]
                };
                return $a4a268d7686bbf3f$var$circleIntersectsRect(circObj, rectObj);
            }
        case 'text':
            // to simplify, just test whether the start point is covered by the circle
            return (circObj.x - shape[1][1]) ** 2 + (circObj.y - shape[1][2]) ** 2 < circObj.r ** 2;
        default:
            return false;
    }
}
/**
 * tests whether any part of the circle overlaps the rectangle
 * @param {object} circle an object with x,y as the circle's centre and r, the circle's radius
 * @param {object} rect an object with the rects x,y for its top left, and width and height
 * @returns Boolean
 */ function $a4a268d7686bbf3f$var$circleIntersectsRect(circle, rect) {
    var distX = Math.abs(circle.x - rect.x - rect.w / 2);
    var distY = Math.abs(circle.y - rect.y - rect.h / 2);
    if (distX > rect.w / 2 + circle.r) return false;
    if (distY > rect.h / 2 + circle.r) return false;
    if (distX <= rect.w / 2) return true;
    if (distY <= rect.h / 2) return true;
    var dx = distX - rect.w / 2;
    var dy = distY - rect.h / 2;
    return dx * dx + dy * dy <= circle.r * circle.r;
}


/*********************************************************************************************************************  

PRSM Participatory System Mapper 

	Copyright (C) 2022  Nigel Gilbert prsm@prsm.uk

	This program is free software: you can redistribute it and/or modify
	it under the terms of the GNU General Public License as published by
	the Free Software Foundation, either version 3 of the License, or
	(at your option) any later version.

	This program is distributed in the hope that it will be useful,
	but WITHOUT ANY WARRANTY; without even the implied warranty of
	MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	GNU General Public License for more details.

	You should have received a copy of the GNU General Public License
	along with this program.  If not, see <https://www.gnu.org/licenses/>.


This module handles operations related to the Styles tabs.  
 ******************************************************************************************************************** */ 


var $gFW3W = parcelRequire("gFW3W");


function $79c06594b77924a6$export$4ca77f8e2d7fc8b6() {
    // expand the styles object to include the default values
    $79c06594b77924a6$var$expandStylesObject();
    // Get all elements with class='sampleNode' and add listener and canvas
    let emptyDataSet = new (0, $558228835489ffff$export$486059efd2d2dabe)([]);
    let sampleElements = document.getElementsByClassName('sampleNode');
    for(let i = 0; i < sampleElements.length; i++){
        let groupId = `group${i}`;
        let sampleElement = sampleElements[i];
        let sampleOptions = (0, $09258687963db43e$export$9dd6ff9ea0189349).nodes[groupId];
        let groupLabel = (0, $09258687963db43e$export$9dd6ff9ea0189349).nodes[groupId].groupLabel;
        let nodeDataSet = new (0, $558228835489ffff$export$486059efd2d2dabe)([
            (0, $gFW3W.deepMerge)({
                id: '1',
                label: groupLabel === undefined ? '' : groupLabel
            }, sampleOptions, {
                chosen: false,
                widthConstraint: 50,
                heightConstraint: 50,
                font: {
                    size: 14
                },
                size: 50,
                margin: 10,
                scaling: {
                    label: {
                        enabled: false
                    }
                }
            })
        ]);
        $79c06594b77924a6$var$initSample(sampleElement, {
            nodes: nodeDataSet,
            edges: emptyDataSet
        });
        sampleElement.addEventListener('dblclick', ()=>{
            $79c06594b77924a6$var$editNodeStyle(sampleElement, groupId);
        });
        sampleElement.addEventListener('click', ()=>{
            (0, $e1c55b086cf8dd0e$export$7ac138a1e38951d6)(groupId, null);
        });
        sampleElement.addEventListener('contextmenu', (event)=>{
            $79c06594b77924a6$var$styleNodeContextMenu(event, sampleElement, groupId);
        });
        sampleElement.addEventListener('mouseover', ()=>(0, $gFW3W.statusMsg)('Left click: apply style to selected; Double click: edit style; Right click: Select or Hide all with this style'));
        sampleElement.addEventListener('mouseout', ()=>(0, $gFW3W.clearStatusBar)());
        sampleElement.groupNode = groupId;
        sampleElement.dataSet = nodeDataSet;
    }
    // and to all sampleLinks
    sampleElements = document.getElementsByClassName('sampleLink');
    for(let i = 0; i < sampleElements.length; i++){
        let sampleElement = sampleElements[i];
        let groupId = `edge${i}`;
        let groupLabel = (0, $09258687963db43e$export$9dd6ff9ea0189349).edges[groupId].groupLabel;
        let sampleOptions = (0, $09258687963db43e$export$9dd6ff9ea0189349).edges[groupId];
        let edgeDataSet = new (0, $558228835489ffff$export$486059efd2d2dabe)([
            (0, $gFW3W.deepMerge)({
                id: '1',
                from: 1,
                to: 2,
                label: groupLabel === undefined ? '' : groupLabel
            }, sampleOptions, {
                font: {
                    size: 24,
                    color: 'black',
                    align: 'top',
                    vadjust: -40
                },
                widthConstraint: 100,
                value: 10
            })
        ]);
        let nodesDataSet = new (0, $558228835489ffff$export$486059efd2d2dabe)([
            {
                id: 1,
                size: 5,
                shape: 'dot',
                fixed: true,
                chosen: false
            },
            {
                id: 2,
                size: 5,
                shape: 'dot',
                fixed: true,
                chosen: false
            }
        ]);
        $79c06594b77924a6$var$initSample(sampleElement, {
            nodes: nodesDataSet,
            edges: edgeDataSet
        });
        sampleElement.addEventListener('dblclick', ()=>{
            $79c06594b77924a6$var$editLinkStyle(sampleElement, groupId);
        });
        sampleElement.addEventListener('click', ()=>{
            (0, $e1c55b086cf8dd0e$export$7ac138a1e38951d6)(null, groupId);
        });
        sampleElement.addEventListener('contextmenu', (event)=>{
            $79c06594b77924a6$var$styleEdgeContextMenu(event, sampleElement, groupId);
        });
        sampleElement.addEventListener('mouseover', ()=>(0, $gFW3W.statusMsg)('Left click: apply style to selected; Double click: edit style; Right click: Select all with this style'));
        sampleElement.groupLink = groupId;
        sampleElement.dataSet = edgeDataSet;
    }
    // set up color pickers
    (0, $e1c55b086cf8dd0e$export$cd571ca6d1702b73).createColorPicker('nodeStyleEditFillColor', $79c06594b77924a6$var$nodeEditSave);
    (0, $e1c55b086cf8dd0e$export$cd571ca6d1702b73).createColorPicker('nodeStyleEditBorderColor', $79c06594b77924a6$var$nodeEditSave);
    (0, $e1c55b086cf8dd0e$export$cd571ca6d1702b73).createColorPicker('nodeStyleEditFontColor', $79c06594b77924a6$var$nodeEditSave);
    (0, $e1c55b086cf8dd0e$export$cd571ca6d1702b73).createColorPicker('linkStyleEditLineColor', $79c06594b77924a6$var$linkEditSave);
    // set up listeners
    (0, $gFW3W.listen)('nodeStyleEditCancel', 'click', $79c06594b77924a6$var$nodeEditCancel);
    (0, $gFW3W.listen)('nodeStyleEditName', 'keyup', $79c06594b77924a6$var$nodeEditSave);
    (0, $gFW3W.listen)('nodeStyleEditShape', 'change', $79c06594b77924a6$var$nodeEditSave);
    (0, $gFW3W.listen)('nodeStyleEditBorder', 'change', $79c06594b77924a6$var$nodeEditSave);
    (0, $gFW3W.listen)('nodeStyleEditFontSize', 'change', $79c06594b77924a6$var$nodeEditSave);
    (0, $gFW3W.listen)('nodeStyleEditSubmit', 'click', $79c06594b77924a6$var$nodeEditSubmit);
    (0, $gFW3W.listen)('linkStyleEditCancel', 'click', $79c06594b77924a6$var$linkEditCancel);
    (0, $gFW3W.listen)('linkStyleEditName', 'keyup', $79c06594b77924a6$var$linkEditSave);
    (0, $gFW3W.listen)('linkStyleEditWidth', 'input', $79c06594b77924a6$var$linkEditSave);
    (0, $gFW3W.listen)('linkStyleEditDashes', 'input', $79c06594b77924a6$var$linkEditSave);
    (0, $gFW3W.listen)('linkStyleEditArrows', 'change', $79c06594b77924a6$var$linkEditSave);
    (0, $gFW3W.listen)('linkStyleEditSubmit', 'click', $79c06594b77924a6$var$linkEditSubmit);
    (0, $gFW3W.listen)('styleNodeContextMenuHide', 'contextmenu', (e)=>e.preventDefault());
    (0, $gFW3W.listen)('styleNodeContextMenuSelect', 'contextmenu', (e)=>e.preventDefault());
    (0, $gFW3W.listen)('styleEdgeContextMenuSelect', 'contextmenu', (e)=>e.preventDefault());
}
/**
 * assemble styles by merging the specifics into the default
 */ function $79c06594b77924a6$var$expandStylesObject() {
    let base = (0, $09258687963db43e$export$9dd6ff9ea0189349).nodes.base;
    for(let prop in (0, $09258687963db43e$export$9dd6ff9ea0189349).nodes){
        let grp = (0, $gFW3W.deepMerge)(base, (0, $09258687963db43e$export$9dd6ff9ea0189349).nodes[prop]);
        // make the hover and highlight colors the same as the basic ones
        grp.color.highlight = {};
        grp.color.highlight.border = grp.color.border;
        grp.color.highlight.background = grp.color.background;
        grp.color.hover = {};
        grp.color.hover.border = grp.color.border;
        grp.color.hover.background = grp.color.background;
        //		grp.font.size = base.font.size
        (0, $09258687963db43e$export$9dd6ff9ea0189349).nodes[prop] = grp;
    }
    base = (0, $09258687963db43e$export$9dd6ff9ea0189349).edges.base;
    for(let prop in (0, $09258687963db43e$export$9dd6ff9ea0189349).edges){
        let grp = (0, $gFW3W.deepMerge)(base, (0, $09258687963db43e$export$9dd6ff9ea0189349).edges[prop]);
        grp.color.highlight = grp.color.color;
        grp.color.hover = grp.color.color;
        (0, $09258687963db43e$export$9dd6ff9ea0189349).edges[prop] = grp;
    }
}
/**
 * create the sample network
 * @param {HTMLElement} wrapper
 * @param {object} sampleData
 */ function $79c06594b77924a6$var$initSample(wrapper, sampleData) {
    let options = {
        interaction: {
            dragNodes: false,
            dragView: false,
            selectable: true,
            zoomView: false
        },
        manipulation: {
            enabled: false
        },
        layout: {
            hierarchical: {
                enabled: true,
                direction: 'LR'
            }
        }
    };
    let net = new (0, $bebd28704f2536ea$export$95be4ae94445245a)(wrapper, sampleData, options);
    net.fit();
    net.storePositions();
    wrapper.net = net;
    return net;
}
var $79c06594b77924a6$var$factorsHiddenByStyle = {};
var $79c06594b77924a6$var$linksHiddenByStyle = {};
(0, $gFW3W.listen)('nodesTab', 'contextmenu', (e)=>{
    e.preventDefault();
});
(0, $gFW3W.listen)('linksTab', 'contextmenu', (e)=>{
    e.preventDefault();
});
/**
 * Context menu for node styles
 * @param {Event} event
 * @param {HTMLElement} sampleElement
 * @param {string} groupId
 */ function $79c06594b77924a6$var$styleNodeContextMenu(event, sampleElement, groupId) {
    let menu = (0, $gFW3W.elem)('styleNodeContextMenu');
    showMenu(event.pageX, event.pageY);
    document.addEventListener('click', onClick, false);
    function onClick(event) {
        // Safari emits a contextmenu and a click event on control-click; ignore the click
        if (event.ctrlKey && !event.target.id) return;
        event.preventDefault();
        hideMenu();
        document.removeEventListener('click', onClick);
        switch(event.target.id){
            case 'styleNodeContextMenuSelect':
                selectFactorsWithStyle(groupId);
                break;
            case 'styleNodeContextMenuHide':
                if (sampleElement.dataset.hide !== 'hidden') {
                    hideFactorsWithStyle(groupId, true);
                    sampleElement.dataset.hide = 'hidden';
                    sampleElement.style.opacity = 0.6;
                } else {
                    hideFactorsWithStyle(groupId, false);
                    sampleElement.dataset.hide = 'visible';
                    sampleElement.style.opacity = 1.0;
                }
                break;
            default:
                break;
        }
    }
    function showMenu(x, y) {
        (0, $gFW3W.elem)('styleNodeContextMenuHide').innerText = sampleElement.dataset.hide === 'hidden' ? 'Unhide Factors' : 'Hide Factors';
        if (x + menu.offsetWidth > (0, $gFW3W.elem)('container').offsetWidth) x = (0, $gFW3W.elem)('container').offsetWidth - menu.offsetWidth;
        if (y + menu.offsetHeight > (0, $gFW3W.elem)('container').offsetHeight) y = (0, $gFW3W.elem)('container').offsetHeighth - menu.offsetHeight;
        menu.style.left = `${x}px`;
        menu.style.top = `${y}px`;
        menu.classList.add('show-menu');
    }
    function hideMenu() {
        menu.classList.remove('show-menu');
    }
    function selectFactorsWithStyle(groupId) {
        (0, $e1c55b086cf8dd0e$export$3ec31f8909af8acf)((0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.getIds({
            filter: (node)=>node.grp === groupId
        }));
    }
    function hideFactorsWithStyle(groupId, toggle) {
        let nodes = (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get({
            filter: (node)=>node.grp === groupId
        });
        nodes.forEach((node)=>{
            (0, $gFW3W.setNodeHidden)(node, toggle);
        });
        (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.update(nodes);
        let edges = [];
        nodes.forEach((node)=>{
            let connectedEdges = (0, $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4).getConnectedEdges(node.id);
            connectedEdges.forEach((edgeId)=>{
                edges.push((0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.get(edgeId));
            });
        });
        edges.forEach((edge)=>{
            (0, $gFW3W.setEdgeHidden)(edge, toggle);
        });
        (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.update(edges);
        $79c06594b77924a6$var$factorsHiddenByStyle[sampleElement.id] = toggle;
        (0, $e1c55b086cf8dd0e$export$807f940a96777041).set('factorsHiddenByStyle', $79c06594b77924a6$var$factorsHiddenByStyle);
    }
}
/**
 * Context menu for edge styles
 * @param {Event} event
 * @param {HTMLElement} sampleElement
 * @param {string} groupId
 */ function $79c06594b77924a6$var$styleEdgeContextMenu(event, sampleElement, groupId) {
    let menu = (0, $gFW3W.elem)('styleEdgeContextMenu');
    showMenu(event.pageX, event.pageY);
    document.addEventListener('click', onClick, false);
    function onClick(event) {
        // Safari emits a contextmenu and a click event on control-click; ignore the click
        if (event.ctrlKey && !event.target.id) return;
        event.preventDefault();
        hideMenu();
        document.removeEventListener('click', onClick);
        switch(event.target.id){
            case 'styleEdgeContextMenuSelect':
                selectLinksWithStyle(groupId);
                break;
            case 'styleEdgeContextMenuHide':
                if (sampleElement.dataset.hide !== 'hidden') {
                    hideLinksWithStyle(groupId, true);
                    sampleElement.dataset.hide = 'hidden';
                    sampleElement.style.opacity = 0.6;
                } else {
                    hideLinksWithStyle(groupId, false);
                    sampleElement.dataset.hide = 'visible';
                    sampleElement.style.opacity = 1.0;
                }
                break;
            default:
                break;
        }
    }
    function showMenu(x, y) {
        (0, $gFW3W.elem)('styleEdgeContextMenuHide').innerText = sampleElement.dataset.hide === 'hidden' ? 'Unhide Links' : 'Hide Links';
        if (x + menu.offsetWidth > (0, $gFW3W.elem)('container').offsetWidth) x = (0, $gFW3W.elem)('container').offsetWidth - menu.offsetWidth;
        if (y + menu.offsetHeight > (0, $gFW3W.elem)('container').offsetHeight) y = (0, $gFW3W.elem)('container').offsetHeighth - menu.offsetHeight;
        menu.style.left = `${x}px`;
        menu.style.top = `${y}px`;
        menu.classList.add('show-menu');
    }
    function hideMenu() {
        menu.classList.remove('show-menu');
    }
    function selectLinksWithStyle(groupId) {
        (0, $e1c55b086cf8dd0e$export$2c92a894f29aaee5)((0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.getIds({
            filter: (edge)=>edge.grp === groupId
        }));
    }
    function hideLinksWithStyle(groupId, toggle) {
        let edges = (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.get({
            filter: (edge)=>edge.grp === groupId
        });
        edges.forEach((edge)=>{
            (0, $gFW3W.setEdgeHidden)(edge, toggle);
        });
        (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.update(edges);
        $79c06594b77924a6$var$linksHiddenByStyle[sampleElement.id] = toggle;
        (0, $e1c55b086cf8dd0e$export$807f940a96777041).set('linksHiddenByStyle', $79c06594b77924a6$var$linksHiddenByStyle);
    }
}
/**
 * open the dialog to edit a node style
 * @param {HTMLElement} styleElement
 * @param {number} groupId
 */ function $79c06594b77924a6$var$editNodeStyle(styleElement, groupId) {
    styleElement.net.unselectAll();
    let container = (0, $gFW3W.elem)('nodeStyleEditorContainer');
    container.groupId = groupId;
    // save the current style format (so that there can be a revert in case of cancelling the edit)
    container.origGroup = (0, $gFW3W.deepCopy)((0, $09258687963db43e$export$9dd6ff9ea0189349).nodes[groupId]);
    // save the div in which the style is displayed
    container.styleElement = styleElement;
    // set the style dialog widgets with the current values for the group style
    $79c06594b77924a6$var$updateNodeEditor(groupId);
    // display the style dialog
    $79c06594b77924a6$var$nodeEditorShow();
}
/**
 * ensure that the edit node style dialog shows the current state of the style
 * @param {string} groupId
 */ function $79c06594b77924a6$var$updateNodeEditor(groupId) {
    let group = (0, $09258687963db43e$export$9dd6ff9ea0189349).nodes[groupId];
    (0, $gFW3W.elem)('nodeStyleEditName').value = group.groupLabel !== 'Sample' ? group.groupLabel : '';
    (0, $gFW3W.elem)('nodeStyleEditFillColor').style.backgroundColor = (0, $gFW3W.standardize_color)(group.color.background);
    (0, $gFW3W.elem)('nodeStyleEditBorderColor').style.backgroundColor = (0, $gFW3W.standardize_color)(group.color.border);
    (0, $gFW3W.elem)('nodeStyleEditFontColor').style.backgroundColor = (0, $gFW3W.standardize_color)(group.font.color);
    (0, $gFW3W.elem)('nodeStyleEditShape').value = group.shape;
    (0, $gFW3W.elem)('nodeStyleEditBorder').value = (0, $gFW3W.getDashes)(group.shapeProperties.borderDashes, group.borderWidth);
    (0, $gFW3W.elem)('nodeStyleEditFontSize').value = group.font.size;
    if (group.fixed) {
        (0, $gFW3W.elem)('nodeStyleEditFixed').style.display = 'inline';
        (0, $gFW3W.elem)('nodeStyleEditUnfixed').style.display = 'none';
    } else {
        (0, $gFW3W.elem)('nodeStyleEditFixed').style.display = 'none';
        (0, $gFW3W.elem)('nodeStyleEditUnfixed').style.display = 'inline';
    }
    (0, $gFW3W.elem)('nodeStyleEditFactorSize').value = (0, $gFW3W.factorSizeToPercent)(group.size);
    (0, $e1c55b086cf8dd0e$export$9d1298853f0e77f7)((0, $gFW3W.elem)('nodeStyleEditFactorSize'));
}
(0, $gFW3W.listen)('nodeStyleEditLock', 'click', $79c06594b77924a6$var$toggleNodeStyleLock);
/**
 * Toggle the lock state of the node style
 */ function $79c06594b77924a6$var$toggleNodeStyleLock() {
    let group = (0, $09258687963db43e$export$9dd6ff9ea0189349).nodes[(0, $gFW3W.elem)('nodeStyleEditorContainer').groupId];
    if (group.fixed) {
        (0, $gFW3W.elem)('nodeStyleEditFixed').style.display = 'none';
        (0, $gFW3W.elem)('nodeStyleEditUnfixed').style.display = 'inline';
    } else {
        (0, $gFW3W.elem)('nodeStyleEditFixed').style.display = 'inline';
        (0, $gFW3W.elem)('nodeStyleEditUnfixed').style.display = 'none';
    }
    group.fixed = !group.fixed;
}
/**
 * save changes to the style made with the edit dialog to the style object
 */ function $79c06594b77924a6$var$nodeEditSave() {
    let groupId = (0, $gFW3W.elem)('nodeStyleEditorContainer').groupId;
    let group = (0, $09258687963db43e$export$9dd6ff9ea0189349).nodes[groupId];
    group.groupLabel = (0, $gFW3W.elem)('nodeStyleEditName').value;
    if (group.groupLabel === '') group.groupLabel = 'Sample';
    group.color.background = (0, $gFW3W.elem)('nodeStyleEditFillColor').style.backgroundColor;
    group.color.border = (0, $gFW3W.elem)('nodeStyleEditBorderColor').style.backgroundColor;
    group.color.highlight.background = group.color.background;
    group.color.highlight.border = group.color.border;
    group.color.hover.background = group.color.background;
    group.color.hover.border = group.color.border;
    group.font.color = (0, $gFW3W.elem)('nodeStyleEditFontColor').style.backgroundColor;
    group.shape = (0, $gFW3W.elem)('nodeStyleEditShape').value;
    let border = (0, $gFW3W.elem)('nodeStyleEditBorder').value;
    group.shapeProperties.borderDashes = (0, $gFW3W.convertDashes)(border);
    group.borderWidth = border === 'none' ? 0 : 4;
    group.font.size = parseInt((0, $gFW3W.elem)('nodeStyleEditFontSize').value);
    (0, $gFW3W.setFactorSizeFromPercent)(group, (0, $gFW3W.elem)('nodeStyleEditFactorSize').value);
    $79c06594b77924a6$var$nodeEditUpdateStyleSample(group);
}
/**
 * update the style sample to show changes to style
 * @param {Object} group
 */ function $79c06594b77924a6$var$nodeEditUpdateStyleSample(group) {
    let groupId = (0, $gFW3W.elem)('nodeStyleEditorContainer').groupId;
    let styleElement = (0, $gFW3W.elem)('nodeStyleEditorContainer').styleElement;
    let node = styleElement.dataSet.get('1');
    node.label = group.groupLabel;
    // the node in the style sample does not change size
    node = (0, $gFW3W.deepMerge)(node, (0, $09258687963db43e$export$9dd6ff9ea0189349).nodes[groupId], {
        chosen: false,
        size: 50,
        widthConstraint: 50,
        heightConstraint: 50,
        margin: 10,
        font: {
            size: 14
        }
    });
    styleElement.dataSet.update(node);
}
/**
 * cancel any editing of the style and revert to what it was previously
 */ function $79c06594b77924a6$var$nodeEditCancel() {
    // restore saved group format
    let groupId = (0, $gFW3W.elem)('nodeStyleEditorContainer').groupId;
    (0, $09258687963db43e$export$9dd6ff9ea0189349).nodes[groupId] = (0, $gFW3W.elem)('nodeStyleEditorContainer').origGroup;
    $79c06594b77924a6$var$nodeEditUpdateStyleSample((0, $09258687963db43e$export$9dd6ff9ea0189349).nodes[groupId]);
    $79c06594b77924a6$var$nodeEditorHide();
}
/**
 * hide the node style editor dialog
 */ function $79c06594b77924a6$var$nodeEditorHide() {
    (0, $gFW3W.elem)('nodeStyleEditorContainer').classList.add('hideEditor');
}
/**
 * show the node style editor dialog
 */ function $79c06594b77924a6$var$nodeEditorShow() {
    let panelRect = (0, $gFW3W.elem)('panel').getBoundingClientRect();
    let container = (0, $gFW3W.elem)('nodeStyleEditorContainer');
    container.style.top = `${panelRect.top}px`;
    container.style.left = `${panelRect.left - 300}px`;
    container.classList.remove('hideEditor');
}
/**
 * save the edited style and close the style editor.  Update the nodes
 * in the map and the legend to the current style
 */ function $79c06594b77924a6$var$nodeEditSubmit() {
    $79c06594b77924a6$var$nodeEditSave();
    $79c06594b77924a6$var$nodeEditorHide();
    // apply updated style to all nodes having that style
    let groupId = (0, $gFW3W.elem)('nodeStyleEditorContainer').groupId;
    // somewhere - but I have no idea where or why, this is set to true, but it must be false
    (0, $09258687963db43e$export$9dd6ff9ea0189349).nodes[groupId].scaling.label.enabled = false;
    $79c06594b77924a6$export$72639688f12e084([
        groupId
    ], true);
    (0, $e1c55b086cf8dd0e$export$4b63d58d2685a993).set(groupId, {
        node: (0, $09258687963db43e$export$9dd6ff9ea0189349).nodes[groupId]
    });
    $79c06594b77924a6$export$b8032ab161d91961();
    (0, $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4).redraw();
    (0, $e1c55b086cf8dd0e$export$e5fde6ebaea8ae1d)('edited a Factor style');
}
function $79c06594b77924a6$export$72639688f12e084(groupIds, force) {
    let nodesToUpdate = (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get({
        filter: (item)=>{
            return groupIds.includes(item.grp);
        }
    });
    (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.update(nodesToUpdate.map((node)=>{
        return force ? (0, $gFW3W.deepMerge)(node, (0, $09258687963db43e$export$9dd6ff9ea0189349).nodes[node.grp]) : (0, $gFW3W.deepMerge)((0, $09258687963db43e$export$9dd6ff9ea0189349).nodes[node.grp], node);
    }));
}
function $79c06594b77924a6$export$675fa328fb4ebccd(groupId) {
    let sampleElements = Array.from(document.getElementsByClassName('sampleNode'));
    let sampleElement = sampleElements[groupId.match(/\d+/)?.[0]];
    let node = sampleElement.dataSet.get()[0];
    node = (0, $gFW3W.deepMerge)(node, (0, $09258687963db43e$export$9dd6ff9ea0189349).nodes[groupId], {
        chosen: false,
        size: 50,
        widthConstraint: 50,
        heightConstraint: 50,
        margin: 10,
        font: {
            size: 14
        }
    });
    node.label = node.groupLabel;
    sampleElement.dataSet.remove(node.id);
    sampleElement.dataSet.update(node);
    sampleElement.net.fit();
}
/**
 * open the dialog to edit a link style
 * @param {HTMLElement} styleElement
 * @param {string} groupId
 */ function $79c06594b77924a6$var$editLinkStyle(styleElement, groupId) {
    let container = (0, $gFW3W.elem)('linkStyleEditorContainer');
    container.styleElement = styleElement;
    container.groupId = groupId;
    // save the current style format (so that there can be a revert in case of cancelling the edit)
    container.origGroup = (0, $gFW3W.deepCopy)((0, $09258687963db43e$export$9dd6ff9ea0189349).edges[groupId]);
    // set the style dialog widgets with the current values for the group style
    $79c06594b77924a6$var$updateLinkEditor(groupId);
    // display the style dialog
    $79c06594b77924a6$var$linkEditorShow();
}
/**
 * ensure that the edit link style dialog shows the current state of the style
 * @param {string} groupId
 */ function $79c06594b77924a6$var$updateLinkEditor(groupId) {
    let group = (0, $09258687963db43e$export$9dd6ff9ea0189349).edges[groupId];
    (0, $gFW3W.elem)('linkStyleEditName').value = group.groupLabel !== 'Sample' ? group.groupLabel : '';
    (0, $gFW3W.elem)('linkStyleEditLineColor').style.backgroundColor = (0, $gFW3W.standardize_color)(group.color.color);
    (0, $gFW3W.elem)('linkStyleEditWidth').value = group.width;
    (0, $gFW3W.elem)('linkStyleEditDashes').value = (0, $gFW3W.getDashes)(group.dashes, 1);
    (0, $gFW3W.elem)('linkStyleEditArrows').value = $79c06594b77924a6$var$getArrows(group.arrows);
}
/**
 * save changes to the style made with the edit dialog to the style object
 */ function $79c06594b77924a6$var$linkEditSave() {
    let groupId = (0, $gFW3W.elem)('linkStyleEditorContainer').groupId;
    let group = (0, $09258687963db43e$export$9dd6ff9ea0189349).edges[groupId];
    group.groupLabel = (0, $gFW3W.elem)('linkStyleEditName').value;
    if (group.groupLabel === '') group.groupLabel = 'Sample';
    group.color.color = (0, $gFW3W.elem)('linkStyleEditLineColor').style.backgroundColor;
    group.color.highlight = group.color.color;
    group.color.hover = group.color.color;
    group.width = parseInt((0, $gFW3W.elem)('linkStyleEditWidth').value);
    group.dashes = (0, $gFW3W.convertDashes)((0, $gFW3W.elem)('linkStyleEditDashes').value);
    groupArrows((0, $gFW3W.elem)('linkStyleEditArrows').value);
    $79c06594b77924a6$var$linkEditUpdateStyleSample(group);
    /**
	 * Set the link object properties to show various arrow types
	 * @param {string} val
	 */ function groupArrows(val) {
        if (val !== '') {
            group.arrows.from.enabled = false;
            group.arrows.middle.enabled = false;
            group.arrows.to.enabled = true;
            if (val === 'none') group.arrows.to.enabled = false;
            else group.arrows.to.type = val;
        }
    }
}
/**
 * update the style sample to show changes to style
 * @param {Object} group
 */ function $79c06594b77924a6$var$linkEditUpdateStyleSample(group) {
    // update the style edge to show changes to style
    let groupId = (0, $gFW3W.elem)('linkStyleEditorContainer').groupId;
    let styleElement = (0, $gFW3W.elem)('linkStyleEditorContainer').styleElement;
    let edge = styleElement.dataSet.get('1');
    edge.label = group.groupLabel;
    edge = (0, $gFW3W.deepMerge)(edge, (0, $09258687963db43e$export$9dd6ff9ea0189349).edges[groupId], {
        chosen: false
    });
    let dataSet = styleElement.dataSet;
    dataSet.update(edge);
}
/**
 * cancel any editing of the style and revert to what it was previously
 */ function $79c06594b77924a6$var$linkEditCancel() {
    // restore saved group format
    let groupId = (0, $gFW3W.elem)('linkStyleEditorContainer').groupId;
    (0, $09258687963db43e$export$9dd6ff9ea0189349).edges[groupId] = (0, $gFW3W.elem)('linkStyleEditorContainer').origGroup;
    $79c06594b77924a6$var$linkEditorHide();
}
/**
 * hide the link style editor dialog
 */ function $79c06594b77924a6$var$linkEditorHide() {
    (0, $gFW3W.elem)('linkStyleEditorContainer').classList.add('hideEditor');
}
/**
 * show the link style editor dialog
 */ function $79c06594b77924a6$var$linkEditorShow() {
    let panelRect = (0, $gFW3W.elem)('panel').getBoundingClientRect();
    let container = (0, $gFW3W.elem)('linkStyleEditorContainer');
    container.style.top = `${panelRect.top}px`;
    container.style.left = `${panelRect.left - 300}px`;
    container.classList.remove('hideEditor');
}
/**
 * save the edited style and close the style editor.  Update the links
 * in the map and the legend to the current style
 */ function $79c06594b77924a6$var$linkEditSubmit() {
    $79c06594b77924a6$var$linkEditSave();
    $79c06594b77924a6$var$linkEditorHide();
    // apply updated style to all edges having that style
    let groupId = (0, $gFW3W.elem)('linkStyleEditorContainer').groupId;
    $79c06594b77924a6$export$8e108f36b8804828([
        groupId
    ], true);
    (0, $e1c55b086cf8dd0e$export$4b63d58d2685a993).set(groupId, {
        edge: (0, $09258687963db43e$export$9dd6ff9ea0189349).edges[groupId]
    });
    $79c06594b77924a6$export$b8032ab161d91961();
    (0, $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4).redraw();
    (0, $e1c55b086cf8dd0e$export$e5fde6ebaea8ae1d)('edited a Link style');
}
function $79c06594b77924a6$export$8e108f36b8804828(groupIds, force) {
    let edgesToUpdate = (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.get({
        filter: (item)=>{
            return groupIds.includes(item.grp);
        }
    });
    (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.update(edgesToUpdate.map((edge)=>{
        return force ? (0, $gFW3W.deepMerge)(edge, (0, $09258687963db43e$export$9dd6ff9ea0189349).edges[edge.grp]) : (0, $gFW3W.deepMerge)((0, $09258687963db43e$export$9dd6ff9ea0189349).edges[edge.grp], edge);
    }));
}
function $79c06594b77924a6$export$e496289367e7ce52(groupId) {
    let sampleElements = Array.from(document.getElementsByClassName('sampleLink'));
    let sampleElement = sampleElements[groupId.match(/\d+/)?.[0]];
    let edge = sampleElement.dataSet.get()[0];
    edge = (0, $gFW3W.deepMerge)(edge, (0, $09258687963db43e$export$9dd6ff9ea0189349).edges[groupId], {
        chosen: false,
        value: 10
    });
    edge.label = edge.groupLabel;
    sampleElement.dataSet.remove(edge.id);
    sampleElement.dataSet.update(edge);
    sampleElement.net.fit();
}
/**
 * Convert from style object properties to arrow menu selection
 * @param {Object} prop
 */ function $79c06594b77924a6$var$getArrows(prop) {
    let val = 'none';
    if (prop.to?.enabled && prop.to.type) val = prop.to.type;
    return val;
}
/*  ------------display the map legend (includes all styles with a group label that is neither blank or 'Sample') */ var $79c06594b77924a6$var$legendData = {
    nodes: new (0, $558228835489ffff$export$486059efd2d2dabe)(),
    edges: new (0, $558228835489ffff$export$486059efd2d2dabe)()
};
var $79c06594b77924a6$var$legendNetwork = null;
const $79c06594b77924a6$var$LEGENDSPACING = 60;
const $79c06594b77924a6$var$HALFLEGENDWIDTH = 60;
function $79c06594b77924a6$export$9a9b59e08de24cef(warn = false) {
    $79c06594b77924a6$export$6bbbe775699090bc();
    let sampleNodeDivs = document.getElementsByClassName('sampleNode');
    let nodes = Array.from(sampleNodeDivs).filter((elem)=>elem.dataSet.get('1').groupLabel !== 'Sample');
    let sampleEdgeDivs = document.getElementsByClassName('sampleLink');
    let edges = Array.from(sampleEdgeDivs).filter((elem)=>![
            'Sample',
            '',
            ' '
        ].includes(elem.dataSet.get('1').groupLabel));
    let nItems = nodes.length + edges.length;
    if (nItems === 0) {
        if (warn) (0, $gFW3W.alertMsg)('Nothing to include in the Legend - rename some styles first', 'warn');
        (0, $gFW3W.elem)('showLegendSwitch').checked = false;
        return;
    }
    let legendBox = document.createElement('div');
    legendBox.className = 'legend';
    legendBox.id = 'legendBox';
    (0, $gFW3W.elem)('main').appendChild(legendBox);
    let title = document.createElement('p');
    title.id = 'Legend';
    title.className = 'legendTitle';
    title.appendChild(document.createTextNode('Legend'));
    legendBox.appendChild(title);
    legendBox.style.height = `${$79c06594b77924a6$var$LEGENDSPACING * nItems + title.offsetHeight}px`;
    legendBox.style.width = `${$79c06594b77924a6$var$HALFLEGENDWIDTH * 2}px`;
    let legendWrapper = document.createElement('div');
    legendWrapper.className = 'legendWrapper';
    legendBox.appendChild(legendWrapper);
    let canvas = document.createElement('div');
    canvas.className = 'legendCanvas';
    canvas.style.height = `${$79c06594b77924a6$var$LEGENDSPACING * nItems}px`;
    legendWrapper.appendChild(canvas);
    (0, $gFW3W.dragElement)(legendBox, title);
    $79c06594b77924a6$var$legendNetwork = new (0, $bebd28704f2536ea$export$95be4ae94445245a)(canvas, $79c06594b77924a6$var$legendData, {
        physics: {
            enabled: false
        },
        interaction: {
            zoomView: false,
            dragView: false
        }
    });
    let height = 0;
    for(let i = 0; i < nodes.length; i++){
        let node = (0, $gFW3W.deepMerge)((0, $09258687963db43e$export$9dd6ff9ea0189349).nodes[nodes[i].groupNode]);
        node.id = i + 10000;
        node.label = node.groupLabel;
        node.fixed = true;
        node.chosen = false;
        node.margin = 10;
        node.x = 0;
        node.y = 0;
        node.widthConstraint = 40;
        node.heightConstraint = 40;
        node.font.size = 10;
        $79c06594b77924a6$var$legendData.nodes.update(node);
        let bbox = $79c06594b77924a6$var$legendNetwork.getBoundingBox(node.id);
        node.y = (bbox.bottom - bbox.top) / 2 + height;
        height += bbox.bottom - bbox.top;
        $79c06594b77924a6$var$legendData.nodes.update(node);
    }
    height += 50;
    for(let i = 0; i < edges.length; i++){
        let edge = (0, $gFW3W.deepMerge)((0, $09258687963db43e$export$9dd6ff9ea0189349).edges[edges[i].groupLink]);
        edge.label = edge.groupLabel;
        edge.id = i + 10000;
        edge.from = i + 20000;
        edge.to = i + 30000;
        edge.smooth = {
            type: 'straightCross'
        };
        edge.font = {
            size: 12,
            color: 'black',
            align: 'top',
            vadjust: -10
        };
        edge.widthConstraint = 80;
        edge.chosen = false;
        let nodes = [
            {
                id: edge.from,
                size: 5,
                shape: 'dot',
                x: -25,
                y: height,
                fixed: true,
                chosen: false
            },
            {
                id: edge.to,
                shape: 'dot',
                size: 5,
                x: 25,
                y: height,
                fixed: true,
                chosen: false
            }
        ];
        $79c06594b77924a6$var$legendData.nodes.update(nodes);
        $79c06594b77924a6$var$legendData.edges.update(edge);
        height += 50;
    }
    $79c06594b77924a6$var$legendNetwork.fit({});
    // required to allow scrolling on IOS
    canvas.firstElementChild.firstElementChild.style.touchAction = 'pan-y';
    canvas.firstElementChild.firstElementChild.style.webkitUserSelect = 'all';
}
window.legendData = $79c06594b77924a6$var$legendData;
function $79c06594b77924a6$export$6bbbe775699090bc() {
    $79c06594b77924a6$var$legendData.nodes.clear();
    $79c06594b77924a6$var$legendData.edges.clear();
    if ($79c06594b77924a6$var$legendNetwork) $79c06594b77924a6$var$legendNetwork.destroy();
    let legendBox = (0, $gFW3W.elem)('legendBox');
    if (legendBox) legendBox.remove();
}
function $79c06594b77924a6$export$b8032ab161d91961() {
    if ((0, $gFW3W.elem)('showLegendSwitch').checked) {
        $79c06594b77924a6$export$9a9b59e08de24cef(false);
        (0, $gFW3W.clearStatusBar)();
    }
}



var $aBK2w = parcelRequire("aBK2w");
var $cc2db08ef43e5d3c$exports = {};
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})($cc2db08ef43e5d3c$exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, $cc2db08ef43e5d3c$exports = g;
});


var $e2cb8cc29293ee9d$exports = {};
!function(e, o) {
    $e2cb8cc29293ee9d$exports = o();
}(self, function() {
    return (()=>{
        "use strict";
        var e = {
            607: (e, o)=>{
                Object.defineProperty(o, "__esModule", {
                    value: !0
                }), o.quillToWord = void 0, o.quillToWord = function() {
                    return "Here is your word document.";
                };
            }
        }, o = {};
        return function r(t) {
            if (o[t]) return o[t].exports;
            var u = o[t] = {
                exports: {}
            };
            return e[t](u, u.exports, r), u.exports;
        }(607);
    })();
});


/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported XLSX */ /*global process:false, Buffer:false, ArrayBuffer:false, DataView:false, Deno:false */ 
var $l52Gj = parcelRequire("l52Gj");
var $b8f343bf88dacc48$require$Buffer = $l52Gj.Buffer;

var $l52Gj = parcelRequire("l52Gj");
var $b8f343bf88dacc48$var$XLSX = {};
$b8f343bf88dacc48$var$XLSX.version = '0.20.2';
var $b8f343bf88dacc48$var$current_codepage = 1200, $b8f343bf88dacc48$var$current_ansi = 1252;
/*:: declare var cptable:any; */ /*global cptable:true, window */ var $b8f343bf88dacc48$var$$cptable;
var $b8f343bf88dacc48$var$VALID_ANSI = [
    874,
    932,
    936,
    949,
    950,
    1250,
    1251,
    1252,
    1253,
    1254,
    1255,
    1256,
    1257,
    1258,
    10000
];
/* ECMA-376 Part I 18.4.1 charset to codepage mapping */ var $b8f343bf88dacc48$var$CS2CP = {
    0: 1252,
    /* ANSI */ 1: 65001,
    /* DEFAULT */ 2: 65001,
    /* SYMBOL */ 77: 10000,
    /* MAC */ 128: 932,
    /* SHIFTJIS */ 129: 949,
    /* HANGUL */ 130: 1361,
    /* JOHAB */ 134: 936,
    /* GB2312 */ 136: 950,
    /* CHINESEBIG5 */ 161: 1253,
    /* GREEK */ 162: 1254,
    /* TURKISH */ 163: 1258,
    /* VIETNAMESE */ 177: 1255,
    /* HEBREW */ 178: 1256,
    /* ARABIC */ 186: 1257,
    /* BALTIC */ 204: 1251,
    /* RUSSIAN */ 222: 874,
    /* THAI */ 238: 1250,
    /* EASTEUROPE */ 255: 1252,
    /* OEM */ 69: 6969 /* MISC */ 
} /*:any*/ ;
var $b8f343bf88dacc48$var$set_ansi = function(cp /*:number*/ ) {
    if ($b8f343bf88dacc48$var$VALID_ANSI.indexOf(cp) == -1) return;
    $b8f343bf88dacc48$var$current_ansi = $b8f343bf88dacc48$var$CS2CP[0] = cp;
};
function $b8f343bf88dacc48$var$reset_ansi() {
    $b8f343bf88dacc48$var$set_ansi(1252);
}
var $b8f343bf88dacc48$var$set_cp = function(cp /*:number*/ ) {
    $b8f343bf88dacc48$var$current_codepage = cp;
    $b8f343bf88dacc48$var$set_ansi(cp);
};
function $b8f343bf88dacc48$var$reset_cp() {
    $b8f343bf88dacc48$var$set_cp(1200);
    $b8f343bf88dacc48$var$reset_ansi();
}
function $b8f343bf88dacc48$var$char_codes(data /*:string*/ ) /*:Array<number>*/ {
    var o /*:Array<number>*/  = [];
    for(var i = 0, len = data.length; i < len; ++i)o[i] = data.charCodeAt(i);
    return o;
}
function $b8f343bf88dacc48$var$utf16leread(data /*:string*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data.charCodeAt(2 * i) + (data.charCodeAt(2 * i + 1) << 8));
    return o.join("");
}
function $b8f343bf88dacc48$var$utf16lereadu(data /*:Uint8Array*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data[2 * i] + (data[2 * i + 1] << 8));
    return o.join("");
}
function $b8f343bf88dacc48$var$utf16beread(data /*:string*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data.charCodeAt(2 * i + 1) + (data.charCodeAt(2 * i) << 8));
    return o.join("");
}
var $b8f343bf88dacc48$var$debom = function(data /*:string*/ ) /*:string*/ {
    var c1 = data.charCodeAt(0), c2 = data.charCodeAt(1);
    if (c1 == 0xFF && c2 == 0xFE) return $b8f343bf88dacc48$var$utf16leread(data.slice(2));
    if (c1 == 0xFE && c2 == 0xFF) return $b8f343bf88dacc48$var$utf16beread(data.slice(2));
    if (c1 == 0xFEFF) return data.slice(1);
    return data;
};
var $b8f343bf88dacc48$var$_getchar = function _gc1(x /*:number*/ ) /*:string*/ {
    return String.fromCharCode(x);
};
var $b8f343bf88dacc48$var$_getansi = function _ga1(x /*:number*/ ) /*:string*/ {
    return String.fromCharCode(x);
};
function $b8f343bf88dacc48$export$58f247d16f363b86(cptable) {
    $b8f343bf88dacc48$var$$cptable = cptable;
    $b8f343bf88dacc48$var$set_cp = function(cp /*:number*/ ) {
        $b8f343bf88dacc48$var$current_codepage = cp;
        $b8f343bf88dacc48$var$set_ansi(cp);
    };
    $b8f343bf88dacc48$var$debom = function(data /*:string*/ ) {
        if (data.charCodeAt(0) === 0xFF && data.charCodeAt(1) === 0xFE) return $b8f343bf88dacc48$var$$cptable.utils.decode(1200, $b8f343bf88dacc48$var$char_codes(data.slice(2)));
        return data;
    };
    $b8f343bf88dacc48$var$_getchar = function _gc2(x /*:number*/ ) /*:string*/ {
        if ($b8f343bf88dacc48$var$current_codepage === 1200) return String.fromCharCode(x);
        return $b8f343bf88dacc48$var$$cptable.utils.decode($b8f343bf88dacc48$var$current_codepage, [
            x & 255,
            x >> 8
        ])[0];
    };
    $b8f343bf88dacc48$var$_getansi = function _ga2(x /*:number*/ ) /*:string*/ {
        return $b8f343bf88dacc48$var$$cptable.utils.decode($b8f343bf88dacc48$var$current_ansi, [
            x
        ])[0];
    };
    $b8f343bf88dacc48$var$cpdoit();
}
var $b8f343bf88dacc48$var$DENSE = null;
var $b8f343bf88dacc48$var$DIF_XL = true;
var $b8f343bf88dacc48$var$Base64_map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function $b8f343bf88dacc48$var$Base64_encode(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input.charCodeAt(i++);
        e1 = c1 >> 2;
        c2 = input.charCodeAt(i++);
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input.charCodeAt(i++);
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += $b8f343bf88dacc48$var$Base64_map.charAt(e1) + $b8f343bf88dacc48$var$Base64_map.charAt(e2) + $b8f343bf88dacc48$var$Base64_map.charAt(e3) + $b8f343bf88dacc48$var$Base64_map.charAt(e4);
    }
    return o;
}
function $b8f343bf88dacc48$var$Base64_encode_pass(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input.charCodeAt(i++);
        if (c1 > 255) c1 = 95;
        e1 = c1 >> 2;
        c2 = input.charCodeAt(i++);
        if (c2 > 255) c2 = 95;
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input.charCodeAt(i++);
        if (c3 > 255) c3 = 95;
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += $b8f343bf88dacc48$var$Base64_map.charAt(e1) + $b8f343bf88dacc48$var$Base64_map.charAt(e2) + $b8f343bf88dacc48$var$Base64_map.charAt(e3) + $b8f343bf88dacc48$var$Base64_map.charAt(e4);
    }
    return o;
}
function $b8f343bf88dacc48$var$Base64_encode_arr(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input[i++];
        e1 = c1 >> 2;
        c2 = input[i++];
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input[i++];
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += $b8f343bf88dacc48$var$Base64_map.charAt(e1) + $b8f343bf88dacc48$var$Base64_map.charAt(e2) + $b8f343bf88dacc48$var$Base64_map.charAt(e3) + $b8f343bf88dacc48$var$Base64_map.charAt(e4);
    }
    return o;
}
function $b8f343bf88dacc48$var$Base64_decode(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    if (input.slice(0, 5) == "data:") {
        var i = input.slice(0, 1024).indexOf(";base64,");
        if (i > -1) input = input.slice(i + 8);
    }
    input = input.replace(/[^\w\+\/\=]/g, "");
    for(var i = 0; i < input.length;){
        e1 = $b8f343bf88dacc48$var$Base64_map.indexOf(input.charAt(i++));
        e2 = $b8f343bf88dacc48$var$Base64_map.indexOf(input.charAt(i++));
        c1 = e1 << 2 | e2 >> 4;
        o += String.fromCharCode(c1);
        e3 = $b8f343bf88dacc48$var$Base64_map.indexOf(input.charAt(i++));
        c2 = (e2 & 15) << 4 | e3 >> 2;
        if (e3 !== 64) o += String.fromCharCode(c2);
        e4 = $b8f343bf88dacc48$var$Base64_map.indexOf(input.charAt(i++));
        c3 = (e3 & 3) << 6 | e4;
        if (e4 !== 64) o += String.fromCharCode(c3);
    }
    return o;
}
var $b8f343bf88dacc48$var$has_buf = /*#__PURE__*/ function() {
    return typeof $b8f343bf88dacc48$require$Buffer !== 'undefined' && typeof $l52Gj !== 'undefined' && typeof $l52Gj.versions !== 'undefined' && !!$l52Gj.versions.node;
}();
var $b8f343bf88dacc48$var$Buffer_from = /*#__PURE__*/ function() {
    if (typeof $b8f343bf88dacc48$require$Buffer !== 'undefined') {
        var nbfs = !$b8f343bf88dacc48$require$Buffer.from;
        if (!nbfs) try {
            $b8f343bf88dacc48$require$Buffer.from("foo", "utf8");
        } catch (e) {
            nbfs = true;
        }
        return nbfs ? function(buf, enc) {
            return enc ? new $b8f343bf88dacc48$require$Buffer(buf, enc) : new $b8f343bf88dacc48$require$Buffer(buf);
        } : $b8f343bf88dacc48$require$Buffer.from.bind($b8f343bf88dacc48$require$Buffer);
    }
    return function() {};
}();
var $b8f343bf88dacc48$var$buf_utf16le = /*#__PURE__*/ function() {
    if (typeof $b8f343bf88dacc48$require$Buffer === 'undefined') return false;
    var x = $b8f343bf88dacc48$var$Buffer_from([
        65,
        0
    ]);
    if (!x) return false;
    var o = x.toString("utf16le");
    return o.length == 1;
}();
function $b8f343bf88dacc48$var$new_raw_buf(len /*:number*/ ) {
    /* jshint -W056 */ if ($b8f343bf88dacc48$var$has_buf) return $b8f343bf88dacc48$require$Buffer.alloc ? $b8f343bf88dacc48$require$Buffer.alloc(len) : new $b8f343bf88dacc48$require$Buffer(len);
    return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
/* jshint +W056 */ }
function $b8f343bf88dacc48$var$new_unsafe_buf(len /*:number*/ ) {
    /* jshint -W056 */ if ($b8f343bf88dacc48$var$has_buf) return $b8f343bf88dacc48$require$Buffer.allocUnsafe ? $b8f343bf88dacc48$require$Buffer.allocUnsafe(len) : new $b8f343bf88dacc48$require$Buffer(len);
    return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
/* jshint +W056 */ }
var $b8f343bf88dacc48$var$s2a = function s2a(s /*:string*/ ) /*:any*/ {
    if ($b8f343bf88dacc48$var$has_buf) return $b8f343bf88dacc48$var$Buffer_from(s, "binary");
    return s.split("").map(function(x /*:string*/ ) /*:number*/ {
        return x.charCodeAt(0) & 0xff;
    });
};
function $b8f343bf88dacc48$var$s2ab(s /*:string*/ ) /*:any*/ {
    if (typeof ArrayBuffer === 'undefined') return $b8f343bf88dacc48$var$s2a(s);
    var buf = new ArrayBuffer(s.length), view = new Uint8Array(buf);
    for(var i = 0; i != s.length; ++i)view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
}
function $b8f343bf88dacc48$var$a2s(data /*:any*/ ) /*:string*/ {
    if (Array.isArray(data)) return data.map(function(c) {
        return String.fromCharCode(c);
    }).join("");
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length; ++i)o[i] = String.fromCharCode(data[i]);
    return o.join("");
}
function $b8f343bf88dacc48$var$a2u(data /*:Array<number>*/ ) /*:Uint8Array*/ {
    if (typeof Uint8Array === 'undefined') throw new Error("Unsupported");
    return new Uint8Array(data);
}
function $b8f343bf88dacc48$var$ab2a(data /*:ArrayBuffer|Uint8Array*/ ) /*:Array<number>*/ {
    if (typeof ArrayBuffer == 'undefined') throw new Error("Unsupported");
    if (data instanceof ArrayBuffer) return $b8f343bf88dacc48$var$ab2a(new Uint8Array(data));
    /*:: if(data instanceof ArrayBuffer) throw new Error("unreachable"); */ var o = new Array(data.length);
    for(var i = 0; i < data.length; ++i)o[i] = data[i];
    return o;
}
var $b8f343bf88dacc48$var$bconcat = $b8f343bf88dacc48$var$has_buf ? function(bufs) {
    return $b8f343bf88dacc48$require$Buffer.concat(bufs.map(function(buf) {
        return $b8f343bf88dacc48$require$Buffer.isBuffer(buf) ? buf : $b8f343bf88dacc48$var$Buffer_from(buf);
    }));
} : function(bufs) {
    if (typeof Uint8Array !== "undefined") {
        var i = 0, maxlen = 0;
        for(i = 0; i < bufs.length; ++i)maxlen += bufs[i].length;
        var o = new Uint8Array(maxlen);
        var len = 0;
        for(i = 0, maxlen = 0; i < bufs.length; maxlen += len, ++i){
            len = bufs[i].length;
            if (bufs[i] instanceof Uint8Array) o.set(bufs[i], maxlen);
            else if (typeof bufs[i] == "string") o.set(new Uint8Array($b8f343bf88dacc48$var$s2a(bufs[i])), maxlen);
            else o.set(new Uint8Array(bufs[i]), maxlen);
        }
        return o;
    }
    return [].concat.apply([], bufs.map(function(buf) {
        return Array.isArray(buf) ? buf : [].slice.call(buf);
    }));
};
function $b8f343bf88dacc48$var$utf8decode(content /*:string*/ ) {
    var out = [], widx = 0, L = content.length + 250;
    var o = $b8f343bf88dacc48$var$new_raw_buf(content.length + 255);
    for(var ridx = 0; ridx < content.length; ++ridx){
        var c = content.charCodeAt(ridx);
        if (c < 0x80) o[widx++] = c;
        else if (c < 0x800) {
            o[widx++] = 192 | c >> 6 & 31;
            o[widx++] = 128 | c & 63;
        } else if (c >= 0xD800 && c < 0xE000) {
            c = (c & 1023) + 64;
            var d = content.charCodeAt(++ridx) & 1023;
            o[widx++] = 240 | c >> 8 & 7;
            o[widx++] = 128 | c >> 2 & 63;
            o[widx++] = 128 | d >> 6 & 15 | (c & 3) << 4;
            o[widx++] = 128 | d & 63;
        } else {
            o[widx++] = 224 | c >> 12 & 15;
            o[widx++] = 128 | c >> 6 & 63;
            o[widx++] = 128 | c & 63;
        }
        if (widx > L) {
            out.push(o.slice(0, widx));
            widx = 0;
            o = $b8f343bf88dacc48$var$new_raw_buf(65535);
            L = 65530;
        }
    }
    out.push(o.slice(0, widx));
    return $b8f343bf88dacc48$var$bconcat(out);
}
var $b8f343bf88dacc48$var$chr0 = /\u0000/g, $b8f343bf88dacc48$var$chr1 = /[\u0001-\u0006]/g;
/*::
declare type Block = any;
declare type BufArray = {
	newblk(sz:number):Block;
	next(sz:number):Block;
	end():any;
	push(buf:Block):void;
};

type RecordHopperCB = {(d:any, Rn:string, RT:number):?boolean;};

type EvertType = {[string]:string};
type EvertNumType = {[string]:number};
type EvertArrType = {[string]:Array<string>};

type StringConv = {(string):string};

*/ /* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */ /*jshint -W041 */ function $b8f343bf88dacc48$var$_strrev(x /*:string*/ ) /*:string*/ {
    var o = "", i = x.length - 1;
    while(i >= 0)o += x.charAt(i--);
    return o;
}
function $b8f343bf88dacc48$var$pad0(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $b8f343bf88dacc48$var$fill('0', d - t.length) + t;
}
function $b8f343bf88dacc48$var$pad_(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $b8f343bf88dacc48$var$fill(' ', d - t.length) + t;
}
function $b8f343bf88dacc48$var$rpad_(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : t + $b8f343bf88dacc48$var$fill(' ', d - t.length);
}
function $b8f343bf88dacc48$var$pad0r1(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + Math.round(v);
    return t.length >= d ? t : $b8f343bf88dacc48$var$fill('0', d - t.length) + t;
}
function $b8f343bf88dacc48$var$pad0r2(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $b8f343bf88dacc48$var$fill('0', d - t.length) + t;
}
var $b8f343bf88dacc48$var$p2_32 = /*#__PURE__*/ Math.pow(2, 32);
function $b8f343bf88dacc48$var$pad0r(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    if (v > $b8f343bf88dacc48$var$p2_32 || v < -$b8f343bf88dacc48$var$p2_32) return $b8f343bf88dacc48$var$pad0r1(v, d);
    var i = Math.round(v);
    return $b8f343bf88dacc48$var$pad0r2(i, d);
}
/* yes, in 2022 this is still faster than string compare */ function $b8f343bf88dacc48$var$SSF_isgeneral(s /*:string*/ , i /*:?number*/ ) /*:boolean*/ {
    i = i || 0;
    return s.length >= 7 + i && (s.charCodeAt(i) | 32) === 103 && (s.charCodeAt(i + 1) | 32) === 101 && (s.charCodeAt(i + 2) | 32) === 110 && (s.charCodeAt(i + 3) | 32) === 101 && (s.charCodeAt(i + 4) | 32) === 114 && (s.charCodeAt(i + 5) | 32) === 97 && (s.charCodeAt(i + 6) | 32) === 108;
}
var $b8f343bf88dacc48$var$days /*:Array<Array<string> >*/  = [
    [
        'Sun',
        'Sunday'
    ],
    [
        'Mon',
        'Monday'
    ],
    [
        'Tue',
        'Tuesday'
    ],
    [
        'Wed',
        'Wednesday'
    ],
    [
        'Thu',
        'Thursday'
    ],
    [
        'Fri',
        'Friday'
    ],
    [
        'Sat',
        'Saturday'
    ]
];
var $b8f343bf88dacc48$var$months /*:Array<Array<string> >*/  = [
    [
        'J',
        'Jan',
        'January'
    ],
    [
        'F',
        'Feb',
        'February'
    ],
    [
        'M',
        'Mar',
        'March'
    ],
    [
        'A',
        'Apr',
        'April'
    ],
    [
        'M',
        'May',
        'May'
    ],
    [
        'J',
        'Jun',
        'June'
    ],
    [
        'J',
        'Jul',
        'July'
    ],
    [
        'A',
        'Aug',
        'August'
    ],
    [
        'S',
        'Sep',
        'September'
    ],
    [
        'O',
        'Oct',
        'October'
    ],
    [
        'N',
        'Nov',
        'November'
    ],
    [
        'D',
        'Dec',
        'December'
    ]
];
function $b8f343bf88dacc48$var$SSF_init_table(t /*:any*/ ) {
    if (!t) t = {};
    t[0] = 'General';
    t[1] = '0';
    t[2] = '0.00';
    t[3] = '#,##0';
    t[4] = '#,##0.00';
    t[9] = '0%';
    t[10] = '0.00%';
    t[11] = '0.00E+00';
    t[12] = '# ?/?';
    t[13] = '# ??/??';
    t[14] = 'm/d/yy';
    t[15] = 'd-mmm-yy';
    t[16] = 'd-mmm';
    t[17] = 'mmm-yy';
    t[18] = 'h:mm AM/PM';
    t[19] = 'h:mm:ss AM/PM';
    t[20] = 'h:mm';
    t[21] = 'h:mm:ss';
    t[22] = 'm/d/yy h:mm';
    t[37] = '#,##0 ;(#,##0)';
    t[38] = '#,##0 ;[Red](#,##0)';
    t[39] = '#,##0.00;(#,##0.00)';
    t[40] = '#,##0.00;[Red](#,##0.00)';
    t[45] = 'mm:ss';
    t[46] = '[h]:mm:ss';
    t[47] = 'mmss.0';
    t[48] = '##0.0E+0';
    t[49] = '@';
    t[56] = '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "';
    return t;
}
/* repeated to satiate webpack */ var $b8f343bf88dacc48$var$table_fmt = {
    0: 'General',
    1: '0',
    2: '0.00',
    3: '#,##0',
    4: '#,##0.00',
    9: '0%',
    10: '0.00%',
    11: '0.00E+00',
    12: '# ?/?',
    13: '# ??/??',
    14: 'm/d/yy',
    15: 'd-mmm-yy',
    16: 'd-mmm',
    17: 'mmm-yy',
    18: 'h:mm AM/PM',
    19: 'h:mm:ss AM/PM',
    20: 'h:mm',
    21: 'h:mm:ss',
    22: 'm/d/yy h:mm',
    37: '#,##0 ;(#,##0)',
    38: '#,##0 ;[Red](#,##0)',
    39: '#,##0.00;(#,##0.00)',
    40: '#,##0.00;[Red](#,##0.00)',
    45: 'mm:ss',
    46: '[h]:mm:ss',
    47: 'mmss.0',
    48: '##0.0E+0',
    49: '@',
    56: '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "'
};
/* Defaults determined by systematically testing in Excel 2019 */ /* These formats appear to default to other formats in the table */ var $b8f343bf88dacc48$var$SSF_default_map = {
    5: 37,
    6: 38,
    7: 39,
    8: 40,
    23: 0,
    24: 0,
    25: 0,
    26: 0,
    27: 14,
    28: 14,
    29: 14,
    30: 14,
    31: 14,
    50: 14,
    51: 14,
    52: 14,
    53: 14,
    54: 14,
    55: 14,
    56: 14,
    57: 14,
    58: 14,
    59: 1,
    60: 2,
    61: 3,
    62: 4,
    67: 9,
    68: 10,
    69: 12,
    70: 13,
    71: 14,
    72: 14,
    73: 15,
    74: 16,
    75: 17,
    76: 20,
    77: 21,
    78: 22,
    79: 45,
    80: 46,
    81: 47,
    82: 0 // 82 ->  0 ... 65536 -> 0 (omitted)
};
/* These formats technically refer to Accounting formats with no equivalent */ var $b8f343bf88dacc48$var$SSF_default_str = {
    //  5 -- Currency,   0 decimal, black negative
    5: '"$"#,##0_);\\("$"#,##0\\)',
    63: '"$"#,##0_);\\("$"#,##0\\)',
    //  6 -- Currency,   0 decimal, red   negative
    6: '"$"#,##0_);[Red]\\("$"#,##0\\)',
    64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
    //  7 -- Currency,   2 decimal, black negative
    7: '"$"#,##0.00_);\\("$"#,##0.00\\)',
    65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
    //  8 -- Currency,   2 decimal, red   negative
    8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    // 41 -- Accounting, 0 decimal, No Symbol
    41: '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',
    // 42 -- Accounting, 0 decimal, $  Symbol
    42: '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',
    // 43 -- Accounting, 2 decimal, No Symbol
    43: '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',
    // 44 -- Accounting, 2 decimal, $  Symbol
    44: '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'
};
function $b8f343bf88dacc48$var$SSF_frac(x /*:number*/ , D /*:number*/ , mixed /*:?boolean*/ ) /*:Array<number>*/ {
    var sgn = x < 0 ? -1 : 1;
    var B = x * sgn;
    var P_2 = 0, P_1 = 1, P = 0;
    var Q_2 = 1, Q_1 = 0, Q = 0;
    var A = Math.floor(B);
    while(Q_1 < D){
        A = Math.floor(B);
        P = A * P_1 + P_2;
        Q = A * Q_1 + Q_2;
        if (B - A < 0.00000005) break;
        B = 1 / (B - A);
        P_2 = P_1;
        P_1 = P;
        Q_2 = Q_1;
        Q_1 = Q;
    }
    if (Q > D) {
        if (Q_1 > D) {
            Q = Q_2;
            P = P_2;
        } else {
            Q = Q_1;
            P = P_1;
        }
    }
    if (!mixed) return [
        0,
        sgn * P,
        Q
    ];
    var q = Math.floor(sgn * P / Q);
    return [
        q,
        sgn * P - q * Q,
        Q
    ];
}
function $b8f343bf88dacc48$var$SSF_normalize_xl_unsafe(v /*:number*/ ) /*:number*/ {
    var s = v.toPrecision(16);
    if (s.indexOf("e") > -1) {
        var m = s.slice(0, s.indexOf("e"));
        m = m.indexOf(".") > -1 ? m.slice(0, m.slice(0, 2) == "0." ? 17 : 16) : m.slice(0, 15) + $b8f343bf88dacc48$var$fill("0", m.length - 15);
        return m + s.slice(s.indexOf("e"));
    }
    var n = s.indexOf(".") > -1 ? s.slice(0, s.slice(0, 2) == "0." ? 17 : 16) : s.slice(0, 15) + $b8f343bf88dacc48$var$fill("0", s.length - 15);
    return Number(n);
}
function $b8f343bf88dacc48$var$SSF_parse_date_code(v /*:number*/ , opts /*:?any*/ , b2 /*:?boolean*/ ) {
    if (v > 2958465 || v < 0) return null;
    v = $b8f343bf88dacc48$var$SSF_normalize_xl_unsafe(v);
    var date = v | 0, time = Math.floor(86400 * (v - date)), dow = 0;
    var dout = [];
    var out = {
        D: date,
        T: time,
        u: 86400 * (v - date) - time,
        y: 0,
        m: 0,
        d: 0,
        H: 0,
        M: 0,
        S: 0,
        q: 0
    };
    if (Math.abs(out.u) < 1e-6) out.u = 0;
    if (opts && opts.date1904) date += 1462;
    if (out.u > 0.9999) {
        out.u = 0;
        if (++time == 86400) {
            out.T = time = 0;
            ++date;
            ++out.D;
        }
    }
    if (date === 60) {
        dout = b2 ? [
            1317,
            10,
            29
        ] : [
            1900,
            2,
            29
        ];
        dow = 3;
    } else if (date === 0) {
        dout = b2 ? [
            1317,
            8,
            29
        ] : [
            1900,
            1,
            0
        ];
        dow = 6;
    } else {
        if (date > 60) --date;
        /* 1 = Jan 1 1900 in Gregorian */ var d = new Date(1900, 0, 1);
        d.setDate(d.getDate() + date - 1);
        dout = [
            d.getFullYear(),
            d.getMonth() + 1,
            d.getDate()
        ];
        dow = d.getDay();
        if (date < 60) dow = (dow + 6) % 7;
        if (b2) dow = $b8f343bf88dacc48$var$SSF_fix_hijri(d, dout);
    }
    out.y = dout[0];
    out.m = dout[1];
    out.d = dout[2];
    out.S = time % 60;
    time = Math.floor(time / 60);
    out.M = time % 60;
    time = Math.floor(time / 60);
    out.H = time;
    out.q = dow;
    return out;
}
/* ECMA-376 18.8.30 numFmt*/ /* Note: `toPrecision` uses standard form when prec > E and E >= -6 */ /* exponent >= -9 and <= 9 */ function $b8f343bf88dacc48$var$SSF_strip_decimal(o /*:string*/ ) /*:string*/ {
    return o.indexOf(".") == -1 ? o : o.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, "$1");
}
/* General Exponential always shows 2 digits exp and trims the mantissa */ function $b8f343bf88dacc48$var$SSF_normalize_exp(o /*:string*/ ) /*:string*/ {
    if (o.indexOf("E") == -1) return o;
    return o.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/, "$1E").replace(/(E[+-])(\d)$/, "$10$2");
}
/* exponent >= -9 and <= 9 */ function $b8f343bf88dacc48$var$SSF_small_exp(v /*:number*/ ) /*:string*/ {
    var w = v < 0 ? 12 : 11;
    var o = $b8f343bf88dacc48$var$SSF_strip_decimal(v.toFixed(12));
    if (o.length <= w) return o;
    o = v.toPrecision(10);
    if (o.length <= w) return o;
    return v.toExponential(5);
}
/* exponent >= 11 or <= -10 likely exponential */ function $b8f343bf88dacc48$var$SSF_large_exp(v /*:number*/ ) /*:string*/ {
    var o = $b8f343bf88dacc48$var$SSF_strip_decimal(v.toFixed(11));
    return o.length > (v < 0 ? 12 : 11) || o === "0" || o === "-0" ? v.toPrecision(6) : o;
}
function $b8f343bf88dacc48$var$SSF_general_num(v /*:number*/ ) /*:string*/ {
    var V = Math.floor(Math.log(Math.abs(v)) * Math.LOG10E), o;
    if (V >= -4 && V <= -1) o = v.toPrecision(10 + V);
    else if (Math.abs(V) <= 9) o = $b8f343bf88dacc48$var$SSF_small_exp(v);
    else if (V === 10) o = v.toFixed(10).substr(0, 12);
    else o = $b8f343bf88dacc48$var$SSF_large_exp(v);
    return $b8f343bf88dacc48$var$SSF_strip_decimal($b8f343bf88dacc48$var$SSF_normalize_exp(o.toUpperCase()));
}
/*
	"General" rules:
	- text is passed through ("@")
	- booleans are rendered as TRUE/FALSE
	- "up to 11 characters" displayed for numbers
	- Default date format (code 14) used for Dates

	The longest 32-bit integer text is "-2147483648", exactly 11 chars
	TODO: technically the display depends on the width of the cell
*/ function $b8f343bf88dacc48$var$SSF_general(v /*:any*/ , opts /*:any*/ ) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? "TRUE" : "FALSE";
        case 'number':
            return (v | 0) === v ? v.toString(10) : $b8f343bf88dacc48$var$SSF_general_num(v);
        case 'undefined':
            return "";
        case 'object':
            if (v == null) return "";
            if (v instanceof Date) return $b8f343bf88dacc48$var$SSF_format(14, $b8f343bf88dacc48$var$datenum(v, opts && opts.date1904), opts);
    }
    throw new Error("unsupported value in General format: " + v);
}
function $b8f343bf88dacc48$var$SSF_fix_hijri(date /*:Date*/ , o /*:[number, number, number]*/ ) {
    /* TODO: properly adjust y/m/d and  */ o[0] -= 581;
    var dow = date.getDay();
    if (date < 60) dow = (dow + 6) % 7;
    return dow;
}
//var THAI_DIGITS = "\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59".split("");
function $b8f343bf88dacc48$var$SSF_write_date(type /*:number*/ , fmt /*:string*/ , val, ss0 /*:?number*/ ) /*:string*/ {
    var o = "", ss = 0, tt = 0, y = val.y, out, outl = 0;
    switch(type){
        case 98:
            /* 'b' buddhist year */ y = val.y + 543;
        /* falls through */ case 121:
            /* 'y' year */ switch(fmt.length){
                case 1:
                case 2:
                    out = y % 100;
                    outl = 2;
                    break;
                default:
                    out = y % 10000;
                    outl = 4;
                    break;
            }
            break;
        case 109:
            /* 'm' month */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.m;
                    outl = fmt.length;
                    break;
                case 3:
                    return $b8f343bf88dacc48$var$months[val.m - 1][1];
                case 5:
                    return $b8f343bf88dacc48$var$months[val.m - 1][0];
                default:
                    return $b8f343bf88dacc48$var$months[val.m - 1][2];
            }
            break;
        case 100:
            /* 'd' day */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.d;
                    outl = fmt.length;
                    break;
                case 3:
                    return $b8f343bf88dacc48$var$days[val.q][0];
                default:
                    return $b8f343bf88dacc48$var$days[val.q][1];
            }
            break;
        case 104:
            /* 'h' 12-hour */ switch(fmt.length){
                case 1:
                case 2:
                    out = 1 + (val.H + 11) % 12;
                    outl = fmt.length;
                    break;
                default:
                    throw 'bad hour format: ' + fmt;
            }
            break;
        case 72:
            /* 'H' 24-hour */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.H;
                    outl = fmt.length;
                    break;
                default:
                    throw 'bad hour format: ' + fmt;
            }
            break;
        case 77:
            /* 'M' minutes */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.M;
                    outl = fmt.length;
                    break;
                default:
                    throw 'bad minute format: ' + fmt;
            }
            break;
        case 115:
            /* 's' seconds */ if (fmt != 's' && fmt != 'ss' && fmt != '.0' && fmt != '.00' && fmt != '.000') throw 'bad second format: ' + fmt;
            if (val.u === 0 && (fmt == "s" || fmt == "ss")) return $b8f343bf88dacc48$var$pad0(val.S, fmt.length);
            /*::if(!ss0) ss0 = 0; */ if (ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
            else tt = ss0 === 1 ? 10 : 1;
            ss = Math.round(tt * (val.S + val.u));
            if (ss >= 60 * tt) ss = 0;
            if (fmt === 's') return ss === 0 ? "0" : "" + ss / tt;
            o = $b8f343bf88dacc48$var$pad0(ss, 2 + ss0);
            if (fmt === 'ss') return o.substr(0, 2);
            return "." + o.substr(2, fmt.length - 1);
        case 90:
            /* 'Z' absolute time */ switch(fmt){
                case '[h]':
                case '[hh]':
                    out = val.D * 24 + val.H;
                    break;
                case '[m]':
                case '[mm]':
                    out = (val.D * 24 + val.H) * 60 + val.M;
                    break;
                case '[s]':
                case '[ss]':
                    out = ((val.D * 24 + val.H) * 60 + val.M) * 60 + (ss0 == 0 ? Math.round(val.S + val.u) : val.S);
                    break;
                default:
                    throw 'bad abstime format: ' + fmt;
            }
            outl = fmt.length === 3 ? 1 : 2;
            break;
        case 101:
            /* 'e' era */ out = y;
            outl = 1;
            break;
    }
    var outstr = outl > 0 ? $b8f343bf88dacc48$var$pad0(out, outl) : "";
    return outstr;
}
/*jshint -W086 */ /*jshint +W086 */ function $b8f343bf88dacc48$var$commaify(s /*:string*/ ) /*:string*/ {
    var w = 3;
    if (s.length <= w) return s;
    var j = s.length % w, o = s.substr(0, j);
    for(; j != s.length; j += w)o += (o.length > 0 ? "," : "") + s.substr(j, w);
    return o;
}
var $b8f343bf88dacc48$var$pct1 = /%/g;
function $b8f343bf88dacc48$var$write_num_pct(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var sfmt = fmt.replace($b8f343bf88dacc48$var$pct1, ""), mul = fmt.length - sfmt.length;
    return $b8f343bf88dacc48$var$write_num(type, sfmt, val * Math.pow(10, 2 * mul)) + $b8f343bf88dacc48$var$fill("%", mul);
}
function $b8f343bf88dacc48$var$write_num_cm(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var idx = fmt.length - 1;
    while(fmt.charCodeAt(idx - 1) === 44)--idx;
    return $b8f343bf88dacc48$var$write_num(type, fmt.substr(0, idx), val / Math.pow(10, 3 * (fmt.length - idx)));
}
function $b8f343bf88dacc48$var$write_num_exp(fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var o /*:string*/ ;
    var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
    if (fmt.match(/^#+0.0E\+0$/)) {
        if (val == 0) return "0.0E+0";
        else if (val < 0) return "-" + $b8f343bf88dacc48$var$write_num_exp(fmt, -val);
        var period = fmt.indexOf(".");
        if (period === -1) period = fmt.indexOf('E');
        var ee = Math.floor(Math.log(val) * Math.LOG10E) % period;
        if (ee < 0) ee += period;
        o = (val / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);
        if (o.indexOf("e") === -1) {
            var fakee = Math.floor(Math.log(val) * Math.LOG10E);
            if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
            else o += "E+" + (fakee - ee);
            while(o.substr(0, 2) === "0."){
                o = o.charAt(0) + o.substr(2, period) + "." + o.substr(2 + period);
                o = o.replace(/^0+([1-9])/, "$1").replace(/^0+\./, "0.");
            }
            o = o.replace(/\+-/, "-");
        }
        o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function($$, $1, $2, $3) {
            return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
        });
    } else o = val.toExponential(idx);
    if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
    if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
    return o.replace("e", "E");
}
var $b8f343bf88dacc48$var$frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
function $b8f343bf88dacc48$var$write_num_f1(r /*:Array<string>*/ , aval /*:number*/ , sign /*:string*/ ) /*:string*/ {
    var den = parseInt(r[4], 10), rr = Math.round(aval * den), base = Math.floor(rr / den);
    var myn = rr - base * den, myd = den;
    return sign + (base === 0 ? "" : "" + base) + " " + (myn === 0 ? $b8f343bf88dacc48$var$fill(" ", r[1].length + 1 + r[4].length) : $b8f343bf88dacc48$var$pad_(myn, r[1].length) + r[2] + "/" + r[3] + $b8f343bf88dacc48$var$pad0(myd, r[4].length));
}
function $b8f343bf88dacc48$var$write_num_f2(r /*:Array<string>*/ , aval /*:number*/ , sign /*:string*/ ) /*:string*/ {
    return sign + (aval === 0 ? "" : "" + aval) + $b8f343bf88dacc48$var$fill(" ", r[1].length + 2 + r[4].length);
}
var $b8f343bf88dacc48$var$dec1 = /^#*0*\.([0#]+)/;
var $b8f343bf88dacc48$var$closeparen = /\)[^)]*[0#]/;
var $b8f343bf88dacc48$var$phone = /\(###\) ###\\?-####/;
function $b8f343bf88dacc48$var$hashq(str /*:string*/ ) /*:string*/ {
    var o = "", cc;
    for(var i = 0; i != str.length; ++i)switch(cc = str.charCodeAt(i)){
        case 35:
            break;
        case 63:
            o += " ";
            break;
        case 48:
            o += "0";
            break;
        default:
            o += String.fromCharCode(cc);
    }
    return o;
}
function $b8f343bf88dacc48$var$rnd(val /*:number*/ , d /*:number*/ ) /*:string*/ {
    var dd = Math.pow(10, d);
    return "" + Math.round(val * dd) / dd;
}
function $b8f343bf88dacc48$var$dec(val /*:number*/ , d /*:number*/ ) /*:number*/ {
    var _frac = val - Math.floor(val), dd = Math.pow(10, d);
    if (d < ('' + Math.round(_frac * dd)).length) return 0;
    return Math.round(_frac * dd);
}
function $b8f343bf88dacc48$var$carry(val /*:number*/ , d /*:number*/ ) /*:number*/ {
    if (d < ('' + Math.round((val - Math.floor(val)) * Math.pow(10, d))).length) return 1;
    return 0;
}
function $b8f343bf88dacc48$var$flr(val /*:number*/ ) /*:string*/ {
    if (val < 2147483647 && val > -2147483648) return "" + (val >= 0 ? val | 0 : val - 1 | 0);
    return "" + Math.floor(val);
}
function $b8f343bf88dacc48$var$write_num_flt(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    if (type.charCodeAt(0) === 40 && !fmt.match($b8f343bf88dacc48$var$closeparen)) {
        var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        if (val >= 0) return $b8f343bf88dacc48$var$write_num_flt('n', ffmt, val);
        return '(' + $b8f343bf88dacc48$var$write_num_flt('n', ffmt, -val) + ')';
    }
    if (fmt.charCodeAt(fmt.length - 1) === 44) return $b8f343bf88dacc48$var$write_num_cm(type, fmt, val);
    if (fmt.indexOf('%') !== -1) return $b8f343bf88dacc48$var$write_num_pct(type, fmt, val);
    if (fmt.indexOf('E') !== -1) return $b8f343bf88dacc48$var$write_num_exp(fmt, val);
    if (fmt.charCodeAt(0) === 36) return "$" + $b8f343bf88dacc48$var$write_num_flt(type, fmt.substr(fmt.charAt(1) == ' ' ? 2 : 1), val);
    var o;
    var r /*:?Array<string>*/ , ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
    if (fmt.match(/^00+$/)) return sign + $b8f343bf88dacc48$var$pad0r(aval, fmt.length);
    if (fmt.match(/^[#?]+$/)) {
        o = $b8f343bf88dacc48$var$pad0r(val, 0);
        if (o === "0") o = "";
        return o.length > fmt.length ? o : $b8f343bf88dacc48$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match($b8f343bf88dacc48$var$frac1)) return $b8f343bf88dacc48$var$write_num_f1(r, aval, sign);
    if (fmt.match(/^#+0+$/)) return sign + $b8f343bf88dacc48$var$pad0r(aval, fmt.length - fmt.indexOf("0"));
    if (r = fmt.match($b8f343bf88dacc48$var$dec1)) {
        o = $b8f343bf88dacc48$var$rnd(val, r[1].length).replace(/^([^\.]+)$/, "$1." + $b8f343bf88dacc48$var$hashq(r[1])).replace(/\.$/, "." + $b8f343bf88dacc48$var$hashq(r[1])).replace(/\.(\d*)$/, function($$, $1) {
            return "." + $1 + $b8f343bf88dacc48$var$fill("0", $b8f343bf88dacc48$var$hashq(/*::(*/ r /*::||[""])*/ [1]).length - $1.length);
        });
        return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
    }
    fmt = fmt.replace(/^#+([0.])/, "$1");
    if (r = fmt.match(/^(0*)\.(#*)$/)) return sign + $b8f343bf88dacc48$var$rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
    if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + $b8f343bf88dacc48$var$commaify($b8f343bf88dacc48$var$pad0r(aval, 0));
    if (r = fmt.match(/^#,##0\.([#0]*0)$/)) return val < 0 ? "-" + $b8f343bf88dacc48$var$write_num_flt(type, fmt, -val) : $b8f343bf88dacc48$var$commaify("" + (Math.floor(val) + $b8f343bf88dacc48$var$carry(val, r[1].length))) + "." + $b8f343bf88dacc48$var$pad0($b8f343bf88dacc48$var$dec(val, r[1].length), r[1].length);
    if (r = fmt.match(/^#,#*,#0/)) return $b8f343bf88dacc48$var$write_num_flt(type, fmt.replace(/^#,#*,/, ""), val);
    if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
        o = $b8f343bf88dacc48$var$_strrev($b8f343bf88dacc48$var$write_num_flt(type, fmt.replace(/[\\-]/g, ""), val));
        ri = 0;
        return $b8f343bf88dacc48$var$_strrev($b8f343bf88dacc48$var$_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function(x) {
            return ri < o.length ? o.charAt(ri++) : x === '0' ? '0' : "";
        }));
    }
    if (fmt.match($b8f343bf88dacc48$var$phone)) {
        o = $b8f343bf88dacc48$var$write_num_flt(type, "##########", val);
        return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
    }
    var oa = "";
    if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(/*::String(*/ r[4]/*::)*/ .length, 7);
        ff = $b8f343bf88dacc48$var$SSF_frac(aval, Math.pow(10, ri) - 1, false);
        o = "" + sign;
        oa = $b8f343bf88dacc48$var$write_num("n", /*::String(*/ r[1], ff[1]);
        if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
        o += oa + /*::String(*/ r[2] + "/" + /*::String(*/ r[3] /*::)*/ ;
        oa = $b8f343bf88dacc48$var$rpad_(ff[2], ri);
        if (oa.length < r[4].length) oa = $b8f343bf88dacc48$var$hashq(r[4].substr(r[4].length - oa.length)) + oa;
        o += oa;
        return o;
    }
    if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(Math.max(r[1].length, r[4].length), 7);
        ff = $b8f343bf88dacc48$var$SSF_frac(aval, Math.pow(10, ri) - 1, true);
        return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? $b8f343bf88dacc48$var$pad_(ff[1], ri) + r[2] + "/" + r[3] + $b8f343bf88dacc48$var$rpad_(ff[2], ri) : $b8f343bf88dacc48$var$fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
    }
    if (r = fmt.match(/^[#0?]+$/)) {
        o = $b8f343bf88dacc48$var$pad0r(val, 0);
        if (fmt.length <= o.length) return o;
        return $b8f343bf88dacc48$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match(/^([#0?]+)\.([#0]+)$/)) {
        o = "" + val.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
        ri = o.indexOf(".");
        var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
        return $b8f343bf88dacc48$var$hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
    }
    if (r = fmt.match(/^00,000\.([#0]*0)$/)) {
        ri = $b8f343bf88dacc48$var$dec(val, r[1].length);
        return val < 0 ? "-" + $b8f343bf88dacc48$var$write_num_flt(type, fmt, -val) : $b8f343bf88dacc48$var$commaify($b8f343bf88dacc48$var$flr(val)).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function($$) {
            return "00," + ($$.length < 3 ? $b8f343bf88dacc48$var$pad0(0, 3 - $$.length) : "") + $$;
        }) + "." + $b8f343bf88dacc48$var$pad0(ri, r[1].length);
    }
    switch(fmt){
        case "###,##0.00":
            return $b8f343bf88dacc48$var$write_num_flt(type, "#,##0.00", val);
        case "###,###":
        case "##,###":
        case "#,###":
            var x = $b8f343bf88dacc48$var$commaify($b8f343bf88dacc48$var$pad0r(aval, 0));
            return x !== "0" ? sign + x : "";
        case "###,###.00":
            return $b8f343bf88dacc48$var$write_num_flt(type, "###,##0.00", val).replace(/^0\./, ".");
        case "#,###.00":
            return $b8f343bf88dacc48$var$write_num_flt(type, "#,##0.00", val).replace(/^0\./, ".");
        default:
    }
    throw new Error("unsupported format |" + fmt + "|");
}
function $b8f343bf88dacc48$var$write_num_cm2(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var idx = fmt.length - 1;
    while(fmt.charCodeAt(idx - 1) === 44)--idx;
    return $b8f343bf88dacc48$var$write_num(type, fmt.substr(0, idx), val / Math.pow(10, 3 * (fmt.length - idx)));
}
function $b8f343bf88dacc48$var$write_num_pct2(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var sfmt = fmt.replace($b8f343bf88dacc48$var$pct1, ""), mul = fmt.length - sfmt.length;
    return $b8f343bf88dacc48$var$write_num(type, sfmt, val * Math.pow(10, 2 * mul)) + $b8f343bf88dacc48$var$fill("%", mul);
}
function $b8f343bf88dacc48$var$write_num_exp2(fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var o /*:string*/ ;
    var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
    if (fmt.match(/^#+0.0E\+0$/)) {
        if (val == 0) return "0.0E+0";
        else if (val < 0) return "-" + $b8f343bf88dacc48$var$write_num_exp2(fmt, -val);
        var period = fmt.indexOf(".");
        if (period === -1) period = fmt.indexOf('E');
        var ee = Math.floor(Math.log(val) * Math.LOG10E) % period;
        if (ee < 0) ee += period;
        o = (val / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);
        if (!o.match(/[Ee]/)) {
            var fakee = Math.floor(Math.log(val) * Math.LOG10E);
            if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
            else o += "E+" + (fakee - ee);
            o = o.replace(/\+-/, "-");
        }
        o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function($$, $1, $2, $3) {
            return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
        });
    } else o = val.toExponential(idx);
    if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
    if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
    return o.replace("e", "E");
}
function $b8f343bf88dacc48$var$write_num_int(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    if (type.charCodeAt(0) === 40 && !fmt.match($b8f343bf88dacc48$var$closeparen)) {
        var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        if (val >= 0) return $b8f343bf88dacc48$var$write_num_int('n', ffmt, val);
        return '(' + $b8f343bf88dacc48$var$write_num_int('n', ffmt, -val) + ')';
    }
    if (fmt.charCodeAt(fmt.length - 1) === 44) return $b8f343bf88dacc48$var$write_num_cm2(type, fmt, val);
    if (fmt.indexOf('%') !== -1) return $b8f343bf88dacc48$var$write_num_pct2(type, fmt, val);
    if (fmt.indexOf('E') !== -1) return $b8f343bf88dacc48$var$write_num_exp2(fmt, val);
    if (fmt.charCodeAt(0) === 36) return "$" + $b8f343bf88dacc48$var$write_num_int(type, fmt.substr(fmt.charAt(1) == ' ' ? 2 : 1), val);
    var o;
    var r /*:?Array<string>*/ , ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
    if (fmt.match(/^00+$/)) return sign + $b8f343bf88dacc48$var$pad0(aval, fmt.length);
    if (fmt.match(/^[#?]+$/)) {
        o = "" + val;
        if (val === 0) o = "";
        return o.length > fmt.length ? o : $b8f343bf88dacc48$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match($b8f343bf88dacc48$var$frac1)) return $b8f343bf88dacc48$var$write_num_f2(r, aval, sign);
    if (fmt.match(/^#+0+$/)) return sign + $b8f343bf88dacc48$var$pad0(aval, fmt.length - fmt.indexOf("0"));
    if (r = fmt.match($b8f343bf88dacc48$var$dec1)) {
        /*:: if(!Array.isArray(r)) throw new Error("unreachable"); */ o = ("" + val).replace(/^([^\.]+)$/, "$1." + $b8f343bf88dacc48$var$hashq(r[1])).replace(/\.$/, "." + $b8f343bf88dacc48$var$hashq(r[1]));
        o = o.replace(/\.(\d*)$/, function($$, $1) {
            /*:: if(!Array.isArray(r)) throw new Error("unreachable"); */ return "." + $1 + $b8f343bf88dacc48$var$fill("0", $b8f343bf88dacc48$var$hashq(r[1]).length - $1.length);
        });
        return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
    }
    fmt = fmt.replace(/^#+([0.])/, "$1");
    if (r = fmt.match(/^(0*)\.(#*)$/)) return sign + ("" + aval).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
    if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + $b8f343bf88dacc48$var$commaify("" + aval);
    if (r = fmt.match(/^#,##0\.([#0]*0)$/)) return val < 0 ? "-" + $b8f343bf88dacc48$var$write_num_int(type, fmt, -val) : $b8f343bf88dacc48$var$commaify("" + val) + "." + $b8f343bf88dacc48$var$fill('0', r[1].length);
    if (r = fmt.match(/^#,#*,#0/)) return $b8f343bf88dacc48$var$write_num_int(type, fmt.replace(/^#,#*,/, ""), val);
    if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
        o = $b8f343bf88dacc48$var$_strrev($b8f343bf88dacc48$var$write_num_int(type, fmt.replace(/[\\-]/g, ""), val));
        ri = 0;
        return $b8f343bf88dacc48$var$_strrev($b8f343bf88dacc48$var$_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function(x) {
            return ri < o.length ? o.charAt(ri++) : x === '0' ? '0' : "";
        }));
    }
    if (fmt.match($b8f343bf88dacc48$var$phone)) {
        o = $b8f343bf88dacc48$var$write_num_int(type, "##########", val);
        return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
    }
    var oa = "";
    if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(/*::String(*/ r[4]/*::)*/ .length, 7);
        ff = $b8f343bf88dacc48$var$SSF_frac(aval, Math.pow(10, ri) - 1, false);
        o = "" + sign;
        oa = $b8f343bf88dacc48$var$write_num("n", /*::String(*/ r[1], ff[1]);
        if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
        o += oa + /*::String(*/ r[2] + "/" + /*::String(*/ r[3] /*::)*/ ;
        oa = $b8f343bf88dacc48$var$rpad_(ff[2], ri);
        if (oa.length < r[4].length) oa = $b8f343bf88dacc48$var$hashq(r[4].substr(r[4].length - oa.length)) + oa;
        o += oa;
        return o;
    }
    if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(Math.max(r[1].length, r[4].length), 7);
        ff = $b8f343bf88dacc48$var$SSF_frac(aval, Math.pow(10, ri) - 1, true);
        return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? $b8f343bf88dacc48$var$pad_(ff[1], ri) + r[2] + "/" + r[3] + $b8f343bf88dacc48$var$rpad_(ff[2], ri) : $b8f343bf88dacc48$var$fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
    }
    if (r = fmt.match(/^[#0?]+$/)) {
        o = "" + val;
        if (fmt.length <= o.length) return o;
        return $b8f343bf88dacc48$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match(/^([#0]+)\.([#0]+)$/)) {
        o = "" + val.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
        ri = o.indexOf(".");
        var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
        return $b8f343bf88dacc48$var$hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
    }
    if (r = fmt.match(/^00,000\.([#0]*0)$/)) return val < 0 ? "-" + $b8f343bf88dacc48$var$write_num_int(type, fmt, -val) : $b8f343bf88dacc48$var$commaify("" + val).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function($$) {
        return "00," + ($$.length < 3 ? $b8f343bf88dacc48$var$pad0(0, 3 - $$.length) : "") + $$;
    }) + "." + $b8f343bf88dacc48$var$pad0(0, r[1].length);
    switch(fmt){
        case "###,###":
        case "##,###":
        case "#,###":
            var x = $b8f343bf88dacc48$var$commaify("" + aval);
            return x !== "0" ? sign + x : "";
        default:
            if (fmt.match(/\.[0#?]*$/)) return $b8f343bf88dacc48$var$write_num_int(type, fmt.slice(0, fmt.lastIndexOf(".")), val) + $b8f343bf88dacc48$var$hashq(fmt.slice(fmt.lastIndexOf(".")));
    }
    throw new Error("unsupported format |" + fmt + "|");
}
function $b8f343bf88dacc48$var$write_num(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    return (val | 0) === val ? $b8f343bf88dacc48$var$write_num_int(type, fmt, val) : $b8f343bf88dacc48$var$write_num_flt(type, fmt, val);
}
function $b8f343bf88dacc48$var$SSF_split_fmt(fmt /*:string*/ ) /*:Array<string>*/ {
    var out /*:Array<string>*/  = [];
    var in_str = false /*, cc*/ ;
    for(var i = 0, j = 0; i < fmt.length; ++i)switch(/*cc=*/ fmt.charCodeAt(i)){
        case 34:
            /* '"' */ in_str = !in_str;
            break;
        case 95:
        case 42:
        case 92:
            /* '_' '*' '\\' */ ++i;
            break;
        case 59:
            /* ';' */ out[out.length] = fmt.substr(j, i - j);
            j = i + 1;
    }
    out[out.length] = fmt.substr(j);
    if (in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
    return out;
}
var $b8f343bf88dacc48$var$SSF_abstime = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
function $b8f343bf88dacc48$var$fmt_is_date(fmt /*:string*/ ) /*:boolean*/ {
    var i = 0, /*cc = 0,*/ c = "", o = "";
    while(i < fmt.length)switch(c = fmt.charAt(i)){
        case 'G':
            if ($b8f343bf88dacc48$var$SSF_isgeneral(fmt, i)) i += 6;
            i++;
            break;
        case '"':
            for(; /*cc=*/ fmt.charCodeAt(++i) !== 34 && i < fmt.length;);
            ++i;
            break;
        case '\\':
            i += 2;
            break;
        case '_':
            i += 2;
            break;
        case '@':
            ++i;
            break;
        case 'B':
        case 'b':
            if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") return true;
        /* falls through */ case 'M':
        case 'D':
        case 'Y':
        case 'H':
        case 'S':
        case 'E':
        /* falls through */ case 'm':
        case 'd':
        case 'y':
        case 'h':
        case 's':
        case 'e':
        case 'g':
            return true;
        case 'A':
        case 'a':
        case "\u4E0A":
            if (fmt.substr(i, 3).toUpperCase() === "A/P") return true;
            if (fmt.substr(i, 5).toUpperCase() === "AM/PM") return true;
            if (fmt.substr(i, 5).toUpperCase() === "\u4E0A\u5348/\u4E0B\u5348") return true;
            ++i;
            break;
        case '[':
            o = c;
            while(fmt.charAt(i++) !== ']' && i < fmt.length)o += fmt.charAt(i);
            if (o.match($b8f343bf88dacc48$var$SSF_abstime)) return true;
            break;
        case '.':
        /* falls through */ case '0':
        case '#':
            while(i < fmt.length && ("0#?.,E+-%".indexOf(c = fmt.charAt(++i)) > -1 || c == '\\' && fmt.charAt(i + 1) == "-" && "0#".indexOf(fmt.charAt(i + 2)) > -1));
            break;
        case '?':
            while(fmt.charAt(++i) === c);
            break;
        case '*':
            ++i;
            if (fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i;
            break;
        case '(':
        case ')':
            ++i;
            break;
        case '1':
        case '2':
        case '3':
        case '4':
        case '5':
        case '6':
        case '7':
        case '8':
        case '9':
            while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1);
            break;
        case ' ':
            ++i;
            break;
        default:
            ++i;
            break;
    }
    return false;
}
function $b8f343bf88dacc48$var$eval_fmt(fmt /*:string*/ , v /*:any*/ , opts /*:any*/ , flen /*:number*/ ) {
    var out = [], o = "", i = 0, c = "", lst = 't', dt, j, cc;
    var hr = 'H';
    /* Tokenize */ while(i < fmt.length)switch(c = fmt.charAt(i)){
        case 'G':
            /* General */ if (!$b8f343bf88dacc48$var$SSF_isgeneral(fmt, i)) throw new Error('unrecognized character ' + c + ' in ' + fmt);
            out[out.length] = {
                t: 'G',
                v: 'General'
            };
            i += 7;
            break;
        case '"':
            /* Literal text */ for(o = ""; (cc = fmt.charCodeAt(++i)) !== 34 && i < fmt.length;)o += String.fromCharCode(cc);
            out[out.length] = {
                t: 't',
                v: o
            };
            ++i;
            break;
        case '\\':
            var w = fmt.charAt(++i), t = w === "(" || w === ")" ? w : 't';
            out[out.length] = {
                t: t,
                v: w
            };
            ++i;
            break;
        case '_':
            out[out.length] = {
                t: 't',
                v: " "
            };
            i += 2;
            break;
        case '@':
            /* Text Placeholder */ out[out.length] = {
                t: 'T',
                v: v
            };
            ++i;
            break;
        case 'B':
        case 'b':
            if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") {
                if (dt == null) {
                    dt = $b8f343bf88dacc48$var$SSF_parse_date_code(v, opts, fmt.charAt(i + 1) === "2");
                    if (dt == null) return "";
                }
                out[out.length] = {
                    t: 'X',
                    v: fmt.substr(i, 2)
                };
                lst = c;
                i += 2;
                break;
            }
        /* falls through */ case 'M':
        case 'D':
        case 'Y':
        case 'H':
        case 'S':
        case 'E':
            c = c.toLowerCase();
        /* falls through */ case 'm':
        case 'd':
        case 'y':
        case 'h':
        case 's':
        case 'e':
        case 'g':
            if (v < 0) return "";
            if (dt == null) {
                dt = $b8f343bf88dacc48$var$SSF_parse_date_code(v, opts);
                if (dt == null) return "";
            }
            o = c;
            while(++i < fmt.length && fmt.charAt(i).toLowerCase() === c)o += c;
            if (c === 'm' && lst.toLowerCase() === 'h') c = 'M';
            if (c === 'h') c = hr;
            out[out.length] = {
                t: c,
                v: o
            };
            lst = c;
            break;
        case 'A':
        case 'a':
        case "\u4E0A":
            var q = {
                t: c,
                v: c
            };
            if (dt == null) dt = $b8f343bf88dacc48$var$SSF_parse_date_code(v, opts);
            if (fmt.substr(i, 3).toUpperCase() === "A/P") {
                if (dt != null) q.v = dt.H >= 12 ? fmt.charAt(i + 2) : c;
                q.t = 'T';
                hr = 'h';
                i += 3;
            } else if (fmt.substr(i, 5).toUpperCase() === "AM/PM") {
                if (dt != null) q.v = dt.H >= 12 ? "PM" : "AM";
                q.t = 'T';
                i += 5;
                hr = 'h';
            } else if (fmt.substr(i, 5).toUpperCase() === "\u4E0A\u5348/\u4E0B\u5348") {
                if (dt != null) q.v = dt.H >= 12 ? "\u4E0B\u5348" : "\u4E0A\u5348";
                q.t = 'T';
                i += 5;
                hr = 'h';
            } else {
                q.t = "t";
                ++i;
            }
            if (dt == null && q.t === 'T') return "";
            out[out.length] = q;
            lst = c;
            break;
        case '[':
            o = c;
            while(fmt.charAt(i++) !== ']' && i < fmt.length)o += fmt.charAt(i);
            if (o.slice(-1) !== ']') throw 'unterminated "[" block: |' + o + '|';
            if (o.match($b8f343bf88dacc48$var$SSF_abstime)) {
                if (dt == null) {
                    dt = $b8f343bf88dacc48$var$SSF_parse_date_code(v, opts);
                    if (dt == null) return "";
                }
                out[out.length] = {
                    t: 'Z',
                    v: o.toLowerCase()
                };
                lst = o.charAt(1);
            } else if (o.indexOf("$") > -1) {
                o = (o.match(/\$([^-\[\]]*)/) || [])[1] || "$";
                if (!$b8f343bf88dacc48$var$fmt_is_date(fmt)) out[out.length] = {
                    t: 't',
                    v: o
                };
            }
            break;
        /* Numbers */ case '.':
            if (dt != null) {
                o = c;
                while(++i < fmt.length && (c = fmt.charAt(i)) === "0")o += c;
                out[out.length] = {
                    t: 's',
                    v: o
                };
                break;
            }
        /* falls through */ case '0':
        case '#':
            o = c;
            while(++i < fmt.length && "0#?.,E+-%".indexOf(c = fmt.charAt(i)) > -1)o += c;
            out[out.length] = {
                t: 'n',
                v: o
            };
            break;
        case '?':
            o = c;
            while(fmt.charAt(++i) === c)o += c;
            out[out.length] = {
                t: c,
                v: o
            };
            lst = c;
            break;
        case '*':
            ++i;
            if (fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i;
            break; // **
        case '(':
        case ')':
            out[out.length] = {
                t: flen === 1 ? 't' : c,
                v: c
            };
            ++i;
            break;
        case '1':
        case '2':
        case '3':
        case '4':
        case '5':
        case '6':
        case '7':
        case '8':
        case '9':
            o = c;
            while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1)o += fmt.charAt(i);
            out[out.length] = {
                t: 'D',
                v: o
            };
            break;
        case ' ':
            out[out.length] = {
                t: c,
                v: c
            };
            ++i;
            break;
        case '$':
            out[out.length] = {
                t: 't',
                v: '$'
            };
            ++i;
            break;
        default:
            if (",$-+/():!^&'~{}<>=\u20ACacfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error('unrecognized character ' + c + ' in ' + fmt);
            out[out.length] = {
                t: 't',
                v: c
            };
            ++i;
            break;
    }
    /* Scan for date/time parts */ var bt = 0, ss0 = 0, ssm;
    for(i = out.length - 1, lst = 't'; i >= 0; --i)switch(out[i].t){
        case 'h':
        case 'H':
            out[i].t = hr;
            lst = 'h';
            if (bt < 1) bt = 1;
            break;
        case 's':
            if (ssm = out[i].v.match(/\.0+$/)) {
                ss0 = Math.max(ss0, ssm[0].length - 1);
                bt = 4;
            }
            if (bt < 3) bt = 3;
        /* falls through */ case 'd':
        case 'y':
        case 'e':
            lst = out[i].t;
            break;
        case 'M':
            lst = out[i].t;
            if (bt < 2) bt = 2;
            break;
        case 'm':
            if (lst === 's') {
                out[i].t = 'M';
                if (bt < 2) bt = 2;
            }
            break;
        case 'X':
            break;
        case 'Z':
            if (bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
            if (bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
            if (bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
    }
    /* time rounding depends on presence of minute / second / usec fields */ var _dt;
    switch(bt){
        case 0:
            break;
        case 1:
        case 2:
        case 3:
            if (dt.u >= 0.5) {
                dt.u = 0;
                ++dt.S;
            }
            if (dt.S >= 60) {
                dt.S = 0;
                ++dt.M;
            }
            if (dt.M >= 60) {
                dt.M = 0;
                ++dt.H;
            }
            if (dt.H >= 24) {
                dt.H = 0;
                ++dt.D;
                _dt = $b8f343bf88dacc48$var$SSF_parse_date_code(dt.D);
                _dt.u = dt.u;
                _dt.S = dt.S;
                _dt.M = dt.M;
                _dt.H = dt.H;
                dt = _dt;
            }
            break;
        case 4:
            switch(ss0){
                case 1:
                    dt.u = Math.round(dt.u * 10) / 10;
                    break;
                case 2:
                    dt.u = Math.round(dt.u * 100) / 100;
                    break;
                case 3:
                    dt.u = Math.round(dt.u * 1000) / 1000;
                    break;
            }
            if (dt.u >= 1) {
                dt.u = 0;
                ++dt.S;
            }
            if (dt.S >= 60) {
                dt.S = 0;
                ++dt.M;
            }
            if (dt.M >= 60) {
                dt.M = 0;
                ++dt.H;
            }
            if (dt.H >= 24) {
                dt.H = 0;
                ++dt.D;
                _dt = $b8f343bf88dacc48$var$SSF_parse_date_code(dt.D);
                _dt.u = dt.u;
                _dt.S = dt.S;
                _dt.M = dt.M;
                _dt.H = dt.H;
                dt = _dt;
            }
            break;
    }
    /* replace fields */ var nstr = "", jj;
    for(i = 0; i < out.length; ++i)switch(out[i].t){
        case 't':
        case 'T':
        case ' ':
        case 'D':
            break;
        case 'X':
            out[i].v = "";
            out[i].t = ";";
            break;
        case 'd':
        case 'm':
        case 'y':
        case 'h':
        case 'H':
        case 'M':
        case 's':
        case 'e':
        case 'b':
        case 'Z':
            /*::if(!dt) throw "unreachable"; */ out[i].v = $b8f343bf88dacc48$var$SSF_write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
            out[i].t = 't';
            break;
        case 'n':
        case '?':
            jj = i + 1;
            while(out[jj] != null && ((c = out[jj].t) === "?" || c === "D" || (c === " " || c === "t") && out[jj + 1] != null && (out[jj + 1].t === '?' || out[jj + 1].t === "t" && out[jj + 1].v === '/') || out[i].t === '(' && (c === ' ' || c === 'n' || c === ')') || c === 't' && (out[jj].v === '/' || out[jj].v === ' ' && out[jj + 1] != null && out[jj + 1].t == '?'))){
                out[i].v += out[jj].v;
                out[jj] = {
                    v: "",
                    t: ";"
                };
                ++jj;
            }
            nstr += out[i].v;
            i = jj - 1;
            break;
        case 'G':
            out[i].t = 't';
            out[i].v = $b8f343bf88dacc48$var$SSF_general(v, opts);
            break;
    }
    var vv = "", myv, ostr;
    if (nstr.length > 0) {
        if (nstr.charCodeAt(0) == 40) /* '(' */ {
            myv = v < 0 && nstr.charCodeAt(0) === 45 ? -v : v;
            ostr = $b8f343bf88dacc48$var$write_num('n', nstr, myv);
        } else {
            myv = v < 0 && flen > 1 ? -v : v;
            ostr = $b8f343bf88dacc48$var$write_num('n', nstr, myv);
            if (myv < 0 && out[0] && out[0].t == 't') {
                ostr = ostr.substr(1);
                out[0].v = "-" + out[0].v;
            }
        }
        jj = ostr.length - 1;
        var decpt = out.length;
        for(i = 0; i < out.length; ++i)if (out[i] != null && out[i].t != 't' && out[i].v.indexOf(".") > -1) {
            decpt = i;
            break;
        }
        var lasti = out.length;
        if (decpt === out.length && ostr.indexOf("E") === -1) {
            for(i = out.length - 1; i >= 0; --i){
                if (out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
                if (jj >= out[i].v.length - 1) {
                    jj -= out[i].v.length;
                    out[i].v = ostr.substr(jj + 1, out[i].v.length);
                } else if (jj < 0) out[i].v = "";
                else {
                    out[i].v = ostr.substr(0, jj + 1);
                    jj = -1;
                }
                out[i].t = 't';
                lasti = i;
            }
            if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
        } else if (decpt !== out.length && ostr.indexOf("E") === -1) {
            jj = ostr.indexOf(".") - 1;
            for(i = decpt; i >= 0; --i){
                if (out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
                j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") - 1 : out[i].v.length - 1;
                vv = out[i].v.substr(j + 1);
                for(; j >= 0; --j)if (jj >= 0 && (out[i].v.charAt(j) === "0" || out[i].v.charAt(j) === "#")) vv = ostr.charAt(jj--) + vv;
                out[i].v = vv;
                out[i].t = 't';
                lasti = i;
            }
            if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
            jj = ostr.indexOf(".") + 1;
            for(i = decpt; i < out.length; ++i){
                if (out[i] == null || 'n?('.indexOf(out[i].t) === -1 && i !== decpt) continue;
                j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") + 1 : 0;
                vv = out[i].v.substr(0, j);
                for(; j < out[i].v.length; ++j)if (jj < ostr.length) vv += ostr.charAt(jj++);
                out[i].v = vv;
                out[i].t = 't';
                lasti = i;
            }
        }
    }
    for(i = 0; i < out.length; ++i)if (out[i] != null && 'n?'.indexOf(out[i].t) > -1) {
        myv = flen > 1 && v < 0 && i > 0 && out[i - 1].v === "-" ? -v : v;
        out[i].v = $b8f343bf88dacc48$var$write_num(out[i].t, out[i].v, myv);
        out[i].t = 't';
    }
    var retval = "";
    for(i = 0; i !== out.length; ++i)if (out[i] != null) retval += out[i].v;
    return retval;
}
var $b8f343bf88dacc48$var$cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
function $b8f343bf88dacc48$var$chkcond(v, rr) {
    if (rr == null) return false;
    var thresh = parseFloat(rr[2]);
    switch(rr[1]){
        case "=":
            if (v == thresh) return true;
            break;
        case ">":
            if (v > thresh) return true;
            break;
        case "<":
            if (v < thresh) return true;
            break;
        case "<>":
            if (v != thresh) return true;
            break;
        case ">=":
            if (v >= thresh) return true;
            break;
        case "<=":
            if (v <= thresh) return true;
            break;
    }
    return false;
}
function $b8f343bf88dacc48$var$choose_fmt(f /*:string*/ , v /*:any*/ ) {
    var fmt = $b8f343bf88dacc48$var$SSF_split_fmt(f);
    var l = fmt.length, lat = fmt[l - 1].indexOf("@");
    if (l < 4 && lat > -1) --l;
    if (fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|");
    if (typeof v !== "number") return [
        4,
        fmt.length === 4 || lat > -1 ? fmt[fmt.length - 1] : "@"
    ];
    switch(fmt.length){
        case 1:
            fmt = lat > -1 ? [
                "General",
                "General",
                "General",
                fmt[0]
            ] : [
                fmt[0],
                fmt[0],
                fmt[0],
                "@"
            ];
            break;
        case 2:
            fmt = lat > -1 ? [
                fmt[0],
                fmt[0],
                fmt[0],
                fmt[1]
            ] : [
                fmt[0],
                fmt[1],
                fmt[0],
                "@"
            ];
            break;
        case 3:
            fmt = lat > -1 ? [
                fmt[0],
                fmt[1],
                fmt[0],
                fmt[2]
            ] : [
                fmt[0],
                fmt[1],
                fmt[2],
                "@"
            ];
            break;
        case 4:
            break;
    }
    var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
    if (fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [
        l,
        ff
    ];
    if (fmt[0].match(/\[[=<>]/) != null || fmt[1].match(/\[[=<>]/) != null) {
        var m1 = fmt[0].match($b8f343bf88dacc48$var$cfregex2);
        var m2 = fmt[1].match($b8f343bf88dacc48$var$cfregex2);
        return $b8f343bf88dacc48$var$chkcond(v, m1) ? [
            l,
            fmt[0]
        ] : $b8f343bf88dacc48$var$chkcond(v, m2) ? [
            l,
            fmt[1]
        ] : [
            l,
            fmt[m1 != null && m2 != null ? 2 : 1]
        ];
    }
    return [
        l,
        ff
    ];
}
function $b8f343bf88dacc48$var$SSF_format(fmt /*:string|number*/ , v /*:any*/ , o /*:?any*/ ) {
    if (o == null) o = {};
    var sfmt = "";
    switch(typeof fmt){
        case "string":
            if (fmt == "m/d/yy" && o.dateNF) sfmt = o.dateNF;
            else sfmt = fmt;
            break;
        case "number":
            if (fmt == 14 && o.dateNF) sfmt = o.dateNF;
            else sfmt = (o.table != null ? o.table /*:any*/  : $b8f343bf88dacc48$var$table_fmt)[fmt];
            if (sfmt == null) sfmt = o.table && o.table[$b8f343bf88dacc48$var$SSF_default_map[fmt]] || $b8f343bf88dacc48$var$table_fmt[$b8f343bf88dacc48$var$SSF_default_map[fmt]];
            if (sfmt == null) sfmt = $b8f343bf88dacc48$var$SSF_default_str[fmt] || "General";
            break;
    }
    if ($b8f343bf88dacc48$var$SSF_isgeneral(sfmt, 0)) return $b8f343bf88dacc48$var$SSF_general(v, o);
    if (v instanceof Date) v = $b8f343bf88dacc48$var$datenum(v, o.date1904);
    var f = $b8f343bf88dacc48$var$choose_fmt(sfmt, v);
    if ($b8f343bf88dacc48$var$SSF_isgeneral(f[1])) return $b8f343bf88dacc48$var$SSF_general(v, o);
    if (v === true) v = "TRUE";
    else if (v === false) v = "FALSE";
    else if (v === "" || v == null) return "";
    return $b8f343bf88dacc48$var$eval_fmt(f[1], v, o, f[0]);
}
function $b8f343bf88dacc48$var$SSF_load(fmt /*:string*/ , idx /*:?number*/ ) /*:number*/ {
    if (typeof idx != 'number') {
        idx = +idx || -1;
        /*::if(typeof idx != 'number') return 0x188; */ for(var i = 0; i < 0x0188; ++i){
            /*::if(typeof idx != 'number') return 0x188; */ if ($b8f343bf88dacc48$var$table_fmt[i] == undefined) {
                if (idx < 0) idx = i;
                continue;
            }
            if ($b8f343bf88dacc48$var$table_fmt[i] == fmt) {
                idx = i;
                break;
            }
        }
        /*::if(typeof idx != 'number') return 0x188; */ if (idx < 0) idx = 0x187;
    }
    /*::if(typeof idx != 'number') return 0x188; */ $b8f343bf88dacc48$var$table_fmt[idx] = fmt;
    return idx;
}
function $b8f343bf88dacc48$var$SSF_load_table(tbl /*:SSFTable*/ ) /*:void*/ {
    for(var i = 0; i != 0x0188; ++i)if (tbl[i] !== undefined) $b8f343bf88dacc48$var$SSF_load(tbl[i], i);
}
function $b8f343bf88dacc48$var$make_ssf() {
    $b8f343bf88dacc48$var$table_fmt = $b8f343bf88dacc48$var$SSF_init_table();
}
var $b8f343bf88dacc48$export$40d8edd678456c2b = {
    format: $b8f343bf88dacc48$var$SSF_format,
    load: $b8f343bf88dacc48$var$SSF_load,
    _table: $b8f343bf88dacc48$var$table_fmt,
    load_table: $b8f343bf88dacc48$var$SSF_load_table,
    parse_date_code: $b8f343bf88dacc48$var$SSF_parse_date_code,
    is_date: $b8f343bf88dacc48$var$fmt_is_date,
    get_table: function get_table() {
        return $b8f343bf88dacc48$export$40d8edd678456c2b._table = $b8f343bf88dacc48$var$table_fmt;
    }
};
var $b8f343bf88dacc48$var$SSFImplicit /*{[number]:string}*/  = {
    "5": '"$"#,##0_);\\("$"#,##0\\)',
    "6": '"$"#,##0_);[Red]\\("$"#,##0\\)',
    "7": '"$"#,##0.00_);\\("$"#,##0.00\\)',
    "8": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    "23": 'General',
    "24": 'General',
    "25": 'General',
    "26": 'General',
    "27": 'm/d/yy',
    "28": 'm/d/yy',
    "29": 'm/d/yy',
    "30": 'm/d/yy',
    "31": 'm/d/yy',
    "32": 'h:mm:ss',
    "33": 'h:mm:ss',
    "34": 'h:mm:ss',
    "35": 'h:mm:ss',
    "36": 'm/d/yy',
    "41": '_(* #,##0_);_(* \(#,##0\);_(* "-"_);_(@_)',
    "42": '_("$"* #,##0_);_("$"* \(#,##0\);_("$"* "-"_);_(@_)',
    "43": '_(* #,##0.00_);_(* \(#,##0.00\);_(* "-"??_);_(@_)',
    "44": '_("$"* #,##0.00_);_("$"* \(#,##0.00\);_("$"* "-"??_);_(@_)',
    "50": 'm/d/yy',
    "51": 'm/d/yy',
    "52": 'm/d/yy',
    "53": 'm/d/yy',
    "54": 'm/d/yy',
    "55": 'm/d/yy',
    "56": 'm/d/yy',
    "57": 'm/d/yy',
    "58": 'm/d/yy',
    "59": '0',
    "60": '0.00',
    "61": '#,##0',
    "62": '#,##0.00',
    "63": '"$"#,##0_);\\("$"#,##0\\)',
    "64": '"$"#,##0_);[Red]\\("$"#,##0\\)',
    "65": '"$"#,##0.00_);\\("$"#,##0.00\\)',
    "66": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    "67": '0%',
    "68": '0.00%',
    "69": '# ?/?',
    "70": '# ??/??',
    "71": 'm/d/yy',
    "72": 'm/d/yy',
    "73": 'd-mmm-yy',
    "74": 'd-mmm',
    "75": 'mmm-yy',
    "76": 'h:mm',
    "77": 'h:mm:ss',
    "78": 'm/d/yy h:mm',
    "79": 'mm:ss',
    "80": '[h]:mm:ss',
    "81": 'mmss.0'
} /*:any*/ ;
/* dateNF parse TODO: move to SSF */ var $b8f343bf88dacc48$var$dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
function $b8f343bf88dacc48$var$dateNF_regex(dateNF /*:string|number*/ ) /*:RegExp*/ {
    var fmt = typeof dateNF == "number" ? $b8f343bf88dacc48$var$table_fmt[dateNF] : dateNF;
    fmt = fmt.replace($b8f343bf88dacc48$var$dateNFregex, "(\\d+)");
    $b8f343bf88dacc48$var$dateNFregex.lastIndex = 0;
    return new RegExp("^" + fmt + "$");
}
function $b8f343bf88dacc48$var$dateNF_fix(str /*:string*/ , dateNF /*:string*/ , match /*:Array<string>*/ ) /*:string*/ {
    var Y = -1, m = -1, d = -1, H = -1, M = -1, S = -1;
    (dateNF.match($b8f343bf88dacc48$var$dateNFregex) || []).forEach(function(n, i) {
        var v = parseInt(match[i + 1], 10);
        switch(n.toLowerCase().charAt(0)){
            case 'y':
                Y = v;
                break;
            case 'd':
                d = v;
                break;
            case 'h':
                H = v;
                break;
            case 's':
                S = v;
                break;
            case 'm':
                if (H >= 0) M = v;
                else m = v;
                break;
        }
    });
    $b8f343bf88dacc48$var$dateNFregex.lastIndex = 0;
    if (S >= 0 && M == -1 && m >= 0) {
        M = m;
        m = -1;
    }
    var datestr = ("" + (Y >= 0 ? Y : new Date().getFullYear())).slice(-4) + "-" + ("00" + (m >= 1 ? m : 1)).slice(-2) + "-" + ("00" + (d >= 1 ? d : 1)).slice(-2);
    if (datestr.length == 7) datestr = "0" + datestr;
    if (datestr.length == 8) datestr = "20" + datestr;
    var timestr = ("00" + (H >= 0 ? H : 0)).slice(-2) + ":" + ("00" + (M >= 0 ? M : 0)).slice(-2) + ":" + ("00" + (S >= 0 ? S : 0)).slice(-2);
    if (H == -1 && M == -1 && S == -1) return datestr;
    if (Y == -1 && m == -1 && d == -1) return timestr;
    return datestr + "T" + timestr;
}
/* table of bad formats written by third-party tools */ var $b8f343bf88dacc48$var$bad_formats = {
    "d.m": "d\\.m" // Issue #2571 Google Sheets writes invalid format 'd.m', correct format is 'd"."m' or 'd\\.m'
};
function $b8f343bf88dacc48$var$SSF__load(fmt, idx) {
    return $b8f343bf88dacc48$var$SSF_load($b8f343bf88dacc48$var$bad_formats[fmt] || fmt, idx);
}
/*::
declare var ReadShift:any;
declare var CheckField:any;
declare var prep_blob:any;
declare var __readUInt32LE:any;
declare var __readInt32LE:any;
declare var __toBuffer:any;
declare var __utf16le:any;
declare var bconcat:any;
declare var s2a:any;
declare var chr0:any;
declare var chr1:any;
declare var has_buf:boolean;
declare var new_buf:any;
declare var new_raw_buf:any;
declare var new_unsafe_buf:any;
declare var Buffer_from:any;
*/ /* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*jshint eqnull:true */ /*exported CFB */ /*global Uint8Array:false, Uint16Array:false */ /*::
type SectorEntry = {
	name?:string;
	nodes?:Array<number>;
	data:RawBytes;
};
type SectorList = {
	[k:string|number]:SectorEntry;
	name:?string;
	fat_addrs:Array<number>;
	ssz:number;
}
type CFBFiles = {[n:string]:CFBEntry};
*/ /* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported CRC32 */ var $b8f343bf88dacc48$var$CRC32 = /*#__PURE__*/ function() {
    var CRC32 = {};
    CRC32.version = '1.2.0';
    /* see perf/crc32table.js */ /*global Int32Array */ function signed_crc_table() /*:any*/ {
        var c = 0, table /*:Array<number>*/  = new Array(256);
        for(var n = 0; n != 256; ++n){
            c = n;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            table[n] = c;
        }
        return typeof Int32Array !== 'undefined' ? new Int32Array(table) : table;
    }
    var T0 = signed_crc_table();
    function slice_by_16_tables(T) {
        var c = 0, v = 0, n = 0, table /*:Array<number>*/  = typeof Int32Array !== 'undefined' ? new Int32Array(4096) : new Array(4096);
        for(n = 0; n != 256; ++n)table[n] = T[n];
        for(n = 0; n != 256; ++n){
            v = T[n];
            for(c = 256 + n; c < 4096; c += 256)v = table[c] = v >>> 8 ^ T[v & 0xFF];
        }
        var out = [];
        for(n = 1; n != 16; ++n)out[n - 1] = typeof Int32Array !== 'undefined' && typeof table.subarray == "function" ? table.subarray(n * 256, n * 256 + 256) : table.slice(n * 256, n * 256 + 256);
        return out;
    }
    var TT = slice_by_16_tables(T0);
    var T1 = TT[0], T2 = TT[1], T3 = TT[2], T4 = TT[3], T5 = TT[4];
    var T6 = TT[5], T7 = TT[6], T8 = TT[7], T9 = TT[8], Ta = TT[9];
    var Tb = TT[10], Tc = TT[11], Td = TT[12], Te = TT[13], Tf = TT[14];
    function crc32_bstr(bstr /*:string*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed /*:: ? 0 : 0 */  ^ -1;
        for(var i = 0, L = bstr.length; i < L;)C = C >>> 8 ^ T0[(C ^ bstr.charCodeAt(i++)) & 0xFF];
        return ~C;
    }
    function crc32_buf(B /*:Uint8Array|Array<number>*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed /*:: ? 0 : 0 */  ^ -1, L = B.length - 15, i = 0;
        for(; i < L;)C = Tf[B[i++] ^ C & 255] ^ Te[B[i++] ^ C >> 8 & 255] ^ Td[B[i++] ^ C >> 16 & 255] ^ Tc[B[i++] ^ C >>> 24] ^ Tb[B[i++]] ^ Ta[B[i++]] ^ T9[B[i++]] ^ T8[B[i++]] ^ T7[B[i++]] ^ T6[B[i++]] ^ T5[B[i++]] ^ T4[B[i++]] ^ T3[B[i++]] ^ T2[B[i++]] ^ T1[B[i++]] ^ T0[B[i++]];
        L += 15;
        while(i < L)C = C >>> 8 ^ T0[(C ^ B[i++]) & 0xFF];
        return ~C;
    }
    function crc32_str(str /*:string*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed ^ -1;
        for(var i = 0, L = str.length, c = 0, d = 0; i < L;){
            c = str.charCodeAt(i++);
            if (c < 0x80) C = C >>> 8 ^ T0[(C ^ c) & 0xFF];
            else if (c < 0x800) {
                C = C >>> 8 ^ T0[(C ^ (192 | c >> 6 & 31)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c & 63)) & 0xFF];
            } else if (c >= 0xD800 && c < 0xE000) {
                c = (c & 1023) + 64;
                d = str.charCodeAt(i++) & 1023;
                C = C >>> 8 ^ T0[(C ^ (240 | c >> 8 & 7)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c >> 2 & 63)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | d >> 6 & 15 | (c & 3) << 4)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | d & 63)) & 0xFF];
            } else {
                C = C >>> 8 ^ T0[(C ^ (224 | c >> 12 & 15)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c >> 6 & 63)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c & 63)) & 0xFF];
            }
        }
        return ~C;
    }
    CRC32.table = T0;
    CRC32.bstr = crc32_bstr;
    CRC32.buf = crc32_buf;
    CRC32.str = crc32_str;
    return CRC32;
}();
/* [MS-CFB] v20171201 */ var $b8f343bf88dacc48$export$9f0e51cd97c572a = /*#__PURE__*/ function _CFB() {
    var exports /*:CFBModule*/  = /*::(*/ {} /*:: :any)*/ ;
    exports.version = '1.2.2';
    /* [MS-CFB] 2.6.4 */ function namecmp(l /*:string*/ , r /*:string*/ ) /*:number*/ {
        var L = l.split("/"), R = r.split("/");
        for(var i = 0, c = 0, Z = Math.min(L.length, R.length); i < Z; ++i){
            if (c = L[i].length - R[i].length) return c;
            if (L[i] != R[i]) return L[i] < R[i] ? -1 : 1;
        }
        return L.length - R.length;
    }
    function dirname(p /*:string*/ ) /*:string*/ {
        if (p.charAt(p.length - 1) == "/") return p.slice(0, -1).indexOf("/") === -1 ? p : dirname(p.slice(0, -1));
        var c = p.lastIndexOf("/");
        return c === -1 ? p : p.slice(0, c + 1);
    }
    function filename(p /*:string*/ ) /*:string*/ {
        if (p.charAt(p.length - 1) == "/") return filename(p.slice(0, -1));
        var c = p.lastIndexOf("/");
        return c === -1 ? p : p.slice(c + 1);
    }
    /* -------------------------------------------------------------------------- */ /* DOS Date format:
   high|YYYYYYYm.mmmddddd.HHHHHMMM.MMMSSSSS|low
   add 1980 to stored year
   stored second should be doubled
*/ /* write JS date to buf as a DOS date */ function write_dos_date(buf /*:CFBlob*/ , date /*:Date|string*/ ) {
        if (typeof date === "string") date = new Date(date);
        var hms /*:number*/  = date.getHours();
        hms = hms << 6 | date.getMinutes();
        hms = hms << 5 | date.getSeconds() >>> 1;
        buf.write_shift(2, hms);
        var ymd /*:number*/  = date.getFullYear() - 1980;
        ymd = ymd << 4 | date.getMonth() + 1;
        ymd = ymd << 5 | date.getDate();
        buf.write_shift(2, ymd);
    }
    /* read four bytes from buf and interpret as a DOS date */ function parse_dos_date(buf /*:CFBlob*/ ) /*:Date*/ {
        var hms = buf.read_shift(2) & 0xFFFF;
        var ymd = buf.read_shift(2) & 0xFFFF;
        var val = new Date();
        var d = ymd & 0x1F;
        ymd >>>= 5;
        var m = ymd & 0x0F;
        ymd >>>= 4;
        val.setMilliseconds(0);
        val.setFullYear(ymd + 1980);
        val.setMonth(m - 1);
        val.setDate(d);
        var S = hms & 0x1F;
        hms >>>= 5;
        var M = hms & 0x3F;
        hms >>>= 6;
        val.setHours(hms);
        val.setMinutes(M);
        val.setSeconds(S << 1);
        return val;
    }
    function parse_extra_field(blob /*:CFBlob*/ ) /*:any*/ {
        $b8f343bf88dacc48$var$prep_blob(blob, 0);
        var o = /*::(*/ {} /*:: :any)*/ ;
        var flags = 0;
        while(blob.l <= blob.length - 4){
            var type = blob.read_shift(2);
            var sz = blob.read_shift(2), tgt = blob.l + sz;
            var p = {};
            switch(type){
                /* UNIX-style Timestamps */ case 0x5455:
                    flags = blob.read_shift(1);
                    if (flags & 1) p.mtime = blob.read_shift(4);
                    /* for some reason, CD flag corresponds to LFH */ if (sz > 5) {
                        if (flags & 2) p.atime = blob.read_shift(4);
                        if (flags & 4) p.ctime = blob.read_shift(4);
                    }
                    if (p.mtime) p.mt = new Date(p.mtime * 1000);
                    break;
                /* ZIP64 Extended Information Field */ case 0x0001:
                    var sz1 = blob.read_shift(4), sz2 = blob.read_shift(4);
                    p.usz = sz2 * Math.pow(2, 32) + sz1;
                    sz1 = blob.read_shift(4);
                    sz2 = blob.read_shift(4);
                    p.csz = sz2 * Math.pow(2, 32) + sz1;
                    break;
            }
            blob.l = tgt;
            o[type] = p;
        }
        return o;
    }
    var fs /*:: = require('fs'); */ ;
    function get_fs() {
        return fs || (fs = $b8f343bf88dacc48$var$_fs);
    }
    function parse(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        if (file[0] == 0x50 && file[1] == 0x4b) return parse_zip(file, options);
        if ((file[0] | 0x20) == 0x6d && (file[1] | 0x20) == 0x69) return parse_mad(file, options);
        if (file.length < 512) throw new Error("CFB file size " + file.length + " < 512");
        var mver = 3;
        var ssz = 512;
        var nmfs = 0; // number of mini FAT sectors
        var difat_sec_cnt = 0;
        var dir_start = 0;
        var minifat_start = 0;
        var difat_start = 0;
        var fat_addrs /*:Array<number>*/  = []; // locations of FAT sectors
        /* [MS-CFB] 2.2 Compound File Header */ var blob /*:CFBlob*/  = /*::(*/ file.slice(0, 512) /*:: :any)*/ ;
        $b8f343bf88dacc48$var$prep_blob(blob, 0);
        /* major version */ var mv = check_get_mver(blob);
        mver = mv[0];
        switch(mver){
            case 3:
                ssz = 512;
                break;
            case 4:
                ssz = 4096;
                break;
            case 0:
                if (mv[1] == 0) return parse_zip(file, options);
            /* falls through */ default:
                throw new Error("Major Version: Expected 3 or 4 saw " + mver);
        }
        /* reprocess header */ if (ssz !== 512) {
            blob = /*::(*/ file.slice(0, ssz) /*:: :any)*/ ;
            $b8f343bf88dacc48$var$prep_blob(blob, 28 /* blob.l */ );
        }
        /* Save header for final object */ var header /*:RawBytes*/  = file.slice(0, ssz);
        check_shifts(blob, mver);
        // Number of Directory Sectors
        var dir_cnt /*:number*/  = blob.read_shift(4, 'i');
        if (mver === 3 && dir_cnt !== 0) throw new Error('# Directory Sectors: Expected 0 saw ' + dir_cnt);
        // Number of FAT Sectors
        blob.l += 4;
        // First Directory Sector Location
        dir_start = blob.read_shift(4, 'i');
        // Transaction Signature
        blob.l += 4;
        // Mini Stream Cutoff Size
        blob.chk('00100000', 'Mini Stream Cutoff Size: ');
        // First Mini FAT Sector Location
        minifat_start = blob.read_shift(4, 'i');
        // Number of Mini FAT Sectors
        nmfs = blob.read_shift(4, 'i');
        // First DIFAT sector location
        difat_start = blob.read_shift(4, 'i');
        // Number of DIFAT Sectors
        difat_sec_cnt = blob.read_shift(4, 'i');
        // Grab FAT Sector Locations
        for(var q = -1, j = 0; j < 109; ++j){
            q = blob.read_shift(4, 'i');
            if (q < 0) break;
            fat_addrs[j] = q;
        }
        /** Break the file up into sectors */ var sectors /*:Array<RawBytes>*/  = sectorify(file, ssz);
        sleuth_fat(difat_start, difat_sec_cnt, sectors, ssz, fat_addrs);
        /** Chains */ var sector_list /*:SectorList*/  = make_sector_list(sectors, dir_start, fat_addrs, ssz);
        if (dir_start < sector_list.length) sector_list[dir_start].name = "!Directory";
        if (nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
        sector_list[fat_addrs[0]].name = "!FAT";
        sector_list.fat_addrs = fat_addrs;
        sector_list.ssz = ssz;
        /* [MS-CFB] 2.6.1 Compound File Directory Entry */ var files /*:CFBFiles*/  = {}, Paths /*:Array<string>*/  = [], FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, minifat_start);
        build_full_paths(FileIndex, FullPaths, Paths);
        Paths.shift();
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        // $FlowIgnore
        if (options && options.raw) o.raw = {
            header: header,
            sectors: sectors
        };
        return o;
    } // parse
    /* [MS-CFB] 2.2 Compound File Header -- read up to major version */ function check_get_mver(blob /*:CFBlob*/ ) /*:[number, number]*/ {
        if (blob[blob.l] == 0x50 && blob[blob.l + 1] == 0x4b) return [
            0,
            0
        ];
        // header signature 8
        blob.chk(HEADER_SIGNATURE, 'Header Signature: ');
        // clsid 16
        //blob.chk(HEADER_CLSID, 'CLSID: ');
        blob.l += 16;
        // minor version 2
        var mver /*:number*/  = blob.read_shift(2, 'u');
        return [
            blob.read_shift(2, 'u'),
            mver
        ];
    }
    function check_shifts(blob /*:CFBlob*/ , mver /*:number*/ ) /*:void*/ {
        var shift = 0x09;
        // Byte Order
        //blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
        blob.l += 2;
        // Sector Shift
        switch(shift = blob.read_shift(2)){
            case 0x09:
                if (mver != 3) throw new Error('Sector Shift: Expected 9 saw ' + shift);
                break;
            case 0x0c:
                if (mver != 4) throw new Error('Sector Shift: Expected 12 saw ' + shift);
                break;
            default:
                throw new Error('Sector Shift: Expected 9 or 12 saw ' + shift);
        }
        // Mini Sector Shift
        blob.chk('0600', 'Mini Sector Shift: ');
        // Reserved
        blob.chk('000000000000', 'Reserved: ');
    }
    /** Break the file up into sectors */ function sectorify(file /*:RawBytes*/ , ssz /*:number*/ ) /*:Array<RawBytes>*/ {
        var nsectors = Math.ceil(file.length / ssz) - 1;
        var sectors /*:Array<RawBytes>*/  = [];
        for(var i = 1; i < nsectors; ++i)sectors[i - 1] = file.slice(i * ssz, (i + 1) * ssz);
        sectors[nsectors - 1] = file.slice(nsectors * ssz);
        return sectors;
    }
    /* [MS-CFB] 2.6.4 Red-Black Tree */ function build_full_paths(FI /*:CFBFileIndex*/ , FP /*:Array<string>*/ , Paths /*:Array<string>*/ ) /*:void*/ {
        var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
        var dad /*:Array<number>*/  = [], q /*:Array<number>*/  = [];
        for(; i < pl; ++i){
            dad[i] = q[i] = i;
            FP[i] = Paths[i];
        }
        for(; j < q.length; ++j){
            i = q[j];
            L = FI[i].L;
            R = FI[i].R;
            C = FI[i].C;
            if (dad[i] === i) {
                if (L !== -1 /*NOSTREAM*/  && dad[L] !== L) dad[i] = dad[L];
                if (R !== -1 && dad[R] !== R) dad[i] = dad[R];
            }
            if (C !== -1 /*NOSTREAM*/ ) dad[C] = i;
            if (L !== -1 && i != dad[i]) {
                dad[L] = dad[i];
                if (q.lastIndexOf(L) < j) q.push(L);
            }
            if (R !== -1 && i != dad[i]) {
                dad[R] = dad[i];
                if (q.lastIndexOf(R) < j) q.push(R);
            }
        }
        for(i = 1; i < pl; ++i)if (dad[i] === i) {
            if (R !== -1 /*NOSTREAM*/  && dad[R] !== R) dad[i] = dad[R];
            else if (L !== -1 && dad[L] !== L) dad[i] = dad[L];
        }
        for(i = 1; i < pl; ++i){
            if (FI[i].type === 0 /* unknown */ ) continue;
            j = i;
            if (j != dad[j]) do {
                j = dad[j];
                FP[i] = FP[j] + "/" + FP[i];
            }while (j !== 0 && -1 !== dad[j] && j != dad[j]);
            dad[i] = -1;
        }
        FP[0] += "/";
        for(i = 1; i < pl; ++i)if (FI[i].type !== 2 /* stream */ ) FP[i] += "/";
    }
    function get_mfat_entry(entry /*:CFBEntry*/ , payload /*:RawBytes*/ , mini /*:?RawBytes*/ ) /*:CFBlob*/ {
        var start = entry.start, size = entry.size;
        //return (payload.slice(start*MSSZ, start*MSSZ + size)/*:any*/);
        var o = [];
        var idx = start;
        while(mini && size > 0 && idx >= 0){
            o.push(payload.slice(idx * MSSZ, idx * MSSZ + MSSZ));
            size -= MSSZ;
            idx = $b8f343bf88dacc48$var$__readInt32LE(mini, idx * 4);
        }
        if (o.length === 0) return $b8f343bf88dacc48$var$new_buf(0);
        return $b8f343bf88dacc48$var$bconcat(o).slice(0, entry.size);
    }
    /** Chase down the rest of the DIFAT chain to build a comprehensive list
    DIFAT chains by storing the next sector number as the last 32 bits */ function sleuth_fat(idx /*:number*/ , cnt /*:number*/ , sectors /*:Array<RawBytes>*/ , ssz /*:number*/ , fat_addrs) /*:void*/ {
        var q /*:number*/  = ENDOFCHAIN;
        if (idx === ENDOFCHAIN) {
            if (cnt !== 0) throw new Error("DIFAT chain shorter than expected");
        } else if (idx !== -1 /*FREESECT*/ ) {
            var sector = sectors[idx], m = (ssz >>> 2) - 1;
            if (!sector) return;
            for(var i = 0; i < m; ++i){
                if ((q = $b8f343bf88dacc48$var$__readInt32LE(sector, i * 4)) === ENDOFCHAIN) break;
                fat_addrs.push(q);
            }
            if (cnt >= 1) sleuth_fat($b8f343bf88dacc48$var$__readInt32LE(sector, ssz - 4), cnt - 1, sectors, ssz, fat_addrs);
        }
    }
    /** Follow the linked list of sectors for a given starting point */ function get_sector_list(sectors /*:Array<RawBytes>*/ , start /*:number*/ , fat_addrs /*:Array<number>*/ , ssz /*:number*/ , chkd /*:?Array<boolean>*/ ) /*:SectorEntry*/ {
        var buf /*:Array<number>*/  = [], buf_chain /*:Array<any>*/  = [];
        if (!chkd) chkd = [];
        var modulus = ssz - 1, j = 0, jj = 0;
        for(j = start; j >= 0;){
            chkd[j] = true;
            buf[buf.length] = j;
            buf_chain.push(sectors[j]);
            var addr = fat_addrs[Math.floor(j * 4 / ssz)];
            jj = j * 4 & modulus;
            if (ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 " + ssz);
            if (!sectors[addr]) break;
            j = $b8f343bf88dacc48$var$__readInt32LE(sectors[addr], jj);
        }
        return {
            nodes: buf,
            data: $b8f343bf88dacc48$var$__toBuffer([
                buf_chain
            ])
        };
    }
    /** Chase down the sector linked lists */ function make_sector_list(sectors /*:Array<RawBytes>*/ , dir_start /*:number*/ , fat_addrs /*:Array<number>*/ , ssz /*:number*/ ) /*:SectorList*/ {
        var sl = sectors.length, sector_list /*:SectorList*/  = [];
        var chkd /*:Array<boolean>*/  = [], buf /*:Array<number>*/  = [], buf_chain /*:Array<RawBytes>*/  = [];
        var modulus = ssz - 1, i = 0, j = 0, k = 0, jj = 0;
        for(i = 0; i < sl; ++i){
            buf = [];
            k = i + dir_start;
            if (k >= sl) k -= sl;
            if (chkd[k]) continue;
            buf_chain = [];
            var seen = [];
            for(j = k; j >= 0;){
                seen[j] = true;
                chkd[j] = true;
                buf[buf.length] = j;
                buf_chain.push(sectors[j]);
                var addr /*:number*/  = fat_addrs[Math.floor(j * 4 / ssz)];
                jj = j * 4 & modulus;
                if (ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 " + ssz);
                if (!sectors[addr]) break;
                j = $b8f343bf88dacc48$var$__readInt32LE(sectors[addr], jj);
                if (seen[j]) break;
            }
            sector_list[k] = {
                nodes: buf,
                data: $b8f343bf88dacc48$var$__toBuffer([
                    buf_chain
                ])
            } /*:SectorEntry*/ ;
        }
        return sector_list;
    }
    /* [MS-CFB] 2.6.1 Compound File Directory Entry */ function read_directory(dir_start /*:number*/ , sector_list /*:SectorList*/ , sectors /*:Array<RawBytes>*/ , Paths /*:Array<string>*/ , nmfs, files, FileIndex, mini) {
        var minifat_store = 0, pl = Paths.length ? 2 : 0;
        var sector = sector_list[dir_start].data;
        var i = 0, namelen = 0, name;
        for(; i < sector.length; i += 128){
            var blob /*:CFBlob*/  = /*::(*/ sector.slice(i, i + 128) /*:: :any)*/ ;
            $b8f343bf88dacc48$var$prep_blob(blob, 64);
            namelen = blob.read_shift(2);
            name = $b8f343bf88dacc48$var$__utf16le(blob, 0, namelen - pl);
            Paths.push(name);
            var o /*:CFBEntry*/  = {
                name: name,
                type: blob.read_shift(1),
                color: blob.read_shift(1),
                L: blob.read_shift(4, 'i'),
                R: blob.read_shift(4, 'i'),
                C: blob.read_shift(4, 'i'),
                clsid: blob.read_shift(16),
                state: blob.read_shift(4, 'i'),
                start: 0,
                size: 0
            };
            var ctime /*:number*/  = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
            if (ctime !== 0) o.ct = read_date(blob, blob.l - 8);
            var mtime /*:number*/  = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
            if (mtime !== 0) o.mt = read_date(blob, blob.l - 8);
            o.start = blob.read_shift(4, 'i');
            o.size = blob.read_shift(4, 'i');
            if (o.size < 0 && o.start < 0) {
                o.size = o.type = 0;
                o.start = ENDOFCHAIN;
                o.name = "";
            }
            if (o.type === 5) {
                minifat_store = o.start;
                if (nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
            /*minifat_size = o.size;*/ } else if (o.size >= 4096 /* MSCSZ */ ) {
                o.storage = 'fat';
                if (sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
                sector_list[o.start].name = o.name;
                o.content = sector_list[o.start].data.slice(0, o.size);
            } else {
                o.storage = 'minifat';
                if (o.size < 0) o.size = 0;
                else if (minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN && sector_list[minifat_store]) o.content = get_mfat_entry(o, sector_list[minifat_store].data, (sector_list[mini] || {}).data);
            }
            if (o.content) $b8f343bf88dacc48$var$prep_blob(o.content, 0);
            files[name] = o;
            FileIndex.push(o);
        }
    }
    function read_date(blob /*:RawBytes|CFBlob*/ , offset /*:number*/ ) /*:Date*/ {
        return new Date(($b8f343bf88dacc48$var$__readUInt32LE(blob, offset + 4) / 1e7 * Math.pow(2, 32) + $b8f343bf88dacc48$var$__readUInt32LE(blob, offset) / 1e7 - 11644473600) * 1000);
    }
    function read_file(filename /*:string*/ , options /*:CFBReadOpts*/ ) {
        get_fs();
        return parse(fs.readFileSync(filename), options);
    }
    function read(blob /*:RawBytes|string*/ , options /*:CFBReadOpts*/ ) {
        var type = options && options.type;
        if (!type) {
            if ($b8f343bf88dacc48$var$has_buf && $b8f343bf88dacc48$require$Buffer.isBuffer(blob)) type = "buffer";
        }
        switch(type || "base64"){
            case "file":
                /*:: if(typeof blob !== 'string') throw "Must pass a filename when type='file'"; */ return read_file(blob, options);
            case "base64":
                /*:: if(typeof blob !== 'string') throw "Must pass a base64-encoded binary string when type='file'"; */ return parse($b8f343bf88dacc48$var$s2a($b8f343bf88dacc48$var$Base64_decode(blob)), options);
            case "binary":
                /*:: if(typeof blob !== 'string') throw "Must pass a binary string when type='file'"; */ return parse($b8f343bf88dacc48$var$s2a(blob), options);
        }
        return parse(/*::typeof blob == 'string' ? new Buffer(blob, 'utf-8') : */ blob, options);
    }
    function init_cfb(cfb /*:CFBContainer*/ , opts /*:?any*/ ) /*:void*/ {
        var o = opts || {}, root = o.root || "Root Entry";
        if (!cfb.FullPaths) cfb.FullPaths = [];
        if (!cfb.FileIndex) cfb.FileIndex = [];
        if (cfb.FullPaths.length !== cfb.FileIndex.length) throw new Error("inconsistent CFB structure");
        if (cfb.FullPaths.length === 0) {
            cfb.FullPaths[0] = root + "/";
            cfb.FileIndex[0] = {
                name: root,
                type: 5
            } /*:any*/ ;
        }
        if (o.CLSID) cfb.FileIndex[0].clsid = o.CLSID;
        seed_cfb(cfb);
    }
    function seed_cfb(cfb /*:CFBContainer*/ ) /*:void*/ {
        var nm = "\u0001Sh33tJ5";
        if ($b8f343bf88dacc48$export$9f0e51cd97c572a.find(cfb, "/" + nm)) return;
        var p = $b8f343bf88dacc48$var$new_buf(4);
        p[0] = 55;
        p[1] = p[3] = 50;
        p[2] = 54;
        cfb.FileIndex.push({
            name: nm,
            type: 2,
            content: p,
            size: 4,
            L: 69,
            R: 69,
            C: 69
        } /*:any*/ );
        cfb.FullPaths.push(cfb.FullPaths[0] + nm);
        rebuild_cfb(cfb);
    }
    function rebuild_cfb(cfb /*:CFBContainer*/ , f /*:?boolean*/ ) /*:void*/ {
        init_cfb(cfb);
        var gc = false, s = false;
        for(var i = cfb.FullPaths.length - 1; i >= 0; --i){
            var _file = cfb.FileIndex[i];
            switch(_file.type){
                case 0:
                    if (s) gc = true;
                    else {
                        cfb.FileIndex.pop();
                        cfb.FullPaths.pop();
                    }
                    break;
                case 1:
                case 2:
                case 5:
                    s = true;
                    if (isNaN(_file.R * _file.L * _file.C)) gc = true;
                    if (_file.R > -1 && _file.L > -1 && _file.R == _file.L) gc = true;
                    break;
                default:
                    gc = true;
                    break;
            }
        }
        if (!gc && !f) return;
        var now = new Date(1987, 1, 19), j = 0;
        // Track which names exist
        var fullPaths = Object.create ? Object.create(null) : {};
        var data /*:Array<[string, CFBEntry]>*/  = [];
        for(i = 0; i < cfb.FullPaths.length; ++i){
            fullPaths[cfb.FullPaths[i]] = true;
            if (cfb.FileIndex[i].type === 0) continue;
            data.push([
                cfb.FullPaths[i],
                cfb.FileIndex[i]
            ]);
        }
        for(i = 0; i < data.length; ++i){
            var dad = dirname(data[i][0]);
            s = fullPaths[dad];
            while(!s){
                while(dirname(dad) && !fullPaths[dirname(dad)])dad = dirname(dad);
                data.push([
                    dad,
                    {
                        name: filename(dad).replace("/", ""),
                        type: 1,
                        clsid: HEADER_CLSID,
                        ct: now,
                        mt: now,
                        content: null
                    } /*:any*/ 
                ]);
                // Add name to set
                fullPaths[dad] = true;
                dad = dirname(data[i][0]);
                s = fullPaths[dad];
            }
        }
        data.sort(function(x, y) {
            return namecmp(x[0], y[0]);
        });
        cfb.FullPaths = [];
        cfb.FileIndex = [];
        for(i = 0; i < data.length; ++i){
            cfb.FullPaths[i] = data[i][0];
            cfb.FileIndex[i] = data[i][1];
        }
        for(i = 0; i < data.length; ++i){
            var elt = cfb.FileIndex[i];
            var nm = cfb.FullPaths[i];
            elt.name = filename(nm).replace("/", "");
            elt.L = elt.R = elt.C = -(elt.color = 1);
            elt.size = elt.content ? elt.content.length : 0;
            elt.start = 0;
            elt.clsid = elt.clsid || HEADER_CLSID;
            if (i === 0) {
                elt.C = data.length > 1 ? 1 : -1;
                elt.size = 0;
                elt.type = 5;
            } else if (nm.slice(-1) == "/") {
                for(j = i + 1; j < data.length; ++j)if (dirname(cfb.FullPaths[j]) == nm) break;
                elt.C = j >= data.length ? -1 : j;
                for(j = i + 1; j < data.length; ++j)if (dirname(cfb.FullPaths[j]) == dirname(nm)) break;
                elt.R = j >= data.length ? -1 : j;
                elt.type = 1;
            } else {
                if (dirname(cfb.FullPaths[i + 1] || "") == dirname(nm)) elt.R = i + 1;
                elt.type = 2;
            }
        }
    }
    function _write(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes|string*/ {
        var _opts = options || {};
        /* MAD is order-sensitive, skip rebuild and sort */ if (_opts.fileType == 'mad') return write_mad(cfb, _opts);
        rebuild_cfb(cfb);
        switch(_opts.fileType){
            case 'zip':
                return write_zip(cfb, _opts);
        }
        var L = function(cfb /*:CFBContainer*/ ) /*:Array<number>*/ {
            var mini_size = 0, fat_size = 0;
            for(var i = 0; i < cfb.FileIndex.length; ++i){
                var file = cfb.FileIndex[i];
                if (!file.content) continue;
                var flen = file.content.length;
                if (flen > 0) {
                    if (flen < 0x1000) mini_size += flen + 0x3F >> 6;
                    else fat_size += flen + 0x01FF >> 9;
                }
            }
            var dir_cnt = cfb.FullPaths.length + 3 >> 2;
            var mini_cnt = mini_size + 7 >> 3;
            var mfat_cnt = mini_size + 0x7F >> 7;
            var fat_base = mini_cnt + fat_size + dir_cnt + mfat_cnt;
            var fat_cnt = fat_base + 0x7F >> 7;
            var difat_cnt = fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt - 109) / 0x7F);
            while(fat_base + fat_cnt + difat_cnt + 0x7F >> 7 > fat_cnt)difat_cnt = ++fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt - 109) / 0x7F);
            var L = [
                1,
                difat_cnt,
                fat_cnt,
                mfat_cnt,
                dir_cnt,
                fat_size,
                mini_size,
                0
            ];
            cfb.FileIndex[0].size = mini_size << 6;
            L[7] = (cfb.FileIndex[0].start = L[0] + L[1] + L[2] + L[3] + L[4] + L[5]) + (L[6] + 7 >> 3);
            return L;
        }(cfb);
        var o = $b8f343bf88dacc48$var$new_buf(L[7] << 9);
        var i = 0, T = 0;
        for(i = 0; i < 8; ++i)o.write_shift(1, HEADER_SIG[i]);
        for(i = 0; i < 8; ++i)o.write_shift(2, 0);
        o.write_shift(2, 0x003E);
        o.write_shift(2, 0x0003);
        o.write_shift(2, 0xFFFE);
        o.write_shift(2, 0x0009);
        o.write_shift(2, 0x0006);
        for(i = 0; i < 3; ++i)o.write_shift(2, 0);
        o.write_shift(4, 0);
        o.write_shift(4, L[2]);
        o.write_shift(4, L[0] + L[1] + L[2] + L[3] - 1);
        o.write_shift(4, 0);
        o.write_shift(4, 4096);
        o.write_shift(4, L[3] ? L[0] + L[1] + L[2] - 1 : ENDOFCHAIN);
        o.write_shift(4, L[3]);
        o.write_shift(-4, L[1] ? L[0] - 1 : ENDOFCHAIN);
        o.write_shift(4, L[1]);
        for(i = 0; i < 109; ++i)o.write_shift(-4, i < L[2] ? L[1] + i : -1);
        if (L[1]) for(T = 0; T < L[1]; ++T){
            for(; i < 236 + T * 127; ++i)o.write_shift(-4, i < L[2] ? L[1] + i : -1);
            o.write_shift(-4, T === L[1] - 1 ? ENDOFCHAIN : T + 1);
        }
        var chainit = function(w /*:number*/ ) /*:void*/ {
            for(T += w; i < T - 1; ++i)o.write_shift(-4, i + 1);
            if (w) {
                ++i;
                o.write_shift(-4, ENDOFCHAIN);
            }
        };
        T = i = 0;
        for(T += L[1]; i < T; ++i)o.write_shift(-4, consts.DIFSECT);
        for(T += L[2]; i < T; ++i)o.write_shift(-4, consts.FATSECT);
        chainit(L[3]);
        chainit(L[4]);
        var j /*:number*/  = 0, flen /*:number*/  = 0;
        var file /*:CFBEntry*/  = cfb.FileIndex[0];
        for(; j < cfb.FileIndex.length; ++j){
            file = cfb.FileIndex[j];
            if (!file.content) continue;
            /*:: if(file.content == null) throw new Error("unreachable"); */ flen = file.content.length;
            if (flen < 0x1000) continue;
            file.start = T;
            chainit(flen + 0x01FF >> 9);
        }
        chainit(L[6] + 7 >> 3);
        while(o.l & 0x1FF)o.write_shift(-4, consts.ENDOFCHAIN);
        T = i = 0;
        for(j = 0; j < cfb.FileIndex.length; ++j){
            file = cfb.FileIndex[j];
            if (!file.content) continue;
            /*:: if(file.content == null) throw new Error("unreachable"); */ flen = file.content.length;
            if (!flen || flen >= 0x1000) continue;
            file.start = T;
            chainit(flen + 0x3F >> 6);
        }
        while(o.l & 0x1FF)o.write_shift(-4, consts.ENDOFCHAIN);
        for(i = 0; i < L[4] << 2; ++i){
            var nm = cfb.FullPaths[i];
            if (!nm || nm.length === 0) {
                for(j = 0; j < 17; ++j)o.write_shift(4, 0);
                for(j = 0; j < 3; ++j)o.write_shift(4, -1);
                for(j = 0; j < 12; ++j)o.write_shift(4, 0);
                continue;
            }
            file = cfb.FileIndex[i];
            if (i === 0) file.start = file.size ? file.start - 1 : ENDOFCHAIN;
            var _nm /*:string*/  = i === 0 && _opts.root || file.name;
            if (_nm.length > 31) {
                console.error("Name " + _nm + " will be truncated to " + _nm.slice(0, 31));
                _nm = _nm.slice(0, 31);
            }
            flen = 2 * (_nm.length + 1);
            o.write_shift(64, _nm, "utf16le");
            o.write_shift(2, flen);
            o.write_shift(1, file.type);
            o.write_shift(1, file.color);
            o.write_shift(-4, file.L);
            o.write_shift(-4, file.R);
            o.write_shift(-4, file.C);
            if (!file.clsid) for(j = 0; j < 4; ++j)o.write_shift(4, 0);
            else o.write_shift(16, file.clsid, "hex");
            o.write_shift(4, file.state || 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, file.start);
            o.write_shift(4, file.size);
            o.write_shift(4, 0);
        }
        for(i = 1; i < cfb.FileIndex.length; ++i){
            file = cfb.FileIndex[i];
            /*:: if(!file.content) throw new Error("unreachable"); */ if (file.size >= 0x1000) {
                o.l = file.start + 1 << 9;
                if ($b8f343bf88dacc48$var$has_buf && $b8f343bf88dacc48$require$Buffer.isBuffer(file.content)) {
                    file.content.copy(o, o.l, 0, file.size);
                    // o is a 0-filled Buffer so just set next offset
                    o.l += file.size + 511 & -512;
                } else {
                    for(j = 0; j < file.size; ++j)o.write_shift(1, file.content[j]);
                    for(; j & 0x1FF; ++j)o.write_shift(1, 0);
                }
            }
        }
        for(i = 1; i < cfb.FileIndex.length; ++i){
            file = cfb.FileIndex[i];
            /*:: if(!file.content) throw new Error("unreachable"); */ if (file.size > 0 && file.size < 0x1000) {
                if ($b8f343bf88dacc48$var$has_buf && $b8f343bf88dacc48$require$Buffer.isBuffer(file.content)) {
                    file.content.copy(o, o.l, 0, file.size);
                    // o is a 0-filled Buffer so just set next offset
                    o.l += file.size + 63 & -64;
                } else {
                    for(j = 0; j < file.size; ++j)o.write_shift(1, file.content[j]);
                    for(; j & 0x3F; ++j)o.write_shift(1, 0);
                }
            }
        }
        if ($b8f343bf88dacc48$var$has_buf) o.l = o.length;
        else // When using Buffer, already 0-filled
        while(o.l < o.length)o.write_shift(1, 0);
        return o;
    }
    /* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */ function find(cfb /*:CFBContainer*/ , path /*:string*/ ) /*:?CFBEntry*/ {
        var UCFullPaths /*:Array<string>*/  = cfb.FullPaths.map(function(x) {
            return x.toUpperCase();
        });
        var UCPaths /*:Array<string>*/  = UCFullPaths.map(function(x) {
            var y = x.split("/");
            return y[y.length - (x.slice(-1) == "/" ? 2 : 1)];
        });
        var k /*:boolean*/  = false;
        if (path.charCodeAt(0) === 47 /* "/" */ ) {
            k = true;
            path = UCFullPaths[0].slice(0, -1) + path;
        } else k = path.indexOf("/") !== -1;
        var UCPath /*:string*/  = path.toUpperCase();
        var w /*:number*/  = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
        if (w !== -1) return cfb.FileIndex[w];
        var m = !UCPath.match($b8f343bf88dacc48$var$chr1);
        UCPath = UCPath.replace($b8f343bf88dacc48$var$chr0, '');
        if (m) UCPath = UCPath.replace($b8f343bf88dacc48$var$chr1, '!');
        for(w = 0; w < UCFullPaths.length; ++w){
            if ((m ? UCFullPaths[w].replace($b8f343bf88dacc48$var$chr1, '!') : UCFullPaths[w]).replace($b8f343bf88dacc48$var$chr0, '') == UCPath) return cfb.FileIndex[w];
            if ((m ? UCPaths[w].replace($b8f343bf88dacc48$var$chr1, '!') : UCPaths[w]).replace($b8f343bf88dacc48$var$chr0, '') == UCPath) return cfb.FileIndex[w];
        }
        return null;
    }
    /** CFB Constants */ var MSSZ = 64; /* Mini Sector Size = 1<<6 */ 
    //var MSCSZ = 4096; /* Mini Stream Cutoff Size */
    /* 2.1 Compound File Sector Numbers and Types */ var ENDOFCHAIN = -2;
    /* 2.2 Compound File Header */ var HEADER_SIGNATURE = 'd0cf11e0a1b11ae1';
    var HEADER_SIG = [
        0xD0,
        0xCF,
        0x11,
        0xE0,
        0xA1,
        0xB1,
        0x1A,
        0xE1
    ];
    var HEADER_CLSID = '00000000000000000000000000000000';
    var consts = {
        /* 2.1 Compund File Sector Numbers and Types */ MAXREGSECT: -6,
        DIFSECT: -4,
        FATSECT: -3,
        ENDOFCHAIN: ENDOFCHAIN,
        FREESECT: -1,
        /* 2.2 Compound File Header */ HEADER_SIGNATURE: HEADER_SIGNATURE,
        HEADER_MINOR_VERSION: '3e00',
        MAXREGSID: -6,
        NOSTREAM: -1,
        HEADER_CLSID: HEADER_CLSID,
        /* 2.6.1 Compound File Directory Entry */ EntryTypes: [
            'unknown',
            'storage',
            'stream',
            'lockbytes',
            'property',
            'root'
        ]
    };
    function write_file(cfb /*:CFBContainer*/ , filename /*:string*/ , options /*:CFBWriteOpts*/ ) /*:void*/ {
        get_fs();
        var o = _write(cfb, options);
        /*:: if(typeof Buffer == 'undefined' || !Buffer.isBuffer(o) || !(o instanceof Buffer)) throw new Error("unreachable"); */ fs.writeFileSync(filename, o);
    }
    function a2s(o /*:RawBytes*/ ) /*:string*/ {
        var out = new Array(o.length);
        for(var i = 0; i < o.length; ++i)out[i] = String.fromCharCode(o[i]);
        return out.join("");
    }
    function write(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes|string*/ {
        var o = _write(cfb, options);
        switch(options && options.type || "buffer"){
            case "file":
                get_fs();
                fs.writeFileSync(options.filename, o /*:any*/ );
                return o;
            case "binary":
                return typeof o == "string" ? o : a2s(o);
            case "base64":
                return $b8f343bf88dacc48$var$Base64_encode(typeof o == "string" ? o : a2s(o));
            case "buffer":
                if ($b8f343bf88dacc48$var$has_buf) return $b8f343bf88dacc48$require$Buffer.isBuffer(o) ? o : $b8f343bf88dacc48$var$Buffer_from(o);
            /* falls through */ case "array":
                return typeof o == "string" ? $b8f343bf88dacc48$var$s2a(o) : o;
        }
        return o;
    }
    /* node < 8.1 zlib does not expose bytesRead, so default to pure JS */ var _zlib;
    function use_zlib(zlib) {
        try {
            var InflateRaw = zlib.InflateRaw;
            var InflRaw = new InflateRaw();
            InflRaw._processChunk(new Uint8Array([
                3,
                0
            ]), InflRaw._finishFlushFlag);
            if (InflRaw.bytesRead) _zlib = zlib;
            else throw new Error("zlib does not expose bytesRead");
        } catch (e) {
            console.error("cannot use native zlib: " + (e.message || e));
        }
    }
    function _inflateRawSync(payload, usz) {
        if (!_zlib) return _inflate(payload, usz);
        var InflateRaw = _zlib.InflateRaw;
        var InflRaw = new InflateRaw();
        var out = InflRaw._processChunk(payload.slice(payload.l), InflRaw._finishFlushFlag);
        payload.l += InflRaw.bytesRead;
        return out;
    }
    function _deflateRawSync(payload) {
        return _zlib ? _zlib.deflateRawSync(payload) : _deflate(payload);
    }
    var CLEN_ORDER = [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    /*  LEN_ID = [ 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285 ]; */ var LEN_LN = [
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        13,
        15,
        17,
        19,
        23,
        27,
        31,
        35,
        43,
        51,
        59,
        67,
        83,
        99,
        115,
        131,
        163,
        195,
        227,
        258
    ];
    /*  DST_ID = [  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13,  14,  15,  16,  17,  18,  19,   20,   21,   22,   23,   24,   25,   26,    27,    28,    29 ]; */ var DST_LN = [
        1,
        2,
        3,
        4,
        5,
        7,
        9,
        13,
        17,
        25,
        33,
        49,
        65,
        97,
        129,
        193,
        257,
        385,
        513,
        769,
        1025,
        1537,
        2049,
        3073,
        4097,
        6145,
        8193,
        12289,
        16385,
        24577
    ];
    function bit_swap_8(n) {
        var t = (n << 1 | n << 11) & 0x22110 | (n << 5 | n << 15) & 0x88440;
        return (t >> 16 | t >> 8 | t) & 0xFF;
    }
    var use_typed_arrays = typeof Uint8Array !== 'undefined';
    var bitswap8 = use_typed_arrays ? new Uint8Array(256) : [];
    for(var q = 0; q < 256; ++q)bitswap8[q] = bit_swap_8(q);
    function bit_swap_n(n, b) {
        var rev = bitswap8[n & 0xFF];
        if (b <= 8) return rev >>> 8 - b;
        rev = rev << 8 | bitswap8[n >> 8 & 0xFF];
        if (b <= 16) return rev >>> 16 - b;
        rev = rev << 8 | bitswap8[n >> 16 & 0xFF];
        return rev >>> 24 - b;
    }
    /* helpers for unaligned bit reads */ function read_bits_2(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 6 ? 0 : buf[h + 1] << 8)) >>> w & 0x03;
    }
    function read_bits_3(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 5 ? 0 : buf[h + 1] << 8)) >>> w & 0x07;
    }
    function read_bits_4(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 4 ? 0 : buf[h + 1] << 8)) >>> w & 0x0F;
    }
    function read_bits_5(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 3 ? 0 : buf[h + 1] << 8)) >>> w & 0x1F;
    }
    function read_bits_7(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 1 ? 0 : buf[h + 1] << 8)) >>> w & 0x7F;
    }
    /* works up to n = 3 * 8 + 1 = 25 */ function read_bits_n(buf, bl, n) {
        var w = bl & 7, h = bl >>> 3, f = (1 << n) - 1;
        var v = buf[h] >>> w;
        if (n < 8 - w) return v & f;
        v |= buf[h + 1] << 8 - w;
        if (n < 16 - w) return v & f;
        v |= buf[h + 2] << 16 - w;
        if (n < 24 - w) return v & f;
        v |= buf[h + 3] << 24 - w;
        return v & f;
    }
    /* helpers for unaligned bit writes */ function write_bits_3(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        if (w <= 5) buf[h] |= (v & 7) << w;
        else {
            buf[h] |= v << w & 0xFF;
            buf[h + 1] = (v & 7) >> 8 - w;
        }
        return bl + 3;
    }
    function write_bits_1(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v = (v & 1) << w;
        buf[h] |= v;
        return bl + 1;
    }
    function write_bits_8(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v <<= w;
        buf[h] |= v & 0xFF;
        v >>>= 8;
        buf[h + 1] = v;
        return bl + 8;
    }
    function write_bits_16(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v <<= w;
        buf[h] |= v & 0xFF;
        v >>>= 8;
        buf[h + 1] = v & 0xFF;
        buf[h + 2] = v >>> 8;
        return bl + 16;
    }
    /* until ArrayBuffer#realloc is a thing, fake a realloc */ function realloc(b, sz /*:number*/ ) {
        var L = b.length, M = 2 * L > sz ? 2 * L : sz + 5, i = 0;
        if (L >= sz) return b;
        if ($b8f343bf88dacc48$var$has_buf) {
            var o = $b8f343bf88dacc48$var$new_unsafe_buf(M);
            // $FlowIgnore
            if (b.copy) b.copy(o);
            else for(; i < b.length; ++i)o[i] = b[i];
            return o;
        } else if (use_typed_arrays) {
            var a = new Uint8Array(M);
            if (a.set) a.set(b);
            else for(; i < L; ++i)a[i] = b[i];
            return a;
        }
        b.length = M;
        return b;
    }
    /* zero-filled arrays for older browsers */ function zero_fill_array(n) {
        var o = new Array(n);
        for(var i = 0; i < n; ++i)o[i] = 0;
        return o;
    }
    /* build tree (used for literals and lengths) */ function build_tree(clens, cmap, MAX /*:number*/ ) /*:number*/ {
        var maxlen = 1, w = 0, i = 0, j = 0, ccode = 0, L = clens.length;
        var bl_count = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
        for(i = 0; i < 32; ++i)bl_count[i] = 0;
        for(i = L; i < MAX; ++i)clens[i] = 0;
        L = clens.length;
        var ctree = use_typed_arrays ? new Uint16Array(L) : zero_fill_array(L); // []
        /* build code tree */ for(i = 0; i < L; ++i){
            bl_count[w = clens[i]]++;
            if (maxlen < w) maxlen = w;
            ctree[i] = 0;
        }
        bl_count[0] = 0;
        for(i = 1; i <= maxlen; ++i)bl_count[i + 16] = ccode = ccode + bl_count[i - 1] << 1;
        for(i = 0; i < L; ++i){
            ccode = clens[i];
            if (ccode != 0) ctree[i] = bl_count[ccode + 16]++;
        }
        /* cmap[maxlen + 4 bits] = (off&15) + (lit<<4) reverse mapping */ var cleni = 0;
        for(i = 0; i < L; ++i){
            cleni = clens[i];
            if (cleni != 0) {
                ccode = bit_swap_n(ctree[i], maxlen) >> maxlen - cleni;
                for(j = (1 << maxlen + 4 - cleni) - 1; j >= 0; --j)cmap[ccode | j << cleni] = cleni & 15 | i << 4;
            }
        }
        return maxlen;
    }
    /* Fixed Huffman */ var fix_lmap = use_typed_arrays ? new Uint16Array(512) : zero_fill_array(512);
    var fix_dmap = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
    if (!use_typed_arrays) {
        for(var i = 0; i < 512; ++i)fix_lmap[i] = 0;
        for(i = 0; i < 32; ++i)fix_dmap[i] = 0;
    }
    (function() {
        var dlens /*:Array<number>*/  = [];
        var i = 0;
        for(; i < 32; i++)dlens.push(5);
        build_tree(dlens, fix_dmap, 32);
        var clens /*:Array<number>*/  = [];
        i = 0;
        for(; i <= 143; i++)clens.push(8);
        for(; i <= 255; i++)clens.push(9);
        for(; i <= 279; i++)clens.push(7);
        for(; i <= 287; i++)clens.push(8);
        build_tree(clens, fix_lmap, 288);
    })();
    var _deflateRaw = /*#__PURE__*/ function _deflateRawIIFE() {
        var DST_LN_RE = use_typed_arrays ? new Uint8Array(0x8000) : [];
        var j = 0, k = 0;
        for(; j < DST_LN.length - 1; ++j)for(; k < DST_LN[j + 1]; ++k)DST_LN_RE[k] = j;
        for(; k < 32768; ++k)DST_LN_RE[k] = 29;
        var LEN_LN_RE = use_typed_arrays ? new Uint8Array(0x103) : [];
        for(j = 0, k = 0; j < LEN_LN.length - 1; ++j)for(; k < LEN_LN[j + 1]; ++k)LEN_LN_RE[k] = j;
        function write_stored(data, out) {
            var boff = 0;
            while(boff < data.length){
                var L = Math.min(0xFFFF, data.length - boff);
                var h = boff + L == data.length;
                out.write_shift(1, +h);
                out.write_shift(2, L);
                out.write_shift(2, ~L & 0xFFFF);
                while(L-- > 0)out[out.l++] = data[boff++];
            }
            return out.l;
        }
        /* Fixed Huffman */ function write_huff_fixed(data, out) {
            var bl = 0;
            var boff = 0;
            var addrs = use_typed_arrays ? new Uint16Array(0x8000) : [];
            while(boff < data.length){
                var L = /* data.length - boff; */ Math.min(0xFFFF, data.length - boff);
                /* write a stored block for short data */ if (L < 10) {
                    bl = write_bits_3(out, bl, +!!(boff + L == data.length)); // jshint ignore:line
                    if (bl & 7) bl += 8 - (bl & 7);
                    out.l = bl / 8 | 0;
                    out.write_shift(2, L);
                    out.write_shift(2, ~L & 0xFFFF);
                    while(L-- > 0)out[out.l++] = data[boff++];
                    bl = out.l * 8;
                    continue;
                }
                bl = write_bits_3(out, bl, +!!(boff + L == data.length) + 2); // jshint ignore:line
                var hash = 0;
                while(L-- > 0){
                    var d = data[boff];
                    hash = (hash << 5 ^ d) & 0x7FFF;
                    var match = -1, mlen = 0;
                    if (match = addrs[hash]) {
                        match |= boff & -32768;
                        if (match > boff) match -= 0x8000;
                        if (match < boff) while(data[match + mlen] == data[boff + mlen] && mlen < 250)++mlen;
                    }
                    if (mlen > 2) {
                        /* Copy Token  */ d = LEN_LN_RE[mlen];
                        if (d <= 22) bl = write_bits_8(out, bl, bitswap8[d + 1] >> 1) - 1;
                        else {
                            write_bits_8(out, bl, 3);
                            bl += 5;
                            write_bits_8(out, bl, bitswap8[d - 23] >> 5);
                            bl += 3;
                        }
                        var len_eb = d < 8 ? 0 : d - 4 >> 2;
                        if (len_eb > 0) {
                            write_bits_16(out, bl, mlen - LEN_LN[d]);
                            bl += len_eb;
                        }
                        d = DST_LN_RE[boff - match];
                        bl = write_bits_8(out, bl, bitswap8[d] >> 3);
                        bl -= 3;
                        var dst_eb = d < 4 ? 0 : d - 2 >> 1;
                        if (dst_eb > 0) {
                            write_bits_16(out, bl, boff - match - DST_LN[d]);
                            bl += dst_eb;
                        }
                        for(var q = 0; q < mlen; ++q){
                            addrs[hash] = boff & 0x7FFF;
                            hash = (hash << 5 ^ data[boff]) & 0x7FFF;
                            ++boff;
                        }
                        L -= mlen - 1;
                    } else {
                        /* Literal Token */ if (d <= 143) d = d + 48;
                        else bl = write_bits_1(out, bl, 1);
                        bl = write_bits_8(out, bl, bitswap8[d]);
                        addrs[hash] = boff & 0x7FFF;
                        ++boff;
                    }
                }
                bl = write_bits_8(out, bl, 0) - 1;
            }
            out.l = (bl + 7) / 8 | 0;
            return out.l;
        }
        return function _deflateRaw(data, out) {
            if (data.length < 8) return write_stored(data, out);
            return write_huff_fixed(data, out);
        };
    }();
    function _deflate(data) {
        var buf = $b8f343bf88dacc48$var$new_buf(50 + Math.floor(data.length * 1.1));
        var off = _deflateRaw(data, buf);
        return buf.slice(0, off);
    }
    /* modified inflate function also moves original read head */ var dyn_lmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
    var dyn_dmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
    var dyn_cmap = use_typed_arrays ? new Uint16Array(128) : zero_fill_array(128);
    var dyn_len_1 = 1, dyn_len_2 = 1;
    /* 5.5.3 Expanding Huffman Codes */ function dyn(data, boff /*:number*/ ) {
        /* nomenclature from RFC1951 refers to bit values; these are offset by the implicit constant */ var _HLIT = read_bits_5(data, boff) + 257;
        boff += 5;
        var _HDIST = read_bits_5(data, boff) + 1;
        boff += 5;
        var _HCLEN = read_bits_4(data, boff) + 4;
        boff += 4;
        var w = 0;
        /* grab and store code lengths */ var clens = use_typed_arrays ? new Uint8Array(19) : zero_fill_array(19);
        var ctree = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var maxlen = 1;
        var bl_count = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
        var next_code = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
        var L = clens.length; /* 19 */ 
        for(var i = 0; i < _HCLEN; ++i){
            clens[CLEN_ORDER[i]] = w = read_bits_3(data, boff);
            if (maxlen < w) maxlen = w;
            bl_count[w]++;
            boff += 3;
        }
        /* build code tree */ var ccode = 0;
        bl_count[0] = 0;
        for(i = 1; i <= maxlen; ++i)next_code[i] = ccode = ccode + bl_count[i - 1] << 1;
        for(i = 0; i < L; ++i)if ((ccode = clens[i]) != 0) ctree[i] = next_code[ccode]++;
        /* cmap[7 bits from stream] = (off&7) + (lit<<3) */ var cleni = 0;
        for(i = 0; i < L; ++i){
            cleni = clens[i];
            if (cleni != 0) {
                ccode = bitswap8[ctree[i]] >> 8 - cleni;
                for(var j = (1 << 7 - cleni) - 1; j >= 0; --j)dyn_cmap[ccode | j << cleni] = cleni & 7 | i << 3;
            }
        }
        /* read literal and dist codes at once */ var hcodes /*:Array<number>*/  = [];
        maxlen = 1;
        for(; hcodes.length < _HLIT + _HDIST;){
            ccode = dyn_cmap[read_bits_7(data, boff)];
            boff += ccode & 7;
            switch(ccode >>>= 3){
                case 16:
                    w = 3 + read_bits_2(data, boff);
                    boff += 2;
                    ccode = hcodes[hcodes.length - 1];
                    while(w-- > 0)hcodes.push(ccode);
                    break;
                case 17:
                    w = 3 + read_bits_3(data, boff);
                    boff += 3;
                    while(w-- > 0)hcodes.push(0);
                    break;
                case 18:
                    w = 11 + read_bits_7(data, boff);
                    boff += 7;
                    while(w-- > 0)hcodes.push(0);
                    break;
                default:
                    hcodes.push(ccode);
                    if (maxlen < ccode) maxlen = ccode;
                    break;
            }
        }
        /* build literal / length trees */ var h1 = hcodes.slice(0, _HLIT), h2 = hcodes.slice(_HLIT);
        for(i = _HLIT; i < 286; ++i)h1[i] = 0;
        for(i = _HDIST; i < 30; ++i)h2[i] = 0;
        dyn_len_1 = build_tree(h1, dyn_lmap, 286);
        dyn_len_2 = build_tree(h2, dyn_dmap, 30);
        return boff;
    }
    /* return [ data, bytesRead ] */ function inflate(data, usz /*:number*/ ) {
        /* shortcircuit for empty buffer [0x03, 0x00] */ if (data[0] == 3 && !(data[1] & 0x3)) return [
            $b8f343bf88dacc48$var$new_raw_buf(usz),
            2
        ];
        /* bit offset */ var boff = 0;
        /* header includes final bit and type bits */ var header = 0;
        var outbuf = $b8f343bf88dacc48$var$new_unsafe_buf(usz ? usz : 262144);
        var woff = 0;
        var OL = outbuf.length >>> 0;
        var max_len_1 = 0, max_len_2 = 0;
        while((header & 1) == 0){
            header = read_bits_3(data, boff);
            boff += 3;
            if (header >>> 1 == 0) {
                /* Stored block */ if (boff & 7) boff += 8 - (boff & 7);
                /* 2 bytes sz, 2 bytes bit inverse */ var sz = data[boff >>> 3] | data[(boff >>> 3) + 1] << 8;
                boff += 32;
                /* push sz bytes */ if (sz > 0) {
                    if (!usz && OL < woff + sz) {
                        outbuf = realloc(outbuf, woff + sz);
                        OL = outbuf.length;
                    }
                    while(sz-- > 0){
                        outbuf[woff++] = data[boff >>> 3];
                        boff += 8;
                    }
                }
                continue;
            } else if (header >> 1 == 1) {
                /* Fixed Huffman */ max_len_1 = 9;
                max_len_2 = 5;
            } else {
                /* Dynamic Huffman */ boff = dyn(data, boff);
                max_len_1 = dyn_len_1;
                max_len_2 = dyn_len_2;
            }
            for(;;){
                if (!usz && OL < woff + 32767) {
                    outbuf = realloc(outbuf, woff + 32767);
                    OL = outbuf.length;
                }
                /* ingest code and move read head */ var bits = read_bits_n(data, boff, max_len_1);
                var code = header >>> 1 == 1 ? fix_lmap[bits] : dyn_lmap[bits];
                boff += code & 15;
                code >>>= 4;
                /* 0-255 are literals, 256 is end of block token, 257+ are copy tokens */ if ((code >>> 8 & 0xFF) === 0) outbuf[woff++] = code;
                else if (code == 256) break;
                else {
                    code -= 257;
                    var len_eb = code < 8 ? 0 : code - 4 >> 2;
                    if (len_eb > 5) len_eb = 0;
                    var tgt = woff + LEN_LN[code];
                    /* length extra bits */ if (len_eb > 0) {
                        tgt += read_bits_n(data, boff, len_eb);
                        boff += len_eb;
                    }
                    /* dist code */ bits = read_bits_n(data, boff, max_len_2);
                    code = header >>> 1 == 1 ? fix_dmap[bits] : dyn_dmap[bits];
                    boff += code & 15;
                    code >>>= 4;
                    var dst_eb = code < 4 ? 0 : code - 2 >> 1;
                    var dst = DST_LN[code];
                    /* dist extra bits */ if (dst_eb > 0) {
                        dst += read_bits_n(data, boff, dst_eb);
                        boff += dst_eb;
                    }
                    /* in the common case, manual byte copy is faster than TA set / Buffer copy */ if (!usz && OL < tgt) {
                        outbuf = realloc(outbuf, tgt + 100);
                        OL = outbuf.length;
                    }
                    while(woff < tgt){
                        outbuf[woff] = outbuf[woff - dst];
                        ++woff;
                    }
                }
            }
        }
        if (usz) return [
            outbuf,
            boff + 7 >>> 3
        ];
        return [
            outbuf.slice(0, woff),
            boff + 7 >>> 3
        ];
    }
    function _inflate(payload, usz) {
        var data = payload.slice(payload.l || 0);
        var out = inflate(data, usz);
        payload.l += out[1];
        return out[0];
    }
    function warn_or_throw(wrn, msg) {
        if (wrn) {
            if (typeof console !== 'undefined') console.error(msg);
        } else throw new Error(msg);
    }
    function parse_zip(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        var blob /*:CFBlob*/  = /*::(*/ file /*:: :any)*/ ;
        $b8f343bf88dacc48$var$prep_blob(blob, 0);
        var FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        init_cfb(o, {
            root: options.root
        });
        /* find end of central directory, start just after signature */ var i = blob.length - 4;
        while((blob[i] != 0x50 || blob[i + 1] != 0x4b || blob[i + 2] != 0x05 || blob[i + 3] != 0x06) && i >= 0)--i;
        blob.l = i + 4;
        /* parse end of central directory */ blob.l += 4;
        var fcnt = blob.read_shift(2);
        blob.l += 6;
        var start_cd = blob.read_shift(4);
        /* parse central directory */ blob.l = start_cd;
        for(i = 0; i < fcnt; ++i){
            /* trust local file header instead of CD entry */ blob.l += 20;
            var csz = blob.read_shift(4);
            var usz = blob.read_shift(4);
            var namelen = blob.read_shift(2);
            var efsz = blob.read_shift(2);
            var fcsz = blob.read_shift(2);
            blob.l += 8;
            var offset = blob.read_shift(4);
            var EF = parse_extra_field(/*::(*/ blob.slice(blob.l + namelen, blob.l + namelen + efsz));
            blob.l += namelen + efsz + fcsz;
            var L = blob.l;
            blob.l = offset + 4;
            /* ZIP64 lengths */ if (EF && EF[0x0001]) {
                if ((EF[0x0001] || {}).usz) usz = EF[0x0001].usz;
                if ((EF[0x0001] || {}).csz) csz = EF[0x0001].csz;
            }
            parse_local_file(blob, csz, usz, o, EF);
            blob.l = L;
        }
        return o;
    }
    /* head starts just after local file header signature */ function parse_local_file(blob /*:CFBlob*/ , csz /*:number*/ , usz /*:number*/ , o /*:CFBContainer*/ , EF) {
        /* [local file header] */ blob.l += 2;
        var flags = blob.read_shift(2);
        var meth = blob.read_shift(2);
        var date = parse_dos_date(blob);
        if (flags & 0x2041) throw new Error("Unsupported ZIP encryption");
        var crc32 = blob.read_shift(4);
        var _csz = blob.read_shift(4);
        var _usz = blob.read_shift(4);
        var namelen = blob.read_shift(2);
        var efsz = blob.read_shift(2);
        // TODO: flags & (1<<11) // UTF8
        var name = "";
        for(var i = 0; i < namelen; ++i)name += String.fromCharCode(blob[blob.l++]);
        if (efsz) {
            var ef = parse_extra_field(/*::(*/ blob.slice(blob.l, blob.l + efsz));
            if ((ef[0x5455] || {}).mt) date = ef[0x5455].mt;
            if ((ef[0x0001] || {}).usz) _usz = ef[0x0001].usz;
            if ((ef[0x0001] || {}).csz) _csz = ef[0x0001].csz;
            if (EF) {
                if ((EF[0x5455] || {}).mt) date = EF[0x5455].mt;
                if ((EF[0x0001] || {}).usz) _usz = ef[0x0001].usz;
                if ((EF[0x0001] || {}).csz) _csz = ef[0x0001].csz;
            }
        }
        blob.l += efsz;
        /* [encryption header] */ /* [file data] */ var data = blob.slice(blob.l, blob.l + _csz);
        switch(meth){
            case 8:
                data = _inflateRawSync(blob, _usz);
                break;
            case 0:
                break; // TODO: scan for magic number
            default:
                throw new Error("Unsupported ZIP Compression method " + meth);
        }
        /* [data descriptor] */ var wrn = false;
        if (flags & 8) {
            crc32 = blob.read_shift(4);
            if (crc32 == 0x08074b50) {
                crc32 = blob.read_shift(4);
                wrn = true;
            }
            _csz = blob.read_shift(4);
            _usz = blob.read_shift(4);
        }
        if (_csz != csz) warn_or_throw(wrn, "Bad compressed size: " + csz + " != " + _csz);
        if (_usz != usz) warn_or_throw(wrn, "Bad uncompressed size: " + usz + " != " + _usz);
        //var _crc32 = CRC32.buf(data, 0);
        //if((crc32>>0) != (_crc32>>0)) warn_or_throw(wrn, "Bad CRC32 checksum: " + crc32 + " != " + _crc32);
        cfb_add(o, name, data, {
            unsafe: true,
            mt: date
        });
    }
    function write_zip(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes*/ {
        var _opts = options || {};
        var out = [], cdirs = [];
        var o /*:CFBlob*/  = $b8f343bf88dacc48$var$new_buf(1);
        var method = _opts.compression ? 8 : 0, flags = 0;
        var desc = false;
        if (desc) flags |= 8;
        var i = 0, j = 0;
        var start_cd = 0, fcnt = 0;
        var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
        var crcs = [];
        var sz_cd = 0;
        for(i = 1; i < cfb.FullPaths.length; ++i){
            fp = cfb.FullPaths[i].slice(root.length);
            fi = cfb.FileIndex[i];
            if (!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;
            var start = start_cd;
            /* TODO: CP437 filename */ var namebuf = $b8f343bf88dacc48$var$new_buf(fp.length);
            for(j = 0; j < fp.length; ++j)namebuf.write_shift(1, fp.charCodeAt(j) & 0x7F);
            namebuf = namebuf.slice(0, namebuf.l);
            crcs[fcnt] = typeof fi.content == "string" ? $b8f343bf88dacc48$var$CRC32.bstr(fi.content, 0) : $b8f343bf88dacc48$var$CRC32.buf(/*::((*/ fi.content /*::||[]):any)*/ , 0);
            var outbuf = typeof fi.content == "string" ? $b8f343bf88dacc48$var$s2a(fi.content) : fi.content /*::||[]*/ ;
            if (method == 8) outbuf = _deflateRawSync(outbuf);
            /* local file header */ o = $b8f343bf88dacc48$var$new_buf(30);
            o.write_shift(4, 0x04034b50);
            o.write_shift(2, 20);
            o.write_shift(2, flags);
            o.write_shift(2, method);
            /* TODO: last mod file time/date */ if (fi.mt) write_dos_date(o, fi.mt);
            else o.write_shift(4, 0);
            o.write_shift(-4, flags & 8 ? 0 : crcs[fcnt]);
            o.write_shift(4, flags & 8 ? 0 : outbuf.length);
            o.write_shift(4, flags & 8 ? 0 : /*::(*/ fi.content /*::||[])*/ .length);
            o.write_shift(2, namebuf.length);
            o.write_shift(2, 0);
            start_cd += o.length;
            out.push(o);
            start_cd += namebuf.length;
            out.push(namebuf);
            /* TODO: extra fields? */ /* TODO: encryption header ? */ start_cd += outbuf.length;
            out.push(outbuf);
            /* data descriptor */ if (flags & 8) {
                o = $b8f343bf88dacc48$var$new_buf(12);
                o.write_shift(-4, crcs[fcnt]);
                o.write_shift(4, outbuf.length);
                o.write_shift(4, /*::(*/ fi.content /*::||[])*/ .length);
                start_cd += o.l;
                out.push(o);
            }
            /* central directory */ o = $b8f343bf88dacc48$var$new_buf(46);
            o.write_shift(4, 0x02014b50);
            o.write_shift(2, 0);
            o.write_shift(2, 20);
            o.write_shift(2, flags);
            o.write_shift(2, method);
            o.write_shift(4, 0); /* TODO: last mod file time/date */ 
            o.write_shift(-4, crcs[fcnt]);
            o.write_shift(4, outbuf.length);
            o.write_shift(4, /*::(*/ fi.content /*::||[])*/ .length);
            o.write_shift(2, namebuf.length);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(4, 0);
            o.write_shift(4, start);
            sz_cd += o.l;
            cdirs.push(o);
            sz_cd += namebuf.length;
            cdirs.push(namebuf);
            ++fcnt;
        }
        /* end of central directory */ o = $b8f343bf88dacc48$var$new_buf(22);
        o.write_shift(4, 0x06054b50);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, fcnt);
        o.write_shift(2, fcnt);
        o.write_shift(4, sz_cd);
        o.write_shift(4, start_cd);
        o.write_shift(2, 0);
        return $b8f343bf88dacc48$var$bconcat([
            $b8f343bf88dacc48$var$bconcat(out /*:any*/ ),
            $b8f343bf88dacc48$var$bconcat(cdirs),
            o
        ]);
    }
    var ContentTypeMap = {
        "htm": "text/html",
        "xml": "text/xml",
        "gif": "image/gif",
        "jpg": "image/jpeg",
        "png": "image/png",
        "mso": "application/x-mso",
        "thmx": "application/vnd.ms-officetheme",
        "sh33tj5": "application/octet-stream"
    } /*:any*/ ;
    function get_content_type(fi /*:CFBEntry*/ , fp /*:string*/ ) /*:string*/ {
        if (fi.ctype) return fi.ctype;
        var ext = fi.name || "", m = ext.match(/\.([^\.]+)$/);
        if (m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
        if (fp) {
            m = (ext = fp).match(/[\.\\]([^\.\\])+$/);
            if (m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
        }
        return "application/octet-stream";
    }
    /* 76 character chunks TODO: intertwine encoding */ function write_base64_76(bstr /*:string*/ ) /*:string*/ {
        var data = $b8f343bf88dacc48$var$Base64_encode(bstr);
        var o = [];
        for(var i = 0; i < data.length; i += 76)o.push(data.slice(i, i + 76));
        return o.join("\r\n") + "\r\n";
    }
    /*
Rules for QP:
	- escape =## applies for all non-display characters and literal "="
	- space or tab at end of line must be encoded
	- \r\n newlines can be preserved, but bare \r and \n must be escaped
	- lines must not exceed 76 characters, use soft breaks =\r\n

TODO: Some files from word appear to write line extensions with bare equals:

```
<table class=3DMsoTableGrid border=3D1 cellspacing=3D0 cellpadding=3D0 width=
="70%"
```
*/ function write_quoted_printable(text /*:string*/ ) /*:string*/ {
        var encoded = text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(c) {
            var w = c.charCodeAt(0).toString(16).toUpperCase();
            return "=" + (w.length == 1 ? "0" + w : w);
        });
        encoded = encoded.replace(/ $/mg, "=20").replace(/\t$/mg, "=09");
        if (encoded.charAt(0) == "\n") encoded = "=0D" + encoded.slice(1);
        encoded = encoded.replace(/\r(?!\n)/mg, "=0D").replace(/\n\n/mg, "\n=0A").replace(/([^\r\n])\n/mg, "$1=0A");
        var o /*:Array<string>*/  = [], split = encoded.split("\r\n");
        for(var si = 0; si < split.length; ++si){
            var str = split[si];
            if (str.length == 0) {
                o.push("");
                continue;
            }
            for(var i = 0; i < str.length;){
                var end = 76;
                var tmp = str.slice(i, i + end);
                if (tmp.charAt(end - 1) == "=") end--;
                else if (tmp.charAt(end - 2) == "=") end -= 2;
                else if (tmp.charAt(end - 3) == "=") end -= 3;
                tmp = str.slice(i, i + end);
                i += end;
                if (i < str.length) tmp += "=";
                o.push(tmp);
            }
        }
        return o.join("\r\n");
    }
    function parse_quoted_printable(data /*:Array<string>*/ ) /*:RawBytes*/ {
        var o = [];
        /* unify long lines */ for(var di = 0; di < data.length; ++di){
            var line = data[di];
            while(di <= data.length && line.charAt(line.length - 1) == "=")line = line.slice(0, line.length - 1) + data[++di];
            o.push(line);
        }
        /* decode */ for(var oi = 0; oi < o.length; ++oi)o[oi] = o[oi].replace(/[=][0-9A-Fa-f]{2}/g, function($$) {
            return String.fromCharCode(parseInt($$.slice(1), 16));
        });
        return $b8f343bf88dacc48$var$s2a(o.join("\r\n"));
    }
    function parse_mime(cfb /*:CFBContainer*/ , data /*:Array<string>*/ , root /*:string*/ ) /*:void*/ {
        var fname = "", cte = "", ctype = "", fdata;
        var di = 0;
        for(; di < 10; ++di){
            var line = data[di];
            if (!line || line.match(/^\s*$/)) break;
            var m = line.match(/^([^:]*?):\s*([^\s].*)$/);
            if (m) switch(m[1].toLowerCase()){
                case "content-location":
                    fname = m[2].trim();
                    break;
                case "content-type":
                    ctype = m[2].trim();
                    break;
                case "content-transfer-encoding":
                    cte = m[2].trim();
                    break;
            }
        }
        ++di;
        switch(cte.toLowerCase()){
            case 'base64':
                fdata = $b8f343bf88dacc48$var$s2a($b8f343bf88dacc48$var$Base64_decode(data.slice(di).join("")));
                break;
            case 'quoted-printable':
                fdata = parse_quoted_printable(data.slice(di));
                break;
            default:
                throw new Error("Unsupported Content-Transfer-Encoding " + cte);
        }
        var file = cfb_add(cfb, fname.slice(root.length), fdata, {
            unsafe: true
        });
        if (ctype) file.ctype = ctype;
    }
    function parse_mad(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        if (a2s(file.slice(0, 13)).toLowerCase() != "mime-version:") throw new Error("Unsupported MAD header");
        var root = options && options.root || "";
        // $FlowIgnore
        var data = ($b8f343bf88dacc48$var$has_buf && $b8f343bf88dacc48$require$Buffer.isBuffer(file) ? file.toString("binary") : a2s(file)).split("\r\n");
        var di = 0, row = "";
        /* if root is not specified, scan for the common prefix */ for(di = 0; di < data.length; ++di){
            row = data[di];
            if (!/^Content-Location:/i.test(row)) continue;
            row = row.slice(row.indexOf("file"));
            if (!root) root = row.slice(0, row.lastIndexOf("/") + 1);
            if (row.slice(0, root.length) == root) continue;
            while(root.length > 0){
                root = root.slice(0, root.length - 1);
                root = root.slice(0, root.lastIndexOf("/") + 1);
                if (row.slice(0, root.length) == root) break;
            }
        }
        var mboundary = (data[1] || "").match(/boundary="(.*?)"/);
        if (!mboundary) throw new Error("MAD cannot find boundary");
        var boundary = "--" + (mboundary[1] || "");
        var FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        init_cfb(o);
        var start_di, fcnt = 0;
        for(di = 0; di < data.length; ++di){
            var line = data[di];
            if (line !== boundary && line !== boundary + "--") continue;
            if (fcnt++) parse_mime(o, data.slice(start_di, di), root);
            start_di = di;
        }
        return o;
    }
    function write_mad(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:string*/ {
        var opts = options || {};
        var boundary = opts.boundary || "SheetJS";
        boundary = '------=' + boundary;
        var out = [
            'MIME-Version: 1.0',
            'Content-Type: multipart/related; boundary="' + boundary.slice(2) + '"',
            '',
            '',
            ''
        ];
        var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
        for(var i = 1; i < cfb.FullPaths.length; ++i){
            fp = cfb.FullPaths[i].slice(root.length);
            fi = cfb.FileIndex[i];
            if (!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;
            /* Normalize filename */ fp = fp.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(c) {
                return "_x" + c.charCodeAt(0).toString(16) + "_";
            }).replace(/[\u0080-\uFFFF]/g, function(u) {
                return "_u" + u.charCodeAt(0).toString(16) + "_";
            });
            /* Extract content as binary string */ var ca = fi.content;
            // $FlowIgnore
            var cstr = $b8f343bf88dacc48$var$has_buf && $b8f343bf88dacc48$require$Buffer.isBuffer(ca) ? ca.toString("binary") : a2s(ca);
            /* 4/5 of first 1024 chars ascii -> quoted printable, else base64 */ var dispcnt = 0, L = Math.min(1024, cstr.length), cc = 0;
            for(var csl = 0; csl <= L; ++csl)if ((cc = cstr.charCodeAt(csl)) >= 0x20 && cc < 0x80) ++dispcnt;
            var qp = dispcnt >= L * 4 / 5;
            out.push(boundary);
            out.push('Content-Location: ' + (opts.root || 'file:///C:/SheetJS/') + fp);
            out.push('Content-Transfer-Encoding: ' + (qp ? 'quoted-printable' : 'base64'));
            out.push('Content-Type: ' + get_content_type(fi, fp));
            out.push('');
            out.push(qp ? write_quoted_printable(cstr) : write_base64_76(cstr));
        }
        out.push(boundary + '--\r\n');
        return out.join("\r\n");
    }
    function cfb_new(opts /*:?any*/ ) /*:CFBContainer*/ {
        var o /*:CFBContainer*/  = {} /*:any*/ ;
        init_cfb(o, opts);
        return o;
    }
    function cfb_add(cfb /*:CFBContainer*/ , name /*:string*/ , content /*:?RawBytes*/ , opts /*:?any*/ ) /*:CFBEntry*/ {
        var unsafe = opts && opts.unsafe;
        if (!unsafe) init_cfb(cfb);
        var file = !unsafe && $b8f343bf88dacc48$export$9f0e51cd97c572a.find(cfb, name);
        if (!file) {
            var fpath /*:string*/  = cfb.FullPaths[0];
            if (name.slice(0, fpath.length) == fpath) fpath = name;
            else {
                if (fpath.slice(-1) != "/") fpath += "/";
                fpath = (fpath + name).replace("//", "/");
            }
            file = {
                name: filename(name),
                type: 2
            } /*:any*/ ;
            cfb.FileIndex.push(file);
            cfb.FullPaths.push(fpath);
            if (!unsafe) $b8f343bf88dacc48$export$9f0e51cd97c572a.utils.cfb_gc(cfb);
        }
        /*:: if(!file) throw new Error("unreachable"); */ file.content = content /*:any*/ ;
        file.size = content ? content.length : 0;
        if (opts) {
            if (opts.CLSID) file.clsid = opts.CLSID;
            if (opts.mt) file.mt = opts.mt;
            if (opts.ct) file.ct = opts.ct;
        }
        return file;
    }
    function cfb_del(cfb /*:CFBContainer*/ , name /*:string*/ ) /*:boolean*/ {
        init_cfb(cfb);
        var file = $b8f343bf88dacc48$export$9f0e51cd97c572a.find(cfb, name);
        if (file) {
            for(var j = 0; j < cfb.FileIndex.length; ++j)if (cfb.FileIndex[j] == file) {
                cfb.FileIndex.splice(j, 1);
                cfb.FullPaths.splice(j, 1);
                return true;
            }
        }
        return false;
    }
    function cfb_mov(cfb /*:CFBContainer*/ , old_name /*:string*/ , new_name /*:string*/ ) /*:boolean*/ {
        init_cfb(cfb);
        var file = $b8f343bf88dacc48$export$9f0e51cd97c572a.find(cfb, old_name);
        if (file) {
            for(var j = 0; j < cfb.FileIndex.length; ++j)if (cfb.FileIndex[j] == file) {
                cfb.FileIndex[j].name = filename(new_name);
                cfb.FullPaths[j] = new_name;
                return true;
            }
        }
        return false;
    }
    function cfb_gc(cfb /*:CFBContainer*/ ) /*:void*/ {
        rebuild_cfb(cfb, true);
    }
    exports.find = find;
    exports.read = read;
    exports.parse = parse;
    exports.write = write;
    exports.writeFile = write_file;
    exports.utils = {
        cfb_new: cfb_new,
        cfb_add: cfb_add,
        cfb_del: cfb_del,
        cfb_mov: cfb_mov,
        cfb_gc: cfb_gc,
        ReadShift: $b8f343bf88dacc48$var$ReadShift,
        CheckField: $b8f343bf88dacc48$var$CheckField,
        prep_blob: $b8f343bf88dacc48$var$prep_blob,
        bconcat: $b8f343bf88dacc48$var$bconcat,
        use_zlib: use_zlib,
        _deflateRaw: _deflate,
        _inflateRaw: _inflate,
        consts: consts
    };
    return exports;
}();
var $b8f343bf88dacc48$var$_fs;
function $b8f343bf88dacc48$export$a48eb669e1768bcf(fs) {
    $b8f343bf88dacc48$var$_fs = fs;
}
/* normalize data for blob ctor */ function $b8f343bf88dacc48$var$blobify(data) {
    if (typeof data === "string") return $b8f343bf88dacc48$var$s2ab(data);
    if (Array.isArray(data)) return $b8f343bf88dacc48$var$a2u(data);
    return data;
}
/* write or download file */ function $b8f343bf88dacc48$var$write_dl(fname /*:string*/ , payload /*:any*/ , enc /*:?string*/ ) {
    /*global IE_SaveFile, Blob, navigator, saveAs, document, File, chrome */ if (typeof $b8f343bf88dacc48$var$_fs !== 'undefined' && $b8f343bf88dacc48$var$_fs.writeFileSync) return enc ? $b8f343bf88dacc48$var$_fs.writeFileSync(fname, payload, enc) : $b8f343bf88dacc48$var$_fs.writeFileSync(fname, payload);
    if (typeof Deno !== 'undefined') {
        /* in this spot, it's safe to assume typed arrays and TextEncoder/TextDecoder exist */ if (enc && typeof payload == "string") switch(enc){
            case "utf8":
                payload = new TextEncoder(enc).encode(payload);
                break;
            case "binary":
                payload = $b8f343bf88dacc48$var$s2ab(payload);
                break;
            /* TODO: binary equivalent */ default:
                throw new Error("Unsupported encoding " + enc);
        }
        return Deno.writeFileSync(fname, payload);
    }
    var data = enc == "utf8" ? $b8f343bf88dacc48$var$utf8write(payload) : payload;
    /*:: declare var IE_SaveFile: any; */ if (typeof IE_SaveFile !== 'undefined') return IE_SaveFile(data, fname);
    if (typeof Blob !== 'undefined') {
        var blob = new Blob([
            $b8f343bf88dacc48$var$blobify(data)
        ], {
            type: "application/octet-stream"
        });
        /*:: declare var navigator: any; */ if (typeof navigator !== 'undefined' && navigator.msSaveBlob) return navigator.msSaveBlob(blob, fname);
        /*:: declare var saveAs: any; */ if (typeof saveAs !== 'undefined') return saveAs(blob, fname);
        if (typeof URL !== 'undefined' && typeof document !== 'undefined' && document.createElement && URL.createObjectURL) {
            var url = URL.createObjectURL(blob);
            /*:: declare var chrome: any; */ if (typeof chrome === 'object' && typeof (chrome.downloads || {}).download == "function") {
                if (URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() {
                    URL.revokeObjectURL(url);
                }, 60000);
                return chrome.downloads.download({
                    url: url,
                    filename: fname,
                    saveAs: true
                });
            }
            var a = document.createElement("a");
            if (a.download != null) {
                /*:: if(document.body == null) throw new Error("unreachable"); */ a.download = fname;
                a.href = url;
                document.body.appendChild(a);
                a.click();
                /*:: if(document.body == null) throw new Error("unreachable"); */ document.body.removeChild(a);
                if (URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() {
                    URL.revokeObjectURL(url);
                }, 60000);
                return url;
            }
        } else if (typeof URL !== 'undefined' && !URL.createObjectURL && typeof chrome === 'object') {
            /* manifest v3 extensions -- no URL.createObjectURL */ var b64 = "data:application/octet-stream;base64," + $b8f343bf88dacc48$var$Base64_encode_arr(new Uint8Array($b8f343bf88dacc48$var$blobify(data)));
            return chrome.downloads.download({
                url: b64,
                filename: fname,
                saveAs: true
            });
        }
    }
    // $FlowIgnore
    if (typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try {
        // $FlowIgnore
        var out = File(fname);
        out.open("w");
        out.encoding = "binary";
        if (Array.isArray(payload)) payload = $b8f343bf88dacc48$var$a2s(payload);
        out.write(payload);
        out.close();
        return payload;
    } catch (e) {
        if (!e.message || e.message.indexOf("onstruct") == -1) throw e;
    }
    throw new Error("cannot save file " + fname);
}
/* read binary data from file */ function $b8f343bf88dacc48$var$read_binary(path /*:string*/ ) {
    if (typeof $b8f343bf88dacc48$var$_fs !== 'undefined') return $b8f343bf88dacc48$var$_fs.readFileSync(path);
    if (typeof Deno !== 'undefined') return Deno.readFileSync(path);
    // $FlowIgnore
    if (typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try {
        // $FlowIgnore
        var infile = File(path);
        infile.open("r");
        infile.encoding = "binary";
        var data = infile.read();
        infile.close();
        return data;
    } catch (e) {
        if (!e.message || e.message.indexOf("onstruct") == -1) throw e;
    }
    throw new Error("Cannot access file " + path);
}
function $b8f343bf88dacc48$var$keys(o /*:any*/ ) /*:Array<any>*/ {
    var ks = Object.keys(o), o2 = [];
    for(var i = 0; i < ks.length; ++i)if (Object.prototype.hasOwnProperty.call(o, ks[i])) o2.push(ks[i]);
    return o2;
}
function $b8f343bf88dacc48$var$evert_key(obj /*:any*/ , key /*:string*/ ) /*:EvertType*/ {
    var o = [], K = $b8f343bf88dacc48$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)if (o[obj[K[i]][key]] == null) o[obj[K[i]][key]] = K[i];
    return o;
}
function $b8f343bf88dacc48$var$evert(obj /*:any*/ ) /*:EvertType*/ {
    var o = [], K = $b8f343bf88dacc48$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)o[obj[K[i]]] = K[i];
    return o;
}
function $b8f343bf88dacc48$var$evert_num(obj /*:any*/ ) /*:EvertNumType*/ {
    var o = [], K = $b8f343bf88dacc48$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)o[obj[K[i]]] = parseInt(K[i], 10);
    return o;
}
function $b8f343bf88dacc48$var$evert_arr(obj /*:any*/ ) /*:EvertArrType*/ {
    var o /*:EvertArrType*/  = [], K = $b8f343bf88dacc48$var$keys(obj);
    for(var i = 0; i !== K.length; ++i){
        if (o[obj[K[i]]] == null) o[obj[K[i]]] = [];
        o[obj[K[i]]].push(K[i]);
    }
    return o;
}
var $b8f343bf88dacc48$var$dnthresh = /*#__PURE__*/ Date.UTC(1899, 11, 30, 0, 0, 0); // -2209161600000
var $b8f343bf88dacc48$var$dnthresh1 = /*#__PURE__*/ Date.UTC(1899, 11, 31, 0, 0, 0); // -2209075200000
var $b8f343bf88dacc48$var$dnthresh2 = /*#__PURE__*/ Date.UTC(1904, 0, 1, 0, 0, 0); // -2209075200000
function $b8f343bf88dacc48$var$datenum(v /*:Date*/ , date1904 /*:?boolean*/ ) /*:number*/ {
    var epoch = /*#__PURE__*/ v.getTime();
    var res = (epoch - $b8f343bf88dacc48$var$dnthresh) / 86400000;
    if (date1904) {
        res -= 1462;
        return res < -1402 ? res - 1 : res;
    }
    return res < 60 ? res - 1 : res;
}
function $b8f343bf88dacc48$var$numdate(v /*:number*/ ) /*:Date|number*/ {
    if (v >= 60 && v < 61) return v;
    var out = new Date();
    out.setTime((v > 60 ? v : v + 1) * 86400000 + $b8f343bf88dacc48$var$dnthresh);
    return out;
}
/* ISO 8601 Duration */ function $b8f343bf88dacc48$var$parse_isodur(s) {
    var sec = 0, mt = 0, time = false;
    var m = s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
    if (!m) throw new Error("|" + s + "| is not an ISO8601 Duration");
    for(var i = 1; i != m.length; ++i){
        if (!m[i]) continue;
        mt = 1;
        if (i > 3) time = true;
        switch(m[i].slice(m[i].length - 1)){
            case 'Y':
                throw new Error("Unsupported ISO Duration Field: " + m[i].slice(m[i].length - 1));
            case 'D':
                mt *= 24;
            /* falls through */ case 'H':
                mt *= 60;
            /* falls through */ case 'M':
                if (!time) throw new Error("Unsupported ISO Duration Field: M");
                else mt *= 60;
            /* falls through */ case 'S':
                break;
        }
        sec += mt * parseInt(m[i], 10);
    }
    return sec;
}
/* Blame https://bugs.chromium.org/p/v8/issues/detail?id=7863 for the regexide */ var $b8f343bf88dacc48$var$pdre1 = /^(\d+):(\d+)(:\d+)?(\.\d+)?$/; // HH:MM[:SS[.UUU]]
var $b8f343bf88dacc48$var$pdre2 = /^(\d+)-(\d+)-(\d+)$/; // YYYY-mm-dd
var $b8f343bf88dacc48$var$pdre3 = /^(\d+)-(\d+)-(\d+)[T ](\d+):(\d+)(:\d+)?(\.\d+)?$/; // YYYY-mm-dd(T or space)HH:MM[:SS[.UUU]], sans "Z"
/* parses a date string as a UTC date */ function $b8f343bf88dacc48$var$parseDate(str /*:string*/ , date1904 /*:boolean*/ ) /*:Date*/ {
    if (str instanceof Date) return str;
    var m = str.match($b8f343bf88dacc48$var$pdre1);
    if (m) return new Date((date1904 ? $b8f343bf88dacc48$var$dnthresh2 : $b8f343bf88dacc48$var$dnthresh1) + ((parseInt(m[1], 10) * 60 + parseInt(m[2], 10)) * 60 + (m[3] ? parseInt(m[3].slice(1), 10) : 0)) * 1000 + (m[4] ? parseInt((m[4] + "000").slice(1, 4), 10) : 0));
    m = str.match($b8f343bf88dacc48$var$pdre2);
    if (m) return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], 0, 0, 0, 0));
    /* TODO: 1900-02-29T00:00:00.000 should return a flag to treat as a date code (affects xlml) */ m = str.match($b8f343bf88dacc48$var$pdre3);
    if (m) return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], m[6] && parseInt(m[6].slice(1), 10) || 0, m[7] && parseInt((m[7] + "0000").slice(1, 4), 10) || 0));
    var d = new Date(str);
    return d;
}
function $b8f343bf88dacc48$var$cc2str(arr /*:Array<number>*/ , debomit) /*:string*/ {
    if ($b8f343bf88dacc48$var$has_buf && $b8f343bf88dacc48$require$Buffer.isBuffer(arr)) {
        if (debomit && $b8f343bf88dacc48$var$buf_utf16le) {
            // TODO: temporary patch
            if (arr[0] == 0xFF && arr[1] == 0xFE) return $b8f343bf88dacc48$var$utf8write(arr.slice(2).toString("utf16le"));
            if (arr[1] == 0xFE && arr[2] == 0xFF) return $b8f343bf88dacc48$var$utf8write($b8f343bf88dacc48$var$utf16beread(arr.slice(2).toString("binary")));
        }
        return arr.toString("binary");
    }
    if (typeof TextDecoder !== "undefined") try {
        if (debomit) {
            if (arr[0] == 0xFF && arr[1] == 0xFE) return $b8f343bf88dacc48$var$utf8write(new TextDecoder("utf-16le").decode(arr.slice(2)));
            if (arr[0] == 0xFE && arr[1] == 0xFF) return $b8f343bf88dacc48$var$utf8write(new TextDecoder("utf-16be").decode(arr.slice(2)));
        }
        var rev = {
            "\u20ac": "\x80",
            "\u201a": "\x82",
            "\u0192": "\x83",
            "\u201e": "\x84",
            "\u2026": "\x85",
            "\u2020": "\x86",
            "\u2021": "\x87",
            "\u02c6": "\x88",
            "\u2030": "\x89",
            "\u0160": "\x8a",
            "\u2039": "\x8b",
            "\u0152": "\x8c",
            "\u017d": "\x8e",
            "\u2018": "\x91",
            "\u2019": "\x92",
            "\u201c": "\x93",
            "\u201d": "\x94",
            "\u2022": "\x95",
            "\u2013": "\x96",
            "\u2014": "\x97",
            "\u02dc": "\x98",
            "\u2122": "\x99",
            "\u0161": "\x9a",
            "\u203a": "\x9b",
            "\u0153": "\x9c",
            "\u017e": "\x9e",
            "\u0178": "\x9f"
        };
        if (Array.isArray(arr)) arr = new Uint8Array(arr);
        return new TextDecoder("latin1").decode(arr).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function(c) {
            return rev[c] || c;
        });
    } catch (e) {}
    var o = [], i = 0;
    // this cascade is for the browsers and runtimes of antiquity (and for modern runtimes that lack TextEncoder)
    try {
        for(i = 0; i < arr.length - 65536; i += 65536)o.push(String.fromCharCode.apply(0, arr.slice(i, i + 65536)));
        o.push(String.fromCharCode.apply(0, arr.slice(i)));
    } catch (e) {
        try {
            for(; i < arr.length - 16384; i += 16384)o.push(String.fromCharCode.apply(0, arr.slice(i, i + 16384)));
            o.push(String.fromCharCode.apply(0, arr.slice(i)));
        } catch (e) {
            for(; i != arr.length; ++i)o.push(String.fromCharCode(arr[i]));
        }
    }
    return o.join("");
}
function $b8f343bf88dacc48$var$dup(o /*:any*/ ) /*:any*/ {
    if (typeof JSON != 'undefined' && !Array.isArray(o)) return JSON.parse(JSON.stringify(o));
    if (typeof o != 'object' || o == null) return o;
    if (o instanceof Date) return new Date(o.getTime());
    var out = {};
    for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) out[k] = $b8f343bf88dacc48$var$dup(o[k]);
    return out;
}
function $b8f343bf88dacc48$var$fill(c /*:string*/ , l /*:number*/ ) /*:string*/ {
    var o = "";
    while(o.length < l)o += c;
    return o;
}
/* TODO: stress test */ function $b8f343bf88dacc48$var$fuzzynum(s /*:string*/ ) /*:number*/ {
    var v /*:number*/  = Number(s);
    if (!isNaN(v)) return isFinite(v) ? v : NaN;
    if (!/\d/.test(s)) return v;
    var wt = 1;
    var ss = s.replace(/([\d]),([\d])/g, "$1$2").replace(/[$]/g, "").replace(/[%]/g, function() {
        wt *= 100;
        return "";
    });
    if (!isNaN(v = Number(ss))) return v / wt;
    ss = ss.replace(/[(]([^()]*)[)]/, function($$, $1) {
        wt = -wt;
        return $1;
    });
    if (!isNaN(v = Number(ss))) return v / wt;
    return v;
}
/* NOTE: Chrome rejects bare times like 1:23 PM */ var $b8f343bf88dacc48$var$FDRE1 = /^(0?\d|1[0-2])(?:|:([0-5]?\d)(?:|(\.\d+)(?:|:([0-5]?\d))|:([0-5]?\d)(|\.\d+)))\s+([ap])m?$/;
var $b8f343bf88dacc48$var$FDRE2 = /^([01]?\d|2[0-3])(?:|:([0-5]?\d)(?:|(\.\d+)(?:|:([0-5]?\d))|:([0-5]?\d)(|\.\d+)))$/;
var $b8f343bf88dacc48$var$FDISO = /^(\d+)-(\d+)-(\d+)[T ](\d+):(\d+)(:\d+)(\.\d+)?[Z]?$/; // YYYY-mm-dd(T or space)HH:MM:SS[.UUU][Z]
/* TODO: 1904 adjustment */ var $b8f343bf88dacc48$var$utc_append_works = new Date("6/9/69 00:00 UTC").valueOf() == -17798400000;
function $b8f343bf88dacc48$var$fuzzytime1(M) /*:Date*/ {
    if (!M[2]) return new Date(Date.UTC(1899, 11, 31, +M[1] % 12 + (M[7] == "p" ? 12 : 0), 0, 0, 0));
    if (M[3]) {
        if (M[4]) return new Date(Date.UTC(1899, 11, 31, +M[1] % 12 + (M[7] == "p" ? 12 : 0), +M[2], +M[4], parseFloat(M[3]) * 1000));
        else return new Date(Date.UTC(1899, 11, 31, M[7] == "p" ? 12 : 0, +M[1], +M[2], parseFloat(M[3]) * 1000));
    } else if (M[5]) return new Date(Date.UTC(1899, 11, 31, +M[1] % 12 + (M[7] == "p" ? 12 : 0), +M[2], +M[5], M[6] ? parseFloat(M[6]) * 1000 : 0));
    else return new Date(Date.UTC(1899, 11, 31, +M[1] % 12 + (M[7] == "p" ? 12 : 0), +M[2], 0, 0));
}
function $b8f343bf88dacc48$var$fuzzytime2(M) /*:Date*/ {
    if (!M[2]) return new Date(Date.UTC(1899, 11, 31, +M[1], 0, 0, 0));
    if (M[3]) {
        if (M[4]) return new Date(Date.UTC(1899, 11, 31, +M[1], +M[2], +M[4], parseFloat(M[3]) * 1000));
        else return new Date(Date.UTC(1899, 11, 31, 0, +M[1], +M[2], parseFloat(M[3]) * 1000));
    } else if (M[5]) return new Date(Date.UTC(1899, 11, 31, +M[1], +M[2], +M[5], M[6] ? parseFloat(M[6]) * 1000 : 0));
    else return new Date(Date.UTC(1899, 11, 31, +M[1], +M[2], 0, 0));
}
var $b8f343bf88dacc48$var$lower_months = [
    'january',
    'february',
    'march',
    'april',
    'may',
    'june',
    'july',
    'august',
    'september',
    'october',
    'november',
    'december'
];
function $b8f343bf88dacc48$var$fuzzydate(s /*:string*/ ) /*:Date*/ {
    // See issue 2863 -- this is technically not supported in Excel but is otherwise useful
    if ($b8f343bf88dacc48$var$FDISO.test(s)) return s.indexOf("Z") == -1 ? $b8f343bf88dacc48$var$local_to_utc(new Date(s)) : new Date(s);
    var lower = s.toLowerCase();
    var lnos = lower.replace(/\s+/g, " ").trim();
    var M = lnos.match($b8f343bf88dacc48$var$FDRE1);
    if (M) return $b8f343bf88dacc48$var$fuzzytime1(M);
    M = lnos.match($b8f343bf88dacc48$var$FDRE2);
    if (M) return $b8f343bf88dacc48$var$fuzzytime2(M);
    M = lnos.match($b8f343bf88dacc48$var$pdre3);
    if (M) return new Date(Date.UTC(+M[1], +M[2] - 1, +M[3], +M[4], +M[5], M[6] && parseInt(M[6].slice(1), 10) || 0, M[7] && parseInt((M[7] + "0000").slice(1, 4), 10) || 0));
    var o = new Date($b8f343bf88dacc48$var$utc_append_works && s.indexOf("UTC") == -1 ? s + " UTC" : s), n = new Date(NaN);
    var y = o.getYear(), m = o.getMonth(), d = o.getDate();
    if (isNaN(d)) return n;
    if (lower.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
        lower = lower.replace(/[^a-z]/g, "").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/, "");
        if (lower.length > 3 && $b8f343bf88dacc48$var$lower_months.indexOf(lower) == -1) return n;
    } else if (lower.replace(/[ap]m?/, "").match(/[a-z]/)) return n;
    if (y < 0 || y > 8099 || s.match(/[^-0-9:,\/\\\ ]/)) return n;
    return o;
}
var $b8f343bf88dacc48$var$split_regex = /*#__PURE__*/ function() {
    var safe_split_regex = "abacaba".split(/(:?b)/i).length == 5;
    return function split_regex(str /*:string*/ , re, def /*:string*/ ) /*:Array<string>*/ {
        if (safe_split_regex || typeof re == "string") return str.split(re);
        var p = str.split(re), o = [
            p[0]
        ];
        for(var i = 1; i < p.length; ++i){
            o.push(def);
            o.push(p[i]);
        }
        return o;
    };
}();
function $b8f343bf88dacc48$var$utc_to_local(utc) {
    return new Date(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate(), utc.getUTCHours(), utc.getUTCMinutes(), utc.getUTCSeconds(), utc.getUTCMilliseconds());
}
function $b8f343bf88dacc48$var$local_to_utc(local) {
    return new Date(Date.UTC(local.getFullYear(), local.getMonth(), local.getDate(), local.getHours(), local.getMinutes(), local.getSeconds(), local.getMilliseconds()));
}
function $b8f343bf88dacc48$var$remove_doctype(str) {
    var preamble = str.slice(0, 1024);
    var si = preamble.indexOf("<!DOCTYPE");
    if (si == -1) return str;
    var m = str.match(/<[\w]/);
    if (!m) return str;
    return str.slice(0, si) + str.slice(m.index);
}
/* str.match(/<!--[\s\S]*?-->/g) --> str_match_ng(str, "<!--", "-->") */ function $b8f343bf88dacc48$var$str_match_ng(str, s, e) {
    var out = [];
    var si = str.indexOf(s);
    while(si > -1){
        var ei = str.indexOf(e, si + s.length);
        if (ei == -1) break;
        out.push(str.slice(si, ei + e.length));
        si = str.indexOf(s, ei + e.length);
    }
    return out.length > 0 ? out : null;
}
/* str.replace(/<!--[\s\S]*?-->/g, "") --> str_remove_ng(str, "<!--", "-->") */ function $b8f343bf88dacc48$var$str_remove_ng(str, s, e) {
    var out = [], last = 0;
    var si = str.indexOf(s);
    if (si == -1) return str;
    while(si > -1){
        out.push(str.slice(last, si));
        var ei = str.indexOf(e, si + s.length);
        if (ei == -1) break;
        if ((si = str.indexOf(s, last = ei + e.length)) == -1) out.push(str.slice(last));
    }
    return out.join("");
}
/* str.match(/<tag\b[^>]*?>([\s\S]*?)</tag>/) --> str_match_xml(str, "tag") */ var $b8f343bf88dacc48$var$xml_boundary = {
    " ": 1,
    "\t": 1,
    "\r": 1,
    "\n": 1,
    ">": 1
};
function $b8f343bf88dacc48$var$str_match_xml(str, tag) {
    var si = str.indexOf('<' + tag), w = tag.length + 1, L = str.length;
    while(si >= 0 && si <= L - w && !$b8f343bf88dacc48$var$xml_boundary[str.charAt(si + w)])si = str.indexOf('<' + tag, si + 1);
    if (si === -1) return null;
    var sf = str.indexOf(">", si + tag.length);
    if (sf === -1) return null;
    var et = "</" + tag + ">";
    var ei = str.indexOf(et, sf);
    if (ei == -1) return null;
    return [
        str.slice(si, ei + et.length),
        str.slice(sf + 1, ei)
    ];
}
/* str.match(/<(?:\w+:)?tag\b[^<>]*?>([\s\S]*?)<\/(?:\w+:)?tag>/) --> str_match_xml(str, "tag") */ var $b8f343bf88dacc48$var$str_match_xml_ns = /*#__PURE__*/ function() {
    var str_match_xml_ns_cache = {};
    return function str_match_xml_ns(str, tag) {
        var res = str_match_xml_ns_cache[tag];
        if (!res) str_match_xml_ns_cache[tag] = res = [
            new RegExp('<(?:\\w+:)?' + tag + '\\b[^<>]*>', "g"),
            new RegExp('</(?:\\w+:)?' + tag + '>', "g")
        ];
        res[0].lastIndex = res[1].lastIndex = 0;
        var m = res[0].exec(str);
        if (!m) return null;
        var si = m.index;
        var sf = res[0].lastIndex;
        res[1].lastIndex = res[0].lastIndex;
        m = res[1].exec(str);
        if (!m) return null;
        var ei = m.index;
        var ef = res[1].lastIndex;
        return [
            str.slice(si, ef),
            str.slice(sf, ei)
        ];
    };
}();
/* str.match(/<(?:\w+:)?tag\b[^<>]*?>([\s\S]*?)<\/(?:\w+:)?tag>/g) --> str_match_xml_ns_g(str, "tag") */ var $b8f343bf88dacc48$var$str_match_xml_ns_g = /*#__PURE__*/ function() {
    var str_match_xml_ns_cache = {};
    return function str_match_xml_ns(str, tag) {
        var out = [];
        var res = str_match_xml_ns_cache[tag];
        if (!res) str_match_xml_ns_cache[tag] = res = [
            new RegExp('<(?:\\w+:)?' + tag + '\\b[^<>]*>', "g"),
            new RegExp('</(?:\\w+:)?' + tag + '>', "g")
        ];
        res[0].lastIndex = res[1].lastIndex = 0;
        var m;
        while(m = res[0].exec(str)){
            var si = m.index;
            res[1].lastIndex = res[0].lastIndex;
            m = res[1].exec(str);
            if (!m) return null;
            var ef = res[1].lastIndex;
            out.push(str.slice(si, ef));
            res[0].lastIndex = res[1].lastIndex;
        }
        return out.length == 0 ? null : out;
    };
}();
var $b8f343bf88dacc48$var$str_remove_xml_ns_g = /*#__PURE__*/ function() {
    var str_remove_xml_ns_cache = {};
    return function str_remove_xml_ns_g(str, tag) {
        var out = [];
        var res = str_remove_xml_ns_cache[tag];
        if (!res) str_remove_xml_ns_cache[tag] = res = [
            new RegExp('<(?:\\w+:)?' + tag + '\\b[^<>]*>', "g"),
            new RegExp('</(?:\\w+:)?' + tag + '>', "g")
        ];
        res[0].lastIndex = res[1].lastIndex = 0;
        var m;
        var si = 0, ef = 0;
        while(m = res[0].exec(str)){
            si = m.index;
            out.push(str.slice(ef, si));
            ef = si;
            res[1].lastIndex = res[0].lastIndex;
            m = res[1].exec(str);
            if (!m) return null;
            ef = res[1].lastIndex;
            res[0].lastIndex = res[1].lastIndex;
        }
        out.push(str.slice(ef));
        return out.length == 0 ? "" : out.join("");
    };
}();
/* str.match(/<(?:\w+:)?tag\b[^>]*?>([\s\S]*?)<\/(?:\w+:)?tag>/gi) --> str_match_xml_ns_ig(str, "tag") */ var $b8f343bf88dacc48$var$str_match_xml_ig = /*#__PURE__*/ function() {
    var str_match_xml_ns_cache = {};
    return function str_match_xml_ns(str, tag) {
        var out = [];
        var res = str_match_xml_ns_cache[tag];
        if (!res) str_match_xml_ns_cache[tag] = res = [
            new RegExp('<' + tag + '\\b[^<>]*>', "ig"),
            new RegExp('</' + tag + '>', "ig")
        ];
        res[0].lastIndex = res[1].lastIndex = 0;
        var m;
        while(m = res[0].exec(str)){
            var si = m.index;
            res[1].lastIndex = res[0].lastIndex;
            m = res[1].exec(str);
            if (!m) return null;
            var ef = res[1].lastIndex;
            out.push(str.slice(si, ef));
            res[0].lastIndex = res[1].lastIndex;
        }
        return out.length == 0 ? null : out;
    };
}();
function $b8f343bf88dacc48$var$getdatastr(data) /*:?string*/ {
    if (!data) return null;
    if (data.content && data.type) return $b8f343bf88dacc48$var$cc2str(data.content, true);
    if (data.data) return $b8f343bf88dacc48$var$debom(data.data);
    if (data.asNodeBuffer && $b8f343bf88dacc48$var$has_buf) return $b8f343bf88dacc48$var$debom(data.asNodeBuffer().toString('binary'));
    if (data.asBinary) return $b8f343bf88dacc48$var$debom(data.asBinary());
    if (data._data && data._data.getContent) return $b8f343bf88dacc48$var$debom($b8f343bf88dacc48$var$cc2str(Array.prototype.slice.call(data._data.getContent(), 0)));
    return null;
}
function $b8f343bf88dacc48$var$getdatabin(data) {
    if (!data) return null;
    if (data.data) return $b8f343bf88dacc48$var$char_codes(data.data);
    if (data.asNodeBuffer && $b8f343bf88dacc48$var$has_buf) return data.asNodeBuffer();
    if (data._data && data._data.getContent) {
        var o = data._data.getContent();
        if (typeof o == "string") return $b8f343bf88dacc48$var$char_codes(o);
        return Array.prototype.slice.call(o);
    }
    if (data.content && data.type) return data.content;
    return null;
}
function $b8f343bf88dacc48$var$getdata(data) {
    return data && data.name.slice(-4) === ".bin" ? $b8f343bf88dacc48$var$getdatabin(data) : $b8f343bf88dacc48$var$getdatastr(data);
}
/* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */ /* OASIS does not comment on filename case sensitivity */ function $b8f343bf88dacc48$var$safegetzipfile(zip, file /*:string*/ ) {
    var k = zip.FullPaths || $b8f343bf88dacc48$var$keys(zip.files);
    var f = file.toLowerCase().replace(/[\/]/g, '\\'), g = f.replace(/\\/g, '\/');
    for(var i = 0; i < k.length; ++i){
        var n = k[i].replace(/^Root Entry[\/]/, "").toLowerCase();
        if (f == n || g == n) return zip.files ? zip.files[k[i]] : zip.FileIndex[i];
    }
    return null;
}
function $b8f343bf88dacc48$var$getzipfile(zip, file /*:string*/ ) {
    var o = $b8f343bf88dacc48$var$safegetzipfile(zip, file);
    if (o == null) throw new Error("Cannot find file " + file + " in zip");
    return o;
}
function $b8f343bf88dacc48$var$getzipdata(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:any*/ {
    if (!safe) return $b8f343bf88dacc48$var$getdata($b8f343bf88dacc48$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $b8f343bf88dacc48$var$getzipdata(zip, file);
    } catch (e) {
        return null;
    }
}
function $b8f343bf88dacc48$var$getzipstr(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:?string*/ {
    if (!safe) return $b8f343bf88dacc48$var$getdatastr($b8f343bf88dacc48$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $b8f343bf88dacc48$var$getzipstr(zip, file);
    } catch (e) {
        return null;
    }
}
function $b8f343bf88dacc48$var$getzipbin(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:any*/ {
    if (!safe) return $b8f343bf88dacc48$var$getdatabin($b8f343bf88dacc48$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $b8f343bf88dacc48$var$getzipbin(zip, file);
    } catch (e) {
        return null;
    }
}
function $b8f343bf88dacc48$var$zipentries(zip) {
    var k = zip.FullPaths || $b8f343bf88dacc48$var$keys(zip.files), o = [];
    for(var i = 0; i < k.length; ++i)if (k[i].slice(-1) != '/') o.push(k[i].replace(/^Root Entry[\/]/, ""));
    return o.sort();
}
function $b8f343bf88dacc48$var$zip_add_file(zip, path, content) {
    if (zip.FullPaths) {
        if (typeof content == "string") {
            var res;
            if ($b8f343bf88dacc48$var$has_buf) res = $b8f343bf88dacc48$var$Buffer_from(content);
            else res = $b8f343bf88dacc48$var$utf8decode(content);
            return $b8f343bf88dacc48$export$9f0e51cd97c572a.utils.cfb_add(zip, path, res);
        }
        $b8f343bf88dacc48$export$9f0e51cd97c572a.utils.cfb_add(zip, path, content);
    } else zip.file(path, content);
}
function $b8f343bf88dacc48$var$zip_new() {
    return $b8f343bf88dacc48$export$9f0e51cd97c572a.utils.cfb_new();
}
function $b8f343bf88dacc48$var$zip_read(d, o) {
    switch(o.type){
        case "base64":
            return $b8f343bf88dacc48$export$9f0e51cd97c572a.read(d, {
                type: "base64"
            });
        case "binary":
            return $b8f343bf88dacc48$export$9f0e51cd97c572a.read(d, {
                type: "binary"
            });
        case "buffer":
        case "array":
            return $b8f343bf88dacc48$export$9f0e51cd97c572a.read(d, {
                type: "buffer"
            });
    }
    throw new Error("Unrecognized type " + o.type);
}
function $b8f343bf88dacc48$var$resolve_path(path /*:string*/ , base /*:string*/ ) /*:string*/ {
    if (path.charAt(0) == "/") return path.slice(1);
    var result = base.split('/');
    if (base.slice(-1) != "/") result.pop(); // folder path
    var target = path.split('/');
    while(target.length !== 0){
        var step = target.shift();
        if (step === '..') result.pop();
        else if (step !== '.') result.push(step);
    }
    return result.join('/');
}
var $b8f343bf88dacc48$var$XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
var $b8f343bf88dacc48$var$attregexg = /\s([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
var $b8f343bf88dacc48$var$tagregex1 = /<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?<>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'"<>\s=]+))*\s*[\/\?]?>/mg, $b8f343bf88dacc48$var$tagregex2 = /<[^<>]*>/g;
var $b8f343bf88dacc48$var$tagregex = /*#__PURE__*/ $b8f343bf88dacc48$var$XML_HEADER.match($b8f343bf88dacc48$var$tagregex1) ? $b8f343bf88dacc48$var$tagregex1 : $b8f343bf88dacc48$var$tagregex2;
var $b8f343bf88dacc48$var$nsregex = /<\w*:/, $b8f343bf88dacc48$var$nsregex2 = /<(\/?)\w+:/;
function $b8f343bf88dacc48$var$parsexmltag(tag /*:string*/ , skip_root /*:?boolean*/ , skip_LC /*:?boolean*/ ) /*:any*/ {
    var z = {} /*:any*/ ;
    var eq = 0, c = 0;
    for(; eq !== tag.length; ++eq)if ((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
    if (!skip_root) z[0] = tag.slice(0, eq);
    if (eq === tag.length) return z;
    var m = tag.match($b8f343bf88dacc48$var$attregexg), j = 0, v = "", i = 0, q = "", cc = "", quot = 1;
    if (m) for(i = 0; i != m.length; ++i){
        cc = m[i].slice(1);
        for(c = 0; c != cc.length; ++c)if (cc.charCodeAt(c) === 61) break;
        q = cc.slice(0, c).trim();
        while(cc.charCodeAt(c + 1) == 32)++c;
        quot = (eq = cc.charCodeAt(c + 1)) == 34 || eq == 39 ? 1 : 0;
        v = cc.slice(c + 1 + quot, cc.length - quot);
        for(j = 0; j != q.length; ++j)if (q.charCodeAt(j) === 58) break;
        if (j === q.length) {
            if (q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
            z[q] = v;
            if (!skip_LC) z[q.toLowerCase()] = v;
        } else {
            var k = (j === 5 && q.slice(0, 5) === "xmlns" ? "xmlns" : "") + q.slice(j + 1);
            if (z[k] && q.slice(j - 3, j) == "ext") continue; // from ods
            z[k] = v;
            if (!skip_LC) z[k.toLowerCase()] = v;
        }
    }
    return z;
}
function $b8f343bf88dacc48$var$strip_ns(x /*:string*/ ) /*:string*/ {
    return x.replace($b8f343bf88dacc48$var$nsregex2, "<$1");
}
var $b8f343bf88dacc48$var$encodings = {
    '&quot;': '"',
    '&apos;': "'",
    '&gt;': '>',
    '&lt;': '<',
    '&amp;': '&'
};
var $b8f343bf88dacc48$var$rencoding = /*#__PURE__*/ $b8f343bf88dacc48$var$evert($b8f343bf88dacc48$var$encodings);
//var rencstr = "&<>'\"".split("");
// TODO: CP remap (need to read file version to determine OS)
var $b8f343bf88dacc48$var$unescapexml /*:StringConv*/  = /*#__PURE__*/ function() {
    /* 22.4.2.4 bstr (Basic String) */ var encregex = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig, coderegex = /_x([\da-fA-F]{4})_/ig;
    function raw_unescapexml(text /*:string*/ ) /*:string*/ {
        var s = text + '', i = s.indexOf("<![CDATA[");
        if (i == -1) return s.replace(encregex, function($$, $1) {
            return $b8f343bf88dacc48$var$encodings[$$] || String.fromCharCode(parseInt($1, $$.indexOf("x") > -1 ? 16 : 10)) || $$;
        }).replace(coderegex, function(m, c) {
            return String.fromCharCode(parseInt(c, 16));
        });
        var j = s.indexOf("]]>");
        return raw_unescapexml(s.slice(0, i)) + s.slice(i + 9, j) + raw_unescapexml(s.slice(j + 3));
    }
    return function unescapexml(text /*:string*/ , xlsx /*:boolean*/ ) {
        var out = raw_unescapexml(text);
        return xlsx ? out.replace(/\r\n/g, "\n") : out;
    };
}();
var $b8f343bf88dacc48$var$decregex = /[&<>'"]/g, $b8f343bf88dacc48$var$charegex = /[\u0000-\u0008\u000b-\u001f\uFFFE-\uFFFF]/g;
function $b8f343bf88dacc48$var$escapexml(text /*:string*/ ) /*:string*/ {
    var s = text + '';
    return s.replace($b8f343bf88dacc48$var$decregex, function(y) {
        return $b8f343bf88dacc48$var$rencoding[y];
    }).replace($b8f343bf88dacc48$var$charegex, function(s) {
        return "_x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + "_";
    });
}
function $b8f343bf88dacc48$var$escapexmltag(text /*:string*/ ) /*:string*/ {
    return $b8f343bf88dacc48$var$escapexml(text).replace(/ /g, "_x0020_");
}
var $b8f343bf88dacc48$var$htmlcharegex = /[\u0000-\u001f]/g;
function $b8f343bf88dacc48$var$escapehtml(text /*:string*/ ) /*:string*/ {
    var s = text + '';
    return s.replace($b8f343bf88dacc48$var$decregex, function(y) {
        return $b8f343bf88dacc48$var$rencoding[y];
    }).replace(/\n/g, "<br/>").replace($b8f343bf88dacc48$var$htmlcharegex, function(s) {
        return "&#x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + ";";
    });
}
function $b8f343bf88dacc48$var$escapexlml(text /*:string*/ ) /*:string*/ {
    var s = text + '';
    return s.replace($b8f343bf88dacc48$var$decregex, function(y) {
        return $b8f343bf88dacc48$var$rencoding[y];
    }).replace($b8f343bf88dacc48$var$htmlcharegex, function(s) {
        return "&#x" + s.charCodeAt(0).toString(16).toUpperCase() + ";";
    });
}
/* TODO: handle codepages */ var $b8f343bf88dacc48$var$xlml_fixstr /*:StringConv*/  = /*#__PURE__*/ function() {
    var entregex = /&#(\d+);/g;
    function entrepl($$ /*:string*/ , $1 /*:string*/ ) /*:string*/ {
        return String.fromCharCode(parseInt($1, 10));
    }
    return function xlml_fixstr(str /*:string*/ ) /*:string*/ {
        return str.replace(entregex, entrepl);
    };
}();
function $b8f343bf88dacc48$var$xlml_unfixstr(str /*:string*/ ) /*:string*/ {
    return str.replace(/(\r\n|[\r\n])/g, "\&#10;");
}
/* note: xsd:boolean valid values: true / 1 / false / 0 */ function $b8f343bf88dacc48$var$parsexmlbool(value /*:any*/ ) /*:boolean*/ {
    switch(value){
        case 1:
        case true:
        case '1':
        case 'true':
            return true;
        case 0:
        case false:
        case '0':
        case 'false':
            return false;
    }
    return false;
}
function $b8f343bf88dacc48$var$utf8reada(orig /*:string*/ ) /*:string*/ {
    var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
    while(i < orig.length){
        c = orig.charCodeAt(i++);
        if (c < 128) {
            out += String.fromCharCode(c);
            continue;
        }
        d = orig.charCodeAt(i++);
        if (c > 191 && c < 224) {
            f = (c & 31) << 6;
            f |= d & 63;
            out += String.fromCharCode(f);
            continue;
        }
        e = orig.charCodeAt(i++);
        if (c < 240) {
            out += String.fromCharCode((c & 15) << 12 | (d & 63) << 6 | e & 63);
            continue;
        }
        f = orig.charCodeAt(i++);
        w = ((c & 7) << 18 | (d & 63) << 12 | (e & 63) << 6 | f & 63) - 65536;
        out += String.fromCharCode(0xD800 + (w >>> 10 & 1023));
        out += String.fromCharCode(0xDC00 + (w & 1023));
    }
    return out;
}
function $b8f343bf88dacc48$var$utf8readb(data) {
    var out = $b8f343bf88dacc48$var$new_raw_buf(2 * data.length), w, i, j = 1, k = 0, ww = 0, c;
    for(i = 0; i < data.length; i += j){
        j = 1;
        if ((c = data.charCodeAt(i)) < 128) w = c;
        else if (c < 224) {
            w = (c & 31) * 64 + (data.charCodeAt(i + 1) & 63);
            j = 2;
        } else if (c < 240) {
            w = (c & 15) * 4096 + (data.charCodeAt(i + 1) & 63) * 64 + (data.charCodeAt(i + 2) & 63);
            j = 3;
        } else {
            j = 4;
            w = (c & 7) * 262144 + (data.charCodeAt(i + 1) & 63) * 4096 + (data.charCodeAt(i + 2) & 63) * 64 + (data.charCodeAt(i + 3) & 63);
            w -= 65536;
            ww = 0xD800 + (w >>> 10 & 1023);
            w = 0xDC00 + (w & 1023);
        }
        if (ww !== 0) {
            out[k++] = ww & 255;
            out[k++] = ww >>> 8;
            ww = 0;
        }
        out[k++] = w % 256;
        out[k++] = w >>> 8;
    }
    return out.slice(0, k).toString('ucs2');
}
function $b8f343bf88dacc48$var$utf8readc(data) {
    return $b8f343bf88dacc48$var$Buffer_from(data, 'binary').toString('utf8');
}
var $b8f343bf88dacc48$var$utf8corpus = "foo bar baz\u00e2\u0098\u0083\u00f0\u009f\u008d\u00a3";
var $b8f343bf88dacc48$var$utf8read = $b8f343bf88dacc48$var$has_buf && /*#__PURE__*/ ($b8f343bf88dacc48$var$utf8readc($b8f343bf88dacc48$var$utf8corpus) == /*#__PURE__*/ $b8f343bf88dacc48$var$utf8reada($b8f343bf88dacc48$var$utf8corpus) && $b8f343bf88dacc48$var$utf8readc || /*#__PURE__*/ $b8f343bf88dacc48$var$utf8readb($b8f343bf88dacc48$var$utf8corpus) == /*#__PURE__*/ $b8f343bf88dacc48$var$utf8reada($b8f343bf88dacc48$var$utf8corpus) && $b8f343bf88dacc48$var$utf8readb) || $b8f343bf88dacc48$var$utf8reada;
var $b8f343bf88dacc48$var$utf8write /*:StringConv*/  = $b8f343bf88dacc48$var$has_buf ? function(data) {
    return $b8f343bf88dacc48$var$Buffer_from(data, 'utf8').toString("binary");
} : function(orig /*:string*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [], i = 0, c = 0, d = 0;
    while(i < orig.length){
        c = orig.charCodeAt(i++);
        switch(true){
            case c < 128:
                out.push(String.fromCharCode(c));
                break;
            case c < 2048:
                out.push(String.fromCharCode(192 + (c >> 6)));
                out.push(String.fromCharCode(128 + (c & 63)));
                break;
            case c >= 55296 && c < 57344:
                c -= 55296;
                d = orig.charCodeAt(i++) - 56320 + (c << 10);
                out.push(String.fromCharCode(240 + (d >> 18 & 7)));
                out.push(String.fromCharCode(144 + (d >> 12 & 63)));
                out.push(String.fromCharCode(128 + (d >> 6 & 63)));
                out.push(String.fromCharCode(128 + (d & 63)));
                break;
            default:
                out.push(String.fromCharCode(224 + (c >> 12)));
                out.push(String.fromCharCode(128 + (c >> 6 & 63)));
                out.push(String.fromCharCode(128 + (c & 63)));
        }
    }
    return out.join("");
};
var $b8f343bf88dacc48$var$htmldecode /*:{(s:string):string}*/  = /*#__PURE__*/ function() {
    var entities /*:Array<[RegExp, string]>*/  = [
        [
            'nbsp',
            ' '
        ],
        [
            'middot',
            "\xb7"
        ],
        [
            'quot',
            '"'
        ],
        [
            'apos',
            "'"
        ],
        [
            'gt',
            '>'
        ],
        [
            'lt',
            '<'
        ],
        [
            'amp',
            '&'
        ]
    ].map(function(x /*:[string, string]*/ ) {
        return [
            new RegExp('&' + x[0] + ';', "ig"),
            x[1]
        ];
    });
    return function htmldecode(str /*:string*/ ) /*:string*/ {
        var o = str// Remove new lines and spaces from start of content
        .replace(/^[\t\n\r ]+/, "")// Remove new lines and spaces from end of content
        .replace(/(^|[^\t\n\r ])[\t\n\r ]+$/, "$1")// Added line which removes any white space characters after and before html tags
        .replace(/>\s+/g, ">").replace(/\b\s+</g, "<")// Replace remaining new lines and spaces with space
        .replace(/[\t\n\r ]+/g, " ")// Replace <br> tags with new lines
        .replace(/<\s*[bB][rR]\s*\/?>/g, "\n")// Strip HTML elements
        .replace(/<[^<>]*>/g, "");
        for(var i = 0; i < entities.length; ++i)o = o.replace(entities[i][0], entities[i][1]);
        return o;
    };
}();
var $b8f343bf88dacc48$var$vtvregex = /<\/?(?:vt:)?variant>/g, $b8f343bf88dacc48$var$vtmregex = /<(?:vt:)([^<"'>]*)>([\s\S]*)</;
function $b8f343bf88dacc48$var$parseVector(data /*:string*/ , opts) /*:Array<{v:string,t:string}>*/ {
    var h = $b8f343bf88dacc48$var$parsexmltag(data);
    var matches /*:Array<string>*/  = $b8f343bf88dacc48$var$str_match_xml_ns_g(data, h.baseType) || [];
    var res /*:Array<any>*/  = [];
    if (matches.length != h.size) {
        if (opts.WTF) throw new Error("unexpected vector length " + matches.length + " != " + h.size);
        return res;
    }
    matches.forEach(function(x /*:string*/ ) {
        var v = x.replace($b8f343bf88dacc48$var$vtvregex, "").match($b8f343bf88dacc48$var$vtmregex);
        if (v) res.push({
            v: $b8f343bf88dacc48$var$utf8read(v[2]),
            t: v[1]
        });
    });
    return res;
}
var $b8f343bf88dacc48$var$wtregex = /(^\s|\s$|\n)/;
function $b8f343bf88dacc48$var$writetag(f /*:string*/ , g /*:string*/ ) /*:string*/ {
    return '<' + f + (g.match($b8f343bf88dacc48$var$wtregex) ? ' xml:space="preserve"' : "") + '>' + g + '</' + f + '>';
}
function $b8f343bf88dacc48$var$wxt_helper(h) /*:string*/ {
    return $b8f343bf88dacc48$var$keys(h).map(function(k) {
        return " " + k + '="' + h[k] + '"';
    }).join("");
}
function $b8f343bf88dacc48$var$writextag(f /*:string*/ , g /*:?string*/ , h) {
    return '<' + f + (h != null ? $b8f343bf88dacc48$var$wxt_helper(h) : "") + (g != null ? (g.match($b8f343bf88dacc48$var$wtregex) ? ' xml:space="preserve"' : "") + '>' + g + '</' + f : "/") + '>';
}
function $b8f343bf88dacc48$var$write_w3cdtf(d /*:Date*/ , t /*:?boolean*/ ) /*:string*/ {
    try {
        return d.toISOString().replace(/\.\d*/, "");
    } catch (e) {
        if (t) throw e;
    }
    return "";
}
function $b8f343bf88dacc48$var$write_vt(s, xlsx /*:?boolean*/ ) /*:string*/ {
    switch(typeof s){
        case 'string':
            var o = $b8f343bf88dacc48$var$writextag('vt:lpwstr', $b8f343bf88dacc48$var$escapexml(s));
            if (xlsx) o = o.replace(/&quot;/g, "_x0022_");
            return o;
        case 'number':
            return $b8f343bf88dacc48$var$writextag((s | 0) == s ? 'vt:i4' : 'vt:r8', $b8f343bf88dacc48$var$escapexml(String(s)));
        case 'boolean':
            return $b8f343bf88dacc48$var$writextag('vt:bool', s ? 'true' : 'false');
    }
    if (s instanceof Date) return $b8f343bf88dacc48$var$writextag('vt:filetime', $b8f343bf88dacc48$var$write_w3cdtf(s));
    throw new Error("Unable to serialize " + s);
}
function $b8f343bf88dacc48$var$xlml_normalize(d) /*:string*/ {
    if ($b8f343bf88dacc48$var$has_buf && /*::typeof Buffer !== "undefined" && d != null && d instanceof Buffer &&*/ $b8f343bf88dacc48$require$Buffer.isBuffer(d)) return d.toString('utf8');
    if (typeof d === 'string') return d;
    /* duktape */ if (typeof Uint8Array !== 'undefined' && d instanceof Uint8Array) return $b8f343bf88dacc48$var$utf8read($b8f343bf88dacc48$var$a2s($b8f343bf88dacc48$var$ab2a(d)));
    throw new Error("Bad input format: expected Buffer or string");
}
/* UOS uses CJK in tags, ODS uses invalid XML */ var $b8f343bf88dacc48$var$xlmlregex = /<([\/]?)([^\s?><!\/:"]*:|)([^\s?<>:\/"]+)(?:\s+[^<>=?"'\s]+="[^"]*?")*\s*[\/]?>/mg;
var $b8f343bf88dacc48$var$XMLNS = {
    CORE_PROPS: 'http://schemas.openxmlformats.org/package/2006/metadata/core-properties',
    CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",
    EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
    CT: 'http://schemas.openxmlformats.org/package/2006/content-types',
    RELS: 'http://schemas.openxmlformats.org/package/2006/relationships',
    TCMNT: 'http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments',
    'dc': 'http://purl.org/dc/elements/1.1/',
    'dcterms': 'http://purl.org/dc/terms/',
    'dcmitype': 'http://purl.org/dc/dcmitype/',
    'mx': 'http://schemas.microsoft.com/office/mac/excel/2008/main',
    'r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
    'sjs': 'http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties',
    'vt': 'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes',
    'xsi': 'http://www.w3.org/2001/XMLSchema-instance',
    'xsd': 'http://www.w3.org/2001/XMLSchema'
} /*:any*/ ;
var $b8f343bf88dacc48$var$XMLNS_main = [
    'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
    'http://purl.oclc.org/ooxml/spreadsheetml/main',
    'http://schemas.microsoft.com/office/excel/2006/main',
    'http://schemas.microsoft.com/office/excel/2006/2'
];
var $b8f343bf88dacc48$var$XLMLNS = {
    'o': 'urn:schemas-microsoft-com:office:office',
    'x': 'urn:schemas-microsoft-com:office:excel',
    'ss': 'urn:schemas-microsoft-com:office:spreadsheet',
    'dt': 'uuid:C2F41010-65B3-11d1-A29F-00AA00C14882',
    'mv': 'http://macVmlSchemaUri',
    'v': 'urn:schemas-microsoft-com:vml',
    'html': 'http://www.w3.org/TR/REC-html40'
} /*:any*/ ;
function $b8f343bf88dacc48$var$read_double_le(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    var s = 1 - 2 * (b[idx + 7] >>> 7);
    var e = ((b[idx + 7] & 0x7f) << 4) + (b[idx + 6] >>> 4 & 0x0f);
    var m = b[idx + 6] & 0x0f;
    for(var i = 5; i >= 0; --i)m = m * 256 + b[idx + i];
    if (e == 0x7ff) return m == 0 ? s * Infinity : NaN;
    if (e == 0) e = -1022;
    else {
        e -= 1023;
        m += Math.pow(2, 52);
    }
    return s * Math.pow(2, e - 52) * m;
}
function $b8f343bf88dacc48$var$write_double_le(b /*:RawBytes|CFBlob*/ , v /*:number*/ , idx /*:number*/ ) {
    var bs = (v < 0 || 1 / v == -Infinity ? 1 : 0) << 7, e = 0, m = 0;
    var av = bs ? -v : v;
    if (!isFinite(av)) {
        e = 0x7ff;
        m = isNaN(v) ? 0x6969 : 0;
    } else if (av == 0) e = m = 0;
    else {
        e = Math.floor(Math.log(av) / Math.LN2);
        m = av * Math.pow(2, 52 - e);
        if (e <= -1023 && (!isFinite(m) || m < Math.pow(2, 52))) e = -1022;
        else {
            m -= Math.pow(2, 52);
            e += 1023;
        }
    }
    for(var i = 0; i <= 5; ++i, m /= 256)b[idx + i] = m & 0xff;
    b[idx + 6] = (e & 0x0f) << 4 | m & 0xf;
    b[idx + 7] = e >> 4 | bs;
}
var $b8f343bf88dacc48$var$___toBuffer = function(bufs /*:Array<Array<RawBytes> >*/ ) /*:RawBytes*/ {
    var x = [], w = 10240;
    for(var i = 0; i < bufs[0].length; ++i)if (bufs[0][i]) for(var j = 0, L = bufs[0][i].length; j < L; j += w)x.push.apply(x, bufs[0][i].slice(j, j + w));
    return x;
};
var $b8f343bf88dacc48$var$__toBuffer = $b8f343bf88dacc48$var$has_buf ? function(bufs) {
    return bufs[0].length > 0 && $b8f343bf88dacc48$require$Buffer.isBuffer(bufs[0][0]) ? $b8f343bf88dacc48$require$Buffer.concat(bufs[0].map(function(x) {
        return $b8f343bf88dacc48$require$Buffer.isBuffer(x) ? x : $b8f343bf88dacc48$var$Buffer_from(x);
    })) : $b8f343bf88dacc48$var$___toBuffer(bufs);
} : $b8f343bf88dacc48$var$___toBuffer;
var $b8f343bf88dacc48$var$___utf16le = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) /*:string*/ {
    var ss /*:Array<string>*/  = [];
    for(var i = s; i < e; i += 2)ss.push(String.fromCharCode($b8f343bf88dacc48$var$__readUInt16LE(b, i)));
    return ss.join("").replace($b8f343bf88dacc48$var$chr0, '');
};
var $b8f343bf88dacc48$var$__utf16le = $b8f343bf88dacc48$var$has_buf ? function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) /*:string*/ {
    if (!$b8f343bf88dacc48$require$Buffer.isBuffer(b) || !$b8f343bf88dacc48$var$buf_utf16le) return $b8f343bf88dacc48$var$___utf16le(b, s, e);
    return b.toString('utf16le', s, e).replace($b8f343bf88dacc48$var$chr0, '') /*.replace(chr1,'!')*/ ;
} : $b8f343bf88dacc48$var$___utf16le;
var $b8f343bf88dacc48$var$___hexlify = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , l /*:number*/ ) /*:string*/ {
    var ss /*:Array<string>*/  = [];
    for(var i = s; i < s + l; ++i)ss.push(("0" + b[i].toString(16)).slice(-2));
    return ss.join("");
};
var $b8f343bf88dacc48$var$__hexlify = $b8f343bf88dacc48$var$has_buf ? function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , l /*:number*/ ) /*:string*/ {
    return $b8f343bf88dacc48$require$Buffer.isBuffer(b) ? b.toString('hex', s, s + l) : $b8f343bf88dacc48$var$___hexlify(b, s, l);
} : $b8f343bf88dacc48$var$___hexlify;
var $b8f343bf88dacc48$var$___utf8 = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
    var ss = [];
    for(var i = s; i < e; i++)ss.push(String.fromCharCode($b8f343bf88dacc48$var$__readUInt8(b, i)));
    return ss.join("");
};
var $b8f343bf88dacc48$var$__utf8 = $b8f343bf88dacc48$var$has_buf ? function utf8_b(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
    return $b8f343bf88dacc48$require$Buffer.isBuffer(b) ? b.toString('utf8', s, e) : $b8f343bf88dacc48$var$___utf8(b, s, e);
} : $b8f343bf88dacc48$var$___utf8;
var $b8f343bf88dacc48$var$___lpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $b8f343bf88dacc48$var$__readUInt32LE(b, i);
    return len > 0 ? $b8f343bf88dacc48$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $b8f343bf88dacc48$var$__lpstr = $b8f343bf88dacc48$var$___lpstr;
var $b8f343bf88dacc48$var$___cpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $b8f343bf88dacc48$var$__readUInt32LE(b, i);
    return len > 0 ? $b8f343bf88dacc48$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $b8f343bf88dacc48$var$__cpstr = $b8f343bf88dacc48$var$___cpstr;
var $b8f343bf88dacc48$var$___lpwstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = 2 * $b8f343bf88dacc48$var$__readUInt32LE(b, i);
    return len > 0 ? $b8f343bf88dacc48$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $b8f343bf88dacc48$var$__lpwstr = $b8f343bf88dacc48$var$___lpwstr;
var $b8f343bf88dacc48$var$___lpp4 = function lpp4_(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $b8f343bf88dacc48$var$__readUInt32LE(b, i);
    return len > 0 ? $b8f343bf88dacc48$var$__utf16le(b, i + 4, i + 4 + len) : "";
};
var $b8f343bf88dacc48$var$__lpp4 = $b8f343bf88dacc48$var$___lpp4;
var $b8f343bf88dacc48$var$___8lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $b8f343bf88dacc48$var$__readUInt32LE(b, i);
    return len > 0 ? $b8f343bf88dacc48$var$__utf8(b, i + 4, i + 4 + len) : "";
};
var $b8f343bf88dacc48$var$__8lpp4 = $b8f343bf88dacc48$var$___8lpp4;
var $b8f343bf88dacc48$var$___double = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) {
    return $b8f343bf88dacc48$var$read_double_le(b, idx);
};
var $b8f343bf88dacc48$var$__double = $b8f343bf88dacc48$var$___double;
var $b8f343bf88dacc48$var$is_buf = function is_buf_a(a) {
    return Array.isArray(a) || typeof Uint8Array !== "undefined" && a instanceof Uint8Array;
};
if ($b8f343bf88dacc48$var$has_buf /*:: && typeof Buffer !== 'undefined'*/ ) {
    $b8f343bf88dacc48$var$__lpstr = function lpstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$b8f343bf88dacc48$require$Buffer.isBuffer(b)) return $b8f343bf88dacc48$var$___lpstr(b, i);
        var len = b.readUInt32LE(i);
        return len > 0 ? b.toString('utf8', i + 4, i + 4 + len - 1) : "";
    };
    $b8f343bf88dacc48$var$__cpstr = function cpstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$b8f343bf88dacc48$require$Buffer.isBuffer(b)) return $b8f343bf88dacc48$var$___cpstr(b, i);
        var len = b.readUInt32LE(i);
        return len > 0 ? b.toString('utf8', i + 4, i + 4 + len - 1) : "";
    };
    $b8f343bf88dacc48$var$__lpwstr = function lpwstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$b8f343bf88dacc48$require$Buffer.isBuffer(b) || !$b8f343bf88dacc48$var$buf_utf16le) return $b8f343bf88dacc48$var$___lpwstr(b, i);
        var len = 2 * b.readUInt32LE(i);
        return b.toString('utf16le', i + 4, i + 4 + len - 1);
    };
    $b8f343bf88dacc48$var$__lpp4 = function lpp4_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$b8f343bf88dacc48$require$Buffer.isBuffer(b) || !$b8f343bf88dacc48$var$buf_utf16le) return $b8f343bf88dacc48$var$___lpp4(b, i);
        var len = b.readUInt32LE(i);
        return b.toString('utf16le', i + 4, i + 4 + len);
    };
    $b8f343bf88dacc48$var$__8lpp4 = function lpp4_8b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$b8f343bf88dacc48$require$Buffer.isBuffer(b)) return $b8f343bf88dacc48$var$___8lpp4(b, i);
        var len = b.readUInt32LE(i);
        return b.toString('utf8', i + 4, i + 4 + len);
    };
    $b8f343bf88dacc48$var$__double = function double_(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if ($b8f343bf88dacc48$require$Buffer.isBuffer(b)) return b.readDoubleLE(i);
        return $b8f343bf88dacc48$var$___double(b, i);
    };
    $b8f343bf88dacc48$var$is_buf = function is_buf_b(a) {
        return $b8f343bf88dacc48$require$Buffer.isBuffer(a) || Array.isArray(a) || typeof Uint8Array !== "undefined" && a instanceof Uint8Array;
    };
}
/* from js-xls */ function $b8f343bf88dacc48$var$cpdoit() {
    $b8f343bf88dacc48$var$__utf16le = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
        return $b8f343bf88dacc48$var$$cptable.utils.decode(1200, b.slice(s, e)).replace($b8f343bf88dacc48$var$chr0, '');
    };
    $b8f343bf88dacc48$var$__utf8 = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
        return $b8f343bf88dacc48$var$$cptable.utils.decode(65001, b.slice(s, e));
    };
    $b8f343bf88dacc48$var$__lpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $b8f343bf88dacc48$var$__readUInt32LE(b, i);
        return len > 0 ? $b8f343bf88dacc48$var$$cptable.utils.decode($b8f343bf88dacc48$var$current_ansi, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $b8f343bf88dacc48$var$__cpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $b8f343bf88dacc48$var$__readUInt32LE(b, i);
        return len > 0 ? $b8f343bf88dacc48$var$$cptable.utils.decode($b8f343bf88dacc48$var$current_codepage, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $b8f343bf88dacc48$var$__lpwstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = 2 * $b8f343bf88dacc48$var$__readUInt32LE(b, i);
        return len > 0 ? $b8f343bf88dacc48$var$$cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $b8f343bf88dacc48$var$__lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $b8f343bf88dacc48$var$__readUInt32LE(b, i);
        return len > 0 ? $b8f343bf88dacc48$var$$cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len)) : "";
    };
    $b8f343bf88dacc48$var$__8lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $b8f343bf88dacc48$var$__readUInt32LE(b, i);
        return len > 0 ? $b8f343bf88dacc48$var$$cptable.utils.decode(65001, b.slice(i + 4, i + 4 + len)) : "";
    };
}
if (typeof $b8f343bf88dacc48$var$$cptable !== 'undefined') $b8f343bf88dacc48$var$cpdoit();
var $b8f343bf88dacc48$var$__readUInt8 = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx];
};
var $b8f343bf88dacc48$var$__readUInt16LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 1] * 256 + b[idx];
};
var $b8f343bf88dacc48$var$__readInt16LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    var u = b[idx + 1] * 256 + b[idx];
    return u < 0x8000 ? u : (0xffff - u + 1) * -1;
};
var $b8f343bf88dacc48$var$__readUInt32LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 3] * 16777216 + (b[idx + 2] << 16) + (b[idx + 1] << 8) + b[idx];
};
var $b8f343bf88dacc48$var$__readInt32LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 3] << 24 | b[idx + 2] << 16 | b[idx + 1] << 8 | b[idx];
};
var $b8f343bf88dacc48$var$__readInt32BE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx] << 24 | b[idx + 1] << 16 | b[idx + 2] << 8 | b[idx + 3];
};
function $b8f343bf88dacc48$var$ReadShift(size /*:number*/ , t /*:?string*/ ) /*:number|string*/ {
    var o = "", oI /*:: :number = 0*/ , oR, oo = [], w, vv, i, loc;
    switch(t){
        case 'dbcs':
            loc = this.l;
            if ($b8f343bf88dacc48$var$has_buf && $b8f343bf88dacc48$require$Buffer.isBuffer(this) && $b8f343bf88dacc48$var$buf_utf16le) o = this.slice(this.l, this.l + 2 * size).toString("utf16le");
            else for(i = 0; i < size; ++i){
                o += String.fromCharCode($b8f343bf88dacc48$var$__readUInt16LE(this, loc));
                loc += 2;
            }
            size *= 2;
            break;
        case 'utf8':
            o = $b8f343bf88dacc48$var$__utf8(this, this.l, this.l + size);
            break;
        case 'utf16le':
            size *= 2;
            o = $b8f343bf88dacc48$var$__utf16le(this, this.l, this.l + size);
            break;
        case 'wstr':
            if (typeof $b8f343bf88dacc48$var$$cptable !== 'undefined') o = $b8f343bf88dacc48$var$$cptable.utils.decode($b8f343bf88dacc48$var$current_codepage, this.slice(this.l, this.l + 2 * size));
            else return $b8f343bf88dacc48$var$ReadShift.call(this, size, 'dbcs');
            size = 2 * size;
            break;
        /* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */ case 'lpstr-ansi':
            o = $b8f343bf88dacc48$var$__lpstr(this, this.l);
            size = 4 + $b8f343bf88dacc48$var$__readUInt32LE(this, this.l);
            break;
        case 'lpstr-cp':
            o = $b8f343bf88dacc48$var$__cpstr(this, this.l);
            size = 4 + $b8f343bf88dacc48$var$__readUInt32LE(this, this.l);
            break;
        /* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */ case 'lpwstr':
            o = $b8f343bf88dacc48$var$__lpwstr(this, this.l);
            size = 4 + 2 * $b8f343bf88dacc48$var$__readUInt32LE(this, this.l);
            break;
        /* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */ case 'lpp4':
            size = 4 + $b8f343bf88dacc48$var$__readUInt32LE(this, this.l);
            o = $b8f343bf88dacc48$var$__lpp4(this, this.l);
            if (size & 0x02) size += 2;
            break;
        /* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */ case '8lpp4':
            size = 4 + $b8f343bf88dacc48$var$__readUInt32LE(this, this.l);
            o = $b8f343bf88dacc48$var$__8lpp4(this, this.l);
            if (size & 0x03) size += 4 - (size & 0x03);
            break;
        case 'cstr':
            size = 0;
            o = "";
            while((w = $b8f343bf88dacc48$var$__readUInt8(this, this.l + size++)) !== 0)oo.push($b8f343bf88dacc48$var$_getchar(w));
            o = oo.join("");
            break;
        case '_wstr':
            size = 0;
            o = "";
            while((w = $b8f343bf88dacc48$var$__readUInt16LE(this, this.l + size)) !== 0){
                oo.push($b8f343bf88dacc48$var$_getchar(w));
                size += 2;
            }
            size += 2;
            o = oo.join("");
            break;
        /* sbcs and dbcs support continue records in the SST way TODO codepages */ case 'dbcs-cont':
            o = "";
            loc = this.l;
            for(i = 0; i < size; ++i){
                if (this.lens && this.lens.indexOf(loc) !== -1) {
                    w = $b8f343bf88dacc48$var$__readUInt8(this, loc);
                    this.l = loc + 1;
                    vv = $b8f343bf88dacc48$var$ReadShift.call(this, size - i, w ? 'dbcs-cont' : 'sbcs-cont');
                    return oo.join("") + vv;
                }
                oo.push($b8f343bf88dacc48$var$_getchar($b8f343bf88dacc48$var$__readUInt16LE(this, loc)));
                loc += 2;
            }
            o = oo.join("");
            size *= 2;
            break;
        case 'cpstr':
            if (typeof $b8f343bf88dacc48$var$$cptable !== 'undefined') {
                o = $b8f343bf88dacc48$var$$cptable.utils.decode($b8f343bf88dacc48$var$current_codepage, this.slice(this.l, this.l + size));
                break;
            }
        /* falls through */ case 'sbcs-cont':
            o = "";
            loc = this.l;
            for(i = 0; i != size; ++i){
                if (this.lens && this.lens.indexOf(loc) !== -1) {
                    w = $b8f343bf88dacc48$var$__readUInt8(this, loc);
                    this.l = loc + 1;
                    vv = $b8f343bf88dacc48$var$ReadShift.call(this, size - i, w ? 'dbcs-cont' : 'sbcs-cont');
                    return oo.join("") + vv;
                }
                oo.push($b8f343bf88dacc48$var$_getchar($b8f343bf88dacc48$var$__readUInt8(this, loc)));
                loc += 1;
            }
            o = oo.join("");
            break;
        default:
            switch(size){
                case 1:
                    oI = $b8f343bf88dacc48$var$__readUInt8(this, this.l);
                    this.l++;
                    return oI;
                case 2:
                    oI = (t === 'i' ? $b8f343bf88dacc48$var$__readInt16LE : $b8f343bf88dacc48$var$__readUInt16LE)(this, this.l);
                    this.l += 2;
                    return oI;
                case 4:
                case -4:
                    if (t === 'i' || (this[this.l + 3] & 0x80) === 0) {
                        oI = (size > 0 ? $b8f343bf88dacc48$var$__readInt32LE : $b8f343bf88dacc48$var$__readInt32BE)(this, this.l);
                        this.l += 4;
                        return oI;
                    } else {
                        oR = $b8f343bf88dacc48$var$__readUInt32LE(this, this.l);
                        this.l += 4;
                    }
                    return oR;
                case 8:
                case -8:
                    if (t === 'f') {
                        if (size == 8) oR = $b8f343bf88dacc48$var$__double(this, this.l);
                        else oR = $b8f343bf88dacc48$var$__double([
                            this[this.l + 7],
                            this[this.l + 6],
                            this[this.l + 5],
                            this[this.l + 4],
                            this[this.l + 3],
                            this[this.l + 2],
                            this[this.l + 1],
                            this[this.l + 0]
                        ], 0);
                        this.l += 8;
                        return oR;
                    } else size = 8;
                /* falls through */ case 16:
                    o = $b8f343bf88dacc48$var$__hexlify(this, this.l, size);
                    break;
            }
    }
    this.l += size;
    return o;
}
var $b8f343bf88dacc48$var$__writeUInt32LE = function(b /*:RawBytes|CFBlob*/ , val /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val & 0xFF;
    b[idx + 1] = val >>> 8 & 0xFF;
    b[idx + 2] = val >>> 16 & 0xFF;
    b[idx + 3] = val >>> 24 & 0xFF;
};
var $b8f343bf88dacc48$var$__writeInt32LE = function(b /*:RawBytes|CFBlob*/ , val /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val & 0xFF;
    b[idx + 1] = val >> 8 & 0xFF;
    b[idx + 2] = val >> 16 & 0xFF;
    b[idx + 3] = val >> 24 & 0xFF;
};
var $b8f343bf88dacc48$var$__writeUInt16LE = function(b /*:RawBytes|CFBlob*/ , val /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val & 0xFF;
    b[idx + 1] = val >>> 8 & 0xFF;
};
function $b8f343bf88dacc48$var$WriteShift(t /*:number*/ , val /*:string|number*/ , f /*:?string*/ ) /*:any*/ {
    var size = 0, i = 0;
    if (f === 'dbcs') {
        /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ for(i = 0; i != val.length; ++i)$b8f343bf88dacc48$var$__writeUInt16LE(this, val.charCodeAt(i), this.l + 2 * i);
        size = 2 * val.length;
    } else if (f === 'sbcs' || f == 'cpstr') {
        if (typeof $b8f343bf88dacc48$var$$cptable !== 'undefined' && $b8f343bf88dacc48$var$current_ansi == 874) {
            /* TODO: use tables directly, don't encode */ /*:: if(typeof val !== "string") throw new Error("unreachable"); */ for(i = 0; i != val.length; ++i){
                var cpp = $b8f343bf88dacc48$var$$cptable.utils.encode($b8f343bf88dacc48$var$current_ansi, val.charAt(i));
                this[this.l + i] = cpp[0];
            }
            size = val.length;
        } else if (typeof $b8f343bf88dacc48$var$$cptable !== 'undefined' && f == 'cpstr') {
            cpp = $b8f343bf88dacc48$var$$cptable.utils.encode($b8f343bf88dacc48$var$current_codepage, val);
            /* replace null bytes with _ when relevant */ if (cpp.length == val.length) {
                for(i = 0; i < val.length; ++i)if (cpp[i] == 0 && val.charCodeAt(i) != 0) cpp[i] = 0x5F;
            }
            if (cpp.length == 2 * val.length) {
                for(i = 0; i < val.length; ++i)if (cpp[2 * i] == 0 && cpp[2 * i + 1] == 0 && val.charCodeAt(i) != 0) cpp[2 * i] = 0x5F;
            }
            for(i = 0; i < cpp.length; ++i)this[this.l + i] = cpp[i];
            size = cpp.length;
        } else {
            /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ val = val.replace(/[^\x00-\x7F]/g, "_");
            /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ for(i = 0; i != val.length; ++i)this[this.l + i] = val.charCodeAt(i) & 0xFF;
            size = val.length;
        }
    } else if (f === 'hex') {
        for(; i < t; ++i)/*:: if(typeof val !== "string") throw new Error("unreachable"); */ this[this.l++] = parseInt(val.slice(2 * i, 2 * i + 2), 16) || 0;
        return this;
    } else if (f === 'utf16le') {
        /*:: if(typeof val !== "string") throw new Error("unreachable"); */ var end /*:number*/  = Math.min(this.l + t, this.length);
        for(i = 0; i < Math.min(val.length, t); ++i){
            var cc = val.charCodeAt(i);
            this[this.l++] = cc & 0xff;
            this[this.l++] = cc >> 8;
        }
        while(this.l < end)this[this.l++] = 0;
        return this;
    } else /*:: if(typeof val === 'number') */ switch(t){
        case 1:
            size = 1;
            this[this.l] = val & 0xFF;
            break;
        case 2:
            size = 2;
            this[this.l] = val & 0xFF;
            val >>>= 8;
            this[this.l + 1] = val & 0xFF;
            break;
        case 3:
            size = 3;
            this[this.l] = val & 0xFF;
            val >>>= 8;
            this[this.l + 1] = val & 0xFF;
            val >>>= 8;
            this[this.l + 2] = val & 0xFF;
            break;
        case 4:
            size = 4;
            $b8f343bf88dacc48$var$__writeUInt32LE(this, val, this.l);
            break;
        case 8:
            size = 8;
            if (f === 'f') {
                $b8f343bf88dacc48$var$write_double_le(this, val, this.l);
                break;
            }
        /* falls through */ case 16:
            break;
        case -4:
            size = 4;
            $b8f343bf88dacc48$var$__writeInt32LE(this, val, this.l);
            break;
    }
    this.l += size;
    return this;
}
function $b8f343bf88dacc48$var$CheckField(hexstr /*:string*/ , fld /*:string*/ ) /*:void*/ {
    var m = $b8f343bf88dacc48$var$__hexlify(this, this.l, hexstr.length >> 1);
    if (m !== hexstr) throw new Error(fld + 'Expected ' + hexstr + ' saw ' + m);
    this.l += hexstr.length >> 1;
}
function $b8f343bf88dacc48$var$prep_blob(blob, pos /*:number*/ ) /*:void*/ {
    blob.l = pos;
    blob.read_shift = /*::(*/ $b8f343bf88dacc48$var$ReadShift /*:: :any)*/ ;
    blob.chk = $b8f343bf88dacc48$var$CheckField;
    blob.write_shift = $b8f343bf88dacc48$var$WriteShift;
}
function $b8f343bf88dacc48$var$parsenoop(blob, length /*:: :number, opts?:any */ ) {
    blob.l += length;
}
function $b8f343bf88dacc48$var$new_buf(sz /*:number*/ ) /*:Block*/ {
    var o = $b8f343bf88dacc48$var$new_raw_buf(sz);
    $b8f343bf88dacc48$var$prep_blob(o, 0);
    return o;
}
/* [MS-XLSB] 2.1.4 Record */ function $b8f343bf88dacc48$var$recordhopper(data, cb /*:RecordHopperCB*/ , opts /*:?any*/ ) {
    if (!data) return;
    var tmpbyte, cntbyte, length;
    $b8f343bf88dacc48$var$prep_blob(data, data.l || 0);
    var L = data.length, RT = 0, tgt = 0;
    while(data.l < L){
        RT = data.read_shift(1);
        if (RT & 0x80) RT = (RT & 0x7F) + ((data.read_shift(1) & 0x7F) << 7);
        var R = $b8f343bf88dacc48$var$XLSBRecordEnum[RT] || $b8f343bf88dacc48$var$XLSBRecordEnum[0xFFFF];
        tmpbyte = data.read_shift(1);
        length = tmpbyte & 0x7F;
        for(cntbyte = 1; cntbyte < 4 && tmpbyte & 0x80; ++cntbyte)length += ((tmpbyte = data.read_shift(1)) & 0x7F) << 7 * cntbyte;
        tgt = data.l + length;
        var d = R.f && R.f(data, length, opts);
        data.l = tgt;
        if (cb(d, R, RT)) return;
    }
}
/* control buffer usage for fixed-length buffers */ function $b8f343bf88dacc48$var$buf_array() /*:BufArray*/ {
    var bufs /*:Array<Block>*/  = [], blksz = $b8f343bf88dacc48$var$has_buf ? 256 : 2048;
    var newblk = function ba_newblk(sz /*:number*/ ) /*:Block*/ {
        var o /*:Block*/  = $b8f343bf88dacc48$var$new_buf(sz);
        $b8f343bf88dacc48$var$prep_blob(o, 0);
        return o;
    };
    var curbuf /*:Block*/  = newblk(blksz);
    var endbuf = function ba_endbuf() {
        if (!curbuf) return;
        // workaround for new Buffer(3).slice(0,0) bug in bun 0.1.3
        if (curbuf.l) {
            if (curbuf.length > curbuf.l) {
                curbuf = curbuf.slice(0, curbuf.l);
                curbuf.l = curbuf.length;
            }
            if (curbuf.length > 0) bufs.push(curbuf);
        }
        curbuf = null;
    };
    var next = function ba_next(sz /*:number*/ ) /*:Block*/ {
        if (curbuf && sz < curbuf.length - curbuf.l) return curbuf;
        endbuf();
        return curbuf = newblk(Math.max(sz + 1, blksz));
    };
    var end = function ba_end() {
        endbuf();
        return $b8f343bf88dacc48$var$bconcat(bufs);
    };
    var push = function ba_push(buf) {
        endbuf();
        curbuf = buf;
        if (curbuf.l == null) curbuf.l = curbuf.length;
        next(blksz);
    };
    return {
        next: next,
        push: push,
        end: end,
        _bufs: bufs
    } /*:any*/ ;
}
function $b8f343bf88dacc48$var$write_record(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) {
    var t /*:number*/  = +type, l;
    if (isNaN(t)) return; // TODO: throw something here?
    if (!length) length = $b8f343bf88dacc48$var$XLSBRecordEnum[t].p || (payload || []).length || 0;
    l = 1 + (t >= 0x80 ? 1 : 0) + 1 /* + length*/ ;
    if (length >= 0x80) ++l;
    if (length >= 0x4000) ++l;
    if (length >= 0x200000) ++l;
    var o = ba.next(l);
    if (t <= 0x7F) o.write_shift(1, t);
    else {
        o.write_shift(1, (t & 0x7F) + 0x80);
        o.write_shift(1, t >> 7);
    }
    for(var i = 0; i != 4; ++i)if (length >= 0x80) {
        o.write_shift(1, (length & 0x7F) + 0x80);
        length >>= 7;
    } else {
        o.write_shift(1, length);
        break;
    }
    if (/*:: length != null &&*/ length > 0 && $b8f343bf88dacc48$var$is_buf(payload)) ba.push(payload);
}
/* XLS ranges enforced */ function $b8f343bf88dacc48$var$shift_cell_xls(cell /*:CellAddress*/ , tgt /*:any*/ , opts /*:?any*/ ) /*:CellAddress*/ {
    var out = $b8f343bf88dacc48$var$dup(cell);
    if (tgt.s) {
        if (out.cRel) out.c += tgt.s.c;
        if (out.rRel) out.r += tgt.s.r;
    } else {
        if (out.cRel) out.c += tgt.c;
        if (out.rRel) out.r += tgt.r;
    }
    if (!opts || opts.biff < 12) {
        while(out.c >= 0x100)out.c -= 0x100;
        while(out.r >= 0x10000)out.r -= 0x10000;
    }
    return out;
}
function $b8f343bf88dacc48$var$shift_range_xls(cell, range, opts) {
    var out = $b8f343bf88dacc48$var$dup(cell);
    out.s = $b8f343bf88dacc48$var$shift_cell_xls(out.s, range.s, opts);
    out.e = $b8f343bf88dacc48$var$shift_cell_xls(out.e, range.s, opts);
    return out;
}
function $b8f343bf88dacc48$var$encode_cell_xls(c /*:CellAddress*/ , biff /*:number*/ ) /*:string*/ {
    if (c.cRel && c.c < 0) {
        c = $b8f343bf88dacc48$var$dup(c);
        while(c.c < 0)c.c += biff > 8 ? 0x4000 : 0x100;
    }
    if (c.rRel && c.r < 0) {
        c = $b8f343bf88dacc48$var$dup(c);
        while(c.r < 0)c.r += biff > 8 ? 0x100000 : biff > 5 ? 0x10000 : 0x4000;
    }
    var s = $b8f343bf88dacc48$var$encode_cell(c);
    if (!c.cRel && c.cRel != null) s = $b8f343bf88dacc48$var$fix_col(s);
    if (!c.rRel && c.rRel != null) s = $b8f343bf88dacc48$var$fix_row(s);
    return s;
}
function $b8f343bf88dacc48$var$encode_range_xls(r, opts) /*:string*/ {
    if (r.s.r == 0 && !r.s.rRel) {
        if (r.e.r == (opts.biff >= 12 ? 0xFFFFF : opts.biff >= 8 ? 0x10000 : 0x4000) && !r.e.rRel) return (r.s.cRel ? "" : "$") + $b8f343bf88dacc48$var$encode_col(r.s.c) + ":" + (r.e.cRel ? "" : "$") + $b8f343bf88dacc48$var$encode_col(r.e.c);
    }
    if (r.s.c == 0 && !r.s.cRel) {
        if (r.e.c == (opts.biff >= 12 ? 0x3FFF : 0xFF) && !r.e.cRel) return (r.s.rRel ? "" : "$") + $b8f343bf88dacc48$var$encode_row(r.s.r) + ":" + (r.e.rRel ? "" : "$") + $b8f343bf88dacc48$var$encode_row(r.e.r);
    }
    return $b8f343bf88dacc48$var$encode_cell_xls(r.s, opts.biff) + ":" + $b8f343bf88dacc48$var$encode_cell_xls(r.e, opts.biff);
}
function $b8f343bf88dacc48$var$decode_row(rowstr /*:string*/ ) /*:number*/ {
    return parseInt($b8f343bf88dacc48$var$unfix_row(rowstr), 10) - 1;
}
function $b8f343bf88dacc48$var$encode_row(row /*:number*/ ) /*:string*/ {
    return "" + (row + 1);
}
function $b8f343bf88dacc48$var$fix_row(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/([A-Z]|^)(\d+)$/, "$1$$$2");
}
function $b8f343bf88dacc48$var$unfix_row(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/\$(\d+)$/, "$1");
}
function $b8f343bf88dacc48$var$decode_col(colstr /*:string*/ ) /*:number*/ {
    var c = $b8f343bf88dacc48$var$unfix_col(colstr), d = 0, i = 0;
    for(; i !== c.length; ++i)d = 26 * d + c.charCodeAt(i) - 64;
    return d - 1;
}
function $b8f343bf88dacc48$var$encode_col(col /*:number*/ ) /*:string*/ {
    if (col < 0) throw new Error("invalid column " + col);
    var s = "";
    for(++col; col; col = Math.floor((col - 1) / 26))s = String.fromCharCode((col - 1) % 26 + 65) + s;
    return s;
}
function $b8f343bf88dacc48$var$fix_col(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/^([A-Z])/, "$$$1");
}
function $b8f343bf88dacc48$var$unfix_col(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/^\$([A-Z])/, "$1");
}
function $b8f343bf88dacc48$var$split_cell(cstr /*:string*/ ) /*:Array<string>*/ {
    return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/, "$1,$2").split(",");
}
function $b8f343bf88dacc48$var$decode_cell(cstr /*:string*/ ) /*:CellAddress*/ {
    var R = 0, C = 0;
    for(var i = 0; i < cstr.length; ++i){
        var cc = cstr.charCodeAt(i);
        if (cc >= 48 && cc <= 57) R = 10 * R + (cc - 48);
        else if (cc >= 65 && cc <= 90) C = 26 * C + (cc - 64);
    }
    return {
        c: C - 1,
        r: R - 1
    };
}
function $b8f343bf88dacc48$var$encode_cell(cell /*:CellAddress*/ ) /*:string*/ {
    var col = cell.c + 1;
    var s = "";
    for(; col; col = (col - 1) / 26 | 0)s = String.fromCharCode((col - 1) % 26 + 65) + s;
    return s + (cell.r + 1);
}
function $b8f343bf88dacc48$var$decode_range(range /*:string*/ ) /*:Range*/ {
    var idx = range.indexOf(":");
    if (idx == -1) return {
        s: $b8f343bf88dacc48$var$decode_cell(range),
        e: $b8f343bf88dacc48$var$decode_cell(range)
    };
    return {
        s: $b8f343bf88dacc48$var$decode_cell(range.slice(0, idx)),
        e: $b8f343bf88dacc48$var$decode_cell(range.slice(idx + 1))
    };
}
/*# if only one arg, it is assumed to be a Range.  If 2 args, both are cell addresses */ function $b8f343bf88dacc48$var$encode_range(cs /*:CellAddrSpec|Range*/ , ce /*:?CellAddrSpec*/ ) /*:string*/ {
    if (typeof ce === 'undefined' || typeof ce === 'number') /*:: if(!(cs instanceof Range)) throw "unreachable"; */ return $b8f343bf88dacc48$var$encode_range(cs.s, cs.e);
    /*:: if((cs instanceof Range)) throw "unreachable"; */ if (typeof cs !== 'string') cs = $b8f343bf88dacc48$var$encode_cell(cs /*:any*/ );
    if (typeof ce !== 'string') ce = $b8f343bf88dacc48$var$encode_cell(ce /*:any*/ );
    /*:: if(typeof cs !== 'string') throw "unreachable"; */ /*:: if(typeof ce !== 'string') throw "unreachable"; */ return cs == ce ? cs : cs + ":" + ce;
}
function $b8f343bf88dacc48$var$fix_range(a1 /*:string*/ ) /*:string*/ {
    var s = $b8f343bf88dacc48$var$decode_range(a1);
    return "$" + $b8f343bf88dacc48$var$encode_col(s.s.c) + "$" + $b8f343bf88dacc48$var$encode_row(s.s.r) + ":$" + $b8f343bf88dacc48$var$encode_col(s.e.c) + "$" + $b8f343bf88dacc48$var$encode_row(s.e.r);
}
// List of invalid characters needs to be tested further
function $b8f343bf88dacc48$var$formula_quote_sheet_name(sname /*:string*/ , opts) /*:string*/ {
    if (!sname && !(opts && opts.biff <= 5 && opts.biff >= 2)) throw new Error("empty sheet name");
    if (/[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(sname)) return "'" + sname.replace(/'/g, "''") + "'";
    return sname;
}
function $b8f343bf88dacc48$var$safe_decode_range(range /*:string*/ ) /*:Range*/ {
    var o = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: 0
        }
    };
    var idx = 0, i = 0, cc = 0;
    var len = range.length;
    for(idx = 0; i < len; ++i){
        if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
        idx = 26 * idx + cc;
    }
    o.s.c = --idx;
    for(idx = 0; i < len; ++i){
        if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
        idx = 10 * idx + cc;
    }
    o.s.r = --idx;
    if (i === len || cc != 10) {
        o.e.c = o.s.c;
        o.e.r = o.s.r;
        return o;
    }
    ++i;
    for(idx = 0; i != len; ++i){
        if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
        idx = 26 * idx + cc;
    }
    o.e.c = --idx;
    for(idx = 0; i != len; ++i){
        if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
        idx = 10 * idx + cc;
    }
    o.e.r = --idx;
    return o;
}
function $b8f343bf88dacc48$var$safe_format_cell(cell /*:Cell*/ , v /*:any*/ ) {
    var q = cell.t == 'd' && v instanceof Date;
    if (cell.z != null) try {
        return cell.w = $b8f343bf88dacc48$var$SSF_format(cell.z, q ? $b8f343bf88dacc48$var$datenum(v) : v);
    } catch (e) {}
    try {
        return cell.w = $b8f343bf88dacc48$var$SSF_format((cell.XF || {}).numFmtId || (q ? 14 : 0), q ? $b8f343bf88dacc48$var$datenum(v) : v);
    } catch (e) {
        return '' + v;
    }
}
function $b8f343bf88dacc48$var$format_cell(cell /*:Cell*/ , v /*:any*/ , o /*:any*/ ) {
    if (cell == null || cell.t == null || cell.t == 'z') return "";
    if (cell.w !== undefined) return cell.w;
    if (cell.t == 'd' && !cell.z && o && o.dateNF) cell.z = o.dateNF;
    if (cell.t == "e") return $b8f343bf88dacc48$var$BErr[cell.v] || cell.v;
    if (v == undefined) return $b8f343bf88dacc48$var$safe_format_cell(cell, cell.v);
    return $b8f343bf88dacc48$var$safe_format_cell(cell, v);
}
function $b8f343bf88dacc48$var$sheet_to_workbook(sheet /*:Worksheet*/ , opts) /*:Workbook*/ {
    var n = opts && opts.sheet ? opts.sheet : "Sheet1";
    var sheets = {};
    sheets[n] = sheet;
    return {
        SheetNames: [
            n
        ],
        Sheets: sheets
    };
}
function $b8f343bf88dacc48$var$sheet_new(opts) {
    var out = {};
    var o = opts || {};
    if (o.dense) out["!data"] = [];
    return out;
}
function $b8f343bf88dacc48$var$sheet_add_aoa(_ws /*:?Worksheet*/ , data /*:AOA*/ , opts /*:?any*/ ) /*:Worksheet*/ {
    var o = opts || {};
    var dense = _ws ? _ws["!data"] != null : o.dense;
    if ($b8f343bf88dacc48$var$DENSE != null && dense == null) dense = $b8f343bf88dacc48$var$DENSE;
    var ws /*:Worksheet*/  = _ws || {} /*:any*/ ;
    if (dense && !ws["!data"]) ws["!data"] = [];
    var _R = 0, _C = 0;
    if (ws && o.origin != null) {
        if (typeof o.origin == 'number') _R = o.origin;
        else {
            var _origin /*:CellAddress*/  = typeof o.origin == "string" ? $b8f343bf88dacc48$var$decode_cell(o.origin) : o.origin;
            _R = _origin.r;
            _C = _origin.c;
        }
    }
    var range /*:Range*/  = {
        s: {
            c: 10000000,
            r: 10000000
        },
        e: {
            c: 0,
            r: 0
        }
    } /*:any*/ ;
    if (ws["!ref"]) {
        var _range = $b8f343bf88dacc48$var$safe_decode_range(ws['!ref']);
        range.s.c = _range.s.c;
        range.s.r = _range.s.r;
        range.e.c = Math.max(range.e.c, _range.e.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        if (_R == -1) range.e.r = _R = ws["!ref"] ? _range.e.r + 1 : 0;
    } else range.s.c = range.e.c = range.s.r = range.e.r = 0;
    var row = [], seen = false;
    for(var R = 0; R != data.length; ++R){
        if (!data[R]) continue;
        if (!Array.isArray(data[R])) throw new Error("aoa_to_sheet expects an array of arrays");
        var __R = _R + R, __Rstr = "" + (__R + 1);
        //console.log("!!", R, _R, __R);
        if (dense) {
            if (!ws["!data"][__R]) ws["!data"][__R] = [];
            row = ws["!data"][__R];
        }
        for(var C = 0; C != data[R].length; ++C){
            if (typeof data[R][C] === 'undefined') continue;
            var cell /*:Cell*/  = {
                v: data[R][C]
            } /*:any*/ ;
            var __C = _C + C;
            if (range.s.r > __R) range.s.r = __R;
            if (range.s.c > __C) range.s.c = __C;
            if (range.e.r < __R) range.e.r = __R;
            if (range.e.c < __C) range.e.c = __C;
            seen = true;
            if (data[R][C] && typeof data[R][C] === 'object' && !Array.isArray(data[R][C]) && !(data[R][C] instanceof Date)) cell = data[R][C];
            else {
                if (Array.isArray(cell.v)) {
                    cell.f = data[R][C][1];
                    cell.v = cell.v[0];
                }
                if (cell.v === null) {
                    if (cell.f) cell.t = 'n';
                    else if (o.nullError) {
                        cell.t = 'e';
                        cell.v = 0;
                    } else if (!o.sheetStubs) continue;
                    else cell.t = 'z';
                } else if (typeof cell.v === 'number') cell.t = 'n';
                else if (typeof cell.v === 'boolean') cell.t = 'b';
                else if (cell.v instanceof Date) {
                    cell.z = o.dateNF || $b8f343bf88dacc48$var$table_fmt[14];
                    if (!o.UTC) cell.v = $b8f343bf88dacc48$var$local_to_utc(cell.v);
                    if (o.cellDates) {
                        cell.t = 'd';
                        cell.w = $b8f343bf88dacc48$var$SSF_format(cell.z, $b8f343bf88dacc48$var$datenum(cell.v, o.date1904));
                    } else {
                        cell.t = 'n';
                        cell.v = $b8f343bf88dacc48$var$datenum(cell.v, o.date1904);
                        cell.w = $b8f343bf88dacc48$var$SSF_format(cell.z, cell.v);
                    }
                } else cell.t = 's';
            }
            if (dense) {
                if (row[__C] && row[__C].z) cell.z = row[__C].z;
                row[__C] = cell;
            } else {
                var cell_ref = $b8f343bf88dacc48$var$encode_col(__C) + __Rstr /*:any*/ ;
                if (ws[cell_ref] && ws[cell_ref].z) cell.z = ws[cell_ref].z;
                ws[cell_ref] = cell;
            }
        }
    }
    if (seen && range.s.c < 10400000) ws['!ref'] = $b8f343bf88dacc48$var$encode_range(range);
    return ws;
}
function $b8f343bf88dacc48$var$aoa_to_sheet(data /*:AOA*/ , opts /*:?any*/ ) /*:Worksheet*/ {
    return $b8f343bf88dacc48$var$sheet_add_aoa(null, data, opts);
}
function $b8f343bf88dacc48$var$parse_Int32LE(data) {
    return data.read_shift(4, 'i');
}
function $b8f343bf88dacc48$var$write_UInt32LE(x /*:number*/ , o) {
    if (!o) o = $b8f343bf88dacc48$var$new_buf(4);
    o.write_shift(4, x);
    return o;
}
/* [MS-XLSB] 2.5.168 */ function $b8f343bf88dacc48$var$parse_XLWideString(data /*::, length*/ ) /*:string*/ {
    var cchCharacters = data.read_shift(4);
    return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, 'dbcs');
}
function $b8f343bf88dacc48$var$write_XLWideString(data /*:string*/ , o) {
    var _null = false;
    if (o == null) {
        _null = true;
        o = $b8f343bf88dacc48$var$new_buf(4 + 2 * data.length);
    }
    o.write_shift(4, data.length);
    if (data.length > 0) o.write_shift(0, data, 'dbcs');
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.91 */ //function parse_LPWideString(data/*::, length*/)/*:string*/ {
//	var cchCharacters = data.read_shift(2);
//	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "utf16le");
//}
/* [MS-XLSB] 2.5.143 */ function $b8f343bf88dacc48$var$parse_StrRun(data) {
    return {
        ich: data.read_shift(2),
        ifnt: data.read_shift(2)
    };
}
function $b8f343bf88dacc48$var$write_StrRun(run, o) {
    if (!o) o = $b8f343bf88dacc48$var$new_buf(4);
    o.write_shift(2, run.ich || 0);
    o.write_shift(2, run.ifnt || 0);
    return o;
}
/* [MS-XLSB] 2.5.121 */ function $b8f343bf88dacc48$var$parse_RichStr(data, length /*:number*/ ) /*:XLString*/ {
    var start = data.l;
    var flags = data.read_shift(1);
    var str = $b8f343bf88dacc48$var$parse_XLWideString(data);
    var rgsStrRun = [];
    var z = {
        t: str,
        h: str
    } /*:any*/ ;
    if ((flags & 1) !== 0) {
        /* TODO: formatted string */ var dwSizeStrRun = data.read_shift(4);
        for(var i = 0; i != dwSizeStrRun; ++i)rgsStrRun.push($b8f343bf88dacc48$var$parse_StrRun(data));
        z.r = rgsStrRun;
    } else z.r = [
        {
            ich: 0,
            ifnt: 0
        }
    ];
    //if((flags & 2) !== 0) { /* fExtStr */
    //	/* TODO: phonetic string */
    //}
    data.l = start + length;
    return z;
}
function $b8f343bf88dacc48$var$write_RichStr(str /*:XLString*/ , o /*:?Block*/ ) /*:Block*/ {
    /* TODO: formatted string */ var _null = false;
    if (o == null) {
        _null = true;
        o = $b8f343bf88dacc48$var$new_buf(15 + 4 * str.t.length);
    }
    o.write_shift(1, 0);
    $b8f343bf88dacc48$var$write_XLWideString(str.t, o);
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */ var $b8f343bf88dacc48$var$parse_BrtCommentText = $b8f343bf88dacc48$var$parse_RichStr;
function $b8f343bf88dacc48$var$write_BrtCommentText(str /*:XLString*/ , o /*:?Block*/ ) /*:Block*/ {
    /* TODO: formatted string */ var _null = false;
    if (o == null) {
        _null = true;
        o = $b8f343bf88dacc48$var$new_buf(23 + 4 * str.t.length);
    }
    o.write_shift(1, 1);
    $b8f343bf88dacc48$var$write_XLWideString(str.t, o);
    o.write_shift(4, 1);
    $b8f343bf88dacc48$var$write_StrRun({
        ich: 0,
        ifnt: 0
    }, o);
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.9 */ function $b8f343bf88dacc48$var$parse_XLSBCell(data) /*:any*/ {
    var col = data.read_shift(4);
    var iStyleRef = data.read_shift(2);
    iStyleRef += data.read_shift(1) << 16;
    data.l++; //var fPhShow = data.read_shift(1);
    return {
        c: col,
        iStyleRef: iStyleRef
    };
}
function $b8f343bf88dacc48$var$write_XLSBCell(cell /*:any*/ , o /*:?Block*/ ) {
    if (o == null) o = $b8f343bf88dacc48$var$new_buf(8);
    o.write_shift(-4, cell.c);
    o.write_shift(3, cell.iStyleRef || cell.s);
    o.write_shift(1, 0); /* fPhShow */ 
    return o;
}
/* Short XLSB Cell does not include column */ function $b8f343bf88dacc48$var$parse_XLSBShortCell(data) /*:any*/ {
    var iStyleRef = data.read_shift(2);
    iStyleRef += data.read_shift(1) << 16;
    data.l++; //var fPhShow = data.read_shift(1);
    return {
        c: -1,
        iStyleRef: iStyleRef
    };
}
function $b8f343bf88dacc48$var$write_XLSBShortCell(cell /*:any*/ , o /*:?Block*/ ) {
    if (o == null) o = $b8f343bf88dacc48$var$new_buf(4);
    o.write_shift(3, cell.iStyleRef || cell.s);
    o.write_shift(1, 0); /* fPhShow */ 
    return o;
}
/* [MS-XLSB] 2.5.21 */ var $b8f343bf88dacc48$var$parse_XLSBCodeName = $b8f343bf88dacc48$var$parse_XLWideString;
var $b8f343bf88dacc48$var$write_XLSBCodeName = $b8f343bf88dacc48$var$write_XLWideString;
/* [MS-XLSB] 2.5.166 */ function $b8f343bf88dacc48$var$parse_XLNullableWideString(data /*::, length*/ ) /*:string*/ {
    var cchCharacters = data.read_shift(4);
    return cchCharacters === 0 || cchCharacters === 0xFFFFFFFF ? "" : data.read_shift(cchCharacters, 'dbcs');
}
function $b8f343bf88dacc48$var$write_XLNullableWideString(data /*:string*/ , o) {
    var _null = false;
    if (o == null) {
        _null = true;
        o = $b8f343bf88dacc48$var$new_buf(127);
    }
    o.write_shift(4, data.length > 0 ? data.length : 0xFFFFFFFF);
    if (data.length > 0) o.write_shift(0, data, 'dbcs');
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.165 */ var $b8f343bf88dacc48$var$parse_XLNameWideString = $b8f343bf88dacc48$var$parse_XLWideString;
//var write_XLNameWideString = write_XLWideString;
/* [MS-XLSB] 2.5.114 */ var $b8f343bf88dacc48$var$parse_RelID = $b8f343bf88dacc48$var$parse_XLNullableWideString;
var $b8f343bf88dacc48$var$write_RelID = $b8f343bf88dacc48$var$write_XLNullableWideString;
/* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */ function $b8f343bf88dacc48$var$parse_RkNumber(data) /*:number*/ {
    var b = data.slice(data.l, data.l + 4);
    var fX100 = b[0] & 1, fInt = b[0] & 2;
    data.l += 4;
    var RK = fInt === 0 ? $b8f343bf88dacc48$var$__double([
        0,
        0,
        0,
        0,
        b[0] & 0xFC,
        b[1],
        b[2],
        b[3]
    ], 0) : $b8f343bf88dacc48$var$__readInt32LE(b, 0) >> 2;
    return fX100 ? RK / 100 : RK;
}
function $b8f343bf88dacc48$var$write_RkNumber(data /*:number*/ , o) {
    if (o == null) o = $b8f343bf88dacc48$var$new_buf(4);
    var fX100 = 0, fInt = 0, d100 = data * 100;
    if (data == (data | 0) && data >= -536870912 && data < 536870912) fInt = 1;
    else if (d100 == (d100 | 0) && d100 >= -536870912 && d100 < 536870912) {
        fInt = 1;
        fX100 = 1;
    }
    if (fInt) o.write_shift(-4, ((fX100 ? d100 : data) << 2) + (fX100 + 2));
    else throw new Error("unsupported RkNumber " + data); // TODO
}
/* [MS-XLSB] 2.5.117 RfX */ function $b8f343bf88dacc48$var$parse_RfX(data /*::, length*/ ) /*:Range*/ {
    var cell /*:Range*/  = {
        s: {},
        e: {}
    } /*:any*/ ;
    cell.s.r = data.read_shift(4);
    cell.e.r = data.read_shift(4);
    cell.s.c = data.read_shift(4);
    cell.e.c = data.read_shift(4);
    return cell;
}
function $b8f343bf88dacc48$var$write_RfX(r /*:Range*/ , o) {
    if (!o) o = $b8f343bf88dacc48$var$new_buf(16);
    o.write_shift(4, r.s.r);
    o.write_shift(4, r.e.r);
    o.write_shift(4, r.s.c);
    o.write_shift(4, r.e.c);
    return o;
}
/* [MS-XLSB] 2.5.153 UncheckedRfX */ var $b8f343bf88dacc48$var$parse_UncheckedRfX = $b8f343bf88dacc48$var$parse_RfX;
var $b8f343bf88dacc48$var$write_UncheckedRfX = $b8f343bf88dacc48$var$write_RfX;
/* [MS-XLSB] 2.5.155 UncheckedSqRfX */ //function parse_UncheckedSqRfX(data) {
//	var cnt = data.read_shift(4);
//	var out = [];
//	for(var i = 0; i < cnt; ++i) {
//		var rng = parse_UncheckedRfX(data);
//		out.push(encode_range(rng));
//	}
//	return out.join(",");
//}
//function write_UncheckedSqRfX(sqrfx/*:string*/) {
//	var parts = sqrfx.split(/\s*,\s*/);
//	var o = new_buf(4); o.write_shift(4, parts.length);
//	var out = [o];
//	parts.forEach(function(rng) {
//		out.push(write_UncheckedRfX(safe_decode_range(rng)));
//	});
//	return bconcat(out);
//}
/* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 */ /* TODO: error checking, NaN and Infinity values are not valid Xnum */ function $b8f343bf88dacc48$var$parse_Xnum(data /*::, length*/ ) {
    if (data.length - data.l < 8) throw "XLS Xnum Buffer underflow";
    return data.read_shift(8, 'f');
}
function $b8f343bf88dacc48$var$write_Xnum(data, o) {
    return (o || $b8f343bf88dacc48$var$new_buf(8)).write_shift(8, data, 'f');
}
/* [MS-XLSB] 2.4.324 BrtColor */ function $b8f343bf88dacc48$var$parse_BrtColor(data /*::, length*/ ) {
    var out = {};
    var d = data.read_shift(1);
    //var fValidRGB = d & 1;
    var xColorType = d >>> 1;
    var index = data.read_shift(1);
    var nTS = data.read_shift(2, 'i');
    var bR = data.read_shift(1);
    var bG = data.read_shift(1);
    var bB = data.read_shift(1);
    data.l++; //var bAlpha = data.read_shift(1);
    switch(xColorType){
        case 0:
            out.auto = 1;
            break;
        case 1:
            out.index = index;
            var icv = $b8f343bf88dacc48$var$XLSIcv[index];
            /* automatic pseudo index 81 */ if (icv) out.rgb = $b8f343bf88dacc48$var$rgb2Hex(icv);
            break;
        case 2:
            /* if(!fValidRGB) throw new Error("invalid"); */ out.rgb = $b8f343bf88dacc48$var$rgb2Hex([
                bR,
                bG,
                bB
            ]);
            break;
        case 3:
            out.theme = index;
            break;
    }
    if (nTS != 0) out.tint = nTS > 0 ? nTS / 32767 : nTS / 32768;
    return out;
}
function $b8f343bf88dacc48$var$write_BrtColor(color, o) {
    if (!o) o = $b8f343bf88dacc48$var$new_buf(8);
    if (!color || color.auto) {
        o.write_shift(4, 0);
        o.write_shift(4, 0);
        return o;
    }
    if (color.index != null) {
        o.write_shift(1, 0x02);
        o.write_shift(1, color.index);
    } else if (color.theme != null) {
        o.write_shift(1, 0x06);
        o.write_shift(1, color.theme);
    } else {
        o.write_shift(1, 0x05);
        o.write_shift(1, 0);
    }
    var nTS = color.tint || 0;
    if (nTS > 0) nTS *= 32767;
    else if (nTS < 0) nTS *= 32768;
    o.write_shift(2, nTS);
    if (!color.rgb || color.theme != null) {
        o.write_shift(2, 0);
        o.write_shift(1, 0);
        o.write_shift(1, 0);
    } else {
        var rgb = color.rgb || 'FFFFFF';
        if (typeof rgb == 'number') rgb = ("000000" + rgb.toString(16)).slice(-6);
        o.write_shift(1, parseInt(rgb.slice(0, 2), 16));
        o.write_shift(1, parseInt(rgb.slice(2, 4), 16));
        o.write_shift(1, parseInt(rgb.slice(4, 6), 16));
        o.write_shift(1, 0xFF);
    }
    return o;
}
/* [MS-XLSB] 2.5.52 */ function $b8f343bf88dacc48$var$parse_FontFlags(data /*::, length, opts*/ ) {
    var d = data.read_shift(1);
    data.l++;
    var out = {
        fBold: d & 0x01,
        fItalic: d & 0x02,
        fUnderline: d & 0x04,
        fStrikeout: d & 0x08,
        fOutline: d & 0x10,
        fShadow: d & 0x20,
        fCondense: d & 0x40,
        fExtend: d & 0x80
    };
    return out;
}
function $b8f343bf88dacc48$var$write_FontFlags(font, o) {
    if (!o) o = $b8f343bf88dacc48$var$new_buf(2);
    var grbit = (font.italic ? 0x02 : 0) | (font.strike ? 0x08 : 0) | (font.outline ? 0x10 : 0) | (font.shadow ? 0x20 : 0) | (font.condense ? 0x40 : 0) | (font.extend ? 0x80 : 0);
    o.write_shift(1, grbit);
    o.write_shift(1, 0);
    return o;
}
/* [MS-OLEDS] 2.3.1 and 2.3.2 */ function $b8f343bf88dacc48$var$parse_ClipboardFormatOrString(o, w /*:number*/ ) /*:string*/ {
    // $FlowIgnore
    var ClipFmt = {
        2: "BITMAP",
        3: "METAFILEPICT",
        8: "DIB",
        14: "ENHMETAFILE"
    };
    var m /*:number*/  = o.read_shift(4);
    switch(m){
        case 0x00000000:
            return "";
        case 0xffffffff:
        case 0xfffffffe:
            return ClipFmt[o.read_shift(4)] || "";
    }
    if (m > 0x190) throw new Error("Unsupported Clipboard: " + m.toString(16));
    o.l -= 4;
    return o.read_shift(0, w == 1 ? "lpstr" : "lpwstr");
}
function $b8f343bf88dacc48$var$parse_ClipboardFormatOrAnsiString(o) {
    return $b8f343bf88dacc48$var$parse_ClipboardFormatOrString(o, 1);
}
function $b8f343bf88dacc48$var$parse_ClipboardFormatOrUnicodeString(o) {
    return $b8f343bf88dacc48$var$parse_ClipboardFormatOrString(o, 2);
}
/* [MS-OLEPS] 2.2 PropertyType */ // Note: some tree shakers cannot handle VT_VECTOR | $CONST, hence extra vars
//var VT_EMPTY    = 0x0000;
//var VT_NULL     = 0x0001;
var $b8f343bf88dacc48$var$VT_I2 = 0x0002;
var $b8f343bf88dacc48$var$VT_I4 = 0x0003;
//var VT_R4       = 0x0004;
//var VT_R8       = 0x0005;
//var VT_CY       = 0x0006;
//var VT_DATE     = 0x0007;
//var VT_BSTR     = 0x0008;
//var VT_ERROR    = 0x000A;
var $b8f343bf88dacc48$var$VT_BOOL = 0x000B;
var $b8f343bf88dacc48$var$VT_VARIANT = 0x000C;
//var VT_DECIMAL  = 0x000E;
//var VT_I1       = 0x0010;
//var VT_UI1      = 0x0011;
//var VT_UI2      = 0x0012;
var $b8f343bf88dacc48$var$VT_UI4 = 0x0013;
//var VT_I8       = 0x0014;
//var VT_UI8      = 0x0015;
//var VT_INT      = 0x0016;
//var VT_UINT     = 0x0017;
//var VT_LPSTR    = 0x001E;
//var VT_LPWSTR   = 0x001F;
var $b8f343bf88dacc48$var$VT_FILETIME = 0x0040;
var $b8f343bf88dacc48$var$VT_BLOB = 0x0041;
//var VT_STREAM   = 0x0042;
//var VT_STORAGE  = 0x0043;
//var VT_STREAMED_Object  = 0x0044;
//var VT_STORED_Object    = 0x0045;
//var VT_BLOB_Object      = 0x0046;
var $b8f343bf88dacc48$var$VT_CF = 0x0047;
//var VT_CLSID    = 0x0048;
//var VT_VERSIONED_STREAM = 0x0049;
//var VT_VECTOR   = 0x1000;
var $b8f343bf88dacc48$var$VT_VECTOR_VARIANT = 0x100C;
var $b8f343bf88dacc48$var$VT_VECTOR_LPSTR = 0x101E;
//var VT_ARRAY    = 0x2000;
var $b8f343bf88dacc48$var$VT_STRING = 0x0050; // 2.3.3.1.11 VtString
var $b8f343bf88dacc48$var$VT_USTR = 0x0051; // 2.3.3.1.12 VtUnalignedString
var $b8f343bf88dacc48$var$VT_CUSTOM = [
    $b8f343bf88dacc48$var$VT_STRING,
    $b8f343bf88dacc48$var$VT_USTR
];
/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */ var $b8f343bf88dacc48$var$DocSummaryPIDDSI = {
    0x01: {
        n: 'CodePage',
        t: $b8f343bf88dacc48$var$VT_I2
    },
    0x02: {
        n: 'Category',
        t: $b8f343bf88dacc48$var$VT_STRING
    },
    0x03: {
        n: 'PresentationFormat',
        t: $b8f343bf88dacc48$var$VT_STRING
    },
    0x04: {
        n: 'ByteCount',
        t: $b8f343bf88dacc48$var$VT_I4
    },
    0x05: {
        n: 'LineCount',
        t: $b8f343bf88dacc48$var$VT_I4
    },
    0x06: {
        n: 'ParagraphCount',
        t: $b8f343bf88dacc48$var$VT_I4
    },
    0x07: {
        n: 'SlideCount',
        t: $b8f343bf88dacc48$var$VT_I4
    },
    0x08: {
        n: 'NoteCount',
        t: $b8f343bf88dacc48$var$VT_I4
    },
    0x09: {
        n: 'HiddenCount',
        t: $b8f343bf88dacc48$var$VT_I4
    },
    0x0a: {
        n: 'MultimediaClipCount',
        t: $b8f343bf88dacc48$var$VT_I4
    },
    0x0b: {
        n: 'ScaleCrop',
        t: $b8f343bf88dacc48$var$VT_BOOL
    },
    0x0c: {
        n: 'HeadingPairs',
        t: $b8f343bf88dacc48$var$VT_VECTOR_VARIANT /* VT_VECTOR | VT_VARIANT */ 
    },
    0x0d: {
        n: 'TitlesOfParts',
        t: $b8f343bf88dacc48$var$VT_VECTOR_LPSTR /* VT_VECTOR | VT_LPSTR */ 
    },
    0x0e: {
        n: 'Manager',
        t: $b8f343bf88dacc48$var$VT_STRING
    },
    0x0f: {
        n: 'Company',
        t: $b8f343bf88dacc48$var$VT_STRING
    },
    0x10: {
        n: 'LinksUpToDate',
        t: $b8f343bf88dacc48$var$VT_BOOL
    },
    0x11: {
        n: 'CharacterCount',
        t: $b8f343bf88dacc48$var$VT_I4
    },
    0x13: {
        n: 'SharedDoc',
        t: $b8f343bf88dacc48$var$VT_BOOL
    },
    0x16: {
        n: 'HyperlinksChanged',
        t: $b8f343bf88dacc48$var$VT_BOOL
    },
    0x17: {
        n: 'AppVersion',
        t: $b8f343bf88dacc48$var$VT_I4,
        p: 'version'
    },
    0x18: {
        n: 'DigSig',
        t: $b8f343bf88dacc48$var$VT_BLOB
    },
    0x1A: {
        n: 'ContentType',
        t: $b8f343bf88dacc48$var$VT_STRING
    },
    0x1B: {
        n: 'ContentStatus',
        t: $b8f343bf88dacc48$var$VT_STRING
    },
    0x1C: {
        n: 'Language',
        t: $b8f343bf88dacc48$var$VT_STRING
    },
    0x1D: {
        n: 'Version',
        t: $b8f343bf88dacc48$var$VT_STRING
    },
    0xFF: {},
    /* [MS-OLEPS] 2.18 */ 0x80000000: {
        n: 'Locale',
        t: $b8f343bf88dacc48$var$VT_UI4
    },
    0x80000003: {
        n: 'Behavior',
        t: $b8f343bf88dacc48$var$VT_UI4
    },
    0x72627262: {}
};
/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */ var $b8f343bf88dacc48$var$SummaryPIDSI = {
    0x01: {
        n: 'CodePage',
        t: $b8f343bf88dacc48$var$VT_I2
    },
    0x02: {
        n: 'Title',
        t: $b8f343bf88dacc48$var$VT_STRING
    },
    0x03: {
        n: 'Subject',
        t: $b8f343bf88dacc48$var$VT_STRING
    },
    0x04: {
        n: 'Author',
        t: $b8f343bf88dacc48$var$VT_STRING
    },
    0x05: {
        n: 'Keywords',
        t: $b8f343bf88dacc48$var$VT_STRING
    },
    0x06: {
        n: 'Comments',
        t: $b8f343bf88dacc48$var$VT_STRING
    },
    0x07: {
        n: 'Template',
        t: $b8f343bf88dacc48$var$VT_STRING
    },
    0x08: {
        n: 'LastAuthor',
        t: $b8f343bf88dacc48$var$VT_STRING
    },
    0x09: {
        n: 'RevNumber',
        t: $b8f343bf88dacc48$var$VT_STRING
    },
    0x0A: {
        n: 'EditTime',
        t: $b8f343bf88dacc48$var$VT_FILETIME
    },
    0x0B: {
        n: 'LastPrinted',
        t: $b8f343bf88dacc48$var$VT_FILETIME
    },
    0x0C: {
        n: 'CreatedDate',
        t: $b8f343bf88dacc48$var$VT_FILETIME
    },
    0x0D: {
        n: 'ModifiedDate',
        t: $b8f343bf88dacc48$var$VT_FILETIME
    },
    0x0E: {
        n: 'PageCount',
        t: $b8f343bf88dacc48$var$VT_I4
    },
    0x0F: {
        n: 'WordCount',
        t: $b8f343bf88dacc48$var$VT_I4
    },
    0x10: {
        n: 'CharCount',
        t: $b8f343bf88dacc48$var$VT_I4
    },
    0x11: {
        n: 'Thumbnail',
        t: $b8f343bf88dacc48$var$VT_CF
    },
    0x12: {
        n: 'Application',
        t: $b8f343bf88dacc48$var$VT_STRING
    },
    0x13: {
        n: 'DocSecurity',
        t: $b8f343bf88dacc48$var$VT_I4
    },
    0xFF: {},
    /* [MS-OLEPS] 2.18 */ 0x80000000: {
        n: 'Locale',
        t: $b8f343bf88dacc48$var$VT_UI4
    },
    0x80000003: {
        n: 'Behavior',
        t: $b8f343bf88dacc48$var$VT_UI4
    },
    0x72627262: {}
};
/* [MS-XLS] 2.4.63 Country/Region codes */ var $b8f343bf88dacc48$var$CountryEnum = {
    0x0001: "US",
    0x0002: "CA",
    0x0003: "",
    0x0007: "RU",
    0x0014: "EG",
    0x001E: "GR",
    0x001F: "NL",
    0x0020: "BE",
    0x0021: "FR",
    0x0022: "ES",
    0x0024: "HU",
    0x0027: "IT",
    0x0029: "CH",
    0x002B: "AT",
    0x002C: "GB",
    0x002D: "DK",
    0x002E: "SE",
    0x002F: "NO",
    0x0030: "PL",
    0x0031: "DE",
    0x0034: "MX",
    0x0037: "BR",
    0x003d: "AU",
    0x0040: "NZ",
    0x0042: "TH",
    0x0051: "JP",
    0x0052: "KR",
    0x0054: "VN",
    0x0056: "CN",
    0x005A: "TR",
    0x0069: "JS",
    0x00D5: "DZ",
    0x00D8: "MA",
    0x00DA: "LY",
    0x015F: "PT",
    0x0162: "IS",
    0x0166: "FI",
    0x01A4: "CZ",
    0x0376: "TW",
    0x03C1: "LB",
    0x03C2: "JO",
    0x03C3: "SY",
    0x03C4: "IQ",
    0x03C5: "KW",
    0x03C6: "SA",
    0x03CB: "AE",
    0x03CC: "IL",
    0x03CE: "QA",
    0x03D5: "IR",
    0xFFFF: "US" // United States
};
/* [MS-XLS] 2.5.127 */ var $b8f343bf88dacc48$var$XLSFillPattern = [
    null,
    'solid',
    'mediumGray',
    'darkGray',
    'lightGray',
    'darkHorizontal',
    'darkVertical',
    'darkDown',
    'darkUp',
    'darkGrid',
    'darkTrellis',
    'lightHorizontal',
    'lightVertical',
    'lightDown',
    'lightUp',
    'lightGrid',
    'lightTrellis',
    'gray125',
    'gray0625'
];
function $b8f343bf88dacc48$var$rgbify(arr /*:Array<number>*/ ) /*:Array<[number, number, number]>*/ {
    return arr.map(function(x) {
        return [
            x >> 16 & 255,
            x >> 8 & 255,
            x & 255
        ];
    });
}
/* [MS-XLS] 2.5.161 */ /* [MS-XLSB] 2.5.75 Icv */ var $b8f343bf88dacc48$var$_XLSIcv = /*#__PURE__*/ $b8f343bf88dacc48$var$rgbify([
    /* Color Constants */ 0x000000,
    0xFFFFFF,
    0xFF0000,
    0x00FF00,
    0x0000FF,
    0xFFFF00,
    0xFF00FF,
    0x00FFFF,
    /* Overridable Defaults */ 0x000000,
    0xFFFFFF,
    0xFF0000,
    0x00FF00,
    0x0000FF,
    0xFFFF00,
    0xFF00FF,
    0x00FFFF,
    0x800000,
    0x008000,
    0x000080,
    0x808000,
    0x800080,
    0x008080,
    0xC0C0C0,
    0x808080,
    0x9999FF,
    0x993366,
    0xFFFFCC,
    0xCCFFFF,
    0x660066,
    0xFF8080,
    0x0066CC,
    0xCCCCFF,
    0x000080,
    0xFF00FF,
    0xFFFF00,
    0x00FFFF,
    0x800080,
    0x800000,
    0x008080,
    0x0000FF,
    0x00CCFF,
    0xCCFFFF,
    0xCCFFCC,
    0xFFFF99,
    0x99CCFF,
    0xFF99CC,
    0xCC99FF,
    0xFFCC99,
    0x3366FF,
    0x33CCCC,
    0x99CC00,
    0xFFCC00,
    0xFF9900,
    0xFF6600,
    0x666699,
    0x969696,
    0x003366,
    0x339966,
    0x003300,
    0x333300,
    0x993300,
    0x993366,
    0x333399,
    0x333333,
    /* Other entries to appease BIFF8/12 */ 0x000000,
    /* 0x40 icvForeground ?? */ 0xFFFFFF,
    /* 0x41 icvBackground ?? */ 0x000000,
    /* 0x42 icvFrame ?? */ 0x000000,
    /* 0x43 icv3D ?? */ 0x000000,
    /* 0x44 icv3DText ?? */ 0x000000,
    /* 0x45 icv3DHilite ?? */ 0x000000,
    /* 0x46 icv3DShadow ?? */ 0x000000,
    /* 0x47 icvHilite ?? */ 0x000000,
    /* 0x48 icvCtlText ?? */ 0x000000,
    /* 0x49 icvCtlScrl ?? */ 0x000000,
    /* 0x4A icvCtlInv ?? */ 0x000000,
    /* 0x4B icvCtlBody ?? */ 0x000000,
    /* 0x4C icvCtlFrame ?? */ 0x000000,
    /* 0x4D icvCtlFore ?? */ 0x000000,
    /* 0x4E icvCtlBack ?? */ 0x000000,
    /* 0x4F icvCtlNeutral */ 0x000000,
    /* 0x50 icvInfoBk ?? */ 0x000000 /* 0x51 icvInfoText ?? */ 
]);
var $b8f343bf88dacc48$var$XLSIcv = /*#__PURE__*/ $b8f343bf88dacc48$var$dup($b8f343bf88dacc48$var$_XLSIcv);
/* [MS-XLSB] 2.5.97.2 */ var $b8f343bf88dacc48$var$BErr = {
    0x00: "#NULL!",
    0x07: "#DIV/0!",
    0x0F: "#VALUE!",
    0x17: "#REF!",
    0x1D: "#NAME?",
    0x24: "#NUM!",
    0x2A: "#N/A",
    0x2B: "#GETTING_DATA",
    0xFF: "#WTF?"
};
//var RBErr = evert_num(BErr);
var $b8f343bf88dacc48$var$RBErr = {
    "#NULL!": 0x00,
    "#DIV/0!": 0x07,
    "#VALUE!": 0x0F,
    "#REF!": 0x17,
    "#NAME?": 0x1D,
    "#NUM!": 0x24,
    "#N/A": 0x2A,
    "#GETTING_DATA": 0x2B,
    "#WTF?": 0xFF
};
var $b8f343bf88dacc48$var$XLSLblBuiltIn = [
    "_xlnm.Consolidate_Area",
    "_xlnm.Auto_Open",
    "_xlnm.Auto_Close",
    "_xlnm.Extract",
    "_xlnm.Database",
    "_xlnm.Criteria",
    "_xlnm.Print_Area",
    "_xlnm.Print_Titles",
    "_xlnm.Recorder",
    "_xlnm.Data_Form",
    "_xlnm.Auto_Activate",
    "_xlnm.Auto_Deactivate",
    "_xlnm.Sheet_Title",
    "_xlnm._FilterDatabase"
];
/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */ /* 12.3 Part Summary <SpreadsheetML> */ /* 14.2 Part Summary <DrawingML> */ /* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */ var $b8f343bf88dacc48$var$ct2type /*{[string]:string}*/  = {
    /* Workbook */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
    "application/vnd.ms-excel.sheet.macroEnabled.main+xml": "workbooks",
    "application/vnd.ms-excel.sheet.binary.macroEnabled.main": "workbooks",
    "application/vnd.ms-excel.addin.macroEnabled.main+xml": "workbooks",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": "workbooks",
    /* Worksheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": "sheets",
    "application/vnd.ms-excel.worksheet": "sheets",
    "application/vnd.ms-excel.binIndexWs": "TODO",
    /* Binary Index */ /* Chartsheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "charts",
    "application/vnd.ms-excel.chartsheet": "charts",
    /* Macrosheet */ "application/vnd.ms-excel.macrosheet+xml": "macros",
    "application/vnd.ms-excel.macrosheet": "macros",
    "application/vnd.ms-excel.intlmacrosheet": "TODO",
    "application/vnd.ms-excel.binIndexMs": "TODO",
    /* Binary Index */ /* Dialogsheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "dialogs",
    "application/vnd.ms-excel.dialogsheet": "dialogs",
    /* Shared Strings */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": "strs",
    "application/vnd.ms-excel.sharedStrings": "strs",
    /* Styles */ "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": "styles",
    "application/vnd.ms-excel.styles": "styles",
    /* File Properties */ "application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
    "application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
    "application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
    /* Custom Data Properties */ "application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
    /* Comments */ "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments",
    "application/vnd.ms-excel.comments": "comments",
    "application/vnd.ms-excel.threadedcomments+xml": "threadedcomments",
    "application/vnd.ms-excel.person+xml": "people",
    /* Metadata (Stock/Geography and Dynamic Array) */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "metadata",
    "application/vnd.ms-excel.sheetMetadata": "metadata",
    /* PivotTable */ "application/vnd.ms-excel.pivotTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
    /* Chart Objects */ "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
    /* Chart Colors */ "application/vnd.ms-office.chartcolorstyle+xml": "TODO",
    /* Chart Style */ "application/vnd.ms-office.chartstyle+xml": "TODO",
    /* Chart Advanced */ "application/vnd.ms-office.chartex+xml": "TODO",
    /* Calculation Chain */ "application/vnd.ms-excel.calcChain": "calcchains",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
    /* Printer Settings */ "application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
    /* ActiveX */ "application/vnd.ms-office.activeX": "TODO",
    "application/vnd.ms-office.activeX+xml": "TODO",
    /* Custom Toolbars */ "application/vnd.ms-excel.attachedToolbars": "TODO",
    /* External Data Connections */ "application/vnd.ms-excel.connections": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
    /* External Links */ "application/vnd.ms-excel.externalLink": "links",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
    /* PivotCache */ "application/vnd.ms-excel.pivotCacheDefinition": "TODO",
    "application/vnd.ms-excel.pivotCacheRecords": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
    /* Query Table */ "application/vnd.ms-excel.queryTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
    /* Shared Workbook */ "application/vnd.ms-excel.userNames": "TODO",
    "application/vnd.ms-excel.revisionHeaders": "TODO",
    "application/vnd.ms-excel.revisionLog": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
    /* Single Cell Table */ "application/vnd.ms-excel.tableSingleCells": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
    /* Slicer */ "application/vnd.ms-excel.slicer": "TODO",
    "application/vnd.ms-excel.slicerCache": "TODO",
    "application/vnd.ms-excel.slicer+xml": "TODO",
    "application/vnd.ms-excel.slicerCache+xml": "TODO",
    /* Sort Map */ "application/vnd.ms-excel.wsSortMap": "TODO",
    /* Table */ "application/vnd.ms-excel.table": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
    /* Themes */ "application/vnd.openxmlformats-officedocument.theme+xml": "themes",
    /* Theme Override */ "application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
    /* Timeline */ "application/vnd.ms-excel.Timeline+xml": "TODO",
    /* verify */ "application/vnd.ms-excel.TimelineCache+xml": "TODO",
    /* verify */ /* VBA */ "application/vnd.ms-office.vbaProject": "vba",
    "application/vnd.ms-office.vbaProjectSignature": "TODO",
    /* Volatile Dependencies */ "application/vnd.ms-office.volatileDependencies": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
    /* Control Properties */ "application/vnd.ms-excel.controlproperties+xml": "TODO",
    /* Data Model */ "application/vnd.openxmlformats-officedocument.model+data": "TODO",
    /* Survey */ "application/vnd.ms-excel.Survey+xml": "TODO",
    /* Drawing */ "application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
    "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
    /* VML */ "application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
    "application/vnd.openxmlformats-package.relationships+xml": "rels",
    "application/vnd.openxmlformats-officedocument.oleObject": "TODO",
    /* Image */ "image/png": "TODO",
    "sheet": "js"
} /*:any*/ ;
var $b8f343bf88dacc48$var$CT_LIST = {
    workbooks: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
        xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
        xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
        xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
        xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
    },
    strs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
        xlsb: "application/vnd.ms-excel.sharedStrings"
    },
    comments: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
        xlsb: "application/vnd.ms-excel.comments"
    },
    sheets: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
        xlsb: "application/vnd.ms-excel.worksheet"
    },
    charts: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
        xlsb: "application/vnd.ms-excel.chartsheet"
    },
    dialogs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
        xlsb: "application/vnd.ms-excel.dialogsheet"
    },
    macros: {
        xlsx: "application/vnd.ms-excel.macrosheet+xml",
        xlsb: "application/vnd.ms-excel.macrosheet"
    },
    metadata: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml",
        xlsb: "application/vnd.ms-excel.sheetMetadata"
    },
    styles: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
        xlsb: "application/vnd.ms-excel.styles"
    }
};
function $b8f343bf88dacc48$var$new_ct() /*:any*/ {
    return {
        workbooks: [],
        sheets: [],
        charts: [],
        dialogs: [],
        macros: [],
        rels: [],
        strs: [],
        comments: [],
        threadedcomments: [],
        links: [],
        coreprops: [],
        extprops: [],
        custprops: [],
        themes: [],
        styles: [],
        calcchains: [],
        vba: [],
        drawings: [],
        metadata: [],
        people: [],
        TODO: [],
        xmlns: ""
    } /*:any*/ ;
}
function $b8f343bf88dacc48$var$parse_ct(data /*:?string*/ ) {
    var ct = $b8f343bf88dacc48$var$new_ct();
    if (!data || !data.match) return ct;
    var ctext = {};
    (data.match($b8f343bf88dacc48$var$tagregex) || []).forEach(function(x) {
        var y = $b8f343bf88dacc48$var$parsexmltag(x);
        switch(y[0].replace($b8f343bf88dacc48$var$nsregex, "<")){
            case '<?xml':
                break;
            case '<Types':
                ct.xmlns = y['xmlns' + (y[0].match(/<(\w+):/) || [
                    "",
                    ""
                ])[1]];
                break;
            case '<Default':
                ctext[y.Extension.toLowerCase()] = y.ContentType;
                break;
            case '<Override':
                if (ct[$b8f343bf88dacc48$var$ct2type[y.ContentType]] !== undefined) ct[$b8f343bf88dacc48$var$ct2type[y.ContentType]].push(y.PartName);
                break;
        }
    });
    if (ct.xmlns !== $b8f343bf88dacc48$var$XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns);
    ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : "";
    ct.sst = ct.strs.length > 0 ? ct.strs[0] : "";
    ct.style = ct.styles.length > 0 ? ct.styles[0] : "";
    ct.defaults = ctext;
    delete ct.calcchains;
    return ct;
}
function $b8f343bf88dacc48$var$write_ct(ct, opts, raw) /*:string*/ {
    var type2ct /*{[string]:Array<string>}*/  = $b8f343bf88dacc48$var$evert_arr($b8f343bf88dacc48$var$ct2type);
    var o /*:Array<string>*/  = [], v;
    if (!raw) {
        o[o.length] = $b8f343bf88dacc48$var$XML_HEADER;
        o[o.length] = $b8f343bf88dacc48$var$writextag('Types', null, {
            'xmlns': $b8f343bf88dacc48$var$XMLNS.CT,
            'xmlns:xsd': $b8f343bf88dacc48$var$XMLNS.xsd,
            'xmlns:xsi': $b8f343bf88dacc48$var$XMLNS.xsi
        });
        o = o.concat([
            [
                'xml',
                'application/xml'
            ],
            [
                'bin',
                'application/vnd.ms-excel.sheet.binary.macroEnabled.main'
            ],
            [
                'vml',
                'application/vnd.openxmlformats-officedocument.vmlDrawing'
            ],
            [
                'data',
                'application/vnd.openxmlformats-officedocument.model+data'
            ],
            /* from test files */ [
                'bmp',
                'image/bmp'
            ],
            [
                'png',
                'image/png'
            ],
            [
                'gif',
                'image/gif'
            ],
            [
                'emf',
                'image/x-emf'
            ],
            [
                'wmf',
                'image/x-wmf'
            ],
            [
                'jpg',
                'image/jpeg'
            ],
            [
                'jpeg',
                'image/jpeg'
            ],
            [
                'tif',
                'image/tiff'
            ],
            [
                'tiff',
                'image/tiff'
            ],
            [
                'pdf',
                'application/pdf'
            ],
            [
                'rels',
                'application/vnd.openxmlformats-package.relationships+xml'
            ]
        ].map(function(x) {
            return $b8f343bf88dacc48$var$writextag('Default', null, {
                'Extension': x[0],
                'ContentType': x[1]
            });
        }));
    }
    /* only write first instance */ var f1 = function(w) {
        if (ct[w] && ct[w].length > 0) {
            v = ct[w][0];
            o[o.length] = $b8f343bf88dacc48$var$writextag('Override', null, {
                'PartName': (v[0] == '/' ? "" : "/") + v,
                'ContentType': $b8f343bf88dacc48$var$CT_LIST[w][opts.bookType] || $b8f343bf88dacc48$var$CT_LIST[w]['xlsx']
            });
        }
    };
    /* book type-specific */ var f2 = function(w) {
        (ct[w] || []).forEach(function(v) {
            o[o.length] = $b8f343bf88dacc48$var$writextag('Override', null, {
                'PartName': (v[0] == '/' ? "" : "/") + v,
                'ContentType': $b8f343bf88dacc48$var$CT_LIST[w][opts.bookType] || $b8f343bf88dacc48$var$CT_LIST[w]['xlsx']
            });
        });
    };
    /* standard type */ var f3 = function(t) {
        (ct[t] || []).forEach(function(v) {
            o[o.length] = $b8f343bf88dacc48$var$writextag('Override', null, {
                'PartName': (v[0] == '/' ? "" : "/") + v,
                'ContentType': type2ct[t][0]
            });
        });
    };
    f1('workbooks');
    f2('sheets');
    f2('charts');
    f3('themes');
    [
        'strs',
        'styles'
    ].forEach(f1);
    [
        'coreprops',
        'extprops',
        'custprops'
    ].forEach(f3);
    f3('vba');
    f3('comments');
    f3('threadedcomments');
    f3('drawings');
    f2('metadata');
    f3('people');
    if (!raw && o.length > 2) {
        o[o.length] = '</Types>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 9.3 Relationships */ var $b8f343bf88dacc48$var$RELS = {
    WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
    VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
    XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
    XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
    XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
    CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
    CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
    CMNT: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
    CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
    EXT_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties',
    CUST_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties',
    SST: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
    STY: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
    THEME: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
    CHART: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",
    CHARTEX: "http://schemas.microsoft.com/office/2014/relationships/chartEx",
    CS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",
    WS: [
        "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
        "http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
    ],
    DS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",
    MS: "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",
    IMG: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
    DRAW: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
    XLMETA: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",
    TCMNT: "http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",
    PEOPLE: "http://schemas.microsoft.com/office/2017/10/relationships/person",
    CONN: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/connections",
    VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
} /*:any*/ ;
/* 9.3.3 Representing Relationships */ function $b8f343bf88dacc48$var$get_rels_path(file /*:string*/ ) /*:string*/ {
    var n = file.lastIndexOf("/");
    return file.slice(0, n + 1) + '_rels/' + file.slice(n + 1) + ".rels";
}
function $b8f343bf88dacc48$var$parse_rels(data /*:?string*/ , currentFilePath /*:string*/ ) {
    var rels = {
        "!id": {}
    };
    if (!data) return rels;
    if (currentFilePath.charAt(0) !== '/') currentFilePath = '/' + currentFilePath;
    var hash = {};
    (data.match($b8f343bf88dacc48$var$tagregex) || []).forEach(function(x) {
        var y = $b8f343bf88dacc48$var$parsexmltag(x);
        /* 9.3.2.2 OPC_Relationships */ if (y[0] === '<Relationship') {
            var rel = {};
            rel.Type = y.Type;
            rel.Target = $b8f343bf88dacc48$var$unescapexml(y.Target);
            rel.Id = y.Id;
            if (y.TargetMode) rel.TargetMode = y.TargetMode;
            var canonictarget = y.TargetMode === 'External' ? y.Target : $b8f343bf88dacc48$var$resolve_path(y.Target, currentFilePath);
            rels[canonictarget] = rel;
            hash[y.Id] = rel;
        }
    });
    rels["!id"] = hash;
    return rels;
}
/* TODO */ function $b8f343bf88dacc48$var$write_rels(rels) /*:string*/ {
    var o = [
        $b8f343bf88dacc48$var$XML_HEADER,
        $b8f343bf88dacc48$var$writextag('Relationships', null, {
            //'xmlns:ns0': XMLNS.RELS,
            'xmlns': $b8f343bf88dacc48$var$XMLNS.RELS
        })
    ];
    $b8f343bf88dacc48$var$keys(rels['!id']).forEach(function(rid) {
        o[o.length] = $b8f343bf88dacc48$var$writextag('Relationship', null, rels['!id'][rid]);
    });
    if (o.length > 2) {
        o[o.length] = '</Relationships>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
function $b8f343bf88dacc48$var$add_rels(rels, rId /*:number*/ , f, type, relobj, targetmode /*:?string*/ ) /*:number*/ {
    if (!relobj) relobj = {};
    if (!rels['!id']) rels['!id'] = {};
    if (!rels['!idx']) rels['!idx'] = 1;
    if (rId < 0) for(rId = rels['!idx']; rels['!id']['rId' + rId]; ++rId);
    rels['!idx'] = rId + 1;
    relobj.Id = 'rId' + rId;
    relobj.Type = type;
    relobj.Target = f;
    if (targetmode) relobj.TargetMode = targetmode;
    else if ([
        $b8f343bf88dacc48$var$RELS.HLINK,
        $b8f343bf88dacc48$var$RELS.XPATH,
        $b8f343bf88dacc48$var$RELS.XMISS
    ].indexOf(relobj.Type) > -1) relobj.TargetMode = "External";
    if (rels['!id'][relobj.Id]) throw new Error("Cannot rewrite rId " + rId);
    rels['!id'][relobj.Id] = relobj;
    rels[('/' + relobj.Target).replace("//", "/")] = relobj;
    return rId;
}
var $b8f343bf88dacc48$var$CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
function $b8f343bf88dacc48$var$parse_manifest(d, opts) {
    var str = $b8f343bf88dacc48$var$xlml_normalize(d);
    var Rn;
    var FEtag;
    while(Rn = $b8f343bf88dacc48$var$xlmlregex.exec(str))switch(Rn[3]){
        case "manifest":
            break;
        case "file-entry":
            FEtag = $b8f343bf88dacc48$var$parsexmltag(Rn[0], false);
            if (FEtag.path == "/" && FEtag.type !== $b8f343bf88dacc48$var$CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
            break;
        case "encryption-data":
        case "algorithm":
        case "start-key-generation":
        case "key-derivation":
            throw new Error("Unsupported ODS Encryption");
        default:
            if (opts && opts.WTF) throw Rn;
    }
}
function $b8f343bf88dacc48$var$write_manifest(manifest) {
    var o = [
        $b8f343bf88dacc48$var$XML_HEADER
    ];
    o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');
    o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');
    for(var i = 0; i < manifest.length; ++i)o.push('  <manifest:file-entry manifest:full-path="' + manifest[i][0] + '" manifest:media-type="' + manifest[i][1] + '"/>\n');
    o.push("</manifest:manifest>");
    return o.join("");
}
function $b8f343bf88dacc48$var$write_rdf_type(file, res, tag) {
    return [
        '  <rdf:Description rdf:about="' + file + '">\n',
        '    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (tag || "odf") + "#" + res + '"/>\n',
        "  </rdf:Description>\n"
    ].join("");
}
function $b8f343bf88dacc48$var$write_rdf_has(base, file) {
    return [
        '  <rdf:Description rdf:about="' + base + '">\n',
        '    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + file + '"/>\n',
        "  </rdf:Description>\n"
    ].join("");
}
function $b8f343bf88dacc48$var$write_rdf(rdf) {
    var o = [
        $b8f343bf88dacc48$var$XML_HEADER
    ];
    o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');
    for(var i = 0; i != rdf.length; ++i){
        o.push($b8f343bf88dacc48$var$write_rdf_type(rdf[i][0], rdf[i][1]));
        o.push($b8f343bf88dacc48$var$write_rdf_has("", rdf[i][0]));
    }
    o.push($b8f343bf88dacc48$var$write_rdf_type("", "Document", "pkg"));
    o.push("</rdf:RDF>");
    return o.join("");
}
function $b8f343bf88dacc48$var$write_meta_ods(wb, opts) {
    return '<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>SheetJS ' + $b8f343bf88dacc48$var$XLSX.version + "</meta:generator></office:meta></office:document-meta>";
}
/* ECMA-376 Part II 11.1 Core Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */ var $b8f343bf88dacc48$var$CORE_PROPS /*:Array<Array<string> >*/  = [
    [
        "cp:category",
        "Category"
    ],
    [
        "cp:contentStatus",
        "ContentStatus"
    ],
    [
        "cp:keywords",
        "Keywords"
    ],
    [
        "cp:lastModifiedBy",
        "LastAuthor"
    ],
    [
        "cp:lastPrinted",
        "LastPrinted"
    ],
    [
        "cp:revision",
        "RevNumber"
    ],
    [
        "cp:version",
        "Version"
    ],
    [
        "dc:creator",
        "Author"
    ],
    [
        "dc:description",
        "Comments"
    ],
    [
        "dc:identifier",
        "Identifier"
    ],
    [
        "dc:language",
        "Language"
    ],
    [
        "dc:subject",
        "Subject"
    ],
    [
        "dc:title",
        "Title"
    ],
    [
        "dcterms:created",
        "CreatedDate",
        'date'
    ],
    [
        "dcterms:modified",
        "ModifiedDate",
        'date'
    ]
];
function $b8f343bf88dacc48$var$parse_core_props(data) {
    var p = {};
    data = $b8f343bf88dacc48$var$utf8read(data);
    for(var i = 0; i < $b8f343bf88dacc48$var$CORE_PROPS.length; ++i){
        var f = $b8f343bf88dacc48$var$CORE_PROPS[i], cur = $b8f343bf88dacc48$var$str_match_xml(data, f[0]);
        if (cur != null && cur.length > 0) p[f[1]] = $b8f343bf88dacc48$var$unescapexml(cur[1]);
        if (f[2] === 'date' && p[f[1]]) p[f[1]] = $b8f343bf88dacc48$var$parseDate(p[f[1]]);
    }
    return p;
}
function $b8f343bf88dacc48$var$cp_doit(f, g, h, o, p) {
    if (p[f] != null || g == null || g === "") return;
    p[f] = g;
    g = $b8f343bf88dacc48$var$escapexml(g);
    o[o.length] = h ? $b8f343bf88dacc48$var$writextag(f, g, h) : $b8f343bf88dacc48$var$writetag(f, g);
}
function $b8f343bf88dacc48$var$write_core_props(cp, _opts) {
    var opts = _opts || {};
    var o = [
        $b8f343bf88dacc48$var$XML_HEADER,
        $b8f343bf88dacc48$var$writextag('cp:coreProperties', null, {
            //'xmlns': XMLNS.CORE_PROPS,
            'xmlns:cp': $b8f343bf88dacc48$var$XMLNS.CORE_PROPS,
            'xmlns:dc': $b8f343bf88dacc48$var$XMLNS.dc,
            'xmlns:dcterms': $b8f343bf88dacc48$var$XMLNS.dcterms,
            'xmlns:dcmitype': $b8f343bf88dacc48$var$XMLNS.dcmitype,
            'xmlns:xsi': $b8f343bf88dacc48$var$XMLNS.xsi
        })
    ], p = {};
    if (!cp && !opts.Props) return o.join("");
    if (cp) {
        if (cp.CreatedDate != null) $b8f343bf88dacc48$var$cp_doit("dcterms:created", typeof cp.CreatedDate === "string" ? cp.CreatedDate : $b8f343bf88dacc48$var$write_w3cdtf(cp.CreatedDate, opts.WTF), {
            "xsi:type": "dcterms:W3CDTF"
        }, o, p);
        if (cp.ModifiedDate != null) $b8f343bf88dacc48$var$cp_doit("dcterms:modified", typeof cp.ModifiedDate === "string" ? cp.ModifiedDate : $b8f343bf88dacc48$var$write_w3cdtf(cp.ModifiedDate, opts.WTF), {
            "xsi:type": "dcterms:W3CDTF"
        }, o, p);
    }
    for(var i = 0; i != $b8f343bf88dacc48$var$CORE_PROPS.length; ++i){
        var f = $b8f343bf88dacc48$var$CORE_PROPS[i];
        var v = opts.Props && opts.Props[f[1]] != null ? opts.Props[f[1]] : cp ? cp[f[1]] : null;
        if (v === true) v = "1";
        else if (v === false) v = "0";
        else if (typeof v == "number") v = String(v);
        if (v != null) $b8f343bf88dacc48$var$cp_doit(f[0], v, null, o, p);
    }
    if (o.length > 2) {
        o[o.length] = '</cp:coreProperties>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 15.2.12.3 Extended File Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */ var $b8f343bf88dacc48$var$EXT_PROPS /*:Array<Array<string> >*/  = [
    [
        "Application",
        "Application",
        "string"
    ],
    [
        "AppVersion",
        "AppVersion",
        "string"
    ],
    [
        "Company",
        "Company",
        "string"
    ],
    [
        "DocSecurity",
        "DocSecurity",
        "string"
    ],
    [
        "Manager",
        "Manager",
        "string"
    ],
    [
        "HyperlinksChanged",
        "HyperlinksChanged",
        "bool"
    ],
    [
        "SharedDoc",
        "SharedDoc",
        "bool"
    ],
    [
        "LinksUpToDate",
        "LinksUpToDate",
        "bool"
    ],
    [
        "ScaleCrop",
        "ScaleCrop",
        "bool"
    ],
    [
        "HeadingPairs",
        "HeadingPairs",
        "raw"
    ],
    [
        "TitlesOfParts",
        "TitlesOfParts",
        "raw"
    ]
];
var $b8f343bf88dacc48$var$PseudoPropsPairs = [
    "Worksheets",
    "SheetNames",
    "NamedRanges",
    "DefinedNames",
    "Chartsheets",
    "ChartNames"
];
function $b8f343bf88dacc48$var$load_props_pairs(HP /*:string|Array<Array<any>>*/ , TOP, props, opts) {
    var v = [];
    if (typeof HP == "string") v = $b8f343bf88dacc48$var$parseVector(HP, opts);
    else for(var j = 0; j < HP.length; ++j)v = v.concat(HP[j].map(function(hp) {
        return {
            v: hp
        };
    }));
    var parts = typeof TOP == "string" ? $b8f343bf88dacc48$var$parseVector(TOP, opts).map(function(x) {
        return x.v;
    }) : TOP;
    var idx = 0, len = 0;
    if (parts.length > 0) for(var i = 0; i !== v.length; i += 2){
        len = +v[i + 1].v;
        switch(v[i].v){
            case "Worksheets":
            case "\u5DE5\u4F5C\u8868":
            case "\u041B\u0438\u0441\u0442\u044B":
            case "\u0623\u0648\u0631\u0627\u0642 \u0627\u0644\u0639\u0645\u0644":
            case "\u30EF\u30FC\u30AF\u30B7\u30FC\u30C8":
            case "\u05D2\u05DC\u05D9\u05D5\u05E0\u05D5\u05EA \u05E2\u05D1\u05D5\u05D3\u05D4":
            case "Arbeitsbl\xe4tter":
            case "\xc7al\u0131\u015Fma Sayfalar\u0131":
            case "Feuilles de calcul":
            case "Fogli di lavoro":
            case "Folhas de c\xe1lculo":
            case "Planilhas":
            case "Regneark":
            case "Hojas de c\xe1lculo":
            case "Werkbladen":
                props.Worksheets = len;
                props.SheetNames = parts.slice(idx, idx + len);
                break;
            case "Named Ranges":
            case "Rangos con nombre":
            case "\u540D\u524D\u4ED8\u304D\u4E00\u89A7":
            case "Benannte Bereiche":
            case "Navngivne omr\xe5der":
                props.NamedRanges = len;
                props.DefinedNames = parts.slice(idx, idx + len);
                break;
            case "Charts":
            case "Diagramme":
                props.Chartsheets = len;
                props.ChartNames = parts.slice(idx, idx + len);
                break;
        }
        idx += len;
    }
}
function $b8f343bf88dacc48$var$parse_ext_props(data, p, opts) {
    var q = {};
    if (!p) p = {};
    data = $b8f343bf88dacc48$var$utf8read(data);
    $b8f343bf88dacc48$var$EXT_PROPS.forEach(function(f) {
        var xml = ($b8f343bf88dacc48$var$str_match_xml_ns(data, f[0]) || [])[1];
        switch(f[2]){
            case "string":
                if (xml) p[f[1]] = $b8f343bf88dacc48$var$unescapexml(xml);
                break;
            case "bool":
                p[f[1]] = xml === "true";
                break;
            case "raw":
                var cur = $b8f343bf88dacc48$var$str_match_xml(data, f[0]);
                if (cur && cur.length > 0) q[f[1]] = cur[1];
                break;
        }
    });
    if (q.HeadingPairs && q.TitlesOfParts) $b8f343bf88dacc48$var$load_props_pairs(q.HeadingPairs, q.TitlesOfParts, p, opts);
    return p;
}
function $b8f343bf88dacc48$var$write_ext_props(cp /*::, opts*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [], W = $b8f343bf88dacc48$var$writextag;
    if (!cp) cp = {};
    cp.Application = "SheetJS";
    o[o.length] = $b8f343bf88dacc48$var$XML_HEADER;
    o[o.length] = $b8f343bf88dacc48$var$writextag('Properties', null, {
        'xmlns': $b8f343bf88dacc48$var$XMLNS.EXT_PROPS,
        'xmlns:vt': $b8f343bf88dacc48$var$XMLNS.vt
    });
    $b8f343bf88dacc48$var$EXT_PROPS.forEach(function(f) {
        if (cp[f[1]] === undefined) return;
        var v;
        switch(f[2]){
            case 'string':
                v = $b8f343bf88dacc48$var$escapexml(String(cp[f[1]]));
                break;
            case 'bool':
                v = cp[f[1]] ? 'true' : 'false';
                break;
        }
        if (v !== undefined) o[o.length] = W(f[0], v);
    });
    /* TODO: HeadingPairs, TitlesOfParts */ o[o.length] = W('HeadingPairs', W('vt:vector', W('vt:variant', '<vt:lpstr>Worksheets</vt:lpstr>') + W('vt:variant', W('vt:i4', String(cp.Worksheets))), {
        size: 2,
        baseType: "variant"
    }));
    o[o.length] = W('TitlesOfParts', W('vt:vector', cp.SheetNames.map(function(s) {
        return "<vt:lpstr>" + $b8f343bf88dacc48$var$escapexml(s) + "</vt:lpstr>";
    }).join(""), {
        size: cp.Worksheets,
        baseType: "lpstr"
    }));
    if (o.length > 2) {
        o[o.length] = '</Properties>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 15.2.12.2 Custom File Properties Part */ var $b8f343bf88dacc48$var$custregex = /<[^<>]+>[^<]*/g;
function $b8f343bf88dacc48$var$parse_cust_props(data /*:string*/ , opts) {
    var p = {}, name = "";
    var m = data.match($b8f343bf88dacc48$var$custregex);
    if (m) for(var i = 0; i != m.length; ++i){
        var x = m[i], y = $b8f343bf88dacc48$var$parsexmltag(x);
        switch($b8f343bf88dacc48$var$strip_ns(y[0])){
            case '<?xml':
                break;
            case '<Properties':
                break;
            case '<property':
                name = $b8f343bf88dacc48$var$unescapexml(y.name);
                break;
            case '</property>':
                name = null;
                break;
            default:
                if (x.indexOf('<vt:') === 0) {
                    var toks = x.split('>');
                    var type = toks[0].slice(4), text = toks[1];
                    /* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */ switch(type){
                        case 'lpstr':
                        case 'bstr':
                        case 'lpwstr':
                            p[name] = $b8f343bf88dacc48$var$unescapexml(text);
                            break;
                        case 'bool':
                            p[name] = $b8f343bf88dacc48$var$parsexmlbool(text);
                            break;
                        case 'i1':
                        case 'i2':
                        case 'i4':
                        case 'i8':
                        case 'int':
                        case 'uint':
                            p[name] = parseInt(text, 10);
                            break;
                        case 'r4':
                        case 'r8':
                        case 'decimal':
                            p[name] = parseFloat(text);
                            break;
                        case 'filetime':
                        case 'date':
                            p[name] = $b8f343bf88dacc48$var$parseDate(text);
                            break;
                        case 'cy':
                        case 'error':
                            p[name] = $b8f343bf88dacc48$var$unescapexml(text);
                            break;
                        default:
                            if (type.slice(-1) == '/') break;
                            if (opts.WTF && typeof console !== 'undefined') console.warn('Unexpected', x, type, toks);
                    }
                } else if (x.slice(0, 2) === "</") ;
                else if (opts.WTF) throw new Error(x);
        }
    }
    return p;
}
function $b8f343bf88dacc48$var$write_cust_props(cp /*::, opts*/ ) /*:string*/ {
    var o = [
        $b8f343bf88dacc48$var$XML_HEADER,
        $b8f343bf88dacc48$var$writextag('Properties', null, {
            'xmlns': $b8f343bf88dacc48$var$XMLNS.CUST_PROPS,
            'xmlns:vt': $b8f343bf88dacc48$var$XMLNS.vt
        })
    ];
    if (!cp) return o.join("");
    var pid = 1;
    $b8f343bf88dacc48$var$keys(cp).forEach(function custprop(k) {
        ++pid;
        o[o.length] = $b8f343bf88dacc48$var$writextag('property', $b8f343bf88dacc48$var$write_vt(cp[k], true), {
            'fmtid': '{D5CDD505-2E9C-101B-9397-08002B2CF9AE}',
            'pid': pid,
            'name': $b8f343bf88dacc48$var$escapexml(k)
        });
    });
    if (o.length > 2) {
        o[o.length] = '</Properties>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* Common Name -> XLML Name */ var $b8f343bf88dacc48$var$XLMLDocPropsMap = {
    Title: 'Title',
    Subject: 'Subject',
    Author: 'Author',
    Keywords: 'Keywords',
    Comments: 'Description',
    LastAuthor: 'LastAuthor',
    RevNumber: 'Revision',
    Application: 'AppName',
    /* TotalTime: 'TotalTime', */ LastPrinted: 'LastPrinted',
    CreatedDate: 'Created',
    ModifiedDate: 'LastSaved',
    /* Pages */ /* Words */ /* Characters */ Category: 'Category',
    /* PresentationFormat */ Manager: 'Manager',
    Company: 'Company',
    /* Guid */ /* HyperlinkBase */ /* Bytes */ /* Lines */ /* Paragraphs */ /* CharactersWithSpaces */ AppVersion: 'Version',
    ContentStatus: 'ContentStatus',
    /* NOTE: missing from schema */ Identifier: 'Identifier',
    /* NOTE: missing from schema */ Language: 'Language' /* NOTE: missing from schema */ 
};
var $b8f343bf88dacc48$var$evert_XLMLDPM;
function $b8f343bf88dacc48$var$xlml_set_prop(Props, tag /*:string*/ , val) {
    if (!$b8f343bf88dacc48$var$evert_XLMLDPM) $b8f343bf88dacc48$var$evert_XLMLDPM = $b8f343bf88dacc48$var$evert($b8f343bf88dacc48$var$XLMLDocPropsMap);
    tag = $b8f343bf88dacc48$var$evert_XLMLDPM[tag] || tag;
    Props[tag] = val;
}
function $b8f343bf88dacc48$var$xlml_write_docprops(Props, opts) {
    var o /*:Array<string>*/  = [];
    $b8f343bf88dacc48$var$keys($b8f343bf88dacc48$var$XLMLDocPropsMap).map(function(m) {
        for(var i = 0; i < $b8f343bf88dacc48$var$CORE_PROPS.length; ++i)if ($b8f343bf88dacc48$var$CORE_PROPS[i][1] == m) return $b8f343bf88dacc48$var$CORE_PROPS[i];
        for(i = 0; i < $b8f343bf88dacc48$var$EXT_PROPS.length; ++i)if ($b8f343bf88dacc48$var$EXT_PROPS[i][1] == m) return $b8f343bf88dacc48$var$EXT_PROPS[i];
        throw m;
    }).forEach(function(p) {
        if (Props[p[1]] == null) return;
        var m = opts && opts.Props && opts.Props[p[1]] != null ? opts.Props[p[1]] : Props[p[1]];
        switch(p[2]){
            case 'date':
                m = new Date(m).toISOString().replace(/\.\d*Z/, "Z");
                break;
        }
        if (typeof m == 'number') m = String(m);
        else if (m === true || m === false) m = m ? "1" : "0";
        else if (m instanceof Date) m = new Date(m).toISOString().replace(/\.\d*Z/, "");
        o.push($b8f343bf88dacc48$var$writetag($b8f343bf88dacc48$var$XLMLDocPropsMap[p[1]] || p[1], m));
    });
    return $b8f343bf88dacc48$var$writextag('DocumentProperties', o.join(""), {
        xmlns: $b8f343bf88dacc48$var$XLMLNS.o
    });
}
function $b8f343bf88dacc48$var$xlml_write_custprops(Props, Custprops /*::, opts*/ ) {
    var BLACKLIST = [
        "Worksheets",
        "SheetNames"
    ];
    var T = 'CustomDocumentProperties';
    var o /*:Array<string>*/  = [];
    if (Props) $b8f343bf88dacc48$var$keys(Props).forEach(function(k) {
        /*:: if(!Props) return; */ if (!Object.prototype.hasOwnProperty.call(Props, k)) return;
        for(var i = 0; i < $b8f343bf88dacc48$var$CORE_PROPS.length; ++i)if (k == $b8f343bf88dacc48$var$CORE_PROPS[i][1]) return;
        for(i = 0; i < $b8f343bf88dacc48$var$EXT_PROPS.length; ++i)if (k == $b8f343bf88dacc48$var$EXT_PROPS[i][1]) return;
        for(i = 0; i < BLACKLIST.length; ++i)if (k == BLACKLIST[i]) return;
        var m = Props[k];
        var t = "string";
        if (typeof m == 'number') {
            t = "float";
            m = String(m);
        } else if (m === true || m === false) {
            t = "boolean";
            m = m ? "1" : "0";
        } else m = String(m);
        o.push($b8f343bf88dacc48$var$writextag($b8f343bf88dacc48$var$escapexmltag(k), m, {
            "dt:dt": t
        }));
    });
    if (Custprops) $b8f343bf88dacc48$var$keys(Custprops).forEach(function(k) {
        /*:: if(!Custprops) return; */ if (!Object.prototype.hasOwnProperty.call(Custprops, k)) return;
        if (Props && Object.prototype.hasOwnProperty.call(Props, k)) return;
        var m = Custprops[k];
        var t = "string";
        if (typeof m == 'number') {
            t = "float";
            m = String(m);
        } else if (m === true || m === false) {
            t = "boolean";
            m = m ? "1" : "0";
        } else if (m instanceof Date) {
            t = "dateTime.tz";
            m = m.toISOString();
        } else m = String(m);
        o.push($b8f343bf88dacc48$var$writextag($b8f343bf88dacc48$var$escapexmltag(k), m, {
            "dt:dt": t
        }));
    });
    return '<' + T + ' xmlns="' + $b8f343bf88dacc48$var$XLMLNS.o + '">' + o.join("") + '</' + T + '>';
}
/* [MS-DTYP] 2.3.3 FILETIME */ /* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */ /* [MS-OLEPS] 2.8 FILETIME (Packet Version) */ function $b8f343bf88dacc48$var$parse_FILETIME(blob) {
    var dwLowDateTime = blob.read_shift(4), dwHighDateTime = blob.read_shift(4);
    return new Date((dwHighDateTime / 1e7 * Math.pow(2, 32) + dwLowDateTime / 1e7 - 11644473600) * 1000).toISOString().replace(/\.000/, "");
}
function $b8f343bf88dacc48$var$write_FILETIME(time /*:string|Date*/ ) {
    var date = typeof time == "string" ? new Date(Date.parse(time)) : time;
    var t = date.getTime() / 1000 + 11644473600;
    var l = t % Math.pow(2, 32), h = (t - l) / Math.pow(2, 32);
    l *= 1e7;
    h *= 1e7;
    var w = l / Math.pow(2, 32) | 0;
    if (w > 0) {
        l = l % Math.pow(2, 32);
        h += w;
    }
    var o = $b8f343bf88dacc48$var$new_buf(8);
    o.write_shift(4, l);
    o.write_shift(4, h);
    return o;
}
/* [MS-OSHARED] 2.3.3.1.4 Lpstr */ function $b8f343bf88dacc48$var$parse_lpstr(blob, type, pad /*:?number*/ ) {
    var start = blob.l;
    var str = blob.read_shift(0, 'lpstr-cp');
    if (pad) while(blob.l - start & 3)++blob.l;
    return str;
}
/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */ function $b8f343bf88dacc48$var$parse_lpwstr(blob, type, pad) {
    var str = blob.read_shift(0, 'lpwstr');
    if (pad) blob.l += 4 - (str.length + 1 & 3) & 3;
    return str;
}
/* [MS-OSHARED] 2.3.3.1.11 VtString */ /* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */ function $b8f343bf88dacc48$var$parse_VtStringBase(blob, stringType, pad) {
    if (stringType === 0x1F /*VT_LPWSTR*/ ) return $b8f343bf88dacc48$var$parse_lpwstr(blob);
    return $b8f343bf88dacc48$var$parse_lpstr(blob, stringType, pad);
}
function $b8f343bf88dacc48$var$parse_VtString(blob, t /*:number*/ , pad /*:?boolean*/ ) {
    return $b8f343bf88dacc48$var$parse_VtStringBase(blob, t, pad === false ? 0 : 4);
}
function $b8f343bf88dacc48$var$parse_VtUnalignedString(blob, t /*:number*/ ) {
    if (!t) throw new Error("VtUnalignedString must have positive length");
    return $b8f343bf88dacc48$var$parse_VtStringBase(blob, t, 0);
}
/* [MS-OSHARED] 2.3.3.1.7 VtVecLpwstrValue */ function $b8f343bf88dacc48$var$parse_VtVecLpwstrValue(blob) /*:Array<string>*/ {
    var length = blob.read_shift(4);
    var ret /*:Array<string>*/  = [];
    for(var i = 0; i != length; ++i){
        var start = blob.l;
        ret[i] = blob.read_shift(0, 'lpwstr').replace($b8f343bf88dacc48$var$chr0, '');
        if (blob.l - start & 0x02) blob.l += 2;
    }
    return ret;
}
/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */ function $b8f343bf88dacc48$var$parse_VtVecUnalignedLpstrValue(blob) /*:Array<string>*/ {
    var length = blob.read_shift(4);
    var ret /*:Array<string>*/  = [];
    for(var i = 0; i != length; ++i)ret[i] = blob.read_shift(0, 'lpstr-cp').replace($b8f343bf88dacc48$var$chr0, '');
    return ret;
}
/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */ function $b8f343bf88dacc48$var$parse_VtHeadingPair(blob) {
    var start = blob.l;
    var headingString = $b8f343bf88dacc48$var$parse_TypedPropertyValue(blob, $b8f343bf88dacc48$var$VT_USTR);
    if (blob[blob.l] == 0x00 && blob[blob.l + 1] == 0x00 && blob.l - start & 0x02) blob.l += 2;
    var headerParts = $b8f343bf88dacc48$var$parse_TypedPropertyValue(blob, $b8f343bf88dacc48$var$VT_I4);
    return [
        headingString,
        headerParts
    ];
}
/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */ function $b8f343bf88dacc48$var$parse_VtVecHeadingPairValue(blob) {
    var cElements = blob.read_shift(4);
    var out = [];
    for(var i = 0; i < cElements / 2; ++i)out.push($b8f343bf88dacc48$var$parse_VtHeadingPair(blob));
    return out;
}
/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */ function $b8f343bf88dacc48$var$parse_dictionary(blob, CodePage) {
    var cnt = blob.read_shift(4);
    var dict /*:{[number]:string}*/  = {} /*:any*/ ;
    for(var j = 0; j != cnt; ++j){
        var pid = blob.read_shift(4);
        var len = blob.read_shift(4);
        dict[pid] = blob.read_shift(len, CodePage === 0x4B0 ? 'utf16le' : 'utf8').replace($b8f343bf88dacc48$var$chr0, '').replace($b8f343bf88dacc48$var$chr1, '!');
        if (CodePage === 0x4B0 && len % 2) blob.l += 2;
    }
    if (blob.l & 3) blob.l = blob.l >> 3 << 2;
    return dict;
}
/* [MS-OLEPS] 2.9 BLOB */ function $b8f343bf88dacc48$var$parse_BLOB(blob) {
    var size = blob.read_shift(4);
    var bytes = blob.slice(blob.l, blob.l + size);
    blob.l += size;
    if ((size & 3) > 0) blob.l += 4 - (size & 3) & 3;
    return bytes;
}
/* [MS-OLEPS] 2.11 ClipboardData */ function $b8f343bf88dacc48$var$parse_ClipboardData(blob) {
    // TODO
    var o = {};
    o.Size = blob.read_shift(4);
    //o.Format = blob.read_shift(4);
    blob.l += o.Size + 3 - (o.Size - 1) % 4;
    return o;
}
/* [MS-OLEPS] 2.15 TypedPropertyValue */ function $b8f343bf88dacc48$var$parse_TypedPropertyValue(blob, type /*:number*/ , _opts) /*:any*/ {
    var t = blob.read_shift(2), ret, opts = _opts || {};
    blob.l += 2;
    if (type !== $b8f343bf88dacc48$var$VT_VARIANT) {
        if (t !== type && $b8f343bf88dacc48$var$VT_CUSTOM.indexOf(type) === -1 && !((type & 0xFFFE) == 0x101E && (t & 0xFFFE) == 0x101E)) throw new Error('Expected type ' + type + ' saw ' + t);
    }
    switch(type === $b8f343bf88dacc48$var$VT_VARIANT ? t : type){
        case 0x02 /*VT_I2*/ :
            ret = blob.read_shift(2, 'i');
            if (!opts.raw) blob.l += 2;
            return ret;
        case 0x03 /*VT_I4*/ :
            ret = blob.read_shift(4, 'i');
            return ret;
        case 0x0B /*VT_BOOL*/ :
            return blob.read_shift(4) !== 0x0;
        case 0x13 /*VT_UI4*/ :
            ret = blob.read_shift(4);
            return ret;
        case 0x1E /*VT_LPSTR*/ :
            return $b8f343bf88dacc48$var$parse_lpstr(blob, t, 4).replace($b8f343bf88dacc48$var$chr0, '');
        case 0x1F /*VT_LPWSTR*/ :
            return $b8f343bf88dacc48$var$parse_lpwstr(blob);
        case 0x40 /*VT_FILETIME*/ :
            return $b8f343bf88dacc48$var$parse_FILETIME(blob);
        case 0x41 /*VT_BLOB*/ :
            return $b8f343bf88dacc48$var$parse_BLOB(blob);
        case 0x47 /*VT_CF*/ :
            return $b8f343bf88dacc48$var$parse_ClipboardData(blob);
        case 0x50 /*VT_STRING*/ :
            return $b8f343bf88dacc48$var$parse_VtString(blob, t, !opts.raw).replace($b8f343bf88dacc48$var$chr0, '');
        case 0x51 /*VT_USTR*/ :
            return $b8f343bf88dacc48$var$parse_VtUnalignedString(blob, t /*, 4*/ ).replace($b8f343bf88dacc48$var$chr0, '');
        case 0x100C /*VT_VECTOR|VT_VARIANT*/ :
            return $b8f343bf88dacc48$var$parse_VtVecHeadingPairValue(blob);
        case 0x101E /*VT_VECTOR|VT_LPSTR*/ :
        case 0x101F /*VT_VECTOR|VT_LPWSTR*/ :
            return t == 0x101F ? $b8f343bf88dacc48$var$parse_VtVecLpwstrValue(blob) : $b8f343bf88dacc48$var$parse_VtVecUnalignedLpstrValue(blob);
        default:
            throw new Error("TypedPropertyValue unrecognized type " + type + " " + t);
    }
}
function $b8f343bf88dacc48$var$write_TypedPropertyValue(type /*:number*/ , value) {
    var o = $b8f343bf88dacc48$var$new_buf(4), p = $b8f343bf88dacc48$var$new_buf(4);
    o.write_shift(4, type == 0x50 ? 0x1F : type);
    switch(type){
        case 0x03 /*VT_I4*/ :
            p.write_shift(-4, value);
            break;
        case 0x05 /*VT_I4*/ :
            p = $b8f343bf88dacc48$var$new_buf(8);
            p.write_shift(8, value, 'f');
            break;
        case 0x0B /*VT_BOOL*/ :
            p.write_shift(4, value ? 0x01 : 0x00);
            break;
        case 0x40 /*VT_FILETIME*/ :
            /*:: if(typeof value !== "string" && !(value instanceof Date)) throw "unreachable"; */ p = $b8f343bf88dacc48$var$write_FILETIME(value);
            break;
        case 0x1F /*VT_LPWSTR*/ :
        case 0x50 /*VT_STRING*/ :
            /*:: if(typeof value !== "string") throw "unreachable"; */ p = $b8f343bf88dacc48$var$new_buf(4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
            p.write_shift(4, value.length + 1);
            p.write_shift(0, value, "dbcs");
            while(p.l != p.length)p.write_shift(1, 0);
            break;
        default:
            throw new Error("TypedPropertyValue unrecognized type " + type + " " + value);
    }
    return $b8f343bf88dacc48$var$bconcat([
        o,
        p
    ]);
}
/* [MS-OLEPS] 2.20 PropertySet */ function $b8f343bf88dacc48$var$parse_PropertySet(blob, PIDSI) {
    var start_addr = blob.l;
    var size = blob.read_shift(4);
    var NumProps = blob.read_shift(4);
    var Props = [], i = 0;
    var CodePage = 0;
    var Dictionary = -1, DictObj /*:{[number]:string}*/  = {} /*:any*/ ;
    for(i = 0; i != NumProps; ++i){
        var PropID = blob.read_shift(4);
        var Offset = blob.read_shift(4);
        Props[i] = [
            PropID,
            Offset + start_addr
        ];
    }
    Props.sort(function(x, y) {
        return x[1] - y[1];
    });
    var PropH = {};
    for(i = 0; i != NumProps; ++i){
        if (blob.l !== Props[i][1]) {
            var fail = true;
            if (i > 0 && PIDSI) switch(PIDSI[Props[i - 1][0]].t){
                case 0x02 /*VT_I2*/ :
                    if (blob.l + 2 === Props[i][1]) {
                        blob.l += 2;
                        fail = false;
                    }
                    break;
                case 0x50 /*VT_STRING*/ :
                    if (blob.l <= Props[i][1]) {
                        blob.l = Props[i][1];
                        fail = false;
                    }
                    break;
                case 0x100C /*VT_VECTOR|VT_VARIANT*/ :
                    if (blob.l <= Props[i][1]) {
                        blob.l = Props[i][1];
                        fail = false;
                    }
                    break;
            }
            if ((!PIDSI || i == 0) && blob.l <= Props[i][1]) {
                fail = false;
                blob.l = Props[i][1];
            }
            if (fail) throw new Error("Read Error: Expected address " + Props[i][1] + ' at ' + blob.l + ' :' + i);
        }
        if (PIDSI) {
            if (Props[i][0] == 0 && Props.length > i + 1 && Props[i][1] == Props[i + 1][1]) continue; // R9
            var piddsi = PIDSI[Props[i][0]];
            PropH[piddsi.n] = $b8f343bf88dacc48$var$parse_TypedPropertyValue(blob, piddsi.t, {
                raw: true
            });
            if (piddsi.p === 'version') PropH[piddsi.n] = String(PropH[piddsi.n] >> 16) + "." + ("0000" + String(PropH[piddsi.n] & 0xFFFF)).slice(-4);
            if (piddsi.n == "CodePage") switch(PropH[piddsi.n]){
                case 0:
                    PropH[piddsi.n] = 1252;
                /* falls through */ case 874:
                case 932:
                case 936:
                case 949:
                case 950:
                case 1250:
                case 1251:
                case 1253:
                case 1254:
                case 1255:
                case 1256:
                case 1257:
                case 1258:
                case 10000:
                case 1200:
                case 1201:
                case 1252:
                case 65000:
                case -536:
                case 65001:
                case -535:
                    $b8f343bf88dacc48$var$set_cp(CodePage = PropH[piddsi.n] >>> 0 & 0xFFFF);
                    break;
                default:
                    throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
            }
        } else {
            if (Props[i][0] === 0x1) {
                CodePage = PropH.CodePage = $b8f343bf88dacc48$var$parse_TypedPropertyValue(blob, $b8f343bf88dacc48$var$VT_I2);
                $b8f343bf88dacc48$var$set_cp(CodePage);
                if (Dictionary !== -1) {
                    var oldpos = blob.l;
                    blob.l = Props[Dictionary][1];
                    DictObj = $b8f343bf88dacc48$var$parse_dictionary(blob, CodePage);
                    blob.l = oldpos;
                }
            } else if (Props[i][0] === 0) {
                if (CodePage === 0) {
                    Dictionary = i;
                    blob.l = Props[i + 1][1];
                    continue;
                }
                DictObj = $b8f343bf88dacc48$var$parse_dictionary(blob, CodePage);
            } else {
                var name = DictObj[Props[i][0]];
                var val;
                /* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */ switch(blob[blob.l]){
                    case 0x41 /*VT_BLOB*/ :
                        blob.l += 4;
                        val = $b8f343bf88dacc48$var$parse_BLOB(blob);
                        break;
                    case 0x1E /*VT_LPSTR*/ :
                        blob.l += 4;
                        val = $b8f343bf88dacc48$var$parse_VtString(blob, blob[blob.l - 4]).replace(/(^|[^\u0000])\u0000+$/, "$1");
                        break;
                    case 0x1F /*VT_LPWSTR*/ :
                        blob.l += 4;
                        val = $b8f343bf88dacc48$var$parse_VtString(blob, blob[blob.l - 4]).replace(/(^|[^\u0000])\u0000+$/, "$1");
                        break;
                    case 0x03 /*VT_I4*/ :
                        blob.l += 4;
                        val = blob.read_shift(4, 'i');
                        break;
                    case 0x13 /*VT_UI4*/ :
                        blob.l += 4;
                        val = blob.read_shift(4);
                        break;
                    case 0x05 /*VT_R8*/ :
                        blob.l += 4;
                        val = blob.read_shift(8, 'f');
                        break;
                    case 0x0B /*VT_BOOL*/ :
                        blob.l += 4;
                        val = $b8f343bf88dacc48$var$parsebool(blob, 4);
                        break;
                    case 0x40 /*VT_FILETIME*/ :
                        blob.l += 4;
                        val = $b8f343bf88dacc48$var$parseDate($b8f343bf88dacc48$var$parse_FILETIME(blob));
                        break;
                    default:
                        throw new Error("unparsed value: " + blob[blob.l]);
                }
                PropH[name] = val;
            }
        }
    }
    blob.l = start_addr + size; /* step ahead to skip padding */ 
    return PropH;
}
var $b8f343bf88dacc48$var$XLSPSSkip = [
    "CodePage",
    "Thumbnail",
    "_PID_LINKBASE",
    "_PID_HLINKS",
    "SystemIdentifier",
    "FMTID"
];
function $b8f343bf88dacc48$var$guess_property_type(val /*:any*/ ) /*:number*/ {
    switch(typeof val){
        case "boolean":
            return 0x0B;
        case "number":
            return (val | 0) == val ? 0x03 : 0x05;
        case "string":
            return 0x1F;
        case "object":
            if (val instanceof Date) return 0x40;
            break;
    }
    return -1;
}
function $b8f343bf88dacc48$var$write_PropertySet(entries, RE, PIDSI) {
    var hdr = $b8f343bf88dacc48$var$new_buf(8), piao = [], prop = [];
    var sz = 8, i = 0;
    var pr = $b8f343bf88dacc48$var$new_buf(8), pio = $b8f343bf88dacc48$var$new_buf(8);
    pr.write_shift(4, 0x0002);
    pr.write_shift(4, 0x04B0);
    pio.write_shift(4, 0x0001);
    prop.push(pr);
    piao.push(pio);
    sz += 8 + pr.length;
    if (!RE) {
        pio = $b8f343bf88dacc48$var$new_buf(8);
        pio.write_shift(4, 0);
        piao.unshift(pio);
        var bufs = [
            $b8f343bf88dacc48$var$new_buf(4)
        ];
        bufs[0].write_shift(4, entries.length);
        for(i = 0; i < entries.length; ++i){
            var value = entries[i][0];
            pr = $b8f343bf88dacc48$var$new_buf(8 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
            pr.write_shift(4, i + 2);
            pr.write_shift(4, value.length + 1);
            pr.write_shift(0, value, "dbcs");
            while(pr.l != pr.length)pr.write_shift(1, 0);
            bufs.push(pr);
        }
        pr = $b8f343bf88dacc48$var$bconcat(bufs);
        prop.unshift(pr);
        sz += 8 + pr.length;
    }
    for(i = 0; i < entries.length; ++i){
        if (RE && !RE[entries[i][0]]) continue;
        if ($b8f343bf88dacc48$var$XLSPSSkip.indexOf(entries[i][0]) > -1 || $b8f343bf88dacc48$var$PseudoPropsPairs.indexOf(entries[i][0]) > -1) continue;
        if (entries[i][1] == null) continue;
        var val = entries[i][1], idx = 0;
        if (RE) {
            idx = +RE[entries[i][0]];
            var pinfo = PIDSI /*:: || {}*/ [idx] /*:: || {} */ ;
            if (pinfo.p == "version" && typeof val == "string") {
                /*:: if(typeof val !== "string") throw "unreachable"; */ var arr = val.split(".");
                val = (+arr[0] << 16) + (+arr[1] || 0);
            }
            pr = $b8f343bf88dacc48$var$write_TypedPropertyValue(pinfo.t, val);
        } else {
            var T = $b8f343bf88dacc48$var$guess_property_type(val);
            if (T == -1) {
                T = 0x1F;
                val = String(val);
            }
            pr = $b8f343bf88dacc48$var$write_TypedPropertyValue(T, val);
        }
        prop.push(pr);
        pio = $b8f343bf88dacc48$var$new_buf(8);
        pio.write_shift(4, !RE ? 2 + i : idx);
        piao.push(pio);
        sz += 8 + pr.length;
    }
    var w = 8 * (prop.length + 1);
    for(i = 0; i < prop.length; ++i){
        piao[i].write_shift(4, w);
        w += prop[i].length;
    }
    hdr.write_shift(4, sz);
    hdr.write_shift(4, prop.length);
    return $b8f343bf88dacc48$var$bconcat([
        hdr
    ].concat(piao).concat(prop));
}
/* [MS-OLEPS] 2.21 PropertySetStream */ function $b8f343bf88dacc48$var$parse_PropertySetStream(file, PIDSI, clsid) {
    var blob = file.content;
    if (!blob) return {} /*:any*/ ;
    $b8f343bf88dacc48$var$prep_blob(blob, 0);
    var NumSets, FMTID0, FMTID1, Offset0, Offset1 = 0;
    blob.chk('feff', 'Byte Order: ');
    /*var vers = */ blob.read_shift(2); // TODO: check version
    var SystemIdentifier = blob.read_shift(4);
    var CLSID = blob.read_shift(16);
    if (CLSID !== $b8f343bf88dacc48$export$9f0e51cd97c572a.utils.consts.HEADER_CLSID && CLSID !== clsid) throw new Error("Bad PropertySet CLSID " + CLSID);
    NumSets = blob.read_shift(4);
    if (NumSets !== 1 && NumSets !== 2) throw new Error("Unrecognized #Sets: " + NumSets);
    FMTID0 = blob.read_shift(16);
    Offset0 = blob.read_shift(4);
    if (NumSets === 1 && Offset0 !== blob.l) throw new Error("Length mismatch: " + Offset0 + " !== " + blob.l);
    else if (NumSets === 2) {
        FMTID1 = blob.read_shift(16);
        Offset1 = blob.read_shift(4);
    }
    var PSet0 = $b8f343bf88dacc48$var$parse_PropertySet(blob, PIDSI);
    var rval = {
        SystemIdentifier: SystemIdentifier
    } /*:any*/ ;
    for(var y in PSet0)rval[y] = PSet0[y];
    //rval.blob = blob;
    rval.FMTID = FMTID0;
    //rval.PSet0 = PSet0;
    if (NumSets === 1) return rval;
    if (Offset1 - blob.l == 2) blob.l += 2;
    if (blob.l !== Offset1) throw new Error("Length mismatch 2: " + blob.l + " !== " + Offset1);
    var PSet1;
    try {
        PSet1 = $b8f343bf88dacc48$var$parse_PropertySet(blob, null);
    } catch (e) {}
    for(y in PSet1)rval[y] = PSet1[y];
    rval.FMTID = [
        FMTID0,
        FMTID1
    ]; // TODO: verify FMTID0/1
    return rval;
}
function $b8f343bf88dacc48$var$write_PropertySetStream(entries, clsid, RE, PIDSI /*:{[key:string|number]:any}*/ , entries2 /*:?any*/ , clsid2 /*:?any*/ ) {
    var hdr = $b8f343bf88dacc48$var$new_buf(entries2 ? 68 : 48);
    var bufs = [
        hdr
    ];
    hdr.write_shift(2, 0xFFFE);
    hdr.write_shift(2, 0x0000); /* TODO: type 1 props */ 
    hdr.write_shift(4, 0x32363237);
    hdr.write_shift(16, $b8f343bf88dacc48$export$9f0e51cd97c572a.utils.consts.HEADER_CLSID, "hex");
    hdr.write_shift(4, entries2 ? 2 : 1);
    hdr.write_shift(16, clsid, "hex");
    hdr.write_shift(4, entries2 ? 68 : 48);
    var ps0 = $b8f343bf88dacc48$var$write_PropertySet(entries, RE, PIDSI);
    bufs.push(ps0);
    if (entries2) {
        var ps1 = $b8f343bf88dacc48$var$write_PropertySet(entries2, null, null);
        hdr.write_shift(16, clsid2, "hex");
        hdr.write_shift(4, 68 + ps0.length);
        bufs.push(ps1);
    }
    return $b8f343bf88dacc48$var$bconcat(bufs);
}
function $b8f343bf88dacc48$var$parsenoop2(blob, length) {
    blob.read_shift(length);
    return null;
}
function $b8f343bf88dacc48$var$writezeroes(n, o) {
    if (!o) o = $b8f343bf88dacc48$var$new_buf(n);
    for(var j = 0; j < n; ++j)o.write_shift(1, 0);
    return o;
}
function $b8f343bf88dacc48$var$parslurp(blob, length, cb) {
    var arr = [], target = blob.l + length;
    while(blob.l < target)arr.push(cb(blob, target - blob.l));
    if (target !== blob.l) throw new Error("Slurp error");
    return arr;
}
function $b8f343bf88dacc48$var$parsebool(blob, length /*:number*/ ) {
    return blob.read_shift(length) === 0x1;
}
function $b8f343bf88dacc48$var$writebool(v /*:any*/ , o) {
    if (!o) o = $b8f343bf88dacc48$var$new_buf(2);
    o.write_shift(2, +!!v);
    return o;
}
function $b8f343bf88dacc48$var$parseuint16(blob /*::, length:?number, opts:?any*/ ) {
    return blob.read_shift(2, 'u');
}
function $b8f343bf88dacc48$var$writeuint16(v /*:number*/ , o) {
    if (!o) o = $b8f343bf88dacc48$var$new_buf(2);
    o.write_shift(2, v);
    return o;
}
function $b8f343bf88dacc48$var$parseuint16a(blob, length /*:: :?number, opts:?any*/ ) {
    return $b8f343bf88dacc48$var$parslurp(blob, length, $b8f343bf88dacc48$var$parseuint16);
}
/* --- 2.5 Structures --- */ /* [MS-XLS] 2.5.10 Bes (boolean or error) */ function $b8f343bf88dacc48$var$parse_Bes(blob /*::, length*/ ) {
    var v = blob.read_shift(1), t = blob.read_shift(1);
    return t === 0x01 ? v : v === 0x01;
}
function $b8f343bf88dacc48$var$write_Bes(v, t /*:string*/ , o) {
    if (!o) o = $b8f343bf88dacc48$var$new_buf(2);
    o.write_shift(1, t == 'e' ? +v : +!!v);
    o.write_shift(1, t == 'e' ? 1 : 0);
    return o;
}
/* [MS-XLS] 2.5.240 ShortXLUnicodeString */ function $b8f343bf88dacc48$var$parse_ShortXLUnicodeString(blob, length, opts) {
    var cch = blob.read_shift(opts && opts.biff >= 12 ? 2 : 1);
    var encoding = 'sbcs-cont';
    var cp = $b8f343bf88dacc48$var$current_codepage;
    if (opts && opts.biff >= 8) $b8f343bf88dacc48$var$current_codepage = 1200;
    if (!opts || opts.biff == 8) {
        var fHighByte = blob.read_shift(1);
        if (fHighByte) encoding = 'dbcs-cont';
    } else if (opts.biff == 12) encoding = 'wstr';
    if (opts.biff >= 2 && opts.biff <= 5) encoding = 'cpstr';
    var o = cch ? blob.read_shift(cch, encoding) : "";
    $b8f343bf88dacc48$var$current_codepage = cp;
    return o;
}
/* 2.5.293 XLUnicodeRichExtendedString */ function $b8f343bf88dacc48$var$parse_XLUnicodeRichExtendedString(blob) {
    var cp = $b8f343bf88dacc48$var$current_codepage;
    $b8f343bf88dacc48$var$current_codepage = 1200;
    var cch = blob.read_shift(2), flags = blob.read_shift(1);
    var /*fHighByte = flags & 0x1,*/ fExtSt = flags & 0x4, fRichSt = flags & 0x8;
    var width = 1 + (flags & 0x1); // 0x0 -> utf8, 0x1 -> dbcs
    var cRun = 0, cbExtRst;
    var z = {};
    if (fRichSt) cRun = blob.read_shift(2);
    if (fExtSt) cbExtRst = blob.read_shift(4);
    var encoding = width == 2 ? 'dbcs-cont' : 'sbcs-cont';
    var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
    if (fRichSt) blob.l += 4 * cRun; //TODO: parse this
    if (fExtSt) blob.l += cbExtRst; //TODO: parse this
    z.t = msg;
    if (!fRichSt) {
        z.raw = "<t>" + z.t + "</t>";
        z.r = z.t;
    }
    $b8f343bf88dacc48$var$current_codepage = cp;
    return z;
}
function $b8f343bf88dacc48$var$write_XLUnicodeRichExtendedString(xlstr /*:: :XLString, opts*/ ) {
    var str = xlstr.t || "", nfmts = 1;
    var hdr = $b8f343bf88dacc48$var$new_buf(3 + (nfmts > 1 ? 2 : 0));
    hdr.write_shift(2, str.length);
    hdr.write_shift(1, (nfmts > 1 ? 0x08 : 0x00) | 0x01);
    if (nfmts > 1) hdr.write_shift(2, nfmts);
    var otext = $b8f343bf88dacc48$var$new_buf(2 * str.length);
    otext.write_shift(2 * str.length, str, 'utf16le');
    var out = [
        hdr,
        otext
    ];
    return $b8f343bf88dacc48$var$bconcat(out);
}
/* 2.5.296 XLUnicodeStringNoCch */ function $b8f343bf88dacc48$var$parse_XLUnicodeStringNoCch(blob, cch, opts) {
    var retval;
    if (opts) {
        if (opts.biff >= 2 && opts.biff <= 5) return blob.read_shift(cch, 'cpstr');
        if (opts.biff >= 12) return blob.read_shift(cch, 'dbcs-cont');
    }
    var fHighByte = blob.read_shift(1);
    if (fHighByte === 0) retval = blob.read_shift(cch, 'sbcs-cont');
    else retval = blob.read_shift(cch, 'dbcs-cont');
    return retval;
}
/* 2.5.294 XLUnicodeString */ function $b8f343bf88dacc48$var$parse_XLUnicodeString(blob, length, opts) {
    var cch = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return $b8f343bf88dacc48$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
}
/* BIFF5 override */ function $b8f343bf88dacc48$var$parse_XLUnicodeString2(blob, length, opts) {
    if (opts.biff > 5) return $b8f343bf88dacc48$var$parse_XLUnicodeString(blob, length, opts);
    var cch = blob.read_shift(1);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return blob.read_shift(cch, opts.biff <= 4 || !blob.lens ? 'cpstr' : 'sbcs-cont');
}
/* TODO: BIFF5 and lower, codepage awareness */ function $b8f343bf88dacc48$var$write_XLUnicodeString(str, opts, o) {
    if (!o) o = $b8f343bf88dacc48$var$new_buf(3 + 2 * str.length);
    o.write_shift(2, str.length);
    o.write_shift(1, 1);
    o.write_shift(31, str, 'utf16le');
    return o;
}
/* [MS-XLS] 2.5.61 ControlInfo */ function $b8f343bf88dacc48$var$parse_ControlInfo(blob /*::, length, opts*/ ) {
    var flags = blob.read_shift(1);
    blob.l++;
    var accel = blob.read_shift(2);
    blob.l += 2;
    return [
        flags,
        accel
    ];
}
/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */ function $b8f343bf88dacc48$var$parse_URLMoniker(blob /*::, length, opts*/ ) {
    var len = blob.read_shift(4), start = blob.l;
    var extra = false;
    if (len > 24) {
        /* look ahead */ blob.l += len - 24;
        if (blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") extra = true;
        blob.l = start;
    }
    var url = blob.read_shift((extra ? len - 24 : len) >> 1, 'utf16le').replace($b8f343bf88dacc48$var$chr0, "");
    if (extra) blob.l += 24;
    return url;
}
/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */ function $b8f343bf88dacc48$var$parse_FileMoniker(blob /*::, length*/ ) {
    var cAnti = blob.read_shift(2);
    var preamble = "";
    while(cAnti-- > 0)preamble += "../";
    var ansiPath = blob.read_shift(0, 'lpstr-ansi');
    blob.l += 2; //var endServer = blob.read_shift(2);
    if (blob.read_shift(2) != 0xDEAD) throw new Error("Bad FileMoniker");
    var sz = blob.read_shift(4);
    if (sz === 0) return preamble + ansiPath.replace(/\\/g, "/");
    var bytes = blob.read_shift(4);
    if (blob.read_shift(2) != 3) throw new Error("Bad FileMoniker");
    var unicodePath = blob.read_shift(bytes >> 1, 'utf16le').replace($b8f343bf88dacc48$var$chr0, "");
    return preamble + unicodePath;
}
/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */ function $b8f343bf88dacc48$var$parse_HyperlinkMoniker(blob, length) {
    var clsid = blob.read_shift(16);
    length -= 16;
    switch(clsid){
        case "e0c9ea79f9bace118c8200aa004ba90b":
            return $b8f343bf88dacc48$var$parse_URLMoniker(blob, length);
        case "0303000000000000c000000000000046":
            return $b8f343bf88dacc48$var$parse_FileMoniker(blob, length);
        default:
            throw new Error("Unsupported Moniker " + clsid);
    }
}
/* [MS-OSHARED] 2.3.7.9 HyperlinkString */ function $b8f343bf88dacc48$var$parse_HyperlinkString(blob /*::, length*/ ) {
    var len = blob.read_shift(4);
    var o = len > 0 ? blob.read_shift(len, 'utf16le').replace($b8f343bf88dacc48$var$chr0, "") : "";
    return o;
}
function $b8f343bf88dacc48$var$write_HyperlinkString(str /*:string*/ , o) {
    if (!o) o = $b8f343bf88dacc48$var$new_buf(6 + str.length * 2);
    o.write_shift(4, 1 + str.length);
    for(var i = 0; i < str.length; ++i)o.write_shift(2, str.charCodeAt(i));
    o.write_shift(2, 0);
    return o;
}
/* [MS-OSHARED] 2.3.7.1 Hyperlink Object */ function $b8f343bf88dacc48$var$parse_Hyperlink(blob, length) /*:Hyperlink*/ {
    var end = blob.l + length;
    var sVer = blob.read_shift(4);
    if (sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
    var flags = blob.read_shift(2);
    blob.l += 2;
    var displayName, targetFrameName, moniker, oleMoniker, Loc = "", guid, fileTime;
    if (flags & 0x0010) displayName = $b8f343bf88dacc48$var$parse_HyperlinkString(blob, end - blob.l);
    if (flags & 0x0080) targetFrameName = $b8f343bf88dacc48$var$parse_HyperlinkString(blob, end - blob.l);
    if ((flags & 0x0101) === 0x0101) moniker = $b8f343bf88dacc48$var$parse_HyperlinkString(blob, end - blob.l);
    if ((flags & 0x0101) === 0x0001) oleMoniker = $b8f343bf88dacc48$var$parse_HyperlinkMoniker(blob, end - blob.l);
    if (flags & 0x0008) Loc = $b8f343bf88dacc48$var$parse_HyperlinkString(blob, end - blob.l);
    if (flags & 0x0020) guid = blob.read_shift(16);
    if (flags & 0x0040) fileTime = $b8f343bf88dacc48$var$parse_FILETIME(blob /*, 8*/ );
    blob.l = end;
    var target = targetFrameName || moniker || oleMoniker || "";
    if (target && Loc) target += "#" + Loc;
    if (!target) target = "#" + Loc;
    if (flags & 0x0002 && target.charAt(0) == "/" && target.charAt(1) != "/") target = "file://" + target;
    var out = {
        Target: target
    } /*:any*/ ;
    if (guid) out.guid = guid;
    if (fileTime) out.time = fileTime;
    if (displayName) out.Tooltip = displayName;
    return out;
}
function $b8f343bf88dacc48$var$write_Hyperlink(hl) {
    var out = $b8f343bf88dacc48$var$new_buf(512), i = 0;
    var Target = hl.Target;
    if (Target.slice(0, 7) == "file://") Target = Target.slice(7);
    var hashidx = Target.indexOf("#");
    var F = hashidx > -1 ? 0x1f : 0x17;
    switch(Target.charAt(0)){
        case "#":
            F = 0x1c;
            break;
        case ".":
            F &= -3;
            break;
    }
    out.write_shift(4, 2);
    out.write_shift(4, F);
    var data = [
        8,
        6815827,
        6619237,
        4849780,
        83
    ];
    for(i = 0; i < data.length; ++i)out.write_shift(4, data[i]);
    if (F == 0x1C) {
        Target = Target.slice(1);
        $b8f343bf88dacc48$var$write_HyperlinkString(Target, out);
    } else if (F & 0x02) {
        data = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
        for(i = 0; i < data.length; ++i)out.write_shift(1, parseInt(data[i], 16));
        var Pretarget = hashidx > -1 ? Target.slice(0, hashidx) : Target;
        out.write_shift(4, 2 * (Pretarget.length + 1));
        for(i = 0; i < Pretarget.length; ++i)out.write_shift(2, Pretarget.charCodeAt(i));
        out.write_shift(2, 0);
        if (F & 0x08) $b8f343bf88dacc48$var$write_HyperlinkString(hashidx > -1 ? Target.slice(hashidx + 1) : "", out);
    } else {
        data = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");
        for(i = 0; i < data.length; ++i)out.write_shift(1, parseInt(data[i], 16));
        var P = 0;
        while(Target.slice(P * 3, P * 3 + 3) == "../" || Target.slice(P * 3, P * 3 + 3) == "..\\")++P;
        out.write_shift(2, P);
        out.write_shift(4, Target.length - 3 * P + 1);
        for(i = 0; i < Target.length - 3 * P; ++i)out.write_shift(1, Target.charCodeAt(i + 3 * P) & 0xFF);
        out.write_shift(1, 0);
        out.write_shift(2, 0xFFFF);
        out.write_shift(2, 0xDEAD);
        for(i = 0; i < 6; ++i)out.write_shift(4, 0);
    }
    return out.slice(0, out.l);
}
/* 2.5.178 LongRGBA */ function $b8f343bf88dacc48$var$parse_LongRGBA(blob /*::, length*/ ) {
    var r = blob.read_shift(1), g = blob.read_shift(1), b = blob.read_shift(1), a = blob.read_shift(1);
    return [
        r,
        g,
        b,
        a
    ];
}
/* 2.5.177 LongRGB */ function $b8f343bf88dacc48$var$parse_LongRGB(blob, length) {
    var x = $b8f343bf88dacc48$var$parse_LongRGBA(blob, length);
    x[3] = 0;
    return x;
}
/* [MS-XLS] 2.5.19 */ function $b8f343bf88dacc48$var$parse_XLSCell(blob, length, opts) /*:Cell*/ {
    var rw = blob.read_shift(2); // 0-indexed
    var col = blob.read_shift(2);
    var ret = {
        r: rw,
        c: col,
        ixfe: 0
    } /*:any*/ ;
    if (opts && opts.biff == 2 || length == 7) {
        /* TODO: pass back flags */ var flags = blob.read_shift(1);
        ret.ixfe = flags & 0x3F;
        blob.l += 2;
    /*
		var ifntifmt = blob.read_shift(1);
		var ifmt = ifntifmt & 0x3f, ifnt = ifntifmt >> 6;
		var flags3 = blob.read_shift(1);
		*/ } else ret.ixfe = blob.read_shift(2);
    return ret;
}
function $b8f343bf88dacc48$var$write_XLSCell(R /*:number*/ , C /*:number*/ , ixfe /*:?number*/ , o) {
    if (!o) o = $b8f343bf88dacc48$var$new_buf(6);
    o.write_shift(2, R);
    o.write_shift(2, C);
    o.write_shift(2, ixfe || 0);
    return o;
}
/* [MS-XLS] 2.5.134 */ function $b8f343bf88dacc48$var$parse_frtHeader(blob) {
    var rt = blob.read_shift(2);
    var flags = blob.read_shift(2); // TODO: parse these flags
    blob.l += 8;
    return {
        type: rt,
        flags: flags
    };
}
function $b8f343bf88dacc48$var$parse_OptXLUnicodeString(blob, length, opts) {
    return length === 0 ? "" : $b8f343bf88dacc48$var$parse_XLUnicodeString2(blob, length, opts);
}
/* [MS-XLS] 2.5.344 */ function $b8f343bf88dacc48$var$parse_XTI(blob, length, opts) {
    var w = opts.biff > 8 ? 4 : 2;
    var iSupBook = blob.read_shift(w), itabFirst = blob.read_shift(w, 'i'), itabLast = blob.read_shift(w, 'i');
    return [
        iSupBook,
        itabFirst,
        itabLast
    ];
}
/* [MS-XLS] 2.5.218 */ function $b8f343bf88dacc48$var$parse_RkRec(blob) {
    var ixfe = blob.read_shift(2);
    var RK = $b8f343bf88dacc48$var$parse_RkNumber(blob);
    return [
        ixfe,
        RK
    ];
}
/* [MS-XLS] 2.5.1 */ function $b8f343bf88dacc48$var$parse_AddinUdf(blob, length, opts) {
    blob.l += 4;
    length -= 4;
    var l = blob.l + length;
    var udfName = $b8f343bf88dacc48$var$parse_ShortXLUnicodeString(blob, length, opts);
    var cb = blob.read_shift(2);
    l -= blob.l;
    if (cb !== l) throw new Error("Malformed AddinUdf: padding = " + l + " != " + cb);
    blob.l += cb;
    return udfName;
}
/* [MS-XLS] 2.5.209 TODO: Check sizes */ function $b8f343bf88dacc48$var$parse_Ref8U(blob /*::, length*/ ) {
    var rwFirst = blob.read_shift(2);
    var rwLast = blob.read_shift(2);
    var colFirst = blob.read_shift(2);
    var colLast = blob.read_shift(2);
    return {
        s: {
            c: colFirst,
            r: rwFirst
        },
        e: {
            c: colLast,
            r: rwLast
        }
    };
}
function $b8f343bf88dacc48$var$write_Ref8U(r /*:Range*/ , o) {
    if (!o) o = $b8f343bf88dacc48$var$new_buf(8);
    o.write_shift(2, r.s.r);
    o.write_shift(2, r.e.r);
    o.write_shift(2, r.s.c);
    o.write_shift(2, r.e.c);
    return o;
}
/* [MS-XLS] 2.5.211 */ function $b8f343bf88dacc48$var$parse_RefU(blob /*::, length*/ ) {
    var rwFirst = blob.read_shift(2);
    var rwLast = blob.read_shift(2);
    var colFirst = blob.read_shift(1);
    var colLast = blob.read_shift(1);
    return {
        s: {
            c: colFirst,
            r: rwFirst
        },
        e: {
            c: colLast,
            r: rwLast
        }
    };
}
/* [MS-XLS] 2.5.207 */ var $b8f343bf88dacc48$var$parse_Ref = $b8f343bf88dacc48$var$parse_RefU;
/* [MS-XLS] 2.5.143 */ function $b8f343bf88dacc48$var$parse_FtCmo(blob /*::, length*/ ) {
    blob.l += 4;
    var ot = blob.read_shift(2);
    var id = blob.read_shift(2);
    var flags = blob.read_shift(2);
    blob.l += 12;
    return [
        id,
        ot,
        flags
    ];
}
/* [MS-XLS] 2.5.149 */ function $b8f343bf88dacc48$var$parse_FtNts(blob) {
    var out = {};
    blob.l += 4;
    blob.l += 16; // GUID TODO
    out.fSharedNote = blob.read_shift(2);
    blob.l += 4;
    return out;
}
/* [MS-XLS] 2.5.142 */ function $b8f343bf88dacc48$var$parse_FtCf(blob) {
    var out = {};
    blob.l += 4;
    blob.cf = blob.read_shift(2);
    return out;
}
/* [MS-XLS] 2.5.140 - 2.5.154 and friends */ function $b8f343bf88dacc48$var$parse_FtSkip(blob) {
    blob.l += 2;
    blob.l += blob.read_shift(2);
}
var $b8f343bf88dacc48$var$FtTab = {
    0x00: $b8f343bf88dacc48$var$parse_FtSkip,
    /* FtEnd */ 0x04: $b8f343bf88dacc48$var$parse_FtSkip,
    /* FtMacro */ 0x05: $b8f343bf88dacc48$var$parse_FtSkip,
    /* FtButton */ 0x06: $b8f343bf88dacc48$var$parse_FtSkip,
    /* FtGmo */ 0x07: $b8f343bf88dacc48$var$parse_FtCf,
    /* FtCf */ 0x08: $b8f343bf88dacc48$var$parse_FtSkip,
    /* FtPioGrbit */ 0x09: $b8f343bf88dacc48$var$parse_FtSkip,
    /* FtPictFmla */ 0x0A: $b8f343bf88dacc48$var$parse_FtSkip,
    /* FtCbls */ 0x0B: $b8f343bf88dacc48$var$parse_FtSkip,
    /* FtRbo */ 0x0C: $b8f343bf88dacc48$var$parse_FtSkip,
    /* FtSbs */ 0x0D: $b8f343bf88dacc48$var$parse_FtNts,
    /* FtNts */ 0x0E: $b8f343bf88dacc48$var$parse_FtSkip,
    /* FtSbsFmla */ 0x0F: $b8f343bf88dacc48$var$parse_FtSkip,
    /* FtGboData */ 0x10: $b8f343bf88dacc48$var$parse_FtSkip,
    /* FtEdoData */ 0x11: $b8f343bf88dacc48$var$parse_FtSkip,
    /* FtRboData */ 0x12: $b8f343bf88dacc48$var$parse_FtSkip,
    /* FtCblsData */ 0x13: $b8f343bf88dacc48$var$parse_FtSkip,
    /* FtLbsData */ 0x14: $b8f343bf88dacc48$var$parse_FtSkip,
    /* FtCblsFmla */ 0x15: $b8f343bf88dacc48$var$parse_FtCmo
};
function $b8f343bf88dacc48$var$parse_FtArray(blob, length /*::, ot*/ ) {
    var tgt = blob.l + length;
    var fts = [];
    while(blob.l < tgt){
        var ft = blob.read_shift(2);
        blob.l -= 2;
        try {
            fts[ft] = $b8f343bf88dacc48$var$FtTab[ft](blob, tgt - blob.l);
        } catch (e) {
            blob.l = tgt;
            return fts;
        }
    }
    if (blob.l != tgt) blob.l = tgt; //throw new Error("bad Object Ft-sequence");
    return fts;
}
/* --- 2.4 Records --- */ /* [MS-XLS] 2.4.21 */ function $b8f343bf88dacc48$var$parse_BOF(blob, length) {
    var o = {
        BIFFVer: 0,
        dt: 0
    };
    o.BIFFVer = blob.read_shift(2);
    length -= 2;
    if (length >= 2) {
        o.dt = blob.read_shift(2);
        blob.l -= 2;
    }
    switch(o.BIFFVer){
        case 0x0600:
        /* BIFF8 */ case 0x0500:
        /* BIFF5 */ case 0x0400:
        /* BIFF4 */ case 0x0300:
        /* BIFF3 */ case 0x0200:
        /* BIFF2 */ case 0x0002:
        case 0x0007:
            break;
        default:
            if (length > 6) throw new Error("Unexpected BIFF Ver " + o.BIFFVer);
    }
    blob.read_shift(length);
    return o;
}
function $b8f343bf88dacc48$var$write_BOF(wb /*:Workbook*/ , t /*:number*/ , o) {
    var h = 0x0600, w = 16;
    switch(o.bookType){
        case 'biff8':
            break;
        case 'biff5':
            h = 0x0500;
            w = 8;
            break;
        case 'biff4':
            h = 0x0004;
            w = 6;
            break;
        case 'biff3':
            h = 0x0003;
            w = 6;
            break;
        case 'biff2':
            h = 0x0002;
            w = 4;
            break;
        case 'xla':
            break;
        default:
            throw new Error("unsupported BIFF version");
    }
    var out = $b8f343bf88dacc48$var$new_buf(w);
    out.write_shift(2, h);
    out.write_shift(2, t);
    if (w > 4) out.write_shift(2, 0x7262);
    if (w > 6) out.write_shift(2, 0x07CD);
    if (w > 8) {
        out.write_shift(2, 0xC009);
        out.write_shift(2, 0x0001);
        out.write_shift(2, 0x0706);
        out.write_shift(2, 0x0000);
    }
    return out;
}
/* [MS-XLS] 2.4.146 */ function $b8f343bf88dacc48$var$parse_InterfaceHdr(blob, length) {
    if (length === 0) return 0x04b0;
    blob.read_shift(2);
    return 0x04b0;
}
/* [MS-XLS] 2.4.349 */ function $b8f343bf88dacc48$var$parse_WriteAccess(blob, length, opts) {
    if (opts.enc) {
        blob.l += length;
        return "";
    }
    var l = blob.l;
    // TODO: make sure XLUnicodeString doesnt overrun
    var UserName = $b8f343bf88dacc48$var$parse_XLUnicodeString2(blob, 0, opts);
    blob.read_shift(length + l - blob.l);
    return UserName;
}
function $b8f343bf88dacc48$var$write_WriteAccess(s /*:string*/ , opts) {
    var b8 = !opts || opts.biff == 8;
    var o = $b8f343bf88dacc48$var$new_buf(b8 ? 112 : 54);
    o.write_shift(opts.biff == 8 ? 2 : 1, 7);
    if (b8) o.write_shift(1, 0);
    o.write_shift(4, 0x33336853);
    o.write_shift(4, 0x00534A74 | (b8 ? 0 : 0x20000000));
    while(o.l < o.length)o.write_shift(1, b8 ? 0 : 32);
    return o;
}
/* [MS-XLS] 2.4.351 */ function $b8f343bf88dacc48$var$parse_WsBool(blob, length, opts) {
    var flags = opts && opts.biff == 8 || length == 2 ? blob.read_shift(2) : (blob.l += length, 0);
    return {
        fDialog: flags & 0x10,
        fBelow: flags & 0x40,
        fRight: flags & 0x80
    };
}
/* [MS-XLS] 2.4.28 */ function $b8f343bf88dacc48$var$parse_BoundSheet8(blob, length, opts) {
    var name = "";
    if (opts.biff == 4) {
        name = $b8f343bf88dacc48$var$parse_ShortXLUnicodeString(blob, 0, opts);
        if (name.length === 0) name = "Sheet1";
        return {
            name: name
        };
    }
    var pos = blob.read_shift(4);
    var hidden = blob.read_shift(1) & 0x03;
    var dt = blob.read_shift(1);
    switch(dt){
        case 0:
            dt = 'Worksheet';
            break;
        case 1:
            dt = 'Macrosheet';
            break;
        case 2:
            dt = 'Chartsheet';
            break;
        case 6:
            dt = 'VBAModule';
            break;
    }
    name = $b8f343bf88dacc48$var$parse_ShortXLUnicodeString(blob, 0, opts);
    if (name.length === 0) name = "Sheet1";
    return {
        pos: pos,
        hs: hidden,
        dt: dt,
        name: name
    };
}
function $b8f343bf88dacc48$var$write_BoundSheet8(data, opts) {
    var w = !opts || opts.biff >= 8 ? 2 : 1;
    var o = $b8f343bf88dacc48$var$new_buf(8 + w * data.name.length);
    o.write_shift(4, data.pos);
    o.write_shift(1, data.hs || 0);
    o.write_shift(1, data.dt);
    o.write_shift(1, data.name.length);
    if (opts.biff >= 8) o.write_shift(1, 1);
    o.write_shift(w * data.name.length, data.name, opts.biff < 8 ? 'sbcs' : 'utf16le');
    var out = o.slice(0, o.l);
    out.l = o.l;
    return out;
}
/* [MS-XLS] 2.4.265 TODO */ function $b8f343bf88dacc48$var$parse_SST(blob, length) /*:SST*/ {
    var end = blob.l + length;
    var cnt = blob.read_shift(4);
    var ucnt = blob.read_shift(4);
    var strs /*:SST*/  = [];
    for(var i = 0; i != ucnt && blob.l < end; ++i)strs.push($b8f343bf88dacc48$var$parse_XLUnicodeRichExtendedString(blob));
    strs.Count = cnt;
    strs.Unique = ucnt;
    return strs;
}
function $b8f343bf88dacc48$var$write_SST(sst, opts) {
    var header = $b8f343bf88dacc48$var$new_buf(8);
    header.write_shift(4, sst.Count);
    header.write_shift(4, sst.Unique);
    var strs = [];
    for(var j = 0; j < sst.length; ++j)strs[j] = $b8f343bf88dacc48$var$write_XLUnicodeRichExtendedString(sst[j], opts);
    var o = $b8f343bf88dacc48$var$bconcat([
        header
    ].concat(strs));
    /*::(*/ o /*:: :any)*/ .parts = [
        header.length
    ].concat(strs.map(function(str) {
        return str.length;
    }));
    return o;
}
/* [MS-XLS] 2.4.107 */ function $b8f343bf88dacc48$var$parse_ExtSST(blob, length) {
    var extsst = {};
    extsst.dsst = blob.read_shift(2);
    blob.l += length - 2;
    return extsst;
}
/* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */ function $b8f343bf88dacc48$var$parse_Row(blob) {
    var z = {} /*:any*/ ;
    z.r = blob.read_shift(2);
    z.c = blob.read_shift(2);
    z.cnt = blob.read_shift(2) - z.c;
    var miyRw = blob.read_shift(2);
    blob.l += 4; // reserved(2), unused(2)
    var flags = blob.read_shift(1); // various flags
    blob.l += 3; // reserved(8), ixfe(12), flags(4)
    if (flags & 0x07) z.level = flags & 0x07;
    // collapsed: flags & 0x10
    if (flags & 0x20) z.hidden = true;
    if (flags & 0x40) z.hpt = miyRw / 20;
    return z;
}
/* [MS-XLS] 2.4.125 */ function $b8f343bf88dacc48$var$parse_ForceFullCalculation(blob) {
    var header = $b8f343bf88dacc48$var$parse_frtHeader(blob);
    if (header.type != 0x08A3) throw new Error("Invalid Future Record " + header.type);
    var fullcalc = blob.read_shift(4);
    return fullcalc !== 0x0;
}
/* [MS-XLS] 2.4.215 rt */ function $b8f343bf88dacc48$var$parse_RecalcId(blob) {
    blob.read_shift(2);
    return blob.read_shift(4);
}
/* [MS-XLS] 2.4.87 */ function $b8f343bf88dacc48$var$parse_DefaultRowHeight(blob, length, opts) {
    var f = 0;
    if (!(opts && opts.biff == 2)) f = blob.read_shift(2);
    var miyRw = blob.read_shift(2);
    if (opts && opts.biff == 2) {
        f = 1 - (miyRw >> 15);
        miyRw &= 0x7fff;
    }
    var fl = {
        Unsynced: f & 1,
        DyZero: (f & 2) >> 1,
        ExAsc: (f & 4) >> 2,
        ExDsc: (f & 8) >> 3
    };
    return [
        fl,
        miyRw
    ];
}
/* [MS-XLS] 2.4.345 TODO */ function $b8f343bf88dacc48$var$parse_Window1(blob) {
    var xWn = blob.read_shift(2), yWn = blob.read_shift(2), dxWn = blob.read_shift(2), dyWn = blob.read_shift(2);
    var flags = blob.read_shift(2), iTabCur = blob.read_shift(2), iTabFirst = blob.read_shift(2);
    var ctabSel = blob.read_shift(2), wTabRatio = blob.read_shift(2);
    return {
        Pos: [
            xWn,
            yWn
        ],
        Dim: [
            dxWn,
            dyWn
        ],
        Flags: flags,
        CurTab: iTabCur,
        FirstTab: iTabFirst,
        Selected: ctabSel,
        TabRatio: wTabRatio
    };
}
function $b8f343bf88dacc48$var$write_Window1() {
    var o = $b8f343bf88dacc48$var$new_buf(18);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 0x7260);
    o.write_shift(2, 0x44c0);
    o.write_shift(2, 0x38);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 1);
    o.write_shift(2, 0x01f4);
    return o;
}
/* [MS-XLS] 2.4.346 TODO */ function $b8f343bf88dacc48$var$parse_Window2(blob, length, opts) {
    if (opts && opts.biff >= 2 && opts.biff < 5) return {};
    var f = blob.read_shift(2);
    return {
        RTL: f & 0x40
    };
}
function $b8f343bf88dacc48$var$write_Window2(view) {
    var o = $b8f343bf88dacc48$var$new_buf(18), f = 0x6b6;
    if (view && view.RTL) f |= 0x40;
    o.write_shift(2, f);
    o.write_shift(4, 0);
    o.write_shift(4, 64);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    return o;
}
/* [MS-XLS] 2.4.189 TODO */ function $b8f343bf88dacc48$var$parse_Pane() {}
/* [MS-XLS] 2.4.122 TODO */ function $b8f343bf88dacc48$var$parse_Font(blob, length, opts) {
    var o /*:any*/  = {
        dyHeight: blob.read_shift(2),
        fl: blob.read_shift(2)
    };
    switch(opts && opts.biff || 8){
        case 2:
            break;
        case 3:
        case 4:
            blob.l += 2;
            break;
        default:
            blob.l += 10;
            break;
    }
    o.name = $b8f343bf88dacc48$var$parse_ShortXLUnicodeString(blob, 0, opts);
    return o;
}
function $b8f343bf88dacc48$var$write_Font(data, opts) {
    var name = data.name || "Arial";
    var b5 = opts && opts.biff == 5, w = b5 ? 15 + name.length : 16 + 2 * name.length;
    var o = $b8f343bf88dacc48$var$new_buf(w);
    o.write_shift(2, (data.sz || 12) * 20);
    o.write_shift(4, 0);
    o.write_shift(2, 400);
    o.write_shift(4, 0);
    o.write_shift(2, 0);
    o.write_shift(1, name.length);
    if (!b5) o.write_shift(1, 1);
    o.write_shift((b5 ? 1 : 2) * name.length, name, b5 ? "sbcs" : "utf16le");
    return o;
}
/* [MS-XLS] 2.4.149 */ function $b8f343bf88dacc48$var$parse_LabelSst(blob, length, opts) {
    var cell = $b8f343bf88dacc48$var$parse_XLSCell(blob, length, opts);
    cell.isst = blob.read_shift(4);
    return cell;
}
function $b8f343bf88dacc48$var$write_LabelSst(R /*:number*/ , C /*:number*/ , v /*:number*/ , os /*:number*/  /*::, opts*/ ) {
    var o = $b8f343bf88dacc48$var$new_buf(10);
    $b8f343bf88dacc48$var$write_XLSCell(R, C, os, o);
    o.write_shift(4, v);
    return o;
}
/* [MS-XLS] 2.4.148 */ function $b8f343bf88dacc48$var$parse_Label(blob, length, opts) {
    if (opts.biffguess && opts.biff == 2) opts.biff = 5;
    var target = blob.l + length;
    var cell = $b8f343bf88dacc48$var$parse_XLSCell(blob, length, opts);
    var str = $b8f343bf88dacc48$var$parse_XLUnicodeString(blob, target - blob.l, opts);
    cell.val = str;
    return cell;
}
function $b8f343bf88dacc48$var$write_Label(R /*:number*/ , C /*:number*/ , v /*:string*/ , os /*:number*/ , opts) {
    var b8 = !opts || opts.biff == 8;
    var o = $b8f343bf88dacc48$var$new_buf(8 + +b8 + (1 + b8) * v.length);
    $b8f343bf88dacc48$var$write_XLSCell(R, C, os, o);
    o.write_shift(2, v.length);
    if (b8) o.write_shift(1, 1);
    o.write_shift((1 + b8) * v.length, v, b8 ? 'utf16le' : 'sbcs');
    return o;
}
/* [MS-XLS] 2.4.126 Number Formats */ function $b8f343bf88dacc48$var$parse_Format(blob, length, opts) {
    var numFmtId = blob.read_shift(2);
    var fmtstr = $b8f343bf88dacc48$var$parse_XLUnicodeString2(blob, 0, opts);
    return [
        numFmtId,
        fmtstr
    ];
}
function $b8f343bf88dacc48$var$write_Format(i /*:number*/ , f /*:string*/ , opts, o) {
    var b5 = opts && opts.biff == 5;
    if (!o) o = $b8f343bf88dacc48$var$new_buf(b5 ? 3 + f.length : 5 + 2 * f.length);
    o.write_shift(2, i);
    o.write_shift(b5 ? 1 : 2, f.length);
    if (!b5) o.write_shift(1, 1);
    o.write_shift((b5 ? 1 : 2) * f.length, f, b5 ? 'sbcs' : 'utf16le');
    var out = o.length > o.l ? o.slice(0, o.l) : o;
    if (out.l == null) out.l = out.length;
    return out;
}
var $b8f343bf88dacc48$var$parse_BIFF2Format = $b8f343bf88dacc48$var$parse_XLUnicodeString2;
function $b8f343bf88dacc48$var$write_BIFF2Format(f /*:string*/ ) {
    var o = $b8f343bf88dacc48$var$new_buf(1 + f.length);
    o.write_shift(1, f.length);
    o.write_shift(f.length, f, "sbcs");
    return o;
}
function $b8f343bf88dacc48$var$write_BIFF4Format(f /*:string*/ ) {
    var o = $b8f343bf88dacc48$var$new_buf(3 + f.length);
    o.l += 2;
    o.write_shift(1, f.length);
    o.write_shift(f.length, f, "sbcs");
    return o;
}
/* [MS-XLS] 2.4.90 */ function $b8f343bf88dacc48$var$parse_Dimensions(blob, length, opts) {
    var end = blob.l + length;
    var w = opts.biff == 8 || !opts.biff ? 4 : 2;
    var r = blob.read_shift(w), R = blob.read_shift(w);
    var c = blob.read_shift(2), C = blob.read_shift(2);
    blob.l = end;
    return {
        s: {
            r: r,
            c: c
        },
        e: {
            r: R,
            c: C
        }
    };
}
function $b8f343bf88dacc48$var$write_Dimensions(range, opts) {
    var w = opts.biff == 8 || !opts.biff ? 4 : 2;
    var o = $b8f343bf88dacc48$var$new_buf(2 * w + 6);
    o.write_shift(w, range.s.r);
    o.write_shift(w, range.e.r + 1);
    o.write_shift(2, range.s.c);
    o.write_shift(2, range.e.c + 1);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.220 */ function $b8f343bf88dacc48$var$parse_RK(blob) {
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var rkrec = $b8f343bf88dacc48$var$parse_RkRec(blob);
    return {
        r: rw,
        c: col,
        ixfe: rkrec[0],
        rknum: rkrec[1]
    };
}
/* [MS-XLS] 2.4.175 */ function $b8f343bf88dacc48$var$parse_MulRk(blob, length) {
    var target = blob.l + length - 2;
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var rkrecs = [];
    while(blob.l < target)rkrecs.push($b8f343bf88dacc48$var$parse_RkRec(blob));
    if (blob.l !== target) throw new Error("MulRK read error");
    var lastcol = blob.read_shift(2);
    if (rkrecs.length != lastcol - col + 1) throw new Error("MulRK length mismatch");
    return {
        r: rw,
        c: col,
        C: lastcol,
        rkrec: rkrecs
    };
}
/* [MS-XLS] 2.4.174 */ function $b8f343bf88dacc48$var$parse_MulBlank(blob, length) {
    var target = blob.l + length - 2;
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var ixfes = [];
    while(blob.l < target)ixfes.push(blob.read_shift(2));
    if (blob.l !== target) throw new Error("MulBlank read error");
    var lastcol = blob.read_shift(2);
    if (ixfes.length != lastcol - col + 1) throw new Error("MulBlank length mismatch");
    return {
        r: rw,
        c: col,
        C: lastcol,
        ixfe: ixfes
    };
}
/* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */ function $b8f343bf88dacc48$var$parse_CellStyleXF(blob, length, style, opts) {
    var o = {};
    var a = blob.read_shift(4), b = blob.read_shift(4);
    var c = blob.read_shift(4), d = blob.read_shift(2);
    o.patternType = $b8f343bf88dacc48$var$XLSFillPattern[c >> 26];
    if (!opts.cellStyles) return o;
    o.alc = a & 0x07;
    o.fWrap = a >> 3 & 0x01;
    o.alcV = a >> 4 & 0x07;
    o.fJustLast = a >> 7 & 0x01;
    o.trot = a >> 8 & 0xFF;
    o.cIndent = a >> 16 & 0x0F;
    o.fShrinkToFit = a >> 20 & 0x01;
    o.iReadOrder = a >> 22 & 0x02;
    o.fAtrNum = a >> 26 & 0x01;
    o.fAtrFnt = a >> 27 & 0x01;
    o.fAtrAlc = a >> 28 & 0x01;
    o.fAtrBdr = a >> 29 & 0x01;
    o.fAtrPat = a >> 30 & 0x01;
    o.fAtrProt = a >> 31 & 0x01;
    o.dgLeft = b & 0x0F;
    o.dgRight = b >> 4 & 0x0F;
    o.dgTop = b >> 8 & 0x0F;
    o.dgBottom = b >> 12 & 0x0F;
    o.icvLeft = b >> 16 & 0x7F;
    o.icvRight = b >> 23 & 0x7F;
    o.grbitDiag = b >> 30 & 0x03;
    o.icvTop = c & 0x7F;
    o.icvBottom = c >> 7 & 0x7F;
    o.icvDiag = c >> 14 & 0x7F;
    o.dgDiag = c >> 21 & 0x0F;
    o.icvFore = d & 0x7F;
    o.icvBack = d >> 7 & 0x7F;
    o.fsxButton = d >> 14 & 0x01;
    return o;
}
//function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
//function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}
/* [MS-XLS] 2.4.353 TODO: actually do this right */ function $b8f343bf88dacc48$var$parse_XF(blob, length, opts) {
    var o = {};
    o.ifnt = blob.read_shift(2);
    o.numFmtId = blob.read_shift(2);
    o.flags = blob.read_shift(2);
    o.fStyle = o.flags >> 2 & 0x01;
    length -= 6;
    o.data = $b8f343bf88dacc48$var$parse_CellStyleXF(blob, length, o.fStyle, opts);
    return o;
}
function $b8f343bf88dacc48$var$write_XF(data, ixfeP, opts, o) {
    var b5 = opts && opts.biff == 5;
    if (!o) o = $b8f343bf88dacc48$var$new_buf(b5 ? 16 : 20);
    o.write_shift(2, 0);
    if (data.style) {
        o.write_shift(2, data.numFmtId || 0);
        o.write_shift(2, 0xFFF4);
    } else {
        o.write_shift(2, data.numFmtId || 0);
        o.write_shift(2, ixfeP << 4);
    }
    var f = 0;
    if (data.numFmtId > 0 && b5) f |= 0x0400;
    o.write_shift(4, f);
    o.write_shift(4, 0);
    if (!b5) o.write_shift(4, 0);
    o.write_shift(2, 0);
    return o;
}
function $b8f343bf88dacc48$var$parse_BIFF2XF(blob /*::, length, opts*/ ) {
    var o = {};
    o.ifnt = blob.read_shift(1);
    blob.l++;
    o.flags = blob.read_shift(1);
    o.numFmtId = o.flags & 0x3F;
    o.flags >>= 6;
    o.fStyle = 0;
    o.data = {}; // TODO
    return o;
}
function $b8f343bf88dacc48$var$write_BIFF2XF(xf) {
    var o = $b8f343bf88dacc48$var$new_buf(4);
    o.l += 2;
    o.write_shift(1, xf.numFmtId);
    o.l++;
    return o;
}
function $b8f343bf88dacc48$var$write_BIFF3XF(xf) {
    var o = $b8f343bf88dacc48$var$new_buf(12);
    o.l++;
    o.write_shift(1, xf.numFmtId);
    o.l += 10;
    return o;
}
/* TODO: check other fields */ var $b8f343bf88dacc48$var$write_BIFF4XF = $b8f343bf88dacc48$var$write_BIFF3XF;
function $b8f343bf88dacc48$var$parse_BIFF3XF(blob /*::, length, opts*/ ) {
    var o = {};
    o.ifnt = blob.read_shift(1);
    o.numFmtId = blob.read_shift(1);
    o.flags = blob.read_shift(2);
    o.fStyle = o.flags >> 2 & 0x01;
    o.data = {}; // TODO
    return o;
}
function $b8f343bf88dacc48$var$parse_BIFF4XF(blob /*::, length, opts*/ ) {
    var o = {};
    o.ifnt = blob.read_shift(1);
    o.numFmtId = blob.read_shift(1);
    o.flags = blob.read_shift(2);
    o.fStyle = o.flags >> 2 & 0x01;
    o.data = {}; // TODO
    return o;
}
/* [MS-XLS] 2.4.134 */ function $b8f343bf88dacc48$var$parse_Guts(blob) {
    blob.l += 4;
    var out = [
        blob.read_shift(2),
        blob.read_shift(2)
    ];
    if (out[0] !== 0) out[0]--;
    if (out[1] !== 0) out[1]--;
    if (out[0] > 7 || out[1] > 7) throw new Error("Bad Gutters: " + out.join("|"));
    return out;
}
function $b8f343bf88dacc48$var$write_Guts(guts /*:Array<number>*/ ) {
    var o = $b8f343bf88dacc48$var$new_buf(8);
    o.write_shift(4, 0);
    o.write_shift(2, guts[0] ? guts[0] + 1 : 0);
    o.write_shift(2, guts[1] ? guts[1] + 1 : 0);
    return o;
}
/* [MS-XLS] 2.4.24 */ function $b8f343bf88dacc48$var$parse_BoolErr(blob, length, opts) {
    var cell = $b8f343bf88dacc48$var$parse_XLSCell(blob, 6, opts);
    var val = $b8f343bf88dacc48$var$parse_Bes(blob, 2);
    cell.val = val;
    cell.t = val === true || val === false ? 'b' : 'e';
    return cell;
}
function $b8f343bf88dacc48$var$write_BoolErr(R /*:number*/ , C /*:number*/ , v, os /*:number*/ , opts, t /*:string*/ ) {
    var o = $b8f343bf88dacc48$var$new_buf(8);
    $b8f343bf88dacc48$var$write_XLSCell(R, C, os, o);
    $b8f343bf88dacc48$var$write_Bes(v, t, o);
    return o;
}
/* [MS-XLS] 2.4.180 Number */ function $b8f343bf88dacc48$var$parse_Number(blob, length, opts) {
    if (opts.biffguess && opts.biff == 2) opts.biff = 5;
    var cell = $b8f343bf88dacc48$var$parse_XLSCell(blob, 6, opts);
    var xnum = $b8f343bf88dacc48$var$parse_Xnum(blob, 8);
    cell.val = xnum;
    return cell;
}
function $b8f343bf88dacc48$var$write_Number(R /*:number*/ , C /*:number*/ , v, os /*:: :number, opts*/ ) {
    var o = $b8f343bf88dacc48$var$new_buf(14);
    $b8f343bf88dacc48$var$write_XLSCell(R, C, os, o);
    $b8f343bf88dacc48$var$write_Xnum(v, o);
    return o;
}
var $b8f343bf88dacc48$var$parse_XLHeaderFooter = $b8f343bf88dacc48$var$parse_OptXLUnicodeString; // TODO: parse 2.4.136
/* [MS-XLS] 2.4.271 */ function $b8f343bf88dacc48$var$parse_SupBook(blob, length, opts) {
    var end = blob.l + length;
    var ctab = blob.read_shift(2);
    var cch = blob.read_shift(2);
    opts.sbcch = cch;
    if (cch == 0x0401 || cch == 0x3A01) return [
        cch,
        ctab
    ];
    if (cch < 0x01 || cch > 0xff) throw new Error("Unexpected SupBook type: " + cch);
    var virtPath = $b8f343bf88dacc48$var$parse_XLUnicodeStringNoCch(blob, cch);
    /* TODO: 2.5.277 Virtual Path */ var rgst = [];
    while(end > blob.l)rgst.push($b8f343bf88dacc48$var$parse_XLUnicodeString(blob));
    return [
        cch,
        ctab,
        virtPath,
        rgst
    ];
}
/* [MS-XLS] 2.4.105 TODO */ function $b8f343bf88dacc48$var$parse_ExternName(blob, length, opts) {
    var flags = blob.read_shift(2);
    var body;
    var o = {
        fBuiltIn: flags & 0x01,
        fWantAdvise: flags >>> 1 & 0x01,
        fWantPict: flags >>> 2 & 0x01,
        fOle: flags >>> 3 & 0x01,
        fOleLink: flags >>> 4 & 0x01,
        cf: flags >>> 5 & 0x3FF,
        fIcon: flags >>> 15 & 0x01
    } /*:any*/ ;
    if (opts.sbcch === 0x3A01) body = $b8f343bf88dacc48$var$parse_AddinUdf(blob, length - 2, opts);
    //else throw new Error("unsupported SupBook cch: " + opts.sbcch);
    o.body = body || blob.read_shift(length - 2);
    if (typeof body === "string") o.Name = body;
    return o;
}
/* [MS-XLS] 2.4.150 TODO */ function $b8f343bf88dacc48$var$parse_Lbl(blob, length, opts) {
    var target = blob.l + length;
    var flags = blob.read_shift(2);
    var chKey = blob.read_shift(1);
    var cch = blob.read_shift(1);
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    var itab = 0;
    if (!opts || opts.biff >= 5) {
        if (opts.biff != 5) blob.l += 2;
        itab = blob.read_shift(2);
        if (opts.biff == 5) blob.l += 2;
        blob.l += 4;
    }
    var name = $b8f343bf88dacc48$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
    if (flags & 0x20) name = $b8f343bf88dacc48$var$XLSLblBuiltIn[name.charCodeAt(0)];
    var npflen = target - blob.l;
    if (opts && opts.biff == 2) --npflen;
    /*jshint -W018 */ var rgce = target == blob.l || cce === 0 || !(npflen > 0) ? [] : $b8f343bf88dacc48$var$parse_NameParsedFormula(blob, npflen, opts, cce);
    /*jshint +W018 */ return {
        chKey: chKey,
        Name: name,
        itab: itab,
        rgce: rgce
    };
}
/* [MS-XLS] 2.4.106 TODO: legacy record filename encoding */ function $b8f343bf88dacc48$var$parse_ExternSheet(blob, length, opts) {
    if (opts.biff < 8) return $b8f343bf88dacc48$var$parse_BIFF5ExternSheet(blob, length, opts);
    /* see issue 2907 */ if (!(opts.biff > 8) && length == blob[blob.l] + (blob[blob.l + 1] == 0x03 ? 1 : 0) + 1) return $b8f343bf88dacc48$var$parse_BIFF5ExternSheet(blob, length, opts);
    var o = [], target = blob.l + length, len = blob.read_shift(opts.biff > 8 ? 4 : 2);
    while(len-- !== 0)o.push($b8f343bf88dacc48$var$parse_XTI(blob, opts.biff > 8 ? 12 : 6, opts));
    // [iSupBook, itabFirst, itabLast];
    if (blob.l != target) throw new Error("Bad ExternSheet: " + blob.l + " != " + target);
    return o;
}
function $b8f343bf88dacc48$var$parse_BIFF5ExternSheet(blob, length, opts) {
    if (blob[blob.l + 1] == 0x03) blob[blob.l]++;
    var o = $b8f343bf88dacc48$var$parse_ShortXLUnicodeString(blob, length, opts);
    return o.charCodeAt(0) == 0x03 ? o.slice(1) : o;
}
/* [MS-XLS] 2.4.176 TODO: check older biff */ function $b8f343bf88dacc48$var$parse_NameCmt(blob, length, opts) {
    if (opts.biff < 8) {
        blob.l += length;
        return;
    }
    var cchName = blob.read_shift(2);
    var cchComment = blob.read_shift(2);
    var name = $b8f343bf88dacc48$var$parse_XLUnicodeStringNoCch(blob, cchName, opts);
    var comment = $b8f343bf88dacc48$var$parse_XLUnicodeStringNoCch(blob, cchComment, opts);
    return [
        name,
        comment
    ];
}
/* [MS-XLS] 2.4.260 */ function $b8f343bf88dacc48$var$parse_ShrFmla(blob, length, opts) {
    var ref = $b8f343bf88dacc48$var$parse_RefU(blob, 6);
    blob.l++;
    var cUse = blob.read_shift(1);
    length -= 8;
    return [
        $b8f343bf88dacc48$var$parse_SharedParsedFormula(blob, length, opts),
        cUse,
        ref
    ];
}
/* [MS-XLS] 2.4.4 TODO */ function $b8f343bf88dacc48$var$parse_Array(blob, length, opts) {
    var ref = $b8f343bf88dacc48$var$parse_Ref(blob, 6);
    /* TODO: fAlwaysCalc */ switch(opts.biff){
        case 2:
            blob.l++;
            length -= 7;
            break;
        case 3:
        case 4:
            blob.l += 2;
            length -= 8;
            break;
        default:
            blob.l += 6;
            length -= 12;
    }
    return [
        ref,
        $b8f343bf88dacc48$var$parse_ArrayParsedFormula(blob, length, opts, ref)
    ];
}
/* [MS-XLS] 2.4.173 */ function $b8f343bf88dacc48$var$parse_MTRSettings(blob) {
    var fMTREnabled = blob.read_shift(4) !== 0x00;
    var fUserSetThreadCount = blob.read_shift(4) !== 0x00;
    var cUserThreadCount = blob.read_shift(4);
    return [
        fMTREnabled,
        fUserSetThreadCount,
        cUserThreadCount
    ];
}
/* [MS-XLS] 2.5.186 */ function $b8f343bf88dacc48$var$parse_NoteSh(blob, length, opts) {
    var row = blob.read_shift(2), col = blob.read_shift(2);
    var flags = blob.read_shift(2), idObj = blob.read_shift(2);
    var stAuthor = $b8f343bf88dacc48$var$parse_XLUnicodeString2(blob, 0, opts);
    return [
        {
            r: row,
            c: col
        },
        stAuthor,
        idObj,
        flags
    ];
}
/* [MS-XLS] 2.4.179 */ function $b8f343bf88dacc48$var$parse_Note(blob, length, opts) {
    if (opts && opts.biff < 8) {
        var row = blob.read_shift(2), col = blob.read_shift(2);
        if (row == 0xFFFF || row == -1) return; // TODO: test continuation
        var cch = blob.read_shift(2);
        var cmnt = blob.read_shift(Math.min(cch, 2048), 'cpstr');
        return [
            {
                r: row,
                c: col
            },
            cmnt
        ];
    }
    /* TODO: Support revisions */ return $b8f343bf88dacc48$var$parse_NoteSh(blob, length, opts);
}
function $b8f343bf88dacc48$var$write_NOTE_BIFF2(text /*:string*/ , R /*:number*/ , C /*:number*/ , len /*?:number*/ ) {
    var o = $b8f343bf88dacc48$var$new_buf(6 + (len || text.length));
    o.write_shift(2, R);
    o.write_shift(2, C);
    o.write_shift(2, len || text.length);
    o.write_shift(text.length, text, "sbcs");
    return o;
}
/* [MS-XLS] 2.4.168 */ function $b8f343bf88dacc48$var$parse_MergeCells(blob, length) /*:Array<Range>*/ {
    var merges /*:Array<Range>*/  = [];
    var cmcs = blob.read_shift(2);
    while(cmcs--)merges.push($b8f343bf88dacc48$var$parse_Ref8U(blob, length));
    return merges;
}
function $b8f343bf88dacc48$var$write_MergeCells(merges /*:Array<Range>*/ ) {
    var o = $b8f343bf88dacc48$var$new_buf(2 + merges.length * 8);
    o.write_shift(2, merges.length);
    for(var i = 0; i < merges.length; ++i)$b8f343bf88dacc48$var$write_Ref8U(merges[i], o);
    return o;
}
/* [MS-XLS] 2.4.181 TODO: parse all the things! */ function $b8f343bf88dacc48$var$parse_Obj(blob, length, opts) {
    if (opts && opts.biff < 8) return $b8f343bf88dacc48$var$parse_BIFF5Obj(blob, length, opts);
    var cmo = $b8f343bf88dacc48$var$parse_FtCmo(blob, 22); // id, ot, flags
    var fts = $b8f343bf88dacc48$var$parse_FtArray(blob, length - 22, cmo[1]);
    return {
        cmo: cmo,
        ft: fts
    };
}
/* from older spec */ var $b8f343bf88dacc48$var$parse_BIFF5OT = {
    0x08: function(blob, length) {
        var tgt = blob.l + length;
        blob.l += 10; // todo
        var cf = blob.read_shift(2);
        blob.l += 4;
        blob.l += 2; //var cbPictFmla = blob.read_shift(2);
        blob.l += 2;
        blob.l += 2; //var grbit = blob.read_shift(2);
        blob.l += 4;
        var cchName = blob.read_shift(1);
        blob.l += cchName; // TODO: stName
        blob.l = tgt; // TODO: fmla
        return {
            fmt: cf
        };
    }
};
function $b8f343bf88dacc48$var$parse_BIFF5Obj(blob, length, opts) {
    blob.l += 4; //var cnt = blob.read_shift(4);
    var ot = blob.read_shift(2);
    var id = blob.read_shift(2);
    var grbit = blob.read_shift(2);
    blob.l += 2; //var colL = blob.read_shift(2);
    blob.l += 2; //var dxL = blob.read_shift(2);
    blob.l += 2; //var rwT = blob.read_shift(2);
    blob.l += 2; //var dyT = blob.read_shift(2);
    blob.l += 2; //var colR = blob.read_shift(2);
    blob.l += 2; //var dxR = blob.read_shift(2);
    blob.l += 2; //var rwB = blob.read_shift(2);
    blob.l += 2; //var dyB = blob.read_shift(2);
    blob.l += 2; //var cbMacro = blob.read_shift(2);
    blob.l += 6;
    length -= 36;
    var fts = [];
    fts.push(($b8f343bf88dacc48$var$parse_BIFF5OT[ot] || $b8f343bf88dacc48$var$parsenoop)(blob, length, opts));
    return {
        cmo: [
            id,
            ot,
            grbit
        ],
        ft: fts
    };
}
/* [MS-XLS] 2.4.329 TODO: parse properly */ function $b8f343bf88dacc48$var$parse_TxO(blob, length, opts) {
    var s = blob.l;
    var texts = "";
    try {
        blob.l += 4;
        var ot = (opts.lastobj || {
            cmo: [
                0,
                0
            ]
        }).cmo[1];
        var controlInfo; // eslint-disable-line no-unused-vars
        if ([
            0,
            5,
            7,
            11,
            12,
            14
        ].indexOf(ot) == -1) blob.l += 6;
        else controlInfo = $b8f343bf88dacc48$var$parse_ControlInfo(blob, 6, opts); // eslint-disable-line no-unused-vars
        var cchText = blob.read_shift(2);
        /*var cbRuns = */ blob.read_shift(2);
        /*var ifntEmpty = */ $b8f343bf88dacc48$var$parseuint16(blob, 2);
        var len = blob.read_shift(2);
        blob.l += len;
        //var fmla = parse_ObjFmla(blob, s + length - blob.l);
        for(var i = 1; i < blob.lens.length - 1; ++i){
            if (blob.l - s != blob.lens[i]) throw new Error("TxO: bad continue record");
            var hdr = blob[blob.l];
            var t = $b8f343bf88dacc48$var$parse_XLUnicodeStringNoCch(blob, blob.lens[i + 1] - blob.lens[i] - 1);
            texts += t;
            if (texts.length >= (hdr ? cchText : 2 * cchText)) break;
        }
        if (texts.length !== cchText && texts.length !== cchText * 2) throw new Error("cchText: " + cchText + " != " + texts.length);
        blob.l = s + length;
        /* [MS-XLS] 2.5.272 TxORuns */ //	var rgTxoRuns = [];
        //	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
        //	var cchText2 = blob.read_shift(2);
        //	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
        //	blob.l += 6;
        //	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
        return {
            t: texts
        };
    } catch (e) {
        blob.l = s + length;
        return {
            t: texts
        };
    }
}
/* [MS-XLS] 2.4.140 */ function $b8f343bf88dacc48$var$parse_HLink(blob, length) {
    var ref = $b8f343bf88dacc48$var$parse_Ref8U(blob, 8);
    blob.l += 16; /* CLSID */ 
    var hlink = $b8f343bf88dacc48$var$parse_Hyperlink(blob, length - 24);
    return [
        ref,
        hlink
    ];
}
function $b8f343bf88dacc48$var$write_HLink(hl) {
    var O = $b8f343bf88dacc48$var$new_buf(24);
    var ref = $b8f343bf88dacc48$var$decode_cell(hl[0]);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.c);
    O.write_shift(2, ref.c);
    var clsid = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
    for(var i = 0; i < 16; ++i)O.write_shift(1, parseInt(clsid[i], 16));
    return $b8f343bf88dacc48$var$bconcat([
        O,
        $b8f343bf88dacc48$var$write_Hyperlink(hl[1])
    ]);
}
/* [MS-XLS] 2.4.141 */ function $b8f343bf88dacc48$var$parse_HLinkTooltip(blob, length) {
    blob.read_shift(2);
    var ref = $b8f343bf88dacc48$var$parse_Ref8U(blob, 8);
    var wzTooltip = blob.read_shift((length - 10) / 2, 'dbcs-cont');
    wzTooltip = wzTooltip.replace($b8f343bf88dacc48$var$chr0, "");
    return [
        ref,
        wzTooltip
    ];
}
function $b8f343bf88dacc48$var$write_HLinkTooltip(hl) {
    var TT = hl[1].Tooltip;
    var O = $b8f343bf88dacc48$var$new_buf(10 + 2 * (TT.length + 1));
    O.write_shift(2, 0x0800);
    var ref = $b8f343bf88dacc48$var$decode_cell(hl[0]);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.c);
    O.write_shift(2, ref.c);
    for(var i = 0; i < TT.length; ++i)O.write_shift(2, TT.charCodeAt(i));
    O.write_shift(2, 0);
    return O;
}
/* [MS-XLS] 2.4.63 */ function $b8f343bf88dacc48$var$parse_Country(blob) /*:[string|number, string|number]*/ {
    var o = [
        0,
        0
    ], d;
    d = blob.read_shift(2);
    o[0] = $b8f343bf88dacc48$var$CountryEnum[d] || d;
    d = blob.read_shift(2);
    o[1] = $b8f343bf88dacc48$var$CountryEnum[d] || d;
    return o;
}
function $b8f343bf88dacc48$var$write_Country(o) {
    if (!o) o = $b8f343bf88dacc48$var$new_buf(4);
    o.write_shift(2, 0x01);
    o.write_shift(2, 0x01);
    return o;
}
/* [MS-XLS] 2.4.50 ClrtClient */ function $b8f343bf88dacc48$var$parse_ClrtClient(blob) {
    var ccv = blob.read_shift(2);
    var o = [];
    while(ccv-- > 0)o.push($b8f343bf88dacc48$var$parse_LongRGB(blob, 8));
    return o;
}
/* [MS-XLS] 2.4.188 */ function $b8f343bf88dacc48$var$parse_Palette(blob) {
    var ccv = blob.read_shift(2);
    var o = [];
    while(ccv-- > 0)o.push($b8f343bf88dacc48$var$parse_LongRGB(blob, 8));
    return o;
}
/* [MS-XLS] 2.4.354 */ function $b8f343bf88dacc48$var$parse_XFCRC(blob) {
    blob.l += 2;
    var o = {
        cxfs: 0,
        crc: 0
    };
    o.cxfs = blob.read_shift(2);
    o.crc = blob.read_shift(4);
    return o;
}
/* [MS-XLS] 2.4.53 TODO: parse flags */ /* [MS-XLSB] 2.4.323 TODO: parse flags */ function $b8f343bf88dacc48$var$parse_ColInfo(blob, length, opts) {
    if (!opts.cellStyles) return $b8f343bf88dacc48$var$parsenoop(blob, length);
    var w = opts && opts.biff >= 12 ? 4 : 2;
    var colFirst = blob.read_shift(w);
    var colLast = blob.read_shift(w);
    var coldx = blob.read_shift(w);
    var ixfe = blob.read_shift(w);
    var flags = blob.read_shift(2);
    if (w == 2) blob.l += 2;
    var o = {
        s: colFirst,
        e: colLast,
        w: coldx,
        ixfe: ixfe,
        flags: flags
    } /*:any*/ ;
    if (opts.biff >= 5 || !opts.biff) o.level = flags >> 8 & 0x7;
    return o;
}
function $b8f343bf88dacc48$var$write_ColInfo(col, idx) {
    var o = $b8f343bf88dacc48$var$new_buf(12);
    o.write_shift(2, idx);
    o.write_shift(2, idx);
    o.write_shift(2, col.width * 256);
    o.write_shift(2, 0);
    var f = 0;
    if (col.hidden) f |= 1;
    o.write_shift(1, f);
    f = col.level || 0;
    o.write_shift(1, f);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.257 */ function $b8f343bf88dacc48$var$parse_Setup(blob, length) {
    var o = {};
    if (length < 32) return o;
    blob.l += 16;
    o.header = $b8f343bf88dacc48$var$parse_Xnum(blob, 8);
    o.footer = $b8f343bf88dacc48$var$parse_Xnum(blob, 8);
    blob.l += 2;
    return o;
}
/* [MS-XLS] 2.4.261 */ function $b8f343bf88dacc48$var$parse_ShtProps(blob, length, opts) {
    var def = {
        area: false
    };
    if (opts.biff != 5) {
        blob.l += length;
        return def;
    }
    var d = blob.read_shift(1);
    blob.l += 3;
    if (d & 0x10) def.area = true;
    return def;
}
/* [MS-XLS] 2.4.241 */ function $b8f343bf88dacc48$var$write_RRTabId(n /*:number*/ ) {
    var out = $b8f343bf88dacc48$var$new_buf(2 * n);
    for(var i = 0; i < n; ++i)out.write_shift(2, i + 1);
    return out;
}
var $b8f343bf88dacc48$var$parse_Blank = $b8f343bf88dacc48$var$parse_XLSCell; /* [MS-XLS] 2.4.20 Just the cell */ 
var $b8f343bf88dacc48$var$parse_Scl = $b8f343bf88dacc48$var$parseuint16a; /* [MS-XLS] 2.4.247 num, den */ 
var $b8f343bf88dacc48$var$parse_String = $b8f343bf88dacc48$var$parse_XLUnicodeString; /* [MS-XLS] 2.4.268 */ 
/* --- Specific to versions before BIFF8 --- */ function $b8f343bf88dacc48$var$parse_ImData(blob) {
    var cf = blob.read_shift(2);
    var env = blob.read_shift(2);
    var lcb = blob.read_shift(4);
    var o = {
        fmt: cf,
        env: env,
        len: lcb,
        data: blob.slice(blob.l, blob.l + lcb)
    };
    blob.l += lcb;
    return o;
}
function $b8f343bf88dacc48$var$write_BIFF2Cell(out, r /*:number*/ , c /*:number*/ , ixfe /*:number*/ , ifmt /*:number*/ ) {
    if (!out) out = $b8f343bf88dacc48$var$new_buf(7);
    out.write_shift(2, r);
    out.write_shift(2, c);
    out.write_shift(1, ixfe || 0 /* & 0x3F */ );
    out.write_shift(1, ifmt || 0 /* & 0x3F */ );
    out.write_shift(1, 0);
    return out;
}
/* BIFF2_??? where ??? is the name from [XLS] */ function $b8f343bf88dacc48$var$parse_BIFF2STR(blob, length, opts) {
    if (opts.biffguess && opts.biff == 5) opts.biff = 2;
    var cell = $b8f343bf88dacc48$var$parse_XLSCell(blob, 7, opts);
    var str = $b8f343bf88dacc48$var$parse_XLUnicodeString2(blob, length - 7, opts);
    cell.t = 'str';
    cell.val = str;
    return cell;
}
function $b8f343bf88dacc48$var$parse_BIFF2NUM(blob, length, opts) {
    var cell = $b8f343bf88dacc48$var$parse_XLSCell(blob, 7, opts);
    var num = $b8f343bf88dacc48$var$parse_Xnum(blob, 8);
    cell.t = 'n';
    cell.val = num;
    return cell;
}
function $b8f343bf88dacc48$var$write_BIFF2NUM(r /*:number*/ , c /*:number*/ , val /*:number*/ , ixfe, ifmt) {
    var out = $b8f343bf88dacc48$var$new_buf(15);
    $b8f343bf88dacc48$var$write_BIFF2Cell(out, r, c, ixfe || 0, ifmt || 0);
    out.write_shift(8, val, 'f');
    return out;
}
function $b8f343bf88dacc48$var$parse_BIFF2INT(blob, length, opts) {
    var cell = $b8f343bf88dacc48$var$parse_XLSCell(blob, 7, opts);
    var num = blob.read_shift(2);
    cell.t = 'n';
    cell.val = num;
    return cell;
}
function $b8f343bf88dacc48$var$write_BIFF2INT(r /*:number*/ , c /*:number*/ , val /*:number*/ , ixfe /*:number*/ , ifmt /*:number*/ ) {
    var out = $b8f343bf88dacc48$var$new_buf(9);
    $b8f343bf88dacc48$var$write_BIFF2Cell(out, r, c, ixfe || 0, ifmt || 0);
    out.write_shift(2, val);
    return out;
}
function $b8f343bf88dacc48$var$parse_BIFF2STRING(blob) {
    var cch = blob.read_shift(1);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return blob.read_shift(cch, 'sbcs-cont');
}
function $b8f343bf88dacc48$var$parse_BIFF2BOOLERR(blob, length, opts) {
    var bestart = blob.l + 7;
    var cell = $b8f343bf88dacc48$var$parse_XLSCell(blob, 6, opts);
    blob.l = bestart;
    var val = $b8f343bf88dacc48$var$parse_Bes(blob, 2);
    cell.val = val;
    cell.t = val === true || val === false ? 'b' : 'e';
    return cell;
}
/* TODO: convert to BIFF8 font struct */ function $b8f343bf88dacc48$var$parse_BIFF2FONTXTRA(blob, length) {
    blob.l += 6; // unknown
    blob.l += 2; // font weight "bls"
    blob.l += 1; // charset
    blob.l += 3; // unknown
    blob.l += 1; // font family
    blob.l += length - 13;
}
/* TODO: parse rich text runs */ function $b8f343bf88dacc48$var$parse_RString(blob, length, opts) {
    var end = blob.l + length;
    var cell = $b8f343bf88dacc48$var$parse_XLSCell(blob, 6, opts);
    var cch = blob.read_shift(2);
    var str = $b8f343bf88dacc48$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
    blob.l = end;
    cell.t = 'str';
    cell.val = str;
    return cell;
}
function $b8f343bf88dacc48$var$parse_BIFF4SheetInfo(blob /*::, length, opts*/ ) {
    var flags = blob.read_shift(4);
    var cch = blob.read_shift(1), name = blob.read_shift(cch, "sbcs");
    if (name.length === 0) name = "Sheet1";
    return {
        flags: flags,
        name: name
    };
}
var $b8f343bf88dacc48$var$DBF_SUPPORTED_VERSIONS = [
    0x02,
    0x03,
    0x30,
    0x31,
    0x83,
    0x8B,
    0x8C,
    0xF5
];
var $b8f343bf88dacc48$var$DBF = /*#__PURE__*/ function() {
    var dbf_codepage_map = {
        /* Code Pages Supported by Visual FoxPro */ 0x01: 437,
        0x02: 850,
        0x03: 1252,
        0x04: 10000,
        0x64: 852,
        0x65: 866,
        0x66: 865,
        0x67: 861,
        0x68: 895,
        0x69: 620,
        0x6A: 737,
        0x6B: 857,
        0x78: 950,
        0x79: 949,
        0x7A: 936,
        0x7B: 932,
        0x7C: 874,
        0x7D: 1255,
        0x7E: 1256,
        0x96: 10007,
        0x97: 10029,
        0x98: 10006,
        0xC8: 1250,
        0xC9: 1251,
        0xCA: 1254,
        0xCB: 1253,
        /* shapefile DBF extension */ 0x00: 20127,
        0x08: 865,
        0x09: 437,
        0x0A: 850,
        0x0B: 437,
        0x0D: 437,
        0x0E: 850,
        0x0F: 437,
        0x10: 850,
        0x11: 437,
        0x12: 850,
        0x13: 932,
        0x14: 850,
        0x15: 437,
        0x16: 850,
        0x17: 865,
        0x18: 437,
        0x19: 437,
        0x1A: 850,
        0x1B: 437,
        0x1C: 863,
        0x1D: 850,
        0x1F: 852,
        0x22: 852,
        0x23: 852,
        0x24: 860,
        0x25: 850,
        0x26: 866,
        0x37: 850,
        0x40: 852,
        0x4D: 936,
        0x4E: 949,
        0x4F: 950,
        0x50: 874,
        0x57: 1252,
        0x58: 1252,
        0x59: 1252,
        0x6C: 863,
        0x86: 737,
        0x87: 852,
        0x88: 857,
        0xCC: 1257,
        0xFF: 16969
    };
    var dbf_reverse_map = $b8f343bf88dacc48$var$evert({
        0x01: 437,
        0x02: 850,
        0x03: 1252,
        0x04: 10000,
        0x64: 852,
        0x65: 866,
        0x66: 865,
        0x67: 861,
        0x68: 895,
        0x69: 620,
        0x6A: 737,
        0x6B: 857,
        0x78: 950,
        0x79: 949,
        0x7A: 936,
        0x7B: 932,
        0x7C: 874,
        0x7D: 1255,
        0x7E: 1256,
        0x96: 10007,
        0x97: 10029,
        0x98: 10006,
        0xC8: 1250,
        0xC9: 1251,
        0xCA: 1254,
        0xCB: 1253,
        0x00: 20127
    });
    /* TODO: find an actual specification */ function dbf_to_aoa(buf, opts) /*:AOA*/ {
        var out /*:AOA*/  = [];
        var d /*:Block*/  = $b8f343bf88dacc48$var$new_raw_buf(1);
        switch(opts.type){
            case 'base64':
                d = $b8f343bf88dacc48$var$s2a($b8f343bf88dacc48$var$Base64_decode(buf));
                break;
            case 'binary':
                d = $b8f343bf88dacc48$var$s2a(buf);
                break;
            case 'buffer':
            case 'array':
                d = buf;
                break;
        }
        $b8f343bf88dacc48$var$prep_blob(d, 0);
        /* header */ var ft = d.read_shift(1);
        var memo = !!(ft & 0x88);
        var vfp = false, l7 = false;
        switch(ft){
            case 0x02:
                break; // dBASE II
            case 0x03:
                break; // dBASE III
            case 0x30:
                vfp = true;
                memo = true;
                break; // VFP
            case 0x31:
                vfp = true;
                memo = true;
                break; // VFP with autoincrement
            // 0x43 dBASE IV SQL table files
            // 0x63 dBASE IV SQL system files
            case 0x83:
                break; // dBASE III with memo
            case 0x8B:
                break; // dBASE IV with memo
            case 0x8C:
                l7 = true;
                break; // dBASE Level 7 with memo
            // case 0xCB dBASE IV SQL table files with memo
            case 0xF5:
                break; // FoxPro 2.x with memo
            // case 0xFB FoxBASE
            default:
                throw new Error("DBF Unsupported Version: " + ft.toString(16));
        }
        var nrow = 0, fpos = 0x0209;
        if (ft == 0x02) nrow = d.read_shift(2);
        d.l += 3; // dBASE II stores DDMMYY date, others use YYMMDD
        if (ft != 0x02) nrow = d.read_shift(4);
        if (nrow > 1048576) nrow = 1e6;
        if (ft != 0x02) fpos = d.read_shift(2); // header length
        var rlen = d.read_shift(2); // record length
        var /*flags = 0,*/ current_cp = opts.codepage || 1252;
        if (ft != 0x02) {
            d.l += 16;
            /*flags = */ d.read_shift(1);
            //if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));
            /* codepage present in FoxPro and dBASE Level 7 */ if (d[d.l] !== 0) current_cp = dbf_codepage_map[d[d.l]];
            d.l += 1;
            d.l += 2;
        }
        if (l7) d.l += 36; // Level 7: 32 byte "Language driver name", 4 byte reserved
        /*:: type DBFField = { name:string; len:number; type:string; } */ var fields /*:Array<DBFField>*/  = [], field /*:DBFField*/  = {} /*:any*/ ;
        var hend = Math.min(d.length, ft == 0x02 ? 0x209 : fpos - 10 - (vfp ? 264 : 0));
        var ww = l7 ? 32 : 11;
        while(d.l < hend && d[d.l] != 0x0d){
            field = {} /*:any*/ ;
            field.name = (typeof $b8f343bf88dacc48$var$$cptable !== "undefined" ? $b8f343bf88dacc48$var$$cptable.utils.decode(current_cp, d.slice(d.l, d.l + ww)) : $b8f343bf88dacc48$var$a2s(d.slice(d.l, d.l + ww))).replace(/[\u0000\r\n][\S\s]*$/g, "");
            d.l += ww;
            field.type = String.fromCharCode(d.read_shift(1));
            if (ft != 0x02 && !l7) field.offset = d.read_shift(4);
            field.len = d.read_shift(1);
            if (ft == 0x02) field.offset = d.read_shift(2);
            field.dec = d.read_shift(1);
            if (field.name.length) fields.push(field);
            if (ft != 0x02) d.l += l7 ? 13 : 14;
            switch(field.type){
                case 'B':
                    if ((!vfp || field.len != 8) && opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
                    break;
                case 'G':
                case 'P':
                    if (opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
                    break;
                case '+':
                case '0':
                case '@':
                case 'C':
                case 'D':
                case 'F':
                case 'I':
                case 'L':
                case 'M':
                case 'N':
                case 'O':
                case 'T':
                case 'Y':
                    break;
                default:
                    throw new Error('Unknown Field Type: ' + field.type);
            }
        }
        if (d[d.l] !== 0x0D) d.l = fpos - 1;
        if (d.read_shift(1) !== 0x0D) throw new Error("DBF Terminator not found " + d.l + " " + d[d.l]);
        d.l = fpos;
        /* data */ var R = 0, C = 0;
        out[0] = [];
        for(C = 0; C != fields.length; ++C)out[0][C] = fields[C].name;
        while(nrow-- > 0){
            if (d[d.l] === 0x2A) {
                // TODO: record marked as deleted -- create a hidden row?
                d.l += rlen;
                continue;
            }
            ++d.l;
            out[++R] = [];
            C = 0;
            for(C = 0; C != fields.length; ++C){
                var dd = d.slice(d.l, d.l + fields[C].len);
                d.l += fields[C].len;
                $b8f343bf88dacc48$var$prep_blob(dd, 0);
                var s = typeof $b8f343bf88dacc48$var$$cptable !== "undefined" ? $b8f343bf88dacc48$var$$cptable.utils.decode(current_cp, dd) : $b8f343bf88dacc48$var$a2s(dd);
                switch(fields[C].type){
                    case 'C':
                        // NOTE: it is conventional to write '  /  /  ' for empty dates
                        if (s.trim().length) out[R][C] = s.replace(/([^\s])\s+$/, "$1");
                        break;
                    case 'D':
                        if (s.length === 8) {
                            out[R][C] = new Date(Date.UTC(+s.slice(0, 4), +s.slice(4, 6) - 1, +s.slice(6, 8), 0, 0, 0, 0));
                            if (!(opts && opts.UTC)) out[R][C] = $b8f343bf88dacc48$var$utc_to_local(out[R][C]);
                        } else out[R][C] = s;
                        break;
                    case 'F':
                        out[R][C] = parseFloat(s.trim());
                        break;
                    case '+':
                    case 'I':
                        out[R][C] = l7 ? dd.read_shift(-4, 'i') ^ 0x80000000 : dd.read_shift(4, 'i');
                        break;
                    case 'L':
                        switch(s.trim().toUpperCase()){
                            case 'Y':
                            case 'T':
                                out[R][C] = true;
                                break;
                            case 'N':
                            case 'F':
                                out[R][C] = false;
                                break;
                            case '':
                            case '\x00':
                            case '?':
                                break;
                            default:
                                throw new Error("DBF Unrecognized L:|" + s + "|");
                        }
                        break;
                    case 'M':
                        /* TODO: handle memo files */ if (!memo) throw new Error("DBF Unexpected MEMO for type " + ft.toString(16));
                        out[R][C] = "##MEMO##" + (l7 ? parseInt(s.trim(), 10) : dd.read_shift(4));
                        break;
                    case 'N':
                        s = s.replace(/\u0000/g, "").trim();
                        // NOTE: dBASE II interprets "  .  " as 0
                        if (s && s != ".") out[R][C] = +s || 0;
                        break;
                    case '@':
                        // NOTE: dBASE specs appear to be incorrect
                        out[R][C] = new Date(dd.read_shift(-8, 'f') - 0x388317533400);
                        break;
                    case 'T':
                        var hi = dd.read_shift(4), lo = dd.read_shift(4);
                        if (hi == 0 && lo == 0) break;
                        out[R][C] = new Date((hi - 0x253D8C) * 0x5265C00 + lo);
                        if (!(opts && opts.UTC)) out[R][C] = $b8f343bf88dacc48$var$utc_to_local(out[R][C]);
                        break;
                    case 'Y':
                        out[R][C] = dd.read_shift(4, 'i') / 1e4 + dd.read_shift(4, 'i') / 1e4 * Math.pow(2, 32);
                        break;
                    case 'O':
                        out[R][C] = -dd.read_shift(-8, 'f');
                        break;
                    case 'B':
                        if (vfp && fields[C].len == 8) {
                            out[R][C] = dd.read_shift(8, 'f');
                            break;
                        }
                    /* falls through */ case 'G':
                    case 'P':
                        dd.l += fields[C].len;
                        break;
                    case '0':
                        if (fields[C].name === '_NullFlags') break;
                    /* falls through */ default:
                        throw new Error("DBF Unsupported data type " + fields[C].type);
                }
            }
        }
        if (ft != 0x02) {
            if (d.l < d.length && d[d.l++] != 0x1A) throw new Error("DBF EOF Marker missing " + (d.l - 1) + " of " + d.length + " " + d[d.l - 1].toString(16));
        }
        if (opts && opts.sheetRows) out = out.slice(0, opts.sheetRows);
        opts.DBF = fields;
        return out;
    }
    function dbf_to_sheet(buf, opts) /*:Worksheet*/ {
        var o = opts || {};
        if (!o.dateNF) o.dateNF = "yyyymmdd";
        var ws = $b8f343bf88dacc48$var$aoa_to_sheet(dbf_to_aoa(buf, o), o);
        ws["!cols"] = o.DBF.map(function(field) {
            return {
                wch: field.len,
                DBF: field
            };
        });
        delete o.DBF;
        return ws;
    }
    function dbf_to_workbook(buf, opts) /*:Workbook*/ {
        try {
            var o = $b8f343bf88dacc48$var$sheet_to_workbook(dbf_to_sheet(buf, opts), opts);
            o.bookType = "dbf";
            return o;
        } catch (e) {
            if (opts && opts.WTF) throw e;
        }
        return {
            SheetNames: [],
            Sheets: {}
        };
    }
    var _RLEN = {
        'B': 8,
        'C': 250,
        'L': 1,
        'D': 8,
        '?': 0,
        '': 0
    };
    function sheet_to_dbf(ws /*:Worksheet*/ , opts /*:WriteOpts*/ ) {
        if (!ws["!ref"]) throw new Error("Cannot export empty sheet to DBF");
        var o = opts || {};
        var old_cp = $b8f343bf88dacc48$var$current_codepage;
        if (+o.codepage >= 0) $b8f343bf88dacc48$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write DBF to JS string");
        var ba = $b8f343bf88dacc48$var$buf_array();
        var aoa /*:AOA*/  = $b8f343bf88dacc48$var$sheet_to_json(ws, {
            header: 1,
            raw: true,
            cellDates: true
        });
        var headers = aoa[0], data = aoa.slice(1), cols = ws["!cols"] || [];
        var i = 0, j = 0, hcnt = 0, rlen = 1;
        for(i = 0; i < headers.length; ++i){
            if (((cols[i] || {}).DBF || {}).name) {
                headers[i] = cols[i].DBF.name;
                ++hcnt;
                continue;
            }
            if (headers[i] == null) continue;
            ++hcnt;
            if (typeof headers[i] === 'number') headers[i] = headers[i].toString(10);
            if (typeof headers[i] !== 'string') throw new Error("DBF Invalid column name " + headers[i] + " |" + typeof headers[i] + "|");
            if (headers.indexOf(headers[i]) !== i) {
                for(j = 0; j < 1024; ++j)if (headers.indexOf(headers[i] + "_" + j) == -1) {
                    headers[i] += "_" + j;
                    break;
                }
            }
        }
        var range = $b8f343bf88dacc48$var$safe_decode_range(ws['!ref']);
        var coltypes /*:Array<string>*/  = [];
        var colwidths /*:Array<number>*/  = [];
        var coldecimals /*:Array<number>*/  = [];
        for(i = 0; i <= range.e.c - range.s.c; ++i){
            var guess = '', _guess = '', maxlen = 0;
            var col /*:Array<any>*/  = [];
            for(j = 0; j < data.length; ++j)if (data[j][i] != null) col.push(data[j][i]);
            if (col.length == 0 || headers[i] == null) {
                coltypes[i] = '?';
                continue;
            }
            for(j = 0; j < col.length; ++j){
                switch(typeof col[j]){
                    /* TODO: check if L2 compat is desired */ case 'number':
                        _guess = 'B';
                        break;
                    case 'string':
                        _guess = 'C';
                        break;
                    case 'boolean':
                        _guess = 'L';
                        break;
                    case 'object':
                        _guess = col[j] instanceof Date ? 'D' : 'C';
                        break;
                    default:
                        _guess = 'C';
                }
                /* TODO: cache the values instead of encoding twice */ maxlen = Math.max(maxlen, (typeof $b8f343bf88dacc48$var$$cptable !== "undefined" && typeof col[j] == "string" ? $b8f343bf88dacc48$var$$cptable.utils.encode($b8f343bf88dacc48$var$current_ansi, col[j]) : String(col[j])).length);
                guess = guess && guess != _guess ? 'C' : _guess;
            //if(guess == 'C') break;
            }
            if (maxlen > 250) maxlen = 250;
            _guess = ((cols[i] || {}).DBF || {}).type;
            /* TODO: more fine grained control over DBF type resolution */ if (_guess == 'C') {
                if (cols[i].DBF.len > maxlen) maxlen = cols[i].DBF.len;
            }
            if (guess == 'B' && _guess == 'N') {
                guess = 'N';
                coldecimals[i] = cols[i].DBF.dec;
                maxlen = cols[i].DBF.len;
            }
            colwidths[i] = guess == 'C' || _guess == 'N' ? maxlen : _RLEN[guess] || 0;
            rlen += colwidths[i];
            coltypes[i] = guess;
        }
        var h = ba.next(32);
        h.write_shift(4, 0x13021130);
        h.write_shift(4, data.length);
        h.write_shift(2, 296 + 32 * hcnt);
        h.write_shift(2, rlen);
        for(i = 0; i < 4; ++i)h.write_shift(4, 0);
        var cp = +dbf_reverse_map[/*::String(*/ $b8f343bf88dacc48$var$current_codepage /*::)*/ ] || 0x03;
        h.write_shift(4, 0x00000000 | cp << 8);
        if (dbf_codepage_map[cp] != +o.codepage) {
            if (o.codepage) console.error("DBF Unsupported codepage " + $b8f343bf88dacc48$var$current_codepage + ", using 1252");
            $b8f343bf88dacc48$var$current_codepage = 1252;
        }
        for(i = 0, j = 0; i < headers.length; ++i){
            if (headers[i] == null) continue;
            var hf = ba.next(32);
            /* TODO: test how applications handle non-ASCII field names */ var _f = (headers[i].slice(-10) + "\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0, 11);
            hf.write_shift(1, _f, "sbcs");
            hf.write_shift(1, coltypes[i] == '?' ? 'C' : coltypes[i], "sbcs");
            hf.write_shift(4, j);
            hf.write_shift(1, colwidths[i] || _RLEN[coltypes[i]] || 0);
            hf.write_shift(1, coldecimals[i] || 0);
            hf.write_shift(1, 0x02);
            hf.write_shift(4, 0);
            hf.write_shift(1, 0);
            hf.write_shift(4, 0);
            hf.write_shift(4, 0);
            j += colwidths[i] || _RLEN[coltypes[i]] || 0;
        }
        var hb = ba.next(264);
        hb.write_shift(4, 0x0000000D);
        for(i = 0; i < 65; ++i)hb.write_shift(4, 0x00000000);
        for(i = 0; i < data.length; ++i){
            var rout = ba.next(rlen);
            rout.write_shift(1, 0);
            for(j = 0; j < headers.length; ++j){
                if (headers[j] == null) continue;
                switch(coltypes[j]){
                    case 'L':
                        rout.write_shift(1, data[i][j] == null ? 0x3F : data[i][j] ? 0x54 : 0x46);
                        break;
                    case 'B':
                        rout.write_shift(8, data[i][j] || 0, 'f');
                        break;
                    case 'N':
                        var _n = "0";
                        if (typeof data[i][j] == "number") _n = data[i][j].toFixed(coldecimals[j] || 0);
                        if (_n.length > colwidths[j]) _n = _n.slice(0, colwidths[j]); // addresses decimal > width
                        for(hcnt = 0; hcnt < colwidths[j] - _n.length; ++hcnt)rout.write_shift(1, 0x20);
                        rout.write_shift(1, _n, "sbcs");
                        break;
                    case 'D':
                        if (!data[i][j]) rout.write_shift(8, "00000000", "sbcs");
                        else {
                            rout.write_shift(4, ("0000" + data[i][j].getFullYear()).slice(-4), "sbcs");
                            rout.write_shift(2, ("00" + (data[i][j].getMonth() + 1)).slice(-2), "sbcs");
                            rout.write_shift(2, ("00" + data[i][j].getDate()).slice(-2), "sbcs");
                        }
                        break;
                    case 'C':
                        var _l = rout.l;
                        var _s = String(data[i][j] != null ? data[i][j] : "").slice(0, colwidths[j]);
                        rout.write_shift(1, _s, "cpstr");
                        _l += colwidths[j] - rout.l;
                        for(hcnt = 0; hcnt < _l; ++hcnt)rout.write_shift(1, 0x20);
                        break;
                }
            }
        // data
        }
        $b8f343bf88dacc48$var$current_codepage = old_cp;
        ba.next(1).write_shift(1, 0x1A);
        return ba.end();
    }
    return {
        to_workbook: dbf_to_workbook,
        to_sheet: dbf_to_sheet,
        from_sheet: sheet_to_dbf
    };
}();
var $b8f343bf88dacc48$var$SYLK = /*#__PURE__*/ function() {
    /* TODO: stress test sequences */ var sylk_escapes = {
        AA: "\xc0",
        BA: "\xc1",
        CA: "\xc2",
        DA: 195,
        HA: "\xc4",
        JA: 197,
        AE: "\xc8",
        BE: "\xc9",
        CE: "\xca",
        HE: "\xcb",
        AI: "\xcc",
        BI: "\xcd",
        CI: "\xce",
        HI: "\xcf",
        AO: "\xd2",
        BO: "\xd3",
        CO: "\xd4",
        DO: 213,
        HO: "\xd6",
        AU: "\xd9",
        BU: "\xda",
        CU: "\xdb",
        HU: "\xdc",
        Aa: "\xe0",
        Ba: "\xe1",
        Ca: "\xe2",
        Da: 227,
        Ha: "\xe4",
        Ja: 229,
        Ae: "\xe8",
        Be: "\xe9",
        Ce: "\xea",
        He: "\xeb",
        Ai: "\xec",
        Bi: "\xed",
        Ci: "\xee",
        Hi: "\xef",
        Ao: "\xf2",
        Bo: "\xf3",
        Co: "\xf4",
        Do: 245,
        Ho: "\xf6",
        Au: "\xf9",
        Bu: "\xfa",
        Cu: "\xfb",
        Hu: "\xfc",
        KC: "\xc7",
        Kc: "\xe7",
        q: "\xe6",
        z: "\u0153",
        a: "\xc6",
        j: "\u0152",
        DN: 209,
        Dn: 241,
        Hy: 255,
        S: 169,
        c: 170,
        R: 174,
        "B ": 180,
        0: 176,
        1: 177,
        2: 178,
        3: 179,
        5: 181,
        6: 182,
        7: 183,
        Q: 185,
        k: 186,
        b: 208,
        i: 216,
        l: 222,
        s: 240,
        y: 248,
        "!": 161,
        '"': 162,
        "#": 163,
        "(": 164,
        "%": 165,
        "'": 167,
        "H ": 168,
        "+": 171,
        ";": 187,
        "<": 188,
        "=": 189,
        ">": 190,
        "?": 191,
        "{": 223
    } /*:any*/ ;
    var sylk_char_regex = new RegExp("\u001BN(" + $b8f343bf88dacc48$var$keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1").replace("{", "\\{") + "|\\|)", "gm");
    try {
        sylk_char_regex = new RegExp("\u001BN(" + $b8f343bf88dacc48$var$keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1") + "|\\|)", "gm");
    } catch (e) {}
    var sylk_char_fn = function(_, $1) {
        var o = sylk_escapes[$1];
        return typeof o == "number" ? $b8f343bf88dacc48$var$_getansi(o) : o;
    };
    var decode_sylk_char = function($$, $1, $2) {
        var newcc = $1.charCodeAt(0) - 0x20 << 4 | $2.charCodeAt(0) - 0x30;
        return newcc == 59 ? $$ : $b8f343bf88dacc48$var$_getansi(newcc);
    };
    sylk_escapes["|"] = 254;
    /* TODO: evert the escape map */ var encode_sylk_str = function($$) {
        return $$.replace(/\n/g, "\x1b :").replace(/\r/g, "\x1b =");
    };
    /* https://oss.sheetjs.com/notes/sylk/ for more details */ function sylk_to_aoa(d /*:RawData*/ , opts) /*:[AOA, Worksheet]*/ {
        switch(opts.type){
            case 'base64':
                return sylk_to_aoa_str($b8f343bf88dacc48$var$Base64_decode(d), opts);
            case 'binary':
                return sylk_to_aoa_str(d, opts);
            case 'buffer':
                return sylk_to_aoa_str($b8f343bf88dacc48$var$has_buf && $b8f343bf88dacc48$require$Buffer.isBuffer(d) ? d.toString('binary') : $b8f343bf88dacc48$var$a2s(d), opts);
            case 'array':
                return sylk_to_aoa_str($b8f343bf88dacc48$var$cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    function sylk_to_aoa_str(str /*:string*/ , opts) /*:[AOA, Worksheet]*/ {
        var records = str.split(/[\n\r]+/), R = -1, C = -1, ri = 0, rj = 0, arr /*:AOA*/  = [];
        var formats /*:Array<string>*/  = [];
        var next_cell_format /*:string|null*/  = null;
        var sht = {}, rowinfo /*:Array<RowInfo>*/  = [], colinfo /*:Array<ColInfo>*/  = [], cw /*:Array<string>*/  = [];
        var Mval = 0, j;
        var wb = {
            Workbook: {
                WBProps: {},
                Names: []
            }
        };
        if (+opts.codepage >= 0) $b8f343bf88dacc48$var$set_cp(+opts.codepage);
        for(; ri !== records.length; ++ri){
            Mval = 0;
            var rstr = records[ri].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, decode_sylk_char).replace(sylk_char_regex, sylk_char_fn);
            var record = rstr.replace(/;;/g, "\u0000").split(";").map(function(x) {
                return x.replace(/\u0000/g, ";");
            });
            var RT = record[0], val;
            if (rstr.length > 0) switch(RT){
                case 'ID':
                    break; /* header */ 
                case 'E':
                    break; /* EOF */ 
                case 'B':
                    break; /* dimensions */ 
                case 'O':
                    /* workbook options */ for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'V':
                            var d1904 = parseInt(record[rj].slice(1), 10);
                            // NOTE: it is technically an error if d1904 >= 5 or < 0
                            if (d1904 >= 1 && d1904 <= 4) wb.Workbook.WBProps.date1904 = true;
                            break;
                    }
                    break;
                case 'W':
                    break; /* window */ 
                case 'P':
                    switch(record[1].charAt(0)){
                        case 'P':
                            formats.push(rstr.slice(3).replace(/;;/g, ";"));
                            break;
                    }
                    break;
                case 'NN':
                    var nn = {
                        Sheet: 0
                    };
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'N':
                            nn.Name = record[rj].slice(1);
                            break;
                        case 'E':
                            nn.Ref = (opts && opts.sheet || "Sheet1") + "!" + $b8f343bf88dacc48$var$rc_to_a1(record[rj].slice(1));
                            break;
                    }
                    wb.Workbook.Names.push(nn);
                    break;
                // case 'NE': // ??
                // case 'NU': // ??
                case 'C':
                    /* cell */ var C_seen_K = false, C_seen_X = false, C_seen_S = false, C_seen_E = false, _R = -1, _C = -1, formula = "", cell_t = "z";
                    var cmnt = "";
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'A':
                            cmnt = record[rj].slice(1);
                            break; // TODO: comment
                        case 'X':
                            C = parseInt(record[rj].slice(1), 10) - 1;
                            C_seen_X = true;
                            break;
                        case 'Y':
                            R = parseInt(record[rj].slice(1), 10) - 1;
                            if (!C_seen_X) C = 0;
                            for(j = arr.length; j <= R; ++j)arr[j] = [];
                            break;
                        case 'K':
                            val = record[rj].slice(1);
                            if (val.charAt(0) === '"') {
                                val = val.slice(1, val.length - 1);
                                cell_t = "s";
                            } else if (val === 'TRUE' || val === 'FALSE') {
                                val = val === 'TRUE';
                                cell_t = "b";
                            } else if (val.charAt(0) == "#" && $b8f343bf88dacc48$var$RBErr[val] != null) {
                                cell_t = "e";
                                val = $b8f343bf88dacc48$var$RBErr[val];
                            } else if (!isNaN($b8f343bf88dacc48$var$fuzzynum(val))) {
                                val = $b8f343bf88dacc48$var$fuzzynum(val);
                                cell_t = "n";
                                if (next_cell_format !== null && $b8f343bf88dacc48$var$fmt_is_date(next_cell_format) && opts.cellDates) {
                                    val = $b8f343bf88dacc48$var$numdate(wb.Workbook.WBProps.date1904 ? val + 1462 : val);
                                    cell_t = typeof val == "number" ? "n" : "d";
                                }
                            }
                            if (typeof $b8f343bf88dacc48$var$$cptable !== 'undefined' && typeof val == "string" && (opts || {}).type != "string" && (opts || {}).codepage) val = $b8f343bf88dacc48$var$$cptable.utils.decode(opts.codepage, val);
                            C_seen_K = true;
                            break;
                        case 'E':
                            C_seen_E = true;
                            formula = $b8f343bf88dacc48$var$rc_to_a1(record[rj].slice(1), {
                                r: R,
                                c: C
                            });
                            break;
                        case 'S':
                            C_seen_S = true;
                            break;
                        case 'G':
                            break; // unknown
                        case 'R':
                            _R = parseInt(record[rj].slice(1), 10) - 1;
                            break;
                        case 'C':
                            _C = parseInt(record[rj].slice(1), 10) - 1;
                            break;
                        // case 'P': // ??
                        // case 'D': // ??
                        default:
                            if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                    }
                    if (C_seen_K) {
                        if (!arr[R][C]) arr[R][C] = {
                            t: cell_t,
                            v: val
                        };
                        else {
                            arr[R][C].t = cell_t;
                            arr[R][C].v = val;
                        }
                        if (next_cell_format) arr[R][C].z = next_cell_format;
                        if (opts.cellText !== false && next_cell_format) arr[R][C].w = $b8f343bf88dacc48$var$SSF_format(arr[R][C].z, arr[R][C].v, {
                            date1904: wb.Workbook.WBProps.date1904
                        });
                        next_cell_format = null;
                    }
                    if (C_seen_S) {
                        if (C_seen_E) throw new Error("SYLK shared formula cannot have own formula");
                        var shrbase = _R > -1 && arr[_R][_C];
                        if (!shrbase || !shrbase[1]) throw new Error("SYLK shared formula cannot find base");
                        formula = $b8f343bf88dacc48$var$shift_formula_str(shrbase[1], {
                            r: R - _R,
                            c: C - _C
                        });
                    }
                    if (formula) {
                        if (!arr[R][C]) arr[R][C] = {
                            t: 'n',
                            f: formula
                        };
                        else arr[R][C].f = formula;
                    }
                    if (cmnt) {
                        if (!arr[R][C]) arr[R][C] = {
                            t: 'z'
                        };
                        arr[R][C].c = [
                            {
                                a: "SheetJSYLK",
                                t: cmnt
                            }
                        ];
                    }
                    break;
                case 'F':
                    /* Format */ var F_seen = 0;
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'X':
                            C = parseInt(record[rj].slice(1), 10) - 1;
                            ++F_seen;
                            break;
                        case 'Y':
                            R = parseInt(record[rj].slice(1), 10) - 1; /*C = 0;*/ 
                            for(j = arr.length; j <= R; ++j)arr[j] = [];
                            break;
                        case 'M':
                            Mval = parseInt(record[rj].slice(1), 10) / 20;
                            break;
                        case 'F':
                            break; /* ??? */ 
                        case 'G':
                            break; /* hide grid */ 
                        case 'P':
                            next_cell_format = formats[parseInt(record[rj].slice(1), 10)];
                            break;
                        case 'S':
                            break; /* cell style */ 
                        case 'D':
                            break; /* column */ 
                        case 'N':
                            break; /* font */ 
                        case 'W':
                            cw = record[rj].slice(1).split(" ");
                            for(j = parseInt(cw[0], 10); j <= parseInt(cw[1], 10); ++j){
                                Mval = parseInt(cw[2], 10);
                                colinfo[j - 1] = Mval === 0 ? {
                                    hidden: true
                                } : {
                                    wch: Mval
                                };
                            }
                            break;
                        case 'C':
                            /* default column format */ C = parseInt(record[rj].slice(1), 10) - 1;
                            if (!colinfo[C]) colinfo[C] = {};
                            break;
                        case 'R':
                            /* row properties */ R = parseInt(record[rj].slice(1), 10) - 1;
                            if (!rowinfo[R]) rowinfo[R] = {};
                            if (Mval > 0) {
                                rowinfo[R].hpt = Mval;
                                rowinfo[R].hpx = $b8f343bf88dacc48$var$pt2px(Mval);
                            } else if (Mval === 0) rowinfo[R].hidden = true;
                            break;
                        // case 'K': // ??
                        // case 'E': // ??
                        default:
                            if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                    }
                    if (F_seen < 1) next_cell_format = null;
                    break;
                default:
                    if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
            }
        }
        if (rowinfo.length > 0) sht['!rows'] = rowinfo;
        if (colinfo.length > 0) sht['!cols'] = colinfo;
        colinfo.forEach(function(col) {
            $b8f343bf88dacc48$var$process_col(col);
        });
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return [
            arr,
            sht,
            wb
        ];
    }
    function sylk_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        var aoasht = sylk_to_aoa(d, opts);
        var aoa = aoasht[0], ws = aoasht[1], wb = aoasht[2];
        var _opts = $b8f343bf88dacc48$var$dup(opts);
        _opts.date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
        var o = $b8f343bf88dacc48$var$aoa_to_sheet(aoa, _opts);
        $b8f343bf88dacc48$var$keys(ws).forEach(function(k) {
            o[k] = ws[k];
        });
        var outwb = $b8f343bf88dacc48$var$sheet_to_workbook(o, opts);
        $b8f343bf88dacc48$var$keys(wb).forEach(function(k) {
            outwb[k] = wb[k];
        });
        outwb.bookType = "sylk";
        return outwb;
    }
    function write_ws_cell_sylk(cell /*:Cell*/ , ws /*:Worksheet*/ , R /*:number*/ , C /*:number*/ , opts, date1904 /*:boolean*/ ) /*:string*/ {
        var o = "C;Y" + (R + 1) + ";X" + (C + 1) + ";K";
        switch(cell.t){
            case 'n':
                o += cell.v || 0;
                if (cell.f && !cell.F) o += ";E" + $b8f343bf88dacc48$var$a1_to_rc(cell.f, {
                    r: R,
                    c: C
                });
                break;
            case 'b':
                o += cell.v ? "TRUE" : "FALSE";
                break;
            case 'e':
                o += cell.w || $b8f343bf88dacc48$var$BErr[cell.v] || cell.v;
                break;
            case 'd':
                o += $b8f343bf88dacc48$var$datenum($b8f343bf88dacc48$var$parseDate(cell.v, date1904), date1904);
                break;
            case 's':
                o += '"' + (cell.v == null ? "" : String(cell.v)).replace(/"/g, "").replace(/;/g, ";;") + '"';
                break;
        }
        return o;
    }
    function write_ws_cmnt_sylk(cmnt /*:Comment*/ , R /*:number*/ , C /*:number*/ ) /*:string*/ {
        var o = "C;Y" + (R + 1) + ";X" + (C + 1) + ";A";
        /* TODO: max length? */ o += encode_sylk_str(cmnt.map(function(c) {
            return c.t;
        }).join(""));
        return o;
    }
    function write_ws_cols_sylk(out, cols) {
        cols.forEach(function(col, i) {
            var rec = "F;W" + (i + 1) + " " + (i + 1) + " ";
            if (col.hidden) rec += "0";
            else {
                if (typeof col.width == 'number' && !col.wpx) col.wpx = $b8f343bf88dacc48$var$width2px(col.width);
                if (typeof col.wpx == 'number' && !col.wch) col.wch = $b8f343bf88dacc48$var$px2char(col.wpx);
                if (typeof col.wch == 'number') rec += Math.round(col.wch);
            }
            if (rec.charAt(rec.length - 1) != " ") out.push(rec);
        });
    }
    function write_ws_rows_sylk(out /*:Array<string>*/ , rows /*:Array<RowInfo>*/ ) {
        rows.forEach(function(row, i) {
            var rec = "F;";
            if (row.hidden) rec += "M0;";
            else if (row.hpt) rec += "M" + 20 * row.hpt + ";";
            else if (row.hpx) rec += "M" + 20 * $b8f343bf88dacc48$var$px2pt(row.hpx) + ";";
            if (rec.length > 2) out.push(rec + "R" + (i + 1));
        });
    }
    function sheet_to_sylk(ws /*:Worksheet*/ , opts /*:?any*/ , wb /*:?WorkBook*/ ) /*:string*/ {
        if (!opts) opts = {};
        opts._formats = [
            "General"
        ];
        /* TODO: codepage */ var preamble /*:Array<string>*/  = [
            "ID;PSheetJS;N;E"
        ], o /*:Array<string>*/  = [];
        var r = $b8f343bf88dacc48$var$safe_decode_range(ws['!ref'] || "A1"), cell /*:Cell*/ ;
        var dense = ws["!data"] != null;
        var RS = "\r\n";
        var d1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
        var _lastfmt = "General";
        preamble.push("P;PGeneral");
        /* Excel has been inconsistent in comment placement */ var R = r.s.r, C = r.s.c, p = [];
        if (ws["!ref"]) for(R = r.s.r; R <= r.e.r; ++R){
            if (dense && !ws["!data"][R]) continue;
            p = [];
            for(C = r.s.c; C <= r.e.c; ++C){
                cell = dense ? ws["!data"][R][C] : ws[$b8f343bf88dacc48$var$encode_col(C) + $b8f343bf88dacc48$var$encode_row(R)];
                if (!cell || !cell.c) continue;
                p.push(write_ws_cmnt_sylk(cell.c, R, C));
            }
            if (p.length) o.push(p.join(RS));
        }
        if (ws["!ref"]) for(R = r.s.r; R <= r.e.r; ++R){
            if (dense && !ws["!data"][R]) continue;
            p = [];
            for(C = r.s.c; C <= r.e.c; ++C){
                cell = dense ? ws["!data"][R][C] : ws[$b8f343bf88dacc48$var$encode_col(C) + $b8f343bf88dacc48$var$encode_row(R)];
                if (!cell || cell.v == null && (!cell.f || cell.F)) continue;
                if ((cell.z || (cell.t == "d" ? $b8f343bf88dacc48$var$table_fmt[14] : "General")) != _lastfmt) {
                    var ifmt = opts._formats.indexOf(cell.z);
                    if (ifmt == -1) {
                        opts._formats.push(cell.z);
                        ifmt = opts._formats.length - 1;
                        preamble.push("P;P" + cell.z.replace(/;/g, ";;"));
                    }
                    p.push("F;P" + ifmt + ";Y" + (R + 1) + ";X" + (C + 1));
                }
                p.push(write_ws_cell_sylk(cell, ws, R, C, opts, d1904));
            }
            o.push(p.join(RS));
        }
        preamble.push("F;P0;DG0G8;M255");
        if (ws['!cols']) write_ws_cols_sylk(preamble, ws['!cols']);
        if (ws['!rows']) write_ws_rows_sylk(preamble, ws['!rows']);
        if (ws["!ref"]) preamble.push("B;Y" + (r.e.r - r.s.r + 1) + ";X" + (r.e.c - r.s.c + 1) + ";D" + [
            r.s.c,
            r.s.r,
            r.e.c,
            r.e.r
        ].join(" "));
        preamble.push("O;L;D;B" + (d1904 ? ";V4" : "") + ";K47;G100 0.001");
        delete opts._formats;
        return preamble.join(RS) + RS + o.join(RS) + RS + "E" + RS;
    }
    return {
        to_workbook: sylk_to_workbook,
        from_sheet: sheet_to_sylk
    };
}();
var $b8f343bf88dacc48$var$DIF = /*#__PURE__*/ function() {
    function dif_to_aoa(d /*:RawData*/ , opts) /*:AOA*/ {
        switch(opts.type){
            case 'base64':
                return dif_to_aoa_str($b8f343bf88dacc48$var$Base64_decode(d), opts);
            case 'binary':
                return dif_to_aoa_str(d, opts);
            case 'buffer':
                return dif_to_aoa_str($b8f343bf88dacc48$var$has_buf && $b8f343bf88dacc48$require$Buffer.isBuffer(d) ? d.toString('binary') : $b8f343bf88dacc48$var$a2s(d), opts);
            case 'array':
                return dif_to_aoa_str($b8f343bf88dacc48$var$cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    function dif_to_aoa_str(str /*:string*/ , opts) /*:AOA*/ {
        var records = str.split('\n'), R = -1, C = -1, ri = 0, arr /*:AOA*/  = [];
        for(; ri !== records.length; ++ri){
            if (records[ri].trim() === 'BOT') {
                arr[++R] = [];
                C = 0;
                continue;
            }
            if (R < 0) continue;
            var metadata = records[ri].trim().split(",");
            var type = metadata[0], value = metadata[1];
            ++ri;
            var data = records[ri] || "";
            while((data.match(/["]/g) || []).length & 1 && ri < records.length - 1)data += "\n" + records[++ri];
            data = data.trim();
            switch(+type){
                case -1:
                    if (data === 'BOT') {
                        arr[++R] = [];
                        C = 0;
                        continue;
                    } else if (data !== 'EOD') throw new Error("Unrecognized DIF special command " + data);
                    break;
                case 0:
                    if (data === 'TRUE') arr[R][C] = true;
                    else if (data === 'FALSE') arr[R][C] = false;
                    else if (!isNaN($b8f343bf88dacc48$var$fuzzynum(value))) arr[R][C] = $b8f343bf88dacc48$var$fuzzynum(value);
                    else if (!isNaN($b8f343bf88dacc48$var$fuzzydate(value).getDate())) {
                        arr[R][C] = $b8f343bf88dacc48$var$parseDate(value);
                        if (!(opts && opts.UTC)) arr[R][C] = $b8f343bf88dacc48$var$utc_to_local(arr[R][C]);
                    } else arr[R][C] = value;
                    ++C;
                    break;
                case 1:
                    data = data.slice(1, data.length - 1);
                    data = data.replace(/""/g, '"');
                    if ($b8f343bf88dacc48$var$DIF_XL && data && data.match(/^=".*"$/)) data = data.slice(2, -1);
                    arr[R][C++] = data !== '' ? data : null;
                    break;
            }
            if (data === 'EOD') break;
        }
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return arr;
    }
    function dif_to_sheet(str /*:string*/ , opts) /*:Worksheet*/ {
        return $b8f343bf88dacc48$var$aoa_to_sheet(dif_to_aoa(str, opts), opts);
    }
    function dif_to_workbook(str /*:string*/ , opts) /*:Workbook*/ {
        var o = $b8f343bf88dacc48$var$sheet_to_workbook(dif_to_sheet(str, opts), opts);
        o.bookType = "dif";
        return o;
    }
    function make_value(v /*:number*/ , s /*:string*/ ) /*:string*/ {
        return "0," + String(v) + "\r\n" + s;
    }
    function make_value_str(s /*:string*/ ) /*:string*/ {
        return "1,0\r\n\"" + s.replace(/"/g, '""') + '"';
    }
    function sheet_to_dif(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        var _DIF_XL = $b8f343bf88dacc48$var$DIF_XL;
        if (!ws["!ref"]) throw new Error("Cannot export empty sheet to DIF");
        var r = $b8f343bf88dacc48$var$safe_decode_range(ws['!ref']);
        var dense = ws["!data"] != null;
        var o /*:Array<string>*/  = [
            "TABLE\r\n0,1\r\n\"sheetjs\"\r\n",
            "VECTORS\r\n0," + (r.e.r - r.s.r + 1) + "\r\n\"\"\r\n",
            "TUPLES\r\n0," + (r.e.c - r.s.c + 1) + "\r\n\"\"\r\n",
            "DATA\r\n0,0\r\n\"\"\r\n"
        ];
        for(var R = r.s.r; R <= r.e.r; ++R){
            var row = dense ? ws["!data"][R] : [];
            var p = "-1,0\r\nBOT\r\n";
            for(var C = r.s.c; C <= r.e.c; ++C){
                var cell /*:Cell*/  = dense ? row && row[C] : ws[$b8f343bf88dacc48$var$encode_cell({
                    r: R,
                    c: C
                })];
                if (cell == null) {
                    p += "1,0\r\n\"\"\r\n";
                    continue;
                }
                switch(cell.t){
                    case 'n':
                        if (_DIF_XL) {
                            if (cell.w != null) p += "0," + cell.w + "\r\nV";
                            else if (cell.v != null) p += make_value(cell.v, "V"); // TODO: should this call SSF_format?
                            else if (cell.f != null && !cell.F) p += make_value_str("=" + cell.f);
                            else p += "1,0\r\n\"\"";
                        } else if (cell.v == null) p += "1,0\r\n\"\"";
                        else p += make_value(cell.v, "V");
                        break;
                    case 'b':
                        p += cell.v ? make_value(1, "TRUE") : make_value(0, "FALSE");
                        break;
                    case 's':
                        p += make_value_str(!_DIF_XL || isNaN(+cell.v) ? cell.v : '="' + cell.v + '"');
                        break;
                    case 'd':
                        if (!cell.w) cell.w = $b8f343bf88dacc48$var$SSF_format(cell.z || $b8f343bf88dacc48$var$table_fmt[14], $b8f343bf88dacc48$var$datenum($b8f343bf88dacc48$var$parseDate(cell.v)));
                        if (_DIF_XL) p += make_value(cell.w, "V");
                        else p += make_value_str(cell.w);
                        break;
                    default:
                        p += "1,0\r\n\"\"";
                }
                p += "\r\n";
            }
            o.push(p);
        }
        return o.join("") + "-1,0\r\nEOD";
    }
    return {
        to_workbook: dif_to_workbook,
        to_sheet: dif_to_sheet,
        from_sheet: sheet_to_dif
    };
}();
var $b8f343bf88dacc48$var$ETH = /*#__PURE__*/ function() {
    function decode(s /*:string*/ ) /*:string*/ {
        return s.replace(/\\b/g, "\\").replace(/\\c/g, ":").replace(/\\n/g, "\n");
    }
    function encode(s /*:string*/ ) /*:string*/ {
        return s.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g, "\\n");
    }
    function eth_to_aoa(str /*:string*/ , opts) /*:AOA*/ {
        var records = str.split('\n'), R = -1, C = -1, ri = 0, arr /*:AOA*/  = [];
        for(; ri !== records.length; ++ri){
            var record = records[ri].trim().split(":");
            if (record[0] !== 'cell') continue;
            var addr = $b8f343bf88dacc48$var$decode_cell(record[1]);
            if (arr.length <= addr.r) {
                for(R = arr.length; R <= addr.r; ++R)if (!arr[R]) arr[R] = [];
            }
            R = addr.r;
            C = addr.c;
            switch(record[2]){
                case 't':
                    arr[R][C] = decode(record[3]);
                    break;
                case 'v':
                    arr[R][C] = +record[3];
                    break;
                case 'vtf':
                    var _f = record[record.length - 1];
                /* falls through */ case 'vtc':
                    switch(record[3]){
                        case 'nl':
                            arr[R][C] = +record[4] ? true : false;
                            break;
                        default:
                            arr[R][C] = +record[4];
                            break;
                    }
                    if (record[2] == 'vtf') arr[R][C] = [
                        arr[R][C],
                        _f
                    ];
            }
        }
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return arr;
    }
    function eth_to_sheet(d /*:string*/ , opts) /*:Worksheet*/ {
        return $b8f343bf88dacc48$var$aoa_to_sheet(eth_to_aoa(d, opts), opts);
    }
    function eth_to_workbook(d /*:string*/ , opts) /*:Workbook*/ {
        return $b8f343bf88dacc48$var$sheet_to_workbook(eth_to_sheet(d, opts), opts);
    }
    var header = [
        "socialcalc:version:1.5",
        "MIME-Version: 1.0",
        "Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
    ].join("\n");
    var sep = [
        "--SocialCalcSpreadsheetControlSave",
        "Content-type: text/plain; charset=UTF-8"
    ].join("\n") + "\n";
    /* TODO: the other parts */ var meta = [
        "# SocialCalc Spreadsheet Control Save",
        "part:sheet"
    ].join("\n");
    var end = "--SocialCalcSpreadsheetControlSave--";
    function sheet_to_eth_data(ws /*:Worksheet*/ ) /*:string*/ {
        if (!ws || !ws['!ref']) return "";
        var o /*:Array<string>*/  = [], oo /*:Array<string>*/  = [], cell, coord = "";
        var r = $b8f343bf88dacc48$var$decode_range(ws['!ref']);
        var dense = ws["!data"] != null;
        for(var R = r.s.r; R <= r.e.r; ++R)for(var C = r.s.c; C <= r.e.c; ++C){
            coord = $b8f343bf88dacc48$var$encode_cell({
                r: R,
                c: C
            });
            cell = dense ? (ws["!data"][R] || [])[C] : ws[coord];
            if (!cell || cell.v == null || cell.t === 'z') continue;
            oo = [
                "cell",
                coord,
                't'
            ];
            switch(cell.t){
                case 's':
                case 'str':
                    oo.push(encode(cell.v));
                    break;
                case 'n':
                    if (!cell.f) {
                        oo[2] = 'v';
                        oo[3] = cell.v;
                    } else {
                        oo[2] = 'vtf';
                        oo[3] = 'n';
                        oo[4] = cell.v;
                        oo[5] = encode(cell.f);
                    }
                    break;
                case 'b':
                    oo[2] = 'vt' + (cell.f ? 'f' : 'c');
                    oo[3] = 'nl';
                    oo[4] = cell.v ? "1" : "0";
                    oo[5] = encode(cell.f || (cell.v ? 'TRUE' : 'FALSE'));
                    break;
                case 'd':
                    var t = $b8f343bf88dacc48$var$datenum($b8f343bf88dacc48$var$parseDate(cell.v));
                    oo[2] = 'vtc';
                    oo[3] = 'nd';
                    oo[4] = "" + t;
                    oo[5] = cell.w || $b8f343bf88dacc48$var$SSF_format(cell.z || $b8f343bf88dacc48$var$table_fmt[14], t);
                    break;
                case 'e':
                    continue;
            }
            o.push(oo.join(":"));
        }
        o.push("sheet:c:" + (r.e.c - r.s.c + 1) + ":r:" + (r.e.r - r.s.r + 1) + ":tvf:1");
        o.push("valueformat:1:text-wiki");
        //o.push("copiedfrom:" + ws['!ref']); // clipboard only
        return o.join("\n");
    }
    function sheet_to_eth(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        return [
            header,
            sep,
            meta,
            sep,
            sheet_to_eth_data(ws),
            end
        ].join("\n");
    // return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
    }
    return {
        to_workbook: eth_to_workbook,
        to_sheet: eth_to_sheet,
        from_sheet: sheet_to_eth
    };
}();
var $b8f343bf88dacc48$var$PRN = /*#__PURE__*/ function() {
    function set_text_arr(data /*:string*/ , arr /*:AOA*/ , R /*:number*/ , C /*:number*/ , o /*:any*/ ) {
        if (o.raw) arr[R][C] = data;
        else if (data === "") ;
        else if (data === 'TRUE') arr[R][C] = true;
        else if (data === 'FALSE') arr[R][C] = false;
        else if (!isNaN($b8f343bf88dacc48$var$fuzzynum(data))) arr[R][C] = $b8f343bf88dacc48$var$fuzzynum(data);
        else if (!isNaN($b8f343bf88dacc48$var$fuzzydate(data).getDate())) arr[R][C] = $b8f343bf88dacc48$var$parseDate(data);
        else arr[R][C] = data;
    }
    function prn_to_aoa_str(f /*:string*/ , opts) /*:AOA*/ {
        var o = opts || {};
        var arr /*:AOA*/  = [];
        if (!f || f.length === 0) return arr;
        var lines = f.split(/[\r\n]/);
        var L = lines.length - 1;
        while(L >= 0 && lines[L].length === 0)--L;
        var start = 10, idx = 0;
        var R = 0;
        for(; R <= L; ++R){
            idx = lines[R].indexOf(" ");
            if (idx == -1) idx = lines[R].length;
            else idx++;
            start = Math.max(start, idx);
        }
        for(R = 0; R <= L; ++R){
            arr[R] = [];
            /* TODO: confirm that widths are always 10 */ var C = 0;
            set_text_arr(lines[R].slice(0, start).trim(), arr, R, C, o);
            for(C = 1; C <= (lines[R].length - start) / 10 + 1; ++C)set_text_arr(lines[R].slice(start + (C - 1) * 10, start + C * 10).trim(), arr, R, C, o);
        }
        if (o.sheetRows) arr = arr.slice(0, o.sheetRows);
        return arr;
    }
    // List of accepted CSV separators
    var guess_seps = {
        0x2C: ',',
        0x09: "\t",
        0x3B: ';',
        0x7C: '|'
    };
    // CSV separator weights to be used in case of equal numbers
    var guess_sep_weights = {
        0x2C: 3,
        0x09: 2,
        0x3B: 1,
        0x7C: 0
    };
    function guess_sep(str) {
        var cnt = {}, instr = false, end = 0, cc = 0;
        for(; end < str.length; ++end){
            if ((cc = str.charCodeAt(end)) == 0x22) instr = !instr;
            else if (!instr && cc in guess_seps) cnt[cc] = (cnt[cc] || 0) + 1;
        }
        cc = [];
        for(end in cnt)if (Object.prototype.hasOwnProperty.call(cnt, end)) cc.push([
            cnt[end],
            end
        ]);
        if (!cc.length) {
            cnt = guess_sep_weights;
            for(end in cnt)if (Object.prototype.hasOwnProperty.call(cnt, end)) cc.push([
                cnt[end],
                end
            ]);
        }
        cc.sort(function(a, b) {
            return a[0] - b[0] || guess_sep_weights[a[1]] - guess_sep_weights[b[1]];
        });
        return guess_seps[cc.pop()[1]] || 0x2C;
    }
    function dsv_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        var o = opts || {};
        var sep = "";
        if ($b8f343bf88dacc48$var$DENSE != null && o.dense == null) o.dense = $b8f343bf88dacc48$var$DENSE;
        var ws /*:Worksheet*/  = {} /*:any*/ ;
        if (o.dense) ws["!data"] = [];
        var range /*:Range*/  = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        } /*:any*/ ;
        if (str.slice(0, 4) == "sep=") {
            // If the line ends in \r\n
            if (str.charCodeAt(5) == 13 && str.charCodeAt(6) == 10) {
                sep = str.charAt(4);
                str = str.slice(7);
            } else if (str.charCodeAt(5) == 13 || str.charCodeAt(5) == 10) {
                sep = str.charAt(4);
                str = str.slice(6);
            } else sep = guess_sep(str.slice(0, 1024));
        } else if (o && o.FS) sep = o.FS;
        else sep = guess_sep(str.slice(0, 1024));
        var R = 0, C = 0, v = 0;
        var start = 0, end = 0, sepcc = sep.charCodeAt(0), instr = false, cc = 0, startcc = str.charCodeAt(0);
        var _re /*:?RegExp*/  = o.dateNF != null ? $b8f343bf88dacc48$var$dateNF_regex(o.dateNF) : null;
        function finish_cell() {
            /* TODO: fuzzy parsers should pass back assumed number format */ var s = str.slice(start, end);
            if (s.slice(-1) == "\r") s = s.slice(0, -1);
            var cell = {} /*:any*/ ;
            if (s.charAt(0) == '"' && s.charAt(s.length - 1) == '"') s = s.slice(1, -1).replace(/""/g, '"');
            if (o.cellText !== false) cell.w = s;
            if (s.length === 0) cell.t = 'z';
            else if (o.raw) {
                cell.t = 's';
                cell.v = s;
            } else if (s.trim().length === 0) {
                cell.t = 's';
                cell.v = s;
            } else if (s.charCodeAt(0) == 0x3D) {
                if (s.charCodeAt(1) == 0x22 && s.charCodeAt(s.length - 1) == 0x22) {
                    cell.t = 's';
                    cell.v = s.slice(2, -1).replace(/""/g, '"');
                } else if ($b8f343bf88dacc48$var$fuzzyfmla(s)) {
                    cell.t = 's';
                    cell.f = s.slice(1);
                    cell.v = s;
                } else {
                    cell.t = 's';
                    cell.v = s;
                }
            } else if (s == "TRUE") {
                cell.t = 'b';
                cell.v = true;
            } else if (s == "FALSE") {
                cell.t = 'b';
                cell.v = false;
            } else if (!isNaN(v = $b8f343bf88dacc48$var$fuzzynum(s))) {
                cell.t = 'n';
                cell.v = v;
            } else if (!isNaN((v = $b8f343bf88dacc48$var$fuzzydate(s)).getDate()) || _re && s.match(_re)) {
                cell.z = o.dateNF || $b8f343bf88dacc48$var$table_fmt[14];
                if (_re && s.match(_re)) {
                    var news = $b8f343bf88dacc48$var$dateNF_fix(s, o.dateNF, s.match(_re) || []);
                    v = $b8f343bf88dacc48$var$parseDate(news);
                    if (o && o.UTC === false) v = $b8f343bf88dacc48$var$utc_to_local(v);
                } else if (o && o.UTC === false) v = $b8f343bf88dacc48$var$utc_to_local(v);
                else if (o.cellText !== false && o.dateNF) cell.w = $b8f343bf88dacc48$var$SSF_format(cell.z, v);
                if (o.cellDates) {
                    cell.t = 'd';
                    cell.v = v;
                } else {
                    cell.t = 'n';
                    cell.v = $b8f343bf88dacc48$var$datenum(v);
                }
                if (!o.cellNF) delete cell.z;
            } else {
                cell.t = 's';
                cell.v = s;
            }
            if (cell.t == 'z') ;
            else if (o.dense) {
                if (!ws["!data"][R]) ws["!data"][R] = [];
                ws["!data"][R][C] = cell;
            } else ws[$b8f343bf88dacc48$var$encode_cell({
                c: C,
                r: R
            })] = cell;
            start = end + 1;
            startcc = str.charCodeAt(start);
            if (range.e.c < C) range.e.c = C;
            if (range.e.r < R) range.e.r = R;
            if (cc == sepcc) ++C;
            else {
                C = 0;
                ++R;
                if (o.sheetRows && o.sheetRows <= R) return true;
            }
        }
        outer: for(; end < str.length; ++end)switch(cc = str.charCodeAt(end)){
            case 0x22:
                if (startcc === 0x22) instr = !instr;
                break;
            case 0x0d:
                if (instr) break;
                if (str.charCodeAt(end + 1) == 0x0a) ++end;
            /* falls through */ case sepcc:
            case 0x0a:
                if (!instr && finish_cell()) break outer;
                break;
            default:
                break;
        }
        if (end - start > 0) finish_cell();
        ws['!ref'] = $b8f343bf88dacc48$var$encode_range(range);
        return ws;
    }
    function prn_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        if (!(opts && opts.PRN)) return dsv_to_sheet_str(str, opts);
        if (opts.FS) return dsv_to_sheet_str(str, opts);
        if (str.slice(0, 4) == "sep=") return dsv_to_sheet_str(str, opts);
        if (str.indexOf("\t") >= 0 || str.indexOf(",") >= 0 || str.indexOf(";") >= 0) return dsv_to_sheet_str(str, opts);
        return $b8f343bf88dacc48$var$aoa_to_sheet(prn_to_aoa_str(str, opts), opts);
    }
    function prn_to_sheet(d /*:RawData*/ , opts) /*:Worksheet*/ {
        var str = "", bytes = opts.type == 'string' ? [
            0,
            0,
            0,
            0
        ] : $b8f343bf88dacc48$var$firstbyte(d, opts);
        switch(opts.type){
            case 'base64':
                str = $b8f343bf88dacc48$var$Base64_decode(d);
                break;
            case 'binary':
                str = d;
                break;
            case 'buffer':
                if (opts.codepage == 65001) str = d.toString('utf8'); // TODO: test if buf
                else if (opts.codepage && typeof $b8f343bf88dacc48$var$$cptable !== 'undefined') str = $b8f343bf88dacc48$var$$cptable.utils.decode(opts.codepage, d);
                else str = $b8f343bf88dacc48$var$has_buf && $b8f343bf88dacc48$require$Buffer.isBuffer(d) ? d.toString('binary') : $b8f343bf88dacc48$var$a2s(d);
                break;
            case 'array':
                str = $b8f343bf88dacc48$var$cc2str(d);
                break;
            case 'string':
                str = d;
                break;
            default:
                throw new Error("Unrecognized type " + opts.type);
        }
        if (bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = $b8f343bf88dacc48$var$utf8read(str.slice(3));
        else if (opts.type != 'string' && opts.type != 'buffer' && opts.codepage == 65001) str = $b8f343bf88dacc48$var$utf8read(str);
        else if (opts.type == 'binary' && typeof $b8f343bf88dacc48$var$$cptable !== 'undefined' && opts.codepage) str = $b8f343bf88dacc48$var$$cptable.utils.decode(opts.codepage, $b8f343bf88dacc48$var$$cptable.utils.encode(28591, str));
        if (str.slice(0, 19) == "socialcalc:version:") return $b8f343bf88dacc48$var$ETH.to_sheet(opts.type == 'string' ? str : $b8f343bf88dacc48$var$utf8read(str), opts);
        return prn_to_sheet_str(str, opts);
    }
    function prn_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        return $b8f343bf88dacc48$var$sheet_to_workbook(prn_to_sheet(d, opts), opts);
    }
    function sheet_to_prn(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        var o /*:Array<string>*/  = [];
        if (!ws["!ref"]) return "";
        var r = $b8f343bf88dacc48$var$safe_decode_range(ws['!ref']), cell /*:Cell*/ ;
        var dense = ws["!data"] != null;
        for(var R = r.s.r; R <= r.e.r; ++R){
            var oo /*:Array<string>*/  = [];
            for(var C = r.s.c; C <= r.e.c; ++C){
                var coord = $b8f343bf88dacc48$var$encode_cell({
                    r: R,
                    c: C
                });
                cell = dense ? (ws["!data"][R] || [])[C] : ws[coord];
                if (!cell || cell.v == null) {
                    oo.push("          ");
                    continue;
                }
                var w = (cell.w || ($b8f343bf88dacc48$var$format_cell(cell), cell.w) || "").slice(0, 10);
                while(w.length < 10)w += " ";
                oo.push(w + (C === 0 ? " " : ""));
            }
            o.push(oo.join(""));
        }
        return o.join("\n");
    }
    return {
        to_workbook: prn_to_workbook,
        to_sheet: prn_to_sheet,
        from_sheet: sheet_to_prn
    };
}();
/* Excel defaults to SYLK but warns if data is not valid */ function $b8f343bf88dacc48$var$read_wb_ID(d, opts) {
    var o = opts || {}, OLD_WTF = !!o.WTF;
    o.WTF = true;
    try {
        var out = $b8f343bf88dacc48$var$SYLK.to_workbook(d, o);
        o.WTF = OLD_WTF;
        return out;
    } catch (e) {
        o.WTF = OLD_WTF;
        if (e.message.indexOf("SYLK bad record ID") == -1 && OLD_WTF) throw e;
        return $b8f343bf88dacc48$var$PRN.to_workbook(d, opts);
    }
}
var $b8f343bf88dacc48$var$WK_ = /*#__PURE__*/ function() {
    function lotushopper(data, cb /*:RecordHopperCB*/ , opts /*:any*/ ) {
        if (!data) return;
        $b8f343bf88dacc48$var$prep_blob(data, data.l || 0);
        var Enum = opts.Enum || WK1Enum;
        while(data.l < data.length){
            var RT = data.read_shift(2);
            var R = Enum[RT] || Enum[0xFFFF];
            var length = data.read_shift(2);
            var tgt = data.l + length;
            var d = R.f && R.f(data, length, opts);
            data.l = tgt;
            if (cb(d, R, RT)) return;
        }
    }
    function lotus_to_workbook(d /*:RawData*/ , opts) {
        switch(opts.type){
            case 'base64':
                return lotus_to_workbook_buf($b8f343bf88dacc48$var$s2a($b8f343bf88dacc48$var$Base64_decode(d)), opts);
            case 'binary':
                return lotus_to_workbook_buf($b8f343bf88dacc48$var$s2a(d), opts);
            case 'buffer':
            case 'array':
                return lotus_to_workbook_buf(d, opts);
        }
        throw "Unsupported type " + opts.type;
    }
    /* NOTE: this list intentionally starts at 1 */ var LOTUS_DATE_FMTS = [
        "mmmm",
        "dd-mmm-yyyy",
        "dd-mmm",
        "mmm-yyyy",
        "@",
        "mm/dd",
        "hh:mm:ss AM/PM",
        "hh:mm AM/PM",
        "mm/dd/yyyy",
        "mm/dd",
        "hh:mm:ss",
        "hh:mm" // 12
    ];
    function lotus_to_workbook_buf(d, opts) /*:Workbook*/ {
        if (!d) return d;
        var o = opts || {};
        if ($b8f343bf88dacc48$var$DENSE != null && o.dense == null) o.dense = $b8f343bf88dacc48$var$DENSE;
        var s /*:Worksheet*/  = {} /*:any*/ , n = "Sheet1", next_n = "", sidx = 0;
        var sheets = {}, snames = [], realnames = [], sdata = [];
        if (o.dense) sdata = s["!data"] = [];
        var refguess = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        };
        var sheetRows = o.sheetRows || 0;
        var lastcell = {};
        if (d[4] == 0x51 && d[5] == 0x50 && d[6] == 0x57) return qpw_to_workbook_buf(d, opts);
        if (d[2] == 0x00) {
            if (d[3] == 0x08 || d[3] == 0x09) {
                if (d.length >= 16 && d[14] == 0x05 && d[15] === 0x6c) throw new Error("Unsupported Works 3 for Mac file");
            }
        }
        if (d[2] == 0x02) {
            o.Enum = WK1Enum;
            lotushopper(d, function(val, R, RT) {
                switch(RT){
                    case 0x00:
                        /* BOF */ o.vers = val;
                        if (val >= 0x1000) o.qpro = true;
                        break;
                    case 0xFF:
                        /* BOF (works 3+) */ o.vers = val;
                        o.works = true;
                        break;
                    case 0x06:
                        refguess = val;
                        break; /* RANGE */ 
                    case 0xCC:
                        if (val) next_n = val;
                        break; /* SHEETNAMECS */ 
                    case 0xDE:
                        next_n = val;
                        break; /* SHEETNAMELP */ 
                    case 0x0F:
                    /* LABEL */ case 0x33:
                        /* STRING */ if ((!o.qpro && !o.works || RT == 0x33) && val[1].v.charCodeAt(0) < 0x30) val[1].v = val[1].v.slice(1);
                        if (o.works || o.works2) val[1].v = val[1].v.replace(/\r\n/g, "\n");
                    /* falls through */ case 0x0D:
                    /* INTEGER */ case 0x0E:
                    /* NUMBER */ case 0x10:
                        /* FORMULA */ /* TODO: actual translation of the format code */ if ((val[2] & 0x70) == 0x70 && (val[2] & 0x0F) > 1 && (val[2] & 0x0F) < 15) {
                            val[1].z = o.dateNF || LOTUS_DATE_FMTS[(val[2] & 0x0F) - 1] || $b8f343bf88dacc48$var$table_fmt[14];
                            if (o.cellDates) {
                                val[1].v = $b8f343bf88dacc48$var$numdate(val[1].v);
                                val[1].t = typeof val[1].v == "number" ? 'n' : 'd';
                            }
                        }
                        if (o.qpro) {
                            if (val[3] > sidx) {
                                s["!ref"] = $b8f343bf88dacc48$var$encode_range(refguess);
                                sheets[n] = s;
                                snames.push(n);
                                s = {} /*:any*/ ;
                                if (o.dense) sdata = s["!data"] = [];
                                refguess = {
                                    s: {
                                        r: 0,
                                        c: 0
                                    },
                                    e: {
                                        r: 0,
                                        c: 0
                                    }
                                };
                                sidx = val[3];
                                n = next_n || "Sheet" + (sidx + 1);
                                next_n = "";
                            }
                        }
                        var tmpcell = o.dense ? (sdata[val[0].r] || [])[val[0].c] : s[$b8f343bf88dacc48$var$encode_cell(val[0])];
                        if (tmpcell) {
                            tmpcell.t = val[1].t;
                            tmpcell.v = val[1].v;
                            if (val[1].z != null) tmpcell.z = val[1].z;
                            if (val[1].f != null) tmpcell.f = val[1].f;
                            lastcell = tmpcell;
                            break;
                        }
                        if (o.dense) {
                            if (!sdata[val[0].r]) sdata[val[0].r] = [];
                            sdata[val[0].r][val[0].c] = val[1];
                        } else s[$b8f343bf88dacc48$var$encode_cell(val[0])] = val[1];
                        lastcell = val[1];
                        break;
                    case 0x5405:
                        o.works2 = true;
                        break;
                    case 0x5402:
                        /* TODO: enumerate all extended number formats */ if (val == 0x14a1) {
                            lastcell.z = "hh:mm:ss";
                            if (o.cellDates && lastcell.t == "n") {
                                lastcell.v = $b8f343bf88dacc48$var$numdate(lastcell.v);
                                lastcell.t = typeof lastcell.v == "number" ? 'n' : 'd';
                            }
                        }
                        break;
                }
            }, o);
        } else if (d[2] == 0x1A || d[2] == 0x0E) {
            o.Enum = WK3Enum;
            if (d[2] == 0x0E) {
                o.qpro = true;
                d.l = 0;
            }
            lotushopper(d, function(val, R, RT) {
                switch(RT){
                    case 0xCC:
                        n = val;
                        break; /* SHEETNAMECS */ 
                    case 0x16:
                        /* LABEL16 */ if (val[1].v.charCodeAt(0) < 0x30) val[1].v = val[1].v.slice(1);
                        // TODO: R9 appears to encode control codes this way -- verify against other versions
                        val[1].v = val[1].v.replace(/\x0F./g, function($$) {
                            return String.fromCharCode($$.charCodeAt(1) - 0x20);
                        }).replace(/\r\n/g, "\n");
                    /* falls through */ case 0x17:
                    /* NUMBER17 */ case 0x18:
                    /* NUMBER18 */ case 0x19:
                    /* FORMULA19 */ case 0x25:
                    /* NUMBER25 */ case 0x27:
                    /* NUMBER27 */ case 0x28:
                        /* FORMULA28 */ if (val[3] > sidx) {
                            s["!ref"] = $b8f343bf88dacc48$var$encode_range(refguess);
                            sheets[n] = s;
                            snames.push(n);
                            s = {} /*:any*/ ;
                            if (o.dense) sdata = s["!data"] = [];
                            refguess = {
                                s: {
                                    r: 0,
                                    c: 0
                                },
                                e: {
                                    r: 0,
                                    c: 0
                                }
                            };
                            sidx = val[3];
                            n = "Sheet" + (sidx + 1);
                        }
                        if (sheetRows > 0 && val[0].r >= sheetRows) break;
                        if (o.dense) {
                            if (!sdata[val[0].r]) sdata[val[0].r] = [];
                            sdata[val[0].r][val[0].c] = val[1];
                        } else s[$b8f343bf88dacc48$var$encode_cell(val[0])] = val[1];
                        if (refguess.e.c < val[0].c) refguess.e.c = val[0].c;
                        if (refguess.e.r < val[0].r) refguess.e.r = val[0].r;
                        break;
                    case 0x1B:
                        /* XFORMAT */ if (val[0x36b0]) realnames[val[0x36b0][0]] = val[0x36b0][1];
                        break;
                    case 0x0601:
                        /* SHEETINFOQP */ realnames[val[0]] = val[1];
                        if (val[0] == sidx) n = val[1];
                        break;
                    default:
                        break;
                }
            }, o);
        } else throw new Error("Unrecognized LOTUS BOF " + d[2]);
        s["!ref"] = $b8f343bf88dacc48$var$encode_range(refguess);
        sheets[next_n || n] = s;
        snames.push(next_n || n);
        if (!realnames.length) return {
            SheetNames: snames,
            Sheets: sheets
        };
        var osheets = {}, rnames = [];
        /* TODO: verify no collisions */ for(var i = 0; i < realnames.length; ++i)if (sheets[snames[i]]) {
            rnames.push(realnames[i] || snames[i]);
            osheets[realnames[i]] = sheets[realnames[i]] || sheets[snames[i]];
        } else {
            rnames.push(realnames[i]);
            osheets[realnames[i]] = {
                "!ref": "A1"
            };
        }
        return {
            SheetNames: rnames,
            Sheets: osheets
        };
    }
    function sheet_to_wk1(ws /*:Worksheet*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) $b8f343bf88dacc48$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write WK1 to JS string");
        var ba = $b8f343bf88dacc48$var$buf_array();
        if (!ws["!ref"]) throw new Error("Cannot export empty sheet to WK1");
        var range = $b8f343bf88dacc48$var$safe_decode_range(ws["!ref"]);
        var dense = ws["!data"] != null;
        var cols = [];
        $b8f343bf88dacc48$var$write_biff_rec(ba, 0x00, write_BOF_WK1(0x0406));
        $b8f343bf88dacc48$var$write_biff_rec(ba, 0x06, write_RANGE(range));
        var max_R = Math.min(range.e.r, 8191);
        for(var C = range.s.c; C <= range.e.c; ++C)cols[C] = $b8f343bf88dacc48$var$encode_col(C);
        for(var R = range.s.r; R <= max_R; ++R){
            var rr = $b8f343bf88dacc48$var$encode_row(R);
            for(C = range.s.c; C <= range.e.c; ++C){
                var cell = dense ? (ws["!data"][R] || [])[C] : ws[cols[C] + rr];
                if (!cell || cell.t == "z") continue;
                /* TODO: formula records */ switch(cell.t){
                    case "n":
                        if ((cell.v | 0) == cell.v && cell.v >= -32768 && cell.v <= 32767) $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0d, write_INTEGER(R, C, cell));
                        else $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0e, write_NUMBER(R, C, cell));
                        break;
                    case "d":
                        var dc = $b8f343bf88dacc48$var$datenum(cell.v);
                        if ((dc | 0) == dc && dc >= -32768 && dc <= 32767) $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0d, write_INTEGER(R, C, {
                            t: "n",
                            v: dc,
                            z: cell.z || $b8f343bf88dacc48$var$table_fmt[14]
                        }));
                        else $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0e, write_NUMBER(R, C, {
                            t: "n",
                            v: dc,
                            z: cell.z || $b8f343bf88dacc48$var$table_fmt[14]
                        }));
                        break;
                    default:
                        var str = $b8f343bf88dacc48$var$format_cell(cell);
                        $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0F, write_LABEL(R, C, str.slice(0, 239)));
                }
            }
        }
        $b8f343bf88dacc48$var$write_biff_rec(ba, 0x01);
        return ba.end();
    }
    function book_to_wk3(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) $b8f343bf88dacc48$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write WK3 to JS string");
        var ba = $b8f343bf88dacc48$var$buf_array();
        $b8f343bf88dacc48$var$write_biff_rec(ba, 0x00, write_BOF_WK3(wb));
        for(var i = 0, cnt = 0; i < wb.SheetNames.length; ++i)if ((wb.Sheets[wb.SheetNames[i]] || {})["!ref"]) $b8f343bf88dacc48$var$write_biff_rec(ba, 0x1b, write_XFORMAT_SHEETNAME(wb.SheetNames[i], cnt++));
        var wsidx = 0;
        for(i = 0; i < wb.SheetNames.length; ++i){
            var ws = wb.Sheets[wb.SheetNames[i]];
            if (!ws || !ws["!ref"]) continue;
            var range = $b8f343bf88dacc48$var$safe_decode_range(ws["!ref"]);
            var dense = ws["!data"] != null;
            var cols = [];
            var max_R = Math.min(range.e.r, 8191);
            for(var R = range.s.r; R <= max_R; ++R){
                var rr = $b8f343bf88dacc48$var$encode_row(R);
                for(var C = range.s.c; C <= range.e.c; ++C){
                    if (R === range.s.r) cols[C] = $b8f343bf88dacc48$var$encode_col(C);
                    var ref = cols[C] + rr;
                    var cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
                    if (!cell || cell.t == "z") continue;
                    /* TODO: FORMULA19 NUMBER18 records */ if (cell.t == "n") $b8f343bf88dacc48$var$write_biff_rec(ba, 0x17, write_NUMBER_17(R, C, wsidx, cell.v));
                    else {
                        var str = $b8f343bf88dacc48$var$format_cell(cell);
                        /* TODO: max len? */ $b8f343bf88dacc48$var$write_biff_rec(ba, 0x16, write_LABEL_16(R, C, wsidx, str.slice(0, 239)));
                    }
                }
            }
            ++wsidx;
        }
        $b8f343bf88dacc48$var$write_biff_rec(ba, 0x01);
        return ba.end();
    }
    function write_BOF_WK1(v /*:number*/ ) {
        var out = $b8f343bf88dacc48$var$new_buf(2);
        out.write_shift(2, v);
        return out;
    }
    function write_BOF_WK3(wb /*:Workbook*/ ) {
        var out = $b8f343bf88dacc48$var$new_buf(26);
        out.write_shift(2, 0x1000);
        out.write_shift(2, 0x0004);
        out.write_shift(4, 0x0000);
        var rows = 0, cols = 0, wscnt = 0;
        for(var i = 0; i < wb.SheetNames.length; ++i){
            var name = wb.SheetNames[i];
            var ws = wb.Sheets[name];
            if (!ws || !ws["!ref"]) continue;
            ++wscnt;
            var range = $b8f343bf88dacc48$var$decode_range(ws["!ref"]);
            if (rows < range.e.r) rows = range.e.r;
            if (cols < range.e.c) cols = range.e.c;
        }
        if (rows > 8191) rows = 8191;
        out.write_shift(2, rows);
        out.write_shift(1, wscnt);
        out.write_shift(1, cols);
        out.write_shift(2, 0x00);
        out.write_shift(2, 0x00);
        out.write_shift(1, 0x01);
        out.write_shift(1, 0x02);
        out.write_shift(4, 0);
        out.write_shift(4, 0);
        return out;
    }
    function parse_RANGE(blob, length, opts) {
        var o = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        };
        if (length == 8 && opts.qpro) {
            o.s.c = blob.read_shift(1);
            blob.l++;
            o.s.r = blob.read_shift(2);
            o.e.c = blob.read_shift(1);
            blob.l++;
            o.e.r = blob.read_shift(2);
            return o;
        }
        o.s.c = blob.read_shift(2);
        o.s.r = blob.read_shift(2);
        if (length == 12 && opts.qpro) blob.l += 2;
        o.e.c = blob.read_shift(2);
        o.e.r = blob.read_shift(2);
        if (length == 12 && opts.qpro) blob.l += 2;
        if (o.s.c == 0xFFFF) o.s.c = o.e.c = o.s.r = o.e.r = 0;
        return o;
    }
    function write_RANGE(range) {
        var out = $b8f343bf88dacc48$var$new_buf(8);
        out.write_shift(2, range.s.c);
        out.write_shift(2, range.s.r);
        out.write_shift(2, range.e.c);
        out.write_shift(2, range.e.r);
        return out;
    }
    function parse_cell(blob, length, opts) {
        var o = [
            {
                c: 0,
                r: 0
            },
            {
                t: 'n',
                v: 0
            },
            0,
            0
        ];
        if (opts.qpro && opts.vers != 0x5120) {
            o[0].c = blob.read_shift(1);
            o[3] = blob.read_shift(1);
            o[0].r = blob.read_shift(2);
            blob.l += 2;
        } else if (opts.works) {
            o[0].c = blob.read_shift(2);
            o[0].r = blob.read_shift(2);
            o[2] = blob.read_shift(2);
        } else {
            o[2] = blob.read_shift(1);
            o[0].c = blob.read_shift(2);
            o[0].r = blob.read_shift(2);
        }
        return o;
    }
    function get_wk1_fmt(cell) /*:number*/ {
        /* TODO: some fuzzy matching on the number format */ if (cell.z && $b8f343bf88dacc48$var$fmt_is_date(cell.z)) return 0xf0 | (LOTUS_DATE_FMTS.indexOf(cell.z) + 1 || 2);
        return 0xFF;
    }
    function parse_LABEL(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        o[1].t = 's';
        if ((opts.vers & 0xFFFE) == 0x5120) {
            blob.l++;
            var len = blob.read_shift(1);
            o[1].v = blob.read_shift(len, 'utf8');
            return o;
        }
        if (opts.qpro) blob.l++;
        o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
        return o;
    }
    function write_LABEL(R, C, s) {
        /* TODO: encoding */ var o = $b8f343bf88dacc48$var$new_buf(7 + s.length);
        o.write_shift(1, 0xFF);
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(1, 0x27); // ??
        for(var i = 0; i < o.length; ++i){
            var cc = s.charCodeAt(i);
            o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
        }
        o.write_shift(1, 0);
        return o;
    }
    function parse_STRING(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        o[1].t = 's';
        if (opts.vers == 0x5120) {
            var len = blob.read_shift(1);
            o[1].v = blob.read_shift(len, 'utf8');
            return o;
        }
        o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
        return o;
    }
    function parse_INTEGER(blob, length, opts) {
        var o = parse_cell(blob, length, opts);
        o[1].v = blob.read_shift(2, 'i');
        return o;
    }
    function write_INTEGER(R, C, cell) {
        var o = $b8f343bf88dacc48$var$new_buf(7);
        o.write_shift(1, get_wk1_fmt(cell));
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(2, cell.v, 'i');
        return o;
    }
    function parse_NUMBER(blob, length, opts) {
        var o = parse_cell(blob, length, opts);
        o[1].v = blob.read_shift(8, 'f');
        return o;
    }
    function write_NUMBER(R, C, cell) {
        var o = $b8f343bf88dacc48$var$new_buf(13);
        o.write_shift(1, get_wk1_fmt(cell));
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(8, cell.v, 'f');
        return o;
    }
    function parse_FORMULA(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        /* TODO: formula */ o[1].v = blob.read_shift(8, 'f');
        if (opts.qpro) blob.l = tgt;
        else {
            var flen = blob.read_shift(2);
            wk1_fmla_to_csf(blob.slice(blob.l, blob.l + flen), o);
            blob.l += flen;
        }
        return o;
    }
    function wk1_parse_rc(B, V, col) {
        var rel = V & 0x8000;
        V &= -32769;
        V = (rel ? B : 0) + (V >= 0x2000 ? V - 0x4000 : V);
        return (rel ? "" : "$") + (col ? $b8f343bf88dacc48$var$encode_col(V) : $b8f343bf88dacc48$var$encode_row(V));
    }
    /* var oprec = [
		8, 8, 8, 8, 8, 8, 8, 8, 6, 4, 4, 5, 5, 7, 3, 3,
		3, 3, 3, 3, 1, 1, 2, 6, 8, 8, 8, 8, 8, 8, 8, 8
	]; */ /* TODO: flesh out */ var FuncTab = {
        0x1F: [
            "NA",
            0
        ],
        // 0x20: ["ERR", 0],
        0x21: [
            "ABS",
            1
        ],
        0x22: [
            "TRUNC",
            1
        ],
        0x23: [
            "SQRT",
            1
        ],
        0x24: [
            "LOG",
            1
        ],
        0x25: [
            "LN",
            1
        ],
        0x26: [
            "PI",
            0
        ],
        0x27: [
            "SIN",
            1
        ],
        0x28: [
            "COS",
            1
        ],
        0x29: [
            "TAN",
            1
        ],
        0x2A: [
            "ATAN2",
            2
        ],
        0x2B: [
            "ATAN",
            1
        ],
        0x2C: [
            "ASIN",
            1
        ],
        0x2D: [
            "ACOS",
            1
        ],
        0x2E: [
            "EXP",
            1
        ],
        0x2F: [
            "MOD",
            2
        ],
        // 0x30
        0x31: [
            "ISNA",
            1
        ],
        0x32: [
            "ISERR",
            1
        ],
        0x33: [
            "FALSE",
            0
        ],
        0x34: [
            "TRUE",
            0
        ],
        0x35: [
            "RAND",
            0
        ],
        0x36: [
            "DATE",
            3
        ],
        // 0x37 NOW
        // 0x38 PMT
        // 0x39 PV
        // 0x3A FV
        // 0x3B IF
        // 0x3C DAY
        // 0x3D MONTH
        // 0x3E YEAR
        0x3F: [
            "ROUND",
            2
        ],
        0x40: [
            "TIME",
            3
        ],
        // 0x41 HOUR
        // 0x42 MINUTE
        // 0x43 SECOND
        0x44: [
            "ISNUMBER",
            1
        ],
        0x45: [
            "ISTEXT",
            1
        ],
        0x46: [
            "LEN",
            1
        ],
        0x47: [
            "VALUE",
            1
        ],
        // 0x48: ["FIXED", ?? 1],
        0x49: [
            "MID",
            3
        ],
        0x4A: [
            "CHAR",
            1
        ],
        // 0x4B
        // 0x4C FIND
        // 0x4D DATEVALUE
        // 0x4E TIMEVALUE
        // 0x4F CELL
        0x50: [
            "SUM",
            69
        ],
        0x51: [
            "AVERAGEA",
            69
        ],
        0x52: [
            "COUNTA",
            69
        ],
        0x53: [
            "MINA",
            69
        ],
        0x54: [
            "MAXA",
            69
        ],
        // 0x55 VLOOKUP
        // 0x56 NPV
        // 0x57 VAR
        // 0x58 STD
        // 0x59 IRR
        // 0x5A HLOOKUP
        // 0x5B DSUM
        // 0x5C DAVERAGE
        // 0x5D DCOUNTA
        // 0x5E DMIN
        // 0x5F DMAX
        // 0x60 DVARP
        // 0x61 DSTDEVP
        // 0x62 INDEX
        // 0x63 COLS
        // 0x64 ROWS
        // 0x65 REPEAT
        0x66: [
            "UPPER",
            1
        ],
        0x67: [
            "LOWER",
            1
        ],
        // 0x68 LEFT
        // 0x69 RIGHT
        // 0x6A REPLACE
        0x6B: [
            "PROPER",
            1
        ],
        // 0x6C CELL
        0x6D: [
            "TRIM",
            1
        ],
        // 0x6E CLEAN
        0x6F: [
            "T",
            1
        ]
    };
    var BinOpTab = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "+",
        "-",
        "*",
        "/",
        "^",
        "=",
        "<>",
        "<=",
        ">=",
        "<",
        ">",
        "",
        "",
        "",
        "",
        "&",
        "",
        "",
        "",
        "",
        "",
        "",
        "" // eslint-disable-line no-mixed-spaces-and-tabs
    ];
    function wk1_fmla_to_csf(blob, o) {
        $b8f343bf88dacc48$var$prep_blob(blob, 0);
        var out = [], argc = 0, R = "", C = "", argL = "", argR = "";
        while(blob.l < blob.length){
            var cc = blob[blob.l++];
            switch(cc){
                case 0x00:
                    out.push(blob.read_shift(8, 'f'));
                    break;
                case 0x01:
                    C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    out.push(C + R);
                    break;
                case 0x02:
                    var c = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    var r = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    out.push(c + r + ":" + C + R);
                    break;
                case 0x03:
                    if (blob.l < blob.length) {
                        console.error("WK1 premature formula end");
                        return;
                    }
                    break;
                case 0x04:
                    out.push("(" + out.pop() + ")");
                    break;
                case 0x05:
                    out.push(blob.read_shift(2));
                    break;
                case 0x06:
                    /* TODO: text encoding */ var Z = "";
                    while(cc = blob[blob.l++])Z += String.fromCharCode(cc);
                    out.push('"' + Z.replace(/"/g, '""') + '"');
                    break;
                case 0x08:
                    out.push("-" + out.pop());
                    break;
                case 0x17:
                    out.push("+" + out.pop());
                    break;
                case 0x16:
                    out.push("NOT(" + out.pop() + ")");
                    break;
                case 0x14:
                case 0x15:
                    argR = out.pop();
                    argL = out.pop();
                    out.push([
                        "AND",
                        "OR"
                    ][cc - 0x14] + "(" + argL + "," + argR + ")");
                    break;
                default:
                    if (cc < 0x20 && BinOpTab[cc]) {
                        argR = out.pop();
                        argL = out.pop();
                        out.push(argL + BinOpTab[cc] + argR);
                    } else if (FuncTab[cc]) {
                        argc = FuncTab[cc][1];
                        if (argc == 69) argc = blob[blob.l++];
                        if (argc > out.length) {
                            console.error("WK1 bad formula parse 0x" + cc.toString(16) + ":|" + out.join("|") + "|");
                            return;
                        }
                        var args = out.slice(-argc);
                        out.length -= argc;
                        out.push(FuncTab[cc][0] + "(" + args.join(",") + ")");
                    } else if (cc <= 0x07) return console.error("WK1 invalid opcode " + cc.toString(16));
                    else if (cc <= 0x18) return console.error("WK1 unsupported op " + cc.toString(16));
                    else if (cc <= 0x1E) return console.error("WK1 invalid opcode " + cc.toString(16));
                    else if (cc <= 0x73) return console.error("WK1 unsupported function opcode " + cc.toString(16));
                    else return console.error("WK1 unrecognized opcode " + cc.toString(16));
            }
        }
        if (out.length == 1) o[1].f = "" + out[0];
        else console.error("WK1 bad formula parse |" + out.join("|") + "|");
    }
    function parse_cell_3(blob /*::, length*/ ) {
        var o = [
            {
                c: 0,
                r: 0
            },
            {
                t: 'n',
                v: 0
            },
            0
        ];
        o[0].r = blob.read_shift(2);
        o[3] = blob[blob.l++];
        o[0].c = blob[blob.l++];
        return o;
    }
    function parse_LABEL_16(blob, length) {
        var o = parse_cell_3(blob, length);
        o[1].t = 's';
        o[1].v = blob.read_shift(length - 4, 'cstr');
        return o;
    }
    function write_LABEL_16(R, C, wsidx, s) {
        /* TODO: encoding */ var o = $b8f343bf88dacc48$var$new_buf(6 + s.length);
        o.write_shift(2, R);
        o.write_shift(1, wsidx);
        o.write_shift(1, C);
        o.write_shift(1, 0x27);
        for(var i = 0; i < s.length; ++i){
            var cc = s.charCodeAt(i);
            o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
        }
        o.write_shift(1, 0);
        return o;
    }
    function parse_NUMBER_18(blob, length) {
        var o = parse_cell_3(blob, length);
        o[1].v = blob.read_shift(2);
        var v = o[1].v >> 1;
        if (o[1].v & 0x1) switch(v & 0x07){
            case 0:
                v = (v >> 3) * 5000;
                break;
            case 1:
                v = (v >> 3) * 500;
                break;
            case 2:
                v = (v >> 3) / 20;
                break;
            case 3:
                v = (v >> 3) / 200;
                break;
            case 4:
                v = (v >> 3) / 2000;
                break;
            case 5:
                v = (v >> 3) / 20000;
                break;
            case 6:
                v = (v >> 3) / 16;
                break;
            case 7:
                v = (v >> 3) / 64;
                break;
        }
        o[1].v = v;
        return o;
    }
    function parse_NUMBER_17(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(4);
        var v2 = blob.read_shift(4);
        var e = blob.read_shift(2);
        if (e == 0xFFFF) {
            if (v1 === 0 && v2 === 0xC0000000) {
                o[1].t = "e";
                o[1].v = 0x0F;
            } else if (v1 === 0 && v2 === 0xD0000000) {
                o[1].t = "e";
                o[1].v = 0x2A;
            } else o[1].v = 0;
            return o;
        }
        var s = e & 0x8000;
        e = (e & 0x7FFF) - 16446;
        o[1].v = (1 - s * 2) * (v2 * Math.pow(2, e + 32) + v1 * Math.pow(2, e));
        return o;
    }
    function write_NUMBER_17(R, C, wsidx, v) {
        var o = $b8f343bf88dacc48$var$new_buf(14);
        o.write_shift(2, R);
        o.write_shift(1, wsidx);
        o.write_shift(1, C);
        if (v == 0) {
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(2, 0xFFFF);
            return o;
        }
        var s = 0, e = 0, v1 = 0, v2 = 0;
        if (v < 0) {
            s = 1;
            v = -v;
        }
        e = Math.log2(v) | 0;
        v /= Math.pow(2, e - 31);
        v2 = v >>> 0;
        if ((v2 & 0x80000000) == 0) {
            v /= 2;
            ++e;
            v2 = v >>> 0;
        }
        v -= v2;
        v2 |= 0x80000000;
        v2 >>>= 0;
        v *= Math.pow(2, 32);
        v1 = v >>> 0;
        o.write_shift(4, v1);
        o.write_shift(4, v2);
        e += 0x3FFF + (s ? 0x8000 : 0);
        o.write_shift(2, e);
        return o;
    }
    function parse_FORMULA_19(blob, length) {
        var o = parse_NUMBER_17(blob, 14);
        blob.l += length - 14; /* TODO: WK3 formula */ 
        return o;
    }
    function parse_NUMBER_25(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(4);
        o[1].v = v1 >> 6;
        return o;
    }
    function parse_NUMBER_27(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(8, 'f');
        o[1].v = v1;
        return o;
    }
    function parse_FORMULA_28(blob, length) {
        var o = parse_NUMBER_27(blob, 12);
        blob.l += length - 12; /* TODO: formula */ 
        return o;
    }
    function parse_SHEETNAMECS(blob, length) {
        return blob[blob.l + length - 1] == 0 ? blob.read_shift(length, 'cstr') : "";
    }
    function parse_SHEETNAMELP(blob, length) {
        var len = blob[blob.l++];
        if (len > length - 1) len = length - 1;
        var o = "";
        while(o.length < len)o += String.fromCharCode(blob[blob.l++]);
        return o;
    }
    function parse_SHEETINFOQP(blob, length, opts) {
        if (!opts.qpro || length < 21) return;
        var id = blob.read_shift(1);
        blob.l += 17;
        blob.l += 1; //var len = blob.read_shift(1);
        blob.l += 2;
        var nm = blob.read_shift(length - 21, 'cstr');
        return [
            id,
            nm
        ];
    }
    function parse_XFORMAT(blob, length) {
        var o = {}, tgt = blob.l + length;
        while(blob.l < tgt){
            var dt = blob.read_shift(2);
            if (dt == 0x36b0) {
                o[dt] = [
                    0,
                    ""
                ];
                o[dt][0] = blob.read_shift(2);
                while(blob[blob.l]){
                    o[dt][1] += String.fromCharCode(blob[blob.l]);
                    blob.l++;
                }
                blob.l++;
            }
        // TODO: 0x3a99 ??
        }
        return o;
    }
    function write_XFORMAT_SHEETNAME(name, wsidx) {
        var out = $b8f343bf88dacc48$var$new_buf(5 + name.length);
        out.write_shift(2, 0x36b0);
        out.write_shift(2, wsidx);
        for(var i = 0; i < name.length; ++i){
            var cc = name.charCodeAt(i);
            out[out.l++] = cc > 0x7F ? 0x5F : cc;
        }
        out[out.l++] = 0;
        return out;
    }
    var WK1Enum = {
        0x0000: {
            n: "BOF",
            f: $b8f343bf88dacc48$var$parseuint16
        },
        0x0001: {
            n: "EOF"
        },
        0x0002: {
            n: "CALCMODE"
        },
        0x0003: {
            n: "CALCORDER"
        },
        0x0004: {
            n: "SPLIT"
        },
        0x0005: {
            n: "SYNC"
        },
        0x0006: {
            n: "RANGE",
            f: parse_RANGE
        },
        0x0007: {
            n: "WINDOW1"
        },
        0x0008: {
            n: "COLW1"
        },
        0x0009: {
            n: "WINTWO"
        },
        0x000A: {
            n: "COLW2"
        },
        0x000B: {
            n: "NAME"
        },
        0x000C: {
            n: "BLANK"
        },
        0x000D: {
            n: "INTEGER",
            f: parse_INTEGER
        },
        0x000E: {
            n: "NUMBER",
            f: parse_NUMBER
        },
        0x000F: {
            n: "LABEL",
            f: parse_LABEL
        },
        0x0010: {
            n: "FORMULA",
            f: parse_FORMULA
        },
        0x0018: {
            n: "TABLE"
        },
        0x0019: {
            n: "ORANGE"
        },
        0x001A: {
            n: "PRANGE"
        },
        0x001B: {
            n: "SRANGE"
        },
        0x001C: {
            n: "FRANGE"
        },
        0x001D: {
            n: "KRANGE1"
        },
        0x0020: {
            n: "HRANGE"
        },
        0x0023: {
            n: "KRANGE2"
        },
        0x0024: {
            n: "PROTEC"
        },
        0x0025: {
            n: "FOOTER"
        },
        0x0026: {
            n: "HEADER"
        },
        0x0027: {
            n: "SETUP"
        },
        0x0028: {
            n: "MARGINS"
        },
        0x0029: {
            n: "LABELFMT"
        },
        0x002A: {
            n: "TITLES"
        },
        0x002B: {
            n: "SHEETJS"
        },
        0x002D: {
            n: "GRAPH"
        },
        0x002E: {
            n: "NGRAPH"
        },
        0x002F: {
            n: "CALCCOUNT"
        },
        0x0030: {
            n: "UNFORMATTED"
        },
        0x0031: {
            n: "CURSORW12"
        },
        0x0032: {
            n: "WINDOW"
        },
        0x0033: {
            n: "STRING",
            f: parse_STRING
        },
        0x0037: {
            n: "PASSWORD"
        },
        0x0038: {
            n: "LOCKED"
        },
        0x003C: {
            n: "QUERY"
        },
        0x003D: {
            n: "QUERYNAME"
        },
        0x003E: {
            n: "PRINT"
        },
        0x003F: {
            n: "PRINTNAME"
        },
        0x0040: {
            n: "GRAPH2"
        },
        0x0041: {
            n: "GRAPHNAME"
        },
        0x0042: {
            n: "ZOOM"
        },
        0x0043: {
            n: "SYMSPLIT"
        },
        0x0044: {
            n: "NSROWS"
        },
        0x0045: {
            n: "NSCOLS"
        },
        0x0046: {
            n: "RULER"
        },
        0x0047: {
            n: "NNAME"
        },
        0x0048: {
            n: "ACOMM"
        },
        0x0049: {
            n: "AMACRO"
        },
        0x004A: {
            n: "PARSE"
        },
        // 0x0064
        0x0066: {
            n: "PRANGES??"
        },
        0x0067: {
            n: "RRANGES??"
        },
        0x0068: {
            n: "FNAME??"
        },
        0x0069: {
            n: "MRANGES??"
        },
        // 0x0096
        // 0x0099
        // 0x009A
        // 0x009B
        // 0x009C
        // 0x00C0
        // 0x00C7
        // 0x00C9
        0x00CC: {
            n: "SHEETNAMECS",
            f: parse_SHEETNAMECS
        },
        // 0x00CD
        0x00DE: {
            n: "SHEETNAMELP",
            f: parse_SHEETNAMELP
        },
        0x00FF: {
            n: "BOF",
            f: $b8f343bf88dacc48$var$parseuint16
        },
        0x5402: {
            n: "WKSNF",
            f: $b8f343bf88dacc48$var$parseuint16
        },
        0xFFFF: {
            n: ""
        }
    };
    var WK3Enum = {
        0x0000: {
            n: "BOF"
        },
        0x0001: {
            n: "EOF"
        },
        0x0002: {
            n: "PASSWORD"
        },
        0x0003: {
            n: "CALCSET"
        },
        0x0004: {
            n: "WINDOWSET"
        },
        0x0005: {
            n: "SHEETCELLPTR"
        },
        0x0006: {
            n: "SHEETLAYOUT"
        },
        0x0007: {
            n: "COLUMNWIDTH"
        },
        0x0008: {
            n: "HIDDENCOLUMN"
        },
        0x0009: {
            n: "USERRANGE"
        },
        0x000A: {
            n: "SYSTEMRANGE"
        },
        0x000B: {
            n: "ZEROFORCE"
        },
        0x000C: {
            n: "SORTKEYDIR"
        },
        0x000D: {
            n: "FILESEAL"
        },
        0x000E: {
            n: "DATAFILLNUMS"
        },
        0x000F: {
            n: "PRINTMAIN"
        },
        0x0010: {
            n: "PRINTSTRING"
        },
        0x0011: {
            n: "GRAPHMAIN"
        },
        0x0012: {
            n: "GRAPHSTRING"
        },
        0x0013: {
            n: "??"
        },
        0x0014: {
            n: "ERRCELL"
        },
        0x0015: {
            n: "NACELL"
        },
        0x0016: {
            n: "LABEL16",
            f: parse_LABEL_16
        },
        0x0017: {
            n: "NUMBER17",
            f: parse_NUMBER_17
        },
        0x0018: {
            n: "NUMBER18",
            f: parse_NUMBER_18
        },
        0x0019: {
            n: "FORMULA19",
            f: parse_FORMULA_19
        },
        0x001A: {
            n: "FORMULA1A"
        },
        0x001B: {
            n: "XFORMAT",
            f: parse_XFORMAT
        },
        0x001C: {
            n: "DTLABELMISC"
        },
        0x001D: {
            n: "DTLABELCELL"
        },
        0x001E: {
            n: "GRAPHWINDOW"
        },
        0x001F: {
            n: "CPA"
        },
        0x0020: {
            n: "LPLAUTO"
        },
        0x0021: {
            n: "QUERY"
        },
        0x0022: {
            n: "HIDDENSHEET"
        },
        0x0023: {
            n: "??"
        },
        0x0025: {
            n: "NUMBER25",
            f: parse_NUMBER_25
        },
        0x0026: {
            n: "??"
        },
        0x0027: {
            n: "NUMBER27",
            f: parse_NUMBER_27
        },
        0x0028: {
            n: "FORMULA28",
            f: parse_FORMULA_28
        },
        0x008E: {
            n: "??"
        },
        0x0093: {
            n: "??"
        },
        0x0096: {
            n: "??"
        },
        0x0097: {
            n: "??"
        },
        0x0098: {
            n: "??"
        },
        0x0099: {
            n: "??"
        },
        0x009A: {
            n: "??"
        },
        0x009B: {
            n: "??"
        },
        0x009C: {
            n: "??"
        },
        0x00A3: {
            n: "??"
        },
        0x00AE: {
            n: "??"
        },
        0x00AF: {
            n: "??"
        },
        0x00B0: {
            n: "??"
        },
        0x00B1: {
            n: "??"
        },
        0x00B8: {
            n: "??"
        },
        0x00B9: {
            n: "??"
        },
        0x00BA: {
            n: "??"
        },
        0x00BB: {
            n: "??"
        },
        0x00BC: {
            n: "??"
        },
        0x00C3: {
            n: "??"
        },
        0x00C9: {
            n: "??"
        },
        0x00CC: {
            n: "SHEETNAMECS",
            f: parse_SHEETNAMECS
        },
        0x00CD: {
            n: "??"
        },
        0x00CE: {
            n: "??"
        },
        0x00CF: {
            n: "??"
        },
        0x00D0: {
            n: "??"
        },
        0x0100: {
            n: "??"
        },
        0x0103: {
            n: "??"
        },
        0x0104: {
            n: "??"
        },
        0x0105: {
            n: "??"
        },
        0x0106: {
            n: "??"
        },
        0x0107: {
            n: "??"
        },
        0x0109: {
            n: "??"
        },
        0x010A: {
            n: "??"
        },
        0x010B: {
            n: "??"
        },
        0x010C: {
            n: "??"
        },
        0x010E: {
            n: "??"
        },
        0x010F: {
            n: "??"
        },
        0x0180: {
            n: "??"
        },
        0x0185: {
            n: "??"
        },
        0x0186: {
            n: "??"
        },
        0x0189: {
            n: "??"
        },
        0x018C: {
            n: "??"
        },
        0x0200: {
            n: "??"
        },
        0x0202: {
            n: "??"
        },
        0x0201: {
            n: "??"
        },
        0x0204: {
            n: "??"
        },
        0x0205: {
            n: "??"
        },
        0x0280: {
            n: "??"
        },
        0x0281: {
            n: "??"
        },
        0x0282: {
            n: "??"
        },
        0x0283: {
            n: "??"
        },
        0x0284: {
            n: "??"
        },
        0x0285: {
            n: "??"
        },
        0x0286: {
            n: "??"
        },
        0x0287: {
            n: "??"
        },
        0x0288: {
            n: "??"
        },
        0x0292: {
            n: "??"
        },
        0x0293: {
            n: "??"
        },
        0x0294: {
            n: "??"
        },
        0x0295: {
            n: "??"
        },
        0x0296: {
            n: "??"
        },
        0x0299: {
            n: "??"
        },
        0x029A: {
            n: "??"
        },
        0x0300: {
            n: "??"
        },
        0x0304: {
            n: "??"
        },
        0x0601: {
            n: "SHEETINFOQP",
            f: parse_SHEETINFOQP
        },
        0x0640: {
            n: "??"
        },
        0x0642: {
            n: "??"
        },
        0x0701: {
            n: "??"
        },
        0x0702: {
            n: "??"
        },
        0x0703: {
            n: "??"
        },
        0x0704: {
            n: "??"
        },
        0x0780: {
            n: "??"
        },
        0x0800: {
            n: "??"
        },
        0x0801: {
            n: "??"
        },
        0x0804: {
            n: "??"
        },
        0x0A80: {
            n: "??"
        },
        0x2AF6: {
            n: "??"
        },
        0x3231: {
            n: "??"
        },
        0x6E49: {
            n: "??"
        },
        0x6F44: {
            n: "??"
        },
        0xFFFF: {
            n: ""
        }
    };
    /* TODO: fill out and verify this table across QP versions */ var QPWNFTable = {
        0x05: "dd-mmm-yy",
        0x06: "dd-mmm",
        0x07: "mmm-yy",
        0x08: "mm/dd/yy",
        0x0A: "hh:mm:ss AM/PM",
        0x0B: "hh:mm AM/PM",
        0x0E: "dd-mmm-yyyy",
        0x0F: "mmm-yyyy",
        /* It is suspected that the the low nybble specifies decimal places */ 0x0022: "0.00",
        0x0032: "0.00;[Red]0.00",
        0x0042: "0.00;\(0.00\)",
        0x0052: "0.00;[Red]\(0.00\)",
        0x00A2: '"$"#,##0.00;\\("$"#,##0.00\\)',
        0x0120: '0%',
        0x0130: '0E+00',
        0x0140: '# ?/?'
    };
    function parse_qpw_str(p) {
        var cch = p.read_shift(2);
        var flags = p.read_shift(1);
        /* TODO: find examples with nonzero flags */ if (flags != 0) throw "unsupported QPW string type " + flags.toString(16);
        return p.read_shift(cch, "sbcs-cont");
    }
    /* QPW uses a different set of record types */ function qpw_to_workbook_buf(d, opts) /*:Workbook*/ {
        $b8f343bf88dacc48$var$prep_blob(d, 0);
        var o = opts || {};
        if ($b8f343bf88dacc48$var$DENSE != null && o.dense == null) o.dense = $b8f343bf88dacc48$var$DENSE;
        var s /*:Worksheet*/  = {} /*:any*/ ;
        if (o.dense) s["!data"] = [];
        var SST = [], sname = "", formulae = [];
        var range = {
            s: {
                r: -1,
                c: -1
            },
            e: {
                r: -1,
                c: -1
            }
        };
        var cnt = 0, type = 0, C = 0, R = 0;
        var wb = {
            SheetNames: [],
            Sheets: {}
        };
        var FMTS = [];
        outer: while(d.l < d.length){
            var RT = d.read_shift(2), length = d.read_shift(2);
            var p = d.slice(d.l, d.l + length);
            $b8f343bf88dacc48$var$prep_blob(p, 0);
            switch(RT){
                case 0x01:
                    /* BOF */ if (p.read_shift(4) != 0x39575051) throw "Bad QPW9 BOF!";
                    break;
                case 0x02:
                    break outer;
                case 0x08:
                    break; // TODO: this is tied to custom number formats
                case 0x0A:
                    var fcnt = p.read_shift(4);
                    var step = (p.length - p.l) / fcnt | 0;
                    for(var ifmt = 0; ifmt < fcnt; ++ifmt){
                        var end = p.l + step;
                        var fmt = {};
                        p.l += 2;
                        fmt.numFmtId = p.read_shift(2);
                        if (QPWNFTable[fmt.numFmtId]) fmt.z = QPWNFTable[fmt.numFmtId];
                        p.l = end;
                        FMTS.push(fmt);
                    }
                    break;
                /* TODO: The behavior here should be consistent with Numbers: QP Notebook ~ .TN.SheetArchive, QP Sheet ~ .TST.TableModelArchive */ case 0x0401:
                    break;
                case 0x0402:
                    break;
                case 0x0407:
                    p.l += 12;
                    while(p.l < p.length){
                        cnt = p.read_shift(2);
                        type = p.read_shift(1);
                        SST.push(p.read_shift(cnt, 'cstr'));
                    }
                    break;
                case 0x0408:
                    break;
                case 0x0601:
                    var sidx = p.read_shift(2);
                    s = {} /*:any*/ ;
                    if (o.dense) s["!data"] = [];
                    range.s.c = p.read_shift(2);
                    range.e.c = p.read_shift(2);
                    range.s.r = p.read_shift(4);
                    range.e.r = p.read_shift(4);
                    p.l += 4;
                    if (p.l + 2 < p.length) {
                        cnt = p.read_shift(2);
                        type = p.read_shift(1);
                        sname = cnt == 0 ? "" : p.read_shift(cnt, 'cstr');
                    }
                    if (!sname) sname = $b8f343bf88dacc48$var$encode_col(sidx);
                    break;
                case 0x0602:
                    /* NOTE: QP valid range A1:IV1000000 */ if (range.s.c > 0xFF || range.s.r > 999999) break;
                    if (range.e.c < range.s.c) range.e.c = range.s.c;
                    if (range.e.r < range.s.r) range.e.r = range.s.r;
                    s["!ref"] = $b8f343bf88dacc48$var$encode_range(range);
                    $b8f343bf88dacc48$var$book_append_sheet(wb, s, sname); // TODO: a barrel roll
                    break;
                case 0x0A01:
                    C = p.read_shift(2);
                    if (range.e.c < C) range.e.c = C;
                    if (range.s.c > C) range.s.c = C;
                    R = p.read_shift(4);
                    if (range.s.r > R) range.s.r = R;
                    R = p.read_shift(4);
                    if (range.e.r < R) range.e.r = R;
                    break;
                case 0x0C01:
                    R = p.read_shift(4), cnt = p.read_shift(4);
                    if (range.s.r > R) range.s.r = R;
                    if (range.e.r < R + cnt - 1) range.e.r = R + cnt - 1;
                    var CC = $b8f343bf88dacc48$var$encode_col(C);
                    while(p.l < p.length){
                        var cell = {
                            t: "z"
                        };
                        var flags = p.read_shift(1), fmtidx = -1;
                        if (flags & 0x80) fmtidx = p.read_shift(2);
                        var mul = flags & 0x40 ? p.read_shift(2) - 1 : 0;
                        switch(flags & 0x1F){
                            case 0:
                                break;
                            case 1:
                                break;
                            case 2:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(2)
                                };
                                break;
                            case 3:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(2, 'i')
                                };
                                break;
                            case 4:
                                cell = {
                                    t: "n",
                                    v: $b8f343bf88dacc48$var$parse_RkNumber(p)
                                };
                                break;
                            case 5:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(8, 'f')
                                };
                                break;
                            case 7:
                                cell = {
                                    t: "s",
                                    v: SST[type = p.read_shift(4) - 1]
                                };
                                break;
                            case 8:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(8, 'f')
                                };
                                p.l += 2; /* cell.f = formulae[p.read_shift(4)]; */ 
                                p.l += 4;
                                if (isNaN(cell.v)) cell = {
                                    t: "e",
                                    v: 0x0F
                                }; // #VALUE!
                                break;
                            default:
                                throw "Unrecognized QPW cell type " + (flags & 0x1F);
                        }
                        if (fmtidx != -1 && (FMTS[fmtidx - 1] || {}).z) cell.z = FMTS[fmtidx - 1].z;
                        var delta = 0;
                        if (flags & 0x20) switch(flags & 0x1F){
                            case 2:
                                delta = p.read_shift(2);
                                break;
                            case 3:
                                delta = p.read_shift(2, 'i');
                                break;
                            case 7:
                                delta = p.read_shift(2);
                                break;
                            default:
                                throw "Unsupported delta for QPW cell type " + (flags & 0x1F);
                        }
                        if (!(!o.sheetStubs && cell.t == "z")) {
                            var newcell = $b8f343bf88dacc48$var$dup(cell);
                            if (cell.t == "n" && cell.z && $b8f343bf88dacc48$var$fmt_is_date(cell.z) && o.cellDates) {
                                newcell.v = $b8f343bf88dacc48$var$numdate(cell.v);
                                newcell.t = typeof newcell.v == "number" ? 'n' : 'd';
                            }
                            if (s["!data"] != null) {
                                if (!s["!data"][R]) s["!data"][R] = [];
                                s["!data"][R][C] = newcell;
                            } else s[CC + $b8f343bf88dacc48$var$encode_row(R)] = newcell;
                        }
                        ++R;
                        --cnt;
                        while(mul-- > 0 && cnt >= 0){
                            if (flags & 0x20) switch(flags & 0x1F){
                                case 2:
                                    cell = {
                                        t: "n",
                                        v: cell.v + delta & 0xFFFF
                                    };
                                    break;
                                case 3:
                                    cell = {
                                        t: "n",
                                        v: cell.v + delta & 0xFFFF
                                    };
                                    if (cell.v > 0x7FFF) cell.v -= 0x10000;
                                    break;
                                case 7:
                                    cell = {
                                        t: "s",
                                        v: SST[type = type + delta >>> 0]
                                    };
                                    break;
                                default:
                                    throw "Cannot apply delta for QPW cell type " + (flags & 0x1F);
                            }
                            else switch(flags & 0x1F){
                                case 1:
                                    cell = {
                                        t: "z"
                                    };
                                    break;
                                case 2:
                                    cell = {
                                        t: "n",
                                        v: p.read_shift(2)
                                    };
                                    break;
                                case 7:
                                    cell = {
                                        t: "s",
                                        v: SST[type = p.read_shift(4) - 1]
                                    };
                                    break;
                                default:
                                    throw "Cannot apply repeat for QPW cell type " + (flags & 0x1F);
                            }
                            fmtidx;
                            if (!(!o.sheetStubs && cell.t == "z")) {
                                if (s["!data"] != null) {
                                    if (!s["!data"][R]) s["!data"][R] = [];
                                    s["!data"][R][C] = cell;
                                } else s[CC + $b8f343bf88dacc48$var$encode_row(R)] = cell;
                            }
                            ++R;
                            --cnt;
                        }
                    }
                    break;
                case 0x0C02:
                    C = p.read_shift(2);
                    R = p.read_shift(4);
                    var str = parse_qpw_str(p);
                    /* TODO: QP10 record has an additional unknown character after the string */ if (s["!data"] != null) {
                        if (!s["!data"][R]) s["!data"][R] = [];
                        s["!data"][R][C] = {
                            t: "s",
                            v: str
                        };
                    } else s[$b8f343bf88dacc48$var$encode_col(C) + $b8f343bf88dacc48$var$encode_row(R)] = {
                        t: "s",
                        v: str
                    };
                    break;
                default:
                    break;
            }
            d.l += length;
        }
        return wb;
    }
    return {
        sheet_to_wk1: sheet_to_wk1,
        book_to_wk3: book_to_wk3,
        to_workbook: lotus_to_workbook
    };
}();
/* 18.4.7 rPr CT_RPrElt */ function $b8f343bf88dacc48$var$parse_rpr(rpr) {
    var font = {}, m = rpr.match($b8f343bf88dacc48$var$tagregex), i = 0;
    var pass = false;
    if (m) for(; i != m.length; ++i){
        var y = $b8f343bf88dacc48$var$parsexmltag(m[i]);
        switch(y[0].replace(/<\w*:/g, "<")){
            /* 18.8.12 condense CT_BooleanProperty */ /* ** not required . */ case '<condense':
                break;
            /* 18.8.17 extend CT_BooleanProperty */ /* ** not required . */ case '<extend':
                break;
            /* 18.8.36 shadow CT_BooleanProperty */ /* ** not required . */ case '<shadow':
                if (!y.val) break;
            /* falls through */ case '<shadow>':
            case '<shadow/>':
                font.shadow = 1;
                break;
            case '</shadow>':
                break;
            /* 18.4.1 charset CT_IntProperty TODO */ case '<charset':
                if (y.val == '1') break;
                font.cp = $b8f343bf88dacc48$var$CS2CP[parseInt(y.val, 10)];
                break;
            /* 18.4.2 outline CT_BooleanProperty TODO */ case '<outline':
                if (!y.val) break;
            /* falls through */ case '<outline>':
            case '<outline/>':
                font.outline = 1;
                break;
            case '</outline>':
                break;
            /* 18.4.5 rFont CT_FontName */ case '<rFont':
                font.name = y.val;
                break;
            /* 18.4.11 sz CT_FontSize */ case '<sz':
                font.sz = y.val;
                break;
            /* 18.4.10 strike CT_BooleanProperty */ case '<strike':
                if (!y.val) break;
            /* falls through */ case '<strike>':
            case '<strike/>':
                font.strike = 1;
                break;
            case '</strike>':
                break;
            /* 18.4.13 u CT_UnderlineProperty */ case '<u':
                if (!y.val) break;
                switch(y.val){
                    case 'double':
                        font.uval = "double";
                        break;
                    case 'singleAccounting':
                        font.uval = "single-accounting";
                        break;
                    case 'doubleAccounting':
                        font.uval = "double-accounting";
                        break;
                }
            /* falls through */ case '<u>':
            case '<u/>':
                font.u = 1;
                break;
            case '</u>':
                break;
            /* 18.8.2 b */ case '<b':
                if (y.val == '0') break;
            /* falls through */ case '<b>':
            case '<b/>':
                font.b = 1;
                break;
            case '</b>':
                break;
            /* 18.8.26 i */ case '<i':
                if (y.val == '0') break;
            /* falls through */ case '<i>':
            case '<i/>':
                font.i = 1;
                break;
            case '</i>':
                break;
            /* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */ case '<color':
                if (y.rgb) font.color = y.rgb.slice(2, 8);
                break;
            case '<color>':
            case '<color/>':
            case '</color>':
                break;
            /* 18.8.18 family ST_FontFamily */ case '<family':
                font.family = y.val;
                break;
            case '<family>':
            case '<family/>':
            case '</family>':
                break;
            /* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */ case '<vertAlign':
                font.valign = y.val;
                break;
            case '<vertAlign>':
            case '<vertAlign/>':
            case '</vertAlign>':
                break;
            /* 18.8.35 scheme CT_FontScheme TODO */ case '<scheme':
                break;
            case '<scheme>':
            case '<scheme/>':
            case '</scheme>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (y[0].charCodeAt(1) !== 47 && !pass) throw new Error('Unrecognized rich format ' + y[0]);
        }
    }
    return font;
}
var $b8f343bf88dacc48$var$parse_rs = /*#__PURE__*/ function() {
    /* 18.4.4 r CT_RElt */ function parse_r(r) {
        /* 18.4.12 t ST_Xstring */ var t = $b8f343bf88dacc48$var$str_match_xml_ns(r, "t") /*, cp = 65001*/ ;
        if (!t) return {
            t: "s",
            v: ""
        };
        var o /*:Cell*/  = {
            t: 's',
            v: $b8f343bf88dacc48$var$unescapexml(t[1])
        } /*:any*/ ;
        var rpr = $b8f343bf88dacc48$var$str_match_xml_ns(r, "rPr");
        if (rpr) o.s = $b8f343bf88dacc48$var$parse_rpr(rpr[1]);
        return o;
    }
    var rregex = /<(?:\w+:)?r>/g, rend = /<\/(?:\w+:)?r>/;
    return function parse_rs(rs) {
        return rs.replace(rregex, "").split(rend).map(parse_r).filter(function(r) {
            return r.v;
        });
    };
}();
/* Parse a list of <r> tags */ var $b8f343bf88dacc48$var$rs_to_html = /*#__PURE__*/ function parse_rs_factory() {
    var nlregex = /(\r\n|\n)/g;
    function parse_rpr2(font, intro, outro) {
        var style /*:Array<string>*/  = [];
        if (font.u) style.push("text-decoration: underline;");
        if (font.uval) style.push("text-underline-style:" + font.uval + ";");
        if (font.sz) style.push("font-size:" + font.sz + "pt;");
        if (font.outline) style.push("text-effect: outline;");
        if (font.shadow) style.push("text-shadow: auto;");
        intro.push('<span style="' + style.join("") + '">');
        if (font.b) {
            intro.push("<b>");
            outro.push("</b>");
        }
        if (font.i) {
            intro.push("<i>");
            outro.push("</i>");
        }
        if (font.strike) {
            intro.push("<s>");
            outro.push("</s>");
        }
        var align = font.valign || "";
        if (align == "superscript" || align == "super") align = "sup";
        else if (align == "subscript") align = "sub";
        if (align != "") {
            intro.push("<" + align + ">");
            outro.push("</" + align + ">");
        }
        outro.push("</span>");
        return font;
    }
    /* 18.4.4 r CT_RElt */ function r_to_html(r) {
        var terms /*:[Array<string>, string, Array<string>]*/  = [
            [],
            r.v,
            []
        ];
        if (!r.v) return "";
        if (r.s) parse_rpr2(r.s, terms[0], terms[2]);
        return terms[0].join("") + terms[1].replace(nlregex, '<br/>') + terms[2].join("");
    }
    return function parse_rs(rs) {
        return rs.map(r_to_html).join("");
    };
}();
/* 18.4.8 si CT_Rst */ var $b8f343bf88dacc48$var$sitregex = /<(?:\w+:)?t\b[^<>]*>([^<]*)<\/(?:\w+:)?t>/g, $b8f343bf88dacc48$var$sirregex = /<(?:\w+:)?r\b[^<>]*>/;
function $b8f343bf88dacc48$var$parse_si(x, opts) {
    var html = opts ? opts.cellHTML : true;
    var z = {};
    if (!x) return {
        t: ""
    };
    //var y;
    /* 18.4.12 t ST_Xstring (Plaintext String) */ // TODO: is whitespace actually valid here?
    if (x.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
        z.t = $b8f343bf88dacc48$var$unescapexml($b8f343bf88dacc48$var$utf8read(x.slice(x.indexOf(">") + 1).split(/<\/(?:\w+:)?t>/)[0] || ""), true);
        z.r = $b8f343bf88dacc48$var$utf8read(x);
        if (html) z.h = $b8f343bf88dacc48$var$escapehtml(z.t);
    } else if (/*y = */ x.match($b8f343bf88dacc48$var$sirregex)) {
        z.r = $b8f343bf88dacc48$var$utf8read(x);
        z.t = $b8f343bf88dacc48$var$unescapexml($b8f343bf88dacc48$var$utf8read(($b8f343bf88dacc48$var$str_remove_xml_ns_g(x, "rPh").match($b8f343bf88dacc48$var$sitregex) || []).join("").replace($b8f343bf88dacc48$var$tagregex, "")), true);
        if (html) z.h = $b8f343bf88dacc48$var$rs_to_html($b8f343bf88dacc48$var$parse_rs(z.r));
    }
    /* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */ /* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */ return z;
}
/* 18.4 Shared String Table */ var $b8f343bf88dacc48$var$sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g;
var $b8f343bf88dacc48$var$sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
function $b8f343bf88dacc48$var$parse_sst_xml(data /*:string*/ , opts) /*:SST*/ {
    var s /*:SST*/  = [], ss = "";
    if (!data) return s;
    /* 18.4.9 sst CT_Sst */ var sst = $b8f343bf88dacc48$var$str_match_xml_ns(data, "sst");
    if (sst) {
        ss = sst[1].replace($b8f343bf88dacc48$var$sstr1, "").split($b8f343bf88dacc48$var$sstr2);
        for(var i = 0; i != ss.length; ++i){
            var o = $b8f343bf88dacc48$var$parse_si(ss[i].trim(), opts);
            if (o != null) s[s.length] = o;
        }
        sst = $b8f343bf88dacc48$var$parsexmltag(sst[0].slice(0, sst[0].indexOf(">")));
        s.Count = sst.count;
        s.Unique = sst.uniqueCount;
    }
    return s;
}
var $b8f343bf88dacc48$var$straywsregex = /^\s|\s$|[\t\n\r]/;
function $b8f343bf88dacc48$var$write_sst_xml(sst /*:SST*/ , opts) /*:string*/ {
    if (!opts.bookSST) return "";
    var o = [
        $b8f343bf88dacc48$var$XML_HEADER
    ];
    o[o.length] = $b8f343bf88dacc48$var$writextag('sst', null, {
        xmlns: $b8f343bf88dacc48$var$XMLNS_main[0],
        count: sst.Count,
        uniqueCount: sst.Unique
    });
    for(var i = 0; i != sst.length; ++i){
        if (sst[i] == null) continue;
        var s /*:XLString*/  = sst[i];
        var sitag = "<si>";
        if (s.r) sitag += s.r;
        else {
            sitag += "<t";
            if (!s.t) s.t = "";
            if (typeof s.t !== "string") s.t = String(s.t);
            if (s.t.match($b8f343bf88dacc48$var$straywsregex)) sitag += ' xml:space="preserve"';
            sitag += ">" + $b8f343bf88dacc48$var$escapexml(s.t) + "</t>";
        }
        sitag += "</si>";
        o[o.length] = sitag;
    }
    if (o.length > 2) {
        o[o.length] = '</sst>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.221 BrtBeginSst */ function $b8f343bf88dacc48$var$parse_BrtBeginSst(data) {
    return [
        data.read_shift(4),
        data.read_shift(4)
    ];
}
/* [MS-XLSB] 2.1.7.45 Shared Strings */ function $b8f343bf88dacc48$var$parse_sst_bin(data, opts) /*:SST*/ {
    var s /*:SST*/  = [];
    var pass = false;
    $b8f343bf88dacc48$var$recordhopper(data, function hopper_sst(val, R, RT) {
        switch(RT){
            case 0x009F:
                /* BrtBeginSst */ s.Count = val[0];
                s.Unique = val[1];
                break;
            case 0x0013:
                /* BrtSSTItem */ s.push(val);
                break;
            case 0x00A0:
                /* BrtEndSst */ return true;
            case 0x0023:
                /* BrtFRTBegin */ pass = true;
                break;
            case 0x0024:
                /* BrtFRTEnd */ pass = false;
                break;
            default:
                R.T;
                if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return s;
}
function $b8f343bf88dacc48$var$write_BrtBeginSst(sst, o) {
    if (!o) o = $b8f343bf88dacc48$var$new_buf(8);
    o.write_shift(4, sst.Count);
    o.write_shift(4, sst.Unique);
    return o;
}
var $b8f343bf88dacc48$var$write_BrtSSTItem = $b8f343bf88dacc48$var$write_RichStr;
function $b8f343bf88dacc48$var$write_sst_bin(sst /*::, opts*/ ) {
    var ba = $b8f343bf88dacc48$var$buf_array();
    $b8f343bf88dacc48$var$write_record(ba, 0x009F /* BrtBeginSst */ , $b8f343bf88dacc48$var$write_BrtBeginSst(sst));
    for(var i = 0; i < sst.length; ++i)$b8f343bf88dacc48$var$write_record(ba, 0x0013 /* BrtSSTItem */ , $b8f343bf88dacc48$var$write_BrtSSTItem(sst[i]));
    /* FRTSST */ $b8f343bf88dacc48$var$write_record(ba, 0x00A0 /* BrtEndSst */ );
    return ba.end();
}
function $b8f343bf88dacc48$var$_JS2ANSI(str /*:string*/ ) /*:Array<number>*/ {
    if (typeof $b8f343bf88dacc48$var$$cptable !== 'undefined') return $b8f343bf88dacc48$var$$cptable.utils.encode($b8f343bf88dacc48$var$current_ansi, str);
    var o /*:Array<number>*/  = [], oo = str.split("");
    for(var i = 0; i < oo.length; ++i)o[i] = oo[i].charCodeAt(0);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.4 Version */ function $b8f343bf88dacc48$var$parse_CRYPTOVersion(blob, length /*:?number*/ ) {
    var o /*:any*/  = {};
    o.Major = blob.read_shift(2);
    o.Minor = blob.read_shift(2);
    /*:: if(length == null) return o; */ if (length >= 4) blob.l += length - 4;
    return o;
}
/* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */ function $b8f343bf88dacc48$var$parse_DataSpaceVersionInfo(blob) {
    var o = {};
    o.id = blob.read_shift(0, 'lpp4');
    o.R = $b8f343bf88dacc48$var$parse_CRYPTOVersion(blob, 4);
    o.U = $b8f343bf88dacc48$var$parse_CRYPTOVersion(blob, 4);
    o.W = $b8f343bf88dacc48$var$parse_CRYPTOVersion(blob, 4);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */ function $b8f343bf88dacc48$var$parse_DataSpaceMapEntry(blob) {
    var len = blob.read_shift(4);
    var end = blob.l + len - 4;
    var o = {};
    var cnt = blob.read_shift(4);
    var comps /*:Array<{t:number, v:string}>*/  = [];
    /* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */ while(cnt-- > 0)comps.push({
        t: blob.read_shift(4),
        v: blob.read_shift(0, 'lpp4')
    });
    o.name = blob.read_shift(0, 'lpp4');
    o.comps = comps;
    if (blob.l != end) throw new Error("Bad DataSpaceMapEntry: " + blob.l + " != " + end);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */ function $b8f343bf88dacc48$var$parse_DataSpaceMap(blob) {
    var o = [];
    blob.l += 4; // must be 0x8
    var cnt = blob.read_shift(4);
    while(cnt-- > 0)o.push($b8f343bf88dacc48$var$parse_DataSpaceMapEntry(blob));
    return o;
}
/* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */ function $b8f343bf88dacc48$var$parse_DataSpaceDefinition(blob) /*:Array<string>*/ {
    var o /*:Array<string>*/  = [];
    blob.l += 4; // must be 0x8
    var cnt = blob.read_shift(4);
    while(cnt-- > 0)o.push(blob.read_shift(0, 'lpp4'));
    return o;
}
/* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */ function $b8f343bf88dacc48$var$parse_TransformInfoHeader(blob) {
    var o = {};
    /*var len = */ blob.read_shift(4);
    blob.l += 4; // must be 0x1
    o.id = blob.read_shift(0, 'lpp4');
    o.name = blob.read_shift(0, 'lpp4');
    o.R = $b8f343bf88dacc48$var$parse_CRYPTOVersion(blob, 4);
    o.U = $b8f343bf88dacc48$var$parse_CRYPTOVersion(blob, 4);
    o.W = $b8f343bf88dacc48$var$parse_CRYPTOVersion(blob, 4);
    return o;
}
function $b8f343bf88dacc48$var$parse_Primary(blob) {
    /* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */ var hdr = $b8f343bf88dacc48$var$parse_TransformInfoHeader(blob);
    /* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */ hdr.ename = blob.read_shift(0, '8lpp4');
    hdr.blksz = blob.read_shift(4);
    hdr.cmode = blob.read_shift(4);
    if (blob.read_shift(4) != 0x04) throw new Error("Bad !Primary record");
    return hdr;
}
/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */ function $b8f343bf88dacc48$var$parse_EncryptionHeader(blob, length /*:number*/ ) {
    var tgt = blob.l + length;
    var o = {};
    o.Flags = blob.read_shift(4) & 0x3F;
    blob.l += 4;
    o.AlgID = blob.read_shift(4);
    var valid = false;
    switch(o.AlgID){
        case 0x660E:
        case 0x660F:
        case 0x6610:
            valid = o.Flags == 0x24;
            break;
        case 0x6801:
            valid = o.Flags == 0x04;
            break;
        case 0:
            valid = o.Flags == 0x10 || o.Flags == 0x04 || o.Flags == 0x24;
            break;
        default:
            throw 'Unrecognized encryption algorithm: ' + o.AlgID;
    }
    if (!valid) throw new Error("Encryption Flags/AlgID mismatch");
    o.AlgIDHash = blob.read_shift(4);
    o.KeySize = blob.read_shift(4);
    o.ProviderType = blob.read_shift(4);
    blob.l += 8;
    o.CSPName = blob.read_shift(tgt - blob.l >> 1, 'utf16le');
    blob.l = tgt;
    return o;
}
/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */ function $b8f343bf88dacc48$var$parse_EncryptionVerifier(blob, length /*:number*/ ) {
    var o = {}, tgt = blob.l + length;
    blob.l += 4; // SaltSize must be 0x10
    o.Salt = blob.slice(blob.l, blob.l + 16);
    blob.l += 16;
    o.Verifier = blob.slice(blob.l, blob.l + 16);
    blob.l += 16;
    /*var sz = */ blob.read_shift(4);
    o.VerifierHash = blob.slice(blob.l, tgt);
    blob.l = tgt;
    return o;
}
/* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */ function $b8f343bf88dacc48$var$parse_EncryptionInfo(blob) {
    var vers = $b8f343bf88dacc48$var$parse_CRYPTOVersion(blob);
    switch(vers.Minor){
        case 0x02:
            return [
                vers.Minor,
                $b8f343bf88dacc48$var$parse_EncInfoStd(blob, vers)
            ];
        case 0x03:
            return [
                vers.Minor,
                $b8f343bf88dacc48$var$parse_EncInfoExt(blob, vers)
            ];
        case 0x04:
            return [
                vers.Minor,
                $b8f343bf88dacc48$var$parse_EncInfoAgl(blob, vers)
            ];
    }
    throw new Error("ECMA-376 Encrypted file unrecognized Version: " + vers.Minor);
}
/* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */ function $b8f343bf88dacc48$var$parse_EncInfoStd(blob /*::, vers*/ ) {
    var flags = blob.read_shift(4);
    if ((flags & 0x3F) != 0x24) throw new Error("EncryptionInfo mismatch");
    var sz = blob.read_shift(4);
    //var tgt = blob.l + sz;
    var hdr = $b8f343bf88dacc48$var$parse_EncryptionHeader(blob, sz);
    var verifier = $b8f343bf88dacc48$var$parse_EncryptionVerifier(blob, blob.length - blob.l);
    return {
        t: "Std",
        h: hdr,
        v: verifier
    };
}
/* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */ function $b8f343bf88dacc48$var$parse_EncInfoExt() {
    throw new Error("File is password-protected: ECMA-376 Extensible");
}
/* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */ function $b8f343bf88dacc48$var$parse_EncInfoAgl(blob /*::, vers*/ ) {
    var KeyData = [
        "saltSize",
        "blockSize",
        "keyBits",
        "hashSize",
        "cipherAlgorithm",
        "cipherChaining",
        "hashAlgorithm",
        "saltValue"
    ];
    blob.l += 4;
    var xml = blob.read_shift(blob.length - blob.l, 'utf8');
    var o = {};
    xml.replace($b8f343bf88dacc48$var$tagregex, function xml_agile(x) {
        var y /*:any*/  = $b8f343bf88dacc48$var$parsexmltag(x);
        switch($b8f343bf88dacc48$var$strip_ns(y[0])){
            case '<?xml':
                break;
            case '<encryption':
            case '</encryption>':
                break;
            case '<keyData':
                KeyData.forEach(function(k) {
                    o[k] = y[k];
                });
                break;
            case '<dataIntegrity':
                o.encryptedHmacKey = y.encryptedHmacKey;
                o.encryptedHmacValue = y.encryptedHmacValue;
                break;
            case '<keyEncryptors>':
            case '<keyEncryptors':
                o.encs = [];
                break;
            case '</keyEncryptors>':
                break;
            case '<keyEncryptor':
                o.uri = y.uri;
                break;
            case '</keyEncryptor>':
                break;
            case '<encryptedKey':
                o.encs.push(y);
                break;
            default:
                throw y[0];
        }
    });
    return o;
}
/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */ function $b8f343bf88dacc48$var$parse_RC4CryptoHeader(blob, length /*:number*/ ) {
    var o = {};
    var vers = o.EncryptionVersionInfo = $b8f343bf88dacc48$var$parse_CRYPTOVersion(blob, 4);
    length -= 4;
    if (vers.Minor != 2) throw new Error('unrecognized minor version code: ' + vers.Minor);
    if (vers.Major > 4 || vers.Major < 2) throw new Error('unrecognized major version code: ' + vers.Major);
    o.Flags = blob.read_shift(4);
    length -= 4;
    var sz = blob.read_shift(4);
    length -= 4;
    o.EncryptionHeader = $b8f343bf88dacc48$var$parse_EncryptionHeader(blob, sz);
    length -= sz;
    o.EncryptionVerifier = $b8f343bf88dacc48$var$parse_EncryptionVerifier(blob, length);
    return o;
}
/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */ function $b8f343bf88dacc48$var$parse_RC4Header(blob /*::, length*/ ) {
    var o = {};
    var vers = o.EncryptionVersionInfo = $b8f343bf88dacc48$var$parse_CRYPTOVersion(blob, 4);
    if (vers.Major != 1 || vers.Minor != 1) throw 'unrecognized version code ' + vers.Major + ' : ' + vers.Minor;
    o.Salt = blob.read_shift(16);
    o.EncryptedVerifier = blob.read_shift(16);
    o.EncryptedVerifierHash = blob.read_shift(16);
    return o;
}
/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */ function $b8f343bf88dacc48$var$crypto_CreatePasswordVerifier_Method1(Password /*:string*/ ) {
    var Verifier = 0x0000, PasswordArray;
    var PasswordDecoded = $b8f343bf88dacc48$var$_JS2ANSI(Password);
    var len = PasswordDecoded.length + 1, i, PasswordByte;
    var Intermediate1, Intermediate2, Intermediate3;
    PasswordArray = $b8f343bf88dacc48$var$new_raw_buf(len);
    PasswordArray[0] = PasswordDecoded.length;
    for(i = 1; i != len; ++i)PasswordArray[i] = PasswordDecoded[i - 1];
    for(i = len - 1; i >= 0; --i){
        PasswordByte = PasswordArray[i];
        Intermediate1 = (Verifier & 0x4000) === 0x0000 ? 0 : 1;
        Intermediate2 = Verifier << 1 & 0x7FFF;
        Intermediate3 = Intermediate1 | Intermediate2;
        Verifier = Intermediate3 ^ PasswordByte;
    }
    return Verifier ^ 0xCE4B;
}
/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */ var $b8f343bf88dacc48$var$crypto_CreateXorArray_Method1 = /*#__PURE__*/ function() {
    var PadArray = [
        0xBB,
        0xFF,
        0xFF,
        0xBA,
        0xFF,
        0xFF,
        0xB9,
        0x80,
        0x00,
        0xBE,
        0x0F,
        0x00,
        0xBF,
        0x0F,
        0x00
    ];
    var InitialCode = [
        0xE1F0,
        0x1D0F,
        0xCC9C,
        0x84C0,
        0x110C,
        0x0E10,
        0xF1CE,
        0x313E,
        0x1872,
        0xE139,
        0xD40F,
        0x84F9,
        0x280C,
        0xA96A,
        0x4EC3
    ];
    var XorMatrix = [
        0xAEFC,
        0x4DD9,
        0x9BB2,
        0x2745,
        0x4E8A,
        0x9D14,
        0x2A09,
        0x7B61,
        0xF6C2,
        0xFDA5,
        0xEB6B,
        0xC6F7,
        0x9DCF,
        0x2BBF,
        0x4563,
        0x8AC6,
        0x05AD,
        0x0B5A,
        0x16B4,
        0x2D68,
        0x5AD0,
        0x0375,
        0x06EA,
        0x0DD4,
        0x1BA8,
        0x3750,
        0x6EA0,
        0xDD40,
        0xD849,
        0xA0B3,
        0x5147,
        0xA28E,
        0x553D,
        0xAA7A,
        0x44D5,
        0x6F45,
        0xDE8A,
        0xAD35,
        0x4A4B,
        0x9496,
        0x390D,
        0x721A,
        0xEB23,
        0xC667,
        0x9CEF,
        0x29FF,
        0x53FE,
        0xA7FC,
        0x5FD9,
        0x47D3,
        0x8FA6,
        0x0F6D,
        0x1EDA,
        0x3DB4,
        0x7B68,
        0xF6D0,
        0xB861,
        0x60E3,
        0xC1C6,
        0x93AD,
        0x377B,
        0x6EF6,
        0xDDEC,
        0x45A0,
        0x8B40,
        0x06A1,
        0x0D42,
        0x1A84,
        0x3508,
        0x6A10,
        0xAA51,
        0x4483,
        0x8906,
        0x022D,
        0x045A,
        0x08B4,
        0x1168,
        0x76B4,
        0xED68,
        0xCAF1,
        0x85C3,
        0x1BA7,
        0x374E,
        0x6E9C,
        0x3730,
        0x6E60,
        0xDCC0,
        0xA9A1,
        0x4363,
        0x86C6,
        0x1DAD,
        0x3331,
        0x6662,
        0xCCC4,
        0x89A9,
        0x0373,
        0x06E6,
        0x0DCC,
        0x1021,
        0x2042,
        0x4084,
        0x8108,
        0x1231,
        0x2462,
        0x48C4
    ];
    var Ror = function(Byte) {
        return (Byte / 2 | Byte * 128) & 0xFF;
    };
    var XorRor = function(byte1, byte2) {
        return Ror(byte1 ^ byte2);
    };
    var CreateXorKey_Method1 = function(Password) {
        var XorKey = InitialCode[Password.length - 1];
        var CurrentElement = 0x68;
        for(var i = Password.length - 1; i >= 0; --i){
            var Char = Password[i];
            for(var j = 0; j != 7; ++j){
                if (Char & 0x40) XorKey ^= XorMatrix[CurrentElement];
                Char *= 2;
                --CurrentElement;
            }
        }
        return XorKey;
    };
    return function(password /*:string*/ ) {
        var Password = $b8f343bf88dacc48$var$_JS2ANSI(password);
        var XorKey = CreateXorKey_Method1(Password);
        var Index = Password.length;
        var ObfuscationArray = $b8f343bf88dacc48$var$new_raw_buf(16);
        for(var i = 0; i != 16; ++i)ObfuscationArray[i] = 0x00;
        var Temp, PasswordLastChar, PadIndex;
        if ((Index & 1) === 1) {
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
            --Index;
            Temp = XorKey & 0xFF;
            PasswordLastChar = Password[Password.length - 1];
            ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
        }
        while(Index > 0){
            --Index;
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
            --Index;
            Temp = XorKey & 0xFF;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
        }
        Index = 15;
        PadIndex = 15 - Password.length;
        while(PadIndex > 0){
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
            --Index;
            --PadIndex;
            Temp = XorKey & 0xFF;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
            --Index;
            --PadIndex;
        }
        return ObfuscationArray;
    };
}();
/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */ var $b8f343bf88dacc48$var$crypto_DecryptData_Method1 = function(password /*:string*/ , Data, XorArrayIndex, XorArray, O) {
    /* If XorArray is set, use it; if O is not set, make changes in-place */ if (!O) O = Data;
    if (!XorArray) XorArray = $b8f343bf88dacc48$var$crypto_CreateXorArray_Method1(password);
    var Index, Value;
    for(Index = 0; Index != Data.length; ++Index){
        Value = Data[Index];
        Value ^= XorArray[XorArrayIndex];
        Value = (Value >> 5 | Value << 3) & 0xFF;
        O[Index] = Value;
        ++XorArrayIndex;
    }
    return [
        O,
        XorArrayIndex,
        XorArray
    ];
};
var $b8f343bf88dacc48$var$crypto_MakeXorDecryptor = function(password /*:string*/ ) {
    var XorArrayIndex = 0, XorArray = $b8f343bf88dacc48$var$crypto_CreateXorArray_Method1(password);
    return function(Data) {
        var O = $b8f343bf88dacc48$var$crypto_DecryptData_Method1("", Data, XorArrayIndex, XorArray);
        XorArrayIndex = O[1];
        return O[0];
    };
};
/* 2.5.343 */ function $b8f343bf88dacc48$var$parse_XORObfuscation(blob, length, opts, out) {
    var o = {
        key: $b8f343bf88dacc48$var$parseuint16(blob),
        verificationBytes: $b8f343bf88dacc48$var$parseuint16(blob)
    } /*:any*/ ;
    if (opts.password) o.verifier = $b8f343bf88dacc48$var$crypto_CreatePasswordVerifier_Method1(opts.password);
    out.valid = o.verificationBytes === o.verifier;
    if (out.valid) out.insitu = $b8f343bf88dacc48$var$crypto_MakeXorDecryptor(opts.password);
    return o;
}
/* 2.4.117 */ function $b8f343bf88dacc48$var$parse_FilePassHeader(blob, length /*:number*/ , oo) {
    var o = oo || {};
    o.Info = blob.read_shift(2);
    blob.l -= 2;
    if (o.Info === 1) o.Data = $b8f343bf88dacc48$var$parse_RC4Header(blob, length);
    else o.Data = $b8f343bf88dacc48$var$parse_RC4CryptoHeader(blob, length);
    return o;
}
function $b8f343bf88dacc48$var$parse_FilePass(blob, length /*:number*/ , opts) {
    var o = {
        Type: opts.biff >= 8 ? blob.read_shift(2) : 0
    } /*:any*/ ; /* wEncryptionType */ 
    if (o.Type) $b8f343bf88dacc48$var$parse_FilePassHeader(blob, length - 2, o);
    else $b8f343bf88dacc48$var$parse_XORObfuscation(blob, opts.biff >= 8 ? length : length - 2, opts, o);
    return o;
}
function $b8f343bf88dacc48$var$rtf_to_sheet(d, opts) {
    switch(opts.type){
        case "base64":
            return $b8f343bf88dacc48$var$rtf_to_sheet_str($b8f343bf88dacc48$var$Base64_decode(d), opts);
        case "binary":
            return $b8f343bf88dacc48$var$rtf_to_sheet_str(d, opts);
        case "buffer":
            return $b8f343bf88dacc48$var$rtf_to_sheet_str($b8f343bf88dacc48$var$has_buf && $b8f343bf88dacc48$require$Buffer.isBuffer(d) ? d.toString("binary") : $b8f343bf88dacc48$var$a2s(d), opts);
        case "array":
            return $b8f343bf88dacc48$var$rtf_to_sheet_str($b8f343bf88dacc48$var$cc2str(d), opts);
    }
    throw new Error("Unrecognized type " + opts.type);
}
function $b8f343bf88dacc48$var$rtf_to_sheet_str(str, opts) {
    var o = opts || {};
    var ws = {};
    var dense = o.dense;
    if (dense) ws["!data"] = [];
    var rows = $b8f343bf88dacc48$var$str_match_ng(str, "\\trowd", "\\row");
    if (!rows) throw new Error("RTF missing table");
    var range = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: rows.length - 1
        }
    };
    var row = [];
    rows.forEach(function(rowtf, R) {
        if (dense) row = ws["!data"][R] = [];
        var rtfre = /\\[\w\-]+\b/g;
        var last_index = 0;
        var res;
        var C = -1;
        var payload = [];
        while((res = rtfre.exec(rowtf)) != null){
            var data = rowtf.slice(last_index, rtfre.lastIndex - res[0].length);
            if (data.charCodeAt(0) == 32) data = data.slice(1);
            if (data.length) payload.push(data);
            switch(res[0]){
                case "\\cell":
                    ++C;
                    if (payload.length) {
                        var cell = {
                            v: payload.join(""),
                            t: "s"
                        };
                        if (cell.v == "TRUE" || cell.v == "FALSE") {
                            cell.v = cell.v == "TRUE";
                            cell.t = "b";
                        } else if (!isNaN($b8f343bf88dacc48$var$fuzzynum(cell.v))) {
                            cell.t = "n";
                            if (o.cellText !== false) cell.w = cell.v;
                            cell.v = $b8f343bf88dacc48$var$fuzzynum(cell.v);
                        }
                        if (dense) row[C] = cell;
                        else ws[$b8f343bf88dacc48$var$encode_cell({
                            r: R,
                            c: C
                        })] = cell;
                    }
                    payload = [];
                    break;
                case "\\par":
                    payload.push("\n");
                    break;
            }
            last_index = rtfre.lastIndex;
        }
        if (C > range.e.c) range.e.c = C;
    });
    ws["!ref"] = $b8f343bf88dacc48$var$encode_range(range);
    return ws;
}
function $b8f343bf88dacc48$var$rtf_to_workbook(d, opts) {
    var wb = $b8f343bf88dacc48$var$sheet_to_workbook($b8f343bf88dacc48$var$rtf_to_sheet(d, opts), opts);
    wb.bookType = "rtf";
    return wb;
}
function $b8f343bf88dacc48$var$sheet_to_rtf(ws, opts) {
    var o = [
        "{\\rtf1\\ansi"
    ];
    if (!ws["!ref"]) return o[0] + "}";
    var r = $b8f343bf88dacc48$var$safe_decode_range(ws["!ref"]), cell;
    var dense = ws["!data"] != null, row = [];
    for(var R = r.s.r; R <= r.e.r; ++R){
        o.push("\\trowd\\trautofit1");
        for(var C = r.s.c; C <= r.e.c; ++C)o.push("\\cellx" + (C + 1));
        o.push("\\pard\\intbl");
        if (dense) row = ws["!data"][R] || [];
        for(C = r.s.c; C <= r.e.c; ++C){
            var coord = $b8f343bf88dacc48$var$encode_cell({
                r: R,
                c: C
            });
            cell = dense ? row[C] : ws[coord];
            if (!cell || cell.v == null && (!cell.f || cell.F)) {
                o.push(" \\cell");
                continue;
            }
            o.push(" " + (cell.w || ($b8f343bf88dacc48$var$format_cell(cell), cell.w) || "").replace(/[\r\n]/g, "\\par "));
            o.push("\\cell");
        }
        o.push("\\pard\\intbl\\row");
    }
    return o.join("") + "}";
}
function $b8f343bf88dacc48$var$hex2RGB(h) {
    var o = h.slice(h[0] === "#" ? 1 : 0).slice(0, 6);
    return [
        parseInt(o.slice(0, 2), 16),
        parseInt(o.slice(2, 4), 16),
        parseInt(o.slice(4, 6), 16)
    ];
}
function $b8f343bf88dacc48$var$rgb2Hex(rgb) {
    for(var i = 0, o = 1; i != 3; ++i)o = o * 256 + (rgb[i] > 255 ? 255 : rgb[i] < 0 ? 0 : rgb[i]);
    return o.toString(16).toUpperCase().slice(1);
}
function $b8f343bf88dacc48$var$rgb2HSL(rgb) {
    var R = rgb[0] / 255, G = rgb[1] / 255, B = rgb[2] / 255;
    var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m;
    if (C === 0) return [
        0,
        0,
        R
    ];
    var H6 = 0, S = 0, L2 = M + m;
    S = C / (L2 > 1 ? 2 - L2 : L2);
    switch(M){
        case R:
            H6 = ((G - B) / C + 6) % 6;
            break;
        case G:
            H6 = (B - R) / C + 2;
            break;
        case B:
            H6 = (R - G) / C + 4;
            break;
    }
    return [
        H6 / 6,
        S,
        L2 / 2
    ];
}
function $b8f343bf88dacc48$var$hsl2RGB(hsl) {
    var H = hsl[0], S = hsl[1], L = hsl[2];
    var C = S * 2 * (L < 0.5 ? L : 1 - L), m = L - C / 2;
    var rgb = [
        m,
        m,
        m
    ], h6 = 6 * H;
    var X;
    if (S !== 0) switch(h6 | 0){
        case 0:
        case 6:
            X = C * h6;
            rgb[0] += C;
            rgb[1] += X;
            break;
        case 1:
            X = C * (2 - h6);
            rgb[0] += X;
            rgb[1] += C;
            break;
        case 2:
            X = C * (h6 - 2);
            rgb[1] += C;
            rgb[2] += X;
            break;
        case 3:
            X = C * (4 - h6);
            rgb[1] += X;
            rgb[2] += C;
            break;
        case 4:
            X = C * (h6 - 4);
            rgb[2] += C;
            rgb[0] += X;
            break;
        case 5:
            X = C * (6 - h6);
            rgb[2] += X;
            rgb[0] += C;
            break;
    }
    for(var i = 0; i != 3; ++i)rgb[i] = Math.round(rgb[i] * 255);
    return rgb;
}
/* 18.8.3 bgColor tint algorithm */ function $b8f343bf88dacc48$var$rgb_tint(hex, tint) {
    if (tint === 0) return hex;
    var hsl = $b8f343bf88dacc48$var$rgb2HSL($b8f343bf88dacc48$var$hex2RGB(hex));
    if (tint < 0) hsl[2] = hsl[2] * (1 + tint);
    else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint);
    return $b8f343bf88dacc48$var$rgb2Hex($b8f343bf88dacc48$var$hsl2RGB(hsl));
}
/* 18.3.1.13 width calculations */ /* [MS-OI29500] 2.1.595 Column Width & Formatting */ var $b8f343bf88dacc48$var$DEF_MDW = 6, $b8f343bf88dacc48$var$MAX_MDW = 15, $b8f343bf88dacc48$var$MIN_MDW = 1, $b8f343bf88dacc48$var$MDW = $b8f343bf88dacc48$var$DEF_MDW;
function $b8f343bf88dacc48$var$width2px(width) {
    return Math.floor((width + Math.round(128 / $b8f343bf88dacc48$var$MDW) / 256) * $b8f343bf88dacc48$var$MDW);
}
function $b8f343bf88dacc48$var$px2char(px) {
    return Math.floor((px - 5) / $b8f343bf88dacc48$var$MDW * 100 + 0.5) / 100;
}
function $b8f343bf88dacc48$var$char2width(chr) {
    return Math.round((chr * $b8f343bf88dacc48$var$MDW + 5) / $b8f343bf88dacc48$var$MDW * 256) / 256;
}
//function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
//function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
function $b8f343bf88dacc48$var$cycle_width(collw) {
    return $b8f343bf88dacc48$var$char2width($b8f343bf88dacc48$var$px2char($b8f343bf88dacc48$var$width2px(collw)));
}
/* XLSX/XLSB/XLS specify width in units of MDW */ function $b8f343bf88dacc48$var$find_mdw_colw(collw) {
    var delta = Math.abs(collw - $b8f343bf88dacc48$var$cycle_width(collw)), _MDW = $b8f343bf88dacc48$var$MDW;
    if (delta > 0.005) {
        for($b8f343bf88dacc48$var$MDW = $b8f343bf88dacc48$var$MIN_MDW; $b8f343bf88dacc48$var$MDW < $b8f343bf88dacc48$var$MAX_MDW; ++$b8f343bf88dacc48$var$MDW)if (Math.abs(collw - $b8f343bf88dacc48$var$cycle_width(collw)) <= delta) {
            delta = Math.abs(collw - $b8f343bf88dacc48$var$cycle_width(collw));
            _MDW = $b8f343bf88dacc48$var$MDW;
        }
    }
    $b8f343bf88dacc48$var$MDW = _MDW;
}
/* XLML specifies width in terms of pixels */ /*function find_mdw_wpx(wpx) {
	var delta = Infinity, guess = 0, _MDW = MIN_MDW;
	for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
		guess = char2width_(px2char_(wpx))*256;
		guess = (guess) % 1;
		if(guess > 0.5) guess--;
		if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
	}
	MDW = _MDW;
}*/ function $b8f343bf88dacc48$var$process_col(coll /*:ColInfo*/ ) {
    if (coll.width) {
        coll.wpx = $b8f343bf88dacc48$var$width2px(coll.width);
        coll.wch = $b8f343bf88dacc48$var$px2char(coll.wpx);
        coll.MDW = $b8f343bf88dacc48$var$MDW;
    } else if (coll.wpx) {
        coll.wch = $b8f343bf88dacc48$var$px2char(coll.wpx);
        coll.width = $b8f343bf88dacc48$var$char2width(coll.wch);
        coll.MDW = $b8f343bf88dacc48$var$MDW;
    } else if (typeof coll.wch == 'number') {
        coll.width = $b8f343bf88dacc48$var$char2width(coll.wch);
        coll.wpx = $b8f343bf88dacc48$var$width2px(coll.width);
        coll.MDW = $b8f343bf88dacc48$var$MDW;
    }
    if (coll.customWidth) delete coll.customWidth;
}
var $b8f343bf88dacc48$var$DEF_PPI = 96, $b8f343bf88dacc48$var$PPI = $b8f343bf88dacc48$var$DEF_PPI;
function $b8f343bf88dacc48$var$px2pt(px) {
    return px * 96 / $b8f343bf88dacc48$var$PPI;
}
function $b8f343bf88dacc48$var$pt2px(pt) {
    return pt * $b8f343bf88dacc48$var$PPI / 96;
}
/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */ var $b8f343bf88dacc48$var$XLMLPatternTypeMap = {
    "None": "none",
    "Solid": "solid",
    "Gray50": "mediumGray",
    "Gray75": "darkGray",
    "Gray25": "lightGray",
    "HorzStripe": "darkHorizontal",
    "VertStripe": "darkVertical",
    "ReverseDiagStripe": "darkDown",
    "DiagStripe": "darkUp",
    "DiagCross": "darkGrid",
    "ThickDiagCross": "darkTrellis",
    "ThinHorzStripe": "lightHorizontal",
    "ThinVertStripe": "lightVertical",
    "ThinReverseDiagStripe": "lightDown",
    "ThinHorzCross": "lightGrid"
};
/* 18.8.5 borders CT_Borders */ function $b8f343bf88dacc48$var$parse_borders(t, styles, themes, opts) {
    styles.Borders = [];
    var border = {};
    var pass = false;
    (t.match($b8f343bf88dacc48$var$tagregex) || []).forEach(function(x) {
        var y = $b8f343bf88dacc48$var$parsexmltag(x);
        switch($b8f343bf88dacc48$var$strip_ns(y[0])){
            case '<borders':
            case '<borders>':
            case '</borders>':
                break;
            /* 18.8.4 border CT_Border */ case '<border':
            case '<border>':
            case '<border/>':
                border = /*::(*/ {} /*:: :any)*/ ;
                if (y.diagonalUp) border.diagonalUp = $b8f343bf88dacc48$var$parsexmlbool(y.diagonalUp);
                if (y.diagonalDown) border.diagonalDown = $b8f343bf88dacc48$var$parsexmlbool(y.diagonalDown);
                styles.Borders.push(border);
                break;
            case '</border>':
                break;
            /* note: not in spec, appears to be CT_BorderPr */ case '<left/>':
                break;
            case '<left':
            case '<left>':
                break;
            case '</left>':
                break;
            /* note: not in spec, appears to be CT_BorderPr */ case '<right/>':
                break;
            case '<right':
            case '<right>':
                break;
            case '</right>':
                break;
            /* 18.8.43 top CT_BorderPr */ case '<top/>':
                break;
            case '<top':
            case '<top>':
                break;
            case '</top>':
                break;
            /* 18.8.6 bottom CT_BorderPr */ case '<bottom/>':
                break;
            case '<bottom':
            case '<bottom>':
                break;
            case '</bottom>':
                break;
            /* 18.8.13 diagonal CT_BorderPr */ case '<diagonal':
            case '<diagonal>':
            case '<diagonal/>':
                break;
            case '</diagonal>':
                break;
            /* 18.8.25 horizontal CT_BorderPr */ case '<horizontal':
            case '<horizontal>':
            case '<horizontal/>':
                break;
            case '</horizontal>':
                break;
            /* 18.8.44 vertical CT_BorderPr */ case '<vertical':
            case '<vertical>':
            case '<vertical/>':
                break;
            case '</vertical>':
                break;
            /* 18.8.37 start CT_BorderPr */ case '<start':
            case '<start>':
            case '<start/>':
                break;
            case '</start>':
                break;
            /* 18.8.16 end CT_BorderPr */ case '<end':
            case '<end>':
            case '<end/>':
                break;
            case '</end>':
                break;
            /* 18.8.? color CT_Color */ case '<color':
            case '<color>':
                break;
            case '<color/>':
            case '</color>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in borders');
                }
        }
    });
}
/* 18.8.21 fills CT_Fills */ function $b8f343bf88dacc48$var$parse_fills(t, styles, themes, opts) {
    styles.Fills = [];
    var fill = {};
    var pass = false;
    (t.match($b8f343bf88dacc48$var$tagregex) || []).forEach(function(x) {
        var y = $b8f343bf88dacc48$var$parsexmltag(x);
        switch($b8f343bf88dacc48$var$strip_ns(y[0])){
            case '<fills':
            case '<fills>':
            case '</fills>':
                break;
            /* 18.8.20 fill CT_Fill */ case '<fill>':
            case '<fill':
            case '<fill/>':
                fill = {};
                styles.Fills.push(fill);
                break;
            case '</fill>':
                break;
            /* 18.8.24 gradientFill CT_GradientFill */ case '<gradientFill>':
                break;
            case '<gradientFill':
            case '</gradientFill>':
                styles.Fills.push(fill);
                fill = {};
                break;
            /* 18.8.32 patternFill CT_PatternFill */ case '<patternFill':
            case '<patternFill>':
                if (y.patternType) fill.patternType = y.patternType;
                break;
            case '<patternFill/>':
            case '</patternFill>':
                break;
            /* 18.8.3 bgColor CT_Color */ case '<bgColor':
                if (!fill.bgColor) fill.bgColor = {};
                if (y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10);
                if (y.theme) fill.bgColor.theme = parseInt(y.theme, 10);
                if (y.tint) fill.bgColor.tint = parseFloat(y.tint);
                /* Excel uses ARGB strings */ if (y.rgb) fill.bgColor.rgb = y.rgb.slice(-6);
                break;
            case '<bgColor/>':
            case '</bgColor>':
                break;
            /* 18.8.19 fgColor CT_Color */ case '<fgColor':
                if (!fill.fgColor) fill.fgColor = {};
                if (y.theme) fill.fgColor.theme = parseInt(y.theme, 10);
                if (y.tint) fill.fgColor.tint = parseFloat(y.tint);
                /* Excel uses ARGB strings */ if (y.rgb != null) fill.fgColor.rgb = y.rgb.slice(-6);
                break;
            case '<fgColor/>':
            case '</fgColor>':
                break;
            /* 18.8.38 stop CT_GradientStop */ case '<stop':
            case '<stop/>':
                break;
            case '</stop>':
                break;
            /* 18.8.? color CT_Color */ case '<color':
            case '<color/>':
                break;
            case '</color>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in fills');
                }
        }
    });
}
/* 18.8.23 fonts CT_Fonts */ function $b8f343bf88dacc48$var$parse_fonts(t, styles, themes, opts) {
    styles.Fonts = [];
    var font = {};
    var pass = false;
    (t.match($b8f343bf88dacc48$var$tagregex) || []).forEach(function(x) {
        var y = $b8f343bf88dacc48$var$parsexmltag(x);
        switch($b8f343bf88dacc48$var$strip_ns(y[0])){
            case '<fonts':
            case '<fonts>':
            case '</fonts>':
                break;
            /* 18.8.22 font CT_Font */ case '<font':
            case '<font>':
                break;
            case '</font>':
            case '<font/>':
                styles.Fonts.push(font);
                font = {};
                break;
            /* 18.8.29 name CT_FontName */ case '<name':
                if (y.val) font.name = $b8f343bf88dacc48$var$utf8read(y.val);
                break;
            case '<name/>':
            case '</name>':
                break;
            /* 18.8.2  b CT_BooleanProperty */ case '<b':
                font.bold = y.val ? $b8f343bf88dacc48$var$parsexmlbool(y.val) : 1;
                break;
            case '<b/>':
                font.bold = 1;
                break;
            /* 18.8.26 i CT_BooleanProperty */ case '<i':
                font.italic = y.val ? $b8f343bf88dacc48$var$parsexmlbool(y.val) : 1;
                break;
            case '<i/>':
                font.italic = 1;
                break;
            /* 18.4.13 u CT_UnderlineProperty */ case '<u':
                switch(y.val){
                    case "none":
                        font.underline = 0x00;
                        break;
                    case "single":
                        font.underline = 0x01;
                        break;
                    case "double":
                        font.underline = 0x02;
                        break;
                    case "singleAccounting":
                        font.underline = 0x21;
                        break;
                    case "doubleAccounting":
                        font.underline = 0x22;
                        break;
                }
                break;
            case '<u/>':
                font.underline = 1;
                break;
            /* 18.4.10 strike CT_BooleanProperty */ case '<strike':
                font.strike = y.val ? $b8f343bf88dacc48$var$parsexmlbool(y.val) : 1;
                break;
            case '<strike/>':
                font.strike = 1;
                break;
            /* 18.4.2  outline CT_BooleanProperty */ case '<outline':
                font.outline = y.val ? $b8f343bf88dacc48$var$parsexmlbool(y.val) : 1;
                break;
            case '<outline/>':
                font.outline = 1;
                break;
            /* 18.8.36 shadow CT_BooleanProperty */ case '<shadow':
                font.shadow = y.val ? $b8f343bf88dacc48$var$parsexmlbool(y.val) : 1;
                break;
            case '<shadow/>':
                font.shadow = 1;
                break;
            /* 18.8.12 condense CT_BooleanProperty */ case '<condense':
                font.condense = y.val ? $b8f343bf88dacc48$var$parsexmlbool(y.val) : 1;
                break;
            case '<condense/>':
                font.condense = 1;
                break;
            /* 18.8.17 extend CT_BooleanProperty */ case '<extend':
                font.extend = y.val ? $b8f343bf88dacc48$var$parsexmlbool(y.val) : 1;
                break;
            case '<extend/>':
                font.extend = 1;
                break;
            /* 18.4.11 sz CT_FontSize */ case '<sz':
                if (y.val) font.sz = +y.val;
                break;
            case '<sz/>':
            case '</sz>':
                break;
            /* 18.4.14 vertAlign CT_VerticalAlignFontProperty */ case '<vertAlign':
                if (y.val) font.vertAlign = y.val;
                break;
            case '<vertAlign/>':
            case '</vertAlign>':
                break;
            /* 18.8.18 family CT_FontFamily */ case '<family':
                if (y.val) font.family = parseInt(y.val, 10);
                break;
            case '<family/>':
            case '</family>':
                break;
            /* 18.8.35 scheme CT_FontScheme */ case '<scheme':
                if (y.val) font.scheme = y.val;
                break;
            case '<scheme/>':
            case '</scheme>':
                break;
            /* 18.4.1 charset CT_IntProperty */ case '<charset':
                if (y.val == '1') break;
                y.codepage = $b8f343bf88dacc48$var$CS2CP[parseInt(y.val, 10)];
                break;
            /* 18.?.? color CT_Color */ case '<color':
                if (!font.color) font.color = {};
                if (y.auto) font.color.auto = $b8f343bf88dacc48$var$parsexmlbool(y.auto);
                if (y.rgb) font.color.rgb = y.rgb.slice(-6);
                else if (y.indexed) {
                    font.color.index = parseInt(y.indexed, 10);
                    var icv = $b8f343bf88dacc48$var$XLSIcv[font.color.index];
                    if (font.color.index == 81) icv = $b8f343bf88dacc48$var$XLSIcv[1];
                    if (!icv) icv = $b8f343bf88dacc48$var$XLSIcv[1]; //throw new Error(x); // note: 206 is valid
                    font.color.rgb = icv[0].toString(16) + icv[1].toString(16) + icv[2].toString(16);
                } else if (y.theme) {
                    font.color.theme = parseInt(y.theme, 10);
                    if (y.tint) font.color.tint = parseFloat(y.tint);
                    if (y.theme && themes.themeElements && themes.themeElements.clrScheme) font.color.rgb = $b8f343bf88dacc48$var$rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb, font.color.tint || 0);
                }
                break;
            case '<color/>':
            case '</color>':
                break;
            /* note: sometimes mc:AlternateContent appears bare */ case '<AlternateContent':
                pass = true;
                break;
            case '</AlternateContent>':
                pass = false;
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in fonts');
                }
        }
    });
}
/* 18.8.31 numFmts CT_NumFmts */ function $b8f343bf88dacc48$var$parse_numFmts(t, styles, opts) {
    styles.NumberFmt = [];
    var k /*Array<number>*/  = $b8f343bf88dacc48$var$keys($b8f343bf88dacc48$var$table_fmt);
    for(var i = 0; i < k.length; ++i)styles.NumberFmt[k[i]] = $b8f343bf88dacc48$var$table_fmt[k[i]];
    var m = t.match($b8f343bf88dacc48$var$tagregex);
    if (!m) return;
    for(i = 0; i < m.length; ++i){
        var y = $b8f343bf88dacc48$var$parsexmltag(m[i]);
        switch($b8f343bf88dacc48$var$strip_ns(y[0])){
            case '<numFmts':
            case '</numFmts>':
            case '<numFmts/>':
            case '<numFmts>':
                break;
            case '<numFmt':
                var f = $b8f343bf88dacc48$var$unescapexml($b8f343bf88dacc48$var$utf8read(y.formatCode)), j = parseInt(y.numFmtId, 10);
                styles.NumberFmt[j] = f;
                if (j > 0) {
                    if (j > 0x188) {
                        for(j = 0x188; j > 0x3c; --j)if (styles.NumberFmt[j] == null) break;
                        styles.NumberFmt[j] = f;
                    }
                    $b8f343bf88dacc48$var$SSF__load(f, j);
                }
                break;
            case '</numFmt>':
                break;
            default:
                if (opts.WTF) throw new Error('unrecognized ' + y[0] + ' in numFmts');
        }
    }
}
function $b8f343bf88dacc48$var$write_numFmts(NF /*:{[n:number|string]:string}*/  /*::, opts*/ ) {
    var o = [
        "<numFmts>"
    ];
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) o[o.length] = $b8f343bf88dacc48$var$writextag('numFmt', null, {
            numFmtId: i,
            formatCode: $b8f343bf88dacc48$var$escapexml(NF[i])
        });
    });
    if (o.length === 1) return "";
    o[o.length] = "</numFmts>";
    o[0] = $b8f343bf88dacc48$var$writextag('numFmts', null, {
        count: o.length - 2
    }).replace("/>", ">");
    return o.join("");
}
/* 18.8.10 cellXfs CT_CellXfs */ var $b8f343bf88dacc48$var$cellXF_uint = [
    "numFmtId",
    "fillId",
    "fontId",
    "borderId",
    "xfId"
];
var $b8f343bf88dacc48$var$cellXF_bool = [
    "applyAlignment",
    "applyBorder",
    "applyFill",
    "applyFont",
    "applyNumberFormat",
    "applyProtection",
    "pivotButton",
    "quotePrefix"
];
function $b8f343bf88dacc48$var$parse_cellXfs(t, styles, opts) {
    styles.CellXf = [];
    var xf;
    var pass = false;
    (t.match($b8f343bf88dacc48$var$tagregex) || []).forEach(function(x) {
        var y = $b8f343bf88dacc48$var$parsexmltag(x), i = 0;
        switch($b8f343bf88dacc48$var$strip_ns(y[0])){
            case '<cellXfs':
            case '<cellXfs>':
            case '<cellXfs/>':
            case '</cellXfs>':
                break;
            /* 18.8.45 xf CT_Xf */ case '<xf':
            case '<xf/>':
            case '<xf>':
                xf = y;
                delete xf[0];
                for(i = 0; i < $b8f343bf88dacc48$var$cellXF_uint.length; ++i)if (xf[$b8f343bf88dacc48$var$cellXF_uint[i]]) xf[$b8f343bf88dacc48$var$cellXF_uint[i]] = parseInt(xf[$b8f343bf88dacc48$var$cellXF_uint[i]], 10);
                for(i = 0; i < $b8f343bf88dacc48$var$cellXF_bool.length; ++i)if (xf[$b8f343bf88dacc48$var$cellXF_bool[i]]) xf[$b8f343bf88dacc48$var$cellXF_bool[i]] = $b8f343bf88dacc48$var$parsexmlbool(xf[$b8f343bf88dacc48$var$cellXF_bool[i]]);
                if (styles.NumberFmt && xf.numFmtId > 0x188) {
                    for(i = 0x188; i > 0x3c; --i)if (styles.NumberFmt[xf.numFmtId] == styles.NumberFmt[i]) {
                        xf.numFmtId = i;
                        break;
                    }
                }
                styles.CellXf.push(xf);
                break;
            case '</xf>':
                break;
            /* 18.8.1 alignment CT_CellAlignment */ case '<alignment':
            case '<alignment/>':
            case '<alignment>':
                var alignment = {};
                if (y.vertical) alignment.vertical = y.vertical;
                if (y.horizontal) alignment.horizontal = y.horizontal;
                if (y.textRotation != null) alignment.textRotation = y.textRotation;
                if (y.indent) alignment.indent = y.indent;
                if (y.wrapText) alignment.wrapText = $b8f343bf88dacc48$var$parsexmlbool(y.wrapText);
                xf.alignment = alignment;
                break;
            case '</alignment>':
                break;
            /* 18.8.33 protection CT_CellProtection */ case '<protection':
            case '<protection>':
                break;
            case '</protection>':
            case '<protection/>':
                break;
            /* note: sometimes mc:AlternateContent appears bare */ case '<AlternateContent':
            case '<AlternateContent>':
                pass = true;
                break;
            case '</AlternateContent>':
                pass = false;
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in cellXfs');
                }
        }
    });
}
function $b8f343bf88dacc48$var$write_cellXfs(cellXfs) /*:string*/ {
    var o /*:Array<string>*/  = [];
    o[o.length] = $b8f343bf88dacc48$var$writextag('cellXfs', null);
    cellXfs.forEach(function(c) {
        o[o.length] = $b8f343bf88dacc48$var$writextag('xf', null, c);
    });
    o[o.length] = "</cellXfs>";
    if (o.length === 2) return "";
    o[0] = $b8f343bf88dacc48$var$writextag('cellXfs', null, {
        count: o.length - 2
    }).replace("/>", ">");
    return o.join("");
}
/* 18.8 Styles CT_Stylesheet*/ var $b8f343bf88dacc48$var$parse_sty_xml = /*#__PURE__*/ function make_pstyx() {
    return function parse_sty_xml(data, themes, opts) {
        var styles = {};
        if (!data) return styles;
        data = $b8f343bf88dacc48$var$remove_doctype($b8f343bf88dacc48$var$str_remove_ng(data, "<!--", "-->"));
        /* 18.8.39 styleSheet CT_Stylesheet */ var t;
        /* 18.8.31 numFmts CT_NumFmts ? */ if (t = $b8f343bf88dacc48$var$str_match_xml_ns(data, "numFmts")) $b8f343bf88dacc48$var$parse_numFmts(t[0], styles, opts);
        /* 18.8.23 fonts CT_Fonts ? */ if (t = $b8f343bf88dacc48$var$str_match_xml_ns(data, "fonts")) $b8f343bf88dacc48$var$parse_fonts(t[0], styles, themes, opts);
        /* 18.8.21 fills CT_Fills ? */ if (t = $b8f343bf88dacc48$var$str_match_xml_ns(data, "fills")) $b8f343bf88dacc48$var$parse_fills(t[0], styles, themes, opts);
        /* 18.8.5  borders CT_Borders ? */ if (t = $b8f343bf88dacc48$var$str_match_xml_ns(data, "borders")) $b8f343bf88dacc48$var$parse_borders(t[0], styles, themes, opts);
        /* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */ /* 18.8.8  cellStyles CT_CellStyles ? */ /* 18.8.10 cellXfs CT_CellXfs ? */ if (t = $b8f343bf88dacc48$var$str_match_xml_ns(data, "cellXfs")) $b8f343bf88dacc48$var$parse_cellXfs(t[0], styles, opts);
        /* 18.8.15 dxfs CT_Dxfs ? */ /* 18.8.42 tableStyles CT_TableStyles ? */ /* 18.8.11 colors CT_Colors ? */ /* 18.2.10 extLst CT_ExtensionList ? */ return styles;
    };
}();
function $b8f343bf88dacc48$var$write_sty_xml(wb /*:Workbook*/ , opts) /*:string*/ {
    var o = [
        $b8f343bf88dacc48$var$XML_HEADER,
        $b8f343bf88dacc48$var$writextag('styleSheet', null, {
            'xmlns': $b8f343bf88dacc48$var$XMLNS_main[0],
            'xmlns:vt': $b8f343bf88dacc48$var$XMLNS.vt
        })
    ], w;
    if (wb.SSF && (w = $b8f343bf88dacc48$var$write_numFmts(wb.SSF)) != null) o[o.length] = w;
    o[o.length] = '<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>';
    o[o.length] = '<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>';
    o[o.length] = '<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>';
    o[o.length] = '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>';
    if (w = $b8f343bf88dacc48$var$write_cellXfs(opts.cellXfs)) o[o.length] = w;
    o[o.length] = '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>';
    o[o.length] = '<dxfs count="0"/>';
    o[o.length] = '<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>';
    if (o.length > 2) {
        o[o.length] = '</styleSheet>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.657 BrtFmt */ function $b8f343bf88dacc48$var$parse_BrtFmt(data, length /*:number*/ ) {
    var numFmtId = data.read_shift(2);
    var stFmtCode = $b8f343bf88dacc48$var$parse_XLWideString(data, length - 2);
    return [
        numFmtId,
        stFmtCode
    ];
}
function $b8f343bf88dacc48$var$write_BrtFmt(i /*:number*/ , f /*:string*/ , o) {
    if (!o) o = $b8f343bf88dacc48$var$new_buf(6 + 4 * f.length);
    o.write_shift(2, i);
    $b8f343bf88dacc48$var$write_XLWideString(f, o);
    var out = o.length > o.l ? o.slice(0, o.l) : o;
    if (o.l == null) o.l = o.length;
    return out;
}
/* [MS-XLSB] 2.4.659 BrtFont TODO */ function $b8f343bf88dacc48$var$parse_BrtFont(data, length /*:number*/ , opts) {
    var out = {} /*:any*/ ;
    out.sz = data.read_shift(2) / 20;
    var grbit = $b8f343bf88dacc48$var$parse_FontFlags(data, 2, opts);
    if (grbit.fItalic) out.italic = 1;
    if (grbit.fCondense) out.condense = 1;
    if (grbit.fExtend) out.extend = 1;
    if (grbit.fShadow) out.shadow = 1;
    if (grbit.fOutline) out.outline = 1;
    if (grbit.fStrikeout) out.strike = 1;
    var bls = data.read_shift(2);
    if (bls === 0x02BC) out.bold = 1;
    switch(data.read_shift(2)){
        /* case 0: out.vertAlign = "baseline"; break; */ case 1:
            out.vertAlign = "superscript";
            break;
        case 2:
            out.vertAlign = "subscript";
            break;
    }
    var underline = data.read_shift(1);
    if (underline != 0) out.underline = underline;
    var family = data.read_shift(1);
    if (family > 0) out.family = family;
    var bCharSet = data.read_shift(1);
    if (bCharSet > 0) out.charset = bCharSet;
    data.l++;
    out.color = $b8f343bf88dacc48$var$parse_BrtColor(data, 8);
    switch(data.read_shift(1)){
        /* case 0: out.scheme = "none": break; */ case 1:
            out.scheme = "major";
            break;
        case 2:
            out.scheme = "minor";
            break;
    }
    out.name = $b8f343bf88dacc48$var$parse_XLWideString(data, length - 21);
    return out;
}
function $b8f343bf88dacc48$var$write_BrtFont(font /*:any*/ , o) {
    if (!o) o = $b8f343bf88dacc48$var$new_buf(153);
    o.write_shift(2, font.sz * 20);
    $b8f343bf88dacc48$var$write_FontFlags(font, o);
    o.write_shift(2, font.bold ? 0x02BC : 0x0190);
    var sss = 0;
    if (font.vertAlign == "superscript") sss = 1;
    else if (font.vertAlign == "subscript") sss = 2;
    o.write_shift(2, sss);
    o.write_shift(1, font.underline || 0);
    o.write_shift(1, font.family || 0);
    o.write_shift(1, font.charset || 0);
    o.write_shift(1, 0);
    $b8f343bf88dacc48$var$write_BrtColor(font.color, o);
    var scheme = 0;
    if (font.scheme == "major") scheme = 1;
    if (font.scheme == "minor") scheme = 2;
    o.write_shift(1, scheme);
    $b8f343bf88dacc48$var$write_XLWideString(font.name, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.650 BrtFill */ var $b8f343bf88dacc48$var$XLSBFillPTNames = [
    "none",
    "solid",
    "mediumGray",
    "darkGray",
    "lightGray",
    "darkHorizontal",
    "darkVertical",
    "darkDown",
    "darkUp",
    "darkGrid",
    "darkTrellis",
    "lightHorizontal",
    "lightVertical",
    "lightDown",
    "lightUp",
    "lightGrid",
    "lightTrellis",
    "gray125",
    "gray0625"
];
var $b8f343bf88dacc48$var$rev_XLSBFillPTNames /*:EvertNumType*/ ;
/* TODO: gradient fill representation */ var $b8f343bf88dacc48$var$parse_BrtFill = $b8f343bf88dacc48$var$parsenoop;
function $b8f343bf88dacc48$var$write_BrtFill(fill, o) {
    if (!o) o = $b8f343bf88dacc48$var$new_buf(84);
    if (!$b8f343bf88dacc48$var$rev_XLSBFillPTNames) $b8f343bf88dacc48$var$rev_XLSBFillPTNames = $b8f343bf88dacc48$var$evert($b8f343bf88dacc48$var$XLSBFillPTNames);
    var fls /*:number*/  = $b8f343bf88dacc48$var$rev_XLSBFillPTNames[fill.patternType];
    if (fls == null) fls = 0x28;
    o.write_shift(4, fls);
    var j = 0;
    if (fls != 0x28) {
        /* TODO: custom FG Color */ $b8f343bf88dacc48$var$write_BrtColor({
            auto: 1
        }, o);
        /* TODO: custom BG Color */ $b8f343bf88dacc48$var$write_BrtColor({
            auto: 1
        }, o);
        for(; j < 12; ++j)o.write_shift(4, 0);
    } else {
        for(; j < 4; ++j)o.write_shift(4, 0);
        for(; j < 12; ++j)o.write_shift(4, 0); /* TODO */ 
    /* iGradientType */ /* xnumDegree */ /* xnumFillToLeft */ /* xnumFillToRight */ /* xnumFillToTop */ /* xnumFillToBottom */ /* cNumStop */ /* xfillGradientStop */ }
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.824 BrtXF */ function $b8f343bf88dacc48$var$parse_BrtXF(data, length /*:number*/ ) {
    var tgt = data.l + length;
    var ixfeParent = data.read_shift(2);
    var ifmt = data.read_shift(2);
    data.l = tgt;
    return {
        ixfe: ixfeParent,
        numFmtId: ifmt
    };
}
function $b8f343bf88dacc48$var$write_BrtXF(data, ixfeP, o) {
    if (!o) o = $b8f343bf88dacc48$var$new_buf(16);
    o.write_shift(2, ixfeP || 0);
    o.write_shift(2, data.numFmtId || 0);
    o.write_shift(2, 0); /* iFont */ 
    o.write_shift(2, 0); /* iFill */ 
    o.write_shift(2, 0); /* ixBorder */ 
    o.write_shift(1, 0); /* trot */ 
    o.write_shift(1, 0); /* indent */ 
    var flow = 0;
    o.write_shift(1, flow); /* flags */ 
    o.write_shift(1, 0); /* flags */ 
    o.write_shift(1, 0); /* xfGrbitAtr */ 
    o.write_shift(1, 0);
    return o;
}
/* [MS-XLSB] 2.5.4 Blxf TODO */ function $b8f343bf88dacc48$var$write_Blxf(data, o) {
    if (!o) o = $b8f343bf88dacc48$var$new_buf(10);
    o.write_shift(1, 0); /* dg */ 
    o.write_shift(1, 0);
    o.write_shift(4, 0); /* color */ 
    o.write_shift(4, 0); /* color */ 
    return o;
}
/* [MS-XLSB] 2.4.302 BrtBorder TODO */ var $b8f343bf88dacc48$var$parse_BrtBorder = $b8f343bf88dacc48$var$parsenoop;
function $b8f343bf88dacc48$var$write_BrtBorder(border, o) {
    if (!o) o = $b8f343bf88dacc48$var$new_buf(51);
    o.write_shift(1, 0); /* diagonal */ 
    $b8f343bf88dacc48$var$write_Blxf(null, o); /* top */ 
    $b8f343bf88dacc48$var$write_Blxf(null, o); /* bottom */ 
    $b8f343bf88dacc48$var$write_Blxf(null, o); /* left */ 
    $b8f343bf88dacc48$var$write_Blxf(null, o); /* right */ 
    $b8f343bf88dacc48$var$write_Blxf(null, o); /* diag */ 
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.763 BrtStyle TODO */ function $b8f343bf88dacc48$var$write_BrtStyle(style, o) {
    if (!o) o = $b8f343bf88dacc48$var$new_buf(52);
    o.write_shift(4, style.xfId);
    o.write_shift(2, 1);
    o.write_shift(1, +style.builtinId);
    o.write_shift(1, 0); /* iLevel */ 
    $b8f343bf88dacc48$var$write_XLNullableWideString(style.name || "", o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.272 BrtBeginTableStyles */ function $b8f343bf88dacc48$var$write_BrtBeginTableStyles(cnt, defTableStyle, defPivotStyle) {
    var o = $b8f343bf88dacc48$var$new_buf(2052);
    o.write_shift(4, cnt);
    $b8f343bf88dacc48$var$write_XLNullableWideString(defTableStyle, o);
    $b8f343bf88dacc48$var$write_XLNullableWideString(defPivotStyle, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.1.7.50 Styles */ function $b8f343bf88dacc48$var$parse_sty_bin(data, themes, opts) {
    var styles = {};
    styles.NumberFmt = [];
    for(var y in $b8f343bf88dacc48$var$table_fmt)styles.NumberFmt[y] = $b8f343bf88dacc48$var$table_fmt[y];
    styles.CellXf = [];
    styles.Fonts = [];
    var state /*:Array<string>*/  = [];
    var pass = false;
    $b8f343bf88dacc48$var$recordhopper(data, function hopper_sty(val, R, RT) {
        switch(RT){
            case 0x002C:
                /* BrtFmt */ styles.NumberFmt[val[0]] = val[1];
                $b8f343bf88dacc48$var$SSF__load(val[1], val[0]);
                break;
            case 0x002B:
                /* BrtFont */ styles.Fonts.push(val);
                if (val.color.theme != null && themes && themes.themeElements && themes.themeElements.clrScheme) val.color.rgb = $b8f343bf88dacc48$var$rgb_tint(themes.themeElements.clrScheme[val.color.theme].rgb, val.color.tint || 0);
                break;
            case 0x0401:
                break;
            case 0x002D:
                break;
            case 0x002E:
                break;
            case 0x002F:
                /* BrtXF */ if (state[state.length - 1] == 0x0269 /* BrtBeginCellXFs */ ) styles.CellXf.push(val);
                break;
            case 0x0030:
            /* BrtStyle */ case 0x01FB:
            /* BrtDXF */ case 0x023C:
            /* BrtMRUColor */ case 0x01DB:
                break;
            case 0x0493:
            /* BrtDXF14 */ case 0x0836:
            /* BrtDXF15 */ case 0x046A:
            /* BrtSlicerStyleElement */ case 0x0200:
            /* BrtTableStyleElement */ case 0x082F:
            /* BrtTimelineStyleElement */ case 0x0C00:
                break;
            case 0x0023:
                /* BrtFRTBegin */ pass = true;
                break;
            case 0x0024:
                /* BrtFRTEnd */ pass = false;
                break;
            case 0x0025:
                /* BrtACBegin */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* BrtACEnd */ state.pop();
                pass = false;
                break;
            default:
                if (R.T > 0) state.push(RT);
                else if (R.T < 0) state.pop();
                else if (!pass || opts.WTF && state[state.length - 1] != 0x0025 /* BrtACBegin */ ) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return styles;
}
function $b8f343bf88dacc48$var$write_FMTS_bin(ba, NF /*:?SSFTable*/ ) {
    if (!NF) return;
    var cnt = 0;
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) ++cnt;
    });
    if (cnt == 0) return;
    $b8f343bf88dacc48$var$write_record(ba, 0x0267 /* BrtBeginFmts */ , $b8f343bf88dacc48$var$write_UInt32LE(cnt));
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) $b8f343bf88dacc48$var$write_record(ba, 0x002C /* BrtFmt */ , $b8f343bf88dacc48$var$write_BrtFmt(i, NF[i]));
    });
    $b8f343bf88dacc48$var$write_record(ba, 0x0268 /* BrtEndFmts */ );
}
function $b8f343bf88dacc48$var$write_FONTS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    if (cnt == 0) return;
    $b8f343bf88dacc48$var$write_record(ba, 0x0263 /* BrtBeginFonts */ , $b8f343bf88dacc48$var$write_UInt32LE(cnt));
    $b8f343bf88dacc48$var$write_record(ba, 0x002B /* BrtFont */ , $b8f343bf88dacc48$var$write_BrtFont({
        sz: 12,
        color: {
            theme: 1
        },
        name: "Calibri",
        family: 2,
        scheme: "minor"
    }));
    /* 1*65491BrtFont [ACFONTS] */ $b8f343bf88dacc48$var$write_record(ba, 0x0264 /* BrtEndFonts */ );
}
function $b8f343bf88dacc48$var$write_FILLS_bin(ba /*::, data*/ ) {
    var cnt = 2;
    if (cnt == 0) return;
    $b8f343bf88dacc48$var$write_record(ba, 0x025B /* BrtBeginFills */ , $b8f343bf88dacc48$var$write_UInt32LE(cnt));
    $b8f343bf88dacc48$var$write_record(ba, 0x002D /* BrtFill */ , $b8f343bf88dacc48$var$write_BrtFill({
        patternType: "none"
    }));
    $b8f343bf88dacc48$var$write_record(ba, 0x002D /* BrtFill */ , $b8f343bf88dacc48$var$write_BrtFill({
        patternType: "gray125"
    }));
    /* 1*65431BrtFill */ $b8f343bf88dacc48$var$write_record(ba, 0x025C /* BrtEndFills */ );
}
function $b8f343bf88dacc48$var$write_BORDERS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    if (cnt == 0) return;
    $b8f343bf88dacc48$var$write_record(ba, 0x0265 /* BrtBeginBorders */ , $b8f343bf88dacc48$var$write_UInt32LE(cnt));
    $b8f343bf88dacc48$var$write_record(ba, 0x002E /* BrtBorder */ , $b8f343bf88dacc48$var$write_BrtBorder({}));
    /* 1*65430BrtBorder */ $b8f343bf88dacc48$var$write_record(ba, 0x0266 /* BrtEndBorders */ );
}
function $b8f343bf88dacc48$var$write_CELLSTYLEXFS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    $b8f343bf88dacc48$var$write_record(ba, 0x0272 /* BrtBeginCellStyleXFs */ , $b8f343bf88dacc48$var$write_UInt32LE(cnt));
    $b8f343bf88dacc48$var$write_record(ba, 0x002F /* BrtXF */ , $b8f343bf88dacc48$var$write_BrtXF({
        numFmtId: 0,
        fontId: 0,
        fillId: 0,
        borderId: 0
    }, 0xFFFF));
    /* 1*65430(BrtXF *FRT) */ $b8f343bf88dacc48$var$write_record(ba, 0x0273 /* BrtEndCellStyleXFs */ );
}
function $b8f343bf88dacc48$var$write_CELLXFS_bin(ba, data) {
    $b8f343bf88dacc48$var$write_record(ba, 0x0269 /* BrtBeginCellXFs */ , $b8f343bf88dacc48$var$write_UInt32LE(data.length));
    data.forEach(function(c) {
        $b8f343bf88dacc48$var$write_record(ba, 0x002F /* BrtXF */ , $b8f343bf88dacc48$var$write_BrtXF(c, 0));
    });
    /* 1*65430(BrtXF *FRT) */ $b8f343bf88dacc48$var$write_record(ba, 0x026A /* BrtEndCellXFs */ );
}
function $b8f343bf88dacc48$var$write_STYLES_bin(ba /*::, data*/ ) {
    var cnt = 1;
    $b8f343bf88dacc48$var$write_record(ba, 0x026B /* BrtBeginStyles */ , $b8f343bf88dacc48$var$write_UInt32LE(cnt));
    $b8f343bf88dacc48$var$write_record(ba, 0x0030 /* BrtStyle */ , $b8f343bf88dacc48$var$write_BrtStyle({
        xfId: 0,
        builtinId: 0,
        name: "Normal"
    }));
    /* 1*65430(BrtStyle *FRT) */ $b8f343bf88dacc48$var$write_record(ba, 0x026C /* BrtEndStyles */ );
}
function $b8f343bf88dacc48$var$write_DXFS_bin(ba /*::, data*/ ) {
    var cnt = 0;
    $b8f343bf88dacc48$var$write_record(ba, 0x01F9 /* BrtBeginDXFs */ , $b8f343bf88dacc48$var$write_UInt32LE(cnt));
    /* *2147483647(BrtDXF *FRT) */ $b8f343bf88dacc48$var$write_record(ba, 0x01FA /* BrtEndDXFs */ );
}
function $b8f343bf88dacc48$var$write_TABLESTYLES_bin(ba /*::, data*/ ) {
    var cnt = 0;
    $b8f343bf88dacc48$var$write_record(ba, 0x01FC /* BrtBeginTableStyles */ , $b8f343bf88dacc48$var$write_BrtBeginTableStyles(cnt, "TableStyleMedium9", "PivotStyleMedium4"));
    /* *TABLESTYLE */ $b8f343bf88dacc48$var$write_record(ba, 0x01FD /* BrtEndTableStyles */ );
}
function $b8f343bf88dacc48$var$write_COLORPALETTE_bin() {
    return;
/* BrtBeginColorPalette [INDEXEDCOLORS] [MRUCOLORS] BrtEndColorPalette */ }
/* [MS-XLSB] 2.1.7.50 Styles */ function $b8f343bf88dacc48$var$write_sty_bin(wb, opts) {
    var ba = $b8f343bf88dacc48$var$buf_array();
    $b8f343bf88dacc48$var$write_record(ba, 0x0116 /* BrtBeginStyleSheet */ );
    $b8f343bf88dacc48$var$write_FMTS_bin(ba, wb.SSF);
    $b8f343bf88dacc48$var$write_FONTS_bin(ba, wb);
    $b8f343bf88dacc48$var$write_FILLS_bin(ba, wb);
    $b8f343bf88dacc48$var$write_BORDERS_bin(ba, wb);
    $b8f343bf88dacc48$var$write_CELLSTYLEXFS_bin(ba, wb);
    $b8f343bf88dacc48$var$write_CELLXFS_bin(ba, opts.cellXfs);
    $b8f343bf88dacc48$var$write_STYLES_bin(ba, wb);
    $b8f343bf88dacc48$var$write_DXFS_bin(ba, wb);
    $b8f343bf88dacc48$var$write_TABLESTYLES_bin(ba, wb);
    $b8f343bf88dacc48$var$write_COLORPALETTE_bin(ba, wb);
    /* FRTSTYLESHEET*/ $b8f343bf88dacc48$var$write_record(ba, 0x0117 /* BrtEndStyleSheet */ );
    return ba.end();
}
/* Even though theme layout is dk1 lt1 dk2 lt2, true order is lt1 dk1 lt2 dk2 */ var $b8f343bf88dacc48$var$XLSXThemeClrScheme = [
    '</a:lt1>',
    '</a:dk1>',
    '</a:lt2>',
    '</a:dk2>',
    '</a:accent1>',
    '</a:accent2>',
    '</a:accent3>',
    '</a:accent4>',
    '</a:accent5>',
    '</a:accent6>',
    '</a:hlink>',
    '</a:folHlink>'
];
/* 20.1.6.2 clrScheme CT_ColorScheme */ function $b8f343bf88dacc48$var$parse_clrScheme(t, themes, opts) {
    themes.themeElements.clrScheme = [];
    var color = {};
    (t[0].match($b8f343bf88dacc48$var$tagregex) || []).forEach(function(x) {
        var y = $b8f343bf88dacc48$var$parsexmltag(x);
        switch(y[0]){
            /* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */ case '<a:clrScheme':
            case '</a:clrScheme>':
                break;
            /* 20.1.2.3.32 srgbClr CT_SRgbColor */ case '<a:srgbClr':
                color.rgb = y.val;
                break;
            case '</a:srgbClr>':
                break;
            /* 20.1.2.3.33 sysClr CT_SystemColor */ case '<a:sysClr':
                color.rgb = y.lastClr;
                break;
            case '</a:sysClr>':
                break;
            /* 20.1.4.1.1 accent1 (Accent 1) */ /* 20.1.4.1.2 accent2 (Accent 2) */ /* 20.1.4.1.3 accent3 (Accent 3) */ /* 20.1.4.1.4 accent4 (Accent 4) */ /* 20.1.4.1.5 accent5 (Accent 5) */ /* 20.1.4.1.6 accent6 (Accent 6) */ /* 20.1.4.1.9 dk1 (Dark 1) */ /* 20.1.4.1.10 dk2 (Dark 2) */ /* 20.1.4.1.15 folHlink (Followed Hyperlink) */ /* 20.1.4.1.19 hlink (Hyperlink) */ /* 20.1.4.1.22 lt1 (Light 1) */ /* 20.1.4.1.23 lt2 (Light 2) */ case '</a:dk1>':
            case '</a:lt1>':
            case '<a:dk1>':
            case '<a:lt1>':
            case '<a:dk2>':
            case '</a:dk2>':
            case '<a:lt2>':
            case '</a:lt2>':
            case '<a:accent1>':
            case '</a:accent1>':
            case '<a:accent2>':
            case '</a:accent2>':
            case '<a:accent3>':
            case '</a:accent3>':
            case '<a:accent4>':
            case '</a:accent4>':
            case '<a:accent5>':
            case '</a:accent5>':
            case '<a:accent6>':
            case '</a:accent6>':
            case '<a:hlink>':
            case '</a:hlink>':
            case '<a:folHlink>':
            case '</a:folHlink>':
                if (y[0].charAt(1) === '/') {
                    themes.themeElements.clrScheme[$b8f343bf88dacc48$var$XLSXThemeClrScheme.indexOf(y[0])] = color;
                    color = {};
                } else color.name = y[0].slice(3, y[0].length - 1);
                break;
            default:
                if (opts && opts.WTF) throw new Error('Unrecognized ' + y[0] + ' in clrScheme');
        }
    });
}
/* 20.1.4.1.18 fontScheme CT_FontScheme */ function $b8f343bf88dacc48$var$parse_fontScheme() {}
/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */ function $b8f343bf88dacc48$var$parse_fmtScheme() {}
/* 20.1.6.10 themeElements CT_BaseStyles */ function $b8f343bf88dacc48$var$parse_themeElements(data, themes, opts) {
    themes.themeElements = {};
    var t;
    /* clrScheme CT_ColorScheme */ if (!(t = $b8f343bf88dacc48$var$str_match_xml(data, "a:clrScheme"))) throw new Error('clrScheme not found in themeElements');
    $b8f343bf88dacc48$var$parse_clrScheme(t, themes, opts);
    /* fontScheme CT_FontScheme */ if (!(t = $b8f343bf88dacc48$var$str_match_xml(data, "a:fontScheme"))) throw new Error('fontScheme not found in themeElements');
    $b8f343bf88dacc48$var$parse_fontScheme(t, themes, opts);
    /* fmtScheme CT_StyleMatrix */ if (!(t = $b8f343bf88dacc48$var$str_match_xml(data, "a:fmtScheme"))) throw new Error('fmtScheme not found in themeElements');
    $b8f343bf88dacc48$var$parse_fmtScheme(t, themes, opts);
}
/* 14.2.7 Theme Part */ function $b8f343bf88dacc48$var$parse_theme_xml(data /*:string*/ , opts) {
    /* 20.1.6.9 theme CT_OfficeStyleSheet */ if (!data || data.length === 0) data = $b8f343bf88dacc48$var$write_theme();
    var t;
    var themes = {};
    /* themeElements CT_BaseStyles */ if (!(t = $b8f343bf88dacc48$var$str_match_xml(data, "a:themeElements"))) throw new Error('themeElements not found in theme');
    $b8f343bf88dacc48$var$parse_themeElements(t[0], themes, opts);
    themes.raw = data;
    return themes;
}
function $b8f343bf88dacc48$var$write_theme(Themes, opts) /*:string*/ {
    if (opts && opts.themeXLSX) return opts.themeXLSX;
    if (Themes && typeof Themes.raw == "string") return Themes.raw;
    var o = [
        $b8f343bf88dacc48$var$XML_HEADER
    ];
    o[o.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
    o[o.length] = '<a:themeElements>';
    o[o.length] = '<a:clrScheme name="Office">';
    o[o.length] = '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
    o[o.length] = '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
    o[o.length] = '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
    o[o.length] = '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
    o[o.length] = '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
    o[o.length] = '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
    o[o.length] = '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
    o[o.length] = '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
    o[o.length] = '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
    o[o.length] = '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
    o[o.length] = '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
    o[o.length] = '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
    o[o.length] = '</a:clrScheme>';
    o[o.length] = '<a:fontScheme name="Office">';
    o[o.length] = '<a:majorFont>';
    o[o.length] = '<a:latin typeface="Cambria"/>';
    o[o.length] = '<a:ea typeface=""/>';
    o[o.length] = '<a:cs typeface=""/>';
    o[o.length] = '<a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/>';
    o[o.length] = '<a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/>';
    o[o.length] = '<a:font script="Hans" typeface="\u5B8B\u4F53"/>';
    o[o.length] = '<a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/>';
    o[o.length] = '<a:font script="Arab" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Hebr" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    o[o.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    o[o.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    o[o.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    o[o.length] = '<a:font script="Khmr" typeface="MoolBoran"/>';
    o[o.length] = '<a:font script="Knda" typeface="Tunga"/>';
    o[o.length] = '<a:font script="Guru" typeface="Raavi"/>';
    o[o.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    o[o.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    o[o.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    o[o.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    o[o.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    o[o.length] = '<a:font script="Deva" typeface="Mangal"/>';
    o[o.length] = '<a:font script="Telu" typeface="Gautami"/>';
    o[o.length] = '<a:font script="Taml" typeface="Latha"/>';
    o[o.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    o[o.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    o[o.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    o[o.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    o[o.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    o[o.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    o[o.length] = '<a:font script="Viet" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    o[o.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    o[o.length] = '</a:majorFont>';
    o[o.length] = '<a:minorFont>';
    o[o.length] = '<a:latin typeface="Calibri"/>';
    o[o.length] = '<a:ea typeface=""/>';
    o[o.length] = '<a:cs typeface=""/>';
    o[o.length] = '<a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/>';
    o[o.length] = '<a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/>';
    o[o.length] = '<a:font script="Hans" typeface="\u5B8B\u4F53"/>';
    o[o.length] = '<a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/>';
    o[o.length] = '<a:font script="Arab" typeface="Arial"/>';
    o[o.length] = '<a:font script="Hebr" typeface="Arial"/>';
    o[o.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    o[o.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    o[o.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    o[o.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    o[o.length] = '<a:font script="Khmr" typeface="DaunPenh"/>';
    o[o.length] = '<a:font script="Knda" typeface="Tunga"/>';
    o[o.length] = '<a:font script="Guru" typeface="Raavi"/>';
    o[o.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    o[o.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    o[o.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    o[o.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    o[o.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    o[o.length] = '<a:font script="Deva" typeface="Mangal"/>';
    o[o.length] = '<a:font script="Telu" typeface="Gautami"/>';
    o[o.length] = '<a:font script="Taml" typeface="Latha"/>';
    o[o.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    o[o.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    o[o.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    o[o.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    o[o.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    o[o.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    o[o.length] = '<a:font script="Viet" typeface="Arial"/>';
    o[o.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    o[o.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    o[o.length] = '</a:minorFont>';
    o[o.length] = '</a:fontScheme>';
    o[o.length] = '<a:fmtScheme name="Office">';
    o[o.length] = '<a:fillStyleLst>';
    o[o.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:lin ang="16200000" scaled="1"/>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:lin ang="16200000" scaled="0"/>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '</a:fillStyleLst>';
    o[o.length] = '<a:lnStyleLst>';
    o[o.length] = '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '</a:lnStyleLst>';
    o[o.length] = '<a:effectStyleLst>';
    o[o.length] = '<a:effectStyle>';
    o[o.length] = '<a:effectLst>';
    o[o.length] = '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = '</a:effectLst>';
    o[o.length] = '</a:effectStyle>';
    o[o.length] = '<a:effectStyle>';
    o[o.length] = '<a:effectLst>';
    o[o.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = '</a:effectLst>';
    o[o.length] = '</a:effectStyle>';
    o[o.length] = '<a:effectStyle>';
    o[o.length] = '<a:effectLst>';
    o[o.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = '</a:effectLst>';
    o[o.length] = '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
    o[o.length] = '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
    o[o.length] = '</a:effectStyle>';
    o[o.length] = '</a:effectStyleLst>';
    o[o.length] = '<a:bgFillStyleLst>';
    o[o.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '</a:bgFillStyleLst>';
    o[o.length] = '</a:fmtScheme>';
    o[o.length] = '</a:themeElements>';
    o[o.length] = '<a:objectDefaults>';
    o[o.length] = '<a:spDef>';
    o[o.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
    o[o.length] = '</a:spDef>';
    o[o.length] = '<a:lnDef>';
    o[o.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
    o[o.length] = '</a:lnDef>';
    o[o.length] = '</a:objectDefaults>';
    o[o.length] = '<a:extraClrSchemeLst/>';
    o[o.length] = '</a:theme>';
    return o.join("");
}
/* [MS-XLS] 2.4.326 TODO: payload is a zip file */ function $b8f343bf88dacc48$var$parse_Theme(blob, length, opts) {
    var end = blob.l + length;
    var dwThemeVersion = blob.read_shift(4);
    if (dwThemeVersion === 124226) return;
    if (!opts.cellStyles) {
        blob.l = end;
        return;
    }
    var data = blob.slice(blob.l);
    blob.l = end;
    var zip;
    try {
        zip = $b8f343bf88dacc48$var$zip_read(data, {
            type: "array"
        });
    } catch (e) {
        return;
    }
    var themeXML = $b8f343bf88dacc48$var$getzipstr(zip, "theme/theme/theme1.xml", true);
    if (!themeXML) return;
    return $b8f343bf88dacc48$var$parse_theme_xml(themeXML, opts);
}
/* 2.5.49 */ function $b8f343bf88dacc48$var$parse_ColorTheme(blob /*::, length*/ ) {
    return blob.read_shift(4);
}
/* 2.5.155 */ function $b8f343bf88dacc48$var$parse_FullColorExt(blob /*::, length*/ ) {
    var o = {};
    o.xclrType = blob.read_shift(2);
    o.nTintShade = blob.read_shift(2);
    switch(o.xclrType){
        case 0:
            blob.l += 4;
            break;
        case 1:
            o.xclrValue = $b8f343bf88dacc48$var$parse_IcvXF(blob, 4);
            break;
        case 2:
            o.xclrValue = $b8f343bf88dacc48$var$parse_LongRGBA(blob, 4);
            break;
        case 3:
            o.xclrValue = $b8f343bf88dacc48$var$parse_ColorTheme(blob, 4);
            break;
        case 4:
            blob.l += 4;
            break;
    }
    blob.l += 8;
    return o;
}
/* 2.5.164 TODO: read 7 bits*/ function $b8f343bf88dacc48$var$parse_IcvXF(blob, length) {
    return $b8f343bf88dacc48$var$parsenoop(blob, length);
}
/* 2.5.280 */ function $b8f343bf88dacc48$var$parse_XFExtGradient(blob, length) {
    return $b8f343bf88dacc48$var$parsenoop(blob, length);
}
/* [MS-XLS] 2.5.108 */ function $b8f343bf88dacc48$var$parse_ExtProp(blob /*::, length*/ ) /*:Array<any>*/ {
    var extType = blob.read_shift(2);
    var cb = blob.read_shift(2) - 4;
    var o = [
        extType
    ];
    switch(extType){
        case 0x04:
        case 0x05:
        case 0x07:
        case 0x08:
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0D:
            o[1] = $b8f343bf88dacc48$var$parse_FullColorExt(blob, cb);
            break;
        case 0x06:
            o[1] = $b8f343bf88dacc48$var$parse_XFExtGradient(blob, cb);
            break;
        case 0x0E:
        case 0x0F:
            o[1] = blob.read_shift(cb === 1 ? 1 : 2);
            break;
        default:
            throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
    }
    return o;
}
/* 2.4.355 */ function $b8f343bf88dacc48$var$parse_XFExt(blob, length) {
    var end = blob.l + length;
    blob.l += 2;
    var ixfe = blob.read_shift(2);
    blob.l += 2;
    var cexts = blob.read_shift(2);
    var ext /*:AOA*/  = [];
    while(cexts-- > 0)ext.push($b8f343bf88dacc48$var$parse_ExtProp(blob, end - blob.l));
    return {
        ixfe: ixfe,
        ext: ext
    };
}
/* xf is an XF, see parse_XFExt for xfext */ function $b8f343bf88dacc48$var$update_xfext(xf, xfext) {
    xfext.forEach(function(xfe) {
        xfe[0];
    });
}
function $b8f343bf88dacc48$var$parse_BrtMdtinfo(data, length) {
    return {
        flags: data.read_shift(4),
        version: data.read_shift(4),
        name: $b8f343bf88dacc48$var$parse_XLWideString(data, length - 8)
    };
}
function $b8f343bf88dacc48$var$write_BrtMdtinfo(data) {
    var o = $b8f343bf88dacc48$var$new_buf(12 + 2 * data.name.length);
    o.write_shift(4, data.flags);
    o.write_shift(4, data.version);
    $b8f343bf88dacc48$var$write_XLWideString(data.name, o);
    return o.slice(0, o.l);
}
function $b8f343bf88dacc48$var$parse_BrtMdb(data) {
    var out = [];
    var cnt = data.read_shift(4);
    while(cnt-- > 0)out.push([
        data.read_shift(4),
        data.read_shift(4)
    ]);
    return out;
}
function $b8f343bf88dacc48$var$write_BrtMdb(mdb) {
    var o = $b8f343bf88dacc48$var$new_buf(4 + 8 * mdb.length);
    o.write_shift(4, mdb.length);
    for(var i = 0; i < mdb.length; ++i){
        o.write_shift(4, mdb[i][0]);
        o.write_shift(4, mdb[i][1]);
    }
    return o;
}
function $b8f343bf88dacc48$var$write_BrtBeginEsfmd(cnt, name) {
    var o = $b8f343bf88dacc48$var$new_buf(8 + 2 * name.length);
    o.write_shift(4, cnt);
    $b8f343bf88dacc48$var$write_XLWideString(name, o);
    return o.slice(0, o.l);
}
function $b8f343bf88dacc48$var$parse_BrtBeginEsmdb(data) {
    data.l += 4;
    return data.read_shift(4) != 0;
}
function $b8f343bf88dacc48$var$write_BrtBeginEsmdb(cnt, cm) {
    var o = $b8f343bf88dacc48$var$new_buf(8);
    o.write_shift(4, cnt);
    o.write_shift(4, cm ? 1 : 0);
    return o;
}
function $b8f343bf88dacc48$var$parse_xlmeta_bin(data, name, _opts) {
    var out = {
        Types: [],
        Cell: [],
        Value: []
    };
    var opts = _opts || {};
    var state = [];
    var pass = false;
    var metatype = 2;
    $b8f343bf88dacc48$var$recordhopper(data, function(val, R, RT) {
        switch(RT){
            case 335:
                out.Types.push({
                    name: val.name
                });
                break;
            case 51:
                val.forEach(function(r) {
                    if (metatype == 1) out.Cell.push({
                        type: out.Types[r[0] - 1].name,
                        index: r[1]
                    });
                    else if (metatype == 0) out.Value.push({
                        type: out.Types[r[0] - 1].name,
                        index: r[1]
                    });
                });
                break;
            case 337:
                metatype = val ? 1 : 0;
                break;
            case 338:
                metatype = 2;
                break;
            case 35:
                state.push(RT);
                pass = true;
                break;
            case 36:
                state.pop();
                pass = false;
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF && state[state.length - 1] != 35) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
function $b8f343bf88dacc48$var$write_xlmeta_bin() {
    var ba = $b8f343bf88dacc48$var$buf_array();
    $b8f343bf88dacc48$var$write_record(ba, 332);
    $b8f343bf88dacc48$var$write_record(ba, 334, $b8f343bf88dacc48$var$write_UInt32LE(1));
    $b8f343bf88dacc48$var$write_record(ba, 335, $b8f343bf88dacc48$var$write_BrtMdtinfo({
        name: "XLDAPR",
        version: 12e4,
        flags: 3496657072
    }));
    $b8f343bf88dacc48$var$write_record(ba, 336);
    $b8f343bf88dacc48$var$write_record(ba, 339, $b8f343bf88dacc48$var$write_BrtBeginEsfmd(1, "XLDAPR"));
    $b8f343bf88dacc48$var$write_record(ba, 52);
    $b8f343bf88dacc48$var$write_record(ba, 35, $b8f343bf88dacc48$var$write_UInt32LE(514));
    $b8f343bf88dacc48$var$write_record(ba, 4096, $b8f343bf88dacc48$var$write_UInt32LE(0));
    $b8f343bf88dacc48$var$write_record(ba, 4097, $b8f343bf88dacc48$var$writeuint16(1));
    $b8f343bf88dacc48$var$write_record(ba, 36);
    $b8f343bf88dacc48$var$write_record(ba, 53);
    $b8f343bf88dacc48$var$write_record(ba, 340);
    $b8f343bf88dacc48$var$write_record(ba, 337, $b8f343bf88dacc48$var$write_BrtBeginEsmdb(1, true));
    $b8f343bf88dacc48$var$write_record(ba, 51, $b8f343bf88dacc48$var$write_BrtMdb([
        [
            1,
            0
        ]
    ]));
    $b8f343bf88dacc48$var$write_record(ba, 338);
    $b8f343bf88dacc48$var$write_record(ba, 333);
    return ba.end();
}
function $b8f343bf88dacc48$var$parse_xlmeta_xml(data, name, opts) {
    var out = {
        Types: [],
        Cell: [],
        Value: []
    };
    if (!data) return out;
    var pass = false;
    var metatype = 2;
    var lastmeta;
    data.replace($b8f343bf88dacc48$var$tagregex, function(x) {
        var y = $b8f343bf88dacc48$var$parsexmltag(x);
        switch($b8f343bf88dacc48$var$strip_ns(y[0])){
            case "<?xml":
                break;
            case "<metadata":
            case "</metadata>":
                break;
            case "<metadataTypes":
            case "</metadataTypes>":
                break;
            case "<metadataType":
                out.Types.push({
                    name: y.name
                });
                break;
            case "</metadataType>":
                break;
            case "<futureMetadata":
                for(var j = 0; j < out.Types.length; ++j)if (out.Types[j].name == y.name) lastmeta = out.Types[j];
                break;
            case "</futureMetadata>":
                break;
            case "<bk>":
                break;
            case "</bk>":
                break;
            case "<rc":
                if (metatype == 1) out.Cell.push({
                    type: out.Types[y.t - 1].name,
                    index: +y.v
                });
                else if (metatype == 0) out.Value.push({
                    type: out.Types[y.t - 1].name,
                    index: +y.v
                });
                break;
            case "</rc>":
                break;
            case "<cellMetadata":
                metatype = 1;
                break;
            case "</cellMetadata>":
                metatype = 2;
                break;
            case "<valueMetadata":
                metatype = 0;
                break;
            case "</valueMetadata>":
                metatype = 2;
                break;
            case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            case "<rvb":
                if (!lastmeta) break;
                if (!lastmeta.offsets) lastmeta.offsets = [];
                lastmeta.offsets.push(+y.i);
                break;
            default:
                if (!pass && (opts == null ? void 0 : opts.WTF)) throw new Error("unrecognized " + y[0] + " in metadata");
        }
        return x;
    });
    return out;
}
function $b8f343bf88dacc48$var$write_xlmeta_xml() {
    var o = [
        $b8f343bf88dacc48$var$XML_HEADER
    ];
    o.push('<metadata xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:xlrd="http://schemas.microsoft.com/office/spreadsheetml/2017/richdata" xmlns:xda="http://schemas.microsoft.com/office/spreadsheetml/2017/dynamicarray">\n  <metadataTypes count="1">\n    <metadataType name="XLDAPR" minSupportedVersion="120000" copy="1" pasteAll="1" pasteValues="1" merge="1" splitFirst="1" rowColShift="1" clearFormats="1" clearComments="1" assign="1" coerce="1" cellMeta="1"/>\n  </metadataTypes>\n  <futureMetadata name="XLDAPR" count="1">\n    <bk>\n      <extLst>\n        <ext uri="{bdbb8cdc-fa1e-496e-a857-3c3f30c029c3}">\n          <xda:dynamicArrayProperties fDynamic="1" fCollapsed="0"/>\n        </ext>\n      </extLst>\n    </bk>\n  </futureMetadata>\n  <cellMetadata count="1">\n    <bk>\n      <rc t="1" v="0"/>\n    </bk>\n  </cellMetadata>\n</metadata>');
    return o.join("");
}
/* 18.6 Calculation Chain */ function $b8f343bf88dacc48$var$parse_cc_xml(data /*::, name, opts*/ ) /*:Array<any>*/ {
    var d = [];
    if (!data) return d;
    var i = 1;
    (data.match($b8f343bf88dacc48$var$tagregex) || []).forEach(function(x) {
        var y = $b8f343bf88dacc48$var$parsexmltag(x);
        switch(y[0]){
            case '<?xml':
                break;
            /* 18.6.2  calcChain CT_CalcChain 1 */ case '<calcChain':
            case '<calcChain>':
            case '</calcChain>':
                break;
            /* 18.6.1  c CT_CalcCell 1 */ case '<c':
                delete y[0];
                if (y.i) i = y.i;
                else y.i = i;
                d.push(y);
                break;
        }
    });
    return d;
}
//function write_cc_xml(data, opts) { }
/* [MS-XLSB] 2.6.4.1 */ function $b8f343bf88dacc48$var$parse_BrtCalcChainItem$(data) {
    var out = {};
    out.i = data.read_shift(4);
    var cell = {};
    cell.r = data.read_shift(4);
    cell.c = data.read_shift(4);
    out.r = $b8f343bf88dacc48$var$encode_cell(cell);
    var flags = data.read_shift(1);
    if (flags & 0x2) out.l = '1';
    if (flags & 0x8) out.a = '1';
    return out;
}
/* 18.6 Calculation Chain */ function $b8f343bf88dacc48$var$parse_cc_bin(data, name, opts) {
    var out = [];
    var pass = false;
    $b8f343bf88dacc48$var$recordhopper(data, function hopper_cc(val, R, RT) {
        switch(RT){
            case 0x003F:
                /* 'BrtCalcChainItem$' */ out.push(val);
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
//function write_cc_bin(data, opts) { }
/* 18.14 Supplementary Workbook Data */ function $b8f343bf88dacc48$var$parse_xlink_xml() {
//var opts = _opts || {};
//if(opts.WTF) throw "XLSX External Link";
}
/* [MS-XLSB] 2.1.7.25 External Link */ function $b8f343bf88dacc48$var$parse_xlink_bin(data, rel, name /*:string*/ , _opts) {
    if (!data) return data;
    var opts = _opts || {};
    var pass = false, end = false;
    $b8f343bf88dacc48$var$recordhopper(data, function xlink_parse(val, R, RT) {
        if (end) return;
        switch(RT){
            case 0x0167:
            /* 'BrtSupTabs' */ case 0x016B:
            /* 'BrtExternTableStart' */ case 0x016C:
            /* 'BrtExternTableEnd' */ case 0x016E:
            /* 'BrtExternRowHdr' */ case 0x016F:
            /* 'BrtExternCellBlank' */ case 0x0170:
            /* 'BrtExternCellReal' */ case 0x0171:
            /* 'BrtExternCellBool' */ case 0x0172:
            /* 'BrtExternCellError' */ case 0x0173:
            /* 'BrtExternCellString' */ case 0x01D8:
            /* 'BrtExternValueMeta' */ case 0x0241:
            /* 'BrtSupNameStart' */ case 0x0242:
            /* 'BrtSupNameValueStart' */ case 0x0243:
            /* 'BrtSupNameValueEnd' */ case 0x0244:
            /* 'BrtSupNameNum' */ case 0x0245:
            /* 'BrtSupNameErr' */ case 0x0246:
            /* 'BrtSupNameSt' */ case 0x0247:
            /* 'BrtSupNameNil' */ case 0x0248:
            /* 'BrtSupNameBool' */ case 0x0249:
            /* 'BrtSupNameFmla' */ case 0x024A:
            /* 'BrtSupNameBits' */ case 0x024B:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
}
/* 20.5 DrawingML - SpreadsheetML Drawing */ /* 20.5.2.35 wsDr CT_Drawing */ function $b8f343bf88dacc48$var$parse_drawing(data, rels /*:any*/ ) {
    if (!data) return "??";
    /*
	  Chartsheet Drawing:
	   - 20.5.2.35 wsDr CT_Drawing
	    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
	     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
	      - 20.1.2.2.16 graphic CT_GraphicalObject
	       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
          - chart reference
	   the actual type is based on the URI of the graphicData
		TODO: handle embedded charts and other types of graphics
	*/ var id = (data.match(/<c:chart [^<>]*r:id="([^<>"]*)"/) || [
        "",
        ""
    ])[1];
    return rels['!id'][id].Target;
}
/* L.5.5.2 SpreadsheetML Comments + VML Schema */ function $b8f343bf88dacc48$var$parse_vml(data /*:string*/ , sheet, comments) {
    var cidx = 0;
    ($b8f343bf88dacc48$var$str_match_xml_ns_g(data, "shape") || []).forEach(function(m) {
        var type = "";
        var hidden = true;
        var aidx = -1;
        var R = -1, C = -1;
        m.replace($b8f343bf88dacc48$var$tagregex, function(x /*:string*/ , idx /*:number*/ ) {
            var y = $b8f343bf88dacc48$var$parsexmltag(x);
            switch($b8f343bf88dacc48$var$strip_ns(y[0])){
                case '<ClientData':
                    if (y.ObjectType) type = y.ObjectType;
                    break;
                case '<Visible':
                case '<Visible/>':
                    hidden = false;
                    break;
                case '<Row':
                case '<Row>':
                    aidx = idx + x.length;
                    break;
                case '</Row>':
                    R = +m.slice(aidx, idx).trim();
                    break;
                case '<Column':
                case '<Column>':
                    aidx = idx + x.length;
                    break;
                case '</Column>':
                    C = +m.slice(aidx, idx).trim();
                    break;
            }
            return "";
        });
        switch(type){
            case 'Note':
                var cell = $b8f343bf88dacc48$var$ws_get_cell_stub(sheet, R >= 0 && C >= 0 ? $b8f343bf88dacc48$var$encode_cell({
                    r: R,
                    c: C
                }) : comments[cidx].ref);
                if (cell.c) cell.c.hidden = hidden;
                ++cidx;
                break;
        }
    });
}
/* comment boxes */ function $b8f343bf88dacc48$var$write_vml(rId /*:number*/ , comments, ws) {
    var csize = [
        21600,
        21600
    ];
    /* L.5.2.1.2 Path Attribute */ var bbox = [
        "m0,0l0",
        csize[1],
        csize[0],
        csize[1],
        csize[0],
        "0xe"
    ].join(",");
    var o = [
        $b8f343bf88dacc48$var$writextag("xml", null, {
            'xmlns:v': $b8f343bf88dacc48$var$XLMLNS.v,
            'xmlns:o': $b8f343bf88dacc48$var$XLMLNS.o,
            'xmlns:x': $b8f343bf88dacc48$var$XLMLNS.x,
            'xmlns:mv': $b8f343bf88dacc48$var$XLMLNS.mv
        }).replace(/\/>/, ">"),
        $b8f343bf88dacc48$var$writextag("o:shapelayout", $b8f343bf88dacc48$var$writextag("o:idmap", null, {
            'v:ext': "edit",
            'data': rId
        }), {
            'v:ext': "edit"
        })
    ];
    var _shapeid = 65536 * rId;
    var _comments = comments || [];
    if (_comments.length > 0) o.push($b8f343bf88dacc48$var$writextag("v:shapetype", [
        $b8f343bf88dacc48$var$writextag("v:stroke", null, {
            joinstyle: "miter"
        }),
        $b8f343bf88dacc48$var$writextag("v:path", null, {
            gradientshapeok: "t",
            'o:connecttype': "rect"
        })
    ].join(""), {
        id: "_x0000_t202",
        coordsize: csize.join(","),
        'o:spt': 202,
        path: bbox
    }));
    _comments.forEach(function(x) {
        ++_shapeid;
        o.push($b8f343bf88dacc48$var$write_vml_comment(x, _shapeid));
    });
    o.push('</xml>');
    return o.join("");
}
function $b8f343bf88dacc48$var$write_vml_comment(x, _shapeid, ws) /*:string*/ {
    var c = $b8f343bf88dacc48$var$decode_cell(x[0]);
    var fillopts = /*::(*/ {
        'color2': "#BEFF82",
        'type': "gradient"
    } /*:: :any)*/ ;
    if (fillopts.type == "gradient") fillopts.angle = "-180";
    var fillparm = fillopts.type == "gradient" ? $b8f343bf88dacc48$var$writextag("o:fill", null, {
        type: "gradientUnscaled",
        'v:ext': "view"
    }) : null;
    var fillxml = $b8f343bf88dacc48$var$writextag('v:fill', fillparm, fillopts);
    var shadata = {
        on: "t",
        'obscured': "t"
    } /*:any*/ ;
    return [
        '<v:shape' + $b8f343bf88dacc48$var$wxt_helper({
            id: '_x0000_s' + _shapeid,
            type: "#_x0000_t202",
            style: "position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (x[1].hidden ? ";visibility:hidden" : ""),
            fillcolor: "#ECFAD4",
            strokecolor: "#edeaa1"
        }) + '>',
        fillxml,
        $b8f343bf88dacc48$var$writextag("v:shadow", null, shadata),
        $b8f343bf88dacc48$var$writextag("v:path", null, {
            'o:connecttype': "none"
        }),
        '<v:textbox><div style="text-align:left"></div></v:textbox>',
        '<x:ClientData ObjectType="Note">',
        '<x:MoveWithCells/>',
        '<x:SizeWithCells/>',
        /* Part 4 19.4.2.3 Anchor (Anchor) */ $b8f343bf88dacc48$var$writetag('x:Anchor', [
            c.c + 1,
            0,
            c.r + 1,
            0,
            c.c + 3,
            20,
            c.r + 5,
            20
        ].join(",")),
        $b8f343bf88dacc48$var$writetag('x:AutoFill', "False"),
        $b8f343bf88dacc48$var$writetag('x:Row', String(c.r)),
        $b8f343bf88dacc48$var$writetag('x:Column', String(c.c)),
        x[1].hidden ? '' : '<x:Visible/>',
        '</x:ClientData>',
        '</v:shape>'
    ].join("");
}
function $b8f343bf88dacc48$var$sheet_insert_comments(sheet /*:WorkSheet*/ , comments /*:Array<RawComment>*/ , threaded /*:boolean*/ , people /*:?Array<any>*/ ) {
    var dense = sheet["!data"] != null;
    var cell /*:Cell*/ ;
    comments.forEach(function(comment) {
        var r = $b8f343bf88dacc48$var$decode_cell(comment.ref);
        if (r.r < 0 || r.c < 0) return;
        if (dense) {
            if (!sheet["!data"][r.r]) sheet["!data"][r.r] = [];
            cell = sheet["!data"][r.r][r.c];
        } else cell = sheet[comment.ref];
        if (!cell) {
            cell = {
                t: "z"
            } /*:any*/ ;
            if (dense) sheet["!data"][r.r][r.c] = cell;
            else sheet[comment.ref] = cell;
            var range = $b8f343bf88dacc48$var$safe_decode_range(sheet["!ref"] || "BDWGO1000001:A1");
            if (range.s.r > r.r) range.s.r = r.r;
            if (range.e.r < r.r) range.e.r = r.r;
            if (range.s.c > r.c) range.s.c = r.c;
            if (range.e.c < r.c) range.e.c = r.c;
            var encoded = $b8f343bf88dacc48$var$encode_range(range);
            sheet["!ref"] = encoded;
        }
        if (!cell.c) cell.c = [];
        var o /*:Comment*/  = {
            a: comment.author,
            t: comment.t,
            r: comment.r,
            T: threaded
        };
        if (comment.h) o.h = comment.h;
        /* threaded comments always override */ for(var i = cell.c.length - 1; i >= 0; --i){
            if (!threaded && cell.c[i].T) return;
            if (threaded && !cell.c[i].T) cell.c.splice(i, 1);
        }
        if (threaded && people) {
            for(i = 0; i < people.length; ++i)if (o.a == people[i].id) {
                o.a = people[i].name || o.a;
                break;
            }
        }
        cell.c.push(o);
    });
}
/* 18.7 Comments */ function $b8f343bf88dacc48$var$parse_comments_xml(data /*:string*/ , opts) /*:Array<RawComment>*/ {
    /* 18.7.6 CT_Comments */ if (data.match(/<(?:\w+:)?comments *\/>/)) return [];
    var authors /*:Array<string>*/  = [];
    var commentList /*:Array<RawComment>*/  = [];
    var authtag = $b8f343bf88dacc48$var$str_match_xml_ns(data, "authors");
    if (authtag && authtag[1]) authtag[1].split(/<\/\w*:?author>/).forEach(function(x) {
        if (x === "" || x.trim() === "") return;
        var a = x.match(/<(?:\w+:)?author[^<>]*>(.*)/);
        if (a) authors.push(a[1]);
    });
    var cmnttag = $b8f343bf88dacc48$var$str_match_xml_ns(data, "commentList");
    if (cmnttag && cmnttag[1]) cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x) {
        if (x === "" || x.trim() === "") return;
        var cm = x.match(/<(?:\w+:)?comment[^<>]*>/);
        if (!cm) return;
        var y = $b8f343bf88dacc48$var$parsexmltag(cm[0]);
        var comment /*:RawComment*/  = {
            author: y.authorId && authors[y.authorId] || "sheetjsghost",
            ref: y.ref,
            guid: y.guid
        } /*:any*/ ;
        var cell = $b8f343bf88dacc48$var$decode_cell(y.ref);
        if (opts.sheetRows && opts.sheetRows <= cell.r) return;
        var textMatch = $b8f343bf88dacc48$var$str_match_xml_ns(x, "text");
        var rt = !!textMatch && !!textMatch[1] && $b8f343bf88dacc48$var$parse_si(textMatch[1]) || {
            r: "",
            t: "",
            h: ""
        };
        comment.r = rt.r;
        if (rt.r == "<t></t>") rt.t = rt.h = "";
        comment.t = (rt.t || "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
        if (opts.cellHTML) comment.h = rt.h;
        commentList.push(comment);
    });
    return commentList;
}
function $b8f343bf88dacc48$var$write_comments_xml(data /*::, opts*/ ) {
    var o = [
        $b8f343bf88dacc48$var$XML_HEADER,
        $b8f343bf88dacc48$var$writextag('comments', null, {
            'xmlns': $b8f343bf88dacc48$var$XMLNS_main[0]
        })
    ];
    var iauthor /*:Array<string>*/  = [];
    o.push("<authors>");
    data.forEach(function(x) {
        x[1].forEach(function(w) {
            var a = $b8f343bf88dacc48$var$escapexml(w.a);
            if (iauthor.indexOf(a) == -1) {
                iauthor.push(a);
                o.push("<author>" + a + "</author>");
            }
            if (w.T && w.ID && iauthor.indexOf("tc=" + w.ID) == -1) {
                iauthor.push("tc=" + w.ID);
                o.push("<author>tc=" + w.ID + "</author>");
            }
        });
    });
    if (iauthor.length == 0) {
        iauthor.push("SheetJ5");
        o.push("<author>SheetJ5</author>");
    }
    o.push("</authors>");
    o.push("<commentList>");
    data.forEach(function(d) {
        /* 18.7.3 CT_Comment */ var lastauthor = 0, ts = [], tcnt = 0;
        if (d[1][0] && d[1][0].T && d[1][0].ID) lastauthor = iauthor.indexOf("tc=" + d[1][0].ID);
        d[1].forEach(function(c) {
            if (c.a) lastauthor = iauthor.indexOf($b8f343bf88dacc48$var$escapexml(c.a));
            if (c.T) ++tcnt;
            ts.push(c.t == null ? "" : $b8f343bf88dacc48$var$escapexml(c.t));
        });
        if (tcnt === 0) d[1].forEach(function(c) {
            o.push('<comment ref="' + d[0] + '" authorId="' + iauthor.indexOf($b8f343bf88dacc48$var$escapexml(c.a)) + '"><text>');
            o.push($b8f343bf88dacc48$var$writetag("t", c.t == null ? "" : $b8f343bf88dacc48$var$escapexml(c.t)));
            o.push('</text></comment>');
        });
        else {
            if (d[1][0] && d[1][0].T && d[1][0].ID) lastauthor = iauthor.indexOf("tc=" + d[1][0].ID);
            /* based on Threaded Comments -> Comments projection */ o.push('<comment ref="' + d[0] + '" authorId="' + lastauthor + '"><text>');
            var t = "Comment:\n    " + ts[0] + "\n";
            for(var i = 1; i < ts.length; ++i)t += "Reply:\n    " + ts[i] + "\n";
            o.push($b8f343bf88dacc48$var$writetag("t", $b8f343bf88dacc48$var$escapexml(t)));
            o.push('</text></comment>');
        }
    });
    o.push("</commentList>");
    if (o.length > 2) {
        o[o.length] = '</comments>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSX] 2.1.17 */ function $b8f343bf88dacc48$var$parse_tcmnt_xml(data /*:string*/ , opts) /*:Array<RawComment>*/ {
    var out = [];
    var pass = false, comment = {}, tidx = 0;
    data.replace($b8f343bf88dacc48$var$tagregex, function xml_tcmnt(x, idx) {
        var y /*:any*/  = $b8f343bf88dacc48$var$parsexmltag(x);
        switch($b8f343bf88dacc48$var$strip_ns(y[0])){
            case '<?xml':
                break;
            /* 2.6.207 ThreadedComments CT_ThreadedComments */ case '<ThreadedComments':
                break;
            case '</ThreadedComments>':
                break;
            /* 2.6.205 threadedComment CT_ThreadedComment */ case '<threadedComment':
                comment = {
                    author: y.personId,
                    guid: y.id,
                    ref: y.ref,
                    T: 1
                };
                break;
            case '</threadedComment>':
                if (comment.t != null) out.push(comment);
                break;
            case '<text>':
            case '<text':
                tidx = idx + x.length;
                break;
            case '</text>':
                comment.t = data.slice(tidx, idx).replace(/\r\n/g, "\n").replace(/\r/g, "\n");
                break;
            /* 2.6.206 mentions CT_ThreadedCommentMentions TODO */ case '<mentions':
            case '<mentions>':
                pass = true;
                break;
            case '</mentions>':
                pass = false;
                break;
            /* 2.6.202 mention CT_Mention TODO */ /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
            case '<extLst/>':
                break;
            /* 18.2.7  ext CT_Extension + */ case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
        }
        return x;
    });
    return out;
}
function $b8f343bf88dacc48$var$write_tcmnt_xml(comments, people, opts) {
    var o = [
        $b8f343bf88dacc48$var$XML_HEADER,
        $b8f343bf88dacc48$var$writextag('ThreadedComments', null, {
            'xmlns': $b8f343bf88dacc48$var$XMLNS.TCMNT
        }).replace(/[\/]>/, ">")
    ];
    comments.forEach(function(carr) {
        var rootid = "";
        (carr[1] || []).forEach(function(c, idx) {
            if (!c.T) {
                delete c.ID;
                return;
            }
            if (c.a && people.indexOf(c.a) == -1) people.push(c.a);
            var tcopts = {
                ref: carr[0],
                id: "{54EE7951-7262-4200-6969-" + ("000000000000" + opts.tcid++).slice(-12) + "}"
            };
            if (idx == 0) rootid = tcopts.id;
            else tcopts.parentId = rootid;
            c.ID = tcopts.id;
            if (c.a) tcopts.personId = "{54EE7950-7262-4200-6969-" + ("000000000000" + people.indexOf(c.a)).slice(-12) + "}";
            o.push($b8f343bf88dacc48$var$writextag('threadedComment', $b8f343bf88dacc48$var$writetag('text', c.t || ""), tcopts));
        });
    });
    o.push('</ThreadedComments>');
    return o.join("");
}
/* [MS-XLSX] 2.1.18 */ function $b8f343bf88dacc48$var$parse_people_xml(data /*:string*/ , opts) {
    var out = [];
    var pass = false;
    data.replace($b8f343bf88dacc48$var$tagregex, function xml_tcmnt(x) {
        var y /*:any*/  = $b8f343bf88dacc48$var$parsexmltag(x);
        switch($b8f343bf88dacc48$var$strip_ns(y[0])){
            case '<?xml':
                break;
            /* 2.4.85 personList CT_PersonList */ case '<personList':
                break;
            case '</personList>':
                break;
            /* 2.6.203 person CT_Person TODO: providers */ case '<person':
                out.push({
                    name: y.displayname,
                    id: y.id
                });
                break;
            case '</person>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
            case '<extLst/>':
                break;
            /* 18.2.7  ext CT_Extension + */ case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
        }
        return x;
    });
    return out;
}
function $b8f343bf88dacc48$var$write_people_xml(people /*, opts*/ ) {
    var o = [
        $b8f343bf88dacc48$var$XML_HEADER,
        $b8f343bf88dacc48$var$writextag('personList', null, {
            'xmlns': $b8f343bf88dacc48$var$XMLNS.TCMNT,
            'xmlns:x': $b8f343bf88dacc48$var$XMLNS_main[0]
        }).replace(/[\/]>/, ">")
    ];
    people.forEach(function(person, idx) {
        o.push($b8f343bf88dacc48$var$writextag('person', null, {
            displayName: person,
            id: "{54EE7950-7262-4200-6969-" + ("000000000000" + idx).slice(-12) + "}",
            userId: person,
            providerId: "None"
        }));
    });
    o.push("</personList>");
    return o.join("");
}
/* [MS-XLSB] 2.4.28 BrtBeginComment */ function $b8f343bf88dacc48$var$parse_BrtBeginComment(data) {
    var out = {};
    out.iauthor = data.read_shift(4);
    var rfx = $b8f343bf88dacc48$var$parse_UncheckedRfX(data, 16);
    out.rfx = rfx.s;
    out.ref = $b8f343bf88dacc48$var$encode_cell(rfx.s);
    data.l += 16; /*var guid = parse_GUID(data); */ 
    return out;
}
function $b8f343bf88dacc48$var$write_BrtBeginComment(data, o) {
    if (o == null) o = $b8f343bf88dacc48$var$new_buf(36);
    o.write_shift(4, data[1].iauthor);
    $b8f343bf88dacc48$var$write_UncheckedRfX(data[0], o);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    return o;
}
/* [MS-XLSB] 2.4.327 BrtCommentAuthor */ var $b8f343bf88dacc48$var$parse_BrtCommentAuthor = $b8f343bf88dacc48$var$parse_XLWideString;
function $b8f343bf88dacc48$var$write_BrtCommentAuthor(data) {
    return $b8f343bf88dacc48$var$write_XLWideString(data.slice(0, 54));
}
/* [MS-XLSB] 2.1.7.8 Comments */ function $b8f343bf88dacc48$var$parse_comments_bin(data, opts) /*:Array<RawComment>*/ {
    var out /*:Array<RawComment>*/  = [];
    var authors /*:Array<string>*/  = [];
    var c = {};
    var pass = false;
    $b8f343bf88dacc48$var$recordhopper(data, function hopper_cmnt(val, R, RT) {
        switch(RT){
            case 0x0278:
                /* 'BrtCommentAuthor' */ authors.push(val);
                break;
            case 0x027B:
                /* 'BrtBeginComment' */ c = val;
                break;
            case 0x027D:
                /* 'BrtCommentText' */ c.t = val.t;
                c.h = val.h;
                c.r = val.r;
                break;
            case 0x027C:
                /* 'BrtEndComment' */ c.author = authors[c.iauthor];
                delete c /*:any*/ .iauthor;
                if (opts.sheetRows && c.rfx && opts.sheetRows <= c.rfx.r) break;
                if (!c.t) c.t = "";
                delete c.rfx;
                out.push(c);
                break;
            case 0x0C00:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                break;
            case 0x0026:
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
function $b8f343bf88dacc48$var$write_comments_bin(data /*::, opts*/ ) {
    var ba = $b8f343bf88dacc48$var$buf_array();
    var iauthor /*:Array<string>*/  = [];
    $b8f343bf88dacc48$var$write_record(ba, 0x0274 /* BrtBeginComments */ );
    $b8f343bf88dacc48$var$write_record(ba, 0x0276 /* BrtBeginCommentAuthors */ );
    data.forEach(function(comment) {
        comment[1].forEach(function(c) {
            if (iauthor.indexOf(c.a) > -1) return;
            iauthor.push(c.a.slice(0, 54));
            $b8f343bf88dacc48$var$write_record(ba, 0x0278 /* BrtCommentAuthor */ , $b8f343bf88dacc48$var$write_BrtCommentAuthor(c.a));
            if (c.T && c.ID && iauthor.indexOf("tc=" + c.ID) == -1) {
                iauthor.push("tc=" + c.ID);
                $b8f343bf88dacc48$var$write_record(ba, 0x0278 /* BrtCommentAuthor */ , $b8f343bf88dacc48$var$write_BrtCommentAuthor("tc=" + c.ID));
            }
        });
    });
    $b8f343bf88dacc48$var$write_record(ba, 0x0277 /* BrtEndCommentAuthors */ );
    $b8f343bf88dacc48$var$write_record(ba, 0x0279 /* BrtBeginCommentList */ );
    data.forEach(function(comment) {
        comment[1].forEach(function(c) {
            var _ia = -1;
            if (c.ID) _ia = iauthor.indexOf("tc=" + c.ID);
            if (_ia == -1 && comment[1][0].T && comment[1][0].ID) _ia = iauthor.indexOf("tc=" + comment[1][0].ID);
            if (_ia == -1) _ia = iauthor.indexOf(c.a);
            c.iauthor = _ia;
            var range = {
                s: $b8f343bf88dacc48$var$decode_cell(comment[0]),
                e: $b8f343bf88dacc48$var$decode_cell(comment[0])
            };
            $b8f343bf88dacc48$var$write_record(ba, 0x027B /* BrtBeginComment */ , $b8f343bf88dacc48$var$write_BrtBeginComment([
                range,
                c
            ]));
            if (c.t && c.t.length > 0) $b8f343bf88dacc48$var$write_record(ba, 0x027D /* BrtCommentText */ , $b8f343bf88dacc48$var$write_BrtCommentText(c));
            $b8f343bf88dacc48$var$write_record(ba, 0x027C /* BrtEndComment */ );
            delete c.iauthor;
        });
    });
    $b8f343bf88dacc48$var$write_record(ba, 0x027A /* BrtEndCommentList */ );
    $b8f343bf88dacc48$var$write_record(ba, 0x0275 /* BrtEndComments */ );
    return ba.end();
}
var $b8f343bf88dacc48$var$CT_VBA = "application/vnd.ms-office.vbaProject";
function $b8f343bf88dacc48$var$make_vba_xls(cfb) {
    var newcfb = $b8f343bf88dacc48$export$9f0e51cd97c572a.utils.cfb_new({
        root: "R"
    });
    cfb.FullPaths.forEach(function(p, i) {
        if (p.slice(-1) === "/" || !p.match(/_VBA_PROJECT_CUR/)) return;
        var newpath = p.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
        $b8f343bf88dacc48$export$9f0e51cd97c572a.utils.cfb_add(newcfb, newpath, cfb.FileIndex[i].content);
    });
    return $b8f343bf88dacc48$export$9f0e51cd97c572a.write(newcfb);
}
function $b8f343bf88dacc48$var$fill_vba_xls(cfb, vba) {
    vba.FullPaths.forEach(function(p, i) {
        if (i == 0) return;
        var newpath = p.replace(/^[\/]*[^\/]*[\/]/, "/_VBA_PROJECT_CUR/");
        if (newpath.slice(-1) !== "/") $b8f343bf88dacc48$export$9f0e51cd97c572a.utils.cfb_add(cfb, newpath, vba.FileIndex[i].content);
    });
}
var $b8f343bf88dacc48$var$VBAFMTS = [
    "xlsb",
    "xlsm",
    "xlam",
    "biff8",
    "xla"
];
/* macro and dialog sheet stubs */ function $b8f343bf88dacc48$var$parse_ds_bin() /*:Worksheet*/ {
    return {
        '!type': 'dialog'
    };
}
function $b8f343bf88dacc48$var$parse_ds_xml() /*:Worksheet*/ {
    return {
        '!type': 'dialog'
    };
}
function $b8f343bf88dacc48$var$parse_ms_bin() /*:Worksheet*/ {
    return {
        '!type': 'macro'
    };
}
function $b8f343bf88dacc48$var$parse_ms_xml() /*:Worksheet*/ {
    return {
        '!type': 'macro'
    };
}
/* TODO: it will be useful to parse the function str */ var $b8f343bf88dacc48$var$rc_to_a1 = /*#__PURE__*/ function() {
    var rcregex = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;
    var rcbase /*:Cell*/  = {
        r: 0,
        c: 0
    } /*:any*/ ;
    function rcfunc($$, $1, $2, $3) {
        var cRel = false, rRel = false;
        if ($2.length == 0) rRel = true;
        else if ($2.charAt(0) == "[") {
            rRel = true;
            $2 = $2.slice(1, -1);
        }
        if ($3.length == 0) cRel = true;
        else if ($3.charAt(0) == "[") {
            cRel = true;
            $3 = $3.slice(1, -1);
        }
        var R = $2.length > 0 ? parseInt($2, 10) | 0 : 0, C = $3.length > 0 ? parseInt($3, 10) | 0 : 0;
        if (cRel) C += rcbase.c;
        else --C;
        if (rRel) R += rcbase.r;
        else --R;
        return $1 + (cRel ? "" : "$") + $b8f343bf88dacc48$var$encode_col(C) + (rRel ? "" : "$") + $b8f343bf88dacc48$var$encode_row(R);
    }
    return function rc_to_a1(fstr /*:string*/ , base /*:Cell*/ ) /*:string*/ {
        rcbase = base;
        return fstr.replace(rcregex, rcfunc);
    };
}();
var $b8f343bf88dacc48$var$crefregex = /(^|[^._A-Z0-9])(\$?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])(\$?)(\d{1,7})(?![_.\(A-Za-z0-9])/g;
try {
    $b8f343bf88dacc48$var$crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;
} catch (e) {}
var $b8f343bf88dacc48$var$a1_to_rc = /*#__PURE__*/ function() {
    return function a1_to_rc(fstr /*:string*/ , base /*:CellAddress*/ ) {
        return fstr.replace($b8f343bf88dacc48$var$crefregex, function($0, $1, $2, $3, $4, $5) {
            var c = $b8f343bf88dacc48$var$decode_col($3) - ($2 ? 0 : base.c);
            var r = $b8f343bf88dacc48$var$decode_row($5) - ($4 ? 0 : base.r);
            var R = $4 == "$" ? r + 1 : r == 0 ? "" : "[" + r + "]";
            var C = $2 == "$" ? c + 1 : c == 0 ? "" : "[" + c + "]";
            return $1 + "R" + R + "C" + C;
        });
    };
}();
/* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */ function $b8f343bf88dacc48$var$shift_formula_str(f /*:string*/ , delta /*:Cell*/ ) /*:string*/ {
    return f.replace($b8f343bf88dacc48$var$crefregex, function($0, $1, $2, $3, $4, $5) {
        return $1 + ($2 == "$" ? $2 + $3 : $b8f343bf88dacc48$var$encode_col($b8f343bf88dacc48$var$decode_col($3) + delta.c)) + ($4 == "$" ? $4 + $5 : $b8f343bf88dacc48$var$encode_row($b8f343bf88dacc48$var$decode_row($5) + delta.r));
    });
}
function $b8f343bf88dacc48$var$shift_formula_xlsx(f /*:string*/ , range /*:string*/ , cell /*:string*/ ) /*:string*/ {
    var r = $b8f343bf88dacc48$var$decode_range(range), s = r.s, c = $b8f343bf88dacc48$var$decode_cell(cell);
    var delta = {
        r: c.r - s.r,
        c: c.c - s.c
    };
    return $b8f343bf88dacc48$var$shift_formula_str(f, delta);
}
/* TODO: parse formula */ function $b8f343bf88dacc48$var$fuzzyfmla(f /*:string*/ ) /*:boolean*/ {
    if (f.length == 1) return false;
    return true;
}
function $b8f343bf88dacc48$var$_xlfn(f /*:string*/ ) /*:string*/ {
    return f.replace(/_xlfn\./g, "");
}
function $b8f343bf88dacc48$var$parseread1(blob) {
    blob.l += 1;
    return;
}
/* [MS-XLS] 2.5.51 */ function $b8f343bf88dacc48$var$parse_ColRelU(blob, length) {
    var c = blob.read_shift(length == 1 ? 1 : 2);
    return [
        c & 0x3FFF,
        c >> 14 & 1,
        c >> 15 & 1
    ];
}
/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */ function $b8f343bf88dacc48$var$parse_RgceArea(blob, length, opts) {
    var w = 2;
    if (opts) {
        if (opts.biff >= 2 && opts.biff <= 5) return $b8f343bf88dacc48$var$parse_RgceArea_BIFF2(blob, length, opts);
        else if (opts.biff == 12) w = 4;
    }
    var r = blob.read_shift(w), R = blob.read_shift(w);
    var c = $b8f343bf88dacc48$var$parse_ColRelU(blob, 2);
    var C = $b8f343bf88dacc48$var$parse_ColRelU(blob, 2);
    return {
        s: {
            r: r,
            c: c[0],
            cRel: c[1],
            rRel: c[2]
        },
        e: {
            r: R,
            c: C[0],
            cRel: C[1],
            rRel: C[2]
        }
    };
}
/* BIFF 2-5 encodes flags in the row field */ function $b8f343bf88dacc48$var$parse_RgceArea_BIFF2(blob /*::, length, opts*/ ) {
    var r = $b8f343bf88dacc48$var$parse_ColRelU(blob, 2), R = $b8f343bf88dacc48$var$parse_ColRelU(blob, 2);
    var c = blob.read_shift(1);
    var C = blob.read_shift(1);
    return {
        s: {
            r: r[0],
            c: c,
            cRel: r[1],
            rRel: r[2]
        },
        e: {
            r: R[0],
            c: C,
            cRel: R[1],
            rRel: R[2]
        }
    };
}
/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */ function $b8f343bf88dacc48$var$parse_RgceAreaRel(blob, length, opts) {
    if (opts.biff < 8) return $b8f343bf88dacc48$var$parse_RgceArea_BIFF2(blob, length, opts);
    var r = blob.read_shift(opts.biff == 12 ? 4 : 2), R = blob.read_shift(opts.biff == 12 ? 4 : 2);
    var c = $b8f343bf88dacc48$var$parse_ColRelU(blob, 2);
    var C = $b8f343bf88dacc48$var$parse_ColRelU(blob, 2);
    return {
        s: {
            r: r,
            c: c[0],
            cRel: c[1],
            rRel: c[2]
        },
        e: {
            r: R,
            c: C[0],
            cRel: C[1],
            rRel: C[2]
        }
    };
}
/* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */ function $b8f343bf88dacc48$var$parse_RgceLoc(blob, length, opts) {
    if (opts && opts.biff >= 2 && opts.biff <= 5) return $b8f343bf88dacc48$var$parse_RgceLoc_BIFF2(blob, length, opts);
    var r = blob.read_shift(opts && opts.biff == 12 ? 4 : 2);
    var c = $b8f343bf88dacc48$var$parse_ColRelU(blob, 2);
    return {
        r: r,
        c: c[0],
        cRel: c[1],
        rRel: c[2]
    };
}
function $b8f343bf88dacc48$var$parse_RgceLoc_BIFF2(blob /*::, length, opts*/ ) {
    var r = $b8f343bf88dacc48$var$parse_ColRelU(blob, 2);
    var c = blob.read_shift(1);
    return {
        r: r[0],
        c: c,
        cRel: r[1],
        rRel: r[2]
    };
}
/* [MS-XLS] 2.5.198.107, 2.5.47 */ function $b8f343bf88dacc48$var$parse_RgceElfLoc(blob /*::, length, opts*/ ) {
    var r = blob.read_shift(2);
    var c = blob.read_shift(2);
    return {
        r: r,
        c: c & 0xFF,
        fQuoted: !!(c & 0x4000),
        cRel: c >> 15,
        rRel: c >> 15
    };
}
/* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */ function $b8f343bf88dacc48$var$parse_RgceLocRel(blob, length, opts) {
    var biff = opts && opts.biff ? opts.biff : 8;
    if (biff >= 2 && biff <= 5) return $b8f343bf88dacc48$var$parse_RgceLocRel_BIFF2(blob, length, opts);
    var r = blob.read_shift(biff >= 12 ? 4 : 2);
    var cl = blob.read_shift(2);
    var cRel = (cl & 0x4000) >> 14, rRel = (cl & 0x8000) >> 15;
    cl &= 0x3FFF;
    if (rRel == 1) while(r > 0x7FFFF)r -= 0x100000;
    if (cRel == 1) while(cl > 0x1FFF)cl = cl - 0x4000;
    return {
        r: r,
        c: cl,
        cRel: cRel,
        rRel: rRel
    };
}
function $b8f343bf88dacc48$var$parse_RgceLocRel_BIFF2(blob /*::, length:number, opts*/ ) {
    var rl = blob.read_shift(2);
    var c = blob.read_shift(1);
    var rRel = (rl & 0x8000) >> 15, cRel = (rl & 0x4000) >> 14;
    rl &= 0x3FFF;
    if (rRel == 1 && rl >= 0x2000) rl = rl - 0x4000;
    if (cRel == 1 && c >= 0x80) c = c - 0x100;
    return {
        r: rl,
        c: c,
        cRel: cRel,
        rRel: rRel
    };
}
/* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */ function $b8f343bf88dacc48$var$parse_PtgArea(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var area = $b8f343bf88dacc48$var$parse_RgceArea(blob, opts.biff >= 2 && opts.biff <= 5 ? 6 : 8, opts);
    return [
        type,
        area
    ];
}
/* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */ function $b8f343bf88dacc48$var$parse_PtgArea3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2, 'i');
    var w = 8;
    if (opts) switch(opts.biff){
        case 5:
            blob.l += 12;
            w = 6;
            break;
        case 12:
            w = 12;
            break;
    }
    var area = $b8f343bf88dacc48$var$parse_RgceArea(blob, w, opts);
    return [
        type,
        ixti,
        area
    ];
}
/* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */ function $b8f343bf88dacc48$var$parse_PtgAreaErr(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    blob.l += opts && opts.biff > 8 ? 12 : opts.biff < 8 ? 6 : 8;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */ function $b8f343bf88dacc48$var$parse_PtgAreaErr3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2);
    var w = 8;
    if (opts) switch(opts.biff){
        case 5:
            blob.l += 12;
            w = 6;
            break;
        case 12:
            w = 12;
            break;
    }
    blob.l += w;
    return [
        type,
        ixti
    ];
}
/* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */ function $b8f343bf88dacc48$var$parse_PtgAreaN(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var area = $b8f343bf88dacc48$var$parse_RgceAreaRel(blob, length - 1, opts);
    return [
        type,
        area
    ];
}
/* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */ function $b8f343bf88dacc48$var$parse_PtgArray(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    blob.l += opts.biff == 2 ? 6 : opts.biff == 12 ? 14 : 7;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */ function $b8f343bf88dacc48$var$parse_PtgAttrBaxcel(blob) {
    var bitSemi = blob[blob.l + 1] & 0x01; /* 1 = volatile */ 
    var bitBaxcel = 1;
    blob.l += 4;
    return [
        bitSemi,
        bitBaxcel
    ];
}
/* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */ function $b8f343bf88dacc48$var$parse_PtgAttrChoose(blob, length, opts) /*:Array<number>*/ {
    blob.l += 2;
    var offset = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    var o /*:Array<number>*/  = [];
    /* offset is 1 less than the number of elements */ for(var i = 0; i <= offset; ++i)o.push(blob.read_shift(opts && opts.biff == 2 ? 1 : 2));
    return o;
}
/* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */ function $b8f343bf88dacc48$var$parse_PtgAttrGoto(blob, length, opts) {
    var bitGoto = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitGoto,
        blob.read_shift(opts && opts.biff == 2 ? 1 : 2)
    ];
}
/* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */ function $b8f343bf88dacc48$var$parse_PtgAttrIf(blob, length, opts) {
    var bitIf = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitIf,
        blob.read_shift(opts && opts.biff == 2 ? 1 : 2)
    ];
}
/* [MS-XLSB] 2.5.97.28 */ function $b8f343bf88dacc48$var$parse_PtgAttrIfError(blob) {
    var bitIf = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitIf,
        blob.read_shift(2)
    ];
}
/* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */ function $b8f343bf88dacc48$var$parse_PtgAttrSemi(blob, length, opts) {
    var bitSemi = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    return [
        bitSemi
    ];
}
/* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */ function $b8f343bf88dacc48$var$parse_PtgAttrSpaceType(blob /*::, length*/ ) {
    var type = blob.read_shift(1), cch = blob.read_shift(1);
    return [
        type,
        cch
    ];
}
/* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */ function $b8f343bf88dacc48$var$parse_PtgAttrSpace(blob) {
    blob.read_shift(2);
    return $b8f343bf88dacc48$var$parse_PtgAttrSpaceType(blob, 2);
}
/* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */ function $b8f343bf88dacc48$var$parse_PtgAttrSpaceSemi(blob) {
    blob.read_shift(2);
    return $b8f343bf88dacc48$var$parse_PtgAttrSpaceType(blob, 2);
}
/* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */ function $b8f343bf88dacc48$var$parse_PtgRef(blob, length, opts) {
    //var ptg = blob[blob.l] & 0x1F;
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var loc = $b8f343bf88dacc48$var$parse_RgceLoc(blob, 0, opts);
    return [
        type,
        loc
    ];
}
/* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */ function $b8f343bf88dacc48$var$parse_PtgRefN(blob, length, opts) {
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var loc = $b8f343bf88dacc48$var$parse_RgceLocRel(blob, 0, opts);
    return [
        type,
        loc
    ];
}
/* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */ function $b8f343bf88dacc48$var$parse_PtgRef3d(blob, length, opts) {
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var ixti = blob.read_shift(2); // XtiIndex
    if (opts && opts.biff == 5) blob.l += 12;
    var loc = $b8f343bf88dacc48$var$parse_RgceLoc(blob, 0, opts); // TODO: or RgceLocRel
    return [
        type,
        ixti,
        loc
    ];
}
/* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */ function $b8f343bf88dacc48$var$parse_PtgFunc(blob, length, opts) {
    //var ptg = blob[blob.l] & 0x1F;
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var iftab = blob.read_shift(opts && opts.biff <= 3 ? 1 : 2);
    return [
        $b8f343bf88dacc48$var$FtabArgc[iftab],
        $b8f343bf88dacc48$var$Ftab[iftab],
        type
    ];
}
/* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */ function $b8f343bf88dacc48$var$parse_PtgFuncVar(blob, length, opts) {
    var type = blob[blob.l++];
    var cparams = blob.read_shift(1), tab = opts && opts.biff <= 3 ? [
        type == 0x58 ? -1 : 0,
        blob.read_shift(1)
    ] : $b8f343bf88dacc48$var$parsetab(blob);
    return [
        cparams,
        (tab[0] === 0 ? $b8f343bf88dacc48$var$Ftab : $b8f343bf88dacc48$var$Cetab)[tab[1]]
    ];
}
function $b8f343bf88dacc48$var$parsetab(blob) {
    return [
        blob[blob.l + 1] >> 7,
        blob.read_shift(2) & 0x7FFF
    ];
}
/* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */ function $b8f343bf88dacc48$var$parse_PtgAttrSum(blob, length, opts) {
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    return;
}
/* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */ function $b8f343bf88dacc48$var$parse_PtgExp(blob, length, opts) {
    blob.l++;
    if (opts && opts.biff == 12) return [
        blob.read_shift(4, 'i'),
        0
    ];
    var row = blob.read_shift(2);
    var col = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        row,
        col
    ];
}
/* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */ function $b8f343bf88dacc48$var$parse_PtgErr(blob) {
    blob.l++;
    return $b8f343bf88dacc48$var$BErr[blob.read_shift(1)];
}
/* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */ function $b8f343bf88dacc48$var$parse_PtgInt(blob) {
    blob.l++;
    return blob.read_shift(2);
}
/* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */ function $b8f343bf88dacc48$var$parse_PtgBool(blob) {
    blob.l++;
    return blob.read_shift(1) !== 0;
}
/* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */ function $b8f343bf88dacc48$var$parse_PtgNum(blob) {
    blob.l++;
    return $b8f343bf88dacc48$var$parse_Xnum(blob, 8);
}
/* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */ function $b8f343bf88dacc48$var$parse_PtgStr(blob, length, opts) {
    blob.l++;
    return $b8f343bf88dacc48$var$parse_ShortXLUnicodeString(blob, length - 1, opts);
}
/* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */ /* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */ function $b8f343bf88dacc48$var$parse_SerAr(blob, biff /*:number*/ ) {
    var val = [
        blob.read_shift(1)
    ];
    if (biff == 12) switch(val[0]){
        case 0x02:
            val[0] = 0x04;
            break; /* SerBool */ 
        case 0x04:
            val[0] = 0x10;
            break; /* SerErr */ 
        case 0x00:
            val[0] = 0x01;
            break; /* SerNum */ 
        case 0x01:
            val[0] = 0x02;
            break; /* SerStr */ 
    }
    switch(val[0]){
        case 0x04:
            /* SerBool -- boolean */ val[1] = $b8f343bf88dacc48$var$parsebool(blob, 1) ? 'TRUE' : 'FALSE';
            if (biff != 12) blob.l += 7;
            break;
        case 0x25:
        /* appears to be an alias */ case 0x10:
            /* SerErr -- error */ val[1] = $b8f343bf88dacc48$var$BErr[blob[blob.l]];
            blob.l += biff == 12 ? 4 : 8;
            break;
        case 0x00:
            /* SerNil -- honestly, I'm not sure how to reproduce this */ blob.l += 8;
            break;
        case 0x01:
            /* SerNum -- Xnum */ val[1] = $b8f343bf88dacc48$var$parse_Xnum(blob, 8);
            break;
        case 0x02:
            /* SerStr -- XLUnicodeString (<256 chars) */ val[1] = $b8f343bf88dacc48$var$parse_XLUnicodeString2(blob, 0, {
                biff: biff > 0 && biff < 8 ? 2 : biff
            });
            break;
        default:
            throw new Error("Bad SerAr: " + val[0]); /* Unreachable */ 
    }
    return val;
}
/* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */ function $b8f343bf88dacc48$var$parse_PtgExtraMem(blob, cce, opts) {
    var count = blob.read_shift(opts.biff == 12 ? 4 : 2);
    var out /*:Array<Range>*/  = [];
    for(var i = 0; i != count; ++i)out.push((opts.biff == 12 ? $b8f343bf88dacc48$var$parse_UncheckedRfX : $b8f343bf88dacc48$var$parse_Ref8U)(blob, 8));
    return out;
}
/* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */ function $b8f343bf88dacc48$var$parse_PtgExtraArray(blob, length, opts) {
    var rows = 0, cols = 0;
    if (opts.biff == 12) {
        rows = blob.read_shift(4); // DRw
        cols = blob.read_shift(4); // DCol
    } else {
        cols = 1 + blob.read_shift(1); //DColByteU
        rows = 1 + blob.read_shift(2); //DRw
    }
    if (opts.biff >= 2 && opts.biff < 8) {
        --rows;
        if (--cols == 0) cols = 0x100;
    }
    // $FlowIgnore
    for(var i = 0, o /*:Array<Array<any>>*/  = []; i != rows && (o[i] = []); ++i)for(var j = 0; j != cols; ++j)o[i][j] = $b8f343bf88dacc48$var$parse_SerAr(blob, opts.biff);
    return o;
}
/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */ function $b8f343bf88dacc48$var$parse_PtgName(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var w = !opts || opts.biff >= 8 ? 4 : 2;
    var nameindex = blob.read_shift(w);
    switch(opts.biff){
        case 2:
            blob.l += 5;
            break;
        case 3:
        case 4:
            blob.l += 8;
            break;
        case 5:
            blob.l += 12;
            break;
    }
    return [
        type,
        0,
        nameindex
    ];
}
/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */ function $b8f343bf88dacc48$var$parse_PtgNameX(blob, length, opts) {
    if (opts.biff == 5) return $b8f343bf88dacc48$var$parse_PtgNameX_BIFF5(blob, length, opts);
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var ixti = blob.read_shift(2); // XtiIndex
    var nameindex = blob.read_shift(4);
    return [
        type,
        ixti,
        nameindex
    ];
}
function $b8f343bf88dacc48$var$parse_PtgNameX_BIFF5(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var ixti = blob.read_shift(2, 'i'); // XtiIndex
    blob.l += 8;
    var nameindex = blob.read_shift(2);
    blob.l += 12;
    return [
        type,
        ixti,
        nameindex
    ];
}
/* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */ function $b8f343bf88dacc48$var$parse_PtgMemArea(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        type,
        cce
    ];
}
/* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */ function $b8f343bf88dacc48$var$parse_PtgMemFunc(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        type,
        cce
    ];
}
/* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */ function $b8f343bf88dacc48$var$parse_PtgRefErr(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    blob.l += 4;
    if (opts.biff < 8) blob.l--;
    if (opts.biff == 12) blob.l += 2;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */ function $b8f343bf88dacc48$var$parse_PtgRefErr3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2);
    var w = 4;
    if (opts) switch(opts.biff){
        case 5:
            w = 15;
            break;
        case 12:
            w = 6;
            break;
    }
    blob.l += w;
    return [
        type,
        ixti
    ];
}
/* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */ var $b8f343bf88dacc48$var$parse_PtgMemErr = $b8f343bf88dacc48$var$parsenoop;
/* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */ var $b8f343bf88dacc48$var$parse_PtgMemNoMem = $b8f343bf88dacc48$var$parsenoop;
/* [MS-XLS] 2.5.198.92 */ var $b8f343bf88dacc48$var$parse_PtgTbl = $b8f343bf88dacc48$var$parsenoop;
function $b8f343bf88dacc48$var$parse_PtgElfLoc(blob, length, opts) {
    blob.l += 2;
    return [
        $b8f343bf88dacc48$var$parse_RgceElfLoc(blob, 4, opts)
    ];
}
function $b8f343bf88dacc48$var$parse_PtgElfNoop(blob /*::, length, opts*/ ) {
    blob.l += 6;
    return [];
}
/* [MS-XLS] 2.5.198.46 */ var $b8f343bf88dacc48$var$parse_PtgElfCol = $b8f343bf88dacc48$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.47 */ var $b8f343bf88dacc48$var$parse_PtgElfColS = $b8f343bf88dacc48$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.48 */ var $b8f343bf88dacc48$var$parse_PtgElfColSV = $b8f343bf88dacc48$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.49 */ var $b8f343bf88dacc48$var$parse_PtgElfColV = $b8f343bf88dacc48$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.50 */ function $b8f343bf88dacc48$var$parse_PtgElfLel(blob /*::, length, opts*/ ) {
    blob.l += 2;
    return [
        $b8f343bf88dacc48$var$parseuint16(blob),
        blob.read_shift(2) & 0x01
    ];
}
/* [MS-XLS] 2.5.198.51 */ var $b8f343bf88dacc48$var$parse_PtgElfRadical = $b8f343bf88dacc48$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.52 */ var $b8f343bf88dacc48$var$parse_PtgElfRadicalLel = $b8f343bf88dacc48$var$parse_PtgElfLel;
/* [MS-XLS] 2.5.198.53 */ var $b8f343bf88dacc48$var$parse_PtgElfRadicalS = $b8f343bf88dacc48$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.54 */ var $b8f343bf88dacc48$var$parse_PtgElfRw = $b8f343bf88dacc48$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.55 */ var $b8f343bf88dacc48$var$parse_PtgElfRwV = $b8f343bf88dacc48$var$parse_PtgElfLoc;
/* [MS-XLSB] 2.5.97.52 TODO */ var $b8f343bf88dacc48$var$PtgListRT = [
    "Data",
    "All",
    "Headers",
    "??",
    "?Data2",
    "??",
    "?DataHeaders",
    "??",
    "Totals",
    "??",
    "??",
    "??",
    "?DataTotals",
    "??",
    "??",
    "??",
    "?Current"
];
function $b8f343bf88dacc48$var$parse_PtgList(blob /*::, length, opts*/ ) {
    blob.l += 2;
    var ixti = blob.read_shift(2);
    var flags = blob.read_shift(2);
    var idx = blob.read_shift(4);
    var c = blob.read_shift(2);
    var C = blob.read_shift(2);
    var rt = $b8f343bf88dacc48$var$PtgListRT[flags >> 2 & 0x1F];
    return {
        ixti: ixti,
        coltype: flags & 0x3,
        rt: rt,
        idx: idx,
        c: c,
        C: C
    };
}
/* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */ function $b8f343bf88dacc48$var$parse_PtgSxName(blob /*::, length, opts*/ ) {
    blob.l += 2;
    return [
        blob.read_shift(4)
    ];
}
/* [XLS] old spec */ function $b8f343bf88dacc48$var$parse_PtgSheet(blob, length, opts) {
    blob.l += 5;
    blob.l += 2;
    blob.l += opts.biff == 2 ? 1 : 4;
    return [
        "PTGSHEET"
    ];
}
function $b8f343bf88dacc48$var$parse_PtgEndSheet(blob, length, opts) {
    blob.l += opts.biff == 2 ? 4 : 5;
    return [
        "PTGENDSHEET"
    ];
}
function $b8f343bf88dacc48$var$parse_PtgMemAreaN(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(2);
    return [
        type,
        cce
    ];
}
function $b8f343bf88dacc48$var$parse_PtgMemNoMemN(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(2);
    return [
        type,
        cce
    ];
}
function $b8f343bf88dacc48$var$parse_PtgAttrNoop(blob /*::, length, opts*/ ) {
    blob.l += 4;
    return [
        0,
        0
    ];
}
/* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */ var $b8f343bf88dacc48$var$PtgTypes = {
    0x01: {
        n: 'PtgExp',
        f: $b8f343bf88dacc48$var$parse_PtgExp
    },
    0x02: {
        n: 'PtgTbl',
        f: $b8f343bf88dacc48$var$parse_PtgTbl
    },
    0x03: {
        n: 'PtgAdd',
        f: $b8f343bf88dacc48$var$parseread1
    },
    0x04: {
        n: 'PtgSub',
        f: $b8f343bf88dacc48$var$parseread1
    },
    0x05: {
        n: 'PtgMul',
        f: $b8f343bf88dacc48$var$parseread1
    },
    0x06: {
        n: 'PtgDiv',
        f: $b8f343bf88dacc48$var$parseread1
    },
    0x07: {
        n: 'PtgPower',
        f: $b8f343bf88dacc48$var$parseread1
    },
    0x08: {
        n: 'PtgConcat',
        f: $b8f343bf88dacc48$var$parseread1
    },
    0x09: {
        n: 'PtgLt',
        f: $b8f343bf88dacc48$var$parseread1
    },
    0x0A: {
        n: 'PtgLe',
        f: $b8f343bf88dacc48$var$parseread1
    },
    0x0B: {
        n: 'PtgEq',
        f: $b8f343bf88dacc48$var$parseread1
    },
    0x0C: {
        n: 'PtgGe',
        f: $b8f343bf88dacc48$var$parseread1
    },
    0x0D: {
        n: 'PtgGt',
        f: $b8f343bf88dacc48$var$parseread1
    },
    0x0E: {
        n: 'PtgNe',
        f: $b8f343bf88dacc48$var$parseread1
    },
    0x0F: {
        n: 'PtgIsect',
        f: $b8f343bf88dacc48$var$parseread1
    },
    0x10: {
        n: 'PtgUnion',
        f: $b8f343bf88dacc48$var$parseread1
    },
    0x11: {
        n: 'PtgRange',
        f: $b8f343bf88dacc48$var$parseread1
    },
    0x12: {
        n: 'PtgUplus',
        f: $b8f343bf88dacc48$var$parseread1
    },
    0x13: {
        n: 'PtgUminus',
        f: $b8f343bf88dacc48$var$parseread1
    },
    0x14: {
        n: 'PtgPercent',
        f: $b8f343bf88dacc48$var$parseread1
    },
    0x15: {
        n: 'PtgParen',
        f: $b8f343bf88dacc48$var$parseread1
    },
    0x16: {
        n: 'PtgMissArg',
        f: $b8f343bf88dacc48$var$parseread1
    },
    0x17: {
        n: 'PtgStr',
        f: $b8f343bf88dacc48$var$parse_PtgStr
    },
    0x1A: {
        n: 'PtgSheet',
        f: $b8f343bf88dacc48$var$parse_PtgSheet
    },
    0x1B: {
        n: 'PtgEndSheet',
        f: $b8f343bf88dacc48$var$parse_PtgEndSheet
    },
    0x1C: {
        n: 'PtgErr',
        f: $b8f343bf88dacc48$var$parse_PtgErr
    },
    0x1D: {
        n: 'PtgBool',
        f: $b8f343bf88dacc48$var$parse_PtgBool
    },
    0x1E: {
        n: 'PtgInt',
        f: $b8f343bf88dacc48$var$parse_PtgInt
    },
    0x1F: {
        n: 'PtgNum',
        f: $b8f343bf88dacc48$var$parse_PtgNum
    },
    0x20: {
        n: 'PtgArray',
        f: $b8f343bf88dacc48$var$parse_PtgArray
    },
    0x21: {
        n: 'PtgFunc',
        f: $b8f343bf88dacc48$var$parse_PtgFunc
    },
    0x22: {
        n: 'PtgFuncVar',
        f: $b8f343bf88dacc48$var$parse_PtgFuncVar
    },
    0x23: {
        n: 'PtgName',
        f: $b8f343bf88dacc48$var$parse_PtgName
    },
    0x24: {
        n: 'PtgRef',
        f: $b8f343bf88dacc48$var$parse_PtgRef
    },
    0x25: {
        n: 'PtgArea',
        f: $b8f343bf88dacc48$var$parse_PtgArea
    },
    0x26: {
        n: 'PtgMemArea',
        f: $b8f343bf88dacc48$var$parse_PtgMemArea
    },
    0x27: {
        n: 'PtgMemErr',
        f: $b8f343bf88dacc48$var$parse_PtgMemErr
    },
    0x28: {
        n: 'PtgMemNoMem',
        f: $b8f343bf88dacc48$var$parse_PtgMemNoMem
    },
    0x29: {
        n: 'PtgMemFunc',
        f: $b8f343bf88dacc48$var$parse_PtgMemFunc
    },
    0x2A: {
        n: 'PtgRefErr',
        f: $b8f343bf88dacc48$var$parse_PtgRefErr
    },
    0x2B: {
        n: 'PtgAreaErr',
        f: $b8f343bf88dacc48$var$parse_PtgAreaErr
    },
    0x2C: {
        n: 'PtgRefN',
        f: $b8f343bf88dacc48$var$parse_PtgRefN
    },
    0x2D: {
        n: 'PtgAreaN',
        f: $b8f343bf88dacc48$var$parse_PtgAreaN
    },
    0x2E: {
        n: 'PtgMemAreaN',
        f: $b8f343bf88dacc48$var$parse_PtgMemAreaN
    },
    0x2F: {
        n: 'PtgMemNoMemN',
        f: $b8f343bf88dacc48$var$parse_PtgMemNoMemN
    },
    0x39: {
        n: 'PtgNameX',
        f: $b8f343bf88dacc48$var$parse_PtgNameX
    },
    0x3A: {
        n: 'PtgRef3d',
        f: $b8f343bf88dacc48$var$parse_PtgRef3d
    },
    0x3B: {
        n: 'PtgArea3d',
        f: $b8f343bf88dacc48$var$parse_PtgArea3d
    },
    0x3C: {
        n: 'PtgRefErr3d',
        f: $b8f343bf88dacc48$var$parse_PtgRefErr3d
    },
    0x3D: {
        n: 'PtgAreaErr3d',
        f: $b8f343bf88dacc48$var$parse_PtgAreaErr3d
    },
    0xFF: {}
};
/* These are duplicated in the PtgTypes table */ var $b8f343bf88dacc48$var$PtgDupes = {
    0x40: 0x20,
    0x60: 0x20,
    0x41: 0x21,
    0x61: 0x21,
    0x42: 0x22,
    0x62: 0x22,
    0x43: 0x23,
    0x63: 0x23,
    0x44: 0x24,
    0x64: 0x24,
    0x45: 0x25,
    0x65: 0x25,
    0x46: 0x26,
    0x66: 0x26,
    0x47: 0x27,
    0x67: 0x27,
    0x48: 0x28,
    0x68: 0x28,
    0x49: 0x29,
    0x69: 0x29,
    0x4A: 0x2A,
    0x6A: 0x2A,
    0x4B: 0x2B,
    0x6B: 0x2B,
    0x4C: 0x2C,
    0x6C: 0x2C,
    0x4D: 0x2D,
    0x6D: 0x2D,
    0x4E: 0x2E,
    0x6E: 0x2E,
    0x4F: 0x2F,
    0x6F: 0x2F,
    0x58: 0x22,
    0x78: 0x22,
    0x59: 0x39,
    0x79: 0x39,
    0x5A: 0x3A,
    0x7A: 0x3A,
    0x5B: 0x3B,
    0x7B: 0x3B,
    0x5C: 0x3C,
    0x7C: 0x3C,
    0x5D: 0x3D,
    0x7D: 0x3D
};
var $b8f343bf88dacc48$var$Ptg18 = {
    0x01: {
        n: 'PtgElfLel',
        f: $b8f343bf88dacc48$var$parse_PtgElfLel
    },
    0x02: {
        n: 'PtgElfRw',
        f: $b8f343bf88dacc48$var$parse_PtgElfRw
    },
    0x03: {
        n: 'PtgElfCol',
        f: $b8f343bf88dacc48$var$parse_PtgElfCol
    },
    0x06: {
        n: 'PtgElfRwV',
        f: $b8f343bf88dacc48$var$parse_PtgElfRwV
    },
    0x07: {
        n: 'PtgElfColV',
        f: $b8f343bf88dacc48$var$parse_PtgElfColV
    },
    0x0A: {
        n: 'PtgElfRadical',
        f: $b8f343bf88dacc48$var$parse_PtgElfRadical
    },
    0x0B: {
        n: 'PtgElfRadicalS',
        f: $b8f343bf88dacc48$var$parse_PtgElfRadicalS
    },
    0x0D: {
        n: 'PtgElfColS',
        f: $b8f343bf88dacc48$var$parse_PtgElfColS
    },
    0x0F: {
        n: 'PtgElfColSV',
        f: $b8f343bf88dacc48$var$parse_PtgElfColSV
    },
    0x10: {
        n: 'PtgElfRadicalLel',
        f: $b8f343bf88dacc48$var$parse_PtgElfRadicalLel
    },
    0x19: {
        n: 'PtgList',
        f: $b8f343bf88dacc48$var$parse_PtgList
    },
    0x1D: {
        n: 'PtgSxName',
        f: $b8f343bf88dacc48$var$parse_PtgSxName
    },
    0xFF: {}
};
var $b8f343bf88dacc48$var$Ptg19 = {
    0x00: {
        n: 'PtgAttrNoop',
        f: $b8f343bf88dacc48$var$parse_PtgAttrNoop
    },
    0x01: {
        n: 'PtgAttrSemi',
        f: $b8f343bf88dacc48$var$parse_PtgAttrSemi
    },
    0x02: {
        n: 'PtgAttrIf',
        f: $b8f343bf88dacc48$var$parse_PtgAttrIf
    },
    0x04: {
        n: 'PtgAttrChoose',
        f: $b8f343bf88dacc48$var$parse_PtgAttrChoose
    },
    0x08: {
        n: 'PtgAttrGoto',
        f: $b8f343bf88dacc48$var$parse_PtgAttrGoto
    },
    0x10: {
        n: 'PtgAttrSum',
        f: $b8f343bf88dacc48$var$parse_PtgAttrSum
    },
    0x20: {
        n: 'PtgAttrBaxcel',
        f: $b8f343bf88dacc48$var$parse_PtgAttrBaxcel
    },
    0x21: {
        n: 'PtgAttrBaxcel',
        f: $b8f343bf88dacc48$var$parse_PtgAttrBaxcel
    },
    0x40: {
        n: 'PtgAttrSpace',
        f: $b8f343bf88dacc48$var$parse_PtgAttrSpace
    },
    0x41: {
        n: 'PtgAttrSpaceSemi',
        f: $b8f343bf88dacc48$var$parse_PtgAttrSpaceSemi
    },
    0x80: {
        n: 'PtgAttrIfError',
        f: $b8f343bf88dacc48$var$parse_PtgAttrIfError
    },
    0xFF: {}
};
/* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */ function $b8f343bf88dacc48$var$parse_RgbExtra(blob, length, rgce, opts) {
    if (opts.biff < 8) return $b8f343bf88dacc48$var$parsenoop(blob, length);
    var target = blob.l + length;
    var o = [];
    for(var i = 0; i !== rgce.length; ++i)switch(rgce[i][0]){
        case 'PtgArray':
            /* PtgArray -> PtgExtraArray */ rgce[i][1] = $b8f343bf88dacc48$var$parse_PtgExtraArray(blob, 0, opts);
            o.push(rgce[i][1]);
            break;
        case 'PtgMemArea':
            /* PtgMemArea -> PtgExtraMem */ rgce[i][2] = $b8f343bf88dacc48$var$parse_PtgExtraMem(blob, rgce[i][1], opts);
            o.push(rgce[i][2]);
            break;
        case 'PtgExp':
            /* PtgExp -> PtgExtraCol */ if (opts && opts.biff == 12) {
                rgce[i][1][1] = blob.read_shift(4);
                o.push(rgce[i][1]);
            }
            break;
        case 'PtgList':
        /* TODO: PtgList -> PtgExtraList */ case 'PtgElfRadicalS':
        /* TODO: PtgElfRadicalS -> PtgExtraElf */ case 'PtgElfColS':
        /* TODO: PtgElfColS -> PtgExtraElf */ case 'PtgElfColSV':
            /* TODO: PtgElfColSV -> PtgExtraElf */ throw "Unsupported " + rgce[i][0];
        default:
            break;
    }
    length = target - blob.l;
    /* note: this is technically an error but Excel disregards */ //if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
    if (length !== 0) o.push($b8f343bf88dacc48$var$parsenoop(blob, length));
    return o;
}
/* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */ function $b8f343bf88dacc48$var$parse_Rgce(blob, length, opts) {
    var target = blob.l + length;
    var R, id, ptgs = [];
    while(target != blob.l){
        length = target - blob.l;
        id = blob[blob.l];
        R = $b8f343bf88dacc48$var$PtgTypes[id] || $b8f343bf88dacc48$var$PtgTypes[$b8f343bf88dacc48$var$PtgDupes[id]];
        if (id === 0x18 || id === 0x19) R = (id === 0x18 ? $b8f343bf88dacc48$var$Ptg18 : $b8f343bf88dacc48$var$Ptg19)[blob[blob.l + 1]];
        if (!R || !R.f) $b8f343bf88dacc48$var$parsenoop(blob, length);
        else ptgs.push([
            R.n,
            R.f(blob, length, opts)
        ]);
    }
    return ptgs;
}
function $b8f343bf88dacc48$var$stringify_array(f /*:Array<Array<string>>*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < f.length; ++i){
        var x = f[i], r /*:Array<string>*/  = [];
        for(var j = 0; j < x.length; ++j){
            var y = x[j];
            if (y) switch(y[0]){
                // TODO: handle embedded quotes
                case 0x02:
                    /*:: if(typeof y[1] != 'string') throw "unreachable"; */ r.push('"' + y[1].replace(/"/g, '""') + '"');
                    break;
                default:
                    r.push(y[1]);
            }
            else r.push("");
        }
        o.push(r.join(","));
    }
    return o.join(";");
}
/* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */ var $b8f343bf88dacc48$var$PtgBinOp = {
    PtgAdd: "+",
    PtgConcat: "&",
    PtgDiv: "/",
    PtgEq: "=",
    PtgGe: ">=",
    PtgGt: ">",
    PtgLe: "<=",
    PtgLt: "<",
    PtgMul: "*",
    PtgNe: "<>",
    PtgPower: "^",
    PtgSub: "-"
};
// TODO: explore space
function $b8f343bf88dacc48$var$make_3d_range(start, end) {
    var s = start.lastIndexOf("!"), e = end.lastIndexOf("!");
    if (s == -1 && e == -1) return start + ":" + end;
    if (s > 0 && e > 0 && start.slice(0, s).toLowerCase() == end.slice(0, e).toLowerCase()) return start + ":" + end.slice(e + 1);
    console.error("Cannot hydrate range", start, end);
    return start + ":" + end;
}
function $b8f343bf88dacc48$var$get_ixti_raw(supbooks, ixti /*:number*/ , opts) /*:string*/ {
    if (!supbooks) return "SH33TJSERR0";
    if (opts.biff > 8 && (!supbooks.XTI || !supbooks.XTI[ixti])) return supbooks.SheetNames[ixti];
    if (!supbooks.XTI) return "SH33TJSERR6";
    var XTI = supbooks.XTI[ixti];
    if (opts.biff < 8) {
        if (ixti > 10000) ixti -= 65536;
        if (ixti < 0) ixti = -ixti;
        return ixti == 0 ? "" : supbooks.XTI[ixti - 1];
    }
    if (!XTI) return "SH33TJSERR1";
    var o = "";
    if (opts.biff > 8) switch(supbooks[XTI[0]][0]){
        case 0x0165:
            /* 'BrtSupSelf' */ o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]];
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
        case 0x0166:
            /* 'BrtSupSame' */ if (opts.SID != null) return supbooks.SheetNames[opts.SID];
            return "SH33TJSSAME" + supbooks[XTI[0]][0];
        case 0x0163:
        /* 'BrtSupBookSrc' */ /* falls through */ default:
            return "SH33TJSSRC" + supbooks[XTI[0]][0];
    }
    switch(supbooks[XTI[0]][0][0]){
        case 0x0401:
            o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]] || "SH33TJSERR3";
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
        case 0x3A01:
            return supbooks[XTI[0]].slice(1).map(function(name) {
                return name.Name;
            }).join(";;"); //return "SH33TJSERR8";
        default:
            if (!supbooks[XTI[0]][0][3]) return "SH33TJSERR2";
            o = XTI[1] == -1 ? "#REF" : supbooks[XTI[0]][0][3][XTI[1]] || "SH33TJSERR4";
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks[XTI[0]][0][3][XTI[2]];
    }
}
function $b8f343bf88dacc48$var$get_ixti(supbooks, ixti /*:number*/ , opts) /*:string*/ {
    var ixtiraw = $b8f343bf88dacc48$var$get_ixti_raw(supbooks, ixti, opts);
    return ixtiraw == "#REF" ? ixtiraw : $b8f343bf88dacc48$var$formula_quote_sheet_name(ixtiraw, opts);
}
function $b8f343bf88dacc48$var$stringify_formula(formula /*Array<any>*/ , range, cell /*:any*/ , supbooks, opts) /*:string*/ {
    var biff = opts && opts.biff || 8;
    var _range = /*range != null ? range :*/ {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: 0
        }
    };
    var stack /*:Array<string>*/  = [], e1, e2, /*::type,*/ c /*:CellAddress*/ , ixti = 0, nameidx = 0, r, sname = "";
    if (!formula[0] || !formula[0][0]) return "";
    var last_sp = -1, sp = "";
    for(var ff = 0, fflen = formula[0].length; ff < fflen; ++ff){
        var f = formula[0][ff];
        switch(f[0]){
            case 'PtgUminus':
                /* [MS-XLS] 2.5.198.93 */ stack.push("-" + stack.pop());
                break;
            case 'PtgUplus':
                /* [MS-XLS] 2.5.198.95 */ stack.push("+" + stack.pop());
                break;
            case 'PtgPercent':
                /* [MS-XLS] 2.5.198.81 */ stack.push(stack.pop() + "%");
                break;
            case 'PtgAdd':
            /* [MS-XLS] 2.5.198.26 */ case 'PtgConcat':
            /* [MS-XLS] 2.5.198.43 */ case 'PtgDiv':
            /* [MS-XLS] 2.5.198.45 */ case 'PtgEq':
            /* [MS-XLS] 2.5.198.56 */ case 'PtgGe':
            /* [MS-XLS] 2.5.198.64 */ case 'PtgGt':
            /* [MS-XLS] 2.5.198.65 */ case 'PtgLe':
            /* [MS-XLS] 2.5.198.68 */ case 'PtgLt':
            /* [MS-XLS] 2.5.198.69 */ case 'PtgMul':
            /* [MS-XLS] 2.5.198.75 */ case 'PtgNe':
            /* [MS-XLS] 2.5.198.78 */ case 'PtgPower':
            /* [MS-XLS] 2.5.198.82 */ case 'PtgSub':
                /* [MS-XLS] 2.5.198.90 */ e1 = stack.pop();
                e2 = stack.pop();
                if (last_sp >= 0) {
                    switch(formula[0][last_sp][1][0]){
                        case 0:
                            // $FlowIgnore
                            sp = $b8f343bf88dacc48$var$fill(" ", formula[0][last_sp][1][1]);
                            break;
                        case 1:
                            // $FlowIgnore
                            sp = $b8f343bf88dacc48$var$fill("\r", formula[0][last_sp][1][1]);
                            break;
                        default:
                            sp = "";
                            // $FlowIgnore
                            if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
                    }
                    e2 = e2 + sp;
                    last_sp = -1;
                }
                stack.push(e2 + $b8f343bf88dacc48$var$PtgBinOp[f[0]] + e1);
                break;
            case 'PtgIsect':
                /* [MS-XLS] 2.5.198.67 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + " " + e1);
                break;
            case 'PtgUnion':
                /* [MS-XLS] 2.5.198.94 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + "," + e1);
                break;
            case 'PtgRange':
                /* [MS-XLS] 2.5.198.83 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push($b8f343bf88dacc48$var$make_3d_range(e2, e1));
                break;
            case 'PtgAttrChoose':
                break;
            case 'PtgAttrGoto':
                break;
            case 'PtgAttrIf':
                break;
            case 'PtgAttrIfError':
                break;
            case 'PtgRef':
                /* [MS-XLS] 2.5.198.84 */ /*::type = f[1][0]; */ c = $b8f343bf88dacc48$var$shift_cell_xls(f[1][1], _range, opts);
                stack.push($b8f343bf88dacc48$var$encode_cell_xls(c, biff));
                break;
            case 'PtgRefN':
                /* [MS-XLS] 2.5.198.88 */ /*::type = f[1][0]; */ c = cell ? $b8f343bf88dacc48$var$shift_cell_xls(f[1][1], cell, opts) : f[1][1];
                stack.push($b8f343bf88dacc48$var$encode_cell_xls(c, biff));
                break;
            case 'PtgRef3d':
                /* [MS-XLS] 2.5.198.85 */ /*::type = f[1][0]; */ ixti = /*::Number(*/ f[1][1] /*::)*/ ;
                c = $b8f343bf88dacc48$var$shift_cell_xls(f[1][2], _range, opts);
                sname = $b8f343bf88dacc48$var$get_ixti(supbooks, ixti, opts);
                var w = sname; /* IE9 fails on defined names */  // eslint-disable-line no-unused-vars
                stack.push(sname + "!" + $b8f343bf88dacc48$var$encode_cell_xls(c, biff));
                break;
            case 'PtgFunc':
            /* [MS-XLS] 2.5.198.62 */ case 'PtgFuncVar':
                /* [MS-XLS] 2.5.198.63 */ /* f[1] = [argc, func, type] */ var argc /*:number*/  = f[1][0], func /*:string*/  = f[1][1];
                if (!argc) argc = 0;
                argc &= 0x7F;
                var args = argc == 0 ? [] : stack.slice(-argc);
                stack.length -= argc;
                if (func === 'User') func = args.shift();
                stack.push(func + "(" + args.join(",") + ")");
                break;
            case 'PtgBool':
                /* [MS-XLS] 2.5.198.42 */ stack.push(f[1] ? "TRUE" : "FALSE");
                break;
            case 'PtgInt':
                /* [MS-XLS] 2.5.198.66 */ stack.push(/*::String(*/ f[1]);
                break;
            case 'PtgNum':
                /* [MS-XLS] 2.5.198.79 TODO: precision? */ stack.push(String(f[1]));
                break;
            case 'PtgStr':
                /* [MS-XLS] 2.5.198.89 */ // $FlowIgnore
                stack.push('"' + f[1].replace(/"/g, '""') + '"');
                break;
            case 'PtgErr':
                /* [MS-XLS] 2.5.198.57 */ stack.push(/*::String(*/ f[1]);
                break;
            case 'PtgAreaN':
                /* [MS-XLS] 2.5.198.31 TODO */ /*::type = f[1][0]; */ r = $b8f343bf88dacc48$var$shift_range_xls(f[1][1], cell ? {
                    s: cell
                } : _range, opts);
                stack.push($b8f343bf88dacc48$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case 'PtgArea':
                /* [MS-XLS] 2.5.198.27 TODO: fixed points */ /*::type = f[1][0]; */ r = $b8f343bf88dacc48$var$shift_range_xls(f[1][1], _range, opts);
                stack.push($b8f343bf88dacc48$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case 'PtgArea3d':
                /* [MS-XLS] 2.5.198.28 TODO */ /*::type = f[1][0]; */ ixti = /*::Number(*/ f[1][1] /*::)*/ ;
                r = f[1][2];
                sname = $b8f343bf88dacc48$var$get_ixti(supbooks, ixti, opts);
                stack.push(sname + "!" + $b8f343bf88dacc48$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case 'PtgAttrSum':
                /* [MS-XLS] 2.5.198.41 */ stack.push("SUM(" + stack.pop() + ")");
                break;
            case 'PtgAttrBaxcel':
            /* [MS-XLS] 2.5.198.33 */ case 'PtgAttrSemi':
                break;
            case 'PtgName':
                /* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions */ /* f[1] = type, 0, nameindex */ nameidx = f[1][2];
                var lbl = (supbooks.names || [])[nameidx - 1] || (supbooks[0] || [])[nameidx];
                var name = lbl ? lbl.Name : "SH33TJSNAME" + String(nameidx);
                /* [MS-XLSB] 2.5.97.10 Ftab -- last verified 20220204 */ if (name && name.slice(0, 6) == "_xlfn." && !opts.xlfn) name = name.slice(6);
                stack.push(name);
                break;
            case 'PtgNameX':
                /* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions */ /* f[1] = type, ixti, nameindex */ var bookidx /*:number*/  = f[1][1];
                nameidx = f[1][2];
                var externbook;
                /* TODO: Properly handle missing values -- this should be using get_ixti_raw primarily */ if (opts.biff <= 5) {
                    if (bookidx < 0) bookidx = -bookidx;
                    if (supbooks[bookidx]) externbook = supbooks[bookidx][nameidx];
                } else {
                    var o = "";
                    if (((supbooks[bookidx] || [])[0] || [])[0] == 0x3A01) ;
                    else if (((supbooks[bookidx] || [])[0] || [])[0] == 0x0401) {
                        if (supbooks[bookidx][nameidx] && supbooks[bookidx][nameidx].itab > 0) o = supbooks.SheetNames[supbooks[bookidx][nameidx].itab - 1] + "!";
                    } else o = supbooks.SheetNames[nameidx - 1] + "!";
                    if (supbooks[bookidx] && supbooks[bookidx][nameidx]) o += supbooks[bookidx][nameidx].Name;
                    else if (supbooks[0] && supbooks[0][nameidx]) o += supbooks[0][nameidx].Name;
                    else {
                        var ixtidata = ($b8f343bf88dacc48$var$get_ixti_raw(supbooks, bookidx, opts) || "").split(";;");
                        if (ixtidata[nameidx - 1]) o = ixtidata[nameidx - 1]; // TODO: confirm this is correct
                        else o += "SH33TJSERRX";
                    }
                    stack.push(o);
                    break;
                }
                if (!externbook) externbook = {
                    Name: "SH33TJSERRY"
                };
                stack.push(externbook.Name);
                break;
            case 'PtgParen':
                /* [MS-XLS] 2.5.198.80 */ var lp = '(', rp = ')';
                if (last_sp >= 0) {
                    sp = "";
                    switch(formula[0][last_sp][1][0]){
                        // $FlowIgnore
                        case 2:
                            lp = $b8f343bf88dacc48$var$fill(" ", formula[0][last_sp][1][1]) + lp;
                            break;
                        // $FlowIgnore
                        case 3:
                            lp = $b8f343bf88dacc48$var$fill("\r", formula[0][last_sp][1][1]) + lp;
                            break;
                        // $FlowIgnore
                        case 4:
                            rp = $b8f343bf88dacc48$var$fill(" ", formula[0][last_sp][1][1]) + rp;
                            break;
                        // $FlowIgnore
                        case 5:
                            rp = $b8f343bf88dacc48$var$fill("\r", formula[0][last_sp][1][1]) + rp;
                            break;
                        default:
                            // $FlowIgnore
                            if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
                    }
                    last_sp = -1;
                }
                stack.push(lp + stack.pop() + rp);
                break;
            case 'PtgRefErr':
                /* [MS-XLS] 2.5.198.86 */ stack.push('#REF!');
                break;
            case 'PtgRefErr3d':
                /* [MS-XLS] 2.5.198.87 */ stack.push('#REF!');
                break;
            case 'PtgExp':
                /* [MS-XLS] 2.5.198.58 TODO */ c = {
                    c: f[1][1],
                    r: f[1][0]
                };
                var q = {
                    c: cell.c,
                    r: cell.r
                } /*:any*/ ;
                if (supbooks.sharedf[$b8f343bf88dacc48$var$encode_cell(c)]) {
                    var parsedf = supbooks.sharedf[$b8f343bf88dacc48$var$encode_cell(c)];
                    stack.push($b8f343bf88dacc48$var$stringify_formula(parsedf, _range, q, supbooks, opts));
                } else {
                    var fnd = false;
                    for(e1 = 0; e1 != supbooks.arrayf.length; ++e1){
                        /* TODO: should be something like range_has */ e2 = supbooks.arrayf[e1];
                        if (c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
                        if (c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
                        stack.push($b8f343bf88dacc48$var$stringify_formula(e2[1], _range, q, supbooks, opts));
                        fnd = true;
                        break;
                    }
                    if (!fnd) stack.push(/*::String(*/ f[1]);
                }
                break;
            case 'PtgArray':
                /* [MS-XLS] 2.5.198.32 TODO */ stack.push("{" + $b8f343bf88dacc48$var$stringify_array(/*::(*/ f[1]) + "}");
                break;
            case 'PtgMemArea':
                break;
            case 'PtgAttrSpace':
            /* [MS-XLS] 2.5.198.38 */ case 'PtgAttrSpaceSemi':
                /* [MS-XLS] 2.5.198.39 */ last_sp = ff;
                break;
            case 'PtgTbl':
                break;
            case 'PtgMemErr':
                break;
            case 'PtgMissArg':
                /* [MS-XLS] 2.5.198.74 */ stack.push("");
                break;
            case 'PtgAreaErr':
                /* [MS-XLS] 2.5.198.29 */ stack.push("#REF!");
                break;
            case 'PtgAreaErr3d':
                /* [MS-XLS] 2.5.198.30 */ stack.push("#REF!");
                break;
            case 'PtgList':
                /* [MS-XLSB] 2.5.97.52 */ // $FlowIgnore
                stack.push("Table" + f[1].idx + "[#" + f[1].rt + "]");
                break;
            case 'PtgMemAreaN':
            case 'PtgMemNoMemN':
            case 'PtgAttrNoop':
            case 'PtgSheet':
            case 'PtgEndSheet':
                break;
            case 'PtgMemFunc':
                break;
            case 'PtgMemNoMem':
                break;
            case 'PtgElfCol':
            /* [MS-XLS] 2.5.198.46 */ case 'PtgElfColS':
            /* [MS-XLS] 2.5.198.47 */ case 'PtgElfColSV':
            /* [MS-XLS] 2.5.198.48 */ case 'PtgElfColV':
            /* [MS-XLS] 2.5.198.49 */ case 'PtgElfLel':
            /* [MS-XLS] 2.5.198.50 */ case 'PtgElfRadical':
            /* [MS-XLS] 2.5.198.51 */ case 'PtgElfRadicalLel':
            /* [MS-XLS] 2.5.198.52 */ case 'PtgElfRadicalS':
            /* [MS-XLS] 2.5.198.53 */ case 'PtgElfRw':
            /* [MS-XLS] 2.5.198.54 */ case 'PtgElfRwV':
                /* [MS-XLS] 2.5.198.55 */ throw new Error("Unsupported ELFs");
            case 'PtgSxName':
                /* [MS-XLS] 2.5.198.91 TODO -- find a test case */ throw new Error('Unrecognized Formula Token: ' + String(f));
            default:
                throw new Error('Unrecognized Formula Token: ' + String(f));
        }
        var PtgNonDisp = [
            'PtgAttrSpace',
            'PtgAttrSpaceSemi',
            'PtgAttrGoto'
        ];
        if (opts.biff != 3) {
            if (last_sp >= 0 && PtgNonDisp.indexOf(formula[0][ff][0]) == -1) {
                f = formula[0][last_sp];
                var _left = true;
                switch(f[1][0]){
                    /* note: some bad XLSB files omit the PtgParen */ case 4:
                        _left = false;
                    /* falls through */ case 0:
                        // $FlowIgnore
                        sp = $b8f343bf88dacc48$var$fill(" ", f[1][1]);
                        break;
                    case 5:
                        _left = false;
                    /* falls through */ case 1:
                        // $FlowIgnore
                        sp = $b8f343bf88dacc48$var$fill("\r", f[1][1]);
                        break;
                    default:
                        sp = "";
                        // $FlowIgnore
                        if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + f[1][0]);
                }
                stack.push((_left ? sp : "") + stack.pop() + (_left ? "" : sp));
                last_sp = -1;
            }
        }
    }
    if (stack.length > 1 && opts.WTF) throw new Error("bad formula stack");
    if (stack[0] == "TRUE") return true;
    if (stack[0] == "FALSE") return false;
    return stack[0];
}
/* [MS-XLS] 2.5.198.1 TODO */ function $b8f343bf88dacc48$var$parse_ArrayParsedFormula(blob, length, opts /*::, ref*/ ) {
    var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
    var rgcb, cce = blob.read_shift(len); // length of rgce
    if (cce == 0xFFFF) return [
        [],
        $b8f343bf88dacc48$var$parsenoop(blob, length - 2)
    ];
    var rgce = $b8f343bf88dacc48$var$parse_Rgce(blob, cce, opts);
    if (length !== cce + len) rgcb = $b8f343bf88dacc48$var$parse_RgbExtra(blob, length - cce - len, rgce, opts);
    blob.l = target;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.3 TODO */ function $b8f343bf88dacc48$var$parse_XLSCellParsedFormula(blob, length, opts) {
    var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
    var rgcb, cce = blob.read_shift(len); // length of rgce
    if (cce == 0xFFFF) return [
        [],
        $b8f343bf88dacc48$var$parsenoop(blob, length - 2)
    ];
    var rgce = $b8f343bf88dacc48$var$parse_Rgce(blob, cce, opts);
    if (length !== cce + len) rgcb = $b8f343bf88dacc48$var$parse_RgbExtra(blob, length - cce - len, rgce, opts);
    blob.l = target;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.21 */ function $b8f343bf88dacc48$var$parse_NameParsedFormula(blob, length, opts, cce) {
    var target = blob.l + length;
    var rgce = $b8f343bf88dacc48$var$parse_Rgce(blob, cce, opts);
    var rgcb;
    if (target !== blob.l) rgcb = $b8f343bf88dacc48$var$parse_RgbExtra(blob, target - blob.l, rgce, opts);
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.118 TODO */ function $b8f343bf88dacc48$var$parse_SharedParsedFormula(blob, length, opts) {
    var target = blob.l + length;
    var rgcb, cce = blob.read_shift(2); // length of rgce
    var rgce = $b8f343bf88dacc48$var$parse_Rgce(blob, cce, opts);
    if (cce == 0xFFFF) return [
        [],
        $b8f343bf88dacc48$var$parsenoop(blob, length - 2)
    ];
    if (length !== cce + 2) rgcb = $b8f343bf88dacc48$var$parse_RgbExtra(blob, target - cce - 2, rgce, opts);
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */ function $b8f343bf88dacc48$var$parse_FormulaValue(blob /*::, length*/ ) {
    var b;
    if ($b8f343bf88dacc48$var$__readUInt16LE(blob, blob.l + 6) !== 0xFFFF) return [
        $b8f343bf88dacc48$var$parse_Xnum(blob),
        'n'
    ];
    switch(blob[blob.l]){
        case 0x00:
            blob.l += 8;
            return [
                "String",
                's'
            ];
        case 0x01:
            b = blob[blob.l + 2] === 0x1;
            blob.l += 8;
            return [
                b,
                'b'
            ];
        case 0x02:
            b = blob[blob.l + 2];
            blob.l += 8;
            return [
                b,
                'e'
            ];
        case 0x03:
            blob.l += 8;
            return [
                "",
                's'
            ];
    }
    return [];
}
function $b8f343bf88dacc48$var$write_FormulaValue(value) {
    if (value == null) {
        // Blank String Value
        var o = $b8f343bf88dacc48$var$new_buf(8);
        o.write_shift(1, 0x03);
        o.write_shift(1, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 0xFFFF);
        return o;
    } else if (typeof value == "number") return $b8f343bf88dacc48$var$write_Xnum(value);
    return $b8f343bf88dacc48$var$write_Xnum(0);
}
/* [MS-XLS] 2.4.127 TODO */ function $b8f343bf88dacc48$var$parse_Formula(blob, length, opts) {
    var end = blob.l + length;
    var cell = $b8f343bf88dacc48$var$parse_XLSCell(blob, 6, opts);
    var val = $b8f343bf88dacc48$var$parse_FormulaValue(blob, 8);
    var flags = blob.read_shift(1);
    if (opts.biff != 2) {
        blob.read_shift(1);
        if (opts.biff >= 5) /*var chn = */ blob.read_shift(4);
    }
    var cbf = $b8f343bf88dacc48$var$parse_XLSCellParsedFormula(blob, end - blob.l, opts);
    return {
        cell: cell,
        val: val[0],
        formula: cbf,
        shared: flags >> 3 & 1,
        tt: val[1]
    };
}
function $b8f343bf88dacc48$var$write_Formula(cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, os /*:number*/ ) {
    // Cell
    var o1 = $b8f343bf88dacc48$var$write_XLSCell(R, C, os);
    // FormulaValue
    var o2 = $b8f343bf88dacc48$var$write_FormulaValue(cell.v);
    // flags + cache
    var o3 = $b8f343bf88dacc48$var$new_buf(6);
    var flags = 33;
    o3.write_shift(2, flags);
    o3.write_shift(4, 0);
    // CellParsedFormula
    var bf = $b8f343bf88dacc48$var$new_buf(cell.bf.length);
    for(var i = 0; i < cell.bf.length; ++i)bf[i] = cell.bf[i];
    var out = $b8f343bf88dacc48$var$bconcat([
        o1,
        o2,
        o3,
        bf
    ]);
    return out;
}
/* XLSB Parsed Formula records have the same shape */ function $b8f343bf88dacc48$var$parse_XLSBParsedFormula(data, length, opts) {
    var cce = data.read_shift(4);
    var rgce = $b8f343bf88dacc48$var$parse_Rgce(data, cce, opts);
    var cb = data.read_shift(4);
    var rgcb = cb > 0 ? $b8f343bf88dacc48$var$parse_RgbExtra(data, cb, rgce, opts) : null;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */ var $b8f343bf88dacc48$var$parse_XLSBArrayParsedFormula = $b8f343bf88dacc48$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.4 CellParsedFormula */ var $b8f343bf88dacc48$var$parse_XLSBCellParsedFormula = $b8f343bf88dacc48$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.8 DVParsedFormula */ //var parse_XLSBDVParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.9 FRTParsedFormula */ //var parse_XLSBFRTParsedFormula = parse_XLSBParsedFormula2;
/* [MS-XLSB] 2.5.97.12 NameParsedFormula */ var $b8f343bf88dacc48$var$parse_XLSBNameParsedFormula = $b8f343bf88dacc48$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.98 SharedParsedFormula */ var $b8f343bf88dacc48$var$parse_XLSBSharedParsedFormula = $b8f343bf88dacc48$var$parse_XLSBParsedFormula;
/* Writes a PtgNum or PtgInt */ function $b8f343bf88dacc48$var$write_XLSBFormulaNum(val /*:number*/ ) {
    if ((val | 0) == val && val < Math.pow(2, 16) && val >= 0) {
        var oint = $b8f343bf88dacc48$var$new_buf(11);
        oint.write_shift(4, 3);
        oint.write_shift(1, 0x1e);
        oint.write_shift(2, val);
        oint.write_shift(4, 0);
        return oint;
    }
    var num = $b8f343bf88dacc48$var$new_buf(17);
    num.write_shift(4, 11);
    num.write_shift(1, 0x1f);
    num.write_shift(8, val);
    num.write_shift(4, 0);
    return num;
}
/* Writes a PtgErr */ function $b8f343bf88dacc48$var$write_XLSBFormulaErr(val /*:number*/ ) {
    var oint = $b8f343bf88dacc48$var$new_buf(10);
    oint.write_shift(4, 2);
    oint.write_shift(1, 0x1C);
    oint.write_shift(1, val);
    oint.write_shift(4, 0);
    return oint;
}
/* Writes a PtgBool */ function $b8f343bf88dacc48$var$write_XLSBFormulaBool(val /*:boolean*/ ) {
    var oint = $b8f343bf88dacc48$var$new_buf(10);
    oint.write_shift(4, 2);
    oint.write_shift(1, 0x1D);
    oint.write_shift(1, val ? 1 : 0);
    oint.write_shift(4, 0);
    return oint;
}
/* Writes a PtgStr */ function $b8f343bf88dacc48$var$write_XLSBFormulaStr(val /*:string*/ ) {
    var preamble = $b8f343bf88dacc48$var$new_buf(7);
    preamble.write_shift(4, 3 + 2 * val.length);
    preamble.write_shift(1, 0x17);
    preamble.write_shift(2, val.length);
    var body = $b8f343bf88dacc48$var$new_buf(2 * val.length);
    body.write_shift(2 * val.length, val, "utf16le");
    var postamble = $b8f343bf88dacc48$var$new_buf(4);
    postamble.write_shift(4, 0);
    return $b8f343bf88dacc48$var$bconcat([
        preamble,
        body,
        postamble
    ]);
}
/* Writes a PtgRef */ function $b8f343bf88dacc48$var$write_XLSBFormulaRef(str) {
    var cell = $b8f343bf88dacc48$var$decode_cell(str);
    var out = $b8f343bf88dacc48$var$new_buf(15);
    out.write_shift(4, 7);
    out.write_shift(1, 36);
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    return out;
}
/* Writes a PtgRef3d */ function $b8f343bf88dacc48$var$write_XLSBFormulaRef3D(str, wb) {
    var lastbang = str.lastIndexOf("!");
    var sname = str.slice(0, lastbang);
    str = str.slice(lastbang + 1);
    var cell = $b8f343bf88dacc48$var$decode_cell(str);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var out = $b8f343bf88dacc48$var$new_buf(17);
    out.write_shift(4, 9);
    out.write_shift(1, 58);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    return out;
}
/* Writes a PtgRefErr3d */ function $b8f343bf88dacc48$var$write_XLSBFormulaRefErr3D(str, wb) {
    var lastbang = str.lastIndexOf("!");
    var sname = str.slice(0, lastbang);
    str = str.slice(lastbang + 1);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var out = $b8f343bf88dacc48$var$new_buf(17);
    out.write_shift(4, 9);
    out.write_shift(1, 60);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, 0);
    out.write_shift(2, 0); // <== ColRelShort
    out.write_shift(4, 0);
    return out;
}
/* Writes a single sheet range [PtgRef PtgRef PtgRange] */ function $b8f343bf88dacc48$var$write_XLSBFormulaRange(_str) {
    var parts = _str.split(":"), str = parts[0];
    var out = $b8f343bf88dacc48$var$new_buf(23);
    out.write_shift(4, 15);
    /* start cell */ str = parts[0];
    var cell = $b8f343bf88dacc48$var$decode_cell(str);
    out.write_shift(1, 36);
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    /* end cell */ str = parts[1];
    cell = $b8f343bf88dacc48$var$decode_cell(str);
    out.write_shift(1, 36);
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    /* PtgRange */ out.write_shift(1, 0x11);
    out.write_shift(4, 0);
    return out;
}
/* Writes a range with explicit sheet name [PtgRef3D PtgRef3D PtgRange] */ function $b8f343bf88dacc48$var$write_XLSBFormulaRangeWS(_str, wb) {
    var lastbang = _str.lastIndexOf("!");
    var sname = _str.slice(0, lastbang);
    _str = _str.slice(lastbang + 1);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var parts = _str.split(":");
    var out = $b8f343bf88dacc48$var$new_buf(27);
    out.write_shift(4, 19);
    /* start cell */ var str = parts[0], cell = $b8f343bf88dacc48$var$decode_cell(str);
    out.write_shift(1, 58);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    /* end cell */ str = parts[1];
    cell = $b8f343bf88dacc48$var$decode_cell(str);
    out.write_shift(1, 58);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    /* PtgRange */ out.write_shift(1, 0x11);
    out.write_shift(4, 0);
    return out;
}
/* Writes a range with explicit sheet name [PtgArea3d] */ function $b8f343bf88dacc48$var$write_XLSBFormulaArea3D(_str, wb) {
    var lastbang = _str.lastIndexOf("!");
    var sname = _str.slice(0, lastbang);
    _str = _str.slice(lastbang + 1);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var range = $b8f343bf88dacc48$var$decode_range(_str);
    var out = $b8f343bf88dacc48$var$new_buf(23);
    out.write_shift(4, 15);
    out.write_shift(1, 59);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, range.s.r);
    out.write_shift(4, range.e.r);
    out.write_shift(2, range.s.c);
    out.write_shift(2, range.e.c);
    out.write_shift(4, 0);
    return out;
}
/* General Formula */ function $b8f343bf88dacc48$var$write_XLSBFormula(val /*:string|number*/ , wb) {
    if (typeof val == "number") return $b8f343bf88dacc48$var$write_XLSBFormulaNum(val);
    if (typeof val == "boolean") return $b8f343bf88dacc48$var$write_XLSBFormulaBool(val);
    if (/^#(DIV\/0!|GETTING_DATA|N\/A|NAME\?|NULL!|NUM!|REF!|VALUE!)$/.test(val)) return $b8f343bf88dacc48$var$write_XLSBFormulaErr(+$b8f343bf88dacc48$var$RBErr[val]);
    if (val.match(/^\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $b8f343bf88dacc48$var$write_XLSBFormulaRef(val);
    if (val.match(/^\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $b8f343bf88dacc48$var$write_XLSBFormulaRange(val);
    if (val.match(/^#REF!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $b8f343bf88dacc48$var$write_XLSBFormulaArea3D(val, wb);
    if (val.match(/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $b8f343bf88dacc48$var$write_XLSBFormulaRef3D(val, wb);
    if (val.match(/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $b8f343bf88dacc48$var$write_XLSBFormulaRangeWS(val, wb);
    if (/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!#REF!$/.test(val)) return $b8f343bf88dacc48$var$write_XLSBFormulaRefErr3D(val, wb);
    if (/^".*"$/.test(val)) return $b8f343bf88dacc48$var$write_XLSBFormulaStr(val);
    if (/^[+-]\d+$/.test(val)) return $b8f343bf88dacc48$var$write_XLSBFormulaNum(parseInt(val, 10));
    throw "Formula |" + val + "| not supported for XLSB";
}
var $b8f343bf88dacc48$var$write_XLSBNameParsedFormula = $b8f343bf88dacc48$var$write_XLSBFormula;
var $b8f343bf88dacc48$var$Cetab = {
    0: "BEEP",
    1: "OPEN",
    2: "OPEN.LINKS",
    3: "CLOSE.ALL",
    4: "SAVE",
    5: "SAVE.AS",
    6: "FILE.DELETE",
    7: "PAGE.SETUP",
    8: "PRINT",
    9: "PRINTER.SETUP",
    10: "QUIT",
    11: "NEW.WINDOW",
    12: "ARRANGE.ALL",
    13: "WINDOW.SIZE",
    14: "WINDOW.MOVE",
    15: "FULL",
    16: "CLOSE",
    17: "RUN",
    22: "SET.PRINT.AREA",
    23: "SET.PRINT.TITLES",
    24: "SET.PAGE.BREAK",
    25: "REMOVE.PAGE.BREAK",
    26: "FONT",
    27: "DISPLAY",
    28: "PROTECT.DOCUMENT",
    29: "PRECISION",
    30: "A1.R1C1",
    31: "CALCULATE.NOW",
    32: "CALCULATION",
    34: "DATA.FIND",
    35: "EXTRACT",
    36: "DATA.DELETE",
    37: "SET.DATABASE",
    38: "SET.CRITERIA",
    39: "SORT",
    40: "DATA.SERIES",
    41: "TABLE",
    42: "FORMAT.NUMBER",
    43: "ALIGNMENT",
    44: "STYLE",
    45: "BORDER",
    46: "CELL.PROTECTION",
    47: "COLUMN.WIDTH",
    48: "UNDO",
    49: "CUT",
    50: "COPY",
    51: "PASTE",
    52: "CLEAR",
    53: "PASTE.SPECIAL",
    54: "EDIT.DELETE",
    55: "INSERT",
    56: "FILL.RIGHT",
    57: "FILL.DOWN",
    61: "DEFINE.NAME",
    62: "CREATE.NAMES",
    63: "FORMULA.GOTO",
    64: "FORMULA.FIND",
    65: "SELECT.LAST.CELL",
    66: "SHOW.ACTIVE.CELL",
    67: "GALLERY.AREA",
    68: "GALLERY.BAR",
    69: "GALLERY.COLUMN",
    70: "GALLERY.LINE",
    71: "GALLERY.PIE",
    72: "GALLERY.SCATTER",
    73: "COMBINATION",
    74: "PREFERRED",
    75: "ADD.OVERLAY",
    76: "GRIDLINES",
    77: "SET.PREFERRED",
    78: "AXES",
    79: "LEGEND",
    80: "ATTACH.TEXT",
    81: "ADD.ARROW",
    82: "SELECT.CHART",
    83: "SELECT.PLOT.AREA",
    84: "PATTERNS",
    85: "MAIN.CHART",
    86: "OVERLAY",
    87: "SCALE",
    88: "FORMAT.LEGEND",
    89: "FORMAT.TEXT",
    90: "EDIT.REPEAT",
    91: "PARSE",
    92: "JUSTIFY",
    93: "HIDE",
    94: "UNHIDE",
    95: "WORKSPACE",
    96: "FORMULA",
    97: "FORMULA.FILL",
    98: "FORMULA.ARRAY",
    99: "DATA.FIND.NEXT",
    100: "DATA.FIND.PREV",
    101: "FORMULA.FIND.NEXT",
    102: "FORMULA.FIND.PREV",
    103: "ACTIVATE",
    104: "ACTIVATE.NEXT",
    105: "ACTIVATE.PREV",
    106: "UNLOCKED.NEXT",
    107: "UNLOCKED.PREV",
    108: "COPY.PICTURE",
    109: "SELECT",
    110: "DELETE.NAME",
    111: "DELETE.FORMAT",
    112: "VLINE",
    113: "HLINE",
    114: "VPAGE",
    115: "HPAGE",
    116: "VSCROLL",
    117: "HSCROLL",
    118: "ALERT",
    119: "NEW",
    120: "CANCEL.COPY",
    121: "SHOW.CLIPBOARD",
    122: "MESSAGE",
    124: "PASTE.LINK",
    125: "APP.ACTIVATE",
    126: "DELETE.ARROW",
    127: "ROW.HEIGHT",
    128: "FORMAT.MOVE",
    129: "FORMAT.SIZE",
    130: "FORMULA.REPLACE",
    131: "SEND.KEYS",
    132: "SELECT.SPECIAL",
    133: "APPLY.NAMES",
    134: "REPLACE.FONT",
    135: "FREEZE.PANES",
    136: "SHOW.INFO",
    137: "SPLIT",
    138: "ON.WINDOW",
    139: "ON.DATA",
    140: "DISABLE.INPUT",
    142: "OUTLINE",
    143: "LIST.NAMES",
    144: "FILE.CLOSE",
    145: "SAVE.WORKBOOK",
    146: "DATA.FORM",
    147: "COPY.CHART",
    148: "ON.TIME",
    149: "WAIT",
    150: "FORMAT.FONT",
    151: "FILL.UP",
    152: "FILL.LEFT",
    153: "DELETE.OVERLAY",
    155: "SHORT.MENUS",
    159: "SET.UPDATE.STATUS",
    161: "COLOR.PALETTE",
    162: "DELETE.STYLE",
    163: "WINDOW.RESTORE",
    164: "WINDOW.MAXIMIZE",
    166: "CHANGE.LINK",
    167: "CALCULATE.DOCUMENT",
    168: "ON.KEY",
    169: "APP.RESTORE",
    170: "APP.MOVE",
    171: "APP.SIZE",
    172: "APP.MINIMIZE",
    173: "APP.MAXIMIZE",
    174: "BRING.TO.FRONT",
    175: "SEND.TO.BACK",
    185: "MAIN.CHART.TYPE",
    186: "OVERLAY.CHART.TYPE",
    187: "SELECT.END",
    188: "OPEN.MAIL",
    189: "SEND.MAIL",
    190: "STANDARD.FONT",
    191: "CONSOLIDATE",
    192: "SORT.SPECIAL",
    193: "GALLERY.3D.AREA",
    194: "GALLERY.3D.COLUMN",
    195: "GALLERY.3D.LINE",
    196: "GALLERY.3D.PIE",
    197: "VIEW.3D",
    198: "GOAL.SEEK",
    199: "WORKGROUP",
    200: "FILL.GROUP",
    201: "UPDATE.LINK",
    202: "PROMOTE",
    203: "DEMOTE",
    204: "SHOW.DETAIL",
    206: "UNGROUP",
    207: "OBJECT.PROPERTIES",
    208: "SAVE.NEW.OBJECT",
    209: "SHARE",
    210: "SHARE.NAME",
    211: "DUPLICATE",
    212: "APPLY.STYLE",
    213: "ASSIGN.TO.OBJECT",
    214: "OBJECT.PROTECTION",
    215: "HIDE.OBJECT",
    216: "SET.EXTRACT",
    217: "CREATE.PUBLISHER",
    218: "SUBSCRIBE.TO",
    219: "ATTRIBUTES",
    220: "SHOW.TOOLBAR",
    222: "PRINT.PREVIEW",
    223: "EDIT.COLOR",
    224: "SHOW.LEVELS",
    225: "FORMAT.MAIN",
    226: "FORMAT.OVERLAY",
    227: "ON.RECALC",
    228: "EDIT.SERIES",
    229: "DEFINE.STYLE",
    240: "LINE.PRINT",
    243: "ENTER.DATA",
    249: "GALLERY.RADAR",
    250: "MERGE.STYLES",
    251: "EDITION.OPTIONS",
    252: "PASTE.PICTURE",
    253: "PASTE.PICTURE.LINK",
    254: "SPELLING",
    256: "ZOOM",
    259: "INSERT.OBJECT",
    260: "WINDOW.MINIMIZE",
    265: "SOUND.NOTE",
    266: "SOUND.PLAY",
    267: "FORMAT.SHAPE",
    268: "EXTEND.POLYGON",
    269: "FORMAT.AUTO",
    272: "GALLERY.3D.BAR",
    273: "GALLERY.3D.SURFACE",
    274: "FILL.AUTO",
    276: "CUSTOMIZE.TOOLBAR",
    277: "ADD.TOOL",
    278: "EDIT.OBJECT",
    279: "ON.DOUBLECLICK",
    280: "ON.ENTRY",
    281: "WORKBOOK.ADD",
    282: "WORKBOOK.MOVE",
    283: "WORKBOOK.COPY",
    284: "WORKBOOK.OPTIONS",
    285: "SAVE.WORKSPACE",
    288: "CHART.WIZARD",
    289: "DELETE.TOOL",
    290: "MOVE.TOOL",
    291: "WORKBOOK.SELECT",
    292: "WORKBOOK.ACTIVATE",
    293: "ASSIGN.TO.TOOL",
    295: "COPY.TOOL",
    296: "RESET.TOOL",
    297: "CONSTRAIN.NUMERIC",
    298: "PASTE.TOOL",
    302: "WORKBOOK.NEW",
    305: "SCENARIO.CELLS",
    306: "SCENARIO.DELETE",
    307: "SCENARIO.ADD",
    308: "SCENARIO.EDIT",
    309: "SCENARIO.SHOW",
    310: "SCENARIO.SHOW.NEXT",
    311: "SCENARIO.SUMMARY",
    312: "PIVOT.TABLE.WIZARD",
    313: "PIVOT.FIELD.PROPERTIES",
    314: "PIVOT.FIELD",
    315: "PIVOT.ITEM",
    316: "PIVOT.ADD.FIELDS",
    318: "OPTIONS.CALCULATION",
    319: "OPTIONS.EDIT",
    320: "OPTIONS.VIEW",
    321: "ADDIN.MANAGER",
    322: "MENU.EDITOR",
    323: "ATTACH.TOOLBARS",
    324: "VBAActivate",
    325: "OPTIONS.CHART",
    328: "VBA.INSERT.FILE",
    330: "VBA.PROCEDURE.DEFINITION",
    336: "ROUTING.SLIP",
    338: "ROUTE.DOCUMENT",
    339: "MAIL.LOGON",
    342: "INSERT.PICTURE",
    343: "EDIT.TOOL",
    344: "GALLERY.DOUGHNUT",
    350: "CHART.TREND",
    352: "PIVOT.ITEM.PROPERTIES",
    354: "WORKBOOK.INSERT",
    355: "OPTIONS.TRANSITION",
    356: "OPTIONS.GENERAL",
    370: "FILTER.ADVANCED",
    373: "MAIL.ADD.MAILER",
    374: "MAIL.DELETE.MAILER",
    375: "MAIL.REPLY",
    376: "MAIL.REPLY.ALL",
    377: "MAIL.FORWARD",
    378: "MAIL.NEXT.LETTER",
    379: "DATA.LABEL",
    380: "INSERT.TITLE",
    381: "FONT.PROPERTIES",
    382: "MACRO.OPTIONS",
    383: "WORKBOOK.HIDE",
    384: "WORKBOOK.UNHIDE",
    385: "WORKBOOK.DELETE",
    386: "WORKBOOK.NAME",
    388: "GALLERY.CUSTOM",
    390: "ADD.CHART.AUTOFORMAT",
    391: "DELETE.CHART.AUTOFORMAT",
    392: "CHART.ADD.DATA",
    393: "AUTO.OUTLINE",
    394: "TAB.ORDER",
    395: "SHOW.DIALOG",
    396: "SELECT.ALL",
    397: "UNGROUP.SHEETS",
    398: "SUBTOTAL.CREATE",
    399: "SUBTOTAL.REMOVE",
    400: "RENAME.OBJECT",
    412: "WORKBOOK.SCROLL",
    413: "WORKBOOK.NEXT",
    414: "WORKBOOK.PREV",
    415: "WORKBOOK.TAB.SPLIT",
    416: "FULL.SCREEN",
    417: "WORKBOOK.PROTECT",
    420: "SCROLLBAR.PROPERTIES",
    421: "PIVOT.SHOW.PAGES",
    422: "TEXT.TO.COLUMNS",
    423: "FORMAT.CHARTTYPE",
    424: "LINK.FORMAT",
    425: "TRACER.DISPLAY",
    430: "TRACER.NAVIGATE",
    431: "TRACER.CLEAR",
    432: "TRACER.ERROR",
    433: "PIVOT.FIELD.GROUP",
    434: "PIVOT.FIELD.UNGROUP",
    435: "CHECKBOX.PROPERTIES",
    436: "LABEL.PROPERTIES",
    437: "LISTBOX.PROPERTIES",
    438: "EDITBOX.PROPERTIES",
    439: "PIVOT.REFRESH",
    440: "LINK.COMBO",
    441: "OPEN.TEXT",
    442: "HIDE.DIALOG",
    443: "SET.DIALOG.FOCUS",
    444: "ENABLE.OBJECT",
    445: "PUSHBUTTON.PROPERTIES",
    446: "SET.DIALOG.DEFAULT",
    447: "FILTER",
    448: "FILTER.SHOW.ALL",
    449: "CLEAR.OUTLINE",
    450: "FUNCTION.WIZARD",
    451: "ADD.LIST.ITEM",
    452: "SET.LIST.ITEM",
    453: "REMOVE.LIST.ITEM",
    454: "SELECT.LIST.ITEM",
    455: "SET.CONTROL.VALUE",
    456: "SAVE.COPY.AS",
    458: "OPTIONS.LISTS.ADD",
    459: "OPTIONS.LISTS.DELETE",
    460: "SERIES.AXES",
    461: "SERIES.X",
    462: "SERIES.Y",
    463: "ERRORBAR.X",
    464: "ERRORBAR.Y",
    465: "FORMAT.CHART",
    466: "SERIES.ORDER",
    467: "MAIL.LOGOFF",
    468: "CLEAR.ROUTING.SLIP",
    469: "APP.ACTIVATE.MICROSOFT",
    470: "MAIL.EDIT.MAILER",
    471: "ON.SHEET",
    472: "STANDARD.WIDTH",
    473: "SCENARIO.MERGE",
    474: "SUMMARY.INFO",
    475: "FIND.FILE",
    476: "ACTIVE.CELL.FONT",
    477: "ENABLE.TIPWIZARD",
    478: "VBA.MAKE.ADDIN",
    480: "INSERTDATATABLE",
    481: "WORKGROUP.OPTIONS",
    482: "MAIL.SEND.MAILER",
    485: "AUTOCORRECT",
    489: "POST.DOCUMENT",
    491: "PICKLIST",
    493: "VIEW.SHOW",
    494: "VIEW.DEFINE",
    495: "VIEW.DELETE",
    509: "SHEET.BACKGROUND",
    510: "INSERT.MAP.OBJECT",
    511: "OPTIONS.MENONO",
    517: "MSOCHECKS",
    518: "NORMAL",
    519: "LAYOUT",
    520: "RM.PRINT.AREA",
    521: "CLEAR.PRINT.AREA",
    522: "ADD.PRINT.AREA",
    523: "MOVE.BRK",
    545: "HIDECURR.NOTE",
    546: "HIDEALL.NOTES",
    547: "DELETE.NOTE",
    548: "TRAVERSE.NOTES",
    549: "ACTIVATE.NOTES",
    620: "PROTECT.REVISIONS",
    621: "UNPROTECT.REVISIONS",
    647: "OPTIONS.ME",
    653: "WEB.PUBLISH",
    667: "NEWWEBQUERY",
    673: "PIVOT.TABLE.CHART",
    753: "OPTIONS.SAVE",
    755: "OPTIONS.SPELL",
    808: "HIDEALL.INKANNOTS"
};
var $b8f343bf88dacc48$var$Ftab = {
    0: "COUNT",
    1: "IF",
    2: "ISNA",
    3: "ISERROR",
    4: "SUM",
    5: "AVERAGE",
    6: "MIN",
    7: "MAX",
    8: "ROW",
    9: "COLUMN",
    10: "NA",
    11: "NPV",
    12: "STDEV",
    13: "DOLLAR",
    14: "FIXED",
    15: "SIN",
    16: "COS",
    17: "TAN",
    18: "ATAN",
    19: "PI",
    20: "SQRT",
    21: "EXP",
    22: "LN",
    23: "LOG10",
    24: "ABS",
    25: "INT",
    26: "SIGN",
    27: "ROUND",
    28: "LOOKUP",
    29: "INDEX",
    30: "REPT",
    31: "MID",
    32: "LEN",
    33: "VALUE",
    34: "TRUE",
    35: "FALSE",
    36: "AND",
    37: "OR",
    38: "NOT",
    39: "MOD",
    40: "DCOUNT",
    41: "DSUM",
    42: "DAVERAGE",
    43: "DMIN",
    44: "DMAX",
    45: "DSTDEV",
    46: "VAR",
    47: "DVAR",
    48: "TEXT",
    49: "LINEST",
    50: "TREND",
    51: "LOGEST",
    52: "GROWTH",
    53: "GOTO",
    54: "HALT",
    55: "RETURN",
    56: "PV",
    57: "FV",
    58: "NPER",
    59: "PMT",
    60: "RATE",
    61: "MIRR",
    62: "IRR",
    63: "RAND",
    64: "MATCH",
    65: "DATE",
    66: "TIME",
    67: "DAY",
    68: "MONTH",
    69: "YEAR",
    70: "WEEKDAY",
    71: "HOUR",
    72: "MINUTE",
    73: "SECOND",
    74: "NOW",
    75: "AREAS",
    76: "ROWS",
    77: "COLUMNS",
    78: "OFFSET",
    79: "ABSREF",
    80: "RELREF",
    81: "ARGUMENT",
    82: "SEARCH",
    83: "TRANSPOSE",
    84: "ERROR",
    85: "STEP",
    86: "TYPE",
    87: "ECHO",
    88: "SET.NAME",
    89: "CALLER",
    90: "DEREF",
    91: "WINDOWS",
    92: "SERIES",
    93: "DOCUMENTS",
    94: "ACTIVE.CELL",
    95: "SELECTION",
    96: "RESULT",
    97: "ATAN2",
    98: "ASIN",
    99: "ACOS",
    100: "CHOOSE",
    101: "HLOOKUP",
    102: "VLOOKUP",
    103: "LINKS",
    104: "INPUT",
    105: "ISREF",
    106: "GET.FORMULA",
    107: "GET.NAME",
    108: "SET.VALUE",
    109: "LOG",
    110: "EXEC",
    111: "CHAR",
    112: "LOWER",
    113: "UPPER",
    114: "PROPER",
    115: "LEFT",
    116: "RIGHT",
    117: "EXACT",
    118: "TRIM",
    119: "REPLACE",
    120: "SUBSTITUTE",
    121: "CODE",
    122: "NAMES",
    123: "DIRECTORY",
    124: "FIND",
    125: "CELL",
    126: "ISERR",
    127: "ISTEXT",
    128: "ISNUMBER",
    129: "ISBLANK",
    130: "T",
    131: "N",
    132: "FOPEN",
    133: "FCLOSE",
    134: "FSIZE",
    135: "FREADLN",
    136: "FREAD",
    137: "FWRITELN",
    138: "FWRITE",
    139: "FPOS",
    140: "DATEVALUE",
    141: "TIMEVALUE",
    142: "SLN",
    143: "SYD",
    144: "DDB",
    145: "GET.DEF",
    146: "REFTEXT",
    147: "TEXTREF",
    148: "INDIRECT",
    149: "REGISTER",
    150: "CALL",
    151: "ADD.BAR",
    152: "ADD.MENU",
    153: "ADD.COMMAND",
    154: "ENABLE.COMMAND",
    155: "CHECK.COMMAND",
    156: "RENAME.COMMAND",
    157: "SHOW.BAR",
    158: "DELETE.MENU",
    159: "DELETE.COMMAND",
    160: "GET.CHART.ITEM",
    161: "DIALOG.BOX",
    162: "CLEAN",
    163: "MDETERM",
    164: "MINVERSE",
    165: "MMULT",
    166: "FILES",
    167: "IPMT",
    168: "PPMT",
    169: "COUNTA",
    170: "CANCEL.KEY",
    171: "FOR",
    172: "WHILE",
    173: "BREAK",
    174: "NEXT",
    175: "INITIATE",
    176: "REQUEST",
    177: "POKE",
    178: "EXECUTE",
    179: "TERMINATE",
    180: "RESTART",
    181: "HELP",
    182: "GET.BAR",
    183: "PRODUCT",
    184: "FACT",
    185: "GET.CELL",
    186: "GET.WORKSPACE",
    187: "GET.WINDOW",
    188: "GET.DOCUMENT",
    189: "DPRODUCT",
    190: "ISNONTEXT",
    191: "GET.NOTE",
    192: "NOTE",
    193: "STDEVP",
    194: "VARP",
    195: "DSTDEVP",
    196: "DVARP",
    197: "TRUNC",
    198: "ISLOGICAL",
    199: "DCOUNTA",
    200: "DELETE.BAR",
    201: "UNREGISTER",
    204: "USDOLLAR",
    205: "FINDB",
    206: "SEARCHB",
    207: "REPLACEB",
    208: "LEFTB",
    209: "RIGHTB",
    210: "MIDB",
    211: "LENB",
    212: "ROUNDUP",
    213: "ROUNDDOWN",
    214: "ASC",
    215: "DBCS",
    216: "RANK",
    219: "ADDRESS",
    220: "DAYS360",
    221: "TODAY",
    222: "VDB",
    223: "ELSE",
    224: "ELSE.IF",
    225: "END.IF",
    226: "FOR.CELL",
    227: "MEDIAN",
    228: "SUMPRODUCT",
    229: "SINH",
    230: "COSH",
    231: "TANH",
    232: "ASINH",
    233: "ACOSH",
    234: "ATANH",
    235: "DGET",
    236: "CREATE.OBJECT",
    237: "VOLATILE",
    238: "LAST.ERROR",
    239: "CUSTOM.UNDO",
    240: "CUSTOM.REPEAT",
    241: "FORMULA.CONVERT",
    242: "GET.LINK.INFO",
    243: "TEXT.BOX",
    244: "INFO",
    245: "GROUP",
    246: "GET.OBJECT",
    247: "DB",
    248: "PAUSE",
    251: "RESUME",
    252: "FREQUENCY",
    253: "ADD.TOOLBAR",
    254: "DELETE.TOOLBAR",
    255: "User",
    256: "RESET.TOOLBAR",
    257: "EVALUATE",
    258: "GET.TOOLBAR",
    259: "GET.TOOL",
    260: "SPELLING.CHECK",
    261: "ERROR.TYPE",
    262: "APP.TITLE",
    263: "WINDOW.TITLE",
    264: "SAVE.TOOLBAR",
    265: "ENABLE.TOOL",
    266: "PRESS.TOOL",
    267: "REGISTER.ID",
    268: "GET.WORKBOOK",
    269: "AVEDEV",
    270: "BETADIST",
    271: "GAMMALN",
    272: "BETAINV",
    273: "BINOMDIST",
    274: "CHIDIST",
    275: "CHIINV",
    276: "COMBIN",
    277: "CONFIDENCE",
    278: "CRITBINOM",
    279: "EVEN",
    280: "EXPONDIST",
    281: "FDIST",
    282: "FINV",
    283: "FISHER",
    284: "FISHERINV",
    285: "FLOOR",
    286: "GAMMADIST",
    287: "GAMMAINV",
    288: "CEILING",
    289: "HYPGEOMDIST",
    290: "LOGNORMDIST",
    291: "LOGINV",
    292: "NEGBINOMDIST",
    293: "NORMDIST",
    294: "NORMSDIST",
    295: "NORMINV",
    296: "NORMSINV",
    297: "STANDARDIZE",
    298: "ODD",
    299: "PERMUT",
    300: "POISSON",
    301: "TDIST",
    302: "WEIBULL",
    303: "SUMXMY2",
    304: "SUMX2MY2",
    305: "SUMX2PY2",
    306: "CHITEST",
    307: "CORREL",
    308: "COVAR",
    309: "FORECAST",
    310: "FTEST",
    311: "INTERCEPT",
    312: "PEARSON",
    313: "RSQ",
    314: "STEYX",
    315: "SLOPE",
    316: "TTEST",
    317: "PROB",
    318: "DEVSQ",
    319: "GEOMEAN",
    320: "HARMEAN",
    321: "SUMSQ",
    322: "KURT",
    323: "SKEW",
    324: "ZTEST",
    325: "LARGE",
    326: "SMALL",
    327: "QUARTILE",
    328: "PERCENTILE",
    329: "PERCENTRANK",
    330: "MODE",
    331: "TRIMMEAN",
    332: "TINV",
    334: "MOVIE.COMMAND",
    335: "GET.MOVIE",
    336: "CONCATENATE",
    337: "POWER",
    338: "PIVOT.ADD.DATA",
    339: "GET.PIVOT.TABLE",
    340: "GET.PIVOT.FIELD",
    341: "GET.PIVOT.ITEM",
    342: "RADIANS",
    343: "DEGREES",
    344: "SUBTOTAL",
    345: "SUMIF",
    346: "COUNTIF",
    347: "COUNTBLANK",
    348: "SCENARIO.GET",
    349: "OPTIONS.LISTS.GET",
    350: "ISPMT",
    351: "DATEDIF",
    352: "DATESTRING",
    353: "NUMBERSTRING",
    354: "ROMAN",
    355: "OPEN.DIALOG",
    356: "SAVE.DIALOG",
    357: "VIEW.GET",
    358: "GETPIVOTDATA",
    359: "HYPERLINK",
    360: "PHONETIC",
    361: "AVERAGEA",
    362: "MAXA",
    363: "MINA",
    364: "STDEVPA",
    365: "VARPA",
    366: "STDEVA",
    367: "VARA",
    368: "BAHTTEXT",
    369: "THAIDAYOFWEEK",
    370: "THAIDIGIT",
    371: "THAIMONTHOFYEAR",
    372: "THAINUMSOUND",
    373: "THAINUMSTRING",
    374: "THAISTRINGLENGTH",
    375: "ISTHAIDIGIT",
    376: "ROUNDBAHTDOWN",
    377: "ROUNDBAHTUP",
    378: "THAIYEAR",
    379: "RTD",
    380: "CUBEVALUE",
    381: "CUBEMEMBER",
    382: "CUBEMEMBERPROPERTY",
    383: "CUBERANKEDMEMBER",
    384: "HEX2BIN",
    385: "HEX2DEC",
    386: "HEX2OCT",
    387: "DEC2BIN",
    388: "DEC2HEX",
    389: "DEC2OCT",
    390: "OCT2BIN",
    391: "OCT2HEX",
    392: "OCT2DEC",
    393: "BIN2DEC",
    394: "BIN2OCT",
    395: "BIN2HEX",
    396: "IMSUB",
    397: "IMDIV",
    398: "IMPOWER",
    399: "IMABS",
    400: "IMSQRT",
    401: "IMLN",
    402: "IMLOG2",
    403: "IMLOG10",
    404: "IMSIN",
    405: "IMCOS",
    406: "IMEXP",
    407: "IMARGUMENT",
    408: "IMCONJUGATE",
    409: "IMAGINARY",
    410: "IMREAL",
    411: "COMPLEX",
    412: "IMSUM",
    413: "IMPRODUCT",
    414: "SERIESSUM",
    415: "FACTDOUBLE",
    416: "SQRTPI",
    417: "QUOTIENT",
    418: "DELTA",
    419: "GESTEP",
    420: "ISEVEN",
    421: "ISODD",
    422: "MROUND",
    423: "ERF",
    424: "ERFC",
    425: "BESSELJ",
    426: "BESSELK",
    427: "BESSELY",
    428: "BESSELI",
    429: "XIRR",
    430: "XNPV",
    431: "PRICEMAT",
    432: "YIELDMAT",
    433: "INTRATE",
    434: "RECEIVED",
    435: "DISC",
    436: "PRICEDISC",
    437: "YIELDDISC",
    438: "TBILLEQ",
    439: "TBILLPRICE",
    440: "TBILLYIELD",
    441: "PRICE",
    442: "YIELD",
    443: "DOLLARDE",
    444: "DOLLARFR",
    445: "NOMINAL",
    446: "EFFECT",
    447: "CUMPRINC",
    448: "CUMIPMT",
    449: "EDATE",
    450: "EOMONTH",
    451: "YEARFRAC",
    452: "COUPDAYBS",
    453: "COUPDAYS",
    454: "COUPDAYSNC",
    455: "COUPNCD",
    456: "COUPNUM",
    457: "COUPPCD",
    458: "DURATION",
    459: "MDURATION",
    460: "ODDLPRICE",
    461: "ODDLYIELD",
    462: "ODDFPRICE",
    463: "ODDFYIELD",
    464: "RANDBETWEEN",
    465: "WEEKNUM",
    466: "AMORDEGRC",
    467: "AMORLINC",
    468: "CONVERT",
    724: "SHEETJS",
    469: "ACCRINT",
    470: "ACCRINTM",
    471: "WORKDAY",
    472: "NETWORKDAYS",
    473: "GCD",
    474: "MULTINOMIAL",
    475: "LCM",
    476: "FVSCHEDULE",
    477: "CUBEKPIMEMBER",
    478: "CUBESET",
    479: "CUBESETCOUNT",
    480: "IFERROR",
    481: "COUNTIFS",
    482: "SUMIFS",
    483: "AVERAGEIF",
    484: "AVERAGEIFS"
};
var $b8f343bf88dacc48$var$FtabArgc = {
    2: 1,
    3: 1,
    10: 0,
    15: 1,
    16: 1,
    17: 1,
    18: 1,
    19: 0,
    20: 1,
    21: 1,
    22: 1,
    23: 1,
    24: 1,
    25: 1,
    26: 1,
    27: 2,
    30: 2,
    31: 3,
    32: 1,
    33: 1,
    34: 0,
    35: 0,
    38: 1,
    39: 2,
    40: 3,
    41: 3,
    42: 3,
    43: 3,
    44: 3,
    45: 3,
    47: 3,
    48: 2,
    53: 1,
    61: 3,
    63: 0,
    65: 3,
    66: 3,
    67: 1,
    68: 1,
    69: 1,
    70: 1,
    71: 1,
    72: 1,
    73: 1,
    74: 0,
    75: 1,
    76: 1,
    77: 1,
    79: 2,
    80: 2,
    83: 1,
    85: 0,
    86: 1,
    89: 0,
    90: 1,
    94: 0,
    95: 0,
    97: 2,
    98: 1,
    99: 1,
    101: 3,
    102: 3,
    105: 1,
    106: 1,
    108: 2,
    111: 1,
    112: 1,
    113: 1,
    114: 1,
    117: 2,
    118: 1,
    119: 4,
    121: 1,
    126: 1,
    127: 1,
    128: 1,
    129: 1,
    130: 1,
    131: 1,
    133: 1,
    134: 1,
    135: 1,
    136: 2,
    137: 2,
    138: 2,
    140: 1,
    141: 1,
    142: 3,
    143: 4,
    144: 4,
    161: 1,
    162: 1,
    163: 1,
    164: 1,
    165: 2,
    172: 1,
    175: 2,
    176: 2,
    177: 3,
    178: 2,
    179: 1,
    184: 1,
    186: 1,
    189: 3,
    190: 1,
    195: 3,
    196: 3,
    197: 1,
    198: 1,
    199: 3,
    201: 1,
    207: 4,
    210: 3,
    211: 1,
    212: 2,
    213: 2,
    214: 1,
    215: 1,
    225: 0,
    229: 1,
    230: 1,
    231: 1,
    232: 1,
    233: 1,
    234: 1,
    235: 3,
    244: 1,
    247: 4,
    252: 2,
    257: 1,
    261: 1,
    271: 1,
    273: 4,
    274: 2,
    275: 2,
    276: 2,
    277: 3,
    278: 3,
    279: 1,
    280: 3,
    281: 3,
    282: 3,
    283: 1,
    284: 1,
    285: 2,
    286: 4,
    287: 3,
    288: 2,
    289: 4,
    290: 3,
    291: 3,
    292: 3,
    293: 4,
    294: 1,
    295: 3,
    296: 1,
    297: 3,
    298: 1,
    299: 2,
    300: 3,
    301: 3,
    302: 4,
    303: 2,
    304: 2,
    305: 2,
    306: 2,
    307: 2,
    308: 2,
    309: 3,
    310: 2,
    311: 2,
    312: 2,
    313: 2,
    314: 2,
    315: 2,
    316: 4,
    325: 2,
    326: 2,
    327: 2,
    328: 2,
    331: 2,
    332: 2,
    337: 2,
    342: 1,
    343: 1,
    346: 2,
    347: 1,
    350: 4,
    351: 3,
    352: 1,
    353: 2,
    360: 1,
    368: 1,
    369: 1,
    370: 1,
    371: 1,
    372: 1,
    373: 1,
    374: 1,
    375: 1,
    376: 1,
    377: 1,
    378: 1,
    382: 3,
    385: 1,
    392: 1,
    393: 1,
    396: 2,
    397: 2,
    398: 2,
    399: 1,
    400: 1,
    401: 1,
    402: 1,
    403: 1,
    404: 1,
    405: 1,
    406: 1,
    407: 1,
    408: 1,
    409: 1,
    410: 1,
    414: 4,
    415: 1,
    416: 1,
    417: 2,
    420: 1,
    421: 1,
    422: 2,
    424: 1,
    425: 2,
    426: 2,
    427: 2,
    428: 2,
    430: 3,
    438: 3,
    439: 3,
    440: 3,
    443: 2,
    444: 2,
    445: 2,
    446: 2,
    447: 6,
    448: 6,
    449: 2,
    450: 2,
    464: 2,
    468: 3,
    476: 2,
    479: 1,
    480: 2,
    65535: 0
};
/* Part 3 TODO: actually parse formulae */ function $b8f343bf88dacc48$var$ods_to_csf_formula(f /*:string*/ ) /*:string*/ {
    if (f.slice(0, 3) == "of:") f = f.slice(3);
    /* 5.2 Basic Expressions */ if (f.charCodeAt(0) == 61) {
        f = f.slice(1);
        if (f.charCodeAt(0) == 61) f = f.slice(1);
    }
    f = f.replace(/COM\.MICROSOFT\./g, "");
    /* Part 3 Section 5.8 References */ f = f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function($$, $1) {
        return $1.replace(/\./g, "");
    });
    f = f.replace(/\$'([^']|'')+'/g, function($$) {
        return $$.slice(1);
    });
    f = f.replace(/\$([^\]\. #$]+)/g, function($$, $1) {
        return $1.match(/^([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])?(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})?$/) ? $$ : $1;
    });
    /* TODO: something other than this */ f = f.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
    return f.replace(/[;~]/g, ",").replace(/\|/g, ";");
}
function $b8f343bf88dacc48$var$csf_to_ods_formula(f /*:string*/ ) /*:string*/ {
    var o = "of:=" + f.replace($b8f343bf88dacc48$var$crefregex, "$1[.$2$3$4$5]").replace(/\]:\[/g, ":");
    /* TODO: something other than this */ return o.replace(/;/g, "|").replace(/,/g, ";");
}
function $b8f343bf88dacc48$var$ods_to_csf_3D(r /*:string*/ ) /*:[string, string]*/ {
    r = r.replace(/\$'([^']|'')+'/g, function($$) {
        return $$.slice(1);
    });
    r = r.replace(/\$([^\]\. #$]+)/g, function($$, $1) {
        return $1.match(/^([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])?(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})?$/) ? $$ : $1;
    });
    var a = r.split(":");
    var s = a[0].split(".")[0];
    return [
        s,
        a[0].split(".")[1] + (a.length > 1 ? ":" + (a[1].split(".")[1] || a[1].split(".")[0]) : "")
    ];
}
function $b8f343bf88dacc48$var$csf_to_ods_3D(r /*:string*/ ) /*:string*/ {
    return r.replace(/!/, ".").replace(/:/, ":.");
}
var $b8f343bf88dacc48$var$strs = {}; // shared strings
var $b8f343bf88dacc48$var$_ssfopts = {}; // spreadsheet formatting options
/*global Map */ var $b8f343bf88dacc48$var$browser_has_Map = typeof Map !== 'undefined';
function $b8f343bf88dacc48$var$get_sst_id(sst /*:SST*/ , str /*:string*/ , rev) /*:number*/ {
    var i = 0, len = sst.length;
    if (rev) {
        if ($b8f343bf88dacc48$var$browser_has_Map ? rev.has(str) : Object.prototype.hasOwnProperty.call(rev, str)) {
            var revarr = $b8f343bf88dacc48$var$browser_has_Map ? rev.get(str) : rev[str];
            for(; i < revarr.length; ++i)if (sst[revarr[i]].t === str) {
                sst.Count++;
                return revarr[i];
            }
        }
    } else for(; i < len; ++i)if (sst[i].t === str) {
        sst.Count++;
        return i;
    }
    sst[len] = {
        t: str
    } /*:any*/ ;
    sst.Count++;
    sst.Unique++;
    if (rev) {
        if ($b8f343bf88dacc48$var$browser_has_Map) {
            if (!rev.has(str)) rev.set(str, []);
            rev.get(str).push(len);
        } else {
            if (!Object.prototype.hasOwnProperty.call(rev, str)) rev[str] = [];
            rev[str].push(len);
        }
    }
    return len;
}
function $b8f343bf88dacc48$var$col_obj_w(C /*:number*/ , col) {
    var p = {
        min: C + 1,
        max: C + 1
    } /*:any*/ ;
    /* wch (chars), wpx (pixels) */ var wch = -1;
    if (col.MDW) $b8f343bf88dacc48$var$MDW = col.MDW;
    if (col.width != null) p.customWidth = 1;
    else if (col.wpx != null) wch = $b8f343bf88dacc48$var$px2char(col.wpx);
    else if (col.wch != null) wch = col.wch;
    if (wch > -1) {
        p.width = $b8f343bf88dacc48$var$char2width(wch);
        p.customWidth = 1;
    } else if (col.width != null) p.width = col.width;
    if (col.hidden) p.hidden = true;
    if (col.level != null) p.outlineLevel = p.level = col.level;
    return p;
}
function $b8f343bf88dacc48$var$default_margins(margins /*:Margins*/ , mode /*:?string*/ ) {
    if (!margins) return;
    var defs = [
        0.7,
        0.7,
        0.75,
        0.75,
        0.3,
        0.3
    ];
    if (mode == 'xlml') defs = [
        1,
        1,
        1,
        1,
        0.5,
        0.5
    ];
    if (margins.left == null) margins.left = defs[0];
    if (margins.right == null) margins.right = defs[1];
    if (margins.top == null) margins.top = defs[2];
    if (margins.bottom == null) margins.bottom = defs[3];
    if (margins.header == null) margins.header = defs[4];
    if (margins.footer == null) margins.footer = defs[5];
}
function $b8f343bf88dacc48$var$get_cell_style(styles /*:Array<any>*/ , cell /*:Cell*/ , opts) {
    var z = opts.revssf[cell.z != null ? cell.z : "General"];
    var i = 0x3c, len = styles.length;
    if (z == null && opts.ssf) {
        for(; i < 0x188; ++i)if (opts.ssf[i] == null) {
            $b8f343bf88dacc48$var$SSF__load(cell.z, i);
            // $FlowIgnore
            opts.ssf[i] = cell.z;
            opts.revssf[cell.z] = z = i;
            break;
        }
    }
    for(i = 0; i != len; ++i)if (styles[i].numFmtId === z) return i;
    styles[len] = {
        numFmtId: z,
        fontId: 0,
        fillId: 0,
        borderId: 0,
        xfId: 0,
        applyNumberFormat: 1
    };
    return len;
}
function $b8f343bf88dacc48$var$safe_format(p /*:Cell*/ , fmtid /*:number*/ , fillid /*:?number*/ , opts, themes, styles, date1904) {
    try {
        if (opts.cellNF) p.z = $b8f343bf88dacc48$var$table_fmt[fmtid];
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (p.t === 'z' && !opts.cellStyles) return;
    if (p.t === 'd' && typeof p.v === 'string') p.v = $b8f343bf88dacc48$var$parseDate(p.v);
    if ((!opts || opts.cellText !== false) && p.t !== 'z') try {
        if ($b8f343bf88dacc48$var$table_fmt[fmtid] == null) $b8f343bf88dacc48$var$SSF__load($b8f343bf88dacc48$var$SSFImplicit[fmtid] || "General", fmtid);
        if (p.t === 'e') p.w = p.w || $b8f343bf88dacc48$var$BErr[p.v];
        else if (fmtid === 0) {
            if (p.t === 'n') {
                if ((p.v | 0) === p.v) p.w = p.v.toString(10);
                else p.w = $b8f343bf88dacc48$var$SSF_general_num(p.v);
            } else if (p.t === 'd') {
                var dd = $b8f343bf88dacc48$var$datenum(p.v, !!date1904);
                if ((dd | 0) === dd) p.w = dd.toString(10);
                else p.w = $b8f343bf88dacc48$var$SSF_general_num(dd);
            } else if (p.v === undefined) return "";
            else p.w = $b8f343bf88dacc48$var$SSF_general(p.v, $b8f343bf88dacc48$var$_ssfopts);
        } else if (p.t === 'd') p.w = $b8f343bf88dacc48$var$SSF_format(fmtid, $b8f343bf88dacc48$var$datenum(p.v, !!date1904), $b8f343bf88dacc48$var$_ssfopts);
        else p.w = $b8f343bf88dacc48$var$SSF_format(fmtid, p.v, $b8f343bf88dacc48$var$_ssfopts);
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (!opts.cellStyles) return;
    if (fillid != null) try {
        p.s = styles.Fills[fillid];
        if (p.s.fgColor && p.s.fgColor.theme && !p.s.fgColor.rgb) {
            p.s.fgColor.rgb = $b8f343bf88dacc48$var$rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb, p.s.fgColor.tint || 0);
            if (opts.WTF) p.s.fgColor.raw_rgb = themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;
        }
        if (p.s.bgColor && p.s.bgColor.theme) {
            p.s.bgColor.rgb = $b8f343bf88dacc48$var$rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb, p.s.bgColor.tint || 0);
            if (opts.WTF) p.s.bgColor.raw_rgb = themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;
        }
    } catch (e) {
        if (opts.WTF && styles.Fills) throw e;
    }
}
function $b8f343bf88dacc48$var$check_ws(ws /*:Worksheet*/ , sname /*:string*/ , i /*:number*/ ) {
    if (ws && ws['!ref']) {
        var range = $b8f343bf88dacc48$var$safe_decode_range(ws['!ref']);
        if (range.e.c < range.s.c || range.e.r < range.s.r) throw new Error("Bad range (" + i + "): " + ws['!ref']);
    }
}
function $b8f343bf88dacc48$var$parse_ws_xml_dim(ws /*:Worksheet*/ , s /*:string*/ ) {
    var d = $b8f343bf88dacc48$var$safe_decode_range(s);
    if (d.s.r <= d.e.r && d.s.c <= d.e.c && d.s.r >= 0 && d.s.c >= 0) ws["!ref"] = $b8f343bf88dacc48$var$encode_range(d);
}
var $b8f343bf88dacc48$var$mergecregex = /<(?:\w+:)?mergeCell ref=["'][A-Z0-9:]+['"]\s*[\/]?>/g;
var $b8f343bf88dacc48$var$hlinkregex = /<(?:\w+:)?hyperlink [^<>]*>/mg;
var $b8f343bf88dacc48$var$dimregex = /"(\w*:\w*)"/;
var $b8f343bf88dacc48$var$colregex = /<(?:\w+:)?col\b[^<>]*[\/]?>/g;
var $b8f343bf88dacc48$var$afregex = /<(?:\w+:)?autoFilter[^>]*/g;
var $b8f343bf88dacc48$var$marginregex = /<(?:\w+:)?pageMargins[^<>]*\/>/g;
var $b8f343bf88dacc48$var$sheetprregex = /<(?:\w+:)?sheetPr\b[^<>]*?\/>/;
/* 18.3 Worksheets */ function $b8f343bf88dacc48$var$parse_ws_xml(data /*:?string*/ , opts, idx /*:number*/ , rels, wb /*:WBWBProps*/ , themes, styles) /*:Worksheet*/ {
    if (!data) return data;
    if (!rels) rels = {
        '!id': {}
    };
    if ($b8f343bf88dacc48$var$DENSE != null && opts.dense == null) opts.dense = $b8f343bf88dacc48$var$DENSE;
    /* 18.3.1.99 worksheet CT_Worksheet */ var s = {} /*:any*/ ;
    if (opts.dense) s["!data"] = [];
    var refguess /*:Range*/  = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    } /*:any*/ ;
    var data1 = "", data2 = "";
    var mtch /*:?any*/  = $b8f343bf88dacc48$var$str_match_xml_ns(data, "sheetData");
    if (mtch) {
        data1 = data.slice(0, mtch.index);
        data2 = data.slice(mtch.index + mtch[0].length);
    } else data1 = data2 = data;
    /* 18.3.1.82 sheetPr CT_SheetPr */ var sheetPr = data1.match($b8f343bf88dacc48$var$sheetprregex);
    if (sheetPr) $b8f343bf88dacc48$var$parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
    else if (sheetPr = $b8f343bf88dacc48$var$str_match_xml_ns(data1, "sheetPr")) $b8f343bf88dacc48$var$parse_ws_xml_sheetpr2(sheetPr[0], sheetPr[1] || "", s, wb, idx, styles, themes);
    /* 18.3.1.35 dimension CT_SheetDimension */ var ridx = (data1.match(/<(?:\w*:)?dimension/) || {
        index: -1
    }).index;
    if (ridx > 0) {
        var ref = data1.slice(ridx, ridx + 50).match($b8f343bf88dacc48$var$dimregex);
        if (ref && !(opts && opts.nodim)) $b8f343bf88dacc48$var$parse_ws_xml_dim(s, ref[1]);
    }
    /* 18.3.1.88 sheetViews CT_SheetViews */ var svs = $b8f343bf88dacc48$var$str_match_xml_ns(data1, "sheetViews");
    if (svs && svs[1]) $b8f343bf88dacc48$var$parse_ws_xml_sheetviews(svs[1], wb);
    /* 18.3.1.17 cols CT_Cols */ var columns /*:Array<ColInfo>*/  = [];
    if (opts.cellStyles) {
        /* 18.3.1.13 col CT_Col */ var cols = data1.match($b8f343bf88dacc48$var$colregex);
        if (cols) $b8f343bf88dacc48$var$parse_ws_xml_cols(columns, cols);
    }
    /* 18.3.1.80 sheetData CT_SheetData ? */ if (mtch) $b8f343bf88dacc48$var$parse_ws_xml_data(mtch[1], s, opts, refguess, themes, styles, wb);
    /* 18.3.1.2  autoFilter CT_AutoFilter */ var afilter = data2.match($b8f343bf88dacc48$var$afregex);
    if (afilter) s['!autofilter'] = $b8f343bf88dacc48$var$parse_ws_xml_autofilter(afilter[0]);
    /* 18.3.1.55 mergeCells CT_MergeCells */ var merges /*:Array<Range>*/  = [];
    var _merge = data2.match($b8f343bf88dacc48$var$mergecregex);
    if (_merge) for(ridx = 0; ridx != _merge.length; ++ridx)merges[ridx] = $b8f343bf88dacc48$var$safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf("\"") + 1));
    /* 18.3.1.48 hyperlinks CT_Hyperlinks */ var hlink = data2.match($b8f343bf88dacc48$var$hlinkregex);
    if (hlink) $b8f343bf88dacc48$var$parse_ws_xml_hlinks(s, hlink, rels);
    /* 18.3.1.62 pageMargins CT_PageMargins */ var margins = data2.match($b8f343bf88dacc48$var$marginregex);
    if (margins) s['!margins'] = $b8f343bf88dacc48$var$parse_ws_xml_margins($b8f343bf88dacc48$var$parsexmltag(margins[0]));
    /* legacyDrawing */ var m;
    if (m = data2.match(/legacyDrawing r:id="(.*?)"/)) s['!legrel'] = m[1];
    if (opts && opts.nodim) refguess.s.c = refguess.s.r = 0;
    if (!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = $b8f343bf88dacc48$var$encode_range(refguess);
    if (opts.sheetRows > 0 && s["!ref"]) {
        var tmpref = $b8f343bf88dacc48$var$safe_decode_range(s["!ref"]);
        if (opts.sheetRows <= +tmpref.e.r) {
            tmpref.e.r = opts.sheetRows - 1;
            if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
            if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
            if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
            if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
            s["!fullref"] = s["!ref"];
            s["!ref"] = $b8f343bf88dacc48$var$encode_range(tmpref);
        }
    }
    if (columns.length > 0) s["!cols"] = columns;
    if (merges.length > 0) s["!merges"] = merges;
    if (rels['!id'][s['!legrel']]) s['!legdrawel'] = rels['!id'][s['!legrel']];
    return s;
}
function $b8f343bf88dacc48$var$write_ws_xml_merges(merges /*:Array<Range>*/ ) /*:string*/ {
    if (merges.length === 0) return "";
    var o = '<mergeCells count="' + merges.length + '">';
    for(var i = 0; i != merges.length; ++i)o += '<mergeCell ref="' + $b8f343bf88dacc48$var$encode_range(merges[i]) + '"/>';
    return o + '</mergeCells>';
}
/* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */ function $b8f343bf88dacc48$var$parse_ws_xml_sheetpr(sheetPr /*:string*/ , s, wb /*:WBWBProps*/ , idx /*:number*/ ) {
    var data = $b8f343bf88dacc48$var$parsexmltag(sheetPr);
    if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
    if (data.codeName) wb.Sheets[idx].CodeName = $b8f343bf88dacc48$var$unescapexml($b8f343bf88dacc48$var$utf8read(data.codeName));
}
function $b8f343bf88dacc48$var$parse_ws_xml_sheetpr2(sheetPr /*:string*/ , body /*:string*/ , s, wb /*:WBWBProps*/ , idx /*:number*/ ) {
    $b8f343bf88dacc48$var$parse_ws_xml_sheetpr(sheetPr.slice(0, sheetPr.indexOf(">")), s, wb, idx);
}
function $b8f343bf88dacc48$var$write_ws_xml_sheetpr(ws, wb, idx, opts, o) {
    var needed = false;
    var props = {}, payload = null;
    if (opts.bookType !== 'xlsx' && wb.vbaraw) {
        var cname = wb.SheetNames[idx];
        try {
            if (wb.Workbook) cname = wb.Workbook.Sheets[idx].CodeName || cname;
        } catch (e) {}
        needed = true;
        props.codeName = $b8f343bf88dacc48$var$utf8write($b8f343bf88dacc48$var$escapexml(cname));
    }
    if (ws && ws["!outline"]) {
        var outlineprops = {
            summaryBelow: 1,
            summaryRight: 1
        };
        if (ws["!outline"].above) outlineprops.summaryBelow = 0;
        if (ws["!outline"].left) outlineprops.summaryRight = 0;
        payload = (payload || "") + $b8f343bf88dacc48$var$writextag('outlinePr', null, outlineprops);
    }
    if (!needed && !payload) return;
    o[o.length] = $b8f343bf88dacc48$var$writextag('sheetPr', payload, props);
}
/* 18.3.1.85 sheetProtection CT_SheetProtection */ var $b8f343bf88dacc48$var$sheetprot_deffalse = [
    "objects",
    "scenarios",
    "selectLockedCells",
    "selectUnlockedCells"
];
var $b8f343bf88dacc48$var$sheetprot_deftrue = [
    "formatColumns",
    "formatRows",
    "formatCells",
    "insertColumns",
    "insertRows",
    "insertHyperlinks",
    "deleteColumns",
    "deleteRows",
    "sort",
    "autoFilter",
    "pivotTables"
];
function $b8f343bf88dacc48$var$write_ws_xml_protection(sp) /*:string*/ {
    // algorithmName, hashValue, saltValue, spinCount
    var o = {
        sheet: 1
    } /*:any*/ ;
    $b8f343bf88dacc48$var$sheetprot_deffalse.forEach(function(n) {
        if (sp[n] != null && sp[n]) o[n] = "1";
    });
    $b8f343bf88dacc48$var$sheetprot_deftrue.forEach(function(n) {
        if (sp[n] != null && !sp[n]) o[n] = "0";
    });
    /* TODO: algorithm */ if (sp.password) o.password = $b8f343bf88dacc48$var$crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();
    return $b8f343bf88dacc48$var$writextag('sheetProtection', null, o);
}
function $b8f343bf88dacc48$var$parse_ws_xml_hlinks(s, data /*:Array<string>*/ , rels) {
    var dense = s["!data"] != null;
    for(var i = 0; i != data.length; ++i){
        var val = $b8f343bf88dacc48$var$parsexmltag($b8f343bf88dacc48$var$utf8read(data[i]), true);
        if (!val.ref) return;
        var rel = ((rels || {})['!id'] || [])[val.id];
        if (rel) {
            val.Target = rel.Target;
            if (val.location) val.Target += "#" + $b8f343bf88dacc48$var$unescapexml(val.location);
        } else {
            val.Target = "#" + $b8f343bf88dacc48$var$unescapexml(val.location);
            rel = {
                Target: val.Target,
                TargetMode: 'Internal'
            };
        }
        val.Rel = rel;
        if (val.tooltip) {
            val.Tooltip = val.tooltip;
            delete val.tooltip;
        }
        var rng = $b8f343bf88dacc48$var$safe_decode_range(val.ref);
        for(var R = rng.s.r; R <= rng.e.r; ++R)for(var C = rng.s.c; C <= rng.e.c; ++C){
            var addr = $b8f343bf88dacc48$var$encode_col(C) + $b8f343bf88dacc48$var$encode_row(R);
            if (dense) {
                if (!s["!data"][R]) s["!data"][R] = [];
                if (!s["!data"][R][C]) s["!data"][R][C] = {
                    t: "z",
                    v: undefined
                };
                s["!data"][R][C].l = val;
            } else {
                if (!s[addr]) s[addr] = {
                    t: "z",
                    v: undefined
                };
                s[addr].l = val;
            }
        }
    }
}
function $b8f343bf88dacc48$var$parse_ws_xml_margins(margin) {
    var o = {};
    [
        "left",
        "right",
        "top",
        "bottom",
        "header",
        "footer"
    ].forEach(function(k) {
        if (margin[k]) o[k] = parseFloat(margin[k]);
    });
    return o;
}
function $b8f343bf88dacc48$var$write_ws_xml_margins(margin) /*:string*/ {
    $b8f343bf88dacc48$var$default_margins(margin);
    return $b8f343bf88dacc48$var$writextag('pageMargins', null, margin);
}
function $b8f343bf88dacc48$var$parse_ws_xml_cols(columns, cols) {
    var seencol = false;
    for(var coli = 0; coli != cols.length; ++coli){
        var coll = $b8f343bf88dacc48$var$parsexmltag(cols[coli], true);
        if (coll.hidden) coll.hidden = $b8f343bf88dacc48$var$parsexmlbool(coll.hidden);
        var colm = parseInt(coll.min, 10) - 1, colM = parseInt(coll.max, 10) - 1;
        if (coll.outlineLevel) coll.level = +coll.outlineLevel || 0;
        delete coll.min;
        delete coll.max;
        coll.width = +coll.width;
        if (!seencol && coll.width) {
            seencol = true;
            $b8f343bf88dacc48$var$find_mdw_colw(coll.width);
        }
        $b8f343bf88dacc48$var$process_col(coll);
        while(colm <= colM)columns[colm++] = $b8f343bf88dacc48$var$dup(coll);
    }
}
function $b8f343bf88dacc48$var$write_ws_xml_cols(ws, cols) /*:string*/ {
    var o = [
        "<cols>"
    ], col;
    for(var i = 0; i != cols.length; ++i){
        if (!(col = cols[i])) continue;
        o[o.length] = $b8f343bf88dacc48$var$writextag('col', null, $b8f343bf88dacc48$var$col_obj_w(i, col));
    }
    o[o.length] = "</cols>";
    return o.join("");
}
function $b8f343bf88dacc48$var$parse_ws_xml_autofilter(data /*:string*/ ) {
    var o = {
        ref: (data.match(/ref="([^"]*)"/) || [])[1]
    };
    return o;
}
function $b8f343bf88dacc48$var$write_ws_xml_autofilter(data, ws, wb, idx) /*:string*/ {
    var ref = typeof data.ref == "string" ? data.ref : $b8f343bf88dacc48$var$encode_range(data.ref);
    if (!wb.Workbook) wb.Workbook = {
        Sheets: []
    } /*:any*/ ;
    if (!wb.Workbook.Names) wb.Workbook.Names = [];
    var names /*: Array<any> */  = wb.Workbook.Names;
    var range = $b8f343bf88dacc48$var$decode_range(ref);
    if (range.s.r == range.e.r) {
        range.e.r = $b8f343bf88dacc48$var$decode_range(ws["!ref"]).e.r;
        ref = $b8f343bf88dacc48$var$encode_range(range);
    }
    for(var i = 0; i < names.length; ++i){
        var name = names[i];
        if (name.Name != '_xlnm._FilterDatabase') continue;
        if (name.Sheet != idx) continue;
        name.Ref = $b8f343bf88dacc48$var$formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + $b8f343bf88dacc48$var$fix_range(ref);
        break;
    }
    if (i == names.length) names.push({
        Name: '_xlnm._FilterDatabase',
        Sheet: idx,
        Ref: "'" + wb.SheetNames[idx] + "'!" + ref
    });
    return $b8f343bf88dacc48$var$writextag("autoFilter", null, {
        ref: ref
    });
}
/* 18.3.1.88 sheetViews CT_SheetViews */ /* 18.3.1.87 sheetView CT_SheetView */ var $b8f343bf88dacc48$var$sviewregex = /<(?:\w:)?sheetView(?:[^<>a-z][^<>]*)?\/?>/g;
function $b8f343bf88dacc48$var$parse_ws_xml_sheetviews(data, wb /*:WBWBProps*/ ) {
    if (!wb.Views) wb.Views = [
        {}
    ];
    (data.match($b8f343bf88dacc48$var$sviewregex) || []).forEach(function(r /*:string*/ , i /*:number*/ ) {
        var tag = $b8f343bf88dacc48$var$parsexmltag(r);
        // $FlowIgnore
        if (!wb.Views[i]) wb.Views[i] = {};
        // $FlowIgnore
        if (+tag.zoomScale) wb.Views[i].zoom = +tag.zoomScale;
        // $FlowIgnore
        if (tag.rightToLeft && $b8f343bf88dacc48$var$parsexmlbool(tag.rightToLeft)) wb.Views[i].RTL = true;
    });
}
function $b8f343bf88dacc48$var$write_ws_xml_sheetviews(ws, opts, idx, wb) /*:string*/ {
    var sview = {
        workbookViewId: "0"
    } /*:any*/ ;
    // $FlowIgnore
    if ((((wb || {}).Workbook || {}).Views || [])[0]) sview.rightToLeft = wb.Workbook.Views[0].RTL ? "1" : "0";
    return $b8f343bf88dacc48$var$writextag("sheetViews", $b8f343bf88dacc48$var$writextag("sheetView", null, sview), {});
}
function $b8f343bf88dacc48$var$write_ws_xml_cell(cell /*:Cell*/ , ref, ws, opts, idx, wb, date1904) /*:string*/ {
    if (cell.c) ws['!comments'].push([
        ref,
        cell.c
    ]);
    if ((cell.v === undefined || cell.t === "z" && !(opts || {}).sheetStubs) && typeof cell.f !== "string" && typeof cell.z == "undefined") return "";
    var vv = "";
    var oldt = cell.t, oldv = cell.v;
    if (cell.t !== "z") switch(cell.t){
        case 'b':
            vv = cell.v ? "1" : "0";
            break;
        case 'n':
            if (isNaN(cell.v)) {
                cell.t = "e";
                vv = $b8f343bf88dacc48$var$BErr[cell.v = 0x24];
            } else if (!isFinite(cell.v)) {
                cell.t = "e";
                vv = $b8f343bf88dacc48$var$BErr[cell.v = 0x07];
            } else vv = '' + cell.v;
            break;
        case 'e':
            vv = $b8f343bf88dacc48$var$BErr[cell.v];
            break;
        case 'd':
            if (opts && opts.cellDates) {
                var _vv = $b8f343bf88dacc48$var$parseDate(cell.v, date1904);
                vv = _vv.toISOString();
                if (_vv.getUTCFullYear() < 1900) vv = vv.slice(vv.indexOf("T") + 1).replace("Z", "");
            } else {
                cell = $b8f343bf88dacc48$var$dup(cell);
                cell.t = 'n';
                vv = '' + (cell.v = $b8f343bf88dacc48$var$datenum($b8f343bf88dacc48$var$parseDate(cell.v, date1904), date1904));
            }
            if (typeof cell.z === 'undefined') cell.z = $b8f343bf88dacc48$var$table_fmt[14];
            break;
        default:
            vv = cell.v;
            break;
    }
    var v = cell.t == "z" || cell.v == null ? "" : $b8f343bf88dacc48$var$writetag('v', $b8f343bf88dacc48$var$escapexml(vv)), o = {
        r: ref
    } /*:any*/ ;
    /* TODO: cell style */ var os = $b8f343bf88dacc48$var$get_cell_style(opts.cellXfs, cell, opts);
    if (os !== 0) o.s = os;
    switch(cell.t){
        case 'n':
            break;
        case 'd':
            o.t = "d";
            break;
        case 'b':
            o.t = "b";
            break;
        case 'e':
            o.t = "e";
            break;
        case 'z':
            break;
        default:
            if (cell.v == null) {
                delete cell.t;
                break;
            }
            if (cell.v.length > 32767) throw new Error("Text length must not exceed 32767 characters");
            if (opts && opts.bookSST) {
                v = $b8f343bf88dacc48$var$writetag('v', '' + $b8f343bf88dacc48$var$get_sst_id(opts.Strings, cell.v, opts.revStrings));
                o.t = "s";
                break;
            } else o.t = "str";
            break;
    }
    if (cell.t != oldt) {
        cell.t = oldt;
        cell.v = oldv;
    }
    if (typeof cell.f == "string" && cell.f) {
        var ff = cell.F && cell.F.slice(0, ref.length) == ref ? {
            t: "array",
            ref: cell.F
        } : null;
        v = $b8f343bf88dacc48$var$writextag('f', $b8f343bf88dacc48$var$escapexml(cell.f), ff) + (cell.v != null ? v : "");
    }
    if (cell.l) {
        cell.l.display = $b8f343bf88dacc48$var$escapexml(vv);
        ws['!links'].push([
            ref,
            cell.l
        ]);
    }
    if (cell.D) o.cm = 1;
    return $b8f343bf88dacc48$var$writextag('c', v, o);
}
var $b8f343bf88dacc48$var$parse_ws_xml_data = /*#__PURE__*/ function() {
    var cellregex = /<(?:\w+:)?c[ \/>]/, rowregex = /<\/(?:\w+:)?row>/;
    var rregex = /r=["']([^"']*)["']/;
    var refregex = /ref=["']([^"']*)["']/;
    return function parse_ws_xml_data(sdata /*:string*/ , s, opts, guess /*:Range*/ , themes, styles, wb) {
        var ri = 0, x = "", cells /*:Array<string>*/  = [], cref /*:?Array<string>*/  = [], idx = 0, i = 0, cc = 0, d = "", p /*:any*/ ;
        var tag, tagr = 0, tagc = 0;
        var sstr, ftag;
        var fmtid = 0, fillid = 0;
        var do_format = Array.isArray(styles.CellXf), cf;
        var arrayf /*:Array<[Range, string]>*/  = [];
        var sharedf = [];
        var dense = s["!data"] != null;
        var rows /*:Array<RowInfo>*/  = [], rowobj = {}, rowrite = false;
        var sheetStubs = !!opts.sheetStubs;
        var date1904 = !!((wb || {}).WBProps || {}).date1904;
        for(var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt){
            x = marr[mt].trim();
            var xlen = x.length;
            if (xlen === 0) continue;
            /* 18.3.1.73 row CT_Row */ var rstarti = 0;
            outa: for(ri = 0; ri < xlen; ++ri)switch(/*x.charCodeAt(ri)*/ x[ri]){
                case ">" /*62*/ :
                    if (/*x.charCodeAt(ri-1) != 47*/ x[ri - 1] != "/") {
                        ++ri;
                        break outa;
                    }
                    if (opts && opts.cellStyles) {
                        // TODO: avoid duplication
                        tag = $b8f343bf88dacc48$var$parsexmltag(x.slice(rstarti, ri), true);
                        tagr = tag.r != null ? parseInt(tag.r, 10) : tagr + 1;
                        tagc = -1;
                        if (opts.sheetRows && opts.sheetRows < tagr) continue;
                        rowobj = {};
                        rowrite = false;
                        if (tag.ht) {
                            rowrite = true;
                            rowobj.hpt = parseFloat(tag.ht);
                            rowobj.hpx = $b8f343bf88dacc48$var$pt2px(rowobj.hpt);
                        }
                        if (tag.hidden && $b8f343bf88dacc48$var$parsexmlbool(tag.hidden)) {
                            rowrite = true;
                            rowobj.hidden = true;
                        }
                        if (tag.outlineLevel != null) {
                            rowrite = true;
                            rowobj.level = +tag.outlineLevel;
                        }
                        if (rowrite) rows[tagr - 1] = rowobj;
                    }
                    break;
                case "<" /*60*/ :
                    rstarti = ri;
                    break;
            }
            if (rstarti >= ri) break;
            tag = $b8f343bf88dacc48$var$parsexmltag(x.slice(rstarti, ri), true);
            tagr = tag.r != null ? parseInt(tag.r, 10) : tagr + 1;
            tagc = -1;
            if (opts.sheetRows && opts.sheetRows < tagr) continue;
            if (!opts.nodim) {
                if (guess.s.r > tagr - 1) guess.s.r = tagr - 1;
                if (guess.e.r < tagr - 1) guess.e.r = tagr - 1;
            }
            if (opts && opts.cellStyles) {
                rowobj = {};
                rowrite = false;
                if (tag.ht) {
                    rowrite = true;
                    rowobj.hpt = parseFloat(tag.ht);
                    rowobj.hpx = $b8f343bf88dacc48$var$pt2px(rowobj.hpt);
                }
                if (tag.hidden && $b8f343bf88dacc48$var$parsexmlbool(tag.hidden)) {
                    rowrite = true;
                    rowobj.hidden = true;
                }
                if (tag.outlineLevel != null) {
                    rowrite = true;
                    rowobj.level = +tag.outlineLevel;
                }
                if (rowrite) rows[tagr - 1] = rowobj;
            }
            /* 18.3.1.4 c CT_Cell */ cells = x.slice(ri).split(cellregex);
            for(var rslice = 0; rslice != cells.length; ++rslice)if (cells[rslice].trim().charAt(0) != "<") break;
            cells = cells.slice(rslice);
            for(ri = 0; ri != cells.length; ++ri){
                x = cells[ri].trim();
                if (x.length === 0) continue;
                cref = x.match(rregex);
                idx = ri;
                i = 0;
                cc = 0;
                x = "<c " + (x.slice(0, 1) == "<" ? ">" : "") + x;
                if (cref != null && cref.length === 2) {
                    idx = 0;
                    d = cref[1];
                    for(i = 0; i != d.length; ++i){
                        if ((cc = d.charCodeAt(i) - 64) < 1 || cc > 26) break;
                        idx = 26 * idx + cc;
                    }
                    --idx;
                    tagc = idx;
                } else ++tagc;
                for(i = 0; i != x.length; ++i)if (x.charCodeAt(i) === 62) break;
                ++i;
                tag = $b8f343bf88dacc48$var$parsexmltag(x.slice(0, i), true);
                if (!tag.r) tag.r = $b8f343bf88dacc48$var$encode_cell({
                    r: tagr - 1,
                    c: tagc
                });
                d = x.slice(i);
                p = {
                    t: ""
                } /*:any*/ ;
                if ((cref = $b8f343bf88dacc48$var$str_match_xml_ns(d, "v")) != null && /*::cref != null && */ cref[1] !== '') p.v = $b8f343bf88dacc48$var$unescapexml(cref[1]);
                if (opts.cellFormula) {
                    if ((cref = $b8f343bf88dacc48$var$str_match_xml_ns(d, "f")) != null) {
                        if (cref[1] == "") {
                            if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="shared"') > -1) {
                                // TODO: parse formula
                                ftag = $b8f343bf88dacc48$var$parsexmltag(cref[0]);
                                if (sharedf[ftag.si]) p.f = $b8f343bf88dacc48$var$shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2], tag.r);
                            }
                        } else {
                            /* TODO: match against XLSXFutureFunctions */ p.f = $b8f343bf88dacc48$var$unescapexml($b8f343bf88dacc48$var$utf8read(cref[1]), true);
                            if (!opts.xlfn) p.f = $b8f343bf88dacc48$var$_xlfn(p.f);
                            if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="array"') > -1) {
                                p.F = (d.match(refregex) || [])[1];
                                if (p.F.indexOf(":") > -1) arrayf.push([
                                    $b8f343bf88dacc48$var$safe_decode_range(p.F),
                                    p.F
                                ]);
                            } else if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="shared"') > -1) {
                                // TODO: parse formula
                                ftag = $b8f343bf88dacc48$var$parsexmltag(cref[0]);
                                var ___f = $b8f343bf88dacc48$var$unescapexml($b8f343bf88dacc48$var$utf8read(cref[1]));
                                if (!opts.xlfn) ___f = $b8f343bf88dacc48$var$_xlfn(___f);
                                sharedf[parseInt(ftag.si, 10)] = [
                                    ftag,
                                    ___f,
                                    tag.r
                                ];
                            }
                        }
                    } else if (cref = d.match(/<f[^<>]*\/>/)) {
                        ftag = $b8f343bf88dacc48$var$parsexmltag(cref[0]);
                        if (sharedf[ftag.si]) p.f = $b8f343bf88dacc48$var$shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2], tag.r);
                    }
                    /* TODO: factor out contains logic */ var _tag = $b8f343bf88dacc48$var$decode_cell(tag.r);
                    for(i = 0; i < arrayf.length; ++i)if (_tag.r >= arrayf[i][0].s.r && _tag.r <= arrayf[i][0].e.r) {
                        if (_tag.c >= arrayf[i][0].s.c && _tag.c <= arrayf[i][0].e.c) p.F = arrayf[i][1];
                    }
                }
                if (tag.t == null && p.v === undefined) {
                    if (p.f || p.F) {
                        p.v = 0;
                        p.t = "n";
                    } else if (!sheetStubs) continue;
                    else p.t = "z";
                } else p.t = tag.t || "n";
                if (guess.s.c > tagc) guess.s.c = tagc;
                if (guess.e.c < tagc) guess.e.c = tagc;
                /* 18.18.11 t ST_CellType */ switch(p.t){
                    case 'n':
                        if (p.v == "" || p.v == null) {
                            if (!sheetStubs) continue;
                            p.t = 'z';
                        } else p.v = parseFloat(p.v);
                        break;
                    case 's':
                        if (typeof p.v == 'undefined') {
                            if (!sheetStubs) continue;
                            p.t = 'z';
                        } else {
                            sstr = $b8f343bf88dacc48$var$strs[parseInt(p.v, 10)];
                            p.v = sstr.t;
                            p.r = sstr.r;
                            if (opts.cellHTML) p.h = sstr.h;
                        }
                        break;
                    case 'str':
                        p.t = "s";
                        p.v = p.v != null ? $b8f343bf88dacc48$var$unescapexml($b8f343bf88dacc48$var$utf8read(p.v), true) : '';
                        if (opts.cellHTML) p.h = $b8f343bf88dacc48$var$escapehtml(p.v);
                        break;
                    case 'inlineStr':
                        cref = $b8f343bf88dacc48$var$str_match_xml_ns(d, "is");
                        p.t = 's';
                        if (cref != null && (sstr = $b8f343bf88dacc48$var$parse_si(cref[1]))) {
                            p.v = sstr.t;
                            if (opts.cellHTML) p.h = sstr.h;
                        } else p.v = "";
                        break;
                    case 'b':
                        p.v = $b8f343bf88dacc48$var$parsexmlbool(p.v);
                        break;
                    case 'd':
                        if (opts.cellDates) p.v = $b8f343bf88dacc48$var$parseDate(p.v, date1904);
                        else {
                            p.v = $b8f343bf88dacc48$var$datenum($b8f343bf88dacc48$var$parseDate(p.v, date1904), date1904);
                            p.t = 'n';
                        }
                        break;
                    /* error string in .w, number in .v */ case 'e':
                        if (!opts || opts.cellText !== false) p.w = p.v;
                        p.v = $b8f343bf88dacc48$var$RBErr[p.v];
                        break;
                }
                /* formatting */ fmtid = fillid = 0;
                cf = null;
                if (do_format && tag.s !== undefined) {
                    cf = styles.CellXf[tag.s];
                    if (cf != null) {
                        if (cf.numFmtId != null) fmtid = cf.numFmtId;
                        if (opts.cellStyles) {
                            if (cf.fillId != null) fillid = cf.fillId;
                        }
                    }
                }
                $b8f343bf88dacc48$var$safe_format(p, fmtid, fillid, opts, themes, styles, date1904);
                if (opts.cellDates && do_format && p.t == 'n' && $b8f343bf88dacc48$var$fmt_is_date($b8f343bf88dacc48$var$table_fmt[fmtid])) {
                    p.v = $b8f343bf88dacc48$var$numdate(p.v + (date1904 ? 1462 : 0));
                    p.t = typeof p.v == "number" ? 'n' : 'd';
                }
                if (tag.cm && opts.xlmeta) {
                    var cm = (opts.xlmeta.Cell || [])[+tag.cm - 1];
                    if (cm && cm.type == 'XLDAPR') p.D = true;
                }
                var _r;
                if (opts.nodim) {
                    _r = $b8f343bf88dacc48$var$decode_cell(tag.r);
                    if (guess.s.r > _r.r) guess.s.r = _r.r;
                    if (guess.e.r < _r.r) guess.e.r = _r.r;
                }
                if (dense) {
                    _r = $b8f343bf88dacc48$var$decode_cell(tag.r);
                    if (!s["!data"][_r.r]) s["!data"][_r.r] = [];
                    s["!data"][_r.r][_r.c] = p;
                } else s[tag.r] = p;
            }
        }
        if (rows.length > 0) s['!rows'] = rows;
    };
}();
function $b8f343bf88dacc48$var$write_ws_xml_data(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/  /*::, rels*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [], r /*:Array<string>*/  = [], range = $b8f343bf88dacc48$var$safe_decode_range(ws['!ref']), cell = "", ref, rr = "", cols /*:Array<string>*/  = [], R = 0, C = 0, rows = ws['!rows'];
    var dense = ws["!data"] != null;
    var params = {
        r: rr
    } /*:any*/ , row /*:RowInfo*/ , height = -1;
    var date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
    for(C = range.s.c; C <= range.e.c; ++C)cols[C] = $b8f343bf88dacc48$var$encode_col(C);
    for(R = range.s.r; R <= range.e.r; ++R){
        r = [];
        rr = $b8f343bf88dacc48$var$encode_row(R);
        for(C = range.s.c; C <= range.e.c; ++C){
            ref = cols[C] + rr;
            var _cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
            if (_cell === undefined) continue;
            if ((cell = $b8f343bf88dacc48$var$write_ws_xml_cell(_cell, ref, ws, opts, idx, wb, date1904)) != null) r.push(cell);
        }
        if (r.length > 0 || rows && rows[R]) {
            params = {
                r: rr
            } /*:any*/ ;
            if (rows && rows[R]) {
                row = rows[R];
                if (row.hidden) params.hidden = 1;
                height = -1;
                if (row.hpx) height = $b8f343bf88dacc48$var$px2pt(row.hpx);
                else if (row.hpt) height = row.hpt;
                if (height > -1) {
                    params.ht = height;
                    params.customHeight = 1;
                }
                if (row.level) params.outlineLevel = row.level;
            }
            o[o.length] = $b8f343bf88dacc48$var$writextag('row', r.join(""), params);
        }
    }
    if (rows) {
        for(; R < rows.length; ++R)if (rows && rows[R]) {
            params = {
                r: R + 1
            } /*:any*/ ;
            row = rows[R];
            if (row.hidden) params.hidden = 1;
            height = -1;
            if (row.hpx) height = $b8f343bf88dacc48$var$px2pt(row.hpx);
            else if (row.hpt) height = row.hpt;
            if (height > -1) {
                params.ht = height;
                params.customHeight = 1;
            }
            if (row.level) params.outlineLevel = row.level;
            o[o.length] = $b8f343bf88dacc48$var$writextag('row', "", params);
        }
    }
    return o.join("");
}
function $b8f343bf88dacc48$var$write_ws_xml(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) /*:string*/ {
    var o = [
        $b8f343bf88dacc48$var$XML_HEADER,
        $b8f343bf88dacc48$var$writextag('worksheet', null, {
            'xmlns': $b8f343bf88dacc48$var$XMLNS_main[0],
            'xmlns:r': $b8f343bf88dacc48$var$XMLNS.r
        })
    ];
    var s = wb.SheetNames[idx], sidx = 0, rdata = "";
    var ws = wb.Sheets[s];
    if (ws == null) ws = {};
    var ref = ws['!ref'] || 'A1';
    var range = $b8f343bf88dacc48$var$safe_decode_range(ref);
    if (range.e.c > 0x3FFF || range.e.r > 0xFFFFF) {
        if (opts.WTF) throw new Error("Range " + ref + " exceeds format limit A1:XFD1048576");
        range.e.c = Math.min(range.e.c, 0x3FFF);
        range.e.r = Math.min(range.e.c, 0xFFFFF);
        ref = $b8f343bf88dacc48$var$encode_range(range);
    }
    if (!rels) rels = {};
    ws['!comments'] = [];
    var _drawing = [];
    $b8f343bf88dacc48$var$write_ws_xml_sheetpr(ws, wb, idx, opts, o);
    o[o.length] = $b8f343bf88dacc48$var$writextag('dimension', null, {
        'ref': ref
    });
    o[o.length] = $b8f343bf88dacc48$var$write_ws_xml_sheetviews(ws, opts, idx, wb);
    /* TODO: store in WB, process styles */ if (opts.sheetFormat) o[o.length] = $b8f343bf88dacc48$var$writextag('sheetFormatPr', null, {
        defaultRowHeight: opts.sheetFormat.defaultRowHeight || '16',
        baseColWidth: opts.sheetFormat.baseColWidth || '10',
        outlineLevelRow: opts.sheetFormat.outlineLevelRow || '7'
    });
    if (ws['!cols'] != null && ws['!cols'].length > 0) o[o.length] = $b8f343bf88dacc48$var$write_ws_xml_cols(ws, ws['!cols']);
    o[sidx = o.length] = '<sheetData/>';
    ws['!links'] = [];
    if (ws['!ref'] != null) {
        rdata = $b8f343bf88dacc48$var$write_ws_xml_data(ws, opts, idx, wb, rels);
        if (rdata.length > 0) o[o.length] = rdata;
    }
    if (o.length > sidx + 1) {
        o[o.length] = '</sheetData>';
        o[sidx] = o[sidx].replace("/>", ">");
    }
    /* sheetCalcPr */ if (ws['!protect']) o[o.length] = $b8f343bf88dacc48$var$write_ws_xml_protection(ws['!protect']);
    /* protectedRanges */ /* scenarios */ if (ws['!autofilter'] != null) o[o.length] = $b8f343bf88dacc48$var$write_ws_xml_autofilter(ws['!autofilter'], ws, wb, idx);
    /* sortState */ /* dataConsolidate */ /* customSheetViews */ if (ws['!merges'] != null && ws['!merges'].length > 0) o[o.length] = $b8f343bf88dacc48$var$write_ws_xml_merges(ws['!merges']);
    /* phoneticPr */ /* conditionalFormatting */ /* dataValidations */ var relc = -1, rel, rId = -1;
    if (/*::(*/ ws['!links']/*::||[])*/ .length > 0) {
        o[o.length] = "<hyperlinks>";
        /*::(*/ ws['!links']/*::||[])*/ .forEach(function(l) {
            if (!l[1].Target) return;
            rel = {
                "ref": l[0]
            } /*:any*/ ;
            if (l[1].Target.charAt(0) != "#") {
                rId = $b8f343bf88dacc48$var$add_rels(rels, -1, $b8f343bf88dacc48$var$escapexml(l[1].Target).replace(/#[\s\S]*$/, ""), $b8f343bf88dacc48$var$RELS.HLINK);
                rel["r:id"] = "rId" + rId;
            }
            if ((relc = l[1].Target.indexOf("#")) > -1) rel.location = $b8f343bf88dacc48$var$escapexml(l[1].Target.slice(relc + 1));
            if (l[1].Tooltip) rel.tooltip = $b8f343bf88dacc48$var$escapexml(l[1].Tooltip);
            rel.display = l[1].display;
            o[o.length] = $b8f343bf88dacc48$var$writextag("hyperlink", null, rel);
        });
        o[o.length] = "</hyperlinks>";
    }
    delete ws['!links'];
    /* printOptions */ if (ws['!margins'] != null) o[o.length] = $b8f343bf88dacc48$var$write_ws_xml_margins(ws['!margins']);
    /* pageSetup */ /* headerFooter */ /* rowBreaks */ /* colBreaks */ /* customProperties */ /* cellWatches */ if (!opts || opts.ignoreEC || opts.ignoreEC == void 0) o[o.length] = $b8f343bf88dacc48$var$writetag("ignoredErrors", $b8f343bf88dacc48$var$writextag("ignoredError", null, {
        numberStoredAsText: 1,
        sqref: ref
    }));
    /* smartTags */ if (_drawing.length > 0) {
        rId = $b8f343bf88dacc48$var$add_rels(rels, -1, "../drawings/drawing" + (idx + 1) + ".xml", $b8f343bf88dacc48$var$RELS.DRAW);
        o[o.length] = $b8f343bf88dacc48$var$writextag("drawing", null, {
            "r:id": "rId" + rId
        });
        ws['!drawing'] = _drawing;
    }
    if (ws['!comments'].length > 0) {
        rId = $b8f343bf88dacc48$var$add_rels(rels, -1, "../drawings/vmlDrawing" + (idx + 1) + ".vml", $b8f343bf88dacc48$var$RELS.VML);
        o[o.length] = $b8f343bf88dacc48$var$writextag("legacyDrawing", null, {
            "r:id": "rId" + rId
        });
        ws['!legacy'] = rId;
    }
    /* legacyDrawingHF */ /* picture */ /* oleObjects */ /* controls */ /* webPublishItems */ /* tableParts */ /* extLst */ if (o.length > 1) {
        o[o.length] = '</worksheet>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.726 BrtRowHdr */ function $b8f343bf88dacc48$var$parse_BrtRowHdr(data, length) {
    var z = {} /*:any*/ ;
    var tgt = data.l + length;
    z.r = data.read_shift(4);
    data.l += 4; // TODO: ixfe
    var miyRw = data.read_shift(2);
    data.l += 1; // TODO: top/bot padding
    var flags = data.read_shift(1);
    data.l = tgt;
    if (flags & 0x07) z.level = flags & 0x07;
    if (flags & 0x10) z.hidden = true;
    if (flags & 0x20) z.hpt = miyRw / 20;
    return z;
}
function $b8f343bf88dacc48$var$write_BrtRowHdr(R /*:number*/ , range, ws) {
    var o = $b8f343bf88dacc48$var$new_buf(145);
    var row = (ws['!rows'] || [])[R] || {};
    o.write_shift(4, R);
    o.write_shift(4, 0); /* TODO: ixfe */ 
    var miyRw = 0x0140;
    if (row.hpx) miyRw = $b8f343bf88dacc48$var$px2pt(row.hpx) * 20;
    else if (row.hpt) miyRw = row.hpt * 20;
    o.write_shift(2, miyRw);
    o.write_shift(1, 0); /* top/bot padding */ 
    var flags = 0x0;
    if (row.level) flags |= row.level;
    if (row.hidden) flags |= 0x10;
    if (row.hpx || row.hpt) flags |= 0x20;
    o.write_shift(1, flags);
    o.write_shift(1, 0); /* phonetic guide */ 
    /* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */ var ncolspan = 0, lcs = o.l;
    o.l += 4;
    var caddr = {
        r: R,
        c: 0
    };
    var dense = ws["!data"] != null;
    for(var i = 0; i < 16; ++i){
        if (range.s.c > i + 1 << 10 || range.e.c < i << 10) continue;
        var first = -1, last = -1;
        for(var j = i << 10; j < i + 1 << 10; ++j){
            caddr.c = j;
            var cell = dense ? (ws["!data"][caddr.r] || [])[caddr.c] : ws[$b8f343bf88dacc48$var$encode_cell(caddr)];
            if (cell) {
                if (first < 0) first = j;
                last = j;
            }
        }
        if (first < 0) continue;
        ++ncolspan;
        o.write_shift(4, first);
        o.write_shift(4, last);
    }
    var l = o.l;
    o.l = lcs;
    o.write_shift(4, ncolspan);
    o.l = l;
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $b8f343bf88dacc48$var$write_row_header(ba, ws, range, R) {
    var o = $b8f343bf88dacc48$var$write_BrtRowHdr(R, range, ws);
    if (o.length > 17 || (ws['!rows'] || [])[R]) $b8f343bf88dacc48$var$write_record(ba, 0x0000 /* BrtRowHdr */ , o);
}
/* [MS-XLSB] 2.4.820 BrtWsDim */ var $b8f343bf88dacc48$var$parse_BrtWsDim = $b8f343bf88dacc48$var$parse_UncheckedRfX;
var $b8f343bf88dacc48$var$write_BrtWsDim = $b8f343bf88dacc48$var$write_UncheckedRfX;
/* [MS-XLSB] 2.4.821 BrtWsFmtInfo */ function $b8f343bf88dacc48$var$parse_BrtWsFmtInfo() {}
//function write_BrtWsFmtInfo(ws, o) { }
/* [MS-XLSB] 2.4.823 BrtWsProp */ function $b8f343bf88dacc48$var$parse_BrtWsProp(data, length) {
    var z = {};
    var f = data[data.l];
    ++data.l;
    z.above = !(f & 0x40);
    z.left = !(f & 0x80);
    /* TODO: pull flags */ data.l += 18;
    z.name = $b8f343bf88dacc48$var$parse_XLSBCodeName(data, length - 19);
    return z;
}
function $b8f343bf88dacc48$var$write_BrtWsProp(str, outl, o) {
    if (o == null) o = $b8f343bf88dacc48$var$new_buf(84 + 4 * str.length);
    var f = 0xC0;
    if (outl) {
        if (outl.above) f &= -65;
        if (outl.left) f &= -129;
    }
    o.write_shift(1, f);
    for(var i = 1; i < 3; ++i)o.write_shift(1, 0);
    $b8f343bf88dacc48$var$write_BrtColor({
        auto: 1
    }, o);
    o.write_shift(-4, -1);
    o.write_shift(-4, -1);
    $b8f343bf88dacc48$var$write_XLSBCodeName(str, o);
    return o.slice(0, o.l);
}
/* [MS-XLSB] 2.4.306 BrtCellBlank */ function $b8f343bf88dacc48$var$parse_BrtCellBlank(data) {
    var cell = $b8f343bf88dacc48$var$parse_XLSBCell(data);
    return [
        cell
    ];
}
function $b8f343bf88dacc48$var$write_BrtCellBlank(cell, ncell, o) {
    if (o == null) o = $b8f343bf88dacc48$var$new_buf(8);
    return $b8f343bf88dacc48$var$write_XLSBCell(ncell, o);
}
function $b8f343bf88dacc48$var$parse_BrtShortBlank(data) {
    var cell = $b8f343bf88dacc48$var$parse_XLSBShortCell(data);
    return [
        cell
    ];
}
function $b8f343bf88dacc48$var$write_BrtShortBlank(cell, ncell, o) {
    if (o == null) o = $b8f343bf88dacc48$var$new_buf(4);
    return $b8f343bf88dacc48$var$write_XLSBShortCell(ncell, o);
}
/* [MS-XLSB] 2.4.307 BrtCellBool */ function $b8f343bf88dacc48$var$parse_BrtCellBool(data) {
    var cell = $b8f343bf88dacc48$var$parse_XLSBCell(data);
    var fBool = data.read_shift(1);
    return [
        cell,
        fBool,
        'b'
    ];
}
function $b8f343bf88dacc48$var$write_BrtCellBool(cell, ncell, o) {
    if (o == null) o = $b8f343bf88dacc48$var$new_buf(9);
    $b8f343bf88dacc48$var$write_XLSBCell(ncell, o);
    o.write_shift(1, cell.v ? 1 : 0);
    return o;
}
function $b8f343bf88dacc48$var$parse_BrtShortBool(data) {
    var cell = $b8f343bf88dacc48$var$parse_XLSBShortCell(data);
    var fBool = data.read_shift(1);
    return [
        cell,
        fBool,
        'b'
    ];
}
function $b8f343bf88dacc48$var$write_BrtShortBool(cell, ncell, o) {
    if (o == null) o = $b8f343bf88dacc48$var$new_buf(5);
    $b8f343bf88dacc48$var$write_XLSBShortCell(ncell, o);
    o.write_shift(1, cell.v ? 1 : 0);
    return o;
}
/* [MS-XLSB] 2.4.308 BrtCellError */ function $b8f343bf88dacc48$var$parse_BrtCellError(data) {
    var cell = $b8f343bf88dacc48$var$parse_XLSBCell(data);
    var bError = data.read_shift(1);
    return [
        cell,
        bError,
        'e'
    ];
}
function $b8f343bf88dacc48$var$write_BrtCellError(cell, ncell, o) {
    if (o == null) o = $b8f343bf88dacc48$var$new_buf(9);
    $b8f343bf88dacc48$var$write_XLSBCell(ncell, o);
    o.write_shift(1, cell.v);
    return o;
}
function $b8f343bf88dacc48$var$parse_BrtShortError(data) {
    var cell = $b8f343bf88dacc48$var$parse_XLSBShortCell(data);
    var bError = data.read_shift(1);
    return [
        cell,
        bError,
        'e'
    ];
}
function $b8f343bf88dacc48$var$write_BrtShortError(cell, ncell, o) {
    if (o == null) o = $b8f343bf88dacc48$var$new_buf(8);
    $b8f343bf88dacc48$var$write_XLSBShortCell(ncell, o);
    o.write_shift(1, cell.v);
    o.write_shift(2, 0);
    o.write_shift(1, 0);
    return o;
}
/* [MS-XLSB] 2.4.311 BrtCellIsst */ function $b8f343bf88dacc48$var$parse_BrtCellIsst(data) {
    var cell = $b8f343bf88dacc48$var$parse_XLSBCell(data);
    var isst = data.read_shift(4);
    return [
        cell,
        isst,
        's'
    ];
}
function $b8f343bf88dacc48$var$write_BrtCellIsst(cell, ncell, o) {
    if (o == null) o = $b8f343bf88dacc48$var$new_buf(12);
    $b8f343bf88dacc48$var$write_XLSBCell(ncell, o);
    o.write_shift(4, ncell.v);
    return o;
}
function $b8f343bf88dacc48$var$parse_BrtShortIsst(data) {
    var cell = $b8f343bf88dacc48$var$parse_XLSBShortCell(data);
    var isst = data.read_shift(4);
    return [
        cell,
        isst,
        's'
    ];
}
function $b8f343bf88dacc48$var$write_BrtShortIsst(cell, ncell, o) {
    if (o == null) o = $b8f343bf88dacc48$var$new_buf(8);
    $b8f343bf88dacc48$var$write_XLSBShortCell(ncell, o);
    o.write_shift(4, ncell.v);
    return o;
}
/* [MS-XLSB] 2.4.313 BrtCellReal */ function $b8f343bf88dacc48$var$parse_BrtCellReal(data) {
    var cell = $b8f343bf88dacc48$var$parse_XLSBCell(data);
    var value = $b8f343bf88dacc48$var$parse_Xnum(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $b8f343bf88dacc48$var$write_BrtCellReal(cell, ncell, o) {
    if (o == null) o = $b8f343bf88dacc48$var$new_buf(16);
    $b8f343bf88dacc48$var$write_XLSBCell(ncell, o);
    $b8f343bf88dacc48$var$write_Xnum(cell.v, o);
    return o;
}
function $b8f343bf88dacc48$var$parse_BrtShortReal(data) {
    var cell = $b8f343bf88dacc48$var$parse_XLSBShortCell(data);
    var value = $b8f343bf88dacc48$var$parse_Xnum(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $b8f343bf88dacc48$var$write_BrtShortReal(cell, ncell, o) {
    if (o == null) o = $b8f343bf88dacc48$var$new_buf(12);
    $b8f343bf88dacc48$var$write_XLSBShortCell(ncell, o);
    $b8f343bf88dacc48$var$write_Xnum(cell.v, o);
    return o;
}
/* [MS-XLSB] 2.4.314 BrtCellRk */ function $b8f343bf88dacc48$var$parse_BrtCellRk(data) {
    var cell = $b8f343bf88dacc48$var$parse_XLSBCell(data);
    var value = $b8f343bf88dacc48$var$parse_RkNumber(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $b8f343bf88dacc48$var$write_BrtCellRk(cell, ncell, o) {
    if (o == null) o = $b8f343bf88dacc48$var$new_buf(12);
    $b8f343bf88dacc48$var$write_XLSBCell(ncell, o);
    $b8f343bf88dacc48$var$write_RkNumber(cell.v, o);
    return o;
}
function $b8f343bf88dacc48$var$parse_BrtShortRk(data) {
    var cell = $b8f343bf88dacc48$var$parse_XLSBShortCell(data);
    var value = $b8f343bf88dacc48$var$parse_RkNumber(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $b8f343bf88dacc48$var$write_BrtShortRk(cell, ncell, o) {
    if (o == null) o = $b8f343bf88dacc48$var$new_buf(8);
    $b8f343bf88dacc48$var$write_XLSBShortCell(ncell, o);
    $b8f343bf88dacc48$var$write_RkNumber(cell.v, o);
    return o;
}
/* [MS-XLSB] 2.4.323 BrtCellRString */ function $b8f343bf88dacc48$var$parse_BrtCellRString(data) {
    var cell = $b8f343bf88dacc48$var$parse_XLSBCell(data);
    var value = $b8f343bf88dacc48$var$parse_RichStr(data);
    return [
        cell,
        value,
        'is'
    ];
}
/* [MS-XLSB] 2.4.317 BrtCellSt */ function $b8f343bf88dacc48$var$parse_BrtCellSt(data) {
    var cell = $b8f343bf88dacc48$var$parse_XLSBCell(data);
    var value = $b8f343bf88dacc48$var$parse_XLWideString(data);
    return [
        cell,
        value,
        'str'
    ];
}
function $b8f343bf88dacc48$var$write_BrtCellSt(cell, ncell, o) {
    var data = cell.v == null ? "" : String(cell.v);
    if (o == null) o = $b8f343bf88dacc48$var$new_buf(12 + 4 * cell.v.length);
    $b8f343bf88dacc48$var$write_XLSBCell(ncell, o);
    $b8f343bf88dacc48$var$write_XLWideString(data, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $b8f343bf88dacc48$var$parse_BrtShortSt(data) {
    var cell = $b8f343bf88dacc48$var$parse_XLSBShortCell(data);
    var value = $b8f343bf88dacc48$var$parse_XLWideString(data);
    return [
        cell,
        value,
        'str'
    ];
}
function $b8f343bf88dacc48$var$write_BrtShortSt(cell, ncell, o) {
    var data = cell.v == null ? "" : String(cell.v);
    if (o == null) o = $b8f343bf88dacc48$var$new_buf(8 + 4 * data.length);
    $b8f343bf88dacc48$var$write_XLSBShortCell(ncell, o);
    $b8f343bf88dacc48$var$write_XLWideString(data, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.653 BrtFmlaBool */ function $b8f343bf88dacc48$var$parse_BrtFmlaBool(data, length, opts) {
    var end = data.l + length;
    var cell = $b8f343bf88dacc48$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = data.read_shift(1);
    var o = [
        cell,
        value,
        'b'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $b8f343bf88dacc48$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $b8f343bf88dacc48$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.654 BrtFmlaError */ function $b8f343bf88dacc48$var$parse_BrtFmlaError(data, length, opts) {
    var end = data.l + length;
    var cell = $b8f343bf88dacc48$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = data.read_shift(1);
    var o = [
        cell,
        value,
        'e'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $b8f343bf88dacc48$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $b8f343bf88dacc48$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.655 BrtFmlaNum */ function $b8f343bf88dacc48$var$parse_BrtFmlaNum(data, length, opts) {
    var end = data.l + length;
    var cell = $b8f343bf88dacc48$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = $b8f343bf88dacc48$var$parse_Xnum(data);
    var o = [
        cell,
        value,
        'n'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $b8f343bf88dacc48$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $b8f343bf88dacc48$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.656 BrtFmlaString */ function $b8f343bf88dacc48$var$parse_BrtFmlaString(data, length, opts) {
    var end = data.l + length;
    var cell = $b8f343bf88dacc48$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = $b8f343bf88dacc48$var$parse_XLWideString(data);
    var o = [
        cell,
        value,
        'str'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $b8f343bf88dacc48$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $b8f343bf88dacc48$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.682 BrtMergeCell */ var $b8f343bf88dacc48$var$parse_BrtMergeCell = $b8f343bf88dacc48$var$parse_UncheckedRfX;
var $b8f343bf88dacc48$var$write_BrtMergeCell = $b8f343bf88dacc48$var$write_UncheckedRfX;
/* [MS-XLSB] 2.4.107 BrtBeginMergeCells */ function $b8f343bf88dacc48$var$write_BrtBeginMergeCells(cnt, o) {
    if (o == null) o = $b8f343bf88dacc48$var$new_buf(4);
    o.write_shift(4, cnt);
    return o;
}
/* [MS-XLSB] 2.4.662 BrtHLink */ function $b8f343bf88dacc48$var$parse_BrtHLink(data, length /*::, opts*/ ) {
    var end = data.l + length;
    var rfx = $b8f343bf88dacc48$var$parse_UncheckedRfX(data, 16);
    var relId = $b8f343bf88dacc48$var$parse_XLNullableWideString(data);
    var loc = $b8f343bf88dacc48$var$parse_XLWideString(data);
    var tooltip = $b8f343bf88dacc48$var$parse_XLWideString(data);
    var display = $b8f343bf88dacc48$var$parse_XLWideString(data);
    data.l = end;
    var o = {
        rfx: rfx,
        relId: relId,
        loc: loc,
        display: display
    } /*:any*/ ;
    if (tooltip) o.Tooltip = tooltip;
    return o;
}
function $b8f343bf88dacc48$var$write_BrtHLink(l, rId) {
    var o = $b8f343bf88dacc48$var$new_buf(50 + 4 * (l[1].Target.length + (l[1].Tooltip || "").length));
    $b8f343bf88dacc48$var$write_UncheckedRfX({
        s: $b8f343bf88dacc48$var$decode_cell(l[0]),
        e: $b8f343bf88dacc48$var$decode_cell(l[0])
    }, o);
    $b8f343bf88dacc48$var$write_RelID("rId" + rId, o);
    var locidx = l[1].Target.indexOf("#");
    var loc = locidx == -1 ? "" : l[1].Target.slice(locidx + 1);
    $b8f343bf88dacc48$var$write_XLWideString(loc || "", o);
    $b8f343bf88dacc48$var$write_XLWideString(l[1].Tooltip || "", o);
    $b8f343bf88dacc48$var$write_XLWideString("", o);
    return o.slice(0, o.l);
}
/* [MS-XLSB] 2.4.692 BrtPane */ function $b8f343bf88dacc48$var$parse_BrtPane() {}
/* [MS-XLSB] 2.4.6 BrtArrFmla */ function $b8f343bf88dacc48$var$parse_BrtArrFmla(data, length, opts) {
    var end = data.l + length;
    var rfx = $b8f343bf88dacc48$var$parse_RfX(data, 16);
    var fAlwaysCalc = data.read_shift(1);
    var o = [
        rfx
    ];
    o[2] = fAlwaysCalc;
    if (opts.cellFormula) {
        var formula = $b8f343bf88dacc48$var$parse_XLSBArrayParsedFormula(data, end - data.l, opts);
        o[1] = formula;
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.750 BrtShrFmla */ function $b8f343bf88dacc48$var$parse_BrtShrFmla(data, length, opts) {
    var end = data.l + length;
    var rfx = $b8f343bf88dacc48$var$parse_UncheckedRfX(data, 16);
    var o = [
        rfx
    ];
    if (opts.cellFormula) {
        var formula = $b8f343bf88dacc48$var$parse_XLSBSharedParsedFormula(data, end - data.l, opts);
        o[1] = formula;
        data.l = end;
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.323 BrtColInfo */ /* TODO: once XLS ColInfo is set, combine the functions */ function $b8f343bf88dacc48$var$write_BrtColInfo(C /*:number*/ , col, o) {
    if (o == null) o = $b8f343bf88dacc48$var$new_buf(18);
    var p = $b8f343bf88dacc48$var$col_obj_w(C, col);
    o.write_shift(-4, C);
    o.write_shift(-4, C);
    o.write_shift(4, (p.width || 10) * 256);
    o.write_shift(4, 0 /*ixfe*/ ); // style
    var flags = 0;
    if (col.hidden) flags |= 0x01;
    if (typeof p.width == 'number') flags |= 0x02;
    if (col.level) flags |= col.level << 8;
    o.write_shift(2, flags); // bit flag
    return o;
}
/* [MS-XLSB] 2.4.678 BrtMargins */ var $b8f343bf88dacc48$var$BrtMarginKeys = [
    "left",
    "right",
    "top",
    "bottom",
    "header",
    "footer"
];
function $b8f343bf88dacc48$var$parse_BrtMargins(data /*::, length, opts*/ ) /*:Margins*/ {
    var margins = {} /*:any*/ ;
    $b8f343bf88dacc48$var$BrtMarginKeys.forEach(function(k) {
        margins[k] = $b8f343bf88dacc48$var$parse_Xnum(data, 8);
    });
    return margins;
}
function $b8f343bf88dacc48$var$write_BrtMargins(margins /*:Margins*/ , o) {
    if (o == null) o = $b8f343bf88dacc48$var$new_buf(48);
    $b8f343bf88dacc48$var$default_margins(margins);
    $b8f343bf88dacc48$var$BrtMarginKeys.forEach(function(k) {
        $b8f343bf88dacc48$var$write_Xnum(margins /*:any*/ [k], o);
    });
    return o;
}
/* [MS-XLSB] 2.4.299 BrtBeginWsView */ function $b8f343bf88dacc48$var$parse_BrtBeginWsView(data /*::, length, opts*/ ) {
    var f = data.read_shift(2);
    data.l += 28;
    return {
        RTL: f & 0x20
    };
}
function $b8f343bf88dacc48$var$write_BrtBeginWsView(ws, Workbook, o) {
    if (o == null) o = $b8f343bf88dacc48$var$new_buf(30);
    var f = 0x39c;
    if ((((Workbook || {}).Views || [])[0] || {}).RTL) f |= 0x20;
    o.write_shift(2, f); // bit flag
    o.write_shift(4, 0);
    o.write_shift(4, 0); // view first row
    o.write_shift(4, 0); // view first col
    o.write_shift(1, 0); // gridline color ICV
    o.write_shift(1, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 100); // zoom scale
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(4, 0); // workbook view id
    return o;
}
/* [MS-XLSB] 2.4.309 BrtCellIgnoreEC */ function $b8f343bf88dacc48$var$write_BrtCellIgnoreEC(ref) {
    var o = $b8f343bf88dacc48$var$new_buf(24);
    o.write_shift(4, 4);
    o.write_shift(4, 1);
    $b8f343bf88dacc48$var$write_UncheckedRfX(ref, o);
    return o;
}
/* [MS-XLSB] 2.4.748 BrtSheetProtection */ function $b8f343bf88dacc48$var$write_BrtSheetProtection(sp, o) {
    if (o == null) o = $b8f343bf88dacc48$var$new_buf(66);
    o.write_shift(2, sp.password ? $b8f343bf88dacc48$var$crypto_CreatePasswordVerifier_Method1(sp.password) : 0);
    o.write_shift(4, 1); // this record should not be written if no protection
    [
        [
            "objects",
            false
        ],
        [
            "scenarios",
            false
        ],
        [
            "formatCells",
            true
        ],
        [
            "formatColumns",
            true
        ],
        [
            "formatRows",
            true
        ],
        [
            "insertColumns",
            true
        ],
        [
            "insertRows",
            true
        ],
        [
            "insertHyperlinks",
            true
        ],
        [
            "deleteColumns",
            true
        ],
        [
            "deleteRows",
            true
        ],
        [
            "selectLockedCells",
            false
        ],
        [
            "sort",
            true
        ],
        [
            "autoFilter",
            true
        ],
        [
            "pivotTables",
            true
        ],
        [
            "selectUnlockedCells",
            false
        ] // fSelUnlockedCells
    ].forEach(function(n) {
        /*:: if(o == null) throw "unreachable"; */ if (n[1]) o.write_shift(4, sp[n[0]] != null && !sp[n[0]] ? 1 : 0);
        else o.write_shift(4, sp[n[0]] != null && sp[n[0]] ? 0 : 1);
    });
    return o;
}
function $b8f343bf88dacc48$var$parse_BrtDVal() {}
function $b8f343bf88dacc48$var$parse_BrtDVal14() {}
/* [MS-XLSB] 2.1.7.61 Worksheet */ function $b8f343bf88dacc48$var$parse_ws_bin(data, _opts, idx, rels, wb /*:WBWBProps*/ , themes, styles) /*:Worksheet*/ {
    if (!data) return data;
    var opts = _opts || {};
    if (!rels) rels = {
        '!id': {}
    };
    if ($b8f343bf88dacc48$var$DENSE != null && opts.dense == null) opts.dense = $b8f343bf88dacc48$var$DENSE;
    var s /*:Worksheet*/  = {};
    if (opts.dense) s["!data"] = [];
    var ref;
    var refguess = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var state /*:Array<string>*/  = [];
    var pass = false, end = false;
    var row, p, cf, R, C, addr, sstr, rr, cell /*:Cell*/ ;
    var merges /*:Array<Range>*/  = [];
    opts.biff = 12;
    opts['!row'] = 0;
    var ai = 0, af = false;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var sharedf = {};
    var supbooks = opts.supbooks || /*::(*/ wb /*:: :any)*/ .supbooks || [
        []
    ];
    supbooks.sharedf = sharedf;
    supbooks.arrayf = arrayf;
    supbooks.SheetNames = wb.SheetNames || wb.Sheets.map(function(x) {
        return x.name;
    });
    if (!opts.supbooks) {
        opts.supbooks = supbooks;
        if (wb.Names) for(var i = 0; i < wb.Names.length; ++i)supbooks[0][i + 1] = wb.Names[i];
    }
    var colinfo /*:Array<ColInfo>*/  = [], rowinfo /*:Array<RowInfo>*/  = [];
    var seencol = false;
    $b8f343bf88dacc48$var$XLSBRecordEnum[0x0010] = {
        n: "BrtShortReal",
        f: $b8f343bf88dacc48$var$parse_BrtShortReal
    };
    var cm, vm;
    var date1904 = 1462 * +!!((wb || {}).WBProps || {}).date1904;
    $b8f343bf88dacc48$var$recordhopper(data, function ws_parse(val, RR, RT) {
        if (end) return;
        switch(RT){
            case 0x0094:
                /* 'BrtWsDim' */ ref = val;
                break;
            case 0x0000:
                /* 'BrtRowHdr' */ row = val;
                if (opts.sheetRows && opts.sheetRows <= row.r) end = true;
                rr = $b8f343bf88dacc48$var$encode_row(R = row.r);
                opts['!row'] = row.r;
                if (val.hidden || val.hpt || val.level != null) {
                    if (val.hpt) val.hpx = $b8f343bf88dacc48$var$pt2px(val.hpt);
                    rowinfo[val.r] = val;
                }
                break;
            case 0x0002:
            /* 'BrtCellRk' */ case 0x0003:
            /* 'BrtCellError' */ case 0x0004:
            /* 'BrtCellBool' */ case 0x0005:
            /* 'BrtCellReal' */ case 0x0006:
            /* 'BrtCellSt' */ case 0x0007:
            /* 'BrtCellIsst' */ case 0x0008:
            /* 'BrtFmlaString' */ case 0x0009:
            /* 'BrtFmlaNum' */ case 0x000A:
            /* 'BrtFmlaBool' */ case 0x000B:
            /* 'BrtFmlaError' */ case 0x000D:
            /* 'BrtShortRk' */ case 0x000E:
            /* 'BrtShortError' */ case 0x000F:
            /* 'BrtShortBool' */ case 0x0010:
            /* 'BrtShortReal' */ case 0x0011:
            /* 'BrtShortSt' */ case 0x0012:
            /* 'BrtShortIsst' */ case 0x003E:
                /* 'BrtCellRString' */ p = {
                    t: val[2]
                } /*:any*/ ;
                switch(val[2]){
                    case 'n':
                        p.v = val[1];
                        break;
                    case 's':
                        sstr = $b8f343bf88dacc48$var$strs[val[1]];
                        p.v = sstr.t;
                        p.r = sstr.r;
                        break;
                    case 'b':
                        p.v = val[1] ? true : false;
                        break;
                    case 'e':
                        p.v = val[1];
                        if (opts.cellText !== false) p.w = $b8f343bf88dacc48$var$BErr[p.v];
                        break;
                    case 'str':
                        p.t = 's';
                        p.v = val[1];
                        break;
                    case 'is':
                        p.t = 's';
                        p.v = val[1].t;
                        break;
                }
                if (cf = styles.CellXf[val[0].iStyleRef]) $b8f343bf88dacc48$var$safe_format(p, cf.numFmtId, null, opts, themes, styles, date1904 > 0);
                C = val[0].c == -1 ? C + 1 : val[0].c;
                if (opts.dense) {
                    if (!s["!data"][R]) s["!data"][R] = [];
                    s["!data"][R][C] = p;
                } else s[$b8f343bf88dacc48$var$encode_col(C) + rr] = p;
                if (opts.cellFormula) {
                    af = false;
                    for(ai = 0; ai < arrayf.length; ++ai){
                        var aii = arrayf[ai];
                        if (row.r >= aii[0].s.r && row.r <= aii[0].e.r) {
                            if (C >= aii[0].s.c && C <= aii[0].e.c) {
                                p.F = $b8f343bf88dacc48$var$encode_range(aii[0]);
                                af = true;
                            }
                        }
                    }
                    if (!af && val.length > 3) p.f = val[3];
                }
                if (refguess.s.r > row.r) refguess.s.r = row.r;
                if (refguess.s.c > C) refguess.s.c = C;
                if (refguess.e.r < row.r) refguess.e.r = row.r;
                if (refguess.e.c < C) refguess.e.c = C;
                if (opts.cellDates && cf && p.t == 'n' && $b8f343bf88dacc48$var$fmt_is_date($b8f343bf88dacc48$var$table_fmt[cf.numFmtId])) {
                    var _d = $b8f343bf88dacc48$var$SSF_parse_date_code(p.v + date1904);
                    if (_d) {
                        p.t = 'd';
                        p.v = new Date(Date.UTC(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u));
                    }
                }
                if (cm) {
                    if (cm.type == 'XLDAPR') p.D = true;
                    cm = void 0;
                }
                if (vm) vm = void 0;
                break;
            case 0x0001:
            /* 'BrtCellBlank' */ case 0x000C:
                /* 'BrtShortBlank' */ if (!opts.sheetStubs || pass) break;
                p = {
                    t: 'z',
                    v: void 0
                } /*:any*/ ;
                C = val[0].c == -1 ? C + 1 : val[0].c;
                if (opts.dense) {
                    if (!s["!data"][R]) s["!data"][R] = [];
                    s["!data"][R][C] = p;
                } else s[$b8f343bf88dacc48$var$encode_col(C) + rr] = p;
                if (refguess.s.r > row.r) refguess.s.r = row.r;
                if (refguess.s.c > C) refguess.s.c = C;
                if (refguess.e.r < row.r) refguess.e.r = row.r;
                if (refguess.e.c < C) refguess.e.c = C;
                if (cm) {
                    if (cm.type == 'XLDAPR') p.D = true;
                    cm = void 0;
                }
                if (vm) vm = void 0;
                break;
            case 0x00B0:
                /* 'BrtMergeCell' */ merges.push(val);
                break;
            case 0x0031:
                cm = ((opts.xlmeta || {}).Cell || [])[val - 1];
                break;
            case 0x01EE:
                /* 'BrtHLink' */ var rel = rels['!id'][val.relId];
                if (rel) {
                    val.Target = rel.Target;
                    if (val.loc) val.Target += "#" + val.loc;
                    val.Rel = rel;
                } else if (val.relId == '') val.Target = "#" + val.loc;
                for(R = val.rfx.s.r; R <= val.rfx.e.r; ++R)for(C = val.rfx.s.c; C <= val.rfx.e.c; ++C)if (opts.dense) {
                    if (!s["!data"][R]) s["!data"][R] = [];
                    if (!s["!data"][R][C]) s["!data"][R][C] = {
                        t: 'z',
                        v: undefined
                    };
                    s["!data"][R][C].l = val;
                } else {
                    addr = $b8f343bf88dacc48$var$encode_col(C) + $b8f343bf88dacc48$var$encode_row(R);
                    if (!s[addr]) s[addr] = {
                        t: 'z',
                        v: undefined
                    };
                    s[addr].l = val;
                }
                break;
            case 0x01AA:
                /* 'BrtArrFmla' */ if (!opts.cellFormula) break;
                arrayf.push(val);
                cell = opts.dense ? s["!data"][R][C] : s[$b8f343bf88dacc48$var$encode_col(C) + rr];
                cell.f = $b8f343bf88dacc48$var$stringify_formula(val[1], refguess, {
                    r: row.r,
                    c: C
                }, supbooks, opts);
                cell.F = $b8f343bf88dacc48$var$encode_range(val[0]);
                break;
            case 0x01AB:
                /* 'BrtShrFmla' */ if (!opts.cellFormula) break;
                sharedf[$b8f343bf88dacc48$var$encode_cell(val[0].s)] = val[1];
                cell = opts.dense ? s["!data"][R][C] : s[$b8f343bf88dacc48$var$encode_col(C) + rr];
                cell.f = $b8f343bf88dacc48$var$stringify_formula(val[1], refguess, {
                    r: row.r,
                    c: C
                }, supbooks, opts);
                break;
            /* identical to 'ColInfo' in XLS */ case 0x003C:
                /* 'BrtColInfo' */ if (!opts.cellStyles) break;
                while(val.e >= val.s){
                    colinfo[val.e--] = {
                        width: val.w / 256,
                        hidden: !!(val.flags & 0x01),
                        level: val.level
                    };
                    if (!seencol) {
                        seencol = true;
                        $b8f343bf88dacc48$var$find_mdw_colw(val.w / 256);
                    }
                    $b8f343bf88dacc48$var$process_col(colinfo[val.e + 1]);
                }
                break;
            case 0x0227:
                /* 'BrtLegacyDrawing' */ if (val) s["!legrel"] = val;
                break;
            case 0x00A1:
                /* 'BrtBeginAFilter' */ s['!autofilter'] = {
                    ref: $b8f343bf88dacc48$var$encode_range(val)
                };
                break;
            case 0x01DC:
                /* 'BrtMargins' */ s['!margins'] = val;
                break;
            case 0x0093:
                /* 'BrtWsProp' */ if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
                if (val.name) wb.Sheets[idx].CodeName = val.name;
                if (val.above || val.left) s['!outline'] = {
                    above: val.above,
                    left: val.left
                };
                break;
            case 0x0089:
                /* 'BrtBeginWsView' */ if (!wb.Views) wb.Views = [
                    {}
                ];
                if (!wb.Views[0]) wb.Views[0] = {};
                if (val.RTL) wb.Views[0].RTL = true;
                break;
            case 0x01E5:
                break;
            case 0x0040:
            /* 'BrtDVal' */ case 0x041D:
                break;
            case 0x0097:
                break;
            case 0x0098:
            /* 'BrtSel' */ case 0x00AF:
            /* 'BrtAFilterDateGroupItem' */ case 0x0284:
            /* 'BrtActiveX' */ case 0x0271:
            /* 'BrtBigName' */ case 0x0232:
            /* 'BrtBkHim' */ case 0x018C:
            /* 'BrtBrk' */ case 0x0458:
            /* 'BrtCFIcon' */ case 0x047A:
            /* 'BrtCFRuleExt' */ case 0x01D7:
            /* 'BrtCFVO' */ case 0x041A:
            /* 'BrtCFVO14' */ case 0x0289:
            /* 'BrtCellIgnoreEC' */ case 0x0451:
            /* 'BrtCellIgnoreEC14' */ case 0x024D:
            /* 'BrtCellSmartTagProperty' */ case 0x025F:
            /* 'BrtCellWatch' */ case 0x0234:
            /* 'BrtColor' */ case 0x041F:
            /* 'BrtColor14' */ case 0x00A8:
            /* 'BrtColorFilter' */ case 0x00AE:
            /* 'BrtCustomFilter' */ case 0x049C:
            /* 'BrtCustomFilter14' */ case 0x01F3:
            /* 'BrtDRef' */ case 0x01FB:
            /* 'BrtDXF' */ case 0x0226:
            /* 'BrtDrawing' */ case 0x00AB:
            /* 'BrtDynamicFilter' */ case 0x00A7:
            /* 'BrtFilter' */ case 0x0499:
            /* 'BrtFilter14' */ case 0x00A9:
            /* 'BrtIconFilter' */ case 0x049D:
            /* 'BrtIconFilter14' */ case 0x0228:
            /* 'BrtLegacyDrawingHF' */ case 0x0295:
            /* 'BrtListPart' */ case 0x027F:
            /* 'BrtOleObject' */ case 0x01DE:
            /* 'BrtPageSetup' */ case 0x0219:
            /* 'BrtPhoneticInfo' */ case 0x01DD:
            /* 'BrtPrintOptions' */ case 0x0218:
            /* 'BrtRangeProtection' */ case 0x044F:
            /* 'BrtRangeProtection14' */ case 0x02A8:
            /* 'BrtRangeProtectionIso' */ case 0x0450:
            /* 'BrtRangeProtectionIso14' */ case 0x0400:
            /* 'BrtRwDescent' */ case 0x0297:
            /* 'BrtSheetCalcProp' */ case 0x0217:
            /* 'BrtSheetProtection' */ case 0x02A6:
            /* 'BrtSheetProtectionIso' */ case 0x01F8:
            /* 'BrtSlc' */ case 0x0413:
            /* 'BrtSparkline' */ case 0x01AC:
            /* 'BrtTable' */ case 0x00AA:
            /* 'BrtTop10Filter' */ case 0x0C00:
            /* 'BrtUid' */ case 0x0032:
            /* 'BrtValueMeta' */ case 0x0816:
            /* 'BrtWebExtension' */ case 0x0415:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                pass = false;
                break;
            default:
                if (RR.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    delete opts.supbooks;
    delete opts['!row'];
    if (!s["!ref"] && (refguess.s.r < 2000000 || ref && (ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0))) s["!ref"] = $b8f343bf88dacc48$var$encode_range(ref || refguess);
    if (opts.sheetRows && s["!ref"]) {
        var tmpref = $b8f343bf88dacc48$var$safe_decode_range(s["!ref"]);
        if (opts.sheetRows <= +tmpref.e.r) {
            tmpref.e.r = opts.sheetRows - 1;
            if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
            if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
            if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
            if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
            s["!fullref"] = s["!ref"];
            s["!ref"] = $b8f343bf88dacc48$var$encode_range(tmpref);
        }
    }
    if (merges.length > 0) s["!merges"] = merges;
    if (colinfo.length > 0) s["!cols"] = colinfo;
    if (rowinfo.length > 0) s["!rows"] = rowinfo;
    if (rels['!id'][s['!legrel']]) s['!legdrawel'] = rels['!id'][s['!legrel']];
    return s;
}
/* TODO: something useful -- this is a stub */ function $b8f343bf88dacc48$var$write_ws_bin_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, ws /*:Worksheet*/ , last_seen /*:boolean*/ , date1904 /*:boolean*/ ) /*:boolean*/ {
    var o /*:any*/  = {
        r: R,
        c: C
    } /*:any*/ ;
    if (cell.c) ws['!comments'].push([
        $b8f343bf88dacc48$var$encode_cell(o),
        cell.c
    ]);
    if (cell.v === undefined) return false;
    var vv = "";
    switch(cell.t){
        case 'b':
            vv = cell.v ? "1" : "0";
            break;
        case 'd':
            cell = $b8f343bf88dacc48$var$dup(cell);
            cell.z = cell.z || $b8f343bf88dacc48$var$table_fmt[14];
            cell.v = $b8f343bf88dacc48$var$datenum($b8f343bf88dacc48$var$parseDate(cell.v, date1904), date1904);
            cell.t = 'n';
            break;
        /* falls through */ case 'n':
        case 'e':
            vv = '' + cell.v;
            break;
        default:
            vv = cell.v;
            break;
    }
    /* TODO: cell style */ o.s = $b8f343bf88dacc48$var$get_cell_style(opts.cellXfs, cell, opts);
    if (cell.l) ws['!links'].push([
        $b8f343bf88dacc48$var$encode_cell(o),
        cell.l
    ]);
    switch(cell.t){
        case 's':
        case 'str':
            if (opts.bookSST) {
                vv = $b8f343bf88dacc48$var$get_sst_id(opts.Strings, cell.v == null ? "" : String(cell.v), opts.revStrings);
                o.t = "s";
                o.v = vv;
                if (last_seen) $b8f343bf88dacc48$var$write_record(ba, 0x0012 /* BrtShortIsst */ , $b8f343bf88dacc48$var$write_BrtShortIsst(cell, o));
                else $b8f343bf88dacc48$var$write_record(ba, 0x0007 /* BrtCellIsst */ , $b8f343bf88dacc48$var$write_BrtCellIsst(cell, o));
            } else {
                o.t = "str";
                if (last_seen) $b8f343bf88dacc48$var$write_record(ba, 0x0011 /* BrtShortSt */ , $b8f343bf88dacc48$var$write_BrtShortSt(cell, o));
                else $b8f343bf88dacc48$var$write_record(ba, 0x0006 /* BrtCellSt */ , $b8f343bf88dacc48$var$write_BrtCellSt(cell, o));
            }
            return true;
        case 'n':
            /* TODO: determine threshold for Real vs RK */ if (cell.v == (cell.v | 0) && cell.v > -1000 && cell.v < 1000) {
                if (last_seen) $b8f343bf88dacc48$var$write_record(ba, 0x000D /* BrtShortRk */ , $b8f343bf88dacc48$var$write_BrtShortRk(cell, o));
                else $b8f343bf88dacc48$var$write_record(ba, 0x0002 /* BrtCellRk */ , $b8f343bf88dacc48$var$write_BrtCellRk(cell, o));
            } else if (isNaN(cell.v)) {
                if (last_seen) $b8f343bf88dacc48$var$write_record(ba, 0x000E /* BrtShortError */ , $b8f343bf88dacc48$var$write_BrtShortError({
                    t: "e",
                    v: 0x24
                }, o)); // #NUM!
                else $b8f343bf88dacc48$var$write_record(ba, 0x0003 /* BrtCellError */ , $b8f343bf88dacc48$var$write_BrtCellError({
                    t: "e",
                    v: 0x24
                }, o)); // #NUM!
            } else if (!isFinite(cell.v)) {
                if (last_seen) $b8f343bf88dacc48$var$write_record(ba, 0x000E /* BrtShortError */ , $b8f343bf88dacc48$var$write_BrtShortError({
                    t: "e",
                    v: 0x07
                }, o)); // #DIV/0!
                else $b8f343bf88dacc48$var$write_record(ba, 0x0003 /* BrtCellError */ , $b8f343bf88dacc48$var$write_BrtCellError({
                    t: "e",
                    v: 0x07
                }, o)); // #DIV/0!
            } else if (last_seen) $b8f343bf88dacc48$var$write_record(ba, 0x0010 /* BrtShortReal */ , $b8f343bf88dacc48$var$write_BrtShortReal(cell, o));
            else $b8f343bf88dacc48$var$write_record(ba, 0x0005 /* BrtCellReal */ , $b8f343bf88dacc48$var$write_BrtCellReal(cell, o));
            return true;
        case 'b':
            o.t = "b";
            if (last_seen) $b8f343bf88dacc48$var$write_record(ba, 0x000F /* BrtShortBool */ , $b8f343bf88dacc48$var$write_BrtShortBool(cell, o));
            else $b8f343bf88dacc48$var$write_record(ba, 0x0004 /* BrtCellBool */ , $b8f343bf88dacc48$var$write_BrtCellBool(cell, o));
            return true;
        case 'e':
            o.t = "e";
            if (last_seen) $b8f343bf88dacc48$var$write_record(ba, 0x000E /* BrtShortError */ , $b8f343bf88dacc48$var$write_BrtShortError(cell, o));
            else $b8f343bf88dacc48$var$write_record(ba, 0x0003 /* BrtCellError */ , $b8f343bf88dacc48$var$write_BrtCellError(cell, o));
            return true;
    }
    if (last_seen) $b8f343bf88dacc48$var$write_record(ba, 0x000C /* BrtShortBlank */ , $b8f343bf88dacc48$var$write_BrtShortBlank(cell, o));
    else $b8f343bf88dacc48$var$write_record(ba, 0x0001 /* BrtCellBlank */ , $b8f343bf88dacc48$var$write_BrtCellBlank(cell, o));
    return true;
}
function $b8f343bf88dacc48$var$write_CELLTABLE(ba, ws /*:Worksheet*/ , idx /*:number*/ , opts, wb /*:Workbook*/ ) {
    var range = $b8f343bf88dacc48$var$safe_decode_range(ws['!ref'] || "A1"), ref, rr = "", cols /*:Array<string>*/  = [];
    var date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
    $b8f343bf88dacc48$var$write_record(ba, 0x0091 /* BrtBeginSheetData */ );
    var dense = ws["!data"] != null;
    var cap = range.e.r;
    if (ws['!rows']) cap = Math.max(range.e.r, ws['!rows'].length - 1);
    for(var R = range.s.r; R <= cap; ++R){
        rr = $b8f343bf88dacc48$var$encode_row(R);
        /* [ACCELLTABLE] */ /* BrtRowHdr */ $b8f343bf88dacc48$var$write_row_header(ba, ws, range, R);
        var last_seen = false;
        if (R <= range.e.r) for(var C = range.s.c; C <= range.e.c; ++C){
            /* *16384CELL */ if (R === range.s.r) cols[C] = $b8f343bf88dacc48$var$encode_col(C);
            ref = cols[C] + rr;
            var cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
            if (!cell) {
                last_seen = false;
                continue;
            }
            /* write cell */ last_seen = $b8f343bf88dacc48$var$write_ws_bin_cell(ba, cell, R, C, opts, ws, last_seen, date1904);
        }
    }
    $b8f343bf88dacc48$var$write_record(ba, 0x0092 /* BrtEndSheetData */ );
}
function $b8f343bf88dacc48$var$write_MERGECELLS(ba, ws /*:Worksheet*/ ) {
    if (!ws || !ws['!merges']) return;
    $b8f343bf88dacc48$var$write_record(ba, 0x00B1 /* BrtBeginMergeCells */ , $b8f343bf88dacc48$var$write_BrtBeginMergeCells(ws['!merges'].length));
    ws['!merges'].forEach(function(m) {
        $b8f343bf88dacc48$var$write_record(ba, 0x00B0 /* BrtMergeCell */ , $b8f343bf88dacc48$var$write_BrtMergeCell(m));
    });
    $b8f343bf88dacc48$var$write_record(ba, 0x00B2 /* BrtEndMergeCells */ );
}
function $b8f343bf88dacc48$var$write_COLINFOS(ba, ws /*:Worksheet*/  /*::, idx:number, opts, wb:Workbook*/ ) {
    if (!ws || !ws['!cols']) return;
    $b8f343bf88dacc48$var$write_record(ba, 0x0186 /* BrtBeginColInfos */ );
    ws['!cols'].forEach(function(m, i) {
        if (m) $b8f343bf88dacc48$var$write_record(ba, 0x003C /* 'BrtColInfo' */ , $b8f343bf88dacc48$var$write_BrtColInfo(i, m));
    });
    $b8f343bf88dacc48$var$write_record(ba, 0x0187 /* BrtEndColInfos */ );
}
function $b8f343bf88dacc48$var$write_IGNOREECS(ba, ws /*:Worksheet*/ ) {
    if (!ws || !ws['!ref']) return;
    $b8f343bf88dacc48$var$write_record(ba, 0x0288 /* BrtBeginCellIgnoreECs */ );
    $b8f343bf88dacc48$var$write_record(ba, 0x0289 /* BrtCellIgnoreEC */ , $b8f343bf88dacc48$var$write_BrtCellIgnoreEC($b8f343bf88dacc48$var$safe_decode_range(ws['!ref'])));
    $b8f343bf88dacc48$var$write_record(ba, 0x028A /* BrtEndCellIgnoreECs */ );
}
function $b8f343bf88dacc48$var$write_HLINKS(ba, ws /*:Worksheet*/ , rels) {
    /* *BrtHLink */ ws['!links'].forEach(function(l) {
        if (!l[1].Target) return;
        var rId = $b8f343bf88dacc48$var$add_rels(rels, -1, l[1].Target.replace(/#[\s\S]*$/, ""), $b8f343bf88dacc48$var$RELS.HLINK);
        $b8f343bf88dacc48$var$write_record(ba, 0x01EE /* BrtHLink */ , $b8f343bf88dacc48$var$write_BrtHLink(l, rId));
    });
    delete ws['!links'];
}
function $b8f343bf88dacc48$var$write_LEGACYDRAWING(ba, ws /*:Worksheet*/ , idx /*:number*/ , rels) {
    /* [BrtLegacyDrawing] */ if (ws['!comments'].length > 0) {
        var rId = $b8f343bf88dacc48$var$add_rels(rels, -1, "../drawings/vmlDrawing" + (idx + 1) + ".vml", $b8f343bf88dacc48$var$RELS.VML);
        $b8f343bf88dacc48$var$write_record(ba, 0x0227 /* BrtLegacyDrawing */ , $b8f343bf88dacc48$var$write_RelID("rId" + rId));
        ws['!legacy'] = rId;
    }
}
function $b8f343bf88dacc48$var$write_AUTOFILTER(ba, ws, wb, idx) {
    if (!ws['!autofilter']) return;
    var data = ws['!autofilter'];
    var ref = typeof data.ref === "string" ? data.ref : $b8f343bf88dacc48$var$encode_range(data.ref);
    /* Update FilterDatabase defined name for the worksheet */ if (!wb.Workbook) wb.Workbook = {
        Sheets: []
    } /*:any*/ ;
    if (!wb.Workbook.Names) wb.Workbook.Names = [];
    var names /*: Array<any> */  = wb.Workbook.Names;
    var range = $b8f343bf88dacc48$var$decode_range(ref);
    if (range.s.r == range.e.r) {
        range.e.r = $b8f343bf88dacc48$var$decode_range(ws["!ref"]).e.r;
        ref = $b8f343bf88dacc48$var$encode_range(range);
    }
    for(var i = 0; i < names.length; ++i){
        var name = names[i];
        if (name.Name != '_xlnm._FilterDatabase') continue;
        if (name.Sheet != idx) continue;
        name.Ref = $b8f343bf88dacc48$var$formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + $b8f343bf88dacc48$var$fix_range(ref);
        break;
    }
    if (i == names.length) names.push({
        Name: '_xlnm._FilterDatabase',
        Sheet: idx,
        Ref: $b8f343bf88dacc48$var$formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + $b8f343bf88dacc48$var$fix_range(ref)
    });
    $b8f343bf88dacc48$var$write_record(ba, 0x00A1 /* BrtBeginAFilter */ , $b8f343bf88dacc48$var$write_UncheckedRfX($b8f343bf88dacc48$var$safe_decode_range(ref)));
    /* *FILTERCOLUMN */ /* [SORTSTATE] */ /* BrtEndAFilter */ $b8f343bf88dacc48$var$write_record(ba, 0x00A2 /* BrtEndAFilter */ );
}
function $b8f343bf88dacc48$var$write_WSVIEWS2(ba, ws, Workbook) {
    $b8f343bf88dacc48$var$write_record(ba, 0x0085 /* BrtBeginWsViews */ );
    /* [ACUID] */ $b8f343bf88dacc48$var$write_record(ba, 0x0089 /* BrtBeginWsView */ , $b8f343bf88dacc48$var$write_BrtBeginWsView(ws, Workbook));
    /* [BrtPane] */ /* *4BrtSel */ /* *4SXSELECT */ /* *FRT */ $b8f343bf88dacc48$var$write_record(ba, 0x008A /* BrtEndWsView */ );
    /* *FRT */ $b8f343bf88dacc48$var$write_record(ba, 0x0086 /* BrtEndWsViews */ );
}
function $b8f343bf88dacc48$var$write_WSFMTINFO() {
/* [ACWSFMTINFO] */ // write_record(ba, 0x01E5 /* BrtWsFmtInfo */, write_BrtWsFmtInfo(ws));
}
function $b8f343bf88dacc48$var$write_SHEETPROTECT(ba, ws) {
    if (!ws['!protect']) return;
    /* [BrtSheetProtectionIso] */ $b8f343bf88dacc48$var$write_record(ba, 0x0217 /* BrtSheetProtection */ , $b8f343bf88dacc48$var$write_BrtSheetProtection(ws['!protect']));
}
function $b8f343bf88dacc48$var$write_ws_bin(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) {
    var ba = $b8f343bf88dacc48$var$buf_array();
    var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
    var c /*:string*/  = s;
    try {
        if (wb && wb.Workbook) c = wb.Workbook.Sheets[idx].CodeName || c;
    } catch (e) {}
    var r = $b8f343bf88dacc48$var$safe_decode_range(ws['!ref'] || "A1");
    if (r.e.c > 0x3FFF || r.e.r > 0xFFFFF) {
        if (opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:XFD1048576");
        r.e.c = Math.min(r.e.c, 0x3FFF);
        r.e.r = Math.min(r.e.c, 0xFFFFF);
    }
    ws['!links'] = [];
    /* passed back to write_zip and removed there */ ws['!comments'] = [];
    $b8f343bf88dacc48$var$write_record(ba, 0x0081 /* BrtBeginSheet */ );
    if (wb.vbaraw || ws['!outline']) $b8f343bf88dacc48$var$write_record(ba, 0x0093 /* BrtWsProp */ , $b8f343bf88dacc48$var$write_BrtWsProp(c, ws['!outline']));
    $b8f343bf88dacc48$var$write_record(ba, 0x0094 /* BrtWsDim */ , $b8f343bf88dacc48$var$write_BrtWsDim(r));
    $b8f343bf88dacc48$var$write_WSVIEWS2(ba, ws, wb.Workbook);
    $b8f343bf88dacc48$var$write_WSFMTINFO(ba, ws);
    $b8f343bf88dacc48$var$write_COLINFOS(ba, ws, idx, opts, wb);
    $b8f343bf88dacc48$var$write_CELLTABLE(ba, ws, idx, opts, wb);
    /* [BrtSheetCalcProp] */ $b8f343bf88dacc48$var$write_SHEETPROTECT(ba, ws);
    /* *([BrtRangeProtectionIso] BrtRangeProtection) */ /* [SCENMAN] */ $b8f343bf88dacc48$var$write_AUTOFILTER(ba, ws, wb, idx);
    /* [SORTSTATE] */ /* [DCON] */ /* [USERSHVIEWS] */ $b8f343bf88dacc48$var$write_MERGECELLS(ba, ws);
    /* [BrtPhoneticInfo] */ /* *CONDITIONALFORMATTING */ /* [DVALS] */ $b8f343bf88dacc48$var$write_HLINKS(ba, ws, rels);
    /* [BrtPrintOptions] */ if (ws['!margins']) $b8f343bf88dacc48$var$write_record(ba, 0x01DC /* BrtMargins */ , $b8f343bf88dacc48$var$write_BrtMargins(ws['!margins']));
    /* [BrtPageSetup] */ /* [HEADERFOOTER] */ /* [RWBRK] */ /* [COLBRK] */ /* *BrtBigName */ /* [CELLWATCHES] */ if (!opts || opts.ignoreEC || opts.ignoreEC == void 0) $b8f343bf88dacc48$var$write_IGNOREECS(ba, ws);
    /* [SMARTTAGS] */ /* [BrtDrawing] */ $b8f343bf88dacc48$var$write_LEGACYDRAWING(ba, ws, idx, rels);
    /* [BrtLegacyDrawingHF] */ /* [BrtBkHim] */ /* [OLEOBJECTS] */ /* [ACTIVEXCONTROLS] */ /* [WEBPUBITEMS] */ /* [LISTPARTS] */ /* FRTWORKSHEET */ $b8f343bf88dacc48$var$write_record(ba, 0x0082 /* BrtEndSheet */ );
    return ba.end();
}
function $b8f343bf88dacc48$var$parse_Cache(data /*:string*/ ) /*:[Array<number|string>, string, ?string]*/ {
    var col /*:Array<number|string>*/  = [];
    var num = data.match(/^<c:numCache>/);
    var f;
    /* 21.2.2.150 pt CT_NumVal */ (data.match(/<c:pt idx="(\d*)"[^<>\/]*><c:v>([^<])<\/c:v><\/c:pt>/mg) || []).forEach(function(pt) {
        var q = pt.match(/<c:pt idx="(\d*)"[^<>\/]*><c:v>([^<]*)<\/c:v><\/c:pt>/);
        if (!q) return;
        col[+q[1]] = num ? +q[2] : q[2];
    });
    /* 21.2.2.71 formatCode CT_Xstring */ var nf = $b8f343bf88dacc48$var$unescapexml(($b8f343bf88dacc48$var$str_match_xml(data, "c:formatCode") || [
        "",
        "General"
    ])[1]);
    ($b8f343bf88dacc48$var$str_match_ng(data, "<c:f>", "</c:f>") || []).forEach(function(F) {
        f = F.replace(/<[^<>]*>/g, "");
    });
    return [
        col,
        nf,
        f
    ];
}
/* 21.2 DrawingML - Charts */ function $b8f343bf88dacc48$var$parse_chart(data /*:?string*/ , name /*:string*/ , opts, rels, wb, csheet) {
    var cs /*:Worksheet*/  = csheet || {
        "!type": "chart"
    };
    if (!data) return csheet;
    /* 21.2.2.27 chart CT_Chart */ var C = 0, R = 0, col = "A";
    var refguess = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    /* 21.2.2.120 numCache CT_NumData */ ($b8f343bf88dacc48$var$str_match_ng(data, "<c:numCache>", "</c:numCache>") || []).forEach(function(nc) {
        var cache = $b8f343bf88dacc48$var$parse_Cache(nc);
        refguess.s.r = refguess.s.c = 0;
        refguess.e.c = C;
        col = $b8f343bf88dacc48$var$encode_col(C);
        cache[0].forEach(function(n, i) {
            if (cs["!data"]) {
                if (!cs["!data"][i]) cs["!data"][i] = [];
                cs["!data"][i][C] = {
                    t: 'n',
                    v: n,
                    z: cache[1]
                };
            } else cs[col + $b8f343bf88dacc48$var$encode_row(i)] = {
                t: 'n',
                v: n,
                z: cache[1]
            };
            R = i;
        });
        if (refguess.e.r < R) refguess.e.r = R;
        ++C;
    });
    if (C > 0) cs["!ref"] = $b8f343bf88dacc48$var$encode_range(refguess);
    return cs;
}
/* 18.3 Worksheets also covers Chartsheets */ function $b8f343bf88dacc48$var$parse_cs_xml(data /*:?string*/ , opts, idx /*:number*/ , rels, wb /*::, themes, styles*/ ) /*:Worksheet*/ {
    if (!data) return data;
    /* 18.3.1.12 chartsheet CT_ChartSheet */ if (!rels) rels = {
        '!id': {}
    };
    var s = {
        '!type': "chart",
        '!drawel': null,
        '!rel': ""
    } /*:any*/ ;
    var m;
    /* 18.3.1.83 sheetPr CT_ChartsheetPr */ var sheetPr = data.match($b8f343bf88dacc48$var$sheetprregex);
    if (sheetPr) $b8f343bf88dacc48$var$parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
    /* 18.3.1.36 drawing CT_Drawing */ if (m = data.match(/drawing r:id="(.*?)"/)) s['!rel'] = m[1];
    if (rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
    return s;
}
//function write_cs_xml(idx/*:number*/, opts, wb/*:Workbook*/, rels)/*:string*/ {
//	var o = [XML_HEADER, writextag('chartsheet', null, {
//		'xmlns': XMLNS_main[0],
//		'xmlns:r': XMLNS.r
//	})];
//	o[o.length] = writextag("drawing", null, {"r:id": "rId1"});
//	add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
//	if(o.length>2) { o[o.length] = ('</chartsheet>'); o[1]=o[1].replace("/>",">"); }
//	return o.join("");
//}
/* [MS-XLSB] 2.4.331 BrtCsProp */ function $b8f343bf88dacc48$var$parse_BrtCsProp(data, length /*:number*/ ) {
    data.l += 10;
    var name = $b8f343bf88dacc48$var$parse_XLWideString(data, length - 10);
    return {
        name: name
    };
}
/* [MS-XLSB] 2.1.7.7 Chart Sheet */ function $b8f343bf88dacc48$var$parse_cs_bin(data, opts, idx /*:number*/ , rels, wb /*::, themes, styles*/ ) /*:Worksheet*/ {
    if (!data) return data;
    if (!rels) rels = {
        '!id': {}
    };
    var s = {
        '!type': "chart",
        '!drawel': null,
        '!rel': ""
    };
    var state /*:Array<string>*/  = [];
    var pass = false;
    $b8f343bf88dacc48$var$recordhopper(data, function cs_parse(val, R, RT) {
        switch(RT){
            case 0x0226:
                /* 'BrtDrawing' */ s['!rel'] = val;
                break;
            case 0x028B:
                /* 'BrtCsProp' */ if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
                if (val.name) wb.Sheets[idx].CodeName = val.name;
                break;
            case 0x0232:
            /* 'BrtBkHim' */ case 0x028C:
            /* 'BrtCsPageSetup' */ case 0x029D:
            /* 'BrtCsProtection' */ case 0x02A7:
            /* 'BrtCsProtectionIso' */ case 0x0227:
            /* 'BrtLegacyDrawing' */ case 0x0228:
            /* 'BrtLegacyDrawingHF' */ case 0x01DC:
            /* 'BrtMargins' */ case 0x0C00:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                break;
            default:
                if (R.T > 0) state.push(RT);
                else if (R.T < 0) state.pop();
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    if (rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
    return s;
}
//function write_cs_bin(/*::idx:number, opts, wb:Workbook, rels*/) {
//	var ba = buf_array();
//	write_record(ba, 0x0081 /* BrtBeginSheet */);
//	/* [BrtCsProp] */
//	/* CSVIEWS */
//	/* [[BrtCsProtectionIso] BrtCsProtection] */
//	/* [USERCSVIEWS] */
//	/* [BrtMargins] */
//	/* [BrtCsPageSetup] */
//	/* [HEADERFOOTER] */
//	/* BrtDrawing */
//	/* [BrtLegacyDrawing] */
//	/* [BrtLegacyDrawingHF] */
//	/* [BrtBkHim] */
//	/* [WEBPUBITEMS] */
//	/* FRTCHARTSHEET */
//	write_record(ba, 0x0082 /* BrtEndSheet */);
//	return ba.end();
//}
/* 18.2.28 (CT_WorkbookProtection) Defaults */ var $b8f343bf88dacc48$var$WBPropsDef = [
    [
        'allowRefreshQuery',
        false,
        "bool"
    ],
    [
        'autoCompressPictures',
        true,
        "bool"
    ],
    [
        'backupFile',
        false,
        "bool"
    ],
    [
        'checkCompatibility',
        false,
        "bool"
    ],
    [
        'CodeName',
        ''
    ],
    [
        'date1904',
        false,
        "bool"
    ],
    [
        'defaultThemeVersion',
        0,
        "int"
    ],
    [
        'filterPrivacy',
        false,
        "bool"
    ],
    [
        'hidePivotFieldList',
        false,
        "bool"
    ],
    [
        'promptedSolutions',
        false,
        "bool"
    ],
    [
        'publishItems',
        false,
        "bool"
    ],
    [
        'refreshAllConnections',
        false,
        "bool"
    ],
    [
        'saveExternalLinkValues',
        true,
        "bool"
    ],
    [
        'showBorderUnselectedTables',
        true,
        "bool"
    ],
    [
        'showInkAnnotation',
        true,
        "bool"
    ],
    [
        'showObjects',
        'all'
    ],
    [
        'showPivotChartFilter',
        false,
        "bool"
    ],
    [
        'updateLinks',
        'userSet'
    ]
];
/* 18.2.30 (CT_BookView) Defaults */ var $b8f343bf88dacc48$var$WBViewDef = [
    [
        'activeTab',
        0,
        "int"
    ],
    [
        'autoFilterDateGrouping',
        true,
        "bool"
    ],
    [
        'firstSheet',
        0,
        "int"
    ],
    [
        'minimized',
        false,
        "bool"
    ],
    [
        'showHorizontalScroll',
        true,
        "bool"
    ],
    [
        'showSheetTabs',
        true,
        "bool"
    ],
    [
        'showVerticalScroll',
        true,
        "bool"
    ],
    [
        'tabRatio',
        600,
        "int"
    ],
    [
        'visibility',
        'visible'
    ]
];
/* 18.2.19 (CT_Sheet) Defaults */ var $b8f343bf88dacc48$var$SheetDef = [];
/* 18.2.2  (CT_CalcPr) Defaults */ var $b8f343bf88dacc48$var$CalcPrDef = [
    [
        'calcCompleted',
        'true'
    ],
    [
        'calcMode',
        'auto'
    ],
    [
        'calcOnSave',
        'true'
    ],
    [
        'concurrentCalc',
        'true'
    ],
    [
        'fullCalcOnLoad',
        'false'
    ],
    [
        'fullPrecision',
        'true'
    ],
    [
        'iterate',
        'false'
    ],
    [
        'iterateCount',
        '100'
    ],
    [
        'iterateDelta',
        '0.001'
    ],
    [
        'refMode',
        'A1'
    ]
];
/* 18.2.3 (CT_CustomWorkbookView) Defaults */ /*var CustomWBViewDef = [
	['autoUpdate', 'false'],
	['changesSavedWin', 'false'],
	['includeHiddenRowCol', 'true'],
	['includePrintSettings', 'true'],
	['maximized', 'false'],
	['minimized', 'false'],
	['onlySync', 'false'],
	['personalView', 'false'],
	['showComments', 'commIndicator'],
	['showFormulaBar', 'true'],
	['showHorizontalScroll', 'true'],
	['showObjects', 'all'],
	['showSheetTabs', 'true'],
	['showStatusbar', 'true'],
	['showVerticalScroll', 'true'],
	['tabRatio', '600'],
	['xWindow', '0'],
	['yWindow', '0']
];*/ function $b8f343bf88dacc48$var$push_defaults_array(target, defaults) {
    for(var j = 0; j != target.length; ++j){
        var w = target[j];
        for(var i = 0; i != defaults.length; ++i){
            var z = defaults[i];
            if (w[z[0]] == null) w[z[0]] = z[1];
            else switch(z[2]){
                case "bool":
                    if (typeof w[z[0]] == "string") w[z[0]] = $b8f343bf88dacc48$var$parsexmlbool(w[z[0]]);
                    break;
                case "int":
                    if (typeof w[z[0]] == "string") w[z[0]] = parseInt(w[z[0]], 10);
                    break;
            }
        }
    }
}
function $b8f343bf88dacc48$var$push_defaults(target, defaults) {
    for(var i = 0; i != defaults.length; ++i){
        var z = defaults[i];
        if (target[z[0]] == null) target[z[0]] = z[1];
        else switch(z[2]){
            case "bool":
                if (typeof target[z[0]] == "string") target[z[0]] = $b8f343bf88dacc48$var$parsexmlbool(target[z[0]]);
                break;
            case "int":
                if (typeof target[z[0]] == "string") target[z[0]] = parseInt(target[z[0]], 10);
                break;
        }
    }
}
function $b8f343bf88dacc48$var$parse_wb_defaults(wb) {
    $b8f343bf88dacc48$var$push_defaults(wb.WBProps, $b8f343bf88dacc48$var$WBPropsDef);
    $b8f343bf88dacc48$var$push_defaults(wb.CalcPr, $b8f343bf88dacc48$var$CalcPrDef);
    $b8f343bf88dacc48$var$push_defaults_array(wb.WBView, $b8f343bf88dacc48$var$WBViewDef);
    $b8f343bf88dacc48$var$push_defaults_array(wb.Sheets, $b8f343bf88dacc48$var$SheetDef);
    $b8f343bf88dacc48$var$_ssfopts.date1904 = $b8f343bf88dacc48$var$parsexmlbool(wb.WBProps.date1904);
}
function $b8f343bf88dacc48$var$safe1904(wb /*:Workbook*/ ) /*:string*/ {
    /* TODO: store date1904 somewhere else */ if (!wb.Workbook) return "false";
    if (!wb.Workbook.WBProps) return "false";
    return $b8f343bf88dacc48$var$parsexmlbool(wb.Workbook.WBProps.date1904) ? "true" : "false";
}
var $b8f343bf88dacc48$var$badchars = /*#__PURE__*/ ":][*?\/\\".split("");
function $b8f343bf88dacc48$var$check_ws_name(n /*:string*/ , safe /*:?boolean*/ ) /*:boolean*/ {
    try {
        if (n == "") throw new Error("Sheet name cannot be blank");
        if (n.length > 31) throw new Error("Sheet name cannot exceed 31 chars");
        if (n.charCodeAt(0) == 0x27 || n.charCodeAt(n.length - 1) == 0x27) throw new Error("Sheet name cannot start or end with apostrophe (')");
        if (n.toLowerCase() == "history") throw new Error("Sheet name cannot be 'History'");
        $b8f343bf88dacc48$var$badchars.forEach(function(c) {
            if (n.indexOf(c) == -1) return;
            throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
        });
    } catch (e) {
        if (safe) return false;
        throw e;
    }
    return true;
}
function $b8f343bf88dacc48$var$check_wb_names(N, S, codes) {
    N.forEach(function(n, i) {
        $b8f343bf88dacc48$var$check_ws_name(n);
        for(var j = 0; j < i; ++j)if (n == N[j]) throw new Error("Duplicate Sheet Name: " + n);
        if (codes) {
            var cn = S && S[i] && S[i].CodeName || n;
            if (cn.charCodeAt(0) == 95 && cn.length > 22) throw new Error("Bad Code Name: Worksheet" + cn);
        }
    });
}
function $b8f343bf88dacc48$var$check_wb(wb) {
    if (!wb || !wb.SheetNames || !wb.Sheets) throw new Error("Invalid Workbook");
    if (!wb.SheetNames.length) throw new Error("Workbook is empty");
    var Sheets = wb.Workbook && wb.Workbook.Sheets || [];
    $b8f343bf88dacc48$var$check_wb_names(wb.SheetNames, Sheets, !!wb.vbaraw);
    for(var i = 0; i < wb.SheetNames.length; ++i)$b8f343bf88dacc48$var$check_ws(wb.Sheets[wb.SheetNames[i]], wb.SheetNames[i], i);
    wb.SheetNames.forEach(function(n, i) {
        var ws = wb.Sheets[n];
        if (!ws || !ws["!autofilter"]) return;
        var DN;
        if (!wb.Workbook) wb.Workbook = {};
        if (!wb.Workbook.Names) wb.Workbook.Names = [];
        wb.Workbook.Names.forEach(function(dn) {
            if (dn.Name == "_xlnm._FilterDatabase" && dn.Sheet == i) DN = dn;
        });
        var nn = $b8f343bf88dacc48$var$formula_quote_sheet_name(n) + "!" + $b8f343bf88dacc48$var$fix_range(ws["!autofilter"].ref);
        if (DN) DN.Ref = nn;
        else wb.Workbook.Names.push({
            Name: "_xlnm._FilterDatabase",
            Sheet: i,
            Ref: nn
        });
    });
/* TODO: validate workbook */ }
/* 18.2 Workbook */ var $b8f343bf88dacc48$var$wbnsregex = /<\w+:workbook/;
function $b8f343bf88dacc48$var$parse_wb_xml(data, opts) /*:WorkbookFile*/ {
    if (!data) throw new Error("Could not find file");
    var wb = /*::(*/ {
        AppVersion: {},
        WBProps: {},
        WBView: [],
        Sheets: [],
        CalcPr: {},
        Names: [],
        xmlns: ""
    } /*::)*/ ;
    var pass = false, xmlns = "xmlns";
    var dname = {}, dnstart = 0;
    data.replace($b8f343bf88dacc48$var$tagregex, function xml_wb(x, idx) {
        var y /*:any*/  = $b8f343bf88dacc48$var$parsexmltag(x);
        switch($b8f343bf88dacc48$var$strip_ns(y[0])){
            case '<?xml':
                break;
            /* 18.2.27 workbook CT_Workbook 1 */ case '<workbook':
                if (x.match($b8f343bf88dacc48$var$wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1];
                wb.xmlns = y[xmlns];
                break;
            case '</workbook>':
                break;
            /* 18.2.13 fileVersion CT_FileVersion ? */ case '<fileVersion':
                delete y[0];
                wb.AppVersion = y;
                break;
            case '<fileVersion/>':
            case '</fileVersion>':
                break;
            /* 18.2.12 fileSharing CT_FileSharing ? */ case '<fileSharing':
                break;
            case '<fileSharing/>':
                break;
            /* 18.2.28 workbookPr CT_WorkbookPr ? */ case '<workbookPr':
            case '<workbookPr/>':
                $b8f343bf88dacc48$var$WBPropsDef.forEach(function(w) {
                    if (y[w[0]] == null) return;
                    switch(w[2]){
                        case "bool":
                            wb.WBProps[w[0]] = $b8f343bf88dacc48$var$parsexmlbool(y[w[0]]);
                            break;
                        case "int":
                            wb.WBProps[w[0]] = parseInt(y[w[0]], 10);
                            break;
                        default:
                            wb.WBProps[w[0]] = y[w[0]];
                    }
                });
                if (y.codeName) wb.WBProps.CodeName = $b8f343bf88dacc48$var$utf8read(y.codeName);
                break;
            case '</workbookPr>':
                break;
            /* 18.2.29 workbookProtection CT_WorkbookProtection ? */ case '<workbookProtection':
                break;
            case '<workbookProtection/>':
                break;
            /* 18.2.1  bookViews CT_BookViews ? */ case '<bookViews':
            case '<bookViews>':
            case '</bookViews>':
                break;
            /* 18.2.30   workbookView CT_BookView + */ case '<workbookView':
            case '<workbookView/>':
                delete y[0];
                wb.WBView.push(y);
                break;
            case '</workbookView>':
                break;
            /* 18.2.20 sheets CT_Sheets 1 */ case '<sheets':
            case '<sheets>':
            case '</sheets>':
                break; // aggregate sheet
            /* 18.2.19   sheet CT_Sheet + */ case '<sheet':
                switch(y.state){
                    case "hidden":
                        y.Hidden = 1;
                        break;
                    case "veryHidden":
                        y.Hidden = 2;
                        break;
                    default:
                        y.Hidden = 0;
                }
                delete y.state;
                y.name = $b8f343bf88dacc48$var$unescapexml($b8f343bf88dacc48$var$utf8read(y.name));
                delete y[0];
                wb.Sheets.push(y);
                break;
            case '</sheet>':
                break;
            /* 18.2.15 functionGroups CT_FunctionGroups ? */ case '<functionGroups':
            case '<functionGroups/>':
                break;
            /* 18.2.14   functionGroup CT_FunctionGroup + */ case '<functionGroup':
                break;
            /* 18.2.9  externalReferences CT_ExternalReferences ? */ case '<externalReferences':
            case '</externalReferences>':
            case '<externalReferences>':
                break;
            /* 18.2.8    externalReference CT_ExternalReference + */ case '<externalReference':
                break;
            /* 18.2.6  definedNames CT_DefinedNames ? */ case '<definedNames/>':
                break;
            case '<definedNames>':
            case '<definedNames':
                pass = true;
                break;
            case '</definedNames>':
                pass = false;
                break;
            /* 18.2.5    definedName CT_DefinedName + */ case '<definedName':
                dname = {};
                dname.Name = $b8f343bf88dacc48$var$utf8read(y.name);
                if (y.comment) dname.Comment = y.comment;
                if (y.localSheetId) dname.Sheet = +y.localSheetId;
                if ($b8f343bf88dacc48$var$parsexmlbool(y.hidden || "0")) dname.Hidden = true;
                dnstart = idx + x.length;
                break;
            case '</definedName>':
                dname.Ref = $b8f343bf88dacc48$var$unescapexml($b8f343bf88dacc48$var$utf8read(data.slice(dnstart, idx)));
                wb.Names.push(dname);
                break;
            case '<definedName/>':
                break;
            /* 18.2.2  calcPr CT_CalcPr ? */ case '<calcPr':
                delete y[0];
                wb.CalcPr = y;
                break;
            case '<calcPr/>':
                delete y[0];
                wb.CalcPr = y;
                break;
            case '</calcPr>':
                break;
            /* 18.2.16 oleSize CT_OleSize ? (ref required) */ case '<oleSize':
                break;
            /* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */ case '<customWorkbookViews>':
            case '</customWorkbookViews>':
            case '<customWorkbookViews':
                break;
            /* 18.2.3  customWorkbookView CT_CustomWorkbookView + */ case '<customWorkbookView':
            case '</customWorkbookView>':
                break;
            /* 18.2.18 pivotCaches CT_PivotCaches ? */ case '<pivotCaches>':
            case '</pivotCaches>':
            case '<pivotCaches':
                break;
            /* 18.2.17 pivotCache CT_PivotCache ? */ case '<pivotCache':
                break;
            /* 18.2.21 smartTagPr CT_SmartTagPr ? */ case '<smartTagPr':
            case '<smartTagPr/>':
                break;
            /* 18.2.23 smartTagTypes CT_SmartTagTypes ? */ case '<smartTagTypes':
            case '<smartTagTypes>':
            case '</smartTagTypes>':
                break;
            /* 18.2.22 smartTagType CT_SmartTagType ? */ case '<smartTagType':
                break;
            /* 18.2.24 webPublishing CT_WebPublishing ? */ case '<webPublishing':
            case '<webPublishing/>':
                break;
            /* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */ case '<fileRecoveryPr':
            case '<fileRecoveryPr/>':
                break;
            /* 18.2.26 webPublishObjects CT_WebPublishObjects ? */ case '<webPublishObjects>':
            case '<webPublishObjects':
            case '</webPublishObjects>':
                break;
            /* 18.2.25 webPublishObject CT_WebPublishObject ? */ case '<webPublishObject':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
            case '<extLst/>':
                break;
            /* 18.2.7  ext CT_Extension + */ case '<ext':
                pass = true;
                break; //TODO: check with versions of excel
            case '</ext>':
                pass = false;
                break;
            /* Others */ case '<ArchID':
                break;
            case '<AlternateContent':
            case '<AlternateContent>':
                pass = true;
                break;
            case '</AlternateContent>':
                pass = false;
                break;
            /* TODO */ case '<revisionPtr':
                break;
            default:
                if (!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in workbook');
        }
        return x;
    });
    if ($b8f343bf88dacc48$var$XMLNS_main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns);
    $b8f343bf88dacc48$var$parse_wb_defaults(wb);
    return wb;
}
function $b8f343bf88dacc48$var$write_wb_xml(wb /*:Workbook*/  /*::, opts:?WriteOpts*/ ) /*:string*/ {
    var o = [
        $b8f343bf88dacc48$var$XML_HEADER
    ];
    o[o.length] = $b8f343bf88dacc48$var$writextag('workbook', null, {
        'xmlns': $b8f343bf88dacc48$var$XMLNS_main[0],
        //'xmlns:mx': XMLNS.mx,
        //'xmlns:s': XMLNS_main[0],
        'xmlns:r': $b8f343bf88dacc48$var$XMLNS.r
    });
    var write_names = wb.Workbook && (wb.Workbook.Names || []).length > 0;
    /* fileVersion */ /* fileSharing */ var workbookPr /*:any*/  = {
        codeName: "ThisWorkbook"
    } /*:any*/ ;
    if (wb.Workbook && wb.Workbook.WBProps) {
        $b8f343bf88dacc48$var$WBPropsDef.forEach(function(x) {
            /*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */ if (wb.Workbook.WBProps[x[0]] == null) return;
            if (wb.Workbook.WBProps[x[0]] == x[1]) return;
            workbookPr[x[0]] = wb.Workbook.WBProps[x[0]];
        });
        /*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */ if (wb.Workbook.WBProps.CodeName) {
            workbookPr.codeName = wb.Workbook.WBProps.CodeName;
            delete workbookPr.CodeName;
        }
    }
    o[o.length] = $b8f343bf88dacc48$var$writextag('workbookPr', null, workbookPr);
    /* workbookProtection */ var sheets = wb.Workbook && wb.Workbook.Sheets || [];
    var i = 0;
    /* bookViews only written if first worksheet is hidden */ if (sheets && sheets[0] && !!sheets[0].Hidden) {
        o[o.length] = "<bookViews>";
        for(i = 0; i != wb.SheetNames.length; ++i){
            if (!sheets[i]) break;
            if (!sheets[i].Hidden) break;
        }
        if (i == wb.SheetNames.length) i = 0;
        o[o.length] = '<workbookView firstSheet="' + i + '" activeTab="' + i + '"/>';
        o[o.length] = "</bookViews>";
    }
    o[o.length] = "<sheets>";
    for(i = 0; i != wb.SheetNames.length; ++i){
        var sht = {
            name: $b8f343bf88dacc48$var$escapexml(wb.SheetNames[i].slice(0, 31))
        } /*:any*/ ;
        sht.sheetId = "" + (i + 1);
        sht["r:id"] = "rId" + (i + 1);
        if (sheets[i]) switch(sheets[i].Hidden){
            case 1:
                sht.state = "hidden";
                break;
            case 2:
                sht.state = "veryHidden";
                break;
        }
        o[o.length] = $b8f343bf88dacc48$var$writextag('sheet', null, sht);
    }
    o[o.length] = "</sheets>";
    /* functionGroups */ /* externalReferences */ if (write_names) {
        o[o.length] = "<definedNames>";
        if (wb.Workbook && wb.Workbook.Names) wb.Workbook.Names.forEach(function(n) {
            var d /*:any*/  = {
                name: n.Name
            };
            if (n.Comment) d.comment = n.Comment;
            if (n.Sheet != null) d.localSheetId = "" + n.Sheet;
            if (n.Hidden) d.hidden = "1";
            if (!n.Ref) return;
            o[o.length] = $b8f343bf88dacc48$var$writextag('definedName', $b8f343bf88dacc48$var$escapexml(n.Ref), d);
        });
        o[o.length] = "</definedNames>";
    }
    /* calcPr */ /* oleSize */ /* customWorkbookViews */ /* pivotCaches */ /* smartTagPr */ /* smartTagTypes */ /* webPublishing */ /* fileRecoveryPr */ /* webPublishObjects */ /* extLst */ if (o.length > 2) {
        o[o.length] = '</workbook>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.304 BrtBundleSh */ function $b8f343bf88dacc48$var$parse_BrtBundleSh(data, length /*:number*/ ) {
    var z = {};
    z.Hidden = data.read_shift(4); //hsState ST_SheetState
    z.iTabID = data.read_shift(4);
    z.strRelID = $b8f343bf88dacc48$var$parse_RelID(data, length - 8);
    z.name = $b8f343bf88dacc48$var$parse_XLWideString(data);
    return z;
}
function $b8f343bf88dacc48$var$write_BrtBundleSh(data, o) {
    if (!o) o = $b8f343bf88dacc48$var$new_buf(127);
    o.write_shift(4, data.Hidden);
    o.write_shift(4, data.iTabID);
    $b8f343bf88dacc48$var$write_RelID(data.strRelID, o);
    $b8f343bf88dacc48$var$write_XLWideString(data.name.slice(0, 31), o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.815 BrtWbProp */ function $b8f343bf88dacc48$var$parse_BrtWbProp(data, length) /*:WBProps*/ {
    var o /*:WBProps*/  = {} /*:any*/ ;
    var flags = data.read_shift(4);
    o.defaultThemeVersion = data.read_shift(4);
    var strName = length > 8 ? $b8f343bf88dacc48$var$parse_XLWideString(data) : "";
    if (strName.length > 0) o.CodeName = strName;
    o.autoCompressPictures = !!(flags & 0x10000);
    o.backupFile = !!(flags & 0x40);
    o.checkCompatibility = !!(flags & 0x1000);
    o.date1904 = !!(flags & 0x01);
    o.filterPrivacy = !!(flags & 0x08);
    o.hidePivotFieldList = !!(flags & 0x400);
    o.promptedSolutions = !!(flags & 0x10);
    o.publishItems = !!(flags & 0x800);
    o.refreshAllConnections = !!(flags & 0x40000);
    o.saveExternalLinkValues = !!(flags & 0x80);
    o.showBorderUnselectedTables = !!(flags & 0x04);
    o.showInkAnnotation = !!(flags & 0x20);
    o.showObjects = [
        "all",
        "placeholders",
        "none"
    ][flags >> 13 & 0x03];
    o.showPivotChartFilter = !!(flags & 0x8000);
    o.updateLinks = [
        "userSet",
        "never",
        "always"
    ][flags >> 8 & 0x03];
    return o;
}
function $b8f343bf88dacc48$var$write_BrtWbProp(data /*:?WBProps*/ , o) {
    if (!o) o = $b8f343bf88dacc48$var$new_buf(72);
    var flags = 0;
    if (data) {
        /* TODO: mirror parse_BrtWbProp fields */ if (data.date1904) flags |= 0x01;
        if (data.filterPrivacy) flags |= 0x08;
    }
    o.write_shift(4, flags);
    o.write_shift(4, 0);
    $b8f343bf88dacc48$var$write_XLSBCodeName(data && data.CodeName || "ThisWorkbook", o);
    return o.slice(0, o.l);
}
function $b8f343bf88dacc48$var$parse_BrtFRTArchID$(data, length) {
    var o = {};
    data.read_shift(4);
    o.ArchID = data.read_shift(4);
    data.l += length - 8;
    return o;
}
/* [MS-XLSB] 2.4.687 BrtName */ function $b8f343bf88dacc48$var$parse_BrtName(data, length, opts) {
    var end = data.l + length;
    var flags = data.read_shift(4);
    data.l += 1; //var chKey = data.read_shift(1);
    var itab = data.read_shift(4);
    var name = $b8f343bf88dacc48$var$parse_XLNameWideString(data);
    var formula;
    var comment = "";
    try {
        formula = $b8f343bf88dacc48$var$parse_XLSBNameParsedFormula(data, 0, opts);
        try {
            comment = $b8f343bf88dacc48$var$parse_XLNullableWideString(data);
        } catch (e) {}
    } catch (e) {
        console.error("Could not parse defined name " + name);
    }
    if (flags & 0x20) name = "_xlnm." + name;
    //if(0 /* fProc */) {
    // unusedstring1: XLNullableWideString
    // description: XLNullableWideString
    // helpTopic: XLNullableWideString
    // unusedstring2: XLNullableWideString
    //}
    data.l = end;
    var out = {
        Name: name,
        Ptg: formula,
        Flags: flags
    } /*:any*/ ;
    if (itab < 0xFFFFFFF) out.Sheet = itab;
    if (comment) out.Comment = comment;
    return out;
}
function $b8f343bf88dacc48$var$write_BrtName(name, wb) {
    var o = $b8f343bf88dacc48$var$new_buf(9);
    var flags = 0;
    var dname = name.Name;
    if ($b8f343bf88dacc48$var$XLSLblBuiltIn.indexOf(dname) > -1) {
        flags |= 0x20;
        dname = dname.slice(6);
    }
    o.write_shift(4, flags); // flags
    o.write_shift(1, 0); // chKey
    o.write_shift(4, name.Sheet == null ? 0xFFFFFFFF : name.Sheet);
    var arr = [
        o,
        $b8f343bf88dacc48$var$write_XLWideString(dname),
        $b8f343bf88dacc48$var$write_XLSBNameParsedFormula(name.Ref, wb)
    ];
    if (name.Comment) arr.push($b8f343bf88dacc48$var$write_XLNullableWideString(name.Comment));
    else {
        var x = $b8f343bf88dacc48$var$new_buf(4);
        x.write_shift(4, 0xFFFFFFFF);
        arr.push(x);
    }
    // if macro (flags & 0x0F):
    // write_shift(4, 0xFFFFFFFF);
    // write_XLNullableWideString(description)
    // write_XLNullableWideString(helpTopic)
    // write_shift(4, 0xFFFFFFFF);
    return $b8f343bf88dacc48$var$bconcat(arr);
}
/* [MS-XLSB] 2.1.7.61 Workbook */ function $b8f343bf88dacc48$var$parse_wb_bin(data, opts) /*:WorkbookFile*/ {
    var wb = {
        AppVersion: {},
        WBProps: {},
        WBView: [],
        Sheets: [],
        CalcPr: {},
        xmlns: ""
    };
    var state /*:Array<string>*/  = [];
    var pass = false;
    if (!opts) opts = {};
    opts.biff = 12;
    var Names = [];
    var supbooks = [
        []
    ];
    supbooks.SheetNames = [];
    supbooks.XTI = [];
    $b8f343bf88dacc48$var$XLSBRecordEnum[0x0010] = {
        n: "BrtFRTArchID$",
        f: $b8f343bf88dacc48$var$parse_BrtFRTArchID$
    };
    $b8f343bf88dacc48$var$recordhopper(data, function hopper_wb(val, R, RT) {
        switch(RT){
            case 0x009C:
                /* 'BrtBundleSh' */ supbooks.SheetNames.push(val.name);
                wb.Sheets.push(val);
                break;
            case 0x0099:
                /* 'BrtWbProp' */ wb.WBProps = val;
                break;
            case 0x0027:
                /* 'BrtName' */ if (val.Sheet != null) opts.SID = val.Sheet;
                val.Ref = val.Ptg ? $b8f343bf88dacc48$var$stringify_formula(val.Ptg, null, null, supbooks, opts) : "#REF!";
                delete opts.SID;
                delete val.Ptg;
                Names.push(val);
                break;
            case 0x040C:
                break;
            case 0x0165:
            /* 'BrtSupSelf' */ case 0x0166:
            /* 'BrtSupSame' */ case 0x0163:
            /* 'BrtSupBookSrc' */ case 0x029B:
                /* 'BrtSupAddin' */ if (!supbooks[0].length) supbooks[0] = [
                    RT,
                    val
                ];
                else supbooks.push([
                    RT,
                    val
                ]);
                supbooks[supbooks.length - 1].XTI = [];
                break;
            case 0x016A:
                /* 'BrtExternSheet' */ if (supbooks.length === 0) {
                    supbooks[0] = [];
                    supbooks[0].XTI = [];
                }
                supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
                supbooks.XTI = supbooks.XTI.concat(val);
                break;
            case 0x0169:
                break;
            case 0x0817:
            /* 'BrtAbsPath15' */ case 0x009E:
            /* 'BrtBookView' */ case 0x008F:
            /* 'BrtBeginBundleShs' */ case 0x0298:
            /* 'BrtBeginFnGroup' */ case 0x0161:
                break;
            /* case 'BrtModelTimeGroupingCalcCol' */ case 0x0C00:
            /* 'BrtUid' */ case 0x0C01:
            /* 'BrtRevisionPtr' */ case 0x0216:
            /* 'BrtBookProtection' */ case 0x02A5:
            /* 'BrtBookProtectionIso' */ case 0x009D:
            /* 'BrtCalcProp' */ case 0x0262:
            /* 'BrtCrashRecErr' */ case 0x0802:
            /* 'BrtDecoupledPivotCacheID' */ case 0x009B:
            /* 'BrtFileRecover' */ case 0x0224:
            /* 'BrtFileSharing' */ case 0x02A4:
            /* 'BrtFileSharingIso' */ case 0x0080:
            /* 'BrtFileVersion' */ case 0x0299:
            /* 'BrtFnGroup' */ case 0x0850:
            /* 'BrtModelRelationship' */ case 0x084D:
            /* 'BrtModelTable' */ case 0x0225:
            /* 'BrtOleSize' */ case 0x0805:
            /* 'BrtPivotTableRef' */ case 0x0254:
            /* 'BrtSmartTagType' */ case 0x081C:
            /* 'BrtTableSlicerCacheID' */ case 0x081B:
            /* 'BrtTableSlicerCacheIDs' */ case 0x0822:
            /* 'BrtTimelineCachePivotCacheID' */ case 0x018D:
            /* 'BrtUserBookView' */ case 0x009A:
            /* 'BrtWbFactoid' */ case 0x045D:
            /* 'BrtWbProp14' */ case 0x0229:
            /* 'BrtWebOpt' */ case 0x082B:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ state.pop();
                pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                pass = false;
                break;
            case 0x0010:
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF && state[state.length - 1] != 0x0025 /* BrtACBegin */  && state[state.length - 1] != 0x0023 /* BrtFRTBegin */ ) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    $b8f343bf88dacc48$var$parse_wb_defaults(wb);
    // $FlowIgnore
    wb.Names = Names;
    wb /*:any*/ .supbooks = supbooks;
    return wb;
}
function $b8f343bf88dacc48$var$write_BUNDLESHS(ba, wb /*::, opts*/ ) {
    $b8f343bf88dacc48$var$write_record(ba, 0x008F /* BrtBeginBundleShs */ );
    for(var idx = 0; idx != wb.SheetNames.length; ++idx){
        var viz = wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx] && wb.Workbook.Sheets[idx].Hidden || 0;
        var d = {
            Hidden: viz,
            iTabID: idx + 1,
            strRelID: 'rId' + (idx + 1),
            name: wb.SheetNames[idx]
        };
        $b8f343bf88dacc48$var$write_record(ba, 0x009C /* BrtBundleSh */ , $b8f343bf88dacc48$var$write_BrtBundleSh(d));
    }
    $b8f343bf88dacc48$var$write_record(ba, 0x0090 /* BrtEndBundleShs */ );
}
/* [MS-XLSB] 2.4.649 BrtFileVersion */ function $b8f343bf88dacc48$var$write_BrtFileVersion(data, o) {
    if (!o) o = $b8f343bf88dacc48$var$new_buf(127);
    for(var i = 0; i != 4; ++i)o.write_shift(4, 0);
    $b8f343bf88dacc48$var$write_XLWideString("SheetJS", o);
    $b8f343bf88dacc48$var$write_XLWideString($b8f343bf88dacc48$var$XLSX.version, o);
    $b8f343bf88dacc48$var$write_XLWideString($b8f343bf88dacc48$var$XLSX.version, o);
    $b8f343bf88dacc48$var$write_XLWideString("7262", o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.301 BrtBookView */ function $b8f343bf88dacc48$var$write_BrtBookView(idx, o) {
    if (!o) o = $b8f343bf88dacc48$var$new_buf(29);
    o.write_shift(-4, 0);
    o.write_shift(-4, 460);
    o.write_shift(4, 28800);
    o.write_shift(4, 17600);
    o.write_shift(4, 500);
    o.write_shift(4, idx);
    o.write_shift(4, idx);
    var flags = 0x78;
    o.write_shift(1, flags);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $b8f343bf88dacc48$var$write_BOOKVIEWS(ba, wb /*::, opts*/ ) {
    /* required if hidden tab appears before visible tab */ if (!wb.Workbook || !wb.Workbook.Sheets) return;
    var sheets = wb.Workbook.Sheets;
    var i = 0, vistab = -1, hidden = -1;
    for(; i < sheets.length; ++i){
        if (!sheets[i] || !sheets[i].Hidden && vistab == -1) vistab = i;
        else if (sheets[i].Hidden == 1 && hidden == -1) hidden = i;
    }
    if (hidden > vistab) return;
    $b8f343bf88dacc48$var$write_record(ba, 0x0087 /* BrtBeginBookViews */ );
    $b8f343bf88dacc48$var$write_record(ba, 0x009E /* BrtBookView */ , $b8f343bf88dacc48$var$write_BrtBookView(vistab));
    /* 1*(BrtBookView *FRT) */ $b8f343bf88dacc48$var$write_record(ba, 0x0088 /* BrtEndBookViews */ );
}
function $b8f343bf88dacc48$var$write_BRTNAMES(ba, wb) {
    if (!wb.Workbook || !wb.Workbook.Names) return;
    wb.Workbook.Names.forEach(function(name) {
        try {
            if (name.Flags & 0x0e) return; // TODO: macro name write
            $b8f343bf88dacc48$var$write_record(ba, 0x0027 /* BrtName */ , $b8f343bf88dacc48$var$write_BrtName(name, wb));
        } catch (e) {
            console.error("Could not serialize defined name " + JSON.stringify(name));
        }
    });
}
function $b8f343bf88dacc48$var$write_SELF_EXTERNS_xlsb(wb) {
    var L = wb.SheetNames.length;
    var o = $b8f343bf88dacc48$var$new_buf(12 * L + 28);
    o.write_shift(4, L + 2);
    o.write_shift(4, 0);
    o.write_shift(4, -2);
    o.write_shift(4, -2); // workbook-level reference
    o.write_shift(4, 0);
    o.write_shift(4, -1);
    o.write_shift(4, -1); // #REF!...
    for(var i = 0; i < L; ++i){
        o.write_shift(4, 0);
        o.write_shift(4, i);
        o.write_shift(4, i);
    }
    return o;
}
function $b8f343bf88dacc48$var$write_EXTERNALS_xlsb(ba, wb) {
    $b8f343bf88dacc48$var$write_record(ba, 0x0161 /* BrtBeginExternals */ );
    $b8f343bf88dacc48$var$write_record(ba, 0x0165 /* BrtSupSelf */ );
    $b8f343bf88dacc48$var$write_record(ba, 0x016A /* BrtExternSheet */ , $b8f343bf88dacc48$var$write_SELF_EXTERNS_xlsb(wb, 0));
    $b8f343bf88dacc48$var$write_record(ba, 0x0162 /* BrtEndExternals */ );
}
/* [MS-XLSB] 2.4.305 BrtCalcProp */ /*function write_BrtCalcProp(data, o) {
	if(!o) o = new_buf(26);
	o.write_shift(4,0); // force recalc
	o.write_shift(4,1);
	o.write_shift(4,0);
	write_Xnum(0, o);
	o.write_shift(-4, 1023);
	o.write_shift(1, 0x33);
	o.write_shift(1, 0x00);
	return o;
}*/ /* [MS-XLSB] 2.4.646 BrtFileRecover */ /*function write_BrtFileRecover(data, o) {
	if(!o) o = new_buf(1);
	o.write_shift(1,0);
	return o;
}*/ /* [MS-XLSB] 2.1.7.61 Workbook */ function $b8f343bf88dacc48$var$write_wb_bin(wb, opts) {
    var ba = $b8f343bf88dacc48$var$buf_array();
    $b8f343bf88dacc48$var$write_record(ba, 0x0083 /* BrtBeginBook */ );
    $b8f343bf88dacc48$var$write_record(ba, 0x0080 /* BrtFileVersion */ , $b8f343bf88dacc48$var$write_BrtFileVersion());
    /* [[BrtFileSharingIso] BrtFileSharing] */ $b8f343bf88dacc48$var$write_record(ba, 0x0099 /* BrtWbProp */ , $b8f343bf88dacc48$var$write_BrtWbProp(wb.Workbook && wb.Workbook.WBProps || null));
    /* [ACABSPATH] */ /* [[BrtBookProtectionIso] BrtBookProtection] */ $b8f343bf88dacc48$var$write_BOOKVIEWS(ba, wb, opts);
    $b8f343bf88dacc48$var$write_BUNDLESHS(ba, wb, opts);
    /* [FNGROUP] */ $b8f343bf88dacc48$var$write_EXTERNALS_xlsb(ba, wb);
    if ((wb.Workbook || {}).Names) $b8f343bf88dacc48$var$write_BRTNAMES(ba, wb);
    /* write_record(ba, 0x009D BrtCalcProp, write_BrtCalcProp()); */ /* [BrtOleSize] */ /* *(BrtUserBookView *FRT) */ /* [PIVOTCACHEIDS] */ /* [BrtWbFactoid] */ /* [SMARTTAGTYPES] */ /* [BrtWebOpt] */ /* write_record(ba, 0x009B BrtFileRecover, write_BrtFileRecover()); */ /* [WEBPUBITEMS] */ /* [CRERRS] */ /* FRTWORKBOOK */ $b8f343bf88dacc48$var$write_record(ba, 0x0084 /* BrtEndBook */ );
    return ba.end();
}
function $b8f343bf88dacc48$var$parse_wb(data, name /*:string*/ , opts) /*:WorkbookFile*/ {
    if (name.slice(-4) === ".bin") return $b8f343bf88dacc48$var$parse_wb_bin(data /*:any*/ , opts);
    return $b8f343bf88dacc48$var$parse_wb_xml(data /*:any*/ , opts);
}
function $b8f343bf88dacc48$var$parse_ws(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $b8f343bf88dacc48$var$parse_ws_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $b8f343bf88dacc48$var$parse_ws_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $b8f343bf88dacc48$var$parse_cs(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $b8f343bf88dacc48$var$parse_cs_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $b8f343bf88dacc48$var$parse_cs_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $b8f343bf88dacc48$var$parse_ms(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $b8f343bf88dacc48$var$parse_ms_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $b8f343bf88dacc48$var$parse_ms_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $b8f343bf88dacc48$var$parse_ds(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $b8f343bf88dacc48$var$parse_ds_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $b8f343bf88dacc48$var$parse_ds_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $b8f343bf88dacc48$var$parse_sty(data, name /*:string*/ , themes, opts) {
    if (name.slice(-4) === ".bin") return $b8f343bf88dacc48$var$parse_sty_bin(data /*:any*/ , themes, opts);
    return $b8f343bf88dacc48$var$parse_sty_xml(data /*:any*/ , themes, opts);
}
function $b8f343bf88dacc48$var$parse_sst(data, name /*:string*/ , opts) /*:SST*/ {
    if (name.slice(-4) === ".bin") return $b8f343bf88dacc48$var$parse_sst_bin(data /*:any*/ , opts);
    return $b8f343bf88dacc48$var$parse_sst_xml(data /*:any*/ , opts);
}
function $b8f343bf88dacc48$var$parse_cmnt(data, name /*:string*/ , opts) /*:Array<RawComment>*/ {
    if (name.slice(-4) === ".bin") return $b8f343bf88dacc48$var$parse_comments_bin(data /*:any*/ , opts);
    return $b8f343bf88dacc48$var$parse_comments_xml(data /*:any*/ , opts);
}
function $b8f343bf88dacc48$var$parse_cc(data, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $b8f343bf88dacc48$var$parse_cc_bin(data /*:any*/ , name, opts);
    return $b8f343bf88dacc48$var$parse_cc_xml(data /*:any*/ , name, opts);
}
function $b8f343bf88dacc48$var$parse_xlink(data, rel, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $b8f343bf88dacc48$var$parse_xlink_bin(data /*:any*/ , rel, name, opts);
    return $b8f343bf88dacc48$var$parse_xlink_xml(data /*:any*/ , rel, name, opts);
}
function $b8f343bf88dacc48$var$parse_xlmeta(data, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $b8f343bf88dacc48$var$parse_xlmeta_bin(data /*:any*/ , name, opts);
    return $b8f343bf88dacc48$var$parse_xlmeta_xml(data /*:any*/ , name, opts);
}
var $b8f343bf88dacc48$var$attregexg2 = /\b((?:\w+:)?[\w]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
var $b8f343bf88dacc48$var$attregex2 = /\b((?:\w+:)?[\w]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
function $b8f343bf88dacc48$var$xlml_parsexmltag(tag /*:string*/ , skip_root /*:?boolean*/ ) {
    var words = tag.split(/\s+/);
    var z /*:any*/  = [];
    if (!skip_root) z[0] = words[0];
    if (words.length === 1) return z;
    var m = tag.match($b8f343bf88dacc48$var$attregexg2), y, j, w, i;
    if (m) for(i = 0; i != m.length; ++i){
        y = m[i].match($b8f343bf88dacc48$var$attregex2);
        /*:: if(!y || !y[2]) continue; */ if ((j = y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1, y[2].length - 1);
        else {
            if (y[1].slice(0, 6) === "xmlns:") w = "xmlns" + y[1].slice(6);
            else w = y[1].slice(j + 1);
            z[w] = y[2].slice(1, y[2].length - 1);
        }
    }
    return z;
}
function $b8f343bf88dacc48$var$xlml_parsexmltagobj(tag /*:string*/ ) {
    var words = tag.split(/\s+/);
    var z = {};
    if (words.length === 1) return z;
    var m = tag.match($b8f343bf88dacc48$var$attregexg2), y, j, w, i;
    if (m) for(i = 0; i != m.length; ++i){
        y = m[i].match($b8f343bf88dacc48$var$attregex2);
        /*:: if(!y || !y[2]) continue; */ if ((j = y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1, y[2].length - 1);
        else {
            if (y[1].slice(0, 6) === "xmlns:") w = "xmlns" + y[1].slice(6);
            else w = y[1].slice(j + 1);
            z[w] = y[2].slice(1, y[2].length - 1);
        }
    }
    return z;
}
// ----
/* map from xlml named formats to SSF TODO: localize */ var $b8f343bf88dacc48$var$XLMLFormatMap /*: {[string]:string}*/ ;
function $b8f343bf88dacc48$var$xlml_format(format, value, date1904) /*:string*/ {
    var fmt = $b8f343bf88dacc48$var$XLMLFormatMap[format] || $b8f343bf88dacc48$var$unescapexml(format);
    if (fmt === "General") return $b8f343bf88dacc48$var$SSF_general(value);
    return $b8f343bf88dacc48$var$SSF_format(fmt, value, {
        date1904: !!date1904
    });
}
function $b8f343bf88dacc48$var$xlml_set_custprop(Custprops, key, cp, val /*:string*/ ) {
    var oval /*:any*/  = val;
    switch((cp[0].match(/dt:dt="([\w.]+)"/) || [
        "",
        ""
    ])[1]){
        case "boolean":
            oval = $b8f343bf88dacc48$var$parsexmlbool(val);
            break;
        case "i2":
        case "int":
            oval = parseInt(val, 10);
            break;
        case "r4":
        case "float":
            oval = parseFloat(val);
            break;
        case "date":
        case "dateTime.tz":
            oval = $b8f343bf88dacc48$var$parseDate(val);
            break;
        case "i8":
        case "string":
        case "fixed":
        case "uuid":
        case "bin.base64":
            break;
        default:
            throw new Error("bad custprop:" + cp[0]);
    }
    Custprops[$b8f343bf88dacc48$var$unescapexml(key)] = oval;
}
function $b8f343bf88dacc48$var$safe_format_xlml(cell /*:Cell*/ , nf, o, date1904) {
    if (cell.t === 'z') return;
    if (!o || o.cellText !== false) try {
        if (cell.t === 'e') cell.w = cell.w || $b8f343bf88dacc48$var$BErr[cell.v];
        else if (nf === "General") {
            if (cell.t === 'n') {
                if ((cell.v | 0) === cell.v) cell.w = cell.v.toString(10);
                else cell.w = $b8f343bf88dacc48$var$SSF_general_num(cell.v);
            } else cell.w = $b8f343bf88dacc48$var$SSF_general(cell.v);
        } else cell.w = $b8f343bf88dacc48$var$xlml_format(nf || "General", cell.v, date1904);
    } catch (e) {
        if (o.WTF) throw e;
    }
    try {
        var z = $b8f343bf88dacc48$var$XLMLFormatMap[nf] || nf || "General";
        if (o.cellNF) cell.z = z;
        if (o.cellDates && cell.t == 'n' && $b8f343bf88dacc48$var$fmt_is_date(z)) {
            var _d = $b8f343bf88dacc48$var$SSF_parse_date_code(cell.v + (date1904 ? 1462 : 0));
            if (_d) {
                cell.t = 'd';
                cell.v = new Date(Date.UTC(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u));
            }
        }
    } catch (e) {
        if (o.WTF) throw e;
    }
}
function $b8f343bf88dacc48$var$process_style_xlml(styles, stag, opts) {
    if (opts.cellStyles) {
        if (stag.Interior) {
            var I = stag.Interior;
            if (I.Pattern) I.patternType = $b8f343bf88dacc48$var$XLMLPatternTypeMap[I.Pattern] || I.Pattern;
        }
    }
    styles[stag.ID] = stag;
}
/* TODO: there must exist some form of OSP-blessed spec */ function $b8f343bf88dacc48$var$parse_xlml_data(xml, ss, data, cell /*:any*/ , base, styles, csty, row, arrayf, o, date1904) {
    var nf = "General", sid = cell.StyleID, S = {};
    o = o || {};
    var interiors = [];
    var i = 0;
    if (sid === undefined && row) sid = row.StyleID;
    if (sid === undefined && csty) sid = csty.StyleID;
    while(styles[sid] !== undefined){
        var ssid = styles[sid];
        if (ssid.nf) nf = ssid.nf;
        if (ssid.Interior) interiors.push(ssid.Interior);
        if (!ssid.Parent) break;
        sid = ssid.Parent;
    }
    switch(data.Type){
        case 'Boolean':
            cell.t = 'b';
            cell.v = $b8f343bf88dacc48$var$parsexmlbool(xml);
            break;
        case 'String':
            cell.t = 's';
            cell.r = $b8f343bf88dacc48$var$xlml_fixstr($b8f343bf88dacc48$var$unescapexml(xml));
            cell.v = xml.indexOf("<") > -1 ? $b8f343bf88dacc48$var$unescapexml(ss || xml).replace(/<[^<>]*>/g, "") : cell.r; // todo: BR etc
            break;
        case 'DateTime':
            if (xml.slice(-1) != "Z") xml += "Z";
            cell.v = $b8f343bf88dacc48$var$datenum($b8f343bf88dacc48$var$parseDate(xml, date1904), date1904);
            if (cell.v !== cell.v) cell.v = $b8f343bf88dacc48$var$unescapexml(xml);
            if (!nf || nf == "General") nf = "yyyy-mm-dd";
        /* falls through */ case 'Number':
            if (cell.v === undefined) cell.v = +xml;
            if (!cell.t) cell.t = 'n';
            break;
        case 'Error':
            cell.t = 'e';
            cell.v = $b8f343bf88dacc48$var$RBErr[xml];
            if (o.cellText !== false) cell.w = xml;
            break;
        default:
            if (xml == "" && ss == "") cell.t = 'z';
            else {
                cell.t = 's';
                cell.v = $b8f343bf88dacc48$var$xlml_fixstr(ss || xml);
            }
            break;
    }
    $b8f343bf88dacc48$var$safe_format_xlml(cell, nf, o, date1904);
    if (o.cellFormula !== false) {
        if (cell.Formula) {
            var fstr = $b8f343bf88dacc48$var$unescapexml(cell.Formula);
            /* strictly speaking, the leading = is required but some writers omit */ if (fstr.charCodeAt(0) == 61 /* = */ ) fstr = fstr.slice(1);
            cell.f = $b8f343bf88dacc48$var$rc_to_a1(fstr, base);
            delete cell.Formula;
            if (cell.ArrayRange == "RC") cell.F = $b8f343bf88dacc48$var$rc_to_a1("RC:RC", base);
            else if (cell.ArrayRange) {
                cell.F = $b8f343bf88dacc48$var$rc_to_a1(cell.ArrayRange, base);
                arrayf.push([
                    $b8f343bf88dacc48$var$safe_decode_range(cell.F),
                    cell.F
                ]);
            }
        } else {
            for(i = 0; i < arrayf.length; ++i)if (base.r >= arrayf[i][0].s.r && base.r <= arrayf[i][0].e.r) {
                if (base.c >= arrayf[i][0].s.c && base.c <= arrayf[i][0].e.c) cell.F = arrayf[i][1];
            }
        }
    }
    if (o.cellStyles) {
        interiors.forEach(function(x) {
            if (!S.patternType && x.patternType) S.patternType = x.patternType;
        });
        cell.s = S;
    }
    if (cell.StyleID !== undefined) cell.ixfe = cell.StyleID;
}
function $b8f343bf88dacc48$var$xlml_prefix_dname(dname) {
    return $b8f343bf88dacc48$var$XLSLblBuiltIn.indexOf("_xlnm." + dname) > -1 ? "_xlnm." + dname : dname;
}
function $b8f343bf88dacc48$var$xlml_clean_comment(comment /*:any*/ ) {
    comment.t = comment.v || "";
    comment.t = comment.t.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    comment.v = comment.w = comment.ixfe = undefined;
}
/* TODO: Everything */ function $b8f343bf88dacc48$var$parse_xlml_xml(d, _opts) /*:Workbook*/ {
    var opts = _opts || {};
    $b8f343bf88dacc48$var$make_ssf();
    var str = $b8f343bf88dacc48$var$debom($b8f343bf88dacc48$var$xlml_normalize(d));
    if (opts.type == 'binary' || opts.type == 'array' || opts.type == 'base64') {
        if (typeof $b8f343bf88dacc48$var$$cptable !== 'undefined') str = $b8f343bf88dacc48$var$$cptable.utils.decode(65001, $b8f343bf88dacc48$var$char_codes(str));
        else str = $b8f343bf88dacc48$var$utf8read(str);
    }
    var opening = str.slice(0, 1024).toLowerCase(), ishtml = false;
    opening = opening.replace(/".*?"/g, "");
    if ((opening.indexOf(">") & 1023) > Math.min(opening.indexOf(",") & 1023, opening.indexOf(";") & 1023)) {
        var _o = $b8f343bf88dacc48$var$dup(opts);
        _o.type = "string";
        return $b8f343bf88dacc48$var$PRN.to_workbook(str, _o);
    }
    if (opening.indexOf("<?xml") == -1) [
        "html",
        "table",
        "head",
        "meta",
        "script",
        "style",
        "div"
    ].forEach(function(tag) {
        if (opening.indexOf("<" + tag) >= 0) ishtml = true;
    });
    if (ishtml) return $b8f343bf88dacc48$var$html_to_workbook(str, opts);
    $b8f343bf88dacc48$var$XLMLFormatMap = {
        "General Number": "General",
        "General Date": $b8f343bf88dacc48$var$table_fmt[22],
        "Long Date": "dddd, mmmm dd, yyyy",
        "Medium Date": $b8f343bf88dacc48$var$table_fmt[15],
        "Short Date": $b8f343bf88dacc48$var$table_fmt[14],
        "Long Time": $b8f343bf88dacc48$var$table_fmt[19],
        "Medium Time": $b8f343bf88dacc48$var$table_fmt[18],
        "Short Time": $b8f343bf88dacc48$var$table_fmt[20],
        "Currency": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
        "Fixed": $b8f343bf88dacc48$var$table_fmt[2],
        "Standard": $b8f343bf88dacc48$var$table_fmt[4],
        "Percent": $b8f343bf88dacc48$var$table_fmt[10],
        "Scientific": $b8f343bf88dacc48$var$table_fmt[11],
        "Yes/No": '"Yes";"Yes";"No";@',
        "True/False": '"True";"True";"False";@',
        "On/Off": '"Yes";"Yes";"No";@'
    } /*:any*/ ;
    var Rn;
    var state = [], tmp;
    if ($b8f343bf88dacc48$var$DENSE != null && opts.dense == null) opts.dense = $b8f343bf88dacc48$var$DENSE;
    var sheets = {}, sheetnames /*:Array<string>*/  = [], cursheet /*:Worksheet*/  = {}, sheetname = "";
    if (opts.dense) cursheet["!data"] = [];
    var cell = {} /*:any*/ , row = {}; // eslint-disable-line no-unused-vars
    var dtag = $b8f343bf88dacc48$var$xlml_parsexmltag('<Data ss:Type="String">'), didx = 0;
    var c = 0, r = 0;
    var refguess /*:Range*/  = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var styles = {}, stag = {};
    var ss = "", fidx = 0;
    var merges /*:Array<Range>*/  = [];
    var Props = {}, Custprops = {}, pidx = 0, cp = [];
    var comments /*:Array<Comment>*/  = [], comment /*:Comment*/  = {} /*:any*/ ;
    var cstys = [], csty, seencol = false;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var rowinfo /*:Array<RowInfo>*/  = [], rowobj = {}, cc = 0, rr = 0;
    var Workbook /*:WBWBProps*/  = {
        Sheets: [],
        WBProps: {
            date1904: false
        }
    } /*:any*/ , wsprops = {};
    $b8f343bf88dacc48$var$xlmlregex.lastIndex = 0;
    str = $b8f343bf88dacc48$var$str_remove_ng(str, "<!--", "-->");
    var raw_Rn3 = "";
    while(Rn = $b8f343bf88dacc48$var$xlmlregex.exec(str))switch(Rn[3] = (raw_Rn3 = Rn[3]).toLowerCase()){
        case 'data' /*case 'Data'*/ :
            if (raw_Rn3 == "data") {
                if (Rn[1] === '/') {
                    if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                    Rn[3],
                    true
                ]);
                break;
            }
            if (state[state.length - 1][1]) break;
            if (Rn[1] === '/') $b8f343bf88dacc48$var$parse_xlml_data(str.slice(didx, Rn.index), ss, dtag, state[state.length - 1][0] == /*"Comment"*/ "comment" ? comment : cell, {
                c: c,
                r: r
            }, styles, cstys[c], row, arrayf, opts, Workbook.WBProps.date1904);
            else {
                ss = "";
                dtag = $b8f343bf88dacc48$var$xlml_parsexmltag(Rn[0]);
                didx = Rn.index + Rn[0].length;
            }
            break;
        case 'cell' /*case 'Cell'*/ :
            if (Rn[1] === '/') {
                if (comments.length > 0) cell.c = comments;
                if ((!opts.sheetRows || opts.sheetRows > r) && cell.v !== void 0) {
                    if (opts.dense) {
                        if (!cursheet["!data"][r]) cursheet["!data"][r] = [];
                        cursheet["!data"][r][c] = cell;
                    } else cursheet[$b8f343bf88dacc48$var$encode_col(c) + $b8f343bf88dacc48$var$encode_row(r)] = cell;
                }
                if (cell.HRef) {
                    cell.l = {
                        Target: $b8f343bf88dacc48$var$unescapexml(cell.HRef)
                    } /*:any*/ ;
                    if (cell.HRefScreenTip) cell.l.Tooltip = cell.HRefScreenTip;
                    delete cell.HRef;
                    delete cell.HRefScreenTip;
                }
                if (cell.MergeAcross || cell.MergeDown) {
                    cc = c + (parseInt(cell.MergeAcross, 10) | 0);
                    rr = r + (parseInt(cell.MergeDown, 10) | 0);
                    if (cc > c || rr > r) merges.push({
                        s: {
                            c: c,
                            r: r
                        },
                        e: {
                            c: cc,
                            r: rr
                        }
                    });
                }
                if (!opts.sheetStubs) {
                    if (cell.MergeAcross) c = cc + 1;
                    else ++c;
                } else if (cell.MergeAcross || cell.MergeDown) {
                    /*:: if(!cc) cc = 0; if(!rr) rr = 0; */ for(var cma = c; cma <= cc; ++cma){
                        for(var cmd = r; cmd <= rr; ++cmd)if (cma > c || cmd > r) {
                            if (opts.dense) {
                                if (!cursheet["!data"][cmd]) cursheet["!data"][cmd] = [];
                                cursheet["!data"][cmd][cma] = {
                                    t: 'z'
                                };
                            } else cursheet[$b8f343bf88dacc48$var$encode_col(cma) + $b8f343bf88dacc48$var$encode_row(cmd)] = {
                                t: 'z'
                            };
                        }
                    }
                    c = cc + 1;
                } else ++c;
            } else {
                cell = $b8f343bf88dacc48$var$xlml_parsexmltagobj(Rn[0]);
                if (cell.Index) c = +cell.Index - 1;
                if (c < refguess.s.c) refguess.s.c = c;
                if (c > refguess.e.c) refguess.e.c = c;
                if (Rn[0].slice(-2) === "/>") ++c;
                comments = [];
            }
            break;
        case 'row' /*case 'Row'*/ :
            if (Rn[1] === '/' || Rn[0].slice(-2) === "/>") {
                if (r < refguess.s.r) refguess.s.r = r;
                if (r > refguess.e.r) refguess.e.r = r;
                if (Rn[0].slice(-2) === "/>") {
                    row = $b8f343bf88dacc48$var$xlml_parsexmltag(Rn[0]);
                    if (row.Index) r = +row.Index - 1;
                }
                c = 0;
                ++r;
            } else {
                row = $b8f343bf88dacc48$var$xlml_parsexmltag(Rn[0]);
                if (row.Index) r = +row.Index - 1;
                rowobj = {};
                if (row.AutoFitHeight == "0" || row.Height) {
                    rowobj.hpx = parseInt(row.Height, 10);
                    rowobj.hpt = $b8f343bf88dacc48$var$px2pt(rowobj.hpx);
                    rowinfo[r] = rowobj;
                }
                if (row.Hidden == "1") {
                    rowobj.hidden = true;
                    rowinfo[r] = rowobj;
                }
            }
            break;
        case 'worksheet' /*case 'Worksheet'*/ :
            /* TODO: read range from FullRows/FullColumns */ if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                sheetnames.push(sheetname);
                if (refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c) {
                    cursheet["!ref"] = $b8f343bf88dacc48$var$encode_range(refguess);
                    if (opts.sheetRows && opts.sheetRows <= refguess.e.r) {
                        cursheet["!fullref"] = cursheet["!ref"];
                        refguess.e.r = opts.sheetRows - 1;
                        cursheet["!ref"] = $b8f343bf88dacc48$var$encode_range(refguess);
                    }
                }
                if (merges.length) cursheet["!merges"] = merges;
                if (cstys.length > 0) cursheet["!cols"] = cstys;
                if (rowinfo.length > 0) cursheet["!rows"] = rowinfo;
                sheets[sheetname] = cursheet;
            } else {
                refguess = {
                    s: {
                        r: 2000000,
                        c: 2000000
                    },
                    e: {
                        r: 0,
                        c: 0
                    }
                };
                r = c = 0;
                state.push([
                    Rn[3],
                    false
                ]);
                tmp = $b8f343bf88dacc48$var$xlml_parsexmltag(Rn[0]);
                sheetname = $b8f343bf88dacc48$var$unescapexml(tmp.Name);
                cursheet = {};
                if (opts.dense) cursheet["!data"] = [];
                merges = [];
                arrayf = [];
                rowinfo = [];
                wsprops = {
                    name: sheetname,
                    Hidden: 0
                };
                Workbook.Sheets.push(wsprops);
            }
            break;
        case 'table' /*case 'Table'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].slice(-2) == "/>") break;
            else {
                state.push([
                    Rn[3],
                    false
                ]);
                cstys = [];
                seencol = false;
            }
            break;
        case 'style' /*case 'Style'*/ :
            if (Rn[1] === '/') $b8f343bf88dacc48$var$process_style_xlml(styles, stag, opts);
            else stag = $b8f343bf88dacc48$var$xlml_parsexmltag(Rn[0]);
            break;
        case 'numberformat' /*case 'NumberFormat'*/ :
            stag.nf = $b8f343bf88dacc48$var$unescapexml($b8f343bf88dacc48$var$xlml_parsexmltag(Rn[0]).Format || "General");
            if ($b8f343bf88dacc48$var$XLMLFormatMap[stag.nf]) stag.nf = $b8f343bf88dacc48$var$XLMLFormatMap[stag.nf];
            for(var ssfidx = 0; ssfidx != 0x188; ++ssfidx)if ($b8f343bf88dacc48$var$table_fmt[ssfidx] == stag.nf) break;
            if (ssfidx == 0x188) {
                for(ssfidx = 0x39; ssfidx != 0x188; ++ssfidx)if ($b8f343bf88dacc48$var$table_fmt[ssfidx] == null) {
                    $b8f343bf88dacc48$var$SSF__load(stag.nf, ssfidx);
                    break;
                }
            }
            break;
        case 'column' /*case 'Column'*/ :
            if (state[state.length - 1][0] !== /*'Table'*/ 'table') break;
            if (Rn[1] === '/') break;
            csty = $b8f343bf88dacc48$var$xlml_parsexmltag(Rn[0]);
            if (csty.Hidden) {
                csty.hidden = true;
                delete csty.Hidden;
            }
            if (csty.Width) csty.wpx = parseInt(csty.Width, 10);
            if (!seencol && csty.wpx > 10) {
                seencol = true;
                $b8f343bf88dacc48$var$MDW = $b8f343bf88dacc48$var$DEF_MDW; //find_mdw_wpx(csty.wpx);
                for(var _col = 0; _col < cstys.length; ++_col)if (cstys[_col]) $b8f343bf88dacc48$var$process_col(cstys[_col]);
            }
            if (seencol) $b8f343bf88dacc48$var$process_col(csty);
            cstys[csty.Index - 1 || cstys.length] = csty;
            for(var i = 0; i < +csty.Span; ++i)cstys[cstys.length] = $b8f343bf88dacc48$var$dup(csty);
            break;
        case 'namedrange' /*case 'NamedRange'*/ :
            if (Rn[1] === '/') break;
            if (!Workbook.Names) Workbook.Names = [];
            var _NamedRange = $b8f343bf88dacc48$var$parsexmltag(Rn[0]);
            var _DefinedName /*:DefinedName*/  = {
                Name: $b8f343bf88dacc48$var$xlml_prefix_dname(_NamedRange.Name),
                Ref: $b8f343bf88dacc48$var$rc_to_a1(_NamedRange.RefersTo.slice(1), {
                    r: 0,
                    c: 0
                })
            } /*:any*/ ;
            if (Workbook.Sheets.length > 0) _DefinedName.Sheet = Workbook.Sheets.length - 1;
            /*:: if(Workbook.Names) */ Workbook.Names.push(_DefinedName);
            break;
        case 'namedcell' /*case 'NamedCell'*/ :
            break;
        case 'b' /*case 'B'*/ :
            break;
        case 'i' /*case 'I'*/ :
            break;
        case 'u' /*case 'U'*/ :
            break;
        case 's' /*case 'S'*/ :
            break;
        case 'em' /*case 'EM'*/ :
            break;
        case 'h2' /*case 'H2'*/ :
            break;
        case 'h3' /*case 'H3'*/ :
            break;
        case 'sub' /*case 'Sub'*/ :
            break;
        case 'sup' /*case 'Sup'*/ :
            break;
        case 'span' /*case 'Span'*/ :
            break;
        case 'alignment' /*case 'Alignment'*/ :
            break;
        case 'borders' /*case 'Borders'*/ :
            break;
        case 'border' /*case 'Border'*/ :
            break;
        case 'font' /*case 'Font'*/ :
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") ss += str.slice(fidx, Rn.index);
            else fidx = Rn.index + Rn[0].length;
            break;
        case 'interior' /*case 'Interior'*/ :
            if (!opts.cellStyles) break;
            stag.Interior = $b8f343bf88dacc48$var$xlml_parsexmltag(Rn[0]);
            break;
        case 'protection' /*case 'Protection'*/ :
            break;
        case 'author' /*case 'Author'*/ :
        case 'title' /*case 'Title'*/ :
        case 'description' /*case 'Description'*/ :
        case 'created' /*case 'Created'*/ :
        case 'keywords' /*case 'Keywords'*/ :
        case 'subject' /*case 'Subject'*/ :
        case 'category' /*case 'Category'*/ :
        case 'company' /*case 'Company'*/ :
        case 'lastauthor' /*case 'LastAuthor'*/ :
        case 'lastsaved' /*case 'LastSaved'*/ :
        case 'lastprinted' /*case 'LastPrinted'*/ :
        case 'version' /*case 'Version'*/ :
        case 'revision' /*case 'Revision'*/ :
        case 'totaltime' /*case 'TotalTime'*/ :
        case 'hyperlinkbase' /*case 'HyperlinkBase'*/ :
        case 'manager' /*case 'Manager'*/ :
        case 'contentstatus' /*case 'ContentStatus'*/ :
        case 'identifier' /*case 'Identifier'*/ :
        case 'language' /*case 'Language'*/ :
        case 'appname' /*case 'AppName'*/ :
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") $b8f343bf88dacc48$var$xlml_set_prop(Props, raw_Rn3, str.slice(pidx, Rn.index));
            else pidx = Rn.index + Rn[0].length;
            break;
        case 'paragraphs' /*case 'Paragraphs'*/ :
            break;
        case 'styles' /*case 'Styles'*/ :
        case 'workbook' /*case 'Workbook'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else state.push([
                Rn[3],
                false
            ]);
            break;
        case 'comment' /*case 'Comment'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                $b8f343bf88dacc48$var$xlml_clean_comment(comment);
                comments.push(comment);
            } else {
                state.push([
                    Rn[3],
                    false
                ]);
                tmp = $b8f343bf88dacc48$var$xlml_parsexmltag(Rn[0]);
                if (!$b8f343bf88dacc48$var$parsexmlbool(tmp["ShowAlways"] || "0")) comments.hidden = true;
                comment = {
                    a: tmp.Author
                } /*:any*/ ;
            }
            break;
        case 'autofilter' /*case 'AutoFilter'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                var AutoFilter = $b8f343bf88dacc48$var$xlml_parsexmltag(Rn[0]);
                cursheet['!autofilter'] = {
                    ref: $b8f343bf88dacc48$var$rc_to_a1(AutoFilter.Range).replace(/\$/g, "")
                };
                state.push([
                    Rn[3],
                    true
                ]);
            }
            break;
        case 'name' /*case 'Name'*/ :
            break;
        case 'datavalidation' /*case 'DataValidation'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                true
            ]);
            break;
        case 'pixelsperinch' /*case 'PixelsPerInch'*/ :
            break;
        case 'componentoptions' /*case 'ComponentOptions'*/ :
        case 'documentproperties' /*case 'DocumentProperties'*/ :
        case 'customdocumentproperties' /*case 'CustomDocumentProperties'*/ :
        case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/ :
        case 'pivottable' /*case 'PivotTable'*/ :
        case 'pivotcache' /*case 'PivotCache'*/ :
        case 'names' /*case 'Names'*/ :
        case 'mapinfo' /*case 'MapInfo'*/ :
        case 'pagebreaks' /*case 'PageBreaks'*/ :
        case 'querytable' /*case 'QueryTable'*/ :
        case 'sorting' /*case 'Sorting'*/ :
        case 'schema' /*case 'Schema'*/ :
        case 'conditionalformatting' /*case 'ConditionalFormatting'*/ :
        case 'smarttagtype' /*case 'SmartTagType'*/ :
        case 'smarttags' /*case 'SmartTags'*/ :
        case 'excelworkbook' /*case 'ExcelWorkbook'*/ :
        case 'workbookoptions' /*case 'WorkbookOptions'*/ :
        case 'worksheetoptions' /*case 'WorksheetOptions'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                true
            ]);
            break;
        case 'null' /*case 'Null'*/ :
            break;
        default:
            /* FODS file root is <office:document> */ if (state.length == 0 && Rn[3] == "document") return $b8f343bf88dacc48$var$parse_fods(str, opts);
            /* UOS file root is <uof:UOF> */ if (state.length == 0 && Rn[3] == "uof" /*"UOF"*/ ) return $b8f343bf88dacc48$var$parse_fods(str, opts);
            var seen = true;
            switch(state[state.length - 1][0]){
                /* OfficeDocumentSettings */ case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/ :
                    switch(Rn[3]){
                        case 'allowpng' /*case 'AllowPNG'*/ :
                            break;
                        case 'removepersonalinformation' /*case 'RemovePersonalInformation'*/ :
                            break;
                        case 'downloadcomponents' /*case 'DownloadComponents'*/ :
                            break;
                        case 'locationofcomponents' /*case 'LocationOfComponents'*/ :
                            break;
                        case 'colors' /*case 'Colors'*/ :
                            break;
                        case 'color' /*case 'Color'*/ :
                            break;
                        case 'index' /*case 'Index'*/ :
                            break;
                        case 'rgb' /*case 'RGB'*/ :
                            break;
                        case 'targetscreensize' /*case 'TargetScreenSize'*/ :
                            break;
                        case 'readonlyrecommended' /*case 'ReadOnlyRecommended'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* ComponentOptions */ case 'componentoptions' /*case 'ComponentOptions'*/ :
                    switch(Rn[3]){
                        case 'toolbar' /*case 'Toolbar'*/ :
                            break;
                        case 'hideofficelogo' /*case 'HideOfficeLogo'*/ :
                            break;
                        case 'spreadsheetautofit' /*case 'SpreadsheetAutoFit'*/ :
                            break;
                        case 'label' /*case 'Label'*/ :
                            break;
                        case 'caption' /*case 'Caption'*/ :
                            break;
                        case 'maxheight' /*case 'MaxHeight'*/ :
                            break;
                        case 'maxwidth' /*case 'MaxWidth'*/ :
                            break;
                        case 'nextsheetnumber' /*case 'NextSheetNumber'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* ExcelWorkbook */ case 'excelworkbook' /*case 'ExcelWorkbook'*/ :
                    switch(Rn[3]){
                        case 'date1904' /*case 'Date1904'*/ :
                            /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ Workbook.WBProps.date1904 = true;
                            break;
                        case 'hidehorizontalscrollbar' /*case 'HideHorizontalScrollBar'*/ :
                            break;
                        case 'hideverticalscrollbar' /*case 'HideVerticalScrollBar'*/ :
                            break;
                        case 'hideworkbooktabs' /*case 'HideWorkbookTabs'*/ :
                            break;
                        case 'windowheight' /*case 'WindowHeight'*/ :
                            break;
                        case 'windowwidth' /*case 'WindowWidth'*/ :
                            break;
                        case 'windowtopx' /*case 'WindowTopX'*/ :
                            break;
                        case 'windowtopy' /*case 'WindowTopY'*/ :
                            break;
                        case 'tabratio' /*case 'TabRatio'*/ :
                            break;
                        case 'protectstructure' /*case 'ProtectStructure'*/ :
                            break;
                        case 'protectwindow' /*case 'ProtectWindow'*/ :
                            break;
                        case 'protectwindows' /*case 'ProtectWindows'*/ :
                            break;
                        case 'activesheet' /*case 'ActiveSheet'*/ :
                            break;
                        case 'displayinknotes' /*case 'DisplayInkNotes'*/ :
                            break;
                        case 'firstvisiblesheet' /*case 'FirstVisibleSheet'*/ :
                            break;
                        case 'supbook' /*case 'SupBook'*/ :
                            break;
                        case 'sheetname' /*case 'SheetName'*/ :
                            break;
                        case 'sheetindex' /*case 'SheetIndex'*/ :
                            break;
                        case 'sheetindexfirst' /*case 'SheetIndexFirst'*/ :
                            break;
                        case 'sheetindexlast' /*case 'SheetIndexLast'*/ :
                            break;
                        case 'dll' /*case 'Dll'*/ :
                            break;
                        case 'acceptlabelsinformulas' /*case 'AcceptLabelsInFormulas'*/ :
                            break;
                        case 'donotsavelinkvalues' /*case 'DoNotSaveLinkValues'*/ :
                            break;
                        case 'iteration' /*case 'Iteration'*/ :
                            break;
                        case 'maxiterations' /*case 'MaxIterations'*/ :
                            break;
                        case 'maxchange' /*case 'MaxChange'*/ :
                            break;
                        case 'path' /*case 'Path'*/ :
                            break;
                        case 'xct' /*case 'Xct'*/ :
                            break;
                        case 'count' /*case 'Count'*/ :
                            break;
                        case 'selectedsheets' /*case 'SelectedSheets'*/ :
                            break;
                        case 'calculation' /*case 'Calculation'*/ :
                            break;
                        case 'uncalced' /*case 'Uncalced'*/ :
                            break;
                        case 'startupprompt' /*case 'StartupPrompt'*/ :
                            break;
                        case 'crn' /*case 'Crn'*/ :
                            break;
                        case 'externname' /*case 'ExternName'*/ :
                            break;
                        case 'formula' /*case 'Formula'*/ :
                            break;
                        case 'colfirst' /*case 'ColFirst'*/ :
                            break;
                        case 'collast' /*case 'ColLast'*/ :
                            break;
                        case 'wantadvise' /*case 'WantAdvise'*/ :
                            break;
                        case 'boolean' /*case 'Boolean'*/ :
                            break;
                        case 'error' /*case 'Error'*/ :
                            break;
                        case 'text' /*case 'Text'*/ :
                            break;
                        case 'ole' /*case 'OLE'*/ :
                            break;
                        case 'noautorecover' /*case 'NoAutoRecover'*/ :
                            break;
                        case 'publishobjects' /*case 'PublishObjects'*/ :
                            break;
                        case 'donotcalculatebeforesave' /*case 'DoNotCalculateBeforeSave'*/ :
                            break;
                        case 'number' /*case 'Number'*/ :
                            break;
                        case 'refmoder1c1' /*case 'RefModeR1C1'*/ :
                            break;
                        case 'embedsavesmarttags' /*case 'EmbedSaveSmartTags'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* WorkbookOptions */ case 'workbookoptions' /*case 'WorkbookOptions'*/ :
                    switch(Rn[3]){
                        case 'owcversion' /*case 'OWCVersion'*/ :
                            break;
                        case 'height' /*case 'Height'*/ :
                            break;
                        case 'width' /*case 'Width'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* WorksheetOptions */ case 'worksheetoptions' /*case 'WorksheetOptions'*/ :
                    switch(Rn[3]){
                        case 'visible' /*case 'Visible'*/ :
                            if (Rn[0].slice(-2) === "/>") ;
                            else if (Rn[1] === "/") switch(str.slice(pidx, Rn.index)){
                                case "SheetHidden":
                                    wsprops.Hidden = 1;
                                    break;
                                case "SheetVeryHidden":
                                    wsprops.Hidden = 2;
                                    break;
                            }
                            else pidx = Rn.index + Rn[0].length;
                            break;
                        case 'header' /*case 'Header'*/ :
                            if (!cursheet['!margins']) $b8f343bf88dacc48$var$default_margins(cursheet['!margins'] = {}, 'xlml');
                            if (!isNaN(+$b8f343bf88dacc48$var$parsexmltag(Rn[0]).Margin)) cursheet['!margins'].header = +$b8f343bf88dacc48$var$parsexmltag(Rn[0]).Margin;
                            break;
                        case 'footer' /*case 'Footer'*/ :
                            if (!cursheet['!margins']) $b8f343bf88dacc48$var$default_margins(cursheet['!margins'] = {}, 'xlml');
                            if (!isNaN(+$b8f343bf88dacc48$var$parsexmltag(Rn[0]).Margin)) cursheet['!margins'].footer = +$b8f343bf88dacc48$var$parsexmltag(Rn[0]).Margin;
                            break;
                        case 'pagemargins' /*case 'PageMargins'*/ :
                            var pagemargins = $b8f343bf88dacc48$var$parsexmltag(Rn[0]);
                            if (!cursheet['!margins']) $b8f343bf88dacc48$var$default_margins(cursheet['!margins'] = {}, 'xlml');
                            if (!isNaN(+pagemargins.Top)) cursheet['!margins'].top = +pagemargins.Top;
                            if (!isNaN(+pagemargins.Left)) cursheet['!margins'].left = +pagemargins.Left;
                            if (!isNaN(+pagemargins.Right)) cursheet['!margins'].right = +pagemargins.Right;
                            if (!isNaN(+pagemargins.Bottom)) cursheet['!margins'].bottom = +pagemargins.Bottom;
                            break;
                        case 'displayrighttoleft' /*case 'DisplayRightToLeft'*/ :
                            if (!Workbook.Views) Workbook.Views = [];
                            if (!Workbook.Views[0]) Workbook.Views[0] = {};
                            Workbook.Views[0].RTL = true;
                            break;
                        case 'freezepanes' /*case 'FreezePanes'*/ :
                            break;
                        case 'frozennosplit' /*case 'FrozenNoSplit'*/ :
                            break;
                        case 'splithorizontal' /*case 'SplitHorizontal'*/ :
                        case 'splitvertical' /*case 'SplitVertical'*/ :
                            break;
                        case 'donotdisplaygridlines' /*case 'DoNotDisplayGridlines'*/ :
                            break;
                        case 'activerow' /*case 'ActiveRow'*/ :
                            break;
                        case 'activecol' /*case 'ActiveCol'*/ :
                            break;
                        case 'toprowbottompane' /*case 'TopRowBottomPane'*/ :
                            break;
                        case 'leftcolumnrightpane' /*case 'LeftColumnRightPane'*/ :
                            break;
                        case 'unsynced' /*case 'Unsynced'*/ :
                            break;
                        case 'print' /*case 'Print'*/ :
                            break;
                        case 'printerrors' /*case 'PrintErrors'*/ :
                            break;
                        case 'panes' /*case 'Panes'*/ :
                            break;
                        case 'scale' /*case 'Scale'*/ :
                            break;
                        case 'pane' /*case 'Pane'*/ :
                            break;
                        case 'number' /*case 'Number'*/ :
                            break;
                        case 'layout' /*case 'Layout'*/ :
                            break;
                        case 'pagesetup' /*case 'PageSetup'*/ :
                            break;
                        case 'selected' /*case 'Selected'*/ :
                            break;
                        case 'protectobjects' /*case 'ProtectObjects'*/ :
                            break;
                        case 'enableselection' /*case 'EnableSelection'*/ :
                            break;
                        case 'protectscenarios' /*case 'ProtectScenarios'*/ :
                            break;
                        case 'validprinterinfo' /*case 'ValidPrinterInfo'*/ :
                            break;
                        case 'horizontalresolution' /*case 'HorizontalResolution'*/ :
                            break;
                        case 'verticalresolution' /*case 'VerticalResolution'*/ :
                            break;
                        case 'numberofcopies' /*case 'NumberofCopies'*/ :
                            break;
                        case 'activepane' /*case 'ActivePane'*/ :
                            break;
                        case 'toprowvisible' /*case 'TopRowVisible'*/ :
                            break;
                        case 'leftcolumnvisible' /*case 'LeftColumnVisible'*/ :
                            break;
                        case 'fittopage' /*case 'FitToPage'*/ :
                            break;
                        case 'rangeselection' /*case 'RangeSelection'*/ :
                            break;
                        case 'papersizeindex' /*case 'PaperSizeIndex'*/ :
                            break;
                        case 'pagelayoutzoom' /*case 'PageLayoutZoom'*/ :
                            break;
                        case 'pagebreakzoom' /*case 'PageBreakZoom'*/ :
                            break;
                        case 'filteron' /*case 'FilterOn'*/ :
                            break;
                        case 'fitwidth' /*case 'FitWidth'*/ :
                            break;
                        case 'fitheight' /*case 'FitHeight'*/ :
                            break;
                        case 'commentslayout' /*case 'CommentsLayout'*/ :
                            break;
                        case 'zoom' /*case 'Zoom'*/ :
                            break;
                        case 'lefttoright' /*case 'LeftToRight'*/ :
                            break;
                        case 'gridlines' /*case 'Gridlines'*/ :
                            break;
                        case 'allowsort' /*case 'AllowSort'*/ :
                            break;
                        case 'allowfilter' /*case 'AllowFilter'*/ :
                            break;
                        case 'allowinsertrows' /*case 'AllowInsertRows'*/ :
                            break;
                        case 'allowdeleterows' /*case 'AllowDeleteRows'*/ :
                            break;
                        case 'allowinsertcols' /*case 'AllowInsertCols'*/ :
                            break;
                        case 'allowdeletecols' /*case 'AllowDeleteCols'*/ :
                            break;
                        case 'allowinserthyperlinks' /*case 'AllowInsertHyperlinks'*/ :
                            break;
                        case 'allowformatcells' /*case 'AllowFormatCells'*/ :
                            break;
                        case 'allowsizecols' /*case 'AllowSizeCols'*/ :
                            break;
                        case 'allowsizerows' /*case 'AllowSizeRows'*/ :
                            break;
                        case 'nosummaryrowsbelowdetail' /*case 'NoSummaryRowsBelowDetail'*/ :
                            if (!cursheet["!outline"]) cursheet["!outline"] = {};
                            cursheet["!outline"].above = true;
                            break;
                        case 'tabcolorindex' /*case 'TabColorIndex'*/ :
                            break;
                        case 'donotdisplayheadings' /*case 'DoNotDisplayHeadings'*/ :
                            break;
                        case 'showpagelayoutzoom' /*case 'ShowPageLayoutZoom'*/ :
                            break;
                        case 'nosummarycolumnsrightdetail' /*case 'NoSummaryColumnsRightDetail'*/ :
                            if (!cursheet["!outline"]) cursheet["!outline"] = {};
                            cursheet["!outline"].left = true;
                            break;
                        case 'blackandwhite' /*case 'BlackAndWhite'*/ :
                            break;
                        case 'donotdisplayzeros' /*case 'DoNotDisplayZeros'*/ :
                            break;
                        case 'displaypagebreak' /*case 'DisplayPageBreak'*/ :
                            break;
                        case 'rowcolheadings' /*case 'RowColHeadings'*/ :
                            break;
                        case 'donotdisplayoutline' /*case 'DoNotDisplayOutline'*/ :
                            break;
                        case 'noorientation' /*case 'NoOrientation'*/ :
                            break;
                        case 'allowusepivottables' /*case 'AllowUsePivotTables'*/ :
                            break;
                        case 'zeroheight' /*case 'ZeroHeight'*/ :
                            break;
                        case 'viewablerange' /*case 'ViewableRange'*/ :
                            break;
                        case 'selection' /*case 'Selection'*/ :
                            break;
                        case 'protectcontents' /*case 'ProtectContents'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* PivotTable */ case 'pivottable' /*case 'PivotTable'*/ :
                case 'pivotcache' /*case 'PivotCache'*/ :
                    switch(Rn[3]){
                        case 'immediateitemsondrop' /*case 'ImmediateItemsOnDrop'*/ :
                            break;
                        case 'showpagemultipleitemlabel' /*case 'ShowPageMultipleItemLabel'*/ :
                            break;
                        case 'compactrowindent' /*case 'CompactRowIndent'*/ :
                            break;
                        case 'location' /*case 'Location'*/ :
                            break;
                        case 'pivotfield' /*case 'PivotField'*/ :
                            break;
                        case 'orientation' /*case 'Orientation'*/ :
                            break;
                        case 'layoutform' /*case 'LayoutForm'*/ :
                            break;
                        case 'layoutsubtotallocation' /*case 'LayoutSubtotalLocation'*/ :
                            break;
                        case 'layoutcompactrow' /*case 'LayoutCompactRow'*/ :
                            break;
                        case 'position' /*case 'Position'*/ :
                            break;
                        case 'pivotitem' /*case 'PivotItem'*/ :
                            break;
                        case 'datatype' /*case 'DataType'*/ :
                            break;
                        case 'datafield' /*case 'DataField'*/ :
                            break;
                        case 'sourcename' /*case 'SourceName'*/ :
                            break;
                        case 'parentfield' /*case 'ParentField'*/ :
                            break;
                        case 'ptlineitems' /*case 'PTLineItems'*/ :
                            break;
                        case 'ptlineitem' /*case 'PTLineItem'*/ :
                            break;
                        case 'countofsameitems' /*case 'CountOfSameItems'*/ :
                            break;
                        case 'item' /*case 'Item'*/ :
                            break;
                        case 'itemtype' /*case 'ItemType'*/ :
                            break;
                        case 'ptsource' /*case 'PTSource'*/ :
                            break;
                        case 'cacheindex' /*case 'CacheIndex'*/ :
                            break;
                        case 'consolidationreference' /*case 'ConsolidationReference'*/ :
                            break;
                        case 'filename' /*case 'FileName'*/ :
                            break;
                        case 'reference' /*case 'Reference'*/ :
                            break;
                        case 'nocolumngrand' /*case 'NoColumnGrand'*/ :
                            break;
                        case 'norowgrand' /*case 'NoRowGrand'*/ :
                            break;
                        case 'blanklineafteritems' /*case 'BlankLineAfterItems'*/ :
                            break;
                        case 'hidden' /*case 'Hidden'*/ :
                            break;
                        case 'subtotal' /*case 'Subtotal'*/ :
                            break;
                        case 'basefield' /*case 'BaseField'*/ :
                            break;
                        case 'mapchilditems' /*case 'MapChildItems'*/ :
                            break;
                        case 'function' /*case 'Function'*/ :
                            break;
                        case 'refreshonfileopen' /*case 'RefreshOnFileOpen'*/ :
                            break;
                        case 'printsettitles' /*case 'PrintSetTitles'*/ :
                            break;
                        case 'mergelabels' /*case 'MergeLabels'*/ :
                            break;
                        case 'defaultversion' /*case 'DefaultVersion'*/ :
                            break;
                        case 'refreshname' /*case 'RefreshName'*/ :
                            break;
                        case 'refreshdate' /*case 'RefreshDate'*/ :
                            break;
                        case 'refreshdatecopy' /*case 'RefreshDateCopy'*/ :
                            break;
                        case 'versionlastrefresh' /*case 'VersionLastRefresh'*/ :
                            break;
                        case 'versionlastupdate' /*case 'VersionLastUpdate'*/ :
                            break;
                        case 'versionupdateablemin' /*case 'VersionUpdateableMin'*/ :
                            break;
                        case 'versionrefreshablemin' /*case 'VersionRefreshableMin'*/ :
                            break;
                        case 'calculation' /*case 'Calculation'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* PageBreaks */ case 'pagebreaks' /*case 'PageBreaks'*/ :
                    switch(Rn[3]){
                        case 'colbreaks' /*case 'ColBreaks'*/ :
                            break;
                        case 'colbreak' /*case 'ColBreak'*/ :
                            break;
                        case 'rowbreaks' /*case 'RowBreaks'*/ :
                            break;
                        case 'rowbreak' /*case 'RowBreak'*/ :
                            break;
                        case 'colstart' /*case 'ColStart'*/ :
                            break;
                        case 'colend' /*case 'ColEnd'*/ :
                            break;
                        case 'rowend' /*case 'RowEnd'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* AutoFilter */ case 'autofilter' /*case 'AutoFilter'*/ :
                    switch(Rn[3]){
                        case 'autofiltercolumn' /*case 'AutoFilterColumn'*/ :
                            break;
                        case 'autofiltercondition' /*case 'AutoFilterCondition'*/ :
                            break;
                        case 'autofilterand' /*case 'AutoFilterAnd'*/ :
                            break;
                        case 'autofilteror' /*case 'AutoFilterOr'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* QueryTable */ case 'querytable' /*case 'QueryTable'*/ :
                    switch(Rn[3]){
                        case 'id' /*case 'Id'*/ :
                            break;
                        case 'autoformatfont' /*case 'AutoFormatFont'*/ :
                            break;
                        case 'autoformatpattern' /*case 'AutoFormatPattern'*/ :
                            break;
                        case 'querysource' /*case 'QuerySource'*/ :
                            break;
                        case 'querytype' /*case 'QueryType'*/ :
                            break;
                        case 'enableredirections' /*case 'EnableRedirections'*/ :
                            break;
                        case 'refreshedinxl9' /*case 'RefreshedInXl9'*/ :
                            break;
                        case 'urlstring' /*case 'URLString'*/ :
                            break;
                        case 'htmltables' /*case 'HTMLTables'*/ :
                            break;
                        case 'connection' /*case 'Connection'*/ :
                            break;
                        case 'commandtext' /*case 'CommandText'*/ :
                            break;
                        case 'refreshinfo' /*case 'RefreshInfo'*/ :
                            break;
                        case 'notitles' /*case 'NoTitles'*/ :
                            break;
                        case 'nextid' /*case 'NextId'*/ :
                            break;
                        case 'columninfo' /*case 'ColumnInfo'*/ :
                            break;
                        case 'overwritecells' /*case 'OverwriteCells'*/ :
                            break;
                        case 'donotpromptforfile' /*case 'DoNotPromptForFile'*/ :
                            break;
                        case 'textwizardsettings' /*case 'TextWizardSettings'*/ :
                            break;
                        case 'source' /*case 'Source'*/ :
                            break;
                        case 'number' /*case 'Number'*/ :
                            break;
                        case 'decimal' /*case 'Decimal'*/ :
                            break;
                        case 'thousandseparator' /*case 'ThousandSeparator'*/ :
                            break;
                        case 'trailingminusnumbers' /*case 'TrailingMinusNumbers'*/ :
                            break;
                        case 'formatsettings' /*case 'FormatSettings'*/ :
                            break;
                        case 'fieldtype' /*case 'FieldType'*/ :
                            break;
                        case 'delimiters' /*case 'Delimiters'*/ :
                            break;
                        case 'tab' /*case 'Tab'*/ :
                            break;
                        case 'comma' /*case 'Comma'*/ :
                            break;
                        case 'autoformatname' /*case 'AutoFormatName'*/ :
                            break;
                        case 'versionlastedit' /*case 'VersionLastEdit'*/ :
                            break;
                        case 'versionlastrefresh' /*case 'VersionLastRefresh'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                case 'datavalidation' /*case 'DataValidation'*/ :
                    switch(Rn[3]){
                        case 'range' /*case 'Range'*/ :
                            break;
                        case 'type' /*case 'Type'*/ :
                            break;
                        case 'min' /*case 'Min'*/ :
                            break;
                        case 'max' /*case 'Max'*/ :
                            break;
                        case 'sort' /*case 'Sort'*/ :
                            break;
                        case 'descending' /*case 'Descending'*/ :
                            break;
                        case 'order' /*case 'Order'*/ :
                            break;
                        case 'casesensitive' /*case 'CaseSensitive'*/ :
                            break;
                        case 'value' /*case 'Value'*/ :
                            break;
                        case 'errorstyle' /*case 'ErrorStyle'*/ :
                            break;
                        case 'errormessage' /*case 'ErrorMessage'*/ :
                            break;
                        case 'errortitle' /*case 'ErrorTitle'*/ :
                            break;
                        case 'inputmessage' /*case 'InputMessage'*/ :
                            break;
                        case 'inputtitle' /*case 'InputTitle'*/ :
                            break;
                        case 'combohide' /*case 'ComboHide'*/ :
                            break;
                        case 'inputhide' /*case 'InputHide'*/ :
                            break;
                        case 'condition' /*case 'Condition'*/ :
                            break;
                        case 'qualifier' /*case 'Qualifier'*/ :
                            break;
                        case 'useblank' /*case 'UseBlank'*/ :
                            break;
                        case 'value1' /*case 'Value1'*/ :
                            break;
                        case 'value2' /*case 'Value2'*/ :
                            break;
                        case 'format' /*case 'Format'*/ :
                            break;
                        case 'cellrangelist' /*case 'CellRangeList'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                case 'sorting' /*case 'Sorting'*/ :
                case 'conditionalformatting' /*case 'ConditionalFormatting'*/ :
                    switch(Rn[3]){
                        case 'range' /*case 'Range'*/ :
                            break;
                        case 'type' /*case 'Type'*/ :
                            break;
                        case 'min' /*case 'Min'*/ :
                            break;
                        case 'max' /*case 'Max'*/ :
                            break;
                        case 'sort' /*case 'Sort'*/ :
                            break;
                        case 'descending' /*case 'Descending'*/ :
                            break;
                        case 'order' /*case 'Order'*/ :
                            break;
                        case 'casesensitive' /*case 'CaseSensitive'*/ :
                            break;
                        case 'value' /*case 'Value'*/ :
                            break;
                        case 'errorstyle' /*case 'ErrorStyle'*/ :
                            break;
                        case 'errormessage' /*case 'ErrorMessage'*/ :
                            break;
                        case 'errortitle' /*case 'ErrorTitle'*/ :
                            break;
                        case 'cellrangelist' /*case 'CellRangeList'*/ :
                            break;
                        case 'inputmessage' /*case 'InputMessage'*/ :
                            break;
                        case 'inputtitle' /*case 'InputTitle'*/ :
                            break;
                        case 'combohide' /*case 'ComboHide'*/ :
                            break;
                        case 'inputhide' /*case 'InputHide'*/ :
                            break;
                        case 'condition' /*case 'Condition'*/ :
                            break;
                        case 'qualifier' /*case 'Qualifier'*/ :
                            break;
                        case 'useblank' /*case 'UseBlank'*/ :
                            break;
                        case 'value1' /*case 'Value1'*/ :
                            break;
                        case 'value2' /*case 'Value2'*/ :
                            break;
                        case 'format' /*case 'Format'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* MapInfo (schema) */ case 'mapinfo' /*case 'MapInfo'*/ :
                case 'schema' /*case 'Schema'*/ :
                case 'data' /*case 'data'*/ :
                    switch(Rn[3]){
                        case 'map' /*case 'Map'*/ :
                            break;
                        case 'entry' /*case 'Entry'*/ :
                            break;
                        case 'range' /*case 'Range'*/ :
                            break;
                        case 'xpath' /*case 'XPath'*/ :
                            break;
                        case 'field' /*case 'Field'*/ :
                            break;
                        case 'xsdtype' /*case 'XSDType'*/ :
                            break;
                        case 'filteron' /*case 'FilterOn'*/ :
                            break;
                        case 'aggregate' /*case 'Aggregate'*/ :
                            break;
                        case 'elementtype' /*case 'ElementType'*/ :
                            break;
                        case 'attributetype' /*case 'AttributeType'*/ :
                            break;
                        /* These are from xsd (XML Schema Definition) */ case 'schema' /*case 'schema'*/ :
                        case 'element' /*case 'element'*/ :
                        case 'complextype' /*case 'complexType'*/ :
                        case 'datatype' /*case 'datatype'*/ :
                        case 'all' /*case 'all'*/ :
                        case 'attribute' /*case 'attribute'*/ :
                        case 'extends' /*case 'extends'*/ :
                            break;
                        case 'row' /*case 'row'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* SmartTags (can be anything) */ case 'smarttags' /*case 'SmartTags'*/ :
                    break;
                default:
                    seen = false;
                    break;
            }
            if (seen) break;
            /* CustomDocumentProperties */ if (Rn[3].match(/!\[CDATA/)) break;
            if (!state[state.length - 1][1]) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
            if (state[state.length - 1][0] === /*'CustomDocumentProperties'*/ 'customdocumentproperties') {
                if (Rn[0].slice(-2) === "/>") break;
                else if (Rn[1] === "/") $b8f343bf88dacc48$var$xlml_set_custprop(Custprops, raw_Rn3, cp, str.slice(pidx, Rn.index));
                else {
                    cp = Rn;
                    pidx = Rn.index + Rn[0].length;
                }
                break;
            }
            if (opts.WTF) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
    }
    var out = {} /*:any*/ ;
    if (!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
    out.SheetNames = sheetnames;
    out.Workbook = Workbook;
    out.SSF = $b8f343bf88dacc48$var$dup($b8f343bf88dacc48$var$table_fmt);
    out.Props = Props;
    out.Custprops = Custprops;
    out.bookType = "xlml";
    return out;
}
function $b8f343bf88dacc48$var$parse_xlml(data /*:RawBytes|string*/ , opts) /*:Workbook*/ {
    $b8f343bf88dacc48$var$fix_read_opts(opts = opts || {});
    switch(opts.type || "base64"){
        case "base64":
            return $b8f343bf88dacc48$var$parse_xlml_xml($b8f343bf88dacc48$var$Base64_decode(data), opts);
        case "binary":
        case "buffer":
        case "file":
            return $b8f343bf88dacc48$var$parse_xlml_xml(data, opts);
        case "array":
            return $b8f343bf88dacc48$var$parse_xlml_xml($b8f343bf88dacc48$var$a2s(data), opts);
    }
/*:: throw new Error("unsupported type " + opts.type); */ }
/* TODO */ function $b8f343bf88dacc48$var$write_props_xlml(wb /*:Workbook*/ , opts) /*:string*/ {
    var o /*:Array<string>*/  = [];
    /* DocumentProperties */ if (wb.Props) o.push($b8f343bf88dacc48$var$xlml_write_docprops(wb.Props, opts));
    /* CustomDocumentProperties */ if (wb.Custprops) o.push($b8f343bf88dacc48$var$xlml_write_custprops(wb.Props, wb.Custprops, opts));
    return o.join("");
}
/* TODO */ function $b8f343bf88dacc48$var$write_wb_xlml(wb /*::, opts*/ ) /*:string*/ {
    /* OfficeDocumentSettings */ /* ExcelWorkbook */ if ((((wb || {}).Workbook || {}).WBProps || {}).date1904) return '<ExcelWorkbook xmlns="urn:schemas-microsoft-com:office:excel"><Date1904/></ExcelWorkbook>';
    return "";
}
/* TODO */ function $b8f343bf88dacc48$var$write_sty_xlml(wb, opts) /*:string*/ {
    /* Styles */ var styles /*:Array<string>*/  = [
        '<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'
    ];
    opts.cellXfs.forEach(function(xf, id) {
        var payload /*:Array<string>*/  = [];
        payload.push($b8f343bf88dacc48$var$writextag('NumberFormat', null, {
            "ss:Format": $b8f343bf88dacc48$var$escapexml($b8f343bf88dacc48$var$table_fmt[xf.numFmtId])
        }));
        var o = /*::(*/ {
            "ss:ID": "s" + (21 + id)
        } /*:: :any)*/ ;
        styles.push($b8f343bf88dacc48$var$writextag('Style', payload.join(""), o));
    });
    return $b8f343bf88dacc48$var$writextag("Styles", styles.join(""));
}
function $b8f343bf88dacc48$var$write_name_xlml(n) {
    return $b8f343bf88dacc48$var$writextag("NamedRange", null, {
        "ss:Name": n.Name.slice(0, 6) == "_xlnm." ? n.Name.slice(6) : n.Name,
        "ss:RefersTo": "=" + $b8f343bf88dacc48$var$a1_to_rc(n.Ref, {
            r: 0,
            c: 0
        })
    });
}
function $b8f343bf88dacc48$var$write_names_xlml(wb /*::, opts*/ ) /*:string*/ {
    if (!((wb || {}).Workbook || {}).Names) return "";
    /*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */ var names /*:Array<any>*/  = wb.Workbook.Names;
    var out /*:Array<string>*/  = [];
    for(var i = 0; i < names.length; ++i){
        var n = names[i];
        if (n.Sheet != null) continue;
        if (n.Name.match(/^_xlfn\./)) continue;
        out.push($b8f343bf88dacc48$var$write_name_xlml(n));
    }
    return $b8f343bf88dacc48$var$writextag("Names", out.join(""));
}
function $b8f343bf88dacc48$var$write_ws_xlml_names(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws) return "";
    if (!((wb || {}).Workbook || {}).Names) return "";
    /*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */ var names /*:Array<any>*/  = wb.Workbook.Names;
    var out /*:Array<string>*/  = [];
    for(var i = 0; i < names.length; ++i){
        var n = names[i];
        if (n.Sheet != idx) continue;
        /*switch(n.Name) {
			case "_": continue;
		}*/ if (n.Name.match(/^_xlfn\./)) continue;
        out.push($b8f343bf88dacc48$var$write_name_xlml(n));
    }
    return out.join("");
}
/* WorksheetOptions */ function $b8f343bf88dacc48$var$write_ws_xlml_wsopts(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws) return "";
    var o /*:Array<string>*/  = [];
    /* NOTE: spec technically allows any order, but stick with implied order */ /* FitToPage */ /* DoNotDisplayColHeaders */ /* DoNotDisplayRowHeaders */ /* ViewableRange */ /* Selection */ /* GridlineColor */ /* Name */ /* ExcelWorksheetType */ /* IntlMacro */ /* Unsynced */ /* Selected */ /* CodeName */ if (ws['!margins']) {
        o.push("<PageSetup>");
        if (ws['!margins'].header) o.push($b8f343bf88dacc48$var$writextag("Header", null, {
            'x:Margin': ws['!margins'].header
        }));
        if (ws['!margins'].footer) o.push($b8f343bf88dacc48$var$writextag("Footer", null, {
            'x:Margin': ws['!margins'].footer
        }));
        o.push($b8f343bf88dacc48$var$writextag("PageMargins", null, {
            'x:Bottom': ws['!margins'].bottom || "0.75",
            'x:Left': ws['!margins'].left || "0.7",
            'x:Right': ws['!margins'].right || "0.7",
            'x:Top': ws['!margins'].top || "0.75"
        }));
        o.push("</PageSetup>");
    }
    /* PageSetup */ /* DisplayPageBreak */ /* TransitionExpressionEvaluation */ /* TransitionFormulaEntry */ /* Print */ /* Zoom */ /* PageLayoutZoom */ /* PageBreakZoom */ /* ShowPageBreakZoom */ /* DefaultRowHeight */ /* DefaultColumnWidth */ /* StandardWidth */ if (wb && wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx]) {
        /* Visible */ if (wb.Workbook.Sheets[idx].Hidden) o.push($b8f343bf88dacc48$var$writextag("Visible", wb.Workbook.Sheets[idx].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden", {}));
        else {
            /* Selected */ for(var i = 0; i < idx; ++i)if (wb.Workbook.Sheets[i] && !wb.Workbook.Sheets[i].Hidden) break;
            if (i == idx) o.push("<Selected/>");
        }
    }
    /* LeftColumnVisible */ if (((((wb || {}).Workbook || {}).Views || [])[0] || {}).RTL) o.push("<DisplayRightToLeft/>");
    /* GridlineColorIndex */ /* DisplayFormulas */ /* DoNotDisplayGridlines */ /* DoNotDisplayHeadings */ /* DoNotDisplayOutline */ /* ApplyAutomaticOutlineStyles */ /* NoSummaryRowsBelowDetail */ /* NoSummaryColumnsRightDetail */ /* DoNotDisplayZeros */ /* ActiveRow */ /* ActiveColumn */ /* FilterOn */ /* RangeSelection */ /* TopRowVisible */ /* TopRowBottomPane */ /* LeftColumnRightPane */ /* ActivePane */ /* SplitHorizontal */ /* SplitVertical */ /* FreezePanes */ /* FrozenNoSplit */ /* TabColorIndex */ /* Panes */ /* NOTE: Password not supported in XLML Format */ if (ws['!protect']) {
        o.push($b8f343bf88dacc48$var$writetag("ProtectContents", "True"));
        if (ws['!protect'].objects) o.push($b8f343bf88dacc48$var$writetag("ProtectObjects", "True"));
        if (ws['!protect'].scenarios) o.push($b8f343bf88dacc48$var$writetag("ProtectScenarios", "True"));
        if (ws['!protect'].selectLockedCells != null && !ws['!protect'].selectLockedCells) o.push($b8f343bf88dacc48$var$writetag("EnableSelection", "NoSelection"));
        else if (ws['!protect'].selectUnlockedCells != null && !ws['!protect'].selectUnlockedCells) o.push($b8f343bf88dacc48$var$writetag("EnableSelection", "UnlockedCells"));
        [
            [
                "formatCells",
                "AllowFormatCells"
            ],
            [
                "formatColumns",
                "AllowSizeCols"
            ],
            [
                "formatRows",
                "AllowSizeRows"
            ],
            [
                "insertColumns",
                "AllowInsertCols"
            ],
            [
                "insertRows",
                "AllowInsertRows"
            ],
            [
                "insertHyperlinks",
                "AllowInsertHyperlinks"
            ],
            [
                "deleteColumns",
                "AllowDeleteCols"
            ],
            [
                "deleteRows",
                "AllowDeleteRows"
            ],
            [
                "sort",
                "AllowSort"
            ],
            [
                "autoFilter",
                "AllowFilter"
            ],
            [
                "pivotTables",
                "AllowUsePivotTables"
            ]
        ].forEach(function(x) {
            if (ws['!protect'][x[0]]) o.push("<" + x[1] + "/>");
        });
    }
    if (o.length == 0) return "";
    return $b8f343bf88dacc48$var$writextag("WorksheetOptions", o.join(""), {
        xmlns: $b8f343bf88dacc48$var$XLMLNS.x
    });
}
function $b8f343bf88dacc48$var$write_ws_xlml_comment(comments /*:Array<any>*/ ) /*:string*/ {
    /* TODO: test multiple comments */ return comments.map(function(c) {
        // TODO: formatted text
        var t = $b8f343bf88dacc48$var$xlml_unfixstr(c.t || "");
        var d = $b8f343bf88dacc48$var$writextag("ss:Data", t, {
            "xmlns": "http://www.w3.org/TR/REC-html40"
        });
        var p = {};
        if (c.a) p["ss:Author"] = c.a;
        if (!comments.hidden) p["ss:ShowAlways"] = "1";
        return $b8f343bf88dacc48$var$writextag("Comment", d, p);
    }).join("");
}
function $b8f343bf88dacc48$var$write_ws_xlml_cell(cell, ref /*:string*/ , ws, opts, idx /*:number*/ , wb, addr) /*:string*/ {
    if (!cell || cell.v == undefined && cell.f == undefined) return "";
    var attr = {};
    if (cell.f) attr["ss:Formula"] = "=" + $b8f343bf88dacc48$var$escapexml($b8f343bf88dacc48$var$a1_to_rc(cell.f, addr));
    if (cell.F && cell.F.slice(0, ref.length) == ref) {
        var end = $b8f343bf88dacc48$var$decode_cell(cell.F.slice(ref.length + 1));
        attr["ss:ArrayRange"] = "RC:R" + (end.r == addr.r ? "" : "[" + (end.r - addr.r) + "]") + "C" + (end.c == addr.c ? "" : "[" + (end.c - addr.c) + "]");
    }
    if (cell.l && cell.l.Target) {
        attr["ss:HRef"] = $b8f343bf88dacc48$var$escapexml(cell.l.Target);
        if (cell.l.Tooltip) attr["x:HRefScreenTip"] = $b8f343bf88dacc48$var$escapexml(cell.l.Tooltip);
    }
    if (ws['!merges']) {
        var marr = ws['!merges'];
        for(var mi = 0; mi != marr.length; ++mi){
            if (marr[mi].s.c != addr.c || marr[mi].s.r != addr.r) continue;
            if (marr[mi].e.c > marr[mi].s.c) attr['ss:MergeAcross'] = marr[mi].e.c - marr[mi].s.c;
            if (marr[mi].e.r > marr[mi].s.r) attr['ss:MergeDown'] = marr[mi].e.r - marr[mi].s.r;
        }
    }
    var t = "", p = "";
    switch(cell.t){
        case 'z':
            if (!opts.sheetStubs) return "";
            break;
        case 'n':
            t = 'Number';
            p = String(cell.v);
            break;
        case 'b':
            t = 'Boolean';
            p = cell.v ? "1" : "0";
            break;
        case 'e':
            t = 'Error';
            p = $b8f343bf88dacc48$var$BErr[cell.v];
            break;
        case 'd':
            t = 'DateTime';
            p = new Date(cell.v).toISOString();
            if (cell.z == null) cell.z = cell.z || $b8f343bf88dacc48$var$table_fmt[14];
            break;
        case 's':
            t = 'String';
            p = $b8f343bf88dacc48$var$escapexlml(cell.v || "");
            break;
    }
    /* TODO: cell style */ var os = $b8f343bf88dacc48$var$get_cell_style(opts.cellXfs, cell, opts);
    attr["ss:StyleID"] = "s" + (21 + os);
    attr["ss:Index"] = addr.c + 1;
    var _v = cell.v != null ? p : "";
    var m = cell.t == 'z' ? "" : '<Data ss:Type="' + t + '">' + _v + '</Data>';
    if ((cell.c || []).length > 0) m += $b8f343bf88dacc48$var$write_ws_xlml_comment(cell.c);
    return $b8f343bf88dacc48$var$writextag("Cell", m, attr);
}
function $b8f343bf88dacc48$var$write_ws_xlml_row(R /*:number*/ , row) /*:string*/ {
    var o = '<Row ss:Index="' + (R + 1) + '"';
    if (row) {
        if (row.hpt && !row.hpx) row.hpx = $b8f343bf88dacc48$var$pt2px(row.hpt);
        if (row.hpx) o += ' ss:AutoFitHeight="0" ss:Height="' + row.hpx + '"';
        if (row.hidden) o += ' ss:Hidden="1"';
    }
    return o + '>';
}
/* TODO */ function $b8f343bf88dacc48$var$write_ws_xlml_table(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws['!ref']) return "";
    var range /*:Range*/  = $b8f343bf88dacc48$var$safe_decode_range(ws['!ref']);
    var marr /*:Array<Range>*/  = ws['!merges'] || [], mi = 0;
    var o /*:Array<string>*/  = [];
    if (ws['!cols']) ws['!cols'].forEach(function(n, i) {
        $b8f343bf88dacc48$var$process_col(n);
        var w = !!n.width;
        var p = $b8f343bf88dacc48$var$col_obj_w(i, n);
        var k /*:any*/  = {
            "ss:Index": i + 1
        };
        if (w) k['ss:Width'] = $b8f343bf88dacc48$var$width2px(p.width);
        if (n.hidden) k['ss:Hidden'] = "1";
        o.push($b8f343bf88dacc48$var$writextag("Column", null, k));
    });
    var dense = ws["!data"] != null;
    for(var R = range.s.r; R <= range.e.r; ++R){
        var row = [
            $b8f343bf88dacc48$var$write_ws_xlml_row(R, (ws['!rows'] || [])[R])
        ];
        for(var C = range.s.c; C <= range.e.c; ++C){
            var skip = false;
            for(mi = 0; mi != marr.length; ++mi){
                if (marr[mi].s.c > C) continue;
                if (marr[mi].s.r > R) continue;
                if (marr[mi].e.c < C) continue;
                if (marr[mi].e.r < R) continue;
                if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                break;
            }
            if (skip) continue;
            var addr = {
                r: R,
                c: C
            };
            var ref = $b8f343bf88dacc48$var$encode_col(C) + $b8f343bf88dacc48$var$encode_row(R), cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
            row.push($b8f343bf88dacc48$var$write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr));
        }
        row.push("</Row>");
        if (row.length > 2) o.push(row.join(""));
    }
    return o.join("");
}
function $b8f343bf88dacc48$var$write_ws_xlml(idx /*:number*/ , opts, wb /*:Workbook*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    var s = wb.SheetNames[idx];
    var ws = wb.Sheets[s];
    var t /*:string*/  = ws ? $b8f343bf88dacc48$var$write_ws_xlml_names(ws, opts, idx, wb) : "";
    if (t.length > 0) o.push("<Names>" + t + "</Names>");
    /* Table */ t = ws ? $b8f343bf88dacc48$var$write_ws_xlml_table(ws, opts, idx, wb) : "";
    if (t.length > 0) o.push("<Table>" + t + "</Table>");
    /* WorksheetOptions */ o.push($b8f343bf88dacc48$var$write_ws_xlml_wsopts(ws, opts, idx, wb));
    if (ws["!autofilter"]) o.push('<AutoFilter x:Range="' + $b8f343bf88dacc48$var$a1_to_rc($b8f343bf88dacc48$var$fix_range(ws["!autofilter"].ref), {
        r: 0,
        c: 0
    }) + '" xmlns="urn:schemas-microsoft-com:office:excel"></AutoFilter>');
    return o.join("");
}
function $b8f343bf88dacc48$var$write_xlml(wb, opts) /*:string*/ {
    if (!opts) opts = {};
    if (!wb.SSF) wb.SSF = $b8f343bf88dacc48$var$dup($b8f343bf88dacc48$var$table_fmt);
    if (wb.SSF) {
        $b8f343bf88dacc48$var$make_ssf();
        $b8f343bf88dacc48$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $b8f343bf88dacc48$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
        opts.cellXfs = [];
        $b8f343bf88dacc48$var$get_cell_style(opts.cellXfs, {}, {
            revssf: {
                "General": 0
            }
        });
    }
    var d /*:Array<string>*/  = [];
    d.push($b8f343bf88dacc48$var$write_props_xlml(wb, opts));
    d.push($b8f343bf88dacc48$var$write_wb_xlml(wb, opts));
    d.push("");
    d.push("");
    for(var i = 0; i < wb.SheetNames.length; ++i)d.push($b8f343bf88dacc48$var$writextag("Worksheet", $b8f343bf88dacc48$var$write_ws_xlml(i, opts, wb), {
        "ss:Name": $b8f343bf88dacc48$var$escapexml(wb.SheetNames[i])
    }));
    d[2] = $b8f343bf88dacc48$var$write_sty_xlml(wb, opts);
    d[3] = $b8f343bf88dacc48$var$write_names_xlml(wb, opts);
    return $b8f343bf88dacc48$var$XML_HEADER + $b8f343bf88dacc48$var$writextag("Workbook", d.join(""), {
        'xmlns': $b8f343bf88dacc48$var$XLMLNS.ss,
        'xmlns:o': $b8f343bf88dacc48$var$XLMLNS.o,
        'xmlns:x': $b8f343bf88dacc48$var$XLMLNS.x,
        'xmlns:ss': $b8f343bf88dacc48$var$XLMLNS.ss,
        'xmlns:dt': $b8f343bf88dacc48$var$XLMLNS.dt,
        'xmlns:html': $b8f343bf88dacc48$var$XLMLNS.html
    });
}
/* [MS-OLEDS] 2.3.8 CompObjStream */ function $b8f343bf88dacc48$var$parse_compobj(obj /*:CFBEntry*/ ) {
    var v = {};
    var o = obj.content;
    /*:: if(o == null) return; */ /* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */ o.l = 28;
    v.AnsiUserType = o.read_shift(0, "lpstr-ansi");
    v.AnsiClipboardFormat = $b8f343bf88dacc48$var$parse_ClipboardFormatOrAnsiString(o);
    if (o.length - o.l <= 4) return v;
    var m /*:number*/  = o.read_shift(4);
    if (m == 0 || m > 40) return v;
    o.l -= 4;
    v.Reserved1 = o.read_shift(0, "lpstr-ansi");
    if (o.length - o.l <= 4) return v;
    m = o.read_shift(4);
    if (m !== 0x71b239f4) return v;
    v.UnicodeClipboardFormat = $b8f343bf88dacc48$var$parse_ClipboardFormatOrUnicodeString(o);
    m = o.read_shift(4);
    if (m == 0 || m > 40) return v;
    o.l -= 4;
    v.Reserved2 = o.read_shift(0, "lpwstr");
}
/*
	Continue logic for:
	- 2.4.58 Continue          0x003c
	- 2.4.59 ContinueBigName   0x043c
	- 2.4.60 ContinueFrt       0x0812
	- 2.4.61 ContinueFrt11     0x0875
	- 2.4.62 ContinueFrt12     0x087f
*/ var $b8f343bf88dacc48$var$CONTINUE_RT = [
    0x003c,
    0x043c,
    0x0812,
    0x0875,
    0x087f
];
function $b8f343bf88dacc48$var$slurp(RecordType, R, blob, length /*:number*/ , opts) /*:any*/ {
    var l = length;
    var bufs = [];
    var d = blob.slice(blob.l, blob.l + l);
    if (opts && opts.enc && opts.enc.insitu && d.length > 0) switch(RecordType){
        case 0x0009:
        case 0x0209:
        case 0x0409:
        case 0x0809 /* BOF */ :
        case 0x002F /* FilePass */ :
        case 0x0195 /* FileLock */ :
        case 0x00E1 /* InterfaceHdr */ :
        case 0x0196 /* RRDInfo */ :
        case 0x0138 /* RRDHead */ :
        case 0x0194 /* UsrExcl */ :
        case 0x000a /* EOF */ :
            break;
        case 0x0085 /* BoundSheet8 */ :
            break;
        default:
            opts.enc.insitu(d);
    }
    bufs.push(d);
    blob.l += l;
    var nextrt = $b8f343bf88dacc48$var$__readUInt16LE(blob, blob.l), next = $b8f343bf88dacc48$var$XLSRecordEnum[nextrt];
    var start = 0;
    while(next != null && $b8f343bf88dacc48$var$CONTINUE_RT.indexOf(nextrt) > -1){
        l = $b8f343bf88dacc48$var$__readUInt16LE(blob, blob.l + 2);
        start = blob.l + 4;
        if (nextrt == 0x0812 /* ContinueFrt */ ) start += 4;
        else if (nextrt == 0x0875 || nextrt == 0x087f) start += 12;
        d = blob.slice(start, blob.l + 4 + l);
        bufs.push(d);
        blob.l += 4 + l;
        next = $b8f343bf88dacc48$var$XLSRecordEnum[nextrt = $b8f343bf88dacc48$var$__readUInt16LE(blob, blob.l)];
    }
    var b = $b8f343bf88dacc48$var$bconcat(bufs);
    $b8f343bf88dacc48$var$prep_blob(b, 0);
    var ll = 0;
    b.lens = [];
    for(var j = 0; j < bufs.length; ++j){
        b.lens.push(ll);
        ll += bufs[j].length;
    }
    if (b.length < length) throw "XLS Record 0x" + RecordType.toString(16) + " Truncated: " + b.length + " < " + length;
    return R.f(b, b.length, opts);
}
function $b8f343bf88dacc48$var$safe_format_xf(p /*:any*/ , opts /*:ParseOpts*/ , date1904 /*:?boolean*/ ) {
    if (p.t === 'z') return;
    if (!p.XF) return;
    var fmtid = 0;
    try {
        fmtid = p.z || p.XF.numFmtId || 0;
        if (opts.cellNF && p.z == null) p.z = $b8f343bf88dacc48$var$table_fmt[fmtid];
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (!opts || opts.cellText !== false) try {
        if (p.t === 'e') p.w = p.w || $b8f343bf88dacc48$var$BErr[p.v];
        else if (fmtid === 0 || fmtid == "General") {
            if (p.t === 'n') {
                if ((p.v | 0) === p.v) p.w = p.v.toString(10);
                else p.w = $b8f343bf88dacc48$var$SSF_general_num(p.v);
            } else p.w = $b8f343bf88dacc48$var$SSF_general(p.v);
        } else p.w = $b8f343bf88dacc48$var$SSF_format(fmtid, p.v, {
            date1904: !!date1904,
            dateNF: opts && opts.dateNF
        });
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (opts.cellDates && fmtid && p.t == 'n' && $b8f343bf88dacc48$var$fmt_is_date($b8f343bf88dacc48$var$table_fmt[fmtid] || String(fmtid))) {
        var _d = $b8f343bf88dacc48$var$SSF_parse_date_code(p.v + (date1904 ? 1462 : 0));
        if (_d) {
            p.t = 'd';
            p.v = new Date(Date.UTC(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u));
        }
    }
}
function $b8f343bf88dacc48$var$make_cell(val, ixfe, t) /*:Cell*/ {
    return {
        v: val,
        ixfe: ixfe,
        t: t
    } /*:any*/ ;
}
// 2.3.2
function $b8f343bf88dacc48$var$parse_workbook(blob, options /*:ParseOpts*/ ) /*:Workbook*/ {
    var wb = {
        opts: {}
    } /*:any*/ ;
    var Sheets = {};
    if ($b8f343bf88dacc48$var$DENSE != null && options.dense == null) options.dense = $b8f343bf88dacc48$var$DENSE;
    var out /*:Worksheet*/  = {} /*:any*/ ;
    if (options.dense) out["!data"] = [];
    var Directory = {};
    var range /*:Range*/  = {} /*:any*/ ;
    var last_formula = null;
    var sst /*:SST*/  = [];
    var cur_sheet = "";
    var Preamble = {};
    var lastcell, last_cell = "", cc /*:Cell*/ , cmnt, rngC, rngR;
    var sharedf = {};
    var arrayf /*:Array<[Range, string]>*/  = [];
    var temp_val /*:Cell*/ ;
    var country;
    var XFs = []; /* XF records */ 
    var palette /*:Array<[number, number, number]>*/  = [];
    var Workbook /*:WBWBProps*/  = {
        Sheets: [],
        WBProps: {
            date1904: false
        },
        Views: [
            {}
        ]
    } /*:any*/ , wsprops = {};
    var biff4w = false;
    var get_rgb = function getrgb(icv /*:number*/ ) /*:[number, number, number]*/ {
        if (icv < 8) return $b8f343bf88dacc48$var$XLSIcv[icv];
        if (icv < 64) return palette[icv - 8] || $b8f343bf88dacc48$var$XLSIcv[icv];
        return $b8f343bf88dacc48$var$XLSIcv[icv];
    };
    var process_cell_style = function pcs(line /*:any*/ , options) {
        var xfd = line.XF.data;
        if (!xfd || !xfd.patternType || !options || !options.cellStyles) return;
        line.s = {} /*:any*/ ;
        line.s.patternType = xfd.patternType;
        var t;
        if (t = $b8f343bf88dacc48$var$rgb2Hex(get_rgb(xfd.icvFore))) line.s.fgColor = {
            rgb: t
        };
        if (t = $b8f343bf88dacc48$var$rgb2Hex(get_rgb(xfd.icvBack))) line.s.bgColor = {
            rgb: t
        };
    };
    var addcell = function addcell(cell /*:any*/ , line /*:any*/ , options /*:any*/ ) {
        if (!biff4w && file_depth > 1) return;
        if (options.sheetRows && cell.r >= options.sheetRows) return;
        if (options.cellStyles && line.XF && line.XF.data) process_cell_style(line, options);
        delete line.ixfe;
        delete line.XF;
        lastcell = cell;
        last_cell = $b8f343bf88dacc48$var$encode_cell(cell);
        if (!range || !range.s || !range.e) range = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        };
        if (cell.r < range.s.r) range.s.r = cell.r;
        if (cell.c < range.s.c) range.s.c = cell.c;
        if (cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
        if (cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
        if (options.cellFormula && line.f) for(var afi = 0; afi < arrayf.length; ++afi){
            if (arrayf[afi][0].s.c > cell.c || arrayf[afi][0].s.r > cell.r) continue;
            if (arrayf[afi][0].e.c < cell.c || arrayf[afi][0].e.r < cell.r) continue;
            line.F = $b8f343bf88dacc48$var$encode_range(arrayf[afi][0]);
            if (arrayf[afi][0].s.c != cell.c || arrayf[afi][0].s.r != cell.r) delete line.f;
            if (line.f) line.f = "" + $b8f343bf88dacc48$var$stringify_formula(arrayf[afi][1], range, cell, supbooks, opts);
            break;
        }
        if (options.dense) {
            if (!out["!data"][cell.r]) out["!data"][cell.r] = [];
            out["!data"][cell.r][cell.c] = line;
        } else out[last_cell] = line;
    };
    var opts = {
        enc: false,
        sbcch: 0,
        snames: [],
        sharedf: sharedf,
        arrayf: arrayf,
        rrtabid: [],
        lastuser: "",
        biff: 8,
        codepage: 0,
        winlocked: 0,
        cellStyles: !!options && !!options.cellStyles,
        WTF: !!options && !!options.wtf
    } /*:any*/ ;
    if (options.password) opts.password = options.password;
    var themes;
    var merges /*:Array<Range>*/  = [];
    var objects = [];
    var colinfo /*:Array<ColInfo>*/  = [], rowinfo /*:Array<RowInfo>*/  = [];
    var seencol = false;
    var supbooks = []; // 1-indexed, will hold extern names
    supbooks.SheetNames = opts.snames;
    supbooks.sharedf = opts.sharedf;
    supbooks.arrayf = opts.arrayf;
    supbooks.names = [];
    supbooks.XTI = [];
    var last_RT = 0;
    var file_depth = 0; /* TODO: make a real stack */ 
    var BIFF2Fmt = 0, BIFF2FmtTable /*:Array<string>*/  = [];
    var FilterDatabases = []; /* TODO: sort out supbooks and process elsewhere */ 
    var last_lbl /*:?DefinedName*/ ;
    /* explicit override for some broken writers */ opts.codepage = 1200;
    $b8f343bf88dacc48$var$set_cp(1200);
    var seen_codepage = false;
    while(blob.l < blob.length - 1){
        var s = blob.l;
        var RecordType = blob.read_shift(2);
        if (RecordType === 0 && last_RT === 0x000a /* EOF */ ) break;
        var length = blob.l === blob.length ? 0 : blob.read_shift(2);
        var R = $b8f343bf88dacc48$var$XLSRecordEnum[RecordType];
        if (file_depth == 0 && [
            0x0009,
            0x0209,
            0x0409,
            0x0809
        ].indexOf(RecordType) == -1 /* BOF */ ) break;
        //console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
        //if(!R) console.log(blob.slice(blob.l, blob.l + length));
        if (R && R.f) {
            if (options.bookSheets) {
                if (last_RT === 0x0085 /* BoundSheet8 */  && RecordType !== 0x0085 /* R.n !== 'BoundSheet8' */ ) break;
            }
            last_RT = RecordType;
            if (R.r === 2 || R.r == 12) {
                var rt = blob.read_shift(2);
                length -= 2;
                if (!opts.enc && rt !== RecordType && ((rt & 0xFF) << 8 | rt >> 8) !== RecordType) throw new Error("rt mismatch: " + rt + "!=" + RecordType);
                if (R.r == 12) {
                    blob.l += 10;
                    length -= 10;
                } // skip FRT
            }
            //console.error(R,blob.l,length,blob.length);
            var val /*:any*/  = {} /*:any*/ ;
            if (RecordType === 0x000a /* EOF */ ) val = /*::(*/ R.f(blob, length, opts) /*:: :any)*/ ;
            else val = /*::(*/ $b8f343bf88dacc48$var$slurp(RecordType, R, blob, length, opts) /*:: :any)*/ ;
            /*:: val = (val:any); */ if (file_depth == 0 && [
                0x0009,
                0x0209,
                0x0409,
                0x0809
            ].indexOf(last_RT) === -1 /* BOF */ ) continue;
            switch(RecordType){
                case 0x0022 /* Date1904 */ :
                    /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ wb.opts.Date1904 = Workbook.WBProps.date1904 = val;
                    break;
                case 0x0086 /* WriteProtect */ :
                    wb.opts.WriteProtect = true;
                    break;
                case 0x002f /* FilePass */ :
                    if (!opts.enc) blob.l = 0;
                    opts.enc = val;
                    if (!options.password) throw new Error("File is password-protected");
                    if (val.valid == null) throw new Error("Encryption scheme unsupported");
                    if (!val.valid) throw new Error("Password is incorrect");
                    break;
                case 0x005c /* WriteAccess */ :
                    opts.lastuser = val;
                    break;
                case 0x0042 /* CodePage */ :
                    var cpval = Number(val);
                    /* overrides based on test cases */ switch(cpval){
                        case 0x5212:
                            cpval = 1200;
                            break;
                        case 0x8000:
                            cpval = 10000;
                            break;
                        case 0x8001:
                            cpval = 1252;
                            break;
                    }
                    $b8f343bf88dacc48$var$set_cp(opts.codepage = cpval);
                    seen_codepage = true;
                    break;
                case 0x013d /* RRTabId */ :
                    opts.rrtabid = val;
                    break;
                case 0x0019 /* WinProtect */ :
                    opts.winlocked = val;
                    break;
                case 0x01b7 /* RefreshAll */ :
                    wb.opts["RefreshAll"] = val;
                    break;
                case 0x000c /* CalcCount */ :
                    wb.opts["CalcCount"] = val;
                    break;
                case 0x0010 /* CalcDelta */ :
                    wb.opts["CalcDelta"] = val;
                    break;
                case 0x0011 /* CalcIter */ :
                    wb.opts["CalcIter"] = val;
                    break;
                case 0x000d /* CalcMode */ :
                    wb.opts["CalcMode"] = val;
                    break;
                case 0x000e /* CalcPrecision */ :
                    wb.opts["CalcPrecision"] = val;
                    break;
                case 0x005f /* CalcSaveRecalc */ :
                    wb.opts["CalcSaveRecalc"] = val;
                    break;
                case 0x000f /* CalcRefMode */ :
                    opts.CalcRefMode = val;
                    break; // TODO: implement R1C1
                case 0x08a3 /* ForceFullCalculation */ :
                    wb.opts.FullCalc = val;
                    break;
                case 0x0081 /* WsBool */ :
                    if (val.fDialog) out["!type"] = "dialog";
                    if (!val.fBelow) (out["!outline"] || (out["!outline"] = {})).above = true;
                    if (!val.fRight) (out["!outline"] || (out["!outline"] = {})).left = true;
                    break; // TODO
                case 0x0043:
                /* BIFF2XF */ case 0x0243:
                /* BIFF3XF */ case 0x0443:
                /* BIFF4XF */ case 0x00e0 /* XF */ :
                    XFs.push(val);
                    break;
                case 0x01ae /* SupBook */ :
                    supbooks.push([
                        val
                    ]);
                    supbooks[supbooks.length - 1].XTI = [];
                    break;
                case 0x0023:
                case 0x0223 /* ExternName */ :
                    supbooks[supbooks.length - 1].push(val);
                    break;
                case 0x0018:
                case 0x0218 /* Lbl */ :
                    last_lbl = {
                        Name: val.Name,
                        Ref: $b8f343bf88dacc48$var$stringify_formula(val.rgce, range, null, supbooks, opts)
                    } /*:DefinedName*/ ;
                    if (val.itab > 0) last_lbl.Sheet = val.itab - 1;
                    supbooks.names.push(last_lbl);
                    if (!supbooks[0]) {
                        supbooks[0] = [];
                        supbooks[0].XTI = [];
                    }
                    supbooks[supbooks.length - 1].push(val);
                    if (val.Name == "_xlnm._FilterDatabase" && val.itab > 0) {
                        if (val.rgce && val.rgce[0] && val.rgce[0][0] && val.rgce[0][0][0] == 'PtgArea3d') FilterDatabases[val.itab - 1] = {
                            ref: $b8f343bf88dacc48$var$encode_range(val.rgce[0][0][1][2])
                        };
                    }
                    break;
                case 0x0016 /* ExternCount */ :
                    opts.ExternCount = val;
                    break;
                case 0x0017 /* ExternSheet */ :
                    if (supbooks.length == 0) {
                        supbooks[0] = [];
                        supbooks[0].XTI = [];
                    }
                    supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
                    supbooks.XTI = supbooks.XTI.concat(val);
                    break;
                case 0x0894 /* NameCmt */ :
                    /* TODO: search for correct name */ if (opts.biff < 8) break;
                    if (last_lbl != null) last_lbl.Comment = val[1];
                    break;
                case 0x0012 /* Protect */ :
                    out["!protect"] = val;
                    break; /* for sheet or book */ 
                case 0x0013 /* Password */ :
                    if (val !== 0 && opts.WTF) console.error("Password verifier: " + val);
                    break;
                case 0x0085 /* BoundSheet8 */ :
                    Directory[opts.biff == 4 ? opts.snames.length : val.pos] = val;
                    opts.snames.push(val.name);
                    break;
                case 0x000a /* EOF */ :
                    if (--file_depth ? !biff4w : biff4w) break;
                    if (range.e) {
                        if (range.e.r > 0 && range.e.c > 0) {
                            range.e.r--;
                            range.e.c--;
                            out["!ref"] = $b8f343bf88dacc48$var$encode_range(range);
                            if (options.sheetRows && options.sheetRows <= range.e.r) {
                                var tmpri = range.e.r;
                                range.e.r = options.sheetRows - 1;
                                out["!fullref"] = out["!ref"];
                                out["!ref"] = $b8f343bf88dacc48$var$encode_range(range);
                                range.e.r = tmpri;
                            }
                            range.e.r++;
                            range.e.c++;
                        }
                        if (merges.length > 0) out["!merges"] = merges;
                        if (objects.length > 0) out["!objects"] = objects;
                        if (colinfo.length > 0) out["!cols"] = colinfo;
                        if (rowinfo.length > 0) out["!rows"] = rowinfo;
                        Workbook.Sheets.push(wsprops);
                    }
                    if (cur_sheet === "") Preamble = out;
                    else Sheets[cur_sheet] = out;
                    out = {} /*:any*/ ;
                    if (options.dense) out["!data"] = [];
                    break;
                case 0x0009:
                case 0x0209:
                case 0x0409:
                case 0x0809 /* BOF */ :
                    if (opts.biff === 8) opts.biff = ({
                        0x0009: 2,
                        0x0209: 3,
                        0x0409: 4
                    })[RecordType] || ({
                        0x0200: 2,
                        0x0300: 3,
                        0x0400: 4,
                        0x0500: 5,
                        0x0600: 8,
                        0x0002: 2,
                        0x0007: 2
                    })[val.BIFFVer] || 8;
                    opts.biffguess = val.BIFFVer == 0;
                    if (val.BIFFVer == 0 && val.dt == 0x1000) {
                        opts.biff = 5;
                        seen_codepage = true;
                        $b8f343bf88dacc48$var$set_cp(opts.codepage = 28591);
                    }
                    if (opts.biff == 4 && val.dt & 0x100) biff4w = true;
                    if (opts.biff == 8 && val.BIFFVer == 0 && val.dt == 16) opts.biff = 2;
                    if (file_depth++ && !biff4w) break;
                    out = {} /*:any*/ ;
                    if (options.dense) out["!data"] = [];
                    if (opts.biff < 8 && !seen_codepage) {
                        seen_codepage = true;
                        $b8f343bf88dacc48$var$set_cp(opts.codepage = options.codepage || 1252);
                    }
                    if (opts.biff == 4 && biff4w) cur_sheet = (Directory[opts.snames.indexOf(cur_sheet) + 1] || {
                        name: ""
                    }).name;
                    else if (opts.biff < 5 || val.BIFFVer == 0 && val.dt == 0x1000) {
                        if (cur_sheet === "") cur_sheet = "Sheet1";
                        range = {
                            s: {
                                r: 0,
                                c: 0
                            },
                            e: {
                                r: 0,
                                c: 0
                            }
                        };
                        /* fake BoundSheet8 */ var fakebs8 = {
                            pos: blob.l - length,
                            name: cur_sheet
                        };
                        Directory[fakebs8.pos] = fakebs8;
                        opts.snames.push(cur_sheet);
                    } else cur_sheet = (Directory[s] || {
                        name: ""
                    }).name;
                    if (val.dt == 0x20) out["!type"] = "chart";
                    if (val.dt == 0x40) out["!type"] = "macro";
                    merges = [];
                    objects = [];
                    opts.arrayf = arrayf = [];
                    colinfo = [];
                    rowinfo = [];
                    seencol = false;
                    wsprops = {
                        Hidden: (Directory[s] || {
                            hs: 0
                        }).hs,
                        name: cur_sheet
                    };
                    break;
                case 0x0203 /* Number */ :
                case 0x0003 /* BIFF2NUM */ :
                case 0x0002 /* BIFF2INT */ :
                    if (out["!type"] == "chart") {
                        if (options.dense ? (out["!data"][val.r] || [])[val.c] : out[$b8f343bf88dacc48$var$encode_col(val.c) + $b8f343bf88dacc48$var$encode_row(val.r)]) ++val.c;
                    }
                    temp_val = {
                        ixfe: val.ixfe,
                        XF: XFs[val.ixfe] || {},
                        v: val.val,
                        t: 'n'
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $b8f343bf88dacc48$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x0005:
                case 0x0205 /* BoolErr */ :
                    temp_val = {
                        ixfe: val.ixfe,
                        XF: XFs[val.ixfe],
                        v: val.val,
                        t: val.t
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $b8f343bf88dacc48$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x027e /* RK */ :
                    temp_val = {
                        ixfe: val.ixfe,
                        XF: XFs[val.ixfe],
                        v: val.rknum,
                        t: 'n'
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $b8f343bf88dacc48$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x00bd /* MulRk */ :
                    for(var j = val.c; j <= val.C; ++j){
                        var ixfe = val.rkrec[j - val.c][0];
                        temp_val = {
                            ixfe: ixfe,
                            XF: XFs[ixfe],
                            v: val.rkrec[j - val.c][1],
                            t: 'n'
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $b8f343bf88dacc48$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: j,
                            r: val.r
                        }, temp_val, options);
                    }
                    break;
                case 0x0006:
                case 0x0206:
                case 0x0406 /* Formula */ :
                    if (val.val == 'String') {
                        last_formula = val;
                        break;
                    }
                    temp_val = $b8f343bf88dacc48$var$make_cell(val.val, val.cell.ixfe, val.tt);
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (options.cellFormula) {
                        var _f = val.formula;
                        if (_f && _f[0] && _f[0][0] && _f[0][0][0] == 'PtgExp') {
                            var _fr = _f[0][0][1][0], _fc = _f[0][0][1][1];
                            var _fe = $b8f343bf88dacc48$var$encode_cell({
                                r: _fr,
                                c: _fc
                            });
                            if (sharedf[_fe]) temp_val.f = "" + $b8f343bf88dacc48$var$stringify_formula(val.formula, range, val.cell, supbooks, opts);
                            else temp_val.F = ((options.dense ? (out["!data"][_fr] || [])[_fc] : out[_fe]) || {}).F;
                        } else temp_val.f = "" + $b8f343bf88dacc48$var$stringify_formula(val.formula, range, val.cell, supbooks, opts);
                    }
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $b8f343bf88dacc48$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell(val.cell, temp_val, options);
                    last_formula = val;
                    break;
                case 0x0007:
                case 0x0207 /* String */ :
                    if (last_formula) {
                        last_formula.val = val;
                        temp_val = $b8f343bf88dacc48$var$make_cell(val, last_formula.cell.ixfe, 's');
                        temp_val.XF = XFs[temp_val.ixfe];
                        if (options.cellFormula) temp_val.f = "" + $b8f343bf88dacc48$var$stringify_formula(last_formula.formula, range, last_formula.cell, supbooks, opts);
                        if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $b8f343bf88dacc48$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell(last_formula.cell, temp_val, options);
                        last_formula = null;
                    } else throw new Error("String record expects Formula");
                    break;
                case 0x0021:
                case 0x0221 /* Array */ :
                    arrayf.push(val);
                    var _arraystart = $b8f343bf88dacc48$var$encode_cell(val[0].s);
                    cc = options.dense ? (out["!data"][val[0].s.r] || [])[val[0].s.c] : out[_arraystart];
                    if (options.cellFormula && cc) {
                        if (!last_formula) break; /* technically unreachable */ 
                        if (!_arraystart || !cc) break;
                        cc.f = "" + $b8f343bf88dacc48$var$stringify_formula(val[1], range, val[0], supbooks, opts);
                        cc.F = $b8f343bf88dacc48$var$encode_range(val[0]);
                    }
                    break;
                case 0x04bc /* ShrFmla */ :
                    if (!options.cellFormula) break;
                    if (last_cell) {
                        /* TODO: capture range */ if (!last_formula) break; /* technically unreachable */ 
                        sharedf[$b8f343bf88dacc48$var$encode_cell(last_formula.cell)] = val[0];
                        cc = options.dense ? (out["!data"][last_formula.cell.r] || [])[last_formula.cell.c] : out[$b8f343bf88dacc48$var$encode_cell(last_formula.cell)];
                        (cc || {}).f = "" + $b8f343bf88dacc48$var$stringify_formula(val[0], range, lastcell, supbooks, opts);
                    }
                    break;
                case 0x00fd /* LabelSst */ :
                    temp_val = $b8f343bf88dacc48$var$make_cell(sst[val.isst].t, val.ixfe, 's');
                    if (sst[val.isst].h) temp_val.h = sst[val.isst].h;
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $b8f343bf88dacc48$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x0201 /* Blank */ :
                    if (options.sheetStubs) {
                        temp_val = {
                            ixfe: val.ixfe,
                            XF: XFs[val.ixfe],
                            t: 'z'
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $b8f343bf88dacc48$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: val.c,
                            r: val.r
                        }, temp_val, options);
                    }
                    break;
                case 0x00be /* MulBlank */ :
                    if (options.sheetStubs) for(var _j = val.c; _j <= val.C; ++_j){
                        var _ixfe = val.ixfe[_j - val.c];
                        temp_val = {
                            ixfe: _ixfe,
                            XF: XFs[_ixfe],
                            t: 'z'
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $b8f343bf88dacc48$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: _j,
                            r: val.r
                        }, temp_val, options);
                    }
                    break;
                case 0x00d6 /* RString */ :
                case 0x0204 /* Label */ :
                case 0x0004 /* BIFF2STR */ :
                    temp_val = $b8f343bf88dacc48$var$make_cell(val.val, val.ixfe, 's');
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $b8f343bf88dacc48$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x0000:
                case 0x0200 /* Dimensions */ :
                    if (file_depth === 1) range = val; /* TODO: stack */ 
                    break;
                case 0x00fc /* SST */ :
                    sst = val;
                    break;
                case 0x041e /* Format */ :
                    if (opts.biff >= 3 && opts.biff <= 4) {
                        BIFF2FmtTable[BIFF2Fmt++] = val[1];
                        for(var b4idx = 0; b4idx < BIFF2Fmt + 163; ++b4idx)if ($b8f343bf88dacc48$var$table_fmt[b4idx] == val[1]) break;
                        if (b4idx >= 163) $b8f343bf88dacc48$var$SSF__load(val[1], BIFF2Fmt + 163);
                    } else $b8f343bf88dacc48$var$SSF__load(val[1], val[0]);
                    break;
                case 0x001e /* BIFF2FORMAT */ :
                    BIFF2FmtTable[BIFF2Fmt++] = val;
                    for(var b2idx = 0; b2idx < BIFF2Fmt + 163; ++b2idx)if ($b8f343bf88dacc48$var$table_fmt[b2idx] == val) break;
                    if (b2idx >= 163) $b8f343bf88dacc48$var$SSF__load(val, BIFF2Fmt + 163);
                    break;
                case 0x00e5 /* MergeCells */ :
                    merges = merges.concat(val);
                    break;
                case 0x005d /* Obj */ :
                    objects[val.cmo[0]] = opts.lastobj = val;
                    break;
                case 0x01b6 /* TxO */ :
                    opts.lastobj.TxO = val;
                    break;
                case 0x007f /* ImData */ :
                    opts.lastobj.ImData = val;
                    break;
                case 0x01b8 /* HLink */ :
                    for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC){
                        cc = options.dense ? (out["!data"][rngR] || [])[rngC] : out[$b8f343bf88dacc48$var$encode_cell({
                            c: rngC,
                            r: rngR
                        })];
                        if (cc) cc.l = val[1];
                    }
                    break;
                case 0x0800 /* HLinkTooltip */ :
                    for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC){
                        cc = options.dense ? (out["!data"][rngR] || [])[rngC] : out[$b8f343bf88dacc48$var$encode_cell({
                            c: rngC,
                            r: rngR
                        })];
                        if (cc && cc.l) cc.l.Tooltip = val[1];
                    }
                    break;
                case 0x001c /* Note */ :
                    /* TODO: comment continuation (row == -1 / 0xFFFF) */ cc = options.dense ? (out["!data"][val[0].r] || [])[val[0].c] : out[$b8f343bf88dacc48$var$encode_cell(val[0])];
                    if (!cc) {
                        if (options.dense) {
                            if (!out["!data"][val[0].r]) out["!data"][val[0].r] = [];
                            cc = out["!data"][val[0].r][val[0].c] = {
                                t: "z"
                            } /*:any*/ ;
                        } else cc = out[$b8f343bf88dacc48$var$encode_cell(val[0])] = {
                            t: "z"
                        } /*:any*/ ;
                        range.e.r = Math.max(range.e.r, val[0].r);
                        range.s.r = Math.min(range.s.r, val[0].r);
                        range.e.c = Math.max(range.e.c, val[0].c);
                        range.s.c = Math.min(range.s.c, val[0].c);
                    }
                    if (!cc.c) cc.c = [];
                    if (opts.biff <= 5 && opts.biff >= 2) cmnt = {
                        a: "SheetJ5",
                        t: val[1]
                    };
                    else {
                        var noteobj = objects[val[2]];
                        cmnt = {
                            a: val[1],
                            t: noteobj.TxO.t
                        };
                        if (val[3] != null && !(val[3] & 0x02)) cc.c.hidden = true;
                    }
                    cc.c.push(cmnt);
                    break;
                case 0x087d /* XFExt */ :
                    $b8f343bf88dacc48$var$update_xfext(XFs[val.ixfe], val.ext);
                    break;
                case 0x007d /* ColInfo */ :
                    if (!opts.cellStyles) break;
                    while(val.e >= val.s){
                        colinfo[val.e--] = {
                            width: val.w / 256,
                            level: val.level || 0,
                            hidden: !!(val.flags & 1)
                        };
                        if (!seencol) {
                            seencol = true;
                            $b8f343bf88dacc48$var$find_mdw_colw(val.w / 256);
                        }
                        $b8f343bf88dacc48$var$process_col(colinfo[val.e + 1]);
                    }
                    break;
                case 0x0208 /* Row */ :
                    var rowobj = {};
                    if (val.level != null) {
                        rowinfo[val.r] = rowobj;
                        rowobj.level = val.level;
                    }
                    if (val.hidden) {
                        rowinfo[val.r] = rowobj;
                        rowobj.hidden = true;
                    }
                    if (val.hpt) {
                        rowinfo[val.r] = rowobj;
                        rowobj.hpt = val.hpt;
                        rowobj.hpx = $b8f343bf88dacc48$var$pt2px(val.hpt);
                    }
                    break;
                case 0x0026 /* LeftMargin */ :
                case 0x0027 /* RightMargin */ :
                case 0x0028 /* TopMargin */ :
                case 0x0029 /* BottomMargin */ :
                    if (!out['!margins']) $b8f343bf88dacc48$var$default_margins(out['!margins'] = {});
                    out['!margins'][({
                        0x26: "left",
                        0x27: "right",
                        0x28: "top",
                        0x29: "bottom"
                    })[RecordType]] = val;
                    break;
                case 0x00a1 /* Setup */ :
                    if (!out['!margins']) $b8f343bf88dacc48$var$default_margins(out['!margins'] = {});
                    out['!margins'].header = val.header;
                    out['!margins'].footer = val.footer;
                    break;
                case 0x023e /* Window2 */ :
                    // $FlowIgnore
                    if (val.RTL) Workbook.Views[0].RTL = true;
                    break;
                case 0x0092 /* Palette */ :
                    palette = val;
                    break;
                case 0x0896 /* Theme */ :
                    themes = val;
                    break;
                case 0x008c /* Country */ :
                    country = val;
                    break;
                case 0x01ba /* CodeName */ :
                    /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ if (!cur_sheet) Workbook.WBProps.CodeName = val || "ThisWorkbook";
                    else wsprops.CodeName = val || wsprops.name;
                    break;
            }
        } else {
            if (!R) console.error("Missing Info for XLS Record 0x" + RecordType.toString(16));
            blob.l += length;
        }
    }
    wb.SheetNames = $b8f343bf88dacc48$var$keys(Directory).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(x) {
        return Directory[x].name;
    });
    if (!options.bookSheets) wb.Sheets = Sheets;
    if (!wb.SheetNames.length && Preamble["!ref"]) {
        wb.SheetNames.push("Sheet1");
        /*jshint -W069 */ if (wb.Sheets) wb.Sheets["Sheet1"] = Preamble;
    /*jshint +W069 */ } else wb.Preamble = Preamble;
    if (wb.Sheets) FilterDatabases.forEach(function(r, i) {
        wb.Sheets[wb.SheetNames[i]]['!autofilter'] = r;
    });
    wb.Strings = sst;
    wb.SSF = $b8f343bf88dacc48$var$dup($b8f343bf88dacc48$var$table_fmt);
    if (opts.enc) wb.Encryption = opts.enc;
    if (themes) wb.Themes = themes;
    wb.Metadata = {};
    if (country !== undefined) wb.Metadata.Country = country;
    if (supbooks.names.length > 0) Workbook.Names = supbooks.names;
    wb.Workbook = Workbook;
    return wb;
}
/* TODO: split props*/ var $b8f343bf88dacc48$var$PSCLSID = {
    SI: "e0859ff2f94f6810ab9108002b27b3d9",
    DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
    UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
};
function $b8f343bf88dacc48$var$parse_xls_props(cfb /*:CFBContainer*/ , props, o) {
    /* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */ var DSI = $b8f343bf88dacc48$export$9f0e51cd97c572a.find(cfb, '/!DocumentSummaryInformation');
    if (DSI && DSI.size > 0) try {
        var DocSummary = $b8f343bf88dacc48$var$parse_PropertySetStream(DSI, $b8f343bf88dacc48$var$DocSummaryPIDDSI, $b8f343bf88dacc48$var$PSCLSID.DSI);
        for(var d in DocSummary)props[d] = DocSummary[d];
    } catch (e) {
        if (o.WTF) throw e; /* empty */ 
    }
    /* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/ var SI = $b8f343bf88dacc48$export$9f0e51cd97c572a.find(cfb, '/!SummaryInformation');
    if (SI && SI.size > 0) try {
        var Summary = $b8f343bf88dacc48$var$parse_PropertySetStream(SI, $b8f343bf88dacc48$var$SummaryPIDSI, $b8f343bf88dacc48$var$PSCLSID.SI);
        for(var s in Summary)if (props[s] == null) props[s] = Summary[s];
    } catch (e) {
        if (o.WTF) throw e; /* empty */ 
    }
    if (props.HeadingPairs && props.TitlesOfParts) {
        $b8f343bf88dacc48$var$load_props_pairs(props.HeadingPairs, props.TitlesOfParts, props, o);
        delete props.HeadingPairs;
        delete props.TitlesOfParts;
    }
}
function $b8f343bf88dacc48$var$write_xls_props(wb /*:Workbook*/ , cfb /*:CFBContainer*/ ) {
    var DSEntries = [], SEntries = [], CEntries = [];
    var i = 0, Keys;
    var DocSummaryRE /*:{[key:string]:string}*/  = $b8f343bf88dacc48$var$evert_key($b8f343bf88dacc48$var$DocSummaryPIDDSI, "n");
    var SummaryRE /*:{[key:string]:string}*/  = $b8f343bf88dacc48$var$evert_key($b8f343bf88dacc48$var$SummaryPIDSI, "n");
    if (wb.Props) {
        Keys = $b8f343bf88dacc48$var$keys(wb.Props);
        // $FlowIgnore
        for(i = 0; i < Keys.length; ++i)(Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([
            Keys[i],
            wb.Props[Keys[i]]
        ]);
    }
    if (wb.Custprops) {
        Keys = $b8f343bf88dacc48$var$keys(wb.Custprops);
        // $FlowIgnore
        for(i = 0; i < Keys.length; ++i)if (!Object.prototype.hasOwnProperty.call(wb.Props || {}, Keys[i])) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([
            Keys[i],
            wb.Custprops[Keys[i]]
        ]);
    }
    var CEntries2 = [];
    for(i = 0; i < CEntries.length; ++i){
        if ($b8f343bf88dacc48$var$XLSPSSkip.indexOf(CEntries[i][0]) > -1 || $b8f343bf88dacc48$var$PseudoPropsPairs.indexOf(CEntries[i][0]) > -1) continue;
        if (CEntries[i][1] == null) continue;
        CEntries2.push(CEntries[i]);
    }
    if (SEntries.length) $b8f343bf88dacc48$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/\u0005SummaryInformation", $b8f343bf88dacc48$var$write_PropertySetStream(SEntries, $b8f343bf88dacc48$var$PSCLSID.SI, SummaryRE, $b8f343bf88dacc48$var$SummaryPIDSI));
    if (DSEntries.length || CEntries2.length) $b8f343bf88dacc48$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/\u0005DocumentSummaryInformation", $b8f343bf88dacc48$var$write_PropertySetStream(DSEntries, $b8f343bf88dacc48$var$PSCLSID.DSI, DocSummaryRE, $b8f343bf88dacc48$var$DocSummaryPIDDSI, CEntries2.length ? CEntries2 : null, $b8f343bf88dacc48$var$PSCLSID.UDI));
}
function $b8f343bf88dacc48$export$b41972a043aba84c(cfb /*:any*/ , options /*:?ParseOpts*/ ) /*:Workbook*/ {
    if (!options) options = {};
    $b8f343bf88dacc48$var$fix_read_opts(options);
    $b8f343bf88dacc48$var$reset_cp();
    if (options.codepage) $b8f343bf88dacc48$var$set_ansi(options.codepage);
    var CompObj /*:?CFBEntry*/ , WB /*:?any*/ ;
    if (cfb.FullPaths) {
        if ($b8f343bf88dacc48$export$9f0e51cd97c572a.find(cfb, '/encryption')) throw new Error("File is password-protected");
        CompObj = $b8f343bf88dacc48$export$9f0e51cd97c572a.find(cfb, '!CompObj');
        WB = $b8f343bf88dacc48$export$9f0e51cd97c572a.find(cfb, '/Workbook') || $b8f343bf88dacc48$export$9f0e51cd97c572a.find(cfb, '/Book');
    } else {
        switch(options.type){
            case 'base64':
                cfb = $b8f343bf88dacc48$var$s2a($b8f343bf88dacc48$var$Base64_decode(cfb));
                break;
            case 'binary':
                cfb = $b8f343bf88dacc48$var$s2a(cfb);
                break;
            case 'buffer':
                break;
            case 'array':
                if (!Array.isArray(cfb)) cfb = Array.prototype.slice.call(cfb);
                break;
        }
        $b8f343bf88dacc48$var$prep_blob(cfb, 0);
        WB = {
            content: cfb
        } /*:any*/ ;
    }
    var /*::CompObjP, */ WorkbookP /*:: :Workbook = XLSX.utils.book_new(); */ ;
    var _data /*:?any*/ ;
    if (CompObj) /*::CompObjP = */ $b8f343bf88dacc48$var$parse_compobj(CompObj);
    if (options.bookProps && !options.bookSheets) WorkbookP = {} /*:any*/ ;
    else /*:: if(cfb instanceof CFBContainer) */ {
        var T = $b8f343bf88dacc48$var$has_buf ? 'buffer' : 'array';
        if (WB && WB.content) WorkbookP = $b8f343bf88dacc48$var$parse_workbook(WB.content, options);
        else if ((_data = $b8f343bf88dacc48$export$9f0e51cd97c572a.find(cfb, 'PerfectOffice_MAIN')) && _data.content) WorkbookP = $b8f343bf88dacc48$var$WK_.to_workbook(_data.content, (options.type = T, options));
        else if ((_data = $b8f343bf88dacc48$export$9f0e51cd97c572a.find(cfb, 'NativeContent_MAIN')) && _data.content) WorkbookP = $b8f343bf88dacc48$var$WK_.to_workbook(_data.content, (options.type = T, options));
        else if ((_data = $b8f343bf88dacc48$export$9f0e51cd97c572a.find(cfb, 'MN0')) && _data.content) throw new Error("Unsupported Works 4 for Mac file");
        else throw new Error("Cannot find Workbook stream");
        if (options.bookVBA && cfb.FullPaths && $b8f343bf88dacc48$export$9f0e51cd97c572a.find(cfb, '/_VBA_PROJECT_CUR/VBA/dir')) WorkbookP.vbaraw = $b8f343bf88dacc48$var$make_vba_xls(cfb);
    }
    var props = {};
    if (cfb.FullPaths) $b8f343bf88dacc48$var$parse_xls_props(/*::((*/ cfb /*:: :any):CFBContainer)*/ , props, options);
    WorkbookP.Props = WorkbookP.Custprops = props; /* TODO: split up properties */ 
    if (options.bookFiles) WorkbookP.cfb = cfb;
    /*WorkbookP.CompObjP = CompObjP; // TODO: storage? */ return WorkbookP;
}
function $b8f343bf88dacc48$var$write_xlscfb(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:CFBContainer*/ {
    var o = opts || {};
    var cfb = $b8f343bf88dacc48$export$9f0e51cd97c572a.utils.cfb_new({
        root: "R"
    });
    var wbpath = "/Workbook";
    switch(o.bookType || "xls"){
        case "xls":
            o.bookType = "biff8";
        /* falls through */ case "xla":
            if (!o.bookType) o.bookType = "xla";
        /* falls through */ case "biff8":
            wbpath = "/Workbook";
            o.biff = 8;
            break;
        case "biff5":
            wbpath = "/Book";
            o.biff = 5;
            break;
        default:
            throw new Error("invalid type " + o.bookType + " for XLS CFB");
    }
    $b8f343bf88dacc48$export$9f0e51cd97c572a.utils.cfb_add(cfb, wbpath, $b8f343bf88dacc48$var$write_biff_buf(wb, o));
    if (o.biff == 8 && (wb.Props || wb.Custprops)) $b8f343bf88dacc48$var$write_xls_props(wb, cfb);
    // TODO: SI, DSI, CO
    if (o.biff == 8 && wb.vbaraw) $b8f343bf88dacc48$var$fill_vba_xls(cfb, $b8f343bf88dacc48$export$9f0e51cd97c572a.read(wb.vbaraw, {
        type: typeof wb.vbaraw == "string" ? "binary" : "buffer"
    }));
    return cfb;
}
/* [MS-XLSB] 2.3 Record Enumeration */ var $b8f343bf88dacc48$var$XLSBRecordEnum = {
    0x0000: {
        f: $b8f343bf88dacc48$var$parse_BrtRowHdr
    },
    0x0001: {
        f: $b8f343bf88dacc48$var$parse_BrtCellBlank
    },
    0x0002: {
        f: $b8f343bf88dacc48$var$parse_BrtCellRk
    },
    0x0003: {
        f: $b8f343bf88dacc48$var$parse_BrtCellError
    },
    0x0004: {
        f: $b8f343bf88dacc48$var$parse_BrtCellBool
    },
    0x0005: {
        f: $b8f343bf88dacc48$var$parse_BrtCellReal
    },
    0x0006: {
        f: $b8f343bf88dacc48$var$parse_BrtCellSt
    },
    0x0007: {
        f: $b8f343bf88dacc48$var$parse_BrtCellIsst
    },
    0x0008: {
        f: $b8f343bf88dacc48$var$parse_BrtFmlaString
    },
    0x0009: {
        f: $b8f343bf88dacc48$var$parse_BrtFmlaNum
    },
    0x000A: {
        f: $b8f343bf88dacc48$var$parse_BrtFmlaBool
    },
    0x000B: {
        f: $b8f343bf88dacc48$var$parse_BrtFmlaError
    },
    0x000C: {
        f: $b8f343bf88dacc48$var$parse_BrtShortBlank
    },
    0x000D: {
        f: $b8f343bf88dacc48$var$parse_BrtShortRk
    },
    0x000E: {
        f: $b8f343bf88dacc48$var$parse_BrtShortError
    },
    0x000F: {
        f: $b8f343bf88dacc48$var$parse_BrtShortBool
    },
    0x0010: {
        f: $b8f343bf88dacc48$var$parse_BrtShortReal
    },
    0x0011: {
        f: $b8f343bf88dacc48$var$parse_BrtShortSt
    },
    0x0012: {
        f: $b8f343bf88dacc48$var$parse_BrtShortIsst
    },
    0x0013: {
        f: $b8f343bf88dacc48$var$parse_RichStr
    },
    0x0014: {},
    0x0015: {},
    0x0016: {},
    0x0017: {},
    0x0018: {},
    0x0019: {},
    0x001A: {},
    0x001B: {},
    0x001C: {},
    0x001D: {},
    0x001E: {},
    0x001F: {},
    0x0020: {},
    0x0021: {},
    0x0022: {},
    0x0023: {
        T: 1
    },
    0x0024: {
        T: -1
    },
    0x0025: {
        T: 1
    },
    0x0026: {
        T: -1
    },
    0x0027: {
        f: $b8f343bf88dacc48$var$parse_BrtName
    },
    0x0028: {},
    0x002A: {},
    0x002B: {
        f: $b8f343bf88dacc48$var$parse_BrtFont
    },
    0x002C: {
        f: $b8f343bf88dacc48$var$parse_BrtFmt
    },
    0x002D: {
        f: $b8f343bf88dacc48$var$parse_BrtFill
    },
    0x002E: {
        f: $b8f343bf88dacc48$var$parse_BrtBorder
    },
    0x002F: {
        f: $b8f343bf88dacc48$var$parse_BrtXF
    },
    0x0030: {},
    0x0031: {
        f: $b8f343bf88dacc48$var$parse_Int32LE
    },
    0x0032: {},
    0x0033: {
        f: $b8f343bf88dacc48$var$parse_BrtMdb
    },
    0x0034: {
        T: 1
    },
    0x0035: {
        T: -1
    },
    0x0036: {
        T: 1
    },
    0x0037: {
        T: -1
    },
    0x0038: {
        T: 1
    },
    0x0039: {
        T: -1
    },
    0x003A: {},
    0x003B: {},
    0x003C: {
        f: $b8f343bf88dacc48$var$parse_ColInfo
    },
    0x003E: {
        f: $b8f343bf88dacc48$var$parse_BrtCellRString
    },
    0x003F: {
        f: $b8f343bf88dacc48$var$parse_BrtCalcChainItem$
    },
    0x0040: {
        f: $b8f343bf88dacc48$var$parse_BrtDVal
    },
    0x0041: {},
    0x0042: {},
    0x0043: {},
    0x0044: {},
    0x0045: {},
    0x0046: {},
    0x0080: {},
    0x0081: {
        T: 1
    },
    0x0082: {
        T: -1
    },
    0x0083: {
        T: 1,
        f: $b8f343bf88dacc48$var$parsenoop,
        p: 0
    },
    0x0084: {
        T: -1
    },
    0x0085: {
        T: 1
    },
    0x0086: {
        T: -1
    },
    0x0087: {
        T: 1
    },
    0x0088: {
        T: -1
    },
    0x0089: {
        T: 1,
        f: $b8f343bf88dacc48$var$parse_BrtBeginWsView
    },
    0x008A: {
        T: -1
    },
    0x008B: {
        T: 1
    },
    0x008C: {
        T: -1
    },
    0x008D: {
        T: 1
    },
    0x008E: {
        T: -1
    },
    0x008F: {
        T: 1
    },
    0x0090: {
        T: -1
    },
    0x0091: {
        T: 1
    },
    0x0092: {
        T: -1
    },
    0x0093: {
        f: $b8f343bf88dacc48$var$parse_BrtWsProp
    },
    0x0094: {
        f: $b8f343bf88dacc48$var$parse_BrtWsDim,
        p: 16
    },
    0x0097: {
        f: $b8f343bf88dacc48$var$parse_BrtPane
    },
    0x0098: {},
    0x0099: {
        f: $b8f343bf88dacc48$var$parse_BrtWbProp
    },
    0x009A: {},
    0x009B: {},
    0x009C: {
        f: $b8f343bf88dacc48$var$parse_BrtBundleSh
    },
    0x009D: {},
    0x009E: {},
    0x009F: {
        T: 1,
        f: $b8f343bf88dacc48$var$parse_BrtBeginSst
    },
    0x00A0: {
        T: -1
    },
    0x00A1: {
        T: 1,
        f: $b8f343bf88dacc48$var$parse_UncheckedRfX
    },
    0x00A2: {
        T: -1
    },
    0x00A3: {
        T: 1
    },
    0x00A4: {
        T: -1
    },
    0x00A5: {
        T: 1
    },
    0x00A6: {
        T: -1
    },
    0x00A7: {},
    0x00A8: {},
    0x00A9: {},
    0x00AA: {},
    0x00AB: {},
    0x00AC: {
        T: 1
    },
    0x00AD: {
        T: -1
    },
    0x00AE: {},
    0x00AF: {},
    0x00B0: {
        f: $b8f343bf88dacc48$var$parse_BrtMergeCell
    },
    0x00B1: {
        T: 1
    },
    0x00B2: {
        T: -1
    },
    0x00B3: {
        T: 1
    },
    0x00B4: {
        T: -1
    },
    0x00B5: {
        T: 1
    },
    0x00B6: {
        T: -1
    },
    0x00B7: {
        T: 1
    },
    0x00B8: {
        T: -1
    },
    0x00B9: {
        T: 1
    },
    0x00BA: {
        T: -1
    },
    0x00BB: {
        T: 1
    },
    0x00BC: {
        T: -1
    },
    0x00BD: {
        T: 1
    },
    0x00BE: {
        T: -1
    },
    0x00BF: {
        T: 1
    },
    0x00C0: {
        T: -1
    },
    0x00C1: {
        T: 1
    },
    0x00C2: {
        T: -1
    },
    0x00C3: {
        T: 1
    },
    0x00C4: {
        T: -1
    },
    0x00C5: {
        T: 1
    },
    0x00C6: {
        T: -1
    },
    0x00C7: {
        T: 1
    },
    0x00C8: {
        T: -1
    },
    0x00C9: {
        T: 1
    },
    0x00CA: {
        T: -1
    },
    0x00CB: {
        T: 1
    },
    0x00CC: {
        T: -1
    },
    0x00CD: {
        T: 1
    },
    0x00CE: {
        T: -1
    },
    0x00CF: {
        T: 1
    },
    0x00D0: {
        T: -1
    },
    0x00D1: {
        T: 1
    },
    0x00D2: {
        T: -1
    },
    0x00D3: {
        T: 1
    },
    0x00D4: {
        T: -1
    },
    0x00D5: {
        T: 1
    },
    0x00D6: {
        T: -1
    },
    0x00D7: {
        T: 1
    },
    0x00D8: {
        T: -1
    },
    0x00D9: {
        T: 1
    },
    0x00DA: {
        T: -1
    },
    0x00DB: {
        T: 1
    },
    0x00DC: {
        T: -1
    },
    0x00DD: {
        T: 1
    },
    0x00DE: {
        T: -1
    },
    0x00DF: {
        T: 1
    },
    0x00E0: {
        T: -1
    },
    0x00E1: {
        T: 1
    },
    0x00E2: {
        T: -1
    },
    0x00E3: {
        T: 1
    },
    0x00E4: {
        T: -1
    },
    0x00E5: {
        T: 1
    },
    0x00E6: {
        T: -1
    },
    0x00E7: {
        T: 1
    },
    0x00E8: {
        T: -1
    },
    0x00E9: {
        T: 1
    },
    0x00EA: {
        T: -1
    },
    0x00EB: {
        T: 1
    },
    0x00EC: {
        T: -1
    },
    0x00ED: {
        T: 1
    },
    0x00EE: {
        T: -1
    },
    0x00EF: {
        T: 1
    },
    0x00F0: {
        T: -1
    },
    0x00F1: {
        T: 1
    },
    0x00F2: {
        T: -1
    },
    0x00F3: {
        T: 1
    },
    0x00F4: {
        T: -1
    },
    0x00F5: {
        T: 1
    },
    0x00F6: {
        T: -1
    },
    0x00F7: {
        T: 1
    },
    0x00F8: {
        T: -1
    },
    0x00F9: {
        T: 1
    },
    0x00FA: {
        T: -1
    },
    0x00FB: {
        T: 1
    },
    0x00FC: {
        T: -1
    },
    0x00FD: {
        T: 1
    },
    0x00FE: {
        T: -1
    },
    0x00FF: {
        T: 1
    },
    0x0100: {
        T: -1
    },
    0x0101: {
        T: 1
    },
    0x0102: {
        T: -1
    },
    0x0103: {
        T: 1
    },
    0x0104: {
        T: -1
    },
    0x0105: {
        T: 1
    },
    0x0106: {
        T: -1
    },
    0x0107: {
        T: 1
    },
    0x0108: {
        T: -1
    },
    0x0109: {
        T: 1
    },
    0x010A: {
        T: -1
    },
    0x010B: {
        T: 1
    },
    0x010C: {
        T: -1
    },
    0x010D: {
        T: 1
    },
    0x010E: {
        T: -1
    },
    0x010F: {
        T: 1
    },
    0x0110: {
        T: -1
    },
    0x0111: {
        T: 1
    },
    0x0112: {
        T: -1
    },
    0x0113: {
        T: 1
    },
    0x0114: {
        T: -1
    },
    0x0115: {},
    0x0116: {
        T: 1
    },
    0x0117: {
        T: -1
    },
    0x0118: {
        T: 1
    },
    0x0119: {
        T: -1
    },
    0x011A: {
        T: 1
    },
    0x011B: {
        T: 1
    },
    0x011C: {
        T: -1
    },
    0x011D: {
        T: 1
    },
    0x011E: {
        T: -1
    },
    0x011F: {
        T: 1
    },
    0x0120: {
        T: -1
    },
    0x0121: {
        T: 1
    },
    0x0122: {
        T: -1
    },
    0x0123: {
        T: 1
    },
    0x0124: {
        T: -1
    },
    0x0125: {
        T: 1
    },
    0x0126: {
        T: -1
    },
    0x0127: {
        T: 1
    },
    0x0128: {
        T: -1
    },
    0x0129: {
        T: 1
    },
    0x012A: {
        T: -1
    },
    0x012B: {
        T: 1
    },
    0x012C: {
        T: -1
    },
    0x012D: {
        T: 1
    },
    0x012E: {
        T: -1
    },
    0x012F: {
        T: 1
    },
    0x0130: {
        T: -1
    },
    0x0131: {
        T: 1
    },
    0x0132: {
        T: -1
    },
    0x0133: {
        T: 1
    },
    0x0134: {
        T: -1
    },
    0x0135: {
        T: 1
    },
    0x0136: {
        T: -1
    },
    0x0137: {
        T: 1
    },
    0x0138: {
        T: -1
    },
    0x0139: {
        T: -1
    },
    0x013A: {
        T: 1
    },
    0x013B: {
        T: -1
    },
    0x013C: {
        T: 1
    },
    0x013D: {
        T: -1
    },
    0x013E: {
        T: 1
    },
    0x013F: {
        T: -1
    },
    0x0140: {
        T: 1
    },
    0x0141: {
        T: -1
    },
    0x0142: {
        T: 1
    },
    0x0143: {
        T: -1
    },
    0x0144: {
        T: 1
    },
    0x0145: {
        T: -1
    },
    0x0146: {
        T: 1
    },
    0x0147: {
        T: -1
    },
    0x0148: {
        T: 1
    },
    0x0149: {
        T: -1
    },
    0x014A: {
        T: 1
    },
    0x014B: {
        T: -1
    },
    0x014C: {
        T: 1
    },
    0x014D: {
        T: -1
    },
    0x014E: {
        T: 1
    },
    0x014F: {
        f: $b8f343bf88dacc48$var$parse_BrtMdtinfo
    },
    0x0150: {
        T: -1
    },
    0x0151: {
        f: $b8f343bf88dacc48$var$parse_BrtBeginEsmdb,
        T: 1
    },
    0x0152: {
        T: -1
    },
    0x0153: {
        T: 1
    },
    0x0154: {
        T: -1
    },
    0x0155: {
        T: 1
    },
    0x0156: {
        T: -1
    },
    0x0157: {
        T: 1
    },
    0x0158: {
        T: -1
    },
    0x0159: {
        T: 1
    },
    0x015A: {
        T: -1
    },
    0x015B: {
        T: 1
    },
    0x015C: {
        T: -1
    },
    0x015D: {
        T: 1
    },
    0x015E: {
        T: -1
    },
    0x015F: {},
    0x0160: {},
    0x0161: {
        T: 1
    },
    0x0162: {
        T: -1
    },
    0x0163: {
        f: $b8f343bf88dacc48$var$parse_RelID
    },
    0x0165: {},
    0x0166: {},
    0x0167: {},
    0x0168: {
        T: 1
    },
    0x0169: {},
    0x016A: {
        f: $b8f343bf88dacc48$var$parse_ExternSheet
    },
    0x016B: {},
    0x016C: {},
    0x016E: {},
    0x016F: {},
    0x0170: {},
    0x0171: {},
    0x0172: {},
    0x0173: {},
    0x0174: {
        T: 1
    },
    0x0175: {
        T: -1
    },
    0x0176: {
        T: 1
    },
    0x0177: {
        T: -1
    },
    0x0178: {
        T: 1
    },
    0x0179: {
        T: -1
    },
    0x017A: {
        T: 1
    },
    0x017B: {
        T: -1
    },
    0x017C: {
        T: 1
    },
    0x017D: {
        T: -1
    },
    0x017E: {
        T: 1
    },
    0x017F: {
        T: -1
    },
    0x0180: {
        T: 1
    },
    0x0181: {
        T: -1
    },
    0x0182: {
        T: 1
    },
    0x0183: {
        T: -1
    },
    0x0184: {
        T: 1
    },
    0x0185: {
        T: -1
    },
    0x0186: {
        T: 1
    },
    0x0187: {
        T: -1
    },
    0x0188: {
        T: 1
    },
    0x0189: {
        T: -1
    },
    0x018A: {
        T: 1
    },
    0x018B: {
        T: -1
    },
    0x018C: {},
    0x018D: {},
    0x018E: {},
    0x018F: {},
    0x0190: {},
    0x0191: {
        T: 1
    },
    0x0193: {},
    0x0194: {},
    0x0195: {},
    0x0196: {},
    0x0197: {},
    0x0198: {},
    0x0199: {},
    0x019A: {},
    0x019B: {},
    0x019C: {},
    0x019D: {},
    0x019E: {},
    0x019F: {},
    0x01A0: {},
    0x01A1: {},
    0x01A2: {},
    0x01A3: {},
    0x01A4: {},
    0x01A5: {},
    0x01A6: {
        T: 1
    },
    0x01A7: {
        T: 1
    },
    0x01A8: {
        T: -1
    },
    0x01A9: {
        T: -1
    },
    0x01AA: {
        f: $b8f343bf88dacc48$var$parse_BrtArrFmla
    },
    0x01AB: {
        f: $b8f343bf88dacc48$var$parse_BrtShrFmla
    },
    0x01AC: {},
    0x01AD: {
        T: 1
    },
    0x01AE: {
        T: -1
    },
    0x01AF: {
        T: 1
    },
    0x01B0: {
        T: -1
    },
    0x01B1: {
        T: 1
    },
    0x01B2: {
        T: -1
    },
    0x01B3: {
        T: 1
    },
    0x01B4: {
        T: -1
    },
    0x01B5: {
        T: 1
    },
    0x01B6: {
        T: -1
    },
    0x01B7: {
        T: 1
    },
    0x01B8: {
        T: -1
    },
    0x01B9: {
        T: 1
    },
    0x01BA: {
        T: -1
    },
    0x01BB: {
        T: 1
    },
    0x01BC: {
        T: -1
    },
    0x01BD: {
        T: 1
    },
    0x01BE: {
        T: -1
    },
    0x01BF: {
        T: 1
    },
    0x01C0: {
        T: -1
    },
    0x01C1: {
        T: 1
    },
    0x01C2: {
        T: -1
    },
    0x01C3: {
        T: 1
    },
    0x01C4: {
        T: -1
    },
    0x01C5: {
        T: 1
    },
    0x01C6: {
        T: -1
    },
    0x01C7: {
        T: 1
    },
    0x01C8: {
        T: -1
    },
    0x01C9: {
        T: 1
    },
    0x01CA: {
        T: -1
    },
    0x01CB: {
        T: 1
    },
    0x01CC: {
        T: -1
    },
    0x01CD: {
        T: 1
    },
    0x01CE: {
        T: -1
    },
    0x01CF: {
        T: 1
    },
    0x01D0: {
        T: -1
    },
    0x01D1: {
        T: 1
    },
    0x01D2: {
        T: -1
    },
    0x01D3: {
        T: 1
    },
    0x01D4: {
        T: -1
    },
    0x01D5: {
        T: 1
    },
    0x01D6: {
        T: -1
    },
    0x01D7: {},
    0x01D8: {},
    0x01D9: {
        T: 1
    },
    0x01DA: {
        T: -1
    },
    0x01DB: {},
    0x01DC: {
        f: $b8f343bf88dacc48$var$parse_BrtMargins
    },
    0x01DD: {},
    0x01DE: {},
    0x01DF: {
        T: 1
    },
    0x01E0: {
        T: -1
    },
    0x01E1: {
        T: 1
    },
    0x01E2: {
        T: -1
    },
    0x01E3: {
        T: 1
    },
    0x01E4: {
        T: -1
    },
    0x01E5: {
        f: $b8f343bf88dacc48$var$parse_BrtWsFmtInfo
    },
    0x01E6: {
        T: 1
    },
    0x01E7: {
        T: -1
    },
    0x01E8: {
        T: 1
    },
    0x01E9: {
        T: -1
    },
    0x01EA: {
        T: 1
    },
    0x01EB: {
        T: -1
    },
    0x01EC: {
        T: 1
    },
    0x01ED: {
        T: -1
    },
    0x01EE: {
        f: $b8f343bf88dacc48$var$parse_BrtHLink
    },
    0x01EF: {
        T: 1
    },
    0x01F0: {
        T: -1
    },
    0x01F1: {
        T: 1
    },
    0x01F2: {
        T: -1
    },
    0x01F3: {},
    0x01F4: {
        T: 1
    },
    0x01F5: {
        T: -1
    },
    0x01F6: {
        T: 1
    },
    0x01F7: {
        T: -1
    },
    0x01F8: {},
    0x01F9: {
        T: 1
    },
    0x01FA: {
        T: -1
    },
    0x01FB: {},
    0x01FC: {
        T: 1
    },
    0x01FD: {
        T: -1
    },
    0x01FE: {
        T: 1
    },
    0x01FF: {
        T: -1
    },
    0x0200: {},
    0x0201: {},
    0x0202: {
        T: 1
    },
    0x0203: {
        T: -1
    },
    0x0204: {
        T: 1
    },
    0x0205: {
        T: -1
    },
    0x0206: {
        T: 1
    },
    0x0207: {
        T: -1
    },
    0x0208: {
        T: 1
    },
    0x0209: {
        T: -1
    },
    0x020A: {},
    0x020B: {},
    0x020C: {},
    0x020D: {},
    0x020E: {},
    0x020F: {},
    0x0210: {
        T: 1
    },
    0x0211: {
        T: -1
    },
    0x0212: {
        T: 1
    },
    0x0213: {
        T: -1
    },
    0x0214: {
        T: 1
    },
    0x0215: {
        T: -1
    },
    0x0216: {},
    0x0217: {},
    0x0218: {},
    0x0219: {},
    0x021A: {
        T: 1
    },
    0x021B: {
        T: -1
    },
    0x021C: {
        T: 1
    },
    0x021D: {
        T: -1
    },
    0x021E: {
        T: 1
    },
    0x0224: {},
    0x0225: {},
    0x0226: {
        f: $b8f343bf88dacc48$var$parse_RelID
    },
    0x0227: {
        f: $b8f343bf88dacc48$var$parse_XLNullableWideString
    },
    0x0228: {},
    0x0229: {},
    0x022A: {
        T: 1
    },
    0x022B: {
        T: -1
    },
    0x022C: {
        T: 1
    },
    0x022D: {
        T: -1
    },
    0x022E: {
        T: 1
    },
    0x022F: {
        T: -1
    },
    0x0230: {
        T: 1
    },
    0x0231: {
        T: -1
    },
    0x0232: {},
    0x0234: {},
    0x0235: {
        T: 1
    },
    0x0236: {
        T: -1
    },
    0x0239: {
        T: 1
    },
    0x023A: {
        T: -1
    },
    0x023C: {},
    0x023D: {
        T: 1
    },
    0x023E: {
        T: -1
    },
    0x0241: {},
    0x0242: {},
    0x0243: {},
    0x0244: {},
    0x0245: {},
    0x0246: {},
    0x0247: {},
    0x0248: {},
    0x0249: {},
    0x024A: {},
    0x024B: {},
    0x024C: {
        T: -1
    },
    0x024D: {},
    0x024E: {
        T: 1
    },
    0x024F: {
        T: -1
    },
    0x0250: {
        T: 1
    },
    0x0251: {
        T: -1
    },
    0x0252: {
        T: 1
    },
    0x0253: {
        T: -1
    },
    0x0254: {},
    0x0255: {
        T: 1
    },
    0x0256: {
        T: -1
    },
    0x0257: {
        T: 1
    },
    0x0258: {
        T: -1
    },
    0x0259: {
        T: 1
    },
    0x025A: {
        T: -1
    },
    0x025B: {
        T: 1
    },
    0x025C: {
        T: -1
    },
    0x025D: {
        T: 1
    },
    0x025E: {
        T: -1
    },
    0x025F: {},
    0x0260: {
        T: 1
    },
    0x0261: {
        T: -1
    },
    0x0262: {},
    0x0263: {
        T: 1
    },
    0x0264: {
        T: -1
    },
    0x0265: {
        T: 1
    },
    0x0266: {
        T: -1
    },
    0x0267: {
        T: 1
    },
    0x0268: {
        T: -1
    },
    0x0269: {
        T: 1
    },
    0x026A: {
        T: -1
    },
    0x026B: {
        T: 1
    },
    0x026C: {
        T: -1
    },
    0x0271: {},
    0x0272: {
        T: 1
    },
    0x0273: {
        T: -1
    },
    0x0274: {
        T: 1
    },
    0x0275: {
        T: -1
    },
    0x0276: {
        T: 1
    },
    0x0277: {
        T: -1
    },
    0x0278: {
        f: $b8f343bf88dacc48$var$parse_BrtCommentAuthor
    },
    0x0279: {
        T: 1
    },
    0x027A: {
        T: -1
    },
    0x027B: {
        T: 1,
        f: $b8f343bf88dacc48$var$parse_BrtBeginComment
    },
    0x027C: {
        T: -1
    },
    0x027D: {
        f: $b8f343bf88dacc48$var$parse_BrtCommentText
    },
    0x027E: {
        T: 1
    },
    0x027F: {},
    0x0280: {
        T: -1
    },
    0x0281: {
        T: 1
    },
    0x0282: {
        T: -1
    },
    0x0283: {
        T: 1
    },
    0x0284: {},
    0x0285: {
        T: -1
    },
    0x0286: {
        T: 1
    },
    0x0288: {
        T: 1
    },
    0x0289: {},
    0x028A: {
        T: -1
    },
    0x028B: {
        f: $b8f343bf88dacc48$var$parse_BrtCsProp
    },
    0x028C: {},
    0x028D: {
        T: 1
    },
    0x028E: {
        T: -1
    },
    0x028F: {
        T: 1
    },
    0x0290: {
        T: -1
    },
    0x0291: {
        T: 1
    },
    0x0292: {
        T: -1
    },
    0x0293: {},
    0x0294: {
        T: 1
    },
    0x0295: {},
    0x0296: {
        T: -1
    },
    0x0297: {},
    0x0298: {
        T: 1
    },
    0x0299: {},
    0x029A: {
        T: -1
    },
    0x029B: {},
    0x029C: {},
    0x029D: {},
    0x029F: {
        T: 1
    },
    0x02A0: {
        T: -1
    },
    0x02A1: {
        T: 1
    },
    0x02A2: {
        T: -1
    },
    0x02A3: {},
    0x02A4: {},
    0x02A5: {},
    0x02A6: {},
    0x02A7: {},
    0x02A8: {},
    0x02A9: {},
    0x0400: {},
    0x0401: {},
    0x0402: {
        T: 1
    },
    0x0403: {
        T: -1
    },
    0x0404: {
        T: 1
    },
    0x0405: {
        T: -1
    },
    0x0406: {},
    0x0407: {
        T: 1
    },
    0x0408: {
        T: -1
    },
    0x0409: {
        T: 1
    },
    0x040A: {
        T: -1
    },
    0x040B: {},
    0x040C: {},
    0x040D: {},
    0x040E: {
        T: 1
    },
    0x040F: {
        T: -1
    },
    0x0410: {},
    0x0411: {
        T: 1
    },
    0x0412: {
        T: -1
    },
    0x0413: {},
    0x0414: {},
    0x0415: {},
    0x0416: {
        T: 1
    },
    0x0417: {
        T: -1
    },
    0x0418: {
        T: 1
    },
    0x0419: {
        T: -1
    },
    0x041A: {},
    0x041B: {
        T: 1
    },
    0x041C: {
        T: 1
    },
    0x041D: {
        f: $b8f343bf88dacc48$var$parse_BrtDVal14
    },
    0x041E: {
        T: 1
    },
    0x041F: {},
    0x0420: {
        T: 1
    },
    0x0421: {
        T: -1
    },
    0x0422: {
        T: 1
    },
    0x0423: {
        T: -1
    },
    0x0425: {},
    0x0426: {
        T: 1
    },
    0x0427: {
        T: -1
    },
    0x0428: {
        T: 1
    },
    0x0429: {
        T: -1
    },
    0x042A: {
        T: 1
    },
    0x042B: {
        T: -1
    },
    0x042C: {
        T: 1
    },
    0x042D: {
        T: -1
    },
    0x042E: {
        T: 1
    },
    0x042F: {
        T: -1
    },
    0x0430: {
        T: 1
    },
    0x0431: {
        T: -1
    },
    0x0433: {
        T: 1
    },
    0x0434: {
        T: -1
    },
    0x0435: {
        T: 1
    },
    0x0436: {
        T: -1
    },
    0x0437: {
        T: 1
    },
    0x0438: {
        T: -1
    },
    0x0439: {
        T: 1
    },
    0x043A: {
        T: -1
    },
    0x043B: {
        T: 1
    },
    0x043C: {
        T: -1
    },
    0x043D: {},
    0x043E: {
        T: 1
    },
    0x043F: {
        T: -1
    },
    0x0440: {
        T: 1
    },
    0x0441: {
        T: -1
    },
    0x0442: {
        T: 1
    },
    0x0443: {
        T: -1
    },
    0x0444: {
        T: 1
    },
    0x0445: {
        T: -1
    },
    0x0446: {
        T: 1
    },
    0x0447: {
        T: -1
    },
    0x0448: {},
    0x0449: {
        T: 1
    },
    0x044A: {},
    0x044B: {
        T: -1
    },
    0x044C: {
        T: 1
    },
    0x044D: {
        T: -1
    },
    0x044E: {},
    0x044F: {},
    0x0450: {},
    0x0451: {},
    0x0457: {},
    0x0458: {},
    0x0459: {
        T: 1
    },
    0x045A: {
        T: -1
    },
    0x045B: {
        T: 1
    },
    0x045C: {
        T: -1
    },
    0x045D: {},
    0x045E: {
        T: 1
    },
    0x045F: {
        T: -1
    },
    0x0460: {
        T: 1
    },
    0x0461: {
        T: -1
    },
    0x0462: {
        T: 1
    },
    0x0463: {
        T: -1
    },
    0x0464: {
        T: 1
    },
    0x0465: {
        T: -1
    },
    0x0466: {},
    0x0468: {
        T: 1
    },
    0x0469: {
        T: -1
    },
    0x046A: {},
    0x046B: {
        T: 1
    },
    0x046C: {
        T: -1
    },
    0x046D: {
        T: 1
    },
    0x046E: {
        T: -1
    },
    0x046F: {
        T: 1
    },
    0x0470: {
        T: -1
    },
    0x0471: {
        T: 1
    },
    0x0472: {
        T: -1
    },
    0x0473: {
        T: 1
    },
    0x0474: {
        T: -1
    },
    0x0475: {},
    0x0476: {
        T: 1
    },
    0x0477: {
        T: -1
    },
    0x0478: {
        T: 1
    },
    0x0479: {
        T: -1
    },
    0x047A: {},
    0x047B: {
        T: 1
    },
    0x047C: {
        T: -1
    },
    0x047D: {
        T: 1
    },
    0x047E: {
        T: -1
    },
    0x0480: {
        T: 1
    },
    0x0481: {
        T: -1
    },
    0x0482: {
        T: -1
    },
    0x0483: {
        T: -1
    },
    0x0484: {
        T: -1
    },
    0x0485: {
        T: 1
    },
    0x0486: {
        T: -1
    },
    0x0487: {
        T: 1
    },
    0x0488: {
        T: -1
    },
    0x0489: {
        T: 1
    },
    0x048A: {
        T: -1
    },
    0x048B: {
        T: 1
    },
    0x048C: {
        T: -1
    },
    0x048D: {
        T: 1
    },
    0x048E: {
        T: -1
    },
    0x048F: {
        T: 1
    },
    0x0490: {
        T: -1
    },
    0x0491: {
        T: 1
    },
    0x0492: {
        T: -1
    },
    0x0493: {},
    0x0494: {
        T: 1
    },
    0x0495: {
        T: -1
    },
    0x0499: {},
    0x049A: {
        T: 1
    },
    0x049C: {},
    0x049D: {},
    0x049E: {},
    0x0800: {
        T: 1
    },
    0x0801: {
        T: -1
    },
    0x0802: {},
    0x0803: {
        T: 1
    },
    0x0804: {
        T: -1
    },
    0x0805: {},
    0x0806: {},
    0x0807: {
        T: 1
    },
    0x0808: {
        T: -1
    },
    0x0809: {
        T: 1
    },
    0x080A: {
        T: -1
    },
    0x080C: {},
    0x0813: {},
    0x0814: {
        T: 1
    },
    0x0815: {
        T: -1
    },
    0x0816: {},
    0x0817: {},
    0x0818: {
        T: 1
    },
    0x0819: {
        T: -1
    },
    0x081B: {},
    0x081C: {},
    0x081D: {
        T: 1
    },
    0x081E: {
        T: -1
    },
    0x081F: {},
    0x0820: {
        T: 1
    },
    0x0821: {
        T: -1
    },
    0x0822: {},
    0x0823: {
        T: 1
    },
    0x0824: {
        T: -1
    },
    0x0825: {
        T: 1
    },
    0x0826: {
        T: -1
    },
    0x0827: {
        T: 1
    },
    0x0828: {
        T: -1
    },
    0x0829: {
        T: 1
    },
    0x082A: {
        T: -1
    },
    0x082B: {},
    0x082C: {},
    0x082D: {
        T: 1
    },
    0x082E: {
        T: -1
    },
    0x082F: {},
    0x0830: {
        T: 1
    },
    0x0831: {
        T: -1
    },
    0x0832: {
        T: 1
    },
    0x0833: {
        T: -1
    },
    0x0834: {
        T: 1
    },
    0x0835: {
        T: -1
    },
    0x0836: {},
    0x0837: {
        T: 1
    },
    0x0838: {
        T: -1
    },
    0x0839: {},
    0x083A: {
        T: 1
    },
    0x083B: {
        T: -1
    },
    0x083C: {},
    0x083D: {
        T: 1
    },
    0x083E: {
        T: -1
    },
    0x083F: {
        T: 1
    },
    0x0840: {
        T: -1
    },
    0x0841: {
        T: 1
    },
    0x0842: {
        T: -1
    },
    0x0843: {},
    0x0844: {},
    0x0845: {},
    0x0846: {
        T: 1
    },
    0x0847: {
        T: -1
    },
    0x0848: {},
    0x0849: {
        T: 1
    },
    0x084A: {
        T: -1
    },
    0x084B: {
        T: 1
    },
    0x084C: {
        T: -1
    },
    0x084D: {},
    0x084E: {
        T: 1
    },
    0x084F: {
        T: -1
    },
    0x0850: {},
    0x0851: {
        T: 1
    },
    0x0852: {
        T: -1
    },
    0x0853: {
        T: 1
    },
    0x0854: {
        T: -1
    },
    0x0855: {
        T: 1
    },
    0x0856: {},
    0x0857: {},
    0x0858: {},
    0x0859: {
        T: 1
    },
    0x085A: {
        T: -1
    },
    0x085B: {
        T: 1
    },
    0x085C: {
        T: -1
    },
    0x085D: {},
    0x0C00: {},
    0x0C01: {},
    0x1000: {
        T: 1
    },
    0x1001: {
        T: -1
    },
    0x138A: {
        T: 1
    },
    0x138B: {
        T: -1
    },
    0x13D9: {
        T: 1
    },
    0x13DA: {
        T: -1
    },
    0x13DB: {},
    0x13DC: {
        T: 1
    },
    0x13DD: {
        T: -1
    },
    0x13DE: {
        T: 1
    },
    0x13DF: {
        T: -1
    },
    0x13E0: {},
    0x13E1: {},
    0x13E2: {},
    0x13E4: {
        T: 1
    },
    0x13E5: {
        T: -1
    },
    0x13E6: {},
    0x13E7: {
        T: 1
    },
    0x13E8: {
        T: -1
    },
    0x13E9: {},
    0x13EB: {},
    0xFFFF: {
        n: ""
    }
};
/* [MS-XLS] 2.3 Record Enumeration (and other sources) */ var $b8f343bf88dacc48$var$XLSRecordEnum = {
    /* [MS-XLS] 2.3 Record Enumeration 2021-08-17 */ 0x0006: {
        f: $b8f343bf88dacc48$var$parse_Formula
    },
    0x000a: {
        f: $b8f343bf88dacc48$var$parsenoop2
    },
    0x000c: {
        f: $b8f343bf88dacc48$var$parseuint16
    },
    0x000d: {
        f: $b8f343bf88dacc48$var$parseuint16
    },
    0x000e: {
        f: $b8f343bf88dacc48$var$parsebool
    },
    0x000f: {
        f: $b8f343bf88dacc48$var$parsebool
    },
    0x0010: {
        f: $b8f343bf88dacc48$var$parse_Xnum
    },
    0x0011: {
        f: $b8f343bf88dacc48$var$parsebool
    },
    0x0012: {
        f: $b8f343bf88dacc48$var$parsebool
    },
    0x0013: {
        f: $b8f343bf88dacc48$var$parseuint16
    },
    0x0014: {
        f: $b8f343bf88dacc48$var$parse_XLHeaderFooter
    },
    0x0015: {
        f: $b8f343bf88dacc48$var$parse_XLHeaderFooter
    },
    0x0017: {
        f: $b8f343bf88dacc48$var$parse_ExternSheet
    },
    0x0018: {
        f: $b8f343bf88dacc48$var$parse_Lbl
    },
    0x0019: {
        f: $b8f343bf88dacc48$var$parsebool
    },
    0x001a: {},
    0x001b: {},
    0x001c: {
        f: $b8f343bf88dacc48$var$parse_Note
    },
    0x001d: {},
    0x0022: {
        f: $b8f343bf88dacc48$var$parsebool
    },
    0x0023: {
        f: $b8f343bf88dacc48$var$parse_ExternName
    },
    0x0026: {
        f: $b8f343bf88dacc48$var$parse_Xnum
    },
    0x0027: {
        f: $b8f343bf88dacc48$var$parse_Xnum
    },
    0x0028: {
        f: $b8f343bf88dacc48$var$parse_Xnum
    },
    0x0029: {
        f: $b8f343bf88dacc48$var$parse_Xnum
    },
    0x002a: {
        f: $b8f343bf88dacc48$var$parsebool
    },
    0x002b: {
        f: $b8f343bf88dacc48$var$parsebool
    },
    0x002f: {
        f: $b8f343bf88dacc48$var$parse_FilePass
    },
    0x0031: {
        f: $b8f343bf88dacc48$var$parse_Font
    },
    0x0033: {
        f: $b8f343bf88dacc48$var$parseuint16
    },
    0x003c: {},
    0x003d: {
        f: $b8f343bf88dacc48$var$parse_Window1
    },
    0x0040: {
        f: $b8f343bf88dacc48$var$parsebool
    },
    0x0041: {
        f: $b8f343bf88dacc48$var$parse_Pane
    },
    0x0042: {
        f: $b8f343bf88dacc48$var$parseuint16
    },
    0x004d: {},
    0x0050: {},
    0x0051: {},
    0x0052: {},
    0x0055: {
        f: $b8f343bf88dacc48$var$parseuint16
    },
    0x0059: {},
    0x005a: {},
    0x005b: {},
    0x005c: {
        f: $b8f343bf88dacc48$var$parse_WriteAccess
    },
    0x005d: {
        f: $b8f343bf88dacc48$var$parse_Obj
    },
    0x005e: {},
    0x005f: {
        f: $b8f343bf88dacc48$var$parsebool
    },
    0x0060: {},
    0x0061: {},
    0x0063: {
        f: $b8f343bf88dacc48$var$parsebool
    },
    0x007d: {
        f: $b8f343bf88dacc48$var$parse_ColInfo
    },
    0x0080: {
        f: $b8f343bf88dacc48$var$parse_Guts
    },
    0x0081: {
        f: $b8f343bf88dacc48$var$parse_WsBool
    },
    0x0082: {
        f: $b8f343bf88dacc48$var$parseuint16
    },
    0x0083: {
        f: $b8f343bf88dacc48$var$parsebool
    },
    0x0084: {
        f: $b8f343bf88dacc48$var$parsebool
    },
    0x0085: {
        f: $b8f343bf88dacc48$var$parse_BoundSheet8
    },
    0x0086: {},
    0x008c: {
        f: $b8f343bf88dacc48$var$parse_Country
    },
    0x008d: {
        f: $b8f343bf88dacc48$var$parseuint16
    },
    0x0090: {},
    0x0092: {
        f: $b8f343bf88dacc48$var$parse_Palette
    },
    0x0097: {},
    0x0098: {},
    0x0099: {},
    0x009a: {},
    0x009b: {},
    0x009c: {
        f: $b8f343bf88dacc48$var$parseuint16
    },
    0x009d: {},
    0x009e: {},
    0x00a0: {
        f: $b8f343bf88dacc48$var$parse_Scl
    },
    0x00a1: {
        f: $b8f343bf88dacc48$var$parse_Setup
    },
    0x00ae: {},
    0x00af: {},
    0x00b0: {},
    0x00b1: {},
    0x00b2: {},
    0x00b4: {},
    0x00b5: {},
    0x00b6: {},
    0x00b8: {},
    0x00b9: {},
    0x00bd: {
        f: $b8f343bf88dacc48$var$parse_MulRk
    },
    0x00be: {
        f: $b8f343bf88dacc48$var$parse_MulBlank
    },
    0x00c1: {
        f: $b8f343bf88dacc48$var$parsenoop2
    },
    0x00c5: {},
    0x00c6: {},
    0x00c7: {},
    0x00c8: {},
    0x00c9: {},
    0x00ca: {
        f: $b8f343bf88dacc48$var$parsebool
    },
    0x00cb: {},
    0x00cc: {},
    0x00cd: {},
    0x00ce: {},
    0x00cf: {},
    0x00d0: {},
    0x00d1: {},
    0x00d2: {},
    0x00d3: {},
    0x00d5: {},
    0x00d7: {},
    0x00d8: {},
    0x00d9: {},
    0x00da: {
        f: $b8f343bf88dacc48$var$parseuint16
    },
    0x00dc: {},
    0x00dd: {
        f: $b8f343bf88dacc48$var$parsebool
    },
    0x00de: {},
    0x00e0: {
        f: $b8f343bf88dacc48$var$parse_XF
    },
    0x00e1: {
        f: $b8f343bf88dacc48$var$parse_InterfaceHdr
    },
    0x00e2: {
        f: $b8f343bf88dacc48$var$parsenoop2
    },
    0x00e3: {},
    0x00e5: {
        f: $b8f343bf88dacc48$var$parse_MergeCells
    },
    0x00e9: {},
    0x00eb: {},
    0x00ec: {},
    0x00ed: {},
    0x00ef: {},
    0x00f0: {},
    0x00f1: {},
    0x00f2: {},
    0x00f4: {},
    0x00f5: {},
    0x00f6: {},
    0x00f7: {},
    0x00f8: {},
    0x00f9: {},
    0x00fb: {},
    0x00fc: {
        f: $b8f343bf88dacc48$var$parse_SST
    },
    0x00fd: {
        f: $b8f343bf88dacc48$var$parse_LabelSst
    },
    0x00ff: {
        f: $b8f343bf88dacc48$var$parse_ExtSST
    },
    0x0100: {},
    0x0103: {},
    0x0122: {},
    0x0137: {},
    0x0138: {},
    0x013b: {},
    0x013d: {
        f: $b8f343bf88dacc48$var$parseuint16a
    },
    0x013e: {},
    0x013f: {},
    0x0140: {},
    0x014a: {},
    0x014b: {},
    0x014d: {},
    0x014e: {},
    0x014f: {},
    0x0150: {},
    0x0151: {},
    0x0152: {},
    0x0153: {},
    0x0154: {},
    0x015f: {},
    0x0160: {
        f: $b8f343bf88dacc48$var$parsebool
    },
    0x0161: {
        f: $b8f343bf88dacc48$var$parsenoop2
    },
    0x0191: {},
    0x0192: {},
    0x0193: {},
    0x0194: {},
    0x0195: {},
    0x0196: {},
    0x0197: {},
    0x0198: {},
    0x01a9: {},
    0x01aa: {},
    0x01ab: {},
    0x01ac: {},
    0x01ad: {},
    0x01ae: {
        f: $b8f343bf88dacc48$var$parse_SupBook
    },
    0x01af: {
        f: $b8f343bf88dacc48$var$parsebool
    },
    0x01b0: {},
    0x01b1: {},
    0x01b2: {},
    0x01b5: {},
    0x01b6: {
        f: $b8f343bf88dacc48$var$parse_TxO
    },
    0x01b7: {
        f: $b8f343bf88dacc48$var$parsebool
    },
    0x01b8: {
        f: $b8f343bf88dacc48$var$parse_HLink
    },
    0x01b9: {},
    0x01ba: {
        f: $b8f343bf88dacc48$var$parse_XLUnicodeString
    },
    0x01bb: {},
    0x01bc: {
        f: $b8f343bf88dacc48$var$parseuint16
    },
    0x01bd: {},
    0x01be: {},
    0x01c0: {
        f: $b8f343bf88dacc48$var$parsenoop2
    },
    0x01c1: {
        f: $b8f343bf88dacc48$var$parse_RecalcId,
        r: 2
    },
    0x01c2: {
        f: $b8f343bf88dacc48$var$parsenoop2
    },
    0x0200: {
        f: $b8f343bf88dacc48$var$parse_Dimensions
    },
    0x0201: {
        f: $b8f343bf88dacc48$var$parse_Blank
    },
    0x0203: {
        f: $b8f343bf88dacc48$var$parse_Number
    },
    0x0204: {
        f: $b8f343bf88dacc48$var$parse_Label
    },
    0x0205: {
        f: $b8f343bf88dacc48$var$parse_BoolErr
    },
    0x0207: {
        f: $b8f343bf88dacc48$var$parse_String
    },
    0x0208: {
        f: $b8f343bf88dacc48$var$parse_Row
    },
    0x020b: {},
    0x0221: {
        f: $b8f343bf88dacc48$var$parse_Array
    },
    0x0225: {
        f: $b8f343bf88dacc48$var$parse_DefaultRowHeight
    },
    0x0236: {},
    0x023e: {
        f: $b8f343bf88dacc48$var$parse_Window2
    },
    0x027e: {
        f: $b8f343bf88dacc48$var$parse_RK
    },
    0x0293: {},
    0x0418: {},
    0x041e: {
        f: $b8f343bf88dacc48$var$parse_Format
    },
    0x043c: {},
    0x04bc: {
        f: $b8f343bf88dacc48$var$parse_ShrFmla
    },
    0x0800: {
        f: $b8f343bf88dacc48$var$parse_HLinkTooltip
    },
    0x0801: {},
    0x0802: {},
    0x0803: {},
    0x0804: {},
    0x0805: {},
    0x0806: {},
    0x0807: {},
    0x0808: {},
    0x0809: {
        f: $b8f343bf88dacc48$var$parse_BOF
    },
    0x080a: {},
    0x080b: {},
    0x080c: {},
    0x080d: {},
    0x080e: {},
    0x080f: {},
    0x0810: {},
    0x0812: {},
    0x0813: {},
    0x0850: {},
    0x0851: {},
    0x0852: {},
    0x0853: {},
    0x0854: {},
    0x0855: {},
    0x0856: {},
    0x0857: {},
    0x0858: {},
    0x0859: {},
    0x085a: {},
    0x0862: {},
    0x0863: {
        r: 12
    },
    0x0864: {},
    0x0865: {},
    0x0866: {},
    0x0867: {
        f: $b8f343bf88dacc48$var$parsenoop2
    },
    0x0868: {},
    0x086a: {},
    0x086b: {},
    0x086c: {},
    0x0871: {},
    0x0872: {},
    0x0874: {},
    0x0875: {},
    0x0876: {},
    0x0877: {},
    0x0878: {},
    0x0879: {},
    0x087a: {},
    0x087b: {},
    0x087c: {
        f: $b8f343bf88dacc48$var$parse_XFCRC,
        r: 12
    },
    0x087d: {
        f: $b8f343bf88dacc48$var$parse_XFExt,
        r: 12
    },
    0x087e: {},
    0x087f: {},
    0x0884: {},
    0x0885: {},
    0x0886: {},
    0x0887: {},
    0x0888: {},
    0x0889: {},
    0x088a: {},
    0x088b: {},
    0x088c: {
        f: $b8f343bf88dacc48$var$parsebool,
        r: 12
    },
    0x088d: {},
    0x088e: {
        r: 12
    },
    0x088f: {},
    0x0890: {},
    0x0892: {},
    0x0893: {},
    0x0894: {
        f: $b8f343bf88dacc48$var$parse_NameCmt,
        r: 12
    },
    0x0895: {},
    0x0896: {
        f: $b8f343bf88dacc48$var$parse_Theme,
        r: 12
    },
    0x0897: {},
    0x0898: {},
    0x0899: {},
    0x089a: {
        f: $b8f343bf88dacc48$var$parse_MTRSettings,
        r: 12
    },
    0x089b: {
        f: $b8f343bf88dacc48$var$parsenoop2
    },
    0x089c: {},
    0x089d: {},
    0x089e: {},
    0x089f: {},
    0x08a3: {
        f: $b8f343bf88dacc48$var$parse_ForceFullCalculation
    },
    0x08a4: {},
    0x08a5: {},
    0x08a6: {},
    0x08a7: {},
    0x1001: {},
    0x1002: {},
    0x1003: {},
    0x1006: {},
    0x1007: {},
    0x1009: {},
    0x100a: {},
    0x100b: {},
    0x100c: {},
    0x100d: {},
    0x1014: {},
    0x1015: {},
    0x1016: {},
    0x1017: {},
    0x1018: {},
    0x1019: {},
    0x101a: {},
    0x101b: {},
    0x101c: {},
    0x101d: {},
    0x101e: {},
    0x101f: {},
    0x1020: {},
    0x1021: {},
    0x1022: {},
    0x1024: {},
    0x1025: {},
    0x1026: {
        f: $b8f343bf88dacc48$var$parseuint16
    },
    0x1027: {},
    0x1032: {},
    0x1033: {},
    0x1034: {},
    0x1035: {},
    0x103a: {},
    0x103c: {},
    0x103d: {},
    0x103e: {},
    0x103f: {},
    0x1040: {},
    0x1041: {},
    0x1043: {},
    0x1044: {
        f: $b8f343bf88dacc48$var$parse_ShtProps
    },
    0x1045: {},
    0x1046: {},
    0x1048: {},
    0x104a: {},
    0x104b: {},
    0x104e: {},
    0x104f: {},
    0x1050: {},
    0x1051: {},
    0x105b: {},
    0x105c: {
        f: $b8f343bf88dacc48$var$parse_ClrtClient
    },
    0x105d: {},
    0x105f: {},
    0x1060: {},
    0x1061: {},
    0x1062: {},
    0x1063: {},
    0x1064: {},
    0x1065: {},
    0x1066: {},
    0x1067: {},
    0x1068: {},
    0x0000: {
        f: $b8f343bf88dacc48$var$parse_Dimensions
    },
    0x0001: {},
    0x0002: {
        f: $b8f343bf88dacc48$var$parse_BIFF2INT
    },
    0x0003: {
        f: $b8f343bf88dacc48$var$parse_BIFF2NUM
    },
    0x0004: {
        f: $b8f343bf88dacc48$var$parse_BIFF2STR
    },
    0x0005: {
        f: $b8f343bf88dacc48$var$parse_BIFF2BOOLERR
    },
    0x0007: {
        f: $b8f343bf88dacc48$var$parse_BIFF2STRING
    },
    0x0008: {},
    0x0009: {
        f: $b8f343bf88dacc48$var$parse_BOF
    },
    0x000b: {},
    0x0016: {
        f: $b8f343bf88dacc48$var$parseuint16
    },
    0x001e: {
        f: $b8f343bf88dacc48$var$parse_BIFF2Format
    },
    0x001f: {},
    /* 16-bit cnt of BIFF2FORMAT records */ 0x0020: {},
    0x0021: {
        f: $b8f343bf88dacc48$var$parse_Array
    },
    0x0024: {},
    0x0025: {
        f: $b8f343bf88dacc48$var$parse_DefaultRowHeight
    },
    // 0x002c ??
    // 0x002d ??
    // 0x002e ??
    // 0x0030 FONTCOUNT: number of fonts
    0x0032: {
        f: $b8f343bf88dacc48$var$parse_BIFF2FONTXTRA
    },
    // 0x0035: INFOOPTS
    // 0x0036: TABLE (BIFF2 only)
    // 0x0037: TABLE2 (BIFF2 only)
    // 0x0038: WNDESK
    // 0x0039 ??
    // 0x003a: BEGINPREF
    // 0x003b: ENDPREF
    0x003e: {},
    // 0x003f ??
    // 0x0046: SHOWSCROLL
    // 0x0047: SHOWFORMULA
    // 0x0048: STATUSBAR
    // 0x0049: SHORTMENUS
    // 0x004A:
    // 0x004B:
    // 0x004C:
    // 0x004E:
    // 0x004F:
    // 0x0058: TOOLBAR (BIFF3)
    /* - - - */ 0x0034: {},
    0x0043: {
        f: $b8f343bf88dacc48$var$parse_BIFF2XF
    },
    0x0044: {
        f: $b8f343bf88dacc48$var$parseuint16
    },
    0x0045: {},
    0x0056: {},
    /* 16-bit cnt, similar to BIFF2 */ 0x007e: {},
    /* Not necessarily same as 0x027e */ 0x007f: {
        f: $b8f343bf88dacc48$var$parse_ImData
    },
    0x0087: {},
    0x0088: {},
    0x0089: {},
    // 0x8A
    // 0x8B LH: alternate menu key flag (BIFF3/4)
    // 0x8E
    0x008F: {
        f: $b8f343bf88dacc48$var$parse_BIFF4SheetInfo
    },
    0x0091: {},
    // 0x93 STYLE
    0x0094: {},
    0x0095: {},
    0x0096: {},
    // 0xA2 FNPROTO: function prototypes (BIFF4)
    // 0xA3
    // 0xA8
    0x00a9: {},
    0x00ab: {},
    0x00bc: {},
    /* Not necessarily same as 0x04bc */ 0x00bf: {},
    0x00c0: {},
    0x00c2: {},
    0x00c3: {},
    0x00d6: {
        f: $b8f343bf88dacc48$var$parse_RString
    },
    0x00df: {},
    0x00ea: {},
    0x0162: {},
    0x01a5: {},
    0x0206: {
        f: $b8f343bf88dacc48$var$parse_Formula
    },
    0x0209: {
        f: $b8f343bf88dacc48$var$parse_BOF
    },
    0x0218: {
        f: $b8f343bf88dacc48$var$parse_Lbl
    },
    0x0223: {
        f: $b8f343bf88dacc48$var$parse_ExternName
    },
    0x0231: {},
    0x0243: {
        f: $b8f343bf88dacc48$var$parse_BIFF3XF
    },
    0x0406: {
        f: $b8f343bf88dacc48$var$parse_Formula
    },
    0x0409: {
        f: $b8f343bf88dacc48$var$parse_BOF
    },
    0x0443: {
        f: $b8f343bf88dacc48$var$parse_BIFF4XF
    },
    0x086d: {},
    0x0873: {},
    0x0881: {},
    0x08c0: {},
    0x08c1: {},
    0x08c2: {},
    0x08c3: {},
    0x08c4: {},
    0x08c5: {},
    0x08c6: {},
    0x08c7: {},
    0x08c8: {},
    0x08c9: {},
    0x08ca: {},
    0x08cb: {},
    0x08d6: {
        r: 12
    },
    /* --- multiplan 4 records --- */ 0x0065: {},
    0x0066: {},
    0x0069: {},
    0x006a: {},
    0x006b: {},
    0x006d: {},
    0x0070: {},
    0x0072: {},
    0x7262: {}
};
function $b8f343bf88dacc48$var$write_biff_rec(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) /*:void*/ {
    var t /*:number*/  = type;
    if (isNaN(t)) return;
    var len = length || (payload || []).length || 0;
    var o = ba.next(4);
    o.write_shift(2, t);
    o.write_shift(2, len);
    if (/*:: len != null &&*/ len > 0 && $b8f343bf88dacc48$var$is_buf(payload)) ba.push(payload);
}
function $b8f343bf88dacc48$var$write_biff_continue(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) /*:void*/ {
    var len = length || (payload || []).length || 0;
    if (len <= 8224) return $b8f343bf88dacc48$var$write_biff_rec(ba, type, payload, len);
    var t = type;
    if (isNaN(t)) return;
    var parts = payload.parts || [], sidx = 0;
    var i = 0, w = 0;
    while(w + (parts[sidx] || 8224) <= 8224){
        w += parts[sidx] || 8224;
        sidx++;
    }
    var o = ba.next(4);
    o.write_shift(2, t);
    o.write_shift(2, w);
    ba.push(payload.slice(i, i + w));
    i += w;
    while(i < len){
        o = ba.next(4);
        o.write_shift(2, 0x3c); // TODO: figure out correct continue type
        w = 0;
        while(w + (parts[sidx] || 8224) <= 8224){
            w += parts[sidx] || 8224;
            sidx++;
        }
        o.write_shift(2, w);
        ba.push(payload.slice(i, i + w));
        i += w;
    }
}
function $b8f343bf88dacc48$var$write_BIFF2BERR(r /*:number*/ , c /*:number*/ , val, t /*:?string*/ ) {
    var out = $b8f343bf88dacc48$var$new_buf(9);
    $b8f343bf88dacc48$var$write_BIFF2Cell(out, r, c);
    $b8f343bf88dacc48$var$write_Bes(val, t || 'b', out);
    return out;
}
/* TODO: codepage, large strings */ function $b8f343bf88dacc48$var$write_BIFF2LABEL(r /*:number*/ , c /*:number*/ , val) {
    var out = $b8f343bf88dacc48$var$new_buf(8 + 2 * val.length);
    $b8f343bf88dacc48$var$write_BIFF2Cell(out, r, c);
    out.write_shift(1, val.length);
    out.write_shift(val.length, val, 'sbcs');
    return out.l < out.length ? out.slice(0, out.l) : out;
}
function $b8f343bf88dacc48$var$write_comments_biff2(ba /*:BufArray*/ , comments /*:Array<[Comment[], number, number]>*/ ) {
    comments.forEach(function(data) {
        var text = data[0].map(function(cc) {
            return cc.t;
        }).join("");
        // TODO: should '\n' be translated to '\r' to correct for Excel 5.0 bug when exporting to BIFF2/3 ?
        if (text.length <= 2048) return $b8f343bf88dacc48$var$write_biff_rec(ba, 0x001C, $b8f343bf88dacc48$var$write_NOTE_BIFF2(text, data[1], data[2]));
        $b8f343bf88dacc48$var$write_biff_rec(ba, 0x001C, $b8f343bf88dacc48$var$write_NOTE_BIFF2(text.slice(0, 2048), data[1], data[2], text.length));
        for(var i = 2048; i < text.length; i += 2048)$b8f343bf88dacc48$var$write_biff_rec(ba, 0x001C, $b8f343bf88dacc48$var$write_NOTE_BIFF2(text.slice(i, Math.min(i + 2048, text.length)), -1, -1, Math.min(2048, text.length - i)));
    });
}
/* TODO: BIFF3/4 use different records -- see comments*/ function $b8f343bf88dacc48$var$write_ws_biff2_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, date1904 /*:boolean*/ ) {
    var ifmt = 0;
    if (cell.z != null) {
        ifmt = opts._BIFF2FmtTable.indexOf(cell.z);
        if (ifmt == -1) {
            opts._BIFF2FmtTable.push(cell.z);
            ifmt = opts._BIFF2FmtTable.length - 1;
        }
    }
    var ixfe = 0;
    if (cell.z != null) {
        for(; ixfe < opts.cellXfs.length; ++ixfe)if (opts.cellXfs[ixfe].numFmtId == ifmt) break;
        if (ixfe == opts.cellXfs.length) opts.cellXfs.push({
            numFmtId: ifmt
        });
    }
    if (cell.v != null) switch(cell.t){
        case 'd':
        case 'n':
            var v = cell.t == 'd' ? $b8f343bf88dacc48$var$datenum($b8f343bf88dacc48$var$parseDate(cell.v, date1904), date1904) : cell.v;
            if (opts.biff == 2 && v == (v | 0) && v >= 0 && v < 65536) // 0x027E (RK) in BIFF3/4
            $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0002, $b8f343bf88dacc48$var$write_BIFF2INT(R, C, v, ixfe, ifmt));
            else if (isNaN(v)) // 0x0205 in BIFF3/4
            $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0005, $b8f343bf88dacc48$var$write_BIFF2BERR(R, C, 0x24, "e")); // #NUM!
            else if (!isFinite(v)) // 0x0205 in BIFF3/4
            $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0005, $b8f343bf88dacc48$var$write_BIFF2BERR(R, C, 0x07, "e")); // #DIV/0!
            else // 0x0203 in BIFF3/4
            $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0003, $b8f343bf88dacc48$var$write_BIFF2NUM(R, C, v, ixfe, ifmt));
            return;
        case 'b':
        case 'e':
            // 0x0205 in BIFF3/4
            $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0005, $b8f343bf88dacc48$var$write_BIFF2BERR(R, C, cell.v, cell.t));
            return;
        /* TODO: codepage, sst */ case 's':
        case 'str':
            // 0x0204 in BIFF3/4
            $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0004, $b8f343bf88dacc48$var$write_BIFF2LABEL(R, C, cell.v == null ? "" : String(cell.v).slice(0, 255)));
            return;
    }
    // 0x0201 in BIFF3/4
    $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0001, $b8f343bf88dacc48$var$write_BIFF2Cell(null, R, C));
}
function $b8f343bf88dacc48$var$write_ws_biff2(ba /*:BufArray*/ , ws /*:Worksheet*/ , idx /*:number*/ , opts, wb /*:Workbook*/ ) {
    var dense = ws["!data"] != null;
    var range = $b8f343bf88dacc48$var$safe_decode_range(ws['!ref'] || "A1"), rr = "", cols /*:Array<string>*/  = [];
    if (range.e.c > 0xFF || range.e.r > 0x3FFF) {
        if (opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
        range.e.c = Math.min(range.e.c, 0xFF);
        range.e.r = Math.min(range.e.c, 0x3FFF);
    }
    var date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
    var row = [], comments = [];
    /* TODO: 0x0000 / 0x0200 dimensions? */ for(var C = range.s.c; C <= range.e.c; ++C)cols[C] = $b8f343bf88dacc48$var$encode_col(C);
    for(var R = range.s.r; R <= range.e.r; ++R){
        if (dense) row = ws["!data"][R] || [];
        rr = $b8f343bf88dacc48$var$encode_row(R);
        for(C = range.s.c; C <= range.e.c; ++C){
            var cell = dense ? row[C] : ws[cols[C] + rr];
            if (!cell) continue;
            /* write cell */ $b8f343bf88dacc48$var$write_ws_biff2_cell(ba, cell, R, C, opts, date1904);
            if (cell.c) comments.push([
                cell.c,
                R,
                C
            ]);
        }
    }
    /* ... 0x12 0x19 0x13 (Password) */ $b8f343bf88dacc48$var$write_comments_biff2(ba, comments);
/* 0x3d (Window1) ... */ }
/* Based on test files */ function $b8f343bf88dacc48$var$write_biff2_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    var o = opts || {};
    var ba = $b8f343bf88dacc48$var$buf_array();
    var idx = 0;
    for(var i = 0; i < wb.SheetNames.length; ++i)if (wb.SheetNames[i] == o.sheet) idx = i;
    if (idx == 0 && !!o.sheet && wb.SheetNames[0] != o.sheet) throw new Error("Sheet not found: " + o.sheet);
    $b8f343bf88dacc48$var$write_biff_rec(ba, o.biff == 4 ? 0x0409 : o.biff == 3 ? 0x0209 : 0x0009, $b8f343bf88dacc48$var$write_BOF(wb, 0x10, o));
    if (((wb.Workbook || {}).WBProps || {}).date1904) $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0022, $b8f343bf88dacc48$var$writebool(true));
    o.cellXfs = [
        {
            numFmtId: 0
        }
    ];
    o._BIFF2FmtTable = [
        "General"
    ];
    o._Fonts = [];
    var body = $b8f343bf88dacc48$var$buf_array();
    $b8f343bf88dacc48$var$write_ws_biff2(body, wb.Sheets[wb.SheetNames[idx]], idx, o, wb);
    o._BIFF2FmtTable.forEach(function(f) {
        if (o.biff <= 3) $b8f343bf88dacc48$var$write_biff_rec(ba, 0x001E, $b8f343bf88dacc48$var$write_BIFF2Format(f));
        else $b8f343bf88dacc48$var$write_biff_rec(ba, 0x041E, $b8f343bf88dacc48$var$write_BIFF4Format(f));
    });
    o.cellXfs.forEach(function(xf) {
        switch(o.biff){
            case 2:
                $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0043, $b8f343bf88dacc48$var$write_BIFF2XF(xf));
                break;
            case 3:
                $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0243, $b8f343bf88dacc48$var$write_BIFF3XF(xf));
                break;
            case 4:
                $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0443, $b8f343bf88dacc48$var$write_BIFF4XF(xf));
                break;
        }
    });
    delete o._BIFF2FmtTable;
    delete o.cellXfs;
    delete o._Fonts;
    ba.push(body.end());
    $b8f343bf88dacc48$var$write_biff_rec(ba, 0x000A);
    return ba.end();
}
var $b8f343bf88dacc48$var$b8oid = 1, $b8f343bf88dacc48$var$b8ocnts /*:Array<[number, number, number]>*/  = [];
function $b8f343bf88dacc48$var$write_MsoDrawingGroup() {
    var buf = $b8f343bf88dacc48$var$new_buf(82 + 8 * $b8f343bf88dacc48$var$b8ocnts.length);
    /* [MS-ODRAW] 2.2.12 OfficeArtDggContainer */ buf.write_shift(2, 0x0F);
    buf.write_shift(2, 0xF000);
    buf.write_shift(4, 74 + 8 * $b8f343bf88dacc48$var$b8ocnts.length);
    buf.write_shift(2, 0);
    buf.write_shift(2, 0xF006);
    buf.write_shift(4, 16 + 8 * $b8f343bf88dacc48$var$b8ocnts.length);
    buf.write_shift(4, $b8f343bf88dacc48$var$b8oid);
    buf.write_shift(4, $b8f343bf88dacc48$var$b8ocnts.length + 1);
    var acc = 0;
    for(var i = 0; i < $b8f343bf88dacc48$var$b8ocnts.length; ++i)acc += $b8f343bf88dacc48$var$b8ocnts[i] && $b8f343bf88dacc48$var$b8ocnts[i][1] || 0;
    buf.write_shift(4, acc);
    buf.write_shift(4, $b8f343bf88dacc48$var$b8ocnts.length);
    /* 2.2.46 OfficeArtIDCL + */ $b8f343bf88dacc48$var$b8ocnts.forEach(function(b8) {
        buf.write_shift(4, b8[0]);
        buf.write_shift(4, b8[2]);
    });
    buf.write_shift(2, 0x33); // 0x03 | (3 << 4)
    buf.write_shift(2, 0xF00B);
    buf.write_shift(4, 0x12); // 3 * 6
    /* 2.3.21.15 Text Boolean Properties */ buf.write_shift(2, 0xBF);
    buf.write_shift(4, 0x00080008);
    /* 2.3.7.2 fillColor */ buf.write_shift(2, 0x0181);
    buf.write_shift(4, 0x08000041);
    /* 2.3.8.1 lineColor */ buf.write_shift(2, 0x01C0);
    buf.write_shift(4, 0x08000040);
    buf.write_shift(2, 0x40);
    buf.write_shift(2, 0xF11E);
    buf.write_shift(4, 16);
    buf.write_shift(4, 0x0800000D);
    buf.write_shift(4, 0x0800000C);
    buf.write_shift(4, 0x08000017);
    buf.write_shift(4, 0x100000F7);
    return buf;
}
function $b8f343bf88dacc48$var$write_comments_biff8(ba /*:BufArray*/ , comments /*:Array<[Comment[], number, number]>*/ ) {
    var notes /*:Array<RawData>*/  = [], sz = 0, pl = $b8f343bf88dacc48$var$buf_array(), baseid = $b8f343bf88dacc48$var$b8oid;
    var _oasc;
    comments.forEach(function(c, ci) {
        var author = "";
        var text = c[0].map(function(t) {
            if (t.a && !author) author = t.a;
            return t.t;
        }).join("");
        ++$b8f343bf88dacc48$var$b8oid;
        var oasc = $b8f343bf88dacc48$var$new_buf(0x96);
        oasc.write_shift(2, 0x0F);
        oasc.write_shift(2, 0xF004);
        oasc.write_shift(4, 0x96);
        oasc.write_shift(2, 0xca2); // 0x02 | (0xca << 4)
        oasc.write_shift(2, 0xF00A);
        oasc.write_shift(4, 8);
        oasc.write_shift(4, $b8f343bf88dacc48$var$b8oid);
        oasc.write_shift(4, 0xA00);
        oasc.write_shift(2, 0xE3); // 0x03 | (14 << 4)
        oasc.write_shift(2, 0xF00B);
        oasc.write_shift(4, 0x54); // 14 * 6
        /* 2.3.21.1 ITxid */ oasc.write_shift(2, 0x80);
        oasc.write_shift(4, 0);
        /* 2.3.21.12 txdir */ oasc.write_shift(2, 0x8B);
        oasc.write_shift(4, 0x02);
        /* 2.3.21.15 Text Boolean Properties */ oasc.write_shift(2, 0xBF);
        oasc.write_shift(4, 0x00080008);
        /* 2.3.6.30 cxk */ oasc.write_shift(2, 0x0158);
        oasc.l += 4;
        /* 2.3.7.2 fillColor */ oasc.write_shift(2, 0x0181);
        oasc.write_shift(4, 0x08000050);
        /* 2.3.7.4 fillBackColor */ oasc.write_shift(2, 0x0183);
        oasc.write_shift(4, 0x08000050);
        /* 2.3.7.6 fillCrMod */ oasc.write_shift(2, 0x0185);
        oasc.write_shift(4, 0x100000F4);
        /* 2.3.7.43 Fill Style Boolean Properties */ oasc.write_shift(2, 0x01BF);
        oasc.write_shift(4, 0x00100010);
        /* 2.3.8.1 lineColor */ oasc.write_shift(2, 0x01C0);
        oasc.write_shift(4, 0x08000051);
        /* 2.3.8.4 lineCrMod */ oasc.write_shift(2, 0x01C3);
        oasc.write_shift(4, 0x100000F4);
        /* 2.3.13.2 shadowColor */ oasc.write_shift(2, 0x0201);
        oasc.write_shift(4, 0x08000051);
        /* 2.3.13.4 shadowCrMod */ oasc.write_shift(2, 0x0203);
        oasc.write_shift(4, 0x100000F4);
        /* 2.3.13.23 Shadow Style Boolean Properties */ oasc.write_shift(2, 0x023F);
        oasc.write_shift(4, 0x00030001);
        /* 2.3.4.44 Group Shape Boolean Properties */ oasc.write_shift(2, 0x03BF);
        oasc.write_shift(4, 0x00020000 | (c[0].hidden ? 2 : 0));
        oasc.l += 2;
        oasc.write_shift(2, 0xF010);
        oasc.write_shift(4, 0x12);
        oasc.write_shift(2, 0x3); // do not move or size with cells
        oasc.write_shift(2, c[2] + 2);
        oasc.l += 2;
        oasc.write_shift(2, c[1] + 1);
        oasc.l += 2;
        oasc.write_shift(2, c[2] + 4);
        oasc.l += 2;
        oasc.write_shift(2, c[1] + 5);
        oasc.l += 2;
        oasc.l += 2;
        oasc.write_shift(2, 0xF011);
        oasc.l += 4;
        oasc.l = 0x96;
        if (ci == 0) /* write_biff_rec(pl, 0x003C, oasc); */ _oasc = oasc;
        else $b8f343bf88dacc48$var$write_biff_rec(pl, 0x00EC, oasc);
        sz += 0x96;
        var obj = $b8f343bf88dacc48$var$new_buf(52); // 22 + 26 + 4
        /* [MS-XLS] 2.5.143 FtCmo */ obj.write_shift(2, 0x15);
        obj.write_shift(2, 0x12);
        obj.write_shift(2, 0x19);
        obj.write_shift(2, $b8f343bf88dacc48$var$b8oid);
        obj.write_shift(2, 0);
        obj.l = 22;
        /* [MS-XLS] 2.5.149 FtNts */ obj.write_shift(2, 0x0D);
        obj.write_shift(2, 0x16);
        obj.write_shift(4, 0x62726272);
        obj.write_shift(4, 0x95374305);
        obj.write_shift(4, 0x80301328);
        obj.write_shift(4, 0x69696904 + $b8f343bf88dacc48$var$b8oid * 256);
        obj.write_shift(2, 0);
        obj.write_shift(4, 0);
        // reserved
        obj.l += 4;
        $b8f343bf88dacc48$var$write_biff_rec(pl, 0x005D, obj);
        var oact = $b8f343bf88dacc48$var$new_buf(8);
        oact.l += 2;
        oact.write_shift(2, 0xF00D);
        oact.l += 4;
        $b8f343bf88dacc48$var$write_biff_rec(pl, 0x00EC, oact);
        sz += 8;
        var txo = $b8f343bf88dacc48$var$new_buf(18);
        txo.write_shift(2, 0x12);
        txo.l += 8;
        txo.write_shift(2, text.length);
        txo.write_shift(2, 0x10);
        txo.l += 4;
        $b8f343bf88dacc48$var$write_biff_rec(pl, 0x01b6, txo);
        var cont = $b8f343bf88dacc48$var$new_buf(1 + text.length);
        cont.write_shift(1, 0);
        cont.write_shift(text.length, text, "sbcs");
        $b8f343bf88dacc48$var$write_biff_rec(pl, 0x003C, cont);
        var conf = $b8f343bf88dacc48$var$new_buf(0x10);
        conf.l += 8;
        conf.write_shift(2, text.length);
        conf.l += 6;
        $b8f343bf88dacc48$var$write_biff_rec(pl, 0x003C, conf);
        var notesh = $b8f343bf88dacc48$var$new_buf(12 + author.length);
        notesh.write_shift(2, c[1]);
        notesh.write_shift(2, c[2]);
        notesh.write_shift(2, 0 | (c[0].hidden ? 0 : 2));
        notesh.write_shift(2, $b8f343bf88dacc48$var$b8oid);
        notesh.write_shift(2, author.length);
        notesh.write_shift(1, 0);
        notesh.write_shift(author.length, author, "sbcs");
        notesh.l++;
        notes.push(notesh);
    });
    var hdr = $b8f343bf88dacc48$var$new_buf(80);
    hdr.write_shift(2, 0x0F);
    hdr.write_shift(2, 0xF002);
    hdr.write_shift(4, sz + hdr.length - 8);
    hdr.write_shift(2, 0x10);
    hdr.write_shift(2, 0xF008);
    hdr.write_shift(4, 0x08);
    hdr.write_shift(4, comments.length + 1);
    hdr.write_shift(4, $b8f343bf88dacc48$var$b8oid);
    hdr.write_shift(2, 0x0f);
    hdr.write_shift(2, 0xF003);
    hdr.write_shift(4, sz + 0x30);
    hdr.write_shift(2, 0x0f);
    hdr.write_shift(2, 0xF004);
    hdr.write_shift(4, 0x28);
    hdr.write_shift(2, 0x01);
    hdr.write_shift(2, 0xF009);
    hdr.write_shift(4, 0x10);
    hdr.l += 16;
    hdr.write_shift(2, 0x02);
    hdr.write_shift(2, 0xF00A);
    hdr.write_shift(4, 0x08);
    hdr.write_shift(4, baseid);
    hdr.write_shift(4, 0x05);
    $b8f343bf88dacc48$var$write_biff_rec(ba, 0x00EC, /* hdr */ _oasc ? $b8f343bf88dacc48$var$bconcat([
        hdr,
        _oasc
    ]) : hdr);
    ba.push(pl.end());
    notes.forEach(function(n) {
        $b8f343bf88dacc48$var$write_biff_rec(ba, 0x001C, n);
    });
    $b8f343bf88dacc48$var$b8ocnts.push([
        baseid,
        comments.length + 1,
        $b8f343bf88dacc48$var$b8oid
    ]);
    ++$b8f343bf88dacc48$var$b8oid;
}
function $b8f343bf88dacc48$var$write_FONTS_biff8(ba, data, opts) {
    $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0031 /* Font */ , $b8f343bf88dacc48$var$write_Font({
        sz: 12,
        color: {
            theme: 1
        },
        name: "Arial",
        family: 2,
        scheme: "minor"
    }, opts));
}
function $b8f343bf88dacc48$var$write_FMTS_biff8(ba, NF /*:?SSFTable*/ , opts) {
    if (!NF) return;
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) $b8f343bf88dacc48$var$write_biff_rec(ba, 0x041E /* Format */ , $b8f343bf88dacc48$var$write_Format(i, NF[i], opts));
    });
}
function $b8f343bf88dacc48$var$write_FEAT(ba, ws) {
    /* [MS-XLS] 2.4.112 */ var o = $b8f343bf88dacc48$var$new_buf(19);
    o.write_shift(4, 0x867);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 3);
    o.write_shift(1, 1);
    o.write_shift(4, 0);
    $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0867 /* FeatHdr */ , o);
    /* [MS-XLS] 2.4.111 */ o = $b8f343bf88dacc48$var$new_buf(39);
    o.write_shift(4, 0x868);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 3);
    o.write_shift(1, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 1);
    o.write_shift(4, 4);
    o.write_shift(2, 0);
    $b8f343bf88dacc48$var$write_Ref8U($b8f343bf88dacc48$var$safe_decode_range(ws['!ref'] || "A1"), o);
    o.write_shift(4, 4);
    $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0868 /* Feat */ , o);
}
function $b8f343bf88dacc48$var$write_CELLXFS_biff8(ba, opts) {
    for(var i = 0; i < 16; ++i)$b8f343bf88dacc48$var$write_biff_rec(ba, 0x00e0 /* XF */ , $b8f343bf88dacc48$var$write_XF({
        numFmtId: 0,
        style: true
    }, 0, opts));
    opts.cellXfs.forEach(function(c) {
        $b8f343bf88dacc48$var$write_biff_rec(ba, 0x00e0 /* XF */ , $b8f343bf88dacc48$var$write_XF(c, 0, opts));
    });
}
function $b8f343bf88dacc48$var$write_ws_biff8_hlinks(ba /*:BufArray*/ , ws) {
    for(var R = 0; R < ws['!links'].length; ++R){
        var HL = ws['!links'][R];
        $b8f343bf88dacc48$var$write_biff_rec(ba, 0x01b8 /* HLink */ , $b8f343bf88dacc48$var$write_HLink(HL));
        if (HL[1].Tooltip) $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0800 /* HLinkTooltip */ , $b8f343bf88dacc48$var$write_HLinkTooltip(HL));
    }
    delete ws['!links'];
}
function $b8f343bf88dacc48$var$write_ws_cols_biff8(ba, cols) {
    if (!cols) return;
    var cnt = 0;
    cols.forEach(function(col, idx) {
        if (++cnt <= 256 && col) $b8f343bf88dacc48$var$write_biff_rec(ba, 0x007d /* ColInfo */ , $b8f343bf88dacc48$var$write_ColInfo($b8f343bf88dacc48$var$col_obj_w(idx, col), idx));
    });
}
function $b8f343bf88dacc48$var$write_ws_biff8_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, date1904 /*:boolean*/ ) {
    var os = 16 + $b8f343bf88dacc48$var$get_cell_style(opts.cellXfs, cell, opts);
    if (cell.v == null && !cell.bf) {
        $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0201 /* Blank */ , $b8f343bf88dacc48$var$write_XLSCell(R, C, os));
        return;
    }
    if (cell.bf) $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0006 /* Formula */ , $b8f343bf88dacc48$var$write_Formula(cell, R, C, opts, os));
    else switch(cell.t){
        case 'd':
        case 'n':
            var v = cell.t == 'd' ? $b8f343bf88dacc48$var$datenum($b8f343bf88dacc48$var$parseDate(cell.v, date1904), date1904) : cell.v;
            if (isNaN(v)) $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0205 /* BoolErr */ , $b8f343bf88dacc48$var$write_BoolErr(R, C, 0x24, os, opts, "e")); // #NUM!
            else if (!isFinite(v)) $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0205 /* BoolErr */ , $b8f343bf88dacc48$var$write_BoolErr(R, C, 0x07, os, opts, "e")); // #DIV/0!
            else $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0203 /* Number */ , $b8f343bf88dacc48$var$write_Number(R, C, v, os, opts));
            break;
        case 'b':
        case 'e':
            $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0205 /* BoolErr */ , $b8f343bf88dacc48$var$write_BoolErr(R, C, cell.v, os, opts, cell.t));
            break;
        /* TODO: codepage, sst */ case 's':
        case 'str':
            if (opts.bookSST) {
                var isst = $b8f343bf88dacc48$var$get_sst_id(opts.Strings, cell.v == null ? "" : String(cell.v), opts.revStrings);
                $b8f343bf88dacc48$var$write_biff_rec(ba, 0x00fd /* LabelSst */ , $b8f343bf88dacc48$var$write_LabelSst(R, C, isst, os, opts));
            } else $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0204 /* Label */ , $b8f343bf88dacc48$var$write_Label(R, C, (cell.v == null ? "" : String(cell.v)).slice(0, 255), os, opts));
            break;
        default:
            $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0201 /* Blank */ , $b8f343bf88dacc48$var$write_XLSCell(R, C, os));
    }
}
/* [MS-XLS] 2.1.7.20.5 */ function $b8f343bf88dacc48$var$write_ws_biff8(idx /*:number*/ , opts, wb /*:Workbook*/ ) {
    var ba = $b8f343bf88dacc48$var$buf_array();
    var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
    var _WB /*:WBWBProps*/  = (wb || {}).Workbook || {} /*:any*/ ;
    var _sheet /*:WBWSProp*/  = (_WB.Sheets || [])[idx] || {} /*:any*/ ;
    var dense = ws["!data"] != null;
    var b8 = opts.biff == 8;
    var ref /*:string*/ , rr = "", cols /*:Array<string>*/  = [];
    var range = $b8f343bf88dacc48$var$safe_decode_range(ws['!ref'] || "A1");
    var MAX_ROWS = b8 ? 65536 : 16384;
    if (range.e.c > 0xFF || range.e.r >= MAX_ROWS) {
        if (opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
        range.e.c = Math.min(range.e.c, 0xFF);
        range.e.r = Math.min(range.e.c, MAX_ROWS - 1);
    }
    $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0809, $b8f343bf88dacc48$var$write_BOF(wb, 0x10, opts));
    /* [Uncalced] Index */ $b8f343bf88dacc48$var$write_biff_rec(ba, 0x000d /* CalcMode */ , $b8f343bf88dacc48$var$writeuint16(1));
    $b8f343bf88dacc48$var$write_biff_rec(ba, 0x000c /* CalcCount */ , $b8f343bf88dacc48$var$writeuint16(100));
    $b8f343bf88dacc48$var$write_biff_rec(ba, 0x000f /* CalcRefMode */ , $b8f343bf88dacc48$var$writebool(true));
    $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0011 /* CalcIter */ , $b8f343bf88dacc48$var$writebool(false));
    $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0010 /* CalcDelta */ , $b8f343bf88dacc48$var$write_Xnum(0.001));
    $b8f343bf88dacc48$var$write_biff_rec(ba, 0x005f /* CalcSaveRecalc */ , $b8f343bf88dacc48$var$writebool(true));
    $b8f343bf88dacc48$var$write_biff_rec(ba, 0x002a /* PrintRowCol */ , $b8f343bf88dacc48$var$writebool(false));
    $b8f343bf88dacc48$var$write_biff_rec(ba, 0x002b /* PrintGrid */ , $b8f343bf88dacc48$var$writebool(false));
    $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0082 /* GridSet */ , $b8f343bf88dacc48$var$writeuint16(1));
    $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0080 /* Guts */ , $b8f343bf88dacc48$var$write_Guts([
        0,
        0
    ]));
    /* DefaultRowHeight WsBool [Sync] [LPr] [HorizontalPageBreaks] [VerticalPageBreaks] */ /* Header (string) */ /* Footer (string) */ $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0083 /* HCenter */ , $b8f343bf88dacc48$var$writebool(false));
    $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0084 /* VCenter */ , $b8f343bf88dacc48$var$writebool(false));
    /* ... */ if (b8) $b8f343bf88dacc48$var$write_ws_cols_biff8(ba, ws["!cols"]);
    /* ... */ $b8f343bf88dacc48$var$write_biff_rec(ba, 0x0200 /* Dimensions */ , $b8f343bf88dacc48$var$write_Dimensions(range, opts));
    /* ... */ var date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
    if (b8) ws['!links'] = [];
    for(var C = range.s.c; C <= range.e.c; ++C)cols[C] = $b8f343bf88dacc48$var$encode_col(C);
    var comments = [];
    var row = [];
    for(var R = range.s.r; R <= range.e.r; ++R){
        if (dense) row = ws["!data"][R] || [];
        rr = $b8f343bf88dacc48$var$encode_row(R);
        for(C = range.s.c; C <= range.e.c; ++C){
            ref = cols[C] + rr;
            var cell = dense ? row[C] : ws[ref];
            if (!cell) continue;
            /* write cell */ $b8f343bf88dacc48$var$write_ws_biff8_cell(ba, cell, R, C, opts, date1904);
            if (b8 && cell.l) ws['!links'].push([
                ref,
                cell.l
            ]);
            if (cell.c) comments.push([
                cell.c,
                R,
                C
            ]);
        }
    }
    var cname /*:string*/  = _sheet.CodeName || _sheet.name || s;
    /* ... */ if (b8) $b8f343bf88dacc48$var$write_comments_biff8(ba, comments);
    else $b8f343bf88dacc48$var$write_comments_biff2(ba, comments);
    /* ... */ if (b8) $b8f343bf88dacc48$var$write_biff_rec(ba, 0x023e /* Window2 */ , $b8f343bf88dacc48$var$write_Window2((_WB.Views || [])[0]));
    /* ... */ if (b8 && (ws['!merges'] || []).length) $b8f343bf88dacc48$var$write_biff_rec(ba, 0x00e5 /* MergeCells */ , $b8f343bf88dacc48$var$write_MergeCells(ws['!merges']));
    /* [LRng] *QUERYTABLE [PHONETICINFO] CONDFMTS */ if (b8) $b8f343bf88dacc48$var$write_ws_biff8_hlinks(ba, ws);
    /* [DVAL] */ $b8f343bf88dacc48$var$write_biff_rec(ba, 0x01ba /* CodeName */ , $b8f343bf88dacc48$var$write_XLUnicodeString(cname, opts));
    /* *WebPub *CellWatch [SheetExt] */ if (b8) $b8f343bf88dacc48$var$write_FEAT(ba, ws);
    /* *FEAT11 *RECORD12 */ $b8f343bf88dacc48$var$write_biff_rec(ba, 0x000a /* EOF */ );
    return ba.end();
}
/* [MS-XLS] 2.1.7.20.3 */ function $b8f343bf88dacc48$var$write_biff8_global(wb /*:Workbook*/ , bufs, opts /*:WriteOpts*/ ) {
    var A = $b8f343bf88dacc48$var$buf_array();
    var _WB /*:WBWBProps*/  = (wb || {}).Workbook || {} /*:any*/ ;
    var _sheets /*:Array<WBWSProp>*/  = _WB.Sheets || [];
    var _wb /*:WBProps*/  = /*::((*/ _WB.WBProps || {} /*:: ):any)*/ ;
    var b8 = opts.biff == 8, b5 = opts.biff == 5;
    $b8f343bf88dacc48$var$write_biff_rec(A, 0x0809, $b8f343bf88dacc48$var$write_BOF(wb, 0x05, opts));
    if (opts.bookType == "xla") $b8f343bf88dacc48$var$write_biff_rec(A, 0x0087 /* Addin */ );
    $b8f343bf88dacc48$var$write_biff_rec(A, 0x00e1 /* InterfaceHdr */ , b8 ? $b8f343bf88dacc48$var$writeuint16(0x04b0) : null);
    $b8f343bf88dacc48$var$write_biff_rec(A, 0x00c1 /* Mms */ , $b8f343bf88dacc48$var$writezeroes(2));
    if (b5) $b8f343bf88dacc48$var$write_biff_rec(A, 0x00bf /* ToolbarHdr */ );
    if (b5) $b8f343bf88dacc48$var$write_biff_rec(A, 0x00c0 /* ToolbarEnd */ );
    $b8f343bf88dacc48$var$write_biff_rec(A, 0x00e2 /* InterfaceEnd */ );
    $b8f343bf88dacc48$var$write_biff_rec(A, 0x005c /* WriteAccess */ , $b8f343bf88dacc48$var$write_WriteAccess("SheetJS", opts));
    /* [FileSharing] */ $b8f343bf88dacc48$var$write_biff_rec(A, 0x0042 /* CodePage */ , $b8f343bf88dacc48$var$writeuint16(b8 ? 0x04b0 : 0x04E4));
    /* *2047 Lel */ if (b8) $b8f343bf88dacc48$var$write_biff_rec(A, 0x0161 /* DSF */ , $b8f343bf88dacc48$var$writeuint16(0));
    if (b8) $b8f343bf88dacc48$var$write_biff_rec(A, 0x01c0 /* Excel9File */ );
    $b8f343bf88dacc48$var$write_biff_rec(A, 0x013d /* RRTabId */ , $b8f343bf88dacc48$var$write_RRTabId(wb.SheetNames.length));
    if (b8 && wb.vbaraw) $b8f343bf88dacc48$var$write_biff_rec(A, 0x00d3 /* ObProj */ );
    /* [ObNoMacros] */ if (b8 && wb.vbaraw) {
        var cname /*:string*/  = _wb.CodeName || "ThisWorkbook";
        $b8f343bf88dacc48$var$write_biff_rec(A, 0x01ba /* CodeName */ , $b8f343bf88dacc48$var$write_XLUnicodeString(cname, opts));
    }
    $b8f343bf88dacc48$var$write_biff_rec(A, 0x009c /* BuiltInFnGroupCount */ , $b8f343bf88dacc48$var$writeuint16(0x11));
    /* *FnGroupName *FnGrp12 */ /* *Lbl */ /* [OleObjectSize] */ $b8f343bf88dacc48$var$write_biff_rec(A, 0x0019 /* WinProtect */ , $b8f343bf88dacc48$var$writebool(false));
    $b8f343bf88dacc48$var$write_biff_rec(A, 0x0012 /* Protect */ , $b8f343bf88dacc48$var$writebool(false));
    $b8f343bf88dacc48$var$write_biff_rec(A, 0x0013 /* Password */ , $b8f343bf88dacc48$var$writeuint16(0));
    if (b8) $b8f343bf88dacc48$var$write_biff_rec(A, 0x01af /* Prot4Rev */ , $b8f343bf88dacc48$var$writebool(false));
    if (b8) $b8f343bf88dacc48$var$write_biff_rec(A, 0x01bc /* Prot4RevPass */ , $b8f343bf88dacc48$var$writeuint16(0));
    $b8f343bf88dacc48$var$write_biff_rec(A, 0x003d /* Window1 */ , $b8f343bf88dacc48$var$write_Window1(opts));
    $b8f343bf88dacc48$var$write_biff_rec(A, 0x0040 /* Backup */ , $b8f343bf88dacc48$var$writebool(false));
    $b8f343bf88dacc48$var$write_biff_rec(A, 0x008d /* HideObj */ , $b8f343bf88dacc48$var$writeuint16(0));
    $b8f343bf88dacc48$var$write_biff_rec(A, 0x0022 /* Date1904 */ , $b8f343bf88dacc48$var$writebool($b8f343bf88dacc48$var$safe1904(wb) == "true"));
    $b8f343bf88dacc48$var$write_biff_rec(A, 0x000e /* CalcPrecision */ , $b8f343bf88dacc48$var$writebool(true));
    if (b8) $b8f343bf88dacc48$var$write_biff_rec(A, 0x01b7 /* RefreshAll */ , $b8f343bf88dacc48$var$writebool(false));
    $b8f343bf88dacc48$var$write_biff_rec(A, 0x00DA /* BookBool */ , $b8f343bf88dacc48$var$writeuint16(0));
    /* ... */ $b8f343bf88dacc48$var$write_FONTS_biff8(A, wb, opts);
    $b8f343bf88dacc48$var$write_FMTS_biff8(A, wb.SSF, opts);
    $b8f343bf88dacc48$var$write_CELLXFS_biff8(A, opts);
    /* ... */ if (b8) $b8f343bf88dacc48$var$write_biff_rec(A, 0x0160 /* UsesELFs */ , $b8f343bf88dacc48$var$writebool(false));
    var a = A.end();
    var C = $b8f343bf88dacc48$var$buf_array();
    /* METADATA [MTRSettings] [ForceFullCalculation] */ if (b8) $b8f343bf88dacc48$var$write_biff_rec(C, 0x008C /* Country */ , $b8f343bf88dacc48$var$write_Country());
    /* *SUPBOOK *LBL *RTD [RecalcId] *HFPicture */ /* BIFF8: MsoDrawingGroup [*Continue] */ if (b8 && $b8f343bf88dacc48$var$b8ocnts.length) $b8f343bf88dacc48$var$write_biff_rec(C, 0x00EB /* MsoDrawingGroup */ , $b8f343bf88dacc48$var$write_MsoDrawingGroup());
    /* BIFF8: [SST *Continue] ExtSST */ if (b8 && opts.Strings) $b8f343bf88dacc48$var$write_biff_continue(C, 0x00FC /* SST */ , $b8f343bf88dacc48$var$write_SST(opts.Strings, opts));
    /* *WebPub [WOpt] [CrErr] [BookExt] *FeatHdr *DConn [THEME] [CompressPictures] [Compat12] [GUIDTypeLib] */ $b8f343bf88dacc48$var$write_biff_rec(C, 0x000A /* EOF */ );
    var c = C.end();
    var B = $b8f343bf88dacc48$var$buf_array();
    var blen = 0, j = 0;
    for(j = 0; j < wb.SheetNames.length; ++j)blen += (b8 ? 12 : 11) + (b8 ? 2 : 1) * wb.SheetNames[j].length;
    var start = a.length + blen + c.length;
    for(j = 0; j < wb.SheetNames.length; ++j){
        var _sheet /*:WBWSProp*/  = _sheets[j] || {} /*:any*/ ;
        $b8f343bf88dacc48$var$write_biff_rec(B, 0x0085 /* BoundSheet8 */ , $b8f343bf88dacc48$var$write_BoundSheet8({
            pos: start,
            hs: _sheet.Hidden || 0,
            dt: 0,
            name: wb.SheetNames[j]
        }, opts));
        start += bufs[j].length;
    }
    /* 1*BoundSheet8 */ var b = B.end();
    if (blen != b.length) throw new Error("BS8 " + blen + " != " + b.length);
    var out = [];
    if (a.length) out.push(a);
    if (b.length) out.push(b);
    if (c.length) out.push(c);
    return $b8f343bf88dacc48$var$bconcat(out);
}
/* [MS-XLS] 2.1.7.20 Workbook Stream */ function $b8f343bf88dacc48$var$write_biff8_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    var o = opts || {};
    var bufs = [];
    if (wb && !wb.SSF) wb.SSF = $b8f343bf88dacc48$var$dup($b8f343bf88dacc48$var$table_fmt);
    if (wb && wb.SSF) {
        $b8f343bf88dacc48$var$make_ssf();
        $b8f343bf88dacc48$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        o.revssf = $b8f343bf88dacc48$var$evert_num(wb.SSF);
        o.revssf[wb.SSF[65535]] = 0;
        o.ssf = wb.SSF;
    }
    $b8f343bf88dacc48$var$b8oid = 1;
    $b8f343bf88dacc48$var$b8ocnts = [];
    o.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    o.Strings.Count = 0;
    o.Strings.Unique = 0;
    $b8f343bf88dacc48$var$fix_write_opts(o);
    o.cellXfs = [];
    $b8f343bf88dacc48$var$get_cell_style(o.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    for(var i = 0; i < wb.SheetNames.length; ++i)bufs[bufs.length] = $b8f343bf88dacc48$var$write_ws_biff8(i, o, wb);
    bufs.unshift($b8f343bf88dacc48$var$write_biff8_global(wb, bufs, o));
    return $b8f343bf88dacc48$var$bconcat(bufs);
}
function $b8f343bf88dacc48$var$write_biff_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    for(var i = 0; i <= wb.SheetNames.length; ++i){
        var ws = wb.Sheets[wb.SheetNames[i]];
        if (!ws || !ws["!ref"]) continue;
        var range = $b8f343bf88dacc48$var$decode_range(ws["!ref"]);
        if (range.e.c > 255) {
            if (typeof console != "undefined" && console.error) console.error("Worksheet '" + wb.SheetNames[i] + "' extends beyond column IV (255).  Data may be lost.");
        }
    }
    var o = opts || {};
    switch(o.biff || 2){
        case 8:
        case 5:
            return $b8f343bf88dacc48$var$write_biff8_buf(wb, opts);
        case 4:
        case 3:
        case 2:
            return $b8f343bf88dacc48$var$write_biff2_buf(wb, opts);
    }
    throw new Error("invalid type " + o.bookType + " for BIFF");
}
/* note: browser DOM element cannot see mso- style attrs, must parse */ function $b8f343bf88dacc48$var$html_to_sheet(str /*:string*/ , _opts) /*:Workbook*/ {
    var opts = _opts || {};
    var dense = opts.dense != null ? opts.dense : $b8f343bf88dacc48$var$DENSE;
    var ws /*:Worksheet*/  = {} /*:any*/ ;
    if (dense) ws["!data"] = [];
    str = $b8f343bf88dacc48$var$str_remove_ng(str, "<!--", "-->");
    var mtch /*:any*/  = str.match(/<table/i);
    if (!mtch) throw new Error("Invalid HTML: could not find <table>");
    var mtch2 /*:any*/  = str.match(/<\/table/i);
    var i /*:number*/  = mtch.index, j /*:number*/  = mtch2 && mtch2.index || str.length;
    var rows = $b8f343bf88dacc48$var$split_regex(str.slice(i, j), /(:?<tr[^<>]*>)/i, "<tr>");
    var R = -1, C = 0, RS = 0, CS = 0;
    var range /*:Range*/  = {
        s: {
            r: 10000000,
            c: 10000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var merges /*:Array<Range>*/  = [];
    for(i = 0; i < rows.length; ++i){
        var row = rows[i].trim();
        var hd = row.slice(0, 3).toLowerCase();
        if (hd == "<tr") {
            ++R;
            if (opts.sheetRows && opts.sheetRows <= R) {
                --R;
                break;
            }
            C = 0;
            continue;
        }
        if (hd != "<td" && hd != "<th") continue;
        var cells = row.split(/<\/t[dh]>/i);
        for(j = 0; j < cells.length; ++j){
            var cell = cells[j].trim();
            if (!cell.match(/<t[dh]/i)) continue;
            var m = cell, cc = 0;
            /* TODO: parse styles etc */ while(m.charAt(0) == "<" && (cc = m.indexOf(">")) > -1)m = m.slice(cc + 1);
            for(var midx = 0; midx < merges.length; ++midx){
                var _merge /*:Range*/  = merges[midx];
                if (_merge.s.c == C && _merge.s.r < R && R <= _merge.e.r) {
                    C = _merge.e.c + 1;
                    midx = -1;
                }
            }
            var tag = $b8f343bf88dacc48$var$parsexmltag(cell.slice(0, cell.indexOf(">")));
            CS = tag.colspan ? +tag.colspan : 1;
            if ((RS = +tag.rowspan) > 1 || CS > 1) merges.push({
                s: {
                    r: R,
                    c: C
                },
                e: {
                    r: R + (RS || 1) - 1,
                    c: C + CS - 1
                }
            });
            var _t /*:string*/  = tag.t || tag["data-t"] || "";
            /* TODO: generate stub cells */ if (!m.length) {
                C += CS;
                continue;
            }
            m = $b8f343bf88dacc48$var$htmldecode(m);
            if (range.s.r > R) range.s.r = R;
            if (range.e.r < R) range.e.r = R;
            if (range.s.c > C) range.s.c = C;
            if (range.e.c < C) range.e.c = C;
            if (!m.length) {
                C += CS;
                continue;
            }
            var o /*:Cell*/  = {
                t: 's',
                v: m
            };
            if (opts.raw || !m.trim().length || _t == 's') ;
            else if (m === 'TRUE') o = {
                t: 'b',
                v: true
            };
            else if (m === 'FALSE') o = {
                t: 'b',
                v: false
            };
            else if (!isNaN($b8f343bf88dacc48$var$fuzzynum(m))) o = {
                t: 'n',
                v: $b8f343bf88dacc48$var$fuzzynum(m)
            };
            else if (!isNaN($b8f343bf88dacc48$var$fuzzydate(m).getDate())) {
                o = {
                    t: 'd',
                    v: $b8f343bf88dacc48$var$parseDate(m)
                } /*:any*/ ;
                if (opts.UTC === false) o.v = $b8f343bf88dacc48$var$utc_to_local(o.v);
                if (!opts.cellDates) o = {
                    t: 'n',
                    v: $b8f343bf88dacc48$var$datenum(o.v)
                } /*:any*/ ;
                o.z = opts.dateNF || $b8f343bf88dacc48$var$table_fmt[14];
            }
            if (o.cellText !== false) o.w = m;
            if (dense) {
                if (!ws["!data"][R]) ws["!data"][R] = [];
                ws["!data"][R][C] = o;
            } else ws[$b8f343bf88dacc48$var$encode_cell({
                r: R,
                c: C
            })] = o;
            C += CS;
        }
    }
    ws['!ref'] = $b8f343bf88dacc48$var$encode_range(range);
    if (merges.length) ws["!merges"] = merges;
    return ws;
}
function $b8f343bf88dacc48$var$make_html_row(ws /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , o /*:Sheet2HTMLOpts*/ ) /*:string*/ {
    var M /*:Array<Range>*/  = ws['!merges'] || [];
    var oo /*:Array<string>*/  = [];
    var sp = {} /*:any*/ ;
    var dense = ws["!data"] != null;
    for(var C = r.s.c; C <= r.e.c; ++C){
        var RS = 0, CS = 0;
        for(var j = 0; j < M.length; ++j){
            if (M[j].s.r > R || M[j].s.c > C) continue;
            if (M[j].e.r < R || M[j].e.c < C) continue;
            if (M[j].s.r < R || M[j].s.c < C) {
                RS = -1;
                break;
            }
            RS = M[j].e.r - M[j].s.r + 1;
            CS = M[j].e.c - M[j].s.c + 1;
            break;
        }
        if (RS < 0) continue;
        var coord = $b8f343bf88dacc48$var$encode_col(C) + $b8f343bf88dacc48$var$encode_row(R);
        var cell = dense ? (ws["!data"][R] || [])[C] : ws[coord];
        /* TODO: html entities */ var w = cell && cell.v != null && (cell.h || $b8f343bf88dacc48$var$escapehtml(cell.w || ($b8f343bf88dacc48$var$format_cell(cell), cell.w) || "")) || "";
        sp = {} /*:any*/ ;
        if (RS > 1) sp.rowspan = RS;
        if (CS > 1) sp.colspan = CS;
        if (o.editable) w = '<span contenteditable="true">' + w + '</span>';
        else if (cell) {
            sp["data-t"] = cell && cell.t || 'z';
            // note: data-v is unaffected by the timezone interpretation
            if (cell.v != null) sp["data-v"] = $b8f343bf88dacc48$var$escapehtml(cell.v instanceof Date ? cell.v.toISOString() : cell.v);
            if (cell.z != null) sp["data-z"] = cell.z;
            if (cell.l && (cell.l.Target || "#").charAt(0) != "#") w = '<a href="' + $b8f343bf88dacc48$var$escapehtml(cell.l.Target) + '">' + w + '</a>';
        }
        sp.id = (o.id || "sjs") + "-" + coord;
        oo.push($b8f343bf88dacc48$var$writextag('td', w, sp));
    }
    var preamble = "<tr>";
    return preamble + oo.join("") + "</tr>";
}
var $b8f343bf88dacc48$var$HTML_BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
var $b8f343bf88dacc48$var$HTML_END = '</body></html>';
function $b8f343bf88dacc48$var$html_to_workbook(str /*:string*/ , opts) /*:Workbook*/ {
    var mtch = $b8f343bf88dacc48$var$str_match_xml_ig(str, "table");
    if (!mtch || mtch.length == 0) throw new Error("Invalid HTML: could not find <table>");
    if (mtch.length == 1) {
        var w = $b8f343bf88dacc48$var$sheet_to_workbook($b8f343bf88dacc48$var$html_to_sheet(mtch[0], opts), opts);
        w.bookType = "html";
        return w;
    }
    var wb = $b8f343bf88dacc48$var$book_new();
    mtch.forEach(function(s, idx) {
        $b8f343bf88dacc48$var$book_append_sheet(wb, $b8f343bf88dacc48$var$html_to_sheet(s, opts), "Sheet" + (idx + 1));
    });
    wb.bookType = "html";
    return wb;
}
function $b8f343bf88dacc48$var$make_html_preamble(ws /*:Worksheet*/ , R /*:Range*/ , o /*:Sheet2HTMLOpts*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [];
    return out.join("") + '<table' + (o && o.id ? ' id="' + o.id + '"' : "") + '>';
}
function $b8f343bf88dacc48$var$sheet_to_html(ws /*:Worksheet*/ , opts /*:?Sheet2HTMLOpts*/  /*, wb:?Workbook*/ ) /*:string*/ {
    var o = opts || {};
    var header = o.header != null ? o.header : $b8f343bf88dacc48$var$HTML_BEGIN;
    var footer = o.footer != null ? o.footer : $b8f343bf88dacc48$var$HTML_END;
    var out /*:Array<string>*/  = [
        header
    ];
    var r = $b8f343bf88dacc48$var$decode_range(ws['!ref'] || "A1");
    out.push($b8f343bf88dacc48$var$make_html_preamble(ws, r, o));
    if (ws["!ref"]) for(var R = r.s.r; R <= r.e.r; ++R)out.push($b8f343bf88dacc48$var$make_html_row(ws, r, R, o));
    out.push("</table>" + footer);
    return out.join("");
}
function $b8f343bf88dacc48$var$sheet_add_dom(ws /*:Worksheet*/ , table /*:HTMLElement*/ , _opts /*:?any*/ ) /*:Worksheet*/ {
    var rows /*:HTMLCollection<HTMLTableRowElement>*/  = table.rows;
    if (!rows) /* not an HTML TABLE */ throw "Unsupported origin when " + table.tagName + " is not a TABLE";
    var opts = _opts || {};
    var dense = ws["!data"] != null;
    var or_R = 0, or_C = 0;
    if (opts.origin != null) {
        if (typeof opts.origin == 'number') or_R = opts.origin;
        else {
            var _origin /*:CellAddress*/  = typeof opts.origin == "string" ? $b8f343bf88dacc48$var$decode_cell(opts.origin) : opts.origin;
            or_R = _origin.r;
            or_C = _origin.c;
        }
    }
    var sheetRows = Math.min(opts.sheetRows || 10000000, rows.length);
    var range /*:Range*/  = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: or_R,
            c: or_C
        }
    };
    if (ws["!ref"]) {
        var _range /*:Range*/  = $b8f343bf88dacc48$var$decode_range(ws["!ref"]);
        range.s.r = Math.min(range.s.r, _range.s.r);
        range.s.c = Math.min(range.s.c, _range.s.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        range.e.c = Math.max(range.e.c, _range.e.c);
        if (or_R == -1) range.e.r = or_R = _range.e.r + 1;
    }
    var merges /*:Array<Range>*/  = [], midx = 0;
    var rowinfo /*:Array<RowInfo>*/  = ws["!rows"] || (ws["!rows"] = []);
    var _R = 0, R = 0, _C = 0, C = 0, RS = 0, CS = 0;
    if (!ws["!cols"]) ws['!cols'] = [];
    for(; _R < rows.length && R < sheetRows; ++_R){
        var row /*:HTMLTableRowElement*/  = rows[_R];
        if ($b8f343bf88dacc48$var$is_dom_element_hidden(row)) {
            if (opts.display) continue;
            rowinfo[R] = {
                hidden: true
            };
        }
        var elts /*:HTMLCollection<HTMLTableCellElement>*/  = row.cells;
        for(_C = C = 0; _C < elts.length; ++_C){
            var elt /*:HTMLTableCellElement*/  = elts[_C];
            if (opts.display && $b8f343bf88dacc48$var$is_dom_element_hidden(elt)) continue;
            var v /*:?string*/  = elt.hasAttribute('data-v') ? elt.getAttribute('data-v') : elt.hasAttribute('v') ? elt.getAttribute('v') : $b8f343bf88dacc48$var$htmldecode(elt.innerHTML);
            var z /*:?string*/  = elt.getAttribute('data-z') || elt.getAttribute('z');
            for(midx = 0; midx < merges.length; ++midx){
                var m /*:Range*/  = merges[midx];
                if (m.s.c == C + or_C && m.s.r < R + or_R && R + or_R <= m.e.r) {
                    C = m.e.c + 1 - or_C;
                    midx = -1;
                }
            }
            /* TODO: figure out how to extract nonstandard mso- style */ CS = +elt.getAttribute("colspan") || 1;
            if ((RS = +elt.getAttribute("rowspan") || 1) > 1 || CS > 1) merges.push({
                s: {
                    r: R + or_R,
                    c: C + or_C
                },
                e: {
                    r: R + or_R + (RS || 1) - 1,
                    c: C + or_C + (CS || 1) - 1
                }
            });
            var o /*:Cell*/  = {
                t: 's',
                v: v
            };
            var _t /*:string*/  = elt.getAttribute("data-t") || elt.getAttribute("t") || "";
            if (v != null) {
                if (v.length == 0) o.t = _t || 'z';
                else if (opts.raw || v.trim().length == 0 || _t == "s") ;
                else if (v === 'TRUE') o = {
                    t: 'b',
                    v: true
                };
                else if (v === 'FALSE') o = {
                    t: 'b',
                    v: false
                };
                else if (!isNaN($b8f343bf88dacc48$var$fuzzynum(v))) o = {
                    t: 'n',
                    v: $b8f343bf88dacc48$var$fuzzynum(v)
                };
                else if (!isNaN($b8f343bf88dacc48$var$fuzzydate(v).getDate())) {
                    o = {
                        t: 'd',
                        v: $b8f343bf88dacc48$var$parseDate(v)
                    } /*:any*/ ;
                    if (opts.UTC) o.v = $b8f343bf88dacc48$var$local_to_utc(o.v);
                    if (!opts.cellDates) o = {
                        t: 'n',
                        v: $b8f343bf88dacc48$var$datenum(o.v)
                    } /*:any*/ ;
                    o.z = opts.dateNF || $b8f343bf88dacc48$var$table_fmt[14];
                }
            }
            if (o.z === undefined && z != null) o.z = z;
            /* The first link is used.  Links are assumed to be fully specified.
			 * TODO: The right way to process relative links is to make a new <a> */ var l = "", Aelts = elt.getElementsByTagName("A");
            if (Aelts && Aelts.length) {
                for(var Aelti = 0; Aelti < Aelts.length; ++Aelti)if (Aelts[Aelti].hasAttribute("href")) {
                    l = Aelts[Aelti].getAttribute("href");
                    if (l.charAt(0) != "#") break;
                }
            }
            if (l && l.charAt(0) != "#" && l.slice(0, 11).toLowerCase() != 'javascript:') o.l = {
                Target: l
            };
            if (dense) {
                if (!ws["!data"][R + or_R]) ws["!data"][R + or_R] = [];
                ws["!data"][R + or_R][C + or_C] = o;
            } else ws[$b8f343bf88dacc48$var$encode_cell({
                c: C + or_C,
                r: R + or_R
            })] = o;
            if (range.e.c < C + or_C) range.e.c = C + or_C;
            C += CS;
        }
        ++R;
    }
    if (merges.length) ws['!merges'] = (ws["!merges"] || []).concat(merges);
    range.e.r = Math.max(range.e.r, R - 1 + or_R);
    ws['!ref'] = $b8f343bf88dacc48$var$encode_range(range);
    if (R >= sheetRows) ws['!fullref'] = $b8f343bf88dacc48$var$encode_range((range.e.r = rows.length - _R + R - 1 + or_R, range)); // We can count the real number of rows to parse but we don't to improve the performance
    return ws;
}
function $b8f343bf88dacc48$var$parse_dom_table(table /*:HTMLElement*/ , _opts /*:?any*/ ) /*:Worksheet*/ {
    var opts = _opts || {};
    var ws /*:Worksheet*/  = {} /*:any*/ ;
    if (opts.dense) ws["!data"] = [];
    return $b8f343bf88dacc48$var$sheet_add_dom(ws, table, _opts);
}
function $b8f343bf88dacc48$var$table_to_book(table /*:HTMLElement*/ , opts /*:?any*/ ) /*:Workbook*/ {
    var o = $b8f343bf88dacc48$var$sheet_to_workbook($b8f343bf88dacc48$var$parse_dom_table(table, opts), opts);
    //o.bookType = "dom"; // TODO: define a type for this
    return o;
}
function $b8f343bf88dacc48$var$is_dom_element_hidden(element /*:HTMLElement*/ ) /*:boolean*/ {
    var display /*:string*/  = '';
    var get_computed_style /*:?function*/  = $b8f343bf88dacc48$var$get_get_computed_style_function(element);
    if (get_computed_style) display = get_computed_style(element).getPropertyValue('display');
    if (!display) display = element.style && element.style.display;
    return display === 'none';
}
/* global getComputedStyle */ function $b8f343bf88dacc48$var$get_get_computed_style_function(element /*:HTMLElement*/ ) /*:?function*/ {
    // The proper getComputedStyle implementation is the one defined in the element window
    if (element.ownerDocument.defaultView && typeof element.ownerDocument.defaultView.getComputedStyle === 'function') return element.ownerDocument.defaultView.getComputedStyle;
    // If it is not available, try to get one from the global namespace
    if (typeof getComputedStyle === 'function') return getComputedStyle;
    return null;
}
/* OpenDocument */ function $b8f343bf88dacc48$var$parse_text_p(text /*:string*/  /*::, tag*/ ) /*:Array<any>*/ {
    /* 6.1.2 White Space Characters */ var fixed = text.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ").replace(/<text:s\/>/g, " ").replace(/<text:s text:c="(\d+)"\/>/g, function($$, $1) {
        return Array(parseInt($1, 10) + 1).join(" ");
    }).replace(/<text:tab[^<>]*\/>/g, "\t").replace(/<text:line-break\/>/g, "\n");
    var v = $b8f343bf88dacc48$var$unescapexml(fixed.replace(/<[^<>]*>/g, ""));
    return [
        v
    ];
}
/* Note: ODS can stick styles in content.xml or styles.xml, FODS blurs lines */ function $b8f343bf88dacc48$var$parse_ods_styles(d /*:string*/ , _opts, _nfm) {
    var number_format_map = _nfm || {};
    var str = $b8f343bf88dacc48$var$xlml_normalize(d);
    $b8f343bf88dacc48$var$xlmlregex.lastIndex = 0;
    str = $b8f343bf88dacc48$var$remove_doctype($b8f343bf88dacc48$var$str_remove_ng(str, "<!--", "-->"));
    var Rn, NFtag, NF = "", tNF = "", y, etpos = 0, tidx = -1, infmt = false, payload = "";
    while(Rn = $b8f343bf88dacc48$var$xlmlregex.exec(str))switch(Rn[3] = Rn[3].replace(/_[\s\S]*$/, "")){
        /* Number Format Definitions */ case 'number-style':
        case 'currency-style':
        case 'percentage-style':
        case 'date-style':
        case 'time-style':
        case 'text-style':
            if (Rn[1] === '/') {
                infmt = false;
                if (NFtag['truncate-on-overflow'] == "false") {
                    if (NF.match(/h/)) NF = NF.replace(/h+/, "[$&]");
                    else if (NF.match(/m/)) NF = NF.replace(/m+/, "[$&]");
                    else if (NF.match(/s/)) NF = NF.replace(/s+/, "[$&]");
                }
                number_format_map[NFtag.name] = NF;
                NF = "";
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                infmt = true;
                NF = "";
                NFtag = $b8f343bf88dacc48$var$parsexmltag(Rn[0], false);
            }
            break;
        // LibreOffice bug https://bugs.documentfoundation.org/show_bug.cgi?id=149484
        case 'boolean-style':
            if (Rn[1] === '/') {
                infmt = false;
                number_format_map[NFtag.name] = "General";
                NF = "";
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                infmt = true;
                NF = "";
                NFtag = $b8f343bf88dacc48$var$parsexmltag(Rn[0], false);
            }
            break;
        /* Number Format Elements */ case 'boolean':
            NF += "General"; // ODF spec is unfortunately underspecified here
            break;
        case 'text':
            if (Rn[1] === '/') {
                payload = str.slice(tidx, $b8f343bf88dacc48$var$xlmlregex.lastIndex - Rn[0].length);
                // NOTE: Excel has a different interpretation of "%%" and friends
                if (payload == "%" && NFtag[0] == '<number:percentage-style') NF += "%";
                else NF += '"' + payload.replace(/"/g, '""') + '"';
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') tidx = $b8f343bf88dacc48$var$xlmlregex.lastIndex;
            break;
        case 'day':
            y = $b8f343bf88dacc48$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "d";
                    break;
                case "long":
                    NF += "dd";
                    break;
                default:
                    NF += "dd";
                    break; // TODO: error condition
            }
            break;
        case 'day-of-week':
            y = $b8f343bf88dacc48$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "ddd";
                    break;
                case "long":
                    NF += "dddd";
                    break;
                default:
                    NF += "ddd";
                    break;
            }
            break;
        case 'era':
            y = $b8f343bf88dacc48$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "ee";
                    break;
                case "long":
                    NF += "eeee";
                    break;
                default:
                    NF += "eeee";
                    break; // TODO: error condition
            }
            break;
        case 'hours':
            y = $b8f343bf88dacc48$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "h";
                    break;
                case "long":
                    NF += "hh";
                    break;
                default:
                    NF += "hh";
                    break; // TODO: error condition
            }
            break;
        case 'minutes':
            y = $b8f343bf88dacc48$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "m";
                    break;
                case "long":
                    NF += "mm";
                    break;
                default:
                    NF += "mm";
                    break; // TODO: error condition
            }
            break;
        case 'month':
            y = $b8f343bf88dacc48$var$parsexmltag(Rn[0], false);
            if (y["textual"]) NF += "mm";
            switch(y["style"]){
                case "short":
                    NF += "m";
                    break;
                case "long":
                    NF += "mm";
                    break;
                default:
                    NF += "m";
                    break;
            }
            break;
        case 'seconds':
            y = $b8f343bf88dacc48$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "s";
                    break;
                case "long":
                    NF += "ss";
                    break;
                default:
                    NF += "ss";
                    break; // TODO: error condition
            }
            if (y["decimal-places"]) NF += "." + $b8f343bf88dacc48$var$fill("0", +y["decimal-places"]);
            break;
        case 'year':
            y = $b8f343bf88dacc48$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "yy";
                    break;
                case "long":
                    NF += "yyyy";
                    break;
                default:
                    NF += "yy";
                    break; // TODO: error condition
            }
            break;
        case 'am-pm':
            NF += "AM/PM"; // LO autocorrects A/P -> AM/PM
            break;
        case 'week-of-year':
        case 'quarter':
            console.error("Excel does not support ODS format token " + Rn[3]);
            break;
        case 'fill-character':
            if (Rn[1] === '/') {
                payload = str.slice(tidx, $b8f343bf88dacc48$var$xlmlregex.lastIndex - Rn[0].length);
                // NOTE: Excel has a different interpretation of "%%" and friends
                NF += '"' + payload.replace(/"/g, '""') + '"*';
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') tidx = $b8f343bf88dacc48$var$xlmlregex.lastIndex;
            break;
        case 'scientific-number':
            // TODO: find a mapping for all parameters
            y = $b8f343bf88dacc48$var$parsexmltag(Rn[0], false);
            NF += "0." + $b8f343bf88dacc48$var$fill("0", +y["min-decimal-places"] || +y["decimal-places"] || 2) + $b8f343bf88dacc48$var$fill("?", +y["decimal-places"] - +y["min-decimal-places"] || 0) + "E" + ($b8f343bf88dacc48$var$parsexmlbool(y["forced-exponent-sign"]) ? "+" : "") + $b8f343bf88dacc48$var$fill("0", +y["min-exponent-digits"] || 2);
            break;
        case 'fraction':
            // TODO: find a mapping for all parameters
            y = $b8f343bf88dacc48$var$parsexmltag(Rn[0], false);
            if (!+y["min-integer-digits"]) NF += "#";
            else NF += $b8f343bf88dacc48$var$fill("0", +y["min-integer-digits"]);
            NF += " ";
            NF += $b8f343bf88dacc48$var$fill("?", +y["min-numerator-digits"] || 1);
            NF += "/";
            if (+y["denominator-value"]) NF += y["denominator-value"];
            else NF += $b8f343bf88dacc48$var$fill("?", +y["min-denominator-digits"] || 1);
            break;
        case 'currency-symbol':
            // TODO: localization with [$-...]
            if (Rn[1] === '/') NF += '"' + str.slice(tidx, $b8f343bf88dacc48$var$xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"';
            else if (Rn[0].charAt(Rn[0].length - 2) !== '/') tidx = $b8f343bf88dacc48$var$xlmlregex.lastIndex;
            else NF += "$";
            break;
        case 'text-properties':
            y = $b8f343bf88dacc48$var$parsexmltag(Rn[0], false);
            switch((y["color"] || "").toLowerCase().replace("#", "")){
                case "ff0000":
                case "red":
                    NF = "[Red]" + NF;
                    break;
            }
            break;
        case 'text-content':
            NF += "@";
            break;
        case 'map':
            // TODO: handle more complex maps
            y = $b8f343bf88dacc48$var$parsexmltag(Rn[0], false);
            if ($b8f343bf88dacc48$var$unescapexml(y["condition"]) == "value()>=0") NF = number_format_map[y["apply-style-name"]] + ";" + NF;
            else console.error("ODS number format may be incorrect: " + y["condition"]);
            break;
        case 'number':
            // TODO: handle all the attributes
            if (Rn[1] === '/') break;
            y = $b8f343bf88dacc48$var$parsexmltag(Rn[0], false);
            tNF = "";
            tNF += $b8f343bf88dacc48$var$fill("0", +y["min-integer-digits"] || 1);
            if ($b8f343bf88dacc48$var$parsexmlbool(y["grouping"])) tNF = $b8f343bf88dacc48$var$commaify($b8f343bf88dacc48$var$fill("#", Math.max(0, 4 - tNF.length)) + tNF);
            if (+y["min-decimal-places"] || +y["decimal-places"]) tNF += ".";
            if (+y["min-decimal-places"]) tNF += $b8f343bf88dacc48$var$fill("0", +y["min-decimal-places"] || 1);
            if (+y["decimal-places"] - (+y["min-decimal-places"] || 0)) tNF += $b8f343bf88dacc48$var$fill("0", +y["decimal-places"] - (+y["min-decimal-places"] || 0)); // TODO: should this be "#" ?
            NF += tNF;
            break;
        case 'embedded-text':
            // TODO: verify interplay with grouping et al
            if (Rn[1] === '/') {
                if (etpos == 0) NF += '"' + str.slice(tidx, $b8f343bf88dacc48$var$xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"';
                else NF = NF.slice(0, etpos) + '"' + str.slice(tidx, $b8f343bf88dacc48$var$xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"' + NF.slice(etpos);
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                tidx = $b8f343bf88dacc48$var$xlmlregex.lastIndex;
                etpos = -+$b8f343bf88dacc48$var$parsexmltag(Rn[0], false)["position"] || 0;
            }
            break;
    }
    return number_format_map;
}
function $b8f343bf88dacc48$var$parse_content_xml(d /*:string*/ , _opts, _nfm) /*:Workbook*/ {
    var opts = _opts || {};
    if ($b8f343bf88dacc48$var$DENSE != null && opts.dense == null) opts.dense = $b8f343bf88dacc48$var$DENSE;
    var str = $b8f343bf88dacc48$var$xlml_normalize(d);
    var state /*:Array<any>*/  = [], tmp;
    var tag /*:: = {}*/ ;
    var nfidx, NF = "", pidx = 0;
    var sheetag /*:: = {name:"", '名称':""}*/ ;
    var rowtag /*:: = {'行号':""}*/ ;
    var Sheets = {}, SheetNames /*:Array<string>*/  = [];
    var ws = {} /*:any*/ ;
    if (opts.dense) ws["!data"] = [];
    var Rn, q /*:: :any = ({t:"", v:null, z:null, w:"",c:[],}:any)*/ ;
    var ctag = {
        value: ""
    } /*:any*/ ;
    var textp = "", textpidx = 0, textptag /*:: = {}*/ , oldtextp = "", oldtextpidx = 0;
    var textR = [], oldtextR = [];
    var R = -1, C = -1, range = {
        s: {
            r: 1000000,
            c: 10000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var row_ol = 0;
    var number_format_map = _nfm || {}, styles = {};
    var merges /*:Array<Range>*/  = [], mrange = {}, mR = 0, mC = 0;
    var rowinfo /*:Array<RowInfo>*/  = [], rowpeat = 1, colpeat = 1;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var WB = {
        Names: [],
        WBProps: {}
    };
    var atag = {} /*:any*/ ;
    var _Ref /*:[string, string]*/  = [
        "",
        ""
    ];
    var comments /*:Array<Comment>*/  = [], comment /*:Comment*/  = {} /*:any*/ ;
    var creator = "", creatoridx = 0;
    var isstub = false, intable = false;
    var i = 0;
    $b8f343bf88dacc48$var$xlmlregex.lastIndex = 0;
    str = $b8f343bf88dacc48$var$remove_doctype($b8f343bf88dacc48$var$str_remove_ng(str, "<!--", "-->"));
    while(Rn = $b8f343bf88dacc48$var$xlmlregex.exec(str))switch(Rn[3] = Rn[3].replace(/_[\s\S]*$/, "")){
        case 'table':
        case "\u5DE5\u4F5C\u8868":
            if (Rn[1] === '/') {
                if (range.e.c >= range.s.c && range.e.r >= range.s.r) ws['!ref'] = $b8f343bf88dacc48$var$encode_range(range);
                else ws['!ref'] = "A1:A1";
                if (opts.sheetRows > 0 && opts.sheetRows <= range.e.r) {
                    ws['!fullref'] = ws['!ref'];
                    range.e.r = opts.sheetRows - 1;
                    ws['!ref'] = $b8f343bf88dacc48$var$encode_range(range);
                }
                if (merges.length) ws['!merges'] = merges;
                if (rowinfo.length) ws["!rows"] = rowinfo;
                sheetag.name = sheetag["\u540D\u79F0"] || sheetag.name;
                if (typeof JSON !== 'undefined') JSON.stringify(sheetag);
                SheetNames.push(sheetag.name);
                Sheets[sheetag.name] = ws;
                intable = false;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                sheetag = $b8f343bf88dacc48$var$parsexmltag(Rn[0], false);
                R = C = -1;
                range.s.r = range.s.c = 10000000;
                range.e.r = range.e.c = 0;
                ws = {} /*:any*/ ;
                if (opts.dense) ws["!data"] = [];
                merges = [];
                rowinfo = [];
                intable = true;
            }
            break;
        case 'table-row-group':
            if (Rn[1] === "/") --row_ol;
            else ++row_ol;
            break;
        case 'table-row':
        case "\u884C":
            if (Rn[1] === '/') {
                R += rowpeat;
                rowpeat = 1;
                break;
            }
            rowtag = $b8f343bf88dacc48$var$parsexmltag(Rn[0], false);
            if (rowtag["\u884C\u53F7"]) R = rowtag["\u884C\u53F7"] - 1;
            else if (R == -1) R = 0;
            rowpeat = +rowtag['number-rows-repeated'] || 1;
            /* TODO: remove magic */ if (rowpeat < 10) {
                for(i = 0; i < rowpeat; ++i)if (row_ol > 0) rowinfo[R + i] = {
                    level: row_ol
                };
            }
            C = -1;
            break;
        case 'covered-table-cell':
            if (Rn[1] !== '/') ++C;
            if (opts.sheetStubs) {
                if (opts.dense) {
                    if (!ws["!data"][R]) ws["!data"][R] = [];
                    ws["!data"][R][C] = {
                        t: 'z'
                    };
                } else ws[$b8f343bf88dacc48$var$encode_cell({
                    r: R,
                    c: C
                })] = {
                    t: 'z'
                };
            }
            textp = "";
            textR = [];
            break; /* stub */ 
        case 'table-cell':
        case "\u6570\u636E":
            if (Rn[0].charAt(Rn[0].length - 2) === '/') {
                ++C;
                ctag = $b8f343bf88dacc48$var$parsexmltag(Rn[0], false);
                colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10);
                q = {
                    t: 'z',
                    v: null
                } /*:any*/ ;
                if (ctag.formula && opts.cellFormula != false) q.f = $b8f343bf88dacc48$var$ods_to_csf_formula($b8f343bf88dacc48$var$unescapexml(ctag.formula));
                if (ctag["style-name"] && styles[ctag["style-name"]]) q.z = styles[ctag["style-name"]];
                if ((ctag["\u6570\u636E\u7C7B\u578B"] || ctag['value-type']) == "string") {
                    q.t = "s";
                    q.v = $b8f343bf88dacc48$var$unescapexml(ctag['string-value'] || "");
                    if (opts.dense) {
                        if (!ws["!data"][R]) ws["!data"][R] = [];
                        ws["!data"][R][C] = q;
                    } else ws[$b8f343bf88dacc48$var$encode_col(C) + $b8f343bf88dacc48$var$encode_row(R)] = q;
                }
                C += colpeat - 1;
            } else if (Rn[1] !== '/') {
                ++C;
                textp = oldtextp = "";
                textpidx = oldtextpidx = 0;
                textR = [];
                oldtextR = [];
                colpeat = 1;
                var rptR = rowpeat ? R + rowpeat - 1 : R;
                if (C > range.e.c) range.e.c = C;
                if (C < range.s.c) range.s.c = C;
                if (R < range.s.r) range.s.r = R;
                if (rptR > range.e.r) range.e.r = rptR;
                ctag = $b8f343bf88dacc48$var$parsexmltag(Rn[0], false);
                comments = [];
                comment = {} /*:any*/ ;
                q = {
                    t: ctag["\u6570\u636E\u7C7B\u578B"] || ctag['value-type'],
                    v: null
                } /*:any*/ ;
                if (ctag["style-name"] && styles[ctag["style-name"]]) q.z = styles[ctag["style-name"]];
                if (opts.cellFormula) {
                    if (ctag.formula) ctag.formula = $b8f343bf88dacc48$var$unescapexml(ctag.formula);
                    if (ctag['number-matrix-columns-spanned'] && ctag['number-matrix-rows-spanned']) {
                        mR = parseInt(ctag['number-matrix-rows-spanned'], 10) || 0;
                        mC = parseInt(ctag['number-matrix-columns-spanned'], 10) || 0;
                        mrange = {
                            s: {
                                r: R,
                                c: C
                            },
                            e: {
                                r: R + mR - 1,
                                c: C + mC - 1
                            }
                        };
                        q.F = $b8f343bf88dacc48$var$encode_range(mrange);
                        arrayf.push([
                            mrange,
                            q.F
                        ]);
                    }
                    if (ctag.formula) q.f = $b8f343bf88dacc48$var$ods_to_csf_formula(ctag.formula);
                    else for(i = 0; i < arrayf.length; ++i)if (R >= arrayf[i][0].s.r && R <= arrayf[i][0].e.r) {
                        if (C >= arrayf[i][0].s.c && C <= arrayf[i][0].e.c) q.F = arrayf[i][1];
                    }
                }
                if (ctag['number-columns-spanned'] || ctag['number-rows-spanned']) {
                    mR = parseInt(ctag['number-rows-spanned'], 10) || 0;
                    mC = parseInt(ctag['number-columns-spanned'], 10) || 0;
                    mrange = {
                        s: {
                            r: R,
                            c: C
                        },
                        e: {
                            r: R + mR - 1,
                            c: C + mC - 1
                        }
                    };
                    merges.push(mrange);
                }
                /* 19.675.2 table:number-columns-repeated */ if (ctag['number-columns-repeated']) colpeat = parseInt(ctag['number-columns-repeated'], 10);
                /* 19.385 office:value-type TODO: verify ODS and UOS */ switch(q.t){
                    case 'boolean':
                        q.t = 'b';
                        q.v = $b8f343bf88dacc48$var$parsexmlbool(ctag['boolean-value']) || +ctag['boolean-value'] >= 1;
                        break;
                    case 'float':
                        q.t = 'n';
                        q.v = parseFloat(ctag.value);
                        if (opts.cellDates && q.z && $b8f343bf88dacc48$var$fmt_is_date(q.z)) {
                            q.v = $b8f343bf88dacc48$var$numdate(q.v + (WB.WBProps.date1904 ? 1462 : 0));
                            q.t = typeof q.v == "number" ? 'n' : 'd';
                        }
                        break;
                    case 'percentage':
                        q.t = 'n';
                        q.v = parseFloat(ctag.value);
                        break;
                    case 'currency':
                        q.t = 'n';
                        q.v = parseFloat(ctag.value);
                        break;
                    case 'date':
                        q.t = 'd';
                        q.v = $b8f343bf88dacc48$var$parseDate(ctag['date-value'], WB.WBProps.date1904);
                        if (!opts.cellDates) {
                            q.t = 'n';
                            q.v = $b8f343bf88dacc48$var$datenum(q.v, WB.WBProps.date1904);
                        }
                        if (!q.z) q.z = 'm/d/yy';
                        break;
                    /* NOTE: for `time`, Excel ODS export incorrectly uses durations relative to 1900 epoch even if 1904 is specified */ case 'time':
                        q.t = 'n';
                        q.v = $b8f343bf88dacc48$var$parse_isodur(ctag['time-value']) / 86400;
                        if (opts.cellDates) {
                            q.v = $b8f343bf88dacc48$var$numdate(q.v);
                            q.t = typeof q.v == "number" ? 'n' : 'd';
                        }
                        if (!q.z) q.z = 'HH:MM:SS';
                        break;
                    case 'number':
                        q.t = 'n';
                        q.v = parseFloat(ctag["\u6570\u636E\u6570\u503C"]);
                        break;
                    default:
                        if (q.t === 'string' || q.t === 'text' || !q.t) {
                            q.t = 's';
                            if (ctag['string-value'] != null) {
                                textp = $b8f343bf88dacc48$var$unescapexml(ctag['string-value']);
                                textR = [];
                            }
                        } else throw new Error('Unsupported value type ' + q.t);
                }
            } else {
                isstub = false;
                if (q.t === 's') {
                    q.v = textp || '';
                    if (textR.length) q.R = textR;
                    isstub = textpidx == 0;
                }
                if (atag.Target) q.l = atag;
                if (comments.length > 0) {
                    q.c = comments;
                    comments = [];
                }
                if (textp && opts.cellText !== false) q.w = textp;
                if (isstub) {
                    q.t = "z";
                    delete q.v;
                }
                if (!isstub || opts.sheetStubs) {
                    if (!(opts.sheetRows && opts.sheetRows <= R)) for(var rpt = 0; rpt < rowpeat; ++rpt){
                        colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10);
                        if (opts.dense) {
                            if (!ws["!data"][R + rpt]) ws["!data"][R + rpt] = [];
                            ws["!data"][R + rpt][C] = rpt == 0 ? q : $b8f343bf88dacc48$var$dup(q);
                            while(--colpeat > 0)ws["!data"][R + rpt][C + colpeat] = $b8f343bf88dacc48$var$dup(q);
                        } else {
                            ws[$b8f343bf88dacc48$var$encode_cell({
                                r: R + rpt,
                                c: C
                            })] = q;
                            while(--colpeat > 0)ws[$b8f343bf88dacc48$var$encode_cell({
                                r: R + rpt,
                                c: C + colpeat
                            })] = $b8f343bf88dacc48$var$dup(q);
                        }
                        if (range.e.c <= C) range.e.c = C;
                    }
                }
                colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10);
                C += colpeat - 1;
                colpeat = 0;
                q = {};
                textp = "";
                textR = [];
            }
            atag = {} /*:any*/ ;
            break; // 9.1.4 <table:table-cell>
        /* pure state */ case 'document':
        case 'document-content':
        case "\u7535\u5B50\u8868\u683C\u6587\u6863":
        case 'spreadsheet':
        case "\u4E3B\u4F53":
        case 'scripts':
        case 'styles':
        case 'font-face-decls':
        case 'master-styles':
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                true
            ]);
            break;
        case 'annotation':
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
                comment.t = textp;
                if (textR.length) /*::(*/ comment /*:: :any)*/ .R = textR;
                comment.a = creator;
                comments.push(comment);
                textp = oldtextp;
                textpidx = oldtextpidx;
                textR = oldtextR;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                state.push([
                    Rn[3],
                    false
                ]);
                var annotag = $b8f343bf88dacc48$var$parsexmltag(Rn[0], true);
                /* office:display TODO: check if there is a global override */ if (!(annotag["display"] && $b8f343bf88dacc48$var$parsexmlbool(annotag["display"]))) comments.hidden = true;
                oldtextp = textp;
                oldtextpidx = textpidx;
                oldtextR = textR;
                textp = "";
                textpidx = 0;
                textR = [];
            }
            creator = "";
            creatoridx = 0;
            break;
        case 'creator':
            if (Rn[1] === '/') creator = str.slice(creatoridx, Rn.index);
            else creatoridx = Rn.index + Rn[0].length;
            break;
        /* ignore state */ case 'meta':
        case "\u5143\u6570\u636E":
        case 'settings':
        case 'config-item-set':
        case 'config-item-map-indexed':
        case 'config-item-map-entry':
        case 'config-item-map-named':
        case 'shapes':
        case 'frame':
        case 'text-box':
        case 'image':
        case 'data-pilot-tables':
        case 'list-style':
        case 'form':
        case 'dde-links':
        case 'event-listeners':
        case 'chart':
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                false
            ]);
            textp = "";
            textpidx = 0;
            textR = [];
            break;
        case 'scientific-number':
        case 'currency-symbol':
        case 'fill-character':
            break;
        case 'text-style':
        case 'boolean-style':
        case 'number-style':
        case 'currency-style':
        case 'percentage-style':
        case 'date-style':
        case 'time-style':
            if (Rn[1] === '/') {
                var xlmlidx = $b8f343bf88dacc48$var$xlmlregex.lastIndex;
                $b8f343bf88dacc48$var$parse_ods_styles(str.slice(nfidx, $b8f343bf88dacc48$var$xlmlregex.lastIndex), _opts, number_format_map);
                $b8f343bf88dacc48$var$xlmlregex.lastIndex = xlmlidx;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') nfidx = $b8f343bf88dacc48$var$xlmlregex.lastIndex - Rn[0].length;
            break;
        case 'script':
            break; // 3.13 <office:script>
        case 'libraries':
            break; // TODO: <ooo:libraries>
        case 'automatic-styles':
            break; // 3.15.3 <office:automatic-styles>
        case 'default-style':
        case 'page-layout':
            break; // TODO: <style:page-layout>
        case 'style':
            var styletag = $b8f343bf88dacc48$var$parsexmltag(Rn[0], false);
            if (styletag["family"] == "table-cell" && number_format_map[styletag["data-style-name"]]) styles[styletag["name"]] = number_format_map[styletag["data-style-name"]];
            break;
        case 'map':
            break; // 16.3 <style:map>
        case 'font-face':
            break; // 16.21 <style:font-face>
        case 'paragraph-properties':
            break; // 17.6 <style:paragraph-properties>
        case 'table-properties':
            break; // 17.15 <style:table-properties>
        case 'table-column-properties':
            break; // 17.16 <style:table-column-properties>
        case 'table-row-properties':
            break; // 17.17 <style:table-row-properties>
        case 'table-cell-properties':
            break; // 17.18 <style:table-cell-properties>
        case 'number':
            break;
        case 'fraction':
            break; // TODO 16.27.6 <number:fraction>
        case 'day':
        case 'month':
        case 'year':
        case 'era':
        case 'day-of-week':
        case 'week-of-year':
        case 'quarter':
        case 'hours':
        case 'minutes':
        case 'seconds':
        case 'am-pm':
            break;
        case 'boolean':
            break; // 16.27.24 <number:boolean>
        case 'text':
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") switch(state[state.length - 1][0]){
                case 'number-style':
                case 'date-style':
                case 'time-style':
                    NF += str.slice(pidx, Rn.index);
                    break;
            }
            else pidx = Rn.index + Rn[0].length;
            break;
        case 'named-range':
            tag = $b8f343bf88dacc48$var$parsexmltag(Rn[0], false);
            _Ref = $b8f343bf88dacc48$var$ods_to_csf_3D(tag['cell-range-address']);
            var nrange = {
                Name: tag.name,
                Ref: _Ref[0] + '!' + _Ref[1]
            } /*:any*/ ;
            if (intable) nrange.Sheet = SheetNames.length;
            WB.Names.push(nrange);
            break;
        case 'text-content':
            break; // 16.27.27 <number:text-content>
        case 'text-properties':
            break; // 16.27.27 <style:text-properties>
        case 'embedded-text':
            break; // 16.27.4 <number:embedded-text>
        case 'body':
        case "\u7535\u5B50\u8868\u683C":
            break; // 3.3 16.9.6 19.726.3
        case 'forms':
            break; // 12.25.2 13.2
        case 'table-column':
            break; // 9.1.6 <table:table-column>
        case 'table-header-rows':
            break; // 9.1.7 <table:table-header-rows>
        case 'table-rows':
            break; // 9.1.12 <table:table-rows>
        /* TODO: outline levels */ case 'table-column-group':
            break; // 9.1.10 <table:table-column-group>
        case 'table-header-columns':
            break; // 9.1.11 <table:table-header-columns>
        case 'table-columns':
            break; // 9.1.12 <table:table-columns>
        case 'null-date':
            tag = $b8f343bf88dacc48$var$parsexmltag(Rn[0], false);
            switch(tag["date-value"]){
                case "1904-01-01":
                    WB.WBProps.date1904 = true;
                    break;
            }
            break;
        case 'graphic-properties':
            break; // 17.21 <style:graphic-properties>
        case 'calculation-settings':
            break; // 9.4.1 <table:calculation-settings>
        case 'named-expressions':
            break; // 9.4.11 <table:named-expressions>
        case 'label-range':
            break; // 9.4.9 <table:label-range>
        case 'label-ranges':
            break; // 9.4.10 <table:label-ranges>
        case 'named-expression':
            break; // 9.4.13 <table:named-expression>
        case 'sort':
            break; // 9.4.19 <table:sort>
        case 'sort-by':
            break; // 9.4.20 <table:sort-by>
        case 'sort-groups':
            break; // 9.4.22 <table:sort-groups>
        case 'tab':
            break; // 6.1.4 <text:tab>
        case 'line-break':
            break; // 6.1.5 <text:line-break>
        case 'span':
            break; // 6.1.7 <text:span>
        case 'p':
        case "\u6587\u672C\u4E32":
            if ([
                'master-styles'
            ].indexOf(state[state.length - 1][0]) > -1) break;
            if (Rn[1] === '/' && (!ctag || !ctag['string-value'])) {
                var ptp = $b8f343bf88dacc48$var$parse_text_p(str.slice(textpidx, Rn.index), textptag);
                textp = (textp.length > 0 ? textp + "\n" : "") + ptp[0];
            } else if (Rn[0].slice(-2) == "/>") /* TODO: is self-closing 文本串 valid? */ textp += "\n";
            else {
                textptag = $b8f343bf88dacc48$var$parsexmltag(Rn[0], false);
                textpidx = Rn.index + Rn[0].length;
            }
            break; // <text:p>
        case 's':
            break; // <text:s>
        case 'database-range':
            if (Rn[1] === '/') break;
            try {
                _Ref = $b8f343bf88dacc48$var$ods_to_csf_3D($b8f343bf88dacc48$var$parsexmltag(Rn[0])['target-range-address']);
                Sheets[_Ref[0]]['!autofilter'] = {
                    ref: _Ref[1]
                };
            } catch (e) {}
            break;
        case 'date':
            break; // <*:date>
        case 'object':
            break; // 10.4.6.2 <draw:object>
        case 'title':
        case "\u6807\u9898":
            break; // <*:title> OR <uof:标题>
        case 'desc':
            break; // <*:desc>
        case 'binary-data':
            break; // 10.4.5 TODO: b64 blob
        /* 9.2 Advanced Tables */ case 'table-source':
            break; // 9.2.6
        case 'scenario':
            break; // 9.2.6
        case 'iteration':
            break; // 9.4.3 <table:iteration>
        case 'content-validations':
            break; // 9.4.4 <table:
        case 'content-validation':
            break; // 9.4.5 <table:
        case 'help-message':
            break; // 9.4.6 <table:
        case 'error-message':
            break; // 9.4.7 <table:
        case 'database-ranges':
            break; // 9.4.14 <table:database-ranges>
        /* 9.5 Filters */ case 'filter':
            break; // 9.5.2 <table:filter>
        case 'filter-and':
            break; // 9.5.3 <table:filter-and>
        case 'filter-or':
            break; // 9.5.4 <table:filter-or>
        case 'filter-condition':
            break; // 9.5.5 <table:filter-condition>
        case 'filter-set-item':
            break; // 9.5.6 <table:filter-condition>
        case 'list-level-style-bullet':
            break; // 16.31 <text:
        case 'list-level-style-number':
            break; // 16.32 <text:
        case 'list-level-properties':
            break; // 17.19 <style:
        /* 7.3 Document Fields */ case 'sender-firstname':
        case 'sender-lastname':
        case 'sender-initials':
        case 'sender-title':
        case 'sender-position':
        case 'sender-email':
        case 'sender-phone-private':
        case 'sender-fax':
        case 'sender-company':
        case 'sender-phone-work':
        case 'sender-street':
        case 'sender-city':
        case 'sender-postal-code':
        case 'sender-country':
        case 'sender-state-or-province':
        case 'author-name':
        case 'author-initials':
        case 'chapter':
        case 'file-name':
        case 'template-name':
        case 'sheet-name':
            break;
        case 'event-listener':
            break;
        /* TODO: FODS Properties */ case 'initial-creator':
        case 'creation-date':
        case 'print-date':
        case 'generator':
        case 'document-statistic':
        case 'user-defined':
        case 'editing-duration':
        case 'editing-cycles':
            break;
        /* TODO: FODS Config */ case 'config-item':
            break;
        /* TODO: style tokens */ case 'page-number':
            break; // TODO <text:page-number>
        case 'page-count':
            break; // TODO <text:page-count>
        case 'time':
            break; // TODO <text:time>
        /* 9.3 Advanced Table Cells */ case 'cell-range-source':
            break; // 9.3.1 <table:
        case 'detective':
            break; // 9.3.2 <table:
        case 'operation':
            break; // 9.3.3 <table:
        case 'highlighted-range':
            break; // 9.3.4 <table:
        /* 9.6 Data Pilot Tables <table: */ case 'data-pilot-table':
        case 'source-cell-range':
        case 'source-service':
        case 'data-pilot-field':
        case 'data-pilot-level':
        case 'data-pilot-subtotals':
        case 'data-pilot-subtotal':
        case 'data-pilot-members':
        case 'data-pilot-member':
        case 'data-pilot-display-info':
        case 'data-pilot-sort-info':
        case 'data-pilot-layout-info':
        case 'data-pilot-field-reference':
        case 'data-pilot-groups':
        case 'data-pilot-group':
        case 'data-pilot-group-member':
            break;
        /* 10.3 Drawing Shapes */ case 'rect':
            break;
        /* 14.6 DDE Connections */ case 'dde-connection-decls':
        case 'dde-connection-decl':
        case 'dde-link':
        case 'dde-source':
            break;
        case 'properties':
            break; // 13.7 <form:properties>
        case 'property':
            break; // 13.8 <form:property>
        case 'a':
            if (Rn[1] !== '/') {
                atag = $b8f343bf88dacc48$var$parsexmltag(Rn[0], false);
                if (!atag.href) break;
                atag.Target = $b8f343bf88dacc48$var$unescapexml(atag.href);
                delete atag.href;
                if (atag.Target.charAt(0) == "#" && atag.Target.indexOf(".") > -1) {
                    _Ref = $b8f343bf88dacc48$var$ods_to_csf_3D(atag.Target.slice(1));
                    atag.Target = "#" + _Ref[0] + "!" + _Ref[1];
                } else if (atag.Target.match(/^\.\.[\\\/]/)) atag.Target = atag.Target.slice(3);
            }
            break;
        /* non-standard */ case 'table-protection':
            break;
        case 'data-pilot-grand-total':
            break; // <table:
        case 'office-document-common-attrs':
            break; // bare
        default:
            switch(Rn[2]){
                case 'dc:':
                case 'calcext:':
                case 'loext:':
                case 'ooo:':
                case 'chartooo:':
                case 'draw:':
                case 'style:':
                case 'chart:':
                case 'form:':
                case 'uof:':
                case "\u8868:":
                case "\u5B57:":
                    break;
                default:
                    if (opts.WTF) throw new Error(Rn);
            }
    }
    var out /*:Workbook*/  = {
        Sheets: Sheets,
        SheetNames: SheetNames,
        Workbook: WB
    } /*:any*/ ;
    if (opts.bookSheets) delete /*::(*/ out /*:: :any)*/ .Sheets;
    return out;
}
function $b8f343bf88dacc48$var$parse_ods(zip /*:ZIPFile*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    opts = opts || {} /*:any*/ ;
    if ($b8f343bf88dacc48$var$safegetzipfile(zip, 'META-INF/manifest.xml')) $b8f343bf88dacc48$var$parse_manifest($b8f343bf88dacc48$var$getzipdata(zip, 'META-INF/manifest.xml'), opts);
    var styles = $b8f343bf88dacc48$var$getzipstr(zip, 'styles.xml');
    var Styles = styles && $b8f343bf88dacc48$var$parse_ods_styles($b8f343bf88dacc48$var$utf8read(styles), opts);
    var content = $b8f343bf88dacc48$var$getzipstr(zip, 'content.xml');
    if (!content) throw new Error("Missing content.xml in ODS / UOF file");
    var wb = $b8f343bf88dacc48$var$parse_content_xml($b8f343bf88dacc48$var$utf8read(content), opts, Styles);
    if ($b8f343bf88dacc48$var$safegetzipfile(zip, 'meta.xml')) wb.Props = $b8f343bf88dacc48$var$parse_core_props($b8f343bf88dacc48$var$getzipdata(zip, 'meta.xml'));
    wb.bookType = "ods";
    return wb;
}
function $b8f343bf88dacc48$var$parse_fods(data /*:string*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var wb = $b8f343bf88dacc48$var$parse_content_xml(data, opts);
    wb.bookType = "fods";
    return wb;
}
/* OpenDocument */ var $b8f343bf88dacc48$var$write_styles_ods /*:{(wb:any, opts:any):string}*/  = /* @__PURE__ */ function() {
    var master_styles = [
        '<office:master-styles>',
        '<style:master-page style:name="mp1" style:page-layout-name="mp1">',
        '<style:header/>',
        '<style:header-left style:display="false"/>',
        '<style:footer/>',
        '<style:footer-left style:display="false"/>',
        '</style:master-page>',
        '</office:master-styles>'
    ].join("");
    var payload = '<office:document-styles ' + $b8f343bf88dacc48$var$wxt_helper({
        'xmlns:office': "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
        'xmlns:table': "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
        'xmlns:style': "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
        'xmlns:text': "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
        'xmlns:draw': "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
        'xmlns:fo': "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
        'xmlns:xlink': "http://www.w3.org/1999/xlink",
        'xmlns:dc': "http://purl.org/dc/elements/1.1/",
        'xmlns:number': "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
        'xmlns:svg': "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
        'xmlns:of': "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
        'office:version': "1.2"
    }) + '>' + master_styles + '</office:document-styles>';
    return function wso() {
        return $b8f343bf88dacc48$var$XML_HEADER + payload;
    };
}();
// TODO: find out if anyone actually read the spec.  LO has some wild errors
function $b8f343bf88dacc48$var$write_number_format_ods(nf /*:string*/ , nfidx /*:string*/ ) /*:string*/ {
    var type = "number", payload = "", nopts = {
        "style:name": nfidx
    }, c = "", i = 0;
    nf = nf.replace(/"[$]"/g, "$");
    /* TODO: replace with an actual parser based on a real grammar */ j: {
        // TODO: support style maps
        if (nf.indexOf(";") > -1) {
            console.error("Unsupported ODS Style Map exported.  Using first branch of " + nf);
            nf = nf.slice(0, nf.indexOf(";"));
        }
        if (nf == "@") {
            type = "text";
            payload = "<number:text-content/>";
            break j;
        }
        /* currency flag */ if (nf.indexOf(/\$/) > -1) type = "currency";
        /* opening string literal */ if (nf[i] == '"') {
            c = "";
            while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
            --i;
            if (nf[i + 1] == "*") {
                i++;
                payload += '<number:fill-character>' + $b8f343bf88dacc48$var$escapexml(c.replace(/""/g, '"')) + '</number:fill-character>';
            } else payload += '<number:text>' + $b8f343bf88dacc48$var$escapexml(c.replace(/""/g, '"')) + '</number:text>';
            nf = nf.slice(i + 1);
            i = 0;
        }
        /* fractions */ var t = nf.match(/# (\?+)\/(\?+)/);
        if (t) {
            payload += $b8f343bf88dacc48$var$writextag("number:fraction", null, {
                "number:min-integer-digits": 0,
                "number:min-numerator-digits": t[1].length,
                "number:max-denominator-value": Math.max(+t[1].replace(/./g, "9"), +t[2].replace(/./g, "9"))
            });
            break j;
        }
        if (t = nf.match(/# (\?+)\/(\d+)/)) {
            payload += $b8f343bf88dacc48$var$writextag("number:fraction", null, {
                "number:min-integer-digits": 0,
                "number:min-numerator-digits": t[1].length,
                "number:denominator-value": +t[2]
            });
            break j;
        }
        /* percentages */ if (t = nf.match(/\b(\d+)(|\.\d+)%/)) {
            type = "percentage";
            payload += $b8f343bf88dacc48$var$writextag("number:number", null, {
                "number:decimal-places": t[2] && t.length - 1 || 0,
                "number:min-decimal-places": t[2] && t.length - 1 || 0,
                "number:min-integer-digits": t[1].length
            }) + "<number:text>%</number:text>";
            break j;
        }
        /* datetime */ var has_time = false;
        if ([
            "y",
            "m",
            "d"
        ].indexOf(nf[0]) > -1) {
            type = "date";
            k: for(; i < nf.length; ++i)switch(c = nf[i].toLowerCase()){
                case "h":
                case "s":
                    has_time = true;
                    --i;
                    break k;
                case "m":
                    l: for(var h = i + 1; h < nf.length; ++h)switch(nf[h]){
                        case "y":
                        case "d":
                            break l;
                        case "h":
                        case "s":
                            has_time = true;
                            --i;
                            break k;
                    }
                /* falls through */ case "y":
                case "d":
                    while((nf[++i] || "").toLowerCase() == c[0])c += c[0];
                    --i;
                    switch(c){
                        case "y":
                        case "yy":
                            payload += "<number:year/>";
                            break;
                        case "yyy":
                        case "yyyy":
                            payload += '<number:year number:style="long"/>';
                            break;
                        case "mmmmm":
                            console.error("ODS has no equivalent of format |mmmmm|");
                        /* falls through */ case "m":
                        case "mm":
                        case "mmm":
                        case "mmmm":
                            payload += '<number:month number:style="' + (c.length % 2 ? "short" : "long") + '" number:textual="' + (c.length >= 3 ? "true" : "false") + '"/>';
                            break;
                        case "d":
                        case "dd":
                            payload += '<number:day number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                        case "ddd":
                        case "dddd":
                            payload += '<number:day-of-week number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                    }
                    break;
                case '"':
                    while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
                    --i;
                    payload += '<number:text>' + $b8f343bf88dacc48$var$escapexml(c.slice(1).replace(/""/g, '"')) + '</number:text>';
                    break;
                case '\\':
                    c = nf[++i];
                    payload += '<number:text>' + $b8f343bf88dacc48$var$escapexml(c) + '</number:text>';
                    break;
                case '/':
                case ':':
                    payload += '<number:text>' + $b8f343bf88dacc48$var$escapexml(c) + '</number:text>';
                    break;
                default:
                    console.error("unrecognized character " + c + " in ODF format " + nf);
            }
            if (!has_time) break j;
            nf = nf.slice(i + 1);
            i = 0;
        }
        if (nf.match(/^\[?[hms]/)) {
            if (type == "number") type = "time";
            if (nf.match(/\[/)) {
                nf = nf.replace(/[\[\]]/g, "");
                nopts['number:truncate-on-overflow'] = "false";
            }
            for(; i < nf.length; ++i)switch(c = nf[i].toLowerCase()){
                case "h":
                case "m":
                case "s":
                    while((nf[++i] || "").toLowerCase() == c[0])c += c[0];
                    --i;
                    switch(c){
                        case "h":
                        case "hh":
                            payload += '<number:hours number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                        case "m":
                        case "mm":
                            payload += '<number:minutes number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                        case "s":
                        case "ss":
                            if (nf[i + 1] == ".") do {
                                c += nf[i + 1];
                                ++i;
                            }while (nf[i + 1] == "0");
                            payload += '<number:seconds number:style="' + (c.match("ss") ? "long" : "short") + '"' + (c.match(/\./) ? ' number:decimal-places="' + (c.match(/0+/) || [
                                ""
                            ])[0].length + '"' : "") + '/>';
                            break;
                    }
                    break;
                case '"':
                    while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
                    --i;
                    payload += '<number:text>' + $b8f343bf88dacc48$var$escapexml(c.slice(1).replace(/""/g, '"')) + '</number:text>';
                    break;
                case '/':
                case ':':
                    payload += '<number:text>' + $b8f343bf88dacc48$var$escapexml(c) + '</number:text>';
                    break;
                case "a":
                    if (nf.slice(i, i + 3).toLowerCase() == "a/p") {
                        payload += '<number:am-pm/>';
                        i += 2;
                        break;
                    } // Note: ODF does not support A/P
                    if (nf.slice(i, i + 5).toLowerCase() == "am/pm") {
                        payload += '<number:am-pm/>';
                        i += 4;
                        break;
                    }
                /* falls through */ default:
                    console.error("unrecognized character " + c + " in ODF format " + nf);
            }
            break j;
        }
        /* currency flag */ if (nf.indexOf(/\$/) > -1) type = "currency";
        /* should be in a char loop */ if (nf[0] == "$") {
            payload += '<number:currency-symbol number:language="en" number:country="US">$</number:currency-symbol>';
            nf = nf.slice(1);
            i = 0;
        }
        i = 0;
        if (nf[i] == '"') {
            while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
            --i;
            if (nf[i + 1] == "*") {
                i++;
                payload += '<number:fill-character>' + $b8f343bf88dacc48$var$escapexml(c.replace(/""/g, '"')) + '</number:fill-character>';
            } else payload += '<number:text>' + $b8f343bf88dacc48$var$escapexml(c.replace(/""/g, '"')) + '</number:text>';
            nf = nf.slice(i + 1);
            i = 0;
        }
        /* number TODO: interstitial text e.g. 000)000-0000 */ var np = nf.match(/([#0][0#,]*)(\.[0#]*|)(E[+]?0*|)/i);
        if (!np || !np[0]) console.error("Could not find numeric part of " + nf);
        else {
            var base = np[1].replace(/,/g, "");
            payload += '<number:' + (np[3] ? "scientific-" : "") + 'number' + ' number:min-integer-digits="' + (base.indexOf("0") == -1 ? "0" : base.length - base.indexOf("0")) + '"' + (np[0].indexOf(",") > -1 ? ' number:grouping="true"' : "") + (np[2] && ' number:decimal-places="' + (np[2].length - 1) + '"' || ' number:decimal-places="0"') + (np[3] && np[3].indexOf("+") > -1 ? ' number:forced-exponent-sign="true"' : "") + (np[3] ? ' number:min-exponent-digits="' + np[3].match(/0+/)[0].length + '"' : "") + '>' + /* TODO: interstitial text placeholders */ '</number:' + (np[3] ? "scientific-" : "") + 'number>';
            i = np.index + np[0].length;
        }
        /* residual text */ if (nf[i] == '"') {
            c = "";
            while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
            --i;
            payload += '<number:text>' + $b8f343bf88dacc48$var$escapexml(c.replace(/""/g, '"')) + '</number:text>';
        }
    }
    if (!payload) {
        console.error("Could not generate ODS number format for |" + nf + "|");
        return "";
    }
    return $b8f343bf88dacc48$var$writextag("number:" + type + "-style", payload, nopts);
}
function $b8f343bf88dacc48$var$write_names_ods(Names, SheetNames, idx) {
    //var scoped = Names.filter(function(name) { return name.Sheet == (idx == -1 ? null : idx); });
    var scoped = [];
    for(var namei = 0; namei < Names.length; ++namei){
        var name = Names[namei];
        if (!name) continue;
        if (name.Sheet == (idx == -1 ? null : idx)) scoped.push(name);
    }
    if (!scoped.length) return "";
    return "      <table:named-expressions>\n" + scoped.map(function(name) {
        var odsref = (idx == -1 ? "$" : "") + $b8f343bf88dacc48$var$csf_to_ods_3D(name.Ref);
        return "        " + $b8f343bf88dacc48$var$writextag("table:named-range", null, {
            "table:name": name.Name,
            "table:cell-range-address": odsref,
            "table:base-cell-address": odsref.replace(/[\.][^\.]*$/, ".$A$1")
        });
    }).join("\n") + "\n      </table:named-expressions>\n";
}
var $b8f343bf88dacc48$var$write_content_ods /*:{(wb:any, opts:any):string}*/  = /* @__PURE__ */ function() {
    /* 6.1.2 White Space Characters */ var write_text_p = function(text /*:string*/ , span) /*:string*/ {
        return $b8f343bf88dacc48$var$escapexml(text).replace(/  +/g, function($$) {
            return '<text:s text:c="' + $$.length + '"/>';
        }).replace(/\t/g, "<text:tab/>").replace(/\n/g, span ? "<text:line-break/>" : "</text:p><text:p>").replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
    };
    var null_cell_xml = '          <table:table-cell />\n';
    var write_ws = function(ws, wb /*:Workbook*/ , i /*:number*/ , opts, nfs, date1904) /*:string*/ {
        /* Section 9 Tables */ var o /*:Array<string>*/  = [];
        o.push('      <table:table table:name="' + $b8f343bf88dacc48$var$escapexml(wb.SheetNames[i]) + '" table:style-name="ta1">\n');
        var R = 0, C = 0, range = $b8f343bf88dacc48$var$decode_range(ws['!ref'] || "A1");
        var marr /*:Array<Range>*/  = ws['!merges'] || [], mi = 0;
        var dense = ws["!data"] != null;
        if (ws["!cols"]) for(C = 0; C <= range.e.c; ++C)o.push('        <table:table-column' + (ws["!cols"][C] ? ' table:style-name="co' + ws["!cols"][C].ods + '"' : '') + '></table:table-column>\n');
        var H = "", ROWS = ws["!rows"] || [];
        for(R = 0; R < range.s.r; ++R){
            H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
            o.push('        <table:table-row' + H + '></table:table-row>\n');
        }
        for(; R <= range.e.r; ++R){
            H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
            o.push('        <table:table-row' + H + '>\n');
            for(C = 0; C < range.s.c; ++C)o.push(null_cell_xml);
            for(; C <= range.e.c; ++C){
                var skip = false, ct = {}, textp = "";
                for(mi = 0; mi != marr.length; ++mi){
                    if (marr[mi].s.c > C) continue;
                    if (marr[mi].s.r > R) continue;
                    if (marr[mi].e.c < C) continue;
                    if (marr[mi].e.r < R) continue;
                    if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                    ct['table:number-columns-spanned'] = marr[mi].e.c - marr[mi].s.c + 1;
                    ct['table:number-rows-spanned'] = marr[mi].e.r - marr[mi].s.r + 1;
                    break;
                }
                if (skip) {
                    o.push('          <table:covered-table-cell/>\n');
                    continue;
                }
                var ref = $b8f343bf88dacc48$var$encode_cell({
                    r: R,
                    c: C
                }), cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
                if (cell && cell.f) {
                    ct['table:formula'] = $b8f343bf88dacc48$var$escapexml($b8f343bf88dacc48$var$csf_to_ods_formula(cell.f));
                    if (cell.F) {
                        if (cell.F.slice(0, ref.length) == ref) {
                            var _Fref = $b8f343bf88dacc48$var$decode_range(cell.F);
                            ct['table:number-matrix-columns-spanned'] = _Fref.e.c - _Fref.s.c + 1;
                            ct['table:number-matrix-rows-spanned'] = _Fref.e.r - _Fref.s.r + 1;
                        }
                    }
                }
                if (!cell) {
                    o.push(null_cell_xml);
                    continue;
                }
                switch(cell.t){
                    case 'b':
                        textp = cell.v ? 'TRUE' : 'FALSE';
                        ct['office:value-type'] = "boolean";
                        ct['office:boolean-value'] = cell.v ? 'true' : 'false';
                        break;
                    case 'n':
                        textp = cell.w || String(cell.v || 0);
                        ct['office:value-type'] = "float";
                        ct['office:value'] = cell.v || 0;
                        break;
                    case 's':
                    case 'str':
                        textp = cell.v == null ? "" : cell.v;
                        ct['office:value-type'] = "string";
                        break;
                    case 'd':
                        textp = cell.w || $b8f343bf88dacc48$var$parseDate(cell.v, date1904).toISOString();
                        ct['office:value-type'] = "date";
                        ct['office:date-value'] = $b8f343bf88dacc48$var$parseDate(cell.v, date1904).toISOString();
                        ct['table:style-name'] = "ce1";
                        break;
                    //case 'e': // TODO: translate to ODS errors
                    default:
                        o.push(null_cell_xml);
                        continue; // TODO: empty cell with comments
                }
                var text_p = write_text_p(textp);
                if (cell.l && cell.l.Target) {
                    var _tgt = cell.l.Target;
                    _tgt = _tgt.charAt(0) == "#" ? "#" + $b8f343bf88dacc48$var$csf_to_ods_3D(_tgt.slice(1)) : _tgt;
                    // TODO: choose correct parent path format based on link delimiters
                    if (_tgt.charAt(0) != "#" && !_tgt.match(/^\w+:/)) _tgt = '../' + _tgt;
                    text_p = $b8f343bf88dacc48$var$writextag('text:a', text_p, {
                        'xlink:href': _tgt.replace(/&/g, "&amp;")
                    });
                }
                if (nfs[cell.z]) ct["table:style-name"] = "ce" + nfs[cell.z].slice(1);
                var payload = $b8f343bf88dacc48$var$writextag('text:p', text_p, {});
                if (cell.c) {
                    var acreator = "", apayload = "", aprops = {};
                    for(var ci = 0; ci < cell.c.length; ++ci){
                        if (!acreator && cell.c[ci].a) acreator = cell.c[ci].a;
                        apayload += "<text:p>" + write_text_p(cell.c[ci].t) + "</text:p>";
                    }
                    if (!cell.c.hidden) aprops["office:display"] = true;
                    payload = $b8f343bf88dacc48$var$writextag('office:annotation', apayload, aprops) + payload;
                }
                o.push('          ' + $b8f343bf88dacc48$var$writextag('table:table-cell', payload, ct) + '\n');
            }
            o.push('        </table:table-row>\n');
        }
        if ((wb.Workbook || {}).Names) o.push($b8f343bf88dacc48$var$write_names_ods(wb.Workbook.Names, wb.SheetNames, i));
        o.push('      </table:table>\n');
        return o.join("");
    };
    var write_automatic_styles_ods = function(o /*:Array<string>*/ , wb) {
        o.push(' <office:automatic-styles>\n');
        /* column styles */ var cidx = 0;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            if (ws["!cols"]) {
                for(var C = 0; C < ws["!cols"].length; ++C)if (ws["!cols"][C]) {
                    var colobj = ws["!cols"][C];
                    if (colobj.width == null && colobj.wpx == null && colobj.wch == null) continue;
                    $b8f343bf88dacc48$var$process_col(colobj);
                    colobj.ods = cidx;
                    var w = ws["!cols"][C].wpx + "px";
                    o.push('  <style:style style:name="co' + cidx + '" style:family="table-column">\n');
                    o.push('   <style:table-column-properties fo:break-before="auto" style:column-width="' + w + '"/>\n');
                    o.push('  </style:style>\n');
                    ++cidx;
                }
            }
        });
        /* row styles */ var ridx = 0;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            if (ws["!rows"]) {
                for(var R = 0; R < ws["!rows"].length; ++R)if (ws["!rows"][R]) {
                    ws["!rows"][R].ods = ridx;
                    var h = ws["!rows"][R].hpx + "px";
                    o.push('  <style:style style:name="ro' + ridx + '" style:family="table-row">\n');
                    o.push('   <style:table-row-properties fo:break-before="auto" style:row-height="' + h + '"/>\n');
                    o.push('  </style:style>\n');
                    ++ridx;
                }
            }
        });
        /* table */ o.push('  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">\n');
        o.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n');
        o.push('  </style:style>\n');
        o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');
        o.push('   <number:month number:style="long"/>\n');
        o.push('   <number:text>/</number:text>\n');
        o.push('   <number:day number:style="long"/>\n');
        o.push('   <number:text>/</number:text>\n');
        o.push('   <number:year/>\n');
        o.push('  </number:date-style>\n');
        /* number formats, table cells, text */ var nfs = {};
        var nfi = 69;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            var dense = ws["!data"] != null;
            if (!ws["!ref"]) return;
            var range = $b8f343bf88dacc48$var$decode_range(ws["!ref"]);
            for(var R = 0; R <= range.e.r; ++R)for(var C = 0; C <= range.e.c; ++C){
                var c = dense ? (ws["!data"][R] || [])[C] : ws[$b8f343bf88dacc48$var$encode_cell({
                    r: R,
                    c: C
                })];
                if (!c || !c.z || c.z.toLowerCase() == "general") continue;
                if (!nfs[c.z]) {
                    var out = $b8f343bf88dacc48$var$write_number_format_ods(c.z, "N" + nfi);
                    if (out) {
                        nfs[c.z] = "N" + nfi;
                        ++nfi;
                        o.push(out + "\n");
                    }
                }
            }
        });
        o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');
        $b8f343bf88dacc48$var$keys(nfs).forEach(function(nf) {
            o.push('<style:style style:name="ce' + nfs[nf].slice(1) + '" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="' + nfs[nf] + '"/>\n');
        });
        /* page-layout */ o.push(' </office:automatic-styles>\n');
        return nfs;
    };
    return function wcx(wb, opts) {
        var o = [
            $b8f343bf88dacc48$var$XML_HEADER
        ];
        /* 3.1.3.2 */ var attr = $b8f343bf88dacc48$var$wxt_helper({
            'xmlns:office': "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
            'xmlns:table': "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
            'xmlns:style': "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
            'xmlns:text': "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
            'xmlns:draw': "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
            'xmlns:fo': "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
            'xmlns:xlink': "http://www.w3.org/1999/xlink",
            'xmlns:dc': "http://purl.org/dc/elements/1.1/",
            'xmlns:meta': "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
            'xmlns:number': "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
            'xmlns:presentation': "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
            'xmlns:svg': "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
            'xmlns:chart': "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
            'xmlns:dr3d': "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
            'xmlns:math': "http://www.w3.org/1998/Math/MathML",
            'xmlns:form': "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
            'xmlns:script': "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
            'xmlns:ooo': "http://openoffice.org/2004/office",
            'xmlns:ooow': "http://openoffice.org/2004/writer",
            'xmlns:oooc': "http://openoffice.org/2004/calc",
            'xmlns:dom': "http://www.w3.org/2001/xml-events",
            'xmlns:xforms': "http://www.w3.org/2002/xforms",
            'xmlns:xsd': "http://www.w3.org/2001/XMLSchema",
            'xmlns:xsi': "http://www.w3.org/2001/XMLSchema-instance",
            'xmlns:sheet': "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
            'xmlns:rpt': "http://openoffice.org/2005/report",
            'xmlns:of': "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
            'xmlns:xhtml': "http://www.w3.org/1999/xhtml",
            'xmlns:grddl': "http://www.w3.org/2003/g/data-view#",
            'xmlns:tableooo': "http://openoffice.org/2009/table",
            'xmlns:drawooo': "http://openoffice.org/2010/draw",
            'xmlns:calcext': "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
            'xmlns:loext': "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
            'xmlns:field': "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
            'xmlns:formx': "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
            'xmlns:css3t': "http://www.w3.org/TR/css3-text/",
            'office:version': "1.2"
        });
        var fods = $b8f343bf88dacc48$var$wxt_helper({
            'xmlns:config': "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
            'office:mimetype': "application/vnd.oasis.opendocument.spreadsheet"
        });
        if (opts.bookType == "fods") {
            o.push('<office:document' + attr + fods + '>\n');
            o.push($b8f343bf88dacc48$var$write_meta_ods().replace(/<office:document-meta[^<>]*?>/, "").replace(/<\/office:document-meta>/, "") + "\n");
        // TODO: settings (equiv of settings.xml for ODS)
        } else o.push('<office:document-content' + attr + '>\n');
        // o.push('  <office:scripts/>\n');
        var nfs = write_automatic_styles_ods(o, wb);
        o.push('  <office:body>\n');
        o.push('    <office:spreadsheet>\n');
        if (((wb.Workbook || {}).WBProps || {}).date1904) o.push('      <table:calculation-settings table:case-sensitive="false" table:search-criteria-must-apply-to-whole-cell="true" table:use-wildcards="true" table:use-regular-expressions="false" table:automatic-find-labels="false">\n        <table:null-date table:date-value="1904-01-01"/>\n      </table:calculation-settings>\n');
        for(var i = 0; i != wb.SheetNames.length; ++i)o.push(write_ws(wb.Sheets[wb.SheetNames[i]], wb, i, opts, nfs, ((wb.Workbook || {}).WBProps || {}).date1904));
        if ((wb.Workbook || {}).Names) o.push($b8f343bf88dacc48$var$write_names_ods(wb.Workbook.Names, wb.SheetNames, -1));
        o.push('    </office:spreadsheet>\n');
        o.push('  </office:body>\n');
        if (opts.bookType == "fods") o.push('</office:document>');
        else o.push('</office:document-content>');
        return o.join("");
    };
}();
function $b8f343bf88dacc48$var$write_ods(wb /*:any*/ , opts /*:any*/ ) {
    if (opts.bookType == "fods") return $b8f343bf88dacc48$var$write_content_ods(wb, opts);
    var zip = $b8f343bf88dacc48$var$zip_new();
    var f = "";
    var manifest /*:Array<Array<string> >*/  = [];
    var rdf /*:Array<[string, string]>*/  = [];
    /* Part 3 Section 3.3 MIME Media Type */ f = "mimetype";
    $b8f343bf88dacc48$var$zip_add_file(zip, f, "application/vnd.oasis.opendocument.spreadsheet");
    /* Part 1 Section 2.2 Documents */ f = "content.xml";
    $b8f343bf88dacc48$var$zip_add_file(zip, f, $b8f343bf88dacc48$var$write_content_ods(wb, opts));
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "ContentFile"
    ]);
    /* TODO: these are hard-coded styles to satiate excel */ f = "styles.xml";
    $b8f343bf88dacc48$var$zip_add_file(zip, f, $b8f343bf88dacc48$var$write_styles_ods(wb, opts));
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "StylesFile"
    ]);
    /* TODO: this is hard-coded to satiate excel */ f = "meta.xml";
    $b8f343bf88dacc48$var$zip_add_file(zip, f, $b8f343bf88dacc48$var$XML_HEADER + $b8f343bf88dacc48$var$write_meta_ods());
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "MetadataFile"
    ]);
    /* Part 3 Section 6 Metadata Manifest File */ f = "manifest.rdf";
    $b8f343bf88dacc48$var$zip_add_file(zip, f, $b8f343bf88dacc48$var$write_rdf(rdf /*, opts*/ ));
    manifest.push([
        f,
        "application/rdf+xml"
    ]);
    /* Part 3 Section 4 Manifest File */ f = "META-INF/manifest.xml";
    $b8f343bf88dacc48$var$zip_add_file(zip, f, $b8f343bf88dacc48$var$write_manifest(manifest /*, opts*/ ));
    return zip;
}
/*! sheetjs (C) 2013-present SheetJS -- http://sheetjs.com */ var $b8f343bf88dacc48$var$subarray = function() {
    try {
        if (typeof Uint8Array == "undefined") return "slice";
        if (typeof Uint8Array.prototype.subarray == "undefined") return "slice";
        if (typeof $b8f343bf88dacc48$require$Buffer !== "undefined") {
            if (typeof $b8f343bf88dacc48$require$Buffer.prototype.subarray == "undefined") return "slice";
            if ((typeof $b8f343bf88dacc48$require$Buffer.from == "function" ? $b8f343bf88dacc48$require$Buffer.from([
                72,
                62
            ]) : new $b8f343bf88dacc48$require$Buffer([
                72,
                62
            ])) instanceof Uint8Array) return "subarray";
            return "slice";
        }
        return "subarray";
    } catch (e) {
        return "slice";
    }
}();
function $b8f343bf88dacc48$var$u8_to_dataview(array) {
    return new DataView(array.buffer, array.byteOffset, array.byteLength);
}
function $b8f343bf88dacc48$var$u8str(u8) {
    return typeof TextDecoder != "undefined" ? new TextDecoder().decode(u8) : $b8f343bf88dacc48$var$utf8read($b8f343bf88dacc48$var$a2s(u8));
}
function $b8f343bf88dacc48$var$stru8(str) {
    return typeof TextEncoder != "undefined" ? new TextEncoder().encode(str) : $b8f343bf88dacc48$var$s2a($b8f343bf88dacc48$var$utf8write(str));
}
function $b8f343bf88dacc48$var$u8concat(u8a) {
    var len = 0;
    for(var i = 0; i < u8a.length; ++i)len += u8a[i].length;
    var out = new Uint8Array(len);
    var off = 0;
    for(i = 0; i < u8a.length; ++i){
        var u8 = u8a[i], L = u8.length;
        if (L < 250) for(var j = 0; j < L; ++j)out[off++] = u8[j];
        else {
            out.set(u8, off);
            off += L;
        }
    }
    return out;
}
function $b8f343bf88dacc48$var$popcnt(x) {
    x -= x >> 1 & 1431655765;
    x = (x & 858993459) + (x >> 2 & 858993459);
    return (x + (x >> 4) & 252645135) * 16843009 >>> 24;
}
function $b8f343bf88dacc48$var$readDecimal128LE(buf, offset) {
    var exp = (buf[offset + 15] & 127) << 7 | buf[offset + 14] >> 1;
    var mantissa = buf[offset + 14] & 1;
    for(var j = offset + 13; j >= offset; --j)mantissa = mantissa * 256 + buf[j];
    return (buf[offset + 15] & 128 ? -mantissa : mantissa) * Math.pow(10, exp - 6176);
}
function $b8f343bf88dacc48$var$writeDecimal128LE(buf, offset, value) {
    var exp = Math.floor(value == 0 ? 0 : Math.LOG10E * Math.log(Math.abs(value))) + 6176 - 16;
    var mantissa = value / Math.pow(10, exp - 6176);
    buf[offset + 15] |= exp >> 7;
    buf[offset + 14] |= (exp & 127) << 1;
    for(var i = 0; mantissa >= 1; ++i, mantissa /= 256)buf[offset + i] = mantissa & 255;
    buf[offset + 15] |= value >= 0 ? 0 : 128;
}
function $b8f343bf88dacc48$var$parse_varint49(buf, ptr) {
    var l = ptr.l;
    var usz = buf[l] & 127;
    varint: if (buf[l++] >= 128) {
        usz |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        usz |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        usz |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 28);
        ++l;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 35);
        ++l;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 42);
        ++l;
        if (buf[l++] < 128) break varint;
    }
    ptr.l = l;
    return usz;
}
function $b8f343bf88dacc48$var$write_varint49(v) {
    var usz = new Uint8Array(7);
    usz[0] = v & 127;
    var L = 1;
    sz: if (v > 127) {
        usz[L - 1] |= 128;
        usz[L] = v >> 7 & 127;
        ++L;
        if (v <= 16383) break sz;
        usz[L - 1] |= 128;
        usz[L] = v >> 14 & 127;
        ++L;
        if (v <= 2097151) break sz;
        usz[L - 1] |= 128;
        usz[L] = v >> 21 & 127;
        ++L;
        if (v <= 268435455) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 256 >>> 21 & 127;
        ++L;
        if (v <= 34359738367) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 65536 >>> 21 & 127;
        ++L;
        if (v <= 4398046511103) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 16777216 >>> 21 & 127;
        ++L;
    }
    return usz[$b8f343bf88dacc48$var$subarray](0, L);
}
function $b8f343bf88dacc48$var$parse_packed_varints(buf) {
    var ptr = {
        l: 0
    };
    var out = [];
    while(ptr.l < buf.length)out.push($b8f343bf88dacc48$var$parse_varint49(buf, ptr));
    return out;
}
function $b8f343bf88dacc48$var$write_packed_varints(nums) {
    return $b8f343bf88dacc48$var$u8concat(nums.map(function(x) {
        return $b8f343bf88dacc48$var$write_varint49(x);
    }));
}
function $b8f343bf88dacc48$var$varint_to_i32(buf) {
    var l = 0, i32 = buf[l] & 127;
    if (buf[l++] < 128) return i32;
    i32 |= (buf[l] & 127) << 7;
    if (buf[l++] < 128) return i32;
    i32 |= (buf[l] & 127) << 14;
    if (buf[l++] < 128) return i32;
    i32 |= (buf[l] & 127) << 21;
    if (buf[l++] < 128) return i32;
    i32 |= (buf[l] & 15) << 28;
    return i32;
}
function $b8f343bf88dacc48$var$varint_to_u64(buf) {
    var l = 0, lo = buf[l] & 127, hi = 0;
    varint: if (buf[l++] >= 128) {
        lo |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        lo |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        lo |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        lo |= (buf[l] & 127) << 28;
        hi = buf[l] >> 4 & 7;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 3;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 10;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 17;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 24;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 31;
    }
    return [
        lo >>> 0,
        hi >>> 0
    ];
}
function $b8f343bf88dacc48$var$parse_shallow(buf) {
    var out = [], ptr = {
        l: 0
    };
    while(ptr.l < buf.length){
        var off = ptr.l;
        var num = $b8f343bf88dacc48$var$parse_varint49(buf, ptr);
        var type = num & 7;
        num = num / 8 | 0;
        var data;
        var l = ptr.l;
        switch(type){
            case 0:
                while(buf[l++] >= 128);
                data = buf[$b8f343bf88dacc48$var$subarray](ptr.l, l);
                ptr.l = l;
                break;
            case 1:
                data = buf[$b8f343bf88dacc48$var$subarray](l, l + 8);
                ptr.l = l + 8;
                break;
            case 2:
                var len = $b8f343bf88dacc48$var$parse_varint49(buf, ptr);
                data = buf[$b8f343bf88dacc48$var$subarray](ptr.l, ptr.l + len);
                ptr.l += len;
                break;
            case 5:
                data = buf[$b8f343bf88dacc48$var$subarray](l, l + 4);
                ptr.l = l + 4;
                break;
            default:
                throw new Error("PB Type ".concat(type, " for Field ").concat(num, " at offset ").concat(off));
        }
        var v = {
            data: data,
            type: type
        };
        if (out[num] == null) out[num] = [];
        out[num].push(v);
    }
    return out;
}
function $b8f343bf88dacc48$var$write_shallow(proto) {
    var out = [];
    proto.forEach(function(field, idx) {
        if (idx == 0) return;
        field.forEach(function(item) {
            if (!item.data) return;
            out.push($b8f343bf88dacc48$var$write_varint49(idx * 8 + item.type));
            if (item.type == 2) out.push($b8f343bf88dacc48$var$write_varint49(item.data.length));
            out.push(item.data);
        });
    });
    return $b8f343bf88dacc48$var$u8concat(out);
}
function $b8f343bf88dacc48$var$mappa(data, cb) {
    return (data == null ? void 0 : data.map(function(d) {
        return cb(d.data);
    })) || [];
}
function $b8f343bf88dacc48$var$parse_iwa_file(buf) {
    var _a;
    var out = [], ptr = {
        l: 0
    };
    while(ptr.l < buf.length){
        var len = $b8f343bf88dacc48$var$parse_varint49(buf, ptr);
        var ai = $b8f343bf88dacc48$var$parse_shallow(buf[$b8f343bf88dacc48$var$subarray](ptr.l, ptr.l + len));
        ptr.l += len;
        var res = {
            id: $b8f343bf88dacc48$var$varint_to_i32(ai[1][0].data),
            messages: []
        };
        ai[2].forEach(function(b) {
            var mi = $b8f343bf88dacc48$var$parse_shallow(b.data);
            var fl = $b8f343bf88dacc48$var$varint_to_i32(mi[3][0].data);
            res.messages.push({
                meta: mi,
                data: buf[$b8f343bf88dacc48$var$subarray](ptr.l, ptr.l + fl)
            });
            ptr.l += fl;
        });
        if ((_a = ai[3]) == null ? void 0 : _a[0]) res.merge = $b8f343bf88dacc48$var$varint_to_i32(ai[3][0].data) >>> 0 > 0;
        out.push(res);
    }
    return out;
}
function $b8f343bf88dacc48$var$write_iwa_file(ias) {
    var bufs = [];
    ias.forEach(function(ia) {
        var ai = [
            [],
            [
                {
                    data: $b8f343bf88dacc48$var$write_varint49(ia.id),
                    type: 0
                }
            ],
            []
        ];
        if (ia.merge != null) ai[3] = [
            {
                data: $b8f343bf88dacc48$var$write_varint49(+!!ia.merge),
                type: 0
            }
        ];
        var midata = [];
        ia.messages.forEach(function(mi) {
            midata.push(mi.data);
            mi.meta[3] = [
                {
                    type: 0,
                    data: $b8f343bf88dacc48$var$write_varint49(mi.data.length)
                }
            ];
            ai[2].push({
                data: $b8f343bf88dacc48$var$write_shallow(mi.meta),
                type: 2
            });
        });
        var aipayload = $b8f343bf88dacc48$var$write_shallow(ai);
        bufs.push($b8f343bf88dacc48$var$write_varint49(aipayload.length));
        bufs.push(aipayload);
        midata.forEach(function(mid) {
            return bufs.push(mid);
        });
    });
    return $b8f343bf88dacc48$var$u8concat(bufs);
}
function $b8f343bf88dacc48$var$parse_snappy_chunk(type, buf) {
    if (type != 0) throw new Error("Unexpected Snappy chunk type ".concat(type));
    var ptr = {
        l: 0
    };
    var usz = $b8f343bf88dacc48$var$parse_varint49(buf, ptr);
    var chunks = [];
    var l = ptr.l;
    while(l < buf.length){
        var tag = buf[l] & 3;
        if (tag == 0) {
            var len = buf[l++] >> 2;
            if (len < 60) ++len;
            else {
                var c = len - 59;
                len = buf[l];
                if (c > 1) len |= buf[l + 1] << 8;
                if (c > 2) len |= buf[l + 2] << 16;
                if (c > 3) len |= buf[l + 3] << 24;
                len >>>= 0;
                len++;
                l += c;
            }
            chunks.push(buf[$b8f343bf88dacc48$var$subarray](l, l + len));
            l += len;
            continue;
        } else {
            var offset = 0, length = 0;
            if (tag == 1) {
                length = (buf[l] >> 2 & 7) + 4;
                offset = (buf[l++] & 224) << 3;
                offset |= buf[l++];
            } else {
                length = (buf[l++] >> 2) + 1;
                if (tag == 2) {
                    offset = buf[l] | buf[l + 1] << 8;
                    l += 2;
                } else {
                    offset = (buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16 | buf[l + 3] << 24) >>> 0;
                    l += 4;
                }
            }
            if (offset == 0) throw new Error("Invalid offset 0");
            var j = chunks.length - 1, off = offset;
            while(j >= 0 && off >= chunks[j].length){
                off -= chunks[j].length;
                --j;
            }
            if (j < 0) {
                if (off == 0) off = chunks[j = 0].length;
                else throw new Error("Invalid offset beyond length");
            }
            if (length < off) chunks.push(chunks[j][$b8f343bf88dacc48$var$subarray](chunks[j].length - off, chunks[j].length - off + length));
            else {
                if (off > 0) {
                    chunks.push(chunks[j][$b8f343bf88dacc48$var$subarray](chunks[j].length - off));
                    length -= off;
                }
                ++j;
                while(length >= chunks[j].length){
                    chunks.push(chunks[j]);
                    length -= chunks[j].length;
                    ++j;
                }
                if (length) chunks.push(chunks[j][$b8f343bf88dacc48$var$subarray](0, length));
            }
            if (chunks.length > 25) chunks = [
                $b8f343bf88dacc48$var$u8concat(chunks)
            ];
        }
    }
    var clen = 0;
    for(var u8i = 0; u8i < chunks.length; ++u8i)clen += chunks[u8i].length;
    if (clen != usz) throw new Error("Unexpected length: ".concat(clen, " != ").concat(usz));
    return chunks;
}
function $b8f343bf88dacc48$var$decompress_iwa_file(buf) {
    if (Array.isArray(buf)) buf = new Uint8Array(buf);
    var out = [];
    var l = 0;
    while(l < buf.length){
        var t = buf[l++];
        var len = buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16;
        l += 3;
        out.push.apply(out, $b8f343bf88dacc48$var$parse_snappy_chunk(t, buf[$b8f343bf88dacc48$var$subarray](l, l + len)));
        l += len;
    }
    if (l !== buf.length) throw new Error("data is not a valid framed stream!");
    return out.length == 1 ? out[0] : $b8f343bf88dacc48$var$u8concat(out);
}
function $b8f343bf88dacc48$var$compress_iwa_file(buf) {
    var out = [];
    var l = 0;
    while(l < buf.length){
        var c = Math.min(buf.length - l, 268435455);
        var frame = new Uint8Array(4);
        out.push(frame);
        var usz = $b8f343bf88dacc48$var$write_varint49(c);
        var L = usz.length;
        out.push(usz);
        if (c <= 60) {
            L++;
            out.push(new Uint8Array([
                c - 1 << 2
            ]));
        } else if (c <= 256) {
            L += 2;
            out.push(new Uint8Array([
                240,
                c - 1 & 255
            ]));
        } else if (c <= 65536) {
            L += 3;
            out.push(new Uint8Array([
                244,
                c - 1 & 255,
                c - 1 >> 8 & 255
            ]));
        } else if (c <= 16777216) {
            L += 4;
            out.push(new Uint8Array([
                248,
                c - 1 & 255,
                c - 1 >> 8 & 255,
                c - 1 >> 16 & 255
            ]));
        } else if (c <= 4294967296) {
            L += 5;
            out.push(new Uint8Array([
                252,
                c - 1 & 255,
                c - 1 >> 8 & 255,
                c - 1 >> 16 & 255,
                c - 1 >>> 24 & 255
            ]));
        }
        out.push(buf[$b8f343bf88dacc48$var$subarray](l, l + c));
        L += c;
        frame[0] = 0;
        frame[1] = L & 255;
        frame[2] = L >> 8 & 255;
        frame[3] = L >> 16 & 255;
        l += c;
    }
    return $b8f343bf88dacc48$var$u8concat(out);
}
var $b8f343bf88dacc48$var$numbers_lut_new = function() {
    return {
        sst: [],
        rsst: [],
        ofmt: [],
        nfmt: [],
        fmla: [],
        ferr: [],
        cmnt: []
    };
};
function $b8f343bf88dacc48$var$numbers_format_cell(cell, t, flags, ofmt, nfmt) {
    var _a, _b, _c, _d;
    var ctype = t & 255, ver = t >> 8;
    var fmt = ver >= 5 ? nfmt : ofmt;
    dur: if (flags & (ver > 4 ? 8 : 4) && cell.t == "n" && ctype == 7) {
        var dstyle = ((_a = fmt[7]) == null ? void 0 : _a[0]) ? $b8f343bf88dacc48$var$varint_to_i32(fmt[7][0].data) : -1;
        if (dstyle == -1) break dur;
        var dmin = ((_b = fmt[15]) == null ? void 0 : _b[0]) ? $b8f343bf88dacc48$var$varint_to_i32(fmt[15][0].data) : -1;
        var dmax = ((_c = fmt[16]) == null ? void 0 : _c[0]) ? $b8f343bf88dacc48$var$varint_to_i32(fmt[16][0].data) : -1;
        var auto = ((_d = fmt[40]) == null ? void 0 : _d[0]) ? $b8f343bf88dacc48$var$varint_to_i32(fmt[40][0].data) : -1;
        var d = cell.v, dd = d;
        autodur: if (auto) {
            if (d == 0) {
                dmin = dmax = 2;
                break autodur;
            }
            if (d >= 604800) dmin = 1;
            else if (d >= 86400) dmin = 2;
            else if (d >= 3600) dmin = 4;
            else if (d >= 60) dmin = 8;
            else if (d >= 1) dmin = 16;
            else dmin = 32;
            if (Math.floor(d) != d) dmax = 32;
            else if (d % 60) dmax = 16;
            else if (d % 3600) dmax = 8;
            else if (d % 86400) dmax = 4;
            else if (d % 604800) dmax = 2;
            if (dmax < dmin) dmax = dmin;
        }
        if (dmin == -1 || dmax == -1) break dur;
        var dstr = [], zstr = [];
        if (dmin == 1) {
            dd = d / 604800;
            if (dmax == 1) zstr.push('d"d"');
            else {
                dd |= 0;
                d -= 604800 * dd;
            }
            dstr.push(dd + (dstyle == 2 ? " week" + (dd == 1 ? "" : "s") : dstyle == 1 ? "w" : ""));
        }
        if (dmin <= 2 && dmax >= 2) {
            dd = d / 86400;
            if (dmax > 2) {
                dd |= 0;
                d -= 86400 * dd;
            }
            zstr.push('d"d"');
            dstr.push(dd + (dstyle == 2 ? " day" + (dd == 1 ? "" : "s") : dstyle == 1 ? "d" : ""));
        }
        if (dmin <= 4 && dmax >= 4) {
            dd = d / 3600;
            if (dmax > 4) {
                dd |= 0;
                d -= 3600 * dd;
            }
            zstr.push((dmin >= 4 ? "[h]" : "h") + '"h"');
            dstr.push(dd + (dstyle == 2 ? " hour" + (dd == 1 ? "" : "s") : dstyle == 1 ? "h" : ""));
        }
        if (dmin <= 8 && dmax >= 8) {
            dd = d / 60;
            if (dmax > 8) {
                dd |= 0;
                d -= 60 * dd;
            }
            zstr.push((dmin >= 8 ? "[m]" : "m") + '"m"');
            if (dstyle == 0) dstr.push((dmin == 8 && dmax == 8 || dd >= 10 ? "" : "0") + dd);
            else dstr.push(dd + (dstyle == 2 ? " minute" + (dd == 1 ? "" : "s") : dstyle == 1 ? "m" : ""));
        }
        if (dmin <= 16 && dmax >= 16) {
            dd = d;
            if (dmax > 16) {
                dd |= 0;
                d -= dd;
            }
            zstr.push((dmin >= 16 ? "[s]" : "s") + '"s"');
            if (dstyle == 0) dstr.push((dmax == 16 && dmin == 16 || dd >= 10 ? "" : "0") + dd);
            else dstr.push(dd + (dstyle == 2 ? " second" + (dd == 1 ? "" : "s") : dstyle == 1 ? "s" : ""));
        }
        if (dmax >= 32) {
            dd = Math.round(1e3 * d);
            if (dmin < 32) zstr.push('.000"ms"');
            if (dstyle == 0) dstr.push((dd >= 100 ? "" : dd >= 10 ? "0" : "00") + dd);
            else dstr.push(dd + (dstyle == 2 ? " millisecond" + (dd == 1 ? "" : "s") : dstyle == 1 ? "ms" : ""));
        }
        cell.w = dstr.join(dstyle == 0 ? ":" : " ");
        cell.z = zstr.join(dstyle == 0 ? '":"' : " ");
        if (dstyle == 0) cell.w = cell.w.replace(/:(\d\d\d)$/, ".$1");
    }
}
function $b8f343bf88dacc48$var$parse_old_storage(buf, lut, v, opts) {
    var dv = $b8f343bf88dacc48$var$u8_to_dataview(buf);
    var flags = dv.getUint32(4, true);
    var ridx = -1, sidx = -1, zidx = -1, ieee = NaN, dc = 0, dt = new Date(Date.UTC(2001, 0, 1));
    var doff = v > 1 ? 12 : 8;
    if (flags & 2) {
        zidx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $b8f343bf88dacc48$var$popcnt(flags & (v > 1 ? 3468 : 396)) * 4;
    if (flags & 512) {
        ridx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $b8f343bf88dacc48$var$popcnt(flags & (v > 1 ? 12288 : 4096)) * 4;
    if (flags & 16) {
        sidx = dv.getUint32(doff, true);
        doff += 4;
    }
    if (flags & 32) {
        ieee = dv.getFloat64(doff, true);
        doff += 8;
    }
    if (flags & 64) {
        dt.setTime(dt.getTime() + (dc = dv.getFloat64(doff, true)) * 1e3);
        doff += 8;
    }
    if (v > 1) {
        flags = dv.getUint32(8, true) >>> 16;
        if (flags & 255) {
            if (zidx == -1) zidx = dv.getUint32(doff, true);
            doff += 4;
        }
    }
    var ret;
    var t = buf[v >= 4 ? 1 : 2];
    switch(t){
        case 0:
            return void 0;
        case 2:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 3:
            ret = {
                t: "s",
                v: lut.sst[sidx]
            };
            break;
        case 5:
            if (opts == null ? void 0 : opts.cellDates) ret = {
                t: "d",
                v: dt
            };
            else ret = {
                t: "n",
                v: dc / 86400 + 35430,
                z: $b8f343bf88dacc48$var$table_fmt[14]
            };
            break;
        case 6:
            ret = {
                t: "b",
                v: ieee > 0
            };
            break;
        case 7:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 8:
            ret = {
                t: "e",
                v: 0
            };
            break;
        case 9:
            if (ridx > -1) {
                var rts = lut.rsst[ridx];
                ret = {
                    t: "s",
                    v: rts.v
                };
                if (rts.l) ret.l = {
                    Target: rts.l
                };
            } else throw new Error("Unsupported cell type ".concat(buf[$b8f343bf88dacc48$var$subarray](0, 4)));
            break;
        default:
            throw new Error("Unsupported cell type ".concat(buf[$b8f343bf88dacc48$var$subarray](0, 4)));
    }
    if (zidx > -1) $b8f343bf88dacc48$var$numbers_format_cell(ret, t | v << 8, flags, lut.ofmt[zidx], lut.nfmt[zidx]);
    if (t == 7) ret.v /= 86400;
    return ret;
}
function $b8f343bf88dacc48$var$parse_new_storage(buf, lut, opts) {
    var dv = $b8f343bf88dacc48$var$u8_to_dataview(buf);
    var flags = dv.getUint32(4, true);
    var fields = dv.getUint32(8, true);
    var doff = 12;
    var ridx = -1, sidx = -1, zidx = -1, d128 = NaN, ieee = NaN, dc = 0, dt = new Date(Date.UTC(2001, 0, 1)), eidx = -1, fidx = -1;
    if (fields & 1) {
        d128 = $b8f343bf88dacc48$var$readDecimal128LE(buf, doff);
        doff += 16;
    }
    if (fields & 2) {
        ieee = dv.getFloat64(doff, true);
        doff += 8;
    }
    if (fields & 4) {
        dt.setTime(dt.getTime() + (dc = dv.getFloat64(doff, true)) * 1e3);
        doff += 8;
    }
    if (fields & 8) {
        sidx = dv.getUint32(doff, true);
        doff += 4;
    }
    if (fields & 16) {
        ridx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $b8f343bf88dacc48$var$popcnt(fields & 480) * 4;
    if (fields & 512) {
        fidx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $b8f343bf88dacc48$var$popcnt(fields & 1024) * 4;
    if (fields & 2048) {
        eidx = dv.getUint32(doff, true);
        doff += 4;
    }
    var ret;
    var t = buf[1];
    switch(t){
        case 0:
            ret = {
                t: "z"
            };
            break;
        case 2:
            ret = {
                t: "n",
                v: d128
            };
            break;
        case 3:
            ret = {
                t: "s",
                v: lut.sst[sidx]
            };
            break;
        case 5:
            if (opts == null ? void 0 : opts.cellDates) ret = {
                t: "d",
                v: dt
            };
            else ret = {
                t: "n",
                v: dc / 86400 + 35430,
                z: $b8f343bf88dacc48$var$table_fmt[14]
            };
            break;
        case 6:
            ret = {
                t: "b",
                v: ieee > 0
            };
            break;
        case 7:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 8:
            ret = {
                t: "e",
                v: 0
            };
            break;
        case 9:
            if (ridx > -1) {
                var rts = lut.rsst[ridx];
                ret = {
                    t: "s",
                    v: rts.v
                };
                if (rts.l) ret.l = {
                    Target: rts.l
                };
            } else throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(fields & 31, " : ").concat(buf[$b8f343bf88dacc48$var$subarray](0, 4)));
            break;
        case 10:
            ret = {
                t: "n",
                v: d128
            };
            break;
        default:
            throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(fields & 31, " : ").concat(buf[$b8f343bf88dacc48$var$subarray](0, 4)));
    }
    doff += $b8f343bf88dacc48$var$popcnt(fields & 4096) * 4;
    if (fields & 516096) {
        if (zidx == -1) zidx = dv.getUint32(doff, true);
        doff += 4;
    }
    if (fields & 524288) {
        var cmntidx = dv.getUint32(doff, true);
        doff += 4;
        if (lut.cmnt[cmntidx]) ret.c = $b8f343bf88dacc48$var$iwa_to_s5s_comment(lut.cmnt[cmntidx]);
    }
    if (zidx > -1) $b8f343bf88dacc48$var$numbers_format_cell(ret, t | 1280, fields >> 13, lut.ofmt[zidx], lut.nfmt[zidx]);
    if (t == 7) ret.v /= 86400;
    return ret;
}
function $b8f343bf88dacc48$var$write_new_storage(cell, lut) {
    var out = new Uint8Array(32), dv = $b8f343bf88dacc48$var$u8_to_dataview(out), l = 12, fields = 0;
    out[0] = 5;
    switch(cell.t){
        case "n":
            if (cell.z && $b8f343bf88dacc48$var$fmt_is_date(cell.z)) {
                out[1] = 5;
                dv.setFloat64(l, ($b8f343bf88dacc48$var$numdate(cell.v + 1462).getTime() - Date.UTC(2001, 0, 1)) / 1e3, true);
                fields |= 4;
                l += 8;
                break;
            } else {
                out[1] = 2;
                $b8f343bf88dacc48$var$writeDecimal128LE(out, l, cell.v);
                fields |= 1;
                l += 16;
            }
            break;
        case "b":
            out[1] = 6;
            dv.setFloat64(l, cell.v ? 1 : 0, true);
            fields |= 2;
            l += 8;
            break;
        case "s":
            var s = cell.v == null ? "" : String(cell.v);
            if (cell.l) {
                var irsst = lut.rsst.findIndex(function(v) {
                    var _a;
                    return v.v == s && v.l == ((_a = cell.l) == null ? void 0 : _a.Target);
                });
                if (irsst == -1) lut.rsst[irsst = lut.rsst.length] = {
                    v: s,
                    l: cell.l.Target
                };
                out[1] = 9;
                dv.setUint32(l, irsst, true);
                fields |= 16;
                l += 4;
            } else {
                var isst = lut.sst.indexOf(s);
                if (isst == -1) lut.sst[isst = lut.sst.length] = s;
                out[1] = 3;
                dv.setUint32(l, isst, true);
                fields |= 8;
                l += 4;
            }
            break;
        case "d":
            out[1] = 5;
            dv.setFloat64(l, (cell.v.getTime() - Date.UTC(2001, 0, 1)) / 1e3, true);
            fields |= 4;
            l += 8;
            break;
        case "z":
            out[1] = 0;
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    if (cell.c) {
        lut.cmnt.push($b8f343bf88dacc48$var$s5s_to_iwa_comment(cell.c));
        dv.setUint32(l, lut.cmnt.length - 1, true);
        fields |= 524288;
        l += 4;
    }
    dv.setUint32(8, fields, true);
    return out[$b8f343bf88dacc48$var$subarray](0, l);
}
function $b8f343bf88dacc48$var$write_old_storage(cell, lut) {
    var out = new Uint8Array(32), dv = $b8f343bf88dacc48$var$u8_to_dataview(out), l = 12, fields = 0, s = "";
    out[0] = 4;
    switch(cell.t){
        case "n":
            break;
        case "b":
            break;
        case "s":
            s = cell.v == null ? "" : String(cell.v);
            if (cell.l) {
                var irsst = lut.rsst.findIndex(function(v) {
                    var _a;
                    return v.v == s && v.l == ((_a = cell.l) == null ? void 0 : _a.Target);
                });
                if (irsst == -1) lut.rsst[irsst = lut.rsst.length] = {
                    v: s,
                    l: cell.l.Target
                };
                out[1] = 9;
                dv.setUint32(l, irsst, true);
                fields |= 512;
                l += 4;
            }
            break;
        case "d":
            break;
        case "e":
            break;
        case "z":
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    if (cell.c) {
        dv.setUint32(l, lut.cmnt.length - 1, true);
        fields |= 4096;
        l += 4;
    }
    switch(cell.t){
        case "n":
            out[1] = 2;
            dv.setFloat64(l, cell.v, true);
            fields |= 32;
            l += 8;
            break;
        case "b":
            out[1] = 6;
            dv.setFloat64(l, cell.v ? 1 : 0, true);
            fields |= 32;
            l += 8;
            break;
        case "s":
            s = cell.v == null ? "" : String(cell.v);
            if (cell.l) ;
            else {
                var isst = lut.sst.indexOf(s);
                if (isst == -1) lut.sst[isst = lut.sst.length] = s;
                out[1] = 3;
                dv.setUint32(l, isst, true);
                fields |= 16;
                l += 4;
            }
            break;
        case "d":
            out[1] = 5;
            dv.setFloat64(l, (cell.v.getTime() - Date.UTC(2001, 0, 1)) / 1e3, true);
            fields |= 64;
            l += 8;
            break;
        case "z":
            out[1] = 0;
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    dv.setUint32(8, fields, true);
    return out[$b8f343bf88dacc48$var$subarray](0, l);
}
function $b8f343bf88dacc48$var$parse_cell_storage(buf, lut, opts) {
    switch(buf[0]){
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
            return $b8f343bf88dacc48$var$parse_old_storage(buf, lut, buf[0], opts);
        case 5:
            return $b8f343bf88dacc48$var$parse_new_storage(buf, lut, opts);
        default:
            throw new Error("Unsupported payload version ".concat(buf[0]));
    }
}
function $b8f343bf88dacc48$var$parse_TSP_Reference(buf) {
    var pb = $b8f343bf88dacc48$var$parse_shallow(buf);
    return $b8f343bf88dacc48$var$varint_to_i32(pb[1][0].data);
}
function $b8f343bf88dacc48$var$write_TSP_Reference(idx) {
    return $b8f343bf88dacc48$var$write_shallow([
        [],
        [
            {
                type: 0,
                data: $b8f343bf88dacc48$var$write_varint49(idx)
            }
        ]
    ]);
}
function $b8f343bf88dacc48$var$numbers_add_oref(iwa, ref) {
    var _a;
    var orefs = ((_a = iwa.messages[0].meta[5]) == null ? void 0 : _a[0]) ? $b8f343bf88dacc48$var$parse_packed_varints(iwa.messages[0].meta[5][0].data) : [];
    var orefidx = orefs.indexOf(ref);
    if (orefidx == -1) {
        orefs.push(ref);
        iwa.messages[0].meta[5] = [
            {
                type: 2,
                data: $b8f343bf88dacc48$var$write_packed_varints(orefs)
            }
        ];
    }
}
function $b8f343bf88dacc48$var$numbers_del_oref(iwa, ref) {
    var _a;
    var orefs = ((_a = iwa.messages[0].meta[5]) == null ? void 0 : _a[0]) ? $b8f343bf88dacc48$var$parse_packed_varints(iwa.messages[0].meta[5][0].data) : [];
    iwa.messages[0].meta[5] = [
        {
            type: 2,
            data: $b8f343bf88dacc48$var$write_packed_varints(orefs.filter(function(r) {
                return r != ref;
            }))
        }
    ];
}
function $b8f343bf88dacc48$var$parse_TST_TableDataList(M, root) {
    var pb = $b8f343bf88dacc48$var$parse_shallow(root.data);
    var type = $b8f343bf88dacc48$var$varint_to_i32(pb[1][0].data);
    var entries = pb[3];
    var data = [];
    (entries || []).forEach(function(entry) {
        var _a, _b;
        var le = $b8f343bf88dacc48$var$parse_shallow(entry.data);
        if (!le[1]) return;
        var key = $b8f343bf88dacc48$var$varint_to_i32(le[1][0].data) >>> 0;
        switch(type){
            case 1:
                data[key] = $b8f343bf88dacc48$var$u8str(le[3][0].data);
                break;
            case 8:
                var rt = M[$b8f343bf88dacc48$var$parse_TSP_Reference(le[9][0].data)][0];
                var rtp = $b8f343bf88dacc48$var$parse_shallow(rt.data);
                var rtpref = M[$b8f343bf88dacc48$var$parse_TSP_Reference(rtp[1][0].data)][0];
                var mtype = $b8f343bf88dacc48$var$varint_to_i32(rtpref.meta[1][0].data);
                if (mtype != 2001) throw new Error("2000 unexpected reference to ".concat(mtype));
                var tswpsa = $b8f343bf88dacc48$var$parse_shallow(rtpref.data);
                var richtext = {
                    v: tswpsa[3].map(function(x) {
                        return $b8f343bf88dacc48$var$u8str(x.data);
                    }).join("")
                };
                data[key] = richtext;
                sfields: if ((_a = tswpsa == null ? void 0 : tswpsa[11]) == null ? void 0 : _a[0]) {
                    var smartfields = (_b = $b8f343bf88dacc48$var$parse_shallow(tswpsa[11][0].data)) == null ? void 0 : _b[1];
                    if (!smartfields) break sfields;
                    smartfields.forEach(function(sf) {
                        var _a2, _b2, _c;
                        var attr = $b8f343bf88dacc48$var$parse_shallow(sf.data);
                        if ((_a2 = attr[2]) == null ? void 0 : _a2[0]) {
                            var obj = M[$b8f343bf88dacc48$var$parse_TSP_Reference((_b2 = attr[2]) == null ? void 0 : _b2[0].data)][0];
                            var objtype = $b8f343bf88dacc48$var$varint_to_i32(obj.meta[1][0].data);
                            switch(objtype){
                                case 2032:
                                    var hlink = $b8f343bf88dacc48$var$parse_shallow(obj.data);
                                    if (((_c = hlink == null ? void 0 : hlink[2]) == null ? void 0 : _c[0]) && !richtext.l) richtext.l = $b8f343bf88dacc48$var$u8str(hlink[2][0].data);
                                    break;
                                case 2039:
                                    break;
                                default:
                                    console.log("unrecognized ObjectAttribute type ".concat(objtype));
                            }
                        }
                    });
                }
                break;
            case 2:
                data[key] = $b8f343bf88dacc48$var$parse_shallow(le[6][0].data);
                break;
            case 3:
                data[key] = $b8f343bf88dacc48$var$parse_shallow(le[5][0].data);
                break;
            case 10:
                var cs = M[$b8f343bf88dacc48$var$parse_TSP_Reference(le[10][0].data)][0];
                data[key] = $b8f343bf88dacc48$var$parse_TSD_CommentStorageArchive(M, cs.data);
                break;
            default:
                throw type;
        }
    });
    return data;
}
function $b8f343bf88dacc48$var$parse_TST_TileRowInfo(u8, type) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
    var pb = $b8f343bf88dacc48$var$parse_shallow(u8);
    var R = $b8f343bf88dacc48$var$varint_to_i32(pb[1][0].data) >>> 0;
    var cnt = $b8f343bf88dacc48$var$varint_to_i32(pb[2][0].data) >>> 0;
    var wide_offsets = ((_b = (_a = pb[8]) == null ? void 0 : _a[0]) == null ? void 0 : _b.data) && $b8f343bf88dacc48$var$varint_to_i32(pb[8][0].data) > 0 || false;
    var used_storage_u8, used_storage;
    if (((_d = (_c = pb[7]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && type != 0) {
        used_storage_u8 = (_f = (_e = pb[7]) == null ? void 0 : _e[0]) == null ? void 0 : _f.data;
        used_storage = (_h = (_g = pb[6]) == null ? void 0 : _g[0]) == null ? void 0 : _h.data;
    } else if (((_j = (_i = pb[4]) == null ? void 0 : _i[0]) == null ? void 0 : _j.data) && type != 1) {
        used_storage_u8 = (_l = (_k = pb[4]) == null ? void 0 : _k[0]) == null ? void 0 : _l.data;
        used_storage = (_n = (_m = pb[3]) == null ? void 0 : _m[0]) == null ? void 0 : _n.data;
    } else throw "NUMBERS Tile missing ".concat(type, " cell storage");
    var width = wide_offsets ? 4 : 1;
    var used_storage_offsets = $b8f343bf88dacc48$var$u8_to_dataview(used_storage_u8);
    var offsets = [];
    for(var C = 0; C < used_storage_u8.length / 2; ++C){
        var off = used_storage_offsets.getUint16(C * 2, true);
        if (off < 65535) offsets.push([
            C,
            off
        ]);
    }
    if (offsets.length != cnt) throw "Expected ".concat(cnt, " cells, found ").concat(offsets.length);
    var cells = [];
    for(C = 0; C < offsets.length - 1; ++C)cells[offsets[C][0]] = used_storage[$b8f343bf88dacc48$var$subarray](offsets[C][1] * width, offsets[C + 1][1] * width);
    if (offsets.length >= 1) cells[offsets[offsets.length - 1][0]] = used_storage[$b8f343bf88dacc48$var$subarray](offsets[offsets.length - 1][1] * width);
    return {
        R: R,
        cells: cells
    };
}
function $b8f343bf88dacc48$var$parse_TST_Tile(M, root) {
    var _a;
    var pb = $b8f343bf88dacc48$var$parse_shallow(root.data);
    var storage = -1;
    if ((_a = pb == null ? void 0 : pb[7]) == null ? void 0 : _a[0]) {
        if ($b8f343bf88dacc48$var$varint_to_i32(pb[7][0].data) >>> 0) storage = 1;
        else storage = 0;
    }
    var ri = $b8f343bf88dacc48$var$mappa(pb[5], function(u8) {
        return $b8f343bf88dacc48$var$parse_TST_TileRowInfo(u8, storage);
    });
    return {
        nrows: $b8f343bf88dacc48$var$varint_to_i32(pb[4][0].data) >>> 0,
        data: ri.reduce(function(acc, x) {
            if (!acc[x.R]) acc[x.R] = [];
            x.cells.forEach(function(cell, C) {
                if (acc[x.R][C]) throw new Error("Duplicate cell r=".concat(x.R, " c=").concat(C));
                acc[x.R][C] = cell;
            });
            return acc;
        }, [])
    };
}
function $b8f343bf88dacc48$var$parse_TSD_CommentStorageArchive(M, data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    var out = {
        t: "",
        a: ""
    };
    var csp = $b8f343bf88dacc48$var$parse_shallow(data);
    if ((_b = (_a = csp == null ? void 0 : csp[1]) == null ? void 0 : _a[0]) == null ? void 0 : _b.data) out.t = $b8f343bf88dacc48$var$u8str((_d = (_c = csp == null ? void 0 : csp[1]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) || "";
    if ((_f = (_e = csp == null ? void 0 : csp[3]) == null ? void 0 : _e[0]) == null ? void 0 : _f.data) {
        var as = M[$b8f343bf88dacc48$var$parse_TSP_Reference((_h = (_g = csp == null ? void 0 : csp[3]) == null ? void 0 : _g[0]) == null ? void 0 : _h.data)][0];
        var asp = $b8f343bf88dacc48$var$parse_shallow(as.data);
        if ((_j = (_i = asp[1]) == null ? void 0 : _i[0]) == null ? void 0 : _j.data) out.a = $b8f343bf88dacc48$var$u8str(asp[1][0].data);
    }
    if (csp == null ? void 0 : csp[4]) {
        out.replies = [];
        csp[4].forEach(function(pi) {
            var cs = M[$b8f343bf88dacc48$var$parse_TSP_Reference(pi.data)][0];
            out.replies.push($b8f343bf88dacc48$var$parse_TSD_CommentStorageArchive(M, cs.data));
        });
    }
    return out;
}
function $b8f343bf88dacc48$var$iwa_to_s5s_comment(iwa) {
    var out = [];
    out.push({
        t: iwa.t || "",
        a: iwa.a,
        T: iwa.replies && iwa.replies.length > 0
    });
    if (iwa.replies) iwa.replies.forEach(function(reply) {
        out.push({
            t: reply.t || "",
            a: reply.a,
            T: true
        });
    });
    return out;
}
function $b8f343bf88dacc48$var$s5s_to_iwa_comment(s5s) {
    var out = {
        a: "",
        t: "",
        replies: []
    };
    for(var i = 0; i < s5s.length; ++i)if (i == 0) {
        out.a = s5s[i].a;
        out.t = s5s[i].t;
    } else out.replies.push({
        a: s5s[i].a,
        t: s5s[i].t
    });
    return out;
}
function $b8f343bf88dacc48$var$parse_TST_TableModelArchive(M, root, ws, opts) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    var pb = $b8f343bf88dacc48$var$parse_shallow(root.data);
    var range = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    range.e.r = ($b8f343bf88dacc48$var$varint_to_i32(pb[6][0].data) >>> 0) - 1;
    if (range.e.r < 0) throw new Error("Invalid row varint ".concat(pb[6][0].data));
    range.e.c = ($b8f343bf88dacc48$var$varint_to_i32(pb[7][0].data) >>> 0) - 1;
    if (range.e.c < 0) throw new Error("Invalid col varint ".concat(pb[7][0].data));
    ws["!ref"] = $b8f343bf88dacc48$var$encode_range(range);
    var dense = ws["!data"] != null, dws = ws;
    var store = $b8f343bf88dacc48$var$parse_shallow(pb[4][0].data);
    var lut = $b8f343bf88dacc48$var$numbers_lut_new();
    if ((_a = store[4]) == null ? void 0 : _a[0]) lut.sst = $b8f343bf88dacc48$var$parse_TST_TableDataList(M, M[$b8f343bf88dacc48$var$parse_TSP_Reference(store[4][0].data)][0]);
    if ((_b = store[6]) == null ? void 0 : _b[0]) lut.fmla = $b8f343bf88dacc48$var$parse_TST_TableDataList(M, M[$b8f343bf88dacc48$var$parse_TSP_Reference(store[6][0].data)][0]);
    if ((_c = store[11]) == null ? void 0 : _c[0]) lut.ofmt = $b8f343bf88dacc48$var$parse_TST_TableDataList(M, M[$b8f343bf88dacc48$var$parse_TSP_Reference(store[11][0].data)][0]);
    if ((_d = store[12]) == null ? void 0 : _d[0]) lut.ferr = $b8f343bf88dacc48$var$parse_TST_TableDataList(M, M[$b8f343bf88dacc48$var$parse_TSP_Reference(store[12][0].data)][0]);
    if ((_e = store[17]) == null ? void 0 : _e[0]) lut.rsst = $b8f343bf88dacc48$var$parse_TST_TableDataList(M, M[$b8f343bf88dacc48$var$parse_TSP_Reference(store[17][0].data)][0]);
    if ((_f = store[19]) == null ? void 0 : _f[0]) lut.cmnt = $b8f343bf88dacc48$var$parse_TST_TableDataList(M, M[$b8f343bf88dacc48$var$parse_TSP_Reference(store[19][0].data)][0]);
    if ((_g = store[22]) == null ? void 0 : _g[0]) lut.nfmt = $b8f343bf88dacc48$var$parse_TST_TableDataList(M, M[$b8f343bf88dacc48$var$parse_TSP_Reference(store[22][0].data)][0]);
    var tile = $b8f343bf88dacc48$var$parse_shallow(store[3][0].data);
    var _R = 0;
    if (!((_h = store[9]) == null ? void 0 : _h[0])) throw "NUMBERS file missing row tree";
    var rtt = $b8f343bf88dacc48$var$parse_shallow(store[9][0].data)[1].map(function(p) {
        return $b8f343bf88dacc48$var$parse_shallow(p.data);
    });
    rtt.forEach(function(kv) {
        _R = $b8f343bf88dacc48$var$varint_to_i32(kv[1][0].data);
        var tidx = $b8f343bf88dacc48$var$varint_to_i32(kv[2][0].data);
        var t = tile[1][tidx];
        if (!t) throw "NUMBERS missing tile " + tidx;
        var tl = $b8f343bf88dacc48$var$parse_shallow(t.data);
        var ref2 = M[$b8f343bf88dacc48$var$parse_TSP_Reference(tl[2][0].data)][0];
        var mtype2 = $b8f343bf88dacc48$var$varint_to_i32(ref2.meta[1][0].data);
        if (mtype2 != 6002) throw new Error("6001 unexpected reference to ".concat(mtype2));
        var _tile = $b8f343bf88dacc48$var$parse_TST_Tile(M, ref2);
        _tile.data.forEach(function(row, R) {
            row.forEach(function(buf, C) {
                var res = $b8f343bf88dacc48$var$parse_cell_storage(buf, lut, opts);
                if (res) {
                    if (dense) {
                        if (!dws["!data"][_R + R]) dws["!data"][_R + R] = [];
                        dws["!data"][_R + R][C] = res;
                    } else ws[$b8f343bf88dacc48$var$encode_col(C) + $b8f343bf88dacc48$var$encode_row(_R + R)] = res;
                }
            });
        });
        _R += _tile.nrows;
    });
    if ((_i = store[13]) == null ? void 0 : _i[0]) {
        var ref = M[$b8f343bf88dacc48$var$parse_TSP_Reference(store[13][0].data)][0];
        var mtype = $b8f343bf88dacc48$var$varint_to_i32(ref.meta[1][0].data);
        if (mtype != 6144) throw new Error("Expected merge type 6144, found ".concat(mtype));
        ws["!merges"] = (_j = $b8f343bf88dacc48$var$parse_shallow(ref.data)) == null ? void 0 : _j[1].map(function(pi) {
            var merge = $b8f343bf88dacc48$var$parse_shallow(pi.data);
            var origin = $b8f343bf88dacc48$var$u8_to_dataview($b8f343bf88dacc48$var$parse_shallow(merge[1][0].data)[1][0].data), size = $b8f343bf88dacc48$var$u8_to_dataview($b8f343bf88dacc48$var$parse_shallow(merge[2][0].data)[1][0].data);
            return {
                s: {
                    r: origin.getUint16(0, true),
                    c: origin.getUint16(2, true)
                },
                e: {
                    r: origin.getUint16(0, true) + size.getUint16(0, true) - 1,
                    c: origin.getUint16(2, true) + size.getUint16(2, true) - 1
                }
            };
        });
    }
}
function $b8f343bf88dacc48$var$parse_TST_TableInfoArchive(M, root, opts) {
    var pb = $b8f343bf88dacc48$var$parse_shallow(root.data);
    var out = {
        "!ref": "A1"
    };
    if (opts == null ? void 0 : opts.dense) out["!data"] = [];
    var tableref = M[$b8f343bf88dacc48$var$parse_TSP_Reference(pb[2][0].data)];
    var mtype = $b8f343bf88dacc48$var$varint_to_i32(tableref[0].meta[1][0].data);
    if (mtype != 6001) throw new Error("6000 unexpected reference to ".concat(mtype));
    $b8f343bf88dacc48$var$parse_TST_TableModelArchive(M, tableref[0], out, opts);
    return out;
}
function $b8f343bf88dacc48$var$parse_TN_SheetArchive(M, root, opts) {
    var _a;
    var pb = $b8f343bf88dacc48$var$parse_shallow(root.data);
    var out = {
        name: ((_a = pb[1]) == null ? void 0 : _a[0]) ? $b8f343bf88dacc48$var$u8str(pb[1][0].data) : "",
        sheets: []
    };
    var shapeoffs = $b8f343bf88dacc48$var$mappa(pb[2], $b8f343bf88dacc48$var$parse_TSP_Reference);
    shapeoffs.forEach(function(off) {
        M[off].forEach(function(m) {
            var mtype = $b8f343bf88dacc48$var$varint_to_i32(m.meta[1][0].data);
            if (mtype == 6e3) out.sheets.push($b8f343bf88dacc48$var$parse_TST_TableInfoArchive(M, m, opts));
        });
    });
    return out;
}
function $b8f343bf88dacc48$var$parse_TN_DocumentArchive(M, root, opts) {
    var _a;
    var out = $b8f343bf88dacc48$var$book_new();
    out.Workbook = {
        WBProps: {
            date1904: true
        }
    };
    var pb = $b8f343bf88dacc48$var$parse_shallow(root.data);
    if ((_a = pb[2]) == null ? void 0 : _a[0]) throw new Error("Keynote presentations are not supported");
    var sheetoffs = $b8f343bf88dacc48$var$mappa(pb[1], $b8f343bf88dacc48$var$parse_TSP_Reference);
    sheetoffs.forEach(function(off) {
        M[off].forEach(function(m) {
            var mtype = $b8f343bf88dacc48$var$varint_to_i32(m.meta[1][0].data);
            if (mtype == 2) {
                var root2 = $b8f343bf88dacc48$var$parse_TN_SheetArchive(M, m, opts);
                root2.sheets.forEach(function(sheet, idx) {
                    $b8f343bf88dacc48$var$book_append_sheet(out, sheet, idx == 0 ? root2.name : root2.name + "_" + idx, true);
                });
            }
        });
    });
    if (out.SheetNames.length == 0) throw new Error("Empty NUMBERS file");
    out.bookType = "numbers";
    return out;
}
function $b8f343bf88dacc48$var$parse_numbers_iwa(cfb, opts) {
    var _a, _b, _c, _d, _e, _f, _g;
    var M = {}, indices = [];
    cfb.FullPaths.forEach(function(p) {
        if (p.match(/\.iwpv2/)) throw new Error("Unsupported password protection");
    });
    cfb.FileIndex.forEach(function(s) {
        if (!s.name.match(/\.iwa$/)) return;
        if (s.content[0] != 0) return;
        var o;
        try {
            o = $b8f343bf88dacc48$var$decompress_iwa_file(s.content);
        } catch (e) {
            return console.log("?? " + s.content.length + " " + (e.message || e));
        }
        var packets;
        try {
            packets = $b8f343bf88dacc48$var$parse_iwa_file(o);
        } catch (e) {
            return console.log("## " + (e.message || e));
        }
        packets.forEach(function(packet) {
            M[packet.id] = packet.messages;
            indices.push(packet.id);
        });
    });
    if (!indices.length) throw new Error("File has no messages");
    if (((_c = (_b = (_a = M == null ? void 0 : M[1]) == null ? void 0 : _a[0].meta) == null ? void 0 : _b[1]) == null ? void 0 : _c[0].data) && $b8f343bf88dacc48$var$varint_to_i32(M[1][0].meta[1][0].data) == 1e4) throw new Error("Pages documents are not supported");
    var docroot = ((_g = (_f = (_e = (_d = M == null ? void 0 : M[1]) == null ? void 0 : _d[0]) == null ? void 0 : _e.meta) == null ? void 0 : _f[1]) == null ? void 0 : _g[0].data) && $b8f343bf88dacc48$var$varint_to_i32(M[1][0].meta[1][0].data) == 1 && M[1][0];
    if (!docroot) indices.forEach(function(idx) {
        M[idx].forEach(function(iwam) {
            var mtype = $b8f343bf88dacc48$var$varint_to_i32(iwam.meta[1][0].data) >>> 0;
            if (mtype == 1) {
                if (!docroot) docroot = iwam;
                else throw new Error("Document has multiple roots");
            }
        });
    });
    if (!docroot) throw new Error("Cannot find Document root");
    return $b8f343bf88dacc48$var$parse_TN_DocumentArchive(M, docroot, opts);
}
function $b8f343bf88dacc48$var$write_TST_TileRowInfo(data, lut, wide) {
    var _a, _b, _c;
    var tri = [
        [],
        [
            {
                type: 0,
                data: $b8f343bf88dacc48$var$write_varint49(0)
            }
        ],
        [
            {
                type: 0,
                data: $b8f343bf88dacc48$var$write_varint49(0)
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array([])
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array(Array.from({
                    length: 510
                }, function() {
                    return 255;
                }))
            }
        ],
        [
            {
                type: 0,
                data: $b8f343bf88dacc48$var$write_varint49(5)
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array([])
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array(Array.from({
                    length: 510
                }, function() {
                    return 255;
                }))
            }
        ],
        [
            {
                type: 0,
                data: $b8f343bf88dacc48$var$write_varint49(1)
            }
        ]
    ];
    if (!((_a = tri[6]) == null ? void 0 : _a[0]) || !((_b = tri[7]) == null ? void 0 : _b[0])) throw "Mutation only works on post-BNC storages!";
    var cnt = 0;
    if (tri[7][0].data.length < 2 * data.length) {
        var new_7 = new Uint8Array(2 * data.length);
        new_7.set(tri[7][0].data);
        tri[7][0].data = new_7;
    }
    if (tri[4][0].data.length < 2 * data.length) {
        var new_4 = new Uint8Array(2 * data.length);
        new_4.set(tri[4][0].data);
        tri[4][0].data = new_4;
    }
    var dv = $b8f343bf88dacc48$var$u8_to_dataview(tri[7][0].data), last_offset = 0, cell_storage = [];
    var _dv = $b8f343bf88dacc48$var$u8_to_dataview(tri[4][0].data), _last_offset = 0, _cell_storage = [];
    var width = wide ? 4 : 1;
    for(var C = 0; C < data.length; ++C){
        if (data[C] == null || data[C].t == "z" && !((_c = data[C].c) == null ? void 0 : _c.length) || data[C].t == "e") {
            dv.setUint16(C * 2, 65535, true);
            _dv.setUint16(C * 2, 65535);
            continue;
        }
        dv.setUint16(C * 2, last_offset / width, true);
        _dv.setUint16(C * 2, _last_offset / width, true);
        var celload, _celload;
        switch(data[C].t){
            case "d":
                if (data[C].v instanceof Date) {
                    celload = $b8f343bf88dacc48$var$write_new_storage(data[C], lut);
                    _celload = $b8f343bf88dacc48$var$write_old_storage(data[C], lut);
                    break;
                }
                celload = $b8f343bf88dacc48$var$write_new_storage(data[C], lut);
                _celload = $b8f343bf88dacc48$var$write_old_storage(data[C], lut);
                break;
            case "s":
            case "n":
            case "b":
            case "z":
                celload = $b8f343bf88dacc48$var$write_new_storage(data[C], lut);
                _celload = $b8f343bf88dacc48$var$write_old_storage(data[C], lut);
                break;
            default:
                throw new Error("Unsupported value " + data[C]);
        }
        cell_storage.push(celload);
        last_offset += celload.length;
        _cell_storage.push(_celload);
        _last_offset += _celload.length;
        ++cnt;
    }
    tri[2][0].data = $b8f343bf88dacc48$var$write_varint49(cnt);
    tri[5][0].data = $b8f343bf88dacc48$var$write_varint49(5);
    for(; C < tri[7][0].data.length / 2; ++C){
        dv.setUint16(C * 2, 65535, true);
        _dv.setUint16(C * 2, 65535, true);
    }
    tri[6][0].data = $b8f343bf88dacc48$var$u8concat(cell_storage);
    tri[3][0].data = $b8f343bf88dacc48$var$u8concat(_cell_storage);
    tri[8] = [
        {
            type: 0,
            data: $b8f343bf88dacc48$var$write_varint49(wide ? 1 : 0)
        }
    ];
    return tri;
}
function $b8f343bf88dacc48$var$write_iwam(type, payload) {
    return {
        meta: [
            [],
            [
                {
                    type: 0,
                    data: $b8f343bf88dacc48$var$write_varint49(type)
                }
            ]
        ],
        data: payload
    };
}
function $b8f343bf88dacc48$var$get_unique_msgid(dep, dependents) {
    if (!dependents.last) dependents.last = 927262;
    for(var i = dependents.last; i < 2e6; ++i)if (!dependents[i]) {
        dependents[dependents.last = i] = dep;
        return i;
    }
    throw new Error("Too many messages");
}
function $b8f343bf88dacc48$var$build_numbers_deps(cfb) {
    var dependents = {};
    var indices = [];
    cfb.FileIndex.map(function(fi, idx) {
        return [
            fi,
            cfb.FullPaths[idx]
        ];
    }).forEach(function(row) {
        var fi = row[0], fp = row[1];
        if (fi.type != 2) return;
        if (!fi.name.match(/\.iwa/)) return;
        if (fi.content[0] != 0) return;
        $b8f343bf88dacc48$var$parse_iwa_file($b8f343bf88dacc48$var$decompress_iwa_file(fi.content)).forEach(function(packet) {
            indices.push(packet.id);
            dependents[packet.id] = {
                deps: [],
                location: fp,
                type: $b8f343bf88dacc48$var$varint_to_i32(packet.messages[0].meta[1][0].data)
            };
        });
    });
    cfb.FileIndex.forEach(function(fi) {
        if (!fi.name.match(/\.iwa/)) return;
        if (fi.content[0] != 0) return;
        $b8f343bf88dacc48$var$parse_iwa_file($b8f343bf88dacc48$var$decompress_iwa_file(fi.content)).forEach(function(ia) {
            ia.messages.forEach(function(mess) {
                [
                    5,
                    6
                ].forEach(function(f) {
                    if (!mess.meta[f]) return;
                    mess.meta[f].forEach(function(x) {
                        dependents[ia.id].deps.push($b8f343bf88dacc48$var$varint_to_i32(x.data));
                    });
                });
            });
        });
    });
    return dependents;
}
function $b8f343bf88dacc48$var$write_TSP_Color_RGB(r, g, b) {
    return $b8f343bf88dacc48$var$write_shallow([
        [],
        [
            {
                type: 0,
                data: $b8f343bf88dacc48$var$write_varint49(1)
            }
        ],
        [],
        [
            {
                type: 5,
                data: new Uint8Array(Float32Array.from([
                    r / 255
                ]).buffer)
            }
        ],
        [
            {
                type: 5,
                data: new Uint8Array(Float32Array.from([
                    g / 255
                ]).buffer)
            }
        ],
        [
            {
                type: 5,
                data: new Uint8Array(Float32Array.from([
                    b / 255
                ]).buffer)
            }
        ],
        [
            {
                type: 5,
                data: new Uint8Array(Float32Array.from([
                    1
                ]).buffer)
            }
        ],
        [],
        [],
        [],
        [],
        [],
        [
            {
                type: 0,
                data: $b8f343bf88dacc48$var$write_varint49(1)
            }
        ]
    ]);
}
function $b8f343bf88dacc48$var$get_author_color(n) {
    switch(n){
        case 0:
            return $b8f343bf88dacc48$var$write_TSP_Color_RGB(99, 222, 171);
        case 1:
            return $b8f343bf88dacc48$var$write_TSP_Color_RGB(162, 197, 240);
        case 2:
            return $b8f343bf88dacc48$var$write_TSP_Color_RGB(255, 189, 189);
    }
    return $b8f343bf88dacc48$var$write_TSP_Color_RGB(Math.random() * 255, Math.random() * 255, Math.random() * 255);
}
function $b8f343bf88dacc48$var$write_numbers_iwa(wb, opts) {
    if (!opts || !opts.numbers) throw new Error("Must pass a `numbers` option -- check the README");
    var cfb = $b8f343bf88dacc48$export$9f0e51cd97c572a.read(opts.numbers, {
        type: "base64"
    });
    var deps = $b8f343bf88dacc48$var$build_numbers_deps(cfb);
    var docroot = $b8f343bf88dacc48$var$numbers_iwa_find(cfb, deps, 1);
    if (docroot == null) throw "Could not find message ".concat(1, " in Numbers template");
    var sheetrefs = $b8f343bf88dacc48$var$mappa($b8f343bf88dacc48$var$parse_shallow(docroot.messages[0].data)[1], $b8f343bf88dacc48$var$parse_TSP_Reference);
    if (sheetrefs.length > 1) throw new Error("Template NUMBERS file must have exactly one sheet");
    wb.SheetNames.forEach(function(name, idx) {
        if (idx >= 1) {
            $b8f343bf88dacc48$var$numbers_add_ws(cfb, deps, idx + 1);
            docroot = $b8f343bf88dacc48$var$numbers_iwa_find(cfb, deps, 1);
            sheetrefs = $b8f343bf88dacc48$var$mappa($b8f343bf88dacc48$var$parse_shallow(docroot.messages[0].data)[1], $b8f343bf88dacc48$var$parse_TSP_Reference);
        }
        $b8f343bf88dacc48$var$write_numbers_ws(cfb, deps, wb.Sheets[name], name, idx, sheetrefs[idx]);
    });
    return cfb;
}
function $b8f343bf88dacc48$var$numbers_iwa_doit(cfb, deps, id, cb) {
    var entry = $b8f343bf88dacc48$export$9f0e51cd97c572a.find(cfb, deps[id].location);
    if (!entry) throw "Could not find ".concat(deps[id].location, " in Numbers template");
    var x = $b8f343bf88dacc48$var$parse_iwa_file($b8f343bf88dacc48$var$decompress_iwa_file(entry.content));
    var ainfo = x.find(function(packet) {
        return packet.id == id;
    });
    cb(ainfo, x);
    entry.content = $b8f343bf88dacc48$var$compress_iwa_file($b8f343bf88dacc48$var$write_iwa_file(x));
    entry.size = entry.content.length;
}
function $b8f343bf88dacc48$var$numbers_iwa_find(cfb, deps, id) {
    var entry = $b8f343bf88dacc48$export$9f0e51cd97c572a.find(cfb, deps[id].location);
    if (!entry) throw "Could not find ".concat(deps[id].location, " in Numbers template");
    var x = $b8f343bf88dacc48$var$parse_iwa_file($b8f343bf88dacc48$var$decompress_iwa_file(entry.content));
    var ainfo = x.find(function(packet) {
        return packet.id == id;
    });
    return ainfo;
}
function $b8f343bf88dacc48$var$numbers_add_meta(mlist, newid, newloc) {
    mlist[3].push({
        type: 2,
        data: $b8f343bf88dacc48$var$write_shallow([
            [],
            [
                {
                    type: 0,
                    data: $b8f343bf88dacc48$var$write_varint49(newid)
                }
            ],
            [
                {
                    type: 2,
                    data: $b8f343bf88dacc48$var$stru8(newloc.replace(/-[\s\S]*$/, ""))
                }
            ],
            [
                {
                    type: 2,
                    data: $b8f343bf88dacc48$var$stru8(newloc)
                }
            ],
            [
                {
                    type: 2,
                    data: new Uint8Array([
                        2,
                        0,
                        0
                    ])
                }
            ],
            [
                {
                    type: 2,
                    data: new Uint8Array([
                        2,
                        0,
                        0
                    ])
                }
            ],
            [],
            [],
            [],
            [],
            [
                {
                    type: 0,
                    data: $b8f343bf88dacc48$var$write_varint49(0)
                }
            ],
            [],
            [
                {
                    type: 0,
                    data: $b8f343bf88dacc48$var$write_varint49(0)
                }
            ]
        ])
    });
    mlist[1] = [
        {
            type: 0,
            data: $b8f343bf88dacc48$var$write_varint49(Math.max(newid + 1, $b8f343bf88dacc48$var$varint_to_i32(mlist[1][0].data)))
        }
    ];
}
function $b8f343bf88dacc48$var$numbers_add_msg(cfb, type, msg, path, deps, id) {
    if (!id) id = $b8f343bf88dacc48$var$get_unique_msgid({
        deps: [],
        location: "",
        type: type
    }, deps);
    var loc = "".concat(path, "-").concat(id, ".iwa");
    deps[id].location = "Root Entry" + loc;
    $b8f343bf88dacc48$export$9f0e51cd97c572a.utils.cfb_add(cfb, loc, $b8f343bf88dacc48$var$compress_iwa_file($b8f343bf88dacc48$var$write_iwa_file([
        {
            id: id,
            messages: [
                $b8f343bf88dacc48$var$write_iwam(type, $b8f343bf88dacc48$var$write_shallow(msg))
            ]
        }
    ])));
    var newloc = loc.replace(/^[\/]/, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
    $b8f343bf88dacc48$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
        var mlist = $b8f343bf88dacc48$var$parse_shallow(ai.messages[0].data);
        $b8f343bf88dacc48$var$numbers_add_meta(mlist, id || 0, newloc);
        ai.messages[0].data = $b8f343bf88dacc48$var$write_shallow(mlist);
    });
    return id;
}
function $b8f343bf88dacc48$var$numbers_meta_add_dep(mlist, deps, id, dep) {
    var loc = deps[id].location.replace(/^Root Entry\//, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
    var parentidx = mlist[3].findIndex(function(m) {
        var _a, _b;
        var mm = $b8f343bf88dacc48$var$parse_shallow(m.data);
        if ((_a = mm[3]) == null ? void 0 : _a[0]) return $b8f343bf88dacc48$var$u8str(mm[3][0].data) == loc;
        if (((_b = mm[2]) == null ? void 0 : _b[0]) && $b8f343bf88dacc48$var$u8str(mm[2][0].data) == loc) return true;
        return false;
    });
    var parent = $b8f343bf88dacc48$var$parse_shallow(mlist[3][parentidx].data);
    if (!parent[6]) parent[6] = [];
    (Array.isArray(dep) ? dep : [
        dep
    ]).forEach(function(dep2) {
        parent[6].push({
            type: 2,
            data: $b8f343bf88dacc48$var$write_shallow([
                [],
                [
                    {
                        type: 0,
                        data: $b8f343bf88dacc48$var$write_varint49(dep2)
                    }
                ]
            ])
        });
    });
    mlist[3][parentidx].data = $b8f343bf88dacc48$var$write_shallow(parent);
}
function $b8f343bf88dacc48$var$numbers_meta_del_dep(mlist, deps, id, dep) {
    var loc = deps[id].location.replace(/^Root Entry\//, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
    var parentidx = mlist[3].findIndex(function(m) {
        var _a, _b;
        var mm = $b8f343bf88dacc48$var$parse_shallow(m.data);
        if ((_a = mm[3]) == null ? void 0 : _a[0]) return $b8f343bf88dacc48$var$u8str(mm[3][0].data) == loc;
        if (((_b = mm[2]) == null ? void 0 : _b[0]) && $b8f343bf88dacc48$var$u8str(mm[2][0].data) == loc) return true;
        return false;
    });
    var parent = $b8f343bf88dacc48$var$parse_shallow(mlist[3][parentidx].data);
    if (!parent[6]) parent[6] = [];
    parent[6] = parent[6].filter(function(m) {
        return $b8f343bf88dacc48$var$varint_to_i32($b8f343bf88dacc48$var$parse_shallow(m.data)[1][0].data) != dep;
    });
    mlist[3][parentidx].data = $b8f343bf88dacc48$var$write_shallow(parent);
}
function $b8f343bf88dacc48$var$numbers_add_ws(cfb, deps, wsidx) {
    var sheetref = -1, newsheetref = -1;
    var remap = {};
    $b8f343bf88dacc48$var$numbers_iwa_doit(cfb, deps, 1, function(docroot, arch) {
        var doc = $b8f343bf88dacc48$var$parse_shallow(docroot.messages[0].data);
        sheetref = $b8f343bf88dacc48$var$parse_TSP_Reference($b8f343bf88dacc48$var$parse_shallow(docroot.messages[0].data)[1][0].data);
        newsheetref = $b8f343bf88dacc48$var$get_unique_msgid({
            deps: [
                1
            ],
            location: deps[sheetref].location,
            type: 2
        }, deps);
        remap[sheetref] = newsheetref;
        $b8f343bf88dacc48$var$numbers_add_oref(docroot, newsheetref);
        doc[1].push({
            type: 2,
            data: $b8f343bf88dacc48$var$write_TSP_Reference(newsheetref)
        });
        var sheet = $b8f343bf88dacc48$var$numbers_iwa_find(cfb, deps, sheetref);
        sheet.id = newsheetref;
        if (deps[1].location == deps[newsheetref].location) arch.push(sheet);
        else $b8f343bf88dacc48$var$numbers_iwa_doit(cfb, deps, newsheetref, function(_, x) {
            return x.push(sheet);
        });
        docroot.messages[0].data = $b8f343bf88dacc48$var$write_shallow(doc);
    });
    var tiaref = -1;
    $b8f343bf88dacc48$var$numbers_iwa_doit(cfb, deps, newsheetref, function(sheetroot, arch) {
        var sa = $b8f343bf88dacc48$var$parse_shallow(sheetroot.messages[0].data);
        for(var i = 3; i <= 69; ++i)delete sa[i];
        var drawables = $b8f343bf88dacc48$var$mappa(sa[2], $b8f343bf88dacc48$var$parse_TSP_Reference);
        drawables.forEach(function(n) {
            return $b8f343bf88dacc48$var$numbers_del_oref(sheetroot, n);
        });
        tiaref = $b8f343bf88dacc48$var$get_unique_msgid({
            deps: [
                newsheetref
            ],
            location: deps[drawables[0]].location,
            type: deps[drawables[0]].type
        }, deps);
        $b8f343bf88dacc48$var$numbers_add_oref(sheetroot, tiaref);
        remap[drawables[0]] = tiaref;
        sa[2] = [
            {
                type: 2,
                data: $b8f343bf88dacc48$var$write_TSP_Reference(tiaref)
            }
        ];
        var tia = $b8f343bf88dacc48$var$numbers_iwa_find(cfb, deps, drawables[0]);
        tia.id = tiaref;
        if (deps[drawables[0]].location == deps[newsheetref].location) arch.push(tia);
        else {
            $b8f343bf88dacc48$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                var mlist = $b8f343bf88dacc48$var$parse_shallow(ai.messages[0].data);
                $b8f343bf88dacc48$var$numbers_meta_add_dep(mlist, deps, newsheetref, tiaref);
                ai.messages[0].data = $b8f343bf88dacc48$var$write_shallow(mlist);
            });
            $b8f343bf88dacc48$var$numbers_iwa_doit(cfb, deps, tiaref, function(_, x) {
                return x.push(tia);
            });
        }
        sheetroot.messages[0].data = $b8f343bf88dacc48$var$write_shallow(sa);
    });
    var tmaref = -1;
    $b8f343bf88dacc48$var$numbers_iwa_doit(cfb, deps, tiaref, function(tiaroot, arch) {
        var tia = $b8f343bf88dacc48$var$parse_shallow(tiaroot.messages[0].data);
        var da = $b8f343bf88dacc48$var$parse_shallow(tia[1][0].data);
        for(var i = 3; i <= 69; ++i)delete da[i];
        var dap = $b8f343bf88dacc48$var$parse_TSP_Reference(da[2][0].data);
        da[2][0].data = $b8f343bf88dacc48$var$write_TSP_Reference(remap[dap]);
        tia[1][0].data = $b8f343bf88dacc48$var$write_shallow(da);
        var oldtmaref = $b8f343bf88dacc48$var$parse_TSP_Reference(tia[2][0].data);
        $b8f343bf88dacc48$var$numbers_del_oref(tiaroot, oldtmaref);
        tmaref = $b8f343bf88dacc48$var$get_unique_msgid({
            deps: [
                tiaref
            ],
            location: deps[oldtmaref].location,
            type: deps[oldtmaref].type
        }, deps);
        $b8f343bf88dacc48$var$numbers_add_oref(tiaroot, tmaref);
        remap[oldtmaref] = tmaref;
        tia[2][0].data = $b8f343bf88dacc48$var$write_TSP_Reference(tmaref);
        var tma = $b8f343bf88dacc48$var$numbers_iwa_find(cfb, deps, oldtmaref);
        tma.id = tmaref;
        if (deps[tiaref].location == deps[tmaref].location) arch.push(tma);
        else $b8f343bf88dacc48$var$numbers_iwa_doit(cfb, deps, tmaref, function(_, x) {
            return x.push(tma);
        });
        tiaroot.messages[0].data = $b8f343bf88dacc48$var$write_shallow(tia);
    });
    $b8f343bf88dacc48$var$numbers_iwa_doit(cfb, deps, tmaref, function(tmaroot, arch) {
        var _a, _b;
        var tma = $b8f343bf88dacc48$var$parse_shallow(tmaroot.messages[0].data);
        var uuid = $b8f343bf88dacc48$var$u8str(tma[1][0].data), new_uuid = uuid.replace(/-[A-Z0-9]*/, "-".concat(("0000" + wsidx.toString(16)).slice(-4)));
        tma[1][0].data = $b8f343bf88dacc48$var$stru8(new_uuid);
        [
            12,
            13,
            29,
            31,
            32,
            33,
            39,
            44,
            47,
            81,
            82,
            84
        ].forEach(function(n) {
            return delete tma[n];
        });
        if (tma[45]) {
            var srrta = $b8f343bf88dacc48$var$parse_shallow(tma[45][0].data);
            var ref = $b8f343bf88dacc48$var$parse_TSP_Reference(srrta[1][0].data);
            $b8f343bf88dacc48$var$numbers_del_oref(tmaroot, ref);
            delete tma[45];
        }
        if (tma[70]) {
            var hsoa = $b8f343bf88dacc48$var$parse_shallow(tma[70][0].data);
            (_a = hsoa[2]) == null || _a.forEach(function(item) {
                var hsa = $b8f343bf88dacc48$var$parse_shallow(item.data);
                [
                    2,
                    3
                ].map(function(n) {
                    return hsa[n][0];
                }).forEach(function(hseadata) {
                    var hsea = $b8f343bf88dacc48$var$parse_shallow(hseadata.data);
                    if (!hsea[8]) return;
                    var ref2 = $b8f343bf88dacc48$var$parse_TSP_Reference(hsea[8][0].data);
                    $b8f343bf88dacc48$var$numbers_del_oref(tmaroot, ref2);
                });
            });
            delete tma[70];
        }
        [
            46,
            30,
            34,
            35,
            36,
            38,
            48,
            49,
            60,
            61,
            62,
            63,
            64,
            71,
            72,
            73,
            74,
            75,
            85,
            86,
            87,
            88,
            89
        ].forEach(function(n) {
            if (!tma[n]) return;
            var ref2 = $b8f343bf88dacc48$var$parse_TSP_Reference(tma[n][0].data);
            delete tma[n];
            $b8f343bf88dacc48$var$numbers_del_oref(tmaroot, ref2);
        });
        var store = $b8f343bf88dacc48$var$parse_shallow(tma[4][0].data);
        [
            2,
            4,
            5,
            6,
            11,
            12,
            13,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22
        ].forEach(function(n) {
            var _a2;
            if (!((_a2 = store[n]) == null ? void 0 : _a2[0])) return;
            var oldref = $b8f343bf88dacc48$var$parse_TSP_Reference(store[n][0].data);
            var newref = $b8f343bf88dacc48$var$get_unique_msgid({
                deps: [
                    tmaref
                ],
                location: deps[oldref].location,
                type: deps[oldref].type
            }, deps);
            $b8f343bf88dacc48$var$numbers_del_oref(tmaroot, oldref);
            $b8f343bf88dacc48$var$numbers_add_oref(tmaroot, newref);
            remap[oldref] = newref;
            var msg = $b8f343bf88dacc48$var$numbers_iwa_find(cfb, deps, oldref);
            msg.id = newref;
            if (deps[oldref].location == deps[tmaref].location) arch.push(msg);
            else {
                deps[newref].location = deps[oldref].location.replace(oldref.toString(), newref.toString());
                if (deps[newref].location == deps[oldref].location) deps[newref].location = deps[newref].location.replace(/\.iwa/, "-".concat(newref, ".iwa"));
                $b8f343bf88dacc48$export$9f0e51cd97c572a.utils.cfb_add(cfb, deps[newref].location, $b8f343bf88dacc48$var$compress_iwa_file($b8f343bf88dacc48$var$write_iwa_file([
                    msg
                ])));
                var newloc = deps[newref].location.replace(/^Root Entry\//, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
                $b8f343bf88dacc48$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $b8f343bf88dacc48$var$parse_shallow(ai.messages[0].data);
                    $b8f343bf88dacc48$var$numbers_add_meta(mlist, newref, newloc);
                    $b8f343bf88dacc48$var$numbers_meta_add_dep(mlist, deps, tmaref, newref);
                    ai.messages[0].data = $b8f343bf88dacc48$var$write_shallow(mlist);
                });
            }
            store[n][0].data = $b8f343bf88dacc48$var$write_TSP_Reference(newref);
        });
        var row_headers = $b8f343bf88dacc48$var$parse_shallow(store[1][0].data);
        (_b = row_headers[2]) == null || _b.forEach(function(tspref) {
            var oldref = $b8f343bf88dacc48$var$parse_TSP_Reference(tspref.data);
            var newref = $b8f343bf88dacc48$var$get_unique_msgid({
                deps: [
                    tmaref
                ],
                location: deps[oldref].location,
                type: deps[oldref].type
            }, deps);
            $b8f343bf88dacc48$var$numbers_del_oref(tmaroot, oldref);
            $b8f343bf88dacc48$var$numbers_add_oref(tmaroot, newref);
            remap[oldref] = newref;
            var msg = $b8f343bf88dacc48$var$numbers_iwa_find(cfb, deps, oldref);
            msg.id = newref;
            if (deps[oldref].location == deps[tmaref].location) arch.push(msg);
            else {
                deps[newref].location = deps[oldref].location.replace(oldref.toString(), newref.toString());
                if (deps[newref].location == deps[oldref].location) deps[newref].location = deps[newref].location.replace(/\.iwa/, "-".concat(newref, ".iwa"));
                $b8f343bf88dacc48$export$9f0e51cd97c572a.utils.cfb_add(cfb, deps[newref].location, $b8f343bf88dacc48$var$compress_iwa_file($b8f343bf88dacc48$var$write_iwa_file([
                    msg
                ])));
                var newloc = deps[newref].location.replace(/^Root Entry\//, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
                $b8f343bf88dacc48$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $b8f343bf88dacc48$var$parse_shallow(ai.messages[0].data);
                    $b8f343bf88dacc48$var$numbers_add_meta(mlist, newref, newloc);
                    $b8f343bf88dacc48$var$numbers_meta_add_dep(mlist, deps, tmaref, newref);
                    ai.messages[0].data = $b8f343bf88dacc48$var$write_shallow(mlist);
                });
            }
            tspref.data = $b8f343bf88dacc48$var$write_TSP_Reference(newref);
        });
        store[1][0].data = $b8f343bf88dacc48$var$write_shallow(row_headers);
        var tiles = $b8f343bf88dacc48$var$parse_shallow(store[3][0].data);
        tiles[1].forEach(function(t) {
            var tst = $b8f343bf88dacc48$var$parse_shallow(t.data);
            var oldtileref = $b8f343bf88dacc48$var$parse_TSP_Reference(tst[2][0].data);
            var newtileref = remap[oldtileref];
            if (!remap[oldtileref]) {
                newtileref = $b8f343bf88dacc48$var$get_unique_msgid({
                    deps: [
                        tmaref
                    ],
                    location: "",
                    type: deps[oldtileref].type
                }, deps);
                deps[newtileref].location = "Root Entry/Index/Tables/Tile-".concat(newtileref, ".iwa");
                remap[oldtileref] = newtileref;
                var oldtile = $b8f343bf88dacc48$var$numbers_iwa_find(cfb, deps, oldtileref);
                oldtile.id = newtileref;
                $b8f343bf88dacc48$var$numbers_del_oref(tmaroot, oldtileref);
                $b8f343bf88dacc48$var$numbers_add_oref(tmaroot, newtileref);
                $b8f343bf88dacc48$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/Index/Tables/Tile-".concat(newtileref, ".iwa"), $b8f343bf88dacc48$var$compress_iwa_file($b8f343bf88dacc48$var$write_iwa_file([
                    oldtile
                ])));
                $b8f343bf88dacc48$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $b8f343bf88dacc48$var$parse_shallow(ai.messages[0].data);
                    mlist[3].push({
                        type: 2,
                        data: $b8f343bf88dacc48$var$write_shallow([
                            [],
                            [
                                {
                                    type: 0,
                                    data: $b8f343bf88dacc48$var$write_varint49(newtileref)
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $b8f343bf88dacc48$var$stru8("Tables/Tile")
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $b8f343bf88dacc48$var$stru8("Tables/Tile-".concat(newtileref))
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [],
                            [],
                            [],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $b8f343bf88dacc48$var$write_varint49(0)
                                }
                            ],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $b8f343bf88dacc48$var$write_varint49(0)
                                }
                            ]
                        ])
                    });
                    mlist[1] = [
                        {
                            type: 0,
                            data: $b8f343bf88dacc48$var$write_varint49(Math.max(newtileref + 1, $b8f343bf88dacc48$var$varint_to_i32(mlist[1][0].data)))
                        }
                    ];
                    $b8f343bf88dacc48$var$numbers_meta_add_dep(mlist, deps, tmaref, newtileref);
                    ai.messages[0].data = $b8f343bf88dacc48$var$write_shallow(mlist);
                });
            }
            tst[2][0].data = $b8f343bf88dacc48$var$write_TSP_Reference(newtileref);
            t.data = $b8f343bf88dacc48$var$write_shallow(tst);
        });
        store[3][0].data = $b8f343bf88dacc48$var$write_shallow(tiles);
        tma[4][0].data = $b8f343bf88dacc48$var$write_shallow(store);
        tmaroot.messages[0].data = $b8f343bf88dacc48$var$write_shallow(tma);
    });
}
function $b8f343bf88dacc48$var$write_numbers_ws(cfb, deps, ws, wsname, sheetidx, rootref) {
    var drawables = [];
    $b8f343bf88dacc48$var$numbers_iwa_doit(cfb, deps, rootref, function(docroot) {
        var sheetref = $b8f343bf88dacc48$var$parse_shallow(docroot.messages[0].data);
        sheetref[1] = [
            {
                type: 2,
                data: $b8f343bf88dacc48$var$stru8(wsname)
            }
        ];
        drawables = $b8f343bf88dacc48$var$mappa(sheetref[2], $b8f343bf88dacc48$var$parse_TSP_Reference);
        docroot.messages[0].data = $b8f343bf88dacc48$var$write_shallow(sheetref);
    });
    var tia = $b8f343bf88dacc48$var$numbers_iwa_find(cfb, deps, drawables[0]);
    var tmaref = $b8f343bf88dacc48$var$parse_TSP_Reference($b8f343bf88dacc48$var$parse_shallow(tia.messages[0].data)[2][0].data);
    $b8f343bf88dacc48$var$numbers_iwa_doit(cfb, deps, tmaref, function(docroot, x) {
        return $b8f343bf88dacc48$var$write_numbers_tma(cfb, deps, ws, docroot, x, tmaref);
    });
}
var $b8f343bf88dacc48$var$USE_WIDE_ROWS = true;
function $b8f343bf88dacc48$var$write_numbers_tma(cfb, deps, ws, tmaroot, tmafile, tmaref) {
    if (!ws["!ref"]) throw new Error("Cannot export empty sheet to NUMBERS");
    var range = $b8f343bf88dacc48$var$decode_range(ws["!ref"]);
    range.s.r = range.s.c = 0;
    var trunc = false;
    if (range.e.c > 999) {
        trunc = true;
        range.e.c = 999;
    }
    if (range.e.r > 999999) {
        trunc = true;
        range.e.r = 999999;
    }
    if (trunc) console.error("Truncating to ".concat($b8f343bf88dacc48$var$encode_range(range)));
    var data = [];
    if (ws["!data"]) data = ws["!data"];
    else {
        var colstr = [];
        for(var _C = 0; _C <= range.e.c; ++_C)colstr[_C] = $b8f343bf88dacc48$var$encode_col(_C);
        for(var R_ = 0; R_ <= range.e.r; ++R_){
            data[R_] = [];
            var _R = "" + (R_ + 1);
            for(_C = 0; _C <= range.e.c; ++_C){
                var _cell = ws[colstr[_C] + _R];
                if (!_cell) continue;
                data[R_][_C] = _cell;
            }
        }
    }
    var LUT = {
        cmnt: [
            {
                a: "~54ee77S~",
                t: "... the people who are crazy enough to think they can change the world, are the ones who do."
            }
        ],
        ferr: [],
        fmla: [],
        nfmt: [],
        ofmt: [],
        rsst: [
            {
                v: "~54ee77S~",
                l: "https://sheetjs.com/"
            }
        ],
        sst: [
            "~Sh33tJ5~"
        ]
    };
    var pb = $b8f343bf88dacc48$var$parse_shallow(tmaroot.messages[0].data);
    pb[6][0].data = $b8f343bf88dacc48$var$write_varint49(range.e.r + 1);
    pb[7][0].data = $b8f343bf88dacc48$var$write_varint49(range.e.c + 1);
    delete pb[46];
    var store = $b8f343bf88dacc48$var$parse_shallow(pb[4][0].data);
    var row_header_ref = $b8f343bf88dacc48$var$parse_TSP_Reference($b8f343bf88dacc48$var$parse_shallow(store[1][0].data)[2][0].data);
    $b8f343bf88dacc48$var$numbers_iwa_doit(cfb, deps, row_header_ref, function(rowhead, _x) {
        var _a;
        var base_bucket = $b8f343bf88dacc48$var$parse_shallow(rowhead.messages[0].data);
        if ((_a = base_bucket == null ? void 0 : base_bucket[2]) == null ? void 0 : _a[0]) for(var R2 = 0; R2 < data.length; ++R2){
            var _bucket = $b8f343bf88dacc48$var$parse_shallow(base_bucket[2][0].data);
            _bucket[1][0].data = $b8f343bf88dacc48$var$write_varint49(R2);
            _bucket[4][0].data = $b8f343bf88dacc48$var$write_varint49(data[R2].length);
            base_bucket[2][R2] = {
                type: base_bucket[2][0].type,
                data: $b8f343bf88dacc48$var$write_shallow(_bucket)
            };
        }
        rowhead.messages[0].data = $b8f343bf88dacc48$var$write_shallow(base_bucket);
    });
    var col_header_ref = $b8f343bf88dacc48$var$parse_TSP_Reference(store[2][0].data);
    $b8f343bf88dacc48$var$numbers_iwa_doit(cfb, deps, col_header_ref, function(colhead, _x) {
        var base_bucket = $b8f343bf88dacc48$var$parse_shallow(colhead.messages[0].data);
        for(var C = 0; C <= range.e.c; ++C){
            var _bucket = $b8f343bf88dacc48$var$parse_shallow(base_bucket[2][0].data);
            _bucket[1][0].data = $b8f343bf88dacc48$var$write_varint49(C);
            _bucket[4][0].data = $b8f343bf88dacc48$var$write_varint49(range.e.r + 1);
            base_bucket[2][C] = {
                type: base_bucket[2][0].type,
                data: $b8f343bf88dacc48$var$write_shallow(_bucket)
            };
        }
        colhead.messages[0].data = $b8f343bf88dacc48$var$write_shallow(base_bucket);
    });
    var rbtree = $b8f343bf88dacc48$var$parse_shallow(store[9][0].data);
    rbtree[1] = [];
    var tilestore = $b8f343bf88dacc48$var$parse_shallow(store[3][0].data);
    var tstride = 256;
    tilestore[2] = [
        {
            type: 0,
            data: $b8f343bf88dacc48$var$write_varint49(tstride)
        }
    ];
    var tileref = $b8f343bf88dacc48$var$parse_TSP_Reference($b8f343bf88dacc48$var$parse_shallow(tilestore[1][0].data)[2][0].data);
    var save_token = function() {
        var metadata = $b8f343bf88dacc48$var$numbers_iwa_find(cfb, deps, 2);
        var mlist = $b8f343bf88dacc48$var$parse_shallow(metadata.messages[0].data);
        var mlst = mlist[3].filter(function(m) {
            return $b8f343bf88dacc48$var$varint_to_i32($b8f343bf88dacc48$var$parse_shallow(m.data)[1][0].data) == tileref;
        });
        return (mlst == null ? void 0 : mlst.length) ? $b8f343bf88dacc48$var$varint_to_i32($b8f343bf88dacc48$var$parse_shallow(mlst[0].data)[12][0].data) : 0;
    }();
    $b8f343bf88dacc48$export$9f0e51cd97c572a.utils.cfb_del(cfb, deps[tileref].location);
    $b8f343bf88dacc48$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
        var mlist = $b8f343bf88dacc48$var$parse_shallow(ai.messages[0].data);
        mlist[3] = mlist[3].filter(function(m) {
            return $b8f343bf88dacc48$var$varint_to_i32($b8f343bf88dacc48$var$parse_shallow(m.data)[1][0].data) != tileref;
        });
        $b8f343bf88dacc48$var$numbers_meta_del_dep(mlist, deps, tmaref, tileref);
        ai.messages[0].data = $b8f343bf88dacc48$var$write_shallow(mlist);
    });
    $b8f343bf88dacc48$var$numbers_del_oref(tmaroot, tileref);
    tilestore[1] = [];
    var ntiles = Math.ceil((range.e.r + 1) / tstride);
    for(var tidx = 0; tidx < ntiles; ++tidx){
        var newtileid = $b8f343bf88dacc48$var$get_unique_msgid({
            deps: [],
            location: "",
            type: 6002
        }, deps);
        deps[newtileid].location = "Root Entry/Index/Tables/Tile-".concat(newtileid, ".iwa");
        var tiledata = [
            [],
            [
                {
                    type: 0,
                    data: $b8f343bf88dacc48$var$write_varint49(0)
                }
            ],
            [
                {
                    type: 0,
                    data: $b8f343bf88dacc48$var$write_varint49(Math.min(range.e.r + 1, (tidx + 1) * tstride))
                }
            ],
            [
                {
                    type: 0,
                    data: $b8f343bf88dacc48$var$write_varint49(0)
                }
            ],
            [
                {
                    type: 0,
                    data: $b8f343bf88dacc48$var$write_varint49(Math.min((tidx + 1) * tstride, range.e.r + 1) - tidx * tstride)
                }
            ],
            [],
            [
                {
                    type: 0,
                    data: $b8f343bf88dacc48$var$write_varint49(5)
                }
            ],
            [
                {
                    type: 0,
                    data: $b8f343bf88dacc48$var$write_varint49(1)
                }
            ],
            [
                {
                    type: 0,
                    data: $b8f343bf88dacc48$var$write_varint49($b8f343bf88dacc48$var$USE_WIDE_ROWS ? 1 : 0)
                }
            ]
        ];
        for(var R = tidx * tstride; R <= Math.min(range.e.r, (tidx + 1) * tstride - 1); ++R){
            var tilerow = $b8f343bf88dacc48$var$write_TST_TileRowInfo(data[R], LUT, $b8f343bf88dacc48$var$USE_WIDE_ROWS);
            tilerow[1][0].data = $b8f343bf88dacc48$var$write_varint49(R - tidx * tstride);
            tiledata[5].push({
                data: $b8f343bf88dacc48$var$write_shallow(tilerow),
                type: 2
            });
        }
        tilestore[1].push({
            type: 2,
            data: $b8f343bf88dacc48$var$write_shallow([
                [],
                [
                    {
                        type: 0,
                        data: $b8f343bf88dacc48$var$write_varint49(tidx)
                    }
                ],
                [
                    {
                        type: 2,
                        data: $b8f343bf88dacc48$var$write_TSP_Reference(newtileid)
                    }
                ]
            ])
        });
        var newtile = {
            id: newtileid,
            messages: [
                $b8f343bf88dacc48$var$write_iwam(6002, $b8f343bf88dacc48$var$write_shallow(tiledata))
            ]
        };
        var tilecontent = $b8f343bf88dacc48$var$compress_iwa_file($b8f343bf88dacc48$var$write_iwa_file([
            newtile
        ]));
        $b8f343bf88dacc48$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/Index/Tables/Tile-".concat(newtileid, ".iwa"), tilecontent);
        $b8f343bf88dacc48$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
            var mlist = $b8f343bf88dacc48$var$parse_shallow(ai.messages[0].data);
            mlist[3].push({
                type: 2,
                data: $b8f343bf88dacc48$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $b8f343bf88dacc48$var$write_varint49(newtileid)
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $b8f343bf88dacc48$var$stru8("Tables/Tile")
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $b8f343bf88dacc48$var$stru8("Tables/Tile-".concat(newtileid))
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: new Uint8Array([
                                2,
                                0,
                                0
                            ])
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: new Uint8Array([
                                2,
                                0,
                                0
                            ])
                        }
                    ],
                    [],
                    [],
                    [],
                    [],
                    [
                        {
                            type: 0,
                            data: $b8f343bf88dacc48$var$write_varint49(0)
                        }
                    ],
                    [],
                    [
                        {
                            type: 0,
                            data: $b8f343bf88dacc48$var$write_varint49(save_token)
                        }
                    ]
                ])
            });
            mlist[1] = [
                {
                    type: 0,
                    data: $b8f343bf88dacc48$var$write_varint49(Math.max(newtileid + 1, $b8f343bf88dacc48$var$varint_to_i32(mlist[1][0].data)))
                }
            ];
            $b8f343bf88dacc48$var$numbers_meta_add_dep(mlist, deps, tmaref, newtileid);
            ai.messages[0].data = $b8f343bf88dacc48$var$write_shallow(mlist);
        });
        $b8f343bf88dacc48$var$numbers_add_oref(tmaroot, newtileid);
        rbtree[1].push({
            type: 2,
            data: $b8f343bf88dacc48$var$write_shallow([
                [],
                [
                    {
                        type: 0,
                        data: $b8f343bf88dacc48$var$write_varint49(tidx * tstride)
                    }
                ],
                [
                    {
                        type: 0,
                        data: $b8f343bf88dacc48$var$write_varint49(tidx)
                    }
                ]
            ])
        });
    }
    store[3][0].data = $b8f343bf88dacc48$var$write_shallow(tilestore);
    store[9][0].data = $b8f343bf88dacc48$var$write_shallow(rbtree);
    store[10] = [
        {
            type: 2,
            data: new Uint8Array([])
        }
    ];
    if (ws["!merges"]) {
        var mergeid = $b8f343bf88dacc48$var$get_unique_msgid({
            type: 6144,
            deps: [
                tmaref
            ],
            location: deps[tmaref].location
        }, deps);
        tmafile.push({
            id: mergeid,
            messages: [
                $b8f343bf88dacc48$var$write_iwam(6144, $b8f343bf88dacc48$var$write_shallow([
                    [],
                    ws["!merges"].map(function(m) {
                        return {
                            type: 2,
                            data: $b8f343bf88dacc48$var$write_shallow([
                                [],
                                [
                                    {
                                        type: 2,
                                        data: $b8f343bf88dacc48$var$write_shallow([
                                            [],
                                            [
                                                {
                                                    type: 5,
                                                    data: new Uint8Array(new Uint16Array([
                                                        m.s.r,
                                                        m.s.c
                                                    ]).buffer)
                                                }
                                            ]
                                        ])
                                    }
                                ],
                                [
                                    {
                                        type: 2,
                                        data: $b8f343bf88dacc48$var$write_shallow([
                                            [],
                                            [
                                                {
                                                    type: 5,
                                                    data: new Uint8Array(new Uint16Array([
                                                        m.e.r - m.s.r + 1,
                                                        m.e.c - m.s.c + 1
                                                    ]).buffer)
                                                }
                                            ]
                                        ])
                                    }
                                ]
                            ])
                        };
                    })
                ]))
            ]
        });
        store[13] = [
            {
                type: 2,
                data: $b8f343bf88dacc48$var$write_TSP_Reference(mergeid)
            }
        ];
        $b8f343bf88dacc48$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
            var mlist = $b8f343bf88dacc48$var$parse_shallow(ai.messages[0].data);
            $b8f343bf88dacc48$var$numbers_meta_add_dep(mlist, deps, tmaref, mergeid);
            ai.messages[0].data = $b8f343bf88dacc48$var$write_shallow(mlist);
        });
        $b8f343bf88dacc48$var$numbers_add_oref(tmaroot, mergeid);
    } else delete store[13];
    var sstref = $b8f343bf88dacc48$var$parse_TSP_Reference(store[4][0].data);
    $b8f343bf88dacc48$var$numbers_iwa_doit(cfb, deps, sstref, function(sstroot) {
        var sstdata = $b8f343bf88dacc48$var$parse_shallow(sstroot.messages[0].data);
        sstdata[3] = [];
        LUT.sst.forEach(function(str, i) {
            if (i == 0) return;
            sstdata[3].push({
                type: 2,
                data: $b8f343bf88dacc48$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $b8f343bf88dacc48$var$write_varint49(i)
                        }
                    ],
                    [
                        {
                            type: 0,
                            data: $b8f343bf88dacc48$var$write_varint49(1)
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $b8f343bf88dacc48$var$stru8(str)
                        }
                    ]
                ])
            });
        });
        sstroot.messages[0].data = $b8f343bf88dacc48$var$write_shallow(sstdata);
    });
    var rsstref = $b8f343bf88dacc48$var$parse_TSP_Reference(store[17][0].data);
    $b8f343bf88dacc48$var$numbers_iwa_doit(cfb, deps, rsstref, function(rsstroot) {
        var rsstdata = $b8f343bf88dacc48$var$parse_shallow(rsstroot.messages[0].data);
        rsstdata[3] = [];
        var style_indices = [
            904980,
            903835,
            903815,
            903845
        ];
        LUT.rsst.forEach(function(rsst, i) {
            if (i == 0) return;
            var tswpsa = [
                [],
                [
                    {
                        type: 0,
                        data: new Uint8Array([
                            5
                        ])
                    }
                ],
                [],
                [
                    {
                        type: 2,
                        data: $b8f343bf88dacc48$var$stru8(rsst.v)
                    }
                ]
            ];
            tswpsa[10] = [
                {
                    type: 0,
                    data: new Uint8Array([
                        1
                    ])
                }
            ];
            tswpsa[19] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        6,
                        8,
                        0,
                        18,
                        2,
                        101,
                        110
                    ])
                }
            ];
            tswpsa[5] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        8,
                        8,
                        0,
                        18,
                        4,
                        8,
                        155,
                        149,
                        55
                    ])
                }
            ];
            tswpsa[2] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        8,
                        148,
                        158,
                        55
                    ])
                }
            ];
            tswpsa[6] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        6,
                        8,
                        0,
                        16,
                        0,
                        24,
                        0
                    ])
                }
            ];
            tswpsa[7] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        8,
                        8,
                        0,
                        18,
                        4,
                        8,
                        135,
                        149,
                        55
                    ])
                }
            ];
            tswpsa[8] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        8,
                        8,
                        0,
                        18,
                        4,
                        8,
                        165,
                        149,
                        55
                    ])
                }
            ];
            tswpsa[14] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        6,
                        8,
                        0,
                        16,
                        0,
                        24,
                        0
                    ])
                }
            ];
            tswpsa[24] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        6,
                        8,
                        0,
                        16,
                        0,
                        24,
                        0
                    ])
                }
            ];
            var tswpsaid = $b8f343bf88dacc48$var$get_unique_msgid({
                deps: [],
                location: "",
                type: 2001
            }, deps);
            var tswpsarefs = [];
            if (rsst.l) {
                var newhlinkid = $b8f343bf88dacc48$var$numbers_add_msg(cfb, 2032, [
                    [],
                    [],
                    [
                        {
                            type: 2,
                            data: $b8f343bf88dacc48$var$stru8(rsst.l)
                        }
                    ]
                ], "/Index/Tables/DataList", deps);
                tswpsa[11] = [];
                var smartfield = [
                    [],
                    []
                ];
                if (!smartfield[1]) smartfield[1] = [];
                smartfield[1].push({
                    type: 2,
                    data: $b8f343bf88dacc48$var$write_shallow([
                        [],
                        [
                            {
                                type: 0,
                                data: $b8f343bf88dacc48$var$write_varint49(0)
                            }
                        ],
                        [
                            {
                                type: 2,
                                data: $b8f343bf88dacc48$var$write_TSP_Reference(newhlinkid)
                            }
                        ]
                    ])
                });
                tswpsa[11][0] = {
                    type: 2,
                    data: $b8f343bf88dacc48$var$write_shallow(smartfield)
                };
                tswpsarefs.push(newhlinkid);
            }
            $b8f343bf88dacc48$var$numbers_add_msg(cfb, 2001, tswpsa, "/Index/Tables/DataList", deps, tswpsaid);
            $b8f343bf88dacc48$var$numbers_iwa_doit(cfb, deps, tswpsaid, function(iwa) {
                style_indices.forEach(function(ref) {
                    return $b8f343bf88dacc48$var$numbers_add_oref(iwa, ref);
                });
                tswpsarefs.forEach(function(ref) {
                    return $b8f343bf88dacc48$var$numbers_add_oref(iwa, ref);
                });
            });
            var rtpaid = $b8f343bf88dacc48$var$numbers_add_msg(cfb, 6218, [
                [],
                [
                    {
                        type: 2,
                        data: $b8f343bf88dacc48$var$write_TSP_Reference(tswpsaid)
                    }
                ],
                [],
                [
                    {
                        type: 2,
                        data: new Uint8Array([
                            13,
                            255,
                            255,
                            255,
                            0,
                            18,
                            10,
                            16,
                            255,
                            255,
                            1,
                            24,
                            255,
                            255,
                            255,
                            255,
                            7
                        ])
                    }
                ]
            ], "/Index/Tables/DataList", deps);
            $b8f343bf88dacc48$var$numbers_iwa_doit(cfb, deps, rtpaid, function(iwa) {
                return $b8f343bf88dacc48$var$numbers_add_oref(iwa, tswpsaid);
            });
            rsstdata[3].push({
                type: 2,
                data: $b8f343bf88dacc48$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $b8f343bf88dacc48$var$write_varint49(i)
                        }
                    ],
                    [
                        {
                            type: 0,
                            data: $b8f343bf88dacc48$var$write_varint49(1)
                        }
                    ],
                    [],
                    [],
                    [],
                    [],
                    [],
                    [],
                    [
                        {
                            type: 2,
                            data: $b8f343bf88dacc48$var$write_TSP_Reference(rtpaid)
                        }
                    ]
                ])
            });
            $b8f343bf88dacc48$var$numbers_add_oref(rsstroot, rtpaid);
            $b8f343bf88dacc48$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                var mlist = $b8f343bf88dacc48$var$parse_shallow(ai.messages[0].data);
                $b8f343bf88dacc48$var$numbers_meta_add_dep(mlist, deps, rsstref, rtpaid);
                $b8f343bf88dacc48$var$numbers_meta_add_dep(mlist, deps, rtpaid, tswpsaid);
                $b8f343bf88dacc48$var$numbers_meta_add_dep(mlist, deps, tswpsaid, tswpsarefs);
                $b8f343bf88dacc48$var$numbers_meta_add_dep(mlist, deps, tswpsaid, style_indices);
                ai.messages[0].data = $b8f343bf88dacc48$var$write_shallow(mlist);
            });
        });
        rsstroot.messages[0].data = $b8f343bf88dacc48$var$write_shallow(rsstdata);
    });
    if (LUT.cmnt.length > 1) {
        var cmntref = $b8f343bf88dacc48$var$parse_TSP_Reference(store[19][0].data);
        var authors = {}, iauthor = 0;
        $b8f343bf88dacc48$var$numbers_iwa_doit(cfb, deps, cmntref, function(cmntroot) {
            var cmntdata = $b8f343bf88dacc48$var$parse_shallow(cmntroot.messages[0].data);
            cmntdata[3] = [];
            LUT.cmnt.forEach(function(cc, i) {
                if (i == 0) return;
                var replies = [];
                if (cc.replies) cc.replies.forEach(function(c) {
                    if (!authors[c.a || ""]) authors[c.a || ""] = $b8f343bf88dacc48$var$numbers_add_msg(cfb, 212, [
                        [],
                        [
                            {
                                type: 2,
                                data: $b8f343bf88dacc48$var$stru8(c.a || "")
                            }
                        ],
                        [
                            {
                                type: 2,
                                data: $b8f343bf88dacc48$var$get_author_color(++iauthor)
                            }
                        ],
                        [],
                        [
                            {
                                type: 0,
                                data: $b8f343bf88dacc48$var$write_varint49(0)
                            }
                        ]
                    ], "/Index/Tables/DataList", deps);
                    var aaaid2 = authors[c.a || ""];
                    var csaid2 = $b8f343bf88dacc48$var$numbers_add_msg(cfb, 3056, [
                        [],
                        [
                            {
                                type: 2,
                                data: $b8f343bf88dacc48$var$stru8(c.t || "")
                            }
                        ],
                        [
                            {
                                type: 2,
                                data: $b8f343bf88dacc48$var$write_shallow([
                                    [],
                                    [
                                        {
                                            type: 1,
                                            data: new Uint8Array([
                                                0,
                                                0,
                                                0,
                                                128,
                                                116,
                                                109,
                                                182,
                                                65
                                            ])
                                        }
                                    ]
                                ])
                            }
                        ],
                        [
                            {
                                type: 2,
                                data: $b8f343bf88dacc48$var$write_TSP_Reference(aaaid2)
                            }
                        ]
                    ], "/Index/Tables/DataList", deps);
                    $b8f343bf88dacc48$var$numbers_iwa_doit(cfb, deps, csaid2, function(iwa) {
                        return $b8f343bf88dacc48$var$numbers_add_oref(iwa, aaaid2);
                    });
                    replies.push(csaid2);
                    $b8f343bf88dacc48$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                        var mlist = $b8f343bf88dacc48$var$parse_shallow(ai.messages[0].data);
                        $b8f343bf88dacc48$var$numbers_meta_add_dep(mlist, deps, csaid2, aaaid2);
                        ai.messages[0].data = $b8f343bf88dacc48$var$write_shallow(mlist);
                    });
                });
                if (!authors[cc.a || ""]) authors[cc.a || ""] = $b8f343bf88dacc48$var$numbers_add_msg(cfb, 212, [
                    [],
                    [
                        {
                            type: 2,
                            data: $b8f343bf88dacc48$var$stru8(cc.a || "")
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $b8f343bf88dacc48$var$get_author_color(++iauthor)
                        }
                    ],
                    [],
                    [
                        {
                            type: 0,
                            data: $b8f343bf88dacc48$var$write_varint49(0)
                        }
                    ]
                ], "/Index/Tables/DataList", deps);
                var aaaid = authors[cc.a || ""];
                var csaid = $b8f343bf88dacc48$var$numbers_add_msg(cfb, 3056, [
                    [],
                    [
                        {
                            type: 2,
                            data: $b8f343bf88dacc48$var$stru8(cc.t || "")
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $b8f343bf88dacc48$var$write_shallow([
                                [],
                                [
                                    {
                                        type: 1,
                                        data: new Uint8Array([
                                            0,
                                            0,
                                            0,
                                            128,
                                            116,
                                            109,
                                            182,
                                            65
                                        ])
                                    }
                                ]
                            ])
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $b8f343bf88dacc48$var$write_TSP_Reference(aaaid)
                        }
                    ],
                    replies.map(function(r) {
                        return {
                            type: 2,
                            data: $b8f343bf88dacc48$var$write_TSP_Reference(r)
                        };
                    }),
                    [
                        {
                            type: 2,
                            data: $b8f343bf88dacc48$var$write_shallow([
                                [],
                                [
                                    {
                                        type: 0,
                                        data: $b8f343bf88dacc48$var$write_varint49(i)
                                    }
                                ],
                                [
                                    {
                                        type: 0,
                                        data: $b8f343bf88dacc48$var$write_varint49(0)
                                    }
                                ]
                            ])
                        }
                    ]
                ], "/Index/Tables/DataList", deps);
                $b8f343bf88dacc48$var$numbers_iwa_doit(cfb, deps, csaid, function(iwa) {
                    $b8f343bf88dacc48$var$numbers_add_oref(iwa, aaaid);
                    replies.forEach(function(r) {
                        return $b8f343bf88dacc48$var$numbers_add_oref(iwa, r);
                    });
                });
                cmntdata[3].push({
                    type: 2,
                    data: $b8f343bf88dacc48$var$write_shallow([
                        [],
                        [
                            {
                                type: 0,
                                data: $b8f343bf88dacc48$var$write_varint49(i)
                            }
                        ],
                        [
                            {
                                type: 0,
                                data: $b8f343bf88dacc48$var$write_varint49(1)
                            }
                        ],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [
                            {
                                type: 2,
                                data: $b8f343bf88dacc48$var$write_TSP_Reference(csaid)
                            }
                        ]
                    ])
                });
                $b8f343bf88dacc48$var$numbers_add_oref(cmntroot, csaid);
                $b8f343bf88dacc48$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $b8f343bf88dacc48$var$parse_shallow(ai.messages[0].data);
                    $b8f343bf88dacc48$var$numbers_meta_add_dep(mlist, deps, cmntref, csaid);
                    $b8f343bf88dacc48$var$numbers_meta_add_dep(mlist, deps, csaid, aaaid);
                    if (replies.length) $b8f343bf88dacc48$var$numbers_meta_add_dep(mlist, deps, csaid, replies);
                    ai.messages[0].data = $b8f343bf88dacc48$var$write_shallow(mlist);
                });
            });
            cmntdata[2][0].data = $b8f343bf88dacc48$var$write_varint49(LUT.cmnt.length + 1);
            cmntroot.messages[0].data = $b8f343bf88dacc48$var$write_shallow(cmntdata);
        });
    }
    pb[4][0].data = $b8f343bf88dacc48$var$write_shallow(store);
    tmaroot.messages[0].data = $b8f343bf88dacc48$var$write_shallow(pb);
}
function $b8f343bf88dacc48$var$fix_opts_func(defaults /*:Array<Array<any> >*/ ) /*:{(o:any):void}*/ {
    return function fix_opts(opts) {
        for(var i = 0; i != defaults.length; ++i){
            var d = defaults[i];
            if (opts[d[0]] === undefined) opts[d[0]] = d[1];
            if (d[2] === 'n') opts[d[0]] = Number(opts[d[0]]);
        }
    };
}
function $b8f343bf88dacc48$var$fix_read_opts(opts) {
    $b8f343bf88dacc48$var$fix_opts_func([
        [
            'cellNF',
            false
        ],
        /* emit cell number format string as .z */ [
            'cellHTML',
            true
        ],
        /* emit html string as .h */ [
            'cellFormula',
            true
        ],
        /* emit formulae as .f */ [
            'cellStyles',
            false
        ],
        /* emits style/theme as .s */ [
            'cellText',
            true
        ],
        /* emit formatted text as .w */ [
            'cellDates',
            false
        ],
        /* emit date cells with type `d` */ [
            'sheetStubs',
            false
        ],
        /* emit empty cells */ [
            'sheetRows',
            0,
            'n'
        ],
        /* read n rows (0 = read all rows) */ [
            'bookDeps',
            false
        ],
        /* parse calculation chains */ [
            'bookSheets',
            false
        ],
        /* only try to get sheet names (no Sheets) */ [
            'bookProps',
            false
        ],
        /* only try to get properties (no Sheets) */ [
            'bookFiles',
            false
        ],
        /* include raw file structure (keys, files, cfb) */ [
            'bookVBA',
            false
        ],
        /* include vba raw data (vbaraw) */ [
            'password',
            ''
        ],
        /* password */ [
            'WTF',
            false
        ]
    ])(opts);
}
function $b8f343bf88dacc48$var$fix_write_opts(opts) {
    $b8f343bf88dacc48$var$fix_opts_func([
        [
            'cellDates',
            false
        ],
        /* write date cells with type `d` */ [
            'bookSST',
            false
        ],
        /* Generate Shared String Table */ [
            'bookType',
            'xlsx'
        ],
        /* Type of workbook (xlsx/m/b) */ [
            'compression',
            false
        ],
        /* Use file compression */ [
            'WTF',
            false
        ]
    ])(opts);
}
function $b8f343bf88dacc48$var$get_sheet_type(n /*:string*/ ) /*:string*/ {
    if ($b8f343bf88dacc48$var$RELS.WS.indexOf(n) > -1) return "sheet";
    if ($b8f343bf88dacc48$var$RELS.CS && n == $b8f343bf88dacc48$var$RELS.CS) return "chart";
    if ($b8f343bf88dacc48$var$RELS.DS && n == $b8f343bf88dacc48$var$RELS.DS) return "dialog";
    if ($b8f343bf88dacc48$var$RELS.MS && n == $b8f343bf88dacc48$var$RELS.MS) return "macro";
    return n && n.length ? n : "sheet";
}
function $b8f343bf88dacc48$var$safe_parse_wbrels(wbrels, sheets) {
    if (!wbrels) return 0;
    try {
        wbrels = sheets.map(function pwbr(w) {
            if (!w.id) w.id = w.strRelID;
            return [
                w.name,
                wbrels['!id'][w.id].Target,
                $b8f343bf88dacc48$var$get_sheet_type(wbrels['!id'][w.id].Type)
            ];
        });
    } catch (e) {
        return null;
    }
    return !wbrels || wbrels.length === 0 ? null : wbrels;
}
function $b8f343bf88dacc48$var$parse_sheet_legacy_drawing(sheet, type, zip, path, idx, opts, wb, comments) {
    if (!sheet || !sheet['!legdrawel']) return;
    var dfile = $b8f343bf88dacc48$var$resolve_path(sheet['!legdrawel'].Target, path);
    var draw = $b8f343bf88dacc48$var$getzipstr(zip, dfile, true);
    if (draw) $b8f343bf88dacc48$var$parse_vml($b8f343bf88dacc48$var$utf8read(draw), sheet, comments || []);
}
function $b8f343bf88dacc48$var$safe_parse_sheet(zip, path /*:string*/ , relsPath /*:string*/ , sheet, idx /*:number*/ , sheetRels, sheets, stype /*:string*/ , opts, wb, themes, styles) {
    try {
        sheetRels[sheet] = $b8f343bf88dacc48$var$parse_rels($b8f343bf88dacc48$var$getzipstr(zip, relsPath, true), path);
        var data = $b8f343bf88dacc48$var$getzipdata(zip, path);
        var _ws;
        switch(stype){
            case 'sheet':
                _ws = $b8f343bf88dacc48$var$parse_ws(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            case 'chart':
                _ws = $b8f343bf88dacc48$var$parse_cs(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                if (!_ws || !_ws['!drawel']) break;
                var dfile = $b8f343bf88dacc48$var$resolve_path(_ws['!drawel'].Target, path);
                var drelsp = $b8f343bf88dacc48$var$get_rels_path(dfile);
                var draw = $b8f343bf88dacc48$var$parse_drawing($b8f343bf88dacc48$var$getzipstr(zip, dfile, true), $b8f343bf88dacc48$var$parse_rels($b8f343bf88dacc48$var$getzipstr(zip, drelsp, true), dfile));
                var chartp = $b8f343bf88dacc48$var$resolve_path(draw, dfile);
                var crelsp = $b8f343bf88dacc48$var$get_rels_path(chartp);
                _ws = $b8f343bf88dacc48$var$parse_chart($b8f343bf88dacc48$var$getzipstr(zip, chartp, true), chartp, opts, $b8f343bf88dacc48$var$parse_rels($b8f343bf88dacc48$var$getzipstr(zip, crelsp, true), chartp), wb, _ws);
                break;
            case 'macro':
                _ws = $b8f343bf88dacc48$var$parse_ms(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            case 'dialog':
                _ws = $b8f343bf88dacc48$var$parse_ds(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            default:
                throw new Error("Unrecognized sheet type " + stype);
        }
        sheets[sheet] = _ws;
        /* scan rels for comments and threaded comments */ var comments = [], tcomments = [];
        if (sheetRels && sheetRels[sheet]) $b8f343bf88dacc48$var$keys(sheetRels[sheet]).forEach(function(n) {
            var dfile = "";
            if (sheetRels[sheet][n].Type == $b8f343bf88dacc48$var$RELS.CMNT) {
                dfile = $b8f343bf88dacc48$var$resolve_path(sheetRels[sheet][n].Target, path);
                comments = $b8f343bf88dacc48$var$parse_cmnt($b8f343bf88dacc48$var$getzipdata(zip, dfile, true), dfile, opts);
                if (!comments || !comments.length) return;
                $b8f343bf88dacc48$var$sheet_insert_comments(_ws, comments, false);
            }
            if (sheetRels[sheet][n].Type == $b8f343bf88dacc48$var$RELS.TCMNT) {
                dfile = $b8f343bf88dacc48$var$resolve_path(sheetRels[sheet][n].Target, path);
                tcomments = tcomments.concat($b8f343bf88dacc48$var$parse_tcmnt_xml($b8f343bf88dacc48$var$getzipdata(zip, dfile, true), opts));
            }
        });
        if (tcomments && tcomments.length) $b8f343bf88dacc48$var$sheet_insert_comments(_ws, tcomments, true, opts.people || []);
        $b8f343bf88dacc48$var$parse_sheet_legacy_drawing(_ws, stype, zip, path, idx, opts, wb, comments);
    } catch (e) {
        if (opts.WTF) throw e;
    }
}
function $b8f343bf88dacc48$var$strip_front_slash(x /*:string*/ ) /*:string*/ {
    return x.charAt(0) == '/' ? x.slice(1) : x;
}
function $b8f343bf88dacc48$export$b165387946f79a1(zip /*:ZIP*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    $b8f343bf88dacc48$var$make_ssf();
    opts = opts || {};
    $b8f343bf88dacc48$var$fix_read_opts(opts);
    /* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */ if ($b8f343bf88dacc48$var$safegetzipfile(zip, 'META-INF/manifest.xml')) return $b8f343bf88dacc48$var$parse_ods(zip, opts);
    /* UOC */ if ($b8f343bf88dacc48$var$safegetzipfile(zip, 'objectdata.xml')) return $b8f343bf88dacc48$var$parse_ods(zip, opts);
    /* Numbers */ if ($b8f343bf88dacc48$var$safegetzipfile(zip, 'Index/Document.iwa')) {
        if (typeof Uint8Array == "undefined") throw new Error('NUMBERS file parsing requires Uint8Array support');
        if (typeof $b8f343bf88dacc48$var$parse_numbers_iwa != "undefined") {
            if (zip.FileIndex) return $b8f343bf88dacc48$var$parse_numbers_iwa(zip, opts);
            var _zip = $b8f343bf88dacc48$export$9f0e51cd97c572a.utils.cfb_new();
            $b8f343bf88dacc48$var$zipentries(zip).forEach(function(e) {
                $b8f343bf88dacc48$var$zip_add_file(_zip, e, $b8f343bf88dacc48$var$getzipbin(zip, e));
            });
            return $b8f343bf88dacc48$var$parse_numbers_iwa(_zip, opts);
        }
        throw new Error('Unsupported NUMBERS file');
    }
    if (!$b8f343bf88dacc48$var$safegetzipfile(zip, '[Content_Types].xml')) {
        if ($b8f343bf88dacc48$var$safegetzipfile(zip, 'index.xml.gz')) throw new Error('Unsupported NUMBERS 08 file');
        if ($b8f343bf88dacc48$var$safegetzipfile(zip, 'index.xml')) throw new Error('Unsupported NUMBERS 09 file');
        var index_zip = $b8f343bf88dacc48$export$9f0e51cd97c572a.find(zip, 'Index.zip');
        if (index_zip) {
            opts = $b8f343bf88dacc48$var$dup(opts);
            delete opts.type;
            if (typeof index_zip.content == "string") opts.type = "binary";
            // TODO: Bun buffer bug
            if (typeof Bun !== "undefined" && $b8f343bf88dacc48$require$Buffer.isBuffer(index_zip.content)) return $b8f343bf88dacc48$export$aafa59e2e03f2942(new Uint8Array(index_zip.content), opts);
            return $b8f343bf88dacc48$export$aafa59e2e03f2942(index_zip.content, opts);
        }
        throw new Error('Unsupported ZIP file');
    }
    var entries = $b8f343bf88dacc48$var$zipentries(zip);
    var dir = $b8f343bf88dacc48$var$parse_ct($b8f343bf88dacc48$var$getzipstr(zip, '[Content_Types].xml'));
    var xlsb = false;
    var sheets, binname;
    if (dir.workbooks.length === 0) {
        binname = "xl/workbook.xml";
        if ($b8f343bf88dacc48$var$getzipdata(zip, binname, true)) dir.workbooks.push(binname);
    }
    if (dir.workbooks.length === 0) {
        binname = "xl/workbook.bin";
        if (!$b8f343bf88dacc48$var$getzipdata(zip, binname, true)) throw new Error("Could not find workbook");
        dir.workbooks.push(binname);
        xlsb = true;
    }
    if (dir.workbooks[0].slice(-3) == "bin") xlsb = true;
    var themes = {} /*:any*/ ;
    var styles = {} /*:any*/ ;
    if (!opts.bookSheets && !opts.bookProps) {
        $b8f343bf88dacc48$var$strs = [];
        if (dir.sst) try {
            $b8f343bf88dacc48$var$strs = $b8f343bf88dacc48$var$parse_sst($b8f343bf88dacc48$var$getzipdata(zip, $b8f343bf88dacc48$var$strip_front_slash(dir.sst)), dir.sst, opts);
        } catch (e) {
            if (opts.WTF) throw e;
        }
        if (opts.cellStyles && dir.themes.length) themes = $b8f343bf88dacc48$var$parse_theme_xml($b8f343bf88dacc48$var$getzipstr(zip, dir.themes[0].replace(/^\//, ''), true) || "", opts);
        if (dir.style) styles = $b8f343bf88dacc48$var$parse_sty($b8f343bf88dacc48$var$getzipdata(zip, $b8f343bf88dacc48$var$strip_front_slash(dir.style)), dir.style, themes, opts);
    }
    /*var externbooks = */ dir.links.map(function(link) {
        try {
            var rels = $b8f343bf88dacc48$var$parse_rels($b8f343bf88dacc48$var$getzipstr(zip, $b8f343bf88dacc48$var$get_rels_path($b8f343bf88dacc48$var$strip_front_slash(link))), link);
            return $b8f343bf88dacc48$var$parse_xlink($b8f343bf88dacc48$var$getzipdata(zip, $b8f343bf88dacc48$var$strip_front_slash(link)), rels, link, opts);
        } catch (e) {}
    });
    var wb = $b8f343bf88dacc48$var$parse_wb($b8f343bf88dacc48$var$getzipdata(zip, $b8f343bf88dacc48$var$strip_front_slash(dir.workbooks[0])), dir.workbooks[0], opts);
    var props = {}, propdata = "";
    if (dir.coreprops.length) {
        propdata = $b8f343bf88dacc48$var$getzipdata(zip, $b8f343bf88dacc48$var$strip_front_slash(dir.coreprops[0]), true);
        if (propdata) props = $b8f343bf88dacc48$var$parse_core_props(propdata);
        if (dir.extprops.length !== 0) {
            propdata = $b8f343bf88dacc48$var$getzipdata(zip, $b8f343bf88dacc48$var$strip_front_slash(dir.extprops[0]), true);
            if (propdata) $b8f343bf88dacc48$var$parse_ext_props(propdata, props, opts);
        }
    }
    var custprops = {};
    if (!opts.bookSheets || opts.bookProps) {
        if (dir.custprops.length !== 0) {
            propdata = $b8f343bf88dacc48$var$getzipstr(zip, $b8f343bf88dacc48$var$strip_front_slash(dir.custprops[0]), true);
            if (propdata) custprops = $b8f343bf88dacc48$var$parse_cust_props(propdata, opts);
        }
    }
    var out = {} /*:any*/ ;
    if (opts.bookSheets || opts.bookProps) {
        if (wb.Sheets) sheets = wb.Sheets.map(function pluck(x) {
            return x.name;
        });
        else if (props.Worksheets && props.SheetNames.length > 0) sheets = props.SheetNames;
        if (opts.bookProps) {
            out.Props = props;
            out.Custprops = custprops;
        }
        if (opts.bookSheets && typeof sheets !== 'undefined') out.SheetNames = sheets;
        if (opts.bookSheets ? out.SheetNames : opts.bookProps) return out;
    }
    sheets = {};
    var deps = {};
    if (opts.bookDeps && dir.calcchain) deps = $b8f343bf88dacc48$var$parse_cc($b8f343bf88dacc48$var$getzipdata(zip, $b8f343bf88dacc48$var$strip_front_slash(dir.calcchain)), dir.calcchain, opts);
    var i = 0;
    var sheetRels = {} /*:any*/ ;
    var path, relsPath;
    var wbsheets = wb.Sheets;
    props.Worksheets = wbsheets.length;
    props.SheetNames = [];
    for(var j = 0; j != wbsheets.length; ++j)props.SheetNames[j] = wbsheets[j].name;
    var wbext = xlsb ? "bin" : "xml";
    var wbrelsi = dir.workbooks[0].lastIndexOf("/");
    var wbrelsfile = (dir.workbooks[0].slice(0, wbrelsi + 1) + "_rels/" + dir.workbooks[0].slice(wbrelsi + 1) + ".rels").replace(/^\//, "");
    if (!$b8f343bf88dacc48$var$safegetzipfile(zip, wbrelsfile)) wbrelsfile = 'xl/_rels/workbook.' + wbext + '.rels';
    var wbrels = $b8f343bf88dacc48$var$parse_rels($b8f343bf88dacc48$var$getzipstr(zip, wbrelsfile, true), wbrelsfile.replace(/_rels.*/, "s5s"));
    if ((dir.metadata || []).length >= 1) /* TODO: MDX and other types of metadata */ opts.xlmeta = $b8f343bf88dacc48$var$parse_xlmeta($b8f343bf88dacc48$var$getzipdata(zip, $b8f343bf88dacc48$var$strip_front_slash(dir.metadata[0])), dir.metadata[0], opts);
    if ((dir.people || []).length >= 1) opts.people = $b8f343bf88dacc48$var$parse_people_xml($b8f343bf88dacc48$var$getzipdata(zip, $b8f343bf88dacc48$var$strip_front_slash(dir.people[0])), opts);
    if (wbrels) wbrels = $b8f343bf88dacc48$var$safe_parse_wbrels(wbrels, wb.Sheets);
    /* Numbers iOS hack */ var nmode = $b8f343bf88dacc48$var$getzipdata(zip, "xl/worksheets/sheet.xml", true) ? 1 : 0;
    wsloop: for(i = 0; i != props.Worksheets; ++i){
        var stype = "sheet";
        if (wbrels && wbrels[i]) {
            path = 'xl/' + wbrels[i][1].replace(/[\/]?xl\//, "");
            if (!$b8f343bf88dacc48$var$safegetzipfile(zip, path)) path = wbrels[i][1];
            if (!$b8f343bf88dacc48$var$safegetzipfile(zip, path)) path = wbrelsfile.replace(/_rels\/[\S\s]*$/, "") + wbrels[i][1];
            stype = wbrels[i][2];
        } else {
            path = 'xl/worksheets/sheet' + (i + 1 - nmode) + "." + wbext;
            path = path.replace(/sheet0\./, "sheet.");
        }
        relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
        if (opts && opts.sheets != null) switch(typeof opts.sheets){
            case "number":
                if (i != opts.sheets) continue wsloop;
                break;
            case "string":
                if (props.SheetNames[i].toLowerCase() != opts.sheets.toLowerCase()) continue wsloop;
                break;
            default:
                if (Array.isArray && Array.isArray(opts.sheets)) {
                    var snjseen = false;
                    for(var snj = 0; snj != opts.sheets.length; ++snj){
                        if (typeof opts.sheets[snj] == "number" && opts.sheets[snj] == i) snjseen = 1;
                        if (typeof opts.sheets[snj] == "string" && opts.sheets[snj].toLowerCase() == props.SheetNames[i].toLowerCase()) snjseen = 1;
                    }
                    if (!snjseen) continue wsloop;
                }
        }
        $b8f343bf88dacc48$var$safe_parse_sheet(zip, path, relsPath, props.SheetNames[i], i, sheetRels, sheets, stype, opts, wb, themes, styles);
    }
    out = {
        Directory: dir,
        Workbook: wb,
        Props: props,
        Custprops: custprops,
        Deps: deps,
        Sheets: sheets,
        SheetNames: props.SheetNames,
        Strings: $b8f343bf88dacc48$var$strs,
        Styles: styles,
        Themes: themes,
        SSF: $b8f343bf88dacc48$var$dup($b8f343bf88dacc48$var$table_fmt)
    } /*:any*/ ;
    if (opts && opts.bookFiles) {
        if (zip.files) {
            out.keys = entries;
            out.files = zip.files;
        } else {
            out.keys = [];
            out.files = {};
            zip.FullPaths.forEach(function(p, idx) {
                p = p.replace(/^Root Entry[\/]/, "");
                out.keys.push(p);
                out.files[p] = zip.FileIndex[idx];
            });
        }
    }
    if (opts && opts.bookVBA) {
        if (dir.vba.length > 0) out.vbaraw = $b8f343bf88dacc48$var$getzipdata(zip, $b8f343bf88dacc48$var$strip_front_slash(dir.vba[0]), true);
        else if (dir.defaults && dir.defaults.bin === $b8f343bf88dacc48$var$CT_VBA) out.vbaraw = $b8f343bf88dacc48$var$getzipdata(zip, 'xl/vbaProject.bin', true);
    }
    // TODO: pass back content types metadata for xlsm/xlsx resolution
    out.bookType = xlsb ? "xlsb" : "xlsx";
    return out;
}
/* [MS-OFFCRYPTO] 2.1.1 */ function $b8f343bf88dacc48$var$parse_xlsxcfb(cfb, _opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var opts = _opts || {};
    var f = 'Workbook', data = $b8f343bf88dacc48$export$9f0e51cd97c572a.find(cfb, f);
    try {
        f = '/!DataSpaces/Version';
        data = $b8f343bf88dacc48$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        /*var version = */ $b8f343bf88dacc48$var$parse_DataSpaceVersionInfo(data.content);
        /* 2.3.4.1 */ f = '/!DataSpaces/DataSpaceMap';
        data = $b8f343bf88dacc48$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        var dsm = $b8f343bf88dacc48$var$parse_DataSpaceMap(data.content);
        if (dsm.length !== 1 || dsm[0].comps.length !== 1 || dsm[0].comps[0].t !== 0 || dsm[0].name !== "StrongEncryptionDataSpace" || dsm[0].comps[0].v !== "EncryptedPackage") throw new Error("ECMA-376 Encrypted file bad " + f);
        /* 2.3.4.2 */ f = '/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace';
        data = $b8f343bf88dacc48$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        var seds = $b8f343bf88dacc48$var$parse_DataSpaceDefinition(data.content);
        if (seds.length != 1 || seds[0] != "StrongEncryptionTransform") throw new Error("ECMA-376 Encrypted file bad " + f);
        /* 2.3.4.3 */ f = '/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary';
        data = $b8f343bf88dacc48$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        /*var hdr = */ $b8f343bf88dacc48$var$parse_Primary(data.content);
    } catch (e) {}
    f = '/EncryptionInfo';
    data = $b8f343bf88dacc48$export$9f0e51cd97c572a.find(cfb, f);
    if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
    var einfo = $b8f343bf88dacc48$var$parse_EncryptionInfo(data.content);
    /* 2.3.4.4 */ f = '/EncryptedPackage';
    data = $b8f343bf88dacc48$export$9f0e51cd97c572a.find(cfb, f);
    if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
    /*global decrypt_agile */ /*:: declare var decrypt_agile:any; */ if (einfo[0] == 0x04 && typeof decrypt_agile !== 'undefined') return decrypt_agile(einfo[1], data.content, opts.password || "", opts);
    /*global decrypt_std76 */ /*:: declare var decrypt_std76:any; */ if (einfo[0] == 0x02 && typeof decrypt_std76 !== 'undefined') return decrypt_std76(einfo[1], data.content, opts.password || "", opts);
    throw new Error("File is password-protected");
}
function $b8f343bf88dacc48$var$write_zip_xlsb(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    if (wb && !wb.SSF) wb.SSF = $b8f343bf88dacc48$var$dup($b8f343bf88dacc48$var$table_fmt);
    if (wb && wb.SSF) {
        $b8f343bf88dacc48$var$make_ssf();
        $b8f343bf88dacc48$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $b8f343bf88dacc48$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
    }
    opts.rels = {};
    opts.wbrels = {};
    opts.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    opts.Strings.Count = 0;
    opts.Strings.Unique = 0;
    if ($b8f343bf88dacc48$var$browser_has_Map) opts.revStrings = new Map();
    else {
        opts.revStrings = {};
        opts.revStrings.foo = [];
        delete opts.revStrings.foo;
    }
    var wbext = "bin";
    var vbafmt = true;
    var ct = $b8f343bf88dacc48$var$new_ct();
    $b8f343bf88dacc48$var$fix_write_opts(opts = opts || {});
    var zip = $b8f343bf88dacc48$var$zip_new();
    var f = "", rId = 0;
    opts.cellXfs = [];
    $b8f343bf88dacc48$var$get_cell_style(opts.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    f = "docProps/core.xml";
    $b8f343bf88dacc48$var$zip_add_file(zip, f, $b8f343bf88dacc48$var$write_core_props(wb.Props, opts));
    ct.coreprops.push(f);
    $b8f343bf88dacc48$var$add_rels(opts.rels, 2, f, $b8f343bf88dacc48$var$RELS.CORE_PROPS);
    /*::if(!wb.Props) throw "unreachable"; */ f = "docProps/app.xml";
    if (wb.Props && wb.Props.SheetNames) ;
    else if (!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
    else {
        var _sn = [];
        for(var _i = 0; _i < wb.SheetNames.length; ++_i)if ((wb.Workbook.Sheets[_i] || {}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
        wb.Props.SheetNames = _sn;
    }
    wb.Props.Worksheets = wb.Props.SheetNames.length;
    $b8f343bf88dacc48$var$zip_add_file(zip, f, $b8f343bf88dacc48$var$write_ext_props(wb.Props, opts));
    ct.extprops.push(f);
    $b8f343bf88dacc48$var$add_rels(opts.rels, 3, f, $b8f343bf88dacc48$var$RELS.EXT_PROPS);
    if (wb.Custprops !== wb.Props && $b8f343bf88dacc48$var$keys(wb.Custprops || {}).length > 0) {
        f = "docProps/custom.xml";
        $b8f343bf88dacc48$var$zip_add_file(zip, f, $b8f343bf88dacc48$var$write_cust_props(wb.Custprops, opts));
        ct.custprops.push(f);
        $b8f343bf88dacc48$var$add_rels(opts.rels, 4, f, $b8f343bf88dacc48$var$RELS.CUST_PROPS);
    }
    var people = [
        "SheetJ5"
    ];
    opts.tcid = 0;
    for(rId = 1; rId <= wb.SheetNames.length; ++rId){
        var wsrels = {
            '!id': {}
        };
        var ws = wb.Sheets[wb.SheetNames[rId - 1]];
        var _type = (ws || {})["!type"] || "sheet";
        _type;
        f = "xl/worksheets/sheet" + rId + "." + wbext;
        $b8f343bf88dacc48$var$zip_add_file(zip, f, $b8f343bf88dacc48$var$write_ws_bin(rId - 1, opts, wb, wsrels));
        ct.sheets.push(f);
        $b8f343bf88dacc48$var$add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, $b8f343bf88dacc48$var$RELS.WS[0]);
        if (ws) {
            var comments = ws['!comments'];
            var need_vml = false;
            var cf = "";
            if (comments && comments.length > 0) {
                var needtc = false;
                comments.forEach(function(carr) {
                    carr[1].forEach(function(c) {
                        if (c.T == true) needtc = true;
                    });
                });
                if (needtc) {
                    cf = "xl/threadedComments/threadedComment" + rId + ".xml";
                    $b8f343bf88dacc48$var$zip_add_file(zip, cf, $b8f343bf88dacc48$var$write_tcmnt_xml(comments, people, opts));
                    ct.threadedcomments.push(cf);
                    $b8f343bf88dacc48$var$add_rels(wsrels, -1, "../threadedComments/threadedComment" + rId + ".xml", $b8f343bf88dacc48$var$RELS.TCMNT);
                }
                cf = "xl/comments" + rId + "." + wbext;
                $b8f343bf88dacc48$var$zip_add_file(zip, cf, $b8f343bf88dacc48$var$write_comments_bin(comments, opts));
                ct.comments.push(cf);
                $b8f343bf88dacc48$var$add_rels(wsrels, -1, "../comments" + rId + "." + wbext, $b8f343bf88dacc48$var$RELS.CMNT);
                need_vml = true;
            }
            if (ws['!legacy']) {
                if (need_vml) $b8f343bf88dacc48$var$zip_add_file(zip, "xl/drawings/vmlDrawing" + rId + ".vml", $b8f343bf88dacc48$var$write_vml(rId, ws['!comments']));
            }
            delete ws['!comments'];
            delete ws['!legacy'];
        }
        if (wsrels['!id'].rId1) $b8f343bf88dacc48$var$zip_add_file(zip, $b8f343bf88dacc48$var$get_rels_path(f), $b8f343bf88dacc48$var$write_rels(wsrels));
    }
    if (opts.Strings != null && opts.Strings.length > 0) {
        f = "xl/sharedStrings." + wbext;
        $b8f343bf88dacc48$var$zip_add_file(zip, f, $b8f343bf88dacc48$var$write_sst_bin(opts.Strings, opts));
        ct.strs.push(f);
        $b8f343bf88dacc48$var$add_rels(opts.wbrels, -1, "sharedStrings." + wbext, $b8f343bf88dacc48$var$RELS.SST);
    }
    f = "xl/workbook." + wbext;
    $b8f343bf88dacc48$var$zip_add_file(zip, f, $b8f343bf88dacc48$var$write_wb_bin(wb, opts));
    ct.workbooks.push(f);
    $b8f343bf88dacc48$var$add_rels(opts.rels, 1, f, $b8f343bf88dacc48$var$RELS.WB);
    /* TODO: something more intelligent with themes */ f = "xl/theme/theme1.xml";
    var ww = $b8f343bf88dacc48$var$write_theme(wb.Themes, opts);
    $b8f343bf88dacc48$var$zip_add_file(zip, f, ww);
    ct.themes.push(f);
    $b8f343bf88dacc48$var$add_rels(opts.wbrels, -1, "theme/theme1.xml", $b8f343bf88dacc48$var$RELS.THEME);
    /* TODO: something more intelligent with styles */ f = "xl/styles." + wbext;
    $b8f343bf88dacc48$var$zip_add_file(zip, f, $b8f343bf88dacc48$var$write_sty_bin(wb, opts));
    ct.styles.push(f);
    $b8f343bf88dacc48$var$add_rels(opts.wbrels, -1, "styles." + wbext, $b8f343bf88dacc48$var$RELS.STY);
    if (wb.vbaraw && vbafmt) {
        f = "xl/vbaProject.bin";
        $b8f343bf88dacc48$var$zip_add_file(zip, f, wb.vbaraw);
        ct.vba.push(f);
        $b8f343bf88dacc48$var$add_rels(opts.wbrels, -1, "vbaProject.bin", $b8f343bf88dacc48$var$RELS.VBA);
    }
    f = "xl/metadata." + wbext;
    $b8f343bf88dacc48$var$zip_add_file(zip, f, $b8f343bf88dacc48$var$write_xlmeta_bin());
    ct.metadata.push(f);
    $b8f343bf88dacc48$var$add_rels(opts.wbrels, -1, "metadata." + wbext, $b8f343bf88dacc48$var$RELS.XLMETA);
    if (people.length > 1) {
        f = "xl/persons/person.xml";
        $b8f343bf88dacc48$var$zip_add_file(zip, f, $b8f343bf88dacc48$var$write_people_xml(people, opts));
        ct.people.push(f);
        $b8f343bf88dacc48$var$add_rels(opts.wbrels, -1, "persons/person.xml", $b8f343bf88dacc48$var$RELS.PEOPLE);
    }
    $b8f343bf88dacc48$var$zip_add_file(zip, "[Content_Types].xml", $b8f343bf88dacc48$var$write_ct(ct, opts));
    $b8f343bf88dacc48$var$zip_add_file(zip, '_rels/.rels', $b8f343bf88dacc48$var$write_rels(opts.rels));
    $b8f343bf88dacc48$var$zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', $b8f343bf88dacc48$var$write_rels(opts.wbrels));
    delete opts.revssf;
    delete opts.ssf;
    return zip;
}
function $b8f343bf88dacc48$var$write_zip_xlsx(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    if (wb && !wb.SSF) wb.SSF = $b8f343bf88dacc48$var$dup($b8f343bf88dacc48$var$table_fmt);
    if (wb && wb.SSF) {
        $b8f343bf88dacc48$var$make_ssf();
        $b8f343bf88dacc48$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $b8f343bf88dacc48$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
    }
    opts.rels = {};
    opts.wbrels = {};
    opts.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    opts.Strings.Count = 0;
    opts.Strings.Unique = 0;
    if ($b8f343bf88dacc48$var$browser_has_Map) opts.revStrings = new Map();
    else {
        opts.revStrings = {};
        opts.revStrings.foo = [];
        delete opts.revStrings.foo;
    }
    var wbext = "xml";
    var vbafmt = $b8f343bf88dacc48$var$VBAFMTS.indexOf(opts.bookType) > -1;
    var ct = $b8f343bf88dacc48$var$new_ct();
    $b8f343bf88dacc48$var$fix_write_opts(opts = opts || {});
    var zip = $b8f343bf88dacc48$var$zip_new();
    var f = "", rId = 0;
    opts.cellXfs = [];
    $b8f343bf88dacc48$var$get_cell_style(opts.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    f = "docProps/core.xml";
    $b8f343bf88dacc48$var$zip_add_file(zip, f, $b8f343bf88dacc48$var$write_core_props(wb.Props, opts));
    ct.coreprops.push(f);
    $b8f343bf88dacc48$var$add_rels(opts.rels, 2, f, $b8f343bf88dacc48$var$RELS.CORE_PROPS);
    /*::if(!wb.Props) throw "unreachable"; */ f = "docProps/app.xml";
    if (wb.Props && wb.Props.SheetNames) ;
    else if (!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
    else {
        var _sn = [];
        for(var _i = 0; _i < wb.SheetNames.length; ++_i)if ((wb.Workbook.Sheets[_i] || {}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
        wb.Props.SheetNames = _sn;
    }
    wb.Props.Worksheets = wb.Props.SheetNames.length;
    $b8f343bf88dacc48$var$zip_add_file(zip, f, $b8f343bf88dacc48$var$write_ext_props(wb.Props, opts));
    ct.extprops.push(f);
    $b8f343bf88dacc48$var$add_rels(opts.rels, 3, f, $b8f343bf88dacc48$var$RELS.EXT_PROPS);
    if (wb.Custprops !== wb.Props && $b8f343bf88dacc48$var$keys(wb.Custprops || {}).length > 0) {
        f = "docProps/custom.xml";
        $b8f343bf88dacc48$var$zip_add_file(zip, f, $b8f343bf88dacc48$var$write_cust_props(wb.Custprops, opts));
        ct.custprops.push(f);
        $b8f343bf88dacc48$var$add_rels(opts.rels, 4, f, $b8f343bf88dacc48$var$RELS.CUST_PROPS);
    }
    var people = [
        "SheetJ5"
    ];
    opts.tcid = 0;
    for(rId = 1; rId <= wb.SheetNames.length; ++rId){
        var wsrels = {
            '!id': {}
        };
        var ws = wb.Sheets[wb.SheetNames[rId - 1]];
        var _type = (ws || {})["!type"] || "sheet";
        _type;
        f = "xl/worksheets/sheet" + rId + "." + wbext;
        $b8f343bf88dacc48$var$zip_add_file(zip, f, $b8f343bf88dacc48$var$write_ws_xml(rId - 1, opts, wb, wsrels));
        ct.sheets.push(f);
        $b8f343bf88dacc48$var$add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, $b8f343bf88dacc48$var$RELS.WS[0]);
        if (ws) {
            var comments = ws['!comments'];
            var need_vml = false;
            var cf = "";
            if (comments && comments.length > 0) {
                var needtc = false;
                comments.forEach(function(carr) {
                    carr[1].forEach(function(c) {
                        if (c.T == true) needtc = true;
                    });
                });
                if (needtc) {
                    cf = "xl/threadedComments/threadedComment" + rId + ".xml";
                    $b8f343bf88dacc48$var$zip_add_file(zip, cf, $b8f343bf88dacc48$var$write_tcmnt_xml(comments, people, opts));
                    ct.threadedcomments.push(cf);
                    $b8f343bf88dacc48$var$add_rels(wsrels, -1, "../threadedComments/threadedComment" + rId + ".xml", $b8f343bf88dacc48$var$RELS.TCMNT);
                }
                cf = "xl/comments" + rId + "." + wbext;
                $b8f343bf88dacc48$var$zip_add_file(zip, cf, $b8f343bf88dacc48$var$write_comments_xml(comments, opts));
                ct.comments.push(cf);
                $b8f343bf88dacc48$var$add_rels(wsrels, -1, "../comments" + rId + "." + wbext, $b8f343bf88dacc48$var$RELS.CMNT);
                need_vml = true;
            }
            if (ws['!legacy']) {
                if (need_vml) $b8f343bf88dacc48$var$zip_add_file(zip, "xl/drawings/vmlDrawing" + rId + ".vml", $b8f343bf88dacc48$var$write_vml(rId, ws['!comments']));
            }
            delete ws['!comments'];
            delete ws['!legacy'];
        }
        if (wsrels['!id'].rId1) $b8f343bf88dacc48$var$zip_add_file(zip, $b8f343bf88dacc48$var$get_rels_path(f), $b8f343bf88dacc48$var$write_rels(wsrels));
    }
    if (opts.Strings != null && opts.Strings.length > 0) {
        f = "xl/sharedStrings." + wbext;
        $b8f343bf88dacc48$var$zip_add_file(zip, f, $b8f343bf88dacc48$var$write_sst_xml(opts.Strings, opts));
        ct.strs.push(f);
        $b8f343bf88dacc48$var$add_rels(opts.wbrels, -1, "sharedStrings." + wbext, $b8f343bf88dacc48$var$RELS.SST);
    }
    f = "xl/workbook." + wbext;
    $b8f343bf88dacc48$var$zip_add_file(zip, f, $b8f343bf88dacc48$var$write_wb_xml(wb, opts));
    ct.workbooks.push(f);
    $b8f343bf88dacc48$var$add_rels(opts.rels, 1, f, $b8f343bf88dacc48$var$RELS.WB);
    /* TODO: something more intelligent with themes */ f = "xl/theme/theme1.xml";
    $b8f343bf88dacc48$var$zip_add_file(zip, f, $b8f343bf88dacc48$var$write_theme(wb.Themes, opts));
    ct.themes.push(f);
    $b8f343bf88dacc48$var$add_rels(opts.wbrels, -1, "theme/theme1.xml", $b8f343bf88dacc48$var$RELS.THEME);
    /* TODO: something more intelligent with styles */ f = "xl/styles." + wbext;
    $b8f343bf88dacc48$var$zip_add_file(zip, f, $b8f343bf88dacc48$var$write_sty_xml(wb, opts));
    ct.styles.push(f);
    $b8f343bf88dacc48$var$add_rels(opts.wbrels, -1, "styles." + wbext, $b8f343bf88dacc48$var$RELS.STY);
    if (wb.vbaraw && vbafmt) {
        f = "xl/vbaProject.bin";
        $b8f343bf88dacc48$var$zip_add_file(zip, f, wb.vbaraw);
        ct.vba.push(f);
        $b8f343bf88dacc48$var$add_rels(opts.wbrels, -1, "vbaProject.bin", $b8f343bf88dacc48$var$RELS.VBA);
    }
    f = "xl/metadata." + wbext;
    $b8f343bf88dacc48$var$zip_add_file(zip, f, $b8f343bf88dacc48$var$write_xlmeta_xml());
    ct.metadata.push(f);
    $b8f343bf88dacc48$var$add_rels(opts.wbrels, -1, "metadata." + wbext, $b8f343bf88dacc48$var$RELS.XLMETA);
    if (people.length > 1) {
        f = "xl/persons/person.xml";
        $b8f343bf88dacc48$var$zip_add_file(zip, f, $b8f343bf88dacc48$var$write_people_xml(people, opts));
        ct.people.push(f);
        $b8f343bf88dacc48$var$add_rels(opts.wbrels, -1, "persons/person.xml", $b8f343bf88dacc48$var$RELS.PEOPLE);
    }
    $b8f343bf88dacc48$var$zip_add_file(zip, "[Content_Types].xml", $b8f343bf88dacc48$var$write_ct(ct, opts));
    $b8f343bf88dacc48$var$zip_add_file(zip, '_rels/.rels', $b8f343bf88dacc48$var$write_rels(opts.rels));
    $b8f343bf88dacc48$var$zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', $b8f343bf88dacc48$var$write_rels(opts.wbrels));
    delete opts.revssf;
    delete opts.ssf;
    return zip;
}
function $b8f343bf88dacc48$var$firstbyte(f /*:RawData*/ , o /*:?TypeOpts*/ ) /*:Array<number>*/ {
    var x = "";
    switch((o || {}).type || "base64"){
        case 'buffer':
            return [
                f[0],
                f[1],
                f[2],
                f[3],
                f[4],
                f[5],
                f[6],
                f[7]
            ];
        case 'base64':
            x = $b8f343bf88dacc48$var$Base64_decode(f.slice(0, 12));
            break;
        case 'binary':
            x = f;
            break;
        case 'array':
            return [
                f[0],
                f[1],
                f[2],
                f[3],
                f[4],
                f[5],
                f[6],
                f[7]
            ];
        default:
            throw new Error("Unrecognized type " + (o && o.type || "undefined"));
    }
    return [
        x.charCodeAt(0),
        x.charCodeAt(1),
        x.charCodeAt(2),
        x.charCodeAt(3),
        x.charCodeAt(4),
        x.charCodeAt(5),
        x.charCodeAt(6),
        x.charCodeAt(7)
    ];
}
function $b8f343bf88dacc48$var$read_cfb(cfb /*:CFBContainer*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    if ($b8f343bf88dacc48$export$9f0e51cd97c572a.find(cfb, "EncryptedPackage")) return $b8f343bf88dacc48$var$parse_xlsxcfb(cfb, opts);
    return $b8f343bf88dacc48$export$b41972a043aba84c(cfb, opts);
}
function $b8f343bf88dacc48$var$read_zip(data /*:RawData*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var zip, d = data;
    var o = opts || {};
    if (!o.type) o.type = $b8f343bf88dacc48$var$has_buf && $b8f343bf88dacc48$require$Buffer.isBuffer(data) ? "buffer" : "base64";
    zip = $b8f343bf88dacc48$var$zip_read(d, o);
    return $b8f343bf88dacc48$export$b165387946f79a1(zip, o);
}
function $b8f343bf88dacc48$var$read_plaintext(data /*:string*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var i = 0;
    main: while(i < data.length)switch(data.charCodeAt(i)){
        case 0x0A:
        case 0x0D:
        case 0x20:
            ++i;
            break;
        case 0x3C:
            return $b8f343bf88dacc48$var$parse_xlml(data.slice(i), o);
        default:
            break main;
    }
    return $b8f343bf88dacc48$var$PRN.to_workbook(data, o);
}
function $b8f343bf88dacc48$var$read_plaintext_raw(data /*:RawData*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var str = "", bytes = $b8f343bf88dacc48$var$firstbyte(data, o);
    switch(o.type){
        case 'base64':
            str = $b8f343bf88dacc48$var$Base64_decode(data);
            break;
        case 'binary':
            str = data;
            break;
        case 'buffer':
            str = data.toString('binary');
            break;
        case 'array':
            str = $b8f343bf88dacc48$var$cc2str(data);
            break;
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    if (bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = $b8f343bf88dacc48$var$utf8read(str);
    o.type = "binary";
    return $b8f343bf88dacc48$var$read_plaintext(str, o);
}
function $b8f343bf88dacc48$var$read_utf16(data /*:RawData*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var d = data;
    if (o.type == 'base64') d = $b8f343bf88dacc48$var$Base64_decode(d);
    if (typeof ArrayBuffer !== "undefined" && data instanceof ArrayBuffer) d = new Uint8Array(data);
    d = typeof $b8f343bf88dacc48$var$$cptable !== "undefined" ? $b8f343bf88dacc48$var$$cptable.utils.decode(1200, d.slice(2), 'str') : $b8f343bf88dacc48$var$has_buf && $b8f343bf88dacc48$require$Buffer.isBuffer(data) ? data.slice(2).toString("utf16le") : typeof Uint8Array !== "undefined" && d instanceof Uint8Array ? typeof TextDecoder !== "undefined" ? new TextDecoder("utf-16le").decode(d.slice(2)) : $b8f343bf88dacc48$var$utf16lereadu(d.slice(2)) : $b8f343bf88dacc48$var$utf16leread(d.slice(2));
    o.type = "binary";
    return $b8f343bf88dacc48$var$read_plaintext(d, o);
}
function $b8f343bf88dacc48$var$bstrify(data /*:string*/ ) /*:string*/ {
    return !data.match(/[^\x00-\x7F]/) ? data : $b8f343bf88dacc48$var$utf8write(data);
}
function $b8f343bf88dacc48$var$read_prn(data, d, o, str) {
    if (str) {
        o.type = "string";
        return $b8f343bf88dacc48$var$PRN.to_workbook(data, o);
    }
    return $b8f343bf88dacc48$var$PRN.to_workbook(d, o);
}
function $b8f343bf88dacc48$export$aafa59e2e03f2942(data /*:RawData*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    $b8f343bf88dacc48$var$reset_cp();
    var o = opts || {};
    if (o.codepage && typeof $b8f343bf88dacc48$var$$cptable === "undefined") console.error("Codepage tables are not loaded.  Non-ASCII characters may not give expected results");
    if (typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) return $b8f343bf88dacc48$export$aafa59e2e03f2942(new Uint8Array(data), (o = $b8f343bf88dacc48$var$dup(o), o.type = "array", o));
    if (typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && !o.type) o.type = typeof Deno !== "undefined" ? "buffer" : "array";
    var d = data, n = [
        0,
        0,
        0,
        0
    ], str = false;
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    $b8f343bf88dacc48$var$_ssfopts = {};
    if (o.dateNF) $b8f343bf88dacc48$var$_ssfopts.dateNF = o.dateNF;
    if (!o.type) o.type = $b8f343bf88dacc48$var$has_buf && $b8f343bf88dacc48$require$Buffer.isBuffer(data) ? "buffer" : "base64";
    if (o.type == "file") {
        o.type = $b8f343bf88dacc48$var$has_buf ? "buffer" : "binary";
        d = $b8f343bf88dacc48$var$read_binary(data);
        if (typeof Uint8Array !== 'undefined' && !$b8f343bf88dacc48$var$has_buf) o.type = "array";
    }
    if (o.type == "string") {
        str = true;
        o.type = "binary";
        o.codepage = 65001;
        d = $b8f343bf88dacc48$var$bstrify(data);
    }
    if (o.type == 'array' && typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && typeof ArrayBuffer !== 'undefined') {
        // $FlowIgnore
        var ab = new ArrayBuffer(3), vu = new Uint8Array(ab);
        vu.foo = "bar";
        // $FlowIgnore
        if (!vu.foo) {
            o = $b8f343bf88dacc48$var$dup(o);
            o.type = 'array';
            return $b8f343bf88dacc48$export$aafa59e2e03f2942($b8f343bf88dacc48$var$ab2a(d), o);
        }
    }
    switch((n = $b8f343bf88dacc48$var$firstbyte(d, o))[0]){
        case 0xD0:
            if (n[1] === 0xCF && n[2] === 0x11 && n[3] === 0xE0 && n[4] === 0xA1 && n[5] === 0xB1 && n[6] === 0x1A && n[7] === 0xE1) return $b8f343bf88dacc48$var$read_cfb($b8f343bf88dacc48$export$9f0e51cd97c572a.read(d, o), o);
            break;
        case 0x09:
            if (n[1] <= 0x08) return $b8f343bf88dacc48$export$b41972a043aba84c(d, o);
            break;
        case 0x3C:
            return $b8f343bf88dacc48$var$parse_xlml(d, o);
        case 0x49:
            if (n[1] === 0x49 && n[2] === 0x2a && n[3] === 0x00) throw new Error("TIFF Image File is not a spreadsheet");
            if (n[1] === 0x44) return $b8f343bf88dacc48$var$read_wb_ID(d, o);
            break;
        case 0x54:
            if (n[1] === 0x41 && n[2] === 0x42 && n[3] === 0x4C) return $b8f343bf88dacc48$var$DIF.to_workbook(d, o);
            break;
        case 0x50:
            return n[1] === 0x4B && n[2] < 0x09 && n[3] < 0x09 ? $b8f343bf88dacc48$var$read_zip(d, o) : $b8f343bf88dacc48$var$read_prn(data, d, o, str);
        case 0xEF:
            return n[3] === 0x3C ? $b8f343bf88dacc48$var$parse_xlml(d, o) : $b8f343bf88dacc48$var$read_prn(data, d, o, str);
        case 0xFF:
            if (n[1] === 0xFE) return $b8f343bf88dacc48$var$read_utf16(d, o);
            else if (n[1] === 0x00 && n[2] === 0x02 && n[3] === 0x00) return $b8f343bf88dacc48$var$WK_.to_workbook(d, o);
            break;
        case 0x00:
            if (n[1] === 0x00) {
                if (n[2] >= 0x02 && n[3] === 0x00) return $b8f343bf88dacc48$var$WK_.to_workbook(d, o);
                if (n[2] === 0x00 && (n[3] === 0x08 || n[3] === 0x09)) return $b8f343bf88dacc48$var$WK_.to_workbook(d, o);
            }
            break;
        case 0x03:
        case 0x83:
        case 0x8B:
        case 0x8C:
            return $b8f343bf88dacc48$var$DBF.to_workbook(d, o);
        case 0x7B:
            if (n[1] === 0x5C && n[2] === 0x72 && n[3] === 0x74) return $b8f343bf88dacc48$var$rtf_to_workbook(d, o);
            break;
        case 0x0A:
        case 0x0D:
        case 0x20:
            return $b8f343bf88dacc48$var$read_plaintext_raw(d, o);
        case 0x89:
            if (n[1] === 0x50 && n[2] === 0x4E && n[3] === 0x47) throw new Error("PNG Image File is not a spreadsheet");
            break;
        case 0x08:
            if (n[1] === 0xE7) throw new Error("Unsupported Multiplan 1.x file!");
            break;
        case 0x0C:
            if (n[1] === 0xEC) throw new Error("Unsupported Multiplan 2.x file!");
            if (n[1] === 0xED) throw new Error("Unsupported Multiplan 3.x file!");
            break;
    }
    if ($b8f343bf88dacc48$var$DBF_SUPPORTED_VERSIONS.indexOf(n[0]) > -1 && n[2] <= 12 && n[3] <= 31) return $b8f343bf88dacc48$var$DBF.to_workbook(d, o);
    return $b8f343bf88dacc48$var$read_prn(data, d, o, str);
}
function $b8f343bf88dacc48$export$72c04af63de9061a(filename /*:string*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var o = opts || {};
    o.type = 'file';
    return $b8f343bf88dacc48$export$aafa59e2e03f2942(filename, o);
}
function $b8f343bf88dacc48$var$write_cfb_ctr(cfb /*:CFBContainer*/ , o /*:WriteOpts*/ ) /*:any*/ {
    switch(o.type){
        case "base64":
        case "binary":
            break;
        case "buffer":
        case "array":
            o.type = "";
            break;
        case "file":
            return $b8f343bf88dacc48$var$write_dl(o.file, $b8f343bf88dacc48$export$9f0e51cd97c572a.write(cfb, {
                type: $b8f343bf88dacc48$var$has_buf ? 'buffer' : ""
            }));
        case "string":
            throw new Error("'string' output type invalid for '" + o.bookType + "' files");
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    return $b8f343bf88dacc48$export$9f0e51cd97c572a.write(cfb, o);
}
function $b8f343bf88dacc48$var$write_zip(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    switch(opts.bookType){
        case "ods":
            return $b8f343bf88dacc48$var$write_ods(wb, opts);
        case "numbers":
            return $b8f343bf88dacc48$var$write_numbers_iwa(wb, opts);
        case "xlsb":
            return $b8f343bf88dacc48$var$write_zip_xlsb(wb, opts);
        default:
            return $b8f343bf88dacc48$var$write_zip_xlsx(wb, opts);
    }
}
/*:: declare var encrypt_agile:any; */ function $b8f343bf88dacc48$var$write_zip_type(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = $b8f343bf88dacc48$var$dup(opts || {});
    var z = $b8f343bf88dacc48$var$write_zip(wb, o);
    return $b8f343bf88dacc48$var$write_zip_denouement(z, o);
}
function $b8f343bf88dacc48$var$write_zip_typeXLSX(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = $b8f343bf88dacc48$var$dup(opts || {});
    var z = $b8f343bf88dacc48$var$write_zip_xlsx(wb, o);
    return $b8f343bf88dacc48$var$write_zip_denouement(z, o);
}
function $b8f343bf88dacc48$var$write_zip_denouement(z /*:any*/ , o /*:?WriteOpts*/ ) /*:any*/ {
    var oopts = {};
    var ftype = $b8f343bf88dacc48$var$has_buf ? "nodebuffer" : typeof Uint8Array !== "undefined" ? "array" : "string";
    if (o.compression) oopts.compression = 'DEFLATE';
    if (o.password) oopts.type = ftype;
    else switch(o.type){
        case "base64":
            oopts.type = "base64";
            break;
        case "binary":
            oopts.type = "string";
            break;
        case "string":
            throw new Error("'string' output type invalid for '" + o.bookType + "' files");
        case "buffer":
        case "file":
            oopts.type = ftype;
            break;
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    var out = z.FullPaths ? $b8f343bf88dacc48$export$9f0e51cd97c572a.write(z, {
        fileType: "zip",
        type: /*::(*/ {
            "nodebuffer": "buffer",
            "string": "binary"
        } /*:: :any)*/ [oopts.type] || oopts.type,
        compression: !!o.compression
    }) : z.generate(oopts);
    if (typeof Deno !== "undefined") {
        if (typeof out == "string") {
            if (o.type == "binary" || o.type == "base64") return out;
            out = new Uint8Array($b8f343bf88dacc48$var$s2ab(out));
        }
    }
    /*jshint -W083 */ if (o.password && typeof encrypt_agile !== 'undefined') return $b8f343bf88dacc48$var$write_cfb_ctr(encrypt_agile(out, o.password), o); // eslint-disable-line no-undef
    /*jshint +W083 */ if (o.type === "file") return $b8f343bf88dacc48$var$write_dl(o.file, out);
    return o.type == "string" ? $b8f343bf88dacc48$var$utf8read(/*::(*/ out /*:: :any)*/ ) : out;
}
function $b8f343bf88dacc48$var$write_cfb_type(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = opts || {};
    var cfb /*:CFBContainer*/  = $b8f343bf88dacc48$var$write_xlscfb(wb, o);
    return $b8f343bf88dacc48$var$write_cfb_ctr(cfb, o);
}
function $b8f343bf88dacc48$var$write_string_type(out /*:string*/ , opts /*:WriteOpts*/ , bom /*:?string*/ ) /*:any*/ {
    if (!bom) bom = "";
    var o = bom + out;
    switch(opts.type){
        case "base64":
            return $b8f343bf88dacc48$var$Base64_encode($b8f343bf88dacc48$var$utf8write(o));
        case "binary":
            return $b8f343bf88dacc48$var$utf8write(o);
        case "string":
            return out;
        case "file":
            return $b8f343bf88dacc48$var$write_dl(opts.file, o, 'utf8');
        case "buffer":
            if ($b8f343bf88dacc48$var$has_buf) return $b8f343bf88dacc48$var$Buffer_from(o, 'utf8');
            else if (typeof TextEncoder !== "undefined") return new TextEncoder().encode(o);
            else return $b8f343bf88dacc48$var$write_string_type(o, {
                type: 'binary'
            }).split("").map(function(c) {
                return c.charCodeAt(0);
            });
    }
    throw new Error("Unrecognized type " + opts.type);
}
function $b8f343bf88dacc48$var$write_stxt_type(out /*:string*/ , opts /*:WriteOpts*/ ) /*:any*/ {
    switch(opts.type){
        case "base64":
            return $b8f343bf88dacc48$var$Base64_encode_pass(out);
        case "binary":
            return out;
        case "string":
            return out; /* override in sheet_to_txt */ 
        case "file":
            return $b8f343bf88dacc48$var$write_dl(opts.file, out, 'binary');
        case "buffer":
            if ($b8f343bf88dacc48$var$has_buf) return $b8f343bf88dacc48$var$Buffer_from(out, 'binary');
            else return out.split("").map(function(c) {
                return c.charCodeAt(0);
            });
    }
    throw new Error("Unrecognized type " + opts.type);
}
/* TODO: test consistency */ function $b8f343bf88dacc48$var$write_binary_type(out, opts /*:WriteOpts*/ ) /*:any*/ {
    switch(opts.type){
        case "string":
        case "base64":
        case "binary":
            var bstr = "";
            // $FlowIgnore
            for(var i = 0; i < out.length; ++i)bstr += String.fromCharCode(out[i]);
            return opts.type == 'base64' ? $b8f343bf88dacc48$var$Base64_encode(bstr) : opts.type == 'string' ? $b8f343bf88dacc48$var$utf8read(bstr) : bstr;
        case "file":
            return $b8f343bf88dacc48$var$write_dl(opts.file, out);
        case "buffer":
            return out;
        default:
            throw new Error("Unrecognized type " + opts.type);
    }
}
function $b8f343bf88dacc48$export$f6ca43591cb061b1(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) {
    $b8f343bf88dacc48$var$reset_cp();
    $b8f343bf88dacc48$var$check_wb(wb);
    var o = $b8f343bf88dacc48$var$dup(opts || {});
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    if (o.type == "array") {
        o.type = "binary";
        var out /*:string*/  = $b8f343bf88dacc48$export$f6ca43591cb061b1(wb, o);
        o.type = "array";
        return $b8f343bf88dacc48$var$s2ab(out);
    }
    return $b8f343bf88dacc48$var$write_zip_typeXLSX(wb, o);
}
function $b8f343bf88dacc48$export$68d8715fc104d294(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) {
    $b8f343bf88dacc48$var$reset_cp();
    $b8f343bf88dacc48$var$check_wb(wb);
    var o = $b8f343bf88dacc48$var$dup(opts || {});
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    if (o.type == "array") {
        o.type = "binary";
        var out /*:string*/  = $b8f343bf88dacc48$export$68d8715fc104d294(wb, o);
        o.type = "array";
        return $b8f343bf88dacc48$var$s2ab(out);
    }
    var idx = 0;
    if (o.sheet) {
        if (typeof o.sheet == "number") idx = o.sheet;
        else idx = wb.SheetNames.indexOf(o.sheet);
        if (!wb.SheetNames[idx]) throw new Error("Sheet not found: " + o.sheet + " : " + typeof o.sheet);
    }
    switch(o.bookType || 'xlsb'){
        case 'xml':
        case 'xlml':
            return $b8f343bf88dacc48$var$write_string_type($b8f343bf88dacc48$var$write_xlml(wb, o), o);
        case 'slk':
        case 'sylk':
            return $b8f343bf88dacc48$var$write_string_type($b8f343bf88dacc48$var$SYLK.from_sheet(wb.Sheets[wb.SheetNames[idx]], o, wb), o);
        case 'htm':
        case 'html':
            return $b8f343bf88dacc48$var$write_string_type($b8f343bf88dacc48$var$sheet_to_html(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'txt':
            return $b8f343bf88dacc48$var$write_stxt_type($b8f343bf88dacc48$var$sheet_to_txt(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'csv':
            return $b8f343bf88dacc48$var$write_string_type($b8f343bf88dacc48$var$sheet_to_csv(wb.Sheets[wb.SheetNames[idx]], o), o, "\ufeff");
        case 'dif':
            return $b8f343bf88dacc48$var$write_string_type($b8f343bf88dacc48$var$DIF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'dbf':
            return $b8f343bf88dacc48$var$write_binary_type($b8f343bf88dacc48$var$DBF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'prn':
            return $b8f343bf88dacc48$var$write_string_type($b8f343bf88dacc48$var$PRN.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'rtf':
            return $b8f343bf88dacc48$var$write_string_type($b8f343bf88dacc48$var$sheet_to_rtf(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'eth':
            return $b8f343bf88dacc48$var$write_string_type($b8f343bf88dacc48$var$ETH.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'fods':
            return $b8f343bf88dacc48$var$write_string_type($b8f343bf88dacc48$var$write_ods(wb, o), o);
        case 'wk1':
            return $b8f343bf88dacc48$var$write_binary_type($b8f343bf88dacc48$var$WK_.sheet_to_wk1(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'wk3':
            return $b8f343bf88dacc48$var$write_binary_type($b8f343bf88dacc48$var$WK_.book_to_wk3(wb, o), o);
        case 'biff2':
            if (!o.biff) o.biff = 2; /* falls through */ 
        case 'biff3':
            if (!o.biff) o.biff = 3; /* falls through */ 
        case 'biff4':
            if (!o.biff) o.biff = 4;
            return $b8f343bf88dacc48$var$write_binary_type($b8f343bf88dacc48$var$write_biff_buf(wb, o), o);
        case 'biff5':
            if (!o.biff) o.biff = 5; /* falls through */ 
        case 'biff8':
        case 'xla':
        case 'xls':
            if (!o.biff) o.biff = 8;
            return $b8f343bf88dacc48$var$write_cfb_type(wb, o);
        case 'xlsx':
        case 'xlsm':
        case 'xlam':
        case 'xlsb':
        case 'numbers':
        case 'ods':
            return $b8f343bf88dacc48$var$write_zip_type(wb, o);
        default:
            throw new Error("Unrecognized bookType |" + o.bookType + "|");
    }
}
function $b8f343bf88dacc48$var$resolve_book_type(o /*:WriteFileOpts*/ ) {
    if (o.bookType) return;
    var _BT = {
        "xls": "biff8",
        "htm": "html",
        "slk": "sylk",
        "socialcalc": "eth",
        "Sh33tJS": "WTF"
    };
    var ext = o.file.slice(o.file.lastIndexOf(".")).toLowerCase();
    if (ext.match(/^\.[a-z]+$/)) o.bookType = ext.slice(1);
    o.bookType = _BT[o.bookType] || o.bookType;
}
function $b8f343bf88dacc48$export$552bfb764b5cd2b4(wb /*:Workbook*/ , filename /*:string*/ , opts /*:?WriteFileOpts*/ ) {
    var o = opts || {};
    o.type = 'file';
    o.file = filename;
    $b8f343bf88dacc48$var$resolve_book_type(o);
    return $b8f343bf88dacc48$export$68d8715fc104d294(wb, o);
}
function $b8f343bf88dacc48$export$40a06aea54ee074e(wb /*:Workbook*/ , filename /*:string*/ , opts /*:?WriteFileOpts*/ ) {
    var o = opts || {};
    o.type = 'file';
    o.file = filename;
    $b8f343bf88dacc48$var$resolve_book_type(o);
    return $b8f343bf88dacc48$export$f6ca43591cb061b1(wb, o);
}
function $b8f343bf88dacc48$export$25469296c4b8ebda(filename /*:string*/ , wb /*:Workbook*/ , opts /*:?WriteFileOpts*/ , cb /*:?(e?:ErrnoError)=>void*/ ) {
    var o = opts || {};
    o.type = 'file';
    o.file = filename;
    $b8f343bf88dacc48$var$resolve_book_type(o);
    o.type = 'buffer';
    var _cb = cb;
    if (!(_cb instanceof Function)) _cb = opts /*:any*/ ;
    return $b8f343bf88dacc48$var$_fs.writeFile(filename, $b8f343bf88dacc48$export$68d8715fc104d294(wb, o), _cb);
}
/*::
type MJRObject = {
	row: any;
	isempty: boolean;
};
*/ function $b8f343bf88dacc48$var$make_json_row(sheet /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , cols /*:Array<string>*/ , header /*:number*/ , hdr /*:Array<any>*/ , o /*:Sheet2JSONOpts*/ ) /*:MJRObject*/ {
    var rr = $b8f343bf88dacc48$var$encode_row(R);
    var defval = o.defval, raw = o.raw || !Object.prototype.hasOwnProperty.call(o, "raw");
    var isempty = true, dense = sheet["!data"] != null;
    var row /*:any*/  = header === 1 ? [] : {};
    if (header !== 1) {
        if (Object.defineProperty) try {
            Object.defineProperty(row, '__rowNum__', {
                value: R,
                enumerable: false
            });
        } catch (e) {
            row.__rowNum__ = R;
        }
        else row.__rowNum__ = R;
    }
    if (!dense || sheet["!data"][R]) for(var C = r.s.c; C <= r.e.c; ++C){
        var val = dense ? (sheet["!data"][R] || [])[C] : sheet[cols[C] + rr];
        if (val == null || val.t === undefined) {
            if (defval === undefined) continue;
            if (hdr[C] != null) row[hdr[C]] = defval;
            continue;
        }
        var v = val.v;
        switch(val.t){
            case 'z':
                if (v == null) break;
                continue;
            case 'e':
                v = v == 0 ? null : void 0;
                break;
            case 's':
            case 'b':
            case 'n':
                if (!val.z || !$b8f343bf88dacc48$var$fmt_is_date(val.z)) break;
                v = $b8f343bf88dacc48$var$numdate(v); // TODO: date1904 setting should also be stored in worksheet object
                if (typeof v == "number") break;
            /* falls through */ case 'd':
                if (!(o && (o.UTC || o.raw === false))) v = $b8f343bf88dacc48$var$utc_to_local(new Date(v));
                break;
            default:
                throw new Error('unrecognized type ' + val.t);
        }
        if (hdr[C] != null) {
            if (v == null) {
                if (val.t == "e" && v === null) row[hdr[C]] = null;
                else if (defval !== undefined) row[hdr[C]] = defval;
                else if (raw && v === null) row[hdr[C]] = null;
                else continue;
            } else row[hdr[C]] = (val.t === 'n' && typeof o.rawNumbers === 'boolean' ? o.rawNumbers : raw) ? v : $b8f343bf88dacc48$var$format_cell(val, v, o);
            if (v != null) isempty = false;
        }
    }
    return {
        row: row,
        isempty: isempty
    };
}
function $b8f343bf88dacc48$var$sheet_to_json(sheet /*:Worksheet*/ , opts /*:?Sheet2JSONOpts*/ ) {
    if (sheet == null || sheet["!ref"] == null) return [];
    var val = {
        t: 'n',
        v: 0
    }, header = 0, offset = 1, hdr /*:Array<any>*/  = [], v = 0, vv = "";
    var r = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var o = opts || {};
    var range = o.range != null ? o.range : sheet["!ref"];
    if (o.header === 1) header = 1;
    else if (o.header === "A") header = 2;
    else if (Array.isArray(o.header)) header = 3;
    else if (o.header == null) header = 0;
    switch(typeof range){
        case 'string':
            r = $b8f343bf88dacc48$var$safe_decode_range(range);
            break;
        case 'number':
            r = $b8f343bf88dacc48$var$safe_decode_range(sheet["!ref"]);
            r.s.r = range;
            break;
        default:
            r = range;
    }
    if (header > 0) offset = 0;
    var rr = $b8f343bf88dacc48$var$encode_row(r.s.r);
    var cols /*:Array<string>*/  = [];
    var out /*:Array<any>*/  = [];
    var outi = 0, counter = 0;
    var dense = sheet["!data"] != null;
    var R = r.s.r, C = 0;
    var header_cnt = {};
    if (dense && !sheet["!data"][R]) sheet["!data"][R] = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(C = r.s.c; C <= r.e.c; ++C){
        if ((colinfo[C] || {}).hidden) continue;
        cols[C] = $b8f343bf88dacc48$var$encode_col(C);
        val = dense ? sheet["!data"][R][C] : sheet[cols[C] + rr];
        switch(header){
            case 1:
                hdr[C] = C - r.s.c;
                break;
            case 2:
                hdr[C] = cols[C];
                break;
            case 3:
                hdr[C] = o.header[C - r.s.c];
                break;
            default:
                if (val == null) val = {
                    w: "__EMPTY",
                    t: "s"
                };
                vv = v = $b8f343bf88dacc48$var$format_cell(val, null, o);
                counter = header_cnt[v] || 0;
                if (!counter) header_cnt[v] = 1;
                else {
                    do vv = v + "_" + counter++;
                    while (header_cnt[vv]);
                    header_cnt[v] = counter;
                    header_cnt[vv] = 1;
                }
                hdr[C] = vv;
        }
    }
    for(R = r.s.r + offset; R <= r.e.r; ++R){
        if ((rowinfo[R] || {}).hidden) continue;
        var row = $b8f343bf88dacc48$var$make_json_row(sheet, r, R, cols, header, hdr, o);
        if (row.isempty === false || (header === 1 ? o.blankrows !== false : !!o.blankrows)) out[outi++] = row.row;
    }
    out.length = outi;
    return out;
}
var $b8f343bf88dacc48$var$qreg = /"/g;
function $b8f343bf88dacc48$var$make_csv_row(sheet /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , cols /*:Array<string>*/ , fs /*:number*/ , rs /*:number*/ , FS /*:string*/ , o /*:Sheet2CSVOpts*/ ) /*:?string*/ {
    var isempty = true;
    var row /*:Array<string>*/  = [], txt = "", rr = $b8f343bf88dacc48$var$encode_row(R);
    var dense = sheet["!data"] != null;
    var datarow = dense && sheet["!data"][R] || [];
    for(var C = r.s.c; C <= r.e.c; ++C){
        if (!cols[C]) continue;
        var val = dense ? datarow[C] : sheet[cols[C] + rr];
        if (val == null) txt = "";
        else if (val.v != null) {
            isempty = false;
            txt = '' + (o.rawNumbers && val.t == "n" ? val.v : $b8f343bf88dacc48$var$format_cell(val, null, o));
            for(var i = 0, cc = 0; i !== txt.length; ++i)if ((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34 || o.forceQuotes) {
                txt = "\"" + txt.replace($b8f343bf88dacc48$var$qreg, '""') + "\"";
                break;
            }
            if (txt == "ID") txt = '"ID"';
        } else if (val.f != null && !val.F) {
            isempty = false;
            txt = '=' + val.f;
            if (txt.indexOf(",") >= 0) txt = '"' + txt.replace($b8f343bf88dacc48$var$qreg, '""') + '"';
        } else txt = "";
        /* NOTE: Excel CSV does not support array formulae */ row.push(txt);
    }
    if (o.strip) while(row[row.length - 1] === "")--row.length;
    if (o.blankrows === false && isempty) return null;
    return row.join(FS);
}
function $b8f343bf88dacc48$var$sheet_to_csv(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [];
    var o = opts == null ? {} : opts;
    if (sheet == null || sheet["!ref"] == null) return "";
    var r = $b8f343bf88dacc48$var$safe_decode_range(sheet["!ref"]);
    var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
    var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
    var row = "", cols /*:Array<string>*/  = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(var C = r.s.c; C <= r.e.c; ++C)if (!(colinfo[C] || {}).hidden) cols[C] = $b8f343bf88dacc48$var$encode_col(C);
    var w = 0;
    for(var R = r.s.r; R <= r.e.r; ++R){
        if ((rowinfo[R] || {}).hidden) continue;
        row = $b8f343bf88dacc48$var$make_csv_row(sheet, r, R, cols, fs, rs, FS, o);
        if (row == null) continue;
        if (row || o.blankrows !== false) out.push((w++ ? RS : "") + row);
    }
    return out.join("");
}
function $b8f343bf88dacc48$var$sheet_to_txt(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    if (!opts) opts = {};
    opts.FS = "\t";
    opts.RS = "\n";
    var s = $b8f343bf88dacc48$var$sheet_to_csv(sheet, opts);
    if (typeof $b8f343bf88dacc48$var$$cptable == 'undefined' || opts.type == 'string') return s;
    var o = $b8f343bf88dacc48$var$$cptable.utils.encode(1200, s, 'str');
    return String.fromCharCode(255) + String.fromCharCode(254) + o;
}
function $b8f343bf88dacc48$var$sheet_to_formulae(sheet /*:Worksheet*/ ) /*:Array<string>*/ {
    var y = "", x, val = "";
    if (sheet == null || sheet["!ref"] == null) return [];
    var r = $b8f343bf88dacc48$var$safe_decode_range(sheet['!ref']), rr = "", cols /*:Array<string>*/  = [], C;
    var cmds /*:Array<string>*/  = [];
    var dense = sheet["!data"] != null;
    for(C = r.s.c; C <= r.e.c; ++C)cols[C] = $b8f343bf88dacc48$var$encode_col(C);
    for(var R = r.s.r; R <= r.e.r; ++R){
        rr = $b8f343bf88dacc48$var$encode_row(R);
        for(C = r.s.c; C <= r.e.c; ++C){
            y = cols[C] + rr;
            x = dense ? (sheet["!data"][R] || [])[C] : sheet[y];
            val = "";
            if (x === undefined) continue;
            else if (x.F != null) {
                y = x.F;
                if (!x.f) continue;
                val = x.f;
                if (y.indexOf(":") == -1) y = y + ":" + y;
            }
            if (x.f != null) val = x.f;
            else if (x.t == 'z') continue;
            else if (x.t == 'n' && x.v != null) val = "" + x.v;
            else if (x.t == 'b') val = x.v ? "TRUE" : "FALSE";
            else if (x.w !== undefined) val = "'" + x.w;
            else if (x.v === undefined) continue;
            else if (x.t == 's') val = "'" + x.v;
            else val = "" + x.v;
            cmds[cmds.length] = y + "=" + val;
        }
    }
    return cmds;
}
function $b8f343bf88dacc48$var$sheet_add_json(_ws /*:?Worksheet*/ , js /*:Array<any>*/ , opts) /*:Worksheet*/ {
    var o = opts || {};
    var dense = _ws ? _ws["!data"] != null : o.dense;
    if ($b8f343bf88dacc48$var$DENSE != null && dense == null) dense = $b8f343bf88dacc48$var$DENSE;
    var offset = +!o.skipHeader;
    var ws /*:Worksheet*/  = _ws || {};
    if (!_ws && dense) ws["!data"] = [];
    var _R = 0, _C = 0;
    if (ws && o.origin != null) {
        if (typeof o.origin == 'number') _R = o.origin;
        else {
            var _origin /*:CellAddress*/  = typeof o.origin == "string" ? $b8f343bf88dacc48$var$decode_cell(o.origin) : o.origin;
            _R = _origin.r;
            _C = _origin.c;
        }
    }
    var range /*:Range*/  = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: _C,
            r: _R + js.length - 1 + offset
        }
    } /*:any*/ ;
    if (ws['!ref']) {
        var _range = $b8f343bf88dacc48$var$safe_decode_range(ws['!ref']);
        range.e.c = Math.max(range.e.c, _range.e.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        if (_R == -1) {
            _R = _range.e.r + 1;
            range.e.r = _R + js.length - 1 + offset;
        }
    } else if (_R == -1) {
        _R = 0;
        range.e.r = js.length - 1 + offset;
    }
    var hdr /*:Array<string>*/  = o.header || [], C = 0;
    var ROW = [];
    js.forEach(function(JS, R /*:number*/ ) {
        if (dense && !ws["!data"][_R + R + offset]) ws["!data"][_R + R + offset] = [];
        if (dense) ROW = ws["!data"][_R + R + offset];
        $b8f343bf88dacc48$var$keys(JS).forEach(function(k) {
            if ((C = hdr.indexOf(k)) == -1) hdr[C = hdr.length] = k;
            var v = JS[k];
            var t = 'z';
            var z = "";
            var ref = dense ? "" : $b8f343bf88dacc48$var$encode_col(_C + C) + $b8f343bf88dacc48$var$encode_row(_R + R + offset);
            var cell /*:Cell*/  = dense ? ROW[_C + C] : ws[ref];
            if (v && typeof v === 'object' && !(v instanceof Date)) {
                if (dense) ROW[_C + C] = v;
                else ws[ref] = v;
            } else {
                if (typeof v == 'number') t = 'n';
                else if (typeof v == 'boolean') t = 'b';
                else if (typeof v == 'string') t = 's';
                else if (v instanceof Date) {
                    t = 'd';
                    if (!o.UTC) v = $b8f343bf88dacc48$var$local_to_utc(v);
                    if (!o.cellDates) {
                        t = 'n';
                        v = $b8f343bf88dacc48$var$datenum(v);
                    }
                    z = cell != null && cell.z && $b8f343bf88dacc48$var$fmt_is_date(cell.z) ? cell.z : o.dateNF || $b8f343bf88dacc48$var$table_fmt[14];
                } else if (v === null && o.nullError) {
                    t = 'e';
                    v = 0;
                }
                if (!cell) {
                    if (!dense) ws[ref] = cell = {
                        t: t,
                        v: v
                    } /*:any*/ ;
                    else ROW[_C + C] = cell = {
                        t: t,
                        v: v
                    } /*:any*/ ;
                } else {
                    cell.t = t;
                    cell.v = v;
                    delete cell.w;
                    delete cell.R;
                    if (z) cell.z = z;
                }
                if (z) cell.z = z;
            }
        });
    });
    range.e.c = Math.max(range.e.c, _C + hdr.length - 1);
    var __R = $b8f343bf88dacc48$var$encode_row(_R);
    if (dense && !ws["!data"][_R]) ws["!data"][_R] = [];
    if (offset) for(C = 0; C < hdr.length; ++C)if (dense) ws["!data"][_R][C + _C] = {
        t: 's',
        v: hdr[C]
    };
    else ws[$b8f343bf88dacc48$var$encode_col(C + _C) + __R] = {
        t: 's',
        v: hdr[C]
    };
    ws['!ref'] = $b8f343bf88dacc48$var$encode_range(range);
    return ws;
}
function $b8f343bf88dacc48$var$json_to_sheet(js /*:Array<any>*/ , opts) /*:Worksheet*/ {
    return $b8f343bf88dacc48$var$sheet_add_json(null, js, opts);
}
/* get cell, creating a stub if necessary */ function $b8f343bf88dacc48$var$ws_get_cell_stub(ws /*:Worksheet*/ , R, C /*:?number*/ ) /*:Cell*/ {
    /* A1 cell address */ if (typeof R == "string") {
        if (ws["!data"] != null) {
            var RC = $b8f343bf88dacc48$var$decode_cell(R);
            if (!ws["!data"][RC.r]) ws["!data"][RC.r] = [];
            return ws["!data"][RC.r][RC.c] || (ws["!data"][RC.r][RC.c] = {
                t: 'z'
            });
        }
        return ws[R] || (ws[R] = {
            t: 'z'
        });
    }
    /* cell address object */ if (typeof R != "number") return $b8f343bf88dacc48$var$ws_get_cell_stub(ws, $b8f343bf88dacc48$var$encode_cell(R));
    /* R and C are 0-based indices */ return $b8f343bf88dacc48$var$ws_get_cell_stub(ws, $b8f343bf88dacc48$var$encode_col(C || 0) + $b8f343bf88dacc48$var$encode_row(R));
}
/* find sheet index for given name / validate index */ function $b8f343bf88dacc48$var$wb_sheet_idx(wb /*:Workbook*/ , sh /*:number|string*/ ) {
    if (typeof sh == "number") {
        if (sh >= 0 && wb.SheetNames.length > sh) return sh;
        throw new Error("Cannot find sheet # " + sh);
    } else if (typeof sh == "string") {
        var idx = wb.SheetNames.indexOf(sh);
        if (idx > -1) return idx;
        throw new Error("Cannot find sheet name |" + sh + "|");
    } else throw new Error("Cannot find sheet |" + sh + "|");
}
/* simple blank or single-sheet workbook object */ function $b8f343bf88dacc48$var$book_new(ws /*:?Worksheet*/ , wsname /*:?string*/ ) /*:Workbook*/ {
    var wb = {
        SheetNames: [],
        Sheets: {}
    };
    if (ws) $b8f343bf88dacc48$var$book_append_sheet(wb, ws, wsname || "Sheet1");
    return wb;
}
/* add a worksheet to the end of a given workbook */ function $b8f343bf88dacc48$var$book_append_sheet(wb /*:Workbook*/ , ws /*:Worksheet*/ , name /*:?string*/ , roll /*:?boolean*/ ) /*:string*/ {
    var i = 1;
    if (!name) {
        for(; i <= 0xFFFF; ++i, name = undefined)if (wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
    }
    if (!name || wb.SheetNames.length >= 0xFFFF) throw new Error("Too many worksheets");
    if (roll && wb.SheetNames.indexOf(name) >= 0 && name.length < 32) {
        var m = name.match(/\d+$/); // at this point, name length is capped at 32
        i = m && +m[0] || 0;
        var root = m && name.slice(0, m.index) || name;
        for(++i; i <= 0xFFFF; ++i)if (wb.SheetNames.indexOf(name = root + i) == -1) break;
    }
    $b8f343bf88dacc48$var$check_ws_name(name);
    if (wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with name |" + name + "| already exists!");
    wb.SheetNames.push(name);
    wb.Sheets[name] = ws;
    return name;
}
/* set sheet visibility (visible/hidden/very hidden) */ function $b8f343bf88dacc48$var$book_set_sheet_visibility(wb /*:Workbook*/ , sh /*:number|string*/ , vis /*:number*/ ) {
    if (!wb.Workbook) wb.Workbook = {};
    if (!wb.Workbook.Sheets) wb.Workbook.Sheets = [];
    var idx = $b8f343bf88dacc48$var$wb_sheet_idx(wb, sh);
    // $FlowIgnore
    if (!wb.Workbook.Sheets[idx]) wb.Workbook.Sheets[idx] = {};
    switch(vis){
        case 0:
        case 1:
        case 2:
            break;
        default:
            throw new Error("Bad sheet visibility setting " + vis);
    }
    // $FlowIgnore
    wb.Workbook.Sheets[idx].Hidden = vis;
}
/* set number format */ function $b8f343bf88dacc48$var$cell_set_number_format(cell /*:Cell*/ , fmt /*:string|number*/ ) {
    cell.z = fmt;
    return cell;
}
/* set cell hyperlink */ function $b8f343bf88dacc48$var$cell_set_hyperlink(cell /*:Cell*/ , target /*:string*/ , tooltip /*:?string*/ ) {
    if (!target) delete cell.l;
    else {
        cell.l = {
            Target: target
        } /*:Hyperlink*/ ;
        if (tooltip) cell.l.Tooltip = tooltip;
    }
    return cell;
}
function $b8f343bf88dacc48$var$cell_set_internal_link(cell /*:Cell*/ , range /*:string*/ , tooltip /*:?string*/ ) {
    return $b8f343bf88dacc48$var$cell_set_hyperlink(cell, "#" + range, tooltip);
}
/* add to cell comments */ function $b8f343bf88dacc48$var$cell_add_comment(cell /*:Cell*/ , text /*:string*/ , author /*:?string*/ ) {
    if (!cell.c) cell.c = [];
    cell.c.push({
        t: text,
        a: author || "SheetJS"
    });
}
/* set array formula and flush related cells */ function $b8f343bf88dacc48$var$sheet_set_array_formula(ws /*:Worksheet*/ , range, formula /*:string*/ , dynamic /*:boolean*/ ) {
    var rng = typeof range != "string" ? range : $b8f343bf88dacc48$var$safe_decode_range(range);
    var rngstr = typeof range == "string" ? range : $b8f343bf88dacc48$var$encode_range(range);
    for(var R = rng.s.r; R <= rng.e.r; ++R)for(var C = rng.s.c; C <= rng.e.c; ++C){
        var cell = $b8f343bf88dacc48$var$ws_get_cell_stub(ws, R, C);
        cell.t = 'n';
        cell.F = rngstr;
        delete cell.v;
        if (R == rng.s.r && C == rng.s.c) {
            cell.f = formula;
            if (dynamic) cell.D = true;
        }
    }
    var wsr = $b8f343bf88dacc48$var$decode_range(ws["!ref"]);
    if (wsr.s.r > rng.s.r) wsr.s.r = rng.s.r;
    if (wsr.s.c > rng.s.c) wsr.s.c = rng.s.c;
    if (wsr.e.r < rng.e.r) wsr.e.r = rng.e.r;
    if (wsr.e.c < rng.e.c) wsr.e.c = rng.e.c;
    ws["!ref"] = $b8f343bf88dacc48$var$encode_range(wsr);
    return ws;
}
var $b8f343bf88dacc48$export$eab97d15b1788b8d /*:any*/  = {
    encode_col: $b8f343bf88dacc48$var$encode_col,
    encode_row: $b8f343bf88dacc48$var$encode_row,
    encode_cell: $b8f343bf88dacc48$var$encode_cell,
    encode_range: $b8f343bf88dacc48$var$encode_range,
    decode_col: $b8f343bf88dacc48$var$decode_col,
    decode_row: $b8f343bf88dacc48$var$decode_row,
    split_cell: $b8f343bf88dacc48$var$split_cell,
    decode_cell: $b8f343bf88dacc48$var$decode_cell,
    decode_range: $b8f343bf88dacc48$var$decode_range,
    format_cell: $b8f343bf88dacc48$var$format_cell,
    sheet_new: $b8f343bf88dacc48$var$sheet_new,
    sheet_add_aoa: $b8f343bf88dacc48$var$sheet_add_aoa,
    sheet_add_json: $b8f343bf88dacc48$var$sheet_add_json,
    sheet_add_dom: $b8f343bf88dacc48$var$sheet_add_dom,
    aoa_to_sheet: $b8f343bf88dacc48$var$aoa_to_sheet,
    json_to_sheet: $b8f343bf88dacc48$var$json_to_sheet,
    table_to_sheet: $b8f343bf88dacc48$var$parse_dom_table,
    table_to_book: $b8f343bf88dacc48$var$table_to_book,
    sheet_to_csv: $b8f343bf88dacc48$var$sheet_to_csv,
    sheet_to_txt: $b8f343bf88dacc48$var$sheet_to_txt,
    sheet_to_json: $b8f343bf88dacc48$var$sheet_to_json,
    sheet_to_html: $b8f343bf88dacc48$var$sheet_to_html,
    sheet_to_formulae: $b8f343bf88dacc48$var$sheet_to_formulae,
    sheet_to_row_object_array: $b8f343bf88dacc48$var$sheet_to_json,
    sheet_get_cell: $b8f343bf88dacc48$var$ws_get_cell_stub,
    book_new: $b8f343bf88dacc48$var$book_new,
    book_append_sheet: $b8f343bf88dacc48$var$book_append_sheet,
    book_set_sheet_visibility: $b8f343bf88dacc48$var$book_set_sheet_visibility,
    cell_set_number_format: $b8f343bf88dacc48$var$cell_set_number_format,
    cell_set_hyperlink: $b8f343bf88dacc48$var$cell_set_hyperlink,
    cell_set_internal_link: $b8f343bf88dacc48$var$cell_set_internal_link,
    cell_add_comment: $b8f343bf88dacc48$var$cell_add_comment,
    sheet_set_array_formula: $b8f343bf88dacc48$var$sheet_set_array_formula,
    consts: {
        SHEET_VISIBLE: 0,
        SHEET_HIDDEN: 1,
        SHEET_VERY_HIDDEN: 2
    }
};
var $b8f343bf88dacc48$var$_Readable;
function $b8f343bf88dacc48$var$set_readable(R) {
    $b8f343bf88dacc48$var$_Readable = R;
}
function $b8f343bf88dacc48$var$write_csv_stream(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    var stream = $b8f343bf88dacc48$var$_Readable();
    var o = opts == null ? {} : opts;
    if (sheet == null || sheet["!ref"] == null) {
        stream.push(null);
        return stream;
    }
    var r = $b8f343bf88dacc48$var$safe_decode_range(sheet["!ref"]);
    var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
    var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
    var row /*:?string*/  = "", cols /*:Array<string>*/  = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<RowInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(var C = r.s.c; C <= r.e.c; ++C)if (!(colinfo[C] || {}).hidden) cols[C] = $b8f343bf88dacc48$var$encode_col(C);
    var R = r.s.r;
    var BOM = false, w = 0;
    stream._read = function() {
        if (!BOM) {
            BOM = true;
            return stream.push("\uFEFF");
        }
        while(R <= r.e.r){
            ++R;
            if ((rowinfo[R - 1] || {}).hidden) continue;
            row = $b8f343bf88dacc48$var$make_csv_row(sheet, r, R - 1, cols, fs, rs, FS, o);
            if (row != null) {
                if (row || o.blankrows !== false) return stream.push((w++ ? RS : "") + row);
            }
        }
        return stream.push(null);
    };
    return stream;
}
function $b8f343bf88dacc48$var$write_html_stream(ws /*:Worksheet*/ , opts /*:?Sheet2HTMLOpts*/ ) {
    var stream = $b8f343bf88dacc48$var$_Readable();
    var o = opts || {};
    var header = o.header != null ? o.header : $b8f343bf88dacc48$var$HTML_BEGIN;
    var footer = o.footer != null ? o.footer : $b8f343bf88dacc48$var$HTML_END;
    stream.push(header);
    var r = $b8f343bf88dacc48$var$decode_range(ws['!ref']);
    stream.push($b8f343bf88dacc48$var$make_html_preamble(ws, r, o));
    var R = r.s.r;
    var end = false;
    stream._read = function() {
        if (R > r.e.r) {
            if (!end) {
                end = true;
                stream.push("</table>" + footer);
            }
            return stream.push(null);
        }
        while(R <= r.e.r){
            stream.push($b8f343bf88dacc48$var$make_html_row(ws, r, R, o));
            ++R;
            break;
        }
    };
    return stream;
}
function $b8f343bf88dacc48$var$write_json_stream(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    var stream = $b8f343bf88dacc48$var$_Readable({
        objectMode: true
    });
    if (sheet == null || sheet["!ref"] == null) {
        stream.push(null);
        return stream;
    }
    var val = {
        t: 'n',
        v: 0
    }, header = 0, offset = 1, hdr /*:Array<any>*/  = [], v = 0, vv = "";
    var r = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var o = opts || {};
    var range = o.range != null ? o.range : sheet["!ref"];
    if (o.header === 1) header = 1;
    else if (o.header === "A") header = 2;
    else if (Array.isArray(o.header)) header = 3;
    switch(typeof range){
        case 'string':
            r = $b8f343bf88dacc48$var$safe_decode_range(range);
            break;
        case 'number':
            r = $b8f343bf88dacc48$var$safe_decode_range(sheet["!ref"]);
            r.s.r = range;
            break;
        default:
            r = range;
    }
    if (header > 0) offset = 0;
    var rr = $b8f343bf88dacc48$var$encode_row(r.s.r);
    var cols /*:Array<string>*/  = [];
    var counter = 0;
    var dense = sheet["!data"] != null;
    var R = r.s.r, C = 0;
    var header_cnt = {};
    if (dense && !sheet["!data"][R]) sheet["!data"][R] = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<RowInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(C = r.s.c; C <= r.e.c; ++C){
        if ((colinfo[C] || {}).hidden) continue;
        cols[C] = $b8f343bf88dacc48$var$encode_col(C);
        val = dense ? sheet["!data"][R][C] : sheet[cols[C] + rr];
        switch(header){
            case 1:
                hdr[C] = C - r.s.c;
                break;
            case 2:
                hdr[C] = cols[C];
                break;
            case 3:
                hdr[C] = o.header[C - r.s.c];
                break;
            default:
                if (val == null) val = {
                    w: "__EMPTY",
                    t: "s"
                };
                vv = v = $b8f343bf88dacc48$var$format_cell(val, null, o);
                counter = header_cnt[v] || 0;
                if (!counter) header_cnt[v] = 1;
                else {
                    do vv = v + "_" + counter++;
                    while (header_cnt[vv]);
                    header_cnt[v] = counter;
                    header_cnt[vv] = 1;
                }
                hdr[C] = vv;
        }
    }
    R = r.s.r + offset;
    stream._read = function() {
        while(R <= r.e.r){
            if ((rowinfo[R - 1] || {}).hidden) continue;
            var row = $b8f343bf88dacc48$var$make_json_row(sheet, r, R, cols, header, hdr, o);
            ++R;
            if (row.isempty === false || (header === 1 ? o.blankrows !== false : !!o.blankrows)) {
                stream.push(row.row);
                return;
            }
        }
        return stream.push(null);
    };
    return stream;
}
var $b8f343bf88dacc48$export$4938110305e6185f = {
    to_json: $b8f343bf88dacc48$var$write_json_stream,
    to_html: $b8f343bf88dacc48$var$write_html_stream,
    to_csv: $b8f343bf88dacc48$var$write_csv_stream,
    set_readable: $b8f343bf88dacc48$var$set_readable
};
const $b8f343bf88dacc48$export$83d89fbfd8236492 = $b8f343bf88dacc48$var$XLSX.version;
var $b8f343bf88dacc48$export$2e2bcd8739ae039 = {
    parse_xlscfb: $b8f343bf88dacc48$export$b41972a043aba84c,
    parse_zip: $b8f343bf88dacc48$export$b165387946f79a1,
    read: $b8f343bf88dacc48$export$aafa59e2e03f2942,
    readFile: $b8f343bf88dacc48$export$72c04af63de9061a,
    readFileSync: $b8f343bf88dacc48$export$72c04af63de9061a,
    write: $b8f343bf88dacc48$export$68d8715fc104d294,
    writeFile: $b8f343bf88dacc48$export$552bfb764b5cd2b4,
    writeFileSync: $b8f343bf88dacc48$export$552bfb764b5cd2b4,
    writeFileAsync: $b8f343bf88dacc48$export$25469296c4b8ebda,
    writeXLSX: $b8f343bf88dacc48$export$f6ca43591cb061b1,
    writeFileXLSX: $b8f343bf88dacc48$export$40a06aea54ee074e,
    utils: $b8f343bf88dacc48$export$eab97d15b1788b8d,
    set_fs: $b8f343bf88dacc48$export$a48eb669e1768bcf,
    set_cptable: $b8f343bf88dacc48$export$58f247d16f363b86,
    stream: $b8f343bf88dacc48$export$4938110305e6185f,
    SSF: $b8f343bf88dacc48$export$40d8edd678456c2b,
    CFB: $b8f343bf88dacc48$export$9f0e51cd97c572a
};



var $3gspO = parcelRequire("3gspO");
var $0ba1812d3e9b7dec$exports = {};
'use strict';
var $f11c3627e8ea9d88$exports = {};

$parcel$export($f11c3627e8ea9d88$exports, "validate", () => $f11c3627e8ea9d88$export$a22775fa5e2eebd9, (v) => $f11c3627e8ea9d88$export$a22775fa5e2eebd9 = v);
//const tagsPattern = new RegExp("<\\/?([\\w:\\-_\.]+)\\s*\/?>","g");
var $f11c3627e8ea9d88$export$a22775fa5e2eebd9;
'use strict';
var $f0c3a3336ccedb73$export$a5edf3f35b6dd392;
var $f0c3a3336ccedb73$export$83b788b1a3698c03;
/**
 * Copy all the properties of a into b.
 * @param {*} target
 * @param {*} a
 */ var $f0c3a3336ccedb73$export$4950aa0f605343fb;
/* exports.merge =function (b,a){
  return Object.assign(b,a);
} */ var $f0c3a3336ccedb73$export$bf7199a9ebcb84a9;
// const fakeCall = function(a) {return a;};
// const fakeCallNoReturn = function() {};
var $f0c3a3336ccedb73$export$998d7ff9801e90bb;
var $f0c3a3336ccedb73$export$aaa9734c55cb7a19;
var $f0c3a3336ccedb73$export$e8f2644f7085b4b1;
'use strict';
const $f0c3a3336ccedb73$var$nameStartChar = ':A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
const $f0c3a3336ccedb73$var$nameChar = $f0c3a3336ccedb73$var$nameStartChar + '\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
const $f0c3a3336ccedb73$var$nameRegexp = '[' + $f0c3a3336ccedb73$var$nameStartChar + '][' + $f0c3a3336ccedb73$var$nameChar + ']*';
const $f0c3a3336ccedb73$var$regexName = new RegExp('^' + $f0c3a3336ccedb73$var$nameRegexp + '$');
const $f0c3a3336ccedb73$var$getAllMatches = function(string, regex) {
    const matches = [];
    let match = regex.exec(string);
    while(match){
        const allmatches = [];
        allmatches.startIndex = regex.lastIndex - match[0].length;
        const len = match.length;
        for(let index = 0; index < len; index++)allmatches.push(match[index]);
        matches.push(allmatches);
        match = regex.exec(string);
    }
    return matches;
};
const $f0c3a3336ccedb73$var$isName = function(string) {
    const match = $f0c3a3336ccedb73$var$regexName.exec(string);
    return !(match === null || typeof match === 'undefined');
};
$f0c3a3336ccedb73$export$a5edf3f35b6dd392 = function(v) {
    return typeof v !== 'undefined';
};
$f0c3a3336ccedb73$export$83b788b1a3698c03 = function(obj) {
    return Object.keys(obj).length === 0;
};
$f0c3a3336ccedb73$export$4950aa0f605343fb = function(target, a, arrayMode) {
    if (a) {
        const keys = Object.keys(a); // will return an array of own properties
        const len = keys.length; //don't make it inline
        for(let i = 0; i < len; i++)if (arrayMode === 'strict') target[keys[i]] = [
            a[keys[i]]
        ];
        else target[keys[i]] = a[keys[i]];
    }
};
$f0c3a3336ccedb73$export$bf7199a9ebcb84a9 = function(v) {
    if ($f0c3a3336ccedb73$export$a5edf3f35b6dd392(v)) return v;
    else return '';
};
$f0c3a3336ccedb73$export$998d7ff9801e90bb = $f0c3a3336ccedb73$var$isName;
$f0c3a3336ccedb73$export$aaa9734c55cb7a19 = $f0c3a3336ccedb73$var$getAllMatches;
$f0c3a3336ccedb73$export$e8f2644f7085b4b1 = $f0c3a3336ccedb73$var$nameRegexp;


const $f11c3627e8ea9d88$var$defaultOptions = {
    allowBooleanAttributes: false,
    unpairedTags: []
};
$f11c3627e8ea9d88$export$a22775fa5e2eebd9 = function(xmlData, options) {
    options = Object.assign({}, $f11c3627e8ea9d88$var$defaultOptions, options);
    //xmlData = xmlData.replace(/(\r\n|\n|\r)/gm,"");//make it single line
    //xmlData = xmlData.replace(/(^\s*<\?xml.*?\?>)/g,"");//Remove XML starting tag
    //xmlData = xmlData.replace(/(<!DOCTYPE[\s\w\"\.\/\-\:]+(\[.*\])*\s*>)/g,"");//Remove DOCTYPE
    const tags = [];
    let tagFound = false;
    //indicates that the root tag has been closed (aka. depth 0 has been reached)
    let reachedRoot = false;
    if (xmlData[0] === '\ufeff') // check for byte order mark (BOM)
    xmlData = xmlData.substr(1);
    for(let i = 0; i < xmlData.length; i++){
        if (xmlData[i] === '<' && xmlData[i + 1] === '?') {
            i += 2;
            i = $f11c3627e8ea9d88$var$readPI(xmlData, i);
            if (i.err) return i;
        } else if (xmlData[i] === '<') {
            //starting of tag
            //read until you reach to '>' avoiding any '>' in attribute value
            let tagStartPos = i;
            i++;
            if (xmlData[i] === '!') {
                i = $f11c3627e8ea9d88$var$readCommentAndCDATA(xmlData, i);
                continue;
            } else {
                let closingTag = false;
                if (xmlData[i] === '/') {
                    //closing tag
                    closingTag = true;
                    i++;
                }
                //read tagname
                let tagName = '';
                for(; i < xmlData.length && xmlData[i] !== '>' && xmlData[i] !== ' ' && xmlData[i] !== '\t' && xmlData[i] !== '\n' && xmlData[i] !== '\r'; i++)tagName += xmlData[i];
                tagName = tagName.trim();
                //console.log(tagName);
                if (tagName[tagName.length - 1] === '/') {
                    //self closing tag without attributes
                    tagName = tagName.substring(0, tagName.length - 1);
                    //continue;
                    i--;
                }
                if (!$f11c3627e8ea9d88$var$validateTagName(tagName)) {
                    let msg;
                    if (tagName.trim().length === 0) msg = "Invalid space after '<'.";
                    else msg = "Tag '" + tagName + "' is an invalid name.";
                    return $f11c3627e8ea9d88$var$getErrorObject('InvalidTag', msg, $f11c3627e8ea9d88$var$getLineNumberForPosition(xmlData, i));
                }
                const result = $f11c3627e8ea9d88$var$readAttributeStr(xmlData, i);
                if (result === false) return $f11c3627e8ea9d88$var$getErrorObject('InvalidAttr', "Attributes for '" + tagName + "' have open quote.", $f11c3627e8ea9d88$var$getLineNumberForPosition(xmlData, i));
                let attrStr = result.value;
                i = result.index;
                if (attrStr[attrStr.length - 1] === '/') {
                    //self closing tag
                    const attrStrStart = i - attrStr.length;
                    attrStr = attrStr.substring(0, attrStr.length - 1);
                    const isValid = $f11c3627e8ea9d88$var$validateAttributeString(attrStr, options);
                    if (isValid === true) tagFound = true;
                    else //the result from the nested function returns the position of the error within the attribute
                    //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                    //this gives us the absolute index in the entire xml, which we can use to find the line at last
                    return $f11c3627e8ea9d88$var$getErrorObject(isValid.err.code, isValid.err.msg, $f11c3627e8ea9d88$var$getLineNumberForPosition(xmlData, attrStrStart + isValid.err.line));
                } else if (closingTag) {
                    if (!result.tagClosed) return $f11c3627e8ea9d88$var$getErrorObject('InvalidTag', "Closing tag '" + tagName + "' doesn't have proper closing.", $f11c3627e8ea9d88$var$getLineNumberForPosition(xmlData, i));
                    else if (attrStr.trim().length > 0) return $f11c3627e8ea9d88$var$getErrorObject('InvalidTag', "Closing tag '" + tagName + "' can't have attributes or invalid starting.", $f11c3627e8ea9d88$var$getLineNumberForPosition(xmlData, tagStartPos));
                    else if (tags.length === 0) return $f11c3627e8ea9d88$var$getErrorObject('InvalidTag', "Closing tag '" + tagName + "' has not been opened.", $f11c3627e8ea9d88$var$getLineNumberForPosition(xmlData, tagStartPos));
                    else {
                        const otg = tags.pop();
                        if (tagName !== otg.tagName) {
                            let openPos = $f11c3627e8ea9d88$var$getLineNumberForPosition(xmlData, otg.tagStartPos);
                            return $f11c3627e8ea9d88$var$getErrorObject('InvalidTag', "Expected closing tag '" + otg.tagName + "' (opened in line " + openPos.line + ", col " + openPos.col + ") instead of closing tag '" + tagName + "'.", $f11c3627e8ea9d88$var$getLineNumberForPosition(xmlData, tagStartPos));
                        }
                        //when there are no more tags, we reached the root level.
                        if (tags.length == 0) reachedRoot = true;
                    }
                } else {
                    const isValid = $f11c3627e8ea9d88$var$validateAttributeString(attrStr, options);
                    if (isValid !== true) //the result from the nested function returns the position of the error within the attribute
                    //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                    //this gives us the absolute index in the entire xml, which we can use to find the line at last
                    return $f11c3627e8ea9d88$var$getErrorObject(isValid.err.code, isValid.err.msg, $f11c3627e8ea9d88$var$getLineNumberForPosition(xmlData, i - attrStr.length + isValid.err.line));
                    //if the root level has been reached before ...
                    if (reachedRoot === true) return $f11c3627e8ea9d88$var$getErrorObject('InvalidXml', 'Multiple possible root nodes found.', $f11c3627e8ea9d88$var$getLineNumberForPosition(xmlData, i));
                    else if (options.unpairedTags.indexOf(tagName) !== -1) ;
                    else tags.push({
                        tagName: tagName,
                        tagStartPos: tagStartPos
                    });
                    tagFound = true;
                }
                //skip tag text value
                //It may include comments and CDATA value
                for(i++; i < xmlData.length; i++){
                    if (xmlData[i] === '<') {
                        if (xmlData[i + 1] === '!') {
                            //comment or CADATA
                            i++;
                            i = $f11c3627e8ea9d88$var$readCommentAndCDATA(xmlData, i);
                            continue;
                        } else if (xmlData[i + 1] === '?') {
                            i = $f11c3627e8ea9d88$var$readPI(xmlData, ++i);
                            if (i.err) return i;
                        } else break;
                    } else if (xmlData[i] === '&') {
                        const afterAmp = $f11c3627e8ea9d88$var$validateAmpersand(xmlData, i);
                        if (afterAmp == -1) return $f11c3627e8ea9d88$var$getErrorObject('InvalidChar', "char '&' is not expected.", $f11c3627e8ea9d88$var$getLineNumberForPosition(xmlData, i));
                        i = afterAmp;
                    } else {
                        if (reachedRoot === true && !$f11c3627e8ea9d88$var$isWhiteSpace(xmlData[i])) return $f11c3627e8ea9d88$var$getErrorObject('InvalidXml', "Extra text at the end", $f11c3627e8ea9d88$var$getLineNumberForPosition(xmlData, i));
                    }
                } //end of reading tag text value
                if (xmlData[i] === '<') i--;
            }
        } else {
            if ($f11c3627e8ea9d88$var$isWhiteSpace(xmlData[i])) continue;
            return $f11c3627e8ea9d88$var$getErrorObject('InvalidChar', "char '" + xmlData[i] + "' is not expected.", $f11c3627e8ea9d88$var$getLineNumberForPosition(xmlData, i));
        }
    }
    if (!tagFound) return $f11c3627e8ea9d88$var$getErrorObject('InvalidXml', 'Start tag expected.', 1);
    else if (tags.length == 1) return $f11c3627e8ea9d88$var$getErrorObject('InvalidTag', "Unclosed tag '" + tags[0].tagName + "'.", $f11c3627e8ea9d88$var$getLineNumberForPosition(xmlData, tags[0].tagStartPos));
    else if (tags.length > 0) return $f11c3627e8ea9d88$var$getErrorObject('InvalidXml', "Invalid '" + JSON.stringify(tags.map((t)=>t.tagName), null, 4).replace(/\r?\n/g, '') + "' found.", {
        line: 1,
        col: 1
    });
    return true;
};
function $f11c3627e8ea9d88$var$isWhiteSpace(char) {
    return char === ' ' || char === '\t' || char === '\n' || char === '\r';
}
/**
 * Read Processing insstructions and skip
 * @param {*} xmlData
 * @param {*} i
 */ function $f11c3627e8ea9d88$var$readPI(xmlData, i) {
    const start = i;
    for(; i < xmlData.length; i++)if (xmlData[i] == '?' || xmlData[i] == ' ') {
        //tagname
        const tagname = xmlData.substr(start, i - start);
        if (i > 5 && tagname === 'xml') return $f11c3627e8ea9d88$var$getErrorObject('InvalidXml', 'XML declaration allowed only at the start of the document.', $f11c3627e8ea9d88$var$getLineNumberForPosition(xmlData, i));
        else if (xmlData[i] == '?' && xmlData[i + 1] == '>') {
            //check if valid attribut string
            i++;
            break;
        } else continue;
    }
    return i;
}
function $f11c3627e8ea9d88$var$readCommentAndCDATA(xmlData, i) {
    if (xmlData.length > i + 5 && xmlData[i + 1] === '-' && xmlData[i + 2] === '-') {
        //comment
        for(i += 3; i < xmlData.length; i++)if (xmlData[i] === '-' && xmlData[i + 1] === '-' && xmlData[i + 2] === '>') {
            i += 2;
            break;
        }
    } else if (xmlData.length > i + 8 && xmlData[i + 1] === 'D' && xmlData[i + 2] === 'O' && xmlData[i + 3] === 'C' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'Y' && xmlData[i + 6] === 'P' && xmlData[i + 7] === 'E') {
        let angleBracketsCount = 1;
        for(i += 8; i < xmlData.length; i++){
            if (xmlData[i] === '<') angleBracketsCount++;
            else if (xmlData[i] === '>') {
                angleBracketsCount--;
                if (angleBracketsCount === 0) break;
            }
        }
    } else if (xmlData.length > i + 9 && xmlData[i + 1] === '[' && xmlData[i + 2] === 'C' && xmlData[i + 3] === 'D' && xmlData[i + 4] === 'A' && xmlData[i + 5] === 'T' && xmlData[i + 6] === 'A' && xmlData[i + 7] === '[') {
        for(i += 8; i < xmlData.length; i++)if (xmlData[i] === ']' && xmlData[i + 1] === ']' && xmlData[i + 2] === '>') {
            i += 2;
            break;
        }
    }
    return i;
}
const $f11c3627e8ea9d88$var$doubleQuote = '"';
const $f11c3627e8ea9d88$var$singleQuote = "'";
/**
 * Keep reading xmlData until '<' is found outside the attribute value.
 * @param {string} xmlData
 * @param {number} i
 */ function $f11c3627e8ea9d88$var$readAttributeStr(xmlData, i) {
    let attrStr = '';
    let startChar = '';
    let tagClosed = false;
    for(; i < xmlData.length; i++){
        if (xmlData[i] === $f11c3627e8ea9d88$var$doubleQuote || xmlData[i] === $f11c3627e8ea9d88$var$singleQuote) {
            if (startChar === '') startChar = xmlData[i];
            else if (startChar !== xmlData[i]) ;
            else startChar = '';
        } else if (xmlData[i] === '>') {
            if (startChar === '') {
                tagClosed = true;
                break;
            }
        }
        attrStr += xmlData[i];
    }
    if (startChar !== '') return false;
    return {
        value: attrStr,
        index: i,
        tagClosed: tagClosed
    };
}
/**
 * Select all the attributes whether valid or invalid.
 */ const $f11c3627e8ea9d88$var$validAttrStrRegxp = new RegExp('(\\s*)([^\\s=]+)(\\s*=)?(\\s*([\'"])(([\\s\\S])*?)\\5)?', 'g');
//attr, ="sd", a="amit's", a="sd"b="saf", ab  cd=""
function $f11c3627e8ea9d88$var$validateAttributeString(attrStr, options) {
    //console.log("start:"+attrStr+":end");
    //if(attrStr.trim().length === 0) return true; //empty string
    const matches = $f0c3a3336ccedb73$export$aaa9734c55cb7a19(attrStr, $f11c3627e8ea9d88$var$validAttrStrRegxp);
    const attrNames = {};
    for(let i = 0; i < matches.length; i++){
        if (matches[i][1].length === 0) //nospace before attribute name: a="sd"b="saf"
        return $f11c3627e8ea9d88$var$getErrorObject('InvalidAttr', "Attribute '" + matches[i][2] + "' has no space in starting.", $f11c3627e8ea9d88$var$getPositionFromMatch(matches[i]));
        else if (matches[i][3] !== undefined && matches[i][4] === undefined) return $f11c3627e8ea9d88$var$getErrorObject('InvalidAttr', "Attribute '" + matches[i][2] + "' is without value.", $f11c3627e8ea9d88$var$getPositionFromMatch(matches[i]));
        else if (matches[i][3] === undefined && !options.allowBooleanAttributes) //independent attribute: ab
        return $f11c3627e8ea9d88$var$getErrorObject('InvalidAttr', "boolean attribute '" + matches[i][2] + "' is not allowed.", $f11c3627e8ea9d88$var$getPositionFromMatch(matches[i]));
        /* else if(matches[i][6] === undefined){//attribute without value: ab=
                    return { err: { code:"InvalidAttr",msg:"attribute " + matches[i][2] + " has no value assigned."}};
                } */ const attrName = matches[i][2];
        if (!$f11c3627e8ea9d88$var$validateAttrName(attrName)) return $f11c3627e8ea9d88$var$getErrorObject('InvalidAttr', "Attribute '" + attrName + "' is an invalid name.", $f11c3627e8ea9d88$var$getPositionFromMatch(matches[i]));
        if (!attrNames.hasOwnProperty(attrName)) //check for duplicate attribute.
        attrNames[attrName] = 1;
        else return $f11c3627e8ea9d88$var$getErrorObject('InvalidAttr', "Attribute '" + attrName + "' is repeated.", $f11c3627e8ea9d88$var$getPositionFromMatch(matches[i]));
    }
    return true;
}
function $f11c3627e8ea9d88$var$validateNumberAmpersand(xmlData, i) {
    let re = /\d/;
    if (xmlData[i] === 'x') {
        i++;
        re = /[\da-fA-F]/;
    }
    for(; i < xmlData.length; i++){
        if (xmlData[i] === ';') return i;
        if (!xmlData[i].match(re)) break;
    }
    return -1;
}
function $f11c3627e8ea9d88$var$validateAmpersand(xmlData, i) {
    // https://www.w3.org/TR/xml/#dt-charref
    i++;
    if (xmlData[i] === ';') return -1;
    if (xmlData[i] === '#') {
        i++;
        return $f11c3627e8ea9d88$var$validateNumberAmpersand(xmlData, i);
    }
    let count = 0;
    for(; i < xmlData.length; i++, count++){
        if (xmlData[i].match(/\w/) && count < 20) continue;
        if (xmlData[i] === ';') break;
        return -1;
    }
    return i;
}
function $f11c3627e8ea9d88$var$getErrorObject(code, message, lineNumber) {
    return {
        err: {
            code: code,
            msg: message,
            line: lineNumber.line || lineNumber,
            col: lineNumber.col
        }
    };
}
function $f11c3627e8ea9d88$var$validateAttrName(attrName) {
    return $f0c3a3336ccedb73$export$998d7ff9801e90bb(attrName);
}
// const startsWithXML = /^xml/i;
function $f11c3627e8ea9d88$var$validateTagName(tagname) {
    return $f0c3a3336ccedb73$export$998d7ff9801e90bb(tagname) /* && !tagname.match(startsWithXML) */ ;
}
//this function returns the line number for the character at the given index
function $f11c3627e8ea9d88$var$getLineNumberForPosition(xmlData, index) {
    const lines = xmlData.substring(0, index).split(/\r?\n/);
    return {
        line: lines.length,
        // column number is last line's length + 1, because column numbering starts at 1:
        col: lines[lines.length - 1].length + 1
    };
}
//this function returns the position of the first character of match within attrStr
function $f11c3627e8ea9d88$var$getPositionFromMatch(match) {
    return match.startIndex + match[1].length;
}


var $ab187eb28ef3756e$exports = {};
var $8b84ef7ab4fc2764$export$ecbd7d678ac4909b;
var $8b84ef7ab4fc2764$export$ba43bf67f3d48107;
const $8b84ef7ab4fc2764$var$defaultOptions = {
    preserveOrder: false,
    attributeNamePrefix: '@_',
    attributesGroupName: false,
    textNodeName: '#text',
    ignoreAttributes: true,
    removeNSPrefix: false,
    allowBooleanAttributes: false,
    //ignoreRootElement : false,
    parseTagValue: true,
    parseAttributeValue: false,
    trimValues: true,
    cdataPropName: false,
    numberParseOptions: {
        hex: true,
        leadingZeros: true,
        eNotation: true
    },
    tagValueProcessor: function(tagName, val) {
        return val;
    },
    attributeValueProcessor: function(attrName, val) {
        return val;
    },
    stopNodes: [],
    alwaysCreateTextNode: false,
    isArray: ()=>false,
    commentPropName: false,
    unpairedTags: [],
    processEntities: true,
    htmlEntities: false,
    ignoreDeclaration: false,
    ignorePiTags: false,
    transformTagName: false,
    transformAttributeName: false,
    updateTag: function(tagName, jPath, attrs) {
        return tagName;
    }
};
const $8b84ef7ab4fc2764$var$buildOptions = function(options) {
    return Object.assign({}, $8b84ef7ab4fc2764$var$defaultOptions, options);
};
$8b84ef7ab4fc2764$export$ecbd7d678ac4909b = $8b84ef7ab4fc2764$var$buildOptions;
$8b84ef7ab4fc2764$export$ba43bf67f3d48107 = $8b84ef7ab4fc2764$var$defaultOptions;


var $ab187eb28ef3756e$require$buildOptions = $8b84ef7ab4fc2764$export$ecbd7d678ac4909b;
var $6144635d46dbca32$exports = {};
'use strict';

var $6bb7b98152f96470$exports = {};
'use strict';
class $6bb7b98152f96470$var$XmlNode {
    constructor(tagname){
        this.tagname = tagname;
        this.child = []; //nested tags, text, cdata, comments in order
        this[":@"] = {}; //attributes map
    }
    add(key, val) {
        // this.child.push( {name : key, val: val, isCdata: isCdata });
        if (key === "__proto__") key = "#__proto__";
        this.child.push({
            [key]: val
        });
    }
    addChild(node) {
        if (node.tagname === "__proto__") node.tagname = "#__proto__";
        if (node[":@"] && Object.keys(node[":@"]).length > 0) this.child.push({
            [node.tagname]: node.child,
            [":@"]: node[":@"]
        });
        else this.child.push({
            [node.tagname]: node.child
        });
    }
}
$6bb7b98152f96470$exports = $6bb7b98152f96470$var$XmlNode;


var $cee21051e24a90db$exports = {};

//TODO: handle comments
function $cee21051e24a90db$var$readDocType(xmlData, i) {
    const entities = {};
    if (xmlData[i + 3] === 'O' && xmlData[i + 4] === 'C' && xmlData[i + 5] === 'T' && xmlData[i + 6] === 'Y' && xmlData[i + 7] === 'P' && xmlData[i + 8] === 'E') {
        i = i + 9;
        let angleBracketsCount = 1;
        let hasBody = false, comment = false;
        let exp = "";
        for(; i < xmlData.length; i++){
            if (xmlData[i] === '<' && !comment) {
                if (hasBody && $cee21051e24a90db$var$isEntity(xmlData, i)) {
                    i += 7;
                    let entityName, val;
                    [entityName, val, i] = $cee21051e24a90db$var$readEntityExp(xmlData, i + 1);
                    if (val.indexOf("&") === -1) entities[$cee21051e24a90db$var$validateEntityName(entityName)] = {
                        regx: RegExp(`&${entityName};`, "g"),
                        val: val
                    };
                } else if (hasBody && $cee21051e24a90db$var$isElement(xmlData, i)) i += 8; //Not supported
                else if (hasBody && $cee21051e24a90db$var$isAttlist(xmlData, i)) i += 8; //Not supported
                else if (hasBody && $cee21051e24a90db$var$isNotation(xmlData, i)) i += 9; //Not supported
                else if ($cee21051e24a90db$var$isComment) comment = true;
                else throw new Error("Invalid DOCTYPE");
                angleBracketsCount++;
                exp = "";
            } else if (xmlData[i] === '>') {
                if (comment) {
                    if (xmlData[i - 1] === "-" && xmlData[i - 2] === "-") {
                        comment = false;
                        angleBracketsCount--;
                    }
                } else angleBracketsCount--;
                if (angleBracketsCount === 0) break;
            } else if (xmlData[i] === '[') hasBody = true;
            else exp += xmlData[i];
        }
        if (angleBracketsCount !== 0) throw new Error(`Unclosed DOCTYPE`);
    } else throw new Error(`Invalid Tag instead of DOCTYPE`);
    return {
        entities: entities,
        i: i
    };
}
function $cee21051e24a90db$var$readEntityExp(xmlData, i) {
    //External entities are not supported
    //    <!ENTITY ext SYSTEM "http://normal-website.com" >
    //Parameter entities are not supported
    //    <!ENTITY entityname "&anotherElement;">
    //Internal entities are supported
    //    <!ENTITY entityname "replacement text">
    //read EntityName
    let entityName = "";
    for(; i < xmlData.length && xmlData[i] !== "'" && xmlData[i] !== '"'; i++)// if(xmlData[i] === " ") continue;
    // else 
    entityName += xmlData[i];
    entityName = entityName.trim();
    if (entityName.indexOf(" ") !== -1) throw new Error("External entites are not supported");
    //read Entity Value
    const startChar = xmlData[i++];
    let val = "";
    for(; i < xmlData.length && xmlData[i] !== startChar; i++)val += xmlData[i];
    return [
        entityName,
        val,
        i
    ];
}
function $cee21051e24a90db$var$isComment(xmlData, i) {
    if (xmlData[i + 1] === '!' && xmlData[i + 2] === '-' && xmlData[i + 3] === '-') return true;
    return false;
}
function $cee21051e24a90db$var$isEntity(xmlData, i) {
    if (xmlData[i + 1] === '!' && xmlData[i + 2] === 'E' && xmlData[i + 3] === 'N' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'I' && xmlData[i + 6] === 'T' && xmlData[i + 7] === 'Y') return true;
    return false;
}
function $cee21051e24a90db$var$isElement(xmlData, i) {
    if (xmlData[i + 1] === '!' && xmlData[i + 2] === 'E' && xmlData[i + 3] === 'L' && xmlData[i + 4] === 'E' && xmlData[i + 5] === 'M' && xmlData[i + 6] === 'E' && xmlData[i + 7] === 'N' && xmlData[i + 8] === 'T') return true;
    return false;
}
function $cee21051e24a90db$var$isAttlist(xmlData, i) {
    if (xmlData[i + 1] === '!' && xmlData[i + 2] === 'A' && xmlData[i + 3] === 'T' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'L' && xmlData[i + 6] === 'I' && xmlData[i + 7] === 'S' && xmlData[i + 8] === 'T') return true;
    return false;
}
function $cee21051e24a90db$var$isNotation(xmlData, i) {
    if (xmlData[i + 1] === '!' && xmlData[i + 2] === 'N' && xmlData[i + 3] === 'O' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'A' && xmlData[i + 6] === 'T' && xmlData[i + 7] === 'I' && xmlData[i + 8] === 'O' && xmlData[i + 9] === 'N') return true;
    return false;
}
function $cee21051e24a90db$var$validateEntityName(name) {
    if ($f0c3a3336ccedb73$export$998d7ff9801e90bb(name)) return name;
    else throw new Error(`Invalid entity name ${name}`);
}
$cee21051e24a90db$exports = $cee21051e24a90db$var$readDocType;


var $167f716b04c2048a$exports = {};
const $167f716b04c2048a$var$hexRegex = /^[-+]?0x[a-fA-F0-9]+$/;
const $167f716b04c2048a$var$numRegex = /^([\-\+])?(0*)(\.[0-9]+([eE]\-?[0-9]+)?|[0-9]+(\.[0-9]+([eE]\-?[0-9]+)?)?)$/;
// const octRegex = /0x[a-z0-9]+/;
// const binRegex = /0x[a-z0-9]+/;
//polyfill
if (!Number.parseInt && window.parseInt) Number.parseInt = window.parseInt;
if (!Number.parseFloat && window.parseFloat) Number.parseFloat = window.parseFloat;
const $167f716b04c2048a$var$consider = {
    hex: true,
    leadingZeros: true,
    decimalPoint: "\.",
    eNotation: true
};
function $167f716b04c2048a$var$toNumber(str, options = {}) {
    // const options = Object.assign({}, consider);
    // if(opt.leadingZeros === false){
    //     options.leadingZeros = false;
    // }else if(opt.hex === false){
    //     options.hex = false;
    // }
    options = Object.assign({}, $167f716b04c2048a$var$consider, options);
    if (!str || typeof str !== "string") return str;
    let trimmedStr = str.trim();
    // if(trimmedStr === "0.0") return 0;
    // else if(trimmedStr === "+0.0") return 0;
    // else if(trimmedStr === "-0.0") return -0;
    if (options.skipLike !== undefined && options.skipLike.test(trimmedStr)) return str;
    else if (options.hex && $167f716b04c2048a$var$hexRegex.test(trimmedStr)) return Number.parseInt(trimmedStr, 16);
    else {
        //separate negative sign, leading zeros, and rest number
        const match = $167f716b04c2048a$var$numRegex.exec(trimmedStr);
        if (match) {
            const sign = match[1];
            const leadingZeros = match[2];
            let numTrimmedByZeros = $167f716b04c2048a$var$trimZeros(match[3]); //complete num without leading zeros
            //trim ending zeros for floating number
            const eNotation = match[4] || match[6];
            if (!options.leadingZeros && leadingZeros.length > 0 && sign && trimmedStr[2] !== ".") return str; //-0123
            else if (!options.leadingZeros && leadingZeros.length > 0 && !sign && trimmedStr[1] !== ".") return str; //0123
            else {
                const num = Number(trimmedStr);
                const numStr = "" + num;
                if (numStr.search(/[eE]/) !== -1) {
                    if (options.eNotation) return num;
                    else return str;
                } else if (eNotation) {
                    if (options.eNotation) return num;
                    else return str;
                } else if (trimmedStr.indexOf(".") !== -1) {
                    // const decimalPart = match[5].substr(1);
                    // const intPart = trimmedStr.substr(0,trimmedStr.indexOf("."));
                    // const p = numStr.indexOf(".");
                    // const givenIntPart = numStr.substr(0,p);
                    // const givenDecPart = numStr.substr(p+1);
                    if (numStr === "0" && numTrimmedByZeros === "") return num; //0.0
                    else if (numStr === numTrimmedByZeros) return num; //0.456. 0.79000
                    else if (sign && numStr === "-" + numTrimmedByZeros) return num;
                    else return str;
                }
                if (leadingZeros) {
                    // if(numTrimmedByZeros === numStr){
                    //     if(options.leadingZeros) return num;
                    //     else return str;
                    // }else return str;
                    if (numTrimmedByZeros === numStr) return num;
                    else if (sign + numTrimmedByZeros === numStr) return num;
                    else return str;
                }
                if (trimmedStr === numStr) return num;
                else if (trimmedStr === sign + numStr) return num;
                // else{
                //     //number with +/- sign
                //     trimmedStr.test(/[-+][0-9]);
                // }
                return str;
            }
        // else if(!eNotation && trimmedStr && trimmedStr !== Number(trimmedStr) ) return str;
        } else return str;
    }
}
/**
 * 
 * @param {string} numStr without leading zeros
 * @returns 
 */ function $167f716b04c2048a$var$trimZeros(numStr) {
    if (numStr && numStr.indexOf(".") !== -1) {
        numStr = numStr.replace(/0+$/, ""); //remove ending zeros
        if (numStr === ".") numStr = "0";
        else if (numStr[0] === ".") numStr = "0" + numStr;
        else if (numStr[numStr.length - 1] === ".") numStr = numStr.substr(0, numStr.length - 1);
        return numStr;
    }
    return numStr;
}
$167f716b04c2048a$exports = $167f716b04c2048a$var$toNumber;


var $87c88be8ddb421a6$exports = {};
function $87c88be8ddb421a6$var$getIgnoreAttributesFn(ignoreAttributes) {
    if (typeof ignoreAttributes === 'function') return ignoreAttributes;
    if (Array.isArray(ignoreAttributes)) return (attrName)=>{
        for (const pattern of ignoreAttributes){
            if (typeof pattern === 'string' && attrName === pattern) return true;
            if (pattern instanceof RegExp && pattern.test(attrName)) return true;
        }
    };
    return ()=>false;
}
$87c88be8ddb421a6$exports = $87c88be8ddb421a6$var$getIgnoreAttributesFn;


// const regx =
//   '<((!\\[CDATA\\[([\\s\\S]*?)(]]>))|((NAME:)?(NAME))([^>]*)>|((\\/)(NAME)\\s*>))([^<]*)'
//   .replace(/NAME/g, util.nameRegexp);
//const tagsRegx = new RegExp("<(\\/?[\\w:\\-\._]+)([^>]*)>(\\s*"+cdataRegx+")*([^<]+)?","g");
//const tagsRegx = new RegExp("<(\\/?)((\\w*:)?([\\w:\\-\._]+))([^>]*)>([^<]*)("+cdataRegx+"([^<]*))*([^<]+)?","g");
class $6144635d46dbca32$var$OrderedObjParser {
    constructor(options){
        this.options = options;
        this.currentNode = null;
        this.tagsNodeStack = [];
        this.docTypeEntities = {};
        this.lastEntities = {
            "apos": {
                regex: /&(apos|#39|#x27);/g,
                val: "'"
            },
            "gt": {
                regex: /&(gt|#62|#x3E);/g,
                val: ">"
            },
            "lt": {
                regex: /&(lt|#60|#x3C);/g,
                val: "<"
            },
            "quot": {
                regex: /&(quot|#34|#x22);/g,
                val: "\""
            }
        };
        this.ampEntity = {
            regex: /&(amp|#38|#x26);/g,
            val: "&"
        };
        this.htmlEntities = {
            "space": {
                regex: /&(nbsp|#160);/g,
                val: " "
            },
            // "lt" : { regex: /&(lt|#60);/g, val: "<" },
            // "gt" : { regex: /&(gt|#62);/g, val: ">" },
            // "amp" : { regex: /&(amp|#38);/g, val: "&" },
            // "quot" : { regex: /&(quot|#34);/g, val: "\"" },
            // "apos" : { regex: /&(apos|#39);/g, val: "'" },
            "cent": {
                regex: /&(cent|#162);/g,
                val: "\xa2"
            },
            "pound": {
                regex: /&(pound|#163);/g,
                val: "\xa3"
            },
            "yen": {
                regex: /&(yen|#165);/g,
                val: "\xa5"
            },
            "euro": {
                regex: /&(euro|#8364);/g,
                val: "\u20AC"
            },
            "copyright": {
                regex: /&(copy|#169);/g,
                val: "\xa9"
            },
            "reg": {
                regex: /&(reg|#174);/g,
                val: "\xae"
            },
            "inr": {
                regex: /&(inr|#8377);/g,
                val: "\u20B9"
            },
            "num_dec": {
                regex: /&#([0-9]{1,7});/g,
                val: (_, str)=>String.fromCharCode(Number.parseInt(str, 10))
            },
            "num_hex": {
                regex: /&#x([0-9a-fA-F]{1,6});/g,
                val: (_, str)=>String.fromCharCode(Number.parseInt(str, 16))
            }
        };
        this.addExternalEntities = $6144635d46dbca32$var$addExternalEntities;
        this.parseXml = $6144635d46dbca32$var$parseXml;
        this.parseTextData = $6144635d46dbca32$var$parseTextData;
        this.resolveNameSpace = $6144635d46dbca32$var$resolveNameSpace;
        this.buildAttributesMap = $6144635d46dbca32$var$buildAttributesMap;
        this.isItStopNode = $6144635d46dbca32$var$isItStopNode;
        this.replaceEntitiesValue = $6144635d46dbca32$var$replaceEntitiesValue;
        this.readStopNodeData = $6144635d46dbca32$var$readStopNodeData;
        this.saveTextToParentTag = $6144635d46dbca32$var$saveTextToParentTag;
        this.addChild = $6144635d46dbca32$var$addChild;
        this.ignoreAttributesFn = $87c88be8ddb421a6$exports(this.options.ignoreAttributes);
    }
}
function $6144635d46dbca32$var$addExternalEntities(externalEntities) {
    const entKeys = Object.keys(externalEntities);
    for(let i = 0; i < entKeys.length; i++){
        const ent = entKeys[i];
        this.lastEntities[ent] = {
            regex: new RegExp("&" + ent + ";", "g"),
            val: externalEntities[ent]
        };
    }
}
/**
 * @param {string} val
 * @param {string} tagName
 * @param {string} jPath
 * @param {boolean} dontTrim
 * @param {boolean} hasAttributes
 * @param {boolean} isLeafNode
 * @param {boolean} escapeEntities
 */ function $6144635d46dbca32$var$parseTextData(val, tagName, jPath, dontTrim, hasAttributes, isLeafNode, escapeEntities) {
    if (val !== undefined) {
        if (this.options.trimValues && !dontTrim) val = val.trim();
        if (val.length > 0) {
            if (!escapeEntities) val = this.replaceEntitiesValue(val);
            const newval = this.options.tagValueProcessor(tagName, val, jPath, hasAttributes, isLeafNode);
            if (newval === null || newval === undefined) //don't parse
            return val;
            else if (typeof newval !== typeof val || newval !== val) //overwrite
            return newval;
            else if (this.options.trimValues) return $6144635d46dbca32$var$parseValue(val, this.options.parseTagValue, this.options.numberParseOptions);
            else {
                const trimmedVal = val.trim();
                if (trimmedVal === val) return $6144635d46dbca32$var$parseValue(val, this.options.parseTagValue, this.options.numberParseOptions);
                else return val;
            }
        }
    }
}
function $6144635d46dbca32$var$resolveNameSpace(tagname) {
    if (this.options.removeNSPrefix) {
        const tags = tagname.split(':');
        const prefix = tagname.charAt(0) === '/' ? '/' : '';
        if (tags[0] === 'xmlns') return '';
        if (tags.length === 2) tagname = prefix + tags[1];
    }
    return tagname;
}
//TODO: change regex to capture NS
//const attrsRegx = new RegExp("([\\w\\-\\.\\:]+)\\s*=\\s*(['\"])((.|\n)*?)\\2","gm");
const $6144635d46dbca32$var$attrsRegx = new RegExp('([^\\s=]+)\\s*(=\\s*([\'"])([\\s\\S]*?)\\3)?', 'gm');
function $6144635d46dbca32$var$buildAttributesMap(attrStr, jPath, tagName) {
    if (this.options.ignoreAttributes !== true && typeof attrStr === 'string') {
        // attrStr = attrStr.replace(/\r?\n/g, ' ');
        //attrStr = attrStr || attrStr.trim();
        const matches = $f0c3a3336ccedb73$export$aaa9734c55cb7a19(attrStr, $6144635d46dbca32$var$attrsRegx);
        const len = matches.length; //don't make it inline
        const attrs = {};
        for(let i = 0; i < len; i++){
            const attrName = this.resolveNameSpace(matches[i][1]);
            if (this.ignoreAttributesFn(attrName, jPath)) continue;
            let oldVal = matches[i][4];
            let aName = this.options.attributeNamePrefix + attrName;
            if (attrName.length) {
                if (this.options.transformAttributeName) aName = this.options.transformAttributeName(aName);
                if (aName === "__proto__") aName = "#__proto__";
                if (oldVal !== undefined) {
                    if (this.options.trimValues) oldVal = oldVal.trim();
                    oldVal = this.replaceEntitiesValue(oldVal);
                    const newVal = this.options.attributeValueProcessor(attrName, oldVal, jPath);
                    if (newVal === null || newVal === undefined) //don't parse
                    attrs[aName] = oldVal;
                    else if (typeof newVal !== typeof oldVal || newVal !== oldVal) //overwrite
                    attrs[aName] = newVal;
                    else //parse
                    attrs[aName] = $6144635d46dbca32$var$parseValue(oldVal, this.options.parseAttributeValue, this.options.numberParseOptions);
                } else if (this.options.allowBooleanAttributes) attrs[aName] = true;
            }
        }
        if (!Object.keys(attrs).length) return;
        if (this.options.attributesGroupName) {
            const attrCollection = {};
            attrCollection[this.options.attributesGroupName] = attrs;
            return attrCollection;
        }
        return attrs;
    }
}
const $6144635d46dbca32$var$parseXml = function(xmlData) {
    xmlData = xmlData.replace(/\r\n?/g, "\n"); //TODO: remove this line
    const xmlObj = new $6bb7b98152f96470$exports('!xml');
    let currentNode = xmlObj;
    let textData = "";
    let jPath = "";
    for(let i = 0; i < xmlData.length; i++){
        const ch = xmlData[i];
        if (ch === '<') {
            // const nextIndex = i+1;
            // const _2ndChar = xmlData[nextIndex];
            if (xmlData[i + 1] === '/') {
                const closeIndex = $6144635d46dbca32$var$findClosingIndex(xmlData, ">", i, "Closing Tag is not closed.");
                let tagName = xmlData.substring(i + 2, closeIndex).trim();
                if (this.options.removeNSPrefix) {
                    const colonIndex = tagName.indexOf(":");
                    if (colonIndex !== -1) tagName = tagName.substr(colonIndex + 1);
                }
                if (this.options.transformTagName) tagName = this.options.transformTagName(tagName);
                if (currentNode) textData = this.saveTextToParentTag(textData, currentNode, jPath);
                //check if last tag of nested tag was unpaired tag
                const lastTagName = jPath.substring(jPath.lastIndexOf(".") + 1);
                if (tagName && this.options.unpairedTags.indexOf(tagName) !== -1) throw new Error(`Unpaired tag can not be used as closing tag: </${tagName}>`);
                let propIndex = 0;
                if (lastTagName && this.options.unpairedTags.indexOf(lastTagName) !== -1) {
                    propIndex = jPath.lastIndexOf('.', jPath.lastIndexOf('.') - 1);
                    this.tagsNodeStack.pop();
                } else propIndex = jPath.lastIndexOf(".");
                jPath = jPath.substring(0, propIndex);
                currentNode = this.tagsNodeStack.pop(); //avoid recursion, set the parent tag scope
                textData = "";
                i = closeIndex;
            } else if (xmlData[i + 1] === '?') {
                let tagData = $6144635d46dbca32$var$readTagExp(xmlData, i, false, "?>");
                if (!tagData) throw new Error("Pi Tag is not closed.");
                textData = this.saveTextToParentTag(textData, currentNode, jPath);
                if (this.options.ignoreDeclaration && tagData.tagName === "?xml" || this.options.ignorePiTags) ;
                else {
                    const childNode = new $6bb7b98152f96470$exports(tagData.tagName);
                    childNode.add(this.options.textNodeName, "");
                    if (tagData.tagName !== tagData.tagExp && tagData.attrExpPresent) childNode[":@"] = this.buildAttributesMap(tagData.tagExp, jPath, tagData.tagName);
                    this.addChild(currentNode, childNode, jPath);
                }
                i = tagData.closeIndex + 1;
            } else if (xmlData.substr(i + 1, 3) === '!--') {
                const endIndex = $6144635d46dbca32$var$findClosingIndex(xmlData, "-->", i + 4, "Comment is not closed.");
                if (this.options.commentPropName) {
                    const comment = xmlData.substring(i + 4, endIndex - 2);
                    textData = this.saveTextToParentTag(textData, currentNode, jPath);
                    currentNode.add(this.options.commentPropName, [
                        {
                            [this.options.textNodeName]: comment
                        }
                    ]);
                }
                i = endIndex;
            } else if (xmlData.substr(i + 1, 2) === '!D') {
                const result = $cee21051e24a90db$exports(xmlData, i);
                this.docTypeEntities = result.entities;
                i = result.i;
            } else if (xmlData.substr(i + 1, 2) === '![') {
                const closeIndex = $6144635d46dbca32$var$findClosingIndex(xmlData, "]]>", i, "CDATA is not closed.") - 2;
                const tagExp = xmlData.substring(i + 9, closeIndex);
                textData = this.saveTextToParentTag(textData, currentNode, jPath);
                let val = this.parseTextData(tagExp, currentNode.tagname, jPath, true, false, true, true);
                if (val == undefined) val = "";
                //cdata should be set even if it is 0 length string
                if (this.options.cdataPropName) currentNode.add(this.options.cdataPropName, [
                    {
                        [this.options.textNodeName]: tagExp
                    }
                ]);
                else currentNode.add(this.options.textNodeName, val);
                i = closeIndex + 2;
            } else {
                let result = $6144635d46dbca32$var$readTagExp(xmlData, i, this.options.removeNSPrefix);
                let tagName = result.tagName;
                const rawTagName = result.rawTagName;
                let tagExp = result.tagExp;
                let attrExpPresent = result.attrExpPresent;
                let closeIndex = result.closeIndex;
                if (this.options.transformTagName) tagName = this.options.transformTagName(tagName);
                //save text as child node
                if (currentNode && textData) {
                    if (currentNode.tagname !== '!xml') //when nested tag is found
                    textData = this.saveTextToParentTag(textData, currentNode, jPath, false);
                }
                //check if last tag was unpaired tag
                const lastTag = currentNode;
                if (lastTag && this.options.unpairedTags.indexOf(lastTag.tagname) !== -1) {
                    currentNode = this.tagsNodeStack.pop();
                    jPath = jPath.substring(0, jPath.lastIndexOf("."));
                }
                if (tagName !== xmlObj.tagname) jPath += jPath ? "." + tagName : tagName;
                if (this.isItStopNode(this.options.stopNodes, jPath, tagName)) {
                    let tagContent = "";
                    //self-closing tag
                    if (tagExp.length > 0 && tagExp.lastIndexOf("/") === tagExp.length - 1) {
                        if (tagName[tagName.length - 1] === "/") {
                            tagName = tagName.substr(0, tagName.length - 1);
                            jPath = jPath.substr(0, jPath.length - 1);
                            tagExp = tagName;
                        } else tagExp = tagExp.substr(0, tagExp.length - 1);
                        i = result.closeIndex;
                    } else if (this.options.unpairedTags.indexOf(tagName) !== -1) i = result.closeIndex;
                    else {
                        //read until closing tag is found
                        const result = this.readStopNodeData(xmlData, rawTagName, closeIndex + 1);
                        if (!result) throw new Error(`Unexpected end of ${rawTagName}`);
                        i = result.i;
                        tagContent = result.tagContent;
                    }
                    const childNode = new $6bb7b98152f96470$exports(tagName);
                    if (tagName !== tagExp && attrExpPresent) childNode[":@"] = this.buildAttributesMap(tagExp, jPath, tagName);
                    if (tagContent) tagContent = this.parseTextData(tagContent, tagName, jPath, true, attrExpPresent, true, true);
                    jPath = jPath.substr(0, jPath.lastIndexOf("."));
                    childNode.add(this.options.textNodeName, tagContent);
                    this.addChild(currentNode, childNode, jPath);
                } else {
                    //selfClosing tag
                    if (tagExp.length > 0 && tagExp.lastIndexOf("/") === tagExp.length - 1) {
                        if (tagName[tagName.length - 1] === "/") {
                            tagName = tagName.substr(0, tagName.length - 1);
                            jPath = jPath.substr(0, jPath.length - 1);
                            tagExp = tagName;
                        } else tagExp = tagExp.substr(0, tagExp.length - 1);
                        if (this.options.transformTagName) tagName = this.options.transformTagName(tagName);
                        const childNode = new $6bb7b98152f96470$exports(tagName);
                        if (tagName !== tagExp && attrExpPresent) childNode[":@"] = this.buildAttributesMap(tagExp, jPath, tagName);
                        this.addChild(currentNode, childNode, jPath);
                        jPath = jPath.substr(0, jPath.lastIndexOf("."));
                    } else {
                        const childNode = new $6bb7b98152f96470$exports(tagName);
                        this.tagsNodeStack.push(currentNode);
                        if (tagName !== tagExp && attrExpPresent) childNode[":@"] = this.buildAttributesMap(tagExp, jPath, tagName);
                        this.addChild(currentNode, childNode, jPath);
                        currentNode = childNode;
                    }
                    textData = "";
                    i = closeIndex;
                }
            }
        } else textData += xmlData[i];
    }
    return xmlObj.child;
};
function $6144635d46dbca32$var$addChild(currentNode, childNode, jPath) {
    const result = this.options.updateTag(childNode.tagname, jPath, childNode[":@"]);
    if (result === false) ;
    else if (typeof result === "string") {
        childNode.tagname = result;
        currentNode.addChild(childNode);
    } else currentNode.addChild(childNode);
}
const $6144635d46dbca32$var$replaceEntitiesValue = function(val) {
    if (this.options.processEntities) {
        for(let entityName in this.docTypeEntities){
            const entity = this.docTypeEntities[entityName];
            val = val.replace(entity.regx, entity.val);
        }
        for(let entityName in this.lastEntities){
            const entity = this.lastEntities[entityName];
            val = val.replace(entity.regex, entity.val);
        }
        if (this.options.htmlEntities) for(let entityName in this.htmlEntities){
            const entity = this.htmlEntities[entityName];
            val = val.replace(entity.regex, entity.val);
        }
        val = val.replace(this.ampEntity.regex, this.ampEntity.val);
    }
    return val;
};
function $6144635d46dbca32$var$saveTextToParentTag(textData, currentNode, jPath, isLeafNode) {
    if (textData) {
        if (isLeafNode === undefined) isLeafNode = Object.keys(currentNode.child).length === 0;
        textData = this.parseTextData(textData, currentNode.tagname, jPath, false, currentNode[":@"] ? Object.keys(currentNode[":@"]).length !== 0 : false, isLeafNode);
        if (textData !== undefined && textData !== "") currentNode.add(this.options.textNodeName, textData);
        textData = "";
    }
    return textData;
}
//TODO: use jPath to simplify the logic
/**
 * 
 * @param {string[]} stopNodes 
 * @param {string} jPath
 * @param {string} currentTagName 
 */ function $6144635d46dbca32$var$isItStopNode(stopNodes, jPath, currentTagName) {
    const allNodesExp = "*." + currentTagName;
    for(const stopNodePath in stopNodes){
        const stopNodeExp = stopNodes[stopNodePath];
        if (allNodesExp === stopNodeExp || jPath === stopNodeExp) return true;
    }
    return false;
}
/**
 * Returns the tag Expression and where it is ending handling single-double quotes situation
 * @param {string} xmlData 
 * @param {number} i starting index
 * @returns 
 */ function $6144635d46dbca32$var$tagExpWithClosingIndex(xmlData, i, closingChar = ">") {
    let attrBoundary;
    let tagExp = "";
    for(let index = i; index < xmlData.length; index++){
        let ch = xmlData[index];
        if (attrBoundary) {
            if (ch === attrBoundary) attrBoundary = ""; //reset
        } else if (ch === '"' || ch === "'") attrBoundary = ch;
        else if (ch === closingChar[0]) {
            if (closingChar[1]) {
                if (xmlData[index + 1] === closingChar[1]) return {
                    data: tagExp,
                    index: index
                };
            } else return {
                data: tagExp,
                index: index
            };
        } else if (ch === '\t') ch = " ";
        tagExp += ch;
    }
}
function $6144635d46dbca32$var$findClosingIndex(xmlData, str, i, errMsg) {
    const closingIndex = xmlData.indexOf(str, i);
    if (closingIndex === -1) throw new Error(errMsg);
    else return closingIndex + str.length - 1;
}
function $6144635d46dbca32$var$readTagExp(xmlData, i, removeNSPrefix, closingChar = ">") {
    const result = $6144635d46dbca32$var$tagExpWithClosingIndex(xmlData, i + 1, closingChar);
    if (!result) return;
    let tagExp = result.data;
    const closeIndex = result.index;
    const separatorIndex = tagExp.search(/\s/);
    let tagName = tagExp;
    let attrExpPresent = true;
    if (separatorIndex !== -1) {
        tagName = tagExp.substring(0, separatorIndex);
        tagExp = tagExp.substring(separatorIndex + 1).trimStart();
    }
    const rawTagName = tagName;
    if (removeNSPrefix) {
        const colonIndex = tagName.indexOf(":");
        if (colonIndex !== -1) {
            tagName = tagName.substr(colonIndex + 1);
            attrExpPresent = tagName !== result.data.substr(colonIndex + 1);
        }
    }
    return {
        tagName: tagName,
        tagExp: tagExp,
        closeIndex: closeIndex,
        attrExpPresent: attrExpPresent,
        rawTagName: rawTagName
    };
}
/**
 * find paired tag for a stop node
 * @param {string} xmlData 
 * @param {string} tagName 
 * @param {number} i 
 */ function $6144635d46dbca32$var$readStopNodeData(xmlData, tagName, i) {
    const startIndex = i;
    // Starting at 1 since we already have an open tag
    let openTagCount = 1;
    for(; i < xmlData.length; i++)if (xmlData[i] === "<") {
        if (xmlData[i + 1] === "/") {
            const closeIndex = $6144635d46dbca32$var$findClosingIndex(xmlData, ">", i, `${tagName} is not closed`);
            let closeTagName = xmlData.substring(i + 2, closeIndex).trim();
            if (closeTagName === tagName) {
                openTagCount--;
                if (openTagCount === 0) return {
                    tagContent: xmlData.substring(startIndex, i),
                    i: closeIndex
                };
            }
            i = closeIndex;
        } else if (xmlData[i + 1] === '?') {
            const closeIndex = $6144635d46dbca32$var$findClosingIndex(xmlData, "?>", i + 1, "StopNode is not closed.");
            i = closeIndex;
        } else if (xmlData.substr(i + 1, 3) === '!--') {
            const closeIndex = $6144635d46dbca32$var$findClosingIndex(xmlData, "-->", i + 3, "StopNode is not closed.");
            i = closeIndex;
        } else if (xmlData.substr(i + 1, 2) === '![') {
            const closeIndex = $6144635d46dbca32$var$findClosingIndex(xmlData, "]]>", i, "StopNode is not closed.") - 2;
            i = closeIndex;
        } else {
            const tagData = $6144635d46dbca32$var$readTagExp(xmlData, i, '>');
            if (tagData) {
                const openTagName = tagData && tagData.tagName;
                if (openTagName === tagName && tagData.tagExp[tagData.tagExp.length - 1] !== "/") openTagCount++;
                i = tagData.closeIndex;
            }
        }
    }
     //end for loop
}
function $6144635d46dbca32$var$parseValue(val, shouldParse, options) {
    if (shouldParse && typeof val === 'string') {
        //console.log(options)
        const newval = val.trim();
        if (newval === 'true') return true;
        else if (newval === 'false') return false;
        else return $167f716b04c2048a$exports(val, options);
    } else {
        if ($f0c3a3336ccedb73$export$a5edf3f35b6dd392(val)) return val;
        else return '';
    }
}
$6144635d46dbca32$exports = $6144635d46dbca32$var$OrderedObjParser;


var $6ee6e17357a4bbcc$export$1b80ed980367b7c1;
'use strict';
/**
 * 
 * @param {array} node 
 * @param {any} options 
 * @returns 
 */ function $6ee6e17357a4bbcc$var$prettify(node, options) {
    return $6ee6e17357a4bbcc$var$compress(node, options);
}
/**
 * 
 * @param {array} arr 
 * @param {object} options 
 * @param {string} jPath 
 * @returns object
 */ function $6ee6e17357a4bbcc$var$compress(arr, options, jPath) {
    let text;
    const compressedObj = {};
    for(let i = 0; i < arr.length; i++){
        const tagObj = arr[i];
        const property = $6ee6e17357a4bbcc$var$propName(tagObj);
        let newJpath = "";
        if (jPath === undefined) newJpath = property;
        else newJpath = jPath + "." + property;
        if (property === options.textNodeName) {
            if (text === undefined) text = tagObj[property];
            else text += "" + tagObj[property];
        } else if (property === undefined) continue;
        else if (tagObj[property]) {
            let val = $6ee6e17357a4bbcc$var$compress(tagObj[property], options, newJpath);
            const isLeaf = $6ee6e17357a4bbcc$var$isLeafTag(val, options);
            if (tagObj[":@"]) $6ee6e17357a4bbcc$var$assignAttributes(val, tagObj[":@"], newJpath, options);
            else if (Object.keys(val).length === 1 && val[options.textNodeName] !== undefined && !options.alwaysCreateTextNode) val = val[options.textNodeName];
            else if (Object.keys(val).length === 0) {
                if (options.alwaysCreateTextNode) val[options.textNodeName] = "";
                else val = "";
            }
            if (compressedObj[property] !== undefined && compressedObj.hasOwnProperty(property)) {
                if (!Array.isArray(compressedObj[property])) compressedObj[property] = [
                    compressedObj[property]
                ];
                compressedObj[property].push(val);
            } else //TODO: if a node is not an array, then check if it should be an array
            //also determine if it is a leaf node
            if (options.isArray(property, newJpath, isLeaf)) compressedObj[property] = [
                val
            ];
            else compressedObj[property] = val;
        }
    }
    // if(text && text.length > 0) compressedObj[options.textNodeName] = text;
    if (typeof text === "string") {
        if (text.length > 0) compressedObj[options.textNodeName] = text;
    } else if (text !== undefined) compressedObj[options.textNodeName] = text;
    return compressedObj;
}
function $6ee6e17357a4bbcc$var$propName(obj) {
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        if (key !== ":@") return key;
    }
}
function $6ee6e17357a4bbcc$var$assignAttributes(obj, attrMap, jpath, options) {
    if (attrMap) {
        const keys = Object.keys(attrMap);
        const len = keys.length; //don't make it inline
        for(let i = 0; i < len; i++){
            const atrrName = keys[i];
            if (options.isArray(atrrName, jpath + "." + atrrName, true, true)) obj[atrrName] = [
                attrMap[atrrName]
            ];
            else obj[atrrName] = attrMap[atrrName];
        }
    }
}
function $6ee6e17357a4bbcc$var$isLeafTag(obj, options) {
    const { textNodeName: textNodeName } = options;
    const propCount = Object.keys(obj).length;
    if (propCount === 0) return true;
    if (propCount === 1 && (obj[textNodeName] || typeof obj[textNodeName] === "boolean" || obj[textNodeName] === 0)) return true;
    return false;
}
$6ee6e17357a4bbcc$export$1b80ed980367b7c1 = $6ee6e17357a4bbcc$var$prettify;


var $ab187eb28ef3756e$require$prettify = $6ee6e17357a4bbcc$export$1b80ed980367b7c1;

class $ab187eb28ef3756e$var$XMLParser {
    constructor(options){
        this.externalEntities = {};
        this.options = $ab187eb28ef3756e$require$buildOptions(options);
    }
    /**
     * Parse XML dats to JS object 
     * @param {string|Buffer} xmlData 
     * @param {boolean|Object} validationOption 
     */ parse(xmlData, validationOption) {
        if (typeof xmlData === "string") ;
        else if (xmlData.toString) xmlData = xmlData.toString();
        else throw new Error("XML data is accepted in String or Bytes[] form.");
        if (validationOption) {
            if (validationOption === true) validationOption = {}; //validate with default options
            const result = $f11c3627e8ea9d88$export$a22775fa5e2eebd9(xmlData, validationOption);
            if (result !== true) throw Error(`${result.err.msg}:${result.err.line}:${result.err.col}`);
        }
        const orderedObjParser = new $6144635d46dbca32$exports(this.options);
        orderedObjParser.addExternalEntities(this.externalEntities);
        const orderedResult = orderedObjParser.parseXml(xmlData);
        if (this.options.preserveOrder || orderedResult === undefined) return orderedResult;
        else return $ab187eb28ef3756e$require$prettify(orderedResult, this.options);
    }
    /**
     * Add Entity which is not by default supported by this library
     * @param {string} key 
     * @param {string} value 
     */ addEntity(key, value) {
        if (value.indexOf("&") !== -1) throw new Error("Entity value can't have '&'");
        else if (key.indexOf("&") !== -1 || key.indexOf(";") !== -1) throw new Error("An entity must be set without '&' and ';'. Eg. use '#xD' for '&#xD;'");
        else if (value === "&") throw new Error("An entity with value '&' is not permitted");
        else this.externalEntities[key] = value;
    }
}
$ab187eb28ef3756e$exports = $ab187eb28ef3756e$var$XMLParser;


var $027681a8ad4ba704$exports = {};
'use strict';
var $6b4f22b5b267a2f9$exports = {};
const $6b4f22b5b267a2f9$var$EOL = "\n";
/**
 * 
 * @param {array} jArray 
 * @param {any} options 
 * @returns 
 */ function $6b4f22b5b267a2f9$var$toXml(jArray, options) {
    let indentation = "";
    if (options.format && options.indentBy.length > 0) indentation = $6b4f22b5b267a2f9$var$EOL;
    return $6b4f22b5b267a2f9$var$arrToStr(jArray, options, "", indentation);
}
function $6b4f22b5b267a2f9$var$arrToStr(arr, options, jPath, indentation) {
    let xmlStr = "";
    let isPreviousElementTag = false;
    for(let i = 0; i < arr.length; i++){
        const tagObj = arr[i];
        const tagName = $6b4f22b5b267a2f9$var$propName(tagObj);
        if (tagName === undefined) continue;
        let newJPath = "";
        if (jPath.length === 0) newJPath = tagName;
        else newJPath = `${jPath}.${tagName}`;
        if (tagName === options.textNodeName) {
            let tagText = tagObj[tagName];
            if (!$6b4f22b5b267a2f9$var$isStopNode(newJPath, options)) {
                tagText = options.tagValueProcessor(tagName, tagText);
                tagText = $6b4f22b5b267a2f9$var$replaceEntitiesValue(tagText, options);
            }
            if (isPreviousElementTag) xmlStr += indentation;
            xmlStr += tagText;
            isPreviousElementTag = false;
            continue;
        } else if (tagName === options.cdataPropName) {
            if (isPreviousElementTag) xmlStr += indentation;
            xmlStr += `<![CDATA[${tagObj[tagName][0][options.textNodeName]}]]>`;
            isPreviousElementTag = false;
            continue;
        } else if (tagName === options.commentPropName) {
            xmlStr += indentation + `<!--${tagObj[tagName][0][options.textNodeName]}-->`;
            isPreviousElementTag = true;
            continue;
        } else if (tagName[0] === "?") {
            const attStr = $6b4f22b5b267a2f9$var$attr_to_str(tagObj[":@"], options);
            const tempInd = tagName === "?xml" ? "" : indentation;
            let piTextNodeName = tagObj[tagName][0][options.textNodeName];
            piTextNodeName = piTextNodeName.length !== 0 ? " " + piTextNodeName : ""; //remove extra spacing
            xmlStr += tempInd + `<${tagName}${piTextNodeName}${attStr}?>`;
            isPreviousElementTag = true;
            continue;
        }
        let newIdentation = indentation;
        if (newIdentation !== "") newIdentation += options.indentBy;
        const attStr = $6b4f22b5b267a2f9$var$attr_to_str(tagObj[":@"], options);
        const tagStart = indentation + `<${tagName}${attStr}`;
        const tagValue = $6b4f22b5b267a2f9$var$arrToStr(tagObj[tagName], options, newJPath, newIdentation);
        if (options.unpairedTags.indexOf(tagName) !== -1) {
            if (options.suppressUnpairedNode) xmlStr += tagStart + ">";
            else xmlStr += tagStart + "/>";
        } else if ((!tagValue || tagValue.length === 0) && options.suppressEmptyNode) xmlStr += tagStart + "/>";
        else if (tagValue && tagValue.endsWith(">")) xmlStr += tagStart + `>${tagValue}${indentation}</${tagName}>`;
        else {
            xmlStr += tagStart + ">";
            if (tagValue && indentation !== "" && (tagValue.includes("/>") || tagValue.includes("</"))) xmlStr += indentation + options.indentBy + tagValue + indentation;
            else xmlStr += tagValue;
            xmlStr += `</${tagName}>`;
        }
        isPreviousElementTag = true;
    }
    return xmlStr;
}
function $6b4f22b5b267a2f9$var$propName(obj) {
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        if (!obj.hasOwnProperty(key)) continue;
        if (key !== ":@") return key;
    }
}
function $6b4f22b5b267a2f9$var$attr_to_str(attrMap, options) {
    let attrStr = "";
    if (attrMap && !options.ignoreAttributes) for(let attr in attrMap){
        if (!attrMap.hasOwnProperty(attr)) continue;
        let attrVal = options.attributeValueProcessor(attr, attrMap[attr]);
        attrVal = $6b4f22b5b267a2f9$var$replaceEntitiesValue(attrVal, options);
        if (attrVal === true && options.suppressBooleanAttributes) attrStr += ` ${attr.substr(options.attributeNamePrefix.length)}`;
        else attrStr += ` ${attr.substr(options.attributeNamePrefix.length)}="${attrVal}"`;
    }
    return attrStr;
}
function $6b4f22b5b267a2f9$var$isStopNode(jPath, options) {
    jPath = jPath.substr(0, jPath.length - options.textNodeName.length - 1);
    let tagName = jPath.substr(jPath.lastIndexOf(".") + 1);
    for(let index in options.stopNodes){
        if (options.stopNodes[index] === jPath || options.stopNodes[index] === "*." + tagName) return true;
    }
    return false;
}
function $6b4f22b5b267a2f9$var$replaceEntitiesValue(textValue, options) {
    if (textValue && textValue.length > 0 && options.processEntities) for(let i = 0; i < options.entities.length; i++){
        const entity = options.entities[i];
        textValue = textValue.replace(entity.regex, entity.val);
    }
    return textValue;
}
$6b4f22b5b267a2f9$exports = $6b4f22b5b267a2f9$var$toXml;



const $027681a8ad4ba704$var$defaultOptions = {
    attributeNamePrefix: '@_',
    attributesGroupName: false,
    textNodeName: '#text',
    ignoreAttributes: true,
    cdataPropName: false,
    format: false,
    indentBy: '  ',
    suppressEmptyNode: false,
    suppressUnpairedNode: true,
    suppressBooleanAttributes: true,
    tagValueProcessor: function(key, a) {
        return a;
    },
    attributeValueProcessor: function(attrName, a) {
        return a;
    },
    preserveOrder: false,
    commentPropName: false,
    unpairedTags: [],
    entities: [
        {
            regex: new RegExp("&", "g"),
            val: "&amp;"
        },
        {
            regex: new RegExp(">", "g"),
            val: "&gt;"
        },
        {
            regex: new RegExp("<", "g"),
            val: "&lt;"
        },
        {
            regex: new RegExp("\'", "g"),
            val: "&apos;"
        },
        {
            regex: new RegExp("\"", "g"),
            val: "&quot;"
        }
    ],
    processEntities: true,
    stopNodes: [],
    // transformTagName: false,
    // transformAttributeName: false,
    oneListGroup: false
};
function $027681a8ad4ba704$var$Builder(options) {
    this.options = Object.assign({}, $027681a8ad4ba704$var$defaultOptions, options);
    if (this.options.ignoreAttributes === true || this.options.attributesGroupName) this.isAttribute = function() {
        return false;
    };
    else {
        this.ignoreAttributesFn = $87c88be8ddb421a6$exports(this.options.ignoreAttributes);
        this.attrPrefixLen = this.options.attributeNamePrefix.length;
        this.isAttribute = $027681a8ad4ba704$var$isAttribute;
    }
    this.processTextOrObjNode = $027681a8ad4ba704$var$processTextOrObjNode;
    if (this.options.format) {
        this.indentate = $027681a8ad4ba704$var$indentate;
        this.tagEndChar = '>\n';
        this.newLine = '\n';
    } else {
        this.indentate = function() {
            return '';
        };
        this.tagEndChar = '>';
        this.newLine = '';
    }
}
$027681a8ad4ba704$var$Builder.prototype.build = function(jObj) {
    if (this.options.preserveOrder) return $6b4f22b5b267a2f9$exports(jObj, this.options);
    else {
        if (Array.isArray(jObj) && this.options.arrayNodeName && this.options.arrayNodeName.length > 1) jObj = {
            [this.options.arrayNodeName]: jObj
        };
        return this.j2x(jObj, 0, []).val;
    }
};
$027681a8ad4ba704$var$Builder.prototype.j2x = function(jObj, level, ajPath) {
    let attrStr = '';
    let val = '';
    const jPath = ajPath.join('.');
    for(let key in jObj){
        if (!Object.prototype.hasOwnProperty.call(jObj, key)) continue;
        if (typeof jObj[key] === 'undefined') // supress undefined node only if it is not an attribute
        {
            if (this.isAttribute(key)) val += '';
        } else if (jObj[key] === null) {
            // null attribute should be ignored by the attribute list, but should not cause the tag closing
            if (this.isAttribute(key)) val += '';
            else if (key[0] === '?') val += this.indentate(level) + '<' + key + '?' + this.tagEndChar;
            else val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
        // val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
        } else if (jObj[key] instanceof Date) val += this.buildTextValNode(jObj[key], key, '', level);
        else if (typeof jObj[key] !== 'object') {
            //premitive type
            const attr = this.isAttribute(key);
            if (attr && !this.ignoreAttributesFn(attr, jPath)) attrStr += this.buildAttrPairStr(attr, '' + jObj[key]);
            else if (!attr) {
                //tag value
                if (key === this.options.textNodeName) {
                    let newval = this.options.tagValueProcessor(key, '' + jObj[key]);
                    val += this.replaceEntitiesValue(newval);
                } else val += this.buildTextValNode(jObj[key], key, '', level);
            }
        } else if (Array.isArray(jObj[key])) {
            //repeated nodes
            const arrLen = jObj[key].length;
            let listTagVal = "";
            let listTagAttr = "";
            for(let j = 0; j < arrLen; j++){
                const item = jObj[key][j];
                if (typeof item === 'undefined') ;
                else if (item === null) {
                    if (key[0] === "?") val += this.indentate(level) + '<' + key + '?' + this.tagEndChar;
                    else val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
                } else if (typeof item === 'object') {
                    if (this.options.oneListGroup) {
                        const result = this.j2x(item, level + 1, ajPath.concat(key));
                        listTagVal += result.val;
                        if (this.options.attributesGroupName && item.hasOwnProperty(this.options.attributesGroupName)) listTagAttr += result.attrStr;
                    } else listTagVal += this.processTextOrObjNode(item, key, level, ajPath);
                } else if (this.options.oneListGroup) {
                    let textValue = this.options.tagValueProcessor(key, item);
                    textValue = this.replaceEntitiesValue(textValue);
                    listTagVal += textValue;
                } else listTagVal += this.buildTextValNode(item, key, '', level);
            }
            if (this.options.oneListGroup) listTagVal = this.buildObjectNode(listTagVal, key, listTagAttr, level);
            val += listTagVal;
        } else //nested node
        if (this.options.attributesGroupName && key === this.options.attributesGroupName) {
            const Ks = Object.keys(jObj[key]);
            const L = Ks.length;
            for(let j = 0; j < L; j++)attrStr += this.buildAttrPairStr(Ks[j], '' + jObj[key][Ks[j]]);
        } else val += this.processTextOrObjNode(jObj[key], key, level, ajPath);
    }
    return {
        attrStr: attrStr,
        val: val
    };
};
$027681a8ad4ba704$var$Builder.prototype.buildAttrPairStr = function(attrName, val) {
    val = this.options.attributeValueProcessor(attrName, '' + val);
    val = this.replaceEntitiesValue(val);
    if (this.options.suppressBooleanAttributes && val === "true") return ' ' + attrName;
    else return ' ' + attrName + '="' + val + '"';
};
function $027681a8ad4ba704$var$processTextOrObjNode(object, key, level, ajPath) {
    const result = this.j2x(object, level + 1, ajPath.concat(key));
    if (object[this.options.textNodeName] !== undefined && Object.keys(object).length === 1) return this.buildTextValNode(object[this.options.textNodeName], key, result.attrStr, level);
    else return this.buildObjectNode(result.val, key, result.attrStr, level);
}
$027681a8ad4ba704$var$Builder.prototype.buildObjectNode = function(val, key, attrStr, level) {
    if (val === "") {
        if (key[0] === "?") return this.indentate(level) + '<' + key + attrStr + '?' + this.tagEndChar;
        else return this.indentate(level) + '<' + key + attrStr + this.closeTag(key) + this.tagEndChar;
    } else {
        let tagEndExp = '</' + key + this.tagEndChar;
        let piClosingChar = "";
        if (key[0] === "?") {
            piClosingChar = "?";
            tagEndExp = "";
        }
        // attrStr is an empty string in case the attribute came as undefined or null
        if ((attrStr || attrStr === '') && val.indexOf('<') === -1) return this.indentate(level) + '<' + key + attrStr + piClosingChar + '>' + val + tagEndExp;
        else if (this.options.commentPropName !== false && key === this.options.commentPropName && piClosingChar.length === 0) return this.indentate(level) + `<!--${val}-->` + this.newLine;
        else return this.indentate(level) + '<' + key + attrStr + piClosingChar + this.tagEndChar + val + this.indentate(level) + tagEndExp;
    }
};
$027681a8ad4ba704$var$Builder.prototype.closeTag = function(key) {
    let closeTag = "";
    if (this.options.unpairedTags.indexOf(key) !== -1) {
        if (!this.options.suppressUnpairedNode) closeTag = "/";
    } else if (this.options.suppressEmptyNode) closeTag = "/";
    else closeTag = `></${key}`;
    return closeTag;
};
function $027681a8ad4ba704$var$buildEmptyObjNode(val, key, attrStr, level) {
    if (val !== '') return this.buildObjectNode(val, key, attrStr, level);
    else {
        if (key[0] === "?") return this.indentate(level) + '<' + key + attrStr + '?' + this.tagEndChar;
        else return this.indentate(level) + '<' + key + attrStr + '/' + this.tagEndChar;
    }
}
$027681a8ad4ba704$var$Builder.prototype.buildTextValNode = function(val, key, attrStr, level) {
    if (this.options.cdataPropName !== false && key === this.options.cdataPropName) return this.indentate(level) + `<![CDATA[${val}]]>` + this.newLine;
    else if (this.options.commentPropName !== false && key === this.options.commentPropName) return this.indentate(level) + `<!--${val}-->` + this.newLine;
    else if (key[0] === "?") return this.indentate(level) + '<' + key + attrStr + '?' + this.tagEndChar;
    else {
        let textValue = this.options.tagValueProcessor(key, val);
        textValue = this.replaceEntitiesValue(textValue);
        if (textValue === '') return this.indentate(level) + '<' + key + attrStr + this.closeTag(key) + this.tagEndChar;
        else return this.indentate(level) + '<' + key + attrStr + '>' + textValue + '</' + key + this.tagEndChar;
    }
};
$027681a8ad4ba704$var$Builder.prototype.replaceEntitiesValue = function(textValue) {
    if (textValue && textValue.length > 0 && this.options.processEntities) for(let i = 0; i < this.options.entities.length; i++){
        const entity = this.options.entities[i];
        textValue = textValue.replace(entity.regex, entity.val);
    }
    return textValue;
};
function $027681a8ad4ba704$var$indentate(level) {
    return this.options.indentBy.repeat(level);
}
function $027681a8ad4ba704$var$isAttribute(name /*, options*/ ) {
    if (name.startsWith(this.options.attributeNamePrefix) && name !== this.options.textNodeName) return name.substr(this.attrPrefixLen);
    else return false;
}
$027681a8ad4ba704$exports = $027681a8ad4ba704$var$Builder;


$0ba1812d3e9b7dec$exports = {
    XMLParser: $ab187eb28ef3756e$exports,
    XMLValidator: $f11c3627e8ea9d88$exports,
    XMLBuilder: $027681a8ad4ba704$exports
};




var $gMLdp = parcelRequire("gMLdp");
const $a61399d7add80213$var$NODEWIDTH = 10 // chars for label splitting
;
var $a61399d7add80213$var$lastFileName = '' // the name of the file last read in
;
let $a61399d7add80213$var$msg = '';
function $a61399d7add80213$export$12d9b7805ed59d8e(e) {
    var file = e.target.files[0];
    if (!file) return;
    let fileName = file.name;
    $a61399d7add80213$var$lastFileName = fileName;
    document.body.style.cursor = 'wait';
    (0, $gFW3W.statusMsg)("Reading '" + fileName + "'");
    $a61399d7add80213$var$msg = '';
    e.target.value = '';
    var reader = new FileReader();
    reader.onloadend = function(e) {
        try {
            document.body.style.cursor = 'wait';
            $a61399d7add80213$var$loadFile(e.target.result);
            if (!$a61399d7add80213$var$msg) (0, $gFW3W.alertMsg)("Read '" + fileName + "'", 'info');
        } catch (err) {
            document.body.style.cursor = 'default';
            (0, $gFW3W.alertMsg)("Error reading '" + fileName + "': " + err.message, 'error');
            console.log(err);
            return;
        }
        document.body.style.cursor = 'default';
    };
    reader.readAsArrayBuffer(file);
}
function $a61399d7add80213$export$c47c8b06a9966d9f() {
    (0, $gFW3W.elem)('fileInput').click();
}
/**
 * Allow user to open a file by dragging and dropping it over the PRSM window
 */ (0, $gFW3W.elem)('container').addEventListener('drop', (e)=>{
    e.preventDefault();
    let dt = e.dataTransfer;
    let files = dt.files;
    if (files.length > 0) $a61399d7add80213$export$12d9b7805ed59d8e({
        target: {
            files: files
        }
    });
});
(0, $gFW3W.elem)('container').addEventListener('dragover', (e)=>{
    e.preventDefault();
});
/**
 * determine what kind of file it is, parse it and replace any current map with the one read from the file
 * @param {string} contents - what is in the file
 */ function $a61399d7add80213$var$loadFile(contents) {
    if ((0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.length > 0) {
        if (!confirm('Loading a file will delete the current network.  Are you sure you want to replace it?')) return;
    }
    (0, $e1c55b086cf8dd0e$export$fb931cd598921492)();
    // load the file as one single yjs transaction to reduce server traffic
    (0, $e1c55b086cf8dd0e$export$c265e176a8e0f011)();
    (0, $e1c55b086cf8dd0e$export$2a111da947c407d2).transact(()=>{
        switch($a61399d7add80213$var$lastFileName.split('.').pop().toLowerCase()){
            case 'csv':
                $a61399d7add80213$var$loadCSV($a61399d7add80213$var$arrayBufferToString(contents));
                break;
            case 'graphml':
                $a61399d7add80213$var$loadGraphML($a61399d7add80213$var$arrayBufferToString(contents));
                break;
            case 'gml':
                $a61399d7add80213$var$loadGML($a61399d7add80213$var$arrayBufferToString(contents));
                break;
            case 'json':
            case 'prsm':
                $a61399d7add80213$var$loadPRSMfile($a61399d7add80213$var$arrayBufferToString(contents));
                break;
            case 'gv':
            case 'dot':
                $a61399d7add80213$var$loadDOTfile($a61399d7add80213$var$arrayBufferToString(contents));
                break;
            case 'xlsx':
                $a61399d7add80213$var$loadExcelfile(contents);
                break;
            default:
                throw {
                    message: 'Unrecognised file name suffix'
                };
        }
        let nodesToUpdate = [];
        (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get().forEach((n)=>{
            // ensure that all nodes have a grp property (converting 'group' property for old format files)
            if (!n.grp) n.grp = n.group ? 'group' + n.group % 9 : 'group0';
            // reassign the sample properties to the nodes
            n = (0, $gFW3W.deepMerge)((0, $09258687963db43e$export$9dd6ff9ea0189349).nodes[n.grp], n);
            // version 1.6 made changes to label scaling
            n.scaling = {
                label: {
                    enabled: false,
                    max: 40,
                    min: 10
                },
                max: 100,
                min: 10
            };
            nodesToUpdate.push(n);
        });
        (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.update(nodesToUpdate);
        // same for edges
        let edgesToUpdate = [];
        (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.get().forEach((e)=>{
            // ensure that all edges have a grp property (converting 'group' property for old format files)
            if (!e.grp) e.grp = e.group ? 'edge' + e.group % 9 : 'edge0';
            // reassign the sample properties to the edges
            e = (0, $gFW3W.deepMerge)((0, $09258687963db43e$export$9dd6ff9ea0189349).edges[e.grp], e);
            edgesToUpdate.push(e);
        });
        (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.update(edgesToUpdate);
        (0, $e1c55b086cf8dd0e$export$1e044b7877db048c)();
        (0, $79c06594b77924a6$export$b8032ab161d91961)();
        (0, $e1c55b086cf8dd0e$export$e5fde6ebaea8ae1d)('loaded &lt;' + $a61399d7add80213$var$lastFileName + '&gt;');
    });
    (0, $e1c55b086cf8dd0e$export$f796f85272199be2).clear();
    (0, $e1c55b086cf8dd0e$export$e810bab53f2cc5ca)();
    (0, $e1c55b086cf8dd0e$export$c1a1b42e4610dc4a)();
    (0, $e1c55b086cf8dd0e$export$5dfa5433ac89eafa)();
}
/**
 * convert an ArrayBuffer to String
 * @param {arrayBuffer} contents
 * @returns string
 */ function $a61399d7add80213$var$arrayBufferToString(contents) {
    let decoder = new TextDecoder('utf-8');
    return decoder.decode(new DataView(contents));
}
/**
 * Parse and load a PRSM map file, or a JSON file exported from Gephi
 * @param {string} str
 */ function $a61399d7add80213$var$loadPRSMfile(str) {
    if (str[0] != '{') str = (0, $3gspO.decompressFromUTF16)(str);
    let json = JSON.parse(str);
    if (json.version && (0, $gMLdp.version).substring(0, 3) > json.version.substring(0, 3)) {
        (0, $gFW3W.alertMsg)('Warning: file was created in an earlier version', 'warn');
        $a61399d7add80213$var$msg = 'old version';
    }
    (0, $e1c55b086cf8dd0e$export$7ac138a1e38951d6)(json.lastNodeSample, json.lastLinkSample);
    if (json.buttons) $a61399d7add80213$var$setButtonStatus(json.buttons);
    if (json.mapTitle) (0, $e1c55b086cf8dd0e$export$807f940a96777041).set('mapTitle', (0, $e1c55b086cf8dd0e$export$f229389f565c6b3f)(json.mapTitle));
    /* if (json.recentMaps) {
		let recents = JSON.parse(localStorage.getItem('recents')) || {}
		localStorage.setItem('recents', JSON.stringify(Object.assign(json.recentMaps, recents)))
	} */ if (json.attributeTitles) (0, $e1c55b086cf8dd0e$export$807f940a96777041).set('attributeTitles', json.attributeTitles);
    else (0, $e1c55b086cf8dd0e$export$807f940a96777041).set('attributeTitles', {});
    if (json.edges.length > 0 && 'source' in json.edges[0]) {
        // the file is from Gephi and needs to be translated
        let parsed = (0, $bebd28704f2536ea$export$63f58ee125a505f5)(json, {
            edges: {
                inheritColors: false
            },
            nodes: {
                fixed: false,
                parseColor: true
            }
        });
        (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.add(parsed.nodes);
        (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.add(parsed.edges);
    } else {
        json.nodes.forEach((n)=>{
            // at version 1.5, the title: property was renamed to note:
            if (!n.note && n.title) n.note = n.title.replace(/<br>|<p>/g, '\n');
            delete n.title;
            if (n.note && !(n.note instanceof Object)) n.note = {
                ops: [
                    {
                        insert: n.note
                    }
                ]
            };
        });
        (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.add(json.nodes);
        json.edges.forEach((e)=>{
            if (!e.note && e.title) e.note = e.title.replace(/<br>|<p>/g, '\n');
            delete e.title;
            if (e.note && !(e.note instanceof Object)) e.note = {
                ops: [
                    {
                        insert: e.note
                    }
                ]
            };
        });
        (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.add(json.edges);
    }
    // before v1.4, the style array was called samples
    if (json.samples) json.styles = json.samples;
    if (json.styles) {
        (0, $09258687963db43e$export$9dd6ff9ea0189349).nodes = (0, $gFW3W.deepMerge)((0, $09258687963db43e$export$9dd6ff9ea0189349).nodes, json.styles.nodes);
        for(let n in (0, $09258687963db43e$export$9dd6ff9ea0189349).nodes)delete (0, $09258687963db43e$export$9dd6ff9ea0189349).nodes[n].chosen;
        (0, $09258687963db43e$export$9dd6ff9ea0189349).edges = (0, $gFW3W.deepMerge)((0, $09258687963db43e$export$9dd6ff9ea0189349).edges, json.styles.edges);
        for(let e in (0, $09258687963db43e$export$9dd6ff9ea0189349).edges)delete (0, $09258687963db43e$export$9dd6ff9ea0189349).edges[e].chosen;
        for(let groupId in (0, $09258687963db43e$export$9dd6ff9ea0189349).nodes){
            (0, $e1c55b086cf8dd0e$export$4b63d58d2685a993).set(groupId, {
                node: (0, $09258687963db43e$export$9dd6ff9ea0189349).nodes[groupId]
            });
            if (groupId.match(/\d+/)?.[0]) (0, $79c06594b77924a6$export$675fa328fb4ebccd)(groupId);
        }
        for(let edgeId in (0, $09258687963db43e$export$9dd6ff9ea0189349).edges){
            (0, $e1c55b086cf8dd0e$export$4b63d58d2685a993).set(edgeId, {
                edge: (0, $09258687963db43e$export$9dd6ff9ea0189349).edges[edgeId]
            });
            if (edgeId.match(/\d+/)?.[0]) (0, $79c06594b77924a6$export$e496289367e7ce52)(edgeId);
        }
    }
    (0, $e1c55b086cf8dd0e$export$da7062de5ac36f9c).clear();
    (0, $a4a268d7686bbf3f$export$67ea982130081db).clear();
    (0, $e1c55b086cf8dd0e$export$ffba1a0e51177788).delete(0, (0, $e1c55b086cf8dd0e$export$ffba1a0e51177788).length);
    if (json.underlay) {
        // background from v1; update it
        (0, $e1c55b086cf8dd0e$export$ffba1a0e51177788).insert(0, json.underlay);
        if ((0, $e1c55b086cf8dd0e$export$ffba1a0e51177788).length > 0) (0, $a4a268d7686bbf3f$export$aab3aebcdfaf4b16)((0, $e1c55b086cf8dd0e$export$ffba1a0e51177788).toArray());
    }
    if (json.background) {
        (0, $a4a268d7686bbf3f$export$cf606e54e8a9990d)();
        let map = JSON.parse(json.background);
        for (const [key, value] of Object.entries(map))(0, $e1c55b086cf8dd0e$export$da7062de5ac36f9c).set(key, value);
        (0, $a4a268d7686bbf3f$export$8d588f71d329a9b1)(Object.keys(map));
    }
    (0, $e1c55b086cf8dd0e$export$d920e34eaf2b21cb).delete(0, (0, $e1c55b086cf8dd0e$export$d920e34eaf2b21cb).length);
    if (json.history) (0, $e1c55b086cf8dd0e$export$d920e34eaf2b21cb).insert(0, json.history);
    if (json.description) {
        (0, $e1c55b086cf8dd0e$export$807f940a96777041).set('mapDescription', json.description);
        (0, $e1c55b086cf8dd0e$export$3a86b7dfc26ebfa6)();
        (0, $e1c55b086cf8dd0e$export$cff30a8f7435ec50)(json.description);
    }
    // node sizing has to be done after nodes have been created
    (0, $e1c55b086cf8dd0e$export$9758cac25f26dd85)((0, $e1c55b086cf8dd0e$export$807f940a96777041).get('sizing'));
}
/**
 * parse and load a GraphViz (.DOT or .GV) file
 *  uses the vis-network DOT parser, which is pretty hopeless -
 *  e.g. it does not manage dotted or dashed node borders and
 *  requires some massaging of the parameters it does recognise
 *
 * @param {string} graph contents of DOT file
 * @returns nodes and edges as an object
 */ function $a61399d7add80213$var$loadDOTfile(graph) {
    let parsedData = (0, $bebd28704f2536ea$export$79fd918c7a17d782)(graph);
    (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.add(parsedData.nodes.map((node)=>{
        let n = (0, $gFW3W.strip)(node, [
            'id',
            'label',
            'color',
            'shape',
            'font',
            'width'
        ]);
        if (!n.id) n.id = (0, $gFW3W.uuidv4)();
        if (!n.color) n.color = (0, $gFW3W.deepCopy)((0, $09258687963db43e$export$9dd6ff9ea0189349).nodes['group0'].color);
        if (!n.font) n.font = (0, $gFW3W.deepCopy)((0, $09258687963db43e$export$9dd6ff9ea0189349).nodes['group0'].font);
        if (!n.shape) n.shape = (0, $gFW3W.deepCopy)((0, $09258687963db43e$export$9dd6ff9ea0189349).nodes['group0'].shape);
        if (n.font?.size) n.font.size = parseInt(n.font.size);
        if (n.width) n.borderWidth = parseInt(n.width);
        if (n.shape === 'plaintext') {
            n.shape = 'text';
            n.borderWidth = 0;
        }
        return n;
    }));
    (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.add(parsedData.edges.map((edge)=>{
        let e = (0, $gFW3W.strip)(edge, [
            'id',
            'from',
            'to',
            'label',
            'color',
            'dashes'
        ]);
        if (!e.id) e.id = (0, $gFW3W.uuidv4)();
        if (!e.color) e.color = (0, $gFW3W.deepCopy)((0, $09258687963db43e$export$9dd6ff9ea0189349).edges['edge0'].color);
        if (!e.dashes) e.dashes = (0, $gFW3W.deepCopy)((0, $09258687963db43e$export$9dd6ff9ea0189349).edges['edge0'].dashes);
        if (!e.width) e.width = e.width ? parseInt(e.width) : (0, $09258687963db43e$export$9dd6ff9ea0189349).edges['edge0'].width;
        return e;
    }));
}
/**
 * parse and load a graphML file
 * @param {string} graphML
 */ function $a61399d7add80213$var$loadGraphML(graphML) {
    let options = {
        attributeNamePrefix: '',
        attrNodeName: 'attr',
        textNodeName: 'txt',
        ignoreAttributes: false,
        ignoreNameSpace: true,
        allowBooleanAttributes: false,
        parseNodeValue: true,
        parseAttributeValue: true,
        trimValues: true,
        parseTrueNumberOnly: false,
        arrayMode: false
    };
    var result = $0ba1812d3e9b7dec$exports.validate(graphML, options);
    if (result !== true) throw {
        message: result.err.msg + '(line ' + result.err.line + ')'
    };
    let jsonObj = $0ba1812d3e9b7dec$exports.parse(graphML, options);
    (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.add(jsonObj.graphml.graph.node.map((n)=>{
        return {
            id: n.attr.id.toString(),
            label: getLabel(n.data)
        };
    }));
    (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.add(jsonObj.graphml.graph.edge.map((e)=>{
        return {
            id: e.attr.id.toString(),
            from: e.attr.source.toString(),
            to: e.attr.target.toString()
        };
    }));
    function getLabel(arr) {
        for (let at of arr){
            if (at.attr.key == 'label') return at.txt;
        }
    }
}
/**
 * Parse and load a GML file
 * @param {string} gml
 */ function $a61399d7add80213$var$loadGML(gml) {
    if (gml.search('graph') < 0) throw {
        message: 'invalid GML format'
    };
    let tokens = gml.match(/"[^"]+"|[\w]+|\[|\]/g);
    let node;
    let edge;
    let edgeId = 0;
    let tok = tokens.shift();
    while(tok){
        switch(tok){
            case 'graph':
                break;
            case 'node':
                tokens.shift() // [
                ;
                node = {};
                tok = tokens.shift();
                while(tok != ']'){
                    switch(tok){
                        case 'id':
                            node.id = tokens.shift().toString();
                            break;
                        case 'label':
                            node.label = (0, $gFW3W.splitText)(tokens.shift().replace(/"/g, ''), $a61399d7add80213$var$NODEWIDTH);
                            break;
                        case 'color':
                        case 'colour':
                            node.color = {};
                            node.color.background = tokens.shift().replace(/"/g, '');
                            break;
                        case '[':
                            while(tok != ']')tok = tokens.shift();
                            break;
                        default:
                            break;
                    }
                    tok = tokens.shift() // ]
                    ;
                }
                if (node.label == undefined) node.label = node.id;
                (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.add(node);
                break;
            case 'edge':
                tokens.shift() // [
                ;
                edge = {};
                tok = tokens.shift();
                while(tok != ']'){
                    switch(tok){
                        case 'id':
                            edge.id = tokens.shift().toString();
                            break;
                        case 'source':
                            edge.from = tokens.shift().toString();
                            break;
                        case 'target':
                            edge.to = tokens.shift().toString();
                            break;
                        case 'label':
                            edge.label = tokens.shift().replace(/"/g, '');
                            break;
                        case 'color':
                        case 'colour':
                            edge.color = tokens.shift().replace(/"/g, '');
                            break;
                        case '[':
                            while(tok != ']')tok = tokens.shift();
                            break;
                        default:
                            break;
                    }
                    tok = tokens.shift() // ]
                    ;
                }
                if (edge.id == undefined) edge.id = (edgeId++).toString();
                (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.add(edge);
                break;
            default:
                break;
        }
        tok = tokens.shift();
    }
}
/**
 * Read a comma separated values file consisting of 'From' label and 'to' label, on each row,
	 with a header row (ignored) 
	optional, cols 3 and 4 can include the groups (styles) of the from and to nodes,
	column 5 can include the style of the edge.  All these must be integers between 1 and 9
 * @param {string} csv 
 */ function $a61399d7add80213$var$loadCSV(csv) {
    let lines = csv.split(/\r\n|\n/);
    let labels = new Map();
    let links = [];
    for(let i = 1; i < lines.length; i++){
        if (lines[i].length <= 2) continue; // empty line
        let line = splitCSVrow(lines[i]);
        let from = node(line[0], line[2], i);
        let to = node(line[1], line[3], i);
        let grp = line[4];
        if (grp) grp = 'edge' + (parseInt(grp.trim()) - 1);
        links.push({
            id: (0, $gFW3W.uuidv4)(),
            from: from.id,
            to: to.id,
            grp: grp
        });
    }
    (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.add(Array.from(labels.values()));
    (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.add(links);
    /**
	 * Parse a CSV row, accounting for commas inside quotes
	 * @param {string} row
	 * @returns array of fields
	 */ function splitCSVrow(row) {
        let insideQuote = false, entries = [], entry = [];
        row.split('').forEach(function(character) {
            if (character === '"') insideQuote = !insideQuote;
            else if (character == ',' && !insideQuote) {
                entries.push(entry.join(''));
                entry = [];
            } else entry.push(character);
        });
        entries.push(entry.join(''));
        return entries;
    }
    /**
	 * retrieves or creates a (new) node object with given label and style,
	 * @param {string} label
	 * @param {number} grp
	 * @param {number} lineNo the file line where this node was read from
	 * @returns the node object
	 */ function node(label, grp, lineNo) {
        label = label.trim();
        if (grp) {
            let styleNo = parseInt(grp);
            if (isNaN(styleNo) || styleNo < 1 || styleNo > 9) throw {
                message: `Line ${lineNo}: Columns 3 and 4 must be values between 1 and 9 or blank (found ${grp})`
            };
            grp = 'group' + (styleNo - 1);
        }
        if (labels.get(label) == undefined) labels.set(label, {
            id: (0, $gFW3W.uuidv4)(),
            label: label.toString(),
            grp: grp
        });
        return labels.get(label);
    }
}
/**
 * Reads map data from an Excel file.  The file must have two spreadsheets in the workbook, named Factors and Links
 * In the spreadsheet, there must be a header row, and columns for (minimally) Label (and for links, also From and To,
 * with entries with the exact same text as the Labels in the Factor sheet.  There may be a Style column, which is used
 * to specify the style for the Factor or Link (numbered from 1 to 9).  There may be a Description (or note or Note)
 * column, the contents of which are treated as a Factor or Link note.  Any other columns are treated as holding values
 * for additional Attributes.
 *
 * Uses https://sheetjs.com/
 *
 * @param {*} contents
 * @returns nodes and edges data
 */ function $a61399d7add80213$var$loadExcelfile(contents) {
    let workbook = (0, $b8f343bf88dacc48$export$aafa59e2e03f2942)(contents);
    let factorsSS = workbook.Sheets['Factors'];
    if (!factorsSS) throw {
        message: 'Sheet named Factors not found in Workbook'
    };
    let linksSS = workbook.Sheets['Links'];
    if (!linksSS) throw {
        message: 'Sheet named Links not found in Workbook'
    };
    // attributeNames is an object with properties attributeField: attributeTitle
    let attributeNames = {};
    /* 
	 Transform data about factors into an array of objects, with properties named after the column headings
	 (with first letter lower cased if necessary) and values from that row's cells.
	 add a GUID to the object,  change 'Style' property to 'grp'
	 Style is a style number between 1 and 9
	 Put value of Description or Notes property into notes
	 Check that any other property names are not in the list of known attribute names; if so add that property name to the attribute name list 
	 Place the factor either at the given x and y coordinates or at some random location
	 */ // convert data from Factors sheet into an array of objects with properties starting with lower case letters
    let factors = (0, $b8f343bf88dacc48$export$eab97d15b1788b8d).sheet_to_json(factorsSS).map((f)=>lowerInitialLetterOfProps(f));
    factors.forEach((f)=>{
        f.id = (0, $gFW3W.uuidv4)();
        if (f.style) {
            let styleNo = parseInt(f.style);
            if (isNaN(styleNo) || styleNo < 1 || styleNo > 9) throw {
                message: `Factors - Line ${f.__rowNum__}: Style must be a number between 1 and 9, a style name, or blank (found ${f.style})`
            };
            f.grp = 'group' + (styleNo - 1);
            if (f.groupLabel) {
                let styleDataSet = Array.from(document.getElementsByClassName('sampleNode'))[styleNo - 1].dataSet;
                let styleNode = styleDataSet.get('1');
                styleNode.label = f.groupLabel;
                styleNode.groupLabel = f.groupLabel;
                styleDataSet.update(styleNode);
                (0, $09258687963db43e$export$9dd6ff9ea0189349).nodes[f.grp].groupLabel = f.groupLabel;
            }
            delete f.style;
        }
        if (!f.label) throw {
            message: `Factors - Line ${f.__rowNum__}: Factor does not have a Label`
        };
        let note = f.description || f.note;
        if (note) {
            f.note = {
                ops: [
                    {
                        insert: note + '\n'
                    }
                ]
            };
            delete f.description;
        }
        if (f.creator) {
            f.created = {
                time: f.createdTime ? Date.parse(f.createdTime) : Date.now(),
                user: f.creator
            };
            delete f.createdTime;
        }
        if (f.modifier) {
            f.modified = {
                time: f.modifiedTime ? Date.parse(f.modifiedTime) : Date.now(),
                user: f.modifier
            };
            delete f.modifiedTime;
        }
        // filter out known properties, leaving the rest to become attributes
        Object.keys(f).filter((k)=>![
                'id',
                'grp',
                'label',
                'groupLabel',
                'shape',
                'note',
                'created',
                'createdTime',
                'creator',
                'modified',
                'modifiedTime',
                'modifier',
                'x',
                'y',
                '__rowNum__'
            ].includes(k)).forEach((k)=>{
            let attributeField = Object.keys(attributeNames).find((prop)=>attributeNames[prop] === k);
            if (!attributeField) {
                // not found, so add
                attributeField = 'att' + (Object.keys(attributeNames).length + 1);
                attributeNames[attributeField] = k;
            }
            f[attributeField] = f[k];
            delete f[k];
        });
        f.x = parseInt(f.x);
        if (!f.x || isNaN(f.x)) f.x = Math.random() * 500;
        f.y = parseInt(f.y);
        if (!f.y || isNaN(f.y)) f.y = Math.random() * 500;
    });
    /* for each row of links
	add a GUID
	look up from and to in factor objects and replace with their ids
	add other attributes as for factors */ let links = (0, $b8f343bf88dacc48$export$eab97d15b1788b8d).sheet_to_json(linksSS).map((l)=>lowerInitialLetterOfProps(l));
    links.forEach((l)=>{
        l.id = (0, $gFW3W.uuidv4)();
        if (l.style) {
            let styleNo = parseInt(l.style);
            if (isNaN(styleNo) || styleNo < 1 || styleNo > 9) throw {
                message: `Links - Line ${l.__rowNum__}: Style must be a number between 1 and 9, a style name, or blank (found ${l.style})`
            };
            l.grp = 'edge' + (styleNo - 1);
            if (l.groupLabel) {
                let styleDataSet = Array.from(document.getElementsByClassName('sampleLink'))[styleNo - 1].dataSet;
                let styleEdge = styleDataSet.get('1');
                styleEdge.label = l.groupLabel;
                styleEdge.groupLabel = l.groupLabel;
                styleDataSet.update(styleEdge);
                (0, $09258687963db43e$export$9dd6ff9ea0189349).edges[l.grp].groupLabel = l.groupLabel;
            }
            delete l.style;
        }
        if (l.creator) {
            l.created = {
                time: l.createdTime ? Date.parse(l.createdTime) : Date.now(),
                user: l.creator
            };
            delete l.createdTime;
        }
        if (l.modifier) {
            l.modified = {
                time: l.modifiedTime ? Date.parse(l.modifiedTime) : Date.now(),
                user: l.modifier
            };
            delete l.modifiedTime;
        }
        let fromFactor = factors.find((factor)=>factor.label === l.from);
        if (fromFactor) l.from = fromFactor.id;
        else throw {
            message: `Links - Line ${l.__rowNum__}: From factor (${l.from}) not found for link`
        };
        let toFactor = factors.find((factor)=>factor.label === l.to);
        if (toFactor) l.to = toFactor.id;
        else throw {
            message: `Links - Line ${l.__rowNum__}: To factor (${l.to}) not found for link`
        };
        let note = l.description || l.note;
        if (note) {
            l.note = {
                ops: [
                    {
                        insert: note + '\n'
                    }
                ]
            };
            delete l.description;
        }
        Object.keys(l).filter((k)=>![
                'id',
                'from',
                'to',
                'grp',
                'groupLabel',
                'creator',
                'created',
                'label',
                'modified',
                'modifier',
                'note',
                '__rowNum__'
            ].includes(k)).forEach((k)=>{
            let attributeField = Object.keys(attributeNames).find((prop)=>attributeNames[prop] === k);
            if (!attributeField) {
                // not found, so add
                attributeField = 'att' + (Object.keys(attributeNames).length + 1);
                attributeNames[attributeField] = k;
            }
            l[attributeField] = l[k];
            delete l[k];
        });
    });
    factors.forEach((f)=>{
        f.label = (0, $gFW3W.splitText)(f.label, $a61399d7add80213$var$NODEWIDTH);
    });
    (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.add(factors);
    (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.add(links);
    (0, $e1c55b086cf8dd0e$export$807f940a96777041).set('attributeTitles', attributeNames);
    (0, $e1c55b086cf8dd0e$export$5323aa6dd0c7006b)(attributeNames);
    /**
	 * ensure the initial letter of each property of obj is lower case
	 * @param {object} obj
	 * @returns copy of object
	 */ function lowerInitialLetterOfProps(obj) {
        return Object.fromEntries(Object.entries(obj).map(([k, v])=>[
                (0, $gFW3W.lowerFirstLetter)(k),
                v
            ]));
    }
}
function $a61399d7add80213$export$37a761894e599695() {
    (0, $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4).storePositions();
    let attributes = (0, $e1c55b086cf8dd0e$export$807f940a96777041).get('attributeTitles') || [];
    let nodeFields = [
        'id',
        'label',
        'grp',
        'x',
        'y',
        'color',
        'font',
        'borderWidth',
        'shape',
        'shapeProperties',
        'margin',
        'thumbUp',
        'thumbDown',
        'created',
        'modified'
    ];
    let json = JSON.stringify({
        saved: new Date(Date.now()).toLocaleString(),
        version: (0, $gMLdp.version),
        room: (0, $e1c55b086cf8dd0e$export$f9d3fff8c23da278),
        mapTitle: (0, $gFW3W.elem)('maptitle').innerText,
        // 			security risk to save recent maps to a file
        //			recentMaps: JSON.parse(localStorage.getItem('recents')),
        lastNodeSample: (0, $e1c55b086cf8dd0e$export$794b27baf354ffba),
        lastLinkSample: (0, $e1c55b086cf8dd0e$export$a01f2d76756b77a5),
        // clustering, and up/down, paths between and x links away settings are not saved (and hidden property is not saved)
        buttons: $a61399d7add80213$var$getButtonStatus(),
        attributeTitles: (0, $e1c55b086cf8dd0e$export$807f940a96777041).get('attributeTitles'),
        styles: (0, $09258687963db43e$export$9dd6ff9ea0189349),
        nodes: (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get({
            fields: [
                ...nodeFields,
                ...Object.keys(attributes)
            ],
            filter: (n)=>!n.isCluster
        }),
        edges: (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.get({
            fields: [
                'id',
                'arrows',
                'color',
                'created',
                'dashes',
                'font',
                'from',
                'grp',
                'label',
                'modified',
                'note',
                'to',
                'width'
            ],
            filter: (e)=>!e.isClusterEdge
        }),
        background: JSON.stringify((0, $e1c55b086cf8dd0e$export$da7062de5ac36f9c).toJSON()),
        history: (0, $e1c55b086cf8dd0e$export$d920e34eaf2b21cb).map((s)=>{
            s.state = null;
            return s;
        }),
        description: (0, $e1c55b086cf8dd0e$export$807f940a96777041).get('mapDescription')
    }, null, '\t');
    if (!/plain/.test((0, $e1c55b086cf8dd0e$export$1c9f709888824e05))) json = (0, $3gspO.compressToUTF16)(json);
    $a61399d7add80213$var$saveStr(json, 'prsm');
    (0, $e1c55b086cf8dd0e$export$38a5743670a777eb)();
}
/**
 * return an object with the current Network panel setting for saving
 * settings for link radius and up/down stream are not saved
 * @return an object with the Network panel settings
 */ function $a61399d7add80213$var$getButtonStatus() {
    return {
        snapToGrid: (0, $gFW3W.elem)('snaptogridswitch').checked,
        curve: (0, $gFW3W.elem)('curveSelect').value,
        background: (0, $gFW3W.elem)('netBackColorWell').style.backgroundColor,
        legend: (0, $gFW3W.elem)('showLegendSwitch').checked,
        sizing: (0, $gFW3W.elem)('sizing').value
    };
}
/**
 * Set the Network panel buttons to their values loaded from a file
 * @param {Object} settings
 */ function $a61399d7add80213$var$setButtonStatus(settings) {
    (0, $e1c55b086cf8dd0e$export$807f940a96777041).set('snapToGrid', settings.snapToGrid);
    (0, $e1c55b086cf8dd0e$export$95ff17332160327a)(settings.snapToGrid);
    (0, $e1c55b086cf8dd0e$export$807f940a96777041).set('curve', settings.curve);
    (0, $e1c55b086cf8dd0e$export$264d5714f8b2c7d8)(settings.curve);
    (0, $e1c55b086cf8dd0e$export$807f940a96777041).set('background', settings.background || '#ffffff');
    (0, $e1c55b086cf8dd0e$export$2e65e79124cca55d)((0, $e1c55b086cf8dd0e$export$807f940a96777041).get('background'));
    (0, $e1c55b086cf8dd0e$export$807f940a96777041).set('legend', settings.legend);
    (0, $e1c55b086cf8dd0e$export$e8f1ea4a10bfd1c9)(settings.legend);
    (0, $e1c55b086cf8dd0e$export$807f940a96777041).set('sizing', settings.sizing);
    // sizing done after the nodes have been created: sizing(settings.sizing)
    (0, $e1c55b086cf8dd0e$export$807f940a96777041).set('radius', {
        radiusSetting: 'All',
        selected: []
    });
    (0, $e1c55b086cf8dd0e$export$807f940a96777041).set('stream', {
        streamSetting: 'All',
        selected: []
    });
    (0, $e1c55b086cf8dd0e$export$807f940a96777041).set('paths', {
        pathsSetting: 'All',
        selected: []
    });
    (0, $e1c55b086cf8dd0e$export$807f940a96777041).set('cluster', 'none');
    (0, $e1c55b086cf8dd0e$export$8b2b949f916968c1)('none');
}
/**
 * Save the string to a local file
 * @param {string} str file contents
 * @param {string} extn file extension
 *
 * Browser will only ask for name and location of the file to be saved if
 * it has a user setting to do so.  Otherwise, it is saved at a default
 * download location with a default name.
 */ function $a61399d7add80213$var$saveStr(str, extn) {
    $a61399d7add80213$export$20ca267bc6805c64(extn);
    const blob = new Blob([
        str
    ], {
        type: 'text/plain;charset=utf-8'
    });
    (0, $cc2db08ef43e5d3c$exports.saveAs)(blob, $a61399d7add80213$var$lastFileName, {
        autoBom: true
    });
}
/**
 * save the map as a PNG image file
 */ const $a61399d7add80213$var$maxScale = 5 // max upscaling for image (avoids blowing up very small networks excessively)
;
function $a61399d7add80213$export$f0cc1c631fa5bb45() {
    $a61399d7add80213$export$20ca267bc6805c64('png');
    // create a very large canvas, so we can download at high resolution
    (0, $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4).storePositions();
    // first, create a large offscreen div to hold a copy of the network at the required width
    const bigWidth = 4096 / window.devicePixelRatio // half the number of pixels in the image file (also half the height, as the image is square)
    ;
    const bigMargin = 256 / window.devicePixelRatio // white space around network so not too close to printable edge
    ;
    let bigNetDiv = document.createElement('div');
    bigNetDiv.id = 'big-net-pane';
    bigNetDiv.style.position = 'absolute';
    bigNetDiv.style.top = '-9999px';
    bigNetDiv.style.left = '-9999px';
    bigNetDiv.style.width = `${bigWidth}px`;
    bigNetDiv.style.height = `${bigWidth}px`;
    (0, $gFW3W.elem)('main').appendChild(bigNetDiv);
    // create an offscreen canvas of the same size to apply the background to
    let bigBackgroundCanvas = new OffscreenCanvas(bigWidth, bigWidth);
    bigBackgroundCanvas.id = 'big-background-canvas';
    let bigFabricCanvas = new (0, $79564f678731bf19$exports.fabric).StaticCanvas('big-background-canvas', {
        width: bigWidth,
        height: bigWidth
    });
    // make a network with the same nodes and links as the original map
    let bigNetwork = new (0, $bebd28704f2536ea$export$95be4ae94445245a)(bigNetDiv, (0, $e1c55b086cf8dd0e$export$4051a07651545597), {
        physics: {
            enabled: false
        },
        edges: {
            smooth: {
                enabled: (0, $gFW3W.elem)('curveSelect').value === 'Curved',
                type: 'straightCross'
            }
        }
    });
    bigNetwork.on('afterDrawing', (bigNetContext)=>{
        // copy the background objects to the big fabric canvas
        bigFabricCanvas.loadFromJSON(JSON.stringify((0, $a4a268d7686bbf3f$export$67ea982130081db)), ()=>{
            // adjust the fabric canvas scale and center to match the big network and match the background colour
            bigFabricCanvas.setZoom(bigNetwork.getScale());
            let fcCenter = bigFabricCanvas.getVpCenter();
            bigFabricCanvas.relativePan({
                x: bigNetwork.getScale() * (fcCenter.x - center.x),
                y: bigNetwork.getScale() * (fcCenter.y - center.y)
            });
            bigFabricCanvas.setBackgroundColor((0, $gFW3W.elem)('underlay').style.backgroundColor || 'rgb(255, 255, 255)');
            bigFabricCanvas.requestRenderAll();
            // create an image version of the background and copy it onto the big network canvas
            let bigBackgroundImage = document.createElement('img');
            bigBackgroundImage.onload = function() {
                bigNetContext.globalCompositeOperation = 'destination-over';
                bigNetContext.drawImage(bigBackgroundImage, 0, 0, bigWidth, bigWidth);
                // save the canvas to a file
                bigNetContext.canvas.toBlob((blob)=>(0, $cc2db08ef43e5d3c$exports.saveAs)(blob, $a61399d7add80213$var$lastFileName));
                // clean up
                bigNetwork.destroy();
                bigNetDiv.remove();
                bigFabricCanvas.dispose();
            };
            bigBackgroundImage.src = bigFabricCanvas.toDataURL();
        });
    });
    let box = mapBoundingBox((0, $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4), (0, $a4a268d7686bbf3f$export$67ea982130081db), (0, $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4).getSelectedNodes());
    let scale = (0, $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4).getScale() * Math.min((bigWidth - bigMargin) / (box.right - box.left), (bigWidth - bigMargin) / (box.bottom - box.top));
    if (scale > $a61399d7add80213$var$maxScale) scale = $a61399d7add80213$var$maxScale;
    let center = (0, $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4).DOMtoCanvas({
        x: 0.5 * (box.right + box.left),
        y: 0.5 * (box.bottom + box.top)
    });
    bigNetwork.moveTo({
        scale: scale,
        position: center
    });
    /**
	 * Get a bounding box for everything on the map (the nodes and the background objects)
	 * @param {object} ntwk the map on which the nodes are placed
	 * @param {array} selectedNodes Ids of selected nodes, if any
	 * @returns box as an object, with dimensions in DOM coords
	 */ function mapBoundingBox(ntwk, fabCanvas, selectedNodes = []) {
        let top = Infinity, bottom = -Infinity, left = Infinity, right = -Infinity;
        // use all nodes if none selected
        if (selectedNodes.length === 0) selectedNodes = (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.map((n)=>n.id);
        selectedNodes.forEach((nodeId)=>{
            let canvasBB = ntwk.getBoundingBox(nodeId);
            let tl = ntwk.canvasToDOM({
                x: canvasBB.left,
                y: canvasBB.top
            });
            let br = ntwk.canvasToDOM({
                x: canvasBB.right,
                y: canvasBB.bottom
            });
            if (left > tl.x) left = tl.x;
            if (right < br.x) right = br.x;
            if (top > tl.y) top = tl.y;
            if (bottom < br.y) bottom = br.y;
        });
        // only include background objects if no nodes are selected
        if (selectedNodes.length === 0) fabCanvas.forEachObject((obj)=>{
            let boundingBox = obj.getBoundingRect();
            console.log(obj, boundingBox);
            if (left > boundingBox.left) left = boundingBox.left;
            if (right < boundingBox.left + boundingBox.width) right = boundingBox.left + boundingBox.width;
            if (top > boundingBox.top) top = boundingBox.top;
            if (bottom < boundingBox.top + boundingBox.height) bottom = boundingBox.top + boundingBox.height;
        });
        if (left === Infinity) top = bottom = left = right = 0;
        return {
            left: left,
            right: right,
            top: top,
            bottom: bottom
        };
    }
}
async function $a61399d7add80213$export$83b54ab4d55d8ebe() {
    let delta = {
        ops: [
            {
                insert: '\n'
            }
        ]
    };
    // start with the title of the map if there is one
    let title = (0, $gFW3W.elem)('maptitle').innerText;
    if (title !== 'Untitled map') delta = {
        ops: [
            {
                insert: title
            },
            {
                attributes: {
                    header: 1
                },
                insert: '\n'
            }
        ]
    };
    // get contents of map note if there is one
    if ((0, $e1c55b086cf8dd0e$export$807f940a96777041).get('mapDescription')) delta.ops = delta.ops.concat([
        {
            insert: 'Description of the map'
        },
        {
            attributes: {
                header: 2
            },
            insert: '\n'
        }
    ], (0, $e1c55b086cf8dd0e$export$807f940a96777041).get('mapDescription').text.ops);
    // add notes for factors
    (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get().toSorted((a, b)=>a.label.localeCompare(b.label)).forEach((n)=>{
        delta.ops = delta.ops.concat([
            {
                insert: `Factor: ${(0, $gFW3W.stripNL)(n.label)}`
            },
            {
                attributes: {
                    header: 2
                },
                insert: '\n'
            }
        ], n.note ? n.note.ops : [
            {
                insert: '[No note]\n'
            }
        ]);
    });
    // add notes for links
    (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.forEach((e)=>{
        let heading = `Link from '${(0, $gFW3W.stripNL)((0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get(e.from).label)}' to '${(0, $gFW3W.stripNL)((0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get(e.to).label)}'`;
        delta.ops = delta.ops.concat([
            {
                insert: heading
            },
            {
                attributes: {
                    header: 2
                },
                insert: '\n'
            }
        ]);
        delta.ops = delta.ops.concat(e.note ? e.note.ops : [
            {
                insert: '[No note]\n'
            }
        ]);
    });
    // save the delta as a Word file
    const quillToWordConfig = {
        exportAs: 'blob',
        paragraphStyles: {
            normal: {
                paragraph: {
                    spacing: {
                        line: 240
                    }
                }
            }
        }
    };
    const docAsBlob = await $e2cb8cc29293ee9d$exports.generateWord(delta, quillToWordConfig);
    $a61399d7add80213$export$20ca267bc6805c64('docx');
    (0, $cc2db08ef43e5d3c$exports.saveAs)(docAsBlob, $a61399d7add80213$var$lastFileName);
}
function $a61399d7add80213$export$20ca267bc6805c64(extn = 'prsm') {
    let title = (0, $gFW3W.elem)('maptitle').innerText;
    if (title === 'Untitled map') $a61399d7add80213$var$lastFileName = 'network';
    else $a61399d7add80213$var$lastFileName = title.replace(/\s+/g, '').replaceAll('.', '_').toLowerCase();
    $a61399d7add80213$var$lastFileName += '.' + extn;
}
function $a61399d7add80213$export$5803f461b1d4777f() {
    // set up Quill note conversion
    let dummyDiv = document.createElement('div');
    dummyDiv.id = 'dummy-div';
    dummyDiv.style.display = 'none';
    (0, $e1c55b086cf8dd0e$export$34e0f9847d4c02dd).appendChild(dummyDiv);
    let qed = new (0, $aBK2w.default)('#dummy-div');
    // create workbook
    const workbook = (0, $b8f343bf88dacc48$export$eab97d15b1788b8d).book_new();
    // Factors
    let rows = (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get().filter((n)=>!n.isCluster).map((n)=>{
        if (n.created) {
            n.creator = n.created.user;
            n.createdTime = new Date(n.created.time).toISOString();
        }
        if (n.modified) {
            n.modifier = n.modified.user;
            n.modifiedTime = new Date(n.modified.time).toISOString();
        }
        n.style = parseInt(n.grp.substring(5)) + 1;
        if (n.note) n.Note = quillToText(n.note);
        // don't save any of the listed properties
        return omit(n, [
            'bc',
            'borderWidth',
            'borderWidthSelected',
            'color',
            'created',
            'fixed',
            'font',
            'grp',
            'id',
            'labelHighlightBold',
            'locked',
            'margin',
            'modified',
            'opacity',
            'oldFont',
            'oldFontColor',
            'oldLabel',
            'note',
            'scaling',
            'shapeProperties',
            'wasFixed'
        ]);
    });
    let factorWorksheet = (0, $b8f343bf88dacc48$export$eab97d15b1788b8d).json_to_sheet(rows);
    (0, $b8f343bf88dacc48$export$eab97d15b1788b8d).book_append_sheet(workbook, factorWorksheet, 'Factors');
    // Links
    let edges = (0, $gFW3W.deepCopy)((0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.get().filter((e)=>!e.isClusterEdge));
    rows = edges.map((e)=>{
        if (e.created) {
            e.creator = e.created.user;
            e.createdTime = new Date(e.created.time).toISOString();
        }
        if (e.modified) {
            e.modifier = e.modified.user;
            e.modifiedTime = new Date(e.modified.time).toISOString();
        }
        e.style = parseInt(e.grp.substring(4)) + 1;
        e.from = (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get(e.from).label;
        e.to = (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get(e.to).label;
        if (e.note) e.Note = quillToText(e.note);
        return omit(e, [
            'arrows',
            'color',
            'created',
            'dashes',
            'font',
            'grp',
            'hoverWidth',
            'id',
            'note',
            'selectionWidth',
            'width'
        ]);
    });
    let linksWorksheet = (0, $b8f343bf88dacc48$export$eab97d15b1788b8d).json_to_sheet(rows);
    (0, $b8f343bf88dacc48$export$eab97d15b1788b8d).book_append_sheet(workbook, linksWorksheet, 'Links');
    $a61399d7add80213$export$20ca267bc6805c64('xlsx');
    (0, $b8f343bf88dacc48$export$40a06aea54ee074e)(workbook, $a61399d7add80213$var$lastFileName);
    dummyDiv.remove();
    function omit(obj, props) {
        return Object.keys(obj).filter((key)=>props.indexOf(key) < 0).reduce((obj2, key)=>(obj2[key] = obj[key], obj2), {});
    }
    /**
	 *
	 * @param {object} ops
	 * @returns contents of Quill note as plain text
	 */ function quillToText(ops) {
        qed.setContents(ops);
        // use qed.root.innerHTML to convert to HTML if that is preferred
        return qed.getText();
    }
}
function $a61399d7add80213$export$e680efcc3295c085() {
    let str = 'Creator "prsm ' + (0, $gMLdp.version) + ' on ' + new Date(Date.now()).toLocaleString() + '"\ngraph\n[\n\tdirected 1\n';
    let nodeIds = (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.map((n)=>n.id) //use integers, not GUIDs for node ids
    ;
    for (let node of (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get()){
        str += '\tnode\n\t[\n\t\tid ' + nodeIds.indexOf(node.id);
        if (node.label) str += '\n\t\tlabel "' + node.label.replace(/"/g, "'") + '"';
        let color = node.color.background || (0, $09258687963db43e$export$9dd6ff9ea0189349).nodes.group0.color.background;
        str += '\n\t\tcolor "' + color + '"';
        str += '\n\t]\n';
    }
    for (let edge of (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.get()){
        str += '\tedge\n\t[\n\t\tsource ' + nodeIds.indexOf(edge.from);
        str += '\n\t\ttarget ' + nodeIds.indexOf(edge.to);
        if (edge.label) str += '\n\t\tlabel "' + edge.label + '"';
        let color = edge.color.color || (0, $09258687963db43e$export$9dd6ff9ea0189349).edges.edge0.color.color;
        str += '\n\t\tcolor "' + color + '"';
        str += '\n\t]\n';
    }
    str += '\n]';
    $a61399d7add80213$var$saveStr(str, 'gml');
}
function $a61399d7add80213$export$5e98004ecc179104() {
    let str = `/* Creator PRSM ${(0, $gMLdp.version)} on ${new Date(Date.now()).toLocaleString()} */\ndigraph {\n`;
    for (let node of (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get())str += `"${node.id}" [label="${node.label}", 
			color="${(0, $gFW3W.standardize_color)(node.color.border)}", fillcolor="${(0, $gFW3W.standardize_color)(node.color.background)}",
			shape="${node.shape == 'text' ? 'plaintext' : node.shape}",
			${gvNodeStyle(node)},
			fontsize="${node.font.size}", fontcolor="${(0, $gFW3W.standardize_color)(node.font.color)}"]\n`;
    for (let edge of (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.get())str += `"${edge.from}" -> "${edge.to}" [label="${edge.label || ''}", 
			color="${(0, $gFW3W.standardize_color)(edge.color.color)}"
			style="${gvConvertEdgeStyle(edge)}"]\n`;
    str += '}\n';
    $a61399d7add80213$var$saveStr(str, 'gv');
    function gvNodeStyle(node) {
        let bDashes = node.shapeProperties.borderDashes;
        let val = 'style="filled';
        if (Array.isArray(bDashes)) val += ', dotted';
        else val += `, ${bDashes ? 'dashed' : 'solid'}`;
        val += `", penwidth="${node.borderWidth}"`;
        return val;
    }
    function gvConvertEdgeStyle(edge) {
        let bDashes = edge.dashes;
        let val = 'solid';
        if (Array.isArray(bDashes)) {
            if (bDashes[0] == 10) val = 'dashed';
            else val = 'dotted';
        }
        return val;
    }
}


/*********************************************************************************************************************  

PRSM Participatory System Mapper 

	Copyright (C) 2022  Nigel Gilbert prsm@prsm.uk

	This program is free software: you can redistribute it and/or modify
	it under the terms of the GNU General Public License as published by
	the Free Software Foundation, either version 3 of the License, or
	(at your option) any later version.

	This program is distributed in the hope that it will be useful,
	but WITHOUT ANY WARRANTY; without even the implied warranty of
	MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	GNU General Public License for more details.

	You should have received a copy of the GNU General Public License
	along with this program.  If not, see <https://www.gnu.org/licenses/>.


This module handles the display of tutorial help messages to beginners.  
 ******************************************************************************************************************** */ /**
 * Class to display help messages in sequence as a user guide
 *
 * Each HTML element that should have a tutorial message should include the attributes:
 * data-step {number} specifies the order of the sequence of messages
 * data-tutorial: the message (can include HTML tags)
 * data-position: the location of the message relative to the element, one of
 * above, above-left, above-middle, above-right, left, right and below and their variants
 * or splash (which positions the message in the middle of the viewport)
 * To initialise:
 *  tutorial = new Tutorial()
 *  tutorial.start()
 *
 *  tutorial.onstep(Array of step numbers or a step number, callback) Evaluate call back
 *       after displaying tutorial message
 *  tutorial.onexit(callback) Evaluate callback when user finishes or skips the tutorial
 */ var $d12bb7f3dafa903b$exports = {};

$d12bb7f3dafa903b$exports = (parcelRequire("7qipm")).getBundleURL('6blyj') + "PRSMlogo200.3b156bda.webp";


class $d483874c34c7b530$export$2e2bcd8739ae039 {
    constructor(){
        this.step = 0;
        this.steps = Array.from(document.querySelectorAll('[data-step]')).sort((a, b)=>{
            return parseInt(a.dataset.step) - parseInt(b.dataset.step);
        });
        this.back = null;
    }
    /**
	 * initialise the step counter and display the first step
	 * @param {number} start optional step to start at (if not provided, start at the lowest numbered step)
	 */ start(start) {
        if (start !== undefined) this.step = start;
        this.stepStart();
    }
    /**
	 * create a tutorial element and position it
	 */ stepStart() {
        let elem = this.steps[this.step];
        let text = elem.dataset.tutorial;
        let position = elem.dataset.position;
        let classToAdd = elem.dataset.tutorialclass;
        let prevLegend = 'Back';
        let nextLegend = 'Next';
        // first and last have special buttons
        if (this.step == 0) prevLegend = 'Skip';
        if (this.step == this.steps.length - 1) nextLegend = 'Done';
        let dialog = document.createElement('div');
        dialog.className = `tutorial-dialog ${position}`;
        if (classToAdd) dialog.classList.add(classToAdd);
        dialog.id = 'tutorial';
        dialog.innerHTML = `
<div class="tutorial-arrow ${position}"></div>
<div class="x-button" id="tutorial-cancel">&times;</div>
<div class="text">
    ${text}
</div>
<input
    type="button"
    value="${nextLegend}"
    id="next"
    class="tutorial-button next"
/>
<input
    type="button"
    value="${prevLegend}"
    id="prev"
    class="tutorial-button prev"
/>
</div>`;
        dialog.style.visibility = 'hidden';
        document.querySelector('body').appendChild(dialog);
        // position the tutorial item and the border around the item being explained
        let dialogBR = dialog.getBoundingClientRect();
        let elemBR = elem.getBoundingClientRect();
        let top = elemBR.top;
        let left = elemBR.left;
        if (position == 'splash') {
            if (!this.back) {
                this.back = document.createElement('div');
                this.back.classList.add('tutorial-background');
                elem.insertAdjacentElement('afterend', this.back);
            }
            dialog.classList.add('splash');
            if (this.step == 0) {
                // initial splash screen for new users
                dialog.classList.add('intro-splash');
                let img = document.createElement('img');
                img.src = new URL($d12bb7f3dafa903b$exports);
                document.getElementById('intro-logo').appendChild(img);
            }
        } else {
            let border = document.createElement('div');
            border.className = 'tutorial-border';
            border.id = 'tutorial-border';
            border.style.top = elemBR.top - 3 + 'px';
            border.style.left = elemBR.left - 3 + 'px';
            border.style.width = elemBR.width + 'px';
            border.style.height = elemBR.height + 'px';
            document.querySelector('body').appendChild(border);
            switch(position){
                case 'below':
                case 'below-right':
                case 'below-middle':
                case 'below-left':
                    top = elemBR.bottom + 15;
                    break;
                case 'above':
                case 'above-left':
                case 'above-middle':
                case 'above-right':
                    top = elemBR.top - dialogBR.height - 15;
                    break;
                case 'right':
                case 'right-middle':
                case 'right-bottom':
                    left = elemBR.right + 15;
                    break;
                case 'left':
                case 'left-middle':
                case 'left-bottom':
                    left = elemBR.left - dialogBR.width - 15;
                    break;
                default:
                    console.log(`Tutorial: Unknown data-position at step ${this.step}`);
                    break;
            }
            // ensure the dialog is in the viewport
            if (top < 0) top = 0;
            if (top > window.innerHeight - dialogBR.height) top = window.innerHeight - dialogBR.height;
            if (left < 0) left = 0;
            if (left > window.innerWidth - dialogBR.width) left = window.innerWidth - dialogBR.width;
            dialog.style.top = top + 'px';
            dialog.style.left = left + 'px';
        }
        dialog.style.visibility = '';
        // add event listeners to buttons to increment/decrement step,
        // destroy this dialog and then call step() to display next one
        document.querySelector('#next').addEventListener('click', ()=>{
            this.step += 1;
            this.stepFinish();
        });
        document.querySelector('#prev').addEventListener('click', ()=>{
            this.step -= 1;
            this.stepFinish();
        });
        document.querySelector('#tutorial-cancel').addEventListener('click', ()=>{
            this.step = this.steps.length;
            this.stepFinish();
        });
        // call onsstepstart function if to run now
        this.runStepStart();
    }
    runStepStart() {
        if (this.onstep == undefined) return;
        if (Array.isArray(this.onstep)) {
            if (this.onstep.indexOf(this.step) == -1) return;
        } else {
            if (this.onstep != this.step) return;
        }
        if (typeof this.onstepfn === 'function') this.onstepfn();
    }
    /**
	 * destroy the tutorial dialog, remove the border around the item being explained, and
	 * and call stepStart() to display the next one
	 */ stepFinish() {
        let dialog = document.querySelector('#tutorial');
        if (dialog) dialog.remove();
        let border = document.querySelector('#tutorial-border');
        if (border) border.remove();
        if (this.step < 0 || this.step >= this.steps.length) this.stepsEnd();
        else this.stepStart();
    }
    /**
	 * called on exit
	 */ stepsEnd() {
        if (this.back) {
            this.back.remove();
            this.back = null;
        }
        if (typeof this.onexitfn === 'function') this.onexitfn();
    }
    /**
	 * store the cleanup function until needed
	 * @param {function} callback
	 */ onexit(callback) {
        this.onexitfn = callback;
    }
    onstep(step, callback) {
        this.onstep = step;
        this.onstepfn = callback;
    }
}



/*********************************************************************************************************************  

PRSM Participatory System Mapper 

    Copyright (C) 2022  Nigel Gilbert prsm@prsm.uk

    This program is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    This program is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>.


This module does trophic layout.  
 ******************************************************************************************************************** */ /*
translation of the Trophic Levels algorithm to javascript

NG 18 December 2020

*/ /* simple minded adjacency matrix manipulation functions.
 * They generally assume that the matrix is square (no checks are done
 * that they are).
 * Assumes all weights are unity (TODO: allow weighted edges)
 * Matrix data structure is just an array of arrays
 */ 
/**
 * convert a directed adjacency matrix to an undirected one
 * mirror the elements above the leading diagonal to below it
 * @param {array[]} a
 * @returns {array[]} a copy of a
 */ function $95f9b1ee7539e417$var$undirected(a) {
    let b = Array(a.length);
    for(let i = 0; i < a.length; i++){
        b[i] = new Array(a.length);
        b[i][i] = a[i][i];
    }
    for(let i = 0; i < a.length; i++){
        for(let j = i + 1; j < a.length; j++)if (a[i][j] || a[j][i]) {
            b[i][j] = 1;
            b[j][i] = 1;
        } else {
            b[i][j] = 0;
            b[j][i] = 0;
        }
    }
    return b;
}
/**
 * check that all nodes are connected to at least one other node
 * i.e. every row includes at least one 1
 * @param {array[]} a
 */ function $95f9b1ee7539e417$var$connected(a) {
    for(let i = 0; i < a.length; i++){
        let nonzero = false;
        for(let j = 0; j < a.length; j++)if (a[i][j] !== 0) {
            nonzero = true;
            break;
        }
        if (!nonzero) return false;
    }
    return true;
}
/**
 * swap cell values across the leading diagonal
 * @param {array[]} a
 * @returns {array[]} a transposed copy of a
 */ function $95f9b1ee7539e417$var$transpose(a) {
    let b = new Array(a.length);
    for(let i = 0; i < a.length; i++){
        b[i] = new Array(a.length);
        for(let j = 0; j < a.length; j++)b[i][j] = a[j][i];
    }
    return b;
}
/**
 * return a vector of the number of edges out of a node
 * @param {array[]} a
 * @returns {array}
 */ function $95f9b1ee7539e417$var$out_degree(a) {
    let v = new Array(a.length);
    for(let row = 0; row < a.length; row++)v[row] = $95f9b1ee7539e417$var$sumVec(a[row]);
    return v;
}
/**
 * return a vector of the number of edges into a node
 * @param {array[]} a
 * @returns {array}
 */ function $95f9b1ee7539e417$var$in_degree(a) {
    return $95f9b1ee7539e417$var$out_degree($95f9b1ee7539e417$var$transpose(a));
}
/**
 * returns the summation of the values in the vector
 * @param {array} v
 * @returns {number}
 */ function $95f9b1ee7539e417$var$sumVec(v) {
    let sum = 0;
    for(let i = 0; i < v.length; i++)sum += v[i];
    return sum;
}
/**
 * v1 - v2
 * @param {array} v1
 * @param {array} v2
 * @returns {array}
 */ function $95f9b1ee7539e417$var$subVec(v1, v2) {
    let res = new Array(v1.length);
    for(let i = 0; i < v1.length; i++)res[i] = v1[i] - v2[i];
    return res;
}
/**
 * v1 + v2
 * @param {array} v1
 * @param {array} v2
 * @returns {array}
 */ function $95f9b1ee7539e417$var$addVec(v1, v2) {
    let res = new Array(v1.length);
    for(let i = 0; i < v1.length; i++)res[i] = v1[i] + v2[i];
    return res;
}
/**
 * subtract matrix b from a
 * @param {array[]} a
 * @param {array[]} b
 */ function $95f9b1ee7539e417$var$subtract(a, b) {
    let c = new Array(a.length);
    for(let i = 0; i < a.length; i++)c[i] = $95f9b1ee7539e417$var$subVec(a[i], b[i]);
    return c;
}
/**
 * Add matrix a to its transpose, but normalise the cell values resulting to 0/1
 * @param {array[]} a
 * @returns {array[]} a copy of the result
 */ function $95f9b1ee7539e417$var$mergeTranspose(a) {
    let b = $95f9b1ee7539e417$var$transpose(a);
    for(let i = 0; i < a.length; i++){
        for(let j = 0; j < a.length; j++)if (a[i][j] > 0) b[i][j] = 1;
    }
    return b;
}
/**
 * create a new matrix of size n, with all cells zero
 * @param {number} n
 */ function $95f9b1ee7539e417$var$zero(n) {
    let b = new Array(n);
    for(let i = 0; i < n; i++)b[i] = new Array(n).fill(0);
    return b;
}
/**
 * create a zero matrix with v as the leading diagonal
 * @param {array} v
 * @returns {array[]}
 */ function $95f9b1ee7539e417$var$diag(v) {
    let b = $95f9b1ee7539e417$var$zero(v.length);
    for(let i = 0; i < v.length; i++)b[i][i] = v[i];
    return b;
}
/**
 * subtract the minimum value of any cell from each cell of the vector
 * @param {array} v
 */ function $95f9b1ee7539e417$var$rebase(v) {
    let min = Math.min(...v);
    let res = new Array(v.length);
    for(let i = 0; i < v.length; i++)res[i] = v[i] - min;
    return res;
}
/**
 * solve Ax=B by Gauss-Jordan elimination method
 * adapted from https://www.npmjs.com/package/linear-equation-system
 * @param {array[]} A
 * @param {array} B
 */ function $95f9b1ee7539e417$var$solve(A, B) {
    let system = A.slice();
    for(let i = 0; i < B.length; i++)system[i].push(B[i]);
    for(let i = 0; i < system.length; i++){
        let pivotRow = findPivotRow(system, i);
        if (!pivotRow) return false //Singular system
        ;
        if (pivotRow != i) system = swapRows(system, i, pivotRow);
        let pivot = system[i][i];
        for(let j = i; j < system[i].length; j++)//divide row by pivot
        system[i][j] = system[i][j] / pivot;
        for(let j = i + 1; j < system.length; j++)// Cancel below pivot
        if (system[j][i] != 0) {
            let operable = system[j][i];
            for(let k = i; k < system[i].length; k++)system[j][k] -= operable * system[i][k];
        }
    }
    for(let i = system.length - 1; i > 0; i--){
        // Back substitution
        for(let j = i - 1; j >= 0; j--)if (system[j][i] != 0) {
            let operable = system[j][i];
            for(let k = j; k < system[j].length; k++)system[j][k] -= operable * system[i][k];
        }
    }
    let answer = [];
    for(let i = 0; i < system.length; i++)answer.push(system[i].pop());
    return answer;
    function findPivotRow(sys, index) {
        let row = index;
        for(let i = index; i < sys.length; i++)if (Math.abs(sys[i][index]) > Math.abs(sys[row][index])) row = i;
        if (sys[row][index] == 0) return false;
        return row;
    }
    function swapRows(sys, row1, row2) {
        let cache = sys[row1];
        sys[row1] = sys[row2];
        sys[row2] = cache;
        return sys;
    }
}
/**
 * Round the cell values of v to the given number of decimal places
 * @param {array} v
 * @param {number} places
 */ function $95f9b1ee7539e417$var$round(v, places) {
    for(let i = 0; i < v.length; i++)v[i] = v[i].toFixed(places);
    return v;
}
/* --------------------------------------------------------------------*/ /**
 * This is the Trophic Levels Algorithm
 *
 * @param {array[]} a square adjacency matrix
 * @returns {array} levels (heights)
 */ function $95f9b1ee7539e417$var$get_trophic_levels(a) {
    // get undirected matrix
    let au = $95f9b1ee7539e417$var$undirected(a);
    // check connected
    if ($95f9b1ee7539e417$var$connected(au)) {
        // get in degree vector
        let in_deg = $95f9b1ee7539e417$var$in_degree(a);
        // get out degree vector
        let out_deg = $95f9b1ee7539e417$var$out_degree(a);
        // get in - out
        let v = $95f9b1ee7539e417$var$subVec(in_deg, out_deg);
        // get diagonal matrix, subtract (adj. matrix plus its transpose)
        let L = $95f9b1ee7539e417$var$subtract($95f9b1ee7539e417$var$diag($95f9b1ee7539e417$var$addVec(in_deg, out_deg)), $95f9b1ee7539e417$var$mergeTranspose(a));
        // set (0,0) to zero
        L[0][0] = 0;
        // do linear solve
        let h = $95f9b1ee7539e417$var$solve(L, v);
        if (!h) throw new Error('Singular matrix');
        // base to zero
        h = $95f9b1ee7539e417$var$rebase(h);
        // round to 3 decimal places
        h = $95f9b1ee7539e417$var$round(h, 3);
        // return tropic heights
        return h;
    } else throw new Error('Network must be weakly connected');
}
/**
 * convert a vector of objects, each an edge referencing from and to nodes
 * to an adjacency matrix.  nodes is a list of nodes that acts as the index for the adj. matrix.
 * @param {array} v list of edges
 * @param {array} nodes list of node Ids
 * @returns matrix
 */ function $95f9b1ee7539e417$var$edgeListToAdjMatrix(v, nodes) {
    let a = $95f9b1ee7539e417$var$zero(nodes.length);
    for(let i = 0; i < v.length; i++)a[nodes.indexOf(v[i].from)][nodes.indexOf(v[i].to)] = 1;
    return a;
}
/**
 * returns a list of the node Ids mentioned in a vector of edges
 * @param {array} v edges
 */ function $95f9b1ee7539e417$var$nodeList(v) {
    let nodes = new Array();
    for(let i = 0; i < v.length; i++){
        if (nodes.indexOf(v[i].from) == -1) nodes.push(v[i].from);
        if (nodes.indexOf(v[i].to) == -1) nodes.push(v[i].to);
    }
    return nodes;
}
/**
 * given a complete set of edges, returns a list of lists of edges, each list being the edges of a connected component
 * @param {object} data
 */ function $95f9b1ee7539e417$var$connectedComponents(data) {
    let edges = data.edges.get();
    let cc = [];
    let added = [];
    let component = [];
    // starting from each edge...
    edges.forEach((e)=>{
        if (!added.includes(e)) {
            component = [];
            //do a depth first search for connected edges
            dfs(e);
            cc.push(component);
        }
    });
    /**
	 * depth first search for edges connected to 'to' or 'from' nodes of this edge
	 * adds edges found to component array
	 * @param {object} e
	 */ function dfs(e) {
        added.push(e);
        component.push(e);
        edges.filter((next)=>{
            return e !== next && (next.from === e.to || next.to === e.from || next.from == -e.from || next.to === e.to);
        }).forEach((next)=>{
            if (!added.includes(next)) dfs(next);
        });
    }
    return cc;
}
function $95f9b1ee7539e417$export$cc9ec954c05f1d69(data) {
    // get a list of lists of connected components, each list being pairs of to and from nodes
    // process each connected component individually
    // nodes that are not connected to anything (degree 0) moved to the base level
    let updatedNodes = [];
    // save min and max x coordinates of nodes
    let minX = Math.min(...data.nodes.map((n)=>n.x));
    let maxX = Math.max(...data.nodes.map((n)=>n.x));
    $95f9b1ee7539e417$var$connectedComponents(data).forEach((edges)=>{
        let nodeIds = $95f9b1ee7539e417$var$nodeList(edges);
        let nodes = data.nodes.get(nodeIds);
        // convert to an adjacency matrix
        let adj = $95f9b1ee7539e417$var$edgeListToAdjMatrix(edges, nodeIds);
        // get trophic levels
        let levels = $95f9b1ee7539e417$var$get_trophic_levels(adj);
        // experimental: round levels to integers within the range 0 .. NLEVELS
        let range = Math.max(...levels) - Math.min(...levels);
        levels = levels.map((l)=>Math.round(l * (0, $e1c55b086cf8dd0e$export$4448800f068b9d2f) / range));
        // rescale x to match original max and min
        range = Math.max(...levels) - Math.min(...levels);
        // if all nodes are at same trophic height (range == 0, so scale would be infinity), line them up
        let scale = range > 0.000001 ? (maxX - minX) / range : 0;
        // move nodes to new positions
        for(let i = 0; i < nodeIds.length; i++){
            let node = nodes[i];
            node.x = levels[i] * scale + minX;
            node.level = levels[i];
            updatedNodes.push(node);
        }
    });
    // move all the rest (i.e. unconnected nodes) to the base level
    data.nodes.get().filter((n)=>!updatedNodes.some((u)=>n.id == u.id)).map((n)=>{
        n.x = minX;
        n.level = 0;
    });
    return data.nodes.get();
}


/*********************************************************************************************************************  

PRSM Participatory System Mapper 

	Copyright (C) 2022  Nigel Gilbert prsm@prsm.uk

	This program is free software: you can redistribute it and/or modify
	it under the terms of the GNU General Public License as published by
	the Free Software Foundation, either version 3 of the License, or
	(at your option) any later version.

	This program is distributed in the hope that it will be useful,
	but WITHOUT ANY WARRANTY; without even the implied warranty of
	MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	GNU General Public License for more details.

	You should have received a copy of the GNU General Public License
	along with this program.  If not, see <https://www.gnu.org/licenses/>.


This module clusters factors  
 ******************************************************************************************************************** */ 
var $gFW3W = parcelRequire("gFW3W");


function $4a821ee537123403$export$54c7dfe5600eab89(attribute) {
    if (!attribute) return;
    (0, $e1c55b086cf8dd0e$export$2a111da947c407d2).transact(()=>{
        $4a821ee537123403$var$unCluster();
        switch(attribute){
            case 'none':
                break;
            case 'color':
                $4a821ee537123403$var$clusterByColor();
                break;
            case 'style':
                $4a821ee537123403$var$clusterByStyle();
                break;
            default:
                $4a821ee537123403$var$clusterByAttribute(attribute);
                break;
        }
    });
}
/**
 *
 * @param {String} attribute
 */ function $4a821ee537123403$var$clusterByAttribute(attribute) {
    // collect all different values of the attribute that are in use
    let attValues = new Set();
    (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get().forEach((node)=>{
        if (!node.isCluster && node[attribute]) attValues.add(node[attribute]);
    });
    (0, $e1c55b086cf8dd0e$export$9bc34f54445cb725)();
    let nodesToUpdate = [];
    // for each cluster
    for (let value of attValues){
        // collect relevant nodes that are not already in a cluster and are not cluster nodes
        // and the attribute value is not blank
        let nodesInCluster = (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get({
            filter: (node)=>node[attribute] === value && !node.clusteredIn && !node.isCluster
        });
        // clusters must have at least 2 nodes
        if (nodesInCluster.length <= 1) continue;
        let sumx = 0;
        let sumy = 0;
        let nInCluster = 0;
        let clusterNode = (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get(`cluster-${attribute}-${value}`);
        if (clusterNode === null) {
            let color = (0, $gFW3W.makeColor)();
            clusterNode = (0, $gFW3W.deepMerge)((0, $09258687963db43e$export$9dd6ff9ea0189349).nodes['cluster'], {
                id: `cluster-${attribute}-${value}`,
                isCluster: true,
                color: {
                    background: color
                },
                font: {
                    color: (0, $gFW3W.lightOrDark)(color) == 'light' ? 'rgba(0,0,0,1)' : 'rgb(255,255,255,1)'
                }
            });
        }
        clusterNode.label = `${(0, $e1c55b086cf8dd0e$export$807f940a96777041).get('attributeTitles')[attribute]} ${value}`;
        clusterNode.hidden = false;
        for (let node of nodesInCluster){
            // for each factor that should be in the cluster
            node.clusteredIn = clusterNode.id;
            node.hidden = true;
            sumx += node.x;
            sumy += node.y;
            nInCluster++;
            nodesToUpdate.push(node);
        }
        // locate the cluster node at the centroid of the constituent nodes
        clusterNode.x = sumx / nInCluster;
        clusterNode.y = sumy / nInCluster;
        nodesToUpdate.push(clusterNode);
    }
    (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.update(nodesToUpdate);
    $4a821ee537123403$var$showClusterLinks();
}
function $4a821ee537123403$var$clusterByColor() {
    // collect all different values of the attribute that are in use
    let colors = new Set();
    (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get().forEach((node)=>{
        if (!node.isCluster) colors.add((0, $gFW3W.standardize_color)(node.color.background));
    });
    (0, $e1c55b086cf8dd0e$export$9bc34f54445cb725)();
    let clusterNumber = 0;
    let nodesToUpdate = [];
    // for each cluster
    for (const color of colors){
        // collect relevant nodes that are not already in a cluster and are not cluster nodes
        let nodesInCluster = (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get({
            filter: (node)=>(0, $gFW3W.standardize_color)(node.color.background) === color && !node.clusteredIn && !node.isCluster
        });
        // clusters must have at least 2 nodes
        if (nodesInCluster.length <= 1) continue;
        let sumx = 0;
        let sumy = 0;
        let nInCluster = 0;
        let clusterNode = (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get(`cluster-color-${color}`);
        if (clusterNode === null) clusterNode = (0, $gFW3W.deepMerge)((0, $09258687963db43e$export$9dd6ff9ea0189349).nodes['cluster'], {
            id: `cluster-color-${color}`,
            isCluster: true
        });
        clusterNode.hidden = false;
        clusterNode.label = `Cluster ${++clusterNumber}`;
        clusterNode.color = {
            background: color
        };
        clusterNode.font = {
            color: (0, $gFW3W.lightOrDark)(color) == 'light' ? 'rgba(0,0,0,1)' : 'rgb(255,255,255,1)'
        };
        for (let node of nodesInCluster){
            // for each factor that should be in the cluster
            node.clusteredIn = clusterNode.id;
            node.hidden = true;
            sumx += node.x;
            sumy += node.y;
            nInCluster++;
            nodesToUpdate.push(node);
        }
        // locate the cluster node at the centroid of the constituent nodes
        clusterNode.x = sumx / nInCluster;
        clusterNode.y = sumy / nInCluster;
        nodesToUpdate.push(clusterNode);
    }
    (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.update(nodesToUpdate);
    $4a821ee537123403$var$showClusterLinks();
}
function $4a821ee537123403$var$clusterByStyle() {
    // collect all different values of the style that are in use
    let stylesInUse = new Set();
    (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get().forEach((node)=>{
        if (!node.isCluster) stylesInUse.add(node.grp);
    });
    (0, $e1c55b086cf8dd0e$export$9bc34f54445cb725)();
    let nodesToUpdate = [];
    // for each cluster
    for (const style of stylesInUse){
        // collect relevant nodes that are not already in a cluster and are not cluster nodes
        let nodesInCluster = (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get({
            filter: (node)=>node.grp === style && !node.clusteredIn && !node.isCluster
        });
        // clusters must have at least 2 nodes
        if (nodesInCluster.length <= 1) continue;
        let sumx = 0;
        let sumy = 0;
        let nInCluster = 0;
        // retrieve or create the cluster node (cluster nodes are re-used if they already exist)
        let clusterNode = (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get(`cluster-style-${style}`);
        if (clusterNode === null) clusterNode = (0, $gFW3W.deepMerge)((0, $09258687963db43e$export$9dd6ff9ea0189349).nodes['cluster'], {
            id: `cluster-style-${style}`,
            isCluster: true
        });
        clusterNode.hidden = false;
        clusterNode.label = `${(0, $09258687963db43e$export$9dd6ff9ea0189349).nodes[style].groupLabel} cluster`;
        clusterNode.color.background = (0, $09258687963db43e$export$9dd6ff9ea0189349).nodes[style].color.background;
        clusterNode.font.color = (0, $gFW3W.lightOrDark)((0, $09258687963db43e$export$9dd6ff9ea0189349).nodes[style].color.background) == 'light' ? 'rgba(0,0,0,1)' : 'rgb(255,255,255,1)';
        for (let node of nodesInCluster){
            // for each factor that should be in the cluster
            node.clusteredIn = clusterNode.id;
            node.hidden = true;
            sumx += node.x;
            sumy += node.y;
            nInCluster++;
            nodesToUpdate.push(node);
        }
        // locate the cluster node at the centroid of the constituent nodes
        clusterNode.x = sumx / nInCluster;
        clusterNode.y = sumy / nInCluster;
        nodesToUpdate.push(clusterNode);
    }
    (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.update(nodesToUpdate);
    $4a821ee537123403$var$showClusterLinks();
}
/**
 * Create links to cluster nodes and hide links that are now inside clustered nodes
 */ function $4a821ee537123403$var$showClusterLinks() {
    // hide all links between clusters initially
    let edgesToUpdate = [];
    (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.get().forEach((edge)=>{
        if (edge.isClusterEdge) {
            edge.hidden = true;
            edge.label = '';
        }
    });
    for (let edge of (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.get()){
        if (edge.isClusterEdge) continue;
        // if edge is between two nodes neither of which are in a cluster, show it
        // if edge is from and to nodes that are in the same cluster, hide it
        // if edge is from a node not in a cluster, and to a node in a cluster, hide it and make a cluster edge for it
        // and vice versa
        // if edge is between two nodes both in (different) clusters, hide it and make a cluster edge for it
        let fromNode = (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get(edge.from);
        let toNode = (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get(edge.to);
        edge.hidden = true;
        if (!fromNode.clusteredIn && !toNode.clusteredIn) edge.hidden = false;
        else if (fromNode.clusteredIn == toNode.clusteredIn) edge.hidden = true;
        else if (!fromNode.clusteredIn && toNode.clusteredIn) makeClusterLink(edge.from, toNode.clusteredIn);
        else if (fromNode.clusteredIn && !toNode.clusteredIn) makeClusterLink(fromNode.clusteredIn, edge.to);
        else if (fromNode.clusteredIn && toNode.clusteredIn) makeClusterLink(fromNode.clusteredIn, toNode.clusteredIn);
        else edge.hidden = false // shouldn't happen
        ;
        edgesToUpdate.push(edge);
    }
    (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.update(edgesToUpdate);
    if (/cluster/.test((0, $e1c55b086cf8dd0e$export$1c9f709888824e05))) {
        console.log('Nodes');
        (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get().forEach((n)=>{
            console.log([
                n.id,
                n.label,
                n.hidden,
                n.clusteredIn
            ]);
        });
        console.log('Edges');
        (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.get().forEach((e)=>{
            console.log([
                e.id,
                (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get(e.from).label,
                (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get(e.to).label,
                e.hidden
            ]);
        });
    }
    /**
	 * Reuse existing edge or create a new one
	 * @param {string} fromId
	 * @param {string} toId
	 */ function makeClusterLink(fromId, toId) {
        let edge = edgesToUpdate.filter((e)=>fromId == e.from && toId == e.to).shift();
        if (!edge) edge = (0, $gFW3W.deepMerge)((0, $09258687963db43e$export$9dd6ff9ea0189349).edges['cluster'], {
            id: `cledge-${(0, $gFW3W.uuidv4)()}`,
            from: fromId,
            to: toId,
            isClusterEdge: true
        });
        edge.hidden = false;
        edge.label = edge.label ? (parseInt(edge.label) + 1).toString() : '1';
        edgesToUpdate.push(edge);
    }
}
function $4a821ee537123403$export$14b245ef7e84f38d(clusterNodeId) {
    let clusterNode = (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get(clusterNodeId);
    // if user has right clicked on a factor that is not a cluster, and clustering is
    // set, re-cluster
    if (!clusterNode.isCluster) {
        let attribute = (0, $gFW3W.elem)('clustering').value;
        if (attribute !== 'none') $4a821ee537123403$export$54c7dfe5600eab89(attribute);
        return;
    }
    (0, $e1c55b086cf8dd0e$export$2a111da947c407d2).transact(()=>{
        (0, $e1c55b086cf8dd0e$export$9bc34f54445cb725)();
        let nodesToUpdate = [];
        let edgesToRemove = [];
        let nodesInCluster = (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get({
            filter: (node)=>node.clusteredIn === clusterNode.id
        });
        for (let node of nodesInCluster){
            node.hidden = false;
            node.clusteredIn = null;
            nodesToUpdate.push(node);
        }
        // hide the cluster node
        clusterNode.hidden = true;
        // and the edges that link it
        let eIds = (0, $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4).getConnectedEdges(clusterNode.id);
        for (let eId of eIds)edgesToRemove.push(eId);
        nodesToUpdate.push(clusterNode);
        (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.update(nodesToUpdate);
        (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.remove(edgesToRemove);
        $4a821ee537123403$var$showClusterLinks();
    });
    if ((0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get({
        filter: (n)=>n.isCluster && !n.hidden
    }).length === 0) // all clusters have been opened; reset the cluster select to None
    (0, $gFW3W.elem)('clustering').value = 'none';
}
function $4a821ee537123403$var$unCluster() {
    let nodesToUpdate = [];
    let edgesToRemove = [];
    (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get({
        filter: (node)=>node.isCluster
    }).forEach((clusterNode)=>{
        let nodesInCluster = (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get({
            filter: (node)=>node.clusteredIn === clusterNode.id
        });
        for (let node of nodesInCluster){
            node.hidden = false;
            node.clusteredIn = null;
            nodesToUpdate.push(node);
        }
        clusterNode.hidden = true;
        // and the edges that link it
        let eIds = (0, $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4).getConnectedEdges(clusterNode.id);
        for (let eId of eIds)edgesToRemove.push(eId);
        nodesToUpdate.push(clusterNode);
    });
    (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.update(nodesToUpdate);
    (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.remove(edgesToRemove);
    $4a821ee537123403$var$showClusterLinks();
}


/**
 * Some functions for examining and merging maps - not for public consumption, but useful
 * for diagnosing problems and for special operations on maps
 */ 
var $lc1R0 = parcelRequire("lc1R0");

var $6iwTo = parcelRequire("6iwTo");



var $gFW3W = parcelRequire("gFW3W");
/* --------------------------------- Merge maps ----------------------------- */ /*
 * Evaluate mergeRoom(string: room code) e.g. mergeRoom('WBI-CRD-ROB-XDK')
 *   adds all factors and links in the 'other' map to this one
 *   if a factor occurs in both maps and is identical in both, nothing is added
 *   if a factor is in both maps, but the label is different, a new factor is added
 *     that is a clone of the 'other' factor, but with a dashed red border and with
 *     cloned links that are dashed.
 *
 * Evaluate diffRoom(string: room code) e.g. diffRoom('WBI-CRD-ROB-XDK')
 *  to list all the differences in the console
 */ var $aa1828bc973fe863$var$bwsp //  websocket to other room
;
var $aa1828bc973fe863$var$bdata // the data from the other room
;
var $aa1828bc973fe863$var$bNodesMap // map of nodes from the other room
;
var $aa1828bc973fe863$var$bEdgesMap //  map of edges from the other room
;
function $aa1828bc973fe863$export$ac1ea0fcd93fecda(otherRoom) {
    let bDoc = new $lc1R0.Doc();
    $aa1828bc973fe863$var$bwsp = new (0, $6iwTo.WebsocketProvider)((0, $e1c55b086cf8dd0e$export$3f859614deccc31b), `prsm${otherRoom}`, bDoc);
    $aa1828bc973fe863$var$bwsp.disconnectBc();
    $aa1828bc973fe863$var$bNodesMap = bDoc.getMap('nodes');
    $aa1828bc973fe863$var$bEdgesMap = bDoc.getMap('edges');
    let bNodes = new (0, $558228835489ffff$export$486059efd2d2dabe)();
    let bEdges = new (0, $558228835489ffff$export$486059efd2d2dabe)();
    $aa1828bc973fe863$var$bdata = {
        nodes: bNodes,
        edges: bEdges
    };
}
function $aa1828bc973fe863$var$mergeMaps() {
    let history = '' // collect history log entries, so that the log can be updated all at once
    ;
    (0, $e1c55b086cf8dd0e$export$2a111da947c407d2).transact(()=>{
        let nodesToAdd = [] // collect new nodes to add to map A
        ;
        let edgesToAdd = [] // and edges
        ;
        let substitutes = new Map() // when two nodes have different ids, but identical labels,
        ;
        // use this as a conversion look up table from one id to the other
        let newNodes = new Map();
        for (let BNode of $aa1828bc973fe863$var$bdata.nodes.get()){
            if (BNode.isCluster) continue;
            // for each node in the other map
            let ANode = (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get(BNode.id) // see whether there is a node in this map with the same id
            ;
            // if not, see whether there is a node in this map with the same label, and treat this node as the same as the node in the other map
            if (!ANode) {
                let sameLabelNodes = (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get().filter((an)=>an.label.replace(/\s/g, '') === BNode.label.replace(/\s/g, ''));
                if (sameLabelNodes.length > 1) {
                    console.log(`%cMatching factors by label ('${BNode.label}'), but there are two or more factors with this label in this map`, 'color: red');
                    (0, $gFW3W.alertMsg)(`Matching factors by label ('${BNode.label}'), but there are two or more factors with this label in the map`, 'warn');
                }
                ANode = sameLabelNodes[0];
                if (ANode) {
                    // map works both ways - OK since ids are unique
                    substitutes.set(BNode.id, ANode.id);
                    substitutes.set(ANode.id, BNode.id);
                }
            }
            if (ANode) {
                // if there is, check whether the label is the same
                if (ANode.label.replace(/\s/g, '') !== BNode.label.replace(/\s/g, '')) {
                    // if not, make a clone of the other node with a new id
                    logMerge(`'${ANode.label}' Factor in this map does not match Factor from other map with new label: '${BNode.label}'. Factor with new label added.`);
                    // generate a new id for BNode.  change border to dashed red.  Add it to the map
                    let newNode = (0, $gFW3W.deepCopy)(BNode);
                    newNode.id = (0, $gFW3W.uuidv4)();
                    newNode.shapeProperties.borderDashes = true;
                    newNode.borderWidth = 4;
                    newNode.borderWidthSelected = 4;
                    newNode.color.border = '#ff0000';
                    newNode.color.highlight.border = '#ff0000';
                    newNode.x = ANode.x + 30;
                    newNode.y = ANode.y + 30;
                    // add it to this map
                    nodesToAdd.push(newNode);
                    // add to lookup table of existing node id to clone node id
                    newNodes.set(BNode.id, newNode.id);
                } else if (ANode.grp !== BNode.grp) // label is the same, but style is not - just report this
                logMerge(`Style: '${ANode.grp}' does not match style: '${BNode.grp}' from other map for Factor: '${ANode.label}. Existing style retained.`);
            } else {
                // the node is on the other map, but not on this one - add it.
                nodesToAdd.push(BNode);
                logMerge(`added new Factor: '${BNode.label}'`);
            }
        }
        (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.update(nodesToAdd);
        $aa1828bc973fe863$var$bdata.edges.get().forEach((BEdge)=>{
            // Some edges on the other map may have been going to/from nodes that have been cloned and given a new id.
            // Clone these edges, giving them the new from: or to: node ids and make them dashed.
            let newEdge = null;
            if (newNodes.has(BEdge.from)) {
                // this edge goes from a node that has been cloned - adjust the from: id
                newEdge = (0, $gFW3W.deepCopy)(BEdge);
                newEdge.from = newNodes.get(BEdge.from);
                // it might also go to a cloned node -if so, adjust the to: id
                if (newNodes.has(newEdge.to)) newEdge.to = newNodes.get(newEdge.to);
            } else if (newNodes.has(BEdge.to)) {
                // this edge goes to a cloned node
                newEdge = (0, $gFW3W.deepCopy)(BEdge);
                newEdge.to = newNodes.get(BEdge.to);
            }
            if (newEdge) {
                // give the cloned edge a new id
                newEdge.id = (0, $gFW3W.uuidv4)();
                // make the edge dashed, red and thick
                newEdge.dashes = true;
                newEdge.width = 4;
                newEdge.color.color = 'rgb(255, 0, 0)';
                edgesToAdd.push(newEdge);
                logMerge(`added Link between new Factor(s): '${(0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get(newEdge.from).label}' to '${(0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get(newEdge.to).label}'`);
            }
            // now deal with the other map's edges
            let AEdge = (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.get(BEdge.id);
            if (!AEdge) {
                // check to see if there is a link in map A that goes from and to the same nodes as
                // this link in map B, although it has a different id, remembering that the map A
                // and map B nodes may have been matched by label, rather than id.
                let from = BEdge.from;
                if (substitutes.get(from)) from = substitutes.get(from);
                let to = BEdge.to;
                if (substitutes.get(to)) to = substitutes.get(to);
                let sameEdges = (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.get().filter((e)=>e.from === from && e.to === to);
                if (sameEdges) AEdge = sameEdges[0];
            }
            if (BEdge.label && BEdge.label.trim() === '') BEdge.label = undefined;
            let edgeName = BEdge.label || `from [${$aa1828bc973fe863$var$bdata.nodes.get(BEdge.from).label}] to [${$aa1828bc973fe863$var$bdata.nodes.get(BEdge.to).label}]`;
            if (AEdge) {
                if ((AEdge.label && AEdge.label.trim() !== '' || BEdge.label && BEdge.label.trim() !== '') && AEdge.label !== BEdge.label) logMerge(`Link with label: '${AEdge.label}' does not match link from other map with label: '${BEdge.label}'.  Existing label retained.`);
                else if (AEdge.grp !== BEdge.grp) logMerge(`Link with style: '${AEdge.grp}' does not match style: '${BEdge.grp}' from other map for link '${edgeName}'. Existing style retained.`);
            } else {
                // if BEdge's from or to nodes have been substituted for a node in the A map
                // with the same label, change the from or to ids to the A map version
                if (substitutes.get(BEdge.from)) BEdge.from = substitutes.get(BEdge.from);
                if (substitutes.get(BEdge.to)) BEdge.to = substitutes.get(BEdge.to);
                edgesToAdd.push(BEdge);
                logMerge(`added new Link: '${edgeName}'`);
            }
        });
        // now check that all edges in the existing map are also in the other map
        (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.forEach((AEdge)=>{
            let BEdge = $aa1828bc973fe863$var$bdata.edges.get(AEdge.id);
            if (!BEdge) {
                let from = AEdge.from;
                if (substitutes.get(from)) from = substitutes.get(from);
                let to = AEdge.to;
                if (substitutes.get(to)) to = substitutes.get(to);
                let sameEdges = $aa1828bc973fe863$var$bdata.edges.get().filter((e)=>e.from === from && e.to === to);
                if (sameEdges) BEdge = sameEdges[0];
            }
        });
        (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.update(nodesToAdd);
        (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.update(edgesToAdd);
    });
    (0, $e1c55b086cf8dd0e$export$e5fde6ebaea8ae1d)(history, 'Merge');
    function logMerge(action) {
        history += '<br />' + action;
    }
}
function $aa1828bc973fe863$export$547fdf2442351faf(otherRoom) {
    $aa1828bc973fe863$export$ac1ea0fcd93fecda(otherRoom);
    console.log('%cMerging map at %s (map A) with map at %s (map B)', 'font-weight: bold', (0, $e1c55b086cf8dd0e$export$f9d3fff8c23da278), otherRoom);
    $aa1828bc973fe863$var$bwsp.on('sync', (status)=>{
        if (!status) return;
        $aa1828bc973fe863$var$bNodesMap.forEach((n)=>$aa1828bc973fe863$var$bdata.nodes.update(n));
        $aa1828bc973fe863$var$bEdgesMap.forEach((e)=>$aa1828bc973fe863$var$bdata.edges.update(e));
        $aa1828bc973fe863$var$mergeMaps();
        $aa1828bc973fe863$var$bwsp.disconnect();
        console.log('Finished');
    });
    return 'Please wait...';
}
/**
 * Print to console the differences between the given map and the current map
 */ function $aa1828bc973fe863$var$diffMaps() {
    for (let BNode of $aa1828bc973fe863$var$bdata.nodes.get()){
        if (BNode.isCluster) continue;
        // for each node in the other map
        let ANode = (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get(BNode.id) // see whether there is a node in this map with the same id
        ;
        if (!ANode) {
            let sameLabelNodes = (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get().filter((an)=>an.label.replace(/\s/g, '') === BNode.label.replace(/\s/g, ''));
            if (sameLabelNodes.length > 1) console.log(`%cMatching factors by label [%c${$aa1828bc973fe863$var$inline(BNode.label)}%c], but there are two or more factors with this label in this map`, 'color: red', 'color:green', 'color:red');
            else if (sameLabelNodes.length === 1) console.log(`%cMatching factors by label [%c${$aa1828bc973fe863$var$inline(BNode.label)}%c] because there is no pair of factors with the same id`, 'color: black', 'color:green', 'color: black');
            ANode = sameLabelNodes[0];
        }
        if (ANode) {
            // if there is, check whether the label is the same
            if (ANode.label.replace(/\s/g, '') !== BNode.label.replace(/\s/g, '')) console.log(`Factor label in map A: [%c${$aa1828bc973fe863$var$inline(ANode.label)}%c] does not match label in map B: [%c${$aa1828bc973fe863$var$inline(BNode.label)}%c].`, 'color:green', 'color:black', 'color:green', 'color:black');
            else if (ANode.grp !== BNode.grp) // label is the same, but style is not - just report this
            console.log(`Factor style in map A : ${ANode.grp} does not match style in map B: ${BNode.grp} for Factor: [%c${$aa1828bc973fe863$var$inline(ANode.label)}%c]. `, 'color:green', 'color:black');
        } else // the node is on the other map, but not on this one - add it.
        console.log(`Factor: [%c${$aa1828bc973fe863$var$inline(BNode.label)}%c] in map B is not in map A`, 'color:green', 'color:black');
    }
    // now check that all nodes in the existing map are also in the other map
    for (let ANode of (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get()){
        if (ANode.isCluster) continue;
        if (!$aa1828bc973fe863$var$bdata.nodes.get(ANode.id)) console.log(`Factor: [%c${$aa1828bc973fe863$var$inline(ANode.label)}%c] in map A is not in map B`, 'color:green', 'color:black');
    }
    // now deal with the other map's edges
    $aa1828bc973fe863$var$bdata.edges.get().forEach((BEdge)=>{
        let AEdge = (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.get(BEdge.id);
        if (BEdge.label && BEdge.label.trim() === '') BEdge.label = undefined;
        let edgeName = BEdge.label || `[${$aa1828bc973fe863$var$bdata.nodes.get(BEdge.from).label}] --> [${$aa1828bc973fe863$var$bdata.nodes.get(BEdge.to).label}]`;
        if (AEdge) {
            if ((AEdge.label && AEdge.label.trim() !== '' || BEdge.label && BEdge.label.trim() !== '') && AEdge.label !== BEdge.label) console.log(`Link label in map A: [%c${$aa1828bc973fe863$var$inline(AEdge.label)}%c] does not match label:[%c${$aa1828bc973fe863$var$inline(BEdge.label)}%c] in map B.  `, 'color:green', 'color:black', 'color:green', 'color:black');
            else if (AEdge.grp !== BEdge.grp) console.log(`Link style: '${AEdge.grp}' in map A does not match style: '${BEdge.grp}' in map B for link [%c${$aa1828bc973fe863$var$inline(edgeName)}%c]. `, 'color:green', 'color:black');
        } else console.log(`Map A does not include the link: %c${$aa1828bc973fe863$var$inline(edgeName)}%c in map B. `, 'color:green', 'color:black');
    });
    // now check that all edges in the existing map are also in the other map
    (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.forEach((AEdge)=>{
        if (!$aa1828bc973fe863$var$bdata.edges.get(AEdge.id)) {
            let edgeName = AEdge.label && AEdge.label.trim() !== '' || `[${(0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get(AEdge.from).label}] --> [${(0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get(AEdge.to).label}]`;
            console.log(`Link %c${$aa1828bc973fe863$var$inline(edgeName)}%c in map A is not in map B`, 'color:green', 'color:black');
        }
    });
}
function $aa1828bc973fe863$export$8150c7da8c1e5fc2(otherRoom) {
    $aa1828bc973fe863$export$ac1ea0fcd93fecda(otherRoom);
    console.log('%cComparing map at %s (map A) with map at %s (map B)', 'font-weight: bold', (0, $e1c55b086cf8dd0e$export$f9d3fff8c23da278), otherRoom);
    $aa1828bc973fe863$var$bwsp.on('sync', (status)=>{
        if (!status) return;
        $aa1828bc973fe863$var$bNodesMap.forEach((n)=>$aa1828bc973fe863$var$bdata.nodes.update(n));
        $aa1828bc973fe863$var$bEdgesMap.forEach((e)=>$aa1828bc973fe863$var$bdata.edges.update(e));
        $aa1828bc973fe863$var$diffMaps();
        $aa1828bc973fe863$var$bwsp.disconnect();
    });
    return true;
}
function $aa1828bc973fe863$export$9d64036b9b8c0207(id) {
    if (!id) return id;
    let node = (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get(id);
    if (!node) return 'node not found';
    return node.label;
}
/**
 * replace all white space with single space characters
 * @param {string} label
 * @returns string
 */ function $aa1828bc973fe863$var$inline(label) {
    return label.replace(/\s+/g, ' ').trim();
}
function $aa1828bc973fe863$export$383e0e82785949bc() {
    let nodes = (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get();
    nodes.forEach((n)=>{
        if (n.created) n.created = undefined;
        if (n.modified) n.modified = undefined;
    });
    (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.update(nodes);
    let edges = (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.get();
    edges.forEach((e)=>{
        if (e.created) e.created = undefined;
        if (e.modified) e.modified = undefined;
    });
    (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.update(edges);
}
function $aa1828bc973fe863$export$2cad840c32f2e04e(del = false) {
    // check all factors have labels
    (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get().forEach((n)=>{
        if (!n.label || n.label === '' || n.label.trim() === '') {
            console.log('Bad factor:', n);
            if (del) {
                (0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.remove(n.id);
                console.log('Deleted factor', n);
            }
        }
    });
    // check all links have existing to and from factors
    (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.get().forEach((e)=>{
        let ok = true;
        if (!(0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get(e.from)) {
            console.log('Missing from factor', e);
            ok = false;
        }
        if (!(0, $e1c55b086cf8dd0e$export$4051a07651545597).nodes.get(e.to)) {
            console.log('Missing to factor', e);
            ok = false;
        }
        if (!ok && del) {
            (0, $e1c55b086cf8dd0e$export$4051a07651545597).edges.remove(e.id);
            console.log('Deleted edge: ', e);
        }
    });
}
window.sanityCheck = $aa1828bc973fe863$export$2cad840c32f2e04e;



var $aBK2w = parcelRequire("aBK2w");

var $hV9VG = parcelRequire("hV9VG");


/********************************************************************************************* 

PRSM Participatory System Mapper 

MIT License

Copyright (c) [2022] Nigel Gilbert email: prsm@prsm.uk

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.


This module generates responses using an LLM.  
********************************************************************************************/ /*
 * Invoke AWS Bedrock LLM model in guest mode using AWS SDK for JavaScript
 *
 * This is a simplified version of the code example in the blog post:
 * https://github.com/alankrantas/aws-sdk-js-bedrock-llm-example/blob/main/README.md
 * See the blog post for details about how to set up the AWS environment.
 */ // bedrock resource
const $84f26894dd035c27$export$663b205817703038 = (runtimeConfig)=>{
    let httpHandler = runtimeConfig.httpHandler;
    return {
        setHttpHandler (handler) {
            httpHandler = handler;
        },
        httpHandler () {
            return httpHandler;
        },
        updateHttpClientConfig (key, value) {
            httpHandler.updateHttpClientConfig(key, value);
        },
        httpHandlerConfigs () {
            return httpHandler.httpHandlerConfigs();
        }
    };
};
const $84f26894dd035c27$export$d94fe0350385c1a8 = (httpHandlerExtensionConfiguration)=>{
    return {
        httpHandler: httpHandlerExtensionConfiguration.httpHandler()
    };
};






var $092694cadb1c322c$export$e24756d4ad084ce1;
(function(HttpAuthLocation) {
    HttpAuthLocation["HEADER"] = "header";
    HttpAuthLocation["QUERY"] = "query";
})($092694cadb1c322c$export$e24756d4ad084ce1 || ($092694cadb1c322c$export$e24756d4ad084ce1 = {}));


var $cad43ee6de694c1d$export$8c5ca875010cb2a6;
(function(HttpApiKeyAuthLocation) {
    HttpApiKeyAuthLocation["HEADER"] = "header";
    HttpApiKeyAuthLocation["QUERY"] = "query";
})($cad43ee6de694c1d$export$8c5ca875010cb2a6 || ($cad43ee6de694c1d$export$8c5ca875010cb2a6 = {}));
































var $b5efabe4788fc71a$export$b141d049add1dcb5;
(function(EndpointURLScheme) {
    EndpointURLScheme["HTTP"] = "http";
    EndpointURLScheme["HTTPS"] = "https";
})($b5efabe4788fc71a$export$b141d049add1dcb5 || ($b5efabe4788fc71a$export$b141d049add1dcb5 = {}));
















var $2bc5d4a467996ea0$export$fe562bf21391d1f0;
(function(AlgorithmId) {
    AlgorithmId["MD5"] = "md5";
    AlgorithmId["CRC32"] = "crc32";
    AlgorithmId["CRC32C"] = "crc32c";
    AlgorithmId["SHA1"] = "sha1";
    AlgorithmId["SHA256"] = "sha256";
})($2bc5d4a467996ea0$export$fe562bf21391d1f0 || ($2bc5d4a467996ea0$export$fe562bf21391d1f0 = {}));
const $2bc5d4a467996ea0$export$129b301e72591856 = (runtimeConfig)=>{
    const checksumAlgorithms = [];
    if (runtimeConfig.sha256 !== undefined) checksumAlgorithms.push({
        algorithmId: ()=>$2bc5d4a467996ea0$export$fe562bf21391d1f0.SHA256,
        checksumConstructor: ()=>runtimeConfig.sha256
    });
    if (runtimeConfig.md5 != undefined) checksumAlgorithms.push({
        algorithmId: ()=>$2bc5d4a467996ea0$export$fe562bf21391d1f0.MD5,
        checksumConstructor: ()=>runtimeConfig.md5
    });
    return {
        _checksumAlgorithms: checksumAlgorithms,
        addChecksumAlgorithm (algo) {
            this._checksumAlgorithms.push(algo);
        },
        checksumAlgorithms () {
            return this._checksumAlgorithms;
        }
    };
};
const $2bc5d4a467996ea0$export$589dfc268e61d391 = (clientConfig)=>{
    const runtimeConfig = {};
    clientConfig.checksumAlgorithms().forEach((checksumAlgorithm)=>{
        runtimeConfig[checksumAlgorithm.algorithmId()] = checksumAlgorithm.checksumConstructor();
    });
    return runtimeConfig;
};


const $6ed805c2f4cf3cff$export$7081660fd0cd662b = (runtimeConfig)=>{
    return {
        ...(0, $2bc5d4a467996ea0$export$129b301e72591856)(runtimeConfig)
    };
};
const $6ed805c2f4cf3cff$export$abfa28b95316e0ae = (config)=>{
    return {
        ...(0, $2bc5d4a467996ea0$export$589dfc268e61d391)(config)
    };
};









var $dc79df9ed5fff9a0$export$54765d03252bd9ed;
(function(FieldPosition) {
    FieldPosition[FieldPosition["HEADER"] = 0] = "HEADER";
    FieldPosition[FieldPosition["TRAILER"] = 1] = "TRAILER";
})($dc79df9ed5fff9a0$export$54765d03252bd9ed || ($dc79df9ed5fff9a0$export$54765d03252bd9ed = {}));
















const $af1a654ad93bbd70$export$94e7bb1b8aa610cb = "__smithy_context";




var $56f9e1610c74252f$export$bd84655cbf2c28d9;
(function(IniSectionType) {
    IniSectionType["PROFILE"] = "profile";
    IniSectionType["SSO_SESSION"] = "sso-session";
    IniSectionType["SERVICES"] = "services";
})($56f9e1610c74252f$export$bd84655cbf2c28d9 || ($56f9e1610c74252f$export$bd84655cbf2c28d9 = {}));




















var $db1eef58c5d5bd8e$export$6431f3fda9a48da2;
(function(RequestHandlerProtocol) {
    RequestHandlerProtocol["HTTP_0_9"] = "http/0.9";
    RequestHandlerProtocol["HTTP_1_0"] = "http/1.0";
    RequestHandlerProtocol["TDS_8_0"] = "tds/8.0";
})($db1eef58c5d5bd8e$export$6431f3fda9a48da2 || ($db1eef58c5d5bd8e$export$6431f3fda9a48da2 = {}));
















class $47e9a797cbe7d625$export$a455218a85c89869 {
    constructor({ name: name, kind: kind = (0, $dc79df9ed5fff9a0$export$54765d03252bd9ed).HEADER, values: values = [] }){
        this.name = name;
        this.kind = kind;
        this.values = values;
    }
    add(value) {
        this.values.push(value);
    }
    set(values) {
        this.values = values;
    }
    remove(value) {
        this.values = this.values.filter((v)=>v !== value);
    }
    toString() {
        return this.values.map((v)=>v.includes(",") || v.includes(" ") ? `"${v}"` : v).join(", ");
    }
    get() {
        return this.values;
    }
}


class $3b09cc1f13bf8eef$export$833b3e5a19fb8939 {
    constructor({ fields: fields = [], encoding: encoding = "utf-8" }){
        this.entries = {};
        fields.forEach(this.setField.bind(this));
        this.encoding = encoding;
    }
    setField(field) {
        this.entries[field.name.toLowerCase()] = field;
    }
    getField(name) {
        return this.entries[name.toLowerCase()];
    }
    removeField(name) {
        delete this.entries[name.toLowerCase()];
    }
    getByType(kind) {
        return Object.values(this.entries).filter((field)=>field.kind === kind);
    }
}




class $36c92c5bbc6e0688$export$7587955500404ec3 {
    constructor(options){
        this.method = options.method || "GET";
        this.hostname = options.hostname || "localhost";
        this.port = options.port;
        this.query = options.query || {};
        this.headers = options.headers || {};
        this.body = options.body;
        this.protocol = options.protocol ? options.protocol.slice(-1) !== ":" ? `${options.protocol}:` : options.protocol : "https:";
        this.path = options.path ? options.path.charAt(0) !== "/" ? `/${options.path}` : options.path : "/";
        this.username = options.username;
        this.password = options.password;
        this.fragment = options.fragment;
    }
    static clone(request) {
        const cloned = new $36c92c5bbc6e0688$export$7587955500404ec3({
            ...request,
            headers: {
                ...request.headers
            }
        });
        if (cloned.query) cloned.query = $36c92c5bbc6e0688$var$cloneQuery(cloned.query);
        return cloned;
    }
    static isInstance(request) {
        if (!request) return false;
        const req = request;
        return "method" in req && "protocol" in req && "hostname" in req && "path" in req && typeof req["query"] === "object" && typeof req["headers"] === "object";
    }
    clone() {
        return $36c92c5bbc6e0688$export$7587955500404ec3.clone(this);
    }
}
function $36c92c5bbc6e0688$var$cloneQuery(query) {
    return Object.keys(query).reduce((carry, paramName)=>{
        const param = query[paramName];
        return {
            ...carry,
            [paramName]: Array.isArray(param) ? [
                ...param
            ] : param
        };
    }, {});
}


class $719e5a813689e03b$export$1d94dfe0d9d1f1e7 {
    constructor(options){
        this.statusCode = options.statusCode;
        this.reason = options.reason;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    static isInstance(response) {
        if (!response) return false;
        const resp = response;
        return typeof resp.statusCode === "number" && typeof resp.headers === "object";
    }
}


function $c67fc6a44f76ab01$export$e024c793399bdd01(hostname) {
    const hostPattern = /^[a-z0-9][a-z0-9\.\-]*[a-z0-9]$/;
    return hostPattern.test(hostname);
}






function $b173a3ce9281b3cf$export$c1625bf0b32b4481(input) {
    return input;
}
const $b173a3ce9281b3cf$export$858685d7aeef192d = (options)=>(next)=>async (args)=>{
            if (!(0, $36c92c5bbc6e0688$export$7587955500404ec3).isInstance(args.request)) return next(args);
            const { request: request } = args;
            const { handlerProtocol: handlerProtocol = "" } = options.requestHandler.metadata || {};
            if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
                delete request.headers["host"];
                request.headers[":authority"] = request.hostname + (request.port ? ":" + request.port : "");
            } else if (!request.headers["host"]) {
                let host = request.hostname;
                if (request.port != null) host += `:${request.port}`;
                request.headers["host"] = host;
            }
            return next(args);
        };
const $b173a3ce9281b3cf$export$696d244ba96181e8 = {
    name: "hostHeaderMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "HOST"
    ],
    override: true
};
const $b173a3ce9281b3cf$export$23d3b647211be53a = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($b173a3ce9281b3cf$export$858685d7aeef192d(options), $b173a3ce9281b3cf$export$696d244ba96181e8);
        }
    });


const $60459010f05dd111$export$fe0e777ee4f58cde = ()=>(next, context)=>async (args)=>{
            try {
                const response = await next(args);
                const { clientName: clientName, commandName: commandName, logger: logger, dynamoDbDocumentClientOptions: dynamoDbDocumentClientOptions = {} } = context;
                const { overrideInputFilterSensitiveLog: overrideInputFilterSensitiveLog, overrideOutputFilterSensitiveLog: overrideOutputFilterSensitiveLog } = dynamoDbDocumentClientOptions;
                const inputFilterSensitiveLog = overrideInputFilterSensitiveLog ?? context.inputFilterSensitiveLog;
                const outputFilterSensitiveLog = overrideOutputFilterSensitiveLog ?? context.outputFilterSensitiveLog;
                const { $metadata: $metadata, ...outputWithoutMetadata } = response.output;
                logger?.info?.({
                    clientName: clientName,
                    commandName: commandName,
                    input: inputFilterSensitiveLog(args.input),
                    output: outputFilterSensitiveLog(outputWithoutMetadata),
                    metadata: $metadata
                });
                return response;
            } catch (error) {
                const { clientName: clientName, commandName: commandName, logger: logger, dynamoDbDocumentClientOptions: dynamoDbDocumentClientOptions = {} } = context;
                const { overrideInputFilterSensitiveLog: overrideInputFilterSensitiveLog } = dynamoDbDocumentClientOptions;
                const inputFilterSensitiveLog = overrideInputFilterSensitiveLog ?? context.inputFilterSensitiveLog;
                logger?.error?.({
                    clientName: clientName,
                    commandName: commandName,
                    input: inputFilterSensitiveLog(args.input),
                    error: error,
                    metadata: error.$metadata
                });
                throw error;
            }
        };
const $60459010f05dd111$export$877c148ab4ad0722 = {
    name: "loggerMiddleware",
    tags: [
        "LOGGER"
    ],
    step: "initialize",
    override: true
};
const $60459010f05dd111$export$f6ef65d7766fc255 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($60459010f05dd111$export$fe0e777ee4f58cde(), $60459010f05dd111$export$877c148ab4ad0722);
        }
    });






var $iZPu2 = parcelRequire("iZPu2");
const $8825720894d7451a$var$TRACE_ID_HEADER_NAME = "X-Amzn-Trace-Id";
const $8825720894d7451a$var$ENV_LAMBDA_FUNCTION_NAME = "AWS_LAMBDA_FUNCTION_NAME";
const $8825720894d7451a$var$ENV_TRACE_ID = "_X_AMZN_TRACE_ID";
const $8825720894d7451a$export$d12885408d4c0634 = (options)=>(next)=>async (args)=>{
            const { request: request } = args;
            if (!(0, $36c92c5bbc6e0688$export$7587955500404ec3).isInstance(request) || options.runtime !== "node" || request.headers.hasOwnProperty($8825720894d7451a$var$TRACE_ID_HEADER_NAME)) return next(args);
            const functionName = $iZPu2.env[$8825720894d7451a$var$ENV_LAMBDA_FUNCTION_NAME];
            const traceId = $iZPu2.env[$8825720894d7451a$var$ENV_TRACE_ID];
            const nonEmptyString = (str)=>typeof str === "string" && str.length > 0;
            if (nonEmptyString(functionName) && nonEmptyString(traceId)) request.headers[$8825720894d7451a$var$TRACE_ID_HEADER_NAME] = traceId;
            return next({
                ...args,
                request: request
            });
        };
const $8825720894d7451a$export$1f1705db3faed8f3 = {
    step: "build",
    tags: [
        "RECURSION_DETECTION"
    ],
    name: "recursionDetectionMiddleware",
    override: true,
    priority: "low"
};
const $8825720894d7451a$export$11d0b9345788bd5 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($8825720894d7451a$export$d12885408d4c0634(options), $8825720894d7451a$export$1f1705db3faed8f3);
        }
    });



const $a8093a28960d4c59$export$1d3c197393275463 = (context)=>context[0, $af1a654ad93bbd70$export$94e7bb1b8aa610cb] || (context[0, $af1a654ad93bbd70$export$94e7bb1b8aa610cb] = {});




const $e6ed4dab4f65171f$export$1d3c197393275463 = (context)=>context[0, $af1a654ad93bbd70$export$94e7bb1b8aa610cb] || (context[0, $af1a654ad93bbd70$export$94e7bb1b8aa610cb] = {});


const $1d6280adb1321100$export$b1276c07738d6325 = (input)=>{
    if (typeof input === "function") return input;
    const promisified = Promise.resolve(input);
    return ()=>promisified;
};




function $791b6da64c755fd7$var$convertHttpAuthSchemesToMap(httpAuthSchemes) {
    const map = new Map();
    for (const scheme of httpAuthSchemes)map.set(scheme.schemeId, scheme);
    return map;
}
const $791b6da64c755fd7$export$681dcf755d3830d0 = (config, mwOptions)=>(next, context)=>async (args)=>{
            const options = config.httpAuthSchemeProvider(await mwOptions.httpAuthSchemeParametersProvider(config, context, args.input));
            const authSchemes = $791b6da64c755fd7$var$convertHttpAuthSchemesToMap(config.httpAuthSchemes);
            const smithyContext = (0, $e6ed4dab4f65171f$export$1d3c197393275463)(context);
            const failureReasons = [];
            for (const option of options){
                const scheme = authSchemes.get(option.schemeId);
                if (!scheme) {
                    failureReasons.push(`HttpAuthScheme \`${option.schemeId}\` was not enabled for this service.`);
                    continue;
                }
                const identityProvider = scheme.identityProvider(await mwOptions.identityProviderConfigProvider(config));
                if (!identityProvider) {
                    failureReasons.push(`HttpAuthScheme \`${option.schemeId}\` did not have an IdentityProvider configured.`);
                    continue;
                }
                const { identityProperties: identityProperties = {}, signingProperties: signingProperties = {} } = option.propertiesExtractor?.(config, context) || {};
                option.identityProperties = Object.assign(option.identityProperties || {}, identityProperties);
                option.signingProperties = Object.assign(option.signingProperties || {}, signingProperties);
                smithyContext.selectedHttpAuthScheme = {
                    httpAuthOption: option,
                    identity: await identityProvider(option.identityProperties),
                    signer: scheme.signer
                };
                break;
            }
            if (!smithyContext.selectedHttpAuthScheme) throw new Error(failureReasons.join("\n"));
            return next(args);
        };



const $1fcce1fc5214c9cb$export$8c136d4eb4815c3e = {
    step: "serialize",
    tags: [
        "HTTP_AUTH_SCHEME"
    ],
    name: "httpAuthSchemeMiddleware",
    override: true,
    relation: "before",
    toMiddleware: "endpointV2Middleware"
};
const $1fcce1fc5214c9cb$export$6ababc1a6356ca41 = (config, { httpAuthSchemeParametersProvider: httpAuthSchemeParametersProvider, identityProviderConfigProvider: identityProviderConfigProvider })=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo((0, $791b6da64c755fd7$export$681dcf755d3830d0)(config, {
                httpAuthSchemeParametersProvider: httpAuthSchemeParametersProvider,
                identityProviderConfigProvider: identityProviderConfigProvider
            }), $1fcce1fc5214c9cb$export$8c136d4eb4815c3e);
        }
    });


const $c4c205795386b373$export$d10196e291075f95 = (options, deserializer)=>(next)=>async (args)=>{
            const { response: response } = await next(args);
            try {
                const parsed = await deserializer(response, options);
                return {
                    response: response,
                    output: parsed
                };
            } catch (error) {
                Object.defineProperty(error, "$response", {
                    value: response
                });
                if (!("$metadata" in error)) {
                    const hint = `Deserialization error: to see the raw response, inspect the hidden field {error}.$response on this object.`;
                    error.message += "\n  " + hint;
                    if (typeof error.$responseBodyText !== "undefined") {
                        if (error.$response) error.$response.body = error.$responseBodyText;
                    }
                }
                throw error;
            }
        };



const $414ffeac33816644$export$125a23d36094c5de = (options, serializer)=>(next, context)=>async (args)=>{
            const endpoint = context.endpointV2?.url && options.urlParser ? async ()=>options.urlParser(context.endpointV2.url) : options.endpoint;
            if (!endpoint) throw new Error("No valid endpoint provider available.");
            const request = await serializer(args.input, {
                ...options,
                endpoint: endpoint
            });
            return next({
                ...args,
                request: request
            });
        };


const $d08040bde29682c1$export$f5d82b333b4f39c9 = {
    name: "deserializerMiddleware",
    step: "deserialize",
    tags: [
        "DESERIALIZER"
    ],
    override: true
};
const $d08040bde29682c1$export$1bd449976e9c484d = {
    name: "serializerMiddleware",
    step: "serialize",
    tags: [
        "SERIALIZER"
    ],
    override: true
};
function $d08040bde29682c1$export$53fdc69654553fd4(config, serializer, deserializer) {
    return {
        applyToStack: (commandStack)=>{
            commandStack.add((0, $c4c205795386b373$export$d10196e291075f95)(config, deserializer), $d08040bde29682c1$export$f5d82b333b4f39c9);
            commandStack.add((0, $414ffeac33816644$export$125a23d36094c5de)(config, serializer), $d08040bde29682c1$export$1bd449976e9c484d);
        }
    };
}






const $2d13c83f6f18e4a5$export$11cd3870e3f87892 = {
    step: "serialize",
    tags: [
        "HTTP_AUTH_SCHEME"
    ],
    name: "httpAuthSchemeMiddleware",
    override: true,
    relation: "before",
    toMiddleware: (0, $d08040bde29682c1$export$1bd449976e9c484d).name
};
const $2d13c83f6f18e4a5$export$ac2af07429c3a20e = (config, { httpAuthSchemeParametersProvider: httpAuthSchemeParametersProvider, identityProviderConfigProvider: identityProviderConfigProvider })=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo((0, $791b6da64c755fd7$export$681dcf755d3830d0)(config, {
                httpAuthSchemeParametersProvider: httpAuthSchemeParametersProvider,
                identityProviderConfigProvider: identityProviderConfigProvider
            }), $2d13c83f6f18e4a5$export$11cd3870e3f87892);
        }
    });







const $cffd8a9b3f2e8c64$var$defaultErrorHandler = (signingProperties)=>(error)=>{
        throw error;
    };
const $cffd8a9b3f2e8c64$var$defaultSuccessHandler = (httpResponse, signingProperties)=>{};
const $cffd8a9b3f2e8c64$export$fe39ed571a606f80 = (config)=>(next, context)=>async (args)=>{
            if (!(0, $36c92c5bbc6e0688$export$7587955500404ec3).isInstance(args.request)) return next(args);
            const smithyContext = (0, $e6ed4dab4f65171f$export$1d3c197393275463)(context);
            const scheme = smithyContext.selectedHttpAuthScheme;
            if (!scheme) throw new Error(`No HttpAuthScheme was selected: unable to sign request`);
            const { httpAuthOption: { signingProperties: signingProperties = {} }, identity: identity, signer: signer } = scheme;
            const output = await next({
                ...args,
                request: await signer.sign(args.request, identity, signingProperties)
            }).catch((signer.errorHandler || $cffd8a9b3f2e8c64$var$defaultErrorHandler)(signingProperties));
            (signer.successHandler || $cffd8a9b3f2e8c64$var$defaultSuccessHandler)(output.response, signingProperties);
            return output;
        };



const $a232cb521b867f08$export$dce1f72b9e752c12 = {
    step: "finalizeRequest",
    tags: [
        "HTTP_SIGNING"
    ],
    name: "httpSigningMiddleware",
    aliases: [
        "apiKeyMiddleware",
        "tokenMiddleware",
        "awsAuthMiddleware"
    ],
    override: true,
    relation: "after",
    toMiddleware: "retryMiddleware"
};
const $a232cb521b867f08$export$ed476aa7e410a = (config)=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo((0, $cffd8a9b3f2e8c64$export$fe39ed571a606f80)(config), $a232cb521b867f08$export$dce1f72b9e752c12);
        }
    });




const $7a73b05cc4d89640$export$b1276c07738d6325 = (input)=>{
    if (typeof input === "function") return input;
    const promisified = Promise.resolve(input);
    return ()=>promisified;
};


const $298cbca4fc09af3d$var$makePagedClientRequest = async (CommandCtor, client, input, withCommand = (_)=>_, ...args)=>{
    let command = new CommandCtor(input);
    command = withCommand(command) ?? command;
    return await client.send(command, ...args);
};
function $298cbca4fc09af3d$export$531a5724c6bf0340(ClientCtor, CommandCtor, inputTokenName, outputTokenName, pageSizeTokenName) {
    return async function* paginateOperation(config, input, ...additionalArguments) {
        const _input = input;
        let token = config.startingToken ?? _input[inputTokenName];
        let hasNext = true;
        let page;
        while(hasNext){
            _input[inputTokenName] = token;
            if (pageSizeTokenName) _input[pageSizeTokenName] = _input[pageSizeTokenName] ?? config.pageSize;
            if (config.client instanceof ClientCtor) page = await $298cbca4fc09af3d$var$makePagedClientRequest(CommandCtor, config.client, input, config.withCommand, ...additionalArguments);
            else throw new Error(`Invalid client, expected instance of ${ClientCtor.name}`);
            yield page;
            const prevToken = token;
            token = $298cbca4fc09af3d$var$get(page, outputTokenName);
            hasNext = !!(token && (!config.stopOnSameToken || token !== prevToken));
        }
        return undefined;
    };
}
const $298cbca4fc09af3d$var$get = (fromObject, path)=>{
    let cursor = fromObject;
    const pathComponents = path.split(".");
    for (const step of pathComponents){
        if (!cursor || typeof cursor !== "object") return undefined;
        cursor = cursor[step];
    }
    return cursor;
};


const $0ccf9807a03a712b$export$7753813254d72972 = {};
const $0ccf9807a03a712b$export$8f4022378ddff4c7 = new Array(64);
for(let i = 0, start = "A".charCodeAt(0), limit = "Z".charCodeAt(0); i + start <= limit; i++){
    const char = String.fromCharCode(i + start);
    $0ccf9807a03a712b$export$7753813254d72972[char] = i;
    $0ccf9807a03a712b$export$8f4022378ddff4c7[i] = char;
}
for(let i = 0, start = "a".charCodeAt(0), limit = "z".charCodeAt(0); i + start <= limit; i++){
    const char = String.fromCharCode(i + start);
    const index = i + 26;
    $0ccf9807a03a712b$export$7753813254d72972[char] = index;
    $0ccf9807a03a712b$export$8f4022378ddff4c7[index] = char;
}
for(let i = 0; i < 10; i++){
    $0ccf9807a03a712b$export$7753813254d72972[i.toString(10)] = i + 52;
    const char = i.toString(10);
    const index = i + 52;
    $0ccf9807a03a712b$export$7753813254d72972[char] = index;
    $0ccf9807a03a712b$export$8f4022378ddff4c7[index] = char;
}
$0ccf9807a03a712b$export$7753813254d72972["+"] = 62;
$0ccf9807a03a712b$export$8f4022378ddff4c7[62] = "+";
$0ccf9807a03a712b$export$7753813254d72972["/"] = 63;
$0ccf9807a03a712b$export$8f4022378ddff4c7[63] = "/";
const $0ccf9807a03a712b$export$1c5cfd5e95b84581 = 6;
const $0ccf9807a03a712b$export$79b97ac4c24c9385 = 8;
const $0ccf9807a03a712b$export$43e943b030ae3d73 = 63;


const $7b3498acd0b4495b$export$c537b38001c583b7 = (input)=>{
    let totalByteLength = input.length / 4 * 3;
    if (input.slice(-2) === "==") totalByteLength -= 2;
    else if (input.slice(-1) === "=") totalByteLength--;
    const out = new ArrayBuffer(totalByteLength);
    const dataView = new DataView(out);
    for(let i = 0; i < input.length; i += 4){
        let bits = 0;
        let bitLength = 0;
        for(let j = i, limit = i + 3; j <= limit; j++)if (input[j] !== "=") {
            if (!(input[j] in (0, $0ccf9807a03a712b$export$7753813254d72972))) throw new TypeError(`Invalid character ${input[j]} in base64 string.`);
            bits |= (0, $0ccf9807a03a712b$export$7753813254d72972)[input[j]] << (limit - j) * (0, $0ccf9807a03a712b$export$1c5cfd5e95b84581);
            bitLength += (0, $0ccf9807a03a712b$export$1c5cfd5e95b84581);
        } else bits >>= (0, $0ccf9807a03a712b$export$1c5cfd5e95b84581);
        const chunkOffset = i / 4 * 3;
        bits >>= bitLength % (0, $0ccf9807a03a712b$export$79b97ac4c24c9385);
        const byteLength = Math.floor(bitLength / (0, $0ccf9807a03a712b$export$79b97ac4c24c9385));
        for(let k = 0; k < byteLength; k++){
            const offset = (byteLength - k - 1) * (0, $0ccf9807a03a712b$export$79b97ac4c24c9385);
            dataView.setUint8(chunkOffset + k, (bits & 255 << offset) >> offset);
        }
    }
    return new Uint8Array(out);
};


const $443e71811b7d31c6$export$c7c5cef950a4d2fc = (input)=>new TextEncoder().encode(input);



const $e75b5fa6fbe27b3f$export$73470fd2221e6aef = (data)=>{
    if (typeof data === "string") return (0, $443e71811b7d31c6$export$c7c5cef950a4d2fc)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
};


const $5a195679de934416$export$b4b216764bb846eb = (input)=>{
    if (typeof input === "string") return input;
    if (typeof input !== "object" || typeof input.byteOffset !== "number" || typeof input.byteLength !== "number") throw new Error("@smithy/util-utf8: toUtf8 encoder function only accepts string | Uint8Array.");
    return new TextDecoder("utf-8").decode(input);
};





function $d63237a3fb21a427$export$37cc283d8fbd3462(_input) {
    let input;
    if (typeof _input === "string") input = (0, $443e71811b7d31c6$export$c7c5cef950a4d2fc)(_input);
    else input = _input;
    const isArrayLike = typeof input === "object" && typeof input.length === "number";
    const isUint8Array = typeof input === "object" && typeof input.byteOffset === "number" && typeof input.byteLength === "number";
    if (!isArrayLike && !isUint8Array) throw new Error("@smithy/util-base64: toBase64 encoder function only accepts string | Uint8Array.");
    let str = "";
    for(let i = 0; i < input.length; i += 3){
        let bits = 0;
        let bitLength = 0;
        for(let j = i, limit = Math.min(i + 3, input.length); j < limit; j++){
            bits |= input[j] << (limit - j - 1) * (0, $0ccf9807a03a712b$export$79b97ac4c24c9385);
            bitLength += (0, $0ccf9807a03a712b$export$79b97ac4c24c9385);
        }
        const bitClusterCount = Math.ceil(bitLength / (0, $0ccf9807a03a712b$export$1c5cfd5e95b84581));
        bits <<= bitClusterCount * (0, $0ccf9807a03a712b$export$1c5cfd5e95b84581) - bitLength;
        for(let k = 1; k <= bitClusterCount; k++){
            const offset = (bitClusterCount - k) * (0, $0ccf9807a03a712b$export$1c5cfd5e95b84581);
            str += (0, $0ccf9807a03a712b$export$8f4022378ddff4c7)[(bits & (0, $0ccf9807a03a712b$export$43e943b030ae3d73) << offset) >> offset];
        }
        str += "==".slice(0, 4 - bitClusterCount);
    }
    return str;
}






function $fa4d9a9e3f32ae9d$export$e9aa0d127315abe(payload, encoding = "utf-8") {
    if (encoding === "base64") return (0, $d63237a3fb21a427$export$37cc283d8fbd3462)(payload);
    return (0, $5a195679de934416$export$b4b216764bb846eb)(payload);
}
function $fa4d9a9e3f32ae9d$export$ed8c0e91f57de3aa(str, encoding) {
    if (encoding === "base64") return (0, $e8c74f5764f57928$export$1465fbad93f83f0a).mutate((0, $7b3498acd0b4495b$export$c537b38001c583b7)(str));
    return (0, $e8c74f5764f57928$export$1465fbad93f83f0a).mutate((0, $443e71811b7d31c6$export$c7c5cef950a4d2fc)(str));
}


class $e8c74f5764f57928$export$1465fbad93f83f0a extends Uint8Array {
    static fromString(source, encoding = "utf-8") {
        switch(typeof source){
            case "string":
                return (0, $fa4d9a9e3f32ae9d$export$ed8c0e91f57de3aa)(source, encoding);
            default:
                throw new Error(`Unsupported conversion from ${typeof source} to Uint8ArrayBlobAdapter.`);
        }
    }
    static mutate(source) {
        Object.setPrototypeOf(source, $e8c74f5764f57928$export$1465fbad93f83f0a.prototype);
        return source;
    }
    transformToString(encoding = "utf-8") {
        return (0, $fa4d9a9e3f32ae9d$export$e9aa0d127315abe)(this, encoding);
    }
}


const $42c2e26783f4e94e$export$cc0c9507624e70d1 = (readableStream, options)=>{
    const { base64Encoder: base64Encoder, bodyLengthChecker: bodyLengthChecker, checksumAlgorithmFn: checksumAlgorithmFn, checksumLocationName: checksumLocationName, streamHasher: streamHasher } = options;
    const checksumRequired = base64Encoder !== undefined && bodyLengthChecker !== undefined && checksumAlgorithmFn !== undefined && checksumLocationName !== undefined && streamHasher !== undefined;
    const digest = checksumRequired ? streamHasher(checksumAlgorithmFn, readableStream) : undefined;
    const reader = readableStream.getReader();
    return new ReadableStream({
        async pull (controller) {
            const { value: value, done: done } = await reader.read();
            if (done) {
                controller.enqueue(`0\r\n`);
                if (checksumRequired) {
                    const checksum = base64Encoder(await digest);
                    controller.enqueue(`${checksumLocationName}:${checksum}\r\n`);
                    controller.enqueue(`\r\n`);
                }
                controller.close();
            } else controller.enqueue(`${(bodyLengthChecker(value) || 0).toString(16)}\r\n${value}\r\n`);
        }
    });
};



const $efd4db5e50b1d59c$export$c3b4775ad75a73db = (uri)=>encodeURIComponent(uri).replace(/[!'()*]/g, $efd4db5e50b1d59c$var$hexEncode);
const $efd4db5e50b1d59c$var$hexEncode = (c)=>`%${c.charCodeAt(0).toString(16).toUpperCase()}`;



const $5d1d41723a0a5478$export$547c045505a754ef = (uri)=>uri.split("/").map((0, $efd4db5e50b1d59c$export$c3b4775ad75a73db)).join("/");




function $4fbde2bc3d2a4571$export$6b17a39e52c8ee53(query) {
    const parts = [];
    for (let key of Object.keys(query).sort()){
        const value = query[key];
        key = (0, $efd4db5e50b1d59c$export$c3b4775ad75a73db)(key);
        if (Array.isArray(value)) for(let i = 0, iLen = value.length; i < iLen; i++)parts.push(`${key}=${(0, $efd4db5e50b1d59c$export$c3b4775ad75a73db)(value[i])}`);
        else {
            let qsEntry = key;
            if (value || typeof value === "string") qsEntry += `=${(0, $efd4db5e50b1d59c$export$c3b4775ad75a73db)(value)}`;
            parts.push(qsEntry);
        }
    }
    return parts.join("&");
}


function $a469163f402dd6cf$export$72e3afa9ac8966be(url, requestOptions) {
    return new Request(url, requestOptions);
}


function $69898d062bca500c$export$363ac302bdbd807b(timeoutInMs = 0) {
    return new Promise((resolve, reject)=>{
        if (timeoutInMs) setTimeout(()=>{
            const timeoutError = new Error(`Request did not complete within ${timeoutInMs} ms`);
            timeoutError.name = "TimeoutError";
            reject(timeoutError);
        }, timeoutInMs);
    });
}


const $40b502f5f0978093$export$3d6343d6ab3191df = {
    supported: undefined
};
class $40b502f5f0978093$export$83588b87edbfa7e0 {
    static create(instanceOrOptions) {
        if (typeof instanceOrOptions?.handle === "function") return instanceOrOptions;
        return new $40b502f5f0978093$export$83588b87edbfa7e0(instanceOrOptions);
    }
    constructor(options){
        if (typeof options === "function") this.configProvider = options().then((opts)=>opts || {});
        else {
            this.config = options ?? {};
            this.configProvider = Promise.resolve(this.config);
        }
        if ($40b502f5f0978093$export$3d6343d6ab3191df.supported === undefined) $40b502f5f0978093$export$3d6343d6ab3191df.supported = Boolean(typeof Request !== "undefined" && "keepalive" in (0, $a469163f402dd6cf$export$72e3afa9ac8966be)("https://[::1]"));
    }
    destroy() {}
    async handle(request, { abortSignal: abortSignal } = {}) {
        if (!this.config) this.config = await this.configProvider;
        const requestTimeoutInMs = this.config.requestTimeout;
        const keepAlive = this.config.keepAlive === true;
        const credentials = this.config.credentials;
        if (abortSignal?.aborted) {
            const abortError = new Error("Request aborted");
            abortError.name = "AbortError";
            return Promise.reject(abortError);
        }
        let path = request.path;
        const queryString = (0, $4fbde2bc3d2a4571$export$6b17a39e52c8ee53)(request.query || {});
        if (queryString) path += `?${queryString}`;
        if (request.fragment) path += `#${request.fragment}`;
        let auth = "";
        if (request.username != null || request.password != null) {
            const username = request.username ?? "";
            const password = request.password ?? "";
            auth = `${username}:${password}@`;
        }
        const { port: port, method: method } = request;
        const url = `${request.protocol}//${auth}${request.hostname}${port ? `:${port}` : ""}${path}`;
        const body = method === "GET" || method === "HEAD" ? undefined : request.body;
        const requestOptions = {
            body: body,
            headers: new Headers(request.headers),
            method: method,
            credentials: credentials
        };
        if (this.config?.cache) requestOptions.cache = this.config.cache;
        if (body) requestOptions.duplex = "half";
        if (typeof AbortController !== "undefined") requestOptions.signal = abortSignal;
        if ($40b502f5f0978093$export$3d6343d6ab3191df.supported) requestOptions.keepalive = keepAlive;
        if (typeof this.config.requestInit === "function") Object.assign(requestOptions, this.config.requestInit(request));
        let removeSignalEventListener = ()=>{};
        const fetchRequest = (0, $a469163f402dd6cf$export$72e3afa9ac8966be)(url, requestOptions);
        const raceOfPromises = [
            fetch(fetchRequest).then((response)=>{
                const fetchHeaders = response.headers;
                const transformedHeaders = {};
                for (const pair of fetchHeaders.entries())transformedHeaders[pair[0]] = pair[1];
                const hasReadableStream = response.body != undefined;
                if (!hasReadableStream) return response.blob().then((body)=>({
                        response: new (0, $719e5a813689e03b$export$1d94dfe0d9d1f1e7)({
                            headers: transformedHeaders,
                            reason: response.statusText,
                            statusCode: response.status,
                            body: body
                        })
                    }));
                return {
                    response: new (0, $719e5a813689e03b$export$1d94dfe0d9d1f1e7)({
                        headers: transformedHeaders,
                        reason: response.statusText,
                        statusCode: response.status,
                        body: response.body
                    })
                };
            }),
            (0, $69898d062bca500c$export$363ac302bdbd807b)(requestTimeoutInMs)
        ];
        if (abortSignal) raceOfPromises.push(new Promise((resolve, reject)=>{
            const onAbort = ()=>{
                const abortError = new Error("Request aborted");
                abortError.name = "AbortError";
                reject(abortError);
            };
            if (typeof abortSignal.addEventListener === "function") {
                const signal = abortSignal;
                signal.addEventListener("abort", onAbort, {
                    once: true
                });
                removeSignalEventListener = ()=>signal.removeEventListener("abort", onAbort);
            } else abortSignal.onabort = onAbort;
        }));
        return Promise.race(raceOfPromises).finally(removeSignalEventListener);
    }
    updateHttpClientConfig(key, value) {
        this.config = undefined;
        this.configProvider = this.configProvider.then((config)=>{
            config[key] = value;
            return config;
        });
    }
    httpHandlerConfigs() {
        return this.config ?? {};
    }
}



const $03d6a1cc7230aa78$export$17bf97b72e307d52 = async (stream)=>{
    if (typeof Blob === "function" && stream instanceof Blob || stream.constructor?.name === "Blob") {
        if (Blob.prototype.arrayBuffer !== undefined) return new Uint8Array(await stream.arrayBuffer());
        return $03d6a1cc7230aa78$var$collectBlob(stream);
    }
    return $03d6a1cc7230aa78$var$collectStream(stream);
};
async function $03d6a1cc7230aa78$var$collectBlob(blob) {
    const base64 = await $03d6a1cc7230aa78$var$readToBase64(blob);
    const arrayBuffer = (0, $7b3498acd0b4495b$export$c537b38001c583b7)(base64);
    return new Uint8Array(arrayBuffer);
}
async function $03d6a1cc7230aa78$var$collectStream(stream) {
    const chunks = [];
    const reader = stream.getReader();
    let isDone = false;
    let length = 0;
    while(!isDone){
        const { done: done, value: value } = await reader.read();
        if (value) {
            chunks.push(value);
            length += value.length;
        }
        isDone = done;
    }
    const collected = new Uint8Array(length);
    let offset = 0;
    for (const chunk of chunks){
        collected.set(chunk, offset);
        offset += chunk.length;
    }
    return collected;
}
function $03d6a1cc7230aa78$var$readToBase64(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>{
            if (reader.readyState !== 2) return reject(new Error("Reader aborted too early"));
            const result = reader.result ?? "";
            const commaIndex = result.indexOf(",");
            const dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
            resolve(result.substring(dataOffset));
        };
        reader.onabort = ()=>reject(new Error("Read aborted"));
        reader.onerror = ()=>reject(reader.error);
        reader.readAsDataURL(blob);
    });
}





const $e3760e64f3fec34b$var$SHORT_TO_HEX = {};
const $e3760e64f3fec34b$var$HEX_TO_SHORT = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    $e3760e64f3fec34b$var$SHORT_TO_HEX[i] = encodedByte;
    $e3760e64f3fec34b$var$HEX_TO_SHORT[encodedByte] = i;
}
function $e3760e64f3fec34b$export$1a8ceedbd5845648(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in $e3760e64f3fec34b$var$HEX_TO_SHORT) out[i / 2] = $e3760e64f3fec34b$var$HEX_TO_SHORT[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
}
function $e3760e64f3fec34b$export$7ea66e3774a60b67(bytes) {
    let out = "";
    for(let i = 0; i < bytes.byteLength; i++)out += $e3760e64f3fec34b$var$SHORT_TO_HEX[bytes[i]];
    return out;
}



const $5de0275d779a366a$export$ac613ff475b69d05 = (stream)=>typeof ReadableStream === "function" && (stream?.constructor?.name === ReadableStream.name || stream instanceof ReadableStream);
const $5de0275d779a366a$export$5bcd6e94ed871c88 = (blob)=>{
    return typeof Blob === "function" && (blob?.constructor?.name === Blob.name || blob instanceof Blob);
};


const $e1addf0b73f33efb$var$ERR_MSG_STREAM_HAS_BEEN_TRANSFORMED = "The stream has already been transformed.";
const $e1addf0b73f33efb$export$5f9760b56bbf9f65 = (stream)=>{
    if (!$e1addf0b73f33efb$var$isBlobInstance(stream) && !(0, $5de0275d779a366a$export$ac613ff475b69d05)(stream)) {
        const name = stream?.__proto__?.constructor?.name || stream;
        throw new Error(`Unexpected stream implementation, expect Blob or ReadableStream, got ${name}`);
    }
    let transformed = false;
    const transformToByteArray = async ()=>{
        if (transformed) throw new Error($e1addf0b73f33efb$var$ERR_MSG_STREAM_HAS_BEEN_TRANSFORMED);
        transformed = true;
        return await (0, $03d6a1cc7230aa78$export$17bf97b72e307d52)(stream);
    };
    const blobToWebStream = (blob)=>{
        if (typeof blob.stream !== "function") throw new Error("Cannot transform payload Blob to web stream. Please make sure the Blob.stream() is polyfilled.\nIf you are using React Native, this API is not yet supported, see: https://react-native.canny.io/feature-requests/p/fetch-streaming-body");
        return blob.stream();
    };
    return Object.assign(stream, {
        transformToByteArray: transformToByteArray,
        transformToString: async (encoding)=>{
            const buf = await transformToByteArray();
            if (encoding === "base64") return (0, $d63237a3fb21a427$export$37cc283d8fbd3462)(buf);
            else if (encoding === "hex") return (0, $e3760e64f3fec34b$export$7ea66e3774a60b67)(buf);
            else if (encoding === undefined || encoding === "utf8" || encoding === "utf-8") return (0, $5a195679de934416$export$b4b216764bb846eb)(buf);
            else if (typeof TextDecoder === "function") return new TextDecoder(encoding).decode(buf);
            else throw new Error("TextDecoder is not available, please make sure polyfill is provided.");
        },
        transformToWebStream: ()=>{
            if (transformed) throw new Error($e1addf0b73f33efb$var$ERR_MSG_STREAM_HAS_BEEN_TRANSFORMED);
            transformed = true;
            if ($e1addf0b73f33efb$var$isBlobInstance(stream)) return blobToWebStream(stream);
            else if ((0, $5de0275d779a366a$export$ac613ff475b69d05)(stream)) return stream;
            else throw new Error(`Cannot transform payload to web stream, got ${stream}`);
        }
    });
};
const $e1addf0b73f33efb$var$isBlobInstance = (stream)=>typeof Blob === "function" && stream instanceof Blob;


async function $5e6c0629f9bc063c$export$e0d279bcdde969f4(stream) {
    if (typeof stream.stream === "function") stream = stream.stream();
    const readableStream = stream;
    return readableStream.tee();
}


async function $f652f80b17073ad4$export$c5bd1fa662e233aa(stream, bytes) {
    let byteLengthCounter = 0;
    const chunks = [];
    const reader = stream.getReader();
    let isDone = false;
    while(!isDone){
        const { done: done, value: value } = await reader.read();
        if (value) {
            chunks.push(value);
            byteLengthCounter += value?.byteLength ?? 0;
        }
        if (byteLengthCounter >= bytes) break;
        isDone = done;
    }
    reader.releaseLock();
    const collected = new Uint8Array(Math.min(bytes, byteLengthCounter));
    let offset = 0;
    for (const chunk of chunks){
        if (chunk.byteLength > collected.byteLength - offset) {
            collected.set(chunk.subarray(0, collected.byteLength - offset), offset);
            break;
        } else collected.set(chunk, offset);
        offset += chunk.length;
    }
    return collected;
}





const $321d45325a303dae$var$ReadableStreamRef = typeof ReadableStream === "function" ? ReadableStream : function() {};
class $321d45325a303dae$export$d89b7ddb391bc480 extends $321d45325a303dae$var$ReadableStreamRef {
}


const $a3347c64f53f0c87$export$6431755c6997f8eb = ({ expectedChecksum: expectedChecksum, checksum: checksum, source: source, checksumSourceLocation: checksumSourceLocation, base64Encoder: base64Encoder })=>{
    if (!(0, $5de0275d779a366a$export$ac613ff475b69d05)(source)) throw new Error(`@smithy/util-stream: unsupported source type ${source?.constructor?.name ?? source} in ChecksumStream.`);
    const encoder = base64Encoder ?? (0, $d63237a3fb21a427$export$37cc283d8fbd3462);
    if (typeof TransformStream !== "function") throw new Error("@smithy/util-stream: unable to instantiate ChecksumStream because API unavailable: ReadableStream/TransformStream.");
    const transform = new TransformStream({
        start () {},
        async transform (chunk, controller) {
            checksum.update(chunk);
            controller.enqueue(chunk);
        },
        async flush (controller) {
            const digest = await checksum.digest();
            const received = encoder(digest);
            if (expectedChecksum !== received) {
                const error = new Error(`Checksum mismatch: expected "${expectedChecksum}" but received "${received}"` + ` in response header "${checksumSourceLocation}".`);
                controller.error(error);
            } else controller.terminate();
        }
    });
    source.pipeThrough(transform);
    const readable = transform.readable;
    Object.setPrototypeOf(readable, (0, $321d45325a303dae$export$d89b7ddb391bc480).prototype);
    return readable;
};





const $7667c5ed780ba41a$export$3392bcddb824e5ca = async (streamBody = new Uint8Array(), context)=>{
    if (streamBody instanceof Uint8Array) return (0, $e8c74f5764f57928$export$1465fbad93f83f0a).mutate(streamBody);
    if (!streamBody) return (0, $e8c74f5764f57928$export$1465fbad93f83f0a).mutate(new Uint8Array());
    const fromContext = context.streamCollector(streamBody);
    return (0, $e8c74f5764f57928$export$1465fbad93f83f0a).mutate(await fromContext);
};


function $6086d4a2e87e67e8$export$7640f3c16fe7f54b(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}




const $369e037e4f16f19c$export$405ac9a9ce1cbd80 = (resolvedPath, input, memberName, labelValueProvider, uriLabel, isGreedyLabel)=>{
    if (input != null && input[memberName] !== undefined) {
        const labelValue = labelValueProvider();
        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: " + memberName + ".");
        resolvedPath = resolvedPath.replace(uriLabel, isGreedyLabel ? labelValue.split("/").map((segment)=>(0, $6086d4a2e87e67e8$export$7640f3c16fe7f54b)(segment)).join("/") : (0, $6086d4a2e87e67e8$export$7640f3c16fe7f54b)(labelValue));
    } else throw new Error("No value provided for input HTTP label: " + memberName + ".");
    return resolvedPath;
};


function $f2d3bbadd4b0e82a$export$9f1f89e694d26cd0(input, context) {
    return new $f2d3bbadd4b0e82a$export$e63ecf257fa6a994(input, context);
}
class $f2d3bbadd4b0e82a$export$e63ecf257fa6a994 {
    constructor(input, context){
        this.input = input;
        this.context = context;
        this.query = {};
        this.method = "";
        this.headers = {};
        this.path = "";
        this.body = null;
        this.hostname = "";
        this.resolvePathStack = [];
    }
    async build() {
        const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await this.context.endpoint();
        this.path = basePath;
        for (const resolvePath of this.resolvePathStack)resolvePath(this.path);
        return new (0, $36c92c5bbc6e0688$export$7587955500404ec3)({
            protocol: protocol,
            hostname: this.hostname || hostname,
            port: port,
            method: this.method,
            path: this.path,
            query: this.query,
            body: this.body,
            headers: this.headers
        });
    }
    hn(hostname) {
        this.hostname = hostname;
        return this;
    }
    bp(uriLabel) {
        this.resolvePathStack.push((basePath)=>{
            this.path = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + uriLabel;
        });
        return this;
    }
    p(memberName, labelValueProvider, uriLabel, isGreedyLabel) {
        this.resolvePathStack.push((path)=>{
            this.path = (0, $369e037e4f16f19c$export$405ac9a9ce1cbd80)(path, this.input, memberName, labelValueProvider, uriLabel, isGreedyLabel);
        });
        return this;
    }
    h(headers) {
        this.headers = headers;
        return this;
    }
    q(query) {
        this.query = query;
        return this;
    }
    b(body) {
        this.body = body;
        return this;
    }
    m(method) {
        this.method = method;
        return this;
    }
}







function $419fd94dbbd9692a$export$69482ba716363b6f(context, feature, value) {
    if (!context.__smithy_context) context.__smithy_context = {
        features: {}
    };
    else if (!context.__smithy_context.features) context.__smithy_context.features = {};
    context.__smithy_context.features[feature] = value;
}


class $99ebb391854b554e$export$67f43b78065c5551 {
    constructor(config){
        this.authSchemes = new Map();
        for (const [key, value] of Object.entries(config))if (value !== undefined) this.authSchemes.set(key, value);
    }
    getIdentityProvider(schemeId) {
        return this.authSchemes.get(schemeId);
    }
}




class $9e822a7a67665203$export$823b895391979983 {
    async sign(httpRequest, identity, signingProperties) {
        if (!signingProperties) throw new Error("request could not be signed with `apiKey` since the `name` and `in` signer properties are missing");
        if (!signingProperties.name) throw new Error("request could not be signed with `apiKey` since the `name` signer property is missing");
        if (!signingProperties.in) throw new Error("request could not be signed with `apiKey` since the `in` signer property is missing");
        if (!identity.apiKey) throw new Error("request could not be signed with `apiKey` since the `apiKey` is not defined");
        const clonedRequest = (0, $36c92c5bbc6e0688$export$7587955500404ec3).clone(httpRequest);
        if (signingProperties.in === (0, $cad43ee6de694c1d$export$8c5ca875010cb2a6).QUERY) clonedRequest.query[signingProperties.name] = identity.apiKey;
        else if (signingProperties.in === (0, $cad43ee6de694c1d$export$8c5ca875010cb2a6).HEADER) clonedRequest.headers[signingProperties.name] = signingProperties.scheme ? `${signingProperties.scheme} ${identity.apiKey}` : identity.apiKey;
        else throw new Error("request can only be signed with `apiKey` locations `query` or `header`, but found: `" + signingProperties.in + "`");
        return clonedRequest;
    }
}



class $afc44d10cb677a64$export$f646f7f27c38a496 {
    async sign(httpRequest, identity, signingProperties) {
        const clonedRequest = (0, $36c92c5bbc6e0688$export$7587955500404ec3).clone(httpRequest);
        if (!identity.token) throw new Error("request could not be signed with `token` since the `token` is not defined");
        clonedRequest.headers["Authorization"] = `Bearer ${identity.token}`;
        return clonedRequest;
    }
}


class $68474e33de95c781$export$19622a6daa7bca6e {
    async sign(httpRequest, identity, signingProperties) {
        return httpRequest;
    }
}




const $511ab404415c7a32$export$4c74afac7567edb5 = (expirationMs)=>(identity)=>$511ab404415c7a32$export$5fef7ca5b4791fa9(identity) && identity.expiration.getTime() - Date.now() < expirationMs;
const $511ab404415c7a32$export$1d503351280d1918 = 300000;
const $511ab404415c7a32$export$42a11a4dafc8f476 = $511ab404415c7a32$export$4c74afac7567edb5($511ab404415c7a32$export$1d503351280d1918);
const $511ab404415c7a32$export$5fef7ca5b4791fa9 = (identity)=>identity.expiration !== undefined;
const $511ab404415c7a32$export$b258763a05c20e85 = (provider, isExpired, requiresRefresh)=>{
    if (provider === undefined) return undefined;
    const normalizedProvider = typeof provider !== "function" ? async ()=>Promise.resolve(provider) : provider;
    let resolved;
    let pending;
    let hasResult;
    let isConstant = false;
    const coalesceProvider = async (options)=>{
        if (!pending) pending = normalizedProvider(options);
        try {
            resolved = await pending;
            hasResult = true;
            isConstant = false;
        } finally{
            pending = undefined;
        }
        return resolved;
    };
    if (isExpired === undefined) return async (options)=>{
        if (!hasResult || options?.forceRefresh) resolved = await coalesceProvider(options);
        return resolved;
    };
    return async (options)=>{
        if (!hasResult || options?.forceRefresh) resolved = await coalesceProvider(options);
        if (isConstant) return resolved;
        if (!requiresRefresh(resolved)) {
            isConstant = true;
            return resolved;
        }
        if (isExpired(resolved)) {
            await coalesceProvider(options);
            return resolved;
        }
        return resolved;
    };
};






const $3b038e7801e78d35$export$3be8671e7272c26d = undefined;
function $3b038e7801e78d35$var$isValidUserAgentAppId(appId) {
    if (appId === undefined) return true;
    return typeof appId === "string" && appId.length <= 50;
}
function $3b038e7801e78d35$export$ec9a2d5663958cb(input) {
    const normalizedAppIdProvider = (0, $7a73b05cc4d89640$export$b1276c07738d6325)(input.userAgentAppId ?? $3b038e7801e78d35$export$3be8671e7272c26d);
    return {
        ...input,
        customUserAgent: typeof input.customUserAgent === "string" ? [
            [
                input.customUserAgent
            ]
        ] : input.customUserAgent,
        userAgentAppId: async ()=>{
            const appId = await normalizedAppIdProvider();
            if (!$3b038e7801e78d35$var$isValidUserAgentAppId(appId)) {
                const logger = input.logger?.constructor?.name === "NoOpLogger" || !input.logger ? console : input.logger;
                if (typeof appId !== "string") logger?.warn("userAgentAppId must be a string or undefined.");
                else if (appId.length > 50) logger?.warn("The provided userAgentAppId exceeds the maximum length of 50 characters.");
            }
            return appId;
        }
    };
}


class $d06f12251068eb72$export$262eb2e4804ef909 {
    constructor({ size: size, params: params }){
        this.data = new Map();
        this.parameters = [];
        this.capacity = size ?? 50;
        if (params) this.parameters = params;
    }
    get(endpointParams, resolver) {
        const key = this.hash(endpointParams);
        if (key === false) return resolver();
        if (!this.data.has(key)) {
            if (this.data.size > this.capacity + 10) {
                const keys = this.data.keys();
                let i = 0;
                while(true){
                    const { value: value, done: done } = keys.next();
                    this.data.delete(value);
                    if (done || ++i > 10) break;
                }
            }
            this.data.set(key, resolver());
        }
        return this.data.get(key);
    }
    size() {
        return this.data.size;
    }
    hash(endpointParams) {
        let buffer = "";
        const { parameters: parameters } = this;
        if (parameters.length === 0) return false;
        for (const param of parameters){
            const val = String(endpointParams[param] ?? "");
            if (val.includes("|;")) return false;
            buffer += val + "|;";
        }
        return buffer;
    }
}


const $f2453320e8b91997$var$IP_V4_REGEX = new RegExp(`^(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}$`);
const $f2453320e8b91997$export$2c835f0fe38d2e0e = (value)=>$f2453320e8b91997$var$IP_V4_REGEX.test(value) || value.startsWith("[") && value.endsWith("]");


const $dca6432297e3b66b$var$VALID_HOST_LABEL_REGEX = new RegExp(`^(?!.*-$)(?!-)[a-zA-Z0-9-]{1,63}$`);
const $dca6432297e3b66b$export$8a024457acd8bb49 = (value, allowSubDomains = false)=>{
    if (!allowSubDomains) return $dca6432297e3b66b$var$VALID_HOST_LABEL_REGEX.test(value);
    const labels = value.split(".");
    for (const label of labels){
        if (!$dca6432297e3b66b$export$8a024457acd8bb49(label)) return false;
    }
    return true;
};


const $91b7ba976acbb024$export$2614fba0847da171 = {};


const $59c95b0713c88c91$export$2a09d6727e5ecede = "endpoints";


function $7e2ba9d546b18d72$export$7b48b8905f46d631(input) {
    if (typeof input !== "object" || input == null) return input;
    if ("ref" in input) return `$${$7e2ba9d546b18d72$export$7b48b8905f46d631(input.ref)}`;
    if ("fn" in input) return `${input.fn}(${(input.argv || []).map($7e2ba9d546b18d72$export$7b48b8905f46d631).join(", ")})`;
    return JSON.stringify(input, null, 2);
}




class $a8b01263c2e6b159$export$603f31e9980bccaf extends Error {
    constructor(message){
        super(message);
        this.name = "EndpointError";
    }
}























const $49ba5251d5f4f946$export$6608cbdc537206b3 = (value1, value2)=>value1 === value2;




const $871c7c7969f75f48$export$e8fa1ee343c456a5 = (path)=>{
    const parts = path.split(".");
    const pathList = [];
    for (const part of parts){
        const squareBracketIndex = part.indexOf("[");
        if (squareBracketIndex !== -1) {
            if (part.indexOf("]") !== part.length - 1) throw new (0, $a8b01263c2e6b159$export$603f31e9980bccaf)(`Path: '${path}' does not end with ']'`);
            const arrayIndex = part.slice(squareBracketIndex + 1, -1);
            if (Number.isNaN(parseInt(arrayIndex))) throw new (0, $a8b01263c2e6b159$export$603f31e9980bccaf)(`Invalid array index: '${arrayIndex}' in path: '${path}'`);
            if (squareBracketIndex !== 0) pathList.push(part.slice(0, squareBracketIndex));
            pathList.push(arrayIndex);
        } else pathList.push(part);
    }
    return pathList;
};


const $7652d5aef8695efc$export$6a93fe6b2b4c71a0 = (value, path)=>(0, $871c7c7969f75f48$export$e8fa1ee343c456a5)(path).reduce((acc, index)=>{
        if (typeof acc !== "object") throw new (0, $a8b01263c2e6b159$export$603f31e9980bccaf)(`Index '${index}' in '${path}' not found in '${JSON.stringify(value)}'`);
        else if (Array.isArray(acc)) return acc[parseInt(index)];
        return acc[index];
    }, value);


const $6d972076f74ed027$export$6750766a7c7ec627 = (value)=>value != null;



const $9a2c031a871d4316$export$6003a5f097c73977 = (value)=>!value;




const $e7efc185cc9e13cb$var$DEFAULT_PORTS = {
    [(0, $b5efabe4788fc71a$export$b141d049add1dcb5).HTTP]: 80,
    [(0, $b5efabe4788fc71a$export$b141d049add1dcb5).HTTPS]: 443
};
const $e7efc185cc9e13cb$export$4b3d9a5bae55976 = (value)=>{
    const whatwgURL = (()=>{
        try {
            if (value instanceof URL) return value;
            if (typeof value === "object" && "hostname" in value) {
                const { hostname: hostname, port: port, protocol: protocol = "", path: path = "", query: query = {} } = value;
                const url = new URL(`${protocol}//${hostname}${port ? `:${port}` : ""}${path}`);
                url.search = Object.entries(query).map(([k, v])=>`${k}=${v}`).join("&");
                return url;
            }
            return new URL(value);
        } catch (error) {
            return null;
        }
    })();
    if (!whatwgURL) {
        console.error(`Unable to parse ${JSON.stringify(value)} as a whatwg URL.`);
        return null;
    }
    const urlString = whatwgURL.href;
    const { host: host, hostname: hostname, pathname: pathname, protocol: protocol, search: search } = whatwgURL;
    if (search) return null;
    const scheme = protocol.slice(0, -1);
    if (!Object.values((0, $b5efabe4788fc71a$export$b141d049add1dcb5)).includes(scheme)) return null;
    const isIp = (0, $f2453320e8b91997$export$2c835f0fe38d2e0e)(hostname);
    const inputContainsDefaultPort = urlString.includes(`${host}:${$e7efc185cc9e13cb$var$DEFAULT_PORTS[scheme]}`) || typeof value === "string" && value.includes(`${host}:${$e7efc185cc9e13cb$var$DEFAULT_PORTS[scheme]}`);
    const authority = `${host}${inputContainsDefaultPort ? `:${$e7efc185cc9e13cb$var$DEFAULT_PORTS[scheme]}` : ``}`;
    return {
        scheme: scheme,
        authority: authority,
        path: pathname,
        normalizedPath: pathname.endsWith("/") ? pathname : `${pathname}/`,
        isIp: isIp
    };
};


const $7f3d4a501c9608c5$export$f8f73f238947765e = (value1, value2)=>value1 === value2;


const $d7e08d594a346eac$export$662d3818631fba36 = (input, start, stop, reverse)=>{
    if (start >= stop || input.length < stop) return null;
    if (!reverse) return input.substring(start, stop);
    return input.substring(input.length - stop, input.length - start);
};


const $5fdcdb72cb463699$export$1ea6cdab375898b5 = (value)=>encodeURIComponent(value).replace(/[!*'()]/g, (c)=>`%${c.charCodeAt(0).toString(16).toUpperCase()}`);




const $2dba649d08ec7d45$export$fffca6040ff170c9 = {
    booleanEquals: $49ba5251d5f4f946$export$6608cbdc537206b3,
    getAttr: $7652d5aef8695efc$export$6a93fe6b2b4c71a0,
    isSet: $6d972076f74ed027$export$6750766a7c7ec627,
    isValidHostLabel: $dca6432297e3b66b$export$8a024457acd8bb49,
    not: $9a2c031a871d4316$export$6003a5f097c73977,
    parseURL: $e7efc185cc9e13cb$export$4b3d9a5bae55976,
    stringEquals: $7f3d4a501c9608c5$export$f8f73f238947765e,
    substring: $d7e08d594a346eac$export$662d3818631fba36,
    uriEncode: $5fdcdb72cb463699$export$1ea6cdab375898b5
};





const $6f6a9c5d95c1822a$export$c77ca0e5a2c5469c = (template, options)=>{
    const evaluatedTemplateArr = [];
    const templateContext = {
        ...options.endpointParams,
        ...options.referenceRecord
    };
    let currentIndex = 0;
    while(currentIndex < template.length){
        const openingBraceIndex = template.indexOf("{", currentIndex);
        if (openingBraceIndex === -1) {
            evaluatedTemplateArr.push(template.slice(currentIndex));
            break;
        }
        evaluatedTemplateArr.push(template.slice(currentIndex, openingBraceIndex));
        const closingBraceIndex = template.indexOf("}", openingBraceIndex);
        if (closingBraceIndex === -1) {
            evaluatedTemplateArr.push(template.slice(openingBraceIndex));
            break;
        }
        if (template[openingBraceIndex + 1] === "{" && template[closingBraceIndex + 1] === "}") {
            evaluatedTemplateArr.push(template.slice(openingBraceIndex + 1, closingBraceIndex));
            currentIndex = closingBraceIndex + 2;
        }
        const parameterName = template.substring(openingBraceIndex + 1, closingBraceIndex);
        if (parameterName.includes("#")) {
            const [refName, attrName] = parameterName.split("#");
            evaluatedTemplateArr.push((0, $7652d5aef8695efc$export$6a93fe6b2b4c71a0)(templateContext[refName], attrName));
        } else evaluatedTemplateArr.push(templateContext[parameterName]);
        currentIndex = closingBraceIndex + 1;
    }
    return evaluatedTemplateArr.join("");
};


const $ece9c216472ac016$export$812bd59fe014e418 = ({ ref: ref }, options)=>{
    const referenceRecord = {
        ...options.endpointParams,
        ...options.referenceRecord
    };
    return referenceRecord[ref];
};


const $f4507d396db6138f$export$3191fa0ae67b450c = (obj, keyName, options)=>{
    if (typeof obj === "string") return (0, $6f6a9c5d95c1822a$export$c77ca0e5a2c5469c)(obj, options);
    else if (obj["fn"]) return (0, $73eb0b921d905940$export$d883fbf232f0d35a)(obj, options);
    else if (obj["ref"]) return (0, $ece9c216472ac016$export$812bd59fe014e418)(obj, options);
    throw new (0, $a8b01263c2e6b159$export$603f31e9980bccaf)(`'${keyName}': ${String(obj)} is not a string, function or reference.`);
};


const $73eb0b921d905940$export$d883fbf232f0d35a = ({ fn: fn, argv: argv }, options)=>{
    const evaluatedArgs = argv.map((arg)=>[
            "boolean",
            "number"
        ].includes(typeof arg) ? arg : (0, $f4507d396db6138f$export$3191fa0ae67b450c)(arg, "arg", options));
    const fnSegments = fn.split(".");
    if (fnSegments[0] in (0, $91b7ba976acbb024$export$2614fba0847da171) && fnSegments[1] != null) return (0, $91b7ba976acbb024$export$2614fba0847da171)[fnSegments[0]][fnSegments[1]](...evaluatedArgs);
    return (0, $2dba649d08ec7d45$export$fffca6040ff170c9)[fn](...evaluatedArgs);
};


const $bbfea82b55452616$export$6695392473e235ae = ({ assign: assign, ...fnArgs }, options)=>{
    if (assign && assign in options.referenceRecord) throw new (0, $a8b01263c2e6b159$export$603f31e9980bccaf)(`'${assign}' is already defined in Reference Record.`);
    const value = (0, $73eb0b921d905940$export$d883fbf232f0d35a)(fnArgs, options);
    options.logger?.debug?.(`${(0, $59c95b0713c88c91$export$2a09d6727e5ecede)} evaluateCondition: ${(0, $7e2ba9d546b18d72$export$7b48b8905f46d631)(fnArgs)} = ${(0, $7e2ba9d546b18d72$export$7b48b8905f46d631)(value)}`);
    return {
        result: value === "" ? true : !!value,
        ...assign != null && {
            toAssign: {
                name: assign,
                value: value
            }
        }
    };
};


const $5b776ba0f5656d41$export$bad219652748f1f3 = (conditions = [], options)=>{
    const conditionsReferenceRecord = {};
    for (const condition of conditions){
        const { result: result, toAssign: toAssign } = (0, $bbfea82b55452616$export$6695392473e235ae)(condition, {
            ...options,
            referenceRecord: {
                ...options.referenceRecord,
                ...conditionsReferenceRecord
            }
        });
        if (!result) return {
            result: result
        };
        if (toAssign) {
            conditionsReferenceRecord[toAssign.name] = toAssign.value;
            options.logger?.debug?.(`${(0, $59c95b0713c88c91$export$2a09d6727e5ecede)} assign: ${toAssign.name} := ${(0, $7e2ba9d546b18d72$export$7b48b8905f46d631)(toAssign.value)}`);
        }
    }
    return {
        result: true,
        referenceRecord: conditionsReferenceRecord
    };
};




const $046cb81422a89112$export$479dec716600cbb = (headers, options)=>Object.entries(headers).reduce((acc, [headerKey, headerVal])=>({
            ...acc,
            [headerKey]: headerVal.map((headerValEntry)=>{
                const processedExpr = (0, $f4507d396db6138f$export$3191fa0ae67b450c)(headerValEntry, "Header value entry", options);
                if (typeof processedExpr !== "string") throw new (0, $a8b01263c2e6b159$export$603f31e9980bccaf)(`Header '${headerKey}' value '${processedExpr}' is not a string`);
                return processedExpr;
            })
        }), {});





const $b8cb14c305491f4a$export$39bc8a0c7360c2f4 = (property, options)=>{
    if (Array.isArray(property)) return property.map((propertyEntry)=>$b8cb14c305491f4a$export$39bc8a0c7360c2f4(propertyEntry, options));
    switch(typeof property){
        case "string":
            return (0, $6f6a9c5d95c1822a$export$c77ca0e5a2c5469c)(property, options);
        case "object":
            if (property === null) throw new (0, $a8b01263c2e6b159$export$603f31e9980bccaf)(`Unexpected endpoint property: ${property}`);
            return (0, $c07b51f2d78f90db$export$f7b44341c2929056)(property, options);
        case "boolean":
            return property;
        default:
            throw new (0, $a8b01263c2e6b159$export$603f31e9980bccaf)(`Unexpected endpoint property type: ${typeof property}`);
    }
};


const $c07b51f2d78f90db$export$f7b44341c2929056 = (properties, options)=>Object.entries(properties).reduce((acc, [propertyKey, propertyVal])=>({
            ...acc,
            [propertyKey]: (0, $b8cb14c305491f4a$export$39bc8a0c7360c2f4)(propertyVal, options)
        }), {});




const $dd7dd5a779d54a82$export$c54f5a49b5be9709 = (endpointUrl, options)=>{
    const expression = (0, $f4507d396db6138f$export$3191fa0ae67b450c)(endpointUrl, "Endpoint URL", options);
    if (typeof expression === "string") try {
        return new URL(expression);
    } catch (error) {
        console.error(`Failed to construct URL with ${expression}`, error);
        throw error;
    }
    throw new (0, $a8b01263c2e6b159$export$603f31e9980bccaf)(`Endpoint URL must be a string, got ${typeof expression}`);
};


const $9182fab55436e91f$export$791799461674b1cb = (endpointRule, options)=>{
    const { conditions: conditions, endpoint: endpoint } = endpointRule;
    const { result: result, referenceRecord: referenceRecord } = (0, $5b776ba0f5656d41$export$bad219652748f1f3)(conditions, options);
    if (!result) return;
    const endpointRuleOptions = {
        ...options,
        referenceRecord: {
            ...options.referenceRecord,
            ...referenceRecord
        }
    };
    const { url: url, properties: properties, headers: headers } = endpoint;
    options.logger?.debug?.(`${(0, $59c95b0713c88c91$export$2a09d6727e5ecede)} Resolving endpoint from template: ${(0, $7e2ba9d546b18d72$export$7b48b8905f46d631)(endpoint)}`);
    return {
        ...headers != undefined && {
            headers: (0, $046cb81422a89112$export$479dec716600cbb)(headers, endpointRuleOptions)
        },
        ...properties != undefined && {
            properties: (0, $c07b51f2d78f90db$export$f7b44341c2929056)(properties, endpointRuleOptions)
        },
        url: (0, $dd7dd5a779d54a82$export$c54f5a49b5be9709)(url, endpointRuleOptions)
    };
};





const $4803af5f0da49534$export$a36dfbc7e1fb8626 = (errorRule, options)=>{
    const { conditions: conditions, error: error } = errorRule;
    const { result: result, referenceRecord: referenceRecord } = (0, $5b776ba0f5656d41$export$bad219652748f1f3)(conditions, options);
    if (!result) return;
    throw new (0, $a8b01263c2e6b159$export$603f31e9980bccaf)((0, $f4507d396db6138f$export$3191fa0ae67b450c)(error, "Error", {
        ...options,
        referenceRecord: {
            ...options.referenceRecord,
            ...referenceRecord
        }
    }));
};




const $e7d3a46e285edbf0$export$2e518b103c26ca79 = (treeRule, options)=>{
    const { conditions: conditions, rules: rules } = treeRule;
    const { result: result, referenceRecord: referenceRecord } = (0, $5b776ba0f5656d41$export$bad219652748f1f3)(conditions, options);
    if (!result) return;
    return (0, $a062347c001ac937$export$cd6fa289eb934f12)(rules, {
        ...options,
        referenceRecord: {
            ...options.referenceRecord,
            ...referenceRecord
        }
    });
};


const $a062347c001ac937$export$cd6fa289eb934f12 = (rules, options)=>{
    for (const rule of rules){
        if (rule.type === "endpoint") {
            const endpointOrUndefined = (0, $9182fab55436e91f$export$791799461674b1cb)(rule, options);
            if (endpointOrUndefined) return endpointOrUndefined;
        } else if (rule.type === "error") (0, $4803af5f0da49534$export$a36dfbc7e1fb8626)(rule, options);
        else if (rule.type === "tree") {
            const endpointOrUndefined = (0, $e7d3a46e285edbf0$export$2e518b103c26ca79)(rule, options);
            if (endpointOrUndefined) return endpointOrUndefined;
        } else throw new (0, $a8b01263c2e6b159$export$603f31e9980bccaf)(`Unknown endpoint rule: ${rule}`);
    }
    throw new (0, $a8b01263c2e6b159$export$603f31e9980bccaf)(`Rules evaluation failed`);
};




const $c21f7418bd0df18f$export$48b88e4e5ecac119 = (ruleSetObject, options)=>{
    const { endpointParams: endpointParams, logger: logger } = options;
    const { parameters: parameters, rules: rules } = ruleSetObject;
    options.logger?.debug?.(`${(0, $59c95b0713c88c91$export$2a09d6727e5ecede)} Initial EndpointParams: ${(0, $7e2ba9d546b18d72$export$7b48b8905f46d631)(endpointParams)}`);
    const paramsWithDefault = Object.entries(parameters).filter(([, v])=>v.default != null).map(([k, v])=>[
            k,
            v.default
        ]);
    if (paramsWithDefault.length > 0) for (const [paramKey, paramDefaultValue] of paramsWithDefault)endpointParams[paramKey] = endpointParams[paramKey] ?? paramDefaultValue;
    const requiredParams = Object.entries(parameters).filter(([, v])=>v.required).map(([k])=>k);
    for (const requiredParam of requiredParams){
        if (endpointParams[requiredParam] == null) throw new (0, $a8b01263c2e6b159$export$603f31e9980bccaf)(`Missing required parameter: '${requiredParam}'`);
    }
    const endpoint = (0, $a062347c001ac937$export$cd6fa289eb934f12)(rules, {
        endpointParams: endpointParams,
        logger: logger,
        referenceRecord: {}
    });
    options.logger?.debug?.(`${(0, $59c95b0713c88c91$export$2a09d6727e5ecede)} Resolved endpoint: ${(0, $7e2ba9d546b18d72$export$7b48b8905f46d631)(endpoint)}`);
    return endpoint;
};









const $6c9f47b4fb4832b9$export$6b6a3f4e857868ec = (value, allowSubDomains = false)=>{
    if (allowSubDomains) {
        for (const label of value.split(".")){
            if (!$6c9f47b4fb4832b9$export$6b6a3f4e857868ec(label)) return false;
        }
        return true;
    }
    if (!(0, $dca6432297e3b66b$export$8a024457acd8bb49)(value)) return false;
    if (value.length < 3 || value.length > 63) return false;
    if (value !== value.toLowerCase()) return false;
    if ((0, $f2453320e8b91997$export$2c835f0fe38d2e0e)(value)) return false;
    return true;
};


const $d166b3152ae24c03$var$ARN_DELIMITER = ":";
const $d166b3152ae24c03$var$RESOURCE_DELIMITER = "/";
const $d166b3152ae24c03$export$ec6a98ce8737fc2c = (value)=>{
    const segments = value.split($d166b3152ae24c03$var$ARN_DELIMITER);
    if (segments.length < 6) return null;
    const [arn, partition, service, region, accountId, ...resourcePath] = segments;
    if (arn !== "arn" || partition === "" || service === "" || resourcePath.join($d166b3152ae24c03$var$ARN_DELIMITER) === "") return null;
    const resourceId = resourcePath.map((resource)=>resource.split($d166b3152ae24c03$var$RESOURCE_DELIMITER)).flat();
    return {
        partition: partition,
        service: service,
        region: region,
        accountId: accountId,
        resourceId: resourceId
    };
};


var $6f96b9be77d8b3e0$exports = {};
$6f96b9be77d8b3e0$exports = JSON.parse("{\"partitions\":[{\"id\":\"aws\",\"outputs\":{\"dnsSuffix\":\"amazonaws.com\",\"dualStackDnsSuffix\":\"api.aws\",\"implicitGlobalRegion\":\"us-east-1\",\"name\":\"aws\",\"supportsDualStack\":true,\"supportsFIPS\":true},\"regionRegex\":\"^(us|eu|ap|sa|ca|me|af|il|mx)\\\\-\\\\w+\\\\-\\\\d+$\",\"regions\":{\"af-south-1\":{\"description\":\"Africa (Cape Town)\"},\"ap-east-1\":{\"description\":\"Asia Pacific (Hong Kong)\"},\"ap-northeast-1\":{\"description\":\"Asia Pacific (Tokyo)\"},\"ap-northeast-2\":{\"description\":\"Asia Pacific (Seoul)\"},\"ap-northeast-3\":{\"description\":\"Asia Pacific (Osaka)\"},\"ap-south-1\":{\"description\":\"Asia Pacific (Mumbai)\"},\"ap-south-2\":{\"description\":\"Asia Pacific (Hyderabad)\"},\"ap-southeast-1\":{\"description\":\"Asia Pacific (Singapore)\"},\"ap-southeast-2\":{\"description\":\"Asia Pacific (Sydney)\"},\"ap-southeast-3\":{\"description\":\"Asia Pacific (Jakarta)\"},\"ap-southeast-4\":{\"description\":\"Asia Pacific (Melbourne)\"},\"ap-southeast-5\":{\"description\":\"Asia Pacific (Malaysia)\"},\"ap-southeast-7\":{\"description\":\"Asia Pacific (Thailand)\"},\"aws-global\":{\"description\":\"AWS Standard global region\"},\"ca-central-1\":{\"description\":\"Canada (Central)\"},\"ca-west-1\":{\"description\":\"Canada West (Calgary)\"},\"eu-central-1\":{\"description\":\"Europe (Frankfurt)\"},\"eu-central-2\":{\"description\":\"Europe (Zurich)\"},\"eu-north-1\":{\"description\":\"Europe (Stockholm)\"},\"eu-south-1\":{\"description\":\"Europe (Milan)\"},\"eu-south-2\":{\"description\":\"Europe (Spain)\"},\"eu-west-1\":{\"description\":\"Europe (Ireland)\"},\"eu-west-2\":{\"description\":\"Europe (London)\"},\"eu-west-3\":{\"description\":\"Europe (Paris)\"},\"il-central-1\":{\"description\":\"Israel (Tel Aviv)\"},\"me-central-1\":{\"description\":\"Middle East (UAE)\"},\"me-south-1\":{\"description\":\"Middle East (Bahrain)\"},\"sa-east-1\":{\"description\":\"South America (Sao Paulo)\"},\"us-east-1\":{\"description\":\"US East (N. Virginia)\"},\"us-east-2\":{\"description\":\"US East (Ohio)\"},\"us-west-1\":{\"description\":\"US West (N. California)\"},\"us-west-2\":{\"description\":\"US West (Oregon)\"}}},{\"id\":\"aws-cn\",\"outputs\":{\"dnsSuffix\":\"amazonaws.com.cn\",\"dualStackDnsSuffix\":\"api.amazonwebservices.com.cn\",\"implicitGlobalRegion\":\"cn-northwest-1\",\"name\":\"aws-cn\",\"supportsDualStack\":true,\"supportsFIPS\":true},\"regionRegex\":\"^cn\\\\-\\\\w+\\\\-\\\\d+$\",\"regions\":{\"aws-cn-global\":{\"description\":\"AWS China global region\"},\"cn-north-1\":{\"description\":\"China (Beijing)\"},\"cn-northwest-1\":{\"description\":\"China (Ningxia)\"}}},{\"id\":\"aws-us-gov\",\"outputs\":{\"dnsSuffix\":\"amazonaws.com\",\"dualStackDnsSuffix\":\"api.aws\",\"implicitGlobalRegion\":\"us-gov-west-1\",\"name\":\"aws-us-gov\",\"supportsDualStack\":true,\"supportsFIPS\":true},\"regionRegex\":\"^us\\\\-gov\\\\-\\\\w+\\\\-\\\\d+$\",\"regions\":{\"aws-us-gov-global\":{\"description\":\"AWS GovCloud (US) global region\"},\"us-gov-east-1\":{\"description\":\"AWS GovCloud (US-East)\"},\"us-gov-west-1\":{\"description\":\"AWS GovCloud (US-West)\"}}},{\"id\":\"aws-iso\",\"outputs\":{\"dnsSuffix\":\"c2s.ic.gov\",\"dualStackDnsSuffix\":\"c2s.ic.gov\",\"implicitGlobalRegion\":\"us-iso-east-1\",\"name\":\"aws-iso\",\"supportsDualStack\":false,\"supportsFIPS\":true},\"regionRegex\":\"^us\\\\-iso\\\\-\\\\w+\\\\-\\\\d+$\",\"regions\":{\"aws-iso-global\":{\"description\":\"AWS ISO (US) global region\"},\"us-iso-east-1\":{\"description\":\"US ISO East\"},\"us-iso-west-1\":{\"description\":\"US ISO WEST\"}}},{\"id\":\"aws-iso-b\",\"outputs\":{\"dnsSuffix\":\"sc2s.sgov.gov\",\"dualStackDnsSuffix\":\"sc2s.sgov.gov\",\"implicitGlobalRegion\":\"us-isob-east-1\",\"name\":\"aws-iso-b\",\"supportsDualStack\":false,\"supportsFIPS\":true},\"regionRegex\":\"^us\\\\-isob\\\\-\\\\w+\\\\-\\\\d+$\",\"regions\":{\"aws-iso-b-global\":{\"description\":\"AWS ISOB (US) global region\"},\"us-isob-east-1\":{\"description\":\"US ISOB East (Ohio)\"}}},{\"id\":\"aws-iso-e\",\"outputs\":{\"dnsSuffix\":\"cloud.adc-e.uk\",\"dualStackDnsSuffix\":\"cloud.adc-e.uk\",\"implicitGlobalRegion\":\"eu-isoe-west-1\",\"name\":\"aws-iso-e\",\"supportsDualStack\":false,\"supportsFIPS\":true},\"regionRegex\":\"^eu\\\\-isoe\\\\-\\\\w+\\\\-\\\\d+$\",\"regions\":{\"eu-isoe-west-1\":{\"description\":\"EU ISOE West\"}}},{\"id\":\"aws-iso-f\",\"outputs\":{\"dnsSuffix\":\"csp.hci.ic.gov\",\"dualStackDnsSuffix\":\"csp.hci.ic.gov\",\"implicitGlobalRegion\":\"us-isof-south-1\",\"name\":\"aws-iso-f\",\"supportsDualStack\":false,\"supportsFIPS\":true},\"regionRegex\":\"^us\\\\-isof\\\\-\\\\w+\\\\-\\\\d+$\",\"regions\":{}}],\"version\":\"1.1\"}");


let $2c1505ef34094ddf$var$selectedPartitionsInfo = (0, (/*@__PURE__*/$parcel$interopDefault($6f96b9be77d8b3e0$exports)));
let $2c1505ef34094ddf$var$selectedUserAgentPrefix = "";
const $2c1505ef34094ddf$export$b29f828819edca8d = (value)=>{
    const { partitions: partitions } = $2c1505ef34094ddf$var$selectedPartitionsInfo;
    for (const partition of partitions){
        const { regions: regions, outputs: outputs } = partition;
        for (const [region, regionData] of Object.entries(regions)){
            if (region === value) return {
                ...outputs,
                ...regionData
            };
        }
    }
    for (const partition of partitions){
        const { regionRegex: regionRegex, outputs: outputs } = partition;
        if (new RegExp(regionRegex).test(value)) return {
            ...outputs
        };
    }
    const DEFAULT_PARTITION = partitions.find((partition)=>partition.id === "aws");
    if (!DEFAULT_PARTITION) throw new Error("Provided region was not found in the partition array or regex, and default partition with id 'aws' doesn't exist.");
    return {
        ...DEFAULT_PARTITION.outputs
    };
};
const $2c1505ef34094ddf$export$5b2daaf969a6da2e = (partitionsInfo, userAgentPrefix = "")=>{
    $2c1505ef34094ddf$var$selectedPartitionsInfo = partitionsInfo;
    $2c1505ef34094ddf$var$selectedUserAgentPrefix = userAgentPrefix;
};
const $2c1505ef34094ddf$export$1003c50da40cdce = ()=>{
    $2c1505ef34094ddf$export$5b2daaf969a6da2e((0, (/*@__PURE__*/$parcel$interopDefault($6f96b9be77d8b3e0$exports))), "");
};
const $2c1505ef34094ddf$export$c249da7071246380 = ()=>$2c1505ef34094ddf$var$selectedUserAgentPrefix;


const $8e31713c360183c3$export$1bfd97ffc6d0eef8 = {
    isVirtualHostableS3Bucket: (0, $6c9f47b4fb4832b9$export$6b6a3f4e857868ec),
    parseArn: (0, $d166b3152ae24c03$export$ec6a98ce8737fc2c),
    partition: (0, $2c1505ef34094ddf$export$b29f828819edca8d)
};
(0, $91b7ba976acbb024$export$2614fba0847da171).aws = $8e31713c360183c3$export$1bfd97ffc6d0eef8;

























function $73e86b9efb78f4be$export$69482ba716363b6f(context, feature, value) {
    if (!context.__aws_sdk_context) context.__aws_sdk_context = {
        features: {}
    };
    else if (!context.__aws_sdk_context.features) context.__aws_sdk_context.features = {};
    context.__aws_sdk_context.features[feature] = value;
}


const $621beee85b196faf$var$ACCOUNT_ID_ENDPOINT_REGEX = /\d{12}\.ddb/;
async function $621beee85b196faf$export$594b1bcae76b1337(context, config, args) {
    const request = args.request;
    if (request?.headers?.["smithy-protocol"] === "rpc-v2-cbor") (0, $73e86b9efb78f4be$export$69482ba716363b6f)(context, "PROTOCOL_RPC_V2_CBOR", "M");
    if (typeof config.retryStrategy === "function") {
        const retryStrategy = await config.retryStrategy();
        if (typeof retryStrategy.acquireInitialRetryToken === "function") {
            if (retryStrategy.constructor?.name?.includes("Adaptive")) (0, $73e86b9efb78f4be$export$69482ba716363b6f)(context, "RETRY_MODE_ADAPTIVE", "F");
            else (0, $73e86b9efb78f4be$export$69482ba716363b6f)(context, "RETRY_MODE_STANDARD", "E");
        } else (0, $73e86b9efb78f4be$export$69482ba716363b6f)(context, "RETRY_MODE_LEGACY", "D");
    }
    if (typeof config.accountIdEndpointMode === "function") {
        const endpointV2 = context.endpointV2;
        if (String(endpointV2?.url?.hostname).match($621beee85b196faf$var$ACCOUNT_ID_ENDPOINT_REGEX)) (0, $73e86b9efb78f4be$export$69482ba716363b6f)(context, "ACCOUNT_ID_ENDPOINT", "O");
        switch(await config.accountIdEndpointMode?.()){
            case "disabled":
                (0, $73e86b9efb78f4be$export$69482ba716363b6f)(context, "ACCOUNT_ID_MODE_DISABLED", "Q");
                break;
            case "preferred":
                (0, $73e86b9efb78f4be$export$69482ba716363b6f)(context, "ACCOUNT_ID_MODE_PREFERRED", "P");
                break;
            case "required":
                (0, $73e86b9efb78f4be$export$69482ba716363b6f)(context, "ACCOUNT_ID_MODE_REQUIRED", "R");
                break;
        }
    }
    const identity = context.__smithy_context?.selectedHttpAuthScheme?.identity;
    if (identity?.$source) {
        const credentials = identity;
        if (credentials.accountId) (0, $73e86b9efb78f4be$export$69482ba716363b6f)(context, "RESOLVED_ACCOUNT_ID", "T");
        for (const [key, value] of Object.entries(credentials.$source ?? {}))(0, $73e86b9efb78f4be$export$69482ba716363b6f)(context, key, value);
    }
}


const $385ff7160a43d0b7$export$97a08a1bb7ee0545 = "user-agent";
const $385ff7160a43d0b7$export$e010e3d6246262a3 = "x-amz-user-agent";
const $385ff7160a43d0b7$export$27b7b95a5fde2b31 = " ";
const $385ff7160a43d0b7$export$43290ff793d1777d = "/";
const $385ff7160a43d0b7$export$2d1b87b5b2a59af3 = /[^\!\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;
const $385ff7160a43d0b7$export$84cb6e726944481 = /[^\!\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w\#]/g;
const $385ff7160a43d0b7$export$f810014d932f8c3e = "-";


const $fdbf07fb6d0308ac$var$BYTE_LIMIT = 1024;
function $fdbf07fb6d0308ac$export$b9d641ef0e9b4bc2(features) {
    let buffer = "";
    for(const key in features){
        const val = features[key];
        if (buffer.length + val.length + 1 <= $fdbf07fb6d0308ac$var$BYTE_LIMIT) {
            if (buffer.length) buffer += "," + val;
            else buffer += val;
            continue;
        }
        break;
    }
    return buffer;
}


const $168add9a52432ffc$export$62c460923941c0b0 = (options)=>(next, context)=>async (args)=>{
            const { request: request } = args;
            if (!(0, $36c92c5bbc6e0688$export$7587955500404ec3).isInstance(request)) return next(args);
            const { headers: headers } = request;
            const userAgent = context?.userAgent?.map($168add9a52432ffc$var$escapeUserAgent) || [];
            const defaultUserAgent = (await options.defaultUserAgentProvider()).map($168add9a52432ffc$var$escapeUserAgent);
            await (0, $621beee85b196faf$export$594b1bcae76b1337)(context, options, args);
            const awsContext = context;
            defaultUserAgent.push(`m/${(0, $fdbf07fb6d0308ac$export$b9d641ef0e9b4bc2)(Object.assign({}, context.__smithy_context?.features, awsContext.__aws_sdk_context?.features))}`);
            const customUserAgent = options?.customUserAgent?.map($168add9a52432ffc$var$escapeUserAgent) || [];
            const appId = await options.userAgentAppId();
            if (appId) defaultUserAgent.push($168add9a52432ffc$var$escapeUserAgent([
                `app/${appId}`
            ]));
            const prefix = (0, $2c1505ef34094ddf$export$c249da7071246380)();
            const sdkUserAgentValue = (prefix ? [
                prefix
            ] : []).concat([
                ...defaultUserAgent,
                ...userAgent,
                ...customUserAgent
            ]).join((0, $385ff7160a43d0b7$export$27b7b95a5fde2b31));
            const normalUAValue = [
                ...defaultUserAgent.filter((section)=>section.startsWith("aws-sdk-")),
                ...customUserAgent
            ].join((0, $385ff7160a43d0b7$export$27b7b95a5fde2b31));
            if (options.runtime !== "browser") {
                if (normalUAValue) headers[0, $385ff7160a43d0b7$export$e010e3d6246262a3] = headers[0, $385ff7160a43d0b7$export$e010e3d6246262a3] ? `${headers[0, $385ff7160a43d0b7$export$97a08a1bb7ee0545]} ${normalUAValue}` : normalUAValue;
                headers[0, $385ff7160a43d0b7$export$97a08a1bb7ee0545] = sdkUserAgentValue;
            } else headers[0, $385ff7160a43d0b7$export$e010e3d6246262a3] = sdkUserAgentValue;
            return next({
                ...args,
                request: request
            });
        };
const $168add9a52432ffc$var$escapeUserAgent = (userAgentPair)=>{
    const name = userAgentPair[0].split((0, $385ff7160a43d0b7$export$43290ff793d1777d)).map((part)=>part.replace((0, $385ff7160a43d0b7$export$2d1b87b5b2a59af3), (0, $385ff7160a43d0b7$export$f810014d932f8c3e))).join((0, $385ff7160a43d0b7$export$43290ff793d1777d));
    const version = userAgentPair[1]?.replace((0, $385ff7160a43d0b7$export$84cb6e726944481), (0, $385ff7160a43d0b7$export$f810014d932f8c3e));
    const prefixSeparatorIndex = name.indexOf((0, $385ff7160a43d0b7$export$43290ff793d1777d));
    const prefix = name.substring(0, prefixSeparatorIndex);
    let uaName = name.substring(prefixSeparatorIndex + 1);
    if (prefix === "api") uaName = uaName.toLowerCase();
    return [
        prefix,
        uaName,
        version
    ].filter((item)=>item && item.length > 0).reduce((acc, item, index)=>{
        switch(index){
            case 0:
                return item;
            case 1:
                return `${acc}/${item}`;
            default:
                return `${acc}#${item}`;
        }
    }, "");
};
const $168add9a52432ffc$export$29eb04da6afef73f = {
    name: "getUserAgentMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "SET_USER_AGENT",
        "USER_AGENT"
    ],
    override: true
};
const $168add9a52432ffc$export$5393c0d2d7f4f5f0 = (config)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($168add9a52432ffc$export$62c460923941c0b0(config), $168add9a52432ffc$export$29eb04da6afef73f);
        }
    });




const $14e26266a8de2cf3$export$f8c4049184e0ac3f = (obj, key, type)=>{
    if (!(key in obj)) return undefined;
    if (obj[key] === "true") return true;
    if (obj[key] === "false") return false;
    throw new Error(`Cannot load ${type} "${key}". Expected "true" or "false", got ${obj[key]}.`);
};


const $4273d505083de2e4$export$964ee8ab6fdb2cf2 = (obj, key, type)=>{
    if (!(key in obj)) return undefined;
    const numberValue = parseInt(obj[key], 10);
    if (Number.isNaN(numberValue)) throw new TypeError(`Cannot load ${type} '${key}'. Expected number, got '${obj[key]}'.`);
    return numberValue;
};


var $2fa0a7440af75565$export$4e8b093ec8dcab0d;
(function(SelectorType) {
    SelectorType["ENV"] = "env";
    SelectorType["CONFIG"] = "shared config entry";
})($2fa0a7440af75565$export$4e8b093ec8dcab0d || ($2fa0a7440af75565$export$4e8b093ec8dcab0d = {}));




const $8bc367ec79540d60$export$eacd91361c129033 = "AWS_USE_DUALSTACK_ENDPOINT";
const $8bc367ec79540d60$export$71f82540e79c63bf = "use_dualstack_endpoint";
const $8bc367ec79540d60$export$beb01fae7626c427 = false;
const $8bc367ec79540d60$export$522137fc0ae615ab = {
    environmentVariableSelector: (env)=>(0, $14e26266a8de2cf3$export$f8c4049184e0ac3f)(env, $8bc367ec79540d60$export$eacd91361c129033, (0, $2fa0a7440af75565$export$4e8b093ec8dcab0d).ENV),
    configFileSelector: (profile)=>(0, $14e26266a8de2cf3$export$f8c4049184e0ac3f)(profile, $8bc367ec79540d60$export$71f82540e79c63bf, (0, $2fa0a7440af75565$export$4e8b093ec8dcab0d).CONFIG),
    default: false
};



const $6569393054577581$export$b7eebc18f98c6d7f = "AWS_USE_FIPS_ENDPOINT";
const $6569393054577581$export$30cf725f60d4be3e = "use_fips_endpoint";
const $6569393054577581$export$5555deeca435a10b = false;
const $6569393054577581$export$42f76cc8f259f4b8 = {
    environmentVariableSelector: (env)=>(0, $14e26266a8de2cf3$export$f8c4049184e0ac3f)(env, $6569393054577581$export$b7eebc18f98c6d7f, (0, $2fa0a7440af75565$export$4e8b093ec8dcab0d).ENV),
    configFileSelector: (profile)=>(0, $14e26266a8de2cf3$export$f8c4049184e0ac3f)(profile, $6569393054577581$export$30cf725f60d4be3e, (0, $2fa0a7440af75565$export$4e8b093ec8dcab0d).CONFIG),
    default: false
};



const $0c37bb8e795ba059$export$6cd750975e36686c = (input)=>{
    const { endpoint: endpoint, urlParser: urlParser } = input;
    return {
        ...input,
        tls: input.tls ?? true,
        endpoint: (0, $1d6280adb1321100$export$b1276c07738d6325)(typeof endpoint === "string" ? urlParser(endpoint) : endpoint),
        isCustomEndpoint: true,
        useDualstackEndpoint: (0, $1d6280adb1321100$export$b1276c07738d6325)(input.useDualstackEndpoint ?? false)
    };
};



const $c8cd7937c1160ce7$export$c69bd155af41e6f1 = async (input)=>{
    const { tls: tls = true } = input;
    const region = await input.region();
    const dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
    if (!dnsHostRegex.test(region)) throw new Error("Invalid region in client config");
    const useDualstackEndpoint = await input.useDualstackEndpoint();
    const useFipsEndpoint = await input.useFipsEndpoint();
    const { hostname: hostname } = await input.regionInfoProvider(region, {
        useDualstackEndpoint: useDualstackEndpoint,
        useFipsEndpoint: useFipsEndpoint
    }) ?? {};
    if (!hostname) throw new Error("Cannot resolve hostname from client config");
    return input.urlParser(`${tls ? "https:" : "http:"}//${hostname}`);
};


const $8e1eff360a98d251$export$24f352b1bd1e2f8b = (input)=>{
    const useDualstackEndpoint = (0, $1d6280adb1321100$export$b1276c07738d6325)(input.useDualstackEndpoint ?? false);
    const { endpoint: endpoint, useFipsEndpoint: useFipsEndpoint, urlParser: urlParser } = input;
    return {
        ...input,
        tls: input.tls ?? true,
        endpoint: endpoint ? (0, $1d6280adb1321100$export$b1276c07738d6325)(typeof endpoint === "string" ? urlParser(endpoint) : endpoint) : ()=>(0, $c8cd7937c1160ce7$export$c69bd155af41e6f1)({
                ...input,
                useDualstackEndpoint: useDualstackEndpoint,
                useFipsEndpoint: useFipsEndpoint
            }),
        isCustomEndpoint: !!endpoint,
        useDualstackEndpoint: useDualstackEndpoint
    };
};




const $27d0463566a31a5f$export$26513716e2900bad = "AWS_REGION";
const $27d0463566a31a5f$export$8afb1c306a7d01b = "region";
const $27d0463566a31a5f$export$1509d3ea54119a08 = {
    environmentVariableSelector: (env)=>env[$27d0463566a31a5f$export$26513716e2900bad],
    configFileSelector: (profile)=>profile[$27d0463566a31a5f$export$8afb1c306a7d01b],
    default: ()=>{
        throw new Error("Region is missing");
    }
};
const $27d0463566a31a5f$export$9a37503ca194454d = {
    preferredFile: "credentials"
};


const $0d0be36227037042$export$cc893cb7e6a508dd = (region)=>typeof region === "string" && (region.startsWith("fips-") || region.endsWith("-fips"));


const $060f3572a4bd3fde$export$ecbdf004a8547a7f = (region)=>(0, $0d0be36227037042$export$cc893cb7e6a508dd)(region) ? [
        "fips-aws-global",
        "aws-fips"
    ].includes(region) ? "us-east-1" : region.replace(/fips-(dkr-|prod-)?|-fips/, "") : region;



const $83ef33ca75f7dd65$export$7696ef37558bd0ec = (input)=>{
    const { region: region, useFipsEndpoint: useFipsEndpoint } = input;
    if (!region) throw new Error("Region is missing");
    return {
        ...input,
        region: async ()=>{
            if (typeof region === "string") return (0, $060f3572a4bd3fde$export$ecbdf004a8547a7f)(region);
            const providedRegion = await region();
            return (0, $060f3572a4bd3fde$export$ecbdf004a8547a7f)(providedRegion);
        },
        useFipsEndpoint: async ()=>{
            const providedRegion = typeof region === "string" ? region : await region();
            if ((0, $0d0be36227037042$export$cc893cb7e6a508dd)(providedRegion)) return true;
            return typeof useFipsEndpoint !== "function" ? Promise.resolve(!!useFipsEndpoint) : useFipsEndpoint();
        }
    };
};








const $e44405d1b3cf31ef$export$75494cb913bf7ef6 = (variants = [], { useFipsEndpoint: useFipsEndpoint, useDualstackEndpoint: useDualstackEndpoint })=>variants.find(({ tags: tags })=>useFipsEndpoint === tags.includes("fips") && useDualstackEndpoint === tags.includes("dualstack"))?.hostname;


const $c56dd7e0cefa7ca7$export$d062b2a57a5d579b = (resolvedRegion, { regionHostname: regionHostname, partitionHostname: partitionHostname })=>regionHostname ? regionHostname : partitionHostname ? partitionHostname.replace("{region}", resolvedRegion) : undefined;


const $4c3f8031ea74fc54$export$2ba1c8e181ae49f8 = (region, { partitionHash: partitionHash })=>Object.keys(partitionHash || {}).find((key)=>partitionHash[key].regions.includes(region)) ?? "aws";


const $ededc5f934a6c40c$export$be75b39beeb48b5c = (hostname, { signingRegion: signingRegion, regionRegex: regionRegex, useFipsEndpoint: useFipsEndpoint })=>{
    if (signingRegion) return signingRegion;
    else if (useFipsEndpoint) {
        const regionRegexJs = regionRegex.replace("\\\\", "\\").replace(/^\^/g, "\\.").replace(/\$$/g, "\\.");
        const regionRegexmatchArray = hostname.match(regionRegexJs);
        if (regionRegexmatchArray) return regionRegexmatchArray[0].slice(1, -1);
    }
};


const $7bed80049b6a8d46$export$2b789d827caebed0 = (region, { useFipsEndpoint: useFipsEndpoint = false, useDualstackEndpoint: useDualstackEndpoint = false, signingService: signingService, regionHash: regionHash, partitionHash: partitionHash })=>{
    const partition = (0, $4c3f8031ea74fc54$export$2ba1c8e181ae49f8)(region, {
        partitionHash: partitionHash
    });
    const resolvedRegion = region in regionHash ? region : partitionHash[partition]?.endpoint ?? region;
    const hostnameOptions = {
        useFipsEndpoint: useFipsEndpoint,
        useDualstackEndpoint: useDualstackEndpoint
    };
    const regionHostname = (0, $e44405d1b3cf31ef$export$75494cb913bf7ef6)(regionHash[resolvedRegion]?.variants, hostnameOptions);
    const partitionHostname = (0, $e44405d1b3cf31ef$export$75494cb913bf7ef6)(partitionHash[partition]?.variants, hostnameOptions);
    const hostname = (0, $c56dd7e0cefa7ca7$export$d062b2a57a5d579b)(resolvedRegion, {
        regionHostname: regionHostname,
        partitionHostname: partitionHostname
    });
    if (hostname === undefined) throw new Error(`Endpoint resolution failed for: ${{
        resolvedRegion: resolvedRegion,
        useFipsEndpoint: useFipsEndpoint,
        useDualstackEndpoint: useDualstackEndpoint
    }}`);
    const signingRegion = (0, $ededc5f934a6c40c$export$be75b39beeb48b5c)(hostname, {
        signingRegion: regionHash[resolvedRegion]?.signingRegion,
        regionRegex: partitionHash[partition].regionRegex,
        useFipsEndpoint: useFipsEndpoint
    });
    return {
        partition: partition,
        signingService: signingService,
        hostname: hostname,
        ...signingRegion && {
            signingRegion: signingRegion
        },
        ...regionHash[resolvedRegion]?.signingService && {
            signingService: regionHash[resolvedRegion].signingService
        }
    };
};








const $88932ea823bca647$var$CONTENT_LENGTH_HEADER = "content-length";
function $88932ea823bca647$export$940b29eb2788b975(bodyLengthChecker) {
    return (next)=>async (args)=>{
            const request = args.request;
            if ((0, $36c92c5bbc6e0688$export$7587955500404ec3).isInstance(request)) {
                const { body: body, headers: headers } = request;
                if (body && Object.keys(headers).map((str)=>str.toLowerCase()).indexOf($88932ea823bca647$var$CONTENT_LENGTH_HEADER) === -1) try {
                    const length = bodyLengthChecker(body);
                    request.headers = {
                        ...request.headers,
                        [$88932ea823bca647$var$CONTENT_LENGTH_HEADER]: String(length)
                    };
                } catch (error) {}
            }
            return next({
                ...args,
                request: request
            });
        };
}
const $88932ea823bca647$export$1f7816f8f350b2f5 = {
    step: "build",
    tags: [
        "SET_CONTENT_LENGTH",
        "CONTENT_LENGTH"
    ],
    name: "contentLengthMiddleware",
    override: true
};
const $88932ea823bca647$export$7e6ddf9365a30fe9 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($88932ea823bca647$export$940b29eb2788b975(options.bodyLengthChecker), $88932ea823bca647$export$1f7816f8f350b2f5);
        }
    });


const $8f9aee6a8496da0e$export$972ee8f9276654f0 = async (endpointParams)=>{
    const bucket = endpointParams?.Bucket || "";
    if (typeof endpointParams.Bucket === "string") endpointParams.Bucket = bucket.replace(/#/g, encodeURIComponent("#")).replace(/\?/g, encodeURIComponent("?"));
    if ($8f9aee6a8496da0e$export$fe7fec9fee338b98(bucket)) {
        if (endpointParams.ForcePathStyle === true) throw new Error("Path-style addressing cannot be used with ARN buckets");
    } else if (!$8f9aee6a8496da0e$export$360a1e07839d0d27(bucket) || bucket.indexOf(".") !== -1 && !String(endpointParams.Endpoint).startsWith("http:") || bucket.toLowerCase() !== bucket || bucket.length < 3) endpointParams.ForcePathStyle = true;
    if (endpointParams.DisableMultiRegionAccessPoints) {
        endpointParams.disableMultiRegionAccessPoints = true;
        endpointParams.DisableMRAP = true;
    }
    return endpointParams;
};
const $8f9aee6a8496da0e$var$DOMAIN_PATTERN = /^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/;
const $8f9aee6a8496da0e$var$IP_ADDRESS_PATTERN = /(\d+\.){3}\d+/;
const $8f9aee6a8496da0e$var$DOTS_PATTERN = /\.\./;
const $8f9aee6a8496da0e$export$b0b24e5455be29b0 = /\./;
const $8f9aee6a8496da0e$export$43f53815580748f = /^(.+\.)?s3(-fips)?(\.dualstack)?[.-]([a-z0-9-]+)\./;
const $8f9aee6a8496da0e$export$360a1e07839d0d27 = (bucketName)=>$8f9aee6a8496da0e$var$DOMAIN_PATTERN.test(bucketName) && !$8f9aee6a8496da0e$var$IP_ADDRESS_PATTERN.test(bucketName) && !$8f9aee6a8496da0e$var$DOTS_PATTERN.test(bucketName);
const $8f9aee6a8496da0e$export$fe7fec9fee338b98 = (bucketName)=>{
    const [arn, partition, service, , , bucket] = bucketName.split(":");
    const isArn = arn === "arn" && bucketName.split(":").length >= 6;
    const isValidArn = Boolean(isArn && partition && service && bucket);
    if (isArn && !isValidArn) throw new Error(`Invalid ARN: ${bucketName} was an invalid ARN.`);
    return isValidArn;
};




const $b6564e9a7758b7e1$export$47243fd4b8e52f1e = (configKey, canonicalEndpointParamKey, config)=>{
    const configProvider = async ()=>{
        const configValue = config[configKey] ?? config[canonicalEndpointParamKey];
        if (typeof configValue === "function") return configValue();
        return configValue;
    };
    if (configKey === "credentialScope" || canonicalEndpointParamKey === "CredentialScope") return async ()=>{
        const credentials = typeof config.credentials === "function" ? await config.credentials() : config.credentials;
        const configValue = credentials?.credentialScope ?? credentials?.CredentialScope;
        return configValue;
    };
    if (configKey === "accountId" || canonicalEndpointParamKey === "AccountId") return async ()=>{
        const credentials = typeof config.credentials === "function" ? await config.credentials() : config.credentials;
        const configValue = credentials?.accountId ?? credentials?.AccountId;
        return configValue;
    };
    if (configKey === "endpoint" || canonicalEndpointParamKey === "endpoint") return async ()=>{
        const endpoint = await configProvider();
        if (endpoint && typeof endpoint === "object") {
            if ("url" in endpoint) return endpoint.url.href;
            if ("hostname" in endpoint) {
                const { protocol: protocol, hostname: hostname, port: port, path: path } = endpoint;
                return `${protocol}//${hostname}${port ? ":" + port : ""}${path}`;
            }
        }
        return endpoint;
    };
    return configProvider;
};


const $2f18f380587389ee$export$8a5041d6190772fe = async (serviceId)=>undefined;


function $4f4394479e5b7dbd$export$66256f83798e5415(querystring) {
    const query = {};
    querystring = querystring.replace(/^\?/, "");
    if (querystring) for (const pair of querystring.split("&")){
        let [key, value = null] = pair.split("=");
        key = decodeURIComponent(key);
        if (value) value = decodeURIComponent(value);
        if (!(key in query)) query[key] = value;
        else if (Array.isArray(query[key])) query[key].push(value);
        else query[key] = [
            query[key],
            value
        ];
    }
    return query;
}


const $931d216cb423ad36$export$7a5253c0f62e0150 = (url)=>{
    if (typeof url === "string") return $931d216cb423ad36$export$7a5253c0f62e0150(new URL(url));
    const { hostname: hostname, pathname: pathname, port: port, protocol: protocol, search: search } = url;
    let query;
    if (search) query = (0, $4f4394479e5b7dbd$export$66256f83798e5415)(search);
    return {
        hostname: hostname,
        port: port ? parseInt(port) : undefined,
        protocol: protocol,
        path: pathname,
        query: query
    };
};


const $f808dd2972874332$export$32d52e935fceeb99 = (endpoint)=>{
    if (typeof endpoint === "object") {
        if ("url" in endpoint) return (0, $931d216cb423ad36$export$7a5253c0f62e0150)(endpoint.url);
        return endpoint;
    }
    return (0, $931d216cb423ad36$export$7a5253c0f62e0150)(endpoint);
};


const $95175c5a528dce71$export$deed4544608f82ff = async (commandInput, instructionsSupplier, clientConfig, context)=>{
    if (!clientConfig.endpoint) {
        let endpointFromConfig;
        if (clientConfig.serviceConfiguredEndpoint) endpointFromConfig = await clientConfig.serviceConfiguredEndpoint();
        else endpointFromConfig = await (0, $2f18f380587389ee$export$8a5041d6190772fe)(clientConfig.serviceId);
        if (endpointFromConfig) clientConfig.endpoint = ()=>Promise.resolve((0, $f808dd2972874332$export$32d52e935fceeb99)(endpointFromConfig));
    }
    const endpointParams = await $95175c5a528dce71$export$a4c001b14047c450(commandInput, instructionsSupplier, clientConfig);
    if (typeof clientConfig.endpointProvider !== "function") throw new Error("config.endpointProvider is not set.");
    const endpoint = clientConfig.endpointProvider(endpointParams, context);
    return endpoint;
};
const $95175c5a528dce71$export$a4c001b14047c450 = async (commandInput, instructionsSupplier, clientConfig)=>{
    const endpointParams = {};
    const instructions = instructionsSupplier?.getEndpointParameterInstructions?.() || {};
    for (const [name, instruction] of Object.entries(instructions))switch(instruction.type){
        case "staticContextParams":
            endpointParams[name] = instruction.value;
            break;
        case "contextParams":
            endpointParams[name] = commandInput[instruction.name];
            break;
        case "clientContextParams":
        case "builtInParams":
            endpointParams[name] = await (0, $b6564e9a7758b7e1$export$47243fd4b8e52f1e)(instruction.name, name, clientConfig)();
            break;
        case "operationContextParams":
            endpointParams[name] = instruction.get(commandInput);
            break;
        default:
            throw new Error("Unrecognized endpoint parameter instruction: " + JSON.stringify(instruction));
    }
    if (Object.keys(instructions).length === 0) Object.assign(endpointParams, clientConfig);
    if (String(clientConfig.serviceId).toLowerCase() === "s3") await (0, $8f9aee6a8496da0e$export$972ee8f9276654f0)(endpointParams);
    return endpointParams;
};








const $e72213461dbca84b$export$aa1c2d132a457833 = ({ config: config, instructions: instructions })=>{
    return (next, context)=>async (args)=>{
            if (config.endpoint) (0, $419fd94dbbd9692a$export$69482ba716363b6f)(context, "ENDPOINT_OVERRIDE", "N");
            const endpoint = await (0, $95175c5a528dce71$export$deed4544608f82ff)(args.input, {
                getEndpointParameterInstructions () {
                    return instructions;
                }
            }, {
                ...config
            }, context);
            context.endpointV2 = endpoint;
            context.authSchemes = endpoint.properties?.authSchemes;
            const authScheme = context.authSchemes?.[0];
            if (authScheme) {
                context["signing_region"] = authScheme.signingRegion;
                context["signing_service"] = authScheme.signingName;
                const smithyContext = (0, $e6ed4dab4f65171f$export$1d3c197393275463)(context);
                const httpAuthOption = smithyContext?.selectedHttpAuthScheme?.httpAuthOption;
                if (httpAuthOption) httpAuthOption.signingProperties = Object.assign(httpAuthOption.signingProperties || {}, {
                    signing_region: authScheme.signingRegion,
                    signingRegion: authScheme.signingRegion,
                    signing_service: authScheme.signingName,
                    signingName: authScheme.signingName,
                    signingRegionSet: authScheme.signingRegionSet
                }, authScheme.properties);
            }
            return next({
                ...args
            });
        };
};




const $335ede9082851668$export$1e040b8d263b920b = {
    step: "serialize",
    tags: [
        "ENDPOINT_PARAMETERS",
        "ENDPOINT_V2",
        "ENDPOINT"
    ],
    name: "endpointV2Middleware",
    override: true,
    relation: "before",
    toMiddleware: (0, $d08040bde29682c1$export$1bd449976e9c484d).name
};
const $335ede9082851668$export$946c80457b765eab = (config, instructions)=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo((0, $e72213461dbca84b$export$aa1c2d132a457833)({
                config: config,
                instructions: instructions
            }), $335ede9082851668$export$1e040b8d263b920b);
        }
    });





const $dedc7eba2c45bbb9$export$8c5b66831e3f26ff = (input)=>{
    const tls = input.tls ?? true;
    const { endpoint: endpoint } = input;
    const customEndpointProvider = endpoint != null ? async ()=>(0, $f808dd2972874332$export$32d52e935fceeb99)(await (0, $1d6280adb1321100$export$b1276c07738d6325)(endpoint)()) : undefined;
    const isCustomEndpoint = !!endpoint;
    const resolvedConfig = {
        ...input,
        endpoint: customEndpointProvider,
        tls: tls,
        isCustomEndpoint: isCustomEndpoint,
        useDualstackEndpoint: (0, $1d6280adb1321100$export$b1276c07738d6325)(input.useDualstackEndpoint ?? false),
        useFipsEndpoint: (0, $1d6280adb1321100$export$b1276c07738d6325)(input.useFipsEndpoint ?? false)
    };
    let configuredEndpointPromise = undefined;
    resolvedConfig.serviceConfiguredEndpoint = async ()=>{
        if (input.serviceId && !configuredEndpointPromise) configuredEndpointPromise = (0, $2f18f380587389ee$export$8a5041d6190772fe)(input.serviceId);
        return configuredEndpointPromise;
    };
    return resolvedConfig;
};






var $5509594642b1e771$export$6842199fccd474d3;
(function(RETRY_MODES) {
    RETRY_MODES["STANDARD"] = "standard";
    RETRY_MODES["ADAPTIVE"] = "adaptive";
})($5509594642b1e771$export$6842199fccd474d3 || ($5509594642b1e771$export$6842199fccd474d3 = {}));
const $5509594642b1e771$export$2c7e51f38ba5a406 = 3;
const $5509594642b1e771$export$41315747b7c5d042 = $5509594642b1e771$export$6842199fccd474d3.STANDARD;


const $4acc829e3728e850$export$9fde012b8b2a10ca = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch"
];
const $4acc829e3728e850$export$89cd1b0ccfcb99d = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException",
    "TransactionInProgressException"
];
const $4acc829e3728e850$export$18bd3bfe89ded398 = [
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
const $4acc829e3728e850$export$38bf589d26009e4f = [
    500,
    502,
    503,
    504
];
const $4acc829e3728e850$export$e4f761fe9d74ce41 = [
    "ECONNRESET",
    "ECONNREFUSED",
    "EPIPE",
    "ETIMEDOUT"
];


const $93a61470f9cadb28$export$46428803f4bd8a0c = (error)=>error.$retryable !== undefined;
const $93a61470f9cadb28$export$7b87435661177a94 = (error)=>(0, $4acc829e3728e850$export$9fde012b8b2a10ca).includes(error.name);
const $93a61470f9cadb28$export$ca8501ea0db9a003 = (error)=>error.$metadata?.clockSkewCorrected;
const $93a61470f9cadb28$export$cbecb89f6256ccc8 = (error)=>error.$metadata?.httpStatusCode === 429 || (0, $4acc829e3728e850$export$89cd1b0ccfcb99d).includes(error.name) || error.$retryable?.throttling == true;
const $93a61470f9cadb28$export$31778435da988512 = (error, depth = 0)=>$93a61470f9cadb28$export$ca8501ea0db9a003(error) || (0, $4acc829e3728e850$export$18bd3bfe89ded398).includes(error.name) || (0, $4acc829e3728e850$export$e4f761fe9d74ce41).includes(error?.code || "") || (0, $4acc829e3728e850$export$38bf589d26009e4f).includes(error.$metadata?.httpStatusCode || 0) || error.cause !== undefined && depth <= 10 && $93a61470f9cadb28$export$31778435da988512(error.cause, depth + 1);
const $93a61470f9cadb28$export$a7cbe72d7c4012af = (error)=>{
    if (error.$metadata?.httpStatusCode !== undefined) {
        const statusCode = error.$metadata.httpStatusCode;
        if (500 <= statusCode && statusCode <= 599 && !$93a61470f9cadb28$export$31778435da988512(error)) return true;
        return false;
    }
    return false;
};


class $d9c7e6babf490934$export$4d4bb1390e4746c4 {
    constructor(options){
        this.currentCapacity = 0;
        this.enabled = false;
        this.lastMaxRate = 0;
        this.measuredTxRate = 0;
        this.requestCount = 0;
        this.lastTimestamp = 0;
        this.timeWindow = 0;
        this.beta = options?.beta ?? 0.7;
        this.minCapacity = options?.minCapacity ?? 1;
        this.minFillRate = options?.minFillRate ?? 0.5;
        this.scaleConstant = options?.scaleConstant ?? 0.4;
        this.smooth = options?.smooth ?? 0.8;
        const currentTimeInSeconds = this.getCurrentTimeInSeconds();
        this.lastThrottleTime = currentTimeInSeconds;
        this.lastTxRateBucket = Math.floor(this.getCurrentTimeInSeconds());
        this.fillRate = this.minFillRate;
        this.maxCapacity = this.minCapacity;
    }
    getCurrentTimeInSeconds() {
        return Date.now() / 1000;
    }
    async getSendToken() {
        return this.acquireTokenBucket(1);
    }
    async acquireTokenBucket(amount) {
        if (!this.enabled) return;
        this.refillTokenBucket();
        if (amount > this.currentCapacity) {
            const delay = (amount - this.currentCapacity) / this.fillRate * 1000;
            await new Promise((resolve)=>$d9c7e6babf490934$export$4d4bb1390e4746c4.setTimeoutFn(resolve, delay));
        }
        this.currentCapacity = this.currentCapacity - amount;
    }
    refillTokenBucket() {
        const timestamp = this.getCurrentTimeInSeconds();
        if (!this.lastTimestamp) {
            this.lastTimestamp = timestamp;
            return;
        }
        const fillAmount = (timestamp - this.lastTimestamp) * this.fillRate;
        this.currentCapacity = Math.min(this.maxCapacity, this.currentCapacity + fillAmount);
        this.lastTimestamp = timestamp;
    }
    updateClientSendingRate(response) {
        let calculatedRate;
        this.updateMeasuredRate();
        if ((0, $93a61470f9cadb28$export$cbecb89f6256ccc8)(response)) {
            const rateToUse = !this.enabled ? this.measuredTxRate : Math.min(this.measuredTxRate, this.fillRate);
            this.lastMaxRate = rateToUse;
            this.calculateTimeWindow();
            this.lastThrottleTime = this.getCurrentTimeInSeconds();
            calculatedRate = this.cubicThrottle(rateToUse);
            this.enableTokenBucket();
        } else {
            this.calculateTimeWindow();
            calculatedRate = this.cubicSuccess(this.getCurrentTimeInSeconds());
        }
        const newRate = Math.min(calculatedRate, 2 * this.measuredTxRate);
        this.updateTokenBucketRate(newRate);
    }
    calculateTimeWindow() {
        this.timeWindow = this.getPrecise(Math.pow(this.lastMaxRate * (1 - this.beta) / this.scaleConstant, 1 / 3));
    }
    cubicThrottle(rateToUse) {
        return this.getPrecise(rateToUse * this.beta);
    }
    cubicSuccess(timestamp) {
        return this.getPrecise(this.scaleConstant * Math.pow(timestamp - this.lastThrottleTime - this.timeWindow, 3) + this.lastMaxRate);
    }
    enableTokenBucket() {
        this.enabled = true;
    }
    updateTokenBucketRate(newRate) {
        this.refillTokenBucket();
        this.fillRate = Math.max(newRate, this.minFillRate);
        this.maxCapacity = Math.max(newRate, this.minCapacity);
        this.currentCapacity = Math.min(this.currentCapacity, this.maxCapacity);
    }
    updateMeasuredRate() {
        const t = this.getCurrentTimeInSeconds();
        const timeBucket = Math.floor(t * 2) / 2;
        this.requestCount++;
        if (timeBucket > this.lastTxRateBucket) {
            const currentRate = this.requestCount / (timeBucket - this.lastTxRateBucket);
            this.measuredTxRate = this.getPrecise(currentRate * this.smooth + this.measuredTxRate * (1 - this.smooth));
            this.requestCount = 0;
            this.lastTxRateBucket = timeBucket;
        }
    }
    getPrecise(num) {
        return parseFloat(num.toFixed(8));
    }
}
$d9c7e6babf490934$export$4d4bb1390e4746c4.setTimeoutFn = setTimeout;



const $814f300a8e809846$export$7067ba90effbd789 = 100;
const $814f300a8e809846$export$2412c80d04e902c6 = 20000;
const $814f300a8e809846$export$4af31f8250b48e23 = 500;
const $814f300a8e809846$export$f8c3d11675a1153 = 500;
const $814f300a8e809846$export$797febae1136bc84 = 5;
const $814f300a8e809846$export$b643545eaf9af837 = 10;
const $814f300a8e809846$export$a25da3406dc148e4 = 1;
const $814f300a8e809846$export$197fd517bf66ccb2 = "amz-sdk-invocation-id";
const $814f300a8e809846$export$d4f764f0ec4f52f = "amz-sdk-request";



const $c6ee0292fd7654cf$export$fc672061560e1611 = ()=>{
    let delayBase = (0, $814f300a8e809846$export$7067ba90effbd789);
    const computeNextBackoffDelay = (attempts)=>{
        return Math.floor(Math.min((0, $814f300a8e809846$export$2412c80d04e902c6), Math.random() * 2 ** attempts * delayBase));
    };
    const setDelayBase = (delay)=>{
        delayBase = delay;
    };
    return {
        computeNextBackoffDelay: computeNextBackoffDelay,
        setDelayBase: setDelayBase
    };
};



const $5a37b7f60cca2c11$export$330ec27afca1b9b = ({ retryDelay: retryDelay, retryCount: retryCount, retryCost: retryCost })=>{
    const getRetryCount = ()=>retryCount;
    const getRetryDelay = ()=>Math.min((0, $814f300a8e809846$export$2412c80d04e902c6), retryDelay);
    const getRetryCost = ()=>retryCost;
    return {
        getRetryCount: getRetryCount,
        getRetryDelay: getRetryDelay,
        getRetryCost: getRetryCost
    };
};


class $bd5a3c6cf13ed65d$export$64af437cce00eae8 {
    constructor(maxAttempts){
        this.maxAttempts = maxAttempts;
        this.mode = (0, $5509594642b1e771$export$6842199fccd474d3).STANDARD;
        this.capacity = (0, $814f300a8e809846$export$f8c3d11675a1153);
        this.retryBackoffStrategy = (0, $c6ee0292fd7654cf$export$fc672061560e1611)();
        this.maxAttemptsProvider = typeof maxAttempts === "function" ? maxAttempts : async ()=>maxAttempts;
    }
    async acquireInitialRetryToken(retryTokenScope) {
        return (0, $5a37b7f60cca2c11$export$330ec27afca1b9b)({
            retryDelay: (0, $814f300a8e809846$export$7067ba90effbd789),
            retryCount: 0
        });
    }
    async refreshRetryTokenForRetry(token, errorInfo) {
        const maxAttempts = await this.getMaxAttempts();
        if (this.shouldRetry(token, errorInfo, maxAttempts)) {
            const errorType = errorInfo.errorType;
            this.retryBackoffStrategy.setDelayBase(errorType === "THROTTLING" ? (0, $814f300a8e809846$export$4af31f8250b48e23) : (0, $814f300a8e809846$export$7067ba90effbd789));
            const delayFromErrorType = this.retryBackoffStrategy.computeNextBackoffDelay(token.getRetryCount());
            const retryDelay = errorInfo.retryAfterHint ? Math.max(errorInfo.retryAfterHint.getTime() - Date.now() || 0, delayFromErrorType) : delayFromErrorType;
            const capacityCost = this.getCapacityCost(errorType);
            this.capacity -= capacityCost;
            return (0, $5a37b7f60cca2c11$export$330ec27afca1b9b)({
                retryDelay: retryDelay,
                retryCount: token.getRetryCount() + 1,
                retryCost: capacityCost
            });
        }
        throw new Error("No retry token available");
    }
    recordSuccess(token) {
        this.capacity = Math.max((0, $814f300a8e809846$export$f8c3d11675a1153), this.capacity + (token.getRetryCost() ?? (0, $814f300a8e809846$export$a25da3406dc148e4)));
    }
    getCapacity() {
        return this.capacity;
    }
    async getMaxAttempts() {
        try {
            return await this.maxAttemptsProvider();
        } catch (error) {
            console.warn(`Max attempts provider could not resolve. Using default of ${(0, $5509594642b1e771$export$2c7e51f38ba5a406)}`);
            return 0, $5509594642b1e771$export$2c7e51f38ba5a406;
        }
    }
    shouldRetry(tokenToRenew, errorInfo, maxAttempts) {
        const attempts = tokenToRenew.getRetryCount() + 1;
        return attempts < maxAttempts && this.capacity >= this.getCapacityCost(errorInfo.errorType) && this.isRetryableError(errorInfo.errorType);
    }
    getCapacityCost(errorType) {
        return errorType === "TRANSIENT" ? (0, $814f300a8e809846$export$b643545eaf9af837) : (0, $814f300a8e809846$export$797febae1136bc84);
    }
    isRetryableError(errorType) {
        return errorType === "THROTTLING" || errorType === "TRANSIENT";
    }
}


class $328f118b7e7fbf2e$export$b6f3faf7501de8bc {
    constructor(maxAttemptsProvider, options){
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = (0, $5509594642b1e771$export$6842199fccd474d3).ADAPTIVE;
        const { rateLimiter: rateLimiter } = options ?? {};
        this.rateLimiter = rateLimiter ?? new (0, $d9c7e6babf490934$export$4d4bb1390e4746c4)();
        this.standardRetryStrategy = new (0, $bd5a3c6cf13ed65d$export$64af437cce00eae8)(maxAttemptsProvider);
    }
    async acquireInitialRetryToken(retryTokenScope) {
        await this.rateLimiter.getSendToken();
        return this.standardRetryStrategy.acquireInitialRetryToken(retryTokenScope);
    }
    async refreshRetryTokenForRetry(tokenToRenew, errorInfo) {
        this.rateLimiter.updateClientSendingRate(errorInfo);
        return this.standardRetryStrategy.refreshRetryTokenForRetry(tokenToRenew, errorInfo);
    }
    recordSuccess(token) {
        this.rateLimiter.updateClientSendingRate({});
        this.standardRetryStrategy.recordSuccess(token);
    }
}




class $7fa7e6433b723513$export$4d488d77e5dad28e extends (0, $bd5a3c6cf13ed65d$export$64af437cce00eae8) {
    constructor(maxAttempts, computeNextBackoffDelay = (0, $814f300a8e809846$export$7067ba90effbd789)){
        super(typeof maxAttempts === "function" ? maxAttempts : async ()=>maxAttempts);
        if (typeof computeNextBackoffDelay === "number") this.computeNextBackoffDelay = ()=>computeNextBackoffDelay;
        else this.computeNextBackoffDelay = computeNextBackoffDelay;
    }
    async refreshRetryTokenForRetry(tokenToRenew, errorInfo) {
        const token = await super.refreshRetryTokenForRetry(tokenToRenew, errorInfo);
        token.getRetryDelay = ()=>this.computeNextBackoffDelay(token.getRetryCount());
        return token;
    }
}













const $a2a3ce921c2c1992$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $a2a3ce921c2c1992$export$2e2bcd8739ae039 = {
    randomUUID: $a2a3ce921c2c1992$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $2e49ad666fb8ed71$var$getRandomValues;
const $2e49ad666fb8ed71$var$rnds8 = new Uint8Array(16);
function $2e49ad666fb8ed71$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$2e49ad666fb8ed71$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $2e49ad666fb8ed71$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$2e49ad666fb8ed71$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $2e49ad666fb8ed71$var$getRandomValues($2e49ad666fb8ed71$var$rnds8);
}


var $10d8cd6ba0d08d80$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $bcd92eac65d4d170$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $10d8cd6ba0d08d80$export$2e2bcd8739ae039).test(uuid);
}
var $bcd92eac65d4d170$export$2e2bcd8739ae039 = $bcd92eac65d4d170$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $a2aac5a3dec375d6$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$a2aac5a3dec375d6$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $a2aac5a3dec375d6$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $a2aac5a3dec375d6$var$byteToHex[arr[offset + 0]] + $a2aac5a3dec375d6$var$byteToHex[arr[offset + 1]] + $a2aac5a3dec375d6$var$byteToHex[arr[offset + 2]] + $a2aac5a3dec375d6$var$byteToHex[arr[offset + 3]] + '-' + $a2aac5a3dec375d6$var$byteToHex[arr[offset + 4]] + $a2aac5a3dec375d6$var$byteToHex[arr[offset + 5]] + '-' + $a2aac5a3dec375d6$var$byteToHex[arr[offset + 6]] + $a2aac5a3dec375d6$var$byteToHex[arr[offset + 7]] + '-' + $a2aac5a3dec375d6$var$byteToHex[arr[offset + 8]] + $a2aac5a3dec375d6$var$byteToHex[arr[offset + 9]] + '-' + $a2aac5a3dec375d6$var$byteToHex[arr[offset + 10]] + $a2aac5a3dec375d6$var$byteToHex[arr[offset + 11]] + $a2aac5a3dec375d6$var$byteToHex[arr[offset + 12]] + $a2aac5a3dec375d6$var$byteToHex[arr[offset + 13]] + $a2aac5a3dec375d6$var$byteToHex[arr[offset + 14]] + $a2aac5a3dec375d6$var$byteToHex[arr[offset + 15]];
}
function $a2aac5a3dec375d6$var$stringify(arr, offset = 0) {
    const uuid = $a2aac5a3dec375d6$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $bcd92eac65d4d170$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $a2aac5a3dec375d6$export$2e2bcd8739ae039 = $a2aac5a3dec375d6$var$stringify;


function $f1f451188ec334c2$var$v4(options, buf, offset) {
    if ((0, $a2a3ce921c2c1992$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $a2a3ce921c2c1992$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $2e49ad666fb8ed71$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $a2aac5a3dec375d6$export$8fb373d660548968)(rnds);
}
var $f1f451188ec334c2$export$2e2bcd8739ae039 = $f1f451188ec334c2$var$v4;



const $47490c73ba5f9a94$export$2ebe7988802fc284 = (initialRetryTokens, options)=>{
    const MAX_CAPACITY = initialRetryTokens;
    const noRetryIncrement = options?.noRetryIncrement ?? (0, $814f300a8e809846$export$a25da3406dc148e4);
    const retryCost = options?.retryCost ?? (0, $814f300a8e809846$export$797febae1136bc84);
    const timeoutRetryCost = options?.timeoutRetryCost ?? (0, $814f300a8e809846$export$b643545eaf9af837);
    let availableCapacity = initialRetryTokens;
    const getCapacityAmount = (error)=>error.name === "TimeoutError" ? timeoutRetryCost : retryCost;
    const hasRetryTokens = (error)=>getCapacityAmount(error) <= availableCapacity;
    const retrieveRetryTokens = (error)=>{
        if (!hasRetryTokens(error)) throw new Error("No retry token available");
        const capacityAmount = getCapacityAmount(error);
        availableCapacity -= capacityAmount;
        return capacityAmount;
    };
    const releaseRetryTokens = (capacityReleaseAmount)=>{
        availableCapacity += capacityReleaseAmount ?? noRetryIncrement;
        availableCapacity = Math.min(availableCapacity, MAX_CAPACITY);
    };
    return Object.freeze({
        hasRetryTokens: hasRetryTokens,
        retrieveRetryTokens: retrieveRetryTokens,
        releaseRetryTokens: releaseRetryTokens
    });
};



const $d5ee771c0dc3647b$export$1cddd42598a3b1f6 = (delayBase, attempts)=>Math.floor(Math.min((0, $814f300a8e809846$export$2412c80d04e902c6), Math.random() * 2 ** attempts * delayBase));



const $748c94c9ec6d61e0$export$3839fd261f89ec2 = (error)=>{
    if (!error) return false;
    return (0, $93a61470f9cadb28$export$46428803f4bd8a0c)(error) || (0, $93a61470f9cadb28$export$7b87435661177a94)(error) || (0, $93a61470f9cadb28$export$cbecb89f6256ccc8)(error) || (0, $93a61470f9cadb28$export$31778435da988512)(error);
};


const $d79467642a9d77cd$export$c780f8210b6eca50 = (error)=>{
    if (error instanceof Error) return error;
    if (error instanceof Object) return Object.assign(new Error(), error);
    if (typeof error === "string") return new Error(error);
    return new Error(`AWS SDK error wrapper for ${error}`);
};


class $50004710372a7ca9$export$64af437cce00eae8 {
    constructor(maxAttemptsProvider, options){
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = (0, $5509594642b1e771$export$6842199fccd474d3).STANDARD;
        this.retryDecider = options?.retryDecider ?? (0, $748c94c9ec6d61e0$export$3839fd261f89ec2);
        this.delayDecider = options?.delayDecider ?? (0, $d5ee771c0dc3647b$export$1cddd42598a3b1f6);
        this.retryQuota = options?.retryQuota ?? (0, $47490c73ba5f9a94$export$2ebe7988802fc284)((0, $814f300a8e809846$export$f8c3d11675a1153));
    }
    shouldRetry(error, attempts, maxAttempts) {
        return attempts < maxAttempts && this.retryDecider(error) && this.retryQuota.hasRetryTokens(error);
    }
    async getMaxAttempts() {
        let maxAttempts;
        try {
            maxAttempts = await this.maxAttemptsProvider();
        } catch (error) {
            maxAttempts = (0, $5509594642b1e771$export$2c7e51f38ba5a406);
        }
        return maxAttempts;
    }
    async retry(next, args, options) {
        let retryTokenAmount;
        let attempts = 0;
        let totalDelay = 0;
        const maxAttempts = await this.getMaxAttempts();
        const { request: request } = args;
        if ((0, $36c92c5bbc6e0688$export$7587955500404ec3).isInstance(request)) request.headers[0, $814f300a8e809846$export$197fd517bf66ccb2] = (0, $f1f451188ec334c2$export$2e2bcd8739ae039)();
        while(true)try {
            if ((0, $36c92c5bbc6e0688$export$7587955500404ec3).isInstance(request)) request.headers[0, $814f300a8e809846$export$d4f764f0ec4f52f] = `attempt=${attempts + 1}; max=${maxAttempts}`;
            if (options?.beforeRequest) await options.beforeRequest();
            const { response: response, output: output } = await next(args);
            if (options?.afterRequest) options.afterRequest(response);
            this.retryQuota.releaseRetryTokens(retryTokenAmount);
            output.$metadata.attempts = attempts + 1;
            output.$metadata.totalRetryDelay = totalDelay;
            return {
                response: response,
                output: output
            };
        } catch (e) {
            const err = (0, $d79467642a9d77cd$export$c780f8210b6eca50)(e);
            attempts++;
            if (this.shouldRetry(err, attempts, maxAttempts)) {
                retryTokenAmount = this.retryQuota.retrieveRetryTokens(err);
                const delayFromDecider = this.delayDecider((0, $93a61470f9cadb28$export$cbecb89f6256ccc8)(err) ? (0, $814f300a8e809846$export$4af31f8250b48e23) : (0, $814f300a8e809846$export$7067ba90effbd789), attempts);
                const delayFromResponse = $50004710372a7ca9$var$getDelayFromRetryAfterHeader(err.$response);
                const delay = Math.max(delayFromResponse || 0, delayFromDecider);
                totalDelay += delay;
                await new Promise((resolve)=>setTimeout(resolve, delay));
                continue;
            }
            if (!err.$metadata) err.$metadata = {};
            err.$metadata.attempts = attempts;
            err.$metadata.totalRetryDelay = totalDelay;
            throw err;
        }
    }
}
const $50004710372a7ca9$var$getDelayFromRetryAfterHeader = (response)=>{
    if (!(0, $719e5a813689e03b$export$1d94dfe0d9d1f1e7).isInstance(response)) return;
    const retryAfterHeaderName = Object.keys(response.headers).find((key)=>key.toLowerCase() === "retry-after");
    if (!retryAfterHeaderName) return;
    const retryAfter = response.headers[retryAfterHeaderName];
    const retryAfterSeconds = Number(retryAfter);
    if (!Number.isNaN(retryAfterSeconds)) return retryAfterSeconds * 1000;
    const retryAfterDate = new Date(retryAfter);
    return retryAfterDate.getTime() - Date.now();
};


class $085a381748becf6b$export$b6f3faf7501de8bc extends (0, $50004710372a7ca9$export$64af437cce00eae8) {
    constructor(maxAttemptsProvider, options){
        const { rateLimiter: rateLimiter, ...superOptions } = options ?? {};
        super(maxAttemptsProvider, superOptions);
        this.rateLimiter = rateLimiter ?? new (0, $d9c7e6babf490934$export$4d4bb1390e4746c4)();
        this.mode = (0, $5509594642b1e771$export$6842199fccd474d3).ADAPTIVE;
    }
    async retry(next, args) {
        return super.retry(next, args, {
            beforeRequest: async ()=>{
                return this.rateLimiter.getSendToken();
            },
            afterRequest: (response)=>{
                this.rateLimiter.updateClientSendingRate(response);
            }
        });
    }
}





const $5ca3ff7097febeef$export$a19952f9e421517c = "AWS_MAX_ATTEMPTS";
const $5ca3ff7097febeef$export$9ae8a04532f798bc = "max_attempts";
const $5ca3ff7097febeef$export$8023fdddb2ca30e0 = {
    environmentVariableSelector: (env)=>{
        const value = env[$5ca3ff7097febeef$export$a19952f9e421517c];
        if (!value) return undefined;
        const maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error(`Environment variable ${$5ca3ff7097febeef$export$a19952f9e421517c} mast be a number, got "${value}"`);
        return maxAttempt;
    },
    configFileSelector: (profile)=>{
        const value = profile[$5ca3ff7097febeef$export$9ae8a04532f798bc];
        if (!value) return undefined;
        const maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error(`Shared config file entry ${$5ca3ff7097febeef$export$9ae8a04532f798bc} mast be a number, got "${value}"`);
        return maxAttempt;
    },
    default: (0, $5509594642b1e771$export$2c7e51f38ba5a406)
};
const $5ca3ff7097febeef$export$ca7f6138f2c98476 = (input)=>{
    const { retryStrategy: retryStrategy } = input;
    const maxAttempts = (0, $1d6280adb1321100$export$b1276c07738d6325)(input.maxAttempts ?? (0, $5509594642b1e771$export$2c7e51f38ba5a406));
    return {
        ...input,
        maxAttempts: maxAttempts,
        retryStrategy: async ()=>{
            if (retryStrategy) return retryStrategy;
            const retryMode = await (0, $1d6280adb1321100$export$b1276c07738d6325)(input.retryMode)();
            if (retryMode === (0, $5509594642b1e771$export$6842199fccd474d3).ADAPTIVE) return new (0, $328f118b7e7fbf2e$export$b6f3faf7501de8bc)(maxAttempts);
            return new (0, $bd5a3c6cf13ed65d$export$64af437cce00eae8)(maxAttempts);
        }
    };
};
const $5ca3ff7097febeef$export$4728af91ff39ef3b = "AWS_RETRY_MODE";
const $5ca3ff7097febeef$export$c5c0171a17765aea = "retry_mode";
const $5ca3ff7097febeef$export$972bf2bb01959ff5 = {
    environmentVariableSelector: (env)=>env[$5ca3ff7097febeef$export$4728af91ff39ef3b],
    configFileSelector: (profile)=>profile[$5ca3ff7097febeef$export$c5c0171a17765aea],
    default: (0, $5509594642b1e771$export$41315747b7c5d042)
};





const $b095d710efa2bca3$export$536b11ee0b9c4a95 = ()=>(next)=>async (args)=>{
            const { request: request } = args;
            if ((0, $36c92c5bbc6e0688$export$7587955500404ec3).isInstance(request)) {
                delete request.headers[0, $814f300a8e809846$export$197fd517bf66ccb2];
                delete request.headers[0, $814f300a8e809846$export$d4f764f0ec4f52f];
            }
            return next(args);
        };
const $b095d710efa2bca3$export$3ec587d8f35e7a2c = {
    name: "omitRetryHeadersMiddleware",
    tags: [
        "RETRY",
        "HEADERS",
        "OMIT_RETRY_HEADERS"
    ],
    relation: "before",
    toMiddleware: "awsAuthMiddleware",
    override: true
};
const $b095d710efa2bca3$export$fa165e6edc16c2a2 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo($b095d710efa2bca3$export$536b11ee0b9c4a95(), $b095d710efa2bca3$export$3ec587d8f35e7a2c);
        }
    });





const $e1f49749b066298e$var$getAllAliases = (name, aliases)=>{
    const _aliases = [];
    if (name) _aliases.push(name);
    if (aliases) for (const alias of aliases)_aliases.push(alias);
    return _aliases;
};
const $e1f49749b066298e$var$getMiddlewareNameWithAliases = (name, aliases)=>{
    return `${name || "anonymous"}${aliases && aliases.length > 0 ? ` (a.k.a. ${aliases.join(",")})` : ""}`;
};
const $e1f49749b066298e$export$73604a93307363d8 = ()=>{
    let absoluteEntries = [];
    let relativeEntries = [];
    let identifyOnResolve = false;
    const entriesNameSet = new Set();
    const sort = (entries)=>entries.sort((a, b)=>$e1f49749b066298e$var$stepWeights[b.step] - $e1f49749b066298e$var$stepWeights[a.step] || $e1f49749b066298e$var$priorityWeights[b.priority || "normal"] - $e1f49749b066298e$var$priorityWeights[a.priority || "normal"]);
    const removeByName = (toRemove)=>{
        let isRemoved = false;
        const filterCb = (entry)=>{
            const aliases = $e1f49749b066298e$var$getAllAliases(entry.name, entry.aliases);
            if (aliases.includes(toRemove)) {
                isRemoved = true;
                for (const alias of aliases)entriesNameSet.delete(alias);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    const removeByReference = (toRemove)=>{
        let isRemoved = false;
        const filterCb = (entry)=>{
            if (entry.middleware === toRemove) {
                isRemoved = true;
                for (const alias of $e1f49749b066298e$var$getAllAliases(entry.name, entry.aliases))entriesNameSet.delete(alias);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    const cloneTo = (toStack)=>{
        absoluteEntries.forEach((entry)=>{
            toStack.add(entry.middleware, {
                ...entry
            });
        });
        relativeEntries.forEach((entry)=>{
            toStack.addRelativeTo(entry.middleware, {
                ...entry
            });
        });
        toStack.identifyOnResolve?.(stack.identifyOnResolve());
        return toStack;
    };
    const expandRelativeMiddlewareList = (from)=>{
        const expandedMiddlewareList = [];
        from.before.forEach((entry)=>{
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push(...expandRelativeMiddlewareList(entry));
        });
        expandedMiddlewareList.push(from);
        from.after.reverse().forEach((entry)=>{
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push(...expandRelativeMiddlewareList(entry));
        });
        return expandedMiddlewareList;
    };
    const getMiddlewareList = (debug = false)=>{
        const normalizedAbsoluteEntries = [];
        const normalizedRelativeEntries = [];
        const normalizedEntriesNameMap = {};
        absoluteEntries.forEach((entry)=>{
            const normalizedEntry = {
                ...entry,
                before: [],
                after: []
            };
            for (const alias of $e1f49749b066298e$var$getAllAliases(normalizedEntry.name, normalizedEntry.aliases))normalizedEntriesNameMap[alias] = normalizedEntry;
            normalizedAbsoluteEntries.push(normalizedEntry);
        });
        relativeEntries.forEach((entry)=>{
            const normalizedEntry = {
                ...entry,
                before: [],
                after: []
            };
            for (const alias of $e1f49749b066298e$var$getAllAliases(normalizedEntry.name, normalizedEntry.aliases))normalizedEntriesNameMap[alias] = normalizedEntry;
            normalizedRelativeEntries.push(normalizedEntry);
        });
        normalizedRelativeEntries.forEach((entry)=>{
            if (entry.toMiddleware) {
                const toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
                if (toMiddleware === undefined) {
                    if (debug) return;
                    throw new Error(`${entry.toMiddleware} is not found when adding ` + `${$e1f49749b066298e$var$getMiddlewareNameWithAliases(entry.name, entry.aliases)} ` + `middleware ${entry.relation} ${entry.toMiddleware}`);
                }
                if (entry.relation === "after") toMiddleware.after.push(entry);
                if (entry.relation === "before") toMiddleware.before.push(entry);
            }
        });
        const mainChain = sort(normalizedAbsoluteEntries).map(expandRelativeMiddlewareList).reduce((wholeList, expandedMiddlewareList)=>{
            wholeList.push(...expandedMiddlewareList);
            return wholeList;
        }, []);
        return mainChain;
    };
    const stack = {
        add: (middleware, options = {})=>{
            const { name: name, override: override, aliases: _aliases } = options;
            const entry = {
                step: "initialize",
                priority: "normal",
                middleware: middleware,
                ...options
            };
            const aliases = $e1f49749b066298e$var$getAllAliases(name, _aliases);
            if (aliases.length > 0) {
                if (aliases.some((alias)=>entriesNameSet.has(alias))) {
                    if (!override) throw new Error(`Duplicate middleware name '${$e1f49749b066298e$var$getMiddlewareNameWithAliases(name, _aliases)}'`);
                    for (const alias of aliases){
                        const toOverrideIndex = absoluteEntries.findIndex((entry)=>entry.name === alias || entry.aliases?.some((a)=>a === alias));
                        if (toOverrideIndex === -1) continue;
                        const toOverride = absoluteEntries[toOverrideIndex];
                        if (toOverride.step !== entry.step || entry.priority !== toOverride.priority) throw new Error(`"${$e1f49749b066298e$var$getMiddlewareNameWithAliases(toOverride.name, toOverride.aliases)}" middleware with ` + `${toOverride.priority} priority in ${toOverride.step} step cannot ` + `be overridden by "${$e1f49749b066298e$var$getMiddlewareNameWithAliases(name, _aliases)}" middleware with ` + `${entry.priority} priority in ${entry.step} step.`);
                        absoluteEntries.splice(toOverrideIndex, 1);
                    }
                }
                for (const alias of aliases)entriesNameSet.add(alias);
            }
            absoluteEntries.push(entry);
        },
        addRelativeTo: (middleware, options)=>{
            const { name: name, override: override, aliases: _aliases } = options;
            const entry = {
                middleware: middleware,
                ...options
            };
            const aliases = $e1f49749b066298e$var$getAllAliases(name, _aliases);
            if (aliases.length > 0) {
                if (aliases.some((alias)=>entriesNameSet.has(alias))) {
                    if (!override) throw new Error(`Duplicate middleware name '${$e1f49749b066298e$var$getMiddlewareNameWithAliases(name, _aliases)}'`);
                    for (const alias of aliases){
                        const toOverrideIndex = relativeEntries.findIndex((entry)=>entry.name === alias || entry.aliases?.some((a)=>a === alias));
                        if (toOverrideIndex === -1) continue;
                        const toOverride = relativeEntries[toOverrideIndex];
                        if (toOverride.toMiddleware !== entry.toMiddleware || toOverride.relation !== entry.relation) throw new Error(`"${$e1f49749b066298e$var$getMiddlewareNameWithAliases(toOverride.name, toOverride.aliases)}" middleware ` + `${toOverride.relation} "${toOverride.toMiddleware}" middleware cannot be overridden ` + `by "${$e1f49749b066298e$var$getMiddlewareNameWithAliases(name, _aliases)}" middleware ${entry.relation} ` + `"${entry.toMiddleware}" middleware.`);
                        relativeEntries.splice(toOverrideIndex, 1);
                    }
                }
                for (const alias of aliases)entriesNameSet.add(alias);
            }
            relativeEntries.push(entry);
        },
        clone: ()=>cloneTo($e1f49749b066298e$export$73604a93307363d8()),
        use: (plugin)=>{
            plugin.applyToStack(stack);
        },
        remove: (toRemove)=>{
            if (typeof toRemove === "string") return removeByName(toRemove);
            else return removeByReference(toRemove);
        },
        removeByTag: (toRemove)=>{
            let isRemoved = false;
            const filterCb = (entry)=>{
                const { tags: tags, name: name, aliases: _aliases } = entry;
                if (tags && tags.includes(toRemove)) {
                    const aliases = $e1f49749b066298e$var$getAllAliases(name, _aliases);
                    for (const alias of aliases)entriesNameSet.delete(alias);
                    isRemoved = true;
                    return false;
                }
                return true;
            };
            absoluteEntries = absoluteEntries.filter(filterCb);
            relativeEntries = relativeEntries.filter(filterCb);
            return isRemoved;
        },
        concat: (from)=>{
            const cloned = cloneTo($e1f49749b066298e$export$73604a93307363d8());
            cloned.use(from);
            cloned.identifyOnResolve(identifyOnResolve || cloned.identifyOnResolve() || (from.identifyOnResolve?.() ?? false));
            return cloned;
        },
        applyToStack: cloneTo,
        identify: ()=>{
            return getMiddlewareList(true).map((mw)=>{
                const step = mw.step ?? mw.relation + " " + mw.toMiddleware;
                return $e1f49749b066298e$var$getMiddlewareNameWithAliases(mw.name, mw.aliases) + " - " + step;
            });
        },
        identifyOnResolve (toggle) {
            if (typeof toggle === "boolean") identifyOnResolve = toggle;
            return identifyOnResolve;
        },
        resolve: (handler, context)=>{
            for (const middleware of getMiddlewareList().map((entry)=>entry.middleware).reverse())handler = middleware(handler, context);
            if (identifyOnResolve) console.log(stack.identify());
            return handler;
        }
    };
    return stack;
};
const $e1f49749b066298e$var$stepWeights = {
    initialize: 5,
    serialize: 4,
    build: 3,
    finalizeRequest: 2,
    deserialize: 1
};
const $e1f49749b066298e$var$priorityWeights = {
    high: 3,
    normal: 2,
    low: 1
};




class $514104a2dba81648$export$1f2bb630327ac4b6 {
    constructor(config){
        this.config = config;
        this.middlewareStack = (0, $e1f49749b066298e$export$73604a93307363d8)();
    }
    send(command, optionsOrCb, cb) {
        const options = typeof optionsOrCb !== "function" ? optionsOrCb : undefined;
        const callback = typeof optionsOrCb === "function" ? optionsOrCb : cb;
        const useHandlerCache = options === undefined && this.config.cacheMiddleware === true;
        let handler;
        if (useHandlerCache) {
            if (!this.handlers) this.handlers = new WeakMap();
            const handlers = this.handlers;
            if (handlers.has(command.constructor)) handler = handlers.get(command.constructor);
            else {
                handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
                handlers.set(command.constructor, handler);
            }
        } else {
            delete this.handlers;
            handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
        }
        if (callback) handler(command).then((result)=>callback(null, result.output), (err)=>callback(err)).catch(()=>{});
        else return handler(command).then((result)=>result.output);
    }
    destroy() {
        this.config?.requestHandler?.destroy?.();
        delete this.handlers;
    }
}







class $ec660c029325fe15$export$cc7e12c76513e857 {
    constructor(){
        this.middlewareStack = (0, $e1f49749b066298e$export$73604a93307363d8)();
    }
    static classBuilder() {
        return new $ec660c029325fe15$var$ClassBuilder();
    }
    resolveMiddlewareWithContext(clientStack, configuration, options, { middlewareFn: middlewareFn, clientName: clientName, commandName: commandName, inputFilterSensitiveLog: inputFilterSensitiveLog, outputFilterSensitiveLog: outputFilterSensitiveLog, smithyContext: smithyContext, additionalContext: additionalContext, CommandCtor: CommandCtor }) {
        for (const mw of middlewareFn.bind(this)(CommandCtor, clientStack, configuration, options))this.middlewareStack.use(mw);
        const stack = clientStack.concat(this.middlewareStack);
        const { logger: logger } = configuration;
        const handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: inputFilterSensitiveLog,
            outputFilterSensitiveLog: outputFilterSensitiveLog,
            [(0, $af1a654ad93bbd70$export$94e7bb1b8aa610cb)]: {
                commandInstance: this,
                ...smithyContext
            },
            ...additionalContext
        };
        const { requestHandler: requestHandler } = configuration;
        return stack.resolve((request)=>requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
}
class $ec660c029325fe15$var$ClassBuilder {
    constructor(){
        this._init = ()=>{};
        this._ep = {};
        this._middlewareFn = ()=>[];
        this._commandName = "";
        this._clientName = "";
        this._additionalContext = {};
        this._smithyContext = {};
        this._inputFilterSensitiveLog = (_)=>_;
        this._outputFilterSensitiveLog = (_)=>_;
        this._serializer = null;
        this._deserializer = null;
    }
    init(cb) {
        this._init = cb;
    }
    ep(endpointParameterInstructions) {
        this._ep = endpointParameterInstructions;
        return this;
    }
    m(middlewareSupplier) {
        this._middlewareFn = middlewareSupplier;
        return this;
    }
    s(service, operation, smithyContext = {}) {
        this._smithyContext = {
            service: service,
            operation: operation,
            ...smithyContext
        };
        return this;
    }
    c(additionalContext = {}) {
        this._additionalContext = additionalContext;
        return this;
    }
    n(clientName, commandName) {
        this._clientName = clientName;
        this._commandName = commandName;
        return this;
    }
    f(inputFilter = (_)=>_, outputFilter = (_)=>_) {
        this._inputFilterSensitiveLog = inputFilter;
        this._outputFilterSensitiveLog = outputFilter;
        return this;
    }
    ser(serializer) {
        this._serializer = serializer;
        return this;
    }
    de(deserializer) {
        this._deserializer = deserializer;
        return this;
    }
    build() {
        const closure = this;
        let CommandRef;
        return CommandRef = class extends $ec660c029325fe15$export$cc7e12c76513e857 {
            static getEndpointParameterInstructions() {
                return closure._ep;
            }
            constructor(...[input]){
                super();
                this.serialize = closure._serializer;
                this.deserialize = closure._deserializer;
                this.input = input ?? {};
                closure._init(this);
            }
            resolveMiddleware(stack, configuration, options) {
                return this.resolveMiddlewareWithContext(stack, configuration, options, {
                    CommandCtor: CommandRef,
                    middlewareFn: closure._middlewareFn,
                    clientName: closure._clientName,
                    commandName: closure._commandName,
                    inputFilterSensitiveLog: closure._inputFilterSensitiveLog,
                    outputFilterSensitiveLog: closure._outputFilterSensitiveLog,
                    smithyContext: closure._smithyContext,
                    additionalContext: closure._additionalContext
                });
            }
        };
    }
}


const $396b6e4de1f32a66$export$17127055dc9ac067 = "***SensitiveInformation***";


const $0e59f10d8a7cb014$export$d13079724e1f0e8b = (commands, Client)=>{
    for (const command of Object.keys(commands)){
        const CommandCtor = commands[command];
        const methodImpl = async function(args, optionsOrCb, cb) {
            const command = new CommandCtor(args);
            if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
            else if (typeof cb === "function") {
                if (typeof optionsOrCb !== "object") throw new Error(`Expected http options but got ${typeof optionsOrCb}`);
                this.send(command, optionsOrCb || {}, cb);
            } else return this.send(command, optionsOrCb);
        };
        const methodName = (command[0].toLowerCase() + command.slice(1)).replace(/Command$/, "");
        Client.prototype[methodName] = methodImpl;
    }
};


const $25d854afa944ccce$export$3fb54149990fb5b5 = (value)=>{
    switch(value){
        case "true":
            return true;
        case "false":
            return false;
        default:
            throw new Error(`Unable to parse boolean value "${value}"`);
    }
};
const $25d854afa944ccce$export$259b2ebfc29bf466 = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value === "number") {
        if (value === 0 || value === 1) $25d854afa944ccce$export$af88d00dbe7f521.warn($25d854afa944ccce$var$stackTraceWarning(`Expected boolean, got ${typeof value}: ${value}`));
        if (value === 0) return false;
        if (value === 1) return true;
    }
    if (typeof value === "string") {
        const lower = value.toLowerCase();
        if (lower === "false" || lower === "true") $25d854afa944ccce$export$af88d00dbe7f521.warn($25d854afa944ccce$var$stackTraceWarning(`Expected boolean, got ${typeof value}: ${value}`));
        if (lower === "false") return false;
        if (lower === "true") return true;
    }
    if (typeof value === "boolean") return value;
    throw new TypeError(`Expected boolean, got ${typeof value}: ${value}`);
};
const $25d854afa944ccce$export$f3945e48fdb5f9a = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value === "string") {
        const parsed = parseFloat(value);
        if (!Number.isNaN(parsed)) {
            if (String(parsed) !== String(value)) $25d854afa944ccce$export$af88d00dbe7f521.warn($25d854afa944ccce$var$stackTraceWarning(`Expected number but observed string: ${value}`));
            return parsed;
        }
    }
    if (typeof value === "number") return value;
    throw new TypeError(`Expected number, got ${typeof value}: ${value}`);
};
const $25d854afa944ccce$var$MAX_FLOAT = Math.ceil(2 ** 127 * (2 - 2 ** -23));
const $25d854afa944ccce$export$44880ec4d8d4909d = (value)=>{
    const expected = $25d854afa944ccce$export$f3945e48fdb5f9a(value);
    if (expected !== undefined && !Number.isNaN(expected) && expected !== Infinity && expected !== -Infinity) {
        if (Math.abs(expected) > $25d854afa944ccce$var$MAX_FLOAT) throw new TypeError(`Expected 32-bit float, got ${value}`);
    }
    return expected;
};
const $25d854afa944ccce$export$a883517a83c9c18 = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (Number.isInteger(value) && !Number.isNaN(value)) return value;
    throw new TypeError(`Expected integer, got ${typeof value}: ${value}`);
};
const $25d854afa944ccce$export$dbec7593c34ded08 = $25d854afa944ccce$export$a883517a83c9c18;
const $25d854afa944ccce$export$99c64e845cdac9c1 = (value)=>$25d854afa944ccce$var$expectSizedInt(value, 32);
const $25d854afa944ccce$export$d4f903340b146129 = (value)=>$25d854afa944ccce$var$expectSizedInt(value, 16);
const $25d854afa944ccce$export$3e4c4435b3b19562 = (value)=>$25d854afa944ccce$var$expectSizedInt(value, 8);
const $25d854afa944ccce$var$expectSizedInt = (value, size)=>{
    const expected = $25d854afa944ccce$export$a883517a83c9c18(value);
    if (expected !== undefined && $25d854afa944ccce$var$castInt(expected, size) !== expected) throw new TypeError(`Expected ${size}-bit integer, got ${value}`);
    return expected;
};
const $25d854afa944ccce$var$castInt = (value, size)=>{
    switch(size){
        case 32:
            return Int32Array.of(value)[0];
        case 16:
            return Int16Array.of(value)[0];
        case 8:
            return Int8Array.of(value)[0];
    }
};
const $25d854afa944ccce$export$8413a63dbe548a49 = (value, location)=>{
    if (value === null || value === undefined) {
        if (location) throw new TypeError(`Expected a non-null value for ${location}`);
        throw new TypeError("Expected a non-null value");
    }
    return value;
};
const $25d854afa944ccce$export$cf825aadce530e7e = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value === "object" && !Array.isArray(value)) return value;
    const receivedType = Array.isArray(value) ? "array" : typeof value;
    throw new TypeError(`Expected object, got ${receivedType}: ${value}`);
};
const $25d854afa944ccce$export$7ed80f53fe336639 = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value === "string") return value;
    if ([
        "boolean",
        "number",
        "bigint"
    ].includes(typeof value)) {
        $25d854afa944ccce$export$af88d00dbe7f521.warn($25d854afa944ccce$var$stackTraceWarning(`Expected string, got ${typeof value}: ${value}`));
        return String(value);
    }
    throw new TypeError(`Expected string, got ${typeof value}: ${value}`);
};
const $25d854afa944ccce$export$9ef77073e45b6301 = (value)=>{
    if (value === null || value === undefined) return undefined;
    const asObject = $25d854afa944ccce$export$cf825aadce530e7e(value);
    const setKeys = Object.entries(asObject).filter(([, v])=>v != null).map(([k])=>k);
    if (setKeys.length === 0) throw new TypeError(`Unions must have exactly one non-null member. None were found.`);
    if (setKeys.length > 1) throw new TypeError(`Unions must have exactly one non-null member. Keys ${setKeys} were not null.`);
    return asObject;
};
const $25d854afa944ccce$export$89e17ed633a86621 = (value)=>{
    if (typeof value == "string") return $25d854afa944ccce$export$f3945e48fdb5f9a($25d854afa944ccce$var$parseNumber(value));
    return $25d854afa944ccce$export$f3945e48fdb5f9a(value);
};
const $25d854afa944ccce$export$884f8e3b42a6cfbf = $25d854afa944ccce$export$89e17ed633a86621;
const $25d854afa944ccce$export$b15cbcea8b4c492f = (value)=>{
    if (typeof value == "string") return $25d854afa944ccce$export$44880ec4d8d4909d($25d854afa944ccce$var$parseNumber(value));
    return $25d854afa944ccce$export$44880ec4d8d4909d(value);
};
const $25d854afa944ccce$var$NUMBER_REGEX = /(-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?)|(-?Infinity)|(NaN)/g;
const $25d854afa944ccce$var$parseNumber = (value)=>{
    const matches = value.match($25d854afa944ccce$var$NUMBER_REGEX);
    if (matches === null || matches[0].length !== value.length) throw new TypeError(`Expected real number, got implicit NaN`);
    return parseFloat(value);
};
const $25d854afa944ccce$export$11335e83c8af2784 = (value)=>{
    if (typeof value == "string") return $25d854afa944ccce$var$parseFloatString(value);
    return $25d854afa944ccce$export$f3945e48fdb5f9a(value);
};
const $25d854afa944ccce$export$b6a7906d2e4b31df = $25d854afa944ccce$export$11335e83c8af2784;
const $25d854afa944ccce$export$50b04c19f942a079 = $25d854afa944ccce$export$11335e83c8af2784;
const $25d854afa944ccce$export$f14938f3036dd492 = (value)=>{
    if (typeof value == "string") return $25d854afa944ccce$var$parseFloatString(value);
    return $25d854afa944ccce$export$44880ec4d8d4909d(value);
};
const $25d854afa944ccce$var$parseFloatString = (value)=>{
    switch(value){
        case "NaN":
            return NaN;
        case "Infinity":
            return Infinity;
        case "-Infinity":
            return -Infinity;
        default:
            throw new Error(`Unable to parse float value: ${value}`);
    }
};
const $25d854afa944ccce$export$f90617f39a736d36 = (value)=>{
    if (typeof value === "string") return $25d854afa944ccce$export$a883517a83c9c18($25d854afa944ccce$var$parseNumber(value));
    return $25d854afa944ccce$export$a883517a83c9c18(value);
};
const $25d854afa944ccce$export$39b7be5d28a09fe1 = $25d854afa944ccce$export$f90617f39a736d36;
const $25d854afa944ccce$export$c3c2f00b115709e6 = (value)=>{
    if (typeof value === "string") return $25d854afa944ccce$export$99c64e845cdac9c1($25d854afa944ccce$var$parseNumber(value));
    return $25d854afa944ccce$export$99c64e845cdac9c1(value);
};
const $25d854afa944ccce$export$813d4a13f25c6b38 = (value)=>{
    if (typeof value === "string") return $25d854afa944ccce$export$d4f903340b146129($25d854afa944ccce$var$parseNumber(value));
    return $25d854afa944ccce$export$d4f903340b146129(value);
};
const $25d854afa944ccce$export$f18d20ea3b6b353 = (value)=>{
    if (typeof value === "string") return $25d854afa944ccce$export$3e4c4435b3b19562($25d854afa944ccce$var$parseNumber(value));
    return $25d854afa944ccce$export$3e4c4435b3b19562(value);
};
const $25d854afa944ccce$var$stackTraceWarning = (message)=>{
    return String(new TypeError(message).stack || message).split("\n").slice(0, 5).filter((s)=>!s.includes("stackTraceWarning")).join("\n");
};
const $25d854afa944ccce$export$af88d00dbe7f521 = {
    warn: console.warn
};


const $d8696255fcc0b769$var$DAYS = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
const $d8696255fcc0b769$var$MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
function $d8696255fcc0b769$export$5b50865171ed23a9(date) {
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth();
    const dayOfWeek = date.getUTCDay();
    const dayOfMonthInt = date.getUTCDate();
    const hoursInt = date.getUTCHours();
    const minutesInt = date.getUTCMinutes();
    const secondsInt = date.getUTCSeconds();
    const dayOfMonthString = dayOfMonthInt < 10 ? `0${dayOfMonthInt}` : `${dayOfMonthInt}`;
    const hoursString = hoursInt < 10 ? `0${hoursInt}` : `${hoursInt}`;
    const minutesString = minutesInt < 10 ? `0${minutesInt}` : `${minutesInt}`;
    const secondsString = secondsInt < 10 ? `0${secondsInt}` : `${secondsInt}`;
    return `${$d8696255fcc0b769$var$DAYS[dayOfWeek]}, ${dayOfMonthString} ${$d8696255fcc0b769$var$MONTHS[month]} ${year} ${hoursString}:${minutesString}:${secondsString} GMT`;
}
const $d8696255fcc0b769$var$RFC3339 = new RegExp(/^(\d{4})-(\d{2})-(\d{2})[tT](\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?[zZ]$/);
const $d8696255fcc0b769$export$202e14f4d6038b6c = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-3339 date-times must be expressed as strings");
    const match = $d8696255fcc0b769$var$RFC3339.exec(value);
    if (!match) throw new TypeError("Invalid RFC-3339 date-time value");
    const [_, yearStr, monthStr, dayStr, hours, minutes, seconds, fractionalMilliseconds] = match;
    const year = (0, $25d854afa944ccce$export$813d4a13f25c6b38)($d8696255fcc0b769$var$stripLeadingZeroes(yearStr));
    const month = $d8696255fcc0b769$var$parseDateValue(monthStr, "month", 1, 12);
    const day = $d8696255fcc0b769$var$parseDateValue(dayStr, "day", 1, 31);
    return $d8696255fcc0b769$var$buildDate(year, month, day, {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        fractionalMilliseconds: fractionalMilliseconds
    });
};
const $d8696255fcc0b769$var$RFC3339_WITH_OFFSET = new RegExp(/^(\d{4})-(\d{2})-(\d{2})[tT](\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?(([-+]\d{2}\:\d{2})|[zZ])$/);
const $d8696255fcc0b769$export$3cb821e2875b4b7d = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-3339 date-times must be expressed as strings");
    const match = $d8696255fcc0b769$var$RFC3339_WITH_OFFSET.exec(value);
    if (!match) throw new TypeError("Invalid RFC-3339 date-time value");
    const [_, yearStr, monthStr, dayStr, hours, minutes, seconds, fractionalMilliseconds, offsetStr] = match;
    const year = (0, $25d854afa944ccce$export$813d4a13f25c6b38)($d8696255fcc0b769$var$stripLeadingZeroes(yearStr));
    const month = $d8696255fcc0b769$var$parseDateValue(monthStr, "month", 1, 12);
    const day = $d8696255fcc0b769$var$parseDateValue(dayStr, "day", 1, 31);
    const date = $d8696255fcc0b769$var$buildDate(year, month, day, {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        fractionalMilliseconds: fractionalMilliseconds
    });
    if (offsetStr.toUpperCase() != "Z") date.setTime(date.getTime() - $d8696255fcc0b769$var$parseOffsetToMilliseconds(offsetStr));
    return date;
};
const $d8696255fcc0b769$var$IMF_FIXDATE = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d{2}) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
const $d8696255fcc0b769$var$RFC_850_DATE = new RegExp(/^(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d{2})-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
const $d8696255fcc0b769$var$ASC_TIME = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( [1-9]|\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? (\d{4})$/);
const $d8696255fcc0b769$export$cf3a566289648a1e = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-7231 date-times must be expressed as strings");
    let match = $d8696255fcc0b769$var$IMF_FIXDATE.exec(value);
    if (match) {
        const [_, dayStr, monthStr, yearStr, hours, minutes, seconds, fractionalMilliseconds] = match;
        return $d8696255fcc0b769$var$buildDate((0, $25d854afa944ccce$export$813d4a13f25c6b38)($d8696255fcc0b769$var$stripLeadingZeroes(yearStr)), $d8696255fcc0b769$var$parseMonthByShortName(monthStr), $d8696255fcc0b769$var$parseDateValue(dayStr, "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        });
    }
    match = $d8696255fcc0b769$var$RFC_850_DATE.exec(value);
    if (match) {
        const [_, dayStr, monthStr, yearStr, hours, minutes, seconds, fractionalMilliseconds] = match;
        return $d8696255fcc0b769$var$adjustRfc850Year($d8696255fcc0b769$var$buildDate($d8696255fcc0b769$var$parseTwoDigitYear(yearStr), $d8696255fcc0b769$var$parseMonthByShortName(monthStr), $d8696255fcc0b769$var$parseDateValue(dayStr, "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        }));
    }
    match = $d8696255fcc0b769$var$ASC_TIME.exec(value);
    if (match) {
        const [_, monthStr, dayStr, hours, minutes, seconds, fractionalMilliseconds, yearStr] = match;
        return $d8696255fcc0b769$var$buildDate((0, $25d854afa944ccce$export$813d4a13f25c6b38)($d8696255fcc0b769$var$stripLeadingZeroes(yearStr)), $d8696255fcc0b769$var$parseMonthByShortName(monthStr), $d8696255fcc0b769$var$parseDateValue(dayStr.trimLeft(), "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        });
    }
    throw new TypeError("Invalid RFC-7231 date-time value");
};
const $d8696255fcc0b769$export$685da212e4e79e10 = (value)=>{
    if (value === null || value === undefined) return undefined;
    let valueAsDouble;
    if (typeof value === "number") valueAsDouble = value;
    else if (typeof value === "string") valueAsDouble = (0, $25d854afa944ccce$export$89e17ed633a86621)(value);
    else if (typeof value === "object" && value.tag === 1) valueAsDouble = value.value;
    else throw new TypeError("Epoch timestamps must be expressed as floating point numbers or their string representation");
    if (Number.isNaN(valueAsDouble) || valueAsDouble === Infinity || valueAsDouble === -Infinity) throw new TypeError("Epoch timestamps must be valid, non-Infinite, non-NaN numerics");
    return new Date(Math.round(valueAsDouble * 1000));
};
const $d8696255fcc0b769$var$buildDate = (year, month, day, time)=>{
    const adjustedMonth = month - 1;
    $d8696255fcc0b769$var$validateDayOfMonth(year, adjustedMonth, day);
    return new Date(Date.UTC(year, adjustedMonth, day, $d8696255fcc0b769$var$parseDateValue(time.hours, "hour", 0, 23), $d8696255fcc0b769$var$parseDateValue(time.minutes, "minute", 0, 59), $d8696255fcc0b769$var$parseDateValue(time.seconds, "seconds", 0, 60), $d8696255fcc0b769$var$parseMilliseconds(time.fractionalMilliseconds)));
};
const $d8696255fcc0b769$var$parseTwoDigitYear = (value)=>{
    const thisYear = new Date().getUTCFullYear();
    const valueInThisCentury = Math.floor(thisYear / 100) * 100 + (0, $25d854afa944ccce$export$813d4a13f25c6b38)($d8696255fcc0b769$var$stripLeadingZeroes(value));
    if (valueInThisCentury < thisYear) return valueInThisCentury + 100;
    return valueInThisCentury;
};
const $d8696255fcc0b769$var$FIFTY_YEARS_IN_MILLIS = 1576800000000;
const $d8696255fcc0b769$var$adjustRfc850Year = (input)=>{
    if (input.getTime() - new Date().getTime() > $d8696255fcc0b769$var$FIFTY_YEARS_IN_MILLIS) return new Date(Date.UTC(input.getUTCFullYear() - 100, input.getUTCMonth(), input.getUTCDate(), input.getUTCHours(), input.getUTCMinutes(), input.getUTCSeconds(), input.getUTCMilliseconds()));
    return input;
};
const $d8696255fcc0b769$var$parseMonthByShortName = (value)=>{
    const monthIdx = $d8696255fcc0b769$var$MONTHS.indexOf(value);
    if (monthIdx < 0) throw new TypeError(`Invalid month: ${value}`);
    return monthIdx + 1;
};
const $d8696255fcc0b769$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $d8696255fcc0b769$var$validateDayOfMonth = (year, month, day)=>{
    let maxDays = $d8696255fcc0b769$var$DAYS_IN_MONTH[month];
    if (month === 1 && $d8696255fcc0b769$var$isLeapYear(year)) maxDays = 29;
    if (day > maxDays) throw new TypeError(`Invalid day for ${$d8696255fcc0b769$var$MONTHS[month]} in ${year}: ${day}`);
};
const $d8696255fcc0b769$var$isLeapYear = (year)=>{
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
};
const $d8696255fcc0b769$var$parseDateValue = (value, type, lower, upper)=>{
    const dateVal = (0, $25d854afa944ccce$export$f18d20ea3b6b353)($d8696255fcc0b769$var$stripLeadingZeroes(value));
    if (dateVal < lower || dateVal > upper) throw new TypeError(`${type} must be between ${lower} and ${upper}, inclusive`);
    return dateVal;
};
const $d8696255fcc0b769$var$parseMilliseconds = (value)=>{
    if (value === null || value === undefined) return 0;
    return (0, $25d854afa944ccce$export$b15cbcea8b4c492f)("0." + value) * 1000;
};
const $d8696255fcc0b769$var$parseOffsetToMilliseconds = (value)=>{
    const directionStr = value[0];
    let direction = 1;
    if (directionStr == "+") direction = 1;
    else if (directionStr == "-") direction = -1;
    else throw new TypeError(`Offset direction, ${directionStr}, must be "+" or "-"`);
    const hour = Number(value.substring(1, 3));
    const minute = Number(value.substring(4, 6));
    return direction * (hour * 60 + minute) * 60000;
};
const $d8696255fcc0b769$var$stripLeadingZeroes = (value)=>{
    let idx = 0;
    while(idx < value.length - 1 && value.charAt(idx) === "0")idx++;
    if (idx === 0) return value;
    return value.slice(idx);
};


class $11a0343ffd48eaff$export$29647f3b4097d3c0 extends Error {
    constructor(options){
        super(options.message);
        Object.setPrototypeOf(this, Object.getPrototypeOf(this).constructor.prototype);
        this.name = options.name;
        this.$fault = options.$fault;
        this.$metadata = options.$metadata;
    }
    static isInstance(value) {
        if (!value) return false;
        const candidate = value;
        return Boolean(candidate.$fault) && Boolean(candidate.$metadata) && (candidate.$fault === "client" || candidate.$fault === "server");
    }
    static [Symbol.hasInstance](instance) {
        if (!instance) return false;
        const candidate = instance;
        if (this === $11a0343ffd48eaff$export$29647f3b4097d3c0) return $11a0343ffd48eaff$export$29647f3b4097d3c0.isInstance(instance);
        if ($11a0343ffd48eaff$export$29647f3b4097d3c0.isInstance(instance)) {
            if (candidate.name && this.name) return this.prototype.isPrototypeOf(instance) || candidate.name === this.name;
            return this.prototype.isPrototypeOf(instance);
        }
        return false;
    }
}
const $11a0343ffd48eaff$export$db01f0c43e877a50 = (exception, additions = {})=>{
    Object.entries(additions).filter(([, v])=>v !== undefined).forEach(([k, v])=>{
        if (exception[k] == undefined || exception[k] === "") exception[k] = v;
    });
    const message = exception.message || exception.Message || "UnknownError";
    exception.message = message;
    delete exception.Message;
    return exception;
};


const $1a84bff7daff0761$export$3df0f68aaf858737 = ({ output: output, parsedBody: parsedBody, exceptionCtor: exceptionCtor, errorCode: errorCode })=>{
    const $metadata = $1a84bff7daff0761$var$deserializeMetadata(output);
    const statusCode = $metadata.httpStatusCode ? $metadata.httpStatusCode + "" : undefined;
    const response = new exceptionCtor({
        name: parsedBody?.code || parsedBody?.Code || errorCode || statusCode || "UnknownError",
        $fault: "client",
        $metadata: $metadata
    });
    throw (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(response, parsedBody);
};
const $1a84bff7daff0761$export$62ac8acba1748a85 = (ExceptionCtor)=>{
    return ({ output: output, parsedBody: parsedBody, errorCode: errorCode })=>{
        $1a84bff7daff0761$export$3df0f68aaf858737({
            output: output,
            parsedBody: parsedBody,
            exceptionCtor: ExceptionCtor,
            errorCode: errorCode
        });
    };
};
const $1a84bff7daff0761$var$deserializeMetadata = (output)=>({
        httpStatusCode: output.statusCode,
        requestId: output.headers["x-amzn-requestid"] ?? output.headers["x-amzn-request-id"] ?? output.headers["x-amz-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    });


const $9ab7bd0f453434be$export$b6e2b46631b45a92 = (mode)=>{
    switch(mode){
        case "standard":
            return {
                retryMode: "standard",
                connectionTimeout: 3100
            };
        case "in-region":
            return {
                retryMode: "standard",
                connectionTimeout: 1100
            };
        case "cross-region":
            return {
                retryMode: "standard",
                connectionTimeout: 3100
            };
        case "mobile":
            return {
                retryMode: "standard",
                connectionTimeout: 30000
            };
        default:
            return {};
    }
};


let $2a6be3c3c4813620$var$warningEmitted = false;
const $2a6be3c3c4813620$export$96550b8fa3e6f65a = (version)=>{
    if (version && !$2a6be3c3c4813620$var$warningEmitted && parseInt(version.substring(1, version.indexOf("."))) < 16) $2a6be3c3c4813620$var$warningEmitted = true;
};







const $89f01de3dc4ef4b7$export$129b301e72591856 = (runtimeConfig)=>{
    const checksumAlgorithms = [];
    for(const id in 0, $2bc5d4a467996ea0$export$fe562bf21391d1f0){
        const algorithmId = (0, $2bc5d4a467996ea0$export$fe562bf21391d1f0)[id];
        if (runtimeConfig[algorithmId] === undefined) continue;
        checksumAlgorithms.push({
            algorithmId: ()=>algorithmId,
            checksumConstructor: ()=>runtimeConfig[algorithmId]
        });
    }
    return {
        _checksumAlgorithms: checksumAlgorithms,
        addChecksumAlgorithm (algo) {
            this._checksumAlgorithms.push(algo);
        },
        checksumAlgorithms () {
            return this._checksumAlgorithms;
        }
    };
};
const $89f01de3dc4ef4b7$export$589dfc268e61d391 = (clientConfig)=>{
    const runtimeConfig = {};
    clientConfig.checksumAlgorithms().forEach((checksumAlgorithm)=>{
        runtimeConfig[checksumAlgorithm.algorithmId()] = checksumAlgorithm.checksumConstructor();
    });
    return runtimeConfig;
};


const $649fde16a2b2cda6$export$d36c8ee6d99d60f7 = (runtimeConfig)=>{
    let _retryStrategy = runtimeConfig.retryStrategy;
    return {
        setRetryStrategy (retryStrategy) {
            _retryStrategy = retryStrategy;
        },
        retryStrategy () {
            return _retryStrategy;
        }
    };
};
const $649fde16a2b2cda6$export$67f4c4448e6afddf = (retryStrategyConfiguration)=>{
    const runtimeConfig = {};
    runtimeConfig.retryStrategy = retryStrategyConfiguration.retryStrategy();
    return runtimeConfig;
};


const $cef2627dbb2c7da1$export$2d53aaae46f156f5 = (runtimeConfig)=>{
    return {
        ...(0, $89f01de3dc4ef4b7$export$129b301e72591856)(runtimeConfig),
        ...(0, $649fde16a2b2cda6$export$d36c8ee6d99d60f7)(runtimeConfig)
    };
};
const $cef2627dbb2c7da1$export$7081660fd0cd662b = $cef2627dbb2c7da1$export$2d53aaae46f156f5;
const $cef2627dbb2c7da1$export$abfa28b95316e0ae = (config)=>{
    return {
        ...(0, $89f01de3dc4ef4b7$export$589dfc268e61d391)(config),
        ...(0, $649fde16a2b2cda6$export$67f4c4448e6afddf)(config)
    };
};




const $56e0591c3f24ef11$export$52272e038712c64e = (mayBeArray)=>Array.isArray(mayBeArray) ? mayBeArray : [
        mayBeArray
    ];


const $530e8cd29c174186$export$113d90026b452881 = (obj)=>{
    const textNodeName = "#text";
    for(const key in obj){
        if (obj.hasOwnProperty(key) && obj[key][textNodeName] !== undefined) obj[key] = obj[key][textNodeName];
        else if (typeof obj[key] === "object" && obj[key] !== null) obj[key] = $530e8cd29c174186$export$113d90026b452881(obj[key]);
    }
    return obj;
};


const $9cc297ee2c171018$export$f25742720bcd7d1c = (value)=>{
    return value != null;
};


const $30728d209297535b$export$494ed5148690ecaf = function LazyJsonString(val) {
    const str = Object.assign(new String(val), {
        deserializeJSON () {
            return JSON.parse(String(val));
        },
        toString () {
            return String(val);
        },
        toJSON () {
            return String(val);
        }
    });
    return str;
};
$30728d209297535b$export$494ed5148690ecaf.from = (object)=>{
    if (object && typeof object === "object" && (object instanceof $30728d209297535b$export$494ed5148690ecaf || "deserializeJSON" in object)) return object;
    else if (typeof object === "string" || Object.getPrototypeOf(object) === String.prototype) return $30728d209297535b$export$494ed5148690ecaf(String(object));
    return $30728d209297535b$export$494ed5148690ecaf(JSON.stringify(object));
};
$30728d209297535b$export$494ed5148690ecaf.fromObject = $30728d209297535b$export$494ed5148690ecaf.from;


class $c9caefe05bf12396$export$4147bde06f294c2e {
    trace() {}
    debug() {}
    info() {}
    warn() {}
    error() {}
}


function $07e9587fb0c3a3de$export$871de8747c9eaa88(arg0, arg1, arg2) {
    let target;
    let filter;
    let instructions;
    if (typeof arg1 === "undefined" && typeof arg2 === "undefined") {
        target = {};
        instructions = arg0;
    } else {
        target = arg0;
        if (typeof arg1 === "function") {
            filter = arg1;
            instructions = arg2;
            return $07e9587fb0c3a3de$var$mapWithFilter(target, filter, instructions);
        } else instructions = arg1;
    }
    for (const key of Object.keys(instructions)){
        if (!Array.isArray(instructions[key])) {
            target[key] = instructions[key];
            continue;
        }
        $07e9587fb0c3a3de$var$applyInstruction(target, null, instructions, key);
    }
    return target;
}
const $07e9587fb0c3a3de$export$a2c0df515c751f13 = (target)=>{
    const output = {};
    for (const [k, v] of Object.entries(target || {}))output[k] = [
        ,
        v
    ];
    return output;
};
const $07e9587fb0c3a3de$export$b7df5d561049483a = (source, instructions)=>{
    const out = {};
    for(const key in instructions)$07e9587fb0c3a3de$var$applyInstruction(out, source, instructions, key);
    return out;
};
const $07e9587fb0c3a3de$var$mapWithFilter = (target, filter, instructions)=>{
    return $07e9587fb0c3a3de$export$871de8747c9eaa88(target, Object.entries(instructions).reduce((_instructions, [key, value])=>{
        if (Array.isArray(value)) _instructions[key] = value;
        else if (typeof value === "function") _instructions[key] = [
            filter,
            value()
        ];
        else _instructions[key] = [
            filter,
            value
        ];
        return _instructions;
    }, {}));
};
const $07e9587fb0c3a3de$var$applyInstruction = (target, source, instructions, targetKey)=>{
    if (source !== null) {
        let instruction = instructions[targetKey];
        if (typeof instruction === "function") instruction = [
            ,
            instruction
        ];
        const [filter = $07e9587fb0c3a3de$var$nonNullish, valueFn = $07e9587fb0c3a3de$var$pass, sourceKey = targetKey] = instruction;
        if (typeof filter === "function" && filter(source[sourceKey]) || typeof filter !== "function" && !!filter) target[targetKey] = valueFn(source[sourceKey]);
        return;
    }
    let [filter, value] = instructions[targetKey];
    if (typeof value === "function") {
        let _value;
        const defaultFilterPassed = filter === undefined && (_value = value()) != null;
        const customFilterPassed = typeof filter === "function" && !!filter(void 0) || typeof filter !== "function" && !!filter;
        if (defaultFilterPassed) target[targetKey] = _value;
        else if (customFilterPassed) target[targetKey] = value();
    } else {
        const defaultFilterPassed = filter === undefined && value != null;
        const customFilterPassed = typeof filter === "function" && !!filter(value) || typeof filter !== "function" && !!filter;
        if (defaultFilterPassed || customFilterPassed) target[targetKey] = value;
    }
};
const $07e9587fb0c3a3de$var$nonNullish = (_)=>_ != null;
const $07e9587fb0c3a3de$var$pass = (_)=>_;



function $2eb7b6bcaab0020e$export$1595c73d061e3431(part) {
    if (part.includes(",") || part.includes('"')) part = `"${part.replace(/"/g, '\\"')}"`;
    return part;
}





const $2af401769ccb273e$export$4a2bea4ecaa09ba7 = (value)=>{
    if (value !== value) return "NaN";
    switch(value){
        case Infinity:
            return "Infinity";
        case -Infinity:
            return "-Infinity";
        default:
            return value;
    }
};
const $2af401769ccb273e$export$93f3a0dd288ea1c8 = (date)=>date.toISOString().replace(".000Z", "Z");


const $ccedd6b7948e7cea$export$e0ede334cf6ab53c = (obj)=>{
    if (obj == null) return {};
    if (Array.isArray(obj)) return obj.filter((_)=>_ != null).map($ccedd6b7948e7cea$export$e0ede334cf6ab53c);
    if (typeof obj === "object") {
        const target = {};
        for (const key of Object.keys(obj)){
            if (obj[key] == null) continue;
            target[key] = $ccedd6b7948e7cea$export$e0ede334cf6ab53c(obj[key]);
        }
        return target;
    }
    return obj;
};


function $5b46b3068458bcd5$export$b0cd0cd33296db41(value, delimiter, numDelimiters) {
    if (numDelimiters <= 0 || !Number.isInteger(numDelimiters)) throw new Error("Invalid number of delimiters (" + numDelimiters + ") for splitEvery.");
    const segments = value.split(delimiter);
    if (numDelimiters === 1) return segments;
    const compoundSegments = [];
    let currentSegment = "";
    for(let i = 0; i < segments.length; i++){
        if (currentSegment === "") currentSegment = segments[i];
        else currentSegment += delimiter + segments[i];
        if ((i + 1) % numDelimiters === 0) {
            compoundSegments.push(currentSegment);
            currentSegment = "";
        }
    }
    if (currentSegment !== "") compoundSegments.push(currentSegment);
    return compoundSegments;
}


const $fdbf76d9e8578328$export$a7d670292ef99aa7 = (value)=>{
    const z = value.length;
    const values = [];
    let withinQuotes = false;
    let prevChar = undefined;
    let anchor = 0;
    for(let i = 0; i < z; ++i){
        const char = value[i];
        switch(char){
            case `"`:
                if (prevChar !== "\\") withinQuotes = !withinQuotes;
                break;
            case ",":
                if (!withinQuotes) {
                    values.push(value.slice(anchor, i));
                    anchor = i + 1;
                }
                break;
            default:
        }
        prevChar = char;
    }
    values.push(value.slice(anchor));
    return values.map((v)=>{
        v = v.trim();
        const z = v.length;
        if (z < 2) return v;
        if (v[0] === `"` && v[z - 1] === `"`) v = v.slice(1, z - 1);
        return v.replace(/\\"/g, '"');
    });
};






const $2bdf2f2a42ef95fc$export$e29b4465f2a53696 = (request)=>request?.body instanceof ReadableStream;



const $9ba3cc7a799aee7e$export$a3922aa5f87bae85 = (options)=>(next, context)=>async (args)=>{
            let retryStrategy = await options.retryStrategy();
            const maxAttempts = await options.maxAttempts();
            if ($9ba3cc7a799aee7e$var$isRetryStrategyV2(retryStrategy)) {
                retryStrategy;
                let retryToken = await retryStrategy.acquireInitialRetryToken(context["partition_id"]);
                let lastError = new Error();
                let attempts = 0;
                let totalRetryDelay = 0;
                const { request: request } = args;
                const isRequest = (0, $36c92c5bbc6e0688$export$7587955500404ec3).isInstance(request);
                if (isRequest) request.headers[0, $814f300a8e809846$export$197fd517bf66ccb2] = (0, $f1f451188ec334c2$export$2e2bcd8739ae039)();
                while(true)try {
                    if (isRequest) request.headers[0, $814f300a8e809846$export$d4f764f0ec4f52f] = `attempt=${attempts + 1}; max=${maxAttempts}`;
                    const { response: response, output: output } = await next(args);
                    retryStrategy.recordSuccess(retryToken);
                    output.$metadata.attempts = attempts + 1;
                    output.$metadata.totalRetryDelay = totalRetryDelay;
                    return {
                        response: response,
                        output: output
                    };
                } catch (e) {
                    const retryErrorInfo = $9ba3cc7a799aee7e$var$getRetryErrorInfo(e);
                    lastError = (0, $d79467642a9d77cd$export$c780f8210b6eca50)(e);
                    if (isRequest && (0, $2bdf2f2a42ef95fc$export$e29b4465f2a53696)(request)) {
                        (context.logger instanceof (0, $c9caefe05bf12396$export$4147bde06f294c2e) ? console : context.logger)?.warn("An error was encountered in a non-retryable streaming request.");
                        throw lastError;
                    }
                    try {
                        retryToken = await retryStrategy.refreshRetryTokenForRetry(retryToken, retryErrorInfo);
                    } catch (refreshError) {
                        if (!lastError.$metadata) lastError.$metadata = {};
                        lastError.$metadata.attempts = attempts + 1;
                        lastError.$metadata.totalRetryDelay = totalRetryDelay;
                        throw lastError;
                    }
                    attempts = retryToken.getRetryCount();
                    const delay = retryToken.getRetryDelay();
                    totalRetryDelay += delay;
                    await new Promise((resolve)=>setTimeout(resolve, delay));
                }
            } else {
                retryStrategy;
                if (retryStrategy?.mode) context.userAgent = [
                    ...context.userAgent || [],
                    [
                        "cfg/retry-mode",
                        retryStrategy.mode
                    ]
                ];
                return retryStrategy.retry(next, args);
            }
        };
const $9ba3cc7a799aee7e$var$isRetryStrategyV2 = (retryStrategy)=>typeof retryStrategy.acquireInitialRetryToken !== "undefined" && typeof retryStrategy.refreshRetryTokenForRetry !== "undefined" && typeof retryStrategy.recordSuccess !== "undefined";
const $9ba3cc7a799aee7e$var$getRetryErrorInfo = (error)=>{
    const errorInfo = {
        error: error,
        errorType: $9ba3cc7a799aee7e$var$getRetryErrorType(error)
    };
    const retryAfterHint = $9ba3cc7a799aee7e$export$8f45b27d98dcedff(error.$response);
    if (retryAfterHint) errorInfo.retryAfterHint = retryAfterHint;
    return errorInfo;
};
const $9ba3cc7a799aee7e$var$getRetryErrorType = (error)=>{
    if ((0, $93a61470f9cadb28$export$cbecb89f6256ccc8)(error)) return "THROTTLING";
    if ((0, $93a61470f9cadb28$export$31778435da988512)(error)) return "TRANSIENT";
    if ((0, $93a61470f9cadb28$export$a7cbe72d7c4012af)(error)) return "SERVER_ERROR";
    return "CLIENT_ERROR";
};
const $9ba3cc7a799aee7e$export$44d3d03587957ce9 = {
    name: "retryMiddleware",
    tags: [
        "RETRY"
    ],
    step: "finalizeRequest",
    priority: "high",
    override: true
};
const $9ba3cc7a799aee7e$export$c73199e2b1df9340 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($9ba3cc7a799aee7e$export$a3922aa5f87bae85(options), $9ba3cc7a799aee7e$export$44d3d03587957ce9);
        }
    });
const $9ba3cc7a799aee7e$export$8f45b27d98dcedff = (response)=>{
    if (!(0, $719e5a813689e03b$export$1d94dfe0d9d1f1e7).isInstance(response)) return;
    const retryAfterHeaderName = Object.keys(response.headers).find((key)=>key.toLowerCase() === "retry-after");
    if (!retryAfterHeaderName) return;
    const retryAfter = response.headers[retryAfterHeaderName];
    const retryAfterSeconds = Number(retryAfter);
    if (!Number.isNaN(retryAfterSeconds)) return new Date(retryAfterSeconds * 1000);
    const retryAfterDate = new Date(retryAfter);
    return retryAfterDate;
};





function $7da50fd8c81c8743$export$5948d889008373f3(credentials, feature, value) {
    if (!credentials.$source) credentials.$source = {};
    credentials.$source[feature] = value;
    return credentials;
}







const $a8755e04fd758a20$export$186cd8495ba0377d = "X-Amz-Algorithm";
const $a8755e04fd758a20$export$5c8e6dd7758f59d6 = "X-Amz-Credential";
const $a8755e04fd758a20$export$6e114beec37430d7 = "X-Amz-Date";
const $a8755e04fd758a20$export$2dcbb254f883c238 = "X-Amz-SignedHeaders";
const $a8755e04fd758a20$export$a0afe6f3bbfaf76e = "X-Amz-Expires";
const $a8755e04fd758a20$export$41ae838dc1e0f082 = "X-Amz-Signature";
const $a8755e04fd758a20$export$8e1383b7eea7bee = "X-Amz-Security-Token";
const $a8755e04fd758a20$export$296a4bada3fe6343 = "X-Amz-Region-Set";
const $a8755e04fd758a20$export$9924a64a4b8b0d58 = "authorization";
const $a8755e04fd758a20$export$acf4b8bdf24aab34 = $a8755e04fd758a20$export$6e114beec37430d7.toLowerCase();
const $a8755e04fd758a20$export$c65c8c9f514da472 = "date";
const $a8755e04fd758a20$export$20d6a73fd0b10982 = [
    $a8755e04fd758a20$export$9924a64a4b8b0d58,
    $a8755e04fd758a20$export$acf4b8bdf24aab34,
    $a8755e04fd758a20$export$c65c8c9f514da472
];
const $a8755e04fd758a20$export$29961f34c719157e = $a8755e04fd758a20$export$41ae838dc1e0f082.toLowerCase();
const $a8755e04fd758a20$export$eaef12179141669a = "x-amz-content-sha256";
const $a8755e04fd758a20$export$fdc81b663012a8d2 = $a8755e04fd758a20$export$8e1383b7eea7bee.toLowerCase();
const $a8755e04fd758a20$export$96307741595055fc = "host";
const $a8755e04fd758a20$export$8ffdcd58c4092560 = {
    authorization: true,
    "cache-control": true,
    connection: true,
    expect: true,
    from: true,
    "keep-alive": true,
    "max-forwards": true,
    pragma: true,
    referer: true,
    te: true,
    trailer: true,
    "transfer-encoding": true,
    upgrade: true,
    "user-agent": true,
    "x-amzn-trace-id": true
};
const $a8755e04fd758a20$export$8085db98abbe0597 = /^proxy-/;
const $a8755e04fd758a20$export$758380400526c39 = /^sec-/;
const $a8755e04fd758a20$export$94e2b626bfa803e0 = [
    /^proxy-/i,
    /^sec-/i
];
const $a8755e04fd758a20$export$863a63fba5b2ddf5 = "AWS4-HMAC-SHA256";
const $a8755e04fd758a20$export$7ad82ab3c556a776 = "AWS4-ECDSA-P256-SHA256";
const $a8755e04fd758a20$export$9a1f6cf06ac56167 = "AWS4-HMAC-SHA256-PAYLOAD";
const $a8755e04fd758a20$export$91f7321b40d9fd07 = "UNSIGNED-PAYLOAD";
const $a8755e04fd758a20$export$bf665777b4a1722f = 50;
const $a8755e04fd758a20$export$c4bf0942098f6bb = "aws4_request";
const $a8755e04fd758a20$export$274df788bdcca184 = 604800;





const $e0339a45d3bd683e$var$signingKeyCache = {};
const $e0339a45d3bd683e$var$cacheQueue = [];
const $e0339a45d3bd683e$export$41a9651decfe2bde = (shortDate, region, service)=>`${shortDate}/${region}/${service}/${0, $a8755e04fd758a20$export$c4bf0942098f6bb}`;
const $e0339a45d3bd683e$export$8b95a069d16dd783 = async (sha256Constructor, credentials, shortDate, region, service)=>{
    const credsHash = await $e0339a45d3bd683e$var$hmac(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId);
    const cacheKey = `${shortDate}:${region}:${service}:${(0, $e3760e64f3fec34b$export$7ea66e3774a60b67)(credsHash)}:${credentials.sessionToken}`;
    if (cacheKey in $e0339a45d3bd683e$var$signingKeyCache) return $e0339a45d3bd683e$var$signingKeyCache[cacheKey];
    $e0339a45d3bd683e$var$cacheQueue.push(cacheKey);
    while($e0339a45d3bd683e$var$cacheQueue.length > (0, $a8755e04fd758a20$export$bf665777b4a1722f))delete $e0339a45d3bd683e$var$signingKeyCache[$e0339a45d3bd683e$var$cacheQueue.shift()];
    let key = `AWS4${credentials.secretAccessKey}`;
    for (const signable of [
        shortDate,
        region,
        service,
        (0, $a8755e04fd758a20$export$c4bf0942098f6bb)
    ])key = await $e0339a45d3bd683e$var$hmac(sha256Constructor, key, signable);
    return $e0339a45d3bd683e$var$signingKeyCache[cacheKey] = key;
};
const $e0339a45d3bd683e$export$a31b95746ea0a30a = ()=>{
    $e0339a45d3bd683e$var$cacheQueue.length = 0;
    Object.keys($e0339a45d3bd683e$var$signingKeyCache).forEach((cacheKey)=>{
        delete $e0339a45d3bd683e$var$signingKeyCache[cacheKey];
    });
};
const $e0339a45d3bd683e$var$hmac = (ctor, secret, data)=>{
    const hash = new ctor(secret);
    hash.update((0, $e75b5fa6fbe27b3f$export$73470fd2221e6aef)(data));
    return hash.digest();
};



const $bed1d102d0d23906$export$859d7f1bb55e2914 = ({ headers: headers }, unsignableHeaders, signableHeaders)=>{
    const canonical = {};
    for (const headerName of Object.keys(headers).sort()){
        if (headers[headerName] == undefined) continue;
        const canonicalHeaderName = headerName.toLowerCase();
        if (canonicalHeaderName in (0, $a8755e04fd758a20$export$8ffdcd58c4092560) || unsignableHeaders?.has(canonicalHeaderName) || (0, $a8755e04fd758a20$export$8085db98abbe0597).test(canonicalHeaderName) || (0, $a8755e04fd758a20$export$758380400526c39).test(canonicalHeaderName)) {
            if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) continue;
        }
        canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
    }
    return canonical;
};




const $15b449caa030ad2b$export$8fea7e63ecd1ddbb = ({ query: query = {} })=>{
    const keys = [];
    const serialized = {};
    for (const key of Object.keys(query)){
        if (key.toLowerCase() === (0, $a8755e04fd758a20$export$29961f34c719157e)) continue;
        const encodedKey = (0, $efd4db5e50b1d59c$export$c3b4775ad75a73db)(key);
        keys.push(encodedKey);
        const value = query[key];
        if (typeof value === "string") serialized[encodedKey] = `${encodedKey}=${(0, $efd4db5e50b1d59c$export$c3b4775ad75a73db)(value)}`;
        else if (Array.isArray(value)) serialized[encodedKey] = value.slice(0).reduce((encoded, value)=>encoded.concat([
                `${encodedKey}=${(0, $efd4db5e50b1d59c$export$c3b4775ad75a73db)(value)}`
            ]), []).sort().join("&");
    }
    return keys.sort().map((key)=>serialized[key]).filter((serialized)=>serialized).join("&");
};


const $15081e518a0b7124$export$9dd3754ae86f0017 = (arg)=>typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";





const $2ad7a2ac0020c140$export$a46a74202b0efd71 = async ({ headers: headers, body: body }, hashConstructor)=>{
    for (const headerName of Object.keys(headers)){
        if (headerName.toLowerCase() === (0, $a8755e04fd758a20$export$eaef12179141669a)) return headers[headerName];
    }
    if (body == undefined) return "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855";
    else if (typeof body === "string" || ArrayBuffer.isView(body) || (0, $15081e518a0b7124$export$9dd3754ae86f0017)(body)) {
        const hashCtor = new hashConstructor();
        hashCtor.update((0, $e75b5fa6fbe27b3f$export$73470fd2221e6aef)(body));
        return (0, $e3760e64f3fec34b$export$7ea66e3774a60b67)(await hashCtor.digest());
    }
    return 0, $a8755e04fd758a20$export$91f7321b40d9fd07;
};




class $24a86c8d3f77a606$export$2695849af3fba360 {
    format(headers) {
        const chunks = [];
        for (const headerName of Object.keys(headers)){
            const bytes = (0, $443e71811b7d31c6$export$c7c5cef950a4d2fc)(headerName);
            chunks.push(Uint8Array.from([
                bytes.byteLength
            ]), bytes, this.formatHeaderValue(headers[headerName]));
        }
        const out = new Uint8Array(chunks.reduce((carry, bytes)=>carry + bytes.byteLength, 0));
        let position = 0;
        for (const chunk of chunks){
            out.set(chunk, position);
            position += chunk.byteLength;
        }
        return out;
    }
    formatHeaderValue(header) {
        switch(header.type){
            case "boolean":
                return Uint8Array.from([
                    header.value ? 0 : 1
                ]);
            case "byte":
                return Uint8Array.from([
                    2,
                    header.value
                ]);
            case "short":
                const shortView = new DataView(new ArrayBuffer(3));
                shortView.setUint8(0, 3);
                shortView.setInt16(1, header.value, false);
                return new Uint8Array(shortView.buffer);
            case "integer":
                const intView = new DataView(new ArrayBuffer(5));
                intView.setUint8(0, 4);
                intView.setInt32(1, header.value, false);
                return new Uint8Array(intView.buffer);
            case "long":
                const longBytes = new Uint8Array(9);
                longBytes[0] = 5;
                longBytes.set(header.value.bytes, 1);
                return longBytes;
            case "binary":
                const binView = new DataView(new ArrayBuffer(3 + header.value.byteLength));
                binView.setUint8(0, 6);
                binView.setUint16(1, header.value.byteLength, false);
                const binBytes = new Uint8Array(binView.buffer);
                binBytes.set(header.value, 3);
                return binBytes;
            case "string":
                const utf8Bytes = (0, $443e71811b7d31c6$export$c7c5cef950a4d2fc)(header.value);
                const strView = new DataView(new ArrayBuffer(3 + utf8Bytes.byteLength));
                strView.setUint8(0, 7);
                strView.setUint16(1, utf8Bytes.byteLength, false);
                const strBytes = new Uint8Array(strView.buffer);
                strBytes.set(utf8Bytes, 3);
                return strBytes;
            case "timestamp":
                const tsBytes = new Uint8Array(9);
                tsBytes[0] = 8;
                tsBytes.set($24a86c8d3f77a606$export$8a5e19712a0a5deb.fromNumber(header.value.valueOf()).bytes, 1);
                return tsBytes;
            case "uuid":
                if (!$24a86c8d3f77a606$var$UUID_PATTERN.test(header.value)) throw new Error(`Invalid UUID received: ${header.value}`);
                const uuidBytes = new Uint8Array(17);
                uuidBytes[0] = 9;
                uuidBytes.set((0, $e3760e64f3fec34b$export$1a8ceedbd5845648)(header.value.replace(/\-/g, "")), 1);
                return uuidBytes;
        }
    }
}
var $24a86c8d3f77a606$var$HEADER_VALUE_TYPE;
(function(HEADER_VALUE_TYPE) {
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolTrue"] = 0] = "boolTrue";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolFalse"] = 1] = "boolFalse";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byte"] = 2] = "byte";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["short"] = 3] = "short";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["integer"] = 4] = "integer";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["long"] = 5] = "long";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byteArray"] = 6] = "byteArray";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["string"] = 7] = "string";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["timestamp"] = 8] = "timestamp";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["uuid"] = 9] = "uuid";
})($24a86c8d3f77a606$var$HEADER_VALUE_TYPE || ($24a86c8d3f77a606$var$HEADER_VALUE_TYPE = {}));
const $24a86c8d3f77a606$var$UUID_PATTERN = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;
class $24a86c8d3f77a606$export$8a5e19712a0a5deb {
    constructor(bytes){
        this.bytes = bytes;
        if (bytes.byteLength !== 8) throw new Error("Int64 buffers must be exactly 8 bytes");
    }
    static fromNumber(number) {
        if (number > 9223372036854776000 || number < -9223372036854776000) throw new Error(`${number} is too large (or, if negative, too small) to represent as an Int64`);
        const bytes = new Uint8Array(8);
        for(let i = 7, remaining = Math.abs(Math.round(number)); i > -1 && remaining > 0; i--, remaining /= 256)bytes[i] = remaining;
        if (number < 0) $24a86c8d3f77a606$var$negate(bytes);
        return new $24a86c8d3f77a606$export$8a5e19712a0a5deb(bytes);
    }
    valueOf() {
        const bytes = this.bytes.slice(0);
        const negative = bytes[0] & 128;
        if (negative) $24a86c8d3f77a606$var$negate(bytes);
        return parseInt((0, $e3760e64f3fec34b$export$7ea66e3774a60b67)(bytes), 16) * (negative ? -1 : 1);
    }
    toString() {
        return String(this.valueOf());
    }
}
function $24a86c8d3f77a606$var$negate(bytes) {
    for(let i = 0; i < 8; i++)bytes[i] ^= 0xff;
    for(let i = 7; i > -1; i--){
        bytes[i]++;
        if (bytes[i] !== 0) break;
    }
}


const $884cab09f69ba6ad$export$17944590be865217 = (soughtHeader, headers)=>{
    soughtHeader = soughtHeader.toLowerCase();
    for (const headerName of Object.keys(headers)){
        if (soughtHeader === headerName.toLowerCase()) return true;
    }
    return false;
};
const $884cab09f69ba6ad$export$149b1181d497cd = (soughtHeader, headers)=>{
    soughtHeader = soughtHeader.toLowerCase();
    for (const headerName of Object.keys(headers)){
        if (soughtHeader === headerName.toLowerCase()) return headers[headerName];
    }
    return undefined;
};
const $884cab09f69ba6ad$export$d3408eaf94074c90 = (soughtHeader, headers)=>{
    soughtHeader = soughtHeader.toLowerCase();
    for (const headerName of Object.keys(headers))if (soughtHeader === headerName.toLowerCase()) delete headers[headerName];
};



const $c87047e1d2af44a1$export$bfc08a76d4bd60f6 = (request, options = {})=>{
    const { headers: headers, query: query = {} } = (0, $36c92c5bbc6e0688$export$7587955500404ec3).clone(request);
    for (const name of Object.keys(headers)){
        const lname = name.toLowerCase();
        if (lname.slice(0, 6) === "x-amz-" && !options.unhoistableHeaders?.has(lname) || options.hoistableHeaders?.has(lname)) {
            query[name] = headers[name];
            delete headers[name];
        }
    }
    return {
        ...request,
        headers: headers,
        query: query
    };
};




const $6e00fb64c48c50be$export$a7cfe9131aa06be4 = (request)=>{
    request = (0, $36c92c5bbc6e0688$export$7587955500404ec3).clone(request);
    for (const headerName of Object.keys(request.headers))if ((0, $a8755e04fd758a20$export$20d6a73fd0b10982).indexOf(headerName.toLowerCase()) > -1) delete request.headers[headerName];
    return request;
};


const $24b3e5b22bf96997$export$b65d57190c224ef2 = (time)=>$24b3e5b22bf96997$export$e67a095c620b86fe(time).toISOString().replace(/\.\d{3}Z$/, "Z");
const $24b3e5b22bf96997$export$e67a095c620b86fe = (time)=>{
    if (typeof time === "number") return new Date(time * 1000);
    if (typeof time === "string") {
        if (Number(time)) return new Date(Number(time) * 1000);
        return new Date(time);
    }
    return time;
};


class $f240ea6ccfdf32b1$export$20baf4d3f65eb30c {
    constructor({ applyChecksum: applyChecksum, credentials: credentials, region: region, service: service, sha256: sha256, uriEscapePath: uriEscapePath = true }){
        this.headerFormatter = new (0, $24a86c8d3f77a606$export$2695849af3fba360)();
        this.service = service;
        this.sha256 = sha256;
        this.uriEscapePath = uriEscapePath;
        this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
        this.regionProvider = (0, $1d6280adb1321100$export$b1276c07738d6325)(region);
        this.credentialProvider = (0, $1d6280adb1321100$export$b1276c07738d6325)(credentials);
    }
    async presign(originalRequest, options = {}) {
        const { signingDate: signingDate = new Date(), expiresIn: expiresIn = 3600, unsignableHeaders: unsignableHeaders, unhoistableHeaders: unhoistableHeaders, signableHeaders: signableHeaders, hoistableHeaders: hoistableHeaders, signingRegion: signingRegion, signingService: signingService } = options;
        const credentials = await this.credentialProvider();
        this.validateResolvedCredentials(credentials);
        const region = signingRegion ?? await this.regionProvider();
        const { longDate: longDate, shortDate: shortDate } = $f240ea6ccfdf32b1$var$formatDate(signingDate);
        if (expiresIn > (0, $a8755e04fd758a20$export$274df788bdcca184)) return Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future");
        const scope = (0, $e0339a45d3bd683e$export$41a9651decfe2bde)(shortDate, region, signingService ?? this.service);
        const request = (0, $c87047e1d2af44a1$export$bfc08a76d4bd60f6)((0, $6e00fb64c48c50be$export$a7cfe9131aa06be4)(originalRequest), {
            unhoistableHeaders: unhoistableHeaders,
            hoistableHeaders: hoistableHeaders
        });
        if (credentials.sessionToken) request.query[0, $a8755e04fd758a20$export$8e1383b7eea7bee] = credentials.sessionToken;
        request.query[0, $a8755e04fd758a20$export$186cd8495ba0377d] = (0, $a8755e04fd758a20$export$863a63fba5b2ddf5);
        request.query[0, $a8755e04fd758a20$export$5c8e6dd7758f59d6] = `${credentials.accessKeyId}/${scope}`;
        request.query[0, $a8755e04fd758a20$export$6e114beec37430d7] = longDate;
        request.query[0, $a8755e04fd758a20$export$a0afe6f3bbfaf76e] = expiresIn.toString(10);
        const canonicalHeaders = (0, $bed1d102d0d23906$export$859d7f1bb55e2914)(request, unsignableHeaders, signableHeaders);
        request.query[0, $a8755e04fd758a20$export$2dcbb254f883c238] = $f240ea6ccfdf32b1$var$getCanonicalHeaderList(canonicalHeaders);
        request.query[0, $a8755e04fd758a20$export$41ae838dc1e0f082] = await this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, await (0, $2ad7a2ac0020c140$export$a46a74202b0efd71)(originalRequest, this.sha256)));
        return request;
    }
    async sign(toSign, options) {
        if (typeof toSign === "string") return this.signString(toSign, options);
        else if (toSign.headers && toSign.payload) return this.signEvent(toSign, options);
        else if (toSign.message) return this.signMessage(toSign, options);
        else return this.signRequest(toSign, options);
    }
    async signEvent({ headers: headers, payload: payload }, { signingDate: signingDate = new Date(), priorSignature: priorSignature, signingRegion: signingRegion, signingService: signingService }) {
        const region = signingRegion ?? await this.regionProvider();
        const { shortDate: shortDate, longDate: longDate } = $f240ea6ccfdf32b1$var$formatDate(signingDate);
        const scope = (0, $e0339a45d3bd683e$export$41a9651decfe2bde)(shortDate, region, signingService ?? this.service);
        const hashedPayload = await (0, $2ad7a2ac0020c140$export$a46a74202b0efd71)({
            headers: {},
            body: payload
        }, this.sha256);
        const hash = new this.sha256();
        hash.update(headers);
        const hashedHeaders = (0, $e3760e64f3fec34b$export$7ea66e3774a60b67)(await hash.digest());
        const stringToSign = [
            (0, $a8755e04fd758a20$export$9a1f6cf06ac56167),
            longDate,
            scope,
            priorSignature,
            hashedHeaders,
            hashedPayload
        ].join("\n");
        return this.signString(stringToSign, {
            signingDate: signingDate,
            signingRegion: region,
            signingService: signingService
        });
    }
    async signMessage(signableMessage, { signingDate: signingDate = new Date(), signingRegion: signingRegion, signingService: signingService }) {
        const promise = this.signEvent({
            headers: this.headerFormatter.format(signableMessage.message.headers),
            payload: signableMessage.message.body
        }, {
            signingDate: signingDate,
            signingRegion: signingRegion,
            signingService: signingService,
            priorSignature: signableMessage.priorSignature
        });
        return promise.then((signature)=>{
            return {
                message: signableMessage.message,
                signature: signature
            };
        });
    }
    async signString(stringToSign, { signingDate: signingDate = new Date(), signingRegion: signingRegion, signingService: signingService } = {}) {
        const credentials = await this.credentialProvider();
        this.validateResolvedCredentials(credentials);
        const region = signingRegion ?? await this.regionProvider();
        const { shortDate: shortDate } = $f240ea6ccfdf32b1$var$formatDate(signingDate);
        const hash = new this.sha256(await this.getSigningKey(credentials, region, shortDate, signingService));
        hash.update((0, $e75b5fa6fbe27b3f$export$73470fd2221e6aef)(stringToSign));
        return (0, $e3760e64f3fec34b$export$7ea66e3774a60b67)(await hash.digest());
    }
    async signRequest(requestToSign, { signingDate: signingDate = new Date(), signableHeaders: signableHeaders, unsignableHeaders: unsignableHeaders, signingRegion: signingRegion, signingService: signingService } = {}) {
        const credentials = await this.credentialProvider();
        this.validateResolvedCredentials(credentials);
        const region = signingRegion ?? await this.regionProvider();
        const request = (0, $6e00fb64c48c50be$export$a7cfe9131aa06be4)(requestToSign);
        const { longDate: longDate, shortDate: shortDate } = $f240ea6ccfdf32b1$var$formatDate(signingDate);
        const scope = (0, $e0339a45d3bd683e$export$41a9651decfe2bde)(shortDate, region, signingService ?? this.service);
        request.headers[0, $a8755e04fd758a20$export$acf4b8bdf24aab34] = longDate;
        if (credentials.sessionToken) request.headers[0, $a8755e04fd758a20$export$fdc81b663012a8d2] = credentials.sessionToken;
        const payloadHash = await (0, $2ad7a2ac0020c140$export$a46a74202b0efd71)(request, this.sha256);
        if (!(0, $884cab09f69ba6ad$export$17944590be865217)((0, $a8755e04fd758a20$export$eaef12179141669a), request.headers) && this.applyChecksum) request.headers[0, $a8755e04fd758a20$export$eaef12179141669a] = payloadHash;
        const canonicalHeaders = (0, $bed1d102d0d23906$export$859d7f1bb55e2914)(request, unsignableHeaders, signableHeaders);
        const signature = await this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash));
        request.headers[0, $a8755e04fd758a20$export$9924a64a4b8b0d58] = `${0, $a8755e04fd758a20$export$863a63fba5b2ddf5} ` + `Credential=${credentials.accessKeyId}/${scope}, ` + `SignedHeaders=${$f240ea6ccfdf32b1$var$getCanonicalHeaderList(canonicalHeaders)}, ` + `Signature=${signature}`;
        return request;
    }
    createCanonicalRequest(request, canonicalHeaders, payloadHash) {
        const sortedHeaders = Object.keys(canonicalHeaders).sort();
        return `${request.method}
${this.getCanonicalPath(request)}
${(0, $15b449caa030ad2b$export$8fea7e63ecd1ddbb)(request)}
${sortedHeaders.map((name)=>`${name}:${canonicalHeaders[name]}`).join("\n")}

${sortedHeaders.join(";")}
${payloadHash}`;
    }
    async createStringToSign(longDate, credentialScope, canonicalRequest) {
        const hash = new this.sha256();
        hash.update((0, $e75b5fa6fbe27b3f$export$73470fd2221e6aef)(canonicalRequest));
        const hashedRequest = await hash.digest();
        return `${0, $a8755e04fd758a20$export$863a63fba5b2ddf5}
${longDate}
${credentialScope}
${(0, $e3760e64f3fec34b$export$7ea66e3774a60b67)(hashedRequest)}`;
    }
    getCanonicalPath({ path: path }) {
        if (this.uriEscapePath) {
            const normalizedPathSegments = [];
            for (const pathSegment of path.split("/")){
                if (pathSegment?.length === 0) continue;
                if (pathSegment === ".") continue;
                if (pathSegment === "..") normalizedPathSegments.pop();
                else normalizedPathSegments.push(pathSegment);
            }
            const normalizedPath = `${path?.startsWith("/") ? "/" : ""}${normalizedPathSegments.join("/")}${normalizedPathSegments.length > 0 && path?.endsWith("/") ? "/" : ""}`;
            const doubleEncoded = (0, $efd4db5e50b1d59c$export$c3b4775ad75a73db)(normalizedPath);
            return doubleEncoded.replace(/%2F/g, "/");
        }
        return path;
    }
    async getSignature(longDate, credentialScope, keyPromise, canonicalRequest) {
        const stringToSign = await this.createStringToSign(longDate, credentialScope, canonicalRequest);
        const hash = new this.sha256(await keyPromise);
        hash.update((0, $e75b5fa6fbe27b3f$export$73470fd2221e6aef)(stringToSign));
        return (0, $e3760e64f3fec34b$export$7ea66e3774a60b67)(await hash.digest());
    }
    getSigningKey(credentials, region, shortDate, service) {
        return (0, $e0339a45d3bd683e$export$8b95a069d16dd783)(this.sha256, credentials, shortDate, region, service || this.service);
    }
    validateResolvedCredentials(credentials) {
        if (typeof credentials !== "object" || typeof credentials.accessKeyId !== "string" || typeof credentials.secretAccessKey !== "string") throw new Error("Resolved credential object is not valid");
    }
}
const $f240ea6ccfdf32b1$var$formatDate = (now)=>{
    const longDate = (0, $24b3e5b22bf96997$export$b65d57190c224ef2)(now).replace(/[\-:]/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.slice(0, 8)
    };
};
const $f240ea6ccfdf32b1$var$getCanonicalHeaderList = (headers)=>Object.keys(headers).sort().join(";");










const $3f66864312eb80d3$export$e18f3f8a841a90ec = (config)=>{
    let isUserSupplied = false;
    let credentialsProvider;
    if (config.credentials) {
        isUserSupplied = true;
        credentialsProvider = (0, $511ab404415c7a32$export$b258763a05c20e85)(config.credentials, (0, $511ab404415c7a32$export$42a11a4dafc8f476), (0, $511ab404415c7a32$export$5fef7ca5b4791fa9));
    }
    if (!credentialsProvider) {
        if (config.credentialDefaultProvider) credentialsProvider = (0, $7a73b05cc4d89640$export$b1276c07738d6325)(config.credentialDefaultProvider(Object.assign({}, config, {
            parentClientConfig: config
        })));
        else credentialsProvider = async ()=>{
            throw new Error("`credentials` is missing");
        };
    }
    const boundCredentialsProvider = async ()=>credentialsProvider({
            callerClientConfig: config
        });
    const { signingEscapePath: signingEscapePath = true, systemClockOffset: systemClockOffset = config.systemClockOffset || 0, sha256: sha256 } = config;
    let signer;
    if (config.signer) signer = (0, $7a73b05cc4d89640$export$b1276c07738d6325)(config.signer);
    else if (config.regionInfoProvider) signer = ()=>(0, $7a73b05cc4d89640$export$b1276c07738d6325)(config.region)().then(async (region)=>[
                await config.regionInfoProvider(region, {
                    useFipsEndpoint: await config.useFipsEndpoint(),
                    useDualstackEndpoint: await config.useDualstackEndpoint()
                }) || {},
                region
            ]).then(([regionInfo, region])=>{
            const { signingRegion: signingRegion, signingService: signingService } = regionInfo;
            config.signingRegion = config.signingRegion || signingRegion || region;
            config.signingName = config.signingName || signingService || config.serviceId;
            const params = {
                ...config,
                credentials: boundCredentialsProvider,
                region: config.signingRegion,
                service: config.signingName,
                sha256: sha256,
                uriEscapePath: signingEscapePath
            };
            const SignerCtor = config.signerConstructor || (0, $f240ea6ccfdf32b1$export$20baf4d3f65eb30c);
            return new SignerCtor(params);
        });
    else signer = async (authScheme)=>{
        authScheme = Object.assign({}, {
            name: "sigv4",
            signingName: config.signingName || config.defaultSigningName,
            signingRegion: await (0, $7a73b05cc4d89640$export$b1276c07738d6325)(config.region)(),
            properties: {}
        }, authScheme);
        const signingRegion = authScheme.signingRegion;
        const signingService = authScheme.signingName;
        config.signingRegion = config.signingRegion || signingRegion;
        config.signingName = config.signingName || signingService || config.serviceId;
        const params = {
            ...config,
            credentials: boundCredentialsProvider,
            region: config.signingRegion,
            service: config.signingName,
            sha256: sha256,
            uriEscapePath: signingEscapePath
        };
        const SignerCtor = config.signerConstructor || (0, $f240ea6ccfdf32b1$export$20baf4d3f65eb30c);
        return new SignerCtor(params);
    };
    return {
        ...config,
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: isUserSupplied ? async ()=>boundCredentialsProvider().then((creds)=>(0, $7da50fd8c81c8743$export$5948d889008373f3)(creds, "CREDENTIALS_CODE", "e")) : boundCredentialsProvider,
        signer: signer
    };
};
const $3f66864312eb80d3$export$d85a20fa3e1218b1 = $3f66864312eb80d3$export$e18f3f8a841a90ec;



const $bd31d60ce493d67e$export$55102b547b733381 = async (config, context, input)=>{
    return {
        operation: (0, $e6ed4dab4f65171f$export$1d3c197393275463)(context).operation,
        region: await (0, $1d6280adb1321100$export$b1276c07738d6325)(config.region)() || (()=>{
            throw new Error("expected `region` to be configured for `aws.auth#sigv4`");
        })()
    };
};
function $bd31d60ce493d67e$var$createAwsAuthSigv4HttpAuthOption(authParameters) {
    return {
        schemeId: "aws.auth#sigv4",
        signingProperties: {
            name: "cognito-identity",
            region: authParameters.region
        },
        propertiesExtractor: (config, context)=>({
                signingProperties: {
                    config: config,
                    context: context
                }
            })
    };
}
function $bd31d60ce493d67e$var$createSmithyApiNoAuthHttpAuthOption(authParameters) {
    return {
        schemeId: "smithy.api#noAuth"
    };
}
const $bd31d60ce493d67e$export$d514ed0616437588 = (authParameters)=>{
    const options = [];
    switch(authParameters.operation){
        case "GetCredentialsForIdentity":
            options.push($bd31d60ce493d67e$var$createSmithyApiNoAuthHttpAuthOption(authParameters));
            break;
        case "GetId":
            options.push($bd31d60ce493d67e$var$createSmithyApiNoAuthHttpAuthOption(authParameters));
            break;
        case "GetOpenIdToken":
            options.push($bd31d60ce493d67e$var$createSmithyApiNoAuthHttpAuthOption(authParameters));
            break;
        case "UnlinkIdentity":
            options.push($bd31d60ce493d67e$var$createSmithyApiNoAuthHttpAuthOption(authParameters));
            break;
        default:
            options.push($bd31d60ce493d67e$var$createAwsAuthSigv4HttpAuthOption(authParameters));
    }
    return options;
};
const $bd31d60ce493d67e$export$d38ef9c0c6c649ab = (config)=>{
    const config_0 = (0, $3f66864312eb80d3$export$e18f3f8a841a90ec)(config);
    return {
        ...config_0
    };
};


const $d1223e7c10daafaf$export$70b6341cd51750a8 = (options)=>{
    return {
        ...options,
        useDualstackEndpoint: options.useDualstackEndpoint ?? false,
        useFipsEndpoint: options.useFipsEndpoint ?? false,
        defaultSigningName: "cognito-identity"
    };
};
const $d1223e7c10daafaf$export$9c07ced2019f0ae0 = {
    UseFIPS: {
        type: "builtInParams",
        name: "useFipsEndpoint"
    },
    Endpoint: {
        type: "builtInParams",
        name: "endpoint"
    },
    Region: {
        type: "builtInParams",
        name: "region"
    },
    UseDualStack: {
        type: "builtInParams",
        name: "useDualstackEndpoint"
    }
};


var $604602824a48a3ef$exports = {};
$604602824a48a3ef$exports = JSON.parse("{\"name\":\"@aws-sdk/client-cognito-identity\",\"description\":\"AWS SDK for JavaScript Cognito Identity Client for Node.js, Browser and React Native\",\"version\":\"3.726.1\",\"scripts\":{\"build\":\"concurrently 'yarn:build:cjs' 'yarn:build:es' 'yarn:build:types'\",\"build:cjs\":\"node ../../scripts/compilation/inline client-cognito-identity\",\"build:es\":\"tsc -p tsconfig.es.json\",\"build:include:deps\":\"lerna run --scope $npm_package_name --include-dependencies build\",\"build:types\":\"tsc -p tsconfig.types.json\",\"build:types:downlevel\":\"downlevel-dts dist-types dist-types/ts3.4\",\"clean\":\"rimraf ./dist-* && rimraf *.tsbuildinfo\",\"extract:docs\":\"api-extractor run --local\",\"generate:client\":\"node ../../scripts/generate-clients/single-service --solo cognito-identity\",\"test:e2e\":\"yarn g:vitest run -c vitest.config.e2e.ts --mode development\",\"test:e2e:watch\":\"yarn g:vitest watch -c vitest.config.e2e.ts\"},\"main\":\"./dist-cjs/index.js\",\"types\":\"./dist-types/index.d.ts\",\"module\":\"./dist-es/index.js\",\"sideEffects\":false,\"dependencies\":{\"@aws-crypto/sha256-browser\":\"5.2.0\",\"@aws-crypto/sha256-js\":\"5.2.0\",\"@aws-sdk/client-sso-oidc\":\"3.726.0\",\"@aws-sdk/client-sts\":\"3.726.1\",\"@aws-sdk/core\":\"3.723.0\",\"@aws-sdk/credential-provider-node\":\"3.726.0\",\"@aws-sdk/middleware-host-header\":\"3.723.0\",\"@aws-sdk/middleware-logger\":\"3.723.0\",\"@aws-sdk/middleware-recursion-detection\":\"3.723.0\",\"@aws-sdk/middleware-user-agent\":\"3.726.0\",\"@aws-sdk/region-config-resolver\":\"3.723.0\",\"@aws-sdk/types\":\"3.723.0\",\"@aws-sdk/util-endpoints\":\"3.726.0\",\"@aws-sdk/util-user-agent-browser\":\"3.723.0\",\"@aws-sdk/util-user-agent-node\":\"3.726.0\",\"@smithy/config-resolver\":\"^4.0.0\",\"@smithy/core\":\"^3.0.0\",\"@smithy/fetch-http-handler\":\"^5.0.0\",\"@smithy/hash-node\":\"^4.0.0\",\"@smithy/invalid-dependency\":\"^4.0.0\",\"@smithy/middleware-content-length\":\"^4.0.0\",\"@smithy/middleware-endpoint\":\"^4.0.0\",\"@smithy/middleware-retry\":\"^4.0.0\",\"@smithy/middleware-serde\":\"^4.0.0\",\"@smithy/middleware-stack\":\"^4.0.0\",\"@smithy/node-config-provider\":\"^4.0.0\",\"@smithy/node-http-handler\":\"^4.0.0\",\"@smithy/protocol-http\":\"^5.0.0\",\"@smithy/smithy-client\":\"^4.0.0\",\"@smithy/types\":\"^4.0.0\",\"@smithy/url-parser\":\"^4.0.0\",\"@smithy/util-base64\":\"^4.0.0\",\"@smithy/util-body-length-browser\":\"^4.0.0\",\"@smithy/util-body-length-node\":\"^4.0.0\",\"@smithy/util-defaults-mode-browser\":\"^4.0.0\",\"@smithy/util-defaults-mode-node\":\"^4.0.0\",\"@smithy/util-endpoints\":\"^3.0.0\",\"@smithy/util-middleware\":\"^4.0.0\",\"@smithy/util-retry\":\"^4.0.0\",\"@smithy/util-utf8\":\"^4.0.0\",\"tslib\":\"^2.6.2\"},\"devDependencies\":{\"@aws-sdk/client-iam\":\"3.726.1\",\"@tsconfig/node18\":\"18.2.4\",\"@types/chai\":\"^4.2.11\",\"@types/node\":\"^18.19.69\",\"concurrently\":\"7.0.0\",\"downlevel-dts\":\"0.10.1\",\"rimraf\":\"3.0.2\",\"typescript\":\"~5.2.2\"},\"engines\":{\"node\":\">=18.0.0\"},\"typesVersions\":{\"<4.0\":{\"dist-types/*\":[\"dist-types/ts3.4/*\"]}},\"files\":[\"dist-*/**\"],\"author\":{\"name\":\"AWS SDK for JavaScript Team\",\"url\":\"https://aws.amazon.com/javascript/\"},\"license\":\"Apache-2.0\",\"browser\":{\"./dist-es/runtimeConfig\":\"./dist-es/runtimeConfig.browser\"},\"react-native\":{\"./dist-es/runtimeConfig\":\"./dist-es/runtimeConfig.native\"},\"homepage\":\"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-cognito-identity\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/aws/aws-sdk-js-v3.git\",\"directory\":\"clients/client-cognito-identity\"}}");


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $168bfc8fb8423203$export$c7c5cef950a4d2fc = (input)=>new TextEncoder().encode(input);



const $09f6ace8ebd99ed4$export$73470fd2221e6aef = (data)=>{
    if (typeof data === "string") return (0, $168bfc8fb8423203$export$c7c5cef950a4d2fc)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
};


const $02f5b501ed821fb7$export$b4b216764bb846eb = (input)=>{
    if (typeof input === "string") return input;
    if (typeof input !== "object" || typeof input.byteOffset !== "number" || typeof input.byteLength !== "number") throw new Error("@smithy/util-utf8: toUtf8 encoder function only accepts string | Uint8Array.");
    return new TextDecoder("utf-8").decode(input);
};





var $djTVs = parcelRequire("djTVs");
var $4d83425858181b6d$require$Buffer = $djTVs.Buffer;
// Quick polyfill
var $4d83425858181b6d$var$fromUtf8 = typeof $4d83425858181b6d$require$Buffer !== "undefined" && $4d83425858181b6d$require$Buffer.from ? function(input) {
    return $4d83425858181b6d$require$Buffer.from(input, "utf8");
} : (0, $168bfc8fb8423203$export$c7c5cef950a4d2fc);
function $4d83425858181b6d$export$4f21f20c2f1a9063(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $4d83425858181b6d$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $b61f34c6d51c0099$export$ea55f474a468804e(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $f5620d206f522417$export$2527dfa2a193fcfa(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// IE 11 does not support Array.from, so we do it manually
function $139149fc62525fb6$export$b6739cd5a63159f9(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}




var $f981184ae7624105$export$2113793cf72f4599 = {
    name: "SHA-256"
};
var $f981184ae7624105$export$1f80374c274e65a6 = {
    name: "HMAC",
    hash: $f981184ae7624105$export$2113793cf72f4599
};
var $f981184ae7624105$export$b6c4a2c4743c9cae = new Uint8Array([
    227,
    176,
    196,
    66,
    152,
    252,
    28,
    20,
    154,
    251,
    244,
    200,
    153,
    111,
    185,
    36,
    39,
    174,
    65,
    228,
    100,
    155,
    147,
    76,
    164,
    149,
    153,
    27,
    120,
    82,
    184,
    85
]);


const $6f99f6e7988cf407$var$fallbackWindow = {};
function $6f99f6e7988cf407$export$2a77db4d0e0dd1ff() {
    if (typeof window !== "undefined") return window;
    else if (typeof self !== "undefined") return self;
    return $6f99f6e7988cf407$var$fallbackWindow;
}


var $b10bcf694d2182e8$export$3b58ea8124ac5e28 = /** @class */ function() {
    function Sha256(secret) {
        this.toHash = new Uint8Array(0);
        this.secret = secret;
        this.reset();
    }
    Sha256.prototype.update = function(data) {
        if ((0, $b61f34c6d51c0099$export$ea55f474a468804e)(data)) return;
        var update = (0, $4d83425858181b6d$export$4f21f20c2f1a9063)(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha256.prototype.digest = function() {
        var _this = this;
        if (this.key) return this.key.then(function(key) {
            return (0, $6f99f6e7988cf407$export$2a77db4d0e0dd1ff)().crypto.subtle.sign((0, $f981184ae7624105$export$1f80374c274e65a6), key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
            });
        });
        if ((0, $b61f34c6d51c0099$export$ea55f474a468804e)(this.toHash)) return Promise.resolve((0, $f981184ae7624105$export$b6c4a2c4743c9cae));
        return Promise.resolve().then(function() {
            return (0, $6f99f6e7988cf407$export$2a77db4d0e0dd1ff)().crypto.subtle.digest((0, $f981184ae7624105$export$2113793cf72f4599), _this.toHash);
        }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
        });
    };
    Sha256.prototype.reset = function() {
        var _this = this;
        this.toHash = new Uint8Array(0);
        if (this.secret && this.secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
                (0, $6f99f6e7988cf407$export$2a77db4d0e0dd1ff)().crypto.subtle.importKey("raw", (0, $4d83425858181b6d$export$4f21f20c2f1a9063)(_this.secret), (0, $f981184ae7624105$export$1f80374c274e65a6), false, [
                    "sign"
                ]).then(resolve, reject);
            });
            this.key.catch(function() {});
        }
    };
    return Sha256;
}();


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $4bd376b3ddf169e8$var$extendStatics = function(d, b) {
    $4bd376b3ddf169e8$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $4bd376b3ddf169e8$var$extendStatics(d, b);
};
function $4bd376b3ddf169e8$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $4bd376b3ddf169e8$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $4bd376b3ddf169e8$export$18ce0697a983be9b = function() {
    $4bd376b3ddf169e8$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4bd376b3ddf169e8$export$18ce0697a983be9b.apply(this, arguments);
};
function $4bd376b3ddf169e8$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $4bd376b3ddf169e8$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $4bd376b3ddf169e8$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $4bd376b3ddf169e8$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $4bd376b3ddf169e8$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $4bd376b3ddf169e8$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $4bd376b3ddf169e8$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $4bd376b3ddf169e8$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $4bd376b3ddf169e8$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $4bd376b3ddf169e8$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $4bd376b3ddf169e8$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $4bd376b3ddf169e8$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $4bd376b3ddf169e8$export$45d3717a4c69092e(o, m, p);
}
function $4bd376b3ddf169e8$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $4bd376b3ddf169e8$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $4bd376b3ddf169e8$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($4bd376b3ddf169e8$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $4bd376b3ddf169e8$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $4bd376b3ddf169e8$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $4bd376b3ddf169e8$export$10c90e4f7922046c(v) {
    return this instanceof $4bd376b3ddf169e8$export$10c90e4f7922046c ? (this.v = v, this) : new $4bd376b3ddf169e8$export$10c90e4f7922046c(v);
}
function $4bd376b3ddf169e8$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $4bd376b3ddf169e8$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $4bd376b3ddf169e8$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $4bd376b3ddf169e8$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $4bd376b3ddf169e8$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $4bd376b3ddf169e8$export$19a8beecd37a4c45 === "function" ? $4bd376b3ddf169e8$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $4bd376b3ddf169e8$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $4bd376b3ddf169e8$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $4bd376b3ddf169e8$var$ownKeys = function(o) {
    $4bd376b3ddf169e8$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $4bd376b3ddf169e8$var$ownKeys(o);
};
function $4bd376b3ddf169e8$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $4bd376b3ddf169e8$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $4bd376b3ddf169e8$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $4bd376b3ddf169e8$var$__setModuleDefault(result, mod);
    return result;
}
function $4bd376b3ddf169e8$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $4bd376b3ddf169e8$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $4bd376b3ddf169e8$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $4bd376b3ddf169e8$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $4bd376b3ddf169e8$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $4bd376b3ddf169e8$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $4bd376b3ddf169e8$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $4bd376b3ddf169e8$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $4bd376b3ddf169e8$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $4bd376b3ddf169e8$export$2e2bcd8739ae039 = {
    __extends: $4bd376b3ddf169e8$export$a8ba968b8961cb8a,
    __assign: $4bd376b3ddf169e8$export$18ce0697a983be9b,
    __rest: $4bd376b3ddf169e8$export$3c9a16f847548506,
    __decorate: $4bd376b3ddf169e8$export$29e00dfd3077644b,
    __param: $4bd376b3ddf169e8$export$d5ad3fd78186038f,
    __esDecorate: $4bd376b3ddf169e8$export$3a84e1ae4e97e9b0,
    __runInitializers: $4bd376b3ddf169e8$export$d831c04e792af3d,
    __propKey: $4bd376b3ddf169e8$export$6a2a36740a146cb8,
    __setFunctionName: $4bd376b3ddf169e8$export$d1a06452d3489bc7,
    __metadata: $4bd376b3ddf169e8$export$f1db080c865becb9,
    __awaiter: $4bd376b3ddf169e8$export$1050f835b63b671e,
    __generator: $4bd376b3ddf169e8$export$67ebef60e6f28a6,
    __createBinding: $4bd376b3ddf169e8$export$45d3717a4c69092e,
    __exportStar: $4bd376b3ddf169e8$export$f33643c0debef087,
    __values: $4bd376b3ddf169e8$export$19a8beecd37a4c45,
    __read: $4bd376b3ddf169e8$export$8d051b38c9118094,
    __spread: $4bd376b3ddf169e8$export$afc72e2116322959,
    __spreadArrays: $4bd376b3ddf169e8$export$6388937ca91ccae8,
    __spreadArray: $4bd376b3ddf169e8$export$1216008129fb82ed,
    __await: $4bd376b3ddf169e8$export$10c90e4f7922046c,
    __asyncGenerator: $4bd376b3ddf169e8$export$e427f37a30a4de9b,
    __asyncDelegator: $4bd376b3ddf169e8$export$bbd80228419bb833,
    __asyncValues: $4bd376b3ddf169e8$export$e3b29a3d6162315f,
    __makeTemplateObject: $4bd376b3ddf169e8$export$4fb47efe1390b86f,
    __importStar: $4bd376b3ddf169e8$export$c21735bcef00d192,
    __importDefault: $4bd376b3ddf169e8$export$da59b14a69baef04,
    __classPrivateFieldGet: $4bd376b3ddf169e8$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $4bd376b3ddf169e8$export$d40a35129aaff81f,
    __classPrivateFieldIn: $4bd376b3ddf169e8$export$81fdc39f203e4e04,
    __addDisposableResource: $4bd376b3ddf169e8$export$88ac25d8e944e405,
    __disposeResources: $4bd376b3ddf169e8$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $4bd376b3ddf169e8$export$889dfb5d17574b0b
};


/**
 * @internal
 */ var $a9df98089928eb65$export$b2e3d6d444266a5c = 64;
var $a9df98089928eb65$export$d7bd469488748c5f = 32;
var $a9df98089928eb65$export$7167c830cefcb6b5 = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
var $a9df98089928eb65$export$d788bc089976c004 = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
var $a9df98089928eb65$export$856b3d11dc447b50 = Math.pow(2, 53) - 1;



/**
 * @internal
 */ var $77650198763bc263$export$aab6bc1ad3c77a42 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from((0, $a9df98089928eb65$export$d788bc089976c004));
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > (0, $a9df98089928eb65$export$856b3d11dc447b50)) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === (0, $a9df98089928eb65$export$b2e3d6d444266a5c)) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % (0, $a9df98089928eb65$export$b2e3d6d444266a5c) >= (0, $a9df98089928eb65$export$b2e3d6d444266a5c) - 8) {
                for(var i = this.bufferLength; i < (0, $a9df98089928eb65$export$b2e3d6d444266a5c); i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < (0, $a9df98089928eb65$export$b2e3d6d444266a5c) - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32((0, $a9df98089928eb65$export$b2e3d6d444266a5c) - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32((0, $a9df98089928eb65$export$b2e3d6d444266a5c) - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array((0, $a9df98089928eb65$export$d7bd469488748c5f));
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < (0, $a9df98089928eb65$export$b2e3d6d444266a5c); i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ((0, $a9df98089928eb65$export$7167c830cefcb6b5)[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();



var $80f5d4585a026180$export$3b58ea8124ac5e28 = /** @class */ function() {
    function Sha256(secret) {
        this.secret = secret;
        this.hash = new (0, $77650198763bc263$export$aab6bc1ad3c77a42)();
        this.reset();
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $b61f34c6d51c0099$export$ea55f474a468804e)(toHash) || this.error) return;
        try {
            this.hash.update((0, $4d83425858181b6d$export$4f21f20c2f1a9063)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, $4bd376b3ddf169e8$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $4bd376b3ddf169e8$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    Sha256.prototype.reset = function() {
        this.hash = new (0, $77650198763bc263$export$aab6bc1ad3c77a42)();
        if (this.secret) {
            this.outer = new (0, $77650198763bc263$export$aab6bc1ad3c77a42)();
            var inner = $80f5d4585a026180$var$bufferFromSecret(this.secret);
            var outer = new Uint8Array((0, $a9df98089928eb65$export$b2e3d6d444266a5c));
            outer.set(inner);
            for(var i = 0; i < (0, $a9df98089928eb65$export$b2e3d6d444266a5c); i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    };
    return Sha256;
}();
function $80f5d4585a026180$var$bufferFromSecret(secret) {
    var input = (0, $4d83425858181b6d$export$4f21f20c2f1a9063)(secret);
    if (input.byteLength > (0, $a9df98089928eb65$export$b2e3d6d444266a5c)) {
        var bufferHash = new (0, $77650198763bc263$export$aab6bc1ad3c77a42)();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array((0, $a9df98089928eb65$export$b2e3d6d444266a5c));
    buffer.set(input);
    return buffer;
}





var $7add5a54c0149cfe$var$subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function $7add5a54c0149cfe$export$519d4361bb708a57(window) {
    if ($7add5a54c0149cfe$export$c4783ac5e58b0ef6(window) && typeof window.crypto.subtle === "object") {
        var subtle = window.crypto.subtle;
        return $7add5a54c0149cfe$export$17b9b1d09487d874(subtle);
    }
    return false;
}
function $7add5a54c0149cfe$export$c4783ac5e58b0ef6(window) {
    if (typeof window === "object" && typeof window.crypto === "object") {
        var getRandomValues = window.crypto.getRandomValues;
        return typeof getRandomValues === "function";
    }
    return false;
}
function $7add5a54c0149cfe$export$17b9b1d09487d874(subtle) {
    return subtle && $7add5a54c0149cfe$var$subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
    });
}
function $7add5a54c0149cfe$export$d94d4c5ec4742a(subtle) {
    return (0, $4bd376b3ddf169e8$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a;
        return (0, $4bd376b3ddf169e8$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!$7add5a54c0149cfe$export$17b9b1d09487d874(subtle)) return [
                        2 /*return*/ ,
                        false
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        subtle.generateKey({
                            name: "AES-GCM",
                            length: 128
                        }, false, [
                            "encrypt"
                        ])
                    ];
                case 2:
                    key = _b.sent();
                    return [
                        4 /*yield*/ ,
                        subtle.encrypt({
                            name: "AES-GCM",
                            iv: new Uint8Array(Array(12)),
                            additionalData: new Uint8Array(Array(16)),
                            tagLength: 128
                        }, key, new Uint8Array(0))
                    ];
                case 3:
                    zeroByteAuthTag = _b.sent();
                    return [
                        2 /*return*/ ,
                        zeroByteAuthTag.byteLength === 16
                    ];
                case 4:
                    _a = _b.sent();
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}






var $96d9020e18f0029b$export$3b58ea8124ac5e28 = /** @class */ function() {
    function Sha256(secret) {
        if ((0, $7add5a54c0149cfe$export$519d4361bb708a57)((0, $6f99f6e7988cf407$export$2a77db4d0e0dd1ff)())) this.hash = new (0, $b10bcf694d2182e8$export$3b58ea8124ac5e28)(secret);
        else this.hash = new (0, $80f5d4585a026180$export$3b58ea8124ac5e28)(secret);
    }
    Sha256.prototype.update = function(data, encoding) {
        this.hash.update((0, $4d83425858181b6d$export$4f21f20c2f1a9063)(data));
    };
    Sha256.prototype.digest = function() {
        return this.hash.digest();
    };
    Sha256.prototype.reset = function() {
        this.hash.reset();
    };
    return Sha256;
}();





var $0e232a422ae1e322$exports = {};
!function(e, t) {
    $0e232a422ae1e322$exports = t();
}($0e232a422ae1e322$exports, function() {
    return function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var i = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)r.d(n, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 90);
    }({
        17: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = r(18), i = function() {
                function e() {}
                return e.getFirstMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 0 && r[1] || "";
                }, e.getSecondMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 1 && r[2] || "";
                }, e.matchAndReturnConst = function(e, t, r) {
                    if (e.test(t)) return r;
                }, e.getWindowsVersionName = function(e) {
                    switch(e){
                        case "NT":
                            return "NT";
                        case "XP":
                            return "XP";
                        case "NT 5.0":
                            return "2000";
                        case "NT 5.1":
                            return "XP";
                        case "NT 5.2":
                            return "2003";
                        case "NT 6.0":
                            return "Vista";
                        case "NT 6.1":
                            return "7";
                        case "NT 6.2":
                            return "8";
                        case "NT 6.3":
                            return "8.1";
                        case "NT 10.0":
                            return "10";
                        default:
                            return;
                    }
                }, e.getMacOSVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), 10 === t[0]) switch(t[1]){
                        case 5:
                            return "Leopard";
                        case 6:
                            return "Snow Leopard";
                        case 7:
                            return "Lion";
                        case 8:
                            return "Mountain Lion";
                        case 9:
                            return "Mavericks";
                        case 10:
                            return "Yosemite";
                        case 11:
                            return "El Capitan";
                        case 12:
                            return "Sierra";
                        case 13:
                            return "High Sierra";
                        case 14:
                            return "Mojave";
                        case 15:
                            return "Catalina";
                        default:
                            return;
                    }
                }, e.getAndroidVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function(e) {
                    return e.split(".").length;
                }, e.compareVersions = function(t, r, n) {
                    void 0 === n && (n = !1);
                    var i = e.getVersionPrecision(t), s = e.getVersionPrecision(r), a = Math.max(i, s), o = 0, u = e.map([
                        t,
                        r
                    ], function(t) {
                        var r = a - e.getVersionPrecision(t), n = t + new Array(r + 1).join(".0");
                        return e.map(n.split("."), function(e) {
                            return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                    });
                    for(n && (o = a - Math.min(i, s)), a -= 1; a >= o;){
                        if (u[0][a] > u[1][a]) return 1;
                        if (u[0][a] === u[1][a]) {
                            if (a === o) return 0;
                            a -= 1;
                        } else if (u[0][a] < u[1][a]) return -1;
                    }
                }, e.map = function(e, t) {
                    var r, n = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for(r = 0; r < e.length; r += 1)n.push(t(e[r]));
                    return n;
                }, e.find = function(e, t) {
                    var r, n;
                    if (Array.prototype.find) return Array.prototype.find.call(e, t);
                    for(r = 0, n = e.length; r < n; r += 1){
                        var i = e[r];
                        if (t(i, r)) return i;
                    }
                }, e.assign = function(e) {
                    for(var t, r, n = e, i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)s[a - 1] = arguments[a];
                    if (Object.assign) return Object.assign.apply(Object, [
                        e
                    ].concat(s));
                    var o = function() {
                        var e = s[t];
                        "object" == typeof e && null !== e && Object.keys(e).forEach(function(t) {
                            n[t] = e[t];
                        });
                    };
                    for(t = 0, r = s.length; t < r; t += 1)o();
                    return e;
                }, e.getBrowserAlias = function(e) {
                    return n.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function(e) {
                    return n.BROWSER_MAP[e] || "";
                }, e;
            }();
            t.default = i, e.exports = t.default;
        },
        18: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
            t.BROWSER_ALIASES_MAP = {
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                Bada: "bada",
                BlackBerry: "blackberry",
                Chrome: "chrome",
                Chromium: "chromium",
                Electron: "electron",
                Epiphany: "epiphany",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                "Internet Explorer": "ie",
                "K-Meleon": "k_meleon",
                Maxthon: "maxthon",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                PhantomJS: "phantomjs",
                Puffin: "puffin",
                QupZilla: "qupzilla",
                QQ: "qq",
                QQLite: "qqlite",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                "Yandex Browser": "yandex",
                Roku: "roku"
            };
            t.BROWSER_MAP = {
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                bada: "Bada",
                blackberry: "BlackBerry",
                chrome: "Chrome",
                chromium: "Chromium",
                electron: "Electron",
                epiphany: "Epiphany",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                googlebot: "Googlebot",
                google_search: "Google Search",
                ie: "Internet Explorer",
                k_meleon: "K-Meleon",
                maxthon: "Maxthon",
                edge: "Microsoft Edge",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                opera: "Opera",
                opera_coast: "Opera Coast",
                phantomjs: "PhantomJS",
                puffin: "Puffin",
                qupzilla: "QupZilla",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                sleipnir: "Sleipnir",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yandex: "Yandex Browser"
            };
            t.PLATFORMS_MAP = {
                tablet: "tablet",
                mobile: "mobile",
                desktop: "desktop",
                tv: "tv"
            };
            t.OS_MAP = {
                WindowsPhone: "Windows Phone",
                Windows: "Windows",
                MacOS: "macOS",
                iOS: "iOS",
                Android: "Android",
                WebOS: "WebOS",
                BlackBerry: "BlackBerry",
                Bada: "Bada",
                Tizen: "Tizen",
                Linux: "Linux",
                ChromeOS: "Chrome OS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku"
            };
            t.ENGINE_MAP = {
                EdgeHTML: "EdgeHTML",
                Blink: "Blink",
                Trident: "Trident",
                Presto: "Presto",
                Gecko: "Gecko",
                WebKit: "WebKit"
            };
        },
        90: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(91)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            function a(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }
            var o = function() {
                function e() {}
                var t, r, n;
                return e.getParser = function(e, t) {
                    if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, t);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, t = e, n = [
                    {
                        key: "BROWSER_MAP",
                        get: function() {
                            return s.BROWSER_MAP;
                        }
                    },
                    {
                        key: "ENGINE_MAP",
                        get: function() {
                            return s.ENGINE_MAP;
                        }
                    },
                    {
                        key: "OS_MAP",
                        get: function() {
                            return s.OS_MAP;
                        }
                    },
                    {
                        key: "PLATFORMS_MAP",
                        get: function() {
                            return s.PLATFORMS_MAP;
                        }
                    }
                ], r = null, n && a(t, n), e;
            }();
            t.default = o, e.exports = t.default;
        },
        91: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = u(r(92)), i = u(r(93)), s = u(r(94)), a = u(r(95)), o = u(r(17));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var d = function() {
                function e(e, t) {
                    if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
                }
                var t = e.prototype;
                return t.getUA = function() {
                    return this._ua;
                }, t.test = function(e) {
                    return e.test(this._ua);
                }, t.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var t = o.default.find(n.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
                }, t.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, t.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, t.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, t.getOS = function() {
                    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, t.parseOS = function() {
                    var e = this;
                    this.parsedResult.os = {};
                    var t = o.default.find(i.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                }, t.getOSName = function(e) {
                    var t = this.getOS().name;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.getOSVersion = function() {
                    return this.getOS().version;
                }, t.getPlatform = function() {
                    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, t.getPlatformType = function(e) {
                    void 0 === e && (e = !1);
                    var t = this.getPlatform().type;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.parsePlatform = function() {
                    var e = this;
                    this.parsedResult.platform = {};
                    var t = o.default.find(s.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                }, t.getEngine = function() {
                    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, t.getEngineName = function(e) {
                    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, t.parseEngine = function() {
                    var e = this;
                    this.parsedResult.engine = {};
                    var t = o.default.find(a.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                }, t.parse = function() {
                    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, t.getResult = function() {
                    return o.default.assign({}, this.parsedResult);
                }, t.satisfies = function(e) {
                    var t = this, r = {}, n = 0, i = {}, s = 0;
                    if (Object.keys(e).forEach(function(t) {
                        var a = e[t];
                        "string" == typeof a ? (i[t] = a, s += 1) : "object" == typeof a && (r[t] = a, n += 1);
                    }), n > 0) {
                        var a = Object.keys(r), u = o.default.find(a, function(e) {
                            return t.isOS(e);
                        });
                        if (u) {
                            var d = this.satisfies(r[u]);
                            if (void 0 !== d) return d;
                        }
                        var c = o.default.find(a, function(e) {
                            return t.isPlatform(e);
                        });
                        if (c) {
                            var f = this.satisfies(r[c]);
                            if (void 0 !== f) return f;
                        }
                    }
                    if (s > 0) {
                        var l = Object.keys(i), h = o.default.find(l, function(e) {
                            return t.isBrowser(e, !0);
                        });
                        if (void 0 !== h) return this.compareVersion(i[h]);
                    }
                }, t.isBrowser = function(e, t) {
                    void 0 === t && (t = !1);
                    var r = this.getBrowserName().toLowerCase(), n = e.toLowerCase(), i = o.default.getBrowserTypeByAlias(n);
                    return t && i && (n = i.toLowerCase()), n === r;
                }, t.compareVersion = function(e) {
                    var t = [
                        0
                    ], r = e, n = !1, i = this.getBrowserVersion();
                    if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (n = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (n = !0, r = e.substr(1)), t.indexOf(o.default.compareVersions(i, r, n)) > -1;
                }, t.isOS = function(e) {
                    return this.getOSName(!0) === String(e).toLowerCase();
                }, t.isPlatform = function(e) {
                    return this.getPlatformType(!0) === String(e).toLowerCase();
                }, t.isEngine = function(e) {
                    return this.getEngineName(!0) === String(e).toLowerCase();
                }, t.is = function(e, t) {
                    return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                }, t.some = function(e) {
                    var t = this;
                    return void 0 === e && (e = []), e.some(function(e) {
                        return t.is(e);
                    });
                }, e;
            }();
            t.default = d, e.exports = t.default;
        },
        92: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            };
            var s = /version\/(\d+(\.?_?\d+)+)/i, a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Googlebot"
                        }, r = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Samsung Internet for Android"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "NAVER Whale Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MZBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "MZ Browser"
                        }, r = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /focus/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Focus"
                        }, r = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /swing/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Swing"
                        }, r = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Coast"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Touch"
                        }, r = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yabrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Yandex Browser"
                        }, r = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ucbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "UC Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Maxthon|mxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Maxthon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /epiphany/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Epiphany"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /puffin/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Puffin"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sleipnir/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sleipnir"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /k-meleon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "K-Meleon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /micromessenger/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WeChat"
                        }, r = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qqbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                        }, r = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Internet Explorer"
                        }, r = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Vivaldi"
                        }, r = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /seamonkey/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SeaMonkey"
                        }, r = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sailfish/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sailfish"
                        }, r = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Amazon Silk"
                        }, r = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /phantom/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PhantomJS"
                        }, r = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /slimerjs/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlimerJS"
                        }, r = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BlackBerry"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WebOS Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Bada"
                        }, r = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Tizen"
                        }, r = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qupzilla/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "QupZilla"
                        }, r = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Firefox"
                        }, r = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Electron"
                        }, r = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MiuiBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Miui"
                        }, r = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chromium"
                        }, r = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chrome"
                        }, r = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Google Search"
                        }, r = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = {
                            name: "Android Browser"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /playstation 4/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PlayStation 4"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Safari"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: i.default.getFirstMatch(t, e),
                            version: i.default.getSecondMatch(t, e)
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        93: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /Roku\/DVP/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                        return {
                            name: s.OS_MAP.Roku,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows phone/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.WindowsPhone,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows /i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = i.default.getWindowsVersionName(t);
                        return {
                            name: s.OS_MAP.Windows,
                            version: t,
                            versionName: r
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.OS_MAP.iOS
                        }, r = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /macintosh/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = i.default.getMacOSVersionName(t), n = {
                            name: s.OS_MAP.MacOS,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(ipod|iphone|ipad)/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                        return {
                            name: s.OS_MAP.iOS,
                            version: t
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = i.default.getAndroidVersionName(t), n = {
                            name: s.OS_MAP.Android,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                            name: s.OS_MAP.WebOS
                        };
                        return t && t.length && (r.version = t), r;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
                        return {
                            name: s.OS_MAP.BlackBerry,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Bada,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Tizen,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /linux/i
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.Linux
                        };
                    }
                },
                {
                    test: [
                        /CrOS/
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.ChromeOS
                        };
                    }
                },
                {
                    test: [
                        /PlayStation 4/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.PlayStation4,
                            version: t
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        94: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function() {
                        return {
                            type: "bot",
                            vendor: "Google"
                        };
                    }
                },
                {
                    test: [
                        /huawei/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Huawei"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /nexus\s*(?:7|8|9|10).*/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /ipad/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /kftt build/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon",
                            model: "Kindle Fire HD 7"
                        };
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /tablet(?! pc)/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(ipod|iphone)/i, e);
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Apple",
                            model: t
                        };
                    }
                },
                {
                    test: [
                        /nexus\s*[0-6].*/i,
                        /galaxy nexus/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /[^-]mobi/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "blackberry" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "BlackBerry"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "bada" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows phone" === e.getBrowserName();
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Microsoft"
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = Number(String(e.getOSVersion()).split(".")[0]);
                        return "android" === e.getOSName(!0) && t >= 3;
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        return "android" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "macos" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop,
                            vendor: "Apple"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "linux" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "playstation 4" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "roku" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        95: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: function(e) {
                        return "microsoft edge" === e.getBrowserName(!0);
                    },
                    describe: function(e) {
                        if (/\sedg\//i.test(e)) return {
                            name: s.ENGINE_MAP.Blink
                        };
                        var t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                        return {
                            name: s.ENGINE_MAP.EdgeHTML,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Trident
                        }, r = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return e.test(/presto/i);
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Presto
                        }, r = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Gecko
                        }, r = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(apple)?webkit\/537\.36/i
                    ],
                    describe: function() {
                        return {
                            name: s.ENGINE_MAP.Blink
                        };
                    }
                },
                {
                    test: [
                        /(apple)?webkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.WebKit
                        }, r = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        }
    });
});


const $6bb11abd8422769c$export$c132edb4cf3f7b9c = ({ serviceId: serviceId, clientVersion: clientVersion })=>async (config)=>{
        const parsedUA = typeof window !== "undefined" && window?.navigator?.userAgent ? (0, (/*@__PURE__*/$parcel$interopDefault($0e232a422ae1e322$exports))).parse(window.navigator.userAgent) : undefined;
        const sections = [
            [
                "aws-sdk-js",
                clientVersion
            ],
            [
                "ua",
                "2.1"
            ],
            [
                `os/${parsedUA?.os?.name || "other"}`,
                parsedUA?.os?.version
            ],
            [
                "lang/js"
            ],
            [
                "md/browser",
                `${parsedUA?.browser?.name ?? "unknown"}_${parsedUA?.browser?.version ?? "unknown"}`
            ]
        ];
        if (serviceId) sections.push([
            `api/${serviceId}`,
            clientVersion
        ]);
        const appId = await config?.userAgentAppId?.();
        if (appId) sections.push([
            `app/${appId}`
        ]);
        return sections;
    };
const $6bb11abd8422769c$export$69d579f32876892f = $6bb11abd8422769c$export$c132edb4cf3f7b9c;




const $53051f39ca48cb63$export$8b6362171c4dfa64 = (message)=>()=>{
        throw new Error(message);
    };


const $2e5ffb59202a2d85$export$d59dd53963f8f3d5 = (message)=>()=>Promise.reject(message);




const $9e4c3027d336cb04$var$TEXT_ENCODER = typeof TextEncoder == "function" ? new TextEncoder() : null;
const $9e4c3027d336cb04$export$967f3527bf233bc0 = (body)=>{
    if (typeof body === "string") {
        if ($9e4c3027d336cb04$var$TEXT_ENCODER) return $9e4c3027d336cb04$var$TEXT_ENCODER.encode(body).byteLength;
        let len = body.length;
        for(let i = len - 1; i >= 0; i--){
            const code = body.charCodeAt(i);
            if (code > 0x7f && code <= 0x7ff) len++;
            else if (code > 0x7ff && code <= 0xffff) len += 2;
            if (code >= 0xdc00 && code <= 0xdfff) i--;
        }
        return len;
    } else if (typeof body.byteLength === "number") return body.byteLength;
    else if (typeof body.size === "number") return body.size;
    throw new Error(`Body Length computation failed for ${body}`);
};







const $0632462b1246f20b$export$6a001c300b5a041e = (response)=>(0, $719e5a813689e03b$export$1d94dfe0d9d1f1e7).isInstance(response) ? response.headers?.date ?? response.headers?.Date : undefined;

const $80cc0de417457f0a$export$86d5c90340985ada = (systemClockOffset)=>new Date(Date.now() + systemClockOffset);


const $f6aae82532ff9cd0$export$c162a01d4a03ea6f = (clockTime, systemClockOffset)=>Math.abs((0, $80cc0de417457f0a$export$86d5c90340985ada)(systemClockOffset).getTime() - clockTime) >= 300000;


const $54be407aa22f19c1$export$1ed4d48b860b1348 = (clockTime, currentSystemClockOffset)=>{
    const clockTimeInMs = Date.parse(clockTime);
    if ((0, $f6aae82532ff9cd0$export$c162a01d4a03ea6f)(clockTimeInMs, currentSystemClockOffset)) return clockTimeInMs - Date.now();
    return currentSystemClockOffset;
};


const $93763e910902e47b$var$throwSigningPropertyError = (name, property)=>{
    if (!property) throw new Error(`Property \`${name}\` is not resolved for AWS SDK SigV4Auth`);
    return property;
};
const $93763e910902e47b$export$bca4a894ff7cfe11 = async (signingProperties)=>{
    const context = $93763e910902e47b$var$throwSigningPropertyError("context", signingProperties.context);
    const config = $93763e910902e47b$var$throwSigningPropertyError("config", signingProperties.config);
    const authScheme = context.endpointV2?.properties?.authSchemes?.[0];
    const signerFunction = $93763e910902e47b$var$throwSigningPropertyError("signer", config.signer);
    const signer = await signerFunction(authScheme);
    const signingRegion = signingProperties?.signingRegion;
    const signingRegionSet = signingProperties?.signingRegionSet;
    const signingName = signingProperties?.signingName;
    return {
        config: config,
        signer: signer,
        signingRegion: signingRegion,
        signingRegionSet: signingRegionSet,
        signingName: signingName
    };
};
class $93763e910902e47b$export$8d10c019aa195a2b {
    async sign(httpRequest, identity, signingProperties) {
        if (!(0, $36c92c5bbc6e0688$export$7587955500404ec3).isInstance(httpRequest)) throw new Error("The request is not an instance of `HttpRequest` and cannot be signed");
        const validatedProps = await $93763e910902e47b$export$bca4a894ff7cfe11(signingProperties);
        const { config: config, signer: signer } = validatedProps;
        let { signingRegion: signingRegion, signingName: signingName } = validatedProps;
        const handlerExecutionContext = signingProperties.context;
        if (handlerExecutionContext?.authSchemes?.length ?? false) {
            const [first, second] = handlerExecutionContext.authSchemes;
            if (first?.name === "sigv4a" && second?.name === "sigv4") {
                signingRegion = second?.signingRegion ?? signingRegion;
                signingName = second?.signingName ?? signingName;
            }
        }
        const signedRequest = await signer.sign(httpRequest, {
            signingDate: (0, $80cc0de417457f0a$export$86d5c90340985ada)(config.systemClockOffset),
            signingRegion: signingRegion,
            signingService: signingName
        });
        return signedRequest;
    }
    errorHandler(signingProperties) {
        return (error)=>{
            const serverTime = error.ServerTime ?? (0, $0632462b1246f20b$export$6a001c300b5a041e)(error.$response);
            if (serverTime) {
                const config = $93763e910902e47b$var$throwSigningPropertyError("config", signingProperties.config);
                const initialSystemClockOffset = config.systemClockOffset;
                config.systemClockOffset = (0, $54be407aa22f19c1$export$1ed4d48b860b1348)(serverTime, config.systemClockOffset);
                const clockSkewCorrected = config.systemClockOffset !== initialSystemClockOffset;
                if (clockSkewCorrected && error.$metadata) error.$metadata.clockSkewCorrected = true;
            }
            throw error;
        };
    }
    successHandler(httpResponse, signingProperties) {
        const dateHeader = (0, $0632462b1246f20b$export$6a001c300b5a041e)(httpResponse);
        if (dateHeader) {
            const config = $93763e910902e47b$var$throwSigningPropertyError("config", signingProperties.config);
            config.systemClockOffset = (0, $54be407aa22f19c1$export$1ed4d48b860b1348)(dateHeader, config.systemClockOffset);
        }
    }
}
const $93763e910902e47b$export$9e647fbacb03e1b7 = $93763e910902e47b$export$8d10c019aa195a2b;










const $abf0c54a0b56ce11$var$s = "required", $abf0c54a0b56ce11$var$t = "fn", $abf0c54a0b56ce11$var$u = "argv", $abf0c54a0b56ce11$var$v = "ref";
const $abf0c54a0b56ce11$var$a = true, $abf0c54a0b56ce11$var$b = "isSet", $abf0c54a0b56ce11$var$c = "booleanEquals", $abf0c54a0b56ce11$var$d = "error", $abf0c54a0b56ce11$var$e = "endpoint", $abf0c54a0b56ce11$var$f = "tree", $abf0c54a0b56ce11$var$g = "PartitionResult", $abf0c54a0b56ce11$var$h = {
    [$abf0c54a0b56ce11$var$s]: false,
    "type": "String"
}, $abf0c54a0b56ce11$var$i = {
    [$abf0c54a0b56ce11$var$s]: true,
    "default": false,
    "type": "Boolean"
}, $abf0c54a0b56ce11$var$j = {
    [$abf0c54a0b56ce11$var$v]: "Endpoint"
}, $abf0c54a0b56ce11$var$k = {
    [$abf0c54a0b56ce11$var$t]: $abf0c54a0b56ce11$var$c,
    [$abf0c54a0b56ce11$var$u]: [
        {
            [$abf0c54a0b56ce11$var$v]: "UseFIPS"
        },
        true
    ]
}, $abf0c54a0b56ce11$var$l = {
    [$abf0c54a0b56ce11$var$t]: $abf0c54a0b56ce11$var$c,
    [$abf0c54a0b56ce11$var$u]: [
        {
            [$abf0c54a0b56ce11$var$v]: "UseDualStack"
        },
        true
    ]
}, $abf0c54a0b56ce11$var$m = {}, $abf0c54a0b56ce11$var$n = {
    [$abf0c54a0b56ce11$var$t]: "getAttr",
    [$abf0c54a0b56ce11$var$u]: [
        {
            [$abf0c54a0b56ce11$var$v]: $abf0c54a0b56ce11$var$g
        },
        "supportsFIPS"
    ]
}, $abf0c54a0b56ce11$var$o = {
    [$abf0c54a0b56ce11$var$t]: $abf0c54a0b56ce11$var$c,
    [$abf0c54a0b56ce11$var$u]: [
        true,
        {
            [$abf0c54a0b56ce11$var$t]: "getAttr",
            [$abf0c54a0b56ce11$var$u]: [
                {
                    [$abf0c54a0b56ce11$var$v]: $abf0c54a0b56ce11$var$g
                },
                "supportsDualStack"
            ]
        }
    ]
}, $abf0c54a0b56ce11$var$p = [
    $abf0c54a0b56ce11$var$k
], $abf0c54a0b56ce11$var$q = [
    $abf0c54a0b56ce11$var$l
], $abf0c54a0b56ce11$var$r = [
    {
        [$abf0c54a0b56ce11$var$v]: "Region"
    }
];
const $abf0c54a0b56ce11$var$_data = {
    version: "1.0",
    parameters: {
        Region: $abf0c54a0b56ce11$var$h,
        UseDualStack: $abf0c54a0b56ce11$var$i,
        UseFIPS: $abf0c54a0b56ce11$var$i,
        Endpoint: $abf0c54a0b56ce11$var$h
    },
    rules: [
        {
            conditions: [
                {
                    [$abf0c54a0b56ce11$var$t]: $abf0c54a0b56ce11$var$b,
                    [$abf0c54a0b56ce11$var$u]: [
                        $abf0c54a0b56ce11$var$j
                    ]
                }
            ],
            rules: [
                {
                    conditions: $abf0c54a0b56ce11$var$p,
                    error: "Invalid Configuration: FIPS and custom endpoint are not supported",
                    type: $abf0c54a0b56ce11$var$d
                },
                {
                    conditions: $abf0c54a0b56ce11$var$q,
                    error: "Invalid Configuration: Dualstack and custom endpoint are not supported",
                    type: $abf0c54a0b56ce11$var$d
                },
                {
                    endpoint: {
                        url: $abf0c54a0b56ce11$var$j,
                        properties: $abf0c54a0b56ce11$var$m,
                        headers: $abf0c54a0b56ce11$var$m
                    },
                    type: $abf0c54a0b56ce11$var$e
                }
            ],
            type: $abf0c54a0b56ce11$var$f
        },
        {
            conditions: [
                {
                    [$abf0c54a0b56ce11$var$t]: $abf0c54a0b56ce11$var$b,
                    [$abf0c54a0b56ce11$var$u]: $abf0c54a0b56ce11$var$r
                }
            ],
            rules: [
                {
                    conditions: [
                        {
                            [$abf0c54a0b56ce11$var$t]: "aws.partition",
                            [$abf0c54a0b56ce11$var$u]: $abf0c54a0b56ce11$var$r,
                            assign: $abf0c54a0b56ce11$var$g
                        }
                    ],
                    rules: [
                        {
                            conditions: [
                                $abf0c54a0b56ce11$var$k,
                                $abf0c54a0b56ce11$var$l
                            ],
                            rules: [
                                {
                                    conditions: [
                                        {
                                            [$abf0c54a0b56ce11$var$t]: $abf0c54a0b56ce11$var$c,
                                            [$abf0c54a0b56ce11$var$u]: [
                                                $abf0c54a0b56ce11$var$a,
                                                $abf0c54a0b56ce11$var$n
                                            ]
                                        },
                                        $abf0c54a0b56ce11$var$o
                                    ],
                                    rules: [
                                        {
                                            endpoint: {
                                                url: "https://cognito-identity-fips.{Region}.{PartitionResult#dualStackDnsSuffix}",
                                                properties: $abf0c54a0b56ce11$var$m,
                                                headers: $abf0c54a0b56ce11$var$m
                                            },
                                            type: $abf0c54a0b56ce11$var$e
                                        }
                                    ],
                                    type: $abf0c54a0b56ce11$var$f
                                },
                                {
                                    error: "FIPS and DualStack are enabled, but this partition does not support one or both",
                                    type: $abf0c54a0b56ce11$var$d
                                }
                            ],
                            type: $abf0c54a0b56ce11$var$f
                        },
                        {
                            conditions: $abf0c54a0b56ce11$var$p,
                            rules: [
                                {
                                    conditions: [
                                        {
                                            [$abf0c54a0b56ce11$var$t]: $abf0c54a0b56ce11$var$c,
                                            [$abf0c54a0b56ce11$var$u]: [
                                                $abf0c54a0b56ce11$var$n,
                                                $abf0c54a0b56ce11$var$a
                                            ]
                                        }
                                    ],
                                    rules: [
                                        {
                                            endpoint: {
                                                url: "https://cognito-identity-fips.{Region}.{PartitionResult#dnsSuffix}",
                                                properties: $abf0c54a0b56ce11$var$m,
                                                headers: $abf0c54a0b56ce11$var$m
                                            },
                                            type: $abf0c54a0b56ce11$var$e
                                        }
                                    ],
                                    type: $abf0c54a0b56ce11$var$f
                                },
                                {
                                    error: "FIPS is enabled but this partition does not support FIPS",
                                    type: $abf0c54a0b56ce11$var$d
                                }
                            ],
                            type: $abf0c54a0b56ce11$var$f
                        },
                        {
                            conditions: $abf0c54a0b56ce11$var$q,
                            rules: [
                                {
                                    conditions: [
                                        $abf0c54a0b56ce11$var$o
                                    ],
                                    rules: [
                                        {
                                            endpoint: {
                                                url: "https://cognito-identity.{Region}.{PartitionResult#dualStackDnsSuffix}",
                                                properties: $abf0c54a0b56ce11$var$m,
                                                headers: $abf0c54a0b56ce11$var$m
                                            },
                                            type: $abf0c54a0b56ce11$var$e
                                        }
                                    ],
                                    type: $abf0c54a0b56ce11$var$f
                                },
                                {
                                    error: "DualStack is enabled but this partition does not support DualStack",
                                    type: $abf0c54a0b56ce11$var$d
                                }
                            ],
                            type: $abf0c54a0b56ce11$var$f
                        },
                        {
                            endpoint: {
                                url: "https://cognito-identity.{Region}.{PartitionResult#dnsSuffix}",
                                properties: $abf0c54a0b56ce11$var$m,
                                headers: $abf0c54a0b56ce11$var$m
                            },
                            type: $abf0c54a0b56ce11$var$e
                        }
                    ],
                    type: $abf0c54a0b56ce11$var$f
                }
            ],
            type: $abf0c54a0b56ce11$var$f
        },
        {
            error: "Invalid Configuration: Missing Region",
            type: $abf0c54a0b56ce11$var$d
        }
    ]
};
const $abf0c54a0b56ce11$export$7b249e066372152f = $abf0c54a0b56ce11$var$_data;


const $eeaa620e218eeeb4$var$cache = new (0, $d06f12251068eb72$export$262eb2e4804ef909)({
    size: 50,
    params: [
        "Endpoint",
        "Region",
        "UseDualStack",
        "UseFIPS"
    ]
});
const $eeaa620e218eeeb4$export$47fc6e98c86e06e3 = (endpointParams, context = {})=>{
    return $eeaa620e218eeeb4$var$cache.get(endpointParams, ()=>(0, $c21f7418bd0df18f$export$48b88e4e5ecac119)((0, $abf0c54a0b56ce11$export$7b249e066372152f), {
            endpointParams: endpointParams,
            logger: context.logger
        }));
};
(0, $91b7ba976acbb024$export$2614fba0847da171).aws = (0, $8e31713c360183c3$export$1bfd97ffc6d0eef8);


const $16249e56868b6843$export$ad0966540b0e71e5 = (config)=>{
    return {
        apiVersion: "2014-06-30",
        base64Decoder: config?.base64Decoder ?? (0, $7b3498acd0b4495b$export$c537b38001c583b7),
        base64Encoder: config?.base64Encoder ?? (0, $d63237a3fb21a427$export$37cc283d8fbd3462),
        disableHostPrefix: config?.disableHostPrefix ?? false,
        endpointProvider: config?.endpointProvider ?? (0, $eeaa620e218eeeb4$export$47fc6e98c86e06e3),
        extensions: config?.extensions ?? [],
        httpAuthSchemeProvider: config?.httpAuthSchemeProvider ?? (0, $bd31d60ce493d67e$export$d514ed0616437588),
        httpAuthSchemes: config?.httpAuthSchemes ?? [
            {
                schemeId: "aws.auth#sigv4",
                identityProvider: (ipc)=>ipc.getIdentityProvider("aws.auth#sigv4"),
                signer: new (0, $93763e910902e47b$export$8d10c019aa195a2b)()
            },
            {
                schemeId: "smithy.api#noAuth",
                identityProvider: (ipc)=>ipc.getIdentityProvider("smithy.api#noAuth") || (async ()=>({})),
                signer: new (0, $68474e33de95c781$export$19622a6daa7bca6e)()
            }
        ],
        logger: config?.logger ?? new (0, $c9caefe05bf12396$export$4147bde06f294c2e)(),
        serviceId: config?.serviceId ?? "Cognito Identity",
        urlParser: config?.urlParser ?? (0, $931d216cb423ad36$export$7a5253c0f62e0150),
        utf8Decoder: config?.utf8Decoder ?? (0, $443e71811b7d31c6$export$c7c5cef950a4d2fc),
        utf8Encoder: config?.utf8Encoder ?? (0, $5a195679de934416$export$b4b216764bb846eb)
    };
};



class $97e5cad572821975$export$478ec1fdae99aa79 extends Error {
    constructor(message, options = true){
        let logger;
        let tryNextLink = true;
        if (typeof options === "boolean") {
            logger = undefined;
            tryNextLink = options;
        } else if (options != null && typeof options === "object") {
            logger = options.logger;
            tryNextLink = options.tryNextLink ?? true;
        }
        super(message);
        this.name = "ProviderError";
        this.tryNextLink = tryNextLink;
        Object.setPrototypeOf(this, $97e5cad572821975$export$478ec1fdae99aa79.prototype);
        logger?.debug?.(`@smithy/property-provider ${tryNextLink ? "->" : "(!)"} ${message}`);
    }
    static from(error, options = true) {
        return Object.assign(new this(error.message, options), error);
    }
}


class $82210d6493f640f7$export$921076535eff0df5 extends (0, $97e5cad572821975$export$478ec1fdae99aa79) {
    constructor(message, options = true){
        super(message, options);
        this.name = "CredentialsProviderError";
        Object.setPrototypeOf(this, $82210d6493f640f7$export$921076535eff0df5.prototype);
    }
}




class $14cbebc2be99e7dc$export$5c605c2f83e2f56b extends (0, $97e5cad572821975$export$478ec1fdae99aa79) {
    constructor(message, options = true){
        super(message, options);
        this.name = "TokenProviderError";
        Object.setPrototypeOf(this, $14cbebc2be99e7dc$export$5c605c2f83e2f56b.prototype);
    }
}



const $1fa5d4a4101c3383$export$e08e3b67e392101e = (...providers)=>async ()=>{
        if (providers.length === 0) throw new (0, $97e5cad572821975$export$478ec1fdae99aa79)("No providers in chain");
        let lastProviderError;
        for (const provider of providers)try {
            const credentials = await provider();
            return credentials;
        } catch (err) {
            lastProviderError = err;
            if (err?.tryNextLink) continue;
            throw err;
        }
        throw lastProviderError;
    };


const $9190d595435cde59$export$294ab423a8f4a426 = (staticValue)=>()=>Promise.resolve(staticValue);


const $84ba1368a06c1684$export$fc10aeed3a532e2a = (provider, isExpired, requiresRefresh)=>{
    let resolved;
    let pending;
    let hasResult;
    let isConstant = false;
    const coalesceProvider = async ()=>{
        if (!pending) pending = provider();
        try {
            resolved = await pending;
            hasResult = true;
            isConstant = false;
        } finally{
            pending = undefined;
        }
        return resolved;
    };
    if (isExpired === undefined) return async (options)=>{
        if (!hasResult || options?.forceRefresh) resolved = await coalesceProvider();
        return resolved;
    };
    return async (options)=>{
        if (!hasResult || options?.forceRefresh) resolved = await coalesceProvider();
        if (isConstant) return resolved;
        if (requiresRefresh && !requiresRefresh(resolved)) {
            isConstant = true;
            return resolved;
        }
        if (isExpired(resolved)) {
            await coalesceProvider();
            return resolved;
        }
        return resolved;
    };
};





const $2d87e674d5e9db19$export$32aeb2667d16f7c1 = [
    "in-region",
    "cross-region",
    "mobile",
    "standard",
    "legacy"
];


const $4b5f1111656da5bf$export$b146d618450007ac = ({ defaultsMode: defaultsMode } = {})=>(0, $84ba1368a06c1684$export$fc10aeed3a532e2a)(async ()=>{
        const mode = typeof defaultsMode === "function" ? await defaultsMode() : defaultsMode;
        switch(mode?.toLowerCase()){
            case "auto":
                return Promise.resolve($4b5f1111656da5bf$var$isMobileBrowser() ? "mobile" : "standard");
            case "mobile":
            case "in-region":
            case "cross-region":
            case "standard":
            case "legacy":
                return Promise.resolve(mode?.toLocaleLowerCase());
            case undefined:
                return Promise.resolve("legacy");
            default:
                throw new Error(`Invalid parameter for "defaultsMode", expect ${(0, $2d87e674d5e9db19$export$32aeb2667d16f7c1).join(", ")}, got ${mode}`);
        }
    });
const $4b5f1111656da5bf$var$isMobileBrowser = ()=>{
    const parsedUA = typeof window !== "undefined" && window?.navigator?.userAgent ? (0, (/*@__PURE__*/$parcel$interopDefault($0e232a422ae1e322$exports))).parse(window.navigator.userAgent) : undefined;
    const platform = parsedUA?.platform?.type;
    return platform === "tablet" || platform === "mobile";
};




const $675b03855634264c$export$ad0966540b0e71e5 = (config)=>{
    const defaultsMode = (0, $4b5f1111656da5bf$export$b146d618450007ac)(config);
    const defaultConfigProvider = ()=>defaultsMode().then((0, $9ab7bd0f453434be$export$b6e2b46631b45a92));
    const clientSharedValues = (0, $16249e56868b6843$export$ad0966540b0e71e5)(config);
    return {
        ...clientSharedValues,
        ...config,
        runtime: "browser",
        defaultsMode: defaultsMode,
        bodyLengthChecker: config?.bodyLengthChecker ?? (0, $9e4c3027d336cb04$export$967f3527bf233bc0),
        credentialDefaultProvider: config?.credentialDefaultProvider ?? ((_)=>()=>Promise.reject(new Error("Credential is missing"))),
        defaultUserAgentProvider: config?.defaultUserAgentProvider ?? (0, $6bb11abd8422769c$export$c132edb4cf3f7b9c)({
            serviceId: clientSharedValues.serviceId,
            clientVersion: (0, (/*@__PURE__*/$parcel$interopDefault($604602824a48a3ef$exports))).version
        }),
        maxAttempts: config?.maxAttempts ?? (0, $5509594642b1e771$export$2c7e51f38ba5a406),
        region: config?.region ?? (0, $2e5ffb59202a2d85$export$d59dd53963f8f3d5)("Region is missing"),
        requestHandler: (0, $40b502f5f0978093$export$83588b87edbfa7e0).create(config?.requestHandler ?? defaultConfigProvider),
        retryMode: config?.retryMode ?? (async ()=>(await defaultConfigProvider()).retryMode || (0, $5509594642b1e771$export$41315747b7c5d042)),
        sha256: config?.sha256 ?? (0, $96d9020e18f0029b$export$3b58ea8124ac5e28),
        streamCollector: config?.streamCollector ?? (0, $03d6a1cc7230aa78$export$17bf97b72e307d52),
        useDualstackEndpoint: config?.useDualstackEndpoint ?? (()=>Promise.resolve((0, $8bc367ec79540d60$export$beb01fae7626c427))),
        useFipsEndpoint: config?.useFipsEndpoint ?? (()=>Promise.resolve((0, $6569393054577581$export$5555deeca435a10b)))
    };
};


const $f7899cd52cf70df9$export$be3086d183cd8ea6 = (runtimeConfig)=>{
    let runtimeConfigRegion = async ()=>{
        if (runtimeConfig.region === undefined) throw new Error("Region is missing from runtimeConfig");
        const region = runtimeConfig.region;
        if (typeof region === "string") return region;
        return region();
    };
    return {
        setRegion (region) {
            runtimeConfigRegion = region;
        },
        region () {
            return runtimeConfigRegion;
        }
    };
};
const $f7899cd52cf70df9$export$74973a8fb8dfc16e = (awsRegionExtensionConfiguration)=>{
    return {
        region: awsRegionExtensionConfiguration.region()
    };
};


const $4e056b38f66c0ad3$export$26513716e2900bad = "AWS_REGION";
const $4e056b38f66c0ad3$export$8afb1c306a7d01b = "region";
const $4e056b38f66c0ad3$export$1509d3ea54119a08 = {
    environmentVariableSelector: (env)=>env[$4e056b38f66c0ad3$export$26513716e2900bad],
    configFileSelector: (profile)=>profile[$4e056b38f66c0ad3$export$8afb1c306a7d01b],
    default: ()=>{
        throw new Error("Region is missing");
    }
};
const $4e056b38f66c0ad3$export$9a37503ca194454d = {
    preferredFile: "credentials"
};


const $af33486b47d05c7b$export$cc893cb7e6a508dd = (region)=>typeof region === "string" && (region.startsWith("fips-") || region.endsWith("-fips"));


const $7c41dc8c94de9002$export$ecbdf004a8547a7f = (region)=>(0, $af33486b47d05c7b$export$cc893cb7e6a508dd)(region) ? [
        "fips-aws-global",
        "aws-fips"
    ].includes(region) ? "us-east-1" : region.replace(/fips-(dkr-|prod-)?|-fips/, "") : region;



const $5e0e6d6788f01770$export$7696ef37558bd0ec = (input)=>{
    const { region: region, useFipsEndpoint: useFipsEndpoint } = input;
    if (!region) throw new Error("Region is missing");
    return {
        ...input,
        region: async ()=>{
            if (typeof region === "string") return (0, $7c41dc8c94de9002$export$ecbdf004a8547a7f)(region);
            const providedRegion = await region();
            return (0, $7c41dc8c94de9002$export$ecbdf004a8547a7f)(providedRegion);
        },
        useFipsEndpoint: async ()=>{
            const providedRegion = typeof region === "string" ? region : await region();
            if ((0, $af33486b47d05c7b$export$cc893cb7e6a508dd)(providedRegion)) return true;
            return typeof useFipsEndpoint !== "function" ? Promise.resolve(!!useFipsEndpoint) : useFipsEndpoint();
        }
    };
};








const $ab13edad010e6582$export$e536d87ced0d9700 = (runtimeConfig)=>{
    const _httpAuthSchemes = runtimeConfig.httpAuthSchemes;
    let _httpAuthSchemeProvider = runtimeConfig.httpAuthSchemeProvider;
    let _credentials = runtimeConfig.credentials;
    return {
        setHttpAuthScheme (httpAuthScheme) {
            const index = _httpAuthSchemes.findIndex((scheme)=>scheme.schemeId === httpAuthScheme.schemeId);
            if (index === -1) _httpAuthSchemes.push(httpAuthScheme);
            else _httpAuthSchemes.splice(index, 1, httpAuthScheme);
        },
        httpAuthSchemes () {
            return _httpAuthSchemes;
        },
        setHttpAuthSchemeProvider (httpAuthSchemeProvider) {
            _httpAuthSchemeProvider = httpAuthSchemeProvider;
        },
        httpAuthSchemeProvider () {
            return _httpAuthSchemeProvider;
        },
        setCredentials (credentials) {
            _credentials = credentials;
        },
        credentials () {
            return _credentials;
        }
    };
};
const $ab13edad010e6582$export$60c55f59b27530a8 = (config)=>{
    return {
        httpAuthSchemes: config.httpAuthSchemes(),
        httpAuthSchemeProvider: config.httpAuthSchemeProvider(),
        credentials: config.credentials()
    };
};


const $6f928516d9fcde39$var$asPartial = (t)=>t;
const $6f928516d9fcde39$export$4278118b303a14cf = (runtimeConfig, extensions)=>{
    const extensionConfiguration = {
        ...$6f928516d9fcde39$var$asPartial((0, $f7899cd52cf70df9$export$be3086d183cd8ea6)(runtimeConfig)),
        ...$6f928516d9fcde39$var$asPartial((0, $cef2627dbb2c7da1$export$2d53aaae46f156f5)(runtimeConfig)),
        ...$6f928516d9fcde39$var$asPartial((0, $84f26894dd035c27$export$663b205817703038)(runtimeConfig)),
        ...$6f928516d9fcde39$var$asPartial((0, $ab13edad010e6582$export$e536d87ced0d9700)(runtimeConfig))
    };
    extensions.forEach((extension)=>extension.configure(extensionConfiguration));
    return {
        ...runtimeConfig,
        ...(0, $f7899cd52cf70df9$export$74973a8fb8dfc16e)(extensionConfiguration),
        ...(0, $cef2627dbb2c7da1$export$abfa28b95316e0ae)(extensionConfiguration),
        ...(0, $84f26894dd035c27$export$d94fe0350385c1a8)(extensionConfiguration),
        ...(0, $ab13edad010e6582$export$60c55f59b27530a8)(extensionConfiguration)
    };
};


class $9394dfc236f09272$export$e576def690e850f7 extends (0, $514104a2dba81648$export$1f2bb630327ac4b6) {
    config;
    constructor(...[configuration]){
        const _config_0 = (0, $675b03855634264c$export$ad0966540b0e71e5)(configuration || {});
        const _config_1 = (0, $d1223e7c10daafaf$export$70b6341cd51750a8)(_config_0);
        const _config_2 = (0, $3b038e7801e78d35$export$ec9a2d5663958cb)(_config_1);
        const _config_3 = (0, $5ca3ff7097febeef$export$ca7f6138f2c98476)(_config_2);
        const _config_4 = (0, $83ef33ca75f7dd65$export$7696ef37558bd0ec)(_config_3);
        const _config_5 = (0, $b173a3ce9281b3cf$export$c1625bf0b32b4481)(_config_4);
        const _config_6 = (0, $dedc7eba2c45bbb9$export$8c5b66831e3f26ff)(_config_5);
        const _config_7 = (0, $bd31d60ce493d67e$export$d38ef9c0c6c649ab)(_config_6);
        const _config_8 = (0, $6f928516d9fcde39$export$4278118b303a14cf)(_config_7, configuration?.extensions || []);
        super(_config_8);
        this.config = _config_8;
        this.middlewareStack.use((0, $168add9a52432ffc$export$5393c0d2d7f4f5f0)(this.config));
        this.middlewareStack.use((0, $9ba3cc7a799aee7e$export$c73199e2b1df9340)(this.config));
        this.middlewareStack.use((0, $88932ea823bca647$export$7e6ddf9365a30fe9)(this.config));
        this.middlewareStack.use((0, $b173a3ce9281b3cf$export$23d3b647211be53a)(this.config));
        this.middlewareStack.use((0, $60459010f05dd111$export$f6ef65d7766fc255)(this.config));
        this.middlewareStack.use((0, $8825720894d7451a$export$11d0b9345788bd5)(this.config));
        this.middlewareStack.use((0, $1fcce1fc5214c9cb$export$6ababc1a6356ca41)(this.config, {
            httpAuthSchemeParametersProvider: (0, $bd31d60ce493d67e$export$55102b547b733381),
            identityProviderConfigProvider: async (config)=>new (0, $99ebb391854b554e$export$67f43b78065c5551)({
                    "aws.auth#sigv4": config.credentials
                })
        }));
        this.middlewareStack.use((0, $a232cb521b867f08$export$ed476aa7e410a)(this.config));
    }
    destroy() {
        super.destroy();
    }
}







class $ef927458c91b40a7$export$b83d40bae15eaefa extends (0, $11a0343ffd48eaff$export$29647f3b4097d3c0) {
    constructor(options){
        super(options);
        Object.setPrototypeOf(this, $ef927458c91b40a7$export$b83d40bae15eaefa.prototype);
    }
}


const $9603a5372f221de0$export$dc00db384271fff6 = {
    AUTHENTICATED_ROLE: "AuthenticatedRole",
    DENY: "Deny"
};
class $9603a5372f221de0$export$8b0f706f4df56c63 extends (0, $ef927458c91b40a7$export$b83d40bae15eaefa) {
    name = "InternalErrorException";
    $fault = "server";
    constructor(opts){
        super({
            name: "InternalErrorException",
            $fault: "server",
            ...opts
        });
        Object.setPrototypeOf(this, $9603a5372f221de0$export$8b0f706f4df56c63.prototype);
    }
}
class $9603a5372f221de0$export$fa781b52e13bf866 extends (0, $ef927458c91b40a7$export$b83d40bae15eaefa) {
    name = "InvalidParameterException";
    $fault = "client";
    constructor(opts){
        super({
            name: "InvalidParameterException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $9603a5372f221de0$export$fa781b52e13bf866.prototype);
    }
}
class $9603a5372f221de0$export$cd419aa7f32ec382 extends (0, $ef927458c91b40a7$export$b83d40bae15eaefa) {
    name = "LimitExceededException";
    $fault = "client";
    constructor(opts){
        super({
            name: "LimitExceededException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $9603a5372f221de0$export$cd419aa7f32ec382.prototype);
    }
}
class $9603a5372f221de0$export$82cff5e5a0a874dd extends (0, $ef927458c91b40a7$export$b83d40bae15eaefa) {
    name = "NotAuthorizedException";
    $fault = "client";
    constructor(opts){
        super({
            name: "NotAuthorizedException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $9603a5372f221de0$export$82cff5e5a0a874dd.prototype);
    }
}
class $9603a5372f221de0$export$cbdaf31887dd0603 extends (0, $ef927458c91b40a7$export$b83d40bae15eaefa) {
    name = "ResourceConflictException";
    $fault = "client";
    constructor(opts){
        super({
            name: "ResourceConflictException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $9603a5372f221de0$export$cbdaf31887dd0603.prototype);
    }
}
class $9603a5372f221de0$export$4a67805ad445f61 extends (0, $ef927458c91b40a7$export$b83d40bae15eaefa) {
    name = "TooManyRequestsException";
    $fault = "client";
    constructor(opts){
        super({
            name: "TooManyRequestsException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $9603a5372f221de0$export$4a67805ad445f61.prototype);
    }
}
const $9603a5372f221de0$export$d4e71bc0b80dc0fb = {
    ACCESS_DENIED: "AccessDenied",
    INTERNAL_SERVER_ERROR: "InternalServerError"
};
class $9603a5372f221de0$export$ecba565262f8bb2 extends (0, $ef927458c91b40a7$export$b83d40bae15eaefa) {
    name = "ResourceNotFoundException";
    $fault = "client";
    constructor(opts){
        super({
            name: "ResourceNotFoundException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $9603a5372f221de0$export$ecba565262f8bb2.prototype);
    }
}
class $9603a5372f221de0$export$cb77a58cb7dbb17 extends (0, $ef927458c91b40a7$export$b83d40bae15eaefa) {
    name = "ExternalServiceException";
    $fault = "client";
    constructor(opts){
        super({
            name: "ExternalServiceException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $9603a5372f221de0$export$cb77a58cb7dbb17.prototype);
    }
}
class $9603a5372f221de0$export$90d12448d3766cda extends (0, $ef927458c91b40a7$export$b83d40bae15eaefa) {
    name = "InvalidIdentityPoolConfigurationException";
    $fault = "client";
    constructor(opts){
        super({
            name: "InvalidIdentityPoolConfigurationException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $9603a5372f221de0$export$90d12448d3766cda.prototype);
    }
}
const $9603a5372f221de0$export$819b5ceb37e06be = {
    CONTAINS: "Contains",
    EQUALS: "Equals",
    NOT_EQUAL: "NotEqual",
    STARTS_WITH: "StartsWith"
};
const $9603a5372f221de0$export$c726ef784882c23e = {
    RULES: "Rules",
    TOKEN: "Token"
};
class $9603a5372f221de0$export$f9e8c5d2069aeea4 extends (0, $ef927458c91b40a7$export$b83d40bae15eaefa) {
    name = "DeveloperUserAlreadyRegisteredException";
    $fault = "client";
    constructor(opts){
        super({
            name: "DeveloperUserAlreadyRegisteredException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $9603a5372f221de0$export$f9e8c5d2069aeea4.prototype);
    }
}
class $9603a5372f221de0$export$21f15e80c2bbca09 extends (0, $ef927458c91b40a7$export$b83d40bae15eaefa) {
    name = "ConcurrentModificationException";
    $fault = "client";
    constructor(opts){
        super({
            name: "ConcurrentModificationException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $9603a5372f221de0$export$21f15e80c2bbca09.prototype);
    }
}
const $9603a5372f221de0$export$d3143998ef536f3a = (obj)=>({
        ...obj,
        ...obj.Logins && {
            Logins: (0, $396b6e4de1f32a66$export$17127055dc9ac067)
        }
    });
const $9603a5372f221de0$export$e77297d79eddfc1d = (obj)=>({
        ...obj,
        ...obj.SecretKey && {
            SecretKey: (0, $396b6e4de1f32a66$export$17127055dc9ac067)
        }
    });
const $9603a5372f221de0$export$10923a44d2e5c004 = (obj)=>({
        ...obj,
        ...obj.Credentials && {
            Credentials: $9603a5372f221de0$export$e77297d79eddfc1d(obj.Credentials)
        }
    });
const $9603a5372f221de0$export$9324de7567a14b0d = (obj)=>({
        ...obj,
        ...obj.Logins && {
            Logins: (0, $396b6e4de1f32a66$export$17127055dc9ac067)
        }
    });
const $9603a5372f221de0$export$2b3066f9a138cb65 = (obj)=>({
        ...obj,
        ...obj.Logins && {
            Logins: (0, $396b6e4de1f32a66$export$17127055dc9ac067)
        }
    });
const $9603a5372f221de0$export$715d19cd9534db0 = (obj)=>({
        ...obj,
        ...obj.Token && {
            Token: (0, $396b6e4de1f32a66$export$17127055dc9ac067)
        }
    });
const $9603a5372f221de0$export$7bc4794b19d19d3d = (obj)=>({
        ...obj,
        ...obj.Logins && {
            Logins: (0, $396b6e4de1f32a66$export$17127055dc9ac067)
        }
    });
const $9603a5372f221de0$export$28f68ffdacabd233 = (obj)=>({
        ...obj,
        ...obj.Token && {
            Token: (0, $396b6e4de1f32a66$export$17127055dc9ac067)
        }
    });
const $9603a5372f221de0$export$f4ea1535a7a87395 = (obj)=>({
        ...obj,
        ...obj.Logins && {
            Logins: (0, $396b6e4de1f32a66$export$17127055dc9ac067)
        }
    });



const $4c5b77b7f021a981$export$3cc1021c6dfb9c3e = (streamBody, context)=>(0, $7667c5ed780ba41a$export$3392bcddb824e5ca)(streamBody, context).then((body)=>context.utf8Encoder(body));


const $496d3a9f084d8cd2$export$759bcb35b0d1bf81 = (streamBody, context)=>(0, $4c5b77b7f021a981$export$3cc1021c6dfb9c3e)(streamBody, context).then((encoded)=>{
        if (encoded.length) try {
            return JSON.parse(encoded);
        } catch (e) {
            if (e?.name === "SyntaxError") Object.defineProperty(e, "$responseBodyText", {
                value: encoded
            });
            throw e;
        }
        return {};
    });
const $496d3a9f084d8cd2$export$cb111c4739f3951f = async (errorBody, context)=>{
    const value = await $496d3a9f084d8cd2$export$759bcb35b0d1bf81(errorBody, context);
    value.message = value.message ?? value.Message;
    return value;
};
const $496d3a9f084d8cd2$export$6e21dac881a79e70 = (output, data)=>{
    const findKey = (object, key)=>Object.keys(object).find((k)=>k.toLowerCase() === key.toLowerCase());
    const sanitizeErrorCode = (rawValue)=>{
        let cleanValue = rawValue;
        if (typeof cleanValue === "number") cleanValue = cleanValue.toString();
        if (cleanValue.indexOf(",") >= 0) cleanValue = cleanValue.split(",")[0];
        if (cleanValue.indexOf(":") >= 0) cleanValue = cleanValue.split(":")[0];
        if (cleanValue.indexOf("#") >= 0) cleanValue = cleanValue.split("#")[1];
        return cleanValue;
    };
    const headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) return sanitizeErrorCode(output.headers[headerKey]);
    if (data.code !== undefined) return sanitizeErrorCode(data.code);
    if (data["__type"] !== undefined) return sanitizeErrorCode(data["__type"]);
};






const $d927e6851be90e99$export$4afbd356070311cf = async (input, context)=>{
    const headers = $d927e6851be90e99$var$sharedHeaders("CreateIdentityPool");
    let body;
    body = JSON.stringify((0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(input));
    return $d927e6851be90e99$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $d927e6851be90e99$export$396844781e030202 = async (input, context)=>{
    const headers = $d927e6851be90e99$var$sharedHeaders("DeleteIdentities");
    let body;
    body = JSON.stringify((0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(input));
    return $d927e6851be90e99$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $d927e6851be90e99$export$da0002b0259d6bd2 = async (input, context)=>{
    const headers = $d927e6851be90e99$var$sharedHeaders("DeleteIdentityPool");
    let body;
    body = JSON.stringify((0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(input));
    return $d927e6851be90e99$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $d927e6851be90e99$export$a7623382f33a4cb = async (input, context)=>{
    const headers = $d927e6851be90e99$var$sharedHeaders("DescribeIdentity");
    let body;
    body = JSON.stringify((0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(input));
    return $d927e6851be90e99$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $d927e6851be90e99$export$5ec6a313056e64c4 = async (input, context)=>{
    const headers = $d927e6851be90e99$var$sharedHeaders("DescribeIdentityPool");
    let body;
    body = JSON.stringify((0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(input));
    return $d927e6851be90e99$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $d927e6851be90e99$export$4044f5fd77bb90b5 = async (input, context)=>{
    const headers = $d927e6851be90e99$var$sharedHeaders("GetCredentialsForIdentity");
    let body;
    body = JSON.stringify((0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(input));
    return $d927e6851be90e99$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $d927e6851be90e99$export$debf8339f48e0aee = async (input, context)=>{
    const headers = $d927e6851be90e99$var$sharedHeaders("GetId");
    let body;
    body = JSON.stringify((0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(input));
    return $d927e6851be90e99$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $d927e6851be90e99$export$ddb7e1515042a738 = async (input, context)=>{
    const headers = $d927e6851be90e99$var$sharedHeaders("GetIdentityPoolRoles");
    let body;
    body = JSON.stringify((0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(input));
    return $d927e6851be90e99$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $d927e6851be90e99$export$4f583fbabea11518 = async (input, context)=>{
    const headers = $d927e6851be90e99$var$sharedHeaders("GetOpenIdToken");
    let body;
    body = JSON.stringify((0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(input));
    return $d927e6851be90e99$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $d927e6851be90e99$export$d8b284d88a3e7a27 = async (input, context)=>{
    const headers = $d927e6851be90e99$var$sharedHeaders("GetOpenIdTokenForDeveloperIdentity");
    let body;
    body = JSON.stringify((0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(input));
    return $d927e6851be90e99$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $d927e6851be90e99$export$2f9e1814fff48320 = async (input, context)=>{
    const headers = $d927e6851be90e99$var$sharedHeaders("GetPrincipalTagAttributeMap");
    let body;
    body = JSON.stringify((0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(input));
    return $d927e6851be90e99$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $d927e6851be90e99$export$356c0374525b9599 = async (input, context)=>{
    const headers = $d927e6851be90e99$var$sharedHeaders("ListIdentities");
    let body;
    body = JSON.stringify((0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(input));
    return $d927e6851be90e99$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $d927e6851be90e99$export$14f32f2f9fd19893 = async (input, context)=>{
    const headers = $d927e6851be90e99$var$sharedHeaders("ListIdentityPools");
    let body;
    body = JSON.stringify((0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(input));
    return $d927e6851be90e99$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $d927e6851be90e99$export$cd89308d1d2e2126 = async (input, context)=>{
    const headers = $d927e6851be90e99$var$sharedHeaders("ListTagsForResource");
    let body;
    body = JSON.stringify((0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(input));
    return $d927e6851be90e99$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $d927e6851be90e99$export$fe5bd93e6e83dbb3 = async (input, context)=>{
    const headers = $d927e6851be90e99$var$sharedHeaders("LookupDeveloperIdentity");
    let body;
    body = JSON.stringify((0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(input));
    return $d927e6851be90e99$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $d927e6851be90e99$export$3371f2b7f6b240e2 = async (input, context)=>{
    const headers = $d927e6851be90e99$var$sharedHeaders("MergeDeveloperIdentities");
    let body;
    body = JSON.stringify((0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(input));
    return $d927e6851be90e99$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $d927e6851be90e99$export$59239d4852f0a7be = async (input, context)=>{
    const headers = $d927e6851be90e99$var$sharedHeaders("SetIdentityPoolRoles");
    let body;
    body = JSON.stringify((0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(input));
    return $d927e6851be90e99$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $d927e6851be90e99$export$609f2c3339b1f0ab = async (input, context)=>{
    const headers = $d927e6851be90e99$var$sharedHeaders("SetPrincipalTagAttributeMap");
    let body;
    body = JSON.stringify((0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(input));
    return $d927e6851be90e99$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $d927e6851be90e99$export$3f3dfadaf322c1d5 = async (input, context)=>{
    const headers = $d927e6851be90e99$var$sharedHeaders("TagResource");
    let body;
    body = JSON.stringify((0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(input));
    return $d927e6851be90e99$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $d927e6851be90e99$export$9a263abceaa46720 = async (input, context)=>{
    const headers = $d927e6851be90e99$var$sharedHeaders("UnlinkDeveloperIdentity");
    let body;
    body = JSON.stringify((0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(input));
    return $d927e6851be90e99$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $d927e6851be90e99$export$1c7afdac12ad7dc5 = async (input, context)=>{
    const headers = $d927e6851be90e99$var$sharedHeaders("UnlinkIdentity");
    let body;
    body = JSON.stringify((0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(input));
    return $d927e6851be90e99$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $d927e6851be90e99$export$b056b897d8c9e1a6 = async (input, context)=>{
    const headers = $d927e6851be90e99$var$sharedHeaders("UntagResource");
    let body;
    body = JSON.stringify((0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(input));
    return $d927e6851be90e99$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $d927e6851be90e99$export$b65c54828b0b87f9 = async (input, context)=>{
    const headers = $d927e6851be90e99$var$sharedHeaders("UpdateIdentityPool");
    let body;
    body = JSON.stringify((0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(input));
    return $d927e6851be90e99$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $d927e6851be90e99$export$a1474b1febcdf86e = async (output, context)=>{
    if (output.statusCode >= 300) return $d927e6851be90e99$var$de_CommandError(output, context);
    const data = await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context);
    let contents = {};
    contents = (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(data);
    const response = {
        $metadata: $d927e6851be90e99$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $d927e6851be90e99$export$a2cb52daeace8ff4 = async (output, context)=>{
    if (output.statusCode >= 300) return $d927e6851be90e99$var$de_CommandError(output, context);
    const data = await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context);
    let contents = {};
    contents = (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(data);
    const response = {
        $metadata: $d927e6851be90e99$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $d927e6851be90e99$export$d250f7f2d9f74093 = async (output, context)=>{
    if (output.statusCode >= 300) return $d927e6851be90e99$var$de_CommandError(output, context);
    await (0, $7667c5ed780ba41a$export$3392bcddb824e5ca)(output.body, context);
    const response = {
        $metadata: $d927e6851be90e99$var$deserializeMetadata(output)
    };
    return response;
};
const $d927e6851be90e99$export$f6838cce4c40214b = async (output, context)=>{
    if (output.statusCode >= 300) return $d927e6851be90e99$var$de_CommandError(output, context);
    const data = await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context);
    let contents = {};
    contents = $d927e6851be90e99$var$de_IdentityDescription(data, context);
    const response = {
        $metadata: $d927e6851be90e99$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $d927e6851be90e99$export$6120c73cd2b70d5f = async (output, context)=>{
    if (output.statusCode >= 300) return $d927e6851be90e99$var$de_CommandError(output, context);
    const data = await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context);
    let contents = {};
    contents = (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(data);
    const response = {
        $metadata: $d927e6851be90e99$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $d927e6851be90e99$export$54863a928c0ff14a = async (output, context)=>{
    if (output.statusCode >= 300) return $d927e6851be90e99$var$de_CommandError(output, context);
    const data = await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context);
    let contents = {};
    contents = $d927e6851be90e99$var$de_GetCredentialsForIdentityResponse(data, context);
    const response = {
        $metadata: $d927e6851be90e99$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $d927e6851be90e99$export$665550e9793d736a = async (output, context)=>{
    if (output.statusCode >= 300) return $d927e6851be90e99$var$de_CommandError(output, context);
    const data = await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context);
    let contents = {};
    contents = (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(data);
    const response = {
        $metadata: $d927e6851be90e99$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $d927e6851be90e99$export$20d87c4ba4d90509 = async (output, context)=>{
    if (output.statusCode >= 300) return $d927e6851be90e99$var$de_CommandError(output, context);
    const data = await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context);
    let contents = {};
    contents = (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(data);
    const response = {
        $metadata: $d927e6851be90e99$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $d927e6851be90e99$export$5a48e0e4dbd2d33 = async (output, context)=>{
    if (output.statusCode >= 300) return $d927e6851be90e99$var$de_CommandError(output, context);
    const data = await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context);
    let contents = {};
    contents = (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(data);
    const response = {
        $metadata: $d927e6851be90e99$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $d927e6851be90e99$export$26fddcad4bbbdba0 = async (output, context)=>{
    if (output.statusCode >= 300) return $d927e6851be90e99$var$de_CommandError(output, context);
    const data = await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context);
    let contents = {};
    contents = (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(data);
    const response = {
        $metadata: $d927e6851be90e99$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $d927e6851be90e99$export$ebd82abe4a34e99a = async (output, context)=>{
    if (output.statusCode >= 300) return $d927e6851be90e99$var$de_CommandError(output, context);
    const data = await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context);
    let contents = {};
    contents = (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(data);
    const response = {
        $metadata: $d927e6851be90e99$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $d927e6851be90e99$export$c3bea9d7a10f8f24 = async (output, context)=>{
    if (output.statusCode >= 300) return $d927e6851be90e99$var$de_CommandError(output, context);
    const data = await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context);
    let contents = {};
    contents = $d927e6851be90e99$var$de_ListIdentitiesResponse(data, context);
    const response = {
        $metadata: $d927e6851be90e99$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $d927e6851be90e99$export$371b8b0831944de5 = async (output, context)=>{
    if (output.statusCode >= 300) return $d927e6851be90e99$var$de_CommandError(output, context);
    const data = await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context);
    let contents = {};
    contents = (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(data);
    const response = {
        $metadata: $d927e6851be90e99$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $d927e6851be90e99$export$16d701d259e88048 = async (output, context)=>{
    if (output.statusCode >= 300) return $d927e6851be90e99$var$de_CommandError(output, context);
    const data = await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context);
    let contents = {};
    contents = (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(data);
    const response = {
        $metadata: $d927e6851be90e99$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $d927e6851be90e99$export$ec80641a3c63ee86 = async (output, context)=>{
    if (output.statusCode >= 300) return $d927e6851be90e99$var$de_CommandError(output, context);
    const data = await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context);
    let contents = {};
    contents = (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(data);
    const response = {
        $metadata: $d927e6851be90e99$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $d927e6851be90e99$export$2cff5e84075bf09b = async (output, context)=>{
    if (output.statusCode >= 300) return $d927e6851be90e99$var$de_CommandError(output, context);
    const data = await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context);
    let contents = {};
    contents = (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(data);
    const response = {
        $metadata: $d927e6851be90e99$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $d927e6851be90e99$export$fabda25dfe76a76c = async (output, context)=>{
    if (output.statusCode >= 300) return $d927e6851be90e99$var$de_CommandError(output, context);
    await (0, $7667c5ed780ba41a$export$3392bcddb824e5ca)(output.body, context);
    const response = {
        $metadata: $d927e6851be90e99$var$deserializeMetadata(output)
    };
    return response;
};
const $d927e6851be90e99$export$1cff07b411cf315e = async (output, context)=>{
    if (output.statusCode >= 300) return $d927e6851be90e99$var$de_CommandError(output, context);
    const data = await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context);
    let contents = {};
    contents = (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(data);
    const response = {
        $metadata: $d927e6851be90e99$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $d927e6851be90e99$export$dc0f1552868d13af = async (output, context)=>{
    if (output.statusCode >= 300) return $d927e6851be90e99$var$de_CommandError(output, context);
    const data = await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context);
    let contents = {};
    contents = (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(data);
    const response = {
        $metadata: $d927e6851be90e99$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $d927e6851be90e99$export$aa5e529fe5077ef0 = async (output, context)=>{
    if (output.statusCode >= 300) return $d927e6851be90e99$var$de_CommandError(output, context);
    await (0, $7667c5ed780ba41a$export$3392bcddb824e5ca)(output.body, context);
    const response = {
        $metadata: $d927e6851be90e99$var$deserializeMetadata(output)
    };
    return response;
};
const $d927e6851be90e99$export$d36f3a78deabc873 = async (output, context)=>{
    if (output.statusCode >= 300) return $d927e6851be90e99$var$de_CommandError(output, context);
    await (0, $7667c5ed780ba41a$export$3392bcddb824e5ca)(output.body, context);
    const response = {
        $metadata: $d927e6851be90e99$var$deserializeMetadata(output)
    };
    return response;
};
const $d927e6851be90e99$export$9bdfbc7f21c1e48f = async (output, context)=>{
    if (output.statusCode >= 300) return $d927e6851be90e99$var$de_CommandError(output, context);
    const data = await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context);
    let contents = {};
    contents = (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(data);
    const response = {
        $metadata: $d927e6851be90e99$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $d927e6851be90e99$export$4e06d90c5f39210d = async (output, context)=>{
    if (output.statusCode >= 300) return $d927e6851be90e99$var$de_CommandError(output, context);
    const data = await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context);
    let contents = {};
    contents = (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(data);
    const response = {
        $metadata: $d927e6851be90e99$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $d927e6851be90e99$var$de_CommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await (0, $496d3a9f084d8cd2$export$cb111c4739f3951f)(output.body, context)
    };
    const errorCode = (0, $496d3a9f084d8cd2$export$6e21dac881a79e70)(output, parsedOutput.body);
    switch(errorCode){
        case "InternalErrorException":
        case "com.amazonaws.cognitoidentity#InternalErrorException":
            throw await $d927e6851be90e99$var$de_InternalErrorExceptionRes(parsedOutput, context);
        case "InvalidParameterException":
        case "com.amazonaws.cognitoidentity#InvalidParameterException":
            throw await $d927e6851be90e99$var$de_InvalidParameterExceptionRes(parsedOutput, context);
        case "LimitExceededException":
        case "com.amazonaws.cognitoidentity#LimitExceededException":
            throw await $d927e6851be90e99$var$de_LimitExceededExceptionRes(parsedOutput, context);
        case "NotAuthorizedException":
        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
            throw await $d927e6851be90e99$var$de_NotAuthorizedExceptionRes(parsedOutput, context);
        case "ResourceConflictException":
        case "com.amazonaws.cognitoidentity#ResourceConflictException":
            throw await $d927e6851be90e99$var$de_ResourceConflictExceptionRes(parsedOutput, context);
        case "TooManyRequestsException":
        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
            throw await $d927e6851be90e99$var$de_TooManyRequestsExceptionRes(parsedOutput, context);
        case "ResourceNotFoundException":
        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
            throw await $d927e6851be90e99$var$de_ResourceNotFoundExceptionRes(parsedOutput, context);
        case "ExternalServiceException":
        case "com.amazonaws.cognitoidentity#ExternalServiceException":
            throw await $d927e6851be90e99$var$de_ExternalServiceExceptionRes(parsedOutput, context);
        case "InvalidIdentityPoolConfigurationException":
        case "com.amazonaws.cognitoidentity#InvalidIdentityPoolConfigurationException":
            throw await $d927e6851be90e99$var$de_InvalidIdentityPoolConfigurationExceptionRes(parsedOutput, context);
        case "DeveloperUserAlreadyRegisteredException":
        case "com.amazonaws.cognitoidentity#DeveloperUserAlreadyRegisteredException":
            throw await $d927e6851be90e99$var$de_DeveloperUserAlreadyRegisteredExceptionRes(parsedOutput, context);
        case "ConcurrentModificationException":
        case "com.amazonaws.cognitoidentity#ConcurrentModificationException":
            throw await $d927e6851be90e99$var$de_ConcurrentModificationExceptionRes(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            return $d927e6851be90e99$var$throwDefaultError({
                output: output,
                parsedBody: parsedBody,
                errorCode: errorCode
            });
    }
};
const $d927e6851be90e99$var$de_ConcurrentModificationExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(body);
    const exception = new (0, $9603a5372f221de0$export$21f15e80c2bbca09)({
        $metadata: $d927e6851be90e99$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, body);
};
const $d927e6851be90e99$var$de_DeveloperUserAlreadyRegisteredExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(body);
    const exception = new (0, $9603a5372f221de0$export$f9e8c5d2069aeea4)({
        $metadata: $d927e6851be90e99$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, body);
};
const $d927e6851be90e99$var$de_ExternalServiceExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(body);
    const exception = new (0, $9603a5372f221de0$export$cb77a58cb7dbb17)({
        $metadata: $d927e6851be90e99$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, body);
};
const $d927e6851be90e99$var$de_InternalErrorExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(body);
    const exception = new (0, $9603a5372f221de0$export$8b0f706f4df56c63)({
        $metadata: $d927e6851be90e99$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, body);
};
const $d927e6851be90e99$var$de_InvalidIdentityPoolConfigurationExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(body);
    const exception = new (0, $9603a5372f221de0$export$90d12448d3766cda)({
        $metadata: $d927e6851be90e99$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, body);
};
const $d927e6851be90e99$var$de_InvalidParameterExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(body);
    const exception = new (0, $9603a5372f221de0$export$fa781b52e13bf866)({
        $metadata: $d927e6851be90e99$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, body);
};
const $d927e6851be90e99$var$de_LimitExceededExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(body);
    const exception = new (0, $9603a5372f221de0$export$cd419aa7f32ec382)({
        $metadata: $d927e6851be90e99$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, body);
};
const $d927e6851be90e99$var$de_NotAuthorizedExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(body);
    const exception = new (0, $9603a5372f221de0$export$82cff5e5a0a874dd)({
        $metadata: $d927e6851be90e99$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, body);
};
const $d927e6851be90e99$var$de_ResourceConflictExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(body);
    const exception = new (0, $9603a5372f221de0$export$cbdaf31887dd0603)({
        $metadata: $d927e6851be90e99$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, body);
};
const $d927e6851be90e99$var$de_ResourceNotFoundExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(body);
    const exception = new (0, $9603a5372f221de0$export$ecba565262f8bb2)({
        $metadata: $d927e6851be90e99$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, body);
};
const $d927e6851be90e99$var$de_TooManyRequestsExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(body);
    const exception = new (0, $9603a5372f221de0$export$4a67805ad445f61)({
        $metadata: $d927e6851be90e99$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, body);
};
const $d927e6851be90e99$var$de_Credentials = (output, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(output, {
        AccessKeyId: (0, $25d854afa944ccce$export$7ed80f53fe336639),
        Expiration: (_)=>(0, $25d854afa944ccce$export$8413a63dbe548a49)((0, $d8696255fcc0b769$export$685da212e4e79e10)((0, $25d854afa944ccce$export$f3945e48fdb5f9a)(_))),
        SecretKey: (0, $25d854afa944ccce$export$7ed80f53fe336639),
        SessionToken: (0, $25d854afa944ccce$export$7ed80f53fe336639)
    });
};
const $d927e6851be90e99$var$de_GetCredentialsForIdentityResponse = (output, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(output, {
        Credentials: (_)=>$d927e6851be90e99$var$de_Credentials(_, context),
        IdentityId: (0, $25d854afa944ccce$export$7ed80f53fe336639)
    });
};
const $d927e6851be90e99$var$de_IdentitiesList = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $d927e6851be90e99$var$de_IdentityDescription(entry, context);
    });
    return retVal;
};
const $d927e6851be90e99$var$de_IdentityDescription = (output, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(output, {
        CreationDate: (_)=>(0, $25d854afa944ccce$export$8413a63dbe548a49)((0, $d8696255fcc0b769$export$685da212e4e79e10)((0, $25d854afa944ccce$export$f3945e48fdb5f9a)(_))),
        IdentityId: (0, $25d854afa944ccce$export$7ed80f53fe336639),
        LastModifiedDate: (_)=>(0, $25d854afa944ccce$export$8413a63dbe548a49)((0, $d8696255fcc0b769$export$685da212e4e79e10)((0, $25d854afa944ccce$export$f3945e48fdb5f9a)(_))),
        Logins: (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)
    });
};
const $d927e6851be90e99$var$de_ListIdentitiesResponse = (output, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(output, {
        Identities: (_)=>$d927e6851be90e99$var$de_IdentitiesList(_, context),
        IdentityPoolId: (0, $25d854afa944ccce$export$7ed80f53fe336639),
        NextToken: (0, $25d854afa944ccce$export$7ed80f53fe336639)
    });
};
const $d927e6851be90e99$var$deserializeMetadata = (output)=>({
        httpStatusCode: output.statusCode,
        requestId: output.headers["x-amzn-requestid"] ?? output.headers["x-amzn-request-id"] ?? output.headers["x-amz-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    });
const $d927e6851be90e99$var$collectBodyString = (streamBody, context)=>(0, $7667c5ed780ba41a$export$3392bcddb824e5ca)(streamBody, context).then((body)=>context.utf8Encoder(body));
const $d927e6851be90e99$var$throwDefaultError = (0, $1a84bff7daff0761$export$62ac8acba1748a85)((0, $ef927458c91b40a7$export$b83d40bae15eaefa));
const $d927e6851be90e99$var$buildHttpRpcRequest = async (context, headers, path, resolvedHostname, body)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const contents = {
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "POST",
        path: basePath.endsWith("/") ? basePath.slice(0, -1) + path : basePath + path,
        headers: headers
    };
    if (resolvedHostname !== undefined) contents.hostname = resolvedHostname;
    if (body !== undefined) contents.body = body;
    return new (0, $36c92c5bbc6e0688$export$7587955500404ec3)(contents);
};
function $d927e6851be90e99$var$sharedHeaders(operation) {
    return {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": `AWSCognitoIdentityService.${operation}`
    };
}


class $3224f2601b4ee115$export$41ceb4ced4f97a44 extends (0, $ec660c029325fe15$export$cc7e12c76513e857).classBuilder().ep((0, $d1223e7c10daafaf$export$9c07ced2019f0ae0)).m(function(Command, cs, config, o) {
    return [
        (0, $d08040bde29682c1$export$53fdc69654553fd4)(config, this.serialize, this.deserialize),
        (0, $335ede9082851668$export$946c80457b765eab)(config, Command.getEndpointParameterInstructions())
    ];
}).s("AWSCognitoIdentityService", "GetId", {}).n("CognitoIdentityClient", "GetIdCommand").f((0, $9603a5372f221de0$export$9324de7567a14b0d), void 0).ser((0, $d927e6851be90e99$export$debf8339f48e0aee)).de((0, $d927e6851be90e99$export$665550e9793d736a)).build() {
}







class $d7650b27571c5709$export$26a6f172ed1f595a extends (0, $ec660c029325fe15$export$cc7e12c76513e857).classBuilder().ep((0, $d1223e7c10daafaf$export$9c07ced2019f0ae0)).m(function(Command, cs, config, o) {
    return [
        (0, $d08040bde29682c1$export$53fdc69654553fd4)(config, this.serialize, this.deserialize),
        (0, $335ede9082851668$export$946c80457b765eab)(config, Command.getEndpointParameterInstructions())
    ];
}).s("AWSCognitoIdentityService", "GetOpenIdToken", {}).n("CognitoIdentityClient", "GetOpenIdTokenCommand").f((0, $9603a5372f221de0$export$2b3066f9a138cb65), (0, $9603a5372f221de0$export$715d19cd9534db0)).ser((0, $d927e6851be90e99$export$4f583fbabea11518)).de((0, $d927e6851be90e99$export$5a48e0e4dbd2d33)).build() {
}





const $71e5440285293b82$export$70b6341cd51750a8 = (options)=>{
    return {
        ...options,
        useDualstackEndpoint: options.useDualstackEndpoint ?? false,
        useFipsEndpoint: options.useFipsEndpoint ?? false,
        useGlobalEndpoint: options.useGlobalEndpoint ?? false,
        defaultSigningName: "sts"
    };
};
const $71e5440285293b82$export$9c07ced2019f0ae0 = {
    UseGlobalEndpoint: {
        type: "builtInParams",
        name: "useGlobalEndpoint"
    },
    UseFIPS: {
        type: "builtInParams",
        name: "useFipsEndpoint"
    },
    Endpoint: {
        type: "builtInParams",
        name: "endpoint"
    },
    Region: {
        type: "builtInParams",
        name: "region"
    },
    UseDualStack: {
        type: "builtInParams",
        name: "useDualstackEndpoint"
    }
};




class $a2ec4191a788c017$export$a18f5bef84fc19ec extends (0, $11a0343ffd48eaff$export$29647f3b4097d3c0) {
    constructor(options){
        super(options);
        Object.setPrototypeOf(this, $a2ec4191a788c017$export$a18f5bef84fc19ec.prototype);
    }
}


class $7e701853b65411f4$export$fa1220c5081036a1 extends (0, $a2ec4191a788c017$export$a18f5bef84fc19ec) {
    name = "ExpiredTokenException";
    $fault = "client";
    constructor(opts){
        super({
            name: "ExpiredTokenException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $7e701853b65411f4$export$fa1220c5081036a1.prototype);
    }
}
class $7e701853b65411f4$export$22b3b5837037e750 extends (0, $a2ec4191a788c017$export$a18f5bef84fc19ec) {
    name = "MalformedPolicyDocumentException";
    $fault = "client";
    constructor(opts){
        super({
            name: "MalformedPolicyDocumentException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $7e701853b65411f4$export$22b3b5837037e750.prototype);
    }
}
class $7e701853b65411f4$export$bc7ad180e2a70628 extends (0, $a2ec4191a788c017$export$a18f5bef84fc19ec) {
    name = "PackedPolicyTooLargeException";
    $fault = "client";
    constructor(opts){
        super({
            name: "PackedPolicyTooLargeException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $7e701853b65411f4$export$bc7ad180e2a70628.prototype);
    }
}
class $7e701853b65411f4$export$bdd8424b8237388d extends (0, $a2ec4191a788c017$export$a18f5bef84fc19ec) {
    name = "RegionDisabledException";
    $fault = "client";
    constructor(opts){
        super({
            name: "RegionDisabledException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $7e701853b65411f4$export$bdd8424b8237388d.prototype);
    }
}
class $7e701853b65411f4$export$929ade002d483fe9 extends (0, $a2ec4191a788c017$export$a18f5bef84fc19ec) {
    name = "IDPRejectedClaimException";
    $fault = "client";
    constructor(opts){
        super({
            name: "IDPRejectedClaimException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $7e701853b65411f4$export$929ade002d483fe9.prototype);
    }
}
class $7e701853b65411f4$export$6703f62d64df85c extends (0, $a2ec4191a788c017$export$a18f5bef84fc19ec) {
    name = "InvalidIdentityTokenException";
    $fault = "client";
    constructor(opts){
        super({
            name: "InvalidIdentityTokenException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $7e701853b65411f4$export$6703f62d64df85c.prototype);
    }
}
class $7e701853b65411f4$export$9b2a7b36a0ed491a extends (0, $a2ec4191a788c017$export$a18f5bef84fc19ec) {
    name = "IDPCommunicationErrorException";
    $fault = "client";
    constructor(opts){
        super({
            name: "IDPCommunicationErrorException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $7e701853b65411f4$export$9b2a7b36a0ed491a.prototype);
    }
}
class $7e701853b65411f4$export$260cc625473883b6 extends (0, $a2ec4191a788c017$export$a18f5bef84fc19ec) {
    name = "InvalidAuthorizationMessageException";
    $fault = "client";
    constructor(opts){
        super({
            name: "InvalidAuthorizationMessageException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $7e701853b65411f4$export$260cc625473883b6.prototype);
    }
}
const $7e701853b65411f4$export$e77297d79eddfc1d = (obj)=>({
        ...obj,
        ...obj.SecretAccessKey && {
            SecretAccessKey: (0, $396b6e4de1f32a66$export$17127055dc9ac067)
        }
    });
const $7e701853b65411f4$export$29d032653816e8ea = (obj)=>({
        ...obj,
        ...obj.Credentials && {
            Credentials: $7e701853b65411f4$export$e77297d79eddfc1d(obj.Credentials)
        }
    });
const $7e701853b65411f4$export$1bc59476227f1d5 = (obj)=>({
        ...obj,
        ...obj.SAMLAssertion && {
            SAMLAssertion: (0, $396b6e4de1f32a66$export$17127055dc9ac067)
        }
    });
const $7e701853b65411f4$export$1e0fa694f3388ecd = (obj)=>({
        ...obj,
        ...obj.Credentials && {
            Credentials: $7e701853b65411f4$export$e77297d79eddfc1d(obj.Credentials)
        }
    });
const $7e701853b65411f4$export$ec337be0d646cf4 = (obj)=>({
        ...obj,
        ...obj.WebIdentityToken && {
            WebIdentityToken: (0, $396b6e4de1f32a66$export$17127055dc9ac067)
        }
    });
const $7e701853b65411f4$export$d2c905d36e51efa2 = (obj)=>({
        ...obj,
        ...obj.Credentials && {
            Credentials: $7e701853b65411f4$export$e77297d79eddfc1d(obj.Credentials)
        }
    });
const $7e701853b65411f4$export$b676e61f910c71d3 = (obj)=>({
        ...obj,
        ...obj.Credentials && {
            Credentials: $7e701853b65411f4$export$e77297d79eddfc1d(obj.Credentials)
        }
    });
const $7e701853b65411f4$export$3b2b2f51bbced4f6 = (obj)=>({
        ...obj,
        ...obj.Credentials && {
            Credentials: $7e701853b65411f4$export$e77297d79eddfc1d(obj.Credentials)
        }
    });
const $7e701853b65411f4$export$becb369cfe83184 = (obj)=>({
        ...obj,
        ...obj.Credentials && {
            Credentials: $7e701853b65411f4$export$e77297d79eddfc1d(obj.Credentials)
        }
    });



var $c0b54c0e081fbf21$exports = {};
'use strict';
var $74ca744e6015d210$exports = {};

$parcel$export($74ca744e6015d210$exports, "validate", () => $74ca744e6015d210$export$a22775fa5e2eebd9, (v) => $74ca744e6015d210$export$a22775fa5e2eebd9 = v);
//const tagsPattern = new RegExp("<\\/?([\\w:\\-_\.]+)\\s*\/?>","g");
var $74ca744e6015d210$export$a22775fa5e2eebd9;
'use strict';
var $88d735a8ac10eecc$export$a5edf3f35b6dd392;
var $88d735a8ac10eecc$export$83b788b1a3698c03;
/**
 * Copy all the properties of a into b.
 * @param {*} target
 * @param {*} a
 */ var $88d735a8ac10eecc$export$4950aa0f605343fb;
/* exports.merge =function (b,a){
  return Object.assign(b,a);
} */ var $88d735a8ac10eecc$export$bf7199a9ebcb84a9;
// const fakeCall = function(a) {return a;};
// const fakeCallNoReturn = function() {};
var $88d735a8ac10eecc$export$998d7ff9801e90bb;
var $88d735a8ac10eecc$export$aaa9734c55cb7a19;
var $88d735a8ac10eecc$export$e8f2644f7085b4b1;
'use strict';
const $88d735a8ac10eecc$var$nameStartChar = ':A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
const $88d735a8ac10eecc$var$nameChar = $88d735a8ac10eecc$var$nameStartChar + '\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
const $88d735a8ac10eecc$var$nameRegexp = '[' + $88d735a8ac10eecc$var$nameStartChar + '][' + $88d735a8ac10eecc$var$nameChar + ']*';
const $88d735a8ac10eecc$var$regexName = new RegExp('^' + $88d735a8ac10eecc$var$nameRegexp + '$');
const $88d735a8ac10eecc$var$getAllMatches = function(string, regex) {
    const matches = [];
    let match = regex.exec(string);
    while(match){
        const allmatches = [];
        allmatches.startIndex = regex.lastIndex - match[0].length;
        const len = match.length;
        for(let index = 0; index < len; index++)allmatches.push(match[index]);
        matches.push(allmatches);
        match = regex.exec(string);
    }
    return matches;
};
const $88d735a8ac10eecc$var$isName = function(string) {
    const match = $88d735a8ac10eecc$var$regexName.exec(string);
    return !(match === null || typeof match === 'undefined');
};
$88d735a8ac10eecc$export$a5edf3f35b6dd392 = function(v) {
    return typeof v !== 'undefined';
};
$88d735a8ac10eecc$export$83b788b1a3698c03 = function(obj) {
    return Object.keys(obj).length === 0;
};
$88d735a8ac10eecc$export$4950aa0f605343fb = function(target, a, arrayMode) {
    if (a) {
        const keys = Object.keys(a); // will return an array of own properties
        const len = keys.length; //don't make it inline
        for(let i = 0; i < len; i++)if (arrayMode === 'strict') target[keys[i]] = [
            a[keys[i]]
        ];
        else target[keys[i]] = a[keys[i]];
    }
};
$88d735a8ac10eecc$export$bf7199a9ebcb84a9 = function(v) {
    if ($88d735a8ac10eecc$export$a5edf3f35b6dd392(v)) return v;
    else return '';
};
$88d735a8ac10eecc$export$998d7ff9801e90bb = $88d735a8ac10eecc$var$isName;
$88d735a8ac10eecc$export$aaa9734c55cb7a19 = $88d735a8ac10eecc$var$getAllMatches;
$88d735a8ac10eecc$export$e8f2644f7085b4b1 = $88d735a8ac10eecc$var$nameRegexp;


const $74ca744e6015d210$var$defaultOptions = {
    allowBooleanAttributes: false,
    unpairedTags: []
};
$74ca744e6015d210$export$a22775fa5e2eebd9 = function(xmlData, options) {
    options = Object.assign({}, $74ca744e6015d210$var$defaultOptions, options);
    //xmlData = xmlData.replace(/(\r\n|\n|\r)/gm,"");//make it single line
    //xmlData = xmlData.replace(/(^\s*<\?xml.*?\?>)/g,"");//Remove XML starting tag
    //xmlData = xmlData.replace(/(<!DOCTYPE[\s\w\"\.\/\-\:]+(\[.*\])*\s*>)/g,"");//Remove DOCTYPE
    const tags = [];
    let tagFound = false;
    //indicates that the root tag has been closed (aka. depth 0 has been reached)
    let reachedRoot = false;
    if (xmlData[0] === '\ufeff') // check for byte order mark (BOM)
    xmlData = xmlData.substr(1);
    for(let i = 0; i < xmlData.length; i++){
        if (xmlData[i] === '<' && xmlData[i + 1] === '?') {
            i += 2;
            i = $74ca744e6015d210$var$readPI(xmlData, i);
            if (i.err) return i;
        } else if (xmlData[i] === '<') {
            //starting of tag
            //read until you reach to '>' avoiding any '>' in attribute value
            let tagStartPos = i;
            i++;
            if (xmlData[i] === '!') {
                i = $74ca744e6015d210$var$readCommentAndCDATA(xmlData, i);
                continue;
            } else {
                let closingTag = false;
                if (xmlData[i] === '/') {
                    //closing tag
                    closingTag = true;
                    i++;
                }
                //read tagname
                let tagName = '';
                for(; i < xmlData.length && xmlData[i] !== '>' && xmlData[i] !== ' ' && xmlData[i] !== '\t' && xmlData[i] !== '\n' && xmlData[i] !== '\r'; i++)tagName += xmlData[i];
                tagName = tagName.trim();
                //console.log(tagName);
                if (tagName[tagName.length - 1] === '/') {
                    //self closing tag without attributes
                    tagName = tagName.substring(0, tagName.length - 1);
                    //continue;
                    i--;
                }
                if (!$74ca744e6015d210$var$validateTagName(tagName)) {
                    let msg;
                    if (tagName.trim().length === 0) msg = "Invalid space after '<'.";
                    else msg = "Tag '" + tagName + "' is an invalid name.";
                    return $74ca744e6015d210$var$getErrorObject('InvalidTag', msg, $74ca744e6015d210$var$getLineNumberForPosition(xmlData, i));
                }
                const result = $74ca744e6015d210$var$readAttributeStr(xmlData, i);
                if (result === false) return $74ca744e6015d210$var$getErrorObject('InvalidAttr', "Attributes for '" + tagName + "' have open quote.", $74ca744e6015d210$var$getLineNumberForPosition(xmlData, i));
                let attrStr = result.value;
                i = result.index;
                if (attrStr[attrStr.length - 1] === '/') {
                    //self closing tag
                    const attrStrStart = i - attrStr.length;
                    attrStr = attrStr.substring(0, attrStr.length - 1);
                    const isValid = $74ca744e6015d210$var$validateAttributeString(attrStr, options);
                    if (isValid === true) tagFound = true;
                    else //the result from the nested function returns the position of the error within the attribute
                    //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                    //this gives us the absolute index in the entire xml, which we can use to find the line at last
                    return $74ca744e6015d210$var$getErrorObject(isValid.err.code, isValid.err.msg, $74ca744e6015d210$var$getLineNumberForPosition(xmlData, attrStrStart + isValid.err.line));
                } else if (closingTag) {
                    if (!result.tagClosed) return $74ca744e6015d210$var$getErrorObject('InvalidTag', "Closing tag '" + tagName + "' doesn't have proper closing.", $74ca744e6015d210$var$getLineNumberForPosition(xmlData, i));
                    else if (attrStr.trim().length > 0) return $74ca744e6015d210$var$getErrorObject('InvalidTag', "Closing tag '" + tagName + "' can't have attributes or invalid starting.", $74ca744e6015d210$var$getLineNumberForPosition(xmlData, tagStartPos));
                    else if (tags.length === 0) return $74ca744e6015d210$var$getErrorObject('InvalidTag', "Closing tag '" + tagName + "' has not been opened.", $74ca744e6015d210$var$getLineNumberForPosition(xmlData, tagStartPos));
                    else {
                        const otg = tags.pop();
                        if (tagName !== otg.tagName) {
                            let openPos = $74ca744e6015d210$var$getLineNumberForPosition(xmlData, otg.tagStartPos);
                            return $74ca744e6015d210$var$getErrorObject('InvalidTag', "Expected closing tag '" + otg.tagName + "' (opened in line " + openPos.line + ", col " + openPos.col + ") instead of closing tag '" + tagName + "'.", $74ca744e6015d210$var$getLineNumberForPosition(xmlData, tagStartPos));
                        }
                        //when there are no more tags, we reached the root level.
                        if (tags.length == 0) reachedRoot = true;
                    }
                } else {
                    const isValid = $74ca744e6015d210$var$validateAttributeString(attrStr, options);
                    if (isValid !== true) //the result from the nested function returns the position of the error within the attribute
                    //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                    //this gives us the absolute index in the entire xml, which we can use to find the line at last
                    return $74ca744e6015d210$var$getErrorObject(isValid.err.code, isValid.err.msg, $74ca744e6015d210$var$getLineNumberForPosition(xmlData, i - attrStr.length + isValid.err.line));
                    //if the root level has been reached before ...
                    if (reachedRoot === true) return $74ca744e6015d210$var$getErrorObject('InvalidXml', 'Multiple possible root nodes found.', $74ca744e6015d210$var$getLineNumberForPosition(xmlData, i));
                    else if (options.unpairedTags.indexOf(tagName) !== -1) ;
                    else tags.push({
                        tagName: tagName,
                        tagStartPos: tagStartPos
                    });
                    tagFound = true;
                }
                //skip tag text value
                //It may include comments and CDATA value
                for(i++; i < xmlData.length; i++){
                    if (xmlData[i] === '<') {
                        if (xmlData[i + 1] === '!') {
                            //comment or CADATA
                            i++;
                            i = $74ca744e6015d210$var$readCommentAndCDATA(xmlData, i);
                            continue;
                        } else if (xmlData[i + 1] === '?') {
                            i = $74ca744e6015d210$var$readPI(xmlData, ++i);
                            if (i.err) return i;
                        } else break;
                    } else if (xmlData[i] === '&') {
                        const afterAmp = $74ca744e6015d210$var$validateAmpersand(xmlData, i);
                        if (afterAmp == -1) return $74ca744e6015d210$var$getErrorObject('InvalidChar', "char '&' is not expected.", $74ca744e6015d210$var$getLineNumberForPosition(xmlData, i));
                        i = afterAmp;
                    } else {
                        if (reachedRoot === true && !$74ca744e6015d210$var$isWhiteSpace(xmlData[i])) return $74ca744e6015d210$var$getErrorObject('InvalidXml', "Extra text at the end", $74ca744e6015d210$var$getLineNumberForPosition(xmlData, i));
                    }
                } //end of reading tag text value
                if (xmlData[i] === '<') i--;
            }
        } else {
            if ($74ca744e6015d210$var$isWhiteSpace(xmlData[i])) continue;
            return $74ca744e6015d210$var$getErrorObject('InvalidChar', "char '" + xmlData[i] + "' is not expected.", $74ca744e6015d210$var$getLineNumberForPosition(xmlData, i));
        }
    }
    if (!tagFound) return $74ca744e6015d210$var$getErrorObject('InvalidXml', 'Start tag expected.', 1);
    else if (tags.length == 1) return $74ca744e6015d210$var$getErrorObject('InvalidTag', "Unclosed tag '" + tags[0].tagName + "'.", $74ca744e6015d210$var$getLineNumberForPosition(xmlData, tags[0].tagStartPos));
    else if (tags.length > 0) return $74ca744e6015d210$var$getErrorObject('InvalidXml', "Invalid '" + JSON.stringify(tags.map((t)=>t.tagName), null, 4).replace(/\r?\n/g, '') + "' found.", {
        line: 1,
        col: 1
    });
    return true;
};
function $74ca744e6015d210$var$isWhiteSpace(char) {
    return char === ' ' || char === '\t' || char === '\n' || char === '\r';
}
/**
 * Read Processing insstructions and skip
 * @param {*} xmlData
 * @param {*} i
 */ function $74ca744e6015d210$var$readPI(xmlData, i) {
    const start = i;
    for(; i < xmlData.length; i++)if (xmlData[i] == '?' || xmlData[i] == ' ') {
        //tagname
        const tagname = xmlData.substr(start, i - start);
        if (i > 5 && tagname === 'xml') return $74ca744e6015d210$var$getErrorObject('InvalidXml', 'XML declaration allowed only at the start of the document.', $74ca744e6015d210$var$getLineNumberForPosition(xmlData, i));
        else if (xmlData[i] == '?' && xmlData[i + 1] == '>') {
            //check if valid attribut string
            i++;
            break;
        } else continue;
    }
    return i;
}
function $74ca744e6015d210$var$readCommentAndCDATA(xmlData, i) {
    if (xmlData.length > i + 5 && xmlData[i + 1] === '-' && xmlData[i + 2] === '-') {
        //comment
        for(i += 3; i < xmlData.length; i++)if (xmlData[i] === '-' && xmlData[i + 1] === '-' && xmlData[i + 2] === '>') {
            i += 2;
            break;
        }
    } else if (xmlData.length > i + 8 && xmlData[i + 1] === 'D' && xmlData[i + 2] === 'O' && xmlData[i + 3] === 'C' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'Y' && xmlData[i + 6] === 'P' && xmlData[i + 7] === 'E') {
        let angleBracketsCount = 1;
        for(i += 8; i < xmlData.length; i++){
            if (xmlData[i] === '<') angleBracketsCount++;
            else if (xmlData[i] === '>') {
                angleBracketsCount--;
                if (angleBracketsCount === 0) break;
            }
        }
    } else if (xmlData.length > i + 9 && xmlData[i + 1] === '[' && xmlData[i + 2] === 'C' && xmlData[i + 3] === 'D' && xmlData[i + 4] === 'A' && xmlData[i + 5] === 'T' && xmlData[i + 6] === 'A' && xmlData[i + 7] === '[') {
        for(i += 8; i < xmlData.length; i++)if (xmlData[i] === ']' && xmlData[i + 1] === ']' && xmlData[i + 2] === '>') {
            i += 2;
            break;
        }
    }
    return i;
}
const $74ca744e6015d210$var$doubleQuote = '"';
const $74ca744e6015d210$var$singleQuote = "'";
/**
 * Keep reading xmlData until '<' is found outside the attribute value.
 * @param {string} xmlData
 * @param {number} i
 */ function $74ca744e6015d210$var$readAttributeStr(xmlData, i) {
    let attrStr = '';
    let startChar = '';
    let tagClosed = false;
    for(; i < xmlData.length; i++){
        if (xmlData[i] === $74ca744e6015d210$var$doubleQuote || xmlData[i] === $74ca744e6015d210$var$singleQuote) {
            if (startChar === '') startChar = xmlData[i];
            else if (startChar !== xmlData[i]) ;
            else startChar = '';
        } else if (xmlData[i] === '>') {
            if (startChar === '') {
                tagClosed = true;
                break;
            }
        }
        attrStr += xmlData[i];
    }
    if (startChar !== '') return false;
    return {
        value: attrStr,
        index: i,
        tagClosed: tagClosed
    };
}
/**
 * Select all the attributes whether valid or invalid.
 */ const $74ca744e6015d210$var$validAttrStrRegxp = new RegExp('(\\s*)([^\\s=]+)(\\s*=)?(\\s*([\'"])(([\\s\\S])*?)\\5)?', 'g');
//attr, ="sd", a="amit's", a="sd"b="saf", ab  cd=""
function $74ca744e6015d210$var$validateAttributeString(attrStr, options) {
    //console.log("start:"+attrStr+":end");
    //if(attrStr.trim().length === 0) return true; //empty string
    const matches = $88d735a8ac10eecc$export$aaa9734c55cb7a19(attrStr, $74ca744e6015d210$var$validAttrStrRegxp);
    const attrNames = {};
    for(let i = 0; i < matches.length; i++){
        if (matches[i][1].length === 0) //nospace before attribute name: a="sd"b="saf"
        return $74ca744e6015d210$var$getErrorObject('InvalidAttr', "Attribute '" + matches[i][2] + "' has no space in starting.", $74ca744e6015d210$var$getPositionFromMatch(matches[i]));
        else if (matches[i][3] !== undefined && matches[i][4] === undefined) return $74ca744e6015d210$var$getErrorObject('InvalidAttr', "Attribute '" + matches[i][2] + "' is without value.", $74ca744e6015d210$var$getPositionFromMatch(matches[i]));
        else if (matches[i][3] === undefined && !options.allowBooleanAttributes) //independent attribute: ab
        return $74ca744e6015d210$var$getErrorObject('InvalidAttr', "boolean attribute '" + matches[i][2] + "' is not allowed.", $74ca744e6015d210$var$getPositionFromMatch(matches[i]));
        /* else if(matches[i][6] === undefined){//attribute without value: ab=
                    return { err: { code:"InvalidAttr",msg:"attribute " + matches[i][2] + " has no value assigned."}};
                } */ const attrName = matches[i][2];
        if (!$74ca744e6015d210$var$validateAttrName(attrName)) return $74ca744e6015d210$var$getErrorObject('InvalidAttr', "Attribute '" + attrName + "' is an invalid name.", $74ca744e6015d210$var$getPositionFromMatch(matches[i]));
        if (!attrNames.hasOwnProperty(attrName)) //check for duplicate attribute.
        attrNames[attrName] = 1;
        else return $74ca744e6015d210$var$getErrorObject('InvalidAttr', "Attribute '" + attrName + "' is repeated.", $74ca744e6015d210$var$getPositionFromMatch(matches[i]));
    }
    return true;
}
function $74ca744e6015d210$var$validateNumberAmpersand(xmlData, i) {
    let re = /\d/;
    if (xmlData[i] === 'x') {
        i++;
        re = /[\da-fA-F]/;
    }
    for(; i < xmlData.length; i++){
        if (xmlData[i] === ';') return i;
        if (!xmlData[i].match(re)) break;
    }
    return -1;
}
function $74ca744e6015d210$var$validateAmpersand(xmlData, i) {
    // https://www.w3.org/TR/xml/#dt-charref
    i++;
    if (xmlData[i] === ';') return -1;
    if (xmlData[i] === '#') {
        i++;
        return $74ca744e6015d210$var$validateNumberAmpersand(xmlData, i);
    }
    let count = 0;
    for(; i < xmlData.length; i++, count++){
        if (xmlData[i].match(/\w/) && count < 20) continue;
        if (xmlData[i] === ';') break;
        return -1;
    }
    return i;
}
function $74ca744e6015d210$var$getErrorObject(code, message, lineNumber) {
    return {
        err: {
            code: code,
            msg: message,
            line: lineNumber.line || lineNumber,
            col: lineNumber.col
        }
    };
}
function $74ca744e6015d210$var$validateAttrName(attrName) {
    return $88d735a8ac10eecc$export$998d7ff9801e90bb(attrName);
}
// const startsWithXML = /^xml/i;
function $74ca744e6015d210$var$validateTagName(tagname) {
    return $88d735a8ac10eecc$export$998d7ff9801e90bb(tagname) /* && !tagname.match(startsWithXML) */ ;
}
//this function returns the line number for the character at the given index
function $74ca744e6015d210$var$getLineNumberForPosition(xmlData, index) {
    const lines = xmlData.substring(0, index).split(/\r?\n/);
    return {
        line: lines.length,
        // column number is last line's length + 1, because column numbering starts at 1:
        col: lines[lines.length - 1].length + 1
    };
}
//this function returns the position of the first character of match within attrStr
function $74ca744e6015d210$var$getPositionFromMatch(match) {
    return match.startIndex + match[1].length;
}


var $5a7d16e887191265$exports = {};
var $b70a842dd88640b8$export$ecbd7d678ac4909b;
var $b70a842dd88640b8$export$ba43bf67f3d48107;
const $b70a842dd88640b8$var$defaultOptions = {
    preserveOrder: false,
    attributeNamePrefix: '@_',
    attributesGroupName: false,
    textNodeName: '#text',
    ignoreAttributes: true,
    removeNSPrefix: false,
    allowBooleanAttributes: false,
    //ignoreRootElement : false,
    parseTagValue: true,
    parseAttributeValue: false,
    trimValues: true,
    cdataPropName: false,
    numberParseOptions: {
        hex: true,
        leadingZeros: true,
        eNotation: true
    },
    tagValueProcessor: function(tagName, val) {
        return val;
    },
    attributeValueProcessor: function(attrName, val) {
        return val;
    },
    stopNodes: [],
    alwaysCreateTextNode: false,
    isArray: ()=>false,
    commentPropName: false,
    unpairedTags: [],
    processEntities: true,
    htmlEntities: false,
    ignoreDeclaration: false,
    ignorePiTags: false,
    transformTagName: false,
    transformAttributeName: false,
    updateTag: function(tagName, jPath, attrs) {
        return tagName;
    }
};
const $b70a842dd88640b8$var$buildOptions = function(options) {
    return Object.assign({}, $b70a842dd88640b8$var$defaultOptions, options);
};
$b70a842dd88640b8$export$ecbd7d678ac4909b = $b70a842dd88640b8$var$buildOptions;
$b70a842dd88640b8$export$ba43bf67f3d48107 = $b70a842dd88640b8$var$defaultOptions;


var $5a7d16e887191265$require$buildOptions = $b70a842dd88640b8$export$ecbd7d678ac4909b;
var $6f6bfc1a18f808f6$exports = {};
'use strict';

var $4b6e00c1635b290d$exports = {};
'use strict';
class $4b6e00c1635b290d$var$XmlNode {
    constructor(tagname){
        this.tagname = tagname;
        this.child = []; //nested tags, text, cdata, comments in order
        this[":@"] = {}; //attributes map
    }
    add(key, val) {
        // this.child.push( {name : key, val: val, isCdata: isCdata });
        if (key === "__proto__") key = "#__proto__";
        this.child.push({
            [key]: val
        });
    }
    addChild(node) {
        if (node.tagname === "__proto__") node.tagname = "#__proto__";
        if (node[":@"] && Object.keys(node[":@"]).length > 0) this.child.push({
            [node.tagname]: node.child,
            [":@"]: node[":@"]
        });
        else this.child.push({
            [node.tagname]: node.child
        });
    }
}
$4b6e00c1635b290d$exports = $4b6e00c1635b290d$var$XmlNode;


var $3b08c4ede4783019$exports = {};

//TODO: handle comments
function $3b08c4ede4783019$var$readDocType(xmlData, i) {
    const entities = {};
    if (xmlData[i + 3] === 'O' && xmlData[i + 4] === 'C' && xmlData[i + 5] === 'T' && xmlData[i + 6] === 'Y' && xmlData[i + 7] === 'P' && xmlData[i + 8] === 'E') {
        i = i + 9;
        let angleBracketsCount = 1;
        let hasBody = false, comment = false;
        let exp = "";
        for(; i < xmlData.length; i++){
            if (xmlData[i] === '<' && !comment) {
                if (hasBody && $3b08c4ede4783019$var$isEntity(xmlData, i)) {
                    i += 7;
                    [entityName, val, i] = $3b08c4ede4783019$var$readEntityExp(xmlData, i + 1);
                    if (val.indexOf("&") === -1) entities[$3b08c4ede4783019$var$validateEntityName(entityName)] = {
                        regx: RegExp(`&${entityName};`, "g"),
                        val: val
                    };
                } else if (hasBody && $3b08c4ede4783019$var$isElement(xmlData, i)) i += 8; //Not supported
                else if (hasBody && $3b08c4ede4783019$var$isAttlist(xmlData, i)) i += 8; //Not supported
                else if (hasBody && $3b08c4ede4783019$var$isNotation(xmlData, i)) i += 9; //Not supported
                else if ($3b08c4ede4783019$var$isComment) comment = true;
                else throw new Error("Invalid DOCTYPE");
                angleBracketsCount++;
                exp = "";
            } else if (xmlData[i] === '>') {
                if (comment) {
                    if (xmlData[i - 1] === "-" && xmlData[i - 2] === "-") {
                        comment = false;
                        angleBracketsCount--;
                    }
                } else angleBracketsCount--;
                if (angleBracketsCount === 0) break;
            } else if (xmlData[i] === '[') hasBody = true;
            else exp += xmlData[i];
        }
        if (angleBracketsCount !== 0) throw new Error(`Unclosed DOCTYPE`);
    } else throw new Error(`Invalid Tag instead of DOCTYPE`);
    return {
        entities: entities,
        i: i
    };
}
function $3b08c4ede4783019$var$readEntityExp(xmlData, i) {
    //External entities are not supported
    //    <!ENTITY ext SYSTEM "http://normal-website.com" >
    //Parameter entities are not supported
    //    <!ENTITY entityname "&anotherElement;">
    //Internal entities are supported
    //    <!ENTITY entityname "replacement text">
    //read EntityName
    let entityName1 = "";
    for(; i < xmlData.length && xmlData[i] !== "'" && xmlData[i] !== '"'; i++)// if(xmlData[i] === " ") continue;
    // else 
    entityName1 += xmlData[i];
    entityName1 = entityName1.trim();
    if (entityName1.indexOf(" ") !== -1) throw new Error("External entites are not supported");
    //read Entity Value
    const startChar = xmlData[i++];
    let val1 = "";
    for(; i < xmlData.length && xmlData[i] !== startChar; i++)val1 += xmlData[i];
    return [
        entityName1,
        val1,
        i
    ];
}
function $3b08c4ede4783019$var$isComment(xmlData, i) {
    if (xmlData[i + 1] === '!' && xmlData[i + 2] === '-' && xmlData[i + 3] === '-') return true;
    return false;
}
function $3b08c4ede4783019$var$isEntity(xmlData, i) {
    if (xmlData[i + 1] === '!' && xmlData[i + 2] === 'E' && xmlData[i + 3] === 'N' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'I' && xmlData[i + 6] === 'T' && xmlData[i + 7] === 'Y') return true;
    return false;
}
function $3b08c4ede4783019$var$isElement(xmlData, i) {
    if (xmlData[i + 1] === '!' && xmlData[i + 2] === 'E' && xmlData[i + 3] === 'L' && xmlData[i + 4] === 'E' && xmlData[i + 5] === 'M' && xmlData[i + 6] === 'E' && xmlData[i + 7] === 'N' && xmlData[i + 8] === 'T') return true;
    return false;
}
function $3b08c4ede4783019$var$isAttlist(xmlData, i) {
    if (xmlData[i + 1] === '!' && xmlData[i + 2] === 'A' && xmlData[i + 3] === 'T' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'L' && xmlData[i + 6] === 'I' && xmlData[i + 7] === 'S' && xmlData[i + 8] === 'T') return true;
    return false;
}
function $3b08c4ede4783019$var$isNotation(xmlData, i) {
    if (xmlData[i + 1] === '!' && xmlData[i + 2] === 'N' && xmlData[i + 3] === 'O' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'A' && xmlData[i + 6] === 'T' && xmlData[i + 7] === 'I' && xmlData[i + 8] === 'O' && xmlData[i + 9] === 'N') return true;
    return false;
}
function $3b08c4ede4783019$var$validateEntityName(name) {
    if ($88d735a8ac10eecc$export$998d7ff9801e90bb(name)) return name;
    else throw new Error(`Invalid entity name ${name}`);
}
$3b08c4ede4783019$exports = $3b08c4ede4783019$var$readDocType;



// const regx =
//   '<((!\\[CDATA\\[([\\s\\S]*?)(]]>))|((NAME:)?(NAME))([^>]*)>|((\\/)(NAME)\\s*>))([^<]*)'
//   .replace(/NAME/g, util.nameRegexp);
//const tagsRegx = new RegExp("<(\\/?[\\w:\\-\._]+)([^>]*)>(\\s*"+cdataRegx+")*([^<]+)?","g");
//const tagsRegx = new RegExp("<(\\/?)((\\w*:)?([\\w:\\-\._]+))([^>]*)>([^<]*)("+cdataRegx+"([^<]*))*([^<]+)?","g");
class $6f6bfc1a18f808f6$var$OrderedObjParser {
    constructor(options){
        this.options = options;
        this.currentNode = null;
        this.tagsNodeStack = [];
        this.docTypeEntities = {};
        this.lastEntities = {
            "apos": {
                regex: /&(apos|#39|#x27);/g,
                val: "'"
            },
            "gt": {
                regex: /&(gt|#62|#x3E);/g,
                val: ">"
            },
            "lt": {
                regex: /&(lt|#60|#x3C);/g,
                val: "<"
            },
            "quot": {
                regex: /&(quot|#34|#x22);/g,
                val: "\""
            }
        };
        this.ampEntity = {
            regex: /&(amp|#38|#x26);/g,
            val: "&"
        };
        this.htmlEntities = {
            "space": {
                regex: /&(nbsp|#160);/g,
                val: " "
            },
            // "lt" : { regex: /&(lt|#60);/g, val: "<" },
            // "gt" : { regex: /&(gt|#62);/g, val: ">" },
            // "amp" : { regex: /&(amp|#38);/g, val: "&" },
            // "quot" : { regex: /&(quot|#34);/g, val: "\"" },
            // "apos" : { regex: /&(apos|#39);/g, val: "'" },
            "cent": {
                regex: /&(cent|#162);/g,
                val: "\xa2"
            },
            "pound": {
                regex: /&(pound|#163);/g,
                val: "\xa3"
            },
            "yen": {
                regex: /&(yen|#165);/g,
                val: "\xa5"
            },
            "euro": {
                regex: /&(euro|#8364);/g,
                val: "\u20AC"
            },
            "copyright": {
                regex: /&(copy|#169);/g,
                val: "\xa9"
            },
            "reg": {
                regex: /&(reg|#174);/g,
                val: "\xae"
            },
            "inr": {
                regex: /&(inr|#8377);/g,
                val: "\u20B9"
            },
            "num_dec": {
                regex: /&#([0-9]{1,7});/g,
                val: (_, str)=>String.fromCharCode(Number.parseInt(str, 10))
            },
            "num_hex": {
                regex: /&#x([0-9a-fA-F]{1,6});/g,
                val: (_, str)=>String.fromCharCode(Number.parseInt(str, 16))
            }
        };
        this.addExternalEntities = $6f6bfc1a18f808f6$var$addExternalEntities;
        this.parseXml = $6f6bfc1a18f808f6$var$parseXml;
        this.parseTextData = $6f6bfc1a18f808f6$var$parseTextData;
        this.resolveNameSpace = $6f6bfc1a18f808f6$var$resolveNameSpace;
        this.buildAttributesMap = $6f6bfc1a18f808f6$var$buildAttributesMap;
        this.isItStopNode = $6f6bfc1a18f808f6$var$isItStopNode;
        this.replaceEntitiesValue = $6f6bfc1a18f808f6$var$replaceEntitiesValue;
        this.readStopNodeData = $6f6bfc1a18f808f6$var$readStopNodeData;
        this.saveTextToParentTag = $6f6bfc1a18f808f6$var$saveTextToParentTag;
        this.addChild = $6f6bfc1a18f808f6$var$addChild;
    }
}
function $6f6bfc1a18f808f6$var$addExternalEntities(externalEntities) {
    const entKeys = Object.keys(externalEntities);
    for(let i = 0; i < entKeys.length; i++){
        const ent = entKeys[i];
        this.lastEntities[ent] = {
            regex: new RegExp("&" + ent + ";", "g"),
            val: externalEntities[ent]
        };
    }
}
/**
 * @param {string} val
 * @param {string} tagName
 * @param {string} jPath
 * @param {boolean} dontTrim
 * @param {boolean} hasAttributes
 * @param {boolean} isLeafNode
 * @param {boolean} escapeEntities
 */ function $6f6bfc1a18f808f6$var$parseTextData(val, tagName, jPath, dontTrim, hasAttributes, isLeafNode, escapeEntities) {
    if (val !== undefined) {
        if (this.options.trimValues && !dontTrim) val = val.trim();
        if (val.length > 0) {
            if (!escapeEntities) val = this.replaceEntitiesValue(val);
            const newval = this.options.tagValueProcessor(tagName, val, jPath, hasAttributes, isLeafNode);
            if (newval === null || newval === undefined) //don't parse
            return val;
            else if (typeof newval !== typeof val || newval !== val) //overwrite
            return newval;
            else if (this.options.trimValues) return $6f6bfc1a18f808f6$var$parseValue(val, this.options.parseTagValue, this.options.numberParseOptions);
            else {
                const trimmedVal = val.trim();
                if (trimmedVal === val) return $6f6bfc1a18f808f6$var$parseValue(val, this.options.parseTagValue, this.options.numberParseOptions);
                else return val;
            }
        }
    }
}
function $6f6bfc1a18f808f6$var$resolveNameSpace(tagname) {
    if (this.options.removeNSPrefix) {
        const tags = tagname.split(':');
        const prefix = tagname.charAt(0) === '/' ? '/' : '';
        if (tags[0] === 'xmlns') return '';
        if (tags.length === 2) tagname = prefix + tags[1];
    }
    return tagname;
}
//TODO: change regex to capture NS
//const attrsRegx = new RegExp("([\\w\\-\\.\\:]+)\\s*=\\s*(['\"])((.|\n)*?)\\2","gm");
const $6f6bfc1a18f808f6$var$attrsRegx = new RegExp('([^\\s=]+)\\s*(=\\s*([\'"])([\\s\\S]*?)\\3)?', 'gm');
function $6f6bfc1a18f808f6$var$buildAttributesMap(attrStr, jPath, tagName) {
    if (!this.options.ignoreAttributes && typeof attrStr === 'string') {
        // attrStr = attrStr.replace(/\r?\n/g, ' ');
        //attrStr = attrStr || attrStr.trim();
        const matches = $88d735a8ac10eecc$export$aaa9734c55cb7a19(attrStr, $6f6bfc1a18f808f6$var$attrsRegx);
        const len = matches.length; //don't make it inline
        const attrs = {};
        for(let i = 0; i < len; i++){
            const attrName = this.resolveNameSpace(matches[i][1]);
            let oldVal = matches[i][4];
            let aName = this.options.attributeNamePrefix + attrName;
            if (attrName.length) {
                if (this.options.transformAttributeName) aName = this.options.transformAttributeName(aName);
                if (aName === "__proto__") aName = "#__proto__";
                if (oldVal !== undefined) {
                    if (this.options.trimValues) oldVal = oldVal.trim();
                    oldVal = this.replaceEntitiesValue(oldVal);
                    const newVal = this.options.attributeValueProcessor(attrName, oldVal, jPath);
                    if (newVal === null || newVal === undefined) //don't parse
                    attrs[aName] = oldVal;
                    else if (typeof newVal !== typeof oldVal || newVal !== oldVal) //overwrite
                    attrs[aName] = newVal;
                    else //parse
                    attrs[aName] = $6f6bfc1a18f808f6$var$parseValue(oldVal, this.options.parseAttributeValue, this.options.numberParseOptions);
                } else if (this.options.allowBooleanAttributes) attrs[aName] = true;
            }
        }
        if (!Object.keys(attrs).length) return;
        if (this.options.attributesGroupName) {
            const attrCollection = {};
            attrCollection[this.options.attributesGroupName] = attrs;
            return attrCollection;
        }
        return attrs;
    }
}
const $6f6bfc1a18f808f6$var$parseXml = function(xmlData) {
    xmlData = xmlData.replace(/\r\n?/g, "\n"); //TODO: remove this line
    const xmlObj = new $4b6e00c1635b290d$exports('!xml');
    let currentNode = xmlObj;
    let textData = "";
    let jPath = "";
    for(let i = 0; i < xmlData.length; i++){
        const ch = xmlData[i];
        if (ch === '<') {
            // const nextIndex = i+1;
            // const _2ndChar = xmlData[nextIndex];
            if (xmlData[i + 1] === '/') {
                const closeIndex = $6f6bfc1a18f808f6$var$findClosingIndex(xmlData, ">", i, "Closing Tag is not closed.");
                let tagName = xmlData.substring(i + 2, closeIndex).trim();
                if (this.options.removeNSPrefix) {
                    const colonIndex = tagName.indexOf(":");
                    if (colonIndex !== -1) tagName = tagName.substr(colonIndex + 1);
                }
                if (this.options.transformTagName) tagName = this.options.transformTagName(tagName);
                if (currentNode) textData = this.saveTextToParentTag(textData, currentNode, jPath);
                //check if last tag of nested tag was unpaired tag
                const lastTagName = jPath.substring(jPath.lastIndexOf(".") + 1);
                if (tagName && this.options.unpairedTags.indexOf(tagName) !== -1) throw new Error(`Unpaired tag can not be used as closing tag: </${tagName}>`);
                let propIndex = 0;
                if (lastTagName && this.options.unpairedTags.indexOf(lastTagName) !== -1) {
                    propIndex = jPath.lastIndexOf('.', jPath.lastIndexOf('.') - 1);
                    this.tagsNodeStack.pop();
                } else propIndex = jPath.lastIndexOf(".");
                jPath = jPath.substring(0, propIndex);
                currentNode = this.tagsNodeStack.pop(); //avoid recursion, set the parent tag scope
                textData = "";
                i = closeIndex;
            } else if (xmlData[i + 1] === '?') {
                let tagData = $6f6bfc1a18f808f6$var$readTagExp(xmlData, i, false, "?>");
                if (!tagData) throw new Error("Pi Tag is not closed.");
                textData = this.saveTextToParentTag(textData, currentNode, jPath);
                if (this.options.ignoreDeclaration && tagData.tagName === "?xml" || this.options.ignorePiTags) ;
                else {
                    const childNode = new $4b6e00c1635b290d$exports(tagData.tagName);
                    childNode.add(this.options.textNodeName, "");
                    if (tagData.tagName !== tagData.tagExp && tagData.attrExpPresent) childNode[":@"] = this.buildAttributesMap(tagData.tagExp, jPath, tagData.tagName);
                    this.addChild(currentNode, childNode, jPath);
                }
                i = tagData.closeIndex + 1;
            } else if (xmlData.substr(i + 1, 3) === '!--') {
                const endIndex = $6f6bfc1a18f808f6$var$findClosingIndex(xmlData, "-->", i + 4, "Comment is not closed.");
                if (this.options.commentPropName) {
                    const comment = xmlData.substring(i + 4, endIndex - 2);
                    textData = this.saveTextToParentTag(textData, currentNode, jPath);
                    currentNode.add(this.options.commentPropName, [
                        {
                            [this.options.textNodeName]: comment
                        }
                    ]);
                }
                i = endIndex;
            } else if (xmlData.substr(i + 1, 2) === '!D') {
                const result = $3b08c4ede4783019$exports(xmlData, i);
                this.docTypeEntities = result.entities;
                i = result.i;
            } else if (xmlData.substr(i + 1, 2) === '![') {
                const closeIndex = $6f6bfc1a18f808f6$var$findClosingIndex(xmlData, "]]>", i, "CDATA is not closed.") - 2;
                const tagExp = xmlData.substring(i + 9, closeIndex);
                textData = this.saveTextToParentTag(textData, currentNode, jPath);
                let val = this.parseTextData(tagExp, currentNode.tagname, jPath, true, false, true, true);
                if (val == undefined) val = "";
                //cdata should be set even if it is 0 length string
                if (this.options.cdataPropName) currentNode.add(this.options.cdataPropName, [
                    {
                        [this.options.textNodeName]: tagExp
                    }
                ]);
                else currentNode.add(this.options.textNodeName, val);
                i = closeIndex + 2;
            } else {
                let result = $6f6bfc1a18f808f6$var$readTagExp(xmlData, i, this.options.removeNSPrefix);
                let tagName = result.tagName;
                const rawTagName = result.rawTagName;
                let tagExp = result.tagExp;
                let attrExpPresent = result.attrExpPresent;
                let closeIndex = result.closeIndex;
                if (this.options.transformTagName) tagName = this.options.transformTagName(tagName);
                //save text as child node
                if (currentNode && textData) {
                    if (currentNode.tagname !== '!xml') //when nested tag is found
                    textData = this.saveTextToParentTag(textData, currentNode, jPath, false);
                }
                //check if last tag was unpaired tag
                const lastTag = currentNode;
                if (lastTag && this.options.unpairedTags.indexOf(lastTag.tagname) !== -1) {
                    currentNode = this.tagsNodeStack.pop();
                    jPath = jPath.substring(0, jPath.lastIndexOf("."));
                }
                if (tagName !== xmlObj.tagname) jPath += jPath ? "." + tagName : tagName;
                if (this.isItStopNode(this.options.stopNodes, jPath, tagName)) {
                    let tagContent = "";
                    //self-closing tag
                    if (tagExp.length > 0 && tagExp.lastIndexOf("/") === tagExp.length - 1) {
                        if (tagName[tagName.length - 1] === "/") {
                            tagName = tagName.substr(0, tagName.length - 1);
                            jPath = jPath.substr(0, jPath.length - 1);
                            tagExp = tagName;
                        } else tagExp = tagExp.substr(0, tagExp.length - 1);
                        i = result.closeIndex;
                    } else if (this.options.unpairedTags.indexOf(tagName) !== -1) i = result.closeIndex;
                    else {
                        //read until closing tag is found
                        const result = this.readStopNodeData(xmlData, rawTagName, closeIndex + 1);
                        if (!result) throw new Error(`Unexpected end of ${rawTagName}`);
                        i = result.i;
                        tagContent = result.tagContent;
                    }
                    const childNode = new $4b6e00c1635b290d$exports(tagName);
                    if (tagName !== tagExp && attrExpPresent) childNode[":@"] = this.buildAttributesMap(tagExp, jPath, tagName);
                    if (tagContent) tagContent = this.parseTextData(tagContent, tagName, jPath, true, attrExpPresent, true, true);
                    jPath = jPath.substr(0, jPath.lastIndexOf("."));
                    childNode.add(this.options.textNodeName, tagContent);
                    this.addChild(currentNode, childNode, jPath);
                } else {
                    //selfClosing tag
                    if (tagExp.length > 0 && tagExp.lastIndexOf("/") === tagExp.length - 1) {
                        if (tagName[tagName.length - 1] === "/") {
                            tagName = tagName.substr(0, tagName.length - 1);
                            jPath = jPath.substr(0, jPath.length - 1);
                            tagExp = tagName;
                        } else tagExp = tagExp.substr(0, tagExp.length - 1);
                        if (this.options.transformTagName) tagName = this.options.transformTagName(tagName);
                        const childNode = new $4b6e00c1635b290d$exports(tagName);
                        if (tagName !== tagExp && attrExpPresent) childNode[":@"] = this.buildAttributesMap(tagExp, jPath, tagName);
                        this.addChild(currentNode, childNode, jPath);
                        jPath = jPath.substr(0, jPath.lastIndexOf("."));
                    } else {
                        const childNode = new $4b6e00c1635b290d$exports(tagName);
                        this.tagsNodeStack.push(currentNode);
                        if (tagName !== tagExp && attrExpPresent) childNode[":@"] = this.buildAttributesMap(tagExp, jPath, tagName);
                        this.addChild(currentNode, childNode, jPath);
                        currentNode = childNode;
                    }
                    textData = "";
                    i = closeIndex;
                }
            }
        } else textData += xmlData[i];
    }
    return xmlObj.child;
};
function $6f6bfc1a18f808f6$var$addChild(currentNode, childNode, jPath) {
    const result = this.options.updateTag(childNode.tagname, jPath, childNode[":@"]);
    if (result === false) ;
    else if (typeof result === "string") {
        childNode.tagname = result;
        currentNode.addChild(childNode);
    } else currentNode.addChild(childNode);
}
const $6f6bfc1a18f808f6$var$replaceEntitiesValue = function(val) {
    if (this.options.processEntities) {
        for(let entityName in this.docTypeEntities){
            const entity = this.docTypeEntities[entityName];
            val = val.replace(entity.regx, entity.val);
        }
        for(let entityName in this.lastEntities){
            const entity = this.lastEntities[entityName];
            val = val.replace(entity.regex, entity.val);
        }
        if (this.options.htmlEntities) for(let entityName in this.htmlEntities){
            const entity = this.htmlEntities[entityName];
            val = val.replace(entity.regex, entity.val);
        }
        val = val.replace(this.ampEntity.regex, this.ampEntity.val);
    }
    return val;
};
function $6f6bfc1a18f808f6$var$saveTextToParentTag(textData, currentNode, jPath, isLeafNode) {
    if (textData) {
        if (isLeafNode === undefined) isLeafNode = Object.keys(currentNode.child).length === 0;
        textData = this.parseTextData(textData, currentNode.tagname, jPath, false, currentNode[":@"] ? Object.keys(currentNode[":@"]).length !== 0 : false, isLeafNode);
        if (textData !== undefined && textData !== "") currentNode.add(this.options.textNodeName, textData);
        textData = "";
    }
    return textData;
}
//TODO: use jPath to simplify the logic
/**
 * 
 * @param {string[]} stopNodes 
 * @param {string} jPath
 * @param {string} currentTagName 
 */ function $6f6bfc1a18f808f6$var$isItStopNode(stopNodes, jPath, currentTagName) {
    const allNodesExp = "*." + currentTagName;
    for(const stopNodePath in stopNodes){
        const stopNodeExp = stopNodes[stopNodePath];
        if (allNodesExp === stopNodeExp || jPath === stopNodeExp) return true;
    }
    return false;
}
/**
 * Returns the tag Expression and where it is ending handling single-double quotes situation
 * @param {string} xmlData 
 * @param {number} i starting index
 * @returns 
 */ function $6f6bfc1a18f808f6$var$tagExpWithClosingIndex(xmlData, i, closingChar = ">") {
    let attrBoundary;
    let tagExp = "";
    for(let index = i; index < xmlData.length; index++){
        let ch = xmlData[index];
        if (attrBoundary) {
            if (ch === attrBoundary) attrBoundary = ""; //reset
        } else if (ch === '"' || ch === "'") attrBoundary = ch;
        else if (ch === closingChar[0]) {
            if (closingChar[1]) {
                if (xmlData[index + 1] === closingChar[1]) return {
                    data: tagExp,
                    index: index
                };
            } else return {
                data: tagExp,
                index: index
            };
        } else if (ch === '\t') ch = " ";
        tagExp += ch;
    }
}
function $6f6bfc1a18f808f6$var$findClosingIndex(xmlData, str, i, errMsg) {
    const closingIndex = xmlData.indexOf(str, i);
    if (closingIndex === -1) throw new Error(errMsg);
    else return closingIndex + str.length - 1;
}
function $6f6bfc1a18f808f6$var$readTagExp(xmlData, i, removeNSPrefix, closingChar = ">") {
    const result = $6f6bfc1a18f808f6$var$tagExpWithClosingIndex(xmlData, i + 1, closingChar);
    if (!result) return;
    let tagExp = result.data;
    const closeIndex = result.index;
    const separatorIndex = tagExp.search(/\s/);
    let tagName = tagExp;
    let attrExpPresent = true;
    if (separatorIndex !== -1) {
        tagName = tagExp.substring(0, separatorIndex);
        tagExp = tagExp.substring(separatorIndex + 1).trimStart();
    }
    const rawTagName = tagName;
    if (removeNSPrefix) {
        const colonIndex = tagName.indexOf(":");
        if (colonIndex !== -1) {
            tagName = tagName.substr(colonIndex + 1);
            attrExpPresent = tagName !== result.data.substr(colonIndex + 1);
        }
    }
    return {
        tagName: tagName,
        tagExp: tagExp,
        closeIndex: closeIndex,
        attrExpPresent: attrExpPresent,
        rawTagName: rawTagName
    };
}
/**
 * find paired tag for a stop node
 * @param {string} xmlData 
 * @param {string} tagName 
 * @param {number} i 
 */ function $6f6bfc1a18f808f6$var$readStopNodeData(xmlData, tagName, i) {
    const startIndex = i;
    // Starting at 1 since we already have an open tag
    let openTagCount = 1;
    for(; i < xmlData.length; i++)if (xmlData[i] === "<") {
        if (xmlData[i + 1] === "/") {
            const closeIndex = $6f6bfc1a18f808f6$var$findClosingIndex(xmlData, ">", i, `${tagName} is not closed`);
            let closeTagName = xmlData.substring(i + 2, closeIndex).trim();
            if (closeTagName === tagName) {
                openTagCount--;
                if (openTagCount === 0) return {
                    tagContent: xmlData.substring(startIndex, i),
                    i: closeIndex
                };
            }
            i = closeIndex;
        } else if (xmlData[i + 1] === '?') {
            const closeIndex = $6f6bfc1a18f808f6$var$findClosingIndex(xmlData, "?>", i + 1, "StopNode is not closed.");
            i = closeIndex;
        } else if (xmlData.substr(i + 1, 3) === '!--') {
            const closeIndex = $6f6bfc1a18f808f6$var$findClosingIndex(xmlData, "-->", i + 3, "StopNode is not closed.");
            i = closeIndex;
        } else if (xmlData.substr(i + 1, 2) === '![') {
            const closeIndex = $6f6bfc1a18f808f6$var$findClosingIndex(xmlData, "]]>", i, "StopNode is not closed.") - 2;
            i = closeIndex;
        } else {
            const tagData = $6f6bfc1a18f808f6$var$readTagExp(xmlData, i, '>');
            if (tagData) {
                const openTagName = tagData && tagData.tagName;
                if (openTagName === tagName && tagData.tagExp[tagData.tagExp.length - 1] !== "/") openTagCount++;
                i = tagData.closeIndex;
            }
        }
    }
     //end for loop
}
function $6f6bfc1a18f808f6$var$parseValue(val, shouldParse, options) {
    if (shouldParse && typeof val === 'string') {
        //console.log(options)
        const newval = val.trim();
        if (newval === 'true') return true;
        else if (newval === 'false') return false;
        else return $167f716b04c2048a$exports(val, options);
    } else {
        if ($88d735a8ac10eecc$export$a5edf3f35b6dd392(val)) return val;
        else return '';
    }
}
$6f6bfc1a18f808f6$exports = $6f6bfc1a18f808f6$var$OrderedObjParser;


var $d84bcc5497848133$export$1b80ed980367b7c1;
'use strict';
/**
 * 
 * @param {array} node 
 * @param {any} options 
 * @returns 
 */ function $d84bcc5497848133$var$prettify(node, options) {
    return $d84bcc5497848133$var$compress(node, options);
}
/**
 * 
 * @param {array} arr 
 * @param {object} options 
 * @param {string} jPath 
 * @returns object
 */ function $d84bcc5497848133$var$compress(arr, options, jPath) {
    let text;
    const compressedObj = {};
    for(let i = 0; i < arr.length; i++){
        const tagObj = arr[i];
        const property = $d84bcc5497848133$var$propName(tagObj);
        let newJpath = "";
        if (jPath === undefined) newJpath = property;
        else newJpath = jPath + "." + property;
        if (property === options.textNodeName) {
            if (text === undefined) text = tagObj[property];
            else text += "" + tagObj[property];
        } else if (property === undefined) continue;
        else if (tagObj[property]) {
            let val = $d84bcc5497848133$var$compress(tagObj[property], options, newJpath);
            const isLeaf = $d84bcc5497848133$var$isLeafTag(val, options);
            if (tagObj[":@"]) $d84bcc5497848133$var$assignAttributes(val, tagObj[":@"], newJpath, options);
            else if (Object.keys(val).length === 1 && val[options.textNodeName] !== undefined && !options.alwaysCreateTextNode) val = val[options.textNodeName];
            else if (Object.keys(val).length === 0) {
                if (options.alwaysCreateTextNode) val[options.textNodeName] = "";
                else val = "";
            }
            if (compressedObj[property] !== undefined && compressedObj.hasOwnProperty(property)) {
                if (!Array.isArray(compressedObj[property])) compressedObj[property] = [
                    compressedObj[property]
                ];
                compressedObj[property].push(val);
            } else //TODO: if a node is not an array, then check if it should be an array
            //also determine if it is a leaf node
            if (options.isArray(property, newJpath, isLeaf)) compressedObj[property] = [
                val
            ];
            else compressedObj[property] = val;
        }
    }
    // if(text && text.length > 0) compressedObj[options.textNodeName] = text;
    if (typeof text === "string") {
        if (text.length > 0) compressedObj[options.textNodeName] = text;
    } else if (text !== undefined) compressedObj[options.textNodeName] = text;
    return compressedObj;
}
function $d84bcc5497848133$var$propName(obj) {
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        if (key !== ":@") return key;
    }
}
function $d84bcc5497848133$var$assignAttributes(obj, attrMap, jpath, options) {
    if (attrMap) {
        const keys = Object.keys(attrMap);
        const len = keys.length; //don't make it inline
        for(let i = 0; i < len; i++){
            const atrrName = keys[i];
            if (options.isArray(atrrName, jpath + "." + atrrName, true, true)) obj[atrrName] = [
                attrMap[atrrName]
            ];
            else obj[atrrName] = attrMap[atrrName];
        }
    }
}
function $d84bcc5497848133$var$isLeafTag(obj, options) {
    const { textNodeName: textNodeName } = options;
    const propCount = Object.keys(obj).length;
    if (propCount === 0) return true;
    if (propCount === 1 && (obj[textNodeName] || typeof obj[textNodeName] === "boolean" || obj[textNodeName] === 0)) return true;
    return false;
}
$d84bcc5497848133$export$1b80ed980367b7c1 = $d84bcc5497848133$var$prettify;


var $5a7d16e887191265$require$prettify = $d84bcc5497848133$export$1b80ed980367b7c1;

class $5a7d16e887191265$var$XMLParser {
    constructor(options){
        this.externalEntities = {};
        this.options = $5a7d16e887191265$require$buildOptions(options);
    }
    /**
     * Parse XML dats to JS object 
     * @param {string|Buffer} xmlData 
     * @param {boolean|Object} validationOption 
     */ parse(xmlData, validationOption) {
        if (typeof xmlData === "string") ;
        else if (xmlData.toString) xmlData = xmlData.toString();
        else throw new Error("XML data is accepted in String or Bytes[] form.");
        if (validationOption) {
            if (validationOption === true) validationOption = {}; //validate with default options
            const result = $74ca744e6015d210$export$a22775fa5e2eebd9(xmlData, validationOption);
            if (result !== true) throw Error(`${result.err.msg}:${result.err.line}:${result.err.col}`);
        }
        const orderedObjParser = new $6f6bfc1a18f808f6$exports(this.options);
        orderedObjParser.addExternalEntities(this.externalEntities);
        const orderedResult = orderedObjParser.parseXml(xmlData);
        if (this.options.preserveOrder || orderedResult === undefined) return orderedResult;
        else return $5a7d16e887191265$require$prettify(orderedResult, this.options);
    }
    /**
     * Add Entity which is not by default supported by this library
     * @param {string} key 
     * @param {string} value 
     */ addEntity(key, value) {
        if (value.indexOf("&") !== -1) throw new Error("Entity value can't have '&'");
        else if (key.indexOf("&") !== -1 || key.indexOf(";") !== -1) throw new Error("An entity must be set without '&' and ';'. Eg. use '#xD' for '&#xD;'");
        else if (value === "&") throw new Error("An entity with value '&' is not permitted");
        else this.externalEntities[key] = value;
    }
}
$5a7d16e887191265$exports = $5a7d16e887191265$var$XMLParser;


var $e16872f5117707b8$exports = {};
'use strict';
var $781775fcdabfb37a$exports = {};
const $781775fcdabfb37a$var$EOL = "\n";
/**
 * 
 * @param {array} jArray 
 * @param {any} options 
 * @returns 
 */ function $781775fcdabfb37a$var$toXml(jArray, options) {
    let indentation = "";
    if (options.format && options.indentBy.length > 0) indentation = $781775fcdabfb37a$var$EOL;
    return $781775fcdabfb37a$var$arrToStr(jArray, options, "", indentation);
}
function $781775fcdabfb37a$var$arrToStr(arr, options, jPath, indentation) {
    let xmlStr = "";
    let isPreviousElementTag = false;
    for(let i = 0; i < arr.length; i++){
        const tagObj = arr[i];
        const tagName = $781775fcdabfb37a$var$propName(tagObj);
        if (tagName === undefined) continue;
        let newJPath = "";
        if (jPath.length === 0) newJPath = tagName;
        else newJPath = `${jPath}.${tagName}`;
        if (tagName === options.textNodeName) {
            let tagText = tagObj[tagName];
            if (!$781775fcdabfb37a$var$isStopNode(newJPath, options)) {
                tagText = options.tagValueProcessor(tagName, tagText);
                tagText = $781775fcdabfb37a$var$replaceEntitiesValue(tagText, options);
            }
            if (isPreviousElementTag) xmlStr += indentation;
            xmlStr += tagText;
            isPreviousElementTag = false;
            continue;
        } else if (tagName === options.cdataPropName) {
            if (isPreviousElementTag) xmlStr += indentation;
            xmlStr += `<![CDATA[${tagObj[tagName][0][options.textNodeName]}]]>`;
            isPreviousElementTag = false;
            continue;
        } else if (tagName === options.commentPropName) {
            xmlStr += indentation + `<!--${tagObj[tagName][0][options.textNodeName]}-->`;
            isPreviousElementTag = true;
            continue;
        } else if (tagName[0] === "?") {
            const attStr = $781775fcdabfb37a$var$attr_to_str(tagObj[":@"], options);
            const tempInd = tagName === "?xml" ? "" : indentation;
            let piTextNodeName = tagObj[tagName][0][options.textNodeName];
            piTextNodeName = piTextNodeName.length !== 0 ? " " + piTextNodeName : ""; //remove extra spacing
            xmlStr += tempInd + `<${tagName}${piTextNodeName}${attStr}?>`;
            isPreviousElementTag = true;
            continue;
        }
        let newIdentation = indentation;
        if (newIdentation !== "") newIdentation += options.indentBy;
        const attStr = $781775fcdabfb37a$var$attr_to_str(tagObj[":@"], options);
        const tagStart = indentation + `<${tagName}${attStr}`;
        const tagValue = $781775fcdabfb37a$var$arrToStr(tagObj[tagName], options, newJPath, newIdentation);
        if (options.unpairedTags.indexOf(tagName) !== -1) {
            if (options.suppressUnpairedNode) xmlStr += tagStart + ">";
            else xmlStr += tagStart + "/>";
        } else if ((!tagValue || tagValue.length === 0) && options.suppressEmptyNode) xmlStr += tagStart + "/>";
        else if (tagValue && tagValue.endsWith(">")) xmlStr += tagStart + `>${tagValue}${indentation}</${tagName}>`;
        else {
            xmlStr += tagStart + ">";
            if (tagValue && indentation !== "" && (tagValue.includes("/>") || tagValue.includes("</"))) xmlStr += indentation + options.indentBy + tagValue + indentation;
            else xmlStr += tagValue;
            xmlStr += `</${tagName}>`;
        }
        isPreviousElementTag = true;
    }
    return xmlStr;
}
function $781775fcdabfb37a$var$propName(obj) {
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        if (!obj.hasOwnProperty(key)) continue;
        if (key !== ":@") return key;
    }
}
function $781775fcdabfb37a$var$attr_to_str(attrMap, options) {
    let attrStr = "";
    if (attrMap && !options.ignoreAttributes) for(let attr in attrMap){
        if (!attrMap.hasOwnProperty(attr)) continue;
        let attrVal = options.attributeValueProcessor(attr, attrMap[attr]);
        attrVal = $781775fcdabfb37a$var$replaceEntitiesValue(attrVal, options);
        if (attrVal === true && options.suppressBooleanAttributes) attrStr += ` ${attr.substr(options.attributeNamePrefix.length)}`;
        else attrStr += ` ${attr.substr(options.attributeNamePrefix.length)}="${attrVal}"`;
    }
    return attrStr;
}
function $781775fcdabfb37a$var$isStopNode(jPath, options) {
    jPath = jPath.substr(0, jPath.length - options.textNodeName.length - 1);
    let tagName = jPath.substr(jPath.lastIndexOf(".") + 1);
    for(let index in options.stopNodes){
        if (options.stopNodes[index] === jPath || options.stopNodes[index] === "*." + tagName) return true;
    }
    return false;
}
function $781775fcdabfb37a$var$replaceEntitiesValue(textValue, options) {
    if (textValue && textValue.length > 0 && options.processEntities) for(let i = 0; i < options.entities.length; i++){
        const entity = options.entities[i];
        textValue = textValue.replace(entity.regex, entity.val);
    }
    return textValue;
}
$781775fcdabfb37a$exports = $781775fcdabfb37a$var$toXml;


const $e16872f5117707b8$var$defaultOptions = {
    attributeNamePrefix: '@_',
    attributesGroupName: false,
    textNodeName: '#text',
    ignoreAttributes: true,
    cdataPropName: false,
    format: false,
    indentBy: '  ',
    suppressEmptyNode: false,
    suppressUnpairedNode: true,
    suppressBooleanAttributes: true,
    tagValueProcessor: function(key, a) {
        return a;
    },
    attributeValueProcessor: function(attrName, a) {
        return a;
    },
    preserveOrder: false,
    commentPropName: false,
    unpairedTags: [],
    entities: [
        {
            regex: new RegExp("&", "g"),
            val: "&amp;"
        },
        {
            regex: new RegExp(">", "g"),
            val: "&gt;"
        },
        {
            regex: new RegExp("<", "g"),
            val: "&lt;"
        },
        {
            regex: new RegExp("\'", "g"),
            val: "&apos;"
        },
        {
            regex: new RegExp("\"", "g"),
            val: "&quot;"
        }
    ],
    processEntities: true,
    stopNodes: [],
    // transformTagName: false,
    // transformAttributeName: false,
    oneListGroup: false
};
function $e16872f5117707b8$var$Builder(options) {
    this.options = Object.assign({}, $e16872f5117707b8$var$defaultOptions, options);
    if (this.options.ignoreAttributes || this.options.attributesGroupName) this.isAttribute = function() {
        return false;
    };
    else {
        this.attrPrefixLen = this.options.attributeNamePrefix.length;
        this.isAttribute = $e16872f5117707b8$var$isAttribute;
    }
    this.processTextOrObjNode = $e16872f5117707b8$var$processTextOrObjNode;
    if (this.options.format) {
        this.indentate = $e16872f5117707b8$var$indentate;
        this.tagEndChar = '>\n';
        this.newLine = '\n';
    } else {
        this.indentate = function() {
            return '';
        };
        this.tagEndChar = '>';
        this.newLine = '';
    }
}
$e16872f5117707b8$var$Builder.prototype.build = function(jObj) {
    if (this.options.preserveOrder) return $781775fcdabfb37a$exports(jObj, this.options);
    else {
        if (Array.isArray(jObj) && this.options.arrayNodeName && this.options.arrayNodeName.length > 1) jObj = {
            [this.options.arrayNodeName]: jObj
        };
        return this.j2x(jObj, 0).val;
    }
};
$e16872f5117707b8$var$Builder.prototype.j2x = function(jObj, level) {
    let attrStr = '';
    let val = '';
    for(let key in jObj){
        if (!Object.prototype.hasOwnProperty.call(jObj, key)) continue;
        if (typeof jObj[key] === 'undefined') // supress undefined node only if it is not an attribute
        {
            if (this.isAttribute(key)) val += '';
        } else if (jObj[key] === null) {
            // null attribute should be ignored by the attribute list, but should not cause the tag closing
            if (this.isAttribute(key)) val += '';
            else if (key[0] === '?') val += this.indentate(level) + '<' + key + '?' + this.tagEndChar;
            else val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
        // val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
        } else if (jObj[key] instanceof Date) val += this.buildTextValNode(jObj[key], key, '', level);
        else if (typeof jObj[key] !== 'object') {
            //premitive type
            const attr = this.isAttribute(key);
            if (attr) attrStr += this.buildAttrPairStr(attr, '' + jObj[key]);
            else //tag value
            if (key === this.options.textNodeName) {
                let newval = this.options.tagValueProcessor(key, '' + jObj[key]);
                val += this.replaceEntitiesValue(newval);
            } else val += this.buildTextValNode(jObj[key], key, '', level);
        } else if (Array.isArray(jObj[key])) {
            //repeated nodes
            const arrLen = jObj[key].length;
            let listTagVal = "";
            let listTagAttr = "";
            for(let j = 0; j < arrLen; j++){
                const item = jObj[key][j];
                if (typeof item === 'undefined') ;
                else if (item === null) {
                    if (key[0] === "?") val += this.indentate(level) + '<' + key + '?' + this.tagEndChar;
                    else val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
                } else if (typeof item === 'object') {
                    if (this.options.oneListGroup) {
                        const result = this.j2x(item, level + 1);
                        listTagVal += result.val;
                        if (this.options.attributesGroupName && item.hasOwnProperty(this.options.attributesGroupName)) listTagAttr += result.attrStr;
                    } else listTagVal += this.processTextOrObjNode(item, key, level);
                } else if (this.options.oneListGroup) {
                    let textValue = this.options.tagValueProcessor(key, item);
                    textValue = this.replaceEntitiesValue(textValue);
                    listTagVal += textValue;
                } else listTagVal += this.buildTextValNode(item, key, '', level);
            }
            if (this.options.oneListGroup) listTagVal = this.buildObjectNode(listTagVal, key, listTagAttr, level);
            val += listTagVal;
        } else //nested node
        if (this.options.attributesGroupName && key === this.options.attributesGroupName) {
            const Ks = Object.keys(jObj[key]);
            const L = Ks.length;
            for(let j = 0; j < L; j++)attrStr += this.buildAttrPairStr(Ks[j], '' + jObj[key][Ks[j]]);
        } else val += this.processTextOrObjNode(jObj[key], key, level);
    }
    return {
        attrStr: attrStr,
        val: val
    };
};
$e16872f5117707b8$var$Builder.prototype.buildAttrPairStr = function(attrName, val) {
    val = this.options.attributeValueProcessor(attrName, '' + val);
    val = this.replaceEntitiesValue(val);
    if (this.options.suppressBooleanAttributes && val === "true") return ' ' + attrName;
    else return ' ' + attrName + '="' + val + '"';
};
function $e16872f5117707b8$var$processTextOrObjNode(object, key, level) {
    const result = this.j2x(object, level + 1);
    if (object[this.options.textNodeName] !== undefined && Object.keys(object).length === 1) return this.buildTextValNode(object[this.options.textNodeName], key, result.attrStr, level);
    else return this.buildObjectNode(result.val, key, result.attrStr, level);
}
$e16872f5117707b8$var$Builder.prototype.buildObjectNode = function(val, key, attrStr, level) {
    if (val === "") {
        if (key[0] === "?") return this.indentate(level) + '<' + key + attrStr + '?' + this.tagEndChar;
        else return this.indentate(level) + '<' + key + attrStr + this.closeTag(key) + this.tagEndChar;
    } else {
        let tagEndExp = '</' + key + this.tagEndChar;
        let piClosingChar = "";
        if (key[0] === "?") {
            piClosingChar = "?";
            tagEndExp = "";
        }
        // attrStr is an empty string in case the attribute came as undefined or null
        if ((attrStr || attrStr === '') && val.indexOf('<') === -1) return this.indentate(level) + '<' + key + attrStr + piClosingChar + '>' + val + tagEndExp;
        else if (this.options.commentPropName !== false && key === this.options.commentPropName && piClosingChar.length === 0) return this.indentate(level) + `<!--${val}-->` + this.newLine;
        else return this.indentate(level) + '<' + key + attrStr + piClosingChar + this.tagEndChar + val + this.indentate(level) + tagEndExp;
    }
};
$e16872f5117707b8$var$Builder.prototype.closeTag = function(key) {
    let closeTag = "";
    if (this.options.unpairedTags.indexOf(key) !== -1) {
        if (!this.options.suppressUnpairedNode) closeTag = "/";
    } else if (this.options.suppressEmptyNode) closeTag = "/";
    else closeTag = `></${key}`;
    return closeTag;
};
function $e16872f5117707b8$var$buildEmptyObjNode(val, key, attrStr, level) {
    if (val !== '') return this.buildObjectNode(val, key, attrStr, level);
    else {
        if (key[0] === "?") return this.indentate(level) + '<' + key + attrStr + '?' + this.tagEndChar;
        else return this.indentate(level) + '<' + key + attrStr + '/' + this.tagEndChar;
    }
}
$e16872f5117707b8$var$Builder.prototype.buildTextValNode = function(val, key, attrStr, level) {
    if (this.options.cdataPropName !== false && key === this.options.cdataPropName) return this.indentate(level) + `<![CDATA[${val}]]>` + this.newLine;
    else if (this.options.commentPropName !== false && key === this.options.commentPropName) return this.indentate(level) + `<!--${val}-->` + this.newLine;
    else if (key[0] === "?") return this.indentate(level) + '<' + key + attrStr + '?' + this.tagEndChar;
    else {
        let textValue = this.options.tagValueProcessor(key, val);
        textValue = this.replaceEntitiesValue(textValue);
        if (textValue === '') return this.indentate(level) + '<' + key + attrStr + this.closeTag(key) + this.tagEndChar;
        else return this.indentate(level) + '<' + key + attrStr + '>' + textValue + '</' + key + this.tagEndChar;
    }
};
$e16872f5117707b8$var$Builder.prototype.replaceEntitiesValue = function(textValue) {
    if (textValue && textValue.length > 0 && this.options.processEntities) for(let i = 0; i < this.options.entities.length; i++){
        const entity = this.options.entities[i];
        textValue = textValue.replace(entity.regex, entity.val);
    }
    return textValue;
};
function $e16872f5117707b8$var$indentate(level) {
    return this.options.indentBy.repeat(level);
}
function $e16872f5117707b8$var$isAttribute(name /*, options*/ ) {
    if (name.startsWith(this.options.attributeNamePrefix) && name !== this.options.textNodeName) return name.substr(this.attrPrefixLen);
    else return false;
}
$e16872f5117707b8$exports = $e16872f5117707b8$var$Builder;


$c0b54c0e081fbf21$exports = {
    XMLParser: $5a7d16e887191265$exports,
    XMLValidator: $74ca744e6015d210$exports,
    XMLBuilder: $e16872f5117707b8$exports
};



const $36d6e9d96fcb95af$export$9f31af2cd814b6c7 = (streamBody, context)=>(0, $4c5b77b7f021a981$export$3cc1021c6dfb9c3e)(streamBody, context).then((encoded)=>{
        if (encoded.length) {
            const parser = new (0, $c0b54c0e081fbf21$exports.XMLParser)({
                attributeNamePrefix: "",
                htmlEntities: true,
                ignoreAttributes: false,
                ignoreDeclaration: true,
                parseTagValue: false,
                trimValues: false,
                tagValueProcessor: (_, val)=>val.trim() === "" && val.includes("\n") ? "" : undefined
            });
            parser.addEntity("#xD", "\r");
            parser.addEntity("#10", "\n");
            let parsedObj;
            try {
                parsedObj = parser.parse(encoded, true);
            } catch (e) {
                if (e && typeof e === "object") Object.defineProperty(e, "$responseBodyText", {
                    value: encoded
                });
                throw e;
            }
            const textNodeName = "#text";
            const key = Object.keys(parsedObj)[0];
            const parsedObjToReturn = parsedObj[key];
            if (parsedObjToReturn[textNodeName]) {
                parsedObjToReturn[key] = parsedObjToReturn[textNodeName];
                delete parsedObjToReturn[textNodeName];
            }
            return (0, $530e8cd29c174186$export$113d90026b452881)(parsedObjToReturn);
        }
        return {};
    });
const $36d6e9d96fcb95af$export$bc3bfbea4e5d3440 = async (errorBody, context)=>{
    const value = await $36d6e9d96fcb95af$export$9f31af2cd814b6c7(errorBody, context);
    if (value.Error) value.Error.message = value.Error.message ?? value.Error.Message;
    return value;
};
const $36d6e9d96fcb95af$export$e5a272551bb5495c = (output, data)=>{
    if (data?.Error?.Code !== undefined) return data.Error.Code;
    if (data?.Code !== undefined) return data.Code;
    if (output.statusCode == 404) return "NotFound";
};






const $e27b8842ac3b4e2f$export$62b69ab13cc70aee = async (input, context)=>{
    const headers = $e27b8842ac3b4e2f$var$SHARED_HEADERS;
    let body;
    body = $e27b8842ac3b4e2f$var$buildFormUrlencodedString({
        ...$e27b8842ac3b4e2f$var$se_AssumeRoleRequest(input, context),
        [$e27b8842ac3b4e2f$var$_A]: $e27b8842ac3b4e2f$var$_AR,
        [$e27b8842ac3b4e2f$var$_V]: $e27b8842ac3b4e2f$var$_
    });
    return $e27b8842ac3b4e2f$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $e27b8842ac3b4e2f$export$a80569788d01bbce = async (input, context)=>{
    const headers = $e27b8842ac3b4e2f$var$SHARED_HEADERS;
    let body;
    body = $e27b8842ac3b4e2f$var$buildFormUrlencodedString({
        ...$e27b8842ac3b4e2f$var$se_AssumeRoleWithSAMLRequest(input, context),
        [$e27b8842ac3b4e2f$var$_A]: $e27b8842ac3b4e2f$var$_ARWSAML,
        [$e27b8842ac3b4e2f$var$_V]: $e27b8842ac3b4e2f$var$_
    });
    return $e27b8842ac3b4e2f$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $e27b8842ac3b4e2f$export$eced031c459ebd44 = async (input, context)=>{
    const headers = $e27b8842ac3b4e2f$var$SHARED_HEADERS;
    let body;
    body = $e27b8842ac3b4e2f$var$buildFormUrlencodedString({
        ...$e27b8842ac3b4e2f$var$se_AssumeRoleWithWebIdentityRequest(input, context),
        [$e27b8842ac3b4e2f$var$_A]: $e27b8842ac3b4e2f$var$_ARWWI,
        [$e27b8842ac3b4e2f$var$_V]: $e27b8842ac3b4e2f$var$_
    });
    return $e27b8842ac3b4e2f$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $e27b8842ac3b4e2f$export$a38e0304e189726c = async (input, context)=>{
    const headers = $e27b8842ac3b4e2f$var$SHARED_HEADERS;
    let body;
    body = $e27b8842ac3b4e2f$var$buildFormUrlencodedString({
        ...$e27b8842ac3b4e2f$var$se_AssumeRootRequest(input, context),
        [$e27b8842ac3b4e2f$var$_A]: $e27b8842ac3b4e2f$var$_ARs,
        [$e27b8842ac3b4e2f$var$_V]: $e27b8842ac3b4e2f$var$_
    });
    return $e27b8842ac3b4e2f$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $e27b8842ac3b4e2f$export$34aab171ef05cbf6 = async (input, context)=>{
    const headers = $e27b8842ac3b4e2f$var$SHARED_HEADERS;
    let body;
    body = $e27b8842ac3b4e2f$var$buildFormUrlencodedString({
        ...$e27b8842ac3b4e2f$var$se_DecodeAuthorizationMessageRequest(input, context),
        [$e27b8842ac3b4e2f$var$_A]: $e27b8842ac3b4e2f$var$_DAM,
        [$e27b8842ac3b4e2f$var$_V]: $e27b8842ac3b4e2f$var$_
    });
    return $e27b8842ac3b4e2f$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $e27b8842ac3b4e2f$export$6e8d13f576ae7b83 = async (input, context)=>{
    const headers = $e27b8842ac3b4e2f$var$SHARED_HEADERS;
    let body;
    body = $e27b8842ac3b4e2f$var$buildFormUrlencodedString({
        ...$e27b8842ac3b4e2f$var$se_GetAccessKeyInfoRequest(input, context),
        [$e27b8842ac3b4e2f$var$_A]: $e27b8842ac3b4e2f$var$_GAKI,
        [$e27b8842ac3b4e2f$var$_V]: $e27b8842ac3b4e2f$var$_
    });
    return $e27b8842ac3b4e2f$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $e27b8842ac3b4e2f$export$f73aba414538b962 = async (input, context)=>{
    const headers = $e27b8842ac3b4e2f$var$SHARED_HEADERS;
    let body;
    body = $e27b8842ac3b4e2f$var$buildFormUrlencodedString({
        ...$e27b8842ac3b4e2f$var$se_GetCallerIdentityRequest(input, context),
        [$e27b8842ac3b4e2f$var$_A]: $e27b8842ac3b4e2f$var$_GCI,
        [$e27b8842ac3b4e2f$var$_V]: $e27b8842ac3b4e2f$var$_
    });
    return $e27b8842ac3b4e2f$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $e27b8842ac3b4e2f$export$e2ba937891ce3ce0 = async (input, context)=>{
    const headers = $e27b8842ac3b4e2f$var$SHARED_HEADERS;
    let body;
    body = $e27b8842ac3b4e2f$var$buildFormUrlencodedString({
        ...$e27b8842ac3b4e2f$var$se_GetFederationTokenRequest(input, context),
        [$e27b8842ac3b4e2f$var$_A]: $e27b8842ac3b4e2f$var$_GFT,
        [$e27b8842ac3b4e2f$var$_V]: $e27b8842ac3b4e2f$var$_
    });
    return $e27b8842ac3b4e2f$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $e27b8842ac3b4e2f$export$f88c702332175777 = async (input, context)=>{
    const headers = $e27b8842ac3b4e2f$var$SHARED_HEADERS;
    let body;
    body = $e27b8842ac3b4e2f$var$buildFormUrlencodedString({
        ...$e27b8842ac3b4e2f$var$se_GetSessionTokenRequest(input, context),
        [$e27b8842ac3b4e2f$var$_A]: $e27b8842ac3b4e2f$var$_GST,
        [$e27b8842ac3b4e2f$var$_V]: $e27b8842ac3b4e2f$var$_
    });
    return $e27b8842ac3b4e2f$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $e27b8842ac3b4e2f$export$a1248a8af2a517a6 = async (output, context)=>{
    if (output.statusCode >= 300) return $e27b8842ac3b4e2f$var$de_CommandError(output, context);
    const data = await (0, $36d6e9d96fcb95af$export$9f31af2cd814b6c7)(output.body, context);
    let contents = {};
    contents = $e27b8842ac3b4e2f$var$de_AssumeRoleResponse(data.AssumeRoleResult, context);
    const response = {
        $metadata: $e27b8842ac3b4e2f$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $e27b8842ac3b4e2f$export$ba2cc6080a18f557 = async (output, context)=>{
    if (output.statusCode >= 300) return $e27b8842ac3b4e2f$var$de_CommandError(output, context);
    const data = await (0, $36d6e9d96fcb95af$export$9f31af2cd814b6c7)(output.body, context);
    let contents = {};
    contents = $e27b8842ac3b4e2f$var$de_AssumeRoleWithSAMLResponse(data.AssumeRoleWithSAMLResult, context);
    const response = {
        $metadata: $e27b8842ac3b4e2f$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $e27b8842ac3b4e2f$export$c445216e9de89804 = async (output, context)=>{
    if (output.statusCode >= 300) return $e27b8842ac3b4e2f$var$de_CommandError(output, context);
    const data = await (0, $36d6e9d96fcb95af$export$9f31af2cd814b6c7)(output.body, context);
    let contents = {};
    contents = $e27b8842ac3b4e2f$var$de_AssumeRoleWithWebIdentityResponse(data.AssumeRoleWithWebIdentityResult, context);
    const response = {
        $metadata: $e27b8842ac3b4e2f$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $e27b8842ac3b4e2f$export$f315e9b84abb921a = async (output, context)=>{
    if (output.statusCode >= 300) return $e27b8842ac3b4e2f$var$de_CommandError(output, context);
    const data = await (0, $36d6e9d96fcb95af$export$9f31af2cd814b6c7)(output.body, context);
    let contents = {};
    contents = $e27b8842ac3b4e2f$var$de_AssumeRootResponse(data.AssumeRootResult, context);
    const response = {
        $metadata: $e27b8842ac3b4e2f$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $e27b8842ac3b4e2f$export$256a89d44a96fc63 = async (output, context)=>{
    if (output.statusCode >= 300) return $e27b8842ac3b4e2f$var$de_CommandError(output, context);
    const data = await (0, $36d6e9d96fcb95af$export$9f31af2cd814b6c7)(output.body, context);
    let contents = {};
    contents = $e27b8842ac3b4e2f$var$de_DecodeAuthorizationMessageResponse(data.DecodeAuthorizationMessageResult, context);
    const response = {
        $metadata: $e27b8842ac3b4e2f$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $e27b8842ac3b4e2f$export$702238b1b0d317b2 = async (output, context)=>{
    if (output.statusCode >= 300) return $e27b8842ac3b4e2f$var$de_CommandError(output, context);
    const data = await (0, $36d6e9d96fcb95af$export$9f31af2cd814b6c7)(output.body, context);
    let contents = {};
    contents = $e27b8842ac3b4e2f$var$de_GetAccessKeyInfoResponse(data.GetAccessKeyInfoResult, context);
    const response = {
        $metadata: $e27b8842ac3b4e2f$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $e27b8842ac3b4e2f$export$c3f1c43a13473460 = async (output, context)=>{
    if (output.statusCode >= 300) return $e27b8842ac3b4e2f$var$de_CommandError(output, context);
    const data = await (0, $36d6e9d96fcb95af$export$9f31af2cd814b6c7)(output.body, context);
    let contents = {};
    contents = $e27b8842ac3b4e2f$var$de_GetCallerIdentityResponse(data.GetCallerIdentityResult, context);
    const response = {
        $metadata: $e27b8842ac3b4e2f$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $e27b8842ac3b4e2f$export$3bdf484b4ba04836 = async (output, context)=>{
    if (output.statusCode >= 300) return $e27b8842ac3b4e2f$var$de_CommandError(output, context);
    const data = await (0, $36d6e9d96fcb95af$export$9f31af2cd814b6c7)(output.body, context);
    let contents = {};
    contents = $e27b8842ac3b4e2f$var$de_GetFederationTokenResponse(data.GetFederationTokenResult, context);
    const response = {
        $metadata: $e27b8842ac3b4e2f$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $e27b8842ac3b4e2f$export$4ec4187dc69df77b = async (output, context)=>{
    if (output.statusCode >= 300) return $e27b8842ac3b4e2f$var$de_CommandError(output, context);
    const data = await (0, $36d6e9d96fcb95af$export$9f31af2cd814b6c7)(output.body, context);
    let contents = {};
    contents = $e27b8842ac3b4e2f$var$de_GetSessionTokenResponse(data.GetSessionTokenResult, context);
    const response = {
        $metadata: $e27b8842ac3b4e2f$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $e27b8842ac3b4e2f$var$de_CommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await (0, $36d6e9d96fcb95af$export$bc3bfbea4e5d3440)(output.body, context)
    };
    const errorCode = $e27b8842ac3b4e2f$var$loadQueryErrorCode(output, parsedOutput.body);
    switch(errorCode){
        case "ExpiredTokenException":
        case "com.amazonaws.sts#ExpiredTokenException":
            throw await $e27b8842ac3b4e2f$var$de_ExpiredTokenExceptionRes(parsedOutput, context);
        case "MalformedPolicyDocument":
        case "com.amazonaws.sts#MalformedPolicyDocumentException":
            throw await $e27b8842ac3b4e2f$var$de_MalformedPolicyDocumentExceptionRes(parsedOutput, context);
        case "PackedPolicyTooLarge":
        case "com.amazonaws.sts#PackedPolicyTooLargeException":
            throw await $e27b8842ac3b4e2f$var$de_PackedPolicyTooLargeExceptionRes(parsedOutput, context);
        case "RegionDisabledException":
        case "com.amazonaws.sts#RegionDisabledException":
            throw await $e27b8842ac3b4e2f$var$de_RegionDisabledExceptionRes(parsedOutput, context);
        case "IDPRejectedClaim":
        case "com.amazonaws.sts#IDPRejectedClaimException":
            throw await $e27b8842ac3b4e2f$var$de_IDPRejectedClaimExceptionRes(parsedOutput, context);
        case "InvalidIdentityToken":
        case "com.amazonaws.sts#InvalidIdentityTokenException":
            throw await $e27b8842ac3b4e2f$var$de_InvalidIdentityTokenExceptionRes(parsedOutput, context);
        case "IDPCommunicationError":
        case "com.amazonaws.sts#IDPCommunicationErrorException":
            throw await $e27b8842ac3b4e2f$var$de_IDPCommunicationErrorExceptionRes(parsedOutput, context);
        case "InvalidAuthorizationMessageException":
        case "com.amazonaws.sts#InvalidAuthorizationMessageException":
            throw await $e27b8842ac3b4e2f$var$de_InvalidAuthorizationMessageExceptionRes(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            return $e27b8842ac3b4e2f$var$throwDefaultError({
                output: output,
                parsedBody: parsedBody.Error,
                errorCode: errorCode
            });
    }
};
const $e27b8842ac3b4e2f$var$de_ExpiredTokenExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = $e27b8842ac3b4e2f$var$de_ExpiredTokenException(body.Error, context);
    const exception = new (0, $7e701853b65411f4$export$fa1220c5081036a1)({
        $metadata: $e27b8842ac3b4e2f$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, body);
};
const $e27b8842ac3b4e2f$var$de_IDPCommunicationErrorExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = $e27b8842ac3b4e2f$var$de_IDPCommunicationErrorException(body.Error, context);
    const exception = new (0, $7e701853b65411f4$export$9b2a7b36a0ed491a)({
        $metadata: $e27b8842ac3b4e2f$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, body);
};
const $e27b8842ac3b4e2f$var$de_IDPRejectedClaimExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = $e27b8842ac3b4e2f$var$de_IDPRejectedClaimException(body.Error, context);
    const exception = new (0, $7e701853b65411f4$export$929ade002d483fe9)({
        $metadata: $e27b8842ac3b4e2f$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, body);
};
const $e27b8842ac3b4e2f$var$de_InvalidAuthorizationMessageExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = $e27b8842ac3b4e2f$var$de_InvalidAuthorizationMessageException(body.Error, context);
    const exception = new (0, $7e701853b65411f4$export$260cc625473883b6)({
        $metadata: $e27b8842ac3b4e2f$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, body);
};
const $e27b8842ac3b4e2f$var$de_InvalidIdentityTokenExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = $e27b8842ac3b4e2f$var$de_InvalidIdentityTokenException(body.Error, context);
    const exception = new (0, $7e701853b65411f4$export$6703f62d64df85c)({
        $metadata: $e27b8842ac3b4e2f$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, body);
};
const $e27b8842ac3b4e2f$var$de_MalformedPolicyDocumentExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = $e27b8842ac3b4e2f$var$de_MalformedPolicyDocumentException(body.Error, context);
    const exception = new (0, $7e701853b65411f4$export$22b3b5837037e750)({
        $metadata: $e27b8842ac3b4e2f$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, body);
};
const $e27b8842ac3b4e2f$var$de_PackedPolicyTooLargeExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = $e27b8842ac3b4e2f$var$de_PackedPolicyTooLargeException(body.Error, context);
    const exception = new (0, $7e701853b65411f4$export$bc7ad180e2a70628)({
        $metadata: $e27b8842ac3b4e2f$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, body);
};
const $e27b8842ac3b4e2f$var$de_RegionDisabledExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = $e27b8842ac3b4e2f$var$de_RegionDisabledException(body.Error, context);
    const exception = new (0, $7e701853b65411f4$export$bdd8424b8237388d)({
        $metadata: $e27b8842ac3b4e2f$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, body);
};
const $e27b8842ac3b4e2f$var$se_AssumeRoleRequest = (input, context)=>{
    const entries = {};
    if (input[$e27b8842ac3b4e2f$var$_RA] != null) entries[$e27b8842ac3b4e2f$var$_RA] = input[$e27b8842ac3b4e2f$var$_RA];
    if (input[$e27b8842ac3b4e2f$var$_RSN] != null) entries[$e27b8842ac3b4e2f$var$_RSN] = input[$e27b8842ac3b4e2f$var$_RSN];
    if (input[$e27b8842ac3b4e2f$var$_PA] != null) {
        const memberEntries = $e27b8842ac3b4e2f$var$se_policyDescriptorListType(input[$e27b8842ac3b4e2f$var$_PA], context);
        if (input[$e27b8842ac3b4e2f$var$_PA]?.length === 0) entries.PolicyArns = [];
        Object.entries(memberEntries).forEach(([key, value])=>{
            const loc = `PolicyArns.${key}`;
            entries[loc] = value;
        });
    }
    if (input[$e27b8842ac3b4e2f$var$_P] != null) entries[$e27b8842ac3b4e2f$var$_P] = input[$e27b8842ac3b4e2f$var$_P];
    if (input[$e27b8842ac3b4e2f$var$_DS] != null) entries[$e27b8842ac3b4e2f$var$_DS] = input[$e27b8842ac3b4e2f$var$_DS];
    if (input[$e27b8842ac3b4e2f$var$_T] != null) {
        const memberEntries = $e27b8842ac3b4e2f$var$se_tagListType(input[$e27b8842ac3b4e2f$var$_T], context);
        if (input[$e27b8842ac3b4e2f$var$_T]?.length === 0) entries.Tags = [];
        Object.entries(memberEntries).forEach(([key, value])=>{
            const loc = `Tags.${key}`;
            entries[loc] = value;
        });
    }
    if (input[$e27b8842ac3b4e2f$var$_TTK] != null) {
        const memberEntries = $e27b8842ac3b4e2f$var$se_tagKeyListType(input[$e27b8842ac3b4e2f$var$_TTK], context);
        if (input[$e27b8842ac3b4e2f$var$_TTK]?.length === 0) entries.TransitiveTagKeys = [];
        Object.entries(memberEntries).forEach(([key, value])=>{
            const loc = `TransitiveTagKeys.${key}`;
            entries[loc] = value;
        });
    }
    if (input[$e27b8842ac3b4e2f$var$_EI] != null) entries[$e27b8842ac3b4e2f$var$_EI] = input[$e27b8842ac3b4e2f$var$_EI];
    if (input[$e27b8842ac3b4e2f$var$_SN] != null) entries[$e27b8842ac3b4e2f$var$_SN] = input[$e27b8842ac3b4e2f$var$_SN];
    if (input[$e27b8842ac3b4e2f$var$_TC] != null) entries[$e27b8842ac3b4e2f$var$_TC] = input[$e27b8842ac3b4e2f$var$_TC];
    if (input[$e27b8842ac3b4e2f$var$_SI] != null) entries[$e27b8842ac3b4e2f$var$_SI] = input[$e27b8842ac3b4e2f$var$_SI];
    if (input[$e27b8842ac3b4e2f$var$_PC] != null) {
        const memberEntries = $e27b8842ac3b4e2f$var$se_ProvidedContextsListType(input[$e27b8842ac3b4e2f$var$_PC], context);
        if (input[$e27b8842ac3b4e2f$var$_PC]?.length === 0) entries.ProvidedContexts = [];
        Object.entries(memberEntries).forEach(([key, value])=>{
            const loc = `ProvidedContexts.${key}`;
            entries[loc] = value;
        });
    }
    return entries;
};
const $e27b8842ac3b4e2f$var$se_AssumeRoleWithSAMLRequest = (input, context)=>{
    const entries = {};
    if (input[$e27b8842ac3b4e2f$var$_RA] != null) entries[$e27b8842ac3b4e2f$var$_RA] = input[$e27b8842ac3b4e2f$var$_RA];
    if (input[$e27b8842ac3b4e2f$var$_PAr] != null) entries[$e27b8842ac3b4e2f$var$_PAr] = input[$e27b8842ac3b4e2f$var$_PAr];
    if (input[$e27b8842ac3b4e2f$var$_SAMLA] != null) entries[$e27b8842ac3b4e2f$var$_SAMLA] = input[$e27b8842ac3b4e2f$var$_SAMLA];
    if (input[$e27b8842ac3b4e2f$var$_PA] != null) {
        const memberEntries = $e27b8842ac3b4e2f$var$se_policyDescriptorListType(input[$e27b8842ac3b4e2f$var$_PA], context);
        if (input[$e27b8842ac3b4e2f$var$_PA]?.length === 0) entries.PolicyArns = [];
        Object.entries(memberEntries).forEach(([key, value])=>{
            const loc = `PolicyArns.${key}`;
            entries[loc] = value;
        });
    }
    if (input[$e27b8842ac3b4e2f$var$_P] != null) entries[$e27b8842ac3b4e2f$var$_P] = input[$e27b8842ac3b4e2f$var$_P];
    if (input[$e27b8842ac3b4e2f$var$_DS] != null) entries[$e27b8842ac3b4e2f$var$_DS] = input[$e27b8842ac3b4e2f$var$_DS];
    return entries;
};
const $e27b8842ac3b4e2f$var$se_AssumeRoleWithWebIdentityRequest = (input, context)=>{
    const entries = {};
    if (input[$e27b8842ac3b4e2f$var$_RA] != null) entries[$e27b8842ac3b4e2f$var$_RA] = input[$e27b8842ac3b4e2f$var$_RA];
    if (input[$e27b8842ac3b4e2f$var$_RSN] != null) entries[$e27b8842ac3b4e2f$var$_RSN] = input[$e27b8842ac3b4e2f$var$_RSN];
    if (input[$e27b8842ac3b4e2f$var$_WIT] != null) entries[$e27b8842ac3b4e2f$var$_WIT] = input[$e27b8842ac3b4e2f$var$_WIT];
    if (input[$e27b8842ac3b4e2f$var$_PI] != null) entries[$e27b8842ac3b4e2f$var$_PI] = input[$e27b8842ac3b4e2f$var$_PI];
    if (input[$e27b8842ac3b4e2f$var$_PA] != null) {
        const memberEntries = $e27b8842ac3b4e2f$var$se_policyDescriptorListType(input[$e27b8842ac3b4e2f$var$_PA], context);
        if (input[$e27b8842ac3b4e2f$var$_PA]?.length === 0) entries.PolicyArns = [];
        Object.entries(memberEntries).forEach(([key, value])=>{
            const loc = `PolicyArns.${key}`;
            entries[loc] = value;
        });
    }
    if (input[$e27b8842ac3b4e2f$var$_P] != null) entries[$e27b8842ac3b4e2f$var$_P] = input[$e27b8842ac3b4e2f$var$_P];
    if (input[$e27b8842ac3b4e2f$var$_DS] != null) entries[$e27b8842ac3b4e2f$var$_DS] = input[$e27b8842ac3b4e2f$var$_DS];
    return entries;
};
const $e27b8842ac3b4e2f$var$se_AssumeRootRequest = (input, context)=>{
    const entries = {};
    if (input[$e27b8842ac3b4e2f$var$_TP] != null) entries[$e27b8842ac3b4e2f$var$_TP] = input[$e27b8842ac3b4e2f$var$_TP];
    if (input[$e27b8842ac3b4e2f$var$_TPA] != null) {
        const memberEntries = $e27b8842ac3b4e2f$var$se_PolicyDescriptorType(input[$e27b8842ac3b4e2f$var$_TPA], context);
        Object.entries(memberEntries).forEach(([key, value])=>{
            const loc = `TaskPolicyArn.${key}`;
            entries[loc] = value;
        });
    }
    if (input[$e27b8842ac3b4e2f$var$_DS] != null) entries[$e27b8842ac3b4e2f$var$_DS] = input[$e27b8842ac3b4e2f$var$_DS];
    return entries;
};
const $e27b8842ac3b4e2f$var$se_DecodeAuthorizationMessageRequest = (input, context)=>{
    const entries = {};
    if (input[$e27b8842ac3b4e2f$var$_EM] != null) entries[$e27b8842ac3b4e2f$var$_EM] = input[$e27b8842ac3b4e2f$var$_EM];
    return entries;
};
const $e27b8842ac3b4e2f$var$se_GetAccessKeyInfoRequest = (input, context)=>{
    const entries = {};
    if (input[$e27b8842ac3b4e2f$var$_AKI] != null) entries[$e27b8842ac3b4e2f$var$_AKI] = input[$e27b8842ac3b4e2f$var$_AKI];
    return entries;
};
const $e27b8842ac3b4e2f$var$se_GetCallerIdentityRequest = (input, context)=>{
    const entries = {};
    return entries;
};
const $e27b8842ac3b4e2f$var$se_GetFederationTokenRequest = (input, context)=>{
    const entries = {};
    if (input[$e27b8842ac3b4e2f$var$_N] != null) entries[$e27b8842ac3b4e2f$var$_N] = input[$e27b8842ac3b4e2f$var$_N];
    if (input[$e27b8842ac3b4e2f$var$_P] != null) entries[$e27b8842ac3b4e2f$var$_P] = input[$e27b8842ac3b4e2f$var$_P];
    if (input[$e27b8842ac3b4e2f$var$_PA] != null) {
        const memberEntries = $e27b8842ac3b4e2f$var$se_policyDescriptorListType(input[$e27b8842ac3b4e2f$var$_PA], context);
        if (input[$e27b8842ac3b4e2f$var$_PA]?.length === 0) entries.PolicyArns = [];
        Object.entries(memberEntries).forEach(([key, value])=>{
            const loc = `PolicyArns.${key}`;
            entries[loc] = value;
        });
    }
    if (input[$e27b8842ac3b4e2f$var$_DS] != null) entries[$e27b8842ac3b4e2f$var$_DS] = input[$e27b8842ac3b4e2f$var$_DS];
    if (input[$e27b8842ac3b4e2f$var$_T] != null) {
        const memberEntries = $e27b8842ac3b4e2f$var$se_tagListType(input[$e27b8842ac3b4e2f$var$_T], context);
        if (input[$e27b8842ac3b4e2f$var$_T]?.length === 0) entries.Tags = [];
        Object.entries(memberEntries).forEach(([key, value])=>{
            const loc = `Tags.${key}`;
            entries[loc] = value;
        });
    }
    return entries;
};
const $e27b8842ac3b4e2f$var$se_GetSessionTokenRequest = (input, context)=>{
    const entries = {};
    if (input[$e27b8842ac3b4e2f$var$_DS] != null) entries[$e27b8842ac3b4e2f$var$_DS] = input[$e27b8842ac3b4e2f$var$_DS];
    if (input[$e27b8842ac3b4e2f$var$_SN] != null) entries[$e27b8842ac3b4e2f$var$_SN] = input[$e27b8842ac3b4e2f$var$_SN];
    if (input[$e27b8842ac3b4e2f$var$_TC] != null) entries[$e27b8842ac3b4e2f$var$_TC] = input[$e27b8842ac3b4e2f$var$_TC];
    return entries;
};
const $e27b8842ac3b4e2f$var$se_policyDescriptorListType = (input, context)=>{
    const entries = {};
    let counter = 1;
    for (const entry of input){
        if (entry === null) continue;
        const memberEntries = $e27b8842ac3b4e2f$var$se_PolicyDescriptorType(entry, context);
        Object.entries(memberEntries).forEach(([key, value])=>{
            entries[`member.${counter}.${key}`] = value;
        });
        counter++;
    }
    return entries;
};
const $e27b8842ac3b4e2f$var$se_PolicyDescriptorType = (input, context)=>{
    const entries = {};
    if (input[$e27b8842ac3b4e2f$var$_a] != null) entries[$e27b8842ac3b4e2f$var$_a] = input[$e27b8842ac3b4e2f$var$_a];
    return entries;
};
const $e27b8842ac3b4e2f$var$se_ProvidedContext = (input, context)=>{
    const entries = {};
    if (input[$e27b8842ac3b4e2f$var$_PAro] != null) entries[$e27b8842ac3b4e2f$var$_PAro] = input[$e27b8842ac3b4e2f$var$_PAro];
    if (input[$e27b8842ac3b4e2f$var$_CA] != null) entries[$e27b8842ac3b4e2f$var$_CA] = input[$e27b8842ac3b4e2f$var$_CA];
    return entries;
};
const $e27b8842ac3b4e2f$var$se_ProvidedContextsListType = (input, context)=>{
    const entries = {};
    let counter = 1;
    for (const entry of input){
        if (entry === null) continue;
        const memberEntries = $e27b8842ac3b4e2f$var$se_ProvidedContext(entry, context);
        Object.entries(memberEntries).forEach(([key, value])=>{
            entries[`member.${counter}.${key}`] = value;
        });
        counter++;
    }
    return entries;
};
const $e27b8842ac3b4e2f$var$se_Tag = (input, context)=>{
    const entries = {};
    if (input[$e27b8842ac3b4e2f$var$_K] != null) entries[$e27b8842ac3b4e2f$var$_K] = input[$e27b8842ac3b4e2f$var$_K];
    if (input[$e27b8842ac3b4e2f$var$_Va] != null) entries[$e27b8842ac3b4e2f$var$_Va] = input[$e27b8842ac3b4e2f$var$_Va];
    return entries;
};
const $e27b8842ac3b4e2f$var$se_tagKeyListType = (input, context)=>{
    const entries = {};
    let counter = 1;
    for (const entry of input){
        if (entry === null) continue;
        entries[`member.${counter}`] = entry;
        counter++;
    }
    return entries;
};
const $e27b8842ac3b4e2f$var$se_tagListType = (input, context)=>{
    const entries = {};
    let counter = 1;
    for (const entry of input){
        if (entry === null) continue;
        const memberEntries = $e27b8842ac3b4e2f$var$se_Tag(entry, context);
        Object.entries(memberEntries).forEach(([key, value])=>{
            entries[`member.${counter}.${key}`] = value;
        });
        counter++;
    }
    return entries;
};
const $e27b8842ac3b4e2f$var$de_AssumedRoleUser = (output, context)=>{
    const contents = {};
    if (output[$e27b8842ac3b4e2f$var$_ARI] != null) contents[$e27b8842ac3b4e2f$var$_ARI] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_ARI]);
    if (output[$e27b8842ac3b4e2f$var$_Ar] != null) contents[$e27b8842ac3b4e2f$var$_Ar] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_Ar]);
    return contents;
};
const $e27b8842ac3b4e2f$var$de_AssumeRoleResponse = (output, context)=>{
    const contents = {};
    if (output[$e27b8842ac3b4e2f$var$_C] != null) contents[$e27b8842ac3b4e2f$var$_C] = $e27b8842ac3b4e2f$var$de_Credentials(output[$e27b8842ac3b4e2f$var$_C], context);
    if (output[$e27b8842ac3b4e2f$var$_ARU] != null) contents[$e27b8842ac3b4e2f$var$_ARU] = $e27b8842ac3b4e2f$var$de_AssumedRoleUser(output[$e27b8842ac3b4e2f$var$_ARU], context);
    if (output[$e27b8842ac3b4e2f$var$_PPS] != null) contents[$e27b8842ac3b4e2f$var$_PPS] = (0, $25d854afa944ccce$export$c3c2f00b115709e6)(output[$e27b8842ac3b4e2f$var$_PPS]);
    if (output[$e27b8842ac3b4e2f$var$_SI] != null) contents[$e27b8842ac3b4e2f$var$_SI] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_SI]);
    return contents;
};
const $e27b8842ac3b4e2f$var$de_AssumeRoleWithSAMLResponse = (output, context)=>{
    const contents = {};
    if (output[$e27b8842ac3b4e2f$var$_C] != null) contents[$e27b8842ac3b4e2f$var$_C] = $e27b8842ac3b4e2f$var$de_Credentials(output[$e27b8842ac3b4e2f$var$_C], context);
    if (output[$e27b8842ac3b4e2f$var$_ARU] != null) contents[$e27b8842ac3b4e2f$var$_ARU] = $e27b8842ac3b4e2f$var$de_AssumedRoleUser(output[$e27b8842ac3b4e2f$var$_ARU], context);
    if (output[$e27b8842ac3b4e2f$var$_PPS] != null) contents[$e27b8842ac3b4e2f$var$_PPS] = (0, $25d854afa944ccce$export$c3c2f00b115709e6)(output[$e27b8842ac3b4e2f$var$_PPS]);
    if (output[$e27b8842ac3b4e2f$var$_S] != null) contents[$e27b8842ac3b4e2f$var$_S] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_S]);
    if (output[$e27b8842ac3b4e2f$var$_ST] != null) contents[$e27b8842ac3b4e2f$var$_ST] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_ST]);
    if (output[$e27b8842ac3b4e2f$var$_I] != null) contents[$e27b8842ac3b4e2f$var$_I] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_I]);
    if (output[$e27b8842ac3b4e2f$var$_Au] != null) contents[$e27b8842ac3b4e2f$var$_Au] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_Au]);
    if (output[$e27b8842ac3b4e2f$var$_NQ] != null) contents[$e27b8842ac3b4e2f$var$_NQ] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_NQ]);
    if (output[$e27b8842ac3b4e2f$var$_SI] != null) contents[$e27b8842ac3b4e2f$var$_SI] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_SI]);
    return contents;
};
const $e27b8842ac3b4e2f$var$de_AssumeRoleWithWebIdentityResponse = (output, context)=>{
    const contents = {};
    if (output[$e27b8842ac3b4e2f$var$_C] != null) contents[$e27b8842ac3b4e2f$var$_C] = $e27b8842ac3b4e2f$var$de_Credentials(output[$e27b8842ac3b4e2f$var$_C], context);
    if (output[$e27b8842ac3b4e2f$var$_SFWIT] != null) contents[$e27b8842ac3b4e2f$var$_SFWIT] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_SFWIT]);
    if (output[$e27b8842ac3b4e2f$var$_ARU] != null) contents[$e27b8842ac3b4e2f$var$_ARU] = $e27b8842ac3b4e2f$var$de_AssumedRoleUser(output[$e27b8842ac3b4e2f$var$_ARU], context);
    if (output[$e27b8842ac3b4e2f$var$_PPS] != null) contents[$e27b8842ac3b4e2f$var$_PPS] = (0, $25d854afa944ccce$export$c3c2f00b115709e6)(output[$e27b8842ac3b4e2f$var$_PPS]);
    if (output[$e27b8842ac3b4e2f$var$_Pr] != null) contents[$e27b8842ac3b4e2f$var$_Pr] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_Pr]);
    if (output[$e27b8842ac3b4e2f$var$_Au] != null) contents[$e27b8842ac3b4e2f$var$_Au] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_Au]);
    if (output[$e27b8842ac3b4e2f$var$_SI] != null) contents[$e27b8842ac3b4e2f$var$_SI] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_SI]);
    return contents;
};
const $e27b8842ac3b4e2f$var$de_AssumeRootResponse = (output, context)=>{
    const contents = {};
    if (output[$e27b8842ac3b4e2f$var$_C] != null) contents[$e27b8842ac3b4e2f$var$_C] = $e27b8842ac3b4e2f$var$de_Credentials(output[$e27b8842ac3b4e2f$var$_C], context);
    if (output[$e27b8842ac3b4e2f$var$_SI] != null) contents[$e27b8842ac3b4e2f$var$_SI] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_SI]);
    return contents;
};
const $e27b8842ac3b4e2f$var$de_Credentials = (output, context)=>{
    const contents = {};
    if (output[$e27b8842ac3b4e2f$var$_AKI] != null) contents[$e27b8842ac3b4e2f$var$_AKI] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_AKI]);
    if (output[$e27b8842ac3b4e2f$var$_SAK] != null) contents[$e27b8842ac3b4e2f$var$_SAK] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_SAK]);
    if (output[$e27b8842ac3b4e2f$var$_STe] != null) contents[$e27b8842ac3b4e2f$var$_STe] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_STe]);
    if (output[$e27b8842ac3b4e2f$var$_E] != null) contents[$e27b8842ac3b4e2f$var$_E] = (0, $25d854afa944ccce$export$8413a63dbe548a49)((0, $d8696255fcc0b769$export$3cb821e2875b4b7d)(output[$e27b8842ac3b4e2f$var$_E]));
    return contents;
};
const $e27b8842ac3b4e2f$var$de_DecodeAuthorizationMessageResponse = (output, context)=>{
    const contents = {};
    if (output[$e27b8842ac3b4e2f$var$_DM] != null) contents[$e27b8842ac3b4e2f$var$_DM] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_DM]);
    return contents;
};
const $e27b8842ac3b4e2f$var$de_ExpiredTokenException = (output, context)=>{
    const contents = {};
    if (output[$e27b8842ac3b4e2f$var$_m] != null) contents[$e27b8842ac3b4e2f$var$_m] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_m]);
    return contents;
};
const $e27b8842ac3b4e2f$var$de_FederatedUser = (output, context)=>{
    const contents = {};
    if (output[$e27b8842ac3b4e2f$var$_FUI] != null) contents[$e27b8842ac3b4e2f$var$_FUI] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_FUI]);
    if (output[$e27b8842ac3b4e2f$var$_Ar] != null) contents[$e27b8842ac3b4e2f$var$_Ar] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_Ar]);
    return contents;
};
const $e27b8842ac3b4e2f$var$de_GetAccessKeyInfoResponse = (output, context)=>{
    const contents = {};
    if (output[$e27b8842ac3b4e2f$var$_Ac] != null) contents[$e27b8842ac3b4e2f$var$_Ac] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_Ac]);
    return contents;
};
const $e27b8842ac3b4e2f$var$de_GetCallerIdentityResponse = (output, context)=>{
    const contents = {};
    if (output[$e27b8842ac3b4e2f$var$_UI] != null) contents[$e27b8842ac3b4e2f$var$_UI] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_UI]);
    if (output[$e27b8842ac3b4e2f$var$_Ac] != null) contents[$e27b8842ac3b4e2f$var$_Ac] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_Ac]);
    if (output[$e27b8842ac3b4e2f$var$_Ar] != null) contents[$e27b8842ac3b4e2f$var$_Ar] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_Ar]);
    return contents;
};
const $e27b8842ac3b4e2f$var$de_GetFederationTokenResponse = (output, context)=>{
    const contents = {};
    if (output[$e27b8842ac3b4e2f$var$_C] != null) contents[$e27b8842ac3b4e2f$var$_C] = $e27b8842ac3b4e2f$var$de_Credentials(output[$e27b8842ac3b4e2f$var$_C], context);
    if (output[$e27b8842ac3b4e2f$var$_FU] != null) contents[$e27b8842ac3b4e2f$var$_FU] = $e27b8842ac3b4e2f$var$de_FederatedUser(output[$e27b8842ac3b4e2f$var$_FU], context);
    if (output[$e27b8842ac3b4e2f$var$_PPS] != null) contents[$e27b8842ac3b4e2f$var$_PPS] = (0, $25d854afa944ccce$export$c3c2f00b115709e6)(output[$e27b8842ac3b4e2f$var$_PPS]);
    return contents;
};
const $e27b8842ac3b4e2f$var$de_GetSessionTokenResponse = (output, context)=>{
    const contents = {};
    if (output[$e27b8842ac3b4e2f$var$_C] != null) contents[$e27b8842ac3b4e2f$var$_C] = $e27b8842ac3b4e2f$var$de_Credentials(output[$e27b8842ac3b4e2f$var$_C], context);
    return contents;
};
const $e27b8842ac3b4e2f$var$de_IDPCommunicationErrorException = (output, context)=>{
    const contents = {};
    if (output[$e27b8842ac3b4e2f$var$_m] != null) contents[$e27b8842ac3b4e2f$var$_m] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_m]);
    return contents;
};
const $e27b8842ac3b4e2f$var$de_IDPRejectedClaimException = (output, context)=>{
    const contents = {};
    if (output[$e27b8842ac3b4e2f$var$_m] != null) contents[$e27b8842ac3b4e2f$var$_m] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_m]);
    return contents;
};
const $e27b8842ac3b4e2f$var$de_InvalidAuthorizationMessageException = (output, context)=>{
    const contents = {};
    if (output[$e27b8842ac3b4e2f$var$_m] != null) contents[$e27b8842ac3b4e2f$var$_m] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_m]);
    return contents;
};
const $e27b8842ac3b4e2f$var$de_InvalidIdentityTokenException = (output, context)=>{
    const contents = {};
    if (output[$e27b8842ac3b4e2f$var$_m] != null) contents[$e27b8842ac3b4e2f$var$_m] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_m]);
    return contents;
};
const $e27b8842ac3b4e2f$var$de_MalformedPolicyDocumentException = (output, context)=>{
    const contents = {};
    if (output[$e27b8842ac3b4e2f$var$_m] != null) contents[$e27b8842ac3b4e2f$var$_m] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_m]);
    return contents;
};
const $e27b8842ac3b4e2f$var$de_PackedPolicyTooLargeException = (output, context)=>{
    const contents = {};
    if (output[$e27b8842ac3b4e2f$var$_m] != null) contents[$e27b8842ac3b4e2f$var$_m] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_m]);
    return contents;
};
const $e27b8842ac3b4e2f$var$de_RegionDisabledException = (output, context)=>{
    const contents = {};
    if (output[$e27b8842ac3b4e2f$var$_m] != null) contents[$e27b8842ac3b4e2f$var$_m] = (0, $25d854afa944ccce$export$7ed80f53fe336639)(output[$e27b8842ac3b4e2f$var$_m]);
    return contents;
};
const $e27b8842ac3b4e2f$var$deserializeMetadata = (output)=>({
        httpStatusCode: output.statusCode,
        requestId: output.headers["x-amzn-requestid"] ?? output.headers["x-amzn-request-id"] ?? output.headers["x-amz-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    });
const $e27b8842ac3b4e2f$var$collectBodyString = (streamBody, context)=>(0, $7667c5ed780ba41a$export$3392bcddb824e5ca)(streamBody, context).then((body)=>context.utf8Encoder(body));
const $e27b8842ac3b4e2f$var$throwDefaultError = (0, $1a84bff7daff0761$export$62ac8acba1748a85)((0, $a2ec4191a788c017$export$a18f5bef84fc19ec));
const $e27b8842ac3b4e2f$var$buildHttpRpcRequest = async (context, headers, path, resolvedHostname, body)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const contents = {
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "POST",
        path: basePath.endsWith("/") ? basePath.slice(0, -1) + path : basePath + path,
        headers: headers
    };
    if (resolvedHostname !== undefined) contents.hostname = resolvedHostname;
    if (body !== undefined) contents.body = body;
    return new (0, $36c92c5bbc6e0688$export$7587955500404ec3)(contents);
};
const $e27b8842ac3b4e2f$var$SHARED_HEADERS = {
    "content-type": "application/x-www-form-urlencoded"
};
const $e27b8842ac3b4e2f$var$_ = "2011-06-15";
const $e27b8842ac3b4e2f$var$_A = "Action";
const $e27b8842ac3b4e2f$var$_AKI = "AccessKeyId";
const $e27b8842ac3b4e2f$var$_AR = "AssumeRole";
const $e27b8842ac3b4e2f$var$_ARI = "AssumedRoleId";
const $e27b8842ac3b4e2f$var$_ARU = "AssumedRoleUser";
const $e27b8842ac3b4e2f$var$_ARWSAML = "AssumeRoleWithSAML";
const $e27b8842ac3b4e2f$var$_ARWWI = "AssumeRoleWithWebIdentity";
const $e27b8842ac3b4e2f$var$_ARs = "AssumeRoot";
const $e27b8842ac3b4e2f$var$_Ac = "Account";
const $e27b8842ac3b4e2f$var$_Ar = "Arn";
const $e27b8842ac3b4e2f$var$_Au = "Audience";
const $e27b8842ac3b4e2f$var$_C = "Credentials";
const $e27b8842ac3b4e2f$var$_CA = "ContextAssertion";
const $e27b8842ac3b4e2f$var$_DAM = "DecodeAuthorizationMessage";
const $e27b8842ac3b4e2f$var$_DM = "DecodedMessage";
const $e27b8842ac3b4e2f$var$_DS = "DurationSeconds";
const $e27b8842ac3b4e2f$var$_E = "Expiration";
const $e27b8842ac3b4e2f$var$_EI = "ExternalId";
const $e27b8842ac3b4e2f$var$_EM = "EncodedMessage";
const $e27b8842ac3b4e2f$var$_FU = "FederatedUser";
const $e27b8842ac3b4e2f$var$_FUI = "FederatedUserId";
const $e27b8842ac3b4e2f$var$_GAKI = "GetAccessKeyInfo";
const $e27b8842ac3b4e2f$var$_GCI = "GetCallerIdentity";
const $e27b8842ac3b4e2f$var$_GFT = "GetFederationToken";
const $e27b8842ac3b4e2f$var$_GST = "GetSessionToken";
const $e27b8842ac3b4e2f$var$_I = "Issuer";
const $e27b8842ac3b4e2f$var$_K = "Key";
const $e27b8842ac3b4e2f$var$_N = "Name";
const $e27b8842ac3b4e2f$var$_NQ = "NameQualifier";
const $e27b8842ac3b4e2f$var$_P = "Policy";
const $e27b8842ac3b4e2f$var$_PA = "PolicyArns";
const $e27b8842ac3b4e2f$var$_PAr = "PrincipalArn";
const $e27b8842ac3b4e2f$var$_PAro = "ProviderArn";
const $e27b8842ac3b4e2f$var$_PC = "ProvidedContexts";
const $e27b8842ac3b4e2f$var$_PI = "ProviderId";
const $e27b8842ac3b4e2f$var$_PPS = "PackedPolicySize";
const $e27b8842ac3b4e2f$var$_Pr = "Provider";
const $e27b8842ac3b4e2f$var$_RA = "RoleArn";
const $e27b8842ac3b4e2f$var$_RSN = "RoleSessionName";
const $e27b8842ac3b4e2f$var$_S = "Subject";
const $e27b8842ac3b4e2f$var$_SAK = "SecretAccessKey";
const $e27b8842ac3b4e2f$var$_SAMLA = "SAMLAssertion";
const $e27b8842ac3b4e2f$var$_SFWIT = "SubjectFromWebIdentityToken";
const $e27b8842ac3b4e2f$var$_SI = "SourceIdentity";
const $e27b8842ac3b4e2f$var$_SN = "SerialNumber";
const $e27b8842ac3b4e2f$var$_ST = "SubjectType";
const $e27b8842ac3b4e2f$var$_STe = "SessionToken";
const $e27b8842ac3b4e2f$var$_T = "Tags";
const $e27b8842ac3b4e2f$var$_TC = "TokenCode";
const $e27b8842ac3b4e2f$var$_TP = "TargetPrincipal";
const $e27b8842ac3b4e2f$var$_TPA = "TaskPolicyArn";
const $e27b8842ac3b4e2f$var$_TTK = "TransitiveTagKeys";
const $e27b8842ac3b4e2f$var$_UI = "UserId";
const $e27b8842ac3b4e2f$var$_V = "Version";
const $e27b8842ac3b4e2f$var$_Va = "Value";
const $e27b8842ac3b4e2f$var$_WIT = "WebIdentityToken";
const $e27b8842ac3b4e2f$var$_a = "arn";
const $e27b8842ac3b4e2f$var$_m = "message";
const $e27b8842ac3b4e2f$var$buildFormUrlencodedString = (formEntries)=>Object.entries(formEntries).map(([key, value])=>(0, $6086d4a2e87e67e8$export$7640f3c16fe7f54b)(key) + "=" + (0, $6086d4a2e87e67e8$export$7640f3c16fe7f54b)(value)).join("&");
const $e27b8842ac3b4e2f$var$loadQueryErrorCode = (output, data)=>{
    if (data.Error?.Code !== undefined) return data.Error.Code;
    if (output.statusCode == 404) return "NotFound";
};


class $3005c366f8041d75$export$4fa277828e31b661 extends (0, $ec660c029325fe15$export$cc7e12c76513e857).classBuilder().ep((0, $71e5440285293b82$export$9c07ced2019f0ae0)).m(function(Command, cs, config, o) {
    return [
        (0, $d08040bde29682c1$export$53fdc69654553fd4)(config, this.serialize, this.deserialize),
        (0, $335ede9082851668$export$946c80457b765eab)(config, Command.getEndpointParameterInstructions())
    ];
}).s("AWSSecurityTokenServiceV20110615", "AssumeRoleWithWebIdentity", {}).n("STSClient", "AssumeRoleWithWebIdentityCommand").f((0, $7e701853b65411f4$export$ec337be0d646cf4), (0, $7e701853b65411f4$export$d2c905d36e51efa2)).ser((0, $e27b8842ac3b4e2f$export$eced031c459ebd44)).de((0, $e27b8842ac3b4e2f$export$c445216e9de89804)).build() {
}














const $48e1b4ff5ccb27e5$export$243f330c7e830948 = async (config, context, input)=>{
    return {
        operation: (0, $e6ed4dab4f65171f$export$1d3c197393275463)(context).operation,
        region: await (0, $1d6280adb1321100$export$b1276c07738d6325)(config.region)() || (()=>{
            throw new Error("expected `region` to be configured for `aws.auth#sigv4`");
        })()
    };
};
function $48e1b4ff5ccb27e5$var$createAwsAuthSigv4HttpAuthOption(authParameters) {
    return {
        schemeId: "aws.auth#sigv4",
        signingProperties: {
            name: "sts",
            region: authParameters.region
        },
        propertiesExtractor: (config, context)=>({
                signingProperties: {
                    config: config,
                    context: context
                }
            })
    };
}
function $48e1b4ff5ccb27e5$var$createSmithyApiNoAuthHttpAuthOption(authParameters) {
    return {
        schemeId: "smithy.api#noAuth"
    };
}
const $48e1b4ff5ccb27e5$export$4ffdde1844b52e4d = (authParameters)=>{
    const options = [];
    switch(authParameters.operation){
        case "AssumeRoleWithSAML":
            options.push($48e1b4ff5ccb27e5$var$createSmithyApiNoAuthHttpAuthOption(authParameters));
            break;
        case "AssumeRoleWithWebIdentity":
            options.push($48e1b4ff5ccb27e5$var$createSmithyApiNoAuthHttpAuthOption(authParameters));
            break;
        default:
            options.push($48e1b4ff5ccb27e5$var$createAwsAuthSigv4HttpAuthOption(authParameters));
    }
    return options;
};
const $48e1b4ff5ccb27e5$export$3ed60288303854f3 = (input)=>({
        ...input,
        stsClientCtor: (0, $db3aafa569e5b933$export$c9157f234d7f779)
    });
const $48e1b4ff5ccb27e5$export$d38ef9c0c6c649ab = (config)=>{
    const config_0 = $48e1b4ff5ccb27e5$export$3ed60288303854f3(config);
    const config_1 = (0, $3f66864312eb80d3$export$e18f3f8a841a90ec)(config_0);
    return {
        ...config_1
    };
};



var $b0d187c8ce25e150$exports = {};
$b0d187c8ce25e150$exports = JSON.parse("{\"name\":\"@aws-sdk/client-sts\",\"description\":\"AWS SDK for JavaScript Sts Client for Node.js, Browser and React Native\",\"version\":\"3.726.1\",\"scripts\":{\"build\":\"concurrently 'yarn:build:cjs' 'yarn:build:es' 'yarn:build:types'\",\"build:cjs\":\"node ../../scripts/compilation/inline client-sts\",\"build:es\":\"tsc -p tsconfig.es.json\",\"build:include:deps\":\"lerna run --scope $npm_package_name --include-dependencies build\",\"build:types\":\"rimraf ./dist-types tsconfig.types.tsbuildinfo && tsc -p tsconfig.types.json\",\"build:types:downlevel\":\"downlevel-dts dist-types dist-types/ts3.4\",\"clean\":\"rimraf ./dist-* && rimraf *.tsbuildinfo\",\"extract:docs\":\"api-extractor run --local\",\"generate:client\":\"node ../../scripts/generate-clients/single-service --solo sts\",\"test\":\"yarn g:vitest run\",\"test:watch\":\"yarn g:vitest watch\"},\"main\":\"./dist-cjs/index.js\",\"types\":\"./dist-types/index.d.ts\",\"module\":\"./dist-es/index.js\",\"sideEffects\":false,\"dependencies\":{\"@aws-crypto/sha256-browser\":\"5.2.0\",\"@aws-crypto/sha256-js\":\"5.2.0\",\"@aws-sdk/client-sso-oidc\":\"3.726.0\",\"@aws-sdk/core\":\"3.723.0\",\"@aws-sdk/credential-provider-node\":\"3.726.0\",\"@aws-sdk/middleware-host-header\":\"3.723.0\",\"@aws-sdk/middleware-logger\":\"3.723.0\",\"@aws-sdk/middleware-recursion-detection\":\"3.723.0\",\"@aws-sdk/middleware-user-agent\":\"3.726.0\",\"@aws-sdk/region-config-resolver\":\"3.723.0\",\"@aws-sdk/types\":\"3.723.0\",\"@aws-sdk/util-endpoints\":\"3.726.0\",\"@aws-sdk/util-user-agent-browser\":\"3.723.0\",\"@aws-sdk/util-user-agent-node\":\"3.726.0\",\"@smithy/config-resolver\":\"^4.0.0\",\"@smithy/core\":\"^3.0.0\",\"@smithy/fetch-http-handler\":\"^5.0.0\",\"@smithy/hash-node\":\"^4.0.0\",\"@smithy/invalid-dependency\":\"^4.0.0\",\"@smithy/middleware-content-length\":\"^4.0.0\",\"@smithy/middleware-endpoint\":\"^4.0.0\",\"@smithy/middleware-retry\":\"^4.0.0\",\"@smithy/middleware-serde\":\"^4.0.0\",\"@smithy/middleware-stack\":\"^4.0.0\",\"@smithy/node-config-provider\":\"^4.0.0\",\"@smithy/node-http-handler\":\"^4.0.0\",\"@smithy/protocol-http\":\"^5.0.0\",\"@smithy/smithy-client\":\"^4.0.0\",\"@smithy/types\":\"^4.0.0\",\"@smithy/url-parser\":\"^4.0.0\",\"@smithy/util-base64\":\"^4.0.0\",\"@smithy/util-body-length-browser\":\"^4.0.0\",\"@smithy/util-body-length-node\":\"^4.0.0\",\"@smithy/util-defaults-mode-browser\":\"^4.0.0\",\"@smithy/util-defaults-mode-node\":\"^4.0.0\",\"@smithy/util-endpoints\":\"^3.0.0\",\"@smithy/util-middleware\":\"^4.0.0\",\"@smithy/util-retry\":\"^4.0.0\",\"@smithy/util-utf8\":\"^4.0.0\",\"tslib\":\"^2.6.2\"},\"devDependencies\":{\"@tsconfig/node18\":\"18.2.4\",\"@types/node\":\"^18.19.69\",\"concurrently\":\"7.0.0\",\"downlevel-dts\":\"0.10.1\",\"rimraf\":\"3.0.2\",\"typescript\":\"~5.2.2\"},\"engines\":{\"node\":\">=18.0.0\"},\"typesVersions\":{\"<4.0\":{\"dist-types/*\":[\"dist-types/ts3.4/*\"]}},\"files\":[\"dist-*/**\"],\"author\":{\"name\":\"AWS SDK for JavaScript Team\",\"url\":\"https://aws.amazon.com/javascript/\"},\"license\":\"Apache-2.0\",\"browser\":{\"./dist-es/runtimeConfig\":\"./dist-es/runtimeConfig.browser\"},\"react-native\":{\"./dist-es/runtimeConfig\":\"./dist-es/runtimeConfig.native\"},\"homepage\":\"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-sts\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/aws/aws-sdk-js-v3.git\",\"directory\":\"clients/client-sts\"}}");


















const $525114cf9aa10ddb$var$F = "required", $525114cf9aa10ddb$var$G = "type", $525114cf9aa10ddb$var$H = "fn", $525114cf9aa10ddb$var$I = "argv", $525114cf9aa10ddb$var$J = "ref";
const $525114cf9aa10ddb$var$a = false, $525114cf9aa10ddb$var$b = true, $525114cf9aa10ddb$var$c = "booleanEquals", $525114cf9aa10ddb$var$d = "stringEquals", $525114cf9aa10ddb$var$e = "sigv4", $525114cf9aa10ddb$var$f = "sts", $525114cf9aa10ddb$var$g = "us-east-1", $525114cf9aa10ddb$var$h = "endpoint", $525114cf9aa10ddb$var$i = "https://sts.{Region}.{PartitionResult#dnsSuffix}", $525114cf9aa10ddb$var$j = "tree", $525114cf9aa10ddb$var$k = "error", $525114cf9aa10ddb$var$l = "getAttr", $525114cf9aa10ddb$var$m = {
    [$525114cf9aa10ddb$var$F]: false,
    [$525114cf9aa10ddb$var$G]: "String"
}, $525114cf9aa10ddb$var$n = {
    [$525114cf9aa10ddb$var$F]: true,
    "default": false,
    [$525114cf9aa10ddb$var$G]: "Boolean"
}, $525114cf9aa10ddb$var$o = {
    [$525114cf9aa10ddb$var$J]: "Endpoint"
}, $525114cf9aa10ddb$var$p = {
    [$525114cf9aa10ddb$var$H]: "isSet",
    [$525114cf9aa10ddb$var$I]: [
        {
            [$525114cf9aa10ddb$var$J]: "Region"
        }
    ]
}, $525114cf9aa10ddb$var$q = {
    [$525114cf9aa10ddb$var$J]: "Region"
}, $525114cf9aa10ddb$var$r = {
    [$525114cf9aa10ddb$var$H]: "aws.partition",
    [$525114cf9aa10ddb$var$I]: [
        $525114cf9aa10ddb$var$q
    ],
    "assign": "PartitionResult"
}, $525114cf9aa10ddb$var$s = {
    [$525114cf9aa10ddb$var$J]: "UseFIPS"
}, $525114cf9aa10ddb$var$t = {
    [$525114cf9aa10ddb$var$J]: "UseDualStack"
}, $525114cf9aa10ddb$var$u = {
    "url": "https://sts.amazonaws.com",
    "properties": {
        "authSchemes": [
            {
                "name": $525114cf9aa10ddb$var$e,
                "signingName": $525114cf9aa10ddb$var$f,
                "signingRegion": $525114cf9aa10ddb$var$g
            }
        ]
    },
    "headers": {}
}, $525114cf9aa10ddb$var$v = {}, $525114cf9aa10ddb$var$w = {
    "conditions": [
        {
            [$525114cf9aa10ddb$var$H]: $525114cf9aa10ddb$var$d,
            [$525114cf9aa10ddb$var$I]: [
                $525114cf9aa10ddb$var$q,
                "aws-global"
            ]
        }
    ],
    [$525114cf9aa10ddb$var$h]: $525114cf9aa10ddb$var$u,
    [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$h
}, $525114cf9aa10ddb$var$x = {
    [$525114cf9aa10ddb$var$H]: $525114cf9aa10ddb$var$c,
    [$525114cf9aa10ddb$var$I]: [
        $525114cf9aa10ddb$var$s,
        true
    ]
}, $525114cf9aa10ddb$var$y = {
    [$525114cf9aa10ddb$var$H]: $525114cf9aa10ddb$var$c,
    [$525114cf9aa10ddb$var$I]: [
        $525114cf9aa10ddb$var$t,
        true
    ]
}, $525114cf9aa10ddb$var$z = {
    [$525114cf9aa10ddb$var$H]: $525114cf9aa10ddb$var$l,
    [$525114cf9aa10ddb$var$I]: [
        {
            [$525114cf9aa10ddb$var$J]: "PartitionResult"
        },
        "supportsFIPS"
    ]
}, $525114cf9aa10ddb$var$A = {
    [$525114cf9aa10ddb$var$J]: "PartitionResult"
}, $525114cf9aa10ddb$var$B = {
    [$525114cf9aa10ddb$var$H]: $525114cf9aa10ddb$var$c,
    [$525114cf9aa10ddb$var$I]: [
        true,
        {
            [$525114cf9aa10ddb$var$H]: $525114cf9aa10ddb$var$l,
            [$525114cf9aa10ddb$var$I]: [
                $525114cf9aa10ddb$var$A,
                "supportsDualStack"
            ]
        }
    ]
}, $525114cf9aa10ddb$var$C = [
    {
        [$525114cf9aa10ddb$var$H]: "isSet",
        [$525114cf9aa10ddb$var$I]: [
            $525114cf9aa10ddb$var$o
        ]
    }
], $525114cf9aa10ddb$var$D = [
    $525114cf9aa10ddb$var$x
], $525114cf9aa10ddb$var$E = [
    $525114cf9aa10ddb$var$y
];
const $525114cf9aa10ddb$var$_data = {
    version: "1.0",
    parameters: {
        Region: $525114cf9aa10ddb$var$m,
        UseDualStack: $525114cf9aa10ddb$var$n,
        UseFIPS: $525114cf9aa10ddb$var$n,
        Endpoint: $525114cf9aa10ddb$var$m,
        UseGlobalEndpoint: $525114cf9aa10ddb$var$n
    },
    rules: [
        {
            conditions: [
                {
                    [$525114cf9aa10ddb$var$H]: $525114cf9aa10ddb$var$c,
                    [$525114cf9aa10ddb$var$I]: [
                        {
                            [$525114cf9aa10ddb$var$J]: "UseGlobalEndpoint"
                        },
                        $525114cf9aa10ddb$var$b
                    ]
                },
                {
                    [$525114cf9aa10ddb$var$H]: "not",
                    [$525114cf9aa10ddb$var$I]: $525114cf9aa10ddb$var$C
                },
                $525114cf9aa10ddb$var$p,
                $525114cf9aa10ddb$var$r,
                {
                    [$525114cf9aa10ddb$var$H]: $525114cf9aa10ddb$var$c,
                    [$525114cf9aa10ddb$var$I]: [
                        $525114cf9aa10ddb$var$s,
                        $525114cf9aa10ddb$var$a
                    ]
                },
                {
                    [$525114cf9aa10ddb$var$H]: $525114cf9aa10ddb$var$c,
                    [$525114cf9aa10ddb$var$I]: [
                        $525114cf9aa10ddb$var$t,
                        $525114cf9aa10ddb$var$a
                    ]
                }
            ],
            rules: [
                {
                    conditions: [
                        {
                            [$525114cf9aa10ddb$var$H]: $525114cf9aa10ddb$var$d,
                            [$525114cf9aa10ddb$var$I]: [
                                $525114cf9aa10ddb$var$q,
                                "ap-northeast-1"
                            ]
                        }
                    ],
                    endpoint: $525114cf9aa10ddb$var$u,
                    [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$h
                },
                {
                    conditions: [
                        {
                            [$525114cf9aa10ddb$var$H]: $525114cf9aa10ddb$var$d,
                            [$525114cf9aa10ddb$var$I]: [
                                $525114cf9aa10ddb$var$q,
                                "ap-south-1"
                            ]
                        }
                    ],
                    endpoint: $525114cf9aa10ddb$var$u,
                    [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$h
                },
                {
                    conditions: [
                        {
                            [$525114cf9aa10ddb$var$H]: $525114cf9aa10ddb$var$d,
                            [$525114cf9aa10ddb$var$I]: [
                                $525114cf9aa10ddb$var$q,
                                "ap-southeast-1"
                            ]
                        }
                    ],
                    endpoint: $525114cf9aa10ddb$var$u,
                    [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$h
                },
                {
                    conditions: [
                        {
                            [$525114cf9aa10ddb$var$H]: $525114cf9aa10ddb$var$d,
                            [$525114cf9aa10ddb$var$I]: [
                                $525114cf9aa10ddb$var$q,
                                "ap-southeast-2"
                            ]
                        }
                    ],
                    endpoint: $525114cf9aa10ddb$var$u,
                    [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$h
                },
                $525114cf9aa10ddb$var$w,
                {
                    conditions: [
                        {
                            [$525114cf9aa10ddb$var$H]: $525114cf9aa10ddb$var$d,
                            [$525114cf9aa10ddb$var$I]: [
                                $525114cf9aa10ddb$var$q,
                                "ca-central-1"
                            ]
                        }
                    ],
                    endpoint: $525114cf9aa10ddb$var$u,
                    [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$h
                },
                {
                    conditions: [
                        {
                            [$525114cf9aa10ddb$var$H]: $525114cf9aa10ddb$var$d,
                            [$525114cf9aa10ddb$var$I]: [
                                $525114cf9aa10ddb$var$q,
                                "eu-central-1"
                            ]
                        }
                    ],
                    endpoint: $525114cf9aa10ddb$var$u,
                    [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$h
                },
                {
                    conditions: [
                        {
                            [$525114cf9aa10ddb$var$H]: $525114cf9aa10ddb$var$d,
                            [$525114cf9aa10ddb$var$I]: [
                                $525114cf9aa10ddb$var$q,
                                "eu-north-1"
                            ]
                        }
                    ],
                    endpoint: $525114cf9aa10ddb$var$u,
                    [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$h
                },
                {
                    conditions: [
                        {
                            [$525114cf9aa10ddb$var$H]: $525114cf9aa10ddb$var$d,
                            [$525114cf9aa10ddb$var$I]: [
                                $525114cf9aa10ddb$var$q,
                                "eu-west-1"
                            ]
                        }
                    ],
                    endpoint: $525114cf9aa10ddb$var$u,
                    [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$h
                },
                {
                    conditions: [
                        {
                            [$525114cf9aa10ddb$var$H]: $525114cf9aa10ddb$var$d,
                            [$525114cf9aa10ddb$var$I]: [
                                $525114cf9aa10ddb$var$q,
                                "eu-west-2"
                            ]
                        }
                    ],
                    endpoint: $525114cf9aa10ddb$var$u,
                    [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$h
                },
                {
                    conditions: [
                        {
                            [$525114cf9aa10ddb$var$H]: $525114cf9aa10ddb$var$d,
                            [$525114cf9aa10ddb$var$I]: [
                                $525114cf9aa10ddb$var$q,
                                "eu-west-3"
                            ]
                        }
                    ],
                    endpoint: $525114cf9aa10ddb$var$u,
                    [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$h
                },
                {
                    conditions: [
                        {
                            [$525114cf9aa10ddb$var$H]: $525114cf9aa10ddb$var$d,
                            [$525114cf9aa10ddb$var$I]: [
                                $525114cf9aa10ddb$var$q,
                                "sa-east-1"
                            ]
                        }
                    ],
                    endpoint: $525114cf9aa10ddb$var$u,
                    [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$h
                },
                {
                    conditions: [
                        {
                            [$525114cf9aa10ddb$var$H]: $525114cf9aa10ddb$var$d,
                            [$525114cf9aa10ddb$var$I]: [
                                $525114cf9aa10ddb$var$q,
                                $525114cf9aa10ddb$var$g
                            ]
                        }
                    ],
                    endpoint: $525114cf9aa10ddb$var$u,
                    [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$h
                },
                {
                    conditions: [
                        {
                            [$525114cf9aa10ddb$var$H]: $525114cf9aa10ddb$var$d,
                            [$525114cf9aa10ddb$var$I]: [
                                $525114cf9aa10ddb$var$q,
                                "us-east-2"
                            ]
                        }
                    ],
                    endpoint: $525114cf9aa10ddb$var$u,
                    [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$h
                },
                {
                    conditions: [
                        {
                            [$525114cf9aa10ddb$var$H]: $525114cf9aa10ddb$var$d,
                            [$525114cf9aa10ddb$var$I]: [
                                $525114cf9aa10ddb$var$q,
                                "us-west-1"
                            ]
                        }
                    ],
                    endpoint: $525114cf9aa10ddb$var$u,
                    [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$h
                },
                {
                    conditions: [
                        {
                            [$525114cf9aa10ddb$var$H]: $525114cf9aa10ddb$var$d,
                            [$525114cf9aa10ddb$var$I]: [
                                $525114cf9aa10ddb$var$q,
                                "us-west-2"
                            ]
                        }
                    ],
                    endpoint: $525114cf9aa10ddb$var$u,
                    [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$h
                },
                {
                    endpoint: {
                        url: $525114cf9aa10ddb$var$i,
                        properties: {
                            authSchemes: [
                                {
                                    name: $525114cf9aa10ddb$var$e,
                                    signingName: $525114cf9aa10ddb$var$f,
                                    signingRegion: "{Region}"
                                }
                            ]
                        },
                        headers: $525114cf9aa10ddb$var$v
                    },
                    [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$h
                }
            ],
            [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$j
        },
        {
            conditions: $525114cf9aa10ddb$var$C,
            rules: [
                {
                    conditions: $525114cf9aa10ddb$var$D,
                    error: "Invalid Configuration: FIPS and custom endpoint are not supported",
                    [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$k
                },
                {
                    conditions: $525114cf9aa10ddb$var$E,
                    error: "Invalid Configuration: Dualstack and custom endpoint are not supported",
                    [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$k
                },
                {
                    endpoint: {
                        url: $525114cf9aa10ddb$var$o,
                        properties: $525114cf9aa10ddb$var$v,
                        headers: $525114cf9aa10ddb$var$v
                    },
                    [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$h
                }
            ],
            [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$j
        },
        {
            conditions: [
                $525114cf9aa10ddb$var$p
            ],
            rules: [
                {
                    conditions: [
                        $525114cf9aa10ddb$var$r
                    ],
                    rules: [
                        {
                            conditions: [
                                $525114cf9aa10ddb$var$x,
                                $525114cf9aa10ddb$var$y
                            ],
                            rules: [
                                {
                                    conditions: [
                                        {
                                            [$525114cf9aa10ddb$var$H]: $525114cf9aa10ddb$var$c,
                                            [$525114cf9aa10ddb$var$I]: [
                                                $525114cf9aa10ddb$var$b,
                                                $525114cf9aa10ddb$var$z
                                            ]
                                        },
                                        $525114cf9aa10ddb$var$B
                                    ],
                                    rules: [
                                        {
                                            endpoint: {
                                                url: "https://sts-fips.{Region}.{PartitionResult#dualStackDnsSuffix}",
                                                properties: $525114cf9aa10ddb$var$v,
                                                headers: $525114cf9aa10ddb$var$v
                                            },
                                            [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$h
                                        }
                                    ],
                                    [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$j
                                },
                                {
                                    error: "FIPS and DualStack are enabled, but this partition does not support one or both",
                                    [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$k
                                }
                            ],
                            [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$j
                        },
                        {
                            conditions: $525114cf9aa10ddb$var$D,
                            rules: [
                                {
                                    conditions: [
                                        {
                                            [$525114cf9aa10ddb$var$H]: $525114cf9aa10ddb$var$c,
                                            [$525114cf9aa10ddb$var$I]: [
                                                $525114cf9aa10ddb$var$z,
                                                $525114cf9aa10ddb$var$b
                                            ]
                                        }
                                    ],
                                    rules: [
                                        {
                                            conditions: [
                                                {
                                                    [$525114cf9aa10ddb$var$H]: $525114cf9aa10ddb$var$d,
                                                    [$525114cf9aa10ddb$var$I]: [
                                                        {
                                                            [$525114cf9aa10ddb$var$H]: $525114cf9aa10ddb$var$l,
                                                            [$525114cf9aa10ddb$var$I]: [
                                                                $525114cf9aa10ddb$var$A,
                                                                "name"
                                                            ]
                                                        },
                                                        "aws-us-gov"
                                                    ]
                                                }
                                            ],
                                            endpoint: {
                                                url: "https://sts.{Region}.amazonaws.com",
                                                properties: $525114cf9aa10ddb$var$v,
                                                headers: $525114cf9aa10ddb$var$v
                                            },
                                            [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$h
                                        },
                                        {
                                            endpoint: {
                                                url: "https://sts-fips.{Region}.{PartitionResult#dnsSuffix}",
                                                properties: $525114cf9aa10ddb$var$v,
                                                headers: $525114cf9aa10ddb$var$v
                                            },
                                            [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$h
                                        }
                                    ],
                                    [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$j
                                },
                                {
                                    error: "FIPS is enabled but this partition does not support FIPS",
                                    [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$k
                                }
                            ],
                            [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$j
                        },
                        {
                            conditions: $525114cf9aa10ddb$var$E,
                            rules: [
                                {
                                    conditions: [
                                        $525114cf9aa10ddb$var$B
                                    ],
                                    rules: [
                                        {
                                            endpoint: {
                                                url: "https://sts.{Region}.{PartitionResult#dualStackDnsSuffix}",
                                                properties: $525114cf9aa10ddb$var$v,
                                                headers: $525114cf9aa10ddb$var$v
                                            },
                                            [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$h
                                        }
                                    ],
                                    [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$j
                                },
                                {
                                    error: "DualStack is enabled but this partition does not support DualStack",
                                    [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$k
                                }
                            ],
                            [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$j
                        },
                        $525114cf9aa10ddb$var$w,
                        {
                            endpoint: {
                                url: $525114cf9aa10ddb$var$i,
                                properties: $525114cf9aa10ddb$var$v,
                                headers: $525114cf9aa10ddb$var$v
                            },
                            [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$h
                        }
                    ],
                    [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$j
                }
            ],
            [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$j
        },
        {
            error: "Invalid Configuration: Missing Region",
            [$525114cf9aa10ddb$var$G]: $525114cf9aa10ddb$var$k
        }
    ]
};
const $525114cf9aa10ddb$export$7b249e066372152f = $525114cf9aa10ddb$var$_data;


const $80e03cbc02157af1$var$cache = new (0, $d06f12251068eb72$export$262eb2e4804ef909)({
    size: 50,
    params: [
        "Endpoint",
        "Region",
        "UseDualStack",
        "UseFIPS",
        "UseGlobalEndpoint"
    ]
});
const $80e03cbc02157af1$export$47fc6e98c86e06e3 = (endpointParams, context = {})=>{
    return $80e03cbc02157af1$var$cache.get(endpointParams, ()=>(0, $c21f7418bd0df18f$export$48b88e4e5ecac119)((0, $525114cf9aa10ddb$export$7b249e066372152f), {
            endpointParams: endpointParams,
            logger: context.logger
        }));
};
(0, $91b7ba976acbb024$export$2614fba0847da171).aws = (0, $8e31713c360183c3$export$1bfd97ffc6d0eef8);


const $917fe54a37ffdfe0$export$ad0966540b0e71e5 = (config)=>{
    return {
        apiVersion: "2011-06-15",
        base64Decoder: config?.base64Decoder ?? (0, $7b3498acd0b4495b$export$c537b38001c583b7),
        base64Encoder: config?.base64Encoder ?? (0, $d63237a3fb21a427$export$37cc283d8fbd3462),
        disableHostPrefix: config?.disableHostPrefix ?? false,
        endpointProvider: config?.endpointProvider ?? (0, $80e03cbc02157af1$export$47fc6e98c86e06e3),
        extensions: config?.extensions ?? [],
        httpAuthSchemeProvider: config?.httpAuthSchemeProvider ?? (0, $48e1b4ff5ccb27e5$export$4ffdde1844b52e4d),
        httpAuthSchemes: config?.httpAuthSchemes ?? [
            {
                schemeId: "aws.auth#sigv4",
                identityProvider: (ipc)=>ipc.getIdentityProvider("aws.auth#sigv4"),
                signer: new (0, $93763e910902e47b$export$8d10c019aa195a2b)()
            },
            {
                schemeId: "smithy.api#noAuth",
                identityProvider: (ipc)=>ipc.getIdentityProvider("smithy.api#noAuth") || (async ()=>({})),
                signer: new (0, $68474e33de95c781$export$19622a6daa7bca6e)()
            }
        ],
        logger: config?.logger ?? new (0, $c9caefe05bf12396$export$4147bde06f294c2e)(),
        serviceId: config?.serviceId ?? "STS",
        urlParser: config?.urlParser ?? (0, $931d216cb423ad36$export$7a5253c0f62e0150),
        utf8Decoder: config?.utf8Decoder ?? (0, $443e71811b7d31c6$export$c7c5cef950a4d2fc),
        utf8Encoder: config?.utf8Encoder ?? (0, $5a195679de934416$export$b4b216764bb846eb)
    };
};




const $a536d3ef1dd0c535$export$ad0966540b0e71e5 = (config)=>{
    const defaultsMode = (0, $4b5f1111656da5bf$export$b146d618450007ac)(config);
    const defaultConfigProvider = ()=>defaultsMode().then((0, $9ab7bd0f453434be$export$b6e2b46631b45a92));
    const clientSharedValues = (0, $917fe54a37ffdfe0$export$ad0966540b0e71e5)(config);
    return {
        ...clientSharedValues,
        ...config,
        runtime: "browser",
        defaultsMode: defaultsMode,
        bodyLengthChecker: config?.bodyLengthChecker ?? (0, $9e4c3027d336cb04$export$967f3527bf233bc0),
        credentialDefaultProvider: config?.credentialDefaultProvider ?? ((_)=>()=>Promise.reject(new Error("Credential is missing"))),
        defaultUserAgentProvider: config?.defaultUserAgentProvider ?? (0, $6bb11abd8422769c$export$c132edb4cf3f7b9c)({
            serviceId: clientSharedValues.serviceId,
            clientVersion: (0, (/*@__PURE__*/$parcel$interopDefault($b0d187c8ce25e150$exports))).version
        }),
        maxAttempts: config?.maxAttempts ?? (0, $5509594642b1e771$export$2c7e51f38ba5a406),
        region: config?.region ?? (0, $2e5ffb59202a2d85$export$d59dd53963f8f3d5)("Region is missing"),
        requestHandler: (0, $40b502f5f0978093$export$83588b87edbfa7e0).create(config?.requestHandler ?? defaultConfigProvider),
        retryMode: config?.retryMode ?? (async ()=>(await defaultConfigProvider()).retryMode || (0, $5509594642b1e771$export$41315747b7c5d042)),
        sha256: config?.sha256 ?? (0, $96d9020e18f0029b$export$3b58ea8124ac5e28),
        streamCollector: config?.streamCollector ?? (0, $03d6a1cc7230aa78$export$17bf97b72e307d52),
        useDualstackEndpoint: config?.useDualstackEndpoint ?? (()=>Promise.resolve((0, $8bc367ec79540d60$export$beb01fae7626c427))),
        useFipsEndpoint: config?.useFipsEndpoint ?? (()=>Promise.resolve((0, $6569393054577581$export$5555deeca435a10b)))
    };
};





const $310dc6e2872d56fc$export$e536d87ced0d9700 = (runtimeConfig)=>{
    const _httpAuthSchemes = runtimeConfig.httpAuthSchemes;
    let _httpAuthSchemeProvider = runtimeConfig.httpAuthSchemeProvider;
    let _credentials = runtimeConfig.credentials;
    return {
        setHttpAuthScheme (httpAuthScheme) {
            const index = _httpAuthSchemes.findIndex((scheme)=>scheme.schemeId === httpAuthScheme.schemeId);
            if (index === -1) _httpAuthSchemes.push(httpAuthScheme);
            else _httpAuthSchemes.splice(index, 1, httpAuthScheme);
        },
        httpAuthSchemes () {
            return _httpAuthSchemes;
        },
        setHttpAuthSchemeProvider (httpAuthSchemeProvider) {
            _httpAuthSchemeProvider = httpAuthSchemeProvider;
        },
        httpAuthSchemeProvider () {
            return _httpAuthSchemeProvider;
        },
        setCredentials (credentials) {
            _credentials = credentials;
        },
        credentials () {
            return _credentials;
        }
    };
};
const $310dc6e2872d56fc$export$60c55f59b27530a8 = (config)=>{
    return {
        httpAuthSchemes: config.httpAuthSchemes(),
        httpAuthSchemeProvider: config.httpAuthSchemeProvider(),
        credentials: config.credentials()
    };
};


const $25a3745131af592a$var$asPartial = (t)=>t;
const $25a3745131af592a$export$4278118b303a14cf = (runtimeConfig, extensions)=>{
    const extensionConfiguration = {
        ...$25a3745131af592a$var$asPartial((0, $f7899cd52cf70df9$export$be3086d183cd8ea6)(runtimeConfig)),
        ...$25a3745131af592a$var$asPartial((0, $cef2627dbb2c7da1$export$2d53aaae46f156f5)(runtimeConfig)),
        ...$25a3745131af592a$var$asPartial((0, $84f26894dd035c27$export$663b205817703038)(runtimeConfig)),
        ...$25a3745131af592a$var$asPartial((0, $310dc6e2872d56fc$export$e536d87ced0d9700)(runtimeConfig))
    };
    extensions.forEach((extension)=>extension.configure(extensionConfiguration));
    return {
        ...runtimeConfig,
        ...(0, $f7899cd52cf70df9$export$74973a8fb8dfc16e)(extensionConfiguration),
        ...(0, $cef2627dbb2c7da1$export$abfa28b95316e0ae)(extensionConfiguration),
        ...(0, $84f26894dd035c27$export$d94fe0350385c1a8)(extensionConfiguration),
        ...(0, $310dc6e2872d56fc$export$60c55f59b27530a8)(extensionConfiguration)
    };
};


class $db3aafa569e5b933$export$c9157f234d7f779 extends (0, $514104a2dba81648$export$1f2bb630327ac4b6) {
    config;
    constructor(...[configuration]){
        const _config_0 = (0, $a536d3ef1dd0c535$export$ad0966540b0e71e5)(configuration || {});
        const _config_1 = (0, $71e5440285293b82$export$70b6341cd51750a8)(_config_0);
        const _config_2 = (0, $3b038e7801e78d35$export$ec9a2d5663958cb)(_config_1);
        const _config_3 = (0, $5ca3ff7097febeef$export$ca7f6138f2c98476)(_config_2);
        const _config_4 = (0, $83ef33ca75f7dd65$export$7696ef37558bd0ec)(_config_3);
        const _config_5 = (0, $b173a3ce9281b3cf$export$c1625bf0b32b4481)(_config_4);
        const _config_6 = (0, $dedc7eba2c45bbb9$export$8c5b66831e3f26ff)(_config_5);
        const _config_7 = (0, $48e1b4ff5ccb27e5$export$d38ef9c0c6c649ab)(_config_6);
        const _config_8 = (0, $25a3745131af592a$export$4278118b303a14cf)(_config_7, configuration?.extensions || []);
        super(_config_8);
        this.config = _config_8;
        this.middlewareStack.use((0, $168add9a52432ffc$export$5393c0d2d7f4f5f0)(this.config));
        this.middlewareStack.use((0, $9ba3cc7a799aee7e$export$c73199e2b1df9340)(this.config));
        this.middlewareStack.use((0, $88932ea823bca647$export$7e6ddf9365a30fe9)(this.config));
        this.middlewareStack.use((0, $b173a3ce9281b3cf$export$23d3b647211be53a)(this.config));
        this.middlewareStack.use((0, $60459010f05dd111$export$f6ef65d7766fc255)(this.config));
        this.middlewareStack.use((0, $8825720894d7451a$export$11d0b9345788bd5)(this.config));
        this.middlewareStack.use((0, $1fcce1fc5214c9cb$export$6ababc1a6356ca41)(this.config, {
            httpAuthSchemeParametersProvider: (0, $48e1b4ff5ccb27e5$export$243f330c7e830948),
            identityProviderConfigProvider: async (config)=>new (0, $99ebb391854b554e$export$67f43b78065c5551)({
                    "aws.auth#sigv4": config.credentials
                })
        }));
        this.middlewareStack.use((0, $a232cb521b867f08$export$ed476aa7e410a)(this.config));
    }
    destroy() {
        super.destroy();
    }
}








const $bef36ba9ce16a8b4$export$5e2ae00bf65442f0 = (input)=>({
        ...input,
        eventStreamMarshaller: input.eventStreamSerdeProvider(input)
    });










const $438932d6c6f0eba7$export$c693595f739216c8 = async (config, context, input)=>{
    return {
        operation: (0, $e6ed4dab4f65171f$export$1d3c197393275463)(context).operation,
        region: await (0, $1d6280adb1321100$export$b1276c07738d6325)(config.region)() || (()=>{
            throw new Error("expected `region` to be configured for `aws.auth#sigv4`");
        })()
    };
};
function $438932d6c6f0eba7$var$createAwsAuthSigv4HttpAuthOption(authParameters) {
    return {
        schemeId: "aws.auth#sigv4",
        signingProperties: {
            name: "bedrock",
            region: authParameters.region
        },
        propertiesExtractor: (config, context)=>({
                signingProperties: {
                    config: config,
                    context: context
                }
            })
    };
}
const $438932d6c6f0eba7$export$f9e04465771042 = (authParameters)=>{
    const options = [];
    authParameters.operation;
    options.push($438932d6c6f0eba7$var$createAwsAuthSigv4HttpAuthOption(authParameters));
    return options;
};
const $438932d6c6f0eba7$export$d38ef9c0c6c649ab = (config)=>{
    const config_0 = (0, $3f66864312eb80d3$export$e18f3f8a841a90ec)(config);
    return {
        ...config_0
    };
};


const $e94babf240abe10f$export$70b6341cd51750a8 = (options)=>{
    return {
        ...options,
        useDualstackEndpoint: options.useDualstackEndpoint ?? false,
        useFipsEndpoint: options.useFipsEndpoint ?? false,
        defaultSigningName: "bedrock"
    };
};
const $e94babf240abe10f$export$9c07ced2019f0ae0 = {
    UseFIPS: {
        type: "builtInParams",
        name: "useFipsEndpoint"
    },
    Endpoint: {
        type: "builtInParams",
        name: "endpoint"
    },
    Region: {
        type: "builtInParams",
        name: "region"
    },
    UseDualStack: {
        type: "builtInParams",
        name: "useDualstackEndpoint"
    }
};


var $4d8dffe09d638ad4$exports = {};
$4d8dffe09d638ad4$exports = JSON.parse("{\"name\":\"@aws-sdk/client-bedrock-runtime\",\"description\":\"AWS SDK for JavaScript Bedrock Runtime Client for Node.js, Browser and React Native\",\"version\":\"3.726.1\",\"scripts\":{\"build\":\"concurrently 'yarn:build:cjs' 'yarn:build:es' 'yarn:build:types'\",\"build:cjs\":\"node ../../scripts/compilation/inline client-bedrock-runtime\",\"build:es\":\"tsc -p tsconfig.es.json\",\"build:include:deps\":\"lerna run --scope $npm_package_name --include-dependencies build\",\"build:types\":\"tsc -p tsconfig.types.json\",\"build:types:downlevel\":\"downlevel-dts dist-types dist-types/ts3.4\",\"clean\":\"rimraf ./dist-* && rimraf *.tsbuildinfo\",\"extract:docs\":\"api-extractor run --local\",\"generate:client\":\"node ../../scripts/generate-clients/single-service --solo bedrock-runtime\"},\"main\":\"./dist-cjs/index.js\",\"types\":\"./dist-types/index.d.ts\",\"module\":\"./dist-es/index.js\",\"sideEffects\":false,\"dependencies\":{\"@aws-crypto/sha256-browser\":\"5.2.0\",\"@aws-crypto/sha256-js\":\"5.2.0\",\"@aws-sdk/client-sso-oidc\":\"3.726.0\",\"@aws-sdk/client-sts\":\"3.726.1\",\"@aws-sdk/core\":\"3.723.0\",\"@aws-sdk/credential-provider-node\":\"3.726.0\",\"@aws-sdk/middleware-host-header\":\"3.723.0\",\"@aws-sdk/middleware-logger\":\"3.723.0\",\"@aws-sdk/middleware-recursion-detection\":\"3.723.0\",\"@aws-sdk/middleware-user-agent\":\"3.726.0\",\"@aws-sdk/region-config-resolver\":\"3.723.0\",\"@aws-sdk/types\":\"3.723.0\",\"@aws-sdk/util-endpoints\":\"3.726.0\",\"@aws-sdk/util-user-agent-browser\":\"3.723.0\",\"@aws-sdk/util-user-agent-node\":\"3.726.0\",\"@smithy/config-resolver\":\"^4.0.0\",\"@smithy/core\":\"^3.0.0\",\"@smithy/eventstream-serde-browser\":\"^4.0.0\",\"@smithy/eventstream-serde-config-resolver\":\"^4.0.0\",\"@smithy/eventstream-serde-node\":\"^4.0.0\",\"@smithy/fetch-http-handler\":\"^5.0.0\",\"@smithy/hash-node\":\"^4.0.0\",\"@smithy/invalid-dependency\":\"^4.0.0\",\"@smithy/middleware-content-length\":\"^4.0.0\",\"@smithy/middleware-endpoint\":\"^4.0.0\",\"@smithy/middleware-retry\":\"^4.0.0\",\"@smithy/middleware-serde\":\"^4.0.0\",\"@smithy/middleware-stack\":\"^4.0.0\",\"@smithy/node-config-provider\":\"^4.0.0\",\"@smithy/node-http-handler\":\"^4.0.0\",\"@smithy/protocol-http\":\"^5.0.0\",\"@smithy/smithy-client\":\"^4.0.0\",\"@smithy/types\":\"^4.0.0\",\"@smithy/url-parser\":\"^4.0.0\",\"@smithy/util-base64\":\"^4.0.0\",\"@smithy/util-body-length-browser\":\"^4.0.0\",\"@smithy/util-body-length-node\":\"^4.0.0\",\"@smithy/util-defaults-mode-browser\":\"^4.0.0\",\"@smithy/util-defaults-mode-node\":\"^4.0.0\",\"@smithy/util-endpoints\":\"^3.0.0\",\"@smithy/util-middleware\":\"^4.0.0\",\"@smithy/util-retry\":\"^4.0.0\",\"@smithy/util-stream\":\"^4.0.0\",\"@smithy/util-utf8\":\"^4.0.0\",\"@types/uuid\":\"^9.0.1\",\"tslib\":\"^2.6.2\",\"uuid\":\"^9.0.1\"},\"devDependencies\":{\"@tsconfig/node18\":\"18.2.4\",\"@types/node\":\"^18.19.69\",\"concurrently\":\"7.0.0\",\"downlevel-dts\":\"0.10.1\",\"rimraf\":\"3.0.2\",\"typescript\":\"~5.2.2\"},\"engines\":{\"node\":\">=18.0.0\"},\"typesVersions\":{\"<4.0\":{\"dist-types/*\":[\"dist-types/ts3.4/*\"]}},\"files\":[\"dist-*/**\"],\"author\":{\"name\":\"AWS SDK for JavaScript Team\",\"url\":\"https://aws.amazon.com/javascript/\"},\"license\":\"Apache-2.0\",\"browser\":{\"./dist-es/runtimeConfig\":\"./dist-es/runtimeConfig.browser\"},\"react-native\":{\"./dist-es/runtimeConfig\":\"./dist-es/runtimeConfig.native\"},\"homepage\":\"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-bedrock-runtime\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/aws/aws-sdk-js-v3.git\",\"directory\":\"clients/client-bedrock-runtime\"}}");







// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



var $17979f7ba1c80f39$export$ea4992a0ab9eff2d = /** @class */ function() {
    function AwsCrc32() {
        this.crc32 = new (0, $14a13df7f7f2c77f$export$16d8d62894c71747)();
    }
    AwsCrc32.prototype.update = function(toHash) {
        if ((0, $b61f34c6d51c0099$export$ea55f474a468804e)(toHash)) return;
        this.crc32.update((0, $4d83425858181b6d$export$4f21f20c2f1a9063)(toHash));
    };
    AwsCrc32.prototype.digest = function() {
        return (0, $4bd376b3ddf169e8$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $4bd376b3ddf169e8$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    (0, $f5620d206f522417$export$2527dfa2a193fcfa)(this.crc32.digest())
                ];
            });
        });
    };
    AwsCrc32.prototype.reset = function() {
        this.crc32 = new (0, $14a13df7f7f2c77f$export$16d8d62894c71747)();
    };
    return AwsCrc32;
}();


function $14a13df7f7f2c77f$export$1cd93882633e45f5(data) {
    return new $14a13df7f7f2c77f$export$16d8d62894c71747().update(data).digest();
}
var $14a13df7f7f2c77f$export$16d8d62894c71747 = /** @class */ function() {
    function Crc32() {
        this.checksum = 0xffffffff;
    }
    Crc32.prototype.update = function(data) {
        var e_1, _a;
        try {
            for(var data_1 = (0, $4bd376b3ddf169e8$export$19a8beecd37a4c45)(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()){
                var byte = data_1_1.value;
                this.checksum = this.checksum >>> 8 ^ $14a13df7f7f2c77f$var$lookupTable[(this.checksum ^ byte) & 0xff];
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return this;
    };
    Crc32.prototype.digest = function() {
        return (this.checksum ^ 0xffffffff) >>> 0;
    };
    return Crc32;
}();
// prettier-ignore
var $14a13df7f7f2c77f$var$a_lookUpTable = [
    0x00000000,
    0x77073096,
    0xEE0E612C,
    0x990951BA,
    0x076DC419,
    0x706AF48F,
    0xE963A535,
    0x9E6495A3,
    0x0EDB8832,
    0x79DCB8A4,
    0xE0D5E91E,
    0x97D2D988,
    0x09B64C2B,
    0x7EB17CBD,
    0xE7B82D07,
    0x90BF1D91,
    0x1DB71064,
    0x6AB020F2,
    0xF3B97148,
    0x84BE41DE,
    0x1ADAD47D,
    0x6DDDE4EB,
    0xF4D4B551,
    0x83D385C7,
    0x136C9856,
    0x646BA8C0,
    0xFD62F97A,
    0x8A65C9EC,
    0x14015C4F,
    0x63066CD9,
    0xFA0F3D63,
    0x8D080DF5,
    0x3B6E20C8,
    0x4C69105E,
    0xD56041E4,
    0xA2677172,
    0x3C03E4D1,
    0x4B04D447,
    0xD20D85FD,
    0xA50AB56B,
    0x35B5A8FA,
    0x42B2986C,
    0xDBBBC9D6,
    0xACBCF940,
    0x32D86CE3,
    0x45DF5C75,
    0xDCD60DCF,
    0xABD13D59,
    0x26D930AC,
    0x51DE003A,
    0xC8D75180,
    0xBFD06116,
    0x21B4F4B5,
    0x56B3C423,
    0xCFBA9599,
    0xB8BDA50F,
    0x2802B89E,
    0x5F058808,
    0xC60CD9B2,
    0xB10BE924,
    0x2F6F7C87,
    0x58684C11,
    0xC1611DAB,
    0xB6662D3D,
    0x76DC4190,
    0x01DB7106,
    0x98D220BC,
    0xEFD5102A,
    0x71B18589,
    0x06B6B51F,
    0x9FBFE4A5,
    0xE8B8D433,
    0x7807C9A2,
    0x0F00F934,
    0x9609A88E,
    0xE10E9818,
    0x7F6A0DBB,
    0x086D3D2D,
    0x91646C97,
    0xE6635C01,
    0x6B6B51F4,
    0x1C6C6162,
    0x856530D8,
    0xF262004E,
    0x6C0695ED,
    0x1B01A57B,
    0x8208F4C1,
    0xF50FC457,
    0x65B0D9C6,
    0x12B7E950,
    0x8BBEB8EA,
    0xFCB9887C,
    0x62DD1DDF,
    0x15DA2D49,
    0x8CD37CF3,
    0xFBD44C65,
    0x4DB26158,
    0x3AB551CE,
    0xA3BC0074,
    0xD4BB30E2,
    0x4ADFA541,
    0x3DD895D7,
    0xA4D1C46D,
    0xD3D6F4FB,
    0x4369E96A,
    0x346ED9FC,
    0xAD678846,
    0xDA60B8D0,
    0x44042D73,
    0x33031DE5,
    0xAA0A4C5F,
    0xDD0D7CC9,
    0x5005713C,
    0x270241AA,
    0xBE0B1010,
    0xC90C2086,
    0x5768B525,
    0x206F85B3,
    0xB966D409,
    0xCE61E49F,
    0x5EDEF90E,
    0x29D9C998,
    0xB0D09822,
    0xC7D7A8B4,
    0x59B33D17,
    0x2EB40D81,
    0xB7BD5C3B,
    0xC0BA6CAD,
    0xEDB88320,
    0x9ABFB3B6,
    0x03B6E20C,
    0x74B1D29A,
    0xEAD54739,
    0x9DD277AF,
    0x04DB2615,
    0x73DC1683,
    0xE3630B12,
    0x94643B84,
    0x0D6D6A3E,
    0x7A6A5AA8,
    0xE40ECF0B,
    0x9309FF9D,
    0x0A00AE27,
    0x7D079EB1,
    0xF00F9344,
    0x8708A3D2,
    0x1E01F268,
    0x6906C2FE,
    0xF762575D,
    0x806567CB,
    0x196C3671,
    0x6E6B06E7,
    0xFED41B76,
    0x89D32BE0,
    0x10DA7A5A,
    0x67DD4ACC,
    0xF9B9DF6F,
    0x8EBEEFF9,
    0x17B7BE43,
    0x60B08ED5,
    0xD6D6A3E8,
    0xA1D1937E,
    0x38D8C2C4,
    0x4FDFF252,
    0xD1BB67F1,
    0xA6BC5767,
    0x3FB506DD,
    0x48B2364B,
    0xD80D2BDA,
    0xAF0A1B4C,
    0x36034AF6,
    0x41047A60,
    0xDF60EFC3,
    0xA867DF55,
    0x316E8EEF,
    0x4669BE79,
    0xCB61B38C,
    0xBC66831A,
    0x256FD2A0,
    0x5268E236,
    0xCC0C7795,
    0xBB0B4703,
    0x220216B9,
    0x5505262F,
    0xC5BA3BBE,
    0xB2BD0B28,
    0x2BB45A92,
    0x5CB36A04,
    0xC2D7FFA7,
    0xB5D0CF31,
    0x2CD99E8B,
    0x5BDEAE1D,
    0x9B64C2B0,
    0xEC63F226,
    0x756AA39C,
    0x026D930A,
    0x9C0906A9,
    0xEB0E363F,
    0x72076785,
    0x05005713,
    0x95BF4A82,
    0xE2B87A14,
    0x7BB12BAE,
    0x0CB61B38,
    0x92D28E9B,
    0xE5D5BE0D,
    0x7CDCEFB7,
    0x0BDBDF21,
    0x86D3D2D4,
    0xF1D4E242,
    0x68DDB3F8,
    0x1FDA836E,
    0x81BE16CD,
    0xF6B9265B,
    0x6FB077E1,
    0x18B74777,
    0x88085AE6,
    0xFF0F6A70,
    0x66063BCA,
    0x11010B5C,
    0x8F659EFF,
    0xF862AE69,
    0x616BFFD3,
    0x166CCF45,
    0xA00AE278,
    0xD70DD2EE,
    0x4E048354,
    0x3903B3C2,
    0xA7672661,
    0xD06016F7,
    0x4969474D,
    0x3E6E77DB,
    0xAED16A4A,
    0xD9D65ADC,
    0x40DF0B66,
    0x37D83BF0,
    0xA9BCAE53,
    0xDEBB9EC5,
    0x47B2CF7F,
    0x30B5FFE9,
    0xBDBDF21C,
    0xCABAC28A,
    0x53B39330,
    0x24B4A3A6,
    0xBAD03605,
    0xCDD70693,
    0x54DE5729,
    0x23D967BF,
    0xB3667A2E,
    0xC4614AB8,
    0x5D681B02,
    0x2A6F2B94,
    0xB40BBE37,
    0xC30C8EA1,
    0x5A05DF1B,
    0x2D02EF8D
];
var $14a13df7f7f2c77f$var$lookupTable = (0, $139149fc62525fb6$export$b6739cd5a63159f9)($14a13df7f7f2c77f$var$a_lookUpTable);




class $944a833481bb67a1$export$8a5e19712a0a5deb {
    constructor(bytes){
        this.bytes = bytes;
        if (bytes.byteLength !== 8) throw new Error("Int64 buffers must be exactly 8 bytes");
    }
    static fromNumber(number) {
        if (number > 9223372036854776000 || number < -9223372036854776000) throw new Error(`${number} is too large (or, if negative, too small) to represent as an Int64`);
        const bytes = new Uint8Array(8);
        for(let i = 7, remaining = Math.abs(Math.round(number)); i > -1 && remaining > 0; i--, remaining /= 256)bytes[i] = remaining;
        if (number < 0) $944a833481bb67a1$var$negate(bytes);
        return new $944a833481bb67a1$export$8a5e19712a0a5deb(bytes);
    }
    valueOf() {
        const bytes = this.bytes.slice(0);
        const negative = bytes[0] & 128;
        if (negative) $944a833481bb67a1$var$negate(bytes);
        return parseInt((0, $e3760e64f3fec34b$export$7ea66e3774a60b67)(bytes), 16) * (negative ? -1 : 1);
    }
    toString() {
        return String(this.valueOf());
    }
}
function $944a833481bb67a1$var$negate(bytes) {
    for(let i = 0; i < 8; i++)bytes[i] ^= 0xff;
    for(let i = 7; i > -1; i--){
        bytes[i]++;
        if (bytes[i] !== 0) break;
    }
}


class $80ae52932767baac$export$74fd41a85c5dcec9 {
    constructor(toUtf8, fromUtf8){
        this.toUtf8 = toUtf8;
        this.fromUtf8 = fromUtf8;
    }
    format(headers) {
        const chunks = [];
        for (const headerName of Object.keys(headers)){
            const bytes = this.fromUtf8(headerName);
            chunks.push(Uint8Array.from([
                bytes.byteLength
            ]), bytes, this.formatHeaderValue(headers[headerName]));
        }
        const out = new Uint8Array(chunks.reduce((carry, bytes)=>carry + bytes.byteLength, 0));
        let position = 0;
        for (const chunk of chunks){
            out.set(chunk, position);
            position += chunk.byteLength;
        }
        return out;
    }
    formatHeaderValue(header) {
        switch(header.type){
            case "boolean":
                return Uint8Array.from([
                    header.value ? 0 : 1
                ]);
            case "byte":
                return Uint8Array.from([
                    2,
                    header.value
                ]);
            case "short":
                const shortView = new DataView(new ArrayBuffer(3));
                shortView.setUint8(0, 3);
                shortView.setInt16(1, header.value, false);
                return new Uint8Array(shortView.buffer);
            case "integer":
                const intView = new DataView(new ArrayBuffer(5));
                intView.setUint8(0, 4);
                intView.setInt32(1, header.value, false);
                return new Uint8Array(intView.buffer);
            case "long":
                const longBytes = new Uint8Array(9);
                longBytes[0] = 5;
                longBytes.set(header.value.bytes, 1);
                return longBytes;
            case "binary":
                const binView = new DataView(new ArrayBuffer(3 + header.value.byteLength));
                binView.setUint8(0, 6);
                binView.setUint16(1, header.value.byteLength, false);
                const binBytes = new Uint8Array(binView.buffer);
                binBytes.set(header.value, 3);
                return binBytes;
            case "string":
                const utf8Bytes = this.fromUtf8(header.value);
                const strView = new DataView(new ArrayBuffer(3 + utf8Bytes.byteLength));
                strView.setUint8(0, 7);
                strView.setUint16(1, utf8Bytes.byteLength, false);
                const strBytes = new Uint8Array(strView.buffer);
                strBytes.set(utf8Bytes, 3);
                return strBytes;
            case "timestamp":
                const tsBytes = new Uint8Array(9);
                tsBytes[0] = 8;
                tsBytes.set((0, $944a833481bb67a1$export$8a5e19712a0a5deb).fromNumber(header.value.valueOf()).bytes, 1);
                return tsBytes;
            case "uuid":
                if (!$80ae52932767baac$var$UUID_PATTERN.test(header.value)) throw new Error(`Invalid UUID received: ${header.value}`);
                const uuidBytes = new Uint8Array(17);
                uuidBytes[0] = 9;
                uuidBytes.set((0, $e3760e64f3fec34b$export$1a8ceedbd5845648)(header.value.replace(/\-/g, "")), 1);
                return uuidBytes;
        }
    }
    parse(headers) {
        const out = {};
        let position = 0;
        while(position < headers.byteLength){
            const nameLength = headers.getUint8(position++);
            const name = this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, nameLength));
            position += nameLength;
            switch(headers.getUint8(position++)){
                case 0:
                    out[name] = {
                        type: $80ae52932767baac$var$BOOLEAN_TAG,
                        value: true
                    };
                    break;
                case 1:
                    out[name] = {
                        type: $80ae52932767baac$var$BOOLEAN_TAG,
                        value: false
                    };
                    break;
                case 2:
                    out[name] = {
                        type: $80ae52932767baac$var$BYTE_TAG,
                        value: headers.getInt8(position++)
                    };
                    break;
                case 3:
                    out[name] = {
                        type: $80ae52932767baac$var$SHORT_TAG,
                        value: headers.getInt16(position, false)
                    };
                    position += 2;
                    break;
                case 4:
                    out[name] = {
                        type: $80ae52932767baac$var$INT_TAG,
                        value: headers.getInt32(position, false)
                    };
                    position += 4;
                    break;
                case 5:
                    out[name] = {
                        type: $80ae52932767baac$var$LONG_TAG,
                        value: new (0, $944a833481bb67a1$export$8a5e19712a0a5deb)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8))
                    };
                    position += 8;
                    break;
                case 6:
                    const binaryLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: $80ae52932767baac$var$BINARY_TAG,
                        value: new Uint8Array(headers.buffer, headers.byteOffset + position, binaryLength)
                    };
                    position += binaryLength;
                    break;
                case 7:
                    const stringLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: $80ae52932767baac$var$STRING_TAG,
                        value: this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, stringLength))
                    };
                    position += stringLength;
                    break;
                case 8:
                    out[name] = {
                        type: $80ae52932767baac$var$TIMESTAMP_TAG,
                        value: new Date(new (0, $944a833481bb67a1$export$8a5e19712a0a5deb)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8)).valueOf())
                    };
                    position += 8;
                    break;
                case 9:
                    const uuidBytes = new Uint8Array(headers.buffer, headers.byteOffset + position, 16);
                    position += 16;
                    out[name] = {
                        type: $80ae52932767baac$var$UUID_TAG,
                        value: `${(0, $e3760e64f3fec34b$export$7ea66e3774a60b67)(uuidBytes.subarray(0, 4))}-${(0, $e3760e64f3fec34b$export$7ea66e3774a60b67)(uuidBytes.subarray(4, 6))}-${(0, $e3760e64f3fec34b$export$7ea66e3774a60b67)(uuidBytes.subarray(6, 8))}-${(0, $e3760e64f3fec34b$export$7ea66e3774a60b67)(uuidBytes.subarray(8, 10))}-${(0, $e3760e64f3fec34b$export$7ea66e3774a60b67)(uuidBytes.subarray(10))}`
                    };
                    break;
                default:
                    throw new Error(`Unrecognized header type tag`);
            }
        }
        return out;
    }
}
var $80ae52932767baac$var$HEADER_VALUE_TYPE;
(function(HEADER_VALUE_TYPE) {
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolTrue"] = 0] = "boolTrue";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolFalse"] = 1] = "boolFalse";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byte"] = 2] = "byte";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["short"] = 3] = "short";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["integer"] = 4] = "integer";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["long"] = 5] = "long";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byteArray"] = 6] = "byteArray";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["string"] = 7] = "string";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["timestamp"] = 8] = "timestamp";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["uuid"] = 9] = "uuid";
})($80ae52932767baac$var$HEADER_VALUE_TYPE || ($80ae52932767baac$var$HEADER_VALUE_TYPE = {}));
const $80ae52932767baac$var$BOOLEAN_TAG = "boolean";
const $80ae52932767baac$var$BYTE_TAG = "byte";
const $80ae52932767baac$var$SHORT_TAG = "short";
const $80ae52932767baac$var$INT_TAG = "integer";
const $80ae52932767baac$var$LONG_TAG = "long";
const $80ae52932767baac$var$BINARY_TAG = "binary";
const $80ae52932767baac$var$STRING_TAG = "string";
const $80ae52932767baac$var$TIMESTAMP_TAG = "timestamp";
const $80ae52932767baac$var$UUID_TAG = "uuid";
const $80ae52932767baac$var$UUID_PATTERN = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;



const $b9d45db4575f4a00$var$PRELUDE_MEMBER_LENGTH = 4;
const $b9d45db4575f4a00$var$PRELUDE_LENGTH = $b9d45db4575f4a00$var$PRELUDE_MEMBER_LENGTH * 2;
const $b9d45db4575f4a00$var$CHECKSUM_LENGTH = 4;
const $b9d45db4575f4a00$var$MINIMUM_MESSAGE_LENGTH = $b9d45db4575f4a00$var$PRELUDE_LENGTH + $b9d45db4575f4a00$var$CHECKSUM_LENGTH * 2;
function $b9d45db4575f4a00$export$546b6bc432bd9a53({ byteLength: byteLength, byteOffset: byteOffset, buffer: buffer }) {
    if (byteLength < $b9d45db4575f4a00$var$MINIMUM_MESSAGE_LENGTH) throw new Error("Provided message too short to accommodate event stream message overhead");
    const view = new DataView(buffer, byteOffset, byteLength);
    const messageLength = view.getUint32(0, false);
    if (byteLength !== messageLength) throw new Error("Reported message length does not match received message length");
    const headerLength = view.getUint32($b9d45db4575f4a00$var$PRELUDE_MEMBER_LENGTH, false);
    const expectedPreludeChecksum = view.getUint32($b9d45db4575f4a00$var$PRELUDE_LENGTH, false);
    const expectedMessageChecksum = view.getUint32(byteLength - $b9d45db4575f4a00$var$CHECKSUM_LENGTH, false);
    const checksummer = new (0, $14a13df7f7f2c77f$export$16d8d62894c71747)().update(new Uint8Array(buffer, byteOffset, $b9d45db4575f4a00$var$PRELUDE_LENGTH));
    if (expectedPreludeChecksum !== checksummer.digest()) throw new Error(`The prelude checksum specified in the message (${expectedPreludeChecksum}) does not match the calculated CRC32 checksum (${checksummer.digest()})`);
    checksummer.update(new Uint8Array(buffer, byteOffset + $b9d45db4575f4a00$var$PRELUDE_LENGTH, byteLength - ($b9d45db4575f4a00$var$PRELUDE_LENGTH + $b9d45db4575f4a00$var$CHECKSUM_LENGTH)));
    if (expectedMessageChecksum !== checksummer.digest()) throw new Error(`The message checksum (${checksummer.digest()}) did not match the expected value of ${expectedMessageChecksum}`);
    return {
        headers: new DataView(buffer, byteOffset + $b9d45db4575f4a00$var$PRELUDE_LENGTH + $b9d45db4575f4a00$var$CHECKSUM_LENGTH, headerLength),
        body: new Uint8Array(buffer, byteOffset + $b9d45db4575f4a00$var$PRELUDE_LENGTH + $b9d45db4575f4a00$var$CHECKSUM_LENGTH + headerLength, messageLength - headerLength - ($b9d45db4575f4a00$var$PRELUDE_LENGTH + $b9d45db4575f4a00$var$CHECKSUM_LENGTH + $b9d45db4575f4a00$var$CHECKSUM_LENGTH))
    };
}


class $7fc4f2e3520db89a$export$60e2ad0c77b6bab {
    constructor(toUtf8, fromUtf8){
        this.headerMarshaller = new (0, $80ae52932767baac$export$74fd41a85c5dcec9)(toUtf8, fromUtf8);
        this.messageBuffer = [];
        this.isEndOfStream = false;
    }
    feed(message) {
        this.messageBuffer.push(this.decode(message));
    }
    endOfStream() {
        this.isEndOfStream = true;
    }
    getMessage() {
        const message = this.messageBuffer.pop();
        const isEndOfStream = this.isEndOfStream;
        return {
            getMessage () {
                return message;
            },
            isEndOfStream () {
                return isEndOfStream;
            }
        };
    }
    getAvailableMessages() {
        const messages = this.messageBuffer;
        this.messageBuffer = [];
        const isEndOfStream = this.isEndOfStream;
        return {
            getMessages () {
                return messages;
            },
            isEndOfStream () {
                return isEndOfStream;
            }
        };
    }
    encode({ headers: rawHeaders, body: body }) {
        const headers = this.headerMarshaller.format(rawHeaders);
        const length = headers.byteLength + body.byteLength + 16;
        const out = new Uint8Array(length);
        const view = new DataView(out.buffer, out.byteOffset, out.byteLength);
        const checksum = new (0, $14a13df7f7f2c77f$export$16d8d62894c71747)();
        view.setUint32(0, length, false);
        view.setUint32(4, headers.byteLength, false);
        view.setUint32(8, checksum.update(out.subarray(0, 8)).digest(), false);
        out.set(headers, 12);
        out.set(body, headers.byteLength + 12);
        view.setUint32(length - 4, checksum.update(out.subarray(8, length - 4)).digest(), false);
        return out;
    }
    decode(message) {
        const { headers: headers, body: body } = (0, $b9d45db4575f4a00$export$546b6bc432bd9a53)(message);
        return {
            headers: this.headerMarshaller.parse(headers),
            body: body
        };
    }
    formatHeaders(rawHeaders) {
        return this.headerMarshaller.format(rawHeaders);
    }
}






class $70b33a3a35622f58$export$4ffe73dc7dfe29dd {
    constructor(options){
        this.options = options;
    }
    [Symbol.asyncIterator]() {
        return this.asyncIterator();
    }
    async *asyncIterator() {
        for await (const bytes of this.options.inputStream){
            const decoded = this.options.decoder.decode(bytes);
            yield decoded;
        }
    }
}


class $b62f0e9442c2ac29$export$1204278c33e35f1b {
    constructor(options){
        this.options = options;
    }
    [Symbol.asyncIterator]() {
        return this.asyncIterator();
    }
    async *asyncIterator() {
        for await (const msg of this.options.messageStream){
            const encoded = this.options.encoder.encode(msg);
            yield encoded;
        }
        if (this.options.includeEndFrame) yield new Uint8Array(0);
    }
}


class $77a6dec70c7a35a3$export$c78403d78d3ee8a {
    constructor(options){
        this.options = options;
    }
    [Symbol.asyncIterator]() {
        return this.asyncIterator();
    }
    async *asyncIterator() {
        for await (const message of this.options.messageStream){
            const deserialized = await this.options.deserializer(message);
            if (deserialized === undefined) continue;
            yield deserialized;
        }
    }
}


class $2dd4718e847f8341$export$96361fe9dd919a8e {
    constructor(options){
        this.options = options;
    }
    [Symbol.asyncIterator]() {
        return this.asyncIterator();
    }
    async *asyncIterator() {
        for await (const chunk of this.options.inputStream){
            const payloadBuf = this.options.serializer(chunk);
            yield payloadBuf;
        }
    }
}




function $2c2f2c34ef31936a$export$3071cd8be9cd01e0(source) {
    let currentMessageTotalLength = 0;
    let currentMessagePendingLength = 0;
    let currentMessage = null;
    let messageLengthBuffer = null;
    const allocateMessage = (size)=>{
        if (typeof size !== "number") throw new Error("Attempted to allocate an event message where size was not a number: " + size);
        currentMessageTotalLength = size;
        currentMessagePendingLength = 4;
        currentMessage = new Uint8Array(size);
        const currentMessageView = new DataView(currentMessage.buffer);
        currentMessageView.setUint32(0, size, false);
    };
    const iterator = async function*() {
        const sourceIterator = source[Symbol.asyncIterator]();
        while(true){
            const { value: value, done: done } = await sourceIterator.next();
            if (done) {
                if (!currentMessageTotalLength) return;
                else if (currentMessageTotalLength === currentMessagePendingLength) yield currentMessage;
                else throw new Error("Truncated event message received.");
                return;
            }
            const chunkLength = value.length;
            let currentOffset = 0;
            while(currentOffset < chunkLength){
                if (!currentMessage) {
                    const bytesRemaining = chunkLength - currentOffset;
                    if (!messageLengthBuffer) messageLengthBuffer = new Uint8Array(4);
                    const numBytesForTotal = Math.min(4 - currentMessagePendingLength, bytesRemaining);
                    messageLengthBuffer.set(value.slice(currentOffset, currentOffset + numBytesForTotal), currentMessagePendingLength);
                    currentMessagePendingLength += numBytesForTotal;
                    currentOffset += numBytesForTotal;
                    if (currentMessagePendingLength < 4) break;
                    allocateMessage(new DataView(messageLengthBuffer.buffer).getUint32(0, false));
                    messageLengthBuffer = null;
                }
                const numBytesToWrite = Math.min(currentMessageTotalLength - currentMessagePendingLength, chunkLength - currentOffset);
                currentMessage.set(value.slice(currentOffset, currentOffset + numBytesToWrite), currentMessagePendingLength);
                currentMessagePendingLength += numBytesToWrite;
                currentOffset += numBytesToWrite;
                if (currentMessageTotalLength && currentMessageTotalLength === currentMessagePendingLength) {
                    yield currentMessage;
                    currentMessage = null;
                    currentMessageTotalLength = 0;
                    currentMessagePendingLength = 0;
                }
            }
        }
    };
    return {
        [Symbol.asyncIterator]: iterator
    };
}


function $625d4431debd6dd9$export$a1a364c5c6ddc1b4(source, options) {
    const messageUnmarshaller = $625d4431debd6dd9$export$5ecf053b59827691(options.deserializer, options.toUtf8);
    return {
        [Symbol.asyncIterator]: async function*() {
            for await (const chunk of source){
                const message = options.eventStreamCodec.decode(chunk);
                const type = await messageUnmarshaller(message);
                if (type === undefined) continue;
                yield type;
            }
        }
    };
}
function $625d4431debd6dd9$export$5ecf053b59827691(deserializer, toUtf8) {
    return async function(message) {
        const { value: messageType } = message.headers[":message-type"];
        if (messageType === "error") {
            const unmodeledError = new Error(message.headers[":error-message"].value || "UnknownError");
            unmodeledError.name = message.headers[":error-code"].value;
            throw unmodeledError;
        } else if (messageType === "exception") {
            const code = message.headers[":exception-type"].value;
            const exception = {
                [code]: message
            };
            const deserializedException = await deserializer(exception);
            if (deserializedException.$unknown) {
                const error = new Error(toUtf8(message.body));
                error.name = code;
                throw error;
            }
            throw deserializedException[code];
        } else if (messageType === "event") {
            const event = {
                [message.headers[":event-type"].value]: message
            };
            const deserialized = await deserializer(event);
            if (deserialized.$unknown) return;
            return deserialized;
        } else throw Error(`Unrecognizable event type: ${message.headers[":event-type"].value}`);
    };
}


class $4a38ed4f8b0154f1$export$b64afa0aa6ce60e2 {
    constructor({ utf8Encoder: utf8Encoder, utf8Decoder: utf8Decoder }){
        this.eventStreamCodec = new (0, $7fc4f2e3520db89a$export$60e2ad0c77b6bab)(utf8Encoder, utf8Decoder);
        this.utfEncoder = utf8Encoder;
    }
    deserialize(body, deserializer) {
        const inputStream = (0, $2c2f2c34ef31936a$export$3071cd8be9cd01e0)(body);
        return new (0, $77a6dec70c7a35a3$export$c78403d78d3ee8a)({
            messageStream: new (0, $70b33a3a35622f58$export$4ffe73dc7dfe29dd)({
                inputStream: inputStream,
                decoder: this.eventStreamCodec
            }),
            deserializer: (0, $625d4431debd6dd9$export$5ecf053b59827691)(deserializer, this.utfEncoder)
        });
    }
    serialize(inputStream, serializer) {
        return new (0, $b62f0e9442c2ac29$export$1204278c33e35f1b)({
            messageStream: new (0, $2dd4718e847f8341$export$96361fe9dd919a8e)({
                inputStream: inputStream,
                serializer: serializer
            }),
            encoder: this.eventStreamCodec,
            includeEndFrame: true
        });
    }
}



const $1d0b95d393a40056$export$9d23a885702ebafb = (options)=>new (0, $4a38ed4f8b0154f1$export$b64afa0aa6ce60e2)(options);




const $6cff5f05bb67415b$export$2346526b0991dd88 = (readableStream)=>({
        [Symbol.asyncIterator]: async function*() {
            const reader = readableStream.getReader();
            try {
                while(true){
                    const { done: done, value: value } = await reader.read();
                    if (done) return;
                    yield value;
                }
            } finally{
                reader.releaseLock();
            }
        }
    });
const $6cff5f05bb67415b$export$92326f9d37f111f = (asyncIterable)=>{
    const iterator = asyncIterable[Symbol.asyncIterator]();
    return new ReadableStream({
        async pull (controller) {
            const { done: done, value: value } = await iterator.next();
            if (done) return controller.close();
            controller.enqueue(value);
        }
    });
};


class $b1b32b7c39dd545c$export$b64afa0aa6ce60e2 {
    constructor({ utf8Encoder: utf8Encoder, utf8Decoder: utf8Decoder }){
        this.universalMarshaller = new (0, $4a38ed4f8b0154f1$export$b64afa0aa6ce60e2)({
            utf8Decoder: utf8Decoder,
            utf8Encoder: utf8Encoder
        });
    }
    deserialize(body, deserializer) {
        const bodyIterable = $b1b32b7c39dd545c$var$isReadableStream(body) ? (0, $6cff5f05bb67415b$export$2346526b0991dd88)(body) : body;
        return this.universalMarshaller.deserialize(bodyIterable, deserializer);
    }
    serialize(input, serializer) {
        const serialziedIterable = this.universalMarshaller.serialize(input, serializer);
        return typeof ReadableStream === "function" ? (0, $6cff5f05bb67415b$export$92326f9d37f111f)(serialziedIterable) : serialziedIterable;
    }
}
const $b1b32b7c39dd545c$var$isReadableStream = (body)=>typeof ReadableStream === "function" && body instanceof ReadableStream;



const $6dc1cc7d0b5001d1$export$9d23a885702ebafb = (options)=>new (0, $b1b32b7c39dd545c$export$b64afa0aa6ce60e2)(options);

















const $983611a0d97f2b00$var$s = "required", $983611a0d97f2b00$var$t = "fn", $983611a0d97f2b00$var$u = "argv", $983611a0d97f2b00$var$v = "ref";
const $983611a0d97f2b00$var$a = true, $983611a0d97f2b00$var$b = "isSet", $983611a0d97f2b00$var$c = "booleanEquals", $983611a0d97f2b00$var$d = "error", $983611a0d97f2b00$var$e = "endpoint", $983611a0d97f2b00$var$f = "tree", $983611a0d97f2b00$var$g = "PartitionResult", $983611a0d97f2b00$var$h = {
    [$983611a0d97f2b00$var$s]: false,
    "type": "String"
}, $983611a0d97f2b00$var$i = {
    [$983611a0d97f2b00$var$s]: true,
    "default": false,
    "type": "Boolean"
}, $983611a0d97f2b00$var$j = {
    [$983611a0d97f2b00$var$v]: "Endpoint"
}, $983611a0d97f2b00$var$k = {
    [$983611a0d97f2b00$var$t]: $983611a0d97f2b00$var$c,
    [$983611a0d97f2b00$var$u]: [
        {
            [$983611a0d97f2b00$var$v]: "UseFIPS"
        },
        true
    ]
}, $983611a0d97f2b00$var$l = {
    [$983611a0d97f2b00$var$t]: $983611a0d97f2b00$var$c,
    [$983611a0d97f2b00$var$u]: [
        {
            [$983611a0d97f2b00$var$v]: "UseDualStack"
        },
        true
    ]
}, $983611a0d97f2b00$var$m = {}, $983611a0d97f2b00$var$n = {
    [$983611a0d97f2b00$var$t]: "getAttr",
    [$983611a0d97f2b00$var$u]: [
        {
            [$983611a0d97f2b00$var$v]: $983611a0d97f2b00$var$g
        },
        "supportsFIPS"
    ]
}, $983611a0d97f2b00$var$o = {
    [$983611a0d97f2b00$var$t]: $983611a0d97f2b00$var$c,
    [$983611a0d97f2b00$var$u]: [
        true,
        {
            [$983611a0d97f2b00$var$t]: "getAttr",
            [$983611a0d97f2b00$var$u]: [
                {
                    [$983611a0d97f2b00$var$v]: $983611a0d97f2b00$var$g
                },
                "supportsDualStack"
            ]
        }
    ]
}, $983611a0d97f2b00$var$p = [
    $983611a0d97f2b00$var$k
], $983611a0d97f2b00$var$q = [
    $983611a0d97f2b00$var$l
], $983611a0d97f2b00$var$r = [
    {
        [$983611a0d97f2b00$var$v]: "Region"
    }
];
const $983611a0d97f2b00$var$_data = {
    version: "1.0",
    parameters: {
        Region: $983611a0d97f2b00$var$h,
        UseDualStack: $983611a0d97f2b00$var$i,
        UseFIPS: $983611a0d97f2b00$var$i,
        Endpoint: $983611a0d97f2b00$var$h
    },
    rules: [
        {
            conditions: [
                {
                    [$983611a0d97f2b00$var$t]: $983611a0d97f2b00$var$b,
                    [$983611a0d97f2b00$var$u]: [
                        $983611a0d97f2b00$var$j
                    ]
                }
            ],
            rules: [
                {
                    conditions: $983611a0d97f2b00$var$p,
                    error: "Invalid Configuration: FIPS and custom endpoint are not supported",
                    type: $983611a0d97f2b00$var$d
                },
                {
                    rules: [
                        {
                            conditions: $983611a0d97f2b00$var$q,
                            error: "Invalid Configuration: Dualstack and custom endpoint are not supported",
                            type: $983611a0d97f2b00$var$d
                        },
                        {
                            endpoint: {
                                url: $983611a0d97f2b00$var$j,
                                properties: $983611a0d97f2b00$var$m,
                                headers: $983611a0d97f2b00$var$m
                            },
                            type: $983611a0d97f2b00$var$e
                        }
                    ],
                    type: $983611a0d97f2b00$var$f
                }
            ],
            type: $983611a0d97f2b00$var$f
        },
        {
            rules: [
                {
                    conditions: [
                        {
                            [$983611a0d97f2b00$var$t]: $983611a0d97f2b00$var$b,
                            [$983611a0d97f2b00$var$u]: $983611a0d97f2b00$var$r
                        }
                    ],
                    rules: [
                        {
                            conditions: [
                                {
                                    [$983611a0d97f2b00$var$t]: "aws.partition",
                                    [$983611a0d97f2b00$var$u]: $983611a0d97f2b00$var$r,
                                    assign: $983611a0d97f2b00$var$g
                                }
                            ],
                            rules: [
                                {
                                    conditions: [
                                        $983611a0d97f2b00$var$k,
                                        $983611a0d97f2b00$var$l
                                    ],
                                    rules: [
                                        {
                                            conditions: [
                                                {
                                                    [$983611a0d97f2b00$var$t]: $983611a0d97f2b00$var$c,
                                                    [$983611a0d97f2b00$var$u]: [
                                                        $983611a0d97f2b00$var$a,
                                                        $983611a0d97f2b00$var$n
                                                    ]
                                                },
                                                $983611a0d97f2b00$var$o
                                            ],
                                            rules: [
                                                {
                                                    rules: [
                                                        {
                                                            endpoint: {
                                                                url: "https://bedrock-runtime-fips.{Region}.{PartitionResult#dualStackDnsSuffix}",
                                                                properties: $983611a0d97f2b00$var$m,
                                                                headers: $983611a0d97f2b00$var$m
                                                            },
                                                            type: $983611a0d97f2b00$var$e
                                                        }
                                                    ],
                                                    type: $983611a0d97f2b00$var$f
                                                }
                                            ],
                                            type: $983611a0d97f2b00$var$f
                                        },
                                        {
                                            error: "FIPS and DualStack are enabled, but this partition does not support one or both",
                                            type: $983611a0d97f2b00$var$d
                                        }
                                    ],
                                    type: $983611a0d97f2b00$var$f
                                },
                                {
                                    conditions: $983611a0d97f2b00$var$p,
                                    rules: [
                                        {
                                            conditions: [
                                                {
                                                    [$983611a0d97f2b00$var$t]: $983611a0d97f2b00$var$c,
                                                    [$983611a0d97f2b00$var$u]: [
                                                        $983611a0d97f2b00$var$n,
                                                        $983611a0d97f2b00$var$a
                                                    ]
                                                }
                                            ],
                                            rules: [
                                                {
                                                    rules: [
                                                        {
                                                            endpoint: {
                                                                url: "https://bedrock-runtime-fips.{Region}.{PartitionResult#dnsSuffix}",
                                                                properties: $983611a0d97f2b00$var$m,
                                                                headers: $983611a0d97f2b00$var$m
                                                            },
                                                            type: $983611a0d97f2b00$var$e
                                                        }
                                                    ],
                                                    type: $983611a0d97f2b00$var$f
                                                }
                                            ],
                                            type: $983611a0d97f2b00$var$f
                                        },
                                        {
                                            error: "FIPS is enabled but this partition does not support FIPS",
                                            type: $983611a0d97f2b00$var$d
                                        }
                                    ],
                                    type: $983611a0d97f2b00$var$f
                                },
                                {
                                    conditions: $983611a0d97f2b00$var$q,
                                    rules: [
                                        {
                                            conditions: [
                                                $983611a0d97f2b00$var$o
                                            ],
                                            rules: [
                                                {
                                                    rules: [
                                                        {
                                                            endpoint: {
                                                                url: "https://bedrock-runtime.{Region}.{PartitionResult#dualStackDnsSuffix}",
                                                                properties: $983611a0d97f2b00$var$m,
                                                                headers: $983611a0d97f2b00$var$m
                                                            },
                                                            type: $983611a0d97f2b00$var$e
                                                        }
                                                    ],
                                                    type: $983611a0d97f2b00$var$f
                                                }
                                            ],
                                            type: $983611a0d97f2b00$var$f
                                        },
                                        {
                                            error: "DualStack is enabled but this partition does not support DualStack",
                                            type: $983611a0d97f2b00$var$d
                                        }
                                    ],
                                    type: $983611a0d97f2b00$var$f
                                },
                                {
                                    rules: [
                                        {
                                            endpoint: {
                                                url: "https://bedrock-runtime.{Region}.{PartitionResult#dnsSuffix}",
                                                properties: $983611a0d97f2b00$var$m,
                                                headers: $983611a0d97f2b00$var$m
                                            },
                                            type: $983611a0d97f2b00$var$e
                                        }
                                    ],
                                    type: $983611a0d97f2b00$var$f
                                }
                            ],
                            type: $983611a0d97f2b00$var$f
                        }
                    ],
                    type: $983611a0d97f2b00$var$f
                },
                {
                    error: "Invalid Configuration: Missing Region",
                    type: $983611a0d97f2b00$var$d
                }
            ],
            type: $983611a0d97f2b00$var$f
        }
    ]
};
const $983611a0d97f2b00$export$7b249e066372152f = $983611a0d97f2b00$var$_data;


const $d6da7581fa9bb733$var$cache = new (0, $d06f12251068eb72$export$262eb2e4804ef909)({
    size: 50,
    params: [
        "Endpoint",
        "Region",
        "UseDualStack",
        "UseFIPS"
    ]
});
const $d6da7581fa9bb733$export$47fc6e98c86e06e3 = (endpointParams, context = {})=>{
    return $d6da7581fa9bb733$var$cache.get(endpointParams, ()=>(0, $c21f7418bd0df18f$export$48b88e4e5ecac119)((0, $983611a0d97f2b00$export$7b249e066372152f), {
            endpointParams: endpointParams,
            logger: context.logger
        }));
};
(0, $91b7ba976acbb024$export$2614fba0847da171).aws = (0, $8e31713c360183c3$export$1bfd97ffc6d0eef8);


const $78818746f0d108ff$export$ad0966540b0e71e5 = (config)=>{
    return {
        apiVersion: "2023-09-30",
        base64Decoder: config?.base64Decoder ?? (0, $7b3498acd0b4495b$export$c537b38001c583b7),
        base64Encoder: config?.base64Encoder ?? (0, $d63237a3fb21a427$export$37cc283d8fbd3462),
        disableHostPrefix: config?.disableHostPrefix ?? false,
        endpointProvider: config?.endpointProvider ?? (0, $d6da7581fa9bb733$export$47fc6e98c86e06e3),
        extensions: config?.extensions ?? [],
        httpAuthSchemeProvider: config?.httpAuthSchemeProvider ?? (0, $438932d6c6f0eba7$export$f9e04465771042),
        httpAuthSchemes: config?.httpAuthSchemes ?? [
            {
                schemeId: "aws.auth#sigv4",
                identityProvider: (ipc)=>ipc.getIdentityProvider("aws.auth#sigv4"),
                signer: new (0, $93763e910902e47b$export$8d10c019aa195a2b)()
            }
        ],
        logger: config?.logger ?? new (0, $c9caefe05bf12396$export$4147bde06f294c2e)(),
        serviceId: config?.serviceId ?? "Bedrock Runtime",
        urlParser: config?.urlParser ?? (0, $931d216cb423ad36$export$7a5253c0f62e0150),
        utf8Decoder: config?.utf8Decoder ?? (0, $443e71811b7d31c6$export$c7c5cef950a4d2fc),
        utf8Encoder: config?.utf8Encoder ?? (0, $5a195679de934416$export$b4b216764bb846eb)
    };
};




const $bfb0744e5919f801$export$ad0966540b0e71e5 = (config)=>{
    const defaultsMode = (0, $4b5f1111656da5bf$export$b146d618450007ac)(config);
    const defaultConfigProvider = ()=>defaultsMode().then((0, $9ab7bd0f453434be$export$b6e2b46631b45a92));
    const clientSharedValues = (0, $78818746f0d108ff$export$ad0966540b0e71e5)(config);
    return {
        ...clientSharedValues,
        ...config,
        runtime: "browser",
        defaultsMode: defaultsMode,
        bodyLengthChecker: config?.bodyLengthChecker ?? (0, $9e4c3027d336cb04$export$967f3527bf233bc0),
        credentialDefaultProvider: config?.credentialDefaultProvider ?? ((_)=>()=>Promise.reject(new Error("Credential is missing"))),
        defaultUserAgentProvider: config?.defaultUserAgentProvider ?? (0, $6bb11abd8422769c$export$c132edb4cf3f7b9c)({
            serviceId: clientSharedValues.serviceId,
            clientVersion: (0, (/*@__PURE__*/$parcel$interopDefault($4d8dffe09d638ad4$exports))).version
        }),
        eventStreamSerdeProvider: config?.eventStreamSerdeProvider ?? (0, $6dc1cc7d0b5001d1$export$9d23a885702ebafb),
        maxAttempts: config?.maxAttempts ?? (0, $5509594642b1e771$export$2c7e51f38ba5a406),
        region: config?.region ?? (0, $2e5ffb59202a2d85$export$d59dd53963f8f3d5)("Region is missing"),
        requestHandler: (0, $40b502f5f0978093$export$83588b87edbfa7e0).create(config?.requestHandler ?? defaultConfigProvider),
        retryMode: config?.retryMode ?? (async ()=>(await defaultConfigProvider()).retryMode || (0, $5509594642b1e771$export$41315747b7c5d042)),
        sha256: config?.sha256 ?? (0, $96d9020e18f0029b$export$3b58ea8124ac5e28),
        streamCollector: config?.streamCollector ?? (0, $03d6a1cc7230aa78$export$17bf97b72e307d52),
        useDualstackEndpoint: config?.useDualstackEndpoint ?? (()=>Promise.resolve((0, $8bc367ec79540d60$export$beb01fae7626c427))),
        useFipsEndpoint: config?.useFipsEndpoint ?? (()=>Promise.resolve((0, $6569393054577581$export$5555deeca435a10b)))
    };
};





const $48ad45c5adb89bb1$export$e536d87ced0d9700 = (runtimeConfig)=>{
    const _httpAuthSchemes = runtimeConfig.httpAuthSchemes;
    let _httpAuthSchemeProvider = runtimeConfig.httpAuthSchemeProvider;
    let _credentials = runtimeConfig.credentials;
    return {
        setHttpAuthScheme (httpAuthScheme) {
            const index = _httpAuthSchemes.findIndex((scheme)=>scheme.schemeId === httpAuthScheme.schemeId);
            if (index === -1) _httpAuthSchemes.push(httpAuthScheme);
            else _httpAuthSchemes.splice(index, 1, httpAuthScheme);
        },
        httpAuthSchemes () {
            return _httpAuthSchemes;
        },
        setHttpAuthSchemeProvider (httpAuthSchemeProvider) {
            _httpAuthSchemeProvider = httpAuthSchemeProvider;
        },
        httpAuthSchemeProvider () {
            return _httpAuthSchemeProvider;
        },
        setCredentials (credentials) {
            _credentials = credentials;
        },
        credentials () {
            return _credentials;
        }
    };
};
const $48ad45c5adb89bb1$export$60c55f59b27530a8 = (config)=>{
    return {
        httpAuthSchemes: config.httpAuthSchemes(),
        httpAuthSchemeProvider: config.httpAuthSchemeProvider(),
        credentials: config.credentials()
    };
};


const $1c64e8138f343e34$var$asPartial = (t)=>t;
const $1c64e8138f343e34$export$4278118b303a14cf = (runtimeConfig, extensions)=>{
    const extensionConfiguration = {
        ...$1c64e8138f343e34$var$asPartial((0, $f7899cd52cf70df9$export$be3086d183cd8ea6)(runtimeConfig)),
        ...$1c64e8138f343e34$var$asPartial((0, $cef2627dbb2c7da1$export$2d53aaae46f156f5)(runtimeConfig)),
        ...$1c64e8138f343e34$var$asPartial((0, $84f26894dd035c27$export$663b205817703038)(runtimeConfig)),
        ...$1c64e8138f343e34$var$asPartial((0, $48ad45c5adb89bb1$export$e536d87ced0d9700)(runtimeConfig))
    };
    extensions.forEach((extension)=>extension.configure(extensionConfiguration));
    return {
        ...runtimeConfig,
        ...(0, $f7899cd52cf70df9$export$74973a8fb8dfc16e)(extensionConfiguration),
        ...(0, $cef2627dbb2c7da1$export$abfa28b95316e0ae)(extensionConfiguration),
        ...(0, $84f26894dd035c27$export$d94fe0350385c1a8)(extensionConfiguration),
        ...(0, $48ad45c5adb89bb1$export$60c55f59b27530a8)(extensionConfiguration)
    };
};


class $cbca8837a0c60e3d$export$6372a0043ccbda8 extends (0, $514104a2dba81648$export$1f2bb630327ac4b6) {
    config;
    constructor(...[configuration]){
        const _config_0 = (0, $bfb0744e5919f801$export$ad0966540b0e71e5)(configuration || {});
        const _config_1 = (0, $e94babf240abe10f$export$70b6341cd51750a8)(_config_0);
        const _config_2 = (0, $3b038e7801e78d35$export$ec9a2d5663958cb)(_config_1);
        const _config_3 = (0, $5ca3ff7097febeef$export$ca7f6138f2c98476)(_config_2);
        const _config_4 = (0, $83ef33ca75f7dd65$export$7696ef37558bd0ec)(_config_3);
        const _config_5 = (0, $b173a3ce9281b3cf$export$c1625bf0b32b4481)(_config_4);
        const _config_6 = (0, $dedc7eba2c45bbb9$export$8c5b66831e3f26ff)(_config_5);
        const _config_7 = (0, $bef36ba9ce16a8b4$export$5e2ae00bf65442f0)(_config_6);
        const _config_8 = (0, $438932d6c6f0eba7$export$d38ef9c0c6c649ab)(_config_7);
        const _config_9 = (0, $1c64e8138f343e34$export$4278118b303a14cf)(_config_8, configuration?.extensions || []);
        super(_config_9);
        this.config = _config_9;
        this.middlewareStack.use((0, $168add9a52432ffc$export$5393c0d2d7f4f5f0)(this.config));
        this.middlewareStack.use((0, $9ba3cc7a799aee7e$export$c73199e2b1df9340)(this.config));
        this.middlewareStack.use((0, $88932ea823bca647$export$7e6ddf9365a30fe9)(this.config));
        this.middlewareStack.use((0, $b173a3ce9281b3cf$export$23d3b647211be53a)(this.config));
        this.middlewareStack.use((0, $60459010f05dd111$export$f6ef65d7766fc255)(this.config));
        this.middlewareStack.use((0, $8825720894d7451a$export$11d0b9345788bd5)(this.config));
        this.middlewareStack.use((0, $1fcce1fc5214c9cb$export$6ababc1a6356ca41)(this.config, {
            httpAuthSchemeParametersProvider: (0, $438932d6c6f0eba7$export$c693595f739216c8),
            identityProviderConfigProvider: async (config)=>new (0, $99ebb391854b554e$export$67f43b78065c5551)({
                    "aws.auth#sigv4": config.credentials
                })
        }));
        this.middlewareStack.use((0, $a232cb521b867f08$export$ed476aa7e410a)(this.config));
    }
    destroy() {
        super.destroy();
    }
}







class $1ccdb23ad82d330a$export$8ff385b3d0137dea extends (0, $11a0343ffd48eaff$export$29647f3b4097d3c0) {
    constructor(options){
        super(options);
        Object.setPrototypeOf(this, $1ccdb23ad82d330a$export$8ff385b3d0137dea.prototype);
    }
}


class $983bf56ae6c3bba6$export$c8018838fe3c6395 extends (0, $1ccdb23ad82d330a$export$8ff385b3d0137dea) {
    name = "AccessDeniedException";
    $fault = "client";
    constructor(opts){
        super({
            name: "AccessDeniedException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $983bf56ae6c3bba6$export$c8018838fe3c6395.prototype);
    }
}
var $983bf56ae6c3bba6$export$458d4553df4f18f5;
(function(AsyncInvokeOutputDataConfig) {
    AsyncInvokeOutputDataConfig.visit = (value, visitor)=>{
        if (value.s3OutputDataConfig !== undefined) return visitor.s3OutputDataConfig(value.s3OutputDataConfig);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($983bf56ae6c3bba6$export$458d4553df4f18f5 || ($983bf56ae6c3bba6$export$458d4553df4f18f5 = {}));
const $983bf56ae6c3bba6$export$df19cca0999772be = {
    COMPLETED: "Completed",
    FAILED: "Failed",
    IN_PROGRESS: "InProgress"
};
class $983bf56ae6c3bba6$export$e2a300c9568821ec extends (0, $1ccdb23ad82d330a$export$8ff385b3d0137dea) {
    name = "InternalServerException";
    $fault = "server";
    constructor(opts){
        super({
            name: "InternalServerException",
            $fault: "server",
            ...opts
        });
        Object.setPrototypeOf(this, $983bf56ae6c3bba6$export$e2a300c9568821ec.prototype);
    }
}
class $983bf56ae6c3bba6$export$f18ab84fe430e4f3 extends (0, $1ccdb23ad82d330a$export$8ff385b3d0137dea) {
    name = "ThrottlingException";
    $fault = "client";
    constructor(opts){
        super({
            name: "ThrottlingException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $983bf56ae6c3bba6$export$f18ab84fe430e4f3.prototype);
    }
}
class $983bf56ae6c3bba6$export$1dbb1718e06c41be extends (0, $1ccdb23ad82d330a$export$8ff385b3d0137dea) {
    name = "ValidationException";
    $fault = "client";
    constructor(opts){
        super({
            name: "ValidationException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $983bf56ae6c3bba6$export$1dbb1718e06c41be.prototype);
    }
}
const $983bf56ae6c3bba6$export$970fd42d1f368698 = {
    SUBMISSION_TIME: "SubmissionTime"
};
const $983bf56ae6c3bba6$export$7ae723045d45777a = {
    ASCENDING: "Ascending",
    DESCENDING: "Descending"
};
class $983bf56ae6c3bba6$export$c64b14d0b7091188 extends (0, $1ccdb23ad82d330a$export$8ff385b3d0137dea) {
    name = "ConflictException";
    $fault = "client";
    constructor(opts){
        super({
            name: "ConflictException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $983bf56ae6c3bba6$export$c64b14d0b7091188.prototype);
    }
}
class $983bf56ae6c3bba6$export$ecba565262f8bb2 extends (0, $1ccdb23ad82d330a$export$8ff385b3d0137dea) {
    name = "ResourceNotFoundException";
    $fault = "client";
    constructor(opts){
        super({
            name: "ResourceNotFoundException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $983bf56ae6c3bba6$export$ecba565262f8bb2.prototype);
    }
}
class $983bf56ae6c3bba6$export$1b9058cd2021c1aa extends (0, $1ccdb23ad82d330a$export$8ff385b3d0137dea) {
    name = "ServiceQuotaExceededException";
    $fault = "client";
    constructor(opts){
        super({
            name: "ServiceQuotaExceededException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $983bf56ae6c3bba6$export$1b9058cd2021c1aa.prototype);
    }
}
class $983bf56ae6c3bba6$export$a9c34d9f9b02169a extends (0, $1ccdb23ad82d330a$export$8ff385b3d0137dea) {
    name = "ServiceUnavailableException";
    $fault = "server";
    constructor(opts){
        super({
            name: "ServiceUnavailableException",
            $fault: "server",
            ...opts
        });
        Object.setPrototypeOf(this, $983bf56ae6c3bba6$export$a9c34d9f9b02169a.prototype);
    }
}
const $983bf56ae6c3bba6$export$ed049d4da7c002d2 = {
    JPEG: "jpeg",
    PNG: "png"
};
var $983bf56ae6c3bba6$export$ec94a271fc9e24c4;
(function(GuardrailImageSource) {
    GuardrailImageSource.visit = (value, visitor)=>{
        if (value.bytes !== undefined) return visitor.bytes(value.bytes);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($983bf56ae6c3bba6$export$ec94a271fc9e24c4 || ($983bf56ae6c3bba6$export$ec94a271fc9e24c4 = {}));
const $983bf56ae6c3bba6$export$275ce912bba5a026 = {
    GROUNDING_SOURCE: "grounding_source",
    GUARD_CONTENT: "guard_content",
    QUERY: "query"
};
var $983bf56ae6c3bba6$export$68cc35827b3472dc;
(function(GuardrailContentBlock) {
    GuardrailContentBlock.visit = (value, visitor)=>{
        if (value.text !== undefined) return visitor.text(value.text);
        if (value.image !== undefined) return visitor.image(value.image);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($983bf56ae6c3bba6$export$68cc35827b3472dc || ($983bf56ae6c3bba6$export$68cc35827b3472dc = {}));
const $983bf56ae6c3bba6$export$90435df5d0859ef1 = {
    INPUT: "INPUT",
    OUTPUT: "OUTPUT"
};
const $983bf56ae6c3bba6$export$3821f53c6537a63f = {
    GUARDRAIL_INTERVENED: "GUARDRAIL_INTERVENED",
    NONE: "NONE"
};
const $983bf56ae6c3bba6$export$9464278d48868556 = {
    BLOCKED: "BLOCKED"
};
const $983bf56ae6c3bba6$export$bfcde047de4fa46e = {
    HIGH: "HIGH",
    LOW: "LOW",
    MEDIUM: "MEDIUM",
    NONE: "NONE"
};
const $983bf56ae6c3bba6$export$cc28ed34bbd370e0 = {
    HIGH: "HIGH",
    LOW: "LOW",
    MEDIUM: "MEDIUM",
    NONE: "NONE"
};
const $983bf56ae6c3bba6$export$712495891de24d96 = {
    HATE: "HATE",
    INSULTS: "INSULTS",
    MISCONDUCT: "MISCONDUCT",
    PROMPT_ATTACK: "PROMPT_ATTACK",
    SEXUAL: "SEXUAL",
    VIOLENCE: "VIOLENCE"
};
const $983bf56ae6c3bba6$export$33a73058c00ef29f = {
    BLOCKED: "BLOCKED",
    NONE: "NONE"
};
const $983bf56ae6c3bba6$export$f55080011681314b = {
    GROUNDING: "GROUNDING",
    RELEVANCE: "RELEVANCE"
};
const $983bf56ae6c3bba6$export$ec46a7a856f655e4 = {
    ANONYMIZED: "ANONYMIZED",
    BLOCKED: "BLOCKED"
};
const $983bf56ae6c3bba6$export$69c7db5a05861fbf = {
    ADDRESS: "ADDRESS",
    AGE: "AGE",
    AWS_ACCESS_KEY: "AWS_ACCESS_KEY",
    AWS_SECRET_KEY: "AWS_SECRET_KEY",
    CA_HEALTH_NUMBER: "CA_HEALTH_NUMBER",
    CA_SOCIAL_INSURANCE_NUMBER: "CA_SOCIAL_INSURANCE_NUMBER",
    CREDIT_DEBIT_CARD_CVV: "CREDIT_DEBIT_CARD_CVV",
    CREDIT_DEBIT_CARD_EXPIRY: "CREDIT_DEBIT_CARD_EXPIRY",
    CREDIT_DEBIT_CARD_NUMBER: "CREDIT_DEBIT_CARD_NUMBER",
    DRIVER_ID: "DRIVER_ID",
    EMAIL: "EMAIL",
    INTERNATIONAL_BANK_ACCOUNT_NUMBER: "INTERNATIONAL_BANK_ACCOUNT_NUMBER",
    IP_ADDRESS: "IP_ADDRESS",
    LICENSE_PLATE: "LICENSE_PLATE",
    MAC_ADDRESS: "MAC_ADDRESS",
    NAME: "NAME",
    PASSWORD: "PASSWORD",
    PHONE: "PHONE",
    PIN: "PIN",
    SWIFT_CODE: "SWIFT_CODE",
    UK_NATIONAL_HEALTH_SERVICE_NUMBER: "UK_NATIONAL_HEALTH_SERVICE_NUMBER",
    UK_NATIONAL_INSURANCE_NUMBER: "UK_NATIONAL_INSURANCE_NUMBER",
    UK_UNIQUE_TAXPAYER_REFERENCE_NUMBER: "UK_UNIQUE_TAXPAYER_REFERENCE_NUMBER",
    URL: "URL",
    USERNAME: "USERNAME",
    US_BANK_ACCOUNT_NUMBER: "US_BANK_ACCOUNT_NUMBER",
    US_BANK_ROUTING_NUMBER: "US_BANK_ROUTING_NUMBER",
    US_INDIVIDUAL_TAX_IDENTIFICATION_NUMBER: "US_INDIVIDUAL_TAX_IDENTIFICATION_NUMBER",
    US_PASSPORT_NUMBER: "US_PASSPORT_NUMBER",
    US_SOCIAL_SECURITY_NUMBER: "US_SOCIAL_SECURITY_NUMBER",
    VEHICLE_IDENTIFICATION_NUMBER: "VEHICLE_IDENTIFICATION_NUMBER"
};
const $983bf56ae6c3bba6$export$4923f78c1f6ccc0e = {
    BLOCKED: "BLOCKED"
};
const $983bf56ae6c3bba6$export$32028a31c7d92d14 = {
    DENY: "DENY"
};
const $983bf56ae6c3bba6$export$9c72046cd6618c64 = {
    BLOCKED: "BLOCKED"
};
const $983bf56ae6c3bba6$export$de093bac033c52ca = {
    PROFANITY: "PROFANITY"
};
const $983bf56ae6c3bba6$export$c296fdf3f5109e18 = {
    DISABLED: "disabled",
    ENABLED: "enabled"
};
const $983bf56ae6c3bba6$export$26fc7c3f918f8a9f = {
    CSV: "csv",
    DOC: "doc",
    DOCX: "docx",
    HTML: "html",
    MD: "md",
    PDF: "pdf",
    TXT: "txt",
    XLS: "xls",
    XLSX: "xlsx"
};
var $983bf56ae6c3bba6$export$d5862784f1527a9c;
(function(DocumentSource) {
    DocumentSource.visit = (value, visitor)=>{
        if (value.bytes !== undefined) return visitor.bytes(value.bytes);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($983bf56ae6c3bba6$export$d5862784f1527a9c || ($983bf56ae6c3bba6$export$d5862784f1527a9c = {}));
const $983bf56ae6c3bba6$export$a18b6e53740cb2dd = {
    JPEG: "jpeg",
    PNG: "png"
};
var $983bf56ae6c3bba6$export$481acdb2ad7a29a;
(function(GuardrailConverseImageSource) {
    GuardrailConverseImageSource.visit = (value, visitor)=>{
        if (value.bytes !== undefined) return visitor.bytes(value.bytes);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($983bf56ae6c3bba6$export$481acdb2ad7a29a || ($983bf56ae6c3bba6$export$481acdb2ad7a29a = {}));
const $983bf56ae6c3bba6$export$485b0bad642d07da = {
    GROUNDING_SOURCE: "grounding_source",
    GUARD_CONTENT: "guard_content",
    QUERY: "query"
};
var $983bf56ae6c3bba6$export$be357cb45c08e0ca;
(function(GuardrailConverseContentBlock) {
    GuardrailConverseContentBlock.visit = (value, visitor)=>{
        if (value.text !== undefined) return visitor.text(value.text);
        if (value.image !== undefined) return visitor.image(value.image);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($983bf56ae6c3bba6$export$be357cb45c08e0ca || ($983bf56ae6c3bba6$export$be357cb45c08e0ca = {}));
const $983bf56ae6c3bba6$export$2176deede4b7eeaf = {
    GIF: "gif",
    JPEG: "jpeg",
    PNG: "png",
    WEBP: "webp"
};
var $983bf56ae6c3bba6$export$280e9a68c3ffd919;
(function(ImageSource) {
    ImageSource.visit = (value, visitor)=>{
        if (value.bytes !== undefined) return visitor.bytes(value.bytes);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($983bf56ae6c3bba6$export$280e9a68c3ffd919 || ($983bf56ae6c3bba6$export$280e9a68c3ffd919 = {}));
const $983bf56ae6c3bba6$export$a9b84cf89cbae825 = {
    FLV: "flv",
    MKV: "mkv",
    MOV: "mov",
    MP4: "mp4",
    MPEG: "mpeg",
    MPG: "mpg",
    THREE_GP: "three_gp",
    WEBM: "webm",
    WMV: "wmv"
};
var $983bf56ae6c3bba6$export$f3a17123d80000c5;
(function(VideoSource) {
    VideoSource.visit = (value, visitor)=>{
        if (value.bytes !== undefined) return visitor.bytes(value.bytes);
        if (value.s3Location !== undefined) return visitor.s3Location(value.s3Location);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($983bf56ae6c3bba6$export$f3a17123d80000c5 || ($983bf56ae6c3bba6$export$f3a17123d80000c5 = {}));
var $983bf56ae6c3bba6$export$e00fc3aa62610e96;
(function(ToolResultContentBlock) {
    ToolResultContentBlock.visit = (value, visitor)=>{
        if (value.json !== undefined) return visitor.json(value.json);
        if (value.text !== undefined) return visitor.text(value.text);
        if (value.image !== undefined) return visitor.image(value.image);
        if (value.document !== undefined) return visitor.document(value.document);
        if (value.video !== undefined) return visitor.video(value.video);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($983bf56ae6c3bba6$export$e00fc3aa62610e96 || ($983bf56ae6c3bba6$export$e00fc3aa62610e96 = {}));
const $983bf56ae6c3bba6$export$61828693f7a0fc84 = {
    ERROR: "error",
    SUCCESS: "success"
};
var $983bf56ae6c3bba6$export$eb38b3b9c7f5f31b;
(function(ContentBlock) {
    ContentBlock.visit = (value, visitor)=>{
        if (value.text !== undefined) return visitor.text(value.text);
        if (value.image !== undefined) return visitor.image(value.image);
        if (value.document !== undefined) return visitor.document(value.document);
        if (value.video !== undefined) return visitor.video(value.video);
        if (value.toolUse !== undefined) return visitor.toolUse(value.toolUse);
        if (value.toolResult !== undefined) return visitor.toolResult(value.toolResult);
        if (value.guardContent !== undefined) return visitor.guardContent(value.guardContent);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($983bf56ae6c3bba6$export$eb38b3b9c7f5f31b || ($983bf56ae6c3bba6$export$eb38b3b9c7f5f31b = {}));
const $983bf56ae6c3bba6$export$9d67d4571507f411 = {
    ASSISTANT: "assistant",
    USER: "user"
};
const $983bf56ae6c3bba6$export$767ea819afff6d5c = {
    OPTIMIZED: "optimized",
    STANDARD: "standard"
};
var $983bf56ae6c3bba6$export$61edc28170328dd9;
(function(PromptVariableValues) {
    PromptVariableValues.visit = (value, visitor)=>{
        if (value.text !== undefined) return visitor.text(value.text);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($983bf56ae6c3bba6$export$61edc28170328dd9 || ($983bf56ae6c3bba6$export$61edc28170328dd9 = {}));
var $983bf56ae6c3bba6$export$4752b2898aac61ad;
(function(SystemContentBlock) {
    SystemContentBlock.visit = (value, visitor)=>{
        if (value.text !== undefined) return visitor.text(value.text);
        if (value.guardContent !== undefined) return visitor.guardContent(value.guardContent);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($983bf56ae6c3bba6$export$4752b2898aac61ad || ($983bf56ae6c3bba6$export$4752b2898aac61ad = {}));
var $983bf56ae6c3bba6$export$1835b46102496046;
(function(ToolChoice) {
    ToolChoice.visit = (value, visitor)=>{
        if (value.auto !== undefined) return visitor.auto(value.auto);
        if (value.any !== undefined) return visitor.any(value.any);
        if (value.tool !== undefined) return visitor.tool(value.tool);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($983bf56ae6c3bba6$export$1835b46102496046 || ($983bf56ae6c3bba6$export$1835b46102496046 = {}));
var $983bf56ae6c3bba6$export$59c0591707ebf96;
(function(ToolInputSchema) {
    ToolInputSchema.visit = (value, visitor)=>{
        if (value.json !== undefined) return visitor.json(value.json);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($983bf56ae6c3bba6$export$59c0591707ebf96 || ($983bf56ae6c3bba6$export$59c0591707ebf96 = {}));
var $983bf56ae6c3bba6$export$724f6b867059ef5f;
(function(Tool) {
    Tool.visit = (value, visitor)=>{
        if (value.toolSpec !== undefined) return visitor.toolSpec(value.toolSpec);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($983bf56ae6c3bba6$export$724f6b867059ef5f || ($983bf56ae6c3bba6$export$724f6b867059ef5f = {}));
var $983bf56ae6c3bba6$export$d74740ad06de1c8e;
(function(ConverseOutput) {
    ConverseOutput.visit = (value, visitor)=>{
        if (value.message !== undefined) return visitor.message(value.message);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($983bf56ae6c3bba6$export$d74740ad06de1c8e || ($983bf56ae6c3bba6$export$d74740ad06de1c8e = {}));
const $983bf56ae6c3bba6$export$cea573f2725d39ec = {
    CONTENT_FILTERED: "content_filtered",
    END_TURN: "end_turn",
    GUARDRAIL_INTERVENED: "guardrail_intervened",
    MAX_TOKENS: "max_tokens",
    STOP_SEQUENCE: "stop_sequence",
    TOOL_USE: "tool_use"
};
class $983bf56ae6c3bba6$export$1964ebc808a4d6e5 extends (0, $1ccdb23ad82d330a$export$8ff385b3d0137dea) {
    name = "ModelErrorException";
    $fault = "client";
    originalStatusCode;
    resourceName;
    constructor(opts){
        super({
            name: "ModelErrorException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $983bf56ae6c3bba6$export$1964ebc808a4d6e5.prototype);
        this.originalStatusCode = opts.originalStatusCode;
        this.resourceName = opts.resourceName;
    }
}
class $983bf56ae6c3bba6$export$e4482e9c7a89f5f4 extends (0, $1ccdb23ad82d330a$export$8ff385b3d0137dea) {
    name = "ModelNotReadyException";
    $fault = "client";
    $retryable = {};
    constructor(opts){
        super({
            name: "ModelNotReadyException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $983bf56ae6c3bba6$export$e4482e9c7a89f5f4.prototype);
    }
}
class $983bf56ae6c3bba6$export$5dcc4fd7a5b3f1e9 extends (0, $1ccdb23ad82d330a$export$8ff385b3d0137dea) {
    name = "ModelTimeoutException";
    $fault = "client";
    constructor(opts){
        super({
            name: "ModelTimeoutException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $983bf56ae6c3bba6$export$5dcc4fd7a5b3f1e9.prototype);
    }
}
const $983bf56ae6c3bba6$export$da0939168ba6846 = {
    ASYNC: "async",
    SYNC: "sync"
};
var $983bf56ae6c3bba6$export$13628bf88bbe4a89;
(function(ContentBlockDelta) {
    ContentBlockDelta.visit = (value, visitor)=>{
        if (value.text !== undefined) return visitor.text(value.text);
        if (value.toolUse !== undefined) return visitor.toolUse(value.toolUse);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($983bf56ae6c3bba6$export$13628bf88bbe4a89 || ($983bf56ae6c3bba6$export$13628bf88bbe4a89 = {}));
var $983bf56ae6c3bba6$export$c84c920d533f7d7f;
(function(ContentBlockStart) {
    ContentBlockStart.visit = (value, visitor)=>{
        if (value.toolUse !== undefined) return visitor.toolUse(value.toolUse);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($983bf56ae6c3bba6$export$c84c920d533f7d7f || ($983bf56ae6c3bba6$export$c84c920d533f7d7f = {}));
class $983bf56ae6c3bba6$export$10846a59510c5e02 extends (0, $1ccdb23ad82d330a$export$8ff385b3d0137dea) {
    name = "ModelStreamErrorException";
    $fault = "client";
    originalStatusCode;
    originalMessage;
    constructor(opts){
        super({
            name: "ModelStreamErrorException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $983bf56ae6c3bba6$export$10846a59510c5e02.prototype);
        this.originalStatusCode = opts.originalStatusCode;
        this.originalMessage = opts.originalMessage;
    }
}
var $983bf56ae6c3bba6$export$8ee88ffc35c40394;
(function(ConverseStreamOutput) {
    ConverseStreamOutput.visit = (value, visitor)=>{
        if (value.messageStart !== undefined) return visitor.messageStart(value.messageStart);
        if (value.contentBlockStart !== undefined) return visitor.contentBlockStart(value.contentBlockStart);
        if (value.contentBlockDelta !== undefined) return visitor.contentBlockDelta(value.contentBlockDelta);
        if (value.contentBlockStop !== undefined) return visitor.contentBlockStop(value.contentBlockStop);
        if (value.messageStop !== undefined) return visitor.messageStop(value.messageStop);
        if (value.metadata !== undefined) return visitor.metadata(value.metadata);
        if (value.internalServerException !== undefined) return visitor.internalServerException(value.internalServerException);
        if (value.modelStreamErrorException !== undefined) return visitor.modelStreamErrorException(value.modelStreamErrorException);
        if (value.validationException !== undefined) return visitor.validationException(value.validationException);
        if (value.throttlingException !== undefined) return visitor.throttlingException(value.throttlingException);
        if (value.serviceUnavailableException !== undefined) return visitor.serviceUnavailableException(value.serviceUnavailableException);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($983bf56ae6c3bba6$export$8ee88ffc35c40394 || ($983bf56ae6c3bba6$export$8ee88ffc35c40394 = {}));
const $983bf56ae6c3bba6$export$78e1bea9036f120f = {
    DISABLED: "DISABLED",
    ENABLED: "ENABLED"
};
var $983bf56ae6c3bba6$export$f12c233eb02f801d;
(function(ResponseStream) {
    ResponseStream.visit = (value, visitor)=>{
        if (value.chunk !== undefined) return visitor.chunk(value.chunk);
        if (value.internalServerException !== undefined) return visitor.internalServerException(value.internalServerException);
        if (value.modelStreamErrorException !== undefined) return visitor.modelStreamErrorException(value.modelStreamErrorException);
        if (value.validationException !== undefined) return visitor.validationException(value.validationException);
        if (value.throttlingException !== undefined) return visitor.throttlingException(value.throttlingException);
        if (value.modelTimeoutException !== undefined) return visitor.modelTimeoutException(value.modelTimeoutException);
        if (value.serviceUnavailableException !== undefined) return visitor.serviceUnavailableException(value.serviceUnavailableException);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($983bf56ae6c3bba6$export$f12c233eb02f801d || ($983bf56ae6c3bba6$export$f12c233eb02f801d = {}));
const $983bf56ae6c3bba6$export$4cdac1ce5474714d = (obj)=>({
        ...obj,
        ...obj.failureMessage && {
            failureMessage: (0, $396b6e4de1f32a66$export$17127055dc9ac067)
        },
        ...obj.outputDataConfig && {
            outputDataConfig: obj.outputDataConfig
        }
    });
const $983bf56ae6c3bba6$export$80e8e813f88abfd8 = (obj)=>({
        ...obj,
        ...obj.failureMessage && {
            failureMessage: (0, $396b6e4de1f32a66$export$17127055dc9ac067)
        },
        ...obj.outputDataConfig && {
            outputDataConfig: obj.outputDataConfig
        }
    });
const $983bf56ae6c3bba6$export$2626660fbe9d5825 = (obj)=>({
        ...obj,
        ...obj.asyncInvokeSummaries && {
            asyncInvokeSummaries: obj.asyncInvokeSummaries.map((item)=>$983bf56ae6c3bba6$export$80e8e813f88abfd8(item))
        }
    });
const $983bf56ae6c3bba6$export$e97b469d8f3b5793 = (obj)=>({
        ...obj,
        ...obj.modelInput && {
            modelInput: (0, $396b6e4de1f32a66$export$17127055dc9ac067)
        },
        ...obj.outputDataConfig && {
            outputDataConfig: obj.outputDataConfig
        }
    });
const $983bf56ae6c3bba6$export$ea9db51b701e2c23 = (obj)=>{
    if (obj.bytes !== undefined) return {
        bytes: obj.bytes
    };
    if (obj.$unknown !== undefined) return {
        [obj.$unknown[0]]: "UNKNOWN"
    };
};
const $983bf56ae6c3bba6$export$57c174b02d161459 = (obj)=>({
        ...obj,
        ...obj.source && {
            source: (0, $396b6e4de1f32a66$export$17127055dc9ac067)
        }
    });
const $983bf56ae6c3bba6$export$ebe5e6bf96b5186e = (obj)=>{
    if (obj.text !== undefined) return {
        text: obj.text
    };
    if (obj.image !== undefined) return {
        image: (0, $396b6e4de1f32a66$export$17127055dc9ac067)
    };
    if (obj.$unknown !== undefined) return {
        [obj.$unknown[0]]: "UNKNOWN"
    };
};
const $983bf56ae6c3bba6$export$26fb2d7af91446b7 = (obj)=>({
        ...obj,
        ...obj.content && {
            content: obj.content.map((item)=>$983bf56ae6c3bba6$export$ebe5e6bf96b5186e(item))
        }
    });
const $983bf56ae6c3bba6$export$7ba514716ce1fe86 = (obj)=>{
    if (obj.bytes !== undefined) return {
        bytes: obj.bytes
    };
    if (obj.$unknown !== undefined) return {
        [obj.$unknown[0]]: "UNKNOWN"
    };
};
const $983bf56ae6c3bba6$export$6c7e95cc88a7a605 = (obj)=>({
        ...obj,
        ...obj.source && {
            source: (0, $396b6e4de1f32a66$export$17127055dc9ac067)
        }
    });
const $983bf56ae6c3bba6$export$e9296334531e11af = (obj)=>{
    if (obj.text !== undefined) return {
        text: obj.text
    };
    if (obj.image !== undefined) return {
        image: (0, $396b6e4de1f32a66$export$17127055dc9ac067)
    };
    if (obj.$unknown !== undefined) return {
        [obj.$unknown[0]]: "UNKNOWN"
    };
};
const $983bf56ae6c3bba6$export$49fa80904c38a4c0 = (obj)=>{
    if (obj.text !== undefined) return {
        text: obj.text
    };
    if (obj.image !== undefined) return {
        image: obj.image
    };
    if (obj.document !== undefined) return {
        document: obj.document
    };
    if (obj.video !== undefined) return {
        video: obj.video
    };
    if (obj.toolUse !== undefined) return {
        toolUse: obj.toolUse
    };
    if (obj.toolResult !== undefined) return {
        toolResult: obj.toolResult
    };
    if (obj.guardContent !== undefined) return {
        guardContent: $983bf56ae6c3bba6$export$e9296334531e11af(obj.guardContent)
    };
    if (obj.$unknown !== undefined) return {
        [obj.$unknown[0]]: "UNKNOWN"
    };
};
const $983bf56ae6c3bba6$export$8c8d7a46d9da0fe6 = (obj)=>({
        ...obj,
        ...obj.content && {
            content: obj.content.map((item)=>$983bf56ae6c3bba6$export$49fa80904c38a4c0(item))
        }
    });
const $983bf56ae6c3bba6$export$c93a1896c3feb = (obj)=>{
    if (obj.text !== undefined) return {
        text: obj.text
    };
    if (obj.guardContent !== undefined) return {
        guardContent: $983bf56ae6c3bba6$export$e9296334531e11af(obj.guardContent)
    };
    if (obj.$unknown !== undefined) return {
        [obj.$unknown[0]]: "UNKNOWN"
    };
};
const $983bf56ae6c3bba6$export$4db079fabcc9b6f3 = (obj)=>({
        ...obj,
        ...obj.messages && {
            messages: obj.messages.map((item)=>$983bf56ae6c3bba6$export$8c8d7a46d9da0fe6(item))
        },
        ...obj.system && {
            system: obj.system.map((item)=>$983bf56ae6c3bba6$export$c93a1896c3feb(item))
        },
        ...obj.toolConfig && {
            toolConfig: obj.toolConfig
        },
        ...obj.promptVariables && {
            promptVariables: (0, $396b6e4de1f32a66$export$17127055dc9ac067)
        },
        ...obj.requestMetadata && {
            requestMetadata: (0, $396b6e4de1f32a66$export$17127055dc9ac067)
        }
    });
const $983bf56ae6c3bba6$export$3a3a24efba5acfb = (obj)=>{
    if (obj.message !== undefined) return {
        message: $983bf56ae6c3bba6$export$8c8d7a46d9da0fe6(obj.message)
    };
    if (obj.$unknown !== undefined) return {
        [obj.$unknown[0]]: "UNKNOWN"
    };
};
const $983bf56ae6c3bba6$export$904d80b0f4729e71 = (obj)=>({
        ...obj,
        ...obj.output && {
            output: $983bf56ae6c3bba6$export$3a3a24efba5acfb(obj.output)
        }
    });
const $983bf56ae6c3bba6$export$c800001906994406 = (obj)=>({
        ...obj,
        ...obj.messages && {
            messages: obj.messages.map((item)=>$983bf56ae6c3bba6$export$8c8d7a46d9da0fe6(item))
        },
        ...obj.system && {
            system: obj.system.map((item)=>$983bf56ae6c3bba6$export$c93a1896c3feb(item))
        },
        ...obj.toolConfig && {
            toolConfig: obj.toolConfig
        },
        ...obj.promptVariables && {
            promptVariables: (0, $396b6e4de1f32a66$export$17127055dc9ac067)
        },
        ...obj.requestMetadata && {
            requestMetadata: (0, $396b6e4de1f32a66$export$17127055dc9ac067)
        }
    });
const $983bf56ae6c3bba6$export$bd8f78c127157948 = (obj)=>{
    if (obj.messageStart !== undefined) return {
        messageStart: obj.messageStart
    };
    if (obj.contentBlockStart !== undefined) return {
        contentBlockStart: obj.contentBlockStart
    };
    if (obj.contentBlockDelta !== undefined) return {
        contentBlockDelta: obj.contentBlockDelta
    };
    if (obj.contentBlockStop !== undefined) return {
        contentBlockStop: obj.contentBlockStop
    };
    if (obj.messageStop !== undefined) return {
        messageStop: obj.messageStop
    };
    if (obj.metadata !== undefined) return {
        metadata: obj.metadata
    };
    if (obj.internalServerException !== undefined) return {
        internalServerException: obj.internalServerException
    };
    if (obj.modelStreamErrorException !== undefined) return {
        modelStreamErrorException: obj.modelStreamErrorException
    };
    if (obj.validationException !== undefined) return {
        validationException: obj.validationException
    };
    if (obj.throttlingException !== undefined) return {
        throttlingException: obj.throttlingException
    };
    if (obj.serviceUnavailableException !== undefined) return {
        serviceUnavailableException: obj.serviceUnavailableException
    };
    if (obj.$unknown !== undefined) return {
        [obj.$unknown[0]]: "UNKNOWN"
    };
};
const $983bf56ae6c3bba6$export$369d8310c3fa7b59 = (obj)=>({
        ...obj,
        ...obj.stream && {
            stream: "STREAMING_CONTENT"
        }
    });
const $983bf56ae6c3bba6$export$eb730a52ca98607f = (obj)=>({
        ...obj,
        ...obj.body && {
            body: (0, $396b6e4de1f32a66$export$17127055dc9ac067)
        }
    });
const $983bf56ae6c3bba6$export$a7eb332c07fb31f6 = (obj)=>({
        ...obj,
        ...obj.body && {
            body: (0, $396b6e4de1f32a66$export$17127055dc9ac067)
        }
    });
const $983bf56ae6c3bba6$export$66b72b520ab8a650 = (obj)=>({
        ...obj,
        ...obj.body && {
            body: (0, $396b6e4de1f32a66$export$17127055dc9ac067)
        }
    });
const $983bf56ae6c3bba6$export$daa5396b0aef9746 = (obj)=>({
        ...obj,
        ...obj.bytes && {
            bytes: (0, $396b6e4de1f32a66$export$17127055dc9ac067)
        }
    });
const $983bf56ae6c3bba6$export$db5966fce0976a0d = (obj)=>{
    if (obj.chunk !== undefined) return {
        chunk: (0, $396b6e4de1f32a66$export$17127055dc9ac067)
    };
    if (obj.internalServerException !== undefined) return {
        internalServerException: obj.internalServerException
    };
    if (obj.modelStreamErrorException !== undefined) return {
        modelStreamErrorException: obj.modelStreamErrorException
    };
    if (obj.validationException !== undefined) return {
        validationException: obj.validationException
    };
    if (obj.throttlingException !== undefined) return {
        throttlingException: obj.throttlingException
    };
    if (obj.modelTimeoutException !== undefined) return {
        modelTimeoutException: obj.modelTimeoutException
    };
    if (obj.serviceUnavailableException !== undefined) return {
        serviceUnavailableException: obj.serviceUnavailableException
    };
    if (obj.$unknown !== undefined) return {
        [obj.$unknown[0]]: "UNKNOWN"
    };
};
const $983bf56ae6c3bba6$export$c9fa3c739822d29c = (obj)=>({
        ...obj,
        ...obj.body && {
            body: "STREAMING_CONTENT"
        }
    });



const $c3cb8cbc7fb69ac6$export$a782fbe4c9957f98 = (value)=>{
    if (value == null) return undefined;
    if (typeof value === "object" && "__type" in value) delete value.__type;
    return (0, $25d854afa944ccce$export$9ef77073e45b6301)(value);
};




const $f95add04c844b6a5$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $f95add04c844b6a5$export$2e2bcd8739ae039 = {
    randomUUID: $f95add04c844b6a5$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $63062c1a1002a8ac$var$getRandomValues;
const $63062c1a1002a8ac$var$rnds8 = new Uint8Array(16);
function $63062c1a1002a8ac$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$63062c1a1002a8ac$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $63062c1a1002a8ac$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$63062c1a1002a8ac$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $63062c1a1002a8ac$var$getRandomValues($63062c1a1002a8ac$var$rnds8);
}


var $076d0226d0249e48$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $fcac379375b4ccb4$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $076d0226d0249e48$export$2e2bcd8739ae039).test(uuid);
}
var $fcac379375b4ccb4$export$2e2bcd8739ae039 = $fcac379375b4ccb4$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $90ec624b35419545$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$90ec624b35419545$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $90ec624b35419545$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $90ec624b35419545$var$byteToHex[arr[offset + 0]] + $90ec624b35419545$var$byteToHex[arr[offset + 1]] + $90ec624b35419545$var$byteToHex[arr[offset + 2]] + $90ec624b35419545$var$byteToHex[arr[offset + 3]] + '-' + $90ec624b35419545$var$byteToHex[arr[offset + 4]] + $90ec624b35419545$var$byteToHex[arr[offset + 5]] + '-' + $90ec624b35419545$var$byteToHex[arr[offset + 6]] + $90ec624b35419545$var$byteToHex[arr[offset + 7]] + '-' + $90ec624b35419545$var$byteToHex[arr[offset + 8]] + $90ec624b35419545$var$byteToHex[arr[offset + 9]] + '-' + $90ec624b35419545$var$byteToHex[arr[offset + 10]] + $90ec624b35419545$var$byteToHex[arr[offset + 11]] + $90ec624b35419545$var$byteToHex[arr[offset + 12]] + $90ec624b35419545$var$byteToHex[arr[offset + 13]] + $90ec624b35419545$var$byteToHex[arr[offset + 14]] + $90ec624b35419545$var$byteToHex[arr[offset + 15]];
}
function $90ec624b35419545$var$stringify(arr, offset = 0) {
    const uuid = $90ec624b35419545$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $fcac379375b4ccb4$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $90ec624b35419545$export$2e2bcd8739ae039 = $90ec624b35419545$var$stringify;


function $8562077db2851f31$var$v4(options, buf, offset) {
    if ((0, $f95add04c844b6a5$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $f95add04c844b6a5$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $63062c1a1002a8ac$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $90ec624b35419545$export$8fb373d660548968)(rnds);
}
var $8562077db2851f31$export$2e2bcd8739ae039 = $8562077db2851f31$var$v4;




const $7e0b86abed89c02c$export$46435507be0f5d3f = async (input, context)=>{
    const b = (0, $f2d3bbadd4b0e82a$export$9f1f89e694d26cd0)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/guardrail/{guardrailIdentifier}/version/{guardrailVersion}/apply");
    b.p("guardrailIdentifier", ()=>input.guardrailIdentifier, "{guardrailIdentifier}", false);
    b.p("guardrailVersion", ()=>input.guardrailVersion, "{guardrailVersion}", false);
    let body;
    body = JSON.stringify((0, $07e9587fb0c3a3de$export$b7df5d561049483a)(input, {
        content: (_)=>$7e0b86abed89c02c$var$se_GuardrailContentBlockList(_, context),
        source: []
    }));
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $7e0b86abed89c02c$export$4db1eb00a2075969 = async (input, context)=>{
    const b = (0, $f2d3bbadd4b0e82a$export$9f1f89e694d26cd0)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/model/{modelId}/converse");
    b.p("modelId", ()=>input.modelId, "{modelId}", false);
    let body;
    body = JSON.stringify((0, $07e9587fb0c3a3de$export$b7df5d561049483a)(input, {
        additionalModelRequestFields: (_)=>$7e0b86abed89c02c$var$se_Document(_, context),
        additionalModelResponseFieldPaths: (_)=>(0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(_),
        guardrailConfig: (_)=>(0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(_),
        inferenceConfig: (_)=>$7e0b86abed89c02c$var$se_InferenceConfiguration(_, context),
        messages: (_)=>$7e0b86abed89c02c$var$se_Messages(_, context),
        performanceConfig: (_)=>(0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(_),
        promptVariables: (_)=>(0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(_),
        requestMetadata: (_)=>(0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(_),
        system: (_)=>$7e0b86abed89c02c$var$se_SystemContentBlocks(_, context),
        toolConfig: (_)=>$7e0b86abed89c02c$var$se_ToolConfiguration(_, context)
    }));
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $7e0b86abed89c02c$export$30d01b02fac3cf41 = async (input, context)=>{
    const b = (0, $f2d3bbadd4b0e82a$export$9f1f89e694d26cd0)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/model/{modelId}/converse-stream");
    b.p("modelId", ()=>input.modelId, "{modelId}", false);
    let body;
    body = JSON.stringify((0, $07e9587fb0c3a3de$export$b7df5d561049483a)(input, {
        additionalModelRequestFields: (_)=>$7e0b86abed89c02c$var$se_Document(_, context),
        additionalModelResponseFieldPaths: (_)=>(0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(_),
        guardrailConfig: (_)=>(0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(_),
        inferenceConfig: (_)=>$7e0b86abed89c02c$var$se_InferenceConfiguration(_, context),
        messages: (_)=>$7e0b86abed89c02c$var$se_Messages(_, context),
        performanceConfig: (_)=>(0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(_),
        promptVariables: (_)=>(0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(_),
        requestMetadata: (_)=>(0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(_),
        system: (_)=>$7e0b86abed89c02c$var$se_SystemContentBlocks(_, context),
        toolConfig: (_)=>$7e0b86abed89c02c$var$se_ToolConfiguration(_, context)
    }));
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $7e0b86abed89c02c$export$9dc36f914b431e11 = async (input, context)=>{
    const b = (0, $f2d3bbadd4b0e82a$export$9f1f89e694d26cd0)(input, context);
    const headers = {};
    b.bp("/async-invoke/{invocationArn}");
    b.p("invocationArn", ()=>input.invocationArn, "{invocationArn}", false);
    let body;
    b.m("GET").h(headers).b(body);
    return b.build();
};
const $7e0b86abed89c02c$export$5c90acbed2c62d7d = async (input, context)=>{
    const b = (0, $f2d3bbadd4b0e82a$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $07e9587fb0c3a3de$export$871de8747c9eaa88)({}, (0, $9cc297ee2c171018$export$f25742720bcd7d1c), {
        [$7e0b86abed89c02c$var$_ct]: input[$7e0b86abed89c02c$var$_cT] || "application/octet-stream",
        [$7e0b86abed89c02c$var$_a]: input[$7e0b86abed89c02c$var$_a],
        [$7e0b86abed89c02c$var$_xabt]: input[$7e0b86abed89c02c$var$_t],
        [$7e0b86abed89c02c$var$_xabg]: input[$7e0b86abed89c02c$var$_gI],
        [$7e0b86abed89c02c$var$_xabg_]: input[$7e0b86abed89c02c$var$_gV],
        [$7e0b86abed89c02c$var$_xabpl]: input[$7e0b86abed89c02c$var$_pCL]
    });
    b.bp("/model/{modelId}/invoke");
    b.p("modelId", ()=>input.modelId, "{modelId}", false);
    let body;
    if (input.body !== undefined) body = input.body;
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $7e0b86abed89c02c$export$ea91d4b233eaa051 = async (input, context)=>{
    const b = (0, $f2d3bbadd4b0e82a$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $07e9587fb0c3a3de$export$871de8747c9eaa88)({}, (0, $9cc297ee2c171018$export$f25742720bcd7d1c), {
        [$7e0b86abed89c02c$var$_ct]: input[$7e0b86abed89c02c$var$_cT] || "application/octet-stream",
        [$7e0b86abed89c02c$var$_xaba]: input[$7e0b86abed89c02c$var$_a],
        [$7e0b86abed89c02c$var$_xabt]: input[$7e0b86abed89c02c$var$_t],
        [$7e0b86abed89c02c$var$_xabg]: input[$7e0b86abed89c02c$var$_gI],
        [$7e0b86abed89c02c$var$_xabg_]: input[$7e0b86abed89c02c$var$_gV],
        [$7e0b86abed89c02c$var$_xabpl]: input[$7e0b86abed89c02c$var$_pCL]
    });
    b.bp("/model/{modelId}/invoke-with-response-stream");
    b.p("modelId", ()=>input.modelId, "{modelId}", false);
    let body;
    if (input.body !== undefined) body = input.body;
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $7e0b86abed89c02c$export$2b9ecb8c56d23b00 = async (input, context)=>{
    const b = (0, $f2d3bbadd4b0e82a$export$9f1f89e694d26cd0)(input, context);
    const headers = {};
    b.bp("/async-invoke");
    const query = (0, $07e9587fb0c3a3de$export$871de8747c9eaa88)({
        [$7e0b86abed89c02c$var$_sTA]: [
            ()=>input.submitTimeAfter !== void 0,
            ()=>(0, $2af401769ccb273e$export$93f3a0dd288ea1c8)(input[$7e0b86abed89c02c$var$_sTA]).toString()
        ],
        [$7e0b86abed89c02c$var$_sTB]: [
            ()=>input.submitTimeBefore !== void 0,
            ()=>(0, $2af401769ccb273e$export$93f3a0dd288ea1c8)(input[$7e0b86abed89c02c$var$_sTB]).toString()
        ],
        [$7e0b86abed89c02c$var$_sE]: [
            ,
            input[$7e0b86abed89c02c$var$_sE]
        ],
        [$7e0b86abed89c02c$var$_mR]: [
            ()=>input.maxResults !== void 0,
            ()=>input[$7e0b86abed89c02c$var$_mR].toString()
        ],
        [$7e0b86abed89c02c$var$_nT]: [
            ,
            input[$7e0b86abed89c02c$var$_nT]
        ],
        [$7e0b86abed89c02c$var$_sB]: [
            ,
            input[$7e0b86abed89c02c$var$_sB]
        ],
        [$7e0b86abed89c02c$var$_sO]: [
            ,
            input[$7e0b86abed89c02c$var$_sO]
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $7e0b86abed89c02c$export$ddb55e5f781d59be = async (input, context)=>{
    const b = (0, $f2d3bbadd4b0e82a$export$9f1f89e694d26cd0)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/async-invoke");
    let body;
    body = JSON.stringify((0, $07e9587fb0c3a3de$export$b7df5d561049483a)(input, {
        clientRequestToken: [
            true,
            (_)=>_ ?? (0, $8562077db2851f31$export$2e2bcd8739ae039)()
        ],
        modelId: [],
        modelInput: (_)=>$7e0b86abed89c02c$var$se_ModelInputPayload(_, context),
        outputDataConfig: (_)=>(0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(_),
        tags: (_)=>(0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(_)
    }));
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $7e0b86abed89c02c$export$bdea95b0d17f52fe = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $7e0b86abed89c02c$var$de_CommandError(output, context);
    const contents = (0, $07e9587fb0c3a3de$export$871de8747c9eaa88)({
        $metadata: $7e0b86abed89c02c$var$deserializeMetadata(output)
    });
    const data = (0, $25d854afa944ccce$export$8413a63dbe548a49)((0, $25d854afa944ccce$export$cf825aadce530e7e)(await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context)), "body");
    const doc = (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(data, {
        action: (0, $25d854afa944ccce$export$7ed80f53fe336639),
        assessments: (_)=>$7e0b86abed89c02c$var$de_GuardrailAssessmentList(_, context),
        guardrailCoverage: (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c),
        outputs: (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c),
        usage: (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)
    });
    Object.assign(contents, doc);
    return contents;
};
const $7e0b86abed89c02c$export$6d9afa3dc76edc0 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $7e0b86abed89c02c$var$de_CommandError(output, context);
    const contents = (0, $07e9587fb0c3a3de$export$871de8747c9eaa88)({
        $metadata: $7e0b86abed89c02c$var$deserializeMetadata(output)
    });
    const data = (0, $25d854afa944ccce$export$8413a63dbe548a49)((0, $25d854afa944ccce$export$cf825aadce530e7e)(await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context)), "body");
    const doc = (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(data, {
        additionalModelResponseFields: (_)=>$7e0b86abed89c02c$var$de_Document(_, context),
        metrics: (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c),
        output: (_)=>$7e0b86abed89c02c$var$de_ConverseOutput((0, $c3cb8cbc7fb69ac6$export$a782fbe4c9957f98)(_), context),
        performanceConfig: (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c),
        stopReason: (0, $25d854afa944ccce$export$7ed80f53fe336639),
        trace: (_)=>$7e0b86abed89c02c$var$de_ConverseTrace(_, context),
        usage: (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)
    });
    Object.assign(contents, doc);
    return contents;
};
const $7e0b86abed89c02c$export$b9d00d07d3a8c67d = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $7e0b86abed89c02c$var$de_CommandError(output, context);
    const contents = (0, $07e9587fb0c3a3de$export$871de8747c9eaa88)({
        $metadata: $7e0b86abed89c02c$var$deserializeMetadata(output)
    });
    const data = output.body;
    contents.stream = $7e0b86abed89c02c$var$de_ConverseStreamOutput(data, context);
    return contents;
};
const $7e0b86abed89c02c$export$5c23da8b9db1dba0 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $7e0b86abed89c02c$var$de_CommandError(output, context);
    const contents = (0, $07e9587fb0c3a3de$export$871de8747c9eaa88)({
        $metadata: $7e0b86abed89c02c$var$deserializeMetadata(output)
    });
    const data = (0, $25d854afa944ccce$export$8413a63dbe548a49)((0, $25d854afa944ccce$export$cf825aadce530e7e)(await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context)), "body");
    const doc = (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(data, {
        clientRequestToken: (0, $25d854afa944ccce$export$7ed80f53fe336639),
        endTime: (_)=>(0, $25d854afa944ccce$export$8413a63dbe548a49)((0, $d8696255fcc0b769$export$3cb821e2875b4b7d)(_)),
        failureMessage: (0, $25d854afa944ccce$export$7ed80f53fe336639),
        invocationArn: (0, $25d854afa944ccce$export$7ed80f53fe336639),
        lastModifiedTime: (_)=>(0, $25d854afa944ccce$export$8413a63dbe548a49)((0, $d8696255fcc0b769$export$3cb821e2875b4b7d)(_)),
        modelArn: (0, $25d854afa944ccce$export$7ed80f53fe336639),
        outputDataConfig: (_)=>(0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)((0, $c3cb8cbc7fb69ac6$export$a782fbe4c9957f98)(_)),
        status: (0, $25d854afa944ccce$export$7ed80f53fe336639),
        submitTime: (_)=>(0, $25d854afa944ccce$export$8413a63dbe548a49)((0, $d8696255fcc0b769$export$3cb821e2875b4b7d)(_))
    });
    Object.assign(contents, doc);
    return contents;
};
const $7e0b86abed89c02c$export$2f9826b6914de78 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $7e0b86abed89c02c$var$de_CommandError(output, context);
    const contents = (0, $07e9587fb0c3a3de$export$871de8747c9eaa88)({
        $metadata: $7e0b86abed89c02c$var$deserializeMetadata(output),
        [$7e0b86abed89c02c$var$_cT]: [
            ,
            output.headers[$7e0b86abed89c02c$var$_ct]
        ],
        [$7e0b86abed89c02c$var$_pCL]: [
            ,
            output.headers[$7e0b86abed89c02c$var$_xabpl]
        ]
    });
    const data = await (0, $7667c5ed780ba41a$export$3392bcddb824e5ca)(output.body, context);
    contents.body = data;
    return contents;
};
const $7e0b86abed89c02c$export$4087bff5cf0a4b1c = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $7e0b86abed89c02c$var$de_CommandError(output, context);
    const contents = (0, $07e9587fb0c3a3de$export$871de8747c9eaa88)({
        $metadata: $7e0b86abed89c02c$var$deserializeMetadata(output),
        [$7e0b86abed89c02c$var$_cT]: [
            ,
            output.headers[$7e0b86abed89c02c$var$_xabct]
        ],
        [$7e0b86abed89c02c$var$_pCL]: [
            ,
            output.headers[$7e0b86abed89c02c$var$_xabpl]
        ]
    });
    const data = output.body;
    contents.body = $7e0b86abed89c02c$var$de_ResponseStream(data, context);
    return contents;
};
const $7e0b86abed89c02c$export$7fb19d7df09ed2d3 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $7e0b86abed89c02c$var$de_CommandError(output, context);
    const contents = (0, $07e9587fb0c3a3de$export$871de8747c9eaa88)({
        $metadata: $7e0b86abed89c02c$var$deserializeMetadata(output)
    });
    const data = (0, $25d854afa944ccce$export$8413a63dbe548a49)((0, $25d854afa944ccce$export$cf825aadce530e7e)(await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context)), "body");
    const doc = (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(data, {
        asyncInvokeSummaries: (_)=>$7e0b86abed89c02c$var$de_AsyncInvokeSummaries(_, context),
        nextToken: (0, $25d854afa944ccce$export$7ed80f53fe336639)
    });
    Object.assign(contents, doc);
    return contents;
};
const $7e0b86abed89c02c$export$820c33176a7f7dda = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $7e0b86abed89c02c$var$de_CommandError(output, context);
    const contents = (0, $07e9587fb0c3a3de$export$871de8747c9eaa88)({
        $metadata: $7e0b86abed89c02c$var$deserializeMetadata(output)
    });
    const data = (0, $25d854afa944ccce$export$8413a63dbe548a49)((0, $25d854afa944ccce$export$cf825aadce530e7e)(await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context)), "body");
    const doc = (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(data, {
        invocationArn: (0, $25d854afa944ccce$export$7ed80f53fe336639)
    });
    Object.assign(contents, doc);
    return contents;
};
const $7e0b86abed89c02c$var$de_CommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await (0, $496d3a9f084d8cd2$export$cb111c4739f3951f)(output.body, context)
    };
    const errorCode = (0, $496d3a9f084d8cd2$export$6e21dac881a79e70)(output, parsedOutput.body);
    switch(errorCode){
        case "AccessDeniedException":
        case "com.amazonaws.bedrockruntime#AccessDeniedException":
            throw await $7e0b86abed89c02c$var$de_AccessDeniedExceptionRes(parsedOutput, context);
        case "InternalServerException":
        case "com.amazonaws.bedrockruntime#InternalServerException":
            throw await $7e0b86abed89c02c$var$de_InternalServerExceptionRes(parsedOutput, context);
        case "ResourceNotFoundException":
        case "com.amazonaws.bedrockruntime#ResourceNotFoundException":
            throw await $7e0b86abed89c02c$var$de_ResourceNotFoundExceptionRes(parsedOutput, context);
        case "ServiceQuotaExceededException":
        case "com.amazonaws.bedrockruntime#ServiceQuotaExceededException":
            throw await $7e0b86abed89c02c$var$de_ServiceQuotaExceededExceptionRes(parsedOutput, context);
        case "ThrottlingException":
        case "com.amazonaws.bedrockruntime#ThrottlingException":
            throw await $7e0b86abed89c02c$var$de_ThrottlingExceptionRes(parsedOutput, context);
        case "ValidationException":
        case "com.amazonaws.bedrockruntime#ValidationException":
            throw await $7e0b86abed89c02c$var$de_ValidationExceptionRes(parsedOutput, context);
        case "ModelErrorException":
        case "com.amazonaws.bedrockruntime#ModelErrorException":
            throw await $7e0b86abed89c02c$var$de_ModelErrorExceptionRes(parsedOutput, context);
        case "ModelNotReadyException":
        case "com.amazonaws.bedrockruntime#ModelNotReadyException":
            throw await $7e0b86abed89c02c$var$de_ModelNotReadyExceptionRes(parsedOutput, context);
        case "ModelTimeoutException":
        case "com.amazonaws.bedrockruntime#ModelTimeoutException":
            throw await $7e0b86abed89c02c$var$de_ModelTimeoutExceptionRes(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.bedrockruntime#ServiceUnavailableException":
            throw await $7e0b86abed89c02c$var$de_ServiceUnavailableExceptionRes(parsedOutput, context);
        case "ModelStreamErrorException":
        case "com.amazonaws.bedrockruntime#ModelStreamErrorException":
            throw await $7e0b86abed89c02c$var$de_ModelStreamErrorExceptionRes(parsedOutput, context);
        case "ConflictException":
        case "com.amazonaws.bedrockruntime#ConflictException":
            throw await $7e0b86abed89c02c$var$de_ConflictExceptionRes(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            return $7e0b86abed89c02c$var$throwDefaultError({
                output: output,
                parsedBody: parsedBody,
                errorCode: errorCode
            });
    }
};
const $7e0b86abed89c02c$var$throwDefaultError = (0, $1a84bff7daff0761$export$62ac8acba1748a85)((0, $1ccdb23ad82d330a$export$8ff385b3d0137dea));
const $7e0b86abed89c02c$var$de_AccessDeniedExceptionRes = async (parsedOutput, context)=>{
    const contents = (0, $07e9587fb0c3a3de$export$871de8747c9eaa88)({});
    const data = parsedOutput.body;
    const doc = (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(data, {
        message: (0, $25d854afa944ccce$export$7ed80f53fe336639)
    });
    Object.assign(contents, doc);
    const exception = new (0, $983bf56ae6c3bba6$export$c8018838fe3c6395)({
        $metadata: $7e0b86abed89c02c$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, parsedOutput.body);
};
const $7e0b86abed89c02c$var$de_ConflictExceptionRes = async (parsedOutput, context)=>{
    const contents = (0, $07e9587fb0c3a3de$export$871de8747c9eaa88)({});
    const data = parsedOutput.body;
    const doc = (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(data, {
        message: (0, $25d854afa944ccce$export$7ed80f53fe336639)
    });
    Object.assign(contents, doc);
    const exception = new (0, $983bf56ae6c3bba6$export$c64b14d0b7091188)({
        $metadata: $7e0b86abed89c02c$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, parsedOutput.body);
};
const $7e0b86abed89c02c$var$de_InternalServerExceptionRes = async (parsedOutput, context)=>{
    const contents = (0, $07e9587fb0c3a3de$export$871de8747c9eaa88)({});
    const data = parsedOutput.body;
    const doc = (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(data, {
        message: (0, $25d854afa944ccce$export$7ed80f53fe336639)
    });
    Object.assign(contents, doc);
    const exception = new (0, $983bf56ae6c3bba6$export$e2a300c9568821ec)({
        $metadata: $7e0b86abed89c02c$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, parsedOutput.body);
};
const $7e0b86abed89c02c$var$de_ModelErrorExceptionRes = async (parsedOutput, context)=>{
    const contents = (0, $07e9587fb0c3a3de$export$871de8747c9eaa88)({});
    const data = parsedOutput.body;
    const doc = (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(data, {
        message: (0, $25d854afa944ccce$export$7ed80f53fe336639),
        originalStatusCode: (0, $25d854afa944ccce$export$99c64e845cdac9c1),
        resourceName: (0, $25d854afa944ccce$export$7ed80f53fe336639)
    });
    Object.assign(contents, doc);
    const exception = new (0, $983bf56ae6c3bba6$export$1964ebc808a4d6e5)({
        $metadata: $7e0b86abed89c02c$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, parsedOutput.body);
};
const $7e0b86abed89c02c$var$de_ModelNotReadyExceptionRes = async (parsedOutput, context)=>{
    const contents = (0, $07e9587fb0c3a3de$export$871de8747c9eaa88)({});
    const data = parsedOutput.body;
    const doc = (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(data, {
        message: (0, $25d854afa944ccce$export$7ed80f53fe336639)
    });
    Object.assign(contents, doc);
    const exception = new (0, $983bf56ae6c3bba6$export$e4482e9c7a89f5f4)({
        $metadata: $7e0b86abed89c02c$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, parsedOutput.body);
};
const $7e0b86abed89c02c$var$de_ModelStreamErrorExceptionRes = async (parsedOutput, context)=>{
    const contents = (0, $07e9587fb0c3a3de$export$871de8747c9eaa88)({});
    const data = parsedOutput.body;
    const doc = (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(data, {
        message: (0, $25d854afa944ccce$export$7ed80f53fe336639),
        originalMessage: (0, $25d854afa944ccce$export$7ed80f53fe336639),
        originalStatusCode: (0, $25d854afa944ccce$export$99c64e845cdac9c1)
    });
    Object.assign(contents, doc);
    const exception = new (0, $983bf56ae6c3bba6$export$10846a59510c5e02)({
        $metadata: $7e0b86abed89c02c$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, parsedOutput.body);
};
const $7e0b86abed89c02c$var$de_ModelTimeoutExceptionRes = async (parsedOutput, context)=>{
    const contents = (0, $07e9587fb0c3a3de$export$871de8747c9eaa88)({});
    const data = parsedOutput.body;
    const doc = (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(data, {
        message: (0, $25d854afa944ccce$export$7ed80f53fe336639)
    });
    Object.assign(contents, doc);
    const exception = new (0, $983bf56ae6c3bba6$export$5dcc4fd7a5b3f1e9)({
        $metadata: $7e0b86abed89c02c$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, parsedOutput.body);
};
const $7e0b86abed89c02c$var$de_ResourceNotFoundExceptionRes = async (parsedOutput, context)=>{
    const contents = (0, $07e9587fb0c3a3de$export$871de8747c9eaa88)({});
    const data = parsedOutput.body;
    const doc = (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(data, {
        message: (0, $25d854afa944ccce$export$7ed80f53fe336639)
    });
    Object.assign(contents, doc);
    const exception = new (0, $983bf56ae6c3bba6$export$ecba565262f8bb2)({
        $metadata: $7e0b86abed89c02c$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, parsedOutput.body);
};
const $7e0b86abed89c02c$var$de_ServiceQuotaExceededExceptionRes = async (parsedOutput, context)=>{
    const contents = (0, $07e9587fb0c3a3de$export$871de8747c9eaa88)({});
    const data = parsedOutput.body;
    const doc = (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(data, {
        message: (0, $25d854afa944ccce$export$7ed80f53fe336639)
    });
    Object.assign(contents, doc);
    const exception = new (0, $983bf56ae6c3bba6$export$1b9058cd2021c1aa)({
        $metadata: $7e0b86abed89c02c$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, parsedOutput.body);
};
const $7e0b86abed89c02c$var$de_ServiceUnavailableExceptionRes = async (parsedOutput, context)=>{
    const contents = (0, $07e9587fb0c3a3de$export$871de8747c9eaa88)({});
    const data = parsedOutput.body;
    const doc = (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(data, {
        message: (0, $25d854afa944ccce$export$7ed80f53fe336639)
    });
    Object.assign(contents, doc);
    const exception = new (0, $983bf56ae6c3bba6$export$a9c34d9f9b02169a)({
        $metadata: $7e0b86abed89c02c$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, parsedOutput.body);
};
const $7e0b86abed89c02c$var$de_ThrottlingExceptionRes = async (parsedOutput, context)=>{
    const contents = (0, $07e9587fb0c3a3de$export$871de8747c9eaa88)({});
    const data = parsedOutput.body;
    const doc = (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(data, {
        message: (0, $25d854afa944ccce$export$7ed80f53fe336639)
    });
    Object.assign(contents, doc);
    const exception = new (0, $983bf56ae6c3bba6$export$f18ab84fe430e4f3)({
        $metadata: $7e0b86abed89c02c$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, parsedOutput.body);
};
const $7e0b86abed89c02c$var$de_ValidationExceptionRes = async (parsedOutput, context)=>{
    const contents = (0, $07e9587fb0c3a3de$export$871de8747c9eaa88)({});
    const data = parsedOutput.body;
    const doc = (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(data, {
        message: (0, $25d854afa944ccce$export$7ed80f53fe336639)
    });
    Object.assign(contents, doc);
    const exception = new (0, $983bf56ae6c3bba6$export$1dbb1718e06c41be)({
        $metadata: $7e0b86abed89c02c$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $11a0343ffd48eaff$export$db01f0c43e877a50)(exception, parsedOutput.body);
};
const $7e0b86abed89c02c$var$de_ConverseStreamOutput = (output, context)=>{
    return context.eventStreamMarshaller.deserialize(output, async (event)=>{
        if (event["messageStart"] != null) return {
            messageStart: await $7e0b86abed89c02c$var$de_MessageStartEvent_event(event["messageStart"], context)
        };
        if (event["contentBlockStart"] != null) return {
            contentBlockStart: await $7e0b86abed89c02c$var$de_ContentBlockStartEvent_event(event["contentBlockStart"], context)
        };
        if (event["contentBlockDelta"] != null) return {
            contentBlockDelta: await $7e0b86abed89c02c$var$de_ContentBlockDeltaEvent_event(event["contentBlockDelta"], context)
        };
        if (event["contentBlockStop"] != null) return {
            contentBlockStop: await $7e0b86abed89c02c$var$de_ContentBlockStopEvent_event(event["contentBlockStop"], context)
        };
        if (event["messageStop"] != null) return {
            messageStop: await $7e0b86abed89c02c$var$de_MessageStopEvent_event(event["messageStop"], context)
        };
        if (event["metadata"] != null) return {
            metadata: await $7e0b86abed89c02c$var$de_ConverseStreamMetadataEvent_event(event["metadata"], context)
        };
        if (event["internalServerException"] != null) return {
            internalServerException: await $7e0b86abed89c02c$var$de_InternalServerException_event(event["internalServerException"], context)
        };
        if (event["modelStreamErrorException"] != null) return {
            modelStreamErrorException: await $7e0b86abed89c02c$var$de_ModelStreamErrorException_event(event["modelStreamErrorException"], context)
        };
        if (event["validationException"] != null) return {
            validationException: await $7e0b86abed89c02c$var$de_ValidationException_event(event["validationException"], context)
        };
        if (event["throttlingException"] != null) return {
            throttlingException: await $7e0b86abed89c02c$var$de_ThrottlingException_event(event["throttlingException"], context)
        };
        if (event["serviceUnavailableException"] != null) return {
            serviceUnavailableException: await $7e0b86abed89c02c$var$de_ServiceUnavailableException_event(event["serviceUnavailableException"], context)
        };
        return {
            $unknown: output
        };
    });
};
const $7e0b86abed89c02c$var$de_ResponseStream = (output, context)=>{
    return context.eventStreamMarshaller.deserialize(output, async (event)=>{
        if (event["chunk"] != null) return {
            chunk: await $7e0b86abed89c02c$var$de_PayloadPart_event(event["chunk"], context)
        };
        if (event["internalServerException"] != null) return {
            internalServerException: await $7e0b86abed89c02c$var$de_InternalServerException_event(event["internalServerException"], context)
        };
        if (event["modelStreamErrorException"] != null) return {
            modelStreamErrorException: await $7e0b86abed89c02c$var$de_ModelStreamErrorException_event(event["modelStreamErrorException"], context)
        };
        if (event["validationException"] != null) return {
            validationException: await $7e0b86abed89c02c$var$de_ValidationException_event(event["validationException"], context)
        };
        if (event["throttlingException"] != null) return {
            throttlingException: await $7e0b86abed89c02c$var$de_ThrottlingException_event(event["throttlingException"], context)
        };
        if (event["modelTimeoutException"] != null) return {
            modelTimeoutException: await $7e0b86abed89c02c$var$de_ModelTimeoutException_event(event["modelTimeoutException"], context)
        };
        if (event["serviceUnavailableException"] != null) return {
            serviceUnavailableException: await $7e0b86abed89c02c$var$de_ServiceUnavailableException_event(event["serviceUnavailableException"], context)
        };
        return {
            $unknown: output
        };
    });
};
const $7e0b86abed89c02c$var$de_ContentBlockDeltaEvent_event = async (output, context)=>{
    const contents = {};
    const data = await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context);
    Object.assign(contents, (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(data));
    return contents;
};
const $7e0b86abed89c02c$var$de_ContentBlockStartEvent_event = async (output, context)=>{
    const contents = {};
    const data = await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context);
    Object.assign(contents, (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(data));
    return contents;
};
const $7e0b86abed89c02c$var$de_ContentBlockStopEvent_event = async (output, context)=>{
    const contents = {};
    const data = await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context);
    Object.assign(contents, (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(data));
    return contents;
};
const $7e0b86abed89c02c$var$de_ConverseStreamMetadataEvent_event = async (output, context)=>{
    const contents = {};
    const data = await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context);
    Object.assign(contents, $7e0b86abed89c02c$var$de_ConverseStreamMetadataEvent(data, context));
    return contents;
};
const $7e0b86abed89c02c$var$de_InternalServerException_event = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context)
    };
    return $7e0b86abed89c02c$var$de_InternalServerExceptionRes(parsedOutput, context);
};
const $7e0b86abed89c02c$var$de_MessageStartEvent_event = async (output, context)=>{
    const contents = {};
    const data = await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context);
    Object.assign(contents, (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(data));
    return contents;
};
const $7e0b86abed89c02c$var$de_MessageStopEvent_event = async (output, context)=>{
    const contents = {};
    const data = await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context);
    Object.assign(contents, $7e0b86abed89c02c$var$de_MessageStopEvent(data, context));
    return contents;
};
const $7e0b86abed89c02c$var$de_ModelStreamErrorException_event = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context)
    };
    return $7e0b86abed89c02c$var$de_ModelStreamErrorExceptionRes(parsedOutput, context);
};
const $7e0b86abed89c02c$var$de_ModelTimeoutException_event = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context)
    };
    return $7e0b86abed89c02c$var$de_ModelTimeoutExceptionRes(parsedOutput, context);
};
const $7e0b86abed89c02c$var$de_PayloadPart_event = async (output, context)=>{
    const contents = {};
    const data = await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context);
    Object.assign(contents, $7e0b86abed89c02c$var$de_PayloadPart(data, context));
    return contents;
};
const $7e0b86abed89c02c$var$de_ServiceUnavailableException_event = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context)
    };
    return $7e0b86abed89c02c$var$de_ServiceUnavailableExceptionRes(parsedOutput, context);
};
const $7e0b86abed89c02c$var$de_ThrottlingException_event = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context)
    };
    return $7e0b86abed89c02c$var$de_ThrottlingExceptionRes(parsedOutput, context);
};
const $7e0b86abed89c02c$var$de_ValidationException_event = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await (0, $496d3a9f084d8cd2$export$759bcb35b0d1bf81)(output.body, context)
    };
    return $7e0b86abed89c02c$var$de_ValidationExceptionRes(parsedOutput, context);
};
const $7e0b86abed89c02c$var$se_ContentBlock = (input, context)=>{
    return (0, $983bf56ae6c3bba6$export$eb38b3b9c7f5f31b).visit(input, {
        document: (value)=>({
                document: $7e0b86abed89c02c$var$se_DocumentBlock(value, context)
            }),
        guardContent: (value)=>({
                guardContent: $7e0b86abed89c02c$var$se_GuardrailConverseContentBlock(value, context)
            }),
        image: (value)=>({
                image: $7e0b86abed89c02c$var$se_ImageBlock(value, context)
            }),
        text: (value)=>({
                text: value
            }),
        toolResult: (value)=>({
                toolResult: $7e0b86abed89c02c$var$se_ToolResultBlock(value, context)
            }),
        toolUse: (value)=>({
                toolUse: $7e0b86abed89c02c$var$se_ToolUseBlock(value, context)
            }),
        video: (value)=>({
                video: $7e0b86abed89c02c$var$se_VideoBlock(value, context)
            }),
        _: (name, value)=>({
                name: value
            })
    });
};
const $7e0b86abed89c02c$var$se_ContentBlocks = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        return $7e0b86abed89c02c$var$se_ContentBlock(entry, context);
    });
};
const $7e0b86abed89c02c$var$se_DocumentBlock = (input, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(input, {
        format: [],
        name: [],
        source: (_)=>$7e0b86abed89c02c$var$se_DocumentSource(_, context)
    });
};
const $7e0b86abed89c02c$var$se_DocumentSource = (input, context)=>{
    return (0, $983bf56ae6c3bba6$export$d5862784f1527a9c).visit(input, {
        bytes: (value)=>({
                bytes: context.base64Encoder(value)
            }),
        _: (name, value)=>({
                name: value
            })
    });
};
const $7e0b86abed89c02c$var$se_GuardrailContentBlock = (input, context)=>{
    return (0, $983bf56ae6c3bba6$export$68cc35827b3472dc).visit(input, {
        image: (value)=>({
                image: $7e0b86abed89c02c$var$se_GuardrailImageBlock(value, context)
            }),
        text: (value)=>({
                text: (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(value)
            }),
        _: (name, value)=>({
                name: value
            })
    });
};
const $7e0b86abed89c02c$var$se_GuardrailContentBlockList = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        return $7e0b86abed89c02c$var$se_GuardrailContentBlock(entry, context);
    });
};
const $7e0b86abed89c02c$var$se_GuardrailConverseContentBlock = (input, context)=>{
    return (0, $983bf56ae6c3bba6$export$be357cb45c08e0ca).visit(input, {
        image: (value)=>({
                image: $7e0b86abed89c02c$var$se_GuardrailConverseImageBlock(value, context)
            }),
        text: (value)=>({
                text: (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(value)
            }),
        _: (name, value)=>({
                name: value
            })
    });
};
const $7e0b86abed89c02c$var$se_GuardrailConverseImageBlock = (input, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(input, {
        format: [],
        source: (_)=>$7e0b86abed89c02c$var$se_GuardrailConverseImageSource(_, context)
    });
};
const $7e0b86abed89c02c$var$se_GuardrailConverseImageSource = (input, context)=>{
    return (0, $983bf56ae6c3bba6$export$481acdb2ad7a29a).visit(input, {
        bytes: (value)=>({
                bytes: context.base64Encoder(value)
            }),
        _: (name, value)=>({
                name: value
            })
    });
};
const $7e0b86abed89c02c$var$se_GuardrailImageBlock = (input, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(input, {
        format: [],
        source: (_)=>$7e0b86abed89c02c$var$se_GuardrailImageSource(_, context)
    });
};
const $7e0b86abed89c02c$var$se_GuardrailImageSource = (input, context)=>{
    return (0, $983bf56ae6c3bba6$export$ec94a271fc9e24c4).visit(input, {
        bytes: (value)=>({
                bytes: context.base64Encoder(value)
            }),
        _: (name, value)=>({
                name: value
            })
    });
};
const $7e0b86abed89c02c$var$se_ImageBlock = (input, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(input, {
        format: [],
        source: (_)=>$7e0b86abed89c02c$var$se_ImageSource(_, context)
    });
};
const $7e0b86abed89c02c$var$se_ImageSource = (input, context)=>{
    return (0, $983bf56ae6c3bba6$export$280e9a68c3ffd919).visit(input, {
        bytes: (value)=>({
                bytes: context.base64Encoder(value)
            }),
        _: (name, value)=>({
                name: value
            })
    });
};
const $7e0b86abed89c02c$var$se_InferenceConfiguration = (input, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(input, {
        maxTokens: [],
        stopSequences: (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c),
        temperature: (0, $2af401769ccb273e$export$4a2bea4ecaa09ba7),
        topP: (0, $2af401769ccb273e$export$4a2bea4ecaa09ba7)
    });
};
const $7e0b86abed89c02c$var$se_Message = (input, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(input, {
        content: (_)=>$7e0b86abed89c02c$var$se_ContentBlocks(_, context),
        role: []
    });
};
const $7e0b86abed89c02c$var$se_Messages = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        return $7e0b86abed89c02c$var$se_Message(entry, context);
    });
};
const $7e0b86abed89c02c$var$se_ModelInputPayload = (input, context)=>{
    return input;
};
const $7e0b86abed89c02c$var$se_SystemContentBlock = (input, context)=>{
    return (0, $983bf56ae6c3bba6$export$4752b2898aac61ad).visit(input, {
        guardContent: (value)=>({
                guardContent: $7e0b86abed89c02c$var$se_GuardrailConverseContentBlock(value, context)
            }),
        text: (value)=>({
                text: value
            }),
        _: (name, value)=>({
                name: value
            })
    });
};
const $7e0b86abed89c02c$var$se_SystemContentBlocks = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        return $7e0b86abed89c02c$var$se_SystemContentBlock(entry, context);
    });
};
const $7e0b86abed89c02c$var$se_Tool = (input, context)=>{
    return (0, $983bf56ae6c3bba6$export$724f6b867059ef5f).visit(input, {
        toolSpec: (value)=>({
                toolSpec: $7e0b86abed89c02c$var$se_ToolSpecification(value, context)
            }),
        _: (name, value)=>({
                name: value
            })
    });
};
const $7e0b86abed89c02c$var$se_ToolConfiguration = (input, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(input, {
        toolChoice: (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c),
        tools: (_)=>$7e0b86abed89c02c$var$se_Tools(_, context)
    });
};
const $7e0b86abed89c02c$var$se_ToolInputSchema = (input, context)=>{
    return (0, $983bf56ae6c3bba6$export$59c0591707ebf96).visit(input, {
        json: (value)=>({
                json: $7e0b86abed89c02c$var$se_Document(value, context)
            }),
        _: (name, value)=>({
                name: value
            })
    });
};
const $7e0b86abed89c02c$var$se_ToolResultBlock = (input, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(input, {
        content: (_)=>$7e0b86abed89c02c$var$se_ToolResultContentBlocks(_, context),
        status: [],
        toolUseId: []
    });
};
const $7e0b86abed89c02c$var$se_ToolResultContentBlock = (input, context)=>{
    return (0, $983bf56ae6c3bba6$export$e00fc3aa62610e96).visit(input, {
        document: (value)=>({
                document: $7e0b86abed89c02c$var$se_DocumentBlock(value, context)
            }),
        image: (value)=>({
                image: $7e0b86abed89c02c$var$se_ImageBlock(value, context)
            }),
        json: (value)=>({
                json: $7e0b86abed89c02c$var$se_Document(value, context)
            }),
        text: (value)=>({
                text: value
            }),
        video: (value)=>({
                video: $7e0b86abed89c02c$var$se_VideoBlock(value, context)
            }),
        _: (name, value)=>({
                name: value
            })
    });
};
const $7e0b86abed89c02c$var$se_ToolResultContentBlocks = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        return $7e0b86abed89c02c$var$se_ToolResultContentBlock(entry, context);
    });
};
const $7e0b86abed89c02c$var$se_Tools = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        return $7e0b86abed89c02c$var$se_Tool(entry, context);
    });
};
const $7e0b86abed89c02c$var$se_ToolSpecification = (input, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(input, {
        description: [],
        inputSchema: (_)=>$7e0b86abed89c02c$var$se_ToolInputSchema(_, context),
        name: []
    });
};
const $7e0b86abed89c02c$var$se_ToolUseBlock = (input, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(input, {
        input: (_)=>$7e0b86abed89c02c$var$se_Document(_, context),
        name: [],
        toolUseId: []
    });
};
const $7e0b86abed89c02c$var$se_VideoBlock = (input, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(input, {
        format: [],
        source: (_)=>$7e0b86abed89c02c$var$se_VideoSource(_, context)
    });
};
const $7e0b86abed89c02c$var$se_VideoSource = (input, context)=>{
    return (0, $983bf56ae6c3bba6$export$f3a17123d80000c5).visit(input, {
        bytes: (value)=>({
                bytes: context.base64Encoder(value)
            }),
        s3Location: (value)=>({
                s3Location: (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(value)
            }),
        _: (name, value)=>({
                name: value
            })
    });
};
const $7e0b86abed89c02c$var$se_Document = (input, context)=>{
    return input;
};
const $7e0b86abed89c02c$var$de_AsyncInvokeSummaries = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $7e0b86abed89c02c$var$de_AsyncInvokeSummary(entry, context);
    });
    return retVal;
};
const $7e0b86abed89c02c$var$de_AsyncInvokeSummary = (output, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(output, {
        clientRequestToken: (0, $25d854afa944ccce$export$7ed80f53fe336639),
        endTime: (_)=>(0, $25d854afa944ccce$export$8413a63dbe548a49)((0, $d8696255fcc0b769$export$3cb821e2875b4b7d)(_)),
        failureMessage: (0, $25d854afa944ccce$export$7ed80f53fe336639),
        invocationArn: (0, $25d854afa944ccce$export$7ed80f53fe336639),
        lastModifiedTime: (_)=>(0, $25d854afa944ccce$export$8413a63dbe548a49)((0, $d8696255fcc0b769$export$3cb821e2875b4b7d)(_)),
        modelArn: (0, $25d854afa944ccce$export$7ed80f53fe336639),
        outputDataConfig: (_)=>(0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)((0, $c3cb8cbc7fb69ac6$export$a782fbe4c9957f98)(_)),
        status: (0, $25d854afa944ccce$export$7ed80f53fe336639),
        submitTime: (_)=>(0, $25d854afa944ccce$export$8413a63dbe548a49)((0, $d8696255fcc0b769$export$3cb821e2875b4b7d)(_))
    });
};
const $7e0b86abed89c02c$var$de_ContentBlock = (output, context)=>{
    if (output.document != null) return {
        document: $7e0b86abed89c02c$var$de_DocumentBlock(output.document, context)
    };
    if (output.guardContent != null) return {
        guardContent: $7e0b86abed89c02c$var$de_GuardrailConverseContentBlock((0, $c3cb8cbc7fb69ac6$export$a782fbe4c9957f98)(output.guardContent), context)
    };
    if (output.image != null) return {
        image: $7e0b86abed89c02c$var$de_ImageBlock(output.image, context)
    };
    if ((0, $25d854afa944ccce$export$7ed80f53fe336639)(output.text) !== undefined) return {
        text: (0, $25d854afa944ccce$export$7ed80f53fe336639)(output.text)
    };
    if (output.toolResult != null) return {
        toolResult: $7e0b86abed89c02c$var$de_ToolResultBlock(output.toolResult, context)
    };
    if (output.toolUse != null) return {
        toolUse: $7e0b86abed89c02c$var$de_ToolUseBlock(output.toolUse, context)
    };
    if (output.video != null) return {
        video: $7e0b86abed89c02c$var$de_VideoBlock(output.video, context)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
const $7e0b86abed89c02c$var$de_ContentBlocks = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $7e0b86abed89c02c$var$de_ContentBlock((0, $c3cb8cbc7fb69ac6$export$a782fbe4c9957f98)(entry), context);
    });
    return retVal;
};
const $7e0b86abed89c02c$var$de_ConverseOutput = (output, context)=>{
    if (output.message != null) return {
        message: $7e0b86abed89c02c$var$de_Message(output.message, context)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
const $7e0b86abed89c02c$var$de_ConverseStreamMetadataEvent = (output, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(output, {
        metrics: (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c),
        performanceConfig: (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c),
        trace: (_)=>$7e0b86abed89c02c$var$de_ConverseStreamTrace(_, context),
        usage: (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)
    });
};
const $7e0b86abed89c02c$var$de_ConverseStreamTrace = (output, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(output, {
        guardrail: (_)=>$7e0b86abed89c02c$var$de_GuardrailTraceAssessment(_, context),
        promptRouter: (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)
    });
};
const $7e0b86abed89c02c$var$de_ConverseTrace = (output, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(output, {
        guardrail: (_)=>$7e0b86abed89c02c$var$de_GuardrailTraceAssessment(_, context),
        promptRouter: (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)
    });
};
const $7e0b86abed89c02c$var$de_DocumentBlock = (output, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(output, {
        format: (0, $25d854afa944ccce$export$7ed80f53fe336639),
        name: (0, $25d854afa944ccce$export$7ed80f53fe336639),
        source: (_)=>$7e0b86abed89c02c$var$de_DocumentSource((0, $c3cb8cbc7fb69ac6$export$a782fbe4c9957f98)(_), context)
    });
};
const $7e0b86abed89c02c$var$de_DocumentSource = (output, context)=>{
    if (output.bytes != null) return {
        bytes: context.base64Decoder(output.bytes)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
const $7e0b86abed89c02c$var$de_GuardrailAssessment = (output, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(output, {
        contentPolicy: (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c),
        contextualGroundingPolicy: (_)=>$7e0b86abed89c02c$var$de_GuardrailContextualGroundingPolicyAssessment(_, context),
        invocationMetrics: (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c),
        sensitiveInformationPolicy: (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c),
        topicPolicy: (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c),
        wordPolicy: (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)
    });
};
const $7e0b86abed89c02c$var$de_GuardrailAssessmentList = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $7e0b86abed89c02c$var$de_GuardrailAssessment(entry, context);
    });
    return retVal;
};
const $7e0b86abed89c02c$var$de_GuardrailAssessmentListMap = (output, context)=>{
    return Object.entries(output).reduce((acc, [key, value])=>{
        if (value === null) return acc;
        acc[key] = $7e0b86abed89c02c$var$de_GuardrailAssessmentList(value, context);
        return acc;
    }, {});
};
const $7e0b86abed89c02c$var$de_GuardrailAssessmentMap = (output, context)=>{
    return Object.entries(output).reduce((acc, [key, value])=>{
        if (value === null) return acc;
        acc[key] = $7e0b86abed89c02c$var$de_GuardrailAssessment(value, context);
        return acc;
    }, {});
};
const $7e0b86abed89c02c$var$de_GuardrailContextualGroundingFilter = (output, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(output, {
        action: (0, $25d854afa944ccce$export$7ed80f53fe336639),
        score: (0, $25d854afa944ccce$export$11335e83c8af2784),
        threshold: (0, $25d854afa944ccce$export$11335e83c8af2784),
        type: (0, $25d854afa944ccce$export$7ed80f53fe336639)
    });
};
const $7e0b86abed89c02c$var$de_GuardrailContextualGroundingFilters = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $7e0b86abed89c02c$var$de_GuardrailContextualGroundingFilter(entry, context);
    });
    return retVal;
};
const $7e0b86abed89c02c$var$de_GuardrailContextualGroundingPolicyAssessment = (output, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(output, {
        filters: (_)=>$7e0b86abed89c02c$var$de_GuardrailContextualGroundingFilters(_, context)
    });
};
const $7e0b86abed89c02c$var$de_GuardrailConverseContentBlock = (output, context)=>{
    if (output.image != null) return {
        image: $7e0b86abed89c02c$var$de_GuardrailConverseImageBlock(output.image, context)
    };
    if (output.text != null) return {
        text: (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(output.text)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
const $7e0b86abed89c02c$var$de_GuardrailConverseImageBlock = (output, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(output, {
        format: (0, $25d854afa944ccce$export$7ed80f53fe336639),
        source: (_)=>$7e0b86abed89c02c$var$de_GuardrailConverseImageSource((0, $c3cb8cbc7fb69ac6$export$a782fbe4c9957f98)(_), context)
    });
};
const $7e0b86abed89c02c$var$de_GuardrailConverseImageSource = (output, context)=>{
    if (output.bytes != null) return {
        bytes: context.base64Decoder(output.bytes)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
const $7e0b86abed89c02c$var$de_GuardrailTraceAssessment = (output, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(output, {
        inputAssessment: (_)=>$7e0b86abed89c02c$var$de_GuardrailAssessmentMap(_, context),
        modelOutput: (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c),
        outputAssessments: (_)=>$7e0b86abed89c02c$var$de_GuardrailAssessmentListMap(_, context)
    });
};
const $7e0b86abed89c02c$var$de_ImageBlock = (output, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(output, {
        format: (0, $25d854afa944ccce$export$7ed80f53fe336639),
        source: (_)=>$7e0b86abed89c02c$var$de_ImageSource((0, $c3cb8cbc7fb69ac6$export$a782fbe4c9957f98)(_), context)
    });
};
const $7e0b86abed89c02c$var$de_ImageSource = (output, context)=>{
    if (output.bytes != null) return {
        bytes: context.base64Decoder(output.bytes)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
const $7e0b86abed89c02c$var$de_Message = (output, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(output, {
        content: (_)=>$7e0b86abed89c02c$var$de_ContentBlocks(_, context),
        role: (0, $25d854afa944ccce$export$7ed80f53fe336639)
    });
};
const $7e0b86abed89c02c$var$de_MessageStopEvent = (output, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(output, {
        additionalModelResponseFields: (_)=>$7e0b86abed89c02c$var$de_Document(_, context),
        stopReason: (0, $25d854afa944ccce$export$7ed80f53fe336639)
    });
};
const $7e0b86abed89c02c$var$de_PayloadPart = (output, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(output, {
        bytes: context.base64Decoder
    });
};
const $7e0b86abed89c02c$var$de_ToolResultBlock = (output, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(output, {
        content: (_)=>$7e0b86abed89c02c$var$de_ToolResultContentBlocks(_, context),
        status: (0, $25d854afa944ccce$export$7ed80f53fe336639),
        toolUseId: (0, $25d854afa944ccce$export$7ed80f53fe336639)
    });
};
const $7e0b86abed89c02c$var$de_ToolResultContentBlock = (output, context)=>{
    if (output.document != null) return {
        document: $7e0b86abed89c02c$var$de_DocumentBlock(output.document, context)
    };
    if (output.image != null) return {
        image: $7e0b86abed89c02c$var$de_ImageBlock(output.image, context)
    };
    if (output.json != null) return {
        json: $7e0b86abed89c02c$var$de_Document(output.json, context)
    };
    if ((0, $25d854afa944ccce$export$7ed80f53fe336639)(output.text) !== undefined) return {
        text: (0, $25d854afa944ccce$export$7ed80f53fe336639)(output.text)
    };
    if (output.video != null) return {
        video: $7e0b86abed89c02c$var$de_VideoBlock(output.video, context)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
const $7e0b86abed89c02c$var$de_ToolResultContentBlocks = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $7e0b86abed89c02c$var$de_ToolResultContentBlock((0, $c3cb8cbc7fb69ac6$export$a782fbe4c9957f98)(entry), context);
    });
    return retVal;
};
const $7e0b86abed89c02c$var$de_ToolUseBlock = (output, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(output, {
        input: (_)=>$7e0b86abed89c02c$var$de_Document(_, context),
        name: (0, $25d854afa944ccce$export$7ed80f53fe336639),
        toolUseId: (0, $25d854afa944ccce$export$7ed80f53fe336639)
    });
};
const $7e0b86abed89c02c$var$de_VideoBlock = (output, context)=>{
    return (0, $07e9587fb0c3a3de$export$b7df5d561049483a)(output, {
        format: (0, $25d854afa944ccce$export$7ed80f53fe336639),
        source: (_)=>$7e0b86abed89c02c$var$de_VideoSource((0, $c3cb8cbc7fb69ac6$export$a782fbe4c9957f98)(_), context)
    });
};
const $7e0b86abed89c02c$var$de_VideoSource = (output, context)=>{
    if (output.bytes != null) return {
        bytes: context.base64Decoder(output.bytes)
    };
    if (output.s3Location != null) return {
        s3Location: (0, $ccedd6b7948e7cea$export$e0ede334cf6ab53c)(output.s3Location)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
const $7e0b86abed89c02c$var$de_Document = (output, context)=>{
    return output;
};
const $7e0b86abed89c02c$var$deserializeMetadata = (output)=>({
        httpStatusCode: output.statusCode,
        requestId: output.headers["x-amzn-requestid"] ?? output.headers["x-amzn-request-id"] ?? output.headers["x-amz-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    });
const $7e0b86abed89c02c$var$collectBodyString = (streamBody, context)=>(0, $7667c5ed780ba41a$export$3392bcddb824e5ca)(streamBody, context).then((body)=>context.utf8Encoder(body));
const $7e0b86abed89c02c$var$_a = "accept";
const $7e0b86abed89c02c$var$_cT = "contentType";
const $7e0b86abed89c02c$var$_ct = "content-type";
const $7e0b86abed89c02c$var$_gI = "guardrailIdentifier";
const $7e0b86abed89c02c$var$_gV = "guardrailVersion";
const $7e0b86abed89c02c$var$_mR = "maxResults";
const $7e0b86abed89c02c$var$_nT = "nextToken";
const $7e0b86abed89c02c$var$_pCL = "performanceConfigLatency";
const $7e0b86abed89c02c$var$_sB = "sortBy";
const $7e0b86abed89c02c$var$_sE = "statusEquals";
const $7e0b86abed89c02c$var$_sO = "sortOrder";
const $7e0b86abed89c02c$var$_sTA = "submitTimeAfter";
const $7e0b86abed89c02c$var$_sTB = "submitTimeBefore";
const $7e0b86abed89c02c$var$_t = "trace";
const $7e0b86abed89c02c$var$_xaba = "x-amzn-bedrock-accept";
const $7e0b86abed89c02c$var$_xabct = "x-amzn-bedrock-content-type";
const $7e0b86abed89c02c$var$_xabg = "x-amzn-bedrock-guardrailidentifier";
const $7e0b86abed89c02c$var$_xabg_ = "x-amzn-bedrock-guardrailversion";
const $7e0b86abed89c02c$var$_xabpl = "x-amzn-bedrock-performanceconfig-latency";
const $7e0b86abed89c02c$var$_xabt = "x-amzn-bedrock-trace";


class $b72ea2f10b136254$export$6b2edff15292259b extends (0, $ec660c029325fe15$export$cc7e12c76513e857).classBuilder().ep((0, $e94babf240abe10f$export$9c07ced2019f0ae0)).m(function(Command, cs, config, o) {
    return [
        (0, $d08040bde29682c1$export$53fdc69654553fd4)(config, this.serialize, this.deserialize),
        (0, $335ede9082851668$export$946c80457b765eab)(config, Command.getEndpointParameterInstructions())
    ];
}).s("AmazonBedrockFrontendService", "Converse", {}).n("BedrockRuntimeClient", "ConverseCommand").f((0, $983bf56ae6c3bba6$export$4db079fabcc9b6f3), (0, $983bf56ae6c3bba6$export$904d80b0f4729e71)).ser((0, $7e0b86abed89c02c$export$4db1eb00a2075969)).de((0, $7e0b86abed89c02c$export$6d9afa3dc76edc0)).build() {
}


/**
 * @import {
 *   Break,
 *   Blockquote,
 *   Code,
 *   Definition,
 *   Emphasis,
 *   Heading,
 *   Html,
 *   Image,
 *   InlineCode,
 *   Link,
 *   ListItem,
 *   List,
 *   Nodes,
 *   Paragraph,
 *   PhrasingContent,
 *   ReferenceType,
 *   Root,
 *   Strong,
 *   Text,
 *   ThematicBreak
 * } from 'mdast'
 * @import {
 *   Encoding,
 *   Event,
 *   Token,
 *   Value
 * } from 'micromark-util-types'
 * @import {Point} from 'unist'
 * @import {
 *   CompileContext,
 *   CompileData,
 *   Config,
 *   Extension,
 *   Handle,
 *   OnEnterError,
 *   Options
 * } from './types.js'
 */ /**
 * @typedef {import('mdast').Nodes} Nodes
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s (default: `true`).
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML (default: `true`).
 */ /** @type {Options} */ const $c4fd171878a6a851$var$emptyOptions = {};
function $c4fd171878a6a851$export$f84e8e69fd4488a5(value, options) {
    const settings = options || $c4fd171878a6a851$var$emptyOptions;
    const includeImageAlt = typeof settings.includeImageAlt === 'boolean' ? settings.includeImageAlt : true;
    const includeHtml = typeof settings.includeHtml === 'boolean' ? settings.includeHtml : true;
    return $c4fd171878a6a851$var$one(value, includeImageAlt, includeHtml);
}
/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */ function $c4fd171878a6a851$var$one(value, includeImageAlt, includeHtml) {
    if ($c4fd171878a6a851$var$node(value)) {
        if ('value' in value) return value.type === 'html' && !includeHtml ? '' : value.value;
        if (includeImageAlt && 'alt' in value && value.alt) return value.alt;
        if ('children' in value) return $c4fd171878a6a851$var$all(value.children, includeImageAlt, includeHtml);
    }
    if (Array.isArray(value)) return $c4fd171878a6a851$var$all(value, includeImageAlt, includeHtml);
    return '';
}
/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */ function $c4fd171878a6a851$var$all(values, includeImageAlt, includeHtml) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    while(++index < values.length)result[index] = $c4fd171878a6a851$var$one(values[index], includeImageAlt, includeHtml);
    return result.join('');
}
/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Nodes}
 *   Whether `value` is a node.
 */ function $c4fd171878a6a851$var$node(value) {
    return Boolean(value && typeof value === 'object');
}


/**
 * @import {Encoding, Value} from 'micromark-util-types'
 */ /**
 * @typedef {import('micromark-util-types').Options} Options
 */ /**
 * While micromark is a lexer/tokenizer, the common case of going from markdown
 * to html is currently built in as this module, even though the parts can be
 * used separately to build ASTs, CSTs, or many other output formats.
 *
 * Having an HTML compiler built in is useful because it allows us to check for
 * compliancy to CommonMark, the de facto norm of markdown, specified in roughly
 * 600 input/output cases.
 *
 * This module has an interface that accepts lists of events instead of the
 * whole at once, however, because markdown can’t be truly streaming, we buffer
 * events before processing and outputting the final result.
 */ /**
 * @import {
 *   CompileContext,
 *   CompileData,
 *   CompileOptions,
 *   Compile,
 *   Definition,
 *   Event,
 *   Handle,
 *   HtmlExtension,
 *   LineEnding,
 *   NormalizedHtmlExtension,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @typedef Media
 * @property {boolean | undefined} [image]
 * @property {string | undefined} [labelId]
 * @property {string | undefined} [label]
 * @property {string | undefined} [referenceId]
 * @property {string | undefined} [destination]
 * @property {string | undefined} [title]
 */ /// <reference lib="dom" />
/* eslint-env browser */ const $a7eaf83d99f11094$var$element = document.createElement('i');
function $a7eaf83d99f11094$export$289b6a6320f709b4(value) {
    const characterReference = '&' + value + ';';
    $a7eaf83d99f11094$var$element.innerHTML = characterReference;
    const char = $a7eaf83d99f11094$var$element.textContent;
    // Some named character references do not require the closing semicolon
    // (`&not`, for instance), which leads to situations where parsing the assumed
    // named reference of `&notit;` will result in the string `¬it;`.
    // When we encounter a trailing semicolon after parsing, and the character
    // reference to decode was not a semicolon (`&semi;`), we can assume that the
    // matching was not complete.
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    if (char.charCodeAt(char.length - 1) === 59 /* `;` */  && value !== 'semi') return false;
    // If the decoded string is equal to the input, the character reference was
    // not valid.
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    return char === characterReference ? false : char;
}


/**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {undefined}
 *   Nothing.
 */ function $fc7d276d876e7974$export$869882364835d202(list, start, remove, items) {
    const end = list.length;
    let chunkStart = 0;
    /** @type {Array<unknown>} */ let parameters;
    // Make start between zero and `end` (included).
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0;
    // No need to chunk the items if there’s only a couple (10k) items.
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        // @ts-expect-error Hush, it’s fine.
        list.splice(...parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) list.splice(start, remove);
        // Insert the items in chunks to not cause stack overflows.
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            // @ts-expect-error Hush, it’s fine.
            list.splice(...parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
function $fc7d276d876e7974$export$4cbf152802aa238(list, items) {
    if (list.length > 0) {
        $fc7d276d876e7974$export$869882364835d202(list, list.length, 0, items);
        return list;
    }
    return items;
}


/**
 * @import {
 *   Extension,
 *   Handles,
 *   HtmlExtension,
 *   NormalizedExtension
 * } from 'micromark-util-types'
 */ 
const $b9be7a96f8f7c619$var$hasOwnProperty = {}.hasOwnProperty;
function $b9be7a96f8f7c619$export$86a865d89ef3c690(extensions) {
    /** @type {NormalizedExtension} */ const all = {};
    let index = -1;
    while(++index < extensions.length)$b9be7a96f8f7c619$var$syntaxExtension(all, extensions[index]);
    return all;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $b9be7a96f8f7c619$var$syntaxExtension(all, extension) {
    /** @type {keyof Extension} */ let hook;
    for(hook in extension){
        const maybe = $b9be7a96f8f7c619$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        /** @type {Record<string, unknown>} */ const left = maybe || (all[hook] = {});
        /** @type {Record<string, unknown> | undefined} */ const right = extension[hook];
        /** @type {string} */ let code;
        if (right) for(code in right){
            if (!$b9be7a96f8f7c619$var$hasOwnProperty.call(left, code)) left[code] = [];
            const value = right[code];
            $b9be7a96f8f7c619$var$constructs(// @ts-expect-error Looks like a list.
            left[code], Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    }
}
/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 *   List of constructs to merge into.
 * @param {Array<unknown>} list
 *   List of constructs to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $b9be7a96f8f7c619$var$constructs(existing, list) {
    let index = -1;
    /** @type {Array<unknown>} */ const before = [];
    while(++index < list.length)(list[index].add === 'after' ? existing : before).push(list[index]);
    (0, $fc7d276d876e7974$export$869882364835d202)(existing, 0, 0, before);
}
function $b9be7a96f8f7c619$export$eaf8c406dfb0a620(htmlExtensions) {
    /** @type {HtmlExtension} */ const handlers = {};
    let index = -1;
    while(++index < htmlExtensions.length)$b9be7a96f8f7c619$var$htmlExtension(handlers, htmlExtensions[index]);
    return handlers;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $b9be7a96f8f7c619$var$htmlExtension(all, extension) {
    /** @type {keyof HtmlExtension} */ let hook;
    for(hook in extension){
        const maybe = $b9be7a96f8f7c619$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        const left = maybe || (all[hook] = {});
        const right = extension[hook];
        /** @type {keyof Handles} */ let type;
        if (right) for(type in right)// @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type];
    }
}


/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCodePoint(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */ function $d84c106c656940a7$export$15a69557afac2c20(value, base) {
    const code = Number.parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space.
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of C0, and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || /* eslint-disable no-bitwise */ (code & 65535) === 65535 || (code & 65535) === 65534 || /* eslint-enable no-bitwise */ // Out of range
    code > 1114111) return "\uFFFD";
    return String.fromCodePoint(code);
}


const $453c066d9e8d44e9$var$characterReferences = {
    '"': 'quot',
    '&': 'amp',
    '<': 'lt',
    '>': 'gt'
};
function $453c066d9e8d44e9$export$c564cdbbe6da493(value) {
    return value.replace(/["&<>]/g, replace);
    /**
   * @param {string} value
   *   Value to replace.
   * @returns {string}
   *   Encoded value.
   */ function replace(value) {
        return '&' + $453c066d9e8d44e9$var$characterReferences[/** @type {keyof typeof characterReferences} */ value] + ';';
    }
}


/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */ function $e8a88a5e1b7aeb38$export$806d55e226cfcd08(value) {
    return value// Collapse markdown whitespace.
    .replace(/[\t\n\r ]+/g, " ")// Trim.
    .replace(/^ | $/g, '')// Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no method is uppercase.
    .toLowerCase().toUpperCase();
}


/**
 * @import {Code} from 'micromark-util-types'
 */ /**
 * Check whether the character code represents an ASCII alpha (`a` through `z`,
 * case insensitive).
 *
 * An **ASCII alpha** is an ASCII upper alpha or ASCII lower alpha.
 *
 * An **ASCII upper alpha** is a character in the inclusive range U+0041 (`A`)
 * to U+005A (`Z`).
 *
 * An **ASCII lower alpha** is a character in the inclusive range U+0061 (`a`)
 * to U+007A (`z`).
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */ const $db5865ecc27181ba$export$d65d6b62c24d5436 = $db5865ecc27181ba$var$regexCheck(/[A-Za-z]/);
const $db5865ecc27181ba$export$75c76db11865a9f4 = $db5865ecc27181ba$var$regexCheck(/[\dA-Za-z]/);
const $db5865ecc27181ba$export$4397998b34fe597d = $db5865ecc27181ba$var$regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function $db5865ecc27181ba$export$67dbf494fc8394df(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127));
}
const $db5865ecc27181ba$export$ca8b5b1a6c320e6e = $db5865ecc27181ba$var$regexCheck(/\d/);
const $db5865ecc27181ba$export$eca2752363989806 = $db5865ecc27181ba$var$regexCheck(/[\dA-Fa-f]/);
const $db5865ecc27181ba$export$35794a7d1db99380 = $db5865ecc27181ba$var$regexCheck(/[!-/:-@[-`{-~]/);
function $db5865ecc27181ba$export$34a1dff1c0936953(code) {
    return code !== null && code < -2;
}
function $db5865ecc27181ba$export$a30284361b3814b7(code) {
    return code !== null && (code < 0 || code === 32);
}
function $db5865ecc27181ba$export$2c6cf65c1127992a(code) {
    return code === -2 || code === -1 || code === 32;
}
const $db5865ecc27181ba$export$aa04114dd888a7a0 = $db5865ecc27181ba$var$regexCheck(/\p{P}|\p{S}/u);
const $db5865ecc27181ba$export$a0ff789c034ffdf4 = $db5865ecc27181ba$var$regexCheck(/\s/);
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 *   Expression.
 * @returns {(code: Code) => boolean}
 *   Check.
 */ function $db5865ecc27181ba$var$regexCheck(regex) {
    return check;
    /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */ function check(code) {
        return code !== null && code > -1 && regex.test(String.fromCharCode(code));
    }
}



function $921de628cfa25736$export$d130a2d684099e5a(url, protocol) {
    const value = (0, $453c066d9e8d44e9$export$c564cdbbe6da493)($921de628cfa25736$export$e42a3e39590d28b5(url || ''));
    if (!protocol) return value;
    const colon = value.indexOf(':');
    const questionMark = value.indexOf('?');
    const numberSign = value.indexOf('#');
    const slash = value.indexOf('/');
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))) return value;
    return '';
}
function $921de628cfa25736$export$e42a3e39590d28b5(value) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    let start = 0;
    let skip = 0;
    while(++index < value.length){
        const code = value.charCodeAt(index);
        /** @type {string} */ let replace = '';
        // A correct percent encoded value.
        if (code === 37 && (0, $db5865ecc27181ba$export$75c76db11865a9f4)(value.charCodeAt(index + 1)) && (0, $db5865ecc27181ba$export$75c76db11865a9f4)(value.charCodeAt(index + 2))) skip = 2;
        else if (code < 128) {
            if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) replace = String.fromCharCode(code);
        } else if (code > 55295 && code < 57344) {
            const next = value.charCodeAt(index + 1);
            // A correct surrogate pair.
            if (code < 56320 && next > 56319 && next < 57344) {
                replace = String.fromCharCode(code, next);
                skip = 1;
            } else replace = "\uFFFD";
        } else replace = String.fromCharCode(code);
        if (replace) {
            result.push(value.slice(start, index), encodeURIComponent(replace));
            start = index + skip + 1;
            replace = '';
        }
        if (skip) {
            index += skip;
            skip = 0;
        }
    }
    return result.join('') + value.slice(start);
}


const $6a1842fa275d2baf$var$hasOwnProperty = {}.hasOwnProperty;
/**
 * These two are allowlists of safe protocols for full URLs in respectively the
 * `href` (on `<a>`) and `src` (on `<img>`) attributes.
 * They are based on what is allowed on GitHub,
 * <https://github.com/syntax-tree/hast-util-sanitize/blob/9275b21/lib/github.json#L31>
 */ const $6a1842fa275d2baf$var$protocolHref = /^(https?|ircs?|mailto|xmpp)$/i;
const $6a1842fa275d2baf$var$protocolSource = /^https?$/i;
function $6a1842fa275d2baf$export$ef7acd7185315e22(options) {
    const settings = options || {};
    /**
   * Tags is needed because according to markdown, links and emphasis and
   * whatnot can exist in images, however, as HTML doesn’t allow content in
   * images, the tags are ignored in the `alt` attribute, but the content
   * remains.
   *
   * @type {boolean | undefined}
   */ let tags = true;
    /**
   * An object to track identifiers to media (URLs and titles) defined with
   * definitions.
   *
   * @type {Record<string, Definition>}
   */ const definitions = {};
    /**
   * A lot of the handlers need to capture some of the output data, modify it
   * somehow, and then deal with it.
   * We do that by tracking a stack of buffers, that can be opened (with
   * `buffer`) and closed (with `resume`) to access them.
   *
   * @type {Array<Array<string>>}
   */ const buffers = [
        []
    ];
    /**
   * As we can have links in images and the other way around, where the deepest
   * ones are closed first, we need to track which one we’re in.
   *
   * @type {Array<Media>}
   */ const mediaStack = [];
    /**
   * Same as `mediaStack` for tightness, which is specific to lists.
   * We need to track if we’re currently in a tight or loose container.
   *
   * @type {Array<boolean>}
   */ const tightStack = [];
    /** @type {HtmlExtension} */ const defaultHandlers = {
        enter: {
            blockQuote: onenterblockquote,
            codeFenced: onentercodefenced,
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: onentercodeindented,
            codeText: onentercodetext,
            content: onentercontent,
            definition: onenterdefinition,
            definitionDestinationString: onenterdefinitiondestinationstring,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: onenteremphasis,
            htmlFlow: onenterhtmlflow,
            htmlText: onenterhtml,
            image: onenterimage,
            label: buffer,
            link: onenterlink,
            listItemMarker: onenterlistitemmarker,
            listItemValue: onenterlistitemvalue,
            listOrdered: onenterlistordered,
            listUnordered: onenterlistunordered,
            paragraph: onenterparagraph,
            reference: buffer,
            resource: onenterresource,
            resourceDestinationString: onenterresourcedestinationstring,
            resourceTitleString: buffer,
            setextHeading: onentersetextheading,
            strong: onenterstrong
        },
        exit: {
            atxHeading: onexitatxheading,
            atxHeadingSequence: onexitatxheadingsequence,
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: onexitblockquote,
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: onexitflowcode,
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onresumedrop,
            codeFlowValue: onexitcodeflowvalue,
            codeIndented: onexitflowcode,
            codeText: onexitcodetext,
            codeTextData: onexitdata,
            data: onexitdata,
            definition: onexitdefinition,
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: onexitemphasis,
            hardBreakEscape: onexithardbreak,
            hardBreakTrailing: onexithardbreak,
            htmlFlow: onexithtml,
            htmlFlowData: onexitdata,
            htmlText: onexithtml,
            htmlTextData: onexitdata,
            image: onexitmedia,
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: onexitmedia,
            listOrdered: onexitlistordered,
            listUnordered: onexitlistunordered,
            paragraph: onexitparagraph,
            reference: onresumedrop,
            referenceString: onexitreferencestring,
            resource: onresumedrop,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            setextHeading: onexitsetextheading,
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: onexitstrong,
            thematicBreak: onexitthematicbreak
        }
    };
    /**
   * Combine the HTML extensions with the default handlers.
   * An HTML extension is an object whose fields are either `enter` or `exit`
   * (reflecting whether a token is entered or exited).
   * The values at such objects are names of tokens mapping to handlers.
   * Handlers are called, respectively when a token is opener or closed, with
   * that token, and a context as `this`.
   */ const handlers = /** @type {NormalizedHtmlExtension} */ (0, $b9be7a96f8f7c619$export$eaf8c406dfb0a620)([
        defaultHandlers,
        ...settings.htmlExtensions || []
    ]);
    /**
   * Handlers do often need to keep track of some state.
   * That state is provided here as a key-value store (an object).
   *
   * @type {CompileData}
   */ const data = {
        definitions: definitions,
        tightStack: tightStack
    };
    /**
   * The context for handlers references a couple of useful functions.
   * In handlers from extensions, those can be accessed at `this`.
   * For the handlers here, they can be accessed directly.
   *
   * @type {Omit<CompileContext, 'sliceSerialize'>}
   */ const context = {
        buffer: buffer,
        encode: encode,
        getData: getData,
        lineEndingIfNeeded: lineEndingIfNeeded,
        options: settings,
        raw: raw,
        resume: resume,
        setData: setData,
        tag: tag
    };
    /**
   * Generally, micromark copies line endings (`'\r'`, `'\n'`, `'\r\n'`) in the
   * markdown document over to the compiled HTML.
   * In some cases, such as `> a`, CommonMark requires that extra line endings
   * are added: `<blockquote>\n<p>a</p>\n</blockquote>`.
   * This variable hold the default line ending when given (or `undefined`),
   * and in the latter case will be updated to the first found line ending if
   * there is one.
   */ let lineEndingStyle = settings.defaultLineEnding;
    // Return the function that handles a slice of events.
    return compile;
    /**
   * Deal w/ a slice of events.
   * Return either the empty string if there’s nothing of note to return, or the
   * result when done.
   *
   * @param {ReadonlyArray<Event>} events
   * @returns {string}
   */ function compile(events) {
        let index = -1;
        let start = 0;
        /** @type {Array<number>} */ const listStack = [];
        // As definitions can come after references, we need to figure out the media
        // (urls and titles) defined by them before handling the references.
        // So, we do sort of what HTML does: put metadata at the start (in head), and
        // then put content after (`body`).
        /** @type {Array<Event>} */ let head = [];
        /** @type {Array<Event>} */ let body = [];
        while(++index < events.length){
            // Figure out the line ending style used in the document.
            if (!lineEndingStyle && (events[index][1].type === "lineEnding" || events[index][1].type === "lineEndingBlank")) lineEndingStyle = /** @type {LineEnding} */ events[index][2].sliceSerialize(events[index][1]);
            // Preprocess lists to infer whether the list is loose or not.
            if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
                if (events[index][0] === 'enter') listStack.push(index);
                else prepareList(events.slice(listStack.pop(), index));
            }
            // Move definitions to the front.
            if (events[index][1].type === "definition") {
                if (events[index][0] === 'enter') {
                    body = (0, $fc7d276d876e7974$export$4cbf152802aa238)(body, events.slice(start, index));
                    start = index;
                } else {
                    head = (0, $fc7d276d876e7974$export$4cbf152802aa238)(head, events.slice(start, index + 1));
                    start = index + 1;
                }
            }
        }
        head = (0, $fc7d276d876e7974$export$4cbf152802aa238)(head, body);
        head = (0, $fc7d276d876e7974$export$4cbf152802aa238)(head, events.slice(start));
        index = -1;
        const result = head;
        // Handle the start of the document, if defined.
        if (handlers.enter.null) handlers.enter.null.call(context);
        // Handle all events.
        while(++index < events.length){
            const handles = handlers[result[index][0]];
            const kind = result[index][1].type;
            const handle = handles[kind];
            if ($6a1842fa275d2baf$var$hasOwnProperty.call(handles, kind) && handle) handle.call({
                sliceSerialize: result[index][2].sliceSerialize,
                ...context
            }, result[index][1]);
        }
        // Handle the end of the document, if defined.
        if (handlers.exit.null) handlers.exit.null.call(context);
        return buffers[0].join('');
    }
    /**
   * Figure out whether lists are loose or not.
   *
   * @param {ReadonlyArray<Event>} slice
   * @returns {undefined}
   */ function prepareList(slice) {
        const length = slice.length;
        let index = 0; // Skip open.
        let containerBalance = 0;
        let loose = false;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index < length){
            const event = slice[index];
            if (event[1]._container) {
                atMarker = undefined;
                if (event[0] === 'enter') containerBalance++;
                else containerBalance--;
            } else switch(event[1].type){
                case "listItemPrefix":
                    if (event[0] === 'exit') atMarker = true;
                    break;
                case "linePrefix":
                    break;
                case "lineEndingBlank":
                    if (event[0] === 'enter' && !containerBalance) {
                        if (atMarker) atMarker = undefined;
                        else loose = true;
                    }
                    break;
                default:
                    atMarker = undefined;
            }
        }
        slice[0][1]._loose = loose;
    }
    /**
   * @type {CompileContext['setData']}
   */ function setData(key, value) {
        // @ts-expect-error: assume `value` is omitted (`undefined` is passed) only
        // if allowed.
        data[key] = value;
    }
    /**
   * @type {CompileContext['getData']}
   */ function getData(key) {
        return data[key];
    }
    /** @type {CompileContext['buffer']} */ function buffer() {
        buffers.push([]);
    }
    /** @type {CompileContext['resume']} */ function resume() {
        const buf = buffers.pop();
        return buf.join('');
    }
    /** @type {CompileContext['tag']} */ function tag(value) {
        if (!tags) return;
        setData('lastWasTag', true);
        buffers[buffers.length - 1].push(value);
    }
    /** @type {CompileContext['raw']} */ function raw(value) {
        setData('lastWasTag');
        buffers[buffers.length - 1].push(value);
    }
    /**
   * Output an extra line ending.
   *
   * @returns {undefined}
   */ function lineEnding() {
        raw(lineEndingStyle || '\n');
    }
    /** @type {CompileContext['lineEndingIfNeeded']} */ function lineEndingIfNeeded() {
        const buffer = buffers[buffers.length - 1];
        const slice = buffer[buffer.length - 1];
        const previous = slice ? slice.charCodeAt(slice.length - 1) : null;
        if (previous === 10 || previous === 13 || previous === null) return;
        lineEnding();
    }
    /** @type {CompileContext['encode']} */ function encode(value) {
        return getData('ignoreEncode') ? value : (0, $453c066d9e8d44e9$export$c564cdbbe6da493)(value);
    }
    //
    // Handlers.
    //
    /**
   * @returns {undefined}
   */ function onresumedrop() {
        resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag('<ol');
        setData('expectFirstItem', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistunordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag('<ul');
        setData('expectFirstItem', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (getData('expectFirstItem')) {
            const value = Number.parseInt(this.sliceSerialize(token), 10);
            if (value !== 1) tag(' start="' + encode(String(value)) + '"');
        }
    }
    /**
   * @returns {undefined}
   */ function onenterlistitemmarker() {
        if (getData('expectFirstItem')) tag('>');
        else onexitlistitem();
        lineEndingIfNeeded();
        tag('<li>');
        setData('expectFirstItem');
        // “Hack” to prevent a line ending from showing up if the item is empty.
        setData('lastWasTag');
    }
    /**
   * @returns {undefined}
   */ function onexitlistordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag('</ol>');
    }
    /**
   * @returns {undefined}
   */ function onexitlistunordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag('</ul>');
    }
    /**
   * @returns {undefined}
   */ function onexitlistitem() {
        if (getData('lastWasTag') && !getData('slurpAllLineEndings')) lineEndingIfNeeded();
        tag('</li>');
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterblockquote() {
        tightStack.push(false);
        lineEndingIfNeeded();
        tag('<blockquote>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitblockquote() {
        tightStack.pop();
        lineEndingIfNeeded();
        tag('</blockquote>');
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterparagraph() {
        if (!tightStack[tightStack.length - 1]) {
            lineEndingIfNeeded();
            tag('<p>');
        }
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitparagraph() {
        if (tightStack[tightStack.length - 1]) setData('slurpAllLineEndings', true);
        else tag('</p>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodefenced() {
        lineEndingIfNeeded();
        tag('<pre><code');
        setData('fencesCount', 0);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const value = resume();
        tag(' class="language-' + value + '"');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        const count = getData('fencesCount') || 0;
        if (!count) {
            tag('>');
            setData('slurpOneLineEnding', true);
        }
        setData('fencesCount', count + 1);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodeindented() {
        lineEndingIfNeeded();
        tag('<pre><code>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitflowcode() {
        const count = getData('fencesCount');
        // One special case is if we are inside a container, and the fenced code was
        // not closed (meaning it runs to the end).
        // In that case, the following line ending, is considered *outside* the
        // fenced code and block quote by micromark, but CM wants to treat that
        // ending as part of the code.
        if (count !== undefined && count < 2 && data.tightStack.length > 0 && !getData('lastWasTag')) lineEnding();
        // But in most cases, it’s simpler: when we’ve seen some data, emit an extra
        // line ending when needed.
        if (getData('flowCodeSeenData')) lineEndingIfNeeded();
        tag('</code></pre>');
        if (count !== undefined && count < 2) lineEndingIfNeeded();
        setData('flowCodeSeenData');
        setData('fencesCount');
        setData('slurpOneLineEnding');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterimage() {
        mediaStack.push({
            image: true
        });
        tags = undefined; // Disallow tags.
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlink() {
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        mediaStack[mediaStack.length - 1].label = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        mediaStack[mediaStack.length - 1].referenceId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresource() {
        buffer(); // We can have line endings in the resource, ignore them.
        mediaStack[mediaStack.length - 1].destination = '';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresourcedestinationstring() {
        buffer();
        // Ignore encoding the result, as we’ll first percent encode the url and
        // encode manually after.
        setData('ignoreEncode', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData('ignoreEncode');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitmedia() {
        let index = mediaStack.length - 1; // Skip current.
        const media = mediaStack[index];
        const id = media.referenceId || media.labelId;
        const context = media.destination === undefined ? definitions[(0, $e8a88a5e1b7aeb38$export$806d55e226cfcd08)(id)] : media;
        tags = true;
        while(index--)if (mediaStack[index].image) {
            tags = undefined;
            break;
        }
        if (media.image) {
            tag('<img src="' + (0, $921de628cfa25736$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $6a1842fa275d2baf$var$protocolSource) + '" alt="');
            raw(media.label);
            tag('"');
        } else tag('<a href="' + (0, $921de628cfa25736$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $6a1842fa275d2baf$var$protocolHref) + '"');
        tag(context.title ? ' title="' + context.title + '"' : '');
        if (media.image) tag(' />');
        else {
            tag('>');
            raw(media.label);
            tag('</a>');
        }
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinition() {
        buffer();
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        // Discard label, use the source content instead.
        resume();
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinitiondestinationstring() {
        buffer();
        setData('ignoreEncode', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData('ignoreEncode');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinition() {
        const media = mediaStack[mediaStack.length - 1];
        const id = (0, $e8a88a5e1b7aeb38$export$806d55e226cfcd08)(media.labelId);
        resume();
        if (!$6a1842fa275d2baf$var$hasOwnProperty.call(definitions, id)) definitions[id] = mediaStack[mediaStack.length - 1];
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercontent() {
        setData('slurpAllLineEndings', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        // Exit for further sequences.
        if (getData('headingRank')) return;
        setData('headingRank', this.sliceSerialize(token).length);
        lineEndingIfNeeded();
        tag('<h' + getData('headingRank') + '>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentersetextheading() {
        buffer();
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        setData('slurpAllLineEndings', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheading() {
        tag('</h' + getData('headingRank') + '>');
        setData('headingRank');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        setData('headingRank', this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        const value = resume();
        lineEndingIfNeeded();
        tag('<h' + getData('headingRank') + '>');
        raw(value);
        tag('</h' + getData('headingRank') + '>');
        setData('slurpAllLineEndings');
        setData('headingRank');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        if (getData('slurpAllLineEndings')) return;
        if (getData('slurpOneLineEnding')) {
            setData('slurpOneLineEnding');
            return;
        }
        if (getData('inCodeText')) {
            raw(' ');
            return;
        }
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeflowvalue(token) {
        raw(encode(this.sliceSerialize(token)));
        setData('flowCodeSeenData', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        tag('<br />');
    }
    /**
   * @returns {undefined}
   */ function onenterhtmlflow() {
        lineEndingIfNeeded();
        onenterhtml();
    }
    /**
   * @returns {undefined}
   */ function onexithtml() {
        setData('ignoreEncode');
    }
    /**
   * @returns {undefined}
   */ function onenterhtml() {
        if (settings.allowDangerousHtml) setData('ignoreEncode', true);
    }
    /**
   * @returns {undefined}
   */ function onenteremphasis() {
        tag('<em>');
    }
    /**
   * @returns {undefined}
   */ function onenterstrong() {
        tag('<strong>');
    }
    /**
   * @returns {undefined}
   */ function onentercodetext() {
        setData('inCodeText', true);
        tag('<code>');
    }
    /**
   * @returns {undefined}
   */ function onexitcodetext() {
        setData('inCodeText');
        tag('</code>');
    }
    /**
   * @returns {undefined}
   */ function onexitemphasis() {
        tag('</em>');
    }
    /**
   * @returns {undefined}
   */ function onexitstrong() {
        tag('</strong>');
    }
    /**
   * @returns {undefined}
   */ function onexitthematicbreak() {
        lineEndingIfNeeded();
        tag('<hr />');
    }
    /**
   * @this {CompileContext}
   * @param {Token} token
   * @returns {undefined}
   */ function onexitcharacterreferencemarker(token) {
        setData('characterReferenceType', token.type);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const value = this.sliceSerialize(token);
        const decoded = getData('characterReferenceType') ? (0, $d84c106c656940a7$export$15a69557afac2c20)(value, getData('characterReferenceType') === "characterReferenceMarkerNumeric" ? 10 : 16) : (0, $a7eaf83d99f11094$export$289b6a6320f709b4)(value);
        // `decodeNamedCharacterReference` can return `false` for invalid named
        // character references,
        // but everything we’ve tokenized is valid.
        raw(encode(/** @type {string} */ decoded));
        setData('characterReferenceType');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $921de628cfa25736$export$d130a2d684099e5a)(uri, settings.allowDangerousProtocol ? undefined : $6a1842fa275d2baf$var$protocolHref) + '">');
        raw(encode(uri));
        tag('</a>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $921de628cfa25736$export$d130a2d684099e5a)('mailto:' + uri) + '">');
        raw(encode(uri));
        tag('</a>');
    }
}


/**
 * @import {
 *   Create,
 *   FullNormalizedExtension,
 *   InitialConstruct,
 *   ParseContext,
 *   ParseOptions
 * } from 'micromark-util-types'
 */ 
/**
 * @import {
 *   InitialConstruct,
 *   Initializer,
 *   State,
 *   TokenizeContext,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @import {Effects, State, TokenType} from 'micromark-util-types'
 */ 
function $9ffa6a5710aabe9f$export$ae105c1eb063a0a2(effects, ok, type, max) {
    const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}



const $269c7d839a0a7a60$export$a7db06668cad9adb = {
    tokenize: $269c7d839a0a7a60$var$initializeContent
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Initializer}
 *   Content.
 */ function $269c7d839a0a7a60$var$initializeContent(effects) {
    const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    /** @type {Token} */ let previous;
    return contentStart;
    /** @type {State} */ function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, contentStart, "linePrefix");
    }
    /** @type {State} */ function paragraphInitial(code) {
        effects.enter("paragraph");
        return lineStart(code);
    }
    /** @type {State} */ function lineStart(code) {
        const token = effects.enter("chunkText", {
            contentType: "text",
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) {
            effects.exit("chunkText");
            effects.exit("paragraph");
            effects.consume(code);
            return;
        }
        if ((0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            effects.exit("chunkText");
            return lineStart;
        }
        // Data.
        effects.consume(code);
        return data;
    }
}


/**
 * @import {
 *   Construct,
 *   ContainerState,
 *   InitialConstruct,
 *   Initializer,
 *   Point,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @typedef {[Construct, ContainerState]} StackItem
 *   Construct and its state.
 */ 


const $e94c0f7dee28bcba$export$5a7bfc01df82fcd1 = {
    tokenize: $e94c0f7dee28bcba$var$initializeDocument
};
/** @type {Construct} */ const $e94c0f7dee28bcba$var$containerConstruct = {
    tokenize: $e94c0f7dee28bcba$var$tokenizeContainer
};
/**
 * @this {TokenizeContext}
 *   Self.
 * @type {Initializer}
 *   Initializer.
 */ function $e94c0f7dee28bcba$var$initializeDocument(effects) {
    const self = this;
    /** @type {Array<StackItem>} */ const stack = [];
    let continued = 0;
    /** @type {TokenizeContext | undefined} */ let childFlow;
    /** @type {Token | undefined} */ let childToken;
    /** @type {number} */ let lineStartOffset;
    return start;
    /** @type {State} */ function start(code) {
        // First we iterate through the open blocks, starting with the root
        // document, and descending through last children down to the last open
        // block.
        // Each block imposes a condition that the line must satisfy if the block is
        // to remain open.
        // For example, a block quote requires a `>` character.
        // A paragraph requires a non-blank line.
        // In this phase we may match all or just some of the open blocks.
        // But we cannot close unmatched blocks yet, because we may have a lazy
        // continuation line.
        if (continued < stack.length) {
            const item = stack[continued];
            self.containerState = item[1];
            return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
        }
        // Done.
        return checkNewContainers(code);
    }
    /** @type {State} */ function documentContinue(code) {
        continued++;
        // Note: this field is called `_closeFlow` but it also closes containers.
        // Perhaps a good idea to rename it but it’s already used in the wild by
        // extensions.
        if (self.containerState._closeFlow) {
            self.containerState._closeFlow = undefined;
            if (childFlow) closeFlow();
            // Note: this algorithm for moving events around is similar to the
            // algorithm when dealing with lazy lines in `writeToChild`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {Point | undefined} */ let point;
            // Find the flow chunk.
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                point = self.events[indexBeforeFlow][1].end;
                break;
            }
            exitContainers(continued);
            // Fix positions.
            let index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = {
                    ...point
                };
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $fc7d276d876e7974$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
            return checkNewContainers(code);
        }
        return start(code);
    }
    /** @type {State} */ function checkNewContainers(code) {
        // Next, after consuming the continuation markers for existing blocks, we
        // look for new block starts (e.g. `>` for a block quote).
        // If we encounter a new block start, we close any blocks unmatched in
        // step 1 before creating the new block as a child of the last matched
        // block.
        if (continued === stack.length) {
            // No need to `check` whether there’s a container, of `exitContainers`
            // would be moot.
            // We can instead immediately `attempt` to parse one.
            if (!childFlow) return documentContinued(code);
            // If we have concrete content, such as block HTML or fenced code,
            // we can’t have containers “pierce” into them, so we can immediately
            // start.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code);
            // If we do have flow, it could still be a blank line,
            // but we’d be interrupting it w/ a new container if there’s a current
            // construct.
            // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
            // needed in micromark-extension-gfm-table@1.0.6).
            self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
        }
        // Check if there is a new container.
        self.containerState = {};
        return effects.check($e94c0f7dee28bcba$var$containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
    }
    /** @type {State} */ function thereIsANewContainer(code) {
        if (childFlow) closeFlow();
        exitContainers(continued);
        return documentContinued(code);
    }
    /** @type {State} */ function thereIsNoNewContainer(code) {
        self.parser.lazy[self.now().line] = continued !== stack.length;
        lineStartOffset = self.now().offset;
        return flowStart(code);
    }
    /** @type {State} */ function documentContinued(code) {
        // Try new containers.
        self.containerState = {};
        return effects.attempt($e94c0f7dee28bcba$var$containerConstruct, containerContinue, flowStart)(code);
    }
    /** @type {State} */ function containerContinue(code) {
        continued++;
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        // Try another.
        return documentContinued(code);
    }
    /** @type {State} */ function flowStart(code) {
        if (code === null) {
            if (childFlow) closeFlow();
            exitContainers(0);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter("chunkFlow", {
            _tokenizer: childFlow,
            contentType: "flow",
            previous: childToken
        });
        return flowContinue(code);
    }
    /** @type {State} */ function flowContinue(code) {
        if (code === null) {
            writeToChild(effects.exit("chunkFlow"), true);
            exitContainers(0);
            effects.consume(code);
            return;
        }
        if ((0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            writeToChild(effects.exit("chunkFlow"));
            // Get ready for the next line.
            continued = 0;
            self.interrupt = undefined;
            return start;
        }
        effects.consume(code);
        return flowContinue;
    }
    /**
   * @param {Token} token
   *   Token.
   * @param {boolean | undefined} [endOfFile]
   *   Whether the token is at the end of the file (default: `false`).
   * @returns {undefined}
   *   Nothing.
   */ function writeToChild(token, endOfFile) {
        const stream = self.sliceStream(token);
        if (endOfFile) stream.push(null);
        token.previous = childToken;
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.defineSkip(token.start);
        childFlow.write(stream);
        // Alright, so we just added a lazy line:
        //
        // ```markdown
        // > a
        // b.
        //
        // Or:
        //
        // > ~~~c
        // d
        //
        // Or:
        //
        // > | e |
        // f
        // ```
        //
        // The construct in the second example (fenced code) does not accept lazy
        // lines, so it marked itself as done at the end of its first line, and
        // then the content construct parses `d`.
        // Most constructs in markdown match on the first line: if the first line
        // forms a construct, a non-lazy line can’t “unmake” it.
        //
        // The construct in the third example is potentially a GFM table, and
        // those are *weird*.
        // It *could* be a table, from the first line, if the following line
        // matches a condition.
        // In this case, that second line is lazy, which “unmakes” the first line
        // and turns the whole into one content block.
        //
        // We’ve now parsed the non-lazy and the lazy line, and can figure out
        // whether the lazy line started a new flow block.
        // If it did, we exit the current containers between the two flow blocks.
        if (self.parser.lazy[token.start.line]) {
            let index = childFlow.events.length;
            while(index--){
                if (// The token starts before the line ending…
                childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
                (!childFlow.events[index][1].end || // …or ends after it.
                childFlow.events[index][1].end.offset > lineStartOffset)) // Exit: there’s still something open, which means it’s a lazy line
                // part of something.
                return;
            }
            // Note: this algorithm for moving events around is similar to the
            // algorithm when closing flow in `documentContinue`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {boolean | undefined} */ let seen;
            /** @type {Point | undefined} */ let point;
            // Find the previous chunk (the one before the lazy line).
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                if (seen) {
                    point = self.events[indexBeforeFlow][1].end;
                    break;
                }
                seen = true;
            }
            exitContainers(continued);
            // Fix positions.
            index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = {
                    ...point
                };
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $fc7d276d876e7974$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
        }
    }
    /**
   * @param {number} size
   *   Size.
   * @returns {undefined}
   *   Nothing.
   */ function exitContainers(size) {
        let index = stack.length;
        // Exit open containers.
        while(index-- > size){
            const entry = stack[index];
            self.containerState = entry[1];
            entry[0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function closeFlow() {
        childFlow.write([
            null
        ]);
        childToken = undefined;
        childFlow = undefined;
        self.containerState._closeFlow = undefined;
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 *   Tokenizer.
 */ function $e94c0f7dee28bcba$var$tokenizeContainer(effects, ok, nok) {
    // Always populated by defaults.
    return (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4);
}


/**
 * @import {
 *   InitialConstruct,
 *   Initializer,
 *   State,
 *   TokenizeContext
 * } from 'micromark-util-types'
 */ /**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $8d5404e5d94cba13$export$d50d28ce3ab2a612 = {
    partial: true,
    tokenize: $8d5404e5d94cba13$var$tokenizeBlankLine
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $8d5404e5d94cba13$var$tokenizeBlankLine(effects, ok, nok) {
    return start;
    /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        return (0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code) ? (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, after, "linePrefix")(code) : after(code);
    }
    /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return code === null || (0, $db5865ecc27181ba$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 

/**
 * @import {Chunk, Event, Token} from 'micromark-util-types'
 */ 
/**
 * Some of the internal operations of micromark do lots of editing
 * operations on very large arrays. This runs into problems with two
 * properties of most circa-2020 JavaScript interpreters:
 *
 *  - Array-length modifications at the high end of an array (push/pop) are
 *    expected to be common and are implemented in (amortized) time
 *    proportional to the number of elements added or removed, whereas
 *    other operations (shift/unshift and splice) are much less efficient.
 *  - Function arguments are passed on the stack, so adding tens of thousands
 *    of elements to an array with `arr.push(...newElements)` will frequently
 *    cause stack overflows. (see <https://stackoverflow.com/questions/22123769/rangeerror-maximum-call-stack-size-exceeded-why>)
 *
 * SpliceBuffers are an implementation of gap buffers, which are a
 * generalization of the "queue made of two stacks" idea. The splice buffer
 * maintains a cursor, and moving the cursor has cost proportional to the
 * distance the cursor moves, but inserting, deleting, or splicing in
 * new information at the cursor is as efficient as the push/pop operation.
 * This allows for an efficient sequence of splices (or pushes, pops, shifts,
 * or unshifts) as long such edits happen at the same part of the array or
 * generally sweep through the array from the beginning to the end.
 *
 * The interface for splice buffers also supports large numbers of inputs by
 * passing a single array argument rather passing multiple arguments on the
 * function call stack.
 *
 * @template T
 *   Item type.
 */ class $1e717fcb19ca97f6$export$bd596157370df26e {
    /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */ constructor(initial){
        /** @type {Array<T>} */ this.left = initial ? [
            ...initial
        ] : [];
        /** @type {Array<T>} */ this.right = [];
    }
    /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */ get(index) {
        if (index < 0 || index >= this.left.length + this.right.length) throw new RangeError('Cannot access index `' + index + '` in a splice buffer of size `' + (this.left.length + this.right.length) + '`');
        if (index < this.left.length) return this.left[index];
        return this.right[this.right.length - index + this.left.length - 1];
    }
    /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */ get length() {
        return this.left.length + this.right.length;
    }
    /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */ shift() {
        this.setCursor(0);
        return this.right.pop();
    }
    /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */ slice(start, end) {
        /** @type {number} */ const stop = end === null || end === undefined ? Number.POSITIVE_INFINITY : end;
        if (stop < this.left.length) return this.left.slice(start, stop);
        if (start > this.left.length) return this.right.slice(this.right.length - stop + this.left.length, this.right.length - start + this.left.length).reverse();
        return this.left.slice(start).concat(this.right.slice(this.right.length - stop + this.left.length).reverse());
    }
    /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */ splice(start, deleteCount, items) {
        /** @type {number} */ const count = deleteCount || 0;
        this.setCursor(Math.trunc(start));
        const removed = this.right.splice(this.right.length - count, Number.POSITIVE_INFINITY);
        if (items) $1e717fcb19ca97f6$var$chunkedPush(this.left, items);
        return removed.reverse();
    }
    /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */ pop() {
        this.setCursor(Number.POSITIVE_INFINITY);
        return this.left.pop();
    }
    /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */ push(item) {
        this.setCursor(Number.POSITIVE_INFINITY);
        this.left.push(item);
    }
    /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */ pushMany(items) {
        this.setCursor(Number.POSITIVE_INFINITY);
        $1e717fcb19ca97f6$var$chunkedPush(this.left, items);
    }
    /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */ unshift(item) {
        this.setCursor(0);
        this.right.push(item);
    }
    /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */ unshiftMany(items) {
        this.setCursor(0);
        $1e717fcb19ca97f6$var$chunkedPush(this.right, items.reverse());
    }
    /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */ setCursor(n) {
        if (n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0) return;
        if (n < this.left.length) {
            // Move cursor to the this.left
            const removed = this.left.splice(n, Number.POSITIVE_INFINITY);
            $1e717fcb19ca97f6$var$chunkedPush(this.right, removed.reverse());
        } else {
            // Move cursor to the this.right
            const removed = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
            $1e717fcb19ca97f6$var$chunkedPush(this.left, removed.reverse());
        }
    }
}
/**
 * Avoid stack overflow by pushing items onto the stack in segments
 *
 * @template T
 *   Item type.
 * @param {Array<T>} list
 *   List to inject into.
 * @param {ReadonlyArray<T>} right
 *   Items to inject.
 * @return {undefined}
 *   Nothing.
 */ function $1e717fcb19ca97f6$var$chunkedPush(list, right) {
    /** @type {number} */ let chunkStart = 0;
    if (right.length < 10000) list.push(...right);
    else while(chunkStart < right.length){
        list.push(...right.slice(chunkStart, chunkStart + 10000));
        chunkStart += 10000;
    }
}


function $43c689452f48fe6d$export$12949d1dd00fddf4(eventsArray) {
    /** @type {Record<string, number>} */ const jumps = {};
    let index = -1;
    /** @type {Event} */ let event;
    /** @type {number | undefined} */ let lineIndex;
    /** @type {number} */ let otherIndex;
    /** @type {Event} */ let otherEvent;
    /** @type {Array<Event>} */ let parameters;
    /** @type {Array<Event>} */ let subevents;
    /** @type {boolean | undefined} */ let more;
    const events = new (0, $1e717fcb19ca97f6$export$bd596157370df26e)(eventsArray);
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events.get(index);
        // Add a hook for the GFM tasklist extension, which needs to know if text
        // is in the first content of a list item.
        if (index && event[1].type === "chunkFlow" && events.get(index - 1)[1].type === "listItemPrefix") {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === "content") break;
                if (subevents[otherIndex][1].type === "chunkText") {
                    subevents[otherIndex][1]._isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        }
        // Enter.
        if (event[0] === 'enter') {
            if (event[1].contentType) {
                Object.assign(jumps, $43c689452f48fe6d$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events.get(otherIndex);
                if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
                    if (otherEvent[0] === 'enter') {
                        if (lineIndex) events.get(lineIndex)[1].type = "lineEndingBlank";
                        otherEvent[1].type = "lineEnding";
                        lineIndex = otherIndex;
                    }
                } else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = {
                    ...events.get(lineIndex)[1].start
                };
                // Switch container exit w/ line endings.
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                events.splice(lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    // The changes to the `events` buffer must be copied back into the eventsArray
    (0, $fc7d276d876e7974$export$869882364835d202)(eventsArray, 0, Number.POSITIVE_INFINITY, events.slice(0));
    return !more;
}
/**
 * Tokenize embedded tokens.
 *
 * @param {SpliceBuffer<Event>} events
 *   Events.
 * @param {number} eventIndex
 *   Index.
 * @returns {Record<string, number>}
 *   Gaps.
 */ function $43c689452f48fe6d$var$subcontent(events, eventIndex) {
    const token = events.get(eventIndex)[1];
    const context = events.get(eventIndex)[2];
    let startPosition = eventIndex - 1;
    /** @type {Array<number>} */ const startPositions = [];
    const tokenizer = token._tokenizer || context.parser[token.contentType](token.start);
    const childEvents = tokenizer.events;
    /** @type {Array<[number, number]>} */ const jumps = [];
    /** @type {Record<string, number>} */ const gaps = {};
    /** @type {Array<Chunk>} */ let stream;
    /** @type {Token | undefined} */ let previous;
    let index = -1;
    /** @type {Token | undefined} */ let current = token;
    let adjust = 0;
    let start = 0;
    const breaks = [
        start
    ];
    // Loop forward through the linked tokens to pass them in order to the
    // subtokenizer.
    while(current){
        // Find the position of the event for this token.
        while(events.get(++startPosition)[1] !== current);
        startPositions.push(startPosition);
        if (!current._tokenizer) {
            stream = context.sliceStream(current);
            if (!current.next) stream.push(null);
            if (previous) tokenizer.defineSkip(current.start);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        }
        // Unravel the next token.
        previous = current;
        current = current.next;
    }
    // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    current = token;
    while(++index < childEvents.length)if (// Find a void token that includes a break.
    childEvents[index][0] === 'exit' && childEvents[index - 1][0] === 'enter' && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
        start = index + 1;
        breaks.push(start);
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
        current = current.next;
    }
    // Help GC.
    tokenizer.events = [];
    // If there’s one more token (which is the cases for lines that end in an
    // EOF), that’s perfect: the last point we found starts it.
    // If there isn’t then make sure any remaining content is added to it.
    if (current) {
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
    } else breaks.pop();
    // Now splice the events from the subtokenizer into the current events,
    // moving back to front so that splice indices aren’t affected.
    index = breaks.length;
    while(index--){
        const slice = childEvents.slice(breaks[index], breaks[index + 1]);
        const start = startPositions.pop();
        jumps.push([
            start,
            start + slice.length - 1
        ]);
        events.splice(start, 2, slice);
    }
    jumps.reverse();
    index = -1;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
}


const $817899b3d68ecb2c$export$a7db06668cad9adb = {
    resolve: $817899b3d68ecb2c$var$resolveContent,
    tokenize: $817899b3d68ecb2c$var$tokenizeContent
};
/** @type {Construct} */ const $817899b3d68ecb2c$var$continuationConstruct = {
    partial: true,
    tokenize: $817899b3d68ecb2c$var$tokenizeContinuation
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */ function $817899b3d68ecb2c$var$resolveContent(events) {
    (0, $43c689452f48fe6d$export$12949d1dd00fddf4)(events);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $817899b3d68ecb2c$var$tokenizeContent(effects, ok) {
    /** @type {Token | undefined} */ let previous;
    return chunkStart;
    /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */ function chunkStart(code) {
        effects.enter("content");
        previous = effects.enter("chunkContent", {
            contentType: "content"
        });
        return chunkInside(code);
    }
    /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */ function chunkInside(code) {
        if (code === null) return contentEnd(code);
        // To do: in `markdown-rs`, each line is parsed on its own, and everything
        // is stitched together resolving.
        if ((0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) return effects.check($817899b3d68ecb2c$var$continuationConstruct, contentContinue, contentEnd)(code);
        // Data.
        effects.consume(code);
        return chunkInside;
    }
    /**
   *
   *
   * @type {State}
   */ function contentEnd(code) {
        effects.exit("chunkContent");
        effects.exit("content");
        return ok(code);
    }
    /**
   *
   *
   * @type {State}
   */ function contentContinue(code) {
        effects.consume(code);
        effects.exit("chunkContent");
        previous.next = effects.enter("chunkContent", {
            contentType: "content",
            previous: previous
        });
        previous = previous.next;
        return chunkInside;
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $817899b3d68ecb2c$var$tokenizeContinuation(effects, ok, nok) {
    const self = this;
    return startLookahead;
    /**
   *
   *
   * @type {State}
   */ function startLookahead(code) {
        effects.exit("chunkContent");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, prefixed, "linePrefix");
    }
    /**
   *
   *
   * @type {State}
   */ function prefixed(code) {
        if (code === null || (0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) return nok(code);
        // Always populated by defaults.
        const tail = self.events[self.events.length - 1];
        if (!self.parser.constructs.disable.null.includes('codeIndented') && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code);
        return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
}




const $85cb6584b341524f$export$ccc7b0636abaffc3 = {
    tokenize: $85cb6584b341524f$var$initializeFlow
};
/**
 * @this {TokenizeContext}
 *   Self.
 * @type {Initializer}
 *   Initializer.
 */ function $85cb6584b341524f$var$initializeFlow(effects) {
    const self = this;
    const initial = effects.attempt(// Try to parse a blank line.
    (0, $8d5404e5d94cba13$export$d50d28ce3ab2a612), atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt((0, $817899b3d68ecb2c$export$a7db06668cad9adb), afterConstruct)), "linePrefix")));
    return initial;
    /** @type {State} */ function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        self.currentConstruct = undefined;
        return initial;
    }
    /** @type {State} */ function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        self.currentConstruct = undefined;
        return initial;
    }
}


/**
 * @import {
 *   Code,
 *   InitialConstruct,
 *   Initializer,
 *   Resolver,
 *   State,
 *   TokenizeContext
 * } from 'micromark-util-types'
 */ const $12a67d71128b0767$export$50397835cbfdbc24 = {
    resolveAll: $12a67d71128b0767$var$createResolver()
};
const $12a67d71128b0767$export$22b082955e083ec3 = $12a67d71128b0767$var$initializeFactory('string');
const $12a67d71128b0767$export$6f093cfa640b7166 = $12a67d71128b0767$var$initializeFactory('text');
/**
 * @param {'string' | 'text'} field
 *   Field.
 * @returns {InitialConstruct}
 *   Construct.
 */ function $12a67d71128b0767$var$initializeFactory(field) {
    return {
        resolveAll: $12a67d71128b0767$var$createResolver(field === 'text' ? $12a67d71128b0767$var$resolveAllLineSuffixes : undefined),
        tokenize: initializeText
    };
    /**
   * @this {TokenizeContext}
   *   Context.
   * @type {Initializer}
   */ function initializeText(effects) {
        const self = this;
        const constructs = this.parser.constructs[field];
        const text = effects.attempt(constructs, start, notText);
        return start;
        /** @type {State} */ function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        /** @type {State} */ function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter("data");
            effects.consume(code);
            return data;
        }
        /** @type {State} */ function data(code) {
            if (atBreak(code)) {
                effects.exit("data");
                return text(code);
            }
            // Data.
            effects.consume(code);
            return data;
        }
        /**
     * @param {Code} code
     *   Code.
     * @returns {boolean}
     *   Whether the code is a break.
     */ function atBreak(code) {
            if (code === null) return true;
            const list = constructs[code];
            let index = -1;
            if (list) // Always populated by defaults.
            while(++index < list.length){
                const item = list[index];
                if (!item.previous || item.previous.call(self, self.previous)) return true;
            }
            return false;
        }
    }
}
/**
 * @param {Resolver | undefined} [extraResolver]
 *   Resolver.
 * @returns {Resolver}
 *   Resolver.
 */ function $12a67d71128b0767$var$createResolver(extraResolver) {
    return resolveAllText;
    /** @type {Resolver} */ function resolveAllText(events, context) {
        let index = -1;
        /** @type {number | undefined} */ let enter;
        // A rather boring computation (to merge adjacent `data` events) which
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === "data") {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== "data") {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */ function $12a67d71128b0767$var$resolveAllLineSuffixes(events, context) {
    let eventIndex = 0; // Skip first.
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
        const data = events[eventIndex - 1][1];
        const chunks = context.sliceStream(data);
        let index = chunks.length;
        let bufferIndex = -1;
        let size = 0;
        /** @type {boolean | undefined} */ let tabs;
        while(index--){
            const chunk = chunks[index];
            if (typeof chunk === 'string') {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        if (size) {
            const token = {
                type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
                start: {
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex,
                    _index: data.start._index + index,
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size
                },
                end: {
                    ...data.end
                }
            };
            data.end = {
                ...token.start
            };
            if (data.start.offset === data.end.offset) Object.assign(data, token);
            else {
                events.splice(eventIndex, 0, [
                    'enter',
                    token,
                    context
                ], [
                    'exit',
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}


var $e188912510daf42a$exports = {};

$parcel$export($e188912510daf42a$exports, "document", () => $e188912510daf42a$export$5a7bfc01df82fcd1);
$parcel$export($e188912510daf42a$exports, "contentInitial", () => $e188912510daf42a$export$5a2181fb44b58173);
$parcel$export($e188912510daf42a$exports, "flowInitial", () => $e188912510daf42a$export$cf8bead395eff824);
$parcel$export($e188912510daf42a$exports, "flow", () => $e188912510daf42a$export$ccc7b0636abaffc3);
$parcel$export($e188912510daf42a$exports, "string", () => $e188912510daf42a$export$22b082955e083ec3);
$parcel$export($e188912510daf42a$exports, "text", () => $e188912510daf42a$export$6f093cfa640b7166);
$parcel$export($e188912510daf42a$exports, "insideSpan", () => $e188912510daf42a$export$d44f260a3f9b69f5);
$parcel$export($e188912510daf42a$exports, "attentionMarkers", () => $e188912510daf42a$export$b9c0b60d74426aea);
$parcel$export($e188912510daf42a$exports, "disable", () => $e188912510daf42a$export$e20fbacbb41798b);
/**
 * @import {Extension} from 'micromark-util-types'
 */ /**
 * @import {
 *   Code,
 *   Construct,
 *   Event,
 *   Point,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 
/**
 * @import {Code} from 'micromark-util-types'
 */ 
function $0cf80314fdbe73de$export$e3902bc0d835cad0(code) {
    if (code === null || (0, $db5865ecc27181ba$export$a30284361b3814b7)(code) || (0, $db5865ecc27181ba$export$a0ff789c034ffdf4)(code)) return 1;
    if ((0, $db5865ecc27181ba$export$aa04114dd888a7a0)(code)) return 2;
}


/**
 * @import {Event, Resolver, TokenizeContext} from 'micromark-util-types'
 */ /**
 * Call all `resolveAll`s.
 *
 * @param {ReadonlyArray<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */ function $572427b391443f2d$export$3ff61ec196ff408b(constructs, events, context) {
    /** @type {Array<Resolver>} */ const called = [];
    let index = -1;
    while(++index < constructs.length){
        const resolve = constructs[index].resolveAll;
        if (resolve && !called.includes(resolve)) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}


const $f61564e9371adf09$export$45b92471da762af7 = {
    name: 'attention',
    resolveAll: $f61564e9371adf09$var$resolveAllAttention,
    tokenize: $f61564e9371adf09$var$tokenizeAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */ // eslint-disable-next-line complexity
function $f61564e9371adf09$var$resolveAllAttention(events, context) {
    let index = -1;
    /** @type {number} */ let open;
    /** @type {Token} */ let group;
    /** @type {Token} */ let text;
    /** @type {Token} */ let openingSequence;
    /** @type {Token} */ let closingSequence;
    /** @type {number} */ let use;
    /** @type {Array<Event>} */ let nextEvents;
    /** @type {number} */ let offset;
    // Walk through all events.
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === 'enter' && events[index][1].type === 'attentionSequence' && events[index][1]._close) {
        open = index;
        // Now walk back to find an opener.
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === 'exit' && events[open][1].type === 'attentionSequence' && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
            // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            const start = {
                ...events[open][1].end
            };
            const end = {
                ...events[index][1].start
            };
            $f61564e9371adf09$var$movePoint(start, -use);
            $f61564e9371adf09$var$movePoint(end, use);
            openingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: start,
                end: {
                    ...events[open][1].end
                }
            };
            closingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: {
                    ...events[index][1].start
                },
                end: end
            };
            text = {
                type: use > 1 ? "strongText" : "emphasisText",
                start: {
                    ...events[open][1].end
                },
                end: {
                    ...events[index][1].start
                }
            };
            group = {
                type: use > 1 ? "strong" : "emphasis",
                start: {
                    ...openingSequence.start
                },
                end: {
                    ...closingSequence.end
                }
            };
            events[open][1].end = {
                ...openingSequence.start
            };
            events[index][1].start = {
                ...closingSequence.end
            };
            nextEvents = [];
            // If there are more markers in the opening, add them before.
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = (0, $fc7d276d876e7974$export$4cbf152802aa238)(nextEvents, [
                [
                    'enter',
                    events[open][1],
                    context
                ],
                [
                    'exit',
                    events[open][1],
                    context
                ]
            ]);
            // Opening.
            nextEvents = (0, $fc7d276d876e7974$export$4cbf152802aa238)(nextEvents, [
                [
                    'enter',
                    group,
                    context
                ],
                [
                    'enter',
                    openingSequence,
                    context
                ],
                [
                    'exit',
                    openingSequence,
                    context
                ],
                [
                    'enter',
                    text,
                    context
                ]
            ]);
            // Always populated by defaults.
            // Between.
            nextEvents = (0, $fc7d276d876e7974$export$4cbf152802aa238)(nextEvents, (0, $572427b391443f2d$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
            // Closing.
            nextEvents = (0, $fc7d276d876e7974$export$4cbf152802aa238)(nextEvents, [
                [
                    'exit',
                    text,
                    context
                ],
                [
                    'enter',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    group,
                    context
                ]
            ]);
            // If there are more markers in the closing, add them after.
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = (0, $fc7d276d876e7974$export$4cbf152802aa238)(nextEvents, [
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            (0, $fc7d276d876e7974$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
    // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === 'attentionSequence') events[index][1].type = 'data';
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $f61564e9371adf09$var$tokenizeAttention(effects, ok) {
    const attentionMarkers = this.parser.constructs.attentionMarkers.null;
    const previous = this.previous;
    const before = (0, $0cf80314fdbe73de$export$e3902bc0d835cad0)(previous);
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        marker = code;
        effects.enter('attentionSequence');
        return inside(code);
    }
    /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        const token = effects.exit('attentionSequence');
        // To do: next major: move this to resolver, just like `markdown-rs`.
        const after = (0, $0cf80314fdbe73de$export$e3902bc0d835cad0)(code);
        // Always populated by defaults.
        const open = !after || after === 2 && before || attentionMarkers.includes(code);
        const close = !before || before === 2 && after || attentionMarkers.includes(previous);
        token._open = Boolean(marker === 42 ? open : open && (before || !close));
        token._close = Boolean(marker === 42 ? close : close && (after || !open));
        return ok(code);
    }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 *   Point.
 * @param {number} offset
 *   Amount to move.
 * @returns {undefined}
 *   Nothing.
 */ function $f61564e9371adf09$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $b5cba1161c57096d$export$17ddf85e4c916ad6 = {
    name: 'autolink',
    tokenize: $b5cba1161c57096d$var$tokenizeAutolink
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $b5cba1161c57096d$var$tokenizeAutolink(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("autolink");
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.enter("autolinkProtocol");
        return open;
    }
    /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if ((0, $db5865ecc27181ba$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        if (code === 64) return nok(code);
        return emailAtext(code);
    }
    /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeOrEmailAtext(code) {
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if (code === 43 || code === 45 || code === 46 || (0, $db5865ecc27181ba$export$75c76db11865a9f4)(code)) {
            // Count the previous alphabetical from `open` too.
            size = 1;
            return schemeInsideOrEmailAtext(code);
        }
        return emailAtext(code);
    }
    /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            size = 0;
            return urlInside;
        }
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if ((code === 43 || code === 45 || code === 46 || (0, $db5865ecc27181ba$export$75c76db11865a9f4)(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        size = 0;
        return emailAtext(code);
    }
    /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */ function urlInside(code) {
        if (code === 62) {
            effects.exit("autolinkProtocol");
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        // ASCII control, space, or `<`.
        if (code === null || code === 32 || code === 60 || (0, $db5865ecc27181ba$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */ function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            return emailAtSignOrDot;
        }
        if ((0, $db5865ecc27181ba$export$4397998b34fe597d)(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */ function emailAtSignOrDot(code) {
        return (0, $db5865ecc27181ba$export$75c76db11865a9f4)(code) ? emailLabel(code) : nok(code);
    }
    /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */ function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the token type.
            effects.exit("autolinkProtocol").type = "autolinkEmail";
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        return emailValue(code);
    }
    /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */ function emailValue(code) {
        // ASCII alphanumeric or `-`.
        if ((code === 45 || (0, $db5865ecc27181ba$export$75c76db11865a9f4)(code)) && size++ < 63) {
            const next = code === 45 ? emailValue : emailLabel;
            effects.consume(code);
            return next;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Exiter,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $195bd471f624b1ee$export$200dcd0a5903c968 = {
    continuation: {
        tokenize: $195bd471f624b1ee$var$tokenizeBlockQuoteContinuation
    },
    exit: $195bd471f624b1ee$var$exit,
    name: 'blockQuote',
    tokenize: $195bd471f624b1ee$var$tokenizeBlockQuoteStart
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $195bd471f624b1ee$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 62) {
            const state = self.containerState;
            if (!state.open) {
                effects.enter("blockQuote", {
                    _container: true
                });
                state.open = true;
            }
            effects.enter("blockQuotePrefix");
            effects.enter("blockQuoteMarker");
            effects.consume(code);
            effects.exit("blockQuoteMarker");
            return after;
        }
        return nok(code);
    }
    /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if ((0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code)) {
            effects.enter("blockQuotePrefixWhitespace");
            effects.consume(code);
            effects.exit("blockQuotePrefixWhitespace");
            effects.exit("blockQuotePrefix");
            return ok;
        }
        effects.exit("blockQuotePrefix");
        return ok(code);
    }
}
/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $195bd471f624b1ee$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    const self = this;
    return contStart;
    /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contStart(code) {
        if ((0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code)) // Always populated by defaults.
        return (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, contBefore, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
        return contBefore(code);
    }
    /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contBefore(code) {
        return effects.attempt($195bd471f624b1ee$export$200dcd0a5903c968, ok, nok)(code);
    }
}
/** @type {Exiter} */ function $195bd471f624b1ee$var$exit(effects) {
    effects.exit("blockQuote");
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $15debd2cf16093b4$export$2005478564e78d96 = {
    name: 'characterEscape',
    tokenize: $15debd2cf16093b4$var$tokenizeCharacterEscape
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $15debd2cf16093b4$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        effects.exit("escapeMarker");
        return inside;
    }
    /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // ASCII punctuation.
        if ((0, $db5865ecc27181ba$export$35794a7d1db99380)(code)) {
            effects.enter("characterEscapeValue");
            effects.consume(code);
            effects.exit("characterEscapeValue");
            effects.exit("characterEscape");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $7009325e01a371ab$export$e31905600aaf3d8e = {
    name: 'characterReference',
    tokenize: $7009325e01a371ab$var$tokenizeCharacterReference
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $7009325e01a371ab$var$tokenizeCharacterReference(effects, ok, nok) {
    const self = this;
    let size = 0;
    /** @type {number} */ let max;
    /** @type {(code: Code) => boolean} */ let test;
    return start;
    /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterReference");
        effects.enter("characterReferenceMarker");
        effects.consume(code);
        effects.exit("characterReferenceMarker");
        return open;
    }
    /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 35) {
            effects.enter("characterReferenceMarkerNumeric");
            effects.consume(code);
            effects.exit("characterReferenceMarkerNumeric");
            return numeric;
        }
        effects.enter("characterReferenceValue");
        max = 31;
        test = (0, $db5865ecc27181ba$export$75c76db11865a9f4);
        return value(code);
    }
    /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */ function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter("characterReferenceMarkerHexadecimal");
            effects.consume(code);
            effects.exit("characterReferenceMarkerHexadecimal");
            effects.enter("characterReferenceValue");
            max = 6;
            test = (0, $db5865ecc27181ba$export$eca2752363989806);
            return value;
        }
        effects.enter("characterReferenceValue");
        max = 7;
        test = (0, $db5865ecc27181ba$export$ca8b5b1a6c320e6e);
        return value(code);
    }
    /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */ function value(code) {
        if (code === 59 && size) {
            const token = effects.exit("characterReferenceValue");
            if (test === (0, $db5865ecc27181ba$export$75c76db11865a9f4) && !(0, $a7eaf83d99f11094$export$289b6a6320f709b4)(self.sliceSerialize(token))) return nok(code);
            // To do: `markdown-rs` uses a different name:
            // `CharacterReferenceMarkerSemi`.
            effects.enter("characterReferenceMarker");
            effects.consume(code);
            effects.exit("characterReferenceMarker");
            effects.exit("characterReference");
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

/** @type {Construct} */ const $0dca07a85c64a229$var$nonLazyContinuation = {
    partial: true,
    tokenize: $0dca07a85c64a229$var$tokenizeNonLazyContinuation
};
const $0dca07a85c64a229$export$c23e4921f8d87e7c = {
    concrete: true,
    name: 'codeFenced',
    tokenize: $0dca07a85c64a229$var$tokenizeCodeFenced
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $0dca07a85c64a229$var$tokenizeCodeFenced(effects, ok, nok) {
    const self = this;
    /** @type {Construct} */ const closeStart = {
        partial: true,
        tokenize: tokenizeCloseStart
    };
    let initialPrefix = 0;
    let sizeOpen = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse whitespace like `markdown-rs`.
        return beforeSequenceOpen(code);
    }
    /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeSequenceOpen(code) {
        const tail = self.events[self.events.length - 1];
        initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
        marker = code;
        effects.enter("codeFenced");
        effects.enter("codeFencedFence");
        effects.enter("codeFencedFenceSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === marker) {
            sizeOpen++;
            effects.consume(code);
            return sequenceOpen;
        }
        if (sizeOpen < 3) return nok(code);
        effects.exit("codeFencedFenceSequence");
        return (0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code) ? (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, infoBefore, "whitespace")(code) : infoBefore(code);
    }
    /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function infoBefore(code) {
        if (code === null || (0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFencedFence");
            return self.interrupt ? ok(code) : effects.check($0dca07a85c64a229$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        }
        effects.enter("codeFencedFenceInfo");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return info(code);
    }
    /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function info(code) {
        if (code === null || (0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return infoBefore(code);
        }
        if ((0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, metaBefore, "whitespace")(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function metaBefore(code) {
        if (code === null || (0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) return infoBefore(code);
        effects.enter("codeFencedFenceMeta");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return meta(code);
    }
    /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function meta(code) {
        if (code === null || (0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceMeta");
            return infoBefore(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function atNonLazyBreak(code) {
        return effects.attempt(closeStart, after, contentBefore)(code);
    }
    /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentBefore(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return contentStart;
    }
    /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentStart(code) {
        return initialPrefix > 0 && (0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code) ? (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code) : beforeContentChunk(code);
    }
    /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeContentChunk(code) {
        if (code === null || (0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) return effects.check($0dca07a85c64a229$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        effects.enter("codeFlowValue");
        return contentChunk(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentChunk(code) {
        if (code === null || (0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return beforeContentChunk(code);
        }
        effects.consume(code);
        return contentChunk;
    }
    /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        effects.exit("codeFenced");
        return ok(code);
    }
    /**
   * @this {TokenizeContext}
   *   Context.
   * @type {Tokenizer}
   */ function tokenizeCloseStart(effects, ok, nok) {
        let size = 0;
        return startBefore;
        /**
     *
     *
     * @type {State}
     */ function startBefore(code) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return start;
        }
        /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function start(code) {
            // Always populated by defaults.
            // To do: `enter` here or in next state?
            effects.enter("codeFencedFence");
            return (0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code) ? (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, beforeSequenceClose, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : beforeSequenceClose(code);
        }
        /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function beforeSequenceClose(code) {
            if (code === marker) {
                effects.enter("codeFencedFenceSequence");
                return sequenceClose(code);
            }
            return nok(code);
        }
        /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function sequenceClose(code) {
            if (code === marker) {
                size++;
                effects.consume(code);
                return sequenceClose;
            }
            if (size >= sizeOpen) {
                effects.exit("codeFencedFenceSequence");
                return (0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code) ? (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, sequenceCloseAfter, "whitespace")(code) : sequenceCloseAfter(code);
            }
            return nok(code);
        }
        /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */ function sequenceCloseAfter(code) {
            if (code === null || (0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
                effects.exit("codeFencedFence");
                return ok(code);
            }
            return nok(code);
        }
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $0dca07a85c64a229$var$tokenizeNonLazyContinuation(effects, ok, nok) {
    const self = this;
    return start;
    /**
   *
   *
   * @type {State}
   */ function start(code) {
        if (code === null) return nok(code);
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineStart;
    }
    /**
   *
   *
   * @type {State}
   */ function lineStart(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $85aef0d291790f13$export$47910b7ab28d1853 = {
    name: 'codeIndented',
    tokenize: $85aef0d291790f13$var$tokenizeCodeIndented
};
/** @type {Construct} */ const $85aef0d291790f13$var$furtherStart = {
    partial: true,
    tokenize: $85aef0d291790f13$var$tokenizeFurtherStart
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $85aef0d291790f13$var$tokenizeCodeIndented(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: manually check if interrupting like `markdown-rs`.
        effects.enter("codeIndented");
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
    }
    /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === null) return after(code);
        if ((0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) return effects.attempt($85aef0d291790f13$var$furtherStart, atBreak, after)(code);
        effects.enter("codeFlowValue");
        return inside(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === null || (0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return atBreak(code);
        }
        effects.consume(code);
        return inside;
    }
    /** @type {State} */ function after(code) {
        effects.exit("codeIndented");
        // To do: allow interrupting like `markdown-rs`.
        // Feel free to interrupt.
        // tokenizer.interrupt = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $85aef0d291790f13$var$tokenizeFurtherStart(effects, ok, nok) {
    const self = this;
    return furtherStart;
    /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */ function furtherStart(code) {
        // To do: improve `lazy` / `pierce` handling.
        // If this is a lazy line, it can’t be code.
        if (self.parser.lazy[self.now().line]) return nok(code);
        if ((0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return furtherStart;
        }
        // To do: the code here in `micromark-js` is a bit different from
        // `markdown-rs` because there it can attempt spaces.
        // We can’t yet.
        //
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : (0, $db5865ecc27181ba$export$34a1dff1c0936953)(code) ? furtherStart(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Previous,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 
const $7b1512082b57af90$export$d24f93e715f9df88 = {
    name: 'codeText',
    previous: $7b1512082b57af90$var$previous,
    resolve: $7b1512082b57af90$var$resolveCodeText,
    tokenize: $7b1512082b57af90$var$tokenizeCodeText
};
// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */ function $7b1512082b57af90$var$resolveCodeText(events) {
    let tailExitIndex = events.length - 4;
    let headEnterIndex = 3;
    /** @type {number} */ let index;
    /** @type {number | undefined} */ let enter;
    // If we start and end with an EOL or a space.
    if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === 'space') && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === 'space')) {
        index = headEnterIndex;
        // And we have data.
        while(++index < tailExitIndex)if (events[index][1].type === "codeTextData") {
            // Then we have padding.
            events[headEnterIndex][1].type = "codeTextPadding";
            events[tailExitIndex][1].type = "codeTextPadding";
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    }
    // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
        } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
            events[enter][1].type = "codeTextData";
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Previous}
 */ function $7b1512082b57af90$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $7b1512082b57af90$var$tokenizeCodeText(effects, ok, nok) {
    const self = this;
    let sizeOpen = 0;
    /** @type {number} */ let size;
    /** @type {Token} */ let token;
    return start;
    /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("codeText");
        effects.enter("codeTextSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit("codeTextSequence");
        return between(code);
    }
    /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */ function between(code) {
        // EOF.
        if (code === null) return nok(code);
        // To do: next major: don’t do spaces in resolve, but when compiling,
        // like `markdown-rs`.
        // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter('space');
            effects.consume(code);
            effects.exit('space');
            return between;
        }
        // Closing fence? Could also be data.
        if (code === 96) {
            token = effects.enter("codeTextSequence");
            size = 0;
            return sequenceClose(code);
        }
        if ((0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return between;
        }
        // Data.
        effects.enter("codeTextData");
        return data(code);
    }
    /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 32 || code === 96 || (0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            effects.exit("codeTextData");
            return between(code);
        }
        effects.consume(code);
        return data;
    }
    /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */ function sequenceClose(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return sequenceClose;
        }
        // Done!
        if (size === sizeOpen) {
            effects.exit("codeTextSequence");
            effects.exit("codeText");
            return ok(code);
        }
        // More or less accents: mark as data.
        token.type = "codeTextData";
        return data(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ /**
 * @import {Effects, State, TokenType} from 'micromark-util-types'
 */ 
function $e6a686b884a80e11$export$2e6c8deaa96af245(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    const limit = max || Number.POSITIVE_INFINITY;
    let balance = 0;
    return start;
    /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return enclosedBefore;
        }
        // ASCII control, space, closing paren.
        if (code === null || code === 32 || code === 41 || (0, $db5865ecc27181ba$export$67dbf494fc8394df)(code)) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return raw(code);
    }
    /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return enclosed(code);
    }
    /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosed(code) {
        if (code === 62) {
            effects.exit("chunkString");
            effects.exit(stringType);
            return enclosedBefore(code);
        }
        if (code === null || code === 60 || (0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? enclosedEscape : enclosed;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */ function enclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return enclosed;
        }
        return enclosed(code);
    }
    /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function raw(code) {
        if (!balance && (code === null || code === 41 || (0, $db5865ecc27181ba$export$a30284361b3814b7)(code))) {
            effects.exit("chunkString");
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if (balance < limit && code === 40) {
            effects.consume(code);
            balance++;
            return raw;
        }
        if (code === 41) {
            effects.consume(code);
            balance--;
            return raw;
        }
        // ASCII control (but *not* `\0`) and space and `(`.
        // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
        // doesn’t.
        if (code === null || code === 32 || code === 40 || (0, $db5865ecc27181ba$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? rawEscape : raw;
    }
    /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */ function rawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return raw;
        }
        return raw(code);
    }
}


/**
 * @import {
 *   Effects,
 *   State,
 *   TokenizeContext,
 *   TokenType
 * } from 'micromark-util-types'
 */ 
function $f906593f37ac63e2$export$7b768614d8ba97a7(effects, ok, nok, type, markerType, stringType) {
    const self = this;
    let size = 0;
    /** @type {boolean} */ let seen;
    return start;
    /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (size > 999 || code === null || code === 91 || code === 93 && !seen || // To do: remove in the future once we’ve switched from
        // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
        // which doesn’t need this.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ code === 94 && !size && '_hiddenFootnoteSupport' in self.parser.constructs) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        // To do: indent? Link chunks and EOLs together?
        if ((0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return atBreak;
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return labelInside(code);
    }
    /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (code === null || code === 91 || code === 93 || (0, $db5865ecc27181ba$export$34a1dff1c0936953)(code) || size++ > 999) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        if (!seen) seen = !(0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
}



/**
 * @import {
 *   Code,
 *   Effects,
 *   State,
 *   TokenType
 * } from 'micromark-util-types'
 */ 

function $403f0b123a51092c$export$f970569cc855e483(effects, ok, nok, type, markerType, stringType) {
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 34 || code === 39 || code === 40) {
            effects.enter(type);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            marker = code === 40 ? 41 : code;
            return begin;
        }
        return nok(code);
    }
    /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function begin(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atBreak(code);
    }
    /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return begin(marker);
        }
        if (code === null) return nok(code);
        // Note: blank lines can’t exist in content.
        if ((0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            // To do: use `space_or_tab_eol_with_options`, connect.
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, atBreak, "linePrefix");
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return inside(code);
    }
    /**
   *
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker || code === null || (0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        return code === 92 ? escape : inside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */ function escape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return inside;
        }
        return inside(code);
    }
}


/**
 * @import {Effects, State} from 'micromark-util-types'
 */ 

function $1f2386765c63a154$export$1f27bd1aa33ce173(effects, ok) {
    /** @type {boolean} */ let seen;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            seen = true;
            return start;
        }
        if ((0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code)) return (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, start, seen ? "linePrefix" : "lineSuffix")(code);
        return ok(code);
    }
}




const $71984b733f5045d6$export$69f215ed977cdb73 = {
    name: 'definition',
    tokenize: $71984b733f5045d6$var$tokenizeDefinition
};
/** @type {Construct} */ const $71984b733f5045d6$var$titleBefore = {
    partial: true,
    tokenize: $71984b733f5045d6$var$tokenizeTitleBefore
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $71984b733f5045d6$var$tokenizeDefinition(effects, ok, nok) {
    const self = this;
    /** @type {string} */ let identifier;
    return start;
    /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Do not interrupt paragraphs (but do follow definitions).
        // To do: do `interrupt` the way `markdown-rs` does.
        // To do: parse whitespace the way `markdown-rs` does.
        effects.enter("definition");
        return before(code);
    }
    /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        // To do: parse whitespace the way `markdown-rs` does.
        return (0, $f906593f37ac63e2$export$7b768614d8ba97a7).call(self, effects, labelAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
    }
    /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        identifier = (0, $e8a88a5e1b7aeb38$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            return markerAfter;
        }
        return nok(code);
    }
    /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */ function markerAfter(code) {
        // Note: whitespace is optional.
        return (0, $db5865ecc27181ba$export$a30284361b3814b7)(code) ? (0, $1f2386765c63a154$export$1f27bd1aa33ce173)(effects, destinationBefore)(code) : destinationBefore(code);
    }
    /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */ function destinationBefore(code) {
        return (0, $e6a686b884a80e11$export$2e6c8deaa96af245)(effects, destinationAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(code);
    }
    /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function destinationAfter(code) {
        return effects.attempt($71984b733f5045d6$var$titleBefore, after, after)(code);
    }
    /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return (0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code) ? (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, afterWhitespace, "whitespace")(code) : afterWhitespace(code);
    }
    /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function afterWhitespace(code) {
        if (code === null || (0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            effects.exit("definition");
            // Note: we don’t care about uniqueness.
            // It’s likely that that doesn’t happen very frequently.
            // It is more likely that it wastes precious time.
            self.parser.defined.push(identifier);
            // To do: `markdown-rs` interrupt.
            // // You’d be interrupting.
            // tokenizer.interrupt = true
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $71984b733f5045d6$var$tokenizeTitleBefore(effects, ok, nok) {
    return titleBefore;
    /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function titleBefore(code) {
        return (0, $db5865ecc27181ba$export$a30284361b3814b7)(code) ? (0, $1f2386765c63a154$export$1f27bd1aa33ce173)(effects, beforeMarker)(code) : nok(code);
    }
    /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function beforeMarker(code) {
        return (0, $403f0b123a51092c$export$f970569cc855e483)(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
    }
    /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfter(code) {
        return (0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code) ? (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, titleAfterOptionalWhitespace, "whitespace")(code) : titleAfterOptionalWhitespace(code);
    }
    /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfterOptionalWhitespace(code) {
        return code === null || (0, $db5865ecc27181ba$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $2700b1defcbba05a$export$86c573ab9e06f418 = {
    name: 'hardBreakEscape',
    tokenize: $2700b1defcbba05a$var$tokenizeHardBreakEscape
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $2700b1defcbba05a$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("hardBreakEscape");
        effects.consume(code);
        return after;
    }
    /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */ function after(code) {
        if ((0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            effects.exit("hardBreakEscape");
            return ok(code);
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 


const $b4d2271e8f1abe18$export$3871e9deb360695c = {
    name: 'headingAtx',
    resolve: $b4d2271e8f1abe18$var$resolveHeadingAtx,
    tokenize: $b4d2271e8f1abe18$var$tokenizeHeadingAtx
};
/** @type {Resolver} */ function $b4d2271e8f1abe18$var$resolveHeadingAtx(events, context) {
    let contentEnd = events.length - 2;
    let contentStart = 3;
    /** @type {Token} */ let content;
    /** @type {Token} */ let text;
    // Prefix whitespace, part of the opening.
    if (events[contentStart][1].type === "whitespace") contentStart += 2;
    // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
    if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: "atxHeadingText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: "chunkText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: "text"
        };
        (0, $fc7d276d876e7974$export$869882364835d202)(events, contentStart, contentEnd - contentStart + 1, [
            [
                'enter',
                content,
                context
            ],
            [
                'enter',
                text,
                context
            ],
            [
                'exit',
                text,
                context
            ],
            [
                'exit',
                content,
                context
            ]
        ]);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $b4d2271e8f1abe18$var$tokenizeHeadingAtx(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        effects.enter("atxHeading");
        return before(code);
    }
    /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("atxHeadingSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return sequenceOpen;
        }
        // Always at least one `#`.
        if (code === null || (0, $db5865ecc27181ba$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingSequence");
            return atBreak(code);
        }
        return nok(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === 35) {
            effects.enter("atxHeadingSequence");
            return sequenceFurther(code);
        }
        if (code === null || (0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            effects.exit("atxHeading");
            // To do: interrupt like `markdown-rs`.
            // // Feel free to interrupt.
            // tokenizer.interrupt = false
            return ok(code);
        }
        if ((0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code)) return (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code);
        // To do: generate `data` tokens, add the `text` token later.
        // Needs edit map, see: `markdown.rs`.
        effects.enter("atxHeadingText");
        return data(code);
    }
    /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */ function sequenceFurther(code) {
        if (code === 35) {
            effects.consume(code);
            return sequenceFurther;
        }
        effects.exit("atxHeadingSequence");
        return atBreak(code);
    }
    /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 35 || (0, $db5865ecc27181ba$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingText");
            return atBreak(code);
        }
        effects.consume(code);
        return data;
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */ const $74739ffa03aeab21$export$7364aee1c59d1879 = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'search',
    'section',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];
const $74739ffa03aeab21$export$948e66da505d080 = [
    'pre',
    'script',
    'style',
    'textarea'
];



const $feb6cdd0f1671823$export$476ac411cb7d0d8f = {
    concrete: true,
    name: 'htmlFlow',
    resolveTo: $feb6cdd0f1671823$var$resolveToHtmlFlow,
    tokenize: $feb6cdd0f1671823$var$tokenizeHtmlFlow
};
/** @type {Construct} */ const $feb6cdd0f1671823$var$blankLineBefore = {
    partial: true,
    tokenize: $feb6cdd0f1671823$var$tokenizeBlankLineBefore
};
const $feb6cdd0f1671823$var$nonLazyContinuationStart = {
    partial: true,
    tokenize: $feb6cdd0f1671823$var$tokenizeNonLazyContinuationStart
};
/** @type {Resolver} */ function $feb6cdd0f1671823$var$resolveToHtmlFlow(events) {
    let index = events.length;
    while(index--){
        if (events[index][0] === 'enter' && events[index][1].type === "htmlFlow") break;
    }
    if (index > 1 && events[index - 2][1].type === "linePrefix") {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start;
        // Add the prefix start to the HTML line token.
        events[index + 1][1].start = events[index - 2][1].start;
        // Remove the line prefix.
        events.splice(index - 2, 2);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $feb6cdd0f1671823$var$tokenizeHtmlFlow(effects, ok, nok) {
    const self = this;
    /** @type {number} */ let marker;
    /** @type {boolean} */ let closingTag;
    /** @type {string} */ let buffer;
    /** @type {number} */ let index;
    /** @type {Code} */ let markerB;
    return start;
    /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("htmlFlow");
        effects.enter("htmlFlowData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            closingTag = true;
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            marker = 3;
            // To do:
            // tokenizer.concrete = true
            // To do: use `markdown-rs` style interrupt.
            // While we’re in an instruction instead of a declaration, we’re on a `?`
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        // ASCII alphabetical.
        if ((0, $db5865ecc27181ba$export$d65d6b62c24d5436)(code)) {
            // Always the case.
            effects.consume(code);
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            marker = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            marker = 5;
            index = 0;
            return cdataOpenInside;
        }
        // ASCII alphabetical.
        if ((0, $db5865ecc27181ba$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            marker = 4;
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            if (index === value.length) // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
            return cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        if ((0, $db5865ecc27181ba$export$d65d6b62c24d5436)(code)) {
            // Always the case.
            effects.consume(code);
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */ function tagName(code) {
        if (code === null || code === 47 || code === 62 || (0, $db5865ecc27181ba$export$a30284361b3814b7)(code)) {
            const slash = code === 47;
            const name = buffer.toLowerCase();
            if (!slash && !closingTag && (0, $74739ffa03aeab21$export$948e66da505d080).includes(name)) {
                marker = 1;
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ((0, $74739ffa03aeab21$export$7364aee1c59d1879).includes(buffer.toLowerCase())) {
                marker = 6;
                if (slash) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            marker = 7;
            // Do not support complete HTML when interrupting.
            return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
        }
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $db5865ecc27181ba$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */ function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeClosingTagAfter(code) {
        if ((0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        // ASCII alphanumerical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $db5865ecc27181ba$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ((0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeName(code) {
        // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $db5865ecc27181ba$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ((0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            markerB = code;
            return completeAttributeValueQuoted;
        }
        if ((0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        return completeAttributeValueUnquoted(code);
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuoted(code) {
        if (code === markerB) {
            effects.consume(code);
            markerB = null;
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || (0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || (0, $db5865ecc27181ba$export$a30284361b3814b7)(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */ function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAfter(code) {
        if (code === null || (0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) // // Do not form containers.
        // tokenizer.concrete = true
        return continuation(code);
        if ((0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */ function continuation(code) {
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && marker === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && marker === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && marker === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && marker === 5) {
            effects.consume(code);
            return continuationCdataInside;
        }
        if ((0, $db5865ecc27181ba$export$34a1dff1c0936953)(code) && (marker === 6 || marker === 7)) {
            effects.exit("htmlFlowData");
            return effects.check($feb6cdd0f1671823$var$blankLineBefore, continuationAfter, continuationStart)(code);
        }
        if (code === null || (0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationStart(code);
        }
        effects.consume(code);
        return continuation;
    }
    /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStart(code) {
        return effects.check($feb6cdd0f1671823$var$nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
    }
    /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStartNonLazy(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return continuationBefore;
    }
    /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */ function continuationBefore(code) {
        if (code === null || (0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) return continuationStart(code);
        effects.enter("htmlFlowData");
        return continuation(code);
    }
    /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */ function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */ function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = '';
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */ function continuationRawEndTag(code) {
        if (code === 62) {
            const name = buffer.toLowerCase();
            if ((0, $74739ffa03aeab21$export$948e66da505d080).includes(name)) {
                effects.consume(code);
                return continuationClose;
            }
            return continuation(code);
        }
        if ((0, $db5865ecc27181ba$export$d65d6b62c24d5436)(code) && buffer.length < 8) {
            // Always the case.
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */ function continuationCdataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */ function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        // More dashes.
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationClose(code) {
        if (code === null || (0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationAfter(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationAfter(code) {
        effects.exit("htmlFlow");
        // // Feel free to interrupt.
        // tokenizer.interrupt = false
        // // No longer concrete.
        // tokenizer.concrete = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $feb6cdd0f1671823$var$tokenizeNonLazyContinuationStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        if ((0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return after;
        }
        return nok(code);
    }
    /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $feb6cdd0f1671823$var$tokenizeBlankLineBefore(effects, ok, nok) {
    return start;
    /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return effects.attempt((0, $8d5404e5d94cba13$export$d50d28ce3ab2a612), ok, nok);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $47500928fca34bc1$export$398af27f284914fe = {
    name: 'htmlText',
    tokenize: $47500928fca34bc1$var$tokenizeHtmlText
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $47500928fca34bc1$var$tokenizeHtmlText(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code> | undefined} */ let marker;
    /** @type {number} */ let index;
    /** @type {State} */ let returnState;
    return start;
    /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("htmlText");
        effects.enter("htmlTextData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        // ASCII alphabetical.
        if ((0, $db5865ecc27181ba$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            index = 0;
            return cdataOpenInside;
        }
        if ((0, $db5865ecc27181ba$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return nok(code);
    }
    /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */ function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            returnState = comment;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return comment;
    }
    /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */ function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return comment(code);
    }
    /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */ function commentEnd(code) {
        return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
    }
    /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            return index === value.length ? cdata : cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */ function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ((0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            returnState = cdata;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return cdata;
    }
    /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */ function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */ function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ((0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            returnState = declaration;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return declaration;
    }
    /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */ function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ((0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            returnState = instruction;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return instruction;
    }
    /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */ function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        // ASCII alphabetical.
        if ((0, $db5865ecc27181ba$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagClose(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $db5865ecc27181ba$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagCloseBetween(code) {
        if ((0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            returnState = tagCloseBetween;
            return lineEndingBefore(code);
        }
        if ((0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpen(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $db5865ecc27181ba$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || (0, $db5865ecc27181ba$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        // ASCII alphabetical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $db5865ecc27181ba$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ((0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenBetween;
            return lineEndingBefore(code);
        }
        if ((0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeName(code) {
        // ASCII alphabetical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $db5865ecc27181ba$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ((0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeNameAfter;
            return lineEndingBefore(code);
        }
        if ((0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ((0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueBefore;
            return lineEndingBefore(code);
        }
        if ((0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            marker = undefined;
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ((0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 47 || code === 62 || (0, $db5865ecc27181ba$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $db5865ecc27181ba$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit("htmlTextData");
            effects.exit("htmlText");
            return ok;
        }
        return nok(code);
    }
    /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */ function lineEndingBefore(code) {
        effects.exit("htmlTextData");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineEndingAfter;
    }
    /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfter(code) {
        // Always populated by defaults.
        return (0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code) ? (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, lineEndingAfterPrefix, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : lineEndingAfterPrefix(code);
    }
    /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfterPrefix(code) {
        effects.enter("htmlTextData");
        return returnState(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Event,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 







const $0a6badad0cddedfe$export$470a5dafbbf62654 = {
    name: 'labelEnd',
    resolveAll: $0a6badad0cddedfe$var$resolveAllLabelEnd,
    resolveTo: $0a6badad0cddedfe$var$resolveToLabelEnd,
    tokenize: $0a6badad0cddedfe$var$tokenizeLabelEnd
};
/** @type {Construct} */ const $0a6badad0cddedfe$var$resourceConstruct = {
    tokenize: $0a6badad0cddedfe$var$tokenizeResource
};
/** @type {Construct} */ const $0a6badad0cddedfe$var$referenceFullConstruct = {
    tokenize: $0a6badad0cddedfe$var$tokenizeReferenceFull
};
/** @type {Construct} */ const $0a6badad0cddedfe$var$referenceCollapsedConstruct = {
    tokenize: $0a6badad0cddedfe$var$tokenizeReferenceCollapsed
};
/** @type {Resolver} */ function $0a6badad0cddedfe$var$resolveAllLabelEnd(events) {
    let index = -1;
    /** @type {Array<Event>} */ const newEvents = [];
    while(++index < events.length){
        const token = events[index][1];
        newEvents.push(events[index]);
        if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
            // Remove the marker.
            const offset = token.type === "labelImage" ? 4 : 2;
            token.type = "data";
            index += offset;
        }
    }
    // If the events are equal, we don't have to copy newEvents to events
    if (events.length !== newEvents.length) (0, $fc7d276d876e7974$export$869882364835d202)(events, 0, events.length, newEvents);
    return events;
}
/** @type {Resolver} */ function $0a6badad0cddedfe$var$resolveToLabelEnd(events, context) {
    let index = events.length;
    let offset = 0;
    /** @type {Token} */ let token;
    /** @type {number | undefined} */ let open;
    /** @type {number | undefined} */ let close;
    /** @type {Array<Event>} */ let media;
    // Find an opening.
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
            // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === 'enter' && token.type === "labelLink") token._inactive = true;
        } else if (close) {
            if (events[index][0] === 'enter' && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
                open = index;
                if (token.type !== "labelLink") {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === "labelEnd") close = index;
    }
    const group = {
        type: events[open][1].type === "labelLink" ? "link" : "image",
        start: {
            ...events[open][1].start
        },
        end: {
            ...events[events.length - 1][1].end
        }
    };
    const label = {
        type: "label",
        start: {
            ...events[open][1].start
        },
        end: {
            ...events[close][1].end
        }
    };
    const text = {
        type: "labelText",
        start: {
            ...events[open + offset + 2][1].end
        },
        end: {
            ...events[close - 2][1].start
        }
    };
    media = [
        [
            'enter',
            group,
            context
        ],
        [
            'enter',
            label,
            context
        ]
    ];
    // Opening marker.
    media = (0, $fc7d276d876e7974$export$4cbf152802aa238)(media, events.slice(open + 1, open + offset + 3));
    // Text open.
    media = (0, $fc7d276d876e7974$export$4cbf152802aa238)(media, [
        [
            'enter',
            text,
            context
        ]
    ]);
    // Always populated by defaults.
    // Between.
    media = (0, $fc7d276d876e7974$export$4cbf152802aa238)(media, (0, $572427b391443f2d$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));
    // Text close, marker close, label close.
    media = (0, $fc7d276d876e7974$export$4cbf152802aa238)(media, [
        [
            'exit',
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            'exit',
            label,
            context
        ]
    ]);
    // Reference, resource, or so.
    media = (0, $fc7d276d876e7974$export$4cbf152802aa238)(media, events.slice(close + 1));
    // Media close.
    media = (0, $fc7d276d876e7974$export$4cbf152802aa238)(media, [
        [
            'exit',
            group,
            context
        ]
    ]);
    (0, $fc7d276d876e7974$export$869882364835d202)(events, open, events.length, media);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $0a6badad0cddedfe$var$tokenizeLabelEnd(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Token} */ let labelStart;
    /** @type {boolean} */ let defined;
    // Find an opening.
    while(index--)if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */ function start(code) {
        // If there is not an okay opening.
        if (!labelStart) return nok(code);
        // If the corresponding label (link) start is marked as inactive,
        // it means we’d be wrapping a link, like this:
        //
        // ```markdown
        // > | a [b [c](d) e](f) g.
        //                  ^
        // ```
        //
        // We can’t have that, so it’s just balanced brackets.
        if (labelStart._inactive) return labelEndNok(code);
        defined = self.parser.defined.includes((0, $e8a88a5e1b7aeb38$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        })));
        effects.enter("labelEnd");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelEnd");
        return after;
    }
    /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
        // an extension.
        // Resource (`[asd](fgh)`)?
        if (code === 40) return effects.attempt($0a6badad0cddedfe$var$resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
        // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
        if (code === 91) return effects.attempt($0a6badad0cddedfe$var$referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
        // Shortcut (`[asd]`) reference?
        return defined ? labelEndOk(code) : labelEndNok(code);
    }
    /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceNotFull(code) {
        return effects.attempt($0a6badad0cddedfe$var$referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
    }
    /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndOk(code) {
        // Note: `markdown-rs` does a bunch of stuff here.
        return ok(code);
    }
    /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndNok(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $0a6badad0cddedfe$var$tokenizeResource(effects, ok, nok) {
    return resourceStart;
    /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */ function resourceStart(code) {
        effects.enter("resource");
        effects.enter("resourceMarker");
        effects.consume(code);
        effects.exit("resourceMarker");
        return resourceBefore;
    }
    /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceBefore(code) {
        return (0, $db5865ecc27181ba$export$a30284361b3814b7)(code) ? (0, $1f2386765c63a154$export$1f27bd1aa33ce173)(effects, resourceOpen)(code) : resourceOpen(code);
    }
    /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceOpen(code) {
        if (code === 41) return resourceEnd(code);
        return (0, $e6a686b884a80e11$export$2e6c8deaa96af245)(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code);
    }
    /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationAfter(code) {
        return (0, $db5865ecc27181ba$export$a30284361b3814b7)(code) ? (0, $1f2386765c63a154$export$1f27bd1aa33ce173)(effects, resourceBetween)(code) : resourceEnd(code);
    }
    /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationMissing(code) {
        return nok(code);
    }
    /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */ function resourceBetween(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $403f0b123a51092c$export$f970569cc855e483)(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
        return resourceEnd(code);
    }
    /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */ function resourceTitleAfter(code) {
        return (0, $db5865ecc27181ba$export$a30284361b3814b7)(code) ? (0, $1f2386765c63a154$export$1f27bd1aa33ce173)(effects, resourceEnd)(code) : resourceEnd(code);
    }
    /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceEnd(code) {
        if (code === 41) {
            effects.enter("resourceMarker");
            effects.consume(code);
            effects.exit("resourceMarker");
            effects.exit("resource");
            return ok;
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $0a6badad0cddedfe$var$tokenizeReferenceFull(effects, ok, nok) {
    const self = this;
    return referenceFull;
    /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFull(code) {
        return (0, $f906593f37ac63e2$export$7b768614d8ba97a7).call(self, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code);
    }
    /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */ function referenceFullAfter(code) {
        return self.parser.defined.includes((0, $e8a88a5e1b7aeb38$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
    }
    /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFullMissing(code) {
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $0a6badad0cddedfe$var$tokenizeReferenceCollapsed(effects, ok, nok) {
    return referenceCollapsedStart;
    /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceCollapsedStart(code) {
        // We only attempt a collapsed label if there’s a `[`.
        effects.enter("reference");
        effects.enter("referenceMarker");
        effects.consume(code);
        effects.exit("referenceMarker");
        return referenceCollapsedOpen;
    }
    /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */ function referenceCollapsedOpen(code) {
        if (code === 93) {
            effects.enter("referenceMarker");
            effects.consume(code);
            effects.exit("referenceMarker");
            effects.exit("reference");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $f29e180fc432f8b2$export$3d754936e25aa5f5 = {
    name: 'labelStartImage',
    resolveAll: (0, $0a6badad0cddedfe$export$470a5dafbbf62654).resolveAll,
    tokenize: $f29e180fc432f8b2$var$tokenizeLabelStartImage
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $f29e180fc432f8b2$var$tokenizeLabelStartImage(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelImage");
        effects.enter("labelImageMarker");
        effects.consume(code);
        effects.exit("labelImageMarker");
        return open;
    }
    /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 91) {
            effects.enter("labelMarker");
            effects.consume(code);
            effects.exit("labelMarker");
            effects.exit("labelImage");
            return after;
        }
        return nok(code);
    }
    /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */ function after(code) {
        // To do: use a new field to do this, this is still needed for
        // `micromark-extension-gfm-footnote`, but the `label-start-link`
        // behavior isn’t.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $0aa5a39b1ea6cc97$export$5c0cee0701a3b584 = {
    name: 'labelStartLink',
    resolveAll: (0, $0a6badad0cddedfe$export$470a5dafbbf62654).resolveAll,
    tokenize: $0aa5a39b1ea6cc97$var$tokenizeLabelStartLink
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $0aa5a39b1ea6cc97$var$tokenizeLabelStartLink(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelLink");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelLink");
        return after;
    }
    /** @type {State} */ function after(code) {
        // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
        // remove.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $3f8ee1909e552213$export$8e62e0ad51c97b2 = {
    name: 'lineEnding',
    tokenize: $3f8ee1909e552213$var$tokenizeLineEnding
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $3f8ee1909e552213$var$tokenizeLineEnding(effects, ok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, ok, "linePrefix");
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Exiter,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 


/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $da49060c217578a3$export$ba7b13e047416c03 = {
    name: 'thematicBreak',
    tokenize: $da49060c217578a3$var$tokenizeThematicBreak
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $da49060c217578a3$var$tokenizeThematicBreak(effects, ok, nok) {
    let size = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("thematicBreak");
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        marker = code;
        return atBreak(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.enter("thematicBreakSequence");
            return sequence(code);
        }
        if (size >= 3 && (code === null || (0, $db5865ecc27181ba$export$34a1dff1c0936953)(code))) {
            effects.exit("thematicBreak");
            return ok(code);
        }
        return nok(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit("thematicBreakSequence");
        return (0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code) ? (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code) : atBreak(code);
    }
}


const $90839a23e90a875e$export$8837f4fc672e936d = {
    continuation: {
        tokenize: $90839a23e90a875e$var$tokenizeListContinuation
    },
    exit: $90839a23e90a875e$var$tokenizeListEnd,
    name: 'list',
    tokenize: $90839a23e90a875e$var$tokenizeListStart
};
/** @type {Construct} */ const $90839a23e90a875e$var$listItemPrefixWhitespaceConstruct = {
    partial: true,
    tokenize: $90839a23e90a875e$var$tokenizeListItemPrefixWhitespace
};
/** @type {Construct} */ const $90839a23e90a875e$var$indentConstruct = {
    partial: true,
    tokenize: $90839a23e90a875e$var$tokenizeIndent
};
// To do: `markdown-rs` parses list items on their own and later stitches them
// together.
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $90839a23e90a875e$var$tokenizeListStart(effects, ok, nok) {
    const self = this;
    const tail = self.events[self.events.length - 1];
    let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
        if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : (0, $db5865ecc27181ba$export$ca8b5b1a6c320e6e)(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === "listUnordered") {
                effects.enter("listItemPrefix");
                return code === 42 || code === 45 ? effects.check((0, $da49060c217578a3$export$ba7b13e047416c03), nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter("listItemPrefix");
                effects.enter("listItemValue");
                return inside(code);
            }
        }
        return nok(code);
    }
    /** @type {State} */ function inside(code) {
        if ((0, $db5865ecc27181ba$export$ca8b5b1a6c320e6e)(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit("listItemValue");
            return atMarker(code);
        }
        return nok(code);
    }
    /**
   * @type {State}
   **/ function atMarker(code) {
        effects.enter("listItemMarker");
        effects.consume(code);
        effects.exit("listItemMarker");
        self.containerState.marker = self.containerState.marker || code;
        return effects.check((0, $8d5404e5d94cba13$export$d50d28ce3ab2a612), // Can’t be empty when interrupting.
        self.interrupt ? nok : onBlank, effects.attempt($90839a23e90a875e$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    /** @type {State} */ function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    /** @type {State} */ function otherPrefix(code) {
        if ((0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code)) {
            effects.enter("listItemPrefixWhitespace");
            effects.consume(code);
            effects.exit("listItemPrefixWhitespace");
            return endOfPrefix;
        }
        return nok(code);
    }
    /** @type {State} */ function endOfPrefix(code) {
        self.containerState.size = initialSize + self.sliceSerialize(effects.exit("listItemPrefix"), true).length;
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $90839a23e90a875e$var$tokenizeListContinuation(effects, ok, nok) {
    const self = this;
    self.containerState._closeFlow = undefined;
    return effects.check((0, $8d5404e5d94cba13$export$d50d28ce3ab2a612), onBlank, notBlank);
    /** @type {State} */ function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;
        // We have a blank line.
        // Still, try to consume at most the items size.
        return (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
    }
    /** @type {State} */ function notBlank(code) {
        if (self.containerState.furtherBlankLines || !(0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code)) {
            self.containerState.furtherBlankLines = undefined;
            self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = undefined;
        self.containerState.initialBlankLine = undefined;
        return effects.attempt($90839a23e90a875e$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    /** @type {State} */ function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true;
        // As we’re closing flow, we’re no longer interrupting.
        self.interrupt = undefined;
        // Always populated by defaults.
        return (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, effects.attempt($90839a23e90a875e$export$8837f4fc672e936d, ok, nok), "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $90839a23e90a875e$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Exiter}
 */ function $90839a23e90a875e$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $90839a23e90a875e$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    const self = this;
    // Always populated by defaults.
    return (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 5);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return !(0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $f782120a8cb017ec$export$e104e2de391dfde9 = {
    name: 'setextUnderline',
    resolveTo: $f782120a8cb017ec$var$resolveToSetextUnderline,
    tokenize: $f782120a8cb017ec$var$tokenizeSetextUnderline
};
/** @type {Resolver} */ function $f782120a8cb017ec$var$resolveToSetextUnderline(events, context) {
    // To do: resolve like `markdown-rs`.
    let index = events.length;
    /** @type {number | undefined} */ let content;
    /** @type {number | undefined} */ let text;
    /** @type {number | undefined} */ let definition;
    // Find the opening of the content.
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === 'enter') {
        if (events[index][1].type === "content") {
            content = index;
            break;
        }
        if (events[index][1].type === "paragraph") text = index;
    } else {
        if (events[index][1].type === "content") // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === "definition") definition = index;
    }
    const heading = {
        type: "setextHeading",
        start: {
            ...events[text][1].start
        },
        end: {
            ...events[events.length - 1][1].end
        }
    };
    // Change the paragraph to setext heading text.
    events[text][1].type = "setextHeadingText";
    // If we have definitions in the content, we’ll keep on having content,
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            'enter',
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            'exit',
            events[content][1],
            context
        ]);
        events[content][1].end = {
            ...events[definition][1].end
        };
    } else events[content][1] = heading;
    // Add the heading exit at the end.
    events.push([
        'exit',
        heading,
        context
    ]);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $f782120a8cb017ec$var$tokenizeSetextUnderline(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        let index = self.events.length;
        /** @type {boolean | undefined} */ let paragraph;
        // Find an opening.
        while(index--)// Skip enter/exit of line ending, line prefix, and content.
        // We can now either have a definition or a paragraph.
        if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
            paragraph = self.events[index][1].type === "paragraph";
            break;
        }
        // To do: handle lazy/pierce like `markdown-rs`.
        // To do: parse indent like `markdown-rs`.
        if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
            effects.enter("setextHeadingLine");
            marker = code;
            return before(code);
        }
        return nok(code);
    }
    /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("setextHeadingLineSequence");
        return inside(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        effects.exit("setextHeadingLineSequence");
        return (0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code) ? (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, after, "lineSuffix")(code) : after(code);
    }
    /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if (code === null || (0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            effects.exit("setextHeadingLine");
            return ok(code);
        }
        return nok(code);
    }
}



const $e188912510daf42a$export$5a7bfc01df82fcd1 = {
    [42]: (0, $90839a23e90a875e$export$8837f4fc672e936d),
    [43]: (0, $90839a23e90a875e$export$8837f4fc672e936d),
    [45]: (0, $90839a23e90a875e$export$8837f4fc672e936d),
    [48]: (0, $90839a23e90a875e$export$8837f4fc672e936d),
    [49]: (0, $90839a23e90a875e$export$8837f4fc672e936d),
    [50]: (0, $90839a23e90a875e$export$8837f4fc672e936d),
    [51]: (0, $90839a23e90a875e$export$8837f4fc672e936d),
    [52]: (0, $90839a23e90a875e$export$8837f4fc672e936d),
    [53]: (0, $90839a23e90a875e$export$8837f4fc672e936d),
    [54]: (0, $90839a23e90a875e$export$8837f4fc672e936d),
    [55]: (0, $90839a23e90a875e$export$8837f4fc672e936d),
    [56]: (0, $90839a23e90a875e$export$8837f4fc672e936d),
    [57]: (0, $90839a23e90a875e$export$8837f4fc672e936d),
    [62]: (0, $195bd471f624b1ee$export$200dcd0a5903c968)
};
const $e188912510daf42a$export$5a2181fb44b58173 = {
    [91]: (0, $71984b733f5045d6$export$69f215ed977cdb73)
};
const $e188912510daf42a$export$cf8bead395eff824 = {
    [-2]: (0, $85aef0d291790f13$export$47910b7ab28d1853),
    [-1]: (0, $85aef0d291790f13$export$47910b7ab28d1853),
    [32]: (0, $85aef0d291790f13$export$47910b7ab28d1853)
};
const $e188912510daf42a$export$ccc7b0636abaffc3 = {
    [35]: (0, $b4d2271e8f1abe18$export$3871e9deb360695c),
    [42]: (0, $da49060c217578a3$export$ba7b13e047416c03),
    [45]: [
        (0, $f782120a8cb017ec$export$e104e2de391dfde9),
        (0, $da49060c217578a3$export$ba7b13e047416c03)
    ],
    [60]: (0, $feb6cdd0f1671823$export$476ac411cb7d0d8f),
    [61]: (0, $f782120a8cb017ec$export$e104e2de391dfde9),
    [95]: (0, $da49060c217578a3$export$ba7b13e047416c03),
    [96]: (0, $0dca07a85c64a229$export$c23e4921f8d87e7c),
    [126]: (0, $0dca07a85c64a229$export$c23e4921f8d87e7c)
};
const $e188912510daf42a$export$22b082955e083ec3 = {
    [38]: (0, $7009325e01a371ab$export$e31905600aaf3d8e),
    [92]: (0, $15debd2cf16093b4$export$2005478564e78d96)
};
const $e188912510daf42a$export$6f093cfa640b7166 = {
    [-5]: (0, $3f8ee1909e552213$export$8e62e0ad51c97b2),
    [-4]: (0, $3f8ee1909e552213$export$8e62e0ad51c97b2),
    [-3]: (0, $3f8ee1909e552213$export$8e62e0ad51c97b2),
    [33]: (0, $f29e180fc432f8b2$export$3d754936e25aa5f5),
    [38]: (0, $7009325e01a371ab$export$e31905600aaf3d8e),
    [42]: (0, $f61564e9371adf09$export$45b92471da762af7),
    [60]: [
        (0, $b5cba1161c57096d$export$17ddf85e4c916ad6),
        (0, $47500928fca34bc1$export$398af27f284914fe)
    ],
    [91]: (0, $0aa5a39b1ea6cc97$export$5c0cee0701a3b584),
    [92]: [
        (0, $2700b1defcbba05a$export$86c573ab9e06f418),
        (0, $15debd2cf16093b4$export$2005478564e78d96)
    ],
    [93]: (0, $0a6badad0cddedfe$export$470a5dafbbf62654),
    [95]: (0, $f61564e9371adf09$export$45b92471da762af7),
    [96]: (0, $7b1512082b57af90$export$d24f93e715f9df88)
};
const $e188912510daf42a$export$d44f260a3f9b69f5 = {
    null: [
        (0, $f61564e9371adf09$export$45b92471da762af7),
        (0, $12a67d71128b0767$export$50397835cbfdbc24)
    ]
};
const $e188912510daf42a$export$b9c0b60d74426aea = {
    null: [
        42,
        95
    ]
};
const $e188912510daf42a$export$e20fbacbb41798b = {
    null: []
};


/**
 * @import {
 *   Chunk,
 *   Code,
 *   ConstructRecord,
 *   Construct,
 *   Effects,
 *   InitialConstruct,
 *   ParseContext,
 *   Point,
 *   State,
 *   TokenizeContext,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @callback Restore
 *   Restore the state.
 * @returns {undefined}
 *   Nothing.
 *
 * @typedef Info
 *   Info.
 * @property {Restore} restore
 *   Restore.
 * @property {number} from
 *   From.
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 *   Construct.
 * @param {Info} info
 *   Info.
 * @returns {undefined}
 *   Nothing.
 */ 


function $51e4d0c57c449d54$export$ae34f10ee4b29837(parser, initialize, from) {
    /** @type {Point} */ let point = {
        _bufferIndex: -1,
        _index: 0,
        line: from && from.line || 1,
        column: from && from.column || 1,
        offset: from && from.offset || 0
    };
    /** @type {Record<string, number>} */ const columnStart = {};
    /** @type {Array<Construct>} */ const resolveAllConstructs = [];
    /** @type {Array<Chunk>} */ let chunks = [];
    /** @type {Array<Token>} */ let stack = [];
    /** @type {boolean | undefined} */ let consumed = true;
    /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */ const effects = {
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        consume: consume,
        enter: enter,
        exit: exit,
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        })
    };
    /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */ const context = {
        code: null,
        containerState: {},
        defineSkip: defineSkip,
        events: [],
        now: now,
        parser: parser,
        previous: null,
        sliceSerialize: sliceSerialize,
        sliceStream: sliceStream,
        write: write
    };
    /**
   * The state function.
   *
   * @type {State | undefined}
   */ let state = initialize.tokenize.call(context, effects);
    /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */ let expectedCode;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
    return context;
    /** @type {TokenizeContext['write']} */ function write(slice) {
        chunks = (0, $fc7d276d876e7974$export$4cbf152802aa238)(chunks, slice);
        main();
        // Exit if we’re not done, resolve might change stuff.
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0);
        // Otherwise, resolve, and exit.
        context.events = (0, $572427b391443f2d$export$3ff61ec196ff408b)(resolveAllConstructs, context.events, context);
        return context.events;
    }
    //
    // Tools.
    //
    /** @type {TokenizeContext['sliceSerialize']} */ function sliceSerialize(token, expandTabs) {
        return $51e4d0c57c449d54$var$serializeChunks(sliceStream(token), expandTabs);
    }
    /** @type {TokenizeContext['sliceStream']} */ function sliceStream(token) {
        return $51e4d0c57c449d54$var$sliceChunks(chunks, token);
    }
    /** @type {TokenizeContext['now']} */ function now() {
        // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
        const { _bufferIndex: _bufferIndex, _index: _index, line: line, column: column, offset: offset } = point;
        return {
            _bufferIndex: _bufferIndex,
            _index: _index,
            line: line,
            column: column,
            offset: offset
        };
    }
    /** @type {TokenizeContext['defineSkip']} */ function defineSkip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    }
    //
    // State management.
    //
    /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {undefined}
   *   Nothing.
   */ function main() {
        /** @type {number} */ let chunkIndex;
        while(point._index < chunks.length){
            const chunk = chunks[point._index];
            // If we’re in a buffer chunk, loop through it.
            if (typeof chunk === 'string') {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    }
    /**
   * Deal with one code.
   *
   * @param {Code} code
   *   Code.
   * @returns {undefined}
   *   Nothing.
   */ function go(code) {
        consumed = undefined;
        expectedCode = code;
        state = state(code);
    }
    /** @type {Effects['consume']} */ function consume(code) {
        if ((0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        }
        // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++;
            // At end of string chunk.
            if (point._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
            // strings.
            /** @type {string} */ chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        }
        // Expose the previous character.
        context.previous = code;
        // Mark as consumed.
        consumed = true;
    }
    /** @type {Effects['enter']} */ function enter(type, fields) {
        /** @type {Token} */ // @ts-expect-error Patch instead of assign required fields to help GC.
        const token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            'enter',
            token,
            context
        ]);
        stack.push(token);
        return token;
    }
    /** @type {Effects['exit']} */ function exit(type) {
        const token = stack.pop();
        token.end = now();
        context.events.push([
            'exit',
            token,
            context
        ]);
        return token;
    }
    /**
   * Use results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    }
    /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulcheck(_, info) {
        info.restore();
    }
    /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   *   Callback.
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   *   Fields.
   */ function constructFactory(onreturn, fields) {
        return hook;
        /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | ConstructRecord | Construct} constructs
     *   Constructs.
     * @param {State} returnState
     *   State.
     * @param {State | undefined} [bogusState]
     *   State.
     * @returns {State}
     *   State.
     */ function hook(constructs, returnState, bogusState) {
            /** @type {ReadonlyArray<Construct>} */ let listOfConstructs;
            /** @type {number} */ let constructIndex;
            /** @type {Construct} */ let currentConstruct;
            /** @type {Info} */ let info;
            return Array.isArray(constructs) ? /* c8 ignore next 1 */ handleListOfConstructs(constructs) : 'tokenize' in constructs ? // Looks like a construct.
            handleListOfConstructs([
                /** @type {Construct} */ constructs
            ]) : handleMapOfConstructs(constructs);
            /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       *   Constructs.
       * @returns {State}
       *   State.
       */ function handleMapOfConstructs(map) {
                return start;
                /** @type {State} */ function start(code) {
                    const left = code !== null && map[code];
                    const all = code !== null && map.null;
                    const list = [
                        // To do: add more extension tests.
                        /* c8 ignore next 2 */ ...Array.isArray(left) ? left : left ? [
                            left
                        ] : [],
                        ...Array.isArray(all) ? all : all ? [
                            all
                        ] : []
                    ];
                    return handleListOfConstructs(list)(code);
                }
            }
            /**
       * Handle a list of construct.
       *
       * @param {ReadonlyArray<Construct>} list
       *   Constructs.
       * @returns {State}
       *   State.
       */ function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                if (list.length === 0) return bogusState;
                return handleConstruct(list[constructIndex]);
            }
            /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       *   Construct.
       * @returns {State}
       *   State.
       */ function handleConstruct(construct) {
                return start;
                /** @type {State} */ function start(code) {
                    // To do: not needed to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    // Always populated by defaults.
                    if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code);
                    return construct.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
                }
            }
            /** @type {State} */ function ok(code) {
                consumed = true;
                onreturn(currentConstruct, info);
                return returnState;
            }
            /** @type {State} */ function nok(code) {
                consumed = true;
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    /**
   * @param {Construct} construct
   *   Construct.
   * @param {number} from
   *   From.
   * @returns {undefined}
   *   Nothing.
   */ function addResult(construct, from) {
        if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
        if (construct.resolve) (0, $fc7d276d876e7974$export$869882364835d202)(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    /**
   * Store state.
   *
   * @returns {Info}
   *   Info.
   */ function store() {
        const startPoint = now();
        const startPrevious = context.previous;
        const startCurrentConstruct = context.currentConstruct;
        const startEventsIndex = context.events.length;
        const startStack = Array.from(stack);
        return {
            from: startEventsIndex,
            restore: restore
        };
        /**
     * Restore state.
     *
     * @returns {undefined}
     *   Nothing.
     */ function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {undefined}
   *   Nothing.
   */ function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {ReadonlyArray<Chunk>} chunks
 *   Chunks.
 * @param {Pick<Token, 'end' | 'start'>} token
 *   Token.
 * @returns {Array<Chunk>}
 *   Chunks.
 */ function $51e4d0c57c449d54$var$sliceChunks(chunks, token) {
    const startIndex = token.start._index;
    const startBufferIndex = token.start._bufferIndex;
    const endIndex = token.end._index;
    const endBufferIndex = token.end._bufferIndex;
    /** @type {Array<Chunk>} */ let view;
    if (startIndex === endIndex) // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) {
            const head = view[0];
            if (typeof head === 'string') view[0] = head.slice(startBufferIndex);
            else view.shift();
        }
        if (endBufferIndex > 0) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {ReadonlyArray<Chunk>} chunks
 *   Chunks.
 * @param {boolean | undefined} [expandTabs=false]
 *   Whether to expand tabs (default: `false`).
 * @returns {string}
 *   Result.
 */ function $51e4d0c57c449d54$var$serializeChunks(chunks, expandTabs) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    /** @type {boolean | undefined} */ let atTab;
    while(++index < chunks.length){
        const chunk = chunks[index];
        /** @type {string} */ let value;
        if (typeof chunk === 'string') value = chunk;
        else switch(chunk){
            case -5:
                value = "\r";
                break;
            case -4:
                value = "\n";
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = expandTabs ? " " : "\t";
                break;
            case -1:
                if (!expandTabs && atTab) continue;
                value = " ";
                break;
            default:
                // Currently only replacement character.
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join('');
}


function $fa5ef1bf720932dc$export$98e6a39c04603d36(options) {
    const settings = options || {};
    const constructs = /** @type {FullNormalizedExtension} */ (0, $b9be7a96f8f7c619$export$86a865d89ef3c690)([
        $e188912510daf42a$exports,
        ...settings.extensions || []
    ]);
    /** @type {ParseContext} */ const parser = {
        constructs: constructs,
        content: create((0, $269c7d839a0a7a60$export$a7db06668cad9adb)),
        defined: [],
        document: create((0, $e94c0f7dee28bcba$export$5a7bfc01df82fcd1)),
        flow: create((0, $85cb6584b341524f$export$ccc7b0636abaffc3)),
        lazy: {},
        string: create((0, $12a67d71128b0767$export$22b082955e083ec3)),
        text: create((0, $12a67d71128b0767$export$6f093cfa640b7166))
    };
    return parser;
    /**
   * @param {InitialConstruct} initial
   *   Construct to start with.
   * @returns {Create}
   *   Create a tokenizer.
   */ function create(initial) {
        return creator;
        /** @type {Create} */ function creator(from) {
            return (0, $51e4d0c57c449d54$export$ae34f10ee4b29837)(parser, initial, from);
        }
    }
}


/**
 * @import {Event} from 'micromark-util-types'
 */ 
function $73da3b8e0085f41a$export$bd0e6e1378a871d7(events) {
    while(!(0, $43c689452f48fe6d$export$12949d1dd00fddf4)(events));
    return events;
}


/**
 * @import {Chunk, Code, Encoding, Value} from 'micromark-util-types'
 */ /**
 * @callback Preprocessor
 *   Preprocess a value.
 * @param {Value} value
 *   Value.
 * @param {Encoding | null | undefined} [encoding]
 *   Encoding when `value` is a typed array (optional).
 * @param {boolean | null | undefined} [end=false]
 *   Whether this is the last chunk (default: `false`).
 * @returns {Array<Chunk>}
 *   Chunks.
 */ const $07fbcb5b8999dc85$var$search = /[\0\t\n\r]/g;
function $07fbcb5b8999dc85$export$fc37fe19dfda43ee() {
    let column = 1;
    let buffer = '';
    /** @type {boolean | undefined} */ let start = true;
    /** @type {boolean | undefined} */ let atCarriageReturn;
    return preprocessor;
    /** @type {Preprocessor} */ // eslint-disable-next-line complexity
    function preprocessor(value, encoding, end) {
        /** @type {Array<Chunk>} */ const chunks = [];
        /** @type {RegExpMatchArray | null} */ let match;
        /** @type {number} */ let next;
        /** @type {number} */ let startPosition;
        /** @type {number} */ let endPosition;
        /** @type {Code} */ let code;
        value = buffer + (typeof value === 'string' ? value.toString() : new TextDecoder(encoding || undefined).decode(value));
        startPosition = 0;
        buffer = '';
        if (start) {
            // To do: `markdown-rs` actually parses BOMs (byte order mark).
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $07fbcb5b8999dc85$var$search.lastIndex = startPosition;
            match = $07fbcb5b8999dc85$var$search.exec(value);
            endPosition = match && match.index !== undefined ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                switch(code){
                    case 0:
                        chunks.push(65533);
                        column++;
                        break;
                    case 9:
                        next = Math.ceil(column / 4) * 4;
                        chunks.push(-2);
                        while(column++ < next)chunks.push(-1);
                        break;
                    case 10:
                        chunks.push(-4);
                        column = 1;
                        break;
                    default:
                        atCarriageReturn = true;
                        column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}


function $9b8bb203a429a4dd$export$eb6d260b88819962(value, encoding, options) {
    if (typeof encoding !== 'string') {
        options = encoding;
        encoding = undefined;
    }
    return (0, $6a1842fa275d2baf$export$ef7acd7185315e22)(options)((0, $73da3b8e0085f41a$export$bd0e6e1378a871d7)((0, $fa5ef1bf720932dc$export$98e6a39c04603d36)(options).document().write((0, $07fbcb5b8999dc85$export$fc37fe19dfda43ee)()(value, encoding, true))));
}





const $8fa28b090247764d$var$characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $8fa28b090247764d$export$a0fb664af7d0cc44(value) {
    return value.replace($8fa28b090247764d$var$characterEscapeOrReference, $8fa28b090247764d$var$decode);
}
/**
 * @param {string} $0
 *   Match.
 * @param {string} $1
 *   Character escape.
 * @param {string} $2
 *   Character reference.
 * @returns {string}
 *   Decoded value
 */ function $8fa28b090247764d$var$decode($0, $1, $2) {
    if ($1) // Escape.
    return $1;
    // Reference.
    const head = $2.charCodeAt(0);
    if (head === 35) {
        const head = $2.charCodeAt(1);
        const hex = head === 120 || head === 88;
        return (0, $d84c106c656940a7$export$15a69557afac2c20)($2.slice(hex ? 2 : 1), hex ? 16 : 10);
    }
    return (0, $a7eaf83d99f11094$export$289b6a6320f709b4)($2) || $0;
}




/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 */ /**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Point | PointLike | Position | PositionLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */ function $c5c5a0aadce33baf$export$c304dd45fe166145(value) {
    // Nothing.
    if (!value || typeof value !== 'object') return '';
    // Node.
    if ('position' in value || 'type' in value) return $c5c5a0aadce33baf$var$position(value.position);
    // Position.
    if ('start' in value || 'end' in value) return $c5c5a0aadce33baf$var$position(value);
    // Point.
    if ('line' in value || 'column' in value) return $c5c5a0aadce33baf$var$point(value);
    // ?
    return '';
}
/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */ function $c5c5a0aadce33baf$var$point(point) {
    return $c5c5a0aadce33baf$var$index(point && point.line) + ':' + $c5c5a0aadce33baf$var$index(point && point.column);
}
/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */ function $c5c5a0aadce33baf$var$position(pos) {
    return $c5c5a0aadce33baf$var$point(pos && pos.start) + '-' + $c5c5a0aadce33baf$var$point(pos && pos.end);
}
/**
 * @param {number | null | undefined} value
 * @returns {number}
 */ function $c5c5a0aadce33baf$var$index(value) {
    return value && typeof value === 'number' ? value : 1;
}


const $ad13aef915352c90$var$own = {}.hasOwnProperty;
function $ad13aef915352c90$export$d744d789c09bfde6(value, encoding, options) {
    if (typeof encoding !== 'string') {
        options = encoding;
        encoding = undefined;
    }
    return $ad13aef915352c90$var$compiler(options)((0, $73da3b8e0085f41a$export$bd0e6e1378a871d7)((0, $fa5ef1bf720932dc$export$98e6a39c04603d36)(options).document().write((0, $07fbcb5b8999dc85$export$fc37fe19dfda43ee)()(value, encoding, true))));
}
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */ function $ad13aef915352c90$var$compiler(options) {
    /** @type {Config} */ const config = {
        transforms: [],
        canContainEols: [
            'emphasis',
            'fragment',
            'heading',
            'paragraph',
            'strong'
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            characterReference: onexitcharacterreference,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    };
    $ad13aef915352c90$var$configure(config, (options || {}).mdastExtensions || []);
    /** @type {CompileData} */ const data = {};
    return compile;
    /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */ function compile(events) {
        /** @type {Root} */ let tree = {
            type: 'root',
            children: []
        };
        /** @type {Omit<CompileContext, 'sliceSerialize'>} */ const context = {
            stack: [
                tree
            ],
            tokenStack: [],
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            data: data
        };
        /** @type {Array<number>} */ const listStack = [];
        let index = -1;
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
            if (events[index][0] === 'enter') listStack.push(index);
            else {
                const tail = listStack.pop();
                index = prepareList(events, tail, index);
            }
        }
        index = -1;
        while(++index < events.length){
            const handler = config[events[index][0]];
            if ($ad13aef915352c90$var$own.call(handler, events[index][1].type)) handler[events[index][1].type].call(Object.assign({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        // Handle tokens still being open.
        if (context.tokenStack.length > 0) {
            const tail = context.tokenStack[context.tokenStack.length - 1];
            const handler = tail[1] || $ad13aef915352c90$var$defaultOnError;
            handler.call(context, undefined, tail[0]);
        }
        // Figure out `root` position.
        tree.position = {
            start: $ad13aef915352c90$var$point(events.length > 0 ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: $ad13aef915352c90$var$point(events.length > 0 ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        // Call transforms.
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */ function prepareList(events, start, length) {
        let index = start - 1;
        let containerBalance = -1;
        let listSpread = false;
        /** @type {Token | undefined} */ let listItem;
        /** @type {number | undefined} */ let lineIndex;
        /** @type {number | undefined} */ let firstBlankLineIndex;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index <= length){
            const event = events[index];
            switch(event[1].type){
                case "listUnordered":
                case "listOrdered":
                case "blockQuote":
                    if (event[0] === 'enter') containerBalance++;
                    else containerBalance--;
                    atMarker = undefined;
                    break;
                case "lineEndingBlank":
                    if (event[0] === 'enter') {
                        if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                        atMarker = undefined;
                    }
                    break;
                case "linePrefix":
                case "listItemValue":
                case "listItemMarker":
                case "listItemPrefix":
                case "listItemPrefixWhitespace":
                    break;
                default:
                    atMarker = undefined;
            }
            if (!containerBalance && event[0] === 'enter' && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === 'exit' && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
                if (listItem) {
                    let tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        const tailEvent = events[tailIndex];
                        if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
                            if (tailEvent[0] === 'exit') continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = "lineEndingBlank";
                                listSpread = true;
                            }
                            tailEvent[1].type = "lineEnding";
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        'exit',
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === "listItemPrefix") {
                    /** @type {Token} */ const item = {
                        type: 'listItem',
                        _spread: false,
                        start: Object.assign({}, event[1].start),
                        // @ts-expect-error: we’ll add `end` in a second.
                        end: undefined
                    };
                    listItem = item;
                    events.splice(index, 0, [
                        'enter',
                        item,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Nodes} create
   *   Create a node.
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function opener(create, and) {
        return open;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    /**
   * @type {CompileContext['buffer']}
   */ function buffer() {
        this.stack.push({
            type: 'fragment',
            children: []
        });
    }
    /**
   * @type {CompileContext['enter']}
   */ function enter(node, token, errorHandler) {
        const parent = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = parent.children;
        siblings.push(node);
        this.stack.push(node);
        this.tokenStack.push([
            token,
            errorHandler || undefined
        ]);
        node.position = {
            start: $ad13aef915352c90$var$point(token.start),
            // @ts-expect-error: `end` will be patched later.
            end: undefined
        };
    }
    /**
   * Create a closer handle.
   *
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function closer(and) {
        return close;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    /**
   * @type {CompileContext['exit']}
   */ function exit(token, onExitError) {
        const node = this.stack.pop();
        const open = this.tokenStack.pop();
        if (!open) throw new Error('Cannot close `' + token.type + '` (' + (0, $c5c5a0aadce33baf$export$c304dd45fe166145)({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open[0].type !== token.type) {
            if (onExitError) onExitError.call(this, token, open[0]);
            else {
                const handler = open[1] || $ad13aef915352c90$var$defaultOnError;
                handler.call(this, token, open[0]);
            }
        }
        node.position.end = $ad13aef915352c90$var$point(token.end);
    }
    /**
   * @type {CompileContext['resume']}
   */ function resume() {
        return (0, $c4fd171878a6a851$export$f84e8e69fd4488a5)(this.stack.pop());
    }
    //
    // Handlers.
    //
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered() {
        this.data.expectingFirstListItemValue = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (this.data.expectingFirstListItemValue) {
            const ancestor = this.stack[this.stack.length - 2];
            ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
            this.data.expectingFirstListItemValue = undefined;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.lang = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfencemeta() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.meta = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (this.data.flowCodeInside) return;
        this.buffer();
        this.data.flowCodeInside = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefenced() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, '');
        this.data.flowCodeInside = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeindented() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/(\r?\n|\r)$/g, '');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.label = label;
        node.identifier = (0, $e8a88a5e1b7aeb38$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        const node = this.stack[this.stack.length - 1];
        if (!node.depth) {
            const depth = this.sliceSerialize(token).length;
            node.depth = depth;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        this.data.setextHeadingSlurpLineEnding = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        const node = this.stack[this.stack.length - 1];
        node.depth = this.sliceSerialize(token).codePointAt(0) === 61 ? 1 : 2;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        this.data.setextHeadingSlurpLineEnding = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdata(token) {
        const node = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = node.children;
        let tail = siblings[siblings.length - 1];
        if (!tail || tail.type !== 'text') {
            // Add a new text node.
            tail = text();
            tail.position = {
                start: $ad13aef915352c90$var$point(token.start),
                // @ts-expect-error: we’ll add `end` later.
                end: undefined
            };
            siblings.push(tail);
        }
        this.stack.push(tail);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        const tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = $ad13aef915352c90$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        const context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (this.data.atHardBreak) {
            const tail = context.children[context.children.length - 1];
            tail.position.end = $ad13aef915352c90$var$point(token.end);
            this.data.atHardBreak = undefined;
            return;
        }
        if (!this.data.setextHeadingSlurpLineEnding && config.canContainEols.includes(context.type)) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        this.data.atHardBreak = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmlflow() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmltext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodetext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlink() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitimage() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        const string = this.sliceSerialize(token);
        const ancestor = this.stack[this.stack.length - 2];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        ancestor.label = (0, $8fa28b090247764d$export$a0fb664af7d0cc44)(string);
        // @ts-expect-error: same as above.
        ancestor.identifier = (0, $e8a88a5e1b7aeb38$export$806d55e226cfcd08)(string).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        const fragment = this.stack[this.stack.length - 1];
        const value = this.resume();
        const node = this.stack[this.stack.length - 1];
        // Assume a reference.
        this.data.inReference = true;
        if (node.type === 'link') {
            /** @type {Array<PhrasingContent>} */ const children = fragment.children;
            node.children = children;
        } else node.alt = value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresource() {
        this.data.inReference = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterreference() {
        this.data.referenceType = 'collapsed';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        node.label = label;
        // @ts-expect-error: same as above.
        node.identifier = (0, $e8a88a5e1b7aeb38$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
        this.data.referenceType = 'full';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencemarker(token) {
        this.data.characterReferenceType = token.type;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const data = this.sliceSerialize(token);
        const type = this.data.characterReferenceType;
        /** @type {string} */ let value;
        if (type) {
            value = (0, $d84c106c656940a7$export$15a69557afac2c20)(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
            this.data.characterReferenceType = undefined;
        } else {
            const result = (0, $a7eaf83d99f11094$export$289b6a6320f709b4)(data);
            value = result;
        }
        const tail = this.stack[this.stack.length - 1];
        tail.value += value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreference(token) {
        const tail = this.stack.pop();
        tail.position.end = $ad13aef915352c90$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = 'mailto:' + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    /** @returns {Blockquote} */ function blockQuote() {
        return {
            type: 'blockquote',
            children: []
        };
    }
    /** @returns {Code} */ function codeFlow() {
        return {
            type: 'code',
            lang: null,
            meta: null,
            value: ''
        };
    }
    /** @returns {InlineCode} */ function codeText() {
        return {
            type: 'inlineCode',
            value: ''
        };
    }
    /** @returns {Definition} */ function definition() {
        return {
            type: 'definition',
            identifier: '',
            label: null,
            title: null,
            url: ''
        };
    }
    /** @returns {Emphasis} */ function emphasis() {
        return {
            type: 'emphasis',
            children: []
        };
    }
    /** @returns {Heading} */ function heading() {
        return {
            type: 'heading',
            // @ts-expect-error `depth` will be set later.
            depth: 0,
            children: []
        };
    }
    /** @returns {Break} */ function hardBreak() {
        return {
            type: 'break'
        };
    }
    /** @returns {Html} */ function html() {
        return {
            type: 'html',
            value: ''
        };
    }
    /** @returns {Image} */ function image() {
        return {
            type: 'image',
            title: null,
            url: '',
            alt: null
        };
    }
    /** @returns {Link} */ function link() {
        return {
            type: 'link',
            title: null,
            url: '',
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {List}
   */ function list(token) {
        return {
            type: 'list',
            ordered: token.type === 'listOrdered',
            start: null,
            spread: token._spread,
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {ListItem}
   */ function listItem(token) {
        return {
            type: 'listItem',
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    /** @returns {Paragraph} */ function paragraph() {
        return {
            type: 'paragraph',
            children: []
        };
    }
    /** @returns {Strong} */ function strong() {
        return {
            type: 'strong',
            children: []
        };
    }
    /** @returns {Text} */ function text() {
        return {
            type: 'text',
            value: ''
        };
    }
    /** @returns {ThematicBreak} */ function thematicBreak() {
        return {
            type: 'thematicBreak'
        };
    }
}
/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */ function $ad13aef915352c90$var$point(d) {
    return {
        line: d.line,
        column: d.column,
        offset: d.offset
    };
}
/**
 * @param {Config} combined
 * @param {Array<Array<Extension> | Extension>} extensions
 * @returns {undefined}
 */ function $ad13aef915352c90$var$configure(combined, extensions) {
    let index = -1;
    while(++index < extensions.length){
        const value = extensions[index];
        if (Array.isArray(value)) $ad13aef915352c90$var$configure(combined, value);
        else $ad13aef915352c90$var$extension(combined, value);
    }
}
/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {undefined}
 */ function $ad13aef915352c90$var$extension(combined, extension) {
    /** @type {keyof Extension} */ let key;
    for(key in extension)if ($ad13aef915352c90$var$own.call(extension, key)) switch(key){
        case 'canContainEols':
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case 'transforms':
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case 'enter':
        case 'exit':
            {
                const right = extension[key];
                if (right) Object.assign(combined[key], right);
                break;
            }
    }
}
/** @type {OnEnterError} */ function $ad13aef915352c90$var$defaultOnError(left, right) {
    if (left) throw new Error('Cannot close `' + left.type + '` (' + (0, $c5c5a0aadce33baf$export$c304dd45fe166145)({
        start: left.start,
        end: left.end
    }) + '): a different token (`' + right.type + '`, ' + (0, $c5c5a0aadce33baf$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is open');
    else throw new Error('Cannot close document, a token (`' + right.type + '`, ' + (0, $c5c5a0aadce33baf$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is still open');
}


/**
 * @import {Info, Join, Options, SafeConfig, State} from 'mdast-util-to-markdown'
 * @import {Nodes} from 'mdast'
 * @import {Enter, FlowParents, PhrasingParents, TrackFields} from './types.js'
 */ /**
 * @callback Handler
 *   Handle a value, with a certain ID field set to a certain value.
 *   The ID field is passed to `zwitch`, and it’s value is this function’s
 *   place on the `handlers` record.
 * @param {...any} parameters
 *   Arbitrary parameters passed to the zwitch.
 *   The first will be an object with a certain ID field set to a certain value.
 * @returns {any}
 *   Anything!
 */ /**
 * @callback UnknownHandler
 *   Handle values that do have a certain ID field, but it’s set to a value
 *   that is not listed in the `handlers` record.
 * @param {unknown} value
 *   An object with a certain ID field set to an unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {any}
 *   Anything!
 */ /**
 * @callback InvalidHandler
 *   Handle values that do not have a certain ID field.
 * @param {unknown} value
 *   Any unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {void|null|undefined|never}
 *   This should crash or return nothing.
 */ /**
 * @template {InvalidHandler} [Invalid=InvalidHandler]
 * @template {UnknownHandler} [Unknown=UnknownHandler]
 * @template {Record<string, Handler>} [Handlers=Record<string, Handler>]
 * @typedef Options
 *   Configuration (required).
 * @property {Invalid} [invalid]
 *   Handler to use for invalid values.
 * @property {Unknown} [unknown]
 *   Handler to use for unknown values.
 * @property {Handlers} [handlers]
 *   Handlers to use.
 */ const $71ff91a92c658015$var$own = {}.hasOwnProperty;
function $71ff91a92c658015$export$d6a12bfbbedf6185(key, options) {
    const settings = options || {};
    /**
   * Handle one value.
   *
   * Based on the bound `key`, a respective handler will be called.
   * If `value` is not an object, or doesn’t have a `key` property, the special
   * “invalid” handler will be called.
   * If `value` has an unknown `key`, the special “unknown” handler will be
   * called.
   *
   * All arguments, and the context object, are passed through to the handler,
   * and it’s result is returned.
   *
   * @this {unknown}
   *   Any context object.
   * @param {unknown} [value]
   *   Any value.
   * @param {...unknown} parameters
   *   Arbitrary parameters passed to the zwitch.
   * @property {Handler} invalid
   *   Handle for values that do not have a certain ID field.
   * @property {Handler} unknown
   *   Handle values that do have a certain ID field, but it’s set to a value
   *   that is not listed in the `handlers` record.
   * @property {Handlers} handlers
   *   Record of handlers.
   * @returns {unknown}
   *   Anything.
   */ function one(value, ...parameters) {
        /** @type {Handler|undefined} */ let fn = one.invalid;
        const handlers = one.handlers;
        if (value && $71ff91a92c658015$var$own.call(value, key)) {
            // @ts-expect-error Indexable.
            const id = String(value[key]);
            // @ts-expect-error Indexable.
            fn = $71ff91a92c658015$var$own.call(handlers, id) ? handlers[id] : one.unknown;
        }
        if (fn) return fn.call(this, value, ...parameters);
    }
    one.handlers = settings.handlers || {};
    one.invalid = settings.invalid;
    one.unknown = settings.unknown;
    // @ts-expect-error: matches!
    return one;
}


/**
 * @import {Options, State} from './types.js'
 */ const $0a6f90e7ce2a3f23$var$own = {}.hasOwnProperty;
function $0a6f90e7ce2a3f23$export$8d21e34596265fa2(base, extension) {
    let index = -1;
    /** @type {keyof Options} */ let key;
    // First do subextensions.
    if (extension.extensions) while(++index < extension.extensions.length)$0a6f90e7ce2a3f23$export$8d21e34596265fa2(base, extension.extensions[index]);
    for(key in extension)if ($0a6f90e7ce2a3f23$var$own.call(extension, key)) switch(key){
        case 'extensions':
            break;
        /* c8 ignore next 4 */ case 'unsafe':
            $0a6f90e7ce2a3f23$var$list(base[key], extension[key]);
            break;
        case 'join':
            $0a6f90e7ce2a3f23$var$list(base[key], extension[key]);
            break;
        case 'handlers':
            $0a6f90e7ce2a3f23$var$map(base[key], extension[key]);
            break;
        default:
            // @ts-expect-error: matches.
            base.options[key] = extension[key];
    }
    return base;
}
/**
 * @template T
 * @param {Array<T>} left
 * @param {Array<T> | null | undefined} right
 */ function $0a6f90e7ce2a3f23$var$list(left, right) {
    if (right) left.push(...right);
}
/**
 * @template T
 * @param {Record<string, T>} left
 * @param {Record<string, T> | null | undefined} right
 */ function $0a6f90e7ce2a3f23$var$map(left, right) {
    if (right) Object.assign(left, right);
}


/**
 * @import {Blockquote, Parents} from 'mdast'
 * @import {Info, Map, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {Blockquote} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $9d5451e7ae89b6b8$export$67dc04e652a298ca(node, _, state, info) {
    const exit = state.enter('blockquote');
    const tracker = state.createTracker(info);
    tracker.move('> ');
    tracker.shift(2);
    const value = state.indentLines(state.containerFlow(node, tracker.current()), $9d5451e7ae89b6b8$var$map);
    exit();
    return value;
}
/** @type {Map} */ function $9d5451e7ae89b6b8$var$map(line, _, blank) {
    return '>' + (blank ? '' : ' ') + line;
}


/**
 * @import {Break, Parents} from 'mdast'
 * @import {Info, State} from 'mdast-util-to-markdown'
 */ /**
 * @import {ConstructName, Unsafe} from 'mdast-util-to-markdown'
 */ /**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe} pattern
 * @returns {boolean}
 */ function $dd92cdb511958ba4$export$78221a09424368d(stack, pattern) {
    return $dd92cdb511958ba4$var$listInScope(stack, pattern.inConstruct, true) && !$dd92cdb511958ba4$var$listInScope(stack, pattern.notInConstruct, false);
}
/**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe['inConstruct']} list
 * @param {boolean} none
 * @returns {boolean}
 */ function $dd92cdb511958ba4$var$listInScope(stack, list, none) {
    if (typeof list === 'string') list = [
        list
    ];
    if (!list || list.length === 0) return none;
    let index = -1;
    while(++index < list.length){
        if (stack.includes(list[index])) return true;
    }
    return false;
}


function $36d16a470f256c7d$export$371da9dd35aba193(_, _1, state, info) {
    let index = -1;
    while(++index < state.unsafe.length){
        // If we can’t put eols in this construct (setext headings, tables), use a
        // space instead.
        if (state.unsafe[index].character === '\n' && (0, $dd92cdb511958ba4$export$78221a09424368d)(state.stack, state.unsafe[index])) return /[ \t]/.test(info.before) ? '' : ' ';
    }
    return '\\\n';
}


/**
 * @import {Info, Map, State} from 'mdast-util-to-markdown'
 * @import {Code, Parents} from 'mdast'
 */ /**
 * Get the count of the longest repeating streak of `substring` in `value`.
 *
 * @param {string} value
 *   Content to search in.
 * @param {string} substring
 *   Substring to look for, typically one character.
 * @returns {number}
 *   Count of most frequent adjacent `substring`s in `value`.
 */ function $fd9ca3ec95631066$export$711675ff42d864f2(value, substring) {
    const source = String(value);
    let index = source.indexOf(substring);
    let expected = index;
    let count = 0;
    let max = 0;
    if (typeof substring !== 'string') throw new TypeError('Expected substring');
    while(index !== -1){
        if (index === expected) {
            if (++count > max) max = count;
        } else count = 1;
        expected = index + substring.length;
        index = source.indexOf(substring, expected);
    }
    return max;
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Code} from 'mdast'
 */ /**
 * @param {Code} node
 * @param {State} state
 * @returns {boolean}
 */ function $947135d4c23ee652$export$8c0df78a8cad9f4b(node, state) {
    return Boolean(state.options.fences === false && node.value && // If there’s no info…
    !node.lang && // And there’s a non-whitespace character…
    /[^ \r\n]/.test(node.value) && // And the value doesn’t start or end in a blank…
    !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(node.value));
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['fence'], null | undefined>}
 */ function $d9a92cee4d3db606$export$7487ee7cbb2e2919(state) {
    const marker = state.options.fence || '`';
    if (marker !== '`' && marker !== '~') throw new Error('Cannot serialize code with `' + marker + '` for `options.fence`, expected `` ` `` or `~`');
    return marker;
}


function $680fca88e6a805bd$export$6565f9f03506010b(node, _, state, info) {
    const marker = (0, $d9a92cee4d3db606$export$7487ee7cbb2e2919)(state);
    const raw = node.value || '';
    const suffix = marker === '`' ? 'GraveAccent' : 'Tilde';
    if ((0, $947135d4c23ee652$export$8c0df78a8cad9f4b)(node, state)) {
        const exit = state.enter('codeIndented');
        const value = state.indentLines(raw, $680fca88e6a805bd$var$map);
        exit();
        return value;
    }
    const tracker = state.createTracker(info);
    const sequence = marker.repeat(Math.max((0, $fd9ca3ec95631066$export$711675ff42d864f2)(raw, marker) + 1, 3));
    const exit = state.enter('codeFenced');
    let value = tracker.move(sequence);
    if (node.lang) {
        const subexit = state.enter(`codeFencedLang${suffix}`);
        value += tracker.move(state.safe(node.lang, {
            before: value,
            after: ' ',
            encode: [
                '`'
            ],
            ...tracker.current()
        }));
        subexit();
    }
    if (node.lang && node.meta) {
        const subexit = state.enter(`codeFencedMeta${suffix}`);
        value += tracker.move(' ');
        value += tracker.move(state.safe(node.meta, {
            before: value,
            after: '\n',
            encode: [
                '`'
            ],
            ...tracker.current()
        }));
        subexit();
    }
    value += tracker.move('\n');
    if (raw) value += tracker.move(raw + '\n');
    value += tracker.move(sequence);
    exit();
    return value;
}
/** @type {Map} */ function $680fca88e6a805bd$var$map(line, _, blank) {
    return (blank ? '' : '    ') + line;
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Definition, Parents} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['quote'], null | undefined>}
 */ function $c371c4ca1e2c35f8$export$7aeba63896b2719(state) {
    const marker = state.options.quote || '"';
    if (marker !== '"' && marker !== "'") throw new Error('Cannot serialize title with `' + marker + '` for `options.quote`, expected `"`, or `\'`');
    return marker;
}


function $96ee42e08af1271f$export$69f215ed977cdb73(node, _, state, info) {
    const quote = (0, $c371c4ca1e2c35f8$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
    const exit = state.enter('definition');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('[');
    value += tracker.move(state.safe(state.associationId(node), {
        before: value,
        after: ']',
        ...tracker.current()
    }));
    value += tracker.move(']: ');
    subexit();
    if (// If there’s no url, or…
    !node.url || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter('destinationLiteral');
        value += tracker.move('<');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: '>',
            ...tracker.current()
        }));
        value += tracker.move('>');
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter('destinationRaw');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: node.title ? ' ' : '\n',
            ...tracker.current()
        }));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(' ' + quote);
        value += tracker.move(state.safe(node.title, {
            before: value,
            after: quote,
            ...tracker.current()
        }));
        value += tracker.move(quote);
        subexit();
    }
    exit();
    return value;
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Emphasis, Parents} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['emphasis'], null | undefined>}
 */ function $2bd3375c7f42b4a2$export$f967eb786dea04e7(state) {
    const marker = state.options.emphasis || '*';
    if (marker !== '*' && marker !== '_') throw new Error('Cannot serialize emphasis with `' + marker + '` for `options.emphasis`, expected `*`, or `_`');
    return marker;
}


/**
 * Encode a code point as a character reference.
 *
 * @param {number} code
 *   Code point to encode.
 * @returns {string}
 *   Encoded character reference.
 */ function $2a128b680e0858ff$export$5810cf1e579e9d5b(code) {
    return '&#x' + code.toString(16).toUpperCase() + ';';
}


/**
 * @import {EncodeSides} from '../types.js'
 */ 
function $59e8cd5c59b050f3$export$b444be54825dd0b6(outside, inside, marker) {
    const outsideKind = (0, $0cf80314fdbe73de$export$e3902bc0d835cad0)(outside);
    const insideKind = (0, $0cf80314fdbe73de$export$e3902bc0d835cad0)(inside);
    // Letter outside:
    if (outsideKind === undefined) return insideKind === undefined ? // we have to encode *both* letters for `_` as it is looser.
    // it already forms for `*` (and GFMs `~`).
    marker === '_' ? {
        inside: true,
        outside: true
    } : {
        inside: false,
        outside: false
    } : insideKind === 1 ? {
        inside: true,
        outside: true
    } : {
        inside: false,
        outside: true
    };
    // Whitespace outside:
    if (outsideKind === 1) return insideKind === undefined ? {
        inside: false,
        outside: false
    } : insideKind === 1 ? {
        inside: true,
        outside: true
    } : {
        inside: false,
        outside: false
    };
    // Punctuation outside:
    return insideKind === undefined ? {
        inside: false,
        outside: false
    } : insideKind === 1 ? {
        inside: true,
        outside: false
    } : {
        inside: false,
        outside: false
    };
}


$ab9ca22207bf06bf$export$bef81ba411953b51.peek = $ab9ca22207bf06bf$var$emphasisPeek;
function $ab9ca22207bf06bf$export$bef81ba411953b51(node, _, state, info) {
    const marker = (0, $2bd3375c7f42b4a2$export$f967eb786dea04e7)(state);
    const exit = state.enter('emphasis');
    const tracker = state.createTracker(info);
    const before = tracker.move(marker);
    let between = tracker.move(state.containerPhrasing(node, {
        after: marker,
        before: before,
        ...tracker.current()
    }));
    const betweenHead = between.charCodeAt(0);
    const open = (0, $59e8cd5c59b050f3$export$b444be54825dd0b6)(info.before.charCodeAt(info.before.length - 1), betweenHead, marker);
    if (open.inside) between = (0, $2a128b680e0858ff$export$5810cf1e579e9d5b)(betweenHead) + between.slice(1);
    const betweenTail = between.charCodeAt(between.length - 1);
    const close = (0, $59e8cd5c59b050f3$export$b444be54825dd0b6)(info.after.charCodeAt(0), betweenTail, marker);
    if (close.inside) between = between.slice(0, -1) + (0, $2a128b680e0858ff$export$5810cf1e579e9d5b)(betweenTail);
    const after = tracker.move(marker);
    exit();
    state.attentionEncodeSurroundingInfo = {
        after: close.outside,
        before: open.outside
    };
    return before + between + after;
}
/**
 * @param {Emphasis} _
 * @param {Parents | undefined} _1
 * @param {State} state
 * @returns {string}
 */ function $ab9ca22207bf06bf$var$emphasisPeek(_, _1, state) {
    return state.options.emphasis || '*';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Heading, Parents} from 'mdast'
 */ 
/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Heading} from 'mdast'
 */ /**
 * @typedef {import('unist').Node} UnistNode
 * @typedef {import('unist').Parent} UnistParent
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ /**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends Array<any>
 *   ? MatchesOne<Value, Check[keyof Check]>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {InternalAncestor<InclusiveDescendant<Tree>, Child>} Ancestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {'skip' | boolean} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<VisitedParents>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [VisitedParents=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Matches<InclusiveDescendant<Tree>, Check>, Ancestor<Tree, Matches<InclusiveDescendant<Tree>, Check>>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Tree type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 */ /**
 * @template Fn
 * @template Fallback
 * @typedef {Fn extends (value: any) => value is infer Thing ? Thing : Fallback} Predicate
 */ /**
 * @callback Check
 *   Check that an arbitrary value is a node.
 * @param {unknown} this
 *   The given context.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 *
 * @typedef {Record<string, unknown> | Node} Props
 *   Object to check for equivalence.
 *
 *   Note: `Node` is included as it is common but is not indexable.
 *
 * @typedef {Array<Props | TestFunction | string> | Props | TestFunction | string | null | undefined} Test
 *   Check for an arbitrary node.
 *
 * @callback TestFunction
 *   Check if a node passes a test.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | undefined | void}
 *   Whether this node passes the test.
 *
 *   Note: `void` is included until TS sees no return as `undefined`.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param {unknown} node
 *   Thing to check, typically `Node`.
 * @param {Test} test
 *   A check for a specific node.
 * @param {number | null | undefined} index
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} parent
 *   The node’s parent.
 * @param {unknown} context
 *   Context object (`this`) to pass to `test` functions.
 * @returns {boolean}
 *   Whether `node` is a node and passes a test.
 */ const $8e5c042dfb772d94$export$226b3eccf92c9ed9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends string>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((node?: null | undefined) => false) &
   *   ((node: unknown, test?: null | undefined, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((node: unknown, test?: Test, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function(node, test, index, parent, context) {
    const check = $8e5c042dfb772d94$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== 'number' || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error('Expected positive finite index');
    if (parent !== undefined && parent !== null && (!$8e5c042dfb772d94$export$226b3eccf92c9ed9(parent) || !parent.children)) throw new Error('Expected parent node');
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error('Expected both parent and index');
    return $8e5c042dfb772d94$var$looksLikeANode(node) ? check.call(context, node, index, parent) : false;
};
const $8e5c042dfb772d94$export$9c68d69a4c5bbcf9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {Check}
     */ function(test) {
    if (test === null || test === undefined) return $8e5c042dfb772d94$var$ok;
    if (typeof test === 'function') return $8e5c042dfb772d94$var$castFactory(test);
    if (typeof test === 'object') return Array.isArray(test) ? $8e5c042dfb772d94$var$anyFactory(test) : $8e5c042dfb772d94$var$propsFactory(test);
    if (typeof test === 'string') return $8e5c042dfb772d94$var$typeFactory(test);
    throw new Error('Expected function, string, or object as test');
};
/**
 * @param {Array<Props | TestFunction | string>} tests
 * @returns {Check}
 */ function $8e5c042dfb772d94$var$anyFactory(tests) {
    /** @type {Array<Check>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $8e5c042dfb772d94$export$9c68d69a4c5bbcf9(tests[index]);
    return $8e5c042dfb772d94$var$castFactory(any);
    /**
   * @this {unknown}
   * @type {TestFunction}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].apply(this, parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {Check}
 */ function $8e5c042dfb772d94$var$propsFactory(check) {
    const checkAsRecord = /** @type {Record<string, unknown>} */ check;
    return $8e5c042dfb772d94$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        const nodeAsRecord = /** @type {unknown} */ node;
        /** @type {string} */ let key;
        for(key in check){
            if (nodeAsRecord[key] !== checkAsRecord[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {Check}
 */ function $8e5c042dfb772d94$var$typeFactory(check) {
    return $8e5c042dfb772d94$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunction} testFunction
 * @returns {Check}
 */ function $8e5c042dfb772d94$var$castFactory(testFunction) {
    return check;
    /**
   * @this {unknown}
   * @type {Check}
   */ function check(value, index, parent) {
        return Boolean($8e5c042dfb772d94$var$looksLikeANode(value) && testFunction.call(this, value, typeof index === 'number' ? index : undefined, parent || undefined));
    }
}
function $8e5c042dfb772d94$var$ok() {
    return true;
}
/**
 * @param {unknown} value
 * @returns {value is Node}
 */ function $8e5c042dfb772d94$var$looksLikeANode(value) {
    return value !== null && typeof value === 'object' && 'type' in value;
}


/**
 * @param {string} d
 * @returns {string}
 */ function $dfb868b7fa2e368d$export$35e9368ef982300f(d) {
    return d;
}


/** @type {Readonly<ActionTuple>} */ const $fcc69681d67bfcdc$var$empty = [];
const $fcc69681d67bfcdc$export$f4d8133c446fe484 = true;
const $fcc69681d67bfcdc$export$7f100f842f565dc9 = false;
const $fcc69681d67bfcdc$export$8773f85c2fb2c116 = 'skip';
function $fcc69681d67bfcdc$export$70008a21eb6de899(tree, test, visitor, reverse) {
    /** @type {Test} */ let check;
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
    } else // @ts-expect-error visitor given, so `test` isn’t a visitor.
    check = test;
    const is = (0, $8e5c042dfb772d94$export$9c68d69a4c5bbcf9)(check);
    const step = reverse ? -1 : 1;
    factory(tree, undefined, [])();
    /**
   * @param {UnistNode} node
   * @param {number | undefined} index
   * @param {Array<UnistParent>} parents
   */ function factory(node, index, parents) {
        const value = /** @type {Record<string, unknown>} */ node && typeof node === 'object' ? node : {};
        if (typeof value.type === 'string') {
            const name = // `hast`
            typeof value.tagName === 'string' ? value.tagName : typeof value.name === 'string' ? value.name : undefined;
            Object.defineProperty(visit, 'name', {
                value: 'node (' + (0, $dfb868b7fa2e368d$export$35e9368ef982300f)(node.type + (name ? '<' + name + '>' : '')) + ')'
            });
        }
        return visit;
        function visit() {
            /** @type {Readonly<ActionTuple>} */ let result = $fcc69681d67bfcdc$var$empty;
            /** @type {Readonly<ActionTuple>} */ let subresult;
            /** @type {number} */ let offset;
            /** @type {Array<UnistParent>} */ let grandparents;
            if (!test || is(node, index, parents[parents.length - 1] || undefined)) {
                // @ts-expect-error: `visitor` is now a visitor.
                result = $fcc69681d67bfcdc$var$toResult(visitor(node, parents));
                if (result[0] === $fcc69681d67bfcdc$export$7f100f842f565dc9) return result;
            }
            if ('children' in node && node.children) {
                const nodeAsParent = /** @type {UnistParent} */ node;
                if (nodeAsParent.children && result[0] !== $fcc69681d67bfcdc$export$8773f85c2fb2c116) {
                    offset = (reverse ? nodeAsParent.children.length : -1) + step;
                    grandparents = parents.concat(nodeAsParent);
                    while(offset > -1 && offset < nodeAsParent.children.length){
                        const child = nodeAsParent.children[offset];
                        subresult = factory(child, offset, grandparents)();
                        if (subresult[0] === $fcc69681d67bfcdc$export$7f100f842f565dc9) return subresult;
                        offset = typeof subresult[1] === 'number' ? subresult[1] : offset + step;
                    }
                }
            }
            return result;
        }
    }
}
/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {Readonly<ActionTuple>}
 *   Clean result.
 */ function $fcc69681d67bfcdc$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === 'number') return [
        $fcc69681d67bfcdc$export$f4d8133c446fe484,
        value
    ];
    return value === null || value === undefined ? $fcc69681d67bfcdc$var$empty : [
        value
    ];
}

/**
 * @typedef {import('unist').Node} UnistNode
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ // To do: use types from `unist-util-visit-parents` when it’s released.
/**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends Array<any>
 *   ? MatchesOne<Value, Check[keyof Check]>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends UnistNode ? number | undefined : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends UnistParent ? Ancestor | undefined : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [Ancestor=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Visited, Parent<Ancestor, Visited>>} BuildVisitorFromMatch
 *   Build a typed `Visitor` function from a node and all possible parents.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Visited
 *   Node type.
 * @template {UnistParent} Ancestor
 *   Parent type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     Matches<Descendant, Check>,
 *     Extract<Descendant, UnistParent>
 *   >
 * )} BuildVisitorFromDescendants
 *   Build a typed `Visitor` function from a list of descendants and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Node type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ 
function $fec995af51c20885$export$bf638b60ea8b89b7(tree, testOrVisitor, visitorOrReverse, maybeReverse) {
    /** @type {boolean | null | undefined} */ let reverse;
    /** @type {Test} */ let test;
    /** @type {Visitor} */ let visitor;
    if (typeof testOrVisitor === 'function' && typeof visitorOrReverse !== 'function') {
        test = undefined;
        visitor = testOrVisitor;
        reverse = visitorOrReverse;
    } else {
        // @ts-expect-error: assume the overload with test was given.
        test = testOrVisitor;
        // @ts-expect-error: assume the overload with test was given.
        visitor = visitorOrReverse;
        reverse = maybeReverse;
    }
    (0, $fcc69681d67bfcdc$export$70008a21eb6de899)(tree, test, overload, reverse);
    /**
   * @param {UnistNode} node
   * @param {Array<UnistParent>} parents
   */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        const index = parent ? parent.children.indexOf(node) : undefined;
        return visitor(node, index, parent);
    }
}



function $3bb6b062d23809f7$export$78863676235adfbc(node, state) {
    let literalWithBreak = false;
    // Look for literals with a line break.
    // Note that this also
    (0, $fec995af51c20885$export$bf638b60ea8b89b7)(node, function(node) {
        if ('value' in node && /\r?\n|\r/.test(node.value) || node.type === 'break') {
            literalWithBreak = true;
            return 0, $fcc69681d67bfcdc$export$7f100f842f565dc9;
        }
    });
    return Boolean((!node.depth || node.depth < 3) && (0, $c4fd171878a6a851$export$f84e8e69fd4488a5)(node) && (state.options.setext || literalWithBreak));
}


function $d447540a6edee744$export$46e4a324ac90507f(node, _, state, info) {
    const rank = Math.max(Math.min(6, node.depth || 1), 1);
    const tracker = state.createTracker(info);
    if ((0, $3bb6b062d23809f7$export$78863676235adfbc)(node, state)) {
        const exit = state.enter('headingSetext');
        const subexit = state.enter('phrasing');
        const value = state.containerPhrasing(node, {
            ...tracker.current(),
            before: '\n',
            after: '\n'
        });
        subexit();
        exit();
        return value + '\n' + (rank === 1 ? '=' : '-').repeat(// The whole size…
        value.length - // Minus the position of the character after the last EOL (or
        // 0 if there is none)…
        (Math.max(value.lastIndexOf('\r'), value.lastIndexOf('\n')) + 1));
    }
    const sequence = '#'.repeat(rank);
    const exit = state.enter('headingAtx');
    const subexit = state.enter('phrasing');
    // Note: for proper tracking, we should reset the output positions when there
    // is no content returned, because then the space is not output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    tracker.move(sequence + ' ');
    let value = state.containerPhrasing(node, {
        before: '# ',
        after: '\n',
        ...tracker.current()
    });
    if (/^[\t ]/.test(value)) // To do: what effect has the character reference on tracking?
    value = (0, $2a128b680e0858ff$export$5810cf1e579e9d5b)(value.charCodeAt(0)) + value.slice(1);
    value = value ? sequence + ' ' + value : sequence;
    if (state.options.closeAtx) value += ' ' + sequence;
    subexit();
    exit();
    return value;
}


/**
 * @import {Html} from 'mdast'
 */ $8c9a6d6709d1ab41$export$c0bb0b647f701bb5.peek = $8c9a6d6709d1ab41$var$htmlPeek;
function $8c9a6d6709d1ab41$export$c0bb0b647f701bb5(node) {
    return node.value || '';
}
/**
 * @returns {string}
 */ function $8c9a6d6709d1ab41$var$htmlPeek() {
    return '<';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Image, Parents} from 'mdast'
 */ 
$1759c029ff038e9a$export$5c452ff88e35e47d.peek = $1759c029ff038e9a$var$imagePeek;
function $1759c029ff038e9a$export$5c452ff88e35e47d(node, _, state, info) {
    const quote = (0, $c371c4ca1e2c35f8$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
    const exit = state.enter('image');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('![');
    value += tracker.move(state.safe(node.alt, {
        before: value,
        after: ']',
        ...tracker.current()
    }));
    value += tracker.move('](');
    subexit();
    if (// If there’s no url but there is a title…
    !node.url && node.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter('destinationLiteral');
        value += tracker.move('<');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: '>',
            ...tracker.current()
        }));
        value += tracker.move('>');
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter('destinationRaw');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: node.title ? ' ' : ')',
            ...tracker.current()
        }));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(' ' + quote);
        value += tracker.move(state.safe(node.title, {
            before: value,
            after: quote,
            ...tracker.current()
        }));
        value += tracker.move(quote);
        subexit();
    }
    value += tracker.move(')');
    exit();
    return value;
}
/**
 * @returns {string}
 */ function $1759c029ff038e9a$var$imagePeek() {
    return '!';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {ImageReference, Parents} from 'mdast'
 */ $b2cc6c068e3fef43$export$f281796f6bc3b8db.peek = $b2cc6c068e3fef43$var$imageReferencePeek;
function $b2cc6c068e3fef43$export$f281796f6bc3b8db(node, _, state, info) {
    const type = node.referenceType;
    const exit = state.enter('imageReference');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('![');
    const alt = state.safe(node.alt, {
        before: value,
        after: ']',
        ...tracker.current()
    });
    value += tracker.move(alt + '][');
    subexit();
    // Hide the fact that we’re in phrasing, because escapes don’t work.
    const stack = state.stack;
    state.stack = [];
    subexit = state.enter('reference');
    // Note: for proper tracking, we should reset the output positions when we end
    // up making a `shortcut` reference, because then there is no brace output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    const reference = state.safe(state.associationId(node), {
        before: value,
        after: ']',
        ...tracker.current()
    });
    subexit();
    state.stack = stack;
    exit();
    if (type === 'full' || !alt || alt !== reference) value += tracker.move(reference + ']');
    else if (type === 'shortcut') // Remove the unwanted `[`.
    value = value.slice(0, -1);
    else value += tracker.move(']');
    return value;
}
/**
 * @returns {string}
 */ function $b2cc6c068e3fef43$var$imageReferencePeek() {
    return '!';
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {InlineCode, Parents} from 'mdast'
 */ $44c633f3ec775797$export$91b9bee19a0d8569.peek = $44c633f3ec775797$var$inlineCodePeek;
function $44c633f3ec775797$export$91b9bee19a0d8569(node, _, state) {
    let value = node.value || '';
    let sequence = '`';
    let index = -1;
    // If there is a single grave accent on its own in the code, use a fence of
    // two.
    // If there are two in a row, use one.
    while(new RegExp('(^|[^`])' + sequence + '([^`]|$)').test(value))sequence += '`';
    // If this is not just spaces or eols (tabs don’t count), and either the
    // first or last character are a space, eol, or tick, then pad with spaces.
    if (/[^ \r\n]/.test(value) && (/^[ \r\n]/.test(value) && /[ \r\n]$/.test(value) || /^`|`$/.test(value))) value = ' ' + value + ' ';
    // We have a potential problem: certain characters after eols could result in
    // blocks being seen.
    // For example, if someone injected the string `'\n# b'`, then that would
    // result in an ATX heading.
    // We can’t escape characters in `inlineCode`, but because eols are
    // transformed to spaces when going from markdown to HTML anyway, we can swap
    // them out.
    while(++index < state.unsafe.length){
        const pattern = state.unsafe[index];
        const expression = state.compilePattern(pattern);
        /** @type {RegExpExecArray | null} */ let match;
        // Only look for `atBreak`s.
        // Btw: note that `atBreak` patterns will always start the regex at LF or
        // CR.
        if (!pattern.atBreak) continue;
        while(match = expression.exec(value)){
            let position = match.index;
            // Support CRLF (patterns only look for one of the characters).
            if (value.charCodeAt(position) === 10 /* `\n` */  && value.charCodeAt(position - 1) === 13 /* `\r` */ ) position--;
            value = value.slice(0, position) + ' ' + value.slice(match.index + 1);
        }
    }
    return sequence + value + sequence;
}
/**
 * @returns {string}
 */ function $44c633f3ec775797$var$inlineCodePeek() {
    return '`';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Link, Parents} from 'mdast'
 * @import {Exit} from '../types.js'
 */ 
/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Link} from 'mdast'
 */ 
function $181369601bbb2356$export$74cae3045e3179ed(node, state) {
    const raw = (0, $c4fd171878a6a851$export$f84e8e69fd4488a5)(node);
    return Boolean(!state.options.resourceLink && // If there’s a url…
    node.url && // And there’s a no title…
    !node.title && // And the content of `node` is a single text node…
    node.children && node.children.length === 1 && node.children[0].type === 'text' && // And if the url is the same as the content…
    (raw === node.url || 'mailto:' + raw === node.url) && // And that starts w/ a protocol…
    /^[a-z][a-z+.-]+:/i.test(node.url) && // And that doesn’t contain ASCII control codes (character escapes and
    // references don’t work), space, or angle brackets…
    !/[\0- <>\u007F]/.test(node.url));
}


$89b350eabf24fd7e$export$9c30223ca0a664fb.peek = $89b350eabf24fd7e$var$linkPeek;
function $89b350eabf24fd7e$export$9c30223ca0a664fb(node, _, state, info) {
    const quote = (0, $c371c4ca1e2c35f8$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
    const tracker = state.createTracker(info);
    /** @type {Exit} */ let exit;
    /** @type {Exit} */ let subexit;
    if ((0, $181369601bbb2356$export$74cae3045e3179ed)(node, state)) {
        // Hide the fact that we’re in phrasing, because escapes don’t work.
        const stack = state.stack;
        state.stack = [];
        exit = state.enter('autolink');
        let value = tracker.move('<');
        value += tracker.move(state.containerPhrasing(node, {
            before: value,
            after: '>',
            ...tracker.current()
        }));
        value += tracker.move('>');
        exit();
        state.stack = stack;
        return value;
    }
    exit = state.enter('link');
    subexit = state.enter('label');
    let value = tracker.move('[');
    value += tracker.move(state.containerPhrasing(node, {
        before: value,
        after: '](',
        ...tracker.current()
    }));
    value += tracker.move('](');
    subexit();
    if (// If there’s no url but there is a title…
    !node.url && node.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter('destinationLiteral');
        value += tracker.move('<');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: '>',
            ...tracker.current()
        }));
        value += tracker.move('>');
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter('destinationRaw');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: node.title ? ' ' : ')',
            ...tracker.current()
        }));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(' ' + quote);
        value += tracker.move(state.safe(node.title, {
            before: value,
            after: quote,
            ...tracker.current()
        }));
        value += tracker.move(quote);
        subexit();
    }
    value += tracker.move(')');
    exit();
    return value;
}
/**
 * @param {Link} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @returns {string}
 */ function $89b350eabf24fd7e$var$linkPeek(node, _, state) {
    return (0, $181369601bbb2356$export$74cae3045e3179ed)(node, state) ? '<' : '[';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {LinkReference, Parents} from 'mdast'
 */ $a2d1e6e7b89f3eaf$export$e6c469b1b7b2bc6a.peek = $a2d1e6e7b89f3eaf$var$linkReferencePeek;
function $a2d1e6e7b89f3eaf$export$e6c469b1b7b2bc6a(node, _, state, info) {
    const type = node.referenceType;
    const exit = state.enter('linkReference');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('[');
    const text = state.containerPhrasing(node, {
        before: value,
        after: ']',
        ...tracker.current()
    });
    value += tracker.move(text + '][');
    subexit();
    // Hide the fact that we’re in phrasing, because escapes don’t work.
    const stack = state.stack;
    state.stack = [];
    subexit = state.enter('reference');
    // Note: for proper tracking, we should reset the output positions when we end
    // up making a `shortcut` reference, because then there is no brace output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    const reference = state.safe(state.associationId(node), {
        before: value,
        after: ']',
        ...tracker.current()
    });
    subexit();
    state.stack = stack;
    exit();
    if (type === 'full' || !text || text !== reference) value += tracker.move(reference + ']');
    else if (type === 'shortcut') // Remove the unwanted `[`.
    value = value.slice(0, -1);
    else value += tracker.move(']');
    return value;
}
/**
 * @returns {string}
 */ function $a2d1e6e7b89f3eaf$var$linkReferencePeek() {
    return '[';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {List, Parents} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['bullet'], null | undefined>}
 */ function $b5e5bedf6160cf3c$export$7425517207a4d0ae(state) {
    const marker = state.options.bullet || '*';
    if (marker !== '*' && marker !== '+' && marker !== '-') throw new Error('Cannot serialize items with `' + marker + '` for `options.bullet`, expected `*`, `+`, or `-`');
    return marker;
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ 
function $91efab6fd8487b6f$export$e6803bf0889262a1(state) {
    const bullet = (0, $b5e5bedf6160cf3c$export$7425517207a4d0ae)(state);
    const bulletOther = state.options.bulletOther;
    if (!bulletOther) return bullet === '*' ? '-' : '*';
    if (bulletOther !== '*' && bulletOther !== '+' && bulletOther !== '-') throw new Error('Cannot serialize items with `' + bulletOther + '` for `options.bulletOther`, expected `*`, `+`, or `-`');
    if (bulletOther === bullet) throw new Error('Expected `bullet` (`' + bullet + '`) and `bulletOther` (`' + bulletOther + '`) to be different');
    return bulletOther;
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['bulletOrdered'], null | undefined>}
 */ function $816be9e589b99e1b$export$98d522b78eddc19b(state) {
    const marker = state.options.bulletOrdered || '.';
    if (marker !== '.' && marker !== ')') throw new Error('Cannot serialize items with `' + marker + '` for `options.bulletOrdered`, expected `.` or `)`');
    return marker;
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['rule'], null | undefined>}
 */ function $9e22f4e940f6c24b$export$d8d533ef24dba866(state) {
    const marker = state.options.rule || '*';
    if (marker !== '*' && marker !== '-' && marker !== '_') throw new Error('Cannot serialize rules with `' + marker + '` for `options.rule`, expected `*`, `-`, or `_`');
    return marker;
}


function $a3fe7b0c12547a0e$export$8837f4fc672e936d(node, parent, state, info) {
    const exit = state.enter('list');
    const bulletCurrent = state.bulletCurrent;
    /** @type {string} */ let bullet = node.ordered ? (0, $816be9e589b99e1b$export$98d522b78eddc19b)(state) : (0, $b5e5bedf6160cf3c$export$7425517207a4d0ae)(state);
    /** @type {string} */ const bulletOther = node.ordered ? bullet === '.' ? ')' : '.' : (0, $91efab6fd8487b6f$export$e6803bf0889262a1)(state);
    let useDifferentMarker = parent && state.bulletLastUsed ? bullet === state.bulletLastUsed : false;
    if (!node.ordered) {
        const firstListItem = node.children ? node.children[0] : undefined;
        // If there’s an empty first list item directly in two list items,
        // we have to use a different bullet:
        //
        // ```markdown
        // * - *
        // ```
        //
        // …because otherwise it would become one big thematic break.
        if (// Bullet could be used as a thematic break marker:
        (bullet === '*' || bullet === '-') && // Empty first list item:
        firstListItem && (!firstListItem.children || !firstListItem.children[0]) && // Directly in two other list items:
        state.stack[state.stack.length - 1] === 'list' && state.stack[state.stack.length - 2] === 'listItem' && state.stack[state.stack.length - 3] === 'list' && state.stack[state.stack.length - 4] === 'listItem' && // That are each the first child.
        state.indexStack[state.indexStack.length - 1] === 0 && state.indexStack[state.indexStack.length - 2] === 0 && state.indexStack[state.indexStack.length - 3] === 0) useDifferentMarker = true;
        // If there’s a thematic break at the start of the first list item,
        // we have to use a different bullet:
        //
        // ```markdown
        // * ---
        // ```
        //
        // …because otherwise it would become one big thematic break.
        if ((0, $9e22f4e940f6c24b$export$d8d533ef24dba866)(state) === bullet && firstListItem) {
            let index = -1;
            while(++index < node.children.length){
                const item = node.children[index];
                if (item && item.type === 'listItem' && item.children && item.children[0] && item.children[0].type === 'thematicBreak') {
                    useDifferentMarker = true;
                    break;
                }
            }
        }
    }
    if (useDifferentMarker) bullet = bulletOther;
    state.bulletCurrent = bullet;
    const value = state.containerFlow(node, info);
    state.bulletLastUsed = bullet;
    state.bulletCurrent = bulletCurrent;
    exit();
    return value;
}


/**
 * @import {Info, Map, State} from 'mdast-util-to-markdown'
 * @import {ListItem, Parents} from 'mdast'
 */ 
/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['listItemIndent'], null | undefined>}
 */ function $f2e656ca2372a5e1$export$2d5358b63da92261(state) {
    const style = state.options.listItemIndent || 'one';
    if (style !== 'tab' && style !== 'one' && style !== 'mixed') throw new Error('Cannot serialize items with `' + style + '` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`');
    return style;
}


function $81b322d2c8e91d4b$export$76c7e83ecc9cdf05(node, parent, state, info) {
    const listItemIndent = (0, $f2e656ca2372a5e1$export$2d5358b63da92261)(state);
    let bullet = state.bulletCurrent || (0, $b5e5bedf6160cf3c$export$7425517207a4d0ae)(state);
    // Add the marker value for ordered lists.
    if (parent && parent.type === 'list' && parent.ordered) bullet = (typeof parent.start === 'number' && parent.start > -1 ? parent.start : 1) + (state.options.incrementListMarker === false ? 0 : parent.children.indexOf(node)) + bullet;
    let size = bullet.length + 1;
    if (listItemIndent === 'tab' || listItemIndent === 'mixed' && (parent && parent.type === 'list' && parent.spread || node.spread)) size = Math.ceil(size / 4) * 4;
    const tracker = state.createTracker(info);
    tracker.move(bullet + ' '.repeat(size - bullet.length));
    tracker.shift(size);
    const exit = state.enter('listItem');
    const value = state.indentLines(state.containerFlow(node, tracker.current()), map);
    exit();
    return value;
    /** @type {Map} */ function map(line, index, blank) {
        if (index) return (blank ? '' : ' '.repeat(size)) + line;
        return (blank ? bullet : bullet + ' '.repeat(size - bullet.length)) + line;
    }
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Paragraph, Parents} from 'mdast'
 */ /**
 * @param {Paragraph} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $d105f1f9ee65bce8$export$9c206ddddb32a9b(node, _, state, info) {
    const exit = state.enter('paragraph');
    const subexit = state.enter('phrasing');
    const value = state.containerPhrasing(node, info);
    subexit();
    exit();
    return value;
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Parents, Root} from 'mdast'
 */ /**
 * @typedef {import('mdast').Html} Html
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 */ 
const $fa60a330ac6749a4$export$444c9dec66a6f08c = /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */ (0, $8e5c042dfb772d94$export$9c68d69a4c5bbcf9)([
    'break',
    'delete',
    'emphasis',
    // To do: next major: removed since footnotes were added to GFM.
    'footnote',
    'footnoteReference',
    'image',
    'imageReference',
    'inlineCode',
    // Enabled by `mdast-util-math`:
    'inlineMath',
    'link',
    'linkReference',
    // Enabled by `mdast-util-mdx`:
    'mdxJsxTextElement',
    // Enabled by `mdast-util-mdx`:
    'mdxTextExpression',
    'strong',
    'text',
    // Enabled by `mdast-util-directive`:
    'textDirective'
]);


function $7282f9db93705e91$export$e8e78c978b129247(node, _, state, info) {
    // Note: `html` nodes are ambiguous.
    const hasPhrasing = node.children.some(function(d) {
        return (0, $fa60a330ac6749a4$export$444c9dec66a6f08c)(d);
    });
    const container = hasPhrasing ? state.containerPhrasing : state.containerFlow;
    return container.call(state, node, info);
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Parents, Strong} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['strong'], null | undefined>}
 */ function $9f4839c5be3a7e5d$export$b7ce17905d66a6c3(state) {
    const marker = state.options.strong || '*';
    if (marker !== '*' && marker !== '_') throw new Error('Cannot serialize strong with `' + marker + '` for `options.strong`, expected `*`, or `_`');
    return marker;
}




$216510496b56f3c7$export$59ae2c325a998f89.peek = $216510496b56f3c7$var$strongPeek;
function $216510496b56f3c7$export$59ae2c325a998f89(node, _, state, info) {
    const marker = (0, $9f4839c5be3a7e5d$export$b7ce17905d66a6c3)(state);
    const exit = state.enter('strong');
    const tracker = state.createTracker(info);
    const before = tracker.move(marker + marker);
    let between = tracker.move(state.containerPhrasing(node, {
        after: marker,
        before: before,
        ...tracker.current()
    }));
    const betweenHead = between.charCodeAt(0);
    const open = (0, $59e8cd5c59b050f3$export$b444be54825dd0b6)(info.before.charCodeAt(info.before.length - 1), betweenHead, marker);
    if (open.inside) between = (0, $2a128b680e0858ff$export$5810cf1e579e9d5b)(betweenHead) + between.slice(1);
    const betweenTail = between.charCodeAt(between.length - 1);
    const close = (0, $59e8cd5c59b050f3$export$b444be54825dd0b6)(info.after.charCodeAt(0), betweenTail, marker);
    if (close.inside) between = between.slice(0, -1) + (0, $2a128b680e0858ff$export$5810cf1e579e9d5b)(betweenTail);
    const after = tracker.move(marker + marker);
    exit();
    state.attentionEncodeSurroundingInfo = {
        after: close.outside,
        before: open.outside
    };
    return before + between + after;
}
/**
 * @param {Strong} _
 * @param {Parents | undefined} _1
 * @param {State} state
 * @returns {string}
 */ function $216510496b56f3c7$var$strongPeek(_, _1, state) {
    return state.options.strong || '*';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Parents, Text} from 'mdast'
 */ /**
 * @param {Text} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $6d8fa2c2b3d5de68$export$6f093cfa640b7166(node, _, state, info) {
    return state.safe(node.value, info);
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Parents, ThematicBreak} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['ruleRepetition'], null | undefined>}
 */ function $5931f533b8b545ed$export$72f02155834d89c4(state) {
    const repetition = state.options.ruleRepetition || 3;
    if (repetition < 3) throw new Error('Cannot serialize rules with repetition `' + repetition + '` for `options.ruleRepetition`, expected `3` or more');
    return repetition;
}



function $7d0c0ec2fd364e5c$export$ba7b13e047416c03(_, _1, state) {
    const value = ((0, $9e22f4e940f6c24b$export$d8d533ef24dba866)(state) + (state.options.ruleSpaces ? ' ' : '')).repeat((0, $5931f533b8b545ed$export$72f02155834d89c4)(state));
    return state.options.ruleSpaces ? value.slice(0, -1) : value;
}


const $e8bbd7b6f4289640$export$8f34ce051745d39e = {
    blockquote: $9d5451e7ae89b6b8$export$67dc04e652a298ca,
    break: (0, $36d16a470f256c7d$export$371da9dd35aba193),
    code: $680fca88e6a805bd$export$6565f9f03506010b,
    definition: $96ee42e08af1271f$export$69f215ed977cdb73,
    emphasis: $ab9ca22207bf06bf$export$bef81ba411953b51,
    hardBreak: $36d16a470f256c7d$export$371da9dd35aba193,
    heading: $d447540a6edee744$export$46e4a324ac90507f,
    html: $8c9a6d6709d1ab41$export$c0bb0b647f701bb5,
    image: $1759c029ff038e9a$export$5c452ff88e35e47d,
    imageReference: $b2cc6c068e3fef43$export$f281796f6bc3b8db,
    inlineCode: $44c633f3ec775797$export$91b9bee19a0d8569,
    link: $89b350eabf24fd7e$export$9c30223ca0a664fb,
    linkReference: $a2d1e6e7b89f3eaf$export$e6c469b1b7b2bc6a,
    list: $a3fe7b0c12547a0e$export$8837f4fc672e936d,
    listItem: $81b322d2c8e91d4b$export$76c7e83ecc9cdf05,
    paragraph: $d105f1f9ee65bce8$export$9c206ddddb32a9b,
    root: $7282f9db93705e91$export$e8e78c978b129247,
    strong: $216510496b56f3c7$export$59ae2c325a998f89,
    text: $6d8fa2c2b3d5de68$export$6f093cfa640b7166,
    thematicBreak: $7d0c0ec2fd364e5c$export$ba7b13e047416c03
};


/**
 * @import {Join} from 'mdast-util-to-markdown'
 */ 

const $21ab7332f764fd98$export$f7e2c8231c57a8bd = [
    $21ab7332f764fd98$var$joinDefaults
];
/** @type {Join} */ function $21ab7332f764fd98$var$joinDefaults(left, right, parent, state) {
    // Indented code after list or another indented code.
    if (right.type === 'code' && (0, $947135d4c23ee652$export$8c0df78a8cad9f4b)(right, state) && (left.type === 'list' || left.type === right.type && (0, $947135d4c23ee652$export$8c0df78a8cad9f4b)(left, state))) return false;
    // Join children of a list or an item.
    // In which case, `parent` has a `spread` field.
    if ('spread' in parent && typeof parent.spread === 'boolean') {
        if (left.type === 'paragraph' && // Two paragraphs.
        (left.type === right.type || right.type === 'definition' || // Paragraph followed by a setext heading.
        right.type === 'heading' && (0, $3bb6b062d23809f7$export$78863676235adfbc)(right, state))) return;
        return parent.spread ? 1 : 0;
    }
}


/**
 * @import {ConstructName, Unsafe} from 'mdast-util-to-markdown'
 */ /**
 * List of constructs that occur in phrasing (paragraphs, headings), but cannot
 * contain things like attention (emphasis, strong), images, or links.
 * So they sort of cancel each other out.
 * Note: could use a better name.
 *
 * @type {Array<ConstructName>}
 */ const $e9c31c3bafab6137$var$fullPhrasingSpans = [
    'autolink',
    'destinationLiteral',
    'destinationRaw',
    'reference',
    'titleQuote',
    'titleApostrophe'
];
const $e9c31c3bafab6137$export$aa1c11b655786597 = [
    {
        character: '\t',
        after: '[\\r\\n]',
        inConstruct: 'phrasing'
    },
    {
        character: '\t',
        before: '[\\r\\n]',
        inConstruct: 'phrasing'
    },
    {
        character: '\t',
        inConstruct: [
            'codeFencedLangGraveAccent',
            'codeFencedLangTilde'
        ]
    },
    {
        character: '\r',
        inConstruct: [
            'codeFencedLangGraveAccent',
            'codeFencedLangTilde',
            'codeFencedMetaGraveAccent',
            'codeFencedMetaTilde',
            'destinationLiteral',
            'headingAtx'
        ]
    },
    {
        character: '\n',
        inConstruct: [
            'codeFencedLangGraveAccent',
            'codeFencedLangTilde',
            'codeFencedMetaGraveAccent',
            'codeFencedMetaTilde',
            'destinationLiteral',
            'headingAtx'
        ]
    },
    {
        character: ' ',
        after: '[\\r\\n]',
        inConstruct: 'phrasing'
    },
    {
        character: ' ',
        before: '[\\r\\n]',
        inConstruct: 'phrasing'
    },
    {
        character: ' ',
        inConstruct: [
            'codeFencedLangGraveAccent',
            'codeFencedLangTilde'
        ]
    },
    // An exclamation mark can start an image, if it is followed by a link or
    // a link reference.
    {
        character: '!',
        after: '\\[',
        inConstruct: 'phrasing',
        notInConstruct: $e9c31c3bafab6137$var$fullPhrasingSpans
    },
    // A quote can break out of a title.
    {
        character: '"',
        inConstruct: 'titleQuote'
    },
    // A number sign could start an ATX heading if it starts a line.
    {
        atBreak: true,
        character: '#'
    },
    {
        character: '#',
        inConstruct: 'headingAtx',
        after: '(?:[\r\n]|$)'
    },
    // Dollar sign and percentage are not used in markdown.
    // An ampersand could start a character reference.
    {
        character: '&',
        after: '[#A-Za-z]',
        inConstruct: 'phrasing'
    },
    // An apostrophe can break out of a title.
    {
        character: "'",
        inConstruct: 'titleApostrophe'
    },
    // A left paren could break out of a destination raw.
    {
        character: '(',
        inConstruct: 'destinationRaw'
    },
    // A left paren followed by `]` could make something into a link or image.
    {
        before: '\\]',
        character: '(',
        inConstruct: 'phrasing',
        notInConstruct: $e9c31c3bafab6137$var$fullPhrasingSpans
    },
    // A right paren could start a list item or break out of a destination
    // raw.
    {
        atBreak: true,
        before: '\\d+',
        character: ')'
    },
    {
        character: ')',
        inConstruct: 'destinationRaw'
    },
    // An asterisk can start thematic breaks, list items, emphasis, strong.
    {
        atBreak: true,
        character: '*',
        after: '(?:[ \t\r\n*])'
    },
    {
        character: '*',
        inConstruct: 'phrasing',
        notInConstruct: $e9c31c3bafab6137$var$fullPhrasingSpans
    },
    // A plus sign could start a list item.
    {
        atBreak: true,
        character: '+',
        after: '(?:[ \t\r\n])'
    },
    // A dash can start thematic breaks, list items, and setext heading
    // underlines.
    {
        atBreak: true,
        character: '-',
        after: '(?:[ \t\r\n-])'
    },
    // A dot could start a list item.
    {
        atBreak: true,
        before: '\\d+',
        character: '.',
        after: '(?:[ \t\r\n]|$)'
    },
    // Slash, colon, and semicolon are not used in markdown for constructs.
    // A less than can start html (flow or text) or an autolink.
    // HTML could start with an exclamation mark (declaration, cdata, comment),
    // slash (closing tag), question mark (instruction), or a letter (tag).
    // An autolink also starts with a letter.
    // Finally, it could break out of a destination literal.
    {
        atBreak: true,
        character: '<',
        after: '[!/?A-Za-z]'
    },
    {
        character: '<',
        after: '[!/?A-Za-z]',
        inConstruct: 'phrasing',
        notInConstruct: $e9c31c3bafab6137$var$fullPhrasingSpans
    },
    {
        character: '<',
        inConstruct: 'destinationLiteral'
    },
    // An equals to can start setext heading underlines.
    {
        atBreak: true,
        character: '='
    },
    // A greater than can start block quotes and it can break out of a
    // destination literal.
    {
        atBreak: true,
        character: '>'
    },
    {
        character: '>',
        inConstruct: 'destinationLiteral'
    },
    // Question mark and at sign are not used in markdown for constructs.
    // A left bracket can start definitions, references, labels,
    {
        atBreak: true,
        character: '['
    },
    {
        character: '[',
        inConstruct: 'phrasing',
        notInConstruct: $e9c31c3bafab6137$var$fullPhrasingSpans
    },
    {
        character: '[',
        inConstruct: [
            'label',
            'reference'
        ]
    },
    // A backslash can start an escape (when followed by punctuation) or a
    // hard break (when followed by an eol).
    // Note: typical escapes are handled in `safe`!
    {
        character: '\\',
        after: '[\\r\\n]',
        inConstruct: 'phrasing'
    },
    // A right bracket can exit labels.
    {
        character: ']',
        inConstruct: [
            'label',
            'reference'
        ]
    },
    // Caret is not used in markdown for constructs.
    // An underscore can start emphasis, strong, or a thematic break.
    {
        atBreak: true,
        character: '_'
    },
    {
        character: '_',
        inConstruct: 'phrasing',
        notInConstruct: $e9c31c3bafab6137$var$fullPhrasingSpans
    },
    // A grave accent can start code (fenced or text), or it can break out of
    // a grave accent code fence.
    {
        atBreak: true,
        character: '`'
    },
    {
        character: '`',
        inConstruct: [
            'codeFencedLangGraveAccent',
            'codeFencedMetaGraveAccent'
        ]
    },
    {
        character: '`',
        inConstruct: 'phrasing',
        notInConstruct: $e9c31c3bafab6137$var$fullPhrasingSpans
    },
    // Left brace, vertical bar, right brace are not used in markdown for
    // constructs.
    // A tilde can start code (fenced).
    {
        atBreak: true,
        character: '~'
    }
];


/**
 * @import {AssociationId} from '../types.js'
 */ 
function $b26291509ac26308$export$c4ca1a6065421754(node) {
    if (node.label || !node.identifier) return node.label || '';
    return (0, $8fa28b090247764d$export$a0fb664af7d0cc44)(node.identifier);
}


/**
 * @import {CompilePattern} from '../types.js'
 */ /**
 * @type {CompilePattern}
 */ function $a6fbed2cac1bb4e4$export$2db8af076f277cbf(pattern) {
    if (!pattern._compiled) {
        const before = (pattern.atBreak ? '[\\r\\n][\\t ]*' : '') + (pattern.before ? '(?:' + pattern.before + ')' : '');
        pattern._compiled = new RegExp((before ? '(' + before + ')' : '') + (/[|\\{}()[\]^$+*?.-]/.test(pattern.character) ? '\\' : '') + pattern.character + (pattern.after ? '(?:' + pattern.after + ')' : ''), 'g');
    }
    return pattern._compiled;
}


/**
 * @import {Handle, Info, State} from 'mdast-util-to-markdown'
 * @import {PhrasingParents} from '../types.js'
 */ 
function $9c0c8f63d162fbf9$export$f4090a9439f37631(parent, state, info) {
    const indexStack = state.indexStack;
    const children = parent.children || [];
    /** @type {Array<string>} */ const results = [];
    let index = -1;
    let before = info.before;
    /** @type {string | undefined} */ let encodeAfter;
    indexStack.push(-1);
    let tracker = state.createTracker(info);
    while(++index < children.length){
        const child = children[index];
        /** @type {string} */ let after;
        indexStack[indexStack.length - 1] = index;
        if (index + 1 < children.length) {
            /** @type {Handle} */ // @ts-expect-error: hush, it’s actually a `zwitch`.
            let handle = state.handle.handlers[children[index + 1].type];
            /** @type {Handle} */ // @ts-expect-error: hush, it’s actually a `zwitch`.
            if (handle && handle.peek) handle = handle.peek;
            after = handle ? handle(children[index + 1], parent, state, {
                before: '',
                after: '',
                ...tracker.current()
            }).charAt(0) : '';
        } else after = info.after;
        // In some cases, html (text) can be found in phrasing right after an eol.
        // When we’d serialize that, in most cases that would be seen as html
        // (flow).
        // As we can’t escape or so to prevent it from happening, we take a somewhat
        // reasonable approach: replace that eol with a space.
        // See: <https://github.com/syntax-tree/mdast-util-to-markdown/issues/15>
        if (results.length > 0 && (before === '\r' || before === '\n') && child.type === 'html') {
            results[results.length - 1] = results[results.length - 1].replace(/(\r?\n|\r)$/, ' ');
            before = ' ';
            // To do: does this work to reset tracker?
            tracker = state.createTracker(info);
            tracker.move(results.join(''));
        }
        let value = state.handle(child, parent, state, {
            ...tracker.current(),
            after: after,
            before: before
        });
        // If we had to encode the first character after the previous node and it’s
        // still the same character,
        // encode it.
        if (encodeAfter && encodeAfter === value.slice(0, 1)) value = (0, $2a128b680e0858ff$export$5810cf1e579e9d5b)(encodeAfter.charCodeAt(0)) + value.slice(1);
        const encodingInfo = state.attentionEncodeSurroundingInfo;
        state.attentionEncodeSurroundingInfo = undefined;
        encodeAfter = undefined;
        // If we have to encode the first character before the current node and
        // it’s still the same character,
        // encode it.
        if (encodingInfo) {
            if (results.length > 0 && encodingInfo.before && before === results[results.length - 1].slice(-1)) results[results.length - 1] = results[results.length - 1].slice(0, -1) + (0, $2a128b680e0858ff$export$5810cf1e579e9d5b)(before.charCodeAt(0));
            if (encodingInfo.after) encodeAfter = after;
        }
        tracker.move(value);
        results.push(value);
        before = value.slice(-1);
    }
    indexStack.pop();
    return results.join('');
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {FlowChildren, FlowParents, TrackFields} from '../types.js'
 */ /**
 * @param {FlowParents} parent
 *   Parent of flow nodes.
 * @param {State} state
 *   Info passed around about the current state.
 * @param {TrackFields} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined by (blank) lines.
 */ function $b9a5d28369b21fc0$export$134f7fdacfea8b16(parent, state, info) {
    const indexStack = state.indexStack;
    const children = parent.children || [];
    const tracker = state.createTracker(info);
    /** @type {Array<string>} */ const results = [];
    let index = -1;
    indexStack.push(-1);
    while(++index < children.length){
        const child = children[index];
        indexStack[indexStack.length - 1] = index;
        results.push(tracker.move(state.handle(child, parent, state, {
            before: '\n',
            after: '\n',
            ...tracker.current()
        })));
        if (child.type !== 'list') state.bulletLastUsed = undefined;
        if (index < children.length - 1) results.push(tracker.move($b9a5d28369b21fc0$var$between(child, children[index + 1], parent, state)));
    }
    indexStack.pop();
    return results.join('');
}
/**
 * @param {FlowChildren} left
 * @param {FlowChildren} right
 * @param {FlowParents} parent
 * @param {State} state
 * @returns {string}
 */ function $b9a5d28369b21fc0$var$between(left, right, parent, state) {
    let index = state.join.length;
    while(index--){
        const result = state.join[index](left, right, parent, state);
        if (result === true || result === 1) break;
        if (typeof result === 'number') return '\n'.repeat(1 + result);
        if (result === false) return '\n\n<!---->\n\n';
    }
    return '\n\n';
}


/**
 * @import {IndentLines} from '../types.js'
 */ const $791d1c85bf3d2cdf$var$eol = /\r?\n|\r/g;
function $791d1c85bf3d2cdf$export$7c3cf23d514b264a(value, map) {
    /** @type {Array<string>} */ const result = [];
    let start = 0;
    let line = 0;
    /** @type {RegExpExecArray | null} */ let match;
    while(match = $791d1c85bf3d2cdf$var$eol.exec(value)){
        one(value.slice(start, match.index));
        result.push(match[0]);
        start = match.index + match[0].length;
        line++;
    }
    one(value.slice(start));
    return result.join('');
    /**
   * @param {string} value
   */ function one(value) {
        result.push(map(value, line, !value));
    }
}


/**
 * @import {SafeConfig, State} from 'mdast-util-to-markdown'
 */ 

function $56428f4bf28369e4$export$170b8c323eee7bec(state, input, config) {
    const value = (config.before || '') + (input || '') + (config.after || '');
    /** @type {Array<number>} */ const positions = [];
    /** @type {Array<string>} */ const result = [];
    /** @type {Record<number, {before: boolean, after: boolean}>} */ const infos = {};
    let index = -1;
    while(++index < state.unsafe.length){
        const pattern = state.unsafe[index];
        if (!(0, $dd92cdb511958ba4$export$78221a09424368d)(state.stack, pattern)) continue;
        const expression = state.compilePattern(pattern);
        /** @type {RegExpExecArray | null} */ let match;
        while(match = expression.exec(value)){
            const before = 'before' in pattern || Boolean(pattern.atBreak);
            const after = 'after' in pattern;
            const position = match.index + (before ? match[1].length : 0);
            if (positions.includes(position)) {
                if (infos[position].before && !before) infos[position].before = false;
                if (infos[position].after && !after) infos[position].after = false;
            } else {
                positions.push(position);
                infos[position] = {
                    before: before,
                    after: after
                };
            }
        }
    }
    positions.sort($56428f4bf28369e4$var$numerical);
    let start = config.before ? config.before.length : 0;
    const end = value.length - (config.after ? config.after.length : 0);
    index = -1;
    while(++index < positions.length){
        const position = positions[index];
        // Character before or after matched:
        if (position < start || position >= end) continue;
        // If this character is supposed to be escaped because it has a condition on
        // the next character, and the next character is definitly being escaped,
        // then skip this escape.
        if (position + 1 < end && positions[index + 1] === position + 1 && infos[position].after && !infos[position + 1].before && !infos[position + 1].after || positions[index - 1] === position - 1 && infos[position].before && !infos[position - 1].before && !infos[position - 1].after) continue;
        if (start !== position) // If we have to use a character reference, an ampersand would be more
        // correct, but as backslashes only care about punctuation, either will
        // do the trick
        result.push($56428f4bf28369e4$var$escapeBackslashes(value.slice(start, position), '\\'));
        start = position;
        if (/[!-/:-@[-`{-~]/.test(value.charAt(position)) && (!config.encode || !config.encode.includes(value.charAt(position)))) // Character escape.
        result.push('\\');
        else {
            // Character reference.
            result.push((0, $2a128b680e0858ff$export$5810cf1e579e9d5b)(value.charCodeAt(position)));
            start++;
        }
    }
    result.push($56428f4bf28369e4$var$escapeBackslashes(value.slice(start, end), config.after));
    return result.join('');
}
/**
 * @param {number} a
 * @param {number} b
 * @returns {number}
 */ function $56428f4bf28369e4$var$numerical(a, b) {
    return a - b;
}
/**
 * @param {string} value
 * @param {string} after
 * @returns {string}
 */ function $56428f4bf28369e4$var$escapeBackslashes(value, after) {
    const expression = /\\(?=[!-/:-@[-`{-~])/g;
    /** @type {Array<number>} */ const positions = [];
    /** @type {Array<string>} */ const results = [];
    const whole = value + after;
    let index = -1;
    let start = 0;
    /** @type {RegExpExecArray | null} */ let match;
    while(match = expression.exec(whole))positions.push(match.index);
    while(++index < positions.length){
        if (start !== positions[index]) results.push(value.slice(start, positions[index]));
        results.push('\\');
        start = positions[index];
    }
    results.push(value.slice(start));
    return results.join('');
}


/**
 * @import {CreateTracker, TrackCurrent, TrackMove, TrackShift} from '../types.js'
 */ /**
 * Track positional info in the output.
 *
 * @type {CreateTracker}
 */ function $afa77e62d3b0fd4f$export$6b2a7d5132615086(config) {
    // Defaults are used to prevent crashes when older utilities somehow activate
    // this code.
    /* c8 ignore next 5 */ const options = config || {};
    const now = options.now || {};
    let lineShift = options.lineShift || 0;
    let line = now.line || 1;
    let column = now.column || 1;
    return {
        move: move,
        current: current,
        shift: shift
    };
    /**
   * Get the current tracked info.
   *
   * @type {TrackCurrent}
   */ function current() {
        return {
            now: {
                line: line,
                column: column
            },
            lineShift: lineShift
        };
    }
    /**
   * Define an increased line shift (the typical indent for lines).
   *
   * @type {TrackShift}
   */ function shift(value) {
        lineShift += value;
    }
    /**
   * Move past some generated markdown.
   *
   * @type {TrackMove}
   */ function move(input) {
        // eslint-disable-next-line unicorn/prefer-default-parameters
        const value = input || '';
        const chunks = value.split(/\r?\n|\r/g);
        const tail = chunks[chunks.length - 1];
        line += chunks.length - 1;
        column = chunks.length === 1 ? column + tail.length : 1 + tail.length + lineShift;
        return value;
    }
}


function $4a5f4556202d090e$export$49a1dda9e62e8ae6(tree, options) {
    const settings = options || {};
    /** @type {State} */ const state = {
        associationId: (0, $b26291509ac26308$export$c4ca1a6065421754),
        containerPhrasing: $4a5f4556202d090e$var$containerPhrasingBound,
        containerFlow: $4a5f4556202d090e$var$containerFlowBound,
        createTracker: (0, $afa77e62d3b0fd4f$export$6b2a7d5132615086),
        compilePattern: $a6fbed2cac1bb4e4$export$2db8af076f277cbf,
        enter: enter,
        // @ts-expect-error: GFM / frontmatter are typed in `mdast` but not defined
        // here.
        handlers: {
            ...(0, $e8bbd7b6f4289640$export$8f34ce051745d39e)
        },
        // @ts-expect-error: add `handle` in a second.
        handle: undefined,
        indentLines: $791d1c85bf3d2cdf$export$7c3cf23d514b264a,
        indexStack: [],
        join: [
            ...(0, $21ab7332f764fd98$export$f7e2c8231c57a8bd)
        ],
        options: {},
        safe: $4a5f4556202d090e$var$safeBound,
        stack: [],
        unsafe: [
            ...(0, $e9c31c3bafab6137$export$aa1c11b655786597)
        ]
    };
    (0, $0a6f90e7ce2a3f23$export$8d21e34596265fa2)(state, settings);
    if (state.options.tightDefinitions) state.join.push($4a5f4556202d090e$var$joinDefinition);
    state.handle = (0, $71ff91a92c658015$export$d6a12bfbbedf6185)('type', {
        invalid: $4a5f4556202d090e$var$invalid,
        unknown: $4a5f4556202d090e$var$unknown,
        handlers: state.handlers
    });
    let result = state.handle(tree, undefined, state, {
        before: '\n',
        after: '\n',
        now: {
            line: 1,
            column: 1
        },
        lineShift: 0
    });
    if (result && result.charCodeAt(result.length - 1) !== 10 && result.charCodeAt(result.length - 1) !== 13) result += '\n';
    return result;
    /** @type {Enter} */ function enter(name) {
        state.stack.push(name);
        return exit;
        /**
     * @returns {undefined}
     */ function exit() {
            state.stack.pop();
        }
    }
}
/**
 * @param {unknown} value
 * @returns {never}
 */ function $4a5f4556202d090e$var$invalid(value) {
    throw new Error('Cannot handle value `' + value + '`, expected node');
}
/**
 * @param {unknown} value
 * @returns {never}
 */ function $4a5f4556202d090e$var$unknown(value) {
    // Always a node.
    const node = /** @type {Nodes} */ value;
    throw new Error('Cannot handle unknown node `' + node.type + '`');
}
/** @type {Join} */ function $4a5f4556202d090e$var$joinDefinition(left, right) {
    // No blank line between adjacent definitions.
    if (left.type === 'definition' && left.type === right.type) return 0;
}
/**
 * Serialize the children of a parent that contains phrasing children.
 *
 * These children will be joined flush together.
 *
 * @this {State}
 *   Info passed around about the current state.
 * @param {PhrasingParents} parent
 *   Parent of flow nodes.
 * @param {Info} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined together.
 */ function $4a5f4556202d090e$var$containerPhrasingBound(parent, info) {
    return (0, $9c0c8f63d162fbf9$export$f4090a9439f37631)(parent, this, info);
}
/**
 * Serialize the children of a parent that contains flow children.
 *
 * These children will typically be joined by blank lines.
 * What they are joined by exactly is defined by `Join` functions.
 *
 * @this {State}
 *   Info passed around about the current state.
 * @param {FlowParents} parent
 *   Parent of flow nodes.
 * @param {TrackFields} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined by (blank) lines.
 */ function $4a5f4556202d090e$var$containerFlowBound(parent, info) {
    return (0, $b9a5d28369b21fc0$export$134f7fdacfea8b16)(parent, this, info);
}
/**
 * Make a string safe for embedding in markdown constructs.
 *
 * In markdown, almost all punctuation characters can, in certain cases,
 * result in something.
 * Whether they do is highly subjective to where they happen and in what
 * they happen.
 *
 * To solve this, `mdast-util-to-markdown` tracks:
 *
 * * Characters before and after something;
 * * What “constructs” we are in.
 *
 * This information is then used by this function to escape or encode
 * special characters.
 *
 * @this {State}
 *   Info passed around about the current state.
 * @param {string | null | undefined} value
 *   Raw value to make safe.
 * @param {SafeConfig} config
 *   Configuration.
 * @returns {string}
 *   Serialized markdown safe for embedding.
 */ function $4a5f4556202d090e$var$safeBound(value, config) {
    return (0, $56428f4bf28369e4$export$170b8c323eee7bec)(this, value, config);
}


/**
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 */ /**
 * @typedef {import('mdast-util-gfm-table').Options} Options
 *   Configuration.
 */ /**
 * @import {RegExpMatchObject, ReplaceFunction} from 'mdast-util-find-and-replace'
 * @import {CompileContext, Extension as FromMarkdownExtension, Handle as FromMarkdownHandle, Transform as FromMarkdownTransform} from 'mdast-util-from-markdown'
 * @import {ConstructName, Options as ToMarkdownExtension} from 'mdast-util-to-markdown'
 * @import {Link, PhrasingContent} from 'mdast'
 */ /**
 * Count how often a character (or substring) is used in a string.
 *
 * @param {string} value
 *   Value to search in.
 * @param {string} character
 *   Character (or substring) to look for.
 * @return {number}
 *   Number of times `character` occurred in `value`.
 */ function $41de3e7a2ee7aa6d$export$fa42eaa97a352e23(value, character) {
    const source = String(value);
    if (typeof character !== 'string') throw new TypeError('Expected character');
    let count = 0;
    let index = source.indexOf(character);
    while(index !== -1){
        count++;
        index = source.indexOf(character, index + character.length);
    }
    return count;
}


function $b52eead50db7e01d$export$b680e6b2c82f8c2f(fn) {
    return fn;
}
function $b52eead50db7e01d$export$411ce8e5a71e3069() {}
function $b52eead50db7e01d$export$dcb8b3f0e2de7e49() {}
function $b52eead50db7e01d$export$565e9d9bd6b6e0d4() {}



/**
 * @import {Nodes, Parents, PhrasingContent, Root, Text} from 'mdast'
 * @import {BuildVisitor, Test, VisitorResult} from 'unist-util-visit-parents'
 */ /**
 * @typedef RegExpMatchObject
 *   Info on the match.
 * @property {number} index
 *   The index of the search at which the result was found.
 * @property {string} input
 *   A copy of the search string in the text node.
 * @property {[...Array<Parents>, Text]} stack
 *   All ancestors of the text node, where the last node is the text itself.
 *
 * @typedef {RegExp | string} Find
 *   Pattern to find.
 *
 *   Strings are escaped and then turned into global expressions.
 *
 * @typedef {Array<FindAndReplaceTuple>} FindAndReplaceList
 *   Several find and replaces, in array form.
 *
 * @typedef {[Find, Replace?]} FindAndReplaceTuple
 *   Find and replace in tuple form.
 *
 * @typedef {ReplaceFunction | string | null | undefined} Replace
 *   Thing to replace with.
 *
 * @callback ReplaceFunction
 *   Callback called when a search matches.
 * @param {...any} parameters
 *   The parameters are the result of corresponding search expression:
 *
 *   * `value` (`string`) — whole match
 *   * `...capture` (`Array<string>`) — matches from regex capture groups
 *   * `match` (`RegExpMatchObject`) — info on the match
 * @returns {Array<PhrasingContent> | PhrasingContent | string | false | null | undefined}
 *   Thing to replace with.
 *
 *   * when `null`, `undefined`, `''`, remove the match
 *   * …or when `false`, do not replace at all
 *   * …or when `string`, replace with a text node of that value
 *   * …or when `Node` or `Array<Node>`, replace with those nodes
 *
 * @typedef {[RegExp, ReplaceFunction]} Pair
 *   Normalized find and replace.
 *
 * @typedef {Array<Pair>} Pairs
 *   All find and replaced.
 *
 * @typedef Options
 *   Configuration.
 * @property {Test | null | undefined} [ignore]
 *   Test for which nodes to ignore (optional).
 */ function $5b4e2de206149cab$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new TypeError('Expected a string');
    // Escape characters with special meaning either inside or outside character sets.
    // Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
    return string.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}




function $b83d2437546acf17$export$fb306ebf003fc574(tree, list, options) {
    const settings = options || {};
    const ignored = (0, $8e5c042dfb772d94$export$9c68d69a4c5bbcf9)(settings.ignore || []);
    const pairs = $b83d2437546acf17$var$toPairs(list);
    let pairIndex = -1;
    while(++pairIndex < pairs.length)(0, $fcc69681d67bfcdc$export$70008a21eb6de899)(tree, 'text', visitor);
    /** @type {BuildVisitor<Root, 'text'>} */ function visitor(node, parents) {
        let index = -1;
        /** @type {Parents | undefined} */ let grandparent;
        while(++index < parents.length){
            const parent = parents[index];
            /** @type {Array<Nodes> | undefined} */ const siblings = grandparent ? grandparent.children : undefined;
            if (ignored(parent, siblings ? siblings.indexOf(parent) : undefined, grandparent)) return;
            grandparent = parent;
        }
        if (grandparent) return handler(node, parents);
    }
    /**
   * Handle a text node which is not in an ignored parent.
   *
   * @param {Text} node
   *   Text node.
   * @param {Array<Parents>} parents
   *   Parents.
   * @returns {VisitorResult}
   *   Result.
   */ function handler(node, parents) {
        const parent = parents[parents.length - 1];
        const find = pairs[pairIndex][0];
        const replace = pairs[pairIndex][1];
        let start = 0;
        /** @type {Array<Nodes>} */ const siblings = parent.children;
        const index = siblings.indexOf(node);
        let change = false;
        /** @type {Array<PhrasingContent>} */ let nodes = [];
        find.lastIndex = 0;
        let match = find.exec(node.value);
        while(match){
            const position = match.index;
            /** @type {RegExpMatchObject} */ const matchObject = {
                index: match.index,
                input: match.input,
                stack: [
                    ...parents,
                    node
                ]
            };
            let value = replace(...match, matchObject);
            if (typeof value === 'string') value = value.length > 0 ? {
                type: 'text',
                value: value
            } : undefined;
            // It wasn’t a match after all.
            if (value === false) // False acts as if there was no match.
            // So we need to reset `lastIndex`, which currently being at the end of
            // the current match, to the beginning.
            find.lastIndex = position + 1;
            else {
                if (start !== position) nodes.push({
                    type: 'text',
                    value: node.value.slice(start, position)
                });
                if (Array.isArray(value)) nodes.push(...value);
                else if (value) nodes.push(value);
                start = position + match[0].length;
                change = true;
            }
            if (!find.global) break;
            match = find.exec(node.value);
        }
        if (change) {
            if (start < node.value.length) nodes.push({
                type: 'text',
                value: node.value.slice(start)
            });
            parent.children.splice(index, 1, ...nodes);
        } else nodes = [
            node
        ];
        return index + nodes.length;
    }
}
/**
 * Turn a tuple or a list of tuples into pairs.
 *
 * @param {FindAndReplaceList | FindAndReplaceTuple} tupleOrList
 *   Schema.
 * @returns {Pairs}
 *   Clean pairs.
 */ function $b83d2437546acf17$var$toPairs(tupleOrList) {
    /** @type {Pairs} */ const result = [];
    if (!Array.isArray(tupleOrList)) throw new TypeError('Expected find and replace tuple or list of tuples');
    /** @type {FindAndReplaceList} */ // @ts-expect-error: correct.
    const list = !tupleOrList[0] || Array.isArray(tupleOrList[0]) ? tupleOrList : [
        tupleOrList
    ];
    let index = -1;
    while(++index < list.length){
        const tuple = list[index];
        result.push([
            $b83d2437546acf17$var$toExpression(tuple[0]),
            $b83d2437546acf17$var$toFunction(tuple[1])
        ]);
    }
    return result;
}
/**
 * Turn a find into an expression.
 *
 * @param {Find} find
 *   Find.
 * @returns {RegExp}
 *   Expression.
 */ function $b83d2437546acf17$var$toExpression(find) {
    return typeof find === 'string' ? new RegExp((0, $5b4e2de206149cab$export$2e2bcd8739ae039)(find), 'g') : find;
}
/**
 * Turn a replace into a function.
 *
 * @param {Replace} replace
 *   Replace.
 * @returns {ReplaceFunction}
 *   Function.
 */ function $b83d2437546acf17$var$toFunction(replace) {
    return typeof replace === 'function' ? replace : function() {
        return replace;
    };
}


/** @type {ConstructName} */ const $475d3e5b4f182f95$var$inConstruct = 'phrasing';
/** @type {Array<ConstructName>} */ const $475d3e5b4f182f95$var$notInConstruct = [
    'autolink',
    'link',
    'image',
    'label'
];
function $475d3e5b4f182f95$export$b6afdfff2163546f() {
    return {
        transforms: [
            $475d3e5b4f182f95$var$transformGfmAutolinkLiterals
        ],
        enter: {
            literalAutolink: $475d3e5b4f182f95$var$enterLiteralAutolink,
            literalAutolinkEmail: $475d3e5b4f182f95$var$enterLiteralAutolinkValue,
            literalAutolinkHttp: $475d3e5b4f182f95$var$enterLiteralAutolinkValue,
            literalAutolinkWww: $475d3e5b4f182f95$var$enterLiteralAutolinkValue
        },
        exit: {
            literalAutolink: $475d3e5b4f182f95$var$exitLiteralAutolink,
            literalAutolinkEmail: $475d3e5b4f182f95$var$exitLiteralAutolinkEmail,
            literalAutolinkHttp: $475d3e5b4f182f95$var$exitLiteralAutolinkHttp,
            literalAutolinkWww: $475d3e5b4f182f95$var$exitLiteralAutolinkWww
        }
    };
}
function $475d3e5b4f182f95$export$d3ace9096b01c39d() {
    return {
        unsafe: [
            {
                character: '@',
                before: '[+\\-.\\w]',
                after: '[\\-.\\w]',
                inConstruct: $475d3e5b4f182f95$var$inConstruct,
                notInConstruct: $475d3e5b4f182f95$var$notInConstruct
            },
            {
                character: '.',
                before: '[Ww]',
                after: '[\\-.\\w]',
                inConstruct: $475d3e5b4f182f95$var$inConstruct,
                notInConstruct: $475d3e5b4f182f95$var$notInConstruct
            },
            {
                character: ':',
                before: '[ps]',
                after: '\\/',
                inConstruct: $475d3e5b4f182f95$var$inConstruct,
                notInConstruct: $475d3e5b4f182f95$var$notInConstruct
            }
        ]
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $475d3e5b4f182f95$var$enterLiteralAutolink(token) {
    this.enter({
        type: 'link',
        title: null,
        url: '',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $475d3e5b4f182f95$var$enterLiteralAutolinkValue(token) {
    this.config.enter.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $475d3e5b4f182f95$var$exitLiteralAutolinkHttp(token) {
    this.config.exit.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $475d3e5b4f182f95$var$exitLiteralAutolinkWww(token) {
    this.config.exit.data.call(this, token);
    const node = this.stack[this.stack.length - 1];
    (0, $b52eead50db7e01d$export$dcb8b3f0e2de7e49)(node.type === 'link');
    node.url = 'http://' + this.sliceSerialize(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $475d3e5b4f182f95$var$exitLiteralAutolinkEmail(token) {
    this.config.exit.autolinkEmail.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $475d3e5b4f182f95$var$exitLiteralAutolink(token) {
    this.exit(token);
}
/** @type {FromMarkdownTransform} */ function $475d3e5b4f182f95$var$transformGfmAutolinkLiterals(tree) {
    (0, $b83d2437546acf17$export$fb306ebf003fc574)(tree, [
        [
            /(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi,
            $475d3e5b4f182f95$var$findUrl
        ],
        [
            /(?<=^|\s|\p{P}|\p{S})([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/gu,
            $475d3e5b4f182f95$var$findEmail
        ]
    ], {
        ignore: [
            'link',
            'linkReference'
        ]
    });
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} protocol
 * @param {string} domain
 * @param {string} path
 * @param {RegExpMatchObject} match
 * @returns {Array<PhrasingContent> | Link | false}
 */ // eslint-disable-next-line max-params
function $475d3e5b4f182f95$var$findUrl(_, protocol, domain, path, match) {
    let prefix = '';
    // Not an expected previous character.
    if (!$475d3e5b4f182f95$var$previous(match)) return false;
    // Treat `www` as part of the domain.
    if (/^w/i.test(protocol)) {
        domain = protocol + domain;
        protocol = '';
        prefix = 'http://';
    }
    if (!$475d3e5b4f182f95$var$isCorrectDomain(domain)) return false;
    const parts = $475d3e5b4f182f95$var$splitUrl(domain + path);
    if (!parts[0]) return false;
    /** @type {Link} */ const result = {
        type: 'link',
        title: null,
        url: prefix + protocol + parts[0],
        children: [
            {
                type: 'text',
                value: protocol + parts[0]
            }
        ]
    };
    if (parts[1]) return [
        result,
        {
            type: 'text',
            value: parts[1]
        }
    ];
    return result;
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} atext
 * @param {string} label
 * @param {RegExpMatchObject} match
 * @returns {Link | false}
 */ function $475d3e5b4f182f95$var$findEmail(_, atext, label, match) {
    if (// Not an expected previous character.
    !$475d3e5b4f182f95$var$previous(match, true) || // Label ends in not allowed character.
    /[-\d_]$/.test(label)) return false;
    return {
        type: 'link',
        title: null,
        url: 'mailto:' + atext + '@' + label,
        children: [
            {
                type: 'text',
                value: atext + '@' + label
            }
        ]
    };
}
/**
 * @param {string} domain
 * @returns {boolean}
 */ function $475d3e5b4f182f95$var$isCorrectDomain(domain) {
    const parts = domain.split('.');
    if (parts.length < 2 || parts[parts.length - 1] && (/_/.test(parts[parts.length - 1]) || !/[a-zA-Z\d]/.test(parts[parts.length - 1])) || parts[parts.length - 2] && (/_/.test(parts[parts.length - 2]) || !/[a-zA-Z\d]/.test(parts[parts.length - 2]))) return false;
    return true;
}
/**
 * @param {string} url
 * @returns {[string, string | undefined]}
 */ function $475d3e5b4f182f95$var$splitUrl(url) {
    const trailExec = /[!"&'),.:;<>?\]}]+$/.exec(url);
    if (!trailExec) return [
        url,
        undefined
    ];
    url = url.slice(0, trailExec.index);
    let trail = trailExec[0];
    let closingParenIndex = trail.indexOf(')');
    const openingParens = (0, $41de3e7a2ee7aa6d$export$fa42eaa97a352e23)(url, '(');
    let closingParens = (0, $41de3e7a2ee7aa6d$export$fa42eaa97a352e23)(url, ')');
    while(closingParenIndex !== -1 && openingParens > closingParens){
        url += trail.slice(0, closingParenIndex + 1);
        trail = trail.slice(closingParenIndex + 1);
        closingParenIndex = trail.indexOf(')');
        closingParens++;
    }
    return [
        url,
        trail
    ];
}
/**
 * @param {RegExpMatchObject} match
 * @param {boolean | null | undefined} [email=false]
 * @returns {boolean}
 */ function $475d3e5b4f182f95$var$previous(match, email) {
    const code = match.input.charCodeAt(match.index - 1);
    return (match.index === 0 || (0, $db5865ecc27181ba$export$a0ff789c034ffdf4)(code) || (0, $db5865ecc27181ba$export$aa04114dd888a7a0)(code)) && // If it’s an email, the previous character should not be a slash.
    (!email || code !== 47);
}


/**
 * @typedef {import('mdast').FootnoteDefinition} FootnoteDefinition
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Map} Map
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 */ 

$fb180f87c0da7ddf$var$footnoteReference.peek = $fb180f87c0da7ddf$var$footnoteReferencePeek;
function $fb180f87c0da7ddf$export$c9d5ad4bdf6ff801() {
    return {
        enter: {
            gfmFootnoteDefinition: $fb180f87c0da7ddf$var$enterFootnoteDefinition,
            gfmFootnoteDefinitionLabelString: $fb180f87c0da7ddf$var$enterFootnoteDefinitionLabelString,
            gfmFootnoteCall: $fb180f87c0da7ddf$var$enterFootnoteCall,
            gfmFootnoteCallString: $fb180f87c0da7ddf$var$enterFootnoteCallString
        },
        exit: {
            gfmFootnoteDefinition: $fb180f87c0da7ddf$var$exitFootnoteDefinition,
            gfmFootnoteDefinitionLabelString: $fb180f87c0da7ddf$var$exitFootnoteDefinitionLabelString,
            gfmFootnoteCall: $fb180f87c0da7ddf$var$exitFootnoteCall,
            gfmFootnoteCallString: $fb180f87c0da7ddf$var$exitFootnoteCallString
        }
    };
}
function $fb180f87c0da7ddf$export$3727766a73a6c09f() {
    return {
        // This is on by default already.
        unsafe: [
            {
                character: '[',
                inConstruct: [
                    'phrasing',
                    'label',
                    'reference'
                ]
            }
        ],
        handlers: {
            footnoteDefinition: $fb180f87c0da7ddf$var$footnoteDefinition,
            footnoteReference: $fb180f87c0da7ddf$var$footnoteReference
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $fb180f87c0da7ddf$var$enterFootnoteDefinition(token) {
    this.enter({
        type: 'footnoteDefinition',
        identifier: '',
        label: '',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $fb180f87c0da7ddf$var$enterFootnoteDefinitionLabelString() {
    this.buffer();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $fb180f87c0da7ddf$var$exitFootnoteDefinitionLabelString(token) {
    const label = this.resume();
    const node = this.stack[this.stack.length - 1];
    (0, $b52eead50db7e01d$export$dcb8b3f0e2de7e49)(node.type === 'footnoteDefinition');
    node.label = label;
    node.identifier = (0, $e8a88a5e1b7aeb38$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $fb180f87c0da7ddf$var$exitFootnoteDefinition(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $fb180f87c0da7ddf$var$enterFootnoteCall(token) {
    this.enter({
        type: 'footnoteReference',
        identifier: '',
        label: ''
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $fb180f87c0da7ddf$var$enterFootnoteCallString() {
    this.buffer();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $fb180f87c0da7ddf$var$exitFootnoteCallString(token) {
    const label = this.resume();
    const node = this.stack[this.stack.length - 1];
    (0, $b52eead50db7e01d$export$dcb8b3f0e2de7e49)(node.type === 'footnoteReference');
    node.label = label;
    node.identifier = (0, $e8a88a5e1b7aeb38$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $fb180f87c0da7ddf$var$exitFootnoteCall(token) {
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {FootnoteReference} node
 */ function $fb180f87c0da7ddf$var$footnoteReference(node, _, state, info) {
    const tracker = state.createTracker(info);
    let value = tracker.move('[^');
    const exit = state.enter('footnoteReference');
    const subexit = state.enter('reference');
    value += tracker.move(state.safe(state.associationId(node), {
        ...tracker.current(),
        before: value,
        after: ']'
    }));
    subexit();
    exit();
    value += tracker.move(']');
    return value;
}
/** @type {ToMarkdownHandle} */ function $fb180f87c0da7ddf$var$footnoteReferencePeek() {
    return '[';
}
/**
 * @type {ToMarkdownHandle}
 * @param {FootnoteDefinition} node
 */ function $fb180f87c0da7ddf$var$footnoteDefinition(node, _, state, info) {
    const tracker = state.createTracker(info);
    let value = tracker.move('[^');
    const exit = state.enter('footnoteDefinition');
    const subexit = state.enter('label');
    value += tracker.move(state.safe(state.associationId(node), {
        ...tracker.current(),
        before: value,
        after: ']'
    }));
    subexit();
    value += tracker.move(']:' + (node.children && node.children.length > 0 ? ' ' : ''));
    tracker.shift(4);
    value += tracker.move(state.indentLines(state.containerFlow(node, tracker.current()), $fb180f87c0da7ddf$var$map));
    exit();
    return value;
}
/** @type {Map} */ function $fb180f87c0da7ddf$var$map(line, index, blank) {
    if (index === 0) return line;
    return (blank ? '' : '    ') + line;
}


/**
 * @typedef {import('mdast').Delete} Delete
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 */ /**
 * List of constructs that occur in phrasing (paragraphs, headings), but cannot
 * contain strikethrough.
 * So they sort of cancel each other out.
 * Note: could use a better name.
 *
 * Note: keep in sync with: <https://github.com/syntax-tree/mdast-util-to-markdown/blob/8ce8dbf/lib/unsafe.js#L14>
 *
 * @type {Array<ConstructName>}
 */ const $8e91fb8e3485b0cb$var$constructsWithoutStrikethrough = [
    'autolink',
    'destinationLiteral',
    'destinationRaw',
    'reference',
    'titleQuote',
    'titleApostrophe'
];
$8e91fb8e3485b0cb$var$handleDelete.peek = $8e91fb8e3485b0cb$var$peekDelete;
function $8e91fb8e3485b0cb$export$34d64e709dd0b9bb() {
    return {
        canContainEols: [
            'delete'
        ],
        enter: {
            strikethrough: $8e91fb8e3485b0cb$var$enterStrikethrough
        },
        exit: {
            strikethrough: $8e91fb8e3485b0cb$var$exitStrikethrough
        }
    };
}
function $8e91fb8e3485b0cb$export$1632835bd2c84956() {
    return {
        unsafe: [
            {
                character: '~',
                inConstruct: 'phrasing',
                notInConstruct: $8e91fb8e3485b0cb$var$constructsWithoutStrikethrough
            }
        ],
        handlers: {
            delete: $8e91fb8e3485b0cb$var$handleDelete
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $8e91fb8e3485b0cb$var$enterStrikethrough(token) {
    this.enter({
        type: 'delete',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $8e91fb8e3485b0cb$var$exitStrikethrough(token) {
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {Delete} node
 */ function $8e91fb8e3485b0cb$var$handleDelete(node, _, state, info) {
    const tracker = state.createTracker(info);
    const exit = state.enter('strikethrough');
    let value = tracker.move('~~');
    value += state.containerPhrasing(node, {
        ...tracker.current(),
        before: value,
        after: '~'
    });
    value += tracker.move('~~');
    exit();
    return value;
}
/** @type {ToMarkdownHandle} */ function $8e91fb8e3485b0cb$var$peekDelete() {
    return '~';
}


/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Table} Table
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('mdast').TableRow} TableRow
 *
 * @typedef {import('markdown-table').Options} MarkdownTableOptions
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').State} State
 * @typedef {import('mdast-util-to-markdown').Info} Info
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [tableCellPadding=true]
 *   Whether to add a space of padding between delimiters and cells (default:
 *   `true`).
 * @property {boolean | null | undefined} [tablePipeAlign=true]
 *   Whether to align the delimiters (default: `true`).
 * @property {MarkdownTableOptions['stringLength'] | null | undefined} [stringLength]
 *   Function to detect the length of table cell content, used when aligning
 *   the delimiters between cells (optional).
 */ 
// To do: next major: remove.
/**
 * @typedef {Options} MarkdownTableOptions
 *   Configuration.
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [alignDelimiters=true]
 *   Whether to align the delimiters (default: `true`);
 *   they are aligned by default:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   Pass `false` to make them staggered:
 *
 *   ```markdown
 *   | Alpha | B |
 *   | - | - |
 *   | C | Delta |
 *   ```
 * @property {ReadonlyArray<string | null | undefined> | string | null | undefined} [align]
 *   How to align columns (default: `''`);
 *   one style for all columns or styles for their respective columns;
 *   each style is either `'l'` (left), `'r'` (right), or `'c'` (center);
 *   other values are treated as `''`, which doesn’t place the colon in the
 *   alignment row but does align left;
 *   *only the lowercased first character is used, so `Right` is fine.*
 * @property {boolean | null | undefined} [delimiterEnd=true]
 *   Whether to end each row with the delimiter (default: `true`).
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B
 *   | ----- | -----
 *   | C     | Delta
 *   ```
 * @property {boolean | null | undefined} [delimiterStart=true]
 *   Whether to begin each row with the delimiter (default: `true`).
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are starting delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no starting delimiters:
 *
 *   ```markdown
 *   Alpha | B     |
 *   ----- | ----- |
 *   C     | Delta |
 *   ```
 * @property {boolean | null | undefined} [padding=true]
 *   Whether to add a space of padding between delimiters and cells
 *   (default: `true`).
 *
 *   When `true`, there is padding:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there is no padding:
 *
 *   ```markdown
 *   |Alpha|B    |
 *   |-----|-----|
 *   |C    |Delta|
 *   ```
 * @property {((value: string) => number) | null | undefined} [stringLength]
 *   Function to detect the length of table cell content (optional);
 *   this is used when aligning the delimiters (`|`) between table cells;
 *   full-width characters and emoji mess up delimiter alignment when viewing
 *   the markdown source;
 *   to fix this, you can pass this function,
 *   which receives the cell content and returns its “visible” size;
 *   note that what is and isn’t visible depends on where the text is displayed.
 *
 *   Without such a function, the following:
 *
 *   ```js
 *   markdownTable([
 *     ['Alpha', 'Bravo'],
 *     ['中文', 'Charlie'],
 *     ['👩‍❤️‍👩', 'Delta']
 *   ])
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo |
 *   | - | - |
 *   | 中文 | Charlie |
 *   | 👩‍❤️‍👩 | Delta |
 *   ```
 *
 *   With [`string-width`](https://github.com/sindresorhus/string-width):
 *
 *   ```js
 *   import stringWidth from 'string-width'
 *
 *   markdownTable(
 *     [
 *       ['Alpha', 'Bravo'],
 *       ['中文', 'Charlie'],
 *       ['👩‍❤️‍👩', 'Delta']
 *     ],
 *     {stringLength: stringWidth}
 *   )
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo   |
 *   | ----- | ------- |
 *   | 中文  | Charlie |
 *   | 👩‍❤️‍👩    | Delta   |
 *   ```
 */ /**
 * @param {string} value
 *   Cell value.
 * @returns {number}
 *   Cell size.
 */ function $f37e15e32d580b31$var$defaultStringLength(value) {
    return value.length;
}
function $f37e15e32d580b31$export$cdb7288612c4f3d6(table, options) {
    const settings = options || {};
    // To do: next major: change to spread.
    const align = (settings.align || []).concat();
    const stringLength = settings.stringLength || $f37e15e32d580b31$var$defaultStringLength;
    /** @type {Array<number>} Character codes as symbols for alignment per column. */ const alignments = [];
    /** @type {Array<Array<string>>} Cells per row. */ const cellMatrix = [];
    /** @type {Array<Array<number>>} Sizes of each cell per row. */ const sizeMatrix = [];
    /** @type {Array<number>} */ const longestCellByColumn = [];
    let mostCellsPerRow = 0;
    let rowIndex = -1;
    // This is a superfluous loop if we don’t align delimiters, but otherwise we’d
    // do superfluous work when aligning, so optimize for aligning.
    while(++rowIndex < table.length){
        /** @type {Array<string>} */ const row = [];
        /** @type {Array<number>} */ const sizes = [];
        let columnIndex = -1;
        if (table[rowIndex].length > mostCellsPerRow) mostCellsPerRow = table[rowIndex].length;
        while(++columnIndex < table[rowIndex].length){
            const cell = $f37e15e32d580b31$var$serialize(table[rowIndex][columnIndex]);
            if (settings.alignDelimiters !== false) {
                const size = stringLength(cell);
                sizes[columnIndex] = size;
                if (longestCellByColumn[columnIndex] === undefined || size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            }
            row.push(cell);
        }
        cellMatrix[rowIndex] = row;
        sizeMatrix[rowIndex] = sizes;
    }
    // Figure out which alignments to use.
    let columnIndex = -1;
    if (typeof align === 'object' && 'length' in align) while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = $f37e15e32d580b31$var$toAlignment(align[columnIndex]);
    else {
        const code = $f37e15e32d580b31$var$toAlignment(align);
        while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = code;
    }
    // Inject the alignment row.
    columnIndex = -1;
    /** @type {Array<string>} */ const row = [];
    /** @type {Array<number>} */ const sizes = [];
    while(++columnIndex < mostCellsPerRow){
        const code = alignments[columnIndex];
        let before = '';
        let after = '';
        if (code === 99 /* `c` */ ) {
            before = ':';
            after = ':';
        } else if (code === 108 /* `l` */ ) before = ':';
        else if (code === 114 /* `r` */ ) after = ':';
        // There *must* be at least one hyphen-minus in each alignment cell.
        let size = settings.alignDelimiters === false ? 1 : Math.max(1, longestCellByColumn[columnIndex] - before.length - after.length);
        const cell = before + '-'.repeat(size) + after;
        if (settings.alignDelimiters !== false) {
            size = before.length + size + after.length;
            if (size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            sizes[columnIndex] = size;
        }
        row[columnIndex] = cell;
    }
    // Inject the alignment row.
    cellMatrix.splice(1, 0, row);
    sizeMatrix.splice(1, 0, sizes);
    rowIndex = -1;
    /** @type {Array<string>} */ const lines = [];
    while(++rowIndex < cellMatrix.length){
        const row = cellMatrix[rowIndex];
        const sizes = sizeMatrix[rowIndex];
        columnIndex = -1;
        /** @type {Array<string>} */ const line = [];
        while(++columnIndex < mostCellsPerRow){
            const cell = row[columnIndex] || '';
            let before = '';
            let after = '';
            if (settings.alignDelimiters !== false) {
                const size = longestCellByColumn[columnIndex] - (sizes[columnIndex] || 0);
                const code = alignments[columnIndex];
                if (code === 114 /* `r` */ ) before = ' '.repeat(size);
                else if (code === 99 /* `c` */ ) {
                    if (size % 2) {
                        before = ' '.repeat(size / 2 + 0.5);
                        after = ' '.repeat(size / 2 - 0.5);
                    } else {
                        before = ' '.repeat(size / 2);
                        after = before;
                    }
                } else after = ' '.repeat(size);
            }
            if (settings.delimiterStart !== false && !columnIndex) line.push('|');
            if (settings.padding !== false && // Don’t add the opening space if we’re not aligning and the cell is
            // empty: there will be a closing space.
            !(settings.alignDelimiters === false && cell === '') && (settings.delimiterStart !== false || columnIndex)) line.push(' ');
            if (settings.alignDelimiters !== false) line.push(before);
            line.push(cell);
            if (settings.alignDelimiters !== false) line.push(after);
            if (settings.padding !== false) line.push(' ');
            if (settings.delimiterEnd !== false || columnIndex !== mostCellsPerRow - 1) line.push('|');
        }
        lines.push(settings.delimiterEnd === false ? line.join('').replace(/ +$/, '') : line.join(''));
    }
    return lines.join('\n');
}
/**
 * @param {string | null | undefined} [value]
 *   Value to serialize.
 * @returns {string}
 *   Result.
 */ function $f37e15e32d580b31$var$serialize(value) {
    return value === null || value === undefined ? '' : String(value);
}
/**
 * @param {string | null | undefined} value
 *   Value.
 * @returns {number}
 *   Alignment.
 */ function $f37e15e32d580b31$var$toAlignment(value) {
    const code = typeof value === 'string' ? value.codePointAt(0) : 0;
    return code === 67 /* `C` */  || code === 99 /* `c` */  ? 99 /* `c` */  : code === 76 /* `L` */  || code === 108 /* `l` */  ? 108 /* `l` */  : code === 82 /* `R` */  || code === 114 /* `r` */  ? 114 /* `r` */  : 0;
}



function $14ec798d42d2b05b$export$8bd0ec8ecf6adb7d() {
    return {
        enter: {
            table: $14ec798d42d2b05b$var$enterTable,
            tableData: $14ec798d42d2b05b$var$enterCell,
            tableHeader: $14ec798d42d2b05b$var$enterCell,
            tableRow: $14ec798d42d2b05b$var$enterRow
        },
        exit: {
            codeText: $14ec798d42d2b05b$var$exitCodeText,
            table: $14ec798d42d2b05b$var$exitTable,
            tableData: $14ec798d42d2b05b$var$exit,
            tableHeader: $14ec798d42d2b05b$var$exit,
            tableRow: $14ec798d42d2b05b$var$exit
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $14ec798d42d2b05b$var$enterTable(token) {
    const align = token._align;
    (0, $b52eead50db7e01d$export$dcb8b3f0e2de7e49)(align, 'expected `_align` on table');
    this.enter({
        type: 'table',
        align: align.map(function(d) {
            return d === 'none' ? null : d;
        }),
        children: []
    }, token);
    this.data.inTable = true;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $14ec798d42d2b05b$var$exitTable(token) {
    this.exit(token);
    this.data.inTable = undefined;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $14ec798d42d2b05b$var$enterRow(token) {
    this.enter({
        type: 'tableRow',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $14ec798d42d2b05b$var$exit(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $14ec798d42d2b05b$var$enterCell(token) {
    this.enter({
        type: 'tableCell',
        children: []
    }, token);
}
// Overwrite the default code text data handler to unescape escaped pipes when
// they are in tables.
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $14ec798d42d2b05b$var$exitCodeText(token) {
    let value = this.resume();
    if (this.data.inTable) value = value.replace(/\\([\\|])/g, $14ec798d42d2b05b$var$replace);
    const node = this.stack[this.stack.length - 1];
    (0, $b52eead50db7e01d$export$dcb8b3f0e2de7e49)(node.type === 'inlineCode');
    node.value = value;
    this.exit(token);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $14ec798d42d2b05b$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === '|' ? $1 : $0;
}
function $14ec798d42d2b05b$export$dafcad76ea6e0045(options) {
    const settings = options || {};
    const padding = settings.tableCellPadding;
    const alignDelimiters = settings.tablePipeAlign;
    const stringLength = settings.stringLength;
    const around = padding ? ' ' : '|';
    return {
        unsafe: [
            {
                character: '\r',
                inConstruct: 'tableCell'
            },
            {
                character: '\n',
                inConstruct: 'tableCell'
            },
            // A pipe, when followed by a tab or space (padding), or a dash or colon
            // (unpadded delimiter row), could result in a table.
            {
                atBreak: true,
                character: '|',
                after: '[\t :-]'
            },
            // A pipe in a cell must be encoded.
            {
                character: '|',
                inConstruct: 'tableCell'
            },
            // A colon must be followed by a dash, in which case it could start a
            // delimiter row.
            {
                atBreak: true,
                character: ':',
                after: '-'
            },
            // A delimiter row can also start with a dash, when followed by more
            // dashes, a colon, or a pipe.
            // This is a stricter version than the built in check for lists, thematic
            // breaks, and setex heading underlines though:
            // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
            {
                atBreak: true,
                character: '-',
                after: '[:|-]'
            }
        ],
        handlers: {
            inlineCode: inlineCodeWithTable,
            table: handleTable,
            tableCell: handleTableCell,
            tableRow: handleTableRow
        }
    };
    /**
   * @type {ToMarkdownHandle}
   * @param {Table} node
   */ function handleTable(node, _, state, info) {
        return serializeData(handleTableAsData(node, state, info), node.align);
    }
    /**
   * This function isn’t really used normally, because we handle rows at the
   * table level.
   * But, if someone passes in a table row, this ensures we make somewhat sense.
   *
   * @type {ToMarkdownHandle}
   * @param {TableRow} node
   */ function handleTableRow(node, _, state, info) {
        const row = handleTableRowAsData(node, state, info);
        const value = serializeData([
            row
        ]);
        // `markdown-table` will always add an align row
        return value.slice(0, value.indexOf('\n'));
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {TableCell} node
   */ function handleTableCell(node, _, state, info) {
        const exit = state.enter('tableCell');
        const subexit = state.enter('phrasing');
        const value = state.containerPhrasing(node, {
            ...info,
            before: around,
            after: around
        });
        subexit();
        exit();
        return value;
    }
    /**
   * @param {Array<Array<string>>} matrix
   * @param {Array<string | null | undefined> | null | undefined} [align]
   */ function serializeData(matrix, align) {
        return (0, $f37e15e32d580b31$export$cdb7288612c4f3d6)(matrix, {
            align: align,
            alignDelimiters: // @ts-expect-error: `markdown-table` types should support `null`.
            alignDelimiters,
            padding: // @ts-expect-error: `markdown-table` types should support `null`.
            padding,
            stringLength: // @ts-expect-error: `markdown-table` types should support `null`.
            stringLength
        });
    }
    /**
   * @param {Table} node
   * @param {State} state
   * @param {Info} info
   */ function handleTableAsData(node, state, info) {
        const children = node.children;
        let index = -1;
        /** @type {Array<Array<string>>} */ const result = [];
        const subexit = state.enter('table');
        while(++index < children.length)result[index] = handleTableRowAsData(children[index], state, info);
        subexit();
        return result;
    }
    /**
   * @param {TableRow} node
   * @param {State} state
   * @param {Info} info
   */ function handleTableRowAsData(node, state, info) {
        const children = node.children;
        let index = -1;
        /** @type {Array<string>} */ const result = [];
        const subexit = state.enter('tableRow');
        while(++index < children.length)// Note: the positional info as used here is incorrect.
        // Making it correct would be impossible due to aligning cells?
        // And it would need copy/pasting `markdown-table` into this project.
        result[index] = handleTableCell(children[index], node, state, info);
        subexit();
        return result;
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {InlineCode} node
   */ function inlineCodeWithTable(node, parent, state) {
        let value = (0, $e8bbd7b6f4289640$export$8f34ce051745d39e).inlineCode(node, parent, state);
        if (state.stack.includes('tableCell')) value = value.replace(/\|/g, '\\$&');
        return value;
    }
}


/**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */ 

function $2e274ce4274a7336$export$a427a608608b215f() {
    return {
        exit: {
            taskListCheckValueChecked: $2e274ce4274a7336$var$exitCheck,
            taskListCheckValueUnchecked: $2e274ce4274a7336$var$exitCheck,
            paragraph: $2e274ce4274a7336$var$exitParagraphWithTaskListItem
        }
    };
}
function $2e274ce4274a7336$export$9975722e7e834b78() {
    return {
        unsafe: [
            {
                atBreak: true,
                character: '-',
                after: '[:|-]'
            }
        ],
        handlers: {
            listItem: $2e274ce4274a7336$var$listItemWithTaskListItem
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $2e274ce4274a7336$var$exitCheck(token) {
    // We’re always in a paragraph, in a list item.
    const node = this.stack[this.stack.length - 2];
    (0, $b52eead50db7e01d$export$dcb8b3f0e2de7e49)(node.type === 'listItem');
    node.checked = token.type === 'taskListCheckValueChecked';
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $2e274ce4274a7336$var$exitParagraphWithTaskListItem(token) {
    const parent = this.stack[this.stack.length - 2];
    if (parent && parent.type === 'listItem' && typeof parent.checked === 'boolean') {
        const node = this.stack[this.stack.length - 1];
        (0, $b52eead50db7e01d$export$dcb8b3f0e2de7e49)(node.type === 'paragraph');
        const head = node.children[0];
        if (head && head.type === 'text') {
            const siblings = parent.children;
            let index = -1;
            /** @type {Paragraph | undefined} */ let firstParaghraph;
            while(++index < siblings.length){
                const sibling = siblings[index];
                if (sibling.type === 'paragraph') {
                    firstParaghraph = sibling;
                    break;
                }
            }
            if (firstParaghraph === node) {
                // Must start with a space or a tab.
                head.value = head.value.slice(1);
                if (head.value.length === 0) node.children.shift();
                else if (node.position && head.position && typeof head.position.start.offset === 'number') {
                    head.position.start.column++;
                    head.position.start.offset++;
                    node.position.start = Object.assign({}, head.position.start);
                }
            }
        }
    }
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {ListItem} node
 */ function $2e274ce4274a7336$var$listItemWithTaskListItem(node, parent, state, info) {
    const head = node.children[0];
    const checkable = typeof node.checked === 'boolean' && head && head.type === 'paragraph';
    const checkbox = '[' + (node.checked ? 'x' : ' ') + '] ';
    const tracker = state.createTracker(info);
    if (checkable) tracker.move(checkbox);
    let value = (0, $e8bbd7b6f4289640$export$8f34ce051745d39e).listItem(node, parent, state, {
        ...info,
        ...tracker.current()
    });
    if (checkable) value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check);
    return value;
    /**
   * @param {string} $0
   * @returns {string}
   */ function check($0) {
        return $0 + checkbox;
    }
}


function $bfee282aacc89190$export$95adae814eb7433e() {
    return [
        (0, $475d3e5b4f182f95$export$b6afdfff2163546f)(),
        (0, $fb180f87c0da7ddf$export$c9d5ad4bdf6ff801)(),
        (0, $8e91fb8e3485b0cb$export$34d64e709dd0b9bb)(),
        (0, $14ec798d42d2b05b$export$8bd0ec8ecf6adb7d)(),
        (0, $2e274ce4274a7336$export$a427a608608b215f)()
    ];
}
function $bfee282aacc89190$export$ea77de6901e7c72b(options) {
    return {
        extensions: [
            (0, $475d3e5b4f182f95$export$d3ace9096b01c39d)(),
            (0, $fb180f87c0da7ddf$export$3727766a73a6c09f)(),
            (0, $8e91fb8e3485b0cb$export$1632835bd2c84956)(),
            (0, $14ec798d42d2b05b$export$dafcad76ea6e0045)(options),
            (0, $2e274ce4274a7336$export$9975722e7e834b78)()
        ]
    };
}


/**
 * @typedef {import('micromark-extension-gfm-footnote').HtmlOptions} HtmlOptions
 * @typedef {import('micromark-extension-gfm-strikethrough').Options} Options
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ 
/**
 * @import {Code, ConstructRecord, Event, Extension, Previous, State, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 
const $4b9ba092cca951b6$var$wwwPrefix = {
    tokenize: $4b9ba092cca951b6$var$tokenizeWwwPrefix,
    partial: true
};
const $4b9ba092cca951b6$var$domain = {
    tokenize: $4b9ba092cca951b6$var$tokenizeDomain,
    partial: true
};
const $4b9ba092cca951b6$var$path = {
    tokenize: $4b9ba092cca951b6$var$tokenizePath,
    partial: true
};
const $4b9ba092cca951b6$var$trail = {
    tokenize: $4b9ba092cca951b6$var$tokenizeTrail,
    partial: true
};
const $4b9ba092cca951b6$var$emailDomainDotTrail = {
    tokenize: $4b9ba092cca951b6$var$tokenizeEmailDomainDotTrail,
    partial: true
};
const $4b9ba092cca951b6$var$wwwAutolink = {
    name: 'wwwAutolink',
    tokenize: $4b9ba092cca951b6$var$tokenizeWwwAutolink,
    previous: $4b9ba092cca951b6$var$previousWww
};
const $4b9ba092cca951b6$var$protocolAutolink = {
    name: 'protocolAutolink',
    tokenize: $4b9ba092cca951b6$var$tokenizeProtocolAutolink,
    previous: $4b9ba092cca951b6$var$previousProtocol
};
const $4b9ba092cca951b6$var$emailAutolink = {
    name: 'emailAutolink',
    tokenize: $4b9ba092cca951b6$var$tokenizeEmailAutolink,
    previous: $4b9ba092cca951b6$var$previousEmail
};
/** @type {ConstructRecord} */ const $4b9ba092cca951b6$var$text = {};
function $4b9ba092cca951b6$export$608123d9b549151() {
    return {
        text: $4b9ba092cca951b6$var$text
    };
}
/** @type {Code} */ let $4b9ba092cca951b6$var$code = 48;
// Add alphanumerics.
while($4b9ba092cca951b6$var$code < 123){
    $4b9ba092cca951b6$var$text[$4b9ba092cca951b6$var$code] = $4b9ba092cca951b6$var$emailAutolink;
    $4b9ba092cca951b6$var$code++;
    if ($4b9ba092cca951b6$var$code === 58) $4b9ba092cca951b6$var$code = 65;
    else if ($4b9ba092cca951b6$var$code === 91) $4b9ba092cca951b6$var$code = 97;
}
$4b9ba092cca951b6$var$text[43] = $4b9ba092cca951b6$var$emailAutolink;
$4b9ba092cca951b6$var$text[45] = $4b9ba092cca951b6$var$emailAutolink;
$4b9ba092cca951b6$var$text[46] = $4b9ba092cca951b6$var$emailAutolink;
$4b9ba092cca951b6$var$text[95] = $4b9ba092cca951b6$var$emailAutolink;
$4b9ba092cca951b6$var$text[72] = [
    $4b9ba092cca951b6$var$emailAutolink,
    $4b9ba092cca951b6$var$protocolAutolink
];
$4b9ba092cca951b6$var$text[104] = [
    $4b9ba092cca951b6$var$emailAutolink,
    $4b9ba092cca951b6$var$protocolAutolink
];
$4b9ba092cca951b6$var$text[87] = [
    $4b9ba092cca951b6$var$emailAutolink,
    $4b9ba092cca951b6$var$wwwAutolink
];
$4b9ba092cca951b6$var$text[119] = [
    $4b9ba092cca951b6$var$emailAutolink,
    $4b9ba092cca951b6$var$wwwAutolink
];
// To do: perform email autolink literals on events, afterwards.
// That’s where `markdown-rs` and `cmark-gfm` perform it.
// It should look for `@`, then for atext backwards, and then for a label
// forwards.
// To do: `mailto:`, `xmpp:` protocol as prefix.
/**
 * Email autolink literal.
 *
 * ```markdown
 * > | a contact@example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $4b9ba092cca951b6$var$tokenizeEmailAutolink(effects, ok, nok) {
    const self = this;
    /** @type {boolean | undefined} */ let dot;
    /** @type {boolean} */ let data;
    return start;
    /**
   * Start of email autolink literal.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (!$4b9ba092cca951b6$var$gfmAtext(code) || !$4b9ba092cca951b6$var$previousEmail.call(self, self.previous) || $4b9ba092cca951b6$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter('literalAutolink');
        effects.enter('literalAutolinkEmail');
        return atext(code);
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function atext(code) {
        if ($4b9ba092cca951b6$var$gfmAtext(code)) {
            effects.consume(code);
            return atext;
        }
        if (code === 64) {
            effects.consume(code);
            return emailDomain;
        }
        return nok(code);
    }
    /**
   * In email domain.
   *
   * The reference code is a bit overly complex as it handles the `@`, of which
   * there may be just one.
   * Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L318>
   *
   * ```markdown
   * > | a contact@example.org b
   *               ^
   * ```
   *
   * @type {State}
   */ function emailDomain(code) {
        // Dot followed by alphanumerical (not `-` or `_`).
        if (code === 46) return effects.check($4b9ba092cca951b6$var$emailDomainDotTrail, emailDomainAfter, emailDomainDot)(code);
        // Alphanumerical, `-`, and `_`.
        if (code === 45 || code === 95 || (0, $db5865ecc27181ba$export$75c76db11865a9f4)(code)) {
            data = true;
            effects.consume(code);
            return emailDomain;
        }
        // To do: `/` if xmpp.
        // Note: normally we’d truncate trailing punctuation from the link.
        // However, email autolink literals cannot contain any of those markers,
        // except for `.`, but that can only occur if it isn’t trailing.
        // So we can ignore truncating!
        return emailDomainAfter(code);
    }
    /**
   * In email domain, on dot that is not a trail.
   *
   * ```markdown
   * > | a contact@example.org b
   *                      ^
   * ```
   *
   * @type {State}
   */ function emailDomainDot(code) {
        effects.consume(code);
        dot = true;
        return emailDomain;
    }
    /**
   * After email domain.
   *
   * ```markdown
   * > | a contact@example.org b
   *                          ^
   * ```
   *
   * @type {State}
   */ function emailDomainAfter(code) {
        // Domain must not be empty, must include a dot, and must end in alphabetical.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L332>.
        if (data && dot && (0, $db5865ecc27181ba$export$d65d6b62c24d5436)(self.previous)) {
            effects.exit('literalAutolinkEmail');
            effects.exit('literalAutolink');
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * `www` autolink literal.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $4b9ba092cca951b6$var$tokenizeWwwAutolink(effects, ok, nok) {
    const self = this;
    return wwwStart;
    /**
   * Start of www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function wwwStart(code) {
        if (code !== 87 && code !== 119 || !$4b9ba092cca951b6$var$previousWww.call(self, self.previous) || $4b9ba092cca951b6$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter('literalAutolink');
        effects.enter('literalAutolinkWww');
        // Note: we *check*, so we can discard the `www.` we parsed.
        // If it worked, we consider it as a part of the domain.
        return effects.check($4b9ba092cca951b6$var$wwwPrefix, effects.attempt($4b9ba092cca951b6$var$domain, effects.attempt($4b9ba092cca951b6$var$path, wwwAfter), nok), nok)(code);
    }
    /**
   * After a www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *                          ^
   * ```
   *
   * @type {State}
   */ function wwwAfter(code) {
        effects.exit('literalAutolinkWww');
        effects.exit('literalAutolink');
        return ok(code);
    }
}
/**
 * Protocol autolink literal.
 *
 * ```markdown
 * > | a https://example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $4b9ba092cca951b6$var$tokenizeProtocolAutolink(effects, ok, nok) {
    const self = this;
    let buffer = '';
    let seen = false;
    return protocolStart;
    /**
   * Start of protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function protocolStart(code) {
        if ((code === 72 || code === 104) && $4b9ba092cca951b6$var$previousProtocol.call(self, self.previous) && !$4b9ba092cca951b6$var$previousUnbalanced(self.events)) {
            effects.enter('literalAutolink');
            effects.enter('literalAutolinkHttp');
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        return nok(code);
    }
    /**
   * In protocol.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^^^^^
   * ```
   *
   * @type {State}
   */ function protocolPrefixInside(code) {
        // `5` is size of `https`
        if ((0, $db5865ecc27181ba$export$d65d6b62c24d5436)(code) && buffer.length < 5) {
            // @ts-expect-error: definitely number.
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        if (code === 58) {
            const protocol = buffer.toLowerCase();
            if (protocol === 'http' || protocol === 'https') {
                effects.consume(code);
                return protocolSlashesInside;
            }
        }
        return nok(code);
    }
    /**
   * In slashes.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *           ^^
   * ```
   *
   * @type {State}
   */ function protocolSlashesInside(code) {
        if (code === 47) {
            effects.consume(code);
            if (seen) return afterProtocol;
            seen = true;
            return protocolSlashesInside;
        }
        return nok(code);
    }
    /**
   * After protocol, before domain.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *             ^
   * ```
   *
   * @type {State}
   */ function afterProtocol(code) {
        // To do: this is different from `markdown-rs`:
        // https://github.com/wooorm/markdown-rs/blob/b3a921c761309ae00a51fe348d8a43adbc54b518/src/construct/gfm_autolink_literal.rs#L172-L182
        return code === null || (0, $db5865ecc27181ba$export$67dbf494fc8394df)(code) || (0, $db5865ecc27181ba$export$a30284361b3814b7)(code) || (0, $db5865ecc27181ba$export$a0ff789c034ffdf4)(code) || (0, $db5865ecc27181ba$export$aa04114dd888a7a0)(code) ? nok(code) : effects.attempt($4b9ba092cca951b6$var$domain, effects.attempt($4b9ba092cca951b6$var$path, protocolAfter), nok)(code);
    }
    /**
   * After a protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *                              ^
   * ```
   *
   * @type {State}
   */ function protocolAfter(code) {
        effects.exit('literalAutolinkHttp');
        effects.exit('literalAutolink');
        return ok(code);
    }
}
/**
 * `www` prefix.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $4b9ba092cca951b6$var$tokenizeWwwPrefix(effects, ok, nok) {
    let size = 0;
    return wwwPrefixInside;
    /**
   * In www prefix.
   *
   * ```markdown
   * > | www.example.com
   *     ^^^^
   * ```
   *
   * @type {State}
   */ function wwwPrefixInside(code) {
        if ((code === 87 || code === 119) && size < 3) {
            size++;
            effects.consume(code);
            return wwwPrefixInside;
        }
        if (code === 46 && size === 3) {
            effects.consume(code);
            return wwwPrefixAfter;
        }
        return nok(code);
    }
    /**
   * After www prefix.
   *
   * ```markdown
   * > | www.example.com
   *         ^
   * ```
   *
   * @type {State}
   */ function wwwPrefixAfter(code) {
        // If there is *anything*, we can link.
        return code === null ? nok(code) : ok(code);
    }
}
/**
 * Domain.
 *
 * ```markdown
 * > | a https://example.org b
 *               ^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $4b9ba092cca951b6$var$tokenizeDomain(effects, ok, nok) {
    /** @type {boolean | undefined} */ let underscoreInLastSegment;
    /** @type {boolean | undefined} */ let underscoreInLastLastSegment;
    /** @type {boolean | undefined} */ let seen;
    return domainInside;
    /**
   * In domain.
   *
   * ```markdown
   * > | https://example.com/a
   *             ^^^^^^^^^^^
   * ```
   *
   * @type {State}
   */ function domainInside(code) {
        // Check whether this marker, which is a trailing punctuation
        // marker, optionally followed by more trailing markers, and then
        // followed by an end.
        if (code === 46 || code === 95) return effects.check($4b9ba092cca951b6$var$trail, domainAfter, domainAtPunctuation)(code);
        // GH documents that only alphanumerics (other than `-`, `.`, and `_`) can
        // occur, which sounds like ASCII only, but they also support `www.點看.com`,
        // so that’s Unicode.
        // Instead of some new production for Unicode alphanumerics, markdown
        // already has that for Unicode punctuation and whitespace, so use those.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L12>.
        if (code === null || (0, $db5865ecc27181ba$export$a30284361b3814b7)(code) || (0, $db5865ecc27181ba$export$a0ff789c034ffdf4)(code) || code !== 45 && (0, $db5865ecc27181ba$export$aa04114dd888a7a0)(code)) return domainAfter(code);
        seen = true;
        effects.consume(code);
        return domainInside;
    }
    /**
   * In domain, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com
   *                    ^
   * ```
   *
   * @type {State}
   */ function domainAtPunctuation(code) {
        // There is an underscore in the last segment of the domain
        if (code === 95) underscoreInLastSegment = true;
        else {
            underscoreInLastLastSegment = underscoreInLastSegment;
            underscoreInLastSegment = undefined;
        }
        effects.consume(code);
        return domainInside;
    }
    /**
   * After domain.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^
   * ```
   *
   * @type {State} */ function domainAfter(code) {
        // Note: that’s GH says a dot is needed, but it’s not true:
        // <https://github.com/github/cmark-gfm/issues/279>
        if (underscoreInLastLastSegment || underscoreInLastSegment || !seen) return nok(code);
        return ok(code);
    }
}
/**
 * Path.
 *
 * ```markdown
 * > | a https://example.org/stuff b
 *                          ^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $4b9ba092cca951b6$var$tokenizePath(effects, ok) {
    let sizeOpen = 0;
    let sizeClose = 0;
    return pathInside;
    /**
   * In path.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^^
   * ```
   *
   * @type {State}
   */ function pathInside(code) {
        if (code === 40) {
            sizeOpen++;
            effects.consume(code);
            return pathInside;
        }
        // To do: `markdown-rs` also needs this.
        // If this is a paren, and there are less closings than openings,
        // we don’t check for a trail.
        if (code === 41 && sizeClose < sizeOpen) return pathAtPunctuation(code);
        // Check whether this trailing punctuation marker is optionally
        // followed by more trailing markers, and then followed
        // by an end.
        if (code === 33 || code === 34 || code === 38 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 60 || code === 63 || code === 93 || code === 95 || code === 126) return effects.check($4b9ba092cca951b6$var$trail, ok, pathAtPunctuation)(code);
        if (code === null || (0, $db5865ecc27181ba$export$a30284361b3814b7)(code) || (0, $db5865ecc27181ba$export$a0ff789c034ffdf4)(code)) return ok(code);
        effects.consume(code);
        return pathInside;
    }
    /**
   * In path, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com/a"b
   *                          ^
   * ```
   *
   * @type {State}
   */ function pathAtPunctuation(code) {
        // Count closing parens.
        if (code === 41) sizeClose++;
        effects.consume(code);
        return pathInside;
    }
}
/**
 * Trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the entire trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | https://example.com").
 *                        ^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $4b9ba092cca951b6$var$tokenizeTrail(effects, ok, nok) {
    return trail;
    /**
   * In trail of domain or path.
   *
   * ```markdown
   * > | https://example.com").
   *                        ^
   * ```
   *
   * @type {State}
   */ function trail(code) {
        // Regular trailing punctuation.
        if (code === 33 || code === 34 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 63 || code === 95 || code === 126) {
            effects.consume(code);
            return trail;
        }
        // `&` followed by one or more alphabeticals and then a `;`, is
        // as a whole considered as trailing punctuation.
        // In all other cases, it is considered as continuation of the URL.
        if (code === 38) {
            effects.consume(code);
            return trailCharacterReferenceStart;
        }
        // Needed because we allow literals after `[`, as we fix:
        // <https://github.com/github/cmark-gfm/issues/278>.
        // Check that it is not followed by `(` or `[`.
        if (code === 93) {
            effects.consume(code);
            return trailBracketAfter;
        }
        if (// `<` is an end.
        code === 60 || // So is whitespace.
        code === null || (0, $db5865ecc27181ba$export$a30284361b3814b7)(code) || (0, $db5865ecc27181ba$export$a0ff789c034ffdf4)(code)) return ok(code);
        return nok(code);
    }
    /**
   * In trail, after `]`.
   *
   * > 👉 **Note**: this deviates from `cmark-gfm` to fix a bug.
   * > See end of <https://github.com/github/cmark-gfm/issues/278> for more.
   *
   * ```markdown
   * > | https://example.com](
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailBracketAfter(code) {
        // Whitespace or something that could start a resource or reference is the end.
        // Switch back to trail otherwise.
        if (code === null || code === 40 || code === 91 || (0, $db5865ecc27181ba$export$a30284361b3814b7)(code) || (0, $db5865ecc27181ba$export$a0ff789c034ffdf4)(code)) return ok(code);
        return trail(code);
    }
    /**
   * In character-reference like trail, after `&`.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharacterReferenceStart(code) {
        // When non-alpha, it’s not a trail.
        return (0, $db5865ecc27181ba$export$d65d6b62c24d5436)(code) ? trailCharacterReferenceInside(code) : nok(code);
    }
    /**
   * In character-reference like trail.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharacterReferenceInside(code) {
        // Switch back to trail if this is well-formed.
        if (code === 59) {
            effects.consume(code);
            return trail;
        }
        if ((0, $db5865ecc27181ba$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return trailCharacterReferenceInside;
        }
        // It’s not a trail.
        return nok(code);
    }
}
/**
 * Dot in email domain trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | contact@example.org.
 *                        ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $4b9ba092cca951b6$var$tokenizeEmailDomainDotTrail(effects, ok, nok) {
    return start;
    /**
   * Dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                    ^   ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Must be dot.
        effects.consume(code);
        return after;
    }
    /**
   * After dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                     ^   ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Not a trail if alphanumeric.
        return (0, $db5865ecc27181ba$export$75c76db11865a9f4)(code) ? nok(code) : ok(code);
    }
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L156>.
 *
 * @type {Previous}
 */ function $4b9ba092cca951b6$var$previousWww(code) {
    return code === null || code === 40 || code === 42 || code === 95 || code === 91 || code === 93 || code === 126 || (0, $db5865ecc27181ba$export$a30284361b3814b7)(code);
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L214>.
 *
 * @type {Previous}
 */ function $4b9ba092cca951b6$var$previousProtocol(code) {
    return !(0, $db5865ecc27181ba$export$d65d6b62c24d5436)(code);
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $4b9ba092cca951b6$var$previousEmail(code) {
    // Do not allow a slash “inside” atext.
    // The reference code is a bit weird, but that’s what it results in.
    // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L307>.
    // Other than slash, every preceding character is allowed.
    return !(code === 47 || $4b9ba092cca951b6$var$gfmAtext(code));
}
/**
 * @param {Code} code
 * @returns {boolean}
 */ function $4b9ba092cca951b6$var$gfmAtext(code) {
    return code === 43 || code === 45 || code === 46 || code === 95 || (0, $db5865ecc27181ba$export$75c76db11865a9f4)(code);
}
/**
 * @param {Array<Event>} events
 * @returns {boolean}
 */ function $4b9ba092cca951b6$var$previousUnbalanced(events) {
    let index = events.length;
    let result = false;
    while(index--){
        const token = events[index][1];
        if ((token.type === 'labelLink' || token.type === 'labelImage') && !token._balanced) {
            result = true;
            break;
        }
        // If we’ve seen this token, and it was marked as not having any unbalanced
        // bracket before it, we can exit.
        if (token._gfmAutolinkLiteralWalkedInto) {
            result = false;
            break;
        }
    }
    if (events.length > 0 && !result) // Mark the last token as “walked into” w/o finding
    // anything.
    events[events.length - 1][1]._gfmAutolinkLiteralWalkedInto = true;
    return result;
}

/**
 * @import {CompileContext, Handle, HtmlExtension, Token} from 'micromark-util-types'
 */ 
function $06454b1cfbaf9a2a$export$999603f1f1c3d2f9() {
    return {
        exit: {
            literalAutolinkEmail: $06454b1cfbaf9a2a$var$literalAutolinkEmail,
            literalAutolinkHttp: $06454b1cfbaf9a2a$var$literalAutolinkHttp,
            literalAutolinkWww: $06454b1cfbaf9a2a$var$literalAutolinkWww
        }
    };
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $06454b1cfbaf9a2a$var$literalAutolinkWww(token) {
    $06454b1cfbaf9a2a$var$anchorFromToken.call(this, token, 'http://');
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $06454b1cfbaf9a2a$var$literalAutolinkEmail(token) {
    $06454b1cfbaf9a2a$var$anchorFromToken.call(this, token, 'mailto:');
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $06454b1cfbaf9a2a$var$literalAutolinkHttp(token) {
    $06454b1cfbaf9a2a$var$anchorFromToken.call(this, token);
}
/**
 * @this CompileContext
 * @param {Token} token
 * @param {string | null | undefined} [protocol]
 * @returns {undefined}
 */ function $06454b1cfbaf9a2a$var$anchorFromToken(token, protocol) {
    const url = this.sliceSerialize(token);
    this.tag('<a href="' + (0, $921de628cfa25736$export$d130a2d684099e5a)((protocol || '') + url) + '">');
    this.raw(this.encode(url));
    this.tag('</a>');
}


/**
 * @import {Event, Exiter, Extension, Resolver, State, Token, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 



const $d11961ba3aedc2b1$var$indent = {
    tokenize: $d11961ba3aedc2b1$var$tokenizeIndent,
    partial: true
};
function $d11961ba3aedc2b1$export$c82499b6656305df() {
    /** @type {Extension} */ return {
        document: {
            [91]: {
                name: 'gfmFootnoteDefinition',
                tokenize: $d11961ba3aedc2b1$var$tokenizeDefinitionStart,
                continuation: {
                    tokenize: $d11961ba3aedc2b1$var$tokenizeDefinitionContinuation
                },
                exit: $d11961ba3aedc2b1$var$gfmFootnoteDefinitionEnd
            }
        },
        text: {
            [91]: {
                name: 'gfmFootnoteCall',
                tokenize: $d11961ba3aedc2b1$var$tokenizeGfmFootnoteCall
            },
            [93]: {
                name: 'gfmPotentialFootnoteCall',
                add: 'after',
                tokenize: $d11961ba3aedc2b1$var$tokenizePotentialGfmFootnoteCall,
                resolveTo: $d11961ba3aedc2b1$var$resolveToPotentialGfmFootnoteCall
            }
        }
    };
}
// To do: remove after micromark update.
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d11961ba3aedc2b1$var$tokenizePotentialGfmFootnoteCall(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    /** @type {Token} */ let labelStart;
    // Find an opening.
    while(index--){
        const token = self.events[index][1];
        if (token.type === "labelImage") {
            labelStart = token;
            break;
        }
        // Exit if we’ve walked far enough.
        if (token.type === 'gfmFootnoteCall' || token.type === "labelLink" || token.type === "label" || token.type === "image" || token.type === "link") break;
    }
    return start;
    /**
   * @type {State}
   */ function start(code) {
        if (!labelStart || !labelStart._balanced) return nok(code);
        const id = (0, $e8a88a5e1b7aeb38$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        }));
        if (id.codePointAt(0) !== 94 || !defined.includes(id.slice(1))) return nok(code);
        effects.enter('gfmFootnoteCallLabelMarker');
        effects.consume(code);
        effects.exit('gfmFootnoteCallLabelMarker');
        return ok(code);
    }
}
// To do: remove after micromark update.
/** @type {Resolver} */ function $d11961ba3aedc2b1$var$resolveToPotentialGfmFootnoteCall(events, context) {
    let index = events.length;
    /** @type {Token | undefined} */ let labelStart;
    // Find an opening.
    while(index--)if (events[index][1].type === "labelImage" && events[index][0] === 'enter') {
        labelStart = events[index][1];
        break;
    }
    // Change the `labelImageMarker` to a `data`.
    events[index + 1][1].type = "data";
    events[index + 3][1].type = 'gfmFootnoteCallLabelMarker';
    // The whole (without `!`):
    /** @type {Token} */ const call = {
        type: 'gfmFootnoteCall',
        start: Object.assign({}, events[index + 3][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // The `^` marker
    /** @type {Token} */ const marker = {
        type: 'gfmFootnoteCallMarker',
        start: Object.assign({}, events[index + 3][1].end),
        end: Object.assign({}, events[index + 3][1].end)
    };
    // Increment the end 1 character.
    marker.end.column++;
    marker.end.offset++;
    marker.end._bufferIndex++;
    /** @type {Token} */ const string = {
        type: 'gfmFootnoteCallString',
        start: Object.assign({}, marker.end),
        end: Object.assign({}, events[events.length - 1][1].start)
    };
    /** @type {Token} */ const chunk = {
        type: "chunkString",
        contentType: 'string',
        start: Object.assign({}, string.start),
        end: Object.assign({}, string.end)
    };
    /** @type {Array<Event>} */ const replacement = [
        // Take the `labelImageMarker` (now `data`, the `!`)
        events[index + 1],
        events[index + 2],
        [
            'enter',
            call,
            context
        ],
        // The `[`
        events[index + 3],
        events[index + 4],
        // The `^`.
        [
            'enter',
            marker,
            context
        ],
        [
            'exit',
            marker,
            context
        ],
        // Everything in between.
        [
            'enter',
            string,
            context
        ],
        [
            'enter',
            chunk,
            context
        ],
        [
            'exit',
            chunk,
            context
        ],
        [
            'exit',
            string,
            context
        ],
        // The ending (`]`, properly parsed and labelled).
        events[events.length - 2],
        events[events.length - 1],
        [
            'exit',
            call,
            context
        ]
    ];
    events.splice(index, events.length - index + 1, ...replacement);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d11961ba3aedc2b1$var$tokenizeGfmFootnoteCall(effects, ok, nok) {
    const self = this;
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    let size = 0;
    /** @type {boolean} */ let data;
    // Note: the implementation of `markdown-rs` is different, because it houses
    // core *and* extensions in one project.
    // Therefore, it can include footnote logic inside `label-end`.
    // We can’t do that, but luckily, we can parse footnotes in a simpler way than
    // needed for labels.
    return start;
    /**
   * Start of footnote label.
   *
   * ```markdown
   * > | a [^b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('gfmFootnoteCall');
        effects.enter('gfmFootnoteCallLabelMarker');
        effects.consume(code);
        effects.exit('gfmFootnoteCallLabelMarker');
        return callStart;
    }
    /**
   * After `[`, at `^`.
   *
   * ```markdown
   * > | a [^b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function callStart(code) {
        if (code !== 94) return nok(code);
        effects.enter('gfmFootnoteCallMarker');
        effects.consume(code);
        effects.exit('gfmFootnoteCallMarker');
        effects.enter('gfmFootnoteCallString');
        effects.enter('chunkString').contentType = 'string';
        return callData;
    }
    /**
   * In label.
   *
   * ```markdown
   * > | a [^b] c
   *         ^
   * ```
   *
   * @type {State}
   */ function callData(code) {
        if (// Too long.
        size > 999 || // Closing brace with nothing.
        code === 93 && !data || // Space or tab is not supported by GFM for some reason.
        // `\n` and `[` not being supported makes sense.
        code === null || code === 91 || (0, $db5865ecc27181ba$export$a30284361b3814b7)(code)) return nok(code);
        if (code === 93) {
            effects.exit('chunkString');
            const token = effects.exit('gfmFootnoteCallString');
            if (!defined.includes((0, $e8a88a5e1b7aeb38$export$806d55e226cfcd08)(self.sliceSerialize(token)))) return nok(code);
            effects.enter('gfmFootnoteCallLabelMarker');
            effects.consume(code);
            effects.exit('gfmFootnoteCallLabelMarker');
            effects.exit('gfmFootnoteCall');
            return ok;
        }
        if (!(0, $db5865ecc27181ba$export$a30284361b3814b7)(code)) data = true;
        size++;
        effects.consume(code);
        return code === 92 ? callEscape : callData;
    }
    /**
   * On character after escape.
   *
   * ```markdown
   * > | a [^b\c] d
   *           ^
   * ```
   *
   * @type {State}
   */ function callEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return callData;
        }
        return callData(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d11961ba3aedc2b1$var$tokenizeDefinitionStart(effects, ok, nok) {
    const self = this;
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    /** @type {string} */ let identifier;
    let size = 0;
    /** @type {boolean | undefined} */ let data;
    return start;
    /**
   * Start of GFM footnote definition.
   *
   * ```markdown
   * > | [^a]: b
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('gfmFootnoteDefinition')._container = true;
        effects.enter('gfmFootnoteDefinitionLabel');
        effects.enter('gfmFootnoteDefinitionLabelMarker');
        effects.consume(code);
        effects.exit('gfmFootnoteDefinitionLabelMarker');
        return labelAtMarker;
    }
    /**
   * In label, at caret.
   *
   * ```markdown
   * > | [^a]: b
   *      ^
   * ```
   *
   * @type {State}
   */ function labelAtMarker(code) {
        if (code === 94) {
            effects.enter('gfmFootnoteDefinitionMarker');
            effects.consume(code);
            effects.exit('gfmFootnoteDefinitionMarker');
            effects.enter('gfmFootnoteDefinitionLabelString');
            effects.enter('chunkString').contentType = 'string';
            return labelInside;
        }
        return nok(code);
    }
    /**
   * In label.
   *
   * > 👉 **Note**: `cmark-gfm` prevents whitespace from occurring in footnote
   * > definition labels.
   *
   * ```markdown
   * > | [^a]: b
   *       ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (// Too long.
        size > 999 || // Closing brace with nothing.
        code === 93 && !data || // Space or tab is not supported by GFM for some reason.
        // `\n` and `[` not being supported makes sense.
        code === null || code === 91 || (0, $db5865ecc27181ba$export$a30284361b3814b7)(code)) return nok(code);
        if (code === 93) {
            effects.exit('chunkString');
            const token = effects.exit('gfmFootnoteDefinitionLabelString');
            identifier = (0, $e8a88a5e1b7aeb38$export$806d55e226cfcd08)(self.sliceSerialize(token));
            effects.enter('gfmFootnoteDefinitionLabelMarker');
            effects.consume(code);
            effects.exit('gfmFootnoteDefinitionLabelMarker');
            effects.exit('gfmFootnoteDefinitionLabel');
            return labelAfter;
        }
        if (!(0, $db5865ecc27181ba$export$a30284361b3814b7)(code)) data = true;
        size++;
        effects.consume(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * > 👉 **Note**: `cmark-gfm` currently does not support escaped brackets:
   * > <https://github.com/github/cmark-gfm/issues/240>
   *
   * ```markdown
   * > | [^a\*b]: c
   *         ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
    /**
   * After definition label.
   *
   * ```markdown
   * > | [^a]: b
   *         ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        if (code === 58) {
            effects.enter('definitionMarker');
            effects.consume(code);
            effects.exit('definitionMarker');
            if (!defined.includes(identifier)) defined.push(identifier);
            // Any whitespace after the marker is eaten, forming indented code
            // is not possible.
            // No space is also fine, just like a block quote marker.
            return (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, whitespaceAfter, 'gfmFootnoteDefinitionWhitespace');
        }
        return nok(code);
    }
    /**
   * After definition prefix.
   *
   * ```markdown
   * > | [^a]: b
   *           ^
   * ```
   *
   * @type {State}
   */ function whitespaceAfter(code) {
        // `markdown-rs` has a wrapping token for the prefix that is closed here.
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d11961ba3aedc2b1$var$tokenizeDefinitionContinuation(effects, ok, nok) {
    /// Start of footnote definition continuation.
    ///
    /// ```markdown
    ///   | [^a]: b
    /// > |     c
    ///     ^
    /// ```
    //
    // Either a blank line, which is okay, or an indented thing.
    return effects.check((0, $8d5404e5d94cba13$export$d50d28ce3ab2a612), ok, effects.attempt($d11961ba3aedc2b1$var$indent, ok, nok));
}
/** @type {Exiter} */ function $d11961ba3aedc2b1$var$gfmFootnoteDefinitionEnd(effects) {
    effects.exit('gfmFootnoteDefinition');
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d11961ba3aedc2b1$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, afterPrefix, 'gfmFootnoteDefinitionIndent', 5);
    /**
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === 'gfmFootnoteDefinitionIndent' && tail[2].sliceSerialize(tail[1], true).length === 4 ? ok(code) : nok(code);
    }
}

/**
 * @import {HtmlOptions as Options} from 'micromark-extension-gfm-footnote'
 * @import {HtmlExtension} from 'micromark-util-types'
 */ 

const $f3640c90bb365335$var$own = {}.hasOwnProperty;
/** @type {Options} */ const $f3640c90bb365335$var$emptyOptions = {};
function $f3640c90bb365335$export$a18c77a47f4154b6(referenceIndex, rereferenceIndex) {
    return 'Back to reference ' + (referenceIndex + 1) + (rereferenceIndex > 1 ? '-' + rereferenceIndex : '');
}
function $f3640c90bb365335$export$a731a1f6cf81900c(options) {
    const config = options || $f3640c90bb365335$var$emptyOptions;
    const label = config.label || 'Footnotes';
    const labelTagName = config.labelTagName || 'h2';
    const labelAttributes = config.labelAttributes === null || config.labelAttributes === undefined ? 'class="sr-only"' : config.labelAttributes;
    const backLabel = config.backLabel || $f3640c90bb365335$export$a18c77a47f4154b6;
    const clobberPrefix = config.clobberPrefix === null || config.clobberPrefix === undefined ? 'user-content-' : config.clobberPrefix;
    return {
        enter: {
            gfmFootnoteDefinition () {
                const stack = this.getData('tightStack');
                stack.push(false);
            },
            gfmFootnoteDefinitionLabelString () {
                this.buffer();
            },
            gfmFootnoteCallString () {
                this.buffer();
            }
        },
        exit: {
            gfmFootnoteDefinition () {
                let definitions = this.getData('gfmFootnoteDefinitions');
                const footnoteStack = this.getData('gfmFootnoteDefinitionStack');
                const tightStack = this.getData('tightStack');
                const current = footnoteStack.pop();
                const value = this.resume();
                if (!definitions) this.setData('gfmFootnoteDefinitions', definitions = {});
                if (!$f3640c90bb365335$var$own.call(definitions, current)) definitions[current] = value;
                tightStack.pop();
                this.setData('slurpOneLineEnding', true);
                // “Hack” to prevent a line ending from showing up if we’re in a definition in
                // an empty list item.
                this.setData('lastWasTag');
            },
            gfmFootnoteDefinitionLabelString (token) {
                let footnoteStack = this.getData('gfmFootnoteDefinitionStack');
                if (!footnoteStack) this.setData('gfmFootnoteDefinitionStack', footnoteStack = []);
                footnoteStack.push((0, $e8a88a5e1b7aeb38$export$806d55e226cfcd08)(this.sliceSerialize(token)));
                this.resume(); // Drop the label.
                this.buffer(); // Get ready for a value.
            },
            gfmFootnoteCallString (token) {
                let calls = this.getData('gfmFootnoteCallOrder');
                let counts = this.getData('gfmFootnoteCallCounts');
                const id = (0, $e8a88a5e1b7aeb38$export$806d55e226cfcd08)(this.sliceSerialize(token));
                /** @type {number} */ let counter;
                this.resume();
                if (!calls) this.setData('gfmFootnoteCallOrder', calls = []);
                if (!counts) this.setData('gfmFootnoteCallCounts', counts = {});
                const index = calls.indexOf(id);
                const safeId = (0, $921de628cfa25736$export$d130a2d684099e5a)(id.toLowerCase());
                if (index === -1) {
                    calls.push(id);
                    counts[id] = 1;
                    counter = calls.length;
                } else {
                    counts[id]++;
                    counter = index + 1;
                }
                const reuseCounter = counts[id];
                this.tag('<sup><a href="#' + clobberPrefix + 'fn-' + safeId + '" id="' + clobberPrefix + 'fnref-' + safeId + (reuseCounter > 1 ? '-' + reuseCounter : '') + '" data-footnote-ref="" aria-describedby="footnote-label">' + String(counter) + '</a></sup>');
            },
            null () {
                const calls = this.getData('gfmFootnoteCallOrder') || [];
                const counts = this.getData('gfmFootnoteCallCounts') || {};
                const definitions = this.getData('gfmFootnoteDefinitions') || {};
                let index = -1;
                if (calls.length > 0) {
                    this.lineEndingIfNeeded();
                    this.tag('<section data-footnotes="" class="footnotes"><' + labelTagName + ' id="footnote-label"' + (labelAttributes ? ' ' + labelAttributes : '') + '>');
                    this.raw(this.encode(label));
                    this.tag('</' + labelTagName + '>');
                    this.lineEndingIfNeeded();
                    this.tag('<ol>');
                }
                while(++index < calls.length){
                    // Called definitions are always defined.
                    const id = calls[index];
                    const safeId = (0, $921de628cfa25736$export$d130a2d684099e5a)(id.toLowerCase());
                    let referenceIndex = 0;
                    /** @type {Array<string>} */ const references = [];
                    while(++referenceIndex <= counts[id])references.push('<a href="#' + clobberPrefix + 'fnref-' + safeId + (referenceIndex > 1 ? '-' + referenceIndex : '') + '" data-footnote-backref="" aria-label="' + this.encode(typeof backLabel === 'string' ? backLabel : backLabel(index, referenceIndex)) + '" class="data-footnote-backref">\u21A9' + (referenceIndex > 1 ? '<sup>' + referenceIndex + '</sup>' : '') + '</a>');
                    const reference = references.join(' ');
                    let injected = false;
                    this.lineEndingIfNeeded();
                    this.tag('<li id="' + clobberPrefix + 'fn-' + safeId + '">');
                    this.lineEndingIfNeeded();
                    this.tag(definitions[id].replace(/<\/p>(?:\r?\n|\r)?$/, function($0) {
                        injected = true;
                        return ' ' + reference + $0;
                    }));
                    if (!injected) {
                        this.lineEndingIfNeeded();
                        this.tag(reference);
                    }
                    this.lineEndingIfNeeded();
                    this.tag('</li>');
                }
                if (calls.length > 0) {
                    this.lineEndingIfNeeded();
                    this.tag('</ol>');
                    this.lineEndingIfNeeded();
                    this.tag('</section>');
                }
            }
        }
    };
}


/**
 * @import {Options} from 'micromark-extension-gfm-strikethrough'
 * @import {Event, Extension, Resolver, State, Token, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 


function $36b62644f9b507a9$export$8bbec8ea1400a00e(options) {
    const options_ = options || {};
    let single = options_.singleTilde;
    const tokenizer = {
        name: 'strikethrough',
        tokenize: tokenizeStrikethrough,
        resolveAll: resolveAllStrikethrough
    };
    if (single === null || single === undefined) single = true;
    return {
        text: {
            [126]: tokenizer
        },
        insideSpan: {
            null: [
                tokenizer
            ]
        },
        attentionMarkers: {
            null: [
                126
            ]
        }
    };
    /**
   * Take events and resolve strikethrough.
   *
   * @type {Resolver}
   */ function resolveAllStrikethrough(events, context) {
        let index = -1;
        // Walk through all events.
        while(++index < events.length)// Find a token that can close.
        if (events[index][0] === 'enter' && events[index][1].type === 'strikethroughSequenceTemporary' && events[index][1]._close) {
            let open = index;
            // Now walk back to find an opener.
            while(open--)// Find a token that can open the closer.
            if (events[open][0] === 'exit' && events[open][1].type === 'strikethroughSequenceTemporary' && events[open][1]._open && // If the sizes are the same:
            events[index][1].end.offset - events[index][1].start.offset === events[open][1].end.offset - events[open][1].start.offset) {
                events[index][1].type = 'strikethroughSequence';
                events[open][1].type = 'strikethroughSequence';
                /** @type {Token} */ const strikethrough = {
                    type: 'strikethrough',
                    start: Object.assign({}, events[open][1].start),
                    end: Object.assign({}, events[index][1].end)
                };
                /** @type {Token} */ const text = {
                    type: 'strikethroughText',
                    start: Object.assign({}, events[open][1].end),
                    end: Object.assign({}, events[index][1].start)
                };
                // Opening.
                /** @type {Array<Event>} */ const nextEvents = [
                    [
                        'enter',
                        strikethrough,
                        context
                    ],
                    [
                        'enter',
                        events[open][1],
                        context
                    ],
                    [
                        'exit',
                        events[open][1],
                        context
                    ],
                    [
                        'enter',
                        text,
                        context
                    ]
                ];
                const insideSpan = context.parser.constructs.insideSpan.null;
                if (insideSpan) // Between.
                (0, $fc7d276d876e7974$export$869882364835d202)(nextEvents, nextEvents.length, 0, (0, $572427b391443f2d$export$3ff61ec196ff408b)(insideSpan, events.slice(open + 1, index), context));
                // Closing.
                (0, $fc7d276d876e7974$export$869882364835d202)(nextEvents, nextEvents.length, 0, [
                    [
                        'exit',
                        text,
                        context
                    ],
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        strikethrough,
                        context
                    ]
                ]);
                (0, $fc7d276d876e7974$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
                index = open + nextEvents.length - 2;
                break;
            }
        }
        index = -1;
        while(++index < events.length)if (events[index][1].type === 'strikethroughSequenceTemporary') events[index][1].type = "data";
        return events;
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeStrikethrough(effects, ok, nok) {
        const previous = this.previous;
        const events = this.events;
        let size = 0;
        return start;
        /** @type {State} */ function start(code) {
            if (previous === 126 && events[events.length - 1][1].type !== "characterEscape") return nok(code);
            effects.enter('strikethroughSequenceTemporary');
            return more(code);
        }
        /** @type {State} */ function more(code) {
            const before = (0, $0cf80314fdbe73de$export$e3902bc0d835cad0)(previous);
            if (code === 126) {
                // If this is the third marker, exit.
                if (size > 1) return nok(code);
                effects.consume(code);
                size++;
                return more;
            }
            if (size < 2 && !single) return nok(code);
            const token = effects.exit('strikethroughSequenceTemporary');
            const after = (0, $0cf80314fdbe73de$export$e3902bc0d835cad0)(code);
            token._open = !after || after === 2 && Boolean(before);
            token._close = !before || before === 2 && Boolean(after);
            return ok(code);
        }
    }
}

/**
 * @import {HtmlExtension} from 'micromark-util-types'
 */ /**
 * Create an HTML extension for `micromark` to support GFM strikethrough when
 * serializing to HTML.
 *
 * @returns {HtmlExtension}
 *   Extension for `micromark` that can be passed in `htmlExtensions`, to
 *   support GFM strikethrough when serializing to HTML.
 */ function $fe136def82886220$export$58acedca46108820() {
    return {
        enter: {
            strikethrough () {
                this.tag('<del>');
            }
        },
        exit: {
            strikethrough () {
                this.tag('</del>');
            }
        }
    };
}


/**
 * @import {Event, Extension, Point, Resolver, State, Token, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ /**
 * @typedef {[number, number, number, number]} Range
 *   Cell info.
 *
 * @typedef {0 | 1 | 2 | 3} RowKind
 *   Where we are: `1` for head row, `2` for delimiter row, `3` for body row.
 */ 

/**
 * @import {Event} from 'micromark-util-types'
 */ // Port of `edit_map.rs` from `markdown-rs`.
// This should move to `markdown-js` later.
// Deal with several changes in events, batching them together.
//
// Preferably, changes should be kept to a minimum.
// Sometimes, it’s needed to change the list of events, because parsing can be
// messy, and it helps to expose a cleaner interface of events to the compiler
// and other users.
// It can also help to merge many adjacent similar events.
// And, in other cases, it’s needed to parse subcontent: pass some events
// through another tokenizer and inject the result.
/**
 * @typedef {[number, number, Array<Event>]} Change
 * @typedef {[number, number, number]} Jump
 */ /**
 * Tracks a bunch of edits.
 */ class $cbae721c897f35be$export$9348908dd4518b4a {
    /**
   * Create a new edit map.
   */ constructor(){
        /**
     * Record of changes.
     *
     * @type {Array<Change>}
     */ this.map = [];
    }
    /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */ add(index, remove, add) {
        $cbae721c897f35be$var$addImplementation(this, index, remove, add);
    }
    // To do: add this when moving to `micromark`.
    // /**
    //  * Create an edit: but insert `add` before existing additions.
    //  *
    //  * @param {number} index
    //  * @param {number} remove
    //  * @param {Array<Event>} add
    //  * @returns {undefined}
    //  */
    // addBefore(index, remove, add) {
    //   addImplementation(this, index, remove, add, true)
    // }
    /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */ consume(events) {
        this.map.sort(function(a, b) {
            return a[0] - b[0];
        });
        /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (this.map.length === 0) return;
        // To do: if links are added in events, like they are in `markdown-rs`,
        // this is needed.
        // // Calculate jumps: where items in the current list move to.
        // /** @type {Array<Jump>} */
        // const jumps = []
        // let index = 0
        // let addAcc = 0
        // let removeAcc = 0
        // while (index < this.map.length) {
        //   const [at, remove, add] = this.map[index]
        //   removeAcc += remove
        //   addAcc += add.length
        //   jumps.push([at, removeAcc, addAcc])
        //   index += 1
        // }
        //
        // . shiftLinks(events, jumps)
        let index = this.map.length;
        /** @type {Array<Array<Event>>} */ const vecs = [];
        while(index > 0){
            index -= 1;
            vecs.push(events.slice(this.map[index][0] + this.map[index][1]), this.map[index][2]);
            // Truncate rest.
            events.length = this.map[index][0];
        }
        vecs.push([
            ...events
        ]);
        events.length = 0;
        let slice = vecs.pop();
        while(slice){
            events.push(...slice);
            slice = vecs.pop();
        }
        // Truncate everything.
        this.map.length = 0;
    }
}
/**
 * Create an edit.
 *
 * @param {EditMap} editMap
 * @param {number} at
 * @param {number} remove
 * @param {Array<Event>} add
 * @returns {undefined}
 */ function $cbae721c897f35be$var$addImplementation(editMap, at, remove, add) {
    let index = 0;
    /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (remove === 0 && add.length === 0) return;
    while(index < editMap.map.length){
        if (editMap.map[index][0] === at) {
            editMap.map[index][1] += remove;
            // To do: before not used by tables, use when moving to micromark.
            // if (before) {
            //   add.push(...editMap.map[index][2])
            //   editMap.map[index][2] = add
            // } else {
            editMap.map[index][2].push(...add);
            // }
            return;
        }
        index += 1;
    }
    editMap.map.push([
        at,
        remove,
        add
    ]);
} // /**
 //  * Shift `previous` and `next` links according to `jumps`.
 //  *
 //  * This fixes links in case there are events removed or added between them.
 //  *
 //  * @param {Array<Event>} events
 //  * @param {Array<Jump>} jumps
 //  */
 // function shiftLinks(events, jumps) {
 //   let jumpIndex = 0
 //   let index = 0
 //   let add = 0
 //   let rm = 0
 //   while (index < events.length) {
 //     const rmCurr = rm
 //     while (jumpIndex < jumps.length && jumps[jumpIndex][0] <= index) {
 //       add = jumps[jumpIndex][2]
 //       rm = jumps[jumpIndex][1]
 //       jumpIndex += 1
 //     }
 //     // Ignore items that will be removed.
 //     if (rm > rmCurr) {
 //       index += rm - rmCurr
 //     } else {
 //       // ?
 //       // if let Some(link) = &events[index].link {
 //       //     if let Some(next) = link.next {
 //       //         events[next].link.as_mut().unwrap().previous = Some(index + add - rm);
 //       //         while jumpIndex < jumps.len() && jumps[jumpIndex].0 <= next {
 //       //             add = jumps[jumpIndex].2;
 //       //             rm = jumps[jumpIndex].1;
 //       //             jumpIndex += 1;
 //       //         }
 //       //         events[index].link.as_mut().unwrap().next = Some(next + add - rm);
 //       //         index = next;
 //       //         continue;
 //       //     }
 //       // }
 //       index += 1
 //     }
 //   }
 // }


/**
 * @import {Event} from 'micromark-util-types'
 */ /**
 * @typedef {'center' | 'left' | 'none' | 'right'} Align
 */ /**
 * Figure out the alignment of a GFM table.
 *
 * @param {Readonly<Array<Event>>} events
 *   List of events.
 * @param {number} index
 *   Table enter event.
 * @returns {Array<Align>}
 *   List of aligns.
 */ function $d6cfaa8641d3420a$export$bbf4fe2c547a4878(events, index) {
    let inDelimiterRow = false;
    /** @type {Array<Align>} */ const align = [];
    while(index < events.length){
        const event = events[index];
        if (inDelimiterRow) {
            if (event[0] === 'enter') // Start of alignment value: set a new column.
            // To do: `markdown-rs` uses `tableDelimiterCellValue`.
            {
                if (event[1].type === 'tableContent') align.push(events[index + 1][1].type === 'tableDelimiterMarker' ? 'left' : 'none');
            } else if (event[1].type === 'tableContent') {
                if (events[index - 1][1].type === 'tableDelimiterMarker') {
                    const alignIndex = align.length - 1;
                    align[alignIndex] = align[alignIndex] === 'left' ? 'center' : 'right';
                }
            } else if (event[1].type === 'tableDelimiterRow') break;
        } else if (event[0] === 'enter' && event[1].type === 'tableDelimiterRow') inDelimiterRow = true;
        index += 1;
    }
    return align;
}


function $8c31b03181123eb6$export$e36cebda627bf2dd() {
    return {
        flow: {
            null: {
                name: 'table',
                tokenize: $8c31b03181123eb6$var$tokenizeTable,
                resolveAll: $8c31b03181123eb6$var$resolveTable
            }
        }
    };
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $8c31b03181123eb6$var$tokenizeTable(effects, ok, nok) {
    const self = this;
    let size = 0;
    let sizeB = 0;
    /** @type {boolean | undefined} */ let seen;
    return start;
    /**
   * Start of a GFM table.
   *
   * If there is a valid table row or table head before, then we try to parse
   * another row.
   * Otherwise, we try to parse a head.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   * > | | b |
   *     ^
   * ```
   * @type {State}
   */ function start(code) {
        let index = self.events.length - 1;
        while(index > -1){
            const type = self.events[index][1].type;
            if (type === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
            type === "linePrefix") index--;
            else break;
        }
        const tail = index > -1 ? self.events[index][1].type : null;
        const next = tail === 'tableHead' || tail === 'tableRow' ? bodyRowStart : headRowBefore;
        // Don’t allow lazy body rows.
        if (next === bodyRowStart && self.parser.lazy[self.now().line]) return nok(code);
        return next(code);
    }
    /**
   * Before table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBefore(code) {
        effects.enter('tableHead');
        effects.enter('tableRow');
        return headRowStart(code);
    }
    /**
   * Before table head row, after whitespace.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowStart(code) {
        if (code === 124) return headRowBreak(code);
        // To do: micromark-js should let us parse our own whitespace in extensions,
        // like `markdown-rs`:
        //
        // ```js
        // // 4+ spaces.
        // if (markdownSpace(code)) {
        //   return nok(code)
        // }
        // ```
        seen = true;
        // Count the first character, that isn’t a pipe, double.
        sizeB += 1;
        return headRowBreak(code);
    }
    /**
   * At break in table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *       ^
   *         ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBreak(code) {
        if (code === null) // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
        if ((0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            // If anything other than one pipe (ignoring whitespace) was used, it’s fine.
            if (sizeB > 1) {
                sizeB = 0;
                // To do: check if this works.
                // Feel free to interrupt:
                self.interrupt = true;
                effects.exit('tableRow');
                effects.enter("lineEnding");
                effects.consume(code);
                effects.exit("lineEnding");
                return headDelimiterStart;
            }
            // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
            return nok(code);
        }
        if ((0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code)) // To do: check if this is fine.
        // effects.attempt(State::Next(StateName::GfmTableHeadRowBreak), State::Nok)
        // State::Retry(space_or_tab(tokenizer))
        return (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, headRowBreak, "whitespace")(code);
        sizeB += 1;
        if (seen) {
            seen = false;
            // Header cell count.
            size += 1;
        }
        if (code === 124) {
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            // Whether a delimiter was seen.
            seen = true;
            return headRowBreak;
        }
        // Anything else is cell data.
        effects.enter("data");
        return headRowData(code);
    }
    /**
   * In table head row data.
   *
   * ```markdown
   * > | | a |
   *       ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowData(code) {
        if (code === null || code === 124 || (0, $db5865ecc27181ba$export$a30284361b3814b7)(code)) {
            effects.exit("data");
            return headRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? headRowEscape : headRowData;
    }
    /**
   * In table head row escape.
   *
   * ```markdown
   * > | | a\-b |
   *         ^
   *   | | ---- |
   *   | | c    |
   * ```
   *
   * @type {State}
   */ function headRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return headRowData;
        }
        return headRowData(code);
    }
    /**
   * Before delimiter row.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterStart(code) {
        // Reset `interrupt`.
        self.interrupt = false;
        // Note: in `markdown-rs`, we need to handle piercing here too.
        if (self.parser.lazy[self.now().line]) return nok(code);
        effects.enter('tableDelimiterRow');
        // Track if we’ve seen a `:` or `|`.
        seen = false;
        if ((0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code)) return (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, headDelimiterBefore, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
        return headDelimiterBefore(code);
    }
    /**
   * Before delimiter row, after optional whitespace.
   *
   * Reused when a `|` is found later, to parse another cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterBefore(code) {
        if (code === 45 || code === 58) return headDelimiterValueBefore(code);
        if (code === 124) {
            seen = true;
            // If we start with a pipe, we open a cell marker.
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            return headDelimiterCellBefore;
        }
        // More whitespace / empty row not allowed at start.
        return headDelimiterNok(code);
    }
    /**
   * After `|`, before delimiter cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *      ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellBefore(code) {
        if ((0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code)) return (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, headDelimiterValueBefore, "whitespace")(code);
        return headDelimiterValueBefore(code);
    }
    /**
   * Before delimiter cell value.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterValueBefore(code) {
        // Align: left.
        if (code === 58) {
            sizeB += 1;
            seen = true;
            effects.enter('tableDelimiterMarker');
            effects.consume(code);
            effects.exit('tableDelimiterMarker');
            return headDelimiterLeftAlignmentAfter;
        }
        // Align: none.
        if (code === 45) {
            sizeB += 1;
            // To do: seems weird that this *isn’t* left aligned, but that state is used?
            return headDelimiterLeftAlignmentAfter(code);
        }
        if (code === null || (0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) return headDelimiterCellAfter(code);
        return headDelimiterNok(code);
    }
    /**
   * After delimiter cell left alignment marker.
   *
   * ```markdown
   *   | | a  |
   * > | | :- |
   *        ^
   * ```
   *
   * @type {State}
   */ function headDelimiterLeftAlignmentAfter(code) {
        if (code === 45) {
            effects.enter('tableDelimiterFiller');
            return headDelimiterFiller(code);
        }
        // Anything else is not ok after the left-align colon.
        return headDelimiterNok(code);
    }
    /**
   * In delimiter cell filler.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterFiller(code) {
        if (code === 45) {
            effects.consume(code);
            return headDelimiterFiller;
        }
        // Align is `center` if it was `left`, `right` otherwise.
        if (code === 58) {
            seen = true;
            effects.exit('tableDelimiterFiller');
            effects.enter('tableDelimiterMarker');
            effects.consume(code);
            effects.exit('tableDelimiterMarker');
            return headDelimiterRightAlignmentAfter;
        }
        effects.exit('tableDelimiterFiller');
        return headDelimiterRightAlignmentAfter(code);
    }
    /**
   * After delimiter cell right alignment marker.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *         ^
   * ```
   *
   * @type {State}
   */ function headDelimiterRightAlignmentAfter(code) {
        if ((0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code)) return (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, headDelimiterCellAfter, "whitespace")(code);
        return headDelimiterCellAfter(code);
    }
    /**
   * After delimiter cell.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *          ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellAfter(code) {
        if (code === 124) return headDelimiterBefore(code);
        if (code === null || (0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            // Exit when:
            // * there was no `:` or `|` at all (it’s a thematic break or setext
            //   underline instead)
            // * the header cell count is not the delimiter cell count
            if (!seen || size !== sizeB) return headDelimiterNok(code);
            // Note: in markdown-rs`, a reset is needed here.
            effects.exit('tableDelimiterRow');
            effects.exit('tableHead');
            // To do: in `markdown-rs`, resolvers need to be registered manually.
            // effects.register_resolver(ResolveName::GfmTable)
            return ok(code);
        }
        return headDelimiterNok(code);
    }
    /**
   * In delimiter row, at a disallowed byte.
   *
   * ```markdown
   *   | | a |
   * > | | x |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterNok(code) {
        // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
    }
    /**
   * Before table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   * ```
   *
   * @type {State}
   */ function bodyRowStart(code) {
        // Note: in `markdown-rs` we need to manually take care of a prefix,
        // but in `micromark-js` that is done for us, so if we’re here, we’re
        // never at whitespace.
        effects.enter('tableRow');
        return bodyRowBreak(code);
    }
    /**
   * At break in table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   *       ^
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowBreak(code) {
        if (code === 124) {
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            return bodyRowBreak;
        }
        if (code === null || (0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) {
            effects.exit('tableRow');
            return ok(code);
        }
        if ((0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code)) return (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, bodyRowBreak, "whitespace")(code);
        // Anything else is cell content.
        effects.enter("data");
        return bodyRowData(code);
    }
    /**
   * In table body row data.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *       ^
   * ```
   *
   * @type {State}
   */ function bodyRowData(code) {
        if (code === null || code === 124 || (0, $db5865ecc27181ba$export$a30284361b3814b7)(code)) {
            effects.exit("data");
            return bodyRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? bodyRowEscape : bodyRowData;
    }
    /**
   * In table body row escape.
   *
   * ```markdown
   *   | | a    |
   *   | | ---- |
   * > | | b\-c |
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return bodyRowData;
        }
        return bodyRowData(code);
    }
}
/** @type {Resolver} */ function $8c31b03181123eb6$var$resolveTable(events, context) {
    let index = -1;
    let inFirstCellAwaitingPipe = true;
    /** @type {RowKind} */ let rowKind = 0;
    /** @type {Range} */ let lastCell = [
        0,
        0,
        0,
        0
    ];
    /** @type {Range} */ let cell = [
        0,
        0,
        0,
        0
    ];
    let afterHeadAwaitingFirstBodyRow = false;
    let lastTableEnd = 0;
    /** @type {Token | undefined} */ let currentTable;
    /** @type {Token | undefined} */ let currentBody;
    /** @type {Token | undefined} */ let currentCell;
    const map = new (0, $cbae721c897f35be$export$9348908dd4518b4a)();
    while(++index < events.length){
        const event = events[index];
        const token = event[1];
        if (event[0] === 'enter') {
            // Start of head.
            if (token.type === 'tableHead') {
                afterHeadAwaitingFirstBodyRow = false;
                // Inject previous (body end and) table end.
                if (lastTableEnd !== 0) {
                    $8c31b03181123eb6$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
                    currentBody = undefined;
                    lastTableEnd = 0;
                }
                // Inject table start.
                currentTable = {
                    type: 'table',
                    start: Object.assign({}, token.start),
                    // Note: correct end is set later.
                    end: Object.assign({}, token.end)
                };
                map.add(index, 0, [
                    [
                        'enter',
                        currentTable,
                        context
                    ]
                ]);
            } else if (token.type === 'tableRow' || token.type === 'tableDelimiterRow') {
                inFirstCellAwaitingPipe = true;
                currentCell = undefined;
                lastCell = [
                    0,
                    0,
                    0,
                    0
                ];
                cell = [
                    0,
                    index + 1,
                    0,
                    0
                ];
                // Inject table body start.
                if (afterHeadAwaitingFirstBodyRow) {
                    afterHeadAwaitingFirstBodyRow = false;
                    currentBody = {
                        type: 'tableBody',
                        start: Object.assign({}, token.start),
                        // Note: correct end is set later.
                        end: Object.assign({}, token.end)
                    };
                    map.add(index, 0, [
                        [
                            'enter',
                            currentBody,
                            context
                        ]
                    ]);
                }
                rowKind = token.type === 'tableDelimiterRow' ? 2 : currentBody ? 3 : 1;
            } else if (rowKind && (token.type === "data" || token.type === 'tableDelimiterMarker' || token.type === 'tableDelimiterFiller')) {
                inFirstCellAwaitingPipe = false;
                // First value in cell.
                if (cell[2] === 0) {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $8c31b03181123eb6$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                        lastCell = [
                            0,
                            0,
                            0,
                            0
                        ];
                    }
                    cell[2] = index;
                }
            } else if (token.type === 'tableCellDivider') {
                if (inFirstCellAwaitingPipe) inFirstCellAwaitingPipe = false;
                else {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $8c31b03181123eb6$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                    }
                    lastCell = cell;
                    cell = [
                        lastCell[1],
                        index,
                        0,
                        0
                    ];
                }
            }
        } else if (token.type === 'tableHead') {
            afterHeadAwaitingFirstBodyRow = true;
            lastTableEnd = index;
        } else if (token.type === 'tableRow' || token.type === 'tableDelimiterRow') {
            lastTableEnd = index;
            if (lastCell[1] !== 0) {
                cell[0] = cell[1];
                currentCell = $8c31b03181123eb6$var$flushCell(map, context, lastCell, rowKind, index, currentCell);
            } else if (cell[1] !== 0) currentCell = $8c31b03181123eb6$var$flushCell(map, context, cell, rowKind, index, currentCell);
            rowKind = 0;
        } else if (rowKind && (token.type === "data" || token.type === 'tableDelimiterMarker' || token.type === 'tableDelimiterFiller')) cell[3] = index;
    }
    if (lastTableEnd !== 0) $8c31b03181123eb6$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
    map.consume(context.events);
    // To do: move this into `html`, when events are exposed there.
    // That’s what `markdown-rs` does.
    // That needs updates to `mdast-util-gfm-table`.
    index = -1;
    while(++index < context.events.length){
        const event = context.events[index];
        if (event[0] === 'enter' && event[1].type === 'table') event[1]._align = (0, $d6cfaa8641d3420a$export$bbf4fe2c547a4878)(context.events, index);
    }
    return events;
}
/**
 * Generate a cell.
 *
 * @param {EditMap} map
 * @param {Readonly<TokenizeContext>} context
 * @param {Readonly<Range>} range
 * @param {RowKind} rowKind
 * @param {number | undefined} rowEnd
 * @param {Token | undefined} previousCell
 * @returns {Token | undefined}
 */ // eslint-disable-next-line max-params
function $8c31b03181123eb6$var$flushCell(map, context, range, rowKind, rowEnd, previousCell) {
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCell' : 'tableCell'
    const groupName = rowKind === 1 ? 'tableHeader' : rowKind === 2 ? 'tableDelimiter' : 'tableData';
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCellValue' : 'tableCellText'
    const valueName = 'tableContent';
    // Insert an exit for the previous cell, if there is one.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //          ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[0] !== 0) {
        previousCell.end = Object.assign({}, $8c31b03181123eb6$var$getPoint(context.events, range[0]));
        map.add(range[0], 0, [
            [
                'exit',
                previousCell,
                context
            ]
        ]);
    }
    // Insert enter of this cell.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //           ^-- enter
    //           ^^^^-- this cell
    // ```
    const now = $8c31b03181123eb6$var$getPoint(context.events, range[1]);
    previousCell = {
        type: groupName,
        start: Object.assign({}, now),
        // Note: correct end is set later.
        end: Object.assign({}, now)
    };
    map.add(range[1], 0, [
        [
            'enter',
            previousCell,
            context
        ]
    ]);
    // Insert text start at first data start and end at last data end, and
    // remove events between.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //            ^-- enter
    //             ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[2] !== 0) {
        const relatedStart = $8c31b03181123eb6$var$getPoint(context.events, range[2]);
        const relatedEnd = $8c31b03181123eb6$var$getPoint(context.events, range[3]);
        /** @type {Token} */ const valueToken = {
            type: valueName,
            start: Object.assign({}, relatedStart),
            end: Object.assign({}, relatedEnd)
        };
        map.add(range[2], 0, [
            [
                'enter',
                valueToken,
                context
            ]
        ]);
        if (rowKind !== 2) {
            // Fix positional info on remaining events
            const start = context.events[range[2]];
            const end = context.events[range[3]];
            start[1].end = Object.assign({}, end[1].end);
            start[1].type = "chunkText";
            start[1].contentType = "text";
            // Remove if needed.
            if (range[3] > range[2] + 1) {
                const a = range[2] + 1;
                const b = range[3] - range[2] - 1;
                map.add(a, b, []);
            }
        }
        map.add(range[3] + 1, 0, [
            [
                'exit',
                valueToken,
                context
            ]
        ]);
    }
    // Insert an exit for the last cell, if at the row end.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //                    ^-- exit
    //               ^^^^^^-- this cell (the last one contains two “between” parts)
    // ```
    if (rowEnd !== undefined) {
        previousCell.end = Object.assign({}, $8c31b03181123eb6$var$getPoint(context.events, rowEnd));
        map.add(rowEnd, 0, [
            [
                'exit',
                previousCell,
                context
            ]
        ]);
        previousCell = undefined;
    }
    return previousCell;
}
/**
 * Generate table end (and table body end).
 *
 * @param {Readonly<EditMap>} map
 * @param {Readonly<TokenizeContext>} context
 * @param {number} index
 * @param {Token} table
 * @param {Token | undefined} tableBody
 */ // eslint-disable-next-line max-params
function $8c31b03181123eb6$var$flushTableEnd(map, context, index, table, tableBody) {
    /** @type {Array<Event>} */ const exits = [];
    const related = $8c31b03181123eb6$var$getPoint(context.events, index);
    if (tableBody) {
        tableBody.end = Object.assign({}, related);
        exits.push([
            'exit',
            tableBody,
            context
        ]);
    }
    table.end = Object.assign({}, related);
    exits.push([
        'exit',
        table,
        context
    ]);
    map.add(index + 1, 0, exits);
}
/**
 * @param {Readonly<Array<Event>>} events
 * @param {number} index
 * @returns {Readonly<Point>}
 */ function $8c31b03181123eb6$var$getPoint(events, index) {
    const event = events[index];
    const side = event[0] === 'enter' ? 'start' : 'end';
    return event[1][side];
}

/**
 * @import {HtmlExtension} from 'micromark-util-types'
 */ const $8f001556f7deba89$var$alignment = {
    none: '',
    left: ' align="left"',
    right: ' align="right"',
    center: ' align="center"'
};
function $8f001556f7deba89$export$c64626c032567c7f() {
    return {
        enter: {
            table (token) {
                const tableAlign = token._align;
                this.lineEndingIfNeeded();
                this.tag('<table>');
                this.setData('tableAlign', tableAlign);
            },
            tableBody () {
                this.tag('<tbody>');
            },
            tableData () {
                const tableAlign = this.getData('tableAlign');
                const tableColumn = this.getData('tableColumn');
                const align = $8f001556f7deba89$var$alignment[tableAlign[tableColumn]];
                if (align === undefined) // Capture results to ignore them.
                this.buffer();
                else {
                    this.lineEndingIfNeeded();
                    this.tag('<td' + align + '>');
                }
            },
            tableHead () {
                this.lineEndingIfNeeded();
                this.tag('<thead>');
            },
            tableHeader () {
                const tableAlign = this.getData('tableAlign');
                const tableColumn = this.getData('tableColumn');
                const align = $8f001556f7deba89$var$alignment[tableAlign[tableColumn]];
                this.lineEndingIfNeeded();
                this.tag('<th' + align + '>');
            },
            tableRow () {
                this.setData('tableColumn', 0);
                this.lineEndingIfNeeded();
                this.tag('<tr>');
            }
        },
        exit: {
            // Overwrite the default code text data handler to unescape escaped pipes when
            // they are in tables.
            codeTextData (token) {
                let value = this.sliceSerialize(token);
                if (this.getData('tableAlign')) value = value.replace(/\\([\\|])/g, $8f001556f7deba89$var$replace);
                this.raw(this.encode(value));
            },
            table () {
                this.setData('tableAlign');
                // Note: we don’t set `slurpAllLineEndings` anymore, in delimiter rows,
                // but we do need to reset it to match a funky newline GH generates for
                // list items combined with tables.
                this.setData('slurpAllLineEndings');
                this.lineEndingIfNeeded();
                this.tag('</table>');
            },
            tableBody () {
                this.lineEndingIfNeeded();
                this.tag('</tbody>');
            },
            tableData () {
                const tableAlign = this.getData('tableAlign');
                const tableColumn = this.getData('tableColumn');
                if (tableColumn in tableAlign) {
                    this.tag('</td>');
                    this.setData('tableColumn', tableColumn + 1);
                } else // Stop capturing.
                this.resume();
            },
            tableHead () {
                this.lineEndingIfNeeded();
                this.tag('</thead>');
            },
            tableHeader () {
                const tableColumn = this.getData('tableColumn');
                this.tag('</th>');
                this.setData('tableColumn', tableColumn + 1);
            },
            tableRow () {
                const tableAlign = this.getData('tableAlign');
                let tableColumn = this.getData('tableColumn');
                while(tableColumn < tableAlign.length){
                    this.lineEndingIfNeeded();
                    this.tag('<td' + $8f001556f7deba89$var$alignment[tableAlign[tableColumn]] + '></td>');
                    tableColumn++;
                }
                this.setData('tableColumn', tableColumn);
                this.lineEndingIfNeeded();
                this.tag('</tr>');
            }
        }
    };
}
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $8f001556f7deba89$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === '|' ? $1 : $0;
}


/**
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */ // An opening or closing tag start, followed by a case-insensitive specific tag name,
// followed by HTML whitespace, a greater than, or a slash.
const $8bbd25eed411eebd$var$reFlow = /<(\/?)(iframe|noembed|noframes|plaintext|script|style|title|textarea|xmp)(?=[\t\n\f\r />])/gi;
// As HTML (text) parses tags separately (and very strictly), we don’t need to be
// global.
const $8bbd25eed411eebd$var$reText = new RegExp('^' + $8bbd25eed411eebd$var$reFlow.source, 'i');
function $8bbd25eed411eebd$export$c9bf87ea36d00682() {
    return {
        exit: {
            htmlFlowData (token) {
                $8bbd25eed411eebd$var$exitHtmlData.call(this, token, $8bbd25eed411eebd$var$reFlow);
            },
            htmlTextData (token) {
                $8bbd25eed411eebd$var$exitHtmlData.call(this, token, $8bbd25eed411eebd$var$reText);
            }
        }
    };
}
/**
 * @this {CompileContext}
 * @param {Token} token
 * @param {RegExp} filter
 * @returns {undefined}
 */ function $8bbd25eed411eebd$var$exitHtmlData(token, filter) {
    let value = this.sliceSerialize(token);
    if (this.options.allowDangerousHtml) value = value.replace(filter, '&lt;$1$2');
    this.raw(this.encode(value));
}


/**
 * @import {Extension, State, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 

const $88040cd4da1e77c1$var$tasklistCheck = {
    name: 'tasklistCheck',
    tokenize: $88040cd4da1e77c1$var$tokenizeTasklistCheck
};
function $88040cd4da1e77c1$export$2912e8b2802475ff() {
    return {
        text: {
            [91]: $88040cd4da1e77c1$var$tasklistCheck
        }
    };
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $88040cd4da1e77c1$var$tokenizeTasklistCheck(effects, ok, nok) {
    const self = this;
    return open;
    /**
   * At start of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (// Exit if there’s stuff before.
        self.previous !== null || // Exit if not in the first content that is the first child of a list
        // item.
        !self._gfmTasklistFirstContentOfListItem) return nok(code);
        effects.enter('taskListCheck');
        effects.enter('taskListCheckMarker');
        effects.consume(code);
        effects.exit('taskListCheckMarker');
        return inside;
    }
    /**
   * In task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *        ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // Currently we match how GH works in files.
        // To match how GH works in comments, use `markdownSpace` (`[\t ]`) instead
        // of `markdownLineEndingOrSpace` (`[\t\n\r ]`).
        if ((0, $db5865ecc27181ba$export$a30284361b3814b7)(code)) {
            effects.enter('taskListCheckValueUnchecked');
            effects.consume(code);
            effects.exit('taskListCheckValueUnchecked');
            return close;
        }
        if (code === 88 || code === 120) {
            effects.enter('taskListCheckValueChecked');
            effects.consume(code);
            effects.exit('taskListCheckValueChecked');
            return close;
        }
        return nok(code);
    }
    /**
   * At close of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *         ^
   * ```
   *
   * @type {State}
   */ function close(code) {
        if (code === 93) {
            effects.enter('taskListCheckMarker');
            effects.consume(code);
            effects.exit('taskListCheckMarker');
            effects.exit('taskListCheck');
            return after;
        }
        return nok(code);
    }
    /**
   * @type {State}
   */ function after(code) {
        // EOL in paragraph means there must be something else after it.
        if ((0, $db5865ecc27181ba$export$34a1dff1c0936953)(code)) return ok(code);
        // Space or tab?
        // Check what comes after.
        if ((0, $db5865ecc27181ba$export$2c6cf65c1127992a)(code)) return effects.check({
            tokenize: $88040cd4da1e77c1$var$spaceThenNonSpace
        }, ok, nok)(code);
        // EOF, or non-whitespace, both wrong.
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $88040cd4da1e77c1$var$spaceThenNonSpace(effects, ok, nok) {
    return (0, $9ffa6a5710aabe9f$export$ae105c1eb063a0a2)(effects, after, "whitespace");
    /**
   * After whitespace, after task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *           ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // EOF means there was nothing, so bad.
        // EOL means there’s content after it, so good.
        // Impossible to have more spaces.
        // Anything else is good.
        return code === null ? nok(code) : ok(code);
    }
}

/**
 * @import {HtmlExtension} from 'micromark-util-types'
 */ /**
 * Create an HTML extension for `micromark` to support GFM task list items when
 * serializing to HTML.
 *
 * @returns {HtmlExtension}
 *   Extension for `micromark` that can be passed in `htmlExtensions` to
 *   support GFM task list items when serializing to HTML.
 */ function $dce9efc1a1f1635b$export$4b6a13e2af1b08ed() {
    return {
        enter: {
            taskListCheck () {
                this.tag('<input type="checkbox" disabled="" ');
            }
        },
        exit: {
            taskListCheck () {
                this.tag('/>');
            },
            taskListCheckValueChecked () {
                this.tag('checked="" ');
            }
        }
    };
}


function $12783eb98083d4a5$export$59ffe8c4d7a4aab2(options) {
    return (0, $b9be7a96f8f7c619$export$86a865d89ef3c690)([
        (0, $4b9ba092cca951b6$export$608123d9b549151)(),
        (0, $d11961ba3aedc2b1$export$c82499b6656305df)(),
        (0, $36b62644f9b507a9$export$8bbec8ea1400a00e)(options),
        (0, $8c31b03181123eb6$export$e36cebda627bf2dd)(),
        (0, $88040cd4da1e77c1$export$2912e8b2802475ff)()
    ]);
}
function $12783eb98083d4a5$export$6983b82e6105d62a(options) {
    return (0, $b9be7a96f8f7c619$export$eaf8c406dfb0a620)([
        (0, $06454b1cfbaf9a2a$export$999603f1f1c3d2f9)(),
        (0, $f3640c90bb365335$export$a731a1f6cf81900c)(options),
        (0, $fe136def82886220$export$58acedca46108820)(),
        (0, $8f001556f7deba89$export$c64626c032567c7f)(),
        (0, $8bbd25eed411eebd$export$c9bf87ea36d00682)(),
        (0, $dce9efc1a1f1635b$export$4b6a13e2af1b08ed)()
    ]);
}


/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $62c5594a1448658d$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
var $62c5594a1448658d$export$2e2bcd8739ae039 = $62c5594a1448658d$var$last;


const $c7dc11338dfe0efc$var$getNextType = (ancestors, node)=>{
    var _a, _b;
    const child = (_a = (0, $62c5594a1448658d$export$2e2bcd8739ae039)(ancestors)) === null || _a === void 0 ? void 0 : _a.children;
    const nextType = (_b = child === null || child === void 0 ? void 0 : child[child.indexOf(node) + 1]) === null || _b === void 0 ? void 0 : _b.type;
    return nextType !== null && nextType !== void 0 ? nextType : 'lastOne';
};
const $c7dc11338dfe0efc$var$root = ({ node: node, process: handle, ancestors: ancestors })=>{
    if (node.type !== 'root') return;
    node.children.forEach((it)=>handle(it, [
            ...ancestors,
            node
        ]));
    return true;
};
const $c7dc11338dfe0efc$var$paragraph = ({ node: node, process: handle, ancestors: ancestors, ops: ops })=>{
    if (node.type !== 'paragraph') return;
    node.children.forEach((it)=>handle(it, [
            ...ancestors,
            node
        ]));
    ops.push({
        insert: '\n'
    });
    // if (['paragraph', 'code', 'heading'].includes(getNextType(ancestors, node))) {
    //   ops.push({ insert: '\n' } as Op)
    // }
    return true;
};
const $c7dc11338dfe0efc$var$text = ({ node: node, ancestors: ancestors, ops: ops })=>{
    if (node.type !== 'text') return;
    const attrs = {};
    if (ancestors.find((it)=>it.type === 'strong')) attrs.bold = true;
    if (ancestors.find((it)=>it.type === 'emphasis')) attrs.italic = true;
    if (ancestors.find((it)=>it.type === 'delete')) attrs.strike = true;
    if (Object.keys(attrs).length > 0) ops.push({
        insert: node.value,
        attributes: attrs
    });
    else ops.push({
        insert: node.value
    });
    return true;
};
const $c7dc11338dfe0efc$var$strong = ({ node: node, ancestors: ancestors, ops: ops, process: handle })=>{
    if (node.type !== 'strong' && node.type !== 'emphasis' && node.type !== 'delete') return;
    const attrs = {};
    if (node.type === 'strong') attrs.bold = true;
    if (node.type === 'emphasis') attrs.italic = true;
    if (node.type === 'delete') attrs.strike = true;
    node.children.forEach((it)=>handle(it, [
            ...ancestors,
            node
        ]));
    return true;
};
const $c7dc11338dfe0efc$var$heading = ({ node: node, ancestors: ancestors, ops: ops, process: handle })=>{
    if (node.type !== 'heading') return;
    node.children.forEach((it)=>handle(it, [
            ...ancestors,
            node
        ]));
    ops.push({
        insert: '\n',
        attributes: {
            header: node.depth
        }
    });
    return true;
};
const $c7dc11338dfe0efc$var$list = ({ node: node, ancestors: ancestors, process: handle })=>{
    if (node.type !== 'list') return;
    node.children.forEach((it)=>handle(it, [
            ...ancestors,
            node
        ]));
    // if (getNextType(ancestors, node) === 'list') {
    //   ops.push({ insert: '\n' } as Op)
    // }
    return true;
};
const $c7dc11338dfe0efc$var$listItem = ({ node: node, ancestors: ancestors, ops: ops, process: handle })=>{
    var _a, _b;
    if (node.type !== 'listItem') return;
    const item = node;
    item.children.filter((it)=>it.type !== 'list').forEach((it)=>handle(it, [
            ...ancestors,
            node
        ]));
    if (((_a = (0, $62c5594a1448658d$export$2e2bcd8739ae039)(ops)) === null || _a === void 0 ? void 0 : _a.insert) === '\n' && !((_b = (0, $62c5594a1448658d$export$2e2bcd8739ae039)(ops)) === null || _b === void 0 ? void 0 : _b.attributes)) ops.pop();
    const list = ancestors.filter((it)=>it.type === 'list');
    const lastList = (0, $62c5594a1448658d$export$2e2bcd8739ae039)(list);
    const op = {
        insert: '\n',
        attributes: {
            list: item.checked === null ? (lastList === null || lastList === void 0 ? void 0 : lastList.ordered) ? 'ordered' : 'bullet' : item.checked ? 'checked' : 'unchecked'
        }
    };
    if (list.length > 1) op.attributes.indent = list.length - 1;
    ops.push(op);
    item.children.filter((it)=>it.type === 'list').forEach((it)=>handle(it, [
            ...ancestors,
            node
        ]));
    return true;
};
const $c7dc11338dfe0efc$var$blockquote = ({ node: node, ancestors: ancestors, ops: ops, process: handle })=>{
    var _a, _b;
    if (node.type !== 'blockquote') return;
    node.children.forEach((it)=>handle(it, [
            ...ancestors,
            node
        ]));
    if (((_a = (0, $62c5594a1448658d$export$2e2bcd8739ae039)(ops)) === null || _a === void 0 ? void 0 : _a.insert) === '\n' && !((_b = (0, $62c5594a1448658d$export$2e2bcd8739ae039)(ops)) === null || _b === void 0 ? void 0 : _b.attributes)) ops.pop();
    ops.push({
        insert: '\n',
        attributes: {
            blockquote: true
        }
    });
    return true;
};
const $c7dc11338dfe0efc$var$link = ({ node: node, ancestors: ancestors, ops: ops, process: handle })=>{
    if (node.type !== 'link') return;
    node.children.forEach((child)=>{
        ops.push({
            insert: child.value,
            attributes: {
                link: node.url
            }
        });
    });
    return true;
};
const $c7dc11338dfe0efc$var$image = ({ node: node, ancestors: ancestors, ops: ops, process: handle })=>{
    if (node.type !== 'image') return;
    ops.push({
        insert: {
            image: node.url
        },
        attributes: {
            alt: node.alt
        }
    });
    return true;
};
const $c7dc11338dfe0efc$var$code = ({ node: node, ancestors: ancestors, ops: ops, process: handle })=>{
    if (node.type !== 'code') return;
    ops.push({
        insert: node.value
    }, {
        insert: '\n',
        attributes: {
            'code-block': true
        }
    });
    // if (['paragraph'].includes(getNextType(ancestors, node))) {
    //   ops.push({ insert: '\n' } as Op)
    // }
    return true;
};
const $c7dc11338dfe0efc$var$inlineCode = ({ node: node, ancestors: ancestors, ops: ops, process: handle })=>{
    if (node.type !== 'inlineCode') return;
    ops.push({
        insert: node.value,
        attributes: {
            code: true
        }
    });
    return true;
};
const $c7dc11338dfe0efc$var$generic = ({ node: node, ancestors: ancestors, ops: ops })=>{
    ops.push({
        insert: (0, $4a5f4556202d090e$export$49a1dda9e62e8ae6)(node, {
            extensions: [
                (0, $bfee282aacc89190$export$ea77de6901e7c72b)()
            ]
        })
    });
    return true;
};
function $c7dc11338dfe0efc$var$markdownToDelta(source, options = {}) {
    let ast;
    if (typeof source === 'string') ast = (0, $ad13aef915352c90$export$d744d789c09bfde6)(source, {
        extensions: [
            (0, $12783eb98083d4a5$export$59ffe8c4d7a4aab2)()
        ],
        mdastExtensions: [
            (0, $bfee282aacc89190$export$95adae814eb7433e)()
        ]
    });
    else ast = source;
    const ops = [];
    function process(node, ancestors) {
        const handles = [
            $c7dc11338dfe0efc$var$root,
            $c7dc11338dfe0efc$var$paragraph,
            $c7dc11338dfe0efc$var$text,
            $c7dc11338dfe0efc$var$strong,
            $c7dc11338dfe0efc$var$heading,
            $c7dc11338dfe0efc$var$list,
            $c7dc11338dfe0efc$var$listItem,
            $c7dc11338dfe0efc$var$blockquote,
            $c7dc11338dfe0efc$var$link,
            $c7dc11338dfe0efc$var$image,
            $c7dc11338dfe0efc$var$code,
            $c7dc11338dfe0efc$var$inlineCode,
            $c7dc11338dfe0efc$var$generic
        ];
        if (options.handle) handles.unshift(options.handle);
        for (const handle of handles){
            const result = handle({
                node: node,
                ancestors: ancestors,
                ops: ops,
                process: process
            });
            if (result) return;
        }
    }
    process(ast, []);
    return ops;
}
var $c7dc11338dfe0efc$export$2e2bcd8739ae039 = $c7dc11338dfe0efc$var$markdownToDelta;


const $4bd848e8e930fa6d$var$region = "eu-west-2";
const $4bd848e8e930fa6d$var$cognitoIdentityPoolId = `eu-west-2:fb5bdf50-29b1-4de5-a33e-3937ef1cef58`;
const $4bd848e8e930fa6d$var$bedrockRoleArn = "arn:aws:iam::162252354798:role/service-role/Bedrock_access";
// select model 
const $4bd848e8e930fa6d$var$modelId = "meta.llama3-8b-instruct-v1:0";
// set the system prompt
const $4bd848e8e930fa6d$var$systemPrompt = [
    {
        text: `Please answer questions using Markdown format. Answer concisely in no more than 200 words 
    Structure the answer in these sections: introduction, bullet points, summary.
    Do not include a title or section headings. Start the answer with: 
    "#### _This text has been generated by AI._". `
    }
];
//import { MarkdownToQuill } from 'md-to-quill-delta';
async function $4bd848e8e930fa6d$var$chat(userMessage) {
    try {
        const config = {
            region: $4bd848e8e930fa6d$var$region
        };
        // get guest identity id
        const cognitoClient = new (0, $9394dfc236f09272$export$e576def690e850f7)(config);
        const idResponse = await cognitoClient.send(new (0, $3224f2601b4ee115$export$41ceb4ced4f97a44)({
            IdentityPoolId: $4bd848e8e930fa6d$var$cognitoIdentityPoolId
        }));
        const id = idResponse.IdentityId;
        // get access token
        const tokenResponse = await cognitoClient.send(new (0, $d7650b27571c5709$export$26a6f172ed1f595a)({
            IdentityId: id
        }));
        const token = tokenResponse.Token;
        // get credential with session policy
        const stsClient = new (0, $db3aafa569e5b933$export$c9157f234d7f779)(config);
        const credentialsResponse = await stsClient.send(new (0, $3005c366f8041d75$export$4fa277828e31b661)({
            RoleArn: $4bd848e8e930fa6d$var$bedrockRoleArn,
            WebIdentityToken: token,
            RoleSessionName: "bedrock_session"
        }));
        const credentials = credentialsResponse.Credentials;
        // get bedrock client using the credential
        const bedrockClient = new (0, $cbca8837a0c60e3d$export$6372a0043ccbda8)({
            region: $4bd848e8e930fa6d$var$region,
            credentials: {
                accessKeyId: credentials.AccessKeyId,
                secretAccessKey: credentials.SecretAccessKey,
                expiration: credentials.Expiration,
                sessionToken: credentials.SessionToken
            }
        });
        const conversation = [
            {
                role: "user",
                content: [
                    {
                        text: userMessage
                    }
                ]
            }
        ];
        // Create a command with the model ID, the message, and a basic configuration.
        const command = new (0, $b72ea2f10b136254$export$6b2edff15292259b)({
            modelId: $4bd848e8e930fa6d$var$modelId,
            messages: conversation,
            system: $4bd848e8e930fa6d$var$systemPrompt,
            inferenceConfig: {
                maxTokens: 512,
                temperature: 0.5,
                topP: 0.9
            }
        });
        // Send the command to the model and wait for the response
        const response = await bedrockClient.send(command);
        // Extract and return the response text.
        const responseText = response.output.message.content[0].text;
        console.log(response);
        return responseText;
    } catch (err) {
        console.log(`ERROR: Can't invoke '${$4bd848e8e930fa6d$var$modelId}'. Reason: ${err}`);
    }
}
async function $4bd848e8e930fa6d$export$d96944eb3d865634(question) {
    let markdown = await $4bd848e8e930fa6d$var$chat(question);
    return (0, $c7dc11338dfe0efc$export$2e2bcd8739ae039)(markdown);
}



var $gMLdp = parcelRequire("gMLdp");

var $3gspO = parcelRequire("3gspO");
const $e1c55b086cf8dd0e$var$appName = 'Participatory System Mapper';
const $e1c55b086cf8dd0e$var$shortAppName = 'PRSM';
const $e1c55b086cf8dd0e$var$GRIDSPACING = 50 // for snap to grid
;
const $e1c55b086cf8dd0e$var$NODEWIDTH = 10 // chars for label splitting
;
const $e1c55b086cf8dd0e$var$TIMETOSLEEP = 900000 // if no mouse movement for this time, user is assumed to have left or is sleeping
;
const $e1c55b086cf8dd0e$var$TIMETOEDIT = 300000 // if node/edge edit dialog is not saved after this time, the edit is cancelled
;
const $e1c55b086cf8dd0e$var$magnification = 3 // magnification of the loupe (magnifier 'glass')
;
const $e1c55b086cf8dd0e$export$4448800f068b9d2f = 20 // max. number of levels for trophic layout
;
const $e1c55b086cf8dd0e$var$ROLLBACKS = 10 // max. number of versions stored for rollback
;
const $e1c55b086cf8dd0e$var$SLOWTRIPTIME = 1000 // any more than this number of ms for the round trip generates a warning
;
var $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4;
var $e1c55b086cf8dd0e$export$f9d3fff8c23da278;
var $e1c55b086cf8dd0e$export$1c9f709888824e05 = '';
var $e1c55b086cf8dd0e$var$viewOnly // when true, user can only view, not modify, the network
;
var $e1c55b086cf8dd0e$var$showCopyMapButton = false // show the Copy Map button on the navbar in viewOnly mode
;
var $e1c55b086cf8dd0e$var$nodes // a dataset of nodes
;
var $e1c55b086cf8dd0e$var$edges // a dataset of edges
;
var $e1c55b086cf8dd0e$export$4051a07651545597 // an object with the nodes and edges datasets as properties
;
const $e1c55b086cf8dd0e$export$2a111da947c407d2 = new $lc1R0.Doc();
var $e1c55b086cf8dd0e$export$3f859614deccc31b = 'wss://www.prsm.uk/wss' // web socket server URL
;
var $e1c55b086cf8dd0e$var$wsProvider // web socket provider
;
var $e1c55b086cf8dd0e$export$4d35f98e5d7d0978 // unique ID for this browser
;
var $e1c55b086cf8dd0e$var$yNodesMap // shared map of nodes
;
var $e1c55b086cf8dd0e$var$yEdgesMap // shared map of edges
;
var $e1c55b086cf8dd0e$export$4b63d58d2685a993 // shared map of styles
;
var $e1c55b086cf8dd0e$export$807f940a96777041 // shared map of global network settings
;
var $e1c55b086cf8dd0e$export$ffba1a0e51177788 // shared array of the background drawing commands
;
var $e1c55b086cf8dd0e$export$da7062de5ac36f9c // shared map of background objects
;
var $e1c55b086cf8dd0e$export$f796f85272199be2 // shared list of commands for undo
;
var $e1c55b086cf8dd0e$var$dontUndo // when non-null, don't add an item to the undo stack
;
var $e1c55b086cf8dd0e$var$yAwareness // awareness channel
;
var $e1c55b086cf8dd0e$export$d920e34eaf2b21cb // log of actions
;
var $e1c55b086cf8dd0e$export$34e0f9847d4c02dd //the DOM body element
;
var $e1c55b086cf8dd0e$export$4b72f5d71fff605 // the DOM pane showing the network
;
var $e1c55b086cf8dd0e$var$panel // the DOM right side panel element
;
var $e1c55b086cf8dd0e$var$myNameRec // the user's name record {actual name, type, etc.}
;
var $e1c55b086cf8dd0e$export$794b27baf354ffba = 'group0' // the last used node style
;
var $e1c55b086cf8dd0e$export$a01f2d76756b77a5 = 'edge0' // the last used edge style
;
/** @type {(string|boolean)} */ var $e1c55b086cf8dd0e$var$inAddMode = false // true when adding a new Factor to the network; used to choose cursor pointer
;
var $e1c55b086cf8dd0e$var$inEditMode = false //true when node or edge is being edited (dialog is open)
;
var $e1c55b086cf8dd0e$var$snapToGridToggle = false // true when snapping nodes to the (unseen) grid
;
var $e1c55b086cf8dd0e$export$c05995454a6ca00d = false // true when the drawing layer is uppermost
;
var $e1c55b086cf8dd0e$var$showNotesToggle = true // show notes when factors and links are selected
;
var $e1c55b086cf8dd0e$var$showVotingToggle = false // whether to show the voting thumb up/down buttons under factors
;
// if set, there are  nodes that need to be hidden when the map is drawn for the first time
var $e1c55b086cf8dd0e$var$hiddenNodes = {
    radiusSetting: null,
    streamSetting: null,
    pathsSetting: null,
    selected: []
};
var $e1c55b086cf8dd0e$var$tutorial = new (0, $d483874c34c7b530$export$2e2bcd8739ae039)() // object driving the tutorial
;
var $e1c55b086cf8dd0e$export$cd571ca6d1702b73 = new (0, $gFW3W.CP)();
// color picker
var $e1c55b086cf8dd0e$var$checkMapSaved = false // if the map is new (no 'room' in URL), or has been imported from a file, and changes have been made, warn user before quitting
;
var $e1c55b086cf8dd0e$var$dirty = false // map has been changed by user and may need saving
;
var $e1c55b086cf8dd0e$var$hammer // Hammer pinch recogniser instance
;
var $e1c55b086cf8dd0e$var$followme // clientId of user's cursor to follow
;
var $e1c55b086cf8dd0e$var$editor = null // Quill editor
;
var $e1c55b086cf8dd0e$var$popupWindow = null // window for editing Notes
;
var $e1c55b086cf8dd0e$var$popupEditor = null // Quill editor in popup window
;
var $e1c55b086cf8dd0e$var$sideDrawEditor = null // Quill editor in side drawer
;
var $e1c55b086cf8dd0e$var$loadingDelayTimer // timer to delay the start of the loading animation for few moments
;
var $e1c55b086cf8dd0e$var$netLoaded = false // becomes true when map is fully displayed
;
var $e1c55b086cf8dd0e$var$savedState = '' // the current state of the map (nodes, edges, network settings) before current user action
;
var $e1c55b086cf8dd0e$var$unknownRoomTimeout = null // timer to check if the room exists
;
/**
 * top level function to initialise everything
 */ window.addEventListener('load', ()=>{
    $e1c55b086cf8dd0e$var$loadingDelayTimer = setTimeout(()=>{
        (0, $gFW3W.elem)('loading').style.display = 'block';
    }, 100);
    $e1c55b086cf8dd0e$var$addEventListeners();
    $e1c55b086cf8dd0e$var$setUpPage();
    (0, $a4a268d7686bbf3f$export$cf606e54e8a9990d)();
    $e1c55b086cf8dd0e$var$startY();
    $e1c55b086cf8dd0e$var$setUpUserName();
    $e1c55b086cf8dd0e$var$setUpAwareness();
    $e1c55b086cf8dd0e$var$setUpShareDialog();
    $e1c55b086cf8dd0e$var$draw();
});
/**
 * Clean up before user departs
 */ window.onbeforeunload = function(event1) {
    $e1c55b086cf8dd0e$var$unlockAll();
    $e1c55b086cf8dd0e$var$yAwareness.setLocalStateField('addingFactor', {
        state: 'done'
    });
    $e1c55b086cf8dd0e$var$yAwareness.setLocalState(null);
    // get confirmation from user before exiting if there are unsaved changes
    if ($e1c55b086cf8dd0e$var$checkMapSaved && $e1c55b086cf8dd0e$var$dirty) {
        event1.preventDefault();
        event1.returnValue = 'You have unsaved unchanges.  Are you sure you want to leave?';
    }
};
/**
 * Set up all the permanent event listeners
 */ function $e1c55b086cf8dd0e$var$addEventListeners() {
    (0, $gFW3W.listen)('whatsnewbutton', 'click', $e1c55b086cf8dd0e$var$hideWhatsNew);
    (0, $gFW3W.listen)('maptitle', 'keydown', (e)=>{
        //disallow Enter key
        if (e.key === 'Enter') e.preventDefault();
    });
    (0, $gFW3W.listen)('net-pane', 'keydown', (e)=>{
        if (e.which === 8 || e.which === 46) $e1c55b086cf8dd0e$var$deleteNode();
    });
    (0, $gFW3W.listen)('recent-rooms-caret', 'click', $e1c55b086cf8dd0e$var$createTitleDropDown);
    (0, $gFW3W.listen)('maptitle', 'keydown', (e)=>{
        if (e.target.innerText === 'Untitled map') window.getSelection().selectAllChildren(e.target);
    });
    (0, $gFW3W.listen)('maptitle', 'keyup', $e1c55b086cf8dd0e$var$mapTitle);
    (0, $gFW3W.listen)('maptitle', 'paste', $e1c55b086cf8dd0e$var$pasteMapTitle);
    (0, $gFW3W.listen)('maptitle', 'click', (e)=>{
        if (e.target.innerText === 'Untitled map') window.getSelection().selectAllChildren(e.target);
    });
    (0, $gFW3W.listen)('addNode', 'click', $e1c55b086cf8dd0e$var$plusNode);
    (0, $gFW3W.listen)('net-pane', 'contextmenu', $e1c55b086cf8dd0e$var$contextMenu);
    (0, $gFW3W.listen)('net-pane', 'click', $e1c55b086cf8dd0e$var$unFollow);
    (0, $gFW3W.listen)('net-pane', 'click', $e1c55b086cf8dd0e$var$removeTitleDropDown);
    (0, $gFW3W.listen)('drawer-handle', 'click', ()=>{
        (0, $gFW3W.elem)('drawer-wrapper').classList.toggle('hide-drawer');
    });
    (0, $gFW3W.listen)('addLink', 'click', $e1c55b086cf8dd0e$var$plusLink);
    (0, $gFW3W.listen)('deleteNode', 'click', $e1c55b086cf8dd0e$var$deleteNode);
    (0, $gFW3W.listen)('undo', 'click', $e1c55b086cf8dd0e$var$undo);
    (0, $gFW3W.listen)('redo', 'click', $e1c55b086cf8dd0e$var$redo);
    (0, $gFW3W.listen)('fileInput', 'change', (0, $a61399d7add80213$export$12d9b7805ed59d8e));
    (0, $gFW3W.listen)('openFile', 'click', (0, $a61399d7add80213$export$c47c8b06a9966d9f));
    (0, $gFW3W.listen)('replaceMap', 'click', (0, $a61399d7add80213$export$c47c8b06a9966d9f));
    (0, $gFW3W.listen)('mergeMap', 'click', $e1c55b086cf8dd0e$var$mergeMap);
    (0, $gFW3W.listen)('merge', 'click', $e1c55b086cf8dd0e$var$doMerge);
    (0, $gFW3W.listen)('mergeClose', 'click', ()=>(0, $gFW3W.elem)('mergeDialog').close());
    (0, $gFW3W.listen)('saveFile', 'click', (0, $a61399d7add80213$export$37a761894e599695));
    (0, $gFW3W.listen)('exportPRSM', 'click', (0, $a61399d7add80213$export$37a761894e599695));
    (0, $gFW3W.listen)('exportImage', 'click', (0, $a61399d7add80213$export$f0cc1c631fa5bb45));
    (0, $gFW3W.listen)('exportExcel', 'click', (0, $a61399d7add80213$export$5803f461b1d4777f));
    (0, $gFW3W.listen)('exportGML', 'click', (0, $a61399d7add80213$export$e680efcc3295c085));
    (0, $gFW3W.listen)('exportDOT', 'click', (0, $a61399d7add80213$export$5e98004ecc179104));
    (0, $gFW3W.listen)('exportNotes', 'click', (0, $a61399d7add80213$export$83b54ab4d55d8ebe));
    (0, $gFW3W.listen)('copy-map', 'click', ()=>$e1c55b086cf8dd0e$var$doClone(false));
    (0, $gFW3W.listen)('search', 'click', $e1c55b086cf8dd0e$var$search);
    (0, $gFW3W.listen)('help', 'click', (0, $gFW3W.displayHelp));
    (0, $gFW3W.listen)('panelToggle', 'click', $e1c55b086cf8dd0e$var$togglePanel);
    (0, $gFW3W.listen)('zoom', 'change', $e1c55b086cf8dd0e$var$zoomnet);
    (0, $gFW3W.listen)('navbar', 'dblclick', $e1c55b086cf8dd0e$export$1e044b7877db048c);
    (0, $gFW3W.listen)('zoomminus', 'click', ()=>{
        $e1c55b086cf8dd0e$var$zoomincr(-0.1);
    });
    (0, $gFW3W.listen)('zoomplus', 'click', ()=>{
        $e1c55b086cf8dd0e$var$zoomincr(0.1);
    });
    (0, $gFW3W.listen)('nodesButton', 'click', ()=>{
        $e1c55b086cf8dd0e$var$openTab('nodesTab');
    });
    (0, $gFW3W.listen)('linksButton', 'click', ()=>{
        $e1c55b086cf8dd0e$var$openTab('linksTab');
    });
    (0, $gFW3W.listen)('networkButton', 'click', ()=>{
        $e1c55b086cf8dd0e$var$openTab('networkTab');
    });
    (0, $gFW3W.listen)('analysisButton', 'click', ()=>{
        $e1c55b086cf8dd0e$var$openTab('analysisTab');
    });
    (0, $gFW3W.listen)('layoutSelect', 'change', $e1c55b086cf8dd0e$var$autoLayout);
    (0, $gFW3W.listen)('snaptogridswitch', 'click', $e1c55b086cf8dd0e$var$snapToGridSwitch);
    (0, $gFW3W.listen)('curveSelect', 'change', $e1c55b086cf8dd0e$var$selectCurve);
    (0, $gFW3W.listen)('drawing', 'click', $e1c55b086cf8dd0e$var$toggleDrawingLayer);
    (0, $gFW3W.listen)('allFactors', 'click', $e1c55b086cf8dd0e$var$selectAllFactors);
    (0, $gFW3W.listen)('allLinks', 'click', $e1c55b086cf8dd0e$var$selectAllLinks);
    (0, $gFW3W.listen)('showLegendSwitch', 'click', $e1c55b086cf8dd0e$var$legendSwitch);
    (0, $gFW3W.listen)('showVotingSwitch', 'click', $e1c55b086cf8dd0e$var$votingSwitch);
    (0, $gFW3W.listen)('showUsersSwitch', 'click', $e1c55b086cf8dd0e$var$showUsersSwitch);
    (0, $gFW3W.listen)('showHistorySwitch', 'click', $e1c55b086cf8dd0e$var$showHistorySwitch);
    (0, $gFW3W.listen)('showNotesSwitch', 'click', $e1c55b086cf8dd0e$var$showNotesSwitch);
    (0, $gFW3W.listen)('clustering', 'change', $e1c55b086cf8dd0e$var$selectClustering);
    (0, $gFW3W.listen)('lock', 'click', $e1c55b086cf8dd0e$var$setFixed);
    (0, $gFW3W.listen)('newNodeWindow', 'click', $e1c55b086cf8dd0e$var$openNotesWindow);
    (0, $gFW3W.listen)('newEdgeWindow', 'click', $e1c55b086cf8dd0e$var$openNotesWindow);
    (0, $gFW3W.listen)('sparklesEdge', 'click', $e1c55b086cf8dd0e$var$genAIEdge);
    (0, $gFW3W.listen)('sparklesNode', 'click', $e1c55b086cf8dd0e$var$genAINode);
    Array.from(document.getElementsByName('radius')).forEach((elem)=>{
        elem.addEventListener('change', $e1c55b086cf8dd0e$var$analyse);
    });
    Array.from(document.getElementsByName('stream')).forEach((elem)=>{
        elem.addEventListener('change', $e1c55b086cf8dd0e$var$analyse);
    });
    Array.from(document.getElementsByName('paths')).forEach((elem)=>{
        elem.addEventListener('change', $e1c55b086cf8dd0e$var$analyse);
    });
    (0, $gFW3W.listen)('sizing', 'change', $e1c55b086cf8dd0e$var$sizingSwitch);
    Array.from(document.getElementsByClassName('sampleNode')).forEach((elem)=>elem.addEventListener('click', (event1)=>{
            $e1c55b086cf8dd0e$var$applySampleToNode(event1);
        }));
    Array.from(document.getElementsByClassName('sampleLink')).forEach((elem)=>elem.addEventListener('click', (event1)=>{
            $e1c55b086cf8dd0e$var$applySampleToLink(event1);
        }));
    (0, $gFW3W.listen)('nodeStyleEditFactorSize', 'input', (event1)=>$e1c55b086cf8dd0e$export$9d1298853f0e77f7(event1.target));
    (0, $gFW3W.listen)('history-copy', 'click', $e1c55b086cf8dd0e$var$copyHistoryToClipboard);
    (0, $gFW3W.listen)('body', 'copy', $e1c55b086cf8dd0e$var$copyToClipboard);
    (0, $gFW3W.listen)('body', 'paste', $e1c55b086cf8dd0e$var$pasteFromClipboard);
    // if user has changed to this  tab, ensure that the network has been drawn
    document.addEventListener('visibilitychange', ()=>{
        $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.redraw();
    });
}
/**
 * create all the DOM elements on the web page
 */ function $e1c55b086cf8dd0e$var$setUpPage() {
    (0, $gFW3W.elem)('version').innerHTML = (0, $gMLdp.version);
    $e1c55b086cf8dd0e$export$34e0f9847d4c02dd = (0, $gFW3W.elem)('container');
    $e1c55b086cf8dd0e$export$4b72f5d71fff605 = (0, $gFW3W.elem)('net-pane');
    $e1c55b086cf8dd0e$var$panel = (0, $gFW3W.elem)('panel');
    // check debug options set on URL: ?debug=yjs|gui|cluster|viewing|start|copyButton
    // each of these generates trace output on the console
    let searchParams = new URL(document.location).searchParams;
    if (searchParams.has('debug')) $e1c55b086cf8dd0e$export$1c9f709888824e05 = searchParams.get('debug');
    // don't allow user to change anything if URL includes ?viewing
    // this is now obsolete, but retained for backwards compatibility
    $e1c55b086cf8dd0e$var$viewOnly = searchParams.has('viewing');
    if ($e1c55b086cf8dd0e$var$viewOnly) $e1c55b086cf8dd0e$var$hideNavButtons();
    if (searchParams.has('copyButton')) $e1c55b086cf8dd0e$var$showCopyMapButton = true;
    // treat user as first time user if URL includes ?start=true
    if (searchParams.has('start')) localStorage.setItem('doneIntro', 'false');
    $e1c55b086cf8dd0e$var$panel.classList.add('hide');
    $e1c55b086cf8dd0e$export$34e0f9847d4c02dd.panelHidden = true;
    $e1c55b086cf8dd0e$export$cd571ca6d1702b73.createColorPicker('netBackColorWell', $e1c55b086cf8dd0e$var$updateNetBack);
    $e1c55b086cf8dd0e$var$hammer = new (0, $hV9VG.default)($e1c55b086cf8dd0e$export$4b72f5d71fff605);
    $e1c55b086cf8dd0e$var$hammer.get('pinch').set({
        enable: true
    });
    $e1c55b086cf8dd0e$var$hammer.on('pinchstart', ()=>{
        $e1c55b086cf8dd0e$var$zoomstart();
    });
    $e1c55b086cf8dd0e$var$hammer.on('pinch', (e)=>{
        $e1c55b086cf8dd0e$var$zoomset(e.scale);
    });
    (0, $79c06594b77924a6$export$4ca77f8e2d7fc8b6)();
    $e1c55b086cf8dd0e$export$7ac138a1e38951d6($e1c55b086cf8dd0e$export$794b27baf354ffba, $e1c55b086cf8dd0e$export$a01f2d76756b77a5);
    (0, $gFW3W.dragElement)((0, $gFW3W.elem)('nodeDataPanel'), (0, $gFW3W.elem)('nodeDataHeader'));
    (0, $gFW3W.dragElement)((0, $gFW3W.elem)('edgeDataPanel'), (0, $gFW3W.elem)('edgeDataHeader'));
    $e1c55b086cf8dd0e$var$hideNotes();
    $e1c55b086cf8dd0e$var$setUpSideDrawer();
    $e1c55b086cf8dd0e$var$displayWhatsNew();
}
const $e1c55b086cf8dd0e$var$sliderColor = getComputedStyle(document.documentElement).getPropertyValue('--slider');
function $e1c55b086cf8dd0e$export$9d1298853f0e77f7(sliderEl) {
    const sliderValue = sliderEl.value;
    sliderEl.style.background = `linear-gradient(to right, ${$e1c55b086cf8dd0e$var$sliderColor} ${sliderValue}%, #ccc ${sliderValue}%)`;
}
/**
 * show the What's New modal dialog unless this is a new user or user has already seen this dialog
 * for this (Major.Minor) version
 */ function $e1c55b086cf8dd0e$var$displayWhatsNew() {
    //new user - don't tell them what is new
    if (!localStorage.getItem('doneIntro')) return;
    let versionDecoded = (0, $gMLdp.version).match(/^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)/);
    let seen = localStorage.getItem('seenWN');
    if (seen) {
        let seenDecoded = seen.match(/^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)/);
        // if this is a new minor version, show the What's New dialog
        if (seenDecoded && versionDecoded[1] === seenDecoded[1] && versionDecoded[2] === seenDecoded[2]) return;
    }
    (0, $gFW3W.elem)('whatsnewversion').innerHTML = `Version ${0, $gMLdp.version}`;
    (0, $gFW3W.elem)('whatsnew').style.display = 'flex';
}
/**
 * hide the What's New dialog when the user has clicked Continue, and note tha the user has seen it
 */ function $e1c55b086cf8dd0e$var$hideWhatsNew() {
    localStorage.setItem('seenWN', (0, $gMLdp.version));
    (0, $gFW3W.elem)('whatsnew').style.display = 'none';
}
/**
 * create a new shared document and start the WebSocket provider
 */ function $e1c55b086cf8dd0e$var$startY(newRoom) {
    let url = new URL(document.location);
    if (newRoom) $e1c55b086cf8dd0e$export$f9d3fff8c23da278 = newRoom;
    else // get the room number from the URL, or if none, generate a new one
    $e1c55b086cf8dd0e$export$f9d3fff8c23da278 = url.searchParams.get('room');
    if ($e1c55b086cf8dd0e$export$f9d3fff8c23da278 == null || $e1c55b086cf8dd0e$export$f9d3fff8c23da278 === '') {
        $e1c55b086cf8dd0e$export$f9d3fff8c23da278 = $e1c55b086cf8dd0e$var$generateRoom();
        $e1c55b086cf8dd0e$var$checkMapSaved = true;
    } else $e1c55b086cf8dd0e$export$f9d3fff8c23da278 = $e1c55b086cf8dd0e$export$f9d3fff8c23da278.toUpperCase();
    // if using a non-standard port (i.e neither 80 nor 443) assume that the websocket port is 1234 in the same domain as the url
    if (url.port && url.port !== 80 && url.port !== 443) $e1c55b086cf8dd0e$export$3f859614deccc31b = `ws://${url.hostname}:1234`;
    $e1c55b086cf8dd0e$var$wsProvider = new (0, $6iwTo.WebsocketProvider)($e1c55b086cf8dd0e$export$3f859614deccc31b, `prsm${$e1c55b086cf8dd0e$export$f9d3fff8c23da278}`, $e1c55b086cf8dd0e$export$2a111da947c407d2);
    $e1c55b086cf8dd0e$var$wsProvider.on('synced', ()=>{
        // if this is a clone, load the cloned data
        $e1c55b086cf8dd0e$var$initiateClone();
        // if this is a new map, display it
        // (if the room already exists, wait until the map data is loaded before displaying it)
        if (url.searchParams.get('room') === null) $e1c55b086cf8dd0e$var$displayNetPane(`${(0, $gFW3W.exactTime)()} remote content loaded from ${$e1c55b086cf8dd0e$export$3f859614deccc31b}`);
        else // if the user wants a room that doesn't exist, the system will hang, so wait and then show a blank map
        $e1c55b086cf8dd0e$var$unknownRoomTimeout = setTimeout(()=>{
            if (!$e1c55b086cf8dd0e$var$netLoaded) $e1c55b086cf8dd0e$var$displayNetPane(`${(0, $gFW3W.exactTime)()} remote content not loaded from ${$e1c55b086cf8dd0e$export$3f859614deccc31b}`);
        }, 3000);
    });
    $e1c55b086cf8dd0e$var$wsProvider.disconnectBc();
    $e1c55b086cf8dd0e$var$wsProvider.on('status', (event1)=>{
        console.log(`${(0, $gFW3W.exactTime)()}${event1.status}${event1.status === 'connected' ? ' to' : ' from'} room ${$e1c55b086cf8dd0e$export$f9d3fff8c23da278}`);
    });
    /* 
	create a yMap for the nodes and one for the edges (we need two because there is no 
	guarantee that the the ids of nodes will differ from the ids of edges) 
	 */ $e1c55b086cf8dd0e$var$yNodesMap = $e1c55b086cf8dd0e$export$2a111da947c407d2.getMap('nodes');
    $e1c55b086cf8dd0e$var$yEdgesMap = $e1c55b086cf8dd0e$export$2a111da947c407d2.getMap('edges');
    $e1c55b086cf8dd0e$export$4b63d58d2685a993 = $e1c55b086cf8dd0e$export$2a111da947c407d2.getMap('samples');
    $e1c55b086cf8dd0e$export$807f940a96777041 = $e1c55b086cf8dd0e$export$2a111da947c407d2.getMap('network');
    $e1c55b086cf8dd0e$export$ffba1a0e51177788 = $e1c55b086cf8dd0e$export$2a111da947c407d2.getArray('points');
    $e1c55b086cf8dd0e$export$da7062de5ac36f9c = $e1c55b086cf8dd0e$export$2a111da947c407d2.getMap('drawing');
    $e1c55b086cf8dd0e$export$d920e34eaf2b21cb = $e1c55b086cf8dd0e$export$2a111da947c407d2.getArray('history');
    $e1c55b086cf8dd0e$var$yAwareness = $e1c55b086cf8dd0e$var$wsProvider.awareness;
    if (/trans/.test($e1c55b086cf8dd0e$export$1c9f709888824e05)) $e1c55b086cf8dd0e$export$2a111da947c407d2.on('afterTransaction', (tr)=>{
        const nodesEvent = tr.changed.get($e1c55b086cf8dd0e$var$yNodesMap);
        if (nodesEvent) console.log(nodesEvent);
        const edgesEvent = tr.changed.get($e1c55b086cf8dd0e$var$yEdgesMap);
        if (edgesEvent) console.log(edgesEvent);
        const sampleEvent = tr.changed.get($e1c55b086cf8dd0e$export$4b63d58d2685a993);
        if (sampleEvent) console.log(sampleEvent);
        const netEvent = tr.changed.get($e1c55b086cf8dd0e$export$807f940a96777041);
        if (netEvent) console.log(netEvent);
    });
    $e1c55b086cf8dd0e$export$4d35f98e5d7d0978 = $e1c55b086cf8dd0e$export$2a111da947c407d2.clientID;
    console.log(`My client ID: ${$e1c55b086cf8dd0e$export$4d35f98e5d7d0978}`);
    /* set up the undo managers */ $e1c55b086cf8dd0e$export$f796f85272199be2 = new $lc1R0.UndoManager([
        $e1c55b086cf8dd0e$var$yNodesMap,
        $e1c55b086cf8dd0e$var$yEdgesMap,
        $e1c55b086cf8dd0e$export$807f940a96777041
    ], {
        trackedOrigins: new Set([
            null
        ])
    });
    $e1c55b086cf8dd0e$var$dontUndo = null;
    $e1c55b086cf8dd0e$var$nodes = new (0, $558228835489ffff$export$486059efd2d2dabe)();
    $e1c55b086cf8dd0e$var$edges = new (0, $558228835489ffff$export$486059efd2d2dabe)();
    $e1c55b086cf8dd0e$export$4051a07651545597 = {
        nodes: $e1c55b086cf8dd0e$var$nodes,
        edges: $e1c55b086cf8dd0e$var$edges
    };
    /* 
	for convenience when debugging
	 */ window.debug = $e1c55b086cf8dd0e$export$1c9f709888824e05;
    window.data = $e1c55b086cf8dd0e$export$4051a07651545597;
    window.clientID = $e1c55b086cf8dd0e$export$4d35f98e5d7d0978;
    window.yNodesMap = $e1c55b086cf8dd0e$var$yNodesMap;
    window.yEdgesMap = $e1c55b086cf8dd0e$var$yEdgesMap;
    window.ySamplesMap = $e1c55b086cf8dd0e$export$4b63d58d2685a993;
    window.yNetMap = $e1c55b086cf8dd0e$export$807f940a96777041;
    window.yUndoManager = $e1c55b086cf8dd0e$export$f796f85272199be2;
    window.yHistory = $e1c55b086cf8dd0e$export$d920e34eaf2b21cb;
    window.yPointsArray = $e1c55b086cf8dd0e$export$ffba1a0e51177788;
    window.yDrawingMap = $e1c55b086cf8dd0e$export$da7062de5ac36f9c;
    window.styles = (0, $09258687963db43e$export$9dd6ff9ea0189349);
    window.yAwareness = $e1c55b086cf8dd0e$var$yAwareness;
    window.mergeRoom = (0, $aa1828bc973fe863$export$547fdf2442351faf);
    window.diffRoom = (0, $aa1828bc973fe863$export$8150c7da8c1e5fc2);
    window.wsProvider = $e1c55b086cf8dd0e$var$wsProvider;
    /* 
	nodes.on listens for when local nodes or edges are changed (added, updated or removed).
	If a local node is removed, the yMap is updated to broadcast to other clients that the node 
	has been deleted. If a local node is added or updated, that is also broadcast.
	 */ $e1c55b086cf8dd0e$var$nodes.on('*', (evt, properties, origin)=>{
        $e1c55b086cf8dd0e$var$yjsTrace('nodes.on', `${evt}  ${JSON.stringify(properties.items)} origin: ${origin} dontUndo: ${$e1c55b086cf8dd0e$var$dontUndo}`);
        clearTimeout($e1c55b086cf8dd0e$var$unknownRoomTimeout);
        $e1c55b086cf8dd0e$export$2a111da947c407d2.transact(()=>{
            properties.items.forEach((id)=>{
                if (origin === null) {
                    // this is a local change
                    if (evt === 'remove') $e1c55b086cf8dd0e$var$yNodesMap.delete(id.toString());
                    else $e1c55b086cf8dd0e$var$yNodesMap.set(id.toString(), (0, $gFW3W.deepCopy)($e1c55b086cf8dd0e$var$nodes.get(id)));
                }
            });
        }, $e1c55b086cf8dd0e$var$dontUndo);
        $e1c55b086cf8dd0e$var$dontUndo = null;
    });
    /* 
	yNodesMap.observe listens for changes in the yMap, receiving a set of the keys that have
	had changed values.  If the change was to delete an entry, the corresponding node and all links to/from it are
	removed from the local nodes dataSet. Otherwise, if the received node differs from the local one, 
	the local node dataSet is updated (which includes adding a new node if it does not already exist locally).
	 */ $e1c55b086cf8dd0e$var$yNodesMap.observe((evt)=>{
        $e1c55b086cf8dd0e$var$yjsTrace('yNodesMap.observe', evt);
        let nodesToUpdate = [];
        let nodesToRemove = [];
        for (let key of evt.keysChanged)if ($e1c55b086cf8dd0e$var$yNodesMap.has(key)) {
            let obj = $e1c55b086cf8dd0e$var$yNodesMap.get(key);
            if (!(0, $gFW3W.object_equals)(obj, $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(key))) {
                // fix nodes if this is a view only copy
                if ($e1c55b086cf8dd0e$var$viewOnly) obj.fixed = true;
                nodesToUpdate.push((0, $gFW3W.deepCopy)(obj));
                // if a note on a node is being remotely edited and is on display here, update the local note and the padlock
                if ($e1c55b086cf8dd0e$var$editor && $e1c55b086cf8dd0e$var$editor.id === key && evt.transaction.local === false) {
                    $e1c55b086cf8dd0e$var$editor.setContents(obj.note);
                    (0, $gFW3W.elem)('fixed').style.display = obj.fixed ? 'inline' : 'none';
                    (0, $gFW3W.elem)('unfixed').style.display = obj.fixed ? 'none' : 'inline';
                }
            }
        } else {
            $e1c55b086cf8dd0e$var$hideNotes();
            if ($e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(key)) $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getConnectedEdges(key).forEach((edge)=>nodesToRemove.push(edge));
            nodesToRemove.push(key);
        }
        if (nodesToUpdate.length > 0) $e1c55b086cf8dd0e$var$nodes.update(nodesToUpdate, 'remote');
        if (nodesToRemove.length > 0) $e1c55b086cf8dd0e$var$nodes.remove(nodesToRemove, 'remote');
        if (/changes/.test($e1c55b086cf8dd0e$export$1c9f709888824e05) && (nodesToUpdate.length > 0 || nodesToRemove.length > 0)) showChange(evt, $e1c55b086cf8dd0e$var$yNodesMap);
    });
    /* 
	See comments above about nodes
	 */ $e1c55b086cf8dd0e$var$edges.on('*', (evt, properties, origin)=>{
        $e1c55b086cf8dd0e$var$yjsTrace('edges.on', `${evt}  ${JSON.stringify(properties.items)} origin: ${origin} dontUndo: ${$e1c55b086cf8dd0e$var$dontUndo}`);
        $e1c55b086cf8dd0e$export$2a111da947c407d2.transact(()=>{
            properties.items.forEach((id)=>{
                if (origin === null) {
                    if (evt === 'remove') $e1c55b086cf8dd0e$var$yEdgesMap.delete(id.toString());
                    else $e1c55b086cf8dd0e$var$yEdgesMap.set(id.toString(), (0, $gFW3W.deepCopy)($e1c55b086cf8dd0e$var$edges.get(id)));
                }
            });
        }, $e1c55b086cf8dd0e$var$dontUndo);
        $e1c55b086cf8dd0e$var$dontUndo = null;
    });
    $e1c55b086cf8dd0e$var$yEdgesMap.observe((evt)=>{
        $e1c55b086cf8dd0e$var$yjsTrace('yEdgesMap.observe', evt);
        let edgesToUpdate = [];
        let edgesToRemove = [];
        for (let key of evt.keysChanged)if ($e1c55b086cf8dd0e$var$yEdgesMap.has(key)) {
            let obj = $e1c55b086cf8dd0e$var$yEdgesMap.get(key);
            if (!(0, $gFW3W.object_equals)(obj, $e1c55b086cf8dd0e$export$4051a07651545597.edges.get(key))) {
                edgesToUpdate.push((0, $gFW3W.deepCopy)(obj));
                if ($e1c55b086cf8dd0e$var$editor && $e1c55b086cf8dd0e$var$editor.id === key && evt.transaction.local === false) $e1c55b086cf8dd0e$var$editor.setContents(obj.note);
            }
        } else {
            $e1c55b086cf8dd0e$var$hideNotes();
            edgesToRemove.push(key);
        }
        if (edgesToUpdate.length > 0) $e1c55b086cf8dd0e$var$edges.update(edgesToUpdate, 'remote');
        if (edgesToRemove.length > 0) $e1c55b086cf8dd0e$var$edges.remove(edgesToRemove, 'remote');
        if (edgesToUpdate.length > 0 || edgesToRemove.length > 0) // if user is in mid-flight adding a Link, and someone else has just added a link,
        // vis-network will cancel the edit mode for this user.  Re-instate it.
        {
            if ($e1c55b086cf8dd0e$var$inAddMode === 'addLink') $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.addEdgeMode();
        }
        if (/changes/.test($e1c55b086cf8dd0e$export$1c9f709888824e05) && (edgesToUpdate.length > 0 || edgesToRemove.length > 0)) showChange(evt, $e1c55b086cf8dd0e$var$yEdgesMap);
    });
    /**
	 * utility trace function that prints the change in the value of a YMap property to the console
	 * @param {YEvent} evt
	 * @param {MapType} ymap
	 */ function showChange(evt, ymap) {
        evt.changes.keys.forEach((change, key)=>{
            if (change.action === 'add') console.log(`Property "${key}" was added. 
				Initial value: `, ymap.get(key));
            else if (change.action === 'update') console.log(`Property "${key}" was updated. 
					New value: "`, ymap.get(key), `"
					Previous value: "`, change.oldValue, `" 
					Difference: "`, typeof change.oldValue === 'object' && typeof ymap.get(key) === 'object' ? (0, $7576ef8bb573c40c$export$2e2bcd8739ae039)(change.oldValue, ymap.get(key)) : `${change.oldValue} ${ymap.get(key)}`, `"`);
            else if (change.action === 'delete') console.log(`Property "${key}" was deleted. 
				Previous value: `, change.oldValue);
        });
    }
    $e1c55b086cf8dd0e$export$4b63d58d2685a993.observe((evt)=>{
        $e1c55b086cf8dd0e$var$yjsTrace('ySamplesMap.observe', evt);
        let nodesToUpdate = [];
        let edgesToUpdate = [];
        for (let key of evt.keysChanged){
            let sample = $e1c55b086cf8dd0e$export$4b63d58d2685a993.get(key);
            if (sample.node !== undefined) {
                if (!(0, $gFW3W.object_equals)((0, $09258687963db43e$export$9dd6ff9ea0189349).nodes[key], sample.node)) {
                    (0, $09258687963db43e$export$9dd6ff9ea0189349).nodes[key] = sample.node;
                    (0, $79c06594b77924a6$export$675fa328fb4ebccd)(key);
                    nodesToUpdate.push(key);
                }
            } else if (!(0, $gFW3W.object_equals)((0, $09258687963db43e$export$9dd6ff9ea0189349).edges[key], sample.edge)) {
                (0, $09258687963db43e$export$9dd6ff9ea0189349).edges[key] = sample.edge;
                (0, $79c06594b77924a6$export$e496289367e7ce52)(key);
                edgesToUpdate.push(key);
            }
        }
        if (nodesToUpdate) (0, $79c06594b77924a6$export$72639688f12e084)(nodesToUpdate);
        if (edgesToUpdate) (0, $79c06594b77924a6$export$8e108f36b8804828)(edgesToUpdate);
    });
    /*
	Map controls (those on the Network tab) are of three kinds:
	1. Those that affect only the local map and are not promulgated to other users
	e.g zoom, show drawing layer, show history
	2. Those where the control status (e.g. whether a switch is on or off) is promulgated,
	but the effect of the switch is handled by yNodesMap and yEdgesMap (e.g. Show Factors
		x links away; Size Factors to)
	3. Those whose effects are promulgated and switches controlled here by yNetMap (e.g
		Background)
	For cases 2 and 3, the functions called here must not invoke yNetMap.set() to avoid loops
	*/ $e1c55b086cf8dd0e$export$807f940a96777041.observe((evt)=>{
        $e1c55b086cf8dd0e$var$yjsTrace('YNetMap.observe', evt);
        if (evt.transaction.origin) // evt is not local
        for (let key of evt.keysChanged){
            let obj = $e1c55b086cf8dd0e$export$807f940a96777041.get(key);
            switch(key){
                case 'viewOnly':
                    $e1c55b086cf8dd0e$var$viewOnly = $e1c55b086cf8dd0e$var$viewOnly || obj;
                    if ($e1c55b086cf8dd0e$var$viewOnly) {
                        $e1c55b086cf8dd0e$var$hideNavButtons();
                        $e1c55b086cf8dd0e$export$3a86b7dfc26ebfa6();
                    }
                    break;
                case 'mapTitle':
                case 'maptitle':
                    $e1c55b086cf8dd0e$export$f229389f565c6b3f(obj);
                    break;
                case 'snapToGrid':
                    $e1c55b086cf8dd0e$export$95ff17332160327a(obj);
                    break;
                case 'curve':
                    $e1c55b086cf8dd0e$export$264d5714f8b2c7d8(obj);
                    break;
                case 'background':
                    $e1c55b086cf8dd0e$export$2e65e79124cca55d(obj);
                    break;
                case 'legend':
                    $e1c55b086cf8dd0e$export$e8f1ea4a10bfd1c9(obj, false);
                    break;
                case 'voting':
                    $e1c55b086cf8dd0e$var$setVoting(obj);
                    break;
                case 'showNotes':
                    $e1c55b086cf8dd0e$var$doShowNotes(obj);
                    break;
                case 'radius':
                    $e1c55b086cf8dd0e$var$hiddenNodes.radiusSetting = obj.radiusSetting;
                    $e1c55b086cf8dd0e$var$hiddenNodes.selected = obj.selected;
                    $e1c55b086cf8dd0e$var$setRadioVal('radius', $e1c55b086cf8dd0e$var$hiddenNodes.radiusSetting);
                    break;
                case 'stream':
                    $e1c55b086cf8dd0e$var$hiddenNodes.streamSetting = obj.streamSetting;
                    $e1c55b086cf8dd0e$var$hiddenNodes.selected = obj.selected;
                    $e1c55b086cf8dd0e$var$setRadioVal('stream', $e1c55b086cf8dd0e$var$hiddenNodes.streamSetting);
                    break;
                case 'paths':
                    $e1c55b086cf8dd0e$var$hiddenNodes.pathsSetting = obj.pathsSetting;
                    $e1c55b086cf8dd0e$var$hiddenNodes.selected = obj.selected;
                    $e1c55b086cf8dd0e$var$setRadioVal('paths', $e1c55b086cf8dd0e$var$hiddenNodes.pathsSetting);
                    break;
                case 'sizing':
                    $e1c55b086cf8dd0e$export$9758cac25f26dd85(obj);
                    break;
                case 'hideAndStream':
                case 'linkRadius':
                    break;
                case 'factorsHiddenByStyle':
                    $e1c55b086cf8dd0e$var$updateFactorsOrLinksHiddenByStyle(obj);
                    break;
                case 'linksHiddenByStyle':
                    $e1c55b086cf8dd0e$var$updateFactorsOrLinksHiddenByStyle(obj);
                    break;
                case 'attributeTitles':
                    $e1c55b086cf8dd0e$export$5323aa6dd0c7006b(obj);
                    break;
                case 'cluster':
                    $e1c55b086cf8dd0e$export$8b2b949f916968c1(obj);
                    break;
                case 'mapDescription':
                    $e1c55b086cf8dd0e$export$cff30a8f7435ec50(obj);
                    break;
                default:
                    console.log('Bad key in yMapNet.observe: ', key);
            }
        }
    //setAnalysisButtonsFromRemote()
    });
    $e1c55b086cf8dd0e$export$ffba1a0e51177788.observe((evt)=>{
        $e1c55b086cf8dd0e$var$yjsTrace('yPointsArray.observe', $e1c55b086cf8dd0e$export$ffba1a0e51177788.get($e1c55b086cf8dd0e$export$ffba1a0e51177788.length - 1));
        if (evt.transaction.local === false) (0, $a4a268d7686bbf3f$export$aab3aebcdfaf4b16)($e1c55b086cf8dd0e$export$ffba1a0e51177788.toArray());
    });
    $e1c55b086cf8dd0e$export$da7062de5ac36f9c.observe((evt)=>{
        $e1c55b086cf8dd0e$var$yjsTrace('yDrawingMap.observe', evt);
        (0, $a4a268d7686bbf3f$export$7ec610621a8fb67b)(evt);
    });
    $e1c55b086cf8dd0e$export$d920e34eaf2b21cb.observe(()=>{
        $e1c55b086cf8dd0e$var$yjsTrace('yHistory.observe', $e1c55b086cf8dd0e$export$d920e34eaf2b21cb.get($e1c55b086cf8dd0e$export$d920e34eaf2b21cb.length - 1));
        if ((0, $gFW3W.elem)('showHistorySwitch').checked) $e1c55b086cf8dd0e$var$showHistory();
        // assume that if we get here at initialisation, everything has been loaded from the room
        // this is a work around to avoid a bug in y-webserver that fires the sync event before syncing is complete
        if (!$e1c55b086cf8dd0e$var$netLoaded) $e1c55b086cf8dd0e$var$displayNetPane(`${(0, $gFW3W.exactTime)()} remote content loaded from ${$e1c55b086cf8dd0e$export$3f859614deccc31b}`);
    });
    $e1c55b086cf8dd0e$export$f796f85272199be2.on('stack-item-added', (evt)=>{
        $e1c55b086cf8dd0e$var$yjsTrace('yUndoManager.on stack-item-added', evt);
        if (/changes/.test($e1c55b086cf8dd0e$export$1c9f709888824e05)) evt.changedParentTypes.forEach((v)=>{
            showChange(v[0], v[0].target);
        });
        $e1c55b086cf8dd0e$export$e810bab53f2cc5ca();
    });
    $e1c55b086cf8dd0e$export$f796f85272199be2.on('stack-item-popped', (evt)=>{
        $e1c55b086cf8dd0e$var$yjsTrace('yUndoManager.on stack-item-popped', evt);
        if (/changes/.test($e1c55b086cf8dd0e$export$1c9f709888824e05)) evt.changedParentTypes.forEach((v)=>{
            showChange(v[0], v[0].target);
        });
        pruneDanglingEdges();
        $e1c55b086cf8dd0e$export$e810bab53f2cc5ca();
    });
    /**
	 * In some slightly obscure circumstances, (specifically, client A undoes the creation of a factor that
	 * client B has subsequently linked to another factor), the undo operation can result in a link that
	 * has no source or destination factor.  Tracking such a situation is rather complex, so this cleans
	 * up the mess without bothering about its cause.
	 */ function pruneDanglingEdges() {
        $e1c55b086cf8dd0e$export$4051a07651545597.edges.forEach((edge)=>{
            if ($e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(edge.from) === null) {
                $e1c55b086cf8dd0e$var$dontUndo = 'danglingEdge';
                $e1c55b086cf8dd0e$export$4051a07651545597.edges.remove(edge.id);
            }
            if ($e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(edge.to) == null) {
                $e1c55b086cf8dd0e$var$dontUndo = 'danglingEdge';
                $e1c55b086cf8dd0e$export$4051a07651545597.edges.remove(edge.id);
            }
        });
    }
} // end startY()
/**
 * load cloned data from localStorage
 */ function $e1c55b086cf8dd0e$var$initiateClone() {
    let clone = localStorage.getItem('clone');
    if (clone) {
        localStorage.removeItem('clone');
        let state = JSON.parse((0, $3gspO.decompressFromUTF16)(clone));
        $e1c55b086cf8dd0e$export$4051a07651545597.nodes.update(state.nodes);
        $e1c55b086cf8dd0e$export$4051a07651545597.edges.update(state.edges);
        $e1c55b086cf8dd0e$export$2a111da947c407d2.transact(()=>{
            for(const k in state.net)$e1c55b086cf8dd0e$export$807f940a96777041.set(k, state.net[k]);
            $e1c55b086cf8dd0e$var$viewOnly = state.options.viewOnly;
            $e1c55b086cf8dd0e$export$807f940a96777041.set('viewOnly', $e1c55b086cf8dd0e$var$viewOnly);
            $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get().forEach((obj)=>obj.fixed = $e1c55b086cf8dd0e$var$viewOnly);
            if ($e1c55b086cf8dd0e$var$viewOnly) $e1c55b086cf8dd0e$var$hideNavButtons();
            for(const k in state.samples)$e1c55b086cf8dd0e$export$4b63d58d2685a993.set(k, state.samples[k]);
            if (state.paint) {
                $e1c55b086cf8dd0e$export$ffba1a0e51177788.delete(0, $e1c55b086cf8dd0e$export$ffba1a0e51177788.length);
                $e1c55b086cf8dd0e$export$ffba1a0e51177788.insert(0, state.paint);
            }
            if (state.drawing) {
                for(const k in state.drawing)$e1c55b086cf8dd0e$export$da7062de5ac36f9c.set(k, state.drawing[k]);
                (0, $a4a268d7686bbf3f$export$234b64ec3262770a)();
            }
            $e1c55b086cf8dd0e$export$e5fde6ebaea8ae1d(state.options.created.action, state.options.created.actor);
        }, 'clone');
        $e1c55b086cf8dd0e$export$9bc34f54445cb725();
        $e1c55b086cf8dd0e$export$1e044b7877db048c();
    }
}
function $e1c55b086cf8dd0e$var$yjsTrace(where, what) {
    if (/yjs/.test($e1c55b086cf8dd0e$export$1c9f709888824e05)) console.log((0, $gFW3W.exactTime)(), where, what);
}
/**
 * create a random string of the form AAA-BBB-CCC-DDD
 */ function $e1c55b086cf8dd0e$var$generateRoom() {
    let room = '';
    for(let i = 0; i < 4; i++){
        for(let j = 0; j < 3; j++)room += String.fromCharCode(65 + Math.floor(Math.random() * 26));
        if (i < 3) room += '-';
    }
    return room;
}
/**
 * randomly create some nodes and edges as a binary tree, mainly used for testing
 * @param {number} nNodes
 */ function $e1c55b086cf8dd0e$var$getRandomData(nNodes) {
    let SFNdata = (0, $gFW3W.getScaleFreeNetwork)(nNodes);
    $e1c55b086cf8dd0e$var$nodes.add(SFNdata.nodes);
    $e1c55b086cf8dd0e$var$edges.add(SFNdata.edges);
    (0, $79c06594b77924a6$export$72639688f12e084)([
        'group0'
    ]);
    (0, $79c06594b77924a6$export$8e108f36b8804828)([
        'edge0'
    ]);
    $e1c55b086cf8dd0e$var$recalculateStats();
}
/**
 * Once any existing map has been loaded, fit it to the pane and reveal it
 * @param {string} msg message for console
 */ function $e1c55b086cf8dd0e$var$displayNetPane(msg) {
    console.log(msg);
    if (!$e1c55b086cf8dd0e$var$netLoaded) {
        (0, $gFW3W.elem)('loading').style.display = 'none';
        $e1c55b086cf8dd0e$export$1e044b7877db048c();
        $e1c55b086cf8dd0e$export$f229389f565c6b3f($e1c55b086cf8dd0e$export$807f940a96777041.get('mapTitle'));
        $e1c55b086cf8dd0e$export$4b72f5d71fff605.style.visibility = 'visible';
        clearTimeout($e1c55b086cf8dd0e$var$loadingDelayTimer);
        $e1c55b086cf8dd0e$export$f796f85272199be2.clear();
        $e1c55b086cf8dd0e$export$e810bab53f2cc5ca();
        $e1c55b086cf8dd0e$var$setUpTutorial();
        $e1c55b086cf8dd0e$var$netLoaded = true;
        $e1c55b086cf8dd0e$export$5dfa5433ac89eafa();
        $e1c55b086cf8dd0e$var$savedState = $e1c55b086cf8dd0e$export$fb931cd598921492();
        $e1c55b086cf8dd0e$var$setAnalysisButtonsFromRemote();
        $e1c55b086cf8dd0e$export$c1a1b42e4610dc4a();
        $e1c55b086cf8dd0e$export$e8f1ea4a10bfd1c9($e1c55b086cf8dd0e$export$807f940a96777041.get('legend'), false);
        console.log((0, $gFW3W.exactTime)(), `Doc size: ${(0, $gFW3W.humanSize)($lc1R0.encodeStateAsUpdate($e1c55b086cf8dd0e$export$2a111da947c407d2).length)}`);
    }
}
// to handle iPad viewport sizing problem when tab bar appears and to keep panels on screen
$e1c55b086cf8dd0e$var$setvh();
window.onresize = function() {
    $e1c55b086cf8dd0e$var$setvh();
    $e1c55b086cf8dd0e$var$keepPaneInWindow($e1c55b086cf8dd0e$var$panel);
    (0, $a4a268d7686bbf3f$export$59b33278b5b2fc8a)();
};
/**
 * Hack to get window size when orientation changes.  Should use screen.orientation, but this is not
 * implemented by Safari
 */ let $e1c55b086cf8dd0e$var$portrait = window.matchMedia('(orientation: portrait)');
$e1c55b086cf8dd0e$var$portrait.addEventListener('change', ()=>{
    $e1c55b086cf8dd0e$var$setvh();
});
/**
 * in View Only mode, hide all the Nav Bar buttons except the search button
 * and make the map title not editable
 */ function $e1c55b086cf8dd0e$var$hideNavButtons() {
    (0, $gFW3W.elem)('buttons').style.visibility = 'hidden';
    (0, $gFW3W.elem)('search').parentElement.style.visibility = 'visible';
    (0, $gFW3W.elem)('search').parentElement.style.borderLeft = 'none';
    if ($e1c55b086cf8dd0e$var$showCopyMapButton) {
        (0, $gFW3W.elem)('copy-map-button').style.display = 'block';
        (0, $gFW3W.elem)('copy-map-button').style.visibility = 'visible';
    }
    (0, $gFW3W.elem)('maptitle').contentEditable = 'false';
    if (!$e1c55b086cf8dd0e$export$34e0f9847d4c02dd.panelHidden) {
        $e1c55b086cf8dd0e$var$panel.classList.add('hide');
        $e1c55b086cf8dd0e$export$34e0f9847d4c02dd.panelHidden = true;
    }
}
/** restore all the Nav Bar buttons when leaving view only mode (e.g. when
 * going back online)
 */ function $e1c55b086cf8dd0e$var$showNavButtons() {
    (0, $gFW3W.elem)('buttons').style.visibility = 'visible';
    (0, $gFW3W.elem)('search').parentElement.style.visibility = 'visible';
    (0, $gFW3W.elem)('search').parentElement.style.borderLeft = '1px solid rgb(255, 255, 255)';
    (0, $gFW3W.elem)('copy-map-button').style.display = 'none';
    (0, $gFW3W.elem)('maptitle').contentEditable = 'true';
}
/**
 * cancel View Only mode (only available via the console)
 */ function $e1c55b086cf8dd0e$var$cancelViewOnly() {
    $e1c55b086cf8dd0e$var$viewOnly = false;
    $e1c55b086cf8dd0e$export$807f940a96777041.set('viewOnly', false);
    $e1c55b086cf8dd0e$var$showNavButtons();
    $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get().forEach((obj)=>obj.fixed = false);
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.setOptions({
        interaction: {
            dragNodes: true,
            hover: true
        }
    });
}
window.cancelViewOnly = $e1c55b086cf8dd0e$var$cancelViewOnly;
/**
 * to handle iOS weirdness in fixing the vh unit (see https://css-tricks.com/the-trick-to-viewport-units-on-mobile/)
 */ function $e1c55b086cf8dd0e$var$setvh() {
    document.body.height = window.innerHeight;
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}
/**
 * retrieve or generate user's name
 */ function $e1c55b086cf8dd0e$var$setUpUserName() {
    try {
        $e1c55b086cf8dd0e$var$myNameRec = JSON.parse(localStorage.getItem('myName'));
    } catch  {
        $e1c55b086cf8dd0e$var$myNameRec = null;
    }
    $e1c55b086cf8dd0e$var$saveUserName($e1c55b086cf8dd0e$var$myNameRec?.name ? $e1c55b086cf8dd0e$var$myNameRec.name : '');
    console.log(`My name: ${$e1c55b086cf8dd0e$var$myNameRec.name}`);
}
/**
 * Save a new user name into local storage
 * @param {String} name
 */ function $e1c55b086cf8dd0e$var$saveUserName(name) {
    if (name.length > 0) {
        $e1c55b086cf8dd0e$var$myNameRec.name = name;
        $e1c55b086cf8dd0e$var$myNameRec.anon = false;
    } else $e1c55b086cf8dd0e$var$myNameRec = (0, $gFW3W.generateName)();
    $e1c55b086cf8dd0e$var$myNameRec.id = $e1c55b086cf8dd0e$export$4d35f98e5d7d0978;
    localStorage.setItem('myName', JSON.stringify($e1c55b086cf8dd0e$var$myNameRec));
    $e1c55b086cf8dd0e$var$yAwareness.setLocalState({
        user: $e1c55b086cf8dd0e$var$myNameRec
    });
    $e1c55b086cf8dd0e$var$showAvatars();
}
/**
 * if this is the user's first time, show them how the user interface works
 */ function $e1c55b086cf8dd0e$var$setUpTutorial() {
    if (localStorage.getItem('doneIntro') !== 'done' && $e1c55b086cf8dd0e$var$viewOnly === false) {
        $e1c55b086cf8dd0e$var$tutorial.onexit(function() {
            localStorage.setItem('doneIntro', 'done');
        });
        $e1c55b086cf8dd0e$var$tutorial.onstep(0, ()=>{
            let splashNameBox = (0, $gFW3W.elem)('splashNameBox');
            let anonName = $e1c55b086cf8dd0e$var$myNameRec.name || (0, $gFW3W.generateName)().name;
            splashNameBox.placeholder = anonName;
            splashNameBox.focus();
            splashNameBox.addEventListener('blur', ()=>{
                $e1c55b086cf8dd0e$var$saveUserName(splashNameBox.value || anonName);
            });
            splashNameBox.addEventListener('keyup', (e)=>{
                if (e.key === 'Enter') splashNameBox.blur();
            });
        });
        $e1c55b086cf8dd0e$var$tutorial.start();
    }
}
/**
 * draw the network, after setting the vis-network options
 */ function $e1c55b086cf8dd0e$var$draw() {
    // for testing, you can append ?t=XXX to the URL of the page, where XXX is the number
    // of factors to include in a random network
    let url = new URL(document.location);
    let nNodes = parseInt(url.searchParams.get('t'));
    if (nNodes) $e1c55b086cf8dd0e$var$getRandomData(nNodes);
    // create a network
    var options = {
        nodes: {
            chosen: {
                node: function(values, id, selected) {
                    values.shadow = selected;
                }
            }
        },
        edges: {
            chosen: {
                edge: function(values, id, selected) {
                    values.shadow = selected;
                }
            },
            smooth: {
                type: 'straightCross'
            }
        },
        physics: {
            enabled: false,
            stabilization: false
        },
        interaction: {
            multiselect: true,
            selectConnectedEdges: false,
            hover: false,
            hoverConnectedEdges: false,
            zoomView: false,
            tooltipDelay: 0
        },
        manipulation: {
            enabled: false,
            addNode: function(item, callback) {
                item.label = '';
                item = (0, $gFW3W.deepMerge)(item, (0, $09258687963db43e$export$9dd6ff9ea0189349).nodes[$e1c55b086cf8dd0e$export$794b27baf354ffba]);
                item.grp = $e1c55b086cf8dd0e$export$794b27baf354ffba;
                item.created = $e1c55b086cf8dd0e$export$fc00ee57782020aa();
                $e1c55b086cf8dd0e$var$addLabel(item, $e1c55b086cf8dd0e$var$cancelAdd, callback);
                $e1c55b086cf8dd0e$var$showPressed('addNode', 'remove');
            },
            editNode: function(item, callback) {
                // for some weird reason, vis-network copies the group properties into the
                // node properties before calling this fn, which we don't want.  So we
                // revert to using the original node properties before continuing.
                item = $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(item.id);
                item.modified = $e1c55b086cf8dd0e$export$fc00ee57782020aa();
                let point = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.canvasToDOM({
                    x: item.x,
                    y: item.y
                });
                $e1c55b086cf8dd0e$var$editNode(item, point, $e1c55b086cf8dd0e$var$cancelEdit, callback);
            },
            addEdge: function(item, callback) {
                $e1c55b086cf8dd0e$var$inAddMode = false;
                $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.setOptions({
                    interaction: {
                        dragView: true,
                        selectable: true
                    }
                });
                $e1c55b086cf8dd0e$var$showPressed('addLink', 'remove');
                if (item.from === item.to) {
                    callback(null);
                    $e1c55b086cf8dd0e$var$stopEdit();
                    return;
                }
                if ($e1c55b086cf8dd0e$var$duplEdge(item.from, item.to).length > 0) {
                    (0, $gFW3W.alertMsg)('There is already a link from this Factor to the other.', 'error');
                    callback(null);
                    $e1c55b086cf8dd0e$var$stopEdit();
                    return;
                }
                if ($e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(item.from).isCluster || $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(item.to).isCluster) {
                    (0, $gFW3W.alertMsg)('Links cannot be made to or from a cluster', 'error');
                    callback(null);
                    $e1c55b086cf8dd0e$var$stopEdit();
                    return;
                }
                item = (0, $gFW3W.deepMerge)(item, (0, $09258687963db43e$export$9dd6ff9ea0189349).edges[$e1c55b086cf8dd0e$export$a01f2d76756b77a5]);
                item.grp = $e1c55b086cf8dd0e$export$a01f2d76756b77a5;
                item.created = $e1c55b086cf8dd0e$export$fc00ee57782020aa();
                (0, $gFW3W.clearStatusBar)();
                callback(item);
                $e1c55b086cf8dd0e$export$e5fde6ebaea8ae1d(`added link from '${$e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(item.from).label}' to '${$e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(item.to).label}'`);
            },
            editEdge: {
                editWithoutDrag: function(item, callback) {
                    item = $e1c55b086cf8dd0e$export$4051a07651545597.edges.get(item.id);
                    item.modified = $e1c55b086cf8dd0e$export$fc00ee57782020aa();
                    // find midpoint of edge
                    let point = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.canvasToDOM({
                        x: ($e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getPosition(item.from).x + $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getPosition(item.to).x) / 2,
                        y: ($e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getPosition(item.from).y + $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getPosition(item.to).y) / 2
                    });
                    $e1c55b086cf8dd0e$var$editEdge(item, point, $e1c55b086cf8dd0e$var$cancelEdit, callback);
                }
            },
            deleteNode: function(item, callback) {
                let locked = false;
                item.nodes.forEach((nId)=>{
                    let n = $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(nId);
                    if (n.locked) {
                        locked = true;
                        (0, $gFW3W.alertMsg)(`Factor '${(0, $gFW3W.shorten)(n.oldLabel)}' can't be deleted because it is locked`, 'warn');
                        callback(null);
                        return;
                    }
                });
                if (locked) return;
                (0, $gFW3W.clearStatusBar)();
                $e1c55b086cf8dd0e$var$hideNotes();
                // delete also all the edges that link to the nodes being deleted
                item.nodes.forEach((nId)=>{
                    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getConnectedEdges(nId).forEach((eId)=>{
                        if (item.edges.indexOf(eId) === -1) item.edges.push(eId);
                    });
                });
                item.edges.forEach((edgeId)=>{
                    $e1c55b086cf8dd0e$export$e5fde6ebaea8ae1d(`deleted link from '${$e1c55b086cf8dd0e$export$4051a07651545597.nodes.get($e1c55b086cf8dd0e$export$4051a07651545597.edges.get(edgeId).from).label}' to '${$e1c55b086cf8dd0e$export$4051a07651545597.nodes.get($e1c55b086cf8dd0e$export$4051a07651545597.edges.get(edgeId).to).label}'`);
                });
                $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.unselectAll();
                item.nodes.forEach((nodeId)=>{
                    $e1c55b086cf8dd0e$export$e5fde6ebaea8ae1d(`deleted factor: '${$e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(nodeId).label}'`);
                });
                callback(item);
            },
            deleteEdge: function(item, callback) {
                item.edges.forEach((edgeId)=>{
                    $e1c55b086cf8dd0e$export$e5fde6ebaea8ae1d(`deleted link from '${$e1c55b086cf8dd0e$export$4051a07651545597.nodes.get($e1c55b086cf8dd0e$export$4051a07651545597.edges.get(edgeId).from).label}' to '${$e1c55b086cf8dd0e$export$4051a07651545597.nodes.get($e1c55b086cf8dd0e$export$4051a07651545597.edges.get(edgeId).to).label}'`);
                });
                callback(item);
            },
            controlNodeStyle: {
                shape: 'dot',
                color: 'red',
                size: 5,
                group: undefined
            }
        }
    };
    if ($e1c55b086cf8dd0e$var$viewOnly) options.interaction = {
        dragNodes: false,
        hover: false
    };
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4 = new (0, $bebd28704f2536ea$export$95be4ae94445245a)($e1c55b086cf8dd0e$export$4b72f5d71fff605, $e1c55b086cf8dd0e$export$4051a07651545597, options);
    window.network = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4;
    (0, $gFW3W.elem)('zoom').value = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getScale();
    // start with factor tab open, but hidden
    (0, $gFW3W.elem)('nodesButton').click();
    // listen for click events on the network pane
    let doubleClickTimer = null;
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.on('click', (params)=>{
        if (/gui/.test($e1c55b086cf8dd0e$export$1c9f709888824e05)) console.log('**click**', params);
        // if user is doing an analysis, and has clicked on a node, show the node notes
        if ($e1c55b086cf8dd0e$var$getRadioVal('radius') !== 'All' || $e1c55b086cf8dd0e$var$getRadioVal('stream') !== 'All' || $e1c55b086cf8dd0e$var$getRadioVal('paths') !== 'All') {
            if (!$e1c55b086cf8dd0e$var$showNotesToggle) return;
            $e1c55b086cf8dd0e$var$hideNotes();
            let clickedNodeId = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getNodeAt(params.pointer.DOM);
            if (clickedNodeId) $e1c55b086cf8dd0e$var$showNodeData(clickedNodeId);
            else {
                let clickedEdgeId = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getEdgeAt(params.pointer.DOM);
                if (clickedEdgeId) $e1c55b086cf8dd0e$var$showEdgeData(clickedEdgeId);
            }
            return;
        }
        // if user has clicked on a portal node, open the map in another tab and go to it
        if (params.nodes.length === 1) {
            let node = $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(params.nodes[0]);
            // tricky stuff to distinguish a single click (move to map) from a double click (edit node)
            if (node.portal && doubleClickTimer === null) doubleClickTimer = setTimeout(()=>{
                window.open(`${window.location.pathname}?room=${node.portal}`, node.portal);
                doubleClickTimer = null;
            }, 500);
        }
        let keys = params.event.pointers[0];
        if (!keys) return;
        if (keys.metaKey) {
            // if the Command key (on a Mac) is down, and the click is on a node/edge, log it to the console
            if (params.nodes.length === 1) {
                let node = $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(params.nodes[0]);
                console.log('node = ', node);
                window.node = node;
            }
            if (params.edges.length === 1) {
                let edge = $e1c55b086cf8dd0e$export$4051a07651545597.edges.get(params.edges[0]);
                console.log('edge = ', edge);
                window.edge = edge;
            }
            return;
        }
        if (keys.altKey) {
            // if the Option/ALT key is down, add a node if on the background
            if (params.nodes.length === 0 && params.edges.length === 0) {
                let pos = params.pointer.canvas;
                let item = {
                    id: (0, $gFW3W.uuidv4)(),
                    label: '',
                    x: pos.x,
                    y: pos.y
                };
                item = (0, $gFW3W.deepMerge)(item, (0, $09258687963db43e$export$9dd6ff9ea0189349).nodes[$e1c55b086cf8dd0e$export$794b27baf354ffba]);
                item.grp = $e1c55b086cf8dd0e$export$794b27baf354ffba;
                $e1c55b086cf8dd0e$var$addLabel(item, $e1c55b086cf8dd0e$var$clearPopUp, function(newItem) {
                    if (newItem !== null) $e1c55b086cf8dd0e$export$4051a07651545597.nodes.add(newItem);
                });
            }
            return;
        }
        if (keys.shiftKey) {
            if (!$e1c55b086cf8dd0e$var$inEditMode) showMagnifier(keys);
            return;
        }
        // Might be a click on a thumb up/down
        if ($e1c55b086cf8dd0e$var$showVotingToggle) for (const node of $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get()){
            let bBox = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getBoundingBox(node.id);
            let clickPos = params.pointer.canvas;
            if (clickPos.x > bBox.left && clickPos.x < bBox.right && clickPos.y > bBox.bottom && clickPos.y < bBox.bottom + 20) {
                if (clickPos.x < bBox.left + (bBox.right - bBox.left) / 2) {
                    // if user has not already voted for this, add their vote, i.e. add their clientID
                    // or if they have voted, remove it
                    if (node.thumbUp?.includes($e1c55b086cf8dd0e$export$4d35f98e5d7d0978)) node.thumbUp = node.thumbUp.filter((c)=>c !== $e1c55b086cf8dd0e$export$4d35f98e5d7d0978);
                    else if (node.thumbUp) node.thumbUp.push($e1c55b086cf8dd0e$export$4d35f98e5d7d0978);
                    else node.thumbUp = [
                        $e1c55b086cf8dd0e$export$4d35f98e5d7d0978
                    ];
                } else {
                    if (node.thumbDown?.includes($e1c55b086cf8dd0e$export$4d35f98e5d7d0978)) node.thumbDown = node.thumbDown.filter((c)=>c !== $e1c55b086cf8dd0e$export$4d35f98e5d7d0978);
                    else if (node.thumbDown) node.thumbDown.push($e1c55b086cf8dd0e$export$4d35f98e5d7d0978);
                    else node.thumbDown = [
                        $e1c55b086cf8dd0e$export$4d35f98e5d7d0978
                    ];
                }
                $e1c55b086cf8dd0e$export$4051a07651545597.nodes.update(node);
                return;
            }
        }
    });
    // despatch to edit a node or an edge or to fit the network on the pane
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.on('doubleClick', function(params) {
        if (/gui/.test($e1c55b086cf8dd0e$export$1c9f709888824e05)) console.log('**doubleClick**');
        clearTimeout(doubleClickTimer);
        doubleClickTimer = null;
        if (params.nodes.length === 1) {
            if (!($e1c55b086cf8dd0e$var$viewOnly || $e1c55b086cf8dd0e$var$inEditMode)) $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.editNode();
        } else if (params.edges.length === 1) {
            if (!($e1c55b086cf8dd0e$var$viewOnly || $e1c55b086cf8dd0e$var$inEditMode)) $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.editEdgeMode();
        } else $e1c55b086cf8dd0e$export$1e044b7877db048c();
    });
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.on('selectNode', function(params) {
        if (/gui/.test($e1c55b086cf8dd0e$export$1c9f709888824e05)) console.log('selectNode', params);
        // if user is doing an analysis, do nothing
        if ($e1c55b086cf8dd0e$var$getRadioVal('radius') !== 'All' || $e1c55b086cf8dd0e$var$getRadioVal('stream') !== 'All' || $e1c55b086cf8dd0e$var$getRadioVal('paths') !== 'All') return;
        // if a 'hidden' node is clicked, it is selected, but we don't want this
        // reset the selected nodes to all except the hidden one
        $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.setSelection({
            nodes: params.nodes.filter((id)=>!$e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(id).nodeHidden),
            edges: params.edges.filter((id)=>!$e1c55b086cf8dd0e$export$4051a07651545597.edges.get(id).edgeHidden)
        });
        $e1c55b086cf8dd0e$var$showSelected();
        $e1c55b086cf8dd0e$var$showNodeOrEdgeData();
        $e1c55b086cf8dd0e$export$c1a1b42e4610dc4a();
        if ($e1c55b086cf8dd0e$var$getRadioVal('radius') !== 'All') $e1c55b086cf8dd0e$var$analyse();
        if ($e1c55b086cf8dd0e$var$getRadioVal('stream') !== 'All') $e1c55b086cf8dd0e$var$analyse();
        if ($e1c55b086cf8dd0e$var$getRadioVal('paths') !== 'All') $e1c55b086cf8dd0e$var$analyse();
    });
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.on('deselectNode', function(params) {
        if (/gui/.test($e1c55b086cf8dd0e$export$1c9f709888824e05)) console.log('deselectNode', params);
        // if user is doing an analysis, do nothing, but first reselect the unselected nodes
        if ($e1c55b086cf8dd0e$var$getRadioVal('radius') !== 'All' || $e1c55b086cf8dd0e$var$getRadioVal('stream') !== 'All' || $e1c55b086cf8dd0e$var$getRadioVal('paths') !== 'All') {
            $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.setSelection({
                nodes: params.previousSelection.nodes.map((node)=>node.id),
                edges: params.previousSelection.edges.map((edge)=>edge.id)
            });
            return;
        }
        // if some other node(s) are already selected, and the user has
        // clicked on one of the selected nodes, do nothing,
        // i.e reselect all the nodes previously selected
        // similarly, if the user has clicked on a 'hidden' node,
        // reselect the previous nodes and do nothing
        if (params.nodes) {
            // clicked on a node
            let prevSelIds = params.previousSelection.nodes.map((node)=>node.id);
            let hiddenEdge;
            if (params.edges.length) hiddenEdge = $e1c55b086cf8dd0e$export$4051a07651545597.edges.get(params.edges[0]).edgeHidden;
            if (prevSelIds.includes(params.nodes[0]) || $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(params.nodes[0]).nodeHidden || hiddenEdge) {
                // reselect the previously selected nodes
                $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.selectNodes(params.previousSelection.nodes.map((node)=>node.id), false);
                return;
            }
        }
        $e1c55b086cf8dd0e$var$showSelected();
        $e1c55b086cf8dd0e$var$showNodeOrEdgeData();
        $e1c55b086cf8dd0e$export$c1a1b42e4610dc4a();
    });
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.on('hoverNode', function() {
        $e1c55b086cf8dd0e$var$changeCursor('grab');
    });
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.on('blurNode', function() {
        $e1c55b086cf8dd0e$var$changeCursor('default');
    });
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.on('selectEdge', function(params) {
        if (/gui/.test($e1c55b086cf8dd0e$export$1c9f709888824e05)) console.log('selectEdge');
        // if user is doing an analysis, do nothing
        if ($e1c55b086cf8dd0e$var$getRadioVal('radius') !== 'All' || $e1c55b086cf8dd0e$var$getRadioVal('stream') !== 'All' || $e1c55b086cf8dd0e$var$getRadioVal('paths') !== 'All') return;
        $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.setSelection({
            nodes: params.nodes.filter((id)=>!$e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(id).nodeHidden),
            edges: params.edges.filter((id)=>!$e1c55b086cf8dd0e$export$4051a07651545597.edges.get(id).edgeHidden)
        });
        $e1c55b086cf8dd0e$var$showSelected();
        $e1c55b086cf8dd0e$var$showNodeOrEdgeData();
        $e1c55b086cf8dd0e$export$c1a1b42e4610dc4a();
    });
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.on('deselectEdge', function(params) {
        if (/gui/.test($e1c55b086cf8dd0e$export$1c9f709888824e05)) console.log('deselectEdge');
        // if user is doing an analysis, do nothing, but first reselect the unselected nodes
        if ($e1c55b086cf8dd0e$var$getRadioVal('radius') !== 'All' || $e1c55b086cf8dd0e$var$getRadioVal('stream') !== 'All' || $e1c55b086cf8dd0e$var$getRadioVal('paths') !== 'All') {
            $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.setSelection({
                nodes: params.previousSelection.nodes.map((node)=>node.id),
                edges: params.previousSelection.edges.map((edge)=>edge.id)
            });
            return;
        }
        if (params.edges) {
            // clicked on an edge(see selectNode for comments)
            let prevSelIds = params.previousSelection.edges.map((edge)=>edge.id);
            if (prevSelIds.includes(params.edges[0]) || $e1c55b086cf8dd0e$export$4051a07651545597.edges.get(params.edges[0]).edgeHidden) {
                // reselect the previously selected edges
                $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.selectEdges(params.previousSelection.edges.map((edge)=>edge.id), false);
                return;
            }
        }
        $e1c55b086cf8dd0e$var$hideNotes();
        $e1c55b086cf8dd0e$var$showSelected();
        $e1c55b086cf8dd0e$export$c1a1b42e4610dc4a();
    });
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.on('oncontext', function(e) {
        let nodeId = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getNodeAt(e.pointer.DOM);
        if (nodeId) (0, $4a821ee537123403$export$14b245ef7e84f38d)(nodeId);
    });
    let viewPosition;
    let selectionCanvasStart = {};
    let selectionStart = {};
    let selectionArea = document.createElement('div');
    selectionArea.className = 'selectionBox';
    selectionArea.style.display = 'none';
    (0, $gFW3W.elem)('main').appendChild(selectionArea);
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.on('dragStart', function(params) {
        if (/gui/.test($e1c55b086cf8dd0e$export$1c9f709888824e05)) console.log('dragStart');
        viewPosition = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getViewPosition();
        let e = params.event.pointers[0];
        // start drawing a selection rectangle if the CTRL key is down and click is on the background
        if (e.ctrlKey && params.nodes.length === 0 && params.edges.length === 0) {
            $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.setOptions({
                interaction: {
                    dragView: false
                }
            });
            (0, $gFW3W.listen)('net-pane', 'mousemove', showAreaSelection);
            selectionStart = {
                x: e.offsetX,
                y: e.offsetY
            };
            selectionCanvasStart = params.pointer.canvas;
            selectionArea.style.left = `${e.offsetX}px`;
            selectionArea.style.top = `${e.offsetY}px`;
            selectionArea.style.width = '0px';
            selectionArea.style.height = '0px';
            selectionArea.style.display = 'block';
            return;
        }
        if (e.altKey) {
            if (!$e1c55b086cf8dd0e$var$inAddMode) {
                $e1c55b086cf8dd0e$var$removeFactorCursor();
                $e1c55b086cf8dd0e$var$changeCursor('crosshair');
                $e1c55b086cf8dd0e$var$inAddMode = 'addLink';
                $e1c55b086cf8dd0e$var$showPressed('addLink', 'add');
                (0, $gFW3W.statusMsg)('Now drag to the middle of the Destination factor');
                $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.setOptions({
                    interaction: {
                        dragView: false,
                        selectable: false
                    }
                });
                $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.addEdgeMode();
                return;
            }
        }
        $e1c55b086cf8dd0e$var$changeCursor('grabbing');
    });
    /**
	 * update the selection rectangle as the mouse moves
	 * @param {Event} event
	 */ function showAreaSelection(event1) {
        selectionArea.style.left = `${Math.min(selectionStart.x, event1.offsetX)}px`;
        selectionArea.style.top = `${Math.min(selectionStart.y, event1.offsetY)}px`;
        selectionArea.style.width = `${Math.abs(event1.offsetX - selectionStart.x)}px`;
        selectionArea.style.height = `${Math.abs(event1.offsetY - selectionStart.y)}px`;
    }
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.on('dragging', function() {
        if (/gui/.test($e1c55b086cf8dd0e$export$1c9f709888824e05)) console.log('dragging');
        let endViewPosition = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getViewPosition();
        (0, $a4a268d7686bbf3f$export$4ccc1b9eba0bcd20)(viewPosition.x - endViewPosition.x, viewPosition.y - endViewPosition.y);
        viewPosition = endViewPosition;
    });
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.on('dragEnd', function(params) {
        if (/gui/.test($e1c55b086cf8dd0e$export$1c9f709888824e05)) console.log('dragEnd');
        let endViewPosition = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getViewPosition();
        (0, $a4a268d7686bbf3f$export$4ccc1b9eba0bcd20)(viewPosition.x - endViewPosition.x, viewPosition.y - endViewPosition.y);
        if (selectionArea.style.display === 'block') {
            selectionArea.style.display = 'none';
            $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.setOptions({
                interaction: {
                    dragView: true
                }
            });
            (0, $gFW3W.elem)('net-pane').removeEventListener('mousemove', showAreaSelection);
        }
        let e = params.event.pointers[0];
        if (e.ctrlKey && params.nodes.length === 0 && params.edges.length === 0) {
            $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.storePositions();
            let selectionCanvasEnd = params.pointer.canvas;
            if (selectionCanvasStart.x > selectionCanvasEnd.x) [selectionCanvasStart.x, selectionCanvasEnd.x] = [
                selectionCanvasEnd.x,
                selectionCanvasStart.x
            ];
            if (selectionCanvasStart.y > selectionCanvasEnd.y) [selectionCanvasStart.y, selectionCanvasEnd.y] = [
                selectionCanvasEnd.y,
                selectionCanvasStart.y
            ];
            let selectedNodes = $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get({
                filter: function(node) {
                    return !node.nodeHidden && node.x >= selectionCanvasStart.x && node.x <= selectionCanvasEnd.x && node.y >= selectionCanvasStart.y && node.y <= selectionCanvasEnd.y;
                }
            });
            $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.setSelection({
                nodes: selectedNodes.map((n)=>n.id).concat($e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getSelectedNodes())
            });
            $e1c55b086cf8dd0e$var$showSelected();
            $e1c55b086cf8dd0e$var$showNodeOrEdgeData();
            return;
        }
        let newPositions = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getPositions(params.nodes);
        $e1c55b086cf8dd0e$export$4051a07651545597.nodes.update($e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(params.nodes).map((n)=>{
            n.x = newPositions[n.id].x;
            n.y = newPositions[n.id].y;
            if ($e1c55b086cf8dd0e$var$snapToGridToggle) $e1c55b086cf8dd0e$var$snapToGrid(n);
            return n;
        }));
        $e1c55b086cf8dd0e$var$changeCursor('default');
    });
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.on('controlNodeDragging', function() {
        if (/gui/.test($e1c55b086cf8dd0e$export$1c9f709888824e05)) console.log('controlNodeDragging');
        $e1c55b086cf8dd0e$var$changeCursor('crosshair');
    });
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.on('controlNodeDragEnd', function(event1) {
        if (/gui/.test($e1c55b086cf8dd0e$export$1c9f709888824e05)) console.log('controlNodeDragEnd');
        if (event1.controlEdge.from !== event1.controlEdge.to) $e1c55b086cf8dd0e$var$changeCursor('default');
    });
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.on('beforeDrawing', (ctx)=>(0, $a4a268d7686bbf3f$export$dfdc6d14987fb95e)(ctx));
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.on('afterDrawing', (ctx)=>$e1c55b086cf8dd0e$var$drawBadges(ctx));
    // listen for changes to the network structure
    // and recalculate the network statistics when there is one
    $e1c55b086cf8dd0e$export$4051a07651545597.nodes.on('add', $e1c55b086cf8dd0e$var$recalculateStats);
    $e1c55b086cf8dd0e$export$4051a07651545597.nodes.on('remove', $e1c55b086cf8dd0e$var$recalculateStats);
    $e1c55b086cf8dd0e$export$4051a07651545597.edges.on('add', $e1c55b086cf8dd0e$var$recalculateStats);
    $e1c55b086cf8dd0e$export$4051a07651545597.edges.on('remove', $e1c55b086cf8dd0e$var$recalculateStats);
    /* --------------------------------------------set up the magnifier --------------------------------------------*/ const magSize = 300 // diameter of loupe
    ;
    const halfMagSize = magSize / 2.0;
    const netPaneCanvas = $e1c55b086cf8dd0e$export$4b72f5d71fff605.firstElementChild.firstElementChild;
    let magnifier = document.createElement('canvas');
    magnifier.width = magSize;
    magnifier.height = magSize;
    magnifier.className = 'magnifier';
    let magnifierCtx = magnifier.getContext('2d');
    magnifierCtx.fillStyle = 'white';
    $e1c55b086cf8dd0e$export$4b72f5d71fff605.appendChild(magnifier);
    let bigNetPane = null;
    let bigNetwork = null;
    let bigNetCanvas = null;
    let netPaneRect = null;
    let magnifying = false;
    $e1c55b086cf8dd0e$export$4b72f5d71fff605.addEventListener('keydown', (e)=>{
        if (!$e1c55b086cf8dd0e$var$inEditMode && e.shiftKey && !magnifying) createMagnifier(e);
    });
    $e1c55b086cf8dd0e$export$4b72f5d71fff605.addEventListener('mousemove', (e)=>{
        if (magnifying && !$e1c55b086cf8dd0e$var$inEditMode && e.shiftKey) showMagnifier(e);
    });
    $e1c55b086cf8dd0e$export$4b72f5d71fff605.addEventListener('keyup', (e)=>{
        if (e.key === 'Shift') closeMagnifier();
    });
    // ensure magnifier shows even if mouse is over the panel (e.g. when doing analysis)
    $e1c55b086cf8dd0e$var$panel.addEventListener('keydown', (e)=>{
        if (!$e1c55b086cf8dd0e$var$inEditMode && e.shiftKey && !magnifying) createMagnifier(e);
    });
    $e1c55b086cf8dd0e$var$panel.addEventListener('mousemove', (e)=>{
        if (magnifying && !$e1c55b086cf8dd0e$var$inEditMode && e.shiftKey) showMagnifier(e);
    });
    $e1c55b086cf8dd0e$var$panel.addEventListener('keyup', (e)=>{
        if (e.key === 'Shift') closeMagnifier();
    });
    /**
	 * create a copy of the network, but magnified and off screen
	 */ function createMagnifier(e) {
        if (bigNetPane) {
            bigNetwork.destroy();
            bigNetPane.remove();
        }
        if ($e1c55b086cf8dd0e$export$c05995454a6ca00d) return;
        magnifying = true;
        netPaneRect = $e1c55b086cf8dd0e$export$4b72f5d71fff605.getBoundingClientRect();
        $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.storePositions();
        bigNetPane = document.createElement('div');
        bigNetPane.id = 'big-net-pane';
        bigNetPane.style.position = 'absolute';
        bigNetPane.style.top = '-9999px';
        bigNetPane.style.left = '-9999px';
        bigNetPane.style.width = `${$e1c55b086cf8dd0e$export$4b72f5d71fff605.offsetWidth * $e1c55b086cf8dd0e$var$magnification}px`;
        bigNetPane.style.height = `${$e1c55b086cf8dd0e$export$4b72f5d71fff605.offsetHeight * $e1c55b086cf8dd0e$var$magnification}px`;
        $e1c55b086cf8dd0e$export$4b72f5d71fff605.appendChild(bigNetPane);
        let bigNetData = {
            nodes: new (0, $558228835489ffff$export$486059efd2d2dabe)(),
            edges: new (0, $558228835489ffff$export$486059efd2d2dabe)()
        };
        bigNetData.nodes.add($e1c55b086cf8dd0e$export$4051a07651545597.nodes.get());
        bigNetData.edges.add($e1c55b086cf8dd0e$export$4051a07651545597.edges.get());
        bigNetwork = new (0, $bebd28704f2536ea$export$95be4ae94445245a)(bigNetPane, bigNetData, {
            physics: {
                enabled: false
            }
        });
        /* // unhide any hidden nodes and edges
		let changedNodes = []
		bigNetData.nodes.forEach((n) => {
			if (n.nodeHidden) {
				changedNodes.push(setNodeHidden(n, false))
			}
		})
		let changedEdges = []
		bigNetData.edges.forEach((e) => {
			if (e.edgeHidden) {
				changedEdges.push(setEdgeHidden(e, false))
			}
		})
		bigNetData.nodes.update(changedNodes)
		bigNetData.edges.update(changedEdges) */ bigNetCanvas = bigNetPane.firstElementChild.firstElementChild;
        bigNetwork.on('afterDrawing', ()=>{
            $e1c55b086cf8dd0e$export$2c4cf0d98d0d7068(bigNetCanvas);
        });
        bigNetwork.moveTo({
            position: $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getViewPosition(),
            scale: $e1c55b086cf8dd0e$var$magnification * $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getScale()
        });
        $e1c55b086cf8dd0e$export$4b72f5d71fff605.style.cursor = 'none';
        magnifier.style.display = 'none';
        showMagnifier(e);
    }
    /**
	 * display the loupe, centred on the mouse pointer, and fill it with
	 * an image copied from the magnified network
	 */ function showMagnifier(e) {
        e.preventDefault();
        if ($e1c55b086cf8dd0e$export$c05995454a6ca00d) return;
        if (bigNetCanvas == null) createMagnifier();
        magnifierCtx.fillRect(0, 0, magSize, magSize);
        magnifierCtx.drawImage(bigNetCanvas, (e.clientX - netPaneRect.x) * bigNetCanvas.width / netPaneCanvas.clientWidth - halfMagSize, (e.clientY - netPaneRect.y) * bigNetCanvas.height / netPaneCanvas.clientHeight - halfMagSize, magSize, magSize, 0, 0, magSize, magSize);
        magnifier.style.top = `${e.clientY - netPaneRect.y - halfMagSize}px`;
        magnifier.style.left = `${e.clientX - netPaneRect.x - halfMagSize}px`;
        magnifier.style.display = 'block';
    }
    /**
	 * destroy the magnified network copy
	 */ function closeMagnifier() {
        if (bigNetPane) {
            bigNetwork.destroy();
            bigNetPane.remove();
        }
        $e1c55b086cf8dd0e$export$4b72f5d71fff605.style.cursor = 'default';
        magnifier.style.display = 'none';
        magnifying = false;
    }
} // end draw()
function $e1c55b086cf8dd0e$export$2c4cf0d98d0d7068(canvas) {
    let context = canvas.getContext('2d');
    context.setTransform();
    context.globalCompositeOperation = 'destination-over';
    // apply the background objects
    let backgroundCanvas = document.getElementById('underlay').firstElementChild.firstElementChild;
    context.drawImage(backgroundCanvas, 0, 0, canvas.width, canvas.height);
    // apply the background colour, if any, or white
    context.fillStyle = (0, $gFW3W.elem)('underlay').style.backgroundColor || 'rgb(255, 255, 255)';
    context.fillRect(0, 0, canvas.width, canvas.height);
    return canvas;
}
function $e1c55b086cf8dd0e$export$5dfa5433ac89eafa(ratio = 5) {
    let fullNetPane, fullNetwork, initialScale, initialPosition, minimapWidth, minimapHeight;
    const minimapWrapper = document.getElementById('minimapWrapper') // a div to contain the minimap
    ;
    const minimapImage = document.getElementById('minimapImage') // an img, child of minimapWrapper
    ;
    const minimapRadar = document.getElementById('minimapRadar') // a div, child of minimapWrapper
    ;
    // size the minimap
    minimapSetup();
    // set up dragging of the radar overlay
    let dragging = false // if true, ignore clicks when user is dragging radar overlay
    ;
    dragRadar();
    /**
	 * Set the size of the minimap and its components
	 */ function minimapSetup() {
        const { clientWidth: clientWidth, clientHeight: clientHeight } = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.body.container;
        minimapWidth = clientWidth / ratio;
        minimapHeight = clientHeight / ratio;
        minimapWrapper.style.width = `${minimapWidth}px`;
        minimapWrapper.style.height = `${minimapHeight}px`;
        minimapRadar.style.width = `${minimapWidth}px`;
        minimapRadar.style.height = `${minimapHeight}px`;
        drawMinimapImage();
        drawRadar();
    }
    /**
	 * Draw a copy of the full network offscreen, then create an image of it
	 * The visible network can't be used, because it may be scaled and panned, but the minimap image needs to
	 * show the full network
	 */ function drawMinimapImage() {
        if (!(0, $gFW3W.elem)('fullnetPane')) {
            // if the full network does not exist, create it
            fullNetPane = document.createElement('div');
            fullNetPane.style.position = 'absolute';
            fullNetPane.style.top = '-9999px';
            fullNetPane.style.left = '-9999px';
            fullNetPane.style.width = `${$e1c55b086cf8dd0e$export$4b72f5d71fff605.offsetWidth}px`;
            fullNetPane.style.height = `${$e1c55b086cf8dd0e$export$4b72f5d71fff605.offsetHeight}px`;
            fullNetPane.id = 'fullNetPane';
            $e1c55b086cf8dd0e$export$4b72f5d71fff605.appendChild(fullNetPane);
            fullNetwork = new (0, $bebd28704f2536ea$export$95be4ae94445245a)(fullNetPane, $e1c55b086cf8dd0e$export$4051a07651545597, {
                physics: {
                    enabled: false
                }
            });
        }
        fullNetwork.setOptions({
            edges: {
                smooth: (0, $gFW3W.elem)('curveSelect').value === 'Curved'
            }
        });
        fullNetwork.fit();
        initialScale = fullNetwork.getScale();
        initialPosition = fullNetwork.getViewPosition();
        const fullNetworklCanvas = fullNetPane.firstElementChild.firstElementChild;
        fullNetwork.on('afterDrawing', ()=>{
            // make the image as a reduced version of the fullNetwork
            const tempCanvas = document.createElement('canvas');
            const tempContext = tempCanvas.getContext('2d');
            tempCanvas.width = minimapWidth;
            tempCanvas.height = minimapHeight;
            tempContext.drawImage(fullNetworklCanvas, 0, 0, minimapWidth, minimapHeight);
            minimapImage.src = tempCanvas.toDataURL();
            minimapImage.width = minimapWidth;
            minimapImage.height = minimapHeight;
        });
    }
    /**
	 * Move a radar overlay on the minimap to show the current view of the network
	 */ function drawRadar() {
        const scale = initialScale / $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getScale();
        // fade out the whole minimap if the network is all visible in the viewport
        // (there is no value in having a minimap in this case)
        if (scale >= 1 && networkInPane()) {
            minimapWrapper.style.display = 'none';
            return;
        } else minimapWrapper.style.display = 'block';
        const currentDOMPosition = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.canvasToDOM($e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getViewPosition());
        const initialDOMPosition = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.canvasToDOM(initialPosition);
        minimapRadar.style.left = `${Math.round((currentDOMPosition.x - initialDOMPosition.x) * scale / ratio + minimapWidth * (1 - scale) / 2)}px`;
        minimapRadar.style.top = `${Math.round((currentDOMPosition.y - initialDOMPosition.y) * scale / ratio + minimapHeight * (1 - scale) / 2)}px`;
        minimapRadar.style.width = `${minimapWidth * scale}px`;
        minimapRadar.style.height = `${minimapHeight * scale}px`;
    }
    /**
	 *
	 * @returns {boolean} - true if the network is entirely within the viewport
	 */ function networkInPane() {
        const netPaneTopLeft = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.DOMtoCanvas({
            x: 0,
            y: 0
        });
        const netPaneBottomRight = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.DOMtoCanvas({
            x: $e1c55b086cf8dd0e$export$4b72f5d71fff605.clientWidth,
            y: $e1c55b086cf8dd0e$export$4b72f5d71fff605.clientHeight
        });
        for (const nodeId of $e1c55b086cf8dd0e$export$4051a07651545597.nodes.getIds()){
            const boundingBox = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getBoundingBox(nodeId);
            if (boundingBox.left < netPaneTopLeft.x) return false;
            if (boundingBox.right > netPaneBottomRight.x) return false;
            if (boundingBox.top < netPaneTopLeft.y) return false;
            if (boundingBox.bottom > netPaneBottomRight.y) return false;
        }
        return true;
    }
    /**
	 * Whenever the network is resized, the minimap needs to be resized and the radar overlay moved
	 */ $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.on('resize', ()=>{
        minimapSetup();
    });
    /**
	 * Whenever the network is changed, panned or zoomed, the radar overlay needs to be moved
	 */ $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.on('afterDrawing', ()=>{
        drawRadar();
    });
    /**
	 * Set up dragging of the radar overlay
	 */ function dragRadar() {
        let x, y, radarStart;
        minimapRadar.addEventListener('pointerdown', dragMouseDown);
        minimapWrapper.addEventListener('wheel', (e)=>{
            e.preventDefault();
            // reject all but vertical touch movements
            if (Math.abs(e.deltaX) <= 1) $e1c55b086cf8dd0e$var$zoomscroll(e);
        }, {
            passive: false
        });
        function dragMouseDown(e) {
            e.preventDefault();
            x = e.clientX, y = e.clientY;
            radarStart = {
                x: minimapRadar.offsetLeft,
                y: minimapRadar.offsetTop
            };
            minimapRadar.addEventListener('pointermove', drag);
            minimapRadar.addEventListener('pointerup', dragMouseUp);
        }
        function drag(e) {
            e.preventDefault();
            dragging = true;
            let dx = e.clientX - x;
            let dy = e.clientY - y;
            let left = radarStart.x + dx;
            let top = radarStart.y + dy;
            if (left < 0) left = 0;
            if (left + minimapRadar.offsetWidth >= minimapWidth) left = minimapWidth - minimapRadar.offsetWidth;
            if (top < 0) top = 0;
            if (top + minimapRadar.offsetHeight >= minimapHeight) top = minimapHeight - minimapRadar.offsetHeight;
            minimapRadar.style.left = `${Math.round(left)}px`;
            minimapRadar.style.top = `${Math.round(top)}px`;
            let initialDOMPosition = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.canvasToDOM(initialPosition);
            const scale = initialScale / $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getScale();
            const radarRect = minimapRadar.getBoundingClientRect();
            const wrapperRect = minimapWrapper.getBoundingClientRect();
            $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.moveTo({
                position: $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.DOMtoCanvas({
                    x: (radarRect.left - wrapperRect.left + (radarRect.width - wrapperRect.width) / 2) * ratio / scale + initialDOMPosition.x,
                    y: (radarRect.top - wrapperRect.top + (radarRect.height - wrapperRect.height) / 2) * ratio / scale + initialDOMPosition.y
                })
            });
        }
        function dragMouseUp(e) {
            e.preventDefault();
            if (!dragging) return;
            minimapRadar.removeEventListener('pointermove', drag);
            minimapRadar.removeEventListener('pointerup', dragMouseUp);
        }
    }
}
function $e1c55b086cf8dd0e$export$c265e176a8e0f011() {
    $e1c55b086cf8dd0e$export$2a111da947c407d2.transact(()=>{
        $e1c55b086cf8dd0e$export$9bc34f54445cb725();
        $e1c55b086cf8dd0e$var$ensureNotDrawing();
        $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.destroy();
        $e1c55b086cf8dd0e$var$checkMapSaved = true;
        $e1c55b086cf8dd0e$export$4051a07651545597.nodes.clear();
        $e1c55b086cf8dd0e$export$4051a07651545597.edges.clear();
        $e1c55b086cf8dd0e$var$draw();
    });
}
function $e1c55b086cf8dd0e$export$38a5743670a777eb() {
    $e1c55b086cf8dd0e$var$checkMapSaved = false;
    $e1c55b086cf8dd0e$var$dirty = false;
}
function $e1c55b086cf8dd0e$export$c1a1b42e4610dc4a() {
    if ($e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getSelectedNodes().length > 0 || $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getSelectedEdges().length > 0) (0, $gFW3W.elem)('deleteNode').classList.remove('disabled');
    else (0, $gFW3W.elem)('deleteNode').classList.add('disabled');
}
function $e1c55b086cf8dd0e$var$contextMenu(event1) {
    event1.preventDefault();
}
function $e1c55b086cf8dd0e$export$fc00ee57782020aa() {
    return {
        time: Date.now(),
        user: $e1c55b086cf8dd0e$var$myNameRec.name
    };
}
window.timestamp = $e1c55b086cf8dd0e$export$fc00ee57782020aa;
/**
 * Generate a key for a time slot in the history log
 *
 * @param {integer} time
 * @returns {string} key
 */ function $e1c55b086cf8dd0e$var$timekey(time) {
    return $e1c55b086cf8dd0e$export$f9d3fff8c23da278 + time;
}
function $e1c55b086cf8dd0e$export$e5fde6ebaea8ae1d(action, actor) {
    let now = Date.now();
    $e1c55b086cf8dd0e$export$d920e34eaf2b21cb.push([
        {
            action: action,
            time: now,
            user: actor ? actor : $e1c55b086cf8dd0e$var$myNameRec.name
        }
    ]);
    // store the current state of the map for possible rollback
    localStorage.setItem($e1c55b086cf8dd0e$var$timekey(now), $e1c55b086cf8dd0e$var$savedState);
    $e1c55b086cf8dd0e$var$savedState = $e1c55b086cf8dd0e$export$fb931cd598921492();
    // delete all but the last ROLLBACKS saved states
    for(let i = 0; i < $e1c55b086cf8dd0e$export$d920e34eaf2b21cb.length - $e1c55b086cf8dd0e$var$ROLLBACKS; i++){
        let obj = $e1c55b086cf8dd0e$export$d920e34eaf2b21cb.get(i);
        if (obj.time) localStorage.removeItem($e1c55b086cf8dd0e$var$timekey(obj.time));
    }
    if ((0, $gFW3W.elem)('history-window').style.display === 'block') $e1c55b086cf8dd0e$var$showHistory();
    $e1c55b086cf8dd0e$var$dirty = true;
}
function $e1c55b086cf8dd0e$export$fb931cd598921492(options) {
    return (0, $3gspO.compressToUTF16)(JSON.stringify({
        nodes: $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(),
        edges: $e1c55b086cf8dd0e$export$4051a07651545597.edges.get(),
        net: $e1c55b086cf8dd0e$export$807f940a96777041.toJSON(),
        samples: $e1c55b086cf8dd0e$export$4b63d58d2685a993.toJSON(),
        paint: $e1c55b086cf8dd0e$export$ffba1a0e51177788.toArray(),
        drawing: $e1c55b086cf8dd0e$export$da7062de5ac36f9c.toJSON(),
        options: options
    }));
}
/******************************************************** map notes side drawer *********************************************************/ /**
 * set up the side drawer for notes
 */ function $e1c55b086cf8dd0e$var$setUpSideDrawer() {
    let toolbarOptions = [
        [
            'bold',
            'italic',
            'underline',
            'strike'
        ],
        [
            'blockquote',
            'code-block'
        ],
        [
            {
                list: 'ordered'
            },
            {
                list: 'bullet'
            }
        ],
        [
            {
                script: 'sub'
            },
            {
                script: 'super'
            }
        ],
        [
            {
                indent: '-1'
            },
            {
                indent: '+1'
            }
        ],
        [
            {
                align: []
            }
        ],
        [
            'link',
            'image'
        ],
        [
            {
                size: [
                    'small',
                    false,
                    'large',
                    'huge'
                ]
            }
        ],
        [
            {
                header: [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    false
                ]
            }
        ],
        [
            {
                color: []
            },
            {
                background: []
            }
        ],
        [
            {
                font: []
            }
        ],
        [
            'clean'
        ]
    ];
    $e1c55b086cf8dd0e$var$sideDrawEditor = new (0, $aBK2w.default)((0, $gFW3W.elem)('drawer-editor'), {
        modules: {
            toolbar: $e1c55b086cf8dd0e$var$viewOnly ? null : toolbarOptions
        },
        placeholder: 'Notes about the map',
        theme: 'snow',
        readOnly: $e1c55b086cf8dd0e$var$viewOnly
    });
    $e1c55b086cf8dd0e$var$sideDrawEditor.on('text-change', (delta, oldDelta, source)=>{
        if (source === 'user') $e1c55b086cf8dd0e$export$807f940a96777041.set('mapDescription', {
            text: (0, $gFW3W.isQuillEmpty)($e1c55b086cf8dd0e$var$sideDrawEditor) ? '' : $e1c55b086cf8dd0e$var$sideDrawEditor.getContents()
        });
    });
}
function $e1c55b086cf8dd0e$export$cff30a8f7435ec50(contents) {
    $e1c55b086cf8dd0e$var$sideDrawEditor.setContents(contents.text);
}
function $e1c55b086cf8dd0e$export$3a86b7dfc26ebfa6() {
    $e1c55b086cf8dd0e$var$sideDrawEditor.disable();
    (0, $gFW3W.elem)('drawer').firstElementChild.style.display = 'none';
}
/************************************************************* badges around the factors ******************************************/ var $e1c55b086cf8dd0e$var$noteImage = new Image();
$e1c55b086cf8dd0e$var$noteImage.src = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYmkgYmktY2FyZC10ZXh0IiB2aWV3Qm94PSIwIDAgMTYgMTYiPgogIDxwYXRoIGQ9Ik0xNC41IDNhLjUuNSAwIDAgMSAuNS41djlhLjUuNSAwIDAgMS0uNS41aC0xM2EuNS41IDAgMCAxLS41LS41di05YS41LjUgMCAwIDEgLjUtLjVoMTN6bS0xMy0xQTEuNSAxLjUgMCAwIDAgMCAzLjV2OUExLjUgMS41IDAgMCAwIDEuNSAxNGgxM2ExLjUgMS41IDAgMCAwIDEuNS0xLjV2LTlBMS41IDEuNSAwIDAgMCAxNC41IDJoLTEzeiIvPgogIDxwYXRoIGQ9Ik0zIDUuNWEuNS41IDAgMCAxIC41LS41aDlhLjUuNSAwIDAgMSAwIDFoLTlhLjUuNSAwIDAgMS0uNS0uNXpNMyA4YS41LjUgMCAwIDEgLjUtLjVoOWEuNS41IDAgMCAxIDAgMWgtOUEuNS41IDAgMCAxIDMgOHptMCAyLjVhLjUuNSAwIDAgMSAuNS0uNWg2YS41LjUgMCAwIDEgMCAxaC02YS41LjUgMCAwIDEtLjUtLjV6Ii8+Cjwvc3ZnPg==';
var $e1c55b086cf8dd0e$var$lockImage = new Image();
$e1c55b086cf8dd0e$var$lockImage.src = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYmkgYmktbG9jay1maWxsIiB2aWV3Qm94PSIwIDAgMTYgMTYiPgogIDxwYXRoIGQ9Ik04IDFhMiAyIDAgMCAxIDIgMnY0SDZWM2EyIDIgMCAwIDEgMi0yem0zIDZWM2EzIDMgMCAwIDAtNiAwdjRhMiAyIDAgMCAwLTIgMnY1YTIgMiAwIDAgMCAyIDJoNmEyIDIgMCAwIDAgMi0yVjlhMiAyIDAgMCAwLTItMnoiLz4KPC9zdmc+';
var $e1c55b086cf8dd0e$var$thumbUpImage = new Image();
$e1c55b086cf8dd0e$var$thumbUpImage.src = 'data:image/svg+xml;base64,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';
var $e1c55b086cf8dd0e$var$thumbUpFilledImage = new Image();
$e1c55b086cf8dd0e$var$thumbUpFilledImage.src = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYmkgYmktaGFuZC10aHVtYnMtdXAtZmlsbCIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8cGF0aCBkPSJNNi45NTYgMS43NDVDNy4wMjEuODEgNy45MDguMDg3IDguODY0LjMyNWwuMjYxLjA2NmMuNDYzLjExNi44NzQuNDU2IDEuMDEyLjk2NS4yMi44MTYuNTMzIDIuNTExLjA2MiA0LjUxYTkuODQgOS44NCAwIDAgMSAuNDQzLS4wNTFjLjcxMy0uMDY1IDEuNjY5LS4wNzIgMi41MTYuMjEuNTE4LjE3My45OTQuNjgxIDEuMiAxLjI3My4xODQuNTMyLjE2IDEuMTYyLS4yMzQgMS43MzMuMDU4LjExOS4xMDMuMjQyLjEzOC4zNjMuMDc3LjI3LjExMy41NjcuMTEzLjg1NiAwIC4yODktLjAzNi41ODYtLjExMy44NTYtLjAzOS4xMzUtLjA5LjI3My0uMTYuNDA0LjE2OS4zODcuMTA3LjgxOS0uMDAzIDEuMTQ4YTMuMTYzIDMuMTYzIDAgMCAxLS40ODguOTAxYy4wNTQuMTUyLjA3Ni4zMTIuMDc2LjQ2NSAwIC4zMDUtLjA4OS42MjUtLjI1My45MTJDMTMuMSAxNS41MjIgMTIuNDM3IDE2IDExLjUgMTZIOGMtLjYwNSAwLTEuMDctLjA4MS0xLjQ2Ni0uMjE4YTQuODIgNC44MiAwIDAgMS0uOTctLjQ4NGwtLjA0OC0uMDNjLS41MDQtLjMwNy0uOTk5LS42MDktMi4wNjgtLjcyMkMyLjY4MiAxNC40NjQgMiAxMy44NDYgMiAxM1Y5YzAtLjg1LjY4NS0xLjQzMiAxLjM1Ny0xLjYxNS44NDktLjIzMiAxLjU3NC0uNzg3IDIuMTMyLTEuNDEuNTYtLjYyNy45MTQtMS4yOCAxLjAzOS0xLjYzOS4xOTktLjU3NS4zNTYtMS41MzkuNDI4LTIuNTl6Ii8+Cjwvc3ZnPg==';
var $e1c55b086cf8dd0e$var$thumbDownImage = new Image();
$e1c55b086cf8dd0e$var$thumbDownImage.src = 'data:image/svg+xml;base64,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';
var $e1c55b086cf8dd0e$var$thumbDownFilledImage = new Image();
$e1c55b086cf8dd0e$var$thumbDownFilledImage.src = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYmkgYmktaGFuZC10aHVtYnMtZG93bi1maWxsIiB2aWV3Qm94PSIwIDAgMTYgMTYiPgogIDxwYXRoIGQ9Ik02Ljk1NiAxNC41MzRjLjA2NS45MzYuOTUyIDEuNjU5IDEuOTA4IDEuNDJsLjI2MS0uMDY1YTEuMzc4IDEuMzc4IDAgMCAwIDEuMDEyLS45NjVjLjIyLS44MTYuNTMzLTIuNTEyLjA2Mi00LjUxLjEzNi4wMi4yODUuMDM3LjQ0My4wNTEuNzEzLjA2NSAxLjY2OS4wNzEgMi41MTYtLjIxMS41MTgtLjE3My45OTQtLjY4IDEuMi0xLjI3MmExLjg5NiAxLjg5NiAwIDAgMC0uMjM0LTEuNzM0Yy4wNTgtLjExOC4xMDMtLjI0Mi4xMzgtLjM2Mi4wNzctLjI3LjExMy0uNTY4LjExMy0uODU2IDAtLjI5LS4wMzYtLjU4Ni0uMTEzLS44NTdhMi4wOTQgMi4wOTQgMCAwIDAtLjE2LS40MDNjLjE2OS0uMzg3LjEwNy0uODItLjAwMy0xLjE0OWEzLjE2MiAzLjE2MiAwIDAgMC0uNDg4LS45Yy4wNTQtLjE1My4wNzYtLjMxMy4wNzYtLjQ2NWExLjg2IDEuODYgMCAwIDAtLjI1My0uOTEyQzEzLjEuNzU3IDEyLjQzNy4yOCAxMS41LjI4SDhjLS42MDUgMC0xLjA3LjA4LTEuNDY2LjIxN2E0LjgyMyA0LjgyMyAwIDAgMC0uOTcuNDg1bC0uMDQ4LjAyOWMtLjUwNC4zMDgtLjk5OS42MS0yLjA2OC43MjNDMi42ODIgMS44MTUgMiAyLjQzNCAyIDMuMjc5djRjMCAuODUxLjY4NSAxLjQzMyAxLjM1NyAxLjYxNi44NDkuMjMyIDEuNTc0Ljc4NyAyLjEzMiAxLjQxLjU2LjYyNi45MTQgMS4yOCAxLjAzOSAxLjYzOC4xOTkuNTc1LjM1NiAxLjU0LjQyOCAyLjU5MXoiLz4KPC9zdmc+';
/**
 * draw badges (icons) around Factors and Links
 * @param {CanvasRenderingContext2D} ctx NetPane canvas context
 */ function $e1c55b086cf8dd0e$var$drawBadges(ctx) {
    // padlock for locked factors
    if (!$e1c55b086cf8dd0e$var$viewOnly) // for a view only map, factors are always locked, so don't bother with padlock
    $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get().filter((node)=>!node.nodeHidden && node.fixed && !node.clusteredIn).forEach((node)=>{
        let box = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getBoundingBox(node.id);
        drawTheBadge($e1c55b086cf8dd0e$var$lockImage, ctx, box.left - 10, box.top);
    });
    if ($e1c55b086cf8dd0e$var$showNotesToggle) {
        // note card for Factors and Links with Notes
        $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get().filter((node)=>!node.hidden && !node.nodeHidden && node.note && node.note !== 'Notes' && !node.clusteredIn).forEach((node)=>{
            let box = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getBoundingBox(node.id);
            drawTheBadge($e1c55b086cf8dd0e$var$noteImage, ctx, box.right, box.top);
        });
        // an edge note badge is placed where a middle arrow would be
        let changedEdges = [];
        $e1c55b086cf8dd0e$export$4051a07651545597.edges.get().forEach((edge)=>{
            if (!edge.edgeHidden && edge.note && edge.note !== 'Notes' && edge.arrows && edge.arrows.middle && !edge.arrows.middle.enabled) {
                // there is a note, but the badge is not shown, so show it
                changedEdges.push(edge);
                edge.arrows.middle.enabled = true;
                edge.arrows.middle.type = 'image';
                edge.arrows.middle.src = $e1c55b086cf8dd0e$var$noteImage.src;
            } else if ((!edge.note || edge.note && edge.note === 'Notes' || edge.edgeHidden) && edge.arrows && edge.arrows.middle && edge.arrows.middle.enabled) {
                // there is not a note, but the badge is shown, so remove it
                changedEdges.push(edge);
                edge.arrows.middle.enabled = false;
            }
        });
        $e1c55b086cf8dd0e$export$4051a07651545597.edges.update(changedEdges);
    }
    // draw the voting thumbs up/down (but not for nodes inside a cluster, or for cluster nodes)
    if ($e1c55b086cf8dd0e$var$showVotingToggle) $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get().filter((node)=>!node.hidden && !node.nodeHidden && !node.clusteredIn && !node.isCluster).forEach((node)=>{
        let box = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getBoundingBox(node.id);
        drawTheBadge(node.thumbUp?.includes($e1c55b086cf8dd0e$export$4d35f98e5d7d0978) ? $e1c55b086cf8dd0e$var$thumbUpFilledImage : $e1c55b086cf8dd0e$var$thumbUpImage, ctx, box.left + 20, box.bottom);
        drawThumbCount(ctx, node.thumbUp, box.left + 36, box.bottom + 10);
        drawTheBadge(node.thumbDown?.includes($e1c55b086cf8dd0e$export$4d35f98e5d7d0978) ? $e1c55b086cf8dd0e$var$thumbDownFilledImage : $e1c55b086cf8dd0e$var$thumbDownImage, ctx, box.right - 36, box.bottom);
        drawThumbCount(ctx, node.thumbDown, box.right - 20, box.bottom + 10);
    });
    /**
	 *
	 * @param {image} badgeImage
	 * @param {context} ctx
	 * @param {number} x
	 * @param {number} y
	 */ function drawTheBadge(badgeImage, ctx, x, y) {
        ctx.beginPath();
        ctx.drawImage(badgeImage, Math.floor(x), Math.floor(y));
    }
    /**
	 * draw the length of the voters array, i.e. the count of those who have voted
	 * @param {context} ctx
	 * @param {array} voters
	 * @param {number} x
	 * @param {number} y
	 */ function drawThumbCount(ctx, voters, x, y) {
        if (voters) {
            ctx.beginPath();
            ctx.fillStyle = 'black';
            ctx.fillText(voters.length.toString(), x, y);
        }
    }
}
/**
 * Move the node to the nearest spot that it on the grid
 * @param {object} node
 */ function $e1c55b086cf8dd0e$var$snapToGrid(node) {
    node.x = $e1c55b086cf8dd0e$var$GRIDSPACING * Math.round(node.x / $e1c55b086cf8dd0e$var$GRIDSPACING);
    node.y = $e1c55b086cf8dd0e$var$GRIDSPACING * Math.round(node.y / $e1c55b086cf8dd0e$var$GRIDSPACING);
}
/*************************************************************** clipboard ************************************** */ /**
 * Copy the selected nodes and links to the clipboard
 * NB this doesn't yet work in Firefox, as they haven't implemented the Clipboard API and Permissions yet.
 * @param {Event} event
 */ function $e1c55b086cf8dd0e$var$copyToClipboard(event1) {
    if (document.getSelection().toString()) return; // only copy factors if there is no text selected (e.g. in Notes)
    event1.preventDefault();
    if ($e1c55b086cf8dd0e$export$c05995454a6ca00d) {
        (0, $a4a268d7686bbf3f$export$adee94ba21be2b8e)(event1);
        return;
    }
    let nIds = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getSelectedNodes();
    let eIds = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getSelectedEdges();
    if (nIds.length + eIds.length === 0) {
        (0, $gFW3W.alertMsg)('Nothing selected to copy', 'warn');
        return;
    }
    let nodes = [];
    let edges = [];
    nIds.forEach((nId)=>{
        nodes.push($e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(nId));
        let edgesFromNode = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getConnectedEdges(nId);
        edgesFromNode.forEach((eId)=>{
            let edge = $e1c55b086cf8dd0e$export$4051a07651545597.edges.get(eId);
            if (nIds.includes(edge.to) && nIds.includes(edge.from) && !edges.find((e)=>e.id === eId)) edges.push(edge);
        });
    });
    eIds.forEach((eId)=>{
        let edge = $e1c55b086cf8dd0e$export$4051a07651545597.edges.get(eId);
        if (!nodes.find((n)=>n.id === edge.from)) nodes.push($e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(edge.from));
        if (!nodes.find((n)=>n.id === edge.to)) nodes.push($e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(edge.to));
        if (!edges.find((e)=>e.id === eId)) edges.push($e1c55b086cf8dd0e$export$4051a07651545597.edges.get(eId));
    });
    $e1c55b086cf8dd0e$var$copyText(JSON.stringify({
        nodes: nodes,
        edges: edges
    }));
}
/**
 * copy the contents of the history log to the clipboard
 * @param {object} event
 */ function $e1c55b086cf8dd0e$var$copyHistoryToClipboard(event1) {
    event1.preventDefault();
    let history = $e1c55b086cf8dd0e$export$d920e34eaf2b21cb.toArray().map((rec)=>`${(0, $gFW3W.timeAndDate)(rec.time, true)}\t${rec.user}\t${rec.action.replace(/\s+/g, ' ').trim()}\n`).join('');
    $e1c55b086cf8dd0e$var$copyText(history);
}
async function $e1c55b086cf8dd0e$var$copyText(text) {
    try {
        if (typeof navigator.clipboard.writeText !== 'function') throw new Error('navigator.clipboard.writeText not a function');
    } catch  {
        (0, $gFW3W.alertMsg)('Copying not implemented in this browser', 'error');
        return false;
    }
    try {
        await navigator.clipboard.writeText(text);
        (0, $gFW3W.alertMsg)('Copied to clipboard', 'info');
        return true;
    } catch (err) {
        console.error('Failed to copy: ', err);
        (0, $gFW3W.alertMsg)('Copy failed', 'error');
        return false;
    }
}
async function $e1c55b086cf8dd0e$var$pasteFromClipboard() {
    if ($e1c55b086cf8dd0e$export$c05995454a6ca00d) {
        (0, $a4a268d7686bbf3f$export$8b0e49c4b227c2a)();
        return;
    }
    let clip = await $e1c55b086cf8dd0e$var$getClipboardContents();
    let nodes;
    let edges;
    try {
        ({ nodes: nodes, edges: edges } = JSON.parse(clip));
    } catch  {
        // silently return (i.e. use system paste) if there is nothing relevant on the clipboard
        return;
    }
    $e1c55b086cf8dd0e$export$9bc34f54445cb725();
    nodes.forEach((node)=>{
        let oldId = node.id;
        node.id = (0, $gFW3W.uuidv4)();
        node.x += 40;
        node.y += 40;
        edges.forEach((edge)=>{
            if (edge.from === oldId) edge.from = node.id;
            if (edge.to === oldId) edge.to = node.id;
        });
    });
    edges.forEach((edge)=>{
        edge.id = (0, $gFW3W.uuidv4)();
    });
    $e1c55b086cf8dd0e$export$4051a07651545597.nodes.add(nodes);
    $e1c55b086cf8dd0e$export$4051a07651545597.edges.add(edges);
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.setSelection({
        nodes: nodes.map((n)=>n.id),
        edges: edges.map((e)=>e.id)
    });
    $e1c55b086cf8dd0e$var$showSelected();
    (0, $gFW3W.alertMsg)('Pasted', 'info');
    $e1c55b086cf8dd0e$export$e5fde6ebaea8ae1d('pasted factors and/or links from clipboard');
}
async function $e1c55b086cf8dd0e$var$getClipboardContents() {
    try {
        if (typeof navigator.clipboard.readText !== 'function') throw new Error('navigator.clipboard.readText not a function');
    } catch  {
        (0, $gFW3W.alertMsg)('Pasting not implemented in this browser', 'error');
        return null;
    }
    try {
        return await navigator.clipboard.readText();
    } catch (err) {
        console.error('Failed to read clipboard contents: ', err);
        (0, $gFW3W.alertMsg)('Failed to paste', 'error');
        return null;
    }
}
/* ----------------- dialogs for creating and editing nodes and links ----------------*/ /**
 * Initialise the dialog for creating nodes/edges
 * @param {string} popUpTitle
 * @param {number} height
 * @param {object} item
 * @param {function} cancelAction
 * @param {function} saveAction
 * @param {function} callback
 */ function $e1c55b086cf8dd0e$var$initPopUp(popUpTitle, height, item, cancelAction, saveAction, callback) {
    $e1c55b086cf8dd0e$var$inAddMode = false;
    $e1c55b086cf8dd0e$var$inEditMode = true;
    $e1c55b086cf8dd0e$var$changeCursor('default');
    (0, $gFW3W.elem)('popup').style.height = `${height}px`;
    (0, $gFW3W.elem)('popup-operation').innerHTML = popUpTitle;
    (0, $gFW3W.elem)('popup-saveButton').onclick = saveAction.bind(this, item, callback);
    (0, $gFW3W.elem)('popup-cancelButton').onclick = cancelAction.bind(this, item, callback);
    let popupLabel = (0, $gFW3W.elem)('popup-label');
    popupLabel.style.fontSize = '14px';
    popupLabel.innerText = item.label === undefined ? '' : item.label.replace(/\n/g, ' ');
}
/**
 * Position the editing dialog box so that it is to the left of the item being edited,
 * but not outside the window
 * @param {Object} point
 */ function $e1c55b086cf8dd0e$var$positionPopUp(point) {
    let popUp = (0, $gFW3W.elem)('popup');
    popUp.style.display = 'block';
    // popup appears to the left of the given point
    popUp.style.top = `${point.y - popUp.offsetHeight / 2}px`;
    let left = point.x - popUp.offsetWidth / 2 - 3;
    popUp.style.left = `${left < 0 ? 0 : left}px`;
    (0, $gFW3W.dragElement)(popUp, (0, $gFW3W.elem)('popup-top'));
}
/**
 * Hide the editing dialog box
 */ function $e1c55b086cf8dd0e$var$clearPopUp() {
    (0, $gFW3W.elem)('popup-saveButton').onclick = null;
    (0, $gFW3W.elem)('popup-cancelButton').onclick = null;
    (0, $gFW3W.elem)('popup-label').onkeyup = null;
    (0, $gFW3W.elem)('popup').style.display = 'none';
    if ((0, $gFW3W.elem)('popup-node-editor')) (0, $gFW3W.elem)('popup-node-editor').remove();
    if ((0, $gFW3W.elem)('popup-link-editor')) (0, $gFW3W.elem)('popup-link-editor').remove();
    if ((0, $gFW3W.elem)('popup').timer) {
        clearTimeout((0, $gFW3W.elem)('popup').timer);
        (0, $gFW3W.elem)('popup').timer = undefined;
    }
    $e1c55b086cf8dd0e$var$yAwareness.setLocalStateField('addingFactor', {
        state: 'done'
    });
    $e1c55b086cf8dd0e$var$inEditMode = false;
}
/**
 * User has pressed 'cancel' - abandon adding a node and hide the dialog
 * @param {Function} callback
 */ function $e1c55b086cf8dd0e$var$cancelAdd(item, callback) {
    $e1c55b086cf8dd0e$var$clearPopUp();
    callback(null);
    $e1c55b086cf8dd0e$var$stopEdit();
}
/**
 * User has pressed 'cancel' - abandon the edit and hide the dialog
 * @param {object} item
 * @param {function} [callback]
 */ function $e1c55b086cf8dd0e$var$cancelEdit(item, callback) {
    $e1c55b086cf8dd0e$var$clearPopUp();
    item.label = item.oldLabel;
    item.font.color = item.oldFontColor;
    if (item.shape === 'portal') item.shape = 'image';
    if (item.from) $e1c55b086cf8dd0e$var$unlockEdge(item);
    else $e1c55b086cf8dd0e$var$unlockNode(item);
    if (callback) callback(null);
    $e1c55b086cf8dd0e$var$stopEdit();
}
/**
 * A factor is being created:  get its label from the user
 * @param {Object} item - the node
 * @param {Function} cancelAction
 * @param {Function} callback
 */ function $e1c55b086cf8dd0e$var$addLabel(item, cancelAction, callback) {
    if ((0, $gFW3W.elem)('popup').style.display === 'block') return; // can't add factor when factor is already being added
    $e1c55b086cf8dd0e$var$initPopUp('Add Factor', 60, item, cancelAction, $e1c55b086cf8dd0e$var$saveLabel, callback);
    let pos = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.canvasToDOM({
        x: item.x,
        y: item.y
    });
    $e1c55b086cf8dd0e$var$positionPopUp(pos);
    $e1c55b086cf8dd0e$var$removeFactorCursor();
    $e1c55b086cf8dd0e$var$ghostFactor(pos);
    (0, $gFW3W.elem)('popup-label').focus();
}
/**
 * broadcast to other users that a new factor is being added here
 * @param {Object} pos offset coordinates of Add Factor dialog
 */ function $e1c55b086cf8dd0e$var$ghostFactor(pos) {
    $e1c55b086cf8dd0e$var$yAwareness.setLocalStateField('addingFactor', {
        state: 'adding',
        pos: $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.DOMtoCanvas(pos),
        name: $e1c55b086cf8dd0e$var$myNameRec.name
    });
    (0, $gFW3W.elem)('popup').timer = setTimeout(()=>{
        // close it after a time if the user has gone away
        $e1c55b086cf8dd0e$var$yAwareness.setLocalStateField('addingFactor', {
            state: 'done'
        });
    }, $e1c55b086cf8dd0e$var$TIMETOEDIT);
}
/**
 * called when a node has been added.  Save the label provided
 * @param {Object} node the item that has been added
 * @param {Function} callback
 */ function $e1c55b086cf8dd0e$var$saveLabel(node, callback) {
    node.label = (0, $gFW3W.splitText)((0, $gFW3W.elem)('popup-label').innerText, $e1c55b086cf8dd0e$var$NODEWIDTH);
    $e1c55b086cf8dd0e$var$clearPopUp();
    if (node.label === '') {
        (0, $gFW3W.alertMsg)('No label: cancelled', 'error');
        callback(null);
        return;
    }
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.manipulation.inMode = 'addNode' // ensure still in Add mode, in case others have done something meanwhile
    ;
    callback(node);
    $e1c55b086cf8dd0e$export$e5fde6ebaea8ae1d(`added factor '${node.label}'`);
}
/**
 * Draw a dialog box for user to edit a node
 * @param {Object} item the node
 * @param {Object} point the centre of the node
 * @param {Function} cancelAction what to do if the edit is cancelled
 * @param {Function} callback what to do if the edit is saved
 */ function $e1c55b086cf8dd0e$var$editNode(item, point, cancelAction, callback) {
    if (item.locked) return;
    $e1c55b086cf8dd0e$var$initPopUp('Edit Factor', 180, item, cancelAction, $e1c55b086cf8dd0e$var$saveNode, callback);
    (0, $gFW3W.elem)('popup').insertAdjacentHTML('beforeend', `
		<div class="popup-node-editor" id="popup-node-editor">	
			<div>fill</div>
			<div>border</div>
			<div>font</div>
			<div class="input-color-container">
				<div class="color-well" id="node-backgroundColor"></div>
			</div>
			<div class="input-color-container">
				<div class="color-well" id="node-borderColor"></div>
			</div>
			<div class="input-color-container">
				<div class="color-well" id="node-fontColor"></div>
			</div>
			<div>
				<select name="nodeEditShape" id="nodeEditShape">
					<option value="box">Shape...</option>
					<option value="ellipse">Ellipse</option>
					<option value="circle">Circle</option>
					<option value="box">Rect</option>
					<option value="diamond">Diamond</option>
					<option value="star">Star</option>
					<option value="triangle">Triangle</option>
					<option value="hexagon">Hexagon</option>
					<option value="text">Text</option>
					<option value="portal">Portal</option>
				</select>
			</div>
			<div>
				<select name="nodeEditBorder" id="node-borderType">
					<option value="solid" selected>Solid</option>
					<option value="dashed">Dashed</option>
					<option value="dots">Dotted</option>
					<option value="none">No border</option>
				</select>
			</div>
			<div>
				<select name="nodeEditFontSize" id="nodeEditFontSize">
					<option value="14">Size...</option>
					<option value="24">Large</option>
					<option value="14">Normal</option>
					<option value="10">Small</option>
				</select>
			</div>
			<div id="popup-sizer">
				<label
					>&nbsp;Size:
					<input type="range" class="xrange" id="nodeEditSizer" />
				</label>
			</div>
		</div>
		`);
    $e1c55b086cf8dd0e$export$cd571ca6d1702b73.createColorPicker('node-backgroundColor');
    (0, $gFW3W.elem)('node-backgroundColor').style.backgroundColor = (0, $gFW3W.standardize_color)(item.color.background);
    if (item.shape === 'image') {
        item.shape = 'portal';
        if ((0, $gFW3W.elem)('popup-portal-room')) (0, $gFW3W.elem)('popup-portal-room').value = item.portal;
        else makePortalInput(item.portal);
    }
    (0, $gFW3W.elem)('nodeEditShape').value = item.shape;
    $e1c55b086cf8dd0e$export$cd571ca6d1702b73.createColorPicker('node-borderColor');
    (0, $gFW3W.elem)('node-borderColor').style.backgroundColor = (0, $gFW3W.standardize_color)(item.color.border);
    $e1c55b086cf8dd0e$export$cd571ca6d1702b73.createColorPicker('node-fontColor');
    (0, $gFW3W.elem)('node-fontColor').style.backgroundColor = (0, $gFW3W.standardize_color)(item.font.color);
    (0, $gFW3W.elem)('node-borderType').value = (0, $gFW3W.getDashes)(item.shapeProperties.borderDashes, item.borderWidth);
    (0, $gFW3W.elem)('nodeEditFontSize').value = item.font.size;
    (0, $gFW3W.elem)('nodeEditSizer').value = (0, $gFW3W.factorSizeToPercent)(item.size);
    $e1c55b086cf8dd0e$export$9d1298853f0e77f7((0, $gFW3W.elem)('nodeEditSizer'));
    (0, $gFW3W.listen)('nodeEditSizer', 'input', (event1)=>$e1c55b086cf8dd0e$export$9d1298853f0e77f7(event1.target));
    (0, $gFW3W.listen)('nodeEditShape', 'change', (event1)=>{
        if (event1.target.value === 'portal') makePortalInput(item.portal);
        else {
            (0, $gFW3W.elem)('popup-portal-link')?.remove();
            item.portal = undefined;
        }
    });
    $e1c55b086cf8dd0e$var$positionPopUp(point);
    (0, $gFW3W.elem)('popup-label').focus();
    (0, $gFW3W.elem)('popup').timer = setTimeout(()=>{
        //ensure that the node cannot be locked out for ever
        $e1c55b086cf8dd0e$var$cancelEdit(item, callback);
        (0, $gFW3W.alertMsg)('Edit timed out', 'warn');
    }, $e1c55b086cf8dd0e$var$TIMETOEDIT);
    $e1c55b086cf8dd0e$var$lockNode(item);
    /**
	 * Generate HTML for the textarea to obtain the room name of the portal
	 * @param {string} portal room name to go to
	 */ function makePortalInput(portal) {
        portal = portal || '';
        // expand the dialog to accommodate the textarea
        (0, $gFW3W.elem)('popup').style.height = `${230}px`;
        (0, $gFW3W.elem)('popup-node-editor').insertAdjacentHTML('beforeend', `<div id="popup-portal-link">
      				<label for="popup-portal-room">Map:</label>
      				<textarea id="popup-portal-room" rows="1" placeholder="ABC-DEF-GHI-JKL">${portal}</textarea>
    			</div>`);
    }
}
// fancy portal image icon
const $e1c55b086cf8dd0e$var$portalSvg = `<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path fill="#ff0000" d="M298.736 21.016c-99.298 0-195.928 104.647-215.83 233.736-7.074 45.887-3.493 88.68 8.512 124.787-4.082-6.407-7.92-13.09-11.467-20.034-16.516-32.335-24.627-65.378-25-96.272-11.74 36.254-8.083 82.47 14.482 126.643 27.7 54.227 81.563 91.94 139.87 97.502 5.658.725 11.447 1.108 17.364 1.108 99.298 0 195.93-104.647 215.83-233.736 9.28-60.196.23-115.072-22.133-156.506 21.625 21.867 36.56 45.786 44.617 69.496.623-30.408-14.064-65.766-44.21-95.806-33.718-33.598-77.227-50.91-114.995-50.723-2.328-.118-4.67-.197-7.04-.197zm-5.6 36.357c40.223 0 73.65 20.342 95.702 53.533 15.915 42.888 12.51 108.315.98 147.858-16.02 54.944-40.598 96.035-79.77 126.107-41.79 32.084-98.447 24.39-115.874-5.798-1.365-2.363-2.487-4.832-3.38-7.385 11.724 14.06 38.188 14.944 61.817 1.3 25.48-14.71 38.003-40.727 27.968-58.108-10.036-17.384-38.826-19.548-64.307-4.837-9.83 5.676-17.72 13.037-23.14 20.934.507-1.295 1.043-2.59 1.626-3.88-18.687 24.49-24.562 52.126-12.848 72.417 38.702 45.923 98.07 25.503 140.746-6.426 37.95-28.392 72.32-73.55 89.356-131.988 1.265-4.34 2.416-8.677 3.467-13.008-.286 2.218-.59 4.442-.934 6.678-16.807 109.02-98.412 197.396-182.272 197.396-35.644 0-65.954-15.975-87.74-42.71-26.492-48.396-15.988-142.083 4.675-185.15 26.745-55.742 66.133-122.77 134.324-116.804 46.03 4.027 63.098 58.637 39.128 116.22-8.61 20.685-21.192 39.314-36.21 54.313 24.91-16.6 46.72-42.13 59.572-73 23.97-57.583 6.94-113.422-39.13-116.805-85.737-6.296-137.638 58.55-177.542 128.485-9.21 19.9-16.182 40.35-20.977 60.707.494-7.435 1.312-14.99 2.493-22.652C127.67 145.75 209.275 57.373 293.135 57.373z"></path></g></svg>`;
/**
 * save the node format details that have been edited
 * @param {Object} item the node that has been edited
 * @param {Function} callback
 */ function $e1c55b086cf8dd0e$var$saveNode(item, callback) {
    $e1c55b086cf8dd0e$var$unlockNode(item);
    item.label = (0, $gFW3W.splitText)((0, $gFW3W.elem)('popup-label').innerText, $e1c55b086cf8dd0e$var$NODEWIDTH);
    if (item.label === '') {
        // if there is no label, cancel (nodes must have a label)
        (0, $gFW3W.alertMsg)('No label: cancelled', 'error');
        callback(null);
    }
    let color = (0, $gFW3W.elem)('node-backgroundColor').style.backgroundColor;
    item.color.background = color;
    item.color.highlight.background = color;
    item.color.hover.background = color;
    color = (0, $gFW3W.elem)('node-borderColor').style.backgroundColor;
    item.color.border = color;
    item.color.highlight.border = color;
    item.color.hover.border = color;
    item.font.color = (0, $gFW3W.elem)('node-fontColor').style.backgroundColor;
    let borderType = (0, $gFW3W.elem)('node-borderType').value;
    item.borderWidth = borderType === 'none' ? 0 : 4;
    item.shapeProperties.borderDashes = (0, $gFW3W.convertDashes)(borderType);
    item.shape = (0, $gFW3W.elem)('nodeEditShape').value;
    if (item.shape === 'portal') {
        item.portal = (0, $gFW3W.elem)('popup-portal-room')?.value;
        if (!item.portal) {
            (0, $gFW3W.alertMsg)('No map room', 'error');
            callback(null);
        }
        item.shape = 'image';
        item.image = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent($e1c55b086cf8dd0e$var$portalSvg);
    }
    item.font.size = parseInt((0, $gFW3W.elem)('nodeEditFontSize').value);
    (0, $gFW3W.setFactorSizeFromPercent)(item, (0, $gFW3W.elem)('nodeEditSizer').value);
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.manipulation.inMode = 'editNode' // ensure still in Add mode, in case others have done something meanwhile
    ;
    if (item.label === item.oldLabel) $e1c55b086cf8dd0e$export$e5fde6ebaea8ae1d(`edited factor: '${item.label}'`);
    else $e1c55b086cf8dd0e$export$e5fde6ebaea8ae1d(`edited factor, changing label from '${item.oldLabel}' to '${item.label}'`);
    $e1c55b086cf8dd0e$var$clearPopUp();
    callback(item);
}
/**
 * User is about to edit the node.  Make sure that no one else can edit it simultaneously
 * @param {Node} item
 */ function $e1c55b086cf8dd0e$var$lockNode(item) {
    item.locked = true;
    item.opacity = 0.3;
    item.oldLabel = item.label;
    item.oldFontColor = item.font.color;
    item.label = `${item.label}\n\n[Being edited by ${$e1c55b086cf8dd0e$var$myNameRec.name}]`;
    item.wasFixed = Boolean(item.fixed);
    item.fixed = true;
    $e1c55b086cf8dd0e$var$dontUndo = 'locked';
    $e1c55b086cf8dd0e$export$4051a07651545597.nodes.update(item);
}
/**
 * User has finished editing the node.  Unlock it.
 * @param {Node} item
 */ function $e1c55b086cf8dd0e$var$unlockNode(item) {
    item.locked = false;
    item.opacity = 1;
    item.fixed = item.wasFixed;
    item.label = item.oldLabel;
    $e1c55b086cf8dd0e$var$dontUndo = 'unlocked';
    $e1c55b086cf8dd0e$export$4051a07651545597.nodes.update(item);
    $e1c55b086cf8dd0e$var$showNodeOrEdgeData();
}
/**
 * ensure that all factors and links are unlocked (called only when user leaves the page, to clear up for others)
 */ function $e1c55b086cf8dd0e$var$unlockAll() {
    $e1c55b086cf8dd0e$export$4051a07651545597.nodes.forEach((node)=>{
        if (node.locked) $e1c55b086cf8dd0e$var$cancelEdit((0, $gFW3W.deepCopy)(node));
    });
    $e1c55b086cf8dd0e$export$4051a07651545597.edges.forEach((edge)=>{
        if (edge.locked) $e1c55b086cf8dd0e$var$cancelEdit((0, $gFW3W.deepCopy)(edge));
    });
}
/**
 * Draw a dialog box for user to edit an edge
 * @param {Object} item the edge
 * @param {Object} point the centre of the edge
 * @param {Function} cancelAction what to do if the edit is cancelled
 * @param {Function} callback what to do if the edit is saved
 */ function $e1c55b086cf8dd0e$var$editEdge(item, point, cancelAction, callback) {
    if (item.locked) return;
    $e1c55b086cf8dd0e$var$initPopUp('Edit Link', 170, item, cancelAction, $e1c55b086cf8dd0e$var$saveEdge, callback);
    (0, $gFW3W.elem)('popup').insertAdjacentHTML('beforeend', `<div class="popup-link-editor" id="popup-link-editor">
		<div>colour</div>
		<div></div>
		<div></div>
		<div class="input-color-container">
			<div class="color-well" id="linkEditLineColor"></div>
		</div>
		<div>
			<select name="linkEditWidth" id="linkEditWidth">
				<option value="1">Width: 1</option>
				<option value="2">Width: 2</option>
				<option value="4">Width: 4</option>
			</select>
		</div>
		<div>
			<select name="linkEditArrows" id="linkEditArrows">
				<option value="vee">Arrows...</option>
				<option value="vee">Sharp</option>
				<option value="arrow">Triangle</option>
				<option value="bar">Bar</option>
				<option value="circle">Circle</option>
				<option value="box">Box</option>
				<option value="diamond">Diamond</option>
				<option value="none">None</option>
			</select>
		</div>
		<div>
			<select name="linkEditDashes" id="linkEditDashes">
				<option value="solid" selected>Solid</option>
				<option value="dashedLinks">Dashed</option>
				<option value="dots">Dotted</option>
			</select>
		</div>
		<div>
			<i>Font size:</i>	
		</div>
		<div>
			<select id="linkEditFontSize">
				<option value="24">Large</option>
				<option value="14">Normal</option>
				<option value="10">Small</option>
			</select>
		</div>
	</div>
`);
    (0, $gFW3W.elem)('linkEditWidth').value = parseInt(item.width);
    $e1c55b086cf8dd0e$export$cd571ca6d1702b73.createColorPicker('linkEditLineColor');
    (0, $gFW3W.elem)('linkEditLineColor').style.backgroundColor = (0, $gFW3W.standardize_color)(item.color.color);
    (0, $gFW3W.elem)('linkEditDashes').value = (0, $gFW3W.getDashes)(item.dashes, null);
    (0, $gFW3W.elem)('linkEditArrows').value = item.arrows.to.enabled ? item.arrows.to.type : 'none';
    (0, $gFW3W.elem)('linkEditFontSize').value = parseInt(item.font.size);
    $e1c55b086cf8dd0e$var$positionPopUp(point);
    (0, $gFW3W.elem)('popup-label').focus();
    (0, $gFW3W.elem)('popup').timer = setTimeout(()=>{
        //ensure that the edge cannot be locked out for ever
        $e1c55b086cf8dd0e$var$cancelEdit(item, callback);
        (0, $gFW3W.alertMsg)('Edit timed out', 'warn');
    }, $e1c55b086cf8dd0e$var$TIMETOEDIT);
    $e1c55b086cf8dd0e$var$lockEdge(item);
}
/**
 * save the edge format details that have been edited
 * @param {Object} item the edge that has been edited
 * @param {Function} callback
 */ function $e1c55b086cf8dd0e$var$saveEdge(item, callback) {
    $e1c55b086cf8dd0e$var$unlockEdge(item);
    item.label = (0, $gFW3W.splitText)((0, $gFW3W.elem)('popup-label').innerText, $e1c55b086cf8dd0e$var$NODEWIDTH);
    if (item.label === '') item.label = ' ';
    let color = (0, $gFW3W.elem)('linkEditLineColor').style.backgroundColor;
    item.color.color = color;
    item.color.hover = color;
    item.color.highlight = color;
    item.width = parseInt((0, $gFW3W.elem)('linkEditWidth').value);
    if (!item.width) item.width = 1;
    item.dashes = (0, $gFW3W.convertDashes)((0, $gFW3W.elem)('linkEditDashes').value);
    item.arrows.to = {
        enabled: (0, $gFW3W.elem)('linkEditArrows').value !== 'none',
        type: (0, $gFW3W.elem)('linkEditArrows').value
    };
    item.font.size = parseInt((0, $gFW3W.elem)('linkEditFontSize').value);
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.manipulation.inMode = 'editEdge' // ensure still in edit mode, in case others have done something meanwhile
    ;
    // vis-network silently deselects all edges in the callback (why?).  So we have to mark this edge as unselected in preparation
    (0, $gFW3W.clearStatusBar)();
    $e1c55b086cf8dd0e$export$e5fde6ebaea8ae1d(`edited link from '${$e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(item.from).label}' to '${$e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(item.to).label}'`);
    $e1c55b086cf8dd0e$var$clearPopUp();
    callback(item);
}
function $e1c55b086cf8dd0e$var$lockEdge(item) {
    item.locked = true;
    item.font.color = 'rgba(0,0,0,0.5)';
    item.opacity = 0.1;
    item.oldLabel = item.label || ' ';
    item.label = `Being edited by ${$e1c55b086cf8dd0e$var$myNameRec.name}`;
    $e1c55b086cf8dd0e$var$dontUndo = 'locked';
    $e1c55b086cf8dd0e$export$4051a07651545597.edges.update(item);
}
/**
 * User has finished editing the edge.  Unlock it.
 * @param {object} item
 */ function $e1c55b086cf8dd0e$var$unlockEdge(item) {
    item.locked = false;
    item.font.color = 'rgba(0,0,0,1)';
    item.opacity = 1;
    item.label = item.oldLabel;
    item.oldLabel = undefined;
    $e1c55b086cf8dd0e$var$dontUndo = 'unlocked';
    $e1c55b086cf8dd0e$export$4051a07651545597.edges.update(item);
    $e1c55b086cf8dd0e$var$showNodeOrEdgeData();
}
/* ----------------- end of node and edge creation and editing dialog -----------------*/ /**
 * if there is already a link from the 'from' node to the 'to' node, return it
 * @param {Object} from A node
 * @param {Object} to Another node
 */ function $e1c55b086cf8dd0e$var$duplEdge(from, to) {
    return $e1c55b086cf8dd0e$export$4051a07651545597.edges.get({
        filter: function(item) {
            return item.from === from && item.to === to;
        }
    });
}
/**
 * Change the cursor style for the net pane and nav bar
 * @param {object} newCursorStyle
 */ function $e1c55b086cf8dd0e$var$changeCursor(newCursorStyle) {
    if ($e1c55b086cf8dd0e$var$inAddMode) return;
    $e1c55b086cf8dd0e$export$4b72f5d71fff605.style.cursor = newCursorStyle;
    (0, $gFW3W.elem)('navbar').style.cursor = newCursorStyle;
}
/**
 * User has set or changed the map title: update the UI and broadcast the new title
 * @param {event} e
 */ function $e1c55b086cf8dd0e$var$mapTitle(e) {
    let title = e.target.innerText.trim();
    title = $e1c55b086cf8dd0e$export$f229389f565c6b3f(title);
    $e1c55b086cf8dd0e$export$807f940a96777041.set('mapTitle', title);
}
function $e1c55b086cf8dd0e$var$pasteMapTitle(e) {
    e.preventDefault();
    let paste = (e.clipboardData || window.clipboardData).getData('text/plain');
    if (paste instanceof HTMLElement) paste = paste.textContent;
    const selection = window.getSelection();
    if (!selection.rangeCount) return false;
    selection.deleteFromDocument();
    selection.getRangeAt(0).insertNode(document.createTextNode(paste));
    $e1c55b086cf8dd0e$export$f229389f565c6b3f((0, $gFW3W.elem)('maptitle').innerText);
}
function $e1c55b086cf8dd0e$export$f229389f565c6b3f(title) {
    let div = (0, $gFW3W.elem)('maptitle');
    (0, $gFW3W.clearStatusBar)();
    if (!title) title = 'Untitled map';
    if (title === 'Untitled map') {
        div.classList.add('unsetmaptitle');
        document.title = $e1c55b086cf8dd0e$var$appName;
    } else {
        if (title.length > 50) {
            title = title.slice(0, 50);
            (0, $gFW3W.alertMsg)('Map title is too long: truncated', 'warn');
        }
        div.classList.remove('unsetmaptitle');
        document.title = `${title}: ${$e1c55b086cf8dd0e$var$shortAppName} map`;
    }
    if (title !== div.innerText.trim()) div.innerText = title;
    if (title.length >= 50) (0, $gFW3W.setEndOfContenteditable)(div);
    (0, $a61399d7add80213$export$20ca267bc6805c64)();
    $e1c55b086cf8dd0e$var$titleDropDown(title);
    return title;
}
/**
 * Add this title to the local record of maps used
 * The list is stored as an object so that it is easy to add [room, title] pairs
 * and easy to modify the title of an existing room
 * @param {String} title
 */ const $e1c55b086cf8dd0e$var$TITLELISTLEN = 500;
function $e1c55b086cf8dd0e$var$titleDropDown(title) {
    let recentMaps = localStorage.getItem('recents');
    if (recentMaps) recentMaps = JSON.parse(recentMaps);
    else recentMaps = {};
    if (title !== 'Untitled map') {
        recentMaps[$e1c55b086cf8dd0e$export$f9d3fff8c23da278] = title;
        // save only the most recent entries
        recentMaps = Object.fromEntries(Object.entries(recentMaps).slice(-$e1c55b086cf8dd0e$var$TITLELISTLEN));
        localStorage.setItem('recents', JSON.stringify(recentMaps));
    }
    // if there is more than 1, append a down arrow after the map title as a cue to there being a list
    if (Object.keys(recentMaps).length > 1) (0, $gFW3W.elem)('recent-rooms-caret').classList.remove('hidden');
}
/**
 * Create a drop down list of previous maps used for user selection
 */ function $e1c55b086cf8dd0e$var$createTitleDropDown() {
    $e1c55b086cf8dd0e$var$removeTitleDropDown();
    let selectList = document.createElement('ul');
    selectList.id = 'recent-rooms-select';
    selectList.classList.add('room-titles');
    (0, $gFW3W.elem)('recent-rooms').appendChild(selectList);
    let recentMaps = JSON.parse(localStorage.getItem('recents'));
    // list is with New Map and then the most recent at the top
    if (recentMaps) {
        makeTitleDropDownEntry('*New map*', '*new*', false);
        let props = Object.keys(recentMaps).reverse();
        props.forEach((prop)=>{
            makeTitleDropDownEntry(recentMaps[prop], prop);
        });
    }
    /**
	 * create a previous map menu item
	 * @param {string} name Title of map
	 * @param {string} room
	 */ function makeTitleDropDownEntry(name, room) {
        let li = document.createElement('li');
        li.classList.add('room-title');
        li.textContent = name;
        li.dataset.room = room;
        li.addEventListener('click', (event1)=>$e1c55b086cf8dd0e$var$changeRoom(event1));
        selectList.appendChild(li);
    }
}
/**
 * User has clicked one of the previous map titles - confirm and change to the web page for that room
 * @param {Event} event
 */ function $e1c55b086cf8dd0e$var$changeRoom(event1) {
    if ($e1c55b086cf8dd0e$export$4051a07651545597.nodes.length > 0) {
        if (!confirm('Are you sure you want to move to a different map?')) return;
    }
    let newRoom = event1.target.dataset.room;
    $e1c55b086cf8dd0e$var$removeTitleDropDown();
    let url = new URL(document.location);
    url.search = newRoom !== '*new*' ? `?room=${newRoom}` : '';
    window.location.replace(url);
}
/**
 * Remove the drop down list of previous maps if user clicks on the net-pane or on a map title.
 */ function $e1c55b086cf8dd0e$var$removeTitleDropDown() {
    let oldSelect = (0, $gFW3W.elem)('recent-rooms-select');
    if (oldSelect) oldSelect.remove();
}
function $e1c55b086cf8dd0e$export$9bc34f54445cb725() {
    $e1c55b086cf8dd0e$var$hideNotes();
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.unselectAll();
    (0, $gFW3W.clearStatusBar)();
}
var $a065f4c089ab2337$exports = {};
var $875f86f006d1834f$exports = {};
"use strict";
$875f86f006d1834f$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};



var $7qipm = parcelRequire("7qipm");
let $a065f4c089ab2337$var$url = $7qipm.getBundleURL('6blyj') + "betweenness.19722fdc.js";
$a065f4c089ab2337$exports = $875f86f006d1834f$exports($a065f4c089ab2337$var$url, $7qipm.getOrigin($a065f4c089ab2337$var$url), true);


/* 
  ----------- Calculate statistics in the background -------------
*/ // set  up a web worker to calculate network statistics in parallel with whatever
// the user is doing
var $e1c55b086cf8dd0e$var$worker = new Worker($a065f4c089ab2337$exports, {
    type: 'module'
});
/**
 * Ask the web worker to recalculate network statistics
 */ function $e1c55b086cf8dd0e$var$recalculateStats() {
    // wait 200 mSecs for things to settle down before recalculating
    setTimeout(()=>{
        $e1c55b086cf8dd0e$var$worker.postMessage([
            $e1c55b086cf8dd0e$var$nodes.get(),
            $e1c55b086cf8dd0e$var$edges.get()
        ]);
    }, 200);
}
$e1c55b086cf8dd0e$var$worker.onmessage = function(e) {
    if (typeof e.data === 'string') (0, $gFW3W.alertMsg)(e.data, 'error');
    else {
        let nodesToUpdate = [];
        $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get().forEach((n)=>{
            if (n.bc !== e.data[n.id]) {
                n.bc = e.data[n.id];
                nodesToUpdate.push(n);
            }
        });
        if (nodesToUpdate) $e1c55b086cf8dd0e$export$4051a07651545597.nodes.update(nodesToUpdate);
    }
};
/* 
  ----------- Status messages ---------------------------------------
*/ /**
 * return a string listing the labels of the given nodes, with nice connecting words
 * @param {Array} factors List of node Ids
 * @param {Boolean} suppressType If true, don't start string with 'Factors'
 */ function $e1c55b086cf8dd0e$var$listFactors(factors, suppressType) {
    if (factors.length > 5) return `${factors.length} factors`;
    let str = '';
    if (!suppressType) {
        str = 'Factor';
        if (factors.length > 1) str = `${str}s`;
        str = `${str}: `;
    }
    return str + lf(factors);
    function lf(factors) {
        // recursive fn to return a string of the node labels, separated by commas and 'and'
        let n = factors.length;
        let label = `'${(0, $gFW3W.shorten)($e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(factors[0]).label)}'`;
        if (n === 1) return label;
        factors.shift();
        if (n === 2) return label.concat(` and ${lf(factors)}`);
        return label.concat(`, ${lf(factors)}`);
    }
}
/**
 * return a string listing the number of Links, or if just one, the starting and ending factors
 * @param {Array} links
 */ function $e1c55b086cf8dd0e$var$listLinks(links) {
    if (links.length > 1) return `${links.length} links`;
    let link = $e1c55b086cf8dd0e$export$4051a07651545597.edges.get(links[0]);
    return `Link from "${(0, $gFW3W.shorten)($e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(link.from).label)}" to "${(0, $gFW3W.shorten)($e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(link.to).label)}"`;
}
/**
 * returns string of currently selected labels of links and factors, nicely formatted
 * @returns {String} string of labels of links and factors, nicely formatted
 */ function $e1c55b086cf8dd0e$var$selectedLabels() {
    let selectedNodes = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getSelectedNodes();
    let selectedEdges = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getSelectedEdges();
    let msg = '';
    if (selectedNodes.length > 0) msg = $e1c55b086cf8dd0e$var$listFactors(selectedNodes);
    if (selectedNodes.length > 0 && selectedEdges.length > 0) msg += ' and ';
    if (selectedEdges.length > 0) msg += $e1c55b086cf8dd0e$var$listLinks(selectedEdges);
    return msg;
}
/**
 * show the nodes and links selected in the status bar
 */ function $e1c55b086cf8dd0e$var$showSelected() {
    let msg = $e1c55b086cf8dd0e$var$selectedLabels();
    if (msg.length > 0) (0, $gFW3W.statusMsg)(`${msg} selected`);
    else (0, $gFW3W.clearStatusBar)();
    $e1c55b086cf8dd0e$export$c1a1b42e4610dc4a();
}
/* ----------------------------------------zoom slider -------------------------------------------- */ (0, $bebd28704f2536ea$export$95be4ae94445245a).prototype.zoom = function(scale) {
    let newScale = scale === undefined ? 1 : scale;
    const animationOptions = {
        scale: newScale,
        animation: {
            duration: 0
        }
    };
    this.view.moveTo(animationOptions);
    (0, $a4a268d7686bbf3f$export$8a6e5c2ddf85cd20)(newScale);
};
function $e1c55b086cf8dd0e$export$1e044b7877db048c() {
    let prevPos = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getViewPosition();
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.fit({
        position: {
            x: 0,
            y: 0
        }
    });
    let newPos = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getViewPosition();
    let newScale = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getScale();
    (0, $a4a268d7686bbf3f$export$8a6e5c2ddf85cd20)(1.0);
    (0, $a4a268d7686bbf3f$export$4ccc1b9eba0bcd20)(prevPos.x - newPos.x, prevPos.y - newPos.y, 1.0);
    (0, $a4a268d7686bbf3f$export$8a6e5c2ddf85cd20)(newScale);
    (0, $gFW3W.elem)('zoom').value = newScale;
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.storePositions();
}
/**
 * expand/reduce the network view using the value in the zoom slider
 */ function $e1c55b086cf8dd0e$var$zoomnet() {
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.zoom(Number((0, $gFW3W.elem)('zoom').value));
}
/**
 * zoom by the given amount (+ve or -ve);
 * used by the + and - buttons at the ends of the zoom slider
 * and by trackpad zoom/pinch
 * @param {Number} incr
 */ function $e1c55b086cf8dd0e$var$zoomincr(incr) {
    let newScale = Number((0, $gFW3W.elem)('zoom').value);
    newScale += incr;
    if (newScale > 4) newScale = 4;
    if (newScale <= 0.1) newScale = 0.1;
    (0, $gFW3W.elem)('zoom').value = newScale;
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.zoom(newScale);
}
/**
 * zoom using a pinch/zoom gesture on a tablet
 * note the starting point
 */ var $e1c55b086cf8dd0e$var$startzoom = 1;
function $e1c55b086cf8dd0e$var$zoomstart() {
    $e1c55b086cf8dd0e$var$startzoom = Number((0, $gFW3W.elem)('zoom').value);
}
/**
 * zoom by the given amount
 * @param {Number} newScale
 */ function $e1c55b086cf8dd0e$var$zoomset(newScale) {
    let newZoom = $e1c55b086cf8dd0e$var$startzoom * newScale;
    if (newZoom > 4) newZoom = 4;
    if (newZoom <= 0.1) newZoom = 0.1;
    (0, $gFW3W.elem)('zoom').value = newZoom;
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.zoom(newZoom);
}
var $e1c55b086cf8dd0e$var$clicks = 0 // accumulate 'mousewheel' clicks sent while display is updating
;
var $e1c55b086cf8dd0e$var$ticking = false // if true, we are waiting for an AnimationFrame */
;
// see https://www.html5rocks.com/en/tutorials/speed/animations/
// listen for zoom/pinch (confusingly, referred to as mousewheel events)
(0, $gFW3W.listen)('net-pane', 'wheel', (e)=>{
    e.preventDefault();
    // reject all but vertical touch movements
    if (Math.abs(e.deltaX) <= 1) $e1c55b086cf8dd0e$var$zoomscroll(e);
}, // must be passive, else pinch/zoom is intercepted by the browser itself
{
    passive: false
});
/**
 * Zoom using a trackpad (with a mousewheel or two fingers)
 * @param {Event} event
 */ function $e1c55b086cf8dd0e$var$zoomscroll(event1) {
    $e1c55b086cf8dd0e$var$clicks += event1.deltaY;
    $e1c55b086cf8dd0e$var$requestZoom();
}
function $e1c55b086cf8dd0e$var$requestZoom() {
    if (!$e1c55b086cf8dd0e$var$ticking) requestAnimationFrame($e1c55b086cf8dd0e$var$zoomUpdate);
    $e1c55b086cf8dd0e$var$ticking = true;
}
const $e1c55b086cf8dd0e$var$MOUSEWHEELZOOMRATE = 0.01 // how many 'clicks' of the mouse wheel/finger track correspond to 1 zoom increment
;
function $e1c55b086cf8dd0e$var$zoomUpdate() {
    $e1c55b086cf8dd0e$var$zoomincr(-$e1c55b086cf8dd0e$var$clicks * $e1c55b086cf8dd0e$var$MOUSEWHEELZOOMRATE);
    $e1c55b086cf8dd0e$var$ticking = false;
    $e1c55b086cf8dd0e$var$clicks = 0;
}
/* -----------Operations related to the top button bar (not the side panel)------------- */ /**
 * react to the user pressing the Add node button
 * handles cases when the button is disabled; has previously been pressed; and the Add link
 * button is active, as well as the normal case
 *
 */ function $e1c55b086cf8dd0e$var$plusNode() {
    switch($e1c55b086cf8dd0e$var$inAddMode){
        case 'disabled':
            return;
        case 'addNode':
            $e1c55b086cf8dd0e$var$removeFactorCursor();
            $e1c55b086cf8dd0e$var$showPressed('addNode', 'remove');
            $e1c55b086cf8dd0e$var$stopEdit();
            break;
        case 'addLink':
            $e1c55b086cf8dd0e$var$showPressed('addLink', 'remove');
            $e1c55b086cf8dd0e$var$stopEdit();
        default:
            // false
            // don't allow user to add a factor while editing another one
            if ((0, $gFW3W.elem)('popup').style.display === 'block') break;
            $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.unselectAll();
            $e1c55b086cf8dd0e$var$changeCursor('cell');
            $e1c55b086cf8dd0e$var$ghostCursor();
            $e1c55b086cf8dd0e$var$inAddMode = 'addNode';
            $e1c55b086cf8dd0e$var$showPressed('addNode', 'add');
            $e1c55b086cf8dd0e$export$9bc34f54445cb725();
            (0, $gFW3W.statusMsg)('Click on the map to add a factor');
            $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.addNodeMode();
    }
}
/**
 * show a box attached to the cursor to guide where the Factor will be placed when the user clicks.
 */ function $e1c55b086cf8dd0e$var$ghostCursor() {
    // no ghost cursor if the hardware only supports touch
    if (!window.matchMedia('(any-hover: hover)').matches) return;
    const box = document.createElement('div');
    box.classList.add('ghost-factor', 'factor-cursor');
    box.innerText = 'Click on the map to add a factor';
    box.id = 'factor-cursor';
    document.body.appendChild(box);
    const netPaneRect = $e1c55b086cf8dd0e$export$4b72f5d71fff605.getBoundingClientRect();
    keepInWindow(box, netPaneRect);
    document.addEventListener('pointermove', ()=>{
        keepInWindow(box, netPaneRect);
    });
    function keepInWindow(box, netPaneRect) {
        const boxHalfWidth = box.offsetWidth / 2;
        const boxHalfHeight = box.offsetHeight / 2;
        let left = window.event.pageX - boxHalfWidth;
        box.style.left = `${left <= netPaneRect.left ? netPaneRect.left : left >= netPaneRect.right - box.offsetWidth ? netPaneRect.right - box.offsetWidth : left}px`;
        let top = window.event.pageY - boxHalfHeight;
        box.style.top = `${top <= netPaneRect.top ? netPaneRect.top : top >= netPaneRect.bottom - box.offsetHeight ? netPaneRect.bottom - box.offsetHeight : top}px`;
    }
}
/**
 * remove the factor cursor if it exists
 */ function $e1c55b086cf8dd0e$var$removeFactorCursor() {
    let factorCursor = (0, $gFW3W.elem)('factor-cursor');
    if (factorCursor) factorCursor.remove();
    (0, $gFW3W.clearStatusBar)();
}
/**
 * react to the user pressing the Add Link button
 * handles cases when the button is disabled; has previously been pressed; and the Add Node
 * button is active, as well as the normal case
 */ function $e1c55b086cf8dd0e$var$plusLink() {
    switch($e1c55b086cf8dd0e$var$inAddMode){
        case 'disabled':
            return;
        case 'addLink':
            $e1c55b086cf8dd0e$var$showPressed('addLink', 'remove');
            $e1c55b086cf8dd0e$var$stopEdit();
            break;
        case 'addNode':
            $e1c55b086cf8dd0e$var$showPressed('addNode', 'remove');
            $e1c55b086cf8dd0e$var$stopEdit() // falls through
            ;
        default:
            // false
            // don't allow user to add a factor while editing another one
            if ((0, $gFW3W.elem)('popup').style.display === 'block') break;
            $e1c55b086cf8dd0e$var$removeFactorCursor();
            if ($e1c55b086cf8dd0e$export$4051a07651545597.nodes.length < 2) {
                (0, $gFW3W.alertMsg)('Two Factors needed to link', 'error');
                break;
            }
            $e1c55b086cf8dd0e$var$changeCursor('crosshair');
            $e1c55b086cf8dd0e$var$inAddMode = 'addLink';
            $e1c55b086cf8dd0e$var$showPressed('addLink', 'add');
            $e1c55b086cf8dd0e$export$9bc34f54445cb725();
            (0, $gFW3W.statusMsg)('Now drag from the middle of the Source factor to the middle of the Destination factor');
            $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.setOptions({
                interaction: {
                    dragView: false,
                    selectable: false
                }
            });
            $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.addEdgeMode();
    }
}
/**
 * cancel adding node and links
 */ function $e1c55b086cf8dd0e$var$stopEdit() {
    $e1c55b086cf8dd0e$var$inAddMode = false;
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.disableEditMode();
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.setOptions({
        interaction: {
            dragView: true,
            selectable: true
        }
    });
    (0, $gFW3W.clearStatusBar)();
    $e1c55b086cf8dd0e$var$changeCursor('default');
}
/**
 * Add or remove the CSS style showing that the button has been pressed
 * @param {string} el the Id of the button
 * @param {*} action whether to add or remove the style
 *
 */ function $e1c55b086cf8dd0e$var$showPressed(el, action) {
    (0, $gFW3W.elem)(el).children.item(0).classList[action]('pressed');
}
function $e1c55b086cf8dd0e$var$undo() {
    if ($e1c55b086cf8dd0e$var$buttonIsDisabled('undo')) return;
    $e1c55b086cf8dd0e$export$9bc34f54445cb725();
    $e1c55b086cf8dd0e$export$f796f85272199be2.undo();
    $e1c55b086cf8dd0e$export$e5fde6ebaea8ae1d('undid last action');
    $e1c55b086cf8dd0e$export$e810bab53f2cc5ca();
}
function $e1c55b086cf8dd0e$var$redo() {
    if ($e1c55b086cf8dd0e$var$buttonIsDisabled('redo')) return;
    $e1c55b086cf8dd0e$export$9bc34f54445cb725();
    $e1c55b086cf8dd0e$export$f796f85272199be2.redo();
    $e1c55b086cf8dd0e$export$e5fde6ebaea8ae1d('redid last action');
    $e1c55b086cf8dd0e$export$e810bab53f2cc5ca();
}
function $e1c55b086cf8dd0e$export$e810bab53f2cc5ca() {
    $e1c55b086cf8dd0e$var$setButtonDisabledStatus('undo', $e1c55b086cf8dd0e$export$f796f85272199be2.undoStack.length === 0);
    $e1c55b086cf8dd0e$var$setButtonDisabledStatus('redo', $e1c55b086cf8dd0e$export$f796f85272199be2.redoStack.length === 0);
}
/**
 * Returns true if the button is not disabled
 * @param {String} id
 * @returns Boolean
 */ function $e1c55b086cf8dd0e$var$buttonIsDisabled(id) {
    return (0, $gFW3W.elem)(id).classList.contains('disabled');
}
/**
 * Change the visible state of a button
 * @param {String} id
 * @param {Boolean} state - true to make the button disabled
 */ function $e1c55b086cf8dd0e$var$setButtonDisabledStatus(id, state) {
    if (state) (0, $gFW3W.elem)(id).classList.add('disabled');
    else (0, $gFW3W.elem)(id).classList.remove('disabled');
}
/**
 * Delete the selected node, plus all the edges that connect to it (so no edge is left dangling)
 */ function $e1c55b086cf8dd0e$var$deleteNode() {
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.deleteSelected();
    (0, $gFW3W.clearStatusBar)();
    $e1c55b086cf8dd0e$export$c1a1b42e4610dc4a();
}
/**
 * set up the modal dialog that opens when the user clicks the Share icon in the nav bar
 */ function $e1c55b086cf8dd0e$var$setUpShareDialog() {
    let modal = (0, $gFW3W.elem)('shareModal');
    let inputElem = (0, $gFW3W.elem)('text-to-copy');
    let copiedText = (0, $gFW3W.elem)('copied-text');
    // When the user clicks the button, open the modal
    (0, $gFW3W.listen)('share', 'click', ()=>{
        let path = `${window.location.pathname}?room=${$e1c55b086cf8dd0e$export$f9d3fff8c23da278}`;
        let linkToShare = window.location.origin + path;
        copiedText.style.display = 'none';
        modal.style.display = 'block';
        inputElem.cols = linkToShare.length.toString();
        inputElem.value = linkToShare;
        inputElem.style.height = `${inputElem.scrollHeight - 3}px`;
        inputElem.select();
        $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.storePositions();
    });
    (0, $gFW3W.listen)('clone-button', 'click', ()=>openWindow('clone'));
    (0, $gFW3W.listen)('view-button', 'click', ()=>openWindow('view'));
    (0, $gFW3W.listen)('table-button', 'click', ()=>openWindow('table'));
    // When the user clicks on <span> (x), close the modal
    (0, $gFW3W.listen)('modal-close', 'click', (event1)=>closeShareDialog(event1));
    // When the user clicks anywhere on the background, close it
    (0, $gFW3W.listen)('shareModal', 'click', (event1)=>closeShareDialog(event1));
    (0, $gFW3W.listen)('copy-text', 'click', (e)=>{
        e.preventDefault();
        // Select the text
        inputElem.select();
        if ($e1c55b086cf8dd0e$var$copyText(inputElem.value)) // Display the copied text message
        copiedText.style.display = 'inline-block';
    });
    function openWindow(type) {
        let path = '';
        switch(type){
            case 'clone':
                $e1c55b086cf8dd0e$var$doClone(false);
                break;
            case 'view':
                $e1c55b086cf8dd0e$var$doClone(true);
                break;
            case 'table':
                path = `${window.location.pathname.replace('prsm.html', 'table.html')}?room=${$e1c55b086cf8dd0e$export$f9d3fff8c23da278}`;
                window.open(path, '_blank');
                break;
            default:
                console.log('Bad case in openWindow()');
                break;
        }
        modal.style.display = 'none';
    }
    function closeShareDialog(event1) {
        if (event1.target === modal || event1.target === (0, $gFW3W.elem)('modal-close')) modal.style.display = 'none';
    }
}
function $e1c55b086cf8dd0e$var$doClone(onlyView) {
    // undo any ongoing analysis and unselect all nodes and edges
    $e1c55b086cf8dd0e$var$setRadioVal('radius', 'All');
    $e1c55b086cf8dd0e$var$setRadioVal('stream', 'All');
    $e1c55b086cf8dd0e$var$setRadioVal('paths', 'All');
    $e1c55b086cf8dd0e$var$analyse();
    $e1c55b086cf8dd0e$export$9bc34f54445cb725();
    let options = {
        created: {
            action: `cloned this map from room: ${$e1c55b086cf8dd0e$export$f9d3fff8c23da278 + (onlyView ? ' (Read Only)' : '')}`,
            actor: $e1c55b086cf8dd0e$var$myNameRec.name
        },
        viewOnly: onlyView
    };
    // save state as a UTF16 string
    let state = $e1c55b086cf8dd0e$export$fb931cd598921492(options);
    // save it in local storage
    localStorage.setItem('clone', state);
    // make a room id
    let clonedRoom = $e1c55b086cf8dd0e$var$generateRoom();
    //open a new map
    let path = `${window.location.pathname}?room=${clonedRoom}`;
    if (onlyView && (0, $gFW3W.elem)('addCopyButton').checked) path += '&copyButton';
    window.open(path, '_blank');
    $e1c55b086cf8dd0e$export$e5fde6ebaea8ae1d(`made a ${onlyView ? 'read-only copy' : 'clone'} of the map in room: ${clonedRoom}`);
}
function $e1c55b086cf8dd0e$var$mergeMap() {
    (0, $gFW3W.elem)('mergedRoom').value = '';
    (0, $gFW3W.elem)('mergeDialog').showModal();
}
function $e1c55b086cf8dd0e$var$doMerge() {
    let path = (0, $gFW3W.elem)('mergedRoom').value;
    if (!path) {
        (0, $gFW3W.alertMsg)('No map given to merge', 'error');
        return;
    }
    try {
        let url = new URL(path);
        let roomToMerge = url.searchParams.get('room');
        console.log('merging ', roomToMerge);
        (0, $aa1828bc973fe863$export$547fdf2442351faf)(roomToMerge);
        $e1c55b086cf8dd0e$export$e5fde6ebaea8ae1d(`merged map from room: ${roomToMerge}`);
    } catch  {
        (0, $gFW3W.alertMsg)('Invalid map URL', 'error');
        return;
    }
    (0, $gFW3W.elem)('mergeDialog').close();
}
/* ----------------------------------------------------------- Search ------------------------------------------------------*/ /**
 * Open an input for user to type label of node to search for and generate suggestions when user starts typing
 */ function $e1c55b086cf8dd0e$var$search() {
    let searchBar = (0, $gFW3W.elem)('search-bar');
    if (searchBar.style.display === 'block') $e1c55b086cf8dd0e$var$hideSearchBar();
    else {
        searchBar.style.display = 'block';
        (0, $gFW3W.elem)('search-icon').style.display = 'block';
        searchBar.focus();
        (0, $gFW3W.listen)('search-bar', 'keyup', $e1c55b086cf8dd0e$var$searchTargets);
    }
}
/**
 * generate and display a set of suggestions - nodes with labels that include the substring that the user has typed
 */ function $e1c55b086cf8dd0e$var$searchTargets() {
    let str = (0, $gFW3W.elem)('search-bar').value;
    if (!str || str === ' ') {
        if ((0, $gFW3W.elem)('targets')) (0, $gFW3W.elem)('targets').remove();
        return;
    }
    let targets = (0, $gFW3W.elem)('targets');
    if (targets) targets.remove();
    targets = document.createElement('ul');
    targets.id = 'targets';
    targets.classList.add('search-ul');
    str = str.toLowerCase();
    let suggestions = $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get().filter((n)=>n.label.toLowerCase().includes(str));
    suggestions.slice(0, 8).forEach((n)=>{
        let li = document.createElement('li');
        li.classList.add('search-suggestion');
        let div = document.createElement('div');
        div.classList.add('search-suggestion-text');
        div.innerText = n.label.replace(/\n/g, ' ');
        div.dataset.id = n.id;
        div.addEventListener('click', (event1)=>$e1c55b086cf8dd0e$var$doSearch(event1));
        li.appendChild(div);
        targets.appendChild(li);
    });
    if (suggestions.length > 8) {
        let li = document.createElement('li');
        li.classList.add('search-suggestion');
        let div = document.createElement('div');
        div.className = 'search-suggestion-text and-more';
        div.innerText = 'and more ...';
        li.appendChild(div);
        targets.appendChild(li);
    }
    (0, $gFW3W.elem)('suggestion-list').appendChild(targets);
}
/**
 * do the search using the string in the search bar and, when found, focus on that node
 */ function $e1c55b086cf8dd0e$var$doSearch(event1) {
    let nodeId = event1.target.dataset.id;
    if (nodeId) {
        let prevPos = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getViewPosition();
        $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.focus(nodeId, {
            scale: 1.5
        });
        let newPos = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getViewPosition();
        let newScale = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getScale();
        (0, $a4a268d7686bbf3f$export$8a6e5c2ddf85cd20)(1.0);
        (0, $a4a268d7686bbf3f$export$4ccc1b9eba0bcd20)(prevPos.x - newPos.x, prevPos.y - newPos.y, 1.0);
        (0, $a4a268d7686bbf3f$export$8a6e5c2ddf85cd20)(newScale);
        (0, $gFW3W.elem)('zoom').value = newScale;
        $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.storePositions();
        $e1c55b086cf8dd0e$var$hideSearchBar();
    }
}
function $e1c55b086cf8dd0e$var$hideSearchBar() {
    let searchBar = (0, $gFW3W.elem)('search-bar');
    if ((0, $gFW3W.elem)('targets')) (0, $gFW3W.elem)('targets').remove();
    searchBar.value = '';
    searchBar.style.display = 'none';
    (0, $gFW3W.elem)('search-icon').style.display = 'none';
}
/**
 * show or hide the side panel
 */ function $e1c55b086cf8dd0e$var$togglePanel() {
    if ($e1c55b086cf8dd0e$export$34e0f9847d4c02dd.panelHidden) {
        $e1c55b086cf8dd0e$var$panel.classList.remove('hide');
        $e1c55b086cf8dd0e$var$positionNotes();
    } else $e1c55b086cf8dd0e$var$panel.classList.add('hide');
    $e1c55b086cf8dd0e$export$34e0f9847d4c02dd.panelHidden = !$e1c55b086cf8dd0e$export$34e0f9847d4c02dd.panelHidden;
}
(0, $gFW3W.dragElement)((0, $gFW3W.elem)('panel'), (0, $gFW3W.elem)('panelHeader'));
/* ------------------------------------------------operations related to the side panel -------------------------------------*/ /**
 * when the window is resized, make sure that the pane is still visible
 * @param {HTMLelement} pane
 */ function $e1c55b086cf8dd0e$var$keepPaneInWindow(pane) {
    if (pane.offsetLeft + pane.offsetWidth > $e1c55b086cf8dd0e$export$34e0f9847d4c02dd.offsetLeft + $e1c55b086cf8dd0e$export$34e0f9847d4c02dd.offsetWidth) pane.style.left = `${$e1c55b086cf8dd0e$export$34e0f9847d4c02dd.offsetLeft + $e1c55b086cf8dd0e$export$34e0f9847d4c02dd.offsetWidth - pane.offsetWidth}px`;
    if (pane.offsetTop + pane.offsetHeight > $e1c55b086cf8dd0e$export$34e0f9847d4c02dd.offsetTop + $e1c55b086cf8dd0e$export$34e0f9847d4c02dd.offsetHeight) pane.style.top = `${$e1c55b086cf8dd0e$export$34e0f9847d4c02dd.offsetTop + $e1c55b086cf8dd0e$export$34e0f9847d4c02dd.offsetHeight - pane.offsetHeight - document.querySelector('footer').offsetHeight}px`;
}
function $e1c55b086cf8dd0e$var$openTab(tabId) {
    let i;
    let tabcontent;
    let tablinks;
    // Get all elements with class="tabcontent" and hide them by moving them off screen
    tabcontent = document.getElementsByClassName('tabcontent');
    for(i = 0; i < tabcontent.length; i++)tabcontent[i].classList.add('hide');
    // Get all elements with class="tablinks" and remove the class "active"
    tablinks = document.getElementsByClassName('tablinks');
    for(i = 0; i < tablinks.length; i++)tablinks[i].className = tablinks[i].className.replace(' active', '');
    // Show the current tab, and add an "active" class to the button that opened the tab
    (0, $gFW3W.elem)(tabId).classList.remove('hide');
    event.currentTarget.className += ' active';
    (0, $gFW3W.clearStatusBar)();
    // if a Notes panel is in the way, move it
    $e1c55b086cf8dd0e$var$positionNotes();
}
// Factors and Links Tabs
function $e1c55b086cf8dd0e$var$applySampleToNode(event1) {
    if (event1.detail !== 1) return; // only process single clicks here
    let selectedNodeIds = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getSelectedNodes();
    if (selectedNodeIds.length === 0) return;
    let nodesToUpdate = [];
    let sample = event1.currentTarget.groupNode;
    for (let node of $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(selectedNodeIds))if (sample !== node.grp) {
        node = (0, $gFW3W.deepMerge)(node, (0, $09258687963db43e$export$9dd6ff9ea0189349).nodes[sample]);
        node.grp = sample;
        node.modified = $e1c55b086cf8dd0e$export$fc00ee57782020aa();
        nodesToUpdate.push(node);
    }
    $e1c55b086cf8dd0e$export$4051a07651545597.nodes.update(nodesToUpdate);
    let nNodes = nodesToUpdate.length;
    if (nNodes) $e1c55b086cf8dd0e$export$e5fde6ebaea8ae1d(`applied ${(0, $09258687963db43e$export$9dd6ff9ea0189349).nodes[sample].groupLabel} style to ${nNodes === 1 ? nodesToUpdate[0].label : nNodes + ' factors'}`);
    $e1c55b086cf8dd0e$export$794b27baf354ffba = sample;
}
function $e1c55b086cf8dd0e$var$applySampleToLink(event1) {
    if (event1.detail !== 1) return; // only process single clicks here
    let sample = event1.currentTarget.groupLink;
    let selectedEdges = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getSelectedEdges();
    if (selectedEdges.length === 0) return;
    let edgesToUpdate = [];
    for (let edge of $e1c55b086cf8dd0e$export$4051a07651545597.edges.get(selectedEdges))if (sample !== edge.grp) {
        edge = (0, $gFW3W.deepMerge)(edge, (0, $09258687963db43e$export$9dd6ff9ea0189349).edges[sample]);
        edge.grp = sample;
        edge.modified = $e1c55b086cf8dd0e$export$fc00ee57782020aa();
        edgesToUpdate.push(edge);
    }
    $e1c55b086cf8dd0e$export$4051a07651545597.edges.update(edgesToUpdate);
    let nEdges = edgesToUpdate.length;
    if (nEdges) $e1c55b086cf8dd0e$export$e5fde6ebaea8ae1d(`applied ${(0, $09258687963db43e$export$9dd6ff9ea0189349).edges[sample].groupLabel} style to ${nEdges} link${nEdges === 1 ? '' : 's'} `);
    $e1c55b086cf8dd0e$export$a01f2d76756b77a5 = sample;
}
function $e1c55b086cf8dd0e$export$7ac138a1e38951d6(nodeId, linkId) {
    if (nodeId) {
        $e1c55b086cf8dd0e$export$794b27baf354ffba = nodeId;
        let sampleNodes = Array.from(document.getElementsByClassName('sampleNode'));
        let node = sampleNodes.filter((e)=>e.groupNode === nodeId)[0];
        sampleNodes.forEach((n)=>n.classList.remove('sampleSelected'));
        node.classList.add('sampleSelected');
    }
    if (linkId) {
        $e1c55b086cf8dd0e$export$a01f2d76756b77a5 = linkId;
        let sampleLinks = Array.from(document.getElementsByClassName('sampleLink'));
        let link = sampleLinks.filter((e)=>e.groupLink === linkId)[0];
        sampleLinks.forEach((n)=>n.classList.remove('sampleSelected'));
        link.classList.add('sampleSelected');
    }
}
/**
 * Hide or reveal all the Factors or Links with the given style
 * @param {Object} obj {sample: state}
 */ function $e1c55b086cf8dd0e$var$updateFactorsOrLinksHiddenByStyle(obj) {
    for(const sampleElementId in obj){
        let sampleElement = (0, $gFW3W.elem)(sampleElementId);
        let state = obj[sampleElementId];
        sampleElement.dataset.hide = state ? 'hidden' : 'visible';
        sampleElement.style.opacity = state ? 0.6 : 1.0;
    }
}
/********************************************************Notes********************************************** */ /**
 * Globally either display or don't display notes when a factor or link is selected
 * @param {Event} e
 */ function $e1c55b086cf8dd0e$var$showNotesSwitch(e) {
    $e1c55b086cf8dd0e$var$showNotesToggle = e.target.checked;
    $e1c55b086cf8dd0e$var$doShowNotes($e1c55b086cf8dd0e$var$showNotesToggle);
    $e1c55b086cf8dd0e$export$807f940a96777041.set('showNotes', $e1c55b086cf8dd0e$var$showNotesToggle);
}
function $e1c55b086cf8dd0e$var$doShowNotes(toggle) {
    (0, $gFW3W.elem)('showNotesSwitch').checked = toggle;
    $e1c55b086cf8dd0e$var$showNotesToggle = toggle;
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.redraw();
    $e1c55b086cf8dd0e$var$showNodeOrEdgeData();
}
/**
 * User has clicked the padlock.  Toggle padlock state and fix the location of the node
 */ function $e1c55b086cf8dd0e$var$setFixed() {
    if ($e1c55b086cf8dd0e$var$viewOnly) return;
    let locked = (0, $gFW3W.elem)('fixed').style.display === 'none';
    let node = $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get($e1c55b086cf8dd0e$var$editor.id);
    node.fixed = locked;
    (0, $gFW3W.elem)('fixed').style.display = node.fixed ? 'inline' : 'none';
    (0, $gFW3W.elem)('unfixed').style.display = node.fixed ? 'none' : 'inline';
    $e1c55b086cf8dd0e$export$4051a07651545597.nodes.update(node);
}
/**
 * Display a panel to show info about the selected edge or node
 */ function $e1c55b086cf8dd0e$var$showNodeOrEdgeData() {
    $e1c55b086cf8dd0e$var$hideNotes();
    if (!$e1c55b086cf8dd0e$var$showNotesToggle) return;
    if ($e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getSelectedNodes().length === 1) $e1c55b086cf8dd0e$var$showNodeData();
    else if ($e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getSelectedEdges().length === 1) $e1c55b086cf8dd0e$var$showEdgeData();
}
/**
 * open another window (popupWindow) in which Notes can be edited
 */ function $e1c55b086cf8dd0e$var$openNotesWindow() {
    $e1c55b086cf8dd0e$var$popupWindow = window.open('./dist/NoteWindow.html', 'popupWindowName', 'toolbar=no,width=600,height=600');
}
/**
 * Hide the Node or Edge Data panel
 */ function $e1c55b086cf8dd0e$var$hideNotes() {
    if ($e1c55b086cf8dd0e$var$editor == null) return;
    (0, $gFW3W.elem)('nodeDataPanel').classList.add('hide');
    (0, $gFW3W.elem)('edgeDataPanel').classList.add('hide');
    document.getSelection().removeAllRanges();
    document.querySelectorAll('.ql-toolbar').forEach((e)=>e.remove());
    $e1c55b086cf8dd0e$var$editor = null;
    if ($e1c55b086cf8dd0e$var$popupWindow) $e1c55b086cf8dd0e$var$popupWindow.close();
}
/**
 * Show the notes box, the fixed node check box and the node statistics
 */ function $e1c55b086cf8dd0e$var$showNodeData(nodeId) {
    let panel = (0, $gFW3W.elem)('nodeDataPanel');
    nodeId = nodeId || $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getSelectedNodes()[0];
    let node = $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(nodeId);
    (0, $gFW3W.elem)('fixed').style.display = node.fixed ? 'inline' : 'none';
    (0, $gFW3W.elem)('unfixed').style.display = node.fixed ? 'none' : 'inline';
    (0, $gFW3W.elem)('nodeLabel').innerHTML = node.label ? (0, $gFW3W.shorten)(node.label) : '';
    if (node.created) {
        (0, $gFW3W.elem)('nodeCreated').innerHTML = `${(0, $gFW3W.timeAndDate)(node.created.time)} by ${node.created.user}`;
        (0, $gFW3W.elem)('nodeCreation').style.display = 'flex';
    } else (0, $gFW3W.elem)('nodeCreation').style.display = 'none';
    if (node.modified) {
        (0, $gFW3W.elem)('nodeModified').innerHTML = `${(0, $gFW3W.timeAndDate)(node.modified.time)} by ${node.modified.user}`;
        (0, $gFW3W.elem)('nodeModification').style.display = 'flex';
    } else (0, $gFW3W.elem)('nodeModification').style.display = 'none';
    (0, $gFW3W.elem)('node-notes').className = 'notes';
    $e1c55b086cf8dd0e$var$editor = new (0, $aBK2w.default)('#node-notes', {
        modules: {
            toolbar: $e1c55b086cf8dd0e$var$viewOnly ? null : [
                'bold',
                'italic',
                'underline',
                'link',
                {
                    list: 'ordered'
                },
                {
                    list: 'bullet'
                },
                {
                    indent: '-1'
                },
                {
                    indent: '+1'
                }
            ]
        },
        placeholder: 'Notes',
        theme: 'snow',
        readOnly: $e1c55b086cf8dd0e$var$viewOnly,
        bounds: (0, $gFW3W.elem)('node-edit-container')
    });
    window.editor = $e1c55b086cf8dd0e$var$editor // used by popupEditor to access this editor
    ;
    $e1c55b086cf8dd0e$var$editor.id = node.id;
    if (node.note) {
        if (node.note instanceof Object) $e1c55b086cf8dd0e$var$editor.setContents(node.note);
        else $e1c55b086cf8dd0e$var$editor.setText(node.note);
    } else $e1c55b086cf8dd0e$var$editor.setText('');
    $e1c55b086cf8dd0e$var$editor.on('text-change', (delta, oldDelta, source)=>{
        if (source === 'user') {
            $e1c55b086cf8dd0e$export$4051a07651545597.nodes.update({
                id: nodeId,
                note: (0, $gFW3W.isQuillEmpty)($e1c55b086cf8dd0e$var$editor) ? '' : $e1c55b086cf8dd0e$var$editor.getContents(),
                modified: $e1c55b086cf8dd0e$export$fc00ee57782020aa()
            });
            if ($e1c55b086cf8dd0e$var$popupWindow) {
                $e1c55b086cf8dd0e$var$popupEditor = $e1c55b086cf8dd0e$var$popupWindow.popupEditor;
                if ($e1c55b086cf8dd0e$var$popupEditor) $e1c55b086cf8dd0e$var$popupEditor.setContents($e1c55b086cf8dd0e$var$editor.getContents());
            }
        }
    });
    panel.classList.remove('hide');
    $e1c55b086cf8dd0e$var$displayStatistics(nodeId);
    $e1c55b086cf8dd0e$var$positionNotes();
}
/**
 * user has clicked on the sparkles icon in a Factor window
 * return the output from an LLM asked to explain the factor
 */ async function $e1c55b086cf8dd0e$var$genAINode() {
    (0, $gFW3W.alertMsg)('Thinking...', 'info', true);
    let nodeId = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getSelectedNodes()[0];
    let node = $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(nodeId);
    let aiResponse = await (0, $4bd848e8e930fa6d$export$d96944eb3d865634)(`Explain ${node.label}`);
    $e1c55b086cf8dd0e$var$editor.setContents(aiResponse);
    let modified = $e1c55b086cf8dd0e$export$fc00ee57782020aa();
    $e1c55b086cf8dd0e$export$4051a07651545597.nodes.update({
        id: nodeId,
        note: (0, $gFW3W.isQuillEmpty)($e1c55b086cf8dd0e$var$editor) ? '' : $e1c55b086cf8dd0e$var$editor.getContents(),
        modified: modified
    });
    (0, $gFW3W.elem)('nodeModified').innerHTML = `${(0, $gFW3W.timeAndDate)(modified.time)} by ${modified.user}`;
    (0, $gFW3W.cancelAlertMsg)();
}
function $e1c55b086cf8dd0e$var$showEdgeData(edgeId) {
    let panel = (0, $gFW3W.elem)('edgeDataPanel');
    edgeId = edgeId || $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getSelectedEdges()[0];
    let edge = $e1c55b086cf8dd0e$export$4051a07651545597.edges.get(edgeId);
    (0, $gFW3W.elem)('edgeLabel').innerHTML = edge.label?.trim().length ? edge.label : `Link from "${(0, $gFW3W.shorten)($e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(edge.from).label)}" to "${(0, $gFW3W.shorten)($e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(edge.to).label)}"`;
    if (edge.created) {
        (0, $gFW3W.elem)('edgeCreated').innerHTML = `${(0, $gFW3W.timeAndDate)(edge.created.time)} by ${edge.created.user}`;
        (0, $gFW3W.elem)('edgeCreation').style.display = 'flex';
    } else (0, $gFW3W.elem)('edgeCreation').style.display = 'none';
    if (edge.modified) {
        (0, $gFW3W.elem)('edgeModified').innerHTML = `${(0, $gFW3W.timeAndDate)(edge.modified.time)} by ${edge.modified.user}`;
        (0, $gFW3W.elem)('edgeModification').style.display = 'flex';
    } else (0, $gFW3W.elem)('edgeModification').style.display = 'none';
    $e1c55b086cf8dd0e$var$editor = new (0, $aBK2w.default)('#edge-notes', {
        modules: {
            toolbar: $e1c55b086cf8dd0e$var$viewOnly ? null : [
                'bold',
                'italic',
                'underline',
                'link',
                {
                    list: 'ordered'
                },
                {
                    list: 'bullet'
                },
                {
                    indent: '-1'
                },
                {
                    indent: '+1'
                }
            ]
        },
        placeholder: 'Notes',
        theme: 'snow',
        readOnly: $e1c55b086cf8dd0e$var$viewOnly,
        bounds: (0, $gFW3W.elem)('edge-edit-container')
    });
    $e1c55b086cf8dd0e$var$editor.id = edge.id;
    window.editor = $e1c55b086cf8dd0e$var$editor // used by popupEditor to access this editor
    ;
    if (edge.note) {
        if (edge.note instanceof Object) $e1c55b086cf8dd0e$var$editor.setContents(edge.note);
        else $e1c55b086cf8dd0e$var$editor.setText(edge.note);
    } else $e1c55b086cf8dd0e$var$editor.setText('');
    $e1c55b086cf8dd0e$var$editor.on('text-change', (delta, oldDelta, source)=>{
        if (source === 'user') {
            $e1c55b086cf8dd0e$export$4051a07651545597.edges.update({
                id: edgeId,
                note: (0, $gFW3W.isQuillEmpty)($e1c55b086cf8dd0e$var$editor) ? '' : $e1c55b086cf8dd0e$var$editor.getContents(),
                modified: $e1c55b086cf8dd0e$export$fc00ee57782020aa()
            });
            if ($e1c55b086cf8dd0e$var$popupWindow) {
                $e1c55b086cf8dd0e$var$popupEditor = $e1c55b086cf8dd0e$var$popupWindow.popupEditor;
                if ($e1c55b086cf8dd0e$var$popupEditor) $e1c55b086cf8dd0e$var$popupEditor.setContents($e1c55b086cf8dd0e$var$editor.getContents());
            }
        }
    });
    panel.classList.remove('hide');
    $e1c55b086cf8dd0e$var$positionNotes();
}
/**
 * user has clicked on the sparkles icon in a Link node window
 * return the output from an LLM asked to elaborate on the causal
 * relationship between the two linked factors
 */ async function $e1c55b086cf8dd0e$var$genAIEdge() {
    (0, $gFW3W.alertMsg)('Thinking...', 'info', true);
    let edgeId = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getSelectedEdges()[0];
    let edge = $e1c55b086cf8dd0e$export$4051a07651545597.edges.get(edgeId);
    let aiResponse = await (0, $4bd848e8e930fa6d$export$d96944eb3d865634)(`Explain the causal link between ${$e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(edge.from).label} and ${$e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(edge.to).label}`);
    $e1c55b086cf8dd0e$var$editor.setContents(aiResponse);
    let modified = $e1c55b086cf8dd0e$export$fc00ee57782020aa();
    $e1c55b086cf8dd0e$export$4051a07651545597.edges.update({
        id: edgeId,
        note: (0, $gFW3W.isQuillEmpty)($e1c55b086cf8dd0e$var$editor) ? '' : $e1c55b086cf8dd0e$var$editor.getContents(),
        modified: modified
    });
    (0, $gFW3W.elem)('edgeModified').innerHTML = `${(0, $gFW3W.timeAndDate)(modified.time)} by ${modified.user}`;
    (0, $gFW3W.cancelAlertMsg)();
}
/**
 * Display the statistics for the selected node
 * @param {String} nodeId 
 */ function $e1c55b086cf8dd0e$var$displayStatistics(nodeId) {
    // leverage (outDegree / inDegree)
    let inDegree = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getConnectedNodes(nodeId, 'from').length;
    let outDegree = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getConnectedNodes(nodeId, 'to').length;
    let leverage = inDegree === 0 ? '--' : (outDegree / inDegree).toPrecision(3);
    (0, $gFW3W.elem)('leverage').textContent = leverage;
    let node = $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(nodeId);
    (0, $gFW3W.elem)('bc').textContent = node.bc >= 0 ? parseFloat(node.bc).toFixed(2) : '--';
}
/**
 * ensure that the panel is not outside the net pane, nor obscuring the Settings panel
 * @param {HTMLElement} panel
 */ function $e1c55b086cf8dd0e$var$positionNotes() {
    let notesPanel;
    if (!(0, $gFW3W.elem)('nodeDataPanel').classList.contains('hide')) notesPanel = (0, $gFW3W.elem)('nodeDataPanel');
    if (!(0, $gFW3W.elem)('edgeDataPanel').classList.contains('hide')) notesPanel = (0, $gFW3W.elem)('edgeDataPanel');
    if (!notesPanel) return;
    let notesPanelRect = notesPanel.getBoundingClientRect();
    let settingsRect = (0, $gFW3W.elem)('panel').getBoundingClientRect();
    let netPaneRect = $e1c55b086cf8dd0e$export$4b72f5d71fff605.getBoundingClientRect();
    // if the notes would cover up the settings panel, move the notes to the left of the settings panel
    if (notesPanelRect.right > settingsRect.left && notesPanelRect.top < settingsRect.bottom) notesPanel.style.left = `${settingsRect.left - notesPanelRect.width - 20}px`;
    // if the notes panel is outside the boundary of the net pane, shift it into the pane
    if (notesPanelRect.left < netPaneRect.left + 20) notesPanel.style.left = `${netPaneRect.left + 20}px`;
    if (notesPanelRect.right > netPaneRect.right) notesPanel.style.left = `${netPaneRect.right - notesPanelRect.width - 20}px`;
    let top = notesPanelRect.top;
    if (notesPanelRect.bottom > netPaneRect.bottom) top = netPaneRect.bottom - notesPanelRect.height - 10;
    if (top < netPaneRect.top + 30) top = netPaneRect.top + 30;
    notesPanel.style.top = `${top}px`;
    (0, $gFW3W.elem)('node-notes').style.maxHeight = `${netPaneRect.height - 230}px`;
}
// Network tab
/**
 * Choose and apply a layout algorithm
 */ function $e1c55b086cf8dd0e$var$autoLayout(e) {
    let option = e.target.value;
    let selectElement = (0, $gFW3W.elem)('layoutSelect');
    selectElement.value = option;
    let label = selectElement.options[selectElement.selectedIndex].innerText;
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.storePositions() // record current positions so it can be undone
    ;
    if ($e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.physics.options.enabled) {
        // another layout already in progress - cancel it first
        $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.off('stabilized');
        $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.stopSimulation();
        $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.setOptions({
            physics: {
                enabled: false
            }
        });
        $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.storePositions();
        (0, $gFW3W.alertMsg)(`Previous layout cancelled`, 'warn');
    }
    $e1c55b086cf8dd0e$export$2a111da947c407d2.transact(()=>{
        switch(option){
            case 'off':
                $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.setOptions({
                    physics: {
                        enabled: false
                    }
                });
                break;
            case 'trophic':
                try {
                    (0, $95f9b1ee7539e417$export$cc9ec954c05f1d69)($e1c55b086cf8dd0e$export$4051a07651545597);
                    trophicDistribute();
                    $e1c55b086cf8dd0e$export$4051a07651545597.nodes.update($e1c55b086cf8dd0e$export$4051a07651545597.nodes.get());
                    (0, $gFW3W.elem)('layoutSelect').value = 'off';
                    (0, $gFW3W.statusMsg)('Trophic layout applied');
                } catch (err) {
                    (0, $gFW3W.alertMsg)(`Trophic layout: ${err.message}`, 'error');
                }
                break;
            case 'fan':
                {
                    let nodes = $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get().filter((n)=>!n.nodeHidden);
                    nodes.forEach((n)=>n.level = undefined);
                    let selectedNodes = $e1c55b086cf8dd0e$var$getSelectedAndFixedNodes().map((nId)=>$e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(nId));
                    if (selectedNodes.length === 0) {
                        (0, $gFW3W.alertMsg)('At least one Factor needs to be selected', 'error');
                        (0, $gFW3W.elem)('layoutSelect').value = 'off';
                        return;
                    }
                    // if Up or Down stream are selected, use those for the direction
                    let direction = 'from';
                    if ($e1c55b086cf8dd0e$var$getRadioVal('stream') === 'downstream') direction = 'to';
                    else if ($e1c55b086cf8dd0e$var$getRadioVal('stream') === 'upstream') direction = 'from';
                    else {
                        // if neither,
                        //  and more links from the selected nodes are going upstream then downstream,
                        //  put the selected nodes on the right, else on the left
                        let nUp = 0;
                        let nDown = 0;
                        selectedNodes.forEach((sl)=>{
                            nUp += $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getConnectedNodes(sl.id, 'to').filter((nId)=>!$e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(nId).nodeHidden).length;
                            nDown += $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getConnectedNodes(sl.id, 'from').filter((nId)=>!$e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(nId).nodeHidden).length;
                        });
                        direction = nUp > nDown ? 'to' : 'from';
                    }
                    let minX = Math.min(...nodes.map((n)=>n.x));
                    let maxX = Math.max(...nodes.map((n)=>n.x));
                    selectedNodes.forEach((n)=>{
                        setZLevel(n, direction);
                    });
                    nodes.forEach((n)=>{
                        if (n.level === undefined) n.level = 0;
                    });
                    let maxLevel = Math.max(...nodes.map((n)=>n.level));
                    let gap = (maxX - minX) / maxLevel;
                    for(let l = 0; l <= maxLevel; l++){
                        let x = l * gap + minX;
                        if (direction === 'from') x = maxX - l * gap;
                        let nodesOnLevel = nodes.filter((n)=>n.level === l);
                        nodesOnLevel.forEach((n)=>n.x = x);
                        let ySpaceNeeded = nodesOnLevel.map((n)=>{
                            let box = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getBoundingBox(n.id);
                            return box.bottom - box.top + 10;
                        }).reduce((a, b)=>a + b, 0);
                        let yGap = ySpaceNeeded / nodesOnLevel.length;
                        let newY = -ySpaceNeeded / 2;
                        nodesOnLevel.sort((a, b)=>a.y - b.y).forEach((n)=>{
                            n.y = newY;
                            newY += yGap;
                        });
                    }
                    $e1c55b086cf8dd0e$export$4051a07651545597.nodes.update(nodes);
                    (0, $gFW3W.elem)('layoutSelect').value = 'off';
                    (0, $gFW3W.statusMsg)('Fan layout applied');
                }
                break;
            default:
                {
                    (0, $gFW3W.statusMsg)('Working...');
                    let options = {
                        physics: {
                            solver: option,
                            stabilization: true
                        }
                    };
                    options.physics[option] = {};
                    options.physics[option].springLength = avEdgeLength();
                    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.setOptions(options);
                    // cancel the iterative algorithms as soon as they have stabilized
                    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.on('stabilized', ()=>{
                        $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.setOptions({
                            physics: {
                                enabled: false
                            }
                        });
                        $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.storePositions();
                        (0, $gFW3W.elem)('layoutSelect').value = 'off';
                        (0, $gFW3W.statusMsg)(`${label} layout applied`);
                        $e1c55b086cf8dd0e$export$4051a07651545597.nodes.update($e1c55b086cf8dd0e$export$4051a07651545597.nodes.get());
                    });
                    break;
                }
        }
    });
    $e1c55b086cf8dd0e$export$e5fde6ebaea8ae1d(`applied ${label} layout`);
    /**
	 * set the levels for fan, using a breadth first search
	 * @param {object} node root node
	 * @param {string} direction either 'from' or 'to', depending on whether the links to use are point from or to the node
	 */ function setZLevel(node, direction) {
        let q = [
            node
        ];
        let level = 0;
        node.level = 0;
        while(q.length > 0){
            let currentNode = q.shift();
            let connectedNodes = $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get($e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getConnectedNodes(currentNode.id, direction)).filter((n)=>!n.nodeHidden && n.level === undefined);
            if (connectedNodes.length > 0) {
                level = currentNode.level + 1;
                connectedNodes.forEach((n)=>{
                    n.level = level;
                });
                q = q.concat(connectedNodes);
            }
        }
    }
    /**
	 * find the average length of all edges, as a guide to the layout spring length
	 * so that map is roughly as spaced out as before layout
	 * @returns average length (in canvas units)
	 */ function avEdgeLength() {
        let edgeSum = 0;
        $e1c55b086cf8dd0e$export$4051a07651545597.edges.forEach((e)=>{
            let from = $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(e.from);
            let to = $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(e.to);
            edgeSum += Math.sqrt((from.x - to.x) ** 2 + (from.y - to.y) ** 2);
        });
        return edgeSum / $e1c55b086cf8dd0e$export$4051a07651545597.edges.length;
    }
    /**
	 * At each level for a trophic layout, distribute the Factors equally along the vertical axis,
	 * avoiding overlaps
	 */ function trophicDistribute() {
        for(let level = 0; level <= $e1c55b086cf8dd0e$export$4448800f068b9d2f; level++){
            let nodesOnLevel = $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get().filter((n)=>n.level === level);
            let ySpaceNeeded = nodesOnLevel.map((n)=>{
                let box = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getBoundingBox(n.id);
                return box.bottom - box.top + 10;
            }).reduce((a, b)=>a + b, 0);
            let gap = ySpaceNeeded / nodesOnLevel.length;
            let newY = -ySpaceNeeded / 2;
            nodesOnLevel.sort((a, b)=>a.y - b.y).forEach((n)=>{
                n.y = newY;
                newY += gap;
            });
        }
    }
}
function $e1c55b086cf8dd0e$var$snapToGridSwitch(e) {
    $e1c55b086cf8dd0e$var$snapToGridToggle = e.target.checked;
    $e1c55b086cf8dd0e$export$95ff17332160327a($e1c55b086cf8dd0e$var$snapToGridToggle);
    $e1c55b086cf8dd0e$export$807f940a96777041.set('snapToGrid', $e1c55b086cf8dd0e$var$snapToGridToggle);
}
function $e1c55b086cf8dd0e$export$95ff17332160327a(toggle) {
    (0, $gFW3W.elem)('snaptogridswitch').checked = toggle;
    if (toggle) $e1c55b086cf8dd0e$export$4051a07651545597.nodes.update($e1c55b086cf8dd0e$export$4051a07651545597.nodes.get().map((n)=>{
        $e1c55b086cf8dd0e$var$snapToGrid(n);
        return n;
    }));
}
function $e1c55b086cf8dd0e$var$selectCurve(e) {
    let option = e.target.value;
    $e1c55b086cf8dd0e$export$264d5714f8b2c7d8(option);
    $e1c55b086cf8dd0e$export$807f940a96777041.set('curve', option);
}
function $e1c55b086cf8dd0e$export$264d5714f8b2c7d8(option) {
    (0, $gFW3W.elem)('curveSelect').value = option;
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.setOptions({
        edges: {
            smooth: option === 'Curved'
        }
    });
}
function $e1c55b086cf8dd0e$var$updateNetBack(color) {
    let ul = (0, $gFW3W.elem)('underlay');
    ul.style.backgroundColor = color;
    // if in drawing mode, make the underlay translucent so that network shows through
    if ((0, $gFW3W.elem)('toolbox').style.display === 'block') $e1c55b086cf8dd0e$var$makeTranslucent(ul);
    $e1c55b086cf8dd0e$export$807f940a96777041.set('background', color);
}
var $e1c55b086cf8dd0e$var$backgroundOpacity = 0.6;
function $e1c55b086cf8dd0e$var$makeTranslucent(el) {
    el.style.backgroundColor = getComputedStyle(el).backgroundColor.replace(')', `, ${$e1c55b086cf8dd0e$var$backgroundOpacity})`).replace('rgb', 'rgba');
}
function $e1c55b086cf8dd0e$var$makeSolid(el) {
    el.style.backgroundColor = getComputedStyle(el).backgroundColor.replace(`, ${$e1c55b086cf8dd0e$var$backgroundOpacity})`, ')').replace('rgba', 'rgb');
}
function $e1c55b086cf8dd0e$export$2e65e79124cca55d(color) {
    (0, $gFW3W.elem)('underlay').style.backgroundColor = color;
    if ((0, $gFW3W.elem)('toolbox').style.display === 'block') $e1c55b086cf8dd0e$var$makeTranslucent((0, $gFW3W.elem)('underlay'));
    (0, $gFW3W.elem)('netBackColorWell').style.backgroundColor = color;
}
function $e1c55b086cf8dd0e$var$toggleDrawingLayer() {
    $e1c55b086cf8dd0e$export$c05995454a6ca00d = (0, $gFW3W.elem)('toolbox').style.display === 'block';
    let ul = (0, $gFW3W.elem)('underlay');
    if ($e1c55b086cf8dd0e$export$c05995454a6ca00d) {
        // close drawing layer
        (0, $a4a268d7686bbf3f$export$f94e63f0099c362e)();
        (0, $gFW3W.elem)('toolbox').style.display = 'none';
        (0, $gFW3W.elem)('underlay').style.zIndex = 0;
        $e1c55b086cf8dd0e$var$makeSolid(ul);
        document.querySelector('.upper-canvas').style.zIndex = 0;
        $e1c55b086cf8dd0e$var$inAddMode = false;
        (0, $gFW3W.elem)('buttons').style.visibility = 'visible';
        $e1c55b086cf8dd0e$var$setButtonDisabledStatus('addNode', false);
        $e1c55b086cf8dd0e$var$setButtonDisabledStatus('addLink', false);
        $e1c55b086cf8dd0e$export$e810bab53f2cc5ca();
        if ((0, $gFW3W.elem)('showLegendSwitch').checked) (0, $79c06594b77924a6$export$9a9b59e08de24cef)();
        if (0, $a4a268d7686bbf3f$export$f2efb2348b1e4771) $e1c55b086cf8dd0e$export$e5fde6ebaea8ae1d('drew on the background layer');
        $e1c55b086cf8dd0e$var$changeCursor('default');
    } else {
        // expose drawing layer
        (0, $gFW3W.elem)('toolbox').style.display = 'block';
        ul.style.zIndex = 1000;
        ul.style.cursor = 'default';
        document.querySelector('.upper-canvas').style.zIndex = 1001;
        // make the underlay (which is now overlay) translucent
        $e1c55b086cf8dd0e$var$makeTranslucent(ul);
        (0, $79c06594b77924a6$export$6bbbe775699090bc)();
        $e1c55b086cf8dd0e$var$inAddMode = 'disabled';
        (0, $gFW3W.elem)('buttons').style.visibility = 'hidden';
        (0, $gFW3W.elem)('help-button').style.visibility = 'visible';
        $e1c55b086cf8dd0e$var$setButtonDisabledStatus('addNode', true);
        $e1c55b086cf8dd0e$var$setButtonDisabledStatus('addLink', true);
        $e1c55b086cf8dd0e$var$setButtonDisabledStatus('undo', true);
        $e1c55b086cf8dd0e$var$setButtonDisabledStatus('redo', true);
    }
    $e1c55b086cf8dd0e$export$c05995454a6ca00d = !$e1c55b086cf8dd0e$export$c05995454a6ca00d;
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.redraw();
}
function $e1c55b086cf8dd0e$var$ensureNotDrawing() {
    if (!$e1c55b086cf8dd0e$export$c05995454a6ca00d) return;
    $e1c55b086cf8dd0e$var$toggleDrawingLayer();
    (0, $gFW3W.elem)('drawing').checked = false;
}
function $e1c55b086cf8dd0e$var$selectAllFactors() {
    $e1c55b086cf8dd0e$export$3ec31f8909af8acf($e1c55b086cf8dd0e$export$4051a07651545597.nodes.getIds({
        filter: (n)=>!n.nodeHidden
    }));
    $e1c55b086cf8dd0e$var$showSelected();
}
function $e1c55b086cf8dd0e$export$3ec31f8909af8acf(nodeIds) {
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.selectNodes(nodeIds, false);
    $e1c55b086cf8dd0e$var$showSelected();
}
function $e1c55b086cf8dd0e$var$selectAllLinks() {
    $e1c55b086cf8dd0e$export$2c92a894f29aaee5($e1c55b086cf8dd0e$export$4051a07651545597.edges.getIds({
        filter: (e)=>!e.edgeHidden
    }));
    $e1c55b086cf8dd0e$var$showSelected();
}
function $e1c55b086cf8dd0e$export$2c92a894f29aaee5(edgeIds) {
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.selectEdges(edgeIds);
    $e1c55b086cf8dd0e$var$showSelected();
}
/**
 * Selects all the nodes and edges that have been created or modified by a user
 */ function $e1c55b086cf8dd0e$var$selectUsersItems(event1) {
    event1.preventDefault();
    let userName = event1.target.dataset.userName;
    let usersNodes = $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get().filter((n)=>n.created?.user === userName || n.modified?.user === userName).map((n)=>n.id);
    let userEdges = $e1c55b086cf8dd0e$export$4051a07651545597.edges.get().filter((e)=>e.created?.user === userName || e.modified?.user === userName).map((e)=>e.id);
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.setSelection({
        nodes: usersNodes,
        edges: userEdges
    });
    $e1c55b086cf8dd0e$var$showSelected();
}
function $e1c55b086cf8dd0e$var$legendSwitch(e) {
    let on = e.target.checked;
    $e1c55b086cf8dd0e$export$e8f1ea4a10bfd1c9(on, true);
    $e1c55b086cf8dd0e$export$807f940a96777041.set('legend', on);
}
function $e1c55b086cf8dd0e$export$e8f1ea4a10bfd1c9(on, warn) {
    (0, $gFW3W.elem)('showLegendSwitch').checked = on;
    if (on) (0, $79c06594b77924a6$export$9a9b59e08de24cef)(warn);
    else (0, $79c06594b77924a6$export$6bbbe775699090bc)();
}
function $e1c55b086cf8dd0e$var$votingSwitch(e) {
    let on = e.target.checked;
    $e1c55b086cf8dd0e$var$setVoting(on);
    $e1c55b086cf8dd0e$export$807f940a96777041.set('voting', on);
}
function $e1c55b086cf8dd0e$var$setVoting(on) {
    (0, $gFW3W.elem)('showVotingSwitch').checked = on;
    $e1c55b086cf8dd0e$var$showVotingToggle = on;
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.redraw();
}
/************************************************************** Analysis tab ************************************************* */ /**
 *
 * @param {String} name of Radio button group
 * @returns value of the button that is checked
 */ function $e1c55b086cf8dd0e$var$getRadioVal(name) {
    // get list of radio buttons with specified name
    let radios = document.getElementsByName(name);
    // loop through list of radio buttons
    for(let i = 0, len = radios.length; i < len; i++){
        if (radios[i].checked) return radios[i].value;
    }
}
/**
 *
 * @param {String} name of the radio button group
 * @param {*} value check the button with this value
 */ function $e1c55b086cf8dd0e$var$setRadioVal(name, value) {
    // get list of radio buttons with specified name
    let radios = document.getElementsByName(name);
    // loop through list of radio buttons and set the check on the one with the value
    for(let i = 0, len = radios.length; i < len; i++)radios[i].checked = radios[i].value === value;
}
/**
 * Return an array of the node Ids of Factors that are selected or are locked
 * @returns Array
 */ function $e1c55b086cf8dd0e$var$getSelectedAndFixedNodes() {
    return [
        ...new Set($e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getSelectedNodes().concat($e1c55b086cf8dd0e$export$4051a07651545597.nodes.get().filter((n)=>n.fixed).map((n)=>n.id)))
    ];
}
/**
 * Sets the Analysis radio buttons and Factor selection according to values in global hiddenNodes
 *  (which is set when yNetMap is loaded, or when a file is read in)
 */ function $e1c55b086cf8dd0e$var$setAnalysisButtonsFromRemote() {
    if ($e1c55b086cf8dd0e$var$netLoaded) {
        let selectedNodes = [].concat($e1c55b086cf8dd0e$var$hiddenNodes.selected) // ensure that hiddenNodes.selected is an array
        ;
        $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.selectNodes(selectedNodes, false) // in viewing  only mode, this does nothing
        ;
        if (selectedNodes.length > 0) {
            if (!$e1c55b086cf8dd0e$var$viewOnly) (0, $gFW3W.statusMsg)(`${$e1c55b086cf8dd0e$var$listFactors($e1c55b086cf8dd0e$var$getSelectedAndFixedNodes())} selected`);
        } else (0, $gFW3W.clearStatusBar)();
        $e1c55b086cf8dd0e$var$showNodeOrEdgeData();
        if ($e1c55b086cf8dd0e$var$hiddenNodes.radiusSetting) $e1c55b086cf8dd0e$var$setRadioVal('radius', $e1c55b086cf8dd0e$var$hiddenNodes.radiusSetting);
        if ($e1c55b086cf8dd0e$var$hiddenNodes.streamSetting) $e1c55b086cf8dd0e$var$setRadioVal('stream', $e1c55b086cf8dd0e$var$hiddenNodes.streamSetting);
        if ($e1c55b086cf8dd0e$var$hiddenNodes.pathsSetting) $e1c55b086cf8dd0e$var$setRadioVal('paths', $e1c55b086cf8dd0e$var$hiddenNodes.pathsSetting);
    }
}
function $e1c55b086cf8dd0e$var$setYMapAnalysisButtons() {
    let selectedNodes = $e1c55b086cf8dd0e$var$getSelectedAndFixedNodes();
    $e1c55b086cf8dd0e$export$807f940a96777041.set('radius', {
        radiusSetting: $e1c55b086cf8dd0e$var$getRadioVal('radius'),
        selected: selectedNodes
    });
    $e1c55b086cf8dd0e$export$807f940a96777041.set('stream', {
        streamSetting: $e1c55b086cf8dd0e$var$getRadioVal('stream'),
        selected: selectedNodes
    });
    $e1c55b086cf8dd0e$export$807f940a96777041.set('paths', {
        pathsSetting: $e1c55b086cf8dd0e$var$getRadioVal('paths'),
        selected: selectedNodes
    });
}
/**
 * Hide factors and links to show only those closest to the selected factors and/or
 * those up/downstream and/or those on paths between the selected factors
 */ function $e1c55b086cf8dd0e$var$analyse() {
    let selectedNodes = $e1c55b086cf8dd0e$var$getSelectedAndFixedNodes();
    $e1c55b086cf8dd0e$var$setYMapAnalysisButtons();
    // get all nodes and edges and unhide them before hiding those not wanted to be visible
    let nodes = $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get().filter((n)=>!n.isCluster).map((n)=>{
        (0, $gFW3W.setNodeHidden)(n, false);
        return n;
    });
    let edges = $e1c55b086cf8dd0e$export$4051a07651545597.edges.get().filter((e)=>!e.isClusterEdge).map((e)=>{
        (0, $gFW3W.setEdgeHidden)(e, false);
        return e;
    });
    $e1c55b086cf8dd0e$var$cancelHiddenStyles();
    // if showing everything, we are done
    if ($e1c55b086cf8dd0e$var$getRadioVal('radius') === 'All' && $e1c55b086cf8dd0e$var$getRadioVal('stream') === 'All' && $e1c55b086cf8dd0e$var$getRadioVal('paths') === 'All') {
        resetAll();
        return;
    }
    // check that at least one factor is selected
    if (selectedNodes.length === 0 && $e1c55b086cf8dd0e$var$getRadioVal('paths') === 'All') {
        (0, $gFW3W.alertMsg)('A Factor needs to be selected', 'error');
        resetAll();
        return;
    }
    // but paths between factors needs at least two
    if ($e1c55b086cf8dd0e$var$getRadioVal('paths') !== 'All' && selectedNodes.length < 2) {
        (0, $gFW3W.alertMsg)('Select at least 2 factors to show paths between them', 'warn');
        resetAll();
        return;
    }
    // these operations are not commutative (at least for networks with loops), so do them all in order
    if ($e1c55b086cf8dd0e$var$getRadioVal('radius') !== 'All') hideNodesByRadius(selectedNodes, parseInt($e1c55b086cf8dd0e$var$getRadioVal('radius')));
    if ($e1c55b086cf8dd0e$var$getRadioVal('stream') !== 'All') hideNodesByStream(selectedNodes, $e1c55b086cf8dd0e$var$getRadioVal('stream'));
    if ($e1c55b086cf8dd0e$var$getRadioVal('paths') !== 'All') hideNodesByPaths(selectedNodes, $e1c55b086cf8dd0e$var$getRadioVal('paths'));
    // finally display the map with its hidden factors and edges
    $e1c55b086cf8dd0e$export$4051a07651545597.nodes.update(nodes);
    $e1c55b086cf8dd0e$export$4051a07651545597.edges.update(edges);
    // announce what has been done
    let streamMsg = '';
    if ($e1c55b086cf8dd0e$var$getRadioVal('stream') === 'upstream') streamMsg = 'upstream';
    if ($e1c55b086cf8dd0e$var$getRadioVal('stream') === 'downstream') streamMsg = 'downstream';
    let radiusMsg = '';
    if ($e1c55b086cf8dd0e$var$getRadioVal('radius') === '1') radiusMsg = 'within one link';
    if ($e1c55b086cf8dd0e$var$getRadioVal('radius') === '2') radiusMsg = 'within two links';
    if ($e1c55b086cf8dd0e$var$getRadioVal('radius') === '3') radiusMsg = 'within three links';
    let pathsMsg = '';
    if ($e1c55b086cf8dd0e$var$getRadioVal('paths') === 'allPaths') pathsMsg = ': showing all paths';
    if ($e1c55b086cf8dd0e$var$getRadioVal('paths') === 'shortestPath') pathsMsg = ': showing shortest paths';
    if ($e1c55b086cf8dd0e$var$getRadioVal('stream') === 'All' && $e1c55b086cf8dd0e$var$getRadioVal('radius') === 'All') (0, $gFW3W.statusMsg)(`Showing  ${$e1c55b086cf8dd0e$var$getRadioVal('paths') === 'allPaths' ? 'all paths' : 'shortest paths'} between ${$e1c55b086cf8dd0e$var$listFactors($e1c55b086cf8dd0e$var$getSelectedAndFixedNodes(), true)}`);
    else (0, $gFW3W.statusMsg)(`Factors ${streamMsg} ${streamMsg && radiusMsg ? ' and ' : ''} ${radiusMsg} of ${$e1c55b086cf8dd0e$var$listFactors($e1c55b086cf8dd0e$var$getSelectedAndFixedNodes(), true)}${pathsMsg}`);
    /**
	 * return all to neutral analysis state
	 */ function resetAll() {
        $e1c55b086cf8dd0e$var$setRadioVal('radius', 'All');
        $e1c55b086cf8dd0e$var$setRadioVal('stream', 'All');
        $e1c55b086cf8dd0e$var$setRadioVal('paths', 'All');
        $e1c55b086cf8dd0e$var$setYMapAnalysisButtons();
        $e1c55b086cf8dd0e$export$4051a07651545597.nodes.update(nodes);
        $e1c55b086cf8dd0e$export$4051a07651545597.edges.update(edges);
    }
    /**
	 * Hide factors that are more than radius links distant from those selected
	 * @param {string[]} selectedNodes
	 * @param {Integer} radius
	 */ function hideNodesByRadius(selectedNodes, radius) {
        let nodeIdsInRadiusSet = new Set();
        let linkIdsInRadiusSet = new Set();
        // put those factors and links within radius links into these sets
        if ($e1c55b086cf8dd0e$var$getRadioVal('stream') === 'upstream' || $e1c55b086cf8dd0e$var$getRadioVal('stream') === 'All') inSet(selectedNodes, radius, 'to');
        if ($e1c55b086cf8dd0e$var$getRadioVal('stream') === 'downstream' || $e1c55b086cf8dd0e$var$getRadioVal('stream') === 'All') inSet(selectedNodes, radius, 'from');
        // hide all nodes and edges not in radius
        nodes.forEach((n)=>{
            if (!nodeIdsInRadiusSet.has(n.id)) (0, $gFW3W.setNodeHidden)(n, true);
        });
        edges.forEach((e)=>{
            if (!linkIdsInRadiusSet.has(e.id)) (0, $gFW3W.setEdgeHidden)(e, true);
        });
        // add links between factors that are in radius set, to give an ego network
        nodeIdsInRadiusSet.forEach((f)=>{
            $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getConnectedEdges(f).forEach((e)=>{
                let edge = $e1c55b086cf8dd0e$export$4051a07651545597.edges.get(e);
                if (nodeIdsInRadiusSet.has(edge.from) && nodeIdsInRadiusSet.has(edge.to)) (0, $gFW3W.setEdgeHidden)(edge, false);
            });
        });
        /**
		 * recursive function to collect Factors and Links within radius links from any of the nodes listed in nodeIds
		 * Factor ids are collected in nodeIdsInRadiusSet and links in linkIdsInRadiusSet
		 * Links are followed in a consistent direction, i.e. if 'to', only links directed away from the the nodes are followed
		 * @param {string[]} nodeIds
		 * @param {number} radius
		 * @param {string} direction - either 'from' or 'to'
		 */ function inSet(nodeIds, radius, direction) {
            if (radius < 0) return;
            nodeIds.forEach((nId)=>{
                let linked = [];
                nodeIdsInRadiusSet.add(nId);
                let links = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getConnectedEdges(nId).filter((e)=>$e1c55b086cf8dd0e$export$4051a07651545597.edges.get(e)[direction] === nId);
                if (links && radius > 0) links.forEach((lId)=>{
                    linkIdsInRadiusSet.add(lId);
                    linked.push($e1c55b086cf8dd0e$export$4051a07651545597.edges.get(lId)[direction === 'to' ? 'from' : 'to']);
                });
                if (linked) inSet(linked, radius - 1, direction);
            });
        }
    }
    /**
	 * Hide factors that are not up or downstream from the selected factors.
	 * Does not include links or factors that are already hidden
	 * @param {string[]} selectedNodes
	 * @param {string} direction - 'upstream' or 'downstream'
	 */ function hideNodesByStream(selectedNodes, upOrDown) {
        let nodeIdsInStreamSet = new Set();
        let linkIdsInStreamSet = new Set();
        let radiusVal = $e1c55b086cf8dd0e$var$getRadioVal('radius');
        let radius = Infinity;
        if (radiusVal !== 'All') radius = parseInt(radiusVal);
        let direction = 'to';
        if (upOrDown === 'upstream') direction = 'from';
        // breadth first search for all Factors that are downstream and less than or equal to radius links away
        $e1c55b086cf8dd0e$export$4051a07651545597.nodes.map((n)=>n.level = undefined);
        selectedNodes.forEach((nodeId)=>{
            nodeIdsInStreamSet.add(nodeId);
            let node = $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get(nodeId);
            let q = [
                node
            ];
            let level = 0;
            node.level = 0;
            while(q.length > 0 && level <= radius){
                let currentNode = q.shift();
                let connectedNodes = $e1c55b086cf8dd0e$export$4051a07651545597.nodes.get($e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getConnectedNodes(currentNode.id, direction)).filter((n)=>!(n.nodeHidden || nodeIdsInStreamSet.has(n.id)));
                if (connectedNodes.length > 0) {
                    level = currentNode.level + 1;
                    connectedNodes.forEach((n)=>{
                        nodeIdsInStreamSet.add(n.id);
                        n.level = level;
                    });
                    q = q.concat(connectedNodes);
                }
            }
        });
        // hide all nodes and edges not up or down stream
        nodes.forEach((n)=>{
            if (!nodeIdsInStreamSet.has(n.id)) (0, $gFW3W.setNodeHidden)(n, true);
        });
        edges.forEach((e)=>{
            if (!linkIdsInStreamSet.has(e.id)) (0, $gFW3W.setEdgeHidden)(e, true);
        });
        // add links between factors that are in radius set, to give an ego network
        nodeIdsInStreamSet.forEach((f)=>{
            $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getConnectedEdges(f).forEach((e)=>{
                let edge = $e1c55b086cf8dd0e$export$4051a07651545597.edges.get(e);
                if (nodeIdsInStreamSet.has(edge.from) && nodeIdsInStreamSet.has(edge.to)) (0, $gFW3W.setEdgeHidden)(edge, false);
            });
        });
    }
    /**
	 * Hide all factors and links that are not on the shortest path (or all paths) between the selected factors
	 * Avoids factors or links that are hidden
	 * @param {string[]} selectedNodes
	 * @param {string} pathType - either 'allPaths' or 'shortestPath'
	 */ function hideNodesByPaths(selectedNodes, pathType) {
        // paths is an array of objects with from and to node ids, or an empty array if there is no path
        let paths = shortestPaths(selectedNodes, pathType === 'allPaths');
        if (paths.length === 0) {
            (0, $gFW3W.alertMsg)('No path between the selected Factors', 'info');
            $e1c55b086cf8dd0e$var$setRadioVal('paths', 'All');
            $e1c55b086cf8dd0e$var$setYMapAnalysisButtons();
            return;
        }
        // hide nodes and links that are not included in paths
        let nodeIdsInPathsSet = new Set();
        let linkIdsInPathsSet = new Set();
        paths.forEach((links)=>{
            links.forEach((link)=>{
                let edge = $e1c55b086cf8dd0e$export$4051a07651545597.edges.get({
                    filter: (e)=>e.to === link.to && e.from === link.from
                })[0];
                linkIdsInPathsSet.add(edge.id);
                nodeIdsInPathsSet.add(edge.from);
                nodeIdsInPathsSet.add(edge.to);
            });
        });
        // hide all factors and links that are not in the set of paths
        nodes.forEach((n)=>{
            if (!nodeIdsInPathsSet.has(n.id)) (0, $gFW3W.setNodeHidden)(n, true);
        });
        edges.forEach((e)=>{
            if (!linkIdsInPathsSet.has(e.id)) (0, $gFW3W.setEdgeHidden)(e, true);
        });
        /**
		 * Given two or more selected factors, return a list of all the links that are either on any path between them, or just the ones on the shortest paths between them
		 * @param {Boolean} all when true, find all the links that connect to the selected factors; when false, find the shortest paths between the selected factors
		 * @returns	Arrays of objects with from: and to: properties for all the links (an empty array if there is no path between any of the selected factors)
		 */ function shortestPaths(selectedNodes, all) {
            let visited = new Map();
            let allPaths = [];
            // list of all pairs of the selected factors
            let combos = selectedNodes.flatMap((v, i)=>selectedNodes.slice(i + 1).map((w)=>[
                        v,
                        w
                    ]));
            // for each pair, find the sequences of links in both directions and combine them
            combos.forEach((combo)=>{
                let source = combo[0];
                let dest = combo[1];
                let links = pathList(source, dest, all);
                if (links.length > 0) allPaths.push(links);
                links = pathList(dest, source, all);
                if (links.length > 0) allPaths.push(links);
            });
            return allPaths;
            /**
			 * find the paths (as a list of links) that connect the source and destination
			 * @param {String} source
			 * @param {String} dest
			 * @param {Boolean} all true of all paths between Source and Destination are wanted; false if just the shortest path
			 * @returns an array of lists of links that connect the paths
			 */ function pathList(source, dest, all) {
                visited.clear();
                let links = [];
                let paths = getPaths(source, dest);
                // if no path found, getPaths return an array of length greater than the total number of factors in the map, or a string
                // in this case, return an empty list
                if (!Array.isArray(paths) || paths.length === $e1c55b086cf8dd0e$export$4051a07651545597.nodes.length + 1) paths = [];
                if (!all) for(let i = 0; i < paths.length - 1; i++)links.push({
                    from: paths[i],
                    to: paths[i + 1]
                });
                return links;
                /**
				 * recursively explore the map starting from source until destination is reached.
				 * stop if a factor has already been visited, or at a dead end (zero out-degree)
				 * @param {String} source
				 * @param {String} dest
				 * @returns an array of factors, the path so far followed
				 */ function getPaths(source, dest) {
                    if (source === dest) return [
                        dest
                    ];
                    visited.set(source, true);
                    let path = [
                        source
                    ];
                    // only consider nodes and edges that are not hidden
                    let connectedNodes = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getConnectedEdges(source).filter((e)=>{
                        let edge = $e1c55b086cf8dd0e$export$4051a07651545597.edges.get(e);
                        return !edge.edgeHidden && edge.from === source;
                    }).map((e)=>$e1c55b086cf8dd0e$export$4051a07651545597.edges.get(e).to);
                    if (connectedNodes.length === 0) return 'deadend';
                    if (all) // all paths between the source and destination
                    connectedNodes.forEach((next)=>{
                        let vis = visited.get(next);
                        if (vis === 'onpath') {
                            links.push({
                                from: source,
                                to: next
                            });
                            path = path.concat([
                                next
                            ]);
                        } else if (!vis) {
                            let p = getPaths(next, dest);
                            if (Array.isArray(p) && p.length > 0) {
                                links.push({
                                    from: source,
                                    to: next
                                });
                                visited.set(next, 'onpath');
                                path = path.concat(p);
                            }
                        }
                    });
                    else {
                        // shortest path between the source and destination
                        let bestPath = [];
                        let bestPathLength = $e1c55b086cf8dd0e$export$4051a07651545597.nodes.length;
                        connectedNodes.forEach((next)=>{
                            let p = visited.get(next);
                            if (!p) {
                                p = getPaths(next, dest);
                                visited.set(next, p);
                            }
                            if (Array.isArray(p) && p.length > 0) {
                                if (p.length < bestPathLength) {
                                    bestPath = p;
                                    bestPathLength = p.length;
                                }
                            }
                        });
                        path = path.concat(bestPath);
                    }
                    // if no progress has been made (the path is just the initial source factor), return an empty path
                    if (path.length === 1) path = [];
                    return path;
                }
            }
        }
    }
}
/**
 * Unset the indicators on the Settings Factor and Link tabs that show that Factors/Links with
 * these styles are hidden
 * Assumes that the factors and links have already been unhidden - this just  removes the UI indicators
 */ function $e1c55b086cf8dd0e$var$cancelHiddenStyles() {
    Array.from(document.getElementsByClassName('sampleNode')).filter((n)=>n.dataset.hide === 'hidden').forEach((n)=>{
        n.dataset.hide = 'visible';
        n.style.opacity = 1.0;
    });
    Array.from(document.getElementsByClassName('sampleLink')).filter((e)=>e.dataset.hide === 'hidden').forEach((e)=>{
        e.dataset.hide = 'visible';
        e.style.opacity = 1.0;
    });
}
function $e1c55b086cf8dd0e$var$sizingSwitch(e) {
    let metric = e.target.value;
    $e1c55b086cf8dd0e$export$9758cac25f26dd85(metric);
    $e1c55b086cf8dd0e$export$807f940a96777041.set('sizing', metric);
}
/**
 * set the size of the nodes proportional to the selected metric
 * @param {String} metric none, all the same size, in degree, out degree or betweenness centrality
 */ // constants for sizes of nodes
const $e1c55b086cf8dd0e$var$MIN_WIDTH = 50;
const $e1c55b086cf8dd0e$var$EQUAL_WIDTH = 100;
const $e1c55b086cf8dd0e$var$MAX_WIDTH = 200;
function $e1c55b086cf8dd0e$export$9758cac25f26dd85(metric) {
    let nodesToUpdate = [];
    let min = Number.MAX_VALUE;
    let max = 0;
    $e1c55b086cf8dd0e$export$4051a07651545597.nodes.forEach((node)=>{
        let oldValue = node.val;
        switch(metric){
            case 'Off':
            case 'Equal':
                node.val = 0;
                break;
            case 'Inputs':
                node.val = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getConnectedNodes(node.id, 'from').length;
                break;
            case 'Outputs':
                node.val = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getConnectedNodes(node.id, 'to').length;
                break;
            case 'Leverage':
                {
                    let inDegree = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getConnectedNodes(node.id, 'from').length;
                    let outDegree = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.getConnectedNodes(node.id, 'to').length;
                    node.val = inDegree === 0 ? 0 : outDegree / inDegree;
                    break;
                }
            case 'Centrality':
                node.val = node.bc;
                break;
        }
        if (node.val < min) min = node.val;
        if (node.val > max) max = node.val;
        if (metric === 'Off' || metric === 'Equal' || node.val !== oldValue) nodesToUpdate.push(node);
    });
    $e1c55b086cf8dd0e$export$4051a07651545597.nodes.forEach((node)=>{
        switch(metric){
            case 'Off':
                node.widthConstraint = node.heightConstraint = false;
                node.size = 25;
                break;
            case 'Equal':
                node.widthConstraint = node.heightConstraint = node.size = $e1c55b086cf8dd0e$var$EQUAL_WIDTH;
                break;
            default:
                node.widthConstraint = node.heightConstraint = node.size = $e1c55b086cf8dd0e$var$MIN_WIDTH + $e1c55b086cf8dd0e$var$MAX_WIDTH * scale(min, max, node.val);
        }
    });
    $e1c55b086cf8dd0e$export$4051a07651545597.nodes.update(nodesToUpdate);
    (0, $gFW3W.elem)('sizing').value = metric;
    function scale(min, max, value) {
        if (max === min) return 0.5;
        else return Math.max(0, (value - min) * (1 / (max - min)));
    }
}
// Note: most of the clustering functionality is in cluster.js
/**
 * User has chosen a clustering option
 * @param {Event} e
 */ function $e1c55b086cf8dd0e$var$selectClustering(e) {
    let option = e.target.value;
    // it doesn't make much sense to cluster while the factors are hidden, so undo that
    $e1c55b086cf8dd0e$var$setRadioVal('radius', 'All');
    $e1c55b086cf8dd0e$var$setRadioVal('stream', 'All');
    $e1c55b086cf8dd0e$var$setRadioVal('paths', 'All');
    $e1c55b086cf8dd0e$var$setYMapAnalysisButtons();
    $e1c55b086cf8dd0e$export$2a111da947c407d2.transact(()=>{
        $e1c55b086cf8dd0e$export$4051a07651545597.nodes.update($e1c55b086cf8dd0e$export$4051a07651545597.nodes.get().map((n)=>{
            (0, $gFW3W.setNodeHidden)(n, false);
            return n;
        }));
        $e1c55b086cf8dd0e$export$4051a07651545597.edges.update($e1c55b086cf8dd0e$export$4051a07651545597.edges.get().map((e)=>{
            (0, $gFW3W.setEdgeHidden)(e, false);
            return e;
        }));
    });
    (0, $4a821ee537123403$export$54c7dfe5600eab89)(option);
    $e1c55b086cf8dd0e$export$1e044b7877db048c();
    $e1c55b086cf8dd0e$export$807f940a96777041.set('cluster', option);
}
function $e1c55b086cf8dd0e$export$8b2b949f916968c1(option) {
    (0, $gFW3W.elem)('clustering').value = option;
}
function $e1c55b086cf8dd0e$export$5323aa6dd0c7006b(obj) {
    // remove any old select items, other than the standard ones (which are the first 3: None, Style, Color)
    let select = (0, $gFW3W.elem)('clustering');
    for(let i = 3, len = select.options.length; i < len; i++)select.remove(3);
    // append the ones provided
    for(const property in obj)if (obj[property] !== '*deleted*') {
        let opt = document.createElement('option');
        opt.value = property;
        opt.text = obj[property];
        select.add(opt, null);
    }
}
/* ---------------------------------------history window --------------------------------*/ /**
 * display the history log in a window
 */ function $e1c55b086cf8dd0e$var$showHistory() {
    (0, $gFW3W.elem)('history-window').style.display = 'block';
    let log = (0, $gFW3W.elem)('history-log');
    log.innerHTML = $e1c55b086cf8dd0e$export$d920e34eaf2b21cb.toArray().map((rec)=>`<div class="history-time">${(0, $gFW3W.timeAndDate)(rec.time)}: </div>
		<div class="history-action">${rec.user} ${rec.action}</div>
		<div class="history-rollback" data-time="${rec.time}"></div>`).join(' ');
    document.querySelectorAll('div.history-rollback').forEach((e)=>$e1c55b086cf8dd0e$var$addRollbackIcon(e));
    if (log.children.length > 0) log.lastChild.scrollIntoView(false);
}
/**
 * add a button for rolling back if there is state data corresponding to this log record
 * @param {HTMLElement} e - history record
 * */ function $e1c55b086cf8dd0e$var$addRollbackIcon(e) {
    let state = localStorage.getItem($e1c55b086cf8dd0e$var$timekey(parseInt(e.dataset.time)));
    if (state) {
        e.id = `hist${e.dataset.time}`;
        e.innerHTML = `<div class="tooltip">
				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-bootstrap-reboot" viewBox="0 0 16 16">
				<path d="M1.161 8a6.84 6.84 0 1 0 6.842-6.84.58.58 0 1 1 0-1.16 8 8 0 1 1-6.556 3.412l-.663-.577a.58.58 0 0 1 .227-.997l2.52-.69a.58.58 0 0 1 .728.633l-.332 2.592a.58.58 0 0 1-.956.364l-.643-.56A6.812 6.812 0 0 0 1.16 8z"/>
				<path d="M6.641 11.671V8.843h1.57l1.498 2.828h1.314L9.377 8.665c.897-.3 1.427-1.106 1.427-2.1 0-1.37-.943-2.246-2.456-2.246H5.5v7.352h1.141zm0-3.75V5.277h1.57c.881 0 1.416.499 1.416 1.32 0 .84-.504 1.324-1.386 1.324h-1.6z"/>
				</svg>
				<span class="tooltiptext rollbacktip">Rollback to before this action</span>
			</div>
		</div>`;
        if ((0, $gFW3W.elem)(e.id)) (0, $gFW3W.listen)(e.id, 'click', $e1c55b086cf8dd0e$var$rollback);
    }
}
/**
 * Restores the state of the map to a previous one
 * @param {Event} event
 * @returns null if no rollback possible or cancelled
 */ function $e1c55b086cf8dd0e$var$rollback(event1) {
    let rbTime = parseInt(event1.currentTarget.dataset.time);
    let rb = localStorage.getItem($e1c55b086cf8dd0e$var$timekey(rbTime));
    if (!rb) return;
    if (!confirm(`Roll back the map to what it was before ${(0, $gFW3W.timeAndDate)(rbTime)}?`)) return;
    let state = JSON.parse((0, $3gspO.decompressFromUTF16)(rb));
    $e1c55b086cf8dd0e$export$4051a07651545597.nodes.clear();
    $e1c55b086cf8dd0e$export$4051a07651545597.edges.clear();
    $e1c55b086cf8dd0e$export$4051a07651545597.nodes.update(state.nodes);
    $e1c55b086cf8dd0e$export$4051a07651545597.edges.update(state.edges);
    $e1c55b086cf8dd0e$export$2a111da947c407d2.transact(()=>{
        for(const k in state.net)$e1c55b086cf8dd0e$export$807f940a96777041.set(k, state.net[k]);
        $e1c55b086cf8dd0e$export$f229389f565c6b3f(state.net.mapTitle);
        for(const k in state.samples)$e1c55b086cf8dd0e$export$4b63d58d2685a993.set(k, state.samples[k]);
        if (state.paint) {
            $e1c55b086cf8dd0e$export$ffba1a0e51177788.delete(0, $e1c55b086cf8dd0e$export$ffba1a0e51177788.length);
            $e1c55b086cf8dd0e$export$ffba1a0e51177788.insert(0, state.paint);
        }
        if (state.drawing) {
            $e1c55b086cf8dd0e$export$da7062de5ac36f9c.clear();
            for(const k in state.drawing)$e1c55b086cf8dd0e$export$da7062de5ac36f9c.set(k, state.drawing[k]);
            (0, $a4a268d7686bbf3f$export$234b64ec3262770a)();
        }
    });
    $e1c55b086cf8dd0e$export$e5fde6ebaea8ae1d(`rolled back the map to what it was before ${(0, $gFW3W.timeAndDate)(rbTime, true)}`);
}
function $e1c55b086cf8dd0e$var$showHistorySwitch() {
    if ((0, $gFW3W.elem)('showHistorySwitch').checked) $e1c55b086cf8dd0e$var$showHistory();
    else (0, $gFW3W.elem)('history-window').style.display = 'none';
}
(0, $gFW3W.listen)('history-close', 'click', $e1c55b086cf8dd0e$var$historyClose);
function $e1c55b086cf8dd0e$var$historyClose() {
    (0, $gFW3W.elem)('history-window').style.display = 'none';
    (0, $gFW3W.elem)('showHistorySwitch').checked = false;
}
(0, $gFW3W.dragElement)((0, $gFW3W.elem)('history-window'), (0, $gFW3W.elem)('history-header'));
/* --------------------------------------- avatars and shared cursors--------------------------------*/ var $e1c55b086cf8dd0e$var$lastPktTime // time when a round trip duration packet was last sent
;
var $e1c55b086cf8dd0e$var$oldViewOnly = $e1c55b086cf8dd0e$var$viewOnly // save the viewOnly state
;
/* tell user if they are offline and disconnect websocket server */ window.addEventListener('offline', ()=>{
    (0, $gFW3W.alertMsg)('No network connection - working offline (view only)', 'info');
    $e1c55b086cf8dd0e$var$wsProvider.shouldConnect = false;
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.setOptions({
        interaction: {
            dragNodes: false,
            hover: false
        }
    });
    $e1c55b086cf8dd0e$var$hideNavButtons();
    $e1c55b086cf8dd0e$var$sideDrawEditor.enable(false);
    $e1c55b086cf8dd0e$var$oldViewOnly = $e1c55b086cf8dd0e$var$viewOnly;
    $e1c55b086cf8dd0e$var$viewOnly = true;
});
window.addEventListener('online', ()=>{
    $e1c55b086cf8dd0e$var$wsProvider.connect();
    (0, $gFW3W.alertMsg)('Network connection re-established', 'info');
    $e1c55b086cf8dd0e$var$lastPktTime = null;
    $e1c55b086cf8dd0e$var$viewOnly = $e1c55b086cf8dd0e$var$oldViewOnly;
    if (!$e1c55b086cf8dd0e$var$viewOnly) $e1c55b086cf8dd0e$var$showNavButtons();
    $e1c55b086cf8dd0e$var$sideDrawEditor.enable(true);
    $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.setOptions({
        interaction: {
            dragNodes: true,
            hover: true
        }
    });
    $e1c55b086cf8dd0e$var$showAvatars();
});
/**
 *  set up user monitoring (awareness)
 */ function $e1c55b086cf8dd0e$var$setUpAwareness() {
    $e1c55b086cf8dd0e$var$showAvatars();
    $e1c55b086cf8dd0e$var$roundTripTimer();
    $e1c55b086cf8dd0e$var$yAwareness.on('change', (event1)=>$e1c55b086cf8dd0e$var$receiveEvent(event1));
    // regularly broadcast our own state, every 20 seconds
    setInterval(()=>{
        $e1c55b086cf8dd0e$var$yAwareness.setLocalStateField('pkt', {
            time: Date.now()
        });
    }, 20000);
    // if debug = fake, generate fake mouse events every 200 ms for testing
    if (/fake/.test($e1c55b086cf8dd0e$export$1c9f709888824e05)) setInterval(()=>{
        $e1c55b086cf8dd0e$var$yAwareness.setLocalStateField('cursor', {
            x: Math.random() * 1000 - 500,
            y: Math.random() * 1000 - 500
        });
    }, 200);
    // fade out avatar when there has been no movement of the mouse for 15 minutes
    $e1c55b086cf8dd0e$var$asleep(false);
    var sleepTimer = setTimeout(()=>$e1c55b086cf8dd0e$var$asleep(true), $e1c55b086cf8dd0e$var$TIMETOSLEEP);
    // throttle mousemove broadcast to avoid overloading server
    var throttled = false;
    var THROTTLETIME = 200;
    window.addEventListener('mousemove', (e)=>{
        // broadcast my mouse movements
        if (throttled) return;
        throttled = true;
        setTimeout(()=>throttled = false, THROTTLETIME);
        clearTimeout(sleepTimer);
        $e1c55b086cf8dd0e$var$asleep(false);
        sleepTimer = setTimeout(()=>$e1c55b086cf8dd0e$var$asleep(true), $e1c55b086cf8dd0e$var$TIMETOSLEEP);
        // broadcast current position of mouse in canvas coordinates
        let box = $e1c55b086cf8dd0e$export$4b72f5d71fff605.getBoundingClientRect();
        $e1c55b086cf8dd0e$var$yAwareness.setLocalStateField('cursor', $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.DOMtoCanvas({
            x: Math.round(e.clientX - box.left),
            y: Math.round(e.clientY - box.top)
        }));
    });
}
/**
 * measure the time taken to send an update to another Y.doc
 * responds to updates sent as 'pkt' objects every 20 seconds (see above)
 */ function $e1c55b086cf8dd0e$var$roundTripTimer() {
    const ydocB = new $lc1R0.Doc();
    const wsProviderB = new (0, $6iwTo.WebsocketProvider)($e1c55b086cf8dd0e$export$3f859614deccc31b, `prsm${$e1c55b086cf8dd0e$export$f9d3fff8c23da278}`, ydocB);
    const yAwarenessB = wsProviderB.awareness;
    wsProviderB.disconnectBc();
    // clientB listens to updates, extracts the time from the state and displays it and
    // how long ago the state change was made ( time now - state.time )
    yAwarenessB.on('change', (event1, origin)=>{
        if (typeof origin === 'string') return; // ignore local changes (e.g. through broadcast channel)
        let sentpkt = yAwarenessB.getStates()?.get($e1c55b086cf8dd0e$var$yAwareness.clientID)?.pkt;
        if (sentpkt) // ignore repetitions of the same state time sent when other things change in the state object
        {
            if ($e1c55b086cf8dd0e$var$lastPktTime && $e1c55b086cf8dd0e$var$lastPktTime !== sentpkt.time) {
                if (Date.now() - sentpkt.time > $e1c55b086cf8dd0e$var$SLOWTRIPTIME || /round/.test($e1c55b086cf8dd0e$export$1c9f709888824e05)) {
                    (0, $gFW3W.alertMsg)(`Slow or unstable network connection (${Date.now() - sentpkt.time} ms)`, 'warn');
                    console.log(`${(0, $gFW3W.exactTime)(sentpkt.time)} Round trip: ${Date.now() - sentpkt.time} ms`);
                }
                $e1c55b086cf8dd0e$var$lastPktTime = sentpkt.time;
            }
        }
    });
}
/**
 * Set the awareness local state to show whether this client is sleeping (no mouse movement for 15 minutes)
 * @param {Boolean} isSleeping
 */ function $e1c55b086cf8dd0e$var$asleep(isSleeping) {
    if ($e1c55b086cf8dd0e$var$myNameRec.asleep === isSleeping) return;
    $e1c55b086cf8dd0e$var$myNameRec.asleep = isSleeping;
    $e1c55b086cf8dd0e$var$yAwareness.setLocalState({
        user: $e1c55b086cf8dd0e$var$myNameRec
    });
    $e1c55b086cf8dd0e$var$showAvatars();
}
/**
 * display the awareness events
 * @param {object} event
 */ function $e1c55b086cf8dd0e$var$traceUsers(event1) {
    let msg = '';
    event1.added.forEach((id)=>{
        msg += `Added ${user(id)} (${id}) `;
    });
    event1.updated.forEach((id)=>{
        msg += `Updated ${user(id)} (${id}) `;
    });
    event1.removed.forEach((id)=>{
        msg += `Removed (${id}) `;
    });
    console.log('yAwareness', (0, $gFW3W.exactTime)(), msg);
    function user(id) {
        let userRec = $e1c55b086cf8dd0e$var$yAwareness.getStates().get(id);
        return (0, $gFW3W.isEmpty)(userRec.user) ? id : userRec.user.name;
    }
}
var $e1c55b086cf8dd0e$var$lastMicePositions = new Map();
var $e1c55b086cf8dd0e$var$lastAvatarStatus = new Map();
var $e1c55b086cf8dd0e$var$refreshAvatars = true;
/**
 * Despatch to deal with event
 * @param {object} event - from yAwareness.on('change')
 */ function $e1c55b086cf8dd0e$var$receiveEvent(event1) {
    if (/aware/.test($e1c55b086cf8dd0e$export$1c9f709888824e05)) $e1c55b086cf8dd0e$var$traceUsers(event1);
    if ((0, $gFW3W.elem)('showUsersSwitch').checked) {
        let box = $e1c55b086cf8dd0e$export$4b72f5d71fff605.getBoundingClientRect();
        let changed = event1.added.concat(event1.updated);
        changed.forEach((userId)=>{
            let rec = $e1c55b086cf8dd0e$var$yAwareness.getStates().get(userId);
            if (userId !== $e1c55b086cf8dd0e$export$4d35f98e5d7d0978 && rec.cursor && !(0, $gFW3W.object_equals)(rec.cursor, $e1c55b086cf8dd0e$var$lastMicePositions.get(userId))) {
                $e1c55b086cf8dd0e$var$showOtherMouse(userId, rec.cursor, box);
                $e1c55b086cf8dd0e$var$lastMicePositions.set(userId, rec.cursor);
            }
            if (rec.user) {
                // if anything has changed, redisplay the avatars
                if ($e1c55b086cf8dd0e$var$refreshAvatars || !(0, $gFW3W.object_equals)(rec.user, $e1c55b086cf8dd0e$var$lastAvatarStatus.get(userId))) $e1c55b086cf8dd0e$var$showAvatars();
                $e1c55b086cf8dd0e$var$lastAvatarStatus.set(userId, rec.user);
                // set a timer for this avatar to self-destruct if no update has been received for a minute
                let ava = (0, $gFW3W.elem)(`ava${userId}`);
                if (ava) {
                    clearTimeout(ava.timer);
                    ava.timer = setTimeout($e1c55b086cf8dd0e$var$removeAvatar, 60000, ava);
                }
            }
            if (userId !== $e1c55b086cf8dd0e$export$4d35f98e5d7d0978 && rec.addingFactor) $e1c55b086cf8dd0e$var$showGhostFactor(userId, rec.addingFactor);
        });
    }
    if ($e1c55b086cf8dd0e$var$followme) $e1c55b086cf8dd0e$var$followUser();
}
/**
 * Display another user's mouse pointers (if they are inside the canvas)
 */ function $e1c55b086cf8dd0e$var$showOtherMouse(userId, cursor, box) {
    let cursorDiv = (0, $gFW3W.elem)(userId.toString());
    if (cursorDiv) {
        let p = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.canvasToDOM(cursor);
        p.x += box.left;
        p.y += box.top;
        cursorDiv.style.top = `${p.y}px`;
        cursorDiv.style.left = `${p.x}px`;
        cursorDiv.style.display = p.x < box.left || p.x > box.right || p.y > box.bottom || p.y < box.top ? 'none' : 'block';
    }
}
/**
 * Place a circle at the top left of the net pane to represent each user who is online
 * Also create a cursor (a div) for each of the users
 */ function $e1c55b086cf8dd0e$var$showAvatars() {
    $e1c55b086cf8dd0e$var$refreshAvatars = false;
    let recs = Array.from($e1c55b086cf8dd0e$var$yAwareness.getStates());
    // remove and save myself (using clientID as the id, not name)
    let me = recs.splice(recs.findIndex((a)=>a[0] === $e1c55b086cf8dd0e$export$4d35f98e5d7d0978), 1);
    let nameRecs = recs// eslint-disable-next-line no-unused-vars
    .map(([key, value])=>{
        if (value.user) return value.user;
    }).filter((e)=>e) // remove any recs without a user record
    .filter((v, i, a)=>a.findIndex((t)=>t.name === v.name) === i) // remove duplicates, by name
    .sort((a, b)=>a.name.charAt(0).toUpperCase() > b.name.charAt(0).toUpperCase() ? 1 : -1) // sort names
    ;
    if (me.length === 0) return; // app is unloading
    nameRecs.unshift(me[0][1].user) // push myself on to the front
    ;
    let avatars = (0, $gFW3W.elem)('avatars');
    let currentCursors = [];
    // check that an avatar exists for each name; if not create one.  If it does, check that it is still looking right
    nameRecs.forEach((nameRec)=>{
        let ava = (0, $gFW3W.elem)(`ava${nameRec.id}`);
        let shortName = (0, $gFW3W.initials)(nameRec.name);
        if (ava === null) {
            makeAvatar(nameRec);
            $e1c55b086cf8dd0e$var$refreshAvatars = true;
        } else {
            // to avoid flashes, don't touch anything that is already correct
            if (ava.dataset.tooltip !== nameRec.name) ava.dataset.tooltip = nameRec.name;
            let circle = ava.firstChild;
            if (circle.style.backgroundColor !== nameRec.color) circle.style.backgroundColor = nameRec.color;
            let circleBorderColor = nameRec.anon ? 'white' : 'black';
            if (circle.style.borderColor !== circleBorderColor) circle.style.borderColor = circleBorderColor;
            if (circle.innerText !== shortName) circle.innerText = shortName;
            let circleFontColor = circle.style.color;
            if (circleFontColor !== (nameRec.isLight ? 'black' : 'white')) circle.style.color = nameRec.isLight ? 'black' : 'white';
            let opacity = nameRec.asleep ? 0.2 : 1.0;
            if (circle.style.opacity !== opacity) circle.style.opacity = opacity;
        }
        if (nameRec.id !== $e1c55b086cf8dd0e$export$4d35f98e5d7d0978) {
            // don't create a cursor for myself
            let cursorDiv = (0, $gFW3W.elem)(nameRec.id);
            if (cursorDiv === null) cursorDiv = makeCursor(nameRec);
            else {
                if (nameRec.asleep) cursorDiv.style.display = 'none';
                if (cursorDiv.innerText !== shortName) cursorDiv.innerText = shortName;
                if (cursorDiv.style.backgroundColor !== nameRec.color) cursorDiv.style.backgroundColor = nameRec.color;
            }
            currentCursors.push(cursorDiv);
        }
    });
    // re-order the avatars into alpha order, without gaps, with me at the start
    let df = document.createDocumentFragment();
    nameRecs.forEach((nameRec)=>{
        df.appendChild((0, $gFW3W.elem)(`ava${nameRec.id}`));
    });
    avatars.replaceChildren(df);
    // delete any cursors that remain from before
    let cursorsToDelete = Array.from(document.querySelectorAll('.shared-cursor')).filter((a)=>!currentCursors.includes(a));
    cursorsToDelete.forEach((e)=>e.remove());
    /**
	 * create an avatar as a div with initials inside
	 * @param {object} nameRec
	 */ function makeAvatar(nameRec) {
        let ava = document.createElement('div');
        ava.classList.add('hoverme');
        if ($e1c55b086cf8dd0e$var$followme === nameRec.id) ava.classList.add('followme');
        ava.id = `ava${nameRec.id}`;
        ava.dataset.tooltip = nameRec.name;
        // the broadcast awareness sometimes loses a client (i.e. broadcasts that it has been removed)
        // when it actually hasn't (e.g. if there is a comms glitch).  So instead, we set a timer
        // and delete the avatar only if nothing is heard from that user for a minute
        ava.timer = setTimeout($e1c55b086cf8dd0e$var$removeAvatar, 60000, ava);
        let circle = document.createElement('div');
        circle.classList.add('round');
        circle.style.backgroundColor = nameRec.color;
        if (nameRec.anon) circle.style.borderColor = 'white';
        circle.innerText = (0, $gFW3W.initials)(nameRec.name);
        circle.style.color = nameRec.isLight ? 'black' : 'white';
        circle.style.opacity = nameRec.asleep ? 0.2 : 1.0;
        circle.dataset.client = nameRec.id;
        circle.dataset.userName = nameRec.name;
        ava.appendChild(circle);
        avatars.appendChild(ava);
        circle.addEventListener('click', nameRec.id === $e1c55b086cf8dd0e$export$4d35f98e5d7d0978 ? $e1c55b086cf8dd0e$var$renameUser : $e1c55b086cf8dd0e$var$follow);
        circle.addEventListener('contextmenu', $e1c55b086cf8dd0e$var$selectUsersItems);
        circle.addEventListener('mouseover', ()=>(0, $gFW3W.statusMsg)(nameRec.id === $e1c55b086cf8dd0e$export$4d35f98e5d7d0978 ? 'Click to change your name. Right click to select all your edits' : `Click to follow this person. Right click to select all this person's edits`));
        circle.addEventListener('mouseout', ()=>(0, $gFW3W.clearStatusBar)());
    }
    /**
	 * make a pseudo cursor (a div)
	 * @param {object} nameRec
	 * @returns a div
	 */ function makeCursor(nameRec) {
        let cursorDiv = document.createElement('div');
        cursorDiv.className = 'shared-cursor';
        cursorDiv.id = nameRec.id;
        cursorDiv.style.backgroundColor = nameRec.color;
        cursorDiv.innerText = (0, $gFW3W.initials)(nameRec.name);
        cursorDiv.style.color = nameRec.isLight ? 'black' : 'white';
        cursorDiv.style.display = 'none' // hide it until we get coordinates at next mousemove
        ;
        $e1c55b086cf8dd0e$export$34e0f9847d4c02dd.appendChild(cursorDiv);
        return cursorDiv;
    }
}
/**
 * destroy the avatar - the user is no longer on line
 * @param {HTMLelement} ava
 */ function $e1c55b086cf8dd0e$var$removeAvatar(ava) {
    $e1c55b086cf8dd0e$var$refreshAvatars = true;
    ava.remove();
}
function $e1c55b086cf8dd0e$var$showUsersSwitch() {
    let on = (0, $gFW3W.elem)('showUsersSwitch').checked;
    document.querySelectorAll('div.shared-cursor').forEach((node)=>{
        node.style.display = on ? 'block' : 'none';
    });
    (0, $gFW3W.elem)('avatars').style.display = on ? 'flex' : 'none';
}
/**
 * User has clicked on an avatar.  Start following this avatar
 * @param {event} event
 */ function $e1c55b086cf8dd0e$var$follow(event1) {
    if ($e1c55b086cf8dd0e$var$followme) $e1c55b086cf8dd0e$var$unFollow();
    let user = parseInt(event1.target.dataset.client, 10);
    if (user === $e1c55b086cf8dd0e$export$4d35f98e5d7d0978) return;
    $e1c55b086cf8dd0e$var$followme = user;
    (0, $gFW3W.elem)(`ava${$e1c55b086cf8dd0e$var$followme}`).classList.add('followme');
    let userName = (0, $gFW3W.elem)(`ava${user}`).dataset.tooltip;
    (0, $gFW3W.alertMsg)(`Following ${userName}`, 'info');
}
/**
 * User was following another user, but has now clicked off the avatar, so stop following
 */ function $e1c55b086cf8dd0e$var$unFollow() {
    if (!$e1c55b086cf8dd0e$var$followme) return;
    (0, $gFW3W.elem)(`ava${$e1c55b086cf8dd0e$var$followme}`).classList.remove('followme');
    $e1c55b086cf8dd0e$var$followme = undefined;
    (0, $gFW3W.elem)('errMsg').classList.remove('fadeInAndOut');
    (0, $gFW3W.clearStatusBar)();
}
/**
 * move the map so that the followed cursor is always in the centre of the pane
 */ function $e1c55b086cf8dd0e$var$followUser() {
    let userRec = $e1c55b086cf8dd0e$var$yAwareness.getStates().get($e1c55b086cf8dd0e$var$followme);
    if (!userRec) return;
    if (userRec.user.asleep) $e1c55b086cf8dd0e$var$unFollow();
    let userPosition = userRec.cursor;
    if (userPosition) $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.moveTo({
        position: userPosition
    });
}
/**
 * User has clicked on their own avatar.  Prompt them to change their own name.
 */ function $e1c55b086cf8dd0e$var$renameUser() {
    let newName = prompt('Enter your new name', $e1c55b086cf8dd0e$var$myNameRec.name);
    if (newName) {
        $e1c55b086cf8dd0e$var$myNameRec.name = newName;
        $e1c55b086cf8dd0e$var$myNameRec.anon = false;
        $e1c55b086cf8dd0e$var$yAwareness.setLocalState({
            user: $e1c55b086cf8dd0e$var$myNameRec
        });
        $e1c55b086cf8dd0e$var$showAvatars();
    }
}
/**
 * show a ghost box where another user is adding a factor
 * addingFactor is an object with properties:
 * state: adding', or 'done' to indicate that the ghost box should be removed
 * pos: a position (of the Add Factor dialog); 'done'
 * name: the name of the other user
 * @param {Integer} userId other user's client Id
 * @param {object} addingFactor
 */ function $e1c55b086cf8dd0e$var$showGhostFactor(userId, addingFactor) {
    let id = `ghost-factor${userId}`;
    switch(addingFactor.state){
        case 'done':
            {
                let ghostDiv = (0, $gFW3W.elem)(id);
                if (ghostDiv) ghostDiv.remove();
            }
            break;
        case 'adding':
            if (!(0, $gFW3W.elem)(id)) {
                let ghostDiv = document.createElement('div');
                ghostDiv.className = 'ghost-factor';
                ghostDiv.id = `ghost-factor${userId}`;
                ghostDiv.innerText = `[New factor\nbeing added by\n${addingFactor.name}]`;
                let p = $e1c55b086cf8dd0e$export$21fcfd9d5c6ebbd4.canvasToDOM(addingFactor.pos);
                let box = $e1c55b086cf8dd0e$export$34e0f9847d4c02dd.getBoundingClientRect();
                p.x += box.left;
                p.y += box.top;
                ghostDiv.style.top = `${p.y - 50}px`;
                ghostDiv.style.left = `${p.x - 187}px`;
                ghostDiv.style.display = p.x < box.left || p.x > box.right || p.y > box.bottom || p.y < box.top ? 'none' : 'block';
                $e1c55b086cf8dd0e$export$4b72f5d71fff605.appendChild(ghostDiv);
            }
            break;
        default:
            console.log(`Bad adding factor: ${addingFactor}`);
    }
}


//# sourceMappingURL=prsm.36f44fa1.js.map
